
sap["ls"]["preload"]["UCF_AbapList"] = function() {/* global _assert,  _trace, INFO*/
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_AbapListItem */
/// <reference path="./AbapListItem.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_ClipboardUtil */
/// <reference path="../../core/util/ClipboardUtil.js"/>
/* global UCF_AbapListBlockSelectionDelegate */
/// <reference path="./delegates/AbapListBlockSelectionDelegate.js"/>
/* global UCF_AbapListKeyboardNavigationDelegate */
/// <reference path="./delegates/AbapListKeyboardNavigationDelegate.js"/>
/* global UCF_AbapListBlockSelectionManager */
/// <reference path="./delegates/AbapListBlockSelectionManager.js"/>
/* global UCF_AbapListKeyboardBlockSelectionDelegate */
/// <reference path="./delegates/AbapListKeyboardBlockSelectionDelegate.js"/>
/* global UCF_AbapListScrollDelegate */
/// <reference path="./delegates/AbapListScrollDelegate.js"/>
/**
 * @typedef {Object} UCF_AbapList_Metadata
 * @property {string} sCopyToClipboardAnimationDurationMs e.g. "800ms"
 */
/**
 * @typedef {Object} UCF_AbapList_Position
 * @property {number} iX
 * @property {number} iY
 */

/**
 * The AbapList control was designed to be used in the SapGUI for HTML (ITS)
 * environment. It provides the means to visualize a ABAP report in Unified
 * Rendering pages. Its usage is limited to this purpose in the ITS
 * environment.
 *
 * The AbapList control is the root control which can cover several
 * AbapListItems. It arranges those items on the screen and handle their
 * eventing in a central processing handling.
 *
 * Use the AbapList control as an invisible layout raster for arranging and
 * aligning controls used in ABAP lists. This is a small defined set of controls.
 *
 * 
 *
 * @constructor
 * @param {HTMLTableElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_AbapList(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_AbapList["_"]["UCF_AbapList"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "AbapList.js(78): UCF_AbapList"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "AbapList.js(79): UCF_AbapList"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "AbapList.js(80): UCF_AbapList"); };

		UCF_ClassLoader["oGetClass"]('UCF_AbapListScrollDelegate');

		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_AbapListScrollDelegate"))(
			this,
			UCF_AbapListScrollDelegate["E_AXIS"]["Vertical"]
		));
		this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_AbapListScrollDelegate"))(
			this,
			UCF_AbapListScrollDelegate["E_AXIS"]["Horizontal"]
		));

		/** @type {UCF_AbapListItem} */
		this["oLastFocusedItem"] = null;

		/** @type {boolean} */
		this["bIsInitialized"] = false;

		/** @type {string[][]} */
		this["mRasterMatrix"] = [];
		/** @type {string} */
		this["sRemoveVisualizeCopyToClipboardDelayedCallId"] = null;
		/** @type {boolean} */
		this["bCopyToClipboardEnabled"] = false;

		/** @type {boolean} */
		this["bActiveItemsProcessed"] = true;

		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

		/** @type {UCF_AbapListBlockSelectionManager} */
		this["oBlockselectionManager"] = null;
		// creates the block selection delegates
		// in initialize is too later, while starting dragging
		if (this["mEvents"]["BlockSelect"])
			this["oBlockselectionManager"] = this["oGetBlockSelectionManager"]();
	}
};window["UCF_AbapList"] = UCF_AbapList; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapList"); UCF_AbapList["_"] = {UCF_AbapList: 0}; }; ;

UCF_AbapList["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_AbapList.prototype["sClassName"] = "UCF_AbapList";

/** @private Initialize when appears on screen */
UCF_AbapList["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["initialize"]++; }; 

	if (this["oBlockselectionManager"]) {
		this["oBlockselectionManager"]["applyBlockSelection"]();
	}
	/** @type {UCF_AbapListBlockSelectionDelegate} */
	this["oGetBlockSelectionDelegate"]();

	/** @type {UCF_AbapListKeyboardNavigationDelegate} */
	this["oGetKeyboardNavigationDelegate"]();
	/** @type {UCF_AbapListKeyboardBlockSelectionDelegate} */
	this["oGetKeyboardBlockSelectionDelegate"]();

	this["bIsInitialized"] = true;

};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["initialize"] = 0; };

/** @override Destructor */
UCF_AbapList["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["destroy"]++; }; 
	/** @type {UCF_AbapListKeyboardNavigationDelegate} */
	var oNavigationDelegate = this["oCache"]["has"]('oKeyboardNavigationDelegate') &&
		this["oGetKeyboardNavigationDelegate"]();

	if (oNavigationDelegate) {
		oNavigationDelegate["destroy"]();
	}

	var oKeyboardBlockSelectionDelegate = this["oCache"]["has"]('oKeyboardBlockSelectionDelegate') &&
		this["oGetKeyboardBlockSelectionDelegate"]();

	if (oKeyboardBlockSelectionDelegate) {
		oKeyboardBlockSelectionDelegate["destroy"]();
	}

	if (this["oBlockselectionDelegate"]) {
		this["oBlockselectionDelegate"]["destroy"]();
		this["oBlockselectionDelegate"] = null;
	}

	if (this["oBlockselectionManager"]) {
		this["oBlockselectionManager"]["destroy"]();
		this["oBlockselectionManager"] = null;
	}

	this["oCache"]["destroy"]();
	this["oCache"] = null;

	this["oLastFocusedItem"] = null;

	this["bCopyToClipboardEnabled"] = null;

	if (this["sRemoveVisualizeCopyToClipboardDelayedCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sRemoveVisualizeCopyToClipboardDelayedCallId"]);
	}
	this["sRemoveVisualizeCopyToClipboardDelayedCallId"] = null;

	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sBlockSelection"] = null;

	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["iFirstVisibleColumn"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["iFirstVisibleLine"] = null;
	this["mRasterMatrix"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["destroy"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsskipforward
 */
UCF_AbapList["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapList.js(199): onlsskipforward"); };

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["onlsskipforward"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsskipback
 */
UCF_AbapList["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapList.js(209): onlsskipback"); };

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["onlsskipback"] = 0; };

/**
 * @private
 * @return {HTMLDivElement}
 */
UCF_AbapList["prototype"]["oGetContentDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetContentDomRef"]++; }; 
	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('oContentDomRef', function() {
		return UCF_DomUtil["$"](self["sId"] + '-contentdiv');
	});
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetContentDomRef"] = 0; };

/**
 *  Returns the ScrollForward DOM Element
 * @private
 * @private
 * @return {HTMLDivElement}
 */
UCF_AbapList["prototype"]["oGetScrollForwardDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetScrollForwardDomRef"]++; }; 
	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('oScrollForward', function() {
		return UCF_DomUtil["$"](self["sId"] + '-scrollForward-inner');
	});
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetScrollForwardDomRef"] = 0; };

/**
 * Returns the ScrollBack DOM Element
 * @private
 * @return {HTMLDivElement}
 */
UCF_AbapList["prototype"]["oGetScrollBackDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetScrollBackDomRef"]++; }; 
	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('oScrollBack', function() {
		return UCF_DomUtil["$"](self["sId"] + '-scrollBack-inner');
	});
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetScrollBackDomRef"] = 0; };

/**
 * @public
 * @return {number}
 */
UCF_AbapList["prototype"]["getAvailableWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["getAvailableWidth"]++; }; 
	return this["oGetContentDomRef"]()["offsetWidth"];
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["getAvailableWidth"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_AbapList["prototype"]["iGetActuallyVisibleColumns"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["iGetActuallyVisibleColumns"]++; }; 
	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('iActuallyVisibleColumns', function() {
		return Math["floor"](self["getAvailableWidth"]() / self["fRasterWidth"]);
	});
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["iGetActuallyVisibleColumns"] = 0; };

/**
 * @public
 * @return {number}
 */
UCF_AbapList["prototype"]["getAvailableHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["getAvailableHeight"]++; }; 
	return this["oGetContentDomRef"]()["offsetHeight"];
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["getAvailableHeight"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_AbapList["prototype"]["iGetActuallyVisibleLines"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["iGetActuallyVisibleLines"]++; }; 
	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('iActuallyVisibleLines', function() {
		return Math["floor"](self["getAvailableHeight"]() / self["fRasterHeight"]);
	});
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["iGetActuallyVisibleLines"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_AbapList["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["onlsaccessibility"]++; }; 
	/** @type {HTMLElement} */
	var oSource;
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper;
	/** @type {string} */
	var sSourceId;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapList.js(310): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() === this) {
		oSource = oBrowserEvent["oGetSource"]();
		// TODO Create AbapList specific announcement
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
		sSourceId = oSource ? oSource["id"] : '';

		if (oSource === this["oDomRef"]) {
			if (this["iVisibleLineCount"] < this["iLineCount"]) {
				oAccessibilityHelper["setControlType"]('AL_PAGE', [
					this["iVisibleLineCount"],
					this["iLineCount"],
					this["iFirstVisibleLine"]
				]);
			} else {
				oAccessibilityHelper["setControlType"]('AL', [this["iLineCount"]]);
			}
			oAccessibilityHelper["applyContainerEntryBehaviour"]();
		} else if (oSource["getAttribute"]('tp') === 'END') {
			oAccessibilityHelper["setControlType"]('AL_END');
		} else if (UCF_StringUtil["bContains"](sSourceId, '-scroll')) {
			oAccessibilityHelper["setControlType"]('AL_SCROLL');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["onlsaccessibility"] = 0; };

/**
 * Applies a highlight effect to an AbapListItem. This is usually done when it
 * is focussed. The standard focus rectangle was not sufficient to visualize
 * the active element. Currently it draws a rectangle around the Item.
 *
 * @private
 * @param {UCF_AbapListItem} oItem a list item.
 * @param {boolean} bSet apply or remove the highlight effect
 */
UCF_AbapList["prototype"]["applyItemHighlightEffect"] = function(oItem, bSet) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["applyItemHighlightEffect"]++; }; 
	/** @type {string} */
	var sStyle;
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {string} */
	var sZIndex;
	if (this["mEvents"]["BlockSelect"]) return;

	if (
		!this["mEvents"]["BlockSelect"] &&
		oItem &&
		UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListItem') &&
		!UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListContainer')
	) {
		sStyle = '1px solid red';
		oDomRef = oItem["oDomRef"];

		if (__UCF_IE6__) {
			if (bSet) {
				oDomRef["style"]["marginTop"] = '-1px';
				oDomRef["style"]["marginLeft"] = '-1px';
				oDomRef["style"]["border"] = sStyle;
				oDomRef["setAttribute"]('hideFocus', true);
			} else {
				oDomRef["style"]["marginTop"] = '';
				oDomRef["style"]["marginLeft"] = '';
				oDomRef["style"]["border"] = '';
				oDomRef["setAttribute"]('hideFocus', false);
			}
		} else {
			sZIndex = oDomRef["getAttribute"]('lsZIndex');

			// Bring element to front so that outlines are not cut off by elements
			// next to the focussed element
			if (bSet) {
				if (!sZIndex) {
					sZIndex = UCF_DomUtil["sGetCurrentStyle"](oDomRef, 'z-index');
					if (sZIndex) { // eslint-disable-line max-depth
						oDomRef["setAttribute"]('lsZIndex', sZIndex);
					}
					oDomRef["style"]["zIndex"] = 101010;
				}
			} else if (sZIndex) {
				oDomRef["style"]["zIndex"] = sZIndex;
				oDomRef["setAttribute"]('lsZIndex', '');
			}

			// Apply outline
			if (bSet) {
				UCF_DomUtil["addClass"](oDomRef, 'lsAbapList__item--selection');
			} else {
				UCF_DomUtil["removeClass"](oDomRef, 'lsAbapList__item--selection');
			}
		}

	}
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["applyItemHighlightEffect"] = 0; };

/**
 * Stores the last focussed control
 *
 * @private
 * @param {UCF_AbapListItem} oLastFocusedItem a list item.
 */
UCF_AbapList["prototype"]["setLastFocusedItem"] = function(oLastFocusedItem) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setLastFocusedItem"]++; }; 
	this["oLastFocusedItem"] = oLastFocusedItem;
	this["parseActiveItems"]();
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setLastFocusedItem"] = 0; };

/**
 * @param {UCF_AbapListItem} oItem
 * @param { boolean } bSetTabIndex - 	sets the TabIndex or remove it
 */
UCF_AbapList["prototype"]["setTabIndexForItem"] = function(oItem, bSetTabIndex) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setTabIndexForItem"]++; }; 
	if (!oItem) return;
	var oDomRef = oItem["oDomRef"];

	if (oDomRef && oDomRef["getAttribute"] && oDomRef["getAttribute"]('navigateindex') === '0') {
		return;
	}
	if (bSetTabIndex) {
		UCF_DomUtil["setTabIndex"](oDomRef, 0);
	} else {
		UCF_DomUtil["resetTabIndex"](oDomRef);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setTabIndexForItem"] = 0; };

/**
 * Set the new focused Item
 * @param {AbapListItem} oItem
 * @param { boolean } bSetFocus - set focus on the AbapListItem
 * @param { boolean } bSetBlockSelection
 */
UCF_AbapList["prototype"]["setLastFocusedItemAndFocus"] = function(oItem, bSetFocus, bSetBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setLastFocusedItemAndFocus"]++; }; 
	if (!oItem) return;
	this["setTabIndexForItem"](this["oLastFocusedItem"], false);
	this["oLastFocusedItem"] = oItem;
	this["setLastFocusedItem"](this["oLastFocusedItem"]);
	if (bSetFocus) {
		if (!bSetBlockSelection && this["oGetBlockSelectionDelegate"]())
			this["oGetBlockSelectionDelegate"]()["setAvoidItemSelectionByFocus"](this["oLastFocusedItem"]);
		this["setTabIndexForItem"](this["oLastFocusedItem"], true);
		UCF_DomUtil["moveFocusDomElement"](this["oLastFocusedItem"]["oDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setLastFocusedItemAndFocus"] = 0; };

/**
 * @private
 *
 *  Parses all items in order to remove the TabIndex
 *  if the item is not active
 *  attribute navigateindex=1 - the item is inactive
 * */
UCF_AbapList["prototype"]["parseActiveItems"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["parseActiveItems"]++; }; 

	if (this["bActiveItemsProcessed"]) return;

	/** @type {HTMLDivElement} */
	var oDomRef = null;
	/** @type {NodeListOf<HTMLDivElement|HTMLInputElement>} */
	var aItemRefs = UCF_DomUtil["querySelectorAll"]('div, input', this["oGetContentDomRef"]());
	/** @type {number} */
	var i;

	for (i = 0; i < aItemRefs["length"]; i++) {
		oDomRef = aItemRefs[i];

		if (oDomRef && oDomRef["getAttribute"] && oDomRef["getAttribute"]('navigateindex') === '1') {
			UCF_DomUtil["removeTabIndex"](oDomRef);
		}
	}
	this["bActiveItemsProcessed"] = true;
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["parseActiveItems"] = 0; };

/**
 * Returns the last stored focussed item
 *
 * @private
 * @return {UCF_AbapListItem} The last stored focussed item
 */
UCF_AbapList["prototype"]["oGetLastFocusedItem"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetLastFocusedItem"]++; }; 
	return this["oLastFocusedItem"];
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetLastFocusedItem"] = 0; };

/*****************************************************************************
 * CENTRAL PROPAGATION OF SEMANTIC EVENTS
 *
 * The AbapListItems do not propagate their events on their own but notify the
 * AbapList that there happened a semantic event. This is done because some
 * items have sometimes identical events and because it is quite easy to
 * handle a central control which propagates the events.
 *
 *****************************************************************************/

/**
 * Propagates a Select event of an item
 *
 * @private
 * @param {UCF_AbapListItem} oItem a list item.
 * @param {UCF_AbapList_Position} [oSelectPosition] An object which contains
 * the X/Y raster select position relativ to the element's origin.
 */
UCF_AbapList["prototype"]["handleItemSelect"] = function(oItem, oSelectPosition) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["handleItemSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_AbapListItem, "oItem instanceof UCF_AbapListItem", "AbapList.js(510): handleItemSelect"); };

	this["fireSelect"](
		this["sId"],
		oItem["sId"],
		oSelectPosition ? oSelectPosition["iX"] : -1,
		oSelectPosition ? oSelectPosition["iY"] : -1
	);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["handleItemSelect"] = 0; };

/**
 * Propagates a Change event of an item
 *
 * @private
 * @param {UCF_AbapListItem} oItem a list item.
 * @param {string} sValue
 */
UCF_AbapList["prototype"]["handleItemChange"] = function(oItem, sValue) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["handleItemChange"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_AbapListItem, "oItem instanceof UCF_AbapListItem", "AbapList.js(528): handleItemChange"); };

	this["fireChange"](this["sId"], oItem["sId"], sValue);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["handleItemChange"] = 0; };

/**
 * Propagates a DoubleClick event of an item
 *
 * @private
 * @param {UCF_AbapListItem} oItem a list item.
 * @param {UCF_AbapList_Position} oClickPosition optional An object which
 * contains the X/Y raster click position relativ to the element's origin.
 */
UCF_AbapList["prototype"]["handleItemDoubleClick"] = function(oItem, oClickPosition) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["handleItemDoubleClick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_AbapListItem, "oItem instanceof UCF_AbapListItem", "AbapList.js(542): handleItemDoubleClick"); };

	this["fireDoubleClick"](
		this["sId"],
		oItem["sId"],
		oClickPosition ? oClickPosition["iX"] : -1,
		oClickPosition ? oClickPosition["iY"] : -1
	);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["handleItemDoubleClick"] = 0; };

/**
 * Returns the BlockSelectionDelegate
 * @return {AbapListBlockSelectionDelegate} - the delegate
 * @private
 */
UCF_AbapList["prototype"]["oGetBlockSelectionDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetBlockSelectionDelegate"]++; }; 
	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('oBlockSelectionDelegate', function() {
		/** @type {UCF_AbapListBlockSelectionDelegate} */
		var oDelegate;

		if (self["mEvents"]["BlockSelect"]) {
			oDelegate = new (UCF_ClassLoader["oGetClass"]("UCF_AbapListBlockSelectionDelegate"))(self["oLS"], self, self["sBlockSelection"]);
			self["addDelegate"](oDelegate);
			UCF_DomUtil["addClass"](self["oDomRef"], 'lsAbapList--blockselection');
			return oDelegate;
		} else {
			return null;
		}
	});
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetBlockSelectionDelegate"] = 0; };

/**
 * Returns the KeyboardNavigationDelegate
 * @return {AbapListKeyboardNavigationDelegate} - the delegate
 * @private
 */
UCF_AbapList["prototype"]["oGetKeyboardNavigationDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetKeyboardNavigationDelegate"]++; }; 
	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('oKeyboardNavigationDelegate', function() {
		/** @type {UCF_AbapListBlockSelectionDelegate} */
		var oDelegate;

		if (self["mEvents"]["BlockSelect"]) {
			oDelegate = new (UCF_ClassLoader["oGetClass"]("UCF_AbapListKeyboardNavigationDelegate"))(self["oLS"], self);
			self["addDelegate"](oDelegate);
			return oDelegate;
		} else {
			return null;
		}
	});
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetKeyboardNavigationDelegate"] = 0; };

/**
 * Returns the KeyboardNavigationDelegate
 * @return {AbapListKeyboardNavigationDelegate} - the delegate
 * @private
 */
UCF_AbapList["prototype"]["oGetKeyboardBlockSelectionDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetKeyboardBlockSelectionDelegate"]++; }; 
	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('oKeyboardBlockSelectionDelegate', function() {
		/** @type {UCF_AbapListBlockSelectionDelegate} */
		var oDelegate;

		if (self["mEvents"]["BlockSelect"]) {
			oDelegate = new (UCF_ClassLoader["oGetClass"]("UCF_AbapListKeyboardBlockSelectionDelegate"))(self["oLS"], self);
			self["addDelegate"](oDelegate);
			return oDelegate;
		} else {
			return null;
		}
	});
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetKeyboardBlockSelectionDelegate"] = 0; };

/**
 * Returns the KeyboardNavigationDelegate
 * @return {AbapListKeyboardNavigationDelegate} - the delegate
 * @private
 */
UCF_AbapList["prototype"]["oGetBlockSelectionManager"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetBlockSelectionManager"]++; }; 
	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('oBlockSelectionManager', function() {
		/** @type {UCF_AbapListBlockSelectionManager} */
		var oManager;

		if (self["mEvents"]["BlockSelect"]) {
			oManager = new (UCF_ClassLoader["oGetClass"]("UCF_AbapListBlockSelectionManager"))(self["oLS"], self);
			return oManager;
		} else {
			return null;
		}
	});
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetBlockSelectionManager"] = 0; };

/**
 * @private
 * @param {string} sId
 * @param {Object} oBlockSelection
 */
UCF_AbapList["prototype"]["fireBlockSelectInternal"] = function(sId, oBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireBlockSelectInternal"]++; }; 
	this["fireBlockSelect"](sId, UCF_JsUtil["sJsonStringify"](oBlockSelection));
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireBlockSelectInternal"] = 0; };

/** @private */
UCF_AbapList["prototype"]["handleTouchEndBlockSelect"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["handleTouchEndBlockSelect"]++; }; 
	this["fireBlockSelectInternal"](this["sId"], this["oBlockSelection"]);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["handleTouchEndBlockSelect"] = 0; };

/**
 * Sets the BlockSelection
 *
 * @public
 * @param {string} sBlockSelection The BlockSelection JSON
 */
UCF_AbapList["prototype"]["setBlockSelection"] = function(sBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setBlockSelection"]++; }; 
	/** @type {UCF_AbapListBlockSelectionDelegate} */
	var oDelegate;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sBlockSelection) === 'string', "typeof(sBlockSelection) === 'string'", "AbapList.js(668): setBlockSelection"); };

	this["sBlockSelection"] = sBlockSelection;
	this["setClientProperty"]('BlockSelection', this["sBlockSelection"], true);

	oDelegate = this["oGetBlockSelectionDelegate"]();

	if (this["sBlockSelection"] && oDelegate) {
		oDelegate["setBlockSelection"](this["sBlockSelection"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setBlockSelection"] = 0; };

/**
 * @private
 * removes the BlockSelection
 */
UCF_AbapList["prototype"]["removeBlockSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["removeBlockSelection"]++; }; 
	/** @type {UCF_AbapListBlockSelectionDelegate} */
	var oDelegate;

	this["sBlockSelection"] = {};
	this["setClientProperty"]('BlockSelection', this["sBlockSelection"], true);

	oDelegate = this["oGetBlockSelectionDelegate"]();

	if (oDelegate) {
		oDelegate["removeBlockSelection"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["removeBlockSelection"] = 0; };

/**
 * Copy to clipboard
 *
 * @private
 * @param {UCF_AbapList_BlockSelection} oBlockSelection The BlockSelection
 */
UCF_AbapList["prototype"]["copyToClipboard"] = function(oBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["copyToClipboard"]++; }; 
	/** @type {string} */
	var sRowString = '';
	/** @type {string} */
	var sText = '';
	/** @type {number} */
	var y;

	/** @type {number} */
	var mRasterMatrix;

	mRasterMatrix = this["oBlockselectionManager"]["oGetAllAbapListItemsAsText"]();

	/** @type {int} */
	var bHasOnlyOneItem = this["oGetBlockSelectionDelegate"]()["bHasBlockSelectionOnlyAnItem"](oBlockSelection);
	//iNoOfItems = 0;

	for (y = oBlockSelection["TopLeftY"]; y < oBlockSelection["BottomRightY"]; y++) {
		if (!mRasterMatrix[y]) {
			mRasterMatrix[y] = [];
		}

		sRowString = this["removeEmptySpacesBefore"](mRasterMatrix[y]["slice"](oBlockSelection["TopLeftX"], oBlockSelection["BottomRightX"])["join"](''));
		if (y < (oBlockSelection["BottomRightY"] - 1)) {
			sRowString += '\n';
		}
		sText += sRowString;
	}
	if (bHasOnlyOneItem) {
		sText = sText["replace"](/\t+$/, '');
	}

	UCF_ClipboardUtil["copyTextToClipboard"](sText, this["oLS"]);

	this["visualizeOnlyCopyToClipboard"]();
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["copyToClipboard"] = 0; };

/**
 * Removes the spaces before the strings
 * @private
 * @param {string} sLine
 * @return {string}
 */
UCF_AbapList["prototype"]["removeEmptySpacesBefore"] = function(sLine) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["removeEmptySpacesBefore"]++; }; 
	/** @type {Array} */
	var array = sLine["split"](/(\t)/g);
	for (var v in array) {
		if (array[v] !== '\t')
			array[v] = UCF_StringUtil["sTrim"](array[v]);
	}
	return array["join"]('');
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["removeEmptySpacesBefore"] = 0; };

/**
 * @private
 * @static
 * @return {UCF_AbapList_Metadata}
 */
UCF_AbapList["oGetMetadata"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetMetadata"]++; }; 
	if (!UCF_AbapList["oMetadata"]) {
		UCF_AbapList["oMetadata"] = UCF_ResourceUtil["oGetMetadataFromTheme"]('lsAbapList__metadata');
	}

	return UCF_JsUtil["extend"]({
		"sCopyToClipboardAnimationDurationMs": '0ms'
	}, UCF_AbapList["oMetadata"]);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["oGetMetadata"] = 0; };

/** @public */
UCF_AbapList["prototype"]["visualizeCopyToClipboard"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["visualizeCopyToClipboard"]++; }; 

	var oDelegate = this["oGetBlockSelectionDelegate"]();

	if (oDelegate) {
		oDelegate["handleCopyToClipboard"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["visualizeCopyToClipboard"] = 0; };

/** @private */
UCF_AbapList["prototype"]["visualizeOnlyCopyToClipboard"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["visualizeOnlyCopyToClipboard"]++; }; 
	/** @type {number} */
	var iCopyToClipboardAnimationDurationMs;

	if (this["oLS"]["oSystem"]["bUseAnimation"]) {
		iCopyToClipboardAnimationDurationMs = parseInt(
			UCF_AbapList["oGetMetadata"]()["sCopyToClipboardAnimationDurationMs"]
		);

		if (iCopyToClipboardAnimationDurationMs > 0) {
			UCF_DomUtil["addClass"](this["oRootRef"], 'lsAbapList--didcopy');
			this["sRemoveVisualizeCopyToClipboardDelayedCallId"] = UCF_JsUtil["delayedCall"](
				iCopyToClipboardAnimationDurationMs,
				this,
				'didVisualizeCopyToClipboard'
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["visualizeOnlyCopyToClipboard"] = 0; };

/** @private */
UCF_AbapList["prototype"]["didVisualizeCopyToClipboard"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["didVisualizeCopyToClipboard"]++; }; 
	this["sRemoveVisualizeCopyToClipboardDelayedCallId"] = null;
	UCF_DomUtil["removeClass"](this["oRootRef"], 'lsAbapList--didcopy');
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["didVisualizeCopyToClipboard"] = 0; };

/**
 * @private
 * @param {boolean} bEnabled
 */
UCF_AbapList["prototype"]["setCopyToClipboardEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setCopyToClipboardEnabled"]++; }; 
	this["bCopyToClipboardEnabled"] = bEnabled;
	//_trace(INFO, ' ========================================================================== bOutsideElement: ' + bEnabled);

	if (bEnabled) {
		UCF_DomUtil["removeClass"](this["oRootRef"], 'lsAbapList--bs-disabled');
		UCF_DomUtil["addClass"](this["oRootRef"], 'lsAbapList--bs-active');
	} else {
		UCF_DomUtil["addClass"](this["oRootRef"], 'lsAbapList--bs-disabled');
		UCF_DomUtil["removeClass"](this["oRootRef"], 'lsAbapList--bs-active');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setCopyToClipboardEnabled"] = 0; };

/**
 * @private
 * @return {boolean} bEnabled
 */
UCF_AbapList["prototype"]["bIsCopyToClipboardEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["bIsCopyToClipboardEnabled"]++; }; 
	return this["oRootRef"] && UCF_DomUtil["bHasClass"](this["oRootRef"], 'lsAbapList--bs-active');
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["bIsCopyToClipboardEnabled"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_AbapList["prototype"]["aAttributeNames"] = ["fRasterWidth","sRasterWidthUnit","fRasterHeight","sRasterHeightUnit","iLineCount","iFirstVisibleLine","iVisibleLineCount","iColumnCount","iFirstVisibleColumn","iVisibleColumnCount","sCustomData","sCustomStyle","sBlockSelection","sAccessibilityDescription"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_AbapList["prototype"]["aEventNames"] = ["Change","Select","DoubleClick","Scroll","TabNotify","BlockSelect","PageUp","PageDown","PageLeft","PageRight"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_AbapList["prototype"]["aMethodNames"] = ["getAvailableWidth","getAvailableHeight","setBlockSelection","visualizeCopyToClipboard","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {number}
 */
UCF_AbapList["prototype"]["fRasterWidth"] = 1;

/**
 * @private
 * @type {string}
 */
UCF_AbapList["prototype"]["sRasterWidthUnit"] = 'px';

/**
 * @private
 * @type {number}
 */
UCF_AbapList["prototype"]["fRasterHeight"] = 1;

/**
 * @private
 * @type {string}
 */
UCF_AbapList["prototype"]["sRasterHeightUnit"] = 'px';

/**
 * @private
 * @type {number}
 */
UCF_AbapList["prototype"]["iLineCount"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_AbapList["prototype"]["iFirstVisibleLine"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_AbapList["prototype"]["iVisibleLineCount"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_AbapList["prototype"]["iColumnCount"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_AbapList["prototype"]["iFirstVisibleColumn"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_AbapList["prototype"]["iVisibleColumnCount"] = -1;

/**
 * @private
 * @type {string}
 */
UCF_AbapList["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_AbapList["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_AbapList["prototype"]["sBlockSelection"] = '';

/**
 * @private
 * @type {string}
 */
UCF_AbapList["prototype"]["sAccessibilityDescription"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_AbapList["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setDefaultValues"]++; }; 
	this["fRasterWidth"] = 1;
	this["sRasterWidthUnit"] = 'px';
	this["fRasterHeight"] = 1;
	this["sRasterHeightUnit"] = 'px';
	this["iLineCount"] = -1;
	this["iFirstVisibleLine"] = -1;
	this["iVisibleLineCount"] = -1;
	this["iColumnCount"] = -1;
	this["iFirstVisibleColumn"] = -1;
	this["iVisibleColumnCount"] = -1;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sBlockSelection"] = '';
	this["sAccessibilityDescription"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("RasterWidth", 1, true);
		this["setClientProperty"]("RasterWidthUnit", 'px', true);
		this["setClientProperty"]("RasterHeight", 1, true);
		this["setClientProperty"]("RasterHeightUnit", 'px', true);
		this["setClientProperty"]("LineCount", -1, true);
		this["setClientProperty"]("FirstVisibleLine", -1, true);
		this["setClientProperty"]("VisibleLineCount", -1, true);
		this["setClientProperty"]("ColumnCount", -1, true);
		this["setClientProperty"]("FirstVisibleColumn", -1, true);
		this["setClientProperty"]("VisibleColumnCount", -1, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("BlockSelection", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the AbapList control.
 * @param {string} sItemId Identifier of the affected item control
 * @param {string} sValue New value after the change
 * @fires AbapList::Change
 */
UCF_AbapList["prototype"]["fireChange"] = function(sId, sItemId, sValue) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireChange"]++; }; 
	/** @type {{Id: string, ItemId: string, Value: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "AbapList.js(989): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AbapList.js(990): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AbapList.js(991): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "AbapList.js(992): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "AbapList.js(993): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "AbapList.js(994): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "AbapList.js(995): fireChange"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"Value": sValue
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	this["fireSemanticEvent"]("AbapList", "Change", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the AbapList control.
 * @param {string} sItemId Identifier of the affected item control
 * @param {number} iPosX The X raster position relativ to the element's origin. -1 when it cannot be determined.
 * @param {number} iPosY The Y raster position relativ to the element's origin. -1 when it cannot be determined.
 * @fires AbapList::Select
 */
UCF_AbapList["prototype"]["fireSelect"] = function(sId, sItemId, iPosX, iPosY) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, ItemId: string, PosX: number, PosY: number}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "AbapList.js(1026): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AbapList.js(1027): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AbapList.js(1028): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "AbapList.js(1029): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "AbapList.js(1030): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "AbapList.js(1031): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "AbapList.js(1032): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "AbapList.js(1033): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "AbapList.js(1034): fireSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"PosX": iPosX,
		"PosY": iPosY
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	
	this["fireSemanticEvent"]("AbapList", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the AbapList control.
 * @param {string} sItemId Identifier of the affected item control
 * @param {number} iPosX The X raster position relativ to the element's origin. -1 when it cannot be determined.
 * @param {number} iPosY The Y raster position relativ to the element's origin. -1 when it cannot be determined.
 * @fires AbapList::DoubleClick
 */
UCF_AbapList["prototype"]["fireDoubleClick"] = function(sId, sItemId, iPosX, iPosY) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string, ItemId: string, PosX: number, PosY: number}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "AbapList.js(1067): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AbapList.js(1068): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AbapList.js(1069): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "AbapList.js(1070): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "AbapList.js(1071): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "AbapList.js(1072): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "AbapList.js(1073): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "AbapList.js(1074): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "AbapList.js(1075): fireDoubleClick"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"PosX": iPosX,
		"PosY": iPosY
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	
	this["fireSemanticEvent"]("AbapList", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the AbapList control.
 * @param {number} iFirstVisibleLine The requested first visible line
 * @param {number} iFirstVisibleColumn The requested first visible column
 * @param {string} sTriggerId The id of a trigger control which caused the scrolling (e.g. a AbapListTabActor). Empty when no trigger was involved
 * @fires AbapList::Scroll
 */
UCF_AbapList["prototype"]["fireScroll"] = function(sId, iFirstVisibleLine, iFirstVisibleColumn, sTriggerId) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, FirstVisibleLine: number, FirstVisibleColumn: number, TriggerId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "AbapList.js(1108): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AbapList.js(1109): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AbapList.js(1110): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleLine != null, "iFirstVisibleLine != null", "AbapList.js(1111): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleLine) == "number", "typeof(iFirstVisibleLine) == \"number\"", "AbapList.js(1112): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleColumn != null, "iFirstVisibleColumn != null", "AbapList.js(1113): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleColumn) == "number", "typeof(iFirstVisibleColumn) == \"number\"", "AbapList.js(1114): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTriggerId != null, "sTriggerId != null", "AbapList.js(1115): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTriggerId) == "string", "typeof(sTriggerId) == \"string\"", "AbapList.js(1116): fireScroll"); };
	mParams = {
		"Id": sId,
		"FirstVisibleLine": iFirstVisibleLine,
		"FirstVisibleColumn": iFirstVisibleColumn,
		"TriggerId": sTriggerId
	};
	
	
	
	if (sTriggerId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sTriggerId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "TriggerId");
			}
		}
	this["fireSemanticEvent"]("AbapList", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the AbapList control.
 * @param {string} sItemId Identifier of the source item control, which triggred the event
 * @param {boolean} bForward True if triggred by a forward tab
 * @fires AbapList::TabNotify
 */
UCF_AbapList["prototype"]["fireTabNotify"] = function(sId, sItemId, bForward) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireTabNotify"]++; }; 
	/** @type {{Id: string, ItemId: string, Forward: boolean}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "AbapList.js(1148): fireTabNotify"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AbapList.js(1149): fireTabNotify"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AbapList.js(1150): fireTabNotify"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "AbapList.js(1151): fireTabNotify"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "AbapList.js(1152): fireTabNotify"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bForward != null, "bForward != null", "AbapList.js(1153): fireTabNotify"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bForward) == "boolean", "typeof(bForward) == \"boolean\"", "AbapList.js(1154): fireTabNotify"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"Forward": bForward
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	this["fireSemanticEvent"]("AbapList", "TabNotify", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireTabNotify"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of abapList
 * @param {string} sBlockSelection BlockSelection Range (for example: {'TopLeftX': 1, 'TopLeftY': 1, 'BottomRightX': 4, 'BottomRightY': 4})
 * @fires AbapList::BlockSelect
 */
UCF_AbapList["prototype"]["fireBlockSelect"] = function(sId, sBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireBlockSelect"]++; }; 
	/** @type {{Id: string, BlockSelection: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "AbapList.js(1181): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AbapList.js(1182): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AbapList.js(1183): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sBlockSelection != null, "sBlockSelection != null", "AbapList.js(1184): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sBlockSelection) == "string", "typeof(sBlockSelection) == \"string\"", "AbapList.js(1185): fireBlockSelect"); };
	mParams = {
		"Id": sId,
		"BlockSelection": sBlockSelection
	};
	
	
	this["fireSemanticEvent"]("AbapList", "BlockSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["fireBlockSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of abapList
 * @fires AbapList::PageUp
 */
UCF_AbapList["prototype"]["firePageUp"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["firePageUp"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "AbapList.js(1204): firePageUp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AbapList.js(1205): firePageUp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AbapList.js(1206): firePageUp"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("AbapList", "PageUp", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["firePageUp"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of abapList
 * @fires AbapList::PageDown
 */
UCF_AbapList["prototype"]["firePageDown"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["firePageDown"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "AbapList.js(1223): firePageDown"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AbapList.js(1224): firePageDown"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AbapList.js(1225): firePageDown"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("AbapList", "PageDown", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["firePageDown"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of abapList
 * @fires AbapList::PageLeft
 */
UCF_AbapList["prototype"]["firePageLeft"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["firePageLeft"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "AbapList.js(1242): firePageLeft"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AbapList.js(1243): firePageLeft"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AbapList.js(1244): firePageLeft"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("AbapList", "PageLeft", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["firePageLeft"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of abapList
 * @fires AbapList::PageRight
 */
UCF_AbapList["prototype"]["firePageRight"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["firePageRight"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "AbapList.js(1261): firePageRight"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AbapList.js(1262): firePageRight"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AbapList.js(1263): firePageRight"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("AbapList", "PageRight", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AbapList["_"]["firePageRight"] = 0; };

UCF_AbapList.prototype["aPublicMethods"] = ["getAvailableWidth","getAvailableHeight","setBlockSelection","visualizeCopyToClipboard"].concat(UCF_AbapList.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_AbapListBlockSelectionDelegate"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_DragDropDecoration */
/// <reference path="../base/DragDropDecoration.js"/>
/* global UCF_DragSession */
/// <reference path="../base/DragSession.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_AbapList */
/// <reference path="../../controls/AbapList.js"/>

/**
 * @typedef {Object} UCF_AbapListBlockSelectionDelegate_AccessInfo
 * @property {UCF_BrowserEvent} oBrowserEvent
 * @property {UCF_AbapListBlockSelectionDelegate_AccessType} eAccessType
 * @property {{iX: number, iY: number}} oDragStartPos
 * @property {{iClientX: number, iClientY: number}} oDragStartClientPos
 * @property {UCF_AbapListBlockSelectionDelegate_DragCustomType} [sHandler]
 */

/** @typedef {0} UCF_AbapListBlockSelectionDelegate_AccessTypeNone */
/** @typedef {1} UCF_AbapListBlockSelectionDelegate_AccessTypeMouse */
/** @typedef {2} UCF_AbapListBlockSelectionDelegate_AccessTypeDragStart */
/** @typedef {4} UCF_AbapListBlockSelectionDelegate_AccessTypeDragOver */
/** @typedef {5} UCF_AbapListBlockSelectionDelegate_AccessTypeDragEnd */
/** @typedef {6} UCF_AbapListBlockSelectionDelegate_AccessTypeTouch */
/** @typedef {7} UCF_AbapListBlockSelectionDelegate_AccessTypeTouchEnd */
/** @typedef {UCF_AbapListBlockSelectionDelegate_AccessTypeNone|UCF_AbapListBlockSelectionDelegate_AccessTypeMouse|UCF_AbapListBlockSelectionDelegate_AccessTypeDragStart|UCF_AbapListBlockSelectionDelegate_AccessTypeDragOver|UCF_AbapListBlockSelectionDelegate_AccessTypeDragEnd|UCF_AbapListBlockSelectionDelegate_AccessTypeTouch|UCF_AbapListBlockSelectionDelegate_AccessTypeTouchEnd} UCF_AbapListBlockSelectionDelegate_AccessType */
/**
 * @typedef {Object} UCF_AbapListBlockSelectionDelegate_AccessTypeEnum
 * @property {UCF_AbapListBlockSelectionDelegate_AccessTypeNone} NONE
 * @property {UCF_AbapListBlockSelectionDelegate_AccessTypeMouse} MOUSE
 * @property {UCF_AbapListBlockSelectionDelegate_AccessTypeDragStart} DRAG_START
 * @property {UCF_AbapListBlockSelectionDelegate_AccessTypeDragOver} DRAG_OVER
 * @property {UCF_AbapListBlockSelectionDelegate_AccessTypeDragEnd} DRAG_END
 * @property {UCF_AbapListBlockSelectionDelegate_AccessTypeTouch} TOUCH
 * @property {UCF_AbapListBlockSelectionDelegate_AccessTypeTouchEnd} TOUCH_END
 */

/** @typedef {'lsAbapListBSFrame'} UCF_AbapListBlockSelectionDelegate_BlockselectionFrameStyle */
/** @typedef {'lsAbapList--bs'} UCF_AbapListBlockSelectionDelegate_BlockselectionContentStyle */
/** @typedef {'lsAbapListBSHandleTL'} UCF_AbapListBlockSelectionDelegate_BlockselectionMouseTopLeftStyle */
/** @typedef {'lsAbapListBSHandleBR'} UCF_AbapListBlockSelectionDelegate_BlockselectionMouseBottomRightStyle */
/** @typedef {'lsAbapListBSHandleTR'} UCF_AbapListBlockSelectionDelegate_BlockselectionMouseTopRightStyle */
/** @typedef {'lsAbapListBSHandleBL'} UCF_AbapListBlockSelectionDelegate_BlockselectionMouseBottomLeftStyle */
/** @typedef {'lsAbapListBSHandleTLTouch'} UCF_AbapListBlockSelectionDelegate_BlockselectionTouchTopLeftStyle */
/** @typedef {'lsAbapListBSHandleBRTouch'} UCF_AbapListBlockSelectionDelegate_BlockselectionTouchBottomRightStyle */
/** @typedef {UCF_AbapListBlockSelectionDelegate_BlockselectionFrameStyle|UCF_AbapListBlockSelectionDelegate_BlockselectionContentStyle|UCF_AbapListBlockSelectionDelegate_BlockselectionMouseTopLeftStyle|UCF_AbapListBlockSelectionDelegate_BlockselectionMouseBottomRightStyle|UCF_AbapListBlockSelectionDelegate_BlockselectionMouseTopRightStyle|UCF_AbapListBlockSelectionDelegate_BlockselectionMouseBottomLeftStyle|UCF_AbapListBlockSelectionDelegate_BlockselectionTouchTopLeftStyle|UCF_AbapListBlockSelectionDelegate_BlockselectionTouchBottomRightStyle} UCF_AbapListBlockSelectionDelegate_Style */
/**
 * @typedef {Object} UCF_AbapListBlockSelectionDelegate_StyleEnum
 * @property {UCF_AbapListBlockSelectionDelegate_BlockselectionFrameStyle} BLOCKSELECTION_FRAME
 * @property {UCF_AbapListBlockSelectionDelegate_BlockselectionContentStyle} BLOCKSELECTION_CONTENT
 * @property {UCF_AbapListBlockSelectionDelegate_BlockselectionMouseTopLeftStyle} BLOCKSELECTION_MOUSE_TOP_LEFT
 * @property {UCF_AbapListBlockSelectionDelegate_BlockselectionMouseBottomRightStyle} BLOCKSELECTION_MOUSE_BOTTOM_RIGHT
 * @property {UCF_AbapListBlockSelectionDelegate_BlockselectionMouseTopRightStyle} BLOCKSELECTION_MOUSE_TOP_RIGHT
 * @property {UCF_AbapListBlockSelectionDelegate_BlockselectionMouseBottomLeftStyle} BLOCKSELECTION_MOUSE_BOTTOM_LEFT
 * @property {UCF_AbapListBlockSelectionDelegate_BlockselectionTouchTopLeftStyle} BLOCKSELECTION_TOUCH_TOP_LEFT
 * @property {UCF_AbapListBlockSelectionDelegate_BlockselectionTouchBottomRightStyle} BLOCKSELECTION_TOUCH_BOTTOM_RIGHT
 */

/** @typedef {null} UCF_AbapListBlockSelectionDelegate_DragCustomTypeNone */
/** @typedef {'listBlockSelectTL'} UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectTL */
/** @typedef {'listBlockSelectBR'} UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectBR */
/** @typedef {'listBlockSelectTR'} UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectTR */
/** @typedef {'listBlockSelectBL'} UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectBL */
/** @typedef {UCF_AbapListBlockSelectionDelegate_DragCustomTypeNone|UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectTL|UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectBR|UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectTR|UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectBL} UCF_AbapListBlockSelectionDelegate_DragCustomType */
/**
 * @typedef {Object} UCF_AbapListBlockSelectionDelegate_DragCustomTypeEnum
 * @property {UCF_AbapListBlockSelectionDelegate_DragCustomTypeNone} NONE
 * @property {UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectTL} BLOCK_SELECT_TL
 * @property {UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectBR} BLOCK_SELECT_BR
 * @property {UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectTR} BLOCK_SELECT_TR
 * @property {UCF_AbapListBlockSelectionDelegate_DragCustomTypeBlockSelectBL} BLOCK_SELECT_BL
 */

/**
 *  Handle the BlockSelection, keyboard selection for AbapList
 *
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_AbapList} oAbapList
 * @param {string} sBlockSelection
 */
function UCF_AbapListBlockSelectionDelegate(oLS, oAbapList, sBlockSelection) {if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["UCF_AbapListBlockSelectionDelegate"]++; }; 
	/** @type {UCF_AbapListBlockSelectionDelegate} */
	var self;

	this["oLS"] = oLS;

	this["oAbapList"] = oAbapList;
	this["oManager"] = this["oAbapList"]["oGetBlockSelectionManager"]();
	this["oAbapList"]["bActiveItemsProcessed"] = false;
	this["oAbapList"]["parseActiveItems"]();
	this["sBlockSelection"] = sBlockSelection;

	if (this["sBlockSelection"])
		this["oBlockSelection"] = UCF_JsUtil["oJsonParse"](this["sBlockSelection"]);

	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	this["oBSRefPoint"] = null;

	/** @type {_ObjectRect} */
	this["oAbapListRect"] = this["oAbapList"]["oGetContentDomRef"]()["getBoundingClientRect"]();

	this["oOriginBlockSelection"] = { "TopLeftX": 0, "TopLeftY": 0, "BottomRightX": 0, "BottomRightY": 0 };
	/** @type {AbapListItem} */
	this["oOriginItem"] = null;
	this["oOriginBoundaries"] = null;

	/** @type {HTMLDivElement} */
	this["oAbapListFocus"] = null;

	this["bIsTouchBlockSelection"] = false;

	if (this["oAbapList"]["bHasEventListeners"]('BlockSelect')) {
		self = this;

		/** @param {Event} oDomEvent */
		this["forwardSelectionchange"] = function(oDomEvent) {
			self["onselectionchange"](self["oLS"]["oBrowserWindow"]["oBrowserEventPool"]["oBorrowObject"](oDomEvent));
		};
		UCF_DomUtil["attachEvent"](document, 'selectionchange', this["forwardSelectionchange"]);
		this["attachAnyEventHandler"]();
		this["attachFocusChangeHandler"]();
	}

	this["mRasterMatrix"] = null;
	this["oNavigationHistory"] = null;

};window["UCF_AbapListBlockSelectionDelegate"] = UCF_AbapListBlockSelectionDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListBlockSelectionDelegate"); UCF_AbapListBlockSelectionDelegate["_"] = {UCF_AbapListBlockSelectionDelegate: 0}; }; ;

UCF_AbapListBlockSelectionDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_AbapListBlockSelectionDelegate.prototype["sClassName"] = "UCF_AbapListBlockSelectionDelegate";

/** @type {UCF_AbapListBlockSelectionDelegate_AccessTypeEnum} Access types */
UCF_AbapListBlockSelectionDelegate["prototype"]["ACCESS_TYPE"] = {
	"NONE": 0,
	"MOUSE": 1,
	"DRAG_START": 2,
	"DRAG_OVER": 4,
	"DRAG_END": 5,
	"TOUCH": 6,
	"TOUCH_OVER": 7,
	"TOUCH_END": 8
};

/** @type {UCF_AbapListBlockSelectionDelegate_DragCustomTypeEnum} Drag/drop custom type */
UCF_AbapListBlockSelectionDelegate["prototype"]["DRAG_CUSTOM_TYPE"] = {
	"NONE": null,
	"BLOCK_SELECT_TL": 'listBlockSelectTL',
	"BLOCK_SELECT_BR": 'listBlockSelectBR',
	"BLOCK_SELECT_TR": 'listBlockSelectTR',
	"BLOCK_SELECT_BL": 'listBlockSelectBL',
	"BLOCK_CLICK_DRAG": 'listBlockSelectItem'
};

/** @type {UCF_AbapListBlockSelectionDelegate_NavigationEnum} Navigation types */
UCF_AbapListBlockSelectionDelegate["prototype"]["NAVIGATION"] = {
	"NONE": 0,
	"EXTEND_COLUMN_TO_LEFT": 1, // [SHIFT] + [LEFT]
	"EXTEND_COLUMN_TO_RIGHT": 2, // [SHIFT] + [RIGHT]
	"EXTEND_COLUMN_TO_HOME": 3, // [SHIFT] + [HOME]
	"EXTEND_COLUMN_TO_END": 4, // [SHIFT] + [END]
	"EXTEND_ROW_UP": 5, // [SHIFT] + [UP]
	"EXTEND_ROW_DOWN": 6, // [SHIFT] + [DOWN]
	"ALL_ROWS": 7, // [SHIFT] + [SPACE]
	"ALL_COLUMNS": 8, // [CTRL] + [SPACE]
	"ALL_CELLS": 9, // [CTRL] + [A]
	"MOVE_ROW_UP": 10, // [ARROW UP]
	"MOVE_ROW_DOWN": 11, // [ARROW DOWN]
	"MOVE_COLUMN_TO_LEFT": 12, // [ARROW LEFT]
	"MOVE_COLUMN_TO_RIGHT": 13, // [ARROW RIGHT]
	"MOVE_TO_FIRST_COLUMN": 14, // [HOME]
	"MOVE_TO_LAST_COLUMN": 15, // [END],
	"EXTEND_CHAR_UP": 16, // [SHIFT] + [ALT] + [ARROW UP]
	"EXTEND_CHAR_DOWN": 17, // [SHIFT] + [ALT] + [ARROW DOWN]
	"EXTEND_CHAR_LEFT": 18, // [SHIFT] + [ALT] + [ARROW LEFT]
	"EXTEND_CHAR_RIGHT": 19, // [SHIFT] + [ALT] + [ARROW RIGHT]
	"MOVE_TO_FIRST_ITEM": 20, // [CTRL] + [HOME]
	"MOVE_TO_LAST_ITEM": 21, //  [CTRL] +[END]
	"EXTEND_TO_FIRST_ITEM": 22, //[SHIFT] + [CTRL] + [HOME]
	"EXTEND_TO_LAST_ITEM": 23 // [SHIFT] + [CTRL] +[END]
};

/**
 * Destructor
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["destroy"]++; }; 

	this["sBlockSelection"] = null;
	this["oBlockSelection"] = null;
	this["oAbapListFocus"] = null;
	this["oBSRefPoint"] = null;

	this["detachAnyEventHandler"]();
	this["detachFocusChangeHandler"]();
	if (this["oAbapList"] && this["oAbapList"]["bHasEventListeners"]('BlockSelect')) {
		UCF_DomUtil["detachEvent"](document, 'selectionchange', this["forwardSelectionchange"]);
		this["forwardSelectionchange"] = null;
	}
	this["mRasterMatrix"] = null;
	this["oLS"] = null;
	this["oAbapList"] = null;
	this["oAbapListRect"] = null;
	this["oOriginBlockSelection"] = null;
	this["oOriginItem"] = null;
	this["oNavigationHistory"] = null;

	this["oOriginBoundaries"] = null;
	this["oManager"] = null;
	this["sTimeOutId"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["destroy"] = 0; };

/** @private */
UCF_AbapListBlockSelectionDelegate["prototype"]["attachAnyEventHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["attachAnyEventHandler"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow = this["oLS"]["oBrowserWindow"];

	if (oBrowserWindow) {
		oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["attachAnyEventHandler"] = 0; };

/** @private */
UCF_AbapListBlockSelectionDelegate["prototype"]["attachFocusChangeHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["attachFocusChangeHandler"]++; }; 
	/** @type {UCF_Page} */
	var oPage = this["oLS"]["oGetPageInternal"]();

	if (oPage) {
		oPage["attachSemanticEvent"]('FocusChange', this, 'onFocusChange');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["attachFocusChangeHandler"] = 0; };

/** @private */
UCF_AbapListBlockSelectionDelegate["prototype"]["detachAnyEventHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["detachAnyEventHandler"]++; }; 
	if (!this["oLS"]) return;
	var oBrowserWindow = this["oLS"]["oBrowserWindow"];

	if (oBrowserWindow) {
		oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["detachAnyEventHandler"] = 0; };

/** @private */
UCF_AbapListBlockSelectionDelegate["prototype"]["detachFocusChangeHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["detachFocusChangeHandler"]++; }; 
	if (!this["oLS"]) return;
	var oPage = this["oLS"]["oGetPageInternal"]();
	if (oPage) {
		oPage["detachSemanticEvent"]('FocusChange', this, 'onFocusChange');
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["detachFocusChangeHandler"] = 0; };

/** @param {UCF_SemanticEvent<{oBrowserEvent: UCF_BrowserEvent}>} oSemanticEvent */
UCF_AbapListBlockSelectionDelegate["prototype"]["onFocusChange"] = function(oSemanticEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onFocusChange"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var sControlId = oSemanticEvent["oGetParam"]('ControlId');
	var oControl;
	if (sControlId) {
		oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sControlId);
		if (oControl && oControl["oDomRef"] && !UCF_DomUtil["bContains"](this["oAbapList"]["oDomRef"], oControl["oDomRef"])) {
			this["oManager"]["setCopyToClipboardEnabled"](false);
		} else {
			this["oManager"]["setCopyToClipboardEnabled"](true);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onFocusChange"] = 0; };

/** @param {UCF_SemanticEvent<{oBrowserEvent: UCF_BrowserEvent}>} oAnyEvent */
UCF_AbapListBlockSelectionDelegate["prototype"]["onAnyEvent"] = function(oAnyEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onAnyEvent"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oAnyEvent["oGetParam"]('oBrowserEvent');
	/** @type {string} */
	var sName = oBrowserEvent["sGetName"]();
	switch (sName) {
		case 'keydown':
			// UR2107 hack: keyup for [CMD][A] or [CMD][C] is not fired, use keydown
			// instead. Better solution would be to find out why keydown is not
			// dispatched properly in ITS and
			if (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["C"], 'C')
				&& this["bIsCopyToClipboardValid"]()) {
				this["handleCopyToClipboard"]();
			}
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onAnyEvent"] = 0; };

/**
 * Check if the copy to clipboard is valid
 *
 * @return {boolean}
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["bIsCopyToClipboardValid"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bIsCopyToClipboardValid"]++; }; 

	if (this["oManager"]["bIsBlockSelectionEmpty"]()) return false;
	if (!this["bCopyToClipboardEnabled"]()) return false;
	if (this["oManager"]["bIsActiveSelectionOutside"]()) return false;
	return true;

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bIsCopyToClipboardValid"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlshotkey"]++; }; 

	if (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["A"], 'C')
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["C"], 'C'))
		oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlshotkey"] = 0; };

/** @private */
UCF_AbapListBlockSelectionDelegate["prototype"]["handleCopyToClipboard"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleCopyToClipboard"]++; }; 
	this["oAbapList"]["copyToClipboard"](this["oManager"]["oGetBlockSelection"]());
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleCopyToClipboard"] = 0; };

/**
 * Remove the block selection
 *
 * @private
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["removeBlockSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["removeBlockSelection"]++; }; 

	if (this["oManager"]["oGetBlockSelectionFrame"]()) {
		UCF_DomUtil["removeFromDom"](this["oManager"]["oGetBlockSelectionFrame"]());
		this["oManager"]["setOriginItem"](null);
		this["oOriginBoundaries"] = null;

		this["oBlockSelection"] = this["oOriginBlockSelection"];
		this["oManager"]["setBlockSelection"](this["oBlockSelection"]);
		this["oManager"]["setBlockSelectionInternal"](this["oBlockSelection"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["removeBlockSelection"] = 0; };

/**
 * Click the Control which has the given oDomRef
 * @private
 * @param {int} iX
 * @param {int} iY
 * @return {UCF_Control} - return the Object
 *
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["oGetItemFromPoint"] = function(iX, iY) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["oGetItemFromPoint"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {UCF_Control} */
	var oItem = null;
	// hide block selection frame before calling document.elementFromPoint(),
	// otherwise we would always get the BS frame
	if (this["oManager"]["oGetBlockSelectionFrame"]() != null)
		UCF_DomUtil["setStyle"](this["oManager"]["oGetBlockSelectionFrame"](), {
			"visibility": 'hidden',
			"display": 'none'
		});
	if (this["oManager"]["oGetFocusFrame"]() != null)
		UCF_DomUtil["setStyle"](this["oManager"]["oGetFocusFrame"](), {
			"visibility": 'hidden',
			"display": 'none'
		});

	oDomRef = document["elementFromPoint"](iX, iY);

	if (this["oManager"]["oGetBlockSelectionFrame"]() != null)
		UCF_DomUtil["setStyle"](this["oManager"]["oGetBlockSelectionFrame"](), {
			"visibility": 'visible',
			"display": ''
		});

	if (this["oManager"]["oGetFocusFrame"]() != null)
		UCF_DomUtil["setStyle"](this["oManager"]["oGetFocusFrame"](), {
			"visibility": 'visible',
			"display": ''
		});

	if (oDomRef) {
		oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](UCF_DomUtil["oGetCTElement"](oDomRef), true);
	}

	return oItem;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["oGetItemFromPoint"] = 0; };

/**
 * Click the Control which has the given oDomRef
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstouchstart
 * @param {boolean} bIsDoubleClick
 * @return {Object} the rectanble of the clicked element
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["clickItem"] = function(oBrowserEvent, bIsDoubleClick) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["clickItem"]++; }; 

	/** @type {UCF_Control} */
	var oItem;

	oItem = this["oGetItemFromPoint"](oBrowserEvent["iClientX"](), oBrowserEvent["iClientY"]());

	if (this["oManager"]["bIsAbapListItem"](oItem)) {
		// The item might not be in TabChain, set TabIndex=0
		this["oManager"]["setTabIndexForItem"](oItem, true);
		// Set the focus on the element
		UCF_DomUtil["moveFocusDomElement"](oItem["oDomRef"]);
		if (bIsDoubleClick) {
			oItem["ondblclick"](oBrowserEvent);
		} else {
			oItem["onclick"](oBrowserEvent);
		}
		if (oItem === this["oAbapList"]["oGetLastFocusedItem"]()) {
			UCF_DomUtil["refocusDomElement"](oItem["oDomRef"]);
		}

		this["oManager"]["resetFocusAndTextSelection"]();

		return this["oManager"]["oGetItemPosition"](oItem);
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["clickItem"] = 0; };

/**
 * Click the Control which has the given oDomRef
 * @private
 * @param {UCF_AbapListItem} oItem the Item should be focused
 * @param {UCF_BrowserEvent} oBrowserEvent the browserEvent
 * @return {Object} the rectanble of the clicked element
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["focusItem"] = function(oItem, oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["focusItem"]++; }; 

	if (this["oManager"]["bIsAbapListItem"](oItem)) {
		// Set the focus on the element
		UCF_DomUtil["moveFocusDomElement"](oItem["oDomRef"]);
		oItem["onclick"](oBrowserEvent);

		this["oManager"]["resetFocusAndTextSelection"]();

		return {
			"TopLeftX": oItem["iGetLeft"](),
			"TopLeftY": oItem["iGetTop"](),
			"BottomRightX": oItem["iGetLeft"]() + oItem["iGetWidth"](),
			"BottomRightY": oItem["iGetTop"]() + oItem["iGetHeight"]()
		};

	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["focusItem"] = 0; };

/**
 * Click only one char ( [ALT] + mouse click)
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstouchstart
 * @return {Object} the rectanble of the clicked element
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["clickOneChar"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["clickOneChar"]++; }; 

	/** @type {UCF_Control} */
	var oItem;

	/** @type {number} */
	var iLeftAbapListPosition;
	/** @type {number} */
	var iTopAbapListPosition;
	/** @type {_ObjectRect} */
	var oAbapListPositionRect;
	/** @type {HTMLElement} */
	var oReferenceContainer;

	iLeftAbapListPosition = 0;
	iTopAbapListPosition = 0;

	// if the AbapList is into a Container with position absolute
	oReferenceContainer = UCF_DomUtil["oGetParentPositionReferenceContainer"](this["oAbapList"]["oDomRef"], true);
	if (oReferenceContainer) {
		oAbapListPositionRect = oReferenceContainer["getBoundingClientRect"]();
		iLeftAbapListPosition = oAbapListPositionRect["left"];
		iTopAbapListPosition = oAbapListPositionRect["top"];
	}

	var iX = Math["floor"]((oBrowserEvent["iClientX"]() - iLeftAbapListPosition - this["oAbapList"]["oGetContentDomRef"]()["offsetLeft"]) / this["oAbapList"]["fRasterWidth"]),
		iY = Math["floor"]((oBrowserEvent["iClientY"]() - iTopAbapListPosition - this["oAbapList"]["oGetContentDomRef"]()["offsetTop"]) / this["oAbapList"]["fRasterHeight"]);

	this["oOriginBlockSelection"] = { "TopLeftX": iX, "TopLeftY": iY, "BottomRightX": iX + 1, "BottomRightY": iY + 1 };
	//	this.oManager.setOriginBlockSelection(this.oOriginBlockSelection);
	this["oOriginBoundaries"] = null;
	this["oManager"]["setCharSelectionPosition"]({ "Left": 0, "Top": 0 });

	this["oBlockSelection"] = this["oOriginBlockSelection"];
	this["oManager"]["setOriginBlockSelection"](this["oOriginBlockSelection"]);
	this["oManager"]["setBlockSelection"](this["oBlockSelection"]);

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ========================= this.oOriginBlockSelection: TopLeftX: '
		+ this["oOriginBlockSelection"]["TopLeftX"]
		+ ', TopLeftY: ' + +this["oOriginBlockSelection"]["TopLeftY"]
		+ ', BottomRightX: ' + +this["oOriginBlockSelection"]["BottomRightX"]
		+ ', BottomRightY: ' + +this["oOriginBlockSelection"]["BottomRightY"], "AbapListBlockSelectionDelegate.js(509): clickOneChar"
	); };

	oItem = this["oGetItemFromPoint"](oBrowserEvent["iClientX"](), oBrowserEvent["iClientY"]());

	if (this["oManager"]["bIsAbapListItem"](oItem)) {
		//	this.oManager.setOriginItem(oItem);
		// Set the Focus, but not the selection
		//this.oManager.setNewFocusedItem(oItem, true, false);
	}

	this["oManager"]["setBlockSelectionInternal"](this["oBlockSelection"]);
	this["oManager"]["fireBlockSelectInternal"](this["oBlockSelection"]);
	this["oManager"]["applyCharSelectionPosition"]();
	this["oManager"]["setFocusedOnCharSelection"]();
	return this["oOriginBlockSelection"];

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["clickOneChar"] = 0; };

/**
 * Click only one char ( [ALT] + mouse click)
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstouchstart
 * @return {Object} the rectanble of the clicked element
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["clickExtend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["clickExtend"]++; }; 

	/** @type {UCF_Control} */
	var oItem;

	/** @type {number} */
	var iTopLeftX, iTopLeftY, iBottomRightX, iBottomRightY;

	oItem = this["oGetItemFromPoint"](oBrowserEvent["iClientX"](), oBrowserEvent["iClientY"]());

	if (oItem && UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListText')) {
		// The item might not be in TabChain, set TabIndex=0

		iTopLeftX = Math["min"](oItem["iGetLeft"](), this["oBlockSelection"] ? this["oBlockSelection"]["TopLeftX"] : this["oManager"]["oGetOriginBlockSelection"]()["TopLeftX"]);
		iTopLeftY = Math["min"](oItem["iGetTop"](), this["oBlockSelection"] ? this["oBlockSelection"]["TopLeftY"] : this["oManager"]["oGetOriginBlockSelection"]()["TopLeftY"]);
		if (this["oManager"]["bIsItemInBlockSelection"](oItem, this["oBlockSelection"])) {

			iBottomRightX = Math["max"](oItem["iGetLeft"]() + oItem["iGetWidth"](), this["oManager"]["oGetOriginBlockSelection"]()["BottomRightX"]);
			iBottomRightY = Math["max"](oItem["iGetTop"]() + oItem["iGetHeight"](), this["oManager"]["oGetOriginBlockSelection"]()["BottomRightY"]);

		} else {
			iBottomRightX = Math["max"](oItem["iGetLeft"]() + oItem["iGetWidth"](), this["oBlockSelection"] ? this["oBlockSelection"]["BottomRightX"] : this["oManager"]["oGetOriginBlockSelection"]()["BottomRightX"]);
			iBottomRightY = Math["max"](oItem["iGetTop"]() + oItem["iGetHeight"](), this["oBlockSelection"] ? this["oBlockSelection"]["BottomRightY"] : this["oManager"]["oGetOriginBlockSelection"]()["BottomRightY"]);
		}

		this["oBlockSelection"] = { "TopLeftX": iTopLeftX, "TopLeftY": iTopLeftY, "BottomRightX": iBottomRightX, "BottomRightY": iBottomRightY };
		this["oManager"]["setBlockSelection"](this["oBlockSelection"]);
		/*	_trace(INFO, ' ========================= this.oBlockSelection: TopLeftX: '
				+ this.oBlockSelection.TopLeftX
				+ ', TopLeftY: ' + +this.oBlockSelection.TopLeftY
				+ ', BottomRightX: ' + +this.oBlockSelection.BottomRightX
				+ ', BottomRightY: ' + +this.oBlockSelection.BottomRightY
			);*/

		// Set the Focus, but not the selection
		this["oManager"]["setNewFocusedItem"](oItem, true, false);
		this["oManager"]["setBlockSelectionInternal"](this["oBlockSelection"]);
		this["oManager"]["fireBlockSelectInternal"](this["oBlockSelection"]);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();

		return this["oBlockSelection"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["clickExtend"] = 0; };

/**
 * Just mouse click select an item
 * [ALT] + mouse click - select the curent char
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListBlockSelectionDelegate.js(594): onclick"); };
	/** @type {UCF_HTMLElement} */
	var oSourceControl = oBrowserEvent["oGetSourceControl"]();
	/** @type {boolean} */
	var bIsAbapListInput = oSourceControl && UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_AbapListText') && !oSourceControl["bReadOnly"];
	if (oBrowserEvent["oSource"] === this["oManager"]["oGetBlockSelectionFrame"]() ||
		oBrowserEvent["oSource"] === this["oManager"]["oGetFocusFrame"]() ||
		(UCF_DomUtil["bContains"](this["oAbapList"]["oGetContentDomRef"](), oBrowserEvent["oSource"]) && !bIsAbapListInput)) {
		this["bIsTouchBlockSelection"] = false;
		if (UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent)) {
			// select just the current char
			this["oManager"]["applySelectionHandlersCss"](!oBrowserEvent["bIsMouseHover"]());
			this["clickOneChar"](oBrowserEvent);

		} else if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent) && this["oOriginBlockSelection"]) {
			// select just the current char
			this["oManager"]["applySelectionHandlersCss"](!oBrowserEvent["bIsMouseHover"]());
			this["clickExtend"](oBrowserEvent);

		} else {
			// select the whole item
			this["oManager"]["applySelectionHandlersCss"](!oBrowserEvent["bIsMouseHover"]());
			this["clickItem"](oBrowserEvent, false);
		}
	} else if (UCF_DomUtil["bContains"](this["oAbapList"]["oGetContentDomRef"](), oBrowserEvent["oSource"]) && bIsAbapListInput && oBrowserEvent["oSource"]) {
		oBrowserEvent["oSource"]["setAttribute"]('data-avoid-click-blockselection', 'true');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onclick"] = 0; };

/**
 * Just mouse click select an item
 * [ALT] + mouse click - select the curent char
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListBlockSelectionDelegate.js(631): onlsfocus"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oBrowserEvent && oBrowserEvent["oFromElement"])
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' +++++++++++++++++++++++ oBrowserEvent.oFromElement : ' + oBrowserEvent["oFromElement"]["id"], "AbapListBlockSelectionDelegate.js(634): onlsfocus"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' +++++++++++++++++++++++ oBrowserEvent.oSource : ' + oSource["id"], "AbapListBlockSelectionDelegate.js(636): onlsfocus"); };
	if (oSource === this["oAbapList"]["oDomRef"]
		&& UCF_DomUtil["bHasTabIndex"](this["oAbapList"]["oDomRef"])) {
		if (!this["oManager"]["oGetFocusFrame"]()) {
			if (!this["oManager"]["bHasAbapListFocusableItems"]()) {
				if (!UCF_DomUtil["bHasClass"](this["oAbapList"]["oDomRef"], 'lsAbapList--disabled-focus'))
					UCF_DomUtil["addClass"](this["oAbapList"]["oDomRef"], 'lsAbapList--disabled-focus');

				this["oBlockSelection"] = this["oOriginBlockSelection"];
				this["oManager"]["setBlockSelection"](this["oBlockSelection"]);
				this["focusAllAbapList"]();
			}

			if (typeof(this["sTimeOutId"]) !== 'undefined') {
				UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
			}
			this["oManager"]["applyFocusFrame"]();
		}

		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](500, this, 'onAfterFocus');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsfocus"] = 0; };

/** @private
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onAfterFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onAfterFocus"]++; }; 
	if (this["oAbapList"] && UCF_DomUtil["oGetActiveElement"]() === this["oAbapList"]["oDomRef"]) {
		this["oManager"]["applyFocusedAbapListStyle"](true);
		this["oManager"]["removeCharFocus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onAfterFocus"] = 0; };

/**
 * Just mouse click select an item
 * [ALT] + mouse click - select the curent char
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsblur"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListBlockSelectionDelegate.js(676): onlsblur"); };

	this["oManager"]["applyFocusedAbapListStyle"](false);

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsblur"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListBlockSelectionDelegate.js(687): ondblclick"); };

	if (
		oBrowserEvent["oSource"] === this["oManager"]["oGetBlockSelectionFrame"]() ||
		UCF_DomUtil["bContains"](this["oAbapList"]["oGetContentDomRef"](), oBrowserEvent["oSource"])
	) {
		this["bIsTouchBlockSelection"] = false;
		// add selection class for TopLeft and BottomRight
		this["oManager"]["applySelectionHandlersCss"](!oBrowserEvent["bIsMouseHover"]());
		this["clickItem"](oBrowserEvent, true);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["ondblclick"] = 0; };

/**
 * @private
 * @param {UCF_AbapListBlockSelectionDelegate_AccessInfo} oAccessInfo
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["handleBlockSelect"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleBlockSelect"]++; }; 
	/** @type {UCF_AbapListItem} */
	var oItem;

	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBlockSelection;
	/** @type {UCF_DragAndDropManager} */
	var oDragAndDropManager;
	/** @type {number} */
	var iTopLeftX;
	/** @type {number} */
	var iTopLeftY;
	/** @type {number} */
	var iBottomRightX;
	/** @type {number} */
	var iBottomRightY;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "AbapListBlockSelectionDelegate.js(721): handleBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "AbapListBlockSelectionDelegate.js(722): handleBlockSelect"); };

	if (oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["MOUSE"] ||
		oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["TOUCH"]) {
		// It happens while Click an AbapListItem
		oItem = oAccessInfo["oItem"];

		iTopLeftX = oItem["iGetLeft"]();
		iTopLeftY = oItem["iGetTop"]();
		iBottomRightX = iTopLeftX + oItem["iGetWidth"]();
		iBottomRightY = iTopLeftY + oItem["iGetHeight"]();

		oBlockSelection = {
			"TopLeftX": iTopLeftX,
			"TopLeftY": iTopLeftY,
			"BottomRightX": iBottomRightX,
			"BottomRightY": iBottomRightY
		};

		this["oBSRefPoint"] = {
			"TopLeftX": oBlockSelection["TopLeftX"],
			"TopLeftY": oBlockSelection["TopLeftY"],
			"BottomRightX": oBlockSelection["BottomRightX"],
			"BottomRightY": oBlockSelection["BottomRightY"]
		};

		this["oOriginBlockSelection"] = {
			"TopLeftX": oBlockSelection["TopLeftX"],
			"TopLeftY": oBlockSelection["TopLeftY"],
			"BottomRightX": oBlockSelection["BottomRightX"],
			"BottomRightY": oBlockSelection["BottomRightY"]
		};
		this["oOriginBoundaries"] = null;
		this["oManager"]["setOriginItem"](oItem);
		// Set the focus & blockselection on the origin
		this["oManager"]["setNewFocusedItem"](oItem, true, true);
		this["oManager"]["setCharSelectionPosition"](null);
		this["oManager"]["setBlockSelectionInternal"](oBlockSelection);
		this["oManager"]["fireBlockSelectInternal"](oBlockSelection);
	}

	if (oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["DRAG_START"]) {
		if (!oAccessInfo["oBrowserEvent"]["oSource"]) {
			return;
		}

		oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"];

		if (oDragAndDropManager) {
			oDragAndDropManager["startDragSession"](this["oAbapList"]["sId"], null, UCF_DragSession["DRAG_TYPE"]["BLOCK_SELECT"], null, null, null);
			oDragAndDropManager["oDragSession"]["setCustomData"]({
				"TopLeftX": this["oBlockSelection"]["TopLeftX"],
				"TopLeftY": this["oBlockSelection"]["TopLeftY"],
				"BottomRightX": this["oBlockSelection"]["BottomRightX"],
				"BottomRightY": this["oBlockSelection"]["BottomRightY"]
			});

			if (oAccessInfo["oBrowserEvent"]["oSource"] === this["oManager"]["oGetResizeHandleTopLeft"]()) {
				oDragAndDropManager["oDragSession"]["setCustomType"](
					this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"]
				);
			} else if (oAccessInfo["oBrowserEvent"]["oSource"] === this["oManager"]["oGetResizeHandleBottomRight"]()) {
				oDragAndDropManager["oDragSession"]["setCustomType"](
					this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"]
				);
			} else if (oAccessInfo["oBrowserEvent"]["oSource"] === this["oManager"]["oGetResizeHandleTopRight"]()) {
				oDragAndDropManager["oDragSession"]["setCustomType"](
					this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TR"]
				);
			} else if (oAccessInfo["oBrowserEvent"]["oSource"] === this["oManager"]["oGetResizeHandleBottomLeft"]()) {
				oDragAndDropManager["oDragSession"]["setCustomType"](
					this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BL"]
				);
			} else {

				oDragAndDropManager["oDragSession"]["setCustomType"](this["DRAG_CUSTOM_TYPE"]["BLOCK_CLICK_DRAG"]);

				oDragAndDropManager["oDragSession"]["setCustomData"]({
					"TopLeftX": this["oBlockSelection"]["TopLeftX"],
					"TopLeftY": this["oBlockSelection"]["TopLeftY"],
					"BottomRightX": this["oAccessInfo"]["oDragStartPos"]["iBottomX"], // this.oBlockSelection.BottomRightX,
					"BottomRightY": this["oAccessInfo"]["oDragStartPos"]["iBottomY"] //, this.oBlockSelection.BottomRightY
				});

				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ========================= this.oOriginBlockSelection: TopLeftX: '
					+ this["oManager"]["oGetOriginBlockSelection"]()["TopLeftX"]
					+ ', TopLeftY: ' + +this["oManager"]["oGetOriginBlockSelection"]()["TopLeftY"]
					+ ', BottomRightX: ' + +this["oManager"]["oGetOriginBlockSelection"]()["BottomRightX"]
					+ ', BottomRightY: ' + +this["oManager"]["oGetOriginBlockSelection"]()["BottomRightY"], "AbapListBlockSelectionDelegate.js(806): handleBlockSelect"
				); };
			}

		}
	}

	if (oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["DRAG_OVER"]) {
		this["handleDragOver"](oAccessInfo);
	}

	if (oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["DRAG_END"]) {

		this["oManager"]["fireBlockSelectInternal"](this["oBlockSelection"]);
	}

	oAccessInfo["oBrowserEvent"]["cancel"]();
	oAccessInfo["oBrowserEvent"]["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleBlockSelect"] = 0; };

/**
 * Sets the block selection while drag over
 * @param { UCF_AbapListBlockSelectionDelegate_AccessInfo } oAccessInfo
 * @private
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["handleClickDragOverByChar"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleClickDragOverByChar"]++; }; 
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBSRefPoint;
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBlockSelection;
	/** @type {UCF_DragAndDropManager} */
	var oDragAndDropManager;

	/** @type {number} */
	var iCurrentRasterX;
	/** @type {number} */
	var iCurrentRasterY;
	/** @type {number} */
	var iRefX;
	/** @type {number} */
	var iRefY;

	iRefX = -1;
	iRefY = -1;

	oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"];
	oBlockSelection = {
		"TopLeftX": this["oBlockSelection"]["TopLeftX"],
		"TopLeftY": this["oBlockSelection"]["TopLeftY"],
		"BottomRightX": this["oBlockSelection"]["BottomRightX"],
		"BottomRightY": this["oBlockSelection"]["BottomRightY"]
	};
	oBSRefPoint = oDragAndDropManager["oDragSession"]["oGetCustomData"]();
	oBSRefPoint = this["oOriginBlockSelection"];

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' =========================  this.oOriginBlockSelection: TopLeftX: '
		+ this["oOriginBlockSelection"]["TopLeftX"]
		+ ', TopLeftY: ' + this["oOriginBlockSelection"]["TopLeftY"]
		+ ', BottomRightX: ' + this["oOriginBlockSelection"]["BottomRightX"]
		+ ', BottomRightY: ' + this["oOriginBlockSelection"]["BottomRightY"], "AbapListBlockSelectionDelegate.js(865): handleClickDragOverByChar"
	); };

	iRefX = oBSRefPoint["TopLeftX"];
	iRefY = oBSRefPoint["TopLeftY"];

	iCurrentRasterX = Math["round"]((oAccessInfo["oBrowserEvent"]["iClientX"]() - this["oAbapListRect"]["left"]) / this["oAbapList"]["fRasterWidth"]);
	iCurrentRasterY = Math["round"]((oAccessInfo["oBrowserEvent"]["iClientY"]() - this["oAbapListRect"]["top"]) / this["oAbapList"]["fRasterHeight"]);

	if (oAccessInfo["oBrowserEvent"]["oSource"] === this["oManager"]["oGetResizeHandleTopLeft"]()) {
		oDragAndDropManager["oDragSession"]["setCustomType"](
			this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"]
		);
	} else if (oAccessInfo["oBrowserEvent"]["oSource"] === this["oManager"]["oGetResizeHandleBottomRight"]()) {
		oDragAndDropManager["oDragSession"]["setCustomType"](
			this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"]
		);
	} else if (oAccessInfo["oBrowserEvent"]["oSource"] === this["oManager"]["oGetResizeHandleTopRight"]()) {
		oDragAndDropManager["oDragSession"]["setCustomType"](
			this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TR"]
		);
	} else if (oAccessInfo["oBrowserEvent"]["oSource"] === this["oManager"]["oGetResizeHandleBottomLeft"]()) {
		oDragAndDropManager["oDragSession"]["setCustomType"](
			this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BL"]
		);
	}
	if (iCurrentRasterX <= iRefX) {
		//the current cursor position if on the left side of the origin
		iRefX = oBSRefPoint["BottomRightX"];
	}

	if (iCurrentRasterY <= iRefY) {
		//the current cursor position if on the top side of the origin
		iRefY = oBSRefPoint["BottomRightY"];
	}

	oBlockSelection["TopLeftX"] = Math["min"](iRefX, iCurrentRasterX);
	oBlockSelection["TopLeftY"] = Math["min"](iRefY, iCurrentRasterY);
	oBlockSelection["BottomRightX"] = Math["max"](iRefX, iCurrentRasterX);
	oBlockSelection["BottomRightY"] = Math["max"](iRefY, iCurrentRasterY);

	//  fit into current frame
	oBlockSelection["TopLeftX"] = Math["max"](oBlockSelection["TopLeftX"], this["oManager"]["iGetFirstColumn"]());
	oBlockSelection["TopLeftY"] = Math["max"](oBlockSelection["TopLeftY"], this["oManager"]["iGetFirstRow"]());
	oBlockSelection["BottomRightX"] = Math["min"](oBlockSelection["BottomRightX"], this["oManager"]["iGetLastColumn"]());
	oBlockSelection["BottomRightY"] = Math["min"](oBlockSelection["BottomRightY"], this["oManager"]["iGetLastRow"]());

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ========================= oBlockSelection: TopLeftX: '
		+ oBlockSelection["TopLeftX"]
		+ ', TopLeftY: ' + oBlockSelection["TopLeftY"]
		+ ', BottomRightX: ' + oBlockSelection["BottomRightX"]
		+ ', BottomRightY: ' + oBlockSelection["BottomRightY"], "AbapListBlockSelectionDelegate.js(916): handleClickDragOverByChar"
	); };

	this["oManager"]["setBlockSelectionInternal"](oBlockSelection);
	this["oManager"]["emphasizeCharSelection"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleClickDragOverByChar"] = 0; };

/**
 * Sets the block selection while drag over
 * @param {UCF_AbapListBlockSelectionDelegate_AccessInfo} oAccessInfo
 * @private
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["handleClickDragOverByItem"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleClickDragOverByItem"]++; }; 
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBSRefPoint;
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBlockSelection;
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oItemBlockSelection;

	/** @type {UCF_AbapListItem} */
	var oItem;

	oBlockSelection = {
		"TopLeftX": this["oManager"]["oGetOriginBlockSelection"]()["TopLeftX"],
		"TopLeftY": this["oManager"]["oGetOriginBlockSelection"]()["TopLeftY"],
		"BottomRightX": this["oManager"]["oGetOriginBlockSelection"]()["BottomRightX"],
		"BottomRightY": this["oManager"]["oGetOriginBlockSelection"]()["BottomRightY"]
	};

	oBSRefPoint = oBlockSelection;

	oItem = this["oGetItemFromPoint"](oAccessInfo["oBrowserEvent"]["iClientX"](), oAccessInfo["oBrowserEvent"]["iClientY"]());

	if (oItem && UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListText')) {

		oItemBlockSelection = {
			"TopLeftX": oItem["iGetLeft"](),
			"TopLeftY": oItem["iGetTop"](),
			"BottomRightX": oItem["iGetLeft"]() + oItem["iGetWidth"](),
			"BottomRightY": oItem["iGetTop"]() + oItem["iGetHeight"]()
		};

		oBlockSelection["TopLeftX"] = Math["min"](oItemBlockSelection["TopLeftX"], oBSRefPoint["TopLeftX"]);
		oBlockSelection["TopLeftY"] = Math["min"](oItemBlockSelection["TopLeftY"], oBSRefPoint["TopLeftY"]);
		oBlockSelection["BottomRightX"] = Math["max"](oItemBlockSelection["BottomRightX"], oBSRefPoint["BottomRightX"]);
		oBlockSelection["BottomRightY"] = Math["max"](oItemBlockSelection["BottomRightY"], oBSRefPoint["BottomRightY"]);

		//  fit into current frame
		oBlockSelection["TopLeftX"] = Math["max"](oBlockSelection["TopLeftX"], this["oManager"]["iGetFirstColumn"]());
		oBlockSelection["TopLeftY"] = Math["max"](oBlockSelection["TopLeftY"], this["oManager"]["iGetFirstRow"]());
		oBlockSelection["BottomRightX"] = Math["min"](oBlockSelection["BottomRightX"], this["oManager"]["iGetLastColumn"]());
		oBlockSelection["BottomRightY"] = Math["min"](oBlockSelection["BottomRightY"], this["oManager"]["iGetLastRow"]());
		// Set the Focus, but not the selection
		this["oManager"]["setNewFocusedItem"](oItem, true, false);
		this["oManager"]["setBlockSelectionInternal"](oBlockSelection);
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleClickDragOverByItem"] = 0; };

/**
 * Sets the block selection while drag over
 * @param {UCF_AbapListBlockSelectionDelegate_AccessInfo} oAccessInfo
 * @private
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["handleDragOverHandlersByItem"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleDragOverHandlersByItem"]++; }; 
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBSRefPoint;
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBlockSelection;
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oItemBlockSelection = null;

	/** @type {UCF_AbapListItem} */
	var oItem;
	/** @type {UCF_AbapListItem} */
	var oNewOriginItem;

	/** @type {UCF_DragAndDropManager} */
	var oDragAndDropManager;

	oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"];
	if (!oDragAndDropManager) return;
	oItem = this["oGetItemFromPoint"](oAccessInfo["oBrowserEvent"]["iClientX"](), oAccessInfo["oBrowserEvent"]["iClientY"]());
	if (!(oItem && UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListText'))) return;

	// current block selection
	oBlockSelection = {
		"TopLeftX": this["oBlockSelection"]["TopLeftX"],
		"TopLeftY": this["oBlockSelection"]["TopLeftY"],
		"BottomRightX": this["oBlockSelection"]["BottomRightX"],
		"BottomRightY": this["oBlockSelection"]["BottomRightY"]
	};

	oBSRefPoint = oBlockSelection;
	// current Item Block Selection
	oItemBlockSelection = {
		"TopLeftX": oItem["iGetLeft"](),
		"TopLeftY": oItem["iGetTop"](),
		"BottomRightX": oItem["iGetLeft"]() + oItem["iGetWidth"](),
		"BottomRightY": oItem["iGetTop"]() + oItem["iGetHeight"]()
	};
	/*
		_trace(INFO, ' =========================  BlockSelection Point Reference: TopLeftX: ' + oBSRefPoint.TopLeftX
			+ ', TopLeftY: ' + oBSRefPoint.TopLeftY + ', BottomRightX: ' + oBSRefPoint.BottomRightX + ', BottomRightY: ' + oBSRefPoint.BottomRightY
		);
	*/
	if (oDragAndDropManager["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"]) {
		//reference
		oBlockSelection["TopLeftX"] = oBSRefPoint["TopLeftX"];
		oBlockSelection["TopLeftY"] = oBSRefPoint["TopLeftY"];

		oBlockSelection["BottomRightX"] = oItemBlockSelection["BottomRightX"];
		oBlockSelection["BottomRightY"] = oItemBlockSelection["BottomRightY"];

	} else if (oDragAndDropManager["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"]) {
		//refrence
		oBlockSelection["BottomRightX"] = oBSRefPoint["BottomRightX"];
		oBlockSelection["BottomRightY"] = oBSRefPoint["BottomRightY"];

		oBlockSelection["TopLeftX"] = oItemBlockSelection["TopLeftX"];
		oBlockSelection["TopLeftY"] = oItemBlockSelection["TopLeftY"];

		oNewOriginItem = this["oGetItemFromPoint"](oBlockSelection["BottomRightX"] - 1, oBlockSelection["BottomRightY"] - 1);
		if (oNewOriginItem && this["oManager"]["bIsAbapListItem"](oNewOriginItem) && oNewOriginItem !== this["oOriginItem"]) {
			this["oManager"]["setOriginItem"](oNewOriginItem);
		}

	} else if (oDragAndDropManager["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BL"]) {
		//reference
		oBlockSelection["BottomRightX"] = oBSRefPoint["BottomRightX"];
		oBlockSelection["TopLeftY"] = oBSRefPoint["TopLeftY"];

		oBlockSelection["TopLeftX"] = oItemBlockSelection["TopLeftX"];
		oBlockSelection["BottomRightY"] = oItemBlockSelection["BottomRightY"];
	} else if (oDragAndDropManager["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TR"]) {
		//reference
		oBlockSelection["TopLeftX"] = oBSRefPoint["TopLeftX"];
		oBlockSelection["BottomRightY"] = oBSRefPoint["BottomRightY"];

		oBlockSelection["TopLeftY"] = oItemBlockSelection["TopLeftY"];
		oBlockSelection["BottomRightX"] = oItemBlockSelection["BottomRightX"];
	}
	//  fit into current frame
	oBlockSelection["TopLeftX"] = Math["max"](oBlockSelection["TopLeftX"], this["oManager"]["iGetFirstColumn"]());
	oBlockSelection["TopLeftY"] = Math["max"](oBlockSelection["TopLeftY"], this["oManager"]["iGetFirstRow"]());
	oBlockSelection["BottomRightX"] = Math["min"](oBlockSelection["BottomRightX"], this["oManager"]["iGetLastColumn"]());
	oBlockSelection["BottomRightY"] = Math["min"](oBlockSelection["BottomRightY"], this["oManager"]["iGetLastRow"]());
	/*
		_trace(INFO, ' ========================= oBlockSelection: TopLeftX: ' + oBlockSelection.TopLeftX + ', TopLeftY: '
			+ oBlockSelection.TopLeftY + ', BottomRightX: ' + oBlockSelection.BottomRightX + ', BottomRightY: ' + oBlockSelection.BottomRightY);*/
	// Set the Focus, but not the selection
	this["oManager"]["setNewFocusedItem"](oItem, true, false);
	this["oManager"]["setBlockSelectionInternal"](oBlockSelection);

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleDragOverHandlersByItem"] = 0; };

/**
 * Sets the block selection while drag over
 * @param { UCF_AbapListBlockSelectionDelegate_AccessInfo } oAccessInfo
 * @private
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["dragOverHandlersByChar"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["dragOverHandlersByChar"]++; }; 
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBSRefPoint;
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBlockSelection;
	/** @type {UCF_DragAndDropManager} */
	var oDragAndDropManager;

	/** @type {number} */
	var iCurrentRasterX;
	/** @type {number} */
	var iCurrentRasterY;
	/** @type {number} */
	var iRefX;
	/** @type {number} */
	var iRefY;

	iRefX = -1;
	iRefY = -1;

	oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"];
	oBlockSelection = {
		"TopLeftX": this["oBlockSelection"]["TopLeftX"],
		"TopLeftY": this["oBlockSelection"]["TopLeftY"],
		"BottomRightX": this["oBlockSelection"]["BottomRightX"],
		"BottomRightY": this["oBlockSelection"]["BottomRightY"]
	};
	oBSRefPoint = oDragAndDropManager["oDragSession"]["oGetCustomData"]();

	iCurrentRasterX = Math["round"]((oAccessInfo["oBrowserEvent"]["iClientX"]() - this["oAbapListRect"]["left"]) / this["oAbapList"]["fRasterWidth"]);
	iCurrentRasterY = Math["round"]((oAccessInfo["oBrowserEvent"]["iClientY"]() - this["oAbapListRect"]["top"]) / this["oAbapList"]["fRasterHeight"]);

	if (oDragAndDropManager["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"]) {
		iRefX = oBSRefPoint["TopLeftX"];
		iRefY = oBSRefPoint["TopLeftY"];
		if (iCurrentRasterX < oBSRefPoint["TopLeftX"]) {
			iRefX = oBSRefPoint["TopLeftX"] + 1;
		}
		if (iCurrentRasterY < oBSRefPoint["TopLeftY"]) {
			iRefY = oBSRefPoint["TopLeftY"] + 1;
		}
	}
	if (oDragAndDropManager["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"]) {
		iRefX = oBSRefPoint["BottomRightX"];
		iRefY = oBSRefPoint["BottomRightY"];
		if (iCurrentRasterX > oBSRefPoint["BottomRightX"]) {
			iRefX = oBSRefPoint["BottomRightX"] - 1;
		}
		if (iCurrentRasterY > oBSRefPoint["BottomRightY"]) {
			iRefY = oBSRefPoint["BottomRightY"] - 1;
		}
	}
	if (oDragAndDropManager["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BL"]) {
		iRefX = oBSRefPoint["BottomRightX"];
		iRefY = oBSRefPoint["TopLeftY"];
		if (iCurrentRasterX > oBSRefPoint["BottomRightX"]) {
			iRefX = oBSRefPoint["BottomRightX"] - 1;
		}
		if (iCurrentRasterY <= oBSRefPoint["TopLeftY"]) {
			iRefY = oBSRefPoint["TopLeftY"] + 1;
		}
	}
	if (oDragAndDropManager["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TR"]) {
		iRefX = oBSRefPoint["TopLeftX"];
		iRefY = oBSRefPoint["BottomRightY"];
		if (iCurrentRasterX <= oBSRefPoint["TopLeftX"]) {
			iRefX = oBSRefPoint["TopLeftX"] + 1;
		}
		if (iCurrentRasterY > oBSRefPoint["BottomRightY"]) {
			iRefY = oBSRefPoint["BottomRightY"] - 1;
		}
	}

	oBlockSelection["TopLeftX"] = Math["min"](iRefX, iCurrentRasterX - 1);
	oBlockSelection["TopLeftY"] = Math["min"](iRefY, iCurrentRasterY - 1);
	oBlockSelection["BottomRightX"] = Math["max"](iRefX, iCurrentRasterX);
	oBlockSelection["BottomRightY"] = Math["max"](iRefY, iCurrentRasterY);

	//  fit into current frame
	oBlockSelection["TopLeftX"] = Math["max"](oBlockSelection["TopLeftX"], this["oManager"]["iGetFirstColumn"]());
	oBlockSelection["TopLeftY"] = Math["max"](oBlockSelection["TopLeftY"], this["oManager"]["iGetFirstRow"]());
	oBlockSelection["BottomRightX"] = Math["min"](oBlockSelection["BottomRightX"], this["oManager"]["iGetLastColumn"]());
	oBlockSelection["BottomRightY"] = Math["min"](oBlockSelection["BottomRightY"], this["oManager"]["iGetLastRow"]());

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ========================= oBlockSelection: TopLeftX: ' + oBlockSelection["TopLeftX"] + ', TopLeftY: '
		+ oBlockSelection["TopLeftY"] + ', BottomRightX: ' + oBlockSelection["BottomRightX"] + ', BottomRightY: ' + oBlockSelection["BottomRightY"], "AbapListBlockSelectionDelegate.js(1166): dragOverHandlersByChar"); };

	this["oManager"]["setBlockSelectionInternal"](oBlockSelection);
	this["oManager"]["emphasizeCharSelection"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["dragOverHandlersByChar"] = 0; };

/**
 * Sets the block selection while drag over
 * @param { UCF_AbapListBlockSelectionDelegate_AccessInfo } oAccessInfo
 * @private
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["handleDragOver"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleDragOver"]++; }; 

	/** @type {UCF_DragAndDropManager} */
	var oDragAndDropManager;

	// if iX && iY is not set, then the touch handlers didn't work
	if (!oAccessInfo["oDragStartPos"]) {
		return;
	}

	oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"];

	if (oDragAndDropManager["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_CLICK_DRAG"]) {
		if (UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oAccessInfo["oBrowserEvent"]))
			this["handleClickDragOverByChar"](oAccessInfo);
		else
			this["handleClickDragOverByItem"](oAccessInfo);

	} else {

		if (UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oAccessInfo["oBrowserEvent"]))
			this["dragOverHandlersByChar"](oAccessInfo);
		else
			this["handleDragOverHandlersByItem"](oAccessInfo);
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleDragOver"] = 0; };

/**
 * Test if the current item is an AbapListText in EditMode
 * @param {BrowserEvent} oBrowserEvent
 * @return {boolean} - return the Object
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["bIsAbapListTextInEditMode"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bIsAbapListTextInEditMode"]++; }; 

	/** @type {AbapListItem} */
	var oCurrentItem;
	/** @type {AbapListTextNavigationDelegate} */
	var oNavigationDelegate;

	oCurrentItem = this["oGetItemFromPoint"](oBrowserEvent["iClientX"](), oBrowserEvent["iClientY"]());

	if (oCurrentItem && UCF_JsUtil["bInstanceOf"](oCurrentItem, 'UCF_AbapListText')) {
		oNavigationDelegate = oCurrentItem["oGetNavigationDelegate"]();
		return oNavigationDelegate && oNavigationDelegate["bIsEditMode"]();
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bIsAbapListTextInEditMode"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdragstart
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsdragstart"]++; }; 
	/** @type {_ObjectRect} */
	var oBsHandlerRect;

	/** @type {number} */
	var iLeftAbapListPosition;
	/** @type {number} */
	var iTopAbapListPosition;
	/** @type {_ObjectRect} */
	var oAbapListPositionRect;
	/** @type {HTMLElement} */
	var oReferenceContainer;

	/** @type {AbapListItem} */
	var oClickedItem;

	if (this["bIsAbapListTextInEditMode"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}

	this["oManager"]["setCopyToClipboardEnabled"](true);
	iLeftAbapListPosition = 0;
	iTopAbapListPosition = 0;

	// if the AbapList is into a Container with position absolute
	oReferenceContainer = UCF_DomUtil["oGetParentPositionReferenceContainer"](this["oAbapList"]["oDomRef"], true);
	if (oReferenceContainer) {
		oAbapListPositionRect = oReferenceContainer["getBoundingClientRect"]();
		iLeftAbapListPosition = oAbapListPositionRect["left"];
		iTopAbapListPosition = oAbapListPositionRect["top"];
	}

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListBlockSelectionDelegate.js(1265): onlsdragstart"); };

	if (!oBrowserEvent["bIsTouchInteraction"]()) {
		oBsHandlerRect = UCF_DomUtil["oGetObjectRect"](
			oBrowserEvent["oSource"],
			this["oAbapList"]["oGetContentDomRef"]()
		);

		this["oAccessInfo"] = {};
		this["oAccessInfo"]["oBrowserEvent"] = oBrowserEvent;
		this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["NONE"];

		if (oBrowserEvent["oSource"] === this["oManager"]["oGetResizeHandleTopLeft"]()) {
			this["oAccessInfo"]["oDragStartPos"] = {
				"iX": oBsHandlerRect["left"],
				"iY": oBsHandlerRect["top"]
			};
			this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["DRAG_START"];
		} else if (oBrowserEvent["oSource"] === this["oManager"]["oGetResizeHandleBottomRight"]()) {
			this["oAccessInfo"]["oDragStartPos"] = {
				"iX": oBsHandlerRect["left"] + oBsHandlerRect["width"],
				"iY": oBsHandlerRect["top"] + oBsHandlerRect["height"]
			};
			this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["DRAG_START"];
		} else if (oBrowserEvent["oSource"] === this["oManager"]["oGetResizeHandleTopRight"]()) {
			this["oAccessInfo"]["oDragStartPos"] = {
				"iX": oBsHandlerRect["left"] + oBsHandlerRect["width"],
				"iY": oBsHandlerRect["top"]
			};
			this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["DRAG_START"];
		} else if (oBrowserEvent["oSource"] === this["oManager"]["oGetResizeHandleBottomLeft"]()) {
			this["oAccessInfo"]["oDragStartPos"] = {
				"iX": oBsHandlerRect["left"],
				"iY": oBsHandlerRect["top"] + oBsHandlerRect["height"]
			};
			this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["DRAG_START"];
		} else {
			// This is the click & drag part
			this["oAccessInfo"]["oDragStartPos"] = {
				"iX": Math["floor"]((oBrowserEvent["iClientX"]() - iLeftAbapListPosition - this["oAbapList"]["oGetContentDomRef"]()["offsetLeft"]) / this["oAbapList"]["fRasterWidth"]), //oBsHandlerRect.left,
				"iY": Math["floor"]((oBrowserEvent["iClientY"]() - iTopAbapListPosition - this["oAbapList"]["oGetContentDomRef"]()["offsetTop"]) / this["oAbapList"]["fRasterHeight"]),
				"iBottomX": Math["floor"]((oBrowserEvent["iClientX"]() - iLeftAbapListPosition - this["oAbapList"]["oGetContentDomRef"]()["offsetLeft"]) / this["oAbapList"]["fRasterWidth"]) + 1,
				"iBottomY": Math["floor"]((oBrowserEvent["iClientY"]() - iTopAbapListPosition - this["oAbapList"]["oGetContentDomRef"]()["offsetTop"]) / this["oAbapList"]["fRasterHeight"]) + 1
			};
			this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["DRAG_START"];
			// if the SHIFT is press and already exists an origin, the origin is kept and the drag is also extending
			if (!(this["oOriginBlockSelection"] && UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent))) {
				if (UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent)) {
					this["oOriginBlockSelection"] = { "TopLeftX": this["oAccessInfo"]["oDragStartPos"]["iX"], "TopLeftY": this["oAccessInfo"]["oDragStartPos"]["iY"], "BottomRightX": this["oAccessInfo"]["oDragStartPos"]["iX"] + 1, "BottomRightY": this["oAccessInfo"]["oDragStartPos"]["iY"] + 1 };
					this["oManager"]["setOriginBlockSelection"](this["oOriginBlockSelection"]);
					this["oOriginBoundaries"] = null;
					this["oManager"]["setCharSelectionPosition"]({ "Left": this["oAccessInfo"]["oDragStartPos"]["iX"], "Top": this["oAccessInfo"]["oDragStartPos"]["iY"] });

				} else {
					oClickedItem = this["oGetItemFromPoint"](oBrowserEvent["iClientX"](), oBrowserEvent["iClientY"]());
					if (oClickedItem && UCF_JsUtil["bInstanceOf"](oClickedItem, 'UCF_AbapListItem')) {
						this["oManager"]["setOriginItem"](oClickedItem);
						this["oOriginBlockSelection"] = { "TopLeftX": oClickedItem["iGetLeft"](), "TopLeftY": oClickedItem["iGetTop"](), "BottomRightX": oClickedItem["iGetLeft"]() + oClickedItem["iGetWidth"](), "BottomRightY": oClickedItem["iGetTop"]() + oClickedItem["iGetHeight"]() };
						this["oOriginBoundaries"] = null;
					} else {
						this["oOriginBlockSelection"] = { "TopLeftX": this["oAccessInfo"]["oDragStartPos"]["iX"], "TopLeftY": this["oAccessInfo"]["oDragStartPos"]["iY"], "BottomRightX": this["oAccessInfo"]["oDragStartPos"]["iX"] + 1, "BottomRightY": this["oAccessInfo"]["oDragStartPos"]["iY"] + 1 };
						this["oManager"]["setOriginBlockSelection"](this["oOriginBlockSelection"]);
						this["oOriginBoundaries"] = null;
					}
					this["oManager"]["removeCharFocus"]();
				}
				this["oBlockSelection"] = this["oOriginBlockSelection"];
				this["oManager"]["setBlockSelection"](this["oBlockSelection"]);

			}
		}

		this["oAccessInfo"]["oDragStartClientPos"] = {
			"iClientX": oBrowserEvent["iClientX"](),
			"iClientY": oBrowserEvent["iClientY"]()
		};
		//Click and drag without mouse up generates JS error
		this["initializeBlockSelection"]();
		this["handleBlockSelect"](this["oAccessInfo"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsdragstart"] = 0; };

/**
 * Sets the block selection
 *
 * @private
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["initializeBlockSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["initializeBlockSelection"]++; }; 

	if (this["oBlockSelection"] && this["oManager"]["oGetBlockSelectionFrame"]()) return;

	if (!this["oBlockSelection"]) {
		this["oBlockSelection"] = { "TopLeftX": 0, "TopLeftY": 0, "BottomRightX": 0, "BottomRightY": 0 };
		this["oManager"]["setBlockSelection"](this["oBlockSelection"]);
	}

	if (!this["oManager"]["oGetBlockSelectionFrame"]()) {
		this["oManager"]["applyBlockSelection"]();
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["initializeBlockSelection"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdragover
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onlsdragover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsdragover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListBlockSelectionDelegate.js(1372): onlsdragover"); };
	if (!this["oAccessInfo"]) return;
	if (!oBrowserEvent["bIsTouchInteraction"]()) {

		this["oAccessInfo"]["oBrowserEvent"] = oBrowserEvent;
		this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["DRAG_OVER"];
		this["handleBlockSelect"](this["oAccessInfo"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsdragover"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdragend
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsdragend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListBlockSelectionDelegate.js(1387): onlsdragend"); };

	if (!oBrowserEvent["bIsTouchInteraction"]()) {
		this["oAccessInfo"]["oBrowserEvent"] = oBrowserEvent;
		this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["DRAG_END"];
		this["handleBlockSelect"](this["oAccessInfo"]);
		this["oAccessInfo"] = null;
		//	this.oAbapList.focus();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsdragend"] = 0; };

/**
 * Sets the block selection while drag over
 * @param { UCF_AbapListBlockSelectionDelegate_AccessInfo } oAccessInfo
 * @private
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["handleTouchOver"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleTouchOver"]++; }; 
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBSRefPoint;
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBlockSelection;

	/** @type {number} */
	var iCurrentRasterX;
	/** @type {number} */
	var iCurrentRasterY;
	/** @type {number} */
	var iRefX;
	/** @type {number} */
	var iRefY;

	iRefX = -1;
	iRefY = -1;

	oBlockSelection = {
		"TopLeftX": this["oBlockSelection"]["TopLeftX"],
		"TopLeftY": this["oBlockSelection"]["TopLeftY"],
		"BottomRightX": this["oBlockSelection"]["BottomRightX"],
		"BottomRightY": this["oBlockSelection"]["BottomRightY"]
	};
	oBSRefPoint = this["oOriginBlockSelection"];
	//debugger;
	iRefX = oBSRefPoint["TopLeftX"];
	iRefY = oBSRefPoint["TopLeftY"];

	iCurrentRasterX = Math["round"]((oAccessInfo["oBrowserEvent"]["iClientX"]() - this["oAbapListRect"]["left"]) / this["oAbapList"]["fRasterWidth"]);
	iCurrentRasterY = Math["round"]((oAccessInfo["oBrowserEvent"]["iClientY"]() - this["oAbapListRect"]["top"]) / this["oAbapList"]["fRasterHeight"]);

	if (iCurrentRasterX <= iRefX) {
		//the current cursor position if on the left side of the origin
		iRefX = oBSRefPoint["BottomRightX"];
	}

	if (iCurrentRasterY <= iRefY) {
		//the current cursor position if on the top side of the origin
		iRefY = oBSRefPoint["BottomRightY"];
	}

	oBlockSelection["TopLeftX"] = Math["min"](iRefX, iCurrentRasterX);
	oBlockSelection["TopLeftY"] = Math["min"](iRefY, iCurrentRasterY);
	oBlockSelection["BottomRightX"] = Math["max"](iRefX, iCurrentRasterX);
	oBlockSelection["BottomRightY"] = Math["max"](iRefY, iCurrentRasterY);

	//  fit into current frame
	oBlockSelection["TopLeftX"] = Math["max"](oBlockSelection["TopLeftX"], this["oManager"]["iGetFirstColumn"]());
	oBlockSelection["TopLeftY"] = Math["max"](oBlockSelection["TopLeftY"], this["oManager"]["iGetFirstRow"]());
	oBlockSelection["BottomRightX"] = Math["min"](oBlockSelection["BottomRightX"], this["oManager"]["iGetLastColumn"]());
	oBlockSelection["BottomRightY"] = Math["min"](oBlockSelection["BottomRightY"], this["oManager"]["iGetLastRow"]());

	this["oManager"]["setBlockSelectionInternal"](oBlockSelection);

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleTouchOver"] = 0; };
/**
 * @private
 * @param {UCF_AbapListBlockSelectionDelegate_AccessInfo} oAccessInfo
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["handleTouchBlockSelect"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleTouchBlockSelect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "AbapListBlockSelectionDelegate.js(1465): handleTouchBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "AbapListBlockSelectionDelegate.js(1466): handleTouchBlockSelect"); };

	this["bIsTouchBlockSelection"] = true;
	// if iX && iY is not set, then the touch handlers didn't work

	if (oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["TOUCH_OVER"]) {
		this["handleTouchOver"](oAccessInfo);
	}

	if (oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["TOUCH_END"]) {
		this["oManager"]["fireBlockSelectInternal"](this["oBlockSelection"]);
	}

	oAccessInfo["oBrowserEvent"]["cancel"]();
	oAccessInfo["oBrowserEvent"]["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["handleTouchBlockSelect"] = 0; };

/**
 * Sets the block selection
 *
 * @private
 * @param {string} sBlockSelection
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["setBlockSelection"] = function(sBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["setBlockSelection"]++; }; 
	/** @type {UCF_AbapListBlockSelectionDelegate_BlockSelection} */
	var oBlockSelection;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sBlockSelection != null, "sBlockSelection != null", "AbapListBlockSelectionDelegate.js(1493): setBlockSelection"); };

	this["sBlockSelection"] = sBlockSelection;

	if (this["sBlockSelection"]) {
		oBlockSelection = UCF_JsUtil["oJsonParse"](this["sBlockSelection"]);
	}
	this["oManager"]["setBlockSelectionInternal"](oBlockSelection);

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["setBlockSelection"] = 0; };

/**
 * @private
 * @return {boolean} - true if the Copy to Clipboard is enabled
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["bCopyToClipboardEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bCopyToClipboardEnabled"]++; }; 
	return this["oAbapList"]["bIsCopyToClipboardEnabled"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bCopyToClipboardEnabled"] = 0; };

/** @private */
UCF_AbapListBlockSelectionDelegate["prototype"]["onselectionchange"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onselectionchange"]++; }; 
	//	this.oManager.setCopyToClipboardEnabled(!this.bIsActiveSelectionOutside());
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onselectionchange"] = 0; };

UCF_AbapListBlockSelectionDelegate["prototype"]["focusAllAbapList"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["focusAllAbapList"]++; }; 
	/** @type {UCF_AbapListBlockSelectionManager_BlockSelection} */
	var oBlockSelection = this["oManager"]["oGetBlockSelection"]();

	oBlockSelection["TopLeftX"] = this["oManager"]["iGetFirstColumn"]();
	oBlockSelection["TopLeftY"] = this["oManager"]["iGetFirstRow"]();
	oBlockSelection["BottomRightX"] = this["oManager"]["iGetLastColumn"]();
	oBlockSelection["BottomRightY"] = this["oManager"]["iGetLastRow"]();
	this["oManager"]["setBlockSelectionInternal"](oBlockSelection);
	this["oManager"]["fireBlockSelectInternal"](this["oBlockSelection"]);

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["focusAllAbapList"] = 0; };

/**

/**
 * [ESCAPE]
 * If focus is in cell navigation mode and a block selection is active: remove block selection, keep focused cell.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onlsescape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsescape"]++; }; 
	var oFocusedBlockSelection =
		this["oAbapList"]["oGetLastFocusedItem"]() && this["oManager"]["oGetBlockSelection"]() ?
		this["oManager"]["oGetItemPosition"](this["oAbapList"]["oGetLastFocusedItem"]()) : null;
	if (oFocusedBlockSelection && !this["oManager"]["bIsSameBlockSelection"](oFocusedBlockSelection)) {

		this["oOriginBlockSelection"] = oFocusedBlockSelection;
		this["oManager"]["setOriginItem"](this["oAbapList"]["oGetLastFocusedItem"]());
		this["oManager"]["setBlockSelectionInternal"](this["oManager"]["oGetOriginBlockSelection"]());
		this["oManager"]["applyBlockSelection"]();
		this["oManager"]["fireBlockSelectInternal"](this["oManager"]["oGetOriginBlockSelection"]());

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ================ [ESCAPE] will bubble further: ' + this["oAbapList"]["sId"], "AbapListBlockSelectionDelegate.js(1554): onlsescape"); };

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlsescape"] = 0; };

/**
 * Starts the resize process and attaches to the mousemove and mouseup event
 * centrally.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["touchStartBlockSelection"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["touchStartBlockSelection"]++; }; 
	/** @type {UCF_AbapList} */
	//var self = this;
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {_ObjectRect} */
	var oBsHandlerRect = UCF_DomUtil["oGetObjectRect"](oSource, this["oAbapList"]["oGetContentDomRef"]());
	/** @type {UCF_Page} */
	var oPage = this["oLS"]["oGetPageInternal"]();

	if (oPage) {
		oPage["disableTextSelection"]();
	}

	this["oAccessInfo"] = {};
	this["oAccessInfo"]["oBrowserEvent"] = oBrowserEvent;
	this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["NONE"];

	if (oSource === this["oManager"]["oGetResizeHandleTopLeft"]()) {
		this["oAccessInfo"]["oTouchStartPos"] = {
			"iX": oBsHandlerRect["left"],
			"iY": oBsHandlerRect["top"]
		};
		this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["TOUCH"];
		this["oAccessInfo"]["sHandler"] = this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"];
	} else if (oSource === this["oManager"]["oGetResizeHandleBottomRight"]()) {
		this["oAccessInfo"]["oTouchStartPos"] = {
			"iX": oBsHandlerRect["left"] + oBsHandlerRect["width"],
			"iY": oBsHandlerRect["top"] + oBsHandlerRect["height"]
		};
		this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["TOUCH"];
		this["oAccessInfo"]["sHandler"] = this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"];
	} else {
		this["oAccessInfo"]["oTouchStartPos"] = {
			"iX": oBsHandlerRect["left"] + oBsHandlerRect["width"],
			"iY": oBsHandlerRect["top"] + oBsHandlerRect["height"]
		};
		this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["TOUCH"];
		this["oAccessInfo"]["sHandler"] = this["DRAG_CUSTOM_TYPE"]["BLOCK_CLICK_DRAG"];
	}
	this["oAccessInfo"]["oTouchStartClientPos"] = {
		"iClientX": oBrowserEvent["iClientX"](),
		"iClientY": oBrowserEvent["iClientY"]()
	};
	if (UCF_JsUtil["bIsEmpty"](this["oBlockSelection"])) {
		this["oAccessInfo"]["oBSRefPoint"] = {
			"TopLeftX": 0,
			"TopLeftY": 0,
			"BottomRightX": 0,
			"BottomRightY": 0
		};
	} else {
		this["oAccessInfo"]["oBSRefPoint"] = {
			"TopLeftX": this["oBlockSelection"]["TopLeftX"],
			"TopLeftY": this["oBlockSelection"]["TopLeftY"],
			"BottomRightX": this["oBlockSelection"]["BottomRightX"],
			"BottomRightY": this["oBlockSelection"]["BottomRightY"]
		};
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["touchStartBlockSelection"] = 0; };

/**
 * Handles the mouse down on the resize handle if the text edit is open
 * It stops the resizing
 *
 * @param {MouseEvent} oDomEvent the mouseup on the resize handle
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onResizeHandleTouchEnd"] = function(oDomEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onResizeHandleTouchEnd"]++; }; 
	/** @type {HTMLElement} */
	var oSource;
	oSource = oDomEvent["target"] || oDomEvent["srcElement"];
	if (!oSource || (oSource && !UCF_DomUtil["bContains"](this["oAbapList"]["oGetContentDomRef"](), oSource)))
		return;

	if (this["oAbapList"] && this["oAbapList"]["mEvents"]["BlockSelect"] && this["oAccessInfo"]) {
		this["oAccessInfo"]["oBrowserEvent"] = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oDomEvent);
		this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["TOUCH_END"];
		this["handleTouchBlockSelect"](this["oAccessInfo"]);
		oDomEvent["cancelBubble"] = true;
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onResizeHandleTouchEnd"] = 0; };

/** @private Stops the resize process */
UCF_AbapListBlockSelectionDelegate["prototype"]["stopResizeBlockSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["stopResizeBlockSelection"]++; }; 
	/** @type {UCF_Page} */
	var oPage = this["oLS"]["oGetPageInternal"]();

	if (oPage) {
		oPage["enableTextSelection"]();
	}
	/*
		// detaching events
		UCF_DomUtil.detachEvent(document.body, 'mousemove', this.handleEvent, true);
		UCF_DomUtil.detachEvent(document.body, 'mouseup', this.handleEvent, true);
		UCF_DomUtil.detachEvent(document.body, 'touchmove', this.handleEvent, true);
		UCF_DomUtil.detachEvent(document.body, 'touchend', this.handleEvent, true);
		*/
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["stopResizeBlockSelection"] = 0; };

/**
 * Handles the mouse move on the resize handle if the text edit is open
 *
 * @param {MouseEvent} oDomEvent the mousemove on the resize handle
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onResizeHandleTouchMove"] = function(oDomEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onResizeHandleTouchMove"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent;
	/** @type {UCF_HTMLElement} */
	var oSource;
	if (this["oAbapList"] && this["oAbapList"]["mEvents"] && this["oAbapList"]["mEvents"]["BlockSelect"] && this["oAccessInfo"]) {
		oBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oDomEvent);
		this["oAccessInfo"]["oBrowserEvent"] = oBrowserEvent;
		if (oBrowserEvent) oSource = oBrowserEvent["oGetSource"]();

		if (oSource && (
				oSource === this["oManager"]["oGetBlockSelectionFrame"]() ||
				UCF_DomUtil["bContains"](this["oAbapList"]["oGetContentDomRef"](), oSource))) {
			this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["TOUCH_OVER"];
			this["handleTouchBlockSelect"](this["oAccessInfo"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onResizeHandleTouchMove"] = 0; };

/**
 * @private
 * Check if the Items have commom positions
 *
 * @param {AbapListItem}  oItem1 - first parameter
 * @param {AbapListItem} oItem2 - second parameter
 * @return {boolean}
 *
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["bItemsIntersect"] = function(oItem1, oItem2) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bItemsIntersect"]++; }; 
	/** @type {boolean} */
	var bIntersect = false;

	if (!(oItem1 && oItem2)) return false;
	// check if have the same begin or end position
	bIntersect = oItem1["iGetLeft"]() === oItem2["iGetLeft"]() || (oItem1["iGetLeft"]() + oItem1["iGetWidth"]()) === (oItem2["iGetLeft"]() + oItem2["iGetWidth"]());

	if (!bIntersect) {
		//check if the second is included on the first item
		bIntersect = (oItem1["iGetLeft"]() < oItem2["iGetLeft"]() && oItem2["iGetLeft"]() < (oItem1["iGetLeft"]() + oItem1["iGetWidth"]()));
	}

	if (!bIntersect) {
		//check if the second is included on the first item
		bIntersect = (oItem2["iGetLeft"]() < oItem1["iGetLeft"]() && oItem1["iGetLeft"]() < (oItem2["iGetLeft"]() + oItem2["iGetWidth"]()));
	}

	return bIntersect;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bItemsIntersect"] = 0; };
/** @private Parses all items in order to create a flat list of characters */
UCF_AbapListBlockSelectionDelegate["prototype"]["generateOriginBoundaries"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["generateOriginBoundaries"]++; }; 
	/** @type {number} */
	var iTop = -1;
	/** @type {number} */
	var iBegin = -1;
	/** @type {number} */
	var iBottom = -1;
	/** @type {number} */
	var iEnd = -1;
	/** @type {UCF_AbapListItem} */
	var oItem = null;

	if (this["oOriginBoundaries"]) return;
	if (!this["oOriginItem"]) return;

	// Get iBegin & iEnd
	var oLine = this["mRasterMatrix"][this["oOriginItem"]["iGetTop"]()];
	if (oLine) {
		iBegin = Math["max"](this["oManager"]["iGetFirstColumn"](), oLine[0]["iGetLeft"]());
		oItem = oLine[oLine["length"] - 1];
		iEnd = Math["min"](this["oManager"]["iGetLastColumn"](), oItem["iGetLeft"]() + oItem["iGetWidth"]());
	}
	oItem = null;
	iTop = this["oManager"]["iGetFirstRow"]();
	var bFound = false;
	while (!bFound && iTop < this["oManager"]["iGetLastRow"]()) {
		oLine = this["mRasterMatrix"][iTop];
		if (oLine) {
			for (var i = 0; i < oLine["length"]; i++) {
				oItem = oLine[i];
				bFound = this["bItemsIntersect"](oItem, this["oOriginItem"]);
				if (bFound)
					break;
			}
		}
		iTop++;
	}
	if (oItem)
		iTop = oItem["iGetTop"]();

	iBottom = this["oManager"]["iGetLastColumn"]();
	oItem = null;
	bFound = false;
	while (!bFound && iBottom > this["oManager"]["iGetFirstRow"]()) {
		oLine = this["mRasterMatrix"][iBottom];
		if (oLine) {
			for (i = 0; i < oLine["length"]; i++) {
				oItem = oLine[i];
				bFound = this["bItemsIntersect"](oItem, this["oOriginItem"]);
				if (bFound)
					break;
			}
		}
		iBottom--;
	}
	if (oItem)
		iBottom = oItem["iGetTop"]() + oItem["iGetHeight"]();

	this["oOriginBoundaries"] = { "Top": iTop, "Begin": iBegin, "Bottom": iBottom, "End": iEnd };

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["generateOriginBoundaries"] = 0; };

/**
 * Checks if the origin is valid - can habe TabIndex
 * @return {boolean} - return true if the item has empty text
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["bIsOriginValid"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bIsOriginValid"]++; }; 

	if (this["oOriginItem"]) {
		return this["oManager"]["bIsNavigable"](this["oOriginItem"]);
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bIsOriginValid"] = 0; };

/**
 * Checks if the origin is valid - can habe TabIndex
 *  @param {UCF_AbapListItem} oItem
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["resetTheOrigin"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["resetTheOrigin"]++; }; 

	if (oItem) {
		this["oManager"]["setOriginItem"](oItem);
		this["oOriginBlockSelection"] = {
			"TopLeftX": oItem["iGetLeft"](),
			"TopLeftY": oItem["iGetTop"](),
			"BottomRightX": oItem["iGetLeft"]() + oItem["iGetWidth"](),
			"BottomRightY": oItem["iGetTop"]() + oItem["iGetHeight"]()
		};
		this["oOriginBoundaries"] = null;

	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["resetTheOrigin"] = 0; };

/**
 * @private
 * Parses all items in order to create a flat list of characters
 *
 * @return {Object} - the first focusable or the first text item
 **/
UCF_AbapListBlockSelectionDelegate["prototype"]["findFocusableItems"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["findFocusableItems"]++; }; 

	/** @type {UCF_AbapListItem} */
	var oItem = null;
	/** @type {NodeListOf<HTMLDivElement|HTMLInputElement>} */
	var aItemRefs = this["oAbapList"]["oGetContentDomRef"]()["querySelectorAll"]('div, input');
	/** @type {number} */
	var i;
	/** @type {UCF_AbapListItem} */
	var oActiveItem = null;
	/** @type {UCF_AbapListItem} */
	var oTextItem = null;

	for (i = 0; i < aItemRefs["length"] && (oActiveItem == null || oTextItem == null); i++) {
		oItem = this["oAbapList"]["oGetControlByDomRef"](aItemRefs[i], true);

		if (oItem) { //	iTopLeftX = oItem.iGetLeft();
			if (UCF_DomUtil["bHasTabIndex"](oItem["oDomRef"])) {
				if (!oActiveItem) oActiveItem = oItem;
			} else if (this["oManager"]["bIsNavigable"](oItem))
				if (!oTextItem) oTextItem = oItem;
		}
	}
	return { "ActiveItem": oActiveItem, "TextItem": oTextItem };
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["findFocusableItems"] = 0; };

/**
 * Check if the BlockSelection has only an Item
 * @param {UCF_AbapListBlockSelectionDelegate_BlockSelection} oBlockSelection
 * @return {boolean} - return the Object
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["bHasBlockSelectionOnlyAnItem"] = function(oBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bHasBlockSelectionOnlyAnItem"]++; }; 
	var oCurrentBlockSelection = oBlockSelection || this["oBlockSelection"];
	if (this["oManager"]["bIsBlockSelectionEmpty"](oCurrentBlockSelection)) return false;
	var oItem = this["oManager"]["oGetItemXY"](oCurrentBlockSelection["TopLeftX"], oCurrentBlockSelection["TopLeftY"]);
	if (!UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListItem')) return false;

	if (oItem["iGetLeft"]() + oItem["iGetWidth"]() !== oCurrentBlockSelection["BottomRightX"]) return false;
	if (oItem["iGetTop"]() + oItem["iGetHeight"]() !== oCurrentBlockSelection["BottomRightY"]) return false;

	return true;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bHasBlockSelectionOnlyAnItem"] = 0; };

/**
 * Avoids to select the current item
 * @param {BrowserEvent} oBrowserEvent
 * @return {boolean} - return the Object
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["bAvoidItemSelection"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bAvoidItemSelection"]++; }; 

	/** @type {UCF_HTMLElement} */
	var oSourceControl;
	/** @type {boolean} */
	var bIsAbapListInput;
	if (UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent)) {
		if (this["oOriginItem"]) {
			this["oManager"]["setTabIndexForItem"](this["oOriginItem"], false);
		}
		return true;
	}

	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) {
		if (this["oOriginItem"]) {
			return true;
		}
	}
	oSourceControl = oBrowserEvent["oGetSourceControl"]();
	bIsAbapListInput = oSourceControl && UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_AbapListText') && !oSourceControl["bReadOnly"];
	if (this["oManager"]["bIsItemInBlockSelection"](oSourceControl) && bIsAbapListInput) {
		return true;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bAvoidItemSelection"] = 0; };

/**
 * Avoids to select the current item
 * @param {BrowserEvent} oBrowserEvent
 * @return {boolean} - return the Object
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["bAvoidItemSelection"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bAvoidItemSelection"]++; }; 

	/** @type {UCF_HTMLElement} */
	var oSourceControl;
	/** @type {boolean} */
	var bIsAbapListInput;
	if (UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent)) {
		if (this["oOriginItem"]) {
			this["setTabIndexForItem"](this["oOriginItem"], false);
		}
		return true;
	}

	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) {
		if (this["oOriginItem"]) {
			return true;
		}
	}
	oSourceControl = oBrowserEvent["oGetSourceControl"]();
	bIsAbapListInput = oSourceControl && UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_AbapListText') && !oSourceControl["bReadOnly"];
	if (this["oManager"]["bIsItemInBlockSelection"](oSourceControl) && bIsAbapListInput) {
		return true;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bAvoidItemSelection"] = 0; };

/**
 * Avoids to select the current item
 * @param {AbapLisItem} oItem
 * @return {boolean} - return the Object
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["bAvoidItemSelectionByFocus"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bAvoidItemSelectionByFocus"]++; }; 
	/** @type {Element} */
	var oDomRef;

	if (oItem) {
		oDomRef = oItem["oDomRef"];
		return oDomRef && UCF_DomUtil["sGetAttribute"](oDomRef, 'data-avoid-blockselection') === 'true';
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["bAvoidItemSelectionByFocus"] = 0; };

/**
 * set data-avoid-blockselection Attribute
 * @param {AbapLisItem} oItem
 *
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["removeAvoidItemSelectionByFocus"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["removeAvoidItemSelectionByFocus"]++; }; 
	/** @type {Element} */
	var oDomRef;

	if (oItem) {
		oDomRef = oItem["oDomRef"];
		oDomRef["removeAttribute"]('data-avoid-blockselection');
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["removeAvoidItemSelectionByFocus"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstouchstart
 * @return {boolean} false to skip event processing
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlstouchstart"]++; }; 
	/** @type {boolean} */
	var bResult = undefined;
	/** @type {HTMLElement} */
	var oSource;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListBlockSelectionDelegate.js(1970): onlstouchstart"); };

	// touchStart at BlockSelectionHandle
	oSource = oBrowserEvent["oGetSource"]();

	bResult = true;
	if (oSource === this["oManager"]["oGetResizeHandleTopLeft"]() ||
		oSource === this["oManager"]["oGetResizeHandleBottomRight"]()) {
		this["bTouchForSelect"] = true;
		// add selection class for TopLeft and BottomRight
		this["oManager"]["applySelectionHandlersCss"](true);
		this["touchStartBlockSelection"](oBrowserEvent);
	} else if (
		oSource === this["oManager"]["oGetBlockSelectionFrame"]() ||
		UCF_DomUtil["bContains"](this["oAbapList"]["oGetContentDomRef"](), oSource)
	) {

		this["bIsTouchBlockSelection"] = true;
		// add selection class for TopLeft and BottomRight
		this["oManager"]["applySelectionHandlersCss"](!oBrowserEvent["bIsMouseHover"]());

		this["clickItem"](oBrowserEvent);
		this["touchStartBlockSelection"](oBrowserEvent);
	}

	return bResult;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlstouchstart"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstouchmove
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onlstouchmove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlstouchmove"]++; }; 
	/** @type {HTMLElement} */
	var oSource;

	if (!this["oBlockSelection"]) {
		// touch & move
		oSource = oBrowserEvent["oGetSource"]();

		if (
			oSource === this["oManager"]["oGetBlockSelectionFrame"]() ||
			UCF_DomUtil["bContains"](this["oAbapList"]["oGetContentDomRef"](), oSource)
		) {
			this["bIsTouchBlockSelection"] = true;
			// add selection class for TopLeft and BottomRight
			this["oManager"]["applySelectionHandlersCss"](!oBrowserEvent["bIsMouseHover"]());

			this["oBlockSelection"] = this["clickItem"](oBrowserEvent);
			this["oManager"]["setBlockSelection"](this["oBlockSelection"]);
			this["touchStartBlockSelection"](oBrowserEvent);
		}
	}

	this["oAccessInfo"]["oBrowserEvent"] = oBrowserEvent;
	this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["TOUCH_OVER"];
	this["handleTouchBlockSelect"](this["oAccessInfo"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlstouchmove"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstouchend
 */
UCF_AbapListBlockSelectionDelegate["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlstouchend"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListBlockSelectionDelegate.js(2035): onlstouchend"); };

	this["oAccessInfo"]["oBrowserEvent"] = oBrowserEvent;
	this["oAccessInfo"]["eAccessType"] = this["ACCESS_TYPE"]["TOUCH_END"];
	this["handleTouchBlockSelect"](this["oAccessInfo"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionDelegate["_"]["onlstouchend"] = 0; };

};
sap["ls"]["preload"]["UCF_AbapListBlockSelectionManager"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_Cache */
/// <reference path="../../../core/util/Cache.js"/>
/* global UCF_AbapList */
/// <reference path="../../controls/AbapList.js"/>

/**
 * @typedef {Object} UCF_AbapListBlockSelectionManager_BlockSelection
 * @property {number} TopLeftX
 * @property {number} TopLeftY
 * @property {number} BottomRightX
 * @property {number} BottomRightY
 */

/**
 *
 * @class UCF_AbapListBlockSelectionManager
 * @extends UCF_Object
 * @param {UCF_LS} oLS
 * @param {UCF_AbapList} oAbapList
 *
 */
function UCF_AbapListBlockSelectionManager(oLS, oAbapList) {if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["UCF_AbapListBlockSelectionManager"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		this["oLS"] = oLS;
		this["oAbapList"] = oAbapList;
		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
		/** {UCF_AbapListBlockSelectionManager_BlockSelection} */
		this["oBlockSelection"] = null;

		/** {UCF_AbapListBlockSelectionManager_BlockSelection} */
		this["oOriginBlockSelection"] = null;
		/** {HTMLDivElement} */
		this["oBlockSelectionFrame"] = null;
		this["iBorderSelection"] = parseInt(UCF_AbapList["oGetMetadata"]()["borderBlockSelection"]);
		if (isNaN(this["iBorderSelection"])) {
			this["iBorderSelection"] = 0;
		}

		this["aCharSelectionPosition"] = null;
		this["oOriginItem"] = null;
		this["sManagerId"] = this["oAbapList"]["sId"] + '______' + UCF_JsUtil["iGetTimeStamp"]();
	}
};window["UCF_AbapListBlockSelectionManager"] = UCF_AbapListBlockSelectionManager; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListBlockSelectionManager"); UCF_AbapListBlockSelectionManager["_"] = {UCF_AbapListBlockSelectionManager: 0}; }; ;

UCF_AbapListBlockSelectionManager["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_AbapListBlockSelectionManager.prototype["sClassName"] = "UCF_AbapListBlockSelectionManager";

UCF_AbapListBlockSelectionManager["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["destroy"]++; }; 
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
	this["oLS"] = null;
	this["oAbapList"] = null;
	this["oCache"]["destroy"]();
	this["oCache"] = null;
	this["oBlockSelection"] = null;
	this["oBlockSelectionFrame"] = null;
	this["oOriginBlockSelection"] = null;
	this["iBorderSelection"] = null;
	this["aCharSelectionPosition"] = null;
	this["oOriginItem"] = null;
	this["sManagerId"] = null;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["destroy"] = 0; };

/** @type {UCF_AbapListBlockSelectionManager_SuffixEnum} */
UCF_AbapListBlockSelectionManager["prototype"]["eIdsSuffix"] = {
	"BLOCKSELECTION_FRAME": '-bsFrame',
	"BLOCKSELECTION_CONTENT": '-lsAbapList--bs',
	"BLOCKSELECTION_TOP_LEFT": '-bsHandleTL',
	"BLOCKSELECTION_BOTTOM_RIGHT": '-bsHandleBR',
	"BLOCKSELECTION_TOP_RIGHT": '-bsHandleTR',
	"BLOCKSELECTION_BOTTOM_LEFT": '-bsHandleBL',
	"BLOCKSELECTION_FOCUS": '-bsFocus',
	"BLOCKSELECTION_CHAR": '-bsCharFocus'
};

/** @type {UCF_AbapListBlockSelectionManager_StyleEnum} */
UCF_AbapListBlockSelectionManager["prototype"]["eStyles"] = {
	"BLOCKSELECTION_FRAME": 'lsAbapListBSFrame',
	"BLOCKSELECTION_CONTENT": 'lsAbapList--bs',
	"BLOCKSELECTION_MOUSE_TOP_LEFT": 'lsAbapListBSHandleTL',
	"BLOCKSELECTION_MOUSE_BOTTOM_RIGHT": 'lsAbapListBSHandleBR',
	"BLOCKSELECTION_MOUSE_TOP_RIGHT": 'lsAbapListBSHandleTR',
	"BLOCKSELECTION_MOUSE_BOTTOM_LEFT": 'lsAbapListBSHandleBL',
	"BLOCKSELECTION_TOUCH_TOP_LEFT": 'lsAbapListBSHandleTLTouch',
	"BLOCKSELECTION_TOUCH_BOTTOM_RIGHT": 'lsAbapListBSHandleBRTouch',
	"BLOCKSELECTION_FOCUS": 'lsAbapList--bsFocus',
	"BLOCKSELECTION_CHAR": 'lsAbapList-char-focus'
};

/**
 * @private
 * Parses all items in order to create a flat list of items
 * @return { Array } - all the AbapListItems, except the AbapListImage with  Type != AbapListImageType.SRC
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetAllAbapListItems"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetAllAbapListItems"]++; }; 

	/** @type {UCF_AbapList} */
	var selfAbapList = this["oAbapList"];

	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('oGetAllAbapListItems', function() {
		/** @type {number} */
		//	var iTopLeftX = -1;
		/** @type {number} */
		var iTopLeftY = -1;
		/** @type {UCF_AbapListItem} */
		var oItem = null;
		/** @type {NodeListOf<HTMLDivElement|HTMLInputElement>} */
		var aItemRefs = selfAbapList["oGetContentDomRef"]()["querySelectorAll"]('div, input');
		/** @type {number} */
		var i;
		/** Array */
		var mRasterMatrix;
		mRasterMatrix = [];

		for (i = 0; i < aItemRefs["length"]; i++) {
			oItem = selfAbapList["oGetControlByDomRef"](aItemRefs[i], true);

			if (oItem) { //	iTopLeftX = oItem.iGetLeft();
				iTopLeftY = oItem["iGetTop"]();

				if (!mRasterMatrix[iTopLeftY]) {
					mRasterMatrix[iTopLeftY] = [];
				}
				if (self["bIsNavigable"](oItem))
					mRasterMatrix[iTopLeftY]["push"](oItem);
			}
		}
		return mRasterMatrix;
	});

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetAllAbapListItems"] = 0; };

/**
 * @private
 * Parses all items in order to create a flat list of characters
 *  @return { Array } - all the text for AbapListText
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetAllAbapListItemsAsText"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetAllAbapListItemsAsText"]++; }; 
	/** @type {UCF_AbapList} */
	var self = this["oAbapList"];

	return this["oCache"]["get"]('oGetAllAbapListItemsAsText', function() {

		/** @type {number} */
		var iTopLeftX = -1;
		/** @type {number} */
		var iTopLeftY = -1;
		/** @type {UCF_AbapListItem} */
		var oItem = null;
		/** @type {string[]} */
		var aItemText = null;
		/** @type {NodeListOf<HTMLDivElement|HTMLInputElement>} */
		var aItemRefs = UCF_DomUtil["querySelectorAll"]('div, input', self["oGetContentDomRef"]());
		/** @type {number} */
		var i;
		/** @type {number} */
		var j;
		/** Array */
		var mRasterMatrix;
		mRasterMatrix = [];

		for (i = 0; i < aItemRefs["length"]; i++) {
			oItem = self["oGetControlByDomRef"](aItemRefs[i], true);

			if (UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListText')) {
				iTopLeftX = oItem["iGetLeft"]();
				iTopLeftY = oItem["iGetTop"]();
				aItemText = oItem["sText"]["split"]('');
				if (oItem["sText"] !== '')
					aItemText = aItemText["concat"](['\t']);

				if (!mRasterMatrix[iTopLeftY]) {
					mRasterMatrix[iTopLeftY] = [];
				}

				for (j = 0; j < aItemText["length"]; j++) {
					mRasterMatrix[iTopLeftY][iTopLeftX + j] = aItemText[j];
				}
			}
		}
		return mRasterMatrix;
	});

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetAllAbapListItemsAsText"] = 0; };

/**
 * @private
 * retrive the AbapList boundaries for the first AbapLisItem
 * and the last AbapListItem
 * @return {Object}
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetAbapListBoundaries"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetAbapListBoundaries"]++; }; 

	/** @type {UCF_AbapList} */
	var self = this["oAbapList"];

	return this["oCache"]["get"]('oGetAbapListBoundaries', function() {
		/** @type {number} */
		var iFirstColumn = 10000;
		/** @type {number} */
		var iFirstRow = 10000;
		/** @type {number} */
		var iNoOfColumns = -1;
		/** @type {number} */
		var iNoOfRows = -1;
		/** @type {UCF_AbapListItem} */
		var oItem = null;
		/** @type {NodeListOf<HTMLDivElement|HTMLInputElement>} */
		var aItemRefs = self["oGetContentDomRef"]()["querySelectorAll"]('div, input');
		/** @type {number} */
		var i;

		for (i = 0; i < aItemRefs["length"]; i++) {
			oItem = self["oGetControlByDomRef"](aItemRefs[i], true);

			if (oItem) { //	iTopLeftX = oItem.iGetLeft();
				iFirstColumn = Math["min"](iFirstColumn, oItem["iGetLeft"]());
				iFirstRow = Math["min"](iFirstRow, oItem["iGetTop"]());
				iNoOfColumns = Math["max"](iNoOfColumns, oItem["iGetLeft"]() + oItem["iGetWidth"]());
				iNoOfRows = Math["max"](iNoOfRows, oItem["iGetTop"]() + oItem["iGetHeight"]());
			}
		}

		return {
			"TopLeftX": iFirstColumn,
			"TopLeftY": iFirstRow,
			"BottomRightX": iNoOfColumns,
			"BottomRightY": iNoOfRows
		};
	});

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetAbapListBoundaries"] = 0; };

/**
 * @private
 * retrives the first row which can be selected
 * @return {int}
 */
UCF_AbapListBlockSelectionManager["prototype"]["iGetFirstRow"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetFirstRow"]++; }; 

	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('iGetFirstRow', function() {
		return self["oGetAbapListBoundaries"]()["TopLeftY"];
	});
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetFirstRow"] = 0; };

/**
 * @private
 * retrives the first column which can be selected
 * @return {int}
 */
UCF_AbapListBlockSelectionManager["prototype"]["iGetFirstColumn"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetFirstColumn"]++; }; 

	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('iGetFirstColumn', function() {
		return self["oGetAbapListBoundaries"]()["TopLeftX"];
	});
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetFirstColumn"] = 0; };

/**
 * @private
 * retrives the last column which can be selected
 * @return {int}
 */
UCF_AbapListBlockSelectionManager["prototype"]["iGetLastColumn"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetLastColumn"]++; }; 

	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('iGetLastColumn', function() {
		return self["oGetAbapListBoundaries"]()["BottomRightX"];
	});
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetLastColumn"] = 0; };

/**
 * @private
 * retrives the last row which can be selected
 * @return {int}
 */
UCF_AbapListBlockSelectionManager["prototype"]["iGetLastRow"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetLastRow"]++; }; 

	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('iGetLastRow', function() {
		return self["oGetAbapListBoundaries"]()["BottomRightY"];
	});
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetLastRow"] = 0; };

/**
 * @param {UCF_AbapListItem} oItem
 * @return {boolean} - return true if the item has empty text
 */
UCF_AbapListBlockSelectionManager["prototype"]["bIsNavigable"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsNavigable"]++; }; 
	if (!oItem) return false;
	if (!this["bIsAbapListItem"](oItem)) return false;
	var oDomRef = oItem["oDomRef"];

	if (oDomRef && oDomRef["getAttribute"] &&
		(oDomRef["getAttribute"]('navigateindex') === '0' || oDomRef["getAttribute"]('navigateindex') === '1')) {
		return true;
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsNavigable"] = 0; };

/**
 * Returns true if the item is AbapListItem
 * @private
 * @param {UCF_AbapListItem} oItem
 * @return {boolean} Return true if the Item is an AbapListItem
 */
UCF_AbapListBlockSelectionManager["prototype"]["bIsAbapListItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsAbapListItem"]++; }; 
	return oItem && (
		UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListCheckBox') ||
		UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListImage') ||
		UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListText')
	);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsAbapListItem"] = 0; };

/**
 * @param {UCF_AbapListItem} oItem
 * @return {boolean} - return true if the item has empty text
 */
UCF_AbapListBlockSelectionManager["prototype"]["bIsEmptyAbapListText"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsEmptyAbapListText"]++; }; 
	if (oItem && UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListText'))
		return UCF_StringUtil["bIsEmpty"](oItem["sText"]) && !oItem["bSelectable"];
	return true;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsEmptyAbapListText"] = 0; };

/**
 * @param {UCF_AbapListItem} oItem
 * @return {boolean} - return true if the item has empty text
 */
UCF_AbapListBlockSelectionManager["prototype"]["bIsAbapListItemFocusabled"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsAbapListItemFocusabled"]++; }; 
	if (oItem && UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListText')) {
		if (!oItem["bReadOnly"] || !UCF_StringUtil["bIsEmpty"](oItem["sText"])) {
			return true;
		}
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsAbapListItemFocusabled"] = 0; };

/**
 * Check If the AbapList has focusable items
 * @return {boolean} - return the Object
 */
UCF_AbapListBlockSelectionManager["prototype"]["bHasAbapListFocusableItems"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bHasAbapListFocusableItems"]++; }; 

	return this["oAbapList"]
		&& this["oAbapList"]["oDomRef"]
		&& this["oAbapList"]["oDomRef"]["getAttribute"]
		&& UCF_DomUtil["sGetAttribute"](this["oAbapList"]["oDomRef"], 'data-focusitems') === 'true';
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bHasAbapListFocusableItems"] = 0; };

/**
 * Returns the Item position
 * @private
 * @param { UCF_AbapListItem } oItem the lstouchstart
 * @return {Object} the rectanble of the clicked element
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetItemPosition"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetItemPosition"]++; }; 

	if (oItem) {
		return {
			"TopLeftX": oItem["iGetLeft"](),
			"TopLeftY": oItem["iGetTop"](),
			"BottomRightX": oItem["iGetLeft"]() + oItem["iGetWidth"](),
			"BottomRightY": oItem["iGetTop"]() + oItem["iGetHeight"]()
		};
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetItemPosition"] = 0; };

/**
 * Reset the focus and Text Selection after the Block selection has been started
 *
 * @private
 */
UCF_AbapListBlockSelectionManager["prototype"]["resetFocusAndTextSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["resetFocusAndTextSelection"]++; }; 
	/** @type {string} */
	var sFocusClass = 'lsAbapList--bs-focus';
	/** @type {HTMLDivElement} */
	var oContent = this["oAbapList"]["oGetContentDomRef"]();
	if (!UCF_DomUtil["bHasClass"](oContent, sFocusClass)) {
		UCF_DomUtil["addClass"](oContent, sFocusClass);
	}
	this["removeCharFocus"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["resetFocusAndTextSelection"] = 0; };

/**
 * @param {UCF_AbapListItem} oItem
 * @param { boolean } bSetTabIndex - 	sets the TabIndex or remove it
 */
UCF_AbapListBlockSelectionManager["prototype"]["setTabIndexForItem"] = function(oItem, bSetTabIndex) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setTabIndexForItem"]++; }; 
	if (!oItem) return;
	var oDomRef = oItem["oDomRef"];

	if (oDomRef && oDomRef["getAttribute"] && oDomRef["getAttribute"]('navigateindex') === '0') return;

	//	if (oDomRef && oDomRef.getAttribute && oDomRef.getAttribute('navigateindex') === '1') {
	if (bSetTabIndex) {
		UCF_DomUtil["setTabIndex"](oDomRef, 0);
	} else {
		UCF_DomUtil["resetTabIndex"](oDomRef);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setTabIndexForItem"] = 0; };

/**
 * @param {int} iX
 * @param {int} iY
 * @return {AbapListItem} - return the AbapListItem
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetItemXY"] = function(iX, iY) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetItemXY"]++; }; 

	/** @type {UCF_AbapListItem} */
	var oItem = null;

	var oLine = this["oGetAllAbapListItems"]()[iY];
	if (!oLine) return null;
	for (var i = 0; i < oLine["length"]; i++) {
		oItem = oLine[i];
		if (oItem["iGetLeft"]() >= iX || iX <= (oItem["iGetLeft"]() + oItem["iGetWidth"]()))
			break;
	}

	return oItem;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetItemXY"] = 0; };

/**
 * @return {int} - returns the first line which have navigable items
 */
UCF_AbapListBlockSelectionManager["prototype"]["iGetFirstVisibleLinePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetFirstVisibleLinePosition"]++; }; 

	/** @type {int} */
	var iFirstPosition = -1;
	/** @type {Array} */
	var oLine;
	/** @type {Array} */
	var mRasterMatrix = this["oGetAllAbapListItems"]();

	for (var i = 0; i < mRasterMatrix["length"]; i++) {
		oLine = mRasterMatrix[i];
		if (oLine && oLine["length"] > 0) {
			iFirstPosition = i;
			break;
		}
	}
	return iFirstPosition;

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetFirstVisibleLinePosition"] = 0; };

/**
 * @return {UCF_AbapListItem} - returns the first line which have navigable items
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetFirstItemWithData"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetFirstItemWithData"]++; }; 

	/** @type {Array} */
	var oLine;
	/** @type {UCF_AbapListItem} */
	var oItem = null;

	oLine = this["oGetAllAbapListItems"]()[this["iGetFirstVisibleLinePosition"]()];
	if (oLine)
		oItem = oLine[0];
	return oItem;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetFirstItemWithData"] = 0; };

/**
 *
 * @return {UCF_AbapListItem} - returns the  last item with Data
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetLastItemWithData"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetLastItemWithData"]++; }; 

	/** @type {Array} */
	var oLine;
	/** @type {UCF_AbapListItem} */
	var oItem = null;

	oLine = this["oGetAllAbapListItems"]()[this["iGetLastVisibleLinePosition"]()];
	if (oLine)
		oItem = oLine[oLine["length"] - 1];
	return oItem;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetLastItemWithData"] = 0; };

/**
 *
 * @return {int} - returns the first line which have navigable items
 */
UCF_AbapListBlockSelectionManager["prototype"]["iGetLastVisibleLinePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetLastVisibleLinePosition"]++; }; 

	/** @type {int} */
	var iFirstPosition = -1;
	/** @type {Array} */
	var oLine;
	/** @type {Array} */
	var mRasterMatrix = this["oGetAllAbapListItems"]();

	for (var i = mRasterMatrix["length"] - 1; i >= 0; i--) {
		oLine = mRasterMatrix[i];
		if (oLine["length"] > 0) {
			iFirstPosition = i;
			break;
		}
	}
	return iFirstPosition;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["iGetLastVisibleLinePosition"] = 0; };

/**
 * Remove the block selection
 *
 * @private
 */
UCF_AbapListBlockSelectionManager["prototype"]["removeCharFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["removeCharFocus"]++; }; 
	this["aCharSelectionPosition"] = null;
	if (this["oGetCharSelection"]()) {
		UCF_DomUtil["addClass"](this["oGetCharSelection"](), 'lsControl--invisible');
		UCF_DomUtil["resetTabIndex"](this["oGetCharSelection"]());
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["removeCharFocus"] = 0; };

UCF_AbapListBlockSelectionManager["prototype"]["applyCharSelectionPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applyCharSelectionPosition"]++; }; 

	if (this["aCharSelectionPosition"] && this["oGetCharSelection"]()) {
		UCF_DomUtil["removeClass"](this["oGetCharSelection"](), 'lsControl--invisible');
		if (this["aCharSelectionPosition"]["Top"] < 0) {
			this["oGetCharSelection"]()["style"]["top"] = '';
			this["oGetCharSelection"]()["style"]["bottom"] = 0 + this["oAbapList"]["sRasterHeightUnit"];
		} else
			this["oGetCharSelection"]()["style"]["top"] = this["aCharSelectionPosition"]["Top"] + this["oAbapList"]["sRasterHeightUnit"];
		if (this["aCharSelectionPosition"]["Left"] < 0) {
			this["oGetCharSelection"]()["style"]["left"] = '';
			this["oGetCharSelection"]()["style"]["right"] = 0 + this["oAbapList"]["sRasterWidthUnit"];
		} else
			this["oGetCharSelection"]()["style"]["left"] = this["aCharSelectionPosition"]["Left"] + this["oAbapList"]["sRasterWidthUnit"];
		UCF_DomUtil["setTabIndex"](this["oGetCharSelection"](), 0);
		this["aCharSelectionPosition"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applyCharSelectionPosition"] = 0; };

/**
 * Set the Position of the Char without
 * @return {Array} aPosition -	Ex: { Left: 0, Top: 0 }
 *
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetCharSelectionOppositeOrigin"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetCharSelectionOppositeOrigin"]++; }; 

	/** @type {number} */
	var iCurrentLeft;
	/** @type {number} */
	var iCurrentTop;
	/** @type {Array}*/
	var aPosition;
	var oOriginBlockSelection;
	var oBlockSelection;

	oBlockSelection = this["oGetBlockSelection"]();
	var bDone = false;

	iCurrentLeft = -1;
	iCurrentTop = -1;
	oOriginBlockSelection = this["oGetOriginBlockSelection"]();
	if (oBlockSelection && oOriginBlockSelection) {

		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' Origin ====== TopLeftX ' + oOriginBlockSelection["TopLeftX"]
			+ ' TopLeftY: ' + oOriginBlockSelection["TopLeftY"]
			+ ' BottomRightX: ' + oOriginBlockSelection["BottomRightX"]
			+ ' BottomRightY: ' + oOriginBlockSelection["BottomRightY"], "AbapListBlockSelectionManager.js(593): oGetCharSelectionOppositeOrigin"); };
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' Current ===== TopLeftX ' + oBlockSelection["TopLeftX"]
			+ ' TopLeftY: ' + oBlockSelection["TopLeftY"]
			+ ' BottomRightX: ' + oBlockSelection["BottomRightX"]
			+ ' BottomRightY: ' + oBlockSelection["BottomRightY"], "AbapListBlockSelectionManager.js(597): oGetCharSelectionOppositeOrigin"); };

		// LeftTop Corner
		if (!bDone && oOriginBlockSelection["TopLeftX"] === oBlockSelection["TopLeftX"] && oOriginBlockSelection["TopLeftY"] === oBlockSelection["TopLeftY"]) {
			iCurrentTop = -1; // style.bottom: 0
			iCurrentLeft = -1; // style.right: 0
			bDone = true;
		}
		//LeftBottom Corner
		if (!bDone && oOriginBlockSelection["TopLeftX"] === oBlockSelection["TopLeftX"] && oOriginBlockSelection["BottomRightY"] === oBlockSelection["BottomRightY"]) {
			iCurrentTop = 0;
			iCurrentLeft = -1; // style.right: 0
			bDone = true;
		}

		//Top Right Corner
		if (!bDone && oOriginBlockSelection["TopLeftY"] === oBlockSelection["TopLeftY"] && oOriginBlockSelection["BottomRightX"] === oBlockSelection["BottomRightX"]) {
			iCurrentTop = -1; // style.bottom: 0
			iCurrentLeft = 0;
			bDone = true;
		}

		//BottomRight Corner
		if (!bDone && oOriginBlockSelection["BottomRightX"] === oBlockSelection["BottomRightX"] && oOriginBlockSelection["BottomRightY"] === oBlockSelection["BottomRightY"]) {
			iCurrentTop = 0;
			iCurrentLeft = 0;
			bDone = true;
		}

	}

	aPosition = { "Left": iCurrentLeft, "Top": iCurrentTop };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ========================= aPosition: Left: ' + aPosition["Left"] + ', Top: ' + aPosition["Top"], "AbapListBlockSelectionManager.js(632): oGetCharSelectionOppositeOrigin"); };

	return aPosition;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetCharSelectionOppositeOrigin"] = 0; };

/**
 * Retrieves the AbapListItem from the current Char position
 * @return {AbapListItem} the AbapListitem from the Char position
 *
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetItemFromCharSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetItemFromCharSelection"]++; }; 

	/** @type {number} */
	var iCurrentLeft;
	/** @type {number} */
	var iCurrentTop;
	/** @type {Array}*/
	var aPosition;
	/** @type {BlockSelection} */
	var oBlockSelection;

	oBlockSelection = this["oGetBlockSelection"]();
	aPosition = this["oGetCharSelectionOppositeOrigin"]();
	var bDone = false;

	iCurrentLeft = -1;
	iCurrentTop = -1;
	if (oBlockSelection && aPosition) {

		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ========================= aPosition: Left: ' + aPosition["Left"] + ', Top: ' + aPosition["Top"], "AbapListBlockSelectionManager.js(661): oGetItemFromCharSelection"); };
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' Current ===== TopLeftX ' + oBlockSelection["TopLeftX"]
			+ ' TopLeftY: ' + oBlockSelection["TopLeftY"]
			+ ' BottomRightX: ' + oBlockSelection["BottomRightX"]
			+ ' BottomRightY: ' + oBlockSelection["BottomRightY"], "AbapListBlockSelectionManager.js(662): oGetItemFromCharSelection"); };

		// Origin - Left/Top Corner - Char on Right/Bottom Corner
		if (!bDone && aPosition["Top"] === -1 && aPosition["Left"] === -1) {
			iCurrentTop = oBlockSelection["BottomRightY"] - 1;
			iCurrentLeft = oBlockSelection["BottomRightX"] - 1;
			bDone = true;
		}
		//Origin - Left/Bottom Corner - Char on Right/Top Corner
		if (!bDone && aPosition["Top"] === 0 && aPosition["Left"] === -1) {
			iCurrentLeft = oBlockSelection["BottomRightX"] - 1;
			iCurrentTop = oBlockSelection["TopLeftY"];
			bDone = true;
		}

		//Origin - Right/Top Corner - Char on Left/Bottom Corner
		if (!bDone && aPosition["Top"] === -1 && aPosition["Left"] === 0) {
			iCurrentLeft = oBlockSelection["TopLeftX"];
			iCurrentTop = oBlockSelection["BottomRightY"] - 1;
			bDone = true;
		}

		//Origin - Right/Bottom Corner - Char on Left/Top Corner
		if (!bDone && aPosition["Top"] === 0 && aPosition["Left"] === 0) {
			iCurrentLeft = oBlockSelection["TopLeftX"];
			iCurrentTop = oBlockSelection["TopLeftY"];
			bDone = true;
		}

		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ========================= Current Item position : Left: ' + iCurrentLeft + ', Top: ' + iCurrentTop, "AbapListBlockSelectionManager.js(694): oGetItemFromCharSelection"); };
	}

	return this["oGetItemXY"](iCurrentLeft, iCurrentTop);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetItemFromCharSelection"] = 0; };

/**
 * Applies or removes the focus styles
 * @param {AbapListItem} oItem
 * @param {boolean} bRemoveStyle
 */
UCF_AbapListBlockSelectionManager["prototype"]["applyFocusedItemStyle"] = function(oItem, bRemoveStyle) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applyFocusedItemStyle"]++; }; 
	if (!oItem) return;
	var oDomRef = oItem["oDomRef"];
	if (!oDomRef) return;

	if (bRemoveStyle) {
		UCF_DomUtil["removeClass"](oDomRef, 'lsAbapList--lastfocused');
	} else {
		UCF_DomUtil["addClass"](oDomRef, 'lsAbapList--lastfocused');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applyFocusedItemStyle"] = 0; };

/**
 * Reset the focus visualization for the last item
 * @param {UCF_AbapListItem} oItem
 */
UCF_AbapListBlockSelectionManager["prototype"]["resetfocusItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["resetfocusItem"]++; }; 

	this["applyFocusedItemStyle"](oItem, true);
	this["setTabIndexForItem"](oItem, false);
	oItem = null;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["resetfocusItem"] = 0; };

/**
 * Set the BlockSelection
 * @param {BlockSelection} oBlockSelection
 */
UCF_AbapListBlockSelectionManager["prototype"]["setBlockSelection"] = function(oBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setBlockSelection"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' This ' + this["sManagerId"] + ' ====================== iBottomRightY ' + oBlockSelection["BottomRightY"] + ' -- iTopLeftY ' + oBlockSelection["TopLeftY"], "AbapListBlockSelectionManager.js(733): setBlockSelection"); };
	this["oBlockSelection"] = oBlockSelection;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' This ' + this["sManagerId"] + ' ====== TopLeftX ' + this["oBlockSelection"]["TopLeftX"]
		+ ' TopLeftY: ' + this["oBlockSelection"]["TopLeftY"]
		+ ' BottomRightX: ' + this["oBlockSelection"]["BottomRightX"]
		+ ' BottomRightY: ' + this["oBlockSelection"]["BottomRightY"], "AbapListBlockSelectionManager.js(735): setBlockSelection"); };
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setBlockSelection"] = 0; };

/**
 * Get current BlockSelection
 * @return {BlockSelection} oBlockSelection
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetBlockSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetBlockSelection"]++; }; 
	if (this["oBlockSelection"])
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' This ' + this["sManagerId"] + ' ====== TopLeftX ' + this["oBlockSelection"]["TopLeftX"]
			+ ' TopLeftY: ' + this["oBlockSelection"]["TopLeftY"]
			+ ' BottomRightX: ' + this["oBlockSelection"]["BottomRightX"]
			+ ' BottomRightY: ' + this["oBlockSelection"]["BottomRightY"], "AbapListBlockSelectionManager.js(747): oGetBlockSelection"); };
	return this["oBlockSelection"];
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetBlockSelection"] = 0; };

/**
 * Get current BlockSelectionFrame
 * @return {HTMElement} BlockSelectionFrame
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetBlockSelectionFrame"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetBlockSelectionFrame"]++; }; 
	return this["oBlockSelectionFrame"];
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetBlockSelectionFrame"] = 0; };

/**
 * returns the current origin block selection BlockSelection
 * @return {BlockSelection} oBlockSelection
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetOriginBlockSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetOriginBlockSelection"]++; }; 
	if (!this["oOriginBlockSelection"]) return { "TopLeftX": 0, "TopLeftY": 0, "BottomRightX": 0, "BottomRightY": 0 };
	return this["oOriginBlockSelection"];
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetOriginBlockSelection"] = 0; };

/**
 * set the current origin block selection BlockSelection
 * @param { BlockSelection } oBlockSelection
 */
UCF_AbapListBlockSelectionManager["prototype"]["setOriginBlockSelection"] = function(oBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setOriginBlockSelection"]++; }; 
	this["oOriginBlockSelection"] = oBlockSelection;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setOriginBlockSelection"] = 0; };

/**
 * Set the origin item
 * set data-bs-origin Attribute
 * @param {AbapLisItem} oItem
 *
 */
UCF_AbapListBlockSelectionManager["prototype"]["setOriginItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setOriginItem"]++; }; 
	if (this["oOriginItem"])
		this["oOriginItem"]["oDomRef"]["removeAttribute"]('data-bs-origin');
	if (oItem) {
		this["oOriginItem"] = oItem;
		this["oOriginItem"]["oDomRef"]["setAttribute"]('data-bs-origin', 'true');
		this["oOriginBlockSelection"] = {
			"TopLeftX": this["oOriginItem"]["iGetLeft"](),
			"TopLeftY": this["oOriginItem"]["iGetTop"](),
			"BottomRightX": this["oOriginItem"]["iGetLeft"]() + this["oOriginItem"]["iGetWidth"](),
			"BottomRightY": this["oOriginItem"]["iGetTop"]() + this["oOriginItem"]["iGetHeight"]()
		};
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setOriginItem"] = 0; };

/**
 * Gets the origin item
 * set data-bs-origin Attribute
 * @return {AbapLisItem} oItem
 *
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetOriginItem"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetOriginItem"]++; }; 
	return this["oOriginItem"];
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetOriginItem"] = 0; };
/**
 * Sets the block selection
 *
 * @private
 * @param {UCF_BlockSelection} oBlockSelection
 */
UCF_AbapListBlockSelectionManager["prototype"]["setBlockSelectionInternal"] = function(oBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setBlockSelectionInternal"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBlockSelection != null, "oBlockSelection != null", "AbapListBlockSelectionManager.js(817): setBlockSelectionInternal"); };

	if (UCF_JsUtil["keys"](oBlockSelection)["length"] > 0) {
		this["setBlockSelection"]({
			"TopLeftX": oBlockSelection["TopLeftX"],
			"TopLeftY": oBlockSelection["TopLeftY"],
			"BottomRightX": oBlockSelection["BottomRightX"],
			"BottomRightY": oBlockSelection["BottomRightY"]
		});
		this["applyBlockSelection"](false);
		this["oSetAssoCurrentBlockSelection"]();
	} else {
		this["setBlockSelection"](oBlockSelection);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setBlockSelectionInternal"] = 0; };

/**
 * @private
 * @param {boolean} bEnabled
 */
UCF_AbapListBlockSelectionManager["prototype"]["setCopyToClipboardEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setCopyToClipboardEnabled"]++; }; 
	this["oAbapList"]["setCopyToClipboardEnabled"](bEnabled);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setCopyToClipboardEnabled"] = 0; };

/**
 * Should not render a dot
 *
 * @private
 * @return {boolean}
 */
UCF_AbapListBlockSelectionManager["prototype"]["bBlockSelectionValid"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bBlockSelectionValid"]++; }; 
	return this["oBlockSelection"] != null
		&& this["oBlockSelection"]["TopLeftX"] !== this["oBlockSelection"]["BottomRightX"]
		&& this["oBlockSelection"]["TopLeftY"] !== this["oBlockSelection"]["BottomRightY"]
		&& this["oBlockSelection"]["BottomRightX"] !== -1;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bBlockSelectionValid"] = 0; };

/**
 * Applies the block selection
 * @param {boolean} bInTouch
 * @private
 */
UCF_AbapListBlockSelectionManager["prototype"]["applyBlockSelection"] = function(bInTouch) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applyBlockSelection"]++; }; 

	if (!this["bBlockSelectionValid"]()) return;
	/** @type {HTMLDivElement} */
	var oContentDiv = this["oAbapList"]["oGetContentDomRef"]();
	/** @type {HTMLDivElement} */
	var oResizeHandleTopLeft;
	/** @type {HTMLDivElement} */
	var oResizeHandleBottomRight;
	/** @type {HTMLDivElement} */
	var oResizeHandleTopRight;
	/** @type {HTMLDivElement} */
	var oResizeHandleBottomLeft;
	/** @type {HTMLDivElement} */
	var oCharFocus;

	this["setCopyToClipboardEnabled"](true);
	if (this["oBlockSelectionFrame"] == null) {
		this["oBlockSelectionFrame"] = document["createElement"]('DIV');
		this["oBlockSelectionFrame"]["setAttribute"]('id', this["oAbapList"]["sId"] + '-bsFrame');
		UCF_DomUtil["addClass"](this["oBlockSelectionFrame"], this["eStyles"]["BLOCKSELECTION_FRAME"]);

		oResizeHandleTopLeft = document["createElement"]('DIV');
		this["oBlockSelectionFrame"]["appendChild"](oResizeHandleTopLeft);
		oResizeHandleTopLeft["setAttribute"]('id', this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_TOP_LEFT"]);

		oResizeHandleBottomRight = document["createElement"]('DIV');
		this["oBlockSelectionFrame"]["appendChild"](oResizeHandleBottomRight);
		oResizeHandleBottomRight["setAttribute"]('id', this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_BOTTOM_RIGHT"]);

		if (!bInTouch) {
			oResizeHandleTopRight = document["createElement"]('DIV');
			this["oBlockSelectionFrame"]["appendChild"](oResizeHandleTopRight);
			oResizeHandleTopRight["setAttribute"]('id', this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_TOP_RIGHT"]);
			UCF_DomUtil["addClass"](oResizeHandleTopRight, this["eStyles"]["BLOCKSELECTION_MOUSE_TOP_RIGHT"]);

			oResizeHandleBottomLeft = document["createElement"]('DIV');
			this["oBlockSelectionFrame"]["appendChild"](oResizeHandleBottomLeft);
			oResizeHandleBottomLeft["setAttribute"]('id', this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_BOTTOM_LEFT"]);
			UCF_DomUtil["addClass"](oResizeHandleBottomLeft, this["eStyles"]["BLOCKSELECTION_MOUSE_BOTTOM_LEFT"]);

			oCharFocus = document["createElement"]('DIV');
			oCharFocus["setAttribute"]('id', this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_CHAR"]);
			UCF_DomUtil["addClass"](oCharFocus, this["eStyles"]["BLOCKSELECTION_CHAR"]);
			UCF_DomUtil["addClass"](oCharFocus, 'lsControl--invisible');
			this["oBlockSelectionFrame"]["appendChild"](oCharFocus);
			oCharFocus["style"]["width"] = this["oAbapList"]["fRasterWidth"] + this["oAbapList"]["sRasterWidthUnit"];
			oCharFocus["style"]["height"] = this["oAbapList"]["fRasterHeight"] + this["oAbapList"]["sRasterHeightUnit"];
		}

		// add selection class for TopLeft and BottomRight
		this["applySelectionHandlersCss"](bInTouch);

		oContentDiv["appendChild"](this["oBlockSelectionFrame"]);
		UCF_DomUtil["addClass"](oContentDiv, this["eStyles"]["BLOCKSELECTION_CONTENT"]);
	}

	this["oBlockSelectionFrame"]["style"]["top"] = Math["max"](this["oBlockSelection"]["TopLeftY"] * this["oAbapList"]["fRasterHeight"] - this["iBorderSelection"], this["iGetFirstRow"]()) + this["oAbapList"]["sRasterHeightUnit"];
	this["oBlockSelectionFrame"]["style"]["left"] = Math["max"](this["oBlockSelection"]["TopLeftX"] * this["oAbapList"]["fRasterWidth"] - this["iBorderSelection"], this["iGetFirstColumn"]()) + this["oAbapList"]["sRasterWidthUnit"];
	// eslint-disable-next-line no-magic-numbers
	this["oBlockSelectionFrame"]["style"]["width"] = Math["min"]((((this["oBlockSelection"]["BottomRightX"] - this["oBlockSelection"]["TopLeftX"]) * this["oAbapList"]["fRasterWidth"])) + 2 * this["iBorderSelection"], this["iGetLastColumn"]() * this["oAbapList"]["fRasterWidth"]) + this["oAbapList"]["sRasterWidthUnit"];
	// eslint-disable-next-line no-magic-numbers
	this["oBlockSelectionFrame"]["style"]["height"] = Math["min"]((((this["oBlockSelection"]["BottomRightY"] - this["oBlockSelection"]["TopLeftY"]) * this["oAbapList"]["fRasterHeight"])) + 2 * this["iBorderSelection"], this["iGetLastRow"]() * this["oAbapList"]["fRasterHeight"]) + this["oAbapList"]["sRasterHeightUnit"];
	//this.applyCharSelectionPosition();

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applyBlockSelection"] = 0; };

/**
 * @return {HTMLDivElement} the TopLeft Corner
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetFocusFrame"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetFocusFrame"]++; }; 
	return UCF_DomUtil["$"](this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_FOCUS"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetFocusFrame"] = 0; };

/**
 * Applies or removes the focus styles for the whole AbapList
 * @param { boolean } bIsVisble
 */
UCF_AbapListBlockSelectionManager["prototype"]["applyFocusedAbapListStyle"] = function(bIsVisble) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applyFocusedAbapListStyle"]++; }; 

	if (bIsVisble) {
		UCF_DomUtil["addClass"](this["oAbapList"]["oDomRef"], 'lsAbapList--bsFocus-visible');
	} else {
		UCF_DomUtil["removeClass"](this["oAbapList"]["oDomRef"], 'lsAbapList--bsFocus-visible');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applyFocusedAbapListStyle"] = 0; };

/**
 *	Applies the focus frame for the whole AbapList
 */
UCF_AbapListBlockSelectionManager["prototype"]["applyFocusFrame"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applyFocusFrame"]++; }; 
	/** {HTMLElement} */
	var oAbapListFocus;

	if (this["iGetLastColumn"]() === -1) {
		//The AbapList has no item
		UCF_DomUtil["addClass"](this["oAbapList"]["oDomRef"], 'lsAbapList--empty');
	}

	oAbapListFocus = document["createElement"]('DIV');
	oAbapListFocus["setAttribute"]('id', this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_FOCUS"]);
	UCF_DomUtil["addClass"](oAbapListFocus, this["eStyles"]["BLOCKSELECTION_FOCUS"]);
	this["oAbapList"]["oGetContentDomRef"]()["appendChild"](oAbapListFocus);

	oAbapListFocus["style"]["top"] = this["iGetFirstRow"]() * this["oAbapList"]["fRasterHeight"] + 'px';
	oAbapListFocus["style"]["left"] = this["iGetFirstColumn"]() * this["oAbapList"]["fRasterWidth"] + 'px';
	// eslint-disable-next-line no-magic-numbers
	oAbapListFocus["style"]["width"] = this["iGetLastColumn"]() * this["oAbapList"]["fRasterWidth"] + 'px';
	// eslint-disable-next-line no-magic-numbers
	oAbapListFocus["style"]["height"] = this["iGetLastRow"]() * this["oAbapList"]["fRasterHeight"] + 'px';
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applyFocusFrame"] = 0; };

/**
 * @return {HTMLDivElement} the TopLeft Corner
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetResizeHandleTopLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetResizeHandleTopLeft"]++; }; 
	return UCF_DomUtil["$"](this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_TOP_LEFT"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetResizeHandleTopLeft"] = 0; };
/**
 * @return {HTMLDivElement} the BottomLeft Corner
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetResizeHandleBottomLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetResizeHandleBottomLeft"]++; }; 
	return UCF_DomUtil["$"](this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_BOTTOM_LEFT"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetResizeHandleBottomLeft"] = 0; };
/**
 * @return {HTMLDivElement} the BottomRight Corner
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetResizeHandleBottomRight"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetResizeHandleBottomRight"]++; }; 
	return UCF_DomUtil["$"](this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_BOTTOM_RIGHT"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetResizeHandleBottomRight"] = 0; };
/**
 * @return {HTMLDivElement} the TopRight Corner
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetResizeHandleTopRight"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetResizeHandleTopRight"]++; }; 
	return UCF_DomUtil["$"](this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_TOP_RIGHT"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetResizeHandleTopRight"] = 0; };

/**
 * @return {HTMLDivElement} the TopRight Corner
 */
UCF_AbapListBlockSelectionManager["prototype"]["oGetCharSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetCharSelection"]++; }; 
	return UCF_DomUtil["$"](this["oAbapList"]["sId"] + this["eIdsSuffix"]["BLOCKSELECTION_CHAR"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oGetCharSelection"] = 0; };

/**
 * Set the Position of the Char without
 * @param {Array} aPosition -	Ex: { Left: 0, Top: 0 }
 *
 */
UCF_AbapListBlockSelectionManager["prototype"]["setCharSelectionPosition"] = function(aPosition) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setCharSelectionPosition"]++; }; 
	this["aCharSelectionPosition"] = { "Left": 0, "Top": 0 };
	if (!aPosition) return;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ========================= aPosition: Left: ' + aPosition["Left"] + ', Top: ' + aPosition["Top"], "AbapListBlockSelectionManager.js(1011): setCharSelectionPosition"); };
	this["aCharSelectionPosition"]["Top"] = aPosition["Top"] * this["oAbapList"]["fRasterHeight"];
	this["aCharSelectionPosition"]["Left"] = aPosition["Left"] * this["oAbapList"]["fRasterWidth"];
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setCharSelectionPosition"] = 0; };

/**
 * Show and Focus the Char selection
 *
 */
UCF_AbapListBlockSelectionManager["prototype"]["emphasizeCharSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["emphasizeCharSelection"]++; }; 
	this["setCharSelectionPosition"](this["oGetCharSelectionOppositeOrigin"]());
	this["applyCharSelectionPosition"]();
	this["setFocusedOnCharSelection"]();
	this["setNewFocusedItem"](this["oGetItemFromCharSelection"](), false, false);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["emphasizeCharSelection"] = 0; };

/**
 * Applies the css class for block selection handlers
 *
 * @private
 * @param {boolean} bIsTouch
 */
UCF_AbapListBlockSelectionManager["prototype"]["applySelectionHandlersCss"] = function(bIsTouch) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applySelectionHandlersCss"]++; }; 
	// only when the top-lef and bottom-right handles exists
	if (this["oGetResizeHandleTopLeft"]() && this["oGetResizeHandleBottomRight"]()) {
		if (bIsTouch) {
			if (!UCF_DomUtil["bHasClass"](
					this["oGetResizeHandleTopLeft"](),
					this["eStyles"]["BLOCKSELECTION_TOUCH_TOP_LEFT"]
				)) {
				UCF_DomUtil["removeClass"](
					this["oGetResizeHandleTopLeft"](),
					this["eStyles"]["BLOCKSELECTION_MOUSE_TOP_LEFT"]
				);
				UCF_DomUtil["addClass"](
					this["oGetResizeHandleTopLeft"](),
					this["eStyles"]["BLOCKSELECTION_TOUCH_TOP_LEFT"]
				);
			}
			if (!UCF_DomUtil["bHasClass"](
					this["oGetResizeHandleBottomRight"](),
					this["eStyles"]["BLOCKSELECTION_TOUCH_BOTTOM_RIGHT"]
				)) {
				UCF_DomUtil["removeClass"](
					this["oGetResizeHandleBottomRight"](),
					this["eStyles"]["BLOCKSELECTION_MOUSE_BOTTOM_RIGHT"]
				);
				UCF_DomUtil["addClass"](
					this["oGetResizeHandleBottomRight"](),
					this["eStyles"]["BLOCKSELECTION_TOUCH_BOTTOM_RIGHT"]
				);
			}
		} else {
			if (!UCF_DomUtil["bHasClass"](
					this["oGetResizeHandleTopLeft"](),
					this["eStyles"]["BLOCKSELECTION_MOUSE_TOP_LEFT"]
				)) {
				UCF_DomUtil["removeClass"](
					this["oGetResizeHandleTopLeft"](),
					this["eStyles"]["BLOCKSELECTION_TOUCH_TOP_LEFT"]
				);
				UCF_DomUtil["addClass"](
					this["oGetResizeHandleTopLeft"](),
					this["eStyles"]["BLOCKSELECTION_MOUSE_TOP_LEFT"]
				);
			}
			if (!UCF_DomUtil["bHasClass"](
					this["oGetResizeHandleBottomRight"](),
					this["eStyles"]["BLOCKSELECTION_MOUSE_BOTTOM_RIGHT"]
				)) {
				UCF_DomUtil["removeClass"](
					this["oGetResizeHandleBottomRight"](),
					this["eStyles"]["BLOCKSELECTION_TOUCH_BOTTOM_RIGHT"]
				);
				UCF_DomUtil["addClass"](
					this["oGetResizeHandleBottomRight"](),
					this["eStyles"]["BLOCKSELECTION_MOUSE_BOTTOM_RIGHT"]
				);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["applySelectionHandlersCss"] = 0; };

/**
 * Set the new focused Item
 * @param {AbapListItem} oItem
 * @param { boolean } bSetFocus - set focus on the AbapListItem
 * @param { boolean } bSetBlockSelection
 */
UCF_AbapListBlockSelectionManager["prototype"]["setNewFocusedItem"] = function(oItem, bSetFocus, bSetBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setNewFocusedItem"]++; }; 
	if (!oItem) return;
	this["applyFocusedItemStyle"](this["oAbapList"]["oGetLastFocusedItem"](), true);
	this["setTabIndexForItem"](this["oAbapList"]["oGetLastFocusedItem"](), false);
	this["oAbapList"]["setLastFocusedItem"](oItem);
	this["applyFocusedItemStyle"](this["oAbapList"]["oGetLastFocusedItem"](), false);
	if (bSetFocus) {
		if (!bSetBlockSelection)
			this["setAvoidItemSelectionByFocus"](this["oAbapList"]["oGetLastFocusedItem"]());
		this["setTabIndexForItem"](this["oAbapList"]["oGetLastFocusedItem"](), true);
		UCF_DomUtil["moveFocusDomElement"](this["oAbapList"]["oGetLastFocusedItem"]()["oDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setNewFocusedItem"] = 0; };

/**
 * Set the focus on the char selection
 */
UCF_AbapListBlockSelectionManager["prototype"]["setFocusedOnCharSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setFocusedOnCharSelection"]++; }; 
	if (this["oAbapList"]["oGetLastFocusedItem"]()) {
		//	this.applyFocusedItemStyle(this.oAbapList.oGetLastFocusedItem(), true);
		this["setTabIndexForItem"](this["oAbapList"]["oGetLastFocusedItem"](), false);
	}
	if (this["oGetCharSelection"]())
		UCF_DomUtil["moveFocusDomElement"](this["oGetCharSelection"]());

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setFocusedOnCharSelection"] = 0; };

/**
 * set data-avoid-blockselection Attribute
 * @param {AbapLisItem} oItem
 *
 */
UCF_AbapListBlockSelectionManager["prototype"]["setAvoidItemSelectionByFocus"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setAvoidItemSelectionByFocus"]++; }; 
	/** @type {Element} */
	var oDomRef;

	if (oItem) {
		oDomRef = oItem["oDomRef"];
		oDomRef["setAttribute"]('data-avoid-blockselection', 'true');
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["setAvoidItemSelectionByFocus"] = 0; };

/**
 * Check if the given BlockSelection is the same with the current BlockSelection
 *
 * @private
 * @param {UCF_AbapListBlockSelectionDelegate_BlockSelection} oCurrentBlockSelection
 * @return {boolean} - true if the same BlockSelection
 */
UCF_AbapListBlockSelectionManager["prototype"]["bIsSameBlockSelection"] = function(oCurrentBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsSameBlockSelection"]++; }; 

	return (this["oBlockSelection"] != null && oCurrentBlockSelection != null
		&& this["oBlockSelection"]["TopLeftX"] === oCurrentBlockSelection["TopLeftX"]
		&& this["oBlockSelection"]["BottomRightX"] === oCurrentBlockSelection["BottomRightX"]
		&& this["oBlockSelection"]["TopLeftY"] === oCurrentBlockSelection["TopLeftY"]
		&& this["oBlockSelection"]["BottomRightY"] === oCurrentBlockSelection["BottomRightY"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsSameBlockSelection"] = 0; };

/**
 * Renders an HTMLElement for the last BlockSelection AbapList
 */
UCF_AbapListBlockSelectionManager["prototype"]["oSetAssoCurrentBlockSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oSetAssoCurrentBlockSelection"]++; }; 
	var oAssoDomRef = UCF_DomUtil["$"]('AbapListBlockSelectionDelegate');
	if (oAssoDomRef) {
		var sCurrentBlockselection = oAssoDomRef["getAttribute"]("data-selection");
		if (sCurrentBlockselection !== this["oAbapList"]["sId"]) {
			var oldAbapList = this["oLS"]["oControlFactory"]["oGetControlById"](sCurrentBlockselection);
			if (oldAbapList) {
				oldAbapList["removeBlockSelection"]();
			}
			oAssoDomRef["setAttribute"]("data-selection", this["oAbapList"]["sId"]);
		}
	} else {
		var oDiv = document["createElement"]("DIV");
		oDiv["setAttribute"]("data-selection", this["oAbapList"]["sId"]);
		oDiv["setAttribute"]("id", 'AbapListBlockSelectionDelegate');
		UCF_DomUtil["addClass"](oDiv, "lsAbapList-asso");
		this["oLS"]["oGetAssociatedAreaRef"]()["appendChild"](oDiv);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["oSetAssoCurrentBlockSelection"] = 0; };

/**
 * @private
 * @param {Object} oBlockSelection
 */
UCF_AbapListBlockSelectionManager["prototype"]["fireBlockSelectInternal"] = function(oBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["fireBlockSelectInternal"]++; }; 
	this["oAbapList"]["fireBlockSelect"](this["oAbapList"]["sId"], UCF_JsUtil["sJsonStringify"](oBlockSelection));
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["fireBlockSelectInternal"] = 0; };

/**
 * Check if the BlockSelection has only an Item
 * @param {UCF_AbapListBlockSelectionDelegate_BlockSelection} oBlockSelection
 * @return {boolean} - return the Object
 */
UCF_AbapListBlockSelectionManager["prototype"]["bHasBlockSelectionOnlyAnItem"] = function(oBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bHasBlockSelectionOnlyAnItem"]++; }; 
	var oCurrentBlockSelection = oBlockSelection || this["oGetBlockSelection"]();
	if (this["bIsBlockSelectionEmpty"](oCurrentBlockSelection)) return false;
	var oItem = this["oManager"]["oGetItemXY"](oCurrentBlockSelection["TopLeftX"], oCurrentBlockSelection["TopLeftY"]);
	if (!UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListItem')) return false;

	if (oItem["iGetLeft"]() + oItem["iGetWidth"]() !== oCurrentBlockSelection["BottomRightX"]) return false;
	if (oItem["iGetTop"]() + oItem["iGetHeight"]() !== oCurrentBlockSelection["BottomRightY"]) return false;

	return true;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bHasBlockSelectionOnlyAnItem"] = 0; };

/**
 * Check if the current BlockSelection is empty
 * @param { UCF_AbapListBlockSelectionDelegate_BlockSelection } oBlockSelection
 * @private
 * @return {boolean}
 */
UCF_AbapListBlockSelectionManager["prototype"]["bIsBlockSelectionEmpty"] = function(oBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsBlockSelectionEmpty"]++; }; 
	var oCurrentBlockSelection = oBlockSelection || this["oGetBlockSelection"]();

	return !oCurrentBlockSelection || (oCurrentBlockSelection != null
		&& oCurrentBlockSelection["TopLeftX"] === 0 && oCurrentBlockSelection["BottomRightX"] === 0
		&& oCurrentBlockSelection["TopLeftY"] === 0 && oCurrentBlockSelection["BottomRightY"] === 0);
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsBlockSelectionEmpty"] = 0; };

/**
 * Check if the this AbapListItem is on the BlockSelection
 *
 * @param {AbapListItem} oItem
 * @param { UCF_AbapListBlockSelectionDelegate_BlockSelection } oBlockSelection
 * @private
 * @return {boolean}
 */
UCF_AbapListBlockSelectionManager["prototype"]["bIsItemInBlockSelection"] = function(oItem, oBlockSelection) {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsItemInBlockSelection"]++; }; 
	var oCurrentBlockSelection = oBlockSelection || this["oBlockSelection"];
	if (!oItem) return false;
	if (!UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListItem')) return false;
	if (this["bIsBlockSelectionEmpty"](oCurrentBlockSelection)) return false;
	if (oItem["iGetLeft"]() < oCurrentBlockSelection["TopLeftX"]) return false;
	if (oItem["iGetTop"]() < oCurrentBlockSelection["TopLeftY"]) return false;

	if (oItem["iGetLeft"]() + oItem["iGetWidth"]() > oCurrentBlockSelection["BottomRightX"]) return false;
	if (oItem["iGetTop"]() + oItem["iGetHeight"]() > oCurrentBlockSelection["BottomRightY"]) return false;

	return true;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsItemInBlockSelection"] = 0; };

/**
 *  add to the helper
 *  If there is any text selection, it should be from AbapList outside
 *  true - if it's a text selection from AbapList outside
 *  false - if it's no text selection or the text selection is inside of the AbapList input
 *
 *  @return {boolean}
 */
UCF_AbapListBlockSelectionManager["prototype"]["bIsActiveSelectionOutside"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsActiveSelectionOutside"]++; }; 
	var oDomRef, oCTDomRef,
		bOutsideElement = false,
		oItem;
	if (UCF_DomUtil["sGetCurrentSelectionText"]() !== '') {
		bOutsideElement = true;
		oDomRef = UCF_DomUtil["oGetSelectionNode"]() || UCF_DomUtil["oGetActiveElement"]();
		oCTDomRef = (oDomRef && oDomRef["id"]) ? UCF_DomUtil["oGetCTElement"](oDomRef) : null;
		if (oCTDomRef) {
			oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oCTDomRef, true);
			if (oItem && UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListText')) {
				bOutsideElement = false;
			}
		}
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ====================== Selection Outside: ' + bOutsideElement, "AbapListBlockSelectionManager.js(1266): bIsActiveSelectionOutside"); };
	return bOutsideElement;
};;if (__UCF_COVERAGE__) { UCF_AbapListBlockSelectionManager["_"]["bIsActiveSelectionOutside"] = 0; };

};
sap["ls"]["preload"]["UCF_AbapListCheckBox"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_AccessibilityHelper */
/// <reference path="../helper/AccessibilityHelper.js"/>
/* global UCF_AbapListItem */
/// <reference path="./AbapListItem.js"/>

/** @class
 * Use the AbapListCheckBox control to create a checkbox in the AbapList control.
 *
 * <br>
 * <b>Java Control references</b><br>
 * <a href='../javadoc/com/sap/tc/ls/api/controls/LSAbapListCheckBox.html'>LSAbapListCheckBox</a>
 *
 * 
 *
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_AbapListCheckBox(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["UCF_AbapListCheckBox"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "AbapListCheckBox.js(30): UCF_AbapListCheckBox"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "AbapListCheckBox.js(31): UCF_AbapListCheckBox"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "AbapListCheckBox.js(32): UCF_AbapListCheckBox"); };

	UCF_AbapListItem["apply"](this, [oDomRef, oLS]);
};window["UCF_AbapListCheckBox"] = UCF_AbapListCheckBox; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListCheckBox"); UCF_AbapListCheckBox["_"] = {UCF_AbapListCheckBox: 0}; }; ;

UCF_AbapListCheckBox["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_AbapListItem"))(); UCF_AbapListCheckBox.prototype["sClassName"] = "UCF_AbapListCheckBox";

/**
 * @see UCF_AbapListItem
 */

UCF_AbapListCheckBox["prototype"]["bIsValidAccess"] = function(iKeyCode) {;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["bIsValidAccess"]++; }; 

	return !this["bReadOnly"]
		&& (!iKeyCode || iKeyCode && iKeyCode === UCF_KeyCodes["SPACE"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["bIsValidAccess"] = 0; };

/**
 * @see UCF_AbapListItem
 */

UCF_AbapListCheckBox["prototype"]["bHandleAccess"] = function(iKeyCode, oSelectPosition) {;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["bHandleAccess"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iKeyCode) === 'number', "typeof(iKeyCode) === 'number'", "AbapListCheckBox.js(54): bHandleAccess"); };

	if (this["bIsValidAccess"](iKeyCode)) {
		this["toggle"]();

		return true;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["bHandleAccess"] = 0; };

UCF_AbapListCheckBox["prototype"]["toggle"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["toggle"]++; }; 

	// TODO: replace by UCF_DomUtil.firstChild(this.oDomRef)
	// to avoid problems with text node
	var oImageRef = this["oDomRef"]["firstChild"];

	// eslint-disable-next-line @ur/no-memory-leaks
	this["bChecked"] = !this["bChecked"];
	this["setClientProperty"]("Checked", this["bChecked"], true);

	oImageRef["className"] = this["bChecked"] ? oImageRef["className"]["replace"]('Off', 'On') : oImageRef["className"]["replace"]('On', 'Off');

	var sClassName = 'lsCBImgSel';
	var oImgDot = UCF_DomUtil["$"](this["sId"] + '-imgSymb');

	if (oImgDot) {
		if (this["bChecked"]) {
			if (!UCF_DomUtil["bHasClass"](oImgDot, sClassName))
				UCF_DomUtil["addClass"](oImgDot, sClassName);
		} else {
			UCF_DomUtil["removeClass"](oImgDot, sClassName);
		}
	}
	this["oGetList"]()["handleItemChange"](this, this["bChecked"] ? 'true' : 'false');
	this["refocus"](this["oFocusDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["toggle"] = 0; };

UCF_AbapListCheckBox["prototype"]["applyAcc"] = function(oAccessibilityHelper) {;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["applyAcc"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessibilityHelper instanceof UCF_AccessibilityHelper, "oAccessibilityHelper instanceof UCF_AccessibilityHelper", "AbapListCheckBox.js(93): applyAcc"); };

	UCF_AbapListItem.prototype["applyAcc"]["call"](this, oAccessibilityHelper);

	oAccessibilityHelper["setControlType"]('C');
	oAccessibilityHelper["setSelected"](this["bChecked"]);
	oAccessibilityHelper["setNotSelected"](!this["bChecked"]);

	if (this["bReadOnly"]) {
		oAccessibilityHelper["setReadonly"](true);
	} else {
		// eslint-disable-next-line no-lonely-if
		if (this["bChecked"]) {
			oAccessibilityHelper["addEnabledTutor"]('DESELECT_TUT', true);
		} else {
			oAccessibilityHelper["addEnabledTutor"]('SELECT_TUT', true);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["applyAcc"] = 0; };

/**
 * Destructor
 */
UCF_AbapListCheckBox["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["destroy"]++; }; 

	UCF_AbapListItem.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_AbapListCheckBox["prototype"]["aAttributeNames"] = ["sAccessibilityDescription","bChecked","bReadOnly","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_AbapListCheckBox["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_AbapListCheckBox["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_AbapListCheckBox["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_AbapListCheckBox["prototype"]["bChecked"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_AbapListCheckBox["prototype"]["bReadOnly"] = false;

/**
 * @private
 * @type {string}
 */
UCF_AbapListCheckBox["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_AbapListCheckBox["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_AbapListCheckBox["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["setDefaultValues"]++; }; 
	this["sAccessibilityDescription"] = '';
	this["bChecked"] = false;
	this["bReadOnly"] = false;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Checked", false, true);
		this["setClientProperty"]("ReadOnly", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListCheckBox["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_AbapListContainer"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_AbapListItem */
/// <reference path="./AbapListItem.js"/>

/** @class
 * Use the AbapListContainer control to create a container in the AbapList
 * control.
 * It mainly provides the possibility to group the AbapListItems for keyboard
 * access tabbing issues.
 * The user can skip the group by the standard LS skipping mechanism
 *
 * <br>
 * <b>Java Control references</b><br>
 * <a href='../javadoc/com/sap/tc/ls/api/controls/LSAbapListContainer.html'>LSAbapListContainer</a>
 *
 * 
 *
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_AbapListContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_AbapListContainer["_"]["UCF_AbapListContainer"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "AbapListContainer.js(30): UCF_AbapListContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "AbapListContainer.js(31): UCF_AbapListContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "AbapListContainer.js(32): UCF_AbapListContainer"); };

	UCF_AbapListItem["apply"](this, [oDomRef, oLS]);

};window["UCF_AbapListContainer"] = UCF_AbapListContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListContainer"); UCF_AbapListContainer["_"] = {UCF_AbapListContainer: 0}; }; ;
UCF_AbapListContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_AbapListItem"))(); UCF_AbapListContainer.prototype["sClassName"] = "UCF_AbapListContainer";

/**
 * @see UCF_Control
 */

UCF_AbapListContainer["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListContainer["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListContainer.js(44): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_AbapListContainer["_"]["onlsskipforward"] = 0; };

/**
 * @see UCF_Control
 */

UCF_AbapListContainer["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListContainer["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListContainer.js(53): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_AbapListContainer["_"]["onlsskipback"] = 0; };

/**
 * @override
 * @param {UCF_BrowserEvent} oClick
 */
UCF_AbapListContainer["prototype"]["onclick"] = function(oClick) {;if (__UCF_COVERAGE__) { UCF_AbapListContainer["_"]["onclick"]++; }; 
	if (this["bHandleAccess"](
			this["iGetKeyCode"](oClick),
			this["oExtractClickPosition"](oClick)
		)) {
		oClick["cancelBubble"]();
	}

	// no block selection triggered for UCF_AbapListContainer
};;if (__UCF_COVERAGE__) { UCF_AbapListContainer["_"]["onclick"] = 0; };

/** @override */
UCF_AbapListContainer["prototype"]["triggerBlockSelect"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListContainer["_"]["triggerBlockSelect"]++; }; 
	// no block selection triggered for UCF_AbapListContainer
};;if (__UCF_COVERAGE__) { UCF_AbapListContainer["_"]["triggerBlockSelect"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_AbapListContainer["prototype"]["aAttributeNames"] = ["sAccessibilityDescription","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_AbapListContainer["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_AbapListContainer["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_AbapListContainer["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {string}
 */
UCF_AbapListContainer["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_AbapListContainer["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_AbapListContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListContainer["_"]["setDefaultValues"]++; }; 
	this["sAccessibilityDescription"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_AbapListImage"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_AccessibilityHelper */
/// <reference path="../helper/AccessibilityHelper.js"/>
/* global UCF_AbapListItem */
/// <reference path="./AbapListItem.js"/>

/** @class
 * Use the AbapListImage control to create a image element
 * (List graphic, Icon) in the AbapList control.
 *
 * <br>
 * <b>Java Control references</b><br>
 * <a href="../javadoc/com/sap/tc/ls/api/controls/LSAbapListImage.html">LSAbapListImage</a>
 *
 * 
 *
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_AbapListImage(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_AbapListImage["_"]["UCF_AbapListImage"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "AbapListImage.js(29): UCF_AbapListImage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "AbapListImage.js(30): UCF_AbapListImage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "AbapListImage.js(31): UCF_AbapListImage"); };

	UCF_AbapListItem["apply"](this, [oDomRef, oLS]);
};window["UCF_AbapListImage"] = UCF_AbapListImage; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListImage"); UCF_AbapListImage["_"] = {UCF_AbapListImage: 0}; }; ;
UCF_AbapListImage["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_AbapListItem"))(); UCF_AbapListImage.prototype["sClassName"] = "UCF_AbapListImage";

/**
 * @see UCF_AbapListItem
 */

UCF_AbapListImage["prototype"]["bIsSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListImage["_"]["bIsSelectable"]++; }; 
	return this["bSelectable"];
};;if (__UCF_COVERAGE__) { UCF_AbapListImage["_"]["bIsSelectable"] = 0; };

/**
 * @see UCF_AbapListItem
 */

UCF_AbapListImage["prototype"]["applyAcc"] = function(oAccessibilityHelper) {;if (__UCF_COVERAGE__) { UCF_AbapListImage["_"]["applyAcc"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessibilityHelper instanceof UCF_AccessibilityHelper, "oAccessibilityHelper instanceof UCF_AccessibilityHelper", "AbapListImage.js(50): applyAcc"); };

	UCF_AbapListItem.prototype["applyAcc"]["call"](this, oAccessibilityHelper);
	oAccessibilityHelper["setControlType"]('IMG');
};;if (__UCF_COVERAGE__) { UCF_AbapListImage["_"]["applyAcc"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_AbapListImage["prototype"]["aAttributeNames"] = ["sAccessibilityDescription","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_AbapListImage["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_AbapListImage["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_AbapListImage["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {string}
 */
UCF_AbapListImage["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_AbapListImage["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_AbapListImage["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListImage["_"]["setDefaultValues"]++; }; 
	this["sAccessibilityDescription"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListImage["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_AbapListItem"] = function() {/* global _assert,  _trace, INFO*/
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_AccessibilityHelper */
/// <reference path="../helper/AccessibilityHelper.js"/>
/* global UCF_AbapList */
/// <reference path="./AbapList.js"/>

/**
 * A AbapListItem is a super class for all AbapList item types.
 *
 * @constructor
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_AbapListItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["UCF_AbapListItem"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "AbapListItem.js(35): UCF_AbapListItem"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "AbapListItem.js(36): UCF_AbapListItem"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "AbapListItem.js(37): UCF_AbapListItem"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
		/** @type {string} */
		// eslint-disable-next-line @ur/no-missing-setClientProperty
		this["sTooltip"] = this["oDomRef"]["title"];
		/** @type {boolean} */
		this["bSelectable"] = UCF_DomUtil["bHasClass"](this["oDomRef"], 'urCursorClickable');
	}
};window["UCF_AbapListItem"] = UCF_AbapListItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListItem"); UCF_AbapListItem["_"] = {UCF_AbapListItem: 0}; }; ;
UCF_AbapListItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_AbapListItem.prototype["sClassName"] = "UCF_AbapListItem";

/**
 * @private
 * @return {CSSStyleDeclaration}
 */
UCF_AbapListItem["prototype"]["oGetCSSStyle"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["oGetCSSStyle"]++; }; 
	/** @type {UCF_AbapListItem} */
	var self = this;

	return this["oCache"]["get"]('oCSSStyle', function() {
		return self["oDomRef"]["style"];
	});
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["oGetCSSStyle"] = 0; };

/**
 * @protected
 * @return {number}
 */
UCF_AbapListItem["prototype"]["iGetWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetWidth"]++; }; 
	/** @type {UCF_AbapListItem} */
	var self = this;

	return this["oCache"]["get"]('iWidth', function() {
		return (
			parseInt(self["oGetCSSStyle"]()["width"]) ||
			self["oDomRef"]["offsetWidth"]
		) / self["oGetList"]()["fRasterWidth"];
	});
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetWidth"] = 0; };

/**
 * @protected
 * @return {number}
 */
UCF_AbapListItem["prototype"]["iGetHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetHeight"]++; }; 
	/** @type {UCF_AbapListItem} */
	var self = this;

	return this["oCache"]["get"]('iHeight', function() {
		/** @type {CSSStyleDeclaration} */
		var oStyle = self["oGetCSSStyle"]();

		return (
			parseInt(oStyle["lineHeight"]) ||
			parseInt(oStyle["height"]) ||
			self["oDomRef"]["offsetHeight"]
		) / self["oGetList"]()["fRasterHeight"];
	});
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetHeight"] = 0; };

/**
 * Destructor
 */
UCF_AbapListItem["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["destroy"]++; }; 
	if (this["oCache"]) {
		this["oCache"]["destroy"]();
		this["oCache"] = null;
	}

	this["sTooltip"] = null;
	this["bSelectable"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["destroy"] = 0; };

/*****************************************************************************
 ** BROWSER EVENT HANDLER
 **
 ** They just delegate the event to the central "bHandleAccess" access method
 ** and cancel the event accordingly or delegate the interaction directly to
 ** the AbapList control. Sometimes they do not handle an action but should be
 ** canceled properly. For that they call the "bIsValidAccess" method
 **
 *****************************************************************************/

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_AbapListItem["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onlsfocus"]++; }; 
	/** @type {UCF_AbapList} */
	var oList = this["oGetList"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListItem.js(134): onlsfocus"); };

	oList["setLastFocusedItem"](this);
	oList["applyItemHighlightEffect"](this, true);
	this["triggerBlockSelect"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onlsfocus"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_AbapListItem["prototype"]["triggerBlockSelect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["triggerBlockSelect"]++; }; 
	/** @type {UCF_AbapListItem} */
	var self;
	/** @type {UCF_AbapListBlockSelectionDelegate} */
	var oDelegate = this["oGetList"]()["oGetBlockSelectionDelegate"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListItem.js(152): triggerBlockSelect"); };
	if (oDelegate && oDelegate["bAvoidItemSelectionByFocus"](this)) {
		oDelegate["removeAvoidItemSelectionByFocus"](this);
		return;
	}

	if (oDelegate && UCF_DomUtil["bHasTabIndex"](this["oDomRef"])) {
		self = this;

		this["requestAnimationFrame"](function() {
			oDelegate["handleBlockSelect"]({
				"oItem": self,
				"oBrowserEvent": oBrowserEvent,
				"eAccessType": oDelegate["ACCESS_TYPE"]["MOUSE"]
			});
		}, 'focus-handleBlockSelect');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["triggerBlockSelect"] = 0; };

/**
 * @private
 */
UCF_AbapListItem["prototype"]["resetTabIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["resetTabIndex"]++; }; 

	/** @type {UCF_AbapListBlockSelectionDelegate} */
	var oDelegate = this["oGetList"]()["oGetBlockSelectionDelegate"]();

	if (oDelegate
		&& UCF_JsUtil["bInstanceOf"](this, 'UCF_AbapListText')
		&& this["oDomRef"]
		&& UCF_DomUtil["bHasTabIndex"](this["oDomRef"])) {

		if (this["oDomRef"]["getAttribute"]
			&& this["oDomRef"]["getAttribute"]('navigateindex') !== '0') {
			//UCF_DomUtil.removeTabIndex(this.oDomRef);
			UCF_DomUtil["resetTabIndex"](this["oDomRef"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["resetTabIndex"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsblur
 */
UCF_AbapListItem["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onlsblur"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListItem.js(197): onlsblur"); };

	this["oGetList"]()["applyItemHighlightEffect"](this, false);
	this["resetTabIndex"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onlsblur"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_AbapListItem["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onclick"]++; }; 
	/** @type {UCF_AbapListItem} */
	var self;
	/** @type {UCF_AbapList} */
	var oList = this["oGetList"]();
	/** @type {UCF_AbapListBlockSelectionDelegate} */
	var oDelegate = oList["oGetBlockSelectionDelegate"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListItem.js(216): onclick"); };
	if (oDelegate && oDelegate["bAvoidItemSelection"](oBrowserEvent))
		return;

	if (this["bHandleAccess"](
			this["iGetKeyCode"](oBrowserEvent),
			this["oExtractClickPosition"](oBrowserEvent)
		)) {
		oBrowserEvent["cancelBubble"]();
	}

	if (oDelegate && !UCF_JsUtil["bInstanceOf"](
			oBrowserEvent["oGetSourceControl"](),
			'UCF_AbapListContainer'
		)) {
		self = this;
		//	oList.applyItemHighlightEffect(self, false);
		this["requestAnimationFrame"](function() {
			oDelegate["handleBlockSelect"]({
				"oItem": self,
				"oBrowserEvent": oBrowserEvent,
				"eAccessType": oBrowserEvent["bIsTouchInteraction"]()
					? oDelegate["ACCESS_TYPE"]["TOUCH"]
					: oDelegate["ACCESS_TYPE"]["MOUSE"]
			});
		}, 'click-handleBlockSelect');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onclick"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mousedown
 */
UCF_AbapListItem["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListItem.js(250): onmousedown"); };
	if (this["bIsValidAccess"](this["iGetKeyCode"](oBrowserEvent))) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onmousedown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsselect
 */
UCF_AbapListItem["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onlsselect"]++; }; 
	/** @type {UCF_KeyCode} */
	var iKeyCode;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListItem.js(264): onlsselect"); };

	iKeyCode = this["iGetKeyCode"](oBrowserEvent);

	if (this["bHandleAccess"](iKeyCode)) {
		if (iKeyCode === UCF_KeyCodes["SPACE"]) {
			oBrowserEvent["cancel"]();
		}

		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onlsselect"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the keydown
 */
UCF_AbapListItem["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListItem.js(282): onkeydown"); };
	if (this["bIsValidAccess"](this["iGetKeyCode"](oBrowserEvent))) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onkeydown"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the dblclick
 */
UCF_AbapListItem["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListItem.js(295): ondblclick"); };

	UCF_DomUtil["removeSelection"](this["oDomRef"]);
	this["oGetList"]()["handleItemDoubleClick"](
		this,
		this["oExtractClickPosition"](oBrowserEvent)
	);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["ondblclick"] = 0; };

UCF_AbapListItem["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListItem.js(306): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() === this) {
		this["applyAcc"](oBrowserEvent["oAccessibilityHelper"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onlsaccessibility"] = 0; };

/**
 * Extracts the raster X/Y position of the click
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {UCF_AbapList_Position} The position
 */
UCF_AbapListItem["prototype"]["oExtractClickPosition"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["oExtractClickPosition"]++; }; 
	return this["oCalculateClickPosition"](
		oBrowserEvent["iOffsetX"](),
		oBrowserEvent["iOffsetY"](),
		oBrowserEvent["oGetSourceControl"]()["sId"]
	);
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["oExtractClickPosition"] = 0; };

/**
 * @private
 * @param {number} iOffsetX x position
 * @param {number} iOffsetY y position
 * @param {string} sSourceId control id
 * @return {UCF_AbapList_Position}
 */
UCF_AbapListItem["prototype"]["oCalculateClickPosition"] = function(iOffsetX, iOffsetY, sSourceId) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["oCalculateClickPosition"]++; }; 
	/** @type {UCF_AbapList} */
	var oList = this["oGetList"]();

	return (oList["sRasterWidthUnit"] === 'px' && oList["sRasterHeightUnit"] === 'px')
		? {
			"iX": Math["floor"](((window["UCF_System"]["bIsRTL"] && sSourceId !== '')
				? UCF_DomUtil["$"](sSourceId)["offsetWidth"] - iOffsetX
				: iOffsetX) / oList["fRasterWidth"]),
			"iY": Math["floor"](iOffsetY / oList["fRasterHeight"])
		}
		: null;
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["oCalculateClickPosition"] = 0; };

/**
 * Extracts the key code from a browser event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {UCF_KeyCode} the key code
 */
UCF_AbapListItem["prototype"]["iGetKeyCode"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetKeyCode"]++; }; 
	return oBrowserEvent["iKeyCode"]() || 0;
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetKeyCode"] = 0; };

/**
 * Checks if the access to an item is valid or if it is somehow disabled for
 * such an action.
 *
 * This method is overwritten by item implementations
 *
 * @private
 * @param {UCF_KeyCode} iKeyCode the key code of the browser event
 * @return {boolean} `true` if the access by keyboard is valid
 */
UCF_AbapListItem["prototype"]["bIsValidAccess"] = function(iKeyCode) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["bIsValidAccess"]++; }; 
	return this["bIsSelectable"](); // Only valid when it is selectable
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["bIsValidAccess"] = 0; };

/**
 * The default implementation of the access of an item
 *
 * This method is overwritten by item implementations
 *
 * @private
 * @param {UCF_KeyCode} iKeyCode the browser event object
 * @param {UCF_AbapList_Position} [oSelectPosition] An object which contains
 * the X/Y raster position relativ to the element's origin.
 * @return {boolean} `false` if the access failed
 */
UCF_AbapListItem["prototype"]["bHandleAccess"] = function(iKeyCode, oSelectPosition) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["bHandleAccess"]++; }; 
	if (this["bIsValidAccess"](iKeyCode)) {
		if (this["bIsSelectable"]()) {
			this["oGetList"]()["handleItemSelect"](this, oSelectPosition);
		}

		return true;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["bHandleAccess"] = 0; };

/**
 * Determines if a item is selectable or not
 *
 * This is the default implementation of the items. The method is overwritten
 * by item implementations.
 *
 * @private
 * @return {boolean} `true` if the item is selectable
 */
UCF_AbapListItem["prototype"]["bIsSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["bIsSelectable"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["bIsSelectable"] = 0; };

/**
 * Searches and returns the root AbapList control
 *
 * @private
 * @return {UCF_AbapList} The control reference of the AbapList
 */
UCF_AbapListItem["prototype"]["oGetList"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["oGetList"]++; }; 
	/** @type {UCF_AbapListItem} */
	var self = this;

	return this["oCache"]["get"]('oList', function() {
		var oControl = self["oGetParent"]();

		while (oControl) {
			if (oControl instanceof UCF_AbapList) {
				return oControl;
			}

			oControl = oControl["oGetParent"]();
		}

		return null;
	});
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["oGetList"] = 0; };

/**
 * Update the Edit mode for the AbapList
 *
 * @param {boolean} bEditMode
 * @private
 */
UCF_AbapListItem["prototype"]["syncListEditMode"] = function(bEditMode) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["syncListEditMode"]++; }; 
	this["oGetList"]()["setCopyToClipboardEnabled"](!bEditMode);
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["syncListEditMode"] = 0; };

/**
 * @protected
 * @return {number} the absolute Left position
 */
UCF_AbapListItem["prototype"]["iGetLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetLeft"]++; }; 
	/** @type {number} */
	var iLeft = this["iGetRelativeLeft"]();
	/** @type {UCF_AbapListItem} */
	var oParent = this["oGetParent"]();

	while (
		oParent &&
		UCF_JsUtil["bInstanceOf"](oParent, 'UCF_AbapListContainer')
	) {
		iLeft += oParent["iGetRelativeLeft"]();
		oParent = oParent["oGetParent"]();
	}

	return iLeft;
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetLeft"] = 0; };

/**
 * @protected
 * @return {number}
 */
UCF_AbapListItem["prototype"]["iGetRelativeLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetRelativeLeft"]++; }; 
	/** @type {UCF_AbapListItem} */
	var self = this;

	return this["oCache"]["get"]('iRelativeLeft', function() {
		return (
			parseInt(self["oGetCSSStyle"]()["left"]) ||
			self["oDomRef"]["offsetLeft"]
		) / self["oGetList"]()["fRasterWidth"];
	});
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetRelativeLeft"] = 0; };

/**
 * Calculates and returns the absolute Left position
 *
 * @protected
 * @return {number}
 */
UCF_AbapListItem["prototype"]["iGetTop"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetTop"]++; }; 
	/** @type {number} */
	var iTop = this["iGetRelativeTop"]();
	/** @type {UCF_AbapListItem} */
	var oParent = this["oGetParent"]();

	while (
		oParent &&
		UCF_JsUtil["bInstanceOf"](oParent, 'UCF_AbapListContainer')
	) {
		iTop += oParent["iGetRelativeTop"]();
		oParent = oParent["oGetParent"]();
	}

	return iTop;
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetTop"] = 0; };

/**
 * @protected
 * @return {number}
 */
UCF_AbapListItem["prototype"]["iGetRelativeTop"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetRelativeTop"]++; }; 
	/** @type {UCF_AbapListItem} */
	var self = this;

	return this["oCache"]["get"]('iRelativeTop', function() {
		return (
			parseInt(self["oGetCSSStyle"]()["top"]) ||
			self["oDomRef"]["offsetTop"]
		) / self["oGetList"]()["fRasterHeight"];
	});
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["iGetRelativeTop"] = 0; };

/**
 * The item specific ACC handling. It is called by the AbapList root control.
 *
 * This is the default implementation of the items.
 * This method is overwritten by item implementations
 *
 * @param {oAccessibilityHelper} oAccessibilityHelper the acc helper
 * @private
 */
UCF_AbapListItem["prototype"]["applyAcc"] = function(oAccessibilityHelper) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["applyAcc"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessibilityHelper instanceof UCF_AccessibilityHelper, "oAccessibilityHelper instanceof UCF_AccessibilityHelper", "AbapListItem.js(531): applyAcc"); };

	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);
	oAccessibilityHelper["addEnabledTutor"]('B_TUT', this["bIsSelectable"]());
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["applyAcc"] = 0; };

/**
 * @override
 * @param {Object<string,number>} oPositionData
 * @param {UCF_ControlInfo} [oSubControl]
 * @return {UCF_Control_TouchContextMenuEntry[]}
 */
UCF_AbapListItem["prototype"]["aGetTouchContextMenuEntries"] = function(oPositionData, oSubControl) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["aGetTouchContextMenuEntries"]++; }; 
	/** @type {UCF_Control_TouchContextMenuEntry[]} */
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	/** @type {UCF_AbapList} */
	var oAbapList = this["oGetList"]();
	/** @type {UCF_AbapListItem} */
	var self;

	if (oAbapList["bHasEventListeners"]('DoubleClick')) {
		self = this;

		aResult["push"]({
			"sType": 'DOUBLECLICK',
			"sText": this["oLS"]["sGetText"]('SAPUR_POMN_CX_DLB_CLICK') || 'Trigger double click',
			"fTrigger": function() {
				var oPos;

				UCF_DomUtil["removeSelection"](self["oDomRef"]);

				oPos = self["oCalculateClickPosition"](
					oPositionData["iOffsetX"],
					oPositionData["iOffsetY"],
					oPositionData["sSourceId"]
				);
				oAbapList["fireDoubleClick"](
					oAbapList["sId"],
					self["sId"],
					oPos["iX"],
					oPos["iY"]
				);
			}
		});
	}

	return aResult;
};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["aGetTouchContextMenuEntries"] = 0; };

/**
 * On Touch the Browser do not send the onClick event so
 * it shold be forced and avoid to be send it twice
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_AbapListItem["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onlstouchstart"]++; }; 
	if (UCF_JsUtil["bInstanceOf"](this, 'UCF_AbapListText') && !this["bReadOnly"]) {
		// Input field, let the Browser do its job
	} else {
		UCF_DomUtil["moveFocusDomElement"](this["oDomRef"], true);
		this["onclick"](oBrowserEvent);
		oBrowserEvent["cancel"]();
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListItem["_"]["onlstouchstart"] = 0; };

};
sap["ls"]["preload"]["UCF_AbapListKeyboardBlockSelectionDelegate"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>

/** @typedef {0} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationNone */
/** @typedef {1} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToLeft */
/** @typedef {2} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToRight */
/** @typedef {3} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToHome */
/** @typedef {4} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToEnd */
/** @typedef {5} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDRowUp */
/** @typedef {6} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDRowDown */
/** @typedef {7} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationAllRows */
/** @typedef {8} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationAllColumns */
/** @typedef {9} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationAllCells */
/** @typedef {16} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharUp */
/** @typedef {17} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharDown */
/** @typedef {18} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharLeft */
/** @typedef {19} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharRight */
/** @typedef {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationNone|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToLeft|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToRight|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToHome|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToEnd|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDRowUp|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationAllRows|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationAllColumns|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationAllCells|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveRowUp|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveRowDown|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveColumnToLeft|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveColumnToRight|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveToFirstColumnToLeft|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveToLastColumn|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharUp|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharDown|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharLeft|UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharRight} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEnum */
/**
 * @typedef {Object} UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEnum
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationNone} NONE
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToLeft} EXTEND_COLUMN_TO_LEFT 			// [SHIFT] + [LEFT]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToRight} EXTEND_COLUMN_TO_RIGHT 		// [SHIFT] + [RIGHT]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToHome} EXTEND_COLUMN_TO_HOME 			// [SHIFT] + [HOME]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDColumnToEnd} EXTEND_COLUMN_TO_END 				// [SHIFT] + [END]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDRowUp} EXTEND_ROW_UP  										// [SHIFT] + [UP]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEXTENDRowDown} EXTEND_ROW_DOWN 								// [SHIFT] + [DOWN]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationAllRows} ALL_ROWS 															// [SHIFT] + [SPACE]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationAllColumns} ALL_COLUMNS 												// [CTRL] + [SPACE]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationAllCells} ALL_CELLS
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharUp } EXTEND_CHAR_UP // [SHIFT] + [ALT] + [ARROW UP]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharDown } EXTEND_CHAR_DOWN //  [SHIFT] + [ALT] + [ARROW DOWN]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharLeft } EXTEND_CHAR_LEFT // [SHIFT] + [ALT] + [ARROW LEFT]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationMoveCharRight } EXTEND_CHAR_RIGHT // [SHIFT] + [ALT] + [ARROW RIGHT]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationExtendToFirstItem } EXTEND_TO_FIRST_ITEM // [SHIFT] + [CTRL] + [HOME]
 * @property {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationExtendToLastItem } EXTEND_TO_LAST_ITEM // [SHIFT] + [CTRL] + [END]
 */

/**
 *
 * @class UCF_AbapListKeyboardBlockSelectionDelegate
 * @extends UCF_Object
 * @param {UCF_LS} oLS
 * @param {UCF_AbapList} oAbapList
 *
 */
function UCF_AbapListKeyboardBlockSelectionDelegate(oLS, oAbapList) {if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["UCF_AbapListKeyboardBlockSelectionDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		this["oLS"] = oLS;
		this["oAbapList"] = oAbapList;
		this["oManager"] = this["oAbapList"]["oGetBlockSelectionManager"]();
		this["attachAnyEventHandler"]();
	}
};window["UCF_AbapListKeyboardBlockSelectionDelegate"] = UCF_AbapListKeyboardBlockSelectionDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListKeyboardBlockSelectionDelegate"); UCF_AbapListKeyboardBlockSelectionDelegate["_"] = {UCF_AbapListKeyboardBlockSelectionDelegate: 0}; }; ;

UCF_AbapListKeyboardBlockSelectionDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_AbapListKeyboardBlockSelectionDelegate.prototype["sClassName"] = "UCF_AbapListKeyboardBlockSelectionDelegate";

UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["destroy"]++; }; 

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
	this["detachAnyEventHandler"]();
	this["oLS"] = null;
	this["oAbapList"] = null;
	this["oManager"] = null;
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["destroy"] = 0; };

/** @type {UCF_AbapListKeyboardBlockSelectionDelegate_NavigationEnum} Navigation types */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["NAVIGATION"] = {
	"NONE": 0,
	"EXTEND_COLUMN_TO_LEFT": 1, // [SHIFT] + [LEFT]
	"EXTEND_COLUMN_TO_RIGHT": 2, // [SHIFT] + [RIGHT]
	"EXTEND_COLUMN_TO_HOME": 3, // [SHIFT] + [HOME]
	"EXTEND_COLUMN_TO_END": 4, // [SHIFT] + [END]
	"EXTEND_ROW_UP": 5, // [SHIFT] + [UP]
	"EXTEND_ROW_DOWN": 6, // [SHIFT] + [DOWN]
	"ALL_ROWS": 7, // [SHIFT] + [SPACE]
	"ALL_COLUMNS": 8, // [CTRL] + [SPACE]
	"ALL_CELLS": 9, // [CTRL] + [A]
	"EXTEND_CHAR_UP": 16, // [SHIFT] + [ALT] + [ARROW UP]
	"EXTEND_CHAR_DOWN": 17, // [SHIFT] + [ALT] + [ARROW DOWN]
	"EXTEND_CHAR_LEFT": 18, // [SHIFT] + [ALT] + [ARROW LEFT]
	"EXTEND_CHAR_RIGHT": 19, // [SHIFT] + [ALT] + [ARROW RIGHT]
	"EXTEND_TO_FIRST_ITEM": 22, //[SHIFT] + [CTRL] + [HOME]
	"EXTEND_TO_LAST_ITEM": 23 // [SHIFT] + [CTRL] +[END]
};

/** @private */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["attachAnyEventHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["attachAnyEventHandler"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow = this["oLS"]["oBrowserWindow"];

	if (oBrowserWindow) {
		oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["attachAnyEventHandler"] = 0; };

/** @private */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["detachAnyEventHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["detachAnyEventHandler"]++; }; 
	if (!this["oLS"]) return;
	var oBrowserWindow = this["oLS"]["oBrowserWindow"];

	if (oBrowserWindow) {
		oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["detachAnyEventHandler"] = 0; };

/** @param {UCF_SemanticEvent<{oBrowserEvent: UCF_BrowserEvent}>} oAnyEvent */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["onAnyEvent"] = function(oAnyEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onAnyEvent"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oAnyEvent["oGetParam"]('oBrowserEvent');
	/** @type {string} */
	var sName = oBrowserEvent["sGetName"]();
	switch (sName) {
		case 'keydown':
			// UR2107 hack: keyup for [CMD][A] or [CMD][C] is not fired, use keydown
			// instead. Better solution would be to find out why keydown is not
			// dispatched properly in ITS and
			if (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["A"], 'C')
				&& !this["oManager"]["bIsActiveSelectionOutside"]()
				&& this["bIsActiveElementAllowed"]()
				&& !this["oManager"]["bIsBlockSelectionEmpty"]()) {
				this["extendBlockSelectionByItem"](oBrowserEvent, this["NAVIGATION"]["ALL_CELLS"]);
				UCF_DomUtil["moveFocusDomElement"](this["oAbapList"]["oDomRef"]);
			}
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onAnyEvent"] = 0; };

/**
 * If a PopupMenu is opened, the [CTRL] + [A] should not occur
 * The PopupMenu might be the ContextMenu
 *
 * @return {boolean}
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["bIsActiveElementAllowed"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["bIsActiveElementAllowed"]++; }; 
	var oDomRef = UCF_DomUtil["oGetActiveElement"](),
		oDomRefChild = UCF_DomUtil["oGetFirstChildCTElement"](oDomRef) || oDomRef,
		// ne selection
		bAllowedElement = (UCF_DomUtil["sGetCurrentSelectionText"]() === ''),
		oItem;
	//	if (oDomRefChild == null && oDomRef && oDomRef.id) { oDomRefChild = oDomRef; }

	if (oDomRefChild) {
		oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oDomRefChild, true);

		if (oItem && (
				UCF_JsUtil["bInstanceOf"](oItem, 'UCF_PopupMenu') ||
				UCF_JsUtil["bInstanceOf"](oItem, 'UCF_PopupMenuItem')
			)) {
			bAllowedElement = false;
		}
		if (oItem && !UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AbapListItem')) {
			bAllowedElement = false;
		}
	}

	return bAllowedElement;
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["bIsActiveElementAllowed"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsupmodifier
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["onlsupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsupmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent))
		this["extendBlockSelectionByItem"](oBrowserEvent, this["NAVIGATION"]["EXTEND_ROW_UP"]);
	if (UCF_KeyboardHelper["bHasOnlyAltShiftAsModifiers"](oBrowserEvent))
		this["extendBlockSelectionByChar"](oBrowserEvent, this["NAVIGATION"]["EXTEND_CHAR_UP"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsupmodifier"] = 0; };
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdownmodifier
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["onlsdownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsdownmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent))
		this["extendBlockSelectionByItem"](oBrowserEvent, this["NAVIGATION"]["EXTEND_ROW_DOWN"]);
	if (UCF_KeyboardHelper["bHasOnlyAltShiftAsModifiers"](oBrowserEvent))
		this["extendBlockSelectionByChar"](oBrowserEvent, this["NAVIGATION"]["EXTEND_CHAR_DOWN"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsdownmodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleftmodifier
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["onlsleftmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsleftmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent))
		this["extendBlockSelectionByItem"](oBrowserEvent, this["NAVIGATION"]["EXTEND_COLUMN_TO_LEFT"]);
	if (UCF_KeyboardHelper["bHasOnlyAltShiftAsModifiers"](oBrowserEvent))
		this["extendBlockSelectionByChar"](oBrowserEvent, this["NAVIGATION"]["EXTEND_CHAR_LEFT"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsleftmodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsrightmodifier
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["onlsrightmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsrightmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent))
		this["extendBlockSelectionByItem"](oBrowserEvent, this["NAVIGATION"]["EXTEND_COLUMN_TO_RIGHT"]);
	if (UCF_KeyboardHelper["bHasOnlyAltShiftAsModifiers"](oBrowserEvent))
		this["extendBlockSelectionByChar"](oBrowserEvent, this["NAVIGATION"]["EXTEND_CHAR_RIGHT"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsrightmodifier"] = 0; };

/**
 * [SHIFT] + [HOME]
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleftmodifier
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["onlshomemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlshomemodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent))
		this["extendBlockSelectionByItem"](oBrowserEvent, this["NAVIGATION"]["EXTEND_COLUMN_TO_HOME"]);
	else if (UCF_KeyboardHelper["bHasOnlyShiftCtrlAsModifiers"](oBrowserEvent))
		this["extendBlockSelectionByItem"](oBrowserEvent, this["NAVIGATION"]["EXTEND_TO_FIRST_ITEM"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlshomemodifier"] = 0; };

/**
 * [SHIFT] + [END]
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleftmodifier
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["onlsendmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsendmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent))
		this["extendBlockSelectionByItem"](oBrowserEvent, this["NAVIGATION"]["EXTEND_COLUMN_TO_END"]);
	else if (UCF_KeyboardHelper["bHasOnlyShiftCtrlAsModifiers"](oBrowserEvent))
		this["extendBlockSelectionByItem"](oBrowserEvent, this["NAVIGATION"]["EXTEND_TO_LAST_ITEM"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsendmodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleftmodifier
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["onlsspacemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsspacemodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent))
		this["extendBlockSelectionByItem"](oBrowserEvent, this["NAVIGATION"]["ALL_ROWS"]);
	else if (UCF_KeyboardHelper["bHasOnlyCtrlAsModifier"](oBrowserEvent))
		this["extendBlockSelectionByItem"](oBrowserEvent, this["NAVIGATION"]["ALL_COLUMNS"]);

};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["onlsspacemodifier"] = 0; };

/**
 * Handle the keyboard selection for [SHIFT] + ARROWs
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {number} eOperation
 */
/* eslint-disable complexity */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["extendBlockSelectionByItem"] = function(oBrowserEvent, eOperation) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["extendBlockSelectionByItem"]++; }; 
	/** @type {UCF_AbapListKeyboardBlockSelectionDelegate_BlockSelection} */
	var oBlockSelection = this["oManager"]["oGetBlockSelection"]();
	/** @type {number} */
	var iTopLeftX = -1;
	/** @type {number} */
	var iTopLeftY = -1;

	/** @type {number} */
	var iBottomRightX = -1;
	/** @type {number} */
	var iBottomRightY = -1;
	/** @type {number} */
	var iCurrentLeft;
	/** @type {number} */
	var iCurrentTop;
	/** @type {boolean} */
	var bExtendToItem = false;

	/** @type {Array} */
	var oCurrentOriginBlockSelection;
	var oItem;
	iTopLeftX = oBlockSelection["TopLeftX"];
	iTopLeftY = oBlockSelection["TopLeftY"];

	iBottomRightX = oBlockSelection["BottomRightX"];
	iBottomRightY = oBlockSelection["BottomRightY"];

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListKeyboardBlockSelectionDelegate.js(295): extendBlockSelectionByItem"); };
	//this.oBlockSelectionDelegate.generateOriginBoundaries(); ????
	oCurrentOriginBlockSelection = this["oManager"]["oGetOriginBlockSelection"]();

	this["oManager"]["removeCharFocus"]();
	switch (eOperation) {
		case this["NAVIGATION"]["EXTEND_COLUMN_TO_LEFT"]: // [SHIFT] + [LEFT]
			if (iBottomRightX === oCurrentOriginBlockSelection["BottomRightX"] &&
				!this["bIsFirstItemOnTheLine"](oCurrentOriginBlockSelection["TopLeftY"], iTopLeftX)) {
				iCurrentLeft = iTopLeftX - 1;
				iCurrentTop = iTopLeftY === oCurrentOriginBlockSelection["TopLeftY"] ? iBottomRightY - 1 : iTopLeftY;
				oItem = this["oGetHorizontalItemFromPosition"](iCurrentLeft, iCurrentTop, eOperation, false);

				if (oItem) {
					iTopLeftX = oItem["iGetLeft"]();
				}

			} else if (iBottomRightX > oCurrentOriginBlockSelection["BottomRightX"]) {
				iCurrentLeft = iBottomRightX - 1;
				iCurrentTop = iBottomRightY === oCurrentOriginBlockSelection["BottomRightY"] ? iTopLeftY : iBottomRightY - 1;

				oItem = this["oGetHorizontalItemFromPosition"](iCurrentLeft, iCurrentTop, eOperation, true);
				if (oItem) {
					iBottomRightX = oItem["iGetLeft"]() + oItem["iGetWidth"]();
				}
			}
			break;
		case this["NAVIGATION"]["EXTEND_COLUMN_TO_RIGHT"]: // [SHIFT] + [RIGHT]
			if (iTopLeftX < oCurrentOriginBlockSelection["TopLeftX"]) {
				iCurrentLeft = iTopLeftX + 1;
				iCurrentTop = iTopLeftY === oCurrentOriginBlockSelection["TopLeftY"] ? iBottomRightY - 1 : iTopLeftY;
				oItem = this["oGetHorizontalItemFromPosition"](iCurrentLeft, iCurrentTop, eOperation, true);
				if (oItem) {
					iTopLeftX = oItem["iGetLeft"]();
				}
			} else if (!this["bIsLastItemOnTheLine"](oCurrentOriginBlockSelection["TopLeftY"], iBottomRightX)) {
				iCurrentLeft = iBottomRightX + 1;
				iCurrentTop = iBottomRightY === oCurrentOriginBlockSelection["BottomRightY"] ? iTopLeftY : iBottomRightY - 1;
				oItem = this["oGetHorizontalItemFromPosition"](iCurrentLeft, iCurrentTop, eOperation, false);
				if (oItem) {
					iBottomRightX = oItem["iGetLeft"]() + oItem["iGetWidth"]();
				}
			}
			break;
		case this["NAVIGATION"]["EXTEND_ROW_UP"]: // [SHIFT] + [UP]
			if (oCurrentOriginBlockSelection["BottomRightY"] < iBottomRightY
				&& oCurrentOriginBlockSelection["TopLeftY"] === iTopLeftY) {
				iBottomRightY--;
				iCurrentLeft = oCurrentOriginBlockSelection["BottomRightX"] === iBottomRightX ? iTopLeftX : iBottomRightX;
				iCurrentTop = iBottomRightY - 1;
				oItem = this["oManager"]["oGetItemXY"](iCurrentLeft, iCurrentTop);
			} else
			if (iTopLeftY > this["oManager"]["iGetFirstRow"]()) {
				iTopLeftY--;
				iCurrentLeft = oCurrentOriginBlockSelection["TopLeftX"] === iTopLeftX ? iBottomRightX : iTopLeftX;
				iCurrentTop = iTopLeftY;
				oItem = this["oManager"]["oGetItemXY"](oCurrentOriginBlockSelection["TopLeftX"] === iTopLeftX ? iBottomRightX : iTopLeftX, iTopLeftY);
			}
			break;
		case this["NAVIGATION"]["EXTEND_ROW_DOWN"]: // [SHIFT] + [DOWN]
			//if (iBottomRightY <= oOriginBoundaries.Bottom && iTopLeftY === oCurrentOriginBlockSelection.TopLeftY) {
			if (iBottomRightY >= oCurrentOriginBlockSelection["BottomRightY"] && iTopLeftY === oCurrentOriginBlockSelection["TopLeftY"]) {
				iBottomRightY++;
				oItem = this["oManager"]["oGetItemXY"](oCurrentOriginBlockSelection["BottomRightX"] === iBottomRightX ? iTopLeftX : iBottomRightX, iBottomRightY - 1);
			} else if (oCurrentOriginBlockSelection["TopLeftY"] > iTopLeftY
				&& oCurrentOriginBlockSelection["BottomRightY"] === iBottomRightY) {
				iTopLeftY++;
				oItem = this["oManager"]["oGetItemXY"](oCurrentOriginBlockSelection["TopLeftX"] === iTopLeftX ? iBottomRightX : iTopLeftX, iTopLeftY);
			}
			break;
		case this["NAVIGATION"]["EXTEND_COLUMN_TO_HOME"]: // [SHIFT] + [HOME]
			iTopLeftX = this["oManager"]["iGetFirstColumn"]();
			iCurrentTop = iTopLeftY === oCurrentOriginBlockSelection["TopLeftY"] ? iBottomRightY - 1 : iTopLeftY;
			oItem = this["oGetHorizontalItemFromPosition"](iTopLeftX, iCurrentTop, eOperation, false);
			if (oItem)
				iTopLeftX = oItem["iGetLeft"]();
			break;
		case this["NAVIGATION"]["EXTEND_COLUMN_TO_END"]: // [SHIFT] + [END]
			iBottomRightX = this["oManager"]["iGetLastColumn"]();
			iCurrentTop = iBottomRightY === oCurrentOriginBlockSelection["BottomRightY"] ? iTopLeftY : iBottomRightY - 1;
			oItem = this["oGetHorizontalItemFromPosition"](iBottomRightX, iCurrentTop, eOperation, false);
			if (oItem)
				iBottomRightX = oItem["iGetLeft"]() + oItem["iGetWidth"]();
			break;
		case this["NAVIGATION"]["ALL_CELLS"]: // [CTRL] + [A]
			if (iTopLeftX === this["oManager"]["iGetFirstColumn"]()
				&& iTopLeftY === this["oManager"]["iGetFirstRow"]()
				&& iBottomRightX === this["oManager"]["iGetLastColumn"]()
				&& iBottomRightY === this["oManager"]["iGetLastRow"]()) {
				iTopLeftX = oCurrentOriginBlockSelection["TopLeftX"];
				iTopLeftY = oCurrentOriginBlockSelection["TopLeftY"];
				iBottomRightX = oCurrentOriginBlockSelection["BottomRightX"];
				iBottomRightY = oCurrentOriginBlockSelection["BottomRightY"];
				//	UCF_DomUtil.moveFocusDomElement(this.oOriginItem.oDomRef);
			} else {

				iTopLeftX = this["oManager"]["iGetFirstColumn"]();
				iTopLeftY = this["oManager"]["iGetFirstRow"]();
				iBottomRightX = this["oManager"]["iGetLastColumn"]();
				iBottomRightY = this["oManager"]["iGetLastRow"]();

			}
			break;
		case this["NAVIGATION"]["ALL_COLUMNS"]: // [CTRL] + [SPACE]
			iTopLeftY = this["oManager"]["iGetFirstRow"]();
			iBottomRightY = this["oManager"]["iGetLastRow"]();
			break;
		case this["NAVIGATION"]["ALL_ROWS"]: // [SHIFT] + [SPACE]
			iTopLeftX = this["oManager"]["iGetFirstColumn"]();
			iBottomRightX = this["oManager"]["iGetLastColumn"]();
			break;

		case this["NAVIGATION"]["EXTEND_TO_FIRST_ITEM"]: // [CTRL] + [SHIFT] + [HOME]
			oItem = this["oManager"]["oGetFirstItemWithData"]();
			if (oItem) {
				iTopLeftX = Math["min"](oItem["iGetLeft"](), iTopLeftX);
				iTopLeftY = Math["min"](oItem["iGetTop"](), iTopLeftY);
				iBottomRightX = Math["max"](oItem["iGetLeft"]() + oItem["iGetWidth"](), iBottomRightX);
				iBottomRightY = Math["max"](oItem["iGetTop"]() + oItem["iGetHeight"](), iBottomRightY);
			}
			break;
		case this["NAVIGATION"]["EXTEND_TO_LAST_ITEM"]: // [CTRL] + [SHIFT] + [END]
			oItem = this["oManager"]["oGetLastItemWithData"]();
			if (oItem) {
				iTopLeftX = Math["min"](oItem["iGetLeft"](), iTopLeftX);
				iTopLeftY = Math["min"](oItem["iGetTop"](), iTopLeftY);
				iBottomRightX = Math["max"](oItem["iGetLeft"]() + oItem["iGetWidth"](), iBottomRightX);
				iBottomRightY = Math["max"](oItem["iGetTop"]() + oItem["iGetHeight"](), iBottomRightY);

			}

			break;
		default:
			break;
	}

	if (oItem) {
		// Set the Focus, but not the selection
		this["oManager"]["setNewFocusedItem"](oItem, true, false);
		bExtendToItem = true;
	} else {
		bExtendToItem = false;
	}

	if (bExtendToItem) {
		oBlockSelection["TopLeftX"] = Math["min"](oItem["iGetLeft"](), oCurrentOriginBlockSelection["TopLeftX"], Math["max"](iTopLeftX, this["oManager"]["iGetFirstColumn"]()));
		oBlockSelection["TopLeftY"] = Math["min"](oItem["iGetTop"](), oCurrentOriginBlockSelection["TopLeftY"], Math["max"](iTopLeftY, this["oManager"]["iGetFirstRow"]()));
		oBlockSelection["BottomRightX"] = Math["max"](iBottomRightX, oCurrentOriginBlockSelection["BottomRightX"], oItem["iGetLeft"]() + oItem["iGetWidth"]());
		oBlockSelection["BottomRightY"] = Math["max"](iBottomRightY, oCurrentOriginBlockSelection["BottomRightY"], oItem["iGetTop"]() + oItem["iGetHeight"]());
	} else {
		oBlockSelection["TopLeftX"] = Math["max"](iTopLeftX, this["oManager"]["iGetFirstColumn"]());
		oBlockSelection["TopLeftY"] = Math["max"](iTopLeftY, this["oManager"]["iGetFirstRow"]());
		oBlockSelection["BottomRightX"] = Math["max"](iBottomRightX, oCurrentOriginBlockSelection["BottomRightX"]);
		oBlockSelection["BottomRightY"] = Math["max"](iBottomRightY, oCurrentOriginBlockSelection["BottomRightY"]);

	}

	this["oManager"]["setBlockSelectionInternal"](oBlockSelection);
	this["oManager"]["fireBlockSelectInternal"](oBlockSelection);
	if (!bExtendToItem) {
		this["oManager"]["emphasizeCharSelection"]();
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["extendBlockSelectionByItem"] = 0; };

/**
 * @param { int } iX
 * @param { int } iY
 * @param { number } eOperation
 * @param { boolean } bChageDirection
 * @return { Object } -
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["oGetVerticalItemFromPosition"] = function(iX, iY, eOperation, bChageDirection) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["oGetVerticalItemFromPosition"]++; }; 

	/** @type {UCF_AbapListItem} */
	var oItem = null;

	var oLine = this["oGetAllAbapListItems"]()[iY];
	if (!oLine) return null;
	for (var i = 0; i < oLine["length"]; i++) {
		oItem = oLine[i];
		if (oItem["iGetLeft"]() >= iX || iX <= (oItem["iGetLeft"]() + oItem["iGetWidth"]()))
			break;
	}

	return oItem;
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["oGetVerticalItemFromPosition"] = 0; };

/**
 * @param {int} iX
 * @param {int} iY
 * @param { number } eOperation
 * @param { boolean } bChageDirection
 * @return {Object} - return the Object
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["oGetHorizontalItemFromPosition"] = function(iX, iY, eOperation, bChageDirection) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["oGetHorizontalItemFromPosition"]++; }; 

	/** @type {UCF_AbapListItem} */
	var oItem = null;
	/** @type {UCF_AbapListItem} */
	var oPreviousItem;
	/** @type {UCF_AbapListItem} */
	var oPositionItem;
	/** @type {int} */
	var iPosition;

	var oLine = this["oManager"]["oGetAllAbapListItems"]()[iY];
	if (!oLine) return null;

	if (iX === this["oManager"]["iGetFirstColumn"]()) {
		// gets the first item
		oItem = oLine[0];
	} else if (iY === this["oManager"]["iGetLastColumn"]()) {
		// it should return the last item
		oItem = oLine[oLine["length"] - 1];
	} else {
		if (oLine["length"] < 2) {
			oItem = oLine[0];
		} else {
			if (!bChageDirection) {
				for (var i = 0; i < oLine["length"]; i++) {
					oItem = oLine[i];
					if (iX === oItem["iGetLeft"]() || (oItem["iGetLeft"]() < iX && iX < (oItem["iGetLeft"]() + oItem["iGetWidth"]())))
						break;
					if (iX < oItem["iGetLeft"]()) {
						if (eOperation === this["NAVIGATION"]["EXTEND_COLUMN_TO_LEFT"])
							oItem = oPreviousItem;
						break;
					}
					oPreviousItem = oItem;
				}
			} else {
				oItem = null;
				for (i = 0; i < oLine["length"]; i++) {
					oPositionItem = oLine[i];
					iPosition = i;
					if (oPositionItem["iGetLeft"]() <= iX && iX <= (oPositionItem["iGetLeft"]() + oPositionItem["iGetWidth"]()))
						break;
				}
				if (oPositionItem) {
					if (eOperation === this["NAVIGATION"]["EXTEND_COLUMN_TO_LEFT"])
						iPosition--;
					if (eOperation === this["NAVIGATION"]["EXTEND_COLUMN_TO_RIGHT"])
						iPosition++;
					if (iPosition >= 0 || iPosition < oLine["length"])
						oItem = oLine[iPosition];
				}
			}
		}
	}
	return oItem;
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["oGetHorizontalItemFromPosition"] = 0; };

/**
 *
 * @param { int } iY
 * @param {int} iX
 * @return {Object} - return the Object
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["bIsLastItemOnTheLine"] = function(iY, iX) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["bIsLastItemOnTheLine"]++; }; 

	/** @type {UCF_AbapListItem} */
	var oItem = null;
	var oLine = this["oManager"]["oGetAllAbapListItems"]()[iY];
	if (!oLine) return true;

	oItem = oLine[oLine["length"] - 1];
	return oItem && iX === (oItem["iGetLeft"]() + oItem["iGetWidth"]());

};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["bIsLastItemOnTheLine"] = 0; };

/**
 *
 * @param { int } iY
 * @param {int} iX
 * @return {Object} - return the Object
 */
UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["bIsFirstItemOnTheLine"] = function(iY, iX) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["bIsFirstItemOnTheLine"]++; }; 

	/** @type {UCF_AbapListItem} */
	var oItem = null;
	var oLine = this["oManager"]["oGetAllAbapListItems"]()[iY];
	if (!oLine) return true;

	oItem = oLine[0];
	return oItem && iX === oItem["iGetLeft"]();

};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["bIsFirstItemOnTheLine"] = 0; };

/**
 * Handle the keyboard selection for [SHIFT] + ARROWs
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {number} eOperation
 */

UCF_AbapListKeyboardBlockSelectionDelegate["prototype"]["extendBlockSelectionByChar"] = function(oBrowserEvent, eOperation) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["extendBlockSelectionByChar"]++; }; 
	/** @type {UCF_AbapListKeyboardBlockSelectionDelegate_BlockSelection} */
	var oBlockSelection = this["oManager"]["oGetBlockSelection"]();
	/** @type {number} */
	var iTopLeftX = -1;
	/** @type {number} */
	var iTopLeftY = -1;

	/** @type {number} */
	var iBottomRightX = -1;
	/** @type {number} */
	var iBottomRightY = -1;

	iTopLeftX = oBlockSelection["TopLeftX"];
	iTopLeftY = oBlockSelection["TopLeftY"];

	iBottomRightX = oBlockSelection["BottomRightX"];
	iBottomRightY = oBlockSelection["BottomRightY"];

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListKeyboardBlockSelectionDelegate.js(613): extendBlockSelectionByChar"); };
	this["oManager"]["removeCharFocus"]();
	var oOriginBlockSelection = this["oManager"]["oGetOriginBlockSelection"]();
	switch (eOperation) {
		case this["NAVIGATION"]["EXTEND_CHAR_LEFT"]: // [ALT] + [SHIFT] + [LEFT]
			if (iBottomRightX === oOriginBlockSelection["BottomRightX"] &&
				this["oManager"]["iGetFirstColumn"]() < iTopLeftX) {
				iTopLeftX--;
			} else if (iBottomRightX > oOriginBlockSelection["BottomRightX"]) {
				iBottomRightX--;
			}
			break;
		case this["NAVIGATION"]["EXTEND_CHAR_RIGHT"]: //  [ALT] + [SHIFT] + [RIGHT]
			if (iTopLeftX < oOriginBlockSelection["TopLeftX"] &&
				iBottomRightX === oOriginBlockSelection["BottomRightX"]) {
				iTopLeftX++;
			} else if (iTopLeftX === oOriginBlockSelection["TopLeftX"] && iBottomRightX < this["oManager"]["iGetLastColumn"]()) {
				iBottomRightX++;
			}
			break;

		case this["NAVIGATION"]["EXTEND_CHAR_UP"]: // [ALT] + [SHIFT] + [UP]

			if (oOriginBlockSelection["BottomRightY"] < iBottomRightY
				&& oOriginBlockSelection["TopLeftY"] === iTopLeftY) {
				iBottomRightY--;

				if (iBottomRightY < oOriginBlockSelection["BottomRightY"])
					iBottomRightY++;
			} else if (iTopLeftY > this["oManager"]["iGetFirstRow"]()) {
				iTopLeftY--;
			}
			break;
		case this["NAVIGATION"]["EXTEND_CHAR_DOWN"]: // [ALT] + [SHIFT] + [DOWN]
			if (iBottomRightY < this["oManager"]["iGetLastRow"]() && iTopLeftY === oOriginBlockSelection["TopLeftY"]) {
				iBottomRightY++;
			} else if (oOriginBlockSelection["TopLeftY"] > iTopLeftY
				&& oOriginBlockSelection["BottomRightY"] === iBottomRightY) {
				iTopLeftY++;
			}
			break;
		default:
			break;
	}

	oBlockSelection["TopLeftX"] = Math["max"](iTopLeftX, this["oManager"]["iGetFirstColumn"]());
	oBlockSelection["TopLeftY"] = Math["max"](iTopLeftY, this["oManager"]["iGetFirstRow"]());
	oBlockSelection["BottomRightX"] = iBottomRightX;
	oBlockSelection["BottomRightY"] = iBottomRightY;

	this["oManager"]["setBlockSelectionInternal"](oBlockSelection);
	this["oManager"]["fireBlockSelectInternal"](oBlockSelection);
	this["oManager"]["emphasizeCharSelection"]();

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardBlockSelectionDelegate["_"]["extendBlockSelectionByChar"] = 0; };

};
sap["ls"]["preload"]["UCF_AbapListKeyboardNavigationDelegate"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>

/**
 *
 * @class UCF_AbapListKeyboardNavigationDelegate
 * @extends UCF_Object
 * @param {UCF_LS} oLS
 * @param {UCF_AbapList} oAbapList
 *
 */
function UCF_AbapListKeyboardNavigationDelegate(oLS, oAbapList) {if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["UCF_AbapListKeyboardNavigationDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		this["oLS"] = oLS;
		this["oAbapList"] = oAbapList;
		this["oManager"] = this["oAbapList"]["oGetBlockSelectionManager"]();
		this["oNavigationHistory"] = [];
		this["mRasterMatrix"] = null;

	}
};window["UCF_AbapListKeyboardNavigationDelegate"] = UCF_AbapListKeyboardNavigationDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListKeyboardNavigationDelegate"); UCF_AbapListKeyboardNavigationDelegate["_"] = {UCF_AbapListKeyboardNavigationDelegate: 0}; }; ;

UCF_AbapListKeyboardNavigationDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_AbapListKeyboardNavigationDelegate.prototype["sClassName"] = "UCF_AbapListKeyboardNavigationDelegate";

UCF_AbapListKeyboardNavigationDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["destroy"]++; }; 

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
	this["oLS"] = null;
	this["oAbapList"] = null;
	this["mRasterMatrix"] = null;
	this["iFirstColumn"] = null;
	this["iFirstRow"] = null;
	this["iNoOfColumns"] = null;
	this["iNoOfRows"] = null;
	this["oNavigationHistory"] = null;
	this["oManager"] = null;
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["destroy"] = 0; };

/** @type {UCF_AbapListBlockSelectionDelegate_NavigationEnum} Navigation types */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["NAVIGATION"] = {
	"NONE": 0,
	"MOVE_ROW_UP": 1, // [ARROW UP]
	"MOVE_ROW_DOWN": 2, // [ARROW DOWN]
	"MOVE_COLUMN_TO_LEFT": 3, // [ARROW LEFT]
	"MOVE_COLUMN_TO_RIGHT": 4, // [ARROW RIGHT]
	"MOVE_TO_FIRST_COLUMN": 5, // [HOME]
	"MOVE_TO_LAST_COLUMN": 6, // [END],
	"MOVE_TO_FIRST_ITEM": 7, // [CTRL] + [HOME]
	"MOVE_TO_LAST_ITEM": 8 //  [CTRL] +[END]
};

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsupmodifier
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsleft"]++; }; 
	this["handleArrowNavigation"](oBrowserEvent, this["NAVIGATION"]["MOVE_COLUMN_TO_LEFT"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsleft"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsupmodifier
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsright"]++; }; 
	this["handleArrowNavigation"](oBrowserEvent, this["NAVIGATION"]["MOVE_COLUMN_TO_RIGHT"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsright"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsupmodifier
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsup"]++; }; 
	this["handleArrowNavigation"](oBrowserEvent, this["NAVIGATION"]["MOVE_ROW_UP"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsup"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsupmodifier
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsdown"]++; }; 
	this["handleArrowNavigation"](oBrowserEvent, this["NAVIGATION"]["MOVE_ROW_DOWN"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsdown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsupmodifier
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlshome"]++; }; 
	this["handleArrowNavigation"](oBrowserEvent, this["NAVIGATION"]["MOVE_TO_FIRST_COLUMN"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlshome"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsupmodifier
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsend"]++; }; 
	this["handleArrowNavigation"](oBrowserEvent, this["NAVIGATION"]["MOVE_TO_LAST_COLUMN"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsend"] = 0; };

/**
 * [SHIFT] + [HOME]
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleftmodifier
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["onlshomemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlshomemodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyCtrlAsModifier"](oBrowserEvent)) {
		this["handleArrowNavigation"](oBrowserEvent, this["NAVIGATION"]["MOVE_TO_FIRST_ITEM"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlshomemodifier"] = 0; };

/**
 * [SHIFT] + [END]
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleftmodifier
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["onlsendmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsendmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyCtrlAsModifier"](oBrowserEvent)) {
		this["handleArrowNavigation"](oBrowserEvent, this["NAVIGATION"]["MOVE_TO_LAST_ITEM"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["onlsendmodifier"] = 0; };

/**
 * Handle keyboard seletion for ARROWS & HOME and END
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {number} eOperation
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["handleArrowNavigation"] = function(oBrowserEvent, eOperation) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["handleArrowNavigation"]++; }; 

	/** @type {number} */
	var iTopLeftX = -1;
	/** @type {number} */
	var iTopLeftY = -1;

	/** @type {number} */
	var iBottomRightX = -1;
	/** @type {number} */
	var iBottomRightY = -1;
	/**@type {boolean} */
	var bScrollBack = false;
	/**@type {boolean} */
	var bScrollForward = false;

	/**@type {boolean} */
	var bDoNothing = false;

	var oCurrentPosition = this["oManager"]["oGetItemPosition"](this["oAbapList"]["oGetLastFocusedItem"]()); //??

	iTopLeftX = oCurrentPosition["TopLeftX"];
	iTopLeftY = oCurrentPosition["TopLeftY"];

	iBottomRightX = oCurrentPosition["BottomRightX"];
	iBottomRightY = oCurrentPosition["BottomRightY"];

	this["parseItems"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListKeyboardNavigationDelegate.js(178): handleArrowNavigation"); };

	switch (eOperation) {
		case this["NAVIGATION"]["MOVE_COLUMN_TO_LEFT"]: // [ARROW LEFT]
			iTopLeftX = iTopLeftX - 1;
			break;
		case this["NAVIGATION"]["MOVE_COLUMN_TO_RIGHT"]: // [ARROW RIGHT]
			iTopLeftX = iBottomRightX + 1;
			break;
		case this["NAVIGATION"]["MOVE_ROW_DOWN"]: // [ARROW DOWN]
			bScrollForward = (iTopLeftY === this["iGetLastVisibleLinePosition"]());
			if (iBottomRightY === this["iNoOfRows"])
				bDoNothing = true;
			else if (iBottomRightY < this["iNoOfRows"]) {
				iBottomRightY++;
				iTopLeftY++;

				while (iBottomRightY < this["iNoOfRows"] && !this["bHasFocusableItemsOnLine"](iTopLeftY)) {
					iBottomRightY++;
					iTopLeftY++;
				}
			}
			break;
		case this["NAVIGATION"]["MOVE_ROW_UP"]: //[ARROW UP]
			bScrollBack = (iTopLeftY === this["iGetFirstVisibleLinePosition"]());
			if (iTopLeftY === this["iFirstRow"])
				bDoNothing = true;
			else if (iTopLeftY > this["iFirstRow"]) {
				iTopLeftY--;
				while (iTopLeftY > this["iFirstRow"] && !this["bHasFocusableItemsOnLine"](iTopLeftY)) {
					iTopLeftY--;
				}
			}
			break;
		case this["NAVIGATION"]["MOVE_TO_FIRST_COLUMN"]: // [HOME]
			iTopLeftX = this["iFirstColumn"];
			break;
		case this["NAVIGATION"]["MOVE_TO_LAST_COLUMN"]: // [END]
			iTopLeftX = this["iNoOfColumns"];
			break;
		case this["NAVIGATION"]["MOVE_TO_FIRST_ITEM"]: // [CTRL] + [HOME]
			iTopLeftX = this["iFirstColumn"];
			break;
		case this["NAVIGATION"]["MOVE_TO_LAST_ITEM"]: // [CTRL] + [END]
			iTopLeftX = this["iNoOfColumns"];
			break;
		default:
			break;
	}

	// Sent AbapList:Scroll Event
	if (bScrollBack && this["oAbapList"]["oGetScrollBackDomRef"]()) {
		UCF_DomUtil["bDomElementFocused"](this["oAbapList"]["oGetScrollBackDomRef"]());
	}
	if (!bDoNothing) {
		var oItem = this["oGetItemFromPosition"](iTopLeftX, iTopLeftY, eOperation);
		if (oItem["oDomRef"] === UCF_DomUtil["oGetActiveElement"]()) {
			// CSN 2180326228: if item gets "refocused", we have to run through focus
			// mechanism again (for editable AbapListText, which deselects before
			// bubbling lsleft/lsright events and has to be selected again)
			UCF_DomUtil["moveFocusDomElement"](document["body"]);
		}
		// Set the Focus and BlockSelection
		this["oManager"]["setNewFocusedItem"](oItem, true, true);
		this["oManager"]["removeCharFocus"]();

	}
	if (bScrollForward && this["oAbapList"]["oGetScrollForwardDomRef"]()) {
		this["oAbapList"]["setTabIndexForItem"](oItem, true);
		UCF_DomUtil["bDomElementFocused"](this["oAbapList"]["oGetScrollForwardDomRef"]());
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["handleArrowNavigation"] = 0; };

/** @private Parses all items in order to create a flat list of characters */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["parseItems"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["parseItems"]++; }; 

	/** @type {Object} */
	var oBoundaries;
	if (this["mRasterMatrix"]) return;

	if (this["mRasterMatrix"] == null) {
		this["mRasterMatrix"] = this["oManager"]["oGetAllAbapListItems"]();
		oBoundaries = this["oManager"]["oGetAbapListBoundaries"]();
		if (oBoundaries) {
			this["iFirstColumn"] = oBoundaries["TopLeftX"];
			this["iFirstRow"] = oBoundaries["TopLeftY"];
			this["iNoOfColumns"] = oBoundaries["BottomRightX"];
			this["iNoOfRows"] = oBoundaries["BottomRightY"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["parseItems"] = 0; };

/**
 *
 * @return {int} - returns the first line which have navigable items
 */

UCF_AbapListKeyboardNavigationDelegate["prototype"]["iGetLastVisibleLinePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["iGetLastVisibleLinePosition"]++; }; 

	/** @type {int} */
	var iFirstPosition = -1;
	/** @type {Array} */
	var oLine;

	if (this["mRasterMatrix"] == null) {
		this["parseItems"]();
	}
	for (var i = this["mRasterMatrix"]["length"] - 1; i >= 0; i--) {
		oLine = this["mRasterMatrix"][i];
		if (oLine["length"] > 0) {
			iFirstPosition = i;
			break;
		}
	}
	return iFirstPosition;

};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["iGetLastVisibleLinePosition"] = 0; };

/**
 * @param {int} iY
 * @return {boolean} - return the Object
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["bHasFocusableItemsOnLine"] = function(iY) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["bHasFocusableItemsOnLine"]++; }; 
	this["parseItems"]();
	return this["mRasterMatrix"][iY] && this["mRasterMatrix"][iY]["length"] > 0;
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["bHasFocusableItemsOnLine"] = 0; };

/**
 *
 * @return {int} - returns the first line which have navigable items
 */

UCF_AbapListKeyboardNavigationDelegate["prototype"]["iGetFirstVisibleLinePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["iGetFirstVisibleLinePosition"]++; }; 

	/** @type {int} */
	var iFirstPosition = -1;
	/** @type {Array} */
	var oLine;

	if (this["mRasterMatrix"] == null) {
		this["parseItems"]();
	}
	for (var i = 0; i < this["mRasterMatrix"]["length"]; i++) {
		oLine = this["mRasterMatrix"][i];
		if (oLine && oLine["length"] > 0) {
			iFirstPosition = i;
			break;
		}
	}
	return iFirstPosition;

};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["iGetFirstVisibleLinePosition"] = 0; };

/**
 * @param {int} iX
 * @param {int} iY
 * @param {number} eOperation
 * @return {Object} - return the Object
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["oGetItemFromPosition"] = function(iX, iY, eOperation) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["oGetItemFromPosition"]++; }; 

	/** @type {UCF_AbapListItem} */
	var oItem = null;

	if (this["mRasterMatrix"] == null) {
		this["parseItems"]();
	}

	var oLine = this["mRasterMatrix"][iY];
	if (!oLine) return this["oAbapList"]["oGetLastFocusedItem"]();
	while (oLine && oLine["length"] === 0) {
		iY++;
		oLine = this["mRasterMatrix"][iY];
	}
	// if no line has been found, just set the latest focused item
	if (!oLine) return this["oAbapList"]["oGetLastFocusedItem"]();

	if (eOperation === this["NAVIGATION"]["MOVE_TO_FIRST_ITEM"]) {
		oLine = this["mRasterMatrix"][this["iGetFirstVisibleLinePosition"]()];
		if (oLine)
			oItem = oLine[0];
	} else if (eOperation === this["NAVIGATION"]["MOVE_TO_LAST_ITEM"]) {
		oLine = this["mRasterMatrix"][this["iGetLastVisibleLinePosition"]()];
		if (oLine)
			oItem = oLine[oLine["length"] - 1];
	} else if (eOperation === this["NAVIGATION"]["MOVE_TO_FIRST_COLUMN"]) {
		// gets the first item
		oItem = oLine[0];
	} else if (eOperation === this["NAVIGATION"]["MOVE_TO_LAST_COLUMN"]) {
		// it should return the last item
		oItem = oLine[oLine["length"] - 1];
	} else if (oLine["length"] === 1) {
		oItem = oLine[0];
	} else if (eOperation === this["NAVIGATION"]["MOVE_COLUMN_TO_RIGHT"] || eOperation === this["NAVIGATION"]["MOVE_COLUMN_TO_LEFT"]) {
		oItem = this["oGetHorizontalNavigationItem"](oLine, eOperation);
	} else {
		oItem = this["oGetVerticalNavigationItem"](oLine, iX, iY, eOperation);
	}
	this["updateNavigationHistory"](oItem);
	return oItem;
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["oGetItemFromPosition"] = 0; };

/**
 * Handles the Keyboard navigation usinf [LEFT] /[RIGHT] key
 *
 * @param {Array} oLine
 * @param { number } eOperation
 * @return {UCF_Control} oItem
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["oGetHorizontalNavigationItem"] = function(oLine, eOperation) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["oGetHorizontalNavigationItem"]++; }; 
	/** @type {AbapListItem} */
	var oItem;
	/** @type {int} */
	var iCurrentPosition = -1;
	/** @type {AbapListItem} */
	var oCurrentItem = this["oAbapList"]["oGetLastFocusedItem"]();
	/** @type {int} */
	var bCurrentFocusable;
	/** @type {int} */
	var i;
	/** @type {int} */
	var iPosition;

	bCurrentFocusable = this["oManager"]["bIsNavigable"](oCurrentItem);
	// LEFT on the first item, should stay on the first item
	if (eOperation === this["NAVIGATION"]["MOVE_COLUMN_TO_LEFT"] && oCurrentItem === oLine[0]) {
		return oLine[0];
	}
	// RIGHT on the last item should stay on the last item
	if (eOperation === this["NAVIGATION"]["MOVE_COLUMN_TO_RIGHT"] && oCurrentItem === oLine[oLine["length"] - 1]) {
		return oLine[oLine["length"] - 1];
	}

	// search the current position on the line
	//it might be that the item is not focusableb because it AbapListText empty or is not an AbapListText
	if (eOperation === this["NAVIGATION"]["MOVE_COLUMN_TO_RIGHT"]) {
		for (i = 0; i < oLine["length"]; i++) {
			iCurrentPosition = i;
			if ((bCurrentFocusable && oLine[i] === oCurrentItem) ||
				(!bCurrentFocusable && oCurrentItem["iGetLeft"]() < oLine[i]["iGetLeft"]())) {
				break;
			}
		}
	}

	if (eOperation === this["NAVIGATION"]["MOVE_COLUMN_TO_LEFT"]) {
		for (i = oLine["length"] - 1; i >= 0; i--) {
			iCurrentPosition = i;
			if ((bCurrentFocusable && oLine[i] === oCurrentItem) ||
				(!bCurrentFocusable && oCurrentItem["iGetLeft"]() >= oLine[i]["iGetLeft"]())) {
				break;
			}
		}
	}

	if (eOperation === this["NAVIGATION"]["MOVE_COLUMN_TO_LEFT"] && iCurrentPosition >= 0) {
		iPosition = bCurrentFocusable ? iCurrentPosition - 1 : iCurrentPosition;
		if (iPosition < 0) {
			iPosition = 0;
		}
		oItem = oLine[iPosition];
	}

	if (eOperation === this["NAVIGATION"]["MOVE_COLUMN_TO_RIGHT"] && iCurrentPosition <= (oLine["length"] - 1)) {
		iPosition = bCurrentFocusable ? iCurrentPosition + 1 : iCurrentPosition;
		if (iPosition > (oLine["length"] - 1)) {
			iPosition = oLine["length"] - 1;
		}
		oItem = oLine[iPosition];
	}

	return oItem;
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["oGetHorizontalNavigationItem"] = 0; };

/**
 * @param {Array} oLine
 * @param {int} iLeftPosition
 * @param {int} iTopPosition
 * @param {number} eOperation
 * @return {UCF_Control} oItem
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["oGetVerticalNavigationItem"] = function(oLine, iLeftPosition, iTopPosition, eOperation) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["oGetVerticalNavigationItem"]++; }; 
	var oItem,
		oPreviousItem = null,
		oCurrentItem = this["oAbapList"]["oGetLastFocusedItem"](),
		iCurrentItemLastPosition = oCurrentItem["iGetLeft"]() + oCurrentItem["iGetWidth"](),
		iCurrentLine = iTopPosition,
		oCurrentLine, oNextItem;
	var bCurrentItemHasText = this["oManager"]["bIsEmptyAbapListText"](oCurrentItem);

	if (oLine) {
		for (var i = 0; i < oLine["length"]; i++) {
			oItem = oLine[i];
			// perfect match
			if (iLeftPosition === oItem["iGetLeft"]() && (oItem["iGetLeft"]() + oItem["iGetWidth"]() === iCurrentItemLastPosition))
				break;
			// if the item with the same left position is empty, take the next one
			if (iLeftPosition === oItem["iGetLeft"]()) {
				if (this["oManager"]["bIsEmptyAbapListText"](oItem) && !bCurrentItemHasText && i < (oLine["length"] - 1)) {
					oItem = oLine[i + 1];
				}
				break;
			}
			// check if the next item has the same end position	like the current item
			if (oItem["iGetLeft"]() < iLeftPosition && iLeftPosition < (oItem["iGetLeft"]() + oItem["iGetWidth"]())) {
				if (i < (oLine["length"] - 1)) {
					oNextItem = oLine[i + 1];
					if (!this["oManager"]["bIsEmptyAbapListText"](oNextItem) && (oNextItem["iGetLeft"]() + oNextItem["iGetWidth"]()) === iCurrentItemLastPosition)
						oItem = oNextItem;
				}
				break;
			}

			if (iLeftPosition < oItem["iGetLeft"]()) {
				if (oPreviousItem != null && oPreviousItem !== oCurrentItem)
					oItem = oPreviousItem;
				break;
			}
			oPreviousItem = oItem;
		}

		if (oCurrentItem === oItem)
			oItem = oPreviousItem;
	}

	if (!oItem || (oItem && !this["oManager"]["bIsAbapListItem"](oItem))) {
		//Nothimg found, just look to the next/previous line
		if (eOperation === this["NAVIGATION"]["MOVE_ROW_DOWN"]) {
			iCurrentLine++;
			oCurrentLine = this["mRasterMatrix"][iCurrentLine];
			while (iCurrentLine < (this["mRasterMatrix"]["length"] - 1) && !oCurrentLine) {
				iCurrentLine++;
				oCurrentLine = this["mRasterMatrix"][iCurrentLine];
			}
			if (oCurrentLine)
				oItem = this["oGetVerticalNavigationItem"](oCurrentLine, iLeftPosition, iCurrentLine, eOperation);
		} else if (eOperation === this["NAVIGATION"]["MOVE_ROW_UP"]) {
			iCurrentLine--;
			oCurrentLine = this["mRasterMatrix"][iCurrentLine];
			while (iCurrentLine > 0 && !oCurrentLine) {
				iCurrentLine--;
				oCurrentLine = this["mRasterMatrix"][iCurrentLine];
			}
			if (oCurrentLine)
				oItem = this["oGetVerticalNavigationItem"](oCurrentLine, iLeftPosition, iCurrentLine, eOperation);
		}

	}

	if (!oItem && (iTopPosition === 0 || iTopPosition === (this["mRasterMatrix"]["length"] - 1))) {
		oItem = this["oAbapList"]["oGetLastFocusedItem"]();
	}

	return oItem;
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["oGetVerticalNavigationItem"] = 0; };

/**
 * @param {UCF_Control} oItem
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["updateNavigationHistory"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["updateNavigationHistory"]++; }; 
	var oFoundItem;

	if (!oItem) return;
	if (this["oNavigationHistory"] === null) {
		this["resetNavigationHistory"]();
	}
	if (this["oNavigationHistory"]["length"] === 0) {
		this["oNavigationHistory"]["push"]({ "LeftPosition": oItem["iGetLeft"](), "Count": 1 });
	} else {
		oFoundItem = UCF_JsUtil["find"](this["oNavigationHistory"],
			function(item) { return item["LeftPosition"] === oItem["iGetLeft"](); }
		);
		if (oFoundItem) {
			oFoundItem["Count"] = oFoundItem["Count"] + 1;
		} else {
			this["oNavigationHistory"]["push"]({ "LeftPosition": oItem["iGetLeft"](), "Count": 1 });
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["updateNavigationHistory"] = 0; };

/**
 * resets the Navigation History
 */
UCF_AbapListKeyboardNavigationDelegate["prototype"]["resetNavigationHistory"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["resetNavigationHistory"]++; }; 
	this["oNavigationHistory"] = [];
};;if (__UCF_COVERAGE__) { UCF_AbapListKeyboardNavigationDelegate["_"]["resetNavigationHistory"] = 0; };

};
sap["ls"]["preload"]["UCF_AbapListScrollDelegate"] = function() {/* global UCF_EventProvider */
/// <reference path="../../../core/EventProvider.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_ScrollArea */
/// <reference path="../base/ScrollArea.js"/>

/** @typedef {0} UCF_AbapListScrollDelegate_HorizontalAxis */
/** @typedef {1} UCF_AbapListScrollDelegate_VerticalAxis */
/** @typedef {UCF_AbapListScrollDelegate_HorizontalAxis|UCF_AbapListScrollDelegate_VerticalAxis} UCF_AbapListScrollDelegate_Axis */
/**
 * @typedef {Object} UCF_AbapListScrollDelegate_AxisEnum
 * @property {UCF_AbapListScrollDelegate_HorizontalAxis} Horizontal
 * @property {UCF_AbapListScrollDelegate_VerticalAxis} Vertical
 */

/**
 * Wraps a UCF_Scrollbar for server-side scrolling of the AbapList.
 * Unfortunately, the AbapListProcessor backend is indexed 0-based whereas the
 * UCF_Scrollbar is indexed 1-based.
 *
 * @constructor
 * @param {UCF_AbapList} oAL
 * @param {UCF_AbapListScrollDelegate_Axis} eAxis
 */
function UCF_AbapListScrollDelegate(oAL, eAxis) {if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["UCF_AbapListScrollDelegate"]++; }; 
	if (arguments["length"] > 0) {
		this["defineEvents"](['Scroll']);

		/** @type {UCF_AbapList} */
		this["oAL"] = oAL;
		/** @type {UCF_Scrollbar} */
		this["oSCB"] = null;
		/** @type {number} */
		this["iFirstVisible"] = null;
		/** @type {number} */
		this["iVisible"] = null;
		/** @type {number} */
		this["iCount"] = null;
		/** @type {UCF_AbapListScrollDelegate_Axis} */
		this["eAxis"] = eAxis;

		switch (eAxis) {
			case UCF_AbapListScrollDelegate["E_AXIS"]["Horizontal"]:
				this["oSCB"] = this["oAL"]["oGetControlById"](this["oAL"]["sId"] + '-scrollH');
				this["iFirstVisible"] = this["oAL"]["iFirstVisibleColumn"];
				this["iVisible"] = this["oAL"]["iVisibleColumnCount"];
				this["iCount"] = this["oAL"]["iColumnCount"];
				break;
			case UCF_AbapListScrollDelegate["E_AXIS"]["Vertical"]:
				this["oSCB"] = this["oAL"]["oGetControlById"](this["oAL"]["sId"] + '-scrollV');
				this["iFirstVisible"] = this["oAL"]["iFirstVisibleLine"];
				this["iVisible"] = this["oAL"]["iVisibleLineCount"];
				this["iCount"] = this["oAL"]["iLineCount"];
				break;
		}

		if (this["oSCB"]) {
			this["oSCB"]["iLargeChange"] = this["iVisible"];
			this["oSCB"]["attachEvent"](this["oSCB"]["E_EVENTS"]["Scroll"], this, 'onScroll');
		}
	}
};window["UCF_AbapListScrollDelegate"] = UCF_AbapListScrollDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListScrollDelegate"); UCF_AbapListScrollDelegate["_"] = {UCF_AbapListScrollDelegate: 0}; }; ;
UCF_AbapListScrollDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_AbapListScrollDelegate.prototype["sClassName"] = "UCF_AbapListScrollDelegate";

/** @type {UCF_AbapListScrollDelegate_AxisEnum} */
UCF_AbapListScrollDelegate["E_AXIS"] = {
	"Horizontal": 0,
	"Vertical": 1
};

/**
 * @private
 * @static
 * @param {number} iMin
 * @param {number} iActual
 * @param {number} iMax
 * @return {number}
 */
UCF_AbapListScrollDelegate["iClamp"] = function(iMin, iActual, iMax) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["iClamp"]++; }; 
	return Math["min"](Math["max"](iMin, iActual), iMax);
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["iClamp"] = 0; };

/** @override */
UCF_AbapListScrollDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["destroy"]++; }; 
	UCF_JsUtil["resetMassNotificationFilter"](UCF_AbapListScrollDelegate);
	this["eAxis"] = null;
	this["iCount"] = null;
	this["iVisible"] = null;
	this["iFirstVisible"] = null;
	if (this["oSCB"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oSCB"]);
		this["oSCB"] = null;
	}
	this["oAL"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["destroy"] = 0; };

/** @param {UCF_BrowserEvent} oBrowserEvent */
UCF_AbapListScrollDelegate["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlsfocus"]++; }; 
	/** @type {HTMLElement} */
	var oSource;
	/** @type {string} */
	var sSourceId;
	/** @type {HTMLElement} */
	var oFocusTo;

	if (this["oSCB"] && this["eAxis"] === UCF_AbapListScrollDelegate["E_AXIS"]["Vertical"]) {
		oSource = oBrowserEvent["oGetSource"]();
		sSourceId = oSource ? oSource["id"] : '';

		if (
			oSource !== this["oAL"]["oDomRef"] &&
			UCF_StringUtil["bContains"](sSourceId, '-scroll')
		) {
			if (UCF_StringUtil["bContains"](sSourceId, '-scrollBack')) {
				oFocusTo = UCF_StringUtil["bContains"](sSourceId, '-inner')
					? this["bScrollTo"](this["iFirstVisible"] - 1)
					? UCF_DomUtil["oGetTabbableElementForward"](UCF_DomUtil["nextSibling"](UCF_DomUtil["$"](this["oAL"]["sId"] + '-scrollBack')), true)
					: UCF_DomUtil["oGetTabbableElementBackward"](UCF_DomUtil["oGetPreviousSibling"](this["oAL"]["oDomRef"], true), true)
					: UCF_DomUtil["oGetTabbableElementForward"](UCF_DomUtil["nextSibling"](UCF_DomUtil["$"](this["oAL"]["sId"] + '-scrollBack')), true);
			} else if (UCF_StringUtil["bContains"](sSourceId, '-scrollForward')) {
				if (this["oAL"]["oGetBlockSelectionDelegate"]() && this["oAL"]["oGetLastFocusedItem"]()) {
					UCF_DomUtil["setTabIndex"](this["oAL"]["oGetLastFocusedItem"]()["oDomRef"], 0);
				}
				oFocusTo = UCF_StringUtil["bContains"](sSourceId, '-inner')
					? UCF_DomUtil["oGetTabbableElementBackward"](UCF_DomUtil["previousSibling"](UCF_DomUtil["$"](this["oAL"]["sId"] + '-scrollForward')), true)
					: this["bScrollTo"](this["iFirstVisible"] + 1)
					? UCF_DomUtil["oGetTabbableElementBackward"](UCF_DomUtil["previousSibling"](UCF_DomUtil["$"](this["oAL"]["sId"] + '-scrollForward')), true)
					: UCF_DomUtil["oGetTabbableElementForward"](UCF_DomUtil["oGetNextSibling"](this["oAL"]["oDomRef"], true), true);
			}

			if (oFocusTo) {
				UCF_DomUtil["focusDomElement"](oFocusTo);
			} else {
				this["oAL"]["oLS"]["focusEnd"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlsfocus"] = 0; };

/** */
UCF_AbapListScrollDelegate["prototype"]["onlspageup"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlspageup"]++; }; 
	if (this["eAxis"] === UCF_AbapListScrollDelegate["E_AXIS"]["Vertical"]) {
		this["bPageUp"]();
		this["oAL"]["firePageUp"](this["oAL"]["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlspageup"] = 0; };

/** */
UCF_AbapListScrollDelegate["prototype"]["onlspagedown"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlspagedown"]++; }; 
	if (this["eAxis"] === UCF_AbapListScrollDelegate["E_AXIS"]["Vertical"]) {
		this["bPageDown"]();
		this["oAL"]["firePageDown"](this["oAL"]["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlspagedown"] = 0; };

/** @param {UCF_BrowserEvent} oBrowserEvent */
UCF_AbapListScrollDelegate["prototype"]["onlspageupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlspageupmodifier"]++; }; 
	if (
		this["eAxis"] === UCF_AbapListScrollDelegate["E_AXIS"]["Horizontal"] &&
		UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent)
	) {
		this["bPageUp"]();
		this["oAL"]["firePageLeft"](this["oAL"]["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlspageupmodifier"] = 0; };

/** @param {UCF_BrowserEvent} oBrowserEvent */
UCF_AbapListScrollDelegate["prototype"]["onlspagedownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlspagedownmodifier"]++; }; 
	if (
		this["eAxis"] === UCF_AbapListScrollDelegate["E_AXIS"]["Horizontal"] &&
		UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent)
	) {
		this["bPageDown"]();
		this["oAL"]["firePageRight"](this["oAL"]["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlspagedownmodifier"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_AbapListScrollDelegate["prototype"]["onlsmousewheel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlsmousewheel"]++; }; 
	var iDeltaX = oBrowserEvent["oDomEvent"]["deltaX"] || 0;
	var iDeltaY = oBrowserEvent["oDomEvent"]["deltaY"] || 0;

	if (Math["abs"](iDeltaX) >= Math["abs"](iDeltaY)
		&& iDeltaX
		&& this["oSCB"]
		&& this["eAxis"] === UCF_AbapListScrollDelegate["E_AXIS"]["Horizontal"])
		return this["oSCB"]["onlsmousewheel"](oBrowserEvent);

	if (this["oSCB"] && this["eAxis"] === UCF_AbapListScrollDelegate["E_AXIS"]["Vertical"])
		return this["oSCB"]["onlsmousewheel"](oBrowserEvent);

	return true;
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlsmousewheel"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_AbapListScrollDelegate["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlstouchstart"]++; }; 
	UCF_DomUtil["addClass"](this["oAL"]["oDomRef"], 'lsAbapList--scroll-hover');

	return this["oSCB"] && this["oSCB"]["onlstouchstart"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlstouchstart"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_AbapListScrollDelegate["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlstouchend"]++; }; 
	UCF_DomUtil["removeClass"](this["oAL"]["oDomRef"], 'lsAbapList--scroll-hover');

	return this["oSCB"] && this["oSCB"]["onlstouchend"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onlstouchend"] = 0; };

/**
 * UCF_ScrollArea.disconnectAndDestroyScrollArea calls detachBrowserEvent()
 * @param {string} sName
 * @param {HTMLElement} oDomRef
 */
UCF_AbapListScrollDelegate["prototype"]["detachBrowserEvent"] = function(sName, oDomRef) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["detachBrowserEvent"]++; }; 
	this["oAL"]["oLS"]["oBrowserWindow"]["detachBrowserEvent"](sName, oDomRef);
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["detachBrowserEvent"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_AbapListScrollDelegate["prototype"]["bPageUp"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["bPageUp"]++; }; 
	return this["bScrollTo"](this["iFirstVisible"] - this["iVisible"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["bPageUp"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_AbapListScrollDelegate["prototype"]["bPageDown"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["bPageDown"]++; }; 
	return this["bScrollTo"](this["iFirstVisible"] + this["iVisible"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["bPageDown"] = 0; };

/** @param {UCF_Event<{iFirstVisibleItem: number}>} oScroll */
UCF_AbapListScrollDelegate["prototype"]["onScroll"] = function(oScroll) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onScroll"]++; }; 
	this["setFirstVisible"](this["iScrollbarIndexToIndex"](
		oScroll["oGetParam"]('iFirstVisibleItem')
	));
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["onScroll"] = 0; };

/**
 * @private
 * @param {number} iZeroBasedIndex
 * @return {boolean}
 */
UCF_AbapListScrollDelegate["prototype"]["bScrollTo"] = function(iZeroBasedIndex) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["bScrollTo"]++; }; 
	/** @type {number} */
	var iAL;
	/** @type {number} */
	var iBefore;

	if (this["oSCB"]) {
		iAL = UCF_AbapListScrollDelegate["iClamp"](0, iZeroBasedIndex, this["iCount"]);
		iBefore = this["oSCB"]["iGetFirstVisibleItem"]();

		this["oSCB"]["scrollToPosition"](this["iIndexToScrollbarIndex"](iAL));

		return this["oSCB"]["iGetFirstVisibleItem"]() !== iBefore;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["bScrollTo"] = 0; };

/**
 * @private
 * @param {number} iZeroBasedIndex
 * @return {number}
 */
UCF_AbapListScrollDelegate["prototype"]["iIndexToScrollbarIndex"] = function(iZeroBasedIndex) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["iIndexToScrollbarIndex"]++; }; 
	return this["oAL"]["oLS"]["oGetRenderManager"]()["callFragment"](
		'AbapListIndexToScrollbarIndex',
		'AbapList', { "Index": iZeroBasedIndex }
	);
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["iIndexToScrollbarIndex"] = 0; };

/**
 * @private
 * @param {number} iOneBasedIndex
 * @return {number}
 */
UCF_AbapListScrollDelegate["prototype"]["iScrollbarIndexToIndex"] = function(iOneBasedIndex) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["iScrollbarIndexToIndex"]++; }; 
	return this["oAL"]["oLS"]["oGetRenderManager"]()["callFragment"](
		'AbapListScrollbarIndexToIndex',
		'AbapList', { "Index": iOneBasedIndex }
	);
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["iScrollbarIndexToIndex"] = 0; };

/**
 * @private
 * @param {number} iFirstVisible
 */
UCF_AbapListScrollDelegate["prototype"]["setFirstVisible"] = function(iFirstVisible) {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["setFirstVisible"]++; }; 
	this["iFirstVisible"] = iFirstVisible;

	switch (this["eAxis"]) {
		case UCF_AbapListScrollDelegate["E_AXIS"]["Horizontal"]:
			this["oAL"]["iFirstVisibleColumn"] = this["iFirstVisible"];
			this["oAL"]["setClientProperty"]('FirstVisibleColumn', this["iFirstVisible"], true);
			break;
		case UCF_AbapListScrollDelegate["E_AXIS"]["Vertical"]:
			this["oAL"]["iFirstVisibleLine"] = this["iFirstVisible"];
			this["oAL"]["setClientProperty"]('FirstVisibleLine', this["iFirstVisible"], true);
			break;
	}

	UCF_JsUtil["feedMassNotificationFilter"](0, UCF_AbapListScrollDelegate, this, 'fireScroll');
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["setFirstVisible"] = 0; };

/** */
UCF_AbapListScrollDelegate["prototype"]["fireScroll"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["fireScroll"]++; }; 
	this["oAL"]["fireScroll"](
		this["oAL"]["sId"],
		this["oAL"]["iFirstVisibleLine"],
		this["oAL"]["iFirstVisibleColumn"],
		// sScrollTriggerId has never been set to anything else than '' in
		// AbapList.js (although there was plenty of logic to set it to anything)
		// => ignoring it here and simply hard-setting it to ''
		''
	);
};;if (__UCF_COVERAGE__) { UCF_AbapListScrollDelegate["_"]["fireScroll"] = 0; };

};
sap["ls"]["preload"]["UCF_AbapListTabActor"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_AbapListItem */
/// <reference path="./AbapListItem.js"/>

/** @class
 * Use the AbapListTabActor control to define an action which is executed
 * when the actor is tabbed
 *
 * <br>
 * <b>Java Control references</b><br>
 * <a href="../javadoc/com/sap/tc/ls/api/controls/LSbapListTabActor.html">LSbapListTabActor</a>
 *
 * 
 *
 * @version
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_AbapListTabActor(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_AbapListTabActor["_"]["UCF_AbapListTabActor"]++; }; 
	if (arguments["length"] === 0) { return; }

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "AbapListTabActor.js(27): UCF_AbapListTabActor"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "AbapListTabActor.js(28): UCF_AbapListTabActor"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "AbapListTabActor.js(29): UCF_AbapListTabActor"); };

	UCF_AbapListItem["apply"](this, [oDomRef, oLS]);
};window["UCF_AbapListTabActor"] = UCF_AbapListTabActor; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListTabActor"); UCF_AbapListTabActor["_"] = {UCF_AbapListTabActor: 0}; }; ;
UCF_AbapListTabActor["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_AbapListItem"))(); UCF_AbapListTabActor.prototype["sClassName"] = "UCF_AbapListTabActor";

/**
 * @see UCF_AbapListItem
 */

UCF_AbapListTabActor["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListTabActor["_"]["onlsfocus"]++; }; 
	var oSource = oBrowserEvent["oGetSource"](),
		bForward = oSource === this["oDomRef"],
		oControlToFocus = null,
		iScrollToLine = -1,
		iScrollToColumn = -1,
		bDoTabNotification = (bForward && this["bDoForwardNotification"])
		|| (!bForward && this["bDoBackwardNotification"]),
		oList = this["oGetList"]();

	// When the TabActor is focused it notifies the application about that so
	// that it can adapt the scroll position and
	// render the new screen output. E.g. when nesting the TabActor
	// at the end of a line a vertical scrolling can be achieved
	// when the user is tabbing through the Screen

	// Scrolling Preparation
	iScrollToLine = bForward ? this["iForwardScrollToLine"] : this["iBackwardScrollToLine"];
	iScrollToColumn = bForward ? this["iForwardScrollToColumn"] : this["iBackwardScrollToColumn"];

	// Calculated the next control to focus
	if (this["sForwardFocusId"] && bForward || this["sBackwardFocusId"] && !bForward) {
		// Redirect to defined control?
		oControlToFocus = this["oGetControlById"](bForward ? this["sForwardFocusId"] : this["sBackwardFocusId"]);
	} else {
		// eslint-disable-next-line no-lonely-if
		if (iScrollToLine !== -1 || iScrollToColumn !== -1 || bDoTabNotification) {
			// Keep focus on the last focused control
			oControlToFocus = oList["oGetLastFocusedItem"]();
		} else { // Move focus to the next tabable element
			var oFocusTo = null;

			if (bForward) {
				var oNext = UCF_DomUtil["oGetNextSibling"](this["oDomRef"], true);

				if (oNext) {
					oFocusTo = UCF_DomUtil["oGetTabbableElementForward"](oNext, true);
				}
			} else {
				var oPrevious = UCF_DomUtil["oGetPreviousSibling"](this["oDomRef"], true);

				if (oPrevious) {
					oFocusTo = UCF_DomUtil["oGetTabbableElementBackward"](oPrevious, true);
				}
			}

			if (oFocusTo) {
				UCF_DomUtil["focusDomElement"](oFocusTo);
			} else {
				this["oLS"]["focusEnd"]();
			}
		}
	}

	if (oControlToFocus) { oControlToFocus["focus"](); }

	// Notify the application about an tab on the TabActor
	if (bDoTabNotification) {
		oList["fireTabNotify"](oList["sId"], this["sId"], bForward);
	}

	// Automatically initate a scrolling when the TabActor has
	// the necessary data maintained
	// This would result in a scoll event
	if (iScrollToLine !== -1 || iScrollToColumn !== -1) {
		oList["scrollToPosition"](iScrollToLine, iScrollToColumn, this["sId"]);
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListTabActor["_"]["onlsfocus"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_AbapListTabActor["prototype"]["aAttributeNames"] = ["sForwardFocusId","iForwardScrollToLine","iForwardScrollToColumn","bDoForwardNotification","sBackwardFocusId","iBackwardScrollToLine","iBackwardScrollToColumn","bDoBackwardNotification","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_AbapListTabActor["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_AbapListTabActor["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_AbapListTabActor["prototype"]["sForwardFocusId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_AbapListTabActor["prototype"]["iForwardScrollToLine"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_AbapListTabActor["prototype"]["iForwardScrollToColumn"] = -1;

/**
 * @private
 * @type {boolean}
 */
UCF_AbapListTabActor["prototype"]["bDoForwardNotification"] = false;

/**
 * @private
 * @type {string}
 */
UCF_AbapListTabActor["prototype"]["sBackwardFocusId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_AbapListTabActor["prototype"]["iBackwardScrollToLine"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_AbapListTabActor["prototype"]["iBackwardScrollToColumn"] = -1;

/**
 * @private
 * @type {boolean}
 */
UCF_AbapListTabActor["prototype"]["bDoBackwardNotification"] = false;

/**
 * @private
 * @type {string}
 */
UCF_AbapListTabActor["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_AbapListTabActor["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListTabActor["_"]["setDefaultValues"]++; }; 
	this["sForwardFocusId"] = '';
	this["iForwardScrollToLine"] = -1;
	this["iForwardScrollToColumn"] = -1;
	this["bDoForwardNotification"] = false;
	this["sBackwardFocusId"] = '';
	this["iBackwardScrollToLine"] = -1;
	this["iBackwardScrollToColumn"] = -1;
	this["bDoBackwardNotification"] = false;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("ForwardFocusId", '', true);
		this["setClientProperty"]("ForwardScrollToLine", -1, true);
		this["setClientProperty"]("ForwardScrollToColumn", -1, true);
		this["setClientProperty"]("DoForwardNotification", false, true);
		this["setClientProperty"]("BackwardFocusId", '', true);
		this["setClientProperty"]("BackwardScrollToLine", -1, true);
		this["setClientProperty"]("BackwardScrollToColumn", -1, true);
		this["setClientProperty"]("DoBackwardNotification", false, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTabActor["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_AbapListText"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_ClipboardUtil */
/// <reference path="../../core/util/ClipboardUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_AccessibilityHelper */
/// <reference path="../helper/AccessibilityHelper.js"/>
/* global UCF_AbapListItem */
/// <reference path="./AbapListItem.js"/>
/* global UCF_AbapListTextNavigationDelegate */
/// <reference path="./delegates/AbapListTextNavigationDelegate.js"/>
/**
 * A AbapListTextItem should display a text on a ABAP list and handle its
 * events.
 *
 * <br>
 * <b>Java Control references</b><br>
 * <a href='../javadoc/com/sap/tc/ls/api/controls/LSTextView.html'>LSTextView</a>
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_AbapListText(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["UCF_AbapListText"]++; }; 
	if (arguments["length"] === 0) { return; }

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "AbapListText.js(45): UCF_AbapListText"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "AbapListText.js(46): UCF_AbapListText"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "AbapListText.js(47): UCF_AbapListText"); };

	UCF_AbapListItem["apply"](this, [oDomRef, oLS]);

	this["allowTextSelection"]();

	/** @type {boolean} */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bReadOnly"] = this["oDomRef"]["nodeName"] === 'DIV';
	/** @type {string} */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sText"] = this["bReadOnly"] ? this["oDomRef"]["textContent"] : this["oDomRef"]["value"];
	/** @type {UCF_Cache} */
	this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
	this["oGetNavigationDelegate"]();
};window["UCF_AbapListText"] = UCF_AbapListText; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListText"); UCF_AbapListText["_"] = {UCF_AbapListText: 0}; }; ;
UCF_AbapListText["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_AbapListItem"))(); UCF_AbapListText.prototype["sClassName"] = "UCF_AbapListText";

/**
 * Returns the BlockSelectionDelegate
 * @return {UCF_AbapListTextNavigationDelegate}
 * @private
 */
UCF_AbapListText["prototype"]["oGetNavigationDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["oGetNavigationDelegate"]++; }; 

	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('oNavigationDelegate', function() {
		/** @type {UCF_AbapListTextNavigationDelegate} */
		var oDelegate;

		if (!self["bReadOnly"] && self["oGetList"]()["mEvents"]["BlockSelect"]) {
			oDelegate = new (UCF_ClassLoader["oGetClass"]("UCF_AbapListTextNavigationDelegate"))(self);
			self["addDelegate"](oDelegate, true);
			return oDelegate;
		} else {
			return null;
		}
	});
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["oGetNavigationDelegate"] = 0; };

/**
 * @see UCF_AbapListItem
 */

UCF_AbapListText["prototype"]["bIsSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["bIsSelectable"]++; }; 
	return this["bSelectable"];
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["bIsSelectable"] = 0; };

UCF_AbapListText["prototype"]["sGetText"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["sGetText"]++; }; 
	return this["sText"];
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["sGetText"] = 0; };

/**
 *
 * @return {string} the Text or the current text from Input
 */
UCF_AbapListText["prototype"]["sGetCurrentText"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["sGetCurrentText"]++; }; 
	if (this["bReadOnly"])
		return this["sText"];
	else
		return this["oDomRef"]["value"];
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["sGetCurrentText"] = 0; };

UCF_AbapListText["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["setText"]++; }; 
	if (this["bReadOnly"]) return;

	this["oDomRef"]["value"] = sText;
	this["sText"] = sText;
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["setText"] = 0; };

/**
 * Handles the lsenter event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_AbapListText["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListText.js(126): onlsenter"); };

	if (this["bHandleChange"]()) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["onlsenter"] = 0; };

/**
 * @see UCF_AbapListItem
 */

UCF_AbapListText["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["onlsblur"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListText.js(138): onlsblur"); };

	UCF_AbapListItem.prototype["onlsblur"]["call"](this, oBrowserEvent);
	if (this["bHandleChange"]()) { oBrowserEvent["cancelBubble"](); }

};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["onlsblur"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey
 */
UCF_AbapListText["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["onlshotkey"]++; }; 
	// todo: implement special treatment for table. Question is how to handle
	// ctrl+a. Suggestion is in navigation mode ctrl+a select the row but in
	// edit mode ctrl+a selects the text.
	if (this["bIsHotkeyHandledLocally"](oBrowserEvent)) {
		oBrowserEvent["cancelBubble"]();
	} else if (this["bHandleChange"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ================ HotKey is further bubbled; KeyCode: ' + oBrowserEvent["iKeyCode"](), "AbapListText.js(155): onlshotkey"); };
	} else
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' ================ HotKey is further bubbled; KeyCode: ' + oBrowserEvent["iKeyCode"](), "AbapListText.js(157): onlshotkey"); };

};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["onlshotkey"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey
 * @return {boolean} `true` if the hotkey is handled locally, otherwise `false`
 */
// eslint-disable-next-line complexity
UCF_AbapListText["prototype"]["bIsHotkeyHandledLocally"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["bIsHotkeyHandledLocally"]++; }; 
	var oNavigationDelegate = this["oGetNavigationDelegate"]();

	if (this["bReadOnly"])
		return (!oNavigationDelegate && (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["A"], 'C')
			|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["C"], 'C')));

	return UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["C"], 'C')
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["X"], 'C')
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["V"], 'C')
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["Z"], 'C')
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["Y"], 'C')
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["DELETE"])
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["INSERT"])
		//	|| (UCF_KeyboardHelper.bIsEventForKey(oBrowserEvent, UCF_KeyCodes.F2)
		|| (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["A"], 'C')
			&& !this["bReadOnly"] && (!oNavigationDelegate || (oNavigationDelegate && oNavigationDelegate["bIsEditMode"]())));
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["bIsHotkeyHandledLocally"] = 0; };

/**
 * @see UCF_AbapListItem
 */

UCF_AbapListText["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AbapListText.js(190): onlsselect"); };

	if (this["bReadOnly"]) {
		UCF_AbapListItem.prototype["onlsselect"]["call"](this, oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["onlsselect"] = 0; };

/**
 * @see UCF_AbapListItem
 */

UCF_AbapListText["prototype"]["bIsValidAccess"] = function(iKeyCode) {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["bIsValidAccess"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iKeyCode) === 'number', "typeof(iKeyCode) === 'number'", "AbapListText.js(202): bIsValidAccess"); };

	if (this["bReadOnly"]) {
		return UCF_AbapListItem.prototype["bIsValidAccess"]["call"](this, iKeyCode);
	} else {
		return iKeyCode ? true : false;
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["bIsValidAccess"] = 0; };

/**
 * @see UCF_AbapListItem
 */

UCF_AbapListText["prototype"]["bHandleAccess"] = function(iKeyCode, oSelectPosition) {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["bHandleAccess"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iKeyCode) === 'number', "typeof(iKeyCode) === 'number'", "AbapListText.js(216): bHandleAccess"); };

	if (this["bIsValidAccess"](iKeyCode)) {
		if (this["bReadOnly"]) {
			return UCF_AbapListItem.prototype["bHandleAccess"]["call"](this, iKeyCode, oSelectPosition);
		}

		return true;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["bHandleAccess"] = 0; };

UCF_AbapListText["prototype"]["bHandleChange"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["bHandleChange"]++; }; 
	if (!this["bReadOnly"] && this["oDomRef"]["value"] !== this["sText"]) {
		this["sText"] = this["oDomRef"]["value"];
		this["setClientProperty"]("Text", this["sText"], true);
		this["oGetList"]()["handleItemChange"](this, this["sText"]);

		return true;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["bHandleChange"] = 0; };

/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the paste
 * @return {boolean}
 */
UCF_AbapListText["prototype"]["onpaste"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["onpaste"]++; }; 
	if (!this["bReadOnly"] && this["bHasEventListeners"]('ClipboardTablePaste')) {
		UCF_ClipboardUtil["parseClipboard"](oBrowserEvent);
		if (UCF_ClipboardUtil["isTable"]()) {
			// eslint-disable-next-line no-magic-numbers
			if (UCF_UserAgent["bIsTrident"](7) || UCF_UserAgent["bIsEdgeHtml"]()) {
				UCF_JsUtil["delayedCall"](
					0,
					this,
					'fireClipboardTablePaste',
					[this["sId"], UCF_ClipboardUtil["getClipboardContents"]()]
				);
			} else {
				this["fireClipboardTablePaste"](
					this["sId"],
					UCF_ClipboardUtil["getClipboardContents"]()
				);
			}
			UCF_ClipboardUtil["cleanup"]();

			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();

			return true;
		}
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["onpaste"] = 0; };

/**
 * @see UCF_AbapListItem
 */

UCF_AbapListText["prototype"]["applyAcc"] = function(oAccessibilityHelper) {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["applyAcc"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessibilityHelper instanceof UCF_AccessibilityHelper, "oAccessibilityHelper instanceof UCF_AccessibilityHelper", "AbapListText.js(282): applyAcc"); };

	var sText = null;

	UCF_AbapListItem.prototype["applyAcc"]["call"](this, oAccessibilityHelper);

	if (this["bReadOnly"]) {
		sText = this["sText"];
	} else {
		sText = this["oDomRef"]["value"];

		oAccessibilityHelper["setControlType"]('I');
		oAccessibilityHelper["setEnabled"](true);
	}

	if (UCF_StringUtil["bIsEmpty"](sText)) {
		oAccessibilityHelper["setEmpty"](true);
	} else {
		oAccessibilityHelper["setText"](sText);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["applyAcc"] = 0; };

/**
 * Destructor
 */
UCF_AbapListText["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["destroy"]++; }; 
	this["oCache"]["destroy"]();
	this["oCache"] = null;

	UCF_AbapListItem.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_AbapListText["prototype"]["aAttributeNames"] = ["sAccessibilityDescription","sTextColor","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_AbapListText["prototype"]["aEventNames"] = ["ClipboardTablePaste"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_AbapListText["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_AbapListText["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_AbapListText["prototype"]["sTextColor"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_AbapListText["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_AbapListText["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_AbapListText["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["setDefaultValues"]++; }; 
	this["sAccessibilityDescription"] = '';
	this["sTextColor"] = "STANDARD";
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("TextColor", "STANDARD", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue The clipboard contents.
 * @fires AbapListText::ClipboardTablePaste
 */
UCF_AbapListText["prototype"]["fireClipboardTablePaste"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["fireClipboardTablePaste"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "AbapListText.js(386): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AbapListText.js(387): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AbapListText.js(388): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "AbapListText.js(389): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "AbapListText.js(390): fireClipboardTablePaste"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("AbapListText", "ClipboardTablePaste", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AbapListText["_"]["fireClipboardTablePaste"] = 0; };

};
sap["ls"]["preload"]["UCF_AbapListTextNavigationDelegate"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_FieldNavigationDelegate */
/// <reference path="./FieldNavigationDelegate.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>

/**
 *
 * For AbapList the selection behaviour should be the same as default
 * <TabIn>: value gets selected, but not in EditMode;
 * 	with ARROWS or TAB it can continue the navigations;
 *  As soon it start to edit or press F2, it'll switch to EditMode and
 *  ARROWS LEFT and RIGHT navigation will not be possible.
 *  ARROW UP / ARROW DOWN continue the navigation
 *  If the cursor is on the 0 postion, ARROW LEFT will continues the navigation to left;
 *  the EditMode will be also disabled
 *  If the cursor is on the end, ARROR RIGHT will continue the navigation;
 *  the EditMode will be also disabled
 *  F2 will switch back the EditMode: false and ARROWs navigation is possible again
 *
 * <Click>: Value is not selected, caret is set to the click position;
 * 	EditMode is enabled, and when the cursor is inside the text,
 * 	no ARROW LEFT /RIGHT no navigation is possble
 *  F2 will switch back the EditMode: false and ARROWs navigation is possible again
 *
 * @class UCF_AbapListTextNavigationDelegate
 * @extends UCF_Object
 * @param {UCF_EditFieldBase} oControl the field
 */
function UCF_AbapListTextNavigationDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["UCF_AbapListTextNavigationDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		this["oControl"] = oControl;
		this["bEditMode"] = false;
		this["bKeepEditMode"] = false;
		this["iSelectionStart"] = this["oControl"]["sGetText"]()["length"];
		this["iSelectionEnd"] = this["iSelectionStart"];
		this["sCurrentText"] = this["oControl"]["sGetText"]();
		this["oTimer"] = null;
	}
};window["UCF_AbapListTextNavigationDelegate"] = UCF_AbapListTextNavigationDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AbapListTextNavigationDelegate"); UCF_AbapListTextNavigationDelegate["_"] = {UCF_AbapListTextNavigationDelegate: 0}; }; ;

UCF_AbapListTextNavigationDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_FieldNavigationDelegate"))(); UCF_AbapListTextNavigationDelegate.prototype["sClassName"] = "UCF_AbapListTextNavigationDelegate";

UCF_AbapListTextNavigationDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["destroy"]++; }; 

	this["iSelectionEnd"] = null;
	this["iSelectionStart"] = null;
	this["sCurrentText"] = null;
	UCF_FieldNavigationDelegate.prototype["destroy"]["apply"](this, arguments);
	this["oTimer"] = null;
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["destroy"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsfocus"]++; }; 

	if (oBrowserEvent["bIsTouchInteraction"]()) {
		this["editMode"]();
	} else if (
		this["bKeepEditMode"] ||
		oBrowserEvent["oFromElement"] === this["oControl"]["oDomRef"]
	) {
		this["bKeepEditMode"] = false;
	} else if (!this["bEditMode"]) {
		this["navigationMode"]();
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsfocus"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlshotkey"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlshotkey"]++; }; 
	if (UCF_KeyboardHelper["bIsEventForKey"](oHotkey, UCF_KeyCodes["F2"])) {
		this["handleF2"](oHotkey);
	}
	if (UCF_KeyboardHelper["bIsEventForKey"](oHotkey, UCF_KeyCodes["A"], 'C')) {
		this["handleCtrlA"](oHotkey);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlshotkey"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oHotkey the hotkey
 */
UCF_AbapListTextNavigationDelegate["prototype"]["handleF2Delayed"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["handleF2Delayed"]++; }; 
	if (this["bEditMode"]) {
		// save selection start and end
		this["iSelectionStart"] = UCF_DomUtil["iGetSelectionStart"](
			this["oControl"]["oDomRef"]
		);
		this["iSelectionEnd"] = UCF_DomUtil["iGetSelectionEnd"](
			this["oControl"]["oDomRef"]
		);
		this["navigationMode"]();
	} else {
		this["editMode"]();
		UCF_DomUtil["setSelection"](
			this["oControl"]["oDomRef"],
			this["iSelectionStart"],
			this["iSelectionEnd"]
		);
	}

	if (window["UCF_System"]["bIs508"]) {
		this["oControl"]["refocus"]();
	}
	this["oTimer"] = null;

};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["handleF2Delayed"] = 0; };
UCF_AbapListTextNavigationDelegate["prototype"]["handleF2"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["handleF2"]++; }; 
	if (!this["oTimer"]) {
		this["oTimer"] = UCF_JsUtil["delayedCall"](
			// eslint-disable-next-line no-magic-numbers
			500,
			this,
			'handleF2Delayed',
			[oHotkey]
		);
		oHotkey["cancelBubble"]();
		oHotkey["cancel"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'handled to switch on/off navigationMode in tables', "AbapListTextNavigationDelegate.js(134): handleF2"); };
	} else {
		UCF_JsUtil["clearDelayedCall"](this["oTimer"]);
		this["oTimer"] = null;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'passing through for drilldown functionality in tables', "AbapListTextNavigationDelegate.js(138): handleF2"); };
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["handleF2"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oHotkey the hotkey
 */
UCF_AbapListTextNavigationDelegate["prototype"]["handleCtrlA"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["handleCtrlA"]++; }; 
	if (this["bEditMode"]) {
		// select the text and cancel the event.
		// otherwise: Let the event bubble, and the table raises a RowSelect event
		this["selectText"]();
		this["bEditMode"] = false;
		oHotkey["cancelBubble"]();
		oHotkey["cancel"]();
	} else {
		this["deselectText"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["handleCtrlA"] = 0; };

/** @override */
// eslint-disable-next-line complexity
UCF_AbapListTextNavigationDelegate["prototype"]["onkeydown"] = function(oKeydown) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onkeydown"]++; }; 
	if (
		UCF_DomUtil["oGetActiveElement"]() === this["oControl"]["oDomRef"] &&
		this["oControl"]["bIsWriteable"]()
	) {
		if (this["bEditMode"] && (
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["DELETE"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ESCAPE"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["INSERT"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"])
			)) {
			oKeydown["cancelBubble"]();
		} else if (this["bIsImplicitEditModeSwitch"](oKeydown)) {
			this["editMode"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onkeydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @return {boolean}
 */
UCF_AbapListTextNavigationDelegate["prototype"]["bIsImplicitEditModeSwitch"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["bIsImplicitEditModeSwitch"]++; }; 
	/** @type {number} */
	var iKeyCode = oBrowserEvent["iKeyCode"]();

	return UCF_KeyboardHelper["bIsEditKey"](iKeyCode)
		&& iKeyCode !== UCF_KeyCodes["ENTER"]
		&& (!oBrowserEvent["bCtrl"]() || oBrowserEvent["bAlt"]())
		&& !UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["SPACE"])
		&& UCF_DomUtil["oGetActiveElement"]() === this["oControl"]["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["bIsImplicitEditModeSwitch"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onpaste"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onpaste"]++; }; 
	this["editMode"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onpaste"] = 0; };

/** @override
 * On MouseDown set the bEditMode: true
 */
UCF_AbapListTextNavigationDelegate["prototype"]["onmousedown"] = function(oMouseDown) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onmousedown"]++; }; 
	var oSourceControl = oMouseDown["oGetSourceControl"]();
	if (oSourceControl === this["oControl"]) {
		this["editMode"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onmousedown"] = 0; };

UCF_AbapListTextNavigationDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsdragstart"]++; }; 

	if (UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent)) {
		this["navigationMode"]();
		oBrowserEvent["cancel"]();
		return;
	}
	var oSourceControl = oBrowserEvent["oGetSourceControl"]();
	if (oSourceControl === this["oControl"]) {
		this["editMode"]();
		oBrowserEvent["cancelBubble"]();
		//	oBrowserEvent.cancel();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsdragstart"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsblur"] = function(oBlur) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsblur"]++; }; 
	this["bSelected"] = false;
	this["bEditMode"] = false;
	this["sCurrentText"] = this["oControl"]["sGetText"]();
	if (!UCF_UserAgent["bIsIE"]())
		this["deselectText"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsblur"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsleft"] = function(oLsLeft) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsleft"]++; }; 
	if (this["bEditMode"]) {
		var iCursorPos = UCF_DomUtil["iGetCursorPos"](this["oControl"]["oDomRef"]);
		//		_trace(INFO, ' ========================== iCursorPos - ' + iCursorPos);
		if (iCursorPos === 0 && !oLsLeft["bRepeat"]() && !UCF_DomUtil["bHasSelection"](this["oControl"]["oDomRef"])) {
			this["bEditMode"] = false;
			this["bubbleToAbapList"](oLsLeft);
		} else
			UCF_FieldNavigationDelegate.prototype["onlsleft"]["apply"](this, arguments);
	} else {
		this["bubbleToAbapList"](oLsLeft);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsleft"] = 0; };

/**
 * [SHIFT] + [LEFT]
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleftmodifier
 */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsleftmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsleftmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent) && this["bEditMode"]) {
		this["oControl"]["syncListEditMode"](this["bEditMode"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsleftmodifier"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsright"] = function(oLsRight) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsright"]++; }; 
	if (this["bEditMode"]) {
		var iCursorPos = UCF_DomUtil["iGetCursorPos"](this["oControl"]["oDomRef"]),
			iLength = this["sGetDomRefValue"]()["length"];
		//	_trace(INFO, ' ========================== iCursorPos - ' + iCursorPos + ' =========== iLength ' + iLength);
		if (iCursorPos === iLength && !oLsRight["bRepeat"]() && !UCF_DomUtil["bHasSelection"](this["oControl"]["oDomRef"])) {
			this["bEditMode"] = false;
			this["bubbleToAbapList"](oLsRight);
		} else
			UCF_FieldNavigationDelegate.prototype["onlsright"]["apply"](this, arguments);
	} else {
		this["bubbleToAbapList"](oLsRight);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsright"] = 0; };

/**
 * [SHIFT] + [RIGHT]
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsrightmodifier
 */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsrightmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsrightmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent) && this["bEditMode"]) {
		if (!UCF_UserAgent["bIsIE"]()) {
			this["oControl"]["syncListEditMode"](this["bEditMode"]);
		}
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsrightmodifier"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsup"] = function(oLsup) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsup"]++; }; 
	// Navigates up
	this["bEditMode"] = false;
	this["bubbleToAbapList"](oLsup);
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsup"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsdown"] = function(oLsdown) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsdown"]++; }; 
	// Navigates up
	this["bEditMode"] = false;
	this["bubbleToAbapList"](oLsdown);
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsdown"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["bubbleToAbapList"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["bubbleToAbapList"]++; }; 
	this["deselectText"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["bubbleToAbapList"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsspacemodifier"] = function(oLsSpaceModifier) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsspacemodifier"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsspacemodifier"]["apply"](this, arguments);
	} else {
		oLsSpaceModifier["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsspacemodifier"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsselect"] = function(oLsSelect) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsselect"]++; }; 
	if (this["bEditMode"]) {
		oLsSelect["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsselect"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsselectmodifier"] = function(oLsSelectModifier) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsselectmodifier"]++; }; 
	if (this["bEditMode"]) {
		this["oControl"]["syncListEditMode"](this["bEditMode"]);
		UCF_FieldNavigationDelegate.prototype["onlsselectmodifier"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsselectmodifier"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlshome"] = function(oLsHome) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlshome"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlshome"]["apply"](this, arguments);
	} else {
		oLsHome["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlshome"] = 0; };

/**
 * [ESCAPE]
 *
 *  - if focus on UI element in edit mode and user has changed a value: Restore old value.
 *  - if focus on UI element in edit mode and user has not changed a value: return to cell navigation mode.
 * @private
 * @param { UCF_BrowserEvent } oLsEscape the lsleftmodifier
 */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsescape"] = function(oLsEscape) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsescape"]++; }; 
	if (this["bEditMode"]) {
		if (this["sCurrentText"] === this["oControl"]["sGetCurrentText"]()) {
			//get back navigation mode
			this["navigationMode"]();
		} else {
			//restore the old value
			this["oControl"]["setText"](this["sCurrentText"]);
		}
		oLsEscape["cancel"]();
		oLsEscape["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsescape"] = 0; };

/**
 * [SHIFT] + [HOME]
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleftmodifier
 */
UCF_AbapListTextNavigationDelegate["prototype"]["onlshomemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlshomemodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent) && this["bEditMode"]) {
		this["oControl"]["syncListEditMode"](this["bEditMode"]);
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlshomemodifier"] = 0; };

/** @override */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsend"] = function(oLsEnd) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsend"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsend"]["apply"](this, arguments);
	} else {
		oLsEnd["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsend"] = 0; };

/**
 * [SHIFT] + [END]
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleftmodifier
 */
UCF_AbapListTextNavigationDelegate["prototype"]["onlsendmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsendmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent) && this["bEditMode"]) {
		this["oControl"]["syncListEditMode"](this["bEditMode"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["onlsendmodifier"] = 0; };

/** @protected */
UCF_AbapListTextNavigationDelegate["prototype"]["navigationMode"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["navigationMode"]++; }; 
	this["bEditMode"] = false;
	this["oControl"]["syncListEditMode"](this["bEditMode"]);
	this["selectText"]();
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["navigationMode"] = 0; };

/** @protected */
UCF_AbapListTextNavigationDelegate["prototype"]["editMode"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["editMode"]++; }; 
	this["bEditMode"] = true;
	this["sCurrentText"] = this["oControl"]["sGetText"]();
	this["oControl"]["syncListEditMode"](this["bEditMode"]);
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["editMode"] = 0; };

/** @protected */
UCF_AbapListTextNavigationDelegate["prototype"]["keepEditMode"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["keepEditMode"]++; }; 
	this["bKeepEditMode"] = true;
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["keepEditMode"] = 0; };

/** @private
 *  Selects the text of the Input
 */
UCF_AbapListTextNavigationDelegate["prototype"]["selectText"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["selectText"]++; }; 
	/** @type {Document} */
	var document = window["document"];
	/** @type {Selection} */
	var selection;
	/** @type {Range} */
	var range;

	if (this["oControl"]["oDomRef"]["select"]) {
		this["oControl"]["oDomRef"]["select"]();
		if (UCF_UserAgent["bIsSafari"]()) {
			// Safari dosn't raise onselect browser event
			this["oControl"]["sSelectedValue"] = this["oControl"]["oDomRef"]["value"]["slice"](
				this["oControl"]["oDomRef"]["selectionStart"],
				this["oControl"]["oDomRef"]["selectionEnd"]
			);
		}
	} else if (window["getSelection"] && document["createRange"]) {
		// Chrome, Firefox, IE11
		selection = window["getSelection"]();
		range = document["createRange"]();
		range["selectNodeContents"](this["oControl"]["oDomRef"]);
		selection["removeAllRanges"]();
		selection["addRange"](range);
	} else if (document["body"]["createTextRange"]) {
		// IE11
		range = document["body"]["createTextRange"]();
		range["moveToElementText"](this["oControl"]["oDomRef"]);
		range["select"]();
	}
	this["bSelected"] = true;
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["selectText"] = 0; };

/** @private */
UCF_AbapListTextNavigationDelegate["prototype"]["deselectText"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["deselectText"]++; }; 
	if (this["oControl"]["oDomRef"]["select"]) {
		this["oControl"]["oDomRef"]["selectionStart"] = 0;
		this["oControl"]["oDomRef"]["selectionEnd"] = 0;
	} else {
		UCF_DomUtil["removeSelection"]();
	}
	this["bSelected"] = false;
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["deselectText"] = 0; };

/**
 * Due to HPIFs one can't rely on this.oDomRef.value. This is not a problem
 * after the HPIF <span> is exchanged to the <input>, but before it is (e.g.
 * in the constructor, or in the onlsblur that is triggered from exchanging
 * the HPIF <span>).
 *
 * @protected
 * @return {string}
 */
UCF_AbapListTextNavigationDelegate["prototype"]["sGetDomRefValue"] = function() {;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["sGetDomRefValue"]++; }; 
	/** @type {string} */
	var sValue = 'value' in this["oControl"]["oDomRef"]
		? this["oControl"]["oDomRef"]["value"]
		: (this["oLS"]["oSystem"]["sDevice"] === 'standards'
			? this["oControl"]["oDomRef"]["textContent"]
			: this["oControl"]["oDomRef"]["innerHTML"]);

	return sValue;
};;if (__UCF_COVERAGE__) { UCF_AbapListTextNavigationDelegate["_"]["sGetDomRefValue"] = 0; };

};
sap["ls"]["preload"]["UCF_AccessibilityHelper"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * Accessibility Helper Class is called by the control if the onlsaccessibility
 * event is thrown. The on lsaccessibility event corresponds to the focus event
 * of the browser that is thrown if a dom element gets the focus. It provides
 * several setter methods to pass the controls status. With the "apply" method
 * the translated accessibility text is set to a given dom reference as its
 * tooltip. The `apply` method is automatically called after the
 * onlsaccessibility event was processed. It adds the result text to the source
 * element of the event. A screenreader software can pick up this tooltip and
 * annouces it to the user. The apply method is automatically called after the
 * During the event bubbling of the onlsaccessibility event the
 * AccessibilityHelper object is passed with the event. This allows parent
 * controls to add status information to the AccessibilityHelper.
 *
 * @example<caption>how to use the Accessibility Helper in a control</caption>
 * ```javascript
 * UCF_SpecialControl.prototype.onlsaccessibility = function(oBrowserEvent) {
 *	_assert (oBrowserEvent instanceof UCF_BrowserEvent);
 *
 *	if(oBrowserEvent.oGetSourceControl() != this) return;
 *
 *  oAccessibilityHelper.setText(this.sText); 		  // sets the text of the control
 *	oAccessibilityHelper.setEnabled(this.bEnabled);   // sets the enabled state
 *	oAccessibilityHelper.setTooltip(this.sTooltip);   // sets a tooltip
 *	oAccessibilityHelper.setControlType("B");         // sets the controltype
 *	oAccessibilityHelper.setSelected(this.bSelected); // sets the selected state of the control
 *  oAccessibilityHelper.addEnabledTutor("B_TUT",this.bEnabled);    // sets the tutor text based on a state
 *  //cancel bubbling of event if necessary
 * }
 * ```
 *
 * @example<caption>if the event bubble to the parent and the parent likes to add information to it</caption>
 * ```javascript
 * UCF_ParentOfSpecialControl.prototype.onlsaccessibility = function(oBrowserEvent) {
 *	_assert (oBrowserEvent instanceof UCF_BrowserEvent);
 *
 *  oAccessibilityHelper.setGroupText(this.sText); 		  // sets the text of the parent control
 *  oBrowserEvent.cancelBubble()
 * }
 * ```
 *
 * Now the new aria properties and roles are supported for IE8 where possible
 * http://www.w3.org/TR/wai-aria/#roles
 *
 * 
 * @version 2.0
 *
 * @class
 * @param {UCF_LS} oLS
 */
function UCF_AccessibilityHelper(oLS) {if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["UCF_AccessibilityHelper"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "AccessibilityHelper.js(74): UCF_AccessibilityHelper"); };

	this["oLS"] = oLS;
	UCF_Object["apply"](this);
	this["bContainerEntryBehaviourApplied"] = false;
	//first load loads the texts for all controls
	//initialize all properties
};window["UCF_AccessibilityHelper"] = UCF_AccessibilityHelper; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AccessibilityHelper"); UCF_AccessibilityHelper["_"] = {UCF_AccessibilityHelper: 0}; }; ;
UCF_AccessibilityHelper["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_AccessibilityHelper.prototype["sClassName"] = "UCF_AccessibilityHelper";

UCF_AccessibilityHelper["prototype"]["E_SEMANTIC"] = {
	"Standard": "STANDARD",
	"Transparent": "TRANSPARENT",
	"Alternating": "ALTERNATING",
	"Header1": "H1",
	"Header2": "H2",
	"Header3": "H3",
	"Header4": "H4",
	"Header5": "H5",
	"Header6": "H6",
	"Bad": "BADVALUE",
	"BadDark": "BADVALUE_DARK",
	"BadMedium": "BADVALUE_MEDIUM",
	"BadLight": "BADVALUE_LIGHT",
	"Critical": "CRITICALVALUE",
	"CriticalDark": "CRITICALVALUE_DARK",
	"CriticalMedium": "CRITICALVALUE_MEDIUM",
	"CriticalLight": "CRITICALVALUE_LIGHT",
	"Good": "GOODVALUE",
	"Emphasized": "EMPHASIZED",
	"Negative": "NEGATIVE",
	"Positive": "POSITIVE",
	"Selected": "SELECTED",
	"Total": "TOTAL",
	"Subtotal": "SUBTOTAL",
	"SubtotalLight": "SUBTOTAL_LIGHT",
	"Key": "KEY",
	"Filtered": "F",
	"Marked": "MARKED"
};

UCF_AccessibilityHelper["prototype"]["E_DATATYPE"] = {
	"Amount": "AMOUNT",
	"Bdc": "BDC",
	"Boolean": "BOOLEAN",
	"Code": "CODE",
	"CurrencyCode": "CURRENCY_CODE",
	"Date": "DATE",
	"DateTime": "DATE_TIME",
	"DaylightSavingIndicator": "DAYLIGHT_SAVING",
	"Description": "DESCRIPTION",
	"Duration": "DURATION",
	"Identifier": "IDENTIFIER",
	"Integer": "INTEGER",
	"Numeric": "NUMERIC",
	"Measure": "MEASURE",
	"Percentage": "PERCENTAGE",
	"Quantity": "QUANTITY",
	"Ratio": "RATIO",
	"Time": "TIME",
	"TimezoneCode": "TIMEZONE_CODE",
	"UnitCode": "UNIT_CODE",
	"Uri": "URI"
};

UCF_AccessibilityHelper["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["destroy"]++; }; 

	this["sControlType"] = null;
	this["sAccessKey"] = null;
	this["sHotkey"] = null;
	this["sRole"] = null;
	this["sHighlightDescription"] = null;
	this["sText"] = null;
	this["sValue"] = null;
	this["sLabelText"] = null;
	this["sDataTip"] = null;
	this["sRichTooltip"] = null;
	this["sGroupText"] = null;
	this["sParentText"] = null;
	this["sParentTooltip"] = null;
	this["sAccessibilityDescription"] = null;
	this["sCustomStatusText"] = null;
	this["sParentControlType"] = null;
	this["sExplanationText"] = null;
	this["sIconTooltip"] = null;

	this["aControlTypeVariables"] = null;
	this["aCustomStatusValues"] = null;
	this["aParentControlTypeVariables"] = null;

	this["bEnabled"] = null;
	this["bSelectable"] = null;
	this["bSelected"] = null;
	this["bNotSelected"] = null;
	this["bChecked"] = null;
	this["bNotChecked"] = null;
	this["bCompleted"] = null;
	this["bSuccess"] = null;
	this["bError"] = null;
	this["bInformation"] = null;
	this["bNotification"] = null;
	this["bTask"] = null;
	this["bLoading"] = null;
	this["bInvalid"] = null;
	this["bRequired"] = null;
	this["bFiltered"] = null;
	this["bUncompleted"] = null;
	this["bPressed"] = null;
	this["bNotPressed"] = null;
	this["bReadonly"] = null;
	this["bToday"] = null;
	this["bUndefined"] = null;
	this["bMixed"] = null;
	this["bValid"] = null;
	this["bWarning"] = null;
	this["bUnchecked"] = null;
	this["bDynamic"] = null;
	this["bEmpty"] = null;
	this["bSortedAscending"] = null;
	this["bSortedDescending"] = null;
	this["bSortable"] = null;
	this["bStop"] = null;
	this["bExpanded"] = null;
	this["bCollapsed"] = null;
	this["bToggled"] = null;
	this["bNotToggled"] = null;
	this["bHighlighted"] = null;
	this["bAlert"] = null;
	this["bRecurring"] = null;

	this["iLevel"] = null;
	this["iItemCount"] = null;
	this["sItemCountText"] = null;
	this["iItemIndex"] = null;
	this["iContainingItemCount"] = null;

	this["oLS"] = null;
	this["oLegendTexts"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["destroy"] = 0; };

/**
 * Returns the text for a given sTextKey and replaces its placeholders with the given values
 * A placeholder is in {0}
 *
 * @private
 *
 * @param {string} sTextKey The text key
 * @param {Array} aValues Array of values for the placeholders
 *
 * @return {string} the text for a given sTextKey

 * @TODO Put this method to Lightspeed globally
 */
UCF_AccessibilityHelper["prototype"]["sGetText"] = function (sTextKey, aValues) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetText"]++; }; 
	return UCF_KeyboardHelper["sGetText"](this["oLS"], sTextKey, aValues);
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetText"] = 0; };

/**
 * Sets the controls type to access the controls texts from MessageBundle properies file
 * Add an array aControlTypeParameters if you need to pass variables (like the itemcount) into the control type string
 * Itemlist with {0} items
 * In this exaple {0} is replaced with the text passed as sControlTypeValiables[0]
 *
 * @public
 *
 * @param {string} sControlType The control type of the control as it is used in the MessageBundle files
 * @param {Array}  aControlTypeVariables Variables to be replaced in the text
 */
UCF_AccessibilityHelper["prototype"]["setControlType"] = function (sControlType, aControlTypeVariables) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setControlType"]++; }; 

	this["sControlType"] = sControlType;
	this["aControlTypeVariables"] = aControlTypeVariables;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setControlType"] = 0; };

/**
 * Sets the access key text
 *
 * @public
 *
 * @param {string} sAccessKey The accessibilty text for an access key
 */
UCF_AccessibilityHelper["prototype"]["setAccessKey"] = function (sAccessKey) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setAccessKey"]++; }; 
	this["sAccessKey"] = sAccessKey;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setAccessKey"] = 0; };

/**
 * Sets the hotkey text
 *
 * @public
 *
 * @param {string} sHotkey The accessibilty text for a hotkey
 */
UCF_AccessibilityHelper["prototype"]["setHotkey"] = function (sHotkey) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setHotkey"]++; }; 
	this["sHotkey"] = sHotkey;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setHotkey"] = 0; };

/**
 * Sets the enabled state
 *
 * @public
 *
 * @param {boolean} bEnabled The enabled state of a control
 */
UCF_AccessibilityHelper["prototype"]["setEnabled"] = function (bEnabled) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setEnabled"]++; }; 
	this["bEnabled"] = bEnabled;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setEnabled"] = 0; };

/**
 * Sets the selectable state
 *
 * @public
 *
 * @param {boolean} bSelectable The selectable state of a control
 */
UCF_AccessibilityHelper["prototype"]["setSelectable"] = function (bSelectable) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSelectable"]++; }; 
	this["bSelectable"] = bSelectable;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSelectable"] = 0; };

/**
 * Sets the selected state
 *
 * @public
 *
 * @param {boolean} bSelected The selected state of a control
 */
UCF_AccessibilityHelper["prototype"]["setSelected"] = function (bSelected) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSelected"]++; }; 
	this["bSelected"] = bSelected;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSelected"] = 0; };

/**
 * Sets the not selected state. This state has to be explicitly set if the controls accessibility needs to read that an item is
 * currently not selected.
 *
 * @public
 *
 * @param {boolean} bNotSelected The not selected state of a control
 */
UCF_AccessibilityHelper["prototype"]["setNotSelected"] = function (bNotSelected) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setNotSelected"]++; }; 
	this["bNotSelected"] = bNotSelected;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setNotSelected"] = 0; };

/**
 * Sets the checked state
 *
 * @public
 *
 * @param {boolean} bChecked The checked state of a control
 */
UCF_AccessibilityHelper["prototype"]["setChecked"] = function (bChecked) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setChecked"]++; }; 
	this["bChecked"] = bChecked;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setChecked"] = 0; };

/**
 * Sets the not checked state. This state has to be explicitly set if the controls accessibility needs to read that an item is
 * currently not checked.
 *
 * @public
 *
 * @param {boolean} bNotChecked The not checked state of a control
 */
UCF_AccessibilityHelper["prototype"]["setNotChecked"] = function (bNotChecked) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setNotChecked"]++; }; 
	this["bNotChecked"] = bNotChecked;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setNotChecked"] = 0; };

/**
 * Sets the complete state
 *
 * @public
 *
 * @param {boolean} bCompleted The completed state of a control
 */
UCF_AccessibilityHelper["prototype"]["setCompleted"] = function (bCompleted) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setCompleted"]++; }; 
	this["bCompleted"] = bCompleted;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setCompleted"] = 0; };

/**
 * Sets the success state. Used to anounce a success text for example in the MessageBar or DataTip
 *
 * @public
 *
 * @param {boolean} bSuccess The success state of a control
 */
UCF_AccessibilityHelper["prototype"]["setSuccess"] = function (bSuccess) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSuccess"]++; }; 
	this["bSuccess"] = bSuccess;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSuccess"] = 0; };

/**
 * Sets the error state. Used to anounce an error text for example in the MessageBar or DataTip
 *
 * @public
 *
 * @param {boolean} bError The error state of a control
 */
UCF_AccessibilityHelper["prototype"]["setError"] = function (bError) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setError"]++; }; 
	this["bError"] = bError;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setError"] = 0; };

/**
 * Sets the information state. Used to anounce an information text for example in the MessageBar or DataTip
 *
 * @public
 *
 * @param {boolean} bInformation The information state of a control
 */
UCF_AccessibilityHelper["prototype"]["setInformation"] = function (bInformation) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setInformation"]++; }; 
	this["bInformation"] = bInformation;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setInformation"] = 0; };

/**
 * Sets the notification state.  Used to anounce a notification text for example in the MessageBar or DataTip
 *
 * @public
 *
 * @param {boolean} bNotification The notofication state of a control
 */
UCF_AccessibilityHelper["prototype"]["setNotification"] = function (bNotification) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setNotification"]++; }; 
	this["bNotification"] = bNotification;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setNotification"] = 0; };

/**
 * Sets the task state
 *
 * @public
 *
 * @param {boolean} bTask The task state of a control
 */
UCF_AccessibilityHelper["prototype"]["setTask"] = function (bTask) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setTask"]++; }; 
	this["bTask"] = bTask;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setTask"] = 0; };

/**
 * Sets the loading state.
 *
 * @public
 *
 * @param {boolean} bLoading The loading state of a control
 */
UCF_AccessibilityHelper["prototype"]["setLoading"] = function (bLoading) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setLoading"]++; }; 
	this["bLoading"] = bLoading;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setLoading"] = 0; };

/**
 * Sets the required state for input elements
 *
 * @public
 *
 * @param {boolean} bRequired The required state of a control
 */
UCF_AccessibilityHelper["prototype"]["setRequired"] = function (bRequired) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setRequired"]++; }; 
	this["bRequired"] = bRequired;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setRequired"] = 0; };

/**
 * Sets the filtered state for e.g. table column
 *
 * @public
 *
 * @param {boolean} bFiltered The filtered state of a control
 */
UCF_AccessibilityHelper["prototype"]["setFiltered"] = function (bFiltered) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setFiltered"]++; }; 
	this["bFiltered"] = bFiltered;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setFiltered"] = 0; };

/**
 * Sets the invalid state for input elements
 *
 * @public
 *
 * @param {boolean} bInvalid The invalid state of a control
 */
UCF_AccessibilityHelper["prototype"]["setInvalid"] = function (bInvalid) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setInvalid"]++; }; 
	this["bInvalid"] = bInvalid;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setInvalid"] = 0; };

/**
 * Sets the uncomplete state
 *
 * @public
 *
 * @param {boolean} bUncompleted The unclompleted state of a control
 */
UCF_AccessibilityHelper["prototype"]["setUncompleted"] = function (bUncompleted) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setUncompleted"]++; }; 
	this["bUncompleted"] = bUncompleted;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setUncompleted"] = 0; };

/**
 * Sets the pressed state
 *
 * @public
 *
 * @param {boolean} bPressed The pressed state of a control
 */

UCF_AccessibilityHelper["prototype"]["setPressed"] = function (bPressed) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setPressed"]++; }; 
	this["bPressed"] = bPressed;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setPressed"] = 0; };

/**
 * Sets the not pressed state
 *
 * @public
 *
 * @param {boolean} bNotPressed The unpressed state of a control
 */

UCF_AccessibilityHelper["prototype"]["setNotPressed"] = function (bNotPressed) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setNotPressed"]++; }; 
	this["bNotPressed"] = bNotPressed;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setNotPressed"] = 0; };

/**
 * Sets the readonly state
 *
 * @public
 *
 * @param {boolean} bReadonly The read only state of a control
 */
UCF_AccessibilityHelper["prototype"]["setReadonly"] = function (bReadonly) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setReadonly"]++; }; 
	this["bReadonly"] = bReadonly;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setReadonly"] = 0; };

/**
 * Sets the today stat for calendar, datepicker and datenavigator controls
 *
 * @public
 *
 * @param {boolean} bToday The today state of a control
 */
UCF_AccessibilityHelper["prototype"]["setToday"] = function (bToday) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setToday"]++; }; 
	this["bToday"] = bToday;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setToday"] = 0; };

/**
 * Sets the undefined state
 *
 * @public
 *
 * @param {boolean} bUndefined The undefined state of a control
 */
UCF_AccessibilityHelper["prototype"]["setUndefined"] = function (bUndefined) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setUndefined"]++; }; 
	this["bUndefined"] = bUndefined;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setUndefined"] = 0; };

/**
 * Sets the mixed state
 *
 * @public
 *
 * @param {boolean} bMixed The mixed state of a control
 */
UCF_AccessibilityHelper["prototype"]["setMixed"] = function (bMixed) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setMixed"]++; }; 
	this["bMixed"] = bMixed;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setMixed"] = 0; };

/**
 * Sets the valid state
 *
 * @public
 *
 * @param {boolean} bValid The valid state of a control
 */
UCF_AccessibilityHelper["prototype"]["setValid"] = function (bValid) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setValid"]++; }; 
	this["bValid"] = bValid;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setValid"] = 0; };

/**
 * Sets the warning state
 *
 * @public
 *
 * @param {boolean} bWarning The warning state of a control
 */
UCF_AccessibilityHelper["prototype"]["setWarning"] = function (bWarning) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setWarning"]++; }; 
	this["bWarning"] = bWarning;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setWarning"] = 0; };

/**
 * Sets the unchecked status for radio buttons, checkboxes...
 *
 * @public
 *
 * @param {boolean} bUnchecked The unchecked state of a control
 */
UCF_AccessibilityHelper["prototype"]["setUnchecked"] = function (bUnchecked) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setUnchecked"]++; }; 
	this["bUnchecked"] = bUnchecked;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setUnchecked"] = 0; };

/**
 * Sets the dynamic status
 *
 * @public
 *
 * @param {boolean} bDynamic The dynamic state of a control
 */
UCF_AccessibilityHelper["prototype"]["setDynamic"] = function (bDynamic) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setDynamic"]++; }; 
	this["bDynamic"] = bDynamic;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setDynamic"] = 0; };

/**
 * Sets the empty status for text elements that are empty
 *
 * @public
 *
 * @param {boolean} bEmpty The empty state of a control
 */
UCF_AccessibilityHelper["prototype"]["setEmpty"] = function (bEmpty) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setEmpty"]++; }; 
	this["bEmpty"] = bEmpty;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setEmpty"] = 0; };

/**
 * Sets the sorting order to ascending
 *
 * @public
 *
 * @param {boolean} bSortedAscending The ascending sorted state of a control
 */
UCF_AccessibilityHelper["prototype"]["setSortedAscending"] = function (bSortedAscending) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSortedAscending"]++; }; 
	this["bSortedAscending"] = bSortedAscending;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSortedAscending"] = 0; };

/**
 * Sets the sorting order to descending
 *
 * @public
 *
 * @param {boolean} bSortedDescending The decending sorted state of a control
 */
UCF_AccessibilityHelper["prototype"]["setSortedDescending"] = function (bSortedDescending) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSortedDescending"]++; }; 
	this["bSortedDescending"] = bSortedDescending;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSortedDescending"] = 0; };

/**
 * Sets the sortable state. Set the sortable state to true as well as the
 * ascending and descending order
 *
 * @see setSortedAscending setSortedDescending
 *
 * @public
 *
 * @param {boolean} bSortable The sortable state of a control
 */
UCF_AccessibilityHelper["prototype"]["setSortable"] = function (bSortable) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSortable"]++; }; 
	this["bSortable"] = bSortable;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setSortable"] = 0; };

/**
 * Sets the stop state
 *
 * @public
 *
 * @param {boolean} bStop The stop state of a control
 */
UCF_AccessibilityHelper["prototype"]["setStop"] = function (bStop) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setStop"]++; }; 
	this["bStop"] = bStop;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setStop"] = 0; };

/**
 * Sets the expanded state
 *
 * @public
 *
 * @param {boolean} bExpanded The expanded state of a control
 */
UCF_AccessibilityHelper["prototype"]["setExpanded"] = function (bExpanded) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setExpanded"]++; }; 
	this["bExpanded"] = bExpanded;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setExpanded"] = 0; };

/**
 * Sets the collapsed state
 * @public
 *
 * @param {boolean} bCollapsed The collapsed state of a control.
 */
UCF_AccessibilityHelper["prototype"]["setCollapsed"] = function (bCollapsed) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setCollapsed"]++; }; 
	this["bCollapsed"] = bCollapsed;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setCollapsed"] = 0; };

/**
 * Sets the toggled state
 * @public
 *
 * @param {boolean} bToggled The toggled state of a control.
 */
UCF_AccessibilityHelper["prototype"]["setToggled"] = function (bToggled) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setToggled"]++; }; 
	this["bToggled"] = bToggled;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setToggled"] = 0; };

/**
 * Sets the non toggled state
 *
 * @public
 *
 * @param {boolean} bNotToggled The not toggled state of a control.
 */
UCF_AccessibilityHelper["prototype"]["setNotToggled"] = function (bNotToggled) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setNotToggled"]++; }; 
	this["bNotToggled"] = bNotToggled;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setNotToggled"] = 0; };

/**
 * Sets the highlight state
 *
 * @public
 *
 * @param {boolean} bHighlighted The highlight state of a control.
 */
UCF_AccessibilityHelper["prototype"]["setHighlighted"] = function (bHighlighted) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setHighlighted"]++; }; 
	this["bHighlighted"] = bHighlighted;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setHighlighted"] = 0; };

/**
 * Sets the highlight description
 *
 * @public
 *
 * @param {string} sHighlightDescription The highlight description of a control.
 */
UCF_AccessibilityHelper["prototype"]["setHighlightDescription"] = function (sHighlightDescription) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setHighlightDescription"]++; }; 
	if (this["bHighlighted"]) this["sHighlightDescription"] = sHighlightDescription;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setHighlightDescription"] = 0; };

/**
 * Sets an alert state
 *
 * @public
 *
 * @param {boolean} bAlert The alert state of a control.
 */
UCF_AccessibilityHelper["prototype"]["setAlert"] = function (bAlert) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setAlert"]++; }; 
	this["bAlert"] = bAlert;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setAlert"] = 0; };

/**
 * Sets the recurring status for calendar entries.
 * @see UCF_CalendarEntry
 *
 * @public
 *
 * @param {boolean} bRecurring The recurring state of a control.
 */
UCF_AccessibilityHelper["prototype"]["setRecurring"] = function (bRecurring) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setRecurring"]++; }; 
	this["bRecurring"] = bRecurring;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setRecurring"] = 0; };

/**
 * Sets the total item count for controls that contain items.
 * @see UCF_ItemNavigation UCF_Viewswitch UCF_Tabstrip
 *
 * @public
 *
 * @param {int} iItemCount The number of items contained in the controls.
 */
UCF_AccessibilityHelper["prototype"]["setItemCount"] = function (iItemCount) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setItemCount"]++; }; 
	this["iItemCount"] = iItemCount;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setItemCount"] = 0; };

/**
 * Sets the total item count text for controls that contain items.
 * @see UCF_ItemNavigation UCF_Viewswitch UCF_Tabstrip
 *
 * @public
 *
 * @param { string } sItemCountText The text which should be announced with number of items contained in the controls.
 */
UCF_AccessibilityHelper["prototype"]["setItemCountText"] = function (sItemCountText) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setItemCountText"]++; }; 
	this["sItemCountText"] = sItemCountText;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setItemCountText"] = 0; };

/**
 * Sets the index of the current item that has the focus for controls that contain items.
 * @see UCF_ItemNavigation UCF_Viewswitch UCF_Tabstrip
 *
 * @public
 *
 * @param {boolean} iItemIndex The index of the focused item of a control.
 */

UCF_AccessibilityHelper["prototype"]["setItemIndex"] = function (iItemIndex) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setItemIndex"]++; }; 
	this["iItemIndex"] = iItemIndex;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setItemIndex"] = 0; };

/**
 * Sets the level information. Used for hierarichal controls.
 * @see UCF_Tree UCF_CalendarYearView
 *
 * @public
 *
 * @param {int} iLevel The level of the control in a hierarchy.
 */
UCF_AccessibilityHelper["prototype"]["setLevel"] = function (iLevel) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setLevel"]++; }; 
	this["iLevel"] = iLevel;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setLevel"] = 0; };

/**
 * Sets the tooltip and overwrites an existing tooltip. Deletes all that were added with addTooltip.
 * @see addTooltip(sTooltip)
 *
 * @public
 *
 * @param {string} sTooltip The tooltip of a control.
 */
UCF_AccessibilityHelper["prototype"]["setTooltip"] = function (sTooltip) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setTooltip"]++; }; 
	if (this["aTooltip"]) this["aTooltip"] = null;
	this["addTooltip"](sTooltip);
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setTooltip"] = 0; };

/**
 * Sets the text. This is normaly the text that is visible on the screen.
 *
 * @public
 *
 * @param {string} sText The text of a control.
 */
UCF_AccessibilityHelper["prototype"]["setText"] = function (sText) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setText"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (sText) === "string", "typeof (sText) === \"string\"", "AccessibilityHelper.js(787): setText"); };
	this["sText"] = sText;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setText"] = 0; };

/**
 * Sets the value. This is special information rendered directly behind control name in front of status information.
 *
 * @public
 *
 * @param {string} sValue The value of a control.
 */
UCF_AccessibilityHelper["prototype"]["setValue"] = function (sValue) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setValue"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (sValue) === "string", "typeof (sValue) === \"string\"", "AccessibilityHelper.js(799): setValue"); };
	this["sValue"] = sValue;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setValue"] = 0; };

/**
 * Sets the label text. The label text of a control is defined by a
 * UCF_Label control or by the accessibily description.
 *
 * @public
 *
 * @param {string} sLabelText The label text of a control.
 */
UCF_AccessibilityHelper["prototype"]["setLabel"] = function (sLabelText) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setLabel"]++; }; 
	this["sLabelText"] = sLabelText;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setLabel"] = 0; };

/**
 * Sets a datatip text. The data tip text gives adds a message explaining an error, warning or success.
 * @see UCF_DataTip
 *
 * @public
 *
 * @param {string} sDataTip The data tip text of a control.
 */
UCF_AccessibilityHelper["prototype"]["setDataTip"] = function (sDataTip) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setDataTip"]++; }; 
	this["sDataTip"] = sDataTip;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setDataTip"] = 0; };
/**
 * Sets a rich tooltip text.
 * @see UCF_RichTooltip
 *
 * @public
 *
 * @param {string} sRichTooltip The rich tooltip text of a control.
 */
UCF_AccessibilityHelper["prototype"]["setRichTooltip"] = function (sRichTooltip) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setRichTooltip"]++; }; 
	this["sRichTooltip"] = sRichTooltip;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setRichTooltip"] = 0; };

/**
 * Sets the explanation text. The explanation is an additional text that explains the control
 * @see UCF_DataTip
 *
 * @public
 *
 * @param {string} sExplanationText The explanation text of a control.
 */
UCF_AccessibilityHelper["prototype"]["setExplanationText"] = function (sExplanationText) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setExplanationText"]++; }; 
	this["sExplanationText"] = sExplanationText;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setExplanationText"] = 0; };

/**
 * Adds a data type from the E_DataType enumeration
 * @see UCF_AccessibilityHelper#E_DATATYPE
 * @public
 *
 * @param {Object} eDataType The data type information of a control.
 */
UCF_AccessibilityHelper["prototype"]["addDataType"] = function (eDataType) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addDataType"]++; }; 
	if (!this["aDataTypes"]) this["aDataTypes"] = [];
	var sText = null;

	sText = this["sGetText"]("DATATYPE_" + eDataType);

	//If translation found
	if ("DATATYPE_" + eDataType !== sText) {
		this["aDataTypes"]["push"](sText);
	}
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addDataType"] = 0; };

/**
 * Adds a semantic from the E_SEMANTIC enumeration
 * @see UCF_AccessibilityHelper#E_SEMANTIC
 * @public
 *
 * @param {Object} eSemantic The semantic information of a control.
 */
UCF_AccessibilityHelper["prototype"]["addSemantic"] = function (eSemantic) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addSemantic"]++; }; 
	if (!this["aSemantics"]) this["aSemantics"] = [];
	var sText = null;
	if (this["oLegendTexts"]) sText = this["oLegendTexts"][eSemantic];

	// UR defaults
	if (!sText) {
		//Skip
		if (eSemantic === this["E_SEMANTIC"]["Standard"]
			|| eSemantic === this["E_SEMANTIC"]["Transparent"]
			|| eSemantic === this["E_SEMANTIC"]["Alternating"]
		) {
			return;
		}

		//Mapping
		if (eSemantic === this["E_SEMANTIC"]["Marked"]) {
			eSemantic = this["E_SEMANTIC"]["Selected"];
		} else if (eSemantic === this["E_SEMANTIC"]["SubtotalLight"]) {
			eSemantic = this["E_SEMANTIC"]["Subtotal"];
		} else if (eSemantic === this["E_SEMANTIC"]["BadDark"]
			|| eSemantic === this["E_SEMANTIC"]["BadMedium"]
			|| eSemantic === this["E_SEMANTIC"]["BadLight"]
		) {
			eSemantic = this["E_SEMANTIC"]["Bad"];
		} else if (eSemantic === this["E_SEMANTIC"]["CriticalDark"]
			|| eSemantic === this["E_SEMANTIC"]["CriticalMedium"]
			|| eSemantic === this["E_SEMANTIC"]["CriticalLight"]
		) {
			eSemantic = this["E_SEMANTIC"]["Critical"];
		}

		sText = this["sGetText"](eSemantic);

		//If no translation found
		if (eSemantic === sText) {
			sText = null;
		}
	}

	if (sText) this["aSemantics"]["push"](sText);

};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addSemantic"] = 0; };
/**
 * Sets the tooltip of an icon included in the control.
 *
 * @public
 *
 * @param {string} sIconTooltip The tooltip of an icon of a control.
 */
UCF_AccessibilityHelper["prototype"]["setIconTooltip"] = function (sIconTooltip) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setIconTooltip"]++; }; 
	this["sIconTooltip"] = sIconTooltip;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setIconTooltip"] = 0; };
/**
 * Sets the group text. The group text is used if a user first enters a group to pronounce the group text
 * together with the controls text.
 *
 * @public
 *
 * @param {string} sGroupText The additional group text of a control.
 */
UCF_AccessibilityHelper["prototype"]["setGroupText"] = function (sGroupText) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setGroupText"]++; }; 
	this["sGroupText"] = sGroupText;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setGroupText"] = 0; };

/**
 * Sets the itemcount for containing items. This containing items are used only rarly
 * for controls that have items and containing items
 *
 * @public
 *
 * @param {int} iContainingItemCount The the number of containing items of a control.
 */
UCF_AccessibilityHelper["prototype"]["setContainingItemCount"] = function (iContainingItemCount) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setContainingItemCount"]++; }; 
	this["iContainingItemCount"] = iContainingItemCount;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setContainingItemCount"] = 0; };

/**
 * Sets the parent text.
 *
 * @public
 *
 * @param {string} sText The additional text of the parent control.
 */
UCF_AccessibilityHelper["prototype"]["setParentText"] = function (sText) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setParentText"]++; }; 
	this["sParentText"] = sText;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setParentText"] = 0; };

/**
 * Sets the parent text.
 *
 * @public
 *
 * @param {string} sTooltip The additional text of the parent control.
 */
UCF_AccessibilityHelper["prototype"]["setParentTooltip"] = function (sTooltip) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setParentTooltip"]++; }; 
	this["sParentTooltip"] = sTooltip;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setParentTooltip"] = 0; };

/**
 * Sets the controls type of the parent control to access the controls texts from MessageBundle properies file
 * Add an array aControlTypeParameters if you need to pass variables (like the itemcount) into the control type string
 * Itemlist with {0} items
 * In this exaple {0} is replaced with the text passed as sControlTypeValiables[0]
 *
 * @public
 *
 * @param {string} sControlType The control type of the control as it is used in the MessageBundle files
 * @param {Array}  aControlTypeVariables Variables to be replaced in the text
 */
UCF_AccessibilityHelper["prototype"]["setParentControlType"] = function (sControlType, aControlTypeVariables) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setParentControlType"]++; }; 

	this["sParentControlType"] = sControlType;
	this["aParentControlTypeVariables"] = aControlTypeVariables;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setParentControlType"] = 0; };

/**
 * Retrieves the text for the item position in the form
 * Item 1 of 7 items or Item 1 of 7 items containing 10 items
 *
 * @return {string} the text of item positon

 */
UCF_AccessibilityHelper["prototype"]["sGetItemPosition"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetItemPosition"]++; }; 
	if (this["iItemCount"] > 0 && this["iItemIndex"] > 0) {
		if (this["iContainingItemCount"] === 1) {
			return this["sGetText"]('ITMPOSCOUNT_SINGLE', ['' + this["iItemIndex"], '' + this["iItemCount"]]);
		} else if (this["iContainingItemCount"] > 0) {
			return this["sGetText"]("ITMPOSCOUNT", new Array("" + this["iItemIndex"], "" + this["iItemCount"], "" + this["iContainingItemCount"]));
		} else {
			if (this["sItemCountText"])
				return this["sGetText"](this["sItemCountText"], new Array("" + this["iItemIndex"], "" + this["iItemCount"]));
			else
				return this["sGetText"]("ITMPOS", new Array("" + this["iItemIndex"], "" + this["iItemCount"]));
		}
	}
	return "";
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetItemPosition"] = 0; };

/**
 * Returns the complete accessibility text
 *
 * @return {string} accessibility text
 */
UCF_AccessibilityHelper["prototype"]["sGetAccessibilityText"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetAccessibilityText"]++; }; 
	var sAccessibilityText = "",
		sSeparator = " " + this["sGetText"]("SEPARATOR") + " ",
		aStatusTexts = this["aGetStatusTexts"](),
		sSemantic = "",
		sStatusText = "",
		sLevel = "",
		aAccessibilityTexts = null;

	if (this["oLS"]["oSystem"]["sAccessibility"] === "ARIA" || this["oLS"]["oSystem"]["sAccessibility"] === "ARIA1.1")
		sSeparator = " ";

	sStatusText = aStatusTexts["join"](sSeparator);

	if (this["sSemanticText"]) sSemantic = this["sSemanticText"];
	else if (this["eSemantic"]) sSemantic = this["sGetText"](this["eSemantic"]);

	if (this["iLevel"] != null) sLevel = this["sGetText"]("LEVEL", [this["iLevel"]]);

	aAccessibilityTexts = [
		this["sParentText"],
		this["sGetParentControlTypeText"](),
		this["sParentTooltip"],
		this["sIconTooltip"],
		this["sGroupText"],
		this["sLabelText"],
		this["sText"],
		this["sAccessibilityDescription"],
		this["sGetControlTypeText"](),
		this["sValue"],
		sLevel,
		sStatusText,
		sSemantic,
		this["sGetItemPosition"](),
		this["sGetTooltip"](),
		this["sDataTip"],
		this["sRichTooltip"],
		this["sExplanationText"],
		this["sGetHotkeyText"](),
		this["sGetAccessKeyText"](),
		window["UCF_System"]["bAccTutor"] ? this["sGetTutorText"]() : ''
	];

	for (var i = 0; i < aAccessibilityTexts["length"]; i++) {
		if (aAccessibilityTexts[i] && aAccessibilityTexts[i]["length"] > 0) {
			if (sAccessibilityText["length"] > 0) sAccessibilityText += sSeparator;
			sAccessibilityText += aAccessibilityTexts[i];
		}
	}

	if (this["aContainerHelpers"]) {
		for (i = 0; i < this["aContainerHelpers"]["length"]; i++) {
			var sContainerAccText = this["aContainerHelpers"][i]["sGetAccessibilityText"]();
			if (sContainerAccText && sContainerAccText !== '')
				sAccessibilityText += sSeparator + sContainerAccText;
		}
	}
	return sAccessibilityText;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetAccessibilityText"] = 0; };

/**
 * Returns the skip container tutor text
 *
 * @return {string} a the skip container text
 */
UCF_AccessibilityHelper["prototype"]["sGetSkipContainerText"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetSkipContainerText"]++; }; 
	return this["oLS"]["bIsAlternativeKeyboardHandling"]() ? this["sGetText"]("SKIP_ALT") : this["sGetText"]("SKIP");
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetSkipContainerText"] = 0; };

/**
 * Returns true if container entry behaviour (Skipping) is already applied
 *
 * @return {boolean} container entry behaviour (Skipping) is already applied
 */
UCF_AccessibilityHelper["prototype"]["bIsContainerEntryBehaviourApplied"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["bIsContainerEntryBehaviourApplied"]++; }; 
	//Bitte nicht wegen Methodennamen toeten :(
	if (this["bContainerEntryBehaviourApplied"]) return true;

	if (this["aContainerHelpers"]) {
		for (var i = 0; i < this["aContainerHelpers"]["length"]; i++) {
			if (this["aContainerHelpers"][i]["bIsContainerEntryBehaviourApplied"]()) return true;
		}
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["bIsContainerEntryBehaviourApplied"] = 0; };

/**
 * Applies the behaviour of an container when the user enters the head
 * @public
 *
 * @param {boolean} bIsToggleContainer (optional) Specifies if the container can be expanded/collapsed in principle
 * @param {boolean} bEnabled (optional) Specifies if the container toggle functionality is enabled/disabled. Applies only when bIsToggleContainer is set.
 * @param {boolean} bCollapsed (optional) Reflects the collapse/expand state of the container. Applies only when bIsToggleContainer is set.
 */
UCF_AccessibilityHelper["prototype"]["applyContainerEntryBehaviour"] = function (bIsToggleContainer, bEnabled, bCollapsed) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["applyContainerEntryBehaviour"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!bIsToggleContainer || typeof (bEnabled) === "boolean", "!bIsToggleContainer || typeof (bEnabled) === \"boolean\"", "AccessibilityHelper.js(1116): applyContainerEntryBehaviour"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!bIsToggleContainer || typeof (bCollapsed) === "boolean", "!bIsToggleContainer || typeof (bCollapsed) === \"boolean\"", "AccessibilityHelper.js(1117): applyContainerEntryBehaviour"); };

	this["bContainerEntryBehaviourApplied"] = true;

	if (bIsToggleContainer) {

		//If container can be toggled in principle the state has to be announced
		if (bCollapsed) this["setCollapsed"](bCollapsed);
		else this["setExpanded"](!bCollapsed);

		if (bEnabled) {
			if (bCollapsed) {
				//SKIP and the EXPAND/COLLAPSE tutor is announced (No ENTER text because container is collapsed)
				this["addTutor"]("GROUPEXP_NO_ENTER_TUT_SI", [this["sGetSkipContainerText"]()]);
			} else {
				//SKIP, ENTER and the EXPAND/COLLAPSE tutor is announced
				this["addTutor"]("GROUPCOLL_TUT_SI", [this["sGetSkipContainerText"]()]);
			}
		} else {
			//Disabled -> announce no EXPAND/COLLAPSE tutor
			if (bCollapsed) {
				//Only announce the SKIP CONTAINER text (No ENTER text because container is collapsed)
				this["addTutor"](this["oLS"]["bIsAlternativeKeyboardHandling"]() ? "SKIP_ALT" : "SKIP");
			} else {
				//SKIP and ENTER text has to be announced
				this["addTutor"]("GROUP_TUT_SI", [this["sGetSkipContainerText"]()]);
			}
		}

	} else {
		//SKIP and ENTER text has to be announced also for non-toggleable containers
		this["addTutor"]("GROUP_TUT_SI", [this["sGetSkipContainerText"]()]);
	}
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["applyContainerEntryBehaviour"] = 0; };

/**
 * Returns the accesskey text
 *
 * @return {string} a the accesskey text
 */
UCF_AccessibilityHelper["prototype"]["sGetAccessKeyText"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetAccessKeyText"]++; }; 
	var sAccessKey = this["sAccessKey"];

	if (((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && (sAccessKey === "d" || sAccessKey === "D")) || UCF_UserAgent["bIsWebKit"]()) return ""; //hack for IE7: IE7 doesn't support ALT+D as accesskey

	if (sAccessKey && sAccessKey["length"] > 0) {
		if (UCF_UserAgent["bIsGecko"]())
			sAccessKey = "(" + this["sGetText"]("MODIFIER_KEY_ALT_SHIFT", sAccessKey) + ")"; //in FF the access key kombination is alt+shift
		else
			sAccessKey = "(" + this["sGetText"]("MODIFIER_KEY_ALT", sAccessKey) + ")";
	}

	return sAccessKey;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetAccessKeyText"] = 0; };

/**
 * Returns the hotkey text
 *
 * @return {string} a the hotkey text
 */
UCF_AccessibilityHelper["prototype"]["sGetHotkeyText"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetHotkeyText"]++; }; 
	return UCF_KeyboardHelper["sGetHotkeyText"](this["oLS"], this["sHotkey"]);
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetHotkeyText"] = 0; };

/**
 * Returns the text for a control type
 *
 * @return {string} a text for the control type
 */
UCF_AccessibilityHelper["prototype"]["sGetControlTypeText"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetControlTypeText"]++; }; 
	//Not every control has to announce the control type e.g. TextView
	return (this["sControlType"]) ? this["sGetText"](this["sControlType"], this["aControlTypeVariables"]) : "";
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetControlTypeText"] = 0; };

/**
 * Returns the control name only for a control type e.g. "CheckBoxGroup"
 * The function sGetControlTypeText would result CheckBoxGroup with x items.
 *
 * @see sGetControlTypeText
 * @return {string} a text for the control type
 */
UCF_AccessibilityHelper["prototype"]["sGetControlTypeShortText"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetControlTypeShortText"]++; }; 
	//Not every control has to announce the control type e.g. TextView
	if (!this["sControlType"]) return "";

	var shortText = this["oLS"]["sGetRawText"]("SAPUR_" + this["sControlType"] + "_SHORTNAME");

	return (shortText) ? shortText : this["sGetControlTypeText"]();
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetControlTypeShortText"] = 0; };
/**
 * Returns the text for the parent control type
 *
 * @return {string} a text for the control type
 */
UCF_AccessibilityHelper["prototype"]["sGetParentControlTypeText"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetParentControlTypeText"]++; }; 
	//Not every control has to announce the control type e.g. TextView
	return (this["sParentControlType"]) ? this["sGetText"](this["sParentControlType"], this["aControlTypeVariables"]) : "";
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetParentControlTypeText"] = 0; };

/**
 * Applies and/or formats the label text and the label's state and considering the acc decription and local label text.
 * The acc description has first priority and overwrites any other text info
 * Then the local label text is applied. After that the associated label (if present) applies its text.
 * Subsequently an optional sAdditionalLabelText is formated and concatenated
 *
 * Additionally the required state of a exiting label is applied.
 *
 * @param {Object} oControl
 * @param {string} sAccDescription the acc description which has to be announced instead of the label text
 * @param {string} sLocalLabelText the label text of the control itself
 * @param {string} sAdditionalLabelText Additional text which can be added
 */
UCF_AccessibilityHelper["prototype"]["applyLabelingInfo"] = function (oControl, sAccDescription, sLocalLabelText, sAdditionalLabelText) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["applyLabelingInfo"]++; }; 
	var oLabel = UCF_AriaStateHelper["oGetLabel"](this["oLS"], oControl["sId"]);

	if (sAccDescription) {
		this["setAccessibilityDescription"](sAccDescription);
	} else {
		var sLabelText = "";

		if (oLabel) {
			sLabelText = oLabel["sGetDisplayedText"]();
		} else if (sLocalLabelText) {
			sLabelText = sLocalLabelText;
		}

		if (sAdditionalLabelText) {
			if (sLabelText) sLabelText += " - ";
			sLabelText += sAdditionalLabelText;
		}

		this["setLabel"](sLabelText);
	}

	if (oLabel && UCF_JsUtil["bInstanceOf"](oLabel, "UCF_Label")) {
		if (oLabel["bGetRequired"]()) this["setRequired"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["applyLabelingInfo"] = 0; };

/**
 * Applies the highlight information of a control or segment
 *
 * @param {Map} mHighlightInfo
 */
UCF_AccessibilityHelper["prototype"]["applyHighlightInfo"] = function (mHighlightInfo) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["applyHighlightInfo"]++; }; 
	if (mHighlightInfo) {
		this["setHighlighted"](true);
		if (mHighlightInfo["sAccDescription"]) this["setHighlightDescription"](mHighlightInfo["sAccDescription"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["applyHighlightInfo"] = 0; };

/**
 * Sets a custom status text key for a control that is not covered with a standard setter.
 * Used for example to display "Sub Menu" for menu items
 *
 * @public
 *
 * @param {string} sTextKey The tutor text to be added.
 * @param {Array} aValues status values.
 */
UCF_AccessibilityHelper["prototype"]["setCustomStatusText"] = function (sTextKey, aValues) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setCustomStatusText"]++; }; 
	this["aCustomStatusValues"] = aValues;
	this["sCustomStatusText"] = sTextKey;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setCustomStatusText"] = 0; };

/**
 * Adds an additional tutor text
 *
 * @param {string} sTutor The tutor text to be added.
 * @param {Array} aValues Array of values for the placeholders
 */
UCF_AccessibilityHelper["prototype"]["addTutor"] = function (sTutor, aValues) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addTutor"]++; }; 
	if (!this["aTutor"]) this["aTutor"] = [];
	if (!UCF_JsUtil["contains"](this["aTutor"], this["sGetText"](sTutor, aValues)))
		this["aTutor"]["push"](this["sGetText"](sTutor, aValues));
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addTutor"] = 0; };

/**
 * Adds and additional tootip text
 *
 * @public
 *
 * @param {string} sTooltip The tooltip text to be added.
 */
UCF_AccessibilityHelper["prototype"]["addTooltip"] = function (sTooltip) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addTooltip"]++; }; 
	if (sTooltip === "")
		return;
	var contained = false;

	if (!this["aTooltip"]) this["aTooltip"] = [];
	for (var i = 0; i < this["aTooltip"]["length"]; i++)
		if (this["aTooltip"][i]["toUpperCase"]() === sTooltip["toUpperCase"]()) contained = true;

	if (!contained) this["aTooltip"]["push"](sTooltip);
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addTooltip"] = 0; };

/**
 * Adds an additional AccessibilityHelper of containers.
 *
 * @public
 *
 * @param {UCF_AccessibilityHelpers} oContainerHelper The AccessibilityHelper of a container of a control.
 */
UCF_AccessibilityHelper["prototype"]["addContainerHelper"] = function (oContainerHelper) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addContainerHelper"]++; }; 
	if (!this["aContainerHelpers"]) this["aContainerHelpers"] = [];
	this["aContainerHelpers"]["push"](oContainerHelper);
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addContainerHelper"] = 0; };

/**
 * Adds an additional tutor text if the given boolean parameter is true
 * Can be used for any tutor text that only applies it a control is enabled or selected
 *
 * @public
 *
 * @param {string} sTutor The tutor text to be added.
 * @param {boolean} bAddTutor The condition to be true for the sTutor to be added
 */
UCF_AccessibilityHelper["prototype"]["addEnabledTutor"] = function (sTutor, bAddTutor) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addEnabledTutor"]++; }; 
	if (bAddTutor) {
		this["addTutor"](sTutor);
	}
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["addEnabledTutor"] = 0; };

/**
 * Sets the dom ref of a legend control where the semantic color is mapped to a text.
 * @see UCF_Legend
 *
 * @public
 *
 * @param {element} oDomRef the dom ref of a legend control.
 */
UCF_AccessibilityHelper["prototype"]["setLegendJSDomRef"] = function (oDomRef) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setLegendJSDomRef"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "AccessibilityHelper.js(1350): setLegendJSDomRef"); };

	var sLegendText = UCF_DomUtil["sGetInnerText"](oDomRef);
	this["setLegend"](UCF_JsUtil["oJsonParse"](sLegendText));
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setLegendJSDomRef"] = 0; };

/**
 * Specify the map to be used for legend.
 * @public
 * @param {map} mLegendTexts Maps value to translated text.
 */
UCF_AccessibilityHelper["prototype"]["setLegend"] = function (mLegendTexts) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setLegend"]++; }; 
	this["oLegendTexts"] = mLegendTexts;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setLegend"] = 0; };

/**
 * Sets the accessibility description of a control
 *
 * @public
 *
 * @param {string} sAccDesc accessibility description of a control.
 */
UCF_AccessibilityHelper["prototype"]["setAccessibilityDescription"] = function (sAccDesc) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setAccessibilityDescription"]++; }; 

	this["sAccessibilityDescription"] = sAccDesc;

};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setAccessibilityDescription"] = 0; };

/**
 * Returns the tutor texts of the control
 *
 * @return {string} tutor texts
 */
UCF_AccessibilityHelper["prototype"]["sGetTutorText"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetTutorText"]++; }; 
	if (this["aTutor"]) {
		var sSeparator = " " + this["sGetText"]("SEPARATOR") + " ";
		return this["aTutor"]["join"](sSeparator);
	}
	return "";
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetTutorText"] = 0; };

/**
 * Returns the tooltip of the control
 *
 * @return {string} tooltip
 */
UCF_AccessibilityHelper["prototype"]["sGetTooltip"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetTooltip"]++; }; 
	if (this["aTooltip"]) {
		var sSeparator = " " + this["sGetText"]("SEPARATOR") + " ";
		return this["aTooltip"]["join"](sSeparator);
	}
	return "";
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetTooltip"] = 0; };

/**
 * Returns the status texts of the control
 *
 * @return status texts
 *
 * @type string
 */
// eslint-disable-next-line complexity
UCF_AccessibilityHelper["prototype"]["aGetStatusTexts"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["aGetStatusTexts"]++; }; 
	var aStatusTexts = [];
	if (this["aDataTypes"] && this["aDataTypes"]["length"] > 0) {
		for (var i = 0; i < this["aDataTypes"]["length"]; i++) {
			aStatusTexts["push"](this["aDataTypes"][i]);
		}
	}
	if (this["bAlert"]) aStatusTexts["push"](this["sGetText"]("ALERT"));
	if (this["bChecked"]) aStatusTexts["push"](this["sGetText"]("CHECKED"));
	if (this["bCollapsed"]) aStatusTexts["push"](this["sGetText"]("COLLAPSED"));
	if (this["bCompleted"]) aStatusTexts["push"](this["sGetText"]("COMPLETED"));
	if (this["bDynamic"]) aStatusTexts["push"](this["sGetText"]("DYNAMIC"));
	if (this["bEmpty"]) aStatusTexts["push"](this["sGetText"]("EMPTY"));
	if (this["bEnabled"] != null && !this["bEnabled"]) aStatusTexts["push"](this["sGetText"]("DISABLED"));
	if (this["bError"]) aStatusTexts["push"](this["sGetText"]("ERROR"));
	if (this["bExpanded"]) aStatusTexts["push"](this["sGetText"]("EXPANDED"));
	if (this["bInformation"]) aStatusTexts["push"](this["sGetText"]("INFORMATION"));
	if (this["bInvalid"]) aStatusTexts["push"](this["sGetText"]("INVALID"));
	if (this["bLoading"]) aStatusTexts["push"](this["sGetText"]("LOADING"));
	if (this["bNotChecked"]) aStatusTexts["push"](this["sGetText"]("NOTCHECKED"));
	if (this["bNotification"]) aStatusTexts["push"](this["sGetText"]("NOTIFICATION"));
	if (this["bNotToggled"]) aStatusTexts["push"](this["sGetText"]("NOTTOGGLED"));
	if (this["bNotSelected"]) aStatusTexts["push"](this["sGetText"]("NOTSELECTED"));
	if (this["bPressed"]) aStatusTexts["push"](this["sGetText"]("PRESSED"));
	if (this["bNotPressed"]) aStatusTexts["push"](this["sGetText"]("NOT_PRESSED"));
	if (this["bReadonly"]) aStatusTexts["push"](this["sGetText"]("READONLY"));
	if (this["bRecurring"]) aStatusTexts["push"](this["sGetText"]("RECURRING"));
	if (this["bRequired"]) aStatusTexts["push"](this["sGetText"]("REQUIRED"));
	if (this["bSelectable"]) aStatusTexts["push"](this["sGetText"]("SELECTABLE"));
	if (this["bSelected"]) aStatusTexts["push"](this["sGetText"]("SELECTED"));
	if (this["bSortable"]) aStatusTexts["push"](this["sGetText"]("SORTABLE"));
	if (this["bSortedAscending"]) aStatusTexts["push"](this["sGetText"]("SORTED_ASC"));
	if (this["bSortedDescending"]) aStatusTexts["push"](this["sGetText"]("SORTED_DESC"));
	if (this["bStop"]) aStatusTexts["push"](this["sGetText"]("STOP"));
	if (this["bSuccess"]) aStatusTexts["push"](this["sGetText"]("SUCCESS"));
	if (this["bTask"]) aStatusTexts["push"](this["sGetText"]("TASK"));
	if (this["bToday"]) aStatusTexts["push"](this["sGetText"]("TODAY"));
	if (this["bToggled"]) aStatusTexts["push"](this["sGetText"]("TOGGLED"));
	if (this["bUnchecked"]) aStatusTexts["push"](this["sGetText"]("UNCKECKED"));
	if (this["bUncompleted"]) aStatusTexts["push"](this["sGetText"]("UNMARKED"));
	if (this["bUndefined"]) aStatusTexts["push"](this["sGetText"]("UNDEFINED"));
	if (this["bMixed"]) aStatusTexts["push"](this["sGetText"]("MIXED"));
	if (this["bValid"]) aStatusTexts["push"](this["sGetText"]("VALID"));
	if (this["bWarning"]) aStatusTexts["push"](this["sGetText"]("WARNING"));
	if (this["bFiltered"]) aStatusTexts["push"](this["sGetText"]("F"));
	if (this["bHighlighted"]) {
		aStatusTexts["push"](this["sGetText"]("HIGHLIGHTED"));
		if (this["sHighlightDescription"]) aStatusTexts["push"](this["sHighlightDescription"]);
	}
	if (this["sCustomStatusText"]) aStatusTexts["push"](this["sGetText"](this["sCustomStatusText"], this["aCustomStatusValues"] || null));
	if (this["aSemantics"] && this["aSemantics"]["length"] > 0) {
		for (i = 0; i < this["aSemantics"]["length"]; i++) {
			aStatusTexts["push"](this["aSemantics"][i]);
		}
	}
	return aStatusTexts;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["aGetStatusTexts"] = 0; };

/**
 * Originally defined to set the accessibility role according to
 * http://www.w3.org/TR/wai-aria/#roles
 * @param {string} sRole a free string of a role (e.g. result of ControlTypeText)
 *
 */
UCF_AccessibilityHelper["prototype"]["setRole"] = function (sRole) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setRole"]++; }; 
	this["sRole"] = sRole;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["setRole"] = 0; };

/**
 * Sets the accessibility text to the title of the a given dom ref
 *
 * @param {element} oDomRef the dom ref where the title should be set.
 */
UCF_AccessibilityHelper["prototype"]["apply"] = function (oDomRef) {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["apply"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "AccessibilityHelper.js(1486): apply"); };
	var sText = this["sGetAccessibilityText"]();
	if (sText === "") return;
	oDomRef["setAttribute"]("title", sText);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "ACCTEXT = " + sText, "AccessibilityHelper.js(1490): apply"); };
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["apply"] = 0; };

UCF_AccessibilityHelper["prototype"]["sGetExtendedTextForARIA"] = function () {;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetExtendedTextForARIA"]++; }; 
	var sAccessibilityText = "",
		sSeparator = " ";
	if (this["aContainerHelpers"]) {
		for (var i = 0; i < this["aContainerHelpers"]["length"]; i++) {
			var sContainerAccText = this["aContainerHelpers"][i]["sGetAccessibilityText"]();
			if (sContainerAccText && sContainerAccText !== '')
				sAccessibilityText += sSeparator + sContainerAccText;
		}
	}
	if (sAccessibilityText === "" && (this["sControlType"] === "DG" || this["sControlType"] === "DGSC" || this["sControlType"] === "DGSC_HDR" ||
		(this["sControlType"] && this["sControlType"]["indexOf"]("ST") === 0))) {
		// this.sText = null;
		sAccessibilityText = this["sGetAccessibilityText"]();
	}
	return sAccessibilityText;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityHelper["_"]["sGetExtendedTextForARIA"] = 0; };

UCF_AccessibilityHelper.prototype["aPublicMethods"] = ["setControlType","setAccessKey","setHotkey","setEnabled","setSelectable","setSelected","setNotSelected","setChecked","setNotChecked","setCompleted","setSuccess","setError","setInformation","setNotification","setTask","setLoading","setRequired","setFiltered","setInvalid","setUncompleted","setReadonly","setToday","setUndefined","setMixed","setValid","setWarning","setUnchecked","setDynamic","setEmpty","setSortedAscending","setSortedDescending","setSortable","setStop","setExpanded","setCollapsed","setToggled","setNotToggled","setHighlighted","setHighlightDescription","setAlert","setRecurring","setItemCount","setItemCountText","setLevel","setTooltip","setText","setValue","setLabel","setDataTip","setRichTooltip","setExplanationText","addDataType","addSemantic","setIconTooltip","setGroupText","setContainingItemCount","setParentText","setParentTooltip","setParentControlType","applyContainerEntryBehaviour","setCustomStatusText","addTooltip","addContainerHelper","addEnabledTutor","setLegendJSDomRef","setLegend","setAccessibilityDescription"].concat(UCF_AccessibilityHelper.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_AccessibilityInfo"] = function() {/* global _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * Shows or hides an accessibility info pane
 *
 * @class
 * 
 * @version
 */
function UCF_AccessibilityInfo() {if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["UCF_AccessibilityInfo"]++; }; 
	UCF_Object["apply"](this);
	this["bRunning"] = false;
};window["UCF_AccessibilityInfo"] = UCF_AccessibilityInfo; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AccessibilityInfo"); UCF_AccessibilityInfo["_"] = {UCF_AccessibilityInfo: 0}; }; ;
UCF_AccessibilityInfo["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_AccessibilityInfo.prototype["sClassName"] = "UCF_AccessibilityInfo";

/**
 * @private
 */
UCF_AccessibilityInfo["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["destroy"]++; }; 
	this["oDiv"] = null;
	this["oHelperInterval"] = null;
	this["sOut"] = null;
	this["eventForwarder"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["destroy"] = 0; };

/**
 * Trigger method which is called by the debug handler when shortcut is pressed
 * @private
 */
UCF_AccessibilityInfo["prototype"]["trigger"] = function() {;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["trigger"]++; }; 
	// Toggle display on and off
	if (!this["bRunning"]) {
		this["start"]();
	} else {
		this["stop"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["trigger"] = 0; };

/**
 * shows the info pane
 * @private
 */
UCF_AccessibilityInfo["prototype"]["start"] = function() {;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["start"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Show Accesibility Info", "AccessibilityInfo.js(54): eventForwarder"); };

	if (__UCF_DEBUG__) {
		var oDoc = UCF_DomUtil["oGetDocument"]();

		var oDiv = oDoc["createElement"]("div");

		UCF_DomUtil["setStyle"](oDiv, {
			"position": "absolute",
			"left": "10px",
			"height": "2em", // STES, must be relative units
			"color": "#000", // STES, otherwise in System HighContrast Settings the text is not readable
			"backgroundColor": "#FF7",
			"border": "1px solid #888",
			"margin": "3px",
			"padding": "2px",
			"overflow": "auto",
			"fontSize": "0.7em",
			"zIndex": 9999
		});

		UCF_DomUtil["setOpacityStyle"](oDiv, 100);

		if (window["UCF_System"]["bIs508"] || window["UCF_System"]["sAccessibility"]["indexOf"]('ARIA') === 0) {
			UCF_DomUtil["setInnerHtml"](oDiv, "Accessibility Info - Ready");
		} else {
			UCF_DomUtil["setInnerHtml"](oDiv, "Accessibility Info - Accessibility mode is disabled");
		}
		oDoc["body"]["appendChild"](oDiv);

		this["oDiv"] = oDiv;
		UCF_DomUtil["attachEvent"](this["oDiv"], "selectstart", function() { return false; });

		this["updatePanePosition"]();

		var oHelper = this;
		this["sOut"] = "";

		if (window["UCF_System"]["bIs508"] || window["UCF_System"]["sAccessibility"]["indexOf"]('ARIA') === 0) {
			this["oHelperInterval"] = setInterval(function() { oHelper["updateAccessibilityInfo"](); }, 250);
		}

		this["eventForwarder"] = function() {
			oHelper["onScrollOrResize"]();
		};

		UCF_DomUtil["attachEvent"](oDiv, "click", function() {
			if (window["clipboardData"] && window["clipboardData"]["setData"]) {
				window["clipboardData"]["setData"]("Text", oHelper["sOut"]);
			}
			return false;
		});

		UCF_DomUtil["attachEvent"](window, "scroll", this["eventForwarder"]);
		UCF_DomUtil["attachEvent"](window, "resize", this["eventForwarder"]);
		this["bRunning"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["start"] = 0; };

/** hides the info pane
 * @private
 */
UCF_AccessibilityInfo["prototype"]["stop"] = function() {;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["stop"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Hide Accesibility Info", "AccessibilityInfo.js(117): stop"); };
	var oDoc = UCF_DomUtil["oGetDocument"]();
	oDoc["body"]["removeChild"](this["oDiv"]);
	if (this["oHelperInterval"]) {
		clearInterval(this["oHelperInterval"]);
	}
	UCF_DomUtil["detachEvent"](window, "scroll", this["eventForwarder"]);
	UCF_DomUtil["detachEvent"](window, "resize", this["eventForwarder"]);
	this["bRunning"] = false;
};;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["stop"] = 0; };

/**
 * Update the the text displayed in the info pane
 * @private
 */
UCF_AccessibilityInfo["prototype"]["updateAccessibilityInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["updateAccessibilityInfo"]++; }; 
	try {
		var oDoc = UCF_DomUtil["oGetDocument"](),
			sOut;

		if (oDoc["activeElement"] && oDoc["activeElement"] === this["oDiv"]) return;

		if (window["UCF_System"]["sAccessibility"] === "ARIA" || window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
			sOut = "ARIAINFO: No text available";

			if (oDoc["activeElement"]) sOut = window["UCF_System"]["sAccessibility"] + ": " + UCF_DomUtil["sGetARIAInfo"](oDoc["activeElement"]);
			else if (oDoc["activeElement"] === oDoc["body"]) sOut = "ARIA Info - Ready";

		} else {
			sOut = "ACC: No text available";

			oDoc = UCF_DomUtil["oGetDocument"]();
			if (oDoc["activeElement"]["localName"] === "iframe") {
				var local_tmp;
				local_tmp = oDoc["activeElement"]["contentWindow"]["self"]["document"];
				oDoc = local_tmp;
			}
			if (oDoc["activeElement"] && oDoc["activeElement"]["title"]) sOut = "ACC: " + oDoc["activeElement"]["title"];
			else if (oDoc["activeElement"] === oDoc["body"]) sOut = "Accessibility Info - Ready";

		}

		UCF_DomUtil["setInnerHtml"](this["oDiv"], UCF_XSSEncoder["encodeHTML"](sOut));

		//changed logging to avoid too many noise in the log
		if (this["sOut"] !== sOut) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Update Accessibility Info - " + sOut, "AccessibilityInfo.js(163): updateAccessibilityInfo"); };
			this["sOut"] = sOut;
		}

	} catch (e) {} // suppress any errors
};;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["updateAccessibilityInfo"] = 0; };

/**
 * Scroll event handler
 * @private
 */
UCF_AccessibilityInfo["prototype"]["onScrollOrResize"] = function() {;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["onScrollOrResize"]++; }; 

	this["updatePanePosition"]();
};;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["onScrollOrResize"] = 0; };

/**
 * Update the position of the info pane on the screen
 * @private
 */
UCF_AccessibilityInfo["prototype"]["updatePanePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["updatePanePosition"]++; }; 
	this["oDiv"]["style"]["top"] = UCF_DomUtil["iClientHeight"]() - this["oDiv"]["offsetHeight"] - 6 + UCF_DomUtil["oGetScrollOffset"]()["y"] + "px";
	this["oDiv"]["style"]["width"] = UCF_DomUtil["iClientWidth"]() - 20 + "px";
};;if (__UCF_COVERAGE__) { UCF_AccessibilityInfo["_"]["updatePanePosition"] = 0; };

};
sap["ls"]["preload"]["UCF_Accordion"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Animation */
/// <reference path="../anim/Animation.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_AccordionDragDelegate */
/// <reference path="./delegates/AccordionDragDelegate.js"/>
/* global UCF_AccordionDropDelegate */
/// <reference path="./delegates/AccordionDropDelegate.js"/>
/* global UCF_AccordionItem */
/// <reference path="./AccordionItem.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>

/**
 * 
 * @version
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Accordion(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Accordion["_"]["UCF_Accordion"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Accordion.js(46): UCF_Accordion"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Accordion.js(47): UCF_Accordion"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Accordion.js(48): UCF_Accordion"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]);
	//this.oItemNavigation.attachEvent(this.oItemNavigation.E_EVENTS.Activate, this, 'onPanelActivate');
	this["oItemNavigation"]["setNavigateInLoop"](false);

	//create the item array and navigation fields
	this["createItems"]();

	// // Per "Konvention" scrollable areas should use the lsscrl-Attribute
	// // but Accordion is the only control that uses a "-scrl" element without creating a ScrollArea instance in some cases
	// // because initialize() is not called => We add the attribute here...
	// if (this.sVerticalSizing == "FILL" && this.iSelectedItemIndex > -1) {
	// 	var oSelected = this.aItems[this.iSelectedItemIndex];
	// 	var oScrollDomRef = UCF_DomUtil.$(oSelected.sId + "-scrl");
	// 	if (oScrollDomRef) {
	// 		oScrollDomRef.setAttribute( /*UCF_ScrollArea.ScrollAttribute*/ "lsscrl", "true");
	// 	}
	// }

	this["iFocus"] = null;
	this["bIsRefocused"] = false;

	//create drag and drop fields
	this["bHasDragDelegate"] = false;
	this["iToggledIndex"] = -1;
	this["bEditModeOn"] = false;

	//create inplace edit objects and fields
	this["oEditItem"] = null;

	//create animation objects and fields
	var iTimeout = (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) ? 300 : 500;
	this["oExpand"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))();
	this["oExpand"]["setTime"](iTimeout);
	this["oCollapse"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))();
	this["oCollapse"]["setTime"](iTimeout);
	this["iAnimsFinished"] = 0;
	this["bLocked"] = false;

	this["bHtmlTableCorrectionDone"] = false;
	this["oAriaHeading"] = UCF_DomUtil["$"](this["sId"] + '-heading');

	//create scroll area helper
	if (this["sVerticalSizing"] === "FILL" && this["iSelectedItemIndex"] > -1) {
		var oSelected = this["aItems"][this["iSelectedItemIndex"]];
		var oScrollDomRef = UCF_DomUtil["$"](oSelected["sId"] + "-scrl");
		// Per "Konvention" scrollable areas should use the lsscrl-Attribute
		// but Accordion is the only control that uses a "-scrl" element without creating a ScrollArea instance in some cases
		// because initialize() is not called => We add the attribute here...
		if (oScrollDomRef) {
			oScrollDomRef["setAttribute"]( /*UCF_ScrollArea.ScrollAttribute*/ "lsscrl", "true");
		}
		this["oScrollArea"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(oScrollDomRef); // eslint-disable-line @ur/no-memory-leaks
		this["attachBrowserEvent"]("scroll", oScrollDomRef);
		this["oScrollArea"]["attachEvent"](this["oScrollArea"]["E_EVENTS"]["Scroll"], this, "onScroll");
		this["addDelegate"](this["oScrollArea"]);

	}

};window["UCF_Accordion"] = UCF_Accordion; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Accordion"); UCF_Accordion["_"] = {UCF_Accordion: 0}; }; ;

UCF_Accordion["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Accordion.prototype["sClassName"] = "UCF_Accordion";

/**
 * Initializes the control, if the selected item has a predefined scroll position.
 * If so, only the selected item will be affected.
 * @private
 */
UCF_Accordion["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["initialize"]++; }; 

	if (UCF_DomUtil["bCheckStandardsCorrection"]() && !this["bHtmlTableCorrectionDone"]) {
		UCF_DomUtil["initHtmlTableCorrection"](UCF_DomUtil["$"](this["sId"] + "-innerTab"));
		this["bHtmlTableCorrectionDone"] = true;
	}

	if (this["aItems"] == null) {
		this["createItems"]();
	}

	if (this["oScrollArea"] == null) return;
	this["setScrollPosition"]();
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["initialize"] = 0; };

/**
 * Handles the click event of the browser. The following handle the click event:
 * - Toggling
 * - ScrollPosition
 * - Focus
 * - Select / Deselect event
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Accordion["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onclick"]++; }; 
	var iIndex = this["iGetNavIndex"](oBrowserEvent),
		oItem = oBrowserEvent["oGetSourceControl"](),
		oSource = oBrowserEvent["oGetSource"]();

	//_trace(INFO, "### iIndex=" + iIndex + ", oItem.iIndex=" + oItem.iIndex + ", this.iSelectedItemIndex=" + this.iSelectedItemIndex);

	if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_AccordionItem") && !oItem["bHasEditableTitle"] ||
		(oItem["bHasEditableTitle"] && oSource !== UCF_DomUtil["$"](oItem["sId"] + "-textedit"))) {

		var bToggleIconClicked = (oSource === UCF_DomUtil["$"](oItem["sId"] + "-tgl"));

		if (!this["bAllowMultipleSelection"]) {
			//fire the deselect
			if (this["bAllowDeselect"] && oItem["iIndex"] === this["iSelectedItemIndex"]) {
				this["fireDeselect"](this["sId"], this["aItems"][this["iSelectedItemIndex"]]["sId"], bToggleIconClicked);
			}
			//fire select
			if (oItem["iIndex"] !== this["iSelectedItemIndex"] && oItem["bEnabled"]) {
				this["fireSelect"](this["sId"], oItem["sId"], bToggleIconClicked);
			}
		} else {
			// mult. selection: this.iSelectedItemIndex is NOT used - see toggleItemIndex() !
			//                  this.setClientProperty("SelectedItemIndex",this.iSelectedItemIndex,true);
			if (oItem["bExpandForMultipleSelection"]) {
				this["fireDeselect"](this["sId"], oItem["sId"], bToggleIconClicked);
			} else {
				this["fireSelect"](this["sId"], oItem["sId"], bToggleIconClicked);
			}
		}

		//depending on whether the editable titla was clicked or not
		//the focus of the item navigation is set to the clicked title
		this["setFocus"](iIndex);
	}

	if (this["bAllowToggle"](oBrowserEvent)) {

		this["toggleItem"](oItem);
	}
	//the scroll position of the content area.
	this["setScrollPosition"]();
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onclick"] = 0; };

/**
 * Handles [ENTER] and [SPACE]
 * Handles the item selection by keyboard. Handles the following functions of the control:
 * - Toggling
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Accordion["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsselect"]++; }; 
	var oItem = oBrowserEvent["oGetSourceControl"]();
	var bToggleIconClicked = true;

	if (!UCF_JsUtil["bInstanceOf"](oItem, "UCF_AccordionItem")) return;

	if (!this["bAllowMultipleSelection"]) {
		//fire the deselect
		if (this["bAllowDeselect"] && oItem["iIndex"] === this["iSelectedItemIndex"]) {
			this["fireDeselect"](this["sId"], this["aItems"][this["iSelectedItemIndex"]]["sId"], bToggleIconClicked);
		}
		//fire select
		if (oItem["iIndex"] !== this["iSelectedItemIndex"] && oItem["bEnabled"]) {
			this["fireSelect"](this["sId"], oItem["sId"], bToggleIconClicked);
		}
	} else {
		// mult. selection: this.iSelectedItemIndex is NOT used - see toggleItemIndex() !
		if (oItem["bExpandForMultipleSelection"]) {
			this["fireDeselect"](this["sId"], oItem["sId"], bToggleIconClicked);
		} else {
			this["fireSelect"](this["sId"], oItem["sId"], bToggleIconClicked);
		}
	}
	if (this["bAllowToggle"](oBrowserEvent)) {

		this["toggleItem"](oItem);

		this["setScrollPosition"]();
		oBrowserEvent["cancel"]();

	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsselect"] = 0; };

/**
 * Collapses or Expands (does not toogle) the current AccordionItem
 * If the item is already collpased and bShouldCollpase: true, then nothing will be done
 * If the item is already expanded and bShouldCollpase: false, then nothing will be done
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {boolean} bShouldCollapse - if the item should be collapse or expand
 * @private
 */

UCF_Accordion["prototype"]["triggerExpandOrCollapse"] = function(oBrowserEvent, bShouldCollapse) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["triggerExpandOrCollapse"]++; }; 
	var oItem = oBrowserEvent["oGetSourceControl"]();

	if (!UCF_JsUtil["bInstanceOf"](oItem, "UCF_AccordionItem")) return;

	// check if the should process further
	if (bShouldCollapse) {
		if (!(!this["bAllowMultipleSelection"] && this["bAllowDeselect"] && oItem["iIndex"] === this["iSelectedItemIndex"])
			|| (this["bAllowMultipleSelection"] && oItem["bExpandForMultipleSelection"])) {
			oBrowserEvent["cancel"]();
			return;
		}

	} else {
		if (!(!this["bAllowMultipleSelection"] && oItem["iIndex"] !== this["iSelectedItemIndex"] && oItem["bEnabled"])
			|| (this["bAllowMultipleSelection"] && !oItem["bExpandForMultipleSelection"])) {
			oBrowserEvent["cancel"]();
			return;
		}
	}

	var bToggleIconClicked = true;

	if (bShouldCollapse) {
		this["fireDeselect"](this["sId"], oItem["sId"], bToggleIconClicked);
	} else {
		this["fireSelect"](this["sId"], oItem["sId"], bToggleIconClicked);
	}

	if (this["bAllowToggle"](oBrowserEvent)) {

		this["toggleItem"](oItem);

		this["setScrollPosition"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["triggerExpandOrCollapse"] = 0; };

/**
 * Press [-] for collapsing the Accordion Item
 * Handles the collapse event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Accordion["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlscollapse"]++; }; 
	this["triggerExpandOrCollapse"](oBrowserEvent, true);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlscollapse"] = 0; };

/**
 * Press[+] for collapsing the Accordion Item
 * Handles the expand event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Accordion["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsexpand"]++; }; 
	this["triggerExpandOrCollapse"](oBrowserEvent, false);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsexpand"] = 0; };

/*********************************************************************
 * Scroll Section
 **********************************************************************/

/**
 * Sets the left/top scroll positions of an items' content.
 * Needs the selected item to do so.
 * @private
 */
UCF_Accordion["prototype"]["setScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setScrollPosition"]++; }; 

	var iSelcted = this["iSelectedItemIndex"];
	if (iSelcted === -1) return;
	var oSelected = this["aItems"][iSelcted];
	if (oSelected["iScrollTop"] < 1 && oSelected["iScrollLeft"] < 1) return;
	this["oScrollArea"]["oDomRef"] = UCF_DomUtil["$"](oSelected["sId"] + "-scrl");
	this["oScrollArea"]["setScrollPosition"](oSelected["iScrollTop"], oSelected["iScrollLeft"]);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setScrollPosition"] = 0; };

/**
 * Handle the area scroll event
 *
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_Accordion["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onScroll"]++; }; 

	if (this["iSelectedItemIndex"] < 0) return;

	var iScrollTop = oEvent["oGetParam"]("iScrollTop"),
		iScrollLeft = oEvent["oGetParam"]("iScrollLeft"),
		oSelected = this["aItems"][this["iSelectedItemIndex"]],
		oScrollContainer = UCF_DomUtil["$"](oSelected["sId"] + "-scrl");

	if (oScrollContainer["offsetHeight"] !== oScrollContainer["scrollHeight"]
		|| oScrollContainer["offsetWidth"] !== oScrollContainer["scrollWidth"]) {
		this["fireScroll"](this["sId"], oSelected["sId"], iScrollTop, iScrollLeft);
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onScroll"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_Accordion["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["destroy"]++; }; 
	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}

	if (this["sVerticalSizing"] === "FILL") {
		this["oExpand"]["stop"]();
		this["oCollapse"]["stop"]();
		this["removeBlindLayer"]();
	}

	this["iFocus"] = null;
	this["iToggledIndex"] = 0;
	if (this["oExpand"]) {
		this["oExpand"]["destroy"]();
		this["oExpand"] = null;
	}
	if (this["oCollapse"]) {
		this["oCollapse"]["destroy"]();
		this["oCollapse"] = null;
	}
	this["iSelectedItemIndex"] = 0;
	this["oExpandDomRef"] = null;
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}
	if (this["oItemNavigation"]) {
		this["oItemNavigation"]["destroy"]();
		this["oItemNavigation"] = null;
	}
	this["oAriaHeading"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["destroy"] = 0; };

/*********************************************************************
 * Toggle Section: all functions of the accordion typic expand/collapse animation
 **********************************************************************/

/**
 * 	Toggle is allowed if: item is enabled,
 *  it has no editable title, or it has an editable title but
 *  the title text was not clicked.
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @return {boolean}
 * @private
 */
UCF_Accordion["prototype"]["bAllowToggle"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["bAllowToggle"]++; }; 

	var oItem = oBrowserEvent["oGetSourceControl"](),
		oSource = oBrowserEvent["oGetSource"](),
		oTextEdit = UCF_DomUtil["$"](oItem["sId"] + "-textedit");

	if (this["bAllowSelect"] && UCF_JsUtil["bInstanceOf"](oItem, "UCF_AccordionItem")) {
		if (oItem["bEnabled"]) {
			if (this["bAllowMultipleSelection"] || (oItem["iIndex"] === this["iSelectedItemIndex"] && this["bAllowDeselect"]) ||
				oItem["iIndex"] !== this["iSelectedItemIndex"]) {

				if (!oItem["bHasEditableTitle"] || (oItem["bHasEditableTitle"] && oSource !== oTextEdit)) {
					if (!this["bEditModeOn"]) {
						return true;
					}
				}
			}
		}
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["bAllowToggle"] = 0; };

/**
 * Public function to trigger toggle animation programmatically.
 * @param {string} sId - the id of the accordion
 * @param {int} iExpand the index of the item to be expanded
 * @public
 */
UCF_Accordion["prototype"]["ToggleItems"] = function(sId, iExpand) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["ToggleItems"]++; }; 

	if (!iExpand) return;

	var oExpanded = this["aItems"][iExpand];

	this["toggleItem"](oExpanded);

};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["ToggleItems"] = 0; };

UCF_Accordion["prototype"]["toggleItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["toggleItem"]++; }; 

	if (this["sVerticalSizing"] === "FILL") {
		this["toggleFilled"](oItem);
	} else if (this["sVerticalSizing"] === "PUSH") {
		this["togglePushed"](oItem);
	}

	if (this["oAriaHeading"])
		UCF_DomUtil["setInnerHtml"](this["oAriaHeading"], UCF_XSSEncoder["encodeHTML"](oItem["sTitle"]));

	this["toggleHeader"](oItem);
	this["toggleItemIndex"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["toggleItem"] = 0; };

/**
 * Returns an array of AccordionItem controls.
 * @return {Array} an array of AccordionItem controls.
 * @public
 */
UCF_Accordion["prototype"]["aGetItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["aGetItems"]++; }; 
	var aResult = [];
	for (var i = 0; i < this["aItems"]["length"]; i++) {
		aResult["push"](this["aItems"][i]["oGetInterface"]());
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["aGetItems"] = 0; };

/**
 * Toggles the accordion items if VerticalSizing is set to FILL
 * @param {UCF_AccordionItem} oItem - the item to be toggled
 * @private
 */
UCF_Accordion["prototype"]["toggleFilled"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["toggleFilled"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oItem) === "object", "typeof(oItem) === \"object\"", "Accordion.js(462): toggleFilled"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_AccordionItem, "oItem instanceof UCF_AccordionItem", "Accordion.js(463): toggleFilled"); };

	var iSelected = this["iSelectedItemIndex"],
		oExpanded = (iSelected > -1) ? this["aItems"][iSelected]["oContent"] :
		UCF_DomUtil["$"](this["sId"] + "-empty"),

		oCollapsed = (oItem["iIndex"] !== iSelected) ? oItem["oContent"] :
		UCF_DomUtil["$"](this["sId"] + "-empty");

	if (window["UCF_System"]["sDevice"] === "standards" && UCF_UserAgent["bIsIE"]()) {
		//todo: check animation not running proper in standards mode in IE
		//todo: check endless loop in UCF_DomUtil.updateHtmlTableCorrection while running animation
		oExpanded["style"]["display"] = "none";
		oExpanded["style"]["height"] = "0%";
		var oExpandedScrlRef = UCF_DomUtil["$"](oExpanded["id"]["split"]("-cnt")[0] + "-scrl");
		if (oExpandedScrlRef) {
			oExpandedScrlRef["style"]["overflow"] = "hidden";
		}
		if (__UCF_IE6__)
			oCollapsed["style"]["display"] = "table-header-group";
		else
			oCollapsed["style"]["display"] = "table-row";
		oCollapsed["style"]["height"] = "100%";
		var oCollapsedScrlRef = UCF_DomUtil["$"](oCollapsed["id"]["split"]("-cnt")[0] + "-scrl");
		if (oCollapsedScrlRef) {
			oCollapsedScrlRef["style"]["overflow"] = "auto";
		}

		UCF_DomUtil["initHtmlTableCorrection"](UCF_DomUtil["$"](this["sId"] + "-innerTab"));
	} else {
		if (!UCF_UserAgent["bIsWebKit"]() || window["UCF_System"]["bUseAnimation"]) {
			this["lock"]();
			this["expand"](oCollapsed, "%", 0, 100);
			this["collapse"](oExpanded, "%", 100, 0);
		} else {
			if (__UCF_IE6__)
				oCollapsed["style"]["display"] = "table-header-group";
			else
				oCollapsed["style"]["display"] = "table-row";
			oExpanded["style"]["display"] = "none";
		}
	}

	if (window["UCF_System"]["bIsAria"]) {
		oCollapsed = oItem["oContent"];
		var sIdColl = oCollapsed["getAttribute"]('id')["split"]('-')[0];
		UCF_AriaStateHelper["setExpanded"](UCF_DomUtil["$"](sIdColl + '-title'), true);

		if (iSelected > -1) {
			oExpanded = this["aItems"][iSelected]["oContent"];
			var sIdExp = oExpanded["getAttribute"]('id')["split"]('-')[0];
			UCF_AriaStateHelper["setExpanded"](UCF_DomUtil["$"](sIdExp + '-title'), false);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["toggleFilled"] = 0; };

/**
 * Toggles the accordion items if VerticalSizing is set to PUSH.
 * Destinguishes between AllowMultipleSeletion TRUE | FALSE
 * @param {UCF_AccordionItem} oItem - the item to be toggled
 * @private
 */
UCF_Accordion["prototype"]["togglePushed"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["togglePushed"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oItem) === "object", "typeof(oItem) === \"object\"", "Accordion.js(526): togglePushed"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_AccordionItem, "oItem instanceof UCF_AccordionItem", "Accordion.js(527): togglePushed"); };

	var oExpanded = null,
		oCollapsed = null,
		bCollapse = false,
		bExpand = false,
		oExpandedScrl = null,
		oCollapsedScrl = null,
		oTd = null;

	if (!this["bAllowMultipleSelection"]) {

		if (this["iSelectedItemIndex"] > -1) {
			oExpanded = this["aItems"][this["iSelectedItemIndex"]];
		} else {
			oExpanded = oItem;
		}

		if (oExpanded) {
			oExpandedScrl = UCF_DomUtil["$"](oExpanded["sId"] + "-scrl");
		}

		oCollapsed = oItem;
		oCollapsedScrl = UCF_DomUtil["$"](oCollapsed["sId"] + "-scrl");

		bExpand = this["iSelectedItemIndex"] !== oItem["iIndex"];
		bCollapse = oExpanded != null;

	} else {
		oExpanded = oItem;
		oCollapsed = oItem;
		oExpandedScrl = UCF_DomUtil["$"](oExpanded["sId"] + "-scrl");
		oCollapsedScrl = UCF_DomUtil["$"](oCollapsed["sId"] + "-scrl");
		bCollapse = oItem["bExpandForMultipleSelection"];
		bExpand = !oItem["bExpandForMultipleSelection"];
	}

	/*
	overflow eigenschaften müssen wahrscheinlich durch call back gesetzt werden
	if (UCF_System.bUseAnimation) {
		this.lock();

		oCollapsed.oContent.style.height = "";
		oCollapsedScrl.style.height = "";
		oCollapsedScrl.style.overflow = "";

		this.expand(oCollapsed.oContent, "px", 1, oCollapsedScrl.scrollHeight);//oDomRef, sUnits, iStartValue, iEndValue)
		this.collapse(oExpanded.oContent, "px", oExpandedScrl.offsetHeight, 1);
	}*/

	if (bCollapse) {
		oExpandedScrl["style"]["overflow"] = "hidden";
		oExpanded["oContent"]["style"]["height"] = "1px";
		oExpanded["oContent"]["style"]["visibility"] = "hidden";
		oTd = UCF_DomUtil["firstChild"](oExpanded["oContent"], "TD");
		oTd["className"] = "lsAcrCntCollapsed";
		UCF_DomUtil["firstChild"](oTd, "DIV")["className"] = "";
		oExpandedScrl["style"]["height"] = window["UCF_System"]["sUserAgentName"] === "MSIE" ? "1px" : "0px";

		if (oExpanded["bHasContentPadding"]) {
			UCF_DomUtil["removeClass"](oExpandedScrl, "lsAcrCntPadding lsResponsivePadding");
			UCF_DomUtil["removeClass"](oExpandedScrl, "lsAcrCntPaddingEmph lsResponsivePadding");
			UCF_DomUtil["addClass"](oExpandedScrl, "lsAcrCntPaddingPush");
			//oExpandedScrl.style.padding = "0px 7px 0px 7px";
		}

		UCF_DomUtil["firstChild"](oExpanded["oDomRef"], "TD")["style"]["borderBottomStyle"] = "none";
	}

	if (bExpand) {
		oCollapsed["oContent"]["style"]["height"] = "100%";
		oCollapsed["oContent"]["style"]["visibility"] = "visible";
		var cn = "lsAcrCnt";
		if (oItem["sGetItemDesign"]() !== "STANDARD") {
			cn += " lsAcrCntEmph";
		}
		oTd = UCF_DomUtil["firstChild"](oCollapsed["oContent"], "TD");
		oTd["className"] = cn;
		if (oItem["sGetItemDesign"]() !== "STANDARD") {
			UCF_DomUtil["firstChild"](oTd, "DIV")["className"] = "lsAcrCntEmphBrd";
		}
		oCollapsedScrl["style"]["height"] = "";
		oCollapsedScrl["style"]["overflow"] = "";

		if (oCollapsed["bHasContentPadding"]) {
			if (oItem["sGetItemDesign"]() !== "STANDARD") {
				// EMPHASIZED: substract 2px border width from padding
				UCF_DomUtil["removeClass"](oCollapsedScrl, "lsAcrCntPadding lsResponsivePadding");
				UCF_DomUtil["removeClass"](oCollapsedScrl, "lsAcrCntPaddingPush");
				UCF_DomUtil["addClass"](oCollapsedScrl, "lsAcrCntPaddingEmph lsResponsivePadding");
				//oCollapsedScrl.style.padding = "1px 5px 5px 5px";
			} else {
				UCF_DomUtil["removeClass"](oCollapsedScrl, "lsAcrCntPaddingEmph lsResponsivePadding");
				UCF_DomUtil["removeClass"](oCollapsedScrl, "lsAcrCntPaddingPush");
				UCF_DomUtil["addClass"](oCollapsedScrl, "lsAcrCntPadding lsResponsivePadding");
				//oCollapsedScrl.style.padding = "3px 7px 7px 7px";
			}
		}

		UCF_DomUtil["firstChild"](oCollapsed["oDomRef"], "TD")["style"]["borderBottomStyle"] = "solid";
	}

};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["togglePushed"] = 0; };

/**
 * Toggles the closed / open icon in the accordion title
 * @param {UCF_AccordionItem} oClickedHeader - the header to be toggled
 * @private
 */
UCF_Accordion["prototype"]["toggleHeader"] = function(oClickedHeader) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["toggleHeader"]++; }; 

	var iSelected = this["iSelectedItemIndex"];
	var oTgl = null;
	var oTitle = null;

	if (this["bCanExpandHeader"](oClickedHeader)) {
		if (oClickedHeader["bHasToggleIcon"]) {
			oTgl = UCF_DomUtil["$"](oClickedHeader["sId"] + "-tgl");
			oTitle = UCF_DomUtil["$"](oClickedHeader["sId"] + "-title");
			UCF_DomUtil["replaceClass"](oTgl, "lsAcrColl", "lsAcrExp");
			UCF_DomUtil["replaceClass"](oTgl, "lsAcrIconColl", "lsAcrIconExp");
			oTgl["title"] = this["oLS"]["sGetText"]("SAPUR_BTNTYP_COLLAPSEBEGIN");
			UCF_DomUtil["replaceClass"](oTitle, "lsAcrTitleColl", "lsAcrTitleExp");
		}
	}

	if (this["bCanCollapseHeader"](oClickedHeader)) {
		if (oClickedHeader["bHasToggleIcon"]) {
			oTgl = null;
			if (this["bAllowMultipleSelection"]) {
				oTgl = UCF_DomUtil["$"](oClickedHeader["sId"] + "-tgl");
				oTitle = UCF_DomUtil["$"](oClickedHeader["sId"] + "-title");
			} else {
				oTgl = UCF_DomUtil["$"](this["aItems"][iSelected]["sId"] + "-tgl");
				oTitle = UCF_DomUtil["$"](this["aItems"][iSelected]["sId"] + "-title");
			}
			oTgl["title"] = this["oLS"]["sGetText"]("SAPUR_BTNTYP_EXPANDBEGIN");
			UCF_DomUtil["replaceClass"](oTgl, "lsAcrExp", "lsAcrColl");
			UCF_DomUtil["replaceClass"](oTgl, "lsAcrIconExp", "lsAcrIconColl");
			UCF_DomUtil["replaceClass"](oTitle, "lsAcrTitleExp", "lsAcrTitleColl");
		}
	}

};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["toggleHeader"] = 0; };

/**
 * Determines whether the status of the toggle icon in the title can be changed to collapsed
 * @param { UCF_AccordionItem } oClickedHeader - the item to be toggled
 * @private
 * @return {boolean}
 */
UCF_Accordion["prototype"]["bCanCollapseHeader"] = function(oClickedHeader) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["bCanCollapseHeader"]++; }; 
	var iSelected = this["iSelectedItemIndex"];

	if (!this["bAllowMultipleSelection"]) {
		return ((iSelected > -1 && oClickedHeader["iIndex"] !== iSelected)
			|| (this["bAllowDeselect"] && oClickedHeader["iIndex"] === iSelected));
	} else {
		return oClickedHeader["bExpandForMultipleSelection"];
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["bCanCollapseHeader"] = 0; };

/**
 * Determines whether the status of the toggle icon in the title can be changed to expanded
 * @private
 * @param { UCF_AccordionItem } oClickedHeader
 * @return {boolean}
 */
UCF_Accordion["prototype"]["bCanExpandHeader"] = function(oClickedHeader) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["bCanExpandHeader"]++; }; 
	var iSelected = this["iSelectedItemIndex"];

	if (!this["bAllowMultipleSelection"]) {
		return (iSelected === -1 || (iSelected > -1 && oClickedHeader["iIndex"] !== iSelected));
	} else {
		return oClickedHeader["bExpandForMultipleSelection"] === false;
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["bCanExpandHeader"] = 0; };

/**
 * Switches the item properties
 * @param { UCF_AccordionItem } oItem
 * @private
 */
UCF_Accordion["prototype"]["toggleItemIndex"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["toggleItemIndex"]++; }; 

	var iSelected = this["iSelectedItemIndex"];

	if (!this["bAllowMultipleSelection"]) {

		if (iSelected === -1 || (iSelected > -1 && oItem["iIndex"] !== iSelected)) {
			this["iSelectedItemIndex"] = oItem["iIndex"];
			this["setClientProperty"]("SelectedItemIndex", this["iSelectedItemIndex"], true);
		} else if (this["bAllowDeselect"] && oItem["iIndex"] === iSelected) {
			this["iSelectedItemIndex"] = -1;
			this["setClientProperty"]("SelectedItemIndex", this["iSelectedItemIndex"], true);
		}

	} else {
		oItem["bExpandForMultipleSelection"] = !oItem["bExpandForMultipleSelection"];
	}

	//neccessary for onlsdraghover in AccordionDropDelegate.
	//if toggled index equals the item index item will not be opened.
	this["iToggledIndex"] = oItem["iIndex"];
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["toggleItemIndex"] = 0; };

/* *
 * Collapse animation. Collapses the expanded content
 * @private
 */
UCF_Accordion["prototype"]["collapse"] = function(oDomRef, sUnits, iStartValue, iEndValue) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["collapse"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Accordion.js(738): collapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Accordion.js(739): collapse"); };
	/** @type {string} */
	// var sId;

	this["removeOverflow"](oDomRef["getAttribute"]("id")["split"]("-")[0]);

	this["oCollapse"]["setDomRef"](oDomRef);
	this["oCollapse"]["addFinalStyleValue"]("display", "none");

	this["oCollapse"]["addStyleChange"](
		/*sName:*/
		"height",
		/*sPrefix:*/
		"",
		/*sSuffix:*/
		sUnits,
		/*iStartValue:*/
		iStartValue,
		/*iEndValue:*/
		iEndValue,
		/*fnTransition:*/
		this["oCollapse"]["M_TRANSITIONS"]["Linear"]
	);

	this["oCollapse"]["callbackFinish"](this, "notifyAnimFinished");
	this["oCollapse"]["play"]();

	// sId = oDomRef.getAttribute('id').split('-')[0];
	//UCF_AriaStateHelper.setExpanded(UCF_DomUtil.$(sId + '-title'), false);
	this["bIsRefocused"] = true;
	UCF_DomUtil["refocusDomElement"](oDomRef);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["collapse"] = 0; };

/* *
 * Expand animation. Expands the selected item
 * @private
 */
UCF_Accordion["prototype"]["expand"] = function(oDomRef, sUnits, iStartValue, iEndValue) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["expand"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Accordion.js(777): expand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Accordion.js(778): expand"); };

	this["oExpand"]["setDomRef"](oDomRef);
	if (__UCF_IE6__)
		this["oExpand"]["addInitialStyleValue"]("display", "table-header-group");
	else
		this["oExpand"]["addInitialStyleValue"]("display", "table-row");

	this["oExpand"]["addStyleChange"](
		/*sName:*/
		"height",
		/*sPrefix:*/
		"",
		/*sSuffix:*/
		sUnits,
		/*iStartValue:*/
		iStartValue,
		/*iEndValue:*/
		iEndValue,
		/*fnTransition:*/
		this["oExpand"]["M_TRANSITIONS"]["Linear"]
	);

	this["oExpandDomRef"] = oDomRef;
	this["oExpand"]["callbackFinish"](this, "notifyAnimFinished");

	this["oExpand"]["play"]();

	// sId = oDomRef.getAttribute('id').split('-')[0];
	//UCF_AriaStateHelper.setExpanded(UCF_DomUtil.$(sId + '-title'), true);
	this["bIsRefocused"] = true;
	UCF_DomUtil["refocusDomElement"](oDomRef);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["expand"] = 0; };

/* *
 * Switches to overflow:hidden to avoid scroll bars during the
 * collapse animation
 * @private
 */
UCF_Accordion["prototype"]["removeOverflow"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["removeOverflow"]++; }; 
	var oScroll = UCF_DomUtil["$"](sId + "-scrl");
	if (oScroll == null) return;
	oScroll["style"]["overflow"] = "hidden";
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["removeOverflow"] = 0; };

/**
 * Returns to overflow:auto after the animation has finished
 * @private
 */
UCF_Accordion["prototype"]["setOverflow"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setOverflow"]++; }; 
	var sId = this["oExpandDomRef"]["getAttribute"]("id");
	if (sId["indexOf"]("empty") > -1) return;

	sId = sId["split"]("-")[0];
	var oScroll = UCF_DomUtil["$"](sId + "-scrl");
	oScroll["style"]["overflow"] = "auto";
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setOverflow"] = 0; };

/**
 * The animations use this function to notify the accordion that they have finished.
 * If both have finished the onToggleFinished function is called.
 * It is neccessary to observe the expand and collapse animation as the run parallel.
 * @private
 */
UCF_Accordion["prototype"]["notifyAnimFinished"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["notifyAnimFinished"]++; }; 
	this["iAnimsFinished"] += 1;
	if (this["iAnimsFinished"] === 2) {
		this["onAnimFinished"]();
		this["iAnimsFinished"] = 0;
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["notifyAnimFinished"] = 0; };

/**
 * Is called after expanding AND collapsing animation have finished.
 * All function that need to be called after both animations have finished
 * are called here.
 * @private
 */
UCF_Accordion["prototype"]["onAnimFinished"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onAnimFinished"]++; }; 
	this["setOverflow"]();
	this["setScrollPosition"]();
	this["unlock"]();
	this["oExpand"]["callbackRemove"]();
	this["oCollapse"]["callbackRemove"]();
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onAnimFinished"] = 0; };

/**
 * locks the control when animation runs in order to have
 * a smooth animation
 * @private
 */
UCF_Accordion["prototype"]["lock"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["lock"]++; }; 

	if (this["bLocked"]) return;

	this["addBlindLayer"]();
	this["setBlindLayerSize"]();
	this["bLocked"] = true;
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["lock"] = 0; };

/**
 * unlocks the control when animation is finished
 * @private
 */
UCF_Accordion["prototype"]["unlock"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["unlock"]++; }; 

	if (!this["bLocked"]) return;

	this["removeBlindLayer"]();
	this["bLocked"] = false;
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["unlock"] = 0; };

/**
 * adds a blind layer over the control that avoids interaction
 * during animation
 * @private
 */
UCF_Accordion["prototype"]["addBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["addBlindLayer"]++; }; 
	if (!this["oBlindLayer"]) {
		var oBlindLayer = this["oLS"]["oGetBlindLayer"]();
		oBlindLayer["oDomRef"]["className"] = "lsnoprint";
		this["oBlindLayer"] = oBlindLayer;
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["addBlindLayer"] = 0; };

/**
 * defines the correct sizes for the blind layer
 * @private
 */
UCF_Accordion["prototype"]["setBlindLayerSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setBlindLayerSize"]++; }; 

	if (this["oBlindLayer"]) {
		var oRect = this["oGetObjectRect"](this["oDomRef"]),
			oStyle = this["oBlindLayer"]["oDomRef"]["style"];

		oStyle["top"] = oRect["top"] + "px";
		oStyle["left"] = oRect["left"] + "px";
		oStyle["width"] = oRect["width"] + "px";
		oStyle["height"] = oRect["height"] + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setBlindLayerSize"] = 0; };

/**
 * Removes the blind layer when control is unlocked.
 * @private
 */
UCF_Accordion["prototype"]["removeBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["removeBlindLayer"]++; }; 
	if (this["oBlindLayer"]) {
		this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
		this["oBlindLayer"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["removeBlindLayer"] = 0; };

/**********************************************************
 * Drag & Drop section
 *********************************************************/

/**
 * implements method from UCF_Control
 * @private
 * @return {boolean}
 */
UCF_Accordion["prototype"]["bIsAnimFinished"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["bIsAnimFinished"]++; }; 
	return !this["oExpand"]["bRunning"] && !this["oCollapse"]["bRunning"];
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["bIsAnimFinished"] = 0; };

UCF_Accordion["sDragSource"] = "ACCORDIONITEM";

/**
 * implements method from UCF_Control
 * @private
 */
UCF_Accordion["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["createDragDelegate"]++; }; 

	if (this["bHasDragDelegate"]) return;

	this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_AccordionDragDelegate"))(this["oLS"], this));
	this["bHasDragDelegate"] = true;
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["createDragDelegate"] = 0; };

UCF_Accordion["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["createDropDelegate"]++; }; 

	if (this["oDropDelegate"]) return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_AccordionDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["createDropDelegate"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {integer}
 */
UCF_Accordion["prototype"]["oGetDropInfo"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["oGetDropInfo"]++; }; 

	var oItem = oBrowserEvent["oGetSourceControl"](),
		oRect = UCF_DomUtil["oGetObjectRect"](oItem["oDomRef"]),
		iOffset = 0,
		iMouseY = oBrowserEvent["iPageY"](),
		fThreshold = .5,
		sItemDropTargetInfo = oItem["sDropTargetInfo"],
		sDropTargetInfo = "";

	if (!UCF_JsUtil["bInstanceOf"](oItem, "UCF_AccordionItem")) {
		return {
			"iOffset": null,
			"sDropTargetInfo": ""

		};
	}
	//drop between items possible
	if (this["sDropTargetInfo"]) {
		if (sItemDropTargetInfo)
			fThreshold = .25;

		sDropTargetInfo = this["sDropTargetInfo"];
		//mouse in the upper region?
		if (iMouseY < oRect["top"] + oRect["height"] * fThreshold) {
			iOffset = -1;

		}
		//mouse in the lower region
		else if (iMouseY >= oRect["top"] + (1 - fThreshold) * oRect["height"]) {
			iOffset = 1;

		}
		//mouse in the middle of the row
		else {
			sDropTargetInfo = sItemDropTargetInfo;
		}
	}
	//no table droptarget info
	else {
		if (sItemDropTargetInfo)
			sDropTargetInfo = sItemDropTargetInfo;
	}

	return {
		"iOffset": iOffset,
		"sDropTargetInfo": sDropTargetInfo

	};
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["oGetDropInfo"] = 0; };

/*********************************************************************
 * ACC and keyboard section
 *******************************************************************/

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Accordion["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsfocus"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();
	var oACRCntRef = UCF_DomUtil["oGetParentByAttribute"](oSource, "className", "lsAcrCntCollapsed");
	var oFollowingControl = null;

	if (this["bIsRefocused"] === true) {
		this["bIsRefocused"] = false;
		return;
	}

	if (oACRCntRef) {
		if (oBrowserEvent["bShift"]()) {
			oFollowingControl = oBrowserEvent["oGetSourceControl"]()["oGetPreviousFocusableControl"]();
		} else {
			oFollowingControl = oBrowserEvent["oGetSourceControl"]()["oGetNextFocusableControl"]();
		}
		if (oFollowingControl) {
			oFollowingControl["focus"]();
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		} else {
			//leave it up to ls object to find the next element
			this["oLS"]["focusEnd"]();
			//UCF_DomUtil.focusDomElement(document.body);

		}
	}

	if (this["iFocus"] == null) {
		this["iFocus"] = this["iGetNavIndex"](oBrowserEvent);
	}

	//	var oItem = oBrowserEvent.oGetSourceControl();
	//	if (UCF_JsUtil.bInstanceOf(oItem, "UCF_AccordionItem")) {
	//		_trace(INFO, "*** source control = UCF_AccordionItem");
	//		//debugger;
	//		this.highlightContentOfItem(this.iFocus);
	//	}

};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsfocus"] = 0; };

/*
UCF_Accordion.prototype.onlscontainerfocus = function(oBrowserEvent) {
	_trace(INFO, this.sId);
	//debugger;

	var oFocusDom = UCF_DomUtil.oGetActiveElement();
	if (!oFocusDom) {
		_trace(DEBUG, "No active element");
		return;
	}


	// Some content control got the focus: Find out it which item it belongs to
	var bFound = false;
	var i = 0;
	while (!bFound && i < this.aItems.length) {
		bFound = UCF_DomUtil.bContains(this.aItems[i].oContent, oFocusDom);
		if (!bFound) i++;
	}
	if (!bFound) {
		_trace(DEBUG, "No accordion item found for focused element: " + oFocusDom);
	}
	else {
		//_trace(INFO, ">>> Acc. Item " + i);
		if (this.bAllowMultipleSelection) {
		}
		else {
			if (this.iSelectedItemIndex == i) {
			}
		}
	}

	_super();
};

UCF_Accordion.prototype.onlscontainerblur = function(oBrowserEvent) {
	_trace(INFO, this.sId);

	var oFocusDom = UCF_DomUtil.oGetActiveElement();
	if (!oFocusDom) {
		_trace(DEBUG, "No active element");
		return;
	}
	// Some other content control got the focus: Does it belong to the currently focused acc. item
	var bFound = false;
	var i = 0;
	while (!bFound && i < this.aItems.length) {
		bFound = UCF_DomUtil.bContains(this.aItems[i].oContent, oFocusDom);
		if (!bFound) i++;
	}
	if (!bFound) {
		this.removePrompt();
	}
	else {
		//_trace(INFO, ">>> Acc. Item " + i + ", current Item " + this.iHLItem);
		if (this.bAllowMultipleSelection) {
		}
		else {
			if (this.iSelectedItemIndex != i) {
			}
		}
	}

};
*/

/*
UCF_Accordion.prototype.removePrompt = function() {

	if (typeof this.oPromptBorder1 != "undefined") {
		this.oPromptBorder1.style.top = -5000;
		this.oPromptBorder2.style.top = -5000;
		this.oPromptBorder3.style.top = -5000;
		this.oPromptBorder4.style.top = -5000;



		var oPItem = this.aItems[this.iPromptItem];
		if (oPItem) {
			var oText = UCF_DomUtil.$(oPItem.sId + "-textedit");
			oText.style.fontWeight = "";
		}

		oPItem.oContent.style.backgroundColor = "transparent";
		//oPItem.oContent.style.filter = "";
		oPItem.oContent.firstChild.style.backgroundColor = "transparent";
		//oPItem.oContent.firstChild.style.filter = "";

	}
};
*/

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @return {integer}
 */
UCF_Accordion["prototype"]["iGetNavIndex"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["iGetNavIndex"]++; }; 
	var oItem = oBrowserEvent["oGetSourceControl"]();
	for (var i = 0; i < this["aNavItems"]["length"]; i++) {
		if (oItem === this["aNavItems"][i]) {
			return i;
		}
	}
	return 0;
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["iGetNavIndex"] = 0; };

/**
 * Creates an array with all items necessary for keyboard navigation
 * @private
 */
UCF_Accordion["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["createItems"]++; }; 

	if (this["aItems"] != null) return;

	this["aItems"] = [];
	this["aNavItems"] = [];
	this["aDragItems"] = [];

	if (!this["oItemNavigation"]) {
		this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
		this["addDelegate"](this["oItemNavigation"]);
	}

	var aDomItems = UCF_DomUtil["$"](this["sId"] + "-bdy")["childNodes"],
		iLoopTo = (this["sVerticalSizing"] === "FILL") ? aDomItems["length"] - 1 : aDomItems["length"];

	//amount of loops depends on vertical sizing property.
	//FILL has one dom element more then PUSH. It is a streching cell at the end of the control.
	for (var i = 0; i < iLoopTo; i++) {

		if (aDomItems[i]["getAttribute"]("ct")) {
			var oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[i], true);
			// Copy value of parameter to items, needed for setItemDesign()
			oItem["sVerticalSizing"] = this["sVerticalSizing"];
			this["aDragItems"]["push"](aDomItems[i]["firstChild"]);
		} else {
			this["aItems"][this["aItems"]["length"] - 1]["oContent"] = aDomItems[i];
			continue;
		}

		this["aItems"]["push"](oItem);
		if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_AccordionItem"))
			this["oItemNavigation"]["addItem"](oItem, oItem["iIndex"] === this["iSelectedItemIndex"]);
		if (oItem["bEnabled"] || window["UCF_System"]["bIs508"]) {
			this["aNavItems"]["push"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["createItems"] = 0; };

/**
 * Checks whether keyboard navigation is possible
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_Accordion["prototype"]["bCanNavigate"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["bCanNavigate"]++; }; 
	var oItem = oBrowserEvent["oGetSourceControl"]();
	return (oItem != null && this["aNavItems"] != null && this["aNavItems"]["length"] > 0 &&
		UCF_JsUtil["bInstanceOf"](oItem, "UCF_AccordionItem") &&
		this["iFocus"] != null);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["bCanNavigate"] = 0; };

/*
UCF_Accordion.prototype.onlstabnext = function(oBrowserEvent) {

	var oSource = oBrowserEvent.oGetSourceControl();

	if (this.sVerticalSizing != "PUSH") return;

	var oNextExpanded = this.oFindNextExpanded(oSource);

	if (oNextExpanded == null) {
		var oNextControl = this.oGetNextFocusableControl();

		if (oNextControl) {
			oNextControl.focus();
		}
		oBrowserEvent.cancel();
		oBrowserEvent.cancelBubble();

	} else {

	}

};

UCF_Accordion.prototype.onlstabprevious = function(oBrowserEvent) {

	if (this.sVerticalSizing != "PUSH") return;

	var oSource = oBrowserEvent.oGetSourceControl(),
		oPreviousExpanded = oBrowserEvent.oGetSourceControl();

	if (oPreviousExpanded == null) {
		var oPreviousControl = this.oGetPreviousFocusableControl();

		if (oPreviousControl) {
			oPreviousControl.focus();
		}
		oBrowserEvent.cancel();
		oBrowserEvent.cancelBubble();
	}

};


UCF_Accordion.prototype.oFindNextExpanded = function(oFocused) {

	if (!this.bAllowMultipleSelection) {
		if (this.iSelectedItemIndex > -1) {
			return this.aItems[this.iSelectedItemIndex];
		} else {
			return null;
		}
	}

	for (var i = oFocused.iIndex; i < this.aItems.length; i++) {
		if (this.aItems[i].bExpandForMultipleSelection) {
			return this.aItems[i];
		}
	}
	return null;
};


UCF_Accordion.prototype.oFindPreviousExpanded = function(oFocused) {

	if (!this.bAllowMultipleSelection) {
		if (this.iSelectedItemIndex > -1) {
			return this.aItems[this.iSelectedItemIndex];
		} else {
			return null;
		}
	}

	for (var i = oFocused.iIndex; i >= 0; i--) {
		if (this.aItems[i].bExpandForMultipleSelection) {
			return this.aItems[i];
		}
	}
	return null;
};
*/

/**
 * Sets the focus to the next item
 * @private
 * @param {int} iIndex
 */
UCF_Accordion["prototype"]["setFocus"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setFocus"]++; }; 
	if (iIndex == null) return;
	var oDomRef = this["aNavItems"][iIndex]["oFocusDomRef"];
	//oDomRef.tabIndex = 0;
	//oDomRef.ti = 0;
	oDomRef["focus"]();
	this["iFocus"] = iIndex;
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setFocus"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Accordion["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Accordion["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsskipback"] = 0; };

/**
 * Sets the correct acc text
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Accordion["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsaccessibility"]++; }; 

	var oSource = oBrowserEvent["oGetSourceControl"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (UCF_JsUtil["bInstanceOf"](oSource, "UCF_AccordionItem")) {

		oAccessibilityHelper["setControlType"]("ACR");
		oAccessibilityHelper["setEnabled"](oSource["bEnabled"]);
		oAccessibilityHelper["setRequired"](oSource["bRequired"]);
		oAccessibilityHelper["addTooltip"](this["sTooltip"]);
		oAccessibilityHelper["addTooltip"](oSource["sTooltip"]);

		oAccessibilityHelper["setText"](oSource["sTitle"]);
		oAccessibilityHelper["setItemCount"](this["aItems"]["length"]);
		oAccessibilityHelper["setItemIndex"](oSource["iIndex"] + 1);

		oAccessibilityHelper["setSelected"](oSource["iIndex"] === this["iSelectedItem"]);

		if (oSource["bHasEditableTitle"] && !this["bEditModeOn"]) {
			oAccessibilityHelper["addTutor"]("ACR_EDIT_TITLE");
		} else if (oSource["bHasEditableTitle"] && this["bEditModeOn"]) {
			oAccessibilityHelper["addTutor"]("ACR_EDITABLE_TITLE");
			oAccessibilityHelper["addTutor"]("ACR_LOCK_TITLE");
		}

		if (!this["bEditModeOn"]) {
			oAccessibilityHelper["applyContainerEntryBehaviour"]();
			oAccessibilityHelper["addTutor"]("LRNAV_TUT");

			if (oSource["iIndex"] !== this["iSelectedItemIndex"] && oSource["bEnabled"]) {
				oAccessibilityHelper["addTutor"]("SELECT_TUT");
			}
		}

		// if (UCF_System.bIsAria) {
		// 	var oItem = oBrowserEvent.oGetSourceControl();
		// 	if (oItem) {
		// 		var oTitleDomRef = UCF_DomUtil.$(oItem.oDomRef.id + '-title');
		// 		if (oTitleDomRef) {
		// 			if (oItem.iIndex !== this.iSelectedItemIndex) {
		// 				// collapse
		// 				UCF_AriaStateHelper.setExpanded(oTitleDomRef, false);
		// 				if (oItem.bHasEditableTitle && oItem.bEnabled) {
		// 					UCF_AriaStateHelper.setDescribedby(oTitleDomRef, "ARIA_ACR_EDIT_TITLE ARIA_ACR_LOCK_TITLE ARIA_B_TG_COLL_TUT ARIA_IL_TUT");
		// 				} else {
		// 					UCF_AriaStateHelper.setDescribedby(oTitleDomRef, "ARIA_B_TG_COLL_TUT ARIA_IL_TUT");
		// 				}
		// 			} else {
		// 				// expand
		// 				UCF_AriaStateHelper.setExpanded(oTitleDomRef, true);
		// 				if (oItem.bHasEditableTitle && oItem.bEnabled) {
		// 					UCF_AriaStateHelper.setDescribedby(oTitleDomRef, "ARIA_ACR_EDIT_TITLE ARIA_ACR_LOCK_TITLE ARIA_B_TG_EXP_TUT ARIA_IL_TUT");
		// 				} else {
		// 					UCF_AriaStateHelper.setDescribedby(oTitleDomRef, "ARIA_B_TG_EXP_TUT ARIA_IL_TUT");
		// 				}
		// 			}
		// 		}
		// 	}
		// }

	} else if (oBrowserEvent["oGetSource"]()["id"]["indexOf"]("-end") > -1 && oSource === this) {
		oAccessibilityHelper["setControlType"]("ACR_END");
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlsaccessibility"] = 0; };

/*********************************************************************
 * Hotkey section
 *******************************************************************/
/**
 * Handle hotkey events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Accordion["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlshotkey"]++; }; 

	var oItem = this["aItems"][this["iSelectedItemIndex"]];

	if (oItem == null || oItem["sHotkeysId"] == null || UCF_StringUtil["bIsEmpty"](oItem["sHotkeysId"])) return;

	var oHotkeys = this["oGetControlById"](oItem["sHotkeysId"]);
	if (oHotkeys == null) return;

	var oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oItem["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onlshotkey"] = 0; };

UCF_Accordion["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]("UCF_Hotkeys")["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["onkeypress"] = 0; };

/**
 * Actives native browser dragging by setting draggable attribute
 *
 * @private
 */
UCF_Accordion["prototype"]["setDraggable"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setDraggable"]++; }; 
	if (this["sDragSourceInfo"] !== "") {
		if (this["aItems"] == null) {
			this["createItems"]();
		}
		var oDragSourceInfo = this["oLS"]["oControlFactory"]["oGetControlById"](this["sDragSourceInfo"]);
		if (oDragSourceInfo && oDragSourceInfo["bBrowserDragDrop"]) {
			for (var i = 0; i < this["aDragItems"]["length"]; i++) {
				this["aDragItems"][i]["setAttribute"]("draggable", true);
				//set thrshold at TR
				this["aDragItems"][i]["parentNode"]["setAttribute"]("iDDThreshold", 10000);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setDraggable"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Accordion["prototype"]["aAttributeNames"] = ["sTooltip","sVerticalSizing","iSelectedItemIndex","bAllowDeselect","bAllowSelect","bAllowMultipleSelection","sDropTargetInfo","sDragSourceInfo","sVisibility","sCustomData","iHeadingLevel"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Accordion["prototype"]["aEventNames"] = ["Change","Select","Deselect","Drag","Drop","Scroll","Hotkey"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Accordion["prototype"]["aMethodNames"] = ["ToggleItems","aGetItems","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Accordion["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.AccordionSizing}
 */
UCF_Accordion["prototype"]["sVerticalSizing"] = "FILL";

/**
 * @private
 * @type {number}
 */
UCF_Accordion["prototype"]["iSelectedItemIndex"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_Accordion["prototype"]["bAllowDeselect"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Accordion["prototype"]["bAllowSelect"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_Accordion["prototype"]["bAllowMultipleSelection"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Accordion["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Accordion["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Accordion["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_Accordion["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {number}
 */
UCF_Accordion["prototype"]["iHeadingLevel"] = 0;

//#JSCOVER_EXCL_START
/** @protected */
UCF_Accordion["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sVerticalSizing"] = "FILL";
	this["iSelectedItemIndex"] = 0;
	this["bAllowDeselect"] = false;
	this["bAllowSelect"] = true;
	this["bAllowMultipleSelection"] = false;
	this["sDropTargetInfo"] = '';
	this["sDragSourceInfo"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["iHeadingLevel"] = 0;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("VerticalSizing", "FILL", true);
		this["setClientProperty"]("SelectedItemIndex", 0, true);
		this["setClientProperty"]("AllowDeselect", false, true);
		this["setClientProperty"]("AllowSelect", true, true);
		this["setClientProperty"]("AllowMultipleSelection", false, true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
	}
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The id of the Accordion.
 * @param {string} sItemId The id of the AccordionItem.
 * @param {string} sValue The new tile.
 * @fires Accordion::Change
 */
UCF_Accordion["prototype"]["fireChange"] = function(sId, sItemId, sValue) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireChange"]++; }; 
	/** @type {{Id: string, ItemId: string, Value: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Accordion.js(1616): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Accordion.js(1617): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Accordion.js(1618): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "Accordion.js(1619): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "Accordion.js(1620): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "Accordion.js(1621): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Accordion.js(1622): fireChange"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"Value": sValue
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	this["fireSemanticEvent"]("Accordion", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the Accordion.
 * @param {string} sItemId The id of the AccordionItem.
 * @param {boolean} bToggleIconClicked Indicates whether the toggle icon in the header was clicked or not (some other position in the header).
 * @fires Accordion::Select
 */
UCF_Accordion["prototype"]["fireSelect"] = function(sId, sItemId, bToggleIconClicked) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, ItemId: string, ToggleIconClicked: boolean}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Accordion.js(1652): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Accordion.js(1653): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Accordion.js(1654): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "Accordion.js(1655): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "Accordion.js(1656): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bToggleIconClicked != null, "bToggleIconClicked != null", "Accordion.js(1657): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bToggleIconClicked) == "boolean", "typeof(bToggleIconClicked) == \"boolean\"", "Accordion.js(1658): fireSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"ToggleIconClicked": bToggleIconClicked
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	this["fireSemanticEvent"]("Accordion", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the Accordion.
 * @param {string} sItemId The id of the AccordionItem.
 * @param {boolean} bToggleIconClicked Indicates whether the toggle icon in the header was clicked or not (some other position in the header).
 * @fires Accordion::Deselect
 */
UCF_Accordion["prototype"]["fireDeselect"] = function(sId, sItemId, bToggleIconClicked) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireDeselect"]++; }; 
	/** @type {{Id: string, ItemId: string, ToggleIconClicked: boolean}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Accordion.js(1688): fireDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Accordion.js(1689): fireDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Accordion.js(1690): fireDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "Accordion.js(1691): fireDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "Accordion.js(1692): fireDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bToggleIconClicked != null, "bToggleIconClicked != null", "Accordion.js(1693): fireDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bToggleIconClicked) == "boolean", "typeof(bToggleIconClicked) == \"boolean\"", "Accordion.js(1694): fireDeselect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"ToggleIconClicked": bToggleIconClicked
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	this["fireSemanticEvent"]("Accordion", "Deselect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireDeselect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires Accordion::Drag
 */
UCF_Accordion["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Accordion.js(1722): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Accordion.js(1723): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Accordion.js(1724): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "Accordion.js(1725): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "Accordion.js(1726): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "Accordion.js(1727): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "Accordion.js(1728): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("Accordion", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sItemId The Id of the TabstripItem where the drop occured
 * @param {number} iOffset The Offset relative to the TabStripItem where the drop occured (signum)
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires Accordion::Drop
 */
UCF_Accordion["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, sItemId, iOffset, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, ItemId: string, Offset: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 12, "arguments.length == 12", "Accordion.js(1762): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Accordion.js(1763): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Accordion.js(1764): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "Accordion.js(1765): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "Accordion.js(1766): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "Accordion.js(1767): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "Accordion.js(1768): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "Accordion.js(1769): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "Accordion.js(1770): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOffset != null, "iOffset != null", "Accordion.js(1771): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOffset) == "number", "typeof(iOffset) == \"number\"", "Accordion.js(1772): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "Accordion.js(1773): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "Accordion.js(1774): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "Accordion.js(1775): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "Accordion.js(1776): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "Accordion.js(1777): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "Accordion.js(1778): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "Accordion.js(1779): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "Accordion.js(1780): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "Accordion.js(1781): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "Accordion.js(1782): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "Accordion.js(1783): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "Accordion.js(1784): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "Accordion.js(1785): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "Accordion.js(1786): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"ItemId": sItemId,
		"Offset": iOffset,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	if (sDropTargetInfo) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sDropTargetInfo);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "DropTargetInfo");
			}
		}
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("Accordion", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sItemId 
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires Accordion::Scroll
 */
UCF_Accordion["prototype"]["fireScroll"] = function(sId, sItemId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ItemId: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "Accordion.js(1835): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Accordion.js(1836): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Accordion.js(1837): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "Accordion.js(1838): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "Accordion.js(1839): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "Accordion.js(1840): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "Accordion.js(1841): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "Accordion.js(1842): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "Accordion.js(1843): fireScroll"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	
	this["fireSemanticEvent"]("Accordion", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sItemId ItemId of the tabstrip item which is currently selected and hotkey is fired
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires Accordion::Hotkey
 */
UCF_Accordion["prototype"]["fireHotkey"] = function(sId, sItemId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, ItemId: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "Accordion.js(1876): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Accordion.js(1877): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Accordion.js(1878): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "Accordion.js(1879): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "Accordion.js(1880): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "Accordion.js(1881): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "Accordion.js(1882): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "Accordion.js(1883): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "Accordion.js(1884): fireHotkey"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	
	this["fireSemanticEvent"]("Accordion", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Accordion["_"]["fireHotkey"] = 0; };

UCF_Accordion.prototype["aPublicMethods"] = ["ToggleItems","aGetItems"].concat(UCF_Accordion.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_AccordionDragDelegate"] = function() {/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_DragSession */
/// <reference path="../base/DragSession.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>
/* global UCF_Accordion */
/// <reference path="../Accordion.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_Accordion} oAccordion
 */
function UCF_AccordionDragDelegate(oLS, oAccordion) {if (__UCF_COVERAGE__) { UCF_AccordionDragDelegate["_"]["UCF_AccordionDragDelegate"]++; }; 

	UCF_DragDelegate["apply"](this, [oLS]);
	this["setDragSourceControl"](oAccordion);
};window["UCF_AccordionDragDelegate"] = UCF_AccordionDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AccordionDragDelegate"); UCF_AccordionDragDelegate["_"] = {UCF_AccordionDragDelegate: 0}; }; ;

UCF_AccordionDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_AccordionDragDelegate.prototype["sClassName"] = "UCF_AccordionDragDelegate";

UCF_AccordionDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionDragDelegate["_"]["oGetGhost"]++; }; 

	var oAccordionItem = oBrowserEvent["oGetSourceControl"]();
	var oGhostFragment = oAccordionItem["oDomRef"]["cloneNode"](true);

	oGhostFragment["style"]["width"] = oAccordionItem["oDomRef"]["offsetWidth"] + 'px';
	var oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oGhostFragment);

	oGhost["setOffset"](12, 12);

	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_AccordionDragDelegate["_"]["oGetGhost"] = 0; };

UCF_AccordionDragDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionDragDelegate["_"]["onlsdragstart"]++; }; 

	var oDragSourceControl = this["oGetDragSourceControl"](oBrowserEvent),
		sDragSourceInfoId = oDragSourceControl["sDragSourceInfo"];

	if (!sDragSourceInfoId)
		return;

	var oDragSourceInfoControl = oDragSourceControl["oGetControlById"](sDragSourceInfoId);

	if (!oDragSourceInfoControl)
		return;

	var sTags = oDragSourceInfoControl["sGetTags"]();

	if (!sTags)
		return;

	if (!this["bIsDragPossible"](oBrowserEvent))
		return;

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];

	var oGhost = this["oGetGhost"](oBrowserEvent),
		oDragSession = oDragAndDropManager["startDragSession"](oDragSourceControl["sId"], sTags, UCF_DragSession["DRAG_TYPE"]["STANDARD"], null, oGhost, oDragSourceInfoControl["sHint"]);

	// if Drag-Event is registered
	if (oDragSourceControl["mEvents"]["Drag"]) {
		oDragSourceControl["fireDrag"](oDragSourceControl["sId"], sDragSourceInfoId, oDragSession["sId"]);
	}

	var oAccordionItem = this["oGetAccordionItem"](oBrowserEvent);
	// if DataAccess is registered

	if (oDragSourceInfoControl["mEvents"]["DataAccess"]) {
		// use mime type from drag source info
		// server can override it with a non-null value
		oDragSession["sMimeType"] = oDragSourceInfoControl["sGetMimeType"]();

		oDragSourceInfoControl["fireDataAccess"](sDragSourceInfoId, oDragSourceControl["sId"], oDragSession["sId"]);
	} else if (oAccordionItem["sDragData"]) {
		oDragSession["setDragData"](oAccordionItem["sDragData"], oDragSourceInfoControl["sGetMimeType"]());
	} else {
		// use data from drag source info control
		oDragSession["setDragData"](oDragSourceInfoControl["sGetData"](), oDragSourceInfoControl["sGetMimeType"]());
	}

	oDragSession["setCustomData"](UCF_Accordion["sDragSource"]);

	oBrowserEvent["bHandled"] = true;
	oBrowserEvent["cancelBubble"]();

	if (!UCF_UserAgent["bIsTrident"](5)) {
		oDragAndDropManager["setDropEnabledCursor"](UCF_DragSession["E_CURSOR"]["MOVE"]);
	}
};;if (__UCF_COVERAGE__) { UCF_AccordionDragDelegate["_"]["onlsdragstart"] = 0; };

UCF_AccordionDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionDragDelegate["_"]["bIsDragPossible"]++; }; 

	return this["oGetAccordionItem"](oBrowserEvent) != null;
};;if (__UCF_COVERAGE__) { UCF_AccordionDragDelegate["_"]["bIsDragPossible"] = 0; };

UCF_AccordionDragDelegate["prototype"]["oGetAccordionItem"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionDragDelegate["_"]["oGetAccordionItem"]++; }; 

	var oItem = oBrowserEvent["oGetSourceControl"]();

	if (oItem != null && UCF_JsUtil["bInstanceOf"](oItem, 'UCF_AccordionItem'))
		return oItem;

	return null;
};;if (__UCF_COVERAGE__) { UCF_AccordionDragDelegate["_"]["oGetAccordionItem"] = 0; };

};
sap["ls"]["preload"]["UCF_AccordionDropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_Accordion} oAccordion
 * @param {UCF_LS} oLS
 */
function UCF_AccordionDropDecorator(oAccordion, oLS) {if (__UCF_COVERAGE__) { UCF_AccordionDropDecorator["_"]["UCF_AccordionDropDecorator"]++; }; 
	//true:horizontal
	//false:vertical
	UCF_LineDecorator["apply"](this, [oAccordion, true]);
	this["oLS"] = oLS;
};window["UCF_AccordionDropDecorator"] = UCF_AccordionDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AccordionDropDecorator"); UCF_AccordionDropDecorator["_"] = {UCF_AccordionDropDecorator: 0}; }; ;

/**
 *
 */
UCF_AccordionDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(); UCF_AccordionDropDecorator.prototype["sClassName"] = "UCF_AccordionDropDecorator";

/**
 * The update function belongs to the LineDecorator where it does not have an implementation.
 * It is called by DropDelegate during drag a operation.
 * Updates the horizontal line that markes the drop target.
 * Calculates it in relation to the currently hovered title/item.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_AccordionDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionDropDecorator["_"]["update"]++; }; 
	this["sItemId"] = null;
	this["iOffset"] = null;

	var oAccordionItem = oBrowserEvent["oGetSourceControl"]();

	if (UCF_JsUtil["bInstanceOf"](oAccordionItem, "UCF_Accordion")) {
		var oSource = oBrowserEvent["oGetSource"](),
			sId = oSource["id"]["split"]("-")[0];

		if (sId != null) {
			oAccordionItem = this["oLS"]["oControlFactory"]["oGetControlById"](sId);
		}
	}

	if (!UCF_JsUtil["bInstanceOf"](oAccordionItem, "UCF_AccordionItem")) {
		this["hide"]();
		return;
	}

	var oItemRect = UCF_DomUtil["oGetObjectRect"](oAccordionItem["oDomRef"]),
		oDropInfo = this["oControl"]["oGetDropInfo"](oBrowserEvent),
		iTop = 0;

	this["sItemId"] = oAccordionItem["sId"];
	this["iOffset"] = oDropInfo["iOffset"];

	if (oDropInfo["iOffset"] === -1) {
		iTop = oItemRect["top"];

	} else if (oDropInfo["iOffset"] === 1) {
		iTop = oItemRect["top"] + oItemRect["height"];
	} else {
		//todo: highlight acc. item
		this["hide"]();
		return;
	}

	this["show"]();
	this["setBounds"](oItemRect["left"], iTop, oItemRect["width"]);
};;if (__UCF_COVERAGE__) { UCF_AccordionDropDecorator["_"]["update"] = 0; };

/**
 *
 */
UCF_AccordionDropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_AccordionDropDecorator["_"]["oGetDropLocation"]++; }; 

	if (this["sItemId"] == null) {
		return null;
	}

	return { "sItemId": this["sItemId"], "iOffset": this["iOffset"] };
};;if (__UCF_COVERAGE__) { UCF_AccordionDropDecorator["_"]["oGetDropLocation"] = 0; };

/**
 * destructor
 */
UCF_AccordionDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AccordionDropDecorator["_"]["destroy"]++; }; 
	this["sItemId"] = null;
	this["iOffset"] = null;
	this["oLS"] = null;
	this["oSecondArrow"] = null;
	UCF_LineDecorator.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AccordionDropDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_AccordionDropDelegate"] = function() {/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_AccordionDropDecorator */
/// <reference path="../decorators/AccordionDropDecorator.js"/>
/* global UCF_Accordion */
/// <reference path="../Accordion.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_AccordionDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["UCF_AccordionDropDelegate"]++; }; 

	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);
	this["oLS"] = oLS;

};window["UCF_AccordionDropDelegate"] = UCF_AccordionDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AccordionDropDelegate"); UCF_AccordionDropDelegate["_"] = {UCF_AccordionDropDelegate: 0}; }; ;
UCF_AccordionDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_AccordionDropDelegate.prototype["sClassName"] = "UCF_AccordionDropDelegate";

/**
 * @override
 */
UCF_AccordionDropDelegate["prototype"]["oCreateDropDecorator"] = function () {;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["oCreateDropDecorator"]++; }; 

	if (this["oDropDecorator"]) return this["oDropDecorator"];

	return this["oDropDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_AccordionDropDecorator"))(this["oDropTargetControl"], this["oLS"]); // eslint-disable-line @ur/no-memory-leaks

};;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["oCreateDropDecorator"] = 0; };

/**
 * destructor
 */
UCF_AccordionDropDelegate["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["destroy"]++; }; 
	UCF_DropDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["destroy"] = 0; };

/**
 *
 */

UCF_AccordionDropDelegate["prototype"]["oGetDropLocation"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["oGetDropLocation"]++; }; 

	if (!this["oDropDecorator"])
		return null;

	return this["oDropDecorator"]["oGetDropLocation"]();
};;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["oGetDropLocation"] = 0; };

UCF_AccordionDropDelegate["prototype"]["onlsdragover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["onlsdragover"]++; }; 

	var oDropInfo = this["oDropTargetControl"]["oGetDropInfo"](oBrowserEvent),
		sDropTargetInfoId = oDropInfo["sDropTargetInfo"];

	if (sDropTargetInfoId) {
		this["onlsdragleave"](oBrowserEvent);
		this["onlsdragenter"](oBrowserEvent);
	}

};;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["onlsdragover"] = 0; };

UCF_AccordionDropDelegate["prototype"]["sGetDropTags"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["sGetDropTags"]++; }; 

	var oDropInfo = this["oDropTargetControl"]["oGetDropInfo"](oBrowserEvent),
		sDropTargetInfoId = oDropInfo["sDropTargetInfo"];

	if (!sDropTargetInfoId)
		return "";

	var oDropTargetInfoControl = this["oDropTargetControl"]["oGetControlById"](sDropTargetInfoId);

	if (!oDropTargetInfoControl)
		return "";

	var sDropTags = oDropTargetInfoControl["sGetTags"]();

	if (!sDropTags)
		return "";

	return sDropTags;

};;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["sGetDropTags"] = 0; };

/**
 *
 */

UCF_AccordionDropDelegate["prototype"]["fGetDropCallBack"] = function (oDragSession) {;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		oLocation = this["oGetDropLocation"](),
		sItemId = oLocation["sItemId"],
		iOffset = oLocation["iOffset"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function (sDragData, sMimeType) {

		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			sItemId,
			iOffset,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);
	};
};;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["fGetDropCallBack"] = 0; };

/**
 * Toggles the accordion. Passes the correct item to be toggled on basis of this.oDropDecorator.sItemId.
 */

UCF_AccordionDropDelegate["prototype"]["onlsdraghover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["onlsdraghover"]++; }; 
	var oAccordion = this["oGetDropTargetControl"](),
		oItem = oBrowserEvent["oGetSourceControl"]();

	// don't toggle if:
	// the animation is still running
	if (!oAccordion["bIsAnimFinished"]() ||
		//the hovered item is not an instance of accordionItem
		!UCF_JsUtil["bInstanceOf"](oItem, "UCF_AccordionItem") ||
		//
		oBrowserEvent["oDragAndDropManager"]["oDragSession"]["oGetCustomData"]() === UCF_Accordion["sDragSource"] ||
		//the item has just been hovered by the drag source and toggled
		oAccordion["iToggledIndex"] === oItem["iIndex"] ||
		//the item hovered by the drag source is the selected item
		oAccordion["iSelectedItemIndex"] === oItem["iIndex"]) return;

	// oAccordion.toggle(oItem);

	oAccordion["toggleItem"](oItem);

	oAccordion["fireSelect"](oAccordion["sId"], oItem["sId"]);

	if (this["oDropDecorator"])
		this["oDropDecorator"]["cleanUp"]();
	this["oDropDecorator"] = null;
	oBrowserEvent["oDragAndDropManager"]["cleanUpDropArea"]();
};;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["onlsdraghover"] = 0; };

/**
 * Drop is possible if the Drop Taget, where the drop event occurs, is an instance of
 * an Accordion item.
 * Don't mix up this functio with bGetDropAllowed(), vailable in the Drag and Drop manager.
 * bGetDropAllowed() returns true when the tags of drag source and drop target match.
 */

UCF_AccordionDropDelegate["prototype"]["bIsDropPossible"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["bIsDropPossible"]++; }; 

	var oItem = oBrowserEvent["oGetSourceControl"](),
		bIsAccordionItem = UCF_JsUtil["bInstanceOf"](oItem, "UCF_AccordionItem"),
		bPossible = UCF_DropDelegate.prototype["bIsDropPossible"]["call"](this, oBrowserEvent);

	if (!bIsAccordionItem && UCF_JsUtil["bInstanceOf"](oItem, "UCF_Accordion")) {
		var oSource = oBrowserEvent["oGetSource"](),
			sId = oSource["id"]["split"]("-")[0];

		if (sId != null) {
			oItem = this["oLS"]["oControlFactory"]["oGetControlById"](sId);
			bIsAccordionItem = UCF_JsUtil["bInstanceOf"](oItem, "UCF_AccordionItem");
		}
	}

	return bIsAccordionItem && bPossible;
};;if (__UCF_COVERAGE__) { UCF_AccordionDropDelegate["_"]["bIsDropPossible"] = 0; };

};
sap["ls"]["preload"]["UCF_AccordionItem"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_AccordionItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["UCF_AccordionItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "AccordionItem.js(27): UCF_AccordionItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "AccordionItem.js(28): UCF_AccordionItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "AccordionItem.js(29): UCF_AccordionItem"); };
	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oFocusDomRef"] = UCF_DomUtil["$"](this["sId"] + "-title");

	//create inplace edit objects and fields
	if (this["bHasEditableTitle"]) {
		var oInplaceEditDelegate = this["oInplaceEditDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEditDelegate"))(oLS);
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this, "onInplaceEditStart");
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this, "onInplaceEditFinished");
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this, 'onInplaceEditClosed');
		this["addDelegate"](oInplaceEditDelegate);
	}
};window["UCF_AccordionItem"] = UCF_AccordionItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AccordionItem"); UCF_AccordionItem["_"] = {UCF_AccordionItem: 0}; }; ;

UCF_AccordionItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_AccordionItem.prototype["sClassName"] = "UCF_AccordionItem";

/**
 * @param {Object} oParams
 */
UCF_AccordionItem["prototype"]["onInplaceEditStart"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onInplaceEditStart"]++; }; 

	var oBrowserEvent = oParams["mParameters"]["oBrowserEvent"],
		oSource = oBrowserEvent["oGetSource"](),
		oTitle = UCF_DomUtil["$"](this["sId"] + "-textedit"),
		oBoundaries = UCF_DomUtil["oGetObjectRect"](oTitle);

	if (!UCF_DomUtil["bContains"](oSource, oTitle)) return;

	this["oInplaceEditDelegate"]["setInplaceEditData"](
		oTitle,
		oBoundaries,
		this["sTitle"]
	);
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onInplaceEditStart"] = 0; };

/**
 * @param { Object } oParams
 */
UCF_AccordionItem["prototype"]["onInplaceEditFinished"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onInplaceEditFinished"]++; }; 

	var sText = oParams["oGetParam"]("sText");
	if (sText === this["sTitle"]) return;

	var oTitle = UCF_DomUtil["$"](this["sId"] + "-textedit"),
		oAccordion = this["oGetParent"]();

	UCF_DomUtil["setInnerHtml"](oTitle, UCF_XSSEncoder["encodeHTML"](sText));
	this["sTitle"] = sText;
	this["setClientProperty"]("Title", this["sTitle"], true);

	oAccordion["fireChange"](oAccordion["sId"], this["sId"], sText);

	var oTitleDomRef = UCF_DomUtil["$"](this["sId"] + "-title");
	UCF_DomUtil["focusDomElement"](oTitleDomRef);

};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onInplaceEditFinished"] = 0; };

UCF_AccordionItem["prototype"]["onInplaceEditClosed"] = function() {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onInplaceEditClosed"]++; }; 
	var oTitleDomRef = UCF_DomUtil["$"](this["sId"] + "-title");
	UCF_DomUtil["focusDomElement"](oTitleDomRef);
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onInplaceEditClosed"] = 0; };

UCF_AccordionItem["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onmouseover"]++; }; 

	var oTitle = UCF_DomUtil["$"](this["sId"] + "-title");

	if (!this["bEnabled"] || oTitle["className"]["indexOf"]("Hover") > -1) return;
	//Hover is done using :hover pseudoclass for Standards mode
	if (window["UCF_System"]["sDevice"] === "standards") return;

	if (oTitle["className"]["indexOf"]("Emph") === -1) {
		var sStyle = oTitle["className"];
		sStyle += "Hover";
		oTitle["className"] = sStyle;
	} else {
		// "lsAcrTitle lsAcrTitleEmph" => "lsAcrTitleHover lsAcrTitleEmph"
		var aNames = oTitle["className"]["split"](" ");
		aNames[0] = aNames[0] + "Hover";
		oTitle["className"] = aNames["join"](" ");
	}
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onmouseover"] = 0; };

UCF_AccordionItem["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onmouseout"]++; }; 

	var oTitle = UCF_DomUtil["$"](this["sId"] + "-title");
	UCF_DomUtil["removeClass"](oTitle, "lsAcrTitleDown");

	if (!this["bEnabled"] || oTitle["className"]["indexOf"]("Hover") < 0) return;

	//Hover is done using :hover pseudoclass for Standards mode
	if (window["UCF_System"]["sDevice"] === "standards") return;

	if (oTitle["className"]["indexOf"]("Emph") === -1) {
		var sStyle = oTitle["className"];
		sStyle = sStyle["split"]("Hover")[0];
		oTitle["className"] = sStyle;
	} else {
		// "lsAcrTitleHover lsAcrTitleEmph" => "lsAcrTitle lsAcrTitleEmph"
		var aNames = oTitle["className"]["split"](" ");
		aNames[0] = aNames[0]["split"]("Hover")[0];
		oTitle["className"] = aNames["join"](" ");
	}
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onmouseout"] = 0; };

UCF_AccordionItem["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onmousedown"]++; }; 
	var oTitle = UCF_DomUtil["$"](this["sId"] + "-title");
	if (UCF_DomUtil["bHasClass"](oTitle, "lsAcrTitleDsbl")) return;
	UCF_DomUtil["addClass"](oTitle, "lsAcrTitleDown");
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onmousedown"] = 0; };

UCF_AccordionItem["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onmouseup"]++; }; 
	var oTitle = UCF_DomUtil["$"](this["sId"] + "-title");
	UCF_DomUtil["removeClass"](oTitle, "lsAcrTitleDown");
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onmouseup"] = 0; };

UCF_AccordionItem["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onlstouchstart"]++; }; 
	this["onmousedown"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onlstouchstart"] = 0; };

UCF_AccordionItem["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onlstouchend"]++; }; 
	this["onmouseup"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["onlstouchend"] = 0; };

UCF_AccordionItem["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["destroy"]++; }; 
	var oInplaceEditDelegate = this["oInplaceEditDelegate"];
	if (oInplaceEditDelegate) {
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this);
		this["oInplaceEditDelegate"]["destroy"]();
		this["oInplaceEditDelegate"] = null;
	}

	this["sTitle"] = "";
	this["sItemDesign"] = "";

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["destroy"] = 0; };

/**
 * Changes the visual appearance of an item.
 * @param {string} sDesign Value of AccordionItemDesign enumeration.
 * @public
 */
UCF_AccordionItem["prototype"]["setItemDesign"] = function(sDesign) {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["setItemDesign"]++; }; 
	if (typeof(sDesign) !== "string") return;

	var oTitle = UCF_DomUtil["$"](this["sId"] + "-title");

	//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	var oCnt = UCF_DomUtil["$"](this["sId"] + "-cnt")["firstChild"];
	var oCntDiv = oCnt["firstChild"];
	if (sDesign["toUpperCase"]() === "EMPHASIZED") {
		if (oTitle["className"]["indexOf"]("Emph") === -1) {
			// Title
			UCF_DomUtil["addClass"](oTitle, "lsAcrTitleEmph");
			// Content - Do not change class if collapsed - it will be set when expanded
			if (oCnt["className"]["indexOf"]("Collapsed") === -1) {
				UCF_DomUtil["addClass"](oCnt, "lsAcrCntEmph");
				UCF_DomUtil["addClass"](oCntDiv, "lsAcrCntEmphBrd");

				if (this["bHasContentPadding"] && this["sVerticalSizing"] === "PUSH") {
					// EMPHASIZED: substract 2px border width from padding
					UCF_DomUtil["removeClass"](oCntDiv, "lsAcrCntPadding lsResponsivePadding");
					UCF_DomUtil["addClass"](oCntDiv, "lsAcrCntPaddingEmph lsResponsivePadding");
				}
			}
		}
		this["sItemDesign"] = sDesign;
		this["setClientProperty"]("ItemDesign", this["sItemDesign"], true);
	} else if (sDesign["toUpperCase"]() === "STANDARD") {
		if (oTitle["className"]["indexOf"]("Emph") > -1) {
			// Title
			UCF_DomUtil["removeClass"](oTitle, "lsAcrTitleEmph");
			// Content - Do not change class if collapsed - it will be set when expanded
			if (oCnt["className"]["indexOf"]("Collapsed") === -1) {
				UCF_DomUtil["removeClass"](oCnt, "lsAcrCntEmph");
				UCF_DomUtil["removeClass"](oCntDiv, "lsAcrCntEmphBrd");
				if (this["bHasContentPadding"] && this["sVerticalSizing"] === "PUSH") {
					UCF_DomUtil["removeClass"](oCntDiv, "lsAcrCntPaddingEmph lsResponsivePadding");
					UCF_DomUtil["addClass"](oCntDiv, "lsAcrCntPadding lsResponsivePadding");
				}
			}
		}
		this["sItemDesign"] = sDesign;
		this["setClientProperty"]("ItemDesign", this["sItemDesign"], true);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Invalid value for AccordionItemDesign:" + sDesign, "AccordionItem.js(217): setItemDesign"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["setItemDesign"] = 0; };

/**
 * Returns the enumeration value for the item design.
 * @return {string} the enumeration value for the item design.
 * @public
 */
UCF_AccordionItem["prototype"]["sGetItemDesign"] = function() {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["sGetItemDesign"]++; }; 
	// Note: ItemDesign has a default value
	return this["sItemDesign"];
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["sGetItemDesign"] = 0; };

/**
 * Returns the id of the item.
 * @return {string} the id of the item.
 * @public
 */
UCF_AccordionItem["prototype"]["sGetId"] = function() {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["sGetId"]++; }; 
	return this["sId"];
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["sGetId"] = 0; };

/*
 * Returns the index of the item.
 * @return the index of the item.
 * @public
 */
UCF_AccordionItem["prototype"]["iGetIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["iGetIndex"]++; }; 
	return this["iIndex"];
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["iGetIndex"] = 0; };

/**
 * @private
 * @see UCF_DTExtension
 * @param {UCF_BrowserEvent} oDTElement the lsaccessibility
 * @return {Object} - the DTE extension
 */
UCF_AccordionItem["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["oGetDTExtension"]++; }; 
	return UCF_Control.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]("UCF_AccordionItemDTExtension"));
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["oGetDTExtension"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_AccordionItem["prototype"]["aAttributeNames"] = ["sTooltip","sTitle","bEnabled","iIndex","bHasToggleIcon","bHasEditableTitle","sDropTargetInfo","sDragData","iScrollTop","iScrollLeft","sHotkeysId","bHasContentPadding","bExpandForMultipleSelection","sItemDesign","bRequired","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_AccordionItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_AccordionItem["prototype"]["aMethodNames"] = ["setItemDesign","sGetItemDesign","sGetId","iGetIndex","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_AccordionItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_AccordionItem["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_AccordionItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {number}
 */
UCF_AccordionItem["prototype"]["iIndex"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_AccordionItem["prototype"]["bHasToggleIcon"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_AccordionItem["prototype"]["bHasEditableTitle"] = false;

/**
 * @private
 * @type {string}
 */
UCF_AccordionItem["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_AccordionItem["prototype"]["sDragData"] = '';

/**
 * @private
 * @type {number}
 */
UCF_AccordionItem["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_AccordionItem["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_AccordionItem["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_AccordionItem["prototype"]["bHasContentPadding"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_AccordionItem["prototype"]["bExpandForMultipleSelection"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.AccordionItemDesign}
 */
UCF_AccordionItem["prototype"]["sItemDesign"] = "STANDARD";

/**
 * @private
 * @type {boolean}
 */
UCF_AccordionItem["prototype"]["bRequired"] = false;

/**
 * @private
 * @type {string}
 */
UCF_AccordionItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_AccordionItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sTitle"] = '';
	this["bEnabled"] = true;
	this["iIndex"] = 0;
	this["bHasToggleIcon"] = true;
	this["bHasEditableTitle"] = false;
	this["sDropTargetInfo"] = '';
	this["sDragData"] = '';
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["sHotkeysId"] = '';
	this["bHasContentPadding"] = true;
	this["bExpandForMultipleSelection"] = false;
	this["sItemDesign"] = "STANDARD";
	this["bRequired"] = false;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Index", 0, true);
		this["setClientProperty"]("HasToggleIcon", true, true);
		this["setClientProperty"]("HasEditableTitle", false, true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("DragData", '', true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("HasContentPadding", true, true);
		this["setClientProperty"]("ExpandForMultipleSelection", false, true);
		this["setClientProperty"]("ItemDesign", "STANDARD", true);
		this["setClientProperty"]("Required", false, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_AccordionItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_AccordionItem.prototype["aPublicMethods"] = ["setItemDesign","sGetItemDesign","sGetId","iGetIndex"].concat(UCF_AccordionItem.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_AccordionItemDTExtension"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DTExtension */
/// <reference path="./DTExtension.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oControl
 * @param {UCF_DTElement} oDTElement
 */
function UCF_AccordionItemDTExtension(oLS, oControl, oDTElement) {if (__UCF_COVERAGE__) { UCF_AccordionItemDTExtension["_"]["UCF_AccordionItemDTExtension"]++; }; 
	if (arguments["length"] == 0) return;
	UCF_DTExtension["apply"](this, arguments);
};window["UCF_AccordionItemDTExtension"] = UCF_AccordionItemDTExtension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AccordionItemDTExtension"); UCF_AccordionItemDTExtension["_"] = {UCF_AccordionItemDTExtension: 0}; }; ;

UCF_AccordionItemDTExtension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTExtension"))(); UCF_AccordionItemDTExtension.prototype["sClassName"] = "UCF_AccordionItemDTExtension";

UCF_AccordionItemDTExtension["prototype"]["oGetScrollAreaDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_AccordionItemDTExtension["_"]["oGetScrollAreaDomRef"]++; }; 
	// Accordion does not always create a UCF_ScrollArea !
	return UCF_DomUtil["$"](this["oControl"]["sId"] + "-scrl");
};;if (__UCF_COVERAGE__) { UCF_AccordionItemDTExtension["_"]["oGetScrollAreaDomRef"] = 0; };

};
sap["ls"]["preload"]["UCF_AcfAdapter"] = function() {/* global _trace, DEBUG, INFO, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>

/**
 * @class
 * 
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_AcfAdapter(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["UCF_AcfAdapter"]++; }; 

	if (arguments["length"] === 0) return;

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["attachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"], "onPendingRequest");

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];

	// consider Drag&Drop specialties for locking
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["Lock"], this, "onLock");
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["Unlock"], this, "onUnlock");

	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["LayersVisible"], this, "onLayersVisible");
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["LayersHidden"], this, "onLayersHidden");

	this["bKeepAlive"] = true;
	/** @type {UCF_Control} */
	this["oControl"] = null;
	/** @type {HTMLElement} */
	this["oObjectRef"] = null;
	this["bLoaded"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["bInitialized"] = false;
	this["bIsServiceEvent"] = false;
	this["iParamCount"] = 0;
	this["mEventParameters"] = {};
	this["bDestroyed"] = false;
	this["bLockFreeze"] = oBrowserWindow["bIsLocked"](); // eslint-disable-line @ur/no-memory-leaks

	// Note: JIRA WDAUIUR1-1547
	// We "unofficially" support active content in a single DIV-popup for WDA.
	// If the AC is contained in a PW then a single "layer" is visible.
	// We do explicitly NOT support multible nested popups with AC.
	this["bLayerFreeze"] = (this["bHasParentPopupWindow"]() !== true && oBrowserWindow["bLayersVisible"]()); // eslint-disable-line @ur/no-memory-leaks

	this["sTimeoutId"] = null; // eslint-disable-line @ur/no-memory-leaks

	if (this["iTimeout"] > 0) {
		this["sTimeoutId"] = UCF_JsUtil["delayedCall"](this["iTimeout"] * 1000, this, "onTimeout");
	}

};window["UCF_AcfAdapter"] = UCF_AcfAdapter; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AcfAdapter"); UCF_AcfAdapter["_"] = {UCF_AcfAdapter: 0}; }; 
UCF_AcfAdapter["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_AcfAdapter.prototype["sClassName"] = "UCF_AcfAdapter";

/**
 * Inititalize ACF
 */
UCF_AcfAdapter["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["initialize"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Loaded: " + this["bLoaded"], "AcfAdapter.js(70): initialize"); };
	if (this["bLoaded"]) {
		if (!this["bInitialized"]) {
			this["doInitialize"]();
		} else {
			this["invoke"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["initialize"] = 0; };

/**
 * Inititalize ACF after load
 */
UCF_AcfAdapter["prototype"]["doInitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["doInitialize"]++; }; 
	if (this["sTimeoutId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeoutId"]);
		this["sTimeoutId"] = null;
	}
	this["oObjectRef"] = this["oGetObjectRef"]();
	// Silverlight does not offer the ACF methods on the object itself
	if (UCF_JsUtil["bInstanceOf"](this["oControl"], "UCF_SilverlightContainer")) {
		this["oObjectRef"] = this["oObjectRef"]["Content"]["WDIsland"];
	}
	this["setBaseUrl"]();
	this["bInitialized"] = true;
	this["invoke"]();
	if (this["bLockFreeze"] || this["bLayerFreeze"]) this["oObjectRef"]["freeze"]();
	if (this["oPendingRequest"]) {
		this["oPendingRequest"]["resume"](this["sId"]);
		this["oPendingRequest"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["doInitialize"] = 0; };

/**
 * Destructor
 */
UCF_AcfAdapter["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroy"]++; }; 

	if (this["bDestroyed"]) return;
	this["bDestroyed"] = true;

	delete UCF_AcfAdapter["mInstances"][this["oControl"]["sId"]];
	delete UCF_AcfAdapter["mLoaded"][this["oControl"]["sId"]];

	this["bKeepAlive"] = false;
	this["oControl"] = null;
	this["mEventParameters"] = null;
	this["oObjectRef"] = null;

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Lock"], this);
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Unlock"], this);
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["LayersVisible"], this);
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["LayersHidden"], this);

	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);
	this["oPendingRequest"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroy"] = 0; };

/**
 * Timeout handling
 */
UCF_AcfAdapter["prototype"]["onTimeout"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onTimeout"]++; }; 
	this["fireTimeout"](this["sId"]);
	if (this["oPendingRequest"]) {
		this["oPendingRequest"]["resume"](this["sId"]);
		this["oPendingRequest"] = null;
	}
	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onTimeout"] = 0; };

/**
 * Set control
 * @param {UCF_Control} oControl
 */
UCF_AcfAdapter["prototype"]["setControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setControl"]++; }; 
	this["oControl"] = oControl;

	this["bLoaded"] = UCF_AcfAdapter["mLoaded"][oControl["sId"]];
	UCF_AcfAdapter["mInstances"][oControl["sId"]] = this;

};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setControl"] = 0; };

/**
 * Handler for PendingRequest event
 *
 * @param {UCF_Event} oEvent
 */
UCF_AcfAdapter["prototype"]["onPendingRequest"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onPendingRequest"]++; }; 
	this["oPendingRequest"] = oEvent["oGetParam"]("oPendingRequest");
	if (!this["bInitialized"]) {
		this["oPendingRequest"]["suspend"](this["sId"]);
	} else {
		if (this["oControl"]["bVisible"]) this["oObjectRef"]["saveChanges"]();
		this["oPendingRequest"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onPendingRequest"] = 0; };

/**
 * @return {HTMLElement} object reference(DOM object of the control)
 */
UCF_AcfAdapter["prototype"]["oGetObjectRef"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["oGetObjectRef"]++; }; 
	return this["oControl"]["oGetObjectRef"]();
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["oGetObjectRef"] = 0; };

/**
 * Forward bDoKeepAlive to active component, to be kept alive
 * as long as the control we are connected to
 * @return {boolean}
 */
UCF_AcfAdapter["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["bDoKeepAlive"]++; }; 
	if (this["bDestroyed"]) return false;
	return this["oControl"]["bDoKeepAlive"]();
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["bDoKeepAlive"] = 0; };

/**
 * Needs special reconnectToDom methods, as it can be kept alive,
 * although it has no valid dom reference
 */
UCF_AcfAdapter["prototype"]["reconnectToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["reconnectToDom"]++; }; 
	if (!UCF_DomUtil["$"](this["sId"])) return;
	UCF_Control.prototype["reconnectToDom"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["reconnectToDom"] = 0; };

/**
 * Get the base URL for this application
 * @return {string} base URL
 */
UCF_AcfAdapter["prototype"]["sGetBaseUrl"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["sGetBaseUrl"]++; }; 
	var sBaseUrl = location["href"],
		iQuestionMarkPos = sBaseUrl["indexOf"]("?");
	if (iQuestionMarkPos > 0) sBaseUrl = sBaseUrl["substr"](0, iQuestionMarkPos);
	return sBaseUrl;
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["sGetBaseUrl"] = 0; };

/**
 * Initialize ACF control
 */
UCF_AcfAdapter["prototype"]["setBaseUrl"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setBaseUrl"]++; }; 
	this["oObjectRef"]["setBaseUrl"](this["sGetBaseUrl"]());
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setBaseUrl"] = 0; };

/**
 * Set invocation XML
 */
UCF_AcfAdapter["prototype"]["invoke"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["invoke"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Invoke: " + this["oDomRef"]["innerHTML"], "AcfAdapter.js(218): invoke"); };
	var sReturnValue = "",
		sInvokeMethod = "invoke",
		sInvokeXML = this["oDomRef"]["innerHTML"];

	// Flash Specific stuff
	if (UCF_JsUtil["bInstanceOf"](this["oControl"], "UCF_FlashContainer")) {
		// The flash ActiveX uses "invoke" internally, so we user "invokeData" instead
		sInvokeMethod = "invokeData";

		// replace 0D0A with single 0A (see int 3845611 2009)
		if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Invoke length retrieved : " + sInvokeXML["length"], "AcfAdapter.js(230): invoke"); };
			sInvokeXML = sInvokeXML["replace"](/\r\n/g, "\n");
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Invoke length normalized: " + sInvokeXML["length"], "AcfAdapter.js(232): invoke"); };
		}
	}

	sReturnValue = this["oObjectRef"][sInvokeMethod](sInvokeXML);

	// Convert Java string to JS string (Firefox)
	sReturnValue = "" + sReturnValue;
	this["fireReturnValue"](this["sId"], sReturnValue);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["invoke"] = 0; };

/**
 * Freeze ACF control
 */
UCF_AcfAdapter["prototype"]["freeze"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["freeze"]++; }; 
	if (this["bInitialized"] && !(this["bLayerFreeze"] || this["bLockFreeze"])) {
		this["oObjectRef"]["freeze"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["freeze"] = 0; };

/**
 * Unfreeze ACF control
 */
UCF_AcfAdapter["prototype"]["unfreeze"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["unfreeze"]++; }; 
	if (this["bInitialized"] && !(this["bLayerFreeze"] || this["bLockFreeze"])) {
		this["oObjectRef"]["unfreeze"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["unfreeze"] = 0; };

/**
 * onLock - freeze only when no Drag&Drop is pending
 */
UCF_AcfAdapter["prototype"]["onLock"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLock"]++; }; 
	if (this["oLS"]["oBrowserWindow"]["bLockedAsDragDrop"]()) {
		this["bLockFreeze"] = true;
		return;
	}
	this["freeze"]();
	this["bLockFreeze"] = true;
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLock"] = 0; };

/**
 * onUnlock - unfreeze only when no Drag&Drop is pending
 */
UCF_AcfAdapter["prototype"]["onUnlock"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onUnlock"]++; }; 
	if (this["oLS"]["oBrowserWindow"]["bLockedAsDragDrop"]()) {
		this["bLockFreeze"] = false;
		return;
	}
	this["bLockFreeze"] = false;
	this["unfreeze"]();
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onUnlock"] = 0; };

/**
 * onLayersVisible
 */
UCF_AcfAdapter["prototype"]["onLayersVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLayersVisible"]++; }; 
	if (this["bHasParentPopupWindow"]() !== true) {
		this["freeze"]();
		this["bLayerFreeze"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLayersVisible"] = 0; };

/**
 * onLayersHidden
 */
UCF_AcfAdapter["prototype"]["onLayersHidden"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLayersHidden"]++; }; 
	this["bLayerFreeze"] = false;
	this["unfreeze"]();
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["onLayersHidden"] = 0; };

/**
 * Static map for ACF instances
 */
UCF_AcfAdapter["mInstances"] = {};
UCF_AcfAdapter["mLoaded"] = {};

/**
 * ACF API forwarder for calls coming from the ACF
 * @param {string} sId id
 */
UCF_AcfAdapter["notifyLoad"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyLoad"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	UCF_AcfAdapter["mLoaded"][sId] = true;
	if (oInstance) UCF_JsUtil["delayedCall"](0, oInstance, "notifyLoad");
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyLoad"] = 0; };
UCF_AcfAdapter["createEvent"] = function(sId, sCommand) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createEvent"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["createEvent"](sCommand);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called createEvent, but no AcfAdapter exists for this ID.", "AcfAdapter.js(323): createEvent"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createEvent"] = 0; };
UCF_AcfAdapter["createServiceEvent"] = function(sId, sCommand) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createServiceEvent"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["createServiceEvent"](sCommand);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called createServiceEvent, but no AcfAdapter exists for this ID.", "AcfAdapter.js(331): createServiceEvent"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createServiceEvent"] = 0; };
UCF_AcfAdapter["addEventParameter"] = function(sId, sName, sValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["addEventParameter"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["addEventParameter"](sName, sValue);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called addEventParameter, but no AcfAdapter exists for this ID.", "AcfAdapter.js(339): addEventParameter"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["addEventParameter"] = 0; };
UCF_AcfAdapter["fireEvent"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireEvent"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["doFireEvent"]();
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called fireEvent, but no AcfAdapter exists for this ID.", "AcfAdapter.js(347): fireEvent"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireEvent"] = 0; };
UCF_AcfAdapter["setAttribute"] = function(sId, sName, sValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setAttribute"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["setAttribute"](sName, sValue);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called setAttribute, but no AcfAdapter exists for this ID.", "AcfAdapter.js(355): setAttribute"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setAttribute"] = 0; };
UCF_AcfAdapter["trace"] = function(sId, sClassName, sMethodName, iSeverity, sDescription) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["trace"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["trace"](sClassName, sMethodName, iSeverity, sDescription);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called trace, but no AcfAdapter exists for this ID.", "AcfAdapter.js(363): trace"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["trace"] = 0; };
UCF_AcfAdapter["getDragSession"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getDragSession"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		return oInstance["getDragSession"]();
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called getDragSession, but no AcfAdapter exists for this ID.", "AcfAdapter.js(371): getDragSession"); };
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getDragSession"] = 0; };
UCF_AcfAdapter["createDragSession"] = function(sId, sDragSessionData) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createDragSession"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		return oInstance["createDragSession"](sDragSessionData);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called createDragSession, but no AcfAdapter exists for this ID.", "AcfAdapter.js(380): createDragSession"); };
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createDragSession"] = 0; };
UCF_AcfAdapter["destroyDragSession"] = function(sId, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroyDragSession"]++; }; 
	var oInstance = UCF_AcfAdapter["mInstances"][sId];
	if (oInstance) {
		oInstance["destroyDragSession"](sDragSessionId);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Active component \"" + sId + "\" called destroyDragSession, but no AcfAdapter exists for this ID.", "AcfAdapter.js(389): destroyDragSession"); };
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroyDragSession"] = 0; };

/**
 * ACF API function currently no in use
 * @param {string} sId id
 */
UCF_AcfAdapter["notifyHooked"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyHooked"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyHooked"] = 0; };
UCF_AcfAdapter["lock"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["lock"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["lock"] = 0; };
UCF_AcfAdapter["unLock"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["unLock"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["unLock"] = 0; };
UCF_AcfAdapter["gotFocus"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["gotFocus"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["gotFocus"] = 0; };
UCF_AcfAdapter["lostFocus"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["lostFocus"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["lostFocus"] = 0; };
UCF_AcfAdapter["tabToNext"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["tabToNext"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["tabToNext"] = 0; };
UCF_AcfAdapter["tabToPrevious"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["tabToPrevious"]++; }; 
	// not used
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["tabToPrevious"] = 0; };
UCF_AcfAdapter["getPagePointer"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getPagePointer"]++; }; 
	return "";
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getPagePointer"] = 0; };

/**
 * Callback function to notify that the control is loaded and ready for commands
 */
UCF_AcfAdapter["prototype"]["notifyLoad"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyLoad"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Intitialized: " + this["bInitialized"], "AcfAdapter.js(426): notifyLoad"); };
	this["bLoaded"] = true;

	if (!this["bInitialized"]) {
		this["doInitialize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["notifyLoad"] = 0; };

/**
 * Callback function to create an event
 * @param {string} sCommand
 */
UCF_AcfAdapter["prototype"]["createEvent"] = function(sCommand) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createEvent"]++; }; 
	this["mEventParameters"] = {
		"Id": this["sId"],
		"Command": sCommand
	};
	this["bIsServiceEvent"] = false;
	this["iParamCount"] = 0;
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createEvent"] = 0; };

/**
 * Callback function to create a service event
 * @param {string} sCommand
 */
UCF_AcfAdapter["prototype"]["createServiceEvent"] = function(sCommand) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createServiceEvent"]++; }; 
	this["mEventParameters"] = {
		"Id": this["sId"],
		"Command": sCommand
	};
	this["bIsServiceEvent"] = true;
	this["iParamCount"] = 0;
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createServiceEvent"] = 0; };

/**
 * Callback function to add parameters to the event
 * @param {string} sName name
 * @param {string} sValue value
 */
UCF_AcfAdapter["prototype"]["addEventParameter"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["addEventParameter"]++; }; 
	this["mEventParameters"]["Name" + this["iParamCount"]] = sName;
	this["mEventParameters"]["Value" + this["iParamCount"]] = sValue;
	this["iParamCount"]++;
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["addEventParameter"] = 0; };

/**
 * Callback function to fire the event
 */
UCF_AcfAdapter["prototype"]["doFireEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["doFireEvent"]++; }; 
	var sEventName = this["bIsServiceEvent"] ? "ServiceEvent" : "Event";
	this["fireSemanticEvent"]("AcfAdapter", sEventName, this["mEventParameters"], false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["doFireEvent"] = 0; };

/**
 * Callback function set an attribute of the control
 * @param {string} sName name
 * @param {string} sValue value
 **/
UCF_AcfAdapter["prototype"]["setAttribute"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setAttribute"]++; }; 
	this["fireAttributeChange"](this["sId"], sName, sValue);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setAttribute"] = 0; };

/**
 * Callback function for tracing
 * @param {string} sClassName
 * @param {string} sMethodName
 * @param {integer} iSeverity
 * @param {string} sDescription
 */
UCF_AcfAdapter["prototype"]["trace"] = function(sClassName, sMethodName, iSeverity, sDescription) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["trace"]++; }; 
	// TODO
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["trace"] = 0; };

/**
 * Callback function to get the current drag session
 *
 * @return {JSONObject} the current drag session in JSON notation or null
 */
UCF_AcfAdapter["prototype"]["getDragSession"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getDragSession"]++; }; 
	var oDragAndDropManager = this["oLS"]["oBrowserWindow"]["oGetDragAndDropManager"]();
	return oDragAndDropManager["sGetDragSession"]();
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["getDragSession"] = 0; };

/**
 * Callback function to create a new drag session
 *
 * @param {JSONObject} sDragSessionData the drag session
 * @return {string} the drag session id
 */
UCF_AcfAdapter["prototype"]["createDragSession"] = function(sDragSessionData) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createDragSession"]++; }; 
	var oDragAndDropManager = this["oLS"]["oBrowserWindow"]["oGetDragAndDropManager"]();
	return oDragAndDropManager["sCreateDragSession"](sDragSessionData);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["createDragSession"] = 0; };

/**
 * Callback function to destroy the current drag session
 *
 * @param {string} sDragSessionId the id of the drag session
 */
UCF_AcfAdapter["prototype"]["destroyDragSession"] = function(sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroyDragSession"]++; }; 
	var oDragAndDropManager = this["oLS"]["oBrowserWindow"]["oGetDragAndDropManager"]();
	oDragAndDropManager["destroyDragSession"](sDragSessionId);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["destroyDragSession"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_AcfAdapter["prototype"]["aAttributeNames"] = ["iTimeout","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_AcfAdapter["prototype"]["aEventNames"] = ["Event","ServiceEvent","AttributeChange","ReturnValue","Timeout"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_AcfAdapter["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_AcfAdapter["prototype"]["iTimeout"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_AcfAdapter["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_AcfAdapter["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setDefaultValues"]++; }; 
	this["iTimeout"] = 0;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Timeout", 0, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The id of the AcfAdapter.
 * @param {string} sName0 Generic event parameter name
 * @param {string} sValue0 Generic event parameter value
 * @param {string} sName1 Generic event parameter name
 * @param {string} sValue1 Generic event parameter value
 * @param {string} sName2 Generic event parameter name
 * @param {string} sValue2 Generic event parameter value
 * @param {string} sName3 Generic event parameter name
 * @param {string} sValue3 Generic event parameter value
 * @param {string} sName4 Generic event parameter name
 * @param {string} sValue4 Generic event parameter value
 * @param {string} sName5 Generic event parameter name
 * @param {string} sValue5 Generic event parameter value
 * @param {string} sName6 Generic event parameter name
 * @param {string} sValue6 Generic event parameter value
 * @param {string} sName7 Generic event parameter name
 * @param {string} sValue7 Generic event parameter value
 * @param {string} sName8 Generic event parameter name
 * @param {string} sValue8 Generic event parameter value
 * @param {string} sName9 Generic event parameter name
 * @param {string} sValue9 Generic event parameter value
 * @fires AcfAdapter::Event
 */
UCF_AcfAdapter["prototype"]["fireEvent"] = function(sId, sName0, sValue0, sName1, sValue1, sName2, sValue2, sName3, sValue3, sName4, sValue4, sName5, sValue5, sName6, sValue6, sName7, sValue7, sName8, sValue8, sName9, sValue9) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireEvent"]++; }; 
	/** @type {{Id: string, Name0: string, Value0: string, Name1: string, Value1: string, Name2: string, Value2: string, Name3: string, Value3: string, Name4: string, Value4: string, Name5: string, Value5: string, Name6: string, Value6: string, Name7: string, Value7: string, Name8: string, Value8: string, Name9: string, Value9: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 21, "arguments.length == 21", "AcfAdapter.js(605): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AcfAdapter.js(606): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AcfAdapter.js(607): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName0 != null, "sName0 != null", "AcfAdapter.js(608): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName0) == "string", "typeof(sName0) == \"string\"", "AcfAdapter.js(609): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue0 != null, "sValue0 != null", "AcfAdapter.js(610): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue0) == "string", "typeof(sValue0) == \"string\"", "AcfAdapter.js(611): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName1 != null, "sName1 != null", "AcfAdapter.js(612): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName1) == "string", "typeof(sName1) == \"string\"", "AcfAdapter.js(613): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue1 != null, "sValue1 != null", "AcfAdapter.js(614): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue1) == "string", "typeof(sValue1) == \"string\"", "AcfAdapter.js(615): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName2 != null, "sName2 != null", "AcfAdapter.js(616): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName2) == "string", "typeof(sName2) == \"string\"", "AcfAdapter.js(617): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue2 != null, "sValue2 != null", "AcfAdapter.js(618): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue2) == "string", "typeof(sValue2) == \"string\"", "AcfAdapter.js(619): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName3 != null, "sName3 != null", "AcfAdapter.js(620): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName3) == "string", "typeof(sName3) == \"string\"", "AcfAdapter.js(621): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue3 != null, "sValue3 != null", "AcfAdapter.js(622): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue3) == "string", "typeof(sValue3) == \"string\"", "AcfAdapter.js(623): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName4 != null, "sName4 != null", "AcfAdapter.js(624): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName4) == "string", "typeof(sName4) == \"string\"", "AcfAdapter.js(625): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue4 != null, "sValue4 != null", "AcfAdapter.js(626): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue4) == "string", "typeof(sValue4) == \"string\"", "AcfAdapter.js(627): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName5 != null, "sName5 != null", "AcfAdapter.js(628): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName5) == "string", "typeof(sName5) == \"string\"", "AcfAdapter.js(629): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue5 != null, "sValue5 != null", "AcfAdapter.js(630): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue5) == "string", "typeof(sValue5) == \"string\"", "AcfAdapter.js(631): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName6 != null, "sName6 != null", "AcfAdapter.js(632): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName6) == "string", "typeof(sName6) == \"string\"", "AcfAdapter.js(633): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue6 != null, "sValue6 != null", "AcfAdapter.js(634): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue6) == "string", "typeof(sValue6) == \"string\"", "AcfAdapter.js(635): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName7 != null, "sName7 != null", "AcfAdapter.js(636): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName7) == "string", "typeof(sName7) == \"string\"", "AcfAdapter.js(637): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue7 != null, "sValue7 != null", "AcfAdapter.js(638): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue7) == "string", "typeof(sValue7) == \"string\"", "AcfAdapter.js(639): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName8 != null, "sName8 != null", "AcfAdapter.js(640): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName8) == "string", "typeof(sName8) == \"string\"", "AcfAdapter.js(641): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue8 != null, "sValue8 != null", "AcfAdapter.js(642): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue8) == "string", "typeof(sValue8) == \"string\"", "AcfAdapter.js(643): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName9 != null, "sName9 != null", "AcfAdapter.js(644): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName9) == "string", "typeof(sName9) == \"string\"", "AcfAdapter.js(645): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue9 != null, "sValue9 != null", "AcfAdapter.js(646): fireEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue9) == "string", "typeof(sValue9) == \"string\"", "AcfAdapter.js(647): fireEvent"); };
	mParams = {
		"Id": sId,
		"Name0": sName0,
		"Value0": sValue0,
		"Name1": sName1,
		"Value1": sValue1,
		"Name2": sName2,
		"Value2": sValue2,
		"Name3": sName3,
		"Value3": sValue3,
		"Name4": sName4,
		"Value4": sValue4,
		"Name5": sName5,
		"Value5": sValue5,
		"Name6": sName6,
		"Value6": sValue6,
		"Name7": sName7,
		"Value7": sValue7,
		"Name8": sName8,
		"Value8": sValue8,
		"Name9": sName9,
		"Value9": sValue9
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("AcfAdapter", "Event", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireEvent"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the AcfAdapter.
 * @param {string} sName0 Generic event parameter name
 * @param {string} sValue0 Generic event parameter value
 * @param {string} sName1 Generic event parameter name
 * @param {string} sValue1 Generic event parameter value
 * @param {string} sName2 Generic event parameter name
 * @param {string} sValue2 Generic event parameter value
 * @param {string} sName3 Generic event parameter name
 * @param {string} sValue3 Generic event parameter value
 * @param {string} sName4 Generic event parameter name
 * @param {string} sValue4 Generic event parameter value
 * @param {string} sName5 Generic event parameter name
 * @param {string} sValue5 Generic event parameter value
 * @param {string} sName6 Generic event parameter name
 * @param {string} sValue6 Generic event parameter value
 * @param {string} sName7 Generic event parameter name
 * @param {string} sValue7 Generic event parameter value
 * @param {string} sName8 Generic event parameter name
 * @param {string} sValue8 Generic event parameter value
 * @param {string} sName9 Generic event parameter name
 * @param {string} sValue9 Generic event parameter value
 * @fires AcfAdapter::ServiceEvent
 */
UCF_AcfAdapter["prototype"]["fireServiceEvent"] = function(sId, sName0, sValue0, sName1, sValue1, sName2, sValue2, sName3, sValue3, sName4, sValue4, sName5, sValue5, sName6, sValue6, sName7, sValue7, sName8, sValue8, sName9, sValue9) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireServiceEvent"]++; }; 
	/** @type {{Id: string, Name0: string, Value0: string, Name1: string, Value1: string, Name2: string, Value2: string, Name3: string, Value3: string, Name4: string, Value4: string, Name5: string, Value5: string, Name6: string, Value6: string, Name7: string, Value7: string, Name8: string, Value8: string, Name9: string, Value9: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 21, "arguments.length == 21", "AcfAdapter.js(724): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AcfAdapter.js(725): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AcfAdapter.js(726): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName0 != null, "sName0 != null", "AcfAdapter.js(727): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName0) == "string", "typeof(sName0) == \"string\"", "AcfAdapter.js(728): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue0 != null, "sValue0 != null", "AcfAdapter.js(729): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue0) == "string", "typeof(sValue0) == \"string\"", "AcfAdapter.js(730): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName1 != null, "sName1 != null", "AcfAdapter.js(731): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName1) == "string", "typeof(sName1) == \"string\"", "AcfAdapter.js(732): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue1 != null, "sValue1 != null", "AcfAdapter.js(733): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue1) == "string", "typeof(sValue1) == \"string\"", "AcfAdapter.js(734): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName2 != null, "sName2 != null", "AcfAdapter.js(735): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName2) == "string", "typeof(sName2) == \"string\"", "AcfAdapter.js(736): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue2 != null, "sValue2 != null", "AcfAdapter.js(737): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue2) == "string", "typeof(sValue2) == \"string\"", "AcfAdapter.js(738): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName3 != null, "sName3 != null", "AcfAdapter.js(739): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName3) == "string", "typeof(sName3) == \"string\"", "AcfAdapter.js(740): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue3 != null, "sValue3 != null", "AcfAdapter.js(741): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue3) == "string", "typeof(sValue3) == \"string\"", "AcfAdapter.js(742): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName4 != null, "sName4 != null", "AcfAdapter.js(743): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName4) == "string", "typeof(sName4) == \"string\"", "AcfAdapter.js(744): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue4 != null, "sValue4 != null", "AcfAdapter.js(745): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue4) == "string", "typeof(sValue4) == \"string\"", "AcfAdapter.js(746): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName5 != null, "sName5 != null", "AcfAdapter.js(747): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName5) == "string", "typeof(sName5) == \"string\"", "AcfAdapter.js(748): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue5 != null, "sValue5 != null", "AcfAdapter.js(749): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue5) == "string", "typeof(sValue5) == \"string\"", "AcfAdapter.js(750): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName6 != null, "sName6 != null", "AcfAdapter.js(751): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName6) == "string", "typeof(sName6) == \"string\"", "AcfAdapter.js(752): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue6 != null, "sValue6 != null", "AcfAdapter.js(753): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue6) == "string", "typeof(sValue6) == \"string\"", "AcfAdapter.js(754): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName7 != null, "sName7 != null", "AcfAdapter.js(755): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName7) == "string", "typeof(sName7) == \"string\"", "AcfAdapter.js(756): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue7 != null, "sValue7 != null", "AcfAdapter.js(757): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue7) == "string", "typeof(sValue7) == \"string\"", "AcfAdapter.js(758): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName8 != null, "sName8 != null", "AcfAdapter.js(759): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName8) == "string", "typeof(sName8) == \"string\"", "AcfAdapter.js(760): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue8 != null, "sValue8 != null", "AcfAdapter.js(761): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue8) == "string", "typeof(sValue8) == \"string\"", "AcfAdapter.js(762): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName9 != null, "sName9 != null", "AcfAdapter.js(763): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName9) == "string", "typeof(sName9) == \"string\"", "AcfAdapter.js(764): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue9 != null, "sValue9 != null", "AcfAdapter.js(765): fireServiceEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue9) == "string", "typeof(sValue9) == \"string\"", "AcfAdapter.js(766): fireServiceEvent"); };
	mParams = {
		"Id": sId,
		"Name0": sName0,
		"Value0": sValue0,
		"Name1": sName1,
		"Value1": sValue1,
		"Name2": sName2,
		"Value2": sValue2,
		"Name3": sName3,
		"Value3": sValue3,
		"Name4": sName4,
		"Value4": sValue4,
		"Name5": sName5,
		"Value5": sValue5,
		"Name6": sName6,
		"Value6": sValue6,
		"Name7": sName7,
		"Value7": sValue7,
		"Name8": sName8,
		"Value8": sValue8,
		"Name9": sName9,
		"Value9": sValue9
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("AcfAdapter", "ServiceEvent", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireServiceEvent"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the AcfAdapter.
 * @param {string} sName The name of the changed attribute.
 * @param {string} sValue The new value of the changed attribute.
 * @fires AcfAdapter::AttributeChange
 */
UCF_AcfAdapter["prototype"]["fireAttributeChange"] = function(sId, sName, sValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireAttributeChange"]++; }; 
	/** @type {{Id: string, Name: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "AcfAdapter.js(825): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AcfAdapter.js(826): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AcfAdapter.js(827): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != null, "sName != null", "AcfAdapter.js(828): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) == "string", "typeof(sName) == \"string\"", "AcfAdapter.js(829): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "AcfAdapter.js(830): fireAttributeChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "AcfAdapter.js(831): fireAttributeChange"); };
	mParams = {
		"Id": sId,
		"Name": sName,
		"Value": sValue
	};
	
	
	
	this["fireSemanticEvent"]("AcfAdapter", "AttributeChange", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireAttributeChange"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the AcfAdapter.
 * @param {string} sReturnValue The return value of the invoke call.
 * @fires AcfAdapter::ReturnValue
 */
UCF_AcfAdapter["prototype"]["fireReturnValue"] = function(sId, sReturnValue) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireReturnValue"]++; }; 
	/** @type {{Id: string, ReturnValue: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "AcfAdapter.js(853): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AcfAdapter.js(854): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AcfAdapter.js(855): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sReturnValue != null, "sReturnValue != null", "AcfAdapter.js(856): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sReturnValue) == "string", "typeof(sReturnValue) == \"string\"", "AcfAdapter.js(857): fireReturnValue"); };
	mParams = {
		"Id": sId,
		"ReturnValue": sReturnValue
	};
	
	
	this["fireSemanticEvent"]("AcfAdapter", "ReturnValue", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireReturnValue"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the AcfAdapter.
 * @fires AcfAdapter::Timeout
 */
UCF_AcfAdapter["prototype"]["fireTimeout"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireTimeout"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "AcfAdapter.js(876): fireTimeout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "AcfAdapter.js(877): fireTimeout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "AcfAdapter.js(878): fireTimeout"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("AcfAdapter", "Timeout", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_AcfAdapter["_"]["fireTimeout"] = 0; };

};
sap["ls"]["preload"]["UCF_ActiveComponent"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_PlaceHolder */
/// <reference path="./PlaceHolder.js"/>

/**
 * ActiveComponent
 *
 * 
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ActiveComponent(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ActiveComponent["_"]["UCF_ActiveComponent"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ActiveComponent.js(24): UCF_ActiveComponent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ActiveComponent.js(25): UCF_ActiveComponent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ActiveComponent.js(26): UCF_ActiveComponent"); };

	UCF_PlaceHolder["apply"](this, [oDomRef, oLS]);

	var oAdapterRef = UCF_DomUtil["$"](this["sId"] + "-a");
	if (oAdapterRef) oAdapterRef = UCF_DomUtil["oGetFirstChild"](oAdapterRef);
	if (oAdapterRef) {
		this["oAdapter"] = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oAdapterRef, true);
		this["oAdapter"]["setControl"](this);
	}

};window["UCF_ActiveComponent"] = UCF_ActiveComponent; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ActiveComponent"); UCF_ActiveComponent["_"] = {UCF_ActiveComponent: 0}; }; ;
UCF_ActiveComponent["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PlaceHolder"))(); UCF_ActiveComponent.prototype["sClassName"] = "UCF_ActiveComponent";

/**
 * Initialize method
 */
UCF_ActiveComponent["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_ActiveComponent["_"]["initialize"]++; }; 
	UCF_PlaceHolder.prototype["initialize"]["apply"](this, arguments);
	if (this["oAdapter"]) this["oAdapter"]["initialize"]();
};;if (__UCF_COVERAGE__) { UCF_ActiveComponent["_"]["initialize"] = 0; };

/**
 * Destructor
 */
UCF_ActiveComponent["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ActiveComponent["_"]["destroy"]++; }; 

	// IE causes weird crashes, if objects are not removed separately
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		if (this["oDomRef"] && this["oDomRef"]["parentNode"]) this["oDomRef"]["parentNode"]["removeChild"](this["oDomRef"]);
	}

	// Make sure to also purge the adapter when the active component is destroyed
	if (this["oAdapter"]) {
		this["oLS"]["oControlFactory"]["purgeControl"](this["oAdapter"]);
		this["oAdapter"] = null;
	}

	UCF_PlaceHolder.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ActiveComponent["_"]["destroy"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_ActiveComponent["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ActiveComponent["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ActiveComponent["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_ActiveComponent["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ActiveComponent["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ActiveComponent["_"]["onlsskipback"] = 0; };

/**
 * Do not process context menu events within active components
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_ActiveComponent["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ActiveComponent["_"]["oncontextmenu"]++; }; 

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ActiveComponent["_"]["oncontextmenu"] = 0; };

};
sap["ls"]["preload"]["UCF_ActiveXContainer"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ActiveComponent */
/// <reference path="./base/ActiveComponent.js"/>

/**
 * 
 * @version
 *
 * @class ActiveXContainer
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ActiveXContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ActiveXContainer["_"]["UCF_ActiveXContainer"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ActiveXContainer.js(19): UCF_ActiveXContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ActiveXContainer.js(20): UCF_ActiveXContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ActiveXContainer.js(21): UCF_ActiveXContainer"); };

	UCF_ActiveComponent["apply"](this, [oDomRef, oLS]);
};window["UCF_ActiveXContainer"] = UCF_ActiveXContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ActiveXContainer"); UCF_ActiveXContainer["_"] = {UCF_ActiveXContainer: 0}; }; ;
UCF_ActiveXContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ActiveComponent"))(); UCF_ActiveXContainer.prototype["sClassName"] = "UCF_ActiveXContainer";

/**
 * Writes the appropriate acc text into the tooltip
 * @param {UCF_BrowserEvent} oBrowserEvent The browser event
 * @private
 */
UCF_ActiveXContainer["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ActiveXContainer["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ActiveXContainer.js(33): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() != this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["setControlType"]("AX");
	oAccessibilityHelper["applyContainerEntryBehaviour"]();
};;if (__UCF_COVERAGE__) { UCF_ActiveXContainer["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ActiveXContainer["prototype"]["aAttributeNames"] = ["sVisibility","sTooltip","sLifeCycle","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ActiveXContainer["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ActiveXContainer["prototype"]["aMethodNames"] = ["setKeepAlive","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ActiveXContainer["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ActiveXContainer["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_ActiveXContainer["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_ActiveXContainer["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ActiveXContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ActiveXContainer["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sLifeCycle"] = "BROWSER";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ActiveXContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Animation"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Animator */
/// <reference path="./Animator.js"/>

/** @typedef {0} UCF_Animation_ValueParamType */
/** @typedef {1} UCF_Animation_StyleValueParamType */
/** @typedef {2} UCF_Animation_StyleColorParamType */
/** @typedef {3} UCF_Animation_StyleOpacityParamType */
/** @typedef {4} UCF_Animation_StyleTransformParamType */
/** @typedef {UCF_Animation_ValueParamType|UCF_Animation_StyleValueParamType|UCF_Animation_StyleColorParamType|UCF_Animation_StyleOpacityParamType|UCF_Animation_StyleTransformParamType} UCF_Animation_ParamType */
/**
 * @typedef {Object} UCF_Animation_ParamTypeEnum
 * @property {UCF_Animation_ValueParamType} Value
 * @property {UCF_Animation_StyleValueParamType} StyleValue
 * @property {UCF_Animation_StyleColorParamType} StyleColor
 * @property {UCF_Animation_StyleOpacityParamType} StyleOpacity
 * @property {UCF_Animation_StyleTransformParamType} StyleTransform
 */
/** @typedef {function(number): number} UCF_Animation_Transition */
/**
 * @typedef {Object} UCF_Animation_TransitionEnum
 * @property {UCF_Animation_Transition} Linear
 * @property {UCF_Animation_Transition} EaseIn
 * @property {UCF_Animation_Transition} EaseOut
 * @property {UCF_Animation_Transition} EaseInOut
 * @property {UCF_Animation_Transition} LinearLoopBack
 * @property {UCF_Animation_Transition} EaseLoopBack
 */
/**
 * @typedef {Object} UCF_Animation_StyleOpacityParam
 * @property {number} sValue
 * @property {UCF_Animation_StyleOpacityParamType} iParamType
 */
/**
 * @typedef {Object} UCF_Animation_StyleTransformParam
 * @property {string} sName
 * @property {string} sTransformation
 * @property {number[]} aValues
 * @property {UCF_Animation_StyleTransformParamType} iParamType
 * @property {boolean} bIsFloat
 */
/**
 * @typedef {Object} UCF_Animation_StyleValueParam
 * @property {string} sName
 * @property {string} sValue
 * @property {UCF_Animation_StyleValueParamType} iParamType
 */
/**
 * @typedef {Object} UCF_Animation_ValueParam
 * @property {string} sName
 * @property {string} sValue
 * @property {UCF_Animation_ValueParamType} iParamType
 */
/** @typedef {UCF_Animation_StyleOpacityParam|UCF_Animation_StyleTransformParam|UCF_Animation_StyleValueParam|UCF_Animation_ValueParam} UCF_Animation_Param */
/**
 * @typedef {Object} UCF_Animation_UninitializedStyleTransformChangeParam
 * @property {string} sName
 * @property {string} sTransformation
 * @property {number[]} aStartValues
 * @property {number[]} aEndValues
 * @property {UCF_Animation_Transition} fnTransition
 * @property {UCF_Animation_StyleTransformParamType} iParamType
 * @property {boolean} bIsFloat
 * @property {false} bInitialized
 */
/**
 * @typedef {Object} UCF_Animation_InitializedStyleTransformChangeParam
 * @property {string} sName
 * @property {string} sTransformation
 * @property {number[]} aStartValues
 * @property {number[]} aEndValues
 * @property {UCF_Animation_Transition} fnTransition
 * @property {UCF_Animation_StyleTransformParamType} iParamType
 * @property {boolean} bIsFloat
 * @property {true} bInitialized
 * @property {string[]} aValues
 */
/** @typedef {UCF_Animation_UninitializedStyleTransformChangeParam|UCF_Animation_InitializedStyleTransformChangeParam} UCF_Animation_StyleTransformChangeParam */
/**
 * @typedef {Object} UCF_Animation_StyleValueChangeParam
 * @property {string} sName
 * @property {string} sPrefix
 * @property {string} sSuffix
 * @property {number} iStartValue
 * @property {number} iEndValue
 * @property {number} [iRange]
 * @property {UCF_Animation_Transition} fnTransition
 * @property {UCF_Animation_StyleValueParamType} iParamType
 * @property {boolean} [bOverflowChanged=false]
 * @property {number} [iDigits] TODO unused
 * @property {boolean} [bCssTransition] TODO unused
 */
/**
 * @typedef {Object} UCF_Animation_UninitializedStyleOpacityChangeParam
 * @property {number} iStartValue
 * @property {number} iEndValue
 * @property {UCF_Animation_Transition} fnTransition
 * @property {UCF_Animation_StyleOpacityParamType} iParamType
 * @property {false} bInitialized
 * @property {boolean} [bCssTransition] TODO unused
 */
/**
 * @typedef {Object} UCF_Animation_InitializedStyleOpacityChangeParam
 * @property {number} iStartValue
 * @property {number} iEndValue
 * @property {number} iRange
 * @property {UCF_Animation_Transition} fnTransition
 * @property {UCF_Animation_StyleOpacityParamType} iParamType
 * @property {true} bInitialized
 * @property {boolean} [bCssTransition] TODO unused
 */
/** @typedef {UCF_Animation_UninitializedStyleOpacityChangeParam|UCF_Animation_InitializedStyleOpacityChangeParam} UCF_Animation_StyleOpacityParam */
/**
 * @typedef {Object} UCF_Animation_UninitializedValueChangeParam
 * @property {string} sName
 * @property {number} iStartValue
 * @property {number} iEndValue
 * @property {UCF_Animation_Transition} fnTransition
 * @property {UCF_Animation_ValueParamType} iParamType
 * @property {false} bInitialized
 * @property {boolean} [bCssTransition] TODO unused
 */
/**
 * @typedef {Object} UCF_Animation_InitializedValueChangeParam
 * @property {string} sName
 * @property {number} iStartValue
 * @property {number} iEndValue
 * @property {number} iRange
 * @property {UCF_Animation_Transition} fnTransition
 * @property {UCF_Animation_ValueParamType} iParamType
 * @property {true} bInitialized
 * @property {boolean} [bCssTransition] TODO unused
 */
/** @property {UCF_Animation_UninitializedValueChangeParam|UCF_Animation_InitializedValueChangeParam} UCF_Animation_ValueChangeParam */
/**
 * @typedef {Object} UCF_Animation_UninitializedStyleColorChangeParam
 * @property {string} sName
 * @property {string} sStartValue
 * @property {string} sEndValue
 * @property {UCF_Animation_Transition} fnTransition
 * @property {UCF_Animation_StyleColorParamType} iParamType
 * @property {false} bInitialized
 * @property {boolean} [bCssTransition] TODO unused
 */
/**
 * @typedef {Object} UCF_Animation_InitializedStyleColorChangeParam
 * @property {string} sName
 * @property {string} sStartValue
 * @property {string} sEndValue
 * @property {UCF_Animation_Transition} fnTransition
 * @property {UCF_Animation_StyleColorParamType} iParamType
 * @property {true} bInitialized
 * @property {UCF_Animation_StyleColorChangeParamPart} oRedPart
 * @property {UCF_Animation_StyleColorChangeParamPart} oGreenPart
 * @property {UCF_Animation_StyleColorChangeParamPart} oBluePart
 * @property {boolean} [bCssTransition] TODO unused
 */
/** @typedef {UCF_Animation_UninitializedStyleColorChangeParam|UCF_Animation_InitializedStyleColorChangeParam} UCF_Animation_StyleColorChangeParam */
/** @typedef {UCF_Animation_StyleTransformChangeParam|UCF_Animation_StyleValueChangeParam|UCF_Animation_StyleOpacityChangeParam|UCF_Animation_ValueChangeParam|UCF_Animation_StyleColorChangeParam} UCF_Animation_ChangeParam */
/**
 * @typedef {Object} UCF_Animation_StyleColorChangeParamPart
 * @property {number} iStartValue
 * @property {number} iEndValue
 * @property {UCF_Animation_Transition} fnTransition
 */
/**
 * @typedef {Object} UCF_Animation_RGB
 * @property {number} iRed
 * @property {number} iGreen
 * @property {number} iBlue
 */
/**
 * Animation class to provide animation functionality to all controls
 *
 * 
 * @version
 *
 * @class UCF_Animation
 * @extends UCF_Object
 * @param {HTMLElement} oDomRef
 * @param {number} iTime
 */
function UCF_Animation(oDomRef, iTime) {if (__UCF_COVERAGE__) { UCF_Animation["_"]["UCF_Animation"]++; }; 
	/** @type {string} */
	this["sId"] = UCF_JsUtil["sGetUID"]();
	/**
	 * @deprecated unused
	 * @type {any}
	 */
	this["oTimer"] = null;
	/** @type {boolean} */
	this["bRunning"] = false;
	/** @type {UCF_Animation_ChangeParam[]} */
	this["aParameters"] = new Array();
	/** @type {UCF_Animation_Param[]} */
	this["aInitialParameters"] = new Array();
	/** @type {UCF_Animation_Param[]} */
	this["aFinalParameters"] = new Array();
	/** @type {HTMLElement} */
	this["oDomRef"] = null;
	/** @type {number} */
	this["iElapsedTime"] = 0;
	/** @type {number} */
	this["iTime"] = 500;
	/** @type {number} */
	this["iStartTimeStamp"] = 0;

	/** @type {Object} */
	this["oFinishCallbackObject"] = null;
	/** @type {string} */
	this["sFinishCallbackMethod"] = null;

	/** @type {Object} */
	this["oStepCallbackObject"] = null;
	/** @type {string} */
	this["sStepCallbackMethod"] = null;

	/** @type {Object<string, number>} */
	this["oHexToInt"] = null;
	/** @type {Object<number, string>} */
	this["oIntToHex"] = null;

	if (oDomRef) {
		this["setDomRef"](oDomRef);
	}
	if (iTime) {
		this["setTime"](iTime);
	}

	// Make sure UCF_Animator is loaded
	UCF_ClassLoader["oGetClass"]('UCF_Animator');
};window["UCF_Animation"] = UCF_Animation; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Animation"); UCF_Animation["_"] = {UCF_Animation: 0}; }; ;
UCF_Animation["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Animation.prototype["sClassName"] = "UCF_Animation";

/**
 * @protected
 * @static
 * @type {boolean} Only used for testability support
 */
UCF_Animation["bRunning"] = false;

/** @override */
UCF_Animation["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["destroy"]++; }; 
	this["stop"]();
	this["sId"] = null;
	this["bRunning"] = null;
	this["aParameters"] = null;
	this["aInitialParameters"] = null;
	this["aFinalParameters"] = null;
	this["oDomRef"] = null;
	this["iElapsedTime"] = null;
	this["iTime"] = null;
	this["iStartTimeStamp"] = null;
	this["oFinishCallbackObject"] = null;
	this["sFinishCallbackMethod"] = null;
	this["oStepCallbackObject"] = null;
	this["sStepCallbackMethod"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["destroy"] = 0; };

/**
 * Internal Enum for parameter types, that have to be treated differently while
 * animating
 * @private
 * @type {UCF_Animation_ParamTypeEnum}
 */
UCF_Animation["prototype"]["E_PARAM_TYPE"] = {
	"Value": 0,
	"StyleValue": 1,
	"StyleColor": 2,
	"StyleOpacity": 3,
	"StyleTransform": 4
};

/**
 * Predefined transition functions for the animation
 * @private
 * @type {UCF_Animation_TransitionEnum}
 */
UCF_Animation["prototype"]["M_TRANSITIONS"] = {
	"Linear": function LinearTransition(fValue) {
		return fValue;
	},
	"EaseIn": function EaseInTransition(fValue) {
		// eslint-disable-next-line no-magic-numbers
		return Math["sin"](fValue * Math["PI"] / 2);
	},
	"EaseOut": function EaseOutTransition(fValue) {
		// eslint-disable-next-line no-magic-numbers
		return Math["sin"]((fValue - 1) * Math["PI"] / 2) + 1;
	},
	"EaseInOut": function EaseInOutTransition(fValue) {
		// eslint-disable-next-line no-magic-numbers
		return (Math["sin"](fValue * Math["PI"] / 2) * fValue + (Math["sin"]((fValue - 1) * Math["PI"] / 2) + 1) * (1 - fValue));
	},
	"LinearLoopBack": function LinearLoopBackTransition(fValue) {
		// eslint-disable-next-line no-magic-numbers
		return 1 - Math["abs"](fValue - 0.5) * 2;
	},
	"EaseLoopBack": function EaseLoopBackTransition(fValue) {
		return Math["sin"](fValue * Math["PI"]);
	}
};

/**
 * Sets the time for the animation
 *
 * @protected
 * @param {number} iTime time for the animation
 */
UCF_Animation["prototype"]["setTime"] = function(iTime) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["setTime"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iTime === 'number', "typeof iTime === 'number'", "Animation.js(328): setTime"); };

	this["iTime"] = iTime;
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["setTime"] = 0; };

/**
 * Register a callback method sMethodName that is called on oObject after the
 * animation is finalized
 *
 * @protected
 * @param {Object} oObject
 * @param {string} sMethodName
 */
UCF_Animation["prototype"]["callbackFinish"] = function(oObject, sMethodName) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["callbackFinish"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oObject === 'object', "typeof oObject === 'object'", "Animation.js(342): callbackFinish"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oObject != null, "oObject != null", "Animation.js(343): callbackFinish"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oObject[sMethodName] != null, "oObject[sMethodName] != null", "Animation.js(344): callbackFinish"); };

	this["oFinishCallbackObject"] = oObject;
	this["sFinishCallbackMethod"] = sMethodName;
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["callbackFinish"] = 0; };

/**
 * Register a callback method sMethodName that is called on oObject after the
 * animation is finalized
 *
 * @protected
 * @param {Object} oObject
 * @param {string} sMethodName
 */
UCF_Animation["prototype"]["callbackStep"] = function(oObject, sMethodName) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["callbackStep"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oObject === 'object', "typeof oObject === 'object'", "Animation.js(359): callbackStep"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oObject != null, "oObject != null", "Animation.js(360): callbackStep"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oObject[sMethodName] != null, "oObject[sMethodName] != null", "Animation.js(361): callbackStep"); };

	this["oStepCallbackObject"] = oObject;
	this["sStepCallbackMethod"] = sMethodName;
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["callbackStep"] = 0; };

/**
 * Removes the callback
 * @protected
 */
UCF_Animation["prototype"]["callbackRemove"] = function() {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["callbackRemove"]++; }; 
	this["oFinishCallbackObject"] = null;
	this["sFinishCallbackMethod"] = null;
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["callbackRemove"] = 0; };

/**
 * Sets the dom reference that is used for the animation
 *
 * @protected
 * @param {element} oDomRef dom reference
 */
UCF_Animation["prototype"]["setDomRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["setDomRef"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "Animation.js(383): setDomRef"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Animation.js(384): setDomRef"); };

	this["oDomRef"] = oDomRef;
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["setDomRef"] = 0; };

/**
 * Starts/stops the animation
 *
 * @protected
 * @param {boolean} bRunning whether to start or stop the animation
 */
UCF_Animation["prototype"]["run"] = function(bRunning) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["run"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof bRunning === 'boolean', "typeof bRunning === 'boolean'", "Animation.js(396): run"); };

	if (this["bRunning"] !== bRunning) {
		this["bRunning"] = bRunning;
		if (this["bRunning"]) {
			if (window["UCF_System"]["bUseAnimation"]) {
				UCF_Animation["bRunning"] = true;
			}

			this["applyInitialParameters"]();

			if (window["UCF_System"]["bUseAnimation"]) {
				UCF_Animator["attach"](this);
				this["iStartTimeStamp"] = UCF_Animator["iGetTimeStamp"]();
			} else {
				this["finalize"]();
			}
		} else {
			this["applyFinalParameters"]();
			UCF_Animator["detach"](this);
			UCF_Animation["bRunning"] = false;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["run"] = 0; };

/**
 * Plays the animation from the beginning
 * @protected
 */
UCF_Animation["prototype"]["play"] = function() {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["play"]++; }; 
	this["run"](true);
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["play"] = 0; };

/**
 * Stopps the animation at its current position
 * @protected
 */
UCF_Animation["prototype"]["stop"] = function() {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["stop"]++; }; 
	if (this["bRunning"]) {
		this["run"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["stop"] = 0; };

/**
 * Jumps directly to the end of the animation
 * @protected
 */
UCF_Animation["prototype"]["finish"] = function() {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["finish"]++; }; 
	this["finalize"]();
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["finish"] = 0; };

/**
 * Finalizes the animation
 *
 * @private
 */
UCF_Animation["prototype"]["finalize"] = function() {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["finalize"]++; }; 
	/** @type {UCF_Animation_ChangeParam[]} */
	var aParameters = this["aParameters"];
	/** @type {number} */
	var i;

	this["iElapsedTime"] = this["iTime"];

	for (i = 0; i < aParameters["length"]; i++) {
		this["stepParameter"](aParameters[i]);
	}

	if (this["oFinishCallbackObject"] && this["sFinishCallbackMethod"]) {
		this["oFinishCallbackObject"][this["sFinishCallbackMethod"]]();
	}

	this["run"](false);
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["finalize"] = 0; };

/**
 * Add a style value to apply intially when beginning the animation
 *
 * @protected
 * @param {number} iValue
 */
UCF_Animation["prototype"]["addInitialOpacityValue"] = function(iValue) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addInitialOpacityValue"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iValue === 'number', "typeof iValue === 'number'", "Animation.js(478): addInitialOpacityValue"); };

	this["aInitialParameters"]["push"]({
		// eslint-disable-next-line no-magic-numbers
		"sValue": Math["min"](100, Math["max"](0, iValue)),
		"iParamType": this["E_PARAM_TYPE"]["StyleOpacity"]
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addInitialOpacityValue"] = 0; };

/**
 * Add a style value to apply intially when beginning the animation
 *
 * @protected
 * @param {number} iValue
 */
UCF_Animation["prototype"]["addFinalOpacityValue"] = function(iValue) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addFinalOpacityValue"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iValue === 'number', "typeof iValue === 'number'", "Animation.js(494): addFinalOpacityValue"); };

	this["aFinalParameters"]["push"]({
		// eslint-disable-next-line no-magic-numbers
		"sValue": Math["min"](100, Math["max"](0, iValue)),
		"iParamType": this["E_PARAM_TYPE"]["StyleOpacity"]
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addFinalOpacityValue"] = 0; };

/**
 * @private
 * @param {string} sName
 * @return {string}
 */
UCF_Animation["prototype"]["sGetBrowserJSStyleName"] = function(sName) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["sGetBrowserJSStyleName"]++; }; 
	return sName === 'transform'
		? UCF_UserAgent["bIsWebKit"]()
		? 'webkitTransform'
		: UCF_UserAgent["bIsFirefox"](4) // eslint-disable-line no-magic-numbers
		? 'MozTransform'
		// eslint-disable-next-line no-magic-numbers
		: (UCF_UserAgent["bIsIE"](8) || UCF_UserAgent["bIsMSEdge"]())
		? 'msTransform'
		: sName
		: sName;
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["sGetBrowserJSStyleName"] = 0; };

/**
 * Add a transform value to apply intialy when beginning the animation
 *
 * @protected
 * @param {string} sTransformation The name of the tranformation
 * @param {number[]} aValues of values for the tranformation
 */
UCF_Animation["prototype"]["addInitialTransformValue"] = function(sTransformation, aValues) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addInitialTransformValue"]++; }; 
	this["aInitialParameters"]["push"]({
		"sName": this["sGetBrowserJSStyleName"]('transform'),
		"sTransformation": sTransformation,
		"aValues": aValues,
		"iParamType": this["E_PARAM_TYPE"]["StyleTransform"],
		"bIsFloat": sTransformation === 'scaleX' || sTransformation === 'scaleY'
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addInitialTransformValue"] = 0; };

/**
 * Add a transform  value to apply finally when the animation has ended
 *
 * @protected
 * @param {string} sTransformation The name of the tranformation
 * @param {number[]} aValues of values for the tranformation
 */
UCF_Animation["prototype"]["addFinalTransformValue"] = function(sTransformation, aValues) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addFinalTransformValue"]++; }; 
	this["aFinalParameters"]["push"]({
		"sName": this["sGetBrowserJSStyleName"]('transform'),
		"sTransformation": sTransformation,
		"aValues": aValues,
		"iParamType": this["E_PARAM_TYPE"]["StyleTransform"],
		"bIsFloat": sTransformation === 'scaleX' || sTransformation === 'scaleY'
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addFinalTransformValue"] = 0; };

/**
 * Adds a transform change step in the animation
 *
 * @protected
 * @param {string} sTransformation The name of the tranformation
 * @param {number[]} aStartValues
 * @param {number[]} aEndValues
 * @param {UCF_Animation_Transition} fnTransition
 */
UCF_Animation["prototype"]["addTransformChange"] = function(sTransformation, aStartValues, aEndValues, fnTransition) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addTransformChange"]++; }; 
	this["aParameters"]["push"]({
		"sName": this["sGetBrowserJSStyleName"]('transform'),
		"sTransformation": sTransformation,
		"aStartValues": aStartValues,
		"aEndValues": aEndValues,
		"fnTransition": fnTransition,
		"iParamType": this["E_PARAM_TYPE"]["StyleTransform"],
		"bIsFloat": sTransformation === 'scaleX' || sTransformation === 'scaleY'
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addTransformChange"] = 0; };

/**
 * Add a style value to apply intially when beginning the animation
 *
 * @protected
 * @param {string} sName
 * @param {string} sValue
 */
UCF_Animation["prototype"]["addInitialStyleValue"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addInitialStyleValue"]++; }; 
	this["aInitialParameters"]["push"]({
		"sName": this["sGetBrowserJSStyleName"](sName),
		"sValue": sValue,
		"iParamType": this["E_PARAM_TYPE"]["StyleValue"]
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addInitialStyleValue"] = 0; };

/**
 * Add a style value to apply finally when the animation has ended
 *
 * @protected
 * @param {string} sName
 * @param {string} sValue
 */
UCF_Animation["prototype"]["addFinalStyleValue"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addFinalStyleValue"]++; }; 
	this["aFinalParameters"]["push"]({
		"sName": this["sGetBrowserJSStyleName"](sName),
		"sValue": sValue,
		"iParamType": this["E_PARAM_TYPE"]["StyleValue"]
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addFinalStyleValue"] = 0; };

/**
 * Adds a style change as part of the animation
 *
 * @example
 * // linear fade out
 * oAnimation.addStyleChange('filter', 'alpha(opacity=', '%)', 100, 0, oAnimation.M_TRANSITIONS.Linear)
 *
 * @protected
 * @param {string} sName name of the style attribute that is changed during the
 * animation, e.g. 'filter'
 * @param {string} sPrefix prefix for the value, e.g. 'alpha(opacity='
 * @param {string} sSuffix suffix for the value, e.g. '%)'
 * @param {number} iStartValue integer value that is applied to sName if the
 * animation starts
 * @param {number} iEndValue integer value that should be reached if the
 * animation is finished
 * @param {UCF_Animation_Transition} fnTransition the transition function used
 * for this part
 */
UCF_Animation["prototype"]["addStyleChange"] = function(sName, sPrefix, sSuffix, iStartValue, iEndValue, fnTransition) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addStyleChange"]++; }; 
	this["aParameters"]["push"]({
		"sName": this["sGetBrowserJSStyleName"](sName),
		"sPrefix": sPrefix,
		"sSuffix": sSuffix,
		"iStartValue": iStartValue,
		"iEndValue": iEndValue,
		"fnTransition": fnTransition,
		"iParamType": this["E_PARAM_TYPE"]["StyleValue"]
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addStyleChange"] = 0; };

/**
 * Adds a alpha change as part of the animation
 *
 * @protected
 * @param {number} iStartValue integer value that is applied to sName if the
 * animation starts
 * @param {number} iEndValue integer value that should be reached if the
 * animation is finished
 * @param {UCF_Animation_Transition} fnTransition the transition function used
 * for this part
 */
UCF_Animation["prototype"]["addOpacityChange"] = function(iStartValue, iEndValue, fnTransition) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addOpacityChange"]++; }; 
	this["aParameters"]["push"]({
		// eslint-disable-next-line no-magic-numbers
		"iStartValue": Math["min"](100, Math["max"](0, parseInt(iStartValue))),
		// eslint-disable-next-line no-magic-numbers
		"iEndValue": Math["min"](100, Math["max"](0, parseInt(iEndValue))),
		"fnTransition": fnTransition,
		"iParamType": this["E_PARAM_TYPE"]["StyleOpacity"]
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addOpacityChange"] = 0; };

/**
 * Add a property value to apply intially when beginning the animation
 *
 * @deprected unused in the Lightspeed codebase
 * @protected
 * @param {string} sName
 * @param {string} sValue
 */
UCF_Animation["prototype"]["addInitialPropertyValue"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addInitialPropertyValue"]++; }; 
	this["aInitialParameters"]["push"]({
		"sName": sName,
		"sValue": sValue,
		"iParamType": this["E_PARAM_TYPE"]["Value"]
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addInitialPropertyValue"] = 0; };

/**
 * Add a property value to apply finally when the animation has ended
 *
 * @deprecated unused in the Lightspeed codebase
 * @protected
 * @param {string} sName
 * @param {string} sValue
 */
UCF_Animation["prototype"]["addFinalPropertyValue"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addFinalPropertyValue"]++; }; 
	this["aFinalParameters"]["push"]({
		"sName": sName,
		"sValue": sValue,
		"iParamType": this["E_PARAM_TYPE"]["Value"]
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addFinalPropertyValue"] = 0; };

/**
 * Adds a property change as part of the animation
 *
 * @example
 * oAnimation.addPropertyChange('scrollTop', 0, 250, oAnimation.M_TRANSITIONS.Linear)
 *
 * @deprecated unused in the Lightspeed codebase
 * @protected
 * @param {string} sName name of the property that is changed during the
 * animation, e.g. 'scrollTop'
 * @param {number} iStartValue integer value that is applied to sName if the
 * animation starts
 * @param {number} iEndValue integer value that should be reached if the
 * animation is finished
 * @param {UCF_Animation_Transition} fnTransition the transition function used
 * for this part
 */
UCF_Animation["prototype"]["addPropertyChange"] = function(sName, iStartValue, iEndValue, fnTransition) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addPropertyChange"]++; }; 
	this["aParameters"]["push"]({
		"sName": sName,
		"iStartValue": iStartValue,
		"iEndValue": iEndValue,
		"fnTransition": fnTransition,
		"iParamType": this["E_PARAM_TYPE"]["Value"]
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addPropertyChange"] = 0; };

/**
 * Adds a color change as part of the animation
 *
 * @param {string} sName name of the style attribute that is changed during the
 * animation, e.g. 'textColor'
 * @param {string} sStartValue color value that is applied to sName if the
 * animation starts; must be a 6-digit HEX value (e.g. '#bad101')
 * @param {string} sEndValue integer value that should be reached if the
 * animation is finished; must be a 6-digit HEX value (e.g. '#c0ffee')
 * @param {UCF_Animation_Transition} fnTransition the transition function used
 * for this part
 */
UCF_Animation["prototype"]["addColorChange"] = function(sName, sStartValue, sEndValue, fnTransition) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addColorChange"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(/^#[0-9A-F]{6}$/["test"](sStartValue), "/^#[0-9A-F]{6}$/.test(sStartValue)", "Animation.js(731): addColorChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(/^#[0-9A-F]{6}$/["test"](sEndValue), "/^#[0-9A-F]{6}$/.test(sEndValue)", "Animation.js(732): addColorChange"); };

	this["aParameters"]["push"]({
		"sName": sName,
		"sStartValue": sStartValue,
		"sEndValue": sEndValue,
		"fnTransition": fnTransition,
		"iParamType": this["E_PARAM_TYPE"]["StyleColor"]
	});
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["addColorChange"] = 0; };

/** @private */
UCF_Animation["prototype"]["applyInitialParameters"] = function() {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["applyInitialParameters"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Apply intial parameters', "Animation.js(745): applyInitialParameters"); };
	this["applyParameters"](this["aInitialParameters"]);
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["applyInitialParameters"] = 0; };

/** @private */
UCF_Animation["prototype"]["applyFinalParameters"] = function() {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["applyFinalParameters"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Apply final parameters', "Animation.js(751): applyFinalParameters"); };
	this["applyParameters"](this["aFinalParameters"]);
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["applyFinalParameters"] = 0; };

/**
 * Apply properties as defined in the parameter list
 *
 * @param {UCF_Animation_Param[]} aParameters
 */
UCF_Animation["prototype"]["applyParameters"] = function(aParameters) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["applyParameters"]++; }; 
	/** @type {UCF_Animation_Param} */
	var oParameter;
	/** @type {UCF_Animation_StyleTransformParam[]} */
	var aTransformParameters = [];
	/** @type {number} */
	var i;

	for (i = 0; i < aParameters["length"]; i++) {
		oParameter = aParameters[i];
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Apply parameter ' + oParameter["sName"] + ': ' + oParameter["sValue"], "Animation.js(770): applyParameters"); };

		switch (oParameter["iParamType"]) {
			case this["E_PARAM_TYPE"]["Value"]:
				this["oDomRef"][oParameter["sName"]] = oParameter["sValue"];
				break;
			case this["E_PARAM_TYPE"]["StyleValue"]:
				if (
					(oParameter["sName"] === 'height' || oParameter["sName"] === 'width') &&
					parseInt(oParameter["sValue"]) <= 0
				) {
					this["oDomRef"]["setAttribute"]('animdisplay', UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'display'));
					if (this["oDomRef"]["tagName"] === 'TD') {
						this["oDomRef"]["style"]["visibility"] = 'hidden';
					} else {
						this["oDomRef"]["style"]["display"] = 'none';
					}
				} else {
					this["oDomRef"]["style"][oParameter["sName"]] = oParameter["sValue"];
				}
				break;
			case this["E_PARAM_TYPE"]["StyleOpacity"]:
				UCF_DomUtil["setOpacityStyle"](this["oDomRef"], oParameter["sValue"]);
				break;
			case this["E_PARAM_TYPE"]["StyleTransform"]:
				aTransformParameters["push"](oParameter);
				break;
		}
	}
	if (aTransformParameters["length"] > 0) {
		this["setTransformParameters"](aTransformParameters);
	}
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["applyParameters"] = 0; };

/**
 * Executes the next step of the animation
 *
 * @private
 * @param {number} iTimeStamp the current timestamp used to calculate the
 * animation step
 */
UCF_Animation["prototype"]["step"] = function(iTimeStamp) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["step"]++; }; 
	/** @type {UCF_Animation_ChangeParam[]} */
	var aParameters;
	/** @type {UCF_Animation_StyleTransformChangeParam[]} */
	var aTransformParameters;
	/** @type {number} */
	var i;

	this["iElapsedTime"] = iTimeStamp - this["iStartTimeStamp"];

	if (this["iElapsedTime"] > this["iTime"]) {
		this["finalize"]();
	} else {
		aParameters = this["aParameters"];
		aTransformParameters = [];

		for (i = 0; i < aParameters["length"]; i++) {
			if (aParameters[i]["iParamType"] === this["E_PARAM_TYPE"]["StyleTransform"]) {
				aTransformParameters["push"](aParameters[i]);
			} else {
				this["stepParameter"](aParameters[i]);
			}
		}

		if (aTransformParameters["length"] > 0) {
			this["stepTransformParameters"](aTransformParameters);
		}

		if (this["oStepCallbackObject"] && this["sStepCallbackMethod"]) {
			this["oStepCallbackObject"][this["sStepCallbackMethod"]]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["step"] = 0; };

/**
 * @private
 * @param {UCF_Animation_StyleTransformChangeParam[]} aParameters
 */
UCF_Animation["prototype"]["stepTransformParameters"] = function(aParameters) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["stepTransformParameters"]++; }; 
	/** @type {number} */
	var i;
	/** @type {UCF_Animation_StyleTransformChangeParam} */
	var oParameter;
	/** @type {number} */
	var j;

	for (i = 0; i < aParameters["length"]; i++) {
		oParameter = aParameters[i];
		if (!oParameter["bInitialized"]) {
			oParameter["aValues"] = oParameter["aStartValues"]["join"](',')["split"](',');
			oParameter["bInitialized"] = true;
		}

		for (j = 0; j < oParameter["aValues"]["length"]; j++) {
			oParameter["aValues"][j] = Math["round"](oParameter["aStartValues"][j] +
				(oParameter["aEndValues"][j] - oParameter["aStartValues"][j]) *
				this["getStepFactor"](oParameter["fnTransition"]));
		}
	}

	this["setTransformParameters"](aParameters);
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["stepTransformParameters"] = 0; };

/**
 * @private
 * @param {UCF_Animation_StyleTransformChangeParam[]} aParameters
 */
UCF_Animation["prototype"]["setTransformParameters"] = function(aParameters) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["setTransformParameters"]++; }; 
	/** @type {Object<string,string>} */
	var mTransformations = {};
	/** @type {string} */
	var sTransformations = '';
	/** @type {string} */
	var sCurrent = '';
	/** @type {string} */
	var sName = this["sGetBrowserJSStyleName"]('transform');
	/** @type {number} */
	var i;
	/** @type {UCF_Animation_StyleTransformChangeParam} */
	var oParameter;
	/** @type {string} */
	var sValues;
	/** @type {number} */
	var j;
	/** @type {string} */
	var n;
	/** @type {number} */
	var iIndex;
	/** @type {string} */
	var s;
	/** @type {number} */
	var iEnd;

	for (i = 0; i < aParameters["length"]; i++) {
		oParameter = aParameters[i];
		sValues = '';

		for (j = 0; j < oParameter["aValues"]["length"]; j++) {
			if (sValues) {
				sValues += ',';
			}

			if (oParameter["bIsFloat"]) {
				// eslint-disable-next-line no-magic-numbers
				sValues += (oParameter["aValues"][j] / 100) + '';
			} else if (
				oParameter["sTransformation"] === 'rotate' ||
				oParameter["sTransformation"] === 'skewX' ||
				oParameter["sTransformation"] === 'skewY'
			) {
				sValues += oParameter["aValues"][j] + 'deg';
			} else if (
				oParameter["sTransformation"] === 'translateX' ||
				oParameter["sTransformation"] === 'translateY'
			) {
				sValues += oParameter["aValues"][j] + 'px';
			}
		}
		mTransformations[oParameter["sTransformation"]] = sValues;
	}

	sCurrent = this["oDomRef"]["style"][sName] || '';
	for (n in mTransformations) {
		if (sTransformations) {
			sTransformations += ' ';
		}
		sTransformations += n + '(' + mTransformations[n] + ')';
		iIndex = sCurrent["indexOf"](n);
		if (iIndex > -1) {
			s = sCurrent["substring"](iIndex);
			iEnd = s["indexOf"](')') + iIndex;
			sCurrent = sCurrent["substring"](0, iIndex) + sCurrent["substring"](iEnd + 1);
		}
	}
	this["oDomRef"]["style"][sName] = sTransformations + sCurrent;
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["setTransformParameters"] = 0; };

/**
 * Applies the value for the current step for a specific parameter
 *
 * @private
 * @param {UCF_Animation_ChangeParam} oParameter
 */
UCF_Animation["prototype"]["stepParameter"] = function(oParameter) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["stepParameter"]++; }; 
	/** @type {string} */
	var sAnimDisplay;
	/** @type {UCF_Animation_StyleTransformChangeParam[]} */
	var aTransformParameters;

	// TODO bCssTransition is NEVER set to true => can we just delete this if?
	if (oParameter["bCssTransition"]) {
		if (
			(oParameter["sName"] === 'width' || oParameter["sName"] === 'height') &&
			oParameter["iParamType"] === this["E_PARAM_TYPE"]["StyleValue"]
		) {
			if (oParameter["iStartValue"] === 0) {
				sAnimDisplay = this["oDomRef"]["getAttribute"]('animdisplay');
				if (sAnimDisplay) {
					// eslint-disable-next-line max-depth
					if (this["oDomRef"]["tagName"] === 'TD') {
						this["oDomRef"]["style"]["visibility"] = 'visible';
					}
					this["oDomRef"]["style"]["display"] = sAnimDisplay;
					this["oDomRef"]["setAttribute"]('animdisplay', '');
				}
			}
		}

		switch (oParameter["iParamType"]) {
			case this["E_PARAM_TYPE"]["StyleValue"]:
				oParameter["bCssTransitionApplied"] = true;
				this["oDomRef"]["style"][oParameter["sName"]] = oParameter["sPrefix"] +
					oParameter["iEndValue"] +
					oParameter["sSuffix"];
				break;
			case this["E_PARAM_TYPE"]["StyleOpacity"]:
				oParameter["bCssTransitionApplied"] = true;
				this["oDomRef"]["style"][oParameter["sName"]] = oParameter["sPrefix"] +
					oParameter["iEndValue"] / 100 + // eslint-disable-line no-magic-numbers
					oParameter["sSuffix"];
				break;
		}
	} else {
		aTransformParameters = [];

		switch (oParameter["iParamType"]) {
			case this["E_PARAM_TYPE"]["Value"]:
				this["oDomRef"][oParameter["sName"]] = this["iGetStepValue"](oParameter);
				break;
			case this["E_PARAM_TYPE"]["StyleValue"]:
				this["oDomRef"]["style"][oParameter["sName"]] = this["sGetStepStyleValue"](
					oParameter
				);
				break;
			case this["E_PARAM_TYPE"]["StyleColor"]:
				this["oDomRef"]["style"][oParameter["sName"]] = this["sGetStepStyleColor"](
					oParameter
				);
				break;
			case this["E_PARAM_TYPE"]["StyleOpacity"]:
				UCF_DomUtil["setOpacityStyle"](
					this["oDomRef"],
					this["iGetStepValue"](oParameter)
				);
				break;
			case this["E_PARAM_TYPE"]["StyleTransform"]:
				aTransformParameters["push"](oParameter);
				break;
		}
		if (aTransformParameters["length"] > 0) {
			this["stepTransformParameters"](aTransformParameters);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["stepParameter"] = 0; };

/**
 * Calculate the integer value for the current step
 *
 * @private
 * @param {UCF_Animation_StyleOpacityChangeParam|UCF_Animation_ValueChangeParam|UCF_Animation_StyleColorChangeParamPart} oParameter
 * @return {number} the calculated value
 */
UCF_Animation["prototype"]["iGetStepValue"] = function(oParameter) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["iGetStepValue"]++; }; 
	if (!oParameter["bInitialized"]) {
		oParameter["iStartValue"] = parseInt(oParameter["iStartValue"]);
		oParameter["iEndValue"] = parseInt(oParameter["iEndValue"]);
		oParameter["iRange"] = oParameter["iEndValue"] - oParameter["iStartValue"];
		oParameter["bInitialized"] = true;
	}

	return Math["round"](
		oParameter["iStartValue"] +
		oParameter["iRange"] * this["getStepFactor"](oParameter["fnTransition"])
	) / (oParameter["bIsFloat"] ? 100 : 1); // eslint-disable-line no-magic-numbers
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["iGetStepValue"] = 0; };

/**
 * Calculate the style value for the current step
 *
 * @private
 * @param {UCF_Animation_StyleValueChangeParam} oParameter
 * @return {string} the calculated value
 */
UCF_Animation["prototype"]["sGetStepStyleValue"] = function(oParameter) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["sGetStepStyleValue"]++; }; 
	/** @type {string} */
	var sOverflow;
	/** @type {number} */
	var iValue;
	/** @type {string} */
	var sName;
	/** @type {string} */
	var sAnimDisplay;

	if (
		!oParameter["bOverflowChanged"] &&
		(oParameter["sName"] === 'height' || oParameter["sName"] === 'width')
	) {
		sOverflow = UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'overflow');
		this["oDomRef"]["style"]["overflow"] = 'hidden';
		this["addFinalStyleValue"]('overflow', sOverflow);
		oParameter["bOverflowChanged"] = true;
	}

	iValue = this["iGetStepValue"](oParameter);
	sName = oParameter["sName"];
	sAnimDisplay = this["oDomRef"]["getAttribute"]('animdisplay');

	if (
		(sName === 'height' || sName === 'width') &&
		iValue > 0 &&
		sAnimDisplay
	) {
		if (this["oDomRef"]["tagName"] === 'TD') {
			this["oDomRef"]["style"]["visibility"] = 'visible';
		}
		this["oDomRef"]["style"]["display"] = sAnimDisplay;
		this["oDomRef"]["setAttribute"]('animdisplay', '');
	} else if ((sName === 'height' || sName === 'width') && iValue <= 0) {
		iValue = 1;
	}

	return oParameter["sPrefix"] +
		(
			oParameter["iDigits"]
			// TODO iDigits seems to never be set at all => remove the if?
			? UCF_StringUtil["fillChars"](iValue, '0', oParameter["iDigits"], true)
			: iValue
		) +
		oParameter["sSuffix"];
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["sGetStepStyleValue"] = 0; };

/**
 * Calculate the color value for the current step
 *
 * @private
 * @param {UCF_Animation_StyleColorChangeParam} oParameter
 * @return {string} the calculated value
 */
UCF_Animation["prototype"]["sGetStepStyleColor"] = function(oParameter) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["sGetStepStyleColor"]++; }; 
	/** @type {UCF_Animation_RGB} */
	var oStartRGB;
	/** @type {UCF_Animation_RGB} */
	var oEndRGB;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oParameter === 'object', "typeof oParameter === 'object'", "Animation.js(1115): sGetStepStyleColor"); };

	if (!oParameter["bInitialized"]) {
		oStartRGB = this["oGetRGBFromHex"](oParameter["sStartValue"]);
		oEndRGB = this["oGetRGBFromHex"](oParameter["sEndValue"]);

		oParameter["oRedPart"] = {
			"iStartValue": oStartRGB["iRed"],
			"iEndValue": oEndRGB["iRed"],
			"fnTransition": oParameter["fnTransition"]
		};
		oParameter["oGreenPart"] = {
			"iStartValue": oStartRGB["iGreen"],
			"iEndValue": oEndRGB["iGreen"],
			"fnTransition": oParameter["fnTransition"]
		};
		oParameter["oBluePart"] = {
			"iStartValue": oStartRGB["iBlue"],
			"iEndValue": oEndRGB["iBlue"],
			"fnTransition": oParameter["fnTransition"]
		};
		oParameter["bInitialized"] = true;
	}

	return this["sGetHexFromRGB"](
		this["iGetStepValue"](oParameter["oRedPart"]),
		this["iGetStepValue"](oParameter["oGreenPart"]),
		this["iGetStepValue"](oParameter["oBluePart"])
	);
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["sGetStepStyleColor"] = 0; };

/**
 * Calculate the calculation factor with the given transition function
 *
 * @private
 * @param {UCF_Animation_Transition} fnTransition
 * @return {number} the calculated transition factor
 */
UCF_Animation["prototype"]["getStepFactor"] = function(fnTransition) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["getStepFactor"]++; }; 
	return fnTransition(this["iElapsedTime"] / this["iTime"]);
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["getStepFactor"] = 0; };

/**
 * Calculate the integer RGB values from a hex color string
 *
 * @private
 * @param {string} sColor the hex color string
 * @return {UCF_Animation_RGB} object containing the red, green and blue value
 */
UCF_Animation["prototype"]["oGetRGBFromHex"] = function(sColor) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["oGetRGBFromHex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(/^#[0-9A-F]{6}$/["test"](sColor), "/^#[0-9A-F]{6}$/.test(sColor)", "Animation.js(1165): oGetRGBFromHex"); };

	if (!this["oHexToInt"]) {
		this["createHexTables"]();
	}

	if (sColor["charAt"](0) === '#') {
		sColor = sColor["substr"](1);
	}

	return {
		// eslint-disable-next-line no-magic-numbers
		"iRed": this["oHexToInt"][sColor["substr"](0, 2)],
		// eslint-disable-next-line no-magic-numbers
		"iGreen": this["oHexToInt"][sColor["substr"](2, 2)],
		// eslint-disable-next-line no-magic-numbers
		"iBlue": this["oHexToInt"][sColor["substr"](4, 2)]
	};
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["oGetRGBFromHex"] = 0; };

/**
 * Calculate a hex color string from the RGB values
 *
 * @private
 * @param {number} iRed the red color value
 * @param {number} iGreen the green color value
 * @param {number} iBlue the blue color value
 * @return {string} hex color string
 */
UCF_Animation["prototype"]["sGetHexFromRGB"] = function(iRed, iGreen, iBlue) {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["sGetHexFromRGB"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRed >= 0 && iRed <= 255, "iRed >= 0 && iRed <= 255", "Animation.js(1195): sGetHexFromRGB"); }; // eslint-disable-line no-magic-numbers
	// eslint-disable-next-line no-magic-numbers
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iGreen >= 0 && iGreen <= 255, "iGreen >= 0 && iGreen <= 255", "Animation.js(1197): sGetHexFromRGB"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iBlue >= 0 && iBlue <= 255, "iBlue >= 0 && iBlue <= 255", "Animation.js(1198): sGetHexFromRGB"); }; // eslint-disable-line no-magic-numbers

	if (!this["oIntToHex"]) {
		this["createHexTables"]();
	}

	return '#' +
		this["oIntToHex"][iRed] +
		this["oIntToHex"][iGreen] +
		this["oIntToHex"][iBlue];
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["sGetHexFromRGB"] = 0; };

/**
 * Returns whether the animation is still running.
 * @deprecated unused in the Lightspeed codebase
 * @protected
 * @return {boolean}
 */
UCF_Animation["prototype"]["bIsRunning"] = function() {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["bIsRunning"]++; }; 
	return this["bRunning"];
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["bIsRunning"] = 0; };

/**
 * Creates lookup tables for integer/hexadecimal conversion
 *
 * @private
 */
UCF_Animation["prototype"]["createHexTables"] = function() {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["createHexTables"]++; }; 
	/** @type {['1','2','3','4','5','6','7','8','9','A','B','C','D','E','F']} */
	var aHexDigits = [
		'0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E',
		'F'
	];
	/** @type {string} */
	var sHexValue;
	/** @type {number} */
	var iIntValue;
	/** @type {number} */
	var i;
	/** @type {number} */
	var j;

	this["oIntToHex"] = [];
	this["oHexToInt"] = {};

	for (i = 0; i < 16; i++) { // eslint-disable-line no-magic-numbers
		for (j = 0; j < 16; j++) { // eslint-disable-line no-magic-numbers
			iIntValue = i * 16 + j; // eslint-disable-line no-magic-numbers
			sHexValue = aHexDigits[i] + aHexDigits[j];
			this["oIntToHex"][iIntValue] = sHexValue;
			this["oHexToInt"][sHexValue] = iIntValue;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["createHexTables"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Animation["prototype"]["aAttributeNames"] = [];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Animation["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Animation["prototype"]["aMethodNames"] = ["play","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];


//#JSCOVER_EXCL_START
/** @protected */
UCF_Animation["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Animation["_"]["setDefaultValues"]++; }; 
	

	if (this["getClientControl"]() && !this["bKeepAlive"]) ;
};;if (__UCF_COVERAGE__) { UCF_Animation["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Animator"] = function() {/* global _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>

/**
 * Animator class, that coordinates the running animations. To avoid multiple
 * timeouts for parallel animations, there is only one timeout used in the
 * animator, that calls the step-method of all attached animations. This also
 * provides a central point for pausing or canceling all animations.
 *
 * 
 * @class
 * @version 0.9
 */
function UCF_Animator() {if (__UCF_COVERAGE__) { UCF_Animator["_"]["UCF_Animator"]++; }; 

};window["UCF_Animator"] = UCF_Animator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Animator"); UCF_Animator["_"] = {UCF_Animator: 0}; }; ;

/**
 * @private
 * @static
 * @type {boolean}
 */
UCF_Animator["bRunning"] = false;

/**
 * @private
 * @static
 * @type {Object<string, UCF_Animation>}
 */
UCF_Animator["mAnimations"] = {};

/**
 * @private
 * @static
 * @type {number}
 */
UCF_Animator["iAnimCounter"] = 0;

/**
 * @private
 * @static
 * @type {number}
 */
UCF_Animator["iTimeStamp"] = 0;

/**
 * @private
 * @static
 * @type {number}
 */
UCF_Animator["iInterval"] = 10;

/**
 * @private
 * @static
 * @type {string}
 */
UCF_Animator["oTimer"] = null;

/**
 * @private
 * @static
 * @type {string}
 */
UCF_Animator["sAnimationFrameId"] = undefined;

/**
 * @protected
 * @static
 */
UCF_Animator["destroyStatic"] = function() {;if (__UCF_COVERAGE__) { UCF_Animator["_"]["destroyStatic"]++; }; 
	if (UCF_Animator["bRunning"]) {
		UCF_Animator["stop"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Animator["_"]["destroyStatic"] = 0; };

/**
 * Attaches an animation to the animator. The animator controls
 * the execution of all currently running animations
 *
 * @see {@link UCF_Animation#run()}
 * @protected
 * @static
 * @param {UCF_Animation} oAnimation
 */
UCF_Animator["attach"] = function(oAnimation) {;if (__UCF_COVERAGE__) { UCF_Animator["_"]["attach"]++; }; 
	if (!UCF_Animator["bRunning"]) {
		UCF_Animator["iTimeStamp"] = UCF_JsUtil["iGetTimeStamp"]();
		UCF_Animator["start"]();
	}
	UCF_Animator["iAnimCounter"]++;
	UCF_Animator["mAnimations"][oAnimation["sId"]] = oAnimation;
};;if (__UCF_COVERAGE__) { UCF_Animator["_"]["attach"] = 0; };

/**
 * Detaches an animation from the animator.
 *
 * @see {@link UCF_Animation#run()}
 * @protected
 * @static
 * @param {UCF_Animation} oAnimation
 */
UCF_Animator["detach"] = function(oAnimation) {;if (__UCF_COVERAGE__) { UCF_Animator["_"]["detach"]++; }; 
	delete UCF_Animator["mAnimations"][oAnimation["sId"]];

	UCF_Animator["iAnimCounter"]--;

	if (UCF_Animator["iAnimCounter"] === 0) {
		UCF_Animator["stop"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Animator["_"]["detach"] = 0; };

/**
 * Returns the timestamp for the current animation step
 *
 * @private
 * @static
 * @return {number}
 */
UCF_Animator["iGetTimeStamp"] = function() {;if (__UCF_COVERAGE__) { UCF_Animator["_"]["iGetTimeStamp"]++; }; 
	return new Date()["getTime"]();
};;if (__UCF_COVERAGE__) { UCF_Animator["_"]["iGetTimeStamp"] = 0; };

/**
 * Calls the next step for all currently attached animations
 * @private
 * @static
 */
UCF_Animator["step"] = function() {;if (__UCF_COVERAGE__) { UCF_Animator["_"]["step"]++; }; 
	/** @type {string} */
	var i;

	UCF_Animator["iTimeStamp"] = UCF_JsUtil["iGetTimeStamp"]();

	for (i in UCF_Animator["mAnimations"]) {
		UCF_Animator["mAnimations"][i]["step"](UCF_Animator["iTimeStamp"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Animator["_"]["step"] = 0; };

/**
 * @private
 * @static
 */
UCF_Animator["loop"] = function() {;if (__UCF_COVERAGE__) { UCF_Animator["_"]["loop"]++; }; 
	UCF_Animator["sAnimationFrameId"] = UCF_JsUtil["requestAnimationFrame"](function() {
		UCF_Animator["step"]();
		UCF_Animator["loop"]();
	});
};;if (__UCF_COVERAGE__) { UCF_Animator["_"]["loop"] = 0; };

/**
 * Starts the animator
 * @private
 * @static
 */
UCF_Animator["start"] = function() {;if (__UCF_COVERAGE__) { UCF_Animator["_"]["start"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Animator started', "Animator.js(159): start"); };
	UCF_Animator["bRunning"] = true;
	UCF_Animator["loop"]();
};;if (__UCF_COVERAGE__) { UCF_Animator["_"]["start"] = 0; };

/**
 * Stops the animator
 * @private
 * @static
 */
UCF_Animator["stop"] = function() {;if (__UCF_COVERAGE__) { UCF_Animator["_"]["stop"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Animator stopped', "Animator.js(170): stop"); };
	UCF_Animator["bRunning"] = false;
	UCF_JsUtil["cancelAnimationFrame"](UCF_Animator["sAnimationFrameId"]);
};;if (__UCF_COVERAGE__) { UCF_Animator["_"]["stop"] = 0; };

};
sap["ls"]["preload"]["UCF_AppletContainer"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ActiveComponent */
/// <reference path="./base/ActiveComponent.js"/>

/**
 * 
 * @version
 *
 * @class
 * @extends UCF_ActiveComponent
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_AppletContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_AppletContainer["_"]["UCF_AppletContainer"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "AppletContainer.js(21): UCF_AppletContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "AppletContainer.js(22): UCF_AppletContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "AppletContainer.js(23): UCF_AppletContainer"); };

	UCF_ActiveComponent["apply"](this, [oDomRef, oLS]);

};window["UCF_AppletContainer"] = UCF_AppletContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_AppletContainer"); UCF_AppletContainer["_"] = {UCF_AppletContainer: 0}; }; ;
UCF_AppletContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ActiveComponent"))(); UCF_AppletContainer.prototype["sClassName"] = "UCF_AppletContainer";

/**
 * Writes the appropriate acc text into the tooltip
 * @param {UCF_BrowserEvent} oBrowserEvent The browser event
 * @private
 */
UCF_AppletContainer["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_AppletContainer["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "AppletContainer.js(36): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() != this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setControlType"]("AP");
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["applyContainerEntryBehaviour"]();
};;if (__UCF_COVERAGE__) { UCF_AppletContainer["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_AppletContainer["prototype"]["aAttributeNames"] = ["sVisibility","sTooltip","sLifeCycle","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_AppletContainer["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_AppletContainer["prototype"]["aMethodNames"] = ["setKeepAlive","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_AppletContainer["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_AppletContainer["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_AppletContainer["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_AppletContainer["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_AppletContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_AppletContainer["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sLifeCycle"] = "BROWSER";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_AppletContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_BarcodeReader"] = function() {/* global _assert, _trace, _measure, DEBUG, INFO, WARNING, ERROR, START, STOP */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>

/**
 *  @class
 *  @param {HTMLElement} oDomRef
 *  @param {UCF_LS} oLS
 */
function UCF_BarcodeReader(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["UCF_BarcodeReader"]++; }; 
	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_BarcodeReader"] = UCF_BarcodeReader; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_BarcodeReader"); UCF_BarcodeReader["_"] = {UCF_BarcodeReader: 0}; }; ;

UCF_BarcodeReader["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_BarcodeReader.prototype["sClassName"] = "UCF_BarcodeReader";

/**
 *  destructor
 */
UCF_BarcodeReader["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["destroy"]++; }; 
	this["oIframe"]["detachSemanticEvent"]('Load', this, 'onIframeLoad');
	this["oIframe"]["detachSemanticEvent"]('Message', this, 'onIframeMessage');

	this["oIframe"] = null;
	
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["destroy"] = 0; };

/**
 *  initialize
 *  @private
 */
UCF_BarcodeReader["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["initialize"]++; }; 
	this["oIframe"] = this["oLS"]["oControlFactory"]["oGetControlById"](this["sId"] + "::frm");

	this["oIframe"]["attachSemanticEvent"]('Load', this, 'onIframeLoad');
	this["oIframe"]["attachSemanticEvent"]('Message', this, 'onIframeMessage');
};;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["initialize"] = 0; };


/**
 *  handles the onload event for the editor iframe
 *
 *  @private
 *  @param {UCF_Event} oEvent the browser event object that occurred
 */
UCF_BarcodeReader["prototype"]["onIframeLoad"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["onIframeLoad"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "BarcodeReader.js(50): onIframeLoad"); };

	var barcodeEvent = { "cmd": "initialize", "value": this["sImageUrl"] ? { "media": "image", "url": this["sImageUrl"] } : { "media": "video", "deviceId": this["sVideoDeviceId"] } };
	this["oLS"]["oControlFactory"]["oGetControlById"](this["sId"] + "::frm")["postMessage"](JSON["stringify"]({ "type": "sap.ls.barcodereader.event", "event": barcodeEvent }));
};;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["onIframeLoad"] = 0; };


/**
 *  handles Message events issued by the iframe via postMessage
 *
 *  @private
 *  @param {UCF_Event} oEvent the browser event object that occurred
 */
UCF_BarcodeReader["prototype"]["onIframeMessage"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["onIframeMessage"]++; }; 
	var eventParameters = JSON["parse"](oEvent["mParameters"]["Data"]);
	switch (eventParameters["type"]) {
	case "sap.ls.barcodereader.event":
		switch (eventParameters["event"]["type"]) {
		case "sap.ls.barcodereader.events.Barcode":
			this["fireBarcode"](this["sId"], eventParameters["event"]["value"]);
			break;
		case "sap.ls.barcodereader.events.DeviceId":
			// this.fireVideoDeviceId(this.sId, eventParameters.event.value);
			break;
		case "sap.ls.barcodereader.events.Devices":
			// this.fireVideoDevices(this.sId, eventParameters.event.value);
			break;
		case "sap.ls.barcodereader.events.Message":
			this["fireMessage"](this["sId"], eventParameters["event"]["value"]);
			break;
		default:
			alert("Unknown event type: \"" + eventParameters["event"]["type"]);
		}
		break;
	case "sap.ls.barcodereader.error":
		switch (eventParameters["event"]["code"]) {
		case "NOT_SUPPORTED":
			this["fireError"](this["sId"], eventParameters["event"]["code"], "");
			break;
		case "NO_DEVICE":
			this["fireError"](this["sId"], eventParameters["event"]["code"], "");
			break;
		case "INVALID_DEVICE":
			// this.fireError(this.sId, eventParameters.event.code, eventParameters.event.deviceId);
			break;
		case "INVALID_IMAGE_URL":
			this["fireError"](this["sId"], eventParameters["event"]["code"], eventParameters["event"]["imageUrl"]);
			break;
		case "GENERIC_ERROR":
			this["fireError"](this["sId"], eventParameters["event"]["code"], eventParameters["event"]["message"]);
			break;
		default:
			alert("Unknown error: " + eventParameters["event"]["code"]);
		}
		break;
	default:
		alert("Unknown message type: " + eventParameters["type"]);
	}
};;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["onIframeMessage"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_BarcodeReader["prototype"]["aAttributeNames"] = ["sVisibility","sTooltip","sHeight","sWidth","sImageUrl","sReaderUrl"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_BarcodeReader["prototype"]["aEventNames"] = ["Barcode","Error"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_BarcodeReader["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_BarcodeReader["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_BarcodeReader["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_BarcodeReader["prototype"]["sHeight"] = '300px';

/**
 * @private
 * @type {string}
 */
UCF_BarcodeReader["prototype"]["sWidth"] = '400px';

/**
 * @private
 * @type {string}
 */
UCF_BarcodeReader["prototype"]["sImageUrl"] = '';

/**
 * @private
 * @type {string}
 */
UCF_BarcodeReader["prototype"]["sReaderUrl"] = null;

//#JSCOVER_EXCL_START
/** @protected */
UCF_BarcodeReader["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sHeight"] = '300px';
	this["sWidth"] = '400px';
	this["sImageUrl"] = '';
	this["sReaderUrl"] = null;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Height", '300px', true);
		this["setClientProperty"]("Width", '400px', true);
		this["setClientProperty"]("ImageUrl", '', true);
		this["setClientProperty"]("ReaderUrl", null, true);
	}
};;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue The barcode detected by the reader.
 * @fires BarcodeReader::Barcode
 */
UCF_BarcodeReader["prototype"]["fireBarcode"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["fireBarcode"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "BarcodeReader.js(199): fireBarcode"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "BarcodeReader.js(200): fireBarcode"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "BarcodeReader.js(201): fireBarcode"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "BarcodeReader.js(202): fireBarcode"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "BarcodeReader.js(203): fireBarcode"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("BarcodeReader", "Barcode", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["fireBarcode"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sErrorCode The error's unique identifier.
 * @param {string} sMessage The message that comes along with the event.
 * @fires BarcodeReader::Error
 */
UCF_BarcodeReader["prototype"]["fireError"] = function(sId, sErrorCode, sMessage) {;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["fireError"]++; }; 
	/** @type {{Id: string, ErrorCode: string, Message: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "BarcodeReader.js(224): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "BarcodeReader.js(225): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "BarcodeReader.js(226): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sErrorCode != null, "sErrorCode != null", "BarcodeReader.js(227): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sErrorCode) == "string", "typeof(sErrorCode) == \"string\"", "BarcodeReader.js(228): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMessage != null, "sMessage != null", "BarcodeReader.js(229): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMessage) == "string", "typeof(sMessage) == \"string\"", "BarcodeReader.js(230): fireError"); };
	mParams = {
		"Id": sId,
		"ErrorCode": sErrorCode,
		"Message": sMessage
	};
	
	
	
	this["fireSemanticEvent"]("BarcodeReader", "Error", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_BarcodeReader["_"]["fireError"] = 0; };

};
sap["ls"]["preload"]["UCF_BiApplicationFrame"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_RequestUtil */
/// <reference path="../../core/util/RequestUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_PlaceHolder */
/// <reference path="./base/PlaceHolder.js"/>

/**
 * 
 * @version
 *
 * @class
 * @extends UCF_PlaceHolder
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_BiApplicationFrame(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["UCF_BiApplicationFrame"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "BiApplicationFrame.js(24): UCF_BiApplicationFrame"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "BiApplicationFrame.js(25): UCF_BiApplicationFrame"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "BiApplicationFrame.js(26): UCF_BiApplicationFrame"); };

	UCF_PlaceHolder["apply"](this, [oDomRef, oLS]);

	this["sSapExtSid"] = UCF_JsUtil["sGetUID"]();
	this["sBiIViewId"] = "pcd:portal_content/com.sap.pct/platform_add_ons/com.sap.ip.bi/iViews/com.sap.ip.bi.bex";

	/(https?:\/\/[^\/]+)?(.*)/["test"](this["sUrl"]);
	this["sServer"] = RegExp["$1"];
	this["sSessionUrl"] = RegExp["$2"];

	this["oIFrameRef"] = null;
	this["bLoaded"] = false;

};window["UCF_BiApplicationFrame"] = UCF_BiApplicationFrame; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_BiApplicationFrame"); UCF_BiApplicationFrame["_"] = {UCF_BiApplicationFrame: 0}; }; ;
UCF_BiApplicationFrame["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PlaceHolder"))(); UCF_BiApplicationFrame.prototype["sClassName"] = "UCF_BiApplicationFrame";

/**
 * Destructor
 * @private
 */
UCF_BiApplicationFrame["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["destroy"]++; }; 

	this["detachBrowserEvent"]("load", this["oIFrameRef"]);

	if (this["sLifeCycle"] != "BROWSER") {
		var sUnloadUrl = this["sUrl"];
		sUnloadUrl += "?sap-ext-sid=" + escape(this["sSapExtSid"]);
		sUnloadUrl += "&sap-sessioncmd=USR_ABORT";
		sUnloadUrl += "&~SAPSessionCmd=USR_ABORT";
		UCF_RequestUtil["sendUnloadRequest"](sUnloadUrl);
	}

	this["oIFrameRef"] = null;

	this["sSessionUrl"] = null;
	this["sServer"] = null;
	this["sSapExtSid"] = null;

	UCF_PlaceHolder.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["destroy"] = 0; };

/**
 * Initialize, register the onload event of the iframe,
 * and fire request to the iframe if an update is needed
 * @private
 */
UCF_BiApplicationFrame["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["initialize"]++; }; 

	UCF_PlaceHolder.prototype["initialize"]["apply"](this, arguments);

	if (!this["oIFrameRef"]) {
		this["oIFrameRef"] = this["oGetObjectRef"]();
		this["attachBrowserEvent"]("load", this["oIFrameRef"]);
	}

	var mParameters = UCF_JsUtil["mDecodeURIParameters"](this["sPostParameters"]);

	if (this["bIsUpdateNeeded"](mParameters)) {
		this["sendRequest"](mParameters);
	}
};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["initialize"] = 0; };

/**
 * Iframe onload handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_BiApplicationFrame["prototype"]["onload"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["onload"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "BiApplicationFrame.js(98): onload"); };

	this["bLoaded"] = true;
	this["sSessionUrl"] = this["sGetBISessionUrl"]();
	this["fireLoad"](this["sId"], this["sSessionUrl"]);

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["onload"] = 0; };

/**
 * Returns the BI Session URL
 *
 * @type string
 * @private
 */
UCF_BiApplicationFrame["prototype"]["sGetBISessionUrl"] = function() {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["sGetBISessionUrl"]++; }; 

	var sSessionUrl = "";
	try {
		if (this["oIFrameRef"]["contentWindow"]["SAP_BW_URL_Get"]) {
			sSessionUrl = this["oIFrameRef"]["contentWindow"]["SAP_BW_URL_Get"]();
		} else {
			sSessionUrl = this["oIFrameRef"]["contentWindow"]["sapbi_getUrlPrefix"]();
		}
	} catch (e) {}
	return sSessionUrl;

};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["sGetBISessionUrl"] = 0; };

/**
 * Returns, whether an update for the iframe is needed
 *
 * @type boolean
 * @private
 */
UCF_BiApplicationFrame["prototype"]["bIsUpdateNeeded"] = function(mParameters) {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["bIsUpdateNeeded"]++; }; 

	// if the iframe is not loaded yet, it must be initialized
	if (!this["bLoaded"]) return true;

	// if there is any parameter but "GET_PAGE" contained
	// the iframe must be reloaded
	for (var i in mParameters) {
		if (mParameters[i] != "GET_PAGE") return true;
	}

	// otherwise return false
	return false;
};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["bIsUpdateNeeded"] = 0; };

/**
 * Returns whether the control should be kept alive.
 *
 * @type boolean
 * @private
 */
UCF_BiApplicationFrame["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["bDoKeepAlive"]++; }; 

	if (this["bKeepAlive"]) {
		var oNewRootRef = this["oGetRootRef"]();
		if (oNewRootRef) {
			// Always keep Iframe, if it is contained on the new page
			return true;
		} else {
			// if no new control is sent, only keep alive if set to MANUAL
			return (this["sLifeCycle"] == "MANUAL");
		}
	}
	return false;

};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["bDoKeepAlive"] = 0; };

/**
 * Sends a request to change the content of the page
 * @private
 */
UCF_BiApplicationFrame["prototype"]["sendRequest"] = function(mParameters) {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["sendRequest"]++; }; 

	//Calculate URL
	var sUrl = this["sServer"] + this["sSessionUrl"];

	// Add esid and iview-ID parameter
	mParameters["sap-ext-sid"] = this["sSapExtSid"];
	mParameters["sap-bw-iViewID"] = this["sBiIViewId"];

	// Send the request
	UCF_RequestUtil["sendFormRequest"]("POST", sUrl, mParameters, this["sName"]);

};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["sendRequest"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_BiApplicationFrame["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_BiApplicationFrame["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["onlsskipback"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_BiApplicationFrame["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "BiApplicationFrame.js(218): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() != this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setControlType"]("IF");
	oAccessibilityHelper["setText"](this["sTooltip"]);
	oAccessibilityHelper["applyContainerEntryBehaviour"]();
};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_BiApplicationFrame["prototype"]["aAttributeNames"] = ["sUrl","sTooltip","sName","sVisibility","sLifeCycle","sPostParameters","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_BiApplicationFrame["prototype"]["aEventNames"] = ["Load"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_BiApplicationFrame["prototype"]["aMethodNames"] = ["setKeepAlive","request","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_BiApplicationFrame["prototype"]["sUrl"] = '';

/**
 * @private
 * @type {string}
 */
UCF_BiApplicationFrame["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_BiApplicationFrame["prototype"]["sName"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_BiApplicationFrame["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_BiApplicationFrame["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_BiApplicationFrame["prototype"]["sPostParameters"] = '';

/**
 * @private
 * @type {string}
 */
UCF_BiApplicationFrame["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_BiApplicationFrame["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["setDefaultValues"]++; }; 
	this["sUrl"] = '';
	this["sTooltip"] = '';
	this["sName"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sLifeCycle"] = "BROWSER";
	this["sPostParameters"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Url", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Name", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("PostParameters", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sSessionId Session Id of the BI Application
 * @fires BiApplicationFrame::Load
 */
UCF_BiApplicationFrame["prototype"]["fireLoad"] = function(sId, sSessionId) {;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["fireLoad"]++; }; 
	/** @type {{Id: string, SessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "BiApplicationFrame.js(325): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "BiApplicationFrame.js(326): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "BiApplicationFrame.js(327): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSessionId != null, "sSessionId != null", "BiApplicationFrame.js(328): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSessionId) == "string", "typeof(sSessionId) == \"string\"", "BiApplicationFrame.js(329): fireLoad"); };
	mParams = {
		"Id": sId,
		"SessionId": sSessionId
	};
	
	
	this["fireSemanticEvent"]("BiApplicationFrame", "Load", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_BiApplicationFrame["_"]["fireLoad"] = 0; };

};
sap["ls"]["preload"]["UCF_BiSapTableDropDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_Animation */
/// <reference path="../../anim/Animation.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_BiSapTableDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["UCF_BiSapTableDropDelegate"]++; }; 
	UCF_DropDelegate["apply"](this, [oLS]);
	this["setDropTargetControl"](oDropTargetControl);
	this["oLS"] = oLS;
	this["sId"] = oDropTargetControl["sId"]; // eslint-disable-line @ur/no-memory-leaks
};window["UCF_BiSapTableDropDelegate"] = UCF_BiSapTableDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_BiSapTableDropDelegate"); UCF_BiSapTableDropDelegate["_"] = {UCF_BiSapTableDropDelegate: 0}; }; ;

UCF_BiSapTableDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_BiSapTableDropDelegate.prototype["sClassName"] = "UCF_BiSapTableDropDelegate";

/**
 * destructor
 */
UCF_BiSapTableDropDelegate["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["destroy"]++; }; 
	UCF_DropDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["destroy"] = 0; };

/**
 * @see UCF_DropDelegate
 * @override
 * @private
 */
UCF_BiSapTableDropDelegate["prototype"]["onlsdragenter"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["onlsdragenter"]++; }; 
	var oDDParentDomRef = this["getDDParent"](oBrowserEvent);

	if (oDDParentDomRef && oDDParentDomRef != null)
		this["decorateDragDrop"](oDDParentDomRef);
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["onlsdragenter"] = 0; };

/**
 * @see UCF_DropDelegate
 * @override
 * @private
 */
UCF_BiSapTableDropDelegate["prototype"]["onlsdragover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["onlsdragover"]++; }; 
	var oDDParentDomRef = this["getDDParent"](oBrowserEvent);

	if (oDDParentDomRef && oDDParentDomRef != null) {
		// Get the adjacent elements
		var oDDLeftDomRef = this["getLeftDomRef"](oDDParentDomRef);
		var oDDRightDomRef = this["getRightDomRef"](oDDParentDomRef);

		if (this["isLeft"](oDDParentDomRef, oBrowserEvent)) {
			// Close the right element
			this["undecorateDragDrop"](oDDRightDomRef);
			// Open the left element
			if (oDDLeftDomRef && oDDLeftDomRef["getAttribute"]('biDDAnim') === 'true')
				this["slideOpen"](oDDLeftDomRef);
		} else if (this["isRight"](oDDParentDomRef, oBrowserEvent)) {
			// Close the left element
			this["undecorateDragDrop"](oDDLeftDomRef);
			// Open the right element
			if (oDDRightDomRef && oDDRightDomRef != null && oDDRightDomRef["getAttribute"]('biDDAnim') === 'true')
				this["slideOpen"](oDDRightDomRef);
		} else {
			// Close both
			this["undecorateDragDrop"](oDDLeftDomRef);
			this["undecorateDragDrop"](oDDRightDomRef);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["onlsdragover"] = 0; };

/**
 * @see UCF_DropDelegate
 * @override
 * @private
 */
UCF_BiSapTableDropDelegate["prototype"]["onlsdragleave"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["onlsdragleave"]++; }; 
	var oDDParentDomRef = this["getDDParent"](oBrowserEvent);

	if (oDDParentDomRef && oDDParentDomRef != null)
		this["undecorateDragDrop"](oDDParentDomRef);
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["onlsdragleave"] = 0; };

/**
 * @see UCF_DropDelegate
 * @override
 * @private
 */
UCF_BiSapTableDropDelegate["prototype"]["onlsdrop"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["onlsdrop"]++; }; 
	var oDDParentDomRef = this["getDDParent"](oBrowserEvent);
	if (oDDParentDomRef && oDDParentDomRef != null) {
		this["undecorateDragDrop"](oDDParentDomRef);
		// Get the drop info part of the id
		var dropInfo = oDDParentDomRef["getAttribute"]('BiDDId')["substring"]((this["sId"] + '-dd')["length"]);
		var sDragId;
		sDragId = oBrowserEvent["oDragAndDropManager"]["oDragSession"]["sGetDragSourceId"]();
		// ... and fire the event
		this["oGetDropTargetControl"]()["fireDropOnAxis"](this["sId"], dropInfo, sDragId);
	}
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["onlsdrop"] = 0; };

/**
 * @return {number}
 * @private
 */
UCF_BiSapTableDropDelegate["prototype"]["getLeftDomRef"] = function (oDDParentDomRef) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["getLeftDomRef"]++; }; 
	if (oDDParentDomRef && oDDParentDomRef != null) {
		var parentId = oDDParentDomRef["getAttribute"]('BiDDId');
		// Cut off <id><-dd[r/c]>
		var infoPart = parentId["substring"](this["sId"]["length"] + 4);
		// Handle 1 or 2 elements
		var infoParts = infoPart["split"]('.');
		var id, leftId;
		switch (infoParts["length"]) {
			case 1:
				id = parseInt(infoParts[0]);
				leftId = parentId["substring"](0, this["sId"]["length"] + 4) + (id - 1) + '.' + id;
				return UCF_DomUtil["$"](leftId);

			case 2:
				id = parseInt(infoParts[0]);
				leftId = parentId["substring"](0, this["sId"]["length"] + 4) + id;
				return UCF_DomUtil["$"](leftId);

			default:
				break;
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["getLeftDomRef"] = 0; };

/**
 * @return {number}
 * @private
 */
UCF_BiSapTableDropDelegate["prototype"]["getRightDomRef"] = function (oDDParentDomRef) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["getRightDomRef"]++; }; 
	if (oDDParentDomRef && oDDParentDomRef != null) {
		var parentId = oDDParentDomRef["getAttribute"]('BiDDId');
		// Cut off <id><-dd[r/c]>
		var infoPart = parentId["substring"](this["sId"]["length"] + 4);
		// Handle 1 or 2 elements
		var infoParts = infoPart["split"]('.');
		var id, rightId;
		switch (infoParts["length"]) {
			case 1:
				id = parseInt(infoParts[0]);
				rightId = parentId["substring"](0, this["sId"]["length"] + 4) + id + '.' + (id + 1);

				return UCF_DomUtil["$"](rightId);

			case 2:
				id = parseInt(infoParts[1]);
				rightId = parentId["substring"](0, this["sId"]["length"] + 4) + id;

				return UCF_DomUtil["$"](rightId);

			default:
				break;
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["getRightDomRef"] = 0; };

/**
 * @return {boolean}
 * @private
 */
UCF_BiSapTableDropDelegate["prototype"]["isLeft"] = function (oDDParentDomRef, oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["isLeft"]++; }; 
	if (oDDParentDomRef && oBrowserEvent && oDDParentDomRef != null && oBrowserEvent != null) {
		var rect = UCF_DomUtil["oGetObjectRect"](oDDParentDomRef);

		if (rect && rect != null && rect["left"])
			return oBrowserEvent["iPageX"]() < rect["left"] + 20;
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["isLeft"] = 0; };

/**
 * @return {boolean}
 * @private
 */

UCF_BiSapTableDropDelegate["prototype"]["isRight"] = function (oDDParentDomRef, oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["isRight"]++; }; 
	if (oDDParentDomRef && oBrowserEvent && oDDParentDomRef != null && oBrowserEvent != null) {
		var rect = UCF_DomUtil["oGetObjectRect"](oDDParentDomRef);
		if (rect && rect != null && rect["left"])
			return oBrowserEvent["iPageX"]() > rect["left"] + rect["width"] - 20;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["isRight"] = 0; };

/**
 * @return {HTMLElemnet}
 * @private
 */

UCF_BiSapTableDropDelegate["prototype"]["getDDParent"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["getDDParent"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource && oSource != null) {
		var oParentDomRef = UCF_DomUtil["oGetParentByAttribute"](oSource, 'biCt', 'biDD');

		if (oParentDomRef && oParentDomRef != null) {
			var sDDId = oParentDomRef["getAttribute"]('BiDDId');

			if (sDDId && sDDId != null && sDDId["indexOf"](this["sId"] + '-dd') > -1) {

				return oParentDomRef;
			}
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["getDDParent"] = 0; };

/**
 * @private
 */
UCF_BiSapTableDropDelegate["prototype"]["slideOpen"] = function (oDDParentDomRef) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["slideOpen"]++; }; 
	if (oDDParentDomRef && oDDParentDomRef != null && oDDParentDomRef["getAttribute"]('biDDAnim') && oDDParentDomRef["getAttribute"]('biDDAnim') === 'true' && oDDParentDomRef["offsetWidth"] === 0) {
		var oAnim = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(oDDParentDomRef, 200);
		oAnim["addStyleChange"]('width', '', 'px', 0, 80,
			oAnim["M_TRANSITIONS"]["EaseIn"]);
		oAnim["play"]();
	}
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["slideOpen"] = 0; };

/**
 * @private
 */
UCF_BiSapTableDropDelegate["prototype"]["decorateDragDrop"] = function (oDDParentDomRef) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["decorateDragDrop"]++; }; 
	if (oDDParentDomRef && oDDParentDomRef != null) {
		oDDParentDomRef["sOrgBackgroundColor"] = oDDParentDomRef["style"]["backgroundColor"];
		oDDParentDomRef["style"]["backgroundColor"] = '#fef09e';

		this["slideOpen"](oDDParentDomRef);
	}
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["decorateDragDrop"] = 0; };

/**
 * @private
 */
UCF_BiSapTableDropDelegate["prototype"]["undecorateDragDrop"] = function (oDDParentDomRef) {;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["undecorateDragDrop"]++; }; 
	if (oDDParentDomRef && oDDParentDomRef != null) {
		oDDParentDomRef["style"]["backgroundColor"] = oDDParentDomRef["sOrgBackgroundColor"];
		oDDParentDomRef["sOrgBackgroundColor"] = null;

		if (oDDParentDomRef["getAttribute"]('biDDAnim') && oDDParentDomRef["getAttribute"]('biDDAnim') === 'true' && oDDParentDomRef["offsetWidth"] > 0) {
			var oAnim = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(oDDParentDomRef, 200);
			oAnim["addStyleChange"]('width', '', 'px', 80, 0,
				oAnim["M_TRANSITIONS"]["EaseOut"]);
			oAnim["play"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_BiSapTableDropDelegate["_"]["undecorateDragDrop"] = 0; };

};
sap["ls"]["preload"]["UCF_Binding"] = function() {/* global UCF_EventProvider */
/// <reference path="../../core/EventProvider.js"/>
/* global UCF_ClientElement */
/// <reference path="../core/ClientElement.js"/>
/* global UCF_BindingContext */
/// <reference path="BindingContext.js" />

/** @typedef {'OneTime'} UCF_Binding_OneTimeMode */
/** @typedef {'OneWay'} UCF_Binding_OneWayMode */
/** @typedef {'TwoWay'} UCF_Binding_TwoWayMode */
/** @typedef {UCF_Binding_OneTimeMode|UCF_Binding_OneWayMode|UCF_Binding_TwoWayMode} UCF_Binding_Mode */
/**
 * @typedef {Object} UCF_Binding_ModeEnum
 * @property {UCF_Binding_OneTimeMode} OneTime
 * @property {UCF_Binding_OneWayMode} OneWay
 * @property {UCF_Binding_TwoWayMode} TwoWay
 */

/**
 * Constructor for Binding class.
 *
 * The Binding is the object, which holds the necessary information for a data
 * binding, like the binding path and the binding context, and acts like an
 * interface to the model for the control, so it is the event provider for
 * changes in the data model and provides getters for accessing properties or
 * lists.
 *
 * @public
 * @class
 * @param {UCF_Model} oModel the model
 * @param {string} sPath the path
 * @param {Object} oContext the context object
 * @param {map} mParameters
 */
function UCF_Binding(oModel, sPath, oContext, mParameters) {if (__UCF_COVERAGE__) { UCF_Binding["_"]["UCF_Binding"]++; }; 
	if (arguments["length"] > 0) {
		UCF_EventProvider["apply"](this);

		this["defineEvents"](['Change']);

		/** @type {string} */
		this["sPath"] = sPath;
		/** @type {UCF_BindingContext} */
		this["oContext"] = oContext;
		/** @type {UCF_Model} */
		this["oModel"] = oModel;
		/** @type {Object} */
		this["mParameters"] = mParameters;
		/** @type {UCF_ClientElement} */
		this["oListener"] = null;
	}
};window["UCF_Binding"] = UCF_Binding; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Binding"); UCF_Binding["_"] = {UCF_Binding: 0}; }; ;
UCF_Binding["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_Binding.prototype["sClassName"] = "UCF_Binding";

/** @type {UCF_Binding_ModeEnum} */
UCF_Binding["Mode"] = {
	"OneTime": 'OneTime',
	"OneWay": 'OneWay',
	"TwoWay": 'TwoWay'
};

UCF_Binding["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Binding["_"]["destroy"]++; }; 
	this["sPath"] = null;
	this["oContext"] = null;
	this["oModel"] = null;
	this["mParameters"] = null;
	this["oListener"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Binding["_"]["destroy"] = 0; };

// Getter
/**
 * Getter for path
 *
 * @return {string} the binding path
 */
UCF_Binding["prototype"]["getPath"] = function() {;if (__UCF_COVERAGE__) { UCF_Binding["_"]["getPath"]++; }; 
	return this["sPath"];
};;if (__UCF_COVERAGE__) { UCF_Binding["_"]["getPath"] = 0; };

/**
 * Getter for an absolute path
 *
 * @return {string} the binding path
 */
UCF_Binding["prototype"]["getAbsolutePath"] = function() {;if (__UCF_COVERAGE__) { UCF_Binding["_"]["getAbsolutePath"]++; }; 
	if (this["oContext"] instanceof UCF_BindingContext) {
		return this["oContext"] + '/' + this["sPath"];
	}

	return this["sPath"];
};;if (__UCF_COVERAGE__) { UCF_Binding["_"]["getAbsolutePath"] = 0; };

/**
 * Getter for context
 *
 * @return {Object} the context object
 */
UCF_Binding["prototype"]["getContext"] = function() {;if (__UCF_COVERAGE__) { UCF_Binding["_"]["getContext"]++; }; 
	return this["oContext"];
};;if (__UCF_COVERAGE__) { UCF_Binding["_"]["getContext"] = 0; };

/**
 * Setter for context
 *
 * @param {Object} oContext the new context object
 */
UCF_Binding["prototype"]["setContext"] = function(oContext) {;if (__UCF_COVERAGE__) { UCF_Binding["_"]["setContext"]++; }; 
	if (this["oContext"] != oContext) { // eslint-disable-line eqeqeq
		this["oContext"] = oContext;
		this["_fireChange"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Binding["_"]["setContext"] = 0; };

/**
 * Getter for model
 *
 * @return {UCF_Model} the model
 */
UCF_Binding["prototype"]["getModel"] = function() {;if (__UCF_COVERAGE__) { UCF_Binding["_"]["getModel"]++; }; 
	return this["oModel"];
};;if (__UCF_COVERAGE__) { UCF_Binding["_"]["getModel"] = 0; };

// Eventing and related
/**
 * Attach event-handler <code>fnFunction</code> to the 'Change' event of this
 * <code>UCF_Model</code>.<br/>
 * @param {function} fnFunction The function to call, when the event occurs.
 * @param {Object} [oListener] object on which to call the given function.
 * @protected
 */
UCF_Binding["prototype"]["attachChange"] = function(fnFunction, oListener) {;if (__UCF_COVERAGE__) { UCF_Binding["_"]["attachChange"]++; }; 
	if (!this["hasListeners"](this["E_EVENTS"]["Change"])) {
		this["oModel"]["addBinding"](this);
	}
	this["oListener"] = oListener;
	this["attachEvent"](this["E_EVENTS"]["Change"], fnFunction);
};;if (__UCF_COVERAGE__) { UCF_Binding["_"]["attachChange"] = 0; };

/**
 * Detach event-handler <code>fnFunction</code> from the 'Change' event of this
 * <code>UCF_Model</code>.<br/>
 * @param {function} fnFunction The function to call, when the event occurs.
 * @protected
 */
UCF_Binding["prototype"]["detachChange"] = function(fnFunction) {;if (__UCF_COVERAGE__) { UCF_Binding["_"]["detachChange"]++; }; 
	this["detachEvent"](this["E_EVENTS"]["Change"], fnFunction);
	if (!this["hasListeners"](this["E_EVENTS"]["Change"])) {
		this["oModel"]["removeBinding"](this);
	}
	this["oListener"] = null;
};;if (__UCF_COVERAGE__) { UCF_Binding["_"]["detachChange"] = 0; };

/**
 * Returns the control that listens to the binding
 *
 * @return {UCF_ClientElement} the control that listens to the binding
 */
UCF_Binding["prototype"]["getControl"] = function() {;if (__UCF_COVERAGE__) { UCF_Binding["_"]["getControl"]++; }; 
	if (this["oListener"] instanceof UCF_ClientElement) {
		return this["oListener"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_Binding["_"]["getControl"] = 0; };

/**
 * Sets the listener control instance for the
 *
 * @param {UCF_ClientElement} oListener the control that listens to the binding
 */
UCF_Binding["prototype"]["setListener"] = function(oListener) {;if (__UCF_COVERAGE__) { UCF_Binding["_"]["setListener"]++; }; 
	this["oListener"] = oListener;
};;if (__UCF_COVERAGE__) { UCF_Binding["_"]["setListener"] = 0; };
/**
 * Fire event 'Change' to attached listeners.
 *
 * @param {Object} mArguments the arguments to pass along with the event.
 * @private
 */
UCF_Binding["prototype"]["_fireChange"] = function(mArguments) {;if (__UCF_COVERAGE__) { UCF_Binding["_"]["_fireChange"]++; }; 
	if (!mArguments) {
		mArguments = {};
	}

	mArguments["binding"] = this;
	this["fireEvent"](this["E_EVENTS"]["Change"], mArguments);
};;if (__UCF_COVERAGE__) { UCF_Binding["_"]["_fireChange"] = 0; };

UCF_Binding.prototype["aPublicMethods"] = ["UCF_Binding"].concat(UCF_Binding.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_BindingContext"] = function() {/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_EventProvider */
/// <reference path="../../core/EventProvider.js"/>

/**
 * Constructor for Context class.
 *
 * The Context is a pointer to an object in the model data, which is used to
 * allow definition of relative bindings, which are resolved relative to the
 * defined object.
 * Context elements are created either by the ListBinding for each list entry
 * or by using createBindingContext.
 *
 * @public
 * @class
 * @param {UCF_Model} oModel the model
 * @param {string} sPath the path
 */
function UCF_BindingContext(oModel, sPath) {if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["UCF_BindingContext"]++; }; 
	if (arguments["length"] > 0) {
		UCF_EventProvider["apply"](this);

		this["defineEvents"](['ValidityChange']);

		/** @type {UCF_Model} */
		this["oModel"] = oModel;
		/** @type {string} */
		this["sPath"] = sPath;
		/** @type {Object} */
		this["oParameter"] = null;
		/** @type {boolean} */
		this["bValid"] = true;
	}
};window["UCF_BindingContext"] = UCF_BindingContext; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_BindingContext"); UCF_BindingContext["_"] = {UCF_BindingContext: 0}; }; ;
UCF_BindingContext["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_BindingContext.prototype["sClassName"] = "UCF_BindingContext";

/** @override */
UCF_BindingContext["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["destroy"]++; }; 
	this["oModel"] = null;
	this["sPath"] = null;
	this["oParameter"] = null;
	this["bValid"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["destroy"] = 0; };

// Getter

/**
 * Getter for model
 *
 * @public
 * @return {UCF_Model} the model
 */
UCF_BindingContext["prototype"]["getModel"] = function() {;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["getModel"]++; }; 
	return this["oModel"];
};;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["getModel"] = 0; };

/**
 * Getter for path
 *
 * @public
 * @return {string} the binding path
 */
UCF_BindingContext["prototype"]["getPath"] = function() {;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["getPath"]++; }; 
	return this["sPath"];
};;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["getPath"] = 0; };

/**
 * Gets the property with the given relative binding path
 *
 * @public
 * @param {string} sPath the binding path
 * @return {any} the property value
 */
UCF_BindingContext["prototype"]["getProperty"] = function(sPath) {;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["getProperty"]++; }; 
	return this["oModel"]["getProperty"](sPath, this);
};;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["getProperty"] = 0; };

/**
 * Gets the (model dependent) object the context points to
 *
 * @public
 * @return {Object} the context object
 */
UCF_BindingContext["prototype"]["getObject"] = function() {;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["getObject"]++; }; 
	return this["oModel"]["getProperty"](this["sPath"]);
};;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["getObject"] = 0; };

/**
 * toString method returns path for compatbility
 *
 * @return {string}
 */
UCF_BindingContext["prototype"]["toString"] = function() {;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["toString"]++; }; 
	return this["sPath"];
};;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["toString"] = 0; };

/**
 * Sets a additional binding parameter to pass
 * an object from the binding to the control
 * Used for x and y position of a grid binding
 * This can to be filled if a binding is created or changed.
 * @param {Object} oParameter binding parameter
 */
UCF_BindingContext["prototype"]["setBindingParameter"] = function(oParameter) {;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["setBindingParameter"]++; }; 
	this["oParameter"] = oParameter;
};;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["setBindingParameter"] = 0; };

/**
 * Returns the additional parameter
 * @return {Object} oParameter
 */
UCF_BindingContext["prototype"]["getBindingParameter"] = function() {;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["getBindingParameter"]++; }; 
	return this["oParameter"];
};;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["getBindingParameter"] = 0; };

/**
 * @protected
 * @param {boolean} bValid
 */
UCF_BindingContext["prototype"]["setDataValidity"] = function(bValid) {;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["setDataValidity"]++; }; 
	if (this["bValid"] != bValid) { // eslint-disable-line eqeqeq
		this["fireEvent"](this["E_EVENTS"]["ValidityChange"], {
			"context": this,
			"valid": bValid
		});
	}
	this["bValid"] = bValid;
};;if (__UCF_COVERAGE__) { UCF_BindingContext["_"]["setDataValidity"] = 0; };

UCF_BindingContext.prototype["aPublicMethods"] = ["UCF_BindingContext","getModel","getPath","getProperty","getObject"].concat(UCF_BindingContext.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_BlockLayer"] = function() {/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_EventProvider */
/// <reference path="../../core/EventProvider.js"/>
/* global UCF_Animation */
/// <reference path="../anim/Animation.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * BlockLayer for blocking user input on windows
 *
 * @class
 *
 * @param {string} sId the id of the blocklayer
 * @param {window} oHostWindow the window that should be blocked
 * @param {boolean} bShaded whether the blocker should have color and opacity (true) or be completely transparent (false)
 * @param {UCF_Page} oPage The page control instance
 */
function UCF_BlockLayer(sId, oHostWindow, bShaded, oPage) {if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["UCF_BlockLayer"]++; }; 
	UCF_EventProvider["apply"](this);

	this["defineEvents"](['Click', 'Focus']);

	this["sId"] = sId; // eslint-disable-line @ur/no-memory-leaks
	this["oHostWindow"] = oHostWindow;
	this["bShaded"] = bShaded; // eslint-disable-line @ur/no-memory-leaks
	this["oDomRef"] = null;
	/** @type {UCF_Page} */
	this["oPage"] = oPage;
	this["bShown"] = false;
	this["iZIndex"] = UCF_LS["E_LAYERS"]["POPUPWINDOWS"]; // eslint-disable-line @ur/no-memory-leaks
	this["DEFAULT_OPACITY"] = 25;
};window["UCF_BlockLayer"] = UCF_BlockLayer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_BlockLayer"); UCF_BlockLayer["_"] = {UCF_BlockLayer: 0}; }; 
UCF_BlockLayer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_BlockLayer.prototype["sClassName"] = "UCF_BlockLayer";

/**
 * Finds/creates the DOM object of this block layer
 *
 * An IFrame solution has been tried for overlaying ActiveComponents.
 * Unfortunately these behave differently in FF and IE, so a general
 * overlay is not possible. The IFrame solution therefore has been revoked.
 *
 *
 */
UCF_BlockLayer["prototype"]["createDom"] = function() {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["createDom"]++; }; 
	var oDoc = this["oHostWindow"]["document"];

	this["oDomRef"] = oDoc["getElementById"](this["sId"]);

	if (this["oDomRef"] != null)
		return;

	//visible BlockLayer is a div
	this["oDomRef"] = oDoc["createElement"]('div');
	this["oDomRef"]["id"] = this["sId"];
	this["oDomRef"]["tabIndex"] = "0";

	var style = this["oDomRef"]["style"];
	style["position"] = "absolute";
	style["display"] = "none";
	style["zIndex"] = this["iZIndex"];

	if (!this["bShaded"]) {
		style["backgroundColor"] = "#000000";
		UCF_DomUtil["setOpacityStyle"](this["oDomRef"], 0);
	} else {
		// Supports only opacity and bg-color - no transitions because that needs to be done with UCF_Animation in show()
		// for older IE and Quirks mode...
		UCF_DomUtil["addClass"](this["oDomRef"], "lsBlockLayer");

		// Must fallback to hard-coded values for Portals: The "host window" (calculated by UCF_DomUtil.oGetTopWindow) where the BL gets inserted in the DOM, does not have a LS stylesheet
		// Note: Obviously, in such a Portal scenario the Theming for parameters of lsBlockLayer is not possible
		if (this["oHostWindow"] !== window) {
			style["backgroundColor"] = "#000000";
			UCF_DomUtil["setOpacityStyle"](this["oDomRef"], this["DEFAULT_OPACITY"]);
		}
	}

	//insert as first child!
	var firstChild = oDoc["body"]["firstChild"];
	oDoc["body"]["insertBefore"](this["oDomRef"], firstChild);

};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["createDom"] = 0; };

/**
 * Change the z-index
 * @param {integer} iZIndex the z-index for the block layer
 */
UCF_BlockLayer["prototype"]["setZIndex"] = function(iZIndex) {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["setZIndex"]++; }; 
	if (this["iZIndex"] !== iZIndex) {
		if (this["oDomRef"]) {
			this["oDomRef"]["style"]["zIndex"] = iZIndex;
		}
		this["iZIndex"] = iZIndex;
	};
};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["setZIndex"] = 0; };

/**
 * Returns the z-index of the block-layer
 *
 * @return {integer} the z-index of the block layer
 */
UCF_BlockLayer["prototype"]["iGetZIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["iGetZIndex"]++; }; 
	return this["iZIndex"];
};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["iGetZIndex"] = 0; };

/**
 * Show the block layer
 */
UCF_BlockLayer["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["show"]++; }; 
	if (this["oDomRef"] == null) this["createDom"]();

	var style = this["oDomRef"]["style"];

	this["attachHandlers"]();
	this["resizeBlocklayer"]();

	style["display"] = "block";

	if (this["bShaded"]) {
		if (window["UCF_System"]["bUseAnimation"]) {
			var oAnimation = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(this["oDomRef"], 100);
			var sOpacityValue = UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], "opacity");
			// Workaround: Special case since last change of this DomUtil function: opacity is no longer returned because it does not "survive" the extend() call
			if (UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== "standards") sOpacityValue = this["oDomRef"]["currentStyle"]["opacity"];
			var iOp = parseFloat(sOpacityValue);
			oAnimation["addOpacityChange"](0, isNaN(iOp) ? this["DEFAULT_OPACITY"] : iOp * 100, oAnimation["M_TRANSITIONS"]["EaseIn"]);
			oAnimation["play"]();
		} else {
			if (UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== "standards") {
				var sOp = sOpacityValue = this["oDomRef"]["currentStyle"]["opacity"];
				iOp = parseFloat(sOpacityValue);
				if (sOp) UCF_DomUtil["setOpacityStyle"](this["oDomRef"], isNaN(iOp) ? this["DEFAULT_OPACITY"] : iOp * 100);
			}
		}
	}

	this["bShown"] = true;
};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["show"] = 0; };

/**
 * Hide the block layer
 */
UCF_BlockLayer["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["hide"]++; }; 

	if (!this["bShown"]) return;

	if (!this["oDomRef"]) this["oDomRef"] = this["oHostWindow"]["document"]["getElementById"](this["sId"]);

	if (!this["oDomRef"]) return;

	if (this["oDomRef"]["style"]["display"] === "none")
		return;

	this["oDomRef"]["style"]["display"] = "none";

	this["detachHandlers"]();

	this["bShown"] = false;
};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["hide"] = 0; };

/**
 * Attach event handlers for the block layer
 */
UCF_BlockLayer["prototype"]["attachHandlers"] = function() {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["attachHandlers"]++; }; 

	var that = this;

	this["callbackResize"] = function() { that["resizeBlocklayer"](); };
	this["callbackCancel"] = function(event) { that["cancelEvent"](event); };
	this["callbackClick"] = function(event) { that["clickHandler"](event); };
	this["callbackFocus"] = function(event) { that["focusHandler"](event); };

	UCF_DomUtil["attachEvent"](this["oHostWindow"], "resize", this["callbackResize"]);
	UCF_DomUtil["attachEvent"](this["oDomRef"], "dragstart", this["callbackCancel"]);
	UCF_DomUtil["attachEvent"](this["oDomRef"], "contextmenu", this["callbackCancel"]);
	UCF_DomUtil["attachEvent"](this["oDomRef"], "click", this["callbackClick"]);
	UCF_DomUtil["attachEvent"](this["oDomRef"], "focus", this["callbackFocus"]);
	UCF_DomUtil["attachEvent"](this["oDomRef"], 'touchmove', this["callbackCancel"]);
	UCF_DomUtil["attachEvent"](this["oDomRef"], 'gesturestart', this["callbackCancel"]);

};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["attachHandlers"] = 0; };

/**
 * Detach event handlers for the block layer
 */
UCF_BlockLayer["prototype"]["detachHandlers"] = function() {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["detachHandlers"]++; }; 

	if (!this["oDomRef"] || !this["oDomRef"]["parentNode"])
		return;

	if (this["callbackResize"])
		UCF_DomUtil["detachEvent"](this["oHostWindow"], "resize", this["callbackResize"]);

	if (this["callbackCancel"])
		UCF_DomUtil["detachEvent"](this["oDomRef"], "dragstart", this["callbackCancel"]);

	if (this["callbackCancel"])
		UCF_DomUtil["detachEvent"](this["oDomRef"], "contextmenu", this["callbackCancel"]);

	if (this["callbackClick"])
		UCF_DomUtil["detachEvent"](this["oDomRef"], "click", this["callbackClick"]);

	if (this["callbackFocus"])
		UCF_DomUtil["detachEvent"](this["oDomRef"], "focus", this["callbackFocus"]);

	if (this["callbackCancel"])
		UCF_DomUtil["detachEvent"](this["oDomRef"], 'touchmove', this["callbackCancel"]);
	if (this["callbackCancel"])
		UCF_DomUtil["detachEvent"](this["oDomRef"], 'gesturestart', this["callbackCancel"]);

	this["callbackResize"] = null;
	this["callbackCancel"] = null;
	this["callbackClick"] = null;
	this["callbackFocus"] = null;
};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["detachHandlers"] = 0; };

/**
 * The event handler for clicks on the block layer
 *
 * @param {event} event
 * @return {boolean}
 */
UCF_BlockLayer["prototype"]["clickHandler"] = function(event) {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["clickHandler"]++; }; 
	event = event || this["oHostWindow"]["event"];
	if (!event)
		return true;

	if (event["button"] && event["button"] === 2 || event["which"] && event["which"] === 3) {
		event["returnValue"] = false;
		return false;
	}

	this["fireEvent"](this["E_EVENTS"]["Click"]);

	return false;

};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["clickHandler"] = 0; };

/**
 * Event handler for the focus event
 *
 * @param {event} event
 */
UCF_BlockLayer["prototype"]["focusHandler"] = function(event) {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["focusHandler"]++; }; 

	this["fireEvent"](this["E_EVENTS"]["Focus"]);

};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["focusHandler"] = 0; };
/**
 *
 * Event handler for the resize event
 */
UCF_BlockLayer["prototype"]["resizeBlocklayer"] = function() {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["resizeBlocklayer"]++; }; 

	UCF_JsUtil["delayedCall"](1, this, "doResizeBlocklayer", []);

};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["resizeBlocklayer"] = 0; };

UCF_BlockLayer["prototype"]["doResizeBlocklayer"] = function() {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["doResizeBlocklayer"]++; }; 

	if (!this["oDomRef"])
		return;

	var oStyle = this["oDomRef"]["style"],
		oBody = this["oHostWindow"]["document"]["body"],
		iScrollTolerance = 1;

	oStyle["width"] = "1px";
	oStyle["height"] = "1px";
	oStyle["top"] = "0px";

	if (window["UCF_System"]["bIsRTL"])
		oStyle["right"] = "0px";
	else
		oStyle["left"] = "0px";

	//in case no scrollbars are displayed the blocklayer can have maximum size
	if (this["oPage"] && this["oPage"]["sGetScrollingMode"]() === "HIDE") iScrollTolerance = 0;

	if (this["oPage"] && this["oPage"]["bInsideShellIFrameOnIOS"]()) {
		// UR is inside FLP/NWBC IFRames: We use the metric-decoupling on the Page control
		// => The blocklayer DIV has to be inside the TD for the zindex layering to work!
		oStyle["position"] = 'fixed';
		oStyle["top"] = '0';
		var oTdOfPage = this["oPage"]["oGetInternalBlockLayerLocation"]();
		oTdOfPage["insertBefore"](this["oDomRef"], oTdOfPage["firstChild"]);
		oStyle["height"] = this["oHostWindow"]["innerHeight"] + "px";
		oStyle["width"] = this["oHostWindow"]["innerWidth"] + "px";
	} else if (UCF_UserAgent["bIsAndroid"]()) {
		oStyle["height"] = Math["max"](this["oPage"]["oDomRef"]["scrollHeight"], this["oHostWindow"]["innerHeight"]) + "px";
		oStyle["width"] = Math["max"](this["oPage"]["oDomRef"]["scrollWidth"], this["oHostWindow"]["innerWidth"]) + "px";
	} else {
		// Math.max needed for wd in IFrame v.s. "standalone"
		oStyle["height"] = (Math["max"](oBody["scrollHeight"], UCF_DomUtil["iClientHeight"](this["oHostWindow"])) - iScrollTolerance) + "px";
		oStyle["width"] = (Math["max"](oBody["scrollWidth"], UCF_DomUtil["iClientWidth"](this["oHostWindow"])) - iScrollTolerance) + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["doResizeBlocklayer"] = 0; };

/**
 * Generic event handler for canceling of events
 * @param {Event} oEvent
 * @return {boolean} return value of event
 */
UCF_BlockLayer["prototype"]["cancelEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["cancelEvent"]++; }; 
	var oCancelMe = oEvent || this["oHostWindow"]["event"];

	if (!oCancelMe)
		return false;

	oCancelMe["returnValue"] = false;
	UCF_DomUtil["cancelEvent"](oCancelMe);
	return false;
};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["cancelEvent"] = 0; };

/**
 * Returns if the block layer is visible
 * @return {boolean} block layer is visible
 *
 */
UCF_BlockLayer["prototype"]["bIsShown"] = function() {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["bIsShown"]++; }; 
	return this["bShown"];
};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["bIsShown"] = 0; };

/**
 * clear references to objects in foreign frames
 *
 */
UCF_BlockLayer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["destroy"]++; }; 

	this["detachHandlers"]();

	if (this["oDomRef"]) {
		UCF_DomUtil["removeFromDom"](this["oDomRef"]);
		this["oDomRef"] = null;
	}

	this["oPage"] = null;
	this["oHostWindow"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_BlockLayer["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_BoxDecorator"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>

/**
 * @class
 * 
 * @param {UCF_Control} oControl
 */
function UCF_BoxDecorator(oControl) {if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["UCF_BoxDecorator"]++; }; 

	if (arguments["length"] === 0) return;

	this["oControl"] = oControl;
	this["bDashed"] = false;
	this["oBox"] = null;
	this["oParentContainer"] = oControl["oLS"]["oGetRootRef"]();
};window["UCF_BoxDecorator"] = UCF_BoxDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_BoxDecorator"); UCF_BoxDecorator["_"] = {UCF_BoxDecorator: 0}; }; ;

UCF_BoxDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_BoxDecorator.prototype["sClassName"] = "UCF_BoxDecorator";

/**
 * destructor
 */
UCF_BoxDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["destroy"]++; }; 
	this["oBox"] = null;
	this["oParentContainer"] = null;
	this["oControl"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["destroy"] = 0; };

/**
 * creates dom
 *
 */
UCF_BoxDecorator["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["init"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "D&D", "BoxDecorator.js(42): init"); };

	if (this["oBox"]) return;

	this["oBox"] = document["createElement"]("DIV");
	this["oBox"]["style"]["position"] = "absolute";
	this["oBox"]["style"]["fontSize"] = "1px";
	this["oBox"]["style"]["zIndex"] = UCF_LS["E_LAYERS"]["DECORATORS"];
	this["oBox"]["style"]["height"] = "2px";
	this["oBox"]["style"]["width"] = "2px";
	try {
		this["oBox"]["style"]["boxSizing"] = "border-box";
	} catch (ex) {}

	if (this["bDashed"]) {
		this["oBox"]["style"]["border"] = "2px dashed black";
	} else {
		this["oBox"]["style"]["border"] = "2px solid black";
	}

	UCF_DomUtil["addClass"](this["oBox"], 'lsDragDrop--decorator-box');
	this["oParentContainer"]["appendChild"](this["oBox"]);
};;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["init"] = 0; };

/**
 * removes elements from DOM
 */
UCF_BoxDecorator["prototype"]["cleanUp"] = function() {;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["cleanUp"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "D&D", "BoxDecorator.js(70): cleanUp"); };

	UCF_DomUtil["removeFromDom"](this["oBox"]);
	this["oBox"] = null;

};;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["cleanUp"] = 0; };

/**
 * needed to determine the hovered element
 */
UCF_BoxDecorator["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["hide"]++; }; 

	if (this["oBox"]) {
		this["oBox"]["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["hide"] = 0; };
UCF_BoxDecorator["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["show"]++; }; 

	if (this["oBox"]) {
		this["oBox"]["style"]["display"] = "block";
	}

};;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["show"] = 0; };

UCF_BoxDecorator["prototype"]["setBounds"] = function(iLeft, iTop, iHeight, iWidth) {;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["setBounds"]++; }; 
	//_trace(INFO,"D&D");

	if (!this["oBox"]) return;

	if (!isNaN(iLeft)) {
		this["oBox"]["style"]["left"] = iLeft + "px";
	}

	if (!isNaN(iTop)) {
		this["oBox"]["style"]["top"] = iTop + "px";
	}

	if (!isNaN(iHeight)) {
		this["oBox"]["style"]["height"] = iHeight + "px";
	}

	if (!isNaN(iWidth)) {
		this["oBox"]["style"]["width"] = iWidth + "px";
	}

};;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["setBounds"] = 0; };

UCF_BoxDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["update"]++; }; };;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["update"] = 0; };

UCF_BoxDecorator["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["bIsVisible"]++; }; 
	if (!this["oBox"]) return false;
	return this["oBox"]["style"]["display"] !== "none";
};;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["bIsVisible"] = 0; };

UCF_BoxDecorator["prototype"]["setContainer"] = function(oContainerDomRef) {;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["setContainer"]++; }; 
	this["oParentContainer"] = oContainerDomRef;
};;if (__UCF_COVERAGE__) { UCF_BoxDecorator["_"]["setContainer"] = 0; };

};
sap["ls"]["preload"]["UCF_BreadCrumb"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ClientPopupMenuHelper */
/// <reference path="../helper/ClientPopupMenuHelper.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_BreadCrumbItem */
/// <reference path="./BreadCrumbItem.js"/>

/**
 * @class
 * @extends UCF_Control
 * 
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_BreadCrumb(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["UCF_BreadCrumb"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "BreadCrumb.js(36): UCF_BreadCrumb"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "BreadCrumb.js(37): UCF_BreadCrumb"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "BreadCrumb.js(38): UCF_BreadCrumb"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	this["aItems"] = [];
	if (!this["bEnabled"] && !window["UCF_System"]["bIs508"]) return;

	if (this["sBehavior"] === 'DEFAULT' && this["oDomRef"]["childNodes"]["length"] > 0) {
		this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
		this["addDelegate"](this["oItemNavigation"]);
		this["createItems"]();
		this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Select"], this, 'onItemSelect');
		//	UCF_DomUtil.setTabIndex(this.oDomRef, -1);
		this["oItemNavigation"]["setFocusedIndex"](this["oItemNavigation"]["iFocusedIndex"]);
		this["oItemNavigation"]["setNavigateInLoop"](false);
	}

	this["oItemOverflow"] = null;
	this["bApplyOverflow"] = false;
	this["iWidth"] = 0;
	this["iFirstVisibleItem"] = 1;
	this["bOverflowDecrease"] = true;
	if (this["bItemOverflow"]) {
		this["oItemOverflow"] = UCF_DomUtil["$"](this["sId"] + '-itemOverflow');
		if (this["oItemOverflow"]) {
			this["bApplyOverflow"] = window["UCF_System"]["sDevice"] === 'standards'
				&& UCF_DomUtil["sGetCurrentStyle"](this["oItemOverflow"], 'display') === 'none';
			if (this["bApplyOverflow"]) {
				this["attachBrowserEvent"]('resize', this["oDomRef"]);
				this["sPopupOpenerId"] = this["sId"] + '-itemOverflow';
				this["oPopupOpenerRef"] = UCF_DomUtil["$"](this["sPopupOpenerId"]);
				this["sPopupMenuId"] = this["sId"] + '-menu';
				this["iWidth"] = this["oDomRef"]["offsetWidth"];
			}
		}

	}
	this["bIgnoreTabChain"] = this["oDomRef"]["hasAttribute"] && this["oDomRef"]["hasAttribute"]('data-ignore-tabchain') && this["oDomRef"]["getAttribute"]('data-ignore-tabchain') === 'true';

};window["UCF_BreadCrumb"] = UCF_BreadCrumb; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_BreadCrumb"); UCF_BreadCrumb["_"] = {UCF_BreadCrumb: 0}; }; ;

UCF_BreadCrumb["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_BreadCrumb.prototype["sClassName"] = "UCF_BreadCrumb";

/** Constructor
 * @private
 */
UCF_BreadCrumb["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["initialize"]++; }; 

	if (!this["bApplyOverflow"]) return;

	if (this["aItems"] && this["aItems"]["length"] === 0) {
		this["createItems"]();
	}
	if (this["aItems"] && this["aItems"]["length"] === 0) return;

	this["applyItemOverflow"]();
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["initialize"] = 0; };

UCF_BreadCrumb["prototype"]["applyItemOverflow"] = function() {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["applyItemOverflow"]++; }; 
	if (!this["bApplyOverflow"] || this["aItems"] == null
		|| (this["aItems"] && (this["aItems"]["length"] === 0
			|| this["aItems"]["length"] === 1))) return;

	// all visible, nothing to do
	if (this["oDomRef"]["offsetWidth"] === this["oDomRef"]["scrollWidth"]
		&& this["iFirstVisibleItem"] === 1) return;

	var oItemDomRef;

	if (UCF_DomUtil["bHasClass"](this["oItemOverflow"], 'lsBreadcrumb--hidden')) {
		UCF_DomUtil["removeClass"](this["oItemOverflow"], 'lsBreadcrumb--hidden');
	}
	// if (this.oDomRef.offsetWidth == this.oDomRef.scrollWidth) return;
	var oLastItem = this["aDomRefItems"][this["aDomRefItems"]["length"] - 1];
	var iLastItem = this["aDomRefItems"]["length"] - 2;

	UCF_DomUtil["resetTabIndex"](this["oItemOverflow"]);
	for (var i = 0; i < this["aDomRefItems"]["length"] - 1; i++) {
		oItemDomRef = this["aDomRefItems"][i];
		UCF_DomUtil["addClass"](oItemDomRef, 'lsBreadcrumb--hidden');

	}

	while (this["bItemVisible"](oLastItem) && iLastItem > 0) {
		oItemDomRef = this["aDomRefItems"][iLastItem];
		UCF_DomUtil["removeClass"](oItemDomRef, 'lsBreadcrumb--hidden');
		iLastItem--;
	}
	if (!this["bItemVisible"](oLastItem)) {
		iLastItem++;
	}

	if (iLastItem >= 1) {
		UCF_DomUtil["removeClass"](this["aDomRefItems"][0], 'lsBreadcrumb--hidden');
		UCF_DomUtil["setTabIndex"](this["oItemOverflow"], 0);
		while (!this["bItemVisible"](oLastItem)
			&& iLastItem < this["aDomRefItems"]["length"] - 1) {
			oItemDomRef = this["aDomRefItems"][iLastItem];
			UCF_DomUtil["addClass"](oItemDomRef, 'lsBreadcrumb--hidden');
			iLastItem++;
		}
	}

	this["iFirstVisibleItem"] = iLastItem;

};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["applyItemOverflow"] = 0; };

/**
 * Checks whether the item is visible or not
 * @private
 */

UCF_BreadCrumb["prototype"]["bItemVisible"] = function(oItemRef) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["bItemVisible"]++; }; 
	var bIsVisible = true;

	if (window["UCF_System"]["bIsRTL"]) {
		bIsVisible = oItemRef["offsetLeft"] > this["oDomRef"]["offsetLeft"];
	} else {
		bIsVisible = (oItemRef["offsetLeft"] + oItemRef["offsetWidth"]) < this["oDomRef"]["offsetWidth"];
	}

	return bIsVisible;
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["bItemVisible"] = 0; };

/**
 * Handles the resize event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 *
 */

UCF_BreadCrumb["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onresize"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource === this["oDomRef"]) {

		if (this["sTimeOutId"] != null) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResize');
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onresize"] = 0; };

/**
 * This function is called after resizing has finished
 *
 * @private
 */
UCF_BreadCrumb["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onAfterResize"]++; }; 

	if (!this["bApplyOverflow"] || this["iWidth"] === this["oDomRef"]["offsetWidth"]
		|| this["aItems"] == null
		|| (this["aItems"] && this["aItems"]["length"] === 0)) return;

	this["bOverflowDecrease"] = (this["iWidth"] > this["oDomRef"]["offsetWidth"]);
	this["applyItemOverflow"]();

	this["iWidth"] = this["oDomRef"]["offsetWidth"];

};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onAfterResize"] = 0; };

UCF_BreadCrumb["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["destroy"]++; }; 

	if (this["bApplyOverflow"]) {
		this["detachBrowserEvent"]('resize', this["oDomRef"]);
	}
	if (this["oItemNavigation"])
		this["oItemNavigation"]["detachEvent"](this["oItemNavigation"]["E_EVENTS"]["Select"], this);

	if (this["oItemNavigation"]) this["oItemNavigation"]["destroy"]();

	this["oItemNavigation"] = null;
	this["aItems"] = null;
	this["oItemOverflow"] = null;
	this["bApplyOverflow"] = null;
	this["sPopupMenuId"] = null;
	this["oPopupOpenerRef"] = null;
	this["sPopupOpenerId"] = null;
	this["aDomRefItems"] = null;
	this["oPopupMenu"] = null;
	this["sTimeOutId"] = null;
	this["iFirstVisibleItem"] = null;
	this["iWidth"] = null;
	this["bOverflowDecrease"] = null;
	this["bIgnoreTabChain"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["destroy"] = 0; };

/**
 * Handles the onclick event of the browser, if the behaviour property is set to SINGLELINK
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_BreadCrumb["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "BreadCrumb.js(237): onclick"); };

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	var oEventSource = oBrowserEvent["oGetSource"]();

	if (this["bApplyOverflow"] && this["aItems"]["length"] > 0
		&& oEventSource === this["oItemOverflow"]) {

		if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
			this["oPopupMenu"]["close"]();
			UCF_DomUtil["focusDomElement"](this["oItemOverflow"]);
		} else {
			this["updatePopupMenuItems"]();
		}

	} else if (this["sBehavior"] === 'SINGLELINK' && this["bEnabled"]) {
		this["fireActivate"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onclick"] = 0; };

/**
 * When an item is selected, fire the according event on the
 * corresponding toolbar item that is hidden
 * @private
 */

UCF_BreadCrumb["prototype"]["onMenuItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onMenuItemSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "BreadCrumb.js(265): onMenuItemSelect"); };

	var sMenuItemId = oEvent["oGetParam"]('sItemId'),
		sMenuId = sMenuItemId["split"]('-')[0],
		oItem = this["oLS"]["oControlFactory"]["oGetControlById"](sMenuId);

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_BreadCrumbItem, "oItem instanceof UCF_BreadCrumbItem", "BreadCrumb.js(271): onMenuItemSelect"); };

	if (!oItem["bSelected"] && this["bEnabled"])
		this["fireSelect"](this["sId"], oItem["sId"]);
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onMenuItemSelect"] = 0; };

/**
 * Open the associated Menu and attach to all necessary events
 * @private
 */
UCF_BreadCrumb["prototype"]["openPopupMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["openPopupMenu"]++; }; 
	// if (this.oPopupMenu == null) return;

	this["oPopupMenu"]["setOpenerRef"](this["oPopupOpenerRef"]);
	this["oPopupMenu"]["setOpenerId"](this["sPopupOpenerId"]);
	this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
	this["oPopupMenu"]["bAutoRefocus"] = false;

	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, 'onMenuClose');
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, 'onMenuItemSelect');
	// this.oPopupMenu.attachEvent(this.oPopupMenu.E_EVENTS.TabPrevious, this, 'onMenuTabToPrevious');
	// this.oPopupMenu.attachEvent(this.oPopupMenu.E_EVENTS.MenuAccess, this, 'onSubMenuAccess');

	this["oPopupMenu"]["open"](false);

};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["openPopupMenu"] = 0; };

/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @private
 */

UCF_BreadCrumb["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onMenuClose"]++; }; 

	//TODO: destroy items?
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, 'onMenuClose');
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, 'onMenuItemSelect');
	// his.oPopupMenu.detachEvent(this.oPopupMenu.E_EVENTS.TabPrevious, this, 'onMenuTabToPrevious');
	// this.oPopupMenu.detachEvent(this.oPopupMenu.E_EVENTS.MenuAccess, this, 'onSubMenuAccess');

	this["bTabbedOutOfMenu"] = false;
	UCF_DomUtil["focusDomElement"](this["oItemOverflow"]);
	// if (this.bMenuOpenerVisible())
	//	this.oPopupMenu.scrollItemIntoView(this.iSavedFirstMenuIdx);
	// this.oPopupMenu.setFirstVisibleItemIdx(this.iSavedFirstMenuIdx);
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onMenuClose"] = 0; };

/**
 * Click on separator must not be delegated to item navigation as it
 * would set the focus to the selected. If breadcrumb is in scrollcontainer
 * container would scroll. CSN:2729784 2008
 */

UCF_BreadCrumb["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onmousedown"]++; }; 

	if (!window["UCF_System"]["bIs508"] && this["bEnabled"] && this["sBehavior"] === 'DEFAULT') {
		this["oItemNavigation"]["bIgnoreFocus"] = false;
		var oSeparator = oBrowserEvent["oGetSource"](),
			oSource = oBrowserEvent["oGetSourceControl"]();

		if (oSeparator["tagName"] === 'IMG') oSeparator = oSeparator["parentNode"];
		// when an Item is selected, then it should also be focused
		if (oSource instanceof UCF_BreadCrumbItem) {
			this["oItemNavigation"]["bIgnoreFocus"] = false;
			this["oItemNavigation"]["focusItem"](oSource);

			return;
		} else if (oSeparator["getAttribute"]('idx') == null) return;

		this["oItemNavigation"]["bIgnoreFocus"] = true;
		var iIdx = parseInt(oSeparator["getAttribute"]('idx'));

		this["oItemNavigation"]["setFocusedIndex"](iIdx);
		this["oItemNavigation"]["focusItemByIndex"](iIdx);
	}
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onmousedown"] = 0; };

/**
 * Handles the keydown event of the browser, if the behaviour property is set to SINGLELINK
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_BreadCrumb["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "BreadCrumb.js(356): onlsselect"); };

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	var oEventSource = oBrowserEvent["oGetSource"]();
	if (this["sBehavior"] === 'SINGLELINK' && this["bEnabled"]) {
		this["fireActivate"](this["sId"]);
	} else if (this["bApplyOverflow"] && this["aItems"]["length"] > 0
		&& oEventSource === this["oItemOverflow"]) {

		if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
			this["oPopupMenu"]["close"]();
			UCF_DomUtil["focusDomElement"](this["oItemOverflow"]);
		} else {
			this["updatePopupMenuItems"]();
		}

	}

};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onlsselect"] = 0; };

/**
 * Handles the onlsshow event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_BreadCrumb["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onlsshow"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "BreadCrumb.js(384): onlsshow"); };
	// fired by keyboard - F4 and Alt+cursor down

	if (!this["bEnabled"]) return;
	var oEventSource = oBrowserEvent["oGetSource"]();

	if (this["bApplyOverflow"] && this["aItems"]["length"] > 0
		&& oEventSource === this["oItemOverflow"]) {

		if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
			this["oPopupMenu"]["close"]();
			UCF_DomUtil["moveFocusDomElement"](oEventSource);
		} else {
			this["updatePopupMenuItems"]();
		}

	}

};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onlsshow"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_BreadCrumb["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "BreadCrumb.js(411): onmouseover"); };
	// fired by mouse click

	window["status"] = '';
	oBrowserEvent["oDomEvent"]["returnValue"] = true;
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onmouseover"] = 0; };

/**
 * Fires a selection event.
 * @param {UCF_Event} oEvent the event that occurred
 * @private
 */
UCF_BreadCrumb["prototype"]["onItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onItemSelect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "BreadCrumb.js(425): onItemSelect"); };

	var oItem = oEvent["oGetParam"]('oItem');

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_BreadCrumbItem, "oItem instanceof UCF_BreadCrumbItem", "BreadCrumb.js(429): onItemSelect"); };

	if (!oItem["bSelected"] && this["bEnabled"])
		this["fireSelect"](this["sId"], oItem["sId"]);
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onItemSelect"] = 0; };

/**
 * Orchestrates the tabIndex.
 * Is necessary for access keys
 *
 * @param {UCF_Control} oBrowserEvent
 */
UCF_BreadCrumb["prototype"]["onfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onfocus"]++; }; 
	if (this["bIgnoreTabChain"] && oBrowserEvent["oGetSource"]() === this["oDomRef"]) {
		this["oItemNavigation"]["focusItemByIndex"](this["oItemNavigation"]["iFocusedIndex"]);
	}
	if (this["bIgnoreTabChain"]) {
		UCF_DomUtil["resetTabIndex"](this["oDomRef"]);
	}

};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onfocus"] = 0; };

/**
 * Passes all items that are neccessary for the navigation to the navigation framework
 */
UCF_BreadCrumb["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["createItems"]++; }; 
	this["aItems"] = [];
	this["aDomRefItems"] = [];
	if (!this["bEnabled"]) return;

	this["aDomRefItems"] = (window["UCF_System"]["sDevice"] === 'standards' && this["bEnabled"] ? this["oDomRef"]["firstChild"]["childNodes"] : this["oDomRef"]["childNodes"]);
	var aDomItems = this["aDomRefItems"];

	for (var i = 0; i < aDomItems["length"]; i++) {

		var oControlItem = aDomItems[i]["tagName"] === 'LI' ?
			this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[i]["firstChild"], true) :
			this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[i], true);

		if (oControlItem == null) continue;
		this["aItems"]["push"](oControlItem);
		oControlItem["bEnabled"] = true;
		this["oItemNavigation"]["addItem"](oControlItem, oControlItem["bSelected"]);
		this["oItemNavigation"]["aItems"][this["oItemNavigation"]["aItems"]["length"] - 1]["iIndex"] = this["oItemNavigation"]["aItems"]["length"];
	}
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["createItems"] = 0; };

/**
 * Sets the correct acc text
 */

UCF_BreadCrumb["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "BreadCrumb.js(481): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSourceControl"](),
		oSourceDomRef = oBrowserEvent["oGetSource"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	// Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this);

	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	if (this["oDomRef"]["childNodes"]["length"] === 0) {
		oAccessibilityHelper["setControlType"]('BRC');
		oAccessibilityHelper["setEmpty"](true);
		oAccessibilityHelper["addTooltip"](this["sTooltip"]);
		return;
	}

	if (this["sBehavior"] === 'SINGLELINK' || !this["bEnabled"]) {

		oAccessibilityHelper["setControlType"]('BRC_SL');
		oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](this["oDomRef"]));
		oAccessibilityHelper["addTooltip"](this["sTooltip"]);

		if (this["bEnabled"])
			oAccessibilityHelper["addTutor"]('SELECT_TUT');

	} else if (oSourceDomRef === this["oItemOverflow"]) {
		oAccessibilityHelper["setText"](this["oLS"]["sGetText"]('SAPUR_BRC_MORE'));
		oAccessibilityHelper["addTutor"]("BRC_MORE_TUT");
	} else if (oSource === this) {
		oAccessibilityHelper["setControlType"]('BRC');
		oAccessibilityHelper["addTooltip"](oSource["sTooltip"]);
		oAccessibilityHelper["addTutor"]('LRNAV_TUT');
	} else if (UCF_JsUtil["bInstanceOf"](oSource, 'UCF_BreadCrumbItem')
		&& this["sBehavior"] !== 'SINGLELINK') {
		oAccessibilityHelper["addTooltip"](oSource["sTooltip"]);
		oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](oSource["oDomRef"]));
		oAccessibilityHelper["setSelected"](oSource["bSelected"]);
		if (this["oItemNavigation"] && this["oItemNavigation"]["aItems"])
			oAccessibilityHelper["setItemCount"](this["oItemNavigation"]["aItems"]["length"]);
		oAccessibilityHelper["setItemIndex"](oSource["iIndex"]);
		if (!oSource["bSelected"] && this["bEnabled"]) {
			oAccessibilityHelper["addTutor"]('SELECT_TUT');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onlsaccessibility"] = 0; };

UCF_BreadCrumb["prototype"]["updatePopupMenuItems"] = function() {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["updatePopupMenuItems"]++; }; 
	var aNewItems = [];
	var oPMHelper = new (UCF_ClassLoader["oGetClass"]("UCF_ClientPopupMenuHelper"))(this["oLS"]);

	for (var i = this["iFirstVisibleItem"] - 2; i >= 0; i--) {
		aNewItems["push"]({
			"PopupMenuItem": {
				"Id": this["aItems"][i]["sId"] + '-itemMenu',
				"Text": this["aItems"][i]["sValue"]
			}
		});
	}

	this["oPopupMenu"] = oPMHelper["oRenderMenu"](
		this["sPopupMenuId"],
		UCF_DomUtil["oGetParentElement"](UCF_DomUtil["$"](this["sId"] + '-itemOverflow')),
		aNewItems);
	this["oPopupMenu"]["bContentChanged"] = false;
	this["openPopupMenu"]();
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["updatePopupMenuItems"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_BreadCrumb["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "BreadCrumb.js(556): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_BreadCrumb["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "BreadCrumb.js(568): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["onlsskipback"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_BreadCrumb["prototype"]["aAttributeNames"] = ["sBehavior","sTooltip","bEnabled","sVisibility","sCustomData","bItemOverflow","sLabelledBy","sAccessibilityDescription"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_BreadCrumb["prototype"]["aEventNames"] = ["Select","Activate"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_BreadCrumb["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.BreadCrumbBehavior}
 */
UCF_BreadCrumb["prototype"]["sBehavior"] = "DEFAULT";

/**
 * @private
 * @type {string}
 */
UCF_BreadCrumb["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_BreadCrumb["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_BreadCrumb["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_BreadCrumb["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_BreadCrumb["prototype"]["bItemOverflow"] = false;

/**
 * @private
 * @type {string}
 */
UCF_BreadCrumb["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {string}
 */
UCF_BreadCrumb["prototype"]["sAccessibilityDescription"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_BreadCrumb["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["setDefaultValues"]++; }; 
	this["sBehavior"] = "DEFAULT";
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["bItemOverflow"] = false;
	this["sLabelledBy"] = '';
	this["sAccessibilityDescription"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Behavior", "DEFAULT", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("ItemOverflow", false, true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the BreadCrumb control (Root object).
 * @param {string} sItemId Identifier of the selected BreadCrumb item. If the BreadCrumbBehavior is set to SINGLELINK the value of this parameter is 'NONE'.
 * @fires BreadCrumb::Select
 */
UCF_BreadCrumb["prototype"]["fireSelect"] = function(sId, sItemId) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, ItemId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "BreadCrumb.js(679): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "BreadCrumb.js(680): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "BreadCrumb.js(681): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "BreadCrumb.js(682): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "BreadCrumb.js(683): fireSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	this["fireSemanticEvent"]("BreadCrumb", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the BreadCrumb control (Root object).
 * @fires BreadCrumb::Activate
 */
UCF_BreadCrumb["prototype"]["fireActivate"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["fireActivate"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "BreadCrumb.js(707): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "BreadCrumb.js(708): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "BreadCrumb.js(709): fireActivate"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("BreadCrumb", "Activate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_BreadCrumb["_"]["fireActivate"] = 0; };

};
sap["ls"]["preload"]["UCF_BreadCrumbItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_BreadCrumbItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_BreadCrumbItem["_"]["UCF_BreadCrumbItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "BreadCrumbItem.js(21): UCF_BreadCrumbItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "BreadCrumbItem.js(22): UCF_BreadCrumbItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "BreadCrumbItem.js(23): UCF_BreadCrumbItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	if (this["oDomRef"]) {
		this["allowTextSelection"]();
	}
};window["UCF_BreadCrumbItem"] = UCF_BreadCrumbItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_BreadCrumbItem"); UCF_BreadCrumbItem["_"] = {UCF_BreadCrumbItem: 0}; }; ;

UCF_BreadCrumbItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_BreadCrumbItem.prototype["sClassName"] = "UCF_BreadCrumbItem";

UCF_BreadCrumbItem["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumbItem["_"]["onlsfocus"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_BreadCrumbItem["_"]["onlsfocus"] = 0; };

/**
 * Makes the browser selection visible
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the selectstart
 */
UCF_BreadCrumbItem["prototype"]["onselectstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_BreadCrumbItem["_"]["onselectstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "BreadCrumbItem.js(45): onselectstart"); };
	// for touch, cancel text selection
	if (oBrowserEvent["bIsTouchInteraction"]()) {
		oBrowserEvent["oDomEvent"]["returnValue"] = false;
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}

	UCF_Control.prototype["onselectstart"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_BreadCrumbItem["_"]["onselectstart"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_BreadCrumbItem["prototype"]["aAttributeNames"] = ["sValue","bSelected","sTooltip","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_BreadCrumbItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_BreadCrumbItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_BreadCrumbItem["prototype"]["sValue"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_BreadCrumbItem["prototype"]["bSelected"] = false;

/**
 * @private
 * @type {string}
 */
UCF_BreadCrumbItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_BreadCrumbItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_BreadCrumbItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_BreadCrumbItem["_"]["setDefaultValues"]++; }; 
	this["sValue"] = '';
	this["bSelected"] = false;
	this["sTooltip"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Value", '', true);
		this["setClientProperty"]("Selected", false, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_BreadCrumbItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Button"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_ImageUtil */
/// <reference path="../core/ImageUtil.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_RenderManager */
/// <reference path="../core/RenderManager.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>
/* global UCF_ButtonDragDelegate */
/// <reference path="./delegates/ButtonDragDelegate.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Button(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Button["_"]["UCF_Button"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Button.js(51): UCF_Button"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Button.js(52): UCF_Button"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Button.js(53): UCF_Button"); };
	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["defineEvents"](['Press', 'MouseDown', 'OpenMenu']);
	// ignore the default button if the control gets the focus

	/** @private **/
	this["bIgnoreDefaultButton"] = true;

	this["sCurrentSrc"] = (this["bDown"] ? this["sDownIconSrc"] : (this["bEnabled"] ? this["sUpIconSrc"] : this["sDisabledIconSrc"]));

	/** @private **/
	this["sMainClassName"] = null;

	//handle the explanation text of the datatip
	if (this["oDataTip"]) {
		var oDataTipRomRef = this["oFocusDomRef"] ? this["oFocusDomRef"] : this["oRootRef"];
		// Disabled etc. Buttons have no focus domref

		this["oDataTip"]["setHoverDomRef"](oDataTipRomRef);
		this["oDataTip"]["setOpenerRef"](oDataTipRomRef);
		this["oDataTip"]["bShowOnActivate"] = false;
		if (this["sTooltip"] !== '' || window["UCF_System"]["bIs508"]) {
			this["oDataTip"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"]);
			/*			this.oDataTip.setMoveIntoViewPort(false); */
		}
	}
	//Fields neccessary for toolbar buttons
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bDelegateOpenMenu"] = false;

	if (this["bHasButtonCaption"]) {
		var oInplaceEditDelegate = this["oInplaceEditDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEditDelegate"))(oLS);

		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this, 'onInplaceEditStart');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this, 'onInplaceEditFinished');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this, 'onInplaceEditClosed');
		this["addDelegate"](oInplaceEditDelegate);
	}

	this["sButtonTooltip"] = null;
	this["oMenuSectionDomRef"] = null;
	if (this["bHasPopupMenuSection"]) {
		this["oMenuSectionDomRef"] = UCF_DomUtil["$"](this["sId"] + '-sec');
	}

	/** On VariantManagement set the focusDomRef on the Section DOM Element */
	if (this["sType"] === 'VARIANTMANAGEMENT' && this["oMenuSectionDomRef"]) {
		this["oFocusDomRef"] = this["oMenuSectionDomRef"];
	}

	// Incident 1482028359: MSIE & standards mode
	// -> set the href=javascript:void(0);
	// Incident 1580006874: Caused a regression in IE when set in mousedown
	// and removed in mouseup: Button would respond to click during round-trip
	// and send request for the base-URL => Server Error 500
	if (UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] === 'standards') {
		this["oDomRef"]["href"] = 'javascript:void(0);';
	}

};window["UCF_Button"] = UCF_Button; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Button"); UCF_Button["_"] = {UCF_Button: 0}; }; ;

UCF_Button["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Button.prototype["sClassName"] = "UCF_Button";

UCF_Button["prototype"]["eStyles"] = {
	"BUTTON_ACTIVE": 'lsButton--active',
	"BUTTON_HOVERABLE": 'lsButton--hoverable',
	"BUTTON_TOUCHABLE": 'lsButton--touchable',
	"BUTTON_FOCUSABLE": 'lsButton--focusable',
	"BUTTON_DOWN": 'lsButton--down',
	"BUTTON_UP": 'lsButton--up',
	"BUTTON_SECTION_DOWN": 'lsButton--section-down',
	"BUTTON_DISABLED": 'lsButton--disabled',
	"BUTTON_SECTION_DISABLED": 'lsButton--section-disabled',
	"BUTTON_DEFAULT": 'lsButton--default'

};

UCF_Button["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["initialize"]++; }; 

	if (__UCF_IE6__) {
		this["initializeQuirks"]();
	}

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["initialize"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(146): onclick"); };
	//fired by mouse click
	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}

	this["handleClick"](oBrowserEvent, false, false);
	return;

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onclick"] = 0; };

/**
 * Handles the default button
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["activateDefaultButton"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["activateDefaultButton"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(164): activateDefaultButton"); };

	UCF_DomUtil["addClass"](this["oDomRef"], 'lsButton--default-pressed');
	this["onclick"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	UCF_JsUtil["delayedCall"](600, this, "resetPressedDefaultButton");
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["activateDefaultButton"] = 0; };

/**
 * Handles the default button
 *
 * @private
 */
UCF_Button["prototype"]["resetPressedDefaultButton"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["resetPressedDefaultButton"]++; }; 
	if (this["oDomRef"])
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsButton--default-pressed');
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["resetPressedDefaultButton"] = 0; };

/**
 * Return true if the control from the focus is comming is the PopupMenu
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 * @return {boolean} - true if the control from event is the curent control
 * @private
 */
UCF_Button["prototype"]["bFocusInFromPopupMenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["bFocusInFromPopupMenu"]++; }; 

	if (!this["bHasPopupMenu"]) return false;
	var oFromElement = oBrowserEvent["oGetFromElement"]();
	if (!oFromElement) return false;
	if (UCF_StringUtil["bIsEmpty"](this["sPopupMenuId"])) return false;

	if (UCF_DomUtil["bIsCTInstanceOf"](oFromElement, 'POMNI')) {
		var oParentElement = UCF_DomUtil["oGetParentByAttribute"](oFromElement, 'ct', 'POMN');
		if (oParentElement) {
			return oParentElement["id"] === this["sPopupMenuId"];
		}

	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["bFocusInFromPopupMenu"] = 0; };

/**
 * Return true if the PopupMenu Is still opened
 * @return {boolean} - true if the control from event is the curent control
 * @private
 */
UCF_Button["prototype"]["bIsPopupMenuOpened"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["bIsPopupMenuOpened"]++; }; 

	if (!this["bHasPopupMenu"]) return false;
	if (!this["oPopupMenu"]) return false;
	if (this["oPopupMenu"]["bIsValid"]() && this["oPopupMenu"]["bOpened"]) return true;

	return false;
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["bIsPopupMenuOpened"] = 0; };

/**
 * Handles the onmousedown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(228): onmousedown"); };

	if (!this["bIsCurentControl"](oBrowserEvent)) return;

	this["fireEvent"](this["E_EVENTS"]["MouseDown"], { "sId": this["sId"] }); //used internally to notify RichTextEdit

	if (!this["bEnabled"]) return;

	this["bIsDownBeforeUp"] = true;
	//cancel bubble to prevent outer container (table) to select the row
	oBrowserEvent["cancelBubble"]();

	if (this["sDragSourceInfo"]) {
		//FIX for CSN 0001911190 2009: cancel native browser drag
		//do not cancel if native browserDragDrop is used
		if ((UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]()) && !this["bDraggable"]) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["oDomEvent"]["returnValue"] = false;
		}
	}
	// start to set Down status
	if (__UCF_IE6__) {
		if (this["sDesign"] === 'TOGGLE') {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsBtnTglPress');
			return;
		}
	}
	if (this["bDown"]) return;

	if (__UCF_IE6__) {
		this["applyQuirksDownStyles"](true);
	}

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onmousedown"] = 0; };

UCF_Button["prototype"]["toggleSectionButton"] = function(down) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["toggleSectionButton"]++; }; 
	if (!this["bEnabled"]) return;
	if (this["bHasPopupMenu"]) {
		if (this["bHasPopupMenuSection"]) {
			if (this["oMenuSectionDomRef"] != null) {
				if (down) {
					UCF_DomUtil["addClass"](this["oMenuSectionDomRef"], 'lsButton--section-push');
				} else {
					UCF_DomUtil["removeClass"](this["oMenuSectionDomRef"], 'lsButton--section-push');
					UCF_DomUtil["removeClass"](this["oMenuSectionDomRef"], 'lsButton--flat-section-over');
					UCF_DomUtil["removeClass"](this["oMenuSectionDomRef"], 'lsButton--section-down');
				}
			}
		} else {
			if (down) {
				UCF_DomUtil["addClass"](this["oDomRef"], 'lsButton--menu-push');
			} else {
				UCF_DomUtil["removeClass"](this["oDomRef"], 'lsButton--menu-push');
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["toggleSectionButton"] = 0; };

/**
 * Applies the down style for the Button
 * Only for Standards mode
 * @param {boolean} bDown - the down state
 */
UCF_Button["prototype"]["applyDownStyles"] = function(bDown) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyDownStyles"]++; }; 
	if (!this["oDomRef"]) return; // avoid RTE JS error

	if (bDown) {
		UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["BUTTON_DOWN"]);
		UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["BUTTON_UP"]);
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["BUTTON_DOWN"]);
		UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["BUTTON_UP"]);
	}
	// Set Down for SectionMenu when hasPopupMenu=true && hasPopupMenuSection=true
	if (this["bHasPopupMenuSection"] && this["bHasPopupMenu"] && this["oMenuSectionDomRef"]) {
		if (bDown)
			UCF_DomUtil["addClass"](this["oMenuSectionDomRef"], this["eStyles"]["BUTTON_SECTION_DOWN"]);
		else
			UCF_DomUtil["removeClass"](this["oMenuSectionDomRef"], this["eStyles"]["BUTTON_SECTION_DOWN"]);
	}

	// Change the Icon Src
	this["applyIconSrc"](this["bEnabled"], bDown);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyDownStyles"] = 0; };

/**
 * Applies the default style for the Button
 * Only for Standards mode
 * @param {boolean} bDefault - the down state
 */
UCF_Button["prototype"]["applyDefaultStyles"] = function(bDefault) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyDefaultStyles"]++; }; 
	if (bDefault) {
		UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["BUTTON_DEFAULT"]);
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["BUTTON_DEFAULT"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyDefaultStyles"] = 0; };

/**
 * Applies Buttons styles according with the new enabled status
 * Only for Standards mode
 * @param { boolean } bEnabled - the new enabled status
 * @private
 */
UCF_Button["prototype"]["applyEnabledStyles"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyEnabledStyles"]++; }; 

	if (bEnabled) {
		UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["BUTTON_DISABLED"]);
		UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["BUTTON_ACTIVE"]);
		UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["BUTTON_FOCUSABLE"]);
		UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"]);
	} else {
		UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["BUTTON_DISABLED"]);
		UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["BUTTON_ACTIVE"]);
		UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["BUTTON_FOCUSABLE"]);
		UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"]);
	}

	// set the Enabled state for section menu, hasPopupMenu=true && hasPopupMenuSection=true
	if (this["bHasPopupMenuSection"] && this["bHasPopupMenu"] && this["oMenuSectionDomRef"]) {
		if (bEnabled)
			UCF_DomUtil["removeClass"](this["oMenuSectionDomRef"], this["eStyles"]["BUTTON_SECTION_DISABLED"]);
		else
			UCF_DomUtil["addClass"](this["oMenuSectionDomRef"], this["eStyles"]["BUTTON_SECTION_DISABLED"]);
	}
	// Change the Icon Src
	this["applyIconSrc"](bEnabled, this["bDown"]);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyEnabledStyles"] = 0; };

/**
 * Applies or removes the hover styles for button
 * Only for Standards mode
 * @param {boolean} bHover - if the hover state should be applied or removed
 * @private
 */
UCF_Button["prototype"]["applyHoverStyles"] = function(bHover) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyHoverStyles"]++; }; 

	if (!bHover) {
		if (UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"])) {
			UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"]);
		}
		if (this["oMenuSectionDomRef"] && UCF_DomUtil["bHasClass"](this["oMenuSectionDomRef"], this["eStyles"]["BUTTON_HOVERABLE"])) {
			UCF_DomUtil["removeClass"](this["oMenuSectionDomRef"], this["eStyles"]["BUTTON_HOVERABLE"]);
		}

	} else {
		if (!UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"])) {
			UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"]);
		}
		if (this["oMenuSectionDomRef"] && !UCF_DomUtil["bHasClass"](this["oMenuSectionDomRef"], this["eStyles"]["BUTTON_HOVERABLE"])) {
			UCF_DomUtil["addClass"](this["oMenuSectionDomRef"], this["eStyles"]["BUTTON_HOVERABLE"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyHoverStyles"] = 0; };

/**
 * Applies or removes the hover styles for Flat button
 * Only for Standards mode
 * @param {boolean} bHover - if the hover state should be applied or removed
 * @param {UCF_HTMLElement} oSource the souce html
 * @private
 */
UCF_Button["prototype"]["applyFlatHoverStyles"] = function(bHover, oSource) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyFlatHoverStyles"]++; }; 
	if (!(this["bHasPopupMenu"] && this["bHasPopupMenuSection"] && this["bEnabled"])) return;
	var oParent = this["oGetParent"]();
	var bIsDBAlready, bIsDBImgAlready;
	//Check if it's a flat button
	if (!(oParent != null && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_Toolbar') && (oParent["sDesign"] === 'FLAT'))) return;

	if (bHover) {
		if (UCF_DomUtil["bContains"](this["oMenuSectionDomRef"], oSource)) {
			bIsDBAlready = UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsButton--flat-over');

			if (!bIsDBAlready) {
				UCF_DomUtil["addClass"](this["oDomRef"], 'lsButton--flat-over');
				// UCF_DomUtil.setClass(this.oDomRef, UCF_DomUtil.sGetClass(this.oDomRef) + 'DB');
			}
			bIsDBImgAlready = UCF_DomUtil["bHasClass"](this["oDomRef"], 'urBtnStdMnuOnlyImgDB');

			if (!bIsDBImgAlready) {
				UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnStdMnuOnlyImg', 'urBtnStdMnuOnlyImgDB');
			}
		} else {
			bIsDBAlready = UCF_DomUtil["bHasClass"](this["oMenuSectionDomRef"], 'lsButton--flat-section-over');

			if (!bIsDBAlready) {
				UCF_DomUtil["addClass"](this["oMenuSectionDomRef"], 'lsButton--flat-section-over');
			}
		}

	} else {

		if (UCF_DomUtil["bContains"](this["oMenuSectionDomRef"], oSource)) {
			// Deselect main button
			bIsDBAlready = UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsButton--flat-over');
			if (bIsDBAlready) {
				UCF_DomUtil["removeClass"](this["oDomRef"], 'lsButton--flat-over');
			}
			bIsDBImgAlready = UCF_DomUtil["bHasClass"](this["oDomRef"], 'urBtnStdMnuOnlyImg');
			if (!bIsDBImgAlready) {
				UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnStdMnuOnlyImgDB', 'urBtnStdMnuOnlyImg');
			}

		} else {
			// Deselect menu section urBtnMnuSection
			bIsDBAlready = UCF_DomUtil["bHasClass"](this["oMenuSectionDomRef"], 'lsButton--flat-section-over');
			if (bIsDBAlready) {
				UCF_DomUtil["removeClass"](this["oMenuSectionDomRef"], 'lsButton--flat-section-over');
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyFlatHoverStyles"] = 0; };

/**
 * Renders the icon for the button according with the given states
 * @param {boolean} bEnabled - the enabled state
 * @param {boolaen} bDown - the down state
 * @private
 */
UCF_Button["prototype"]["applyIconSrc"] = function(bEnabled, bDown) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyIconSrc"]++; }; 

	//	if (UCF_System.sDevice !== 'standards') return;

	if (!this["bHasIcon"]) return;
	var oImageDomRef = UCF_DomUtil["$"](this["sId"] + '-img');
	if (!oImageDomRef) return;

	var sIconSrc = '';

	if (!bEnabled && !UCF_StringUtil["bIsEmpty"](this["sDisabledIconSrc"])) {
		sIconSrc = this["sDisabledIconSrc"];
	} else {
		sIconSrc = bDown && bEnabled && !UCF_StringUtil["bIsEmpty"](this["sDownIconSrc"]) ? this["sDownIconSrc"] : this["sUpIconSrc"];
	}

	//_trace(INFO, '== Button id - ' + this.sId + ' - bEnabled: ' + bEnabled + '; bDown - ' + bDown + ';  sIconSrc: ' + sIconSrc);
	this["setIconSource"](sIconSrc, oImageDomRef);

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyIconSrc"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_Button["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onmouseup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Button.js(474): onmouseup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oBrowserEvent) === "object", "typeof(oBrowserEvent) === \"object\"", "Button.js(475): onmouseup"); };

	if (!this["bIsCurentControl"](oBrowserEvent)) return;
	if (__UCF_IE6__) {
		this["doMouseUp"]();
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onmouseup"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(492): onmouseover"); };
	// fired by mouse click

	window["status"] = '';
	if (!this["bEnabled"]) return;

	var oSourceControl = oBrowserEvent["oGetSourceControl"]();
	if (this !== oSourceControl) return;

	var bIsTouch = !oBrowserEvent["bIsMouseHover"]();
	this["applyHoverStyles"](!bIsTouch);
	this["applyFlatHoverStyles"](!bIsTouch, oBrowserEvent["oGetSource"]());

	if (__UCF_IE6__) {
		this["applyQuirksHoverStyles"](true, oBrowserEvent["oGetSource"]());
	}

	oBrowserEvent["oDomEvent"]["returnValue"] = true;
	if (window["UCF_System"]["bIs508"]) return;
	if (this["sText"] === this["sTooltip"]) return;

	// Check for the text with ellipsis
	var oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + '-caption');

	try {
		if (!this["sButtonTooltip"]) {
			// eslint-disable-next-line @ur/no-memory-leaks
			this["sButtonTooltip"] = this["oDomRef"]["title"];
		}
	} catch (oException) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sButtonTooltip"] = this["sTooltip"];
	}

	if (oDomRefOvfl) {
		UCF_DomUtil["checkTooltip"](this["oDomRef"], this["sButtonTooltip"], oDomRefOvfl);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onmouseover"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(538): ondblclick"); };

	if (!this["bEnabled"] || !this["mEvents"]["DoubleClick"]) return;

	if ((this["bHasPopupMenuSection"] && oBrowserEvent["oGetSource"]() !== this["oDomRef"]) ||
		(this["bHasPopupMenu"] && !this["bHasPopupMenuSection"])) {
		return; // no double click on menu part
	}

	if (this["oPopupMenu"] && this["oPopupMenu"]["bIsValid"]() && this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"](); // close opened menu by clicking on button
		this["toggleSectionButton"](false);
		this["oPopupMenu"] = null;
	}

	if (this["oDataTip"])
		this["oDataTip"]["close"]();

	this["fireDoubleClick"](this["sId"]);
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["ondblclick"] = 0; };
// D039230 : Handles F2 for double-click
/**
 * Handles the onkeydown event of the browser
 *
 *  [F2] - doubleClick for InplaceEdit
 *  [ALT] + [UP] - toggle the menu
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(571): onkeydown"); };

	var iKeyCode = oBrowserEvent["iKeyCode"]();
	/** @type {boolean} */
	var bAltOnly = oBrowserEvent["bAlt"]() && !oBrowserEvent["bShift"]() && !oBrowserEvent["bCtrl"]();

	if (iKeyCode === UCF_KeyCodes["F2"]) {
		this["ondblclick"](oBrowserEvent);
	} else if (iKeyCode === UCF_KeyCodes["ARROW_UP"] && bAltOnly) {
		this["toggleMenu"](oBrowserEvent, true);
	}

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onkeydown"] = 0; };

/**
 * Handles the onlsenter event on key down
 * [ENTER]
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(593): onlsenter"); };

	if (this["bIsCurentControl"](oBrowserEvent)) {
		//cancel the event, otherwise will generate a scroll down

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		this["applyDownStyles"](true);
		this["handleClick"](oBrowserEvent, true, true);
		if (this["bHasPopupMenu"])
			this["applyDownStyles"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsenter"] = 0; };

/**
 * Handles the onlsenter event on key down
 * [ENTER]
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onlsenterup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsenterup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(615): onlsenterup"); };

	if (this["bIsCurentControl"](oBrowserEvent)) {
		//cancel the event, otherwise will generate a scroll down

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		if (!this["bDown"])
			this["applyDownStyles"](false);
		return;
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsenterup"] = 0; };

/**
 * Handles the onlsspace event on key down
 * [SPACE]
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsspace"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(636): onlsspace"); };

	if (this["bIsCurentControl"](oBrowserEvent)) {
		//cancel the event, otherwise will generate a scroll down

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		if (oBrowserEvent["bRepeat"]()) {
			return;
		}
		this["applyDownStyles"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsspace"] = 0; };

/**
 * Handles the onlsspaceup event on key up
 * [SPACE]
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onlsspaceup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsspaceup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(658): onlsspaceup"); };
	if (!this["bIsCurentControl"](oBrowserEvent)) return;
	this["applyDownStyles"](false);

	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}

	this["handleClick"](oBrowserEvent, true, true);

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsspaceup"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * [ESCAPE] or [SHIFT] should remove the Down state
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onkeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onkeyup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(681): onkeyup"); };

	var iKeyCode = oBrowserEvent["iKeyCode"]();

	if (iKeyCode === UCF_KeyCodes["ESCAPE"] || iKeyCode === UCF_KeyCodes["SHIFT"]) {
		if (!this["bDown"])
			this["applyDownStyles"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onkeyup"] = 0; };

/**
 * Return true if the control from event is the same with the current Button
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 * @return {boolean} - true if the control from event is the curent control
 * @private
 */
UCF_Button["prototype"]["bIsCurentControl"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["bIsCurentControl"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(698): bIsCurentControl"); };
	if (!oBrowserEvent)
		return false;
	var oBrowserControl = oBrowserEvent["oGetSourceControl"]();
	if (!oBrowserControl)
		return false;

	if (this["bDefaultButton"] || (this["oLS"] && this["oLS"]["sActiveDefaultButtonIdForCtrlEnter"]))
		return true;
	if (oBrowserControl === this)
		return true;
	if (UCF_JsUtil["bInstanceOf"](oBrowserControl, 'UCF_RasterLayoutItem')
		&& oBrowserControl["oGetFirstChildControl"]() === this)
		return true;

	return false;
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["bIsCurentControl"] = 0; };

/**
 * Handles the click on the menu with keyboard or mouse
 *
 * @param {UCF_BrowserEvent} oBrowserEvent - the browser event object that occurred
 * @param {boolean} bWithKeyboard - true if the PopupMenu is opening with keyboard
 * @private
 */
UCF_Button["prototype"]["handleClick"] = function(oBrowserEvent, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["handleClick"]++; }; 

	if (!this["bIsCurentControl"](oBrowserEvent)) return;

	if (!this["bEnabled"]) return;

	// cancel event to avoid page scrolling in the browser
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

	if (this["oDataTip"])
		this["oDataTip"]["close"]();

	if (((this["bHasPopupMenuSection"]
				&& UCF_DomUtil["bContains"](this["oMenuSectionDomRef"], oBrowserEvent["oGetSource"]()))
			|| (this["bHasPopupMenu"] && !this["bHasPopupMenuSection"]))
		&& this["sType"] !== 'VARIANTMANAGEMENT') {
		this["toggleMenu"](oBrowserEvent, bWithKeyboard);
	} else {
		if (this["oPopupMenu"] && this["oPopupMenu"]["bIsValid"]() && this["oPopupMenu"]["bOpened"]) {
			this["oPopupMenu"]["close"](); // close opened menu by clicking on button
			this["toggleSectionButton"](false);
			this["oPopupMenu"] = null;
		}

		this["firePress"](this["sId"]);
		this["fireEvent"](this["E_EVENTS"]["Press"], { "sId": this["sId"] }); // used internally to notify RichTextEdit
	}

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["handleClick"] = 0; };

/**
 * Handles the onlsshow event
 *  [F4] or [ALT] + [DOWN]
 *  It should toggle the menu
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsshow"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(763): onlsshow"); };
	// fired by keyboard - F4 and Alt+cursor down
	this["toggleMenu"](oBrowserEvent, true);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsshow"] = 0; };

/**
 * Open menu
 *
 * @param {boolean} bWithKeyboard determines if popup was opened with keyboard or mouse
 * @public
 */
UCF_Button["prototype"]["openMenu"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["openMenu"]++; }; 

	if (!this["bHasPopupMenu"] || this["sPopupMenuId"] === '' || this["oGetControlById"](this["sPopupMenuId"]) == null) return;

	this["oPopupMenu"] = this["oGetControlById"](this["sPopupMenuId"], true);
	if (!this["oPopupMenu"] || (this["oPopupMenu"] && !UCF_JsUtil["bInstanceOf"](this["oPopupMenu"], 'UCF_PopupMenu'))) return;

	if (!this["bIsPointerCancelationEnabled"]) {
		this["oPopupMenu"]["setAutoRefocus"](true);
	} else
		this["oPopupMenu"]["setAutoRefocusOnKeyup"](true); //refocus this element if popup menu is closed
	this["toggleAriaMenuAttributes"]();
	if (this["oPopupMenu"]["bOpened"]) return;

	// when the Button has MenuSection, set the opener to the root element in order
	// to avoid the close event from PopupMenu
	var oToolbarOpener = this["bHasPopupMenuSection"] ? UCF_DomUtil["$"](this["sId"] + '-sectionRoot') : null;
	var oOpenerDomRef = this["bHasPopupMenuSection"] ? (oToolbarOpener ? oToolbarOpener : this["oRootRef"]) : this["oDomRef"],
		sOpenerId = this["bHasPopupMenuSection"] ? this["sId"] + '-r' : this["sId"];

	this["oPopupMenu"]["setOpenerRef"](oOpenerDomRef);
	this["oPopupMenu"]["setOpenerId"](sOpenerId);
	this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);

	if (!this["bDelegateOpenMenu"]) {
		this["oPopupMenu"]["open"](bWithKeyboard); //bWithKeyboard=true --> opened by keyboard --> select first entry
		this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, 'onPopupMenuClose');
		this["toggleSectionButton"](true);
	} else {
		this["fireEvent"](this["E_EVENTS"]["OpenMenu"], { "sId": this["sId"], "sMenuId": this["sPopupMenuId"] });
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["openMenu"] = 0; };

/**
 * Handles the onmouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onmouseout"]++; }; 

	if (!this["bEnabled"]) return;

	var oSourceControl = oBrowserEvent["oGetSourceControl"]();
	if (this !== oSourceControl) return;
	// remove the hover styles
	this["applyHoverStyles"](false);
	this["applyFlatHoverStyles"](false);

	if (__UCF_IE6__) {
		this["applyQuirksHoverStyles"](false, oBrowserEvent["oGetSource"]());
		this["doMouseUp"]();
	}

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onmouseout"] = 0; };

/**
 * Toggle menu
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @param {boolean} bWithKeyboard - determines if popup was opened with keyboard or mouse
 * @private
 */
UCF_Button["prototype"]["toggleMenu"] = function(oBrowserEvent, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["toggleMenu"]++; }; 
	if (!this["bEnabled"]) return;
	if (!this["bHasPopupMenu"]) return;

	if (oBrowserEvent) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
	//used for loading on demand menu - fire only event if PopupMenu doesn't exists or isn't valid (e.g. caused by popupMenu.setRemoveOnClose(true))
	if (this["sPopupMenuId"] === '' || this["oGetControlById"](this["sPopupMenuId"]) == null) { //|| (this.oPopupMenu && !this.oPopupMenu.bIsValid())) {
		this["fireMenuAccess"](this["sId"], this["sPopupMenuId"]);
		return;
	}

	this["oPopupMenu"] = this["oGetControlById"](this["sPopupMenuId"], true);

	if (this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"]();
		this["oPopupMenu"] = null;
	} else {
		this["fireMenuAccess"](this["sId"], this["sPopupMenuId"]);
		this["openMenu"](bWithKeyboard);
	}

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["toggleMenu"] = 0; };

/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @param {UCF_BrowserEvent} oEvent  when the menu is closed
 * @private
 */
UCF_Button["prototype"]["onPopupMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onPopupMenuClose"]++; }; 

	if (this["oPopupMenu"] && this["bHasPopupMenu"]) {
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, 'onPopupMenuClose');
	}
 	this["toggleAriaMenuAttributes"]();
	this["toggleSectionButton"](false);

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onPopupMenuClose"] = 0; };

/**
 * Set enabled
 *
 * @param {boolean} bEnabled the new enabled value
 * @public
 */
UCF_Button["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setEnabled"]++; }; 
	if (this["bEnabled"] === bEnabled) return;

	// eslint-disable-next-line @ur/no-memory-leaks
	this["bEnabled"] = bEnabled;

	if (__UCF_IE6__) {
		this["applyQuirksEnabledStyles"](bEnabled);
	}
	if (!__UCF_IE6__) {
		this["applyEnabledStyles"](bEnabled);
	}

	if (bEnabled) {

		if (!window["UCF_System"]["bIs508"]) {
			UCF_DomUtil["setTabIndex"](this["oDomRef"], '0');
			this["oDomRef"]["removeAttribute"]('hideFocus');
		}
		//D039230 - set this.oFocusDomRef in order to be announced as focusable in Toolbar
		this["oFocusDomRef"] = this["oDomRef"];
	} else {

		if (!window["UCF_System"]["bIs508"]) {
			UCF_DomUtil["resetTabIndex"](this["oDomRef"]);
			this["oDomRef"]["setAttribute"]('hideFocus', '-1');
		}
		//D039230 - set this.oFocusDomRef to null in order to be announced as not focusable in Toolbar
		this["oFocusDomRef"] = null;
	}

	this["setClientProperty"]("Enabled", this["bEnabled"], true);

	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setDisabled"](this["oDomRef"], !this["bEnabled"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setEnabled"] = 0; };

/**
 * Returns the enabled state
 * @return {boolean} - true if the button is enabled
 * @public
 */
UCF_Button["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["getEnabled"]++; }; 
	return this["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["getEnabled"] = 0; };

/**
 * Set ID of the popup menu connected to the button. Cleans up a previous existing popup menu
 *
 * @param {string} sPopupMenuId ID of popup menu
 * @public
 */
UCF_Button["prototype"]["setPopupMenuId"] = function(sPopupMenuId) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setPopupMenuId"]++; }; 
	if (this["oPopupMenu"] && this["oPopupMenu"]["sId"] !== sPopupMenuId) {
		//clenup an existing PopupMenu object to be able to create a new one
		if (this["oPopupMenu"]["bIsValid"]() && this["oPopupMenu"]["bOpened"]) this["oPopupMenu"]["close"]();
		this["oPopupMenu"] = null;
	}
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sPopupMenuId"] = sPopupMenuId;
	this["setClientProperty"]("PopupMenuId", this["sPopupMenuId"], true);

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setPopupMenuId"] = 0; };

/**
 * Get ID of the popup menu connected to the button.
 *
 * @return {string} sPopupMenuId ID of popup menu
 * @public
 */
UCF_Button["prototype"]["sGetPopupMenuId"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetPopupMenuId"]++; }; 
	return this["sPopupMenuId"];
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetPopupMenuId"] = 0; };

/**
 * Changes the visualization of the button to a default button
 *
 * @param {boolean} bDefault Specifies whether the button is marked as a default button or not
 * @private
 */
UCF_Button["prototype"]["setIsDefaultButton"] = function(bDefault) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setIsDefaultButton"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bDefault) === "boolean", "typeof(bDefault) === \"boolean\"", "Button.js(966): setIsDefaultButton"); };

	var sDefaultButtonShortCut = '(' + this["oLS"]["sGetText"]('SAPUR_MODIFIER_CTRL') + '+' + this["oLS"]["sGetText"]('SAPUR_ENTER_KEY') + ')';
	var sDefaultButtonTooltip = this["sTooltip"]
		? this["sTooltip"] + ' ' + sDefaultButtonShortCut
		: sDefaultButtonShortCut;

	// eslint-disable-next-line @ur/no-memory-leaks
	this["bDefaultButton"] = bDefault;
	this["oLS"]["sActiveDefaultButtonIdForCtrlEnter"] = this["sId"];

	if ((this["sHotkey"] === 'NONE' || this["sHotkey"] === 'undefinded')
		// && !this.sAccessKey
		&& !UCF_StringUtil["bContains"](this["sTooltip"], sDefaultButtonShortCut)
	) {
		// set tooltip + (Ctrl+Enter)
		this["setTooltip"](sDefaultButtonTooltip);
	}

	if (!this["bEnabled"]) return;
	this["applyDefaultStyles"](bDefault);

	if (window["UCF_System"]["bIsAria"]) {
		if (bDefault) {
			// can't remove because some controls use bIgnoreDefaultButton
			// so that the default button gets disabled
			UCF_AriaStateHelper["setRoleDescription"](this["oDomRef"], this["oLS"]["sGetText"]('SAPUR_B_DEFAULT') || 'Default button');
		}
	}

	if (__UCF_IE6__) {
		this["applyQuirksDefaultStyles"](bDefault);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setIsDefaultButton"] = 0; };

/** Sets the sSemanticColor
 * @param {string} sSemanticColor
 * @public
 */
UCF_Button["prototype"]["setSemanticColor"] = function(sSemanticColor) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setSemanticColor"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSemanticColor) === "string", "typeof(sSemanticColor) === \"string\"", "Button.js(1006): setSemanticColor"); };
	var sOldSemanticColor = this["sSemanticColor"];
	this["sSemanticColor"] = sSemanticColor;
	this["setClientProperty"]("SemanticColor", this["sSemanticColor"], true);

	//TODO: replace by UCF_DomUtil.firstChildByClassName(this.oDomRef,"lsBtnSemanticColor"); to make it more error friendly

	var oSemanticDomRef = UCF_DomUtil["$"](this["sId"] + '-img');
	if (!oSemanticDomRef) return;

	UCF_DomUtil["removeClass"](oSemanticDomRef, this["sGetSemanticColorClass"](sOldSemanticColor));
	UCF_DomUtil["addClass"](oSemanticDomRef, this["sGetSemanticColorClass"](this["sSemanticColor"]));
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setSemanticColor"] = 0; };

/**
 * Returns the SemanticColor
 * @return {string} the sSemanticColor
 * @public
 */
UCF_Button["prototype"]["getSemanticColor"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["getSemanticColor"]++; }; 
	return this["sSemanticColor"];
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["getSemanticColor"] = 0; };

/**
 * Set the SemanticColor for the
 * @param {string} sSemanticColor - the semanticColor set via API
 * @return {Object} -
 */
UCF_Button["prototype"]["sGetSemanticColorClass"] = function(sSemanticColor) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetSemanticColorClass"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'UrBase_sSemanticColor',
		'UrBase', { "SemanticColor": sSemanticColor }
	);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetSemanticColorClass"] = 0; };

/**
 * Sets the sImage
 * @public
 * @param {string} sImage
 */
UCF_Button["prototype"]["setUpIconSrc"] = function(sImage) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setUpIconSrc"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sImage) === "string", "typeof(sImage) === \"string\"", "Button.js(1047): setUpIconSrc"); };

	if ((!this["bDown"] || this["sDownIconSrc"] === '') && this["sType"] === 'NONE') {
		this["setIconSource"](sImage);
	}

	this["sUpIconSrc"] = sImage;
	this["setClientProperty"]("UpIconSrc", this["sUpIconSrc"], true);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setUpIconSrc"] = 0; };

/** Returns the UpIconSrc
 * @public
 * @return {string} Returns the UpIconSrc
 */
UCF_Button["prototype"]["getUpIconSrc"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["getUpIconSrc"]++; }; 
	return this["sUpIconSrc"];
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["getUpIconSrc"] = 0; };

/**
 * Returns the up state.
 * @private
 * @return {boolean} Returns the up
 */
UCF_Button["prototype"]["getUp"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["getUp"]++; }; 
	return this["bUp"];
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["getUp"] = 0; };

/**
 * Returns the down state.
 * @public
 * @return {boolean} Returns the down state
 */
UCF_Button["prototype"]["getDown"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["getDown"]++; }; 
	return this["bDown"];
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["getDown"] = 0; };

/**
 * Returns the down state.
 * @param {boolean} bDown the new enabled value
 * @public
 */
UCF_Button["prototype"]["setDown"] = function(bDown) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setDown"]++; }; 

	if (this["bDown"] === bDown) return;
	// should not apply the down state twice
	if (__UCF_IE6__) {
		this["applyQuirksDownStyles"](bDown);
	}
	if (!__UCF_IE6__) {
		this["applyDownStyles"](bDown);
	}

	// eslint-disable-next-line @ur/no-memory-leaks
	this["bDown"] = bDown;
	this["setClientProperty"]("Down", this["bDown"], true);
	if (window["UCF_System"]["bIsAria"]) {
		//set down for all type of buttons so that the screen reader should
		//annouce it; but it'l be announced always as Toggle button
		UCF_AriaStateHelper["setPressed"](this["oDomRef"], this["bDown"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setDown"] = 0; };

/**
 * Sets the Tooltip text for the Button control.
 * The Tooltip will be shown if the mouse hovers over the control.
 * In case that screenreader support is turned on, text will automatically be
 * added to the tooltip to support 508 features.
 * @public
 * @param {string} sTooltip
 */
UCF_Button["prototype"]["setTooltip"] = function(sTooltip) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setTooltip"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTooltip) === "string", "typeof(sTooltip) === \"string\"", "Button.js(1118): setTooltip"); };
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sTooltip"] = sTooltip;
	this["setClientProperty"]("Tooltip", this["sTooltip"], true);

	var sHotkeyTooltip = '';
	if (this["sHotkey"] && (this["sHotkey"] !== 'NONE' || this["sHotkey"] !== 'undefinded')) {
		sHotkeyTooltip = this["sGetHotkeyString"]();
	}

	var sTitle = (sHotkeyTooltip !== '' && sTooltip !== '')
		? (sTooltip + ' ' + sHotkeyTooltip)
		: (sTooltip + '' + sHotkeyTooltip);

	if (sTitle !== '') {
		this["sButtonTooltip"] = sTitle;
		UCF_DomUtil["setTooltip"](this["oDomRef"], sTitle);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setTooltip"] = 0; };

/**
 * @return {string} the hotkey tooltip string
 */
UCF_Button["prototype"]["sGetHotkeyString"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetHotkeyString"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'UrBase_sHotkeyTooltip',
		'UrBase', { "Hotkey": this["sHotkey"] }
	);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetHotkeyString"] = 0; };

/**
 * Returns the Tooltip text for the Button control.
 * The Tooltip will be shown if the mouse hovers over the control.
 * In case that screenreader support is turned on, text will automatically be
 * added to the tooltip to support 508 features.
 * @public
 * @return {string} Returns the Tooltip
 */
UCF_Button["prototype"]["getTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["getTooltip"]++; }; 
	return this["sTooltip"];
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["getTooltip"] = 0; };

/**
 * Returns the Caption of the Button control.
 * @public
 * @return {string} Returns the Text
 *
 */
UCF_Button["prototype"]["getText"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["getText"]++; }; 
	if (this["sContentVisibility"] === 'ICON') {
		return this["sText"];
	}
	var oCaptionDomRef = UCF_DomUtil["$"](this["sId"] + '-caption'),
		oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-txt'),
		sTitle;
	if (oCaptionDomRef)
		sTitle = UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](oCaptionDomRef));
	else if (oTextDomRef)
		sTitle = UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](oTextDomRef));
	else if (window["UCF_System"]["sDevice"] === 'standards') {
		sTitle = '';
	} else
		sTitle = UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](this["oDomRef"]));

	return sTitle;

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["getText"] = 0; };

/**
 * Notify the Toolbar for changes
 * @private
 */
UCF_Button["prototype"]["notifyToolbarForChanges"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["notifyToolbarForChanges"]++; }; 

	var oParent = this["oGetParent"]();
	if (oParent && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_Toolbar_standards')) {
		oParent["onContentChange"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["notifyToolbarForChanges"] = 0; };

/**
 * @private
 * @param { string } sVisibility For the parameter values see enumeration 'Visibility'.
 *
 */
UCF_Button["prototype"]["adaptButtonRowForChanges"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["adaptButtonRowForChanges"]++; }; 
	var oParent = this["oGetParent"]();
	if (oParent && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_ButtonRow')) {
		var oParentDomRef = UCF_DomUtil["oGetParentElement"](this["oDomRef"]);
		UCF_DomUtil["setVisibility"](oParentDomRef, sVisibility);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["adaptButtonRowForChanges"] = 0; };

/**
 * Sets the visibility of the Button control. For the parameter values see enumeration 'Visibility'.
 * @public
 * @param {string} sVisibility For the parameter values see enumeration 'Visibility'.
 */
UCF_Button["prototype"]["setVisibility"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setVisibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sVisibility) === "string", "typeof(sVisibility) === \"string\"", "Button.js(1217): setVisibility"); };
	UCF_Control.prototype["setVisibility"]["apply"](this, arguments);
	if (this["oPopupMenu"] && this["oPopupMenu"]["bIsValid"]() && this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"](); //close opened menu by clicking on button
	}
	this["notifyToolbarForChanges"]();
	this["adaptButtonRowForChanges"](sVisibility);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setVisibility"] = 0; };

/**
 * Returns the visibility of the Button control. For the parameter values see enumeration 'Visibility'.
 * @public
 * @return {string}  Returns the Visibility
 *
 */
UCF_Button["prototype"]["getVisibility"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["getVisibility"]++; }; 

	if (UCF_DomUtil["sGetCurrentStyle"](this["oRootRef"], 'visibility') === 'hidden') {
		return 'BLANK';
	} else {
		if (UCF_DomUtil["sGetCurrentStyle"](this["oRootRef"], 'display') === 'none') {
			return 'NONE';
		} else {
			return 'VISIBLE';
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["getVisibility"] = 0; };

/**
 * Checks if the control is currently visible.
 *
 * @return {boolean} Whether the control has a valid DOM reference
 */
UCF_Button["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["bIsVisible"]++; }; 
	if (!this["bIsValid"]()) return false;
	if (!UCF_DomUtil["bIsVisible"](this["oRootRef"], true)) {
		var oParent = this["oGetParent"]();
		if (this["bIsHiddenToolbarButton"](oParent)) {
			return true;
		} else
			return false;
	}

	return true;
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["bIsVisible"] = 0; };

/**
 * implements method from UCF_Control
 * @private
 */
UCF_Button["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["createDragDelegate"]++; }; 

	if (!this["sDragSourceInfo"])
		return;

	if (this["oDragDelegate"])
		return;

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_ButtonDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["createDragDelegate"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Button["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Button.js(1287): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		sCt = 'B',
		sTutor = null,
		sText = UCF_StringUtil["sTrim"](this["sGetText"]()),
		sTooltip = UCF_StringUtil["sTrim"](this["sTooltip"]);

	oAccessibilityHelper["setText"](sText);

	if (sText !== sTooltip)
		oAccessibilityHelper["setTooltip"](sTooltip);

	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

	if (this["bEnabled"]) {
		oAccessibilityHelper["setHotkey"](this["sHotkey"]);
		oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
	}

	// announce the button as toggle button, if design is toggle
	if (this["sDesign"] === 'TOGGLE') sCt = 'TGB';

	if (this["bHasPopupMenuSection"]) {
		sCt = 'B_MNU';
		if (this["mEvents"]["Press"]) sTutor = 'B_MNUSEC_TUT';
		else sTutor = 'MENU_TUT';
	} else if (this["bHasPopupMenu"]) {
		sCt = 'B_MNU';
		sTutor = 'MENU_TUT';
	} else if (this["sDesign"] === 'TOGGLE') {
		oAccessibilityHelper["setToggled"](this["bDown"]);
		oAccessibilityHelper["setNotToggled"](!this["bDown"]);
		sTutor = 'TGL_TUT';
	} else if (this["bDown"] || this["bUp"]) {
		oAccessibilityHelper["setNotPressed"](this["bUp"]);
		oAccessibilityHelper["setPressed"](this["bDown"]);
		sTutor = 'B_TUT';
	} else {
		// D039230 : Handles F2 for double-click; acc message
		// if doubleClickInfo.enabled='true' & pressInfo.enabled='false'
		if (this["mEvents"]["DoubleClick"] && !this["mEvents"]["Press"]) sTutor = 'B_F2_TUT';
		else sTutor = 'B_TUT';
	}

	if (this["bIsButtonType"]()) {
		//Icon buttons announce their function as text. The control type has to be reseted to 'Button'
		sCt = 'B';
	}

	if (sCt) oAccessibilityHelper["setControlType"](sCt);
	if (sTutor) oAccessibilityHelper["addEnabledTutor"](sTutor, this["bEnabled"]);

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onlsaccessibility"] = 0; };

/***###########################################################################***/
/***################ Added for handling of item overflow ####################***/
/***###########################################################################***/

/**
 * @param {boolean} bDelegate
 * @private
 */
UCF_Button["prototype"]["setDelegateOpenMenu"] = function(bDelegate) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setDelegateOpenMenu"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bDelegateOpenMenu"] = bDelegate;
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setDelegateOpenMenu"] = 0; };

/**
 * @see UCF_Control#focus
 * @override
 */
UCF_Button["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["focus"]++; }; 

	var oParent = this["oGetParent"]();
	if (oParent && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_Toolbar') && this["bIsHiddenToolbarButton"](oParent)) {
		oParent["setFocusFromHiddenItem"](true);
		oParent["moveFocus"]();
	} else if (oParent && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_SegmentedButton') && this["bIsHiddenToolbarButton"](oParent)) {
		oParent["focusParent"]();
	} else {
		UCF_Control.prototype["focus"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["focus"] = 0; };

/**
 * Return true if the button is hidden in toolbar
 * @param {Object} oParent - The Toolbar control
 * @return {boolean} - true if the button is hidden in toolbar
 * @private
 */
UCF_Button["prototype"]["bIsHiddenToolbarButton"] = function(oParent) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["bIsHiddenToolbarButton"]++; }; 
	if (oParent && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_SegmentedButton')) {
		return oParent["bIsHiddenToolbarButton"]();
	}
	if (oParent && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_Toolbar')) {
		return !oParent["bIsVisibleItem"](this["oRootRef"]);
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["bIsHiddenToolbarButton"] = 0; };

/**
 * Returns the button tooltip
 * @return {string} - the button tooltip
 * @private
 */
UCF_Button["prototype"]["sGetTitle"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetTitle"]++; }; 
	return this["getText"]();
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetTitle"] = 0; };

/**
 * Returns the text on the button or an alternative text for icon buttons
 * to use them for ACC or inside of overflow menus
 * @return {string}
 * @private
 */
UCF_Button["prototype"]["sGetText"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetText"]++; }; 
	var bIconButton = this["bIsButtonType"](),
		sText = this["sGetTitle"]();

	sText = !bIconButton || !UCF_StringUtil["bIsEmpty"](sText)
		? sText
		: UCF_KeyboardHelper["sGetText"](this["oLS"], 'BTNTYP_' + this["sType"]);
	return UCF_StringUtil["bIsEmpty"](sText) ? ' ' : sText;
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetText"] = 0; };

/**
 * Return true if it is an icon button
 * @return {boolean}
 * @private
 */
UCF_Button["prototype"]["bIsButtonType"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["bIsButtonType"]++; }; 
	return this["sType"] !== 'NONE';
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["bIsButtonType"] = 0; };

/**
 * Check if the Image DomRef has the fontIcon class
 * Used in Toolbar, for creating the PopupMenuItem
 * @return {boolean} true if the button has the fon icon class in the src
 * @private
 */
UCF_Button["prototype"]["bHasCssIcon"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["bHasCssIcon"]++; }; 
	var bCssIcon = false;
	if (this["sType"] === 'NONE') {
		var oIconRef = UCF_DomUtil["$"](this["sId"] + '-img');
		if (oIconRef)
			bCssIcon = UCF_DomUtil["bHasClass"](oIconRef, 'lsControl--fontIcon');
	}

	return this["sType"] !== 'NONE' || bCssIcon;
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["bHasCssIcon"] = 0; };

/**
 * Returns the icon source
 *
 * @param {HTMLElement} oIconRef
 * @return {string}
 * @private
 */
UCF_Button["prototype"]["sGetIconSource"] = function(oIconRef) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetIconSource"]++; }; 
	if (!oIconRef) oIconRef = UCF_DomUtil["$"](this["sId"] + '-img');
	if (!oIconRef && this["sContentVisibility"] === 'TEXT')
		return this["getUpIconSrc"]();
	if (oIconRef && oIconRef["tagName"] === 'svg')
		return this["getUpIconSrc"]();
	else
		return UCF_ImageUtil["sGetImageSource"](oIconRef);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetIconSource"] = 0; };

/**
 * Sets the icon source
 *
 * @param {string} sIconSrc
 * @param {HTMLElement} oIconRef
 * @private
 */
UCF_Button["prototype"]["setIconSource"] = function(sIconSrc, oIconRef) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setIconSource"]++; }; 
	/** @type {UCF_RenderManager} */
	var oRenderManager;
	if (this["sCurrentSrc"] === sIconSrc) return;

	if (!oIconRef)
		oIconRef = UCF_DomUtil["$"](this["sId"] + '-img');
	if (oIconRef) {
		oRenderManager = this["oLS"]["oGetRenderManager"]();
		this["renderButtonImage"](sIconSrc, oRenderManager);

		UCF_DomUtil["replaceElement"](
			oIconRef,
			oRenderManager["oGetElementFromHtml"]()
		);
		oRenderManager["clearBuffer"]();

		this["sCurrentSrc"] = sIconSrc;
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setIconSource"] = 0; };

/**
 * @private
 * @param {string} sIconSrc the icon src
 * @param {UCF_RenderManager} oRenderManager the render manager
 */
UCF_Button["prototype"]["renderButtonImage"] = function(sIconSrc, oRenderManager) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["renderButtonImage"]++; }; 
	oRenderManager["write"](this["oLS"]["oGetRenderManager"]()["callFragment"](
		'ButtonIconTypeFragment',
		'Button', {
			"Text": this["sText"],
			"ImageFirst": this["bImageFirst"],
			"ImageSrc": sIconSrc,
			"ImageAlt": '',
			"RenderAsDisabled": this["bEnabled"] === false,
			"FixedHeight": false,
			"Type": 'NONE',
			"Id": this["sId"],
			"TextOverflow": false,
			"Height": ''
		}
	));
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["renderButtonImage"] = 0; };

/**
 * get the Button type class
 * @return {Object} -
 */
UCF_Button["prototype"]["sGetButtonTypeClass"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetButtonTypeClass"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'ButtonTypeClassFragment',
		'Button', { "Type": this["sType"] }
	);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetButtonTypeClass"] = 0; };

/**
 * Returns the image class of an icon button for the overflow menu in the toolbar
 * In RTE, for sap_belize the buttons are using font-icons
 * @return {string} - the css class
 * @private
 */
UCF_Button["prototype"]["sIconButtonClass"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["sIconButtonClass"]++; }; 
	if (this["sType"] === 'NONE') {
		var oIconRef = UCF_DomUtil["$"](this["sId"] + '-img');
		if (oIconRef) {
			return UCF_DomUtil["sGetClass"](oIconRef);
		}
	}

	var sP = 'lsControl--fontIcon lsButton--type-icon lsBtnTypeDspl ',
		sS = this["bEnabled"] ? '' : ' urImgDsbl';
	var sButtonTypeclass = this["sGetButtonTypeClass"]();
	return sP + sButtonTypeclass + sS;
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["sIconButtonClass"] = 0; };

/**
 * Start InplaceEdit in delayed double click or F2
 * when the Button has Caption with Editable:true
 * @param {Object} oParams
 * @private
 */
UCF_Button["prototype"]["onInplaceEditStart"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onInplaceEditStart"]++; }; 

	var oBrowserEvent = oParams["mParameters"]["oBrowserEvent"],
		oSource = oBrowserEvent && oBrowserEvent["oGetSourceControl"](),
		oSourceTitle = oSource && UCF_DomUtil["$"](oSource["sId"] + '-caption'),
		oTitle = UCF_DomUtil["$"](this["sId"] + '-caption'),
		sTitle = UCF_StringUtil["sTrim"](UCF_InplaceEditDelegate["sGetInnerText"](oTitle));

	if (oSourceTitle && oSourceTitle !== oTitle) return;
	/*if (this.sImageSrc && this.bImageFirst)
	{
		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
		oBoundaries.left += this.oDomRef.firstChild.offsetWidth + 3;
	}*/

	this["oInplaceEditDelegate"]["setInplaceEditData"](
		this["oDomRef"],
		UCF_DomUtil["oGetObjectRect"](oTitle),
		sTitle
	);

};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onInplaceEditStart"] = 0; };

/**
 * Called when Inplace Edit is finished
 * @param {Object} oParams
 */
UCF_Button["prototype"]["onInplaceEditFinished"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onInplaceEditFinished"]++; }; 
	/** @type {UCF_UrBase} */
	var UrBase = new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(undefined, this["oLS"]);

	var oText = UCF_DomUtil["$"](this["sId"] + '-caption'),
		sTextWithAccessKey;

	var sText = oParams["oGetParam"]('sText');
	if (sText === this["getText"]()) return;

	if (window["UCF_System"]["sDevice"] === 'standards') {
		sTextWithAccessKey = UrBase["sAccessKeyTextFragment"](sText, this["sAccessKey"]);
		if (oText)
			UCF_DomUtil["setInnerHtml"](oText, UCF_XSSEncoder["encodeHTML"](sTextWithAccessKey));
	} else
		UCF_InplaceEditDelegate["setInnerText"](oText, sText);

	if (window["UCF_System"]["bIsAria"]) {
		//change -arialabel text
		UCF_DomUtil["$"](this["sId"] + '-arialabel')["textContent"] = sText + ' ' + this["sTooltip"] + ' ' + this["oLS"]["sGetText"]('SAPUR_ACR_EDIT_TITLE') + ' ' + this["oLS"]["sGetText"]('SAPUR_ACR_LOCK_TITLE');
	}

	// eslint-disable-next-line @ur/no-memory-leaks
	this["sText"] = sText;
	this["setClientProperty"]("Text", this["sText"], true);
	this["fireChange"](this["sId"], sText);
	this["oFocusDomRef"] = this["oDomRef"];
	UCF_DomUtil["focusDomElement"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onInplaceEditFinished"] = 0; };

/**
 * Perform the action after Inplace Edit is finished
 */
UCF_Button["prototype"]["onInplaceEditClosed"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["onInplaceEditClosed"]++; }; 
	UCF_DomUtil["focusDomElement"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["onInplaceEditClosed"] = 0; };

/**
 * Perfom destroy
 */
UCF_Button["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["destroy"]++; }; 

	var oInplaceEditDelegate = this["oInplaceEditDelegate"];
	if (oInplaceEditDelegate) {
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this);
		this["oInplaceEditDelegate"]["destroy"]();
		this["oInplaceEditDelegate"] = null;
	}

	this["oPopupMenu"] = null;
	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	this["sMainClassName"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sSemanticColor"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sUpIconSrc"] = null;
	this["sButtonTooltip"] = null;
	this["sCurrentSrc"] = null;
	this["oMenuSectionDomRef"] = null;
	this["eCurrentEventState"] = null;
	this["bIsPointerCancelationEnabled"] = null;
	this["bIsDownBeforeUp"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["destroy"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 * @return {UCF_HTMLElement}
 */
UCF_Button["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["oGetInplaceEditDomRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + '-caption') || this["oDomRef"]["getElementsByTagName"]('SPAN')[0];
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["oGetInplaceEditDomRef"] = 0; };

/**
 *  Sets the text typed in InplaceEdit field
 * @param {string} sText - the text typed
 * @return {string} - the text for inplaceedit
 * @see UCF_Control.sGetInplaceEditText
 */
UCF_Button["prototype"]["sGetInplaceEditText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetInplaceEditText"]++; }; 
	return this["getClientProperty"]("Text") || this["sText"];
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetInplaceEditText"] = 0; };

/**
 * Sets the text typed in InplaceEdit field
 * @param {string} sText - the text typed
 * @see UCF_Control.setInplaceEditDomRef
 */
UCF_Button["prototype"]["setInplaceEditText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setInplaceEditText"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sText"] = sText;
	this["setClientProperty"]("Text", sText);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setInplaceEditText"] = 0; };

/**
 * @see UCF_DTExtension
 * @param {UCF_HTMLElement} oDTElement the lsaccessibility
 * @return {UCF_DTExtesion} the control specific DTExtension and instance of the base class UCF_DTExtesion
 * @private
 */
UCF_Button["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["oGetDTExtension"]++; }; 
	return UCF_Control.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]("UCF_ButtonDTExtension"));
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["oGetDTExtension"] = 0; };

/**
 * Activates native browser dragging by setting draggable attribute
 *
 * @private
 */
UCF_Button["prototype"]["setDraggable"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setDraggable"]++; }; 
	if (this["sDragSourceInfo"]) {
		var oDragSourceInfo = this["oLS"]["oControlFactory"]["oGetControlById"](this["sDragSourceInfo"]);
		if (oDragSourceInfo && oDragSourceInfo["bBrowserDragDrop"]) {
			this["bDraggable"] = true;
			this["oRootRef"]["setAttribute"]('draggable', true);
			this["oRootRef"]["setAttribute"]('iDDThreshold', 10000);
			//IE does not fire dragstart even draggable attribute is set
			if (UCF_UserAgent["bIsIE"]()) {
				this["oRootRef"]["setAttribute"]('href', 'javascript:void(0);');
			}
			this["oRootRef"]["ondragstart"] = null;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setDraggable"] = 0; };

/**
 * Add the Text on the ContextMenu
 * @return {Object}
 * @private
 */
UCF_Button["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	var oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-caption');
	if (UCF_DomUtil["bHasTextEllipsis"](this["oDomRef"], oTextDomRef)) {
		aResult["push"]({
			"sType": 'TEXT',
			"sText": this["getText"]()
		});
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["aGetTouchContextMenuEntries"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_Button["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
		}
	}
	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["bPrepareAria"] = 0; };

if (__UCF_IE6__) {

	/**
	 * Retrieve the current main class, according to the design
	 * @return {string}
	 * @private
	 */
	UCF_Button["prototype"]["sGetMainClass"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetMainClass"]++; }; 
		var sMainClass = 'urBtnStd';
		switch (this["sDesign"]) {
			case 'EMPHASIZED': {
				sMainClass = 'urBtnEmph';
				break;
			}
			case 'PREVIOUS': {
				sMainClass = 'urBtnStdPrevStep';
				break;
			}
			case 'NEXT': {
				sMainClass = 'urBtnStdNextStep';
				break;
			}
			case 'TOGGLE': {
				sMainClass = 'urBtnTgl';
				break;
			}

		}
		return sMainClass;
	};;if (__UCF_COVERAGE__) { UCF_Button["_"]["sGetMainClass"] = 0; };

	/**
	 *  Apply Buttons styles according with the new enabled status
	 *
	 * @param {boolean} enabled - the new enabled status
	 * @private
	 */
	UCF_Button["prototype"]["applyQuirksEnabledStyles"] = function(enabled) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyQuirksEnabledStyles"]++; }; 
		if (window["UCF_System"]["sDevice"] === 'standards') return;
		var sOldSuffix = (enabled ? 'Dsbl' : ''),
			sNewSuffix = (enabled ? '' : 'Dsbl');

		var oImageDomRef = UCF_DomUtil["$"](this["sId"] + '-img');
		if (this["sMainClassName"] == null)
			// eslint-disable-next-line @ur/no-memory-leaks
			this["sMainClassName"] = this["sGetMainClass"]();

		UCF_DomUtil["replaceClass"](this["oDomRef"], this["sMainClassName"] + sOldSuffix, this["sMainClassName"] + sNewSuffix);
		//Enable MenuIcon hasPopupMenu=true && hasPopupMenuSection=false
		var oMenuDomRef = UCF_DomUtil["$"](this["sId"] + '-MnuIco');
		var oBtnDesignTxt, oBtnDesignImg;
		if (oMenuDomRef)
			UCF_DomUtil["replaceClass"](oMenuDomRef, 'urBtnMnuIco' + sOldSuffix, 'urBtnMnuIco' + sNewSuffix);

		switch (this["sDesign"]) {
			case 'EMPHASIZED': {
				break;
			}
			case 'PREVIOUS': {
				oBtnDesignTxt = UCF_DomUtil["$"](this["sId"] + '-txt');
				oBtnDesignImg = UCF_DomUtil["$"](this["sId"] + '-btnDesign');
				if (oBtnDesignImg) {
					if (enabled)
						UCF_DomUtil["replaceClass"](oBtnDesignImg, 'lsBtnPrevDsblImg', 'lsBtnPrevImg');
					else
						UCF_DomUtil["replaceClass"](oBtnDesignImg, 'lsBtnPrevImg', 'lsBtnPrevDsblImg');
				}
				if (oBtnDesignTxt)
					UCF_DomUtil["replaceClass"](oBtnDesignTxt, 'urBtnCnt' + sOldSuffix, 'urBtnCnt' + sNewSuffix);
				break;
			}
			case 'NEXT': {
				oBtnDesignTxt = UCF_DomUtil["$"](this["sId"] + '-txt');
				oBtnDesignImg = UCF_DomUtil["$"](this["sId"] + '-btnDesign');
				if (oBtnDesignImg) {
					if (enabled)
						UCF_DomUtil["replaceClass"](oBtnDesignImg, 'lsBtnNextDsblImg', 'lsBtnNextImg');
					else
						UCF_DomUtil["replaceClass"](oBtnDesignImg, 'lsBtnNextImg', 'lsBtnNextDsblImg');
				}
				if (oBtnDesignTxt)
					UCF_DomUtil["replaceClass"](oBtnDesignTxt, 'urBtnCnt' + sOldSuffix, 'urBtnCnt' + sNewSuffix);
				break;
			}
			case 'TOGGLE': {
				if (this["bDown"]) {
					UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnTglD' + sOldSuffix, 'urBtnTglD' + sNewSuffix);
					oBtnDesignTxt = UCF_DomUtil["$"](this["sId"] + '-txt');
					if (oBtnDesignTxt)
						UCF_DomUtil["replaceClass"](oBtnDesignTxt, 'urBtnCntD' + sOldSuffix, 'urBtnCntD' + sNewSuffix);
				} else {
					UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnTgl' + sOldSuffix, 'urBtnTgl' + sNewSuffix);
					oBtnDesignTxt = UCF_DomUtil["$"](this["sId"] + '-txt');
					if (oBtnDesignTxt)
						UCF_DomUtil["replaceClass"](oBtnDesignTxt, 'urBtnCnt' + sOldSuffix, 'urBtnCnt' + sNewSuffix);
				}
				break;
			}
			default: {
				UCF_DomUtil["replaceClass"](this["oDomRef"], 'lsBtnStdHeight' + sOldSuffix, 'lsBtnStdHeight' + sNewSuffix);
			}
		}

		UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnStdMnuOnlyImg' + sOldSuffix, 'urBtnStdMnuOnlyImg' + sNewSuffix);
		UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnStdOnlyImg' + sOldSuffix, 'urBtnStdOnlyImg' + sNewSuffix);
		UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnImgBgColor' + sOldSuffix, 'urBtnImgBgColor' + sNewSuffix);

		//Enable MenuIcon hasPopupMenu=true && hasPopupMenuSection=true
		if (this["bHasPopupMenuSection"] && this["bHasPopupMenu"]) {
			var oSecDomRef = UCF_DomUtil["$"](this["sId"] + '-sec');
			if (oSecDomRef) {
				UCF_DomUtil["replaceClass"](oSecDomRef, 'urBtnMnuSection' + sOldSuffix, 'urBtnMnuSection' + sNewSuffix);
			}
			oMenuDomRef = UCF_DomUtil["$"](this["sId"] + '-MnuIco');
			if (oMenuDomRef)
				UCF_DomUtil["replaceClass"](oMenuDomRef, 'urBtnMnuIco' + sOldSuffix, 'urBtnMnuIco' + sNewSuffix);
		}

		if (oImageDomRef) {
			if (this["bDown"]) {
				if (this["sDownIconSrc"] === this["sDisabledIconSrc"] || this["sDisabledIconSrc"] === '') {
					UCF_DomUtil["replaceClass"](oImageDomRef, 'urImgBtn' + sOldSuffix, 'urImgBtn' + sNewSuffix);
				}
			} else {
				if (this["sUpIconSrc"] === this["sDisabledIconSrc"] || this["sDisabledIconSrc"] === '') {
					UCF_DomUtil["replaceClass"](oImageDomRef, 'urImgBtn' + sOldSuffix, 'urImgBtn' + sNewSuffix);
				}
			}
		}
		// Change the Icon Src
		this["applyIconSrc"](enabled, this["bDown"]);
	};;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyQuirksEnabledStyles"] = 0; };

	/**
	 * Applies Down state for Quirks mode
	 *
	 * @param {boolean} down - the down state
	 */
	UCF_Button["prototype"]["applyQuirksDownStyles"] = function(down) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyQuirksDownStyles"]++; }; 

		if (window["UCF_System"]["sDevice"] === 'standards') return;

		var sOldSuffix = (down ? '' : 'D'),
			sNewSuffix = (down ? 'D' : '');
		var oBtnDesignTxt;

		switch (this["sDesign"]) {
			case 'EMPHASIZED': {
				UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnEmph' + sOldSuffix, 'urBtnEmph' + sNewSuffix);
				break;
			}
			case 'PREVIOUS': {
				UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnStdPrevStep' + sOldSuffix, 'urBtnStdPrevStep' + sNewSuffix);
				oBtnDesignTxt = UCF_DomUtil["$"](this["sId"] + '-txt');
				if (oBtnDesignTxt)
					UCF_DomUtil["replaceClass"](oBtnDesignTxt, 'urBtnCnt' + sOldSuffix, 'urBtnCnt' + sNewSuffix);
				break;
			}
			case 'NEXT': {
				UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnStdNextStep' + sOldSuffix, 'urBtnStdNextStep' + sNewSuffix);
				oBtnDesignTxt = UCF_DomUtil["$"](this["sId"] + '-txt');
				if (oBtnDesignTxt)
					UCF_DomUtil["replaceClass"](oBtnDesignTxt, 'urBtnCnt' + sOldSuffix, 'urBtnCnt' + sNewSuffix);
				break;
			}
			case 'TOGGLE': {
				if (this["bDown"] !== down) {
					var sOldClass = (this["bDown"] ? 'urBtnTglD' : 'urBtnTgl') + (this["bEnabled"] ? '' : 'Dsbl');
					var sNewClass = (this["bDown"] ? 'urBtnTgl' : 'urBtnTglD') + (this["bEnabled"] ? '' : 'Dsbl');
					UCF_DomUtil["removeClass"](this["oDomRef"], sOldClass);
					if (!UCF_DomUtil["bHasClass"](this["oDomRef"], sNewClass)) {
						UCF_DomUtil["addClass"](this["oDomRef"], sNewClass);
					}
					oBtnDesignTxt = UCF_DomUtil["$"](this["sId"] + '-txt');
					if (oBtnDesignTxt)
						UCF_DomUtil["replaceClass"](oBtnDesignTxt, 'urBtnCnt' + sOldSuffix, 'urBtnCnt' + sNewSuffix);
				}
				break;
			}
			default: {
				UCF_DomUtil["replaceClass"](this["oDomRef"], 'lsBtnStdHeight' + sOldSuffix, 'lsBtnStdHeight' + sNewSuffix);
				if (this["bDefaultButton"]) {
					UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnStdDB' + sOldSuffix, 'urBtnStdDB' + sNewSuffix);
				} else {
					UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnStd' + sOldSuffix, 'urBtnStd' + sNewSuffix);
				}
			}
		}
		//	}
		if (this["bHasPopupMenu"] && this["bHasPopupMenuSection"]) {
			if (this["oMenuSectionDomRef"] != null) {
				if (this["bDefaultButton"]) {
					UCF_DomUtil["replaceClass"](this["oDomRef"], 'urBtnMnuSectionDB' + sOldSuffix, 'urBtnMnuSectionDB' + sNewSuffix);
				} else {
					UCF_DomUtil["replaceClass"](this["oMenuSectionDomRef"], 'urBtnMnuSection' + sOldSuffix, 'urBtnMnuSection' + sNewSuffix);
				}
				if (down) {
					UCF_DomUtil["addClass"](this["oMenuSectionDomRef"], 'lsButton--section-down');
				} else {
					if (this["oPopupMenu"] && !this["oPopupMenu"]["bOpened"])
						UCF_DomUtil["removeClass"](this["oMenuSectionDomRef"], 'lsButton--section-down');
				}

				UCF_DomUtil["replaceClass"](this["oMenuSectionDomRef"], 'lsBtnStdHeight' + sOldSuffix, 'lsBtnStdHeight' + sNewSuffix);
			}
		}
		// Change the Icon Src
		this["applyIconSrc"](this["bEnabled"], down);
	};;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyQuirksDownStyles"] = 0; };

	/**
	 * Applies the default style for the Button
	 * Only for Quirks mode
	 * @param { boolean } bDefault - the down state
	 */
	UCF_Button["prototype"]["applyQuirksDefaultStyles"] = function(bDefault) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyQuirksDefaultStyles"]++; }; 
		//TODO High clarify default button visualization
		if (this["sMainClassName"] == null)
			this["sMainClassName"] = this["sGetMainClass"]();
		if (bDefault) {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsButton--default ' + this["sMainClassName"] + 'DB');
			UCF_DomUtil["addClass"](this["oDomRef"], this["sMainClassName"] + '-default');
		} else {
			UCF_DomUtil["removeClass"](this["oDomRef"], this["sMainClassName"] + 'DB');
			UCF_DomUtil["removeClass"](this["oDomRef"], this["sMainClassName"] + '-default');
		}
	};;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyQuirksDefaultStyles"] = 0; };

	/**
	 * Applies or removes the hover styles for button
	 * Only for Quirks mode
	 * @param {boolean} bHover - if the hover state should be applied or removed
	 * @param {UCF_HTMLElement} oSource the souce html
	 * @private
	 */
	UCF_Button["prototype"]["applyQuirksHoverStyles"] = function(bHover, oSource) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyQuirksHoverStyles"]++; }; 
		var oMnuIco = UCF_DomUtil["$"](this["sId"] + '-MnuIco'),
			oBtnDesignImg;
		if (bHover) {
			if (this["bHasPopupMenu"] && this["bEnabled"]) {
				var addHoverClass = true;

				if (this["bHasPopupMenuSection"]) {
					addHoverClass = (this["oMenuSectionDomRef"] != null && oMnuIco != null
						&& (this["oMenuSectionDomRef"] === oSource || oMnuIco === oSource));
				}
				if (addHoverClass && oMnuIco && !UCF_DomUtil["bHasClass"](oMnuIco, 'urBtnMnuIcoHover')) {
					UCF_DomUtil["addClass"](oMnuIco, 'urBtnMnuIcoHover');
				}
			}

			if (this["bEnabled"] && (this["sDesign"] === 'NEXT' || this["sDesign"] === 'PREVIOUS')) {
				oBtnDesignImg = UCF_DomUtil["$"](this["sId"] + '-btnDesign');
				if (oBtnDesignImg) {
					UCF_DomUtil["replaceClass"](oBtnDesignImg, this["sDesign"] === 'NEXT' ? 'lsBtnNextImg' : 'lsBtnPrevImg', this["sDesign"] === 'NEXT' ? 'lsBtnNextHoverImg' : 'lsBtnPrevHoverImg');
				}
			}
		} else {
			if (this["bHasPopupMenu"] && this["bEnabled"]) {
				if (oMnuIco && UCF_DomUtil["bHasClass"](oMnuIco, 'urBtnMnuIcoHover')) {
					UCF_DomUtil["removeClass"](oMnuIco, 'urBtnMnuIcoHover');
				}
			}
			if (this["bEnabled"] && (this["sDesign"] === 'NEXT' || this["sDesign"] === 'PREVIOUS')) {
				oBtnDesignImg = UCF_DomUtil["$"](this["sId"] + '-btnDesign');
				if (oBtnDesignImg) {
					UCF_DomUtil["replaceClass"](oBtnDesignImg, this["sDesign"] === 'NEXT' ? 'lsBtnNextHoverImg' : 'lsBtnPrevHoverImg', this["sDesign"] === 'NEXT' ? 'lsBtnNextImg' : 'lsBtnPrevImg');
				}
			}
		}
	};;if (__UCF_COVERAGE__) { UCF_Button["_"]["applyQuirksHoverStyles"] = 0; };

	UCF_Button["prototype"]["doMouseUp"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["doMouseUp"]++; }; 
		if (!this["bEnabled"]) return;
		if (this["sDesign"] === 'TOGGLE') {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsBtnTglPress');
			return;
		}
		if (this["bDown"]) return;
		if (__UCF_IE6__) {
			this["applyQuirksDownStyles"](false);
		}

	};;if (__UCF_COVERAGE__) { UCF_Button["_"]["doMouseUp"] = 0; };

	UCF_Button["prototype"]["initializeQuirks"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["initializeQuirks"]++; }; 

		// Initialize is used only in IE Quirks mode
		var oSecRef, offsetBtn;
		if (!this["bHasPopupMenu"]) return;

		if (this["sWidth"] === '' || !this["bTextOverflow"]) return;

		if (!this["bHasPopupMenuSection"] && this["bTextOverflow"] && this["sWidth"] !== '' && this["sText"] !== '') {
			//check the button lenght;When the text lenght is bigger then
			//the button width, the menu icon is not displayed

			var offsetRight = parseInt(this["oDomRef"]["offsetLeft"] + this["oDomRef"]["offsetWidth"]);
			oSecRef = UCF_DomUtil["$"](this["sId"] + '-MnuIco');
			if (oSecRef != null) {
				var offsetLeft = parseInt(oSecRef["offsetLeft"]);
				if (offsetLeft > offsetRight) {
					oSecRef["style"]["marginLeft"] = (offsetRight - offsetLeft - 10) + 'px';
					oSecRef["style"]["cssFloat"] = 'right';
				}

			}
		}
		//if a width is set & TextOveflow = false, then the whole text will be displayed inside
		//the button and width will be ignored
		//if a width is set, not content push will be accepted
		if (this["bHasPopupMenuSection"] && this["sWidth"] !== '' && this["sText"] !== '') {
			offsetBtn = parseInt(this["oDomRef"]["offsetWidth"]);
			if (this["oMenuSectionDomRef"] != null) {

				var widthPercent = this["sWidth"] != null && this["sWidth"]["indexOf"]('%') > -1;
				var widthSecRef = this["oMenuSectionDomRef"]["clientWidth"] + 1; // plus border
				if (widthPercent) {
					var newWidth = Math["floor"]((Math["round"](this["oDomRef"]["clientWidth"]) - Math["round"](widthSecRef)) * parseInt(this["sWidth"]) / Math["round"](this["oDomRef"]["clientWidth"])) + '%';
					//_trace(INFO, '== Button id - ' + this.sId + ' - clientWidth ' + this.oDomRef.clientWidth + 'px - oSecRef.clientWidth - ' + widthSecRef + ';  new width' +  newWidth);
					this["oDomRef"]["style"]["width"] = newWidth;
				}
			} else {
				var offsetSec = Math["max"](parseInt(this["oMenuSectionDomRef"]["offsetWidth"]), 11);
				offsetBtn = parseInt(this["sWidth"]);
				this["oDomRef"]["style"]["width"] = (offsetBtn - offsetSec) + 'px';
				this["oDomRef"]["style"]["minWidth"] = (offsetBtn - offsetSec) + 'px';
			}
		}
	};;if (__UCF_COVERAGE__) { UCF_Button["_"]["initializeQuirks"] = 0; };
}

/**
 * Prepare ARIA for Controls in SAPTable
 */
UCF_Button["prototype"]["toggleAriaMenuAttributes"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["toggleAriaMenuAttributes"]++; }; 
	if (!window["UCF_System"]["bIsAria"]) return;
	/** @type {Node} */
	var oMenuDomRef = this["bHasPopupMenuSection"] ? this["oRootRef"] : this["oDomRef"];
	if (oMenuDomRef["hasAttribute"] && oMenuDomRef["hasAttribute"]('aria-controls')) {
		oMenuDomRef["removeAttribute"]('aria-controls');
	} else {
		oMenuDomRef["setAttribute"]('aria-controls', this["sPopupMenuId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["toggleAriaMenuAttributes"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Button["prototype"]["aAttributeNames"] = ["sText","sTextDesign","sDesign","sWidth","sTooltip","bEnabled","bHasButtonCaption","sVisibility","bShowHelp","bDown","bHasIcon","sDisabledIconSrc","sUpIconSrc","sDownIconSrc","bHasPopupMenu","sPopupMenuId","bHasPopupMenuSection","bImageFirst","sAccessKey","sHotkey","bUp","bTextOverflow","bFixedHeight","sType","sDragSourceInfo","sSemanticColor","sInteractionBehaviour","sCustomStyle","sCustomData","bWrapping","sHeight","sContentVisibility"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Button["prototype"]["aEventNames"] = ["Press","MenuAccess","DoubleClick","Change"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Button["prototype"]["aMethodNames"] = ["openMenu","setEnabled","getEnabled","setPopupMenuId","sGetPopupMenuId","setSemanticColor","getSemanticColor","setUpIconSrc","getUpIconSrc","setTooltip","getTooltip","setDown","getDown","setText","getText","setVisibility","getVisibility","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sText"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputDesign}
 */
UCF_Button["prototype"]["sTextDesign"] = "STANDARD";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ButtonDesign}
 */
UCF_Button["prototype"]["sDesign"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bHasButtonCaption"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Button["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bShowHelp"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bDown"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bHasIcon"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sDisabledIconSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sUpIconSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sDownIconSrc"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bHasPopupMenu"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sPopupMenuId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bHasPopupMenuSection"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bImageFirst"] = true;

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HotkeyValue}
 */
UCF_Button["prototype"]["sHotkey"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bUp"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bTextOverflow"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bFixedHeight"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ButtonType}
 */
UCF_Button["prototype"]["sType"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_Button["prototype"]["sSemanticColor"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ButtonInteractionBehaviour}
 */
UCF_Button["prototype"]["sInteractionBehaviour"] = "PUSH";

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Button["prototype"]["bWrapping"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Button["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ContentVisibility}
 */
UCF_Button["prototype"]["sContentVisibility"] = "ALL";

//#JSCOVER_EXCL_START
/** @protected */
UCF_Button["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Button["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["sTextDesign"] = "STANDARD";
	this["sDesign"] = "STANDARD";
	this["sWidth"] = '';
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["bHasButtonCaption"] = false;
	this["sVisibility"] = "VISIBLE";
	this["bShowHelp"] = false;
	this["bDown"] = false;
	this["bHasIcon"] = false;
	this["sDisabledIconSrc"] = '';
	this["sUpIconSrc"] = '';
	this["sDownIconSrc"] = '';
	this["bHasPopupMenu"] = false;
	this["sPopupMenuId"] = '';
	this["bHasPopupMenuSection"] = false;
	this["bImageFirst"] = true;
	this["sAccessKey"] = '';
	this["sHotkey"] = "NONE";
	this["bUp"] = false;
	this["bTextOverflow"] = false;
	this["bFixedHeight"] = false;
	this["sType"] = "NONE";
	this["sDragSourceInfo"] = '';
	this["sSemanticColor"] = "NONE";
	this["sInteractionBehaviour"] = "PUSH";
	this["sCustomStyle"] = '';
	this["sCustomData"] = '';
	this["bWrapping"] = false;
	this["sHeight"] = '';
	this["sContentVisibility"] = "ALL";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("TextDesign", "STANDARD", true);
		this["setClientProperty"]("Design", "STANDARD", true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("HasButtonCaption", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ShowHelp", false, true);
		this["setClientProperty"]("Down", false, true);
		this["setClientProperty"]("HasIcon", false, true);
		this["setClientProperty"]("DisabledIconSrc", '', true);
		this["setClientProperty"]("UpIconSrc", '', true);
		this["setClientProperty"]("DownIconSrc", '', true);
		this["setClientProperty"]("HasPopupMenu", false, true);
		this["setClientProperty"]("PopupMenuId", '', true);
		this["setClientProperty"]("HasPopupMenuSection", false, true);
		this["setClientProperty"]("ImageFirst", true, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("Hotkey", "NONE", true);
		this["setClientProperty"]("Up", false, true);
		this["setClientProperty"]("TextOverflow", false, true);
		this["setClientProperty"]("FixedHeight", false, true);
		this["setClientProperty"]("Type", "NONE", true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("SemanticColor", "NONE", true);
		this["setClientProperty"]("InteractionBehaviour", "PUSH", true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("Wrapping", false, true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("ContentVisibility", "ALL", true);
	}
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the Button control in the current HTML document context. The Id of any control should be unique within the document.
 * @fires Button::Press
 */
UCF_Button["prototype"]["firePress"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["firePress"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Button.js(2386): firePress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Button.js(2387): firePress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Button.js(2388): firePress"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Button", "Press", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["firePress"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Button control in the current HTML document context. The Id of any control should be unique within the document.
 * @param {string} sPopupMenuId Identifier assigned PopupMenu in the current HTML document context. The Id of any control should be unique within the document.
 * @fires Button::MenuAccess
 */
UCF_Button["prototype"]["fireMenuAccess"] = function(sId, sPopupMenuId) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string, PopupMenuId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Button.js(2406): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Button.js(2407): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Button.js(2408): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPopupMenuId != null, "sPopupMenuId != null", "Button.js(2409): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPopupMenuId) == "string", "typeof(sPopupMenuId) == \"string\"", "Button.js(2410): fireMenuAccess"); };
	mParams = {
		"Id": sId,
		"PopupMenuId": sPopupMenuId
	};
	
	
	this["fireSemanticEvent"]("Button", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["fireMenuAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Button control.
 * @fires Button::DoubleClick
 */
UCF_Button["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Button.js(2429): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Button.js(2430): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Button.js(2431): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Button", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the Button.
 * @param {string} sValue The new Button text.
 * @fires Button::Change
 */
UCF_Button["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_Button["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Button.js(2449): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Button.js(2450): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Button.js(2451): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "Button.js(2452): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Button.js(2453): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("Button", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Button["_"]["fireChange"] = 0; };

UCF_Button.prototype["aPublicMethods"] = ["openMenu","setEnabled","getEnabled","setPopupMenuId","sGetPopupMenuId","setSemanticColor","getSemanticColor","setUpIconSrc","getUpIconSrc","getDown","setDown","setTooltip","getTooltip","getText","setVisibility","getVisibility"].concat(UCF_Button.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ButtonDTExtension"] = function() {/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_DTExtension */
/// <reference path="./DTExtension.js"/>

/**
 * 
 *
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oControl
 * @param {UCF_DTElement} oDTElement
 */
function UCF_ButtonDTExtension(oLS, oControl, oDTElement) {if (__UCF_COVERAGE__) { UCF_ButtonDTExtension["_"]["UCF_ButtonDTExtension"]++; }; 
	if (arguments["length"] === 0) return;
	UCF_DTExtension["apply"](this, arguments);
};window["UCF_ButtonDTExtension"] = UCF_ButtonDTExtension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ButtonDTExtension"); UCF_ButtonDTExtension["_"] = {UCF_ButtonDTExtension: 0}; }; ;

UCF_ButtonDTExtension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTExtension"))(); UCF_ButtonDTExtension.prototype["sClassName"] = "UCF_ButtonDTExtension";

/**
 * @see UCF_DTExtension
 * @private
 */
UCF_ButtonDTExtension["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_ButtonDTExtension["_"]["bIsVisible"]++; }; 
	var bIsVisible = true;
	var oParent = this["oControl"]["oGetParent"]();
	if (oParent != null && UCF_JsUtil["bInstanceOf"](oParent, "UCF_Toolbar")) {
		bIsVisible = !oParent["bItemIsHidden"](this["oControl"]["oRootRef"]);
	}

	if (bIsVisible === false && this["oControl"]["bGetInvisibility"]() && !this["oControl"]["bIsAncestorInvisible"]()) {
		// "Invisibility" => Designtime must show small DTElement to be able to select the invisible control
		bIsVisible = true;
	}

	if (bIsVisible) {
		return UCF_DTExtension.prototype["bIsVisible"]["apply"](this, arguments);
	} else {
		return bIsVisible;
	}
};;if (__UCF_COVERAGE__) { UCF_ButtonDTExtension["_"]["bIsVisible"] = 0; };

/**
 * @private
 * @see UCF_DTExtension
 */
UCF_ButtonDTExtension["prototype"]["oGetDomRefForRect"] = function(sElementId) {;if (__UCF_COVERAGE__) { UCF_ButtonDTExtension["_"]["oGetDomRefForRect"]++; }; 
	if (this["oControl"]["oGetParent"]() && UCF_JsUtil["bInstanceOf"](this["oControl"]["oGetParent"](), "UCF_RasterLayoutItem")) {
		return this["oControl"]["oGetParent"]()["oRootRef"];
	}
	if (this["oControl"]["bHasPopupMenuSection"]) {
		return this["oControl"]["oRootRef"];
	}
	return this["oControl"]["oDomRef"]; // Use the A-element not the SPAN (oRootRef)
};;if (__UCF_COVERAGE__) { UCF_ButtonDTExtension["_"]["oGetDomRefForRect"] = 0; };

UCF_ButtonDTExtension["prototype"]["hideControlOnDragStart"] = function() {;if (__UCF_COVERAGE__) { UCF_ButtonDTExtension["_"]["hideControlOnDragStart"]++; }; 
	return this["oControl"]["oGetParent"]() && this["oControl"]["oGetParent"]()["sClassName"] == "UCF_Toolbar";
};;if (__UCF_COVERAGE__) { UCF_ButtonDTExtension["_"]["hideControlOnDragStart"] = 0; };

};
sap["ls"]["preload"]["UCF_ButtonDragDelegate"] = function() {/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/**
 * @class
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_ButtonDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_ButtonDragDelegate["_"]["UCF_ButtonDragDelegate"]++; }; 
	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);
};window["UCF_ButtonDragDelegate"] = UCF_ButtonDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ButtonDragDelegate"); UCF_ButtonDragDelegate["_"] = {UCF_ButtonDragDelegate: 0}; }; ;

UCF_ButtonDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_ButtonDragDelegate.prototype["sClassName"] = "UCF_ButtonDragDelegate";

/** @return {UCF_HTMLGhost} */
UCF_ButtonDragDelegate["prototype"]["oGetGhost"] = function() {;if (__UCF_COVERAGE__) { UCF_ButtonDragDelegate["_"]["oGetGhost"]++; }; 

	var oButton = document["createElement"]('DIV');

	var oTemp = document["createElement"]('div');

	oTemp["appendChild"](this["oDragSourceControl"]["oRootRef"]["cloneNode"](true));
	// direct cloning caused errors when button is in saptable
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oButton, oTemp["innerHTML"]);
	// Right border cut off on FF and Safari => +2
	oButton["style"]["width"] = (this["oDragSourceControl"]["oDomRef"]["clientWidth"] + 2) + 'px';

	return new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oButton);

};;if (__UCF_COVERAGE__) { UCF_ButtonDragDelegate["_"]["oGetGhost"] = 0; };

};
sap["ls"]["preload"]["UCF_ButtonRow"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ButtonRow(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ButtonRow["_"]["UCF_ButtonRow"]++; }; 
	if (arguments["length"] == 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "ButtonRow.js(21): UCF_ButtonRow"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ButtonRow.js(22): UCF_ButtonRow"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ButtonRow.js(23): UCF_ButtonRow"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_ButtonRow"] = UCF_ButtonRow; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ButtonRow"); UCF_ButtonRow["_"] = {UCF_ButtonRow: 0}; }; ;
UCF_ButtonRow["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ButtonRow.prototype["sClassName"] = "UCF_ButtonRow";

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ButtonRow["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ButtonRow["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ButtonRow.js(36): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ButtonRow["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ButtonRow["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ButtonRow["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ButtonRow.js(48): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
  oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ButtonRow["_"]["onlsskipback"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ButtonRow["prototype"]["aAttributeNames"] = ["sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ButtonRow["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ButtonRow["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ButtonRow["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ButtonRow["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ButtonRow["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ButtonRow["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ButtonRow["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_CSSGrid"] = function() {/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_CSSGrid_ResizeDelegate */
/// <reference path="./delegates/CSSGrid_ResizeDelegate.js"/>

/**
 * @param {HTMLDivElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_CSSGrid(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CSSGrid["_"]["UCF_CSSGrid"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Control["apply"](this, [oDomRef, oLS]);

		if (this["sRelativeTo"] === 'CONTROL') {
			this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_CSSGrid_ResizeDelegate"))(
				this["oDomRef"],
				this["oDomRef"],
				UCF_JsUtil["find"](
					UCF_JsUtil["arrayFrom"](this["oDomRef"]["childNodes"]),
					function(oRef) { return oRef["nodeName"] === 'STYLE'; }
				),
				this["oLS"]
			));
		}
	}
};window["UCF_CSSGrid"] = UCF_CSSGrid; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CSSGrid"); UCF_CSSGrid["_"] = {UCF_CSSGrid: 0}; }; ;
UCF_CSSGrid["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_CSSGrid.prototype["sClassName"] = "UCF_CSSGrid";

/** @override */
UCF_CSSGrid["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_CSSGrid["_"]["initialize"]++; }; 
	// UCF_CSSGrid_ResizeDelegate will initialize during constructor
};;if (__UCF_COVERAGE__) { UCF_CSSGrid["_"]["initialize"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_CSSGrid["prototype"]["aAttributeNames"] = ["sRelativeTo"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_CSSGrid["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_CSSGrid["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CSSGridRelativeTo}
 */
UCF_CSSGrid["prototype"]["sRelativeTo"] = "VIEWPORT";

//#JSCOVER_EXCL_START
/** @protected */
UCF_CSSGrid["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_CSSGrid["_"]["setDefaultValues"]++; }; 
	this["sRelativeTo"] = "VIEWPORT";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("RelativeTo", "VIEWPORT", true);
	}
};;if (__UCF_COVERAGE__) { UCF_CSSGrid["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_CSSGridItem"] = function() {/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_CSSGrid_ResizeDelegate */
/// <reference path="./delegates/CSSGrid_ResizeDelegate.js"/>

/**
 * @param {HTMLDivElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_CSSGridItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CSSGridItem["_"]["UCF_CSSGridItem"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Control["apply"](this, [oDomRef, oLS]);

		if (this["sRelativeTo"] === 'CONTROL') {
			this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_CSSGrid_ResizeDelegate"))(
				this["oGetParent"]()["oRootRef"],
				this["oDomRef"],
				UCF_JsUtil["find"](
					UCF_JsUtil["arrayFrom"](this["oDomRef"]["childNodes"]),
					function(oRef) { return oRef["nodeName"] === 'STYLE'; }
				),
				this["oLS"]
			));
		}
	}
};window["UCF_CSSGridItem"] = UCF_CSSGridItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CSSGridItem"); UCF_CSSGridItem["_"] = {UCF_CSSGridItem: 0}; }; ;
UCF_CSSGridItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_CSSGridItem.prototype["sClassName"] = "UCF_CSSGridItem";

/** @override */
UCF_CSSGridItem["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_CSSGridItem["_"]["initialize"]++; }; 
	// UCF_CSSGrid_ResizeDelegate will initialize during constructor
};;if (__UCF_COVERAGE__) { UCF_CSSGridItem["_"]["initialize"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_CSSGridItem["prototype"]["aAttributeNames"] = ["sRelativeTo"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_CSSGridItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_CSSGridItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CSSGridRelativeTo}
 */
UCF_CSSGridItem["prototype"]["sRelativeTo"] = "VIEWPORT";

//#JSCOVER_EXCL_START
/** @protected */
UCF_CSSGridItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_CSSGridItem["_"]["setDefaultValues"]++; }; 
	this["sRelativeTo"] = "VIEWPORT";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("RelativeTo", "VIEWPORT", true);
	}
};;if (__UCF_COVERAGE__) { UCF_CSSGridItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_CSSGrid_ResizeDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Cache */
/// <reference path="../../../core/util/Cache.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_Exception */
/// <reference path="../../core/Exception.js"/>
/* global UCF_ResizeEventHelper */
/// <reference path="../../helper/ResizeEventHelper.js"/>

/**
 * @typedef {Object} UCF_CSSGrid_ResizeDelegate_ObservedRef
 * @property {HTMLElement} oDomRef
 * @property {string} sId
 */

/**
 * @param {HTMLElement} oRootRef the reference for resizes
 * @param {HTMLElement} oDomRef the element that applies the generated classes
 * @param {HTMLStyleElement} oStylesRef the element that implements the
 * generated classes
 * @param {UCF_LS} oLS
 */
function UCF_CSSGrid_ResizeDelegate(oRootRef, oDomRef, oStylesRef, oLS) {if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["UCF_CSSGrid_ResizeDelegate"]++; }; 
	/** @type {UCF_CSSGrid_ResizeDelegate} */
	var self = this;

	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		/** @type {HTMLElement} */
		this["oRootRef"] = oRootRef;
		/** @type {HTMLElement} */
		this["oDomRef"] = oDomRef;
		/** @type {UCF_LS} */
		this["oLS"] = oLS;
		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
		/** @type {Object<number, string>} maps min-width breakpoints (px) to css classes */
		this["aBreakpoints"] = {};
		/** @type {number} */
		this["iCurrentBreakpoint"] = -Infinity;

		try {
			this["convertStyleRef"](oStylesRef);

			this["sResizeId"] = UCF_CSSGrid_ResizeDelegate["sAttachResize"](
				this["oRootRef"],
				function() { self["onresize"]["apply"](self, arguments); }
			);

			this["onresize"]();
		} catch (e) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, e["message"], "CSSGrid_ResizeDelegate.js(61): UCF_CSSGrid_ResizeDelegate"); };
		}
	}
};window["UCF_CSSGrid_ResizeDelegate"] = UCF_CSSGrid_ResizeDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CSSGrid_ResizeDelegate"); UCF_CSSGrid_ResizeDelegate["_"] = {UCF_CSSGrid_ResizeDelegate: 0}; }; ;
UCF_CSSGrid_ResizeDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_CSSGrid_ResizeDelegate.prototype["sClassName"] = "UCF_CSSGrid_ResizeDelegate";

/** @type {Object<string, Object<string,function(DOMEvent): void>>} */
UCF_CSSGrid_ResizeDelegate["oHandlers"] = null;
/** @type {UCF_CSSGrid_ResizeDelegate_ObservedRef[]} */
UCF_CSSGrid_ResizeDelegate["aObservedRefs"] = null;
/** @type {UCF_ResizeEventHelper} */
UCF_CSSGrid_ResizeDelegate["oResizeEventHelper"] = null;

/**
 * @static
 * @param {HTMLElement} oDomRef
 * @param {function(DOMEvent): void} fHandler
 * @return {string}
 */
UCF_CSSGrid_ResizeDelegate["sAttachResize"] = function(oDomRef, fHandler) {;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["sAttachResize"]++; }; 
	/** @type {string} */
	var sId = UCF_JsUtil["sGetUID"]();
	/** @type {string} */
	var sRefId;
	/** @type {UCF_CSSGrid_ResizeDelegate_ObservedRef} */
	var oObservedRef;

	if (!UCF_CSSGrid_ResizeDelegate["oResizeEventHelper"]) {
		UCF_CSSGrid_ResizeDelegate["oResizeEventHelper"] = new (UCF_ClassLoader["oGetClass"]("UCF_ResizeEventHelper"))(function(oEvent) {
			/** @type {UCF_CSSGrid_ResizeDelegate_ObservedRef} */
			var oRef = UCF_JsUtil["find"](UCF_CSSGrid_ResizeDelegate["aObservedRefs"], function(o) {
				return o["oDomRef"] === oEvent["target"];
			});

			if (
				oRef &&
				UCF_CSSGrid_ResizeDelegate["oHandlers"] &&
				oRef["sId"] in UCF_CSSGrid_ResizeDelegate["oHandlers"]
			) {
				UCF_JsUtil["forEach"](
					UCF_JsUtil["values"](UCF_CSSGrid_ResizeDelegate["oHandlers"][oRef["sId"]]),
					function(f) { f(oEvent); }
				);
			}
		});
	}

	if (!UCF_CSSGrid_ResizeDelegate["oHandlers"]) {
		UCF_CSSGrid_ResizeDelegate["oHandlers"] = {};
	}
	if (!UCF_CSSGrid_ResizeDelegate["aObservedRefs"]) {
		UCF_CSSGrid_ResizeDelegate["aObservedRefs"] = [];
	}
	if (!UCF_JsUtil["some"](
			UCF_CSSGrid_ResizeDelegate["aObservedRefs"],
			function(o) { return o["oDomRef"] === oDomRef; }
		)) {
		sRefId = UCF_JsUtil["sGetUID"]();

		UCF_CSSGrid_ResizeDelegate["aObservedRefs"]["push"]({
			"oDomRef": oDomRef,
			"sId": sRefId
		});

		UCF_CSSGrid_ResizeDelegate["oResizeEventHelper"]["attachEvent"](oDomRef);
	}

	oObservedRef = UCF_JsUtil["find"](
		UCF_CSSGrid_ResizeDelegate["aObservedRefs"],
		function(o) { return o["oDomRef"] === oDomRef; }
	);

	if (oObservedRef) {
		if (!(oObservedRef["sId"] in UCF_CSSGrid_ResizeDelegate["oHandlers"])) {
			UCF_CSSGrid_ResizeDelegate["oHandlers"][oObservedRef["sId"]] = {};
		}
		UCF_CSSGrid_ResizeDelegate["oHandlers"][oObservedRef["sId"]][sId] = fHandler;

		return sId;
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["sAttachResize"] = 0; };

/**
 * @static
 * @param {HTMLElement} oDomRef
 * @param {string} sId
 */
UCF_CSSGrid_ResizeDelegate["detachResize"] = function(oDomRef, sId) {;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["detachResize"]++; }; 
	/** @type {UCF_CSSGrid_ResizeDelegate_ObservedRef} */
	var oObservedRef;

	if (
		UCF_CSSGrid_ResizeDelegate["oHandlers"] &&
		UCF_CSSGrid_ResizeDelegate["aObservedRefs"]
	) {
		oObservedRef = UCF_JsUtil["find"](
			UCF_CSSGrid_ResizeDelegate["aObservedRefs"],
			function(o) { return o["oDomRef"] === oDomRef; }
		);

		if (
			oObservedRef &&
			oObservedRef["sId"] in UCF_CSSGrid_ResizeDelegate["oHandlers"] &&
			sId in UCF_CSSGrid_ResizeDelegate["oHandlers"][oObservedRef["sId"]]
		) {
			delete UCF_CSSGrid_ResizeDelegate["oHandlers"][oObservedRef["sId"]][sId];

			if (UCF_JsUtil["bIsEmpty"](UCF_CSSGrid_ResizeDelegate["oHandlers"][oObservedRef["sId"]])) {
				delete UCF_CSSGrid_ResizeDelegate["oHandlers"][oObservedRef["sId"]];
				UCF_CSSGrid_ResizeDelegate["aObservedRefs"] = UCF_CSSGrid_ResizeDelegate["aObservedRefs"]["splice"](
					UCF_JsUtil["findIndex"](
						UCF_CSSGrid_ResizeDelegate["aObservedRefs"],
						function(o) { return o["oDomRef"] === oDomRef; }
					),
					1
				);
			}
			if (UCF_JsUtil["bIsEmpty"](UCF_CSSGrid_ResizeDelegate["oHandlers"])) {
				UCF_CSSGrid_ResizeDelegate["oResizeEventHelper"]["destroy"]();
				UCF_CSSGrid_ResizeDelegate["oResizeEventHelper"] = null;
				UCF_CSSGrid_ResizeDelegate["oHandlers"] = null;
			}
			if (UCF_CSSGrid_ResizeDelegate["aObservedRefs"]["length"] === 0) {
				UCF_CSSGrid_ResizeDelegate["aObservedRefs"] = null;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["detachResize"] = 0; };

/** @static */
UCF_CSSGrid_ResizeDelegate["destroyStatic"] = function() {;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["destroyStatic"]++; }; 
	if (UCF_CSSGrid_ResizeDelegate["oResizeEventHelper"]) {
		UCF_CSSGrid_ResizeDelegate["oResizeEventHelper"]["destroy"]();
		UCF_CSSGrid_ResizeDelegate["oResizeEventHelper"] = null;
	}
	UCF_CSSGrid_ResizeDelegate["oHandlers"] = null;
	UCF_CSSGrid_ResizeDelegate["aObservedRefs"] = null;
};;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["destroyStatic"] = 0; };

/** */
UCF_CSSGrid_ResizeDelegate["prototype"]["onresize"] = function() {;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["onresize"]++; }; 
	/** @type {number} */
	var iOffsetWidth = this["oRootRef"]["offsetWidth"];
	/** @type {number} */
	var iNewBreakpoint = Math["max"]["apply"](null, UCF_JsUtil["filter"](
		UCF_JsUtil["keys"](this["aBreakpoints"]),
		function(iBreakpoint) { return iOffsetWidth >= iBreakpoint; }
	));

	if (iNewBreakpoint !== this["iCurrentBreakpoint"]) {
		if (this["iCurrentBreakpoint"] in this["aBreakpoints"]) {
			UCF_DomUtil["removeClass"](
				this["oDomRef"],
				this["aBreakpoints"][this["iCurrentBreakpoint"]]
			);
		}
		UCF_DomUtil["addClass"](
			this["oDomRef"],
			this["aBreakpoints"][iNewBreakpoint]
		);
		this["iCurrentBreakpoint"] = iNewBreakpoint;
		this["oLS"]["oBrowserWindow"]["notifyLayoutChange"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["onresize"] = 0; };

/** @override */
UCF_CSSGrid_ResizeDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["destroy"]++; }; 
	if (this["sResizeId"]) {
		UCF_CSSGrid_ResizeDelegate["detachResize"](this["oRootRef"], this["sResizeId"]);
		this["sResizeId"] = null;
	}
	if (this["oCache"]) {
		this["oCache"]["destroy"]();
		this["oCache"] = null;
	}
	this["iCurrentBreakpoint"] = null;
	this["oLS"] = null;
	this["oDomRef"] = null;
	this["oRootRef"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["destroy"] = 0; };

/**
 * @param {HTMLStyleElement} oStyleRef
 * @throws {Error}
 */
UCF_CSSGrid_ResizeDelegate["prototype"]["convertStyleRef"] = function(oStyleRef) {;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["convertStyleRef"]++; }; 
	/** @type {UCF_CSSGrid_ResizeDelegate} */
	var self = this;

	if (oStyleRef) {
		oStyleRef["textContent"] = oStyleRef["textContent"]["replace"](/\}@media\(min-width:(.*?)\){/g, function(_, sBreakpoint) {
			/** @type {string} */
			var sClass = UCF_CSSGrid_ResizeDelegate["sGetNewRandomClass"]();

			self["aBreakpoints"][UCF_DomUtil["iConvertAnySizeToPixel"](sBreakpoint)] = sClass;

			return '.' + sClass;
		})["replace"](';.', ';}.'); // replace(string,string) replaces only the first occurrence

		if (UCF_JsUtil["bIsEmpty"](this["aBreakpoints"])) {
			throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))(this["oDomRef"]["id"] + ' has no media queries => no need to listen to resize');
		}
	} else {
		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))(this["oDomRef"]["id"] + ' has no <style> => no need to listen to resize');
	}
};;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["convertStyleRef"] = 0; };

/**
 * @static
 * @return {string}
 */
UCF_CSSGrid_ResizeDelegate["sGetNewRandomClass"] = function() {;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["sGetNewRandomClass"]++; }; 
	/** @type {string} */
	var c = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

	// eslint-disable-next-line no-magic-numbers
	return c["charAt"](Math["floor"](Math["random"]() * 52)) +
		// eslint-disable-next-line no-magic-numbers
		c["charAt"](Math["floor"](Math["random"]() * 52)) +
		// eslint-disable-next-line no-magic-numbers
		c["charAt"](Math["floor"](Math["random"]() * 52));
};;if (__UCF_COVERAGE__) { UCF_CSSGrid_ResizeDelegate["_"]["sGetNewRandomClass"] = 0; };

};
sap["ls"]["preload"]["UCF_Calculator"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 * @param {string} sId identifier of the calculator
 */
function UCF_Calculator(oDomRef, oLS, sId) {if (__UCF_COVERAGE__) { UCF_Calculator["_"]["UCF_Calculator"]++; }; 
	if (arguments["length"] > 0) {
		/** @type {string} */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sId"] = sId;

		// create calculator
		oDomRef = this["oCreateDom"]();
		oLS["oGetAssociatedAreaRef"]()["appendChild"](oDomRef);

		UCF_LayeredControl["apply"](this, [oDomRef, oLS, sId]);
		this["defineEvents"](['Close', 'Select']);

		// number format
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sFormat"] = null;
		this["sDefaultDecimalSeparator"] = '.';
		switch (this["oLS"]["oSystem"]["sLanguage"]["toUpperCase"]()) {
			case 'BE':
			case 'BG':
			case 'CS':
			case 'DA':
			case 'DE':
			case 'EL':
			case 'ES':
			case 'ET':
			case 'FI':
			case 'FR':
			case 'HR':
			case 'HU':
			case 'IS':
			case 'IT':
			case 'LT':
			case 'LV':
			case 'NO':
			case 'PL':
			case 'PT':
			case 'Ro':
			case 'RU':
			case 'SK':
			case 'SL':
			case 'SQ':
			case 'SV':
			case 'TR':
			case 'UK':
				this["sDefaultDecimalSeparator"] = ',';
				break;
		}
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sDecimalSeparator"] = this["sDefaultDecimalSeparator"];

		// array to save numbers and operators for the next calculation
		this["aInput"] = new Array();

		// array to save all user input as long as the calculator is open
		this["aHistory"] = new Array();

		/** @type {HTMLInputElement} field dom ref */
		this["oInputField"] = null;

		/** @type {HTMLSpanElement} field dom ref for aria-describedby */
		this["oInputFieldDescr"] = null;

		/** @type {string} input field value */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sValue"] = null;

		/** @type {boolean} flag if the field value should be overwritten or extended */
		this["bOverwrite"] = false;

		/** @type {string} last input type */
		this["sLastInput"] = 'NUMBER';

		/** @type {boolean} */
		this["bEnhancePopupWindows"] = true;

		/** @type {boolean} */
		this["bKeepAlive"] = true;
	}
};window["UCF_Calculator"] = UCF_Calculator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Calculator"); UCF_Calculator["_"] = {UCF_Calculator: 0}; }; ;
UCF_Calculator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_Calculator.prototype["sClassName"] = "UCF_Calculator";

/** @override */
UCF_Calculator["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["setDefaultValues"]++; }; };;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["setDefaultValues"] = 0; };

/** @override */
UCF_Calculator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["destroy"]++; }; 
	this["sValue"] = null;
	this["oInputFieldDescr"] = null;
	this["oInputField"] = null;
	this["aHistory"] = null;
	this["aInput"] = null;
	this["sDecimalSeparator"] = null;
	this["oConnectedControl"] = null;
	this["sFormat"] = null;
	this["sId"] = null;

	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["destroy"] = 0; };

/**
 * @see UCF_LayeredControl
 * @private
 */
UCF_Calculator["prototype"]["addClassesOnOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["addClassesOnOpen"]++; }; 
	if (!UCF_DomUtil["bHasClass"](this["oRootRef"], UCF_LayeredControl["BOX_SHADOW_CLASS"])) {
		UCF_DomUtil["addClass"](this["oRootRef"], UCF_LayeredControl["BOX_SHADOW_CLASS"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["addClassesOnOpen"] = 0; };

/**
 * Renders the HTML of the root container
 * @private
 * @return {HTMLDivElement} the created HTML div object
 */
UCF_Calculator["prototype"]["oCreateDom"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["oCreateDom"]++; }; 
	/** @type {HTMLDivElement} */
	var oDiv = document["createElement"]('DIV');

	oDiv["setAttribute"]('ct', 'Calculator');
	oDiv["setAttribute"]('id', this["sId"]);
	oDiv["setAttribute"]('class', 'urCalcBody');
	oDiv["setAttribute"]('role', 'application');
	oDiv["style"]["position"] = 'absolute';
	//	oDiv.style.width = '205px';
	oDiv["style"]["top"] = '-1000px';

	return oDiv;
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["oCreateDom"] = 0; };

/**
 * Sets the connected control. The connected control is the control for which you
 * opened the calculator.
 *
 * @param {UCF_Control} oControl the control instance
 * @private
 */
UCF_Calculator["prototype"]["setConnectedControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["setConnectedControl"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oControl) === 'object', "typeof(oControl) === 'object'", "Calculator.js(167): setConnectedControl"); };

	this["oConnectedControl"] = oControl;
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["setConnectedControl"] = 0; };

/**
 * Sets the number format
 *
 * @param {string} sFormat value of the calculator input field
 * @private
 */
UCF_Calculator["prototype"]["setFormat"] = function(sFormat) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["setFormat"]++; }; 
	this["sFormat"] = sFormat;

	// get decimal separator from the format
	if (this["sFormat"]) {
		if (sFormat["lastIndexOf"](',') > sFormat["lastIndexOf"]('.')) this["sDecimalSeparator"] = ',';
		else if (sFormat["lastIndexOf"](',') < sFormat["lastIndexOf"]('.')) this["sDecimalSeparator"] = '.';
	}
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["setFormat"] = 0; };

/**
 * Formats the value in decimal format
 *
 * @return {string} the decimal separator character
 * @private
 */
UCF_Calculator["prototype"]["sGetDecimalSeparator"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["sGetDecimalSeparator"]++; }; 
	return this["sDecimalSeparator"];
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["sGetDecimalSeparator"] = 0; };

/**
 * Formats the value in decimal format
 *
 * @param {string} sValue value of the calculator input field
 * @return {string} formatted string value
 * @private
 */
UCF_Calculator["prototype"]["sGetFormattedValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["sGetFormattedValue"]++; }; 
	var sFormattedValue = sValue;
	var sOutValue;
	var sDecimalSeparator = this["sGetDecimalSeparator"]();
	var iLast = sFormattedValue["lastIndexOf"](sDecimalSeparator);
	var sLHS;
	var sRHS;

	if (iLast > 0) {
		sFormattedValue = sFormattedValue["replace"](/,/g, '#');
		sFormattedValue = sFormattedValue["replace"](/\./g, '#');
		sLHS = sFormattedValue["substring"](0, iLast);
		sRHS = sFormattedValue["substring"](iLast + 1, sFormattedValue["length"]);
		sFormattedValue = sLHS + sDecimalSeparator + sRHS;
		sFormattedValue = sFormattedValue["replace"](/#/g, '');
	} else if (sDecimalSeparator === ',') {
		sFormattedValue = sFormattedValue["replace"](/\./g, '');
	} else {
		sFormattedValue = sFormattedValue["replace"](/,/g, '');
	}

	sOutValue = sFormattedValue;
	// make sure that the value is a number
	if (sDecimalSeparator === ',')
		sFormattedValue = sFormattedValue["replace"](/,/g, '\.');
	sFormattedValue = parseFloat(sFormattedValue);
	if (isNaN(sFormattedValue))
		return 0;
	else
		return sOutValue["toString"]();
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["sGetFormattedValue"] = 0; };

/**
 * Sets the value of the calculator input field
 *
 * @param {string} sValue value of the calculator input field
 * @private
 */
UCF_Calculator["prototype"]["setValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["setValue"]++; }; 
	var sFormattedValue = this["sGetFormattedValue"](sValue);

	this["sValue"] = sFormattedValue;
	if (this["oInputField"]) this["oInputField"]["value"] = this["sValue"];
	this["bOverwrite"] = true;
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["setValue"] = 0; };

/**
 * Gets the formatted value of the calculator input field
 *
 * @return {string} the actual value string
 * @private
 */
UCF_Calculator["prototype"]["sGetValue"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["sGetValue"]++; }; 
	return this["sValue"];
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["sGetValue"] = 0; };

/**
 * Opens the calculator
 * @private
 */
UCF_Calculator["prototype"]["open"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["open"]++; }; 
	var oWindow = this["oLS"]["oBrowserWindow"];

	// listen to all events
	oWindow["attachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');

	// open
	this["bOpen"] = true;
	this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);
	this["setOpenerRef"](this["oConnectedControl"]["oRootRef"]);
	this["render"]();
	this["openBase"]();

	// initialize value
	this["oInputField"] = UCF_DomUtil["$"](this["sId"] + '-in');
	if (this["sValue"]) this["setValue"](this["sValue"]);
	else this["setValue"]('0');

	if (window["UCF_System"]["bIsAria"]) {
		this["oInputFieldDescr"] = UCF_DomUtil["$"](this["sId"] + '-value');
		this["oInputFieldDescr"]["textContent"] = this["oLS"]["sGetText"]('SAPUR_CALC_RESULT') + ' ' + this["sValue"];
	}

	// initialize array for calculation
	this["aInput"] = new Array();

	if (this["oLS"]["oSystem"]["bIs508"] || window["UCF_System"]["bIsAria"]) {
		this["oInputField"]["focus"]();
	} else {
		UCF_DomUtil["$"](this["sId"] + '-ce')["focus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["open"] = 0; };

/**
 * close the calculator
 * @private
 * @param {boolean} bCancelled
 */
UCF_Calculator["prototype"]["close"] = function(bCancelled) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["close"]++; }; 
	if (!this["bOpen"]) return;

	// detach listening on any events
	var oWindow = this["oLS"]["oBrowserWindow"];
	oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');

	if (this["oDomRef"]) {
		UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
	}

	// reset decimal separator to default
	this["sDecimalSeparator"] = this["sDefaultDecimalSeparator"];

	// close
	this["bOpen"] = false;
	this["closeBase"]();
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["close"] = 0; };

/**
 * Handles all events
 *
 * @param {UCF_Event} oEvent the event object
 * @private
 */
UCF_Calculator["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onAnyEvent"]++; }; 
	var oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');
	var oSource = oBrowserEvent["oGetSource"]();
	var oSourceRoot = oBrowserEvent["oGetSourceRoot"]();

	// close calculator if you click somewhere outside
	if ((oBrowserEvent["sGetName"]() === 'click' || oBrowserEvent["sGetName"]() === 'touchstart') &&
		oSourceRoot !== this["oDomRef"] &&
		oSourceRoot !== this["oConnectedControl"]["oDomRef"] &&
		(oSource !== this["oConnectedControl"]["oGetHelpButtonRef"]() || this["oConnectedControl"]["bFieldHelpFloating"])
	) {
		this["close"](false);
	} else if (oBrowserEvent["sGetName"]() === 'lsfocuslost' && !(UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]() || window["UCF_System"]["sDevice"] === 'standards')) {
		this["close"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onAnyEvent"] = 0; };

/**
 * Add number to the field
 *
 * @param {string} sValue number or comma
 * @private
 */
UCF_Calculator["prototype"]["addNumber"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["addNumber"]++; }; 
	var sFieldValue = this["oInputField"]["value"];

	// allow only one , or .
	if (sValue === this["sDecimalSeparator"] && sFieldValue["indexOf"](sValue) > 0)
		return;

	// overwrite or append value
	if ((sFieldValue === '0' || this["bOverwrite"]) && sValue === this["sDecimalSeparator"])
		this["oInputField"]["value"] = '0' + this["sDecimalSeparator"];
	else if (sFieldValue === '0' || this["bOverwrite"])
		this["oInputField"]["value"] = sValue;
	else
		this["oInputField"]["value"] += sValue;

	this["bOverwrite"] = false;
	this["sLastInput"] = 'NUMBER';
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["addNumber"] = 0; };

/**
 * Add operator
 *
 * @param {string} sOperator the operator
 * @private
 */
UCF_Calculator["prototype"]["addOperator"] = function(sOperator) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["addOperator"]++; }; 
	if (this["aHistory"]["length"] > 1 && this["aHistory"][this["aHistory"]["length"] - 2] === '=') {
		this["aInput"] = new Array();
	}

	if (this["sLastInput"] === 'OPERATOR') return;

	this["aInput"]["push"](this["oInputField"]["value"]);

	if (this["aInput"]["length"] > 2) {
		var sValue = this["aInput"]["join"]('');
		sValue = sValue["replace"](/,/g, '\.');
		try {
			sValue = UCF_JsUtil["eval"]('return ' + sValue);
		} catch (e) {
			sValue = 'Error';
		}
		if (this["sDecimalSeparator"] === ',') sValue = sValue["toString"]()["replace"](/\./g, ',');
		this["oInputField"]["value"] = sValue;
		this["aInput"] = new Array();
		this["aInput"]["push"](this["oInputField"]["value"]);
	}

	this["aInput"]["push"](sOperator);

	this["bOverwrite"] = true;
	this["sLastInput"] = 'OPERATOR';
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["addOperator"] = 0; };

/**
 * Evaluate
 *
 * @private
 */
UCF_Calculator["prototype"]["evaluate"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["evaluate"]++; }; 
	if (this["aHistory"]["length"] > 1 && this["aHistory"][this["aHistory"]["length"] - 2] === '=')
		this["aInput"][0] = this["oInputField"]["value"];
	else
		this["aInput"]["push"](this["oInputField"]["value"]);

	var sValue = this["aInput"]["join"]('');
	sValue = sValue["replace"](/,/g, '\.');
	sValue = sValue["replace"](/%/g, '');
	if (sValue !== 'Error') {
		try {
			sValue = UCF_JsUtil["eval"]('return ' + sValue);
		} catch (e) {
			sValue = 'Error';
		}
	}
	if (this["sDecimalSeparator"] === ',') sValue = sValue["toString"]()["replace"](/\./g, ',');
	this["oInputField"]["value"] = sValue;

	this["aInput"] = new Array();
	this["bOverwrite"] = true;
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["evaluate"] = 0; };
/**
 * ClearField
 *
 * @private
 */
UCF_Calculator["prototype"]["clearField"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["clearField"]++; }; 
	this["oInputField"]["value"] = '0';
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["clearField"] = 0; };

/**
 * ClearAll
 *
 * @private
 */
UCF_Calculator["prototype"]["clearAll"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["clearAll"]++; }; 
	this["oInputField"]["value"] = '0';
	this["aInput"] = new Array();
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["clearAll"] = 0; };

/**
 * ClearLast
 *
 * @private
 */
UCF_Calculator["prototype"]["clearLast"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["clearLast"]++; }; 
	if (this["oInputField"]["value"]["length"] === 1)
		this["oInputField"]["value"] = '0';
	else {
		this["oInputField"]["value"] = this["oInputField"]["value"]["substring"](0, this["oInputField"]["value"]["length"] - 1);
	}
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["clearLast"] = 0; };

/**
 * Handles the click event on the DatePicker
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Calculator["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Calculator.js(471): onclick"); };

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource["id"] == null || oSource["id"] === '')
		oSource = oSource["parentElement"];
	var sBtnValue = oSource["id"];
	sBtnValue = sBtnValue["replace"](this["sId"] + '-', '');
	this["aHistory"]["push"](sBtnValue);

	switch (sBtnValue) {
		case '0':
			this["addNumber"](sBtnValue);
			break;
		case '1':
			this["addNumber"](sBtnValue);
			break;
		case '2':
			this["addNumber"](sBtnValue);
			break;
		case '3':
			this["addNumber"](sBtnValue);
			break;
		case '4':
			this["addNumber"](sBtnValue);
			break;
		case '5':
			this["addNumber"](sBtnValue);
			break;
		case '6':
			this["addNumber"](sBtnValue);
			break;
		case '7':
			this["addNumber"](sBtnValue);
			break;
		case '8':
			this["addNumber"](sBtnValue);
			break;
		case '9':
			this["addNumber"](sBtnValue);
			break;
		case '.':
			this["addNumber"](sBtnValue);
			break;
		case ',':
			this["addNumber"](sBtnValue);
			break;
		case '+':
			this["addOperator"](sBtnValue);
			break;
		case '-':
			this["addOperator"](sBtnValue);
			break;
		case '/':
			this["addOperator"](sBtnValue);
			break;
		case '*':
			this["addOperator"](sBtnValue);
			break;
		case 'sqrt':
			this["sqrt"]();
			break;
		case '%':
			this["percentage"]();
			break;
		case '1/x':
			this["inverse"]();
			break;
		case '+/-':
			this["exchangeSign"]();
			break;
		case '=':
			this["evaluate"]();
			break;
		case 'c':
			this["clearAll"]();
			break;
		case 'ce':
			this["clearField"]();
			break;
		case 'ok':
		case 'ok-r':
			this["handleOk"](oBrowserEvent);
			break;
		case 'cancel':
			this["close"](true);
			break;
	}
	if (window["UCF_System"]["bIsAria"])
		this["oInputFieldDescr"]["textContent"] =
		this["oLS"]["sGetText"]('SAPUR_CALC_RESULT') + ' ' + this["oInputField"]["value"];
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onclick"] = 0; };

UCF_Calculator["prototype"]["handleOk"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["handleOk"]++; }; 
	this["evaluate"]();
	this["fireEvent"](this["E_EVENTS"]["Select"], {
		"value": this["oInputField"]["value"],
		"bTouchInteraction": oBrowserEvent["bIsTouchInteraction"]()
	});
	this["close"](false);
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["handleOk"] = 0; };

UCF_Calculator["prototype"]["sqrt"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["sqrt"]++; }; 
	var sValue = this["oInputField"]["value"];
	if (this["sDecimalSeparator"] === ',')
		sValue = sValue["toString"]()["replace"](/,/g, '.');
	sValue = Math["sqrt"](sValue);
	if (this["sDecimalSeparator"] === ',')
		sValue = sValue["toString"]()["replace"](/\./g, ',');
	this["oInputField"]["value"] = sValue;
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["sqrt"] = 0; };

UCF_Calculator["prototype"]["percentage"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["percentage"]++; }; 
	var sValue = this["oInputField"]["value"];
	if (this["sDecimalSeparator"] === ',')
		sValue = sValue["toString"]()["replace"](/,/g, '.');
	if (this["aInput"]["length"] > 1 && !isNaN(parseInt(this["aInput"][0]))) {
		sValue = this["aInput"][0] / 100 * sValue;
	}
	this["bOverwrite"] = true;
	if (this["sDecimalSeparator"] === ',')
		sValue = sValue["toString"]()["replace"](/\./g, ',');
	this["oInputField"]["value"] = sValue;
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["percentage"] = 0; };

UCF_Calculator["prototype"]["exchangeSign"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["exchangeSign"]++; }; 
	var sValue = this["oInputField"]["value"];
	if (this["sDecimalSeparator"] === ',')
		sValue = sValue["toString"]()["replace"](/,/g, '.');
	sValue *= -1;
	if (this["sDecimalSeparator"] === ',')
		sValue = sValue["toString"]()["replace"](/\./g, ',');
	this["oInputField"]["value"] = sValue;
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["exchangeSign"] = 0; };

UCF_Calculator["prototype"]["inverse"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["inverse"]++; }; 
	var sValue = this["oInputField"]["value"];
	if (this["sDecimalSeparator"] === ',')
		sValue = sValue["toString"]()["replace"](/,/g, '.');
	sValue = 1 / sValue;
	if (this["sDecimalSeparator"] === ',')
		sValue = sValue["toString"]()["replace"](/\./g, ',');
	this["oInputField"]["value"] = sValue;
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["inverse"] = 0; };

/**
 * Handles the keydown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Calculator["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onkeydown"]++; }; 
	var iKey = oBrowserEvent["iKeyCode"]();
	var bAlt = oBrowserEvent["bAlt"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Calculator.js(627): onkeydown"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'iKey=' + iKey["toString"](), "Calculator.js(628): onkeydown"); };
	if (iKey === UCF_KeyCodes["DELETE"]) {
		this["clearAll"]();
	} else if (iKey === UCF_KeyCodes["BACKSPACE"]) {
		this["clearLast"]();
	} else if (iKey === UCF_KeyCodes["ENTER"]) {
		this["handleOk"](oBrowserEvent);
	} else if (
		iKey === UCF_KeyCodes["ESCAPE"] ||
		iKey === UCF_KeyCodes["F4"] ||
		iKey === UCF_KeyCodes["F2"] ||
		(iKey === UCF_KeyCodes["ARROW_UP"] && bAlt)
	) {
		this["oConnectedControl"]["oNavigation"]["keepEditMode"]();
		this["oConnectedControl"]["focus"]();
		this["close"]();
	} else {
		return;
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onkeydown"] = 0; };

/**
 * Handles the mouseover event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_Calculator["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Calculator.js(659): onmouseover"); };

	if (window["UCF_System"]["sDevice"] !== 'standards') return;

	var oSourceDomRef = oBrowserEvent["oGetSource"]();
	if (!(oSourceDomRef && oSourceDomRef["getAttribute"]('canhover') === 'true'))
		return;
	if (oBrowserEvent["bIsMouseHover"]()) {
		if (!UCF_DomUtil["bHasClass"](oSourceDomRef, 'lsButton--hoverable')) {
			UCF_DomUtil["addClass"](oSourceDomRef, 'lsButton--hoverable');
		}
	} else {
		if (UCF_DomUtil["bHasClass"](oSourceDomRef, 'lsButton--hoverable')) {
			UCF_DomUtil["removeClass"](oSourceDomRef, 'lsButton--hoverable');
		}
	}

};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onmouseover"] = 0; };
/**
 * Handles the keypress event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Calculator["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onkeypress"]++; }; 
	var iKey = oBrowserEvent["iKeyCode"]();
	var sKey = String["fromCharCode"](iKey);

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Calculator.js(687): onkeypress"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'iKey=' + iKey["toString"]() + ' sKey=' + sKey, "Calculator.js(688): onkeypress"); };

	if (UCF_KeyCodes["TAB"] === iKey)
		return;
	if (sKey === '=') {
		this["evaluate"]();
	} else if (sKey === '*') {
		this["addOperator"]('*');
	} else if (sKey === '/' || sKey === ':') {
		this["addOperator"]('/');
	} else if (sKey === '+') {
		this["addOperator"]('+');
	} else if (sKey === '-') {
		this["addOperator"]('-');
	} else if (sKey === '%') {
		this["percentage"]();
	} else if (iKey === UCF_KeyCodes["_0"] || iKey === UCF_KeyCodes["NUMPAD_0"]) {
		this["addNumber"]('0');
	} else if (iKey === UCF_KeyCodes["_1"] || iKey === UCF_KeyCodes["NUMPAD_1"]) {
		this["addNumber"]('1');
	} else if (iKey === UCF_KeyCodes["_2"] || iKey === UCF_KeyCodes["NUMPAD_2"]) {
		this["addNumber"]('2');
	} else if (iKey === UCF_KeyCodes["_3"] || iKey === UCF_KeyCodes["NUMPAD_3"]) {
		this["addNumber"]('3');
	} else if (iKey === UCF_KeyCodes["_4"] || iKey === UCF_KeyCodes["NUMPAD_4"]) {
		this["addNumber"]('4');
	} else if (iKey === UCF_KeyCodes["_5"] || iKey === UCF_KeyCodes["NUMPAD_5"]) {
		this["addNumber"]('5');
	} else if (iKey === UCF_KeyCodes["_6"] || iKey === UCF_KeyCodes["NUMPAD_6"]) {
		this["addNumber"]('6');
	} else if (iKey === UCF_KeyCodes["_7"] || iKey === UCF_KeyCodes["NUMPAD_7"]) {
		this["addNumber"]('7');
	} else if (iKey === UCF_KeyCodes["_8"] || iKey === UCF_KeyCodes["NUMPAD_8"]) {
		this["addNumber"]('8');
	} else if (iKey === UCF_KeyCodes["_9"] || iKey === UCF_KeyCodes["NUMPAD_9"]) {
		this["addNumber"]('9');
	} else if (sKey === ',' || sKey === '.') {
		this["addNumber"](this["sDecimalSeparator"]);
	} else if (iKey === UCF_KeyCodes["C"] || sKey === 'c') {
		this["clearAll"]();
	} else if (iKey === UCF_KeyCodes["E"] || iKey === UCF_KeyCodes["DELETE"]) {
		this["clearField"]();
	} else if (iKey === UCF_KeyCodes["R"] || sKey === 'r') {
		this["inverse"]();
	} else if (
		iKey === UCF_KeyCodes["S"] || sKey === 's' ||
		(iKey === UCF_KeyCodes["Q"] && oBrowserEvent["bAlt"]())
	) {
		this["sqrt"]();
	} else if (iKey === UCF_KeyCodes["F9"]) {
		this["exchangeSign"]();
	} else if (iKey === UCF_KeyCodes["ENTER"]) {
		this["handleOk"](oBrowserEvent);
		/*	} else if (iKey == UCF_KeyCodes.SPACE &&
				oBrowserEvent.oGetSource().tagName != 'INPUT') {
				this.clearField();
				oBrowserEvent.cancel(); */
	} else if (iKey === UCF_KeyCodes["SPACE"]) {
		this["onclick"](oBrowserEvent);
	} else {
		return;
	}
	if (window["UCF_System"]["bIsAria"])
		this["oInputFieldDescr"]["textContent"] =
		this["oLS"]["sGetText"]('SAPUR_CALC_RESULT') + ' ' + this["oInputField"]["value"];
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onkeypress"] = 0; };

/**
 * Renders the datepickers HTML
 * @private
 */
UCF_Calculator["prototype"]["render"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["render"]++; }; 
	var aCalculatorHtml = new Array();
	var sOkButton = this["oLS"]["sGetText"]('SAPUR_CALC_OK');
	var sCancelButton = this["oLS"]["sGetText"]('SAPUR_CALC_CANCEL');
	var sHoverableButtonClass = 'lsButton--focusable lsButton--active';
	var sAriaDescribedBy = '',
		sAriaCancelLabel = '',
		sAriaOkLabel = '';
	var sRole = '';
	if (window["UCF_System"]["bIsAria"]) {
		sAriaDescribedBy = ' aria-describedby="' + this["sId"] + '-value" ';
		sAriaCancelLabel = ' aria-label="' + this["oLS"]["sGetText"]('SAPUR_CALC_CANCEL') + '" ';
		sAriaOkLabel = ' aria-label="' + this["oLS"]["sGetText"]('SAPUR_CALC_OK') + '" ';
		sRole = ' role="button" ';
	}

	aCalculatorHtml["push"]('<div class="urCalc" ' + this["oLS"]["sStyleAttributeName"] + '="direction:ltr" role="application"  aria-roledescription="'
		+ this["oLS"]["sGetText"]('SAPUR_CB_Calculator_TUT') + '">');

	aCalculatorHtml["push"]('<span class="lsControl--invisible" id="' +
		this["sId"] + '-value">' + this["oLS"]["sGetText"]('SAPUR_CALC_RESULT') +
		'</span>');

	aCalculatorHtml["push"]('<table cellpadding=0 class="urCalcTable" border=0 role="presentation">');
	aCalculatorHtml["push"]('<tr>');
	aCalculatorHtml["push"]('<td colspan=5 class="urCalcInptField"><input id="' +
		this["sId"] +
		'-in" type="text" value="0" class="lsCalculator--input urEdf2TxtEnbl urBorderBox" tabindex="0" aria-label="' +
		this["oLS"]["sGetText"]('SAPUR_CALC_RESULT') +
		'" ti="0"	' + this["oLS"]["sStyleAttributeName"] + '="width:100%;text-align:right;"/> </td>');
	aCalculatorHtml["push"]('</tr>');

	aCalculatorHtml["push"]('<tr>');
	aCalculatorHtml["push"]('<td colspan=4 align=right>' +
		this["sGetButtonHtml"]('ce', this["oLS"]["sGetText"]('SAPUR_CALC_CLEARENTRY'), sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('c', this["oLS"]["sGetText"]('SAPUR_CALC_CLEAR'), sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('</tr>');

	aCalculatorHtml["push"]('<tr>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('7', '', sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('8', '', sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('9', '', sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('/', this["oLS"]["sGetText"]('SAPUR_CALC_DIVIDE'), sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('sqrt', this["oLS"]["sGetText"]('SAPUR_CALC_SQRT'), sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('</tr>');

	aCalculatorHtml["push"]('<tr>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('4', '', sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('5', '', sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('6', '', sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('*', this["oLS"]["sGetText"]('SAPUR_CALC_MULTIPLY'), sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('%', this["oLS"]["sGetText"]('SAPUR_CALC_PERCENT'), sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('</tr>');

	aCalculatorHtml["push"]('<tr>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('1', '', sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('2', '', sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('3', '', sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('-', this["oLS"]["sGetText"]('SAPUR_CALC_MINUS'), sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td ' + this["oLS"]["sStyleAttributeName"] + '="direction:ltr">' +
		this["sGetButtonHtml"]('1/x', this["oLS"]["sGetText"]('SAPUR_CALC_INVERT'), sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('</tr>');

	aCalculatorHtml["push"]('<tr>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('0') + '</td>');
	aCalculatorHtml["push"]('<td ' + this["oLS"]["sStyleAttributeName"] + '="direction:ltr">' +
		this["sGetButtonHtml"]('+/-', this["oLS"]["sGetText"]('SAPUR_CALC_CHANGESIGN'), sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"](this["sDecimalSeparator"], this["oLS"]["sGetText"]('SAPUR_CALC_POINT'), sAriaDescribedBy, sRole) +
		'</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('+', this["oLS"]["sGetText"]('SAPUR_CALC_PLUS'), sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('<td>' + this["sGetButtonHtml"]('=', this["oLS"]["sGetText"]('SAPUR_CALC_EXEC'), sAriaDescribedBy, sRole) + '</td>');
	aCalculatorHtml["push"]('</tr>');

	if (sOkButton === '') {
		sOkButton = 'Ok';
	}
	if (sCancelButton === '') {
		sCancelButton = 'Cancel';
	}

	aCalculatorHtml["push"]('<tr>');
	aCalculatorHtml["push"]('<td class="urCalcOkBtnline" colspan=5 align=right>');
	if (window["UCF_System"]["bIsRTL"]) {
		aCalculatorHtml["push"]('<a id="' + this["sId"] +
			'-cancel" canhover="true"  class="lsCalculator--button lsButton lsTbarBtnStd ' + sHoverableButtonClass + ' urInlineMetricTop urNoUserSelect urBtnRadius lsButton--design-standard urBtnStd" href="#" ' +
			sRole + sAriaCancelLabel + sAriaDescribedBy +
			'>' +
			sCancelButton);
		aCalculatorHtml["push"]('&nbsp;');
		aCalculatorHtml["push"]('<a id="' +
			this["sId"] +
			'-ok-r" canhover="true" class="lsCalculator--button lsButton lsTbarBtnStd ' + sHoverableButtonClass + ' urInlineMetricTop urNoUserSelect urBtnRadius lsButton--design-emphasized urBtnStd urCalcOKBtn" href="#" tabindex=0 ti=0 ' +
			sRole + sAriaOkLabel + sAriaDescribedBy +
			'"><span id="' +
			this["sId"] + '-ok" class=urBtnCnt>' + sOkButton +
			'</span></a>');
	} else {
		aCalculatorHtml["push"]('<a id="' +
			this["sId"] +
			'-ok-r" canhover="true"  class="lsCalculator--button lsButton lsTbarBtnStd ' + sHoverableButtonClass + ' urInlineMetricTop urNoUserSelect urBtnRadius lsButton--design-emphasized urBtnStd urCalcOKBtn" href="#" tabindex=0 ti=0 ' +
			sRole + sAriaOkLabel + sAriaDescribedBy +
			'"><span id="' +
			this["sId"] + '-ok" class=urBtnCnt>' + sOkButton +
			'</span></a>');
		aCalculatorHtml["push"]('&nbsp;');
		aCalculatorHtml["push"]('<a id="' + this["sId"] +
			'-cancel" canhover="true" class="lsCalculator--button lsButton lsTbarBtnStd ' + sHoverableButtonClass + ' urInlineMetricTop urNoUserSelect urBtnRadius lsButton--design-standard urBtnStd" href="#" tabindex=0 ti=0 ' +
			sRole + sAriaCancelLabel + sAriaDescribedBy +
			'" >' +
			sCancelButton);
	}
	aCalculatorHtml["push"]('</a></td>');
	aCalculatorHtml["push"]('</tr>');

	aCalculatorHtml["push"]('</table>');

	aCalculatorHtml["push"]('</div>');

	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](this["oDomRef"], aCalculatorHtml["join"](''));

};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["render"] = 0; };

/**
 * Returns the html of a calculator button
 *
 * @param {strig} sText button text
 * @param {string} sAriaLabel
 * @param {string} sAriaDescribedBy
 * @param {string} sRole
 * @return {string}
 *
 * @private
 */
UCF_Calculator["prototype"]["sGetButtonHtml"] = function(sText, sAriaLabel, sAriaDescribedBy, sRole) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["sGetButtonHtml"]++; }; 
	var sHtml = '';
	var sButtonTag = 'a';
	var sAriaLabelText = '';
	var sAriaDescribedByText = '';
	var sHoverableButtonClass = 'lsButton--focusable lsButton--active';

	if (!sRole)
		sRole = '';
	if (sAriaLabel) {
		if (window["UCF_System"]["bIsAria"])
			sAriaLabelText = ' aria-label="' + sAriaLabel + '" ';
	}
	if (sAriaDescribedBy && window["UCF_System"]["bIsAria"])
		sAriaDescribedByText = ' ' + sAriaDescribedBy + ' ';
	if (UCF_UserAgent["bIsWebKit"]()) sButtonTag = 'span';

	sHtml = '<' + sButtonTag + ' id="' + this["sId"] + '-' + sText + '" canhover="true" class="lsCalculator--button lsCalcBtn ' + sHoverableButtonClass + ' lsButton--design-standard urBtnRadius" href="#" tabindex=0 ' +
		sRole + sAriaLabelText + sAriaDescribedByText +
		'ti=0>' + sText + '</' + sButtonTag + '>';
	return sHtml;
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["sGetButtonHtml"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Calculator["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onlsaccessibility"]++; }; 
	var text, oSource, oAccessibilityHelper;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "Calculator.js(928): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) {
		return;
	}

	oSource = oBrowserEvent["oGetSource"]();
	oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource["tagName"] === 'INPUT') {
		oAccessibilityHelper["setText"](oSource["value"]);
		oAccessibilityHelper["setControlType"]('CALC_I');
		oAccessibilityHelper["addTutor"]('CALC_I_TUT');
	} else {
		text = UCF_DomUtil["sGetInnerText"](oSource);
		/*
		 * CSN
		 * [158088111](https://support.wdf.sap.corp/sap/support/message/1580088111):
		 * '-' gets read as 'dash', should be read as 'Minus', '.' gets ignored,
		 * should be read as 'Point'
		 */
		if (text === '-')
			text = this["oLS"]["sGetText"]('SAPUR_CALC_MINUS') || 'Minus';
		if (text === '.')
			text = this["oLS"]["sGetText"]('SAPUR_CALC_POINT') || 'Point';
		if (text === 'ce')
			text = this["oLS"]["sGetText"]('SAPUR_CALC_CLEARENTRY') || 'Clear entry';
		if (text === 'c')
			text = this["oLS"]["sGetText"]('SAPUR_CALC_CLEAR') || 'Clear';
		if (text === '/')
			text = this["oLS"]["sGetText"]('SAPUR_CALC_DIVIDE') || 'Divide';
		if (text === 'sqrt')
			text = this["oLS"]["sGetText"]('SAPUR_CALC_SQRT') || 'Square root';
		if (text === '*')
			text = this["oLS"]["sGetText"]('SAPUR_CALC_MULTIPLY') || 'Multiply';
		if (text === '1/x')
			text = this["oLS"]["sGetText"]('SAPUR_CALC_INVER') || 'Invert';
		if (text === '+/-')
			text = this["oLS"]["sGetText"]('SAPUR_CALC_CHANGESIGN') || 'Change sign';

		oAccessibilityHelper["setText"](text);
		oAccessibilityHelper["setControlType"]('B');
		oAccessibilityHelper["addTutor"]('B_TUT');
	}
};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["onlsaccessibility"] = 0; };

/**
 * Detach Events and clear all objects references calls
 * @private
 */
UCF_Calculator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["destroy"]++; }; 

	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");
	this["aInput"] = null;
	this["aHistory"] = null;
	this["oInputField"] = null;
	this["oInputFieldDescr"] = null;
	this["oConnectedControl"] = null;

	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_Calculator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_Calendar"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_CalendarEntry */
/// <reference path="../CalendarEntry.js"/>

/**
 * @typedef {Object} UCF_Calendar_Column
 * @property {_ObjectRect} oRect
 * @property {HTMLTableHeaderCellElement} oDomRef
 * @property {number} [iRowsPerDay]
 */
/**
 * @typedef {Object} UCF_Calendar_Row
 * @property {_ObjectRect} oRect
 * @property {HTMLTableRowElement} oDomRef
 */

/**
 * Base class for CalendarDayView, CalendarMonthView, CalendarYearView
 *
 * @constructor
 * @param {HTMLTableElement} oDomRef the element
 * @param {UCF_LS} oLS the lightspeed instance
 */
function UCF_Calendar(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Calendar["_"]["UCF_Calendar"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "Calendar.js(39): UCF_Calendar"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Calendar.js(40): UCF_Calendar"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Calendar.js(41): UCF_Calendar"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);
	}
};window["UCF_Calendar"] = UCF_Calendar; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Calendar"); UCF_Calendar["_"] = {UCF_Calendar: 0}; }; ;
UCF_Calendar["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Calendar.prototype["sClassName"] = "UCF_Calendar";

/**
 * Creates and returns an array of UCF_CalendarEntry instances from the given
 * aEntryDomRefs
 *
 * @private
 * @param {HTMLTableElement} oEntryDomRef
 * @return {Array<UCF_CalendarEntry>} null if no entries where found otherwise
 * an array of entries.
 */
UCF_Calendar["prototype"]["aGetEntriesFromDomRef"] = function(oEntryDomRef) {;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["aGetEntriesFromDomRef"]++; }; 
	/** @type {NodeListOf<HTMLTableRowElement>} */
	var aEntryDomRefs;
	/** @type {Array} */
	var aEntries = [];
	/** @type {number} */
	var i;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oEntryDomRef === 'object', "typeof oEntryDomRef === 'object'", "Calendar.js(65): aGetEntriesFromDomRef"); };

	if (oEntryDomRef) {
		aEntryDomRefs = UCF_DomUtil["childNodes"](oEntryDomRef);
		if (aEntryDomRefs) {
			for (i = 0; i < aEntryDomRefs["length"]; i++)
				aEntries["push"](this["getEntry"](aEntryDomRefs[i]));
		}
		return aEntries;
	} else
		return null;
};;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["aGetEntriesFromDomRef"] = 0; };

/**
 * Creates and returns an UCF_CalendarEntry instance from the given oEntryDomRef
 *
 * @private
 * @param {HTMLTableElement} oEntryDomRef
 * @return {UCF_CalendarEntry} null if no valid entry was found otherwise an
 * entry instance
 */
UCF_Calendar["prototype"]["getEntry"] = function(oEntryDomRef) {;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["getEntry"]++; }; 
	/** @type {UCF_CalendarEntry} */
	var oEntry;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oEntryDomRef === 'object', "typeof oEntryDomRef === 'object'", "Calendar.js(90): getEntry"); };

	if (oEntryDomRef) {
		oEntry = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oEntryDomRef, true);

		oEntry["setCalendar"](this);

		return oEntry;
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["getEntry"] = 0; };

/**
 * Returns the rectangle position of the given dom object oDomRef
 *
 * @private
 * @param {HTMLElement} oDomRef
 * @return {_ObjectRect} Rectangle of the position (top,left,width,height)
 */
UCF_Calendar["prototype"]["getRect"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["getRect"]++; }; 
	/** @type {_ObjectRect} */
	var oRect;
	/** @type {HTMLElement} */
	var oOrig;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "Calendar.js(116): getRect"); };

	oRect = {
		"left": 0,
		"top": 0,
		"width": oDomRef["offsetWidth"],
		"height": oDomRef["offsetHeight"]
	};
	oOrig = oDomRef;

	while (oDomRef["tagName"] !== 'BODY') {
		if (
			oDomRef["tagName"] === 'DIV' &&
			UCF_DomUtil["sGetCurrentStyle"](oDomRef, 'overflow') !== 'none'
		) {
			break;
		} else {
			oRect["left"] += oDomRef["offsetLeft"];
			oRect["top"] += oDomRef["offsetTop"];
			oDomRef = oDomRef["offsetParent"];
		}
	}

	if (this["oLS"]["oSystem"]["bIsRTL"]) {
		oRect["right"] = oDomRef["offsetWidth"] - oRect["left"] - oOrig["offsetWidth"];
	}

	if (UCF_UserAgent["bIsGecko"]()) {
		oRect["left"]--;
		oRect["top"]--;
	}

	return oRect;
};;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["getRect"] = 0; };

/**
 * Sorts UCF_CalendarEntry array ascending to display the entries in row based
 * calendars. Used for CalendarDayView (all day area), CalendarMonthView
 * (weeks) and CalendarYearView
 *
 * @private
 * @param {UCF_CalendarEntry} oEntry1
 * @param {UCF_CalendarEntry} oEntry2
 * @return {-1|0|1} -1 if oEntry2 starts before oEntry1, 0 if oEntry2 starts at
 * the same time as oEntry1, 1 if oEntry1 starts before oEntry2
 */
UCF_Calendar["prototype"]["sortRowEntries"] = function(oEntry1, oEntry2) {;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["sortRowEntries"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEntry1 instanceof UCF_CalendarEntry, "oEntry1 instanceof UCF_CalendarEntry", "Calendar.js(163): sortRowEntries"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEntry2 instanceof UCF_CalendarEntry, "oEntry2 instanceof UCF_CalendarEntry", "Calendar.js(164): sortRowEntries"); };

	return (oEntry1["fStartColumn"] - oEntry2["fStartColumn"]) === 0
		? oEntry1["fStartRow"] - oEntry2["fStartRow"]
		: oEntry1["fStartColumn"] - oEntry2["fStartColumn"];
};;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["sortRowEntries"] = 0; };

/**
 * Sorts UCF_CalendarEntry array ascending to display the entries in column
 * based calendars. Used for CalendarDayView (scrollable area)
 *
 * @private
 * @param {UCF_CalendarEntry} oEntry1
 * @param {UCF_CalendarEntry} oEntry2
 * @return {-1|0|1} -1 if oEntry2 starts before oEntry1, 0 if oEntry2 starts at
 * the same time as oEntry1, 1 if oEntry1 starts before oEntry2
 */
UCF_Calendar["prototype"]["sortColEntries"] = function(oEntry1, oEntry2) {;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["sortColEntries"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEntry1 instanceof UCF_CalendarEntry, "oEntry1 instanceof UCF_CalendarEntry", "Calendar.js(182): sortColEntries"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEntry2 instanceof UCF_CalendarEntry, "oEntry2 instanceof UCF_CalendarEntry", "Calendar.js(183): sortColEntries"); };

	if (oEntry1["fStartRow"] - oEntry2["fStartRow"] !== 0) {
		return oEntry1["fStartRow"] - oEntry2["fStartRow"];
	} else if (oEntry1["bIsClone"] && !oEntry2["bIsClone"]) {
		return oEntry1["fStartColumn"] - oEntry2["fStartColumn"];
	} else {
		return oEntry1["fStartColumn"] - oEntry2["fStartColumn"];
	}
};;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["sortColEntries"] = 0; };

/**
 * Returns a collection of columns that can contain entries
 *
 * @private
 * @return {Array<UCF_Calendar_Column>}
 * Object Array with a {oDomRef: reference to the dom reference of the column,
 * oRect: top,left, width, height of the column}
 */
UCF_Calendar["prototype"]["aGetColumns"] = function() {;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["aGetColumns"]++; }; 
	/** @type {NodeListOf<HTMLTableHeaderCellElement>} */
	var aDomColumns = this["oDomRef"]["getElementsByTagName"]('TH');
	/** @type {Array<UCF_Calendar_Column>} */
	var aColumns = [];
	/** @type {number} */
	var iWidth = this["oDomRef"]["offsetWidth"];
	/** @type {number} */
	var i;
	/** @type {_ObjectRect} */
	var oRect;
	/** @type {UCF_Calendar_Column} */
	var o;

	for (i = 1; i < aDomColumns["length"]; i++) {
		oRect = this["getRect"](aDomColumns[i]);
		iWidth = iWidth - oRect["width"];
		o = { "oRect": oRect, "oDomRef": aDomColumns[i] };

		aColumns["push"](o);
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '' + (iWidth - aDomColumns[0]["offsetWidth"]), "Calendar.js(223): aGetColumns"); };

	return aColumns;
};;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["aGetColumns"] = 0; };

/**
 * Returns a collection of columns that can contain entries
 *
 * @private
 * @param {HTMLTableElement} oBaseDomRef
 * @return {Array<UCF_Calendar_Row>} Object
 * Array with a {oDomRef: reference to the dom reference of the column,
 * oRect: top,left, width, height of the column}
 */
UCF_Calendar["prototype"]["aGetRows"] = function(oBaseDomRef) {;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["aGetRows"]++; }; 
	/** @type {NodeListOf<HTMLTableRowElement>} */
	var aDomRows;
	/** @type {Array<UCF_Calendar_Row>} */
	var aRows;
	/** @type {number} */
	var i;

	if (!this["aRows"]) {
		if (!oBaseDomRef) {
			oBaseDomRef = this["oDomRef"];
		}
		aDomRows = oBaseDomRef["getElementsByTagName"]('TR');
		aRows = [];

		for (i = 0; i < aDomRows["length"]; i++) {
			if (aDomRows[i]["firstChild"]["tagName"] !== 'TH') {
				aRows["push"]({ "oRect": this["getRect"](aDomRows[i]), "oDomRef": aDomRows[i] });
			}
		}
		this["aRows"] = aRows;
	}

	return this["aRows"];
};;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["aGetRows"] = 0; };

/**
 * Returns the width of an entry based on its duration applied on the column widths of a calendar.
 * Used in the CalendarYearView and CalendarDayView(fullday)
 *
 * @private
 * @param {Array<UCF_Calendar_Column>} aColumns Array of columns created by the
 * UCF_Calendar.aGetColumns
 * @param {UCF_CalendarEntry} oEntry
 * @param {boolean} bSubstractScrollbarForLastCol
 * @return {number} Width of the entry
 */
UCF_Calendar["prototype"]["iGetEntryColumnWidth"] = function(aColumns, oEntry, bSubstractScrollbarForLastCol) {;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["iGetEntryColumnWidth"]++; }; 
	/** @type {number} */
	var iStartColumn = Math["floor"](oEntry["fStartColumn"]);
	/** @type {number} */
	var iWidth = 0;
	/** @type {number} */
	var fLastColDuration;
	/** @type {number} */
	var iLastColDurationWidth;

	// calculate the width of the calendar entry based on the width of each column
	// simple multipication does not work in this case because the column widths
	// differ slightly by rounding bugs of the browser
	if (window["UCF_System"]["bIsRTL"]) {
		if (iStartColumn + Math["floor"](oEntry["fDuration"]) >= aColumns["length"]) {
			return aColumns[iStartColumn]["oRect"]["left"] -
				aColumns[aColumns["length"] - 1]["oRect"]["left"] +
				aColumns[aColumns["length"] - 1]["oRect"]["width"];
		}
		iWidth = aColumns[iStartColumn]["oRect"]["left"] - aColumns[iStartColumn + Math["floor"](oEntry["fDuration"])]["oRect"]["left"];
		fLastColDuration = oEntry["fDuration"] - Math["floor"](oEntry["fDuration"]);
		if (
			iStartColumn + Math["floor"](oEntry["fDuration"]) === aColumns["length"] - 1 &&
			bSubstractScrollbarForLastCol
		) {
			iWidth -= 16; // eslint-disable-line no-magic-numbers
		}
		if (fLastColDuration > 0) {
			if (Math["floor"](oEntry["fDuration"]) + iStartColumn < aColumns["length"]) {
				iLastColDurationWidth = aColumns[Math["floor"](oEntry["fDuration"]) + iStartColumn]["oRect"]["width"] * fLastColDuration;
				iWidth += iLastColDurationWidth;
			}
		}
	} else {
		if (iStartColumn + Math["floor"](oEntry["fDuration"]) >= aColumns["length"]) {
			return aColumns[aColumns["length"] - 1]["oRect"]["left"] -
				aColumns[iStartColumn]["oRect"]["left"] +
				aColumns[aColumns["length"] - 1]["oRect"]["width"];
		}
		iWidth = aColumns[iStartColumn + Math["floor"](oEntry["fDuration"])]["oRect"]["left"] - aColumns[iStartColumn]["oRect"]["left"];
		if (
			iStartColumn + Math["floor"](oEntry["fDuration"]) === aColumns["length"] - 1 &&
			bSubstractScrollbarForLastCol
		) {
			iWidth -= 16; // eslint-disable-line no-magic-numbers
		}
		fLastColDuration = oEntry["fDuration"] - Math["floor"](oEntry["fDuration"]);
		if (fLastColDuration > 0) {
			if (Math["floor"](oEntry["fDuration"]) + iStartColumn < aColumns["length"]) {
				iLastColDurationWidth = aColumns[Math["floor"](oEntry["fDuration"]) + iStartColumn]["oRect"]["width"] * fLastColDuration;
				iWidth += iLastColDurationWidth;
			}
		}
	}

	return iWidth;
};;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["iGetEntryColumnWidth"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Calendar["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Calendar["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["onlsskipback"] = 0; };

UCF_Calendar["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["destroy"]++; }; 
	this["aRows"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Calendar["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_CalendarDayView"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Calendar */
/// <reference path="./base/Calendar.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_CalendarEntry */
/// <reference path="./CalendarEntry.js"/>

/**
 * @constructor
 * @param {HTMLDivElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_CalendarDayView(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["UCF_CalendarDayView"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "CalendarDayView.js(34): UCF_CalendarDayView"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CalendarDayView.js(35): UCF_CalendarDayView"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "CalendarDayView.js(36): UCF_CalendarDayView"); };

	UCF_Calendar["apply"](this, [oDomRef, oLS]);

	/** @type {Array<UCF_CalendarEntry>} */
	this["aEntries"] = null;
	/** @type {Array<UCF_CalendarEntry>} */
	this["aFullEntries"] = null;

	/** @type {number} the height of one row */
	this["fRowHeight"] = 0;

	/** @type {HTMLDivElement} */
	this["oScrollAreaDomRef"] = UCF_DomUtil["$"](this["sId"] + '-scrl');
	/** @type {UCF_ScrollArea} */
	this["oScrollArea"] = null; // eslint-disable-line @ur/no-memory-leaks

	/** @type {Array<Array<HTMLTableHeaderCellElement>>} array of all columns with another array that has the tabbable dom references */
	this["aKeyboardColumnNavigation"] = [];
	/** @type {Array<number>} the count for entries per column for accessibility */
	this["aColumnEntryCounts"] = [];
	/** @type {Array<number>} the count for fullday entries per column for accessibility */
	this["aColumnFullEntryCounts"] = [];

	/** @type {{iColumn: number, iItem: number}} */
	this["oFocusPosition"] = null;

};window["UCF_CalendarDayView"] = UCF_CalendarDayView; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CalendarDayView"); UCF_CalendarDayView["_"] = {UCF_CalendarDayView: 0}; }; ;
UCF_CalendarDayView["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Calendar"))(); UCF_CalendarDayView.prototype["sClassName"] = "UCF_CalendarDayView";

/**
 * Initializes the CalendarDayView.
 * Sets the initial scroll position and triggers drawing of entries.
 *
 * @private
 */
UCF_CalendarDayView["prototype"]["initialize"] = function () {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["initialize"]++; }; 
	/** @type {HTMLTableDataCellElement} */
	var oFirstCellDomRef = UCF_DomUtil["$"](this["sId"] + '-start');
	/** @type {HTMLElement} */
	var oFocussedElement;

	if (oFirstCellDomRef) {
		this["fRowHeight"] = oFirstCellDomRef["offsetHeight"];
		/** @type {Array<UCF_Calendar_Column>} */
		this["aColumns"] = null; // getting columns is expensive because it retrieves the widths, therefore store it here @see applySize

		this["applySize"]();

		this["drawFulldayEntries"]();
		this["drawEntries"]();

		this["initializeKeyboard"]();
		this["initializeScrollArea"]();

		this["attachBrowserEvent"]('resize', this["oDomRef"]);

		// for accessibility mode set the initial tooltip CSN: 2928108 2012
		if (window["UCF_System"]["bIs508"]) {
			oFocussedElement = UCF_DomUtil["oGetActiveElement"]();
			this["focus"]();
			if (oFocussedElement) {
				UCF_DomUtil["bFocusDomElement"](oFocussedElement);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["initialize"] = 0; };

/**
 * Initializes the scroll area of the control.
 * @private
 */
UCF_CalendarDayView["prototype"]["initializeScrollArea"] = function () {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["initializeScrollArea"]++; }; 
	if (this["bScrollable"]) {
		this["oScrollAreaDomRef"]["style"]["height"] = this["sScrollHeight"];
		this["oScrollArea"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(this["oScrollAreaDomRef"]);
		this["oScrollArea"]["setScrollPosition"](
			Math["floor"](this["fRowHeight"] * this["fScrollTop"]),
			0
		);
		this["oScrollArea"]["attachEvent"](
			this["oScrollArea"]["E_EVENTS"]["Scroll"],
			this,
			'onScroll'
		);
		this["addDelegate"](this["oScrollArea"]);
		this["attachBrowserEvent"]('scroll', this["oScrollAreaDomRef"]);
	} else {
		this["oScrollAreaDomRef"]["style"]["height"] = this["oScrollAreaDomRef"]["scrollHeight"] + 'px';
		this["oScrollAreaDomRef"]["parentNode"]["style"]["height"] = this["oScrollAreaDomRef"]["scrollHeight"] + 'px';
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["initializeScrollArea"] = 0; };

/**
 * Appies the minimal width for the outer table
 * @private
 */
UCF_CalendarDayView["prototype"]["applyMinimalWidth"] = function () {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["applyMinimalWidth"]++; }; 
	/** @type {NodeListOf<HTMLTableHeaderCellElement>} */
	var oDomColumns = this["oDomRef"]["getElementsByTagName"]('TH');
	/** @type {HTMLTableElement} */
	var oTable = UCF_DomUtil["$"](this["sId"] + '-tbl');
	/** @type {number} */
	var iMinWidth = (oDomColumns["length"] + 1) * 50; // eslint-disable-line no-magic-numbers

	if (this["oDomRef"]["offsetWidth"] < iMinWidth) {
		oTable["style"]["width"] = iMinWidth + 'px';
		// we need to detach the resize event to avoid recursive calls
		this["detachBrowserEvent"]('resize', this["oDomRef"]);

		this["oDomRef"]["style"]["overflowX"] = 'visible';
		this["oDomRef"]["offsetWidth"]; // eslint-disable-line no-unused-expressions

		// attach again
		this["attachBrowserEvent"]('resize', this["oDomRef"]);

	} else {
		oTable["style"]["width"] = '100%';
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["applyMinimalWidth"] = 0; };

/** @override */
UCF_CalendarDayView["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["destroy"]++; }; 
	this["detachBrowserEvent"]('resize', this["oDomRef"]);

	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}
	this["oScrollAreaDomRef"] = null;

	this["aFullEntries"] = null;
	this["aEntries"] = null;
	this["aKeyboardColumnNavigation"] = null;

	this["aColumns"] = null;
	this["oFocusPosition"] = null;
	this["fRowHeight"] = null;

	UCF_Calendar.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["destroy"] = 0; };

/**
 * Initializes arrays for the entry calculation
 *
 * @private
 */
UCF_CalendarDayView["prototype"]["applySize"] = function () {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["applySize"]++; }; 
	/** @type {Array<UCF_Calendar_Column>} */
	var aColumns;
	/** @type {Array<UCF_Calendar_Row>} */
	var aRows;
	/** @type {NodeListOf<HTMLTableDataCellElement>} */
	var aColCells;
	/** @type {number} */
	var iCols;

	this["applyMinimalWidth"]();

	aColumns = this["aGetColumns"]();
	aRows = this["aGetRows"](this["oScrollAreaDomRef"]);

	this["aColumns"] = aColumns; // expensive therefore store it

	aColCells = this["oScrollAreaDomRef"]["getElementsByTagName"]('TD');
	for (iCols = 0; iCols < aColumns["length"]; iCols++) {
		aColumns[iCols]["iRowsPerDay"] = aRows["length"];
		if (iCols < aColumns["length"] - 1) {
			if (
				UCF_UserAgent["bIsGecko"]() ||
				UCF_UserAgent["bIsWebKit"]() ||
				window["UCF_System"]["sDevice"] === 'standards'
			) {
				// ff,sf correction, the border is not taken into account for left and
				// width calculation
				aColumns[iCols]["oRect"]["width"]--;
			}
			aColCells[iCols]["style"]["width"] = aColumns[iCols]["oRect"]["width"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["applySize"] = 0; };

/**
 * Creates and returns an array of UCF_CalendarEntry instances from the given
 * aEntryDomRefs
 *
 * @private
 * @return {Array<UCF_CalendarEntry>} null if no entries where found otherwise
 * an array of entries.
 */
UCF_CalendarDayView["prototype"]["getFullDayEntries"] = function () {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["getFullDayEntries"]++; }; 
	if (!this["aFullEntries"]) {
		this["aFullEntries"] = this["aGetEntriesFromDomRef"](
			UCF_DomUtil["$"](this["sId"] + '-entries-fullday')
		);
	}

	return this["aFullEntries"];
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["getFullDayEntries"] = 0; };

/**
 * Creates and returns an array of UCF_CalendarEntry instances from the given
 * aEntryDomRefs. Also crates clone entries if the duration exceeds the
 * available rows and pushes them into the array
 *
 * @private
 * @return {Array<UCF_CalendarEntry>} null if no entries where found otherwise
 * an array of entries
 */
UCF_CalendarDayView["prototype"]["getEntries"] = function () {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["getEntries"]++; }; 
	/** @type {HTMLDivElement} */
	var oEntryRoot;
	/** @type {Array<UCF_CalendarEntry>} */
	var aEntries;
	/** @type {number} */
	var iEntryLength;
	/** @type {number} */
	var iRowsPerDay;
	/** @type {number} */
	var iEntryCount;
	/** @type {UCF_CalendarEntry} */
	var oEntry;
	/** @type {number} */
	var fDuration;
	/** @type {number} */
	var iCurrentCol;
	/** @type {number} */
	var fStartRow;
	/** @type {string} */
	var sEntryId;
	/** @type {number} */
	var iStartColumn;
	/** @type {number} */
	var fNewDuration;
	/** @type {number} clone counter */
	var iIndex;
	/** @type {number} index of the next column */
	var iNextCol;
	/** @type {number} the duration of the clone */
	var fCloneDuration;
	/** @type {string} */
	var sCloneId;
	/** @type {UCF_CalendarEntry} */
	var oEntryClone;

	if (!this["aEntries"]) {
		oEntryRoot = UCF_DomUtil["$"](this["sId"] + '-entries');
		aEntries = this["aGetEntriesFromDomRef"](oEntryRoot);
		iEntryLength = aEntries["length"];
		iRowsPerDay = this["aColumns"][0]["iRowsPerDay"];

		// loop over all entries and create clones if the duration leads to the
		// next day. correct the initial settings of the original entry as well
		for (iEntryCount = 0; iEntryCount < iEntryLength; iEntryCount++) {
			// retrieve the entry
			oEntry = aEntries[iEntryCount];
			fDuration = oEntry["fDuration"];
			iCurrentCol = oEntry["iStartColumn"];
			fStartRow = oEntry["fStartRow"];
			sEntryId = oEntry["sId"];

			// the column has to be in the calendar and the entry has to start in a
			// displayed row
			if (iCurrentCol < this["aColumns"]["length"] && fStartRow <= iRowsPerDay) {
				// oEntry is colspanned, needed for the OpenStart and OpenEnd settings
				// of the border
				oEntry["bRowSpanned"] = false;

				// does the entry ends in this column
				if (fStartRow + fDuration > iRowsPerDay) {
					iStartColumn = oEntry["iStartColumn"];
					// it needs to stop after the last row (iRowsPerDay + 1)
					fNewDuration = iRowsPerDay - fStartRow;

					// apply to the entry
					oEntry["fDuration"] = fNewDuration;

					// the current entry starts and ends in the same column
					oEntry["iEndColumn"] = iStartColumn;
					oEntry["fEndColumn"] = iStartColumn;
					oEntry["fEndRow"] = iRowsPerDay;
					// the current entry has an open end because it goes to next col
					oEntry["setOpenEnd"](true);

					// calculate the rest of the duration
					fDuration -= fNewDuration;

					// create clones for entries that exceed the current column
					iIndex = 0;
					while (fDuration > 0) { // eslint-disable-line max-depth
						iNextCol = oEntry["iEndColumn"] + 1 + iIndex;

						// there is no next column,if a clone already exists
						if ( // eslint-disable-line max-depth
							!this["aColumns"][iNextCol] ||
							UCF_DomUtil["$"](sEntryId + '-clone-' + iIndex)
						) {
							break;
						}

						fCloneDuration = Math["min"](fDuration, iRowsPerDay);
						sCloneId = sEntryId + '-clone-' + iIndex;
						oEntryClone = oEntry["clone"](
							sCloneId,
							oEntryRoot,
							iNextCol,
							0,
							fCloneDuration
						);
						// even the clone does not end in this column
						oEntryClone["setOpenEnd"](fDuration >= iRowsPerDay);
						// add the clone the the entries array
						aEntries["push"](oEntryClone);

						// substract the duration from the current entry
						fDuration -= fCloneDuration;
						iIndex++; // for the next clones id
					}
				}
			}
		}
		this["aEntries"] = aEntries;
	}

	return this["aEntries"];
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["getEntries"] = 0; };

/**
 * Creates and returns an array of all fullDayCells in the calender control
 *
 * @private
 * @return {Array<HTMLTableDataCellElement>} null if no entries where found
 * otherwise an array of entries.
 */
UCF_CalendarDayView["prototype"]["aGetFullDayCells"] = function () {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["aGetFullDayCells"]++; }; 
	/** @type {HTMLTableDataCellElement} */
	var oFullDayCell = UCF_DomUtil["$"](this["sId"] + '-fixed');
	/** @type {HTMLTableDataCellElement} */
	var oFullDayCellSibling = null;
	/** @type {Array<HTMLTableDataCellElement>} */
	var aFullDayCells = [];

	if (oFullDayCell) {
		aFullDayCells["push"](oFullDayCell);

		oFullDayCellSibling = oFullDayCell;

		while (UCF_DomUtil["previousSibling"](oFullDayCellSibling, 'TD')) {
			oFullDayCellSibling = UCF_DomUtil["previousSibling"](oFullDayCellSibling, 'TD');
			if (oFullDayCellSibling["id"] === this["sId"] + '-fixed') {
				aFullDayCells["push"](oFullDayCellSibling);
			}
		}

		oFullDayCellSibling = oFullDayCell;

		while (UCF_DomUtil["nextSibling"](oFullDayCellSibling, 'TD')) {
			oFullDayCellSibling = UCF_DomUtil["nextSibling"](oFullDayCellSibling, 'TD');
			if (oFullDayCellSibling["id"] === this["sId"] + '-fixed') {
				aFullDayCells["push"](oFullDayCellSibling);
			}
		}

		return aFullDayCells;
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["aGetFullDayCells"] = 0; };

/**
 * Draws all full day entries in the all day area
 *
 * @private
 */
UCF_CalendarDayView["prototype"]["drawFulldayEntries"] = function () {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["drawFulldayEntries"]++; }; 
	/** @type {HTMLTableDataCellElement} */
	var oFullDayCell = UCF_DomUtil["$"](this["sId"] + '-fixed');
	/** @type {HTMLDivElement} */
	var oFullDayNode = UCF_DomUtil["$"](this["sId"] + '-entries-fullday');
	/** @type {Array<UCF_CalendarEntry>} */
	var aFullEntries;
	/** @type {Array<number>} */
	var aEndCols;
	/** @type {number} */
	var iHeight;
	/** @type {UCF_CalendarDayView} */
	var self = this;

	if (oFullDayCell && oFullDayNode) {
		// sort them ascending per column @see UCF_Calendar.sortColEntries
		aFullEntries = this["getFullDayEntries"]()["sort"](this["sortColEntries"]);
		aEndCols = this["calculateFulldayEntryPositions"](aFullEntries);

		// calculate the positions:

		// adapt the height of the fullday cell to the max of parallel entries
		// eslint-disable-next-line no-magic-numbers
		iHeight = (5 + (aEndCols["length"] * 22));

		if (window["UCF_System"]["sDevice"] === 'standards') {
			UCF_JsUtil["forEach"](this["aGetFullDayCells"](), function (oCell) {
				oCell["style"]["height"] = iHeight + 'px';
			});
		} else if (oFullDayCell["offsetHeight"] !== iHeight) {
			oFullDayCell["style"]["height"] = iHeight + 'px';
		}

		UCF_JsUtil["forEach"](aFullEntries, function (oEntry) {
			self["drawFulldayEntry"](oEntry);
		});
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["drawFulldayEntries"] = 0; };

/**
 * Draws a full day entry in the all day area
 *
 * @private
 * @param {UCF_CalendarEntry} oFulldayEntry the entry to be drawn
 */
UCF_CalendarDayView["prototype"]["drawFulldayEntry"] = function (oFulldayEntry) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["drawFulldayEntry"]++; }; 
	/** @type {number} */
	var iStartColumn = Math["floor"](oFulldayEntry["fStartColumn"]);
	/** @type {HTMLTableElement} */
	var oTbl = UCF_DomUtil["$"](this["sId"] + '-tbl');
	/** @type {_ObjectRect} */
	var oRectOrig = this["aColumns"][iStartColumn]["oRect"];
	/** @type {_ObjectRect} */
	var oRect = {
		"top": oRectOrig["top"],
		"left": oRectOrig["left"] + 1,
		"width": oRectOrig["width"],
		"height": oRectOrig["height"],
		"right": oRectOrig["right"]
	};

	oRect["top"] = oRect["top"] + oRect["height"];
	oRect["height"] = 22; // fixed height for all entries
	oRect["top"] = oRect["top"] + ((oRect["height"] * oFulldayEntry["iLevel"]) + 1);
	oRect["width"] = this["iGetEntryColumnWidth"](
		this["aColumns"],
		oFulldayEntry,
		this["bScrollable"]
	);
	if (window["UCF_System"]["bIsRTL"]) {
		oRect["left"] = oRect["left"] - oRect["width"];
	}

	// if the width is larger than the available width, cut it out
	if (oRect["width"] + oRect["left"] > oTbl["offsetWidth"]) {
		oRect["width"] = oTbl["offsetWidth"] - oRect["left"] - 1;
	}
	oFulldayEntry["applyStyles"]();
	oFulldayEntry["setPosition"](
		oRect["left"],
		oRect["top"],
		oRect["width"],
		oRect["height"],
		oRect["right"]
	);
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["drawFulldayEntry"] = 0; };

/**
 * Calculates the position of the fullday entries in the all day area
 * Returns an array that represents the column ends
 *
 * @private
 * @param {Array<UCF_CalendarEntry>} aFullDayEntries
 * @return {Array<number>}
 */
UCF_CalendarDayView["prototype"]["calculateFulldayEntryPositions"] = function (aFullDayEntries) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["calculateFulldayEntryPositions"]++; }; 
	/** @type {Array<UCF_CalendarEntry>} */
	var aEntries = aFullDayEntries;
	/** @type {number} */
	var iEndCol = 0;
	/** @type {Array<UCF_CalendarEntry>} entries that are parallel for a level */
	var aParallelRows = [];
	/** @type {Array<number>} actual end column for an entry for a specific level */
	var aEndCols = [];
	/** @type {number} */
	var n;
	/** @type {number} */
	var iLevelCount;
	/** @type {number} */
	var x;
	/** @type {number} */
	var y;

	aEndCols[0] = 0;
	aParallelRows[0] = [];

	// push all entries into a 2 dim matrix
	for (n = 0; n < aEntries["length"]; n++) {
		iLevelCount = 0; // the number of parallel levels
		while (
			aEndCols[iLevelCount] > aEntries[n]["fStartColumn"] &&
			iLevelCount < aEndCols["length"]
		) {
			iLevelCount++;
			if (!aParallelRows[iLevelCount]) {
				aParallelRows[iLevelCount] = [];
			}
		}
		aEndCols[iLevelCount] = aEntries[n]["fEndColumn"];
		aParallelRows[iLevelCount]["push"](aEntries[n]);

		aEntries[n]["iLevel"] = iLevelCount; // set the level to the entry
		if (iEndCol < aEntries[n]["fEndColumn"]) {
			iEndCol = aEntries[n]["fEndColumn"];
		}
	}

	// loop over the matrix and add missing information for drawing the entry
	for (x = 0; x < aParallelRows["length"]; x++) {
		for (y = 0; y < aParallelRows[x]["length"]; y++) {
			aParallelRows[x][y]["iLevel"] = x;
			aParallelRows[x][y]["iMaxLevels"] = aEndCols["length"];
		}
	}

	return aEndCols;
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["calculateFulldayEntryPositions"] = 0; };

/**
 * Draws all entries of the scrollable area
 *
 * @private
 */
UCF_CalendarDayView["prototype"]["drawEntries"] = function () {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["drawEntries"]++; }; 
	/** @type {Array<UCF_CalendarEntry>} */
	var aEntries = this["getEntries"]();
	/** @type {UCF_CalendarDayView} */
	var self = this;

	if (aEntries) {
		aEntries["sort"](this["sortRowEntries"]);
		this["calculateEntryPositions"](aEntries);

		UCF_JsUtil["forEach"](aEntries, function (oEntry) {
			self["drawEntry"](oEntry);
		});
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["drawEntries"] = 0; };

/**
 * Calculates the position of entries in the scrollable area of the calendar
 *
 * @private
 * @param {Array<UCF_CalendarEntry>} aEntries
 */
UCF_CalendarDayView["prototype"]["calculateEntryPositions"] = function (aEntries) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["calculateEntryPositions"]++; }; 
	/** @type {number} */
	var iColCount = this["aColumns"]["length"];
	/** @type {Array<Array<UCF_CalendarEntry>>} */
	var aEntryCols = [];
	/** @type {number} */
	var i;
	/** @type {number} */
	var iEndRow;
	/** @type {Array<Array<UCF_CalendarEntry>>} */
	var aParallelCols;
	/** @type {Array<number>} */
	var aEndRows;
	/** @type {number} */
	var n;
	/** @type {number} */
	var iLevelCount;
	/** @type {number} */
	var x;
	/** @type {number} */
	var y;
	/** @type {boolean} */
	var bFound;
	/** @type {number} */
	var iNextCol;
	/** @type {number} */
	var iNextColEntryCount;

	// build a matrix for all columns (days)
	for (i = 0; i < iColCount; i++) {
		aEntryCols["push"]([]);
	}

	// push the entries into theis starting column (day)
	for (i = 0; i < aEntries["length"]; i++) {
		aEntryCols[Math["floor"](aEntries[i]["fStartColumn"])]["push"](aEntries[i]);
	}

	// for each column (day) build an array of parallel columns
	for (i = 0; i < iColCount; i++) {
		iEndRow = 0;
		aParallelCols = [[]];
		aEndRows = [0];

		for (n = 0; n < aEntryCols[i]["length"]; n++) {
			iLevelCount = 0;
			while (aEndRows[iLevelCount] > aEntryCols[i][n]["fStartRow"] && iLevelCount < aEndRows["length"]) {
				iLevelCount++;
				if (!aParallelCols[iLevelCount]) {
					aParallelCols[iLevelCount] = [];
				}
			}
			aEndRows[iLevelCount] = aEntryCols[i][n]["fEndRow"];
			aParallelCols[iLevelCount]["push"](aEntryCols[i][n]);

			aEntryCols[i][n]["iLevel"] = iLevelCount;
			if (iEndRow < aEntryCols[i][n]["fEndRow"]) {
				iEndRow = aEntryCols[i][n]["fEndRow"];
			}
		}

		// calculation of the spanning over the cols
		for (x = 0; x < aParallelCols["length"]; x++) {
			for (y = 0; y < aParallelCols[x]["length"]; y++) {
				aParallelCols[x][y]["iLevel"] = x;
				aParallelCols[x][y]["iMaxLevels"] = aEndRows["length"];
				aParallelCols[x][y]["iSpannedColumns"] = aEndRows["length"] - x;
				bFound = false;

				for (iNextCol = x + 1; iNextCol < aParallelCols["length"]; iNextCol++) {
					for ( // eslint-disable-line max-depth
						iNextColEntryCount = 0; iNextColEntryCount < aParallelCols[iNextCol]["length"]; iNextColEntryCount++
					) {
						if ( // eslint-disable-line max-depth
							aParallelCols[x][y]["fEndRow"] >= aParallelCols[iNextCol][iNextColEntryCount]["fStartRow"] &&
							aParallelCols[x][y]["fStartRow"] <= aParallelCols[iNextCol][iNextColEntryCount]["fEndRow"]
						) {
							bFound = true;
							break;
						}
					}

					if (bFound) { // eslint-disable-line max-depth
						break;
					}
				}
				if (bFound) {
					aParallelCols[x][y]["iSpannedColumns"] = 1;
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["calculateEntryPositions"] = 0; };

/**
 * Draws an entry in the scrollable area
 *
 * @private
 * @param {UCF_CalendarEntry} oEntry the entry to draw
 */
UCF_CalendarDayView["prototype"]["drawEntry"] = function (oEntry) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["drawEntry"]++; }; 
	/** @type {number} */
	var iColSpace = 6;
	/** @type {number} */
	var iStartColumn = Math["floor"](oEntry["fStartColumn"]);
	/** @type {_ObjectRect} */
	var oRectOrig = this["aColumns"][iStartColumn]["oRect"];
	/** @type {_ObjectRect} */
	var oRect = {
		"top": oRectOrig["top"],
		"left": oRectOrig["left"] + 1,
		"width": oRectOrig["width"],
		"height": oRectOrig["height"],
		"right": oRectOrig["right"]
	};
	/** @type {number} */
	var iColWidth = oRect["width"] - iColSpace;
	/** @type {number} */
	var iMinWidth;
	/** @type {number} left position in this column */
	var iColLeft;

	// last column is 16 pixels because scrollbar is displayed
	if (this["bScrollable"] && oEntry["fStartColumn"] === this["aColumns"]["length"] - 1) {
		iColWidth = iColWidth - 16; // eslint-disable-line no-magic-numbers
	}
	iMinWidth = Math["floor"](iColWidth / oEntry["iMaxLevels"]);

	oRect["left"] = oRect["left"] + oEntry["iLevel"] * iMinWidth - 1;
	oRect["right"] = oRect["right"] + oEntry["iLevel"] * iMinWidth - 1;
	oRect["top"] = oRect["top"] + Math["floor"](this["fRowHeight"] * oEntry["fStartRow"]);
	oRect["width"] = iMinWidth * oEntry["iSpannedColumns"];
	oRect["height"] = Math["ceil"](this["fRowHeight"] * oEntry["fDuration"]);

	// correction for parallel entries
	// the last one in the column should fill the whole column available column width
	// there is a rounfoff error that is corrected with the last parallel entry in a column
	iColLeft = oRect["left"] - oRectOrig["left"];
	if (iColLeft + oRect["width"] === iMinWidth * oEntry["iMaxLevels"]) {
		oRect["width"] = iColWidth - (iMinWidth * oEntry["iLevel"] - 1);
	}
	oEntry["applyStyles"]();
	oEntry["setPosition"](oRect["left"], oRect["top"], oRect["width"], oRect["height"], oRect["right"]);

};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["drawEntry"] = 0; };

/**
 * Initializes the keyboard navigation arrays
 */
UCF_CalendarDayView["prototype"]["initializeKeyboard"] = function () {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["initializeKeyboard"]++; }; 
	/** @type {Array<UCF_CalendarEntry>} */
	var aEntries = this["getEntries"]();
	/** @type {Array<UCF_CalendarEntry>} */
	var aFullEntries = this["getFullDayEntries"]();
	/** @type {Array<UCF_Calendar_Column>} */
	var aColumns = this["aColumns"] || this["aGetColums"]();
	/** @type {number} */
	var i;
	/** @type {number} */
	var j;
	/** @type {number} */
	var iStartColumn;
	/** @type {number} */
	var iEndColumn;

	this["aKeyboardColumnNavigation"] = [];
	this["aColumnEntryCounts"] = [];
	this["aColumnFullEntryCounts"] = [];

	for (i = 0; i < aColumns["length"]; i++) {
		this["aKeyboardColumnNavigation"][i] = [];
		this["aColumnEntryCounts"][i] = 0;
		this["aColumnFullEntryCounts"][i] = 0;
		this["aKeyboardColumnNavigation"][i]["push"](aColumns[i]["oDomRef"]);
		for (j = 0; j < aFullEntries["length"]; j++) {
			iStartColumn = Math["floor"](aFullEntries[j]["fStartColumn"]);
			iEndColumn = Math["ceil"](
				aFullEntries[j]["fStartColumn"] + aFullEntries[j]["fDuration"]
			);

			if (
				iStartColumn <= i &&
				iEndColumn > i &&
				(this["aFullEntries"][j]["bSelectable"] || window["UCF_System"]["bIs508"])
			) {
				this["aKeyboardColumnNavigation"][i]["push"](aFullEntries[j]["oDomRef"]);
				this["aColumnFullEntryCounts"][i]++;
				aFullEntries[j]["iDayIndex"] = this["aColumnFullEntryCounts"][i];
			}
		}
		for (j = 0; j < aEntries["length"]; j++) {
			iStartColumn = Math["floor"](aEntries[j]["fStartColumn"]);
			if (
				iStartColumn === i &&
				(aEntries[j]["bSelectable"] || window["UCF_System"]["bIs508"])
			) {
				this["aKeyboardColumnNavigation"][i]["push"](aEntries[j]["oDomRef"]);
				this["aColumnEntryCounts"][i]++;
				aEntries[j]["iDayIndex"] = this["aColumnEntryCounts"][i];
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["initializeKeyboard"] = 0; };

/**
 * Focus a specific item
 *
 * @private
 * @param {int} iColumn the column of the item
 * @param {int} iItem the item index
 */
UCF_CalendarDayView["prototype"]["focusItem"] = function (iColumn, iItem) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["focusItem"]++; }; 
	/** @type {HTMLTableHeaderCellElement} */
	var oDomRef = null;

	if (this["oFocusPosition"]) {
		oDomRef = this["aKeyboardColumnNavigation"][this["oFocusPosition"]["iColumn"]][this["oFocusPosition"]["iItem"]];
		if (oDomRef) {
			UCF_DomUtil["setTabIndex"](oDomRef, -1);
		}
	}

	if (this["aColumns"]) {
		if (iColumn === -1) {
			iColumn = this["aColumns"]["length"] - 1;
		} else if (iColumn > this["aColumns"]["length"] - 1) {
			iColumn = 0;
		}
		if (iItem === -1) {
			iColumn--;
			iItem = this["aKeyboardColumnNavigation"][iColumn]["length"] - 1;
		} else if (iItem > this["aKeyboardColumnNavigation"][iColumn]["length"] - 1) {
			iColumn++;
			iItem = 0;
		}
		if (iColumn === -1) {
			iColumn = this["aColumns"]["length"] - 1;
			iItem = 0;
		} else if (iColumn > this["aColumns"]["length"] - 1) {
			iColumn = 0;
			iItem = 0;
		}
		this["oFocusPosition"] = { "iColumn": iColumn, "iItem": iItem };
		oDomRef = this["aKeyboardColumnNavigation"][this["oFocusPosition"]["iColumn"]][this["oFocusPosition"]["iItem"]];
		if (oDomRef) {
			UCF_DomUtil["setTabIndex"](oDomRef, 0);
			oDomRef["focus"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["focusItem"] = 0; };

/**
 * Focus element by DOM reference
 *
 * @param {element} oDomRef the DOM element to focus
 */
UCF_CalendarDayView["prototype"]["focusElementFromNavigation"] = function (oDomRef) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["focusElementFromNavigation"]++; }; 
	/** @type {number} */
	var i;
	/** @type {number} */
	var j;

	if (this["aKeyboardColumnNavigation"]) {
		for (i = 0; i < this["aKeyboardColumnNavigation"]["length"]; i++) {
			for (j = 0; j < this["aKeyboardColumnNavigation"][i]["length"]; j++) {
				if (oDomRef === this["aKeyboardColumnNavigation"][i][j]) {
					this["focusItem"](i, j);

					return;
				}
			}
		}
		this["focusItem"](0, 0);
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["focusElementFromNavigation"] = 0; };

/** @override */
UCF_CalendarDayView["prototype"]["collectFocusInfo"] = function (oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "CalendarDayView.js(863): collectFocusInfo"); };
	if (this["oFocusPosition"]) {
		oFocusInfo["setApplyControl"](this);
		oFocusInfo["addParam"]('iColumn', this["oFocusPosition"]["iColumn"]);
		oFocusInfo["addParam"]('iItem', this["oFocusPosition"]["iItem"]);
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["collectFocusInfo"] = 0; };

/** @override */
UCF_CalendarDayView["prototype"]["applyFocusInfo"] = function (oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "CalendarDayView.js(873): applyFocusInfo"); };
	this["oFocusPosition"] = {
		"iColumn": oFocusInfo["oGetParam"]('iColumn'),
		"iItem": oFocusInfo["oGetParam"]('iItem')
	};
	this["focusItem"](this["oFocusPosition"]["iColumn"], this["oFocusPosition"]["iItem"]);
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["applyFocusInfo"] = 0; };

/**
 * Handles the onclick event for the CalendarDayView
 * and fires semantic events based on the clicked element
 * the semantic events that are handled are:
 * SELECTHEADER, SELECTCELL
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onclick"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onclick"]++; }; 
	/** @type {HTMLElement} */
	var oEventDomRef = oBrowserEvent["oGetSource"]();
	/** @type {HTMLTableHeaderCellElement|HTMLTableDataCellElement} */
	var oCellRef = UCF_DomUtil["oGetParentByAttribute"](oEventDomRef, 'cidx');
	/** @type {number} */
	var iRow;
	/** @type {number} */
	var iCol;
	/** @type {boolean} */
	var bFullDay;
	/** @type {UCF_Control} */
	var oSourceControl;
	/** @type {number} */
	var iScrollTop;
	/** @type {HTMLTableHeaderCellElement} */
	var oTh;

	if (oCellRef && !oBrowserEvent["bGetCancelBubble"]()) {
		iRow = parseInt(oCellRef["getAttribute"]('ridx'));
		iCol = parseInt(oCellRef["getAttribute"]('cidx'));
		bFullDay = oCellRef["getAttribute"]('fr') != null;

		if (isNaN(iRow)) {
			this["fireHeaderSelect"](this["sId"], iCol);
		} else {
			this["fireCellSelect"](this["sId"], iRow, iCol, bFullDay);
		}
	}

	oSourceControl = oBrowserEvent["oGetSourceControl"]();
	if (UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_CalendarEntry')) {
		if (this["oScrollArea"]) {
			iScrollTop = this["oScrollAreaDomRef"]["scrollTop"];
			this["focusElementFromNavigation"](oSourceControl["oDomRef"]);
			if (iScrollTop > 0) {
				this["oScrollArea"]["setScrollPosition"](iScrollTop, 0);
			}
		}
	} else {
		oTh = UCF_DomUtil["oGetParentByTagName"](oEventDomRef, 'TH');
		if (oTh) {
			this["focusElementFromNavigation"](oTh);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onclick"] = 0; };

/**
 * Handles the resize event for the CalendarDayView
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onresize"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onresize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(946): onresize"); };

	this["applySize"]();
	this["drawFulldayEntries"]();
	this["drawEntries"]();

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onresize"] = 0; };

/**
 * Handles the scroll event for the CalendarDayView and fires the according
 * scroll event. In this case the scroll top is the number of rows that are scrolled
 *
 * @private
 * @param {UCF_Event} oEvent the internal event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onScroll"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onScroll"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "CalendarDayView.js(964): onScroll"); };
	this["fireScroll"](this["sId"], oEvent["oGetParam"]('iScrollTop') / this["fRowHeight"]);
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onScroll"] = 0; };

/**
 * Handles the lsnext event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlsnext"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsnext"]++; }; 
	/** @type {number} */
	var iKey;
	/** @type {boolean} */
	var bAlt;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(980): onlsnext"); };

	if (this["oFocusPosition"]) {
		iKey = oBrowserEvent["iKeyCode"]();
		bAlt = oBrowserEvent["bAlt"]();

		if (
			iKey === UCF_KeyCodes["ARROW_UP"] &&
			!bAlt &&
			this["aKeyboardColumnNavigation"][this["oFocusPosition"]["iColumn"]][this["oFocusPosition"]["iItem"]]["tagName"] !== 'TH'
		) {
			this["focusItem"](this["oFocusPosition"]["iColumn"], 0);
		} else {
			this["focusItem"](this["oFocusPosition"]["iColumn"] + 1, 0);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsnext"] = 0; };

/**
 * Handles the lsprevious event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlsprevious"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsprevious"]++; }; 
	/** @type {number} */
	var iKey;
	/** @type {boolean} */
	var bAlt;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(1010): onlsprevious"); };

	if (this["oFocusPosition"]) {
		iKey = oBrowserEvent["iKeyCode"]();
		bAlt = oBrowserEvent["bAlt"]();

		if (
			iKey === UCF_KeyCodes["ARROW_UP"] &&
			!bAlt &&
			this["aKeyboardColumnNavigation"][this["oFocusPosition"]["iColumn"]][this["oFocusPosition"]["iItem"]]["tagName"] !== 'TH'
		) {
			this["focusItem"](this["oFocusPosition"]["iColumn"], 0);
		} else {
			this["focusItem"](this["oFocusPosition"]["iColumn"] - 1, 0);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsprevious"] = 0; };

/**
 * Handles the lsfocus event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlsfocus"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsfocus"]++; }; 
	/** @type {HTMLElement} */
	var oEventDomRef;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(1038): onlsfocus"); };

	oEventDomRef = oBrowserEvent["oGetSource"]();

	if (oEventDomRef === this["oFocusDomRef"]) {
		UCF_DomUtil["setTabIndex"](this["oFocusDomRef"], -1);
		this["bInitialFocus"] = true;
		this["focusItem"](0, 0);
	}

	if (!this["oFocusPosition"]) {
		this["focusItem"](0, 0);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsfocus"] = 0; };

/**
 * Handles the lstop event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlstop"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlstop"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(1061): onlstop"); };

	if (this["oFocusPosition"]) {
		this["focusItem"](this["oFocusPosition"]["iColumn"], 0);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlstop"] = 0; };

/**
 * Handles the lsbottom event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlsbottom"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsbottom"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(1076): onlsbottom"); };

	if (this["oFocusPosition"]) {
		this["focusItem"](
			this["oFocusPosition"]["iColumn"],
			this["aKeyboardColumnNavigation"][this["oFocusPosition"]["iColumn"]]["length"] - 1
		);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsbottom"] = 0; };

/**
 * Handles the lshome event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlshome"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlshome"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(1094): onlshome"); };

	if (this["aKeyboardColumnNavigation"]) {
		this["focusItem"](0, 0);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlshome"] = 0; };

/**
 * Handles the lsend event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlsend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(1109): onlsend"); };

	if (this["aKeyboardColumnNavigation"]) {
		this["focusItem"](this["aKeyboardColumnNavigation"]["length"] - 1, 0);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsend"] = 0; };

/**
 * Handles the lspageup event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlspageup"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlspageup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(1124): onlspageup"); };

	if (this["oFocusPosition"]) {
		this["focusItem"](this["oFocusPosition"]["iColumn"], 0);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlspageup"] = 0; };

/**
 * Handles the lspagedown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlspagedown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlspagedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(1139): onlspagedown"); };

	if (this["oFocusPosition"]) {
		this["focusItem"](
			this["oFocusPosition"]["iColumn"],
			this["aKeyboardColumnNavigation"][this["oFocusPosition"]["iColumn"]]["length"] - 1
		);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlspagedown"] = 0; };

/**
 * Handles the lsskipforward event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlsskipforward"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsskipforward"] = 0; };

/**
 * Handles the lsskipback event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlsskipback"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsskipback"] = 0; };

/**
 * Handles the lstabnext event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlstabnext"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlstabnext"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(1177): onlstabnext"); };

	if (this["oFocusPosition"]) {
		if (
			this["oFocusPosition"]["iColumn"] === this["aKeyboardColumnNavigation"]["length"] - 1 &&
			this["oFocusPosition"]["iItem"] === this["aKeyboardColumnNavigation"][this["oFocusPosition"]["iColumn"]]["length"] - 1
		) {
			if (this["focusNextControl"]()) {
				UCF_DomUtil["setTabIndex"](this["oFocusDomRef"], 0);
				oBrowserEvent["cancel"]();
			}
		} else {
			this["focusItem"](this["oFocusPosition"]["iColumn"], this["oFocusPosition"]["iItem"] + 1);
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlstabnext"] = 0; };

/**
 * Handles the lstabprevious event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlstabprevious"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlstabprevious"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(1202): onlstabprevious"); };

	if (this["oFocusPosition"]) {
		if (
			this["oFocusPosition"]["iColumn"] === 0 &&
			this["oFocusPosition"]["iItem"] === 0
		) {
			if (this["focusPreviousControl"]()) {
				UCF_DomUtil["setTabIndex"](this["oFocusDomRef"], 0);
				oBrowserEvent["cancel"]();
			}
		} else {
			this["focusItem"](this["oFocusPosition"]["iColumn"], this["oFocusPosition"]["iItem"] - 1);
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlstabprevious"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarDayView["prototype"]["onlsaccessibility"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_Control} */
	var oSourceControl;
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper;
	/** @type {HTMLElement} */
	var oSource;
	/** @type {boolean} */
	var bIsColumn;
	/** @type {string} */
	var sText;
	/** @type {number} */
	var iFullDayEntriesOfDay;
	/** @type {number} */
	var iEntriesOfDay;
	/** @type {UCF_CalendarEntry} */
	var oEntry;
	/** @type {HTMLXmpElement} */
	var oLegendDomRef;
	/** @type {string} */
	var sSemantic;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarDayView.js(1248): onlsaccessibility"); };

	oSourceControl = oBrowserEvent["oGetSourceControl"]();

	if (oSourceControl === this || UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_CalendarEntry')) {
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
		oSource = oBrowserEvent["oGetSource"]();
		bIsColumn = oSource["tagName"] === 'TH';

		if (bIsColumn) {
			sText = '';

			if (this["bInitialFocus"]) {
				if (this["oDomRef"]["getAttribute"]('tp') === 'D') {
					oAccessibilityHelper["setControlType"]('CAL_D');
				} else {
					oAccessibilityHelper["setControlType"](
						'CAL_MD',
						new Array('' + (oSource["parentNode"]["childNodes"]["length"] - 1))
					);
				}
				sText += this["sAccessibilityDescription"];
				oAccessibilityHelper["setTooltip"](this["sTooltip"]);
				oAccessibilityHelper["addTutor"](
					'CAL_D_TUT_SI',
					[oAccessibilityHelper["sGetSkipContainerText"]()]
				);
			}

			// eslint-disable-next-line no-magic-numbers
			if (oSource["parentNode"]["childNodes"]["length"] > 2) {
				if (sText["length"] > 0) {
					sText += ' - ';
				}
				sText += UCF_DomUtil["sGetInnerText"](oSource);
				sText += ' - ' + oAccessibilityHelper["sGetText"](
					'CAL_DCOL',
					new Array('' + oSource["cellIndex"], '' + (oSource["parentNode"]["childNodes"]["length"] - 1))
				);

				iFullDayEntriesOfDay = this["aColumnFullEntryCounts"][oSource["cellIndex"] - 1];
				iEntriesOfDay = this["aColumnEntryCounts"][oSource["cellIndex"] - 1];

				if (iEntriesOfDay === 1) {
					sText += ' - ' + oAccessibilityHelper["sGetText"]('CAL_DCOL_ENTRY_1');
				} else {
					sText += ' - ' + oAccessibilityHelper["sGetText"](
						'CAL_DCOL_ENTRY',
						new Array('' + iEntriesOfDay)
					);
				}

				if (iFullDayEntriesOfDay === 1) {
					sText += ' - ' + oAccessibilityHelper["sGetText"]('CAL_DCOL_FULLENTRY_1');
				} else {
					sText += ' - ' + oAccessibilityHelper["sGetText"](
						'CAL_DCOL_FULLENTRY',
						new Array('' + iFullDayEntriesOfDay)
					);
				}
				oAccessibilityHelper["addTutor"]('CAL_DCOL_ENTRY_TUT');
				oAccessibilityHelper["addTutor"]('CAL_DCOL_TUT');

				if (this["bIsClickable"]) {
					oAccessibilityHelper["addTutor"]('CAL_DCOL_CLK_TUT');
				}
			} else {
				if (sText["length"] > 0) {
					sText += ' - ';
				}
				sText += UCF_DomUtil["sGetInnerText"](oSource);

				if (this["aEntries"]["length"] === 1) {
					sText += ' - ' + oAccessibilityHelper["sGetText"]('CAL_DCOL_ENTRY_1');
				} else {
					sText += ' - ' + oAccessibilityHelper["sGetText"](
						'CAL_DCOL_ENTRY',
						new Array('' + this["aEntries"]["length"])
					);
				}

				if (this["aFullEntries"]["length"] === 1) {
					sText += ' - ' + oAccessibilityHelper["sGetText"]('CAL_DCOL_FULLENTRY_1');
				} else {
					sText += ' - ' + oAccessibilityHelper["sGetText"](
						'CAL_DCOL_FULLENTRY',
						new Array('' + this["aFullEntries"]["length"])
					);
				}

				oAccessibilityHelper["addTutor"]('CAL_DCOL_ENTRY_TUT');
			}
			oAccessibilityHelper["setText"](sText);
			oBrowserEvent["cancelBubble"]();
		} else if (UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_CalendarEntry')) {
			oEntry = oBrowserEvent["oGetSourceControl"]();

			oAccessibilityHelper["setItemIndex"](oEntry["iDayIndex"]);
			if (oEntry["bFullDay"]) {
				oAccessibilityHelper["setItemCount"](
					this["aColumnFullEntryCounts"][this["oFocusPosition"]["iColumn"]]
				);
			} else {
				oAccessibilityHelper["setItemCount"](
					this["aColumnEntryCounts"][this["oFocusPosition"]["iColumn"]]
				);
			}

			oLegendDomRef = UCF_DomUtil["$"](this["sId"] + '-legend');
			if (oLegendDomRef) {
				oAccessibilityHelper["setLegendJSDomRef"](oLegendDomRef);
			}

			sSemantic = oSourceControl["bStriped"]
				? oSourceControl["sSemanticColor"] + '_STRIPED'
				: oSourceControl["sSemanticColor"];
			oAccessibilityHelper["addSemantic"](sSemantic);
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_CalendarDayView["prototype"]["aAttributeNames"] = ["bScrollable","sScrollHeight","fScrollTop","sTooltip","sAccessibilityDescription","sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_CalendarDayView["prototype"]["aEventNames"] = ["CellSelect","CellSelectMore","HeaderSelect","Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_CalendarDayView["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarDayView["prototype"]["bScrollable"] = true;

/**
 * @private
 * @type {string}
 */
UCF_CalendarDayView["prototype"]["sScrollHeight"] = '400px';

/**
 * @private
 * @type {number}
 */
UCF_CalendarDayView["prototype"]["fScrollTop"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_CalendarDayView["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_CalendarDayView["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_CalendarDayView["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_CalendarDayView["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_CalendarDayView["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["setDefaultValues"]++; }; 
	this["bScrollable"] = true;
	this["sScrollHeight"] = '400px';
	this["fScrollTop"] = 0;
	this["sTooltip"] = '';
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Scrollable", true, true);
		this["setClientProperty"]("ScrollHeight", '400px', true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iRowIndex Index of the selected row
 * @param {number} iColIndex Index of the selected col
 * @param {boolean} bFullday true for a full day cell
 * @fires CalendarDayView::CellSelect
 */
UCF_CalendarDayView["prototype"]["fireCellSelect"] = function(sId, iRowIndex, iColIndex, bFullday) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["fireCellSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number, ColIndex: number, Fullday: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "CalendarDayView.js(1468): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarDayView.js(1469): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarDayView.js(1470): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "CalendarDayView.js(1471): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "CalendarDayView.js(1472): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "CalendarDayView.js(1473): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "CalendarDayView.js(1474): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bFullday != null, "bFullday != null", "CalendarDayView.js(1475): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bFullday) == "boolean", "typeof(bFullday) == \"boolean\"", "CalendarDayView.js(1476): fireCellSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex,
		"Fullday": bFullday
	};
	
	
	
	
	this["fireSemanticEvent"]("CalendarDayView", "CellSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["fireCellSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iRowIndex Index of the selected row
 * @param {number} iColIndex Index of the selected col
 * @fires CalendarDayView::CellSelectMore
 */
UCF_CalendarDayView["prototype"]["fireCellSelectMore"] = function(sId, iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["fireCellSelectMore"]++; }; 
	/** @type {{Id: string, RowIndex: number, ColIndex: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "CalendarDayView.js(1501): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarDayView.js(1502): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarDayView.js(1503): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "CalendarDayView.js(1504): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "CalendarDayView.js(1505): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "CalendarDayView.js(1506): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "CalendarDayView.js(1507): fireCellSelectMore"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex
	};
	
	
	
	this["fireSemanticEvent"]("CalendarDayView", "CellSelectMore", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["fireCellSelectMore"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iColIndex Index of the selected column
 * @fires CalendarDayView::HeaderSelect
 */
UCF_CalendarDayView["prototype"]["fireHeaderSelect"] = function(sId, iColIndex) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["fireHeaderSelect"]++; }; 
	/** @type {{Id: string, ColIndex: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "CalendarDayView.js(1529): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarDayView.js(1530): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarDayView.js(1531): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "CalendarDayView.js(1532): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "CalendarDayView.js(1533): fireHeaderSelect"); };
	mParams = {
		"Id": sId,
		"ColIndex": iColIndex
	};
	
	
	this["fireSemanticEvent"]("CalendarDayView", "HeaderSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["fireHeaderSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} fScrollTop The new position of the vertical scroll bar in rows.
 * @fires CalendarDayView::Scroll
 */
UCF_CalendarDayView["prototype"]["fireScroll"] = function(sId, fScrollTop) {;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "CalendarDayView.js(1553): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarDayView.js(1554): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarDayView.js(1555): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(fScrollTop != null, "fScrollTop != null", "CalendarDayView.js(1556): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(fScrollTop) == "number", "typeof(fScrollTop) == \"number\"", "CalendarDayView.js(1557): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": fScrollTop
	};
	
	
	this["fireSemanticEvent"]("CalendarDayView", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarDayView["_"]["fireScroll"] = 0; };

};
sap["ls"]["preload"]["UCF_CalendarEntry"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * CalendarEntry represents a calendar entry for the CalendarDayView,
 * CalendarMonthView, CalendarYearView. The creation and positioning of entry
 * instances is handled by the corresponding CalendarView.
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_CalendarEntry(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["UCF_CalendarEntry"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "CalendarEntry.js(27): UCF_CalendarEntry"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CalendarEntry.js(28): UCF_CalendarEntry"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "CalendarEntry.js(29): UCF_CalendarEntry"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oCalendar"] = null;
	this["iStartColumn"] = Math["floor"](this["fStartColumn"]);
	this["iStartRow"] = Math["floor"](this["fStartRow"]);
	this["fEndColumn"] = this["fStartColumn"] + this["fDuration"];
	this["fEndRow"] = this["fStartRow"] + this["fDuration"];
	this["iEndColumn"] = Math["floor"](this["fEndColumn"]);
	this["iEndRow"] = Math["floor"](this["fEndRow"]);
	this["bOpenStart"] = this["bStartsBeforeView"];
	this["bOpenEnd"] = this["bEndsAfterView"];
	this["bIsClone"] = false;
	this["bRowSpanned"] = true;

	//fix of contrast for HCB, instead of adding a weird new parameter
	if (this["oDomRef"] && this["bAdditionalTextClickable"]) {
		var oEntryTextRef = this["oDomRef"]["getElementsByTagName"]("A")[0];
		if (oEntryTextRef && (UCF_DomUtil["sGetCurrentStyle"](oEntryTextRef, "color") == "#fff" || UCF_DomUtil["sGetCurrentStyle"](oEntryTextRef, "color") == "rgb(255, 255, 255)")) {
			oEntryTextRef["style"]["color"] = "#000";
		}
	}

};window["UCF_CalendarEntry"] = UCF_CalendarEntry; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CalendarEntry"); UCF_CalendarEntry["_"] = {UCF_CalendarEntry: 0}; }; ;
UCF_CalendarEntry["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_CalendarEntry.prototype["sClassName"] = "UCF_CalendarEntry";

UCF_CalendarEntry["prototype"]["TextAlign"] = {
	"LEFT": 0,
	"CENTER": 1,
	"RIGHT": 2
};

/**
 * Handles the onclick events on the CalendarEntry and fires
 * semantic events for SELECTADDITIONALTEXT and SELECT based on the settings of
 * Selectable or the AdditionalTextClickable
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarEntry["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["onclick"]++; }; 

	var oEventDomRef = oBrowserEvent["oGetSource"](),
		oEntryTextRef = UCF_DomUtil["oGetParentByTagName"](oEventDomRef, "A"),
		sId = this["sId"],
		iCloneIndex = sId["indexOf"]("-clone-");
	if (iCloneIndex > -1) sId = sId["substring"](0, iCloneIndex);
	if (this["bAdditionalTextClickable"] && oEntryTextRef) {
		this["fireAdditionalTextActivate"](sId, this["oCalendar"]["sId"]);
	} else if (this["bSelectable"]) {
		this["fireSelect"](sId, this["oCalendar"]["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["onclick"] = 0; };

/**
 * Sets the reference to the calendar where this entry belongs to.
 * Recalculates based on the calendar view if duplicates of the entry are necessary because is spans of more columns and rows then
 *
 * @private
 * @param {UCF_Calendar} oCalendar Calendar instance.
 */
UCF_CalendarEntry["prototype"]["setCalendar"] = function(oCalendar) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setCalendar"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCalendar != null, "oCalendar != null", "CalendarEntry.js(94): setCalendar"); };

	this["oCalendar"] = oCalendar;
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setCalendar"] = 0; };

/**
 * Applies the styles for a calendar entry based on the parameters.
 *
 * @private
 */
UCF_CalendarEntry["prototype"]["applyStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["applyStyles"]++; }; 
	if (this["bOpenStart"]) {
		if (this["bRowSpanned"])
			if (this["oLS"]["oSystem"]["bIsRTL"]) {
				this["oDomRef"]["style"]["borderRight"] = "none";
			} else {
				this["oDomRef"]["style"]["borderLeft"] = "none";
			}
		else
			this["oDomRef"]["style"]["borderTop"] = "none";
	}
	if (this["bOpenEnd"]) {
		if (this["bRowSpanned"])
			if (this["oLS"]["oSystem"]["bIsRTL"]) {
				this["oDomRef"]["style"]["borderLeft"] = "none";
			} else {
				this["oDomRef"]["style"]["borderRight"] = "none";
			}
		else
			this["oDomRef"]["style"]["borderBottom"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["applyStyles"] = 0; };
/**
 * Clones the current entry.
 *
 * @private
 * @param {string} sId the Id of the clone
 * @param {element} oParentNode the node where to include the entries dom node
 * @param {float} fStartRow StartRow of the clone
 * @param {float} fStartCol StartCol of the clone
 * @param {float} fDuration Duration of the clone
 */
UCF_CalendarEntry["prototype"]["clone"] = function(sId, oParentNode, fStartCol, fStartRow, fDuration) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["clone"]++; }; 
	var oDomClone = this["oDomRef"]["cloneNode"](true);
	oDomClone["setAttribute"]("id", sId);
	oParentNode["appendChild"](oDomClone);
	var oClone = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oDomClone, true);
	oClone["fDuration"] = fDuration;
	oClone["fStartRow"] = fStartRow;
	oClone["iStartRow"] = Math["floor"](fStartRow);
	oClone["fStartColumn"] = fStartCol;
	oClone["iStartColumn"] = Math["floor"](fStartCol);
	oClone["fEndColumn"] = fStartCol + fDuration;
	oClone["iEndColumn"] = Math["floor"](this["fEndCol"]);
	oClone["fEndRow"] = fStartRow + fDuration;
	oClone["iEndRow"] = Math["floor"](oClone["fEndRow"]);
	oClone["setCalendar"](this["oCalendar"]);
	oClone["bIsClone"] = true;
	oClone["setOpenStart"](true);
	oClone["bRowSpanned"] = this["bRowSpanned"];
	return oClone;
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["clone"] = 0; };

/**
 * Sets whether the entry has an open end
 * if the original entry goes to the next row or column
 * @param {boolean} bOpenEnd true if the entry has an open end
 */
UCF_CalendarEntry["prototype"]["setOpenEnd"] = function(bOpenEnd) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setOpenEnd"]++; }; 
	this["bOpenEnd"] = bOpenEnd;
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setOpenEnd"] = 0; };

/**
 * Sets whether the entry has an open start
 * if the original entry starts in the previous row or column
 * @param {boolean} bOpenStart true if the entry has an open start
 */
UCF_CalendarEntry["prototype"]["setOpenStart"] = function(bOpenStart) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setOpenStart"]++; }; 
	this["bOpenStart"] = bOpenStart;
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setOpenStart"] = 0; };

/**
 * Sets the position of an UCF_CalendarEntry withi the calendar.
 *
 * @private
 * @param {int} iLeft Left offset for the entry for LTR mode
 * @param {int} iTop Top offset for the entry
 * @param {int} iWidth Width of the entry
 * @param {int} iHeight Height of the entry
 * @param {int} iRight Rigth of the entry for RTL mode
 */
UCF_CalendarEntry["prototype"]["setPosition"] = function(iLeft, iTop, iWidth, iHeight, iRight) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setPosition"]++; }; 
	if (iWidth < 0 || iHeight < 0) return;
	if (this["oLS"]["oSystem"]["bIsRTL"]) {
		if (!iRight) iRight = iLeft;
		this["oDomRef"]["style"]["right"] = iRight + "px";
	} else {
		this["oDomRef"]["style"]["left"] = iLeft + "px";
	}
	this["oDomRef"]["style"]["top"] = iTop + "px";
	this["oDomRef"]["style"]["width"] = iWidth + "px";
	this["oDomRef"]["style"]["height"] = iHeight + "px";
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setPosition"] = 0; };
/**
 *
 */
UCF_CalendarEntry["prototype"]["setTextAlign"] = function(iTextAlign) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setTextAlign"]++; }; 
	if (iTextAlign == this["TextAlign"]["CENTER"]) {
		this["oDomRef"]["style"]["textAlign"] = "center";
	} else if (iTextAlign == this["TextAlign"]["RIGHT"]) {
		this["oDomRef"]["style"]["textAlign"] = "right";
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setTextAlign"] = 0; };

UCF_CalendarEntry["prototype"]["onlsselectmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["onlsselectmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarEntry.js(209): onlsselectmodifier"); };
	var sId = this["sId"],
		iCloneIndex = sId["indexOf"]("-clone-");
	if (iCloneIndex > -1) sId = sId["substring"](0, iCloneIndex);

	if (oBrowserEvent["bCtrl"]() && this["bAdditionalTextClickable"]) {
		this["fireAdditionalTextActivate"](sId, this["oCalendar"]["sId"]);
	}
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["onlsselectmodifier"] = 0; };

/**
 * Handles the lsselect event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarEntry["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarEntry.js(227): onlsselect"); };
	var sId = this["sId"],
		iCloneIndex = sId["indexOf"]("-clone-");
	if (iCloneIndex > -1) sId = sId["substring"](0, iCloneIndex);

	if (this["bSelectable"]) {
		this["fireSelect"](sId, this["oCalendar"]["sId"]);
	}
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["onlsselect"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarEntry["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarEntry.js(246): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() != this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		sText = UCF_DomUtil["sGetInnerText"](this["oDomRef"]) + " ",
		sStartText = "",
		sEndText = "";
	if (this["sStartDateText"] != "") {
		sStartText += this["sStartDateText"] + " ";
	}
	if (this["sStartTimeText"] != "") {
		sStartText += this["sStartTimeText"] + " ";
	}
	if (UCF_StringUtil["sTrim"](sStartText) != "") {
		sStartText = this["oLS"]["sGetText"]("SAPUR_CAL_ENTRY_FROM_DATETIME", [sStartText]);
	}
	if (this["sEndDateText"] != "") {
		sEndText += this["sEndDateText"] + " ";
	}
	if (this["sEndTimeText"] != "") {
		sEndText += this["sEndTimeText"] + " ";
	}
	if (UCF_StringUtil["sTrim"](sEndText) != "") {
		sEndText = this["oLS"]["sGetText"]("SAPUR_CAL_ENTRY_TO_DATETIME", [sEndText]);
	}

	if (UCF_StringUtil["sTrim"](sEndText) != "" && UCF_StringUtil["sTrim"](sStartText) != "") {
		sText += sStartText + " " + sEndText;
	} else if (UCF_StringUtil["sTrim"](sStartText) != "") {
		sText += " " + sStartText;
	} else if (UCF_StringUtil["sTrim"](sEndText) != "") {
		sText += " " + sEndText;
	}

	oAccessibilityHelper["setText"](sText);
	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["setControlType"]("B");
	oAccessibilityHelper["setSelected"](this["bSelected"]);

	var sRecurring = this["bReoccuring"] ? "_RECURRING" : "";

	if (this["bFullDay"]) {
		oAccessibilityHelper["setControlType"]("CAL_ENTRY" + sRecurring + "_FDAY");
	} else {
		oAccessibilityHelper["setControlType"]("CAL_ENTRY" + sRecurring);
	}
	if (this["bAdditionalTextClickable"]) {
		oAccessibilityHelper["addTutor"]("CAL_ENTRY_ADDL_TUT");
	}
	if (this["bSelected"] && this["bSelectable"]) {
		oAccessibilityHelper["addTutor"]("CAL_ENTRY_SEL_TUT");
	}
	if (!this["bSelected"] && this["bSelectable"]) {
		oAccessibilityHelper["addTutor"]("CAL_ENTRY_NSEL_TUT");
	}
	if (this["bStriped"]) {
		oAccessibilityHelper["setCustomStatusText"]("CAL_ENTRY_TENTATIVE");
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["onlsaccessibility"] = 0; };

/** @override */
UCF_CalendarEntry["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["destroy"]++; }; 
	this["oCalendar"] = null;
	this["bOpenEnd"] = null;
	this["bOpenStart"] = null;
	this["iEndRow"] = null;
	this["iEndColumn"] = null;
	this["fEndRow"] = null;
	this["fEndColumn"] = null;
	this["iStartRow"] = null;
	this["iStartColumn"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_CalendarEntry["prototype"]["aAttributeNames"] = ["fStartRow","fStartColumn","fDuration","bFullDay","sText","bAdditionalTextClickable","sStartDateText","sEndDateText","sStartTimeText","sEndTimeText","bStartsBeforeView","bEndsAfterView","bSelected","bSelectable","bReoccuring","sSemanticColor","bStriped","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_CalendarEntry["prototype"]["aEventNames"] = ["Select","AdditionalTextActivate"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_CalendarEntry["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_CalendarEntry["prototype"]["fStartRow"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_CalendarEntry["prototype"]["fStartColumn"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_CalendarEntry["prototype"]["fDuration"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarEntry["prototype"]["bFullDay"] = false;

/**
 * @private
 * @type {string}
 */
UCF_CalendarEntry["prototype"]["sText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarEntry["prototype"]["bAdditionalTextClickable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_CalendarEntry["prototype"]["sStartDateText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_CalendarEntry["prototype"]["sEndDateText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_CalendarEntry["prototype"]["sStartTimeText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_CalendarEntry["prototype"]["sEndTimeText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarEntry["prototype"]["bStartsBeforeView"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarEntry["prototype"]["bEndsAfterView"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarEntry["prototype"]["bSelected"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarEntry["prototype"]["bSelectable"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarEntry["prototype"]["bReoccuring"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_CalendarEntry["prototype"]["sSemanticColor"] = "STANDARD";

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarEntry["prototype"]["bStriped"] = false;

/**
 * @private
 * @type {string}
 */
UCF_CalendarEntry["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_CalendarEntry["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setDefaultValues"]++; }; 
	this["fStartRow"] = 0;
	this["fStartColumn"] = 0;
	this["fDuration"] = 0;
	this["bFullDay"] = false;
	this["sText"] = '';
	this["bAdditionalTextClickable"] = false;
	this["sStartDateText"] = '';
	this["sEndDateText"] = '';
	this["sStartTimeText"] = '';
	this["sEndTimeText"] = '';
	this["bStartsBeforeView"] = false;
	this["bEndsAfterView"] = false;
	this["bSelected"] = false;
	this["bSelectable"] = false;
	this["bReoccuring"] = false;
	this["sSemanticColor"] = "STANDARD";
	this["bStriped"] = false;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("StartRow", 0, true);
		this["setClientProperty"]("StartColumn", 0, true);
		this["setClientProperty"]("Duration", 0, true);
		this["setClientProperty"]("FullDay", false, true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("AdditionalTextClickable", false, true);
		this["setClientProperty"]("StartDateText", '', true);
		this["setClientProperty"]("EndDateText", '', true);
		this["setClientProperty"]("StartTimeText", '', true);
		this["setClientProperty"]("EndTimeText", '', true);
		this["setClientProperty"]("StartsBeforeView", false, true);
		this["setClientProperty"]("EndsAfterView", false, true);
		this["setClientProperty"]("Selected", false, true);
		this["setClientProperty"]("Selectable", false, true);
		this["setClientProperty"]("Reoccuring", false, true);
		this["setClientProperty"]("SemanticColor", "STANDARD", true);
		this["setClientProperty"]("Striped", false, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the entry
 * @param {string} sCalendarId Identifier of the calendar
 * @fires CalendarEntry::Select
 */
UCF_CalendarEntry["prototype"]["fireSelect"] = function(sId, sCalendarId) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, CalendarId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "CalendarEntry.js(509): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarEntry.js(510): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarEntry.js(511): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCalendarId != null, "sCalendarId != null", "CalendarEntry.js(512): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCalendarId) == "string", "typeof(sCalendarId) == \"string\"", "CalendarEntry.js(513): fireSelect"); };
	mParams = {
		"Id": sId,
		"CalendarId": sCalendarId
	};
	
	if (sCalendarId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sCalendarId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "CalendarId");
			}
		}
	this["fireSemanticEvent"]("CalendarEntry", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the entry
 * @param {string} sCalendarId Identifier of the calendar
 * @fires CalendarEntry::AdditionalTextActivate
 */
UCF_CalendarEntry["prototype"]["fireAdditionalTextActivate"] = function(sId, sCalendarId) {;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["fireAdditionalTextActivate"]++; }; 
	/** @type {{Id: string, CalendarId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "CalendarEntry.js(540): fireAdditionalTextActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarEntry.js(541): fireAdditionalTextActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarEntry.js(542): fireAdditionalTextActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCalendarId != null, "sCalendarId != null", "CalendarEntry.js(543): fireAdditionalTextActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCalendarId) == "string", "typeof(sCalendarId) == \"string\"", "CalendarEntry.js(544): fireAdditionalTextActivate"); };
	mParams = {
		"Id": sId,
		"CalendarId": sCalendarId
	};
	
	if (sCalendarId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sCalendarId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "CalendarId");
			}
		}
	this["fireSemanticEvent"]("CalendarEntry", "AdditionalTextActivate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarEntry["_"]["fireAdditionalTextActivate"] = 0; };

};
sap["ls"]["preload"]["UCF_CalendarMonthView"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Calendar */
/// <reference path="./base/Calendar.js"/>

/**
 * @typedef {Object} UCF_CalendarMonthView_Cell
 * @property {HTMLTableDataCellElement} oDomRef
 * @property {boolean} bClickable
 * @property {number} iCount
 * @property {Array<HTMLElement>} aEntries
 */
/**
 * @typedef {Object} UCF_CalendarMonthView_Tab
 * @property {number} x
 * @property {number} y
 * @property {number} [z]
 */

/**
 * @constructor
 * @param {HTMLDivElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_CalendarMonthView(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["UCF_CalendarMonthView"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "CalendarMonthView.js(40): UCF_CalendarMonthView"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CalendarMonthView.js(41): UCF_CalendarMonthView"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "CalendarMonthView.js(42): UCF_CalendarMonthView"); };

	UCF_Calendar["apply"](this, [oDomRef, oLS]);

	/** @type {boolean} */
	this["bInitial"] = true;
	/** @type {Array<UCF_CalendarEntry>} */
	this["aEntries"] = null;
	/** @type {Array<UCF_Calendar_Column>} */
	this["aColumns"] = null;
	/** @type {Array<UCF_Calendar_Row>} */
	this["aRows"] = null;
	/** @type {Array<Array<UCF_CalendarMonthView_Cell>>} */
	this["aCellNavigation"] = null;
	/** @type {Array<UCF_CalendarMonthView_Tab>} */
	this["aTabNavigation"] = null;
	/** @type {UCF_CalendarMonthView_Cell} */
	this["oFocusedCell"] = null;
};window["UCF_CalendarMonthView"] = UCF_CalendarMonthView; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CalendarMonthView"); UCF_CalendarMonthView["_"] = {UCF_CalendarMonthView: 0}; }; ;
UCF_CalendarMonthView["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Calendar"))(); UCF_CalendarMonthView.prototype["sClassName"] = "UCF_CalendarMonthView";

/**
 * Handles the initialize event and attaches to the resize of the browser
 *
 * @private
 */
UCF_CalendarMonthView["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["initialize"]++; }; 
	/** @type {HTMLTableElement} */
	var oTable = UCF_DomUtil["$"](this["sId"] + '-tbl');

	if (this["oDomRef"]["offsetWidth"] < 400) { // eslint-disable-line no-magic-numbers
		if (!this["bInitial"]) {
			this["detachBrowserEvent"]('resize', this["oDomRef"]);
		}
		oTable["style"]["width"] = '400px';
		this["oDomRef"]["style"]["overflowX"] = 'visible';
		this["oDomRef"]["offsetWidth"]; // eslint-disable-line no-unused-expressions
		if (!this["bInitial"]) {
			this["attachBrowserEvent"]('resize', this["oDomRef"]);
		}
	} else {
		oTable["style"]["width"] = '100%';
		this["oDomRef"]["style"]["overflowX"] = 'visible';
	}
	if (this["bInitial"]) {
		this["attachBrowserEvent"]('resize', this["oDomRef"]);
		// keyboard navigation initialization
		this["createCellNavigationStructure"]();
		this["iInitialWidth"] = this["oDomRef"]["offsetWidth"];
	}

	// draw the entries
	this["initializeMatrix"]();

	this["drawEntries"]();
	if (this["bInitial"]) {
		// keyboard navigation initialization
		this["createTabNavigationStructure"]();
		this["bInitial"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["initialize"] = 0; };

/** @override */
UCF_CalendarMonthView["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["destroy"]++; }; 
	this["detachBrowserEvent"]('resize', this["oDomRef"]);

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	this["sWeek"] = null;
	this["iTabItem"] = null;
	this["sTimerId"] = null;
	this["oFocusedElement"] = null;
	this["oFocusedCell"] = null;
	this["iInitialWidth"] = null;
	this["aRows"] = null;
	this["aColumns"] = null;
	this["aEntries"] = null;

	UCF_Calendar.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["destroy"] = 0; };

/**
 * Fires semantic events based on the element that recieved the BrowserEvent
 * the semantic events that are handled are:
 * SELECTHEADER, SELECTCELL
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["select"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["select"]++; }; 
	/** @type {HTMLElement} */
	var oEventDomRef = oBrowserEvent["oGetSource"]();
	/** @type {HTMLTableHeaderCellElement} */
	var oCellRef = UCF_DomUtil["oGetParentByAttribute"](oEventDomRef, 'cidx');
	/** @type {number} */
	var iRow;
	/** @type {number} */
	var iCol;

	if (oCellRef && !oBrowserEvent["bGetCancelBubble"]()) {
		iRow = parseInt(oCellRef["getAttribute"]('ridx'));
		iCol = parseInt(oCellRef["getAttribute"]('cidx'));

		if (isNaN(iRow)) {
			this["fireHeaderSelect"](this["sId"], iCol);
		} else if (
			oEventDomRef["className"] === 'MORE2' ||
			(oEventDomRef["getAttribute"]('MORE') === 'true' && oBrowserEvent["bCtrl"]())
		) {
			this["fireCellSelectMore"](this["sId"], iRow, iCol);
		} else if (oCellRef["getAttribute"]('SELECT') === 'true') {
			this["fireCellSelect"](this["sId"], iRow, iCol);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["select"] = 0; };

/**
 * Focus the clicked element of the calendar month view
 *
 * @param {HTMLElement} oDomRef
 */
UCF_CalendarMonthView["prototype"]["focusElementFromNavigation"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["focusElementFromNavigation"]++; }; 
	/** @type {number} */
	var i;
	/** @type {number} */
	var j;
	/** @type {UCF_CalendarMonthView_Cell} */
	var oCell;
	/** @type {number} */
	var n;

	for (i = 0; i < this["aCellNavigation"]["length"]; i++) {
		for (j = 0; j < this["aCellNavigation"][i]["length"]; j++) {
			oCell = this["aCellNavigation"][i][j];
			if (oDomRef === oCell["oDomRef"]) {
				this["focusCell"](j, i);

				return;
			}
			if (oCell["aEntries"]) {
				for (n = 0; n < oCell["aEntries"]["length"]; n++) {
					if (oCell["aEntries"][n] === oDomRef) { // eslint-disable-line max-depth
						this["oFocusedCell"] = { "x": j, "y": i };
						this["oFocusedElement"] = oCell["aEntries"][n];
						UCF_DomUtil["setTabIndex"](this["oFocusedElement"], 0);
						this["oFocusedElement"]["focus"]();

						return;
					}
				}
			}
		}
	}

	this["focusCell"](0, 0);
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["focusElementFromNavigation"] = 0; };

/**
 * Handles the onlselectmodifier event for the CalendarMonthView
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["onlsselectmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsselectmodifier"]++; }; 
	this["select"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsselectmodifier"] = 0; };
/**
 * Handles the onlselect event for the CalendarMonthView
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsselect"]++; }; 
	this["select"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsselect"] = 0; };

/**
 * Handles the onclick event for the CalendarMonthView
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onclick"]++; }; 
	/** @type {HTMLElement} */
	var oEventDomRef = oBrowserEvent["oGetSource"]();
	/** @type {UCF_Control} */
	var oSourceControl = oBrowserEvent["oGetSourceControl"]();
	/** @type {HTMLTableDataCellElement} */
	var oTd;

	if (oSourceControl["sClassName"] === 'UCF_CalendarEntry') {
		this["focusElementFromNavigation"](oSourceControl["oDomRef"]);
	} else {
		oTd = UCF_DomUtil["oGetParentByTagName"](oEventDomRef, 'TD');

		if (oTd && UCF_DomUtil["bContains"](this["oDomRef"], oTd)) {
			this["focusElementFromNavigation"](oTd);
		}
	}
	this["select"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onclick"] = 0; };

/**
 * Handles the resize event for the CalendarMonthView
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onresize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarMonthView.js(251): onresize"); };

	this["oDomRef"]["style"]["overflow"] = 'hidden';
	if (this["iInitialWidth"] !== this["oDomRef"]["offsetWidth"]) {
		if (this["sTimerId"]) {
			UCF_JsUtil["clearDelayedCall"](this["sTimerId"]);
		}
		// eslint-disable-next-line no-magic-numbers
		this["sTimerId"] = UCF_JsUtil["delayedCall"](10, this, 'initialize');

		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onresize"] = 0; };

/**
 * Calculates the position of entries in the calendar
 *
 * @private
 */
UCF_CalendarMonthView["prototype"]["calculateEntryPositions"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["calculateEntryPositions"]++; }; 
	/** @type {Array<UCF_Calendar_Row>} */
	var aRows = this["aRows"];
	/** @type {Array<UCF_CalendarEntry>} */
	var aEntries = this["aEntries"];
	/** @type {Array<Array<UCF_CalendarEntry>>} */
	var aMonthRows = [];
	/** @type {number} */
	var iLevelCount = 0;
	/** @type {number} */
	var n;
	/** @type {number} */
	var iStartRow;
	/** @type {number} */
	var i;
	/** @type {number} */
	var iEndCol;
	/** @type {Array<Array<UCF_CalendarEntry>>} */
	var aParallelRows;
	/** @type {Array<number>} */
	var aEndCols;
	/** @type {UCF_CalendarEntry} */
	var oRowEntry;
	/** @type {number} */
	var x;
	/** @type {number} */
	var y;

	// create an array for all rows
	for (n = 0; n < aRows["length"]; n++) {
		aMonthRows["push"]([]);
	}
	// add the entries to the row
	for (n = 0; n < aEntries["length"]; n++) {
		iStartRow = Math["floor"](aEntries[n]["fStartRow"]);
		aMonthRows[iStartRow]["push"](aEntries[n]);
	}

	// calculate parallel entries
	for (i = 0; i < aMonthRows["length"]; i++) {
		iEndCol = 0;
		aParallelRows = [];
		aEndCols = [];

		aEndCols[0] = 0;
		aParallelRows[0] = [];
		for (n = 0; n < aMonthRows[i]["length"]; n++) {
			iLevelCount = 0;
			oRowEntry = aMonthRows[i][n];
			while (
				aEndCols[iLevelCount] > oRowEntry["iStartColumn"] &&
				iLevelCount < aEndCols["length"]
			) {
				iLevelCount++;
				if (!aParallelRows[iLevelCount]) {
					aParallelRows[iLevelCount] = [];
				}
			}
			aEndCols[iLevelCount] = oRowEntry["fEndColumn"];
			aParallelRows[iLevelCount]["push"](oRowEntry);
			oRowEntry["iLevel"] = iLevelCount;
			if (iEndCol < oRowEntry["iEndColumn"]) {
				iEndCol = oRowEntry["iEndColumn"];
			}
			for (x = 0; x < aParallelRows["length"]; x++) {
				for (y = 0; y < aParallelRows[x]["length"]; y++) {
					aParallelRows[x][y]["iLevel"] = x;
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["calculateEntryPositions"] = 0; };

/**
 * Draws the calendar entries
 *
 * @private
 */
UCF_CalendarMonthView["prototype"]["drawEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["drawEntries"]++; }; 
	/** @type {HTMLDivElement} */
	var oEntriesDomRef = UCF_DomUtil["$"](this["sId"] + '-entries');
	/** @type {Array<UCF_CalendarEntry>} */
	var aEntries;
	/** @type {Array<UCF_Calendar_Row>} */
	var aRows;
	/** @type {Array<number>} */
	var aRowHeightSet;
	/** @type {number} */
	var m;
	/** @type {number} */
	var n;
	/** @type {number} */
	var iRowIdx;
	/** @type {number} */
	var iNewHeight;
	/** @type {HTMLTableRowElement} */
	var oRow;
	/** @type {NodeListOf<HTMLSpanElement>} */
	var aDays;
	/** @type {NodeListOf<HTMLImageElement>} */
	var aMores;
	/** @type {UCF_CalendarMonthView} */
	var self = this;

	if (oEntriesDomRef) {
		// draw the day entries
		this["aEntries"] = this["getEntries"](oEntriesDomRef["childNodes"]);
		this["aEntries"]["sort"](this["sortColEntries"]);

		aEntries = this["aEntries"];
		aRows = this["aRows"];
		aRowHeightSet = [];
		for (m = 0; m < aRows["length"]; m++) {
			aRowHeightSet["push"](67); // eslint-disable-line no-magic-numbers
		}

		this["calculateEntryPositions"]();

		for (n = 0; n < aEntries["length"]; n++) {
			iRowIdx = Math["floor"](aEntries[n]["fStartRow"]);
			if (aEntries[n]["iLevel"] < 5) { // eslint-disable-line no-magic-numbers
				// exit the calendar if more than 5 entries are in one day

				if (aEntries[n]["iLevel"] > 2) { // eslint-disable-line no-magic-numbers
					// change the height of the row to fit all elements
					// eslint-disable-next-line no-magic-numbers
					iNewHeight = ((aEntries[n]["iLevel"] + 1) * 16) + 20;

					if (iNewHeight > 67) { // eslint-disable-line no-magic-numbers, max-depth
						aRowHeightSet[iRowIdx] = iNewHeight;
					}
				}
			}
		}

		for (m = 0; m < aRowHeightSet["length"]; m++) {
			oRow = aRows[m]["oDomRef"];
			iNewHeight = aRowHeightSet[m];

			UCF_JsUtil["forEach"](oRow["cells"], function(oCell) {
				// TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid
				// problems with text node
				oCell["firstChild"]["style"]["height"] = iNewHeight + 'px';
			});
			oRow["style"]["height"] = iNewHeight + 'px';

			if (
				UCF_UserAgent["bIsGecko"]() ||
				UCF_UserAgent["bIsWebKit"]() ||
				window["UCF_System"]["sDevice"] === 'standards'
			) {
				aDays = oRow["getElementsByTagName"]('SPAN');
				aMores = oRow["getElementsByTagName"]('IMG');

				UCF_JsUtil["forEach"](aDays, function(oDay) {
					if (oDay) {
						if (window["UCF_System"]["sDevice"] === 'standards') {
							// eslint-disable-next-line no-magic-numbers
							oDay["style"]["top"] = iNewHeight - 13 + 'px';
						} else {
							// eslint-disable-next-line no-magic-numbers
							oDay["style"]["top"] = iNewHeight - 16 + 'px';
						}
					}
				});

				UCF_JsUtil["forEach"](aMores, function(oMore) {
					if (oMore) {
						if (window["UCF_System"]["sDevice"] === 'standards') {
							if (UCF_UserAgent["bIsGecko"]()) {
								// eslint-disable-next-line no-magic-numbers
								oMore["style"]["top"] = iNewHeight - 20 + 'px';
							} else {
								// eslint-disable-next-line no-magic-numbers
								oMore["style"]["top"] = iNewHeight - 13 + 'px';
							}
						} else if (UCF_UserAgent["bIsGecko"]()) {
							// eslint-disable-next-line no-magic-numbers
							oMore["style"]["top"] = iNewHeight - 35 + 'px';
						} else if (UCF_UserAgent["bIsWebKit"]()) {
							// eslint-disable-next-line no-magic-numbers
							oMore["style"]["top"] = iNewHeight - 25 + 'px';
						}
					}
				});
			}
		}
	}

	UCF_JsUtil["forEach"](this["aEntries"], function(oEntry) {
		self["drawEntry"](oEntry);
	});
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["drawEntries"] = 0; };

/**
 * Initializes arrays for the entry calculation
 *
 * @private
 */
UCF_CalendarMonthView["prototype"]["initializeMatrix"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["initializeMatrix"]++; }; 
	this["aColumns"] = this["aGetColumns"]();
	this["aRows"] = this["aGetRows"]();

	UCF_JsUtil["forEach"](this["aRows"], function(oRow) {
		oRow["iDaysPerWeek"] = 7;
	});
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["initializeMatrix"] = 0; };

/**
 * Creates and returns an array of UCF_CalendarEntry instances from the given
 * aEntryDomRefs
 *
 * @private
 * @param {Array<HTMLElement>} aEntryDomRefs Collection of DOMElement
 * @return {Array<UCF_CalendarEntry>} null if no entries where found otherwise
 * an array of entries
 */
UCF_CalendarMonthView["prototype"]["getEntries"] = function(aEntryDomRefs) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["getEntries"]++; }; 
	/** @type {Array<UCF_CalendarEntry>} */
	var aEntries;
	/** @type {number} */
	var iEntryLength;
	/** @type {number} */
	var i;
	/** @type {UCF_CalendarEntry} */
	var oEntry;
	/** @type {number} */
	var fDuration;
	/** @type {number} */
	var iCurrentRow;
	/** @type {number} */
	var iEndRow;
	/** @type {number} */
	var iStartRow;
	/** @type {number} */
	var iIndex;
	/** @type {number} */
	var j;
	/** @type {HTMLElement} */
	var oEntryDomClone;
	/** @type {UCF_CalendarEntry} */
	var oEntryClone;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof aEntryDomRefs === 'object' || typeof aEntryDomRefs === 'function', "typeof aEntryDomRefs === 'object' || typeof aEntryDomRefs === 'function'", "CalendarMonthView.js(513): getEntries"); };

	if (!aEntryDomRefs && aEntryDomRefs["length"] === 0) {
		return null;
	}

	aEntries = [];
	iEntryLength = aEntryDomRefs["length"];

	for (i = 0; i < iEntryLength; i++) {
		if (aEntryDomRefs[i]["nodeType"] === 1) {
			oEntry = this["getEntry"](aEntryDomRefs[i]);

			// calculate the real end row of the entry
			oEntry["iEndRow"] = oEntry["iStartRow"];
			oEntry["fEndRow"] = oEntry["fStartRow"];

			fDuration = oEntry["fDuration"];
			iCurrentRow = oEntry["iStartRow"];

			if (
				iCurrentRow >= this["aRows"]["length"] ||
				oEntry["fStartColumn"] > this["aRows"][iCurrentRow]["iDaysPerWeek"]
			) {
				continue;
			}

			if (fDuration + oEntry["fStartColumn"] > this["aRows"][iCurrentRow]["iDaysPerWeek"]) {
				while (fDuration > 0) {
					if ( // eslint-disable-line max-depth
						iCurrentRow >= this["aRows"]["length"] ||
						oEntry["fStartColumn"] > this["aRows"][iCurrentRow]["iDaysPerWeek"]
					) {
						break;
					}
					// eslint-disable-next-line max-depth
					if (iCurrentRow === oEntry["iStartRow"]) {
						fDuration = fDuration - this["aRows"][iCurrentRow]["iDaysPerWeek"] + oEntry["fStartColumn"];
						// eslint-disable-next-line max-depth
						if (iCurrentRow === this["aRows"]["length"]) {
							break;
						}
					} else {
						fDuration = fDuration - this["aRows"][iCurrentRow]["iDaysPerWeek"];
						// eslint-disable-next-line max-depth
						if (iCurrentRow === this["aRows"]["length"]) {
							break;
						}
						oEntry["iEndRow"]++;
						oEntry["fEndRow"]++;
					}
					iCurrentRow++;
				}
			}

			if (this["bInitial"] && oEntry["iEndRow"] > oEntry["iStartRow"]) {
				iEndRow = oEntry["iEndRow"];
				iStartRow = oEntry["iStartRow"];
				// correction of duration settings
				fDuration = oEntry["fDuration"];
				oEntry["fDuration"] = this["aRows"][oEntry["iStartRow"]]["iDaysPerWeek"] - oEntry["fStartColumn"];
				fDuration -= oEntry["fDuration"];
				fDuration++;
				oEntry["iStartRow"] = iStartRow;
				oEntry["iEndRow"] = iStartRow;
				iIndex = 0;

				for (j = iStartRow + 1; j <= iEndRow; j++) {
					// create a clone
					iIndex++;
					// eslint-disable-next-line max-depth
					if (UCF_DomUtil["$"](oEntry["sId"] + '-clone' + iIndex)) {
						break;
					}
					oEntryDomClone = oEntry["oDomRef"]["cloneNode"](true);
					oEntryDomClone["setAttribute"]('id', oEntry["sId"] + '-clone-' + iIndex);
					oEntry["oDomRef"]["parentNode"]["appendChild"](oEntryDomClone);

					oEntryClone = this["getEntry"](oEntryDomClone);
					oEntry["bOpenEnd"] = true;
					oEntryClone["iStartColumn"] = 0;
					oEntryClone["iStartRow"] = j;
					oEntryClone["fStartRow"] = j;
					oEntryClone["iEndRow"] = j;
					oEntryClone["setTextAlign"](oEntryClone["TextAlign"]["CENTER"]);
					oEntryClone["fStartColumn"] = 0;

					// eslint-disable-next-line max-depth
					if (fDuration - 1 > this["aRows"][j]["iDaysPerWeek"]) {
						oEntryClone["fDuration"] = this["aRows"][j]["iDaysPerWeek"];
						fDuration = fDuration - oEntryClone["fDuration"];
					} else {
						oEntryClone["fDuration"] = fDuration - 1;
					}
					oEntryClone["fEndColumn"] = oEntryClone["fStartColumn"] + oEntryClone["fDuration"];
					oEntryClone["iEndColumn"] = Math["floor"](oEntryClone["fEndColumn"]);
					oEntryClone["setCalendar"](this);

					// eslint-disable-next-line max-depth
					if (fDuration - 1 < this["aRows"][j]["iDaysPerWeek"]) {
						oEntryClone["bOpenStart"] = true;
					} else {
						oEntryClone["bOpenStart"] = true;
						oEntryClone["bOpenEnd"] = true;
					}
					oEntryClone["bIsClone"] = true;
					aEntries["push"](oEntryClone);
				}

			} else {
				fDuration = oEntry["fDuration"];
				if (fDuration > this["aRows"][oEntry["iEndRow"]]["iDaysPerWeek"]) {
					oEntry["bOpenEnd"] = true;
				}

			}
			aEntries["push"](oEntry);
			oEntry["setCalendar"](this);
		}
	}

	return aEntries;
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["getEntries"] = 0; };

/**
 * Creates the tab order array
 * @private
 */
UCF_CalendarMonthView["prototype"]["createTabNavigationStructure"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["createTabNavigationStructure"]++; }; 
	/** @type {Array<UCF_CalendarMonthView_Cell>} */
	var aCellNavigation = this["aCellNavigation"];
	/** @type {Array<UCF_CalendarEntry>} */
	var aEntries = this["aEntries"];
	/** @type {number} */
	var y;
	/** @type {number} */
	var x;
	/** @type {number} */
	var iEntryCount;
	/** @type {number} */
	var i;
	/** @type {UCF_CalendarEntry} */
	var oEntry;

	this["aTabNavigation"] = [];

	for (y = 0; y < aCellNavigation["length"]; y++) {
		for (x = 0; x < aCellNavigation[y]["length"]; x++) {
			for (iEntryCount = 0; iEntryCount < aEntries["length"]; iEntryCount++) {
				if (
					aEntries[iEntryCount]["fStartRow"] === y &&
					(aEntries[iEntryCount]["bSelectable"] || window["UCF_System"]["bIs508"]) &&
					aEntries[iEntryCount]["fStartColumn"] <= x &&
					aEntries[iEntryCount]["fEndColumn"] > x
				) {
					this["aCellNavigation"][y][x]["aEntries"][aEntries[iEntryCount]["iLevel"]] = aEntries[iEntryCount]["oDomRef"];
					this["aCellNavigation"][y][x]["iCount"]++;
				}
			}
			if (
				aCellNavigation[y][x]["aEntries"]["length"] > 0 ||
				aCellNavigation[y][x]["bClickable"]
			) {
				this["aTabNavigation"]["push"]({ "x": x, "y": y });
				aCellNavigation[y][x]["iTabIndex"] = this["aTabNavigation"]["length"] - 1;

				for (i = 0; i < aCellNavigation[y][x]["aEntries"]["length"]; i++) {
					oEntry = aCellNavigation[y][x]["aEntries"][i];
					if (oEntry) { // eslint-disable-line max-depth
						this["aTabNavigation"]["push"]({ "x": x, "y": y, "z": i });
					}
				}
			} else {
				aCellNavigation[y][x]["previousTabIndex"] = this["aTabNavigation"]["length"] - 1;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["createTabNavigationStructure"] = 0; };

/** @private */
UCF_CalendarMonthView["prototype"]["createCellNavigationStructure"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["createCellNavigationStructure"]++; }; 
	/** @type {NodeListOf<HTMLTableRowElement>} */
	var oRows = this["oDomRef"]["getElementsByTagName"]('TR');
	/** @type {number} */
	var y;
	/** @type {number} */
	var x;
	/** @type {UCF_CalendarMonthView_Cell} */
	var oCell;
	/** @type {number} */
	var iRow;
	/** @type {number} */
	var iCol;

	this["aCellNavigation"] = [];

	// loop over all cells and build a 2 dimentional array for the navigation
	// add references to cells that have more link or entry or are clickable to
	// the tab collection to the cells to the tabnavigation structure as well as
	// the inner entries of these cells
	for (y = 1; y < oRows["length"]; y++) {
		this["aCellNavigation"]["push"]([]);

		for (x = 1; x < oRows[y]["cells"]["length"]; x++) {
			oCell = oRows[y]["cells"][x];
			iRow = parseInt(oCell["getAttribute"]('ridx'));
			iCol = parseInt(oCell["getAttribute"]('cidx'));

			this["aCellNavigation"][y - 1]["push"]({
				"oDomRef": oCell,
				"bClickable": !(isNaN(iRow) && isNaN(iCol)),
				"aEntries": [],
				"iCount": 0
			});
		}
	}

};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["createCellNavigationStructure"] = 0; };

/**
 * Focus an calendar item
 *
 * @private
 * @param {int} iIndex the index of the item to focus
 */
UCF_CalendarMonthView["prototype"]["focusItem"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["focusItem"]++; }; 
	/** @type {number} */
	var iX;
	/** @type {number} */
	var iY;
	/** @type {number} */
	var iZ;

	if (iIndex >= 0 && iIndex <= this["aTabNavigation"]["length"]) {
		this["iTabItem"] = iIndex;

		iX = this["aTabNavigation"][iIndex]["x"];
		iY = this["aTabNavigation"][iIndex]["y"];
		iZ = this["aTabNavigation"][iIndex]["z"];

		if (typeof iZ === 'number') {
			if (this["oFocusedElement"]) {
				UCF_DomUtil["setTabIndex"](this["oFocusedElement"], -1);
			}
			this["oFocusedCell"] = { "x": iX, "y": iY };
			while (!this["aCellNavigation"][iY][iX]["aEntries"][iZ]) {
				iZ++;
			}
			this["oFocusedElement"] = this["aCellNavigation"][iY][iX]["aEntries"][iZ];
			UCF_DomUtil["setTabIndex"](this["oFocusedElement"], 0);
			this["oFocusedElement"]["focus"]();
		} else {
			this["focusCell"](iX, iY);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["focusItem"] = 0; };

/**
 * Focus a cell in the calendar
 *
 * @private
 * @param {int} x the x coordinate of the cell
 * @param {int} y the y coordinate of the cell
 */
UCF_CalendarMonthView["prototype"]["focusCell"] = function(x, y) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["focusCell"]++; }; 
	/** @type {number} */
	var iTabIndex;

	if (
		y >= 0 &&
		y <= this["aCellNavigation"]["length"] &&
		x >= 0 &&
		x <= this["aCellNavigation"][y]["length"] - 1
	) {
		if (this["oFocusedElement"]) {
			UCF_DomUtil["setTabIndex"](this["oFocusedElement"], -1);
		}

		if (this["aCellNavigation"][y][x]) {
			UCF_DomUtil["setTabIndex"](this["aCellNavigation"][y][x]["oDomRef"], 0);
			this["oFocusedCell"] = { "x": x, "y": y };
			this["oFocusedElement"] = this["aCellNavigation"][y][x]["oDomRef"];
			iTabIndex = this["aCellNavigation"][y][x]["iTabIndex"];
			if (typeof iTabIndex === 'number') {
				this["iTabItem"] = iTabIndex;
			} else {
				this["iTabItem"] = this["aCellNavigation"][y][x]["previousTabIndex"];
			}
			this["aCellNavigation"][y][x]["oDomRef"]["focus"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["focusCell"] = 0; };

/**
 * Handles the lstabnext event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlstabnext"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarMonthView.js(813): onlstabnext"); };

	if (this["iTabItem"] < this["aTabNavigation"]["length"] - 1) {
		this["focusItem"](this["iTabItem"] + 1);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlstabnext"] = 0; };

/**
 * Handles the lstabprevious event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlstabprevious"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarMonthView.js(828): onlstabprevious"); };

	if (this["oFocusedCell"] && this["iTabItem"] > 0) {
		if (this["aCellNavigation"][this["oFocusedCell"]["y"]][this["oFocusedCell"]["x"]]["previousTabIndex"]) {
			this["focusItem"](this["iTabItem"]);
		} else {
			this["focusItem"](this["iTabItem"] - 1);
		}
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlstabprevious"] = 0; };

/**
 * Handles the lsfocus event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsfocus"]++; }; 
	/** @type {HTMLElement} */
	var oEventDomRef;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarMonthView.js(850): onlsfocus"); };

	oEventDomRef = oBrowserEvent["oGetSource"]();

	if (oEventDomRef === this["oDomRef"]) {
		if (!this["oFocusedCell"] && !window["UCF_System"]["b508"]) {
			if (this["aTabNavigation"] && this["aTabNavigation"][0]) {
				this["focusCell"](this["aTabNavigation"][0]["x"], this["aTabNavigation"][0]["y"]);
			}
		} else {
			this["oFocusedCell"] = null;
			this["focusCell"](this["aTabNavigation"][0]["x"], this["aTabNavigation"][0]["y"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsfocus"] = 0; };

/**
 * Handles the lsup event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarMonthView.js(873): onlsup"); };

	if (this["oFocusedCell"]) {
		this["focusCell"](this["oFocusedCell"]["x"], this["oFocusedCell"]["y"] - 1);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsup"] = 0; };

/**
 * Handles the lsdown event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsdown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarMonthView.js(888): onlsdown"); };

	if (this["oFocusedCell"]) {
		this["focusCell"](this["oFocusedCell"]["x"], this["oFocusedCell"]["y"] + 1);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsdown"] = 0; };

/**
 * Handles the lsleft event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsleft"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarMonthView.js(903): onlsleft"); };

	if (this["oFocusedCell"]) {
		if (window["UCF_System"]["bIsRTL"]) {
			this["focusCell"](this["oFocusedCell"]["x"] + 1, this["oFocusedCell"]["y"]);
		} else {
			this["focusCell"](this["oFocusedCell"]["x"] - 1, this["oFocusedCell"]["y"]);
		}
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsleft"] = 0; };

/**
 * Handles the lsright event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarMonthView["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsright"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarMonthView.js(922): onlsright"); };

	if (this["oFocusedCell"]) {
		if (window["UCF_System"]["bIsRTL"]) {
			this["focusCell"](this["oFocusedCell"]["x"] - 1, this["oFocusedCell"]["y"]);
		} else {
			this["focusCell"](this["oFocusedCell"]["x"] + 1, this["oFocusedCell"]["y"]);
		}
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsright"] = 0; };

/**
 * Draw a calendar entry
 *
 * @private
 * @param {UCF_CalendarEntry} oEntry
 */
UCF_CalendarMonthView["prototype"]["drawEntry"] = function(oEntry) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["drawEntry"]++; }; 
	/** @type {number} */
	var iCellIdx = Math["floor"](oEntry["fStartColumn"]);
	/** @type {number} */
	var iStartRow = Math["floor"](oEntry["fStartRow"]);
	/** @type {HTMLTableDataCellElement} */
	var oStartCell = this["aRows"][iStartRow]["oDomRef"]["cells"][iCellIdx + 1];
	/** @type {_ObjectRect} */
	var oRectOrig = this["getRect"](oStartCell);
	/** @type {number} */
	var iHeight = 16;
	/** @type {number} */
	var iTop = oRectOrig["top"] + (iHeight * oEntry["iLevel"]) + 1;
	/** @type {number} */
	var iLeft = oRectOrig["left"] + 1;
	/** @type {number} */
	var iRight = oRectOrig["right"] + 1;
	/** @type {number} */
	var iWidth = this["iGetEntryColumnWidth"](this["aColumns"], oEntry) - 1;

	if (!oEntry["bFullDay"] && oEntry["fDuration"] < 1) {
		oEntry["fDuration"] = 1;
	}

	if (window["UCF_System"]["sDevice"] !== 'standards') {
		oEntry["oDomRef"]["style"]["lineHeight"] = '15px';
	}
	oEntry["applyStyles"]();
	oEntry["setPosition"](iLeft, iTop, iWidth, iHeight, iRight);
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["drawEntry"] = 0; };

/** @override */
UCF_CalendarMonthView["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "CalendarMonthView.js(973): collectFocusInfo"); };
	if (this["oFocusedCell"]) {
		oFocusInfo["setApplyControl"](this);
		oFocusInfo["addParam"]('iX', this["oFocusedCell"]["x"]);
		oFocusInfo["addParam"]('iY', this["oFocusedCell"]["y"]);
		if (this["oFocusedElement"]) {
			oFocusInfo["addParam"]('sElementId', '' + this["oFocusedElement"]["id"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["collectFocusInfo"] = 0; };

/** @override */
UCF_CalendarMonthView["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "CalendarMonthView.js(986): applyFocusInfo"); };
	this["oFocusedCell"] = {
		"x": oFocusInfo["oGetParam"]('iX'),
		"y": oFocusInfo["oGetParam"]('iY')
	};
	this["oFocusedElement"] = UCF_DomUtil["$"](oFocusInfo["oGetParam"]('sElementId'));
	if (this["oFocusedElement"]) {
		this["focusElementFromNavigation"](this["oFocusedElement"]);
	} else {
		this["focusCell"](this["oFocusedCell"]["x"], this["oFocusedCell"]["y"]);
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["applyFocusInfo"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarMonthView["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_Control} */
	var oSourceControl;
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper;
	/** @type {HTMLElement} */
	var oSource;
	/** @type {Array<string>} */
	var aTexts;
	/** @type {HTMLTableElement} */
	var oTable;
	/** @type {string} */
	var sWeekDay;
	/** @type {string} */
	var sDay;
	/** @type {string} */
	var sWeek;
	/** @type {number} */
	var iEntryCount;
	/** @type {string} */
	var sMonth;
	/** @type {string} */
	var iCellTabIndex;
	/** @type {UCF_CalendarMonthView_Cell} */
	var oCell;
	/** @type {Array<UCF_CalendarEntry>} */
	var aEntries;
	/** @type {number} */
	var iEntryIndex;
	/** @type {number} */
	var i;
	/** @type {HTMLXmpElement} */
	var oLegendDomRef;
	/** @type {string} */
	var sSemantic;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarMonthView.js(1041): onlsaccessibility"); };

	oSourceControl = oBrowserEvent["oGetSourceControl"]();

	if (
		oSourceControl === this ||
		UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_CalendarEntry')
	) {
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
		oSource = oBrowserEvent["oGetSource"]();
		if (oSource["getAttribute"]('className') === 'MCELL') {
			oAccessibilityHelper["setParentText"](oAccessibilityHelper["sGetText"]('CAL_M'));

			aTexts = [];
			if (!UCF_DomUtil["bContains"](this["oDomRef"], oBrowserEvent["oGetFromElement"]())) {
				this["sWeekDay"] = '';
				this["sWeek"] = '';
			}

			oTable = UCF_DomUtil["$"](this["sId"] + '-tbl');
			sWeekDay = UCF_DomUtil["sGetInnerText"](oTable["rows"][0]["cells"][oSource["cellIndex"]]);
			sDay = UCF_DomUtil["sGetInnerText"](oSource);
			sWeek = UCF_DomUtil["sGetInnerText"](oSource["parentNode"]["cells"][0]);
			iEntryCount = this["aCellNavigation"][this["oFocusedCell"]["y"]][this["oFocusedCell"]["x"]]["aEntries"]["length"];

			aTexts["push"](sWeekDay);
			aTexts["push"](sDay);
			sMonth = oSource["getAttribute"]('desc');
			if (sMonth) {
				aTexts["push"](sMonth);
			}
			if (this["sWeek"] !== sWeek) {
				aTexts["push"](oAccessibilityHelper["sGetText"]('DN_WEEK', ['' + sWeek]));
				this["sWeek"] = sWeek;
			}
			if (iEntryCount > 0) {
				aTexts["push"](oAccessibilityHelper["sGetText"]('CAL_MCELL', ['' + iEntryCount]));
			}
			oAccessibilityHelper["setText"](aTexts["join"](' - '));

			if (iEntryCount > 0) {
				oAccessibilityHelper["addTutor"]('CAL_MCELL_TUT');
			}

			// TODO: replace by UCF_DomUtil.lastChild(this.oDomRef) to avoid problems
			// with text node
			if (oSource["firstChild"]["lastChild"]["tagName"] === 'IMG') {
				oAccessibilityHelper["addTutor"]('CAL_MORE_TUT');
			}
			if (oSource["firstChild"]["className"]["indexOf"]('TOD') > 0) {
				oAccessibilityHelper["setToday"](true);
			}
		} else if (UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_CalendarEntry')) {

			iCellTabIndex = this["iTabItem"];
			if (!this["iTabItem"]) {
				return;
			}

			while (typeof this["aTabNavigation"][iCellTabIndex]["z"] !== 'number') {
				iCellTabIndex--;
			}
			if (iCellTabIndex === -1) {
				return;
			}

			oCell = this["aCellNavigation"][this["aTabNavigation"][iCellTabIndex]["y"]][this["aTabNavigation"][iCellTabIndex]["x"]];
			aEntries = oCell["aEntries"];
			iEntryIndex = 0;
			iEntryCount = oCell["iCount"];
			for (i = 0; i < iEntryCount; i++) {
				iEntryIndex++;
				if (oSourceControl["oDomRef"] === aEntries[i]) {
					break;
				}
			}
			oAccessibilityHelper["setItemCount"](iEntryCount);
			oAccessibilityHelper["setItemIndex"](iEntryIndex);

			oLegendDomRef = UCF_DomUtil["$"](this["sId"] + '-legend');
			if (oLegendDomRef) {
				oAccessibilityHelper["setLegendJSDomRef"](oLegendDomRef);
			}

			sSemantic = oSourceControl["bStriped"]
				? oSourceControl["sSemanticColor"] + '_STRIPED'
				: oSourceControl["sSemanticColor"];
			oAccessibilityHelper["addSemantic"](sSemantic);
		} else if (oSource === this["oDomRef"]) {
			oAccessibilityHelper["setControlType"]('CAL_M');
			oAccessibilityHelper["setText"](this["sAccessibilityDescription"]);
			oAccessibilityHelper["setTooltip"](this["sTooltip"]);
			oAccessibilityHelper["addTutor"](
				'CAL_M_TUT_SI',
				[oAccessibilityHelper["sGetSkipContainerText"]()]
			);
		}
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_CalendarMonthView["prototype"]["aAttributeNames"] = ["sTooltip","sAccessibilityDescription","sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_CalendarMonthView["prototype"]["aEventNames"] = ["CellSelect","CellSelectMore","HeaderSelect"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_CalendarMonthView["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_CalendarMonthView["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_CalendarMonthView["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_CalendarMonthView["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_CalendarMonthView["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_CalendarMonthView["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iRowIndex Index of the selected row
 * @param {number} iColIndex Index of the selected col
 * @fires CalendarMonthView::CellSelect
 */
UCF_CalendarMonthView["prototype"]["fireCellSelect"] = function(sId, iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["fireCellSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number, ColIndex: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "CalendarMonthView.js(1215): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarMonthView.js(1216): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarMonthView.js(1217): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "CalendarMonthView.js(1218): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "CalendarMonthView.js(1219): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "CalendarMonthView.js(1220): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "CalendarMonthView.js(1221): fireCellSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex
	};
	
	
	
	this["fireSemanticEvent"]("CalendarMonthView", "CellSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["fireCellSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iRowIndex Index of the selected row
 * @param {number} iColIndex Index of the selected col
 * @fires CalendarMonthView::CellSelectMore
 */
UCF_CalendarMonthView["prototype"]["fireCellSelectMore"] = function(sId, iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["fireCellSelectMore"]++; }; 
	/** @type {{Id: string, RowIndex: number, ColIndex: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "CalendarMonthView.js(1244): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarMonthView.js(1245): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarMonthView.js(1246): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "CalendarMonthView.js(1247): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "CalendarMonthView.js(1248): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "CalendarMonthView.js(1249): fireCellSelectMore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "CalendarMonthView.js(1250): fireCellSelectMore"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex
	};
	
	
	
	this["fireSemanticEvent"]("CalendarMonthView", "CellSelectMore", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["fireCellSelectMore"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iRowIndex Index of the selected row
 * @fires CalendarMonthView::HeaderSelect
 */
UCF_CalendarMonthView["prototype"]["fireHeaderSelect"] = function(sId, iRowIndex) {;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["fireHeaderSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "CalendarMonthView.js(1272): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarMonthView.js(1273): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarMonthView.js(1274): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "CalendarMonthView.js(1275): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "CalendarMonthView.js(1276): fireHeaderSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex
	};
	
	
	this["fireSemanticEvent"]("CalendarMonthView", "HeaderSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarMonthView["_"]["fireHeaderSelect"] = 0; };

};
sap["ls"]["preload"]["UCF_CalendarRowHeader"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_CalendarRowHeader(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CalendarRowHeader["_"]["UCF_CalendarRowHeader"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "CalendarRowHeader.js(18): UCF_CalendarRowHeader"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CalendarRowHeader.js(19): UCF_CalendarRowHeader"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "CalendarRowHeader.js(20): UCF_CalendarRowHeader"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_CalendarRowHeader"] = UCF_CalendarRowHeader; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CalendarRowHeader"); UCF_CalendarRowHeader["_"] = {UCF_CalendarRowHeader: 0}; }; ;
UCF_CalendarRowHeader["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_CalendarRowHeader.prototype["sClassName"] = "UCF_CalendarRowHeader";

/**
 * Handles the mouse over event on a row header
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarRowHeader["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarRowHeader["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarRowHeader.js(34): onmouseover"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource["id"] && oSource["id"] == this["sId"] + "-txt" &&
		oSource["offsetWidth"] > this["oDomRef"]["offsetWidth"]) {
		oSource["title"] = this["sText"];
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarRowHeader["_"]["onmouseover"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_CalendarRowHeader["prototype"]["aAttributeNames"] = ["sText","bHasChildRows","bExpanded","bExpandable","iLevel","bClickable","bSelected"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_CalendarRowHeader["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_CalendarRowHeader["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_CalendarRowHeader["prototype"]["sText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarRowHeader["prototype"]["bHasChildRows"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarRowHeader["prototype"]["bExpanded"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarRowHeader["prototype"]["bExpandable"] = false;

/**
 * @private
 * @type {number}
 */
UCF_CalendarRowHeader["prototype"]["iLevel"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarRowHeader["prototype"]["bClickable"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarRowHeader["prototype"]["bSelected"] = false;

//#JSCOVER_EXCL_START
/** @protected */
UCF_CalendarRowHeader["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarRowHeader["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["bHasChildRows"] = false;
	this["bExpanded"] = false;
	this["bExpandable"] = false;
	this["iLevel"] = 0;
	this["bClickable"] = false;
	this["bSelected"] = false;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("HasChildRows", false, true);
		this["setClientProperty"]("Expanded", false, true);
		this["setClientProperty"]("Expandable", false, true);
		this["setClientProperty"]("Level", 0, true);
		this["setClientProperty"]("Clickable", false, true);
		this["setClientProperty"]("Selected", false, true);
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarRowHeader["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_CalendarYearView"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Calendar */
/// <reference path="./base/Calendar.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>

/**
 * UCF_CalendarYearView
 * Provides event handler and methods for the CalendarYearView and HierarchicalMonthView.
 * Both views use a rowwise view of entries. In the CalendarYearView each row represents a
 * month. In the HierachicalMonthView each row represents a resource. Resources can have a
 * hierarchical dependancy.
 *
 * 
 * @version 1.0
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_CalendarYearView(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["UCF_CalendarYearView"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "CalendarYearView.js(40): UCF_CalendarYearView"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CalendarYearView.js(41): UCF_CalendarYearView"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "CalendarYearView.js(42): UCF_CalendarYearView"); };

	UCF_Calendar["apply"](this, [oDomRef, oLS]);

	//table dom reference stored for various methods
	this["oTable"] = UCF_DomUtil["$"](this["sId"] + "-tbl");

	//special feature to draw a blue border around todays date
	if (this["bIsHierarchical"]) this["markToday"]();

	//@see getEnties
	this["aEntries"] = null;

	//@see initializeScollArea
	this["oScrollArea"] = null; // eslint-disable-line @ur/no-memory-leaks

	//@see initializeKeyboard
	this["aKeyboardRowNavigation"] = [];
	this["aRowEntries"] = [];

	//@see focusItem
	this["oFocusPosition"] = null;

};window["UCF_CalendarYearView"] = UCF_CalendarYearView; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CalendarYearView"); UCF_CalendarYearView["_"] = {UCF_CalendarYearView: 0}; }; ;
UCF_CalendarYearView["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Calendar"))(); UCF_CalendarYearView.prototype["sClassName"] = "UCF_CalendarYearView";

UCF_CalendarYearView["prototype"]["MINIMALDAYWIDTH"] = 21;
UCF_CalendarYearView["prototype"]["MINIMALMONTHWIDTH"] = 120;
UCF_CalendarYearView["prototype"]["MINIMALCALENDARWIDTH"] = 400;

/**
 * Handles the initialize event and attaches to the resize of the browser
 *
 * @private
 */
UCF_CalendarYearView["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["initialize"]++; }; 

	//the user initially enters (focus) the calendar
	this["bInitialEnter"] = true;

	//initialize the scrolling area
	this["initializeScollArea"]();

	//applies the size to the calendar
	this["applySize"]();

	this["aColumns"] = this["aGetColumns"]();
	this["aRows"] = this["aGetRows"]();

	//draw the entries
	this["drawEntries"]();

	//initialize the keyboard navigation
	this["initializeKeyboard"]();

	//attach to the resize event of the browser
	this["attachBrowserEvent"]("resize", this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["initialize"] = 0; };

/**
 * Marks a given day as today if iTodaysDate is set in the interface
 */
UCF_CalendarYearView["prototype"]["markToday"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["markToday"]++; }; 
	if (this["iTodaysDay"] > 0) {
		var oCell = this["oTable"]["rows"][0]["cells"][this["iTodaysDay"]];
		oCell["style"]["padding"] = "0";
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](oCell, "<div class=\"urToday\" >" + this["iTodaysDay"] + "</div>");
		UCF_DomUtil["setStyle"](oCell["firstChild"], {
			"paddinTop": '1px',
			"paddingBottom": '2px'
		});
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["markToday"] = 0; };

/**
 * Applies the sizes to the calendar grid
 */
UCF_CalendarYearView["prototype"]["applySize"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["applySize"]++; }; 
	if (this["bScrollable"]) {
		//set the overflow to hidden to allow the calendar to be drawn without width restrictions
		if (UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]() || window["UCF_System"]["sDevice"] === "standards") {
			this["oDomRef"]["style"]["overflow"] = "hidden";
		} else {
			this["oDomRef"]["style"]["overflowX"] = "hidden";
		}
	} else {
		if (UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]() || window["UCF_System"]["sDevice"] === "standards") {
			this["oDomRef"]["style"]["overflow"] = "visible";
		} else {
			this["oDomRef"]["style"]["overflowX"] = "visible";
		}
	}

	var oCols = this["oTable"]["getElementsByTagName"]("COL"),
		iTotalWidth = this["oTable"]["offsetWidth"],
		iMonthWidth = this["MINIMALMONTHWIDTH"];

	// do not allow to be smaller than 400px
	iTotalWidth = Math["max"](iTotalWidth, this["MINIMALCALENDARWIDTH"]);

	//the space per day for 31 days with the same width
	var iDayWidth = Math["floor"]((iTotalWidth - iMonthWidth) / 31);
	iMonthWidth = iTotalWidth - (iDayWidth * 31);
	if (iDayWidth < this["MINIMALDAYWIDTH"] || this["oDomRef"]["offsetWidth"] < iTotalWidth) {
		if (this["bScrollable"]) {
			this["oDomRef"]["style"]["overflow"] = "auto";
			this["oDomRef"]["style"]["height"] = this["oTable"]["offsetHeight"] + 16; //scrollbar added to the bottom will need more space
		}
		//turn on scrolling if days are less than 21px
		iDayWidth = 21;
		//apply the new width to each day col
		for (var i = 1; i < 32; i++) {
			oCols[i]["width"] = iDayWidth; //set all day colums to same width
		}
		this["oDomRef"]["style"]["width"] = this["oDomRef"]["offsetWidth"];
		if (this["bScrollable"]) {
			this["oScrollArea"]["setScrollPosition"](0, this["iScrollLeft"]);
		}
	}

	oCols[0]["width"] = iMonthWidth;
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["applySize"] = 0; };

/**
 * Initializes the scroll area
 */
UCF_CalendarYearView["prototype"]["initializeScollArea"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["initializeScollArea"]++; }; 
	if (this["bScrollable"]) {
		this["oScrollArea"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(this["oDomRef"]);
		this["attachBrowserEvent"]("scroll", this["oDomRef"]);
		this["addDelegate"](this["oScrollArea"]);
		this["oScrollArea"]["attachEvent"](this["oScrollArea"]["E_EVENTS"]["Scroll"], this, "onScroll");
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["initializeScollArea"] = 0; };
/**
 * Initializes the
 */
UCF_CalendarYearView["prototype"]["initializeKeyboard"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["initializeKeyboard"]++; }; 
	this["aKeyboardRowNavigation"] = [];
	this["aRowEntries"] = [];

	var bEmpty = true,
		aEntries = this["getEntries"]();
	for (var i = 0; i < this["aRows"]["length"]; i++) {
		var aElementsForMore = [];
		this["aKeyboardRowNavigation"][i] = [];

		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
		if (this["aRows"][i]["oDomRef"]["firstChild"]["getAttribute"]("ridx")) {
			this["aKeyboardRowNavigation"][i]["push"](this["aRows"][i]["oDomRef"]["firstChild"]);
			bEmpty = false;

		}
		for (var iCells = 1; iCells < this["aRows"][i]["oDomRef"]["cells"]["length"]; iCells++) {
			var oCell = this["aRows"][i]["oDomRef"]["cells"][iCells];
			if (oCell["getAttribute"]("MORE") === "true") {
				aElementsForMore["push"]({ "fStartRow": i, "fStartColumn": iCells - 1, "oDomRef": oCell });
			}
		}
		var iMore = 0;
		for (var j = 0; j < aEntries["length"]; j++) {
			var oEntry = aEntries[j];
			var iStartRow = Math["floor"](oEntry["fStartRow"]);
			if (iStartRow === i) {
				this["aRowEntries"][i] = true;
				if (aElementsForMore && aElementsForMore[iMore]) {
					while (aElementsForMore[iMore]["fStartColumn"] < oEntry["fStartColumn"]) {
						this["aKeyboardRowNavigation"][i]["push"](aElementsForMore[iMore]["oDomRef"]);
						bEmpty = false;
						iMore++;
						if (iMore === aElementsForMore["length"]) break;
					}
				}
				if (oEntry["bSelectable"] || window["UCF_System"]["bIs508"]) {
					this["aKeyboardRowNavigation"][i]["push"](oEntry["oDomRef"]);
					bEmpty = false;
				}
			}
		}
		if (aElementsForMore && aElementsForMore[iMore]) {
			while (iMore < aElementsForMore["length"]) {
				this["aKeyboardRowNavigation"][i]["push"](aElementsForMore[iMore]["oDomRef"]);
				bEmpty = false;
				iMore++;
			}
		}
	}
	if (bEmpty) {
		this["aKeyboardRowNavigation"] = [];
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["initializeKeyboard"] = 0; };
/**
 * Destructor
 */
UCF_CalendarYearView["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["destroy"]++; }; 
	this["detachBrowserEvent"]("resize", this["oDomRef"]);

	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}
	this["oTable"] = null;

	this["aKeyboardRowNavigation"] = null;
	this["aRowEntries"] = null;
	this["oFocusPosition"] = null;

	this["iScrollLeft"] = null;
	this["aEntries"] = null;
	this["aRows"] = null;
	this["aColumns"] = null;

	UCF_Calendar.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["destroy"] = 0; };

/**
 * Fires semantic events based on the element that recieved the BrowserEvent
 * the semantic events that are handled are:
 * SELECTHEADER, SELECTCELL
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["select"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["select"]++; }; 
	var oEventDomRef = oBrowserEvent["oGetSource"]();
	var oCellRef = UCF_DomUtil["oGetParentByAttribute"](oEventDomRef, "cidx");
	var oRowRef = UCF_DomUtil["oGetParentByAttribute"](oEventDomRef, "ridx");
	var iRow;

	if (oCellRef && !oBrowserEvent["bGetCancelBubble"]()) {
		iRow = parseInt(oCellRef["getAttribute"]("ridx"));
		var iCol = parseInt(oCellRef["getAttribute"]("cidx"));
		if (oEventDomRef["className"] === "MORE" || (oEventDomRef["getAttribute"]("MORE") === "true" && oBrowserEvent["bCtrl"]())) {
			this["fireCellMoreSelect"](this["sId"], iRow, iCol);
		} else if (oCellRef["getAttribute"]("SELECT") === "true") {
			this["fireCellSelect"](this["sId"], iRow, iCol);
		}
	} else if (oRowRef) {
		iRow = parseInt(oRowRef["getAttribute"]("ridx"));
		var oRowHeader = oBrowserEvent["oSourceControl"];
		if (oEventDomRef["tagName"] === "IMG" &&
			oRowHeader["bExpandable"]) {
			if (oEventDomRef["className"]["indexOf"]("COL") > -1) {
				this["collapse"](oBrowserEvent);
			} else if (oEventDomRef["className"]["indexOf"]("EXP") > -1) {
				this["expand"](oBrowserEvent);
			}
		} else if (oRowHeader["bClickable"]) {
			this["fireHeaderSelect"](this["sId"], iRow);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["select"] = 0; };
/**
 * Fires semantic toggle event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["expand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["expand"]++; }; 
	var oEventDomRef = oBrowserEvent["oGetSource"](),
		oRowRef = UCF_DomUtil["oGetParentByAttribute"](oEventDomRef, "ridx"),
		oRowHeader = oBrowserEvent["oSourceControl"];
	if (oRowRef) {
		var iRow = parseInt(oRowRef["getAttribute"]("ridx"));
		if (oRowHeader["bExpandable"] && !oRowHeader["bExpanded"] && oRowHeader["bHasChildRows"]) {
			this["fireHeaderToggle"](this["sId"], iRow, false);
		}
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["expand"] = 0; };

/**
 * Fires semantic collapse event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["collapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["collapse"]++; }; 
	var oEventDomRef = oBrowserEvent["oGetSource"](),
		oRowHeader = oBrowserEvent["oSourceControl"],
		oRowRef = UCF_DomUtil["oGetParentByAttribute"](oEventDomRef, "ridx");
	if (oRowRef) {
		var iRow = parseInt(oRowRef["getAttribute"]("ridx"));
		if (oRowHeader["bExpandable"] && oRowHeader["bExpanded"] && oRowHeader["bHasChildRows"]) {
			this["fireHeaderToggle"](this["sId"], iRow, oRowHeader["bExpanded"]);
		}
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["collapse"] = 0; };

/**
 * Handles the onclick event for the CalendarYearView
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onclick"]++; }; 

	this["select"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onclick"] = 0; };

/**
 * Handles the mouse down on the calendarview
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onmousedown"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(353): onmousedown"); };

	var oSource = oBrowserEvent["oGetSource"]();

	for (var i = 0; i < this["aKeyboardRowNavigation"]["length"]; i++) {
		for (var j = 0; j < this["aKeyboardRowNavigation"][i]["length"]; j++) {
			if (UCF_DomUtil["bContains"](this["aKeyboardRowNavigation"][i][j], oSource)) {
				this["focusItem"](i, j);
			}
		}
	}

};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onmousedown"] = 0; };

/**
 * Handles the resize event for the CalendarYearView
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onresize"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(375): onresize"); };
	this["applySize"]();
	this["aColumns"] = this["aGetColumns"]();
	this["aRows"] = this["aGetRows"]();
	this["drawEntries"]();
	this["iScrollLeft"] = this["oDomRef"]["scrollLeft"];
	this["setClientProperty"]("ScrollLeft", this["iScrollLeft"], true);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onresize"] = 0; };

/**
 * Handles the scroll event for the CalendarYearView
 *
 * @private
 * @param {UCF_Event} oEvent the internal event object that occurred
 * @private
 */
UCF_CalendarYearView["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onScroll"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "CalendarYearView.js(393): onScroll"); };
	this["fireScroll"](this["sId"], oEvent["oGetParam"]("iScrollLeft"));
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onScroll"] = 0; };

/**
 * Calculates the position of entries in the calendar year view.
 * Gathers the parallel entries and applies all settings for drawing these entries.
 *
 * @private
 * @param {Array} aEntries Array of UCF_CalendarEntry
 */
UCF_CalendarYearView["prototype"]["calculateEntryPositions"] = function(aEntries) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["calculateEntryPositions"]++; }; 

	// handle the entries
	var aRows = this["aRows"],
		aMonthRows = [],
		i;

	// create an array for the rows
	for (i = 0; i < aRows["length"]; i++) {
		aMonthRows[i] = [];
	}

	// add the entries to the row
	for (i = 0; i < aEntries["length"]; i++) {
		aMonthRows[aEntries[i]["fStartRow"]]["push"](aEntries[i]);
	}

	// calculate parallel entries
	for (i = 0; i < aMonthRows["length"]; i++) {
		var iEndCol = 0,
			aParallelRows = [],
			aEndCols = [];

		aEndCols[0] = 0;
		aParallelRows[0] = [];
		for (var n = 0; n < aMonthRows[i]["length"]; n++) {
			var iLevelCount = 0;
			while (aEndCols[iLevelCount] > aMonthRows[i][n]["fStartColumn"] && iLevelCount < aEndCols["length"]) {
				iLevelCount++;
				if (!aParallelRows[iLevelCount]) {
					aParallelRows[iLevelCount] = [];
				}
			}
			aEndCols[iLevelCount] = aMonthRows[i][n]["fEndColumn"];
			aParallelRows[iLevelCount]["push"](aMonthRows[i][n]);
			aMonthRows[i][n]["iLevel"] = iLevelCount;
			if (iEndCol < aMonthRows[i][n]["fEndColumn"]) {
				iEndCol = aMonthRows[i][n]["fEndColumn"];
			}
			for (var x = 0; x < aParallelRows["length"]; x++) {
				for (var y = 0; y < aParallelRows[x]["length"]; y++) {
					//apply the level of the parallel entry
					aParallelRows[x][y]["iLevel"] = x;
				}
			}
		}
	}

};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["calculateEntryPositions"] = 0; };

/*
 * Creates and returns an array of UCF_CalendarEntry instances from the given aEntryDomRefs
 * including cloned entries if one entry exceeds a month.
 *
 * @private
 *
 * @param {Array} aEntryDomRefs Collection of DOMElement
 *
 * @return null if no entries where found otherwise an array of entries.
 * @type Array
 */
UCF_CalendarYearView["prototype"]["getEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["getEntries"]++; }; 

	//already initialized
	if (this["aEntries"]) return this["aEntries"];

	var oEntryRoot = UCF_DomUtil["$"](this["sId"] + "-entries"),
		aEntries = this["aGetEntriesFromDomRef"](oEntryRoot),
		iEntryLength = aEntries["length"];

	//loop over all entries and create clones if the duration leads to the next month
	//correct the initial settings of the original entry as well
	for (var iEntryCount = 0; iEntryCount < iEntryLength; iEntryCount++) {
		//retrieve the entry
		var oEntry = aEntries[iEntryCount],
			fDuration = oEntry["fDuration"],
			iCurrentRow = oEntry["iStartRow"],
			fStartColumn = oEntry["fStartColumn"],
			sEntryId = oEntry["sId"];
		//the current row is not viisble
		if (iCurrentRow >= this["aRows"]["length"]) continue;

		//get the actuals days in the row, some days might not be available, e.g. february has only 28/29 days
		var iDaysPerMonth = this["iGetDaysPerMonth"](this["aRows"][iCurrentRow]);

		//the start column is not avaiablable for the row
		if (fStartColumn > iDaysPerMonth) continue;

		//the entry goes to the next row
		if (fStartColumn + fDuration > iDaysPerMonth) {
			var fNewDuration = iDaysPerMonth - fStartColumn;
			//correct the settings of the entry
			oEntry["fDuration"] = fNewDuration;
			//the current entry starts and ends in the same row
			oEntry["iEndColumn"] = iDaysPerMonth;
			oEntry["fEndColumn"] = iDaysPerMonth;
			oEntry["fEndRow"] = iCurrentRow;
			oEntry["iEndRow"] = iCurrentRow;

			//the current entry has an open end because it goes to next row
			oEntry["setOpenEnd"](true);

			//calculate the rest of the duration
			fDuration -= fNewDuration;

			//create clones for entries that exceed the current column
			var iIndex = 0; //clone counter
			while (fDuration > 0) {
				var iNextRow = oEntry["iEndRow"] + 1 + iIndex; //index of the next row

				//if the rows is not available or a close already exists break
				if (!this["aRows"][iNextRow] || UCF_DomUtil["$"](sEntryId + "-clone-" + iIndex)) break; //row is not visible

				//available days in the row
				iDaysPerMonth = this["iGetDaysPerMonth"](this["aRows"][iNextRow]);
				var fCloneDuration = Math["min"](fDuration, iDaysPerMonth), //calc the duration of the clone
					sCloneId = sEntryId + "-clone-" + iIndex, //clone id
					oEntryClone = oEntry["clone"](
						sCloneId,
						oEntryRoot,
						0,
						iNextRow,
						fCloneDuration);
				//even the clone does not end in this row
				oEntryClone["setOpenEnd"](fDuration >= iDaysPerMonth);

				//add the clone the the entries array
				aEntries["push"](oEntryClone);

				//substract the duration from the current entry
				fDuration -= fCloneDuration;
				iIndex++; //for the next clones id
			}
		}
	}
	this["aEntries"] = aEntries;
	return aEntries;
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["getEntries"] = 0; };

/*
 * Returns the number of days available for one row (month)
 *
 * @private
 *
 * @param {Object} an object with {oRect,oDomRef} of a row
 * @return {int} number of days in one row
 *
 */
UCF_CalendarYearView["prototype"]["iGetDaysPerMonth"] = function(oRow) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["iGetDaysPerMonth"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oRow != null, "oRow != null", "CalendarYearView.js(554): iGetDaysPerMonth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oRow["oDomRef"]) === "object", "typeof(oRow.oDomRef) === \"object\"", "CalendarYearView.js(555): iGetDaysPerMonth"); };

	if (!oRow) return 0;

	var oCells = oRow["oDomRef"]["cells"];

	if (oCells) {
		var iCol = oCells["length"] - 1;
		while (oCells[iCol]["getAttribute"]("disabled") === "true" ||
			oCells[iCol]["getAttribute"]("disabled") === true) {
			iCol = iCol - parseInt(oCells[iCol]["colSpan"]);
			if (iCol < 28) {
				return iCol;
			}
		}
		return iCol;
	}
	return 0;
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["iGetDaysPerMonth"] = 0; };
/**
 * Draws the entries of the CalendarYearView.
 *
 * @private
 */
UCF_CalendarYearView["prototype"]["drawEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["drawEntries"]++; }; 

	var aEntries = this["getEntries"]();
	if (!aEntries) return;
	aEntries["sort"](this["sortRowEntries"]);
	this["calculateEntryPositions"](aEntries);

	for (var i = 0; i < aEntries["length"]; i++) {
		this["drawEntry"](aEntries[i]);
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["drawEntries"] = 0; };

/**
 * Draws an entry
 *
 * @private
 * @param {UCF_CalendarEntry} oEntry
 */
UCF_CalendarYearView["prototype"]["drawEntry"] = function(oEntry) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["drawEntry"]++; }; 
	var iStartColumn = Math["floor"](oEntry["fStartColumn"]),
		iStartRow = Math["floor"](oEntry["fStartRow"]),
		oRect = this["aColumns"][iStartColumn]["oRect"],
		iLeft = oRect["left"] + (oRect["width"] * (oEntry["fStartColumn"] - iStartColumn)),
		iRight = oRect["right"],
		iHeight = 16,
		iTop = this["aRows"][iStartRow]["oRect"]["top"] + (iHeight * (oEntry["iLevel"]) + 1),
		iWidth = this["iGetEntryColumnWidth"](this["aColumns"], oEntry),
		iTableWidth = this["oTable"]["offsetWidth"];
	iWidth = iWidth - 1;
	if (this["oLS"]["oSystem"]["bIsRTL"]) {
		iRight = iRight + 1;

	} else {
		//if the width would be larger than the available width, cut of the end of the entry
		if (iWidth + iLeft > iTableWidth) {
			iWidth = iTableWidth - iLeft + 1;
		}
	}
	oEntry["applyStyles"]();
	//set the position of the entry.
	oEntry["setPosition"](iLeft + 1, iTop, iWidth, iHeight, iRight);
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["drawEntry"] = 0; };

/**
 * Focuses an item at iRow, iItem
 *
 * @param {int} iRow the row of the item
 * @param {int} iItem the item index
 */
UCF_CalendarYearView["prototype"]["focusItem"] = function(iRow, iItem) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["focusItem"]++; }; 
	var oDomRef = null;
	if (this["aKeyboardRowNavigation"]["length"] === 0) return;
	if (this["oFocusPosition"]) {
		oDomRef = this["aKeyboardRowNavigation"][this["oFocusPosition"]["iRow"]][this["oFocusPosition"]["iItem"]];
		if (oDomRef) UCF_DomUtil["setTabIndex"](oDomRef, -1);
	}

	if (iRow === -1) {
		iRow = this["aRows"]["length"] - 1;
	} else if (iRow > this["aRows"]["length"] - 1) {
		iRow = 0;
	}
	if (iItem === -1) {
		iRow--;
		while (this["aKeyboardRowNavigation"][iRow] && this["aKeyboardRowNavigation"][iRow]["length"] === 0) iRow--;
		iItem = this["aKeyboardRowNavigation"][iRow]["length"] - 1;
	} else if (iItem > this["aKeyboardRowNavigation"][iRow]["length"] - 1) {
		iRow++;
		while (this["aKeyboardRowNavigation"][iRow] && this["aKeyboardRowNavigation"][iRow]["length"] === 0) iRow++;
		iItem = 0;
	}
	if (iRow === -1) {
		iRow = this["aRows"]["length"] - 1;
		iItem = 0;
	} else if (iRow > this["aRows"]["length"] - 1) {
		iRow = 0;
		iItem = 0;
	}

	this["oFocusPosition"] = { "iRow": iRow, "iItem": iItem };
	oDomRef = this["aKeyboardRowNavigation"][this["oFocusPosition"]["iRow"]][this["oFocusPosition"]["iItem"]];
	if (oDomRef) {
		UCF_DomUtil["setTabIndex"](oDomRef, 0);
		oDomRef["focus"]();
	}

};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["focusItem"] = 0; };

/**
 * Handles lsfocus
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsfocus"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(675): onlsfocus"); };

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oDomRef"] && !window["UCF_System"]["bIs508"]) {
		if (this["aKeyboardRowNavigation"]["length"] === 0) {
			return;
		}
		UCF_DomUtil["setTabIndex"](this["oDomRef"], "-1");

	}
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsfocus"] = 0; };

/**
 * Handles tab next
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlstabnext"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(695): onlstabnext"); };
	if (this["aKeyboardRowNavigation"]["length"] === 0) {
		return;
	}
	if (!this["oFocusPosition"]) {
		this["focusItem"](0, 0);
	} else {

		if (this["oFocusPosition"]["iItem"] === this["aKeyboardRowNavigation"][this["oFocusPosition"]["iRow"]]["length"] - 1) {
			//find the next row
			var iRow = this["oFocusPosition"]["iRow"] + 1;
			while (this["aKeyboardRowNavigation"][iRow] && this["aKeyboardRowNavigation"][iRow]["length"] === 0) iRow++;
			if (iRow >= this["aKeyboardRowNavigation"]["length"]) {
				if (this["focusNextControl"]()) {
					this["bInitialEnter"] = true;
					oBrowserEvent["cancel"]();
				}
				return;
			}
		}
		this["focusItem"](this["oFocusPosition"]["iRow"], this["oFocusPosition"]["iItem"] + 1);
	}
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlstabnext"] = 0; };

/**
 * Handles tab previous
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlstabprevious"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(729): onlstabprevious"); };

	if (this["oFocusPosition"]) {
		if (this["oFocusPosition"]["iRow"] === 0
			&& this["oFocusPosition"]["iItem"] === 0) {
			this["oFocusPosition"] = null;
			this["bInitialEnter"] = true;
			return;
		}
		this["focusItem"](this["oFocusPosition"]["iRow"], this["oFocusPosition"]["iItem"] - 1);
		oBrowserEvent["cancel"]();
	}

};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlstabprevious"] = 0; };

/**
 * Handles up arrow key event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsup"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(752): onlsup"); };

	if (this["oFocusPosition"]) {
		this["focusItem"](this["oFocusPosition"]["iRow"] - 1, 0);
		oBrowserEvent["cancel"]();
	}

};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsup"] = 0; };

/**
 * Handles up arrow key event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsdown"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(769): onlsdown"); };

	if (this["oFocusPosition"]) {
		this["focusItem"](this["oFocusPosition"]["iRow"] + 1, 0);
		oBrowserEvent["cancel"]();
	}

};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsdown"] = 0; };

/**
 * Handles skipping
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(785): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
	this["bInitialEnter"] = true;
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsskipforward"] = 0; };

/**
 * Handles skipping
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(797): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
	this["bInitialEnter"] = true;
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsskipback"] = 0; };

/**
 * Handles the space and enter on cells and the more indicators
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlsselectmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsselectmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(809): onlsselectmodifier"); };
	this["select"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsselectmodifier"] = 0; };

/**
 * Handles the space and enter on cells and the more indicators
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(822): onlsselect"); };
	this["select"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsselect"] = 0; };

/**
 * Handles the right arrow on HeaderRow
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsright"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(835): onlsright"); };
	this["expand"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsright"] = 0; };

/**
 * Handles the keyboard expand on HeaderRow
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsexpand"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(848): onlsexpand"); };
	this["expand"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsexpand"] = 0; };

/**
 * Handles the keyboard lsleft on HeaderRow
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsleft"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(861): onlsleft"); };
	this["collapse"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsleft"] = 0; };

/**
 * Handles the keyboard collapse on HeaderRow
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_CalendarYearView["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlscollapse"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(874): onlscollapse"); };
	this["collapse"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlscollapse"] = 0; };

/**
 * @see UCF_Control
 * @param {FocusInfo} oFocusInfo
 */
UCF_CalendarYearView["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "CalendarYearView.js(885): collectFocusInfo"); };
	if (this["oFocusPosition"]) {
		oFocusInfo["setApplyControl"](this);
		oFocusInfo["addParam"]("iRow", this["oFocusPosition"]["iRow"]);
		oFocusInfo["addParam"]("iItem", this["oFocusPosition"]["iItem"]);
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["collectFocusInfo"] = 0; };

/**
 * @see UCF_Control
 * @param { FocusInfo } oFocusInfo
 */
UCF_CalendarYearView["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "CalendarYearView.js(898): applyFocusInfo"); };
	this["oFocusPosition"] = {
		"iRow": oFocusInfo["oGetParam"]("iRow"),
		"iItem": oFocusInfo["oGetParam"]("iItem")
	};
	this["focusItem"](this["oFocusPosition"]["iRow"], this["oFocusPosition"]["iItem"]);
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["applyFocusInfo"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CalendarYearView["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CalendarYearView.js(914): onlsaccessibility"); };

	var oSourceControl = oBrowserEvent["oGetSourceControl"]();

	if (oSourceControl !== this &&
		!(UCF_JsUtil["bInstanceOf"](oSourceControl, "UCF_CalendarEntry")) &&
		!(UCF_JsUtil["bInstanceOf"](oSourceControl, "UCF_CalendarRowHeader"))
	) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSource = oBrowserEvent["oGetSource"]();
	if (UCF_JsUtil["bInstanceOf"](oSourceControl, "UCF_CalendarRowHeader")) {
		//Row Header
		if (oSourceControl["oParentControl"]["sMonthColumnTitle"] && oSourceControl["oParentControl"]["sMonthColumnTitle"] !== "")
			oAccessibilityHelper["setText"](oSourceControl["oParentControl"]["sMonthColumnTitle"] + ' - ' + oSourceControl["sText"]);
		else
			oAccessibilityHelper["setText"](oSourceControl["sText"]);
		if (this["bIsHierarchical"]) {
			if (this["aRowEntries"][oSource["parentNode"]["rowIndex"] - 1]) {
				oAccessibilityHelper["addTutor"]("CAL_DCOL_ENTRY_TUT");
			}
			oAccessibilityHelper["setExpanded"](
				oSourceControl["bHasChildRows"] &&
				oSourceControl["bExpanded"]);
			oAccessibilityHelper["setCollapsed"](
				oSourceControl["bHasChildRows"] &&
				!oSourceControl["bExpanded"]);
			oAccessibilityHelper["setSelected"](
				oSourceControl["bSelected"]);
			oAccessibilityHelper["addEnabledTutor"]("SELECT_TUT",
				oSourceControl["bClickable"] &&
				!oSourceControl["bSelected"]);
			oAccessibilityHelper["addEnabledTutor"]("DESELECT_TUT",
				oSourceControl["bClickable"] &&
				oSourceControl["bSelected"]);
			oAccessibilityHelper["addEnabledTutor"]("CAL_RH_EXP_TUT",
				oSourceControl["bHasChildRows"] &&
				oSourceControl["bExpanded"]);
			oAccessibilityHelper["addEnabledTutor"]("CAL_RH_COLL_TUT",
				oSourceControl["bHasChildRows"] &&
				!oSourceControl["bExpanded"]);
		}

	} else if (oSource["getAttribute"]("MORE") === "true") {
		//More
		var sDay = oSource["cellIndex"],
			sRowHeader = UCF_DomUtil["sGetInnerText"](oSource["parentNode"]["firstChild"]);
		oAccessibilityHelper["setText"](sDay + " - " + sRowHeader);
		oAccessibilityHelper["addTutor"]("CAL_MORE_TUT");

	} else if (UCF_JsUtil["bInstanceOf"](oSourceControl, "UCF_CalendarEntry")) {
		var oLegendDomRef = UCF_DomUtil["$"](this["sId"] + '-legend');
		if (oLegendDomRef) oAccessibilityHelper["setLegendJSDomRef"](oLegendDomRef);
		var sSemantic = oSourceControl["bStriped"] ? oSourceControl["sSemanticColor"] + "_STRIPED" : oSourceControl["sSemanticColor"];
		oAccessibilityHelper["addSemantic"](sSemantic);

	} else if (oSource === this["oDomRef"]) {
		if (this["bIsHierarchical"]) {
			var sHeader = UCF_DomUtil["sGetInnerText"](this["oTable"]["getElementsByTagName"]("TH")[0]);
			oAccessibilityHelper["setControlType"]("CAL_HM", ["" + (this["oTable"]["rows"]["length"] - 1), sHeader]);
			oAccessibilityHelper["addTutor"]("CAL_HM_TUT");
		} else {
			oAccessibilityHelper["setControlType"]("CAL_Y", ["" + (this["oTable"]["rows"]["length"] - 1)]);
		}
		oAccessibilityHelper["setText"](this["sAccessibilityDescription"]);
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		oAccessibilityHelper["addTutor"]("CAL_Y_TUT_SI", [oAccessibilityHelper["sGetSkipContainerText"]()]);

	}
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_CalendarYearView["prototype"]["aAttributeNames"] = ["sTooltip","sAccessibilityDescription","sVisibility","sMonthColumnTitle","iMonthColumnWidth","bIsHierarchical","iTodaysDay","bScrollable","iScrollLeft","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_CalendarYearView["prototype"]["aEventNames"] = ["CellSelect","CellMoreSelect","HeaderSelect","HeaderToggle","Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_CalendarYearView["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_CalendarYearView["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_CalendarYearView["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_CalendarYearView["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_CalendarYearView["prototype"]["sMonthColumnTitle"] = '';

/**
 * @private
 * @type {number}
 */
UCF_CalendarYearView["prototype"]["iMonthColumnWidth"] = 120;

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarYearView["prototype"]["bIsHierarchical"] = false;

/**
 * @private
 * @type {number}
 */
UCF_CalendarYearView["prototype"]["iTodaysDay"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_CalendarYearView["prototype"]["bScrollable"] = true;

/**
 * @private
 * @type {number}
 */
UCF_CalendarYearView["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_CalendarYearView["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_CalendarYearView["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sMonthColumnTitle"] = '';
	this["iMonthColumnWidth"] = 120;
	this["bIsHierarchical"] = false;
	this["iTodaysDay"] = 0;
	this["bScrollable"] = true;
	this["iScrollLeft"] = 0;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("MonthColumnTitle", '', true);
		this["setClientProperty"]("MonthColumnWidth", 120, true);
		this["setClientProperty"]("IsHierarchical", false, true);
		this["setClientProperty"]("TodaysDay", 0, true);
		this["setClientProperty"]("Scrollable", true, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iRowIndex Index of the selected row
 * @param {number} iColIndex Index of the selected col
 * @fires CalendarYearView::CellSelect
 */
UCF_CalendarYearView["prototype"]["fireCellSelect"] = function(sId, iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["fireCellSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number, ColIndex: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "CalendarYearView.js(1108): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarYearView.js(1109): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarYearView.js(1110): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "CalendarYearView.js(1111): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "CalendarYearView.js(1112): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "CalendarYearView.js(1113): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "CalendarYearView.js(1114): fireCellSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex
	};
	
	
	
	this["fireSemanticEvent"]("CalendarYearView", "CellSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["fireCellSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iRowIndex Index of the selected row
 * @param {number} iColIndex Index of the selected col
 * @fires CalendarYearView::CellMoreSelect
 */
UCF_CalendarYearView["prototype"]["fireCellMoreSelect"] = function(sId, iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["fireCellMoreSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number, ColIndex: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "CalendarYearView.js(1137): fireCellMoreSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarYearView.js(1138): fireCellMoreSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarYearView.js(1139): fireCellMoreSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "CalendarYearView.js(1140): fireCellMoreSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "CalendarYearView.js(1141): fireCellMoreSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "CalendarYearView.js(1142): fireCellMoreSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "CalendarYearView.js(1143): fireCellMoreSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex
	};
	
	
	
	this["fireSemanticEvent"]("CalendarYearView", "CellMoreSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["fireCellMoreSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iRowIndex Index of the selected row
 * @fires CalendarYearView::HeaderSelect
 */
UCF_CalendarYearView["prototype"]["fireHeaderSelect"] = function(sId, iRowIndex) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["fireHeaderSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "CalendarYearView.js(1165): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarYearView.js(1166): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarYearView.js(1167): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "CalendarYearView.js(1168): fireHeaderSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "CalendarYearView.js(1169): fireHeaderSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex
	};
	
	
	this["fireSemanticEvent"]("CalendarYearView", "HeaderSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["fireHeaderSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the tree control
 * @param {number} iRowIndex Index of the selected row
 * @param {boolean} bIsOpen The open state of the node
 * @fires CalendarYearView::HeaderToggle
 */
UCF_CalendarYearView["prototype"]["fireHeaderToggle"] = function(sId, iRowIndex, bIsOpen) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["fireHeaderToggle"]++; }; 
	/** @type {{Id: string, RowIndex: number, IsOpen: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "CalendarYearView.js(1190): fireHeaderToggle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarYearView.js(1191): fireHeaderToggle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarYearView.js(1192): fireHeaderToggle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "CalendarYearView.js(1193): fireHeaderToggle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "CalendarYearView.js(1194): fireHeaderToggle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsOpen != null, "bIsOpen != null", "CalendarYearView.js(1195): fireHeaderToggle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsOpen) == "boolean", "typeof(bIsOpen) == \"boolean\"", "CalendarYearView.js(1196): fireHeaderToggle"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"IsOpen": bIsOpen
	};
	
	
	
	this["fireSemanticEvent"]("CalendarYearView", "HeaderToggle", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["fireHeaderToggle"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires CalendarYearView::Scroll
 */
UCF_CalendarYearView["prototype"]["fireScroll"] = function(sId, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "CalendarYearView.js(1218): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CalendarYearView.js(1219): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CalendarYearView.js(1220): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "CalendarYearView.js(1221): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "CalendarYearView.js(1222): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollLeft": iScrollLeft
	};
	
	
	this["fireSemanticEvent"]("CalendarYearView", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CalendarYearView["_"]["fireScroll"] = 0; };

};
sap["ls"]["preload"]["UCF_Canvas"] = function() {/* global UCF_EventProvider */
/// <reference path="../../core/EventProvider.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>

/**
 * Canvas
 * Class to create a canvas image on the screen
 * The width and height will grow in order to make all drawn objects visible
 * Use addLine, addRect, addCircle to draw objects.
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 * @param {Object} oRect
 */
function UCF_Canvas(oLS, oParent, oRect) {if (__UCF_COVERAGE__) { UCF_Canvas["_"]["UCF_Canvas"]++; }; 

	if (arguments["length"] == 0) return;
	UCF_EventProvider["apply"](this, []);
	this["oLS"] = oLS;
	this["iTop"] = -100;
	this["iLeft"] = -100;
	this["iWidth"] = 1;
	this["iHeight"] = 1;
	this["oDomRef"] = oLS["oGetWindow"]()["document"]["createElement"]("CANVAS");
	this["oParent"] = oParent;
	if (oParent) {
		this["oParent"]["appendChild"](this["oDomRef"]);
	}
	this["oDomRef"]["style"]["pointerEvents"] = "none";
	this["aDrawedObjects"] = [];
	this["iMaxX"] = 0;
	this["iMaxY"] = 0;
	this["iMinX"] = 0;
	this["iMinY"] = 0;
	this["oContext"] = this["oDomRef"]["getContext"]("2d");
	this["bDraw"] = false;
	if (oRect) {
		this["setPosition"](oRect);
	}
	this["bHidden"] = false;
	this["iZIndex"] = 0;
	this["setZIndex"](10000);

};window["UCF_Canvas"] = UCF_Canvas; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Canvas"); UCF_Canvas["_"] = {UCF_Canvas: 0}; }; ;
UCF_Canvas["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_Canvas.prototype["sClassName"] = "UCF_Canvas";

UCF_Canvas["ConnectorType"] = {
	"Bullet": "Bullet",
	"Arrow": "Arrow",
	"None": "None"
};

UCF_Canvas["CornerType"] = {
	"Rounded": "Rounded",
	"Normal": "Normal"
};

UCF_Canvas["prototype"]["getDataURL"] = function() {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["getDataURL"]++; }; 
	return this["oDomRef"]["toDataURL"]("image/png");
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["getDataURL"] = 0; };

UCF_Canvas["prototype"]["setZIndex"] = function(iZIndex) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["setZIndex"]++; }; 
	this["iZIndex"] = iZIndex;
	if (!this["bHidden"]) {
		this["oDomRef"]["style"]["zIndex"] = "" + iZIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["setZIndex"] = 0; };

UCF_Canvas["prototype"]["setPosition"] = function(oRect) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["setPosition"]++; }; 
	if (oRect) {
		this["oDomRef"]["style"]["position"] = "absolute";
		this["oDomRef"]["style"]["top"] = oRect["top"] + "px";
		this["oDomRef"]["style"]["left"] = oRect["left"] + "px";
		this["oDomRef"]["width"] = oRect["width"] || 100;
		this["oDomRef"]["height"] = oRect["height"] || 100;
	} else {
		this["oDomRef"]["style"]["position"] = "static";
		this["oDomRef"]["style"]["top"] = "0px";
		this["oDomRef"]["style"]["left"] = "0px";
		this["oDomRef"]["width"] = "100px";
		this["oDomRef"]["height"] = "100px";
	}
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["setPosition"] = 0; };

UCF_Canvas["prototype"]["createObject"] = function(sName, aArgumentNames, aArguments) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createObject"]++; }; 
	var oObject = {};
	oObject["name"] = sName;
	oObject["argumentNames"] = aArgumentNames;
	oObject["arguments"] = aArguments;
	for (var i = 0; i < aArgumentNames["length"]; i++) {
		sName = aArgumentNames[i]["substring"](1);
		oObject["set" + sName] = (function(i, oObject, that) {
			return function(val) {
				oObject[i] = val;
				that["redraw"]();

			};
		})(i, oObject, this);
		oObject["get" + sName] = (function(i, oObject, that) {
			return function(val) {
				oObject[i] = val;
				that["redraw"]();

			};
		})(i, oObject, this);
	}
	var that = this;
	oObject["redraw"] = function() {
		that["redraw"]();

	};
	oObject["remove"] = function() {
		that["removeObject"](this);
	};

	return oObject;
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createObject"] = 0; };

UCF_Canvas["prototype"]["addObject"] = function(oObject) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addObject"]++; }; 
	this["aDrawedObjects"]["push"](oObject);
	this["redraw"]();
	return oObject;
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addObject"] = 0; };

UCF_Canvas["prototype"]["removeObject"] = function(oObject) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeObject"]++; }; 
	for (var i = 0; i < this["aDrawedObjects"]["length"]; i++) {
		if (oObject == this["aDrawedObjects"][i]) {
			this["aDrawedObjects"]["splice"](i, 0);
			return;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeObject"] = 0; };

/**
 * Line Methods
 */

/**
 * @private
 */
UCF_Canvas["prototype"]["createLine"] = function(iStartX, iStartY, iEndX, iEndY, sStrokeColor, iStrokeWidth) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createLine"]++; }; 
	return this["createObject"]("Line", ["iStartX", "iStartY", "iEndX", "iEndY", "sStrokeColor", "iStrokeWidth"], Array["prototype"]["slice"]["call"](arguments, 0));
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createLine"] = 0; };

/**
 * @public
 */
UCF_Canvas["prototype"]["addLine"] = function(iStartX, iStartY, iEndX, iEndY, sStrokeColor, iStrokeWidth) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addLine"]++; }; 
	return this["addObject"](this["createLine"]["apply"](this, arguments));
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addLine"] = 0; };

/**
 * @public
 */
UCF_Canvas["prototype"]["removeLine"] = function(oLine) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeLine"]++; }; 
	this["removeObject"](oLine);
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeLine"] = 0; };

/**
 * @private
 */
UCF_Canvas["prototype"]["drawLine"] = function(iStartX, iStartY, iEndX, iEndY, sStrokeColor, iStrokeWidth) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawLine"]++; }; 
	this["iMaxX"] = Math["max"](iEndX, this["iMaxX"]);
	this["iMaxY"] = Math["max"](iEndY, this["iMaxY"]);
	if (this["bDraw"]) {
		this["oContext"]["beginPath"]();
		this["oContext"]["moveTo"](iStartX, iStartY);
		this["oContext"]["lineTo"](iEndX, iEndY);
		this["oContext"]["strokeStyle"] = sStrokeColor || "black";
		this["oContext"]["lineWidth"] = iStrokeWidth || 1;
		this["oContext"]["stroke"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawLine"] = 0; };

/**
 * Rect Methods
 */

/**
 * @private
 */
UCF_Canvas["prototype"]["createRect"] = function(iStartX, iStartY, iEndX, iEndY, sFillColor, sStrokeColor, iStrokeWidth) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createRect"]++; }; 
	return this["createObject"]("Rect", ["iStartX", "iStartY", "iEndX", "iEndY", "sFillColor", "sStrokeColor", "iStrokeWidth"], Array["prototype"]["slice"]["call"](arguments, 0));
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createRect"] = 0; };

/**
 * @public
 */
UCF_Canvas["prototype"]["addRect"] = function(iStartX, iStartY, iEndX, iEndY, sFillColor, sStrokeColor, iStrokeWidth) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addRect"]++; }; 
	return this["addObject"](this["createRect"]["apply"](this, arguments));
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addRect"] = 0; };
/**
 * @public
 */
UCF_Canvas["prototype"]["removeRect"] = function(oRect) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeRect"]++; }; 
	this["removeObject"](oRect);
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeRect"] = 0; };
/**
 * @private
 */
UCF_Canvas["prototype"]["drawRect"] = function(iStartX, iStartY, iEndX, iEndY, sFillColor, sStrokeColor, iStrokeWidth) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawRect"]++; }; 
	this["iMaxX"] = Math["max"](iEndX, this["iMaxX"]);
	this["iMaxY"] = Math["max"](iEndY, this["iMaxY"]);
	if (this["bDraw"]) {
		this["oContext"]["beginPath"]();
		this["oContext"]["lineWidth"] = iStrokeWidth || 0;
		this["oContext"]["rect"](iStartX, iStartY, iEndX - iStartX - Math["floor"](iStrokeWidth / 2), iEndY - iStartY - Math["floor"](iStrokeWidth / 2));
		this["oContext"]["fillStyle"] = sFillColor || "";
		this["oContext"]["fill"]();
		this["oContext"]["strokeStyle"] = sStrokeColor || "black";
		this["oContext"]["stroke"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawRect"] = 0; };

/**
 * Circle Methods
 */

/**
 * @private
 */
UCF_Canvas["prototype"]["createCircle"] = function(iStartX, iStartY, iEndX, iEndY, sFillColor, sStrokeColor, iStrokeWidth) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createCircle"]++; }; 
	return this["createObject"]("Circle", ["iStartX", "iStartY", "iEndX", "iEndY", "sFillColor", "sStrokeColor", "iStrokeWidth"], Array["prototype"]["slice"]["call"](arguments, 0));
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createCircle"] = 0; };

/**
 * @public
 */
UCF_Canvas["prototype"]["addCircle"] = function(iStartX, iStartY, iEndX, iEndY, sFillColor, sStrokeColor, iStrokeWidth) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addCircle"]++; }; 
	return this["addObject"](this["createCircle"]["apply"](this, arguments));
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addCircle"] = 0; };
/**
 * @public
 */
UCF_Canvas["prototype"]["removeCircle"] = function(oCircle) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeCircle"]++; }; 
	this["removeObject"](oCircle);
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeCircle"] = 0; };

/**
 * @private
 */
UCF_Canvas["prototype"]["drawCircle"] = function(iCenterX, iCenterY, iRadius, sFillColor, sStrokeColor, iStrokeWidth) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawCircle"]++; }; 
	this["iMaxX"] = Math["max"](iCenterX + iRadius, this["iMaxX"]);
	this["iMaxY"] = Math["max"](iCenterY + iRadius, this["iMaxY"]);
	if (this["bDraw"]) {
		this["oContext"]["beginPath"]();
		this["oContext"]["arc"](iCenterX, iCenterY, iRadius - Math["floor"](iStrokeWidth / 2), 0, 2 * Math["PI"], false);
		this["oContext"]["fillStyle"] = sFillColor;
		this["oContext"]["fill"]();
		this["oContext"]["lineWidth"] = iStrokeWidth || 0;
		this["oContext"]["strokeStyle"] = sStrokeColor || "black";
		this["oContext"]["stroke"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawCircle"] = 0; };

UCF_Canvas["prototype"]["createConnector"] = function(oFrom, oTo, sCornerType, iWidth, sColor, aCollisionRects) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createConnector"]++; }; 
	return this["createObject"]("Connector", ["oFrom", "oTo", "sCornerType", "iWidth", "sColor", "aDockReaCollisionRects"], Array["prototype"]["slice"]["call"](arguments, 0));
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createConnector"] = 0; };

UCF_Canvas["prototype"]["addConnector"] = function(oFrom, oTo, sCornerType, iWidth, sColor, aCollisionRects) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addConnector"]++; }; 
	return this["addObject"](this["createConnector"]["apply"](this, arguments));
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addConnector"] = 0; };

UCF_Canvas["prototype"]["drawConnector"] = function(oFrom, oTo, sCornerType, iWidth, sColor, aCollisionRects) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawConnector"]++; }; 
	var initDock = function(o) {
		if (!o["dock"]) o["dock"] = {};
		o["dock"]["position"] = o["dock"]["position"] || 50;
		o["dock"]["offset"] = o["dock"]["offset"] || 0;
		o["dock"]["sides"] = o["dock"]["sides"] || "top left bottom right";
		o["dock"]["top"] = o["dock"]["sides"]["indexOf"]("top") > -1 && true;
		o["dock"]["left"] = o["dock"]["sides"]["indexOf"]("left") > -1 && true;
		o["dock"]["bottom"] = o["dock"]["sides"]["indexOf"]("bottom") > -1 && true;
		o["dock"]["right"] = o["dock"]["sides"]["indexOf"]("right") > -1 && true;
	};
	var getConnectionPoints = function(o) {
		var iWidth = o["x2"] - o["x1"];
		var iHeight = o["y2"] - o["y1"];
		var iCenter = o["x1"] + Math["floor"](iWidth - (iWidth / 100 * o["dock"]["position"]));
		var iMiddle = o["y1"] + Math["floor"](iHeight - (iHeight / 100 * o["dock"]["position"]));
		var aResults = [];
		var aSides = o["dock"]["sides"]["split"](" ");
		for (var i = 0; i < aSides["length"]; i++) {
			if (aSides[i] == "top" && o["dock"]["top"]) aResults["push"]({ "x": iCenter, "y": o["y1"] - o["dock"]["offset"], "dir": "top" });
			if (aSides[i] == "bottom" && o["dock"]["bottom"]) aResults["push"]({ "x": iCenter, "y": o["y2"] + o["dock"]["offset"], "dir": "bottom" });
			if (aSides[i] == "left" && o["dock"]["left"]) aResults["push"]({ "x": o["x1"] - o["dock"]["offset"], "y": iMiddle, "dir": "left" });
			if (aSides[i] == "right" && o["dock"]["right"]) aResults["push"]({ "x": o["x2"] + o["dock"]["offset"], "y": iMiddle, "dir": "right" });
		}
		return aResults;
	};
	var i;

	initDock(oFrom);
	initDock(oTo);

	var aFromConnectionPoints = getConnectionPoints(oFrom);
	var aToConnectionPoints = getConnectionPoints(oTo);

	//DEBUG DRAW  A POINT
	for (i = 0; i < aFromConnectionPoints["length"]; i++) {
		this["drawLine"](aFromConnectionPoints[i]["x"], aFromConnectionPoints[i]["y"], aFromConnectionPoints[i]["x"] + 1, aFromConnectionPoints[i]["y"] + 1, "red", 1);
	}
	for (i = 0; i < aToConnectionPoints["length"]; i++) {
		this["drawLine"](aToConnectionPoints[i]["x"], aToConnectionPoints[i]["y"], aToConnectionPoints[i]["x"] + 1, aToConnectionPoints[i]["y"] + 1, "green", 1);
	}
	//DEBUG DRAW DIRECT CONNECTOR
	this["drawLine"](aFromConnectionPoints[0]["x"], aFromConnectionPoints[0]["y"], aToConnectionPoints[0]["x"], aToConnectionPoints[0]["y"], sColor, 1);
	//DEBUG DRAW COLLISION RECTS
	for (i = 0; i < aCollisionRects["length"]; i++) {
		this["drawRect"](aCollisionRects[i]["left"], aCollisionRects[i]["top"], aCollisionRects[i]["left"] + aCollisionRects[i]["width"], aCollisionRects[i]["top"] + aCollisionRects[i]["height"], "yellow", "red", 1);
	};

	var isInRect = function(x, y, oRect, iOffset) {
		return (x >= oRect["left"] - iOffset && x <= oRect["left"] + oRect["width"] + iOffset && y >= oRect["top"] - iOffset && y <= oRect["top"] + oRect["height"] + iOffset);
	};

	var sortDotsX = function(a, b) {
		if (a["y"] > b["y"]) return 1;
		if (a["y"] < b["y"]) return -1;
		if (a["y"] == b["y"] && a["x"] > b["x"]) return 1;
		if (a["y"] == b["y"] && a["x"] < b["x"]) return -1;
		return 0;
	};
	var sortDotsY = function(a, b) {
		if (a["x"] > b["x"]) return 1;
		if (a["x"] < b["x"]) return -1;
		if (a["x"] == b["x"] && a["y"] > b["y"]) return 1;
		if (a["x"] == b["x"] && a["y"] < b["y"]) return -1;
		return 0;
	};
	var filterX = function(o) {
		if (this["right"] == true) {
			return !o["visited"] && o["x"] > this["x1"] && o["x"] <= this["x2"] && o["y"] >= this["y1"] && o["y"] <= this["y2"];
		} else {
			return !o["visited"] && o["x"] < this["x1"] && o["x"] >= 0 && o["y"] >= this["y1"] && o["y"] <= this["y2"];
		}
	};
	var filterY = function(o) {
		if (this["bottom"] == true) {
			return !o["visited"] && o["x"] >= this["x1"] && o["x"] <= this["x2"] && o["y"] > this["y1"] && o["y"] <= this["y2"];
		} else {
			return !o["visited"] && o["x"] >= this["x1"] && o["x"] <= this["x2"] && o["y"] < this["y1"] && o["y"] >= 0;
		}
	};

	//Calculate a raster with dots that do not collide
	var aDots = [];
	var aPaths = [];

	var findPath = function(iX1, iY1, iX2, iY2, a, sDir, aParentValidPoints) {
		var aFiltered;
		var oPoint;
		var aVisited;

		if (sDir == "x") {
			a["sort"](sortDotsX);
		} else {
			a["sort"](sortDotsY);
		}
		var iX = iX1;
		var iY = iY1;
		var bValidPoint = false;
		var aValidPoints = [];
		if (!aParentValidPoints) {
			aParentValidPoints = [];
		}
		for (var i = 0; i < a["length"]; i++) {
			var o = a[i];
			if (sDir == "x") {
				if (o["y"] == iY && !o["coll"]) {
					iX = o["x"];
					a[i]["visited"] = true;
					aValidPoints["push"]({ "x": iX, "y": iY, "i": i });
					bValidPoint = true;
					if (iY == iY2 && iX == iX2) {
						a[i]["visited"] = false;
						aParentValidPoints = aParentValidPoints["concat"](aValidPoints);
						aPaths["push"](aParentValidPoints);
						break;
					}
				} else {
					if (bValidPoint) {
						aFiltered = a["filter"](filterY, { "x1": iX, "x2": iX2, "y1": iY, "y2": iY2, "bottom": true });
						var aPathArray = findPath(iX, iY, iX2, iY2, aFiltered, "y", aParentValidPoints["concat"](aValidPoints));
						if (!aPathArray) {
							aFiltered = a["filter"](filterY, { "x1": iX, "x2": iX2, "y1": iY, "y2": iY2, "top": true });
							aPathArray = findPath(iX, iY, iX2, iY2, aFiltered, "y", aParentValidPoints["concat"](aValidPoints));
							if (!aPathArray) {
								oPoint = aValidPoints["pop"]();
								a[oPoint["i"]]["visited"] = false;
								while (!aPathArray && aValidPoints["length"] > 0) {
									aVisited = aParentValidPoints["concat"](aValidPoints);
									oPoint = aValidPoints["pop"]();
									a[oPoint["i"]]["visited"] = false;
									aFiltered = a["filter"](filterY, { "x1": oPoint["x"], "x2": iX2, "y1": oPoint["y"], "y2": iY2, "bottom": true });
									aPathArray = findPath(oPoint["x"], oPoint["y"], iX2, iY2, aFiltered, "y", aVisited);
									if (!aPathArray) {
										aFiltered = a["filter"](filterY, { "x1": oPoint["x"], "x2": iX2, "y1": oPoint["y"], "y2": iY2, "top": true });
										aPathArray = findPath(oPoint["x"], oPoint["y"], iX2, iY2, aFiltered, "y", aVisited);
									}
								}
							}
						}
						return aPathArray;
					}
					break;
				}
			} else {
				if (o["x"] == iX && !o["coll"]) {
					iY = o["y"];
					a[i]["visited"] = true;
					aValidPoints["push"]({ "x": iX, "y": iY, "i": i });
					bValidPoint = true;
					if (iY == iY2 && iX == iX2) {
						a[i]["visited"] = false;
						aParentValidPoints = aParentValidPoints["concat"](aValidPoints);
						aPaths["push"](aParentValidPoints);
						break;
					}
				} else {
					if (bValidPoint) {
						aFiltered = a["filter"](filterX, { "x1": iX, "x2": iX2, "y1": iY, "y2": iY2, "right": true });
						aPathArray = findPath(iX, iY, iX2, iY2, aFiltered, "x", aParentValidPoints["concat"](aValidPoints));
						if (!aPathArray) {
							aFiltered = a["filter"](filterX, { "x1": iX, "x2": iX2, "y1": iY, "y2": iY2, "left": true });
							aPathArray = findPath(iX, iY, iX2, iY2, aFiltered, "x", aParentValidPoints["concat"](aValidPoints));
							if (!aPathArray) {
								oPoint = aValidPoints["pop"]();
								a[oPoint["i"]]["visited"] = false;
								while (!aPathArray && aValidPoints["length"] > 0) {
									aVisited = aParentValidPoints["concat"](aValidPoints);
									oPoint = aValidPoints["pop"]();
									a[oPoint["i"]]["visited"] = false;
									aFiltered = a["filter"](filterY, { "x1": oPoint["x"], "x2": iX2, "y1": oPoint["y"], "y2": iY2, "right": true });
									aPathArray = findPath(oPoint["x"], oPoint["y"], iX2, iY2, aFiltered, "x", aVisited);
									if (!aPathArray) {
										aFiltered = a["filter"](filterY, { "x1": oPoint["x"], "x2": iX2, "y1": oPoint["y"], "y2": iY2, "left": true });
										aPathArray = findPath(oPoint["x"], oPoint["y"], iX2, iY2, aFiltered, "x", aVisited);
									}
								}
							}
						}
						return aPathArray;
					}
					break;
				}
			}
		}
	};

	var aValidPathsX = [],
		aValidPathsY = [];
	for (i = 0; i < aFromConnectionPoints["length"]; i++) {
		for (var j = 0; j < aToConnectionPoints["length"]; j++) {
			var iStartX = aFromConnectionPoints[i]["x"];
			var iEndX = aToConnectionPoints[j]["x"];
			var iStartY = aFromConnectionPoints[i]["y"];
			var iEndY = aToConnectionPoints[j]["y"];
			iWidth = iEndX - iStartX;
			var iHeight = iEndY - iStartY;
			var iRasterX = iWidth / 10;
			var iRasterY = iHeight / 10;

			for (var x = iStartX; x <= iEndX; x = x + iRasterX) {
				for (var y = iStartY; y <= iEndY; y = y + iRasterY) {
					var iX = Math["ceil"](x);
					var iY = Math["ceil"](y);
					var bCollision = false;
					for (var z = 0; z < aCollisionRects["length"]; z++) {
						var oCollisionRect = aCollisionRects[z];
						if (isInRect(iX, iY, oCollisionRect, 3)) {
							bCollision = true;
						}
					}
					if (!bCollision) {
						aDots["push"]({ "x": iX, "y": iY });
						this["drawLine"](iX, iY, iX + 1, iY + 1, "blue", 1);
					} else {
						aDots["push"]({ "x": iX, "y": iY, "coll": true });
						this["drawLine"](iX, iY, iX + 1, iY + 1, "pink", 1);
					}
				}
			}
			if (aFromConnectionPoints[i]["dir"] == "right" || aFromConnectionPoints[i]["dir"] == "left") {
				findPath(iStartX, iStartY, iEndX, iEndY, aDots, "x");
				aValidPathsX = aValidPathsX["concat"](aPaths);
				aPaths = [];
			} else {
				findPath(iStartX, iStartY, iEndX, iEndY, aDots, "y");
				aValidPathsY = aValidPathsY["concat"](aPaths);
				aPaths = [];
			}
		}
	}
	var getWeightenedPath = function(aPath) {
		var oResult = {
			"pathCoords": [],
			"corners": 0,
			"valid": true,
			"minDistanceX": 10000,
			"maxDistanceX": 0,
			"minDistanceY": 10000,
			"maxDistanceY": 0,
			"averageDistance": 0,
			"segments": aPath["length"]
		};
		var i;

		//optimize the path
		var sDir = "";
		for (i = 0; i < aPath["length"]; i++) {
			var oCoord = aPath[i],
				oLastCoord = null;
			if (oResult["pathCoords"]["length"] > 0) {
				oLastCoord = oResult["pathCoords"][oResult["pathCoords"]["length"] - 1];
				if (oLastCoord["x"] != oCoord["x"] && oLastCoord["y"] == oCoord["y"]) {
					if (sDir != "x") {
						if (sDir == "y") {
							oResult["corners"]++;
						}
						oResult["pathCoords"]["push"]({ "x": oCoord["x"], "y": oLastCoord["y"] });
					} else {
						oLastCoord["x"] = oCoord["x"];
					}
					sDir = "x";
				} else if (oLastCoord["y"] != oCoord["y"] && oLastCoord["x"] == oCoord["x"]) {
					if (sDir != "y") {
						if (sDir == "x") {
							oResult["corners"]++;
						}
						oResult["pathCoords"]["push"]({ "x": oLastCoord["x"], "y": oCoord["y"] });
					} else {
						oLastCoord["y"] = oCoord["y"];
					}
					sDir = "y";
				} else {
					oResult["pathCoords"]["push"]({ "x": oCoord["x"], "y": oCoord["y"] });
				}
			} else {
				oResult["pathCoords"]["push"]({ "x": oCoord["x"], "y": oCoord["y"] });
			}
		}
		for (i = 0; i < oResult["pathCoords"]["length"] - 1; i++) {
			var oCoord1 = oResult["pathCoords"][i],
				oCoord2 = oResult["pathCoords"][i + 1];
			oResult["minDistanceX"] = Math["min"](oResult["minDistanceX"], oCoord2["x"] - oCoord1["x"]);
			oResult["minDistanceY"] = Math["min"](oResult["minDistanceY"], oCoord2["y"] - oCoord1["y"]);
			oResult["maxDistanceX"] = Math["max"](oResult["maxDistanceX"], oCoord2["x"] - oCoord1["x"]);
			oResult["maxDistanceY"] = Math["max"](oResult["maxDistanceY"], oCoord2["y"] - oCoord1["y"]);
		}
		oResult["averageDistance"] = (oResult["maxDistanceY"] + oResult["minDistanceY"] + oResult["maxDistanceX"] + oResult["minDistanceX"]) / 4;
		return oResult;
	};
	var oWeightedPath = null;
	var aValidPaths = aValidPathsY["concat"](aValidPathsX);
	if (aValidPaths["length"] > 0) {
		for (var k = 0; k < aValidPaths["length"]; k++) {
			var aPath = aValidPaths[k];
			var oPath = getWeightenedPath(aPath);
			for (i = 0; i < oPath["pathCoords"]["length"] - 1; i++) {
				this["drawLine"](oPath["pathCoords"][i]["x"], oPath["pathCoords"][i]["y"], oPath["pathCoords"][i + 1]["x"], oPath["pathCoords"][i + 1]["y"], "#ccc0c0", 1);
			}
			if (oWeightedPath) {
				if (oPath["corners"] < oWeightedPath["corners"]) {
					oWeightedPath = oPath;
				} else if (oPath["corners"] == oWeightedPath["corners"]) {
					if (oPath["averageDistance"] < oWeightedPath["averageDistance"]) {
						oWeightedPath = oPath;
					}
				}
			} else {
				oWeightedPath = oPath;
			}
		}
	}
	if (oWeightedPath) {
		this["oContext"]["beginPath"]();
		for (i = 0; i < oWeightedPath["pathCoords"]["length"] - 1; i++) {
			this["drawLine"](oWeightedPath["pathCoords"][i]["x"], oWeightedPath["pathCoords"][i]["y"], oWeightedPath["pathCoords"][i + 1]["x"], oWeightedPath["pathCoords"][i + 1]["y"], "green", 1);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawConnector"] = 0; };

/**
 * BezierConnector Methods
 */

/**
 * @private
 */
UCF_Canvas["prototype"]["createBezierConnector"] = function(oFrom, oTo, iWidth, sColor) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createBezierConnector"]++; }; 
	return this["createObject"]("BezierConnector", ["oFrom", "oTo", "iWidth", "sColor"], Array["prototype"]["slice"]["call"](arguments, 0));
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["createBezierConnector"] = 0; };

/**
 * @public
 */
UCF_Canvas["prototype"]["addBezierConnector"] = function(oFrom, oTo, iWidth, sColor) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addBezierConnector"]++; }; 
	return this["addObject"](this["createBezierConnector"]["apply"](this, arguments));
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["addBezierConnector"] = 0; };
/**
 * @public
 */
UCF_Canvas["prototype"]["removeBezierConnector"] = function(oBezierConnector) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeBezierConnector"]++; }; 
	this["removeObject"](oBezierConnector);
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeBezierConnector"] = 0; };

/**
 * @private
 */
UCF_Canvas["prototype"]["drawBezierConnector"] = function(oFrom, oTo, iWidth, sColor) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawBezierConnector"]++; }; 

	this["iMaxX"] = Math["max"](this["iMaxX"], oFrom["x"] + 50, oTo["x"]);
	this["iMaxY"] = Math["max"](this["iMaxY"], oFrom["y"], oTo["y"] + 50);

	if (this["bDraw"]) {
		this["oContext"]["beginPath"]();
		this["oContext"]["lineWidth"] = iWidth;
		this["oContext"]["strokeStyle"] = sColor;
		this["oContext"]["beginPath"]();
		this["oContext"]["moveTo"](oFrom["x"], oFrom["y"]);
		if (!oFrom["spaceX"]) oFrom["spaceX"] = 0;
		if (!oFrom["spaceY"]) oFrom["spaceY"] = 0;
		if (!oTo["spaceX"]) oTo["spaceX"] = 0;
		if (!oTo["spaceY"]) oTo["spaceY"] = 0;
		if (oFrom["x"] > oTo["x"]) oFrom["spaceX"] = -oFrom["spaceX"];
		if (oFrom["y"] > oTo["y"]) oFrom["spaceY"] = -oFrom["spaceY"];
		if (oTo["x"] > oFrom["x"]) oTo["spaceX"] = -oTo["spaceX"];
		if (oTo["y"] > oFrom["y"]) oTo["spaceY"] = -oTo["spaceY"];

		this["oContext"]["bezierCurveTo"](oFrom["x"] + 10 + Math["floor"](oFrom["spaceY"]), oFrom["y"] + Math["floor"](oFrom["spaceY"]), oTo["x"] + Math["floor"](oTo["spaceX"]), oTo["y"] - 10 + Math["floor"](oTo["spaceY"]), oTo["x"], oTo["y"]);
		this["oContext"]["stroke"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawBezierConnector"] = 0; };

UCF_Canvas["prototype"]["drawConnectorPoint"] = function(iX, iY, sType, sColor, oLine) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawConnectorPoint"]++; }; 
	this["oContext"]["beginPath"]();
	if (sType == UCF_Canvas["ConnectorType"]["Bullet"]) {
		this["oContext"]["arc"](iX, iY, 3, 0, 2 * Math["PI"]);
	} else if (sType == UCF_Canvas["ConnectorType"]["Arrow"]) {
		var iDirectionPos = -8;
		if (oLine["iStartX"] > oLine["iEndX"]) {
			iDirectionPos = 8;
		}
		this["oContext"]["moveTo"](iX, iY);
		this["oContext"]["lineTo"](iX + iDirectionPos, iY - 4);
		this["oContext"]["lineTo"](iX + iDirectionPos, iY + 4);
		this["oContext"]["closePath"]();
	}
	this["oContext"]["fillStyle"] = sColor;
	this["oContext"]["fill"]();
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["drawConnectorPoint"] = 0; };

/**
 * Returns the DOM Element of the canvas
 * @returns {Element} DOM Element of the canvas
 * @public
 */
UCF_Canvas["prototype"]["oGetDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["oGetDomRef"]++; }; 
	return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["oGetDomRef"] = 0; };

UCF_Canvas["prototype"]["clear"] = function() {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["clear"]++; }; 
	this["oContext"] = this["oDomRef"]["getContext"]("2d");
	this["oContext"]["clearRect"](0, 0, this["iWidth"], this["iHeight"]);
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["clear"] = 0; };
/**
 * Hides the canvas if it is in the dom
 * @public
 */
UCF_Canvas["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["hide"]++; }; 
	this["bHidden"] = true;
	this["oDomRef"]["style"]["display"] = "none";
	this["oDomRef"]["style"]["zIndex"] = "0";
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["hide"] = 0; };

/**
 * Shows the canvas if it is in the dom
 * @public
 */
UCF_Canvas["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["show"]++; }; 
	this["bHidden"] = false;
	this["oDomRef"]["style"]["display"] = "block";
	this["setZIndex"](this["iZIndex"]);
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["show"] = 0; };

/**
 * Sets the opacity of the canvas
 * @public
 */
UCF_Canvas["prototype"]["setOpacity"] = function(fOpacity) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["setOpacity"]++; }; 
	this["oDomRef"]["style"]["opacity"] = "" + fOpacity;
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["setOpacity"] = 0; };

/**
 * Sets the given CSS class to the canvas. Used for central background or opazity settings
 * @public
 */
UCF_Canvas["prototype"]["setCssClass"] = function(sCssClass) {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["setCssClass"]++; }; 
	this["oDomRef"]["className"] = sCssClass;
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["setCssClass"] = 0; };

/**
 * Removes all objects from the canvas
 * @public
 */
UCF_Canvas["prototype"]["removeAllObjects"] = function() {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeAllObjects"]++; }; 
	this["aDrawedObjects"] = [];
	this["redraw"]();
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["removeAllObjects"] = 0; };

/**
 * Destroys the canvas
 * @public
 */
UCF_Canvas["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["destroy"]++; }; 
	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	this["oDomRef"]["parentNode"]["removeChild"](this["oDomRef"]);
	this["oDomRef"] = null;

	this["iZIndex"] = null;
	this["iRedrawTimer"] = null;
	this["oContext"] = null;
	this["iMaxY"] = null;
	this["iMaxX"] = null;
	this["oParent"] = null;
	this["iLeft"] = null;
	this["iTop"] = null;
	this["oLS"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["destroy"] = 0; };

UCF_Canvas["prototype"]["redraw"] = function() {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["redraw"]++; }; 
	if (this["iRedrawTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["iRedrawTimer"]);
	}
	this["iRedrawTimer"] = UCF_JsUtil["delayedCall"](1, this, "_redraw");
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["redraw"] = 0; };

/**
 * Redraws all canvas objects
 * @private
 */
UCF_Canvas["prototype"]["_redraw"] = function() {;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["_redraw"]++; }; 
	var a = this["aDrawedObjects"];
	var i;

	this["iMaxX"] = 0;
	this["iMaxY"] = 0;
	this["bDraw"] = false;
	//calculate the max height and width
	for (i = 0; i < a["length"]; i++) {
		this["draw" + a[i]["name"]]["apply"](this, a[i]["arguments"]);
	}
	//resize id needed (this clears)
	this["oDomRef"]["width"] = this["iMaxX"];
	this["oDomRef"]["height"] = this["iMaxY"];
	this["oContext"]["clearRect"](0, 0, this["iMaxX"], this["iMaxY"]);

	//now draw it
	this["bDraw"] = true;
	for (i = 0; i < a["length"]; i++) {
		var sName = a[i]["name"];
		this["oContext"]["lineWidth"] = 1;
		this["draw" + sName]["apply"](this, a[i]["arguments"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Canvas["_"]["_redraw"] = 0; };

UCF_Canvas.prototype["aPublicMethods"] = ["addLine","removeLine","addRect","removeRect","addCircle","removeCircle","addBezierConnector","removeBezierConnector","oGetDomRef","hide","show","setOpacity","setCssClass","removeAllObjects","destroy"].concat(UCF_Canvas.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Caption"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_ImageUtil */
/// <reference path="../core/ImageUtil.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_RenderManager */
/// <reference path="../core/RenderManager.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_CaptionDragDelegate */
/// <reference path="./delegates/CaptionDragDelegate.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Caption(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Caption["_"]["UCF_Caption"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "Caption.js(39): UCF_Caption"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Caption.js(40): UCF_Caption"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Caption.js(41): UCF_Caption"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["allowTextSelection"]();

	this["initializeHandle"](oDomRef);
	this["iSVGDefaultWidth"] = 16;
	// parameter does not exist yet
	if (this["bEditable"]) {
		var oInplaceEditDelegate = this["oInplaceEditDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEditDelegate"))(oLS);

		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this, 'onInplaceEditStart');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this, 'onInplaceEditFinished');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this, 'onInplaceEditClosed');
		this["addDelegate"](oInplaceEditDelegate);
	}
};window["UCF_Caption"] = UCF_Caption; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Caption"); UCF_Caption["_"] = {UCF_Caption: 0}; }; ;

UCF_Caption["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Caption.prototype["sClassName"] = "UCF_Caption";

UCF_Caption["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["initialize"]++; }; 
	// user-select:none behaviour for IE
	if (this["bIsDragHandle"] || this["sDragSourceInfo"] !== '') {
		if (typeof this["oDomRef"]["onselectstart"] !== 'undefined') {
			if (UCF_UserAgent["bIsGecko"]()) this["oDomRef"]["onselectstart"] = function() { return false; };
			else this["oDomRef"]["onselectstart"] = function() {
				var e = window["event"];
				e["cancelBubble"] = true;
				e["returnValue"] = false;
				return false;
			};
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["initialize"] = 0; };

UCF_Caption["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onmouseover"]++; }; 
	if (this["sHoverImageSrc"] != null && !UCF_StringUtil["bIsEmpty"](this["sHoverImageSrc"])) {
		this["setIconSource"](this["sHoverImageSrc"]);
	}
	// Tooltip for hidden overflow
	if (window["UCF_System"]["bIs508"]) return;
	var sTooltip = this["sTooltip"];
	// Check for IE if the Caption is nested and rendered into a SapTableHeaderCell
	// in IE Standards pointer-events:none not working for display:inline
	if (!this["bIsNested"] && UCF_UserAgent["bIsIE"]()) {
		var oHeaderCellDomRef = UCF_DomUtil["oGetParentByAttribute"](this["oDomRef"], "captionid", this["sId"]);
		sTooltip = (oHeaderCellDomRef && oHeaderCellDomRef["getAttribute"])
			? oHeaderCellDomRef["getAttribute"]('t') : this["sTooltip"];
	}

	UCF_DomUtil["checkTooltip"](this["oDomRef"], sTooltip, null, this["sText"]);
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onmouseover"] = 0; };

/**
 * Sets the icon source
 *
 * @param {string} sIconSrc
 * @param {HTMLElement} oIconRef
 * @private
 */
UCF_Caption["prototype"]["setIconSource"] = function(sIconSrc, oIconRef) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["setIconSource"]++; }; 
	/** @type {UCF_RenderManager} */
	var oRenderManager;
	if (this["sCurrentSrc"] === sIconSrc) return;

	if (!oIconRef)
		oIconRef = UCF_DomUtil["$"](this["sId"] + '-img');

	if (oIconRef["tagName"] === "IMG") {
		UCF_ImageUtil["setImageSource"](sIconSrc, oIconRef);
		return;
	}
	if (!this["bIsNested"]) {
		return;
	}
	if (oIconRef) {
		oRenderManager = this["oLS"]["oGetRenderManager"]();
		this["renderImage"](sIconSrc, oRenderManager);

		UCF_DomUtil["replaceElement"](
			oIconRef,
			oRenderManager["oGetElementFromHtml"]()
		);
		oRenderManager["clearBuffer"]();

		this["sCurrentSrc"] = sIconSrc;
	}
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["setIconSource"] = 0; };

/**
 * @private
 * @param {string} sIconSrc the icon src
 * @param {UCF_RenderManager} oRenderManager the render manager
 */
UCF_Caption["prototype"]["renderImage"] = function(sIconSrc, oRenderManager) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["renderImage"]++; }; 
	oRenderManager["write"](this["oLS"]["oGetRenderManager"]()["callFragment"](
		'UrBase_IconFragmentExtended',
		'UrBase', {
			"Id": this["sId"] + '-img',
			"Src": sIconSrc,
			"SrcOnError": '',
			"Width": this["sImageWidth"],
			"Height": this["sImageHeight"],
			"Tooltip": this["sTooltip"],
			"AlternativeText": '',
			"CssClass": '',
			"PreventDraging": '',
			"Text": this["sText"],
			"AccessKey": '',
			"EnabledAccessKey": false
		}
	));
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["renderImage"] = 0; };

UCF_Caption["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onmouseout"]++; }; 
	if (this["sHoverImageSrc"] != null && !UCF_StringUtil["bIsEmpty"](this["sHoverImageSrc"])) {
		this["setIconSource"](this["sImageSrc"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onmouseout"] = 0; };

UCF_Caption["prototype"]["bParentIsLayout"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["bParentIsLayout"]++; }; 

	var oParent = oDomRef["parentNode"];

	if (oParent == null) return false;

	var sCt = oParent["ct"];

	return (sCt === 'CL' || sCt === 'FL' || sCt === 'GLC' || sCt === 'GL' || sCt === 'MLC' || sCt === 'ML' || sCt === 'MG' || sCt === 'PHM' || sCt === 'RL' || sCt === 'SL' || sCt === 'SLC' || sCt == null);
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["bParentIsLayout"] = 0; };

/**
 * Sets the correct acc text
 */

UCF_Caption["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Caption.js(178): onlsaccessibility"); };

	if (this["bIsNested"] && !this["bParentIsLayout"](this["oDomRef"])) return;

	var oSource = oBrowserEvent["oGetSourceControl"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		sText = UCF_DomUtil["sGetInnerText"](oSource["oDomRef"]);

	oAccessibilityHelper["setText"](sText);
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);

	if (UCF_StringUtil["bIsEmpty"](sText) && UCF_StringUtil["bIsEmpty"](this["sImageSrc"])) oAccessibilityHelper["setEmpty"](true);

	// Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this);
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

	this["applyAccSemantic"](oAccessibilityHelper);

};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onlsaccessibility"] = 0; };

/**
 * Applies semantic accessibility description for caption
 *
 * @param {UCF_AccessibilityHelper}
 *            UCF_AccessibilityHelper passed
 */

UCF_Caption["prototype"]["applyAccSemantic"] = function(oAccessibilityHelper) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["applyAccSemantic"]++; }; 

	if (this["sSemanticColor"] !== 'NONE') {
		oAccessibilityHelper["addSemantic"](this["sSemanticColor"]);
	}

	if (this["sDesign"] === 'EMPHASIZED') {
		oAccessibilityHelper["addSemantic"](this["sDesign"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["applyAccSemantic"] = 0; };

/**
 * Returns caption text
 */

UCF_Caption["prototype"]["sGetText"] = function() {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["sGetText"]++; }; 
	return this["sText"];
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["sGetText"] = 0; };

UCF_Caption["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["createDragDelegate"]++; }; 

	if (!this["sDragSourceInfo"])
		return;

	if (this["oDragDelegate"])
		return;

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_CaptionDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["createDragDelegate"] = 0; };

/**
 * setDragSourceInfo
 *
 * @param { string } sDragSourceInfo of the the new DragSourceInfo
 * @public
 */
UCF_Caption["prototype"]["setDragSourceInfo"] = function(sDragSourceInfo) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["setDragSourceInfo"]++; }; 
	this["sDragSourceInfo"] = sDragSourceInfo;
	this["setClientProperty"]("DragSourceInfo", this["sDragSourceInfo"], true);
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["setDragSourceInfo"] = 0; };

/**
 * Called when Inplace Edit starts
 */

UCF_Caption["prototype"]["onInplaceEditStart"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onInplaceEditStart"]++; }; 

	var oBoundaries = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);

	if (this["sImageSrc"] && this["bImageFirst"]) {
		// SVG have no offsetWidth, so a default value is needed		this.iSVGDefaultWidth
		var iImgOffsetWidth = UCF_DomUtil["firstChild"](this["oDomRef"])["offsetWidth"];

		oBoundaries["left"] += (iImgOffsetWidth ? iImgOffsetWidth : this["iSVGDefaultWidth"]) + 3;
	}

	this["oInplaceEditDelegate"]["setInplaceEditData"](
		this["oDomRef"],
		oBoundaries,
		this["sText"]
	);

};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onInplaceEditStart"] = 0; };

/**
 * Called when Inplace Edit is finished
 */

UCF_Caption["prototype"]["onInplaceEditFinished"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onInplaceEditFinished"]++; }; 
	var sText = oParams["oGetParam"]('sText');

	if (sText === this["sText"]) return;

	this["sText"] = sText;
	sText = UCF_XSSEncoder["encodeHTML"](sText);
	var oImageDomRef = UCF_DomUtil["$"](this["sId"] + '-img'),
		oTxtDomRef = UCF_DomUtil["$"](this["sId"] + '-txt'),
		oAriaDomRef = UCF_DomUtil["$"](this["sId"] + '-ariadescription');

	if (this["bImageFirst"] && this["sImageSrc"]) {

		if (oTxtDomRef) {
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oTxtDomRef, '&nbsp;' + sText);
		} else {
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](this["oDomRef"], '&nbsp;' + sText);
			this["oDomRef"]["insertBefore"](oImageDomRef, this["oDomRef"]["firstChild"]);
		}
	} else if (!this["bImageFirst"] && this["sImageSrc"]) {
		if (oTxtDomRef) {
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oTxtDomRef, '&nbsp;' + sText);
		} else {
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](this["oDomRef"], sText + '&nbsp;');
			this["oDomRef"]["appendChild"](oImageDomRef);
		}
	} else {
		if (oTxtDomRef) {
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oTxtDomRef, '&nbsp;' + sText);
		} else {
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](this["oDomRef"], sText);
		}
	}
	if (oAriaDomRef)
		this["oDomRef"]["appendChild"](oAriaDomRef);

	this["setClientProperty"]("Text", this["sText"], true);

	if (this["bIsNested"]) {
		UCF_DomUtil["focusDomElement"](this["oDomRef"]);
	}

	this["fireChange"](this["sId"], sText);
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onInplaceEditFinished"] = 0; };

UCF_Caption["prototype"]["onInplaceEditClosed"] = function() {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onInplaceEditClosed"]++; }; 
	UCF_DomUtil["focusDomElement"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["onInplaceEditClosed"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 */

UCF_Caption["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["oGetInplaceEditDomRef"]++; }; 
	return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["oGetInplaceEditDomRef"] = 0; };

UCF_Caption["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["destroy"]++; }; 

	var oInplaceEditDelegate = this["oInplaceEditDelegate"];

	if (oInplaceEditDelegate) {
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this);
		this["oInplaceEditDelegate"]["destroy"]();
		this["oInplaceEditDelegate"] = null;
	}
	this["sCurrentSrc"] = null;

	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	this["sDragSourceInfo"] = null;
	this["sText"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["destroy"] = 0; };

/**
 * Returns the icon source
 *
 * @param {HTMLElement} oIconRef
 * @return {string}
 * @private
 */
UCF_Caption["prototype"]["sGetIconSource"] = function(oIconRef) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["sGetIconSource"]++; }; 
	if (!oIconRef) oIconRef = UCF_DomUtil["$"](this["sId"] + '-img');

	return UCF_ImageUtil["sGetImageSource"](oIconRef);
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["sGetIconSource"] = 0; };

/**
 * See UCF_Control.aGetTouchContextMenuEntries()
 * @private
 * @return {Array<{sType: ('TOOLTIP'|'TEXT'|'DATATIP'|'DOUBLECLICK'), sText: string, fTrigger: function(): void}>}
 */
UCF_Caption["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	if (UCF_DomUtil["bHasTextEllipsis"](this["oDomRef"])) {
		aResult["push"]({
			"sType": 'TEXT',
			"sText": UCF_DomUtil["removeColon"](this["sGetText"]())
		});
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["aGetTouchContextMenuEntries"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_Caption["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			this["oDomRef"]["setAttribute"]('role', 'gridcell');
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
		}
	}
	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["bPrepareAria"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Caption["prototype"]["aAttributeNames"] = ["sTooltip","sText","sImageSrc","bImageFirst","sImageWidth","sImageHeight","bIsNested","sVisibility","bIsDragHandle","sHoverImageSrc","sDragSourceInfo","bEditable","sSemanticColor","sDesign","sCustomData","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Caption["prototype"]["aEventNames"] = ["Change"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Caption["prototype"]["aMethodNames"] = ["setDragSourceInfo","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Caption["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Caption["prototype"]["sText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Caption["prototype"]["sImageSrc"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Caption["prototype"]["bImageFirst"] = true;

/**
 * @private
 * @type {string}
 */
UCF_Caption["prototype"]["sImageWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Caption["prototype"]["sImageHeight"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Caption["prototype"]["bIsNested"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Caption["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_Caption["prototype"]["bIsDragHandle"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Caption["prototype"]["sHoverImageSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Caption["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Caption["prototype"]["bEditable"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_Caption["prototype"]["sSemanticColor"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CaptionDesign}
 */
UCF_Caption["prototype"]["sDesign"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_Caption["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Caption["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Caption["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sText"] = '';
	this["sImageSrc"] = '';
	this["bImageFirst"] = true;
	this["sImageWidth"] = '';
	this["sImageHeight"] = '';
	this["bIsNested"] = true;
	this["sVisibility"] = "VISIBLE";
	this["bIsDragHandle"] = false;
	this["sHoverImageSrc"] = '';
	this["sDragSourceInfo"] = '';
	this["bEditable"] = false;
	this["sSemanticColor"] = "NONE";
	this["sDesign"] = "STANDARD";
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("ImageSrc", '', true);
		this["setClientProperty"]("ImageFirst", true, true);
		this["setClientProperty"]("ImageWidth", '', true);
		this["setClientProperty"]("ImageHeight", '', true);
		this["setClientProperty"]("IsNested", true, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("IsDragHandle", false, true);
		this["setClientProperty"]("HoverImageSrc", '', true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("Editable", false, true);
		this["setClientProperty"]("SemanticColor", "NONE", true);
		this["setClientProperty"]("Design", "STANDARD", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The id of the Accordion.
 * @param {string} sValue The new tile.
 * @fires Caption::Change
 */
UCF_Caption["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_Caption["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Caption.js(582): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Caption.js(583): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Caption.js(584): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "Caption.js(585): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Caption.js(586): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("Caption", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Caption["_"]["fireChange"] = 0; };

UCF_Caption.prototype["aPublicMethods"] = ["setDragSourceInfo"].concat(UCF_Caption.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_CaptionDragDelegate"] = function() {/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_CaptionDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_CaptionDragDelegate["_"]["UCF_CaptionDragDelegate"]++; }; 
	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);
};window["UCF_CaptionDragDelegate"] = UCF_CaptionDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CaptionDragDelegate"); UCF_CaptionDragDelegate["_"] = {UCF_CaptionDragDelegate: 0}; }; ;

UCF_CaptionDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_CaptionDragDelegate.prototype["sClassName"] = "UCF_CaptionDragDelegate";

/** @return {UCF_HTMLGhost} */
UCF_CaptionDragDelegate["prototype"]["oGetGhost"] = function() {;if (__UCF_COVERAGE__) { UCF_CaptionDragDelegate["_"]["oGetGhost"]++; }; 

	var oDiv = document["createElement"]('DIV'),
		oTemp = document["createElement"]('DIV');

	oTemp["appendChild"](this["oDragSourceControl"]["oDomRef"]["cloneNode"](true));
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oDiv, oTemp["innerHTML"]);

	// Right border cut off on FF => +2
	oDiv["style"]["width"] = (this["oDragSourceControl"]["oDomRef"]["offsetWidth"] + 2) + 'px';

	var oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv);

	oGhost["setOffset"](12, 12);

	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_CaptionDragDelegate["_"]["oGetGhost"] = 0; };

};
sap["ls"]["preload"]["UCF_Carousel"] = function() {/* global _assert, _trace, INFO, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>

/**
 * @typedef {Object} UCF_Carousel_ItemInfo
 * @property {HTMLSpanElement} oDomRef
 * @property {number} iOffsetLeft
 * @property {number} iOffsetTop
 * @property {number} iOffsetWidth
 * @property {number} iOffsetHeight
 */
/**
 * @typedef {UCF_Carousel_ScrollConfiguration} oConf
 * @property {number} iEndPx
 * @property {boolean} [bImmediate]
 * @property {number} [iCurrentIndex=0]
 * @property {number} [iFutureIndex=1]
 * @property {function(): void} [fDone]
 */

/** @class
 *
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Carousel(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Carousel["_"]["UCF_Carousel"]++; }; 
	/** @type {HTMLDivElement} */
	var oPrevButtonRef;
	/** @type {HTMLDivElement} */
	var oNextButtonRef;
	/** @type {UCF_Carousel} */
	var self;

	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "Carousel.js(64): onPointerDown"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Carousel.js(65): onPointerDown"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Carousel.js(66): onPointerDown"); };

		self = this;
		UCF_Control["apply"](this, [oDomRef, oLS]);
		/** @type {int} */
		this["iPageSize"] = 10; // No. of items per Page

		/** @type {int} */
		this["iLastSelectedItem"] = -1; // for ARIA to reset the ARIA attributes

		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

		/** @type {UCF_Control} */
		this["oCurrentControl"] = null;
		/** @type {UCF_ScrollArea} */
		this["oScrollArea"] = UCF_ClassLoader["oGetClass"]('UCF_ScrollArea')["oCreateAndConnectScrollArea"](
			this,
			this["sAlignment"] === 'VERTICAL' ? 'VERTICAL_AUTO' : 'HORIZONTAL_AUTO',
			'onScroll'
		);

		oPrevButtonRef = this["oGetPrevButtonRef"]();
		oNextButtonRef = this["oGetNextButtonRef"]();

		/** @type {UCF_Button} */
		this["oPrevButton"] = oPrevButtonRef &&
			this["oLS"]["oControlFactory"]["oGetControlByDomRef"](
				oPrevButtonRef,
				true
			);
		/** @type {UCF_Button} */
		this["oNextButton"] = oNextButtonRef &&
			this["oLS"]["oControlFactory"]["oGetControlByDomRef"](
				oNextButtonRef,
				true
			);

		if (this["oPrevButton"]) {
			this["oPrevButton"]["attachSemanticEvent"]('Press', this, 'onPrevPress');
		}
		if (this["oNextButton"]) {
			this["oNextButton"]["attachSemanticEvent"]('Press', this, 'onNextPress');
		}

		this["oLS"]["oBrowserWindow"]["attachEvent"](
			this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"],
			this,
			'onLayoutChange'
		);

		// Pointer-events
		/** @param {Event} oDomEvent */
		this["onPointerDown"] = function(oDomEvent) {
			/** @type {UCF_BrowserEvent} */
			// eslint-disable-next-line @ur/no-memory-leaks
			var oBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oDomEvent);
			/** @type {HTMLElement} */
			var oSourceRoot = oBrowserEvent["oGetSourceRoot"]();

			oBrowserEvent["oSourceControl"] = self["oLS"]["oControlFactory"]["bIsControlDomRef"](oSourceRoot)
				? self["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSourceRoot, true)
				: self["oLS"]["oGetPageInternal"]();

			self["handlePointerDown"](oBrowserEvent);

			oBrowserEvent["destroy"]();
		};
		/** @param {Event} oDomEvent */
		this["onPointerUp"] = function(oDomEvent) {
			/** @type {UCF_BrowserEvent} */
			// eslint-disable-next-line @ur/no-memory-leaks
			var oBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oDomEvent);
			/** @type {HTMLElement} */
			var oSourceRoot = oBrowserEvent["oGetSourceRoot"]();

			oBrowserEvent["oSourceControl"] = self["oLS"]["oControlFactory"]["bIsControlDomRef"](oSourceRoot)
				? self["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSourceRoot, true)
				: self["oLS"]["oGetPageInternal"]();

			self["handlePointerUp"](oBrowserEvent);

			oBrowserEvent["destroy"]();
		};
		// this.onPointerMove = function(oDomEvent) {
		// 	self.handlePointerMove(new UCF_BrowserEvent(oDomEvent));
		// };
		UCF_DomUtil["attachEvent"](self["oDomRef"], 'pointerdown', this["onPointerDown"]);
		UCF_DomUtil["attachEvent"](self["oDomRef"], 'pointerup', this["onPointerUp"]);
		// UCF_DomUtil.attachEvent(this.oGetScrollRef(), 'pointermove', this.onPointerMove);
	}
};window["UCF_Carousel"] = UCF_Carousel; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Carousel"); UCF_Carousel["_"] = {UCF_Carousel: 0}; }; ;

// UCF_Carousel.prototype = new (UCF_ClassLoader.oGetClass('UCF_Control'))();
UCF_Carousel["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Carousel.prototype["sClassName"] = "UCF_Carousel";

/** @const {number} */
UCF_Carousel["ANIMATION_DURATION_MS"] = 250;
/** @const {number} */
UCF_Carousel["MOVE_THRESHOLD"] = 20;

/** @return {void} */
UCF_Carousel["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["initialize"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	// set position absolute to hang out the items (get removed after initialize)
	UCF_DomUtil["setStyle"](this["oGetItemsRef"](), 'position', 'absolute');

	UCF_DomUtil["setStyle"](self["oDomRef"], self["oGetInitialDomRefStyle"]());

	// remove Position absolute from the itmes
	if (window["UCF_System"]["bIsRTL"])
		UCF_DomUtil["setStyle"](self["oGetItemsRef"](), 'position', 'static');
	else
		UCF_DomUtil["setStyle"](self["oGetItemsRef"](), 'position', '');

	self["onBeforeInitialize"]();
	if (self["sAlignment"] === 'HORIZONTAL' && self["iScrollLeft"] > 0) {
		if (UCF_DomUtil["bIsRTL"] && UCF_UserAgent["bIsIE"]()) {
			self["oGetScrollRef"]()["scrollLeft"] = self["iGetScrollRefScrollWidth"]() - self["iGetScrollRefClientWidth"]() - self["iScrollLeft"];
			self["onAfterInitializeWithScrollPosition"]();
		} else if (UCF_DomUtil["bIsRTL"] && (UCF_UserAgent["bIsFirefox"]() || UCF_UserAgent["bIsSafari"]())) {
			self["oGetScrollRef"]()["scrollLeft"] = (self["iGetScrollRefScrollWidth"]() - self["iGetScrollRefClientWidth"]() - self["iScrollLeft"]) * -1;
			self["onAfterInitializeWithScrollPosition"]();
		} else {
			self["oGetScrollRef"]()["scrollLeft"] = self["iScrollLeft"];
			self["onAfterInitializeWithScrollPosition"]();
		}
	} else if (self["sAlignment"] === 'VERTICAL' && self["iScrollTop"] > 0) {
		self["oGetScrollRef"]()["scrollTop"] = self["iScrollTop"];
		self["onAfterInitializeWithScrollPosition"]();
	} else if (self["iFirstVisible"] && self["iFirstVisible"] < self["aGetItems"]()["length"]) {
		self["scrollTo"](self["iFirstVisible"], true);
	} else {
		self["scrollTo"](0, true);
	}

	if (this["sNavigationPlacement"] === 'CONTENT') {
		if (self["oPrevButton"]) {
			UCF_DomUtil["setTabIndex"](self["oPrevButton"]["oDomRef"], -1);
			self["oPrevButton"]["oDomRef"]["setAttribute"]('aria-hidden', 'true');
		};
		if (self["oNextButton"]) {
			UCF_DomUtil["setTabIndex"](self["oNextButton"]["oDomRef"], -1);
			self["oNextButton"]["oDomRef"]["setAttribute"]('aria-hidden', 'true');
		};
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["initialize"] = 0; };

/**
 * @protected
 * @return {Object}
 */
UCF_Carousel["prototype"]["oGetInitialDomRefStyle"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetInitialDomRefStyle"]++; }; 
	return {};
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetInitialDomRefStyle"] = 0; };

UCF_Carousel["prototype"]["onBeforeInitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onBeforeInitialize"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onBeforeInitialize"] = 0; };

UCF_Carousel["prototype"]["onAfterInitializeWithScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterInitializeWithScrollPosition"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterInitializeWithScrollPosition"] = 0; };

/**
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetLargestItemWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetLargestItemWidth"]++; }; 
	/** @type {UCF_Carousel_ItemInfo[]} */
	var aItems = this["aGetItems"]();
	/** @type {number} */
	var maxWidth = 0;

	UCF_JsUtil["forEach"](
		aItems,
		function(oItem) {
			if (oItem["iOffsetWidth"] > maxWidth) {
				maxWidth = oItem["iOffsetWidth"];
			};
		}
	);
	return maxWidth;
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetLargestItemWidth"] = 0; };

/**
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetLargestItemHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetLargestItemHeight"]++; }; 
	/** @type {UCF_Carousel_ItemInfo[]} */
	var aItems = this["aGetItems"]();
	/** @type {number} */
	var maxHeight = 0;

	UCF_JsUtil["forEach"](
		aItems,
		function(oItem) {
			if (oItem["iOffsetHeight"] > maxHeight) {
				maxHeight = oItem["iOffsetHeight"];
			};
		}
	);
	return maxHeight;
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetLargestItemHeight"] = 0; };

/**
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetButtonsSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetButtonsSize"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('iButtonsSize', function() {
		return self["sNavigationPlacement"] === 'CONTENT'
			? (
				self["sAlignment"] === 'HORIZONTAL'
				? self["oGetPrevButtonContainerRef"]()["offsetWidth"] + self["iGetComputetMarginLeft"](self["oGetPrevButtonContainerRef"]()) + self["iGetComputetMarginRight"](self["oGetPrevButtonContainerRef"]()) +
				self["oGetNextButtonContainerRef"]()["offsetWidth"] + self["iGetComputetMarginLeft"](self["oGetNextButtonContainerRef"]()) + self["iGetComputetMarginRight"](self["oGetNextButtonContainerRef"]())
				: self["oGetPrevButtonContainerRef"]()["offsetHeight"] + self["iGetComputetMarginTop"](self["oGetPrevButtonContainerRef"]()) + self["iGetComputetMarginBottom"](self["oGetPrevButtonContainerRef"]()) +
				self["oGetNextButtonContainerRef"]()["offsetHeight"] + self["iGetComputetMarginTop"](self["oGetNextButtonContainerRef"]()) + self["iGetComputetMarginBottom"](self["oGetNextButtonContainerRef"]())
			) : 0;
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetButtonsSize"] = 0; };

/**
 * Returns the height from one of the two buttons with margin and boxshadow
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetFullButtonHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetFullButtonHeight"]++; }; 
	var self = this;

	return this["oCache"]["get"]('iButtonHeight', function() {
		return self["oPrevButton"]
			? self["oGetPrevButtonContainerRef"]()["offsetHeight"]
			+ self["iGetComputetBoxShadowSize"](self["oGetPrevButtonContainerRef"]())
			// + self.iGetComputetMarginTop(self.oPrevButton.oRootRef)
			// + self.iGetComputetMarginBottom(self.oPrevButton.oRootRef)
			: 0;
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetFullButtonHeight"] = 0; };

/**
 * @param {HTMLElement} oDomRef
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetComputetBoxShadowSize"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetComputetBoxShadowSize"]++; }; 
	/** @type {string} */
	var sComputetBoxShadow = UCF_DomUtil["oGetComputedStyle"](oDomRef)["boxShadow"];

	var r = UCF_UserAgent["bIsIE"]()
		? /(\d+(?:\.\d+)?)px (\d+(?:\.\d+)?)px (\d+(?:\.\d+)?)px (\d+(?:\.\d+)?)px rgba\(.*?\)/g
		: /rgba\(.*?\) (\d+(?:\.\d+)?)px (\d+(?:\.\d+)?)px (\d+(?:\.\d+)?)px (\d+(?:\.\d+)?)px/g;

	return sComputetBoxShadow !== 'none'
		? Math["max"]["apply"](null, UCF_JsUtil["map"](UCF_JsUtil["map"](sComputetBoxShadow["match"](r), function(_) { return r["lastIndex"] = 0 || UCF_JsUtil["map"](r["exec"](_)["slice"](1), function(_) { return parseInt(_); }); }), function(_) { return 2 * Math["max"](_[2], _[3]); }))
		: 0;
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetComputetBoxShadowSize"] = 0; };

/**
 * @param {HTMLElement} oDomRef
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetComputetMarginRight"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetComputetMarginRight"]++; }; 
	/** @type {string} */
	var sComputetMarginRight = UCF_DomUtil["oGetComputedStyle"](oDomRef)["marginRight"];

	return isNaN(parseInt(sComputetMarginRight, 10)) ? 0 : Math["round"](parseFloat(sComputetMarginRight));
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetComputetMarginRight"] = 0; };
/**
 * @param {HTMLElement} oDomRef
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetComputetMarginLeft"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetComputetMarginLeft"]++; }; 
	/** @type {string} */
	var sComputetMarginLeft = UCF_DomUtil["oGetComputedStyle"](oDomRef)["marginLeft"];

	return isNaN(parseInt(sComputetMarginLeft, 10)) ? 0 : Math["round"](parseFloat(sComputetMarginLeft));
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetComputetMarginLeft"] = 0; };
/**
 * @param {HTMLElement} oDomRef
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetComputetMarginTop"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetComputetMarginTop"]++; }; 
	/** @type {string} */
	var sComputetMarginTop = UCF_DomUtil["oGetComputedStyle"](oDomRef)["marginTop"];

	return isNaN(parseInt(sComputetMarginTop, 10)) ? 0 : Math["round"](parseFloat(sComputetMarginTop));
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetComputetMarginTop"] = 0; };
/**
 * @param {HTMLElement} oDomRef
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetComputetMarginBottom"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetComputetMarginBottom"]++; }; 
	/** @type {string} */
	var sComputetMarginBottom = UCF_DomUtil["oGetComputedStyle"](oDomRef)["marginBottom"];

	return isNaN(parseInt(sComputetMarginBottom, 10)) ? 0 : Math["round"](parseFloat(sComputetMarginBottom));
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetComputetMarginBottom"] = 0; };

/**
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetMinPaginationSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetMinPaginationSize"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {number} */
	var iMinPaginationSize = 0;

	if (this["sPagination"] !== 'NONE') {
		if ((this["sNavigationPlacement"] === "NONE" || this["sNavigationPlacement"] === "CONTENT") && this["sAlignment"] === "HORIZONTAL") {
			iMinPaginationSize = this["oCache"]["get"]('iMinPaginationSize', function() {
				return self["oGetPaginationElementscontainerRef"]()["clientWidth"];
			});
		} else if ((this["sNavigationPlacement"] === "NONE" || this["sNavigationPlacement"] === "CONTENT") && this["sAlignment"] === "VERTICAL") {
			iMinPaginationSize = this["oCache"]["get"]('iMinPaginationSize', function() {
				return self["oGetPaginationElementscontainerRef"]()["clientHeight"];
			});
		} else if (this["sNavigationPlacement"] === "PAGINATION" && this["sAlignment"] === "HORIZONTAL") {
			iMinPaginationSize = this["oCache"]["get"]('iMinPaginationSize', function() {
				return self["oGetPaginationElementscontainerRef"]()["clientWidth"] + self["oGetPrevButtonRef"]()["offsetWidth"] + self["oGetNextButtonRef"]()["offsetWidth"];
			});
		} else if (this["sNavigationPlacement"] === "PAGINATION" && this["sAlignment"] === "VERTICAL") {
			iMinPaginationSize = this["oCache"]["get"]('iMinPaginationSize', function() {
				return self["oGetPaginationElementscontainerRef"]()["clientHeight"]
					+ self["oGetPrevButtonRef"]()["offsetHeight"]
					+ self["iGetComputetMarginTop"](self["oPrevButton"]["oRootRef"])
					+ self["iGetComputetMarginBottom"](self["oPrevButton"]["oRootRef"])
					+ self["oGetNextButtonRef"]()["offsetHeight"]
					+ self["iGetComputetMarginTop"](self["oNextButton"]["oRootRef"])
					+ self["iGetComputetMarginBottom"](self["oNextButton"]["oRootRef"]);
			});
		}
	}
	return iMinPaginationSize;
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetMinPaginationSize"] = 0; };

/**
 * @private
 * @param {number} iTargetIndex
 * @param {boolean} [bImmediate]
 * @param {boolean} [bHomeOrEnd]
 */
UCF_Carousel["prototype"]["scrollTo"] = function(iTargetIndex, bImmediate, bHomeOrEnd) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["scrollTo"]++; }; 
	/** @type {UCF_Carousel_ItemInfo[]} */
	var aItems = this["aGetItems"]();

	this["_scrollTo"](
		aItems,
		Math["max"](0, Math["min"](iTargetIndex, aItems["length"] - 1)),
		bImmediate,
		bHomeOrEnd
	);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["scrollTo"] = 0; };

/**
 * @private
 * @param {UCF_Event} oEvent
 */
UCF_Carousel["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onScroll"]++; }; 
	var self = this;

	this["updateNavigation"]();
	this["onAfterScroll"]();
	this["fireScroll"](
		this["sId"],
		oEvent["oGetParam"]('iScrollTop'),
		// oEvent.oGetParam('iScrollLeft')
		UCF_DomUtil["iGetScrollLeft"](self["oGetScrollRef"]())
	);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onScroll"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Carousel["prototype"]["onAfterScroll"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterScroll"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterScroll"] = 0; };

/**
 * @protected
 */
UCF_Carousel["prototype"]["hideItemsBeforeFirstVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["hideItemsBeforeFirstVisible"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["hideItemsBeforeFirstVisible"] = 0; };


/**
 * @protected
 * @param {string} sId
 * @return {HTMLElement} the firstVisibleitem DOMElement
 */
UCF_Carousel["prototype"]["bIsItemId"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["bIsItemId"]++; }; 
	return UCF_StringUtil["bContains"](sId, this["sId"] + '__item-');
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["bIsItemId"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Carousel["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsfocus"]++; }; 
	this["onAfterCarouselFocus"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsfocus"] = 0; };

/** @protected */
UCF_Carousel["prototype"]["onAfterCarouselFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterCarouselFocus"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterCarouselFocus"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBlur
 */
UCF_Carousel["prototype"]["onlsblur"] = function(oBlur) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsblur"]++; }; 
	if (UCF_StringUtil["bStartsWith"](oBlur["oGetSource"]()["id"], this["oDomRef"]["id"])) {
		// _trace(INFO, '->showAllItems()');
		this["onAfterLsBlur"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsblur"] = 0; };

/** @protected */
UCF_Carousel["prototype"]["onAfterLsBlur"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterLsBlur"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterLsBlur"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Carousel["prototype"]["handlePointerDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["handlePointerDown"]++; }; 
	/** @type {number} */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iStartXCoordinate"] = oBrowserEvent["oDomEvent"]["x"];
	/** @type {number} */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iStartYCoordinate"] = oBrowserEvent["oDomEvent"]["y"];

	this["onAfterPointerDown"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["handlePointerDown"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Carousel["prototype"]["onAfterPointerDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterPointerDown"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterPointerDown"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Carousel["prototype"]["handlePointerUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["handlePointerUp"]++; }; 
	this["onAfterPointerUp"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["handlePointerUp"] = 0; };

UCF_Carousel["prototype"]["onAfterPointerUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterPointerUp"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterPointerUp"] = 0; };

/**
 * @private
 * @param {UCF_Event} oEvent
 */
UCF_Carousel["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onLayoutChange"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	if (!this["bIsDestroyed"]) {
		UCF_DomUtil["setStyle"](self["oDomRef"], 'height', self["sHeight"]);
		UCF_DomUtil["setStyle"](self["oDomRef"], 'width', self["sWidth"]);

		self["oCache"]["invalidate"]();
		self["initialize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onLayoutChange"] = 0; };

/** @return {number[]} */
UCF_Carousel["prototype"]["aGetItemOffsets"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["aGetItemOffsets"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('aItemOffsets', function() {
		/** @type {number[]} */
		var aItemOffsets = UCF_JsUtil["map"](
			self["aGetItems"](), self["sAlignment"] === 'HORIZONTAL'
			? function(oItem) { return oItem["iOffsetLeft"]; }
			// : function(oItem) { return oItem.iOffsetTop; }
			: function(oItem) { return oItem["iOffsetTop"]; }
		);

		// _trace(INFO, 'aItemOffsets == ' + UCF_JsUtil.sJsonStringify(aItemOffsets));

		return aItemOffsets;
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["aGetItemOffsets"] = 0; };

/** @return {HTMLDivElement} */
UCF_Carousel["prototype"]["oGetScrollRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetScrollRef"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('oScrollRef', function() {
		return UCF_DomUtil["$"](self["sId"] + '-scrl');
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetScrollRef"] = 0; };

/** @return {HTMLDivElement} */
UCF_Carousel["prototype"]["oGetContentRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetContentRef"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('oContentRef', function() {
		return UCF_DomUtil["$"](self["sId"] + '-cnt');
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetContentRef"] = 0; };

/** @return {HTMLDivElement} */
UCF_Carousel["prototype"]["oGetItemsRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetItemsRef"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('oItemsRef', function() {
		return UCF_DomUtil["$"](self["sId"] + '-items');
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetItemsRef"] = 0; };

/** @return {HTMLDivElement} */
UCF_Carousel["prototype"]["oGetPrevButtonContainerRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetPrevButtonContainerRef"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('oGetPrevButtonContainerRef', function() {
		return self["sNavigationPlacement"] === 'CONTENT' ? UCF_DomUtil["$"](self["sId"] + '-prev') : UCF_DomUtil["$"](self["sId"] + '-prevbutton');
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetPrevButtonContainerRef"] = 0; };

/** @return {HTMLDivElement} */
UCF_Carousel["prototype"]["oGetPrevButtonRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetPrevButtonRef"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('oPrevButtonRef', function() {
		return UCF_DomUtil["$"](self["sId"] + '-prevbutton');
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetPrevButtonRef"] = 0; };

/** @return {HTMLDivElement} */
UCF_Carousel["prototype"]["oGetNextButtonRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetNextButtonRef"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('oGetNextButtonRef', function() {
		return UCF_DomUtil["$"](self["sId"] + '-nextbutton');
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetNextButtonRef"] = 0; };

/** @return {HTMLDivElement} */
UCF_Carousel["prototype"]["oGetNextButtonContainerRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetNextButtonContainerRef"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('oGetNextButtonContainerRef', function() {
		return self["sNavigationPlacement"] === 'CONTENT' ?
			UCF_DomUtil["$"](self["sId"] + '-next') : UCF_DomUtil["$"](self["sId"] + '-nextbutton');
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetNextButtonContainerRef"] = 0; };

/**@private */
UCF_Carousel["prototype"]["alignNavigationButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["alignNavigationButtons"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	var sMarginUnit = this["sAlignment"] === 'HORIZONTAL'
		? 'margin-bottom'
		: UCF_DomUtil["bIsRTL"] ? 'margin-left' : 'margin-right';

	UCF_DomUtil["setStyle"](
		UCF_DomUtil["$"](self["sId"] + '-prev'),
		sMarginUnit,
		sMarginUnit === 'margin-bottom' && UCF_UserAgent["bIsIE"]() ? '0px' : UCF_DomUtil["iGetScrollbarWidth"]() + 'px'
	);
	UCF_DomUtil["setStyle"](
		UCF_DomUtil["$"](self["sId"] + '-next'),
		sMarginUnit,
		sMarginUnit === 'margin-bottom' && UCF_UserAgent["bIsIE"]() ? '0px' : UCF_DomUtil["iGetScrollbarWidth"]() + 'px'
	);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["alignNavigationButtons"] = 0; };

/**@return {UCF_Carousel_ItemInfo[]} */
UCF_Carousel["prototype"]["aGetItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["aGetItems"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('aItems', function() {
		return UCF_JsUtil["map"](
			UCF_JsUtil["arrayFrom"](UCF_DomUtil["querySelectorAll"]('tbody[id="' + self["sId"] + '-items"] > tr > td.lsCarousel__item')),
			function(oChildnode) {
				return {
					"oDomRef": oChildnode,
					"iOffsetLeft": oChildnode["offsetLeft"],
					"iOffsetTop": oChildnode["offsetTop"],
					"iOffsetHeight": oChildnode["offsetHeight"],
					"iOffsetWidth": oChildnode["offsetWidth"]
				};
			}
		);
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["aGetItems"] = 0; };

/**@private */
UCF_Carousel["prototype"]["updatePagination"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["updatePagination"]++; }; 
	/**@type {HTMLDivElement[]} */
	var aPaginationElements = this["aGetPaginationElements"]();
	/**@type {HTMLDivElement} */
	var oPaginationRef;

	if (aPaginationElements && aPaginationElements["length"] > 0) {
		UCF_JsUtil["forEach"](aPaginationElements, function(oRef) {
			UCF_DomUtil["removeClass"](oRef, 'lsCarousel__paginationelement--active');
		});
		UCF_DomUtil["addClass"](aPaginationElements[this["iFirstVisible"]], 'lsCarousel__paginationelement--active');
	} else {
		oPaginationRef = this["oGetPaginationElementscontainerRef"]();
		if (oPaginationRef) {
			oPaginationRef["textContent"] = this["oLS"]["sGetText"](
				'SAPUR_RI_VAL',
			[this["iFirstVisible"] + 1, this["aGetItems"]()["length"]]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["updatePagination"] = 0; };

/**@private */
UCF_Carousel["prototype"]["updateNavigation"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["updateNavigation"]++; }; 
	this["_updateNavigation"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["updateNavigation"] = 0; };

/** @protected */
UCF_Carousel["prototype"]["_updateNavigation"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["_updateNavigation"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, this["sClassName"] + ' did not override _updateNavigation(). Nothing will happen.', "Carousel.js(706): _updateNavigation"); };
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["_updateNavigation"] = 0; };

/**@protected */
UCF_Carousel["prototype"]["updateAriaAttributes"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["updateAriaAttributes"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	if (self["iLastSelectedItem"] !== -1 && self["iLastSelectedItem"] !== self["iFirstVisible"]) {
		UCF_AriaStateHelper["setHidden"](UCF_DomUtil["$"](self["sId"] + '__item-' + self["iLastSelectedItem"]), true);
		UCF_AriaStateHelper["setSelected"](UCF_DomUtil["$"](self["sId"] + '__item-' + self["iLastSelectedItem"]), false);
		UCF_DomUtil["resetTabIndex"](UCF_DomUtil["$"](self["sId"] + '__item-' + self["iLastSelectedItem"]));
	}

	UCF_AriaStateHelper["setHidden"](UCF_DomUtil["$"](self["sId"] + '__item-' + self["iFirstVisible"]), false);
	UCF_AriaStateHelper["setSelected"](UCF_DomUtil["$"](self["sId"] + '__item-' + self["iFirstVisible"]), true);
	UCF_DomUtil["setTabIndex"](UCF_DomUtil["$"](self["sId"] + '__item-' + self["iFirstVisible"]), 0);

	self["iLastSelectedItem"] = self["iFirstVisible"];
	UCF_AriaStateHelper["setActivedescendant"](self["oGetContentRef"](), self["sId"] + '__item-' + self["iFirstVisible"]);

};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["updateAriaAttributes"] = 0; };

/**
 * Writes the appropriate accessibility text into the tooltip
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Carousel["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(737): onlsaccessibility"); };

	// oAccessibilityHelper.setItemCount(this.aGetItems().length);
	oAccessibilityHelper["applyContainerEntryBehaviour"]();

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsaccessibility"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetScrollRefScrollHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetScrollRefScrollHeight"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('iScrollRefScrollHeight', function() {
		return self["oGetScrollRef"]()["scrollHeight"];
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetScrollRefScrollHeight"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetScrollRefScrollWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetScrollRefScrollWidth"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('iScrollRefScrollWidth', function() {
		return self["oGetScrollRef"]()["scrollWidth"];
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetScrollRefScrollWidth"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetScrollRefClientHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetScrollRefClientHeight"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('iScrollRefClientHeight', function() {
		return (self["sNavigationPlacement"] === 'CONTENT' && self["sAlignment"] === 'VERTICAL')
			? self["oDomRef"]["clientHeight"] - self["iGetButtonsSize"]()
			: self["oDomRef"]["clientHeight"];
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetScrollRefClientHeight"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetScrollRefClientWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetScrollRefClientWidth"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('iScrollRefClientWidth', function() {
		return (self["sNavigationPlacement"] === 'CONTENT' && self["sAlignment"] === 'HORIZONTAL')
			? self["oDomRef"]["clientWidth"] - self["iGetButtonsSize"]()
			: self["oDomRef"]["clientWidth"];
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetScrollRefClientWidth"] = 0; };

/**
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetPaddingLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPaddingLeft"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {HTMLElement}*/
	var oContentDomRef = UCF_DomUtil["$"](self["sId"] + '-cnt');

	/** @type {CSSStyleDeclaration} */
	var oComputedStyle = UCF_DomUtil["oGetComputedStyle"](oContentDomRef);

	return this["oCache"]["get"]('iPaddingLeft', function() {
		return parseInt(oComputedStyle["paddingLeft"], 10) || 0;
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPaddingLeft"] = 0; };

/**
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetPaddingTop"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPaddingTop"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {HTMLElement}*/
	var oContentDomRef = UCF_DomUtil["$"](self["sId"] + '-cnt');

	/** @type {CSSStyleDeclaration} */
	var oComputedStyle = UCF_DomUtil["oGetComputedStyle"](oContentDomRef);

	return this["oCache"]["get"]('iPaddingTop', function() {
		return parseInt(oComputedStyle["paddingTop"], 10) || 0;
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPaddingTop"] = 0; };

/**
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetPaddingRight"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPaddingRight"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {HTMLElement}*/
	var oContentDomRef = UCF_DomUtil["$"](self["sId"] + '-cnt');

	/** @type {CSSStyleDeclaration} */
	var oComputedStyle = UCF_DomUtil["oGetComputedStyle"](oContentDomRef);

	return this["oCache"]["get"]('iPaddingRight', function() {
		return parseInt(oComputedStyle["paddingRight"], 10) || 0;
	});

};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPaddingRight"] = 0; };

/**
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetPaddingBottom"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPaddingBottom"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {HTMLElement}*/
	var oContentDomRef = UCF_DomUtil["$"](self["sId"] + '-cnt');

	/** @type {CSSStyleDeclaration} */
	var oComputedStyle = UCF_DomUtil["oGetComputedStyle"](oContentDomRef);

	return this["oCache"]["get"]('iPaddingBottom', function() {
		return parseInt(oComputedStyle["paddingBottom"], 10) || 0;
	});

};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPaddingBottom"] = 0; };

/**@param {boolean} enabled */
UCF_Carousel["prototype"]["enablePrevButton"] = function(enabled) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["enablePrevButton"]++; }; 
	if (this["oPrevButton"]) {
		this["oPrevButton"]["setEnabled"](enabled);
		if (this["sNavigationPlacement"] === 'CONTENT')
			UCF_DomUtil["setTabIndex"](this["oPrevButton"]["oDomRef"], -1);
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["enablePrevButton"] = 0; };

/** @param {boolean} enabled */
UCF_Carousel["prototype"]["enableNextButton"] = function(enabled) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["enableNextButton"]++; }; 
	if (this["oNextButton"]) {
		this["oNextButton"]["setEnabled"](enabled);
		if (this["sNavigationPlacement"] === 'CONTENT')
			UCF_DomUtil["setTabIndex"](this["oNextButton"]["oDomRef"], -1);
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["enableNextButton"] = 0; };

/**@return {HTMLDivElement[]} */
UCF_Carousel["prototype"]["aGetPaginationElements"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["aGetPaginationElements"]++; }; 
	/**@type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('aPaginationElements', function() {
		/**@type {HTMLDivElement} */
		var oPaginationRef = self["oGetPaginationElementscontainerRef"]();

		return oPaginationRef
			? UCF_JsUtil["filter"](UCF_JsUtil["arrayFrom"](UCF_DomUtil["childNodes"](oPaginationRef)), function(oRef) {
				return UCF_DomUtil["bHasClass"](oRef, 'lsCarousel__paginationelement');
			})
			: [];
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["aGetPaginationElements"] = 0; };

/** @return {HTMLDivElement} */
UCF_Carousel["prototype"]["oGetPaginationcontainerRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetPaginationcontainerRef"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('oPaginationcontainerRef', function() {
		return UCF_DomUtil["$"](self["sId"] + '-paginationcontainer');
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetPaginationcontainerRef"] = 0; };

/** @return {HTMLDivElement} */
UCF_Carousel["prototype"]["oGetPaginationElementscontainerRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetPaginationElementscontainerRef"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('oPaginationElementscontainerRef', function() {
		return UCF_DomUtil["$"](self["sId"] + '-paginationelementscontainer');
	});
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetPaginationElementscontainerRef"] = 0; };

/**
 * @param {UCF_Event} oEvent
 */
UCF_Carousel["prototype"]["onPrevPress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onPrevPress"]++; }; 
	if (oEvent) {
		oEvent["mParameters"]["CancelEvent"] = true;
	}

	this["scrollTo"](this["iGetPrevIndex"]());
	this["onAfterNavigationButton"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onPrevPress"] = 0; };

/**
 * @param {UCF_Event} oEvent
 */
UCF_Carousel["prototype"]["onPrevPagePress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onPrevPagePress"]++; }; 
	if (oEvent) {
		oEvent["mParameters"]["CancelEvent"] = true;
	}
	this["scrollTo"](this["iGetPrevPageIndex"]());
	this["onAfterKeyboardNavigation"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onPrevPagePress"] = 0; };

/** @protected */
UCF_Carousel["prototype"]["iGetPrevIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPrevIndex"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPrevIndex"] = 0; };

/** @protected */
UCF_Carousel["prototype"]["iGetPrevPageIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPrevPageIndex"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetPrevPageIndex"] = 0; };

/**
 * @param {UCF_Event} oEvent
 */
UCF_Carousel["prototype"]["onNextPress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onNextPress"]++; }; 
	if (oEvent) {
		oEvent["mParameters"]["CancelEvent"] = true;
	}

	this["scrollTo"](this["iGetNextIndex"]());
	this["onAfterNavigationButton"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onNextPress"] = 0; };

/**
 * @param {UCF_Event} oEvent
 */
UCF_Carousel["prototype"]["onNextPagePress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onNextPagePress"]++; }; 
	if (oEvent) {
		oEvent["mParameters"]["CancelEvent"] = true;
	}
	this["scrollTo"](this["iGetNextPageIndex"]());
	this["onAfterKeyboardNavigation"]();

};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onNextPagePress"] = 0; };

/** @protected */
UCF_Carousel["prototype"]["iGetNextIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetNextIndex"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetNextIndex"] = 0; };

/** @protected */
UCF_Carousel["prototype"]["iGetNextPageIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetNextPageIndex"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetNextPageIndex"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Carousel["prototype"]["onAfterClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterClick"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterClick"] = 0; };

/** @param {UCF_BrowserEvent} oBrowserEvent */
UCF_Carousel["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onclick"]++; }; 
	/**@type {HTMLElement} */
	var oSrcRef = oBrowserEvent["oGetSource"]();
	/**@type {number} */
	var iIndex;

	if (UCF_DomUtil["bHasClass"](oSrcRef, 'lsCarousel__paginationelement')) {
		// this doesn't work anymore because the bubles have pointer-events:none
		iIndex = parseInt(UCF_DomUtil["dataset"](oSrcRef)["index"]);
		this["scrollTo"](iIndex);
	}

	this["onAfterClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onclick"] = 0; };

/**
 * Avoid scroll down on the Page
 * @param {UCF_BrowserEvent} oBrowserEvent
 *
 **/
UCF_Carousel["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsspace"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsspace"] = 0; };

/** @return {HTMLDivElement} */
UCF_Carousel["prototype"]["oGetActiveItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetActiveItem"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + '__item-' + this["iFirstVisible"]);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["oGetActiveItem"] = 0; };

/**
 * Handle F7 key to toogle between the Carousel and the active item
 * @param {UCF_BrowserEvent} oBrowserEvent
 *
 **/
UCF_Carousel["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1042): onkeydown"); };
	if (UCF_KeyboardHelper["bHasKeyWithoutModifiers"](oBrowserEvent, UCF_KeyCodes["F7"])) {
		if (UCF_DomUtil["oGetActiveElement"]() === this["oGetActiveItem"]()) {
			var oParentDomRef = this["aGetItems"]()[this["iFirstVisible"]]["oDomRef"];
			var oNextFocusedDomRef = oParentDomRef ? UCF_DomUtil["oGetTabbableElementForward"](oParentDomRef["firstChild"], true) || oParentDomRef : this["oDomRef"];
			UCF_DomUtil["focusDomElement"](oNextFocusedDomRef);
		} else {
			UCF_DomUtil["focusDomElement"](this["oGetActiveItem"]());
		}
		oBrowserEvent["oDomEvent"]["preventDefault"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onkeydown"] = 0; };

/**
 * @private
 * @param {UCF_Carousel_ScrollConfiguration} oConf
 */
UCF_Carousel["prototype"]["animateScroll"] = function(oConf) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["animateScroll"]++; }; 
	/** @type {UCF_Carousel_ScrollConfiguration} */
	var oConfiguration = UCF_JsUtil["extend"]({
		"bImmediate": false,
		"iCurrentIndex": 0,
		"iFutureIndex": 1,
		"fDone": function() {}
	}, oConf);
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {string} */
	var sAnimateProperty = this["sAlignment"] === 'HORIZONTAL' ? 'scrollLeft' : 'scrollTop';
	/** @type {number} */
	var iStartMs = performance["now"]();
	/** @type {number} */
	var iStartPx = this["oGetScrollRef"]()[sAnimateProperty];
	/** @type {number} */
	var iScrollDistance = oConfiguration["iEndPx"] - iStartPx;
	/** @type {boolean} */
	var bShouldAnimate = !oConfiguration["bImmediate"] && window["UCF_System"]["bUseAnimation"];

	/** */
	function animate() {
		/** @type {number} */
		var iNowMs = performance["now"]();
		/** @type {number} */
		var iStep = (iNowMs - iStartMs) / UCF_Carousel["ANIMATION_DURATION_MS"];

		if (iNowMs - iStartMs < UCF_Carousel["ANIMATION_DURATION_MS"]) {
			// _trace(INFO, 'inside animation and scrollDistance: ' + iScrollDistance * iStep);
			self["oGetScrollRef"]()[sAnimateProperty] = iStartPx + iScrollDistance * iStep;

			self["onAfterAnimationStep"](oConfiguration, iStep);

			UCF_JsUtil["requestAnimationFrame"](animate);
		} else {
			self["oGetScrollRef"]()[sAnimateProperty] = oConfiguration["iEndPx"];
			oConfiguration["fDone"]();
		}
	}

	if (bShouldAnimate) {
		UCF_JsUtil["requestAnimationFrame"](animate);
	} else {
		self["oGetScrollRef"]()[sAnimateProperty] = oConfiguration["iEndPx"];
		oConfiguration["fDone"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["animateScroll"] = 0; };

/**
 * @protected
 * @param {UCF_Carousel_ScrollConfiguration} oConfiguration
 * @param {number} iStep
 */
UCF_Carousel["prototype"]["onAfterAnimationStep"] = function(oConfiguration, iStep) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterAnimationStep"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterAnimationStep"] = 0; };

/**
 * @private
 * @param {UCF_Carousel_ItemInfo} aItems
 * @param {number} iIndex
 * @param {boolean} [bImmediate]
 * @param {boolean} [bHomeOrEnd]
 */
UCF_Carousel["prototype"]["_scrollTo"] = function(aItems, iIndex, bImmediate, bHomeOrEnd) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["_scrollTo"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["_scrollTo"] = 0; };

/**
 * @private
 * @param {number} iIndex
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetOffsetRight"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetOffsetRight"]++; }; 
	/** @type {number} */
	var iOffsetRight = 0;
	/** @type {number} */
	var i;

	for (i = 0; i < iIndex; i++) {
		iOffsetRight += this["aGetItems"]()[i]["iOffsetWidth"];
	}

	// _trace(INFO, 'iOffsetRight == ' + iOffsetRight);

	return iOffsetRight;
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetOffsetRight"] = 0; };

/** @private */
UCF_Carousel["prototype"]["showAllItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["showAllItems"]++; }; 
	/** @type {number} */
	var index = 0;
	/** @type {UCF_Carousel_ItemInfo[]} */
	var items = this["aGetItems"]();

	// _trace(INFO, 'iFirstVisible == ' + this.iFirstVisible);

	for (index; index < items["length"]; index++) {
		UCF_DomUtil["setStyle"](items[index]["oDomRef"], { "visibility": 'visible' });
	};
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["showAllItems"] = 0; };

/**
 * @param { number } iFirstItemPosition
 * @return {number}
 */
UCF_Carousel["prototype"]["iGetFullVisibleItemsCount"] = function(iFirstItemPosition) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetFullVisibleItemsCount"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {UCF_Carousel_ItemInfo[]} */
	var aItems = this["aGetItems"]();
	/** @type {number} */
	var iVisibleItemsCount;
	/** @type {number} */
	var iVisibleItemsLength = 0;
	/** @type {number} */
	var iIndex = 0;
	/** @type {number} */
	var iItem = iFirstItemPosition;

	if (this["sAlignment"] === 'HORIZONTAL') {
		for (iIndex; iVisibleItemsLength < self["iGetScrollRefClientWidth"]() && iItem < aItems["length"]; iIndex++) {
			iVisibleItemsLength += aItems[iItem]["iOffsetWidth"];
			iItem++;
			iVisibleItemsCount = iIndex;
		}
	} else {
		for (iIndex; iVisibleItemsLength < self["iGetScrollRefClientHeight"]() && iItem < aItems["length"]; iIndex++) {
			iVisibleItemsLength += aItems[iItem]["iOffsetHeight"];
			iItem++;
			iVisibleItemsCount = iIndex;
		}
	}

	return iVisibleItemsCount;
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["iGetFullVisibleItemsCount"] = 0; };

/**
 * Handles the next key
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsnext
 */
UCF_Carousel["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsright"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1206): onlsright"); };

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	this["scrollTo"](this["iGetNextIndex"]());
	this["onAfterKeyboardNavigation"]();

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsright"] = 0; };

/**
 * Handles the next key
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsnext
 */
UCF_Carousel["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsdown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1225): onlsdown"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	this["scrollTo"](this["iGetNextIndex"]());
	this["onAfterKeyboardNavigation"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsdown"] = 0; };

/**
 * Handles the PLUS key
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsnext
 */
UCF_Carousel["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsexpand"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1243): onlsexpand"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	this["scrollTo"](this["iGetNextIndex"]());
	this["onAfterKeyboardNavigation"]();

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsexpand"] = 0; };

/**
 * Handles the previous key
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsprevious
 */
UCF_Carousel["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsleft"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1261): onlsleft"); };

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	this["scrollTo"](this["iGetPrevIndex"]());
	this["onAfterKeyboardNavigation"]();

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsleft"] = 0; };

/**
 * Handles the previous key
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsprevious
 */
UCF_Carousel["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1280): onlsup"); };

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	this["scrollTo"](this["iGetPrevIndex"]());
	this["onAfterKeyboardNavigation"]();

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsup"] = 0; };

/**
 * Handles the MINUS key
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsprevious
 */
UCF_Carousel["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlscollapse"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1299): onlscollapse"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	this["scrollTo"](this["iGetPrevIndex"]());
	this["onAfterKeyboardNavigation"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlscollapse"] = 0; };

/**
 * @private CTRL + ARROW_DONW -> Next Page
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdownmodifier
 */
UCF_Carousel["prototype"]["onlsdownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsdownmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1314): onlsdownmodifier"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	if (UCF_KeyboardHelper["bHasOnlyCtrlAsModifier"](oBrowserEvent)) {
		this["onNextPagePress"]();

		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsdownmodifier"] = 0; };

/**
 * @private CTRL + ARROW_RIGHT -> Next Page
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdownmodifier
 */
UCF_Carousel["prototype"]["onlsrightmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsrightmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1331): onlsrightmodifier"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	if (UCF_KeyboardHelper["bHasOnlyCtrlAsModifier"](oBrowserEvent)) {
		this["onNextPagePress"]();

		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsrightmodifier"] = 0; };

/**
 * @private PAGEDOWN -> Next Page
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdownmodifier
 */
UCF_Carousel["prototype"]["onlspagedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlspagedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1348): onlspagedown"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	this["onNextPagePress"]();

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlspagedown"] = 0; };

/**
 * @private CTRL + ARROW_LEFT -> Previous Page
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdownmodifier
 */
UCF_Carousel["prototype"]["onlsleftmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsleftmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1364): onlsleftmodifier"); };

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	if (UCF_KeyboardHelper["bHasOnlyCtrlAsModifier"](oBrowserEvent)) {
		this["onPrevPagePress"]();

		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsleftmodifier"] = 0; };

/**
 * @private CTRL + ARROW_UP - > Previous Page
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdownmodifier
 */
UCF_Carousel["prototype"]["onlsupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsupmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1382): onlsupmodifier"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	if (UCF_KeyboardHelper["bHasOnlyCtrlAsModifier"](oBrowserEvent)) {
		this["onPrevPagePress"]();

		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsupmodifier"] = 0; };

/**
 * @private PAGEUP - > Previous Page
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdownmodifier
 */
UCF_Carousel["prototype"]["onlspageup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlspageup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1399): onlspageup"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	this["onPrevPagePress"]();

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlspageup"] = 0; };

/**
 * Handles the tabprevious
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsprevious
 */
UCF_Carousel["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlstabprevious"]++; }; 
	this["onAfterTabPrevious"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlstabprevious"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Carousel["prototype"]["onAfterTabPrevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterTabPrevious"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterTabPrevious"] = 0; };

/**
 * Handles the tabnext
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsprevious
 */
UCF_Carousel["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlstabnext"]++; }; 
	this["onAfterTabNext"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlstabnext"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Carousel["prototype"]["onAfterTabNext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterTabNext"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterTabNext"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Carousel["prototype"]["onAfterKeyboardNavigation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterKeyboardNavigation"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterKeyboardNavigation"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Carousel["prototype"]["onAfterNavigationButton"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterNavigationButton"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterNavigationButton"] = 0; };

/**
 * Handles the end key
 *
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the lsend
 */
UCF_Carousel["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1469): onlsend"); };

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;
	this["scrollTo"](this["aGetItems"]()["length"] - 1, false, true);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsend"] = 0; };

/**
 * Handles the home key
 *
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the lshome
 */
UCF_Carousel["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlshome"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Carousel.js(1486): onlshome"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && !this["bIsItemId"](oSource["id"])) return;

	this["scrollTo"](0, false, true);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlshome"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Carousel["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Carousel["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onlsskipback"] = 0; };

/**
 * Handle mousewheel action
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Carousel["prototype"]["onmousewheel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onmousewheel"]++; }; 
	this["onAfterMousewheel"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onmousewheel"] = 0; };

/**
 * Handle mousewheel action for Firefox
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Carousel["prototype"]["onDOMMouseScroll"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onDOMMouseScroll"]++; }; 
	this["onAfterMousewheel"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onDOMMouseScroll"] = 0; };

/**
 * @protected
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Carousel["prototype"]["onAfterMousewheel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterMousewheel"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onAfterMousewheel"] = 0; };

/** @private */
UCF_Carousel["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["destroy"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oWindow = this["oLS"]["oBrowserWindow"];
	this["onBeforeDestroy"]();

	oWindow["detachEvent"](oWindow["LayoutChange"], this);
	UCF_DomUtil["detachEvent"](this["oDomRef"], 'pointerdown', this["onPointerDown"]);
	UCF_DomUtil["detachEvent"](this["oDomRef"], 'pointerup', this["onPointerUp"]);
	// UCF_DomUtil.detachEvent(this.oGetScrollRef(), 'pointermove', this.onPointerMove);
	UCF_JsUtil["clearIntervalCall"](this["sUpdateInterval"]);

	//this.oLS.oBrowserWindow.detachEvent('onLayoutChange');

	this["oCache"]["destroy"]();
	this["oCache"] = null;
	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}
	this["oPrevButton"] = null;
	this["oNextButton"] = null;
	this["onPointerDown"] = null;
	this["onPointerUp"] = null;
	this["iLastSelectedItem"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["destroy"] = 0; };

/** @protected */
UCF_Carousel["prototype"]["onBeforeDestroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onBeforeDestroy"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["onBeforeDestroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Carousel["prototype"]["aAttributeNames"] = ["sVisibility","sTooltip","sWidth","sHeight","iScrollLeft","iScrollTop","sNavigationPlacement","sPagination","iFirstVisible","sAlignment","sDisplayItems"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Carousel["prototype"]["aEventNames"] = ["Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Carousel["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Carousel["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_Carousel["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Carousel["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Carousel["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {number}
 */
UCF_Carousel["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_Carousel["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CarouselNavigationPlacement}
 */
UCF_Carousel["prototype"]["sNavigationPlacement"] = "CONTENT";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CarouselPagination}
 */
UCF_Carousel["prototype"]["sPagination"] = "ADAPT_TO_ITEMS";

/**
 * @private
 * @type {number}
 */
UCF_Carousel["prototype"]["iFirstVisible"] = 0;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CarouselAlignment}
 */
UCF_Carousel["prototype"]["sAlignment"] = "HORIZONTAL";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CarouselDisplayItems}
 */
UCF_Carousel["prototype"]["sDisplayItems"] = "MULTIPLE";

//#JSCOVER_EXCL_START
/** @protected */
UCF_Carousel["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sWidth"] = '';
	this["sHeight"] = '';
	this["iScrollLeft"] = 0;
	this["iScrollTop"] = 0;
	this["sNavigationPlacement"] = "CONTENT";
	this["sPagination"] = "ADAPT_TO_ITEMS";
	this["iFirstVisible"] = 0;
	this["sAlignment"] = "HORIZONTAL";
	this["sDisplayItems"] = "MULTIPLE";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("NavigationPlacement", "CONTENT", true);
		this["setClientProperty"]("Pagination", "ADAPT_TO_ITEMS", true);
		this["setClientProperty"]("FirstVisible", 0, true);
		this["setClientProperty"]("Alignment", "HORIZONTAL", true);
		this["setClientProperty"]("DisplayItems", "MULTIPLE", true);
	}
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires Carousel::Scroll
 */
UCF_Carousel["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Carousel.js(1706): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Carousel.js(1707): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Carousel.js(1708): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "Carousel.js(1709): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "Carousel.js(1710): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "Carousel.js(1711): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "Carousel.js(1712): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("Carousel", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Carousel["_"]["fireScroll"] = 0; };

};
sap["ls"]["preload"]["UCF_Chart"] = function() {/* global _assert, _trace, INFO, WARNING, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_PlaceHolder */
/// <reference path="./base/PlaceHolder.js"/>
/* global sap */

/**
 * Class for the Chart control
 *
 * Please ensure to load the necessary script files as the actual source is not known this
 * cannot be done by the controls, but needs to be done centrally in the page control using HeadScripts aggregation.
 *
 * Sample:
 * script src="http://shg-cvom-build3.dhcp.pgdev.sap.corp:8080/job/html5_viz_trunkdev_build/lastSuccessfulBuild/artifact/bin/cvom.riv.html5.viz/libs/jquery.js"
 * script src="http://shg-cvom-build3.dhcp.pgdev.sap.corp:8080/job/html5_viz_trunkdev_build/lastSuccessfulBuild/artifact/bin/cvom.riv.html5.viz/libs/d3.v2.js"
 * script src="http://shg-cvom-build3.dhcp.pgdev.sap.corp:8080/job/html5_viz_trunkdev_build/lastSuccessfulBuild/artifact/bin/cvom.riv.html5.viz/libs/sap.common.globalization.js"
 * script src="http://shg-cvom-build3.dhcp.pgdev.sap.corp:8080/job/html5_viz_trunkdev_build/lastSuccessfulBuild/artifact/bin/cvom.riv.html5.viz/libs/sap.viz.js"
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Chart(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Chart["_"]["UCF_Chart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Chart.js(41): UCF_Chart"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Chart.js(42): UCF_Chart"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Chart.js(43): UCF_Chart"); };

	UCF_PlaceHolder["apply"](this, [oDomRef, oLS]);

	this["oChartInstance"] = null;
	this["oData"] = {};
	this["oDataFeeding"] = null;
	this["oOptions"] = {};
	this["oDataSet"] = null;
	this["oSelection"] = null;

	this["_sType"] = ''; // For caching and compare
	this["_sDataString"] = ''; // For caching and compare
	this["_sDataFeedingString"] = ''; // For caching and compare
	this["_sOptionsString"] = ''; // For caching and compare
	this["_sSelectionString"] = ''; // For caching and compare

	this["bSuppressSelectionEvent"] = false; // If we set a selection via chart API, we do not fire a selection event. This is done only if the user clicks
	this["hasAnySelection"] = false; // Workaround to fire deselect events on resize for older CVOM versions.

	this["attachBrowserEvent"]("resize", this["oRootRef"]);
};window["UCF_Chart"] = UCF_Chart; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Chart"); UCF_Chart["_"] = {UCF_Chart: 0}; }; ;
UCF_Chart["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PlaceHolder"))(); UCF_Chart.prototype["sClassName"] = "UCF_Chart";

/**
 * Initializes the chart control
 *
 * @private
 */

UCF_Chart["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["initialize"]++; }; 
	UCF_PlaceHolder.prototype["initialize"]["apply"](this, arguments);
	if (__UCF_IE6__) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Charts are supported in standards mode only", "Chart.js(76): initialize"); };
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](this["oRootRef"],
			this["oLS"]["sGetText"]("SAPUR_HTML5_CONTROL_ERROR", ["<a target=\"_blank\" href=\"https://service.sap.com/sap/support/notes/1970689\">Note 1970689</a>", "Charts"]));
		return;
	}
	this["oRootRef"]["className"] = "lsBusyIndicator urLoadImg";
	this["oRootRef"]["style"]["backgroundPosition"] = "center center";
	this["oRootRef"]["style"]["backgroundRepeat"] = "no-repeat";
	this["loadScripts"]();
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["initialize"] = 0; };

/**
 * Loads the scripts and erases the carrying with the informations of the scripts
 */
UCF_Chart["prototype"]["loadScripts"] = function() {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["loadScripts"]++; }; 
	/** @type {HTMLDivElement} */
	var oScriptRef = UCF_DomUtil["$"](this["sId"] + "-scripts");
	/** @type {UCF_Page} */
	var oPage;
	/** @type {string} */
	var sScriptJSON;
	/** @type {{src: string, content: string, customAttributes: Array}[]} */
	var aScriptsJSON;
	/** @type {number} */
	var i;
	/** @type {{src: string, content: string, customAttributes: Array}} */
	var oScript;

	if (oScriptRef) {
		oPage = this["oLS"]["oGetPageInternal"]();

		if (oPage) {
			if (!window["less"]) {
				oPage["addScript"](UCF_ResourceUtil["sGetJsRoot"]() + '/common/lib/less.js');
			}

			sScriptJSON = UCF_DomUtil["sGetInnerText"](oScriptRef);

			if (sScriptJSON) {
				try {
					aScriptsJSON = UCF_JsUtil["oJsonParse"](sScriptJSON);

					// eslint-disable-next-line max-depth
					if (aScriptsJSON && aScriptsJSON["length"] > 0) {
						// eslint-disable-next-line max-depth
						for (i = 0; i < aScriptsJSON["length"]; i++) {
							oScript = aScriptsJSON[i];

							oPage["addScript"](
								oScript["src"],
								oScript["content"],
								oScript["customAttributes"],
								i === aScriptsJSON["length"] - 1 ? this : null,
								i === aScriptsJSON["length"] - 1 ? 'onAfterScriptLoad' : null,
								null,
								// Workaround for jquery which may be already loaded by sap.ui.core
								// and contain 'plugins' in the jQuery.sap namespace: by loading
								// jquery again we would overwrite the existing object.
								oScript["src"]["indexOf"]('/jquery') > -1
								? function() {
									return typeof window["jQuery"] === 'undefined'
										|| window["jQuery"] == null;
								}
								: null
							);
						}
					}
				} catch (ex) {
					if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Failed to read scripts for Chart ' + this["sId"], "Chart.js(145): loadScripts"); };
					this["onAfterScriptLoad"]();
				}
			}
		}

	} else {
		this["onAfterScriptLoad"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["loadScripts"] = 0; };

UCF_Chart["prototype"]["onAfterScriptLoad"] = function() {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["onAfterScriptLoad"]++; }; 
	if (typeof sap === "undefined") {
		//IE10 is sometimes too fast: After loading the script, the callback is called. Unfortunately, the script isn't parsed yet and therefore we still have to wait...
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "waiting for sap...", "Chart.js(159): onAfterScriptLoad"); };
		UCF_JsUtil["delayedCall"](10, this, "onAfterScriptLoad");
		return;
	}
	this["oRootRef"]["className"] = "";
	this["oRootRef"]["style"]["backgroundPosition"] = "";
	var oScriptRef = UCF_DomUtil["$"](this["sId"] + "-scripts");
	if (oScriptRef) {
		oScriptRef["parentNode"]["removeChild"](oScriptRef);
	}

	var bCreateNew = false;

	// Apply new values
	this["applyPlaceholderChanges"]();

	// To prevent re-rendering each roundtrip, we cache type and compare
	if (this["_sType"] != this["sType"]) {
		this["_sType"] = this["sType"];
		bCreateNew = true;
	}

	// To prevent re-rendering each roundtrip, we cache data and compare
	if (this["_sDataString"] != this["sDataString"]) {
		this["_sDataString"] = this["sDataString"];
		try {
			this["oData"] = UCF_JsUtil["oJsonParse"](this["_sDataString"]);
		} catch (ex) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Chart data could not be initialized", "Chart.js(187): onAfterScriptLoad"); };
			return;
		}

		if (this["oData"]) {
			this["oDataSet"] = new sap["viz"]["data"]["CrosstableDataset"]();
			this["oDataSet"]["setData"](this["oData"]);
		} else {
			this["oDataSet"] = null;
		}
		bCreateNew = true;
	}

	// To prevent re-rendering each roundtrip, we cache options and compare as well
	if (this["_sOptionsString"] != this["sOptionsString"]) {
		this["_sOptionsString"] = this["sOptionsString"];
		try {
			this["oOptions"] = UCF_JsUtil["oJsonParse"](this["_sOptionsString"]);
		} catch (ex) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Chart options could not be initialized", "Chart.js(206): onAfterScriptLoad"); };
			return;
		}
		bCreateNew = true;
	}

	// To prevent re-rendering each roundtrip, we cache options and compare as well
	if (this["_sDataFeedingString"] != this["sDataFeedingString"]) {
		this["_sDataFeedingString"] = this["sDataFeedingString"];
		try {
			this["oDataFeeding"] = UCF_JsUtil["oJsonParse"](this["_sDataFeedingString"]);
		} catch (ex) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Chart feeding could not be initialized", "Chart.js(218): onAfterScriptLoad"); };
			return;
		}
		bCreateNew = true;
	}

	// To prevent re-rendering each roundtrip, we cache selection and compare as well
	if (this["_sSelectionString"] != this["sSelectionString"]) {
		this["_sSelectionString"] = this["sSelectionString"];
		try {
			this["oSelection"] = UCF_JsUtil["oJsonParse"](this["_sSelectionString"]);
			if (this["oChartInstance"]) {
				// If we have already a chart instance, apply selection now. If not, the selection is set
				// via event handler in createChartInstance( )
				this["setChartSelection"]();
			}
		} catch (ex) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Chart selection could not be initialized", "Chart.js(235): onAfterScriptLoad"); };
			return;
		}
	}

	// Path to resources is set fixed to ../../../resources/langs/ which does not work currently in our case
	/*
		try {
			if(sap.viz.env) {
				sap.viz.env.initialize({
					locale: UCF_System.sLanguage
				});
			};
		} catch(ex) {
			_trace(WARNING,"Could not initialize locale setting for chart " + this.sId);
		}
	*/

	if (bCreateNew) {
		this["createChartInstance"]();
	} else {
		this["applySize"](); // Needs to be done for some cases where the resize event is not fired.
	}

};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["onAfterScriptLoad"] = 0; };

/**
 * Creates a internal cvom chart instance and attaches the events
 */
UCF_Chart["prototype"]["createChartInstance"] = function() {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["createChartInstance"]++; }; 
	if (this["oChartInstance"]) {
		// Destroy existing chart
		this["oChartInstance"]["destroy"]();
		this["oChartInstance"] = null; // Calling two times destroy() on chart instance leads to error in viz library. Therefore set it to null.
	}
	if (!this["sType"] || !this["oDataSet"]) {
		return;
	}

	this["oChartInstance"] = sap["viz"]["core"]["createViz"]({
		"type": this["sType"],
		"data": this["oDataSet"],
		"container": this["oDomRef"],
		"options": this["oOptions"],
		"dataFeeding": this["oDataFeeding"]
	});
	var that = this;
	this["_handleChartEvent"] = function(oChartEvent) {
		that["handleChartEvent"](oChartEvent);
	};
	this["oChartInstance"]["on"]("selectData", this["_handleChartEvent"]);
	this["oChartInstance"]["on"]("deselectData", this["_handleChartEvent"]);

	if (this["oSelection"]) {
		this["oChartInstance"]["on"]("initialized", function() {
			that["setChartSelection"]();
			// We need to set the selection only one time after data initialization.
			// As this would be called each time the chart gets resized, we unregister this handler.
			// Unregister is not provided by the API, do we use a workaround (empty function)
			that["oChartInstance"]["on"]("initialized", function() {});
		});
	}

	this["applySize"]();
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["createChartInstance"] = 0; };

/**
 * Handles event from the chart instance *
 * @private
 */
UCF_Chart["prototype"]["handleChartEvent"] = function(oChartEvent) {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["handleChartEvent"]++; }; 
	var sDataString = "",
		sSelectionString = "";

	if (oChartEvent["data"] && oChartEvent["data"]["length"] > 0) {
		for (var i = 0; i < oChartEvent["data"]["length"]; i++) {
			delete oChartEvent["data"][i]["target"];
		}
		sDataString = UCF_JsUtil["sJsonStringify"](oChartEvent);
	}
	if (this["oChartInstance"] && this["oChartInstance"]["selection"]) {
		this["oSelection"] = this["oChartInstance"]["selection"]();
		if (this["bSuppressSelectionEvent"]) {
			// This is the case if we set the selection via API and not via user interaction
			return;
		}
		sSelectionString = UCF_JsUtil["sJsonStringify"](this["oSelection"]);
	}

	//do some semantic event mapping for data to be sent
	if (oChartEvent["name"] === "selectData") {
		delete oChartEvent["name"];
		this["fireSelectData"](this["sId"], sDataString, sSelectionString);
		if (this["oChartInstance"] && !this["oChartInstance"]["selection"]) {
			// Workaround to fire deselect events on resize.
			// Is fixed by sap.viz, however for older releases that do not support select, apply the fallback
			this["hasAnySelection"] = true;
		}
	} else if (oChartEvent["name"] === "deselectData") {
		delete oChartEvent["name"];
		this["fireDeselectData"](this["sId"], sDataString, sSelectionString);
	}
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["handleChartEvent"] = 0; };

/**
 * Applies the new size after a resize of the div
 *
 * @private
 */
UCF_Chart["prototype"]["applySize"] = function() {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["applySize"]++; }; 
	if (this["oChartInstance"] && this["oRootRef"]) {
		this["oChartInstance"]["size"]({
			"width": this["oRootRef"]["offsetWidth"],
			"height": this["oRootRef"]["offsetHeight"]
		});
		// Workaround as chart resets selection when doing resize. Remove after this is implemented by VIZ
		if (this["hasAnySelection"]) {
			this["hasAnySelection"] = false;
			this["fireDeselectData"](this["sId"], '');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["applySize"] = 0; };

/**
 * Handler for the resize event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 *
 * @private
 */
UCF_Chart["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["onresize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Chart.js(366): onresize"); };
	UCF_PlaceHolder.prototype["onresize"]["apply"](this, arguments);
	this["applySize"]();
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["onresize"] = 0; };

/**
 * Sets the type of the chart
 *
 * @param {String} sType the type of the chart
 *
 * @public
 */
UCF_Chart["prototype"]["setType"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["setType"]++; }; 
	this["sType"] = sType;
	this["setClientProperty"]("Type", sType, true);
	// this.oChartInstance.destroy();
	this["createChartInstance"]();
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["setType"] = 0; };

/**
 * Sets new selection for the chart
 *
 * @public
 */
UCF_Chart["prototype"]["setChartSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["setChartSelection"]++; }; 
	if (!this["oChartInstance"] || !this["oSelection"]) return; // Nothing to select
	if (this["oChartInstance"]["selection"]) { // Supported in newer versions of sap.viz only
		this["bSuppressSelectionEvent"] = true; // Do not fire an event if we set it via API
		this["oChartInstance"]["selection"](this["oSelection"], { "clearSelection": true });
		this["bSuppressSelectionEvent"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["setChartSelection"] = 0; };

/**
 * Sets new json data for the chart
 * @param {Object} oData the new json data for the chart
 *
 * @public
 */
UCF_Chart["prototype"]["setData"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["setData"]++; }; 
	this["oData"] = oData;
	this["oChartInstance"]["data"](this["oData"]);
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["setData"] = 0; };

/**
 * Destroys the control and the chart instance
 *
 * @private
 */
UCF_Chart["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["destroy"]++; }; 
	if (this["oRootRef"]) {
		this["detachBrowserEvent"]("resize", this["oRootRef"]);
	}
	if (this["oChartInstance"]) {
		this["oChartInstance"]["destroy"](); // should remove the _handleChartEvent handlers
		this["_handleChartEvent"] = null;
	}
	this["mEvents"] = null;
	this["oChartInstance"] = null;
	this["oData"] = null;
	this["oDataFeeding"] = null;
	this["oDataSet"] = null;
	this["oOptions"] = null;
	this["oSelection"] = null;
	this["_sType"] = null;
	this["_sDataString"] = null;
	this["_sDataFeedingString"] = null;
	this["_sOptionsString"] = null;
	this["_sSelectionString"] = null;
	this["sType"] = null;

	UCF_PlaceHolder.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["destroy"] = 0; };

/**
 * @private
 * Applies the new values that are stored in XMP
 * Can be used when init() Method is called
 */
UCF_Chart["prototype"]["applyPlaceholderChanges"] = function() {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["applyPlaceholderChanges"]++; }; 
	var oNewRootRef = this["oGetRootRef"]();
	var oDiv;
	var oLsdataNode;

	if (!oNewRootRef) {
		return;
	}

	oDiv = document["createElement"]("div");
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oDiv, oNewRootRef["firstChild"]["innerHTML"]);
	oLsdataNode = oDiv["querySelector"]("*[lsdata]");
	if (oLsdataNode) {
		// In case a new value has the default value, it is not transported via lsdata.
		// Therefore we need to set all attributes to default and apply new values
		this["setDefaultValues"]();

		UCF_JsUtil["extend"](this, UCF_Control["oGetPackedAttribute"](
			oLsdataNode,
			'lsdata',
			this["aAttributeNames"]
		));

		// Apply events
		this["mEvents"] = UCF_Control["oGetPackedAttribute"](oLsdataNode, 'lsevents', this["aEventNames"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["applyPlaceholderChanges"] = 0; };

/**
 * @public
 * @returns whether it is alive
 * @see UCF_PlaceHolder
 */
UCF_Chart["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["bDoKeepAlive"]++; }; 
	// In case of scrollcontainers the content div may get lost
	var oContentRef = UCF_DomUtil["$"](this["sId"] + "-ph");
	if (oContentRef) {
		return this["bKeepAlive"];
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["bDoKeepAlive"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Chart["prototype"]["aAttributeNames"] = ["sType","sDataString","sDataFeedingString","sOptionsString","sSelectionString","sLifeCycle","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Chart["prototype"]["aEventNames"] = ["SelectData","DeselectData"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Chart["prototype"]["aMethodNames"] = ["setData","setType","setKeepAlive","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Chart["prototype"]["sType"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Chart["prototype"]["sDataString"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Chart["prototype"]["sDataFeedingString"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Chart["prototype"]["sOptionsString"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Chart["prototype"]["sSelectionString"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_Chart["prototype"]["sLifeCycle"] = "MANUAL";

/**
 * @private
 * @type {string}
 */
UCF_Chart["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Chart["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["setDefaultValues"]++; }; 
	this["sType"] = '';
	this["sDataString"] = '';
	this["sDataFeedingString"] = '';
	this["sOptionsString"] = '';
	this["sSelectionString"] = '';
	this["sLifeCycle"] = "MANUAL";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Type", '', true);
		this["setClientProperty"]("DataString", '', true);
		this["setClientProperty"]("DataFeedingString", '', true);
		this["setClientProperty"]("OptionsString", '', true);
		this["setClientProperty"]("SelectionString", '', true);
		this["setClientProperty"]("LifeCycle", "MANUAL", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sResult JSON representation of the selected data.
 * @param {string} sSelectionString New JSON representation of the selection.
 * @fires Chart::SelectData
 */
UCF_Chart["prototype"]["fireSelectData"] = function(sId, sResult, sSelectionString) {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["fireSelectData"]++; }; 
	/** @type {{Id: string, Result: string, SelectionString: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Chart.js(586): fireSelectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Chart.js(587): fireSelectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Chart.js(588): fireSelectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sResult != null, "sResult != null", "Chart.js(589): fireSelectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sResult) == "string", "typeof(sResult) == \"string\"", "Chart.js(590): fireSelectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSelectionString != null, "sSelectionString != null", "Chart.js(591): fireSelectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSelectionString) == "string", "typeof(sSelectionString) == \"string\"", "Chart.js(592): fireSelectData"); };
	mParams = {
		"Id": sId,
		"Result": sResult,
		"SelectionString": sSelectionString
	};
	
	
	
	this["fireSemanticEvent"]("Chart", "SelectData", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["fireSelectData"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sResult JSON representation of the selected data.
 * @param {string} sSelectionString New JSON representation of the selection.
 * @fires Chart::DeselectData
 */
UCF_Chart["prototype"]["fireDeselectData"] = function(sId, sResult, sSelectionString) {;if (__UCF_COVERAGE__) { UCF_Chart["_"]["fireDeselectData"]++; }; 
	/** @type {{Id: string, Result: string, SelectionString: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Chart.js(615): fireDeselectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Chart.js(616): fireDeselectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Chart.js(617): fireDeselectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sResult != null, "sResult != null", "Chart.js(618): fireDeselectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sResult) == "string", "typeof(sResult) == \"string\"", "Chart.js(619): fireDeselectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSelectionString != null, "sSelectionString != null", "Chart.js(620): fireDeselectData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSelectionString) == "string", "typeof(sSelectionString) == \"string\"", "Chart.js(621): fireDeselectData"); };
	mParams = {
		"Id": sId,
		"Result": sResult,
		"SelectionString": sSelectionString
	};
	
	
	
	this["fireSemanticEvent"]("Chart", "DeselectData", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Chart["_"]["fireDeselectData"] = 0; };

UCF_Chart.prototype["aPublicMethods"] = ["setType","setChartSelection","setData","bDoKeepAlive"].concat(UCF_Chart.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_CheckBox"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * CheckBox control implementation
 * @class
 * @param {HTMLElement} oDomRef DOM reference
 * @param {UCF_LS} oLS LS instance
 */
function UCF_CheckBox(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["UCF_CheckBox"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "CheckBox.js(20): UCF_CheckBox"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CheckBox.js(21): UCF_CheckBox"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "CheckBox.js(22): UCF_CheckBox"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_CheckBox"] = UCF_CheckBox; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CheckBox"); UCF_CheckBox["_"] = {UCF_CheckBox: 0}; }; ;
UCF_CheckBox["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_CheckBox.prototype["sClassName"] = "UCF_CheckBox";

/**
 * Returns the Rectangle used for Help
 *
 * @private
 * @return {DOMRect}
 */

UCF_CheckBox["prototype"]["oGetClientRectForHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["oGetClientRectForHelp"]++; }; 
	var oDomRect = this["oDomRef"]["getBoundingClientRect"]();
	if (window["UCF_System"]["bIsRTL"]) {
		if (this["sArrangement"] === 'CHECKBOXLAST') {
			oDomRect["right"] = oDomRect["left"] + oDomRect["height"];
			oDomRect["width"] = oDomRect["height"];
		} else {
			oDomRect["x"] = oDomRect["right"] - oDomRect["height"];
			oDomRect["width"] = oDomRect["height"];
		}
	} else {
		if (this["sArrangement"] === 'CHECKBOXLAST') {
			oDomRect["x"] = oDomRect["right"] - oDomRect["height"];
			oDomRect["width"] = oDomRect["height"];
		} else {
			oDomRect["right"] = oDomRect["left"] + oDomRect["height"];
			oDomRect["width"] = oDomRect["height"];
		}
	}
	return oDomRect;
};;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["oGetClientRectForHelp"] = 0; };


UCF_CheckBox["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_CheckBox["prototype"]["aAttributeNames"] = ["sName","bChecked","bEnabled","bReadonly","sText","sTooltip","bInvalid","sVisibility","bShowHelp","sInputState","sAccessKey","sArrangement","sAssociatedEditContext","sTextDesign","bUsedInSapTable","sCustomData","sCustomStyle","bTextOverflow","sHeight","bIsTextLabel","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_CheckBox["prototype"]["aEventNames"] = ["Change","DoubleClick","Enter"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_CheckBox["prototype"]["aMethodNames"] = ["setValue","getValue","setEnabled","getEnabled","setValueState","getValueState","setEditable","getEditable","createDataTip","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_CheckBox["prototype"]["sName"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_CheckBox["prototype"]["bChecked"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_CheckBox["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_CheckBox["prototype"]["bReadonly"] = false;

/**
 * @private
 * @type {string}
 */
UCF_CheckBox["prototype"]["sText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_CheckBox["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_CheckBox["prototype"]["bInvalid"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_CheckBox["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_CheckBox["prototype"]["bShowHelp"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputState}
 */
UCF_CheckBox["prototype"]["sInputState"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_CheckBox["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CheckBoxArrangement}
 */
UCF_CheckBox["prototype"]["sArrangement"] = "CHECKBOXFIRST";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.EditContext}
 */
UCF_CheckBox["prototype"]["sAssociatedEditContext"] = "PARENTEDITABLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CheckBoxTextDesign}
 */
UCF_CheckBox["prototype"]["sTextDesign"] = "STANDARD";

/**
 * @private
 * @type {boolean}
 */
UCF_CheckBox["prototype"]["bUsedInSapTable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_CheckBox["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_CheckBox["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_CheckBox["prototype"]["bTextOverflow"] = false;

/**
 * @private
 * @type {string}
 */
UCF_CheckBox["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_CheckBox["prototype"]["bIsTextLabel"] = false;

/**
 * @private
 * @type {string}
 */
UCF_CheckBox["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_CheckBox["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["setDefaultValues"]++; }; 
	this["sName"] = '';
	this["bChecked"] = false;
	this["bEnabled"] = true;
	this["bReadonly"] = false;
	this["sText"] = '';
	this["sTooltip"] = '';
	this["bInvalid"] = false;
	this["sVisibility"] = "VISIBLE";
	this["bShowHelp"] = false;
	this["sInputState"] = "NONE";
	this["sAccessKey"] = '';
	this["sArrangement"] = "CHECKBOXFIRST";
	this["sAssociatedEditContext"] = "PARENTEDITABLE";
	this["sTextDesign"] = "STANDARD";
	this["bUsedInSapTable"] = false;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["bTextOverflow"] = false;
	this["sHeight"] = '';
	this["bIsTextLabel"] = false;
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Name", '', true);
		this["setClientProperty"]("Checked", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Readonly", false, true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Invalid", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ShowHelp", false, true);
		this["setClientProperty"]("InputState", "NONE", true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("Arrangement", "CHECKBOXFIRST", true);
		this["setClientProperty"]("AssociatedEditContext", "PARENTEDITABLE", true);
		this["setClientProperty"]("TextDesign", "STANDARD", true);
		this["setClientProperty"]("UsedInSapTable", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("TextOverflow", false, true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("IsTextLabel", false, true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {boolean} bChecked Returns the current checked status of the checkbox
 * @fires CheckBox::Change
 */
UCF_CheckBox["prototype"]["fireChange"] = function(sId, bChecked) {;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Checked: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "CheckBox.js(270): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CheckBox.js(271): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CheckBox.js(272): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bChecked != null, "bChecked != null", "CheckBox.js(273): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bChecked) == "boolean", "typeof(bChecked) == \"boolean\"", "CheckBox.js(274): fireChange"); };
	mParams = {
		"Id": sId,
		"Checked": bChecked
	};
	
	
	this["fireSemanticEvent"]("CheckBox", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires CheckBox::DoubleClick
 */
UCF_CheckBox["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "CheckBox.js(293): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CheckBox.js(294): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CheckBox.js(295): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("CheckBox", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires CheckBox::Enter
 */
UCF_CheckBox["prototype"]["fireEnter"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["fireEnter"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "CheckBox.js(312): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "CheckBox.js(313): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "CheckBox.js(314): fireEnter"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("CheckBox", "Enter", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_CheckBox["_"]["fireEnter"] = 0; };

};
sap["ls"]["preload"]["UCF_CheckBoxBase"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./LayeredControl.js"/>

/**
 * CheckBoxBase
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_CheckBoxBase(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["UCF_CheckBoxBase"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "CheckBoxBase.js(31): UCF_CheckBoxBase"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CheckBoxBase.js(32): UCF_CheckBoxBase"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "CheckBoxBase.js(33): UCF_CheckBoxBase"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	// set reference to html objects
	this["oImageRef"] = UCF_DomUtil["$"](this["sId"] + "-img"); // radio button image
	this["oImageStdRef"] = UCF_DomUtil["$"](this["sId"] + "-imgStd");
	this["oImageDotRef"] = UCF_DomUtil["$"](this["sId"] + "-imgDot");
	this["oFocusDomRef"] = UCF_DomUtil["$"](this["sId"] + "-lbl"); // outer span is focused
	this["oDataTipOpenerRef"] = this["oImageRef"];
	this["bUseFontIcon"] = false;
	if (this["oImageRef"] && this["oImageStdRef"]) {
		this["sImageDisplayMode"] = UCF_DomUtil["sGetCurrentStyle"](this["oImageRef"], "display");
		if (this["sImageDisplayMode"] && this["sImageDisplayMode"] === "none") {
			this["oDataTipOpenerRef"] = this["oImageStdRef"];
			this["bUseFontIcon"] = true;
		}
	}
	// connect the datatip to the checkboxes image
	if (this["oDataTip"]) {
		this["oDataTip"]["setOpenerRef"](this["oDataTipOpenerRef"]);
		if (this["sTooltip"] !== "" || window["UCF_System"]["bIs508"]) this["oDataTip"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"]);
		if (this["bShowHelp"]) {
			this["oDataTip"]["setHoverDomRef"](this["oFocusDomRef"]);
			this["oDataTip"]["setHoverDomRefExcluded"](this["oDataTipOpenerRef"]);
		}
	}
	// parent readonly leads to readonly behaviour and different design
	if (this["sAssociatedEditContext"] === "PARENTREADONLY") this["bReadonly"] = true;
	this["bSelectionButtonFirst"] = true;
	if (this["sArrangement"] === "CHECKBOXLAST" || this["sArrangement"] === "RADIOBUTTONLAST") {
		this["bSelectionButtonFirst"] = false;
	}
	//touchend event for Label
	this["oLabelDomRef"] = UCF_DomUtil["$"](this["sId"] + '-lbl');
	if (this["oLabelDomRef"] && (UCF_UserAgent["bIsPhone"]() || UCF_UserAgent["bIsTablet"]())) {
		this["attachBrowserEvent"]("touchend", this["oLabelDomRef"]);
		this["bTouchEvent"] = false;
	}
};window["UCF_CheckBoxBase"] = UCF_CheckBoxBase; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CheckBoxBase"); UCF_CheckBoxBase["_"] = {UCF_CheckBoxBase: 0}; }; ;
UCF_CheckBoxBase["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_CheckBoxBase.prototype["sClassName"] = "UCF_CheckBoxBase";

/**
 * Destructor
 * @private
 */
UCF_CheckBoxBase["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["destroy"]++; }; 
	if (this["oLabelDomRef"] && (UCF_UserAgent["bIsPhone"]() || UCF_UserAgent["bIsTablet"]())) {
		this["detachBrowserEvent"]("touchend", this["oLabelDomRef"]);
	}

	this["oImageRef"] = null;
	this["oImageStdRef"] = null;
	this["oImageDotRef"] = null;
	this["oFocusDomRef"] = null;
	this["oDataTipOpenerRef"] = null;
	this["bUseFontIcon"] = null;
	this["bSelectionButtonFirst"] = null;
	this["sImageDisplayMode"] = null;
	this["sInputState"] = null;
	this["bEnabled"] = null;
	this["bChecked"] = null;
	this["bReadonly"] = null;
	this["oLabelDomRef"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["destroy"] = 0; };

/**
 * Returns the value of the CheckBox, true=checked; false=not checked
 * @return {boolean} The value of the CheckBox, true=checked; false=not checked
 * @public
 */
UCF_CheckBoxBase["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["getValue"]++; }; 
	return this["bChecked"];
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["getValue"] = 0; };

/**
 * Set the value of the CheckBox, true=selected; false=deselected
 * @param {boolean} bValue the new value
 * @public
 */
UCF_CheckBoxBase["prototype"]["setValue"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setValue"]++; }; 
	this["bChecked"] = bValue;
	this["setClientProperty"]("Value", this["bChecked"], true);
	this["setClientProperty"]("Checked", this["bChecked"], true);
	this["applyStateToDom"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setValue"] = 0; };

/**
 * Get enabled
 * @returns the enabled state
 * @type boolean
 * @public
 */
UCF_CheckBoxBase["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["getEnabled"]++; }; 
	return this["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["getEnabled"] = 0; };

/**
 * Set enabled
 * @param {boolean} bEnabled the new enabled value
 * @public
 */
UCF_CheckBoxBase["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setEnabled"]++; }; 
	if (this["bEnabled"] === bEnabled) return;

	this["bEnabled"] = bEnabled;
	this["setClientProperty"]("Enabled", this["bEnabled"], true);

	if (window["UCF_System"]["bIs508"] || (this["bEnabled"] && !this["bReadonly"]))
		UCF_DomUtil["setTabIndex"](this["oFocusDomRef"], 0);
	else
		UCF_DomUtil["setTabIndex"](this["oFocusDomRef"], -1);

	this["applyStateToDom"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setEnabled"] = 0; };

/**
 * Get the editable state of the checkbox
 * @returns the editable state
 * @type boolean
 * @public
 */
UCF_CheckBoxBase["prototype"]["getEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["getEditable"]++; }; 
	return !this["bReadonly"];
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["getEditable"] = 0; };

/**
 * Set the editable state of the checkbox
 *
 * @param {boolean} bEditable the new editable value
 * @public
 */
UCF_CheckBoxBase["prototype"]["setEditable"] = function(bEditable) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setEditable"]++; }; 
	var bReadOnly = !bEditable;

	if (this["bReadonly"] === bReadOnly) return;

	this["bReadonly"] = bReadOnly;
	this["setClientProperty"]("Readonly", this["bReadonly"], true);

	if (window["UCF_System"]["bIs508"] || (this["bEnabled"] && !this["bReadonly"]))
		UCF_DomUtil["setTabIndex"](this["oFocusDomRef"], 0);
	else
		UCF_DomUtil["setTabIndex"](this["oFocusDomRef"], -1);

	this["applyStateToDom"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setEditable"] = 0; };

/**
 * Gets the value state of this checkbox
 * @returns the required state
 * @type string
 * @public
 */
UCF_CheckBoxBase["prototype"]["getValueState"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["getValueState"]++; }; 
	return this["sInputState"];
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["getValueState"] = 0; };

/**
 * Sets the input state of the checkbox
 * @param { string } sInputState state
 * @public
 */
UCF_CheckBoxBase["prototype"]["setValueState"] = function(sInputState) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setValueState"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sInputState === "ERROR" || sInputState === "WARNING" || sInputState === "NONE" || sInputState === "INVALIDATE" || sInputState === "INVALIDATELOADING", "sInputState === \"ERROR\" || sInputState === \"WARNING\" || sInputState === \"NONE\" || sInputState === \"INVALIDATE\" || sInputState === \"INVALIDATELOADING\"", "CheckBoxBase.js(199): setValueState"); };

	if (sInputState === this["sInputState"]) return;

	this["sInputState"] = sInputState;
	this["setClientProperty"]("InputState", this["sInputState"], true);

	this["applyStateToDom"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setValueState"] = 0; };

/**
 * Checks if the control can get the focus or not
 * @return {boolean} Whether the control can get the focus
 * @private
 */
UCF_CheckBoxBase["prototype"]["bIsFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["bIsFocusable"]++; }; 
	if (window["UCF_System"]["bIs508"] || (this["bEnabled"] && !this["bReadonly"]))
		return (this["oFocusDomRef"] && UCF_DomUtil["bHasTabIndex"](this["oFocusDomRef"]));
	else
		return false;
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["bIsFocusable"] = 0; };

/**
 * Applies the current state of the control to the dom
 * @param {string} sClassId The id of the css class
 * @private
 */
UCF_CheckBoxBase["prototype"]["applyStateToDom"] = function(sClassId) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["applyStateToDom"]++; }; 

	/* !!! IMPORTANT
	 * This code section has a related code section
	 * in the renderer which has to be kept in sync
	 */
	//customStyles
	// Optimeze the class set just replacing the classes and not from begining creating it
	/*var sCustomStyleClass = "";
	if (this.sCustomStyle != "") {
		var sCustomStyleClass = this.sCustomStyle;
		sCustomStyleClass = UCF_RenderManager.addCustomStyleSuffix(sCustomStyleClass, "") + " ";
	}*/
	var sImageOldClass = this["sGetClass"](this["oImageRef"]),
		sImageDisplayClass = "ls" + sClassId + "ImgDspl",
		sImageClassName = "urNoUserSelect ur" + sClassId + "Img",
		eChecked = this["getValue"]();
	if (sImageOldClass["indexOf"](sImageDisplayClass) > -1) {
		sImageClassName = sImageDisplayClass + " " + sImageClassName;
	}
	/*if (!this.bSelectionButtonFirst) {
		sLabelClassName = "lsCBImgLast " +  sLabelClassName;
	} */
	if (eChecked === true) {
		sImageClassName += "On";
	} else if (eChecked === false) {
		sImageClassName += "Off";
	} else if (eChecked === null) {
		sImageClassName += "Ind";
	}

	this["removeClass"](this["oFocusDomRef"], "urCLbl urCLblInv urCLblWarn urCLblDsbl");
	if (this["bEnabled"]) {
		if (this["bInvalid"] || this["sInputState"] === "ERROR") {
			sImageClassName += "Inv";
			//sLabelClassName += "Inv";
			this["addClass"](this["oFocusDomRef"], "urCLblInv");

		} else if (this["bInvalid"] || this["sInputState"] === "WARNING") {
			sImageClassName += "Warn";
			this["addClass"](this["oFocusDomRef"], "urCLbl");
		} else {
			this["addClass"](this["oFocusDomRef"], "urCLbl");
		}

		if (this["sAssociatedEditContext"] === "PARENTREADONLY") {
			sImageClassName += "CtxtRo";
		} else if (this["bReadonly"]) {
			sImageClassName += "Ro";
		}
	} else {
		sImageClassName += "Dsbl";
		this["addClass"](this["oFocusDomRef"], "urCLblDsbl");
	}

	if (this["bUsedInSapTable"]) {
		sImageClassName += " lsCWhlTbl";
	}

	//if (bHasText) sLabelClassName += " urCl1";

	if (this["oImageRef"]) {
		//IE9 bug I-4654763 2012 --
		//this.oImageRef.className = '';
		//this.oImageRef.className = sImageClassName;

		if (this["oImageRef"]["className"]["indexOf"]('LastAndStreched') > -1)
			sImageClassName += " lsCBImgLastAndStreched";

		this["setClass"](this["oImageRef"], sImageClassName);
	}

	//	if (this.oFocusDomRef) this.oFocusDomRef.className = sLabelClassName;
	var oDescDomRef = document["getElementById"](this["sId"] + "-lbl");

	// Image for Standard mode
	if (this["oImageStdRef"]) {

		var sDomRefClass = this["sGetClass"](this["oImageStdRef"]);

		if (this["bEnabled"]) {
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgDsbl", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdRO", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdErr", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdInv", true);
			if (this["bReadonly"]) {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "ls" + sClassId + "BImgDefHv", true);
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdRO");
			} else {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "ls" + sClassId + "BImgDefHv");
			}
			if (this["sInputState"] === "ERROR") {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdErr");
			} else if (this["sInputState"] === "WARNING") {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdInv");
			}
		} else {
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "ls" + sClassId + "BImgDefHv", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdRO", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdErr", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdInv", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgDsbl");
			if (this["sInputState"] === "ERROR") {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdErr");
			} else if (this["sInputState"] === "WARNING") {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdInv");
			}
		}
		this["setClass"](this["oImageStdRef"], sDomRefClass);
	}

	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setChecked"](oDescDomRef, eChecked);
		UCF_AriaStateHelper["setDisabled"](oDescDomRef, !this["bEnabled"]);
		UCF_AriaStateHelper["setReadonly"](oDescDomRef, this["bReadonly"]);
		UCF_AriaStateHelper["setTabIndex"](oDescDomRef, this["bEnabled"] && !this["bReadonly"]);
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["applyStateToDom"] = 0; };
/**
 * Applys the selection class for the button in standards mode
 * @param {string} sClassId
 * @private
 */
UCF_CheckBoxBase["prototype"]["applySelection"] = function(sClassId) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["applySelection"]++; }; 

	//if(!this.bEnabled || this.bReadonly)
	//	return;

	// change the Standard Classes
	var oImgDot = UCF_DomUtil["$"](this["sId"] + '-imgSymb');
	if (oImgDot) {
		if (sClassId === 'Tri') {
			var sClassNameSel = "lsTriBImgSel",
				sClassNameSymbSel = "lsTriBImgSymb",
				sClassNameInd = "lsTriBImgInd",
				sClassNameSymbInd = "lsTriBImgSymbInd",
				sDomRefClass = this["sGetClass"](oImgDot);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSel, true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSymbSel, true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameInd, true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSymbInd, true);
			switch (this["sState"]) {
				case "CHECKED":
					sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSel, false);
					sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSymbSel, false);
					break;
				case "UNCHECKED":
					break;
				case "INDETERMINATE":
					sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameInd, false);
					sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSymbInd, false);
					break;
			}
			this["setClass"](oImgDot, sDomRefClass);
		} else {
			var sClassName = "ls" + sClassId + "BImgSel";
			if (this["bChecked"]) {
				if (!this["bHasClass"](oImgDot, sClassName))
					this["addClass"](oImgDot, sClassName);
			} else {
				this["removeClass"](oImgDot, sClassName);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["applySelection"] = 0; };

/**
 * Adds/removes the given class to the given domRef
 * @param {string} sDomRefClass
 * @param {string} sClassName
 * @param {bool} bRemoveClass
 * @return {bool}
 *
 * @private
 */
UCF_CheckBoxBase["prototype"]["maintainDomClass"] = function(sDomRefClass, sClassName, bRemoveClass) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["maintainDomClass"]++; }; 
	if (sDomRefClass != null && sClassName != null) {
		var oReg = new RegExp("(^| )" + sClassName + "( |$)"),
			bHasClass = sDomRefClass["match"](oReg);
		if (bHasClass) {
			if (bRemoveClass) {
				var aClassNames = sDomRefClass["split"](" ");

				for (var x = 0; x < aClassNames["length"]; x++) {
					var sName = aClassNames[x];
					if (sName === sClassName || sName === "") {
						aClassNames["splice"](x, 1);
						x--;
					}
				}
				sDomRefClass = aClassNames["join"](" ");
			}
		} else {
			if (!bRemoveClass) {
				sDomRefClass = sDomRefClass + " " + sClassName;
			}
		}
	}
	return sDomRefClass;
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["maintainDomClass"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 * @param {UCF_BrowserEvent} oBrowserEvent The browser event
 * @private
 */
UCF_CheckBoxBase["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBoxBase.js(433): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		eChecked = this["getValue"]();

	//Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this, "", "", this["sText"]);
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());
	oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setReadonly"](this["bReadonly"]);
	oAccessibilityHelper["setInvalid"](this["bInvalid"]);

	if (eChecked === true) {
		oAccessibilityHelper["setChecked"](true);
	} else if (eChecked === false) {
		oAccessibilityHelper["setNotChecked"](true);
	} else if (eChecked === null) {
		oAccessibilityHelper["setMixed"](true);
	}

	if (this["bInvalid"] || this["sInputState"] === "ERROR") {
		oAccessibilityHelper["setInvalid"](true);
	} else if (this["sInputState"] === "WARNING") {
		oAccessibilityHelper["setWarning"](true);
	}

	// data tip
	if (this["oDataTip"]) {
		oAccessibilityHelper["setDataTip"](this["oDataTip"]["sText"]);
	}

	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["onlsaccessibility"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 * @return {HTML_Element}
 */
UCF_CheckBoxBase["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["oGetInplaceEditDomRef"]++; }; 
	var aSpans = this["oRootRef"]["getElementsByTagName"]("SPAN");
	for (var i = 0; i < aSpans["length"]; i++) {
		if (aSpans[i]["getAttribute"]("iid") === "text") {
			return aSpans[i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["oGetInplaceEditDomRef"] = 0; };

/**
 * @see UCF_Control.sGetInplaceEditText
 * @return {string}
 */
UCF_CheckBoxBase["prototype"]["sGetInplaceEditText"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["sGetInplaceEditText"]++; }; 
	var oClientContol = this["getClientControl"]();
	if (oClientContol) {
		if (oClientContol["getText"]()) {
			return oClientContol["getText"]();
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["sGetInplaceEditText"] = 0; };

/**
 * @see UCF_Control.setInplaceEditDomRef
 * @param {string} sText
 */
UCF_CheckBoxBase["prototype"]["setInplaceEditText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setInplaceEditText"]++; }; 
	var oClientContol = this["getClientControl"]();
	if (oClientContol) {
		oClientContol["setText"](sText);
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setInplaceEditText"] = 0; };

/**
 * Check the text if rendered with ellipsis, and display it in tooltip
 * @private
 */
UCF_CheckBoxBase["prototype"]["applyTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["applyTooltip"]++; }; 

	if (window["UCF_System"]["bIs508"]) return;
	// the text will not be added to the Title when Wrapping=true and the
	if (!this["bTextOverflow"] && this["bWrapping"])
		return;

	var oDomRefTxt = UCF_DomUtil["$"](this["sId"] + "-txt"),
		oDomRefContainer = UCF_DomUtil["$"](this["sId"] + "-lbl");
	if (this["bTextOverflow"]) {
		UCF_DomUtil["checkTooltip"](oDomRefContainer, this["sTooltip"], oDomRefTxt);
	} else {
		UCF_DomUtil["checkTooltip"](oDomRefTxt, this["sTooltip"], null);
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["applyTooltip"] = 0; };
/**
 * Handles the lsenter event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBoxBase["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBoxBase.js(535): onlsenter"); };

	if (this["mEvents"]["Enter"]) {
		this["fireEnter"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["onlsenter"] = 0; };

/**
 * @override
 * @see {UCF_Control}
 * @private
 */
UCF_CheckBoxBase["prototype"]["colorizeHighlightedText"] = function(iStart, iLength, sTextProperty, bFocused) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["colorizeHighlightedText"]++; }; 
	if (bFocused) {
		if (this["oFocusDomRef"] && !this["bHasClass"](this["oFocusDomRef"], 'lsHighlightTextFocus')) {
			this["addClass"](this["oFocusDomRef"], 'lsHighlightTextFocus');
		}
	} else {
		if (this["oFocusDomRef"] && !this["bHasClass"](this["oFocusDomRef"], 'lsHighlightText')) {
			this["addClass"](this["oFocusDomRef"], 'lsHighlightText');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["colorizeHighlightedText"] = 0; };

/**
 * SapTable needs information if a text selection is caused by the user or not:
 * For CheckBox, TriStateCheckBox as well as RadioButton there never should be
 * a texSelection triggered by the user.
 *
 * @protected
 * @return {boolean} `true` if the control text is selected (by the user), `false` otherwise
 */
UCF_CheckBoxBase["prototype"]["bIsUserTextSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["bIsUserTextSelection"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["bIsUserTextSelection"] = 0; };

/**
 * Sets a CSS class to a DOM object
 *
 * @param {element} oDomRef the DOM reference
 * @param {string} sClassName the class to set to the object
 * @private
 */
UCF_CheckBoxBase["setClass"] = function(oDomRef, sClassName) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setClass"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CheckBoxBase.js(582): setClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "CheckBoxBase.js(583): setClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sClassName) === "string", "typeof(sClassName) === \"string\"", "CheckBoxBase.js(584): setClass"); };

	oDomRef["className"] = sClassName;
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["setClass"] = 0; };

/**
 * Gets the CSS class of a DOM object
 *
 * @param {element} oDomRef the DOM reference
 * @return {string} sClassName the class to set to the object
 * @private
 */
UCF_CheckBoxBase["sGetClass"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["sGetClass"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CheckBoxBase.js(598): sGetClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "CheckBoxBase.js(599): sGetClass"); };

	return oDomRef["className"];
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["sGetClass"] = 0; };

/**
 * Adds a CSS class to existing classes on a DOM object
 *
 * @param {element} oDomRef the DOM reference
 * @param {string} sClassName the class to add to the object
 * @private
 */
UCF_CheckBoxBase["addClass"] = function(oDomRef, sClassName) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["addClass"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CheckBoxBase.js(613): addClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "CheckBoxBase.js(614): addClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sClassName) === "string", "typeof(sClassName) === \"string\"", "CheckBoxBase.js(615): addClass"); };

	var sCurrentClass = oDomRef["className"];
	if (sCurrentClass) {
		sClassName = sCurrentClass + " " + sClassName;
	}
	oDomRef["className"] = sClassName;

};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["addClass"] = 0; };

/**
 * Removes a CSS class from existing classes on a DOM object
 *
 * @param {element} oDomRef the DOM reference
 * @param {string} sRemoveClassName the class to add to the object
 * @private
 */
UCF_CheckBoxBase["removeClass"] = function(oDomRef, sRemoveClassName) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["removeClass"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CheckBoxBase.js(634): removeClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "CheckBoxBase.js(635): removeClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRemoveClassName) === "string", "typeof(sRemoveClassName) === \"string\"", "CheckBoxBase.js(636): removeClass"); };

	if (sRemoveClassName === "" || sRemoveClassName === " ") return;
	var sClassName = oDomRef["className"];
	if (!sClassName)
		return;

	var aClassNames = oDomRef["className"]["split"](" ");

	for (var x = 0; x < aClassNames["length"]; x++) {
		var sName = aClassNames[x];
		if (sName === sRemoveClassName || sName === "") {
			aClassNames["splice"](x, 1);
			x--;
		}
	}

	oDomRef["className"] = aClassNames["join"](" ");
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["removeClass"] = 0; };

/**
 * Checks if a CSS class is part of the existing classes on a DOM object
 *
 * @param {element} oDomRef the DOM reference
 * @param {string} sClassName the class that should be found
 * @return {bool}
 * @private
 */
UCF_CheckBoxBase["bHasClass"] = function(oDomRef, sClassName) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["bHasClass"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CheckBoxBase.js(665): bHasClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "CheckBoxBase.js(666): bHasClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sClassName) === "string", "typeof(sClassName) === \"string\"", "CheckBoxBase.js(667): bHasClass"); };

	var oReg = new RegExp("(^| )" + sClassName + "( |$)"),
		sClass = this["sGetClass"](oDomRef);
	return sClass["match"](oReg);
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["bHasClass"] = 0; };

/**
 * Replaces a CSS class of the existing classes on a DOM object
 *
 * @param {element} oDomRef the DOM reference
 * @param {string} sReplaceClassName the class that should be replaced
 * @param {string} sClassName the class that replaces the old class
 * @private
 */
UCF_CheckBoxBase["replaceClass"] = function(oDomRef, sReplaceClassName, sClassName) {;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["replaceClass"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CheckBoxBase.js(684): replaceClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "CheckBoxBase.js(685): replaceClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sReplaceClassName) === "string", "typeof(sReplaceClassName) === \"string\"", "CheckBoxBase.js(686): replaceClass"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sClassName) === "string", "typeof(sClassName) === \"string\"", "CheckBoxBase.js(687): replaceClass"); };

	if (sReplaceClassName === "" || sReplaceClassName === " ") return;
	var sCurrentClass = oDomRef["className"];
	if (sCurrentClass) {
		sCurrentClass = sCurrentClass["replace"](new RegExp("(^| )" + sReplaceClassName + "( |$)", "g"), "$1" + sClassName + "$2");
		oDomRef["className"] = sCurrentClass;
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxBase["_"]["replaceClass"] = 0; };

UCF_CheckBoxBase.prototype["aPublicMethods"] = ["getValue","setValue","getEnabled","setEnabled","getEditable","setEditable","getValueState","setValueState"].concat(UCF_CheckBoxBase.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_CheckBoxDTExtension"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DTExtension */
/// <reference path="./DTExtension.js"/>

/**
 * 
 *
 * @class
 * @extends UCF_DTExtension
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oControl
 * @param {UCF_DTElement} oDTElement
 */
function UCF_CheckBoxDTExtension(oLS, oControl, oDTElement) {if (__UCF_COVERAGE__) { UCF_CheckBoxDTExtension["_"]["UCF_CheckBoxDTExtension"]++; }; 
	if (arguments["length"] === 0) return;
	UCF_DTExtension["apply"](this, arguments);
};window["UCF_CheckBoxDTExtension"] = UCF_CheckBoxDTExtension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CheckBoxDTExtension"); UCF_CheckBoxDTExtension["_"] = {UCF_CheckBoxDTExtension: 0}; }; ;
UCF_CheckBoxDTExtension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTExtension"))(); UCF_CheckBoxDTExtension.prototype["sClassName"] = "UCF_CheckBoxDTExtension";

/**
 * @private
 * @see UCF_DTExtension
 * @param {string} sElementId
 * @return {HTMLElement}
 */
UCF_CheckBoxDTExtension["prototype"]["oGetDomRefForRect"] = function(sElementId) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDTExtension["_"]["oGetDomRefForRect"]++; }; 
	// Use label SPAN (instead of oRootRef) which includes everything (image and text)
	return UCF_DomUtil["$"](this["oControl"]["sId"] + "-lbl");
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDTExtension["_"]["oGetDomRefForRect"] = 0; };

};
sap["ls"]["preload"]["UCF_CheckBoxDelegate_ie6"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="../base/LayeredControl.js"/>

/**
 * @class
 * @param {HTMLElement} oSelector
 */
function UCF_CheckBoxDelegate_ie6(oSelector) {if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["UCF_CheckBoxDelegate_ie6"]++; }; 

	// set reference to html objects
	this["oSelector"] = oSelector;
	this["sClassId"] = oSelector["oDomRef"]["getAttribute"]('ct')["split"]('_ie6')[0];
	this["oImageRef"] = UCF_DomUtil["$"](oSelector["sId"] + "-img"); // radio button image
	this["oImageStdRef"] = UCF_DomUtil["$"](oSelector["sId"] + "-imgStd");
	this["oImageDotRef"] = UCF_DomUtil["$"](oSelector["sId"] + "-imgDot");
	this["oFocusDomRef"] = UCF_DomUtil["$"](oSelector["sId"] + "-lbl"); // outer span is focused
	this["oDataTipOpenerRef"] = this["oImageRef"];
	this["bUseFontIcon"] = false;
	if (this["oImageRef"] && this["oImageStdRef"]) {
		this["sImageDisplayMode"] = UCF_DomUtil["sGetCurrentStyle"](this["oImageRef"], "display");
		if (this["sImageDisplayMode"] && this["sImageDisplayMode"] === "none") {
			this["oDataTipOpenerRef"] = this["oImageStdRef"];
			this["bUseFontIcon"] = true;
		}
	}

	// connect the datatip to the checkboxes image
	if (oSelector["oDataTip"]) {
		oSelector["oDataTip"]["setOpenerRef"](this["oDataTipOpenerRef"]);
		if (oSelector["sTooltip"] !== "" || window["UCF_System"]["bIs508"]) oSelector["oDataTip"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"]);
		if (oSelector["bShowHelp"]) {
			oSelector["oDataTip"]["setHoverDomRef"](this["oSelector"]["oFocusDomRef"]);
			oSelector["oDataTip"]["setHoverDomRefExcluded"](this["oDataTipOpenerRef"]);
		}
	}
	// parent readonly leads to readonly behaviour and different design
	if (oSelector["sAssociatedEditContext"] === "PARENTREADONLY") this["oSelector"]["bReadonly"] = true;
	oSelector["bSelectionButtonFirst"] = true;
	if (oSelector["sArrangement"] === "CHECKBOXLAST" || oSelector["sArrangement"] === "RADIOBUTTONLAST") {
		oSelector["bSelectionButtonFirst"] = false;
	}

	this["oLabelDomRef"] = UCF_DomUtil["$"](this["oSelector"]["sId"] + '-lbl');

};window["UCF_CheckBoxDelegate_ie6"] = UCF_CheckBoxDelegate_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CheckBoxDelegate_ie6"); UCF_CheckBoxDelegate_ie6["_"] = {UCF_CheckBoxDelegate_ie6: 0}; }; ;
UCF_CheckBoxDelegate_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_CheckBoxDelegate_ie6.prototype["sClassName"] = "UCF_CheckBoxDelegate_ie6";

/**
 * Destructor
 * @private
 */
UCF_CheckBoxDelegate_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["destroy"]++; }; 
	this["oImageRef"] = null;
	if (this["oSelector"]) {
		this["oSelector"]["oFocusDomRef"] = null;
		this["oSelector"] = null;
	}
	this["oLabelDomRef"] = null;
	this["sClassId"] = null;
	this["oImageDotRef"] = null;
	this["oImageStdRef"] = null;
	this["oFocusDomRef"] = null;
	this["oDataTipOpenerRef"] = null;
	this["sImageDisplayMode"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["destroy"] = 0; };

/**
 * Returns the value of the CheckBox, true=checked; false=not checked
 * @return {boolean} The value of the CheckBox, true=checked; false=not checked
 * @public
 */
UCF_CheckBoxDelegate_ie6["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["getValue"]++; }; 

	if (this["oSelector"]["sState"]) {
		switch (this["oSelector"]["sState"]) {
			case 'CHECKED':
				return true;
			case 'UNCHECKED':
				return false;
			case 'INDETERMINATE':
				return null;
		}
	} else {
		return this["oSelector"]["bChecked"];
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["getValue"] = 0; };

/**
 * Set the value of the CheckBox, true=selected; false=deselected
 * @param {boolean} bValue the new value
 * @public
 */
UCF_CheckBoxDelegate_ie6["prototype"]["setValue"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["setValue"]++; }; 
	this["oSelector"]["bChecked"] = bValue;
	this["oSelector"]["setClientProperty"]("Value", this["oSelector"]["bChecked"], true);
	this["oSelector"]["setClientProperty"]("Checked", this["oSelector"]["bChecked"], true);
	this["applyStateToDom"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["setValue"] = 0; };

/**
 * Get enabled
 * @return {boolean} the enabled state
 * @public
 */
UCF_CheckBoxDelegate_ie6["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["getEnabled"]++; }; 
	return this["oSelector"]["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["getEnabled"] = 0; };

/**
 * Set enabled
 * @param {boolean} bEnabled the new enabled value
 * @public
 */
UCF_CheckBoxDelegate_ie6["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["setEnabled"]++; }; 
	if (this["oSelector"]["bEnabled"] === bEnabled) return;

	this["oSelector"]["bEnabled"] = bEnabled;
	this["oSelector"]["setClientProperty"]("Enabled", this["oSelector"]["bEnabled"], true);

	if (window["UCF_System"]["bIs508"] || (this["oSelector"]["bEnabled"] && !this["oSelector"]["bReadonly"]))
		UCF_DomUtil["setTabIndex"](this["oSelector"]["oFocusDomRef"], 0);
	else
		UCF_DomUtil["setTabIndex"](this["oSelector"]["oFocusDomRef"], -1);

	this["applyStateToDom"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["setEnabled"] = 0; };

/**
 * Get the editable state of the checkbox
 * @return {boolean} the editable state
 * @public
 */
UCF_CheckBoxDelegate_ie6["prototype"]["getEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["getEditable"]++; }; 
	return !this["oSelector"]["bReadonly"];
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["getEditable"] = 0; };

/**
 * Set the editable state of the checkbox
 *
 * @param {boolean} bEditable the new editable value
 * @public
 */
UCF_CheckBoxDelegate_ie6["prototype"]["setEditable"] = function(bEditable) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["setEditable"]++; }; 
	var bReadOnly = !bEditable;

	if (this["oSelector"]["bReadonly"] === bReadOnly) return;

	this["oSelector"]["bReadonly"] = bReadOnly;
	this["oSelector"]["setClientProperty"]("Readonly", this["oSelector"]["bReadonly"], true);

	if (window["UCF_System"]["bIs508"] || (this["oSelector"]["bEnabled"] && !this["oSelector"]["bReadonly"]))
		UCF_DomUtil["setTabIndex"](this["oSelector"]["oFocusDomRef"], 0);
	else
		UCF_DomUtil["setTabIndex"](this["oSelector"]["oFocusDomRef"], -1);

	this["applyStateToDom"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["setEditable"] = 0; };

/**
 * Gets the value state of this checkbox
 * @return {string} the required state
 * @public
 */
UCF_CheckBoxDelegate_ie6["prototype"]["getValueState"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["getValueState"]++; }; 
	return this["oSelector"]["sInputState"];
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["getValueState"] = 0; };

/**
 * Sets the input state of the checkbox
 * @param {string} sInputState
 * @public
 */
UCF_CheckBoxDelegate_ie6["prototype"]["setValueState"] = function(sInputState) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["setValueState"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sInputState === "ERROR" || sInputState === "WARNING" || sInputState === "NONE" || sInputState === "INVALIDATE" || sInputState === "INVALIDATELOADING", "sInputState === \"ERROR\" || sInputState === \"WARNING\" || sInputState === \"NONE\" || sInputState === \"INVALIDATE\" || sInputState === \"INVALIDATELOADING\"", "CheckBoxDelegate_ie6.js(185): setValueState"); };

	if (sInputState === this["oSelector"]["sInputState"]) return;

	this["oSelector"]["sInputState"] = sInputState;
	this["oSelector"]["setClientProperty"]("InputState", this["oSelector"]["sInputState"], true);

	this["applyStateToDom"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["setValueState"] = 0; };

/**
 * Checks if the control can get the focus or not
 * @return {boolean} Whether the control can get the focus
 * @private
 */
UCF_CheckBoxDelegate_ie6["prototype"]["bIsFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["bIsFocusable"]++; }; 
	if (window["UCF_System"]["bIs508"] || (this["oSelector"]["bEnabled"] && !this["oSelector"]["bReadonly"]))
		return (this["oSelector"]["oFocusDomRef"] && UCF_DomUtil["bHasTabIndex"](this["oSelector"]["oFocusDomRef"]));
	else
		return false;
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["bIsFocusable"] = 0; };

/**
 * Applies the current state of the control to the dom
 * @param {string} sClassId The id of the css class
 * @private
 */
UCF_CheckBoxDelegate_ie6["prototype"]["applyStateToDom"] = function(sClassId) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["applyStateToDom"]++; }; 

	if (!sClassId) sClassId = this["sClassId"];
	if (sClassId === 'TRI') sClassId = 'Tri';

	/* !!! IMPORTANT
	 * This code section has a related code section
	 * in the renderer which has to be kept in sync
	 */
	//customStyles
	// Optimeze the class set just replacing the classes and not from begining creating it
	/*var sCustomStyleClass = "";
	if (this.sCustomStyle != "") {
		var sCustomStyleClass = this.sCustomStyle;
		sCustomStyleClass = UCF_RenderManager.addCustomStyleSuffix(sCustomStyleClass, "") + " ";
	}*/

	var sImageOldClass = UCF_DomUtil["sGetClass"](this["oImageRef"]),
		sImageDisplayClass = "ls" + sClassId + "ImgDspl",
		sImageClassName = "urNoUserSelect ur" + sClassId + "Img",
		eChecked = this["getValue"](),
		oSelector = this["oSelector"];

	if (sImageOldClass["indexOf"](sImageDisplayClass) > -1) {
		sImageClassName = sImageDisplayClass + " " + sImageClassName;
	}
	/*if (!this.bSelectionButtonFirst) {
		sLabelClassName = "lsCBImgLast " +  sLabelClassName;
	} */
	if (eChecked === true) {
		sImageClassName += "On";
	} else if (eChecked === false) {
		sImageClassName += "Off";
	} else if (eChecked === null) {
		sImageClassName += "Ind";
	}

	UCF_DomUtil["removeClass"](oSelector["oFocusDomRef"], "urCLbl urCLblInv urCLblWarn urCLblDsbl");
	if (oSelector["bEnabled"]) {
		if (oSelector["bInvalid"] || oSelector["sInputState"] === "ERROR") {
			sImageClassName += "Inv";
			//sLabelClassName += "Inv";
			UCF_DomUtil["addClass"](oSelector["oFocusDomRef"], "urCLblInv");

		} else if (oSelector["bInvalid"] || oSelector["sInputState"] === "WARNING") {
			sImageClassName += "Warn";
			UCF_DomUtil["addClass"](oSelector["oFocusDomRef"], "urCLbl");
		} else {
			UCF_DomUtil["addClass"](oSelector["oFocusDomRef"], "urCLbl");
		}

		if (oSelector["sAssociatedEditContext"] === "PARENTREADONLY") {
			sImageClassName += "CtxtRo";
		} else if (oSelector["bReadonly"]) {
			sImageClassName += "Ro";
		}
	} else {
		sImageClassName += "Dsbl";
		UCF_DomUtil["addClass"](oSelector["oFocusDomRef"], "urCLblDsbl");
	}

	if (oSelector["bUsedInSapTable"]) {
		sImageClassName += " lsCWhlTbl";
	}

	//if (bHasText) sLabelClassName += " urCl1";

	if (this["oImageRef"]) {
		//IE9 bug I-4654763 2012 --
		//this.oImageRef.className = '';
		//this.oImageRef.className = sImageClassName;

		if (this["oImageRef"]["className"]["indexOf"]('LastAndStreched') > -1)
			sImageClassName += " lsCBImgLastAndStreched";

		UCF_DomUtil["setClass"](this["oImageRef"], sImageClassName);
	}

	// Image for Standard mode
	if (this["oImageStdRef"]) {

		var sDomRefClass = UCF_DomUtil["sGetClass"](this["oImageStdRef"]);

		if (oSelector["bEnabled"]) {
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgDsbl", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdRO", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdErr", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdInv", true);
			if (this["oSelector"]["bReadonly"]) {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "ls" + sClassId + "BImgDefHv", true);
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdRO");
			} else {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "ls" + sClassId + "BImgDefHv");
			}
			if (this["oSelector"]["sInputState"] === "ERROR") {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdErr");
			} else if (this["oSelector"]["sInputState"] === "WARNING") {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdInv");
			}
		} else {
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "ls" + sClassId + "BImgDefHv", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdRO", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdErr", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdInv", true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgDsbl");
			if (this["oSelector"]["sInputState"] === "ERROR") {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdErr");
			} else if (this["oSelector"]["sInputState"] === "WARNING") {
				sDomRefClass = this["maintainDomClass"](sDomRefClass, "lsCBImgStdInv");
			}
		}
		UCF_DomUtil["setClass"](this["oImageStdRef"], sDomRefClass);
	}

};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["applyStateToDom"] = 0; };
/**
 * Applys the selection class for the button in standards mode
 * @param {string} sClassId
 * @private
 */
UCF_CheckBoxDelegate_ie6["prototype"]["applySelection"] = function(sClassId) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["applySelection"]++; }; 
	if (!sClassId) sClassId = this["sClassId"];
	if (sClassId === 'TRI') sClassId = 'Tri';
	//if(!this.bEnabled || this.bReadonly)
	//	return;

	// change the Standard Classes
	var oSelector = this["oSelector"];
	var oImgDot = UCF_DomUtil["$"](oSelector["sId"] + '-imgSymb');
	if (oImgDot) {
		if (sClassId === 'Tri' || sClassId === 'TRI') {
			var sClassNameSel = "lsTriBImgSel",
				sClassNameSymbSel = "lsTriBImgSymb",
				sClassNameInd = "lsTriBImgInd",
				sClassNameSymbInd = "lsTriBImgSymbInd",
				sDomRefClass = UCF_DomUtil["sGetClass"](oImgDot);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSel, true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSymbSel, true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameInd, true);
			sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSymbInd, true);
			switch (this["oSelector"]["sState"]) {
				case "CHECKED":
					sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSel, false);
					sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSymbSel, false);
					break;
				case "UNCHECKED":
					break;
				case "INDETERMINATE":
					sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameInd, false);
					sDomRefClass = this["maintainDomClass"](sDomRefClass, sClassNameSymbInd, false);
					break;
			}
			UCF_DomUtil["setClass"](oImgDot, sDomRefClass);
		} else {
			var sClassName = "ls" + sClassId + "BImgSel";
			if (oSelector["bChecked"]) {
				if (!UCF_DomUtil["bHasClass"](oImgDot, sClassName))
					UCF_DomUtil["addClass"](oImgDot, sClassName);
			} else {
				UCF_DomUtil["removeClass"](oImgDot, sClassName);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["applySelection"] = 0; };

/**
 * Adds/removes the given class to the given domRef
 * @param {string} sDomRefClass
 * @param {string} sClassName
 * @param {boolean} bRemoveClass
 * @return {string} respective style
 * @private
 */
UCF_CheckBoxDelegate_ie6["prototype"]["maintainDomClass"] = function(sDomRefClass, sClassName, bRemoveClass) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["maintainDomClass"]++; }; 
	if (sDomRefClass != null && sClassName != null) {
		var oReg = new RegExp("(^| )" + sClassName + "( |$)"),
			bHasClass = sDomRefClass["match"](oReg);
		if (bHasClass) {
			if (bRemoveClass) {
				var aClassNames = sDomRefClass["split"](" ");

				for (var x = 0; x < aClassNames["length"]; x++) {
					var sName = aClassNames[x];
					if (sName === sClassName || sName === "") {
						aClassNames["splice"](x, 1);
						x--;
					}
				}
				sDomRefClass = aClassNames["join"](" ");
			}
		} else {
			if (!bRemoveClass) {
				sDomRefClass = sDomRefClass + " " + sClassName;
			}
		}
	}
	return sDomRefClass;
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["maintainDomClass"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 * @param {UCF_AccessibilityHelper} oAccessibilityHelper
 * @private
 */
UCF_CheckBoxDelegate_ie6["prototype"]["handleAccessibility"] = function(oAccessibilityHelper) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["handleAccessibility"]++; }; 

	var oSelector = this["oSelector"],
		eChecked = this["getValue"]();

	if (!oAccessibilityHelper) return;

	//Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](oSelector, "", "", oSelector["sText"]);
	oAccessibilityHelper["applyHighlightInfo"](oSelector["mGetHighlightInfo"]());
	oAccessibilityHelper["setAccessKey"](oSelector["sAccessKey"]);
	oAccessibilityHelper["setEnabled"](oSelector["bEnabled"]);
	oAccessibilityHelper["setReadonly"](oSelector["bReadonly"]);
	oAccessibilityHelper["setInvalid"](oSelector["bInvalid"]);

	if (eChecked === true) {
		oAccessibilityHelper["setChecked"](true);
	} else if (eChecked === false) {
		oAccessibilityHelper["setNotChecked"](true);
	} else if (eChecked === null) {
		oAccessibilityHelper["setMixed"](true);
	}

	if (this["oSelector"]["bInvalid"] || this["oSelector"]["sInputState"] === "ERROR") {
		oAccessibilityHelper["setInvalid"](true);
	} else if (this["oSelector"]["sInputState"] === "WARNING") {
		oAccessibilityHelper["setWarning"](true);
	}

	// data tip
	if (this["oSelector"]["oDataTip"]) {
		oAccessibilityHelper["setDataTip"](this["oSelector"]["oDataTip"]["sText"]);
	}

	oAccessibilityHelper["setTooltip"](this["oSelector"]["sTooltip"]);
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["handleAccessibility"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 * @return {HTMLelement}
 */
UCF_CheckBoxDelegate_ie6["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["oGetInplaceEditDomRef"]++; }; 
	var aSpans = this["oSelector"]["oRootRef"]["getElementsByTagName"]("SPAN");
	for (var i = 0; i < aSpans["length"]; i++) {
		if (aSpans[i]["getAttribute"]("iid") === "text") {
			return aSpans[i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["oGetInplaceEditDomRef"] = 0; };

/**
 * @see UCF_Control.sGetInplaceEditText
 * @return {string}
 */
UCF_CheckBoxDelegate_ie6["prototype"]["sGetInplaceEditText"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["sGetInplaceEditText"]++; }; 
	var oClientContol = this["oSelector"]["getClientControl"]();
	if (oClientContol) {
		if (oClientContol["getText"]()) {
			return oClientContol["getText"]();
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["sGetInplaceEditText"] = 0; };

/**
 * @see UCF_Control.setInplaceEditDomRef
 * @param {string} sText
 */
UCF_CheckBoxDelegate_ie6["prototype"]["setInplaceEditText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["setInplaceEditText"]++; }; 
	var oClientContol = this["oSelector"]["getClientControl"]();
	if (oClientContol) {
		oClientContol["setText"](sText);
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["setInplaceEditText"] = 0; };

/**
 * Check the text if rendered with ellipsis, and display it in tooltip
 * @private
 */
UCF_CheckBoxDelegate_ie6["prototype"]["applyTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["applyTooltip"]++; }; 
	var oSelector = this["oSelector"];
	if (window["UCF_System"]["bIs508"]) return;
	// the text will not be added to the Title when Wrapping=true and the
	if (!oSelector["bTextOverflow"] && oSelector["bWrapping"])
		return;

	var oDomRefTxt = UCF_DomUtil["$"](oSelector["sId"] + "-txt"),
		oDomRefContainer = UCF_DomUtil["$"](oSelector["sId"] + "-lbl");
	if (oSelector["bTextOverflow"]) {
		UCF_DomUtil["checkTooltip"](oDomRefContainer, oSelector["sTooltip"], oDomRefTxt);
	} else {
		UCF_DomUtil["checkTooltip"](oDomRefTxt, oSelector["sTooltip"], null);
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["applyTooltip"] = 0; };
/**
 * Handles the lsenter event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBoxDelegate_ie6["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBoxDelegate_ie6.js(518): onlsenter"); };

	if (this["oSelector"]["mEvents"]["Enter"]) {
		this["oSelector"]["fireEnter"](this["oSelector"]["sId"]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["onlsenter"] = 0; };

/**
 * @override
 * @see {UCF_Control}
 * @private
 */
UCF_CheckBoxDelegate_ie6["prototype"]["colorizeHighlightedText"] = function(iStart, iLength, sTextProperty, bFocused) {;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["colorizeHighlightedText"]++; }; 
	var oSelector = this["oSelector"];
	if (bFocused) {
		if (oSelector["oFocusDomRef"] && !UCF_DomUtil["bHasClass"](oSelector["oFocusDomRef"], 'lsHighlightTextFocus')) {
			UCF_DomUtil["addClass"](oSelector["oFocusDomRef"], 'lsHighlightTextFocus');
		}
	} else {
		if (oSelector["oFocusDomRef"] && !UCF_DomUtil["bHasClass"](oSelector["oFocusDomRef"], 'lsHighlightText')) {
			UCF_DomUtil["addClass"](oSelector["oFocusDomRef"], 'lsHighlightText');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxDelegate_ie6["_"]["colorizeHighlightedText"] = 0; };

UCF_CheckBoxDelegate_ie6.prototype["aPublicMethods"] = ["getValue","setValue","getEnabled","setEnabled","getEditable","setEditable","getValueState","setValueState"].concat(UCF_CheckBoxDelegate_ie6.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_CheckBoxGroup"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_CheckBoxGroup(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["UCF_CheckBoxGroup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "CheckBoxGroup.js(24): UCF_CheckBoxGroup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CheckBoxGroup.js(25): UCF_CheckBoxGroup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "CheckBoxGroup.js(26): UCF_CheckBoxGroup"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	if (!window["UCF_System"]["bIs508"]) {
		//var oControl=this.oGetFirstFocusableChild();
		//if (oControl) this.oFocusDomRef = oControl.oFocusDomRef;
	}

	// all checkBoxes of the group
	this["aCheckBoxes"] = new Array();

};window["UCF_CheckBoxGroup"] = UCF_CheckBoxGroup; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CheckBoxGroup"); UCF_CheckBoxGroup["_"] = {UCF_CheckBoxGroup: 0}; }; ;
UCF_CheckBoxGroup["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_CheckBoxGroup.prototype["sClassName"] = "UCF_CheckBoxGroup";

/**
 * Get all checkBoxes of the checkBox group.
 *
 * @return {Array} of checkBoxes in the group
 * @private
 */
UCF_CheckBoxGroup["prototype"]["aGetGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["aGetGroup"]++; }; 
	if (this["aCheckBoxes"]["length"] > 0)
		return this["aCheckBoxes"];

	var aCheckBoxesRef = this["oDomRef"]["getElementsByTagName"]("input"),
		j = 0;
	for (var i = 0; i < aCheckBoxesRef["length"]; i++) {
		if (UCF_DomUtil["bIsCTInstanceOf"](aCheckBoxesRef[i], "C")) {
			this["aCheckBoxes"][j] = this["oLS"]["oControlFactory"]["oGetControlById"](aCheckBoxesRef[i]["id"], true);
			j++;
		}
	}
	return this["aCheckBoxes"];
};;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["aGetGroup"] = 0; };

/**
 * Focusses the control
 * @private
 */
UCF_CheckBoxGroup["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["focus"]++; }; 

	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Focus " + this["sClassName"] + " \"" + this["sId"] + "\"", "CheckBoxGroup.js(68): focus"); };

	if (window["UCF_System"]["bIs508"]) {
		UCF_DomUtil["focusDomElement"](this["oFocusDomRef"]);
	} else {
		var oControl = this["oGetFirstFocusableChild"]();
		if (oControl && oControl["oFocusDomRef"]) UCF_DomUtil["focusDomElement"](oControl["oFocusDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["focus"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBoxGroup["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBoxGroup["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["onlsskipback"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBoxGroup["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBoxGroup.js(106): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	var oSource = oBrowserEvent["oGetSource"]();

	// checkbox group
	if (oSource === this["oDomRef"]) {
		// control type with item count
		var aCheckBoxes = oSource["getElementsByTagName"]("SPAN");
		var iItemCount = aCheckBoxes["length"] - 1;
		oAccessibilityHelper["setControlType"]("CG", new Array(iItemCount["toString"]()));

		//set disabled / readOnly if all items of the group are disabled / readOnly

		var setEnabled = true,
			setReadOnly = false,
			oCheckBox,
			iDisabled = 0,
			iReadonly = 0;

		for (var i = 0; i < iItemCount; i++) {
			oCheckBox = this["oLS"]["oControlFactory"]["oGetControlById"](aCheckBoxes[i]["getAttribute"]('id'));

			if (!oCheckBox) continue;

			if (oCheckBox["bEnabled"] === false) {
				iDisabled++;
			}

			if (oCheckBox["bReadonly"] === true) {
				iReadonly++;
			}
		}

		if (iDisabled === iItemCount) {
			setEnabled = false;
		}

		if (iReadonly === iItemCount) {
			setReadOnly = true;
		}

		oAccessibilityHelper["setEnabled"](setEnabled);
		oAccessibilityHelper["setReadonly"](setReadOnly);

		//Apply label and accDescription
		oAccessibilityHelper["applyLabelingInfo"](this, this["sAccessibilityDescription"]);

		// tutor text
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
	}
	// end point of checkbox group
	else {
		oAccessibilityHelper["setControlType"]("CG_END");
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_CheckBoxGroup["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["destroy"]++; }; 
	this["aCheckBoxes"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_CheckBoxGroup["prototype"]["aAttributeNames"] = ["sAccessibilityDescription","sVisibility","sCustomData","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_CheckBoxGroup["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_CheckBoxGroup["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_CheckBoxGroup["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_CheckBoxGroup["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_CheckBoxGroup["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_CheckBoxGroup["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_CheckBoxGroup["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["setDefaultValues"]++; }; 
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBoxGroup["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_CheckBox_ie6"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_CheckBoxDelegate_ie6 */
/// <reference path="./delegates/CheckBoxDelegate_ie6.js"/>
/* global UCF_CheckBox */
/// <reference path="./CheckBox.js"/>

/**
 * CheckBox control implementation
 * @class
 * @param {HTMLElement} oDomRef DOM reference
 * @param {UCF_LS} oLS LS instance
 */
function UCF_CheckBox_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["UCF_CheckBox_ie6"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "CheckBox_ie6.js(29): UCF_CheckBox_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CheckBox_ie6.js(30): UCF_CheckBox_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "CheckBox_ie6.js(31): UCF_CheckBox_ie6"); };

	UCF_CheckBox["apply"](this, [oDomRef, oLS]);
	this["oFocusDomRef"] = UCF_DomUtil["$"](this["sId"] + '-lbl');
	this["oCheckBoxBase"] = new (UCF_ClassLoader["oGetClass"]("UCF_CheckBoxDelegate_ie6"))(this);
	this["addDelegate"](this["oCheckBoxBase"]);

	this["bIsMouseOver"] = false;
};window["UCF_CheckBox_ie6"] = UCF_CheckBox_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CheckBox_ie6"); UCF_CheckBox_ie6["_"] = {UCF_CheckBox_ie6: 0}; }; ;
UCF_CheckBox_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_CheckBox"))(); UCF_CheckBox_ie6.prototype["sClassName"] = "UCF_CheckBox_ie6";

/**
 * Destructor
 * @private
 */
UCF_CheckBox_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["destroy"]++; }; 
	this["oCheckBoxBase"]["destroy"]();
	this["oCheckBoxBase"] = null;
	this["bChecked"] = null;
	UCF_CheckBox.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["destroy"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_ie6["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_ie6.js(60): onclick"); };
	if (!this["bEnabled"] || this["bReadonly"]) {
		if (UCF_UserAgent["bIsWebKit"]()) {
			oBrowserEvent["cancelBubble"]();
		}

		return;
	}

	this["oFocusDomRef"]["focus"]();
	this["toggle"]();
	if (UCF_UserAgent["bIsPhone"]() || UCF_UserAgent["bIsTablet"]()) {
		this["bIsMouseOver"] = false;
	}
	this["applyHoverState"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onclick"] = 0; };

/**
 * Handles the onmouse down event
 * @private
 * @param {oBrowserEvent} oBrowserEvent
 */
UCF_CheckBox_ie6["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_ie6.js(84): onmousedown"); };

	if (!this["bEnabled"] || this["bReadonly"]) {
		return;
	}
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onmousedown"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_ie6["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_ie6.js(100): ondblclick"); };

	if (this["mEvents"]["DoubleClick"]) {
		this["fireDoubleClick"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["ondblclick"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_ie6["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_ie6.js(115): onkeydown"); };

	if (!this["bEnabled"]) {
		return;
	}

	if (oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["SPACE"] && !oBrowserEvent["bAlt"]()) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onkeydown"] = 0; };

/**
 * Handles the onlsselect event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_ie6["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_ie6.js(134): onlsselect"); };
	if (!this["bEnabled"] || this["bReadonly"]) {
		return;
	}

	if (oBrowserEvent["iKeyCode"]() !== UCF_KeyCodes["ENTER"]) {
		this["toggle"]();
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onlsselect"] = 0; };

/**
 * Toggles checked state and updates the visual representation of the checkbox
 * @private
 */
UCF_CheckBox_ie6["prototype"]["toggle"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["toggle"]++; }; 
	if (this["oDataTip"] && this["oDataTip"]["sExplanationText"]) {
		this["oDataTip"]["close"]();
	}

	this["bChecked"] = !this["bChecked"];

	this["oCheckBoxBase"]["applyStateToDom"]('C');
	this["oCheckBoxBase"]["applySelection"]('C');

	this["fireChange"](this["sId"], this["bChecked"]);
	this["refocus"](this["oFocusDomRef"]);

	this["setClientProperty"]("Checked", this["bChecked"], true);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["toggle"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element
 * within the control gets the focus. The methods sets the tool tip for a
 * screen reader if the system runs in accessibility mode.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_ie6["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onlsaccessibility"]++; }; 
	var oAccessibilityHelper;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_ie6.js(177): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) {
		return;
	}

	oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	this["oCheckBoxBase"]["handleAccessibility"](oAccessibilityHelper);
	oAccessibilityHelper["setControlType"]('C');

	if (!this["bReadonly"]) {
		if (this["bChecked"]) {
			oAccessibilityHelper["addEnabledTutor"]('UNCHECK_TUT', this["bEnabled"]);
		} else {
			oAccessibilityHelper["addEnabledTutor"]('CHECK_TUT', this["bEnabled"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onlsaccessibility"] = 0; };

/**
 * Handles the onlsfocus event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_ie6["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onlsfocus"]++; }; 
	var oCheckBoxesData;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_ie6.js(205): onlsfocus"); };

	if (!this["bEnabled"]) {
		return;
	}

	if (window["UCF_System"]["bIsAria"]) {
		if (this["oDataTip"]) {
			this["applyAriaDataTipInfo"]();
		}

		oCheckBoxesData = this["oGetCheckBoxes"]();

		if (oCheckBoxesData["iSizeOfSet"] == null) {
			return;
		}
		UCF_AriaStateHelper["setPosinset"](UCF_DomUtil["$"](this["oDomRef"]["id"] + '-lbl'),
			oCheckBoxesData["iPosInSet"]);

		UCF_AriaStateHelper["setSetsize"](UCF_DomUtil["$"](this["oDomRef"]["id"] + '-lbl'),
			oCheckBoxesData["iSizeOfSet"]);
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onlsfocus"] = 0; };

UCF_CheckBox_ie6["prototype"]["oGetCheckBoxes"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["oGetCheckBoxes"]++; }; 

	var oCheckBoxGroup = this["oGetParent"](),
		oCheckBoxesData = { 'iSizeOfSet': '', 'iPosInSet': '' },
		aCollectedCheckBoxes, i;

	if (oCheckBoxGroup && oCheckBoxGroup["sClassName"] === 'UCF_CheckBoxGroup') {
		aCollectedCheckBoxes = oCheckBoxGroup["oDomRef"]["getElementsByTagName"]('INPUT');
	} else {
		aCollectedCheckBoxes = document["getElementsByName"](this["sName"]);
	}

	if (!aCollectedCheckBoxes || aCollectedCheckBoxes["length"] === 0) {
		oCheckBoxesData["iSizeOfSet"] = null;

		return oCheckBoxesData;
	}

	for (i = 0; i < aCollectedCheckBoxes["length"]; i++) {
		if (this["sId"] === aCollectedCheckBoxes[i]["getAttribute"]('id')) {
			oCheckBoxesData["iSizeOfSet"] = aCollectedCheckBoxes["length"];
			oCheckBoxesData["iPosInSet"] = i + 1;
			break;
		}
	}

	return oCheckBoxesData;
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["oGetCheckBoxes"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_ie6["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_ie6.js(265): onmouseover"); };

	this["bIsMouseOver"] = true;
	this["applyHoverState"]();

	this["oCheckBoxBase"]["applyTooltip"]('C');

	if (window["UCF_System"]["bIsAria"]) {
		if (this["oDataTip"]) {
			this["applyAriaDataTipInfo"]();
		}
	}

};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onmouseover"] = 0; };

/**
 * Applies the hover style
 * @private
 */
UCF_CheckBox_ie6["prototype"]["applyHoverState"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["applyHoverState"]++; }; 
	var oImg, sClasses, sState;

	if (this["bReadonly"] || !this["bEnabled"])
		return;

	if (this["bIsMouseOver"] === true) {
		oImg = UCF_DomUtil["$"](this["sId"] + '-img');
		if (!oImg)
			return;
		sClasses = UCF_DomUtil["sGetClass"](oImg);
		if (sClasses["indexOf"]('Hover') !== -1)
			return;
		sState = this["oCheckBoxBase"]["getValueState"]();
		if ('NONE' === sState) {
			if (this["bChecked"])
				sClasses += ' urCImgOnHover';
			else
				sClasses += ' urCImgOffHover';
		} else if ('ERROR' === sState) {
			if (this["bChecked"])
				sClasses += ' urCImgOnInvHover';
			else
				sClasses += ' urCImgOffInvHover';
		} else if ('WARNING' === sState) {
			if (this["bChecked"])
				sClasses += ' urCImgOnWarnHover';
			else
				sClasses += ' urCImgOffWarnHover';
		}
		UCF_DomUtil["setClass"](oImg, sClasses);
	} else {
		oImg = UCF_DomUtil["$"](this["sId"] + '-img');
		if (!oImg)
			return;
		sClasses = UCF_DomUtil["sGetClass"](oImg);
		if (sClasses["indexOf"]('Hover') === -1)
			return;
		var aClasses = sClasses["split"](' ');
		var sClassName = aClasses[0];
		for (var i = 1; i < aClasses["length"] - 1; i++)
			sClassName = sClassName + ' ' + aClasses[i];
		UCF_DomUtil["setClass"](oImg, sClassName);
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["applyHoverState"] = 0; };

/**
 *Handles the onmouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_ie6["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_ie6.js(337): onmouseout"); };

	this["bIsMouseOver"] = false;
	this["applyHoverState"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["onmouseout"] = 0; };

/**
 * Adds the data tip id to the DOM in aria-describedby attribute
 * @private
 */
UCF_CheckBox_ie6["prototype"]["applyAriaDataTipInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["applyAriaDataTipInfo"]++; }; 
	var id;

	if (window["UCF_System"]["bIsAria"]) {
		id = this["sId"] + '-lbl';
		if (this["oDomRef"]["id"]) {
			UCF_AriaStateHelper["addDescribedby"](UCF_DomUtil["$"](id),
				this["oDomRef"]["id"] + '-dtip');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["applyAriaDataTipInfo"] = 0; };

UCF_CheckBox_ie6["prototype"]["setValue"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["setValue"]++; }; 
	this["oCheckBoxBase"]["setValue"](bValue);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["setValue"] = 0; };

UCF_CheckBox_ie6["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["getValue"]++; }; 
	return this["oCheckBoxBase"]["getValue"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["getValue"] = 0; };

UCF_CheckBox_ie6["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["getEnabled"]++; }; 
	return this["oCheckBoxBase"]["getEnabled"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["getEnabled"] = 0; };

UCF_CheckBox_ie6["prototype"]["setEnabled"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["setEnabled"]++; }; 
	return this["oCheckBoxBase"]["setEnabled"](bValue);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["setEnabled"] = 0; };

UCF_CheckBox_ie6["prototype"]["getEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["getEditable"]++; }; 
	return this["oCheckBoxBase"]["getEditable"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["getEditable"] = 0; };

UCF_CheckBox_ie6["prototype"]["setEditable"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["setEditable"]++; }; 
	this["oCheckBoxBase"]["setEditable"](bValue);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["setEditable"] = 0; };

UCF_CheckBox_ie6["prototype"]["getValueState"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["getValueState"]++; }; 
	return this["oCheckBoxBase"]["getValueState"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["getValueState"] = 0; };

UCF_CheckBox_ie6["prototype"]["setValueState"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["setValueState"]++; }; 
	this["oCheckBoxBase"]["setValueState"](sValue);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["setValueState"] = 0; };

/**
 * @private
 * @see UCF_DTExtension
 * @param {UCF_DataTip} oDTElement
 */
UCF_CheckBox_ie6["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["oGetDTExtension"]++; }; 
	//	return _super(oDTElement, UCF_ClassLoader.oGetClass('UCF_CheckBoxDTExtension"));
};;if (__UCF_COVERAGE__) { UCF_CheckBox_ie6["_"]["oGetDTExtension"] = 0; };

};
sap["ls"]["preload"]["UCF_CheckBox_standards"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_SelectorDelegate */
/// <reference path="./delegates/SelectorDelegate.js"/>
/* global UCF_Selector_508_Delegate */
/// <reference path="./delegates/Selector_508_Delegate.js"/>
/* global UCF_CheckBox */
/// <reference path="./CheckBox.js"/>

/**
 * CheckBox control implementation for standards rendering mode
 * @class
 * @param {HTMLElement} oDomRef DOM reference
 * @param {UCF_LS} oLS LS instance
 */
function UCF_CheckBox_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["UCF_CheckBox_standards"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "CheckBox_standards.js(29): UCF_CheckBox_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "CheckBox_standards.js(30): UCF_CheckBox_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "CheckBox_standards.js(31): UCF_CheckBox_standards"); };
	UCF_CheckBox["apply"](this, [oDomRef, oLS]);

	this["defineEvents"](['Select']);

	/** @type {HTML_Element} */
	this["oFocusDomRef"] = this["oDomRef"];
	this["sFocusType"] = 'NAVIGATION';
	this["oData"] = null;
	this["oCheckBoxBase"] = new (UCF_ClassLoader["oGetClass"]("UCF_SelectorDelegate"))(this);
	this["addDelegate"](this["oCheckBoxBase"]);

	if (window["UCF_System"]["bIs508"]) {
		this["Delegate_508"] = new (UCF_ClassLoader["oGetClass"]("UCF_Selector_508_Delegate"))(this);
		this["addDelegate"](this["Delegate_508"]);
	}
};window["UCF_CheckBox_standards"] = UCF_CheckBox_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_CheckBox_standards"); UCF_CheckBox_standards["_"] = {UCF_CheckBox_standards: 0}; }; ;
UCF_CheckBox_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_CheckBox"))(); UCF_CheckBox_standards.prototype["sClassName"] = "UCF_CheckBox_standards";

/**
 * ############################################################################
 *
 * SECTION RESPONSIBLE FOR SELECTION
 *
 * ############################################################################
 */

/**
 * determines why the control has received its last focus
 * @private
 */
UCF_CheckBox_standards["prototype"]["eFocusType"] = {
	"NAVIGATION": 'NAVIGATION',
	"REFOCUSED": 'REFOCUSED'
};

/**
 * determines why the control has received its last focus
 * @private
 */
UCF_CheckBox_standards["prototype"]["eControlUsage"] = {
	"API_DRIVEN": 'API_DRIVEN',
	"FRAGMENT_DRIVEN": 'FRAGMENT_DRIVEN',
	"UNKNOWN": 'UNKNOWN'
};

/**
 * retries a data set from HTML and creates an object
 * @private
 */
UCF_CheckBox_standards["prototype"]["oGetData"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["oGetData"]++; }; 
	var oDataSet = UCF_DomUtil["dataset"](this["oDomRef"]);
	var oData = {};
	var key;

	for (key in oDataSet) {
		oData[key] = oDataSet[key];
	}
	this["oData"] = oData;
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["oGetData"] = 0; };

/**
 * Handles the onlsselect event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_standards["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_standards.js(99): onlsselect"); };

	// --- return if element is not selectable
	if (!this["oCheckBoxBase"]["bIsSelectable"]()) {
		return;
	}

	//--- toggle selection state
	if (oBrowserEvent["iKeyCode"]() !== UCF_KeyCodes["ENTER"]) {
		this["oGetData"]();
		this["toggle"]();
		this["fireInternalEvent"]();

		// --- refocus to get Jaws to anounce new state
		if (this["oCheckBoxBase"]["bAccModeOn"]()) {
			this["sFocusType"] = this["eFocusType"]["REFOCUSED"];
			UCF_DomUtil["refocusDomElement"](this["oFocusDomRef"]);
		}
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onlsselect"] = 0; };
/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_standards["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_standards.js(128): onclick"); };
	if (this["oDataTip"] && this["oDataTip"]["sExplanationText"]) {
		this["oDataTip"]["close"]();
	}
	if (this["oCheckBoxBase"]["bIsSelectable"]()) {
		this["oGetData"]();
		this["toggle"]();
		this["fireInternalEvent"]();
		// --
		if (this["oCheckBoxBase"]["bAccModeOn"]()) {
			this["sFocusType"] = this["eFocusType"]["REFOCUSED"];
			UCF_DomUtil["refocusDomElement"](this["oFocusDomRef"]);
		}
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onclick"] = 0; };

/**
 * Toggles checked state and updates the visual representation of the checkbox
 * @private
 * @param {boolean} bSwitchTo
 */
UCF_CheckBox_standards["prototype"]["toggle"] = function(bSwitchTo) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["toggle"]++; }; 

	var oCheckBoxBase = this["oCheckBoxBase"];
	var Style_Factory = oCheckBoxBase["styleFactory"]["bind"](this["oCheckBoxBase"]);
	var toggleMethods = oCheckBoxBase["toggleMethods"];
	var eSelectionState = oCheckBoxBase["eSelectionState"];
	var bSwitchToState;

	if (bSwitchTo === null ||
		bSwitchTo === 'undefined' ||
		bSwitchTo === undefined) {
		bSwitchToState = !this["bChecked"];
	} else {
		bSwitchToState = bSwitchTo;
	}

	if (bSwitchToState) {
		Style_Factory(toggleMethods["switchSelectionState"]["bind"](this["oCheckBoxBase"]),
			this, eSelectionState["SELECTED"]);
	} else {
		Style_Factory(toggleMethods["switchSelectionState"]["bind"](this["oCheckBoxBase"]),
			this, eSelectionState["UNSELECTED"]);
	}
	this["bChecked"] = (bSwitchToState) ? bSwitchToState : !this["bChecked"];
	this["setClientProperty"]("Value", this["bChecked"], true);
	this["setClientProperty"]("Checked", this["bChecked"], true);
	this["oCheckBoxBase"]["updateAriaInfo"](this);

	// -- refocus to get Jaws to announce new states
	// if (UCF_System.bIs508 || UCF_System.bIsAria){
	// 			UCF_DomUtil.refocusDomElement(this.oFocusDomRef);
	// }

	this["fireChange"](this["sId"], this["bChecked"]);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["toggle"] = 0; };

/**
 * Fires when control is FRAGMENT_DRIVEN, i.e. when it is used internally
 * by another control such as the sap table for its own purpose
 * @private
 */
UCF_CheckBox_standards["prototype"]["fireInternalEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["fireInternalEvent"]++; }; 
	/** @type {Object} */
	var oData = this["oData"];
	/** @type {enum-value} */
	var sSelectionState;
	/** @type {enum-list} */
	var eSelectionState;

	if (oData["controlusage"] === this["eControlUsage"]["API_DRIVEN"]) return;

	eSelectionState = this["oCheckBoxBase"]["eSelectionState"];

	switch (oData["selectionstate"]) {
		case eSelectionState["UNCHECKED"]:
			sSelectionState = eSelectionState["CHECKED"];
			break;
		case eSelectionState["CHECKED"]:
			sSelectionState = eSelectionState["UNCHECKED"];
			break;
		case eSelectionState["SAPTABLE_PRIMARY_SELECTED"]:
			sSelectionState = eSelectionState["SAPTABLE_PRIMARY_UNSELECTED"];
			break;
		case eSelectionState["SAPTABLE_SECONDARY_SELECTED"]:
			sSelectionState = eSelectionState["SAPTABLE_SECONDARY_UNSELECTED"];
			break;
		case eSelectionState["SAPTABLE_PRIMARY_UNSELECTED"]:
			sSelectionState = eSelectionState["SAPTABLE_PRIMARY_SELECTED"];
			break;
		case eSelectionState["SAPTABLE_SECONDARY_UNSELECTED"]:
			sSelectionState = eSelectionState["SAPTABLE_SECONDARY_SELECTED"];
			break;
	}

	oData["selectionstate"] = sSelectionState;
	this["oDomRef"]["setAttribute"]('data-selectionstate', sSelectionState);

	this["fireEvent"](this["E_EVENTS"]["Select"], {
		"sId": this["sId"],
		"sSelectionState": sSelectionState
	});
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["fireInternalEvent"] = 0; };

/**
 * A compiled list with all styles relevant for selection
 * and deselection
 *
 * @private
 */
UCF_CheckBox_standards["prototype"]["eStyles"] = {
	'SELECTED_ENABLED': 'lsCheckBox--checked',
	'UNSELECTED_ENABLED': 'lsCheckBox--unchecked',
	'SELECTED_READONLY': 'lsCheckBox--checked--readOnly',
	'UNSELECTED_READONLY': 'lsCheckBox--unchecked--readOnly',
	'SELECTED_ERROR_ENABLED': 'lsCheckBox--checked--error',
	'UNSELECTED_ERROR_ENABLED': 'lsCheckBox--unchecked--error',
	'SELECTED_WARNING_ENABLED': 'lsCheckBox--checked--warning',
	'UNSELECTED_WARNING_ENABLED': 'lsCheckBox--unchecked--warning',
	'SELECTED_PARENT_READONLY': 'lsCheckBox--checked--parentReadOnly',
	'UNSELECTED_PARENT_READONLY': 'lsCheckBox--unchecked--parentReadOnly',
	'SELECTED_ERROR_READONLY': 'lsCheckBox--checked--error--readOnly',
	'UNSELECTED_ERROR_READONLY': 'lsCheckBox--unchecked--error--readOnly',
	'SELECTED_WARNING_READONLY': 'lsCheckBox--checked--warning--readOnly',
	'UNSELECTED_WARNING_READONLY': 'lsCheckBox--unchecked--warning--readOnly',
	'SELECTED_DISABLED': 'lsCheckBox--checked--disabled',
	'UNSELECTED_DISABLED': 'lsCheckBox--unchecked--disabled',
	'SAPTABLE_PRIMARY_SELECTED': 'lsSelector--sapTablePrimarySelection',
	'SAPTABLE_PRIMARY_UNSELECTED': 'lsSelector--sapTablePrimarySelection',
	'SAPTABLE_SECONDARY_SELECTED': 'lsSelector--sapTableSecondarySelection',
	'SAPTABLE_SECONDARY_UNSELECTED': 'lsSelector--sapTableSecondarySelection',
	'SELECTOR_BASE': 'lsSelector--generic'
};

/**
 * ############################################################################
 *
 * SECTION WITH ALL PUBLIC APIS
 *
 * ############################################################################
 */

/**
 * @param { enum-value } sNewState the new value
 * @public
 */
UCF_CheckBox_standards["prototype"]["setSelectionState"] = function(sNewState) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["setSelectionState"]++; }; 

	var oCheckBoxBase = this["oCheckBoxBase"];
	var Style_Factory = oCheckBoxBase["styleFactory"]["bind"](this["oCheckBoxBase"]);
	var toggleMethods = oCheckBoxBase["toggleMethods"];
	var eBaseStyles = oCheckBoxBase["eBaseStyles"];
	var sBaseStyle;

	this["oGetData"]();

	switch (sNewState) {
		case 'CHECKED':
			this["setValue"](true);
			sBaseStyle = eBaseStyles["SELECTOR_BASE"];
			break;

		case 'SAPTABLE_PRIMARY_SELECTED':
		case 'SAPTABLE_SECONDARY_SELECTED':
			this["setValue"](true);
			sBaseStyle = eBaseStyles[sNewState];
			break;

		case 'UNCHECKED':
			this["setValue"](false);
			sBaseStyle = eBaseStyles["SELECTOR_BASE"];
			break;

		case 'SAPTABLE_PRIMARY_UNSELECTED':
		case 'SAPTABLE_SECONDARY_UNSELECTED':
			this["setValue"](false);
			sBaseStyle = eBaseStyles[sNewState];
			break;
	}

	Style_Factory(toggleMethods["switchBaseClass"]["bind"](this["oCheckBoxBase"]),
		this,
		sBaseStyle);

	this["oData"]["selectionstate"] = sNewState;
	this["oDomRef"]["setAttribute"]('data-selectionstate', sNewState);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["setSelectionState"] = 0; };

/**
 * Set the value of the CheckBox, true=selected; false=deselected
 * @return {enum-value} the current state
 * @public
 */
UCF_CheckBox_standards["prototype"]["getSelectionState"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["getSelectionState"]++; }; 
	/** @type {string} determines field in style enum of selector */
	return this["oData"]["selectionstate"];
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["getSelectionState"] = 0; };

/**
 * Set the value of the CheckBox, true=selected; false=deselected
 * @param {boolean} bSetToChecked the new value
 * @public
 */
UCF_CheckBox_standards["prototype"]["setValue"] = function(bSetToChecked) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["setValue"]++; }; 
	if (this["bChecked"] !== bSetToChecked) {
		this["toggle"](bSetToChecked);
		this["oCheckBoxBase"]["updateAriaInfo"](this);
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["setValue"] = 0; };
/**
 * Returns the value of the CheckBox, true=checked; false=not checked
 * @return {boolean} The value of the CheckBox,
 * true=checked; false=not checked
 * @public
 */
UCF_CheckBox_standards["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["getValue"]++; }; 
	return this["oCheckBoxBase"]["getValue"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["getValue"] = 0; };
/**
 * Get enabled
 * @return {boolean} the enabled state
 * @public
 */
UCF_CheckBox_standards["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["getEnabled"]++; }; 
	return this["oCheckBoxBase"]["getEnabled"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["getEnabled"] = 0; };
/**
 * Set enabled
 * @param {boolean} bEnabled the new enabled value
 * @public
 */
UCF_CheckBox_standards["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["setEnabled"]++; }; 
	this["oCheckBoxBase"]["setEnabled"](bEnabled);
	this["oCheckBoxBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["setEnabled"] = 0; };
/**
 * Get the editable state of the checkbox
 * @return {boolean} the editable state
 * @public
 */
UCF_CheckBox_standards["prototype"]["getEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["getEditable"]++; }; 
	return this["oCheckBoxBase"]["getEditable"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["getEditable"] = 0; };
/**
 * Set the editable state of the checkbox
 *
 * @param {boolean} bValue the new editable value
 * @public
 */
UCF_CheckBox_standards["prototype"]["setEditable"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["setEditable"]++; }; 
	this["oCheckBoxBase"]["setEditable"](bValue);
	this["oCheckBoxBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["setEditable"] = 0; };
/**
 * Gets the value state of this checkbox
 * @return {string} the required state
 * @public
 */
UCF_CheckBox_standards["prototype"]["getValueState"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["getValueState"]++; }; 
	return this["oCheckBoxBase"]["getValueState"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["getValueState"] = 0; };
/**
 * Sets the input state of the checkbox
 * @param {string} sValue state
 * @public
 */
UCF_CheckBox_standards["prototype"]["setValueState"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["setValueState"]++; }; 
	this["oCheckBoxBase"]["setValueState"](sValue);
	this["oCheckBoxBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["setValueState"] = 0; };
/**
 * ###########################################################################
 *
 * SECTION WITH GENERICALLY USED MOUSE EVENTS
 *
 * ###########################################################################
 */
/**
 * Handles the onmouse down event
 * @private
 * @param {oBrowserEvent} oBrowserEvent
 */
UCF_CheckBox_standards["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_standards.js(412): onmousedown"); };
	if (!this["bEnabled"] || this["bReadonly"]) {
		return;
	}
	if (this["oCheckBoxBase"]["bIsSelectable"]() && this["oCheckBoxBase"]["bAccModeOn"]()) {
		UCF_DomUtil["focusDomElement"](this["oFocusDomRef"]);
		this["sFocusType"] = this["eFocusType"]["REFOCUSED"];
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onmousedown"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_standards["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_standards.js(430): ondblclick"); };
	if (this["mEvents"]["DoubleClick"]) {
		this["fireDoubleClick"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["ondblclick"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_standards["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_standards.js(444): onkeydown"); };
	if (!this["bEnabled"]) {
		return;
	}

	if (oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["SPACE"] &&
		!oBrowserEvent["bAlt"]()) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onkeydown"] = 0; };
/**
 * ############################################################################
 *
 * SECTION RESPONSIBLE FOR ACC BE IT 508 OR ARIA
 *
 * ###########################################################################
 */
/**


/**
 * Handles the onlsfocus event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_standards["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_standards.js(472): onlsfocus"); };
	// --
	if (window["UCF_System"]["bIsAria"]) {
		this["oCheckBoxBase"]["updateAriaInfo"](this);
	}
	this["sFocusType"] = this["eFocusType"]["NAVIGATION"];
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onlsfocus"] = 0; };

/**
 * @private
 * @param {UCF_Control} oDTElement
 * @return {class}
 */
UCF_CheckBox_standards["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["oGetDTExtension"]++; }; 
	return UCF_CheckBox.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]('UCF_CheckBoxDTExtension'));
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["oGetDTExtension"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_CheckBox_standards["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "CheckBox_standards.js(496): onmouseover"); };

	this["oCheckBoxBase"]["applyTooltip"]();
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["onmouseover"] = 0; };

/**
 * ###########################################################################
 *
 * SECTION RESPONSIBLE FOR DESTRUCTION OF THE CONTROL
 *
 * ###########################################################################
 */
/**
 * Destructor
 * @private
 */
UCF_CheckBox_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["destroy"]++; }; 
	this["oCheckBoxBase"]["destroy"]();
	this["oCheckBoxBase"] = null;
	this["sFocusType"] = null;
	if (this["Delegate_508"]) {
		this["Delegate_508"]["destroy"]();
		this["Delegate_508"] = null;
	}
	this["bChecked"] = null;
	this["oData"] = null;
	UCF_CheckBox.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_CheckBox_standards["_"]["destroy"] = 0; };

UCF_CheckBox_standards.prototype["aPublicMethods"] = ["setSelectionState","getSelectionState","setValue","getValue","getEnabled","setEnabled","getEditable","setEditable","getValueState","setValueState"].concat(UCF_CheckBox_standards.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ChildLayerDelegate"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>

/**
 * @class
 * @extends UCF_Object
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_LayeredControl} oParentLayer
 */
function UCF_ChildLayerDelegate(oLS, oParentLayer) {if (__UCF_COVERAGE__) { UCF_ChildLayerDelegate["_"]["UCF_ChildLayerDelegate"]++; }; 
	/** @type {UCF_LS} */
	this["oLS"] = oLS;
	/** @type {UCF_LayeredControl} */
	this["oParentLayer"] = oParentLayer;
};window["UCF_ChildLayerDelegate"] = UCF_ChildLayerDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ChildLayerDelegate"); UCF_ChildLayerDelegate["_"] = {UCF_ChildLayerDelegate: 0}; }; ;
UCF_ChildLayerDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_ChildLayerDelegate.prototype["sClassName"] = "UCF_ChildLayerDelegate";

/** @override */
UCF_ChildLayerDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ChildLayerDelegate["_"]["destroy"]++; }; 
	this["oParentLayer"] = null;
	this["oLS"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ChildLayerDelegate["_"]["destroy"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ChildLayerDelegate["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ChildLayerDelegate["_"]["onmouseover"]++; }; 
	this["oParentLayer"]["notifyChildLayerMouseOver"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ChildLayerDelegate["_"]["onmouseover"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ChildLayerDelegate["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ChildLayerDelegate["_"]["onmouseout"]++; }; 
	this["oParentLayer"]["notifyChildLayerMouseOut"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ChildLayerDelegate["_"]["onmouseout"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientAccordion"] = function() { var UCF_ClientAccordion = window["UCF_ClientAccordion"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientAccordion"); UCF_ClientAccordion["_"] = {UCF_ClientAccordion: 0}; };/* global UCF_ClientAccordion */
UCF_ClientAccordion["prototype"]["getSelectedItemId"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientAccordion["_"]["getSelectedItemId"]++; }; 
	return this["getAggregation"]("Items")[this["getSelectedItemIndex"]()]["sId"];
};;if (__UCF_COVERAGE__) { UCF_ClientAccordion["_"]["getSelectedItemId"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientButton"] = function() { var UCF_ClientButton = window["UCF_ClientButton"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientButton"); UCF_ClientButton["_"] = {UCF_ClientButton: 0}; };/* global UCF_ClientButton */
UCF_ClientButton["prototype"]["setVisibility"] = function(sVisibility, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientButton["_"]["setVisibility"]++; }; 
	return this["setUCFProperty"]("Visibility", sVisibility, bSuppressRerendering, "setVisibility");
};;if (__UCF_COVERAGE__) { UCF_ClientButton["_"]["setVisibility"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientDTContainer"] = function() { var UCF_ClientDTContainer = window["UCF_ClientDTContainer"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientDTContainer"); UCF_ClientDTContainer["_"] = {UCF_ClientDTContainer: 0}; };/* global UCF_ClientDTContainer */

UCF_ClientDTContainer["prototype"]["bHideNoneMatchingElements"] = true;
UCF_ClientDTContainer["prototype"]["bPersonasEnabled"] = false;
UCF_ClientDTContainer["prototype"]["bHideControlOnDragStart"] = false;

/**
 * This specifies an (additional) hover-effect that uses CSS 'outline' (class lsDTHoverOutline).
 * It is incompatible with API-parameter 'Outline'.
 */
UCF_ClientDTContainer["prototype"]["bHoverOutline"] = false;

/**
 * Each DTElement that has a DragSourceInfo will have a move-cursor when selected.
 */
UCF_ClientDTContainer["prototype"]["bMoveCursorForSelectedElement"] = false;

/**
 * Special handling of RasterLayouts for Personas-WDA.
 */
UCF_ClientDTContainer["prototype"]["bEnableRasterLayoutGridMode"] = false;

UCF_ClientDTContainer["prototype"]["aPublicMethods"] = ["bHideNoneMatchingElements","bPersonasEnabled","bHideControlOnDragStart","setHideControlOnDragStart","hideControlOnDragStart", "resumeUpdates","pauseUpdates"];

UCF_ClientDTContainer["prototype"]["setHideControlOnDragStart"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_ClientDTContainer["_"]["setHideControlOnDragStart"]++; }; 
	this["bHideConrolOnDragStart"] = bValue;
};;if (__UCF_COVERAGE__) { UCF_ClientDTContainer["_"]["setHideControlOnDragStart"] = 0; };
UCF_ClientDTContainer["prototype"]["hideControlOnDragStart"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDTContainer["_"]["hideControlOnDragStart"]++; }; 
	return this["bHideConrolOnDragStart"];
};;if (__UCF_COVERAGE__) { UCF_ClientDTContainer["_"]["hideControlOnDragStart"] = 0; };

UCF_ClientDTContainer["prototype"]["pauseUpdates"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDTContainer["_"]["pauseUpdates"]++; }; 
	if (this["getUCFInstance"]()) {
		this["getUCFInstance"]()["bPausePositioning"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTContainer["_"]["pauseUpdates"] = 0; };

UCF_ClientDTContainer["prototype"]["resumeUpdates"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDTContainer["_"]["resumeUpdates"]++; }; 
	if (this["getUCFInstance"]()) {
		this["getUCFInstance"]()["bPausePositioning"] = false;
		this["getUCFInstance"]()["updatePositions"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTContainer["_"]["resumeUpdates"] = 0; };

UCF_ClientDTContainer["prototype"]["fireMove"] = function (iPageX, iPageY, oDTMovedElement, oTargetElement, oOriginalTargetElement){;if (__UCF_COVERAGE__) { UCF_ClientDTContainer["_"]["fireMove"]++; }; 
	if (this["getUCFInstance"]()) {
		var bNoOriginalTarget = (typeof(oOriginalTargetElement) === "undefined" || typeof(oOriginalTargetElement) === "boolean");
		this["getUCFInstance"]()["fireMove"](iPageX, iPageY, oDTMovedElement["getUCFInstance"](), oTargetElement["getUCFInstance"](), bNoOriginalTarget ? undefined : oOriginalTargetElement["getUCFInstance"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTContainer["_"]["fireMove"] = 0; };



};
sap["ls"]["preload"]["UCF_ClientDTElement"] = function() { var UCF_ClientDTElement = window["UCF_ClientDTElement"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientDTElement"); UCF_ClientDTElement["_"] = {UCF_ClientDTElement: 0}; };/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_ClientElement */
/// <reference path="../core/ClientElement.js"/>

/* global UCF_ClientDTElement */
UCF_ClientDTElement["prototype"]["onAfterRendering"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["onAfterRendering"]++; }; 
	UCF_JsUtil["delayedCall"](500, this, "doAfterRendering");
	UCF_ClientElement["prototype"]["onAfterRendering"]["apply"](this);
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["onAfterRendering"] = 0; };

UCF_ClientDTElement["prototype"]["aPublicMethods"] = ["updatePosition", "setControlIds", "setKeepRatio", "removeCustomStyle", "addCustomStyle", "showAction", "hideAction", "removeAction", "addAction", "setResizeHandleWest", "setResizeHandleEast", "setResizeHandleNorth", "setInplaceEditable", "getConnectedClientControl", "getConnectedCustomData", "isConnectedControlInvisible", "hideResizeHandles", "showResizeHandles", "setTooltip", "setHiddenDesign", "hasHiddenDesign", "setResizeHandleSouth"];

UCF_ClientDTElement["prototype"]["doAfterRendering"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["doAfterRendering"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		// Workaround for unnecessary scrollbars, see also DTElement.init
		if (oUCFInstance["bIsScrollElement"] && UCF_UserAgent["bIsChromium"]()) {
			if (oUCFInstance["oDomRef"]) {
				// Chrome would still show some unnecessary scrollbars: Keep overflow:hidden if the original ScrollContainer has ScrollingMode=NONE
				// and no "layered" element (this may happen in FMP screens)
				if (oUCFInstance["oDomRef"]["firstChild"]["id"] && oUCFInstance["oDomRef"]["firstChild"]["id"]["indexOf"]("-layered") > -1) {
					oUCFInstance["oDomRef"]["style"]["overflow"] = "auto";
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["doAfterRendering"] = 0; };

UCF_ClientDTElement["prototype"]["setControlIds"] = function(sControlIds, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setControlIds"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance && bSuppressRerendering) {
		oUCFInstance["sControlIds"] = sControlIds;
		this["setProperty"]("ControlIds", sControlIds, true);
		return;
	}
	this["setProperty"]("ControlIds", sControlIds, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setControlIds"] = 0; };

UCF_ClientDTElement["prototype"]["setKeepRatio"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setKeepRatio"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		if (bValue != this["getKeepRatio"]()) {
			this["setProperty"]("KeepRatio", bValue, true);
			oUCFInstance["setKeepRatio"](bValue);
		}
		return;
	}
	this["setProperty"]("KeepRatio", bValue, true);
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setKeepRatio"] = 0; };

UCF_ClientDTElement["prototype"]["removeCustomStyle"] = function(sCustomStyle, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["removeCustomStyle"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		UCF_DomUtil["removeClass"](oUCFInstance["oDomRef"], sCustomStyle);
		if (this["hasCustomStyle"](sCustomStyle)) {
			this["setProperty"]("CustomStyle", UCF_StringUtil["sTrim"]((" " + this["getCustomStyle"]() + " ")["replace"](" " + sCustomStyle + " ", " ")), true);
		}
	} else {
		if (this["hasCustomStyle"](sCustomStyle)) {
			this["setProperty"]("CustomStyle", UCF_StringUtil["sTrim"]((" " + this["getCustomStyle"]() + " ")["replace"](" " + sCustomStyle + " ", " ")), bSuppressRerendering);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["removeCustomStyle"] = 0; };

UCF_ClientDTElement["prototype"]["addCustomStyle"] = function(sCustomStyle, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["addCustomStyle"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		UCF_DomUtil["addClass"](oUCFInstance["oDomRef"], sCustomStyle);
		if (!this["hasCustomStyle"](sCustomStyle)) {
			this["setProperty"]("CustomStyle", this["getCustomStyle"]() + " " + sCustomStyle, true);
		}
	} else {
		if (!this["hasCustomStyle"](sCustomStyle)) {
			this["setProperty"]("CustomStyle", this["getCustomStyle"]() + " " + sCustomStyle, bSuppressRerendering);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["addCustomStyle"] = 0; };

UCF_ClientDTElement["prototype"]["setInplaceEditable"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setInplaceEditable"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		oUCFInstance["setInplaceEditable"](sId);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setInplaceEditable"] = 0; };

UCF_ClientDTElement["prototype"]["updatePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["updatePosition"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		oUCFInstance["updatePosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["updatePosition"] = 0; };

UCF_ClientDTElement["prototype"]["getConnectedClientControl"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["getConnectedClientControl"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		var oControl = oUCFInstance["oGetConnectedControl"]();
		if (oControl) {
			return oControl["getClientControl"]();
		}
		var oControlInfo = oUCFInstance["oGetConnectedControlInfo"]();
		if (oControlInfo) {
			return oControlInfo["getClientControl"]();
		}
	} else {
		var sControlId = this["getControlIds"]()["split"](" ")[0];
		oControl = this["oLS"]["oGetClientControlById"](sControlId);
		if (oControl) {
			return oControl;
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["getConnectedClientControl"] = 0; };

UCF_ClientDTElement["prototype"]["getConnectedCustomData"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["getConnectedCustomData"]++; }; 
	var oClientControl = this["getConnectedClientControl"]();
	if (oClientControl) {
		if (sKey) {
			return oClientControl["getCustomDataKey"](sKey);
		} else {
			return oClientControl["getCustomDataMap"]();
		}

	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["getConnectedCustomData"] = 0; };

UCF_ClientDTElement["prototype"]["isConnectedControlInvisible"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["isConnectedControlInvisible"]++; }; 
	var oControl = this["getConnectedClientControl"]();
	if (oControl && oControl["getUCFInstance"]()) {
		return oControl["getUCFInstance"]()["bGetInvisibility"]();
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["isConnectedControlInvisible"] = 0; };

UCF_ClientDTElement["prototype"]["hideResizeHandles"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["hideResizeHandles"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		oUCFInstance["displayResizeHandles"](false);
		this["setProperty"]("ResizeHandleNorth", false, true);
		this["setProperty"]("ResizeHandleEast", false, true);
		this["setProperty"]("ResizeHandleSouth", false, true);
		this["setProperty"]("ResizeHandleWest", false, true);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["hideResizeHandles"] = 0; };

UCF_ClientDTElement["prototype"]["showResizeHandles"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["showResizeHandles"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		oUCFInstance["displayResizeHandles"](true);
		this["setProperty"]("ResizeHandleNorth", true, true);
		this["setProperty"]("ResizeHandleEast", true, true);
		this["setProperty"]("ResizeHandleSouth", true, true);
		this["setProperty"]("ResizeHandleWest", true, true);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["showResizeHandles"] = 0; };

UCF_ClientDTElement["prototype"]["setTooltip"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setTooltip"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		oUCFInstance["setTooltip"](sText);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setTooltip"] = 0; };
UCF_ClientDTElement["prototype"]["setOutline"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setOutline"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		if (sValue != this["getOutline"]()) {
			this["setProperty"]("Outline", sValue, true);
			oUCFInstance["setOutline"](sValue);
		}
		return;
	}
	this["setProperty"]("Outline", sValue, true);
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setOutline"] = 0; };

UCF_ClientDTElement["prototype"]["setHiddenDesign"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setHiddenDesign"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		oUCFInstance["setHiddenDesign"](bValue);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setHiddenDesign"] = 0; };

UCF_ClientDTElement["prototype"]["hasHiddenDesign"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["hasHiddenDesign"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		return oUCFInstance["bHasHiddenDesign"]();
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["hasHiddenDesign"] = 0; };

UCF_ClientDTElement["prototype"]["setResizeHandleSouth"] = function(bValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setResizeHandleSouth"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		if (this["getResizeHandleSouth"]() != bValue) {
			oUCFInstance["bResizeHandleSouth"] = bValue;
			this["setProperty"]("ResizeHandleSouth", bValue, true);
		}
		return;
	}
	this["setProperty"]("ResizeHandleSouth", bValue, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setResizeHandleSouth"] = 0; };

UCF_ClientDTElement["prototype"]["setResizeHandleNorth"] = function(bValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setResizeHandleNorth"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		if (this["getResizeHandleNorth"]() != bValue) {
			oUCFInstance["bResizeHandleNorth"] = bValue;
			this["setProperty"]("ResizeHandleNorth", bValue, true);
		}
		return;
	}
	this["setProperty"]("ResizeHandleNorth", bValue, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setResizeHandleNorth"] = 0; };

UCF_ClientDTElement["prototype"]["setResizeHandleEast"] = function(bValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setResizeHandleEast"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		if (this["getResizeHandleEast"]() != bValue) {
			oUCFInstance["bResizeHandleEast"] = bValue;
			this["setProperty"]("ResizeHandleEast", bValue, true);
		}
		return;
	}
	this["setProperty"]("ResizeHandleEast", bValue, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setResizeHandleEast"] = 0; };

UCF_ClientDTElement["prototype"]["setResizeHandleWest"] = function(bValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setResizeHandleWest"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		if (this["getResizeHandleWest"]() != bValue) {
			oUCFInstance["bResizeHandleWest"] = bValue;
			this["setProperty"]("ResizeHandleWest", bValue, true);
		}
		return;
	}
	this["setProperty"]("ResizeHandleWest", bValue, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setResizeHandleWest"] = 0; };

UCF_ClientDTElement["prototype"]["_handleActionPress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["_handleActionPress"]++; }; 
	var sId = oEvent["mParameters"]["ActionItemId"];
	for (var i = 0; i < this["getActionMenuItems"]()["length"]; i++) {
		var oAction = this["getActionMenuItems"]()[i];
		if (this["getId"]() + "-action-" + oAction["getId"]() == sId && oAction["_fHandler"]) {
			oAction["_fHandler"]();
			break;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["_handleActionPress"] = 0; };

/**
 * Add ActionMenuItem
 */
UCF_ClientDTElement["prototype"]["addAction"] = function(sId, fHandler, sCssClass, sTooltip) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["addAction"]++; }; 
	if (this["getActionMenuItems"]()["length"] == 0 && fHandler && !this["hasListeners"]("ActionPress")) {
		var that = this;
		this["attachActionPress"](function(mParameters) {
			that["_handleActionPress"](mParameters);
		});
	}
	if (this["oLS"]["oGetClientControlById"](sId)) {
		this["oLS"]["oGetClientControlById"](sId)["removeFromParent"](true);
	}
	var oAction = this["oLS"]["oCreateClientControl"]("DTActionMenuItem", sId);
	oAction["setCssClassName"](sCssClass, true);
	oAction["setTooltip"](sTooltip || "", true);
	oAction["_fHandler"] = fHandler;
	this["addActionMenuItem"](oAction, true);
	if (this["getUCFInstance"]()) {
		// This function will render the item "manually" via DOM createElement/innerHTML
		this["getUCFInstance"]()["addActionItem"](sId, sCssClass, sTooltip);
	} else {
		// We end up here for table-columns only, which are not controls, this means: no UCF_Instance
		if (this["getParent"]()) {
			this["getParent"]()["invalidate"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["addAction"] = 0; };

UCF_ClientDTElement["prototype"]["removeAction"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["removeAction"]++; }; 
	var bRemoved = false;
	for (var i = 0; i < this["getActionMenuItems"]()["length"]; i++) {
		var oAction = this["getActionMenuItems"]()[i];
		if (oAction["getId"]() == sId) {
			oAction["_fHandler"] = null;
			this["removeActionMenuItem"](oAction, true);
			bRemoved = true;
			break;
		}
	}
	if (bRemoved) {
		if (this["getUCFInstance"]()) {
			this["getUCFInstance"]()["removeActionItem"](sId);
		} else {
			if (this["getParent"]()) {
				this["getParent"]()["invalidate"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["removeAction"] = 0; };

UCF_ClientDTElement["prototype"]["hideAction"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["hideAction"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	for (var i = 0; i < this["getActionMenuItems"]()["length"]; i++) {
		var oAction = this["getActionMenuItems"]()[i];
		if (oAction["getId"]() == sId) {
			oAction["setVisible"](false, oUCFInstance != null);
			break;
		}
	}
	if (oUCFInstance) {
		oUCFInstance["hideAction"](sId);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["hideAction"] = 0; };

UCF_ClientDTElement["prototype"]["showAction"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["showAction"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	for (var i = 0; i < this["getActionMenuItems"]()["length"]; i++) {
		var oAction = this["getActionMenuItems"]()[i];
		if (oAction["getId"]() == sId) {
			oAction["setVisible"](true, oUCFInstance != null);
			break;
		}
	}
	if (oUCFInstance) {
		oUCFInstance["showAction"](sId);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["showAction"] = 0; };

UCF_ClientDTElement["prototype"]["alignActionMenu"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["alignActionMenu"]++; }; 
	// Client-side re-rendering of DTElements is "suppressed" in the UCFInstance setter
	// (DTElement cannot be re-rendered individually, because they get initialized only by DTContainer init.)
	// This means we also have to call showActionMenu() to trigger the re-positioning.
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		if (sValue !== this["getActionMenuAlignment"]()) {
			oUCFInstance["setActionMenuAlignment"](sValue);
			oUCFInstance["showActionMenu"](); // re-position
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["alignActionMenu"] = 0; };

/**
 * Select or unselect this element.
 */
UCF_ClientDTElement["prototype"]["setSelected"] = function(bValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setSelected"]++; }; 
	var sValue = bValue ? "SELECTED" : "SELECTABLE";
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance) {
		this["setProperty"]("SelectionState", sValue, bSuppressRerendering);
		if (oUCFInstance["bIsSelectable"]()) {
			oUCFInstance["setSelectionState"](sValue);
		}
	} else {
		this["setProperty"]("SelectionState", sValue, bSuppressRerendering);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDTElement["_"]["setSelected"] = 0; };

///**
// * "Forward" the 'SELECTED' state of this element to a parent element (parent of connected control) that is layered behind this element (DOM position or z-index).
// * This element will no longer be selected but the Designtime will remembere from which element the selection was forwarded (needed for drag-start handling and consistent visual appearance of hover effects and mouse cursor).
// */
//UCF_ClientDTElement.prototype.forwardSelection = function(oTargetClientDTElement, bSuppressRerendering) {
//	this.getUCFInstanceInternal().sSelectionForwardedTo = oTargetClientDTElement.sId;
//	oTargetClientDTElement.getUCFInstanceInternal().sSelectionForwardedFrom = this.sId;
//
//	this.setSelected(false, bSuppressRerendering);
//	oTargetClientDTElement.setSelected(true, bSuppressRerendering);
//};

};
sap["ls"]["preload"]["UCF_ClientDataGrid"] = function() { var UCF_ClientDataGrid = window["UCF_ClientDataGrid"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientDataGrid"); UCF_ClientDataGrid["_"] = {UCF_ClientDataGrid: 0}; };/* global UCF_ClientDataGrid */
UCF_ClientDataGrid["prototype"]["setWidth"] = function(sWidth, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGrid["_"]["setWidth"]++; }; 
	if (this["getWidth"]() != sWidth) {
		this["setProperty"]("Width", sWidth, true);
		this["updateInnerHTML"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGrid["_"]["setWidth"] = 0; };

UCF_ClientDataGrid["prototype"]["setHeight"] = function(sHeight, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGrid["_"]["setHeight"]++; }; 
	if (this["getHeight"]() != sHeight) {
		this["setProperty"]("Height", sHeight, true);
		this["updateInnerHTML"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGrid["_"]["setHeight"] = 0; };

UCF_ClientDataGrid["prototype"]["updateInnerHTML"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGrid["_"]["updateInnerHTML"]++; }; 

	var sWidth = this["getWidth"](),
		sHeight = this["getHeight"](),
		oUCFDataGrid = this["getUCFInstance"]();

	if (!oUCFDataGrid || !oUCFDataGrid["oDomRef"]) return;

	var oDomRef = oUCFDataGrid["oDomRef"],
		oTableRef = oDomRef["childNodes"][2];

	if (this["_sWidth"] != sWidth) {
		this["_sWidth"] = sWidth;
		oTableRef["style"]["width"] = sWidth;
	}

	if (this["_sHeight"] != sHeight) {
		this["_sHeight"] = sHeight;
		if (sHeight["indexOf"]("%") !== -1) {
			oDomRef["style"]["height"] = sHeight;
			oTableRef["style"]["height"] = "100%";
		} else {
			oTableRef["style"]["height"] = sHeight;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGrid["_"]["updateInnerHTML"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientDataGridColumn"] = function() { var UCF_ClientDataGridColumn = window["UCF_ClientDataGridColumn"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientDataGridColumn"); UCF_ClientDataGridColumn["_"] = {UCF_ClientDataGridColumn: 0}; };/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_ClientElement */
/// <reference path="../core/ClientElement.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/* global UCF_ClientDataGridColumn */
UCF_ClientDataGridColumn["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["initialize"]++; }; 
	this["oUCFDataGrid"] = this["getParent"]()["getUCFInstance"]();
	this["iMaxCols"] = Math["floor"](UCF_DomUtil["iScreenWidth"]() / 30);
	this["bKeepClones"] = true;
	this["_iDirtyIndex"] = this["getSegmentColumnIndexOffset"]();
	this["_iStartIndex"] = 0;
	this["_bVisibleRangeCalculated"] = false;
	this["bInitialRangeRequested"] = false;
	this["bSegmentColumnCountChanged"] = false;
	this["_bScrollPositionDirty"] = true;
	this["mSegmentColumns"] = {};

	//workaround for IE issue of positioning at positions greater than 1500000px
	this["_iShiftPosition"] = 1500000;
	this["_iShiftIndex"] = 0;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["initialize"] = 0; };

UCF_ClientDataGridColumn["prototype"]["oGetDataGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["oGetDataGrid"]++; }; 
	if (!this["oDataGrid"]) {
		this["oDataGrid"] = this["getParent"]();
	}
	return this["oDataGrid"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["oGetDataGrid"] = 0; };

UCF_ClientDataGridColumn["prototype"]["oGetUCFDataGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["oGetUCFDataGrid"]++; }; 
	if (!this["oUCFDataGrid"] || !this["oUCFDataGrid"]["oDomRef"]) {
		this["oUCFDataGrid"] = this["getParent"]()["getUCFInstance"]();
	}
	return this["oUCFDataGrid"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["oGetUCFDataGrid"] = 0; };

UCF_ClientDataGridColumn["prototype"]["_addSegmentColumn"] = function(iIndex, oSegmentColumn) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_addSegmentColumn"]++; }; 
	this["mSegmentColumns"]["_" + iIndex] = oSegmentColumn;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_addSegmentColumn"] = 0; };

UCF_ClientDataGridColumn["prototype"]["_removeSegmentColumn"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_removeSegmentColumn"]++; }; 
	delete this["mSegmentColumns"]["_" + iIndex];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_removeSegmentColumn"] = 0; };

UCF_ClientDataGridColumn["prototype"]["_getSegmentColumn"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_getSegmentColumn"]++; }; 
	return this["mSegmentColumns"]["_" + iIndex];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_getSegmentColumn"] = 0; };

UCF_ClientDataGridColumn["prototype"]["_getSegmentColumns"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_getSegmentColumns"]++; }; 
	return this["mSegmentColumns"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_getSegmentColumns"] = 0; };

UCF_ClientDataGridColumn["prototype"]["iGetIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iGetIndex"]++; }; 
	if (!this["_iIndex"]) {
		this["_iIndex"] = this["oGetDataGrid"]()["indexOfAggregation"]("Columns", this);
	}
	return this["_iIndex"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iGetIndex"] = 0; };

UCF_ClientDataGridColumn["prototype"]["bGetVisibleRangeCalculated"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["bGetVisibleRangeCalculated"]++; }; 
	return this["_bVisibleRangeCalculated"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["bGetVisibleRangeCalculated"] = 0; };

/**
 * Returns an array of all DataGridSegments of the DataGridColumn.
 * @return {Array} list of DataGridSegments of the DataGridColumn.
 */
UCF_ClientDataGridColumn["prototype"]["aGetSegments"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["aGetSegments"]++; }; 
	if (!this["aSegments"] || this["aSegments"]["length"] === 0) {
		var aDataGridRows = this["oGetDataGrid"]()["getRows"]();
		this["aSegments"] = [];
		for (var i = 0; i < aDataGridRows["length"]; i++) {
			this["aSegments"]["push"](aDataGridRows[i]["getSegment"](this["iGetIndex"]()));
		}
	}
	return this["aSegments"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["aGetSegments"] = 0; };

/**
 * Returns the lowest index of the SegmentColumn Aggregation which width has been changed
 * so that its left position is not valid anymore
 *
 * @param {integer} iDirtyIndex
 * @private
 */
UCF_ClientDataGridColumn["prototype"]["setDirtyIndex"] = function(iDirtyIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setDirtyIndex"]++; }; 
	if (this["_iDirtyIndex"] > iDirtyIndex) {
		this["_iDirtyIndex"] = iDirtyIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setDirtyIndex"] = 0; };

UCF_ClientDataGridColumn["prototype"]["iGetDirtyIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iGetDirtyIndex"]++; }; 
	return this["_iDirtyIndex"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iGetDirtyIndex"] = 0; };

UCF_ClientDataGridColumn["prototype"]["recalculateLeftPositions"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["recalculateLeftPositions"]++; }; 

	var iMaxIndex = this["getSegmentColumnCount"]() + this["getSegmentColumnIndexOffset"](),
		fStartLeft = 0;

	if (this["_getSegmentColumn"](this["_iDirtyIndex"] - 1)) {
		fStartLeft = this["_getSegmentColumn"](this["_iDirtyIndex"] - 1)["left"] + this["_getSegmentColumn"](this["_iDirtyIndex"] - 1)["width"] - 1;
	}

	for (var col = this["_iDirtyIndex"]; col < iMaxIndex; col++) {
		this["_setSegmentColumnLeft"](col, fStartLeft);
		fStartLeft += this["_getSegmentColumn"](col)["width"] - 1;
	}
	this["_iDirtyIndex"] = iMaxIndex;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["recalculateLeftPositions"] = 0; };

UCF_ClientDataGridColumn["prototype"]["updateAggregation"] = function(sName) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["updateAggregation"]++; }; 
	var fDefaultWidth, fLeft, oSegmentColumn;
	if (!this["bInitialRangeRequested"]) {
		fDefaultWidth = this["fGetDefaultWidth"]();
		for (var i = this["getSegmentColumnIndexOffset"](); i < this["getSegmentColumnCount"]() + this["getSegmentColumnIndexOffset"](); i++) {
			fLeft = (fDefaultWidth - 1) * (i - this["getSegmentColumnIndexOffset"]());
			oSegmentColumn = { "width": fDefaultWidth, "left": fLeft, "type": "STANDARD" };
			this["_addSegmentColumn"](i, oSegmentColumn);
		}
		this["bInitialRangeRequested"] = true;
	} else if (this["bSegmentColumnCountChanged"] && !isNaN(this["iOldSegmentColumnCount"])) {
		if (this["iOldSegmentColumnCount"] < this["getSegmentColumnCount"]()) {
			fDefaultWidth = this["fGetDefaultWidth"]();
			var iStartIndex = this["iOldSegmentColumnCount"] + this["getSegmentColumnIndexOffset"]();
			// add missing segmentColumns with default values ... not neccessary to remove needless segmentColumns because only those up to segmentColumnCount are taken into account
			for (i = iStartIndex; i < this["getSegmentColumnCount"]() + this["getSegmentColumnIndexOffset"](); i++) {
				if (!this["_getSegmentColumn"](i)) {
					fLeft = (fDefaultWidth - 1) * (i - this["getSegmentColumnIndexOffset"]());
					oSegmentColumn = { "width": fDefaultWidth, "left": fLeft, "type": "STANDARD" };
					this["_addSegmentColumn"](i, oSegmentColumn);
				}
			}
		}
		this["bSegmentColumnCountChanged"] = false;
	}
	this["iOldSegmentColumnCount"] = this["getSegmentColumnCount"]();
	//always call super
	UCF_ClientElement["prototype"]["updateAggregation"]["apply"](this, arguments);

	//reset scrollPosition after aggregation update
	//necessary for the case the default width does not match received widths
	var oBinding = this["getBinding"]("SegmentColumns");
	//manageRange = false -> no need to reset scrollPosition
	if (!oBinding || !oBinding["bManageRange"]) return;
	var iFirstVisibleSegmentColumnIndex = this["getFirstVisibleSegmentColumnIndex"](),
		oFirstVisibleSegmentColumn = this["_getSegmentColumn"](iFirstVisibleSegmentColumnIndex),
		aSegments = this["aGetSegments"]();
	if (!aSegments || aSegments["length"] === 0) return;
	var oSegment = aSegments[0],
		oUCFSegment = oSegment["getUCFInstance"]();
	if (!oFirstVisibleSegmentColumn || !oUCFSegment || !oUCFSegment["oDomRef"]) return;
	var iScrollPosition = this["_fGetSegmentColumnLeft"](iFirstVisibleSegmentColumnIndex);
	//dont reset scrollOffset for smooth scrolling
	if (Math["abs"](this["_iScrollPosition"] - iScrollPosition) > (2 * this["fGetDefaultWidth"]())) {
		this["setScrollPosition"](iScrollPosition);
		this["scroll"](false, false);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["updateAggregation"] = 0; };

UCF_ClientDataGridColumn["prototype"]["fGetDefaultWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["fGetDefaultWidth"]++; }; 
	if (this["_fDefaultWidth"]) {
		return this["_fDefaultWidth"];
	}
	var oBinding = this["getBinding"]("SegmentColumns");
	//manageRange = false -> no need to set up defaults
	if (!oBinding || !oBinding["bManageRange"]) return 0;
	var oModel = oBinding["getModel"]();
	if (!oModel) return 0;
	var sTemplatePath = oBinding["getAbsolutePath"]() + "/__templates",
		oSegmentColumnBinding = this["mBindingInfos"]["SegmentColumns"];
	if (!oSegmentColumnBinding) return 0;
	var oTemplateWidthBinding = oSegmentColumnBinding["template"]["mBindingInfos"]["Width"];
	if (!oTemplateWidthBinding || !oModel["getProperty"](sTemplatePath) || !oModel["getProperty"](sTemplatePath)[0] || !oModel["getProperty"](oModel["getProperty"](sTemplatePath)[0] + "/" + oTemplateWidthBinding["path"])) return 0;

	this["_fDefaultWidth"] = oModel["getProperty"](oModel["getProperty"](sTemplatePath)[0] + "/" + oTemplateWidthBinding["path"]);
	return this["_fDefaultWidth"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["fGetDefaultWidth"] = 0; };

UCF_ClientDataGridColumn["prototype"]["setWidth"] = function(sWidth, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setWidth"]++; }; 
	if (this["getWidth"]() != sWidth) {
		this["setProperty"]("Width", sWidth, true);
		this["updateInnerHTML"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setWidth"] = 0; };

//addSegmentColumn
UCF_ClientDataGridColumn["prototype"]["addSegmentColumn"] = function(oSegmentColumn, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["addSegmentColumn"]++; }; 
	this["addAggregation"]("SegmentColumns", oSegmentColumn, true);
	//adjustment of  DataGridColumn width if there is no scrollbar is done in SegmentColumn width setter
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["addSegmentColumn"] = 0; };

UCF_ClientDataGridColumn["prototype"]["setSegmentColumnCount"] = function(iValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setSegmentColumnCount"]++; }; 
	var iOldSegmentColumnCount = this["getSegmentColumnCount"]();
	this["setProperty"]("SegmentColumnCount", iValue, true);
	if (!isNaN(iValue)) {
		this["bSegmentColumnCountChanged"] = true;
		var oBinding = this["getBinding"]("SegmentColumns");
		if (oBinding) {
			oBinding["checkUpdate"](true);
		}
		if (!isNaN(iOldSegmentColumnCount) && iOldSegmentColumnCount != this["getSegmentColumnCount"]()) {
			//adjust DataGridColumn width if there is no scrollbar
			if (!this["getScrollbar"]()) {
				//check for completely initialized UCF as well as ClientControl ... otherwise scrollbar aggregation is anyway not defined
				if (!this["oGetUCFDataGrid"]() || !this["oGetUCFDataGrid"]()["oDomRef"] || (this["getParent"]()["indexOfAggregation"]("Columns", this) == null)) return;
				this["updateColumnWidth"]();
			} else {
				if (this["oGetUCFDataGrid"]()) this["oGetUCFDataGrid"]()["checkResize"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setSegmentColumnCount"] = 0; };

UCF_ClientDataGridColumn["prototype"]["getVisibleRange"] = function(sName, oBinding) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["getVisibleRange"]++; }; 
	if (sName == "SegmentColumns") {
		var iColCount = this["getSegmentColumnCount"]();
		oBinding = this["getBinding"](sName);
		//manageRange = false -> no need to set up defaults
		if (oBinding && !oBinding["bManageRange"]) {
			return { "iStart": this["getSegmentColumnIndexOffset"](), "iEnd": iColCount + this["getSegmentColumnIndexOffset"]() - 1 };
		}
		if (!isNaN(iColCount) && iColCount > 0) {
			var iFirst = this["getFirstVisibleSegmentColumnIndex"](),
				iStart = iFirst,
				iEnd = iStart;
			iStart = Math["max"](this["getSegmentColumnIndexOffset"](), iStart - this["iMaxCols"]);
			iEnd = Math["min"](iFirst + this["iMaxCols"], iColCount + this["getSegmentColumnIndexOffset"]() - 1);
			this["_iStartIndex"] = iStart - this["getSegmentColumnIndexOffset"]();
			return { "iStart": iStart, "iEnd": iEnd };
		}
		return {};
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["getVisibleRange"] = 0; };

UCF_ClientDataGridColumn["prototype"]["setFirstVisibleSegmentColumnIndex"] = function(iFirstVisibleSegmentColumnIndex, bSupressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setFirstVisibleSegmentColumnIndex"]++; }; 
	if (this["getFirstVisibleSegmentColumnIndex"]() != iFirstVisibleSegmentColumnIndex) {
		this["setProperty"]("FirstVisibleSegmentColumnIndex", iFirstVisibleSegmentColumnIndex, true);
		//mark Segment Cells Aggregation dirty
		this["_bSegmentCellAggregationDirty"] = true;
		//adjust scrollPosition if not already set
		if (this["_bScrollPositionDirty"] && this["getSegmentColumn"](iFirstVisibleSegmentColumnIndex - this["getSegmentColumnIndexOffset"]())) {
			this["_iScrollPosition"] = this["getSegmentColumn"](iFirstVisibleSegmentColumnIndex - this["getSegmentColumnIndexOffset"]())["fGetLeft"]();
			this["_bScrollPositionDirty"] = true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setFirstVisibleSegmentColumnIndex"] = 0; };

UCF_ClientDataGridColumn["prototype"]["setLastVisibleSegmentColumnIndex"] = function(iLastVisibleSegmentColumnIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setLastVisibleSegmentColumnIndex"]++; }; 
	if (this["_iLastVisibleSegmentColumnIndex"] != iLastVisibleSegmentColumnIndex) {
		this["_iLastVisibleSegmentColumnIndex"] = iLastVisibleSegmentColumnIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setLastVisibleSegmentColumnIndex"] = 0; };

UCF_ClientDataGridColumn["prototype"]["iGetLastVisibleSegmentColumnIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iGetLastVisibleSegmentColumnIndex"]++; }; 
	return this["_iLastVisibleSegmentColumnIndex"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iGetLastVisibleSegmentColumnIndex"] = 0; };

UCF_ClientDataGridColumn["prototype"]["setScrollPosition"] = function(iScrollPosition) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setScrollPosition"]++; }; 
	if (this["_iScrollPosition"] != iScrollPosition) {
		this["_iScrollPosition"] = iScrollPosition;
		this["_bScrollPositionDirty"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["setScrollPosition"] = 0; };

UCF_ClientDataGridColumn["prototype"]["iGetScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iGetScrollPosition"]++; }; 
	//adjust scrollPosition if not already set
	var iFirstVisibleSegmentColumnIndex = this["getFirstVisibleSegmentColumnIndex"]();
	if (this["_bScrollPositionDirty"] && this["_getSegmentColumn"](iFirstVisibleSegmentColumnIndex)) {
		this["_iScrollPosition"] = this["_fGetSegmentColumnLeft"](iFirstVisibleSegmentColumnIndex);
		this["_bScrollPositionDirty"] = true;
	}
	return this["_iScrollPosition"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iGetScrollPosition"] = 0; };

UCF_ClientDataGridColumn["prototype"]["iGetScrollRange"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iGetScrollRange"]++; }; 
	if (!this["getSegmentColumnCount"]() || this["getSegmentColumnCount"]() == 0) return;
	var iMaxIndex = this["getSegmentColumnCount"]() + this["getSegmentColumnIndexOffset"](),
		iScrollRange = this["_fGetSegmentColumnLeft"](iMaxIndex - 1) + this["_fGetSegmentColumnWidth"](iMaxIndex - 1);

	return iScrollRange;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iGetScrollRange"] = 0; };

UCF_ClientDataGridColumn["prototype"]["updateInnerHTML"] = function(bApply) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["updateInnerHTML"]++; }; 

	if (!bApply) {
		if (this["_iApplyUpdateInnerHTMLTimer"]) {
			clearTimeout(this["_iApplyUpdateInnerHTMLTimer"]);
		}
		var that = this;
		this["_iApplyUpdateInnerHTMLTimer"] = setTimeout(function() {
			that["updateInnerHTML"](true);
		}, 0);
		return;
	}

	if (!this["oGetUCFDataGrid"]() || !this["oGetUCFDataGrid"]()["oDomRef"] || (this["getParent"]()["indexOfAggregation"]("Columns", this) == null)) return;

	var sWidth = this["getWidth"]();

	if (this["_sWidth"] != sWidth) {
		//set width of dataGrid if there is only one column and no scrollbar
		if (this["oGetDataGrid"]()["getColumns"]()["length"] === 1 && !this["getScrollbar"]()) {
			this["oGetDataGrid"]()["setWidth"](sWidth);
		}
		this["_sWidth"] = sWidth;
		var oColGroupRef = this["oGetUCFDataGrid"]()["oDomRef"]["childNodes"][2]["childNodes"][0],
			iCurrentColIndex = this["getParent"]()["indexOfAggregation"]("Columns", this),
			iColApplyIndex = 2 * iCurrentColIndex,
			oColRef = oColGroupRef["childNodes"][iColApplyIndex];
		oColRef["style"]["width"] = sWidth;

		this["oGetUCFDataGrid"]()["checkResize"]();

		//hack for webKit to trigger repainting
		if (!UCF_UserAgent["bIsWebKit"]()) return;
		var oTableRef = this["oGetUCFDataGrid"]()["oDomRef"]["childNodes"][2];
		oTableRef["style"]["display"] = "none";
		//oTableRef.offsetHeight;
		oTableRef["style"]["display"] = "table";
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["updateInnerHTML"] = 0; };

UCF_ClientDataGridColumn["prototype"]["scroll"] = function(bCalcVisibleCellRange, bDelayedUpdate) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["scroll"]++; }; 

	var aSegments = this["aGetSegments"](),
		iFirstVisibleSegmentColumnIndex = this["iCalcFirstVisibleSegmentColumnIndex"]();

	this["setFirstVisibleSegmentColumnIndex"](iFirstVisibleSegmentColumnIndex);
	var oSegment, oUCFSegment;
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		//workaround for IE issue of positioning at positions greater than 1500000px

		for (var i = 0; i < aSegments["length"]; i++) {
			oSegment = aSegments[i];
			//call with forceRerendering=true because sometimes oSegment is invalidate here -> TODO check
			oUCFSegment = oSegment["getUCFInstance"](true);
			var iScrollPosition = this["_iScrollPosition"];

			if (iScrollPosition > this["_iShiftPosition"]) {
				this["_iShiftIndex"] = Math["floor"](iScrollPosition / this["_iShiftPosition"]);
				iScrollPosition = this["_iScrollPosition"] - (this["_iShiftIndex"] * this["_iShiftPosition"]);
			} else {
				this["_iShiftIndex"] = 0;
				iScrollPosition = this["_iScrollPosition"];
			}
			if (window["UCF_System"]["bIsRTL"]) {
				oUCFSegment["oDomRef"]["firstChild"]["style"]["right"] = (-iScrollPosition) + "px";
			} else {
				oUCFSegment["oDomRef"]["firstChild"]["style"]["left"] = (-iScrollPosition) + "px";
			}
			oUCFSegment["paintRasterX"](iScrollPosition);
		}
	} else {
		for (i = 0; i < aSegments["length"]; i++) {
			oSegment = aSegments[i];
			//call with forceRerendering=true because sometimes oSegment is invalidate here -> TODO check
			oUCFSegment = oSegment["getUCFInstance"](true);

			if (window["UCF_System"]["bIsRTL"]) {
				oUCFSegment["oDomRef"]["firstChild"]["style"]["right"] = (-this["_iScrollPosition"]) + "px";
			} else {
				oUCFSegment["oDomRef"]["firstChild"]["style"]["left"] = (-this["_iScrollPosition"]) + "px";
			}
			oUCFSegment["paintRasterX"](this["_iScrollPosition"]);
		}
	}

	if (!bCalcVisibleCellRange) {
		return;
	}

	if (this["_bSegmentCellAggregationDirty"]) {
		var oBinding = this["getBinding"]("SegmentColumns");
		//manageRange = true -> update SegmentColumns aggregation
		if (oBinding && oBinding["bManageRange"]) {
			if (bDelayedUpdate) {
				if (this["_iColScrollTimer"]) {
					UCF_JsUtil["clearDelayedCall"](this["_iColScrollTimer"]);
				}
				this["_iColScrollTimer"] = UCF_JsUtil["delayedCall"](60, this, "updateAggregation", ["SegmentColumns"]);
			} else {
				this["updateAggregation"]("SegmentColumns");
			}
		}
		this["calcVisibleCellRange"]();
		//reset this._bSegmentCellAggregationDirty here because of delayed update (correctly in ClientDataGridSegment.updateAggregation)
		this["_bSegmentCellAggregationDirty"] = false;
		if (bDelayedUpdate) {
			if (this["_iScrollTimer"]) {
				UCF_JsUtil["clearDelayedCall"](this["_iScrollTimer"]);
			}
			this["_iScrollTimer"] = UCF_JsUtil["delayedCall"](60, this, "updateSegmentCellAggregation");
		} else {
			this["updateSegmentCellAggregation"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["scroll"] = 0; };

/**
 * Returns the index of the DataGridSegmentColumn at iPositionX in px.
 * @param {int} iPositionX the position in px as integer.
 * @return {int} the index of the DataGridSegmentColumn at iPositionX in px.
 */
UCF_ClientDataGridColumn["prototype"]["iCalcXindex"] = function(iPositionX) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iCalcXindex"]++; }; 

	//try to find the current column by taking the default width or 100
	var fDefaultWidth = this["fGetDefaultWidth"]() == 0 ? 100 : this["fGetDefaultWidth"](),
		iMaxIndex = this["getSegmentColumnCount"]() + this["getSegmentColumnIndexOffset"]() - 1,
		iSegmentColIndex = Math["min"](iMaxIndex, Math["floor"](iPositionX / fDefaultWidth) + this["getSegmentColumnIndexOffset"]());

	if (this["_getSegmentColumn"](iSegmentColIndex)["left"] <= iPositionX) {
		while (iSegmentColIndex <= iMaxIndex && this["_getSegmentColumn"](iSegmentColIndex)["left"] <= iPositionX) {
			iSegmentColIndex++;
		}
		return iSegmentColIndex - 1;
	} else {
		while (iSegmentColIndex >= this["getSegmentColumnIndexOffset"]() && this["_getSegmentColumn"](iSegmentColIndex)["left"] >= iPositionX) {
			iSegmentColIndex--;
		}
		return iSegmentColIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iCalcXindex"] = 0; };

UCF_ClientDataGridColumn["prototype"]["iCalcFirstVisibleSegmentColumnIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iCalcFirstVisibleSegmentColumnIndex"]++; }; 
	return this["iCalcXindex"](this["_iScrollPosition"]);
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["iCalcFirstVisibleSegmentColumnIndex"] = 0; };

/**
 * Calculates visible cell range
 * Calculation is done by starting at topLeft index and mount up the widths of the
 * DataGridSegmentColumns until reaching the domRef offsetWidth of the corresponding
 * DataGridColumn.
 */
UCF_ClientDataGridColumn["prototype"]["calcVisibleCellRange"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["calcVisibleCellRange"]++; }; 

	if (this["getSegmentColumns"]()["length"] === 0) {
		return;
	}
	if (!this["aGetSegments"]()[0]["getUCFInstance"]()) {
		return;
	}
	var iCurrentLeft = 0,
		iXCounter = this["getFirstVisibleSegmentColumnIndex"](),
		iOffsetWidth = this["aGetSegments"]()[0]["getUCFInstance"]()["iOffsetWidth"],
		iMaxIndex = this["getSegmentColumnCount"]() + this["getSegmentColumnIndexOffset"]() - 1;

	while (iXCounter < iMaxIndex && iCurrentLeft <= iOffsetWidth) {
		iCurrentLeft += parseInt(this["_getSegmentColumn"](iXCounter)["width"]);
		iXCounter++;
	}

	//need to request more than really visible but not more than column count
	var iLastVisibleSegmentColumnIndex = Math["min"]((iXCounter + this["getSegmentColumnIndexOffset"]() + 1), iMaxIndex);

	this["setLastVisibleSegmentColumnIndex"](iLastVisibleSegmentColumnIndex);
	this["_bVisibleRangeCalculated"] = true;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["calcVisibleCellRange"] = 0; };

UCF_ClientDataGridColumn["prototype"]["updateSegmentCellAggregation"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["updateSegmentCellAggregation"]++; }; 

	var aSegments = this["aGetSegments"]();
	for (var i = 0; i < aSegments["length"]; i++) {
		aSegments[i]["updateAggregation"]("Cells");
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["updateSegmentCellAggregation"] = 0; };

UCF_ClientDataGridColumn["prototype"]["_setSegmentColumnLeft"] = function(iIndex, fLeft) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_setSegmentColumnLeft"]++; }; 
	var oSegmentColumn = this["_getSegmentColumn"](iIndex);
	if (oSegmentColumn["left"] != fLeft) {
		oSegmentColumn["left"] = fLeft;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_setSegmentColumnLeft"] = 0; };

UCF_ClientDataGridColumn["prototype"]["_setSegmentColumnWidth"] = function(iIndex, fWidth) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_setSegmentColumnWidth"]++; }; 
	var oSegmentColumn = this["_getSegmentColumn"](iIndex);
	if (oSegmentColumn["width"] != fWidth) {
		oSegmentColumn["width"] = fWidth;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_setSegmentColumnWidth"] = 0; };

UCF_ClientDataGridColumn["prototype"]["_setSegmentColumnType"] = function(iIndex, sType) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_setSegmentColumnType"]++; }; 
	var oSegmentColumn = this["_getSegmentColumn"](iIndex);
	if (oSegmentColumn["type"] != sType) {
		oSegmentColumn["type"] = sType;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_setSegmentColumnType"] = 0; };

UCF_ClientDataGridColumn["prototype"]["_fGetSegmentColumnLeft"] = function(iIndex, bShiftedValue) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_fGetSegmentColumnLeft"]++; }; 
	var oSegmentColumn = this["_getSegmentColumn"](iIndex);
	if (this["_iDirtyIndex"] <= iIndex) {
		//trigger recalculation starting from iDirtyIndex
		this["recalculateLeftPositions"]();
	}
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		//workaround for IE issue of positioning at positions greater than 1500000px
		if (this["_iShiftIndex"] == 0 || !bShiftedValue) {
			return oSegmentColumn["left"];
		} else {
			return oSegmentColumn["left"] - (this["_iShiftIndex"] * this["_iShiftPosition"]);
		}
	} else {
		return oSegmentColumn["left"];
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_fGetSegmentColumnLeft"] = 0; };

UCF_ClientDataGridColumn["prototype"]["_fGetSegmentColumnWidth"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_fGetSegmentColumnWidth"]++; }; 
	var oSegmentColumn = this["_getSegmentColumn"](iIndex);
	return oSegmentColumn["width"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_fGetSegmentColumnWidth"] = 0; };

UCF_ClientDataGridColumn["prototype"]["_sGetSegmentColumnType"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_sGetSegmentColumnType"]++; }; 
	var oSegmentColumn = this["_getSegmentColumn"](iIndex);
	return oSegmentColumn["type"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["_sGetSegmentColumnType"] = 0; };

UCF_ClientDataGridColumn["prototype"]["updateColumnWidth"] = function(bApply) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["updateColumnWidth"]++; }; 

	if (!bApply) {
		if (this["_iApplyUpdateColumnWidthTimer"]) {
			clearTimeout(this["_iApplyUpdateColumnWidthTimer"]);
		}
		var that = this;
		this["_iApplyUpdateColumnWidthTimer"] = setTimeout(function() {
			that["updateColumnWidth"](true);
		}, 0);
		return;
	}

	var iColumnWidth = 0,
		sColumnWidth = "";

	// take only the columns within the current segmentColumnCount into account
	for (var i = this["getSegmentColumnIndexOffset"](); i < this["getSegmentColumnCount"]() + this["getSegmentColumnIndexOffset"](); i++) {
		iColumnWidth += this["_fGetSegmentColumnWidth"](i);
	}

	//dataGridColumnwidth = n * dataGridSegmentColumnWidth - ( n - 1)
	iColumnWidth = iColumnWidth - (this["getSegmentColumnCount"]() - 1);
	sColumnWidth = iColumnWidth + this["getSegmentColumnUnit"]();
	this["setWidth"](sColumnWidth, true);
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridColumn["_"]["updateColumnWidth"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientDataGridRow"] = function() { var UCF_ClientDataGridRow = window["UCF_ClientDataGridRow"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientDataGridRow"); UCF_ClientDataGridRow["_"] = {UCF_ClientDataGridRow: 0}; };/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_ClientElement */
/// <reference path="../core/ClientElement.js"/>

/*global UCF_ClientDataGridRow */
UCF_ClientDataGridRow["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["initialize"]++; }; 
	this["oUCFDataGrid"] = this["getParent"]()["getUCFInstance"]();
	this["iMaxRows"] = Math["floor"](UCF_DomUtil["iScreenHeight"]() / 20);
	this["bKeepClones"] = true;
	this["_iDirtyIndex"] = this["getSegmentRowIndexOffset"]();
	this["_iStartIndex"] = 0;
	this["_bVisibleRangeCalculated"] = false;
	this["bInitialRangeRequested"] = false;
	this["bSegmentRowCountChanged"] = false;
	this["_bScrollPositionDirty"] = true;
	this["mSegmentRows"] = {};

	//workaround for IE issue of positioning at positions greater than 1500000px
	this["_iShiftPosition"] = 1500000;
	this["_iShiftIndex"] = 0;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["initialize"] = 0; };

UCF_ClientDataGridRow["prototype"]["oGetDataGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["oGetDataGrid"]++; }; 
	if (!this["oDataGrid"]) {
		this["oDataGrid"] = this["getParent"]();
	}
	return this["oDataGrid"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["oGetDataGrid"] = 0; };

UCF_ClientDataGridRow["prototype"]["oGetUCFDataGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["oGetUCFDataGrid"]++; }; 
	if (!this["oUCFDataGrid"] || !this["oUCFDataGrid"]["oDomRef"]) {
		this["oUCFDataGrid"] = this["getParent"]()["getUCFInstance"]();
	}
	return this["oUCFDataGrid"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["oGetUCFDataGrid"] = 0; };

UCF_ClientDataGridRow["prototype"]["_addSegmentRow"] = function(iIndex, oSegmentRow) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_addSegmentRow"]++; }; 
	this["mSegmentRows"]["_" + iIndex] = oSegmentRow;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_addSegmentRow"] = 0; };

UCF_ClientDataGridRow["prototype"]["_removeSegmentRow"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_removeSegmentRow"]++; }; 
	delete this["mSegmentRows"]["_" + iIndex];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_removeSegmentRow"] = 0; };

UCF_ClientDataGridRow["prototype"]["_getSegmentRow"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_getSegmentRow"]++; }; 
	return this["mSegmentRows"]["_" + iIndex];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_getSegmentRow"] = 0; };

UCF_ClientDataGridRow["prototype"]["_getSegmentRows"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_getSegmentRows"]++; }; 
	return this["mSegmentRows"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_getSegmentRows"] = 0; };

UCF_ClientDataGridRow["prototype"]["iGetIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iGetIndex"]++; }; 
	if (!this["_iIndex"]) {
		this["_iIndex"] = this["oGetDataGrid"]()["indexOfAggregation"]("Rows", this);
	}
	return this["_iIndex"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iGetIndex"] = 0; };

UCF_ClientDataGridRow["prototype"]["bGetVisibleRangeCalculated"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["bGetVisibleRangeCalculated"]++; }; 
	return this["_bVisibleRangeCalculated"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["bGetVisibleRangeCalculated"] = 0; };

/**
 * Returns an array of all DataGridSegments of DataGridRow.
 * @return {Array} list of DataGridSegments of DataGridRow.
 */
UCF_ClientDataGridRow["prototype"]["aGetSegments"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["aGetSegments"]++; }; 
	if (!this["aSegments"] || this["aSegments"]["length"] === 0) {
		this["aSegments"] = this["getSegments"]();
	}
	return this["aSegments"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["aGetSegments"] = 0; };

/**
 * Returns the lowest index of the SegmentRow Aggregation which height has been changed
 * so that its top position is not valid anymore
 *
 * @param {integer} iDirtyIndex
 * @private
 */
UCF_ClientDataGridRow["prototype"]["setDirtyIndex"] = function(iDirtyIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setDirtyIndex"]++; }; 
	if (this["_iDirtyIndex"] > iDirtyIndex) {
		this["_iDirtyIndex"] = iDirtyIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setDirtyIndex"] = 0; };

UCF_ClientDataGridRow["prototype"]["iGetDirtyIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iGetDirtyIndex"]++; }; 
	return this["_iDirtyIndex"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iGetDirtyIndex"] = 0; };

UCF_ClientDataGridRow["prototype"]["recalculateTopPositions"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["recalculateTopPositions"]++; }; 

	var iMaxIndex = this["getSegmentRowCount"]() + this["getSegmentRowIndexOffset"](),
		fStartTop = 0;

	if (this["_getSegmentRow"](this["_iDirtyIndex"] - 1)) {
		fStartTop = this["_getSegmentRow"](this["_iDirtyIndex"] - 1)["top"] + this["_getSegmentRow"](this["_iDirtyIndex"] - 1)["height"] - 1; //, "px";
	}

	for (var row = this["_iDirtyIndex"]; row < iMaxIndex; row++) {
		this["_setSegmentRowTop"](row, fStartTop);
		fStartTop += this["_getSegmentRow"](row)["height"] - 1;
	}
	this["_iDirtyIndex"] = iMaxIndex;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["recalculateTopPositions"] = 0; };

UCF_ClientDataGridRow["prototype"]["updateAggregation"] = function(sName) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["updateAggregation"]++; }; 
	var fDefaultHeight, fTop, oSegmentRow;
	if (!this["bInitialRangeRequested"]) {
		fDefaultHeight = this["fGetDefaultHeight"]();
		for (var i = this["getSegmentRowIndexOffset"](); i < this["getSegmentRowCount"]() + this["getSegmentRowIndexOffset"](); i++) {
			fTop = (fDefaultHeight - 1) * (i - this["getSegmentRowIndexOffset"]());
			oSegmentRow = { "height": fDefaultHeight, "top": fTop, "type": "STANDARD" };
			this["_addSegmentRow"](i, oSegmentRow);
		}
		this["bInitialRangeRequested"] = true;
	} else if (this["bSegmentRowCountChanged"] && !isNaN(this["iOldSegmentRowCount"])) {
		if (this["iOldSegmentRowCount"] < this["getSegmentRowCount"]()) {
			fDefaultHeight = this["fGetDefaultHeight"]();
			var iStartIndex = this["iOldSegmentRowCount"] + this["getSegmentRowIndexOffset"]();
			// add missing segmentRows with default values ... not neccessary to remove needless segmentRows because only those up to segmentRowCount are taken into account
			for (i = iStartIndex; i < this["getSegmentRowCount"]() + this["getSegmentRowIndexOffset"](); i++) {
				if (!this["_getSegmentRow"](i)) {
					fTop = (fDefaultHeight - 1) * (i - this["getSegmentRowIndexOffset"]());
					oSegmentRow = { "height": fDefaultHeight, "top": fTop, "type": "STANDARD" };
					this["_addSegmentRow"](i, oSegmentRow);
				}
			}
		}
		this["bSegmentRowCountChanged"] = false;
	}
	this["iOldSegmentRowCount"] = this["getSegmentRowCount"]();
	//always call super
	UCF_ClientElement["prototype"]["updateAggregation"]["apply"](this, arguments);

	//reset scrollPosition after aggregation update
	//necessary for the case the default height does not match received heights
	var oBinding = this["getBinding"]("SegmentRows");
	//manageRange = false -> no need to reset scrollPosition
	if (!oBinding || !oBinding["bManageRange"]) return;
	var iFirstVisibleSegmentRowIndex = this["getFirstVisibleSegmentRowIndex"](),
		oFirstVisibleSegmentRow = this["_getSegmentRow"](iFirstVisibleSegmentRowIndex),
		aSegments = this["aGetSegments"]();
	if (!aSegments || aSegments["length"] === 0) return;
	var oSegment = aSegments[0],
		oUCFSegment = oSegment["getUCFInstance"]();
	if (!oFirstVisibleSegmentRow || !oUCFSegment || !oUCFSegment["oDomRef"]) return;
	var iScrollPosition = this["_fGetSegmentRowTop"](iFirstVisibleSegmentRowIndex);
	//dont reset scrollOffset for smooth scrolling
	if (Math["abs"](this["_iScrollPosition"] - iScrollPosition) > (2 * this["fGetDefaultHeight"]())) {
		this["setScrollPosition"](iScrollPosition);
		this["scroll"](false, false);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["updateAggregation"] = 0; };

UCF_ClientDataGridRow["prototype"]["fGetDefaultHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["fGetDefaultHeight"]++; }; 
	if (this["_fDefaultHeight"]) {
		return this["_fDefaultHeight"];
	}
	var oBinding = this["getBinding"]("SegmentRows");
	//manageRange = false -> no need to set up defaults
	if (!oBinding || !oBinding["bManageRange"]) return 0;
	var oModel = oBinding["getModel"]();
	if (!oModel) return 0;
	var sTemplatePath = oBinding["getAbsolutePath"]() + "/__templates",
		oSegmentColumnBinding = this["mBindingInfos"]["SegmentRows"];
	if (!oSegmentColumnBinding) return 0;
	var oTemplateWidthBinding = oSegmentColumnBinding["template"]["mBindingInfos"]["Height"];
	if (!oTemplateWidthBinding || !oModel["getProperty"](sTemplatePath) || !oModel["getProperty"](sTemplatePath)[0] || !oModel["getProperty"](oModel["getProperty"](sTemplatePath)[0] + "/" + oTemplateWidthBinding["path"])) return 0;

	this["_fDefaultHeight"] = oModel["getProperty"](oModel["getProperty"](sTemplatePath)[0] + "/" + oTemplateWidthBinding["path"]);
	return this["_fDefaultHeight"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["fGetDefaultHeight"] = 0; };

UCF_ClientDataGridRow["prototype"]["setHeight"] = function(sHeight, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setHeight"]++; }; 
	if (this["getHeight"]() != sHeight) {
		this["setProperty"]("Height", sHeight, true);
		this["updateInnerHTML"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setHeight"] = 0; };

UCF_ClientDataGridRow["prototype"]["addSegmentRow"] = function(oSegmentRow, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["addSegmentRow"]++; }; 
	this["addAggregation"]("SegmentRows", oSegmentRow, true);
	//adjustment of  DataGridRow height if there is no scrollbar is done in SegmentRow height setter
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["addSegmentRow"] = 0; };

UCF_ClientDataGridRow["prototype"]["setSegmentRowCount"] = function(iValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setSegmentRowCount"]++; }; 
	var iOldSegmentRowCount = this["getSegmentRowCount"]();
	this["setProperty"]("SegmentRowCount", iValue, true);
	if (!isNaN(iValue)) {
		this["bSegmentRowCountChanged"] = true;
		var oBinding = this["getBinding"]("SegmentRows");
		if (oBinding) {
			oBinding["checkUpdate"](true);
		}
		if (!isNaN(iOldSegmentRowCount) && iOldSegmentRowCount != this["getSegmentRowCount"]()) {
			//adjust DataGridRow width if there is no scrollbar
			if (!this["getScrollbar"]()) {
				//check for completely initialized UCF as well as ClientControl ... otherwise scrollbar aggregation is anyway not defined
				if (!this["oGetUCFDataGrid"]() || !this["oGetUCFDataGrid"]()["oDomRef"] || (this["getParent"]()["indexOfAggregation"]("Rows", this) == null)) return;
				this["updateRowHeight"]();
			} else {
				if (this["oGetUCFDataGrid"]()) this["oGetUCFDataGrid"]()["checkResize"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setSegmentRowCount"] = 0; };

UCF_ClientDataGridRow["prototype"]["getVisibleRange"] = function(sName, oBinding) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["getVisibleRange"]++; }; 
	if (sName == "SegmentRows") {
		var iRowCount = this["getSegmentRowCount"]();
		oBinding = this["getBinding"](sName);
		//manageRange = false -> no need to set up defaults
		if (oBinding && !oBinding["bManageRange"]) {
			return { "iStart": this["getSegmentRowIndexOffset"](), "iEnd": iRowCount + this["getSegmentRowIndexOffset"]() - 1 };
		}
		if (!isNaN(iRowCount) && iRowCount > 0) {
			var iFirst = this["getFirstVisibleSegmentRowIndex"](),
				iStart = iFirst,
				iEnd = iStart;
			iStart = Math["max"](this["getSegmentRowIndexOffset"](), iStart - this["iMaxRows"]);
			iEnd = Math["min"](iFirst + this["iMaxRows"], iRowCount + this["getSegmentRowIndexOffset"]() - 1);
			this["_iStartIndex"] = iStart - this["getSegmentRowIndexOffset"]();
			return { "iStart": iStart, "iEnd": iEnd };
		}
		return {};
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["getVisibleRange"] = 0; };

UCF_ClientDataGridRow["prototype"]["setFirstVisibleSegmentRowIndex"] = function(iFirstVisibleSegmentRowIndex, bSupressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setFirstVisibleSegmentRowIndex"]++; }; 
	if (this["getFirstVisibleSegmentRowIndex"]() != iFirstVisibleSegmentRowIndex) {
		this["setProperty"]("FirstVisibleSegmentRowIndex", iFirstVisibleSegmentRowIndex, true);
		//mark Segment Cells Aggregation dirty
		this["_bSegmentCellAggregationDirty"] = true;
		//adjust scrollPosition if not already set
		if (this["_bScrollPositionDirty"] && this["getSegmentRow"](iFirstVisibleSegmentRowIndex - this["getSegmentRowIndexOffset"]())) {
			this["_iScrollPosition"] = this["getSegmentRow"](iFirstVisibleSegmentRowIndex - this["getSegmentRowIndexOffset"]())["fGetTop"]();
			this["_bScrollPositionDirty"] = true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setFirstVisibleSegmentRowIndex"] = 0; };

UCF_ClientDataGridRow["prototype"]["setLastVisibleSegmentRowIndex"] = function(iLastVisibleSegmentRowIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setLastVisibleSegmentRowIndex"]++; }; 
	if (this["_iLastVisibleSegmentRowIndex"] != iLastVisibleSegmentRowIndex) {
		this["_iLastVisibleSegmentRowIndex"] = iLastVisibleSegmentRowIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setLastVisibleSegmentRowIndex"] = 0; };

UCF_ClientDataGridRow["prototype"]["iGetLastVisibleSegmentRowIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iGetLastVisibleSegmentRowIndex"]++; }; 
	return this["_iLastVisibleSegmentRowIndex"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iGetLastVisibleSegmentRowIndex"] = 0; };

UCF_ClientDataGridRow["prototype"]["setScrollPosition"] = function(iScrollPosition) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setScrollPosition"]++; }; 
	if (this["_iScrollPosition"] != iScrollPosition) {
		this["_iScrollPosition"] = iScrollPosition;
		this["_bScrollPositionDirty"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["setScrollPosition"] = 0; };

UCF_ClientDataGridRow["prototype"]["iGetScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iGetScrollPosition"]++; }; 
	//adjust scrollPosition if not already set
	var iFirstVisibleSegmentRowIndex = this["getFirstVisibleSegmentRowIndex"]();
	if (this["_bScrollPositionDirty"] && this["_getSegmentRow"](iFirstVisibleSegmentRowIndex)) {
		this["_iScrollPosition"] = this["_fGetSegmentRowTop"](iFirstVisibleSegmentRowIndex);
		this["_bScrollPositionDirty"] = true;
	}
	return this["_iScrollPosition"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iGetScrollPosition"] = 0; };

UCF_ClientDataGridRow["prototype"]["iGetScrollRange"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iGetScrollRange"]++; }; 
	if (!this["getSegmentRowCount"]() || this["getSegmentRowCount"]() == 0) return;
	var iMaxIndex = this["getSegmentRowCount"]() + this["getSegmentRowIndexOffset"](),
		iScrollRange = this["_fGetSegmentRowTop"](iMaxIndex - 1) + this["_fGetSegmentRowHeight"](iMaxIndex - 1);

	return iScrollRange;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iGetScrollRange"] = 0; };

UCF_ClientDataGridRow["prototype"]["updateInnerHTML"] = function(bApply) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["updateInnerHTML"]++; }; 

	if (!bApply) {
		if (this["_iApplyUpdateInnerHTMLTimer"]) {
			clearTimeout(this["_iApplyUpdateInnerHTMLTimer"]);
		}
		var that = this;
		this["_iApplyUpdateInnerHTMLTimer"] = setTimeout(function() {
			that["updateInnerHTML"](true);
		}, 0);
		return;
	}

	if (!this["oGetUCFDataGrid"]() || !this["oGetUCFDataGrid"]()["oDomRef"] || (this["getParent"]()["indexOfAggregation"]("Rows", this) == null)) return;

	var sHeight = this["getHeight"]();

	if (this["_sHeight"] != sHeight) {
		//set height of dataGrid if there is only one row and no scrollbar
		if (this["oGetDataGrid"]()["getRows"]()["length"] === 1 && !this["getScrollbar"]()) {
			this["oGetDataGrid"]()["setHeight"](sHeight);
		}
		this["_sHeight"] = sHeight;
		var oTBodyRef = this["oGetUCFDataGrid"]()["oDomRef"]["childNodes"][2]["childNodes"][2],
			iCurrentRowIndex = this["getParent"]()["indexOfAggregation"]("Rows", this),
			iTrApplyIndex = 2 * iCurrentRowIndex,
			oTrRef = oTBodyRef["childNodes"][iTrApplyIndex],
			aTdRef = oTrRef["childNodes"];

		oTrRef["style"]["height"] = sHeight;
		for (var iTdIndex = 0; iTdIndex < aTdRef["length"]; iTdIndex++) {
			if (iTdIndex % 2 != 0 && iTdIndex != (aTdRef["length"] - 1)) continue;
			aTdRef[iTdIndex]["style"]["height"] = sHeight;
		}
		this["oGetUCFDataGrid"]()["checkResize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["updateInnerHTML"] = 0; };

UCF_ClientDataGridRow["prototype"]["scroll"] = function(bCalcVisibleCellRange, bDelayedUpdate) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["scroll"]++; }; 

	var aSegments = this["aGetSegments"](),
		iFirstVisibleSegmentRowIndex = this["iCalcFirstVisibleSegmentRowIndex"]();
	var oSegment, oUCFSegment;
	this["setFirstVisibleSegmentRowIndex"](iFirstVisibleSegmentRowIndex);

	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		//workaround for IE issue of positioning at positions greater than 1500000px
		for (var i = 0; i < aSegments["length"]; i++) {
			oSegment = aSegments[i];
			//call with forceRerendering=true because sometimes oSegment is invalidate here -> TODO check
			oUCFSegment = oSegment["getUCFInstance"](true);
			var iScrollPosition = this["_iScrollPosition"];

			if (iScrollPosition > this["_iShiftPosition"]) {
				this["_iShiftIndex"] = Math["floor"](iScrollPosition / this["_iShiftPosition"]);
				iScrollPosition = this["_iScrollPosition"] - (this["_iShiftIndex"] * this["_iShiftPosition"]);
			} else {
				this["_iShiftIndex"] = 0;
				iScrollPosition = this["_iScrollPosition"];
			}
			oUCFSegment["oDomRef"]["firstChild"]["style"]["top"] = (-iScrollPosition) + "px";
			oUCFSegment["paintRasterY"](iScrollPosition);
		}
	} else {
		for (i = 0; i < aSegments["length"]; i++) {
			oSegment = aSegments[i];
			//call with forceRerendering=true because sometimes oSegment is invalidate here -> TODO check
			oUCFSegment = oSegment["getUCFInstance"](true);

			oUCFSegment["oDomRef"]["firstChild"]["style"]["top"] = (-this["_iScrollPosition"]) + "px";
			oUCFSegment["paintRasterY"](this["_iScrollPosition"]);
		}
	}

	if (!bCalcVisibleCellRange) {
		return;
	}

	if (this["_bSegmentCellAggregationDirty"]) {
		var oBinding = this["getBinding"]("SegmentRows");
		//manageRange = true -> update SegmentRows aggregation
		if (oBinding && oBinding["bManageRange"]) {
			if (bDelayedUpdate) {
				if (this["_iRowScrollTimer"]) {
					UCF_JsUtil["clearDelayedCall"](this["_iRowScrollTimer"]);
				}
				this["_iRowScrollTimer"] = UCF_JsUtil["delayedCall"](60, this, "updateAggregation", ["SegmentRows"]);
			} else {
				this["updateAggregation"]("SegmentRows");
			}
		}
		this["calcVisibleCellRange"]();
		//reset this._bSegmentCellAggregationDirty here because of delayed update (correctly in ClientDataGridSegment.updateAggregation)
		this["_bSegmentCellAggregationDirty"] = false;
		if (bDelayedUpdate) {
			if (this["_iScrollTimer"]) {
				UCF_JsUtil["clearDelayedCall"](this["_iScrollTimer"]);
			}
			this["_iScrollTimer"] = UCF_JsUtil["delayedCall"](60, this, "updateSegmentCellAggregation");
		} else {
			this["updateSegmentCellAggregation"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["scroll"] = 0; };

/**
 * Returns the index of the DataGridSegmentRow at iPositionY in px.
 * @param {int} iPositionY the position in px as integer.
 * @return {int} the index of the DataGridSegmentRow at iPositionY in px.
 */
UCF_ClientDataGridRow["prototype"]["iCalcYindex"] = function(iPositionY) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iCalcYindex"]++; }; 

	//try to find the current row by taking the default height or 30
	var fDefaultHeight = this["fGetDefaultHeight"]() == 0 ? 30 : this["fGetDefaultHeight"](),
		iMaxIndex = this["getSegmentRowCount"]() + this["getSegmentRowIndexOffset"]() - 1,
		iSegmentRowIndex = Math["min"](iMaxIndex, Math["floor"](iPositionY / fDefaultHeight) + this["getSegmentRowIndexOffset"]());

	if (this["_getSegmentRow"](iSegmentRowIndex)["top"] <= iPositionY) {
		while (iSegmentRowIndex <= iMaxIndex && this["_getSegmentRow"](iSegmentRowIndex)["top"] <= iPositionY) {
			iSegmentRowIndex++;
		}
		return iSegmentRowIndex - 1;
	} else {
		while (iSegmentRowIndex >= this["getSegmentRowIndexOffset"]() && this["_getSegmentRow"](iSegmentRowIndex)["top"] >= iPositionY) {
			iSegmentRowIndex--;
		}
		return iSegmentRowIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iCalcYindex"] = 0; };

UCF_ClientDataGridRow["prototype"]["iCalcFirstVisibleSegmentRowIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iCalcFirstVisibleSegmentRowIndex"]++; }; 
	return this["iCalcYindex"](this["_iScrollPosition"]);
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["iCalcFirstVisibleSegmentRowIndex"] = 0; };

/**
 * Calculates visible cell range
 * Calculation is done by starting at topLeft index and mount up the heights of the
 * DataGridSegmentRows until reaching the domRef offsetHeight of the corresponding
 * DataGridRow.
 */
UCF_ClientDataGridRow["prototype"]["calcVisibleCellRange"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["calcVisibleCellRange"]++; }; 

	if (this["getSegmentRows"]()["length"] === 0) {
		return;
	}
	if (!this["aGetSegments"]()[0]["getUCFInstance"]()) {
		return;
	}
	var iCurrentTop = 0,
		iYCounter = this["getFirstVisibleSegmentRowIndex"](),
		iOffsetHeight = this["aGetSegments"]()[0]["getUCFInstance"]()["iOffsetHeight"],
		iMaxIndex = this["getSegmentRowCount"]() + this["getSegmentRowIndexOffset"]() - 1;

	while (iYCounter < iMaxIndex && iCurrentTop <= iOffsetHeight) {
		iCurrentTop += parseInt(this["_getSegmentRow"](iYCounter)["height"]);
		iYCounter++;
	}

	//need to request more than really visible but not more than row count
	var iLastVisibleSegmentRowIndex = Math["min"]((iYCounter + this["getSegmentRowIndexOffset"]() + 1), iMaxIndex);

	this["setLastVisibleSegmentRowIndex"](iLastVisibleSegmentRowIndex);
	this["_bVisibleRangeCalculated"] = true;

};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["calcVisibleCellRange"] = 0; };

UCF_ClientDataGridRow["prototype"]["updateSegmentCellAggregation"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["updateSegmentCellAggregation"]++; }; 

	var aSegments = this["aGetSegments"]();
	for (var i = 0; i < aSegments["length"]; i++) {
		aSegments[i]["updateAggregation"]("Cells");
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["updateSegmentCellAggregation"] = 0; };

UCF_ClientDataGridRow["prototype"]["_setSegmentRowTop"] = function(iIndex, fTop) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_setSegmentRowTop"]++; }; 
	var oSegmentRow = this["_getSegmentRow"](iIndex);
	if (oSegmentRow["top"] != fTop) {
		oSegmentRow["top"] = fTop;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_setSegmentRowTop"] = 0; };

UCF_ClientDataGridRow["prototype"]["_setSegmentRowHeight"] = function(iIndex, fHeight) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_setSegmentRowHeight"]++; }; 
	var oSegmentRow = this["_getSegmentRow"](iIndex);
	if (oSegmentRow["height"] != fHeight) {
		oSegmentRow["height"] = fHeight;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_setSegmentRowHeight"] = 0; };

UCF_ClientDataGridRow["prototype"]["_setSegmentRowType"] = function(iIndex, sType) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_setSegmentRowType"]++; }; 
	var oSegmentRow = this["_getSegmentRow"](iIndex);
	if (oSegmentRow["type"] != sType) {
		oSegmentRow["type"] = sType;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_setSegmentRowType"] = 0; };

UCF_ClientDataGridRow["prototype"]["_fGetSegmentRowTop"] = function(iIndex, bShiftedValue) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_fGetSegmentRowTop"]++; }; 
	var oSegmentRow = this["_getSegmentRow"](iIndex);
	if (this["_iDirtyIndex"] <= iIndex) {
		//trigger recalculation starting from iDirtyIndex
		this["recalculateTopPositions"]();
	}
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		//workaround for IE issue of positioning at positions greater than 1500000px
		if (this["_iShiftIndex"] == 0 || !bShiftedValue) {
			return oSegmentRow["top"];
		} else {
			return oSegmentRow["top"] - (this["_iShiftIndex"] * this["_iShiftPosition"]);
		}
	} else {
		return oSegmentRow["top"];
	}

};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_fGetSegmentRowTop"] = 0; };

UCF_ClientDataGridRow["prototype"]["_fGetSegmentRowHeight"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_fGetSegmentRowHeight"]++; }; 
	var oSegmentRow = this["_getSegmentRow"](iIndex);
	return oSegmentRow["height"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_fGetSegmentRowHeight"] = 0; };

UCF_ClientDataGridRow["prototype"]["_sGetSegmentRowType"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_sGetSegmentRowType"]++; }; 
	var oSegmentRow = this["_getSegmentRow"](iIndex);
	return oSegmentRow["type"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["_sGetSegmentRowType"] = 0; };

UCF_ClientDataGridRow["prototype"]["updateRowHeight"] = function(bApply) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["updateRowHeight"]++; }; 

	if (!bApply) {
		if (this["_iApplyUpdateRowHeightTimer"]) {
			clearTimeout(this["_iApplyUpdateRowHeightTimer"]);
		}
		var that = this;
		this["_iApplyUpdateRowHeightTimer"] = setTimeout(function() {
			that["updateRowHeight"](true);
		}, 0);
		return;
	}

	var iRowHeight = 0,
		sRowHeight = "";

	// take only the rows within the current segmentRowCount into account
	for (var i = this["getSegmentRowIndexOffset"](); i < this["getSegmentRowCount"]() + this["getSegmentRowIndexOffset"](); i++) {
		iRowHeight += this["_fGetSegmentRowHeight"](i);
	}

	//dataGridColumnwidth = n * dataGridSegmentColumnWidth - ( n - 1)
	iRowHeight = iRowHeight - (this["getSegmentRowCount"]() - 1);
	sRowHeight = iRowHeight + this["getSegmentRowUnit"]();
	this["setHeight"](sRowHeight, true);
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridRow["_"]["updateRowHeight"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientDataGridSegment"] = function() { var UCF_ClientDataGridSegment = window["UCF_ClientDataGridSegment"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientDataGridSegment"); UCF_ClientDataGridSegment["_"] = {UCF_ClientDataGridSegment: 0}; };/* global UCF_Rectangle */
/// <reference path="../../core/types/Rectangle.js"/>
/* global UCF_ClientElement */
/// <reference path="../core/ClientElement.js"/>

/* global UCF_ClientDataGridSegment */
/**
 * @class UCF_ClientDataGridSegment is the ClientElement Class for UCF_DataGridSegment
 *
 * It overwrites the necessary methods for virtualization and updating aggregations.
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["initialize"]++; }; 
	this["bVisibleRangeCalculated"] = false;

	this["mCellIds"] = {};
	this["mCellContexts"] = {};
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["initialize"] = 0; };

/**
 * Handles the onAfterRendering event of the
 * the RenderManager
 * @see UCF_RenderManager
 * After rendering the UCF instance is notified to check the size
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["onAfterRendering"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onAfterRendering"]++; }; 
	UCF_ClientElement["prototype"]["onAfterRendering"]["apply"](this);
	if (this["getUCFInstance"]()) {
		this["getUCFInstance"]()["checkResize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onAfterRendering"] = 0; };

UCF_ClientDataGridSegment["prototype"]["getDataGridColumn"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getDataGridColumn"]++; }; 
	return this["getParent"]()["getParent"]()["getColumns"]()[this["getParent"]()["indexOfAggregation"]("Segments", this)]; //wow
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getDataGridColumn"] = 0; };

UCF_ClientDataGridSegment["prototype"]["getDataGridRow"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getDataGridRow"]++; }; 
	return this["getParent"]();
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getDataGridRow"] = 0; };

/**
 * @see UCF_ClientElement
 * @param {string} sName
 */
UCF_ClientDataGridSegment["prototype"]["updateAggregation"] = function(sName) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["updateAggregation"]++; }; 
	this["mCellContexts"] = {};
	this["mCellIds"] = {};
	UCF_ClientElement["prototype"]["updateAggregation"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["updateAggregation"] = 0; };

/**
 * Returns whether the segment has cells or not.
 *
 * @return {boolean} Whether the segment has cells or not.
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["hasCells"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["hasCells"]++; }; 
	return this["getCells"]()["length"] > 0;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["hasCells"] = 0; };

/**
 * @see UCF_ClientElement
 *
 * Sets the virtualization on the Cells aggregation.
 *
 * @param {string} sName
 * @param {object} oContext
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["bindAggregation"] = function(sName, oContext) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["bindAggregation"]++; }; 
	if (sName == "Cells") {
		//virtualize cells aggregation
		this["setVirtualize"]("Cells", true);
	}
	//always call super
	UCF_ClientElement["prototype"]["bindAggregation"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["bindAggregation"] = 0; };

/**
 * Returns the currently visible range determined by the UCF_DataGridSegment
 *
 * @param {string} sName
 * @param {object} oBinding
 * @return {object} The range object with {iStartX,iStartY,iEndX,iEndY}
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["getVisibleRange"] = function(sName, oBinding) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getVisibleRange"]++; }; 
	if (sName == "Cells") {
		if (!this["getDataGridRow"]() || !this["getDataGridColumn"]()) {
			return null;
		}
		if (!this["getDataGridRow"]()["bGetVisibleRangeCalculated"]() || !this["getDataGridColumn"]()["bGetVisibleRangeCalculated"]()
			|| this["getDataGridRow"]()["getSegmentRowCount"]() == 0 || this["getDataGridColumn"]()["getSegmentColumnCount"]() == 0) {
			return null;
		}

		var oUCFSegment = this["getUCFInstance"]();

		if (oUCFSegment) {
			if (!this["getDataGridRow"]()["bGetVisibleRangeCalculated"]()) {
				this["getDataGridRow"]()["calcVisibleCellRange"]();
			}
			if (!this["getDataGridColumn"]()["bGetVisibleRangeCalculated"]()) {
				this["getDataGridColumn"]()["calcVisibleCellRange"]();
			}
			return {
				"iStartX": this["getDataGridColumn"]()["getFirstVisibleSegmentColumnIndex"](),
				"iStartY": this["getDataGridRow"]()["getFirstVisibleSegmentRowIndex"](),
				"iEndX": this["getDataGridColumn"]()["iGetLastVisibleSegmentColumnIndex"](),
				"iEndY": this["getDataGridRow"]()["iGetLastVisibleSegmentRowIndex"]()
			};
		} else return null;
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getVisibleRange"] = 0; };

/**
 * Handles the onCloneCreate event of the UCF_ClientElement
 *
 * @see UCF_ClientElement
 *
 * @param {object} oCell
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["onCloneCreate"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onCloneCreate"]++; }; 
	oCell["setDisplay"](false);
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onCloneCreate"] = 0; };

/**
 * Handles the onCloneReturn event of the UCF_ClientElement
 *
 * @see UCF_ClientElement
 *
 * @param {object} oCell
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["onCloneReturn"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onCloneReturn"]++; }; 
	oCell["setDisplay"](false);
	oCell["setFocused"](false);
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onCloneReturn"] = 0; };

/**
 * Handles the onCloneUpdate event of the UCF_ClientElement
 *
 * @see UCF_ClientElement
 *
 * @param {object} oCell
 * @param {object} oContext
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["onCloneUpdate"] = function(oCell, oContext) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onCloneUpdate"]++; }; 

	var oParameter = oContext["getBindingParameter"]();
	this["setCellContext"](oCell["getId"](), oParameter["x"], oParameter["y"]);

	//	_trace(INFO,""+oCell.sId + " -x:" + oContext.getBindingParameter().x + " y:"+ oContext.getBindingParameter().y);
	var oDataGridRow = this["getParent"](),
		oDataGridColumn = oDataGridRow["getParent"]()["getColumns"]()[this["getParent"]()["indexOfAggregation"]("Segments", this)],
		iX = oParameter["x"],
		iY = oParameter["y"],
		sSegmentRowUnit = oDataGridRow["getSegmentRowUnit"](),
		sSegmentColumnUnit = oDataGridColumn["getSegmentColumnUnit"]();

	if (iX > (oDataGridColumn["getSegmentColumnCount"]() + oDataGridColumn["getSegmentColumnIndexOffset"]() - 1) || iY > (oDataGridRow["getSegmentRowCount"]() + oDataGridRow["getSegmentRowIndexOffset"]() - 1)) {
		oCell["setDisplay"](false);
		oCell["setFocused"](false);
		return;
	}
	if (!sSegmentRowUnit || sSegmentRowUnit == "") sSegmentRowUnit = "px";
	if (!sSegmentColumnUnit || sSegmentColumnUnit == "") sSegmentColumnUnit = "px";

	var sWidth = oDataGridColumn["_fGetSegmentColumnWidth"](iX) + sSegmentColumnUnit,
		sHeight = oDataGridRow["_fGetSegmentRowHeight"](iY) + sSegmentRowUnit,
		sLeft = oDataGridColumn["_fGetSegmentColumnLeft"](iX, true) + sSegmentColumnUnit,
		sTop = oDataGridRow["_fGetSegmentRowTop"](iY, true) + sSegmentRowUnit,
		sSegmentColumnType = oDataGridColumn["_sGetSegmentColumnType"](iX),
		sSegmentRowType = oDataGridRow["_sGetSegmentRowType"](iY);

	oCell["setDisplay"](true);
	oCell["setWidth"](sWidth, true);
	oCell["setHeight"](sHeight, true);
	oCell["setTop"](sTop, true);
	oCell["setLeft"](sLeft, true);
	oCell["setColumnType"](sSegmentColumnType, true);
	oCell["setRowType"](sSegmentRowType, true);
	oCell["reinitialize"]();
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onCloneUpdate"] = 0; };

/**
 * Handles the onCloneUpdateStart event of the UCF_ClientElement
 *
 * @see UCF_ClientElement
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["onCloneUpdateStart"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onCloneUpdateStart"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	//skip ResizeEventHelper for performance reasons (offsetWidth/offsetHeight determination expensive in large DOMs)
	if (oUCFInstance && oUCFInstance["oLS"]["oBrowserWindow"]["oResizeEventHelper"]) {
		oUCFInstance["oLS"]["oBrowserWindow"]["oResizeEventHelper"]["skipResizeEventEmulation"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onCloneUpdateStart"] = 0; };

/**
 * Handles the onCloneUpdateEnd event of the UCF_ClientElement
 * It sets the focus to the cell of the DataGrid
 *
 * @see UCF_ClientElement
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["onCloneUpdateEnd"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onCloneUpdateEnd"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();
	if (oUCFInstance && oUCFInstance["oDataGrid"] && oUCFInstance["oDataGrid"]["getUCFInstance"]()) {
		if (oUCFInstance["oDataGrid"]["getUCFInstance"]()) {
			oUCFInstance["oDataGrid"]["getUCFInstance"]()["focusAfterUpdate"]();
		}
	}
	//continue ResizeEventHelper
	if (oUCFInstance && oUCFInstance["oLS"]["oBrowserWindow"]["oResizeEventHelper"]) {
		oUCFInstance["oLS"]["oBrowserWindow"]["oResizeEventHelper"]["continueResizeEventEmulation"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["onCloneUpdateEnd"] = 0; };

/**
 * Returns the UCF_ClientDataGrid of this segment
 *
 * @return {UCF_ClientDataGrid} The UCF_ClientDataGrid of this segment
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["getDataGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getDataGrid"]++; }; 
	return this["getParent"]()["getParent"]();
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getDataGrid"] = 0; };

/**
 * Returns the total row count for this segment
 *
 * @return {int} The total row count for this segment
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["getRowCount"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getRowCount"]++; }; 
	return this["getRows"]()["length"] + this["getStartRowIndex"]();
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getRowCount"] = 0; };

/**
 * Returns the total col count for this segment
 *
 * @return {int} The total col count for this segment
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["getColCount"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getColCount"]++; }; 
	return this["getCols"]()["length"] + this["getStartColIndex"]();
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getColCount"] = 0; };

/**
 * Returns the column definitions for this segment
 *
 * @return {Array}  Array of DataGridSegmentColumn - The column definitions for this segment
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["getCols"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getCols"]++; }; 
	var iGridCol = this["getGridCol"]();
	return this["getDataGrid"]()["getColumns"]()[iGridCol]["getSegmentColumns"]();
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getCols"] = 0; };

/**
 * Returns the row definitions for this segment
 *
 * @return {Array}  Array of DataGridSegmentRow - The row definitions for this segment
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["getRows"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getRows"]++; }; 
	return this["getParent"]()["getSegmentRows"]();
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getRows"] = 0; };

/**
 * Returns the start index of the rows in this segment
 * Normally the start index is 0 but can be overwritten
 *
 * @return {int} The start index of the rows in this segment
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["getStartRowIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getStartRowIndex"]++; }; 
	return this["getParent"]()["getSegmentRowIndexOffset"]();
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getStartRowIndex"] = 0; };

/**
 * Returns the start index of the cols in this segment
 * Normally the start index is 0 but can be overwritten
 *
 * @return {int} The start index of the cols in this segment
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["getStartColIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getStartColIndex"]++; }; 
	return this["getDataGrid"]()["getColumns"]()[this["getGridColIndex"]()]["getSegmentColumnIndexOffset"]();
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getStartColIndex"] = 0; };

/**
 * Returns the index of the grid col of this segment
 *
 * @return {int} The index of the grid col of this segment
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["getGridColIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getGridColIndex"]++; }; 
	return this["getParent"]()["indexOfAggregation"]("Segments", this);
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getGridColIndex"] = 0; };

/**
 * Returns the index of the grid row of this segment
 *
 * @return {int} The index of the grid row of this segment
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["getGridRowIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getGridRowIndex"]++; }; 
	return this["getDataGrid"]()["indexOfAggregation"]("Rows", this["getParent"]());
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getGridRowIndex"] = 0; };

/**
 * Returns the next client segment in Y direction
 *
 * @return {int} the next client segment in Y direction
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["nextYSegment"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["nextYSegment"]++; }; 
	return this["getDataGrid"]()["getRows"]()[this["getGridRow"]() + 1];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["nextYSegment"] = 0; };

/**
 * Returns the next client segment in X direction
 *
 * @return {int} the next client segment in X direction
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["nextXSegment"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["nextXSegment"]++; }; 
	return this["getParent"]()["getSegments"]()[this["getGridCol"]() + 1];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["nextXSegment"] = 0; };

/**
 * Returns the previous client segment in Y direction
 *
 * @return {int} the previous client segment in Y direction
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["previousYSegment"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["previousYSegment"]++; }; 
	return this["getDataGrid"]()["getRows"]()[this["getGridRowIndex"]() - 1];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["previousYSegment"] = 0; };

/**
 * Returns the previous client segment in X direction
 *
 * @return {int} the previous client segment in X direction
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["previousXSegment"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["previousXSegment"]++; }; 
	return this["getParent"]()["getSegments"]()[this["getGridColIndex"]() - 1];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["previousXSegment"] = 0; };

/**
 * Returns the position rect of a cell with the given col and row in the segment.
 *
 * @param {int} iCol
 * @param {int} iRow
 * @param {boolean} bRecalculate
 *
 * @return {UCF_Rectangle} A rectangle of the position.
 *
 * @private
 */
UCF_ClientDataGridSegment["prototype"]["getCellPosition"] = function(iCol, iRow, bRecalculate) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getCellPosition"]++; }; 
	var aRows = this["getRows"](),
		aCols = this["getCols"]();
	if (aCols[iCol]["left"] == null || bRecalculate) {
		var iLeft = 0;
		for (var i = 0; i < aCols["length"]; i++) {
			var oCol = aCols[i];
			oCol["width"] = parseInt(oCol["getWidth"]());
			oCol["left"] = iLeft;
			iLeft = iLeft + oCol["width"];
		}
	}
	if (aRows[iRow]["top"] == null || bRecalculate) {
		var iTop = 0;
		for (i = 0; i < aRows["length"]; i++) {
			var oRow = aRows[i];
			oRow["height"] = parseInt(oRow["getHeight"]());
			oRow["top"] = iTop;
			iTop = iTop + oRow["height"];
		}
	}
	return new (UCF_ClassLoader["oGetClass"]("UCF_Rectangle"))(aRows[iRow]["top"], aCols[iCol]["left"], aCols[iCol]["width"], aRows[iRow]["height"]);
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getCellPosition"] = 0; };

UCF_ClientDataGridSegment["prototype"]["setCellsAggregationDirtyState"] = function(bState) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["setCellsAggregationDirtyState"]++; }; 
	this["bCellsAggregationDirty"] = bState;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["setCellsAggregationDirtyState"] = 0; };

UCF_ClientDataGridSegment["prototype"]["bGetCellsAggregationDirtyState"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["bGetCellsAggregationDirtyState"]++; }; 
	return this["bCellsAggregationDirty"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["bGetCellsAggregationDirtyState"] = 0; };

UCF_ClientDataGridSegment["prototype"]["setCellContext"] = function(sId, iX, iY) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["setCellContext"]++; }; 
	this["mCellContexts"][iX + "-" + iY] = sId;
	this["mCellIds"][sId] = iX + "-" + iY;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["setCellContext"] = 0; };

UCF_ClientDataGridSegment["prototype"]["getCellGridContext"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getCellGridContext"]++; }; 
	var aCoors = this["mCellIds"][sId]["split"]("-");
	return { "x": aCoors[0], "y": aCoors[1] };
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getCellGridContext"] = 0; };

UCF_ClientDataGridSegment["prototype"]["getCellId"] = function(iX, iY) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getCellId"]++; }; 
	return this["mCellContexts"][iX + "-" + iY];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegment["_"]["getCellId"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientDataGridSegmentCell"] = function() { var UCF_ClientDataGridSegmentCell = window["UCF_ClientDataGridSegmentCell"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientDataGridSegmentCell"); UCF_ClientDataGridSegmentCell["_"] = {UCF_ClientDataGridSegmentCell: 0}; };/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_ClientElement */
/// <reference path="../core/ClientElement.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_UrBase */
/// <reference path="../controls/base/UrBase.js"/>

/* global UCF_ClientDataGridSegmentCell */

/* eslint eqeqeq:0 */

/** */
UCF_ClientDataGridSegmentCell["prototype"]["reinitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["reinitialize"]++; }; 
	this["_sDisplay"] = null;
	this["__sWidth"] = null;
	this["__sHeight"] = null;
	this["__sTop"] = null;
	this["__sLeft"] = null;
	this["_sHierarchyState"] = null;
	this["_iHierarchyLevel"] = null;
	this["_sIconSrc"] = null;
	this["_sSortState"] = null;
	this["_bFiltered"] = null;
	this["_bRotateContent"] = null;
	this["_sActionMenuId"] = null;
	this["__iContentFragmentWidth"] = null;
	this["__iContentFragmentLeft"] = null;
	this["__sRowType"] = null;
	this["__sColumnType"] = null;
	this["__sClassName"] = null;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["reinitialize"] = 0; };

/**
 * @override
 * @param {string} sSkipLocal
 */
UCF_ClientDataGridSegmentCell["prototype"]["updateBindingContext"] = function(sSkipLocal) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["updateBindingContext"]++; }; 
	// create path to __selection
	/** @type {string} */
	var sSelectionPath = '__selected';

	// call super
	UCF_ClientElement["prototype"]["updateBindingContext"]["apply"](this, arguments);

	// bind the Selection property to the selection path and put a formatting
	// function to map the values
	this["bindProperty"]('SelectionState', sSelectionPath, function(iValue) {
		if (iValue === true) { iValue = 1; }
		if (iValue === false) { iValue = 0; }
		switch (iValue) {
			case -1:
				return 'NOT_SELECTABLE';
			case 0:
				return 'NOT_SELECTED';
			case 1:
				return 'PRIMARY_SELECTED';
			case 2: // eslint-disable-line no-magic-numbers
				return 'SELECTED';
			default:
				return 'NOT_SELECTED';
		}
	});
	this["bindMerge"]();
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["updateBindingContext"] = 0; };

/** */
UCF_ClientDataGridSegmentCell["prototype"]["unbindMerge"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["unbindMerge"]++; }; 
	if (this["oMergeBinding"]) {
		this["oMergeBinding"]["detachChange"](this["fMergeHandler"]);
		this["oMergeBinding"]["destroy"]();
		this["oMergeBinding"] = null;
		this["oMergeData"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["unbindMerge"] = 0; };

/** */
UCF_ClientDataGridSegmentCell["prototype"]["bindMerge"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["bindMerge"]++; }; 
	/** @type {UCF_ClientDataGridSegmentCell} */
	var self;

	this["unbindMerge"]();
	if (this["getBindingContext"]()) {
		self = this;

		this["oMergeBinding"] = this["getBindingContext"]()
			["getModel"]()
			["bindProperty"]('__merge', this["getBindingContext"]());
		this["oMergeData"] = this["oMergeBinding"]["getValue"]();
		this["fMergeHandler"] = function() {
			self["oMergeData"] = self["oMergeBinding"]["getValue"]();
			self["updateInnerHTML"](self["getId"]());
		};

		this["oMergeBinding"]["attachChange"](this["fMergeHandler"]);
		this["fMergeHandler"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["bindMerge"] = 0; };

/** @override */
UCF_ClientDataGridSegmentCell["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["destroy"]++; }; 
	this["unbindMerge"]();
	UCF_ClientElement["prototype"]["destroy"]["apply"](this, []);
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["destroy"] = 0; };

/** @param {boolean} bShow */
UCF_ClientDataGridSegmentCell["prototype"]["setDisplay"] = function(bShow) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setDisplay"]++; }; 
	this["_bShow"] = bShow;
	this["updateInnerHTML"](this["getId"]());
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setDisplay"] = 0; };

/** @return {UCF_DataGridSegment} */
UCF_ClientDataGridSegmentCell["prototype"]["oGetUCFSegment"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["oGetUCFSegment"]++; }; 
	if (this["_oUCFSegment"]) {
		return this["_oUCFSegment"];
	} else {
		this["_oSegment"] = this["getParent"]();

		if (this["_oSegment"]) {
			this["_oUCFSegment"] = this["_oSegment"]["getUCFInstance"]();

			return this["_oUCFSegment"];
		} else {
			return null;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["oGetUCFSegment"] = 0; };

/** @return {UCF_ClientDataGridSegment} */
UCF_ClientDataGridSegmentCell["prototype"]["oGetSegment"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["oGetSegment"]++; }; 
	if (this["_oSegment"]) {
		return this["_oSegment"];
	} else {
		this["_oSegment"] = this["getParent"]();

		return this["_oSegment"];
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["oGetSegment"] = 0; };

/** @param {boolean} bFocused */
UCF_ClientDataGridSegmentCell["prototype"]["setFocused"] = function(bFocused) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setFocused"]++; }; 
	if (this["_bFocused"] != bFocused) {
		this["_bFocused"] = bFocused;
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setFocused"] = 0; };

/** @param {string} sWidth */
UCF_ClientDataGridSegmentCell["prototype"]["setWidth"] = function(sWidth) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setWidth"]++; }; 
	if (this["_sWidth"] != sWidth) {
		this["_sWidth"] = sWidth;
		this["_sOriginalWidth"] = sWidth;
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setWidth"] = 0; };

/** @param {string} sHeight */
UCF_ClientDataGridSegmentCell["prototype"]["setHeight"] = function(sHeight) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setHeight"]++; }; 
	if (this["_sHeight"] != sHeight) {
		this["_sHeight"] = sHeight;
		this["_sOriginalHeight"] = sHeight;
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setHeight"] = 0; };

/** @param {string} sTop */
UCF_ClientDataGridSegmentCell["prototype"]["setTop"] = function(sTop) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setTop"]++; }; 
	if (this["_sTop"] != sTop) {
		this["_sTop"] = sTop;
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setTop"] = 0; };

/** @param {string} sLeft */
UCF_ClientDataGridSegmentCell["prototype"]["setLeft"] = function(sLeft) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setLeft"]++; }; 
	if (this["_sLeft"] != sLeft) {
		this["_sLeft"] = sLeft;
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setLeft"] = 0; };

/** @param {string} sColumnType */
UCF_ClientDataGridSegmentCell["prototype"]["setColumnType"] = function(sColumnType) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setColumnType"]++; }; 
	if (this["_sColumnType"] != sColumnType) {
		this["_sColumnType"] = sColumnType;
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setColumnType"] = 0; };

/** @param {string} sRowType */
UCF_ClientDataGridSegmentCell["prototype"]["setRowType"] = function(sRowType) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setRowType"]++; }; 
	if (this["_sRowType"] != sRowType) {
		this["_sRowType"] = sRowType;
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setRowType"] = 0; };

/** @param {string} sActionMenuId */
UCF_ClientDataGridSegmentCell["prototype"]["setActionMenuId"] = function(sActionMenuId) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setActionMenuId"]++; }; 
	if (this["getActionMenuId"]() != sActionMenuId) {
		this["setProperty"]('ActionMenuId', sActionMenuId, true);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setActionMenuId"] = 0; };

/** @param {string} sDragSourceInfo */
UCF_ClientDataGridSegmentCell["prototype"]["setDragSourceInfo"] = function(sDragSourceInfo) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setDragSourceInfo"]++; }; 
	/** @type {UCF_DataGridSegmentCell} */
	var oUCFCell;

	if (this["getDragSourceInfo"]() != sDragSourceInfo) {
		oUCFCell = this["getUCFInstance"]();

		if (oUCFCell) {
			this["setProperty"]('DragSourceInfo', sDragSourceInfo, true);
			if (sDragSourceInfo != oUCFCell["sDragSourceInfo"] && sDragSourceInfo != null) {
				oUCFCell["setDragSourceInfo"](sDragSourceInfo);
			}
		} else {
			this["setProperty"]('DragSourceInfo', sDragSourceInfo, true);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setDragSourceInfo"] = 0; };

/** @param {string} sSortState */
UCF_ClientDataGridSegmentCell["prototype"]["setSortState"] = function(sSortState) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setSortState"]++; }; 
	if (this["getSortState"]() != sSortState) {
		this["setProperty"]('SortState', sSortState, true);
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setSortState"] = 0; };

/** @param {boolean} bFiltered */
UCF_ClientDataGridSegmentCell["prototype"]["setFiltered"] = function(bFiltered) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setFiltered"]++; }; 
	if (this["getFiltered"]() != bFiltered) {
		this["setProperty"]('Filtered', bFiltered, true);
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setFiltered"] = 0; };

/** @param {string} sIconSrc */
UCF_ClientDataGridSegmentCell["prototype"]["setIconSrc"] = function(sIconSrc) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setIconSrc"]++; }; 
	if (this["getIconSrc"]() != sIconSrc) {
		this["setProperty"]('IconSrc', sIconSrc, true);
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setIconSrc"] = 0; };

/** @param {string} sHierarchyState */
UCF_ClientDataGridSegmentCell["prototype"]["setHierarchyState"] = function(sHierarchyState) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setHierarchyState"]++; }; 
	if (this["getHierarchyState"]() != sHierarchyState) {
		this["setProperty"]('HierarchyState', sHierarchyState, true);
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setHierarchyState"] = 0; };

/** @param {number} iHierarchyLevel */
UCF_ClientDataGridSegmentCell["prototype"]["setHierarchyLevel"] = function(iHierarchyLevel) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setHierarchyLevel"]++; }; 
	if (this["getHierarchyLevel"]() != iHierarchyLevel) {
		this["setProperty"]('HierarchyLevel', iHierarchyLevel, true);
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setHierarchyLevel"] = 0; };

/** @param {string} sSemanticColor */
UCF_ClientDataGridSegmentCell["prototype"]["setSemanticColor"] = function(sSemanticColor) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setSemanticColor"]++; }; 
	if (this["getSemanticColor"]() != sSemanticColor) {
		this["setProperty"]('SemanticColor', sSemanticColor, true);
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setSemanticColor"] = 0; };

/** @param {string} sSemanticType */
UCF_ClientDataGridSegmentCell["prototype"]["setSemanticType"] = function(sSemanticType) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setSemanticType"]++; }; 
	if (this["getSemanticType"]() != sSemanticType) {
		this["setProperty"]('SemanticType', sSemanticType, true);
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setSemanticType"] = 0; };

/** @param {string} sVerticalAlign */
UCF_ClientDataGridSegmentCell["prototype"]["setVerticalAlign"] = function(sVerticalAlign) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setVerticalAlign"]++; }; 
	if (this["getVerticalAlign"]() != sVerticalAlign) {
		this["setProperty"]('VerticalAlign', sVerticalAlign, true);
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setVerticalAlign"] = 0; };

/** @param {boolean} bRotateContent */
UCF_ClientDataGridSegmentCell["prototype"]["setRotateContent"] = function(bRotateContent) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setRotateContent"]++; }; 
	if (this["getRotateContent"]() != bRotateContent) {
		this["setProperty"]('RotateContent', bRotateContent, true);
		this["updateInnerHTML"](this["getId"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setRotateContent"] = 0; };

/** */
UCF_ClientDataGridSegmentCell["prototype"]["calcMergeRange"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["calcMergeRange"]++; }; 
	/** @type {TODO} */
	var oMergeData;
	/** @type {boolean} */
	var bFound;
	/** @type {number} */
	var x;
	/** @type {number} */
	var y;
	/** @type {UCF_ClientDataGridSegmentCell} */
	var oTopLeftCell;

	if (this["oMergeData"]) {
		oMergeData = this["oMergeData"];
		bFound = false;

		for (x = oMergeData["from_x"]; x < oMergeData["to_x"] + 1; x++) {
			for (y = oMergeData["from_y"]; y < oMergeData["to_y"] + 1; y++) {
				oTopLeftCell = this["oLS"]["oControlFactory"]["oGetClientControlById"](this["oGetSegment"]()["getCellId"](x, y));

				if (oTopLeftCell) {
					this["_bMergedShow"] = oTopLeftCell == this;
					bFound = true;
					break;
				} else {
					this["_bMergedShow"] = false;
				}
			}
			if (bFound) {
				break;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["calcMergeRange"] = 0; };

/** @return {boolean} */
UCF_ClientDataGridSegmentCell["prototype"]["bIsMerged"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["bIsMerged"]++; }; 
	/** @type {number} */
	var iX;
	/** @type {number} */
	var iY;
	/** @type {TODO} */
	var oMergeData;

	if (this["oMergeData"]) {
		iX = this["getBindingContext"]()["oParameter"]["x"];
		iY = this["getBindingContext"]()["oParameter"]["y"];
		oMergeData = this["oMergeData"];

		return oMergeData["from_x"] <= iX && iX <= oMergeData["to_x"] &&
			oMergeData["from_y"] <= iY && iY <= oMergeData["to_y"];
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["bIsMerged"] = 0; };

/** @param {string} sSelectionState */
UCF_ClientDataGridSegmentCell["prototype"]["setSelectionState"] = function(sSelectionState) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setSelectionState"]++; }; 
	/** @type {TODO} */
	var oBindingContext;
	/** @type {number} */
	var iX;
	/** @type {number} */
	var iY;
	/** @type {boolean} */
	var bBeforeSiblingSelected;
	/** @type {boolean} */
	var bBehindSiblingSelected;
	/** @type {boolean} */
	var bTopSiblingSelected;
	/** @type {boolean} */
	var bBottomSiblingSelected;
	/** @type {boolean} */
	var bSelected;
	/** @type {UCF_ClientDataGridSegment} */
	var oSegment;
	/** @type {UCF_ClientDataGridSegmentCell} */
	var oBeforeSiblingCell;
	/** @type {UCF_ClientDataGridSegmentCell} */
	var oBehindSiblingCell;
	/** @type {UCF_ClientDataGridSegmentCell} */
	var oTopSiblingCell;
	/** @type {UCF_ClientDataGridSegmentCell} */
	var oBottomSiblingCell;

	if (this["getSelectionState"]() != sSelectionState) {
		this["setProperty"]('SelectionState', sSelectionState, true);
		this["updateInnerHTML"](this["getId"]());

		// applySelectionStateStyle to sibling cells (to render border style of ranges selections correctly)
		this["_oUCFSegment"] = this["oGetUCFSegment"]();
		oBindingContext = this["getBindingContext"]();

		if (this["_oUCFSegment"] && oBindingContext) {
			iX = oBindingContext["oParameter"]["x"];
			iY = oBindingContext["oParameter"]["y"];
			bBeforeSiblingSelected = this["bIsNeighborCellSelected"]((iX - 1), iY);
			bBehindSiblingSelected = this["bIsNeighborCellSelected"]((iX + 1), iY);
			bTopSiblingSelected = this["bIsNeighborCellSelected"](iX, (iY - 1));
			bBottomSiblingSelected = this["bIsNeighborCellSelected"](iX, (iY + 1));
			bSelected = (sSelectionState == 'SELECTED' || sSelectionState == 'PRIMARY_SELECTED');
			oSegment = this["oGetSegment"]();

			if (bBeforeSiblingSelected) {
				oBeforeSiblingCell = this["oLS"]["oControlFactory"]["oGetClientControlById"](
					oSegment["getCellId"]((iX - 1), iY)
				);
				if (oBeforeSiblingCell) {
					oBeforeSiblingCell["applySelectionBehindBorderStyles"](bSelected);
				}
			}
			if (bBehindSiblingSelected) {
				oBehindSiblingCell = this["oLS"]["oControlFactory"]["oGetClientControlById"](
					oSegment["getCellId"]((iX + 1), iY)
				);
				if (oBehindSiblingCell) {
					oBehindSiblingCell["applySelectionBeforeBorderStyles"](bSelected);
				}
			}
			if (bTopSiblingSelected) {
				oTopSiblingCell = this["oLS"]["oControlFactory"]["oGetClientControlById"](
					oSegment["getCellId"](iX, (iY - 1))
				);
				if (oTopSiblingCell) {
					oTopSiblingCell["applySelectionBottomBorderStyles"](bSelected);
				}
			}
			if (bBottomSiblingSelected) {
				oBottomSiblingCell = this["oLS"]["oControlFactory"]["oGetClientControlById"](
					oSegment["getCellId"](iX, (iY + 1))
				);
				if (oBottomSiblingCell) {
					oBottomSiblingCell["applySelectionTopBorderStyles"](bSelected);
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setSelectionState"] = 0; };

// eslint-disable-next-line complexity
UCF_ClientDataGridSegmentCell["prototype"]["updateInnerHTML"] = function(sId, bApply) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["updateInnerHTML"]++; }; 
	/** @type {HTMLElement} */
	var oCellDomRef = UCF_DomUtil["$"](sId);
	/** @type {UCF_ClientDataGridSegmentCell} */
	var oCell;
	/** @type {UCF_ClientDataGridSegmentCell} */
	var self;
	/** @type {TODO} */
	var oMergeData;
	/** @type {number} */
	var iX;
	/** @type {number} */
	var iY;
	/** @type {number} */
	var x;
	/** @type {number} */
	var y;
	/** @type {Object} */
	var oBindingContext;
	/** @type {HTMLElement} */
	var oHierarchyFragment;
	/** @type {HTMLElement} */
	var oIconFragment;
	/** @type {HTMLElement} */
	var oContentFragment;
	/** @type {HTMLElement} */
	var oDividerFragment;
	/** @type {HTMLElement} */
	var oFilterFragment;
	/** @type {HTMLElement} */
	var oSortFragment;
	/** @type {string} */
	var sFilterFragmentClassName;
	/** @type {string} */
	var sCellWidth;
	/** @type {string} */
	var sActionMenuId;
	/** @type {string} */
	var sIconSrc;
	/** @type {boolean} */
	var bFiltered;
	/** @type {boolean} */
	var bRotateContent;
	/** @type {string} */
	var sVerticalAlign;
	/** @type {string} */
	var sSortState;
	/** @type {Object<string, {classname: string}>} */
	var mSortFragmentStates;
	/** @type {{classname: string}} */
	var oSortFragmentState;
	/** @type {string} */
	var sHierarchyState;
	/** @type {number} */
	var iHierarchyLevel;
	/** @type {Object<string, {display: string, classname: string, width: number, left: number}>} */
	var mHierarchyFragmentStates;
	/** @type {{display: string, classname: string, width: number, left: number}} */
	var oHierarchyFragmentState;
	/** @type {string} */
	var sPos;
	/** @type {string[]} */
	var aIconSrc;
	/** @type {string[]} */
	var aBGImages;
	/** @type {string[]} */
	var aBGPositions;
	/** @type {number} */
	var i;
	/** @type {number} */
	var iTranslateX;
	/** @type {number} */
	var iTranslateY;
	/** @type {number} */
	var iRotate;

	if (oCellDomRef) {
		if (!this["_bShow"]) {
			UCF_DomUtil["setStyle"](oCellDomRef, {
				"transition": '',
				"opacity": 0
			});
			this["_sDisplay"] = 'none';

			return;
		}

		if (!bApply) {
			if (this["_iApplyUpdateTimer"]) {
				clearTimeout(this["_iApplyUpdateTimer"]);
			}
			self = this;
			this["_iApplyUpdateTimer"] = setTimeout(function() {
				self["updateInnerHTML"](sId, true);
			}, 0);

			return;
		}

		this["__bShowLeftBorder"] = true;
		this["__bShowTopBorder"] = true;
		this["__bShowRightBorder"] = true;
		this["__bShowBottomBorder"] = true;

		if (this["oMergeData"]) {
			this["calcMergeRange"]();
			if (this["_bMergedShow"]) {
				if (this["_sOriginalHeight"]) {
					this["_sHeight"] = this["_sOriginalHeight"];
				} else {
					this["_sOriginalHeight"] = this["_sHeight"];
				}
				if (this["_sOriginalWidth"]) {
					this["_sWidth"] = this["_sOriginalWidth"];
				} else {
					this["_sOriginalWidth"] = this["_sWidth"];
				}
				oMergeData = this["oMergeData"];
				iX = this["getBindingContext"]()["oParameter"]["x"];
				iY = this["getBindingContext"]()["oParameter"]["y"];

				for (x = iX; x < oMergeData["to_x"] + 1; x++) {
					oCell = this["oLS"]["oControlFactory"]["oGetClientControlById"](this["oGetSegment"]()["getCellId"](x, iY));
					if (oCell && oCell != this) { // eslint-disable-line max-depth
						this["_sWidth"] = (parseInt(this["_sWidth"]) + parseInt(oCell["_sWidth"]) - 1) + 'px';
					}
					this["__bShowRightBorder"] = (oCell != null);
				}
				for (y = iY; y < oMergeData["to_y"] + 1; y++) {
					oCell = this["oLS"]["oControlFactory"]["oGetClientControlById"](this["oGetSegment"]()["getCellId"](iX, y));
					if (oCell && oCell != this) { // eslint-disable-line max-depth
						this["_sHeight"] = (parseInt(this["_sHeight"]) + parseInt(oCell["_sHeight"]) - 1) + 'px';
					}
					this["__bShowBottomBorder"] = (oCell != null);
				}
				this["__bShowLeftBorder"] = oMergeData["from_x"] == iX;
				this["__bShowTopBorder"] = oMergeData["from_y"] == iY;
			} else {
				UCF_DomUtil["setStyle"](oCellDomRef, 'display', 'none');
				this["_sDisplay"] = 'none';

				return;
			}
		}

		if (this["_sDisplay"] != 'block') {
			this["_sDisplay"] = 'block';

			oBindingContext = this["getBindingContext"]();

			UCF_DomUtil["setStyle"](oCellDomRef, UCF_JsUtil["extend"]({
					"display": this["_sDisplay"],
					"opacity": 1
				}, oBindingContext && oBindingContext["bValid"]
				? { "transition": 'opacity 100ms', "msTransition": 'opacity 100ms' }
				: oBindingContext && oBindingContext["oParameter"] && oBindingContext["oParameter"]["templated"]
				? { "transition": 'opacity 500ms 200ms', "msTransition": 'opacity 500ms 200ms' }
				: { "transition": 'opacity 200ms', "msTransition": 'opacity 200ms' }));
		}
		if (this["__sWidth"] != this["_sWidth"]) {
			this["__sWidth"] = this["_sWidth"];
			UCF_DomUtil["setStyle"](oCellDomRef, 'width', this["_sWidth"]);
		}
		if (this["__sHeight"] != this["_sHeight"]) {
			this["__sHeight"] = this["_sHeight"];
			UCF_DomUtil["setStyle"](oCellDomRef, 'height', this["_sHeight"]);
		}
		if (this["__sTop"] != this["_sTop"]) {
			this["__sTop"] = this["_sTop"];
			UCF_DomUtil["setStyle"](oCellDomRef, 'top', this["_sTop"]);
		}
		if (this["__sLeft"] != this["_sLeft"]) {
			this["__sLeft"] = this["_sLeft"];
			UCF_DomUtil["setStyle"](oCellDomRef, window["UCF_System"]["bIsRTL"] ? 'right' : 'left', this["_sLeft"]);
		}

		oHierarchyFragment = oCellDomRef["childNodes"][0];
		oIconFragment = oCellDomRef["childNodes"][1];
		// eslint-disable-next-line no-magic-numbers
		oContentFragment = oCellDomRef["childNodes"][2];
		// eslint-disable-next-line no-magic-numbers
		oDividerFragment = oCellDomRef["childNodes"][3];
		// eslint-disable-next-line no-magic-numbers
		oFilterFragment = oCellDomRef["childNodes"][4];
		// eslint-disable-next-line no-magic-numbers
		oSortFragment = oCellDomRef["childNodes"][5];
		sFilterFragmentClassName = '';
		sCellWidth = this["_sWidth"];
		sActionMenuId = this["getActionMenuId"]();
		sIconSrc = this["getIconSrc"]();
		bFiltered = this["getFiltered"]();
		bRotateContent = this["getRotateContent"]();
		sVerticalAlign = this["getVerticalAlign"]();
		sSortState = this["getSortState"]();
		mSortFragmentStates = {
			"DISABLED": { "classname": '' },
			"NONE": { "classname": '' },
			"ASCENDING": { "classname": 'lsDGSCSortAsc' },
			"DESCENDING": { "classname": 'lsDGSCSortDesc' }
		};
		oSortFragmentState = mSortFragmentStates[sSortState];
		sHierarchyState = this["getHierarchyState"]();
		iHierarchyLevel = this["getHierarchyLevel"]();
		mHierarchyFragmentStates = {
			// eslint-disable-next-line no-magic-numbers
			"NONE": { "display": 'none', "classname": '', "width": 0, "left": 6 },
			"EXPANDED": {
				"display": 'block',
				"classname": 'lsDGSCHierExp lsMirrorRtl',
				// eslint-disable-next-line no-magic-numbers
				"width": (iHierarchyLevel + 1) * 14,
				"left": 0
			},
			"EXPANDEDMINUS": {
				"display": 'block',
				"classname": 'lsDGSCHierExpMinus lsMirrorRtl',
				// eslint-disable-next-line no-magic-numbers
				"width": (iHierarchyLevel + 1) * 14,
				"left": 0
			},
			"EXPANDEDTOP": {
				"display": 'block',
				"classname": 'lsDGSCHierExpTop lsMirrorRtl',
				// eslint-disable-next-line no-magic-numbers
				"width": (iHierarchyLevel + 1) * 14,
				"left": 0
			},
			"COLLAPSED": {
				"display": 'block',
				"classname": 'lsDGSCHierCol lsMirrorRtl',
				// eslint-disable-next-line no-magic-numbers
				"width": (iHierarchyLevel + 1) * 14,
				"left": 0
			},
			"COLLAPSEDPLUS": {
				"display": 'block',
				"classname": 'lsDGSCHierColPlus lsMirrorRtl',
				// eslint-disable-next-line no-magic-numbers
				"width": (iHierarchyLevel + 1) * 14,
				"left": 0
			},
			"LEAF": {
				"display": 'block',
				"classname": 'lsDGSCHierLeaf lsMirrorRtl',
				// eslint-disable-next-line no-magic-numbers
				"width": (iHierarchyLevel + 1) * 14,
				"left": 0
			},
			"MARKTOTALS": {
				"display": 'block',
				"classname": 'lsDGSCHierMarkTotals',
				// eslint-disable-next-line no-magic-numbers
				"width": (iHierarchyLevel + 1) * 14,
				"left": 0
			}
		};
		oHierarchyFragmentState = mHierarchyFragmentStates[sHierarchyState];

		this["applyHeaderStateStyles"](oCellDomRef);
		this["applySemanticColorStyles"]();
		this["applyReadonlyStyles"]();

		// set selection state
		this["applySelectionStateStyles"](oCellDomRef);
		// apply mergeBorder styles
		this["applyMergeBorderStyles"](oCellDomRef);
		// apply decorator styles
		this["applyDecoratorStyles"](oCellDomRef);
		// apply focus styles
		this["applyFocusStyles"](oCellDomRef);
		// set resulting css class at cell domref
		this["setCssClass"](oCellDomRef);

		if (this["_sHierarchyState"] != sHierarchyState || this["_iHierarchyLevel"] != iHierarchyLevel) {
			this["_sHierarchyState"] = sHierarchyState;
			this["_iHierarchyLevel"] = iHierarchyLevel;
			if (oHierarchyFragment) {
				UCF_DomUtil["setStyle"](oHierarchyFragment, {
					"display": oHierarchyFragmentState["display"],
					"width": oHierarchyFragmentState["width"] + 'px'
				});
				UCF_DomUtil["setStyle"](oHierarchyFragment, window["UCF_System"]["bIsRTL"] ? 'right' : 'left', oHierarchyFragmentState["left"] + 'px');
				UCF_DomUtil["setClass"](oHierarchyFragment, 'lsDGSCHierFrag ' + oHierarchyFragmentState["classname"]);
				if (oHierarchyFragmentState["display"] != 'none') {
					this["applyFragmentVAlignStyles"](oHierarchyFragment, oContentFragment, sVerticalAlign);
					UCF_DomUtil["setStyle"](oHierarchyFragment, 'lineHeight', this["_sHeight"]);
				}
			}
		}

		if (this["_sIconSrc"] == sIconSrc) {
			this["_iIconFragmentLeft"] = oHierarchyFragmentState["width"] + oHierarchyFragmentState["left"];
		} else {
			this["_sIconSrc"] = sIconSrc;
			if (oIconFragment) {
				if (sIconSrc == '') {
					UCF_DomUtil["setStyle"](oIconFragment, {
						"display": 'none',
						"backgroundImage": ''
					});
					this["_iIconFragmentWidth"] = 0;
				} else {
					UCF_DomUtil["setStyle"](oIconFragment, 'display', 'block');
					sPos = '';
					aIconSrc = sIconSrc["split"](',');
					aBGImages = [];
					aBGPositions = [];
					// eslint-disable-next-line max-depth
					for (i = 0; i < aIconSrc["length"]; i++) {
						aBGImages["push"]('url(' + aIconSrc[i] + ')');
						// eslint-disable-next-line no-magic-numbers
						this["_iIconFragmentWidth"] = 16 * (i + 1);
						// eslint-disable-next-line no-magic-numbers
						sPos = (this["_iIconFragmentWidth"] - 16) + 'px ' + this["sGetVAlignPosition"](sVerticalAlign, null, oContentFragment, aIconSrc[i]);
						aBGPositions["push"](sPos);
					}
					UCF_DomUtil["setStyle"](oIconFragment, {
						"backgroundImage": aBGImages["join"](','),
						"backgroundPosition": aBGPositions["join"](',')
					});
				}
				this["_iIconFragmentLeft"] = oHierarchyFragmentState["width"] + oHierarchyFragmentState["left"];
				UCF_DomUtil["setStyle"](oIconFragment, 'width', this["_iIconFragmentWidth"] + 'px');
				UCF_DomUtil["setStyle"](oIconFragment, window["UCF_System"]["bIsRTL"] ? 'right' : 'left', this["_iIconFragmentLeft"] + 'px');
			}
		}

		if (this["_sSortState"] != sSortState || this["_sActionMenuId"] != sActionMenuId) {
			this["_sSortState"] = sSortState;
			if (oSortFragment) {
				if ((sSortState != '' && sSortState != 'DISABLED' && sSortState != 'NONE') || sActionMenuId != '') {
					UCF_DomUtil["setStyle"](oSortFragment, 'display', 'block');
					this["_iSortFragmentWidth"] = 9;
				} else {
					UCF_DomUtil["setStyle"](oSortFragment, 'display', 'none');
					this["_iSortFragmentWidth"] = 0;
				}
				UCF_DomUtil["setStyle"](oSortFragment, 'width', this["_iSortFragmentWidth"] + 'px');
				UCF_DomUtil["setStyle"](oSortFragment, window["UCF_System"]["bIsRTL"] ? 'left' : 'right', '8px');
				UCF_DomUtil["setClass"](oSortFragment, 'lsDGSCSortFrag ' + oSortFragmentState["classname"]);
				if (oSortFragmentState["classname"] != '') {
					this["applyFragmentVAlignStyles"](oSortFragment, oContentFragment, sVerticalAlign);
				}
			}
		}

		if (this["_bFiltered"] != bFiltered || this["_sActionMenuId"] != sActionMenuId) {
			this["_bFiltered"] = bFiltered;
			if (oFilterFragment) {
				sFilterFragmentClassName = '';
				if (bFiltered || sActionMenuId != '') {
					UCF_DomUtil["setStyle"](oFilterFragment, 'display', 'block');
					this["_iFilterFragmentWidth"] = 9;
					if (bFiltered) { // eslint-disable-line max-depth
						sFilterFragmentClassName = ' urST5IcoFilter';
					}
				} else {
					UCF_DomUtil["setStyle"](oFilterFragment, 'display', 'none');
					this["_iFilterFragmentWidth"] = 0;
				}
				UCF_DomUtil["setStyle"](oFilterFragment, 'width', this["_iFilterFragmentWidth"] + 'px');
				// eslint-disable-next-line no-magic-numbers
				UCF_DomUtil["setStyle"](oFilterFragment, window["UCF_System"]["bIsRTL"] ? 'left' : 'right', this["_iSortFragmentWidth"] + 8 + 'px');
				UCF_DomUtil["setClass"](oFilterFragment, 'lsDGSCFilterFrag' + sFilterFragmentClassName);
				if (bFiltered) {
					this["applyFragmentVAlignStyles"](oFilterFragment, oContentFragment, sVerticalAlign);
				}
			}
		}

		if (this["_sActionMenuId"] != sActionMenuId) {
			this["_sActionMenuId"] = sActionMenuId;
			if (oDividerFragment) {
				if (sActionMenuId == '') {
					UCF_DomUtil["setStyle"](oDividerFragment, 'display', 'none');
					this["_iDividerFragmentWidth"] = 0;
				} else {
					UCF_DomUtil["setStyle"](oDividerFragment, 'display', 'block');
					this["_iDividerFragmentWidth"] = 7;
					this["applyFragmentVAlignStyles"](oDividerFragment, oContentFragment, sVerticalAlign);
				}

				UCF_DomUtil["setStyle"](oDividerFragment, 'width', this["_iDividerFragmentWidth"] + 'px');
				UCF_DomUtil["setStyle"](
					oDividerFragment,
					window["UCF_System"]["bIsRTL"] ? 'left' : 'right',
					// eslint-disable-next-line no-magic-numbers
					this["_iSortFragmentWidth"] + this["_iFilterFragmentWidth"] + 8 + 'px'
				);
			}
		}

		if (oContentFragment) {
			// eslint-disable-next-line no-magic-numbers
			this["_iContentFragmentWidth"] = parseInt(sCellWidth) - this["_iIconFragmentWidth"] - this["_iIconFragmentLeft"] - this["_iSortFragmentWidth"] - this["_iFilterFragmentWidth"] - this["_iDividerFragmentWidth"] - 8;
			if (this["__iContentFragmentWidth"] != this["_iContentFragmentWidth"]) {
				this["__iContentFragmentWidth"] = this["_iContentFragmentWidth"];
				UCF_DomUtil["setStyle"](oContentFragment, 'width', this["_iContentFragmentWidth"] + 'px');
				UCF_DomUtil["setStyle"](oContentFragment["firstChild"]["firstChild"], 'width', this["_iContentFragmentWidth"] + 'px');
			}
			this["_iContentFragmentLeft"] = this["_iIconFragmentWidth"] + this["_iIconFragmentLeft"];
			if (this["__iContentFragmentLeft"] != this["_iContentFragmentLeft"]) {
				this["__iContentFragmentLeft"] = this["_iContentFragmentLeft"];
				UCF_DomUtil["setStyle"](oContentFragment, window["UCF_System"]["bIsRTL"] ? 'right' : 'left', this["_iContentFragmentLeft"] + 'px');
			}
			UCF_DomUtil["setStyle"](oContentFragment["firstChild"], 'verticalAlign', sVerticalAlign);
			UCF_DomUtil["setStyle"](
				oContentFragment,
				(!this["_bShowTopBorder"] && sVerticalAlign == 'TOP') || (!this["_bShowBottomBorder"] && sVerticalAlign == 'BOTTOM')
				? 'none' : 'table');
		}

		if (this["_bRotateContent"] != bRotateContent) {
			this["_bRotateContent"] = bRotateContent;
			if (oContentFragment) {
				if (bRotateContent) {
					UCF_DomUtil["setClass"](oContentFragment, 'lsDGSCContentFrag lsDGSCContentRotate');
					// eslint-disable-next-line no-magic-numbers
					iTranslateX = window["UCF_System"]["bIsRTL"] ? -(parseInt(this["_sHeight"]) + 3) : 2;
					iTranslateY = window["UCF_System"]["bIsRTL"] ? -(this["_iContentFragmentWidth"] - parseInt(this["_sHeight"])) : -this["_iContentFragmentWidth"];
					// eslint-disable-next-line no-magic-numbers
					iRotate = window["UCF_System"]["bIsRTL"] ? 270 : 90;
					UCF_DomUtil["setStyle"](oContentFragment, {
						"width": this["_sHeight"],
						"height": this["_iContentFragmentWidth"] + 'px',
						"webkitTransform": 'rotate(' + iRotate + 'deg) translate(' + iTranslateX + 'px, ' + iTranslateY + 'px)',
						"msTransform": 'rotate(' + iRotate + 'deg) translate(' + iTranslateX + 'px, ' + iTranslateY + 'px)',
						"transform": 'rotate(' + iRotate + 'deg) translate(' + iTranslateX + 'px, ' + iTranslateY + 'px)'
					});
					UCF_DomUtil["setStyle"](oContentFragment["firstChild"]["firstChild"], 'width', this["_sHeight"]);
				} else {
					UCF_DomUtil["setClass"](oContentFragment, 'lsDGSCContentFrag');
					UCF_DomUtil["setStyle"](oContentFragment, {
						"width": this["_iContentFragmentWidth"] + 'px',
						"height": '',
						"webkitTransform": 'none',
						"msTransform": 'none',
						"transform": 'none'
					});
					UCF_DomUtil["setStyle"](oContentFragment["firstChild"]["firstChild"], 'width', this["_iContentFragmentWidth"] + 'px');
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["updateInnerHTML"] = 0; };

/** @param {HTMLElement} oCellDomRef */
UCF_ClientDataGridSegmentCell["prototype"]["applyFocusStyles"] = function(oCellDomRef) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyFocusStyles"]++; }; 
	if (this["_bFocused"] != this["__bFocused"]) {
		this["__bFocused"] = this["_bFocused"];

		UCF_DomUtil["setStyle"](oCellDomRef, {
			"boxShadow": this["__bFocused"] ? 'inset 0 0 1px 1px grey' : '',
			"zIndex": this["__bFocused"] ? '200' : ''
		});
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyFocusStyles"] = 0; };

/** @param {HTMLElement} oCellDomRef */
UCF_ClientDataGridSegmentCell["prototype"]["applyHeaderStateStyles"] = function(oCellDomRef) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyHeaderStateStyles"]++; }; 
	var oResizeBeginFragment;
	var oResizeEndFragment;

	if (this["_sRowType"] && this["_sColumnType"]) {
		if (this["_sRowType"] != this["__sRowType"] || this["_sColumnType"] != this["__sColumnType"]) {
			this["__sRowType"] = this["_sRowType"];
			this["__sColumnType"] = this["_sColumnType"];
			this["_sHeaderStateClassName"] = (this["_sRowType"] == 'HEADERROW' && this["_sColumnType"] == 'HEADERCOLUMN')
				? 'lsDGSCDivRowHead lsDGSCDivColHead'
				: this["_sRowType"] == 'HEADERROW'
				? 'lsDGSCDivRowHead'
				: this["_sColumnType"] == 'HEADERCOLUMN'
				? 'lsDGSCDivColHead'
				: 'lsDGSCDivNoHead';

			// eslint-disable-next-line no-magic-numbers
			this["applyResizeCursorStyles"](oCellDomRef["childNodes"][6], oCellDomRef["childNodes"][7]);
		} else if (this["_sRowType"] == 'HEADERROW' || this["_sColumnType"] == 'HEADERCOLUMN') {
			if (this["_sHeight"] != this["_sResizeHeight"]) {
				// eslint-disable-next-line no-magic-numbers
				oResizeBeginFragment = oCellDomRef["childNodes"][6];
				// eslint-disable-next-line no-magic-numbers
				oResizeEndFragment = oCellDomRef["childNodes"][7];

				if (this["_sRowType"] == 'HEADERROW' || this["_sColumnType"] == 'HEADERCOLUMN') {
					UCF_DomUtil["setStyle"](oResizeBeginFragment, 'height', this["_sHeight"]);
					// eslint-disable-next-line no-magic-numbers
					UCF_DomUtil["setStyle"](oResizeEndFragment, 'top', (parseInt(this["_sHeight"]) - 5) + 'px');
				} else if (this["_sRowType"] == 'HEADERROW') {
					UCF_DomUtil["setStyle"](oResizeBeginFragment, 'height', this["_sHeight"]);
					UCF_DomUtil["setStyle"](oResizeEndFragment, 'height', this["_sHeight"]);
				} else if (this["_sColumnType"] == 'HEADERCOLUMN') {
					// eslint-disable-next-line no-magic-numbers
					UCF_DomUtil["setStyle"](oResizeEndFragment, 'top', (parseInt(this["_sHeight"]) - 5) + 'px');
				}

				this["_sResizeHeight"] = this["_sHeight"];
			}

			if (this["_sWidth"] != this["_sResizeWidth"]) {
				// eslint-disable-next-line no-magic-numbers
				oResizeBeginFragment = oResizeBeginFragment || oCellDomRef["childNodes"][6];
				// eslint-disable-next-line no-magic-numbers
				oResizeEndFragment = oResizeEndFragment || oCellDomRef["childNodes"][7];
				if (this["_sRowType"] == 'HEADERROW' || this["_sColumnType"] == 'HEADERCOLUMN') {
					// eslint-disable-next-line no-magic-numbers
					UCF_DomUtil["setStyle"](oResizeBeginFragment, window["UCF_System"]["bIsRTL"] ? 'right' : 'left', (parseInt(this["_sWidth"]) - 5) + 'px');
					UCF_DomUtil["setStyle"](oResizeEndFragment, 'width', this["_sWidth"]);
				} else if (this["_sRowType"] == 'HEADERROW') {
					// eslint-disable-next-line no-magic-numbers
					UCF_DomUtil["setStyle"](oResizeBeginFragment, window["UCF_System"]["bIsRTL"] ? 'right' : 'left', (parseInt(this["_sWidth"]) - 5) + 'px');
				} else if (this["_sColumnType"] == 'HEADERCOLUMN') {
					UCF_DomUtil["setStyle"](oResizeBeginFragment, 'width', this["_sWidth"]);
					UCF_DomUtil["setStyle"](oResizeEndFragment, 'width', this["_sWidth"]);
				}

				this["_sResizeWidth"] = this["_sWidth"];
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyHeaderStateStyles"] = 0; };

/**
 * @param {HTMLElement} oResizeBeginFragment
 * @param {HTMLElement} oResizeEndFragment
 */
UCF_ClientDataGridSegmentCell["prototype"]["applyResizeCursorStyles"] = function(oResizeBeginFragment, oResizeEndFragment) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyResizeCursorStyles"]++; }; 
	UCF_DomUtil["setStyle"](oResizeBeginFragment, 'display', 'none');
	UCF_DomUtil["setStyle"](oResizeEndFragment, 'display', 'none');

	if (this["_sRowType"] == 'HEADERROW' || this["_sColumnType"] == 'HEADERCOLUMN') {
		UCF_DomUtil["setStyle"](oResizeBeginFragment, {
			"display": 'block',
			"cursor": 'col-resize',
			"position": 'absolute',
			"top": '0',
			"width": '5px',
			"height": this["_sHeight"]
		});
		// eslint-disable-next-line no-magic-numbers
		UCF_DomUtil["setStyle"](oResizeBeginFragment, window["UCF_System"]["bIsRTL"] ? 'right' : 'left', (parseInt(this["_sWidth"]) - 5) + 'px');
		oResizeBeginFragment["setAttribute"]('rsz', 'end');

		UCF_DomUtil["setStyle"](oResizeEndFragment, {
			"display": 'block',
			"cursor": 'row-resize',
			"position": 'absolute',
			// eslint-disable-next-line no-magic-numbers
			"top": (parseInt(this["_sHeight"]) - 5) + 'px',
			"width": this["_sWidth"],
			"height": '5px'
		});
		UCF_DomUtil["setStyle"](oResizeEndFragment, window["UCF_System"]["bIsRTL"] ? 'right' : 'left', 0);
		oResizeEndFragment["setAttribute"]('rsz', 'end');

		this["_sResizeHeight"] = this["_sHeight"];
		this["_sResizeWidth"] = this["_sWidth"];
	} else if (this["_sRowType"] == 'HEADERROW') {
		UCF_DomUtil["setStyle"](oResizeEndFragment, {
			"display": 'block',
			"cursor": 'col-resize',
			"position": 'absolute',
			"top": '0',
			"width": '5px',
			"height": this["_sHeight"]
		});
		// eslint-disable-next-line no-magic-numbers
		UCF_DomUtil["setStyle"](oResizeEndFragment, window["UCF_System"]["bIsRTL"] ? 'right' : 'left', (parseInt(this["_sWidth"]) - 5) + 'px');
		oResizeEndFragment["setAttribute"]('rsz', 'end');

		this["_sResizeHeight"] = this["_sHeight"];
		this["_sResizeWidth"] = this["_sWidth"];
	} else if (this["_sColumnType"] == 'HEADERCOLUMN') {
		UCF_DomUtil["setStyle"](oResizeEndFragment, {
			"display": 'block',
			"cursor": 'row-resize',
			"position": 'absolute',
			// eslint-disable-next-line no-magic-numbers
			"top": (parseInt(this["_sHeight"]) - 5) + 'px',
			"width": this["_sWidth"],
			"height": '5px'
		});
		UCF_DomUtil["setStyle"](oResizeEndFragment, window["UCF_System"]["bIsRTL"] ? 'right' : 'left', 0);
		oResizeEndFragment["setAttribute"]('rsz', 'end');

		this["_sResizeHeight"] = this["_sHeight"];
		this["_sResizeWidth"] = this["_sWidth"];
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyResizeCursorStyles"] = 0; };

/** @param {HTMLElement} oCellDomRef */
UCF_ClientDataGridSegmentCell["prototype"]["applyDecoratorStyles"] = function(oCellDomRef) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyDecoratorStyles"]++; }; 
	/** @type {UCF_ClientDecorator[]} */
	var aDecorators = this["getCellDecorators"]();
	/** @type {HTMLElement} */ // eslint-disable-next-line no-magic-numbers
	var oDecoratorFragmentTopLeft = oCellDomRef["childNodes"][8];
	/** @type {HTMLElement} */ // eslint-disable-next-line no-magic-numbers
	var oDecoratorFragmentTopRight = oCellDomRef["childNodes"][9];
	/** @type {HTMLElement} */ // eslint-disable-next-line no-magic-numbers
	var oDecoratorFragmentBottomRight = oCellDomRef["childNodes"][10];
	/** @type {HTMLElement} */ // eslint-disable-next-line no-magic-numbers
	var oDecoratorFragmentBottomLeft = oCellDomRef["childNodes"][11];
	/** @type {string} */
	var sTopLeftImgSrc = 'undefined';
	/** @type {string} */
	var sTopRightImgSrc = 'undefined';
	/** @type {string} */
	var sBottomRightImgSrc = 'undefined';
	/** @type {string} */
	var sBottomLeftImgSrc = 'undefined';
	/** @type {number} */
	var i;
	/** @type {UCF_ClientDecorator} */
	var oDecorator;
	/** @type {string} */
	var sPos;
	/** @type {string} */
	var sImgSrc;

	for (i = 0; i < aDecorators["length"]; i++) {
		oDecorator = aDecorators[i];
		sPos = oDecorator["getPosition"]();
		sImgSrc = null;

		if (sPos != 'NONE') {
			sPos = sPos["replace"]('_', ' ')["toLowerCase"]();
			sImgSrc = oDecorator["getIconSrc"]();

			switch (sPos) {
				case 'top left':
					sTopLeftImgSrc = sImgSrc ? 'url(' + sImgSrc + ')' : '';
					break;
				case 'top right':
					sTopRightImgSrc = sImgSrc ? 'url(' + sImgSrc + ')' : '';
					break;
				case 'bottom right':
					sBottomRightImgSrc = sImgSrc ? 'url(' + sImgSrc + ')' : '';
					break;
				case 'bottom left':
					sBottomLeftImgSrc = sImgSrc ? 'url(' + sImgSrc + ')' : '';
					break;
			}
		}
	}

	if (this["_sTopLeftImgSrc"] != sTopLeftImgSrc) {
		this["_sTopLeftImgSrc"] = sTopLeftImgSrc;
		UCF_DomUtil["setStyle"](oDecoratorFragmentTopLeft, sTopLeftImgSrc == 'undefined'
			? { "backgroundImage": '', "display": 'none' }
			: { "backgroundImage": sTopLeftImgSrc, "display": 'block' });
	}

	if (this["_sTopRightImgSrc"] != sTopRightImgSrc) {
		this["_sTopRightImgSrc"] = sTopRightImgSrc;
		UCF_DomUtil["setStyle"](oDecoratorFragmentTopRight, sTopRightImgSrc == 'undefined'
			? { "backgroundImage": '', "display": 'none' }
			: { "backgroundImage": sTopRightImgSrc, "display": 'block' });
	}

	if (this["_sBottomRightImgSrc"] != sBottomRightImgSrc) {
		this["_sBottomRightImgSrc"] = sBottomRightImgSrc;
		UCF_DomUtil["setStyle"](oDecoratorFragmentBottomRight, sBottomRightImgSrc == 'undefined'
			? { "backgroundImage": '', "display": 'none' }
			: { "backgroundImage": sBottomRightImgSrc, "display": 'block' });
	}

	if (this["_sBottomLeftImgSrc"] != sBottomLeftImgSrc) {
		this["_sBottomLeftImgSrc"] = sBottomLeftImgSrc;
		UCF_DomUtil["setStyle"](oDecoratorFragmentBottomLeft, sBottomLeftImgSrc == 'undefined'
			? { "backgroundImage": '', "display": 'none' }
			: { "backgroundImage": sBottomLeftImgSrc, "display": 'block' });
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyDecoratorStyles"] = 0; };

/** @param {HTMLElement} oCellDomRef */
UCF_ClientDataGridSegmentCell["prototype"]["applySelectionStateStyles"] = function(oCellDomRef) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySelectionStateStyles"]++; }; 
	/** @type {string} */
	var sSelectionState = this["getSelectionState"]();
	/** @type {boolean} */
	var bSelected;
	/** @type {number} */
	var iX;
	/** @type {number} */
	var iY;
	/** @type {boolean} */
	var bBeforeSiblingSelected;
	/** @type {boolean} */
	var bBehindSiblingSelected;
	/** @type {boolean} */
	var bTopSiblingSelected;
	/** @type {boolean} */
	var bBottomSiblingSelected;
	/** @type {boolean} */
	var bHasBeforeBorder;
	/** @type {boolean} */
	var bHasBehindBorder;
	/** @type {boolean} */
	var bHasTopBorder;
	/** @type {boolean} */
	var bHasBottomBorder;

	if (this["_sSelectionState"] != sSelectionState) {
		this["_sSelectionState"] = sSelectionState;

		if (sSelectionState == 'SELECTED') {
			this["_sSelectionStateClassName"] = 'lsDGSCDivSel';
			bSelected = true;
		} else if (sSelectionState == 'PRIMARY_SELECTED') {
			this["_sSelectionStateClassName"] = 'lsDGSCDivPrimSel';
		} else {
			this["_sSelectionStateClassName"] = '';
			this["_sSelectionBorderTopClassName"] = '';
			this["_sSelectionBorderRightClassName"] = '';
			this["_sSelectionBorderBottomClassName"] = '';
			this["_sSelectionBorderLeftClassName"] = '';
			this["_bHasBeforeBorder"] = false;
			this["_bHasBehindBorder"] = false;
			this["_bHasTopBorder"] = false;
			this["_bHasBottomBorder"] = false;

			UCF_DomUtil["setStyle"](oCellDomRef, {
				"border": '',
				"width": parseInt(this["_sWidth"]) + 'px',
				"top": parseInt(this["_sTop"]) + 'px',
				"height": parseInt(this["_sHeight"]) + 'px'
			});
			UCF_DomUtil["setStyle"](oCellDomRef, window["UCF_System"]["bIsRTL"] ? 'right' : 'left', parseInt(this["_sLeft"]) + 'px');

			return;
		}
	}

	bSelected = (sSelectionState == 'SELECTED' || sSelectionState == 'PRIMARY_SELECTED');

	if (bSelected) {
		iX = this["getBindingContext"]()["oParameter"]["x"];
		iY = this["getBindingContext"]()["oParameter"]["y"];
		bBeforeSiblingSelected = this["bIsNeighborCellSelected"]((iX - 1), iY);
		bBehindSiblingSelected = this["bIsNeighborCellSelected"]((iX + 1), iY);
		bTopSiblingSelected = this["bIsNeighborCellSelected"](iX, (iY - 1));
		bBottomSiblingSelected = this["bIsNeighborCellSelected"](iX, (iY + 1));
		bHasBeforeBorder = (bSelected && !bBeforeSiblingSelected);
		bHasBehindBorder = (bSelected && !bBehindSiblingSelected);
		bHasTopBorder = (bSelected && !bTopSiblingSelected);
		bHasBottomBorder = (bSelected && !bBottomSiblingSelected);

		if (this["_bHasBeforeBorder"] != bHasBeforeBorder) {
			this["_bHasBeforeBorder"] = bHasBeforeBorder;
			if (bHasBeforeBorder) {
				this["_sSelectionBorderLeftClassName"] = 'lsDGSCDivSelBrdLeft';
				UCF_DomUtil["setStyle"](oCellDomRef, UCF_JsUtil["extend"]({ "width": (parseInt(this["_sWidth"]) + 1) + 'px' }, window["UCF_System"]["bIsRTL"]
					? { "borderRightWidth": '2px', "right": (parseInt(this["_sLeft"]) - 1) + 'px' }
					: { "borderLeftWidth": '2px', "left": (parseInt(this["_sLeft"]) - 1) + 'px' }
				));
			} else {
				this["_sSelectionBorderLeftClassName"] = '';
				UCF_DomUtil["setStyle"](oCellDomRef, UCF_JsUtil["extend"]({ "width": this["_sWidth"] }, window["UCF_System"]["bIsRTL"]
					? { "borderRightWidth": '', "right": this["_sLeft"] }
					: { "borderLeftWidth": '', "left": this["_sLeft"] }));
			}
		}
		if (this["_bHasBehindBorder"] != bHasBehindBorder) {
			this["_bHasBehindBorder"] = bHasBehindBorder;
			if (bHasBehindBorder) {
				this["_sSelectionBorderRightClassName"] = 'lsDGSCDivSelBrdRight';
				UCF_DomUtil["setStyle"](oCellDomRef, UCF_JsUtil["extend"]({
						"width": bBeforeSiblingSelected
							? (parseInt(this["_sWidth"]) + 1) + 'px'
							// eslint-disable-next-line no-magic-numbers
							: (parseInt(this["_sWidth"]) + 2) + 'px'
					}, window["UCF_System"]["bIsRTL"]
					? { "borderLeftWidth": '2px' }
					: { "borderRightWidth": '2px' }));
			} else {
				this["_sSelectionBorderRightClassName"] = '';
				UCF_DomUtil["setStyle"](oCellDomRef, UCF_JsUtil["extend"]({
						"width": bBeforeSiblingSelected
							? this["_sWidth"]
							: (parseInt(this["_sWidth"]) + 1) + 'px'
					}, window["UCF_System"]["bIsRTL"]
					? { "borderLeftWidth": '' }
					: { "borderRightWidth": '' }));
			}
		}
		if (this["_bHasTopBorder"] != bHasTopBorder) {
			this["_bHasTopBorder"] = bHasTopBorder;
			if (bHasTopBorder) {
				UCF_DomUtil["setStyle"](oCellDomRef, {
					"borderTopWidth": '2px',
					"top": (parseInt(this["_sTop"]) - 1) + 'px',
					"height": (parseInt(this["_sHeight"]) + 1) + 'px'
				});
				this["_sSelectionBorderTopClassName"] = 'lsDGSCDivSelBrdTop';
			} else {
				UCF_DomUtil["setStyle"](oCellDomRef, {
					"borderTopWidth": '',
					"top": this["_sTop"],
					"height": this["_sHeight"]
				});
				this["_sSelectionBorderTopClassName"] = '';
			}
		}
		if (this["_bHasBottomBorder"] != bHasBottomBorder) {
			this["_bHasBottomBorder"] = bHasBottomBorder;
			if (bHasBottomBorder) {
				UCF_DomUtil["setStyle"](oCellDomRef, {
					"borderBottomWidth": '2px',
					"height": bTopSiblingSelected
						? (parseInt(this["_sHeight"]) + 1) + 'px'
						// eslint-disable-next-line no-magic-numbers
						: (parseInt(this["_sHeight"]) + 2) + 'px'
				});
				this["_sSelectionBorderBottomClassName"] = 'lsDGSCDivSelBrdBottom';
			} else {
				UCF_DomUtil["setStyle"](oCellDomRef, {
					"borderBottomWidth": '',
					"height": bTopSiblingSelected
						? this["_sHeight"]
						: (parseInt(this["_sHeight"]) + 1) + 'px'
				});
				this["_sSelectionBorderBottomClassName"] = '';
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySelectionStateStyles"] = 0; };

/** @param {boolean} bTopSiblingSelected */
UCF_ClientDataGridSegmentCell["prototype"]["applySelectionTopBorderStyles"] = function(bTopSiblingSelected) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySelectionTopBorderStyles"]++; }; 
	/** @type {number} */
	var iX = this["getBindingContext"]()["oParameter"]["x"];
	/** @type {number} */
	var iY = this["getBindingContext"]()["oParameter"]["y"];
	/** @type {boolean} */
	var bBottomSiblingSelected = this["bIsNeighborCellSelected"](iX, (iY + 1));
	/** @type {UCF_DataGridSegmentCell} */
	var oUCFCell = this["getUCFInstance"]();
	/** @type {HTMLElement} */
	var oCellDomRef;

	if (oUCFCell) {
		oCellDomRef = oUCFCell["oDomRef"];

		if (oCellDomRef) {
			if (bTopSiblingSelected) {
				UCF_DomUtil["setStyle"](oCellDomRef, {
					"borderTopWidth": '',
					"top": this["_sTop"],
					"height": bBottomSiblingSelected
						? this["_sHeight"]
						: (parseInt(this["_sHeight"]) + 1) + 'px'
				});
				this["_sSelectionBorderTopClassName"] = '';
			} else {
				UCF_DomUtil["setStyle"](oCellDomRef, {
					"borderTopWidth": '2px',
					"top": (parseInt(this["_sTop"]) - 1) + 'px',
					"height": (parseInt(this["_sHeight"]) + 1) + 'px'
				});
				this["_sSelectionBorderTopClassName"] = 'lsDGSCDivSelBrdTop';
			}
			// set resulting css class at cell domref
			this["setCssClass"](oCellDomRef);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySelectionTopBorderStyles"] = 0; };

/** @param {boolean} bBottomSiblingSelected */
UCF_ClientDataGridSegmentCell["prototype"]["applySelectionBottomBorderStyles"] = function(bBottomSiblingSelected) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySelectionBottomBorderStyles"]++; }; 
	/** @type {number} */
	var iX = this["getBindingContext"]()["oParameter"]["x"];
	/** @type {number} */
	var iY = this["getBindingContext"]()["oParameter"]["y"];
	/** @type {boolean} */
	var bTopSiblingSelected = this["bIsNeighborCellSelected"](iX, (iY - 1));
	/** @type {UCF_DataGridSegmentCell} */
	var oUCFCell = this["getUCFInstance"]();
	/** @type {HTMLElement} */
	var oCellDomRef;

	if (oUCFCell) {
		oCellDomRef = oUCFCell["oDomRef"];

		if (oCellDomRef) {
			if (bBottomSiblingSelected) {
				UCF_DomUtil["setStyle"](oCellDomRef, {
					"borderBottomWidth": '',
					"height": bTopSiblingSelected
						? this["_sHeight"]
						: (parseInt(this["_sHeight"]) + 1) + 'px'
				});
				this["_sSelectionBorderBottomClassName"] = '';
			} else {
				UCF_DomUtil["setStyle"](oCellDomRef, {
					"borderBottomWidth": '2px',
					"height": bTopSiblingSelected
						? (parseInt(this["_sHeight"]) + 1) + 'px'
						// eslint-disable-next-line no-magic-numbers
						: (parseInt(this["_sHeight"]) + 2) + 'px'
				});
				this["_sSelectionBorderBottomClassName"] = 'lsDGSCDivSelBrdBottom';
			}
			// set resulting css class at cell domref
			this["setCssClass"](oCellDomRef);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySelectionBottomBorderStyles"] = 0; };

/** @param {boolean} bBeforeSiblingSelected */
UCF_ClientDataGridSegmentCell["prototype"]["applySelectionBeforeBorderStyles"] = function(bBeforeSiblingSelected) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySelectionBeforeBorderStyles"]++; }; 
	/** @type {number} */
	var iX = this["getBindingContext"]()["oParameter"]["x"];
	/** @type {number} */
	var iY = this["getBindingContext"]()["oParameter"]["y"];
	/** @type {boolean} */
	var bBehindSiblingSelected = this["bIsNeighborCellSelected"]((iX + 1), iY);
	/** @type {UCF_DataGridSegmentCell} */
	var oUCFCell = this["getUCFInstance"]();
	/** @type {HTMLElement} */
	var oCellDomRef;

	if (oUCFCell) {
		oCellDomRef = oUCFCell["oDomRef"];

		if (oCellDomRef) {
			if (bBeforeSiblingSelected) {
				UCF_DomUtil["setStyle"](oCellDomRef, 'width', bBehindSiblingSelected ? this["_sWidth"] : (parseInt(this["_sWidth"]) + 1) + 'px');
				UCF_DomUtil["setStyle"](oCellDomRef, window["UCF_System"]["bIsRTL"]
					? { "borderRightWidth": '', "right": this["_sLeft"] }
					: { "borderLeftWidth": '', "left": this["_sLeft"] });
				this["_sSelectionBorderLeftClassName"] = '';
			} else {
				this["_sSelectionBorderLeftClassName"] = 'lsDGSCDivSelBrdLeft';
				UCF_DomUtil["setStyle"](oCellDomRef, 'width', (parseInt(this["_sWidth"]) + 1) + 'px');
				UCF_DomUtil["setStyle"](oCellDomRef, window["UCF_System"]["bIsRTL"]
					? { "borderRightWidth": '2px', "right": (parseInt(this["_sLeft"]) - 1) + 'px' }
					: { "borderLeftWidth": '2px', "left": (parseInt(this["_sLeft"]) - 1) + 'px' });
			}
			// set resulting css class at cell domref
			this["setCssClass"](oCellDomRef);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySelectionBeforeBorderStyles"] = 0; };

/** @param {boolean} bBehindSiblingSelected */
UCF_ClientDataGridSegmentCell["prototype"]["applySelectionBehindBorderStyles"] = function(bBehindSiblingSelected) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySelectionBehindBorderStyles"]++; }; 
	/** @type {number} */
	var iX = this["getBindingContext"]()["oParameter"]["x"];
	/** @type {number} */
	var iY = this["getBindingContext"]()["oParameter"]["y"];
	/** @type {boolean} */
	var bBeforeSiblingSelected = this["bIsNeighborCellSelected"]((iX - 1), iY);
	/** @type {UCF_DataGridSegmentCell} */
	var oUCFCell = this["getUCFInstance"]();
	/** @type {HTMLElement} */
	var oCellDomRef;

	if (oUCFCell) {
		oCellDomRef = oUCFCell["oDomRef"];

		if (oCellDomRef) {
			if (bBehindSiblingSelected) {
				this["_sSelectionBorderRightClassName"] = '';
				UCF_DomUtil["setStyle"](oCellDomRef, window["UCF_System"]["bIsRTL"] ? 'borderLeftWidth' : 'borderRightWidth', '');
				UCF_DomUtil["setStyle"](oCellDomRef, 'width', bBeforeSiblingSelected ? this["_sWidth"] : (parseInt(this["_sWidth"]) + 1) + 'px');
			} else {
				this["_sSelectionBorderRightClassName"] = 'lsDGSCDivSelBrdRight';
				UCF_DomUtil["setStyle"](oCellDomRef, window["UCF_System"]["bIsRTL"] ? 'borderLeftWidth' : 'borderRightWidth', '2px');
				// eslint-disable-next-line no-magic-numbers
				UCF_DomUtil["setStyle"](oCellDomRef, 'width', (parseInt(this["_sWidth"]) + (bBeforeSiblingSelected ? 1 : 2)) + 'px');
			}
			// set resulting css class at cell domref
			this["setCssClass"](oCellDomRef);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySelectionBehindBorderStyles"] = 0; };

/** */
UCF_ClientDataGridSegmentCell["prototype"]["applySemanticColorStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySemanticColorStyles"]++; }; 
	/** @type {UCF_UrBase_SapTableSemanticType} */
	var sSemanticType = this["getSemanticType"]();
	/** @type {UCF_UrBase_SapTableCellDesign} */
	var sSemanticColor = this["getSemanticColor"]();
	/** @type {string} */
	var sSemanticColorClassName;

	if (
		this["_sSemanticType"] !== sSemanticType ||
		this["_sSemanticColor"] !== sSemanticColor
	) {
		if (sSemanticType && sSemanticType !== 'NONE') {
			this["_sSemanticType"] = sSemanticType;
			this["_sSemanticColor"] = '';
			this["_sSemanticColorClassName"] = UCF_UrBase["sSemanticType"](sSemanticType);
		} else {
			this["_sSemanticType"] = '';
			this["_sSemanticColor"] = sSemanticColor;
			sSemanticColorClassName = UCF_UrBase["getSemanticColor"](sSemanticColor);
			if (sSemanticColorClassName !== '') {
				sSemanticColorClassName += ' ' + sSemanticColorClassName + 'IconBar';
			}
			this["_sSemanticColorClassName"] = sSemanticColorClassName;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applySemanticColorStyles"] = 0; };

/** */
UCF_ClientDataGridSegmentCell["prototype"]["applyReadonlyStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyReadonlyStyles"]++; }; 
	/** @type {UCF_ClientElement} */
	var oContent;

	if (
		this["oParent"] && // oParent = DataGridSegment
		this["oParent"]["oParent"] && // oParent.oParent = DataGridRow
		this["oParent"]["oParent"]["oParent"] && // oParent.oParent.oParent = DataGrid
		this["oParent"]["oParent"]["oParent"]["getContentEditMode"]() === 'EDITABLE' &&
		(oContent = this["getContent"]()) // the assignment is intended
	) {
		this["_sReadonlyClassName"] = oContent["getUCFInstanceInternal"]()["bIsWriteable"]()
			? ''
			: 'lsDGSCDivRo';
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyReadonlyStyles"] = 0; };

/** @param {HTMLElement} oCellDomRef */
UCF_ClientDataGridSegmentCell["prototype"]["applyMergeBorderStyles"] = function(oCellDomRef) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyMergeBorderStyles"]++; }; 
	if (this["_bShowLeftBorder"] != this["__bShowLeftBorder"]) {
		this["_bShowLeftBorder"] = this["__bShowLeftBorder"];

		UCF_DomUtil["setStyle"](oCellDomRef, 'borderLeftStyle', this["_bShowLeftBorder"] ? 'solid' : 'none');
	}
	if (this["_bShowTopBorder"] != this["__bShowTopBorder"]) {
		this["_bShowTopBorder"] = this["__bShowTopBorder"];

		UCF_DomUtil["setStyle"](oCellDomRef, 'borderTopStyle', this["_bShowTopBorder"] ? 'solid' : 'none');
	}
	if (this["_bShowRightBorder"] != this["__bShowRightBorder"]) {
		this["_bShowRightBorder"] = this["__bShowRightBorder"];

		UCF_DomUtil["setStyle"](oCellDomRef, 'borderRightStyle', this["_bShowRightBorder"] ? 'solid' : 'none');
	}
	if (this["_bShowBottomBorder"] != this["__bShowBottomBorder"]) {
		this["_bShowBottomBorder"] = this["__bShowBottomBorder"];

		UCF_DomUtil["setStyle"](oCellDomRef, 'borderBottomStyle', this["_bShowBottomBorder"] ? 'solid' : 'none');
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyMergeBorderStyles"] = 0; };

/**
 * @param {number} iX
 * @param {number} iY
 * @return {boolean}
 */
UCF_ClientDataGridSegmentCell["prototype"]["bIsNeighborCellSelected"] = function(iX, iY) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["bIsNeighborCellSelected"]++; }; 
	/** @type {string} */
	var sSelectionState;
	/** @type {string} */
	var sPath;
	/** @type {string[]} */
	var aPathFragments;

	if (this["mBindingInfos"]["SelectionState"]) {
		sSelectionState = '';
		sPath = this["mBindingInfos"]["SelectionState"]["binding"]["getContext"]()["getPath"]();
		aPathFragments = sPath["split"]('/');

		aPathFragments[aPathFragments["length"] - 1] = iX + '-' + iY;
		sPath = aPathFragments["join"]('/');
		sSelectionState = this["getModel"]()["getProperty"](sPath + '/__selected');

		// eslint-disable-next-line no-magic-numbers
		return (sSelectionState == 1 || sSelectionState == 2);
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["bIsNeighborCellSelected"] = 0; };

UCF_ClientDataGridSegmentCell["prototype"]["applyFragmentVAlignStyles"] = function(oFragment, oContentFragment, sVerticalAlign) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyFragmentVAlignStyles"]++; }; 
	UCF_DomUtil["setStyle"](oFragment, 'backgroundPositionY', this["sGetVAlignPosition"](sVerticalAlign, oFragment, oContentFragment));
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["applyFragmentVAlignStyles"] = 0; };

/**
 * @param {string} sVerticalAlign
 * @param {HTMLElement} oFragment
 * @param {HTMLElement} oContentFragment
 * @param {string} sIconSrc
 * @return {string}
 */
UCF_ClientDataGridSegmentCell["prototype"]["sGetVAlignPosition"] = function(sVerticalAlign, oFragment, oContentFragment, sIconSrc) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["sGetVAlignPosition"]++; }; 
	/** @type {number} */ // eslint-disable-next-line no-magic-numbers
	var vAlignBottomOffset = (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) ? 5 : 2;
	/** @type {number} */
	var vAlignTopOffset = (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) ? 1 : 0;
	/** @type {number} */
	var iContentHeight;
	/** @type {number} */
	var iIconHeight;
	/** @type {HTMLImageElement} */
	var oImage;
	/** @type {CSSStyleDeclaration} */
	var oComputedStyle;

	switch (sVerticalAlign) {
		case 'TOP':
			iContentHeight = oContentFragment["firstChild"]["firstChild"]["firstChild"]["offsetHeight"];
			iIconHeight = 0;
			oImage = new Image();
			if (sIconSrc) {
				oImage["src"] = sIconSrc;
			} else {
				oComputedStyle = window["getComputedStyle"](oFragment, null);
				oImage["src"] = oComputedStyle["backgroundImage"]["replace"](/url\((['"])?(.*?)\1\)/gi, '$2')["split"](',')[0];
			}
			iIconHeight = oImage["height"];

			// eslint-disable-next-line no-magic-numbers
			return ((iContentHeight / 2) - (iIconHeight / 2) + vAlignTopOffset) + 'px';
		case 'MIDDLE':
			return 'center';
		case 'BOTTOM':
			iContentHeight = oContentFragment["firstChild"]["firstChild"]["firstChild"]["offsetHeight"];
			iIconHeight = 0;
			oImage = new Image();
			if (sIconSrc) {
				oImage["src"] = sIconSrc;
			} else {
				oComputedStyle = window["getComputedStyle"](oFragment, null);
				oImage["src"] = oComputedStyle["backgroundImage"]["replace"](/url\((['"])?(.*?)\1\)/gi, '$2')["split"](',')[0];
			}
			iIconHeight = oImage["height"];

			// eslint-disable-next-line no-magic-numbers
			return (parseInt(this["_sHeight"]) - ((iContentHeight / 2) + (iIconHeight / 2) + vAlignBottomOffset)) + 'px';
		case 'BASELINE':
			return 'center';
		default:
			return 'center';
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["sGetVAlignPosition"] = 0; };

/** @param {HTMLElement} oCellDomRef */
UCF_ClientDataGridSegmentCell["prototype"]["setCssClass"] = function(oCellDomRef) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setCssClass"]++; }; 
	this["_sClassName"] = 'lsDGSCDiv urBorderBox';
	//set sematic color only for non header cells
	if (this["_sSemanticColorClassName"] && this["_sSemanticColorClassName"] != '') {
		this["_sClassName"] = this["_sClassName"] + ' ' + this["_sSemanticColorClassName"];
	}
	if (this["_sHeaderStateClassName"] && this["_sHeaderStateClassName"] != '') {
		this["_sClassName"] = this["_sClassName"] + ' ' + this["_sHeaderStateClassName"];
	}
	if (this["_sSelectionStateClassName"] && this["_sSelectionStateClassName"] != '') {
		this["_sClassName"] = this["_sClassName"] + ' ' + this["_sSelectionStateClassName"];
	}
	if (this["_sSelectionBorderTopClassName"] && this["_sSelectionBorderTopClassName"] != '') {
		this["_sClassName"] = this["_sClassName"] + ' ' + this["_sSelectionBorderTopClassName"];
	}
	if (this["_sSelectionBorderRightClassName"] && this["_sSelectionBorderRightClassName"] != '') {
		this["_sClassName"] = this["_sClassName"] + ' ' + this["_sSelectionBorderRightClassName"];
	}
	if (this["_sSelectionBorderBottomClassName"] && this["_sSelectionBorderBottomClassName"] != '') {
		this["_sClassName"] = this["_sClassName"] + ' ' + this["_sSelectionBorderBottomClassName"];
	}
	if (this["_sSelectionBorderLeftClassName"] && this["_sSelectionBorderLeftClassName"] != '') {
		this["_sClassName"] = this["_sClassName"] + ' ' + this["_sSelectionBorderLeftClassName"];
	}
	if (this["_sReadonlyClassName"] && this["_sReadonlyClassName"] != '') {
		this["_sClassName"] = this["_sClassName"] + ' ' + this["_sReadonlyClassName"];
	}
	if (this["_sClassName"] != this["__sClassName"]) {
		UCF_DomUtil["setClass"](oCellDomRef, this["_sClassName"]);
		this["__sClassName"] = this["_sClassName"];
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentCell["_"]["setCssClass"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientDataGridSegmentColumn"] = function() { var UCF_ClientDataGridSegmentColumn = window["UCF_ClientDataGridSegmentColumn"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientDataGridSegmentColumn"); UCF_ClientDataGridSegmentColumn["_"] = {UCF_ClientDataGridSegmentColumn: 0}; };/* global UCF_ClientDataGridSegmentColumn */
UCF_ClientDataGridSegmentColumn["prototype"]["oGetDataGridColumn"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["oGetDataGridColumn"]++; }; 
	if (!this["oDataGridColumn"]) {
		this["oDataGridColumn"] = this["getParent"]();
	}
	return this["oDataGridColumn"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["oGetDataGridColumn"] = 0; };

UCF_ClientDataGridSegmentColumn["prototype"]["oGetUCFDataGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["oGetUCFDataGrid"]++; }; 
	if (!this["oUCFDataGrid"] || !this["oUCFDataGrid"]["oDomRef"]) {
		this["oUCFDataGrid"] = this["oGetDataGridColumn"]()["getParent"]()["getUCFInstance"]();
	}
	return this["oUCFDataGrid"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["oGetUCFDataGrid"] = 0; };

UCF_ClientDataGridSegmentColumn["prototype"]["setWidth"] = function(fWidth, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["setWidth"]++; }; 

	if ((fWidth && this["getWidth"]() != fWidth) || this["bForceUpdate"]) {
		this["setProperty"]("Width", fWidth, true);
		//		if (!this.oGetDataGridColumn() || !this.oGetUCFDataGrid()) return;
		if (!this["oGetDataGridColumn"]() || (this["iGetIndex"]() == null)) return;
		//update _SegmentColumns array of DataGridColumn
		this["oGetDataGridColumn"]()["_setSegmentColumnWidth"](this["iGetIndex"](), fWidth);
		//set dirty Index
		this["oGetDataGridColumn"]()["setDirtyIndex"](this["iGetIndex"]());

		//adjust DataGridColumn width if there is no scrollbar
		if (!this["oGetDataGridColumn"]()["getScrollbar"]()) {
			//check for completely initialized UCF as well as ClientControl ... otherwise scrollbar aggregation is anyway not defined
			if (!this["oGetUCFDataGrid"]() || !this["oGetUCFDataGrid"]()["oDomRef"] || (this["oGetUCFDataGrid"]()["getClientControl"]()["indexOfAggregation"]("Columns", this["oGetDataGridColumn"]()) == null)) return;
			this["oGetDataGridColumn"]()["updateColumnWidth"]();
		} else {
			if (this["oGetUCFDataGrid"]()) this["oGetUCFDataGrid"]()["checkResize"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["setWidth"] = 0; };

UCF_ClientDataGridSegmentColumn["prototype"]["setType"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["setType"]++; }; 
	if (sType && this["getType"]() != sType) {
		this["setProperty"]("Type", sType, true);

		if (!this["oGetDataGridColumn"]() || (this["iGetIndex"]() == null)) return;
		//update _SegmentColumns array of DataGridColumn
		this["oGetDataGridColumn"]()["_setSegmentColumnType"](this["iGetIndex"](), sType);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["setType"] = 0; };

UCF_ClientDataGridSegmentColumn["prototype"]["setIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["setIndex"]++; }; 
	if (this["_iIndex"] != iIndex) {
		this["_iIndex"] = iIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["setIndex"] = 0; };

UCF_ClientDataGridSegmentColumn["prototype"]["iGetIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["iGetIndex"]++; }; 
	var oBindingContext = this["getBindingContext"]();
	if (oBindingContext) {
		return oBindingContext["oParameter"]["x"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentColumn["_"]["iGetIndex"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientDataGridSegmentRow"] = function() { var UCF_ClientDataGridSegmentRow = window["UCF_ClientDataGridSegmentRow"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientDataGridSegmentRow"); UCF_ClientDataGridSegmentRow["_"] = {UCF_ClientDataGridSegmentRow: 0}; };/* global UCF_ClientDataGridSegmentRow */
UCF_ClientDataGridSegmentRow["prototype"]["oGetDataGridRow"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["oGetDataGridRow"]++; }; 
	if (!this["oDataGridRow"]) {
		this["oDataGridRow"] = this["getParent"]();
	}
	return this["oDataGridRow"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["oGetDataGridRow"] = 0; };

UCF_ClientDataGridSegmentRow["prototype"]["oGetUCFDataGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["oGetUCFDataGrid"]++; }; 
	if (!this["oUCFDataGrid"] || !this["oUCFDataGrid"]["oDomRef"]) {
		this["oUCFDataGrid"] = this["oGetDataGridRow"]()["getParent"]()["getUCFInstance"]();
	}
	return this["oUCFDataGrid"];
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["oGetUCFDataGrid"] = 0; };

UCF_ClientDataGridSegmentRow["prototype"]["setHeight"] = function(fHeight, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["setHeight"]++; }; 

	if ((fHeight && this["getHeight"]() != fHeight) || this["bForceUpdate"]) {
		this["setProperty"]("Height", fHeight, true);

		if (!this["oGetDataGridRow"]() || (this["iGetIndex"]() == null)) return;
		//update _SegmentRows array of DataGridRow
		this["oGetDataGridRow"]()["_setSegmentRowHeight"](this["iGetIndex"](), fHeight);
		//set dirty Index
		this["oGetDataGridRow"]()["setDirtyIndex"](this["iGetIndex"]());

		//adjust DataGridRow height if there is no scrollbar
		if (!this["oGetDataGridRow"]()["getScrollbar"]()) {
			//check for completely initialized UCF as well as ClientControl ... otherwise scrollbar aggregation is anyway not defined
			if (!this["oGetUCFDataGrid"]() || !this["oGetUCFDataGrid"]()["oDomRef"] || (this["oGetUCFDataGrid"]()["getClientControl"]()["indexOfAggregation"]("Rows", this["oGetDataGridRow"]()) == null)) return;
			this["oGetDataGridRow"]()["updateRowHeight"]();
		} else {
			if (this["oGetUCFDataGrid"]()) this["oGetUCFDataGrid"]()["checkResize"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["setHeight"] = 0; };

UCF_ClientDataGridSegmentRow["prototype"]["setType"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["setType"]++; }; 
	if (sType && this["getType"]() != sType) {
		this["setProperty"]("Type", sType, true);

		if (!this["oGetDataGridRow"]() || (this["iGetIndex"]() == null)) return;
		//update _SegmentRows array of DataGridRow
		this["oGetDataGridRow"]()["_setSegmentRowType"](this["iGetIndex"](), sType);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["setType"] = 0; };

UCF_ClientDataGridSegmentRow["prototype"]["setIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["setIndex"]++; }; 
	if (this["_iIndex"] != iIndex) {
		this["_iIndex"] = iIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["setIndex"] = 0; };

UCF_ClientDataGridSegmentRow["prototype"]["iGetIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["iGetIndex"]++; }; 
	var oBindingContext = this["getBindingContext"]();
	if (oBindingContext) {
		return oBindingContext["oParameter"]["x"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ClientDataGridSegmentRow["_"]["iGetIndex"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientDecorator"] = function() { var UCF_ClientDecorator = window["UCF_ClientDecorator"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientDecorator"); UCF_ClientDecorator["_"] = {UCF_ClientDecorator: 0}; };/* global UCF_ClientDecorator */

UCF_ClientDecorator["prototype"]["setIconSrc"] = function(sIconSrc, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDecorator["_"]["setIconSrc"]++; }; 
	if (this["getIconSrc"]() === sIconSrc) return;
	var oParent = this["getParent"]();

	if (oParent && oParent["updateInnerHTML"]) {
		this["setProperty"]("IconSrc", sIconSrc,true);
		oParent["updateInnerHTML"](oParent["getId"]());

		return;
	}
	this["setProperty"]("IconSrc", sIconSrc, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientDecorator["_"]["setIconSrc"] = 0; };

UCF_ClientDecorator["prototype"]["setPosition"] = function(sPosition, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientDecorator["_"]["setPosition"]++; }; 
	if (this["getPosition"]() === sPosition) return;
	var oParent = this["getParent"]();

	if (oParent && oParent["updateInnerHTML"]) {
		this["setProperty"]("Position", sPosition, true);
		oParent["updateInnerHTML"](oParent["getId"]());

		return;
	}
	this["setProperty"]("Position", sPosition, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientDecorator["_"]["setPosition"] = 0; };


};
sap["ls"]["preload"]["UCF_ClientInputField"] = function() { var UCF_ClientInputField = window["UCF_ClientInputField"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientInputField"); UCF_ClientInputField["_"] = {UCF_ClientInputField: 0}; };/* global UCF_ClientElement */
/// <reference path="../core/ClientElement.js"/>

/* global UCF_ClientInputField */
UCF_ClientInputField["prototype"]["unbindProperty"] = function(sProperty) {;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["unbindProperty"]++; }; 
	if (sProperty === "Value") {
		UCF_ClientElement["prototype"]["unbindProperty"]["apply"](this, ["InputState"]);
		UCF_ClientElement["prototype"]["unbindProperty"]["apply"](this, arguments);
	};
};;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["unbindProperty"] = 0; };

UCF_ClientInputField["prototype"]["bindProperty"] = function(sProperty) {;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["bindProperty"]++; }; 
	//fill the binding info
	UCF_ClientElement["prototype"]["bindProperty"]["apply"](this, arguments);
	if (sProperty === "Value" && !this["isBound"]("InputState") && !this["bIsClone"]) {
		var sPath = this["mBindingInfos"][sProperty]["path"];
		//create the path to the __state
		var sStatePath = sPath,
			sModelField;

		if (sStatePath["indexOf"]("/") > -1) {
			sModelField = sPath["substring"](sPath["lastIndexOf"]("/") + 1);
			sStatePath = sPath["substring"](0, sPath["lastIndexOf"]("/")) + "/__state/" + sModelField;
		} else {
			sModelField = sPath;
			sStatePath = "__state/" + sModelField;
		}

		//bind the InputState to the state path and put a formatting function to map the values
		this["bindProperty"]("InputState", sStatePath, function(iValue) {

			if (iValue === true) iValue = 1;
			if (iValue === false) iValue = 0;

			switch (iValue) {
				case 1:
					return "ERROR";
				case 2:
					return "WARNING";
				default:
					return "NONE"; //valid
			}
		});
	}
};;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["bindProperty"] = 0; };

UCF_ClientInputField["prototype"]["setValue"] = function(sValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["setValue"]++; }; 
	return this["setUCFProperty"]("Value", sValue, bSuppressRerendering, "setValue");
};;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["setValue"] = 0; };

UCF_ClientInputField["prototype"]["setTooltip"] = function(sTooltip, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["setTooltip"]++; }; 
	return this["setUCFProperty"]("Tooltip", sTooltip, bSuppressRerendering, "setTooltip");
};;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["setTooltip"] = 0; };

UCF_ClientInputField["prototype"]["setAlign"] = function(sAlign, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["setAlign"]++; }; 
	// Note: Do not use the optional 4-th array-argument to allow setting to the default value with sAlign=null - see UCF_ClientElement.setUCFProperty() coding
	return this["setUCFProperty"]("Align", sAlign, bSuppressRerendering, "setAlign");
};;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["setAlign"] = 0; };

UCF_ClientInputField["prototype"]["setInputState"] = function(sInputState, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["setInputState"]++; }; 
	return this["setUCFProperty"]("InputState", sInputState, bSuppressRerendering, "setInputState", [sInputState, ""]);
};;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["setInputState"] = 0; };

UCF_ClientInputField["prototype"]["setReadonly"] = function(bReadonly, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["setReadonly"]++; }; 
	return this["setUCFProperty"]("Readonly", bReadonly, bSuppressRerendering, "setEditable", [!bReadonly]);
};;if (__UCF_COVERAGE__) { UCF_ClientInputField["_"]["setReadonly"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientInterfaces"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../../core/util/ClassLoader.js"/>

/** @typedef {Object<string,string>} UCF_ClientInterfaces_Enum */
/**
 * @typedef {Object} UCF_ClientInterfaces_Property
 * @property {string} type
 * @property {any} defaultValue
 */
/**
 * @typedef {Object} UCF_ClientInterfaces_Aggregation
 * @property {string} type
 * @property {boolean} multiple
 * @property {string} [singularName] only if multiple=true
 * @property {boolean} [bindable]
 * @property {'tree'|'grid'} [bindingType]
 * @property {string} _sMutator
 * @property {string} _sDestructor
 */
/**
 * @typedef {Object} UCF_ClientInterfaces_Association
 * @property {string} type
 */
/** @typedef {Object} UCF_ClientInterfaces_Event */
/**
 * @typedef {Object} UCF_ClientInterfaces_CustomStyleVariable
 * @property {string} name
 * @property {string} property
 * @property {string} [defaultValue]
 * @property {string} [expression]
 * @property {string} [docu]
 */
/**
 * @typedef {Object} UCF_ClientInterfaces_CustomStyleProperty
 * @property {string} name
 * @property {string} expression
 * @property {boolean} [important]
 */
/** @typedef {Array<UCF_ClientInterfaces_CustomStyleProperty>} UCF_ClientInterfaces_CustomStyleClass */
/**
 * @typedef {Object} UCF_ClientInterfaces_CustomStyles
 * @property {Array<UCF_ClientInterfaces_CustomStyleVariable>} variables
 * @property {Object<string,UCF_ClientInterfaces_CustomStyleClass>} classes
 */
/**
 * @typedef {Object} UCF_ClientInterfaces_Interface
 * @property {string} name
 * @property {Object<string,UCF_ClientInterfaces_Property} properties
 * @property {Object<string,UCF_ClientInterfaces_Aggregation} aggregations
 * @property {Object<string,UCF_ClientInterfaces_Association} associations
 * @property {Object<string,UCF_ClientInterfaces_Event} events
 * @property {Array<string>} publicMethods
 * @property {UCF_ClientInterfaces_CustomStyles} styles
 */
/**
 * @typedef {Object} UCF_ClientInterfaces_Renderer
 * @property {function(UCF_ClientElement_RenderInfo, UCF_RenderManager): void} render
 */

/** Creates the necessary base implementation for all client interfaces. */
function UCF_ClientInterfaces() {if (__UCF_COVERAGE__) { UCF_ClientInterfaces["_"]["UCF_ClientInterfaces"]++; }; 
	UCF_Object["apply"](this);
};window["UCF_ClientInterfaces"] = UCF_ClientInterfaces; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientInterfaces"); UCF_ClientInterfaces["_"] = {UCF_ClientInterfaces: 0}; }; ;
UCF_ClientInterfaces["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_ClientInterfaces.prototype["sClassName"] = "UCF_ClientInterfaces";
UCF_ClientInterfaces["self"] = new (UCF_ClassLoader["oGetClass"]("UCF_ClientInterfaces"))();  //needed, otherwise rollup removes the unused class from the bundle

/**
 * Returns the client side interface of a given class
 *
 * @param {string} sClassName the classname to find the interface to
 * @return {UCF_ClientInterfaces_Interface} The client side interface
 */
UCF_ClientInterfaces["getInterface"] = function(sClassName) {;if (__UCF_COVERAGE__) { UCF_ClientInterfaces["_"]["getInterface"]++; }; 
	/** @type {UCF_ClientInterfaces_Interface} */
	var mMetadata;
	/** @type {string} */
	var n;
	/** @type {UCF_ClientInterfaces_Aggregation} */
	var oAggregation;

	if (sClassName) {
		if (sClassName["lastIndexOf"]('.') > -1) {
			sClassName = sClassName["substring"](sClassName["lastIndexOf"]('.') + 1);
		}
		mMetadata = UCF_ClientInterfaces["I"][sClassName];
		for (n in mMetadata["properties"]) {
			mMetadata["properties"][n]["_sMutator"] = 'set' + n;
		}
		for (n in mMetadata["aggregations"]) {
			oAggregation = mMetadata["aggregations"][n];
			if (oAggregation["multiple"]) {
				oAggregation["_sMutator"] = 'add' + mMetadata["aggregations"][n]["singularName"];
				oAggregation["_sDestructor"] = 'clear' + n;
			} else {
				oAggregation["_sMutator"] = 'set' + n;
				oAggregation["_sDestructor"] = 'clear' + n;
			}
		}

		return mMetadata;
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientInterfaces["_"]["getInterface"] = 0; };

/**
 * Returns the enumeration with the given name
 *
 * @param {string} sEnumName the name of the enum to get
 * @return {UCF_ClientInterfaces_Enum} The enumeration map
 */
UCF_ClientInterfaces["getEnum"] = function(sEnumName) {;if (__UCF_COVERAGE__) { UCF_ClientInterfaces["_"]["getEnum"]++; }; 
	return sEnumName ? UCF_ClientInterfaces["E"][sEnumName] : null;
};;if (__UCF_COVERAGE__) { UCF_ClientInterfaces["_"]["getEnum"] = 0; };

/**
 * Returns the enumeration with the given name
 *
 * @param {string} sControlName the name of the control
 * @return {Array<string>} The used renderers
 */
UCF_ClientInterfaces["getRenderers"] = function(sControlName) {;if (__UCF_COVERAGE__) { UCF_ClientInterfaces["_"]["getRenderers"]++; }; 
	return sControlName ? UCF_ClientInterfaces["R"][sControlName] : null;
};;if (__UCF_COVERAGE__) { UCF_ClientInterfaces["_"]["getRenderers"] = 0; };

/**
 * Returns whether the given control has a renderer or not
 *
 * @param {string} sControlName The name of the control
 * @return {boolean} `true` if there is a renderer for the control
 */
UCF_ClientInterfaces["hasRenderer"] = function(sControlName) {;if (__UCF_COVERAGE__) { UCF_ClientInterfaces["_"]["hasRenderer"]++; }; 
	return sControlName in UCF_ClientInterfaces["R"];
};;if (__UCF_COVERAGE__) { UCF_ClientInterfaces["_"]["hasRenderer"] = 0; };

/**
 * Loads the renderes for a given control sName.
 * It includes all renderers that might be used via useControl in fragments.
 * @param {string} sName The name of the control
 * @param {array} aImpl optional string writer to add the class string of the
 * renderer. If not given the class is loaded and evaluated directly.
 */
UCF_ClientInterfaces["loadRenderer"] = function(sName, aImpl) {;if (__UCF_COVERAGE__) { UCF_ClientInterfaces["_"]["loadRenderer"]++; }; 
	/** @type {string} */
	var sInternalName;

	if (UCF_ClientInterfaces["hasRenderer"](sName)) {
		if (!UCF_ClientInterfaces["R"][sName + 'Loaded']) {
			UCF_ClientInterfaces["R"][sName + 'Loaded'] = true;
			UCF_JsUtil["forEach"](
				UCF_ClientInterfaces["getRenderers"](sName),
				function(oRenderer) {
					UCF_ClientInterfaces["loadRenderer"](oRenderer, aImpl);
				}
			);

			sInternalName = 'UCF_' + sName + 'Renderer';
			if (aImpl) {
				aImpl["push"](UCF_ClassLoader["sGetClassString"](sInternalName));
			} else {
				UCF_ClassLoader["oGetClass"](sInternalName);
			}

		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientInterfaces["_"]["loadRenderer"] = 0; };

/**
 * Global namespace for all interfaces
 * @constant {Object<string,UCF_ClientInterfaces_Interface>}
 */
UCF_ClientInterfaces["I"] = {};
/**
 * Global namespace for all enumerations
 * @constant {Object<string,UCF_ClientInterfaces_Enum>}
 */
UCF_ClientInterfaces["E"] = {};
/**
 * Global namespace for all implementations
 * @constant {Object<string,boolean>}
 */
UCF_ClientInterfaces["IMPL"] = {};
/**
 * Global namespace for all use control renderers
 * @constant {Object<string,Array<string>>}
 */
UCF_ClientInterfaces["R"] = {};
UCF_ClientInterfaces["E"]["AbapListImageType"] = {
	"SRC": "SRC",
	"LINE_TOP_RIGHT": "LINE_TOP_RIGHT",
	"LINE_TOP_RIGHT_BOTTOM": "LINE_TOP_RIGHT_BOTTOM",
	"LINE_TOP_RIGHT_BOTTOM_LEFT": "LINE_TOP_RIGHT_BOTTOM_LEFT",
	"LINE_TOP_RIGHT_LEFT": "LINE_TOP_RIGHT_LEFT",
	"LINE_TOP_BOTTOM": "LINE_TOP_BOTTOM",
	"LINE_TOP_BOTTOM_LEFT": "LINE_TOP_BOTTOM_LEFT",
	"LINE_TOP_LEFT": "LINE_TOP_LEFT",
	"LINE_RIGHT_BOTTOM": "LINE_RIGHT_BOTTOM",
	"LINE_RIGHT_BOTTOM_LEFT": "LINE_RIGHT_BOTTOM_LEFT",
	"LINE_RIGHT_LEFT": "LINE_RIGHT_LEFT",
	"LINE_BOTTOM_LEFT": "LINE_BOTTOM_LEFT"
};

UCF_ClientInterfaces["E"]["AccordionItemDesign"] = {
	"STANDARD": "STANDARD",
	"EMPHASIZED": "EMPHASIZED"
};

UCF_ClientInterfaces["E"]["AccordionSizing"] = {
	"FILL": "FILL",
	"PUSH": "PUSH"
};

UCF_ClientInterfaces["E"]["AnimAttribute"] = {
	"OPACITY": "OPACITY",
	"HEIGHT": "HEIGHT",
	"WIDTH": "WIDTH",
	"LEFT": "LEFT",
	"TOP": "TOP",
	"SCALEX": "SCALEX",
	"SCALEY": "SCALEY",
	"ROTATE": "ROTATE",
	"SKEWX": "SKEWX",
	"SKEWY": "SKEWY",
	"TRANSLATEX": "TRANSLATEX",
	"TRANSLATEY": "TRANSLATEY"
};

UCF_ClientInterfaces["E"]["AnimEventType"] = {
	"SEMANTIC": "SEMANTIC",
	"USER": "USER"
};

UCF_ClientInterfaces["E"]["AnimFunction"] = {
	"LINEAR": "LINEAR",
	"EASEIN": "EASEIN",
	"EASEOUT": "EASEOUT",
	"EASEINOUT": "EASEINOUT",
	"EASELOOPBACK": "EASELOOPBACK"
};

UCF_ClientInterfaces["E"]["AnimPhase"] = {
	"TRIGGER": "TRIGGER",
	"BEFOREREQUEST": "BEFOREREQUEST",
	"AFTERREQUEST": "AFTERREQUEST",
	"AFTERRESPONSE": "AFTERRESPONSE",
	"UPDATECOMPLETE": "UPDATECOMPLETE"
};

UCF_ClientInterfaces["E"]["AppletContainerJavaVersion"] = {
	"BROWSER": "BROWSER",
	"V13": "V13",
	"V14": "V14",
	"V15": "V15"
};

UCF_ClientInterfaces["E"]["Accessibility"] = {
	"NONE": "NONE",
	"ARIA": "ARIA"
};

UCF_ClientInterfaces["E"]["ARIALandmark"] = {
	"article": "article",
	"application": "application",
	"banner": "banner",
	"complementary": "complementary",
	"contentinfo": "contentinfo",
	"form": "form",
	"main": "main",
	"navigation": "navigation",
	"search": "search",
	"region": "region",
	"none": "none"
};

UCF_ClientInterfaces["E"]["CellBackgroundDesign"] = {
	"HEADER": "HEADER",
	"FILL1": "FILL1",
	"FILL2": "FILL2",
	"FILL3": "FILL3",
	"PLAIN": "PLAIN",
	"TRANSPARENT": "TRANSPARENT",
	"BORDER": "BORDER"
};

UCF_ClientInterfaces["E"]["CellHAlign"] = {
	"FORCEDLEFT": "FORCEDLEFT",
	"LEFT": "LEFT",
	"CENTER": "CENTER",
	"RIGHT": "RIGHT",
	"ENDOFLINE": "ENDOFLINE",
	"JUSTIFY": "JUSTIFY",
	"CHAR": "CHAR",
	"FORCEDRIGHT": "FORCEDRIGHT",
	"BEGINOFLINE": "BEGINOFLINE"
};

UCF_ClientInterfaces["E"]["CellVAlign"] = {
	"TOP": "TOP",
	"MIDDLE": "MIDDLE",
	"BOTTOM": "BOTTOM",
	"BASELINE": "BASELINE"
};

UCF_ClientInterfaces["E"]["ClientAction"] = {
	"SUBMIT": "SUBMIT",
	"SUBMITASYNC": "SUBMITASYNC",
	"ENQUEUE": "ENQUEUE",
	"NONE": "NONE"
};

UCF_ClientInterfaces["E"]["CssLengthUnit"] = {
	"PERCENT": "PERCENT",
	"IN": "IN",
	"CM": "CM",
	"MM": "MM",
	"EM": "EM",
	"EX": "EX",
	"PT": "PT",
	"PC": "PC",
	"PX": "PX",
	"VH": "VH",
	"VW": "VW",
	"REM": "REM"
};

UCF_ClientInterfaces["E"]["DebugLevel"] = {
	"OFF": "OFF",
	"PERFORMANCE": "PERFORMANCE",
	"FESR": "FESR"
};

UCF_ClientInterfaces["E"]["DecoratorPosition"] = {
	"TOP_LEFT": "TOP_LEFT",
	"TOP_RIGHT": "TOP_RIGHT",
	"BOTTOM_LEFT": "BOTTOM_LEFT",
	"BOTTOM_RIGHT": "BOTTOM_RIGHT",
	"NONE": "NONE"
};

UCF_ClientInterfaces["E"]["Device"] = {
	"ie6": "ie6",
	"ff1": "ff1",
	"sf3": "sf3",
	"lsx": "lsx",
	"standards": "standards"
};

UCF_ClientInterfaces["E"]["DragGhostType"] = {
	"BOX": "BOX",
	"CONTENT": "CONTENT"
};

UCF_ClientInterfaces["E"]["EmbeddingBehaviour"] = {
	"COMPATIBLE": "COMPATIBLE",
	"FILL": "FILL",
	"FILL_FIXED_LAYOUT": "FILL_FIXED_LAYOUT"
};

UCF_ClientInterfaces["E"]["FeatureChannel"] = {
	"STABLE": "STABLE",
	"BETA": "BETA",
	"NIGHTLY": "NIGHTLY"
};

UCF_ClientInterfaces["E"]["ForcedTextDirection"] = {
	"LTR": "LTR",
	"RTL": "RTL",
	"INHERIT": "INHERIT"
};

UCF_ClientInterfaces["E"]["FormInputFieldType"] = {
	"BUTTON": "BUTTON",
	"CHECKBOX": "CHECKBOX",
	"COLOR": "COLOR",
	"DATE": "DATE",
	"DATETIMELOCAL": "DATETIMELOCAL",
	"EMAIL": "EMAIL",
	"FILE": "FILE",
	"HIDDEN": "HIDDEN",
	"IMAGE": "IMAGE",
	"MONTH": "MONTH",
	"NUMBER": "NUMBER",
	"PASSWORD": "PASSWORD",
	"RADIO": "RADIO",
	"RANGE": "RANGE",
	"RESET": "RESET",
	"SEARCH": "SEARCH",
	"SUBMIT": "SUBMIT",
	"TEL": "TEL",
	"TEXT": "TEXT",
	"TIME": "TIME",
	"URL": "URL",
	"WEEK": "WEEK"
};

UCF_ClientInterfaces["E"]["GeneratorTestEnum"] = {
	"FIRST": "FIRST",
	"SECOND": "SECOND",
	"THIRD": "THIRD"
};

UCF_ClientInterfaces["E"]["HorizontalAlign"] = {
	"FORCEDLEFT": "FORCEDLEFT",
	"LEFT": "LEFT",
	"CENTER": "CENTER",
	"RIGHT": "RIGHT",
	"ENDOFLINE": "ENDOFLINE",
	"FORCEDRIGHT": "FORCEDRIGHT",
	"BEGINOFLINE": "BEGINOFLINE"
};

UCF_ClientInterfaces["E"]["HorizontalTextAlign"] = {
	"CENTER": "CENTER",
	"LEFT": "LEFT",
	"RIGHT": "RIGHT",
	"JUSTIFY": "JUSTIFY"
};

UCF_ClientInterfaces["E"]["IMEMode"] = {
	"AUTO": "AUTO",
	"ACTIVE": "ACTIVE",
	"INACTIVE": "INACTIVE",
	"DISABLED": "DISABLED"
};

UCF_ClientInterfaces["E"]["InputDesign"] = {
	"STANDARD": "STANDARD",
	"MONOSPACE": "MONOSPACE"
};

UCF_ClientInterfaces["E"]["InputState"] = {
	"ERROR": "ERROR",
	"WARNING": "WARNING",
	"NONE": "NONE"
};

UCF_ClientInterfaces["E"]["InterActionState"] = {
	"ENABLED": "ENABLED",
	"DISABLED": "DISABLED",
	"READONLY": "READONLY",
	"PARENTREADONLY": "PARENTREADONLY",
	"API_DRIVEN": "API_DRIVEN"
};

UCF_ClientInterfaces["E"]["InteractionType"] = {
	"KEYBOARD": "KEYBOARD",
	"TOUCH": "TOUCH"
};

UCF_ClientInterfaces["E"]["LayoutCellDesign"] = {
	"DEFAULT": "DEFAULT",
	"LRNOPAD": "LRNOPAD",
	"LPAD": "LPAD",
	"LRPAD": "LRPAD",
	"RPAD": "RPAD",
	"PADLESS": "PADLESS"
};

UCF_ClientInterfaces["E"]["LayoutCellPosition"] = {
	"DEFAULT": "DEFAULT",
	"RELATIVE": "RELATIVE"
};

UCF_ClientInterfaces["E"]["LayoutCellSeparation"] = {
	"DEFAULT": "DEFAULT",
	"SMALL": "SMALL",
	"SMALLWITHLINE": "SMALLWITHLINE",
	"LARGE": "LARGE",
	"LARGEWITHLINE": "LARGEWITHLINE",
	"XLARGE": "XLARGE",
	"XLARGEWITHLINE": "XLARGEWITHLINE"
};

UCF_ClientInterfaces["E"]["LayoutDropDecorator"] = {
	"BOX": "BOX",
	"LINE": "LINE"
};

UCF_ClientInterfaces["E"]["LifeCycle"] = {
	"BROWSER": "BROWSER",
	"AUTOMATIC": "AUTOMATIC",
	"MANUAL": "MANUAL"
};

UCF_ClientInterfaces["E"]["LockBehavior"] = {
	"ROUNDTRIP": "ROUNDTRIP",
	"OFF": "OFF"
};

UCF_ClientInterfaces["E"]["NotificationTrigger"] = {
	"NONE": "NONE",
	"INITIAL": "INITIAL",
	"WHEN_CHANGED": "WHEN_CHANGED"
};

UCF_ClientInterfaces["E"]["Platform"] = {
	"Windows": "Windows",
	"X11": "X11",
	"Macintosh": "Macintosh",
	"iOS": "iOS",
	"Android": "Android",
	"Blackberry": "Blackberry",
	"bot": "bot",
	"Java": "Java",
	"WindowsPhone": "WindowsPhone",
	"ChromeOS": "ChromeOS"
};

UCF_ClientInterfaces["E"]["RenderingMode"] = {
	"QUIRKS": "QUIRKS",
	"STANDARDS": "STANDARDS"
};

UCF_ClientInterfaces["E"]["ResizeMode"] = {
	"NONE": "NONE",
	"HORIZONTAL": "HORIZONTAL",
	"VERTICAL": "VERTICAL",
	"BOTH": "BOTH",
	"AUTO_VERTICAL": "AUTO_VERTICAL"
};

UCF_ClientInterfaces["E"]["ResponseData"] = {
	"FULL": "FULL",
	"DELTA": "DELTA",
	"INHERIT": "INHERIT"
};

UCF_ClientInterfaces["E"]["ScrollingMode"] = {
	"AUTO": "AUTO",
	"BOTH": "BOTH",
	"HIDE": "HIDE",
	"NONE": "NONE",
	"HORIZONTAL": "HORIZONTAL",
	"HORIZONTAL_AUTO": "HORIZONTAL_AUTO",
	"VERTICAL": "VERTICAL",
	"VERTICAL_AUTO": "VERTICAL_AUTO"
};

UCF_ClientInterfaces["E"]["SelectionState"] = {
	"CHECKED": "CHECKED",
	"UNCHECKED": "UNCHECKED",
	"INDETERMINATE": "INDETERMINATE",
	"SAPTABLE_PRIMARY_SELECTED": "SAPTABLE_PRIMARY_SELECTED",
	"SAPTABLE_SECONDARY_SELECTED": "SAPTABLE_SECONDARY_SELECTED",
	"SAPTABLE_PRIMARY_UNSELECTED": "SAPTABLE_PRIMARY_UNSELECTED",
	"SAPTABLE_SECONDARY_UNSELECTED": "SAPTABLE_SECONDARY_UNSELECTED",
	"API_DRIVEN": "API_DRIVEN"
};

UCF_ClientInterfaces["E"]["Semantic"] = {
	"STANDARD": "STANDARD",
	"ALTERNATING": "ALTERNATING",
	"TRANSPARENT": "TRANSPARENT",
	"NEGATIVE": "NEGATIVE",
	"POSITIVE": "POSITIVE",
	"TOTAL": "TOTAL",
	"SUBTOTAL": "SUBTOTAL",
	"SUBTOTAL_LIGHT": "SUBTOTAL_LIGHT",
	"BADVALUE_DARK": "BADVALUE_DARK",
	"BADVALUE_MEDIUM": "BADVALUE_MEDIUM",
	"BADVALUE_LIGHT": "BADVALUE_LIGHT",
	"CRITICAL": "CRITICAL",
	"CRITICALVALUE_DARK": "CRITICALVALUE_DARK",
	"CRITICALVALUE_MEDIUM": "CRITICALVALUE_MEDIUM",
	"CRITICALVALUE_LIGHT": "CRITICALVALUE_LIGHT",
	"GOODVALUE_DARK": "GOODVALUE_DARK",
	"GOODVALUE_MEDIUM": "GOODVALUE_MEDIUM",
	"GOODVALUE_LIGHT": "GOODVALUE_LIGHT",
	"GROUP_HIGHLIGHTED": "GROUP_HIGHLIGHTED",
	"GROUP_HIGHLIGHTED_LIGHT": "GROUP_HIGHLIGHTED_LIGHT",
	"KEY_MEDIUM": "KEY_MEDIUM",
	"GROUP_LEVEL1": "GROUP_LEVEL1",
	"GROUP_LEVEL2": "GROUP_LEVEL2",
	"GROUP_LEVEL3": "GROUP_LEVEL3",
	"MARKED": "MARKED",
	"FILTER": "FILTER",
	"FILTERICON": "FILTERICON",
	"POPIN": "POPIN",
	"NONE": "NONE",
	"DISABLED": "DISABLED",
	"TODAY": "TODAY",
	"SELECTED1": "SELECTED1",
	"SELECTED2": "SELECTED2",
	"SELECTED3": "SELECTED3",
	"SELECTED4": "SELECTED4",
	"SELECTED5": "SELECTED5",
	"CALENDAR_METAL": "CALENDAR_METAL",
	"CALENDAR_PEACH": "CALENDAR_PEACH",
	"CALENDAR_BLUE": "CALENDAR_BLUE",
	"CALENDAR_ROSE": "CALENDAR_ROSE",
	"CALENDAR_PURPLE": "CALENDAR_PURPLE",
	"CALENDAR_AQUA": "CALENDAR_AQUA",
	"CALENDAR_TEAL": "CALENDAR_TEAL",
	"CALENDAR_YELLOW": "CALENDAR_YELLOW",
	"CALENDAR_BROWN": "CALENDAR_BROWN",
	"CALENDAR_DEFAULT": "CALENDAR_DEFAULT",
	"CALENDAR_GREEN": "CALENDAR_GREEN"
};

UCF_ClientInterfaces["E"]["Size"] = {
	"MEDIUM": "MEDIUM",
	"LARGE": "LARGE"
};

UCF_ClientInterfaces["E"]["Sizing"] = {
	"PUSH": "PUSH",
	"FILL": "FILL"
};

UCF_ClientInterfaces["E"]["Spacing"] = {
	"ALIGNED": "ALIGNED",
	"ALIGNED_NO_BEGIN": "ALIGNED_NO_BEGIN",
	"ALIGNED_NO_END": "ALIGNED_NO_END"
};

UCF_ClientInterfaces["E"]["SubmitMethod"] = {
	"EVENT_QUEUE": "EVENT_QUEUE",
	"FORM": "FORM",
	"SEMANTIC_EVENT_HANDLER": "SEMANTIC_EVENT_HANDLER"
};

UCF_ClientInterfaces["E"]["UserAgent"] = {
	"MSIE": "MSIE",
	"GECKO": "GECKO",
	"WEBKIT": "WEBKIT",
	"EDGEHTML": "EDGEHTML"
};

UCF_ClientInterfaces["E"]["VerticalTextAlign"] = {
	"MIDDLE": "MIDDLE",
	"BASELINE": "BASELINE",
	"TOP": "TOP",
	"BOTTOM": "BOTTOM"
};

UCF_ClientInterfaces["E"]["Visibility"] = {
	"VISIBLE": "VISIBLE",
	"BLANK": "BLANK",
	"NONE": "NONE",
	"ON_DEMAND": "ON_DEMAND"
};

UCF_ClientInterfaces["E"]["BorderStyle"] = {
	"SOLID": "SOLID",
	"DASHED": "DASHED",
	"DOTTED": "DOTTED",
	"NONE": "NONE",
	"PREDEFINED": "PREDEFINED"
};

UCF_ClientInterfaces["E"]["FontSizeUnit"] = {
	"PT": "PT",
	"PX": "PX",
	"PC": "PC",
	"PERCENT": "PERCENT"
};

UCF_ClientInterfaces["E"]["FontStyle"] = {
	"ITALIC": "ITALIC",
	"NORMAL": "NORMAL",
	"PREDEFINED": "PREDEFINED"
};

UCF_ClientInterfaces["E"]["FontWeight"] = {
	"BOLD": "BOLD",
	"NORMAL": "NORMAL",
	"PREDEFINED": "PREDEFINED"
};

UCF_ClientInterfaces["E"]["TextDecoration"] = {
	"UNDERLINE": "UNDERLINE",
	"NORMAL": "NORMAL",
	"OVERLINE": "OVERLINE",
	"LINETHROUGH": "LINETHROUGH",
	"PREDEFINED": "PREDEFINED"
};

UCF_ClientInterfaces["E"]["TextWrapping"] = {
	"PREDEFINED": "PREDEFINED",
	"NOWRAP": "NOWRAP",
	"WRAP": "WRAP"
};

UCF_ClientInterfaces["E"]["BreadCrumbBehavior"] = {
	"DEFAULT": "DEFAULT",
	"SINGLELINK": "SINGLELINK"
};

UCF_ClientInterfaces["E"]["BreadCrumbSize"] = {
	"SMALL": "SMALL",
	"MEDIUM": "MEDIUM",
	"LARGE": "LARGE"
};

UCF_ClientInterfaces["E"]["ButtonDesign"] = {
	"EMPHASIZED": "EMPHASIZED",
	"STANDARD": "STANDARD",
	"PREVIOUS": "PREVIOUS",
	"NEXT": "NEXT",
	"TRANSPARENT": "TRANSPARENT",
	"ACCEPT": "ACCEPT",
	"REJECT": "REJECT",
	"TOGGLE": "TOGGLE"
};

UCF_ClientInterfaces["E"]["ButtonInteractionBehaviour"] = {
	"PUSH": "PUSH",
	"TOGGLE": "TOGGLE"
};

UCF_ClientInterfaces["E"]["ButtonSize"] = {
	"SMALL": "SMALL",
	"DEFAULT": "DEFAULT"
};

UCF_ClientInterfaces["E"]["ButtonType"] = {
	"NONE": "NONE",
	"MENU": "MENU",
	"HELP": "HELP",
	"PERSONALIZE": "PERSONALIZE",
	"CLOSE": "CLOSE",
	"EXPANDALL": "EXPANDALL",
	"COLLAPSEALL": "COLLAPSEALL",
	"SCROLLTOP": "SCROLLTOP",
	"MINIMIZE": "MINIMIZE",
	"MAXIMIZE": "MAXIMIZE",
	"RESTORE": "RESTORE",
	"COLLAPSEBEGIN": "COLLAPSEBEGIN",
	"COLLAPSEEND": "COLLAPSEEND",
	"EXPANDBEGIN": "EXPANDBEGIN",
	"EXPANDEND": "EXPANDEND",
	"BACK": "BACK",
	"FORWARD": "FORWARD",
	"VARIANTMANAGEMENT": "VARIANTMANAGEMENT",
	"RTE": "RTE"
};

UCF_ClientInterfaces["E"]["ContentVisibility"] = {
	"ALL": "ALL",
	"TEXT": "TEXT",
	"ICON": "ICON"
};

UCF_ClientInterfaces["E"]["IconButtonFunctionStatus"] = {
	"LARGE": "LARGE",
	"SMALL": "SMALL",
	"MEDIUM": "MEDIUM"
};

UCF_ClientInterfaces["E"]["ButtonRowType"] = {
	"NONE": "NONE",
	"DIVIDER": "DIVIDER"
};

UCF_ClientInterfaces["E"]["CalendarCellSemantic"] = {
	"WORK": "WORK",
	"FREE": "FREE",
	"DISABLED": "DISABLED"
};

UCF_ClientInterfaces["E"]["CaptionDesign"] = {
	"EMPHASIZED": "EMPHASIZED",
	"STANDARD": "STANDARD"
};

UCF_ClientInterfaces["E"]["CarouselAlignment"] = {
	"HORIZONTAL": "HORIZONTAL",
	"VERTICAL": "VERTICAL"
};

UCF_ClientInterfaces["E"]["CarouselDisplayItems"] = {
	"MULTIPLE": "MULTIPLE",
	"SINGLE": "SINGLE"
};

UCF_ClientInterfaces["E"]["CarouselLoopBehavior"] = {
	"NONE": "NONE",
	"JUMP": "JUMP",
	"ENDLESS": "ENDLESS"
};

UCF_ClientInterfaces["E"]["CarouselNavigationPlacement"] = {
	"CONTENT": "CONTENT",
	"NONE": "NONE",
	"PAGINATION": "PAGINATION"
};

UCF_ClientInterfaces["E"]["CarouselPagination"] = {
	"ADAPT_TO_ITEMS": "ADAPT_TO_ITEMS",
	"NONE": "NONE"
};

UCF_ClientInterfaces["E"]["CheckBoxArrangement"] = {
	"CHECKBOXFIRST": "CHECKBOXFIRST",
	"CHECKBOXLAST": "CHECKBOXLAST"
};

UCF_ClientInterfaces["E"]["CheckBoxTextDesign"] = {
	"STANDARD": "STANDARD",
	"EMPHAZISED": "EMPHAZISED",
	"MONOSPACE": "MONOSPACE"
};

UCF_ClientInterfaces["E"]["SelectorArrangement"] = {
	"SELECTOR_BEFORE_CONTENT_IN_SHRINKED_CONTAINER": "SELECTOR_BEFORE_CONTENT_IN_SHRINKED_CONTAINER",
	"SELECTOR_AFTER_CONTENT_IN_SHRINKED_CONTAINER": "SELECTOR_AFTER_CONTENT_IN_SHRINKED_CONTAINER",
	"SELECTOR_BEFORE_CONTENT_BOTH_PUSHED_TO_START_IN_STRECHED_CONTAINER": "SELECTOR_BEFORE_CONTENT_BOTH_PUSHED_TO_START_IN_STRECHED_CONTAINER",
	"SELECTOR_AFTER_CONTENT_BOTH_PUSHED_TO_START_IN_STRECHED_CONTAINER": "SELECTOR_AFTER_CONTENT_BOTH_PUSHED_TO_START_IN_STRECHED_CONTAINER",
	"SELECTOR_AFTER_CONTENT_BOTH_PUSHED_TO_END_IN_STRECHED_CONTAINER": "SELECTOR_AFTER_CONTENT_BOTH_PUSHED_TO_END_IN_STRECHED_CONTAINER",
	"SELECTOR_BEFORE_CONTENT_BOTH_OPPOSITE_EACH_OTHER_IN_STRECHED_CONTAINER": "SELECTOR_BEFORE_CONTENT_BOTH_OPPOSITE_EACH_OTHER_IN_STRECHED_CONTAINER",
	"SELECTOR_AFTER_CONTENT_BOTH_OPPOSITE_EACH_OTHER_IN_STRECHED_CONTAINER": "SELECTOR_AFTER_CONTENT_BOTH_OPPOSITE_EACH_OTHER_IN_STRECHED_CONTAINER",
	"SOLE_SELECTOR": "SOLE_SELECTOR",
	"SELECTOR_WITH_WRAPPING_LABEL": "SELECTOR_WITH_WRAPPING_LABEL"
};

UCF_ClientInterfaces["E"]["MajorColCount"] = {
	"ONE": "ONE",
	"TWO": "TWO",
	"THREE": "THREE",
	"FOUR": "FOUR",
	"FIVE": "FIVE"
};

UCF_ClientInterfaces["E"]["ComboBoxBehavior"] = {
	"DROPDOWNSELECT": "DROPDOWNSELECT",
	"FREETEXT": "FREETEXT",
	"SUGGESTLIST": "SUGGESTLIST",
	"SUGGESTFIELDHELP": "SUGGESTFIELDHELP"
};

UCF_ClientInterfaces["E"]["SuggestFilterCondition"] = {
	"VALUE1_OR_VALUE2": "VALUE1_OR_VALUE2",
	"VALUE1": "VALUE1"
};

UCF_ClientInterfaces["E"]["SuggestFilterType"] = {
	"OFF": "OFF",
	"SERVER": "SERVER",
	"CLIENT_SERVER": "CLIENT_SERVER",
	"CLIENT_SERVER_PREFIX": "CLIENT_SERVER_PREFIX"
};

UCF_ClientInterfaces["E"]["LockedDesign"] = {
	"TRANSPARENT": "TRANSPARENT",
	"BORDER": "BORDER",
	"LOADING": "LOADING",
	"BORDER_LOADING": "BORDER_LOADING",
	"SEMI": "SEMI",
	"SEMI_BORDER": "SEMI_BORDER",
	"SEMI_LOADING": "SEMI_LOADING",
	"SEMI_BORDER_LOADING": "SEMI_BORDER_LOADING"
};

UCF_ClientInterfaces["E"]["AreaDesign"] = {
	"TRANSPARENT": "TRANSPARENT",
	"PLAIN": "PLAIN",
	"FILL": "FILL"
};

UCF_ClientInterfaces["E"]["BorderDesign"] = {
	"NONE": "NONE",
	"BOX": "BOX"
};

UCF_ClientInterfaces["E"]["ContentPadding"] = {
	"STANDARD": "STANDARD",
	"NONE": "NONE",
	"MANUAL": "MANUAL"
};

UCF_ClientInterfaces["E"]["CSSGridRelativeTo"] = {
	"VIEWPORT": "VIEWPORT",
	"CONTROL": "CONTROL"
};

UCF_ClientInterfaces["E"]["DataGridSegmentColumnType"] = {
	"STANDARD": "STANDARD",
	"HEADERCOLUMN": "HEADERCOLUMN"
};

UCF_ClientInterfaces["E"]["DataGridSegmentRowType"] = {
	"STANDARD": "STANDARD",
	"HEADERROW": "HEADERROW"
};

UCF_ClientInterfaces["E"]["DataTipDesign"] = {
	"DEFAULT": "DEFAULT",
	"NOTE": "NOTE"
};

UCF_ClientInterfaces["E"]["DataTipType"] = {
	"ERROR": "ERROR",
	"WARNING": "WARNING",
	"OK": "OK",
	"TEXT": "TEXT"
};

UCF_ClientInterfaces["E"]["DateNavigatorDayDesign"] = {
	"NONE": "NONE",
	"DISABLED": "DISABLED",
	"TODAY": "TODAY",
	"SELECTED1": "SELECTED1",
	"SELECTED2": "SELECTED2",
	"SELECTED3": "SELECTED3",
	"SELECTED4": "SELECTED4",
	"SELECTED5": "SELECTED5",
	"STANDARD": "STANDARD",
	"NEGATIVE": "NEGATIVE",
	"POSITIVE": "POSITIVE",
	"TOTAL": "TOTAL",
	"SUBTOTAL": "SUBTOTAL",
	"SUBTOTAL_LIGHT": "SUBTOTAL_LIGHT",
	"BADVALUE_DARK": "BADVALUE_DARK",
	"BADVALUE_MEDIUM": "BADVALUE_MEDIUM",
	"BADVALUE_LIGHT": "BADVALUE_LIGHT",
	"CRITICALVALUE_DARK": "CRITICALVALUE_DARK",
	"CRITICALVALUE_MEDIUM": "CRITICALVALUE_MEDIUM",
	"CRITICALVALUE_LIGHT": "CRITICALVALUE_LIGHT",
	"GOODVALUE_DARK": "GOODVALUE_DARK",
	"GOODVALUE_MEDIUM": "GOODVALUE_MEDIUM",
	"GOODVALUE_LIGHT": "GOODVALUE_LIGHT",
	"GROUP_HIGHLIGHTED": "GROUP_HIGHLIGHTED",
	"GROUP_HIGHLIGHTED_LIGHT": "GROUP_HIGHLIGHTED_LIGHT",
	"KEY_MEDIUM": "KEY_MEDIUM",
	"GROUP_LEVEL1": "GROUP_LEVEL1",
	"GROUP_LEVEL2": "GROUP_LEVEL2",
	"GROUP_LEVEL3": "GROUP_LEVEL3",
	"MARKED": "MARKED"
};

UCF_ClientInterfaces["E"]["DateNavigatorSelectType"] = {
	"STANDARD": "STANDARD",
	"RANGE": "RANGE",
	"TOGGLE": "TOGGLE"
};

UCF_ClientInterfaces["E"]["DTActionMenuAlignment"] = {
	"TOP_LEFT": "TOP_LEFT",
	"TOP_LEFT_INSIDE": "TOP_LEFT_INSIDE",
	"BOTTOM_LEFT": "BOTTOM_LEFT",
	"BOTTOM_LEFT_INSIDE": "BOTTOM_LEFT_INSIDE"
};

UCF_ClientInterfaces["E"]["DTElementButtonRow"] = {
	"NONE": "NONE",
	"CONFIG": "CONFIG",
	"CONFIG_AND_CLOSE": "CONFIG_AND_CLOSE"
};

UCF_ClientInterfaces["E"]["DTHoverEffect"] = {
	"NONE": "NONE",
	"DEFAULT": "DEFAULT",
	"PERMANENT": "PERMANENT"
};

UCF_ClientInterfaces["E"]["DTLayerDesign"] = {
	"NONE": "NONE",
	"DEFAULT": "DEFAULT",
	"LAYER_AND_HOVER": "LAYER_AND_HOVER",
	"HIDDEN": "HIDDEN"
};

UCF_ClientInterfaces["E"]["DTMoveMode"] = {
	"NONE": "NONE",
	"RELATIVE": "RELATIVE",
	"ABSOLUTE": "ABSOLUTE"
};

UCF_ClientInterfaces["E"]["DTOutlineVisualization"] = {
	"NONE": "NONE",
	"DEFAULT": "DEFAULT",
	"DASHED": "DASHED"
};

UCF_ClientInterfaces["E"]["DTRasterMode"] = {
	"NONE": "NONE",
	"NESTED_RL_DROP_ON_ELEMENT": "NESTED_RL_DROP_ON_ELEMENT",
	"NESTED_RL_DROP_RELATIVE": "NESTED_RL_DROP_RELATIVE"
};

UCF_ClientInterfaces["E"]["DTSelectionState"] = {
	"SELECTABLE": "SELECTABLE",
	"UNSELECTABLE": "UNSELECTABLE",
	"SELECTED": "SELECTED"
};

UCF_ClientInterfaces["E"]["DropEffect"] = {
	"NONE": "NONE",
	"MOVE": "MOVE",
	"COPY": "COPY",
	"LINK": "LINK"
};

UCF_ClientInterfaces["E"]["HoverVisualizationType"] = {
	"NONE": "NONE",
	"BORDER": "BORDER",
	"BACKGROUND": "BACKGROUND",
	"BORDERANDBACKGROUND": "BORDERANDBACKGROUND",
	"OVERLAY": "OVERLAY"
};

UCF_ClientInterfaces["E"]["FileUploadBehavior"] = {
	"STANDARD": "STANDARD",
	"ONSUBMIT": "ONSUBMIT",
	"IMMEDIATE": "IMMEDIATE"
};

UCF_ClientInterfaces["E"]["FluidResizeHandlePos"] = {
	"TOP": "TOP",
	"BOTTOM": "BOTTOM",
	"BEGIN": "BEGIN",
	"END": "END"
};

UCF_ClientInterfaces["E"]["FormResponseData"] = {
	"FULL": "FULL",
	"DELTA": "DELTA"
};

UCF_ClientInterfaces["E"]["FreeContextualAreaDesign"] = {
	"FILL": "FILL",
	"PLAIN": "PLAIN"
};

UCF_ClientInterfaces["E"]["GeoMapMoveBehavior"] = {
	"NONE": "NONE",
	"BUTTON": "BUTTON",
	"MOUSE": "MOUSE",
	"BUTTON_PLUS_MOUSE": "BUTTON_PLUS_MOUSE"
};

UCF_ClientInterfaces["E"]["GeoMapZoomBehavior"] = {
	"NONE": "NONE",
	"PANEL": "PANEL",
	"MOUSE": "MOUSE",
	"PANEL_PLUS_MOUSE": "PANEL_PLUS_MOUSE"
};

UCF_ClientInterfaces["E"]["GroupDesign"] = {
	"SAPCOLOR": "SAPCOLOR",
	"PRIMARYCOLOR": "PRIMARYCOLOR",
	"SECONDARYCOLOR": "SECONDARYCOLOR",
	"SECONDARYBOX": "SECONDARYBOX",
	"SECONDARYBOXCOLOR": "SECONDARYBOXCOLOR",
	"TRANSPARENT": "TRANSPARENT",
	"OBJECT_NAVIGATION_ITEM": "OBJECT_NAVIGATION_ITEM"
};

UCF_ClientInterfaces["E"]["GroupHeaderDesign"] = {
	"STANDARD": "STANDARD",
	"TRANSPARENT": "TRANSPARENT",
	"UNDERLINE": "UNDERLINE"
};

UCF_ClientInterfaces["E"]["CollapseIconPosition"] = {
	"START": "START",
	"END": "END",
	"START_AND_END": "START_AND_END"
};

UCF_ClientInterfaces["E"]["HeaderDesign"] = {
	"STANDARD": "STANDARD",
	"UNDERLINE": "UNDERLINE",
	"LIGHT": "LIGHT",
	"EMPHASIZED": "EMPHASIZED",
	"TRANSPARENT": "TRANSPARENT",
	"SECTION_UNDERLINE": "SECTION_UNDERLINE",
	"OBJECT_NAVIGATION_ITEM": "OBJECT_NAVIGATION_ITEM"
};

UCF_ClientInterfaces["E"]["HierarchicalViewNavigation"] = {
	"NONE": "NONE",
	"BREADCRUMB_FULL": "BREADCRUMB_FULL",
	"BREADCRUMB_PARENT": "BREADCRUMB_PARENT",
	"BREADCRUMB_SELF": "BREADCRUMB_SELF"
};

UCF_ClientInterfaces["E"]["HorizontalContextualPanelIconSemantic"] = {
	"DEFAULT": "DEFAULT",
	"POSITIVE": "POSITIVE",
	"CRITICAL": "CRITICAL",
	"NEGATIVE": "NEGATIVE"
};

UCF_ClientInterfaces["E"]["HorizontalContextualPanelMenuItemsDesign"] = {
	"TAB": "TAB",
	"MENU": "MENU"
};

UCF_ClientInterfaces["E"]["HorizontalContextualPanelTabDesign"] = {
	"TAB": "TAB",
	"ICONANDTEXT": "ICONANDTEXT"
};

UCF_ClientInterfaces["E"]["HorizontalDividerRuleDisplayType"] = {
	"NONE": "NONE",
	"AREADIVIDER": "AREADIVIDER",
	"PAGEDIVIDER": "PAGEDIVIDER"
};

UCF_ClientInterfaces["E"]["HorizontalDividerRuleHeight"] = {
	"SMALL": "SMALL",
	"MEDIUM": "MEDIUM",
	"LARGE": "LARGE",
	"RULEHEIGHT": "RULEHEIGHT"
};

UCF_ClientInterfaces["E"]["HotkeyValue"] = {
	"NONE": "NONE",
	"CTRL_0": "CTRL_0",
	"CTRL_1": "CTRL_1",
	"CTRL_2": "CTRL_2",
	"CTRL_3": "CTRL_3",
	"CTRL_4": "CTRL_4",
	"CTRL_5": "CTRL_5",
	"CTRL_6": "CTRL_6",
	"CTRL_7": "CTRL_7",
	"CTRL_8": "CTRL_8",
	"CTRL_9": "CTRL_9",
	"CTRL_A": "CTRL_A",
	"CTRL_B": "CTRL_B",
	"CTRL_C": "CTRL_C",
	"CTRL_D": "CTRL_D",
	"CTRL_E": "CTRL_E",
	"CTRL_F": "CTRL_F",
	"CTRL_G": "CTRL_G",
	"CTRL_H": "CTRL_H",
	"CTRL_I": "CTRL_I",
	"CTRL_J": "CTRL_J",
	"CTRL_K": "CTRL_K",
	"CTRL_L": "CTRL_L",
	"CTRL_M": "CTRL_M",
	"CTRL_N": "CTRL_N",
	"CTRL_O": "CTRL_O",
	"CTRL_P": "CTRL_P",
	"CTRL_Q": "CTRL_Q",
	"CTRL_R": "CTRL_R",
	"CTRL_S": "CTRL_S",
	"CTRL_T": "CTRL_T",
	"CTRL_U": "CTRL_U",
	"CTRL_V": "CTRL_V",
	"CTRL_W": "CTRL_W",
	"CTRL_X": "CTRL_X",
	"CTRL_Y": "CTRL_Y",
	"CTRL_Z": "CTRL_Z",
	"F1": "F1",
	"F2": "F2",
	"F3": "F3",
	"F4": "F4",
	"F5": "F5",
	"F6": "F6",
	"F7": "F7",
	"F8": "F8",
	"F9": "F9",
	"F10": "F10",
	"F11": "F11",
	"F12": "F12",
	"CTRL_F1": "CTRL_F1",
	"CTRL_F2": "CTRL_F2",
	"CTRL_F3": "CTRL_F3",
	"CTRL_F4": "CTRL_F4",
	"CTRL_F5": "CTRL_F5",
	"CTRL_F6": "CTRL_F6",
	"CTRL_F7": "CTRL_F7",
	"CTRL_F8": "CTRL_F8",
	"CTRL_F9": "CTRL_F9",
	"CTRL_F10": "CTRL_F10",
	"CTRL_F11": "CTRL_F11",
	"CTRL_F12": "CTRL_F12",
	"CTRL_ALT_N": "CTRL_ALT_N",
	"CTRL_SHIFT_0": "CTRL_SHIFT_0",
	"CTRL_SHIFT_1": "CTRL_SHIFT_1",
	"CTRL_SHIFT_2": "CTRL_SHIFT_2",
	"CTRL_SHIFT_3": "CTRL_SHIFT_3",
	"CTRL_SHIFT_4": "CTRL_SHIFT_4",
	"CTRL_SHIFT_5": "CTRL_SHIFT_5",
	"CTRL_SHIFT_6": "CTRL_SHIFT_6",
	"CTRL_SHIFT_7": "CTRL_SHIFT_7",
	"CTRL_SHIFT_8": "CTRL_SHIFT_8",
	"CTRL_SHIFT_9": "CTRL_SHIFT_9",
	"CTRL_SHIFT_A": "CTRL_SHIFT_A",
	"CTRL_SHIFT_B": "CTRL_SHIFT_B",
	"CTRL_SHIFT_C": "CTRL_SHIFT_C",
	"CTRL_SHIFT_D": "CTRL_SHIFT_D",
	"CTRL_SHIFT_E": "CTRL_SHIFT_E",
	"CTRL_SHIFT_F": "CTRL_SHIFT_F",
	"CTRL_SHIFT_G": "CTRL_SHIFT_G",
	"CTRL_SHIFT_H": "CTRL_SHIFT_H",
	"CTRL_SHIFT_I": "CTRL_SHIFT_I",
	"CTRL_SHIFT_J": "CTRL_SHIFT_J",
	"CTRL_SHIFT_K": "CTRL_SHIFT_K",
	"CTRL_SHIFT_L": "CTRL_SHIFT_L",
	"CTRL_SHIFT_M": "CTRL_SHIFT_M",
	"CTRL_SHIFT_N": "CTRL_SHIFT_N",
	"CTRL_SHIFT_O": "CTRL_SHIFT_O",
	"CTRL_SHIFT_P": "CTRL_SHIFT_P",
	"CTRL_SHIFT_Q": "CTRL_SHIFT_Q",
	"CTRL_SHIFT_R": "CTRL_SHIFT_R",
	"CTRL_SHIFT_S": "CTRL_SHIFT_S",
	"CTRL_SHIFT_T": "CTRL_SHIFT_T",
	"CTRL_SHIFT_U": "CTRL_SHIFT_U",
	"CTRL_SHIFT_V": "CTRL_SHIFT_V",
	"CTRL_SHIFT_W": "CTRL_SHIFT_W",
	"CTRL_SHIFT_X": "CTRL_SHIFT_X",
	"CTRL_SHIFT_Y": "CTRL_SHIFT_Y",
	"CTRL_SHIFT_Z": "CTRL_SHIFT_Z",
	"CTRL_SHIFT_F1": "CTRL_SHIFT_F1",
	"CTRL_SHIFT_F2": "CTRL_SHIFT_F2",
	"CTRL_SHIFT_F3": "CTRL_SHIFT_F3",
	"CTRL_SHIFT_F4": "CTRL_SHIFT_F4",
	"CTRL_SHIFT_F5": "CTRL_SHIFT_F5",
	"CTRL_SHIFT_F6": "CTRL_SHIFT_F6",
	"CTRL_SHIFT_F7": "CTRL_SHIFT_F7",
	"CTRL_SHIFT_F8": "CTRL_SHIFT_F8",
	"CTRL_SHIFT_F9": "CTRL_SHIFT_F9",
	"CTRL_SHIFT_F10": "CTRL_SHIFT_F10",
	"CTRL_SHIFT_F11": "CTRL_SHIFT_F11",
	"CTRL_SHIFT_F12": "CTRL_SHIFT_F12",
	"ESCAPE": "ESCAPE",
	"DELETE": "DELETE",
	"INSERT": "INSERT",
	"ENTER": "ENTER",
	"CTRL_DOT": "CTRL_DOT",
	"CTRL_COMMA": "CTRL_COMMA",
	"ALT_ARROW_LEFT": "ALT_ARROW_LEFT",
	"ALT_ARROW_UP": "ALT_ARROW_UP",
	"ALT_ARROW_RIGHT": "ALT_ARROW_RIGHT",
	"ALT_ARROW_DOWN": "ALT_ARROW_DOWN",
	"SHIFT_F1": "SHIFT_F1",
	"SHIFT_F2": "SHIFT_F2",
	"SHIFT_F3": "SHIFT_F3",
	"SHIFT_F4": "SHIFT_F4",
	"SHIFT_F5": "SHIFT_F5",
	"SHIFT_F6": "SHIFT_F6",
	"SHIFT_F7": "SHIFT_F7",
	"SHIFT_F8": "SHIFT_F8",
	"SHIFT_F9": "SHIFT_F9",
	"SHIFT_F10": "SHIFT_F10",
	"SHIFT_F11": "SHIFT_F11",
	"SHIFT_F12": "SHIFT_F12",
	"CTRL_DELETE": "CTRL_DELETE",
	"CTRL_ENTER": "CTRL_ENTER",
	"CTRL_PAGE_DOWN": "CTRL_PAGE_DOWN",
	"CTRL_ARROW_LEFT": "CTRL_ARROW_LEFT",
	"CTRL_ARROW_RIGHT": "CTRL_ARROW_RIGHT",
	"SHIFT_ENTER": "SHIFT_ENTER",
	"CTRL_SHIFT_ENTER": "CTRL_SHIFT_ENTER",
	"CTRL_SHIFT_COMMA": "CTRL_SHIFT_COMMA",
	"CTRL_SHIFT_DOT": "CTRL_SHIFT_DOT",
	"ALT_BACKSPACE": "ALT_BACKSPACE",
	"ALT_ENTER": "ALT_ENTER",
	"CTRL_ALT_T": "CTRL_ALT_T"
};

UCF_ClientInterfaces["E"]["IframeScrolling"] = {
	"NO": "NO",
	"AUTO": "AUTO",
	"YES": "YES"
};

UCF_ClientInterfaces["E"]["ImageItsDisplayMode"] = {
	"NORMAL": "NORMAL",
	"STRETCH": "STRETCH",
	"FIT": "FIT",
	"NORMALCENTER": "NORMALCENTER",
	"FITCENTER": "FITCENTER",
	"FILL": "FILL"
};

UCF_ClientInterfaces["E"]["ImageMapShape"] = {
	"RECTANGLE": "RECTANGLE",
	"CIRCLE": "CIRCLE",
	"POLYGON": "POLYGON"
};

UCF_ClientInterfaces["E"]["InputFieldFieldHelp"] = {
	"DEFAULT": "DEFAULT",
	"CALENDAR": "CALENDAR",
	"F4LOOKUP": "F4LOOKUP",
	"CALCULATOR": "CALCULATOR",
	"SPINNER": "SPINNER",
	"SEARCH": "SEARCH",
	"FILTERFIELDS": "FILTERFIELDS"
};

UCF_ClientInterfaces["E"]["InputFieldSize"] = {
	"DEFAULT": "DEFAULT",
	"SMALL": "SMALL"
};

UCF_ClientInterfaces["E"]["InputFieldTextStyle"] = {
	"NORMAL": "NORMAL",
	"UNDERLINE": "UNDERLINE",
	"UNDERLINE_HOTSPOT": "UNDERLINE_HOTSPOT",
	"BOLD": "BOLD",
	"BOLD_HOTSPOT": "BOLD_HOTSPOT",
	"ITALIC": "ITALIC",
	"ITALIC_HOTSPOT": "ITALIC_HOTSPOT",
	"BOLD_ITALIC": "BOLD_ITALIC",
	"BOLD_ITALIC_HOTSPOT": "BOLD_ITALIC_HOTSPOT",
	"BOLD_UNDERLINE": "BOLD_UNDERLINE",
	"BOLD_ITALIC_UNDERLINE": "BOLD_ITALIC_UNDERLINE",
	"ITALIC_UNDERLINE": "ITALIC_UNDERLINE",
	"BOLD_UNDERLINE_HOTSPOT": "BOLD_UNDERLINE_HOTSPOT",
	"BOLD_ITALIC_UNDERLINE_HOTSPOT": "BOLD_ITALIC_UNDERLINE_HOTSPOT",
	"ITALIC_UNDERLINE_HOTSPOT": "ITALIC_UNDERLINE_HOTSPOT"
};

UCF_ClientInterfaces["E"]["InputFieldType"] = {
	"STRING": "STRING",
	"BOOLEAN": "BOOLEAN",
	"TIME": "TIME",
	"DATE": "DATE",
	"BDC": "BDC",
	"INTEGER": "INTEGER",
	"AMOUNT": "AMOUNT",
	"CODE": "CODE",
	"CURRENCY_CODE": "CURRENCY_CODE",
	"DATE_TIME": "DATE_TIME",
	"DESCRIPTION": "DESCRIPTION",
	"DURATION": "DURATION",
	"IDENTIFIER": "IDENTIFIER",
	"MEASURE": "MEASURE",
	"NUMERIC": "NUMERIC",
	"PERCENTAGE": "PERCENTAGE",
	"QUANTITY": "QUANTITY",
	"RATIO": "RATIO",
	"TIMEZONE_CODE": "TIMEZONE_CODE",
	"UNIT_CODE": "UNIT_CODE",
	"URI": "URI",
	"EMAIL": "EMAIL"
};

UCF_ClientInterfaces["E"]["TabBehaviour"] = {
	"STANDARD": "STANDARD",
	"AUTOINTRA": "AUTOINTRA",
	"AUTOINTER": "AUTOINTER"
};

UCF_ClientInterfaces["E"]["TableFieldDesign"] = {
	"NONE": "NONE",
	"EDITABLE_COLORED": "EDITABLE_COLORED"
};

UCF_ClientInterfaces["E"]["ValidationTrigger"] = {
	"STANDARD": "STANDARD",
	"TAB": "TAB"
};

UCF_ClientInterfaces["E"]["TokenizerFieldHelp"] = {
	"OFF": "OFF",
	"F4LOOKUP": "F4LOOKUP",
	"FILTERFIELDS": "FILTERFIELDS",
	"SEARCH": "SEARCH"
};

UCF_ClientInterfaces["E"]["TokenizerOverflow"] = {
	"OVERLAY": "OVERLAY",
	"PUSH": "PUSH"
};

UCF_ClientInterfaces["E"]["TokenizerSuggest"] = {
	"OFF": "OFF",
	"SERVER": "SERVER"
};

UCF_ClientInterfaces["E"]["ItemListBoxSeparators"] = {
	"NONE": "NONE",
	"INNER": "INNER"
};

UCF_ClientInterfaces["E"]["ItemListBoxVisibility"] = {
	"NONE": "NONE",
	"VISIBLE": "VISIBLE",
	"DESCRIPTIVE": "DESCRIPTIVE"
};

UCF_ClientInterfaces["E"]["LabelDesign"] = {
	"STANDARD": "STANDARD",
	"LIGHT": "LIGHT"
};

UCF_ClientInterfaces["E"]["LabelInteractionBehavior"] = {
	"REDIRECT_FOCUS": "REDIRECT_FOCUS",
	"NONE": "NONE",
	"ACTIVATE": "ACTIVATE"
};

UCF_ClientInterfaces["E"]["LabelSize"] = {
	"SMALL": "SMALL",
	"DEFAULT": "DEFAULT"
};

UCF_ClientInterfaces["E"]["LabelTextDesign"] = {
	"STANDARD": "STANDARD",
	"EMPHASIZED": "EMPHASIZED",
	"MONOSPACE": "MONOSPACE",
	"MONOSPACE_EMPHASIZED": "MONOSPACE_EMPHASIZED",
	"TEXT": "TEXT"
};

UCF_ClientInterfaces["E"]["LargeButtonIconPosition"] = {
	"BEGINOFLINE": "BEGINOFLINE",
	"ENDOFLINE": "ENDOFLINE",
	"TOP": "TOP",
	"BOTTOM": "BOTTOM"
};

UCF_ClientInterfaces["E"]["LinkSize"] = {
	"DEFAULT": "DEFAULT",
	"SMALL": "SMALL"
};

UCF_ClientInterfaces["E"]["LinkType"] = {
	"DEFAULT": "DEFAULT",
	"FUNCTION": "FUNCTION",
	"REPORTING": "REPORTING",
	"RESULT": "RESULT",
	"DRAGRELATE": "DRAGRELATE",
	"SUBTLE": "SUBTLE"
};

UCF_ClientInterfaces["E"]["MenuBarDesign"] = {
	"STANDARD": "STANDARD",
	"TRANSPARENT": "TRANSPARENT"
};

UCF_ClientInterfaces["E"]["MessageFilterType"] = {
	"ALL": "ALL",
	"ERROR": "ERROR",
	"WARNING": "WARNING",
	"SUCCESS": "SUCCESS",
	"INFO": "INFO"
};

UCF_ClientInterfaces["E"]["MessageMode"] = {
	"SINGLE": "SINGLE",
	"MULTI": "MULTI"
};

UCF_ClientInterfaces["E"]["MessageBarDesign"] = {
	"STANDARD": "STANDARD",
	"TRANSPARENT": "TRANSPARENT"
};

UCF_ClientInterfaces["E"]["MessageBarRulerDisplay"] = {
	"NONE": "NONE",
	"TOP": "TOP",
	"BOTTOM": "BOTTOM"
};

UCF_ClientInterfaces["E"]["MessageType"] = {
	"ERROR": "ERROR",
	"WARNING": "WARNING",
	"OK": "OK",
	"STOP": "STOP",
	"LOADING": "LOADING",
	"NONE": "NONE",
	"TEXT": "TEXT",
	"ALERT": "ALERT",
	"INFO": "INFO",
	"NOTIFICATION": "NOTIFICATION",
	"TASK": "TASK"
};

UCF_ClientInterfaces["E"]["BrowserHistory"] = {
	"ENABLED": "ENABLED",
	"DISABLED": "DISABLED",
	"NOTIFY": "NOTIFY"
};

UCF_ClientInterfaces["E"]["ControlUpdateMethod"] = {
	"FULL": "FULL",
	"PARTIAL": "PARTIAL"
};

UCF_ClientInterfaces["E"]["DirtyMode"] = {
	"NONE": "NONE",
	"SERVER": "SERVER",
	"CLIENTSERVER": "CLIENTSERVER"
};

UCF_ClientInterfaces["E"]["DomainRelax"] = {
	"AUTO": "AUTO",
	"NONE": "NONE"
};

UCF_ClientInterfaces["E"]["FrameProtection"] = {
	"HIDEBODY": "HIDEBODY",
	"LOCKEVENTS": "LOCKEVENTS"
};

UCF_ClientInterfaces["E"]["IhubWebSocketErrorCode"] = {
	"NOT_SUPPORTED": "NOT_SUPPORTED",
	"CONFIGURATION_ERROR": "CONFIGURATION_ERROR",
	"CANNOT_CONNECT": "CANNOT_CONNECT",
	"CONNECTION_CLOSED": "CONNECTION_CLOSED",
	"CONNECTION_CLOSING": "CONNECTION_CLOSING",
	"CONNECTION_ERROR": "CONNECTION_ERROR"
};

UCF_ClientInterfaces["E"]["PageDesign"] = {
	"DEFAULT": "DEFAULT",
	"HELP": "HELP",
	"PLAIN": "PLAIN",
	"FILL": "FILL",
	"TRANSPARENT": "TRANSPARENT",
	"CANVAS": "CANVAS"
};

UCF_ClientInterfaces["E"]["PageScriptIncludeType"] = {
	"BASE_LIBRARY": "BASE_LIBRARY",
	"INIT_BASE_LIBRARY": "INIT_BASE_LIBRARY",
	"DOMAIN_RELAX": "DOMAIN_RELAX",
	"INIT_DOMAIN_RELAX": "INIT_DOMAIN_RELAX",
	"CLASSES": "CLASSES",
	"CLIENTRENDERERS": "CLIENTRENDERERS",
	"CUSTOM": "CUSTOM"
};

UCF_ClientInterfaces["E"]["PageSessionHandling"] = {
	"DEFAULT": "DEFAULT",
	"SYNC": "SYNC"
};

UCF_ClientInterfaces["E"]["ScriptCallPhase"] = {
	"AFTER_UPDATE": "AFTER_UPDATE",
	"BEFORE_UPDATE": "BEFORE_UPDATE"
};

UCF_ClientInterfaces["E"]["ScriptType"] = {
	"BASE_LIBRARY": "BASE_LIBRARY",
	"INIT_BASE_LIBRARY": "INIT_BASE_LIBRARY",
	"DOMAIN_RELAX": "DOMAIN_RELAX",
	"INIT_DOMAIN_RELAX": "INIT_DOMAIN_RELAX",
	"AUTO_RELAX": "AUTO_RELAX",
	"CLASSES": "CLASSES",
	"CLASSES_ITS": "CLASSES_ITS",
	"CLIENTRENDERERS": "CLIENTRENDERERS",
	"TEXTS": "TEXTS",
	"CUSTOM": "CUSTOM",
	"SAPUI5": "SAPUI5"
};

UCF_ClientInterfaces["E"]["SessionStateValidity"] = {
	"PERMANENT": "PERMANENT",
	"ROUNDTRIP": "ROUNDTRIP"
};

UCF_ClientInterfaces["E"]["SessionTimeoutBehavior"] = {
	"PAGE": "PAGE",
	"POSTMESSAGE": "POSTMESSAGE",
	"POPUPWINDOW": "POPUPWINDOW"
};

UCF_ClientInterfaces["E"]["PageHeaderDesign"] = {
	"STANDARD": "STANDARD",
	"SMALL": "SMALL",
	"APPLICATION": "APPLICATION",
	"EMBEDDED": "EMBEDDED"
};

UCF_ClientInterfaces["E"]["PageHeaderItemDesign"] = {
	"PLAIN": "PLAIN",
	"EMPHASIZED": "EMPHASIZED",
	"TRANSPARENT": "TRANSPARENT",
	"WARNING": "WARNING",
	"MAJORWARNING": "MAJORWARNING"
};

UCF_ClientInterfaces["E"]["PageLayoutBackground"] = {
	"TRANSPARENT": "TRANSPARENT",
	"PLAIN": "PLAIN",
	"FILL1": "FILL1",
	"HELP": "HELP"
};

UCF_ClientInterfaces["E"]["PageLayoutBorder"] = {
	"NONE": "NONE",
	"CLOSURE": "CLOSURE",
	"AREADIVIDER": "AREADIVIDER",
	"SUBAREADIVIDER": "SUBAREADIVIDER",
	"CLOSURELIGHT": "CLOSURELIGHT"
};

UCF_ClientInterfaces["E"]["PageLayoutSlot"] = {
	"TOP": "TOP",
	"BEGIN": "BEGIN",
	"INNER_TOP": "INNER_TOP",
	"END": "END",
	"INNER_BEGIN": "INNER_BEGIN",
	"CENTER": "CENTER",
	"INNER_END": "INNER_END",
	"INNER_BOTTOM": "INNER_BOTTOM",
	"BOTTOM": "BOTTOM"
};

UCF_ClientInterfaces["E"]["PaginatorNavigationMode"] = {
	"HORIZONTAL": "HORIZONTAL",
	"VERTICAL": "VERTICAL"
};

UCF_ClientInterfaces["E"]["PaginatorNavigationText"] = {
	"PAGE": "PAGE",
	"COLUMN": "COLUMN",
	"ROW": "ROW",
	"ITEM": "ITEM"
};

UCF_ClientInterfaces["E"]["PaginatorNavigationType"] = {
	"COLUMN": "COLUMN",
	"ITEM": "ITEM",
	"ROW": "ROW",
	"CALENDAR": "CALENDAR"
};

UCF_ClientInterfaces["E"]["CollapseMode"] = {
	"NONE": "NONE",
	"TO_HORIZONTAL_LINE": "TO_HORIZONTAL_LINE"
};

UCF_ClientInterfaces["E"]["StackDesign"] = {
	"MENU": "MENU",
	"TAB": "TAB"
};

UCF_ClientInterfaces["E"]["HorizontalScrollingMode"] = {
	"AUTO": "AUTO",
	"SHOW": "SHOW",
	"HIDE": "HIDE",
	"NONE": "NONE"
};

UCF_ClientInterfaces["E"]["PatternContainerDesign"] = {
	"TRANSPARENT": "TRANSPARENT",
	"PLAIN": "PLAIN",
	"FILL": "FILL"
};

UCF_ClientInterfaces["E"]["PatternContainerSequenceItemDesign"] = {
	"DEFAULT": "DEFAULT",
	"INTERMEDIATE": "INTERMEDIATE",
	"LASTBRANCH": "LASTBRANCH",
	"TERMINATOR": "TERMINATOR"
};

UCF_ClientInterfaces["E"]["PatternContainerSequenceStatus"] = {
	"NONE": "NONE",
	"ERROR": "ERROR",
	"WARNING": "WARNING",
	"DONE": "DONE"
};

UCF_ClientInterfaces["E"]["PhaseIndicatorBackgroundDesign"] = {
	"TRANSPARENT": "TRANSPARENT",
	"EMPHASIZED": "EMPHASIZED"
};

UCF_ClientInterfaces["E"]["PhaseIndicatorItemStatus"] = {
	"NONE": "NONE",
	"COMPLETED": "COMPLETED",
	"WARNING": "WARNING",
	"UNAVAILABLE": "UNAVAILABLE"
};

UCF_ClientInterfaces["E"]["PopInDesign"] = {
	"TRANSPARENT": "TRANSPARENT",
	"PLAIN": "PLAIN",
	"FILL": "FILL"
};

UCF_ClientInterfaces["E"]["PopInTitleAreaDesign"] = {
	"TEXT": "TEXT",
	"CRITICAL": "CRITICAL",
	"ERROR": "ERROR",
	"OK": "OK"
};

UCF_ClientInterfaces["E"]["PopUpTriggerIndicator"] = {
	"PERMANENT": "PERMANENT",
	"HOVER": "HOVER",
	"BUTTON": "BUTTON"
};

UCF_ClientInterfaces["E"]["InfoType"] = {
	"NONE": "NONE",
	"INFORMATION": "INFORMATION",
	"WARNING": "WARNING",
	"SUCCESS": "SUCCESS",
	"ERROR": "ERROR",
	"QUESTION": "QUESTION",
	"TEXT": "TEXT"
};

UCF_ClientInterfaces["E"]["Mode"] = {
	"MODAL": "MODAL",
	"AMODAL": "AMODAL",
	"FLOATING": "FLOATING"
};

UCF_ClientInterfaces["E"]["ProgressIndicatorBarColor"] = {
	"NEUTRAL": "NEUTRAL",
	"POSITIVE": "POSITIVE",
	"CRITICAL": "CRITICAL",
	"NEGATIVE": "NEGATIVE"
};

UCF_ClientInterfaces["E"]["PopOverAlignment"] = {
	"DEFAULT": "DEFAULT",
	"TOP_LEFT_CONTAINER": "TOP_LEFT_CONTAINER"
};

UCF_ClientInterfaces["E"]["QuickViewBehavior"] = {
	"DEFAULT": "DEFAULT",
	"POPOVER": "POPOVER"
};

UCF_ClientInterfaces["E"]["QuickViewDesign"] = {
	"STANDARD": "STANDARD",
	"APPLICATION": "APPLICATION"
};

UCF_ClientInterfaces["E"]["RadioButtonArrangement"] = {
	"RADIOBUTTONFIRST": "RADIOBUTTONFIRST",
	"RADIOBUTTONLAST": "RADIOBUTTONLAST"
};

UCF_ClientInterfaces["E"]["RadioButtonLabelDesign"] = {
	"STANDARD": "STANDARD",
	"EMPHAZISED": "EMPHAZISED",
	"MONOSPACE": "MONOSPACE"
};

UCF_ClientInterfaces["E"]["RasterLayoutItemAlignment"] = {
	"CENTER": "CENTER",
	"RIGHT": "RIGHT",
	"LEFT": "LEFT"
};

UCF_ClientInterfaces["E"]["RasterLayoutPosition"] = {
	"ABSOLUTE": "ABSOLUTE",
	"RELATIVE": "RELATIVE"
};

UCF_ClientInterfaces["E"]["StretchingMode"] = {
	"NONE": "NONE",
	"FILL": "FILL"
};

UCF_ClientInterfaces["E"]["RatingIndicatorAppearance"] = {
	"SQUARE": "SQUARE"
};

UCF_ClientInterfaces["E"]["RatingIndicatorDesign"] = {
	"INITIAL": "INITIAL",
	"NEUTRAL": "NEUTRAL",
	"UNRATED": "UNRATED",
	"POSITIVE": "POSITIVE",
	"CRITICAL": "CRITICAL",
	"NEGATIVE": "NEGATIVE"
};

UCF_ClientInterfaces["E"]["ValueDisplayMode"] = {
	"FULL": "FULL",
	"HALF": "HALF",
	"CONTINUOUS": "CONTINUOUS"
};

UCF_ClientInterfaces["E"]["RoadMapEdgesDesign"] = {
	"DEFAULT": "DEFAULT",
	"SELECTED": "SELECTED",
	"DISABLED": "DISABLED",
	"MORE": "MORE",
	"MORE_DISABLED": "MORE_DISABLED"
};

UCF_ClientInterfaces["E"]["RoadMapStepDesign"] = {
	"DEFAULT": "DEFAULT",
	"SELECTED": "SELECTED",
	"DISABLED": "DISABLED"
};

UCF_ClientInterfaces["E"]["RoadMapStepType"] = {
	"STANDARDSTEP": "STANDARDSTEP",
	"ROUNDTRIPCLOSED": "ROUNDTRIPCLOSED",
	"ROUNDTRIPSTART": "ROUNDTRIPSTART",
	"ROUNDTRIPEND": "ROUNDTRIPEND",
	"SUBSTEP": "SUBSTEP"
};

UCF_ClientInterfaces["E"]["SapTableBorderOmitting"] = {
	"NONE": "NONE",
	"HORIZONTAL": "HORIZONTAL",
	"VERTICAL": "VERTICAL",
	"BOTH": "BOTH"
};

UCF_ClientInterfaces["E"]["SapTableCellDesign"] = {
	"STANDARD": "STANDARD",
	"ALTERNATING": "ALTERNATING",
	"TRANSPARENT": "TRANSPARENT",
	"NEGATIVE": "NEGATIVE",
	"POSITIVE": "POSITIVE",
	"TOTAL": "TOTAL",
	"SUBTOTAL": "SUBTOTAL",
	"SUBTOTAL_LIGHT": "SUBTOTAL_LIGHT",
	"BADVALUE_DARK": "BADVALUE_DARK",
	"BADVALUE_MEDIUM": "BADVALUE_MEDIUM",
	"BADVALUE_LIGHT": "BADVALUE_LIGHT",
	"CRITICAL": "CRITICAL",
	"CRITICALVALUE_DARK": "CRITICALVALUE_DARK",
	"CRITICALVALUE_MEDIUM": "CRITICALVALUE_MEDIUM",
	"CRITICALVALUE_LIGHT": "CRITICALVALUE_LIGHT",
	"GOODVALUE_DARK": "GOODVALUE_DARK",
	"GOODVALUE_MEDIUM": "GOODVALUE_MEDIUM",
	"GOODVALUE_LIGHT": "GOODVALUE_LIGHT",
	"GROUP_HIGHLIGHTED": "GROUP_HIGHLIGHTED",
	"GROUP_HIGHLIGHTED_LIGHT": "GROUP_HIGHLIGHTED_LIGHT",
	"KEY_MEDIUM": "KEY_MEDIUM",
	"GROUP_LEVEL1": "GROUP_LEVEL1",
	"GROUP_LEVEL2": "GROUP_LEVEL2",
	"GROUP_LEVEL3": "GROUP_LEVEL3",
	"MARKED": "MARKED",
	"FILTER": "FILTER",
	"FILTERICON": "FILTERICON",
	"POPIN": "POPIN",
	"NONE": "NONE",
	"DISABLED": "DISABLED",
	"TODAY": "TODAY",
	"SELECTED1": "SELECTED1",
	"SELECTED2": "SELECTED2",
	"SELECTED3": "SELECTED3",
	"SELECTED4": "SELECTED4",
	"SELECTED5": "SELECTED5",
	"SECONDARY_SELECTED": "SECONDARY_SELECTED",
	"CALENDAR_METAL": "CALENDAR_METAL",
	"CALENDAR_PEACH": "CALENDAR_PEACH",
	"CALENDAR_BLUE": "CALENDAR_BLUE",
	"CALENDAR_ROSE": "CALENDAR_ROSE",
	"CALENDAR_PURPLE": "CALENDAR_PURPLE",
	"CALENDAR_AQUA": "CALENDAR_AQUA",
	"CALENDAR_TEAL": "CALENDAR_TEAL",
	"CALENDAR_YELLOW": "CALENDAR_YELLOW",
	"CALENDAR_BROWN": "CALENDAR_BROWN",
	"CALENDAR_DEFAULT": "CALENDAR_DEFAULT",
	"CALENDAR_GREEN": "CALENDAR_GREEN",
	"INTENSIFIED": "INTENSIFIED",
	"COLOR_BLACK": "COLOR_BLACK",
	"COLOR_BROWN": "COLOR_BROWN",
	"COLOR_OLIVE_GREEN": "COLOR_OLIVE_GREEN",
	"COLOR_DARK_GREEN": "COLOR_DARK_GREEN",
	"COLOR_DARK_TEAL": "COLOR_DARK_TEAL",
	"COLOR_DARK_BLUE": "COLOR_DARK_BLUE",
	"COLOR_INDIGO": "COLOR_INDIGO",
	"COLOR_GRAY_80": "COLOR_GRAY_80",
	"COLOR_DARK_RED": "COLOR_DARK_RED",
	"COLOR_ORANGE": "COLOR_ORANGE",
	"COLOR_DARK_YELLOW": "COLOR_DARK_YELLOW",
	"COLOR_GREEN": "COLOR_GREEN",
	"COLOR_TEAL": "COLOR_TEAL",
	"COLOR_BLUE": "COLOR_BLUE",
	"COLOR_BLUE_GRAY": "COLOR_BLUE_GRAY",
	"COLOR_GRAY_50": "COLOR_GRAY_50",
	"COLOR_RED": "COLOR_RED",
	"COLOR_LIGHT_ORANGE": "COLOR_LIGHT_ORANGE",
	"COLOR_LIME": "COLOR_LIME",
	"COLOR_SEA_GREEN": "COLOR_SEA_GREEN",
	"COLOR_AQUA": "COLOR_AQUA",
	"COLOR_LIGHT_BLUE": "COLOR_LIGHT_BLUE",
	"COLOR_VIOLET": "COLOR_VIOLET",
	"COLOR_GRAY_40": "COLOR_GRAY_40",
	"COLOR_PINK": "COLOR_PINK",
	"COLOR_GOLD": "COLOR_GOLD",
	"COLOR_YELLOW": "COLOR_YELLOW",
	"COLOR_BRIGHT_GREEN": "COLOR_BRIGHT_GREEN",
	"COLOR_TURQUOISE": "COLOR_TURQUOISE",
	"COLOR_SKY_BLUE": "COLOR_SKY_BLUE",
	"COLOR_PLUM": "COLOR_PLUM",
	"COLOR_GRAY_25": "COLOR_GRAY_25",
	"COLOR_ROSE": "COLOR_ROSE",
	"COLOR_TAN": "COLOR_TAN",
	"COLOR_LIGHT_YELLOW": "COLOR_LIGHT_YELLOW",
	"COLOR_LIGHT_GREEN": "COLOR_LIGHT_GREEN",
	"COLOR_LIGHT_TURQUOISE": "COLOR_LIGHT_TURQUOISE",
	"COLOR_PALE_BLUE": "COLOR_PALE_BLUE",
	"COLOR_LAVENDER": "COLOR_LAVENDER",
	"COLOR_WHITE": "COLOR_WHITE",
	"COLOR_A_1": "COLOR_A_1",
	"COLOR_A_2": "COLOR_A_2",
	"COLOR_A_3": "COLOR_A_3",
	"COLOR_A_4": "COLOR_A_4",
	"COLOR_A_5": "COLOR_A_5",
	"COLOR_A_6": "COLOR_A_6",
	"COLOR_A_7": "COLOR_A_7",
	"COLOR_A_8": "COLOR_A_8",
	"COLOR_A_9": "COLOR_A_9",
	"COLOR_B_1": "COLOR_B_1",
	"COLOR_B_2": "COLOR_B_2",
	"COLOR_B_3": "COLOR_B_3",
	"COLOR_B_4": "COLOR_B_4",
	"COLOR_B_5": "COLOR_B_5",
	"COLOR_B_6": "COLOR_B_6",
	"COLOR_B_7": "COLOR_B_7",
	"COLOR_B_8": "COLOR_B_8",
	"COLOR_B_9": "COLOR_B_9",
	"COLOR_C_1": "COLOR_C_1",
	"COLOR_C_2": "COLOR_C_2",
	"COLOR_C_3": "COLOR_C_3",
	"COLOR_C_4": "COLOR_C_4",
	"COLOR_C_5": "COLOR_C_5",
	"COLOR_C_6": "COLOR_C_6",
	"COLOR_C_7": "COLOR_C_7",
	"COLOR_C_8": "COLOR_C_8",
	"COLOR_C_9": "COLOR_C_9",
	"COLOR_D_1": "COLOR_D_1",
	"COLOR_D_2": "COLOR_D_2",
	"COLOR_D_3": "COLOR_D_3",
	"COLOR_D_4": "COLOR_D_4",
	"COLOR_D_5": "COLOR_D_5",
	"COLOR_D_6": "COLOR_D_6",
	"COLOR_D_7": "COLOR_D_7",
	"COLOR_D_8": "COLOR_D_8",
	"COLOR_D_9": "COLOR_D_9",
	"COLOR_E_1": "COLOR_E_1",
	"COLOR_E_2": "COLOR_E_2",
	"COLOR_E_3": "COLOR_E_3",
	"COLOR_E_4": "COLOR_E_4",
	"COLOR_E_5": "COLOR_E_5",
	"COLOR_E_6": "COLOR_E_6",
	"COLOR_E_7": "COLOR_E_7",
	"COLOR_E_8": "COLOR_E_8",
	"COLOR_E_9": "COLOR_E_9",
	"COL_BACKGROUND_INTENSIFIED": "COL_BACKGROUND_INTENSIFIED",
	"COL_HEADING_INTENSIFIED": "COL_HEADING_INTENSIFIED",
	"COL_NORMAL_INTENSIFIED": "COL_NORMAL_INTENSIFIED",
	"COL_TOTAL_INTENSIFIED": "COL_TOTAL_INTENSIFIED",
	"COL_KEY_INTENSIFIED": "COL_KEY_INTENSIFIED",
	"COL_POSITIVE_INTENSIFIED": "COL_POSITIVE_INTENSIFIED",
	"COL_NEGATIVE_INTENSIFIED": "COL_NEGATIVE_INTENSIFIED",
	"COL_GROUP_INTENSIFIED": "COL_GROUP_INTENSIFIED",
	"COL_INACTIVE_INTENSIFIED": "COL_INACTIVE_INTENSIFIED",
	"COL_LISTTREE_BACKGROUND_INTENSIFIED": "COL_LISTTREE_BACKGROUND_INTENSIFIED",
	"COL_BACKGROUND": "COL_BACKGROUND",
	"COL_HEADING": "COL_HEADING",
	"COL_NORMAL": "COL_NORMAL",
	"COL_TOTAL": "COL_TOTAL",
	"COL_KEY": "COL_KEY",
	"COL_POSITIVE": "COL_POSITIVE",
	"COL_NEGATIVE": "COL_NEGATIVE",
	"COL_GROUP": "COL_GROUP",
	"COL_INACTIVE": "COL_INACTIVE",
	"COL_LISTTREE_BACKGROUND": "COL_LISTTREE_BACKGROUND",
	"CALENDAR_1_INTENSIFIED": "CALENDAR_1_INTENSIFIED",
	"CALENDAR_2_INTENSIFIED": "CALENDAR_2_INTENSIFIED",
	"CALENDAR_3_INTENSIFIED": "CALENDAR_3_INTENSIFIED",
	"CALENDAR_4_INTENSIFIED": "CALENDAR_4_INTENSIFIED",
	"CALENDAR_5_INTENSIFIED": "CALENDAR_5_INTENSIFIED",
	"CALENDAR_6_INTENSIFIED": "CALENDAR_6_INTENSIFIED",
	"CALENDAR_7_INTENSIFIED": "CALENDAR_7_INTENSIFIED",
	"CALENDAR_8_INTENSIFIED": "CALENDAR_8_INTENSIFIED",
	"CALENDAR_1": "CALENDAR_1",
	"CALENDAR_2": "CALENDAR_2",
	"CALENDAR_3": "CALENDAR_3",
	"CALENDAR_4": "CALENDAR_4",
	"CALENDAR_5": "CALENDAR_5",
	"CALENDAR_6": "CALENDAR_6",
	"CALENDAR_7": "CALENDAR_7",
	"CALENDAR_8": "CALENDAR_8"
};

UCF_ClientInterfaces["E"]["SapTableCellEventProcessing"] = {
	"STANDARD": "STANDARD",
	"CAPTURE": "CAPTURE"
};

UCF_ClientInterfaces["E"]["SapTableCellGroupingMode"] = {
	"NONE": "NONE",
	"ROW_HEAD": "ROW_HEAD",
	"ROW": "ROW",
	"ROW_REDUNDANT": "ROW_REDUNDANT"
};

UCF_ClientInterfaces["E"]["SapTableCellMode"] = {
	"CONTENT_READONLY": "CONTENT_READONLY",
	"CONTENT_EDITABLE": "CONTENT_EDITABLE",
	"EMPTY_CELL": "EMPTY_CELL"
};

UCF_ClientInterfaces["E"]["SapTableCellSelectionKeyboardTrigger"] = {
	"SPACEBAR_ENTER": "SPACEBAR_ENTER",
	"SPACEBAR": "SPACEBAR"
};

UCF_ClientInterfaces["E"]["SapTableCellSelectionMapping"] = {
	"NONE": "NONE",
	"ROW": "ROW",
	"COLUMN": "COLUMN"
};

UCF_ClientInterfaces["E"]["SapTableCellType"] = {
	"TEXT": "TEXT",
	"EDIT": "EDIT",
	"EMPTYROW": "EMPTYROW",
	"EMPTYCELL": "EMPTYCELL",
	"FORMAT": "FORMAT",
	"ROWCREATOR": "ROWCREATOR",
	"INFO": "INFO"
};

UCF_ClientInterfaces["E"]["SapTableColumnSelectionClientBehaviour"] = {
	"NONE": "NONE",
	"SMART": "SMART"
};

UCF_ClientInterfaces["E"]["SapTableColumnSelectionMode"] = {
	"SERVER": "SERVER",
	"NONE": "NONE",
	"SINGLE": "SINGLE",
	"MULTI": "MULTI"
};

UCF_ClientInterfaces["E"]["SapTableColumnType"] = {
	"STANDARD": "STANDARD",
	"SELECTIONCOLUMN": "SELECTIONCOLUMN"
};

UCF_ClientInterfaces["E"]["SapTableContentBackgroundDesign"] = {
	"INHERIT": "INHERIT",
	"TRANSPARENT": "TRANSPARENT"
};

UCF_ClientInterfaces["E"]["SapTableContentEditMode"] = {
	"READONLY": "READONLY",
	"EDITABLE": "EDITABLE"
};

UCF_ClientInterfaces["E"]["SapTableCSRenderFragment"] = {
	"FULL": "FULL",
	"PAGES": "PAGES"
};

UCF_ClientInterfaces["E"]["SapTableGapGrid"] = {
	"ALL": "ALL",
	"NONE": "NONE"
};

UCF_ClientInterfaces["E"]["SapTableGridMode"] = {
	"BOTH": "BOTH",
	"NONE": "NONE",
	"VERTICAL": "VERTICAL",
	"HORIZONTAL": "HORIZONTAL"
};

UCF_ClientInterfaces["E"]["SapTableHeaderCellDesign"] = {
	"LEVEL1HEADER": "LEVEL1HEADER",
	"LEVEL2HEADER": "LEVEL2HEADER",
	"LEVEL3HEADER": "LEVEL3HEADER"
};

UCF_ClientInterfaces["E"]["SapTableHeaderCellType"] = {
	"STANDARD": "STANDARD",
	"SELECTIONCOLUMN": "SELECTIONCOLUMN"
};

UCF_ClientInterfaces["E"]["SapTableHierarchicalCellStatus"] = {
	"NONE": "NONE",
	"INDENT": "INDENT",
	"EXPANDED": "EXPANDED",
	"COLLAPSED": "COLLAPSED",
	"COLLAPSEDPLUS": "COLLAPSEDPLUS",
	"EXPANDEDMINUS": "EXPANDEDMINUS",
	"EXPANDEDTOP": "EXPANDEDTOP",
	"MARKTOTALS": "MARKTOTALS",
	"LEAF": "LEAF",
	"ICON": "ICON"
};

UCF_ClientInterfaces["E"]["SapTableNoDataNotificationMode"] = {
	"NONE": "NONE",
	"UNSPECIFIC": "UNSPECIFIC",
	"NO_SEARCH_RESULTS": "NO_SEARCH_RESULTS",
	"FREE_TEXT": "FREE_TEXT"
};

UCF_ClientInterfaces["E"]["SapTableRowCreationTrigger"] = {
	"INHERIT": "INHERIT",
	"NONE": "NONE",
	"LAST_ROW_ACTION": "LAST_ROW_ACTION"
};

UCF_ClientInterfaces["E"]["SapTableRowSelectionClientBehaviour"] = {
	"NONE": "NONE",
	"WEB": "WEB",
	"SMART": "SMART",
	"WEB_SMART": "WEB_SMART",
	"SERVER_SMART": "SERVER_SMART",
	"SERVER_WEB": "SERVER_WEB",
	"SERVER_WEB_SMART": "SERVER_WEB_SMART"
};

UCF_ClientInterfaces["E"]["SapTableRowSelectionFollowFocus"] = {
	"NONE": "NONE",
	"KEYBOARD": "KEYBOARD",
	"MOUSE": "MOUSE",
	"BOTH": "BOTH"
};

UCF_ClientInterfaces["E"]["SapTableRowSelectionMassState"] = {
	"NONE": "NONE",
	"INDETERMINATE": "INDETERMINATE",
	"ALL": "ALL"
};

UCF_ClientInterfaces["E"]["SapTableRowSelectionMode"] = {
	"SERVER": "SERVER",
	"NONE": "NONE",
	"SINGLE": "SINGLE",
	"MULTI": "MULTI",
	"SINGLE_PRIMARY": "SINGLE_PRIMARY",
	"MULTI_PRIMARY": "MULTI_PRIMARY",
	"SINGLE_PRIMARY_MANDATORY": "SINGLE_PRIMARY_MANDATORY",
	"MULTI_PRIMARY_MANDATORY": "MULTI_PRIMARY_MANDATORY",
	"MULTI_IMPLICIT_PRIMARY": "MULTI_IMPLICIT_PRIMARY",
	"MULTI_IMPLICIT_PRIMARY_MANDATORY": "MULTI_IMPLICIT_PRIMARY_MANDATORY"
};

UCF_ClientInterfaces["E"]["SapTableRowType"] = {
	"UNSPECIFIED": "UNSPECIFIED",
	"STANDARD": "STANDARD",
	"HEADER": "HEADER",
	"FILTER": "FILTER",
	"TOP_FIXED": "TOP_FIXED",
	"BOTTOM_FIXED": "BOTTOM_FIXED",
	"PIVOT": "PIVOT"
};

UCF_ClientInterfaces["E"]["SapTableScrollUpdateMode"] = {
	"CLIENT": "CLIENT",
	"SERVER": "SERVER"
};

UCF_ClientInterfaces["E"]["SapTableSelectionColumnAction"] = {
	"NONE": "NONE",
	"SELECTION_MENU": "SELECTION_MENU",
	"SELECTION_TOGGLE": "SELECTION_TOGGLE"
};

UCF_ClientInterfaces["E"]["SapTableSelectionMassAction"] = {
	"ROW": "ROW",
	"COLUMN": "COLUMN",
	"BOTH": "BOTH"
};

UCF_ClientInterfaces["E"]["SapTableSelectionState"] = {
	"NOT_SELECTABLE": "NOT_SELECTABLE",
	"NOT_SELECTED": "NOT_SELECTED",
	"SELECTED": "SELECTED",
	"PRIMARY_SELECTED": "PRIMARY_SELECTED",
	"NONE": "NONE"
};

UCF_ClientInterfaces["E"]["SapTableSemanticType"] = {
	"NONE": "NONE",
	"ALTERNATING": "ALTERNATING",
	"ALTERNATING_KEY": "ALTERNATING_KEY",
	"KEY": "KEY",
	"TOTAL": "TOTAL",
	"SUBTOTAL": "SUBTOTAL",
	"GROUP1": "GROUP1",
	"GROUP2": "GROUP2",
	"GROUP3": "GROUP3",
	"POSITIVE1": "POSITIVE1",
	"POSITIVE2": "POSITIVE2",
	"POSITIVE3": "POSITIVE3",
	"NEGATIVE1": "NEGATIVE1",
	"NEGATIVE2": "NEGATIVE2",
	"NEGATIVE3": "NEGATIVE3",
	"CRITICAL1": "CRITICAL1",
	"CRITICAL2": "CRITICAL2",
	"CRITICAL3": "CRITICAL3"
};

UCF_ClientInterfaces["E"]["SortState"] = {
	"DISABLED": "DISABLED",
	"NONE": "NONE",
	"ASCENDING": "ASCENDING",
	"DESCENDING": "DESCENDING"
};

UCF_ClientInterfaces["E"]["ScrollDirection"] = {
	"VERTICAL": "VERTICAL",
	"HORIZONTAL": "HORIZONTAL"
};

UCF_ClientInterfaces["E"]["SectionHeaderLevel"] = {
	"HEADER1": "HEADER1",
	"HEADER2": "HEADER2",
	"HEADER3": "HEADER3",
	"HEADER4": "HEADER4",
	"HEADER5": "HEADER5",
	"HEADER6": "HEADER6"
};

UCF_ClientInterfaces["E"]["SegmentedButtonSelectionType"] = {
	"SINGLE": "SINGLE",
	"MULTIPLE": "MULTIPLE",
	"NONE": "NONE"
};

UCF_ClientInterfaces["E"]["ShuttleBehavior"] = {
	"ADD": "ADD",
	"MOVE": "MOVE"
};

UCF_ClientInterfaces["E"]["SplitterCollapseDirection"] = {
	"PREVIOUS": "PREVIOUS",
	"NEXT": "NEXT",
	"NONE": "NONE"
};

UCF_ClientInterfaces["E"]["SplitterDomType"] = {
	"DETACHED_DOM": "DETACHED_DOM",
	"VERTICALLY_PUSHING_DOM": "VERTICALLY_PUSHING_DOM",
	"RESIZABLE_DOM": "RESIZABLE_DOM",
	"HEAVY_DOM": "HEAVY_DOM",
	"DYNAMIC_CONTAINER": "DYNAMIC_CONTAINER"
};

UCF_ClientInterfaces["E"]["SplitterGridType"] = {
	"CELL": "CELL",
	"ROWSASH": "ROWSASH",
	"COLSASH": "COLSASH",
	"ROOT": "ROOT"
};

UCF_ClientInterfaces["E"]["SplitterMode"] = {
	"WEB": "WEB",
	"ITS": "ITS"
};

UCF_ClientInterfaces["E"]["SplitterRenderingMode"] = {
	"HEAVY_DOM": "HEAVY_DOM",
	"MODERN_LEAN": "MODERN_LEAN"
};

UCF_ClientInterfaces["E"]["SplitterSashDesign"] = {
	"STANDARD": "STANDARD",
	"CONTOUR": "CONTOUR"
};

UCF_ClientInterfaces["E"]["SplitterSashDragBehavior"] = {
	"SERVERSIDE_DRAGGING": "SERVERSIDE_DRAGGING",
	"CLIENTSIDE_DRAGGING": "CLIENTSIDE_DRAGGING"
};

UCF_ClientInterfaces["E"]["SplitterSashType"] = {
	"RESIZABLE": "RESIZABLE",
	"FIX": "FIX",
	"INVISIBLE": "INVISIBLE",
	"NONE": "NONE"
};

UCF_ClientInterfaces["E"]["SplitterSizeMode"] = {
	"RELATIVE": "RELATIVE",
	"ABSOLUTE": "ABSOLUTE"
};

UCF_ClientInterfaces["E"]["SplitterType"] = {
	"SPLITTER": "SPLITTER",
	"DOCKER": "DOCKER"
};

UCF_ClientInterfaces["E"]["SwitchType"] = {
	"DEFAULT": "DEFAULT",
	"ACCEPTREJECT": "ACCEPTREJECT"
};

UCF_ClientInterfaces["E"]["TabItemsDesign"] = {
	"TAB": "TAB",
	"PANEL": "PANEL"
};

UCF_ClientInterfaces["E"]["TabItemsPosition"] = {
	"TOP": "TOP",
	"BOTTOM": "BOTTOM"
};

UCF_ClientInterfaces["E"]["EditContext"] = {
	"PARENTEDITABLE": "PARENTEDITABLE",
	"PARENTREADONLY": "PARENTREADONLY"
};

UCF_ClientInterfaces["E"]["RichTextEditParagraphSpacing"] = {
	"NONE": "NONE",
	"LINE": "LINE"
};

UCF_ClientInterfaces["E"]["TextEditOverflow"] = {
	"AUTO": "AUTO",
	"HIDDEN": "HIDDEN",
	"SCROLL": "SCROLL",
	"VISIBLE": "VISIBLE"
};

UCF_ClientInterfaces["E"]["TextEditWrapping"] = {
	"OFF": "OFF",
	"HARD": "HARD",
	"SOFT": "SOFT"
};

UCF_ClientInterfaces["E"]["FormattedTextViewLayout"] = {
	"BLOCK": "BLOCK",
	"NATIVE": "NATIVE",
	"PARAGRAPH": "PARAGRAPH"
};

UCF_ClientInterfaces["E"]["TextViewDesign"] = {
	"EMPHASIZED": "EMPHASIZED",
	"STANDARD": "STANDARD",
	"LABEL_SMALL": "LABEL_SMALL",
	"LABEL": "LABEL",
	"HEADER1": "HEADER1",
	"HEADER2": "HEADER2",
	"HEADER3": "HEADER3",
	"HEADER4": "HEADER4",
	"GROUPTITLE": "GROUPTITLE",
	"LEGEND": "LEGEND",
	"REFERENCE": "REFERENCE",
	"MONOSPACE": "MONOSPACE"
};

UCF_ClientInterfaces["E"]["TextViewLayout"] = {
	"BLOCK": "BLOCK",
	"NATIVE": "NATIVE",
	"PARAGRAPH": "PARAGRAPH"
};

UCF_ClientInterfaces["E"]["TextViewSemanticColor"] = {
	"DEFAULT": "DEFAULT",
	"DIMINISHED": "DIMINISHED",
	"POSITIVE": "POSITIVE",
	"CRITICAL": "CRITICAL",
	"NEGATIVE": "NEGATIVE",
	"MARKED1": "MARKED1",
	"MARKED2": "MARKED2",
	"LISTHEADING": "LISTHEADING",
	"LISTHEADINGINTENSIV": "LISTHEADINGINTENSIV",
	"LISTNORMAL": "LISTNORMAL",
	"LISTNORMALINTENSIV": "LISTNORMALINTENSIV",
	"LISTTOTAL": "LISTTOTAL",
	"LISTTOTALINTENSIV": "LISTTOTALINTENSIV",
	"LISTKEY": "LISTKEY",
	"LISTKEYINTENSIV": "LISTKEYINTENSIV",
	"LISTPOSITIVE": "LISTPOSITIVE",
	"LISTPOSITIVEINTENSIV": "LISTPOSITIVEINTENSIV",
	"LISTNEGATIVE": "LISTNEGATIVE",
	"LISTNEGATIVEINTENSIV": "LISTNEGATIVEINTENSIV",
	"LISTGROUP": "LISTGROUP",
	"LISTGROUPINTENSIV": "LISTGROUPINTENSIV",
	"INHERIT": "INHERIT"
};

UCF_ClientInterfaces["E"]["ThresholdSliderSizing"] = {
	"STATIC": "STATIC",
	"DYNAMIC": "DYNAMIC"
};

UCF_ClientInterfaces["E"]["TileLayoutCellPadding"] = {
	"NONE": "NONE",
	"SMALL": "SMALL",
	"MEDIUM": "MEDIUM",
	"LARGE": "LARGE",
	"RESPONSIVE": "RESPONSIVE",
	"SMALL_GAP": "SMALL_GAP",
	"MEDIUM_GAP": "MEDIUM_GAP",
	"LARGE_GAP": "LARGE_GAP",
	"RESPONSIVE_GAP": "RESPONSIVE_GAP",
	"HORIZONTAL_SMALL": "HORIZONTAL_SMALL",
	"HORIZONTAL_MEDIUM": "HORIZONTAL_MEDIUM",
	"HORIZONTAL_LARGE": "HORIZONTAL_LARGE",
	"HORIZONTAL_RESPONSIVE": "HORIZONTAL_RESPONSIVE",
	"HORIZONTAL_SMALL_GAP": "HORIZONTAL_SMALL_GAP",
	"HORIZONTAL_MEDIUM_GAP": "HORIZONTAL_MEDIUM_GAP",
	"HORIZONTAL_LARGE_GAP": "HORIZONTAL_LARGE_GAP",
	"HORIZONTAL_RESPONSIVE_GAP": "HORIZONTAL_RESPONSIVE_GAP"
};

UCF_ClientInterfaces["E"]["ToolbarAlignment"] = {
	"HORIZONTAL": "HORIZONTAL",
	"VERTICAL": "VERTICAL"
};

UCF_ClientInterfaces["E"]["ToolbarDesign"] = {
	"EMPHASIZED": "EMPHASIZED",
	"STANDARD": "STANDARD",
	"TRANSPARENT": "TRANSPARENT",
	"FLAT": "FLAT",
	"FOOTER": "FOOTER",
	"HEADER": "HEADER",
	"ITS_MODE": "ITS_MODE"
};

UCF_ClientInterfaces["E"]["ToolbarItemSeparation"] = {
	"LARGEWITHLINE": "LARGEWITHLINE",
	"LARGE": "LARGE",
	"MEDIUMWITHLINE": "MEDIUMWITHLINE",
	"MEDIUM": "MEDIUM",
	"SMALLWITHLINE": "SMALLWITHLINE",
	"SMALL": "SMALL",
	"BREAKLINE": "BREAKLINE"
};

UCF_ClientInterfaces["E"]["TrayDesign"] = {
	"TRANSPARENT": "TRANSPARENT",
	"PLAIN": "PLAIN",
	"FILL": "FILL"
};

UCF_ClientInterfaces["E"]["TreeBackground"] = {
	"STANDARD": "STANDARD",
	"LEVEL": "LEVEL",
	"PLAIN": "PLAIN",
	"TRANSPARENT": "TRANSPARENT"
};

UCF_ClientInterfaces["E"]["TreeNodeDesign"] = {
	"EMPHASIZED": "EMPHASIZED",
	"STANDARD": "STANDARD"
};

UCF_ClientInterfaces["E"]["TreeNodeEventProcessing"] = {
	"STANDARD": "STANDARD",
	"CAPTURE": "CAPTURE"
};

UCF_ClientInterfaces["E"]["TreeNodeSelection"] = {
	"NONE": "NONE",
	"PRIMARYSELECTION": "PRIMARYSELECTION",
	"SECONDARYSELECTION": "SECONDARYSELECTION"
};

UCF_ClientInterfaces["E"]["TreeNodeSelectionFollowFocus"] = {
	"NONE": "NONE",
	"KEYBOARD": "KEYBOARD",
	"MOUSE": "MOUSE",
	"BOTH": "BOTH"
};

UCF_ClientInterfaces["E"]["TreeSelectionClientBehaviour"] = {
	"NONE": "NONE",
	"WEB": "WEB",
	"SMART": "SMART"
};

UCF_ClientInterfaces["E"]["TreeSelectionMode"] = {
	"NONE": "NONE",
	"SINGLE": "SINGLE",
	"MULTI": "MULTI",
	"SINGLE_SECONDARY": "SINGLE_SECONDARY",
	"MULTI_PRIMARY": "MULTI_PRIMARY",
	"SINGLE_PRIMARY_MANDATORY": "SINGLE_PRIMARY_MANDATORY",
	"MULTI_PRIMARY_MANDATORY": "MULTI_PRIMARY_MANDATORY",
	"MULTI_IMPLICIT_PRIMARY": "MULTI_IMPLICIT_PRIMARY",
	"MULTI_IMPLICIT_PRIMARY_MANDATORY": "MULTI_IMPLICIT_PRIMARY_MANDATORY"
};

UCF_ClientInterfaces["E"]["TriStateCheckBoxState"] = {
	"CHECKED": "CHECKED",
	"UNCHECKED": "UNCHECKED",
	"INDETERMINATE": "INDETERMINATE"
};

UCF_ClientInterfaces["E"]["TriStateCheckBoxUserChoice"] = {
	"TRISTATE": "TRISTATE",
	"BISTATE": "BISTATE"
};

UCF_ClientInterfaces["E"]["VCBarColor"] = {
	"NEUTRAL1": "NEUTRAL1",
	"NEUTRAL2": "NEUTRAL2",
	"NEUTRAL3": "NEUTRAL3",
	"POSITIVE": "POSITIVE",
	"NEGATIVE": "NEGATIVE",
	"CRITICAL": "CRITICAL"
};

UCF_ClientInterfaces["E"]["VCMarkerType"] = {
	"NEUTRAL": "NEUTRAL",
	"CRITICAL": "CRITICAL"
};

UCF_ClientInterfaces["E"]["ViewSwitchIcon"] = {
	"NONE": "NONE",
	"BLANK": "BLANK",
	"CUSTOM": "CUSTOM",
	"NEWS": "NEWS",
	"OVERVIEW": "OVERVIEW",
	"REPORTS": "REPORTS",
	"SELFSERVICE": "SELFSERVICE",
	"WORK": "WORK"
};

UCF_ClientInterfaces["E"]["WebWidgetListener"] = {
	"NONE": "NONE",
	"ALL": "ALL"
};

UCF_ClientInterfaces["I"]["AbapList"] = {
	"name": "AbapList",
	"properties": {
		"RasterWidth": {
			"type": "number",
			"defaultValue": 1
		},
		"RasterWidthUnit": {
			"type": "string",
			"defaultValue": 'px'
		},
		"RasterHeight": {
			"type": "number",
			"defaultValue": 1
		},
		"RasterHeightUnit": {
			"type": "string",
			"defaultValue": 'px'
		},
		"LineCount": {
			"type": "number",
			"defaultValue": -1
		},
		"FirstVisibleLine": {
			"type": "number",
			"defaultValue": -1
		},
		"VisibleLineCount": {
			"type": "number",
			"defaultValue": -1
		},
		"ColumnCount": {
			"type": "number",
			"defaultValue": -1
		},
		"FirstVisibleColumn": {
			"type": "number",
			"defaultValue": -1
		},
		"VisibleColumnCount": {
			"type": "number",
			"defaultValue": -1
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CellDesign": {
			"type": "UCF_ClientInterfaces.E.LayoutCellDesign",
			"defaultValue": "PADLESS"
		},
		"BlockSelection": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"UseAlternativeFont": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Item",
			"bindable": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Change": {},
		"Select": {},
		"DoubleClick": {},
		"Scroll": {},
		"TabNotify": {},
		"BlockSelect": {},
		"PageUp": {},
		"PageDown": {},
		"PageLeft": {},
		"PageRight": {}
	},
	"publicMethods": [
		"getAvailableWidth",
		"getAvailableHeight",
		"setBlockSelection",
		"visualizeCopyToClipboard"
	],
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color"
			},
			{
				"name": "backgroundImage",
				"property": "background-image"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"defaultValue": "no-repeat"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"defaultValue": "cover"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background image X position for the content"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background image Y position for the content"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage || none"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat || no-repeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize || cover"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["AbapListCheckBox"] = {
	"name": "AbapListCheckBox",
	"properties": {
		"Top": {
			"type": "number",
			"defaultValue": 0
		},
		"Left": {
			"type": "number",
			"defaultValue": 0
		},
		"Width": {
			"type": "number",
			"defaultValue": -1
		},
		"Height": {
			"type": "number",
			"defaultValue": -1
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"BackgroundColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"Checked": {
			"type": "boolean",
			"defaultValue": false
		},
		"ReadOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["AbapListContainer"] = {
	"name": "AbapListContainer",
	"properties": {
		"Top": {
			"type": "number",
			"defaultValue": 0
		},
		"Left": {
			"type": "number",
			"defaultValue": 0
		},
		"Width": {
			"type": "number",
			"defaultValue": -1
		},
		"Height": {
			"type": "number",
			"defaultValue": -1
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Item",
			"bindable": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color"
			},
			{
				"name": "backgroundImage",
				"property": "background-image"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"defaultValue": "no-repeat"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"defaultValue": "cover"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background image X position for the content"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background image Y position for the content"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage || none"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat || no-repeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize || cover"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["AbapListImage"] = {
	"name": "AbapListImage",
	"properties": {
		"Top": {
			"type": "number",
			"defaultValue": 0
		},
		"Left": {
			"type": "number",
			"defaultValue": 0
		},
		"Width": {
			"type": "number",
			"defaultValue": -1
		},
		"Height": {
			"type": "number",
			"defaultValue": -1
		},
		"ContentWidth": {
			"type": "number",
			"defaultValue": -1
		},
		"ContentHeight": {
			"type": "number",
			"defaultValue": -1
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"BackgroundColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"Selectable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Src": {
			"type": "string",
			"defaultValue": ''
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.AbapListImageType",
			"defaultValue": "SRC"
		},
		"Decorative": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["AbapListTabActor"] = {
	"name": "AbapListTabActor",
	"properties": {
		"ForwardFocusId": {
			"type": "string",
			"defaultValue": ''
		},
		"ForwardScrollToLine": {
			"type": "number",
			"defaultValue": -1
		},
		"ForwardScrollToColumn": {
			"type": "number",
			"defaultValue": -1
		},
		"DoForwardNotification": {
			"type": "boolean",
			"defaultValue": false
		},
		"BackwardFocusId": {
			"type": "string",
			"defaultValue": ''
		},
		"BackwardScrollToLine": {
			"type": "number",
			"defaultValue": -1
		},
		"BackwardScrollToColumn": {
			"type": "number",
			"defaultValue": -1
		},
		"DoBackwardNotification": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["AbapListText"] = {
	"name": "AbapListText",
	"properties": {
		"Top": {
			"type": "number",
			"defaultValue": 0
		},
		"Left": {
			"type": "number",
			"defaultValue": 0
		},
		"Width": {
			"type": "number",
			"defaultValue": -1
		},
		"Height": {
			"type": "number",
			"defaultValue": -1
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"BackgroundColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"Selectable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"ReadOnly": {
			"type": "boolean",
			"defaultValue": true
		},
		"MaxLength": {
			"type": "number",
			"defaultValue": -1
		},
		"TextColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"Decorative": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"ClipboardTablePaste": {}
	},
	"styles": {
		"variables": [
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color for AbapListText"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration for AbapListText"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["Accordion"] = {
	"name": "Accordion",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalSizing": {
			"type": "UCF_ClientInterfaces.E.AccordionSizing",
			"defaultValue": "FILL"
		},
		"SelectedItemIndex": {
			"type": "number",
			"defaultValue": 0
		},
		"AllowDeselect": {
			"type": "boolean",
			"defaultValue": false
		},
		"AllowSelect": {
			"type": "boolean",
			"defaultValue": true
		},
		"AllowMultipleSelection": {
			"type": "boolean",
			"defaultValue": false
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"DropTargetInfo": {
			"type": "string"
		},
		"DragSourceInfo": {
			"type": "string"
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.AccordionItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Change": {},
		"Select": {},
		"Deselect": {},
		"Drag": {},
		"Drop": {},
		"Scroll": {},
		"Hotkey": {}
	},
	"publicMethods": [
		"ToggleItems",
		"aGetItems"
	]
};

UCF_ClientInterfaces["I"]["AccordionItem"] = {
	"name": "AccordionItem",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Index": {
			"type": "number",
			"defaultValue": 0
		},
		"ImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"HasToggleIcon": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasEditableTitle": {
			"type": "boolean",
			"defaultValue": false
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"DragData": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"HasContentPadding": {
			"type": "boolean",
			"defaultValue": true
		},
		"ExpandForMultipleSelection": {
			"type": "boolean",
			"defaultValue": false
		},
		"ItemDesign": {
			"type": "UCF_ClientInterfaces.E.AccordionItemDesign",
			"defaultValue": "STANDARD"
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"setItemDesign",
		"sGetItemDesign",
		"sGetId",
		"iGetIndex"
	]
};

UCF_ClientInterfaces["I"]["AcfAdapter"] = {
	"name": "AcfAdapter",
	"properties": {
		"InvocationXML": {
			"type": "string",
			"defaultValue": ''
		},
		"Timeout": {
			"type": "number",
			"defaultValue": 0
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Event": {},
		"ServiceEvent": {},
		"AttributeChange": {},
		"ReturnValue": {},
		"Timeout": {}
	}
};

UCF_ClientInterfaces["I"]["InteractiveForm"] = {
	"name": "InteractiveForm",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"Height": {
			"type": "string",
			"defaultValue": null
		},
		"Source": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AutoActivate": {
			"type": "boolean",
			"defaultValue": false
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "BROWSER"
		},
		"InvocationXML": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Check": {},
		"Submit": {},
		"ValueHelp": {},
		"PDFChange": {},
		"XMLChange": {},
		"ReturnValue": {}
	},
	"publicMethods": [
		"setKeepAlive"
	]
};

UCF_ClientInterfaces["I"]["InteractiveFormAbap"] = {
	"name": "InteractiveFormAbap",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"Height": {
			"type": "string",
			"defaultValue": null
		},
		"Source": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AutoActivate": {
			"type": "boolean",
			"defaultValue": false
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "BROWSER"
		},
		"XmlSource": {
			"type": "string",
			"defaultValue": ''
		},
		"PdfSource": {
			"type": "string",
			"defaultValue": ''
		},
		"ReadOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Offline": {
			"type": "boolean",
			"defaultValue": false
		},
		"PdfOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"HighlightOnError": {
			"type": "string",
			"defaultValue": ''
		},
		"XmlData": {
			"type": "string",
			"defaultValue": ''
		},
		"LegacyAttachmentSupport": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Submit": {},
		"ValueHelp": {},
		"DataChange": {},
		"Error": {}
	},
	"publicMethods": [
		"setKeepAlive",
		"setFocusInternal"
	]
};

UCF_ClientInterfaces["I"]["ActiveXContainer"] = {
	"name": "ActiveXContainer",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"Height": {
			"type": "string",
			"defaultValue": null
		},
		"MinHeight": {
			"type": "string",
			"defaultValue": null
		},
		"ClassId": {
			"type": "string",
			"defaultValue": null
		},
		"CodeBase": {
			"type": "string",
			"defaultValue": ''
		},
		"CodeType": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AutoActivate": {
			"type": "boolean",
			"defaultValue": false
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "BROWSER"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Parameters": {
			"type": "UCF_ClientInterfaces.I.ActiveXContainerParameter",
			"multiple": true,
			"singularName": "Parameter"
		},
		"Adapter": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"setKeepAlive"
	]
};

UCF_ClientInterfaces["I"]["ActiveXContainerParameter"] = {
	"name": "ActiveXContainerParameter",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"Value": {
			"type": "string",
			"defaultValue": null
		}
	}
};

UCF_ClientInterfaces["I"]["Animation"] = {
	"name": "Animation",
	"properties": {
		"ControlId": {
			"type": "string",
			"defaultValue": ''
		},
		"Duration": {
			"type": "number",
			"defaultValue": 300
		}
	},
	"aggregations": {
		"Triggers": {
			"type": "UCF_ClientInterfaces.I.AnimTrigger",
			"multiple": true,
			"singularName": "Trigger"
		},
		"Steps": {
			"type": "UCF_ClientInterfaces.I.AnimStep",
			"multiple": true,
			"singularName": "Step"
		}
	},
	"publicMethods": [
		"play"
	]
};

UCF_ClientInterfaces["I"]["AnimStep"] = {
	"name": "AnimStep",
	"properties": {
		"Phase": {
			"type": "UCF_ClientInterfaces.E.AnimPhase",
			"defaultValue": "TRIGGER"
		},
		"Attribute": {
			"type": "UCF_ClientInterfaces.E.AnimAttribute",
			"defaultValue": "OPACITY"
		},
		"StartValue": {
			"type": "number",
			"defaultValue": 0
		},
		"EndValue": {
			"type": "number",
			"defaultValue": 0
		},
		"InitialValue": {
			"type": "number",
			"defaultValue": 0
		},
		"FinalValue": {
			"type": "number",
			"defaultValue": 0
		},
		"Function": {
			"type": "UCF_ClientInterfaces.E.AnimFunction",
			"defaultValue": "LINEAR"
		}
	}
};

UCF_ClientInterfaces["I"]["AnimTrigger"] = {
	"name": "AnimTrigger",
	"properties": {
		"EventType": {
			"type": "UCF_ClientInterfaces.E.AnimEventType",
			"defaultValue": "SEMANTIC"
		},
		"EventName": {
			"type": "string",
			"defaultValue": ''
		},
		"SourceControlId": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["AppletContainer"] = {
	"name": "AppletContainer",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"Height": {
			"type": "string",
			"defaultValue": null
		},
		"MinHeight": {
			"type": "string",
			"defaultValue": null
		},
		"JavaClass": {
			"type": "string",
			"defaultValue": null
		},
		"Library": {
			"type": "string",
			"defaultValue": null
		},
		"AppletJavaVersion": {
			"type": "UCF_ClientInterfaces.E.AppletContainerJavaVersion",
			"defaultValue": "BROWSER"
		},
		"CodeBase": {
			"type": "string",
			"defaultValue": ''
		},
		"Scriptable": {
			"type": "boolean",
			"defaultValue": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AutoActivate": {
			"type": "boolean",
			"defaultValue": false
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "BROWSER"
		},
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Parameters": {
			"type": "UCF_ClientInterfaces.I.AppletContainerParameter",
			"multiple": true,
			"singularName": "Parameter"
		},
		"Adapter": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"setKeepAlive"
	]
};

UCF_ClientInterfaces["I"]["AppletContainerParameter"] = {
	"name": "AppletContainerParameter",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"Value": {
			"type": "string",
			"defaultValue": null
		}
	}
};

UCF_ClientInterfaces["I"]["AriaStatic"] = {
	"name": "AriaStatic"
};

UCF_ClientInterfaces["I"]["BarcodeReader"] = {
	"name": "BarcodeReader",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": '300px'
		},
		"Width": {
			"type": "string",
			"defaultValue": '400px'
		},
		"ImageUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"ReaderUrl": {
			"type": "string",
			"defaultValue": null
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Barcode": {},
		"Error": {}
	}
};

UCF_ClientInterfaces["I"]["Attribute"] = {
	"name": "Attribute",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["Decorator"] = {
	"name": "Decorator",
	"properties": {
		"Position": {
			"type": "UCF_ClientInterfaces.E.DecoratorPosition",
			"defaultValue": "TOP_LEFT"
		},
		"IconSrc": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["FeatureFlags"] = {
	"name": "FeatureFlags"
};

UCF_ClientInterfaces["I"]["FormInputField"] = {
	"name": "FormInputField",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"Value": {
			"type": "string",
			"defaultValue": null
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.FormInputFieldType",
			"defaultValue": "HIDDEN"
		}
	}
};

UCF_ClientInterfaces["I"]["GeneratorTest"] = {
	"name": "GeneratorTest",
	"properties": {
		"StringParam": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"ControlName": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		}
	},
	"aggregations": {
		"List": {
			"type": "UCF_ClientInterfaces.I.GeneratorTest",
			"multiple": true,
			"singularName": "List",
			"deprecated": true
		}
	},
	"events": {
		"TestEvent": {}
	},
	"publicMethods": [
		"test",
		"getTestPropertyWithReturn"
	]
};

UCF_ClientInterfaces["I"]["IconBase"] = {
	"name": "IconBase"
};

UCF_ClientInterfaces["I"]["Property"] = {
	"name": "Property",
	"properties": {
		"Key": {
			"type": "string",
			"defaultValue": ''
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["System"] = {
	"name": "System",
	"properties": {
		"Is508": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsRTL": {
			"type": "boolean",
			"defaultValue": false
		},
		"Device": {
			"type": "string",
			"defaultValue": 'ie6'
		},
		"Language": {
			"type": "string",
			"defaultValue": 'en'
		},
		"FirstDayOfWeek": {
			"type": "number",
			"defaultValue": 0
		},
		"MinimalDaysInFirstWeek": {
			"type": "number",
			"defaultValue": 4
		},
		"IsDesigntime": {
			"type": "boolean",
			"defaultValue": false
		},
		"ServerDebug": {
			"type": "boolean",
			"defaultValue": false
		},
		"ClientDebug": {
			"type": "boolean",
			"defaultValue": false
		},
		"ExternalThemeRoot": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"ThemepartID": {
			"type": "string",
			"defaultValue": 'ls',
			"deprecated": true
		},
		"InlineCSS": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"CSSURL": {
			"type": "string",
			"defaultValue": ''
		},
		"ResourceRoot": {
			"type": "string",
			"defaultValue": '.'
		},
		"SpaceGif": {
			"type": "string",
			"defaultValue": null,
			"deprecated": true
		},
		"LoadOnDemand": {
			"type": "boolean",
			"defaultValue": true
		},
		"UseAnimation": {
			"type": "boolean",
			"defaultValue": true
		},
		"UseActiveX": {
			"type": "boolean",
			"defaultValue": true
		},
		"SuppressCustomJavaScript": {
			"type": "boolean",
			"defaultValue": false
		},
		"SuppressCustomHTML": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsUCF": {
			"type": "boolean",
			"defaultValue": false
		},
		"Platform": {
			"type": "string",
			"defaultValue": 'Windows'
		},
		"ClientVersionKey": {
			"type": "string",
			"defaultValue": ''
		},
		"UserAgentName": {
			"type": "string",
			"defaultValue": 'MSIE'
		},
		"UserAgentVersion": {
			"type": "number",
			"defaultValue": 0
		},
		"UseSafeTransportEncoding": {
			"type": "boolean",
			"defaultValue": true
		},
		"UseXHR": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"Accessibility": {
			"type": "string",
			"defaultValue": 'NONE'
		},
		"Embedding": {
			"type": "string",
			"defaultValue": 'AUTO',
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"ThemeID": {
			"type": "string",
			"defaultValue": null
		},
		"ThemeFileName": {
			"type": "string",
			"defaultValue": ''
		},
		"ThemeRepositoryURL": {
			"type": "string",
			"defaultValue": ''
		},
		"ThemeRepositoryURLAppendix": {
			"type": "string",
			"defaultValue": ''
		},
		"ThemeRequiredVersion": {
			"type": "string",
			"defaultValue": ''
		},
		"ThemeFallbackRepositoryURL": {
			"type": "string",
			"defaultValue": ''
		},
		"ThemeFallbackID": {
			"type": "string",
			"defaultValue": ''
		},
		"ThemeFallbackCSSURL": {
			"type": "string",
			"defaultValue": ''
		},
		"DataTypeFormats": {
			"type": "string",
			"defaultValue": ''
		},
		"RuntimeVersion": {
			"type": "string",
			"defaultValue": ''
		},
		"EnableClientSideTesting": {
			"type": "boolean",
			"defaultValue": false
		},
		"BaseURL": {
			"type": "string",
			"defaultValue": ''
		},
		"WeekendDays": {
			"type": "string",
			"defaultValue": '[0,6]'
		},
		"SetDirtyForRoundtrips": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsRemoteDesktop": {
			"type": "boolean",
			"defaultValue": false
		},
		"UseFocusColor": {
			"type": "boolean",
			"defaultValue": false
		},
		"DebugLevel": {
			"type": "UCF_ClientInterfaces.E.DebugLevel",
			"defaultValue": "OFF"
		},
		"FeatureChannel": {
			"type": "UCF_ClientInterfaces.E.FeatureChannel",
			"defaultValue": "STABLE"
		},
		"FeatureFlags": {
			"type": "string",
			"defaultValue": ''
		},
		"BrowserName": {
			"type": "string",
			"defaultValue": ''
		},
		"BrowserVersion": {
			"type": "string",
			"defaultValue": ''
		},
		"Nonce": {
			"type": "string",
			"defaultValue": ''
		},
		"SubmitMethod": {
			"type": "UCF_ClientInterfaces.E.SubmitMethod",
			"defaultValue": "FORM"
		},
		"InteractionType": {
			"type": "UCF_ClientInterfaces.E.InteractionType",
			"defaultValue": "KEYBOARD"
		},
		"SupportedSapThemeIDs": {
			"type": "string",
			"defaultValue": 'null'
		},
		"DefaultClientAction": {
			"type": "UCF_ClientInterfaces.E.ClientAction",
			"defaultValue": "ENQUEUE"
		},
		"DefaultResponseData": {
			"type": "UCF_ClientInterfaces.E.ResponseData",
			"defaultValue": "INHERIT"
		},
		"UTCOffset": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Properties": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "Propertie",
			"deprecated": true
		}
	}
};

UCF_ClientInterfaces["I"]["UrBase"] = {
	"name": "UrBase",
	"properties": {
		"ControlName": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["BiApplicationFrame"] = {
	"name": "BiApplicationFrame",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"Url": {
			"type": "string",
			"defaultValue": ''
		},
		"HasBorder": {
			"type": "boolean",
			"defaultValue": false
		},
		"Scrolling": {
			"type": "UCF_ClientInterfaces.E.IframeScrolling",
			"defaultValue": "NO"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "BROWSER"
		},
		"PostParameters": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Load": {}
	},
	"publicMethods": [
		"setKeepAlive",
		"request"
	]
};

UCF_ClientInterfaces["I"]["BIReportCellStyle"] = {
	"name": "BIReportCellStyle",
	"properties": {
		"BackgroundColor": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingLead": {
			"type": "number",
			"defaultValue": -1
		},
		"PaddingTrail": {
			"type": "number",
			"defaultValue": -1
		},
		"PaddingTop": {
			"type": "number",
			"defaultValue": -1
		},
		"PaddingBottom": {
			"type": "number",
			"defaultValue": -1
		},
		"BorderStyleLead": {
			"type": "UCF_ClientInterfaces.E.BorderStyle",
			"defaultValue": "PREDEFINED"
		},
		"BorderStyleTrail": {
			"type": "UCF_ClientInterfaces.E.BorderStyle",
			"defaultValue": "PREDEFINED"
		},
		"BorderStyleTop": {
			"type": "UCF_ClientInterfaces.E.BorderStyle",
			"defaultValue": "PREDEFINED"
		},
		"BorderStyleBottom": {
			"type": "UCF_ClientInterfaces.E.BorderStyle",
			"defaultValue": "PREDEFINED"
		},
		"BorderColorLead": {
			"type": "string",
			"defaultValue": ''
		},
		"BorderColorTrail": {
			"type": "string",
			"defaultValue": ''
		},
		"BorderColorTop": {
			"type": "string",
			"defaultValue": ''
		},
		"BorderColorBottom": {
			"type": "string",
			"defaultValue": ''
		},
		"BorderWidthLead": {
			"type": "number",
			"defaultValue": -1
		},
		"BorderWidthTrail": {
			"type": "number",
			"defaultValue": -1
		},
		"BorderWidthTop": {
			"type": "number",
			"defaultValue": -1
		},
		"BorderWidthBottom": {
			"type": "number",
			"defaultValue": -1
		}
	}
};

UCF_ClientInterfaces["I"]["BIReportStyles"] = {
	"name": "BIReportStyles",
	"aggregations": {
		"CellStyles": {
			"type": "UCF_ClientInterfaces.I.BIReportCellStyle",
			"multiple": true,
			"singularName": "CellStyle"
		},
		"TextStyles": {
			"type": "UCF_ClientInterfaces.I.BIReportTextStyle",
			"multiple": true,
			"singularName": "TextStyle"
		}
	}
};

UCF_ClientInterfaces["I"]["BIReportTextStyle"] = {
	"name": "BIReportTextStyle",
	"properties": {
		"FontFamily": {
			"type": "string",
			"defaultValue": ''
		},
		"FontSize": {
			"type": "number",
			"defaultValue": -1
		},
		"FontSizeUnit": {
			"type": "UCF_ClientInterfaces.E.FontSizeUnit",
			"defaultValue": "PT"
		},
		"TextColor": {
			"type": "string",
			"defaultValue": ''
		},
		"BackgroundColor": {
			"type": "string",
			"defaultValue": ''
		},
		"FontWeight": {
			"type": "UCF_ClientInterfaces.E.FontWeight",
			"defaultValue": "PREDEFINED"
		},
		"FontStyle": {
			"type": "UCF_ClientInterfaces.E.FontStyle",
			"defaultValue": "PREDEFINED"
		},
		"TextDecoration": {
			"type": "UCF_ClientInterfaces.E.TextDecoration",
			"defaultValue": "PREDEFINED"
		},
		"TextWrapping": {
			"type": "UCF_ClientInterfaces.E.TextWrapping",
			"defaultValue": "PREDEFINED"
		}
	}
};

UCF_ClientInterfaces["I"]["BreadCrumb"] = {
	"name": "BreadCrumb",
	"properties": {
		"Behavior": {
			"type": "UCF_ClientInterfaces.E.BreadCrumbBehavior",
			"defaultValue": "DEFAULT"
		},
		"Size": {
			"type": "UCF_ClientInterfaces.E.BreadCrumbSize",
			"defaultValue": "MEDIUM"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageSeparatorSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"MirrorImageSeparator": {
			"type": "boolean",
			"defaultValue": false
		},
		"SeparatorText": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"ItemOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.BreadCrumbItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {},
		"Activate": {}
	}
};

UCF_ClientInterfaces["I"]["BreadCrumbItem"] = {
	"name": "BreadCrumbItem",
	"properties": {
		"Value": {
			"type": "string",
			"defaultValue": ''
		},
		"Selected": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["Button"] = {
	"name": "Button",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.ButtonDesign",
			"defaultValue": "STANDARD"
		},
		"Size": {
			"type": "UCF_ClientInterfaces.E.ButtonSize",
			"defaultValue": "DEFAULT",
			"deprecated": true
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasButtonCaption": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"Down": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasIcon": {
			"type": "boolean",
			"defaultValue": false
		},
		"DisabledIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"UpIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"DownIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"HasPopupMenu": {
			"type": "boolean",
			"defaultValue": false
		},
		"PopupMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"HasPopupMenuSection": {
			"type": "boolean",
			"defaultValue": false
		},
		"ImageFirst": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageAlt": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"Hotkey": {
			"type": "UCF_ClientInterfaces.E.HotkeyValue",
			"defaultValue": "NONE"
		},
		"Up": {
			"type": "boolean",
			"defaultValue": false
		},
		"HAlign": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "CENTER"
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"FixedHeight": {
			"type": "boolean",
			"defaultValue": false
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.ButtonType",
			"defaultValue": "NONE"
		},
		"DragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentPadding": {
			"type": "number",
			"defaultValue": -1,
			"deprecated": true
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"InteractionBehaviour": {
			"type": "UCF_ClientInterfaces.E.ButtonInteractionBehaviour",
			"defaultValue": "PUSH"
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": false
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentVisibility": {
			"type": "UCF_ClientInterfaces.E.ContentVisibility",
			"defaultValue": "ALL"
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"DescribedBy": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"ButtonCaption": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": false,
			"deprecated": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Press": {},
		"MenuAccess": {},
		"DoubleClick": {},
		"Change": {}
	},
	"publicMethods": [
		"openMenu",
		"setEnabled",
		"getEnabled",
		"setPopupMenuId",
		"sGetPopupMenuId",
		"setSemanticColor",
		"getSemanticColor",
		"setUpIconSrc",
		"getUpIconSrc",
		"setTooltip",
		"getTooltip",
		"setDown",
		"getDown",
		"setText",
		"getText",
		"setVisibility",
		"getVisibility"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urBdyStd,font-family)",
				"docu": "Defines the font family for all button states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "@fontColor || contrast(@backgroundColor)",
				"defaultValue": "ruleValue(.urBtnStd,color)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"defaultValue": "ruleValue(.urBtnStd,font-weight)"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urBtnStd,font-size)"
			},
			{
				"name": "fontStyle",
				"property": "font-style"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"defaultValue": "ruleValue(.urBtnStd,text-decoration)"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"expression": "@backgroundColor",
				"defaultValue": "ruleValue(.urBtnStd,background-color)"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "borderRadius",
				"property": "border-radius",
				"defaultValue": "ruleValue(.urBtnRadius,border-radius)"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urBtnStd:hover,background-color)"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urBtnStd:hover,color)"
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "hoverBorderStyle",
				"property": "border-style",
				"expression": "@borderStyle || @hoverBorderStyle",
				"docu": "Defines the border-style."
			},
			{
				"name": "hoverBorderWidth",
				"property": "border-width",
				"expression": "@borderWidth || @hoverBorderWidth",
				"docu": "Defines the border-width."
			},
			{
				"name": "selectedBackgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urBtnStd:hover,background-color)"
			},
			{
				"name": "selectedFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urBtnStd:hover,color)"
			},
			{
				"name": "selectedBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "selectedBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "selectedBorderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "disabledOpacity",
				"property": "opacity",
				"docu": "Defines the opacity for disabled buttons."
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urBtnStdDsbl,background-color)"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urBtnStdDsbl,color)"
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "disabledBorderStyle",
				"property": "border-style",
				"expression": "@disabledBorderStyle || @borderStyle",
				"docu": "Defines the border-style."
			},
			{
				"name": "disabledBorderWidth",
				"property": "border-width",
				"expression": "@borderWidth || @disabledBorderWidth",
				"docu": "Defines the border-width."
			},
			{
				"name": "emphasizedFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urBtnEmph,color)",
				"docu": "Defines the font color"
			},
			{
				"name": "emphasizedTextShadow",
				"property": "text-shadow",
				"expression": "none || @emphasizedTextShadow",
				"docu": "Defines the text-shadow"
			},
			{
				"name": "emphasizedBackgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urBtnEmph,background-color)"
			},
			{
				"name": "emphasizedBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "emphasizedBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "emphasizedBorderWidth",
				"property": "border-width",
				"expression": "@borderWidth || @emphasizedBorderWidth",
				"docu": "Defines the border-width."
			},
			{
				"name": "emphasizedHoverBackgroundColor",
				"property": "background-color",
				"expression": "@emphasizedHoverBackgroundColor || @emphasizedBackgroundColor"
			},
			{
				"name": "emphasizedHoverBorderColor",
				"property": "border-color",
				"expression": "@emphasizedHoverBorderColor || @emphasizedBorderColor"
			},
			{
				"name": "emphasizedHoverFontColor",
				"property": "color",
				"expression": "@emphasizedHoverFontColor || @emphasizedFontColor"
			},
			{
				"name": "emphasizedSelectedBackgroundColor",
				"property": "background-color",
				"expression": "@emphasizedSelectedBackgroundColor || @emphasizedHoverBackgroundColor"
			},
			{
				"name": "emphasizedSelectedFontColor",
				"property": "color",
				"expression": "@emphasizedSelectedFontColor || @emphasizedHoverFontColor"
			},
			{
				"name": "emphasizedSelectedBorderColor",
				"property": "border-color",
				"expression": "@emphasizedSelectedBorderColor || @emphasizedHoverBorderColor"
			},
			{
				"name": "emphasizedDisabledBackgroundColor",
				"property": "background-color",
				"expression": "@emphasizedDisabledBackgroundColor || @disabledBackgroundColor"
			},
			{
				"name": "emphasizedDisabledFontColor",
				"property": "color",
				"expression": "@emphasizedDisabledFontColor || @disabledFontColor"
			},
			{
				"name": "emphasizedDisabledBorderColor",
				"property": "border-color",
				"expression": "@emphasizedDisabledBorderColor || @disabledBorderColor"
			},
			{
				"name": "nextBackgroundImage",
				"property": "background-image",
				"expression": "contrast(@nextFontColor)",
				"defaultValue": "ruleValue(.lsBtnNextImg,background-image)"
			},
			{
				"name": "nextHoverBackgroundImage",
				"property": "background-image",
				"expression": "contrast(@nextFontColor)",
				"defaultValue": "ruleValue(.lsBtnNextHoverImg,background-image)"
			},
			{
				"name": "prevBackgroundImage",
				"property": "background-image",
				"expression": "contrast(@nextFontColor)",
				"defaultValue": "ruleValue(.lsBtnPrevImg,background-image)"
			},
			{
				"name": "prevHoverBackgroundImage",
				"property": "background-image",
				"expression": "contrast(@nextFontColor)",
				"defaultValue": "ruleValue(.lsBtnPrevHoverImg,background-image)"
			},
			{
				"name": "tglFontColor",
				"property": "color",
				"expression": "@fontColor || @tglFontColor"
			},
			{
				"name": "tglBackgroundColor",
				"property": "background-color",
				"expression": "@backgroundColor || @tglBackgroundColor"
			},
			{
				"name": "tglBorderColor",
				"property": "border-color",
				"expression": "@borderColor || @tglBorderColor"
			},
			{
				"name": "tglHoverFontColor",
				"property": "color",
				"expression": "@hoverFontColor"
			},
			{
				"name": "tglHoverBackgroundColor",
				"property": "background-color",
				"expression": "@hoverBackgroundColor"
			},
			{
				"name": "tglHoverBorderColor",
				"property": "border-color",
				"expression": "@hoverBorderColor"
			},
			{
				"name": "tglDFontColor",
				"property": "color",
				"expression": "@tglDFontColor || @selectedFontColor"
			},
			{
				"name": "tglDBackgroundColor",
				"property": "background-color",
				"expression": "@tglDBackgroundColor || @selectedBackgroundColor"
			},
			{
				"name": "tglDBorderColor",
				"property": "border-color",
				"expression": "@tglDBorderColor || @selectedBorderColor"
			},
			{
				"name": "tglDsblFontColor",
				"property": "color",
				"expression": "@disabledFontColor || @tglDsblFontColor"
			},
			{
				"name": "tglDsblBackgroundColor",
				"property": "background-color",
				"expression": "@disabledBackgroundColor || @tglDsblBackgroundColor"
			},
			{
				"name": "tglDsblBorderColor",
				"property": "border-color",
				"expression": "@disabledBorderColor || @tglDsblBorderColor"
			},
			{
				"name": "buttonFontSize",
				"property": "font-size",
				"defaultValue": "themeValue(.lsButton__metadata,buttonFontSize)",
				"docu": "DO NOT CHANGE THIS!"
			},
			{
				"name": "buttonLineHeight",
				"property": "line-height",
				"defaultValue": "themeValue(.lsButton__metadata,buttonLineHeight)",
				"docu": "DO NOT CHANGE THIS!"
			}
		],
		"classes": {
			'.lsButton,.lsButton--section,.lsButton--hoverable:hover,.lsButton--active:active': {
				"properties": [
					{
						"name": "background-image",
						"expression": "none"
					}
				]
			},
			'.lsButton .lsButton--content-design': {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					}
				]
			},
			'.sapContrast @{CustomStyle}, @{CustomStyle}': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			' .lsButton--content': {
				"properties": [
					{
						"name": "line-height",
						"expression": "~\"calc(@{fontSize} / @{buttonFontSize})\""
					}
				]
			},
			'@{CustomStyle} .lsButton--content': {
				"properties": [
					{
						"name": "line-height",
						"expression": "~\"max(@{buttonLineHeight}, calc(@{fontSize} / @{buttonFontSize}))\""
					}
				]
			},
			'.sapContrast @{CustomStyle} .lsButton--content[style*=\'height:\'] .lsButton--content[style*=\'height:\'], @{CustomStyle} .lsButton--content[style*=\'height:\']': {
				"properties": [
					{
						"name": "line-height",
						"expression": "normal"
					}
				]
			},
			'.lsButton--design-transparent,.lsTbarLarge @{CustomStyle},.lsToolbar__Header @{CustomStyle}.lsButton--design-standard,.lsToolbar__Header @{CustomStyle}.lsButton--design-next,.lsToolbar__Header @{CustomStyle}.lsButton--design-previous': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsTwhlFooter.sapContrast .lsButton--up.lsButton--design-standard@{CustomStyle}, .lsTwhlFooter.sapContrast @{CustomStyle}': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--section': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle @borderStyle @borderStyle none"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "text-decoration",
						"expression": "none"
					}
				]
			},
			'.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--active.lsButton--section:active': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle @borderStyle @borderStyle none"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "text-decoration",
						"expression": "none"
					},
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			' .lsButton__text': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			' .lsControl--monospace.lsButton__text': {
				"properties": [
					{
						"name": "font-family",
						"important": true,
						"expression": "@fontFamily"
					}
				]
			},
			'.lsButton--section': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle @borderStyle @borderStyle none"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "text-decoration",
						"expression": "none"
					}
				]
			},
			'.lsButton--hoverable.lsButton--design-standard:hover,.lsButton--hoverable.lsButton--design-previous:hover,.lsButton--hoverable.lsButton--design-next:hover,.lsButton--hoverable.lsButton--design-transparent:hover, .lsTwhlFooter.sapContrast .lsButton--up.lsButton--design-standard@{CustomStyle}:hover,.lsTwhlFooter.sapContrast .lsButton--up.lsButton--design-next@{CustomStyle}:hover,.lsTwhlFooter.sapContrast .lsButton--up.lsButton--design-previous@{CustomStyle}:hover,.sapContrast .lsBtnTransparent.lsButton--up@{CustomStyle}.lsButton--design-standard:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@hoverBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@hoverBorderWidth"
					}
				]
			},
			'.lsButton--hoverable.lsButton--section:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@hoverBorderStyle @hoverBorderStyle @hoverBorderStyle none"
					},
					{
						"name": "border-width",
						"expression": "@hoverBorderWidth"
					}
				]
			},
			'.lsButton--active.lsButton--design-standard:active,.lsButton--active.lsButton--design-standard.lsButton--menu-push,.lsButton--active.lsButton--menu-push.lsButton--hoverable,.lsButton--active.lsButton--design-next:active,.lsButton--active.lsButton--design-previous:active,.lsButton--active.lsButton--design-transparent:active,.lsTwhlFooter.sapContrast .lsButton--down@{CustomStyle}': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@selectedFontColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@selectedBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@selectedBorderWidth"
					}
				]
			},
			'.lsButton--active.lsButton--section:active,.lsButton--active.lsButton--section-push,.lsButton--active.lsButton--hoverable.lsButton--section-push:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle @borderStyle @borderStyle none"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "text-decoration",
						"expression": "none"
					},
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsButton--disabled': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@disabledFontColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@disabledBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@disabledBorderWidth"
					},
					{
						"name": "opacity",
						"expression": "@disabledOpacity"
					}
				]
			},
			'.lsButton--section-disabled': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@disabledFontColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@disabledBorderWidth"
					},
					{
						"name": "border-style",
						"expression": "@disabledBorderStyle @disabledBorderStyle @disabledBorderStyle none"
					},
					{
						"name": "opacity",
						"expression": "@disabledOpacity"
					}
				]
			},
			'.lsButton--design-emphasized': {
				"properties": [
					{
						"name": "color",
						"expression": "@emphasizedFontColor"
					},
					{
						"name": "background-color",
						"expression": "@emphasizedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@emphasizedBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@emphasizedBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@emphasizedBorderWidth"
					},
					{
						"name": "text-shadow",
						"expression": "@emphasizedTextShadow"
					}
				]
			},
			'.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--design-emphasized': {
				"properties": [
					{
						"name": "color",
						"expression": "@emphasizedFontColor"
					},
					{
						"name": "background-color",
						"expression": "@emphasizedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@emphasizedBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@emphasizedBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@emphasizedBorderWidth"
					},
					{
						"name": "text-shadow",
						"expression": "@emphasizedTextShadow"
					}
				]
			},
			'.lsButton--hoverable.lsButton--design-emphasized:hover, .lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--hoverable.lsButton--design-emphasized:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@emphasizedHoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@emphasizedHoverFontColor"
					},
					{
						"name": "border-color",
						"expression": "@emphasizedHoverBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@emphasizedHoverBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@emphasizedHoverBorderWidth"
					}
				]
			},
			'.lsButton--disabled.lsButton--design-emphasized': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@emphasizedDisabledBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@emphasizedDisabledFontColor"
					},
					{
						"name": "border-color",
						"expression": "@emphasizedDisabledBorderColor"
					}
				]
			},
			'.lsButton--active.lsButton--design-emphasized:active,.lsTwhlFooter.sapContrast .lsButton--down@{CustomStyle}.lsButton--design-emphasized': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@emphasizedSelectedBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@emphasizedSelectedFontColor"
					},
					{
						"name": "border-color",
						"expression": "@emphasizedSelectedBorderColor"
					}
				]
			},
			'.lsButton--design-emphasized .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@emphasizedFontColor"
					}
				]
			},
			'.lsButton--design-emphasized.lsButton--hoverable:hover .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@emphasizedHoverFontColor"
					}
				]
			},
			'.lsButton--design-emphasized.lsButton--active:active .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@emphasizedSelectedFontColor"
					}
				]
			},
			'.lsButton--disabled.lsButton--design-emphasized  .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@emphasizedDisabledFontColor"
					}
				]
			},
			' .lsBtnPrevImg': {
				"properties": [
					{
						"name": "background-image",
						"expression": "@prevBackgroundImage"
					}
				]
			},
			' .lsBtnPrevHoverImg': {
				"properties": [
					{
						"name": "background-image",
						"expression": "@prevHoverBackgroundImage"
					}
				]
			},
			' .lsBtnNextImg': {
				"properties": [
					{
						"name": "background-image",
						"expression": "@nextBackgroundImage"
					}
				]
			},
			' .lsBtnNextHoverImg': {
				"properties": [
					{
						"name": "background-image",
						"expression": "@nextHoverBackgroundImage"
					}
				]
			},
			'.sapContrast @{CustomStyle}.lsButton--design-toggle,.lsButton--design-toggle,.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--up.lsButton--design-toggle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@tglBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@tglFontColor"
					},
					{
						"name": "border-color",
						"expression": "@tglBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.sapContrast @{CustomStyle}.lsButton--hoverable.lsButton--design-toggle:hover,.lsButton--hoverable.lsButton--design-toggle:hover,.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--hoverable.lsButton--design-toggle:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@tglHoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@tglHoverFontColor"
					},
					{
						"name": "border-color",
						"expression": "@tglHoverBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@hoverBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@hoverBorderWidth"
					}
				]
			},
			'.sapContrast @{CustomStyle}.lsButton--active.lsButton--design-toggle:active,.lsButton--down.lsButton--design-toggle,.lsButton--active.lsButton--design-toggle:active, .lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--down.lsButton--design-toggle, .lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--hoverable.lsButton--down.lsButton--design-toggle:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@tglDBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@tglDBorderColor"
					},
					{
						"name": "color",
						"expression": "@tglDFontColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@selectedBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@selectedBorderWidth"
					}
				]
			},
			'.lsButton--disabled.lsButton--design-toggle': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@tglDsblBackgroundColor"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@tglDsblBorderColor"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@tglDsblFontColor"
					}
				]
			},
			'.lsToolbar--design-flat .lsButton--flat-over@{CustomStyle}': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					}
				]
			},
			' .urSvgAppIconColorBase,.sapContrast @{CustomStyle} .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'.lsButton--hoverable:hover .urSvgAppIconColorBase,.sapContrast @{CustomStyle}.lsButton--hoverable:hover .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsButton--active:active .urSvgAppIconColorBase,.sapContrast @{CustomStyle}.lsButton--active:active .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@selectedFontColor"
					}
				]
			},
			' .lsFontIcon,.sapContrast @{CustomStyle} .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsButton--hoverable:hover .lsFontIcon,.sapContrast @{CustomStyle}.lsButton--hoverable:hover .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsButton--active:active .lsFontIcon,.sapContrast @{CustomStyle}.lsButton--active:active .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsButton--disabled .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsButton--disabled .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemtext': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemhotkey': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active)': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active) .lsHierarchicalview__itemhotkey': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active) .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView.lsHierarchicalview__item--isactive:active,.lsHierarchicalview @{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView.lsHierarchicalview__item--active': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					},
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView.lsHierarchicalview__item--isactive:active>td': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView.lsHierarchicalview__item--active:active .lsHierarchicalview__itemhotkey': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView.lsHierarchicalview__item--active:active .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@selectedFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["DefaultButton"] = {
	"name": "DefaultButton",
	"events": {
		"Create": {}
	}
};

UCF_ClientInterfaces["I"]["ButtonRow"] = {
	"name": "ButtonRow",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.ButtonRowType",
			"defaultValue": "NONE"
		}
	},
	"aggregations": {
		"Buttons": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Button",
			"bindable": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["CalendarCell"] = {
	"name": "CalendarCell",
	"properties": {
		"Semantic": {
			"type": "UCF_ClientInterfaces.E.CalendarCellSemantic",
			"defaultValue": "WORK"
		},
		"Today": {
			"type": "boolean",
			"defaultValue": false
		},
		"PublicHoliday": {
			"type": "boolean",
			"defaultValue": false
		},
		"PublicHolidayText": {
			"type": "string",
			"defaultValue": ''
		},
		"Clickable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Selected": {
			"type": "boolean",
			"defaultValue": false
		},
		"MoreIndicator": {
			"type": "boolean",
			"defaultValue": false
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"DisabledText": {
			"type": "boolean",
			"defaultValue": false
		},
		"Month": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["CalendarColumn"] = {
	"name": "CalendarColumn",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": null
		},
		"Today": {
			"type": "boolean",
			"defaultValue": false
		},
		"Clickable": {
			"type": "boolean",
			"defaultValue": false
		}
	}
};

UCF_ClientInterfaces["I"]["CalendarDayView"] = {
	"name": "CalendarDayView",
	"properties": {
		"Scrollable": {
			"type": "boolean",
			"defaultValue": true
		},
		"ScrollHeight": {
			"type": "string",
			"defaultValue": '400px'
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"TimeColumnTitle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Entries": {
			"type": "UCF_ClientInterfaces.I.CalendarEntry",
			"multiple": true,
			"singularName": "Entrie"
		},
		"FixedRow": {
			"type": "UCF_ClientInterfaces.I.CalendarRow",
			"multiple": false
		},
		"Rows": {
			"type": "UCF_ClientInterfaces.I.CalendarRow",
			"multiple": true,
			"singularName": "Row"
		},
		"Cols": {
			"type": "UCF_ClientInterfaces.I.CalendarColumn",
			"multiple": true,
			"singularName": "Col"
		},
		"Legend": {
			"type": "UCF_ClientInterfaces.I.Legend",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"CellSelect": {},
		"CellSelectMore": {},
		"HeaderSelect": {},
		"Scroll": {}
	}
};

UCF_ClientInterfaces["I"]["CalendarEntry"] = {
	"name": "CalendarEntry",
	"properties": {
		"StartRow": {
			"type": "number",
			"defaultValue": 0
		},
		"StartColumn": {
			"type": "number",
			"defaultValue": 0
		},
		"Duration": {
			"type": "number",
			"defaultValue": 0
		},
		"FullDay": {
			"type": "boolean",
			"defaultValue": false
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"AdditionalText": {
			"type": "string",
			"defaultValue": ''
		},
		"AdditionalTextClickable": {
			"type": "boolean",
			"defaultValue": false
		},
		"StartDateText": {
			"type": "string",
			"defaultValue": ''
		},
		"EndDateText": {
			"type": "string",
			"defaultValue": ''
		},
		"StartTimeText": {
			"type": "string",
			"defaultValue": ''
		},
		"EndTimeText": {
			"type": "string",
			"defaultValue": ''
		},
		"StartsBeforeView": {
			"type": "boolean",
			"defaultValue": false
		},
		"EndsAfterView": {
			"type": "boolean",
			"defaultValue": false
		},
		"DurationText": {
			"type": "string",
			"defaultValue": ''
		},
		"Selected": {
			"type": "boolean",
			"defaultValue": false
		},
		"Selectable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Reoccuring": {
			"type": "boolean",
			"defaultValue": false
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"Striped": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Select": {},
		"AdditionalTextActivate": {}
	}
};

UCF_ClientInterfaces["I"]["CalendarMonthView"] = {
	"name": "CalendarMonthView",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Entries": {
			"type": "UCF_ClientInterfaces.I.CalendarEntry",
			"multiple": true,
			"singularName": "Entrie"
		},
		"Rows": {
			"type": "UCF_ClientInterfaces.I.CalendarRow",
			"multiple": true,
			"singularName": "Row"
		},
		"Cols": {
			"type": "UCF_ClientInterfaces.I.CalendarColumn",
			"multiple": true,
			"singularName": "Col"
		},
		"Legend": {
			"type": "UCF_ClientInterfaces.I.Legend",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"CellSelect": {},
		"CellSelectMore": {},
		"HeaderSelect": {}
	}
};

UCF_ClientInterfaces["I"]["CalendarRow"] = {
	"name": "CalendarRow",
	"properties": {
		"HasSeparator": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"RowHeader": {
			"type": "UCF_ClientInterfaces.I.CalendarRowHeader",
			"multiple": false
		},
		"Cells": {
			"type": "UCF_ClientInterfaces.I.CalendarCell",
			"multiple": true,
			"singularName": "Cell"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["CalendarRowHeader"] = {
	"name": "CalendarRowHeader",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"SubText": {
			"type": "string",
			"defaultValue": ''
		},
		"IconUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"HasChildRows": {
			"type": "boolean",
			"defaultValue": false
		},
		"Expanded": {
			"type": "boolean",
			"defaultValue": false
		},
		"Expandable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Level": {
			"type": "number",
			"defaultValue": 0
		},
		"Clickable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Selected": {
			"type": "boolean",
			"defaultValue": false
		}
	}
};

UCF_ClientInterfaces["I"]["CalendarYearView"] = {
	"name": "CalendarYearView",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"MonthColumnTitle": {
			"type": "string",
			"defaultValue": ''
		},
		"MonthColumnWidth": {
			"type": "number",
			"defaultValue": 120
		},
		"IsHierarchical": {
			"type": "boolean",
			"defaultValue": false
		},
		"TodaysDay": {
			"type": "number",
			"defaultValue": 0
		},
		"Scrollable": {
			"type": "boolean",
			"defaultValue": true
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Entries": {
			"type": "UCF_ClientInterfaces.I.CalendarEntry",
			"multiple": true,
			"singularName": "Entrie"
		},
		"Rows": {
			"type": "UCF_ClientInterfaces.I.CalendarRow",
			"multiple": true,
			"singularName": "Row"
		},
		"Legend": {
			"type": "UCF_ClientInterfaces.I.Legend",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"CellSelect": {},
		"CellMoreSelect": {},
		"HeaderSelect": {},
		"HeaderToggle": {},
		"Scroll": {}
	}
};

UCF_ClientInterfaces["I"]["Caption"] = {
	"name": "Caption",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageFirst": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageAlt": {
			"type": "string",
			"defaultValue": ''
		},
		"IsNested": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"IsDragHandle": {
			"type": "boolean",
			"defaultValue": false
		},
		"HoverImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"Editable": {
			"type": "boolean",
			"defaultValue": false
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.CaptionDesign",
			"defaultValue": "STANDARD"
		},
		"HandleLineBreaks": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		}
	},
	"associations": {
		"DragSourceInfo": {
			"type": "string"
		}
	},
	"events": {
		"Change": {}
	},
	"publicMethods": [
		"setDragSourceInfo"
	]
};

UCF_ClientInterfaces["I"]["Carousel"] = {
	"name": "Carousel",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"NavigationPlacement": {
			"type": "UCF_ClientInterfaces.E.CarouselNavigationPlacement",
			"defaultValue": "CONTENT"
		},
		"Pagination": {
			"type": "UCF_ClientInterfaces.E.CarouselPagination",
			"defaultValue": "ADAPT_TO_ITEMS"
		},
		"FirstVisible": {
			"type": "number",
			"defaultValue": 0
		},
		"Alignment": {
			"type": "UCF_ClientInterfaces.E.CarouselAlignment",
			"defaultValue": "HORIZONTAL"
		},
		"DisplayItems": {
			"type": "UCF_ClientInterfaces.E.CarouselDisplayItems",
			"defaultValue": "MULTIPLE"
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Item",
			"bindable": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Scroll": {}
	}
};

UCF_ClientInterfaces["I"]["Chart"] = {
	"name": "Chart",
	"properties": {
		"Type": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": '800px'
		},
		"Height": {
			"type": "string",
			"defaultValue": '400px'
		},
		"DataString": {
			"type": "string",
			"defaultValue": ''
		},
		"DataFeedingString": {
			"type": "string",
			"defaultValue": ''
		},
		"OptionsString": {
			"type": "string",
			"defaultValue": ''
		},
		"SelectionString": {
			"type": "string",
			"defaultValue": ''
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "MANUAL"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Scripts": {
			"type": "UCF_ClientInterfaces.I.Script",
			"multiple": true,
			"singularName": "Script"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"SelectData": {},
		"DeselectData": {}
	},
	"publicMethods": [
		"setData",
		"setType",
		"setKeepAlive"
	]
};

UCF_ClientInterfaces["I"]["VizFrame"] = {
	"name": "VizFrame",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": '800px'
		},
		"Height": {
			"type": "string",
			"defaultValue": '400px'
		},
		"Type": {
			"type": "string",
			"defaultValue": ''
		},
		"Data": {
			"type": "string",
			"defaultValue": ''
		},
		"DataSet": {
			"type": "string",
			"defaultValue": ''
		},
		"FeedItems": {
			"type": "string",
			"defaultValue": ''
		},
		"Properties": {
			"type": "string",
			"defaultValue": ''
		},
		"Scales": {
			"type": "string",
			"defaultValue": ''
		},
		"Selection": {
			"type": "string",
			"defaultValue": ''
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "MANUAL"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Scripts": {
			"type": "UCF_ClientInterfaces.I.Script",
			"multiple": true,
			"singularName": "Script"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {},
		"Deselect": {}
	},
	"publicMethods": [
		"setKeepAlive"
	]
};

UCF_ClientInterfaces["I"]["CheckBox"] = {
	"name": "CheckBox",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Checked": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"IsTextTitle": {
			"type": "boolean",
			"defaultValue": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowAccessKey": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageAlt": {
			"type": "string",
			"defaultValue": ''
		},
		"Arrangement": {
			"type": "UCF_ClientInterfaces.E.CheckBoxArrangement",
			"defaultValue": "CHECKBOXFIRST"
		},
		"HasSpacing": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"AssociatedEditContext": {
			"type": "UCF_ClientInterfaces.E.EditContext",
			"defaultValue": "PARENTEDITABLE"
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.CheckBoxTextDesign",
			"defaultValue": "STANDARD"
		},
		"UsedInSapTable": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"TextWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"IsTextLabel": {
			"type": "boolean",
			"defaultValue": false
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalSpacing": {
			"type": "UCF_ClientInterfaces.E.Spacing",
			"defaultValue": "ALIGNED"
		}
	},
	"aggregations": {
		"LabelContent": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Change": {},
		"DoubleClick": {},
		"Enter": {}
	},
	"publicMethods": [
		"setValue",
		"getValue",
		"setEnabled",
		"getEnabled",
		"setValueState",
		"getValueState",
		"setEditable",
		"getEditable",
		"createDataTip"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urCWhl,font-family)",
				"docu": "Defines the font family for all CheckBox states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urCLbl,color)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urCWhl,font-size)",
				"docu": "Defines the font size e.g. px, em"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style e.g. italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration e.g. underline"
			},
			{
				"name": "textShadow",
				"property": "text-shadow",
				"docu": "Defines the text shadow"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color of the checkBox icon"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "selectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked CheckBox icon"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color of the checkBox icon"
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "hoverSelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked CheckBox icon"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"docu": "Defines the font color on mouse over"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urCLbllDsbl,color)",
				"docu": "Sets the color for disabled text"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color of the checkBox icon"
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "disabledSelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked CheckBox icon"
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urCLblRo,color)",
				"docu": "Defines the readonly font color of the CheckBox text"
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color of the checkBox icon"
			},
			{
				"name": "readonlyBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "readonlySelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked CheckBox icon"
			},
			{
				"name": "errorFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urCLblRo,color)",
				"docu": "Defines the readonly font color of the CheckBox text"
			},
			{
				"name": "errorBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color of the checkBox icon"
			},
			{
				"name": "errorBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "errorSelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked CheckBox icon"
			},
			{
				"name": "errorReadOnlyFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urCLblRo,color)",
				"docu": "Defines the readonly font color of the CheckBox text"
			},
			{
				"name": "errorReadOnlyBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color of the checkBox icon"
			},
			{
				"name": "errorReadOnlyBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "errorReadOnlySelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked CheckBox icon"
			},
			{
				"name": "warningFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urCLblRo,color)",
				"docu": "Defines the readonly font color of the CheckBox text"
			},
			{
				"name": "warningBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color of the checkBox icon"
			},
			{
				"name": "warningBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "warningSelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked CheckBox icon"
			},
			{
				"name": "warningReadOnlyFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urCLblRo,color)",
				"docu": "Defines the readonly font color of the CheckBox text"
			},
			{
				"name": "warningReadOnlyBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color of the checkBox icon"
			},
			{
				"name": "warningReadOnlyBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "warningReadOnlySelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked CheckBox icon"
			}
		],
		"classes": {
			'.lsSelector--generic': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsCheckBox--checked:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsCheckBox--checked--error:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsCheckBox--checked--warning:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsCheckBox--unchecked:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsCheckBox--unchecked--error:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsCheckBox--unchecked--warning:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsCheckBox--unchecked::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "height",
						"expression": "@checkBoxHeight"
					},
					{
						"name": "width",
						"expression": "@checkBoxWidth"
					}
				]
			},
			'.lsCheckBox--checked::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					}
				]
			},
			'Dsbl.lsCheckBox--unchecked--disabled::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					}
				]
			},
			'Dsbl.lsCheckBox--checked--disabled::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledSelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					}
				]
			},
			'Ro.lsCheckBox--unchecked--readOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					}
				]
			},
			'Ro.lsCheckBox--checked--readOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					}
				]
			},
			'Ro.lsCheckBox--unchecked--parentReadOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					}
				]
			},
			'Ro.lsCheckBox--checked--parentReadOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					}
				]
			},
			'Warn.lsCheckBox--unchecked--warning::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@warningBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					}
				]
			},
			'Warn.lsCheckBox--checked--warning::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningSelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@warningBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					}
				]
			},
			'Warn.lsCheckBox--unchecked--warning--readOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@warningReadOnlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningReadOnlyBorderColor"
					}
				]
			},
			'WarnRo.lsCheckBox--checked--warning--readOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningReadOnlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@warningReadOnlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningReadOnlyBorderColor"
					}
				]
			},
			'WarnRo.lsCheckBox--unchecked--warning--parentReadOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@warningReadOnlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningReadOnlyBorderColor"
					}
				]
			},
			'WarnRo.lsCheckBox--checked--warning--parentReadOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningReadOnlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@warningReadOnlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningReadOnlyBorderColor"
					}
				]
			},
			'Err.lsCheckBox--unchecked--error::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@errorBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					}
				]
			},
			'Err.lsCheckBox--checked--error::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorSelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@errorBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					}
				]
			},
			'ErrRo.lsCheckBox--unchecked--error--readOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@errorReadOnlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorReadOnlyBorderColor"
					}
				]
			},
			'ErrRo.lsCheckBox--checked--error--readOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorReadOnlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@errorReadOnlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorReadOnlyBorderColor"
					}
				]
			},
			'ErrRo.lsCheckBox--unchecked--error--parentReadOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@errorReadOnlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorReadOnlyBorderColor"
					}
				]
			},
			'ErrRo.lsCheckBox--checked--error--parentReadOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorReadOnlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@errorReadOnlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorReadOnlyBorderColor"
					}
				]
			},
			'.lsCheckBox--unchecked:hover:before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					}
				]
			},
			'.lsCheckBox--checked:hover:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverSelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					}
				]
			},
			'.lsSelector--styleHelper': {
				"properties": [
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-shadow",
						"expression": "@textShadow"
					}
				]
			},
			'Dsbl .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'Ro .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			'Err .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorFontColor"
					}
				]
			},
			'Warn .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningFontColor"
					}
				]
			},
			'ErrRo .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorReadOnlyFontColor"
					}
				]
			},
			'WarnRo .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningReadOnlyFontColor"
					}
				]
			},
			'.lsControl--monospace': {
				"properties": [
					{
						"name": "font-family",
						"important": true,
						"expression": "@fontFamily"
					}
				]
			},
			' .lsCBStdTxt': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "text-shadow",
						"expression": "@textShadow"
					}
				]
			},
			' .lsCBImgStdDef': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					}
				]
			},
			' .lsCBImgStdDefHv:hover,.urCLbl:hover .lsCBImgStdDefHv': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					}
				]
			},
			' .lsCBImgStdDef .lsCBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedColor"
					}
				]
			},
			' .lsCBImgStdDefHv:hover .lsCBImgSel:before,.urCLbl:hover .lsCBImgStdDefHv .lsCBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverSelectedColor"
					}
				]
			},
			' .lsCBImgStdErr': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@errorBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					}
				]
			},
			' .lsCBImgStdErr .lsCBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorSelectedColor"
					}
				]
			},
			'Err .lsCBStdTxt': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorFontColor"
					}
				]
			},
			' .lsCBImgStdInv': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@warningBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					}
				]
			},
			'Inv .lsCBStdTxt': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningFontColor"
					}
				]
			},
			' .lsCBImgStdInv .lsCBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningSelectedColor"
					}
				]
			},
			'Dsbl .lsCBStdTxt': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'Ro .lsCBStdTxt, .lsCBImgStdRO .lsCBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			' .lsCBImgDsbl, .lsCBImgStdDsbl': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					}
				]
			},
			'Dsbl .lsCBImgStdDef .lsCBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledSelectedColor"
					}
				]
			},
			' .lsCBImgStdRO': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					}
				]
			},
			' .lsCBImgStdRO .lsCBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlySelectedColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["CheckBoxGroup"] = {
	"name": "CheckBoxGroup",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"ColumnCount": {
			"type": "number",
			"defaultValue": 1
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ItemHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.CheckBox",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["ClientInspector"] = {
	"name": "ClientInspector",
	"properties": {
		"NotificationTrigger": {
			"type": "UCF_ClientInterfaces.E.NotificationTrigger",
			"defaultValue": "INITIAL"
		},
		"ClientWidth": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ClientHeight": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ScreenWidth": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ScreenHeight": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ScreenOrientation": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"QME": {
			"type": "string",
			"defaultValue": 'OFF',
			"deprecated": true
		},
		"RenderingModeCompatibility": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemeID": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"SapThemeID": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemeScope": {
			"type": "string",
			"defaultValue": ''
		},
		"ThemedTableRowHeight": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedFormLayoutRowHeight": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedScrollbarDimension": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedDocumentBackgroundColor": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedSvgLibs": {
			"type": "string",
			"defaultValue": 'OFF',
			"deprecated": true
		},
		"ThemedSvgLibUrls": {
			"type": "string",
			"defaultValue": '[]'
		},
		"ThemedRasterHeight": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedRasterWidth": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedLayoutPaddingTop": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedLayoutPaddingLeft": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedLayoutPaddingBottom": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedLayoutPaddingRight": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedAbapListRasterHeight": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedAbapListRasterWidth": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedValueHelpHeight": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemedValueHelpWidth": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ThemeTags": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"WordEnabled": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ExcelEnabled": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"FlashEnabled": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"AcrobatEnabled": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"SilverlightEnabled": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"JavaEnabled": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"JavaVersion": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"WebSocketsEnabled": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"DeviceType": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"CssMatchesHtmlVersion": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Platform": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"WindowOpenerExists": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ClientURL": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"DocumentDomain": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"IsTopWindow": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"ParentAccessible": {
			"type": "string",
			"defaultValue": 'OFF'
		},
		"IsHighContrastOsUser": {
			"type": "string",
			"defaultValue": 'OFF'
		}
	},
	"events": {
		"Notify": {}
	}
};

UCF_ClientInterfaces["I"]["ColorPalette"] = {
	"name": "ColorPalette",
	"properties": {
		"DefaultColor": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowDefaultColor": {
			"type": "boolean",
			"defaultValue": false
		},
		"ShowRecentColors": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"Colors": {
			"type": "UCF_ClientInterfaces.I.ColorPaletteItem",
			"multiple": true,
			"singularName": "Color"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"ItemClick": {}
	}
};

UCF_ClientInterfaces["I"]["ColorPaletteItem"] = {
	"name": "ColorPaletteItem",
	"properties": {
		"Value": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["ColorItem"] = {
	"name": "ColorItem",
	"properties": {
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"Selected": {
			"type": "boolean",
			"defaultValue": false
		},
		"Image": {
			"type": "string",
			"defaultValue": ''
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"TextColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Select": {}
	},
	"publicMethods": [
		"setSelected",
		"getSelected",
		"setSemanticColor",
		"getSemanticColor",
		"setImage",
		"getImage",
		"setTextColor",
		"getTextColor"
	]
};

UCF_ClientInterfaces["I"]["ColumnLayout"] = {
	"name": "ColumnLayout",
	"properties": {
		"MajorColumns": {
			"type": "UCF_ClientInterfaces.E.MajorColCount",
			"defaultValue": "THREE"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Rows": {
			"type": "UCF_ClientInterfaces.I.ColumnLayoutRow",
			"multiple": true,
			"singularName": "Row"
		},
		"Sections": {
			"type": "UCF_ClientInterfaces.I.ColumnLayoutSection",
			"multiple": true,
			"singularName": "Section"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Hotkey": {}
	}
};

UCF_ClientInterfaces["I"]["ColumnLayoutCell"] = {
	"name": "ColumnLayoutCell",
	"properties": {
		"SectionId": {
			"type": "string",
			"defaultValue": '1'
		},
		"ColSpan": {
			"type": "number",
			"defaultValue": 1
		},
		"RowSpan": {
			"type": "number",
			"defaultValue": 1
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["ColumnLayoutRow"] = {
	"name": "ColumnLayoutRow",
	"aggregations": {
		"Cells": {
			"type": "UCF_ClientInterfaces.I.ColumnLayoutCell",
			"multiple": true,
			"singularName": "Cell"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["ColumnLayoutSection"] = {
	"name": "ColumnLayoutSection",
	"properties": {
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"ParentSectionId": {
			"type": "string",
			"defaultValue": ''
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"publicMethods": [
		"setDefaultButtonId"
	]
};

UCF_ClientInterfaces["I"]["ComboBox"] = {
	"name": "ComboBox",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"Behavior": {
			"type": "UCF_ClientInterfaces.E.ComboBoxBehavior",
			"defaultValue": "DROPDOWNSELECT"
		},
		"AllowVirtualTyping": {
			"type": "boolean",
			"defaultValue": true
		},
		"Key": {
			"type": "string",
			"defaultValue": ''
		},
		"HasIconColumn": {
			"type": "boolean",
			"defaultValue": false
		},
		"IconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"DisabledIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		},
		"ItemCount": {
			"type": "number",
			"defaultValue": -1
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"ContainerWidthSet": {
			"type": "boolean",
			"defaultValue": false
		},
		"UsedInSapTable": {
			"type": "boolean",
			"defaultValue": false
		},
		"PaddingInSapTable": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelText": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelFor": {
			"type": "string",
			"defaultValue": ''
		},
		"IMEMode": {
			"type": "UCF_ClientInterfaces.E.IMEMode",
			"defaultValue": "AUTO"
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"MaxLength": {
			"type": "number",
			"defaultValue": 0
		},
		"Align": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.InputFieldType",
			"defaultValue": "STRING"
		},
		"ShowHelpButtonAlways": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"SuggestFilter": {
			"type": "UCF_ClientInterfaces.E.SuggestFilterType",
			"defaultValue": "OFF"
		},
		"FieldHelp": {
			"type": "UCF_ClientInterfaces.E.InputFieldFieldHelp",
			"defaultValue": "DEFAULT"
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"ShowRequiredIndicator": {
			"type": "boolean",
			"defaultValue": false
		},
		"DisplayAsText": {
			"type": "boolean",
			"defaultValue": false
		},
		"HideFieldHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"InputPrompt": {
			"type": "string",
			"defaultValue": ''
		},
		"Length": {
			"type": "number",
			"defaultValue": 20
		},
		"ShowHelpButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"SuggestAutoComplete": {
			"type": "boolean",
			"defaultValue": false
		},
		"SuggestFilterCondition": {
			"type": "UCF_ClientInterfaces.E.SuggestFilterCondition",
			"defaultValue": "VALUE1_OR_VALUE2"
		},
		"FieldHelpFloating": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"TextStyle": {
			"type": "UCF_ClientInterfaces.E.InputFieldTextStyle",
			"defaultValue": "NORMAL"
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"EmbeddingBehaviour": {
			"type": "UCF_ClientInterfaces.E.EmbeddingBehaviour",
			"defaultValue": "COMPATIBLE"
		},
		"Hidden": {
			"type": "boolean",
			"defaultValue": false
		},
		"ShowInputLength": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"TextOverflowEllipsis": {
			"type": "boolean",
			"defaultValue": true
		},
		"SapTableFieldDesign": {
			"type": "UCF_ClientInterfaces.E.TableFieldDesign",
			"defaultValue": "NONE"
		},
		"FieldHelpEmbedding": {
			"type": "boolean",
			"defaultValue": false
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowClearButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"TabBehaviour": {
			"type": "UCF_ClientInterfaces.E.TabBehaviour",
			"defaultValue": "STANDARD"
		},
		"DescribedBy": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"ItemListBoxId": {
			"type": "string"
		}
	},
	"events": {
		"ActionItemActivate": {},
		"Change": {},
		"DeleteItem": {},
		"Select": {},
		"Enter": {},
		"ListAccess": {},
		"Validate": {},
		"FieldHelpPress": {},
		"DoubleClick": {},
		"ClipboardTablePaste": {},
		"Activate": {}
	},
	"publicMethods": [
		"setChanged",
		"open",
		"update",
		"setInputState",
		"setCursorPosition",
		"setSelection",
		"iGetSelectionStart",
		"iGetSelectionEnd",
		"setEnabled",
		"getEnabled",
		"setEditable",
		"getEditable",
		"setRequired",
		"getRequired",
		"setValueState",
		"getValueState",
		"getValue",
		"setValue",
		"getText",
		"setText",
		"setItemListBoxId",
		"setSuggestFilterCondition",
		"createDataTip"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for all ComboBox states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size e.g. px, em"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style e.g. italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration e.g. underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "borderRadius",
				"property": "borderRadius",
				"docu": "Defines the broder radius"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"docu": "Defines the disabled background color of the ComboBox"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "contrast(@disabledBackgroundColor)",
				"docu": "Defines the disabled font color of the ComboBox"
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the disabled font color of the ComboBox"
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "background-color",
				"docu": "Defines the readonly background color of the ComboBox"
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"expression": "contrast(@readonlyBackgroundColor)",
				"docu": "Defines the readonly font color of the ComboBox"
			},
			{
				"name": "readonlyBorderColor",
				"property": "border-color",
				"docu": "Defines the readonly border color of the ComboBox"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color"
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color"
			},
			{
				"name": "hoverColor",
				"property": "color",
				"expression": "@fontColor || contrast(@hoverBackgroundColor)"
			},
			{
				"name": "inputFontSize",
				"property": "font-size",
				"defaultValue": "themeValue(.lsField__metadata,inputFontSize)",
				"docu": "DO NOT CHANGE THIS!"
			},
			{
				"name": "inputBackgroundImage",
				"property": "background-image",
				"defaultValue": "themeValue(.lsField__metadata,backgroundImage)",
				"docu": "DO NOT CHANGE THIS!"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "@inputBackgroundImage"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "font-size",
						"expression": "~\"calc(@{fontSize} / @{inputFontSize})\""
					},
					{
						"name": "outline-color",
						"expression": "contrast(@backgroundColor)"
					},
					{
						"name": "outline-offset",
						"expression": "-@borderWidth - 2px"
					}
				]
			},
			' .lsField__input': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			' .lsField__help,.lsField--hasclear:not(.lsField--hashelp) .lsField__clear': {
				"properties": [
					{
						"name": "border-top-right-radius",
						"expression": "@borderRadius - @borderWidth"
					},
					{
						"name": "border-bottom-right-radius",
						"expression": "@borderRadius - @borderWidth"
					}
				]
			},
			' .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly)': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly) .lsField__input': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverColor || @fontColor || contrast(@hoverBackgroundColor)"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly) .lsField__help,.lsField--hover:not(.lsField--readonly)#ls-inputfieldhelpbutton,.lsField--hover:not(.lsField--readonly) .lsField__clear': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@hoverColor || @fontColor || contrast(@hoverBackgroundColor)"
					}
				]
			},
			'.lsField--disabled': {
				"properties": [
					{
						"name": "opacity",
						"expression": "1"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					},
					{
						"name": "outline-color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsField--disabled .lsField__input,.lsField--disabled .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsField--readonly': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "outline-color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			'.lsField--readonly .lsField__input,.lsField--readonly .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ComboBoxListBox"] = {
	"name": "ComboBoxListBox",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"VisibleItems": {
			"type": "number",
			"defaultValue": 10
		},
		"Height": {
			"type": "string",
			"defaultValue": '0'
		},
		"IconVisibility": {
			"type": "UCF_ClientInterfaces.E.ItemListBoxVisibility",
			"defaultValue": "NONE"
		},
		"FirstValueVisibility": {
			"type": "UCF_ClientInterfaces.E.ItemListBoxVisibility",
			"defaultValue": "VISIBLE"
		},
		"SecondValueVisibility": {
			"type": "UCF_ClientInterfaces.E.ItemListBoxVisibility",
			"defaultValue": "NONE"
		},
		"FirstValueTextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"SecondValueTextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"FirstValueAlign": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"SecondValueAlign": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"Available": {
			"type": "boolean",
			"defaultValue": true
		},
		"ServerFilter": {
			"type": "string",
			"defaultValue": ''
		},
		"Complete": {
			"type": "boolean",
			"defaultValue": true
		},
		"Filtered": {
			"type": "boolean",
			"defaultValue": true
		},
		"TableDataDefinition": {
			"type": "string",
			"defaultValue": ''
		},
		"ItemTableData": {
			"type": "string",
			"defaultValue": ''
		},
		"HistoryTableData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"TableDataItemDesign": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"HistoryItems": {
			"type": "UCF_ClientInterfaces.I.ItemListBoxItem",
			"multiple": true,
			"singularName": "HistoryItem"
		},
		"Items": {
			"type": "UCF_ClientInterfaces.I.ItemListBoxItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ActionItems": {
			"type": "UCF_ClientInterfaces.I.ItemListBoxActionItem",
			"multiple": true,
			"singularName": "ActionItem"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for the menu items."
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight, bold"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size in px"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style, italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration, underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"expression": "contrast(@fontColor)",
				"docu": "Defines the background color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "borderRadius",
				"property": "borderRadius",
				"docu": "Defines the border radius of the menu"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"docu": "Defines the hover background color for enabled items"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"docu": "Defines the font color for hovered items"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"expression": "lighten(greyscale(@backgroundColor),30%)",
				"docu": "Defines the disabled background color of the ComboBoxListBox."
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "lighten(greyscale(@fontColor),20%) || greyscale(contrast(@backgroundColor))",
				"docu": "Defines the disabled font color of the ComboBoxListBox."
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "background-color",
				"expression": "lighten(greyscale(@backgroundColor),30%)",
				"docu": "Defines the readonly background color of the ComboBoxListBox."
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"expression": "lighten(greyscale(@fontColor),20%) || lighten(greyscale(@backgroundColor),10%)",
				"docu": "Defines the readonly font color of the ComboBoxListBox."
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					}
				]
			},
			',__root, .lsListbox__items': {
				"properties": [
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			' .lsItemlistbox__content--descriptive, .lsItemlistbox__item--history, .lsItemlistbox__item--group, .lsListbox__value, lsListbox__values': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			' .lsItemlistbox__content, .lsListbox__value': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.lsItemlistbox--disabled .lsItemlistbox__content, .lsItemlistbox__content--disabled,.lsListbox--disabled .lsListbox__value,.lsListbox--disabled .lsListbox__values, .lsListbox__value--disabled': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			},
			' .lsItemlistbox__item:hover .lsItemlistbox__content, .lsListbox__value--hover': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@hoverFontColor"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@hoverBackgroundColor"
					}
				]
			},
			'.lsItemlistbox--readonly,.lsItemlistbox--readonly .lsItemlistbox__content--descriptive,.lsListbox--readonly,.lsListbox--readonly .lsListbox__values--descriptive': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					}
				]
			},
			'.lsItemlistbox--disabled,.lsItemlistbox--readonly .lsItemlistbox__content--descriptive, .lsItemlistbox__content--disabled,.lsListbox--disabled,.lsListbox--disabled .lsListbox__values--descriptive, .lsListbox__value--disabled': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["Container"] = {
	"name": "Container",
	"properties": {
		"VerticalSizing": {
			"type": "UCF_ClientInterfaces.E.Sizing",
			"defaultValue": "PUSH"
		},
		"Locked": {
			"type": "boolean",
			"defaultValue": false
		},
		"Printable": {
			"type": "boolean",
			"defaultValue": true
		},
		"PrintArea": {
			"type": "boolean",
			"defaultValue": false
		},
		"LockedDesign": {
			"type": "UCF_ClientInterfaces.E.LockedDesign",
			"defaultValue": "TRANSPARENT"
		},
		"LockedMessage": {
			"type": "string",
			"defaultValue": ''
		},
		"TransientRendering": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Item",
			"bindable": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"lock",
		"unlock",
		"setLockedDesign",
		"setLockedMessage"
	],
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Background color"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"docu": "Background image"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"docu": "Background size, cover, contain"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"docu": "Background repeating, repeat, no-repeat"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background position X for background image for the content"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background position Y for background image for the content"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize || cover"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat || no-repeat"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ContentArea"] = {
	"name": "ContentArea",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentPadding": {
			"type": "UCF_ClientInterfaces.E.ContentPadding",
			"defaultValue": "STANDARD"
		},
		"PaddingTop": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingRight": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingBottom": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingLeft": {
			"type": "string",
			"defaultValue": ''
		},
		"AreaDesign": {
			"type": "UCF_ClientInterfaces.E.AreaDesign",
			"defaultValue": "PLAIN"
		},
		"BorderDesign": {
			"type": "UCF_ClientInterfaces.E.BorderDesign",
			"defaultValue": "BOX"
		},
		"ScrollingMode": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "NONE"
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ContentToolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Scroll": {}
	},
	"publicMethods": [
		"setVisibility",
		"getVisibility",
		"setDefaultButtonId",
		"getContentHeightPx",
		"getContentWidthPx"
	],
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the content"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "borderRadius",
				"property": "border-radius",
				"docu": "Defines the border-radius for the content"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"docu": "Defines the background-iamge for the content"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background position X for background image for the content"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background position Y for background image for the content"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"docu": "Defines the background repeat for background image for the content"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"docu": "Defines the background site for background image for the content"
			}
		],
		"classes": {
			'@{CustomStyle}': {
				"properties": [
					{
						"name": "background",
						"expression": "@backgroundColor || none"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage || none"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "border-collapse",
						"expression": "separate"
					}
				]
			},
			'@{CustomStyle} .lsContentArea--content, @{CustomStyle} .lsContentArea--toolbar': {
				"properties": [
					{
						"name": "background",
						"expression": "@backgroundColor || none"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage || none"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'@{CustomStyle} .lsToolbar--design-default': {
				"properties": [
					{
						"name": "background",
						"expression": "none"
					},
					{
						"name": "background-color",
						"expression": "transparent"
					},
					{
						"name": "background-image",
						"expression": "none"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ContextualPanel"] = {
	"name": "ContextualPanel",
	"properties": {
		"Expandable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Expanded": {
			"type": "boolean",
			"defaultValue": true
		},
		"Width": {
			"type": "number",
			"defaultValue": 220
		},
		"HasPersonalizeLink": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasHelpLink": {
			"type": "boolean",
			"defaultValue": false
		},
		"Label": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Item",
			"bindable": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Expand": {},
		"Collapse": {},
		"Help": {},
		"Personalize": {}
	}
};

UCF_ClientInterfaces["I"]["CSSGrid"] = {
	"name": "CSSGrid",
	"properties": {
		"RelativeTo": {
			"type": "UCF_ClientInterfaces.E.CSSGridRelativeTo",
			"defaultValue": "VIEWPORT"
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Width": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "Width"
		},
		"Height": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "Height"
		},
		"Grid": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "Grid"
		},
		"GridTemplate": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridTemplate"
		},
		"GridTemplateAreas": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridTemplateArea"
		},
		"GridTemplateColumns": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridTemplateColumn"
		},
		"GridTemplateRows": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridTemplateRow"
		},
		"Gap": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "Gap"
		},
		"RowGap": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "RowGap"
		},
		"ColumnGap": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "ColumnGap"
		},
		"PlaceItems": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "PlaceItem"
		},
		"JustifyItems": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "JustifyItem"
		},
		"AlignItems": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "AlignItem"
		},
		"PlaceContent": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "PlaceContent"
		},
		"JustifyContent": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "JustifyContent"
		},
		"AlignContent": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "AlignContent"
		},
		"GridAutoColumns": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridAutoColumn"
		},
		"GridAutoRows": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridAutoRow"
		},
		"GridAutoFlow": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridAutoFlow"
		},
		"MsGridColumns": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "MsGridColumn"
		},
		"MsGridRows": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "MsGridRow"
		},
		"MsRowGap": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "MsRowGap"
		},
		"MsColumnGap": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "MsColumnGap"
		},
		"Items": {
			"type": "UCF_ClientInterfaces.I.CSSGridItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["CSSGridItem"] = {
	"name": "CSSGridItem",
	"properties": {
		"RelativeTo": {
			"type": "UCF_ClientInterfaces.E.CSSGridRelativeTo",
			"defaultValue": "VIEWPORT"
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Width": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "Width"
		},
		"Height": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "Height"
		},
		"GridColumn": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridColumn"
		},
		"GridColumnStart": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridColumnStart"
		},
		"GridColumnEnd": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridColumnEnd"
		},
		"GridRow": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridRow"
		},
		"GridRowStart": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridRowStart"
		},
		"GridRowEnd": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridRowEnd"
		},
		"GridArea": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "GridArea"
		},
		"PlaceSelf": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "PlaceSelf"
		},
		"AlignSelf": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "AlignSelf"
		},
		"JustifySelf": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "JustifySelf"
		},
		"MsGridColumn": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "MsGridColumn"
		},
		"MsGridColumnSpan": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "MsGridColumnSpan"
		},
		"MsGridColumnAlign": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "MsGridColumnAlign"
		},
		"MsGridRow": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "MsGridRow"
		},
		"MsGridRowSpan": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "MsGridRowSpan"
		},
		"MsGridRowAlign": {
			"type": "UCF_ClientInterfaces.I.Property",
			"multiple": true,
			"singularName": "MsGridRowAlign"
		},
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["DataGrid"] = {
	"name": "DataGrid",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentEditMode": {
			"type": "UCF_ClientInterfaces.E.SapTableContentEditMode",
			"defaultValue": "READONLY"
		}
	},
	"aggregations": {
		"Columns": {
			"type": "UCF_ClientInterfaces.I.DataGridColumn",
			"multiple": true,
			"singularName": "Column"
		},
		"Rows": {
			"type": "UCF_ClientInterfaces.I.DataGridRow",
			"multiple": true,
			"singularName": "Row"
		},
		"Legend": {
			"type": "UCF_ClientInterfaces.I.Legend",
			"multiple": false
		},
		"Toolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"VerticalScroll": {},
		"HorizontalScroll": {},
		"RowDrop": {},
		"ColumnDrop": {},
		"RowResize": {},
		"ColumnResize": {}
	}
};

UCF_ClientInterfaces["I"]["DataGridColumn"] = {
	"name": "DataGridColumn",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"FirstVisibleSegmentColumnIndex": {
			"type": "number",
			"defaultValue": 0
		},
		"SegmentColumnIndexOffset": {
			"type": "number",
			"defaultValue": 1
		},
		"SegmentColumnUnit": {
			"type": "string",
			"defaultValue": 'px'
		},
		"SegmentColumnCount": {
			"type": "number",
			"defaultValue": 0
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Scrollbar": {
			"type": "UCF_ClientInterfaces.I.Scrollbar",
			"multiple": false
		},
		"SegmentColumns": {
			"type": "UCF_ClientInterfaces.I.DataGridSegmentColumn",
			"multiple": true,
			"singularName": "SegmentColumn"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["DataGridRow"] = {
	"name": "DataGridRow",
	"properties": {
		"Height": {
			"type": "string",
			"defaultValue": "-1"
		},
		"FirstVisibleSegmentRowIndex": {
			"type": "number",
			"defaultValue": 0
		},
		"SegmentRowIndexOffset": {
			"type": "number",
			"defaultValue": 1
		},
		"SegmentRowUnit": {
			"type": "string",
			"defaultValue": 'px'
		},
		"SegmentRowCount": {
			"type": "number",
			"defaultValue": 0
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"ThemeScope": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Scrollbar": {
			"type": "UCF_ClientInterfaces.I.Scrollbar",
			"multiple": false
		},
		"SegmentRows": {
			"type": "UCF_ClientInterfaces.I.DataGridSegmentRow",
			"multiple": true,
			"singularName": "SegmentRow"
		},
		"Segments": {
			"type": "UCF_ClientInterfaces.I.DataGridSegment",
			"multiple": true,
			"singularName": "Segment"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["DataGridSegment"] = {
	"name": "DataGridSegment",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Cells": {
			"type": "UCF_ClientInterfaces.I.DataGridSegmentCell",
			"multiple": true,
			"singularName": "Cell"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"CellSelect": {}
	}
};

UCF_ClientInterfaces["I"]["DataGridSegmentCell"] = {
	"name": "DataGridSegmentCell",
	"properties": {
		"SelectionState": {
			"type": "UCF_ClientInterfaces.E.SapTableSelectionState",
			"defaultValue": "NOT_SELECTED"
		},
		"HierarchyState": {
			"type": "UCF_ClientInterfaces.E.SapTableHierarchicalCellStatus",
			"defaultValue": "NONE"
		},
		"HierarchyLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"HierarchyStateIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"IconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"SortState": {
			"type": "UCF_ClientInterfaces.E.SortState",
			"defaultValue": "DISABLED"
		},
		"Filtered": {
			"type": "boolean",
			"defaultValue": false
		},
		"ActionMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "MIDDLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"DragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"RotateContent": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"SemanticType": {
			"type": "UCF_ClientInterfaces.E.SapTableSemanticType",
			"defaultValue": "NONE"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"CellDecorators": {
			"type": "UCF_ClientInterfaces.I.Decorator",
			"multiple": true,
			"singularName": "CellDecorator"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Expand": {},
		"Collapse": {},
		"MenuAccess": {}
	},
	"publicMethods": [
		"openMenu"
	]
};

UCF_ClientInterfaces["I"]["DataGridSegmentColumn"] = {
	"name": "DataGridSegmentColumn",
	"properties": {
		"Width": {
			"type": "number",
			"defaultValue": 0
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.DataGridSegmentColumnType",
			"defaultValue": "STANDARD"
		}
	}
};

UCF_ClientInterfaces["I"]["DataGridSegmentRow"] = {
	"name": "DataGridSegmentRow",
	"properties": {
		"Height": {
			"type": "number",
			"defaultValue": 0
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.DataGridSegmentRowType",
			"defaultValue": "STANDARD"
		}
	}
};

UCF_ClientInterfaces["I"]["DataTip"] = {
	"name": "DataTip",
	"properties": {
		"ConnectedControlId": {
			"type": "string",
			"defaultValue": ''
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.DataTipType",
			"defaultValue": "TEXT"
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"ExplanationText": {
			"type": "string",
			"defaultValue": ''
		},
		"AutoShowOnFocus": {
			"type": "boolean",
			"defaultValue": true
		},
		"AutoShowOnFirstFocus": {
			"type": "boolean",
			"defaultValue": false
		},
		"AutoHideTimeout": {
			"type": "number",
			"defaultValue": 0
		},
		"EscapeText": {
			"type": "boolean",
			"defaultValue": true
		},
		"EscapeExplanationText": {
			"type": "boolean",
			"defaultValue": true
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.DataTipDesign",
			"defaultValue": "DEFAULT"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["DateNavigator"] = {
	"name": "DateNavigator",
	"properties": {
		"CanNavigate": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasLegend": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"HasSelection": {
			"type": "boolean",
			"defaultValue": false
		},
		"AllowDeselection": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasYearNavigation": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"SelectType": {
			"type": "UCF_ClientInterfaces.E.DateNavigatorSelectType",
			"defaultValue": "STANDARD"
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Rows": {
			"type": "UCF_ClientInterfaces.I.DateNavigatorRow",
			"multiple": true,
			"singularName": "Row"
		},
		"Legend": {
			"type": "UCF_ClientInterfaces.I.Legend",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"DaySelect": {},
		"MonthSelect": {},
		"WeekSelect": {},
		"DayDoubleClick": {},
		"WeekDoubleClick": {},
		"MonthDoubleClick": {},
		"NextMonth": {},
		"PreviousMonth": {},
		"NextYear": {},
		"PreviousYear": {},
		"ContextMenu": {}
	},
	"publicMethods": [
		"selectMonth",
		"deselectMonth",
		"selectWeek",
		"deselectWeek",
		"selectDay",
		"deselectDay",
		"bIsDaySelected",
		"bIsWeekSelected",
		"drawFocusRect"
	]
};

UCF_ClientInterfaces["I"]["DateNavigatorDay"] = {
	"name": "DateNavigatorDay",
	"properties": {
		"Design": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"DayNr": {
			"type": "number",
			"defaultValue": 0
		},
		"MonthNr": {
			"type": "number",
			"defaultValue": 0
		},
		"Year": {
			"type": "number",
			"defaultValue": 0
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"IsToday": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsClickable": {
			"type": "boolean",
			"defaultValue": true
		},
		"DayDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"DesignDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"IsWeekend": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsSelected": {
			"type": "boolean",
			"defaultValue": false
		}
	}
};

UCF_ClientInterfaces["I"]["DateNavigatorMonth"] = {
	"name": "DateNavigatorMonth",
	"properties": {
		"MonthNr": {
			"type": "number",
			"defaultValue": NaN
		},
		"Year": {
			"type": "number",
			"defaultValue": NaN
		},
		"FirstDayOfWeek": {
			"type": "number",
			"defaultValue": NaN
		},
		"IsClickable": {
			"type": "boolean",
			"defaultValue": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"YearAsString": {
			"type": "string",
			"defaultValue": ''
		},
		"MonthAsString": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Weeks": {
			"type": "UCF_ClientInterfaces.I.DateNavigatorWeek",
			"multiple": true,
			"singularName": "Week"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["DateNavigatorRow"] = {
	"name": "DateNavigatorRow",
	"aggregations": {
		"Months": {
			"type": "UCF_ClientInterfaces.I.DateNavigatorMonth",
			"multiple": true,
			"singularName": "Month"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["DateNavigatorWeek"] = {
	"name": "DateNavigatorWeek",
	"properties": {
		"WeekNr": {
			"type": "number",
			"defaultValue": 0
		},
		"Year": {
			"type": "number",
			"defaultValue": 0
		},
		"IsClickable": {
			"type": "boolean",
			"defaultValue": true
		},
		"HighlightAsCurrentWeek": {
			"type": "boolean",
			"defaultValue": false
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Days": {
			"type": "UCF_ClientInterfaces.I.DateNavigatorDay",
			"multiple": true,
			"singularName": "Day"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["DTActionMenuItem"] = {
	"name": "DTActionMenuItem",
	"properties": {
		"CssClassName": {
			"type": "string",
			"defaultValue": 'lsDTAactionMenuItem'
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Visible": {
			"type": "boolean",
			"defaultValue": true
		}
	}
};

UCF_ClientInterfaces["I"]["DTContainer"] = {
	"name": "DTContainer",
	"properties": {
		"RasterMode": {
			"type": "UCF_ClientInterfaces.E.DTRasterMode",
			"defaultValue": "NONE"
		},
		"Height": {
			"type": "string",
			"defaultValue": '100%'
		},
		"ScrollContainerSupport": {
			"type": "boolean",
			"defaultValue": false
		},
		"ScrollContainersWithScrollbars": {
			"type": "string",
			"defaultValue": ''
		},
		"DragAndDropLayoutMode": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollContainerSupportAdvanced": {
			"type": "boolean",
			"defaultValue": false
		},
		"EnableRectangleSelection": {
			"type": "boolean",
			"defaultValue": false
		},
		"EnableInplaceEdit": {
			"type": "boolean",
			"defaultValue": false
		},
		"EnableAdvancedElementFeatures": {
			"type": "boolean",
			"defaultValue": false
		},
		"EnableTabChainMode": {
			"type": "boolean",
			"defaultValue": false
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"Elements": {
			"type": "UCF_ClientInterfaces.I.DTElement",
			"multiple": true,
			"singularName": "Element"
		},
		"DropTargetInfos": {
			"type": "UCF_ClientInterfaces.I.DropTargetInfo",
			"multiple": true,
			"singularName": "DropTargetInfo"
		},
		"DragSourceInfos": {
			"type": "UCF_ClientInterfaces.I.DragSourceInfo",
			"multiple": true,
			"singularName": "DragSourceInfo"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {},
		"CommitSelection": {},
		"Drop": {},
		"DropOnRaster": {}
	},
	"publicMethods": [
		"updatePositions",
		"oGetDTElement",
		"aListSelectedElements"
	]
};

UCF_ClientInterfaces["I"]["DTElement"] = {
	"name": "DTElement",
	"properties": {
		"SelectionState": {
			"type": "UCF_ClientInterfaces.E.DTSelectionState",
			"defaultValue": "SELECTABLE"
		},
		"HoverEffect": {
			"type": "UCF_ClientInterfaces.E.DTHoverEffect",
			"defaultValue": "NONE",
			"deprecated": true
		},
		"ControlIds": {
			"type": "string",
			"defaultValue": null
		},
		"ZIndex": {
			"type": "number",
			"defaultValue": -1
		},
		"InplaceEditRefId": {
			"type": "string",
			"defaultValue": ''
		},
		"DragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfoTop": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfoAbove": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfoBefore": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfoAfter": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfoBelow": {
			"type": "string",
			"defaultValue": ''
		},
		"DragGhostType": {
			"type": "UCF_ClientInterfaces.E.DragGhostType",
			"defaultValue": "BOX"
		},
		"LayerDesign": {
			"type": "UCF_ClientInterfaces.E.DTLayerDesign",
			"defaultValue": "NONE"
		},
		"ResizeHandleNorth": {
			"type": "boolean",
			"defaultValue": false
		},
		"ResizeHandleSouth": {
			"type": "boolean",
			"defaultValue": false
		},
		"ResizeHandleEast": {
			"type": "boolean",
			"defaultValue": false
		},
		"ResizeHandleWest": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Outline": {
			"type": "UCF_ClientInterfaces.E.DTOutlineVisualization",
			"defaultValue": "NONE"
		},
		"IsScrollElement": {
			"type": "boolean",
			"defaultValue": false
		},
		"MoveMode": {
			"type": "UCF_ClientInterfaces.E.DTMoveMode",
			"defaultValue": "NONE"
		},
		"KeepRatio": {
			"type": "boolean",
			"defaultValue": false
		},
		"ActionMenuAlignment": {
			"type": "UCF_ClientInterfaces.E.DTActionMenuAlignment",
			"defaultValue": "TOP_LEFT"
		}
	},
	"aggregations": {
		"Buttons": {
			"type": "UCF_ClientInterfaces.I.Button",
			"multiple": true,
			"singularName": "Button"
		},
		"ActionMenuItems": {
			"type": "UCF_ClientInterfaces.I.DTActionMenuItem",
			"multiple": true,
			"singularName": "ActionMenuItem"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Drag": {},
		"ButtonPress": {},
		"Resize": {},
		"DragEnd": {},
		"Moved": {},
		"DoubleClick": {},
		"InplaceEditStart": {},
		"InplaceEditFinish": {},
		"ActionPress": {}
	},
	"publicMethods": [
		"aGetControlIDs",
		"hide",
		"show",
		"setHiddenDesign",
		"updatePosition"
	]
};

UCF_ClientInterfaces["I"]["DropTarget"] = {
	"name": "DropTarget",
	"properties": {
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"HoverVisualizationType": {
			"type": "UCF_ClientInterfaces.E.HoverVisualizationType",
			"defaultValue": "BORDERANDBACKGROUND"
		},
		"VerticalSizing": {
			"type": "UCF_ClientInterfaces.E.Sizing",
			"defaultValue": "PUSH"
		},
		"HorizontalSizing": {
			"type": "UCF_ClientInterfaces.E.Sizing",
			"defaultValue": "PUSH"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Drop": {}
	}
};

UCF_ClientInterfaces["I"]["DragSourceInfo"] = {
	"name": "DragSourceInfo",
	"properties": {
		"Tags": {
			"type": "string",
			"defaultValue": ''
		},
		"Data": {
			"type": "string",
			"defaultValue": ''
		},
		"MimeType": {
			"type": "string",
			"defaultValue": 'text/plain'
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"BrowserDragDrop": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"events": {
		"DataAccess": {}
	},
	"publicMethods": [
		"setTags"
	]
};

UCF_ClientInterfaces["I"]["DropTargetInfo"] = {
	"name": "DropTargetInfo",
	"properties": {
		"Tags": {
			"type": "string",
			"defaultValue": ''
		},
		"SupportRightMouseButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"EventBubbling": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"ValidMimeTypes": {
			"type": "string",
			"defaultValue": 'text/plain'
		}
	},
	"publicMethods": [
		"setTags"
	]
};

UCF_ClientInterfaces["I"]["FileUpload"] = {
	"name": "FileUpload",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Size": {
			"type": "number",
			"defaultValue": 0
		},
		"MaxLength": {
			"type": "number",
			"defaultValue": 0
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"UploadBehavior": {
			"type": "UCF_ClientInterfaces.E.FileUploadBehavior",
			"defaultValue": "STANDARD"
		},
		"UploadUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"UsedInSapTable": {
			"type": "boolean",
			"defaultValue": false
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"Multiple": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hidden": {
			"type": "boolean",
			"defaultValue": false
		},
		"Accept": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"FormFields": {
			"type": "UCF_ClientInterfaces.I.FormInputField",
			"multiple": true,
			"singularName": "FormField"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Change": {},
		"Error": {}
	},
	"publicMethods": [
		"aGetSelectedFiles",
		"openFileSelection",
		"addFormField"
	]
};

UCF_ClientInterfaces["I"]["FlashContainer"] = {
	"name": "FlashContainer",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"Height": {
			"type": "string",
			"defaultValue": null
		},
		"MinHeight": {
			"type": "string",
			"defaultValue": null
		},
		"Source": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AutoActivate": {
			"type": "boolean",
			"defaultValue": false
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "BROWSER"
		},
		"Transparent": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Parameters": {
			"type": "UCF_ClientInterfaces.I.FlashContainerParameter",
			"multiple": true,
			"singularName": "Parameter"
		},
		"Adapter": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"setKeepAlive"
	]
};

UCF_ClientInterfaces["I"]["FlashContainerParameter"] = {
	"name": "FlashContainerParameter",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"Value": {
			"type": "string",
			"defaultValue": null
		}
	}
};

UCF_ClientInterfaces["I"]["FlowLayout"] = {
	"name": "FlowLayout",
	"properties": {
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"Layout": {
			"type": "UCF_ClientInterfaces.E.TextViewLayout",
			"defaultValue": "NATIVE"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"FlowLayoutItems": {
			"type": "UCF_ClientInterfaces.I.FlowLayoutItem",
			"multiple": true,
			"singularName": "FlowLayoutItem"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["FlowLayoutItem"] = {
	"name": "FlowLayoutItem",
	"properties": {
		"PaddingTop": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"PaddingRight": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingBottom": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"PaddingLeft": {
			"type": "string",
			"defaultValue": ''
		},
		"ItemDesign": {
			"type": "UCF_ClientInterfaces.E.LayoutCellDesign",
			"defaultValue": "PADLESS"
		},
		"ItemSeparation": {
			"type": "UCF_ClientInterfaces.E.LayoutCellSeparation",
			"defaultValue": "DEFAULT"
		}
	},
	"aggregations": {
		"Control": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["FluidLayout"] = {
	"name": "FluidLayout",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"ColumnWidth": {
			"type": "string",
			"defaultValue": '70'
		},
		"ColumnCount": {
			"type": "number",
			"defaultValue": 5
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"DragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"FluidLayoutRows": {
			"type": "UCF_ClientInterfaces.I.FluidLayoutRow",
			"multiple": true,
			"singularName": "FluidLayoutRow"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Drop": {},
		"CellResize": {}
	}
};

UCF_ClientInterfaces["I"]["FluidLayoutCell"] = {
	"name": "FluidLayoutCell",
	"properties": {
		"ColSpan": {
			"type": "number",
			"defaultValue": 1
		},
		"RowSpan": {
			"type": "number",
			"defaultValue": 1
		},
		"AssociatedCellIds": {
			"type": "string",
			"defaultValue": ''
		},
		"SelectionState": {
			"type": "UCF_ClientInterfaces.E.DTSelectionState",
			"defaultValue": "SELECTABLE"
		},
		"Occupied": {
			"type": "boolean",
			"defaultValue": false
		},
		"PaddingTop": {
			"type": "string",
			"defaultValue": '0px'
		},
		"PaddingRight": {
			"type": "string",
			"defaultValue": '0px'
		},
		"PaddingBottom": {
			"type": "string",
			"defaultValue": '0px'
		},
		"PaddingLeft": {
			"type": "string",
			"defaultValue": '0px'
		},
		"ResizeableTop": {
			"type": "boolean",
			"defaultValue": false
		},
		"ResizeableBottom": {
			"type": "boolean",
			"defaultValue": false
		},
		"ResizeableBegin": {
			"type": "boolean",
			"defaultValue": false
		},
		"ResizeableEnd": {
			"type": "boolean",
			"defaultValue": false
		},
		"RangeSelectionStartMarker": {
			"type": "boolean",
			"defaultValue": false
		},
		"RangeSelectionEndMarker": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"HAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "LEFT"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["FluidLayoutContainer"] = {
	"name": "FluidLayoutContainer",
	"properties": {
		"HeaderColumnWidth": {
			"type": "string",
			"defaultValue": '40px'
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"FluidLayouts": {
			"type": "UCF_ClientInterfaces.I.FluidLayout",
			"multiple": true,
			"singularName": "FluidLayout"
		},
		"HeaderCells": {
			"type": "UCF_ClientInterfaces.I.FluidLayoutCell",
			"multiple": true,
			"singularName": "HeaderCell"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {},
		"CommitSelection": {}
	}
};

UCF_ClientInterfaces["I"]["FluidLayoutRow"] = {
	"name": "FluidLayoutRow",
	"aggregations": {
		"FluidLayoutCells": {
			"type": "UCF_ClientInterfaces.I.FluidLayoutCell",
			"multiple": true,
			"singularName": "FluidLayoutCell"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["FocusRect"] = {
	"name": "FocusRect",
	"properties": {
		"FocusElementId": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["Form"] = {
	"name": "Form",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"SubmitMethod": {
			"type": "string",
			"defaultValue": null
		},
		"ActionMethod": {
			"type": "string",
			"defaultValue": null
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": null
		},
		"ContentType": {
			"type": "string",
			"defaultValue": null
		},
		"CharacterSet": {
			"type": "string",
			"defaultValue": null
		},
		"EncodingType": {
			"type": "string",
			"defaultValue": null
		},
		"Target": {
			"type": "string",
			"defaultValue": null
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"HasEventQueue": {
			"type": "boolean",
			"defaultValue": false
		},
		"ResponseData": {
			"type": "UCF_ClientInterfaces.E.FormResponseData",
			"defaultValue": "FULL"
		},
		"VerticalSizing": {
			"type": "UCF_ClientInterfaces.E.Sizing",
			"defaultValue": "PUSH"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"HiddenFields": {
			"type": "UCF_ClientInterfaces.I.InputField",
			"multiple": true,
			"singularName": "HiddenField"
		},
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Content",
			"bindable": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Submit": {},
		"Reset": {},
		"Request": {}
	},
	"publicMethods": [
		"submit",
		"appendHiddenField",
		"putHiddenField",
		"setActionMethod",
		"setSubmitMethod",
		"setTarget",
		"getId",
		"saveAutoComplete"
	]
};

UCF_ClientInterfaces["I"]["FreeContextualArea"] = {
	"name": "FreeContextualArea",
	"properties": {
		"Design": {
			"type": "UCF_ClientInterfaces.E.FreeContextualAreaDesign",
			"defaultValue": "PLAIN"
		},
		"Title": {
			"type": "string",
			"defaultValue": 'Title'
		},
		"HasHeader": {
			"type": "boolean",
			"defaultValue": false
		},
		"Expandable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Expanded": {
			"type": "boolean",
			"defaultValue": true
		},
		"Personalizable": {
			"type": "boolean",
			"defaultValue": false
		},
		"ContentHeight": {
			"type": "number",
			"defaultValue": 0
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Expand": {},
		"Collapse": {},
		"Personalize": {}
	},
	"publicMethods": [
		"setDefaultButtonId"
	]
};

UCF_ClientInterfaces["I"]["GeoMap"] = {
	"name": "GeoMap",
	"properties": {
		"MapImageUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"MapImageWidth": {
			"type": "number",
			"defaultValue": 0
		},
		"MapImageHeight": {
			"type": "number",
			"defaultValue": 0
		},
		"HasImageMap": {
			"type": "boolean",
			"defaultValue": false
		},
		"ImageMapId": {
			"type": "string",
			"defaultValue": ''
		},
		"ZoomBehavior": {
			"type": "UCF_ClientInterfaces.E.GeoMapZoomBehavior",
			"defaultValue": "PANEL"
		},
		"MoveBehavior": {
			"type": "UCF_ClientInterfaces.E.GeoMapMoveBehavior",
			"defaultValue": "BUTTON"
		},
		"ShowResetButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"ResetButtonText": {
			"type": "string",
			"defaultValue": 'Maintain a text'
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"ZoomSteps": {
			"type": "UCF_ClientInterfaces.I.GeoMapZoomStep",
			"multiple": true,
			"singularName": "ZoomStep"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Move": {},
		"ImageMove": {},
		"ImageZoom": {},
		"ImageMapClick": {},
		"ZoomIn": {},
		"ZoomOut": {},
		"ZoomStep": {},
		"Reset": {}
	}
};

UCF_ClientInterfaces["I"]["GeoMapZoomStep"] = {
	"name": "GeoMapZoomStep",
	"properties": {
		"StepNumber": {
			"type": "number",
			"defaultValue": 0
		}
	}
};

UCF_ClientInterfaces["I"]["GridLayout"] = {
	"name": "GridLayout",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"FixedLayout": {
			"type": "boolean",
			"defaultValue": false
		},
		"MarginTop": {
			"type": "string",
			"defaultValue": '0px'
		},
		"MarginBottom": {
			"type": "string",
			"defaultValue": '0px'
		},
		"MarginLeft": {
			"type": "string",
			"defaultValue": '0px'
		},
		"MarginRight": {
			"type": "string",
			"defaultValue": '0px'
		},
		"DefaultCellPadding": {
			"type": "number",
			"defaultValue": 0
		},
		"DefaultCellSpacing": {
			"type": "number",
			"defaultValue": 0
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"DebugMode": {
			"type": "boolean",
			"defaultValue": false
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"DragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"DropDecoratorType": {
			"type": "UCF_ClientInterfaces.E.LayoutDropDecorator",
			"defaultValue": "BOX"
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Cols": {
			"type": "UCF_ClientInterfaces.I.GridLayoutCol",
			"multiple": true,
			"singularName": "Col"
		},
		"Rows": {
			"type": "UCF_ClientInterfaces.I.GridLayoutRow",
			"multiple": true,
			"singularName": "Row"
		},
		"Legend": {
			"type": "UCF_ClientInterfaces.I.Legend",
			"multiple": false
		},
		"RasterItems": {
			"type": "UCF_ClientInterfaces.I.RasterLayoutItem",
			"multiple": true,
			"singularName": "RasterItem"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Drag": {},
		"Drop": {}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the GridLayout"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "borderRadius",
				"property": "border-radius"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["GridLayoutCell"] = {
	"name": "GridLayoutCell",
	"properties": {
		"ColSpan": {
			"type": "number",
			"defaultValue": 1
		},
		"RowSpan": {
			"type": "number",
			"defaultValue": 1
		},
		"HAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "LEFT"
		},
		"VAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "MIDDLE"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingTop": {
			"type": "string",
			"defaultValue": '0px'
		},
		"PaddingBottom": {
			"type": "string",
			"defaultValue": '0px'
		},
		"PaddingRight": {
			"type": "string",
			"defaultValue": '0px'
		},
		"PaddingLeft": {
			"type": "string",
			"defaultValue": '0px'
		},
		"StyleClass": {
			"type": "string",
			"defaultValue": ''
		},
		"CellBackgroundDesign": {
			"type": "UCF_ClientInterfaces.E.CellBackgroundDesign",
			"defaultValue": "TRANSPARENT"
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"DragData": {
			"type": "string",
			"defaultValue": ''
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"LayoutCellPosition": {
			"type": "UCF_ClientInterfaces.E.LayoutCellPosition",
			"defaultValue": "DEFAULT"
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CellDesign": {
			"type": "UCF_ClientInterfaces.E.LayoutCellDesign",
			"defaultValue": "DEFAULT"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the GridLayoutCell"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "padding",
				"property": "padding",
				"docu": "Padding"
			},
			{
				"name": "borderRadius",
				"property": "border-radius"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "padding",
						"important": true,
						"expression": "@padding"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["GridLayoutCol"] = {
	"name": "GridLayoutCol",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": null
		}
	}
};

UCF_ClientInterfaces["I"]["GridLayoutRow"] = {
	"name": "GridLayoutRow",
	"properties": {
		"PaddingTop": {
			"type": "string",
			"defaultValue": '0px'
		},
		"PaddingBottom": {
			"type": "string",
			"defaultValue": '0px'
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Cells": {
			"type": "UCF_ClientInterfaces.I.GridLayoutCell",
			"multiple": true,
			"singularName": "Cell"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["Group"] = {
	"name": "Group",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.GroupDesign",
			"defaultValue": "PRIMARYCOLOR"
		},
		"HeaderDesign": {
			"type": "UCF_ClientInterfaces.E.GroupHeaderDesign",
			"defaultValue": "STANDARD"
		},
		"IsTextTitle": {
			"type": "boolean",
			"defaultValue": true
		},
		"ScrollingMode": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "NONE"
		},
		"HasTitleCaption": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasToolbar": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasContentPadding": {
			"type": "boolean",
			"defaultValue": true
		},
		"HeaderVisible": {
			"type": "boolean",
			"defaultValue": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"FormatTitleControl": {
			"type": "boolean",
			"defaultValue": false
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"ARIALandmark": {
			"type": "UCF_ClientInterfaces.E.ARIALandmark",
			"defaultValue": "none"
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"TitleContent": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"TitleCaption": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": false
		},
		"Toolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Scroll": {},
		"Hotkey": {}
	},
	"publicMethods": [
		"setDefaultButtonId"
	],
	"styles": {
		"variables": [
			{
				"name": "headerFontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urGrpWhlWeb1,font-family)",
				"docu": "Defines the font family for the group"
			},
			{
				"name": "headerFontColor",
				"property": "color",
				"expression": "@headerFontColor || contrast(@headerBackgroundColor)",
				"docu": "Defines the font color"
			},
			{
				"name": "headerFontWeight",
				"property": "font-weight",
				"defaultValue": "ruleValue(.urGrpWhlWeb1,font-weight)"
			},
			{
				"name": "headerFontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urGrpWhlWeb1,font-size)"
			},
			{
				"name": "headerFontStyle",
				"property": "font-style"
			},
			{
				"name": "headerTextDecoration",
				"property": "text-decoration",
				"defaultValue": "ruleValue(.urGrpWhlWeb1,text-decoration)"
			},
			{
				"name": "headerTextAlign",
				"property": "text-align"
			},
			{
				"name": "headerBackgroundColor",
				"property": "background-color",
				"expression": "@headerBackgroundColor",
				"defaultValue": "ruleValue(.urGrpWhlWeb1,background-color)"
			},
			{
				"name": "headerBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the header"
			},
			{
				"name": "headerBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the header"
			},
			{
				"name": "headerBorderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the header"
			},
			{
				"name": "headerBackgroundImage",
				"property": "background-image",
				"defaultValue": "none"
			},
			{
				"name": "headerBackgroundRepeat",
				"property": "background-repeat",
				"defaultValue": "no-repeat"
			},
			{
				"name": "headerBackgroundSize",
				"property": "background-size",
				"defaultValue": "contain"
			},
			{
				"name": "headerBackgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background image X position for the content"
			},
			{
				"name": "headerBackgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background image Y position for the content"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"expression": "contrast(@fontColor)",
				"defaultValue": "ruleValue(.urGrpWhlWeb1,background-color)"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"defaultValue": "none"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"defaultValue": "no-repeat"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"defaultValue": "contain"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background image X position for the content"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background image Y position for the content"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "borderRadius",
				"property": "border-radius"
			}
		],
		"classes": {
			"Header": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@headerFontFamily"
					},
					{
						"name": "font-size",
						"expression": "@headerFontSize"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@headerTextDecoration"
					},
					{
						"name": "text-align",
						"expression": "@headerTextAlign"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "background",
						"expression": "@headerBackgroundColor || none"
					},
					{
						"name": "background-color",
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@headerBackgroundImage || none"
					},
					{
						"name": "background-repeat",
						"expression": "@headerBackgroundRepeat || no-repeat"
					},
					{
						"name": "background-size",
						"expression": "@headerBackgroundSize || cover"
					},
					{
						"name": "background-position-x",
						"expression": "@headerBackgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@headerBackgroundPositionY"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-style",
						"expression": "none none @headerBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@headerBorderWidth"
					},
					{
						"name": "border-top-left-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "border-top-right-radius",
						"expression": "@borderRadius"
					}
				]
			},
			"_default": {
				"properties": [
					{
						"name": "background",
						"expression": "@backgroundColor || none"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage || none"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat || no-repeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize || cover"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "border-spacing",
						"expression": "0"
					}
				]
			},
			"Content": {
				"properties": [
					{
						"name": "background",
						"expression": "transparent"
					},
					{
						"name": "border-bottom-left-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "border-bottom-right-radius",
						"expression": "@borderRadius"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["HeaderArea"] = {
	"name": "HeaderArea",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"HasEditableTitle": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"IsCollapsible": {
			"type": "boolean",
			"defaultValue": true
		},
		"ClientCollapse": {
			"type": "boolean",
			"defaultValue": true
		},
		"Collapsed": {
			"type": "boolean",
			"defaultValue": false
		},
		"CollapseIconPosition": {
			"type": "UCF_ClientInterfaces.E.CollapseIconPosition",
			"defaultValue": "START"
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HeaderDesign": {
			"type": "UCF_ClientInterfaces.E.HeaderDesign",
			"defaultValue": "STANDARD"
		},
		"IsDragHandle": {
			"type": "boolean",
			"defaultValue": false
		},
		"TitleOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"AriaHeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"HeaderToolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"HeaderFunctions": {
			"type": "UCF_ClientInterfaces.I.Button",
			"multiple": true,
			"singularName": "HeaderFunction"
		},
		"TitleMenu": {
			"type": "UCF_ClientInterfaces.I.PopupMenu",
			"multiple": false,
			"deprecated": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Collapse": {},
		"Expand": {},
		"Change": {},
		"MenuAccess": {}
	},
	"publicMethods": [
		"openOnRequest",
		"getHeightPx",
		"getWidthPx"
	],
	"styles": {
		"variables": [
			{
				"name": "headerBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the header"
			},
			{
				"name": "headerBackgroundImage",
				"property": "background-image",
				"docu": "Defines the background-iamge for the header "
			},
			{
				"name": "headerFontColor",
				"property": "color",
				"docu": "Defines the color for the header"
			},
			{
				"name": "headerFontWeight",
				"property": "font-weight",
				"docu": "Defines the font-weight for the header"
			},
			{
				"name": "headerFontStyle",
				"property": "font-style",
				"docu": "Defines the font-style for the header"
			},
			{
				"name": "headerFontSize",
				"property": "font-size",
				"docu": "Defines the font-size for the header"
			},
			{
				"name": "headerFontFamily",
				"property": "font-family",
				"docu": "Defines the font-family for the header"
			},
			{
				"name": "headerTextDecoration",
				"property": "text-decoration",
				"docu": "Defines the text-decoration for the header"
			},
			{
				"name": "headerTextShadow",
				"property": "text-shadow",
				"docu": "Defines the text-shadow for the header"
			},
			{
				"name": "headerBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the header"
			},
			{
				"name": "headerBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the header"
			},
			{
				"name": "headerBorderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the header"
			}
		],
		"classes": {
			'Hd.lsHdArTbar2': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "@headerBackgroundImage"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "border-bottom-color",
						"important": true,
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-bottom-style",
						"important": true,
						"expression": "@headerBorderStyle"
					},
					{
						"name": "border-bottom-width",
						"important": true,
						"expression": "@headerBorderWidth"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@headerFontColor"
					}
				]
			},
			'Hd.lsHdArTitle': {
				"properties": [
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "font-family",
						"expression": "@headerFontFamily"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@headerFontColor"
					},
					{
						"name": "font-size",
						"expression": "@headerFontSize"
					},
					{
						"name": "text-decoration",
						"expression": "@headerTextDecoration"
					},
					{
						"name": "text-shadow",
						"expression": "@headerTextShadow || none"
					}
				]
			},
			'Hd .lsHdArCenter2,Hd .lsHdArLeft2Exp,Hd .lsHdArLeft2Col': {
				"properties": [
					{
						"name": "background-image",
						"expression": "none"
					},
					{
						"name": "border-width",
						"expression": "0px"
					},
					{
						"name": "height",
						"expression": "auto"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["HierarchicalView"] = {
	"name": "HierarchicalView",
	"properties": {
		"SegmentId": {
			"type": "string",
			"defaultValue": ''
		},
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Navigation": {
			"type": "UCF_ClientInterfaces.E.HierarchicalViewNavigation",
			"defaultValue": "NONE"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Item",
			"bindable": true
		},
		"Close": {
			"type": "UCF_ClientInterfaces.I.Button",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"SegmentChange": {}
	},
	"styles": {
		"variables": [
			{
				"name": "itemFontColor",
				"property": "color",
				"docu": "Defines the font color"
			},
			{
				"name": "itemIconColor",
				"property": "color",
				"expression": "@itemIconColor || @itemFontColor",
				"docu": "Defines the icon color"
			},
			{
				"name": "itemBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color color"
			},
			{
				"name": "itemHoverFontColor",
				"property": "color",
				"docu": "Defines the font color when hovering over an item"
			},
			{
				"name": "itemHoverIconColor",
				"property": "color",
				"expression": "@itemHoverIconColor || @itemHoverFontColor",
				"docu": "Defines the icon color when hovering over an item"
			},
			{
				"name": "itemHoverBackgroundColor",
				"property": "color",
				"docu": "Defines the background-color when hovering over an item"
			},
			{
				"name": "itemActiveFontColor",
				"property": "color",
				"docu": "Defines the font color when an item is active"
			},
			{
				"name": "itemActiveIconColor",
				"property": "color",
				"expression": "@itemActiveIconColor || @itemActiveFontColor",
				"docu": "Defines the icon color when an item is active"
			},
			{
				"name": "itemActiveBackgroundColor",
				"property": "color",
				"docu": "Defines the background-color when an item is active"
			},
			{
				"name": "itemDisabledFontColor",
				"property": "color",
				"expression": "@itemFontColor || @itemDisabledFontColor",
				"docu": "Defines the font color when disabled"
			},
			{
				"name": "itemDisabledIconColor",
				"property": "color",
				"expression": "@itemDisabledIconColor || @itemDisabledFontColor || @itemFontColor",
				"docu": "Defines the font color when disabled"
			},
			{
				"name": "itemDisabledBackgroundColor",
				"property": "background-color",
				"expression": "@itemDisabledBackgroundColor || @itemBackgroundColor",
				"docu": "Defines the background-color color when disabled"
			},
			{
				"name": "itemDisabledOpacity",
				"property": "opacity",
				"docu": "Defines the opacity of an item when disable"
			},
			{
				"name": "itemSeperatorLineColor",
				"property": "color"
			},
			{
				"name": "navigationItemFontColor",
				"property": "color",
				"docu": "Defines the font color"
			}
		],
		"classes": {
			'  .lsHierarchicalview__navigation': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemFontColor"
					},
					{
						"name": "background-color",
						"expression": "@itemBackgroundColor"
					},
					{
						"name": "box-shadow",
						"expression": "0 0 0.25rem rgba(0,0,0,0.15), inset 0 -0.0625rem 0 0 @itemSeperatorLineColor"
					}
				]
			},
			' .lsHierarchicalview__navigationtitle': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemFontColor"
					}
				]
			},
			' .lsHierarchicalview__item.lsHierarchicalview__item--isactive': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemFontColor"
					},
					{
						"name": "background-color",
						"expression": "@itemBackgroundColor"
					}
				]
			},
			' .lsHierarchicalview__item.lsHierarchicalview__item--isactive .lsLabel--standalone': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemFontColor"
					}
				]
			},
			' .lsHierarchicalview__item.lsHierarchicalview__item--isactive .lsHierarchicalview__itemhotkey': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemFontColor"
					}
				]
			},
			' .lsHierarchicalview__item.lsHierarchicalview__item--isactive .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@itemIconColor"
					},
					{
						"name": "color",
						"expression": "@itemIconColor"
					}
				]
			},
			' .lsHierarchicalview__items': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@itemBackgroundColor"
					},
					{
						"name": "background-image",
						"expression": "repeating-linear-gradient(to bottom, transparent 0, transparent 1.9375rem, @itemSeperatorLineColor 1.9375rem, @itemSeperatorLineColor 2rem)"
					}
				]
			},
			' .lsHierarchicalview__item': {
				"properties": [
					{
						"name": "background-image",
						"expression": "linear-gradient(to top, @itemSeperatorLineColor .0625rem, transparent .0625rem)"
					}
				]
			},
			' .lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active)': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemHoverFontColor"
					},
					{
						"name": "background-color",
						"expression": "@itemHoverBackgroundColor"
					}
				]
			},
			' .lsHierarchicalview__item--hoverable:hover .lsLabel--standalone': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemHoverFontColor"
					}
				]
			},
			' .lsHierarchicalview__item--hoverable:hover .lsHierarchicalview__itemhotkey': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemHoverFontColor"
					}
				]
			},
			' .lsHierarchicalview__item--hoverable:hover .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@itemHoverIconColor"
					},
					{
						"name": "color",
						"expression": "@itemHoverIconColor"
					}
				]
			},
			' .lsHierarchicalview__item--isactive:active, .lsHierarchicalview__item--isactive.lsHierarchicalview__item--active': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@itemActiveBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@itemActiveFontColor"
					}
				]
			},
			' .lsHierarchicalview__item--isactive:active >td, .lsHierarchicalview__item--isactive:active  .lsHierarchicalview__itemhotkey, .lsHierarchicalview__item--isactive.lsHierarchicalview__item--active  .lsHierarchicalview__itemhotkey': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemActiveFontColor"
					}
				]
			},
			' .lsHierarchicalview__item--isactive:active .lsLabel--standalone': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemActiveFontColor"
					}
				]
			},
			' .lsHierarchicalview__item--isactive:active .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemActiveIconColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@itemActiveIconColor"
					}
				]
			},
			' .lsHierarchicalview__item--disabled': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemDisabledFontColor"
					},
					{
						"name": "background-color",
						"expression": "@itemDisabledBackgroundColor"
					},
					{
						"name": "opacity",
						"expression": "@itemDisabledOpacity"
					}
				]
			},
			' .lsHierarchicalview__item--disabled .lsHierarchicalview__itemhotkey': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemDisabledFontColor"
					}
				]
			},
			' .lsHierarchicalview__item--disabled .lsLabel--standalone': {
				"properties": [
					{
						"name": "color",
						"expression": "@itemDisabledFontColor"
					},
					{
						"name": "opacity",
						"expression": "@itemDisabledOpacity"
					}
				]
			},
			' .lsHierarchicalview__item--disabled .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@itemDisabledIconColor"
					},
					{
						"name": "color",
						"expression": "@itemDisabledIconColor"
					}
				]
			},
			' .lsHierarchicalview__item--hasseparator': {
				"properties": [
					{
						"name": "background-image",
						"expression": "linear-gradient(to bottom, @itemSeperatorLineColor 0, @itemSeperatorLineColor .15625rem, transparent .15625rem),linear-gradient(to top, @itemSeperatorLineColor .0625rem, transparent .0625rem)"
					}
				]
			},
			' .lsHierarchicalview--breadcrumbparent .lsHierarchicalview__navigationitem, .lsHierarchicalview--breadcrumbfull .lsHierarchicalview__navigationitem, .lsHierarchicalview__navigationitems .lsHierarchicalview__navigationitem': {
				"properties": [
					{
						"name": "color",
						"expression": "@navigationItemFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["HierarchicalViewItem"] = {
	"name": "HierarchicalViewItem",
	"properties": {
		"ItemId": {
			"type": "string",
			"defaultValue": ''
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Emphasized": {
			"type": "boolean",
			"defaultValue": false
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasSegment": {
			"type": "boolean",
			"defaultValue": false
		},
		"SegmentId": {
			"type": "string",
			"defaultValue": ''
		},
		"Hotkey": {
			"type": "UCF_ClientInterfaces.E.HotkeyValue",
			"defaultValue": "NONE"
		},
		"UpIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"DownIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Role": {
			"type": "string",
			"defaultValue": ''
		},
		"AriaDescribedBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["HorizontalContextualPanel"] = {
	"name": "HorizontalContextualPanel",
	"properties": {
		"SelectedTabIndex": {
			"type": "number",
			"defaultValue": 0
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Emphasized": {
			"type": "boolean",
			"defaultValue": false
		},
		"ClientSelect": {
			"type": "boolean",
			"defaultValue": true
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"Scrollable": {
			"type": "boolean",
			"defaultValue": false
		},
		"FirstVisibleOnMainLevel": {
			"type": "number",
			"defaultValue": -1
		},
		"FirstVisibleOnSubLevel": {
			"type": "number",
			"defaultValue": -1
		},
		"PopupMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"TabDesign": {
			"type": "UCF_ClientInterfaces.E.HorizontalContextualPanelTabDesign",
			"defaultValue": "TAB"
		},
		"MenuItemsDesign": {
			"type": "UCF_ClientInterfaces.E.HorizontalContextualPanelMenuItemsDesign",
			"defaultValue": "TAB"
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.HorizontalContextualPanelItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {},
		"Scroll": {}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"expression": "@backgroundColor"
			},
			{
				"name": "subItemsBackgroundColor",
				"property": "background-color",
				"expression": "@subItemsBackgroundColor || @backgroundColor"
			}
		],
		"classes": {
			'-mainItems': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'-subItems': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@subMenuBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["HorizontalContextualPanelItem"] = {
	"name": "HorizontalContextualPanelItem",
	"properties": {
		"Index": {
			"type": "number",
			"defaultValue": 0
		},
		"SelectedTabMenuIndex": {
			"type": "number",
			"defaultValue": -1
		},
		"Caption": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"PopupMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"IconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"IconSemantic": {
			"type": "UCF_ClientInterfaces.E.HorizontalContextualPanelIconSemantic",
			"defaultValue": "DEFAULT"
		}
	},
	"aggregations": {
		"MenuItems": {
			"type": "UCF_ClientInterfaces.I.HorizontalContextualPanelMenuItem",
			"multiple": true,
			"singularName": "MenuItem"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"styles": {
		"variables": [
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color."
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight."
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style."
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color."
			},
			{
				"name": "selectedFontColor",
				"property": "color",
				"expression": "@selectedFontColor || @fontColor",
				"docu": "Defines the font color for selected panel items."
			},
			{
				"name": "selectedFontWeight",
				"property": "font-weight",
				"expression": "@selectedFontWeight || @fontWeight",
				"docu": "Defines the font weight for selected panel items."
			},
			{
				"name": "selectedFontStyle",
				"property": "font-style",
				"expression": "@selectedFontStyle || @fontStyle",
				"docu": "Defines the font style for selected panel items."
			},
			{
				"name": "selectedBackgroundColor",
				"property": "background-color",
				"expression": "@selectedBackgroundColor || @backgroundColor",
				"docu": "Defines the background color for selected panel items."
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "@disabledFontColor || @fontColor",
				"docu": "Defines the font color for disabled panel items."
			},
			{
				"name": "disabledFontWeight",
				"property": "font-weight",
				"expression": "@disabledFontWeight || @fontWeight",
				"docu": "Defines the font weight for disabled panel items."
			},
			{
				"name": "disabledFontStyle",
				"property": "font-style",
				"expression": "@disabledFontStyle || @fontStyle",
				"docu": "Defines the font style for disabled panel items."
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"expression": "@disabledBackgroundColor || @backgroundColor",
				"docu": "Defines the background color for disabled panel items."
			}
		],
		"classes": {
			'-title.lsHcnp__title,-title.lsHcnp2__title': {
				"properties": [
					{
						"name": "color",
						"expression": "@FontColor"
					},
					{
						"name": "font-weight",
						"expression": "@FontWeight"
					},
					{
						"name": "font-style",
						"expression": "@FontStyle"
					}
				]
			},
			'-title.lsHcnp__title--selected,-title.lsHcnp2__title--selected': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@selectedFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@selectedFontStyle"
					}
				]
			},
			'-title.lsHcnp__title--disabled,-title.lsHcnp2__title--disabled': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@disabledFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@disabledFontStyle"
					}
				]
			},
			'-title.lsHcnp__title--selected--disabled,-title.lsHcnp2__title--selected--disabled': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@disabledFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@disabledFontStyle"
					}
				]
			},
			'.lsHcnp__firstTab,.lsHcnp__tab,.lsHcnp2__firstTab,.lsHcnp2__tab': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'.lsHcnp__firstTab--selected,.lsHcnp__tab--selected,.lsHcnp2__firstTab--selected,.lsHcnp2__tab--selected': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					}
				]
			},
			'.lsHcnp__firstTab--disabled,.lsHcnp__tab--disabled,.lsHcnp2__firstTab--disabled,.lsHcnp2__tab--disabled': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					}
				]
			},
			'-title.lsHcnpTabText2': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					}
				]
			},
			'.lsHcnpTabEnd2': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'-title.lsHcnpTabText2Sel': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@selectedFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@selectedFontStyle"
					}
				]
			},
			'.lsHcnpTabEnd2Sel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					}
				]
			},
			'-title.lsHcnpTabText2Dsbl': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@disabledFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@disabledFontStyle"
					}
				]
			},
			'.lsHcnp__item--disabled': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["HorizontalContextualPanelMenuItem"] = {
	"name": "HorizontalContextualPanelMenuItem",
	"properties": {
		"TabIndex": {
			"type": "number",
			"defaultValue": 0
		},
		"Index": {
			"type": "number",
			"defaultValue": 0
		},
		"MenuItemCaption": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"styles": {
		"variables": [
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color."
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight."
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style."
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color."
			},
			{
				"name": "selectedFontColor",
				"property": "color",
				"expression": "@selectedFontColor || @fontColor",
				"docu": "Defines the font color for selected panel items."
			},
			{
				"name": "selectedFontWeight",
				"property": "font-weight",
				"expression": "@selectedFontWeight || @fontWeight",
				"docu": "Defines the font weight for selected panel items."
			},
			{
				"name": "selectedFontStyle",
				"property": "font-style",
				"expression": "@selectedFontStyle || @fontStyle",
				"docu": "Defines the font style for selected panel items."
			},
			{
				"name": "selectedBackgroundColor",
				"property": "background-color",
				"expression": "@selectedBackgroundColor || @backgroundColor",
				"docu": "Defines the background color for selected panel items."
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "@disabledFontColor || @fontColor",
				"docu": "Defines the font color for disabled panel items."
			},
			{
				"name": "disabledFontWeight",
				"property": "font-weight",
				"expression": "@disabledFontWeight || @fontWeight",
				"docu": "Defines the font weight for disabled panel items."
			},
			{
				"name": "disabledFontStyle",
				"property": "font-style",
				"expression": "@disabledFontStyle || @fontStyle",
				"docu": "Defines the font style for disabled panel items."
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"expression": "@disabledBackgroundColor || @backgroundColor",
				"docu": "Defines the background color for disabled panel items."
			}
		],
		"classes": {
			'-title.lsHcnpMenu3': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'-title.lsHcnpMenu3Sel': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@selectedFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@selectedFontStyle"
					},
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					}
				]
			},
			'-title.lsHcnpMenu3Dsbl': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@disabledFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@disabledFontStyle"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["HorizontalDivider"] = {
	"name": "HorizontalDivider",
	"properties": {
		"RuleDisplay": {
			"type": "UCF_ClientInterfaces.E.HorizontalDividerRuleDisplayType",
			"defaultValue": "AREADIVIDER"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"SeparationHeight": {
			"type": "UCF_ClientInterfaces.E.HorizontalDividerRuleHeight",
			"defaultValue": "MEDIUM"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["Hotkey"] = {
	"name": "Hotkey",
	"properties": {
		"Hotkey": {
			"type": "UCF_ClientInterfaces.E.HotkeyValue",
			"defaultValue": "NONE"
		},
		"ProviderId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["Hotkeys"] = {
	"name": "Hotkeys",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Hotkeys": {
			"type": "UCF_ClientInterfaces.I.Hotkey",
			"multiple": true,
			"singularName": "Hotkey"
		}
	}
};

UCF_ClientInterfaces["I"]["HtmlFragment"] = {
	"name": "HtmlFragment",
	"properties": {
		"HTML": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["HtmlIsland"] = {
	"name": "HtmlIsland",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"MinHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollingMode": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "HIDE"
		},
		"UnLoad": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "BROWSER"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"ContentItems": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "ContentItem",
			"bindable": true
		},
		"Scripts": {
			"type": "UCF_ClientInterfaces.I.Script",
			"multiple": true,
			"singularName": "Script"
		},
		"Styles": {
			"type": "UCF_ClientInterfaces.I.Style",
			"multiple": true,
			"singularName": "Style"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"setDragAndDropHandler",
		"setKeepAlive",
		"addEventListener",
		"removeEventListener"
	]
};

UCF_ClientInterfaces["I"]["Iframe"] = {
	"name": "Iframe",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": '300px'
		},
		"Height": {
			"type": "string",
			"defaultValue": '150px'
		},
		"MinHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"Url": {
			"type": "string",
			"defaultValue": ''
		},
		"HasBorder": {
			"type": "boolean",
			"defaultValue": false
		},
		"Scrolling": {
			"type": "UCF_ClientInterfaces.E.IframeScrolling",
			"defaultValue": "NO"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "BROWSER"
		},
		"PostParameters": {
			"type": "string",
			"defaultValue": ''
		},
		"AutoHeight": {
			"type": "boolean",
			"defaultValue": false
		},
		"ForwardDragDropEvents": {
			"type": "boolean",
			"defaultValue": false
		},
		"LockBehavior": {
			"type": "UCF_ClientInterfaces.E.LockBehavior",
			"defaultValue": "ROUNDTRIP"
		},
		"AppendSapIeParameter": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"Allow": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Load": {},
		"Resize": {},
		"Message": {}
	},
	"publicMethods": [
		"setKeepAlive",
		"setUrl",
		"postMessage"
	]
};

UCF_ClientInterfaces["I"]["Image"] = {
	"name": "Image",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"Src": {
			"type": "string",
			"defaultValue": ''
		},
		"Alt": {
			"type": "string",
			"defaultValue": ''
		},
		"Border": {
			"type": "number",
			"defaultValue": 0
		},
		"IsInteractive": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasImageMap": {
			"type": "boolean",
			"defaultValue": false
		},
		"ImageMapId": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"IsNested": {
			"type": "boolean",
			"defaultValue": false
		},
		"LabelText": {
			"type": "string",
			"defaultValue": ''
		},
		"AdjustImageSize": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsDecorative": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsDragHandle": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"ErrorImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"ItsMode": {
			"type": "boolean",
			"defaultValue": false
		},
		"ItsDisplayMode": {
			"type": "UCF_ClientInterfaces.E.ImageItsDisplayMode",
			"defaultValue": "NORMAL"
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalTextAlign": {
			"type": "UCF_ClientInterfaces.E.VerticalTextAlign",
			"defaultValue": "MIDDLE"
		},
		"HorizontalTextAlign": {
			"type": "UCF_ClientInterfaces.E.HorizontalTextAlign",
			"defaultValue": "CENTER"
		},
		"UsedInSapTable": {
			"type": "boolean",
			"defaultValue": false
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"DragSourceInfo": {
			"type": "string"
		},
		"DropTargetInfo": {
			"type": "string"
		}
	},
	"events": {
		"Activate": {},
		"ImageMapClick": {},
		"Drag": {},
		"Drop": {},
		"DoubleClick": {}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the Image"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the Image"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the Image"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the Image"
			},
			{
				"name": "borderRadius",
				"property": "border-radius",
				"docu": "Defines the border-radius for the Image"
			},
			{
				"name": "verticalAlign",
				"property": "vertical-align",
				"docu": "Defines the vertical-align for the content"
			},
			{
				"name": "textAlign",
				"property": "text-align",
				"docu": "Defines the text-align for the content"
			},
			{
				"name": "width",
				"property": "width",
				"docu": "Defines the width for the Image; it should be 100% for Fit and Stretch"
			},
			{
				"name": "height",
				"property": "height",
				"docu": "Defines the height for the Image; it should be 100% for Fit and Stretch"
			}
		],
		"classes": {
			"Scrl": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			"Align": {
				"properties": [
					{
						"name": "vertical-align",
						"important": true,
						"expression": "@verticalAlign"
					},
					{
						"name": "text-align",
						"important": true,
						"expression": "@textAlign"
					}
				]
			},
			"_default": {
				"properties": [
					{
						"name": "width",
						"important": true,
						"expression": "@width"
					},
					{
						"name": "height",
						"important": true,
						"expression": "@height"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ImageMap"] = {
	"name": "ImageMap",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"ImageMapAreas": {
			"type": "UCF_ClientInterfaces.I.ImageMapArea",
			"multiple": true,
			"singularName": "ImageMapArea"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"ImageMapClick": {}
	}
};

UCF_ClientInterfaces["I"]["ImageMapArea"] = {
	"name": "ImageMapArea",
	"properties": {
		"Coordinates": {
			"type": "string",
			"defaultValue": ''
		},
		"Shape": {
			"type": "UCF_ClientInterfaces.E.ImageMapShape",
			"defaultValue": "RECTANGLE"
		},
		"Alt": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["InputField"] = {
	"name": "InputField",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		},
		"Length": {
			"type": "number",
			"defaultValue": 20
		},
		"MaxLength": {
			"type": "number",
			"defaultValue": 0
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"ShowHelpButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"PasswordField": {
			"type": "boolean",
			"defaultValue": false
		},
		"Size": {
			"type": "UCF_ClientInterfaces.E.InputFieldSize",
			"defaultValue": "DEFAULT"
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.InputFieldType",
			"defaultValue": "STRING"
		},
		"FieldHelp": {
			"type": "UCF_ClientInterfaces.E.InputFieldFieldHelp",
			"defaultValue": "F4LOOKUP"
		},
		"Hidden": {
			"type": "boolean",
			"defaultValue": false
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Align": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"ShowInputLength": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"LabelText": {
			"type": "string",
			"defaultValue": ''
		},
		"HideFieldHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"ContainerWidthSet": {
			"type": "boolean",
			"defaultValue": false
		},
		"UsedInSapTable": {
			"type": "boolean",
			"defaultValue": false
		},
		"PaddingInSapTable": {
			"type": "string",
			"defaultValue": ''
		},
		"IMEMode": {
			"type": "UCF_ClientInterfaces.E.IMEMode",
			"defaultValue": "AUTO"
		},
		"AutoComplete": {
			"type": "boolean",
			"defaultValue": false
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"FormatString": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowHelpButtonAlways": {
			"type": "boolean",
			"defaultValue": false
		},
		"DatePickerStartRefId": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"ShowRequiredIndicator": {
			"type": "boolean",
			"defaultValue": false
		},
		"DisplayAsText": {
			"type": "boolean",
			"defaultValue": false
		},
		"InputPrompt": {
			"type": "string",
			"defaultValue": ''
		},
		"TextStyle": {
			"type": "UCF_ClientInterfaces.E.InputFieldTextStyle",
			"defaultValue": "NORMAL"
		},
		"SpinnerIncrement": {
			"type": "number",
			"defaultValue": 1
		},
		"SpinnerBoundsCheck": {
			"type": "boolean",
			"defaultValue": false
		},
		"SpinnerMax": {
			"type": "number",
			"defaultValue": 0
		},
		"SpinnerMin": {
			"type": "number",
			"defaultValue": 0
		},
		"TextOverflowEllipsis": {
			"type": "boolean",
			"defaultValue": true
		},
		"SapTableFieldDesign": {
			"type": "UCF_ClientInterfaces.E.TableFieldDesign",
			"defaultValue": "NONE"
		},
		"ValidationTrigger": {
			"type": "UCF_ClientInterfaces.E.ValidationTrigger",
			"defaultValue": "STANDARD"
		},
		"UpperCase": {
			"type": "boolean",
			"defaultValue": false
		},
		"TabBehaviour": {
			"type": "UCF_ClientInterfaces.E.TabBehaviour",
			"defaultValue": "STANDARD"
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"EmbeddingBehaviour": {
			"type": "UCF_ClientInterfaces.E.EmbeddingBehaviour",
			"defaultValue": "COMPATIBLE"
		},
		"FieldHelpFloating": {
			"type": "boolean",
			"defaultValue": true
		},
		"AutoCorrect": {
			"type": "boolean",
			"defaultValue": false
		},
		"FirstDayOfWeek": {
			"type": "number",
			"defaultValue": -1
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"FieldHelpEmbedding": {
			"type": "boolean",
			"defaultValue": false
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowClearButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"DescribedBy": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Change": {},
		"FieldHelpPress": {},
		"Enter": {},
		"Validate": {},
		"DoubleClick": {},
		"Activate": {},
		"ClipboardTablePaste": {},
		"Spin": {},
		"TabOut": {}
	},
	"publicMethods": [
		"sGetValue",
		"setChanged",
		"setInputState",
		"setCursorPosition",
		"setSelection",
		"iGetSelectionStart",
		"iGetSelectionEnd",
		"getValue",
		"setValue",
		"setEnabled",
		"getEnabled",
		"setEditable",
		"getEditable",
		"setRequired",
		"getRequired",
		"setValueState",
		"getValueState",
		"sGetFormatString",
		"sGetUnformattedValue",
		"createDataTip"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for all InputField states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size e.g. px, em"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style e.g. italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration e.g. underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "borderRadius",
				"property": "borderRadius",
				"docu": "Defines the broder radius"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"docu": "Defines the disabled background color of the InputField"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "contrast(@disabledBackgroundColor)",
				"docu": "Defines the disabled font color of the InputField"
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the disabled font color of the InputField"
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "background-color",
				"docu": "Defines the readonly background color of the InputField"
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"expression": "contrast(@readonlyBackgroundColor)",
				"docu": "Defines the readonly font color of the InputField"
			},
			{
				"name": "readonlyBorderColor",
				"property": "border-color",
				"docu": "Defines the readonly border color of the InputField"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color"
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color"
			},
			{
				"name": "hoverColor",
				"property": "color",
				"expression": "@fontColor || contrast(@hoverBackgroundColor)"
			},
			{
				"name": "inputFontSize",
				"property": "font-size",
				"defaultValue": "themeValue(.lsField__metadata,inputFontSize)",
				"docu": "DO NOT CHANGE THIS!"
			},
			{
				"name": "inputBackgroundImage",
				"property": "background-image",
				"defaultValue": "themeValue(.lsField__metadata,backgroundImage)",
				"docu": "DO NOT CHANGE THIS!"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "@inputBackgroundImage"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "font-size",
						"expression": "~\"calc(@{fontSize} / @{inputFontSize})\""
					},
					{
						"name": "outline-color",
						"expression": "contrast(@backgroundColor)"
					},
					{
						"name": "outline-offset",
						"expression": "-@borderWidth - 2px"
					}
				]
			},
			' .lsField__input': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			' .lsField__help,.lsField--hasclear:not(.lsField--hashelp) .lsField__clear': {
				"properties": [
					{
						"name": "border-top-right-radius",
						"expression": "@borderRadius - @borderWidth"
					},
					{
						"name": "border-bottom-right-radius",
						"expression": "@borderRadius - @borderWidth"
					}
				]
			},
			' .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly)': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly) .lsField__input': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverColor || @fontColor || contrast(@hoverBackgroundColor)"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly) .lsField__help,.lsField--hover:not(.lsField--readonly)#ls-inputfieldhelpbutton,.lsField--hover:not(.lsField--readonly) .lsField__clear': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@hoverColor || @fontColor || contrast(@hoverBackgroundColor)"
					}
				]
			},
			'.lsField--disabled': {
				"properties": [
					{
						"name": "opacity",
						"expression": "1"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					},
					{
						"name": "outline-color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsField--disabled .lsField__input,.lsField--disabled .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsField--readonly': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "outline-color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			'.lsField--readonly .lsField__input,.lsField--readonly .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["InputTokenizer"] = {
	"name": "InputTokenizer",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"Key": {
			"type": "string",
			"defaultValue": ''
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		},
		"Align": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"IMEMode": {
			"type": "UCF_ClientInterfaces.E.IMEMode",
			"defaultValue": "AUTO"
		},
		"DisplayAsText": {
			"type": "boolean",
			"defaultValue": false
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"ContainerWidthSet": {
			"type": "boolean",
			"defaultValue": false
		},
		"UsedInSapTable": {
			"type": "boolean",
			"defaultValue": false
		},
		"PaddingInSapTable": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowHelpButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"ShowHelpButtonAlways": {
			"type": "boolean",
			"defaultValue": false
		},
		"HideFieldHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"SuggestFilter": {
			"type": "UCF_ClientInterfaces.E.SuggestFilterType",
			"defaultValue": "OFF"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"HasClickableToken": {
			"type": "boolean",
			"defaultValue": false
		},
		"InputPrompt": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"ItemListBoxId": {
			"type": "string"
		}
	},
	"events": {
		"ActionItemActivate": {},
		"Change": {},
		"Select": {},
		"Enter": {},
		"ListAccess": {},
		"FieldHelpPress": {},
		"Navigate": {}
	},
	"publicMethods": [
		"setChanged",
		"open",
		"update",
		"setInputState",
		"setCursorPosition",
		"setSelection",
		"iGetSelectionStart",
		"iGetSelectionEnd",
		"createDataTip"
	]
};

UCF_ClientInterfaces["I"]["Token"] = {
	"name": "Token",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HideIcon": {
			"type": "boolean",
			"defaultValue": false
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false
		},
		"Key": {
			"type": "string",
			"defaultValue": ''
		},
		"MaxWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"ReadOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Selected": {
			"type": "boolean",
			"defaultValue": false
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		}
	},
	"associations": {
		"DragSourceInfo": {
			"type": "string"
		}
	},
	"events": {
		"Select": {},
		"Delete": {},
		"Edit": {},
		"Drag": {}
	},
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font-family for a token"
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "@fontColor || contrast(@backgroundColor)",
				"docu": "Defines the font-color for a token"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font-weight for a token"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font-size for a token"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style for a token"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text-decoration for a token"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"expression": "@backgroundColor",
				"docu": "Defines the background-color for a token"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for a token"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for a token"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for a token"
			},
			{
				"name": "borderRadius",
				"property": "border-radius",
				"docu": "Defines the border-radius for a token"
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"docu": "Defines the font-color for a read only token"
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for a read only token"
			},
			{
				"name": "readonlyBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for a read only token"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"docu": "Defines the font-color for a disabled token"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for a disabled token"
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for a disabled token"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"docu": "Defines the font-color for a hovered token"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for a hovered token"
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for a hovered token"
			},
			{
				"name": "selectedFontColor",
				"property": "color",
				"docu": "Defines the font-color for a selected token"
			},
			{
				"name": "selectedBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for a selected token"
			},
			{
				"name": "selectedBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for a selected token"
			},
			{
				"name": "selectedHoverFontColor",
				"property": "color",
				"docu": "Defines the font-color for a hovered selected token"
			},
			{
				"name": "selectedHoverBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for a hovered selected token"
			},
			{
				"name": "selectedHoverBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for a hovered selected token"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"important": true,
						"expression": "@borderRadius"
					}
				]
			},
			'@{CustomStyle}-text': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'@{CustomStyle}-icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--readonly': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--readonly .lsToken__text': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--disabled': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--disabled .lsToken__text': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--disabled .lsToken__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--selected': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBorderColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--selected .lsToken__text': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--selected .lsToken__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--hoverable:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--hoverable:hover .lsToken__text': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--hoverable:hover .lsToken__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--hoverable.lsToken--selected:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedHoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedHoverBorderColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--hoverable.lsToken--selected:hover .lsToken__text': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedHoverFontColor"
					}
				]
			},
			'@{CustomStyle}.lsToken--hoverable.lsToken--selected:hover .lsToken__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedHoverFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["Tokenizer"] = {
	"name": "Tokenizer",
	"properties": {
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"DisplayOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"FieldHelp": {
			"type": "UCF_ClientInterfaces.E.TokenizerFieldHelp",
			"defaultValue": "OFF"
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"InputPrompt": {
			"type": "string",
			"defaultValue": ''
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"LabelText": {
			"type": "string",
			"defaultValue": ''
		},
		"MaxInputLength": {
			"type": "number",
			"defaultValue": 0
		},
		"MaxInputWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"MaxVisibleLines": {
			"type": "number",
			"defaultValue": 5
		},
		"MinVisibleLines": {
			"type": "number",
			"defaultValue": 1
		},
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"NoInput": {
			"type": "boolean",
			"defaultValue": false
		},
		"Overflow": {
			"type": "UCF_ClientInterfaces.E.TokenizerOverflow",
			"defaultValue": "PUSH"
		},
		"ReadOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"Suggest": {
			"type": "UCF_ClientInterfaces.E.TokenizerSuggest",
			"defaultValue": "OFF"
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"DropTargetInfo": {
			"type": "string"
		},
		"ItemListBoxId": {
			"type": "string"
		}
	},
	"aggregations": {
		"Tokens": {
			"type": "UCF_ClientInterfaces.I.Token",
			"multiple": true,
			"singularName": "Token"
		},
		"RightTokens": {
			"type": "UCF_ClientInterfaces.I.Token",
			"multiple": true,
			"singularName": "RightToken"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Change": {},
		"Enter": {},
		"FieldHelpRequest": {},
		"ListAccess": {},
		"SelectListItem": {},
		"DeleteListItem": {},
		"ActionItemActivate": {},
		"Paste": {},
		"Drop": {}
	},
	"publicMethods": [
		"open",
		"setItemListBoxId",
		"setSuggestFilterCondition",
		"getText",
		"setSelection",
		"setCursorPosition",
		"deleteToken"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for all input field states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size e.g. px, em"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style e.g. italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration e.g. underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "borderRadius",
				"property": "borderRadius",
				"docu": "Defines the border radius"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "@fontColor || contrast(@disabledBackgroundColor)",
				"docu": "Defines the disabled font color"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"docu": "Defines the disabled background color"
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the disabled font color"
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"expression": "@fontColor || contrast(@readonlyValueBackgroundColor)",
				"docu": "Defines the readonly font color"
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "background-color",
				"docu": "Defines the readonly background color"
			},
			{
				"name": "readonlyBorderColor",
				"property": "border-color",
				"docu": "Defines the readonly border color"
			},
			{
				"name": "readonlyValueBackgroundColor",
				"property": "background-color",
				"docu": "Defines the readonly background color of the value"
			},
			{
				"name": "readonlyValueBorderColor",
				"property": "border-color",
				"docu": "Defines the readonly border color of the value"
			},
			{
				"name": "readonlyValueBorderStyle",
				"property": "border-style",
				"docu": "Defines the readonly border style of the value"
			},
			{
				"name": "readonlyValueBorderWidth",
				"property": "border-width",
				"docu": "Defines the readonly border width of the value"
			},
			{
				"name": "readonlyValueBorderRadius",
				"property": "border-radius",
				"docu": "Defines the readonly border radius of the value"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"expression": "@fontColor || contrast(@hoverBackgroundColor)",
				"docu": "Defines the readonly font color"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"docu": "Defines the readonly background color"
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color",
				"expression": "contrast(@borderColor, lighten(@borderColor, 20), darken(@borderColor, 20))",
				"docu": "Defines the readonly border color"
			}
		],
		"classes": {
			'@{CustomStyle}:not(.lsTokenizerDispOnly)': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-radius",
						"important": true,
						"expression": "@borderRadius"
					}
				]
			},
			'@{CustomStyle}:not(.lsTokenizerDispOnly), @{CustomStyle}:not(.lsTokenizerDispOnly).lsTokenizerInvalid, @{CustomStyle}:not(.lsTokenizerDispOnly).lsTokenizerWarning': {
				"properties": [
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					}
				]
			},
			'@{CustomStyle}-combobox .lsField__input': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'@{CustomStyle}-combobox .lsField__input, @{CustomStyle}-roinput-text': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					}
				]
			},
			'@{CustomStyle}-combobox .lsField__help, @{CustomStyle}-combobox.lsField--helpupperhover .lsField__help, @{CustomStyle}-combobox.lsField--helplowerhover .lsField__help': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'@{CustomStyle}.lsTokenizerDsbl:not(.lsTokenizerDispOnly)': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					}
				]
			},
			'.lsTokenizerDsbl @{CustomStyle}-combobox .lsField__input': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsTokenizerDsbl @{CustomStyle}-combobox .lsField__help, .lsTokenizerDsbl @{CustomStyle}-combobox.lsField--helpupperhover .lsField__help, .lsTokenizerDsbl @{CustomStyle}-combobox.lsField--helplowerhover .lsField__help': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'@{CustomStyle}.lsTokenizerRo:not(.lsTokenizerDispOnly), @{CustomStyle}.lsTokenizerRo.lsTokenizerInvalid:not(.lsTokenizerDispOnly), @{CustomStyle}.lsTokenizerRo.lsTokenizerWarning:not(.lsTokenizerDispOnly)': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					}
				]
			},
			'.lsTokenizerRo @{CustomStyle}-combobox .lsField__input': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			'.lsTokenizerRo @{CustomStyle}-combobox .lsField__help, .lsTokenizerRo @{CustomStyle}-combobox.lsField--helpupperhover .lsField__help, .lsTokenizerRo @{CustomStyle}-combobox.lsField--helplowerhover .lsField__help': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			'@{CustomStyle}-roinput': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyValueBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyValueBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@readonlyValueBorderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@readonlyValueBorderWidth"
					},
					{
						"name": "border-radius",
						"important": true,
						"expression": "@readonlyValueBorderRadius"
					}
				]
			},
			'@{CustomStyle}-roinput-text': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'@{CustomStyle}.lsTokenizerHover:not(.lsTokenizerDispOnly):hover, @{CustomStyle}.lsTokenizerInvalid:not(.lsTokenizerDispOnly):hover, @{CustomStyle}.lsTokenizerWarning:not(.lsTokenizerDispOnly):hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					}
				]
			},
			'.lsTokenizerHover:hover @{CustomStyle}-combobox .lsField__input, .lsTokenizerInvalid:hover @{CustomStyle}-combobox .lsField__input, .lsTokenizerWarning:hover @{CustomStyle}-combobox .lsField__input': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsTokenizerHover:hover @{CustomStyle}-combobox .lsField__help, .lsTokenizerHover:hover @{CustomStyle}-combobox.lsField--helpupperhover .lsField__help, .lsTokenizerHover:hover @{CustomStyle}-combobox.lsField--helplowerhover .lsField__help': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["Invisible"] = {
	"name": "Invisible",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["ItemList"] = {
	"name": "ItemList",
	"properties": {
		"Ordered": {
			"type": "boolean",
			"defaultValue": false
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.ItemListItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["ItemListItem"] = {
	"name": "ItemListItem",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"HasImageUrl": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsControl": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasBulletStyle": {
			"type": "boolean",
			"defaultValue": false
		},
		"BulletStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["ItemListBox"] = {
	"name": "ItemListBox",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": '0'
		},
		"VisibleItems": {
			"type": "number",
			"defaultValue": 10
		},
		"Height": {
			"type": "string",
			"defaultValue": '0'
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"MultipleSelection": {
			"type": "boolean",
			"defaultValue": false
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsPopup": {
			"type": "boolean",
			"defaultValue": false
		},
		"DisplayInline": {
			"type": "boolean",
			"defaultValue": false
		},
		"IconVisibility": {
			"type": "UCF_ClientInterfaces.E.ItemListBoxVisibility",
			"defaultValue": "NONE"
		},
		"FirstValueVisibility": {
			"type": "UCF_ClientInterfaces.E.ItemListBoxVisibility",
			"defaultValue": "VISIBLE"
		},
		"SecondValueVisibility": {
			"type": "UCF_ClientInterfaces.E.ItemListBoxVisibility",
			"defaultValue": "NONE"
		},
		"FirstValueTextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"SecondValueTextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"LabelText": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"FirstValueAlign": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"SecondValueAlign": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"DragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"Available": {
			"type": "boolean",
			"defaultValue": true
		},
		"ServerFilter": {
			"type": "string",
			"defaultValue": ''
		},
		"Complete": {
			"type": "boolean",
			"defaultValue": true
		},
		"Filtered": {
			"type": "boolean",
			"defaultValue": true
		},
		"TableDataDefinition": {
			"type": "string",
			"defaultValue": ''
		},
		"ItemTableData": {
			"type": "string",
			"defaultValue": ''
		},
		"HistoryTableData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"TableDataItemDesign": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"ItemsSeparator": {
			"type": "UCF_ClientInterfaces.E.ItemListBoxSeparators",
			"defaultValue": "INNER"
		}
	},
	"aggregations": {
		"HistoryItems": {
			"type": "UCF_ClientInterfaces.I.ItemListBoxItem",
			"multiple": true,
			"singularName": "HistoryItem"
		},
		"Items": {
			"type": "UCF_ClientInterfaces.I.ItemListBoxItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ActionItems": {
			"type": "UCF_ClientInterfaces.I.ItemListBoxActionItem",
			"multiple": true,
			"singularName": "ActionItem"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {},
		"Drag": {},
		"Drop": {},
		"Scroll": {},
		"DoubleClick": {}
	},
	"publicMethods": [
		"setEnabled",
		"selectItemById",
		"deselectItemById",
		"setTooltip",
		"setValue",
		"setValues",
		"getText",
		"getTexts",
		"getValue",
		"getValues",
		"scrollToItemByIndex",
		"createDataTip"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for the menu items."
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight, bold"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size in px"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style, italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration, underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"expression": "contrast(@fontColor)",
				"docu": "Defines the background color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "border",
				"property": "border",
				"docu": "Defines the border of the menu"
			},
			{
				"name": "borderRadius",
				"property": "borderRadius",
				"docu": "Defines the border radius of the menu"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"docu": "Defines the hover background color for enabled items"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"docu": "Defines the font color for hovered items"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"expression": "lighten(greyscale(@backgroundColor),30%)",
				"docu": "Defines the disabled background color of the ItemListBox."
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "lighten(greyscale(@fontColor),20%) || greyscale(contrast(@backgroundColor))",
				"docu": "Defines the disabled font color of the ItemListBox."
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "background-color",
				"expression": "lighten(greyscale(@backgroundColor),30%)",
				"docu": "Defines the readonly background color of the ItemListBox"
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"expression": "lighten(greyscale(@fontColor),20%) || lighten(greyscale(@backgroundColor),10%)",
				"docu": "Defines the readonly font color of the ItemListBox"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					}
				]
			},
			', .lsListbox__items': {
				"properties": [
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			' .lsItemlistbox__content, .lsListbox__value': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			' .lsItemlistbox__content--descriptive, .lsItemlistbox__item--history, .lsItemlistbox__item--group, .lsListbox__value, .lsListbox__values': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'.lsItemlistbox--disabled .lsItemlistbox__content, .lsItemlistbox__content--disabled,.lsListbox--disabled .lsListbox__value,.lsListbox--disabled .lsListbox__values, .lsListbox__value--disabled': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			},
			' .lsItemlistbox__item:hover .lsItemlistbox__content, .lsListbox__value--hover': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@hoverFontColor"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@hoverBackgroundColor"
					}
				]
			},
			'.lsItemlistbox--readonly,.lsItemlistbox--readonly .lsItemlistbox__content--descriptive,.lsListbox--readonly,.lsListbox--readonly .lsListbox__values--descriptive': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					}
				]
			},
			'.lsItemlistbox--disabled,.lsItemlistbox--readonly .lsItemlistbox__content--descriptive, .lsItemlistbox__content--disabled,.lsListbox--disabled,.lsListbox--disabled .lsListbox__values--descriptive, .lsListbox__value--disabled': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ItemListBoxActionItem"] = {
	"name": "ItemListBoxActionItem",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["ItemListBoxItem"] = {
	"name": "ItemListBoxItem",
	"properties": {
		"Key": {
			"type": "string",
			"defaultValue": ''
		},
		"IconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"DisabledIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Value1": {
			"type": "string",
			"defaultValue": ''
		},
		"Value2": {
			"type": "string",
			"defaultValue": ''
		},
		"Selected": {
			"type": "boolean",
			"defaultValue": false
		},
		"IconToolTip": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"GroupTitle": {
			"type": "string",
			"defaultValue": ''
		},
		"Escape": {
			"type": "boolean",
			"defaultValue": true
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.TextViewSemanticColor",
			"defaultValue": "INHERIT",
			"deprecated": true
		},
		"SemanticTextColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"IsDeletable": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["Label"] = {
	"name": "Label",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelFor": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": false
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"RequiredIndicatorTooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Encode": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Size": {
			"type": "UCF_ClientInterfaces.E.LabelSize",
			"defaultValue": "DEFAULT",
			"deprecated": true
		},
		"DesignBar": {
			"type": "UCF_ClientInterfaces.E.LabelDesign",
			"defaultValue": "STANDARD"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"HasIcon": {
			"type": "boolean",
			"defaultValue": false
		},
		"IconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageFirst": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"LabeledControlName": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.LabelTextDesign",
			"defaultValue": "STANDARD"
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Escape": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"Align": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"RequiredIndicatorAtFront": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hidden": {
			"type": "boolean",
			"defaultValue": false
		},
		"ErrorIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"InteractionBehavior": {
			"type": "UCF_ClientInterfaces.E.LabelInteractionBehavior",
			"defaultValue": "REDIRECT_FOCUS"
		},
		"IsNested": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsLink": {
			"type": "boolean",
			"defaultValue": false
		},
		"Editable": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalSpacing": {
			"type": "UCF_ClientInterfaces.E.Spacing",
			"defaultValue": "ALIGNED"
		}
	},
	"events": {
		"DoubleClick": {},
		"Activate": {},
		"Change": {}
	},
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family"
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration"
			},
			{
				"name": "requiredFontColor",
				"property": "color",
				"docu": "Defines the font color for the required indicator"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "@disabledFontColor || @fontColor",
				"docu": "Defines the font color for the disabled status"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"docu": "Defines the font color on mouse over"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color on mouse over"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			':hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					}
				]
			},
			' .lsLabel__required': {
				"properties": [
					{
						"name": "color",
						"expression": "@requiredFontColor"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					}
				]
			},
			' .lsLabel__text': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			' .lsLabel__image': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'.lsControl--monospace,.lsControl--monospace .lsLabel__text': {
				"properties": [
					{
						"name": "font-family",
						"important": true,
						"expression": "@fontFamily"
					}
				]
			},
			':hover .lsLabel__text': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsLabel--disabled,.lsLabel--disabled .lsLabel__text': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			' .lsLabel__text--overflow': {
				"properties": [
					{
						"name": "padding-right",
						"expression": "3px"
					}
				]
			},
			'MultiLine.lsLabel--multiline-ellipsis:after': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsLabel--designbar-colon:after': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemtext': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemicon .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemicon .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["LargeButton"] = {
	"name": "LargeButton",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Down": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasIcon": {
			"type": "boolean",
			"defaultValue": true
		},
		"DisabledIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"UpIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"DownIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"IconPosition": {
			"type": "UCF_ClientInterfaces.E.LargeButtonIconPosition",
			"defaultValue": "TOP"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"HotKey": {
			"type": "UCF_ClientInterfaces.E.HotkeyValue",
			"defaultValue": "NONE"
		},
		"InteractionBehaviour": {
			"type": "UCF_ClientInterfaces.E.ButtonInteractionBehaviour",
			"defaultValue": "PUSH"
		},
		"FontSize": {
			"type": "string",
			"defaultValue": ''
		},
		"HasPopupMenu": {
			"type": "boolean",
			"defaultValue": false
		},
		"PopupMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Press": {},
		"MenuAccess": {}
	},
	"publicMethods": [
		"setEnabled",
		"getEnabled",
		"openMenu",
		"setPopupMenuId",
		"sGetPopupMenuId"
	]
};

UCF_ClientInterfaces["I"]["Legend"] = {
	"name": "Legend",
	"properties": {
		"ColumnCount": {
			"type": "number",
			"defaultValue": 1
		},
		"Width": {
			"type": "string",
			"defaultValue": '100%'
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.LegendItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["LegendItem"] = {
	"name": "LegendItem",
	"properties": {
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"IconUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": '12px'
		},
		"Height": {
			"type": "string",
			"defaultValue": '12px'
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Striped": {
			"type": "boolean",
			"defaultValue": false
		}
	}
};

UCF_ClientInterfaces["I"]["Link"] = {
	"name": "Link",
	"properties": {
		"Size": {
			"type": "UCF_ClientInterfaces.E.LinkSize",
			"defaultValue": "DEFAULT"
		},
		"Target": {
			"type": "string",
			"defaultValue": '_self'
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Reference": {
			"type": "string",
			"defaultValue": ''
		},
		"HasContentStyle": {
			"type": "boolean",
			"defaultValue": true
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"IsTextLink": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasReference": {
			"type": "boolean",
			"defaultValue": false
		},
		"LinkType": {
			"type": "UCF_ClientInterfaces.E.LinkType",
			"defaultValue": "DEFAULT"
		},
		"MimeType": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasPopupMenu": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasLinkCaption": {
			"type": "boolean",
			"defaultValue": false
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"IsNested": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"LabelText": {
			"type": "string",
			"defaultValue": ''
		},
		"Emphasized": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowAccessKey": {
			"type": "boolean",
			"defaultValue": true
		},
		"Hotkey": {
			"type": "UCF_ClientInterfaces.E.HotkeyValue",
			"defaultValue": "NONE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalSpacing": {
			"type": "UCF_ClientInterfaces.E.Spacing",
			"defaultValue": "ALIGNED"
		},
		"Rel": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentVisibility": {
			"type": "UCF_ClientInterfaces.E.ContentVisibility",
			"defaultValue": "ALL"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"LinkCaption": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Activate": {},
		"DoubleClick": {}
	},
	"publicMethods": [
		"setIconSource",
		"setTooltip",
		"setText",
		"setRel",
		"getRel"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for Link"
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color for Link"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight for Link"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size for Link"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style for Link"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the ftext decoration for Link"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"expression": "@hoverFontColor || @fontColor",
				"docu": "Defines the font color for hovered Link"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "@disabledFontColor || @fontColor",
				"docu": "Defines the font color for disabled Link"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			' .lsLink__text': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			' .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			' .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.urLnkDsbl': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.urLnkDsbl .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.urLnkDsbl .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			},
			'.urLnk:hover,.urLnk:hover .lsLink__text': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.urLnk:hover .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.urLnk:hover .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemtext': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView:not(.lsHierarchicalview__item--active)': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView:not(.lsHierarchicalview__item--active) .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active)': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active) .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["LinkChoice"] = {
	"name": "LinkChoice",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"PopupMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowAccessKey": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageFirst": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageAlt": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentVisibility": {
			"type": "UCF_ClientInterfaces.E.ContentVisibility",
			"defaultValue": "ALL"
		}
	},
	"events": {
		"MenuAccess": {}
	},
	"publicMethods": [
		"openMenu",
		"setPopupMenuId",
		"setText"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for LinkChoice"
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color for LinkChoice"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight for LinkChoice"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size for LinkChoice"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style for LinkChoice"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the ftext decoration for LinkChoice"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"expression": "@hoverFontColor || @fontColor",
				"docu": "Defines the font color for hovered LinkChoice"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "@disabledFontColor || @fontColor",
				"docu": "Defines the font color for disabled LinkChoice"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			' .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			' .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.urLnkDsbl,.lsLinkchoice--disabled': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemtext': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView:not(:active):not(.lsHierarchicalview__item--active)': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView:not(:active):not(.lsHierarchicalview__item--active) .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active)': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active) .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["LoadingAnimation"] = {
	"name": "LoadingAnimation",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Delay": {
			"type": "number",
			"defaultValue": 2000
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"FooterToolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Show": {},
		"Hide": {}
	},
	"publicMethods": [
		"trigger",
		"show",
		"cancel",
		"setText",
		"getText"
	]
};

UCF_ClientInterfaces["I"]["MatrixLayout"] = {
	"name": "MatrixLayout",
	"properties": {
		"FixedLayout": {
			"type": "boolean",
			"defaultValue": false
		},
		"MarginTop": {
			"type": "string",
			"defaultValue": '0px'
		},
		"MarginBottom": {
			"type": "string",
			"defaultValue": '0px'
		},
		"MarginLeft": {
			"type": "string",
			"defaultValue": '0px'
		},
		"MarginRight": {
			"type": "string",
			"defaultValue": '0px'
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"DebugMode": {
			"type": "boolean",
			"defaultValue": false
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"DropDecoratorType": {
			"type": "UCF_ClientInterfaces.E.LayoutDropDecorator",
			"defaultValue": "BOX"
		},
		"SingleCellOptimization": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"DragSourceInfo": {
			"type": "string"
		},
		"DropTargetInfo": {
			"type": "string"
		}
	},
	"aggregations": {
		"Rows": {
			"type": "UCF_ClientInterfaces.I.MatrixLayoutRow",
			"multiple": true,
			"singularName": "Row"
		},
		"RasterItems": {
			"type": "UCF_ClientInterfaces.I.RasterLayoutItem",
			"multiple": true,
			"singularName": "RasterItem"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Resize": {},
		"Drag": {},
		"Drop": {}
	},
	"publicMethods": [
		"setWidth",
		"setHeight"
	],
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the MatrixLayout"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["MatrixLayoutCell"] = {
	"name": "MatrixLayoutCell",
	"properties": {
		"ColSpan": {
			"type": "number",
			"defaultValue": 1
		},
		"RowSpan": {
			"type": "number",
			"defaultValue": 1
		},
		"HAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "LEFT"
		},
		"VAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "MIDDLE"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"CellDesign": {
			"type": "UCF_ClientInterfaces.E.LayoutCellDesign",
			"defaultValue": "DEFAULT"
		},
		"CellSeparation": {
			"type": "UCF_ClientInterfaces.E.LayoutCellSeparation",
			"defaultValue": "DEFAULT"
		},
		"CellBackgroundDesign": {
			"type": "UCF_ClientInterfaces.E.CellBackgroundDesign",
			"defaultValue": "TRANSPARENT"
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasBorder": {
			"type": "boolean",
			"defaultValue": false
		},
		"DragData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"LayoutCellPosition": {
			"type": "UCF_ClientInterfaces.E.LayoutCellPosition",
			"defaultValue": "DEFAULT"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the MatrixLayoutCell"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "padding",
				"property": "padding",
				"docu": "Padding"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "padding",
						"expression": "@padding"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["MatrixLayoutRow"] = {
	"name": "MatrixLayoutRow",
	"aggregations": {
		"Cells": {
			"type": "UCF_ClientInterfaces.I.MatrixLayoutCell",
			"multiple": true,
			"singularName": "Cell"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["MeltingGroup"] = {
	"name": "MeltingGroup",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Width": {
			"type": "string",
			"defaultValue": '100%'
		},
		"UsedInSapTable": {
			"type": "boolean",
			"defaultValue": false
		},
		"IgnoreSeparationInSapTable": {
			"type": "boolean",
			"defaultValue": true
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"FixedColWidth": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"IsLayout": {
			"type": "boolean",
			"defaultValue": false
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Cells": {
			"type": "UCF_ClientInterfaces.I.MeltingGroupCell",
			"multiple": true,
			"singularName": "Cell"
		},
		"Legend": {
			"type": "UCF_ClientInterfaces.I.Legend",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"setCellSelectionState",
		"getCellDisplayValue"
	]
};

UCF_ClientInterfaces["I"]["MeltingGroupCell"] = {
	"name": "MeltingGroupCell",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Separation": {
			"type": "UCF_ClientInterfaces.E.LayoutCellSeparation",
			"defaultValue": "DEFAULT"
		},
		"HAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "BEGINOFLINE"
		},
		"VAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "TOP"
		},
		"ExWidth": {
			"type": "number",
			"defaultValue": 0
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"SemanticTextColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"SelectionState": {
			"type": "UCF_ClientInterfaces.E.SapTableSelectionState",
			"defaultValue": "NONE",
			"deprecated": true
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["MenuBar"] = {
	"name": "MenuBar",
	"properties": {
		"Design": {
			"type": "UCF_ClientInterfaces.E.MenuBarDesign",
			"defaultValue": "STANDARD"
		},
		"Width": {
			"type": "string",
			"defaultValue": '100%'
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.MenuBarItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"MenuAccess": {}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "borderRadius",
				"property": "borderRadius",
				"docu": "Defines the border radius"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["MenuBarItem"] = {
	"name": "MenuBarItem",
	"properties": {
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Caption": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"PopupMenuId": {
			"type": "string"
		}
	},
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family"
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size e.g. px, em"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style e.g. italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration e.g. underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "borderRadius",
				"property": "borderRadius",
				"docu": "Defines the border radius"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"docu": "Defines the disabled font color"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"docu": "Defines the disabled background-color"
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the disabled border-color."
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"docu": "Defines the hover background-color"
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color",
				"docu": "Defines the hover border-color."
			},
			{
				"name": "hoverColor",
				"property": "color",
				"docu": "Defines the hover font color"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "height",
						"expression": "auto"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsMenuBar--item-disabled': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					}
				]
			},
			'.lsMenuBar--item-hoverable:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverColor"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["Message"] = {
	"name": "Message",
	"properties": {
		"Type": {
			"type": "UCF_ClientInterfaces.E.MessageType",
			"defaultValue": "NONE"
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasContent": {
			"type": "boolean",
			"defaultValue": false
		},
		"ConnectedControlId": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {},
		"ContentAccess": {}
	}
};

UCF_ClientInterfaces["I"]["MessageArea"] = {
	"name": "MessageArea",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": '400px'
		},
		"IsPinned": {
			"type": "boolean",
			"defaultValue": false
		},
		"VisibleMessageCount": {
			"type": "number",
			"defaultValue": 1
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"AdjustHeight": {
			"type": "boolean",
			"defaultValue": true
		},
		"ContentAccessId": {
			"type": "string",
			"defaultValue": ''
		},
		"AllowUnpin": {
			"type": "boolean",
			"defaultValue": true
		},
		"IsOpened": {
			"type": "boolean",
			"defaultValue": false
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"Top": {
			"type": "string",
			"defaultValue": ''
		},
		"Left": {
			"type": "string",
			"defaultValue": ''
		},
		"FilterType": {
			"type": "UCF_ClientInterfaces.E.MessageFilterType",
			"defaultValue": "ALL"
		},
		"AllowPin": {
			"type": "boolean",
			"defaultValue": true
		},
		"MessageMode": {
			"type": "UCF_ClientInterfaces.E.MessageMode",
			"defaultValue": "MULTI"
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"HasContentPadding": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"Messages": {
			"type": "UCF_ClientInterfaces.I.Message",
			"multiple": true,
			"singularName": "Message"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Pin": {},
		"Unpin": {},
		"Expand": {},
		"Collapse": {},
		"Resize": {},
		"Reposition": {},
		"Filter": {}
	}
};

UCF_ClientInterfaces["I"]["MessageBar"] = {
	"name": "MessageBar",
	"properties": {
		"Design": {
			"type": "UCF_ClientInterfaces.E.MessageBarDesign",
			"defaultValue": "STANDARD"
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.MessageType",
			"defaultValue": "NONE"
		},
		"RulerDisplay": {
			"type": "UCF_ClientInterfaces.E.MessageBarRulerDisplay",
			"defaultValue": "BOTTOM"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ConnectedControlId": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"HasHelpLink": {
			"type": "boolean",
			"defaultValue": false
		},
		"HelpLinkText": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"FocusData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"BindingPath": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"DoubleClick": {},
		"Click": {},
		"ActivateHelp": {}
	},
	"publicMethods": [
		"setText",
		"setType"
	],
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the MessageBar"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "borderRadius",
				"property": "border-radius",
				"docu": "Defines the border-radius for the content"
			},
			{
				"name": "margin",
				"property": "margin",
				"docu": "Defines the margin for the content"
			},
			{
				"name": "padding",
				"property": "padding",
				"docu": "Defines the padding for the content"
			},
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for all button states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urL,color)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urL,font-size)"
			},
			{
				"name": "fontStyle",
				"property": "font-style"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration for TextView"
			}
		],
		"classes": {
			'@{CustomStyle}.lsMessageBar--standard': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "margin",
						"expression": "@margin"
					},
					{
						"name": "padding",
						"expression": "@padding"
					}
				]
			},
			' .urTxtStd, .urLnkReport, .lsMessageBar__text, .lsMessageBar__link': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			' .urTxtColor, .lsMessageBar__text': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			' .lsMsgBarIcn': {
				"properties": [
					{
						"name": "vertical-align",
						"expression": "middle"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["MessageToast"] = {
	"name": "MessageToast",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"OpenerId": {
			"type": "string",
			"defaultValue": ''
		},
		"Duration": {
			"type": "number",
			"defaultValue": 5000
		}
	},
	"publicMethods": [
		"setText",
		"show",
		"close"
	]
};

UCF_ClientInterfaces["I"]["GridBinding"] = {
	"name": "GridBinding",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"Path": {
			"type": "string",
			"defaultValue": null
		},
		"ManageRange": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"Template": {
			"type": "UCF_ClientElement",
			"multiple": false
		}
	}
};

UCF_ClientInterfaces["I"]["ListBinding"] = {
	"name": "ListBinding",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"Path": {
			"type": "string",
			"defaultValue": null
		},
		"ManageRange": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"Template": {
			"type": "UCF_ClientElement",
			"multiple": false
		}
	}
};

UCF_ClientInterfaces["I"]["ModelControl"] = {
	"name": "ModelControl",
	"properties": {
		"IsDefaultModel": {
			"type": "boolean",
			"defaultValue": false
		},
		"Data": {
			"type": "string",
			"defaultValue": null
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"DataChange": {},
		"UpdateGrid": {},
		"UpdateList": {},
		"UpdateSelection": {},
		"UpdateGridSelection": {}
	},
	"publicMethods": [
		"updateBindings"
	]
};

UCF_ClientInterfaces["I"]["ModelData"] = {
	"name": "ModelData",
	"properties": {
		"Path": {
			"type": "string",
			"defaultValue": null
		},
		"Merge": {
			"type": "boolean",
			"defaultValue": false
		},
		"Data": {
			"type": "string",
			"defaultValue": null
		}
	}
};

UCF_ClientInterfaces["I"]["ModelUpdate"] = {
	"name": "ModelUpdate",
	"properties": {
		"Data": {
			"type": "string",
			"defaultValue": null
		},
		"Merge": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"PartialData": {
			"type": "UCF_ClientInterfaces.I.ModelData",
			"multiple": true,
			"singularName": "PartialData"
		}
	}
};

UCF_ClientInterfaces["I"]["PropertyBinding"] = {
	"name": "PropertyBinding",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"Path": {
			"type": "string",
			"defaultValue": null
		},
		"Type": {
			"type": "string",
			"defaultValue": null
		},
		"TypeConfiguration": {
			"type": "string",
			"defaultValue": null
		}
	}
};

UCF_ClientInterfaces["I"]["TemplateItem"] = {
	"name": "TemplateItem",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Control": {
			"type": "UCF_ClientElement",
			"multiple": false
		}
	}
};

UCF_ClientInterfaces["I"]["TemplateList"] = {
	"name": "TemplateList",
	"properties": {
		"ItemName": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.TemplateItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["MultiComboBox"] = {
	"name": "MultiComboBox",
	"properties": {
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"ReadOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"ItemListBoxId": {
			"type": "string"
		}
	},
	"events": {
		"Select": {}
	}
};

UCF_ClientInterfaces["I"]["NavigationList"] = {
	"name": "NavigationList",
	"properties": {
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"Expandable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Expanded": {
			"type": "boolean",
			"defaultValue": true
		},
		"Personalizable": {
			"type": "boolean",
			"defaultValue": false
		},
		"ContentHeight": {
			"type": "number",
			"defaultValue": 0
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Groups": {
			"type": "UCF_ClientInterfaces.I.NavigationListGroup",
			"multiple": true,
			"singularName": "Group"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {},
		"Expand": {},
		"Collapse": {},
		"MenuAccess": {},
		"Personalize": {}
	}
};

UCF_ClientInterfaces["I"]["NavigationListGroup"] = {
	"name": "NavigationListGroup",
	"properties": {
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"IsClickable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.NavigationListItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["NavigationListItem"] = {
	"name": "NavigationListItem",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"IconUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Selected": {
			"type": "boolean",
			"defaultValue": false
		},
		"ContextMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"PopupMenuId": {
			"type": "string"
		}
	}
};

UCF_ClientInterfaces["I"]["ObjectContainer"] = {
	"name": "ObjectContainer",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"Height": {
			"type": "string",
			"defaultValue": null
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"ARIALandmark": {
			"type": "UCF_ClientInterfaces.E.ARIALandmark",
			"defaultValue": "region"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Headers": {
			"type": "UCF_ClientInterfaces.I.ObjectHeader",
			"multiple": true,
			"singularName": "Header"
		},
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"Footer": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Scroll": {},
		"Hotkey": {}
	},
	"publicMethods": [
		"setScrollPosition",
		"getScrollPosition",
		"setDefaultButtonId"
	]
};

UCF_ClientInterfaces["I"]["ObjectHeader"] = {
	"name": "ObjectHeader",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Attach": {
			"type": "boolean",
			"defaultValue": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"ARIALandmark": {
			"type": "UCF_ClientInterfaces.E.ARIALandmark",
			"defaultValue": "region"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["ObjectNavigation"] = {
	"name": "ObjectNavigation",
	"properties": {
		"FirstItemId": {
			"type": "string",
			"defaultValue": null
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.ObjectNavigationItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"ItemScroll": {}
	}
};

UCF_ClientInterfaces["I"]["ObjectNavigationItem"] = {
	"name": "ObjectNavigationItem",
	"properties": {
		"Caption": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"IconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"IconSemantic": {
			"type": "UCF_ClientInterfaces.E.HorizontalContextualPanelIconSemantic",
			"defaultValue": "DEFAULT"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["ContainerAppend"] = {
	"name": "ContainerAppend",
	"properties": {
		"ContainerId": {
			"type": "string",
			"defaultValue": null
		},
		"ControlId": {
			"type": "string",
			"defaultValue": null
		},
		"ControlTree": {
			"type": "string",
			"defaultValue": ''
		},
		"SuppressControlTreeRendering": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		}
	}
};

UCF_ClientInterfaces["I"]["ContainerUpdate"] = {
	"name": "ContainerUpdate",
	"properties": {
		"ContainerId": {
			"type": "string",
			"defaultValue": null
		},
		"ControlTree": {
			"type": "string",
			"defaultValue": ''
		},
		"SuppressControlTreeRendering": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		}
	}
};

UCF_ClientInterfaces["I"]["ControlUpdate"] = {
	"name": "ControlUpdate",
	"properties": {
		"ControlId": {
			"type": "string",
			"defaultValue": null
		},
		"UpdateMethod": {
			"type": "UCF_ClientInterfaces.E.ControlUpdateMethod",
			"defaultValue": "FULL"
		},
		"ControlTree": {
			"type": "string",
			"defaultValue": ''
		},
		"SuppressControlTreeRendering": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		}
	}
};

UCF_ClientInterfaces["I"]["DeltaUpdate"] = {
	"name": "DeltaUpdate",
	"properties": {
		"WindowId": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"UpdateSections": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "UpdateSection",
			"bindable": true
		}
	}
};

UCF_ClientInterfaces["I"]["FullUpdate"] = {
	"name": "FullUpdate",
	"properties": {
		"PageId": {
			"type": "string",
			"defaultValue": ''
		},
		"WindowId": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"AssociatedContent": {
			"type": "UCF_ClientInterfaces.I.Container",
			"multiple": false
		},
		"ScriptCalls": {
			"type": "UCF_ClientInterfaces.I.ScriptCall",
			"multiple": true,
			"singularName": "ScriptCall"
		},
		"Animations": {
			"type": "UCF_ClientInterfaces.I.Animation",
			"multiple": true,
			"singularName": "Animation"
		},
		"ModelUpdates": {
			"type": "UCF_ClientInterfaces.I.ModelUpdate",
			"multiple": true,
			"singularName": "ModelUpdate"
		}
	}
};

UCF_ClientInterfaces["I"]["HTMLUpdate"] = {
	"name": "HTMLUpdate",
	"properties": {
		"ControlId": {
			"type": "string",
			"defaultValue": null
		},
		"HTML": {
			"type": "string",
			"defaultValue": null
		},
		"IsInnerHtml": {
			"type": "boolean",
			"defaultValue": false
		},
		"ControlTree": {
			"type": "string",
			"defaultValue": ''
		},
		"SuppressControlTreeRendering": {
			"type": "boolean",
			"defaultValue": false
		}
	}
};

UCF_ClientInterfaces["I"]["IHub"] = {
	"name": "IHub",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Plugins": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Plugin",
			"bindable": true
		}
	}
};

UCF_ClientInterfaces["I"]["IHubEventing"] = {
	"name": "IHubEventing",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"ExternalEvent": {}
	},
	"publicMethods": [
		"raiseEvent",
		"subscribeEvent",
		"unsubscribeEvent"
	]
};

UCF_ClientInterfaces["I"]["IHubFrameProtect"] = {
	"name": "IHubFrameProtect",
	"properties": {
		"Whitelist": {
			"type": "string",
			"defaultValue": ''
		},
		"ClickjackProtectionScript": {
			"type": "string",
			"defaultValue": ''
		},
		"ErrorMessageWhitelist": {
			"type": "string",
			"defaultValue": ''
		},
		"ErrorMessageNoRepsonse": {
			"type": "string",
			"defaultValue": ''
		},
		"TimeoutValue": {
			"type": "string",
			"defaultValue": '5000'
		},
		"ErrorMsgWLSNotReached": {
			"type": "string",
			"defaultValue": ''
		},
		"WhitelistService": {
			"type": "string",
			"defaultValue": ''
		},
		"ProtectionMethod": {
			"type": "UCF_ClientInterfaces.E.FrameProtection",
			"defaultValue": "LOCKEVENTS"
		},
		"AllowSameOrigin": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["IHubLegacyWDJ"] = {
	"name": "IHubLegacyWDJ",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"PendingPreNavigate": {}
	},
	"publicMethods": [
		"raisePortalEventToOpener",
		"setWindowTitle",
		"enableEBN",
		"disableEBN",
		"checkEBN",
		"captureScreen",
		"setPreNavigate",
		"closeWindow"
	]
};

UCF_ClientInterfaces["I"]["IHubMessaging"] = {
	"name": "IHubMessaging",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Receive": {}
	},
	"publicMethods": [
		"subscribeMessage",
		"unsubscribeMessage"
	]
};

UCF_ClientInterfaces["I"]["IHubNavigation"] = {
	"name": "IHubNavigation",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"publicMethods": [
		"navigateAbsolute",
		"navigateRelative",
		"navigateObjectBased"
	]
};

UCF_ClientInterfaces["I"]["IHubPostMessage"] = {
	"name": "IHubPostMessage",
	"properties": {
		"ServiceProviderListId": {
			"type": "string",
			"defaultValue": ''
		},
		"Target": {
			"type": "string",
			"defaultValue": ''
		},
		"Contents": {
			"type": "string",
			"defaultValue": ''
		},
		"Synchronous": {
			"type": "boolean",
			"defaultValue": false
		},
		"ServiceWhitelist": {
			"type": "string",
			"defaultValue": null
		},
		"ServiceTreatmentsId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Receive": {},
		"RequestReceive": {}
	},
	"publicMethods": [
		"postMessage",
		"addToServiceWhitelist"
	]
};

UCF_ClientInterfaces["I"]["IHubWebSocket"] = {
	"name": "IHubWebSocket",
	"properties": {
		"Url": {
			"type": "string",
			"defaultValue": ''
		},
		"Protocols": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Receive": {},
		"Error": {}
	},
	"publicMethods": [
		"send"
	]
};

UCF_ClientInterfaces["I"]["IHubWebSocketPcp"] = {
	"name": "IHubWebSocketPcp",
	"properties": {
		"ProtocolImplementation": {
			"type": "string",
			"defaultValue": '/sap/public/bc/ur/sap-pcp-websocket.js'
		},
		"ConnectionProperties": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Receive": {},
		"ReceivePcpEventSeverity0": {},
		"ReceivePcpEventSeverity1": {},
		"Error": {},
		"Close": {}
	},
	"publicMethods": [
		"open",
		"send",
		"register",
		"close"
	]
};

UCF_ClientInterfaces["I"]["IHubWorkProtect"] = {
	"name": "IHubWorkProtect",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["LinkedResource"] = {
	"name": "LinkedResource",
	"properties": {
		"Href": {
			"type": "string",
			"defaultValue": ''
		},
		"Rel": {
			"type": "string",
			"defaultValue": ''
		},
		"Media": {
			"type": "string",
			"defaultValue": ''
		},
		"HrefLang": {
			"type": "string",
			"defaultValue": ''
		},
		"Type": {
			"type": "string",
			"defaultValue": ''
		},
		"Title": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["LoadingPlaceHolder"] = {
	"name": "LoadingPlaceHolder",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Load": {}
	}
};

UCF_ClientInterfaces["I"]["LSXUpdate"] = {
	"name": "LSXUpdate",
	"properties": {
		"ControlId": {
			"type": "string",
			"defaultValue": null
		},
		"Content": {
			"type": "string",
			"defaultValue": null
		}
	}
};

UCF_ClientInterfaces["I"]["MessagingTrigger"] = {
	"name": "MessagingTrigger",
	"properties": {
		"ServiceProviderId": {
			"type": "string",
			"defaultValue": ''
		},
		"MessageName": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Receive": {}
	}
};

UCF_ClientInterfaces["I"]["Meta"] = {
	"name": "Meta",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Content": {
			"type": "string",
			"defaultValue": ''
		},
		"Language": {
			"type": "string",
			"defaultValue": ''
		},
		"IsHttpEquiv": {
			"type": "boolean",
			"defaultValue": false
		}
	}
};

UCF_ClientInterfaces["I"]["Page"] = {
	"name": "Page",
	"properties": {
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"HasMargin": {
			"type": "boolean",
			"defaultValue": false
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.PageDesign",
			"defaultValue": "DEFAULT"
		},
		"InitBaseLibrary": {
			"type": "boolean",
			"defaultValue": true
		},
		"DomainRelax": {
			"type": "UCF_ClientInterfaces.E.DomainRelax",
			"defaultValue": "AUTO"
		},
		"Icon": {
			"type": "string",
			"defaultValue": 'default'
		},
		"FormId": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollingMode": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "NONE"
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"BrowserHistory": {
			"type": "UCF_ClientInterfaces.E.BrowserHistory",
			"defaultValue": "ENABLED"
		},
		"HeadComment": {
			"type": "string",
			"defaultValue": ''
		},
		"UnloadUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"VerticalSizing": {
			"type": "UCF_ClientInterfaces.E.Sizing",
			"defaultValue": "FILL"
		},
		"DirtyMode": {
			"type": "UCF_ClientInterfaces.E.DirtyMode",
			"defaultValue": "CLIENTSERVER"
		},
		"Dirty": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hash": {
			"type": "string",
			"defaultValue": ''
		},
		"HashChangedNotification": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasEventQueue": {
			"type": "boolean",
			"defaultValue": true
		},
		"SessionTimeout": {
			"type": "number",
			"defaultValue": 0
		},
		"SessionKeepAliveUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"ControlTree": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"SessionTimeoutActionUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"SessionTimeoutActionTarget": {
			"type": "string",
			"defaultValue": ''
		},
		"SessionTimeoutActionText": {
			"type": "string",
			"defaultValue": ''
		},
		"SessionHandling": {
			"type": "UCF_ClientInterfaces.E.PageSessionHandling",
			"defaultValue": "DEFAULT"
		},
		"SessionTimeoutBehavior": {
			"type": "UCF_ClientInterfaces.E.SessionTimeoutBehavior",
			"defaultValue": "PAGE"
		},
		"SessionLogoutServiceName": {
			"type": "string",
			"defaultValue": 'sap.ushell.sessionHandler.logout'
		},
		"SessionExtendServiceName": {
			"type": "string",
			"defaultValue": 'sap.ushell.sessionHandler.extendSession'
		},
		"SessionTimeoutWarning": {
			"type": "number",
			"defaultValue": 0
		},
		"ARIALandmark": {
			"type": "UCF_ClientInterfaces.E.ARIALandmark",
			"defaultValue": "main"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"AssociatedContent": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ScriptIncludes": {
			"type": "UCF_ClientInterfaces.I.PageScriptInclude",
			"multiple": true,
			"singularName": "ScriptInclude",
			"deprecated": true
		},
		"Styles": {
			"type": "UCF_ClientInterfaces.I.Style",
			"multiple": true,
			"singularName": "Style"
		},
		"HeadScripts": {
			"type": "UCF_ClientInterfaces.I.Script",
			"multiple": true,
			"singularName": "HeadScript"
		},
		"BodyScripts": {
			"type": "UCF_ClientInterfaces.I.Script",
			"multiple": true,
			"singularName": "BodyScript"
		},
		"Meta": {
			"type": "UCF_ClientInterfaces.I.Meta",
			"multiple": true,
			"singularName": "Meta"
		},
		"LoadingAnimation": {
			"type": "UCF_ClientInterfaces.I.LoadingAnimation",
			"multiple": false
		},
		"InitialUpdate": {
			"type": "UCF_ClientInterfaces.I.PageUpdate",
			"multiple": false
		},
		"Form": {
			"type": "UCF_ClientInterfaces.I.Form",
			"multiple": false
		},
		"IHub": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"LinkedResources": {
			"type": "UCF_ClientInterfaces.I.LinkedResource",
			"multiple": true,
			"singularName": "LinkedResource"
		},
		"HeadContent": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"Animations": {
			"type": "UCF_ClientInterfaces.I.Animation",
			"multiple": true,
			"singularName": "Animation"
		},
		"Models": {
			"type": "UCF_ClientInterfaces.I.ModelControl",
			"multiple": true,
			"singularName": "Model"
		},
		"SessionTimeoutPopupWindow": {
			"type": "UCF_ClientInterfaces.I.PopupWindow",
			"multiple": false
		}
	},
	"events": {
		"Help": {},
		"ContextMenu": {},
		"FocusChange": {},
		"Hotkey": {},
		"Back": {},
		"Scroll": {},
		"Request": {},
		"Resize": {},
		"HashChanged": {},
		"DragEnter": {},
		"DragLeave": {},
		"Initialized": {},
		"ControlsInitialized": {}
	},
	"publicMethods": [
		"setTitle",
		"setHasMargin",
		"setBrowserHistory",
		"setFocus",
		"showModalDialog",
		"openModalPopup",
		"closePopup",
		"closeAllModalPopups",
		"openExternalWindow",
		"openExternalWindowByPost",
		"closeExternalWindow",
		"closeWindow",
		"setKeepAlive",
		"setDragData",
		"downloadFile",
		"scrollIntoView",
		"setDirty",
		"print",
		"setUnloadUrl",
		"redirect",
		"setHash",
		"getHash",
		"setHashChangedNotification",
		"setDirtyMode",
		"enableDataLossPopup",
		"setScrollingMode",
		"setDefaultButtonId",
		"addStyle",
		"addScript",
		"changeThemeUrl",
		"addCustomStyleClass",
		"removeCustomStyleClass",
		"applyCustomStyles",
		"setConditionalRules",
		"setConditionalControlMapping",
		"applyConditionalRules",
		"applyPositions",
		"applyMargins",
		"disableContextMenuEvent",
		"enableContextMenuEvent",
		"setPreunloadUrl",
		"setSessionState",
		"sendPreunloadRequest",
		"loadLess",
		"setMessageFocusToggleInfo",
		"ariaAlertMessage",
		"setAccessibility",
		"fileSelect",
		"waitForServiceAvailability",
		"setRole",
		"ariaInvisibleAlert",
		"ariaRemoveAllAlerts",
		"showMessageToast",
		"closeMessageToast",
		"setSessionKeepAliveUrl"
	],
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urTWhl,background-color)"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"docu": "Defines the background image for the content"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background image X position for the content"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background image Y position for the content"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"docu": "Defines the background image streching mode for the content"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"docu": "Background size, cover, contain"
			},
			{
				"name": "scrollBarBackgroundColor",
				"property": "background-color",
				"expression": "@backgroundColor||@scrollBarBackgroundColor"
			},
			{
				"name": "scrollBarThumbBackgroundColor",
				"property": "background-color",
				"expression": "@scrollBarThumbBackgroundColor || darken(@scrollBarBackgroundColor,8%) || darken(@backgroundColor,8%)"
			},
			{
				"name": "scrollBarThumbBorderColor",
				"property": "border-color",
				"expression": "darken(@scrollBarThumbBackgroundColor,8%) || darken(@scrollBarBackgroundColor,8%) || darken(@backgroundColor,8%)"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize"
					}
				]
			},
			'::-webkit-scrollbar,    ::-webkit-scrollbar': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@scrollBarBackgroundColor"
					}
				]
			},
			'::-webkit-scrollbar-corner,    ::-webkit-scrollbar-corner': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@scrollBarBackgroundColor"
					}
				]
			},
			'::-webkit-scrollbar-thumb,    ::-webkit-scrollbar-thumb': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@scrollBarThumbBackgroundColor"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@scrollBarThumbBorderColor"
					}
				]
			},
			'  body': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@scrollBarThumbBackgroundColor"
					}
				]
			},
			'	.urSCBHHdl .urSCBBtn, .urSCBVHdl .urSCBBtn': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@scrollBarThumbBackgroundColor"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@scrollBarThumbBorderColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["PageScriptInclude"] = {
	"name": "PageScriptInclude",
	"properties": {
		"Type": {
			"type": "UCF_ClientInterfaces.E.PageScriptIncludeType",
			"defaultValue": "CUSTOM"
		},
		"Src": {
			"type": "string",
			"defaultValue": ''
		},
		"Content": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PageStyleInclude"] = {
	"name": "PageStyleInclude",
	"properties": {
		"Src": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PageUpdate"] = {
	"name": "PageUpdate",
	"aggregations": {
		"Updates": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Update",
			"bindable": true
		}
	}
};

UCF_ClientInterfaces["I"]["PMServiceDirty"] = {
	"name": "PMServiceDirty",
	"properties": {
		"Target": {
			"type": "string",
			"defaultValue": 'parent.parent'
		},
		"TargetService": {
			"type": "string",
			"defaultValue": 'sap.ushell.services.Container.setDirtyFlag'
		},
		"IgnoreResponse": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PMServiceGenericResponder"] = {
	"name": "PMServiceGenericResponder",
	"properties": {
		"TargetService": {
			"type": "string",
			"defaultValue": ''
		},
		"Response": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PMServiceStatefulContainer"] = {
	"name": "PMServiceStatefulContainer",
	"properties": {
		"Target": {
			"type": "string",
			"defaultValue": ''
		},
		"ServiceName": {
			"type": "string",
			"defaultValue": 'sap.ushell.services.appLifeCycle'
		},
		"Receive": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PMServiceThemeChange"] = {
	"name": "PMServiceThemeChange"
};

UCF_ClientInterfaces["I"]["PMServiceTimeout"] = {
	"name": "PMServiceTimeout",
	"properties": {
		"Target": {
			"type": "string",
			"defaultValue": 'parent.parent'
		},
		"TargetService": {
			"type": "string",
			"defaultValue": 'sap.ushell.services.Container.setDirtyFlag'
		},
		"IgnoreResponse": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PMServiceUShellSessionHandler"] = {
	"name": "PMServiceUShellSessionHandler",
	"properties": {
		"Target": {
			"type": "string",
			"defaultValue": 'parent.parent'
		},
		"NotifyUserActive": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PMServiceWebAssistant"] = {
	"name": "PMServiceWebAssistant",
	"properties": {
		"Technology": {
			"type": "string",
			"defaultValue": 'OTHER'
		},
		"ServiceType": {
			"type": "string",
			"defaultValue": 'WebAssistant'
		},
		"ServiceName": {
			"type": "string",
			"defaultValue": 'sap.webassistant.services.updateHotspots'
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PostMessageService"] = {
	"name": "PostMessageService",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"Implementation": {
			"type": "string",
			"defaultValue": null
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PostMessageServices"] = {
	"name": "PostMessageServices",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"PostMessageService": {
			"type": "UCF_ClientInterfaces.I.PostMessageService",
			"multiple": true,
			"singularName": "PostMessageService"
		}
	},
	"publicMethods": [
		"addPostMessageService",
		"removePostMessageService"
	]
};

UCF_ClientInterfaces["I"]["PostMessageTreatment"] = {
	"name": "PostMessageTreatment",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"ClientAction": {
			"type": "UCF_ClientInterfaces.E.ClientAction",
			"defaultValue": "ENQUEUE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PostMessageTreatments"] = {
	"name": "PostMessageTreatments",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"PostMessageTreatment": {
			"type": "UCF_ClientInterfaces.I.PostMessageTreatment",
			"multiple": true,
			"singularName": "PostMessageTreatment"
		}
	},
	"publicMethods": [
		"addPostMessageTreatment",
		"removePostMessageTreatment",
		"getClientAction"
	]
};

UCF_ClientInterfaces["I"]["Script"] = {
	"name": "Script",
	"properties": {
		"Type": {
			"type": "UCF_ClientInterfaces.E.ScriptType",
			"defaultValue": "CUSTOM"
		},
		"Src": {
			"type": "string",
			"defaultValue": ''
		},
		"Content": {
			"type": "string",
			"defaultValue": ''
		},
		"ResourceRoot": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"CustomAttributes": {
			"type": "UCF_ClientInterfaces.I.Attribute",
			"multiple": true,
			"singularName": "CustomAttribute"
		}
	}
};

UCF_ClientInterfaces["I"]["ScriptCall"] = {
	"name": "ScriptCall",
	"properties": {
		"Script": {
			"type": "string",
			"defaultValue": ''
		},
		"Phase": {
			"type": "UCF_ClientInterfaces.E.ScriptCallPhase",
			"defaultValue": "AFTER_UPDATE"
		}
	}
};

UCF_ClientInterfaces["I"]["Style"] = {
	"name": "Style",
	"properties": {
		"Src": {
			"type": "string",
			"defaultValue": ''
		},
		"Content": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["StyleUpdate"] = {
	"name": "StyleUpdate",
	"properties": {
		"StyleText": {
			"type": "string",
			"defaultValue": null
		}
	}
};

UCF_ClientInterfaces["I"]["PageHeader"] = {
	"name": "PageHeader",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.PageHeaderDesign",
			"defaultValue": "STANDARD"
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowTitle": {
			"type": "boolean",
			"defaultValue": true
		},
		"TitlePosition": {
			"type": "number",
			"defaultValue": 0
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.PageHeaderItem",
			"multiple": true,
			"singularName": "Item"
		},
		"TitleEndArea": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"MessageArea": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"LeftBarItems": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "LeftBarItem",
			"bindable": true
		},
		"TitleControl": {
			"type": "UCF_ClientInterfaces.I.PageHeaderTitle",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"expression": "contrast(@fontColor)",
				"defaultValue": "ruleValue(.urPgHT2,background-color)"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "headerFontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urPgHTTxt,font-family)",
				"docu": "Defines the font family for the group"
			},
			{
				"name": "headerFontColor",
				"property": "color",
				"docu": "Defines the font color"
			},
			{
				"name": "headerFontWeight",
				"property": "font-weight",
				"defaultValue": "ruleValue(.urPgHTTxt,font-weight)"
			},
			{
				"name": "headerFontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urPgHTTxt,font-size)"
			},
			{
				"name": "headerFontStyle",
				"property": "font-style"
			},
			{
				"name": "headerTextDecoration",
				"property": "text-decoration",
				"defaultValue": "ruleValue(.urPgHTTxt,text-decoration)"
			},
			{
				"name": "headerTextAlign",
				"property": "text-align"
			},
			{
				"name": "headerBackgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urPgHT2,background-color)"
			},
			{
				"name": "headerBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "headerBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "headerBorderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "headerBorderRadius",
				"property": "border-radius",
				"docu": "Defines the border-radius for the content"
			}
		],
		"classes": {
			"Header": {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@headerBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@headerBorderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@headerBorderRadius"
					}
				]
			},
			'Header .lsPageHeader-text,Header .lsPageHeaderTitle--text': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@headerFontFamily"
					},
					{
						"name": "font-size",
						"expression": "@headerFontSize"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@headerTextDecoration"
					},
					{
						"name": "text-align",
						"expression": "@headerTextAlign"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@headerFontColor"
					}
				]
			},
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["PageHeaderItem"] = {
	"name": "PageHeaderItem",
	"properties": {
		"Design": {
			"type": "UCF_ClientInterfaces.E.PageHeaderItemDesign",
			"defaultValue": "PLAIN"
		},
		"HasBeginPadding": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasEndPadding": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasTopPadding": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasBottomPadding": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"ARIALandmark": {
			"type": "UCF_ClientInterfaces.E.ARIALandmark",
			"defaultValue": "none"
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "borderRadius",
				"property": "border-radius",
				"docu": "Defines the border-radius for the content"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["PageHeaderTitle"] = {
	"name": "PageHeaderTitle",
	"properties": {
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.PageHeaderDesign",
			"defaultValue": "STANDARD"
		}
	}
};

UCF_ClientInterfaces["I"]["PageLayout"] = {
	"name": "PageLayout",
	"properties": {
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Top": {
			"type": "UCF_ClientInterfaces.I.PageLayoutPanel",
			"multiple": false
		},
		"Bottom": {
			"type": "UCF_ClientInterfaces.I.PageLayoutPanel",
			"multiple": false
		},
		"Begin": {
			"type": "UCF_ClientInterfaces.I.PageLayoutPanel",
			"multiple": false
		},
		"End": {
			"type": "UCF_ClientInterfaces.I.PageLayoutPanel",
			"multiple": false
		},
		"InnerTop": {
			"type": "UCF_ClientInterfaces.I.PageLayoutPanel",
			"multiple": false
		},
		"InnerBottom": {
			"type": "UCF_ClientInterfaces.I.PageLayoutPanel",
			"multiple": false
		},
		"InnerBegin": {
			"type": "UCF_ClientInterfaces.I.PageLayoutPanel",
			"multiple": false
		},
		"InnerEnd": {
			"type": "UCF_ClientInterfaces.I.PageLayoutPanel",
			"multiple": false
		},
		"Center": {
			"type": "UCF_ClientInterfaces.I.PageLayoutPanel",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Hotkey": {}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "width",
				"property": "width",
				"docu": "Width"
			},
			{
				"name": "height",
				"property": "height",
				"docu": "Height"
			},
			{
				"name": "top",
				"property": "top",
				"docu": "MarginTop"
			},
			{
				"name": "padding",
				"property": "padding",
				"docu": "Padding"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"docu": "Defines the background image for the content"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background image X position for the content"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background image Y position for the content"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"docu": "Defines the background image streching mode for the content"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"docu": "Background size, cover, contain"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize"
					},
					{
						"name": "padding",
						"expression": "@padding"
					},
					{
						"name": "width",
						"important": true,
						"expression": "@width"
					},
					{
						"name": "height",
						"important": true,
						"expression": "@height"
					},
					{
						"name": "margin",
						"value": "auto"
					},
					{
						"name": "position",
						"value": "relative"
					},
					{
						"name": "top ",
						"expression": "@top"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["PageLayoutPanel"] = {
	"name": "PageLayoutPanel",
	"properties": {
		"TopBorder": {
			"type": "UCF_ClientInterfaces.E.PageLayoutBorder",
			"defaultValue": "NONE"
		},
		"BottomBorder": {
			"type": "UCF_ClientInterfaces.E.PageLayoutBorder",
			"defaultValue": "NONE"
		},
		"BeginBorder": {
			"type": "UCF_ClientInterfaces.E.PageLayoutBorder",
			"defaultValue": "NONE"
		},
		"EndBorder": {
			"type": "UCF_ClientInterfaces.E.PageLayoutBorder",
			"defaultValue": "NONE"
		},
		"HasTopPadding": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasBottomPadding": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasBeginPadding": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasEndPadding": {
			"type": "boolean",
			"defaultValue": false
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Background": {
			"type": "UCF_ClientInterfaces.E.PageLayoutBackground",
			"defaultValue": "TRANSPARENT"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"ARIALandmark": {
			"type": "UCF_ClientInterfaces.E.ARIALandmark",
			"defaultValue": "none"
		},
		"Slot": {
			"type": "UCF_ClientInterfaces.E.PageLayoutSlot",
			"defaultValue": "CENTER"
		},
		"Colspan": {
			"type": "number",
			"defaultValue": 1
		},
		"Rowspan": {
			"type": "number",
			"defaultValue": 1
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Background color"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"docu": "Background image"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"docu": "Background size, cover, contain"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"docu": "Background repeating, repeat, no-repeat"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Background image X position"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Background image Y position"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["Pager"] = {
	"name": "Pager",
	"properties": {
		"FirstVisibleItem": {
			"type": "number",
			"defaultValue": 1
		},
		"ItemCount": {
			"type": "number",
			"defaultValue": 0
		},
		"ItemsPerPage": {
			"type": "number",
			"defaultValue": 10
		},
		"PagePickerCount": {
			"type": "number",
			"defaultValue": 5
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Select": {}
	}
};

UCF_ClientInterfaces["I"]["Paginator"] = {
	"name": "Paginator",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"VisibleIndex": {
			"type": "number",
			"defaultValue": -1
		},
		"MaximumIndex": {
			"type": "number",
			"defaultValue": 0
		},
		"InputFieldWidth": {
			"type": "string",
			"defaultValue": '4ex'
		},
		"InputFieldMaxLength": {
			"type": "number",
			"defaultValue": 3
		},
		"PageIndicatorText": {
			"type": "string",
			"defaultValue": ''
		},
		"HasPageIndicator": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasFreetext": {
			"type": "boolean",
			"defaultValue": false
		},
		"Freetext": {
			"type": "string",
			"defaultValue": ''
		},
		"ConnectedControlId": {
			"type": "string",
			"defaultValue": ''
		},
		"NavigationMode": {
			"type": "UCF_ClientInterfaces.E.PaginatorNavigationMode",
			"defaultValue": "VERTICAL"
		},
		"NavigationType": {
			"type": "UCF_ClientInterfaces.E.PaginatorNavigationType",
			"defaultValue": "ITEM"
		},
		"NavigationText": {
			"type": "UCF_ClientInterfaces.E.PaginatorNavigationText",
			"defaultValue": "PAGE"
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasBeginButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"BeginButtonEnabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasEndButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"EndButtonEnabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasNextPageButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"NextPageButtonEnabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasPreviousPageButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"PreviousPageButtonEnabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasNextItemButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"NextItemButtonEnabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasPreviousItemButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"PreviousItemButtonEnabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasCalendarDoubleNextButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasCalendarDoublePrevButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasItemJumper": {
			"type": "boolean",
			"defaultValue": true
		},
		"OptionMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ContextDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"HasMoreIndicator": {
			"type": "boolean",
			"defaultValue": false
		},
		"TooltipCalendarDoubleNext": {
			"type": "string",
			"defaultValue": ''
		},
		"TooltipCalendarDoublePrev": {
			"type": "string",
			"defaultValue": ''
		},
		"TooltipCalendarNext": {
			"type": "string",
			"defaultValue": ''
		},
		"TooltipCalendarPrev": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"PageTop": {},
		"PageEnd": {},
		"PreviousYear": {},
		"PageNext": {},
		"NextYear": {},
		"PagePrevious": {},
		"ItemNext": {},
		"ItemPrevious": {},
		"FieldChange": {},
		"MenuOpen": {}
	},
	"publicMethods": [
		"openMenu"
	]
};

UCF_ClientInterfaces["I"]["Panel"] = {
	"name": "Panel",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"HasEditableTitle": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"IsCollapsible": {
			"type": "boolean",
			"defaultValue": true
		},
		"ClientCollapse": {
			"type": "boolean",
			"defaultValue": true
		},
		"Collapsed": {
			"type": "boolean",
			"defaultValue": false
		},
		"CollapseIconPosition": {
			"type": "UCF_ClientInterfaces.E.CollapseIconPosition",
			"defaultValue": "START"
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HeaderDesign": {
			"type": "UCF_ClientInterfaces.E.HeaderDesign",
			"defaultValue": "STANDARD"
		},
		"IsDragHandle": {
			"type": "boolean",
			"defaultValue": false
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"ContentPadding": {
			"type": "UCF_ClientInterfaces.E.ContentPadding",
			"defaultValue": "STANDARD"
		},
		"PaddingTop": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingRight": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingBottom": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingLeft": {
			"type": "string",
			"defaultValue": ''
		},
		"AreaDesign": {
			"type": "UCF_ClientInterfaces.E.AreaDesign",
			"defaultValue": "PLAIN"
		},
		"BorderDesign": {
			"type": "UCF_ClientInterfaces.E.BorderDesign",
			"defaultValue": "BOX"
		},
		"ScrollingMode": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "NONE"
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"TitleOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"ARIALandmark": {
			"type": "UCF_ClientInterfaces.E.ARIALandmark",
			"defaultValue": "region"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"DragSourceInfo": {
			"type": "string"
		},
		"DropTargetInfo": {
			"type": "string"
		}
	},
	"aggregations": {
		"HeaderToolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"HeaderFunctions": {
			"type": "UCF_ClientInterfaces.I.Button",
			"multiple": true,
			"singularName": "HeaderFunction"
		},
		"TitleMenu": {
			"type": "UCF_ClientInterfaces.I.PopupMenu",
			"multiple": false,
			"deprecated": true
		},
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ContentToolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Collapse": {},
		"Expand": {},
		"Change": {},
		"Scroll": {},
		"Hotkey": {},
		"MenuAccess": {},
		"Drop": {}
	},
	"publicMethods": [
		"setDefaultButtonId"
	],
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the content"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "borderRadius",
				"property": "border-radius",
				"docu": "Defines the border-radius for the content"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"docu": "Defines the background-iamge for the content"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background position X for background image for the content"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background position Y for background image for the content"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"docu": "Defines the background repeat for background image for the content"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"docu": "Defines the background site for background image for the content"
			},
			{
				"name": "headerBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the header"
			},
			{
				"name": "headerBackgroundImage",
				"property": "background-image",
				"docu": "Defines the background-iamge for the header "
			},
			{
				"name": "headerFontColor",
				"property": "color",
				"docu": "Defines the color for the header"
			},
			{
				"name": "headerFontWeight",
				"property": "font-weight",
				"docu": "Defines the font-weight for the header"
			},
			{
				"name": "headerFontStyle",
				"property": "font-style",
				"docu": "Defines the font-style for the header"
			},
			{
				"name": "headerFontSize",
				"property": "font-size",
				"docu": "Defines the font-size for the header"
			},
			{
				"name": "headerFontFamily",
				"property": "font-family",
				"docu": "Defines the font-family for the header"
			},
			{
				"name": "headerTextDecoration",
				"property": "text-decoration",
				"docu": "Defines the text-decoration for the header"
			},
			{
				"name": "headerBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the header"
			},
			{
				"name": "headerBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the header"
			},
			{
				"name": "headerBorderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the header"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background",
						"expression": "@backgroundColor || none"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage || none"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'@{CustomStyle} .lsPanel--content': {
				"properties": [
					{
						"name": "background",
						"expression": "@headerBackgroundColor || none"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "@headerBackgroundImage || none"
					},
					{
						"name": "border-bottom-color",
						"important": true,
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-bottom-style",
						"important": true,
						"expression": "@headerBorderStyle"
					},
					{
						"name": "border-bottom-width",
						"important": true,
						"expression": "@headerBorderWidth"
					},
					{
						"name": "border-top-left-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "border-top-right-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'@{CustomStyle} .lsPanel--title-text': {
				"properties": [
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "font-family",
						"expression": "@headerFontFamily"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-size",
						"expression": "@headerFontSize"
					},
					{
						"name": "text-decoration",
						"expression": "@headerTextDecoration"
					}
				]
			},
			'@{CustomStyle} .lsContentArea--content, @{CustomStyle} .lsContentArea--toolbar': {
				"properties": [
					{
						"name": "background",
						"expression": "@backgroundColor || none"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize"
					},
					{
						"name": "border-top-left-radius",
						"expression": "0"
					},
					{
						"name": "border-top-right-radius",
						"expression": "0"
					},
					{
						"name": "border-bottom-left-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "border-bottom-right-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'@{CustomStyle} .lsToolbar--design-default': {
				"properties": [
					{
						"name": "background",
						"expression": "none"
					},
					{
						"name": "background-color",
						"expression": "transparent"
					},
					{
						"name": "background-image",
						"expression": "none"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["PanelStack"] = {
	"name": "PanelStack",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"CollapseMode": {
			"type": "UCF_ClientInterfaces.E.CollapseMode",
			"defaultValue": "TO_HORIZONTAL_LINE"
		},
		"ClientCollapse": {
			"type": "boolean",
			"defaultValue": true
		},
		"Collapsed": {
			"type": "boolean",
			"defaultValue": false
		},
		"StackDesign": {
			"type": "UCF_ClientInterfaces.E.StackDesign",
			"defaultValue": "TAB"
		},
		"ClientSelect": {
			"type": "boolean",
			"defaultValue": true
		},
		"SelectedPanelId": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollingMode": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "NONE"
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"ARIALandmark": {
			"type": "UCF_ClientInterfaces.E.ARIALandmark",
			"defaultValue": "region"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"DragSourceInfo": {
			"type": "string"
		},
		"DropTargetInfo": {
			"type": "string"
		}
	},
	"aggregations": {
		"Panels": {
			"type": "UCF_ClientInterfaces.I.Panel",
			"multiple": true,
			"singularName": "Panel"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Collapse": {},
		"Expand": {},
		"Change": {},
		"Hotkey": {},
		"Scroll": {},
		"Select": {},
		"Drag": {},
		"Drop": {},
		"MenuAccess": {}
	},
	"publicMethods": [
		"selectPanel"
	],
	"styles": {
		"variables": [
			{
				"name": "headerFontColor",
				"property": "color",
				"docu": "Defines the font color"
			},
			{
				"name": "headerFontStyle",
				"property": "font-style",
				"docu": "Defines the font style for the header"
			},
			{
				"name": "headerFontSize",
				"property": "font-size",
				"docu": "Defines the font-size for the header"
			},
			{
				"name": "headerFontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight for the header"
			},
			{
				"name": "headerFontFamily",
				"property": "font-family",
				"docu": "Defines the font-family for the header"
			},
			{
				"name": "headerTextDecoration",
				"property": "text-decoration",
				"docu": "Defines the text-decoration for the header"
			},
			{
				"name": "headerPadding",
				"property": "padding",
				"docu": "Defines the padding"
			},
			{
				"name": "selectedHeaderBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the selected item"
			},
			{
				"name": "selectedHeaderBackgroundImage",
				"property": "background-image",
				"docu": "Defines the font family for all button states"
			},
			{
				"name": "selectedHeaderBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the header"
			},
			{
				"name": "selectedHeaderBorderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the header"
			},
			{
				"name": "selectedHeaderTextDecoration",
				"property": "text-decoration",
				"docu": "Defines the text-decoration for the header"
			},
			{
				"name": "selectedHeaderFontFamily",
				"property": "font-family",
				"expression": "@headerFontFamily || @selectedHeaderFontFamily",
				"docu": "Defines the font-family for the header"
			},
			{
				"name": "selectedHeaderBottom",
				"property": "bottom",
				"docu": "Defines the border-color for the selected item"
			},
			{
				"name": "selectedHeaderPadding",
				"property": "padding",
				"expression": "@selectedHeaderPadding || @headerPadding",
				"docu": "Defines the padding"
			},
			{
				"name": "selectedHeaderFontColor",
				"property": "color",
				"expression": "@selectedHeaderFontColor || contrast(@selectedHeaderBackgroundColor)",
				"docu": "Defines the font color"
			},
			{
				"name": "selectedHeaderFontStyle",
				"property": "font-style",
				"expression": "@selectedHeaderFontStyle || @headerFontStyle",
				"docu": "Defines the font style for the header"
			},
			{
				"name": "selectedHeaderFontWeight",
				"property": "font-weight",
				"expression": "@selectedHeaderFontWeight || @headerFontWeight",
				"docu": "Defines the font weight for the header"
			},
			{
				"name": "disabledHeaderFontColor",
				"property": "color",
				"expression": "@disabledHeaderFontColor || greyscale(@disabledHeaderBackgroundColor)|| greyscale(@headerBackgroundColor)",
				"docu": "Defines the font color"
			},
			{
				"name": "disabledHeaderFontStyle",
				"property": "font-style",
				"expression": "@disabledHeaderFontStyle || @headerFontStyle",
				"docu": "Defines the font style for the header"
			},
			{
				"name": "disabledHeaderFontWeight",
				"property": "font-weight",
				"expression": "@disabledHeaderFontWeight || @headerFontWeight",
				"docu": "Defines the font weight for the header"
			},
			{
				"name": "disabledHeaderTextDecoration",
				"property": "text-decoration",
				"docu": "Defines the text-decoration for the header"
			},
			{
				"name": "disabledHeaderFontFamily",
				"property": "font-family",
				"expression": "@headerFontFamily || @selectedHeaderFontFamily || @disabledHeaderFontFamily",
				"docu": "Defines the font-family for the header"
			},
			{
				"name": "disabledHeaderPadding",
				"property": "padding",
				"expression": "@disabledHeaderPadding || @headerPadding",
				"docu": "Defines the padding"
			}
		],
		"classes": {
			'.lsPnstHdCenter,.lsPnstHdRight,.lsPnstHdLeft,.lsPnstHdRightCol,.lsPnstHdLeftCol': {
				"properties": [
					{
						"name": "border-bottom-color",
						"important": true,
						"expression": "@selectedHeaderBorderColor"
					},
					{
						"name": "background-image",
						"expression": "@selectedHeaderBackgroundImage"
					},
					{
						"name": "border-bottom-style",
						"important": true,
						"expression": "@selectedHeaderBorderStyle"
					},
					{
						"name": "border-bottom-width",
						"important": true,
						"expression": "@selectedHeaderBorderWidth"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					},
					{
						"name": "border-top-color",
						"important": true,
						"expression": "transparent"
					},
					{
						"name": "border-right-color",
						"important": true,
						"expression": "transparent"
					},
					{
						"name": "border-left-color",
						"important": true,
						"expression": "transparent"
					}
				]
			},
			'.lsPnstNavBarArrow': {
				"properties": [
					{
						"name": "border-bottom-color",
						"important": true,
						"expression": "@selectedHeaderBorderColor"
					},
					{
						"name": "bottom",
						"expression": "@selectedHeaderBottom"
					}
				]
			},
			'.lsPnstOvfl': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@headerFontSize"
					}
				]
			},
			'.lsPnstLabel,.lsPnstLabelHover': {
				"properties": [
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@headerTextDecoration"
					},
					{
						"name": "font-family",
						"expression": "@headerFontFamily"
					},
					{
						"name": "padding",
						"expression": "@headerPadding"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "transparent"
					}
				]
			},
			'.lsPnstLabelSel': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedHeaderFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@selectedHeaderFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@selectedHeaderFontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@selectedHeaderTextDecoration"
					},
					{
						"name": "font-family",
						"expression": "@selectedHeaderFontFamily"
					},
					{
						"name": "padding",
						"expression": "@selectedHeaderPadding"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "transparent"
					}
				]
			},
			'.lsPnstLabelDsbl': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledHeaderFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@disabledHeaderFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@disabledHeaderFontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@disabledHeaderTextDecoration"
					},
					{
						"name": "font-family",
						"expression": "@disabledHeaderFontFamily"
					},
					{
						"name": "padding",
						"expression": "@disabledHeaderPadding"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "transparent"
					}
				]
			},
			' .lsPnstEndMore, .lsPnstFirst, .lsPnstStartSel, .lsPnstStartEndSel, .lsPnstLast, .lsPnstStart, .lsPnstStartHover, .lsPnstEndMoreSel, .lsPnstFirstSel, .lsPnstFirstHover, .lsPnstStartSelHover, .lsPnstStartEndSelHover, .lsPnstStartSelHover, .lsPnstPanelBrd, .lsPnstPager, .lsPnstStartHover, .lsPnstStartEndHover, .lsPnstFirstMoreSel, .lsPnstFirstMoreHover, .lsPnstFirstMore, .lsPnstLastSel': {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "transparent"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["PatternContainerContentItem"] = {
	"name": "PatternContainerContentItem",
	"properties": {
		"Border": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"PatternContentDesign": {
			"type": "UCF_ClientInterfaces.E.PatternContainerDesign",
			"defaultValue": "PLAIN",
			"deprecated": true
		},
		"HasContentPadding": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"ContentScrollingMode": {
			"type": "UCF_ClientInterfaces.E.HorizontalScrollingMode",
			"defaultValue": "NONE",
			"deprecated": true
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false,
			"deprecated": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["PatternContainerIconButton"] = {
	"name": "PatternContainerIconButton",
	"properties": {
		"Enabled": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"FunctionStatus": {
			"type": "UCF_ClientInterfaces.E.IconButtonFunctionStatus",
			"defaultValue": "LARGE",
			"deprecated": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.PatternContainerDesign",
			"defaultValue": "PLAIN",
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		}
	},
	"events": {
		"Press": {}
	}
};

UCF_ClientInterfaces["I"]["PatternContainerSequence"] = {
	"name": "PatternContainerSequence",
	"properties": {
		"Design": {
			"type": "UCF_ClientInterfaces.E.PatternContainerDesign",
			"defaultValue": "PLAIN",
			"deprecated": true
		},
		"HasTitle": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"HasTitleContent": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"TitleSelected": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"HasOptionMenu": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"OptionMenuId": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"HasAdditionalButtons": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Collapsed": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"MaxVisibleItems": {
			"type": "number",
			"defaultValue": 0,
			"deprecated": true
		},
		"SelectedIndex": {
			"type": "number",
			"defaultValue": 0,
			"deprecated": true
		},
		"Scrollable": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"HasContentConnector": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE",
			"deprecated": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		}
	},
	"aggregations": {
		"TitleItem": {
			"type": "UCF_ClientInterfaces.I.PatternContainerSequenceItem",
			"multiple": false,
			"deprecated": true
		},
		"Items": {
			"type": "UCF_ClientInterfaces.I.PatternContainerSequenceItem",
			"multiple": true,
			"singularName": "Item",
			"deprecated": true
		},
		"AdditionalButtons": {
			"type": "UCF_ClientInterfaces.I.PatternContainerIconButton",
			"multiple": true,
			"singularName": "AdditionalButton",
			"deprecated": true
		},
		"ItemMenu": {
			"type": "UCF_ClientInterfaces.I.PopupMenu",
			"multiple": false,
			"deprecated": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"MenuAccess": {},
		"ItemSelect": {},
		"TitleSelect": {},
		"Scroll": {}
	}
};

UCF_ClientInterfaces["I"]["PatternContainerSequenceItem"] = {
	"name": "PatternContainerSequenceItem",
	"properties": {
		"ItemIndex": {
			"type": "number",
			"defaultValue": 0,
			"deprecated": true
		},
		"Title": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Status": {
			"type": "UCF_ClientInterfaces.E.PatternContainerSequenceStatus",
			"defaultValue": "NONE",
			"deprecated": true
		},
		"StepNumber": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"ShowStepNumber": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"TooltipStepNumber": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"TooltipTitle": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"TooltipStatus": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"ItemDesign": {
			"type": "UCF_ClientInterfaces.E.PatternContainerSequenceItemDesign",
			"defaultValue": "DEFAULT",
			"deprecated": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT",
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		}
	},
	"aggregations": {
		"ContentItems": {
			"type": "UCF_ClientInterfaces.I.PatternContainerContentItem",
			"multiple": true,
			"singularName": "ContentItem",
			"deprecated": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["PatternContainerTab"] = {
	"name": "PatternContainerTab",
	"properties": {
		"Design": {
			"type": "UCF_ClientInterfaces.E.PatternContainerDesign",
			"defaultValue": "PLAIN",
			"deprecated": true
		},
		"HasOptionMenu": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"OptionMenuId": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"HasAdditionalButtons": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Collapsed": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"MaxVisibleItems": {
			"type": "number",
			"defaultValue": 7,
			"deprecated": true
		},
		"SelectedIndex": {
			"type": "number",
			"defaultValue": 0,
			"deprecated": true
		},
		"Scrollable": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"HasContentConnector": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"ContextDescription": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE",
			"deprecated": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.PatternContainerTabItem",
			"multiple": true,
			"singularName": "Item",
			"deprecated": true
		},
		"AdditionalButtons": {
			"type": "UCF_ClientInterfaces.I.PatternContainerIconButton",
			"multiple": true,
			"singularName": "AdditionalButton",
			"deprecated": true
		},
		"ItemMenu": {
			"type": "UCF_ClientInterfaces.I.PopupMenu",
			"multiple": false,
			"deprecated": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"MenuAccess": {},
		"TabSelect": {},
		"Scroll": {},
		"Hotkey": {}
	}
};

UCF_ClientInterfaces["I"]["PatternContainerTabItem"] = {
	"name": "PatternContainerTabItem",
	"properties": {
		"ItemIndex": {
			"type": "number",
			"defaultValue": 0,
			"deprecated": true
		},
		"Title": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT",
			"deprecated": true
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		}
	},
	"aggregations": {
		"ContentItems": {
			"type": "UCF_ClientInterfaces.I.PatternContainerContentItem",
			"multiple": true,
			"singularName": "ContentItem",
			"deprecated": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["PatternContainerTitle"] = {
	"name": "PatternContainerTitle",
	"properties": {
		"Design": {
			"type": "UCF_ClientInterfaces.E.PatternContainerDesign",
			"defaultValue": "PLAIN",
			"deprecated": true
		},
		"Title": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"HasOptionMenu": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"OptionMenuId": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"HasAdditionalButtons": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Collapsed": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"HasContentConnector": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"ContextDescription": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE",
			"deprecated": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientInterfaces.I.PatternContainerContentItem",
			"multiple": true,
			"singularName": "Content",
			"deprecated": true
		},
		"AdditionalButtons": {
			"type": "UCF_ClientInterfaces.I.PatternContainerIconButton",
			"multiple": true,
			"singularName": "AdditionalButton",
			"deprecated": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"MenuAccess": {},
		"Hotkey": {}
	}
};

UCF_ClientInterfaces["I"]["PDFContainer"] = {
	"name": "PDFContainer",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"Height": {
			"type": "string",
			"defaultValue": null
		},
		"MinHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"Source": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AutoActivate": {
			"type": "boolean",
			"defaultValue": false
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "BROWSER"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"publicMethods": [
		"setKeepAlive"
	]
};

UCF_ClientInterfaces["I"]["PersonasFacade"] = {
	"name": "PersonasFacade",
	"properties": {
		"PersonasSourceRoot": {
			"type": "string",
			"defaultValue": ''
		},
		"PackageName": {
			"type": "string",
			"defaultValue": ''
		},
		"PackageUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"ThemeSupport": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Ui5SourceRoot": {
			"type": "string",
			"defaultValue": ''
		},
		"PersonasSourceDir": {
			"type": "string",
			"defaultValue": ''
		},
		"ConfigJson": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"RequestData": {}
	},
	"publicMethods": [
		"callMethod",
		"getPersonasRootPath"
	]
};

UCF_ClientInterfaces["I"]["PhaseIndicator"] = {
	"name": "PhaseIndicator",
	"properties": {
		"FirstVisibleItem": {
			"type": "string",
			"defaultValue": '0'
		},
		"BackgroundDesign": {
			"type": "UCF_ClientInterfaces.E.PhaseIndicatorBackgroundDesign",
			"defaultValue": "EMPHASIZED"
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"PhaseIndicatorItems": {
			"type": "UCF_ClientInterfaces.I.PhaseIndicatorItem",
			"multiple": true,
			"singularName": "PhaseIndicatorItem"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {},
		"Scroll": {}
	}
};

UCF_ClientInterfaces["I"]["PhaseIndicatorItem"] = {
	"name": "PhaseIndicatorItem",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"ItemStatus": {
			"type": "UCF_ClientInterfaces.E.PhaseIndicatorItemStatus",
			"defaultValue": "NONE"
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Selected": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PopIn"] = {
	"name": "PopIn",
	"properties": {
		"TitleAreaDesign": {
			"type": "UCF_ClientInterfaces.E.PopInTitleAreaDesign",
			"defaultValue": "TEXT"
		},
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"HasCloseIcon": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasTextBar": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasContent": {
			"type": "boolean",
			"defaultValue": false
		},
		"ContentDesign": {
			"type": "UCF_ClientInterfaces.E.PopInDesign",
			"defaultValue": "FILL"
		},
		"HasContentPadding": {
			"type": "boolean",
			"defaultValue": true
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"TextBar": {
			"type": "UCF_ClientInterfaces.I.TextBar",
			"multiple": false
		},
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Close": {}
	}
};

UCF_ClientInterfaces["I"]["TextBar"] = {
	"name": "TextBar",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["PopoverContainer"] = {
	"name": "PopoverContainer",
	"properties": {
		"ContentHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"Padding": {
			"type": "UCF_ClientInterfaces.E.LayoutCellDesign",
			"defaultValue": "DEFAULT"
		},
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"HeaderLeftButton": {
			"type": "UCF_ClientInterfaces.I.Button",
			"multiple": false
		},
		"HeaderRightButton": {
			"type": "UCF_ClientInterfaces.I.Button",
			"multiple": false
		},
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"FooterButtons": {
			"type": "UCF_ClientInterfaces.I.Button",
			"multiple": true,
			"singularName": "FooterButton"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Hotkey": {}
	}
};

UCF_ClientInterfaces["I"]["PopupMenu"] = {
	"name": "PopupMenu",
	"properties": {
		"FirstVisibleItemIdx": {
			"type": "number",
			"defaultValue": 0
		},
		"MaxVisibleItems": {
			"type": "number",
			"defaultValue": 0,
			"deprecated": true
		},
		"KeepSpaceForIcon": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"IsContextMenu": {
			"type": "boolean",
			"defaultValue": false
		},
		"CmDoubleClickText": {
			"type": "string",
			"defaultValue": ''
		},
		"CmQuickViewText": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"DragSourceInfo": {
			"type": "string"
		},
		"DropTargetInfo": {
			"type": "string"
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.PopupMenuItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {},
		"Drag": {},
		"BeforeOpen": {},
		"Drop": {},
		"Close": {}
	},
	"publicMethods": [
		"openAtPosition",
		"openAtControl",
		"setRemoveOnClose",
		"setAutoRefocus",
		"setAutoRefocusOnKeyup",
		"addItem",
		"removeItems",
		"iGetItemCount",
		"oGetItemByIndex",
		"aGetItems",
		"removeItem",
		"setCmDoubleClickText",
		"setCmQuickViewText"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for the menu items."
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight, bold"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size in px"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style, italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration, underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"expression": "contrast(@fontColor)",
				"docu": "Defines the background color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "border",
				"property": "border",
				"docu": "Defines the border of the menu"
			},
			{
				"name": "borderRadius",
				"property": "borderRadius",
				"docu": "Defines the border radius of the menu"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"expression": "@hoverBackgroundColor || darken(@backgroundColor,20%)",
				"docu": "Defines the hover background color for enabled items"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"docu": "Defines the font color for hovered items"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"expression": "lighten(@disabledBackgroundColor,10%) || @disabledBackgroundColor || greyscale(@hoverBackgroundColor) || greyscale(@backgroundColor) || greyscale(contrast(@fontColor))",
				"docu": "Defines the disabled background color for menu items"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "@disabledFontColor || lighten(greyscale(@fontColor),20%) || lighten(greyscale(@backgroundColor),10%)",
				"docu": "Defines the disabled font color for menu items"
			}
		],
		"classes": {
			'.urMnu': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.urMnuRowOn': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					}
				]
			},
			'.urMnuRowOff': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			' .urMnuDvdr div': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'.urMnuRow': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'.urMnuRowDsbl': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					}
				]
			},
			'.urMnuTxt': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.urMnuRowOn .urMnuTxt': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			},
			'.urMnuRowDsbl .urMnuTxt': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					}
				]
			},
			'.urMnuRowDsblOn .urMnuTxt': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					}
				]
			},
			'.urMnuRowDsblOn': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["PopupMenuItem"] = {
	"name": "PopupMenuItem",
	"properties": {
		"GroupId": {
			"type": "string",
			"defaultValue": ''
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Checked": {
			"type": "boolean",
			"defaultValue": false
		},
		"CanCheck": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasSeparator": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasSubMenu": {
			"type": "boolean",
			"defaultValue": false
		},
		"SubMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"IsLink": {
			"type": "boolean",
			"defaultValue": false
		},
		"LinkReference": {
			"type": "string",
			"defaultValue": ''
		},
		"LinkTarget": {
			"type": "string",
			"defaultValue": ''
		},
		"HasIcon": {
			"type": "boolean",
			"defaultValue": false
		},
		"EnabledIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"DisabledIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"HasEllipsis": {
			"type": "boolean",
			"defaultValue": false
		},
		"ShortcutText": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Selected": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hotkey": {
			"type": "UCF_ClientInterfaces.E.HotkeyValue",
			"defaultValue": "NONE"
		},
		"HasSubMenuSection": {
			"type": "boolean",
			"defaultValue": false
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"publicMethods": [
		"sGetId",
		"bIsChecked",
		"setChecked",
		"bGetCanCheck",
		"setCanCheck",
		"bIsEnabled",
		"setEnabled",
		"bGetIsVisible",
		"setVisible",
		"bGetIsSeperatorVisible",
		"setSeperatorVisible",
		"sGetGroupId",
		"setGroupId",
		"sGetSubMenuId",
		"setSubMenuId",
		"bGetHasSubMenu",
		"setText",
		"openSubMenu",
		"setSemanticColor",
		"getSemanticColor",
		"setEnabledIconSrc",
		"getEnabledIconSrc"
	]
};

UCF_ClientInterfaces["I"]["PopupTrigger"] = {
	"name": "PopupTrigger",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"HasContent": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasPopupMenu": {
			"type": "boolean",
			"defaultValue": true
		},
		"PopupMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"TriggerIndicator": {
			"type": "UCF_ClientInterfaces.E.PopUpTriggerIndicator",
			"defaultValue": "PERMANENT"
		},
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"MenuAccess": {}
	},
	"publicMethods": [
		"openOnRequest"
	]
};

UCF_ClientInterfaces["I"]["PopupWindow"] = {
	"name": "PopupWindow",
	"properties": {
		"Title": {
			"type": "string",
			"defaultValue": 'SAP Popup Window'
		},
		"InfoType": {
			"type": "UCF_ClientInterfaces.E.InfoType",
			"defaultValue": "NONE"
		},
		"IsResizable": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasCloseButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasContentPadding": {
			"type": "boolean",
			"defaultValue": false
		},
		"X": {
			"type": "string",
			"defaultValue": '-1'
		},
		"Y": {
			"type": "string",
			"defaultValue": '-1'
		},
		"Width": {
			"type": "string",
			"defaultValue": '-1'
		},
		"Height": {
			"type": "string",
			"defaultValue": '-1'
		},
		"WindowSize": {
			"type": "boolean",
			"defaultValue": false
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"OverrideMinimumSize": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsMaximized": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasHelpButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"Mode": {
			"type": "UCF_ClientInterfaces.E.Mode",
			"defaultValue": "MODAL"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"NoContentScrolling": {
			"type": "boolean",
			"defaultValue": false
		},
		"ContextMenuEvent": {
			"type": "boolean",
			"defaultValue": false
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.QuickViewDesign",
			"defaultValue": "STANDARD"
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"MessageArea": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"Buttons": {
			"type": "UCF_ClientInterfaces.I.Button",
			"multiple": true,
			"singularName": "Button"
		},
		"FooterToolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Close": {},
		"Help": {},
		"Hotkey": {},
		"Resize": {},
		"Move": {},
		"Maximize": {},
		"Restore": {},
		"PopupContextMenu": {}
	},
	"publicMethods": [
		"setDefaultButtonId",
		"setTitleText"
	],
	"styles": {
		"variables": [
			{
				"name": "headerFontFamily",
				"property": "font-family",
				"docu": "Font family of the title text"
			},
			{
				"name": "headerFontWeight",
				"property": "font-weight",
				"docu": "Font weight of the title text"
			},
			{
				"name": "headerFontSize",
				"property": "font-size",
				"docu": "Font size of the title text"
			},
			{
				"name": "headerFontColor",
				"property": "color",
				"docu": "Font color of the title text"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Background color of the whole PopupWindow"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Border color color of the whole PopupWindow"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@headerFontColor"
					},
					{
						"name": "font-family",
						"important": true,
						"expression": "@headerFontFamily"
					},
					{
						"name": "font-size",
						"important": true,
						"expression": "@headerFontSize"
					},
					{
						"name": "font-weight",
						"important": true,
						"expression": "@headerFontWeight"
					}
				]
			},
			"ContentArea": {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					}
				]
			},
			"OuterBorder": {
				"properties": [
					{
						"name": "border-color",
						"important": true,
						"expression": "@borderColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ProgressIndicator"] = {
	"name": "ProgressIndicator",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"PercentValue": {
			"type": "number",
			"defaultValue": 0
		},
		"DisplayValue": {
			"type": "string",
			"defaultValue": '0'
		},
		"ShowValue": {
			"type": "boolean",
			"defaultValue": true
		},
		"BarColor": {
			"type": "UCF_ClientInterfaces.E.ProgressIndicatorBarColor",
			"defaultValue": "NEUTRAL"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"WebsocketId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"publicMethods": [
		"updateValues"
	]
};

UCF_ClientInterfaces["I"]["QuickView"] = {
	"name": "QuickView",
	"properties": {
		"Preload": {
			"type": "boolean",
			"defaultValue": false
		},
		"OpenHotkey": {
			"type": "UCF_ClientInterfaces.E.HotkeyValue",
			"defaultValue": "CTRL_SHIFT_I"
		},
		"AlwaysSendKCAEvent": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CloseOnTyping": {
			"type": "boolean",
			"defaultValue": false
		},
		"Behavior": {
			"type": "UCF_ClientInterfaces.E.QuickViewBehavior",
			"defaultValue": "DEFAULT"
		},
		"PopOverCloseEvent": {
			"type": "boolean",
			"defaultValue": false
		},
		"PopOverOpenAtControl": {
			"type": "string",
			"defaultValue": ''
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.QuickViewDesign",
			"defaultValue": "STANDARD"
		},
		"PopOverFocusContent": {
			"type": "boolean",
			"defaultValue": true
		},
		"PopOverAlignment": {
			"type": "UCF_ClientInterfaces.E.PopOverAlignment",
			"defaultValue": "DEFAULT"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"ContentAccess": {},
		"KeyboardContentAccess": {},
		"Close": {}
	},
	"publicMethods": [
		"show",
		"contentReady",
		"openAtControl",
		"close"
	]
};

UCF_ClientInterfaces["I"]["RadioButton"] = {
	"name": "RadioButton",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Key": {
			"type": "string",
			"defaultValue": ''
		},
		"Checked": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"IsTextTitle": {
			"type": "boolean",
			"defaultValue": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"UsedInSapTable": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowAccessKey": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageAlt": {
			"type": "string",
			"defaultValue": ''
		},
		"Arrangement": {
			"type": "UCF_ClientInterfaces.E.RadioButtonArrangement",
			"defaultValue": "RADIOBUTTONFIRST"
		},
		"AssociatedEditContext": {
			"type": "UCF_ClientInterfaces.E.EditContext",
			"defaultValue": "PARENTEDITABLE"
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.RadioButtonLabelDesign",
			"defaultValue": "STANDARD"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"IsTextLabel": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalSpacing": {
			"type": "UCF_ClientInterfaces.E.Spacing",
			"defaultValue": "ALIGNED"
		}
	},
	"aggregations": {
		"LabelContent": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Change": {},
		"DoubleClick": {},
		"Enter": {}
	},
	"publicMethods": [
		"setValue",
		"getValue",
		"setName",
		"getName",
		"setEnabled",
		"getEnabled",
		"setValueState",
		"getValueState",
		"setEditable",
		"getEditable",
		"createDataTip"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Font family for all radios"
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Font color of the label"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size e.g. px, em"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style e.g. italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration e.g. underline"
			},
			{
				"name": "backgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,backGround)",
				"docu": "Background of enabled radios."
			},
			{
				"name": "borderColor",
				"property": "stroke",
				"defaultValue": "themeValue(.lsRadioButton__metaData,border)",
				"docu": "Border of enabled radios."
			},
			{
				"name": "selectedBackgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,checkMark)",
				"docu": "Knob color at center of radio."
			},
			{
				"name": "hoverBackgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,backGround)",
				"docu": "Background color on hover."
			},
			{
				"name": "hoverBorderColor",
				"property": "stroke",
				"defaultValue": "themeValue(.lsRadioButton__metaData,borderHover)",
				"docu": "Border color on hover."
			},
			{
				"name": "hoverSelectedBackgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,checkMark)",
				"docu": "Checkmark color on hover."
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"docu": "Defines the font color on mouse over"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"docu": "Font color disabled."
			},
			{
				"name": "disabledBackgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,backGround)",
				"docu": "Background color disabled."
			},
			{
				"name": "disabledBorderColor",
				"property": "stroke",
				"defaultValue": "themeValue(.lsRadioButton__metaData,border)",
				"docu": "Border color disabled."
			},
			{
				"name": "disabledSelectedBackgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,checkMark)",
				"docu": "Checkmark color disabled."
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"docu": "Font color read only."
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,backGroundReadOnly)",
				"docu": "Background color read only."
			},
			{
				"name": "readonlyBorderColor",
				"property": "stroke",
				"defaultValue": "themeValue(.lsRadioButton__metaData,borderReadOnly)",
				"docu": "Border color read only."
			},
			{
				"name": "readonlySelectedBackgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,checkMarkReadOnly)",
				"docu": "Checkmark color read only."
			},
			{
				"name": "errorFontColor",
				"property": "color",
				"docu": "Font color upon error."
			},
			{
				"name": "errorBackgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,backGround)",
				"docu": "Background color upon error."
			},
			{
				"name": "errorBorderColor",
				"property": "stroke",
				"defaultValue": "themeValue(.lsRadioButton__metaData,borderError)",
				"docu": "Border color upon error."
			},
			{
				"name": "errorSelectedBackgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,checkMarkError)",
				"docu": "Checkmark color upon error."
			},
			{
				"name": "warningFontColor",
				"property": "color",
				"docu": "Font color upon warning."
			},
			{
				"name": "warningBackgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,backGround)",
				"docu": "Background color upon warning."
			},
			{
				"name": "warningBorderColor",
				"property": "stroke",
				"defaultValue": "themeValue(.lsRadioButton__metaData,borderWarning)",
				"docu": "Border color upon warning."
			},
			{
				"name": "warningSelectedBackgroundColor",
				"property": "fill",
				"defaultValue": "themeValue(.lsRadioButton__metaData,checkMarkWarning)",
				"docu": "Checkmark color upon warning."
			},
			{
				"name": "size",
				"property": "width",
				"defaultValue": "themeValue(.lsRadioButton__metaData,size)",
				"docu": "The size of the radio button."
			},
			{
				"name": "center",
				"property": "cx",
				"defaultValue": "themeValue(.lsRadioButton__metaData,center)",
				"docu": "DO NOT CHANGE THIS!"
			},
			{
				"name": "radius",
				"property": "r",
				"defaultValue": "themeValue(.lsRadioButton__metaData,radius)",
				"docu": "The size of the radio button."
			},
			{
				"name": "radiusCheckMark",
				"property": "r",
				"defaultValue": "themeValue(.lsRadioButton__metaData,radiusCheckMark)",
				"docu": "The size of the radio button."
			}
		],
		"classes": {
			'.lsSelector--generic': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsRadioButton--checked:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsRadioButton--checked--error:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsRadioButton--checked--warning:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsRadioButton--unchecked:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsRadioButton--unchecked--error:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsRadioButton--unchecked--warning:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsRadioButton--checked::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{backgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{borderColor}') ~\"%22/%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radiusCheckMark}%22%20fill%3D%22\" escape(~'@{selectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsRadioButton--unchecked::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{backgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{borderColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsRadioButton--checked:hover:before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{hoverBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{hoverBorderColor}') ~\"%22/%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radiusCheckMark}%22%20fill%3D%22\" escape(~'@{hoverSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsRadioButton--unchecked:hover:before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{hoverBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{hoverBorderColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'Dsbl.lsRadioButton--checked--disabled::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{disabledBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{disabledBorderColor}') ~\"%22/%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radiusCheckMark}%22%20fill%3D%22\" escape(~'@{disabledSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'Dsbl.lsRadioButton--unchecked--disabled::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{disabledBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{disabledBorderColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'Ro.lsRadioButton--checked--readOnly::before,.lsRadioButton--checked--parentReadOnly::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{readonlyBorderColor}') ~\"%22/%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radiusCheckMark}%22%20fill%3D%22\" escape(~'@{readonlySelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'Ro.lsRadioButton--unchecked--readOnly::before,.lsRadioButton--unchecked--parentReadOnly::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{readonlyBorderColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsRadioButton--checked--warning::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{warningBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{warningBorderColor}') ~\"%22/%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radiusCheckMark}%22%20fill%3D%22\" escape(~'@{warningSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsRadioButton--unchecked--warning::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{warningBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{warningBorderColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsRadioButton--checked--warning--readOnly::before,.lsRadioButton--checked--warning--parentReadOnly::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{warningBorderColor}') ~\"%22/%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radiusCheckMark}%22%20fill%3D%22\" escape(~'@{warningSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsRadioButton--unchecked--warning--readOnly::before,.lsRadioButton--unchecked--warning--readOnly::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{warningBorderColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsRadioButton--checked--error::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{errorBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{errorBorderColor}') ~\"%22/%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radiusCheckMark}%22%20fill%3D%22\" escape(~'@{errorSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsRadioButton--unchecked--error::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{errorBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{errorBorderColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsRadioButton--checked--error--readOnly::before,.lsRadioButton--checked--error--parentReadOnly::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{errorBorderColor}') ~\"%22/%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radiusCheckMark}%22%20fill%3D%22\" escape(~'@{errorSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsRadioButton--unchecked--error--readOnly::before,.lsRadioButton--unchecked--error--parentReadOnly::before': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{size}%22%20height%3D%22@{size}%22%20viewBox%3D%220%200%20@{size}%20@{size}%22%3E%3Ccircle%20cx%3D%22@{center}%22%20cy%3D%22@{center}%22%20r%3D%22@{radius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20stroke-width%3D%222%22%20stroke%3D%22\" escape(~'@{errorBorderColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsSelector--styleHelper': {
				"properties": [
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-shadow",
						"expression": "@textShadow"
					}
				]
			},
			'Dsbl .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'Ro .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			'Err .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorFontColor"
					}
				]
			},
			'Warn .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningFontColor"
					}
				]
			},
			'ErrRo .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorReadOnlyFontColor"
					}
				]
			},
			'WarnRo .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningReadOnlyFontColor"
					}
				]
			},
			'.lsControl--monospace': {
				"properties": [
					{
						"name": "font-family",
						"important": true,
						"expression": "@fontFamily"
					}
				]
			},
			' .lsCBStdTxt': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			' .lsCBImgStdDef': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					}
				]
			},
			' .lsCBImgStdDefHv:hover,.urCLbl:hover .lsCBImgStdDefHv': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					}
				]
			},
			' .lsCBImgStdDef .lsRBImgSel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					}
				]
			},
			' .lsCBImgStdDefHv:hover .lsRBImgSel,.urCLbl:hover .lsCBImgStdDefHv .lsRBImgSel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverSelectedBackgroundColor"
					}
				]
			},
			' .lsCBImgStdErr': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@errorBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					}
				]
			},
			' .lsCBImgStdErr .lsRBImgSel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@errorSelectedBackgroundColor"
					}
				]
			},
			'Err .lsCBStdTxt': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorFontColor"
					}
				]
			},
			' .lsCBImgStdInv': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@warningBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					}
				]
			},
			'Inv .lsCBStdTxt': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningFontColor"
					}
				]
			},
			' .lsCBImgStdInv .lsRBImgSel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@warningSelectedBackgroundColor"
					}
				]
			},
			'Dsbl .lsCBStdTxt': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'Ro .lsCBStdTxt': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			' .lsCBImgDsbl, .lsCBImgStdDsbl': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					}
				]
			},
			'Dsbl .lsCBImgStdDef .lsRBImgSel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledSelectedBackgroundColor"
					}
				]
			},
			' .lsCBImgStdRO': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					}
				]
			},
			' .lsCBImgStdRO .lsRBImgSel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlySelectedBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["RadioButtonGroup"] = {
	"name": "RadioButtonGroup",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"ColumnCount": {
			"type": "number",
			"defaultValue": 1
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ItemHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.RadioButton",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["RasterLayout"] = {
	"name": "RasterLayout",
	"properties": {
		"RasterHeight": {
			"type": "number",
			"defaultValue": 1
		},
		"RasterHeightUnit": {
			"type": "string",
			"defaultValue": 'px'
		},
		"RasterWidth": {
			"type": "number",
			"defaultValue": 1
		},
		"RasterWidthUnit": {
			"type": "string",
			"defaultValue": 'px'
		},
		"Compression": {
			"type": "boolean",
			"defaultValue": false
		},
		"Position": {
			"type": "UCF_ClientInterfaces.E.RasterLayoutPosition",
			"defaultValue": "ABSOLUTE"
		},
		"HasSize": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"FixedHeight": {
			"type": "number",
			"defaultValue": -1
		},
		"FixedWidth": {
			"type": "number",
			"defaultValue": -1
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ScrollingMode": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "NONE"
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"CellDesign": {
			"type": "UCF_ClientInterfaces.E.LayoutCellDesign",
			"defaultValue": "PADLESS"
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.RasterLayoutItem",
			"multiple": true,
			"singularName": "Item"
		},
		"Legend": {
			"type": "UCF_ClientInterfaces.I.Legend",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Scroll": {}
	},
	"publicMethods": [
		"showGrid",
		"hideGrid",
		"getAvailableWidth",
		"getAvailableHeight",
		"setScrollPosition",
		"getScrollPosition"
	],
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the content"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"docu": "Defines the background-iamge for the content"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background position X for background image for the content"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background position Y for background image for the content"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"docu": "Defines the background repeat for background image for the content"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"docu": "Defines the background site for background image for the content"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "box-sizing",
						"expression": "border-box"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["RasterLayoutItem"] = {
	"name": "RasterLayoutItem",
	"properties": {
		"Top": {
			"type": "number",
			"defaultValue": 0
		},
		"Left": {
			"type": "number",
			"defaultValue": 0
		},
		"Width": {
			"type": "number",
			"defaultValue": 0
		},
		"Height": {
			"type": "number",
			"defaultValue": 0
		},
		"Position": {
			"type": "UCF_ClientInterfaces.E.RasterLayoutPosition",
			"defaultValue": "ABSOLUTE"
		},
		"Alignment": {
			"type": "UCF_ClientInterfaces.E.RasterLayoutItemAlignment",
			"defaultValue": "CENTER"
		},
		"HasBorder": {
			"type": "boolean",
			"defaultValue": false
		},
		"SemanticBgColor": {
			"type": "UCF_ClientInterfaces.E.TextViewSemanticColor",
			"defaultValue": "DEFAULT"
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"VAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "TOP"
		},
		"PaddingTop": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingBottom": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingRight": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingLeft": {
			"type": "string",
			"defaultValue": ''
		},
		"PositionOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"ZIndex": {
			"type": "number",
			"defaultValue": 0
		},
		"HitZone": {
			"type": "boolean",
			"defaultValue": false
		},
		"CssTop": {
			"type": "string",
			"defaultValue": ''
		},
		"CssLeft": {
			"type": "string",
			"defaultValue": ''
		},
		"CssBottom": {
			"type": "string",
			"defaultValue": ''
		},
		"CssRight": {
			"type": "string",
			"defaultValue": ''
		},
		"CssWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"CssHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"CssMinWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"CssMinHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"CssMaxWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"CssMaxHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CellDesign": {
			"type": "UCF_ClientInterfaces.E.LayoutCellDesign",
			"defaultValue": "PADLESS"
		},
		"StretchingMode": {
			"type": "UCF_ClientInterfaces.E.StretchingMode",
			"defaultValue": "NONE"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color"
			},
			{
				"name": "borderColor",
				"property": "border-color"
			},
			{
				"name": "borderStyle",
				"property": "border-style"
			},
			{
				"name": "borderWidth",
				"property": "border-width"
			},
			{
				"name": "borderRadius",
				"property": "border-radius"
			},
			{
				"name": "backgroundImage",
				"property": "background-image"
			},
			{
				"name": "backgroundSize",
				"property": "background-size"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["RatingIndicator"] = {
	"name": "RatingIndicator",
	"properties": {
		"ItemCount": {
			"type": "number",
			"defaultValue": 0
		},
		"Value": {
			"type": "number",
			"defaultValue": 0
		},
		"DisplayMode": {
			"type": "UCF_ClientInterfaces.E.ValueDisplayMode",
			"defaultValue": "CONTINUOUS"
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"FullItemIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"EmptyItemIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"HoverItemIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.RatingIndicatorItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Rate": {}
	},
	"styles": {
		"variables": [
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color of the RatingIndicator item"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"docu": "Defines the font color of the RatingIndicator item on hover"
			},
			{
				"name": "fullFontColor",
				"property": "color",
				"docu": "Defines the font color of the RatingIndicator item on unselected mode"
			}
		],
		"classes": {
			' .lsRatingindicator__item, .lsRatingindicator__item .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			' .lsRatingindicator__filleditem, .lsRatingindicator__filleditem .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fullFontColor"
					}
				]
			},
			' .lsRatingindicator__filleditem:hover, .lsRatingindicator__filleditem:hover .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			' .lsRatingindicator__item .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			' .lsRatingindicator__filleditem .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@fullFontColor"
					}
				]
			},
			' .lsRatingindicator__filleditem:hover .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["RatingIndicatorItem"] = {
	"name": "RatingIndicatorItem",
	"properties": {
		"RatingItemDesign": {
			"type": "UCF_ClientInterfaces.E.RatingIndicatorDesign",
			"defaultValue": "INITIAL"
		},
		"IsHalfItem": {
			"type": "boolean",
			"defaultValue": false
		},
		"RatingItemAppearance": {
			"type": "UCF_ClientInterfaces.E.RatingIndicatorAppearance",
			"defaultValue": "SQUARE",
			"deprecated": true
		}
	}
};

UCF_ClientInterfaces["I"]["RichTooltip"] = {
	"name": "RichTooltip",
	"properties": {
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"publicMethods": [
		"show"
	]
};

UCF_ClientInterfaces["I"]["RoadMap"] = {
	"name": "RoadMap",
	"properties": {
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"StartingPoint": {
			"type": "UCF_ClientInterfaces.E.RoadMapEdgesDesign",
			"defaultValue": "DEFAULT"
		},
		"EndPoint": {
			"type": "UCF_ClientInterfaces.E.RoadMapEdgesDesign",
			"defaultValue": "DEFAULT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Scroll": {
			"type": "boolean",
			"defaultValue": true
		},
		"FirstVisibleItemIdx": {
			"type": "number",
			"defaultValue": -1
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"ClientSelect": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"RoadItems": {
			"type": "UCF_ClientInterfaces.I.RoadMapItem",
			"multiple": true,
			"singularName": "RoadItem"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {},
		"Scroll": {},
		"PagePrevious": {},
		"PageNext": {}
	}
};

UCF_ClientInterfaces["I"]["RoadMapItem"] = {
	"name": "RoadMapItem",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"StepDesign": {
			"type": "UCF_ClientInterfaces.E.RoadMapStepDesign",
			"defaultValue": "DEFAULT"
		},
		"StepType": {
			"type": "UCF_ClientInterfaces.E.RoadMapStepType",
			"defaultValue": "STANDARDSTEP"
		},
		"StepName": {
			"type": "string",
			"defaultValue": ''
		},
		"StepDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"IsInteractive": {
			"type": "boolean",
			"defaultValue": false
		},
		"DynamicStep": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color within the box."
			},
			{
				"name": "boxFontColor",
				"property": "color",
				"docu": "Defines the font color within the box."
			},
			{
				"name": "boxBorderColor",
				"property": "border-color",
				"docu": "Defines the border color of the box."
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color of the text."
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style of the text."
			},
			{
				"name": "boxHoverColor",
				"property": "color",
				"docu": "Defines the font color of the hovered text in the box."
			},
			{
				"name": "boxHoverBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background color of the hovered box."
			},
			{
				"name": "boxHoverBorderColor",
				"property": "border-color",
				"docu": "Defines the border color of the hovered box."
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"docu": "Defines the font color of the hovered text."
			},
			{
				"name": "subStepBackgroundColor",
				"property": "background-color",
				"expression": "@subStepBackgroundColor || contrast(@backgroundColor, lighten(@backgroundColor,20%), darken(@backgroundColor,20%))",
				"docu": "Defines the background color within the sub step box."
			},
			{
				"name": "subStepBoxFontColor",
				"property": "color",
				"expression": "@subStepBoxFontColor || @boxFontColor",
				"docu": "Defines the font color within the sub step box."
			},
			{
				"name": "subStepBoxBorderColor",
				"property": "border-color",
				"expression": "@subStepBoxBorderColor || contrast(@boxBorderColor)",
				"docu": "Defines the border color of the sub step box."
			},
			{
				"name": "subStepFontColor",
				"property": "color",
				"expression": "@subStepFontColor || @fontColor",
				"docu": "Defines the sub step font color."
			},
			{
				"name": "subStepFontStyle",
				"property": "font-style",
				"expression": "@subStepFontStyle || @fontStyle",
				"docu": "Defines the sub step font style."
			},
			{
				"name": "subStepBoxHoverColor",
				"property": "color",
				"expression": "@subStepBoxHoverColor || contrast(@boxHoverColor)",
				"docu": "Defines the sub step font color of the hovered text in the box."
			},
			{
				"name": "subStepBoxHoverBackgroundColor",
				"property": "background-color",
				"expression": "@subStepBoxHoverBackgroundColor || contrast(@boxHoverBackgroundColor, lighten(@boxHoverBackgroundColor,20%), darken(@boxHoverBackgroundColor,20%))",
				"docu": "Defines the sub step background color of the hovered box."
			},
			{
				"name": "subStepBoxHoverBorderColor",
				"property": "border-color",
				"expression": "@subStepBoxHoverBorderColor ||contrast(@boxHoverBorderColor)",
				"docu": "Defines the sub step border color of the hovered box."
			},
			{
				"name": "subStepHoverFontColor",
				"property": "color",
				"expression": "@subStepHoverFontColor || @hoverFontColor",
				"docu": "Defines the sub step font color of the hovered text."
			},
			{
				"name": "selectedBackgroundColor",
				"property": "background-color",
				"expression": "@selectedBackgroundColor || contrast(@backgroundColor, lighten(@backgroundColor,20%), darken(@backgroundColor,20%))",
				"docu": "Defines the background color within the selected step box."
			},
			{
				"name": "selectedBoxFontColor",
				"property": "color",
				"expression": "@selectedBoxFontColor || @boxFontColor",
				"docu": "Defines the font color within the selected step box."
			},
			{
				"name": "selectedBoxBorderColor",
				"property": "border-color",
				"expression": "@selectedBoxBorderColor || contrast(@boxBorderColor)",
				"docu": "Defines the border color of the selected step box."
			},
			{
				"name": "selectedFontColor",
				"property": "color",
				"expression": "@selectedFontColor || @fontColor",
				"docu": "Defines the font color for a selected step."
			},
			{
				"name": "selectedFontStyle",
				"property": "font-style",
				"expression": "@selectedFontStyle || @fontStyle",
				"docu": "Defines the font style for a selected step."
			},
			{
				"name": "selectedBoxHoverColor",
				"property": "color",
				"expression": "@selectedBoxHoverColor || contrast(@boxHoverColor)",
				"docu": "Defines the selected font color of the hovered text in the box."
			},
			{
				"name": "selectedBoxHoverBackgroundColor",
				"property": "background-color",
				"expression": "@selectedBoxHoverBackgroundColor || contrast(@boxHoverBackgroundColor, lighten(@boxHoverBackgroundColor,20%), darken(@boxHoverBackgroundColor,20%))",
				"docu": "Defines the selected background color of the hovered box."
			},
			{
				"name": "selectedBoxHoverBorderColor",
				"property": "border-color",
				"expression": "@selectedBoxHoverBorderColor || contrast(@boxHoverBorderColor)",
				"docu": "Defines the selected border color of the hovered box."
			},
			{
				"name": "selectedHoverFontColor",
				"property": "color",
				"expression": "@selectedHoverFontColor || @hoverFontColor",
				"docu": "Defines the selected font color of the hovered text."
			},
			{
				"name": "selectedSubStepBackgroundColor",
				"property": "background-color",
				"expression": "@selectedSubStepBackgroundColor || contrast(@subStepBackgroundColor, lighten(@subStepBackgroundColor,20%), darken(@subStepBackgroundColor,20%))",
				"docu": "Defines the background color within the selected sub step box."
			},
			{
				"name": "selectedSubStepBoxFontColor",
				"property": "color",
				"expression": "@selectedSubStepBoxFontColor || @subStepBoxFontColor",
				"docu": "Defines the font color within the selected sub step box."
			},
			{
				"name": "selectedSubStepBoxBorderColor",
				"property": "border-color",
				"expression": "@selectedSubStepBoxBorderColor || contrast(@subStepBoxBorderColor)",
				"docu": "Defines the border color of the selected sub step box."
			},
			{
				"name": "selectedSubStepFontColor",
				"property": "color",
				"expression": "@selectedSubStepFontColor || @subStepFontColor",
				"docu": "Defines the font color for a selected sub step."
			},
			{
				"name": "selectedSubStepFontStyle",
				"property": "font-style",
				"expression": "@selectedSubStepFontStyle || @subStepFontStyle",
				"docu": "Defines the font style for a selected sub step."
			},
			{
				"name": "selectedSubStepBoxHoverColor",
				"property": "color",
				"expression": "@selectedSubStepBoxHoverColor || contrast(@subStepBoxHoverColor)",
				"docu": "Defines the selected font color of a hovered sub step box."
			},
			{
				"name": "selectedSubStepBoxHoverBackgroundColor",
				"property": "background-color",
				"expression": "@selectedSubStepBoxHoverBackgroundColor || contrast(@subStepBoxHoverBackgroundColor, lighten(@subStepBoxHoverBackgroundColor,20%), darken(@subStepBoxHoverBackgroundColor,20%))",
				"docu": "Defines the selected background color of a hovered sub step box."
			},
			{
				"name": "selectedSubStepBoxHoverBorderColor",
				"property": "border-color",
				"expression": "@selectedSubStepBoxHoverBorderColor || contrast(@subStepBoxHoverBorderColor)",
				"docu": "Defines the selected border color of a hovered sub step box."
			},
			{
				"name": "selectedSubStepHoverFontColor",
				"property": "color",
				"expression": "@selectedSubStepHoverFontColor || @selectedHoverFontColor",
				"docu": "Defines the selected font color of the hovered sub step text."
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"expression": "@disabledBackgroundColor || desaturate(@backgroundColor, 90%)",
				"docu": "Defines the background color within the disabled step box."
			},
			{
				"name": "disabledBoxFontColor",
				"property": "color",
				"expression": "@disabledBoxFontColor || desaturate(@boxFontColor, 100%)",
				"docu": "Defines the font color within the disabled step box."
			},
			{
				"name": "disabledBoxBorderColor",
				"property": "border-color",
				"expression": "@disabledBoxBorderColor || desaturate(@boxBorderColor, 90%)",
				"docu": "Defines the border color of the disabled step box."
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "@disabledFontColor || desaturate(@fontColor, 100%)",
				"docu": "Defines the font color for a disabled step."
			},
			{
				"name": "disabledFontStyle",
				"property": "font-style",
				"expression": "@disabledFontStyle || @fontStyle",
				"docu": "Defines the font style for a disabled step."
			},
			{
				"name": "disabledSubStepBackgroundColor",
				"property": "background-color",
				"expression": "@disabledSubStepBackgroundColor || desaturate(@disabledBackgroundColor, 90%)",
				"docu": "Defines the background color within the disabled sub step box."
			},
			{
				"name": "disabledSubStepBoxFontColor",
				"property": "color",
				"expression": "@disabledSubStepBoxFontColor || desaturate(@disabledBoxFontColor, 100%)",
				"docu": "Defines the font color within the disabled sub step box."
			},
			{
				"name": "disabledSubStepBoxBorderColor",
				"property": "border-color",
				"expression": "@disabledSubStepBoxBorderColor || desaturate(@disabledBoxBorderColor, 90%)",
				"docu": "Defines the border color of the disabled sub step box."
			},
			{
				"name": "disabledSubStepFontColor",
				"property": "color",
				"expression": "@disabledSubStepFontColor || desaturate(@disabledFontColor, 100%)",
				"docu": "Defines the font color for a disabled sub step."
			},
			{
				"name": "disabledSubStepFontStyle",
				"property": "font-style",
				"expression": "@disabledSubStepFontStyle || @disabledFontStyle",
				"docu": "Defines the font style for a disabled sub step."
			}
		],
		"classes": {
			'.lsRMstep2': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@boxBorderColor"
					},
					{
						"name": "color",
						"expression": "@boxFontColor"
					}
				]
			},
			'.lsRMsubStep': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@subStepBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@subStepBoxBorderColor"
					},
					{
						"name": "color",
						"expression": "@subStepBoxFontColor"
					}
				]
			},
			'.lsRMstep2Sel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBoxBorderColor"
					},
					{
						"name": "color",
						"expression": "@selectedBoxFontColor"
					}
				]
			},
			'.lsRMsubStepSel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedSubStepBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedSubStepBoxBorderColor"
					},
					{
						"name": "color",
						"expression": "@selectedSubStepBoxFontColor"
					}
				]
			},
			'.lsRMstep2Dsbl': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBoxBorderColor"
					},
					{
						"name": "color",
						"expression": "@disabledBoxFontColor"
					}
				]
			},
			'.lsRMsubStepDsbl': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledSubStepBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledSubStepBoxBorderColor"
					},
					{
						"name": "color",
						"expression": "@disabledSubStepBoxFontColor"
					}
				]
			},
			'.lsRMdefault @{CustomStyle}.lsRMTitle,.lsRMrtStart2 @{CustomStyle}.lsRMTitle,.lsRMrtEnd2 @{CustomStyle}.lsRMTitle': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					}
				]
			},
			'.lsRMdefault @{CustomStyle}.lsRMTitleSel,.lsRMrtStart2 @{CustomStyle}.lsRMTitleSel,.lsRMrtEnd2 @{CustomStyle}.lsRMTitleSel': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					},
					{
						"name": "font-style",
						"expression": "@selectedFontStyle"
					}
				]
			},
			'.lsRMdefault @{CustomStyle}.lsRMTitleDsbl,.lsRMrtStart2 @{CustomStyle}.lsRMTitleDsbl,.lsRMrtEnd2 @{CustomStyle}.lsRMTitleDsbl': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					},
					{
						"name": "font-style",
						"expression": "@disabledFontStyle"
					}
				]
			},
			'.lsRMsub @{CustomStyle}.lsRMTitle': {
				"properties": [
					{
						"name": "color",
						"expression": "@subStepFontColor"
					},
					{
						"name": "font-style",
						"expression": "@subStepFontStyle"
					}
				]
			},
			'.lsRMsub @{CustomStyle}.lsRMTitleSel': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedSubStepFontColor"
					},
					{
						"name": "font-style",
						"expression": "@selectedSubStepFontStyle"
					}
				]
			},
			'.lsRMsub @{CustomStyle}.lsRMTitleDsbl': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledSubStepFontColor"
					},
					{
						"name": "font-style",
						"expression": "@disabledSubStepFontStyle"
					}
				]
			},
			'.lsRMstep2Hover': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@boxHoverColor"
					},
					{
						"name": "background-color",
						"expression": "@boxHoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@boxHoverBorderColor"
					}
				]
			},
			'.lsRMsubStepHover': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@subStepBoxHoverColor"
					},
					{
						"name": "background-color",
						"expression": "@subStepBoxHoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@subStepBoxHoverBorderColor"
					}
				]
			},
			'.lsRMfloat:hover @{CustomStyle}.lsRMstep2Sel,.lsRMfloat:hover @{CustomStyle}.lsRMsubStepSel,.lsRMdefault:hover @{CustomStyle}.lsRMstep2Sel,.lsRMdefault:hover @{CustomStyle}.lsRMsubStepSel': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@selectedBoxHoverColor"
					},
					{
						"name": "background-color",
						"expression": "@selectedBoxHoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBoxHoverBorderColor"
					}
				]
			},
			'.lsRMTitleHover': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsRMsub @{CustomStyle}.lsRMTitleHover': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@subStepHoverFontColor"
					}
				]
			},
			'.lsRMfloat:hover .lsRMdefault @{CustomStyle}.lsRMTitleSel,.lsRMfloat:hover .lsRMrtStart2 @{CustomStyle}.lsRMTitleSel,.lsRMfloat:hover .lsRMrtEnd2 @{CustomStyle}.lsRMTitleSel': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@selectedHoverFontColor"
					}
				]
			},
			'.lsRMfloat:hover .lsRMsub @{CustomStyle}.lsRMTitleSel': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@selectedSubStepHoverFontColor"
					}
				]
			},
			'.lsRMfloat:hover .lsRMsub @{CustomStyle}.lsRMsubStepSel': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@selectedSubStepBoxHoverColor"
					},
					{
						"name": "background-color",
						"expression": "@selectedSubStepBoxHoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedSubStepBoxHoverBorderColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["SapTable"] = {
	"name": "SapTable",
	"properties": {
		"TitleVisible": {
			"type": "boolean",
			"defaultValue": true
		},
		"TitleText": {
			"type": "string",
			"defaultValue": ''
		},
		"HasTitleCaption": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasTitleContent": {
			"type": "boolean",
			"defaultValue": false
		},
		"Transparent": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasToolbar": {
			"type": "boolean",
			"defaultValue": false
		},
		"Summary": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"HasFooter": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasHeaderRow": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"GridMode": {
			"type": "UCF_ClientInterfaces.E.SapTableGridMode",
			"defaultValue": "BOTH"
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"RowCount": {
			"type": "number",
			"defaultValue": -1
		},
		"ColCount": {
			"type": "number",
			"defaultValue": -1
		},
		"VisibleFirstRow": {
			"type": "number",
			"defaultValue": -1
		},
		"VisibleRowCount": {
			"type": "number",
			"defaultValue": -1
		},
		"VisibleColCount": {
			"type": "number",
			"defaultValue": -1
		},
		"ScrollableColCount": {
			"type": "number",
			"defaultValue": -1
		},
		"VisibleScrollableColCount": {
			"type": "number",
			"defaultValue": -1
		},
		"FirstVisibleScrollableCol": {
			"type": "number",
			"defaultValue": -1
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"VerticalPaginatorId": {
			"type": "string",
			"defaultValue": ''
		},
		"HorizontalPaginatorId": {
			"type": "string",
			"defaultValue": ''
		},
		"HasLegendContainer": {
			"type": "boolean",
			"defaultValue": false
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"HasVerticalScrollbar": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasHorizontalScrollbar": {
			"type": "boolean",
			"defaultValue": false
		},
		"VerticalScrollRange": {
			"type": "number",
			"defaultValue": -1
		},
		"ScrollbarVisibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"DragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"ColumnRootDragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"ColumnRootDropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"RowSelectionMode": {
			"type": "UCF_ClientInterfaces.E.SapTableRowSelectionMode",
			"defaultValue": "SERVER"
		},
		"RowSelectionClientBehaviour": {
			"type": "UCF_ClientInterfaces.E.SapTableRowSelectionClientBehaviour",
			"defaultValue": "NONE"
		},
		"RowSelectionFollowFocus": {
			"type": "UCF_ClientInterfaces.E.SapTableRowSelectionFollowFocus",
			"defaultValue": "NONE"
		},
		"RowSelectionReferenceIndex": {
			"type": "number",
			"defaultValue": -2147483648
		},
		"RowSelectionRangeEndIndex": {
			"type": "number",
			"defaultValue": -2147483648
		},
		"RowSelectionMassOperation": {
			"type": "boolean",
			"defaultValue": true
		},
		"RowSelectionMassState": {
			"type": "UCF_ClientInterfaces.E.SapTableRowSelectionMassState",
			"defaultValue": "NONE"
		},
		"RowsSelected": {
			"type": "string",
			"defaultValue": ''
		},
		"SelectableRowCount": {
			"type": "number",
			"defaultValue": -1
		},
		"RowCreationTrigger": {
			"type": "UCF_ClientInterfaces.E.SapTableRowCreationTrigger",
			"defaultValue": "INHERIT"
		},
		"CellSelectionKeyboardTrigger": {
			"type": "UCF_ClientInterfaces.E.SapTableCellSelectionKeyboardTrigger",
			"defaultValue": "SPACEBAR_ENTER"
		},
		"CellSelectionMapping": {
			"type": "UCF_ClientInterfaces.E.SapTableCellSelectionMapping",
			"defaultValue": "NONE"
		},
		"CellEventProcessing": {
			"type": "UCF_ClientInterfaces.E.SapTableCellEventProcessing",
			"defaultValue": "STANDARD"
		},
		"ContentThemeScope": {
			"type": "string",
			"defaultValue": ''
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"ResizeMode": {
			"type": "UCF_ClientInterfaces.E.ResizeMode",
			"defaultValue": "NONE"
		},
		"HorizontalScrollUpdateMode": {
			"type": "UCF_ClientInterfaces.E.SapTableScrollUpdateMode",
			"defaultValue": "SERVER"
		},
		"HorizontalScrollPosition": {
			"type": "number",
			"defaultValue": 0
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"BlockSelection": {
			"type": "string",
			"defaultValue": ''
		},
		"ColumnTitleAdoption": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"SelectionMassAction": {
			"type": "UCF_ClientInterfaces.E.SapTableSelectionMassAction",
			"defaultValue": "ROW"
		}
	},
	"aggregations": {
		"TitleCaption": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": false
		},
		"TitleContent": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"Toolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"TableBody": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"FooterContent": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"Legend": {
			"type": "UCF_ClientInterfaces.I.Legend",
			"multiple": false
		},
		"LegendContainer": {
			"type": "UCF_ClientInterfaces.I.PopIn",
			"multiple": false
		},
		"VerticalScrollTips": {
			"type": "UCF_ClientInterfaces.I.ScrollTip",
			"multiple": true,
			"singularName": "VerticalScrollTip"
		},
		"HorizontalScrollTips": {
			"type": "UCF_ClientInterfaces.I.ScrollTip",
			"multiple": true,
			"singularName": "HorizontalScrollTip"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"RowSelect": {},
		"ClientRowSelect": {},
		"ClientPrimaryRowChange": {},
		"Filter": {},
		"CellSelect": {},
		"ColSort": {},
		"HeaderCellSelect": {},
		"HeaderActionMenuAccess": {},
		"CellExpand": {},
		"CellCollapse": {},
		"CellIconSelect": {},
		"SelectionMenuItemSelect": {},
		"CellContextMenu": {},
		"VerticalScroll": {},
		"HorizontalScroll": {},
		"ClipboardSelectionDataGet": {},
		"ColumnReorder": {},
		"ColumnResize": {},
		"RowCreate": {},
		"Hotkey": {},
		"Drag": {},
		"Drop": {},
		"TableResize": {},
		"CopyToClipboardRequest": {},
		"BlockSelect": {}
	},
	"publicMethods": [
		"setPrimaryRowSelection",
		"setRowSelection",
		"clearRowSelection",
		"setColumnSelection",
		"getPrimaryRowSelection",
		"getRowSelection",
		"getColumnSelection",
		"setClipboardHtml",
		"openHeaderActionMenu",
		"setDefaultButtonId",
		"getColumnWidth",
		"setColumnWidth",
		"setRowRootDropTargetInfo",
		"setRowRootDragSourceInfo",
		"getColumnHeaderDropTargetInfo",
		"setColumnHeaderDropTargetInfo",
		"getColumnHeaderDragSourceInfo",
		"setColumnHeaderDragSourceInfo",
		"getCell",
		"setBlockSelection",
		"visualizeCopyToClipboard"
	]
};

UCF_ClientInterfaces["I"]["SapTableCell"] = {
	"name": "SapTableCell",
	"properties": {
		"HasBorder": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"IsSelected": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsSecondarySelected": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsReadOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "LEFT"
		},
		"VerticalAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "MIDDLE"
		},
		"CellType": {
			"type": "UCF_ClientInterfaces.E.SapTableCellType",
			"defaultValue": "TEXT"
		},
		"CellDesign": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"ColIdx": {
			"type": "number",
			"defaultValue": -1
		},
		"HasContent": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"HasContentPadding": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"ContentPadding": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"IsClickable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Colspan": {
			"type": "number",
			"defaultValue": 1
		},
		"Rowspan": {
			"type": "number",
			"defaultValue": 1
		},
		"HeaderCellIds": {
			"type": "string",
			"defaultValue": ''
		},
		"RowHeaderCellIds": {
			"type": "string",
			"defaultValue": ''
		},
		"IsLastFixedColumn": {
			"type": "boolean",
			"defaultValue": false
		},
		"FixedTableBody": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsTableReadOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentVisibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"GroupingMode": {
			"type": "UCF_ClientInterfaces.E.SapTableCellGroupingMode",
			"defaultValue": "NONE"
		},
		"SemanticType": {
			"type": "UCF_ClientInterfaces.E.SapTableSemanticType",
			"defaultValue": "NONE"
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"getContent"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urSTd,font-family)",
				"docu": "Defines the font family of the SapTableCell"
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"defaultValue": "ruleValue(.urSTd,color)",
				"docu": "Defines the font color of the SapTableCell"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"defaultValue": "ruleValue(.urSTd,font-weight)",
				"docu": "Defines the font color of the SapTableCell"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urSTd,font-size)",
				"docu": "Defines the font color of the SapTableCell"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"defaultValue": "ruleValue(.urSTd,font-style)",
				"docu": "Defines the font color of the SapTableCell"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"defaultValue": "ruleValue(.urSTd,text-decoration)",
				"docu": "Defines the text decoration of the SapTableCell"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urSTd,background-color)",
				"docu": "Defines the background color of the SapTableCell"
			},
			{
				"name": "inputFontSize",
				"property": "font-size",
				"defaultValue": "themeValue(.lsField__metadata,inputFontSize)",
				"docu": "DO NOT CHANGE THIS!"
			}
		],
		"classes": {
			', .lsTextView, .lsLabel, .lsLink__text, .lsLinkchoice': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					}
				]
			},
			' .lsField,NotSel .lsField': {
				"properties": [
					{
						"name": "font-size",
						"expression": "~\"calc(@{fontSize} / @{inputFontSize})\""
					}
				]
			},
			', .lsField__input, .lsTextView, .lsLabel, .lsLink, .lsLinkchoice': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			"NotSel": {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor || contrast(@backgroundColor)"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					}
				]
			},
			'NotSel .lsField__input': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor || contrast(@backgroundColor)"
					},
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'NotSel .urTxtStd,NotSel .lsTextView--color,NotSel .lsLabel,NotSel .lsLink__text,NotSel .lsLinkchoice': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor || contrast(@backgroundColor)"
					},
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableCellEditor"] = {
	"name": "SapTableCellEditor"
};

UCF_ClientInterfaces["I"]["SapTableColumn"] = {
	"name": "SapTableColumn",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"ReservedWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"ColumnType": {
			"type": "UCF_ClientInterfaces.E.SapTableColumnType",
			"defaultValue": "STANDARD"
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableCS"] = {
	"name": "SapTableCS",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Transparent": {
			"type": "boolean",
			"defaultValue": false
		},
		"GridMode": {
			"type": "UCF_ClientInterfaces.E.SapTableGridMode",
			"defaultValue": "BOTH"
		},
		"GapGrid": {
			"type": "UCF_ClientInterfaces.E.SapTableGapGrid",
			"defaultValue": "ALL"
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"SelectionColumnAction": {
			"type": "UCF_ClientInterfaces.E.SapTableSelectionColumnAction",
			"defaultValue": "NONE"
		},
		"SelectionMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"Configurable": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentRowCount": {
			"type": "number",
			"defaultValue": 0
		},
		"VisibleContentRowCount": {
			"type": "number",
			"defaultValue": 5
		},
		"FirstVisibleContentRowIndex": {
			"type": "number",
			"defaultValue": 0
		},
		"RowHeight": {
			"type": "number",
			"defaultValue": 1
		},
		"HorizontalScrollPosition": {
			"type": "number",
			"defaultValue": 0
		},
		"VerticalPagerId": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalScrollUpdateMode": {
			"type": "UCF_ClientInterfaces.E.SapTableScrollUpdateMode",
			"defaultValue": "CLIENT"
		},
		"ResizeMode": {
			"type": "UCF_ClientInterfaces.E.ResizeMode",
			"defaultValue": "NONE"
		},
		"RowSelectionMode": {
			"type": "UCF_ClientInterfaces.E.SapTableRowSelectionMode",
			"defaultValue": "SERVER"
		},
		"RowSelectionClientBehaviour": {
			"type": "UCF_ClientInterfaces.E.SapTableRowSelectionClientBehaviour",
			"defaultValue": "NONE"
		},
		"RowSelectionFollowFocus": {
			"type": "UCF_ClientInterfaces.E.SapTableRowSelectionFollowFocus",
			"defaultValue": "NONE"
		},
		"RowSelectionReferenceIndex": {
			"type": "number",
			"defaultValue": -2147483648
		},
		"RowSelectionRangeEndIndex": {
			"type": "number",
			"defaultValue": -2147483648
		},
		"RowSelectionMassOperation": {
			"type": "boolean",
			"defaultValue": true
		},
		"RowSelectionMassState": {
			"type": "UCF_ClientInterfaces.E.SapTableRowSelectionMassState",
			"defaultValue": "NONE"
		},
		"RowsSelected": {
			"type": "string",
			"defaultValue": ''
		},
		"SelectableRowCount": {
			"type": "number",
			"defaultValue": -1
		},
		"ColumnSelectionMode": {
			"type": "UCF_ClientInterfaces.E.SapTableColumnSelectionMode",
			"defaultValue": "NONE"
		},
		"ColumnSelectionClientBehaviour": {
			"type": "UCF_ClientInterfaces.E.SapTableColumnSelectionClientBehaviour",
			"defaultValue": "NONE"
		},
		"ColumnSelectionReferenceIndex": {
			"type": "number",
			"defaultValue": -2147483648
		},
		"ColumnSelectionRangeEndIndex": {
			"type": "number",
			"defaultValue": -2147483648
		},
		"RowCreationTrigger": {
			"type": "UCF_ClientInterfaces.E.SapTableRowCreationTrigger",
			"defaultValue": "NONE"
		},
		"CellSelectionKeyboardTrigger": {
			"type": "UCF_ClientInterfaces.E.SapTableCellSelectionKeyboardTrigger",
			"defaultValue": "SPACEBAR_ENTER"
		},
		"CellSelectionMapping": {
			"type": "UCF_ClientInterfaces.E.SapTableCellSelectionMapping",
			"defaultValue": "NONE"
		},
		"CellEventProcessing": {
			"type": "UCF_ClientInterfaces.E.SapTableCellEventProcessing",
			"defaultValue": "STANDARD"
		},
		"ContentBackgroundDesign": {
			"type": "UCF_ClientInterfaces.E.SapTableContentBackgroundDesign",
			"defaultValue": "INHERIT"
		},
		"ContentEditMode": {
			"type": "UCF_ClientInterfaces.E.SapTableContentEditMode",
			"defaultValue": "READONLY"
		},
		"ContentThemeScope": {
			"type": "string",
			"defaultValue": ''
		},
		"NoDataNotification": {
			"type": "UCF_ClientInterfaces.E.SapTableNoDataNotificationMode",
			"defaultValue": "NONE"
		},
		"NoDataNotificationText": {
			"type": "string",
			"defaultValue": ''
		},
		"RowRootDragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"RowRootDropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"ColumnRootDragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"ColumnRootDropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"RenderFragment": {
			"type": "UCF_ClientInterfaces.E.SapTableCSRenderFragment",
			"defaultValue": "FULL"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"BlockSelection": {
			"type": "string",
			"defaultValue": ''
		},
		"ColumnTitleAdoption": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"SelectionMassAction": {
			"type": "UCF_ClientInterfaces.E.SapTableSelectionMassAction",
			"defaultValue": "ROW"
		}
	},
	"aggregations": {
		"Title": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"Toolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"HeaderRows": {
			"type": "UCF_ClientInterfaces.I.SapTableCSRow",
			"multiple": true,
			"singularName": "HeaderRow"
		},
		"TopFixedRows": {
			"type": "UCF_ClientInterfaces.I.SapTableCSRow",
			"multiple": true,
			"singularName": "TopFixedRow"
		},
		"ContentRows": {
			"type": "UCF_ClientInterfaces.I.SapTableCSRow",
			"multiple": true,
			"singularName": "ContentRow"
		},
		"ContentRowsFragments": {
			"type": "UCF_ClientInterfaces.I.SapTableCSRowsFragment",
			"multiple": true,
			"singularName": "ContentRowsFragment"
		},
		"BottomFixedRows": {
			"type": "UCF_ClientInterfaces.I.SapTableCSRow",
			"multiple": true,
			"singularName": "BottomFixedRow"
		},
		"LeftFixedColumns": {
			"type": "UCF_ClientInterfaces.I.SapTableCSColumn",
			"multiple": true,
			"singularName": "LeftFixedColumn"
		},
		"NoneFixedColumns": {
			"type": "UCF_ClientInterfaces.I.SapTableCSColumn",
			"multiple": true,
			"singularName": "NoneFixedColumn"
		},
		"RightFixedColumns": {
			"type": "UCF_ClientInterfaces.I.SapTableCSColumn",
			"multiple": true,
			"singularName": "RightFixedColumn"
		},
		"VerticalScrollbar": {
			"type": "UCF_ClientInterfaces.I.Scrollbar",
			"multiple": false
		},
		"HorizontalScrollbar": {
			"type": "UCF_ClientInterfaces.I.Scrollbar",
			"multiple": false
		},
		"Legend": {
			"type": "UCF_ClientInterfaces.I.Legend",
			"multiple": false
		},
		"FooterAreaContent": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"RowSelect": {},
		"ClientRowSelect": {},
		"ColumnSelect": {},
		"ClientColumnSelect": {},
		"ClientPrimaryRowChange": {},
		"Filter": {},
		"CellSelect": {},
		"CellDoubleClick": {},
		"ColSort": {},
		"HeaderCellSelect": {},
		"HeaderActionMenuAccess": {},
		"CellExpand": {},
		"CellCollapse": {},
		"CellIconSelect": {},
		"SelectionMenuItemSelect": {},
		"CellContextMenu": {},
		"VerticalScroll": {},
		"HorizontalScroll": {},
		"ClipboardSelectionDataGet": {},
		"ColumnReorder": {},
		"ColumnResize": {},
		"RowCreate": {},
		"Hotkey": {},
		"Drag": {},
		"Drop": {},
		"TableResize": {},
		"Config": {},
		"RequestData": {},
		"DataCleanUp": {},
		"CopyToClipboardRequest": {},
		"BlockSelect": {}
	},
	"publicMethods": [
		"setRowSelection",
		"clearRowSelection",
		"setCellSelection",
		"setColumnSelection",
		"getRowSelection",
		"getCellSelection",
		"getColumnSelection",
		"setVisibleRowCount",
		"setFirstVisibleRowIndex",
		"getFocusInfoByIndex",
		"openHeaderActionMenu",
		"setDefaultButtonId",
		"getColumnWidth",
		"setColumnWidth",
		"setRowRootDropTargetInfo",
		"setRowRootDragSourceInfo",
		"getColumnHeaderDropTargetInfo",
		"setColumnHeaderDropTargetInfo",
		"getColumnHeaderDragSourceInfo",
		"setColumnHeaderDragSourceInfo",
		"setDataCleanUpThreshold",
		"setHighlightTexts",
		"getCell",
		"setBlockSelection",
		"visualizeCopyToClipboard"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urST3Tit,font-family)",
				"docu": "Defines the font family of the SapTableCS."
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"defaultValue": "ruleValue(.urST3Tit,color)",
				"docu": "Defines the font color of the SapTableCS."
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"defaultValue": "ruleValue(.urST3Tit,font-weight)",
				"docu": "Defines the font color of the SapTableCS."
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urST3Tit,font-size)",
				"docu": "Defines the font color of the SapTableCS."
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"defaultValue": "ruleValue(.urST3Tit,font-style)",
				"docu": "Defines the font color of the SapTableCS."
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"defaultValue": "ruleValue(.urST3Tit,text-decoration)",
				"docu": "Defines the text decoration of the SapTableCS."
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urST3Tit,background-color)",
				"docu": "Defines the background color of the SapTableCS."
			},
			{
				"name": "headerBackgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urST3Tit,background-color)",
				"docu": "Defines the header background color of the SapTableCS."
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor || contrast(@backgroundColor)"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			"TitleArea": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor || contrast(@backgroundColor)"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@headerBackgroundColor || @backgroundColor"
					}
				]
			},
			"ContentArea": {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableCSCell"] = {
	"name": "SapTableCSCell",
	"properties": {
		"SelectionState": {
			"type": "UCF_ClientInterfaces.E.SapTableSelectionState",
			"defaultValue": "NOT_SELECTED"
		},
		"HorizontalAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "BEGINOFLINE"
		},
		"VerticalAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "TOP"
		},
		"Colspan": {
			"type": "number",
			"defaultValue": 1
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"Mode": {
			"type": "UCF_ClientInterfaces.E.SapTableCellMode",
			"defaultValue": "CONTENT_READONLY"
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Indention": {
			"type": "number",
			"defaultValue": 0
		},
		"HierarchicalState": {
			"type": "UCF_ClientInterfaces.E.SapTableHierarchicalCellStatus",
			"defaultValue": "NONE"
		},
		"GroupingMode": {
			"type": "UCF_ClientInterfaces.E.SapTableCellGroupingMode",
			"defaultValue": "NONE"
		},
		"ContentPadding": {
			"type": "string",
			"defaultValue": ''
		},
		"BorderOmitting": {
			"type": "UCF_ClientInterfaces.E.SapTableBorderOmitting",
			"defaultValue": "NONE"
		},
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentVisibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"SemanticType": {
			"type": "UCF_ClientInterfaces.E.SapTableSemanticType",
			"defaultValue": "NONE"
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"getContent"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urSTd,font-family)",
				"docu": "Defines the font family of the SapTableCSCell."
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"defaultValue": "ruleValue(.urSTd,color)",
				"docu": "Defines the font color of the SapTableCSCell."
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"defaultValue": "ruleValue(.urSTd,font-weight)",
				"docu": "Defines the font color of the SapTableCSCell."
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urSTd,font-size)",
				"docu": "Defines the font color of the SapTableCSCell."
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"defaultValue": "ruleValue(.urSTd,font-style)",
				"docu": "Defines the font color of the SapTableCSCell."
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"defaultValue": "ruleValue(.urSTd,text-decoration)",
				"docu": "Defines the text decoration of the SapTableCSCell."
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urSTd,background-color)",
				"docu": "Defines the background color of the SapTableCSCell."
			},
			{
				"name": "inputFontSize",
				"property": "font-size",
				"defaultValue": "themeValue(.lsField__metadata,inputFontSize)",
				"docu": "DO NOT CHANGE THIS!"
			}
		],
		"classes": {
			', .lsTextView, .lsLabel, .lsLink__text, .lsLinkchoice': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					}
				]
			},
			' .lsField,NotSel .lsField': {
				"properties": [
					{
						"name": "font-size",
						"expression": "~\"calc(@{fontSize} / @{inputFontSize})\""
					}
				]
			},
			', .lsField__input, .lsTextView, .lsLabel, .lsLink, .lsLinkchoice': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			"NotSel": {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor || contrast(@backgroundColor)"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					}
				]
			},
			'NotSel .lsField__input': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor || contrast(@backgroundColor)"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'NotSel .urTxtStd,NotSel .lsTextView--color,NotSel .lsLabel,NotSel .lsLink__text,NotSel .lsLinkchoice': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor || contrast(@backgroundColor)"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableCSColumn"] = {
	"name": "SapTableCSColumn",
	"properties": {
		"SelectionState": {
			"type": "UCF_ClientInterfaces.E.SapTableSelectionState",
			"defaultValue": "NOT_SELECTABLE"
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.SapTableColumnType",
			"defaultValue": "STANDARD"
		},
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"Index": {
			"type": "number",
			"defaultValue": -1
		},
		"Resizable": {
			"type": "boolean",
			"defaultValue": true
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableCSHeaderCell"] = {
	"name": "SapTableCSHeaderCell",
	"properties": {
		"SortState": {
			"type": "UCF_ClientInterfaces.E.SortState",
			"defaultValue": "DISABLED"
		},
		"HorizontalAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "BEGINOFLINE"
		},
		"VerticalAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "TOP"
		},
		"Colspan": {
			"type": "number",
			"defaultValue": 1
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"Filtered": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentPadding": {
			"type": "string",
			"defaultValue": ''
		},
		"IconUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"IconTooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"IconFirst": {
			"type": "boolean",
			"defaultValue": false
		},
		"IconEnabled": {
			"type": "boolean",
			"defaultValue": false
		},
		"ActionMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"DragSourceFlavours": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"DropTargetFlavours": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"DragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"ParentDropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Title": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": false
		},
		"MultipleTitles": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": true,
			"singularName": "MultipleTitle"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"getCurrentTitle"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urST5HCMetricContent,font-family)",
				"docu": "Defines the font family of the SapTableCSHeaderCell."
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"defaultValue": "ruleValue(.urST5HCMetricContent,color)",
				"docu": "Defines the font color of the SapTableCSHeaderCell."
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"defaultValue": "ruleValue(.urST5HCMetricContent,font-weight)",
				"docu": "Defines the font color of the SapTableCSHeaderCell."
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urST5HCMetricContent,font-size)",
				"docu": "Defines the font color of the SapTableCSHeaderCell."
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"defaultValue": "ruleValue(.urST5HCMetricContent,font-style)",
				"docu": "Defines the font color of the SapTableCSHeaderCell."
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"defaultValue": "ruleValue(.urST5HCMetricContent,text-decoration)",
				"docu": "Defines the text decoration of the SapTableCSHeaderCell."
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urST5HCMetricContent,background-color)",
				"docu": "Defines the background color of the SapTableCSHeaderCell."
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor || contrast(@backgroundColor)"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'.urST4LbHdrHvrBg': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "darken(@backgroundColor,10%)"
					},
					{
						"name": "color",
						"important": true,
						"expression": "darken(@fontColor,10%)"
					}
				]
			},
			'.urST4LbHdrHvrBg .urSTHdrClCust': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "darken(@backgroundColor,10%)"
					},
					{
						"name": "color",
						"important": true,
						"expression": "darken(@fontColor,10%)"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableCSRow"] = {
	"name": "SapTableCSRow",
	"properties": {
		"SelectionState": {
			"type": "UCF_ClientInterfaces.E.SapTableSelectionState",
			"defaultValue": "NOT_SELECTED"
		},
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"Index": {
			"type": "number",
			"defaultValue": -1
		},
		"Height": {
			"type": "number",
			"defaultValue": -1
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"ParentDropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"DragData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"LeftFixedCells": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "LeftFixedCell",
			"bindable": true
		},
		"NoneFixedCells": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "NoneFixedCell",
			"bindable": true
		},
		"RightFixedCells": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "RightFixedCell",
			"bindable": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableCSRowsFragment"] = {
	"name": "SapTableCSRowsFragment",
	"properties": {
		"StartIndex": {
			"type": "number",
			"defaultValue": -1
		}
	},
	"aggregations": {
		"Rows": {
			"type": "UCF_ClientInterfaces.I.SapTableCSRow",
			"multiple": true,
			"singularName": "Row"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableCSSelectionCell"] = {
	"name": "SapTableCSSelectionCell",
	"properties": {
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableDefaultBody"] = {
	"name": "SapTableDefaultBody",
	"properties": {
		"FixedColWidth": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"Rows": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Row",
			"bindable": true
		},
		"Cols": {
			"type": "UCF_ClientInterfaces.I.SapTableColumn",
			"multiple": true,
			"singularName": "Col"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableHeaderCell"] = {
	"name": "SapTableHeaderCell",
	"properties": {
		"SortState": {
			"type": "UCF_ClientInterfaces.E.SortState",
			"defaultValue": "DISABLED"
		},
		"HeaderCellDesign": {
			"type": "UCF_ClientInterfaces.E.SapTableHeaderCellDesign",
			"defaultValue": "LEVEL1HEADER"
		},
		"HeaderCellType": {
			"type": "UCF_ClientInterfaces.E.SapTableHeaderCellType",
			"defaultValue": "STANDARD"
		},
		"SelectionColumnAction": {
			"type": "UCF_ClientInterfaces.E.SapTableSelectionColumnAction",
			"defaultValue": "NONE"
		},
		"SelectionMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"RowSelectionMassState": {
			"type": "UCF_ClientInterfaces.E.SapTableRowSelectionMassState",
			"defaultValue": "NONE"
		},
		"Colspan": {
			"type": "number",
			"defaultValue": 1
		},
		"Rowspan": {
			"type": "number",
			"defaultValue": 1
		},
		"TextAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "LEFT"
		},
		"VerticalAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "MIDDLE"
		},
		"HeaderText": {
			"type": "string",
			"defaultValue": ''
		},
		"HasContent": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasCaption": {
			"type": "boolean",
			"defaultValue": false
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsClickable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"IsLastFixedColumn": {
			"type": "boolean",
			"defaultValue": false
		},
		"ColumnSelected": {
			"type": "boolean",
			"defaultValue": false
		},
		"ColumnSelectable": {
			"type": "boolean",
			"defaultValue": false
		},
		"ColumnResizable": {
			"type": "boolean",
			"defaultValue": false
		},
		"FixedTableBody": {
			"type": "boolean",
			"defaultValue": false
		},
		"Filtered": {
			"type": "boolean",
			"defaultValue": false
		},
		"MarkTotals": {
			"type": "boolean",
			"defaultValue": false
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"CanDragData": {
			"type": "boolean",
			"defaultValue": false
		},
		"DragSourceFlavours": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"DropTargetFlavours": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"DragSourceInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"ParentDropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"ActionMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"IconUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"IconTooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"IconFirst": {
			"type": "boolean",
			"defaultValue": false
		},
		"IconEnabled": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"HeaderCellContent": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"HeaderCellCaption": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": false
		},
		"MultipleHeaderCellCaptions": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": true,
			"singularName": "MultipleHeaderCellCaption"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"getCurrentHeaderCellCaption"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urST5HCMetricContent,font-family)",
				"docu": "Defines the font family of the SapTableCSHeaderCell."
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"defaultValue": "ruleValue(.urST5HCMetricContent,color)",
				"docu": "Defines the font color of the SapTableCSHeaderCell."
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"defaultValue": "ruleValue(.urST5HCMetricContent,font-weight)",
				"docu": "Defines the font color of the SapTableCSHeaderCell."
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urST5HCMetricContent,font-size)",
				"docu": "Defines the font color of the SapTableCSHeaderCell."
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"defaultValue": "ruleValue(.urST5HCMetricContent,font-style)",
				"docu": "Defines the font color of the SapTableCSHeaderCell."
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"defaultValue": "ruleValue(.urST5HCMetricContent,text-decoration)",
				"docu": "Defines the text decoration of the SapTableCSHeaderCell."
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urST5HCMetricContent,background-color)",
				"docu": "Defines the background color of the SapTableCSHeaderCell."
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor || contrast(@backgroundColor)"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'.urST4LbHdrHvrBg': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "darken(@backgroundColor,10%)"
					},
					{
						"name": "color",
						"important": true,
						"expression": "darken(@fontColor,10%)"
					}
				]
			},
			'.urST4LbHdrHvrBg .urSTHdrClCust': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "darken(@backgroundColor,10%)"
					},
					{
						"name": "color",
						"important": true,
						"expression": "darken(@fontColor,10%)"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableHierarchicalCell"] = {
	"name": "SapTableHierarchicalCell",
	"properties": {
		"HasBorder": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"IsSelected": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsSecondarySelected": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsReadOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "LEFT"
		},
		"VerticalAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "MIDDLE"
		},
		"CellType": {
			"type": "UCF_ClientInterfaces.E.SapTableCellType",
			"defaultValue": "TEXT"
		},
		"CellDesign": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"ColIdx": {
			"type": "number",
			"defaultValue": -1
		},
		"HasContent": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"HasContentPadding": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"ContentPadding": {
			"type": "string",
			"defaultValue": ''
		},
		"IsClickable": {
			"type": "boolean",
			"defaultValue": false
		},
		"Colspan": {
			"type": "number",
			"defaultValue": 1
		},
		"Rowspan": {
			"type": "number",
			"defaultValue": 1
		},
		"HeaderCellIds": {
			"type": "string",
			"defaultValue": ''
		},
		"Level": {
			"type": "number",
			"defaultValue": 0
		},
		"Status": {
			"type": "UCF_ClientInterfaces.E.SapTableHierarchicalCellStatus",
			"defaultValue": "NONE"
		},
		"StatusIconUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"IsLastFixedColumn": {
			"type": "boolean",
			"defaultValue": false
		},
		"FixedTableBody": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsTableReadOnly": {
			"type": "boolean",
			"defaultValue": false
		},
		"StatusEnabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentTypeIconUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentTypeTooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentVisibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"GroupingMode": {
			"type": "UCF_ClientInterfaces.E.SapTableCellGroupingMode",
			"defaultValue": "NONE"
		},
		"SemanticType": {
			"type": "UCF_ClientInterfaces.E.SapTableSemanticType",
			"defaultValue": "NONE"
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableMatrixCell"] = {
	"name": "SapTableMatrixCell",
	"properties": {
		"CellType": {
			"type": "UCF_ClientInterfaces.E.SapTableCellType",
			"defaultValue": "TEXT"
		},
		"CellBackgroundDesign": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "STANDARD"
		},
		"CellDesign": {
			"type": "UCF_ClientInterfaces.E.LayoutCellDesign",
			"defaultValue": "DEFAULT"
		},
		"CellSeparation": {
			"type": "UCF_ClientInterfaces.E.LayoutCellSeparation",
			"defaultValue": "DEFAULT"
		},
		"TextAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "LEFT"
		},
		"VerticalAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "MIDDLE"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"Colspan": {
			"type": "number",
			"defaultValue": 1
		},
		"Rowspan": {
			"type": "number",
			"defaultValue": 1
		},
		"HeaderCellIds": {
			"type": "string",
			"defaultValue": ''
		},
		"RowHeaderCellIds": {
			"type": "string",
			"defaultValue": ''
		},
		"FixedTableBody": {
			"type": "boolean",
			"defaultValue": false
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"SemanticType": {
			"type": "UCF_ClientInterfaces.E.SapTableSemanticType",
			"defaultValue": "NONE"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableRow"] = {
	"name": "SapTableRow",
	"properties": {
		"RowIndex": {
			"type": "number",
			"defaultValue": -2147483648
		},
		"SelectionState": {
			"type": "UCF_ClientInterfaces.E.SapTableSelectionState",
			"defaultValue": "NONE"
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.SapTableRowType",
			"defaultValue": "UNSPECIFIED"
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"DragData": {
			"type": "string",
			"defaultValue": ''
		},
		"DropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		},
		"ParentDropTargetInfo": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Cells": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Cell",
			"bindable": true
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["SapTableSelectionCell"] = {
	"name": "SapTableSelectionCell",
	"properties": {
		"SapTableId": {
			"type": "string",
			"defaultValue": ''
		},
		"ColIdx": {
			"type": "number",
			"defaultValue": 0
		},
		"HasBorder": {
			"type": "boolean",
			"defaultValue": true
		},
		"IsSelected": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsSecondarySelected": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"CellType": {
			"type": "UCF_ClientInterfaces.E.SapTableCellType",
			"defaultValue": "TEXT"
		},
		"RowDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"IsDeselectable": {
			"type": "boolean",
			"defaultValue": true
		},
		"CanDragData": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["Scrollbar"] = {
	"name": "Scrollbar",
	"properties": {
		"Value": {
			"type": "number",
			"defaultValue": 0
		},
		"Maximum": {
			"type": "number",
			"defaultValue": 100
		},
		"Minimum": {
			"type": "number",
			"defaultValue": 0
		},
		"LargeChange": {
			"type": "number",
			"defaultValue": 10
		},
		"SmallChange": {
			"type": "number",
			"defaultValue": 1
		},
		"ShowBeginEndButtons": {
			"type": "boolean",
			"defaultValue": false
		},
		"ScrollDirection": {
			"type": "UCF_ClientInterfaces.E.ScrollDirection",
			"defaultValue": "VERTICAL"
		},
		"ScrolledElementId": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowScrollTip": {
			"type": "boolean",
			"defaultValue": false
		},
		"ScrollTipValueDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"ItemCount": {
			"type": "number",
			"defaultValue": -1
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		}
	},
	"aggregations": {
		"ScrollTips": {
			"type": "UCF_ClientInterfaces.I.ScrollTip",
			"multiple": true,
			"singularName": "ScrollTip"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Scroll": {}
	}
};

UCF_ClientInterfaces["I"]["ScrollTip"] = {
	"name": "ScrollTip",
	"properties": {
		"Value": {
			"type": "number",
			"defaultValue": 0
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["ScrollContainer"] = {
	"name": "ScrollContainer",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollingMode": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "AUTO"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"IsLayout": {
			"type": "boolean",
			"defaultValue": true
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"ARIALandmark": {
			"type": "UCF_ClientInterfaces.E.ARIALandmark",
			"defaultValue": "none"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Scroll": {},
		"Hotkey": {}
	},
	"publicMethods": [
		"setScrollPosition",
		"getScrollPosition",
		"setDefaultButtonId"
	],
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urTWhl,background-color)"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"docu": "Defines the background image for the content"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background image X position for the content"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background image Y position for the content"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"docu": "Defines the background image streching mode for the content"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"expression": "cover",
				"docu": "Background size, cover, contain"
			},
			{
				"name": "width",
				"property": "width",
				"docu": "Defines the width of the content"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage || none"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					},
					{
						"name": "background-repeat",
						"expression": "no-repeat || @backgroundRepeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize || cover"
					},
					{
						"name": "width",
						"important": true,
						"expression": "@width"
					},
					{
						"name": "margin",
						"value": "auto"
					},
					{
						"name": "padding",
						"expression": "@padding"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["SectionHeader"] = {
	"name": "SectionHeader",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Level": {
			"type": "UCF_ClientInterfaces.E.SectionHeaderLevel",
			"defaultValue": "HEADER6"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"IsDragHandle": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasUnderline": {
			"type": "boolean",
			"defaultValue": false
		},
		"Editable": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"DoubleClick": {},
		"Change": {}
	},
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urTxtStd,font-family)",
				"docu": "Defines the font family for SectionHeader"
			},
			{
				"name": "fontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urTxtColor,color)",
				"docu": "Defines the font color for SectionHeader"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"defaultValue": "ruleValue(.urTxtStd,font-weight)",
				"docu": "Defines the font weight for SectionHeader"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urTxtStd,font-size)",
				"docu": "Defines the font size for SectionHeader"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"defaultValue": "ruleValue(.urTxtStd,font-style)",
				"docu": "Defines the font style for SectionHeader"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration for SectionHeader"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "greyscale(@fontColor)",
				"defaultValue": "ruleValue(.urTxtDsblStd,color)",
				"docu": "Defines the font color for SectionHeader"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["SegmentedButton"] = {
	"name": "SegmentedButton",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"SelectionType": {
			"type": "UCF_ClientInterfaces.E.SegmentedButtonSelectionType",
			"defaultValue": "SINGLE"
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Buttons": {
			"type": "UCF_ClientInterfaces.I.Button",
			"multiple": true,
			"singularName": "Button"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Change": {}
	}
};

UCF_ClientInterfaces["I"]["Shuttle"] = {
	"name": "Shuttle",
	"properties": {
		"NavigationMode": {
			"type": "UCF_ClientInterfaces.E.PaginatorNavigationMode",
			"defaultValue": "VERTICAL"
		},
		"ShuttleBehavior": {
			"type": "UCF_ClientInterfaces.E.ShuttleBehavior",
			"defaultValue": "ADD"
		},
		"HasAddButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"AddButtonEnabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"TooltipAddButton": {
			"type": "string",
			"defaultValue": ''
		},
		"HasAddAllButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"AddAllButtonEnabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"TooltipAddAllButton": {
			"type": "string",
			"defaultValue": ''
		},
		"HasRemoveButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"RemoveButtonEnabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"TooltipRemoveButton": {
			"type": "string",
			"defaultValue": ''
		},
		"HasRemoveAllButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"RemoveAllButtonEnabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"TooltipRemoveAllButton": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Add": {},
		"RemoveAll": {},
		"AddAll": {},
		"Remove": {}
	}
};

UCF_ClientInterfaces["I"]["SidePopup"] = {
	"name": "SidePopup",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"MaxWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"Mode": {
			"type": "UCF_ClientInterfaces.E.Mode",
			"defaultValue": "MODAL"
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Close": {},
		"Hotkey": {}
	},
	"publicMethods": [
		"setDefaultButtonId"
	]
};

UCF_ClientInterfaces["I"]["SilverlightContainer"] = {
	"name": "SilverlightContainer",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"Height": {
			"type": "string",
			"defaultValue": null
		},
		"MinHeight": {
			"type": "string",
			"defaultValue": null
		},
		"Source": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AutoActivate": {
			"type": "boolean",
			"defaultValue": false
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "BROWSER"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Parameters": {
			"type": "UCF_ClientInterfaces.I.SilverlightContainerParameter",
			"multiple": true,
			"singularName": "Parameter"
		},
		"Adapter": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"setKeepAlive"
	]
};

UCF_ClientInterfaces["I"]["SilverlightContainerParameter"] = {
	"name": "SilverlightContainerParameter",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": null
		},
		"Value": {
			"type": "string",
			"defaultValue": null
		}
	}
};

UCF_ClientInterfaces["I"]["SingleColumnLayout"] = {
	"name": "SingleColumnLayout",
	"properties": {
		"MarginTop": {
			"type": "string",
			"defaultValue": ''
		},
		"MarginBottom": {
			"type": "string",
			"defaultValue": ''
		},
		"MarginLeft": {
			"type": "string",
			"defaultValue": ''
		},
		"MarginRight": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"DebugMode": {
			"type": "boolean",
			"defaultValue": false
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Cells": {
			"type": "UCF_ClientInterfaces.I.SingleColumnLayoutCell",
			"multiple": true,
			"singularName": "Cell"
		},
		"RasterItems": {
			"type": "UCF_ClientInterfaces.I.RasterLayoutItem",
			"multiple": true,
			"singularName": "RasterItem"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["SingleColumnLayoutCell"] = {
	"name": "SingleColumnLayoutCell",
	"properties": {
		"HAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "LEFT"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"DebugMode": {
			"type": "boolean",
			"defaultValue": false
		},
		"CellDesign": {
			"type": "UCF_ClientInterfaces.E.LayoutCellDesign",
			"defaultValue": "DEFAULT"
		},
		"CellSeparation": {
			"type": "UCF_ClientInterfaces.E.LayoutCellSeparation",
			"defaultValue": "DEFAULT"
		},
		"CellBackgroundDesign": {
			"type": "UCF_ClientInterfaces.E.CellBackgroundDesign",
			"defaultValue": "TRANSPARENT"
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"LayoutCellPosition": {
			"type": "UCF_ClientInterfaces.E.LayoutCellPosition",
			"defaultValue": "DEFAULT"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["Splitter"] = {
	"name": "Splitter",
	"properties": {
		"Width": {
			"type": "number",
			"defaultValue": -1
		},
		"WidthSizeMode": {
			"type": "UCF_ClientInterfaces.E.SplitterSizeMode",
			"defaultValue": "RELATIVE"
		},
		"WidthSizeModeOfColums": {
			"type": "UCF_ClientInterfaces.E.SplitterSizeMode",
			"defaultValue": "ABSOLUTE"
		},
		"Height": {
			"type": "number",
			"defaultValue": -1
		},
		"HeightSizeMode": {
			"type": "UCF_ClientInterfaces.E.SplitterSizeMode",
			"defaultValue": "RELATIVE"
		},
		"HeightSizeModeOfRows": {
			"type": "UCF_ClientInterfaces.E.SplitterSizeMode",
			"defaultValue": "ABSOLUTE"
		},
		"Scrollbars": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "AUTO",
			"deprecated": true
		},
		"Mode": {
			"type": "UCF_ClientInterfaces.E.SplitterMode",
			"defaultValue": "WEB",
			"deprecated": true
		},
		"DebugMode": {
			"type": "boolean",
			"defaultValue": false
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Border": {
			"type": "UCF_ClientInterfaces.E.PageLayoutBorder",
			"defaultValue": "NONE"
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.SplitterType",
			"defaultValue": "SPLITTER",
			"deprecated": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalPushMode": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"CellDesign": {
			"type": "UCF_ClientInterfaces.E.LayoutCellDesign",
			"defaultValue": "PADLESS"
		},
		"MinHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"SashDragBehavior": {
			"type": "UCF_ClientInterfaces.E.SplitterSashDragBehavior",
			"defaultValue": "SERVERSIDE_DRAGGING"
		},
		"RenderingMode": {
			"type": "UCF_ClientInterfaces.E.SplitterRenderingMode",
			"defaultValue": "HEAVY_DOM"
		}
	},
	"aggregations": {
		"Cols": {
			"type": "UCF_ClientInterfaces.I.SplitterCol",
			"multiple": true,
			"singularName": "Col"
		},
		"Rows": {
			"type": "UCF_ClientInterfaces.I.SplitterRow",
			"multiple": true,
			"singularName": "Row"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"MoveEnd": {},
		"Scroll": {},
		"DoubleClick": {},
		"Expand": {},
		"Collapse": {},
		"Resize": {}
	},
	"publicMethods": [
		"setColumnWidth",
		"setSplitterWidth",
		"setRowHeight",
		"setSplitterHeight",
		"getAvailableWidth",
		"getAvailableHeight"
	],
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color of the Splitter"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "sashBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color of the Splitter Sash"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					}
				]
			},
			'@{CustomStyle}--sash': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@sashBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["SplitterCell"] = {
	"name": "SplitterCell",
	"properties": {
		"Scrollbars": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "AUTO",
			"deprecated": true
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0,
			"deprecated": true
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0,
			"deprecated": true
		},
		"AttachBrowserResize": {
			"type": "boolean",
			"defaultValue": false
		},
		"TopBorder": {
			"type": "UCF_ClientInterfaces.E.PageLayoutBorder",
			"defaultValue": "NONE"
		},
		"BottomBorder": {
			"type": "UCF_ClientInterfaces.E.PageLayoutBorder",
			"defaultValue": "NONE"
		},
		"BeginBorder": {
			"type": "UCF_ClientInterfaces.E.PageLayoutBorder",
			"defaultValue": "NONE"
		},
		"EndBorder": {
			"type": "UCF_ClientInterfaces.E.PageLayoutBorder",
			"defaultValue": "NONE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "BASELINE",
			"deprecated": true
		},
		"HasPushingContent": {
			"type": "boolean",
			"defaultValue": true
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Resize": {},
		"Scroll": {}
	},
	"publicMethods": [
		"iGetWidth",
		"iGetHeight",
		"setDefaultButtonId"
	]
};

UCF_ClientInterfaces["I"]["SplitterCol"] = {
	"name": "SplitterCol",
	"properties": {
		"Width": {
			"type": "number",
			"defaultValue": -1
		},
		"SashType": {
			"type": "UCF_ClientInterfaces.E.SplitterSashType",
			"defaultValue": "RESIZABLE"
		},
		"CollapseDirection": {
			"type": "UCF_ClientInterfaces.E.SplitterCollapseDirection",
			"defaultValue": "NONE"
		},
		"ExpandedWidth": {
			"type": "number",
			"defaultValue": 0
		},
		"SashDesign": {
			"type": "UCF_ClientInterfaces.E.SplitterSashDesign",
			"defaultValue": "STANDARD"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["SplitterRow"] = {
	"name": "SplitterRow",
	"properties": {
		"Height": {
			"type": "number",
			"defaultValue": -1
		},
		"SashType": {
			"type": "UCF_ClientInterfaces.E.SplitterSashType",
			"defaultValue": "RESIZABLE"
		},
		"CollapseDirection": {
			"type": "UCF_ClientInterfaces.E.SplitterCollapseDirection",
			"defaultValue": "NONE"
		},
		"ExpandedHeight": {
			"type": "number",
			"defaultValue": 0
		},
		"SashDesign": {
			"type": "UCF_ClientInterfaces.E.SplitterSashDesign",
			"defaultValue": "STANDARD"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Cells": {
			"type": "UCF_ClientInterfaces.I.SplitterCell",
			"multiple": true,
			"singularName": "Cell"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["StickyNote"] = {
	"name": "StickyNote",
	"properties": {
		"HasTitleArea": {
			"type": "boolean",
			"defaultValue": true
		},
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"IsCollapsed": {
			"type": "boolean",
			"defaultValue": false
		},
		"ClientCollapse": {
			"type": "boolean",
			"defaultValue": true
		},
		"Width": {
			"type": "string",
			"defaultValue": '250px'
		},
		"Height": {
			"type": "string",
			"defaultValue": '200px'
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"InplaceEditTitle": {
			"type": "boolean",
			"defaultValue": false
		},
		"EditText": {
			"type": "boolean",
			"defaultValue": false
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"RLIMode": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"FormattedText": {
			"type": "UCF_ClientInterfaces.I.FormattedTextView",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Change": {},
		"TitleChange": {},
		"TextChange": {},
		"Collapse": {},
		"Expand": {}
	},
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family"
			},
			{
				"name": "fontColor",
				"property": "color"
			},
			{
				"name": "fontSize",
				"property": "font-size"
			},
			{
				"name": "fontStyle",
				"property": "font-style"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration e.g. underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "padding",
				"property": "padding"
			},
			{
				"name": "borderRadius",
				"property": "border-radius"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"expression": "none",
				"docu": "Defines the background image for the content"
			},
			{
				"name": "boxShadow",
				"property": "box-shadow"
			},
			{
				"name": "headerFontWeight",
				"property": "font-weight",
				"docu": "Font weight of the title text"
			},
			{
				"name": "headerFontSize",
				"property": "font-size",
				"docu": "Font size of the title text"
			},
			{
				"name": "headerFontStyle",
				"property": "font-style"
			},
			{
				"name": "headerFontColor",
				"property": "color",
				"docu": "Font color of the title text"
			},
			{
				"name": "headerBorderColor",
				"property": "border-color",
				"expression": "@headerBorderColor || darken(@backgroundColor,10%)",
				"docu": "Border color (top and bottom) of the title area"
			},
			{
				"name": "headerBorderWidth",
				"property": "border-width",
				"docu": "Border width (top and bottom) of the title area"
			},
			{
				"name": "headerBorderStyle",
				"property": "border-style",
				"docu": "Border style (top and bottom) of the title area"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage"
					},
					{
						"name": "padding",
						"expression": "@padding"
					},
					{
						"name": "box-shadow",
						"expression": "@boxShadow"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			"TitleArea": {
				"properties": [
					{
						"name": "border-top",
						"expression": "1px solid transparent"
					},
					{
						"name": "border-bottom-width",
						"expression": "@headerBorderWidth"
					},
					{
						"name": "border-style",
						"expression": "@headerBorderStyle none @headerBorderStyle none"
					},
					{
						"name": "border-color",
						"expression": "@backgroundColor transparent @headerBorderColor transparent"
					},
					{
						"name": "border-top-left-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "border-top-right-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "box-shadow",
						"expression": "none"
					}
				]
			},
			"TextArea": {
				"properties": [
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-size",
						"expression": "@headerFontSize"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-family",
						"expression": "@fontFamily"
					}
				]
			},
			"ContentTextArea": {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "border-bottom-left-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "border-bottom-right-radius",
						"expression": "@borderRadius"
					}
				]
			},
			"CollapseIcon": {
				"properties": [
					{
						"name": "margin",
						"important": true
					},
					{
						"name": "background-image",
						"important": true
					},
					{
						"name": "width",
						"important": true
					}
				]
			},
			"Icon": {
				"properties": [
					{
						"name": "background-image",
						"important": true
					},
					{
						"name": "width",
						"important": true
					},
					{
						"name": "box-shadow"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@headerFontColor"
					}
				]
			},
			'Scrollbar::-webkit-scrollbar': {
				"properties": [
					{
						"name": "width",
						"important": true
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					},
					{
						"name": "border-bottom-right-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'Scrollbar::-webkit-scrollbar:horizontal': {
				"properties": [
					{
						"name": "border-bottom-left-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'Scrollbar::-webkit-scrollbar-corner': {
				"properties": [
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'ScrollbarTrack::-webkit-scrollbar-track': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "lighten(@backgroundColor, 40)"
					},
					{
						"name": "border-bottom-right-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'ScrollbarTrack::-webkit-scrollbar-track:horizontal': {
				"properties": [
					{
						"name": "border-bottom-left-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'ScrollbarThumb::-webkit-scrollbar-thumb': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "darken(@backgroundColor,8%)"
					},
					{
						"name": "border",
						"important": true,
						"expression": "2px solid @backgroundColor"
					},
					{
						"name": "border-top-right-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "border-bottom-right-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'ScrollbarThumbHover:hover::-webkit-scrollbar-thumb': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "darken(@backgroundColor,15%)"
					},
					{
						"name": "border",
						"important": true,
						"expression": "2px solid @backgroundColor"
					},
					{
						"name": "border-radius",
						"important": true
					}
				]
			},
			'Root.lsSTNControl,Icon.lsSTNStickyIcon.lsSTNVisible': {
				"properties": [
					{
						"name": "box-shadow",
						"expression": "@boxShadow"
					}
				]
			},
			'Root.lsLCDropShadow': {
				"properties": [
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["Switch"] = {
	"name": "Switch",
	"properties": {
		"Selection": {
			"type": "UCF_ClientInterfaces.E.SelectionState",
			"defaultValue": "UNCHECKED"
		},
		"InterAction": {
			"type": "UCF_ClientInterfaces.E.InterActionState",
			"defaultValue": "ENABLED"
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.SwitchType",
			"defaultValue": "DEFAULT"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Change": {}
	},
	"publicMethods": [
		"setSelectionState",
		"getSelectionState"
	],
	"styles": {
		"variables": [
			{
				"name": "selected_Track_BackgroundColor",
				"property": "background-color",
				"docu": "Sets the background color of the track of a selected switch"
			},
			{
				"name": "selected_Track_BorderColor",
				"property": "border-color",
				"docu": "Sets the border color of the track of a selected switch"
			},
			{
				"name": "unselected_Track_BackgroundColor",
				"property": "background-color",
				"docu": "Sets the background color of the track of a unselected switch"
			},
			{
				"name": "unselected_Track_BorderColor",
				"property": "border-color",
				"docu": "Sets the border color of the track of a unselected switch"
			},
			{
				"name": "selected_Track_BackgroundColor_Hover",
				"property": "background-color",
				"docu": "Sets the background color of the track of a selected switch on hover"
			},
			{
				"name": "selected_Track_BorderColor_Hover",
				"property": "border-color",
				"docu": "Sets the border color of the track of a selected switch on hover"
			},
			{
				"name": "unselected_Track_BackgroundColor_Hover",
				"property": "background-color",
				"docu": "Sets the background color of the track of a unselected switch on hover"
			},
			{
				"name": "unselected_Track_BorderColor_Hover",
				"property": "border-color",
				"docu": "Sets the border color of the track of a unselected switch on hover"
			},
			{
				"name": "selected_Track_BackgroundColor_Disabled",
				"property": "background-color",
				"docu": "Sets the background color of the track of a selected and disabled switch"
			},
			{
				"name": "selected_Track_BorderColor_Disabled",
				"property": "border-color",
				"docu": "Sets the border color of the track of a selected and disabled switch"
			},
			{
				"name": "unselected_Track_BackgroundColor_Disabled",
				"property": "background-color",
				"docu": "Sets the background color of the track of a unselected and disabled switch"
			},
			{
				"name": "unselected_Track_BorderColor_Disabled",
				"property": "border-color",
				"docu": "Sets the border color of the track of a unselected and disabled switch"
			},
			{
				"name": "selected_Handle_BackgroundColor",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a selected switch"
			},
			{
				"name": "selected_Handle_BorderColor",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a selected switch"
			},
			{
				"name": "unselected_Handle_BackgroundColor",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a unselected switch"
			},
			{
				"name": "unselected_Handle_BorderColor",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a unselected switch"
			},
			{
				"name": "selected_Handle_BackgroundColor_Hover",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a selected switch on hover"
			},
			{
				"name": "selected_Handle_BorderColor_Hover",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a selected switch on hover"
			},
			{
				"name": "unselected_Handle_BackgroundColor_Hover",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a unselected switch on hover"
			},
			{
				"name": "unselected_Handle_BorderColor_Hover",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a unselected switch on hover"
			},
			{
				"name": "selected_Handle_BackgroundColor_Disabled",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a selected and disabled switch"
			},
			{
				"name": "selected_Handle_BorderColor_Disabled",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a selected and disabled switch"
			},
			{
				"name": "unselected_Handle_BackgroundColor_Disabled",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a unselected and disabled switch"
			},
			{
				"name": "unselected_Handle_BorderColor_Disabled",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a unselected and disabled switch"
			},
			{
				"name": "selected_Track_AcceptReject_BackgroundColor",
				"property": "background-color",
				"docu": "Track-background color of a selected switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BorderColor",
				"property": "border-color",
				"docu": "Track-border color of a selected switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BackgroundColor",
				"property": "background-color",
				"docu": "Track-background color of a unselected switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BorderColor",
				"property": "border-color",
				"docu": "Track-border color of a unselected switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BackgroundColor_Hover",
				"property": "background-color",
				"docu": "Track-background color of a selected switch on hover of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BorderColor_Hover",
				"property": "border-color",
				"docu": "Track-border color of a selected switch on hover of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BackgroundColor_Hover",
				"property": "background-color",
				"docu": "Track-background color of a unselected switch on hover of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BorderColor_Hover",
				"property": "border-color",
				"docu": "Track-border color of a unselected switch on hover of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BackgroundColor_Disabled",
				"property": "background-color",
				"docu": "Track-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BorderColor_Disabled",
				"property": "border-color",
				"docu": "Track-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BackgroundColor_Disabled",
				"property": "background-color",
				"docu": "Track-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BorderColor_Disabled",
				"property": "border-color",
				"docu": "Track-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_BackgroundColor_ReadOnly",
				"property": "background-color",
				"docu": "Sets the background color of the track of a selected and ReadOnly switch"
			},
			{
				"name": "selected_Track_BorderColor_ReadOnly",
				"property": "border-color",
				"docu": "Sets the border color of the track of a selected and ReadOnly switch"
			},
			{
				"name": "unselected_Track_BackgroundColor_ReadOnly",
				"property": "background-color",
				"docu": "Sets the background color of the track of a unselected and ReadOnly switch"
			},
			{
				"name": "unselected_Track_BorderColor_ReadOnly",
				"property": "border-color",
				"docu": "Sets the border color of the track of a unselected and ReadOnly switch"
			},
			{
				"name": "selected_Handle_BackgroundColor_ReadOnly",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a selected and ReadOnly switch"
			},
			{
				"name": "selected_Handle_BorderColor_ReadOnly",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a selected and ReadOnly switch"
			},
			{
				"name": "unselected_Handle_BackgroundColor_ReadOnly",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a unselected and ReadOnly switch"
			},
			{
				"name": "unselected_Handle_BorderColor_ReadOnly",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a unselected and ReadOnly switch"
			},
			{
				"name": "selected_Track_BackgroundColor_ReadOnly_Warning",
				"property": "background-color",
				"docu": "Sets the background color of the track of a selected and read-only warning switch"
			},
			{
				"name": "selected_Track_BorderColor_ReadOnly_Warning",
				"property": "border-color",
				"docu": "Sets the border color of the track of a selected and read-only warning switch"
			},
			{
				"name": "unselected_Track_BackgroundColor_ReadOnly_Warning",
				"property": "background-color",
				"docu": "Sets the background color of the track of a unselected and read-only warning switch"
			},
			{
				"name": "unselected_Track_BorderColor_ReadOnly_Warning",
				"property": "border-color",
				"docu": "Sets the border color of the track of a unselected and read-only warning switch"
			},
			{
				"name": "selected_Handle_BackgroundColor_ReadOnly_Warning",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a selected and ReadOnly_Warning switch"
			},
			{
				"name": "selected_Handle_BorderColor_ReadOnly_Warning",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a selected and ReadOnly_Warning switch"
			},
			{
				"name": "unselected_Handle_BackgroundColor_ReadOnly_Warning",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a unselected and ReadOnly_Warning switch"
			},
			{
				"name": "unselected_Handle_BorderColor_ReadOnly_Warning",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a unselected and ReadOnly_Warning switch"
			},
			{
				"name": "selected_Track_BackgroundColor_ReadOnly_Error",
				"property": "background-color",
				"docu": "Sets the background color of the track of a selected and read-only Error switch"
			},
			{
				"name": "selected_Track_BorderColor_ReadOnly_Error",
				"property": "border-color",
				"docu": "Sets the border color of the track of a selected and read-only Error switch"
			},
			{
				"name": "unselected_Track_BackgroundColor_ReadOnly_Error",
				"property": "background-color",
				"docu": "Sets the background color of the track of a unselected and read-only Error switch"
			},
			{
				"name": "unselected_Track_BorderColor_ReadOnly_Error",
				"property": "border-color",
				"docu": "Sets the border color of the track of a unselected and read-only Error switch"
			},
			{
				"name": "selected_Handle_BackgroundColor_ReadOnly_Error",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a selected and ReadOnly_Error switch"
			},
			{
				"name": "selected_Handle_BorderColor_ReadOnly_Error",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a selected and ReadOnly_Error switch"
			},
			{
				"name": "unselected_Handle_BackgroundColor_ReadOnly_Error",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a unselected and ReadOnly_Error switch"
			},
			{
				"name": "unselected_Handle_BorderColor_ReadOnly_Error",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a unselected and ReadOnly_Error switch"
			},
			{
				"name": "selected_Track_BackgroundColor_ParentReadOnly",
				"property": "background-color",
				"docu": "Sets the background color of the track of a selected and ParentReadOnly switch"
			},
			{
				"name": "selected_Track_BorderColor_ParentReadOnly",
				"property": "border-color",
				"docu": "Sets the border color of the track of a selected and ParentReadOnly switch"
			},
			{
				"name": "unselected_Track_BackgroundColor_ParentReadOnly",
				"property": "background-color",
				"docu": "Sets the background color of the track of a unselected and ParentReadOnly switch"
			},
			{
				"name": "unselected_Track_BorderColor_ParentReadOnly",
				"property": "border-color",
				"docu": "Sets the border color of the track of a unselected and ParentReadOnly switch"
			},
			{
				"name": "selected_Handle_BackgroundColor_ParentReadOnly",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a selected and ParentReadOnly switch"
			},
			{
				"name": "selected_Handle_BorderColor_ParentReadOnly",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a selected and ParentReadOnly switch"
			},
			{
				"name": "unselected_Handle_BackgroundColor_ParentReadOnly",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a unselected and ParentReadOnly switch"
			},
			{
				"name": "unselected_Handle_BorderColor_ParentReadOnly",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a unselected and ParentReadOnly switch"
			},
			{
				"name": "selected_Track_BackgroundColor_ParentReadOnly_Warning",
				"property": "background-color",
				"docu": "Sets the background color of the track of a selected and parent-read-only warning switch"
			},
			{
				"name": "selected_Track_BorderColor_ParentReadOnly_Warning",
				"property": "border-color",
				"docu": "Sets the border color of the track of a selected and parent-read-only warning switch"
			},
			{
				"name": "unselected_Track_BackgroundColor_ParentReadOnly_Warning",
				"property": "background-color",
				"docu": "Sets the background color of the track of a unselected and parent-read-only warning switch"
			},
			{
				"name": "unselected_Track_BorderColor_ParentReadOnly_Warning",
				"property": "border-color",
				"docu": "Sets the border color of the track of a unselected and parent-read-only warning switch"
			},
			{
				"name": "selected_Handle_BackgroundColor_ParentReadOnly_Warning",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a selected and ParentReadOnly_Warning switch"
			},
			{
				"name": "selected_Handle_BorderColor_ParentReadOnly_Warning",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a selected and ParentReadOnly_Warning switch"
			},
			{
				"name": "unselected_Handle_BackgroundColor_ParentReadOnly_Warning",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a unselected and ParentReadOnly_Warning switch"
			},
			{
				"name": "unselected_Handle_BorderColor_ParentReadOnly_Warning",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a unselected and ParentReadOnly_Warning switch"
			},
			{
				"name": "selected_Track_BackgroundColor_ParentReadOnly_Error",
				"property": "background-color",
				"docu": "Sets the background color of the track of a selected and parent-read-only Error switch"
			},
			{
				"name": "selected_Track_BorderColor_ParentReadOnly_Error",
				"property": "border-color",
				"docu": "Sets the border color of the track of a selected and parent-read-only Error switch"
			},
			{
				"name": "unselected_Track_BackgroundColor_ParentReadOnly_Error",
				"property": "background-color",
				"docu": "Sets the background color of the track of a unselected and parent-read-only Error switch"
			},
			{
				"name": "unselected_Track_BorderColor_ParentReadOnly_Error",
				"property": "border-color",
				"docu": "Sets the border color of the track of a unselected and parent-read-only Error switch"
			},
			{
				"name": "selected_Handle_BackgroundColor_ParentReadOnly_Error",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a selected and ParentReadOnly_Error switch"
			},
			{
				"name": "selected_Handle_BorderColor_ParentReadOnly_Error",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a selected and ParentReadOnly_Error switch"
			},
			{
				"name": "unselected_Handle_BackgroundColor_ParentReadOnly_Error",
				"property": "background-color",
				"docu": "Sets the background color of the handle of a unselected and ParentReadOnly_Error switch"
			},
			{
				"name": "unselected_Handle_BorderColor_ParentReadOnly_Error",
				"property": "border-color",
				"docu": "Sets the border color of the handle of a unselected and ParentReadOnly_Error switch"
			},
			{
				"name": "selected_Handle_AcceptReject_BackgroundColor",
				"property": "background-color",
				"docu": "Handle-background color of a selected switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BorderColor",
				"property": "border-color",
				"docu": "Handle-border color of a selected switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BackgroundColor",
				"property": "background-color",
				"docu": "Handle-background color of a unselected switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BorderColor",
				"property": "border-color",
				"docu": "Handle-border color of a unselected switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BackgroundColor_Hover",
				"property": "background-color",
				"docu": "Handle-background color of a selected switch on hover of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BorderColor_Hover",
				"property": "border-color",
				"docu": "Handle-border color of a selected switch on hover of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BackgroundColor_Hover",
				"property": "background-color",
				"docu": "Handle-background color of a unselected switch on hover of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BorderColor_Hover",
				"property": "border-color",
				"docu": "Handle-border color of a unselected switch on hover of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BackgroundColor_ReadOnly",
				"property": "background-color",
				"docu": "Handle-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BorderColor_ReadOnly",
				"property": "border-color",
				"docu": "Handle-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BackgroundColor_ReadOnly",
				"property": "background-color",
				"docu": "Handle-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BorderColor_ReadOnly",
				"property": "border-color",
				"docu": "Handle-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BackgroundColor_ReadOnly",
				"property": "background-color",
				"docu": "Track-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BorderColor_ReadOnly",
				"property": "border-color",
				"docu": "Track-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BackgroundColor_ReadOnly",
				"property": "background-color",
				"docu": "Track-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BorderColor_ReadOnly",
				"property": "border-color",
				"docu": "Track-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BackgroundColor_Ro_Warn",
				"property": "background-color",
				"docu": "Handle-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BorderColor_ReadOnly_Warning",
				"property": "border-color",
				"docu": "Handle-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BackgroundColor_Ro_Warn",
				"property": "background-color",
				"docu": "Handle-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BorderColor_ReadOnly_Warning",
				"property": "border-color",
				"docu": "Handle-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BackgroundColor_Ro_Warn",
				"property": "background-color",
				"docu": "Track-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BorderColor_ReadOnly_Warning",
				"property": "border-color",
				"docu": "Track-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BackgroundColor_Ro_Warn",
				"property": "background-color",
				"docu": "Track-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BorderColor_ReadOnly_Warning",
				"property": "border-color",
				"docu": "Track-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BackgroundColor_Ro_Err",
				"property": "background-color",
				"docu": "Handle-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BorderColor_ReadOnly_Error",
				"property": "border-color",
				"docu": "Handle-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BackgroundColor_Ro_Err",
				"property": "background-color",
				"docu": "Handle-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BorderColor_ReadOnly_Error",
				"property": "border-color",
				"docu": "Handle-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BackgroundColor_Ro_Err",
				"property": "background-color",
				"docu": "Track-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BorderColor_ReadOnly_Error",
				"property": "border-color",
				"docu": "Track-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BackgroundColor_Ro_Err",
				"property": "background-color",
				"docu": "Track-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BorderColor_ReadOnly_Error",
				"property": "border-color",
				"docu": "Track-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BackgroundColor_PaRo",
				"property": "background-color",
				"docu": "Handle-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BorderColor_ParentReadOnly",
				"property": "border-color",
				"docu": "Handle-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BackgroundColor_PaRo",
				"property": "background-color",
				"docu": "Handle-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BorderColor_ParentReadOnly",
				"property": "border-color",
				"docu": "Handle-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BackgroundColor_PaRo",
				"property": "background-color",
				"docu": "Track-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BorderColor_ParentReadOnly",
				"property": "border-color",
				"docu": "Track-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BackgroundColor_PaRo",
				"property": "background-color",
				"docu": "Track-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BorderColor_ParentReadOnly",
				"property": "border-color",
				"docu": "Track-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BackgroundColor_PaRo_Warning",
				"property": "background-color",
				"docu": "Handle-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BorderColor_PaRo_Warn",
				"property": "border-color",
				"docu": "Handle-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BackgroundColor_PaRo_Warning",
				"property": "background-color",
				"docu": "Handle-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BorderColor_PaRo_Warn",
				"property": "border-color",
				"docu": "Handle-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BackgroundColor_PaRo_Warning",
				"property": "background-color",
				"docu": "Track-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BorderColor_PaRo_Warn",
				"property": "border-color",
				"docu": "Track-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BackgroundColor_PaRo_Warning",
				"property": "background-color",
				"docu": "Track-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BorderColor_PaRo_Warn",
				"property": "border-color",
				"docu": "Track-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BackgroundColor_PaRo_Error",
				"property": "background-color",
				"docu": "Handle-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Handle_AcceptReject_BorderColor_PaRo_Err",
				"property": "border-color",
				"docu": "Handle-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BackgroundColor_PaRo_Error",
				"property": "background-color",
				"docu": "Handle-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Handle_AcceptReject_BorderColor_PaRo_Err",
				"property": "border-color",
				"docu": "Handle-border color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BackgroundColor_PaRo_Error",
				"property": "background-color",
				"docu": "Track-background color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "selected_Track_AcceptReject_BorderColor_PaRo_Err",
				"property": "border-color",
				"docu": "Track-border color of a selected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BackgroundColor_PaRo_Error",
				"property": "background-color",
				"docu": "Track-background color of a unselected and disabled switch of the type accept/reject"
			},
			{
				"name": "unselected_Track_AcceptReject_BorderColor_PaRo_Err",
				"property": "border-color",
				"docu": "Track-border color of a unselected and disabled switch of the type accept/reject"
			}
		],
		"classes": {
			'.lsSwitch--on .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_BackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_BorderColor"
					}
				]
			},
			'.lsSwitch--off .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_BackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_BorderColor"
					}
				]
			},
			'.lsSwitch--on:hover .lsSwitch__track,.lsSwitch--on .lsSwitch__track:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_BackgroundColor_Hover"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_BorderColor_Hover"
					}
				]
			},
			'.lsSwitch--off:hover .lsSwitch__track,.lsSwitch--off .lsSwitch__track:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_BackgroundColor_Hover"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_BorderColor_Hover"
					}
				]
			},
			'.lsSwitch--on--disabled .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_BackgroundColor_Disabled"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_BorderColor_Disabled"
					}
				]
			},
			'.lsSwitch--off--disabled .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_BackgroundColor_Disabled"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_BorderColor_Track_Disabled"
					}
				]
			},
			'.lsSwitch--on .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_BackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_BorderColor"
					}
				]
			},
			'.lsSwitch--off .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_BackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_BorderColor"
					}
				]
			},
			'.lsSwitch--on:hover .lsSwitch__handle,.lsSwitch--on .lsSwitch__handle:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_BackgroundColor_Hover"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_BorderColor_Hover"
					}
				]
			},
			'.lsSwitch--off:hover .lsSwitch__handle,.lsSwitch--off .lsSwitch__handle:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_BackgroundColor_Hover"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_BorderColor_Hover"
					}
				]
			},
			'.lsSwitch--on--disabled .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_BackgroundColor_Disabled"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_BorderColor_Disabled"
					}
				]
			},
			'.lsSwitch--off--disabled .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_BackgroundColor_Disabled"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_BorderColor_Disabled"
					}
				]
			},
			'.lsSwitch--on--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_BackgroundColor_ReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_BorderColor_ReadOnly"
					}
				]
			},
			'.lsSwitch--off--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_BackgroundColor_ReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_BorderColor_ReadOnly"
					}
				]
			},
			'.lsSwitch--on--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_BackgroundColor_ReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_BorderColor_ReadOnly"
					}
				]
			},
			'.lsSwitch--off--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_BackgroundColor_ReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_BorderColor_ReadOnly"
					}
				]
			},
			'.lsSwitch--on--warning--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_BackgroundColor_ReadOnly_Warning"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_BorderColor_ReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--off--warning--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_BackgroundColor_ReadOnly_Warning"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_BorderColor_ReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--on--warning--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_BackgroundColor_ReadOnly_Warning"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_BorderColor_ReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--off--warning--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_BackgroundColor_ReadOnly_Warning"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_BorderColor_ReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--on--error--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_BackgroundColor_ReadOnly_Error"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_BorderColor_ReadOnly_Error"
					}
				]
			},
			'.lsSwitch--off--error--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_BackgroundColor_ReadOnly_Error"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_BorderColor_ReadOnly_Error"
					}
				]
			},
			'.lsSwitch--on--error--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_BackgroundColor_ReadOnly_Error"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_BorderColor_ReadOnly_Error"
					}
				]
			},
			'.lsSwitch--off--error--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_BackgroundColor_ReadOnly_Error"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_BorderColor_ReadOnly_Error"
					}
				]
			},
			'.lsSwitch--on--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_BackgroundColor_ParentReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_BorderColor_ParentReadOnly"
					}
				]
			},
			'.lsSwitch--off--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_BackgroundColor_ParentReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_BorderColor_ParentReadOnly"
					}
				]
			},
			'.lsSwitch--on--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_BackgroundColor_ParentReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_BorderColor_ParentReadOnly"
					}
				]
			},
			'.lsSwitch--off--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_BackgroundColor_ParentReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_BorderColor_ParentReadOnly"
					}
				]
			},
			'.lsSwitch--on--warning--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_BackgroundColor_ParentReadOnly_Warning"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_BorderColor_ParentReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--off--warning--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_BackgroundColor_ParentReadOnly_Warning"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_BorderColor_ParentReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--on--warning--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_BackgroundColor_ParentReadOnly_Warning"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_BorderColor_ParentReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--off--warning--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_BackgroundColor_ParentReadOnly_Warning"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_BorderColor_ParentReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--on--error--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_BackgroundColor_ParentReadOnly_Error"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_BorderColor_ParentReadOnly_Error"
					}
				]
			},
			'.lsSwitch--off--error--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_BackgroundColor_ParentReadOnly_Error"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_BorderColor_ParentReadOnly_Error"
					}
				]
			},
			'.lsSwitch--on--error--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_BackgroundColor_ParentReadOnly_Error"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_BorderColor_ParentReadOnly_Error"
					}
				]
			},
			'.lsSwitch--off--error--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_BackgroundColor_ParentReadOnly_Error"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_BorderColor_ParentReadOnly_Error"
					}
				]
			},
			'.lsSwitch--on--acceptReject .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_AcceptReject_BackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_AcceptReject_BorderColor"
					}
				]
			},
			'.lsSwitch--off--acceptReject .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_AcceptReject_BackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_AcceptReject_BorderColor"
					}
				]
			},
			'.lsSwitch--on--acceptReject:hover .lsSwitch__track,.lsSwitch--on--acceptReject .lsSwitch__track:hover ': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_AcceptReject_BackgroundColo_Hover"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_AcceptReject_BorderColor_Hover"
					}
				]
			},
			'.lsSwitch--off--acceptReject:hover .lsSwitch__track,.lsSwitch--off--acceptReject .lsSwitch__track:hover ': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_AcceptReject_BackgroundColor_Hover"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_AcceptReject_BorderColor_Hover"
					}
				]
			},
			'.lsSwitch--on--acceptReject .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_AcceptReject_BackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_AcceptReject_BorderColor"
					}
				]
			},
			'.lsSwitch--off--acceptReject .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_AcceptReject_BackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_AcceptReject_BorderColor"
					}
				]
			},
			'.lsSwitch--on--acceptReject:hover .lsSwitch__handle,.lsSwitch--on--acceptReject .lsSwitch__handle:hover ': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_AcceptReject_BackgroundColo_Hover"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_AcceptReject_BorderColor_Hover"
					}
				]
			},
			'.lsSwitch--off--acceptReject:hover .lsSwitch__handle,.lsSwitch--off--acceptReject .lsSwitch__handle:hover ': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_AcceptReject_BackgroundColor_Hover"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_AcceptReject_BorderColor_Hover"
					}
				]
			},
			'.lsSwitch--on--acceptReject--disabled .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_AcceptReject_BackgroundColor_Disabled"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_AcceptReject_BorderColor_Disabled"
					}
				]
			},
			'.lsSwitch--off--acceptReject--disabled .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_AcceptReject_BackgroundColor_Disabled"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_AcceptReject_BorderColor_Disabled"
					}
				]
			},
			'.lsSwitch--on--acceptReject--disabled .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_AcceptReject_BackgroundColor_Disabled"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_AcceptReject_BorderColor_Disabled"
					}
				]
			},
			'.lsSwitch--off--acceptReject--disabled .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_AcceptReject_BackgroundColor_Disabled"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_AcceptReject_BorderColor_Disabled"
					}
				]
			},
			'.lsSwitch--on--acceptReject--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_AcceptReject_BackgroundColor_ReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_AcceptReject_BorderColor_ReadOnly"
					}
				]
			},
			'.lsSwitch--off--acceptReject--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_AcceptReject_BackgroundColor_ReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_AcceptReject_BorderColor_ReadOnly"
					}
				]
			},
			'.lsSwitch--on--acceptReject--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_AcceptReject_BackgroundColor_ReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_AcceptReject_BorderColor_ReadOnly"
					}
				]
			},
			'.lsSwitch--off--acceptReject--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_AcceptReject_BackgroundColor_ReadOnly"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_AcceptReject_BorderColor_ReadOnly"
					}
				]
			},
			'.lsSwitch--on--warning--acceptReject--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_AcceptReject_BackgroundColor_Ro_Warn"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_AcceptReject_BorderColor_ReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--off--warning--acceptReject--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_AcceptReject_BackgroundColor_Ro_Warn"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_AcceptReject_BorderColor_ReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--on--warning--acceptReject--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_AcceptReject_BackgroundColor_Ro_Warn"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_AcceptReject_BorderColor_ReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--off--warning--acceptReject--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_AcceptReject_BackgroundColor_Ro_Warn"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_AcceptReject_BorderColor_ReadOnly_Warning"
					}
				]
			},
			'.lsSwitch--on--error--acceptReject--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_AcceptReject_BackgroundColor_Ro_Err"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_AcceptReject_BorderColor_ReadOnly_Error"
					}
				]
			},
			'.lsSwitch--off--error--acceptReject--readOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_AcceptReject_BackgroundColor_Ro_Err"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_AcceptReject_BorderColor_ReadOnly_Error"
					}
				]
			},
			'.lsSwitch--on--error--acceptReject--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_AcceptReject_BackgroundColor_Ro_Err"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_AcceptReject_BorderColor_ReadOnly_Error"
					}
				]
			},
			'.lsSwitch--off--error--acceptReject--readOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_AcceptReject_BackgroundColor_Ro_Err"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_AcceptReject_BorderColor_ReadOnly_Error"
					}
				]
			},
			'.lsSwitch--on--acceptReject--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_AcceptReject_BackgroundColor_PaRo"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_AcceptReject_BorderColor_ParentReadOnly"
					}
				]
			},
			'.lsSwitch--off--acceptReject--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_AcceptReject_BackgroundColor_PaRo"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_AcceptReject_BorderColor_ParentReadOnly"
					}
				]
			},
			'.lsSwitch--on--acceptReject--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_AcceptReject_BackgroundColor_PaRo"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_AcceptReject_BorderColor_ParentReadOnly"
					}
				]
			},
			'.lsSwitch--off--acceptReject--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_AcceptReject_BackgroundColor_PaRo"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_AcceptReject_BorderColor_ParentReadOnly"
					}
				]
			},
			'.lsSwitch--on--warning--acceptReject--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_AcceptReject_BackgroundColor_PaRo_Warning"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_AcceptReject_BorderColor_PaRo_Warn"
					}
				]
			},
			'.lsSwitch--off--warning--acceptReject--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_AcceptReject_BackgroundColor_PaRo_Warning"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_AcceptReject_BorderColor_PaRo_Warn"
					}
				]
			},
			'.lsSwitch--on--warning--acceptReject--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_AcceptReject_BackgroundColor_PaRo_Warning"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_AcceptReject_BorderColor_PaRo_Warn"
					}
				]
			},
			'.lsSwitch--off--warning--acceptReject--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_AcceptReject_BackgroundColor_PaRo_Warning"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_AcceptReject_BorderColor_PaRo_Warn"
					}
				]
			},
			'.lsSwitch--on--error--acceptReject--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Handle_AcceptReject_BackgroundColor_PaRo_Error"
					},
					{
						"name": "border-color",
						"expression": "@selected_Handle_AcceptReject_BorderColor_PaRo_Err"
					}
				]
			},
			'.lsSwitch--off--error--acceptReject--parentReadOnly .lsSwitch__handle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Handle_AcceptReject_BackgroundColor_PaRo_Error"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Handle_AcceptReject_BorderColor_PaRo_Err"
					}
				]
			},
			'.lsSwitch--on--error--acceptReject--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selected_Track_AcceptReject_BackgroundColor_PaRo_Error"
					},
					{
						"name": "border-color",
						"expression": "@selected_Track_AcceptReject_BorderColor_PaRo_Err"
					}
				]
			},
			'.lsSwitch--off--error--acceptReject--parentReadOnly .lsSwitch__track': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@unselected_Track_AcceptReject_BackgroundColor_PaRo_Error"
					},
					{
						"name": "border-color",
						"expression": "@unselected_Track_AcceptReject_BorderColor_PaRo_Err"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["SwitchGroup"] = {
	"name": "SwitchGroup",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"ColumnCount": {
			"type": "number",
			"defaultValue": 1
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ItemHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.Switch",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["TabStrip"] = {
	"name": "TabStrip",
	"properties": {
		"CurrentIndex": {
			"type": "number",
			"defaultValue": 0
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"HAlign": {
			"type": "UCF_ClientInterfaces.E.CellHAlign",
			"defaultValue": "LEFT",
			"deprecated": true
		},
		"VAlign": {
			"type": "UCF_ClientInterfaces.E.CellVAlign",
			"defaultValue": "TOP",
			"deprecated": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"FirstVisibleItemIdx": {
			"type": "number",
			"defaultValue": -1
		},
		"Scrollable": {
			"type": "boolean",
			"defaultValue": false
		},
		"ExactTabAlignment": {
			"type": "boolean",
			"defaultValue": true
		},
		"ClientTabSelect": {
			"type": "boolean",
			"defaultValue": true
		},
		"TabItemsPosition": {
			"type": "UCF_ClientInterfaces.E.TabItemsPosition",
			"defaultValue": "TOP"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"TabItemsDesign": {
			"type": "UCF_ClientInterfaces.E.TabItemsDesign",
			"defaultValue": "TAB"
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0,
			"deprecated": true
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"DragSourceInfo": {
			"type": "string"
		},
		"DropTargetInfo": {
			"type": "string"
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.TabStripItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ItemMenu": {
			"type": "UCF_ClientInterfaces.I.PopupMenu",
			"multiple": false
		},
		"HeaderFunctions": {
			"type": "UCF_ClientInterfaces.I.Button",
			"multiple": true,
			"singularName": "HeaderFunction"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"TabSelect": {},
		"TabClose": {},
		"Scroll": {},
		"TabScroll": {},
		"Hotkey": {},
		"Drag": {},
		"Drop": {},
		"Change": {}
	},
	"publicMethods": [
		"selectTabStripItem",
		"setScrollPosition",
		"getScrollPosition"
	],
	"styles": {
		"variables": [
			{
				"name": "headerBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for all enabled TabStripItems"
			},
			{
				"name": "headerBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for all enabled TabStripItems"
			},
			{
				"name": "headerBorderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for all enabled TabStripItems"
			},
			{
				"name": "headerBorderStyle",
				"property": "border-sytle",
				"docu": "Defines the border-style for all enabled TabStripItems"
			},
			{
				"name": "headerFontColor",
				"property": "color",
				"docu": "Defines the font-color for all enabled TabStripItems"
			},
			{
				"name": "headerFontStyle",
				"property": "font-style",
				"docu": "Defines the font-style for all enabled TabStripItems"
			},
			{
				"name": "headerFontWeight",
				"property": "font-weight",
				"docu": "Defines the font-weight for all enabled TabStripItems"
			},
			{
				"name": "headerFontFamily",
				"property": "font-family",
				"docu": "Defines the font-family for all TabStripItems"
			},
			{
				"name": "headerFontSize",
				"property": "font-size",
				"docu": "Defines the font-size  for all  TabStripItems"
			},
			{
				"name": "headerMargin",
				"property": "margin",
				"docu": "Defines the margin  for all  TabStripItems"
			},
			{
				"name": "selectedHeaderBackgroundColor",
				"property": "background-color",
				"expression": "@selectedHeaderBackgroundColor || contrast(@selectedHeaderFontColor)",
				"docu": "Defines the background-color for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderBorderColor",
				"property": "border-color",
				"expression": "@selectedHeaderBorderColor || darken(@selectedHeaderBackgroundColor, 20)",
				"docu": "Defines the border-color for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderBorderWidth",
				"property": "border-width",
				"expression": "@headerBorderWidth || @selectedHeaderBorderWidth",
				"docu": "Defines the border-width for all enabled TabStripItems"
			},
			{
				"name": "selectedHeaderBorderStyle",
				"property": "border-sytle",
				"expression": "@headerBorderStyle || @selectedHeaderBorderStyle",
				"docu": "Defines the border-style for all enabled TabStripItems"
			},
			{
				"name": "selectedHeaderFontColor",
				"property": "color",
				"expression": "@selectedHeaderFontColor || contrast(@selectedHeaderBackgroundColor)",
				"docu": "Defines the font-color for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderFontStyle",
				"property": "font-style",
				"expression": "@selectedHeaderFontStyle || @headerFontStyle",
				"docu": "Defines the font-style for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderFontWeight",
				"property": "font-weight",
				"expression": "@selectedHeaderFontWeight || @headerFontWeight",
				"docu": "Defines the font-weight for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderMargin",
				"property": "margin",
				"expression": "@headerMargin || @selectedHeaderMargin",
				"docu": "Defines the margin  for all  TabStripItems"
			},
			{
				"name": "disabledHeaderBackgroundColor",
				"property": "background-color",
				"expression": "@disabledHeaderBackgroundColor || @headerBackgroundColor",
				"docu": "Defines the background-color for all disabled TabStripItems"
			},
			{
				"name": "disabledHeaderFontColor",
				"property": "color",
				"expression": "@disabledHeaderFontColor || greyscale(@disabledHeaderBackgroundColor)|| greyscale(@headerBackgroundColor)",
				"docu": "Defines the border-color for all disabled TabStripItems"
			},
			{
				"name": "disabledHeaderFontStyle",
				"property": "font-style",
				"expression": "@disabledHeaderFontStyle || @headerFontStyle",
				"docu": "Defines the font-style for all disabled TabStripItems"
			},
			{
				"name": "disabledHeaderFontWeight",
				"property": "font-weight",
				"expression": "@disabledHeaderFontWeight || @headerFontWeight",
				"docu": "Defines the font-weight for all disabled TabStripItems"
			}
		],
		"classes": {
			' .lsTbsFirstMore2, .lsTbsFirst2Sel, .lsTbsStartEnd2Sel, .lsTbsFirstMore2Sel, .lsTbsFirst2, .lsTbsStart2, .lsTbsStart2Sel': {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					},
					{
						"name": "background-color",
						"expression": "transparent"
					}
				]
			},
			' .lsTbsLast2, .lsTbsLast2Sel, .lsTbsEndMore2, .lsTbsEndMore2Sel': {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					}
				]
			},
			' .lsTbsPanel2': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@headerFontFamily"
					},
					{
						"name": "font-size",
						"expression": "@headerFontSize"
					}
				]
			},
			' .lsTbsEndMore2': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@headerBorderWidth"
					},
					{
						"name": "border-sytle",
						"expression": "@headerBorderStyle"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "margin",
						"expression": "@headerMargin"
					}
				]
			},
			' .lsTbsLabel2': {
				"properties": [
					{
						"name": "background-color",
						"expression": "transparent"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					}
				]
			},
			' .lsTbsEndMore2Sel, .lsTbsLast2Sel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedHeaderBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedHeaderBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@selectedHeaderBorderWidth"
					},
					{
						"name": "border-sytle",
						"expression": "@selectedHeaderBorderStyle"
					},
					{
						"name": "color",
						"expression": "@selectedHeaderFontColor"
					},
					{
						"name": "margin",
						"expression": "@selectedHeaderMargin"
					}
				]
			},
			' .lsTbsLabel2Sel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "transparent"
					},
					{
						"name": "border-color",
						"expression": "@selectedHeaderBorderColor"
					},
					{
						"name": "color",
						"expression": "@selectedHeaderFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@selectedHeaderFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@selectedHeaderFontStyle"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					}
				]
			},
			' .lsTbsLabel2Dsbl': {
				"properties": [
					{
						"name": "background-color",
						"expression": "transparent"
					},
					{
						"name": "color",
						"expression": "@disabledHeaderFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@disabledHeaderFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@disabledHeaderFontStyle"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					}
				]
			},
			' .urTbsDiv': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					}
				]
			},
			'.lsTbsv5-FirstItem': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@headerBorderWidth"
					},
					{
						"name": "border-sytle",
						"expression": "@headerBorderStyle"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "margin",
						"expression": "@headerMargin"
					},
					{
						"name": "background",
						"expression": "none"
					},
					{
						"name": "background-repetition",
						"expression": "none"
					},
					{
						"name": "background-position",
						"expression": "none"
					}
				]
			},
			'.lsTbsv5-Item, .lsTbsv5-MoreIndicator': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@headerBorderWidth"
					},
					{
						"name": "border-sytle",
						"expression": "@headerBorderStyle"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "margin",
						"expression": "@headerMargin"
					},
					{
						"name": "background",
						"expression": "none"
					},
					{
						"name": "background-repetition",
						"expression": "none"
					},
					{
						"name": "background-position",
						"expression": "none"
					}
				]
			},
			'.lsTbsv5-LastItem, .lsTbsv5-MoreIndicatorLast': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@headerBorderWidth"
					},
					{
						"name": "border-sytle",
						"expression": "@headerBorderStyle"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "margin",
						"expression": "@headerMargin"
					},
					{
						"name": "background",
						"expression": "none"
					},
					{
						"name": "background-repetition",
						"expression": "none"
					},
					{
						"name": "background-position",
						"expression": "none"
					}
				]
			},
			'.lsTbsv5-FirstItemSel, .lsTbsv5-ItemSel, .lsTbsv5-LastItemSel, .lsTbsv5-MoreIndicatorSel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedHeaderBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedHeaderBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@selectedHeaderBorderWidth"
					},
					{
						"name": "border-sytle",
						"expression": "@selectedHeaderBorderStyle"
					},
					{
						"name": "margin",
						"expression": "@selectedHeaderMargin"
					},
					{
						"name": "background",
						"expression": "none"
					},
					{
						"name": "background-repetition",
						"expression": "none"
					},
					{
						"name": "background-position",
						"expression": "none"
					}
				]
			},
			'.lsTbsv5-ItemTitle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@headerBackgroundColor"
					}
				]
			},
			'[ct=\'TSITM_standards\'][selected=\'true\'] .lsTbsv5-ItemTitle': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedHeaderFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@selectedHeaderFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@selectedHeaderFontStyle"
					},
					{
						"name": "background-color",
						"expression": "@selectedHeaderBackgroundColor"
					}
				]
			},
			'.lsTbsv5-ItemDsbl, [ct=\'TSITM_standards\'][disabled=\'true\'] .lsTbsv5-ItemTitle, .lsTbsv5-MoreIndicatorDsbl, .lsTbsv5-ItemFirstDsbl, .lsTbsv5-ItemLastDsbl': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledHeaderFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@disabledHeaderFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@disabledHeaderFontStyle"
					},
					{
						"name": "background-color",
						"expression": "@disabledHeaderBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["TabStripItem"] = {
	"name": "TabStripItem",
	"properties": {
		"Index": {
			"type": "number",
			"defaultValue": 0
		},
		"Height": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Caption": {
			"type": "string",
			"defaultValue": ''
		},
		"IsTextCaption": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasTitleCaption": {
			"type": "boolean",
			"defaultValue": false
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"ScrollingMode": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "NONE"
		},
		"HasToolbar": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasContentPadding": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"IsClosable": {
			"type": "boolean",
			"defaultValue": false
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"ClientTabSelect": {
			"type": "boolean",
			"defaultValue": true
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"HasEditableTitle": {
			"type": "boolean",
			"defaultValue": false
		},
		"BorderDesign": {
			"type": "UCF_ClientInterfaces.E.BorderDesign",
			"defaultValue": "BOX"
		},
		"AreaDesign": {
			"type": "UCF_ClientInterfaces.E.AreaDesign",
			"defaultValue": "FILL"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingTop": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingBottom": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingRight": {
			"type": "string",
			"defaultValue": ''
		},
		"PaddingLeft": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		}
	},
	"aggregations": {
		"CaptionContent": {
			"type": "UCF_ClientElement",
			"multiple": false,
			"deprecated": true
		},
		"TitleCaption": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": false
		},
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"Toolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"editInplace",
		"setDefaultButtonId",
		"setVisibility",
		"getVisibility"
	],
	"styles": {
		"variables": [
			{
				"name": "headerFontFamily",
				"property": "font-family",
				"docu": "Defines the font-family for TabStripItem"
			},
			{
				"name": "headerFontSize",
				"property": "font-size",
				"docu": "Defines the font-size  for  TabStripItem"
			},
			{
				"name": "headerFontColor",
				"property": "color",
				"docu": "Defines the font-color for  enabled TabStripItem"
			},
			{
				"name": "headerFontStyle",
				"property": "font-style",
				"docu": "Defines the font-style for  enabled TabStripItem"
			},
			{
				"name": "headerFontWeight",
				"property": "font-weight",
				"docu": "Defines the font-weight for enabled TabStripItem"
			},
			{
				"name": "headerTextDecoration",
				"property": "text-decoration",
				"docu": "Defines the text-decoration for enabled TabStripItem"
			},
			{
				"name": "headerBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for enabled TabStripItem"
			},
			{
				"name": "headerBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for enabled TabStripItem"
			},
			{
				"name": "headerBorderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for enabled TabStripItem"
			},
			{
				"name": "headerBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for enabled TabStripItem"
			},
			{
				"name": "headerBorderRadius",
				"property": "border-radius",
				"docu": "Defines the border-radius for enabled TabStripItem"
			},
			{
				"name": "headerMargin",
				"property": "margin",
				"docu": "Defines the margin  for all  TabStripItems"
			},
			{
				"name": "selectedHeaderFontColor",
				"property": "color",
				"docu": "Defines the font-color for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderFontStyle",
				"property": "font-style",
				"expression": "@selectedHeaderFontStyle || @headerFontStyle",
				"docu": "Defines the font-style for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderFontWeight",
				"property": "font-weight",
				"expression": "@selectedHeaderFontWeight || @headerFontWeight",
				"docu": "Defines the font-weight for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderTextDecoration",
				"property": "text-decoration",
				"docu": "Defines the text-decoration for enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderBorderWidth",
				"property": "border-width",
				"expression": "@selectedHeaderBorderWidth || @headerBorderWidth",
				"docu": "Defines the border-width for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderBorderStyle",
				"property": "border-style",
				"expression": "@selectedHeaderBorderStyle || @headerBorderStyle",
				"docu": "Defines the border-style for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderBorderRadius",
				"property": "border-radius",
				"expression": "@selectedHeaderBorderRadius || @headerBorderRadius",
				"docu": "Defines the border-radius for the enabled and selected TabStripItem"
			},
			{
				"name": "selectedHeaderMargin",
				"property": "margin",
				"expression": "@headerMargin || @selectedHeaderMargin",
				"docu": "Defines the margin  for all  TabStripItems"
			},
			{
				"name": "disabledHeaderBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for all disabled TabStripItems"
			},
			{
				"name": "disabledHeaderFontColor",
				"property": "color",
				"docu": "Defines the border-color for all disabled TabStripItems"
			},
			{
				"name": "disabledHeaderFontStyle",
				"property": "font-style",
				"expression": "@disabledHeaderFontStyle || @headerFontStyle",
				"docu": "Defines the font-style for all disabled TabStripItems"
			},
			{
				"name": "disabledHeaderFontWeight",
				"property": "font-weight",
				"expression": "@disabledHeaderFontWeight || @headerFontWeight",
				"docu": "Defines the font-weight for all disabled TabStripItems"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color for the content"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"docu": "Defines the background-image for the content"
			},
			{
				"name": "backgroundPositionX",
				"property": "background-position-x",
				"docu": "Defines the background position X for background image for the content"
			},
			{
				"name": "backgroundPositionY",
				"property": "background-position-y",
				"docu": "Defines the background position Y for background image for the content"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"docu": "Defines the background repeat for background image for the content"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"docu": "Defines the background site for background image for the content"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "background-image",
						"expression": "@backgroundImage"
					},
					{
						"name": "background-position-x",
						"expression": "@backgroundPositionX"
					},
					{
						"name": "background-position-y",
						"expression": "@backgroundPositionY"
					},
					{
						"name": "background-repeat",
						"expression": "@backgroundRepeat"
					},
					{
						"name": "background-size",
						"expression": "@backgroundSize"
					}
				]
			},
			'Hd.lsTbsFirstMore2,Hd.lsTbsFirst2Sel,Hd.lsTbsStartEnd2Sel,Hd.lsTbsFirstMore2Sel,Hd.lsTbsFirst2,Hd.lsTbsStart2,Hd.lsTbsStart2Sel': {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					},
					{
						"name": "background-color",
						"expression": "transparent"
					}
				]
			},
			'Hd.lsTbsLast2,Hd.lsTbsLast2Sel,Hd.lsTbsEndMore2,Hd.lsTbsEndMore2Sel': {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					}
				]
			},
			"Hd": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@headerFontFamily"
					},
					{
						"name": "font-size",
						"expression": "@headerFontSize"
					}
				]
			},
			'Hd.lsTbsEndMore2,Hd.lsTbsLast2': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@headerBorderWidth @headerBorderWidth 0 @headerBorderWidth"
					},
					{
						"name": "border-style",
						"expression": "@headerBorderStyle"
					},
					{
						"name": "border-radius",
						"expression": "@headerBorderRadius @headerBorderRadius 0 0"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "margin",
						"expression": "@headerMargin"
					}
				]
			},
			'Hd .lsTbsLabel2': {
				"properties": [
					{
						"name": "background-color",
						"expression": "transparent"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@headerTextDecoration"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					}
				]
			},
			'Hd.lsTbsEndMore2Sel,Hd.lsTbsLast2Sel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedHeaderBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedHeaderBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@selectedHeaderBorderWidth @selectedHeaderBorderWidth 0 @selectedHeaderBorderWidth"
					},
					{
						"name": "border-style",
						"expression": "@selectedHeaderBorderStyle"
					},
					{
						"name": "border-top-left-radius",
						"expression": "@selectedHeaderBorderRadius"
					},
					{
						"name": "border-top-right-radius",
						"expression": "@selectedHeaderBorderRadius"
					},
					{
						"name": "border-bottom-left-radius",
						"expression": "0"
					},
					{
						"name": "border-bottom-right-radius",
						"expression": "0"
					},
					{
						"name": "color",
						"expression": "@selectedHeaderFontColor"
					},
					{
						"name": "margin",
						"expression": "@selectedHeaderMargin"
					}
				]
			},
			'Hd .lsTbsLabel2Sel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "transparent"
					},
					{
						"name": "border-color",
						"expression": "@selectedHeaderBorderColor"
					},
					{
						"name": "color",
						"expression": "@selectedHeaderFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@selectedHeaderFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@selectedHeaderFontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@selectedHeaderTextDecoration"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					}
				]
			},
			'Hd .lsTbsLabel2Dsbl': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledHeaderBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@disabledHeaderFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@disabledHeaderFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@disabledHeaderFontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@headerTextDecoration"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					},
					{
						"name": "border-radius",
						"expression": "@headerBorderRadius @headerBorderRadius 0 0"
					}
				]
			},
			'.lsTbsv5-FirstItem@{CustomStyle}': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@headerBorderWidth"
					},
					{
						"name": "border-sytle",
						"expression": "@headerBorderStyle"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "margin",
						"expression": "@headerMargin"
					},
					{
						"name": "background",
						"expression": "none"
					},
					{
						"name": "background-repetition",
						"expression": "none"
					},
					{
						"name": "background-position",
						"expression": "none"
					}
				]
			},
			'.lsTbsv5-Item@{CustomStyle},.lsTbsv5-MoreIndicator@{CustomStyle}': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@headerBorderWidth"
					},
					{
						"name": "border-sytle",
						"expression": "@headerBorderStyle"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "margin",
						"expression": "@headerMargin"
					},
					{
						"name": "background",
						"expression": "none"
					},
					{
						"name": "background-repetition",
						"expression": "none"
					},
					{
						"name": "background-position",
						"expression": "none"
					}
				]
			},
			'.lsTbsv5-LastItem@{CustomStyle},.lsTbsv5-MoreIndicatorLast@{CustomStyle}': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@headerBorderWidth"
					},
					{
						"name": "border-sytle",
						"expression": "@headerBorderStyle"
					},
					{
						"name": "color",
						"expression": "@headerFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "margin",
						"expression": "@headerMargin"
					},
					{
						"name": "background",
						"expression": "none"
					},
					{
						"name": "background-repetition",
						"expression": "none"
					},
					{
						"name": "background-position",
						"expression": "none"
					}
				]
			},
			'.lsTbsv5-FirstItemSel@{CustomStyle},.lsTbsv5-ItemSel@{CustomStyle},.lsTbsv5-LastItemSel,.lsTbsv5-MoreIndicatorSel': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedHeaderBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedHeaderBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@selectedHeaderBorderWidth"
					},
					{
						"name": "border-sytle",
						"expression": "@selectedHeaderBorderStyle"
					},
					{
						"name": "margin",
						"expression": "@selectedHeaderMargin"
					},
					{
						"name": "background",
						"expression": "none"
					},
					{
						"name": "background-repetition",
						"expression": "none"
					},
					{
						"name": "background-position",
						"expression": "none"
					}
				]
			},
			'.lsTbsv5-ItemTitle@{CustomStyle}': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@headerBackgroundColor"
					}
				]
			},
			'[ct=\'TSITM_standards\'][selected=\'true\'] .lsTbsv5-ItemTitle@{CustomStyle}': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedHeaderFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@selectedHeaderFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@selectedHeaderFontStyle"
					},
					{
						"name": "background-color",
						"expression": "@selectedHeaderBackgroundColor"
					}
				]
			},
			'.lsTbsv5-ItemDsbl@{CustomStyle},[ct=\'TSITM_standards\'][disabled=\'true\'] .lsTbsv5-ItemTitle@{CustomStyle},.lsTbsv5-MoreIndicatorDsbl,.lsTbsv5-ItemFirstDsbl@{CustomStyle},.lsTbsv5-ItemLastDsbl@{CustomStyle}': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledHeaderFontColor"
					},
					{
						"name": "font-weight",
						"expression": "@disabledHeaderFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@disabledHeaderFontStyle"
					},
					{
						"name": "background-color",
						"expression": "@disabledHeaderBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["TagCloud"] = {
	"name": "TagCloud",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Tags": {
			"type": "UCF_ClientInterfaces.I.TagCloudItem",
			"multiple": true,
			"singularName": "Tag"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["TagCloudItem"] = {
	"name": "TagCloudItem",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HitCount": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Size": {
			"type": "number",
			"defaultValue": 1
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Select": {}
	}
};

UCF_ClientInterfaces["I"]["RichTextEdit"] = {
	"name": "RichTextEdit",
	"properties": {
		"HtmlText": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"HasToolBar": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasBold": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasItalics": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasUnderline": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasHeadings": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasIndent": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasOutdent": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasOrderedList": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasUnorderedList": {
			"type": "boolean",
			"defaultValue": false
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"HasTextAlignment": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasBorder": {
			"type": "boolean",
			"defaultValue": false
		},
		"ToolbarDesign": {
			"type": "UCF_ClientInterfaces.E.ToolbarDesign",
			"defaultValue": "STANDARD"
		},
		"AssociatedEditContext": {
			"type": "UCF_ClientInterfaces.E.EditContext",
			"defaultValue": "PARENTEDITABLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"ParagraphSpacing": {
			"type": "UCF_ClientInterfaces.E.RichTextEditParagraphSpacing",
			"defaultValue": "NONE"
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"ButtonCaption": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Change": {},
		"Scroll": {}
	}
};

UCF_ClientInterfaces["I"]["TextEdit"] = {
	"name": "TextEdit",
	"properties": {
		"Wrapping": {
			"type": "UCF_ClientInterfaces.E.TextEditWrapping",
			"defaultValue": "SOFT"
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Cols": {
			"type": "number",
			"defaultValue": NaN
		},
		"Rows": {
			"type": "number",
			"defaultValue": -1
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"MaxLength": {
			"type": "number",
			"defaultValue": 0
		},
		"IMEMode": {
			"type": "UCF_ClientInterfaces.E.IMEMode",
			"defaultValue": "AUTO"
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"UsedInSapTable": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"Overflow": {
			"type": "UCF_ClientInterfaces.E.TextEditOverflow",
			"defaultValue": "AUTO"
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"DisplayAsText": {
			"type": "boolean",
			"defaultValue": false
		},
		"AdjustRowsToText": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasBorder": {
			"type": "boolean",
			"defaultValue": true
		},
		"ContainerWidthSet": {
			"type": "boolean",
			"defaultValue": false
		},
		"AssociatedEditContext": {
			"type": "UCF_ClientInterfaces.E.EditContext",
			"defaultValue": "PARENTEDITABLE"
		},
		"ItsMode": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"ShowTextInputHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"ItsMessage": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Change": {},
		"DoubleClick": {},
		"Scroll": {}
	},
	"publicMethods": [
		"setScrollPosition",
		"setCursorPosition",
		"setSelection",
		"iGetSelectionStart",
		"iGetSelectionEnd",
		"setValueState",
		"getValueState",
		"setValue",
		"getValue",
		"setEnabled",
		"getEnabled",
		"setEditable",
		"getEditable",
		"createDataTip"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urTedWhl,font-family)",
				"docu": "Defines the font family for all text edit states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "contrast(@backgroundColor)",
				"defaultValue": "ruleValue(.urTedWhl,color)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urTedWhl,font-size)",
				"docu": "Defines the font size e.g. px, em"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style e.g. italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration e.g. underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"expression": "contrast(@fontColor)",
				"defaultValue": "ruleValue(.urTedWhl,background-color)",
				"docu": "Defines the background color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "borderRadius",
				"property": "border-radius",
				"docu": "Defines the broder radius."
			},
			{
				"name": "borderCollapse",
				"property": "border-collapse",
				"docu": "Defines the broder radius."
			},
			{
				"name": "focusBackgroundColor",
				"property": "background-color",
				"expression": "@focusBackgroundColor || @backgroundColor",
				"defaultValue": "ruleValue(.lsEdFieldFocus,background-color)",
				"docu": "Defines the disabled background color of the TextEdit"
			},
			{
				"name": "focusFontColor",
				"property": "color",
				"expression": "@focusFontColor",
				"defaultValue": "ruleValue(.lsEdFieldFocus,color)",
				"docu": "Defines the disabled font color of the TextEdit"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"expression": "lighten(greyscale(@backgroundColor),30%)",
				"defaultValue": "ruleValue(.urTedWhlDsbl,background-color)",
				"docu": "Defines the disabled background color of the TextEdit"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "lighten(greyscale(@fontColor),20%) || lighten(greyscale(@backgroundColor),10%)",
				"defaultValue": "ruleValue(.urTedWhlDsbl,color)",
				"docu": "Defines the disabled font color of the TextEdit"
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the disabled font color of the TextEdit"
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "background-color",
				"expression": "lighten(greyscale(@backgroundColor),30%)",
				"defaultValue": "ruleValue(.urTedWhlRo,background-color)",
				"docu": "Defines the readonly background color of the TextEdit"
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"expression": "lighten(greyscale(@fontColor),20%) || lighten(greyscale(@backgroundColor),10%)",
				"defaultValue": "ruleValue(.urTedWhlRo,color)",
				"docu": "Defines the readonly font color of the TextEdit"
			},
			{
				"name": "readonlyBorderColor",
				"property": "border-color",
				"docu": "Defines the readonly border color of the TextEdit"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color"
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color"
			},
			{
				"name": "hoverColor",
				"property": "color",
				"expression": "@fontColor || contrast(@hoverBackgroundColor)"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"important": true,
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"important": true,
						"expression": "@borderRadius"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					}
				]
			},
			'.urEdf2TxtDsbl,.lsTextEdit--disabled': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					}
				]
			},
			'.urEdf2TxtRo,.lsTextEdit--readonly': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@readonlyFontColor"
					},
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					}
				]
			},
			'.lsEdFieldFocus,:not(.lsTextEdit--readonly).lsTextEdit--focus': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@focusFontColor"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@focusBackgroundColor"
					}
				]
			},
			'.lsTextEdit--hover': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@hoverColor"
					}
				]
			},
			"ITS": {
				"properties": [
					{
						"name": "border-color",
						"important": true,
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"important": true,
						"expression": "@borderRadius"
					},
					{
						"name": "border-collapse",
						"important": true,
						"expression": "separate || @borderCollapse"
					}
				]
			},
			'ITS .lsTedItsFont,ITSMsg .urTxtStd,ITS .lsTextEdit--itsfont': {
				"properties": [
					{
						"name": "font-family",
						"important": true,
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"important": true,
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'ITS.lsTedItsCntBgColor,ITS .lsTedItsCntBgColor,ITS.lsTextEditIts__inner,ITS .lsTextEditIts__inner': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'ITS.urEdf2TxtDsbl,ITS.lsTextEditIts__inner--disabled,ITS .lsTextEditIts__inner--disabled,ITS.lsTextEditIts--disabled': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@disabledBorderColor"
					}
				]
			},
			'ITS.lsTedItsCntBgColorRo,ITS .lsTedItsCntBgColorRo,ITS.lsTextEditIts__inner--readonly,ITS .lsTextEditIts__inner--readonly,ITS.lsTextEditIts--readonly': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@readonlyBorderColor"
					}
				]
			},
			'ITS .urTedWhlEnbl,ITSMsg .urTxtStd,ITS .lsTextEdit': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "transparent"
					}
				]
			},
			'ITSMsg .lsTextEdit__itsContent': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'ITS .urEdf2TxtDsbl,ITS .lsTextEdit--disabled': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					},
					{
						"name": "background-color",
						"expression": "transparent"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					}
				]
			},
			'ITSMsg.lsTextEditIts__message--disabled .lsTextEdit__itsContent': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			},
			'ITS .urEdf2TxtRo,ITS .lsTextEdit--readonly': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@readonlyFontColor"
					},
					{
						"name": "background-color",
						"expression": "transparent"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@readonlyBorderColor"
					}
				]
			},
			'ITSMsg.lsTextEditIts__message--readonly .lsTextEdit__itsContent': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@readonlyFontColor"
					}
				]
			},
			'ITS .lsEdFieldFocus': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@focusFontColor"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "transparent || @focusBackgroundColor"
					}
				]
			},
			'ITS.lsTextEdit--hover': {
				"properties": [
					{
						"name": "border-color",
						"important": true,
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					}
				]
			},
			'ITS.lsTextEdit--hover .lsTextEdit': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@hoverColor"
					}
				]
			},
			'ITS.lsTextEditIts__inner.lsTextEdit--hover,ITS.lsTextEdit--hover .lsTextEditIts__inner': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["FormattedTextView"] = {
	"name": "FormattedTextView",
	"properties": {
		"HTML": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"Layout": {
			"type": "UCF_ClientInterfaces.E.FormattedTextViewLayout",
			"defaultValue": "NATIVE"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"Overflow": {
			"type": "UCF_ClientInterfaces.E.TextEditOverflow",
			"defaultValue": "VISIBLE"
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"LinkData": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"LinkActivate": {}
	},
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family"
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			},
			{
				"name": "linkFontColor",
				"property": "color",
				"docu": "Defines the font color for links"
			},
			{
				"name": "linkTextDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration for links"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'.urFTxtV h1,.urFTxtV h2,.urFTxtV h3,.urFTxtV h4,.urFTxtV h5,.urFTxtV h6': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsControl--monospace,.lsControl--monospace.urFTxtV h1,.lsControl--monospace.urFTxtV h2,.lsControl--monospace.urFTxtV h3,.lsControl--monospace.urFTxtV h4,.lsControl--monospace.urFTxtV h5,.lsControl--monospace.urFTxtV h6': {
				"properties": [
					{
						"name": "font-family",
						"important": true,
						"expression": "@fontFamily"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.urFTxtV a': {
				"properties": [
					{
						"name": "color",
						"expression": "@linkFontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@linkTextDecoration"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["HTMLTextView"] = {
	"name": "HTMLTextView",
	"properties": {
		"HTML": {
			"type": "string",
			"defaultValue": ''
		},
		"JavaScript": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"Layout": {
			"type": "UCF_ClientInterfaces.E.TextViewLayout",
			"defaultValue": "NATIVE"
		},
		"Width": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"EscapeHTML": {
			"type": "boolean",
			"defaultValue": true
		},
		"RenderOnlyContent": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"IsCustomHTML": {
			"type": "boolean",
			"defaultValue": true
		},
		"IsCustomJavaScript": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"InheritFontColor": {
			"type": "boolean",
			"defaultValue": false
		},
		"Selectable": {
			"type": "boolean",
			"defaultValue": true
		},
		"IsLayout": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"ContextMenu": {}
	},
	"publicMethods": [
		"setDragAndDropHandler"
	]
};

UCF_ClientInterfaces["I"]["TextView"] = {
	"name": "TextView",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.TextViewDesign",
			"defaultValue": "STANDARD"
		},
		"Layout": {
			"type": "UCF_ClientInterfaces.E.TextViewLayout",
			"defaultValue": "NATIVE"
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.TextViewSemanticColor",
			"defaultValue": "DEFAULT",
			"deprecated": true
		},
		"SemanticBgColor": {
			"type": "UCF_ClientInterfaces.E.TextViewSemanticColor",
			"defaultValue": "DEFAULT",
			"deprecated": true
		},
		"HasPopupMenu": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"IsNested": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Align": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"TextForTooltip": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"Tabstop": {
			"type": "boolean",
			"defaultValue": false
		},
		"UsedInSapTable": {
			"type": "boolean",
			"defaultValue": false
		},
		"PreserveWhitespace": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalSpacing": {
			"type": "UCF_ClientInterfaces.E.Spacing",
			"defaultValue": "ALIGNED"
		}
	},
	"events": {
		"Activate": {},
		"DoubleClick": {}
	},
	"publicMethods": [
		"setText",
		"getText",
		"setSemanticColor",
		"getSemanticColor",
		"setSemanticBgColor",
		"getSemanticBgColor"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urTxtStd,font-family)",
				"docu": "Defines the font family for TextView"
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "@fontColor || contrast(@backgroundColor)",
				"defaultValue": "ruleValue(.urTxtColor,color)",
				"docu": "Defines the font color for TextView"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"defaultValue": "ruleValue(.urTxtStd,font-weight)",
				"docu": "Defines the font weight for TextView"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urTxtStd,font-size)",
				"docu": "Defines the font size for TextView"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"defaultValue": "ruleValue(.urTxtStd,font-style)",
				"docu": "Defines the font style for TextView"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration for TextView"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "@disabledFontColor || @fontColor",
				"defaultValue": "ruleValue(.urTxtDsblStd,color)",
				"docu": "Defines the font color for TextView"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'.urTxtDsblStd,.lsTextView--disabled': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemtext': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ThresholdPoint"] = {
	"name": "ThresholdPoint",
	"properties": {
		"ShowAsMarker": {
			"type": "boolean",
			"defaultValue": false
		},
		"Position": {
			"type": "number",
			"defaultValue": 0
		},
		"Semantic": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "GOODVALUE_DARK"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": 'threshold tooltip'
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["ThresholdSlider"] = {
	"name": "ThresholdSlider",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": 'control tooltip'
		},
		"ShowUnits": {
			"type": "boolean",
			"defaultValue": true
		},
		"TotalUnits": {
			"type": "number",
			"defaultValue": 10
		},
		"SubUnitsPerUnit": {
			"type": "number",
			"defaultValue": 1
		},
		"SubUnitWidth": {
			"type": "number",
			"defaultValue": 10
		},
		"ColoredBarSubUnits": {
			"type": "number",
			"defaultValue": 5
		},
		"IsInteractive": {
			"type": "boolean",
			"defaultValue": true
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ReferenceValue": {
			"type": "number",
			"defaultValue": -1
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"SizingBehavior": {
			"type": "UCF_ClientInterfaces.E.ThresholdSliderSizing",
			"defaultValue": "STATIC"
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Thresholds": {
			"type": "UCF_ClientInterfaces.I.ThresholdPoint",
			"multiple": true,
			"singularName": "Threshold"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Change": {},
		"Activate": {}
	}
};

UCF_ClientInterfaces["I"]["TileLayout"] = {
	"name": "TileLayout",
	"properties": {
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"MinCellWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"AllowedColCounts": {
			"type": "string",
			"defaultValue": ''
		},
		"CellPadding": {
			"type": "UCF_ClientInterfaces.E.TileLayoutCellPadding",
			"defaultValue": "NONE"
		},
		"AlignLastCell": {
			"type": "boolean",
			"defaultValue": false
		}
	},
	"aggregations": {
		"Cells": {
			"type": "UCF_ClientInterfaces.I.TileLayoutCell",
			"multiple": true,
			"singularName": "Cell"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["TileLayoutCell"] = {
	"name": "TileLayoutCell",
	"properties": {
		"Height": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["ToggleLink"] = {
	"name": "ToggleLink",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Collapsed": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Emphasized": {
			"type": "boolean",
			"defaultValue": false
		},
		"Underlined": {
			"type": "boolean",
			"defaultValue": true
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowAccessKey": {
			"type": "boolean",
			"defaultValue": true
		},
		"Hotkey": {
			"type": "UCF_ClientInterfaces.E.HotkeyValue",
			"defaultValue": "NONE"
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Expand": {},
		"Collapse": {}
	}
};

UCF_ClientInterfaces["I"]["Toolbar"] = {
	"name": "Toolbar",
	"properties": {
		"Design": {
			"type": "UCF_ClientInterfaces.E.ToolbarDesign",
			"defaultValue": "STANDARD"
		},
		"HasShowAllState": {
			"type": "boolean",
			"defaultValue": false
		},
		"ShowAll": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasLayerButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"LayerButtonHidden": {
			"type": "boolean",
			"defaultValue": false
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"HasPopInContainer": {
			"type": "boolean",
			"defaultValue": false
		},
		"ItemOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"Alignment": {
			"type": "UCF_ClientInterfaces.E.ToolbarAlignment",
			"defaultValue": "HORIZONTAL"
		},
		"HasBorder": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"IsNested": {
			"type": "boolean",
			"defaultValue": false
		},
		"ToolbarSize": {
			"type": "UCF_ClientInterfaces.E.Size",
			"defaultValue": "MEDIUM"
		},
		"HasRightItemsFixed": {
			"type": "boolean",
			"defaultValue": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "Item",
			"bindable": true
		},
		"LayerButton": {
			"type": "UCF_ClientInterfaces.I.ToolbarButton",
			"multiple": false
		},
		"RightItems": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "RightItem",
			"bindable": true
		},
		"PopInContainer": {
			"type": "UCF_ClientInterfaces.I.PopIn",
			"multiple": false
		},
		"OverflowItems": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "OverflowItem",
			"bindable": true
		},
		"OverflowButton": {
			"type": "UCF_ClientInterfaces.I.ToolbarButton",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"getHeightPx",
		"getWidthPx"
	],
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urTWhl,background-color)"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "height",
				"property": "height",
				"docu": "Defines the height of the Toolbar."
			},
			{
				"name": "overflowFontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urBdyStd,font-family)",
				"docu": "Defines the font family for all button states"
			},
			{
				"name": "overflowFontColor",
				"property": "color",
				"expression": "@overflowFontColor || contrast(@overflowBackgroundColor)",
				"docu": "Defines the font color"
			},
			{
				"name": "overflowFontWeight",
				"property": "font-weight"
			},
			{
				"name": "overflowFontSize",
				"property": "font-size"
			},
			{
				"name": "overflowFontStyle",
				"property": "font-style"
			},
			{
				"name": "overflowTextDecoration",
				"property": "text-decoration"
			},
			{
				"name": "overflowBackgroundColor",
				"property": "background-color",
				"expression": "@overflowBackgroundColor"
			},
			{
				"name": "overflowBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "overflowBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "overflowBorderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "overflowBorderRadius",
				"property": "border-radius",
				"defaultValue": "ruleValue(.urBtnRadius,border-radius)"
			},
			{
				"name": "overflowHoverBackgroundColor",
				"property": "background-color"
			},
			{
				"name": "overflowHoverFontColor",
				"property": "color"
			},
			{
				"name": "overflowHoverBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "overflowHoverBorderStyle",
				"property": "border-style",
				"expression": "@overflowBorderStyle || @overflowHoverBorderStyle",
				"docu": "Defines the border-style."
			},
			{
				"name": "overflowHoverBorderWidth",
				"property": "border-width",
				"expression": "@overflowBorderWidth || @overflowHoverBorderWidth",
				"docu": "Defines the border-width."
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "height",
						"expression": "@height"
					},
					{
						"name": "background-image",
						"expression": "none"
					}
				]
			},
			' .lsTbarFlatMenuIndCover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			' .urTItmLnk, .urTbarItmBtn,  .urTSepTrans, .urTItm, .urTItmLnk': {
				"properties": [
					{
						"name": "height",
						"expression": "@height || auto"
					},
					{
						"name": "vertical-align",
						"expression": "middle"
					}
				]
			},
			' .lsTItmOvfl, .lsTbarOvfl': {
				"properties": [
					{
						"name": "height",
						"expression": "@height"
					}
				]
			},
			'.lsBtnTransparent.urBtnStd': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@overflowFontFamily"
					},
					{
						"name": "font-size",
						"expression": "@overflowFontSize"
					},
					{
						"name": "font-weight",
						"expression": "@overflowFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@overflowFontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@overflowFontColor"
					},
					{
						"name": "text-decoration",
						"important": true,
						"expression": "@overflowTextDecoration"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@overflowBackgroundColor"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@overflowBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@overflowBorderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@overflowBorderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@overflowBorderRadius"
					}
				]
			},
			'.lsBtnTransparent.urBtnStd:hover': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@overflowHoverBackgroundColor"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@overflowHoverBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@overflowHoverBorderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@overflowHoverBorderWidth"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@overflowHoverFontColor"
					}
				]
			},
			' .lsToolbar--standards-overflowButton': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@overflowFontColor"
					},
					{
						"name": "background-color",
						"important": true,
						"expression": "@overflowBackgroundColor"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@overflowBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@overflowBorderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@overflowBorderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@overflowBorderRadius"
					}
				]
			},
			' .lsToolbar--standards-overflowButton.lsToolbar--standards-overflowButton-hoverable:hover': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@overflowHoverBackgroundColor"
					},
					{
						"name": "border-color",
						"important": true,
						"expression": "@overflowHoverBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@overflowHoverBorderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@overflowHoverBorderWidth"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@overflowHoverFontColor"
					}
				]
			},
			'.urST4Toolbar .urTWhlFlat@{CustomStyle}, .lsTbsTbar .urTWhlFlat@{CustomStyle}, .lsTbsTbar .urTWhl@{CustomStyle}, .urST4Toolbar .urTWhl@{CustomStyle} ': {
				"properties": [
					{
						"name": "border-color",
						"important": true,
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ToolbarButton"] = {
	"name": "ToolbarButton",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.ButtonDesign",
			"defaultValue": "STANDARD"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasButtonCaption": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"Down": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasIcon": {
			"type": "boolean",
			"defaultValue": false
		},
		"DisabledIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"UpIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"DownIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"HasPopupMenu": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasPopupMenuSection": {
			"type": "boolean",
			"defaultValue": false
		},
		"ImageFirst": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageAlt": {
			"type": "string",
			"defaultValue": ''
		},
		"HasShowAlwaysState": {
			"type": "boolean",
			"defaultValue": true
		},
		"Show": {
			"type": "boolean",
			"defaultValue": true
		},
		"Hotkey": {
			"type": "UCF_ClientInterfaces.E.HotkeyValue",
			"defaultValue": "NONE"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"Up": {
			"type": "boolean",
			"defaultValue": false
		},
		"HAlign": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "CENTER"
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"FixedHeight": {
			"type": "boolean",
			"defaultValue": false
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.ButtonType",
			"defaultValue": "NONE"
		},
		"InteractionBehaviour": {
			"type": "UCF_ClientInterfaces.E.ButtonInteractionBehaviour",
			"defaultValue": "PUSH"
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentVisibility": {
			"type": "UCF_ClientInterfaces.E.ContentVisibility",
			"defaultValue": "ALL"
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"Priority": {
			"type": "number",
			"defaultValue": 0
		},
		"MinWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"DescribedBy": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"PopupMenuId": {
			"type": "string"
		},
		"DragSourceInfo": {
			"type": "string"
		}
	},
	"aggregations": {
		"ButtonCaption": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Press": {},
		"MenuAccess": {},
		"DoubleClick": {}
	},
	"publicMethods": [
		"openMenu",
		"setEnabled",
		"setDisabled"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"defaultValue": "ruleValue(.urBdyStd,font-family)",
				"docu": "Defines the font family for all button states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"expression": "@fontColor || contrast(@backgroundColor)",
				"defaultValue": "ruleValue(.urBtnStd,color)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"defaultValue": "ruleValue(.urBtnStd,font-weight)"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urBtnStd,font-size)"
			},
			{
				"name": "fontStyle",
				"property": "font-style"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"defaultValue": "ruleValue(.urBtnStd,text-decoration)"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"expression": "@backgroundColor",
				"defaultValue": "ruleValue(.urBtnStd,background-color)"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "borderRadius",
				"property": "border-radius",
				"defaultValue": "ruleValue(.urBtnRadius,border-radius)"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urBtnStd:hover,background-color)"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urBtnStd:hover,color)"
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "hoverBorderStyle",
				"property": "border-style",
				"expression": "@borderStyle || @hoverBorderStyle",
				"docu": "Defines the border-style."
			},
			{
				"name": "hoverBorderWidth",
				"property": "border-width",
				"expression": "@borderWidth || @hoverBorderWidth",
				"docu": "Defines the border-width."
			},
			{
				"name": "selectedBackgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urBtnStd:hover,background-color)"
			},
			{
				"name": "selectedFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urBtnStd:hover,color)"
			},
			{
				"name": "selectedBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "selectedBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "selectedBorderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urBtnStdDsbl,background-color)"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urBtnStdDsbl,color)"
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "disabledBorderStyle",
				"property": "border-style",
				"expression": "@disabledBorderStyle || @borderStyle",
				"docu": "Defines the border-style."
			},
			{
				"name": "disabledBorderWidth",
				"property": "border-width",
				"expression": "@borderWidth || @disabledBorderWidth",
				"docu": "Defines the border-width."
			},
			{
				"name": "emphasizedFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urBtnEmph,color)",
				"docu": "Defines the font color"
			},
			{
				"name": "emphasizedTextShadow",
				"property": "text-shadow",
				"expression": "none || @emphasizedTextShadow",
				"docu": "Defines the text-shadow"
			},
			{
				"name": "emphasizedBackgroundColor",
				"property": "background-color",
				"defaultValue": "ruleValue(.urBtnEmph,background-color)"
			},
			{
				"name": "emphasizedBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "emphasizedBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "emphasizedBorderWidth",
				"property": "border-width",
				"expression": "@borderWidth || @emphasizedBorderWidth",
				"docu": "Defines the border-width."
			},
			{
				"name": "emphasizedHoverBackgroundColor",
				"property": "background-color",
				"expression": "@emphasizedHoverBackgroundColor || @emphasizedBackgroundColor"
			},
			{
				"name": "emphasizedHoverBorderColor",
				"property": "border-color",
				"expression": "@emphasizedHoverBorderColor || @emphasizedBorderColor"
			},
			{
				"name": "emphasizedHoverFontColor",
				"property": "color",
				"expression": "@emphasizedHoverFontColor || @emphasizedFontColor"
			},
			{
				"name": "emphasizedSelectedBackgroundColor",
				"property": "background-color",
				"expression": "@emphasizedSelectedBackgroundColor || @emphasizedHoverBackgroundColor"
			},
			{
				"name": "emphasizedSelectedFontColor",
				"property": "color",
				"expression": "@emphasizedSelectedFontColor || @emphasizedHoverFontColor"
			},
			{
				"name": "emphasizedSelectedBorderColor",
				"property": "border-color",
				"expression": "@emphasizedSelectedBorderColor || @emphasizedHoverBorderColor"
			},
			{
				"name": "emphasizedDisabledBackgroundColor",
				"property": "background-color",
				"expression": "@emphasizedDisabledBackgroundColor || @disabledBackgroundColor"
			},
			{
				"name": "emphasizedDisabledFontColor",
				"property": "color",
				"expression": "@emphasizedDisabledFontColor || @disabledFontColor"
			},
			{
				"name": "emphasizedDisabledBorderColor",
				"property": "border-color",
				"expression": "@emphasizedDisabledBorderColor || @disabledBorderColor"
			},
			{
				"name": "nextBackgroundImage",
				"property": "background-image",
				"expression": "contrast(@nextFontColor)",
				"defaultValue": "ruleValue(.lsBtnNextImg,background-image)"
			},
			{
				"name": "nextHoverBackgroundImage",
				"property": "background-image",
				"expression": "contrast(@nextFontColor)",
				"defaultValue": "ruleValue(.lsBtnNextHoverImg,background-image)"
			},
			{
				"name": "prevBackgroundImage",
				"property": "background-image",
				"expression": "contrast(@nextFontColor)",
				"defaultValue": "ruleValue(.lsBtnPrevImg,background-image)"
			},
			{
				"name": "prevHoverBackgroundImage",
				"property": "background-image",
				"expression": "contrast(@nextFontColor)",
				"defaultValue": "ruleValue(.lsBtnPrevHoverImg,background-image)"
			},
			{
				"name": "tglFontColor",
				"property": "color",
				"expression": "@fontColor || @tglFontColor"
			},
			{
				"name": "tglBackgroundColor",
				"property": "background-color",
				"expression": "@backgroundColor || @tglBackgroundColor"
			},
			{
				"name": "tglBorderColor",
				"property": "border-color",
				"expression": "@borderColor || @tglBorderColor"
			},
			{
				"name": "tglHoverFontColor",
				"property": "color",
				"expression": "@hoverFontColor"
			},
			{
				"name": "tglHoverBackgroundColor",
				"property": "background-color",
				"expression": "@hoverBackgroundColor"
			},
			{
				"name": "tglHoverBorderColor",
				"property": "border-color",
				"expression": "@hoverBorderColor"
			},
			{
				"name": "tglDFontColor",
				"property": "color",
				"expression": "@tglDFontColor || @selectedFontColor"
			},
			{
				"name": "tglDBackgroundColor",
				"property": "background-color",
				"expression": "@tglDBackgroundColor || @selectedBackgroundColor"
			},
			{
				"name": "tglDBorderColor",
				"property": "border-color",
				"expression": "@tglDBorderColor || @selectedBorderColor"
			},
			{
				"name": "tglDsblFontColor",
				"property": "color",
				"expression": "@disabledFontColor || @tglDsblFontColor"
			},
			{
				"name": "tglDsblBackgroundColor",
				"property": "background-color",
				"expression": "@disabledBackgroundColor || @tglDsblBackgroundColor"
			},
			{
				"name": "tglDsblBorderColor",
				"property": "border-color",
				"expression": "@disabledBorderColor || @tglDsblBorderColor"
			},
			{
				"name": "buttonFontSize",
				"property": "font-size",
				"defaultValue": "themeValue(.lsButton__metadata,buttonFontSize)",
				"docu": "DO NOT CHANGE THIS!"
			},
			{
				"name": "buttonLineHeight",
				"property": "line-height",
				"defaultValue": "themeValue(.lsButton__metadata,buttonLineHeight)",
				"docu": "DO NOT CHANGE THIS!"
			}
		],
		"classes": {
			'.lsButton,.lsButton--hoverable:hover,.lsButton--active:active,.lsToolbar--design-flat @{CustomStyle}.lsButton--design-standard.lsButton--flat-over.lsButton--hoverable': {
				"properties": [
					{
						"name": "background-image",
						"expression": "none"
					}
				]
			},
			'.lsButton--section,.lsToolbar--design-flat @{CustomStyle}.lsButton--section.lsButton--section.lsButton--section,.lsButton .lsButton--content-design,.lsToolbar--design-flat @{CustomStyle}.lsButton.lsButton.lsButton .lsButton--content-design,.lsToolbar--design-flat @{CustomStyle}.lsButton.lsButton--design-standard': {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "none"
					}
				]
			},
			'@{CustomStyle},.lsToolbar--design-flat @{CustomStyle}': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			' .lsButton--content': {
				"properties": [
					{
						"name": "line-height",
						"expression": "~\"calc(@{fontSize} / @{buttonFontSize})\""
					}
				]
			},
			'@{CustomStyle} .lsButton--content': {
				"properties": [
					{
						"name": "line-height",
						"expression": "~\"max(@{buttonLineHeight}, calc(@{fontSize} / @{buttonFontSize}))\""
					}
				]
			},
			'.sapContrast @{CustomStyle} .lsButton--content[style*=\'height:\'] .lsButton--content[style*=\'height:\'], @{CustomStyle} .lsButton--content[style*=\'height:\']': {
				"properties": [
					{
						"name": "line-height",
						"expression": "normal"
					}
				]
			},
			'.lsButton--design-transparent,.lsTbarLarge @{CustomStyle}': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			' .lsButton__text': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			' .lsControl--monospace.lsButton__text': {
				"properties": [
					{
						"name": "font-family",
						"important": true,
						"expression": "@fontFamily"
					}
				]
			},
			'.lsButton--section,.lsToolbar--design-flat @{CustomStyle}.lsButton--section': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle @borderStyle @borderStyle none"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "text-decoration",
						"expression": "none"
					}
				]
			},
			'.lsButton--hoverable.lsButton--design-standard:hover,.lsButton--hoverable.lsButton--design-previous:hover,.lsButton--hoverable.lsButton--design-next:hover,.lsButton--hoverable.lsButton--design-transparent:hover,.sapContrast .lsBtnTransparent.lsButton--up@{CustomStyle}.lsButton--design-standard:hover,.lsToolbar--design-flat @{CustomStyle}.lsButton--hoverable:hover,.lsToolbar--design-flat @{CustomStyle}.lsButton--design-standard.lsButton--flat-over.lsButton--hoverable': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@hoverBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@hoverBorderWidth"
					}
				]
			},
			'.lsButton--hoverable.lsButton--section:hover,.lsToolbar--design-flat @{CustomStyle}.lsButton--hoverable.lsButton--section:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@hoverBorderStyle @hoverBorderStyle @hoverBorderStyle none"
					},
					{
						"name": "border-width",
						"expression": "@hoverBorderWidth"
					}
				]
			},
			'.lsButton--active.lsButton--design-standard:active,.lsButton--active.lsButton--design-next:active,.lsButton--active.lsButton--design-previous:active,.lsButton--active.lsButton--design-transparent:active,.lsToolbar--design-flat @{CustomStyle}.lsButton--active:active': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@selectedFontColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@selectedBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@selectedBorderWidth"
					}
				]
			},
			'.lsButton--active.lsButton--menu-push,.lsButton--active.lsButton--menu-push.lsButton--hoverable:hover,.lsButton--active.lsButton--section:active,.lsButton--active.lsButton--section-push,.lsButton--active.lsButton--hoverable.lsButton--section-push:hover,.lsToolbar--design-flat @{CustomStyle}.lsButton--active.lsButton--section:active': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle @borderStyle @borderStyle none"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "text-decoration",
						"expression": "none"
					},
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsButton--disabled': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@disabledFontColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@disabledBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@disabledBorderWidth"
					},
					{
						"name": "opacity",
						"expression": "@disabledOpacity"
					}
				]
			},
			'.lsButton--section-disabled,.lsToolbar--design-flat @{CustomStyle}.lsButton--section-disabled': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@disabledFontColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					},
					{
						"name": "border-width",
						"expression": "@disabledBorderWidth"
					},
					{
						"name": "border-style",
						"expression": "@disabledBorderStyle @disabledBorderStyle @disabledBorderStyle none"
					},
					{
						"name": "opacity",
						"expression": "@disabledOpacity"
					}
				]
			},
			'.lsToolbar__Header @{CustomStyle}.lsButton--design-standard,.lsToolbar__Header @{CustomStyle}.lsButton--design-next,.lsToolbar__Header @{CustomStyle}.lsButton--design-previous': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					}
				]
			},
			'.lsToolbar__Header @{CustomStyle}.lsButton--hoverable:hover,.lsToolbar__Header .lsButton--root-section:hover .lsButton--hoverable@{CustomStyle},.lsToolbar__Header .lsButton--root-section:hover .lsButton--hoverable.lsButton--section@{CustomStyle}': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					}
				]
			},
			'.lsToolbar__Header @{CustomStyle}.lsButton--active:active,.lsToolbar__Header @{CustomStyle}.lsButton--active.lsButton--menu-push,.lsToolbar__Header @{CustomStyle}.lsButton--active.lsButton--menu-push.lsButton--hoverable:hover,.lsToolbar__Header .lsButton--root-section:active .lsButton--active@{CustomStyle},.lsToolbar__Header @{CustomStyle}.lsButton--active.lsButton--section.lsButton--section-push:active,.lsToolbar__Header @{CustomStyle}.lsButton--active.lsButton--section.lsButton--section-push,.lsToolbar__Header .lsButton--root-section:active .lsButton--active@{CustomStyle}.lsButton--section': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBorderColor"
					},
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsToolbar__Header .lsButton--root-section:active .lsButton--active@{CustomStyle},.lsToolbar__Header .lsButton--root-section:hover .lsButton--active@{CustomStyle}.lsButton--section-push': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBorderColor"
					},
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsTwhlFooter.sapContrast @{CustomStyle},.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--section': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					}
				]
			},
			'.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--hoverable:hover,.lsTwhlFooter.sapContrast .lsButton--root-section:hover .lsButton--hoverable@{CustomStyle},.lsTwhlFooter.sapContrast .lsButton--root-section:hover .lsButton--hoverable.lsButton--section@{CustomStyle}': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					}
				]
			},
			'.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--active:active,.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--active.lsButton--section-push,.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--active.lsButton--menu-push': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBorderColor"
					},
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsTwhlFooter.sapContrast .lsButton--root-section:active .lsButton--active@{CustomStyle},.lsTwhlFooter.sapContrast .lsButton--root-section:hover .lsButton--active@{CustomStyle}.lsButton--section-push': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBorderColor"
					},
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsTwhlFooter.sapContrast @{CustomStyle} .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--hoverable:hover .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--active:active .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsButton--design-emphasized,.lsToolbar--design-flat @{CustomStyle}.lsButton--design-emphasized': {
				"properties": [
					{
						"name": "color",
						"expression": "@emphasizedFontColor"
					},
					{
						"name": "background-color",
						"expression": "@emphasizedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@emphasizedBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@emphasizedBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@emphasizedBorderWidth"
					},
					{
						"name": "text-shadow",
						"expression": "@emphasizedTextShadow"
					}
				]
			},
			'.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--design-emphasized': {
				"properties": [
					{
						"name": "color",
						"expression": "@emphasizedFontColor"
					},
					{
						"name": "background-color",
						"expression": "@emphasizedBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@emphasizedBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@emphasizedBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@emphasizedBorderWidth"
					},
					{
						"name": "text-shadow",
						"expression": "@emphasizedTextShadow"
					}
				]
			},
			'.lsButton--hoverable.lsButton--design-emphasized:hover, .lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--hoverable.lsButton--design-emphasized:hover,.lsToolbar--design-flat @{CustomStyle}.lsButton--hoverable.lsButton--design-emphasized:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@emphasizedHoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@emphasizedHoverFontColor"
					},
					{
						"name": "border-color",
						"expression": "@emphasizedHoverBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@emphasizedHoverBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@emphasizedHoverBorderWidth"
					}
				]
			},
			'.lsButton--disabled.lsButton--design-emphasized,.lsToolbar--design-flat @{CustomStyle}.lsButton--disabled.lsButton--design-emphasized': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@emphasizedDisabledBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@emphasizedDisabledFontColor"
					},
					{
						"name": "border-color",
						"expression": "@emphasizedDisabledBorderColor"
					}
				]
			},
			'.lsButton--active.lsButton--design-emphasized:active,.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--design-emphasized.lsButton--active:active,.lsTwhlFooter.sapContrast .lsButton--down@{CustomStyle}.lsButton--design-emphasized,.lsToolbar--design-flat @{CustomStyle}.lsButton--active.lsButton--design-emphasized:active,.lsToolbar--design-flat @{CustomStyle}.lsButton--down.lsButton--design-emphasized': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@emphasizedSelectedBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@emphasizedSelectedFontColor"
					},
					{
						"name": "border-color",
						"expression": "@emphasizedSelectedBorderColor"
					}
				]
			},
			'.lsButton--design-emphasized .urSvgAppIconColorBase,.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--design-emphasized .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@emphasizedFontColor"
					}
				]
			},
			'.lsButton--design-emphasized.lsButton--hoverable:hover .urSvgAppIconColorBase,.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--design-emphasized.lsButton--hoverable:hover .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@emphasizedHoverFontColor"
					}
				]
			},
			'.lsButton--design-emphasized.lsButton--active:active .urSvgAppIconColorBase,.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--design-emphasized.lsButton--active:active .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@emphasizedSelectedFontColor"
					}
				]
			},
			'.lsButton--disabled.lsButton--design-emphasized  .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@emphasizedDisabledFontColor"
					}
				]
			},
			' .lsBtnPrevImg': {
				"properties": [
					{
						"name": "background-image",
						"expression": "@prevBackgroundImage"
					}
				]
			},
			' .lsBtnPrevHoverImg': {
				"properties": [
					{
						"name": "background-image",
						"expression": "@prevHoverBackgroundImage"
					}
				]
			},
			' .lsBtnNextImg': {
				"properties": [
					{
						"name": "background-image",
						"expression": "@nextBackgroundImage"
					}
				]
			},
			' .lsBtnNextHoverImg': {
				"properties": [
					{
						"name": "background-image",
						"expression": "@nextHoverBackgroundImage"
					}
				]
			},
			'.lsButton--design-toggle,.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--up.lsButton--design-toggle,.lsToolbar--design-flat @{CustomStyle}.lsButton--up.lsButton--design-toggle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@tglBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@tglFontColor"
					},
					{
						"name": "border-color",
						"expression": "@tglBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsButton--hoverable.lsButton--design-toggle:hover,.lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--hoverable.lsButton--design-toggle:hover,.lsToolbar--design-flat @{CustomStyle}.lsButton--hoverable.lsButton--design-toggle:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@tglHoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@tglHoverFontColor"
					},
					{
						"name": "border-color",
						"expression": "@tglHoverBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@hoverBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@hoverBorderWidth"
					}
				]
			},
			'.lsButton--down.lsButton--design-toggle,.lsButton--active.lsButton--design-toggle:active, .lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--down.lsButton--design-toggle, .lsTwhlFooter.sapContrast @{CustomStyle}.lsButton--hoverable.lsButton--down.lsButton--design-toggle:hover,.lsToolbar--design-flat @{CustomStyle}.lsButton--up.lsButton--active.lsButton--design-toggle:active': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@tglDBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@tglDBorderColor"
					},
					{
						"name": "color",
						"expression": "@tglDFontColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@selectedBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@selectedBorderWidth"
					}
				]
			},
			'.lsButton--disabled.lsButton--design-toggle,.lsToolbar--design-flat @{CustomStyle}.lsButton--disabled.lsButton--design-toggle': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@tglDsblBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@tglDsblBorderColor"
					},
					{
						"name": "color",
						"expression": "@tglDsblFontColor"
					}
				]
			},
			'.lsToolbar--design-flat .lsButton--flat-over@{CustomStyle}': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					}
				]
			},
			' .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'.lsButton--hoverable:hover .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsButton--active:active .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@selectedFontColor"
					}
				]
			},
			' .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsButton--hoverable:hover .lsFontIcon': {
				"properties": [
					{
						"name": "fill",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsButton--active:active .lsFontIcon': {
				"properties": [
					{
						"name": "fill",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsToolbar--overflowMenu-opened.lsButton--design-standard,.lsToolbar--overflowMenu-opened.lsButton--design-transparent,.lsToolbar--overflowMenu-opened.lsButton--design-standard.lsButton--hoverable:hover,.lsToolbar--overflowMenu-opened.lsButton--design-transparent.lsButton--hoverable:hover, .lsTwhlFooter.sapContrast @{CustomStyle}.lsToolbar--overflowMenu-opened.lsButton--design-standard, .lsTwhlFooter.sapContrast @{CustomStyle}.lsToolbar--overflowMenu-opened.lsButton--design-standard.lsButton--hoverable:hover': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@selectedFontColor"
					},
					{
						"name": "border-color",
						"expression": "@selectedBorderColor"
					},
					{
						"name": "border-style",
						"important": true,
						"expression": "@selectedBorderStyle"
					},
					{
						"name": "border-width",
						"expression": "@selectedBorderWidth"
					}
				]
			},
			'.lsToolbar--overflowMenu-opened.lsButton--design-standard .urSvgAppIconColorBase, .lsToolbar--overflowMenu-opened.lsButton--design-transparent .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@selectedFontColor"
					}
				]
			},
			' .lsFontIcon,.sapContrast @{CustomStyle} .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsButton--hoverable:hover .lsFontIcon,.sapContrast @{CustomStyle}.lsButton--hoverable:hover .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsButton--active:active .lsFontIcon,.sapContrast @{CustomStyle}.lsButton--active:active .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsButton--disabled .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsButton--disabled .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemtext': {
				"properties": [
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemhotkey': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active)': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active) .lsHierarchicalview__itemhotkey': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active) .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView.lsHierarchicalview__item--isactive:active,.lsHierarchicalview @{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView.lsHierarchicalview__item--active': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					},
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView.lsHierarchicalview__item--isactive:active>td': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView.lsHierarchicalview__item--active:active .lsHierarchicalview__itemhotkey': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView.lsHierarchicalview__item--active:active .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedFontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@selectedFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ToolbarComboBox"] = {
	"name": "ToolbarComboBox",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Behavior": {
			"type": "UCF_ClientInterfaces.E.ComboBoxBehavior",
			"defaultValue": "DROPDOWNSELECT"
		},
		"AllowVirtualTyping": {
			"type": "boolean",
			"defaultValue": true
		},
		"ItemListBoxId": {
			"type": "string",
			"defaultValue": ''
		},
		"Key": {
			"type": "string",
			"defaultValue": ''
		},
		"HasIconColumn": {
			"type": "boolean",
			"defaultValue": false
		},
		"IconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"DisabledIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		},
		"ItemCount": {
			"type": "number",
			"defaultValue": -1
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ShowLabel": {
			"type": "boolean",
			"defaultValue": true
		},
		"LabelText": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"HasShowAlwaysState": {
			"type": "boolean",
			"defaultValue": true
		},
		"Show": {
			"type": "boolean",
			"defaultValue": true
		},
		"LabelFor": {
			"type": "string",
			"defaultValue": ''
		},
		"IMEMode": {
			"type": "UCF_ClientInterfaces.E.IMEMode",
			"defaultValue": "AUTO"
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"MaxLength": {
			"type": "number",
			"defaultValue": 0
		},
		"Align": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.InputFieldType",
			"defaultValue": "STRING"
		},
		"ShowHelpButtonAlways": {
			"type": "boolean",
			"defaultValue": false
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"SuggestFilter": {
			"type": "UCF_ClientInterfaces.E.SuggestFilterType",
			"defaultValue": "OFF"
		},
		"FieldHelp": {
			"type": "UCF_ClientInterfaces.E.InputFieldFieldHelp",
			"defaultValue": "DEFAULT"
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"ShowRequiredIndicator": {
			"type": "boolean",
			"defaultValue": false
		},
		"DisplayAsText": {
			"type": "boolean",
			"defaultValue": false
		},
		"HideFieldHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"InputPrompt": {
			"type": "string",
			"defaultValue": ''
		},
		"Length": {
			"type": "number",
			"defaultValue": 20
		},
		"ShowHelpButton": {
			"type": "boolean",
			"defaultValue": true
		},
		"SuggestAutoComplete": {
			"type": "boolean",
			"defaultValue": false
		},
		"SuggestFilterCondition": {
			"type": "UCF_ClientInterfaces.E.SuggestFilterCondition",
			"defaultValue": "VALUE1_OR_VALUE2"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"ShowClearButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"Priority": {
			"type": "number",
			"defaultValue": 0
		},
		"MinWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"TabBehaviour": {
			"type": "UCF_ClientInterfaces.E.TabBehaviour",
			"defaultValue": "STANDARD"
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"ActionItemActivate": {},
		"Change": {},
		"DeleteItem": {},
		"Select": {},
		"Enter": {},
		"ListAccess": {},
		"Validate": {},
		"FieldHelpPress": {},
		"DoubleClick": {},
		"Activate": {},
		"ClipboardTablePaste": {}
	},
	"publicMethods": [
		"setChanged",
		"open",
		"update",
		"setInputState",
		"setCursorPosition",
		"setSelection",
		"iGetSelectionStart",
		"iGetSelectionEnd",
		"setEnabled",
		"getEnabled",
		"setEditable",
		"getEditable",
		"setRequired",
		"getRequired",
		"setValueState",
		"getValueState",
		"getValue",
		"setValue",
		"getText",
		"setText",
		"setItemListBoxId",
		"setSuggestFilterCondition",
		"createDataTip"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for all ComboBox states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size e.g. px, em"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style e.g. italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration e.g. underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "borderRadius",
				"property": "borderRadius",
				"docu": "Defines the broder radius"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"docu": "Defines the disabled background color of the ComboBox"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "contrast(@disabledBackgroundColor)",
				"docu": "Defines the disabled font color of the ComboBox"
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the disabled font color of the ComboBox"
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "background-color",
				"docu": "Defines the readonly background color of the ComboBox"
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"expression": "contrast(@readonlyBackgroundColor)",
				"docu": "Defines the readonly font color of the ComboBox"
			},
			{
				"name": "readonlyBorderColor",
				"property": "border-color",
				"docu": "Defines the readonly border color of the ComboBox"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color"
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color"
			},
			{
				"name": "hoverColor",
				"property": "color",
				"expression": "@fontColor || contrast(@hoverBackgroundColor)"
			},
			{
				"name": "inputFontSize",
				"property": "font-size",
				"defaultValue": "themeValue(.lsField__metadata,inputFontSize)",
				"docu": "DO NOT CHANGE THIS!"
			},
			{
				"name": "inputBackgroundImage",
				"property": "background-image",
				"defaultValue": "themeValue(.lsField__metadata,backgroundImage)",
				"docu": "DO NOT CHANGE THIS!"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "@inputBackgroundImage"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "font-size",
						"expression": "~\"calc(@{fontSize} / @{inputFontSize})\""
					},
					{
						"name": "outline-color",
						"expression": "contrast(@backgroundColor)"
					},
					{
						"name": "outline-offset",
						"expression": "-@borderWidth - 2px"
					}
				]
			},
			' .lsField__input': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "color",
						"expression": "@fontColor || contrast(@backgroundColor)"
					}
				]
			},
			' .lsField__help,.lsField--hasclear:not(.lsField--hashelp) .lsField__clear': {
				"properties": [
					{
						"name": "border-top-right-radius",
						"expression": "@borderRadius - @borderWidth"
					},
					{
						"name": "border-bottom-right-radius",
						"expression": "@borderRadius - @borderWidth"
					}
				]
			},
			' .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor || contrast(@backgroundColor)"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly)': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly) .lsField__input': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverColor || @fontColor || contrast(@hoverBackgroundColor) || contrast(@backgroundColor)"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly) .lsField__help,.lsField--hover:not(.lsField--readonly)#ls-inputfieldhelpbutton,.lsField--hover:not(.lsField--readonly) .lsField__clear': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@hoverColor || @fontColor || contrast(@hoverBackgroundColor) || contrast(@backgroundColor)"
					}
				]
			},
			'.lsField--disabled': {
				"properties": [
					{
						"name": "opacity",
						"expression": "1"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					},
					{
						"name": "outline-color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsField--disabled .lsField__input,.lsField--disabled .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsField--readonly': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "outline-color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			'.lsField--readonly .lsField__input,.lsField--readonly .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			"Label": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'Label.lsLabel--disabled': {
				"properties": [
					{
						"name": "opacity",
						"expression": "1"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ToolbarInputField"] = {
	"name": "ToolbarInputField",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"MaxLength": {
			"type": "number",
			"defaultValue": 20
		},
		"Length": {
			"type": "number",
			"defaultValue": 20
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false
		},
		"ShowLabel": {
			"type": "boolean",
			"defaultValue": true
		},
		"LabelText": {
			"type": "string",
			"defaultValue": ''
		},
		"HasShowAlwaysState": {
			"type": "boolean",
			"defaultValue": true
		},
		"Show": {
			"type": "boolean",
			"defaultValue": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Align": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"PasswordField": {
			"type": "boolean",
			"defaultValue": false
		},
		"ShowHelpButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"FieldHelp": {
			"type": "UCF_ClientInterfaces.E.InputFieldFieldHelp",
			"defaultValue": "F4LOOKUP"
		},
		"Type": {
			"type": "UCF_ClientInterfaces.E.InputFieldType",
			"defaultValue": "STRING"
		},
		"IMEMode": {
			"type": "UCF_ClientInterfaces.E.IMEMode",
			"defaultValue": "AUTO"
		},
		"AutoComplete": {
			"type": "boolean",
			"defaultValue": false
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"FormatString": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowHelpButtonAlways": {
			"type": "boolean",
			"defaultValue": false
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"DatePickerStartRefId": {
			"type": "string",
			"defaultValue": ''
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.InputDesign",
			"defaultValue": "STANDARD"
		},
		"ShowRequiredIndicator": {
			"type": "boolean",
			"defaultValue": false
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"DisplayAsText": {
			"type": "boolean",
			"defaultValue": false
		},
		"InputPrompt": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"SemanticColor": {
			"type": "UCF_ClientInterfaces.E.SapTableCellDesign",
			"defaultValue": "NONE"
		},
		"ShowClearButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"Priority": {
			"type": "number",
			"defaultValue": 0
		},
		"MinWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Change": {},
		"FieldHelpPress": {},
		"Enter": {},
		"Validate": {},
		"DoubleClick": {},
		"Activate": {},
		"ClipboardTablePaste": {},
		"Spin": {},
		"TabOut": {}
	},
	"publicMethods": [
		"sGetValue",
		"setChanged",
		"setInputState",
		"setCursorPosition",
		"setSelection",
		"iGetSelectionStart",
		"iGetSelectionEnd",
		"getValue",
		"setValue",
		"setEnabled",
		"getEnabled",
		"setEditable",
		"getEditable",
		"setRequired",
		"getRequired",
		"setValueState",
		"getValueState",
		"sGetFormatString",
		"sGetUnformattedValue",
		"createDataTip"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for all InputField states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size e.g. px, em"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style e.g. italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration e.g. underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"docu": "Defines the background color"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style."
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width."
			},
			{
				"name": "borderRadius",
				"property": "borderRadius",
				"docu": "Defines the broder radius"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"docu": "Defines the disabled background color of the InputField"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "contrast(@disabledBackgroundColor)",
				"docu": "Defines the disabled font color of the InputField"
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the disabled font color of the InputField"
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "background-color",
				"docu": "Defines the readonly background color of the InputField"
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"expression": "contrast(@readonlyBackgroundColor)",
				"docu": "Defines the readonly font color of the InputField"
			},
			{
				"name": "readonlyBorderColor",
				"property": "border-color",
				"docu": "Defines the readonly border color of the InputField"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color"
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color"
			},
			{
				"name": "hoverColor",
				"property": "color",
				"expression": "@fontColor || contrast(@hoverBackgroundColor)"
			},
			{
				"name": "inputFontSize",
				"property": "font-size",
				"defaultValue": "themeValue(.lsField__metadata,inputFontSize)",
				"docu": "DO NOT CHANGE THIS!"
			},
			{
				"name": "inputBackgroundImage",
				"property": "background-image",
				"defaultValue": "themeValue(.lsField__metadata,backgroundImage)",
				"docu": "DO NOT CHANGE THIS!"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "@inputBackgroundImage"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"important": true,
						"expression": "@borderWidth"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "font-size",
						"expression": "~\"calc(@{fontSize} / @{inputFontSize})\""
					},
					{
						"name": "outline-color",
						"expression": "contrast(@backgroundColor)"
					},
					{
						"name": "outline-offset",
						"expression": "-@borderWidth - 2px"
					}
				]
			},
			' .lsField__input': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "color",
						"expression": "@fontColor || contrast(@backgroundColor)"
					}
				]
			},
			' .lsField__help,.lsField--hasclear:not(.lsField--hashelp) .lsField__clear': {
				"properties": [
					{
						"name": "border-top-right-radius",
						"expression": "@borderRadius - @borderWidth"
					},
					{
						"name": "border-bottom-right-radius",
						"expression": "@borderRadius - @borderWidth"
					}
				]
			},
			' .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor || contrast(@backgroundColor)"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly)': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly) .lsField__input': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverColor || @fontColor || contrast(@hoverBackgroundColor) || contrast(@backgroundColor)"
					}
				]
			},
			'.lsField--hover:not(.lsField--readonly) .lsField__help,.lsField--hover:not(.lsField--readonly)#ls-inputfieldhelpbutton,.lsField--hover:not(.lsField--readonly) .lsField__clear': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "color",
						"expression": "@hoverColor || @fontColor || contrast(@hoverBackgroundColor) || contrast(@backgroundColor)"
					}
				]
			},
			'.lsField--disabled': {
				"properties": [
					{
						"name": "opacity",
						"expression": "1"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					},
					{
						"name": "outline-color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsField--disabled .lsField__input,.lsField--disabled .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsField--readonly': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "outline-color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			'.lsField--readonly .lsField__input,.lsField--readonly .lsField__help': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			"Label": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'Label.lsLabel--disabled': {
				"properties": [
					{
						"name": "opacity",
						"expression": "1"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ToolbarItem"] = {
	"name": "ToolbarItem",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"HasShowAlwaysState": {
			"type": "boolean",
			"defaultValue": true
		},
		"Show": {
			"type": "boolean",
			"defaultValue": true
		},
		"Priority": {
			"type": "number",
			"defaultValue": 0
		},
		"MinWidth": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["ToolbarLabel"] = {
	"name": "ToolbarLabel",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelFor": {
			"type": "string",
			"defaultValue": ''
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": false
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false
		},
		"Required": {
			"type": "boolean",
			"defaultValue": false
		},
		"RequiredIndicatorTooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Encode": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Size": {
			"type": "UCF_ClientInterfaces.E.LabelSize",
			"defaultValue": "DEFAULT",
			"deprecated": true
		},
		"DesignBar": {
			"type": "UCF_ClientInterfaces.E.LabelDesign",
			"defaultValue": "STANDARD"
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"HasIcon": {
			"type": "boolean",
			"defaultValue": false
		},
		"IconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageFirst": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"LabeledControlName": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.LabelTextDesign",
			"defaultValue": "STANDARD"
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"Escape": {
			"type": "boolean",
			"defaultValue": true,
			"deprecated": true
		},
		"Align": {
			"type": "UCF_ClientInterfaces.E.HorizontalAlign",
			"defaultValue": "LEFT"
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"RequiredIndicatorAtFront": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hidden": {
			"type": "boolean",
			"defaultValue": false
		},
		"ErrorIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"InteractionBehavior": {
			"type": "UCF_ClientInterfaces.E.LabelInteractionBehavior",
			"defaultValue": "REDIRECT_FOCUS"
		},
		"IsNested": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsLink": {
			"type": "boolean",
			"defaultValue": false
		},
		"Editable": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"HasShowAlwaysState": {
			"type": "boolean",
			"defaultValue": true
		},
		"Show": {
			"type": "boolean",
			"defaultValue": true
		},
		"Priority": {
			"type": "number",
			"defaultValue": 0
		},
		"MinWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"DoubleClick": {},
		"Activate": {}
	},
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for all button states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urL,color)",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"defaultValue": "ruleValue(.urL,font-size)"
			},
			{
				"name": "fontStyle",
				"property": "font-style"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration for Label"
			},
			{
				"name": "requiredFontColor",
				"property": "color",
				"defaultValue": "ruleValue(.urLblReq,color)",
				"docu": "Defines the font color for the required symbol"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "greyscale(@fontColor)",
				"docu": "Defines the font color for the required symbol"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"docu": "Defines the font color on mouse over"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"docu": "Defines the background-color on mouse over"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			},
			':hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					}
				]
			},
			' .lsLabel__required': {
				"properties": [
					{
						"name": "color",
						"expression": "@requiredFontColor"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					}
				]
			},
			' .lsLabel__text': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			' .lsLabel__image': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'.lsControl--monospace,.lsControl--monospace .lsLabel__text': {
				"properties": [
					{
						"name": "font-family",
						"important": true,
						"expression": "@fontFamily"
					}
				]
			},
			' .lsLabel__text:hover': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsLabel--disabled,.lsLabel--disabled .lsLabel__text': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			' .lsLabel__text--overflow': {
				"properties": [
					{
						"name": "padding-right",
						"expression": "3px"
					}
				]
			},
			'MultiLine.lsLabel--multiline-ellipsis:after': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemtext': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemicon .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemicon .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ToolbarLink"] = {
	"name": "ToolbarLink",
	"properties": {
		"Target": {
			"type": "string",
			"defaultValue": '_self'
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Reference": {
			"type": "string",
			"defaultValue": ''
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"IsTextLink": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasReference": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasLinkCaption": {
			"type": "boolean",
			"defaultValue": false
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"IsNested": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasShowAlwaysState": {
			"type": "boolean",
			"defaultValue": true
		},
		"Show": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Emphasized": {
			"type": "boolean",
			"defaultValue": false
		},
		"Hotkey": {
			"type": "UCF_ClientInterfaces.E.HotkeyValue",
			"defaultValue": "NONE"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Priority": {
			"type": "number",
			"defaultValue": 0
		},
		"MinWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"Rel": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentVisibility": {
			"type": "UCF_ClientInterfaces.E.ContentVisibility",
			"defaultValue": "ALL"
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"LinkCaption": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Activate": {},
		"DoubleClick": {}
	},
	"publicMethods": [
		"setIconSource",
		"setTooltip",
		"setText",
		"setRel",
		"getRel"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for Link"
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color for Link"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight for Link"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size for Link"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style for Link"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the ftext decoration for Link"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"expression": "@hoverFontColor || @fontColor",
				"docu": "Defines the font color for hovered Link"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "@disabledFontColor || @fontColor",
				"docu": "Defines the font color for disabled Link"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			' .lsLink__text': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			' .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			' .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.urLnkDsbl': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.urLnkDsbl .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'.urLnkDsbl .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			},
			'.urLnk:hover,.urLnk:hover .lsLink__text': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.urLnk:hover .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.urLnk:hover .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemtext': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView:not(.lsHierarchicalview__item--active)': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView:not(.lsHierarchicalview__item--active) .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active)': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active) .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ToolbarLinkChoice"] = {
	"name": "ToolbarLinkChoice",
	"properties": {
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowAccessKey": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageFirst": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageAlt": {
			"type": "string",
			"defaultValue": ''
		},
		"HasShowAlwaysState": {
			"type": "boolean",
			"defaultValue": true
		},
		"Show": {
			"type": "boolean",
			"defaultValue": true
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Priority": {
			"type": "number",
			"defaultValue": 0
		},
		"MinWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentVisibility": {
			"type": "UCF_ClientInterfaces.E.ContentVisibility",
			"defaultValue": "ALL"
		}
	},
	"associations": {
		"PopupMenuId": {
			"type": "string"
		}
	},
	"events": {
		"MenuAccess": {}
	},
	"publicMethods": [
		"openMenu",
		"setPopupMenuId"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for LinkChoice"
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color for LinkChoice"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight for LinkChoice"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size for LinkChoice"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style for LinkChoice"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the ftext decoration for LinkChoice"
			},
			{
				"name": "hoverFontColor",
				"property": "color",
				"expression": "@hoverFontColor || @fontColor",
				"docu": "Defines the font color for hovered LinkChoice"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"expression": "@disabledFontColor || @fontColor",
				"docu": "Defines the font color for disabled LinkChoice"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			' .urSvgAppIconColorBase': {
				"properties": [
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			' .lsFontIcon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.urLnkDsbl': {
				"properties": [
					{
						"name": "color",
						"important": true,
						"expression": "@disabledFontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView .lsHierarchicalview__itemtext': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView:not(:active):not(.lsHierarchicalview__item--active)': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview .lsHierarchicalview__item@{CustomStyle}--hierarchicalView@{CustomStyle}--hierarchicalView:not(:active):not(.lsHierarchicalview__item--active) .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@fontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active)': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					}
				]
			},
			'.lsHierarchicalview @{CustomStyle}--hierarchicalView.lsHierarchicalview__item--hoverable:hover:not(:active):not(.lsHierarchicalview__item--active) .lsHierarchicalview__icon': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverFontColor"
					},
					{
						"name": "fill",
						"important": true,
						"expression": "@hoverFontColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ToolbarSeparator"] = {
	"name": "ToolbarSeparator",
	"properties": {
		"Transparent": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasShowAlwaysState": {
			"type": "boolean",
			"defaultValue": true
		},
		"Show": {
			"type": "boolean",
			"defaultValue": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ItemSeparation": {
			"type": "UCF_ClientInterfaces.E.ToolbarItemSeparation",
			"defaultValue": "LARGEWITHLINE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"styles": {
		"variables": [
			{
				"name": "backgroundColor",
				"property": "background-color",
				"expression": "@backgroundColor"
			}
		],
		"classes": {
			"_default": {
				"properties": [
					{
						"name": "background-image",
						"important": true,
						"expression": "linear-gradient(@backgroundColor,@backgroundColor)"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["TrackSwitch"] = {
	"name": "TrackSwitch",
	"properties": {
		"ForwardConnectId": {
			"type": "string",
			"defaultValue": null
		},
		"BackwardConnectId": {
			"type": "string",
			"defaultValue": null
		}
	}
};

UCF_ClientInterfaces["I"]["Tray"] = {
	"name": "Tray",
	"properties": {
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"Design": {
			"type": "UCF_ClientInterfaces.E.TrayDesign",
			"defaultValue": "TRANSPARENT"
		},
		"Collapsed": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentHeight": {
			"type": "string",
			"defaultValue": ''
		},
		"HasOptionMenu": {
			"type": "boolean",
			"defaultValue": true
		},
		"OptionMenuId": {
			"type": "string",
			"defaultValue": ''
		},
		"HasCloseButton": {
			"type": "boolean",
			"defaultValue": false
		},
		"ScrollingMode": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "NONE"
		},
		"HasTitleCaption": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasToolbar": {
			"type": "boolean",
			"defaultValue": false
		},
		"HasContentPadding": {
			"type": "boolean",
			"defaultValue": true
		},
		"IsCollapsible": {
			"type": "boolean",
			"defaultValue": true
		},
		"AccessibilityDescription": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"DefaultButtonId": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"HotkeysId": {
			"type": "string",
			"defaultValue": ''
		},
		"IsDragHandle": {
			"type": "boolean",
			"defaultValue": false
		},
		"ClientSelect": {
			"type": "boolean",
			"defaultValue": true
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"ARIALandmark": {
			"type": "UCF_ClientInterfaces.E.ARIALandmark",
			"defaultValue": "region"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"OptionMenuDescription": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"TitleCaption": {
			"type": "UCF_ClientInterfaces.I.Caption",
			"multiple": false
		},
		"Toolbar": {
			"type": "UCF_ClientInterfaces.I.Toolbar",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Expand": {},
		"Collapse": {},
		"Close": {},
		"MenuAccess": {},
		"Scroll": {},
		"Hotkey": {}
	},
	"publicMethods": [
		"setDefaultButtonId"
	],
	"styles": {
		"variables": [
			{
				"name": "headerFontFamily",
				"property": "font-family",
				"docu": "Defines the font family for the Tray"
			},
			{
				"name": "headerFontColor",
				"property": "color",
				"expression": "contrast(@headerBackgroundColor)",
				"docu": "Defines the font color"
			},
			{
				"name": "headerFontWeight",
				"property": "font-weight"
			},
			{
				"name": "headerFontSize",
				"property": "font-size"
			},
			{
				"name": "headerFontStyle",
				"property": "font-style"
			},
			{
				"name": "headerTextDecoration",
				"property": "text-decoration"
			},
			{
				"name": "headerTextAlign",
				"property": "text-align"
			},
			{
				"name": "headerBackgroundColor",
				"property": "background-color",
				"expression": "contrast(@headerFontColor) || @backgroundColor"
			},
			{
				"name": "headerBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the header"
			},
			{
				"name": "headerBorderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the header"
			},
			{
				"name": "headerBorderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the header"
			},
			{
				"name": "headerBackgroundImage",
				"property": "background-color",
				"expression": "@headerBackgroundImage || none"
			},
			{
				"name": "backgroundColor",
				"property": "background-color"
			},
			{
				"name": "backgroundImage",
				"property": "background-image",
				"defaultValue": "none"
			},
			{
				"name": "backgroundRepeat",
				"property": "background-repeat",
				"defaultValue": "no-repeat"
			},
			{
				"name": "backgroundSize",
				"property": "background-size",
				"defaultValue": "contain"
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color for the content"
			},
			{
				"name": "borderStyle",
				"property": "border-style",
				"docu": "Defines the border-style for the content"
			},
			{
				"name": "borderWidth",
				"property": "border-width",
				"docu": "Defines the border-width for the content"
			}
		],
		"classes": {
			' .lsTray--header-content': {
				"properties": [
					{
						"name": "background-color",
						"important": true,
						"expression": "@headerBackgroundColor"
					},
					{
						"name": "border-bottom-color",
						"important": true,
						"expression": "@headerBorderColor"
					},
					{
						"name": "border-bottom-style",
						"important": true,
						"expression": "@headerBorderStyle"
					},
					{
						"name": "border-bottom-width",
						"important": true,
						"expression": "@headerBorderWidth"
					},
					{
						"name": "background-image",
						"expression": "@headerBackgroundImage"
					}
				]
			},
			' .lsTray--title-txt': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@headerFontFamily"
					},
					{
						"name": "font-size",
						"expression": "@headerFontSize"
					},
					{
						"name": "font-weight",
						"expression": "@headerFontWeight"
					},
					{
						"name": "font-style",
						"expression": "@headerFontStyle"
					},
					{
						"name": "text-decoration",
						"expression": "@headerTextDecoration"
					},
					{
						"name": "text-align",
						"expression": "@headerTextAlign"
					},
					{
						"name": "color",
						"important": true,
						"expression": "@headerFontColor"
					},
					{
						"name": "background-image",
						"expression": "none"
					}
				]
			},
			"_default": {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "background-image",
						"important": true,
						"expression": "@backgroundImage || none"
					},
					{
						"name": "background-repeat",
						"important": true,
						"expression": "@backgroundRepeat || no-repeat"
					},
					{
						"name": "background-size",
						"important": true,
						"expression": "@backgroundSize || cover"
					}
				]
			},
			' .lsTray--content': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-style",
						"expression": "@borderStyle"
					},
					{
						"name": "border-width",
						"expression": "@borderWidth"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["Tree"] = {
	"name": "Tree",
	"properties": {
		"Title": {
			"type": "string",
			"defaultValue": ''
		},
		"RootNodeIsVisible": {
			"type": "boolean",
			"defaultValue": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"CanCollapseAll": {
			"type": "boolean",
			"defaultValue": true
		},
		"CanExpandAll": {
			"type": "boolean",
			"defaultValue": false
		},
		"Width": {
			"type": "string",
			"defaultValue": ''
		},
		"TitleVisible": {
			"type": "boolean",
			"defaultValue": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"ScrollingMode": {
			"type": "UCF_ClientInterfaces.E.ScrollingMode",
			"defaultValue": "NONE"
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"ScrollTop": {
			"type": "number",
			"defaultValue": 0
		},
		"ScrollLeft": {
			"type": "number",
			"defaultValue": 0
		},
		"DropBug": {
			"type": "boolean",
			"defaultValue": false
		},
		"Background": {
			"type": "UCF_ClientInterfaces.E.TreeBackground",
			"defaultValue": "STANDARD"
		},
		"ClientSelection": {
			"type": "UCF_ClientInterfaces.E.TreeSelectionMode",
			"defaultValue": "NONE"
		},
		"NodeSelectionFollowFocus": {
			"type": "UCF_ClientInterfaces.E.TreeNodeSelectionFollowFocus",
			"defaultValue": "MOUSE"
		},
		"SelectionClientBehaviour": {
			"type": "UCF_ClientInterfaces.E.TreeSelectionClientBehaviour",
			"defaultValue": "SMART"
		},
		"NodeEventProcessing": {
			"type": "UCF_ClientInterfaces.E.TreeNodeEventProcessing",
			"defaultValue": "STANDARD"
		},
		"ReferenceNodeId": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"DropTargetInfo": {
			"type": "string"
		}
	},
	"aggregations": {
		"Root": {
			"type": "UCF_ClientInterfaces.I.TreeNode",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"CollapseAll": {},
		"ExpandAll": {},
		"NodeSelect": {},
		"ClientNodeSelect": {},
		"ClientPrimarySelectionChange": {},
		"NodeDeselect": {},
		"NodeExpand": {},
		"NodeCollapse": {},
		"NodeContextMenu": {},
		"NodeDrop": {},
		"Scroll": {},
		"Drop": {},
		"Drag": {},
		"DoubleClick": {}
	},
	"publicMethods": [
		"collapseAllNodes",
		"expandAllNodes",
		"getSelection",
		"setSelection"
	]
};

UCF_ClientInterfaces["I"]["TreeNode"] = {
	"name": "TreeNode",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Level": {
			"type": "number",
			"defaultValue": 0
		},
		"HasChildren": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsOpen": {
			"type": "boolean",
			"defaultValue": true
		},
		"IsTextNode": {
			"type": "boolean",
			"defaultValue": true
		},
		"IsCaptionNode": {
			"type": "boolean",
			"defaultValue": false
		},
		"IsClickable": {
			"type": "boolean",
			"defaultValue": true
		},
		"HasPopupMenu": {
			"type": "boolean",
			"defaultValue": false
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Selection": {
			"type": "UCF_ClientInterfaces.E.TreeNodeSelection",
			"defaultValue": "NONE"
		},
		"EnabledIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"DisabledIconSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"NodeDesign": {
			"type": "UCF_ClientInterfaces.E.TreeNodeDesign",
			"defaultValue": "STANDARD"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"UserData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"associations": {
		"PopupMenuId": {
			"type": "string"
		},
		"DragSourceInfo": {
			"type": "string"
		},
		"DropTargetInfo": {
			"type": "string"
		}
	},
	"aggregations": {
		"Nodes": {
			"type": "UCF_ClientInterfaces.I.TreeNode",
			"multiple": true,
			"singularName": "Node"
		},
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"publicMethods": [
		"collapse",
		"expand",
		"openPopupMenu",
		"setSelection",
		"getSelection",
		"setDragSourceInfo"
	]
};

UCF_ClientInterfaces["I"]["TimeTrigger"] = {
	"name": "TimeTrigger",
	"properties": {
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Delay": {
			"type": "number",
			"defaultValue": 5
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Trigger": {}
	},
	"publicMethods": [
		"setEnabled"
	]
};

UCF_ClientInterfaces["I"]["TriStateCheckBox"] = {
	"name": "TriStateCheckBox",
	"properties": {
		"Name": {
			"type": "string",
			"defaultValue": ''
		},
		"State": {
			"type": "UCF_ClientInterfaces.E.TriStateCheckBoxState",
			"defaultValue": "UNCHECKED"
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Readonly": {
			"type": "boolean",
			"defaultValue": false
		},
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"IsTextTitle": {
			"type": "boolean",
			"defaultValue": true
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Invalid": {
			"type": "boolean",
			"defaultValue": false,
			"deprecated": true
		},
		"Value": {
			"type": "string",
			"defaultValue": '',
			"deprecated": true
		},
		"TextDirection": {
			"type": "UCF_ClientInterfaces.E.ForcedTextDirection",
			"defaultValue": "INHERIT"
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"ShowHelp": {
			"type": "boolean",
			"defaultValue": false
		},
		"InputState": {
			"type": "UCF_ClientInterfaces.E.InputState",
			"defaultValue": "NONE"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"ShowAccessKey": {
			"type": "boolean",
			"defaultValue": true
		},
		"ImageSrc": {
			"type": "string",
			"defaultValue": ''
		},
		"ImageAlt": {
			"type": "string",
			"defaultValue": ''
		},
		"Arrangement": {
			"type": "UCF_ClientInterfaces.E.CheckBoxArrangement",
			"defaultValue": "CHECKBOXFIRST"
		},
		"UserChoice": {
			"type": "UCF_ClientInterfaces.E.TriStateCheckBoxUserChoice",
			"defaultValue": "TRISTATE"
		},
		"AssociatedEditContext": {
			"type": "UCF_ClientInterfaces.E.EditContext",
			"defaultValue": "PARENTEDITABLE"
		},
		"Wrapping": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextDesign": {
			"type": "UCF_ClientInterfaces.E.CheckBoxTextDesign",
			"defaultValue": "STANDARD"
		},
		"UsedInSapTable": {
			"type": "boolean",
			"defaultValue": false
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomStyle": {
			"type": "string",
			"defaultValue": ''
		},
		"TextOverflow": {
			"type": "boolean",
			"defaultValue": false
		},
		"Height": {
			"type": "string",
			"defaultValue": ''
		},
		"IsTextLabel": {
			"type": "boolean",
			"defaultValue": false
		},
		"TextWidth": {
			"type": "string",
			"defaultValue": ''
		},
		"LabelledBy": {
			"type": "string",
			"defaultValue": ''
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		},
		"VerticalSpacing": {
			"type": "UCF_ClientInterfaces.E.Spacing",
			"defaultValue": "ALIGNED"
		}
	},
	"aggregations": {
		"LabelContent": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Change": {},
		"DoubleClick": {},
		"Enter": {}
	},
	"publicMethods": [
		"setValueState",
		"getValueState",
		"setEnabled",
		"getEnabled",
		"setValue",
		"getValue",
		"setEditable",
		"getEditable",
		"createDataTip"
	],
	"styles": {
		"variables": [
			{
				"name": "fontFamily",
				"property": "font-family",
				"docu": "Defines the font family for all TristateCheckBox states"
			},
			{
				"name": "fontColor",
				"property": "color",
				"docu": "Defines the font color"
			},
			{
				"name": "fontWeight",
				"property": "font-weight",
				"docu": "Defines the font weight"
			},
			{
				"name": "fontSize",
				"property": "font-size",
				"docu": "Defines the font size e.g. px, em"
			},
			{
				"name": "fontStyle",
				"property": "font-style",
				"docu": "Defines the font style e.g. italic"
			},
			{
				"name": "textDecoration",
				"property": "text-decoration",
				"docu": "Defines the text decoration e.g. underline"
			},
			{
				"name": "backgroundColor",
				"property": "background-color",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,backgroundColor)",
				"docu": "Background color within square."
			},
			{
				"name": "borderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "selectedBackgroundColor",
				"property": "background",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,selectedBackgroundColor)",
				"docu": "Color of indeterminate sign."
			},
			{
				"name": "selectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked CheckBox icon"
			},
			{
				"name": "hoverBackgroundColor",
				"property": "background-color",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,hoverBackgroundColor)",
				"docu": "Background color on hover."
			},
			{
				"name": "hoverBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "hoverSelectedBackgroundColor",
				"property": "background",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,hoverSelectedBackgroundColor)",
				"docu": "Color of indeterminate sign on hover."
			},
			{
				"name": "hoverSelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked icon"
			},
			{
				"name": "disabledFontColor",
				"property": "color",
				"docu": "Defines the disabled font color of the text"
			},
			{
				"name": "disabledBackgroundColor",
				"property": "background-color",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,disabledBackgroundColor)",
				"docu": "Disabled background color within square."
			},
			{
				"name": "disabledBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "disabledSelectedBackgroundColor",
				"property": "background",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,disabledSelectedBackgroundColor)",
				"docu": "Color of indeterminate disabled sign."
			},
			{
				"name": "disabledSelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked  icon"
			},
			{
				"name": "readonlyFontColor",
				"property": "color",
				"docu": "Defines the readonly font color of the CheckBox text"
			},
			{
				"name": "readonlyBackgroundColor",
				"property": "background-color",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,readonlyBackgroundColor)",
				"docu": "Background color within read-only square."
			},
			{
				"name": "readonlyBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "readonlySelectedBackgroundColor",
				"property": "background",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,readonlySelectedBackgroundColor)",
				"docu": "Color of indeterminate read-only sign."
			},
			{
				"name": "readonlySelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked icon"
			},
			{
				"name": "errorFontColor",
				"property": "color",
				"docu": "Defines the readonly font color of the CheckBox text"
			},
			{
				"name": "errorBackgroundColor",
				"property": "background-color",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,errorBackgroundColor)",
				"docu": "Background color of square upon error."
			},
			{
				"name": "errorBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "errorSelectedBackgroundColor",
				"property": "background",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,errorSelectedBackgroundColor)",
				"docu": "Color of indeterminate sign upon error."
			},
			{
				"name": "errorSelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked icon"
			},
			{
				"name": "warningFontColor",
				"property": "color",
				"docu": "Defines the readonly font color of the CheckBox text"
			},
			{
				"name": "warningBackgroundColor",
				"property": "background-color",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,warningBackgroundColor)",
				"docu": "Defines the background-color of the icon"
			},
			{
				"name": "warningBorderColor",
				"property": "border-color",
				"docu": "Defines the border-color."
			},
			{
				"name": "warningSelectedBackgroundColor",
				"property": "background",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,warningSelectedBackgroundColor)",
				"docu": "Color of indeterminate sign upon warning."
			},
			{
				"name": "warningSelectedColor",
				"property": "color",
				"docu": "Defines the color for the font-icon of the checked icon"
			},
			{
				"name": "totalSize",
				"property": "width",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,totalSize)"
			},
			{
				"name": "visibleSize",
				"property": "width",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,visibleSize)"
			},
			{
				"name": "borderRadius",
				"property": "width",
				"defaultValue": "themeValue(.lsTristateCheckBox__metaData,borderRadius)"
			}
		],
		"classes": {
			'.lsSelector--generic': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					}
				]
			},
			'.lsCheckBox--unchecked::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--unchecked:hover:before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					}
				]
			},
			'.lsCheckBox--checked::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedColor"
					},
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--checked:hover:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverSelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@hoverBorderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate::before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@borderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate:hover:before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20viewBox%3D%220%200%20@{totalSize}%20@{totalSize}%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20rx%3D%22@{borderRadius}%22%20ry%3D%22@{borderRadius}%22%20fill%3D%22\" escape(~'@{backgroundColor}') ~\"%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20/%3E%3Crect%20x%3D%224%22%20y%3D%224%22%20height%3D%22@{visibleSize}%22%20width%3D%22@{visibleSize}%22%20fill%3D%22\" escape(~'@{selectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsCheckBox--indeterminate:hover': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20viewBox%3D%220%200%20@{totalSize}%20@{totalSize}%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20rx%3D%22@{borderRadius}%22%20ry%3D%22@{borderRadius}%22%20fill%3D%22\" escape(~'@{hoverBackgroundColor}') ~\"%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20/%3E%3Crect%20x%3D%224%22%20y%3D%224%22%20height%3D%22@{visibleSize}%22%20width%3D%22@{visibleSize}%22%20fill%3D%22\" escape(~'@{hoverSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'Dsbl.lsCheckBox--unchecked--disabled::before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					}
				]
			},
			'Dsbl.lsCheckBox--checked--disabled::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledSelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'Dsbl.lsCheckBox--indeterminate--disabled::before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--disabled': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20viewBox%3D%220%200%20@{totalSize}%20@{totalSize}%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20rx%3D%22@{borderRadius}%22%20ry%3D%22@{borderRadius}%22%20fill%3D%22\" escape(~'@{disabledBackgroundColor}') ~\"%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20/%3E%3Crect%20x%3D%224%22%20y%3D%224%22%20height%3D%22@{visibleSize}%22%20width%3D%22@{visibleSize}%22%20fill%3D%22\" escape(~'@{disabledSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'Ro.lsCheckBox--unchecked--readOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'Ro.lsCheckBox--checked--readOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'Ro.lsCheckBox--indeterminate--readOnly::before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--readOnly': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20viewBox%3D%220%200%20@{totalSize}%20@{totalSize}%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20rx%3D%22@{borderRadius}%22%20ry%3D%22@{borderRadius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20/%3E%3Crect%20x%3D%224%22%20y%3D%224%22%20height%3D%22@{visibleSize}%22%20width%3D%22@{visibleSize}%22%20fill%3D%22\" escape(~'@{readonlySelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'Ro.lsCheckBox--unchecked--parentReadOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'Ro.lsCheckBox--checked--parentReadOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'Ro.lsCheckBox--indeterminate--parentReadOnly::before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--parentReadOnly': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20viewBox%3D%220%200%20@{totalSize}%20@{totalSize}%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20rx%3D%22@{borderRadius}%22%20ry%3D%22@{borderRadius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20/%3E%3Crect%20x%3D%224%22%20y%3D%224%22%20height%3D%22@{visibleSize}%22%20width%3D%22@{visibleSize}%22%20fill%3D%22\" escape(~'@{readonlySelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'Warn.lsCheckBox--unchecked--warning::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@warningBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'Warn.lsCheckBox--checked--warning::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningSelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@warningBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'Warn.lsCheckBox--indeterminate--warning::before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--warning': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20viewBox%3D%220%200%20@{totalSize}%20@{totalSize}%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20rx%3D%22@{borderRadius}%22%20ry%3D%22@{borderRadius}%22%20fill%3D%22\" escape(~'@{warningBackgroundColor}') ~\"%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20/%3E%3Crect%20x%3D%224%22%20y%3D%224%22%20height%3D%22@{visibleSize}%22%20width%3D%22@{visibleSize}%22%20fill%3D%22\" escape(~'@{warningSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'Warn.lsCheckBox--unchecked--warning--readOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'WarnRo.lsCheckBox--checked--warning--readOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@redonlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--warning--readOnly::before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--warning--readOnly': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20viewBox%3D%220%200%20@{totalSize}%20@{totalSize}%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20rx%3D%22@{borderRadius}%22%20ry%3D%22@{borderRadius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20/%3E%3Crect%20x%3D%224%22%20y%3D%224%22%20height%3D%22@{visibleSize}%22%20width%3D%22@{visibleSize}%22%20fill%3D%22\" escape(~'@{warningSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'WarnRo.lsCheckBox--unchecked--warning--parentReadOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'WarnRo.lsCheckBox--checked--warning--parentReadOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'WarnRo.lsCheckBox--indeterminate--warning--parentReadOnly::before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--warning--parentReadOnly': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20viewBox%3D%220%200%20@{totalSize}%20@{totalSize}%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20rx%3D%22@{borderRadius}%22%20ry%3D%22@{borderRadius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20/%3E%3Crect%20x%3D%224%22%20y%3D%224%22%20height%3D%22@{visibleSize}%22%20width%3D%22@{visibleSize}%22%20fill%3D%22\" escape(~'@{warningSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'Err.lsCheckBox--unchecked--error::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@errorBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'Err.lsCheckBox--checked--error::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorSelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@errorBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--error::before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--error': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20viewBox%3D%220%200%20@{totalSize}%20@{totalSize}%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20rx%3D%22@{borderRadius}%22%20ry%3D%22@{borderRadius}%22%20fill%3D%22\" escape(~'@{errorBackgroundColor}') ~\"%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20/%3E%3Crect%20x%3D%224%22%20y%3D%224%22%20height%3D%22@{visibleSize}%22%20width%3D%22@{visibleSize}%22%20fill%3D%22\" escape(~'@{errorSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'ErrRo.lsCheckBox--unchecked--error--readOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'ErrRo.lsCheckBox--checked--error--readOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'ErrRo.lsCheckBox--indeterminate--error--readOnly::before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--error--readOnly': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20viewBox%3D%220%200%20@{totalSize}%20@{totalSize}%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20rx%3D%22@{borderRadius}%22%20ry%3D%22@{borderRadius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20/%3E%3Crect%20x%3D%224%22%20y%3D%224%22%20height%3D%22@{visibleSize}%22%20width%3D%22@{visibleSize}%22%20fill%3D%22\" escape(~'@{errorSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'ErrRo.lsCheckBox--unchecked--error--parentReadOnly::before': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'ErrRo.lsCheckBox--checked--error--parentReadOnly::before': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlySelectedColor"
					},
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--error--parentReadOnly::before': {
				"properties": [
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					},
					{
						"name": "border-radius",
						"expression": "@borderRadius"
					}
				]
			},
			'.lsCheckBox--indeterminate--error--parentReadOnly': {
				"properties": [
					{
						"name": "background-image",
						"expression": "~\"url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20viewBox%3D%220%200%20@{totalSize}%20@{totalSize}%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20rx%3D%22@{borderRadius}%22%20ry%3D%22@{borderRadius}%22%20fill%3D%22\" escape(~'@{readonlyBackgroundColor}') ~\"%22%20width%3D%22@{totalSize}%22%20height%3D%22@{totalSize}%22%20/%3E%3Crect%20x%3D%224%22%20y%3D%224%22%20height%3D%22@{visibleSize}%22%20width%3D%22@{visibleSize}%22%20fill%3D%22\" escape(~'@{errorSelectedBackgroundColor}') ~\"%22/%3E%3C/svg%3E')\""
					}
				]
			},
			'.lsSelector--styleHelper': {
				"properties": [
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "text-shadow",
						"expression": "@textShadow"
					}
				]
			},
			'Dsbl .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'Ro .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			'Err .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorFontColor"
					}
				]
			},
			'Warn .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningFontColor"
					}
				]
			},
			'ErrRo .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorReadOnlyFontColor"
					}
				]
			},
			'WarnRo .lsSelector--styleHelper': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningReadOnlyFontColor"
					}
				]
			},
			'.lsControl--monospace': {
				"properties": [
					{
						"name": "font-family",
						"important": true,
						"expression": "@fontFamily"
					}
				]
			},
			' .lsCBStdTxt': {
				"properties": [
					{
						"name": "font-family",
						"expression": "@fontFamily"
					},
					{
						"name": "font-size",
						"expression": "@fontSize"
					},
					{
						"name": "font-weight",
						"expression": "@fontWeight"
					},
					{
						"name": "font-style",
						"expression": "@fontStyle"
					},
					{
						"name": "color",
						"expression": "@fontColor"
					},
					{
						"name": "text-decoration",
						"expression": "@textDecoration"
					},
					{
						"name": "text-shadow",
						"expression": "@textShadow"
					}
				]
			},
			' .lsCBImgStdDef': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@backgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@borderColor"
					}
				]
			},
			' .lsCBImgStdDefHv:hover,.urCLbl:hover .lsCBImgStdDefHv': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@hoverBorderColor"
					}
				]
			},
			' .lsCBImgStdDef .lsTriBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@selectedColor"
					}
				]
			},
			' .lsCBImgStdDef .lsTriBImgInd': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@selectedBackgroundColor"
					}
				]
			},
			' .lsCBImgStdDefHv:hover .lsTriBImgSel:before,.urCLbl:hover .lsCBImgStdDefHv .lsTriBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@hoverSelectedColor"
					}
				]
			},
			' .lsCBImgStdDefHv:hover .lsTriBImgInd,.urCLbl:hover .lsCBImgStdDefHv .lsTriBImgInd': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@hoverSelectedBackgroundColor"
					}
				]
			},
			' .lsCBImgStdErr': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@errorBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@errorBorderColor"
					}
				]
			},
			' .lsCBImgStdErr .lsTriBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorSelectedColor"
					}
				]
			},
			' .lsCBImgStdErr .lsTriBImgInd': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@errorSelectedBackgroundColor"
					}
				]
			},
			'Err .lsCBStdTxt': {
				"properties": [
					{
						"name": "color",
						"expression": "@errorFontColor"
					}
				]
			},
			' .lsCBImgStdInv': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@warningBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@warningBorderColor"
					}
				]
			},
			'Inv .lsCBStdTxt': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningFontColor"
					}
				]
			},
			' .lsCBImgStdInv .lsTriBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@warningSelectedColor"
					}
				]
			},
			' .lsCBImgStdInv .lsTriBImgInd': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@warningSelectedBackgroundColor"
					}
				]
			},
			'Dsbl .lsCBStdTxt': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledFontColor"
					}
				]
			},
			'Ro .lsCBStdTxt, .lsCBImgStdRO .lsTriBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlyFontColor"
					}
				]
			},
			' .lsCBImgDsbl, .lsCBImgStdDsbl': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@disabledBorderColor"
					}
				]
			},
			'Dsbl .lsCBImgStdDef .lsTriBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@disabledSelectedColor"
					}
				]
			},
			'Dsbl .lsCBImgStdDef .lsTriBImgInd': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@disabledSelectedBackgroundColor"
					}
				]
			},
			' .lsCBImgStdRO': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlyBackgroundColor"
					},
					{
						"name": "border-color",
						"expression": "@readonlyBorderColor"
					}
				]
			},
			' .lsCBImgStdRO .lsTriBImgSel:before': {
				"properties": [
					{
						"name": "color",
						"expression": "@readonlySelectedColor"
					}
				]
			},
			' .lsCBImgStdRO .lsTriBImgInd': {
				"properties": [
					{
						"name": "background-color",
						"expression": "@readonlySelectedBackgroundColor"
					}
				]
			}
		}
	}
};

UCF_ClientInterfaces["I"]["ValueComparison"] = {
	"name": "ValueComparison",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"MarkerType": {
			"type": "UCF_ClientInterfaces.E.VCMarkerType",
			"defaultValue": "NEUTRAL"
		},
		"BarColor1": {
			"type": "UCF_ClientInterfaces.E.VCBarColor",
			"defaultValue": "NEUTRAL1"
		},
		"BarColor2": {
			"type": "UCF_ClientInterfaces.E.VCBarColor",
			"defaultValue": "CRITICAL"
		},
		"BarColor3": {
			"type": "UCF_ClientInterfaces.E.VCBarColor",
			"defaultValue": "NEGATIVE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": 'Compares values'
		},
		"MaxWidth": {
			"type": "number",
			"defaultValue": -1
		},
		"BoxWidth": {
			"type": "number",
			"defaultValue": -1
		},
		"BarWidth": {
			"type": "number",
			"defaultValue": -1
		},
		"MarkerPosition": {
			"type": "number",
			"defaultValue": -1
		},
		"ColorChangePoint1": {
			"type": "number",
			"defaultValue": -1
		},
		"ColorChangePoint2": {
			"type": "number",
			"defaultValue": -1
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["VariantManagement"] = {
	"name": "VariantManagement",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"AccessKey": {
			"type": "string",
			"defaultValue": ''
		},
		"Hotkey": {
			"type": "UCF_ClientInterfaces.E.HotkeyValue",
			"defaultValue": "NONE"
		},
		"HeadingLevel": {
			"type": "number",
			"defaultValue": 0
		},
		"Hint": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"events": {
		"Press": {}
	}
};

UCF_ClientInterfaces["I"]["ViewContainer"] = {
	"name": "ViewContainer",
	"properties": {
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Content": {
			"type": "UCF_ClientElement",
			"multiple": false
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	}
};

UCF_ClientInterfaces["I"]["ViewSwitch"] = {
	"name": "ViewSwitch",
	"properties": {
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"Items": {
			"type": "UCF_ClientInterfaces.I.ViewSwitchItem",
			"multiple": true,
			"singularName": "Item"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"Select": {}
	}
};

UCF_ClientInterfaces["I"]["ViewSwitchItem"] = {
	"name": "ViewSwitchItem",
	"properties": {
		"Text": {
			"type": "string",
			"defaultValue": ''
		},
		"Enabled": {
			"type": "boolean",
			"defaultValue": true
		},
		"Selected": {
			"type": "boolean",
			"defaultValue": false
		},
		"IconUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"SelectedIconUrl": {
			"type": "string",
			"defaultValue": ''
		},
		"ViewSwitchIcon": {
			"type": "UCF_ClientInterfaces.E.ViewSwitchIcon",
			"defaultValue": "NONE"
		},
		"Tooltip": {
			"type": "string",
			"defaultValue": ''
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["I"]["WebWidget"] = {
	"name": "WebWidget",
	"properties": {
		"Width": {
			"type": "string",
			"defaultValue": null
		},
		"Height": {
			"type": "string",
			"defaultValue": null
		},
		"Content": {
			"type": "string",
			"defaultValue": ''
		},
		"ContentEnd": {
			"type": "string",
			"defaultValue": ''
		},
		"Load": {
			"type": "string",
			"defaultValue": ''
		},
		"UnLoad": {
			"type": "string",
			"defaultValue": ''
		},
		"Style": {
			"type": "string",
			"defaultValue": ''
		},
		"StyleClass": {
			"type": "string",
			"defaultValue": ''
		},
		"Visibility": {
			"type": "UCF_ClientInterfaces.E.Visibility",
			"defaultValue": "VISIBLE"
		},
		"LifeCycle": {
			"type": "UCF_ClientInterfaces.E.LifeCycle",
			"defaultValue": "BROWSER"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	},
	"aggregations": {
		"ContentItems": {
			"type": "UCF_ClientElement",
			"multiple": true,
			"singularName": "ContentItem",
			"bindable": true
		},
		"Parameters": {
			"type": "UCF_ClientInterfaces.I.WebWidgetParameter",
			"multiple": true,
			"singularName": "Parameter"
		},
		"Scripts": {
			"type": "UCF_ClientInterfaces.I.Script",
			"multiple": true,
			"singularName": "Script"
		},
		"Styles": {
			"type": "UCF_ClientInterfaces.I.Style",
			"multiple": true,
			"singularName": "Style"
		},
		"ListBinding": {
			"type": "UCF_ClientInterfaces.I.ListBinding",
			"bindable": false,
			"multiple": true
		},
		"PropertyBinding": {
			"type": "UCF_ClientInterfaces.I.PropertyBinding",
			"bindable": false,
			"multiple": true
		}
	},
	"events": {
		"ValueChange": {},
		"Action": {}
	},
	"publicMethods": [
		"getPropertyNames",
		"get",
		"set",
		"save",
		"setDragAndDropHandler",
		"setKeepAlive"
	]
};

UCF_ClientInterfaces["I"]["WebWidgetParameter"] = {
	"name": "WebWidgetParameter",
	"properties": {
		"Key": {
			"type": "string",
			"defaultValue": ''
		},
		"Value": {
			"type": "string",
			"defaultValue": ''
		},
		"Listener": {
			"type": "UCF_ClientInterfaces.E.WebWidgetListener",
			"defaultValue": "ALL"
		},
		"CustomData": {
			"type": "string",
			"defaultValue": ''
		}
	}
};

UCF_ClientInterfaces["R"]["AbapList"] = ["Scrollbar","UrBase","CheckBox"];

UCF_ClientInterfaces["R"]["Accordion"] = ["UrBase"];

UCF_ClientInterfaces["R"]["AcfAdapter"] = [];

UCF_ClientInterfaces["R"]["InteractiveForm"] = ["UrBase","TrackSwitch"];

UCF_ClientInterfaces["R"]["InteractiveFormAbap"] = ["UrBase","TrackSwitch"];

UCF_ClientInterfaces["R"]["ActiveXContainer"] = ["UrBase","TrackSwitch"];

UCF_ClientInterfaces["R"]["Animation"] = [];

UCF_ClientInterfaces["R"]["AppletContainer"] = ["UrBase","TrackSwitch"];

UCF_ClientInterfaces["R"]["AriaStatic"] = [];

UCF_ClientInterfaces["R"]["BarcodeReader"] = ["Iframe"];

UCF_ClientInterfaces["R"]["FeatureFlags"] = [];

UCF_ClientInterfaces["R"]["GeneratorTest"] = [];

UCF_ClientInterfaces["R"]["IconBase"] = ["IconBase"];

UCF_ClientInterfaces["R"]["System"] = [];

UCF_ClientInterfaces["R"]["UrBase"] = ["UrBase","IconBase"];

UCF_ClientInterfaces["R"]["BiApplicationFrame"] = ["UrBase","TrackSwitch"];

UCF_ClientInterfaces["R"]["BIReportStyles"] = [];

UCF_ClientInterfaces["R"]["BreadCrumb"] = ["UrBase"];

UCF_ClientInterfaces["R"]["Button"] = ["UrBase","IconBase","ToolbarButton","Label"];

UCF_ClientInterfaces["R"]["DefaultButton"] = [];

UCF_ClientInterfaces["R"]["ButtonRow"] = ["UrBase"];

UCF_ClientInterfaces["R"]["CalendarDayView"] = ["UrBase","Legend"];

UCF_ClientInterfaces["R"]["CalendarEntry"] = [];

UCF_ClientInterfaces["R"]["CalendarMonthView"] = ["UrBase","Legend"];

UCF_ClientInterfaces["R"]["CalendarYearView"] = ["UrBase","Legend"];

UCF_ClientInterfaces["R"]["Caption"] = ["UrBase"];

UCF_ClientInterfaces["R"]["Carousel"] = ["UrBase","Button"];

UCF_ClientInterfaces["R"]["Chart"] = ["Script","TrackSwitch"];

UCF_ClientInterfaces["R"]["VizFrame"] = ["Script","TrackSwitch"];

UCF_ClientInterfaces["R"]["CheckBox"] = ["UrBase","CheckBox"];

UCF_ClientInterfaces["R"]["CheckBoxGroup"] = ["UrBase"];

UCF_ClientInterfaces["R"]["ClientInspector"] = [];

UCF_ClientInterfaces["R"]["ColorPalette"] = [];

UCF_ClientInterfaces["R"]["ColorItem"] = ["UrBase"];

UCF_ClientInterfaces["R"]["ColumnLayout"] = ["UrBase"];

UCF_ClientInterfaces["R"]["ComboBox"] = ["UrBase","InputField","HierarchicalView","ToolbarComboBox"];

UCF_ClientInterfaces["R"]["ComboBoxListBox"] = ["ItemListBox"];

UCF_ClientInterfaces["R"]["Container"] = [];

UCF_ClientInterfaces["R"]["ContentArea"] = ["UrBase","Toolbar","ContentArea","ScrollContainer"];

UCF_ClientInterfaces["R"]["ContextualPanel"] = [];

UCF_ClientInterfaces["R"]["CSSGrid"] = [];

UCF_ClientInterfaces["R"]["CSSGridItem"] = [];

UCF_ClientInterfaces["R"]["DataGrid"] = ["Scrollbar","DataGridSegment","Legend"];

UCF_ClientInterfaces["R"]["DataGridSegment"] = [];

UCF_ClientInterfaces["R"]["DataGridSegmentCell"] = [];

UCF_ClientInterfaces["R"]["DataTip"] = [];

UCF_ClientInterfaces["R"]["DateNavigator"] = ["UrBase","Legend"];

UCF_ClientInterfaces["R"]["DTContainer"] = [];

UCF_ClientInterfaces["R"]["DTElement"] = [];

UCF_ClientInterfaces["R"]["DropTarget"] = [];

UCF_ClientInterfaces["R"]["DragSourceInfo"] = [];

UCF_ClientInterfaces["R"]["DropTargetInfo"] = [];

UCF_ClientInterfaces["R"]["FileUpload"] = ["UrBase"];

UCF_ClientInterfaces["R"]["FlashContainer"] = ["UrBase","TrackSwitch"];

UCF_ClientInterfaces["R"]["FlowLayout"] = ["UrBase"];

UCF_ClientInterfaces["R"]["FluidLayoutContainer"] = ["UrBase"];

UCF_ClientInterfaces["R"]["FocusRect"] = [];

UCF_ClientInterfaces["R"]["Form"] = ["InputField"];

UCF_ClientInterfaces["R"]["FreeContextualArea"] = [];

UCF_ClientInterfaces["R"]["GeoMap"] = ["UrBase"];

UCF_ClientInterfaces["R"]["GridLayout"] = ["RasterLayout","UrBase","Legend"];

UCF_ClientInterfaces["R"]["Group"] = ["UrBase","ScrollContainer","Toolbar"];

UCF_ClientInterfaces["R"]["HeaderArea"] = ["UrBase","Button","Toolbar"];

UCF_ClientInterfaces["R"]["HierarchicalView"] = ["HierarchicalViewItem","ComboBox","InputField","Label","ToolbarComboBox","ToolbarInputField"];

UCF_ClientInterfaces["R"]["HierarchicalViewItem"] = ["UrBase"];

UCF_ClientInterfaces["R"]["HorizontalContextualPanel"] = ["UrBase"];

UCF_ClientInterfaces["R"]["HorizontalDivider"] = ["UrBase"];

UCF_ClientInterfaces["R"]["Hotkeys"] = [];

UCF_ClientInterfaces["R"]["HtmlFragment"] = [];

UCF_ClientInterfaces["R"]["HtmlIsland"] = ["UrBase","Script","TrackSwitch"];

UCF_ClientInterfaces["R"]["Iframe"] = ["UrBase","TrackSwitch"];

UCF_ClientInterfaces["R"]["Image"] = ["UrBase","IconBase"];

UCF_ClientInterfaces["R"]["ImageMap"] = [];

UCF_ClientInterfaces["R"]["InputField"] = ["UrBase","InputField","ToolbarInputField","HierarchicalView"];

UCF_ClientInterfaces["R"]["InputTokenizer"] = ["InputField","UrBase"];

UCF_ClientInterfaces["R"]["Token"] = [];

UCF_ClientInterfaces["R"]["Tokenizer"] = ["UrBase","Token","ComboBox"];

UCF_ClientInterfaces["R"]["Invisible"] = [];

UCF_ClientInterfaces["R"]["ItemList"] = ["UrBase"];

UCF_ClientInterfaces["R"]["ItemListBox"] = ["ComboBoxListBox","UrBase"];

UCF_ClientInterfaces["R"]["Label"] = ["UrBase","ToolbarLabel"];

UCF_ClientInterfaces["R"]["LargeButton"] = ["UrBase"];

UCF_ClientInterfaces["R"]["Legend"] = ["UrBase"];

UCF_ClientInterfaces["R"]["Link"] = ["UrBase","ToolbarLink"];

UCF_ClientInterfaces["R"]["LinkChoice"] = ["UrBase","Link","ToolbarLinkChoice"];

UCF_ClientInterfaces["R"]["LoadingAnimation"] = ["FeatureFlags"];

UCF_ClientInterfaces["R"]["MatrixLayout"] = ["RasterLayout","UrBase"];

UCF_ClientInterfaces["R"]["MeltingGroup"] = ["UrBase","SapTableCell","Legend"];

UCF_ClientInterfaces["R"]["MenuBar"] = ["UrBase"];

UCF_ClientInterfaces["R"]["MessageArea"] = [];

UCF_ClientInterfaces["R"]["MessageBar"] = ["UrBase"];

UCF_ClientInterfaces["R"]["MessageToast"] = [];

UCF_ClientInterfaces["R"]["ModelControl"] = [];

UCF_ClientInterfaces["R"]["MultiComboBox"] = ["UrBase"];

UCF_ClientInterfaces["R"]["NavigationList"] = ["FreeContextualArea","UrBase"];

UCF_ClientInterfaces["R"]["ObjectContainer"] = ["ObjectHeader"];

UCF_ClientInterfaces["R"]["ObjectHeader"] = [];

UCF_ClientInterfaces["R"]["ObjectNavigation"] = [];

UCF_ClientInterfaces["R"]["ObjectNavigationItem"] = [];

UCF_ClientInterfaces["R"]["DeltaUpdate"] = [];

UCF_ClientInterfaces["R"]["FullUpdate"] = [];

UCF_ClientInterfaces["R"]["IHub"] = [];

UCF_ClientInterfaces["R"]["IHubEventing"] = [];

UCF_ClientInterfaces["R"]["IHubFrameProtect"] = [];

UCF_ClientInterfaces["R"]["IHubLegacyWDJ"] = [];

UCF_ClientInterfaces["R"]["IHubMessaging"] = [];

UCF_ClientInterfaces["R"]["IHubNavigation"] = [];

UCF_ClientInterfaces["R"]["IHubPostMessage"] = [];

UCF_ClientInterfaces["R"]["IHubWebSocketPcp"] = [];

UCF_ClientInterfaces["R"]["IHubWorkProtect"] = [];

UCF_ClientInterfaces["R"]["LinkedResource"] = [];

UCF_ClientInterfaces["R"]["LoadingPlaceHolder"] = [];

UCF_ClientInterfaces["R"]["MessagingTrigger"] = [];

UCF_ClientInterfaces["R"]["Meta"] = [];

UCF_ClientInterfaces["R"]["Page"] = ["FeatureFlags","Style","Script","PageUpdate","AriaStatic"];

UCF_ClientInterfaces["R"]["PageScriptInclude"] = ["Script"];

UCF_ClientInterfaces["R"]["PageStyleInclude"] = [];

UCF_ClientInterfaces["R"]["PageUpdate"] = [];

UCF_ClientInterfaces["R"]["PMServiceDirty"] = [];

UCF_ClientInterfaces["R"]["PMServiceGenericResponder"] = [];

UCF_ClientInterfaces["R"]["PMServiceStatefulContainer"] = [];

UCF_ClientInterfaces["R"]["PMServiceThemeChange"] = [];

UCF_ClientInterfaces["R"]["PMServiceTimeout"] = [];

UCF_ClientInterfaces["R"]["PMServiceUShellSessionHandler"] = [];

UCF_ClientInterfaces["R"]["PMServiceWebAssistant"] = [];

UCF_ClientInterfaces["R"]["PostMessageService"] = [];

UCF_ClientInterfaces["R"]["PostMessageServices"] = [];

UCF_ClientInterfaces["R"]["PostMessageTreatment"] = [];

UCF_ClientInterfaces["R"]["PostMessageTreatments"] = [];

UCF_ClientInterfaces["R"]["Script"] = ["Script"];

UCF_ClientInterfaces["R"]["Style"] = [];

UCF_ClientInterfaces["R"]["PageHeader"] = ["UrBase","PageHeaderTitle"];

UCF_ClientInterfaces["R"]["PageHeaderTitle"] = [];

UCF_ClientInterfaces["R"]["PageLayout"] = ["PageLayoutPanel"];

UCF_ClientInterfaces["R"]["PageLayoutPanel"] = ["PageLayout"];

UCF_ClientInterfaces["R"]["Pager"] = ["UrBase"];

UCF_ClientInterfaces["R"]["Paginator"] = ["UrBase"];

UCF_ClientInterfaces["R"]["Panel"] = ["UrBase","HeaderArea","ContentArea"];

UCF_ClientInterfaces["R"]["PanelStack"] = ["UrBase","HeaderArea","ContentArea"];

UCF_ClientInterfaces["R"]["PatternContainerContentItem"] = [];

UCF_ClientInterfaces["R"]["PatternContainerIconButton"] = [];

UCF_ClientInterfaces["R"]["PatternContainerSequence"] = ["UrBase"];

UCF_ClientInterfaces["R"]["PatternContainerTab"] = ["UrBase"];

UCF_ClientInterfaces["R"]["PatternContainerTitle"] = ["UrBase"];

UCF_ClientInterfaces["R"]["PDFContainer"] = ["UrBase","TrackSwitch"];

UCF_ClientInterfaces["R"]["PersonasFacade"] = [];

UCF_ClientInterfaces["R"]["PhaseIndicator"] = ["UrBase"];

UCF_ClientInterfaces["R"]["PopIn"] = ["UrBase"];

UCF_ClientInterfaces["R"]["TextBar"] = ["UrBase"];

UCF_ClientInterfaces["R"]["PopoverContainer"] = [];

UCF_ClientInterfaces["R"]["PopupMenu"] = ["UrBase"];

UCF_ClientInterfaces["R"]["PopupTrigger"] = ["UrBase"];

UCF_ClientInterfaces["R"]["PopupWindow"] = ["FeatureFlags","UrBase"];

UCF_ClientInterfaces["R"]["ProgressIndicator"] = ["UrBase"];

UCF_ClientInterfaces["R"]["QuickView"] = ["TrackSwitch"];

UCF_ClientInterfaces["R"]["RadioButton"] = ["CheckBox","UrBase"];

UCF_ClientInterfaces["R"]["RadioButtonGroup"] = ["UrBase"];

UCF_ClientInterfaces["R"]["RasterLayout"] = ["UrBase","Legend"];

UCF_ClientInterfaces["R"]["RatingIndicator"] = ["UrBase"];

UCF_ClientInterfaces["R"]["RichTooltip"] = ["UrBase"];

UCF_ClientInterfaces["R"]["RoadMap"] = ["UrBase"];

UCF_ClientInterfaces["R"]["SapTable"] = ["UrBase","SapTable","HeaderArea","Scrollbar","SapTableCell","SapTableHeaderCell","SapTableHierarchicalCell","SapTableSelectionCell","Legend"];

UCF_ClientInterfaces["R"]["SapTableCell"] = ["UrBase","SapTableCell"];

UCF_ClientInterfaces["R"]["SapTableCS"] = ["UrBase","SapTable","SapTableCS","HeaderArea","Scrollbar","SapTableHierarchicalCell","SapTableCell","SapTableHeaderCell","SapTableSelectionCell"];

UCF_ClientInterfaces["R"]["SapTableDefaultBody"] = [];

UCF_ClientInterfaces["R"]["SapTableHeaderCell"] = ["SapTableCell","UrBase"];

UCF_ClientInterfaces["R"]["SapTableHierarchicalCell"] = ["UrBase","SapTableCell"];

UCF_ClientInterfaces["R"]["SapTableMatrixCell"] = ["SapTableCell"];

UCF_ClientInterfaces["R"]["SapTableRow"] = [];

UCF_ClientInterfaces["R"]["SapTableSelectionCell"] = ["SapTableCell","SapTableSelectionCell"];

UCF_ClientInterfaces["R"]["Scrollbar"] = [];

UCF_ClientInterfaces["R"]["ScrollContainer"] = ["UrBase"];

UCF_ClientInterfaces["R"]["SectionHeader"] = ["UrBase"];

UCF_ClientInterfaces["R"]["SegmentedButton"] = ["UrBase","Button"];

UCF_ClientInterfaces["R"]["Shuttle"] = ["UrBase"];

UCF_ClientInterfaces["R"]["SidePopup"] = [];

UCF_ClientInterfaces["R"]["SilverlightContainer"] = ["UrBase","TrackSwitch"];

UCF_ClientInterfaces["R"]["SingleColumnLayout"] = ["UrBase","RasterLayout"];

UCF_ClientInterfaces["R"]["Splitter"] = ["FeatureFlags","SplitterCell","SplitterCol","SplitterRow"];

UCF_ClientInterfaces["R"]["SplitterCell"] = ["ScrollContainer","Splitter"];

UCF_ClientInterfaces["R"]["SplitterCol"] = ["Splitter"];

UCF_ClientInterfaces["R"]["SplitterRow"] = ["Splitter"];

UCF_ClientInterfaces["R"]["StickyNote"] = ["UrBase","FormattedTextView"];

UCF_ClientInterfaces["R"]["Switch"] = ["CheckBox","UrBase"];

UCF_ClientInterfaces["R"]["SwitchGroup"] = ["UrBase"];

UCF_ClientInterfaces["R"]["TabStrip"] = ["UrBase","FeatureFlags","ContentArea","ScrollContainer"];

UCF_ClientInterfaces["R"]["TagCloud"] = ["UrBase"];

UCF_ClientInterfaces["R"]["TagCloudItem"] = ["UrBase"];

UCF_ClientInterfaces["R"]["RichTextEdit"] = [];

UCF_ClientInterfaces["R"]["TextEdit"] = ["UrBase","TextView"];

UCF_ClientInterfaces["R"]["FormattedTextView"] = ["UrBase"];

UCF_ClientInterfaces["R"]["HTMLTextView"] = ["UrBase","TextView"];

UCF_ClientInterfaces["R"]["TextView"] = ["UrBase"];

UCF_ClientInterfaces["R"]["ThresholdSlider"] = [];

UCF_ClientInterfaces["R"]["TileLayout"] = [];

UCF_ClientInterfaces["R"]["ToggleLink"] = ["UrBase"];

UCF_ClientInterfaces["R"]["Toolbar"] = ["UrBase","ToolbarInputField","ToolbarLabel","ToolbarComboBox","Button","Link","LinkChoice","InputField","ComboBox","Label","ToolbarButton","ToolbarLink","ToolbarLinkChoice","ToolbarSeparator","ToolbarItem","Toolbar"];

UCF_ClientInterfaces["R"]["ToolbarButton"] = ["UrBase","Button"];

UCF_ClientInterfaces["R"]["ToolbarComboBox"] = ["ComboBox","UrBase","ToolbarLabel","HierarchicalView"];

UCF_ClientInterfaces["R"]["ToolbarInputField"] = ["UrBase","ToolbarLabel","InputField","HierarchicalView"];

UCF_ClientInterfaces["R"]["ToolbarItem"] = ["UrBase"];

UCF_ClientInterfaces["R"]["ToolbarLabel"] = ["UrBase","Label"];

UCF_ClientInterfaces["R"]["ToolbarLink"] = ["UrBase","Link"];

UCF_ClientInterfaces["R"]["ToolbarLinkChoice"] = ["UrBase","LinkChoice"];

UCF_ClientInterfaces["R"]["ToolbarSeparator"] = ["UrBase"];

UCF_ClientInterfaces["R"]["TrackSwitch"] = [];

UCF_ClientInterfaces["R"]["Tray"] = ["UrBase","Toolbar","ScrollContainer"];

UCF_ClientInterfaces["R"]["Tree"] = ["UrBase"];

UCF_ClientInterfaces["R"]["TimeTrigger"] = [];

UCF_ClientInterfaces["R"]["TriStateCheckBox"] = ["UrBase","CheckBox"];

UCF_ClientInterfaces["R"]["ValueComparison"] = ["UrBase"];

UCF_ClientInterfaces["R"]["VariantManagement"] = ["UrBase"];

UCF_ClientInterfaces["R"]["ViewContainer"] = ["UrBase"];

UCF_ClientInterfaces["R"]["ViewSwitch"] = ["UrBase"];

UCF_ClientInterfaces["R"]["WebWidget"] = ["UrBase","TrackSwitch"];

UCF_ClientInterfaces["IMPL"] = {
	"UCF_ClientAccordion": true,
	"UCF_ClientButton": true,
	"UCF_ClientDataGrid": true,
	"UCF_ClientDataGridColumn": true,
	"UCF_ClientDataGridRow": true,
	"UCF_ClientDataGridSegment": true,
	"UCF_ClientDataGridSegmentCell": true,
	"UCF_ClientDataGridSegmentColumn": true,
	"UCF_ClientDataGridSegmentRow": true,
	"UCF_ClientDecorator": true,
	"UCF_ClientDTContainer": true,
	"UCF_ClientDTElement": true,
	"UCF_ClientInputField": true,
	"UCF_ClientLink": true,
	"UCF_ClientMessageArea": true,
	"UCF_ClientPanel": true,
	"UCF_ClientProgressIndicator": true,
	"UCF_ClientRadioButton": true,
	"UCF_ClientRasterLayoutItem": true,
	"UCF_ClientSapTableCS": true,
	"UCF_ClientSapTableHeaderCell": true,
	"UCF_ClientStickyNote": true,
	"UCF_ClientTextView": true,
	"UCF_ClientToolbar": true,
	"UCF_ClientToolbarComboBox": true,
	"UCF_ClientToolbarInputField": true
};


};
sap["ls"]["preload"]["UCF_ClientLink"] = function() { var UCF_ClientLink = window["UCF_ClientLink"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientLink"); UCF_ClientLink["_"] = {UCF_ClientLink: 0}; };/* global UCF_ClientLink */

UCF_ClientLink["prototype"]["setText"] = function(sText, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientLink["_"]["setText"]++; }; 
	var oUCFLink = this["getUCFInstance"]();

	if (oUCFLink) {
		if (oUCFLink["sGetTitle"]() !== sText) {
			this["setProperty"]("Text", sText, true);
			oUCFLink["setText"](this["getProperty"]("Text"));

			return;
		}
	}
	this["setProperty"]("Text", sText, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientLink["_"]["setText"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientMessageArea"] = function() { var UCF_ClientMessageArea = window["UCF_ClientMessageArea"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientMessageArea"); UCF_ClientMessageArea["_"] = {UCF_ClientMessageArea: 0}; };/* global UCF_ClientMessageArea */
UCF_ClientMessageArea["prototype"]["getVisibleRange"] = function(sName, oBinding) {;if (__UCF_COVERAGE__) { UCF_ClientMessageArea["_"]["getVisibleRange"]++; }; 
	if (sName == "Messages") {
		var iMessageCount = this["getMessageCount"]();
		oBinding = this["getBinding"](sName);

		if (oBinding) {
			return { "iStart": 0, "iEnd": (iMessageCount - 1) };
		}
		return {};
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ClientMessageArea["_"]["getVisibleRange"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientPanel"] = function() { var UCF_ClientPanel = window["UCF_ClientPanel"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientPanel"); UCF_ClientPanel["_"] = {UCF_ClientPanel: 0}; };/* global UCF_ClientPanel, UCF_ClientElement, UCF_ClientControl, UCF_ClientPanelStack */
UCF_ClientPanel["prototype"]["render"] = function(bTimer) {;if (__UCF_COVERAGE__) { UCF_ClientPanel["_"]["render"]++; }; 
	if (this["getParent"]() &&
			typeof UCF_ClientPanelStack !== 'undefined' &&
			this["getParent"]() instanceof UCF_ClientPanelStack
	) {
		UCF_ClientElement["prototype"]["render"]["apply"](this);
	} else {
		UCF_ClientControl["prototype"]["render"]["apply"](this, [bTimer]);
	}
};;if (__UCF_COVERAGE__) { UCF_ClientPanel["_"]["render"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientPopupMenuHelper"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_ClientControlTree */
/// <reference path="../core/ClientControlTree.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * A helper class to create PopupMenu instances on the client, e.g. for 'overflow menu' feature of Toolbar and PanelStack.
 * This is a replacement for calling the PopupMenuFragment in the renderer and using the (deprecated) PopupMenu.addItem() API call.
 * Note: In production code the menu must always be rendered in the Page assoc-area (instead of the normal DOM inside a layout, etc.)
 * @param {UCF_LS} oLS The LS instance
 * @class
 * @example <caption>Usage example</caption>
 *  var oMenuHlp = new UCF_ClientPopupMenuHelper(this.oLS);
 *  this.oPopupMenu = oMenuHlp.oRenderMenu('id', [
 * 		{ PopupMenuItem: { Id: 'item1', ... } },
 * 		...
 * 	]);
 *  this.oPopupMenu.setOpenerRef(...);
 *  this.oPopupMenu.attachEvent(...)
 *  this.oPopupMenu.open();
 *  // destroy() implementation ...
 *  UCF_ClientPopupMenuHelper.handleDestroy(this.oPopupMenu);
 *  this.oPopupMenu = null;
 */
function UCF_ClientPopupMenuHelper(oLS) {if (__UCF_COVERAGE__) { UCF_ClientPopupMenuHelper["_"]["UCF_ClientPopupMenuHelper"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ClientPopupMenuHelper.js(32): UCF_ClientPopupMenuHelper"); };
	this["oLS"] = oLS; // eslint-disable-line @ur/no-memory-leaks
	UCF_Object["apply"](this);

	/** @type {UCF_ClientPopupMenu} */
	this["oMenu"] = null; // eslint-disable-line @ur/no-memory-leaks
};window["UCF_ClientPopupMenuHelper"] = UCF_ClientPopupMenuHelper; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientPopupMenuHelper"); UCF_ClientPopupMenuHelper["_"] = {UCF_ClientPopupMenuHelper: 0}; }; ;
UCF_ClientPopupMenuHelper["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_ClientPopupMenuHelper.prototype["sClassName"] = "UCF_ClientPopupMenuHelper";

/**
 * Renders a PopupMenu with the given items. Paramaters: MaxVisibleItems=20
 * The client-side rendering is triggered synchronously, so the initialized UCF-instance is available
 * as return value.
 * @param {string} sControlId The control ID to use
 * @param {HTMLElement} [oParentDomRef] Optional DOM location of the menu control.
 * In production code the Page assoc-area must be used, which is the default.
 * @param {Array} aItems The PopupMenu.Items aggregation in JSON format
 * @return {UCF_PopupMenu} The PopupMenu UCF-instance
 * @public
 */
UCF_ClientPopupMenuHelper["prototype"]["oRenderMenu"] = function(sControlId, oParentDomRef, aItems) {;if (__UCF_COVERAGE__) { UCF_ClientPopupMenuHelper["_"]["oRenderMenu"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sControlId) === 'string', "typeof(sControlId) === 'string'", "ClientPopupMenuHelper.js(53): oRenderMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bIsArray"](aItems), "UCF_JsUtil.bIsArray(aItems)", "ClientPopupMenuHelper.js(54): oRenderMenu"); };

	oParentDomRef = oParentDomRef || this["oLS"]["oGetAssociatedAreaRef"]();
	this["oMenu"] = this["oLS"]["oGetClientControlById"](sControlId);
	if (this["oMenu"]) {
		this["oMenu"]["getUCFInstance"]()["destroy"](); // destroy UCF isntance
		this["oMenu"]["destroy"](); // remove from DOM
	}
	this["oMenu"] = this["oLS"]["oCreateClientControl"]({ "PopupMenu": { "Id": sControlId, "MaxVisibleItems": 20, "Items": aItems } });

	// Note: placeAt() calls UCF_CLientControl.replace() which is (re-)rendering the control synchronously
	// when it is already invalidated (which is the case because we modified the Items aggregation before)
	this["oMenu"]["placeAt"](oParentDomRef);
	return this["oLS"]["oControlFactory"]["oGetControlById"](sControlId);
};;if (__UCF_COVERAGE__) { UCF_ClientPopupMenuHelper["_"]["oRenderMenu"] = 0; };

/**
 * Reuses the menu created by oRenderMenu() and updates the Items aggregation.
 * The client-side rendering is triggered asynchronously ("delayed").
 * @param {Array} aItems The PopupMenu.Items aggregation in JSON format
 * @public
 */
UCF_ClientPopupMenuHelper["prototype"]["replaceItems"] = function(aItems) {;if (__UCF_COVERAGE__) { UCF_ClientPopupMenuHelper["_"]["replaceItems"]++; }; 
	this["oMenu"]["clearItems"]();
	for (var i = 0; i < aItems["length"]; i++) {
		this["oMenu"]["addItem"](this["oLS"]["oCreateClientControl"](aItems[i]));
	}
};;if (__UCF_COVERAGE__) { UCF_ClientPopupMenuHelper["_"]["replaceItems"] = 0; };

/**
 * Handle destroy of the control implementation
 * @param {UCF_Control} oMenu The menu instance (return value of oRenderMenu())
 */
UCF_ClientPopupMenuHelper["handleDestroy"] = function(oMenu) {;if (__UCF_COVERAGE__) { UCF_ClientPopupMenuHelper["_"]["handleDestroy"]++; }; 
	// Destroy the UCF-instance first, then remove from DOM by destroying client-instance
	var oLS = oMenu["oLS"];
	if (oLS) {
		oMenu["destroy"]();
		var oClientPM = oLS["oGetClientControlById"](oMenu["sGetId"]());
		if (oClientPM) {
			oClientPM["destroy"](); // Remove from DOM
		}
	}
	this["oMenu"] = null;
	this["oLS"] = null;
};;if (__UCF_COVERAGE__) { UCF_ClientPopupMenuHelper["_"]["handleDestroy"] = 0; };

/**
 * Destructor
 */
UCF_ClientPopupMenuHelper["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientPopupMenuHelper["_"]["destroy"]++; }; 

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ClientPopupMenuHelper["_"]["destroy"] = 0; };

UCF_ClientPopupMenuHelper.prototype["aPublicMethods"] = ["oRenderMenu","replaceItems"].concat(UCF_ClientPopupMenuHelper.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ClientProgressIndicator"] = function() { var UCF_ClientProgressIndicator = window["UCF_ClientProgressIndicator"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientProgressIndicator"); UCF_ClientProgressIndicator["_"] = {UCF_ClientProgressIndicator: 0}; };/* global UCF_ClientProgressIndicator */
UCF_ClientProgressIndicator["prototype"]["setBarColor"] = function(sBarColor, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientProgressIndicator["_"]["setBarColor"]++; }; 
	var oUCFProgressIndicator = this["getUCFInstance"]();
	if (oUCFProgressIndicator) {
		if (oUCFProgressIndicator["sBarColor"] != sBarColor) {
			this["setProperty"]("BarColor", sBarColor, true);
			oUCFProgressIndicator["setBarColor"](this["getProperty"]("BarColor"));
			return;
		}
	}
	this["setProperty"]("BarColor", sBarColor, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientProgressIndicator["_"]["setBarColor"] = 0; };

UCF_ClientProgressIndicator["prototype"]["setDisplayValue"] = function(sDisplayValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientProgressIndicator["_"]["setDisplayValue"]++; }; 
	var oUCFProgressIndicator = this["getUCFInstance"]();
	if (oUCFProgressIndicator) {
		if (oUCFProgressIndicator["sDisplayValue"] != sDisplayValue) {
			this["setProperty"]("DisplayValue", sDisplayValue, true);
			oUCFProgressIndicator["setDisplayValue"](this["getProperty"]("DisplayValue"));
			return;
		}
	}
	this["setProperty"]("DisplayValue", sDisplayValue, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientProgressIndicator["_"]["setDisplayValue"] = 0; };

UCF_ClientProgressIndicator["prototype"]["setShowValue"] = function(bShowValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientProgressIndicator["_"]["setShowValue"]++; }; 
	var oUCFProgressIndicator = this["getUCFInstance"]();
	if (oUCFProgressIndicator) {
		if (oUCFProgressIndicator["bShowValue"] != bShowValue) {
			this["setProperty"]("ShowValue", bShowValue, true);
			oUCFProgressIndicator["setShowValue"](this["getProperty"]("ShowValue"));
			return;
		}
	}
	this["setProperty"]("ShowValue", bShowValue, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientProgressIndicator["_"]["setShowValue"] = 0; };

UCF_ClientProgressIndicator["prototype"]["setPercentValue"] = function(iPercentValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientProgressIndicator["_"]["setPercentValue"]++; }; 
	var oUCFProgressIndicator = this["getUCFInstance"]();
	if (oUCFProgressIndicator) {
		if (oUCFProgressIndicator["iPercentValue"] != iPercentValue) {
			this["setProperty"]("PercentValue", iPercentValue, true);
			oUCFProgressIndicator["setPercentValue"](this["getProperty"]("PercentValue"));
			return;
		}
	}
	this["setProperty"]("PercentValue", iPercentValue, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientProgressIndicator["_"]["setPercentValue"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientRadioButton"] = function() { var UCF_ClientRadioButton = window["UCF_ClientRadioButton"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientRadioButton"); UCF_ClientRadioButton["_"] = {UCF_ClientRadioButton: 0}; };/* global UCF_ClientRadioButton */
UCF_ClientRadioButton["prototype"]["setChecked"] = function(bValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRadioButton["_"]["setChecked"]++; }; 
	return this["setUCFProperty"]("Checked", bValue, bSuppressRerendering, "handleClientSideSelection");
};;if (__UCF_COVERAGE__) { UCF_ClientRadioButton["_"]["setChecked"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientRasterLayoutItem"] = function() { var UCF_ClientRasterLayoutItem = window["UCF_ClientRasterLayoutItem"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientRasterLayoutItem"); UCF_ClientRasterLayoutItem["_"] = {UCF_ClientRasterLayoutItem: 0}; };/* global UCF_ClientRasterLayoutItem */
/* global UCF_System */
/// <reference path="../core/System.js"/>
UCF_ClientRasterLayoutItem["prototype"]["_setCssStyleValue"] = function(sValue, sProperty, sStyleName, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["_setCssStyleValue"]++; }; 
	var oUCFInstance = this["getUCFInstance"]();

	if (oUCFInstance) {
		oUCFInstance["oRootRef"]["style"][sStyleName] = sValue;
		this["setProperty"](sProperty, sValue, true);

		return;
	}
	this["setProperty"](sProperty, sValue, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["_setCssStyleValue"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["_setRasterValue"] = function(fValue, sProperty, sStyleName, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["_setRasterValue"]++; }; 
	if (!this["bInvalidated"] && this["getParent"]() && !this["getParent"]()["bInvalidated"]
		&& this["getParent"]()["getRasterHeight"] && this["getParent"]()["getRasterWidth"]) {
		var oUCFInstance = this["getUCFInstance"]();

		if (oUCFInstance) {
			var sUnit = 'px',
				fRaster = 1;

			if (sProperty === 'Height' || sProperty === 'Top') {
				fRaster = this["getParent"]()["getRasterHeight"]();
				sUnit = this["getParent"]()["getRasterHeightUnit"]();
			} else if (sProperty === 'Width' || sProperty === 'Left') {
				fRaster = this["getParent"]()["getRasterWidth"]();
				sUnit = this["getParent"]()["getRasterWidthUnit"]();
			}
			oUCFInstance["oRootRef"]["style"][sStyleName] = (fValue * fRaster) + sUnit;
			this["setProperty"](sProperty, fValue, true);

			return;
		}
	}
	this["setProperty"](sProperty, fValue, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["_setRasterValue"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setTop"] = function(fValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setTop"]++; }; 
	this["_setRasterValue"](fValue, 'Top', 'marginTop', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setTop"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setLeft"] = function(fValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setLeft"]++; }; 
	if (window["UCF_System"]["bIsRTL"])
		this["_setRasterValue"](fValue, 'Left', 'marginRight', bSuppressRerendering);
	else
		this["_setRasterValue"](fValue, 'Left', 'marginLeft', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setLeft"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setHeight"] = function(fValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setHeight"]++; }; 
	this["_setRasterValue"](fValue, 'Height', 'height', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setHeight"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setWidth"] = function(fValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setWidth"]++; }; 
	this["_setRasterValue"](fValue, 'Width', 'width', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setWidth"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setCssLeft"] = function(sValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssLeft"]++; }; 
	if (window["UCF_System"]["bIsRTL"])
		this["_setCssStyleValue"](sValue, 'CssLeft', 'marginRight', bSuppressRerendering);
	else
		this["_setCssStyleValue"](sValue, 'CssLeft', 'marginLeft', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssLeft"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setCssRight"] = function(sValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssRight"]++; }; 
	if (window["UCF_System"]["bIsRTL"])
		this["_setCssStyleValue"](sValue, 'CssRight', 'marginLeft', bSuppressRerendering);
	else
		this["_setCssStyleValue"](sValue, 'CssRight', 'marginRight', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssRight"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setCssTop"] = function(sValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssTop"]++; }; 
	this["_setCssStyleValue"](sValue, 'CssTop', 'marginTop', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssTop"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setCssBottom"] = function(sValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssBottom"]++; }; 
	this["_setCssStyleValue"](sValue, 'CssBottom', 'marginBottom', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssBottom"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setCssMinWidth"] = function(sValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssMinWidth"]++; }; 
	this["_setCssStyleValue"](sValue, 'CssMinWidth', 'minWidth', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssMinWidth"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setCssMinHeight"] = function(sValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssMinHeight"]++; }; 
	this["_setCssStyleValue"](sValue, 'CssMinHeight', 'minHeight', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssMinHeight"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setCssMaxWidth"] = function(sValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssMaxWidth"]++; }; 
	this["_setCssStyleValue"](sValue, 'CssMaxWidth', 'maxWidth', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssMaxWidth"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setCssMaxHeight"] = function(sValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssMaxHeight"]++; }; 
	this["_setCssStyleValue"](sValue, 'CssMaxHeight', 'maxHeight', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssMaxHeight"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setCssWidth"] = function(sValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssWidth"]++; }; 
	this["_setCssStyleValue"](sValue, 'CssWidth', 'width', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssWidth"] = 0; };

UCF_ClientRasterLayoutItem["prototype"]["setCssHeight"] = function(sValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssHeight"]++; }; 
	this["_setCssStyleValue"](sValue, 'CssHeight', 'height', bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientRasterLayoutItem["_"]["setCssHeight"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientSapTableCS"] = function() { var UCF_ClientSapTableCS = window["UCF_ClientSapTableCS"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientSapTableCS"); UCF_ClientSapTableCS["_"] = {UCF_ClientSapTableCS: 0}; };/* global _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>

/* global UCF_ClientSapTableCS */
/**
 * @class UCF_ClientSapTableCS is the ClientElement Class for UCF_SapTableCS
 * It overwrites the necessary methods fast rendering of certain properties
 * @private
 */

UCF_ClientSapTableCS["prototype"]["getMaxCols"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["getMaxCols"]++; }; 
	return this["getAggregation"]("LeftFixedColumns")["length"] + this["getAggregation"]("NoneFixedColumns")["length"];
};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["getMaxCols"] = 0; };

UCF_ClientSapTableCS["prototype"]["getColumnIndexByCellReference"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["getColumnIndexByCellReference"]++; }; 
	var oSapTable = this["getUCFInstance"]();
	if (oSapTable) {
		return oSapTable["oGetCellInfoByDomRef"](document["getElementById"](oCell["getId"]()))["iColIndex"];
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No UCFInstance found to apply the width", "ClientSapTableCS.js(20): getColumnIndexByCellReference"); };
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["getColumnIndexByCellReference"] = 0; };

UCF_ClientSapTableCS["prototype"]["moveCellColumnToNoneFixed"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["moveCellColumnToNoneFixed"]++; }; 
	var iCurrentLocalIndex = oCell["indexInParentAggregation"]();
	var sCurrentArea = oCell["sAggregationName"]["replace"]("Cells", "");
	var oRemovedCell, aContentRows;
	//move columns in the none fixed area
	if (sCurrentArea === "NoneFixed") {
		return;
	} else {
		var oRemovedColumn = this["getLeftFixedColumns"]()[iCurrentLocalIndex];
		if (!oRemovedColumn["getWidth"]()) {
			oRemovedColumn["setWidth"]("100px");
		} else if (oRemovedColumn["getWidth"]()["indexOf"]("%") > 0) {
			if (this["getUCFInstance"]()) {
				var iWidth = this["getUCFInstance"]()["iGetColumnWidth"](iCurrentLocalIndex);
				if (typeof(iWidth) === "number") {
					oRemovedColumn["setWidth"](iWidth + "px");
				}
			}
		}
		oRemovedColumn["removeFromParent"]();
		this["insertNoneFixedColumn"](oRemovedColumn, 0);

		var aHeaderRows = this["getHeaderRows"]();
		for (var i = 0; i < aHeaderRows["length"]; i++) {
			oRemovedCell = aHeaderRows[i]["getLeftFixedCells"]()[iCurrentLocalIndex];
			oRemovedCell["removeFromParent"]();
			aHeaderRows[i]["insertNoneFixedCell"](oRemovedCell, 0);
		}

		var aTopFixedRows = this["getTopFixedRows"]();
		for (i = 0; i < aTopFixedRows["length"]; i++) {
			oRemovedCell = aTopFixedRows[i]["getLeftFixedCells"]()[iCurrentLocalIndex];
			oRemovedCell["removeFromParent"]();
			aTopFixedRows[i]["insertNoneFixedCell"](oRemovedCell, 0);
		}

		var aContentFragments = this["getContentRowsFragments"]();
		for (var j = 0; i < aContentFragments["length"]; j++) {
			aContentRows = aContentFragments[j]["getRows"]();
			for (i = 0; i < aContentRows["length"]; i++) {
				oRemovedCell = aContentRows[i]["getLeftFixedCells"]()[iCurrentLocalIndex];
				oRemovedCell["removeFromParent"]();
				aContentRows[i]["insertNoneFixedCell"](oRemovedCell, 0);
			}
		}

		aContentRows = this["getContentRows"]();
		for (i = 0; i < aContentRows["length"]; i++) {
			oRemovedCell = aContentRows[i]["getLeftFixedCells"]()[iCurrentLocalIndex];
			oRemovedCell["removeFromParent"]();
			aContentRows[i]["insertNoneFixedCell"](oRemovedCell, 0);
		}

		var aBottomFixedRows = this["getBottomFixedRows"]();
		for (i = 0; i < aBottomFixedRows["length"]; i++) {
			oRemovedCell = aBottomFixedRows[i]["getLeftFixedCells"]()[iCurrentLocalIndex];
			oRemovedCell["removeFromParent"]();
			aBottomFixedRows[i]["insertNoneFixedCell"](oRemovedCell, 0);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["moveCellColumnToNoneFixed"] = 0; };

UCF_ClientSapTableCS["prototype"]["moveCellColumnToLeftFixed"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["moveCellColumnToLeftFixed"]++; }; 
	var iCurrentGlobalIndex = this["getColumnIndexByCellReference"](oCell),
		iCurrentLocalIndex = oCell["indexInParentAggregation"](),
		sCurrentArea = oCell["sAggregationName"]["replace"]("Cells", "");
	var oRemovedCell, aContentRows;
	//move columns in the left fixed area
	if (sCurrentArea === "LeftFixed") {
		return;
	} else {
		var oRemovedColumn = this["getNoneFixedColumns"]()[iCurrentLocalIndex];
		if (!oRemovedColumn["getWidth"]()) {
			oRemovedColumn["setWidth"]("100px");
		} else if (oRemovedColumn["getWidth"]()["indexOf"]("%") > 0) {
			if (this["getUCFInstance"]()) {
				var iWidth = this["getUCFInstance"]()["iGetColumnWidth"](iCurrentGlobalIndex);
				if (typeof(iWidth) === "number") {
					oRemovedColumn["setWidth"](iWidth + "px");
				}
			}
		}
		oRemovedColumn["removeFromParent"]();
		this["addLeftFixedColumn"](oRemovedColumn);
		var aHeaderRows = this["getHeaderRows"]();

		for (var i = 0; i < aHeaderRows["length"]; i++) {
			oRemovedCell = aHeaderRows[i]["getNoneFixedCells"]()[iCurrentLocalIndex];
			oRemovedCell["removeFromParent"]();
			aHeaderRows[i]["addLeftFixedCell"](oRemovedCell);
		}

		var aTopFixedRows = this["getTopFixedRows"]();
		for (i = 0; i < aTopFixedRows["length"]; i++) {
			oRemovedCell = aTopFixedRows[i]["getNoneFixedCells"]()[iCurrentLocalIndex];
			oRemovedCell["removeFromParent"]();
			aTopFixedRows[i]["addLeftFixedCell"](oRemovedCell);
		}

		var aContentFragments = this["getContentRowsFragments"]();
		for (var j = 0; i < aContentFragments["length"]; j++) {
			aContentRows = aContentFragments[j]["getRows"]();
			for (i = 0; i < aContentRows["length"]; i++) {
				oRemovedCell = aContentRows[i]["getNoneFixedCells"]()[iCurrentLocalIndex];
				oRemovedCell["removeFromParent"]();
				aContentRows[i]["addLeftFixedCell"](oRemovedCell);
			}
		}

		aContentRows = this["getContentRows"]();
		for (i = 0; i < aContentRows["length"]; i++) {
			oRemovedCell = aContentRows[i]["getNoneFixedCells"]()[iCurrentLocalIndex];
			oRemovedCell["removeFromParent"]();
			aContentRows[i]["addLeftFixedCell"](oRemovedCell);
		}

		var aBottomFixedRows = this["getBottomFixedRows"]();
		for (i = 0; i < aBottomFixedRows["length"]; i++) {
			oRemovedCell = aBottomFixedRows[i]["getNoneFixedCells"]()[iCurrentLocalIndex];
			oRemovedCell["removeFromParent"]();
			aBottomFixedRows[i]["addLeftFixedCell"](oRemovedCell);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["moveCellColumnToLeftFixed"] = 0; };

UCF_ClientSapTableCS["prototype"]["setColumnIndexByCellReference"] = function(oCell, iIndex) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["setColumnIndexByCellReference"]++; }; 
	var iCurrentLocalIndex = oCell["indexInParentAggregation"](),
		sCurrentArea = oCell["sAggregationName"]["replace"]("Cells", "");
	var oRemovedCell, aContentRows, oRemovedColumn, aBottomFixedRows,
		aTopFixedRows, aContentFragments, aHeaderRows;
	//move columns in the none fixed area
	if (sCurrentArea === "NoneFixed") {
		var iLocalNewIndex = iIndex - this["getAggregation"]("LeftFixedColumns")["length"];
		if (iLocalNewIndex < 0 && this["getAggregation"]("LeftFixedColumns")["length"] > 1) {
			//moveToFixed
			this["moveCellColumnToLeftFixed"](oCell);
			return;
		}
		if (iLocalNewIndex >= 0 && iLocalNewIndex < this["getAggregation"]("NoneFixedColumns")["length"]) {

			oRemovedColumn = this["getNoneFixedColumns"]()[iCurrentLocalIndex];
			oRemovedColumn["removeFromParent"]();
			this["insertNoneFixedColumn"](oRemovedColumn, iLocalNewIndex);

			aHeaderRows = this["getHeaderRows"]();
			for (var i = 0; i < aHeaderRows["length"]; i++) {
				oRemovedCell = aHeaderRows[i]["getNoneFixedCells"]()[iCurrentLocalIndex];
				oRemovedCell["removeFromParent"]();
				aHeaderRows[i]["insertNoneFixedCell"](oRemovedCell, iLocalNewIndex);
			}

			aTopFixedRows = this["getTopFixedRows"]();
			for (i = 0; i < aTopFixedRows["length"]; i++) {
				oRemovedCell = aTopFixedRows[i]["getNoneFixedCells"]()[iCurrentLocalIndex];
				oRemovedCell["removeFromParent"]();
				aTopFixedRows[i]["insertNoneFixedCell"](oRemovedCell, iLocalNewIndex);
			}

			aContentFragments = this["getContentRowsFragments"]();
			for (var j = 0; j < aContentFragments["length"]; j++) {
				aContentRows = aContentFragments[j]["getRows"]();
				for (i = 0; i < aContentRows["length"]; i++) {
					oRemovedCell = aContentRows[i]["getNoneFixedCells"]()[iCurrentLocalIndex];
					oRemovedCell["removeFromParent"]();
					aContentRows[i]["insertNoneFixedCell"](oRemovedCell, iLocalNewIndex);
				}
			}

			aContentRows = this["getContentRows"]();
			for (i = 0; i < aContentRows["length"]; i++) {
				oRemovedCell = aContentRows[i]["getNoneFixedCells"]()[iCurrentLocalIndex];
				oRemovedCell["removeFromParent"]();
				aContentRows[i]["insertNoneFixedCell"](oRemovedCell, iLocalNewIndex);
			}

			aBottomFixedRows = this["getBottomFixedRows"]();
			for (i = 0; i < aBottomFixedRows["length"]; i++) {
				oRemovedCell = aBottomFixedRows[i]["getNoneFixedCells"]()[iCurrentLocalIndex];
				oRemovedCell["removeFromParent"]();
				aBottomFixedRows[i]["insertNoneFixedCell"](oRemovedCell, iLocalNewIndex);
			}
		}
	} else if (sCurrentArea === "LeftFixed") {
		iLocalNewIndex = iIndex;
		if (iLocalNewIndex > 0 && iLocalNewIndex < this["getAggregation"]("LeftFixedColumns")["length"]) {
			//move to right in none fixed

			oRemovedColumn = this["getLeftFixedColumns"]()[iCurrentLocalIndex];
			oRemovedColumn["removeFromParent"]();
			this["insertLeftFixedColumn"](oRemovedColumn, iLocalNewIndex);
			aHeaderRows = this["getHeaderRows"]();

			for (i = 0; i < aHeaderRows["length"]; i++) {
				oRemovedCell = aHeaderRows[i]["getLeftFixedCells"]()[iCurrentLocalIndex];
				oRemovedCell["removeFromParent"]();
				aHeaderRows[i]["insertLeftFixedCell"](oRemovedCell, iLocalNewIndex);
			}

			aTopFixedRows = this["getTopFixedRows"]();
			for (i = 0; i < aTopFixedRows["length"]; i++) {
				oRemovedCell = aTopFixedRows[i]["getLeftFixedCells"]()[iCurrentLocalIndex];
				oRemovedCell["removeFromParent"]();
				aTopFixedRows[i]["insertLeftFixedCell"](oRemovedCell, iLocalNewIndex);
			}

			aContentFragments = this["getContentRowsFragments"]();
			for (j = 0; i < aContentFragments["length"]; j++) {
				aContentRows = aContentFragments[j]["getRows"]();
				for (i = 0; i < aContentRows["length"]; i++) {
					oRemovedCell = aContentRows[i]["getLeftFixedCells"]()[iCurrentLocalIndex];
					oRemovedCell["removeFromParent"]();
					aContentRows[i]["insertLeftFixedCell"](oRemovedCell, iLocalNewIndex);
				}
			}

			aContentRows = this["getContentRows"]();
			for (i = 0; i < aContentRows["length"]; i++) {
				oRemovedCell = aContentRows[i]["getLeftFixedCells"]()[iCurrentLocalIndex];
				oRemovedCell["removeFromParent"]();
				aContentRows[i]["insertLeftFixedCell"](oRemovedCell, iLocalNewIndex);
			}

			aBottomFixedRows = this["getBottomFixedRows"]();
			for (i = 0; i < aBottomFixedRows["length"]; i++) {
				oRemovedCell = aBottomFixedRows[i]["getLeftFixedCells"]()[iCurrentLocalIndex];
				oRemovedCell["removeFromParent"]();
				aBottomFixedRows[i]["insertLeftFixedCell"](oRemovedCell, iLocalNewIndex);
			}
		}
	}

};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["setColumnIndexByCellReference"] = 0; };

UCF_ClientSapTableCS["prototype"]["isLeftFixedColumnCell"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["isLeftFixedColumnCell"]++; }; 
	if (oCell["sClassName"] === "SapTableCSHeaderCell" || oCell["sClassName"] === "SapTableCSCell") {
		return oCell["sAggregationName"] === "LeftFixedCells";
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["isLeftFixedColumnCell"] = 0; };

UCF_ClientSapTableCS["prototype"]["isNoneFixedColumnCell"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["isNoneFixedColumnCell"]++; }; 
	if (oCell["sClassName"] === "SapTableCSHeaderCell" || oCell["sClassName"] === "SapTableCSCell") {
		return oCell["sAggregationName"] === "NoneFixedCells";
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["isNoneFixedColumnCell"] = 0; };

UCF_ClientSapTableCS["prototype"]["isRightFixedColumnCell"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["isRightFixedColumnCell"]++; }; 
	if (oCell["sClassName"] === "SapTableCSHeaderCell" || oCell["sClassName"] === "SapTableCSCell") {
		return oCell["sAggregationName"] === "RightFixedCells";
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["isRightFixedColumnCell"] = 0; };

/**
 * Returns the column control for the given cell reference
 * @param {*} oCell
 * @return {Object}
 * @private
 */
UCF_ClientSapTableCS["prototype"]["getColumnByCellReference"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["getColumnByCellReference"]++; }; 
	if (oCell["sClassName"] === "SapTableCSHeaderCell" || oCell["sClassName"] === "SapTableCSCell") {
		var sColAggregationName = oCell["sAggregationName"]["replace"]("Cells", "Columns");
		var iIndex = oCell["indexInParentAggregation"]();
		return this["getAggregation"](sColAggregationName)[iIndex];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["getColumnByCellReference"] = 0; };

/**
 * Sets the column width for a given cell or header cell reference.
 * Important is that a column definition exists for this table.
 * @param {UCF_ClientSapTableCSCell | UCF_ClientSapTableCSHeaderCell} oCell The cell reference
 * @param {string} sWidth The new width for the column
 * @private
 */
UCF_ClientSapTableCS["prototype"]["setColumnWidthByCellReference"] = function(oCell, sWidth) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["setColumnWidthByCellReference"]++; }; 
	if (oCell["sClassName"] === "SapTableCSHeaderCell" || oCell["sClassName"] === "SapTableCSCell") {
		var oColumn = this["getColumnByCellReference"](oCell);
		if (oColumn) {
			oColumn["setWidth"](sWidth, true); // suppress rerendering
			// Now do the change in the dom directly with convenient api
			var oSapTable = this["getUCFInstance"]();
			if (oSapTable) {
				var iColIndex = oSapTable["oGetCellInfoByDomRef"](document["getElementById"](oCell["getId"]()))["iColIndex"];
				oSapTable["setColumnWidth"](iColIndex, sWidth);
			} else {
				if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No UCFInstance found to apply the width", "ClientSapTableCS.js(314): setColumnWidthByCellReference"); };

			}
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No Column Defintition found", "ClientSapTableCS.js(318): setColumnWidthByCellReference"); };
		}
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Cell is not of type SapTableCSHeaderCell or SapTableCSCell", "ClientSapTableCS.js(321): setColumnWidthByCellReference"); };
	}
};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["setColumnWidthByCellReference"] = 0; };

/**
 * Returns the column width for a given cell or header cell reference.
 * Important is that a column definition exists for this table.
 * @param {UCF_ClientSapTableCSCell | UCF_ClientSapTableCSHeaderCell} oCell The cell reference
 * @return {string}
 * @private
 */
UCF_ClientSapTableCS["prototype"]["getColumnWidthByCellReference"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["getColumnWidthByCellReference"]++; }; 
	if (oCell["sClassName"] === "SapTableCSHeaderCell" || oCell["sClassName"] === "SapTableCSCell") {
		var oColumn = this["getColumnByCellReference"](oCell);
		if (oColumn) {
			return oColumn["getWidth"](); // suppress rerendering
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No Column Defintition found", "ClientSapTableCS.js(338): getColumnWidthByCellReference"); };
		}
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Cell is not of type SapTableCSHeaderCell or SapTableCSCell", "ClientSapTableCS.js(341): getColumnWidthByCellReference"); };
	}
	return "";
};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["getColumnWidthByCellReference"] = 0; };

/**
 * Sets the column invisibility for a given cell or header cell reference.
 * Important is that a column definition exists for this table.
 * @param {UCF_ClientSapTableCSCell | UCF_ClientSapTableCSHeaderCell} oCell The cell reference
 * @param {boolean} bInvisible Whether the column is visible or not.
 * @private
 */
UCF_ClientSapTableCS["prototype"]["setColumnInvisibilityByCellReference"] = function(oCell, bInvisible) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["setColumnInvisibilityByCellReference"]++; }; 
	var oColumn;
	if (bInvisible) {
		oColumn = this["getColumnByCellReference"](oCell);
		if (oColumn) {
			oColumn["addCustomObject"]("OriginalWith", oColumn["getWidth"]());
			oColumn["addCustomObject"]("Invisible", "true");
			this["setColumnWidthByCellReference"](oCell, "0px");
		}
	} else {
		oColumn = this["getColumnByCellReference"](oCell);
		if (oColumn) {
			var sOldWidth = oColumn["getCustomObject"]("OriginalWith");
			oColumn["removeCustomObject"]("Invisible");
			this["setColumnWidthByCellReference"](oCell, sOldWidth);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["setColumnInvisibilityByCellReference"] = 0; };

/**
 * Returns the column invisibility for a given cell or header cell reference.
 * Important is that a column definition exists for this table.
 * @param {UCF_ClientSapTableCSCell | UCF_ClientSapTableCSHeaderCell} oCell The cell reference
 * @return {boolean}
 * @private
 */
UCF_ClientSapTableCS["prototype"]["getColumnInvisibilityByCellReference"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["getColumnInvisibilityByCellReference"]++; }; 
	var oColumn = this["getColumnByCellReference"](oCell);
	if (oColumn["getCustomObject"]("Invisible")) {
		return true;
	} else {
		// This is also called during startup of editor: invisible columns are rendered with width=0
		return oColumn["getWidth"]() === "0px";
	}
};;if (__UCF_COVERAGE__) { UCF_ClientSapTableCS["_"]["getColumnInvisibilityByCellReference"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientSapTableHeaderCell"] = function() { var UCF_ClientSapTableHeaderCell = window["UCF_ClientSapTableHeaderCell"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientSapTableHeaderCell"); UCF_ClientSapTableHeaderCell["_"] = {UCF_ClientSapTableHeaderCell: 0}; };/* global UCF_ClientElement */
/// <reference path="../core/ClientElement.js"/>

/* global UCF_ClientSapTableHeaderCell */
UCF_ClientSapTableHeaderCell["prototype"]["render"] = function(bTimer) {;if (__UCF_COVERAGE__) { UCF_ClientSapTableHeaderCell["_"]["render"]++; }; 
	UCF_ClientElement["prototype"]["render"]["apply"](this);
};;if (__UCF_COVERAGE__) { UCF_ClientSapTableHeaderCell["_"]["render"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientStickyNote"] = function() { var UCF_ClientStickyNote = window["UCF_ClientStickyNote"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientStickyNote"); UCF_ClientStickyNote["_"] = {UCF_ClientStickyNote: 0}; };/* global UCF_ClientStickyNote */
UCF_ClientStickyNote["prototype"]["setRLIMode"] = function(bValue, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientStickyNote["_"]["setRLIMode"]++; }; 
	return this["setUCFProperty"]("RLIMode", bValue, bSuppressRerendering, "setRLIMode");
};;if (__UCF_COVERAGE__) { UCF_ClientStickyNote["_"]["setRLIMode"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientTextView"] = function() { var UCF_ClientTextView = window["UCF_ClientTextView"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientTextView"); UCF_ClientTextView["_"] = {UCF_ClientTextView: 0}; };/**
 * @class UCF_ClientTextView is the ClientElement Class for UCF_TextView
 * It overwrites the necessary methods fast rendering of certain properties
 * @private
 */

/* global UCF_ClientTextView */


/**
 * Sets the text of the TextView
 * @param {string} sText The new text to be set
 * @param {boolean} bSuppressRerendering avoid an rerendering of the element after the property change.
 * @private
 */

UCF_ClientTextView["prototype"]["setText"] = function(sText, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientTextView["_"]["setText"]++; }; 
	return this["setUCFProperty"]('Text', sText, bSuppressRerendering, 'setText');
};;if (__UCF_COVERAGE__) { UCF_ClientTextView["_"]["setText"] = 0; };

/**
 * Sets the tooltip of the TextView
 * @param {string} sTooltip The new text for the tooltip to be set
 * @param {boolean} bSuppressRerendering avoid an rerendering of the element after the property change.
 * @private
 */

UCF_ClientTextView["prototype"]["setTooltip"] = function(sTooltip, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientTextView["_"]["setTooltip"]++; }; 
	return this["setUCFProperty"]('Tooltip', sTooltip, bSuppressRerendering, 'setTooltip');
};;if (__UCF_COVERAGE__) { UCF_ClientTextView["_"]["setTooltip"] = 0; };

/**
 * Sets the align of the TextView
 * @param {string} sAlign The new align to be set FORCEDLEFT, LEFT, RIGHT, BEGINOFLINE, ENDOFLINE FORCEDRIGHT, CENTER
 * @param {boolean} bSuppressRerendering avoid an rerendering of the element after the property change.
 * @private
 */

UCF_ClientTextView["prototype"]["setAlign"] = function(sAlign, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientTextView["_"]["setAlign"]++; }; 
	return this["setUCFProperty"]('Align', sAlign, bSuppressRerendering, 'setAlign', [sAlign, this["getTextDirection"]()]);
};;if (__UCF_COVERAGE__) { UCF_ClientTextView["_"]["setAlign"] = 0; };

/**
 * Sets the design of the TextView
 * @param {string} sDesign The new design to be set
 * @param {boolean} bSuppressRerendering avoid an rerendering of the element after the property change.
 * @private
 */

UCF_ClientTextView["prototype"]["setDesign"] = function(sDesign, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientTextView["_"]["setDesign"]++; }; 
	return this["setUCFProperty"]('Design', sDesign, bSuppressRerendering, 'setDesign');
};;if (__UCF_COVERAGE__) { UCF_ClientTextView["_"]["setDesign"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientToolbar"] = function() { var UCF_ClientToolbar = window["UCF_ClientToolbar"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientToolbar"); UCF_ClientToolbar["_"] = {UCF_ClientToolbar: 0}; };/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_ClientElement */
/// <reference path="../core/ClientElement.js"/>

var oMoreClient;

/* global UCF_ClientToolbar, UCF_ClientButton, UCF_ClientControl */
/**
 * Switch off support and visalization for the RightItems in
 * designtime extension (handled by ToolbarDTExtension)
 */

UCF_ClientToolbar["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_ClientToolbar["_"]["initialize"]++; }; 

	if (this["oJson"] && !this["oJson"]["ItemOverflow"])
		return;

	if (this["oJson"] && !this["oJson"]["OverflowItems"])
		return;

	var sMoreButtonId = this["sId"] + '-moreButton',
		oJsonMoreButton = {
			"Button": {
				"Id": sMoreButtonId,
				"Visibility": 'VISIBLE',
				"Design": 'TRANSPARENT',
				"HasPopupMenu": true,
				"HAlign": 'CENTER',
				"Type": 'NONE',
				"PopupMenuId": (this["sId"] + '-tbarMoreMenu')
			}
		};

	if (!this["oLS"]) return;
	try {
		oMoreClient = UCF_ClientElement["createInstance"]('sap.ls.controls.Button', this["oLS"], sMoreButtonId, oJsonMoreButton, this);
		//oMoreClient = new UCF_ClientButton(this.oLS, sMoreButtonId, oJsonMoreButton, this);
		if (oMoreClient) {
			oMoreClient["setDesign"]('TRANSPARENT');
			oMoreClient["setHasPopupMenu"](true);
			oMoreClient["setPopupMenuId"](this["sId"] + '-tbarMoreMenu');
			var oMoreButtonOvfl = UCF_DomUtil["$"](this["sId"] + '-moreOvfl');

			if (oMoreButtonOvfl)
				oMoreClient["placeAt"](oMoreButtonOvfl);
		}
	} catch (e) {

	}
};;if (__UCF_COVERAGE__) { UCF_ClientToolbar["_"]["initialize"] = 0; };

UCF_ClientToolbar["prototype"]["bNoRightAreaInDesigntime"] = false;

UCF_ClientToolbar["prototype"]["setCustomStyle"] = function(sCustomStyle, bSuppressRerendering) {;if (__UCF_COVERAGE__) { UCF_ClientToolbar["_"]["setCustomStyle"]++; }; 

	var oMoreDomRef = UCF_DomUtil["$"](this["sId"] + '-moreButton');

	if (oMoreDomRef) {
		UCF_DomUtil["addClass"](oMoreDomRef, sCustomStyle + 'MoreButton');
	}
	this["setProperty"]('CustomStyle', sCustomStyle, bSuppressRerendering);
};;if (__UCF_COVERAGE__) { UCF_ClientToolbar["_"]["setCustomStyle"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientToolbarComboBox"] = function() { var UCF_ClientToolbarComboBox = window["UCF_ClientToolbarComboBox"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientToolbarComboBox"); UCF_ClientToolbarComboBox["_"] = {UCF_ClientToolbarComboBox: 0}; };/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_ClientControl */
/// <reference path="../core/ClientControl.js"/>

/* global UCF_ClientToolbarComboBox */
UCF_ClientToolbarComboBox["prototype"]["render"] = function(bTimer) {;if (__UCF_COVERAGE__) { UCF_ClientToolbarComboBox["_"]["render"]++; }; 
	UCF_DomUtil["removeFromDom"](UCF_DomUtil["$"](this["sId"] + '-tr'));
	UCF_ClientControl["prototype"]["render"]["apply"](this, [bTimer]);
};;if (__UCF_COVERAGE__) { UCF_ClientToolbarComboBox["_"]["render"] = 0; };

};
sap["ls"]["preload"]["UCF_ClientToolbarInputField"] = function() { var UCF_ClientToolbarInputField = window["UCF_ClientToolbarInputField"] || function() {}; if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ClientToolbarInputField"); UCF_ClientToolbarInputField["_"] = {UCF_ClientToolbarInputField: 0}; };/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_ClientControl */
/// <reference path="../core/ClientControl.js"/>

/* global UCF_ClientToolbarInputField */
UCF_ClientToolbarInputField["prototype"]["render"] = function(bTimer) {;if (__UCF_COVERAGE__) { UCF_ClientToolbarInputField["_"]["render"]++; }; 
	UCF_DomUtil["removeFromDom"](UCF_DomUtil["$"](this["sId"] + '-tr'));
	UCF_ClientControl["prototype"]["render"]["apply"](this, [bTimer]);
};;if (__UCF_COVERAGE__) { UCF_ClientToolbarInputField["_"]["render"] = 0; };

};
sap["ls"]["preload"]["UCF_ColorItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>

/**
 * Implements a Lightspeed ColorItem control
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ColorItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["UCF_ColorItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ColorItem.js(23): UCF_ColorItem"); };

	UCF_UrBase["apply"](this, [oDomRef, oLS]);

	this["bHover"] = false;
};window["UCF_ColorItem"] = UCF_ColorItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ColorItem"); UCF_ColorItem["_"] = {UCF_ColorItem: 0}; }; ;
UCF_ColorItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(); UCF_ColorItem.prototype["sClassName"] = "UCF_ColorItem";

/** @override */
UCF_ColorItem["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["destroy"]++; }; 
	this["sSemanticColor"] = null;
	this["sTextColor"] = null;
	this["bSelected"] = null;
	this["sImage"] = null;

	UCF_UrBase.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["destroy"] = 0; };

/**
 * Set the CSS classes
 *
 * @private
 */
UCF_ColorItem["prototype"]["setClass"] = function() {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setClass"]++; }; 

	this["oDomRef"]["className"] = (this["bSelected"] ? "lsCoIS" : "lsCoI")
		+ (this["bHover"] ? " lsCoIH" : "");

	var oImg = UCF_DomUtil["firstChild"](this["oDomRef"], "IMG");

	if (oImg == null)
		oImg = UCF_DomUtil["firstChild"](this["oDomRef"], "DIV");

	//new UCF_UrBase(); //load urbase
	oImg["className"] = "lsCoII lsColorPicker--text urTxtStd " + UCF_UrBase["getSemanticColor"](this["sSemanticColor"]) + " " + UCF_UrBase["getSemanticTextColor"](this["sTextColor"]);

	if (this["sImage"] != null && this["sImage"] != "")
		oImg["src"] = this["sImage"];
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setClass"] = 0; };

/**
 * Handles the mouseover event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_ColorItem["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["onmouseover"]++; }; 

	//Hint: mouseout fired if leave the outer note to the inner as well
	if (!this["bEnabled"] || oBrowserEvent["oGetSource"]() == this["oDomRef"]) return;

	this["bHover"] = true;
	this["setClass"]();
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["onmouseover"] = 0; };

/**
 * Handles the mouseout event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_ColorItem["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["onmouseout"]++; }; 

	//Hint: mouseout fired if leave the outer note to the inner as well
	if (!this["bEnabled"] || oBrowserEvent["oGetSource"]() == this["oDomRef"]) return;

	this["bHover"] = false;
	this["setClass"]();
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["onmouseout"] = 0; };

/**
 * Handles the onclick event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_ColorItem["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ColorItem.js(100): onclick"); };

	if (this["bEnabled"]) {
		//always fired even if selected e.g. to enable the closing of the popup window
		this["fireSelect"](this["sId"], this["sSemanticColor"], this["sImage"] /*, this.sValue*/ );
	}
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["onclick"] = 0; };

/**
 * Handles the onlsselect event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_ColorItem["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["onlsselect"]++; }; 
	//fired by space and enter
	this["onclick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["onlsselect"] = 0; };

/**
 * Sets the selected state
 * @public
 * @param {boolean} selected the selected state
 */
UCF_ColorItem["prototype"]["setSelected"] = function(bSelected) {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setSelected"]++; }; 
	this["bSelected"] = bSelected;
	this["setClientProperty"]("Selected", this["bSelected"], true);
	this["setClass"]();
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setSelected"] = 0; };

/**
 * @public
 * @return Returns the selected state
 * @type string
 */
UCF_ColorItem["prototype"]["getSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["getSelected"]++; }; 
	return this["bSelected"];
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["getSelected"] = 0; };

/**
 * Sets the sSemanticColor
 * @public
 * @param {string} sSemanticColor
 */
UCF_ColorItem["prototype"]["setSemanticColor"] = function(sSemanticColor) {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setSemanticColor"]++; }; 
	this["sSemanticColor"] = sSemanticColor;
	this["setClientProperty"]("SemanticColor", this["sSemanticColor"], true);
	this["setClass"]();
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setSemanticColor"] = 0; };

/**
 * @public
 * @return the sSemanticColor
 * @type string
 */
UCF_ColorItem["prototype"]["getSemanticColor"] = function() {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["getSemanticColor"]++; }; 
	return this["sSemanticColor"];
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["getSemanticColor"] = 0; };

/**
 * Sets the sTextColor
 * @public
 * @param {string} sTextColor
 */
UCF_ColorItem["prototype"]["setTextColor"] = function(sTextColor) {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setTextColor"]++; }; 
	this["sTextColor"] = sTextColor;
	this["setClientProperty"]("TextColor", this["sTextColor"], true);
	this["setClass"]();
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setTextColor"] = 0; };

/**
 * @public
 * @return the sTextColor
 * @type string
 */
UCF_ColorItem["prototype"]["getTextColor"] = function() {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["getTextColor"]++; }; 
	return this["sTextColor"];
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["getTextColor"] = 0; };

/**
 * @public
 * @param {string} sSemanticColor
 * @return the sSemanticColor
 * @type string
 *
UCF_ColorItem.prototype.getSemanticColorClass = function(sSemanticColor) {
	return UCF_ColorItem.getSemanticColorClass(this.sSemanticColor);
};

/**
 * @public
 * @param {string} sSemanticColor
 * @return the sSemanticColor
 * @type string
 *
UCF_ColorItem.getSemanticColorClass = function(sSemanticColor) {
	return UCF_UrBase.getSemanticColor(this.sSemanticColor);
};
*/

/**
 * Sets the sImage
 * @public
 * @param {string} sImage
 */
UCF_ColorItem["prototype"]["setImage"] = function(sImage) {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setImage"]++; }; 
	this["sImage"] = sImage;
	this["setClientProperty"]("Image", this["sImage"], true);
	this["setClass"]();
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setImage"] = 0; };

/** @public
 * @return Returns the selected state
 * @type string
 */
UCF_ColorItem["prototype"]["getImage"] = function() {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["getImage"]++; }; 
	return this["sImage"];
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["getImage"] = 0; };

/** Accessibility
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_ColorItem["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ColorItem.js(225): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() != this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	oAccessibilityHelper["setControlType"]("COI");
	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["setPressed"](this["bSelected"]);
	oAccessibilityHelper["addEnabledTutor"]("COI_TUT", this["bEnabled"]);
	oAccessibilityHelper["addSemantic"](this["sSemanticColor"]);
	//Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ColorItem["prototype"]["aAttributeNames"] = ["bEnabled","sTooltip","sSemanticColor","bSelected","sImage","sText","sTextColor","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ColorItem["prototype"]["aEventNames"] = ["Select"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ColorItem["prototype"]["aMethodNames"] = ["setSelected","getSelected","setSemanticColor","getSemanticColor","setImage","getImage","setTextColor","getTextColor","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {boolean}
 */
UCF_ColorItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_ColorItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_ColorItem["prototype"]["sSemanticColor"] = "STANDARD";

/**
 * @private
 * @type {boolean}
 */
UCF_ColorItem["prototype"]["bSelected"] = false;

/**
 * @private
 * @type {string}
 */
UCF_ColorItem["prototype"]["sImage"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ColorItem["prototype"]["sText"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_ColorItem["prototype"]["sTextColor"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_ColorItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ColorItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setDefaultValues"]++; }; 
	this["bEnabled"] = true;
	this["sTooltip"] = '';
	this["sSemanticColor"] = "STANDARD";
	this["bSelected"] = false;
	this["sImage"] = '';
	this["sText"] = '';
	this["sTextColor"] = "STANDARD";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("SemanticColor", "STANDARD", true);
		this["setClientProperty"]("Selected", false, true);
		this["setClientProperty"]("Image", '', true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("TextColor", "STANDARD", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the Color
 * @param {string} sSemanticColor Value of the SemanticColor key
 * @param {string} sImage The image source on the selected element
 * @fires ColorItem::Select
 */
UCF_ColorItem["prototype"]["fireSelect"] = function(sId, sSemanticColor, sImage) {;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, SemanticColor: string, Image: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "ColorItem.js(345): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ColorItem.js(346): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ColorItem.js(347): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSemanticColor != null, "sSemanticColor != null", "ColorItem.js(348): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSemanticColor) == "string", "typeof(sSemanticColor) == \"string\"", "ColorItem.js(349): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sImage != null, "sImage != null", "ColorItem.js(350): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sImage) == "string", "typeof(sImage) == \"string\"", "ColorItem.js(351): fireSelect"); };
	mParams = {
		"Id": sId,
		"SemanticColor": sSemanticColor,
		"Image": sImage
	};
	
	
	
	this["fireSemanticEvent"]("ColorItem", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ColorItem["_"]["fireSelect"] = 0; };

UCF_ColorItem.prototype["aPublicMethods"] = ["setSelected","getSelected","setSemanticColor","getSemanticColor","setTextColor","getTextColor","setImage","getImage"].concat(UCF_ColorItem.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ColorPalette"] = function() {/* eslint-env es6 */
/* global _assert, _trace, WARNING, ERROR */

/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_UI5WebComponent */
/// <reference path="base/UI5WebComponent.js"/>

/**
 * UR control for the UI5 webcompoment 'ui5-color-palette'
 * @class
 * @extends UCF_Control
 * @param { HTMLElement } oDomRef
 * @param { UCF_LS } oLS LS instance
 */
function UCF_ColorPalette(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ColorPalette["_"]["UCF_ColorPalette"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ColorPalette.js(18): UCF_ColorPalette"); };
		UCF_UI5WebComponent["apply"](this, [oDomRef, oLS]);
	}
};window["UCF_ColorPalette"] = UCF_ColorPalette; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ColorPalette"); UCF_ColorPalette["_"] = {UCF_ColorPalette: 0}; }; ;
UCF_ColorPalette["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_UI5WebComponent"))(); UCF_ColorPalette.prototype["sClassName"] = "UCF_ColorPalette";

// UCF_ColorPalette.prototype.onScriptsLoaded = function() {
// 	_super();
// 	if (this.bShowMoreColors) {
// 		this.oDomRef.setAttribute('show-more-colors', '');
// 	}
// };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ColorPalette["prototype"]["aAttributeNames"] = ["sDefaultColor","bShowDefaultColor","bShowRecentColors"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ColorPalette["prototype"]["aEventNames"] = ["ItemClick"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ColorPalette["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ColorPalette["prototype"]["sDefaultColor"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_ColorPalette["prototype"]["bShowDefaultColor"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_ColorPalette["prototype"]["bShowRecentColors"] = false;

//#JSCOVER_EXCL_START
/** @protected */
UCF_ColorPalette["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ColorPalette["_"]["setDefaultValues"]++; }; 
	this["sDefaultColor"] = '';
	this["bShowDefaultColor"] = false;
	this["bShowRecentColors"] = false;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("DefaultColor", '', true);
		this["setClientProperty"]("ShowDefaultColor", false, true);
		this["setClientProperty"]("ShowRecentColors", false, true);
	}
};;if (__UCF_COVERAGE__) { UCF_ColorPalette["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sColorValue The CSS color value of the selected item
 * @fires ColorPalette::ItemClick
 */
UCF_ColorPalette["prototype"]["fireItemClick"] = function(sId, sColorValue) {;if (__UCF_COVERAGE__) { UCF_ColorPalette["_"]["fireItemClick"]++; }; 
	/** @type {{Id: string, ColorValue: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ColorPalette.js(96): fireItemClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ColorPalette.js(97): fireItemClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ColorPalette.js(98): fireItemClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sColorValue != null, "sColorValue != null", "ColorPalette.js(99): fireItemClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sColorValue) == "string", "typeof(sColorValue) == \"string\"", "ColorPalette.js(100): fireItemClick"); };
	mParams = {
		"Id": sId,
		"ColorValue": sColorValue
	};
	
	
	this["fireSemanticEvent"]("ColorPalette", "ItemClick", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_ColorPalette["_"]["fireItemClick"] = 0; };

};
sap["ls"]["preload"]["UCF_ColorPaletteItem"] = function() {/* global _assert, _trace, WARNING, ERROR */

/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_UI5WebComponent */
/// <reference path="base/UI5WebComponent.js"/>


/**
 * @class
 * @extends UCF_Control
 * @param { HTMLElement } oDomRef
 * @param { UCF_LS } oLS LS instance
 */
function UCF_ColorPaletteItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ColorPaletteItem["_"]["UCF_ColorPaletteItem"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ColorPaletteItem.js(17): UCF_ColorPaletteItem"); };
		UCF_UI5WebComponent["apply"](this, [oDomRef, oLS]);
	}
};window["UCF_ColorPaletteItem"] = UCF_ColorPaletteItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ColorPaletteItem"); UCF_ColorPaletteItem["_"] = {UCF_ColorPaletteItem: 0}; }; ;
UCF_ColorPaletteItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_UI5WebComponent"))(); UCF_ColorPaletteItem.prototype["sClassName"] = "UCF_ColorPaletteItem";

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ColorPaletteItem["prototype"]["aAttributeNames"] = ["sValue"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ColorPaletteItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ColorPaletteItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ColorPaletteItem["prototype"]["sValue"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ColorPaletteItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ColorPaletteItem["_"]["setDefaultValues"]++; }; 
	this["sValue"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Value", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ColorPaletteItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ColumnLayout"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ColumnLayoutSection */
/// <reference path="./ColumnLayoutSection.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ColumnLayout(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["UCF_ColumnLayout"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ColumnLayout.js(30): UCF_ColumnLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ColumnLayout.js(31): UCF_ColumnLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ColumnLayout.js(32): UCF_ColumnLayout"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["bInitialized"] = false;
	this["oSectionsList"] = null;
	this["oNavigationTree"] = null;
	this["oActiveSection"] = null;
	this["iActiveIndex"] = -1;
	this["bSkipped"] = false;
	this["bMoved"] = false;

	this["bFocusableControlExist"] = false;
};window["UCF_ColumnLayout"] = UCF_ColumnLayout; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ColumnLayout"); UCF_ColumnLayout["_"] = {UCF_ColumnLayout: 0}; }; ;
UCF_ColumnLayout["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ColumnLayout.prototype["sClassName"] = "UCF_ColumnLayout";

/**
 * Initializes the ColumnLayout
 *
 * @private
 */
UCF_ColumnLayout["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["init"]++; }; 
	if (!this["aSectionsList"]) {
		this["aSectionsList"] = this["getSectionList"]();
	}
	if (!this["oNavigationTree"]) {
		this["oNavigationTree"] = this["oGetNavigationTree"]();
	}
	//UCF_DomUtil.resetTabIndex(this.oDomRef);
	//UCF_DomUtil.resetTabIndex(UCF_DomUtil.$(this.sId + "-endpoint"));

	this["bFocusableControlExist"] = this["oGetFirstFocusableChild"]() ? true : false; //the columnlayout have any focusable element

	this["oGetNextControl"]();

	this["bInitialized"] = true;

};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["init"] = 0; };

/**
 * Collects and return the sections of the column layout
 * @return {Object}
 * @private
 */
UCF_ColumnLayout["prototype"]["getSectionList"] = function() {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["getSectionList"]++; }; 

	var oDomSections = UCF_DomUtil["$"](this["sId"] + "-sections");

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomSections != null, "oDomSections != null", "ColumnLayout.js(80): getSectionList"); };

	if (oDomSections) {
		var aChildNodes = UCF_DomUtil["childNodes"](oDomSections, "SPAN"),
			aSectionsList = [],
			oSection;
		for (var i = 0; i < aChildNodes["length"]; i++) {
			oSection = new (UCF_ClassLoader["oGetClass"]("UCF_ColumnLayoutSection"))(aChildNodes[i], this["oLS"]);
			aSectionsList["push"](oSection);
		}
		if (aSectionsList["length"] > 0) return aSectionsList;
	}

	//No Sections where defined
	var aTableRows = this["oDomRef"]["rows"];
	for (var iRows = 1; iRows < aTableRows["length"]; iRows++) {
		var aTableCells = aTableRows[iRows]["cells"];
		for (var iCells = 0; iCells < aTableCells["length"]; iCells++) {
			aTableCells[iCells]["setAttribute"]("sectionid", "ur-pseudosection");
		}
	}
	return [{ "sId": "ur-pseudosection", "sParentSectionId": "" }];

};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["getSectionList"] = 0; };

/**
 * Builds and returns a tree structure of sections with their corresponding cells
 * The structure represents the tab order of the column layout cells
 *
 * @private
 */
UCF_ColumnLayout["prototype"]["oGetNavigationTree"] = function() {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["oGetNavigationTree"]++; }; 

	var aTableRows = this["oDomRef"]["rows"];
	var oSection;
	this["aSectionNames"] = new Array();
	var iSections;
	//build a section map
	for (iSections = 0; iSections < this["aSectionsList"]["length"]; iSections++) {
		oSection = this["aSectionsList"][iSections];
		oSection["iIndex"] = iSections;
		this["aSectionNames"][oSection["sId"]] = oSection;
	}

	//build a section tree
	for (iSections = 0; iSections < this["aSectionsList"]["length"]; iSections++) {
		oSection = this["aSectionsList"][iSections];
		if (oSection["sParentSectionId"]) {
			var oParentSection = this["aSectionNames"][oSection["sParentSectionId"]];
			oSection["oParentSection"] = oParentSection;
		}
	}

	//loop over all sections
	for (iSections = 0; iSections < this["aSectionsList"]["length"]; iSections++) {
		oSection = this["aSectionsList"][iSections];
		oSection["iSectionsTabIndex"] = 0;

		//loop over all rows and their cells and add them as cells to their section
		for (var iRows = 1; iRows < aTableRows["length"]; iRows++) {
			var aTableCells = aTableRows[iRows]["cells"];
			for (var iCells = 0; iCells < aTableCells["length"]; iCells++) {
				var oTableCell = aTableCells[iCells],
					sCellSectionId = oTableCell["getAttribute"]("sectionid"),
					bIgnoreCell = oTableCell["getAttribute"]("ignore") === "true";
				if (bIgnoreCell) continue;
				if (sCellSectionId != null && sCellSectionId !== "" && !this["aSectionNames"][sCellSectionId]) {
					sCellSectionId = "";
					oTableCell["setAttribute"]("sectionid", "");
				}
				if (oSection["sId"] === sCellSectionId) {
					//cell belongs directly to the section
					if (false) {
						oTableCell["setAttribute"]("iSectionsTabIndex", oSection["iSectionsTabIndex"]);
						oTableCell["style"]["border"] = "solid 2px " + this["aSectionColors"][iSections];
					}
					oSection["iSectionsTabIndex"]++;
					if (!oSection["aCells"]) oSection["aCells"] = [];
					oSection["aCells"]["push"](oTableCell);
				} else {
					//check whether the section with sCellSectionId is a child of oSection
					if (sCellSectionId != null && sCellSectionId === "") {
						oSection = this["aSectionsList"][0];
						if (!oSection["aCells"]) oSection["aCells"] = [];
						oSection["iSectionsTabIndex"]++;
						oSection["aCells"]["push"](oTableCell);
						oTableCell["setAttribute"]("ignore", "true");
						continue;
					}
					var oTempSection = this["aSectionNames"][sCellSectionId];
					if (!oTempSection) continue;

					//see if the previous cell is in the
					while (oTempSection && oTempSection["oParentSection"] && !oTempSection["bChecked"]) {
						if (oTempSection["oParentSection"]["sId"] === oSection["sId"]) {
							if (!oSection["aCells"]) oSection["aCells"] = [];
							oSection["aCells"]["push"](oTempSection);
							//a section can only have one parent, therefore mark as checked and avoid second run
							oTempSection["bChecked"] = true;
							oTempSection["iStartRow"] = oTableCell["parentNode"]["rowIndex"];
							oTempSection["iStartColumn"] = oTableCell["cellIndex"];
						}
						oTempSection = oTempSection["oParentSection"];
					}
				}
			}
		}
	}

	this["iIndexCounter"] = 0;

	for (iSections = 0; iSections < this["aSectionsList"]["length"]; iSections++) {
		oSection = this["aSectionsList"][iSections];
		this["buildCellTabIndex"](oSection);
	}
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["oGetNavigationTree"] = 0; };
/**
 * Builds the global tabindex for cells and stores them in this.aGlobalTabIndex
 * @param {UCF_Control} oSection
 */
UCF_ColumnLayout["prototype"]["buildCellTabIndex"] = function(oSection) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["buildCellTabIndex"]++; }; 

	//if the section was already processed exit
	if (oSection["bProcessed"]) return;

	//mark the section as processed to avoid a second loop
	oSection["bProcessed"] = true;

	//if the section does not contain any cells exit
	if (!oSection["aCells"]) return;

	//create the TabOrder array to store the cells in the tab order to access them while keyboard navigation or clicks
	if (!this["aTabOrderCells"]) this["aTabOrderCells"] = [];
	var oParallelSections = [],
		oLastCell = null;
	//loop over all section cells
	for (var iCells = 0; iCells < oSection["aCells"]["length"]; iCells++) {
		var oCell = oSection["aCells"][iCells];
		//oCell can be a td element or a sub section, this handles the case that there are mixtures of subsections and cells
		if (oCell["tagName"]) {
			//is a real cell
			//if debug: oCell.title = "Globale Index = " + this.iIndexCounter;
			//set the cltabindex to the cell to access the index fast while clicking and navigating
			oCell["setAttribute"]("cltabindex", this["iIndexCounter"]);
			this["aTabOrderCells"]["push"]({ "oCell": oCell, "oSection": oSection });
			oLastCell = oCell;
			this["iIndexCounter"]++;
		} else {
			//its a sub section
			var oSubSection = oCell;
			if (iCells > 0 && oLastCell && oSubSection["iStartRow"] === oLastCell["parentNode"]["rowIndex"]) {
				oParallelSections["push"](oCell);
			} else {
				//reursive go over all sub sections of the current section and add them
				this["buildCellTabIndex"](oSubSection);
			}
		}
	}
	for (var i = 0; i < oParallelSections["length"]; i++) {
		this["buildCellTabIndex"](oParallelSections[i]);
	}
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["buildCellTabIndex"] = 0; };

/**
 * Returns the next control that should recieve the focus
 * @return {UCF_Control}
 * @private
 */
UCF_ColumnLayout["prototype"]["oGetNextControl"] = function() {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["oGetNextControl"]++; }; 
	var oControl = null;

	if (!this["bFocusableControlExist"]) return null; //the columnlayout does not have any focusable element

	if (this["iActiveIndex"] >= this["aTabOrderCells"]["length"]) {
		this["oGetPreviousControl"]();
		return null;
	} else {
		this["iActiveIndex"]++;
		if (this["iActiveIndex"] > this["aTabOrderCells"]["length"] - 1) return this["oGetNextControl"]();
		oControl = this["oGetFirstFocusableChildRecursive"](this["aTabOrderCells"][this["iActiveIndex"]]["oCell"]);
		this["oActiveSection"] = this["aTabOrderCells"][this["iActiveIndex"]]["oSection"];
		if (!oControl) {
			this["oActiveSection"] = null;
			return this["oGetNextControl"]();
		} else {
			return oControl;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["oGetNextControl"] = 0; };

/**
 * Returns the previous control that should recieve the focus
 * @return {UCF_Control}
 * @private
 */
UCF_ColumnLayout["prototype"]["oGetPreviousControl"] = function() {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["oGetPreviousControl"]++; }; 
	var oControl = null;

	if (!this["bFocusableControlExist"]) return null; //the columnlayout does not have any focusable element

	if (this["iActiveIndex"] < 0) {
		this["oGetNextControl"]();
		return null;
	} else {
		this["iActiveIndex"]--;
		if (this["iActiveIndex"] < 0) return this["oGetPreviousControl"]();
		oControl = this["oGetLastFocusableChildRecursive"](this["aTabOrderCells"][this["iActiveIndex"]]["oCell"]);
		this["oActiveSection"] = this["aTabOrderCells"][this["iActiveIndex"]]["oSection"];
		if (!oControl) {
			this["oActiveSection"] = null;
			return this["oGetPreviousControl"]();
		} else {
			return oControl;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["oGetPreviousControl"] = 0; };

/**
 * Handles the onlscontainerblur event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_ColumnLayout["prototype"]["onlscontainerblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlscontainerblur"]++; }; 
	UCF_DomUtil["setTabIndex"](UCF_DomUtil["$"](this["sId"] + "-endpoint"), 0);
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlscontainerblur"] = 0; };
/**
 * Handles the onlscontainerfocus event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_ColumnLayout["prototype"]["onlscontainerfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlscontainerfocus"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ColumnLayout.js(314): onlscontainerfocus"); };
	if (!this["bInitialized"]) this["init"]();
	//UCF_DomUtil.resetTabIndex(UCF_DomUtil.$(this.sId + "-endpoint"));

	if (!UCF_DomUtil["bContains"](this["oDomRef"], oBrowserEvent["oFromElement"])) {
		this["oLastAccessibilitySection"] = null;
	}

	//find the activated cell end set the active index
	var oSource = oBrowserEvent["oGetSource"]();

	if (oBrowserEvent["oGetSourceControl"]() !== this) {
		for (var i = 0; i < this["aTabOrderCells"]["length"]; i++) {
			if (UCF_DomUtil["bContains"](this["aTabOrderCells"][i]["oCell"], oSource)) {
				//remember the old index for skipping
				this["iActiveIndex"] = i;
				this["oActiveSection"] = this["aTabOrderCells"][i]["oSection"];

				var oDefaultButtonSection = this["oActiveSection"];

				while (oDefaultButtonSection) {
					//highlight a default button by using the hierarchy given by the section. In case of a enter hotkey stop bubbling and default button visulization. If a section has a enter hotkey and default button the default button wins
					if (oDefaultButtonSection["sHotkeysId"] != null && oDefaultButtonSection["sHotkeysId"] !== '') {
						var oHotkeys = this["oGetControlById"](oDefaultButtonSection["sHotkeysId"]);

						if (oHotkeys != null && oHotkeys["oGetHotkey"](UCF_KeyCodes["ENTER"], false, false, false)) {
							if (oDefaultButtonSection["sDefaultButtonId"] == null || oDefaultButtonSection["sDefaultButtonId"] === '') {
								this["setDefaultButtonId"](null);
								break;
							}
						}
					}

					if (oDefaultButtonSection["sDefaultButtonId"]) {
						this["setDefaultButtonId"](oDefaultButtonSection["sDefaultButtonId"]);
						break;
					}
					oDefaultButtonSection = oDefaultButtonSection["oParentSection"];
				}

				UCF_Control.prototype["onlscontainerfocus"]["apply"](this, arguments);
				return;
			}
		}
	}

	UCF_Control.prototype["onlscontainerfocus"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlscontainerfocus"] = 0; };

/**
 * Handles the onlshotkey event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_ColumnLayout["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlshotkey"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ColumnLayout.js(371): onlshotkey"); };
	if (!this["bInitialized"]) this["init"](); //ToDo clarify with martin if this is needed here.

	var oHotkey = null,
		oHotkeys = null,
		sectionId = "";

	//assume this.oActiveSection contains the section of the currently focussed control

	if (this["oActiveSection"]) {
		var oSection = this["oActiveSection"];

		while (oSection) {
			if (oSection["sHotkeysId"]) {
				oHotkeys = this["oGetControlById"](oSection["sHotkeysId"]);

				if (oHotkeys != null) {
					oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

					if (oHotkey) {
						if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
							oBrowserEvent["cancel"]();
						}
						oBrowserEvent["cancelBubble"]();
						sectionId = (this["sId"] !== oSection["sId"]) ? oSection["sId"] : ""; //check if the hotkey was defined at section otherwise use empty sectionId

						if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
							this["oLS"]["fireBeforeHotkey"]();
							this["fireHotkey"](this["sId"], sectionId, oHotkey["sHotkey"], oHotkey["sProviderId"]);
						}
						return;
					}
				}
			}

			if (oSection["oParentSection"])
				oSection = oSection["oParentSection"];
			else {
				//check the columnLayout for hotkeys if all section were checked or no section are defined
				if (oSection !== this) oSection = this;
				else oSection = null;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlshotkey"] = 0; };

UCF_ColumnLayout["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]("UCF_Hotkeys")["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onkeypress"] = 0; };

/**
 * Handles the onlsfocus event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_ColumnLayout["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlsfocus"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ColumnLayout.js(431): onlsfocus"); };

	if (!this["bInitialized"]) this["init"]();

	var oSource = oBrowserEvent["oGetSource"]();
	// if the user presses tab back the hidden element with fr=CLC will get the focus and delegates to the previous element
	// the user cannot reach theses elements by mouse

	if (oSource["getAttribute"]("fr") && oSource["getAttribute"]("fr") === "CLC") {
		this["focusPreviousCellControl"](oBrowserEvent);
	}
	// if the user presses tab forward the hidden element with fr=CLCE will get the focus and delegates to the next element
	// the user cannot reach theses elements by mouse
	else if (oSource["getAttribute"]("fr") && oSource["getAttribute"]("fr") === "CLCE") {
		var bNext = this["focusNextCellControl"](oBrowserEvent);
		if (!bNext) {
			//TODO: replace by UCF_DomUtil.nextSibling
			var oNext, oFocusTo;
			oNext = UCF_DomUtil["oGetNextSibling"](this["oDomRef"], true);
			if (oNext) oFocusTo = UCF_DomUtil["oGetTabbableElementForward"](oNext, true);

			if (oFocusTo) {
				UCF_DomUtil["focusDomElement"](oFocusTo);
			} else {
				this["oLS"]["focusEnd"]();
			}
		}

	} else if (oSource["getAttribute"]("fr") && oSource["getAttribute"]("fr") === "CLKEYENTER") {
		this["iActiveIndex"] = -1;
		this["focusNextCellControl"](oBrowserEvent);
	} else if (oSource["getAttribute"]("id") && oSource["getAttribute"]("id")["indexOf"]("-endpoint") > -1) {
		this["iActiveIndex"] = this["aTabOrderCells"]["length"];
		this["focusPreviousCellControl"](oBrowserEvent);
	}

	this["bIgnoreFocus"] = false;
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlsfocus"] = 0; };

/**
 * Focus the next control in a column layout cell
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 * @return {boolean}
 */
UCF_ColumnLayout["prototype"]["focusNextCellControl"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["focusNextCellControl"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ColumnLayout.js(479): focusNextCellControl"); };

	var oControl = this["oGetNextControl"]();
	if (oControl) {
		oControl["moveFocus"]();
		this["bMoved"] = oBrowserEvent["sGetName"]() === "lsfocus";
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else {
		//let the browser take care of the next element to focus
		this["oActiveSection"] = null;
		this["oLastAccessibilitySection"] = null;
		//focus the next element that has a tabindex=0;
		var oDomElem = this["oDomRef"];
		var oFirstChild;

		while (oDomElem) {
			//TODO: replace by UCF_DomUtil.nextSibling
			oDomElem = UCF_DomUtil["oGetNextSibling"](oDomElem);
			if (oDomElem) {
				if (!UCF_DomUtil["bIsVisible"](oDomElem)) continue;
				if (oDomElem && oDomElem["ti"] === "0") break;
				oFirstChild = UCF_DomUtil["firstChild"](oDomElem);
				if (oFirstChild && UCF_DomUtil["bIsVisible"](oFirstChild))
					oDomElem = this["oGetFirstTabindexedChild"](oFirstChild);
				if (oDomElem && oDomElem["ti"] === "0") break;
			}
		}
		if (oDomElem) {
			UCF_DomUtil["focusDomElement"](oDomElem);
			return true;
		}
		if (this["focusNextControl"]()) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			return true;
		} else {
			//No focusable control after the column layout then leave it up to ls object to find the next element
			UCF_DomUtil["setTabIndex"](UCF_DomUtil["$"](this["sId"] + "-endpoint"), 0);
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "" + UCF_DomUtil["$"](this["sId"] + "-endpoint")["ti"], "ColumnLayout.js(518): focusNextCellControl"); };
			this["oLS"]["focusEnd"]();
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "" + UCF_DomUtil["$"](this["sId"] + "-endpoint")["ti"], "ColumnLayout.js(520): focusNextCellControl"); };
			return true;
		}

	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["focusNextCellControl"] = 0; };

/**
 * Finds the forst focusable element after or inside a fom reference
 * @param {HTMLElement} oDomRef
 * @return {HTMLElement}
 */
UCF_ColumnLayout["prototype"]["oGetFirstTabindexedChild"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["oGetFirstTabindexedChild"]++; }; 
	var oFirstChild;
	while (oDomRef && UCF_DomUtil["bIsVisible"](oDomRef)) {
		if (oDomRef["getAttribute"]("ti") === "0") {
			return oDomRef;
		}
		oFirstChild = UCF_DomUtil["firstChild"](oDomRef);
		if (oFirstChild) {
			return this["oGetFirstTabindexedChild"](oFirstChild);
		}

		//TODO: replace by UCF_DomUtil.nextSibling
		oDomRef = oDomRef["nextSibling"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["oGetFirstTabindexedChild"] = 0; };

/**
 * Focus the previous control in a column layout cell
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 * @return {boolean}
 */
UCF_ColumnLayout["prototype"]["focusPreviousCellControl"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["focusPreviousCellControl"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ColumnLayout.js(559): focusPreviousCellControl"); };
	var oControl = this["oGetPreviousControl"]();

	if (oControl) {
		var oLastChild = oControl["oGetLastFocusableChild"]();
		if (oLastChild) {
			oLastChild["moveFocus"]();
		} else {
			oControl["moveFocus"]();
		}
		this["bMoved"] = oBrowserEvent["sGetName"]() === "lsfocus";
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else {
		//let the browser find the next control
		this["oActiveSection"] = null;
		this["oLastAccessibilitySection"] = null;
		if (this["focusPreviousControl"]()) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			return true;
		} else {
			document["body"]["focus"]();
		}
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["focusPreviousCellControl"] = 0; };

/**
 * Handle the lsskipback event that leads to the previous section of the colum layout or the previous control.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_ColumnLayout["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlsskipback"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ColumnLayout.js(595): onlsskipback"); };

	var oCell = null,
		oSection = this["aTabOrderCells"][this["iActiveIndex"]]["oSection"];
	if (!oSection || !oSection["aCells"] || oSection["aCells"]["length"] === 0) {
		this["handleSkipBack"](oBrowserEvent);
		return;
	}
	oCell = oSection["aCells"][0];
	for (var i = this["iActiveIndex"]; i >= 0; i--) {
		//look for the first cell in the current section
		if (this["aTabOrderCells"][i]["oCell"] === oCell) {
			this["iActiveIndex"] = i;
			//focus the previous cell
			if (this["focusPreviousCellControl"](oBrowserEvent)) {
				oBrowserEvent["cancel"]();
				oBrowserEvent["cancelBubble"]();
			}
			return;
		}
	}

	this["handleSkipBack"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlsskipback"] = 0; };

/**
 * Handle the lsskipforward event that leads to the next section in this columnlayout or the next control
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event object that triggered the event
 */
UCF_ColumnLayout["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlsskipforward"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ColumnLayout.js(629): onlsskipforward"); };

	var oCell = null,
		oSection = this["aTabOrderCells"][this["iActiveIndex"]]["oSection"];
	if (!oSection && !oSection["aCells"] || oSection["aCells"]["length"] === 0) {
		this["handleSkipForward"](oBrowserEvent);
		return;
	}
	oCell = oSection["aCells"][oSection["aCells"]["length"] - 1];
	for (var i = this["iActiveIndex"]; i < this["aTabOrderCells"]["length"]; i++) {
		if (this["aTabOrderCells"][i]["oCell"] === oCell) {
			this["iActiveIndex"] = i;
			if (this["focusNextCellControl"](oBrowserEvent)) {
				oBrowserEvent["cancel"]();
				oBrowserEvent["cancelBubble"]();
			}
			return;
		}
	}
	this["handleSkipForward"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlsskipforward"] = 0; };

/**
 * Handles the onlsaccessibility event for the ColumnLayout that adds the section whenever the section changed
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_ColumnLayout["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ColumnLayout.js(658): onlsaccessibility"); };

	//if the focus was moved to another element do not process the accessibility for the column layout
	//otherwise the section information will be lost
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "bMoved=" + this["bMoved"], "ColumnLayout.js(662): onlsaccessibility"); };
	if (this["bMoved"]) {
		this["bMoved"] = false;
		return;
	}
	if (this["oActiveSection"]) {
		if (this["oLastAccessibilitySection"] !== this["oActiveSection"]) {
			var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
				sSectionText = "",
				oParentSection = this["oActiveSection"]["oParentSection"],
				oLastParentSection = null;
			if (this["oLastAccessibilitySection"]) {
				oLastParentSection = this["oLastAccessibilitySection"]["oParentSection"];
			}

			var aSections = [],
				sSeparatorText = oAccessibilityHelper["sGetText"]("SEPARATOR");

			aSections["push"](this["oActiveSection"]);

			//Build section array to announce section hierarchy of column layout
			//First loop and push the section objects
			while (oParentSection && (oLastParentSection !== oParentSection)) {
				aSections["push"](oParentSection);
				oParentSection = oParentSection["oParentSection"];
				if (oLastParentSection) {
					oLastParentSection = oLastParentSection["oParentSection"];
				}
			}
			//for loop backward and add the texts
			for (var i = aSections["length"] - 1; i >= 0; i--) {
				if (aSections[i]["sAccessibilityDescription"]) {
					if (sSectionText) sSectionText += " " + sSeparatorText + " ";
					sSectionText += aSections[i]["sAccessibilityDescription"];
				}
				if (aSections[i]["sTooltip"]) {
					oAccessibilityHelper["addTooltip"](aSections[i]["sTooltip"]);
				}
			}

			if (sSectionText) {
				oAccessibilityHelper["setGroupText"](sSectionText);
			}

			if (!oAccessibilityHelper["bIsContainerEntryBehaviourApplied"]())
				oAccessibilityHelper["addTutor"]("SKIP");

			this["oLastAccessibilitySection"] = this["oActiveSection"];

		}
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 */
UCF_ColumnLayout["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["destroy"]++; }; 
	this["oNavigationTree"] = null;
	this["oActiveSection"] = null;
	this["aSectionNames"] = null;
	this["aSectionsList"] = null;
	this["oLastAccessibilitySection"] = null;
	this["iActiveIndex"] = null;
	this["bMoved"] = null;
	this["bFocusableControlExist"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ColumnLayout["prototype"]["aAttributeNames"] = ["sVisibility","sHotkeysId","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ColumnLayout["prototype"]["aEventNames"] = ["Hotkey"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ColumnLayout["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ColumnLayout["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ColumnLayout["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ColumnLayout["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ColumnLayout["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sHotkeysId"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sSectionId Identifier of the section defining and handing the hotkey. If sectionId is empty the hotkey was defined at the ColumnLayout itself.
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires ColumnLayout::Hotkey
 */
UCF_ColumnLayout["prototype"]["fireHotkey"] = function(sId, sSectionId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, SectionId: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "ColumnLayout.js(801): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ColumnLayout.js(802): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ColumnLayout.js(803): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSectionId != null, "sSectionId != null", "ColumnLayout.js(804): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSectionId) == "string", "typeof(sSectionId) == \"string\"", "ColumnLayout.js(805): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "ColumnLayout.js(806): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "ColumnLayout.js(807): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "ColumnLayout.js(808): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "ColumnLayout.js(809): fireHotkey"); };
	mParams = {
		"Id": sId,
		"SectionId": sSectionId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	if (sSectionId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sSectionId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "SectionId");
			}
		}
	
	if (sProviderId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sProviderId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ProviderId");
			}
		}
	this["fireSemanticEvent"]("ColumnLayout", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ColumnLayout["_"]["fireHotkey"] = 0; };

};
sap["ls"]["preload"]["UCF_ColumnLayoutSection"] = function() {/* global UCF_ControlInfo */
/// <reference path="../core/ControlInfo.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ColumnLayoutSection(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ColumnLayoutSection["_"]["UCF_ColumnLayoutSection"]++; }; 
	UCF_ControlInfo["apply"](this, [oDomRef, oLS]);
};window["UCF_ColumnLayoutSection"] = UCF_ColumnLayoutSection; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ColumnLayoutSection"); UCF_ColumnLayoutSection["_"] = {UCF_ColumnLayoutSection: 0}; }; ;
UCF_ColumnLayoutSection["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ControlInfo"))(); UCF_ColumnLayoutSection.prototype["sClassName"] = "UCF_ColumnLayoutSection";

/**
 * Sets the default button id for the control
 *
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 * @public
 */
UCF_ColumnLayoutSection["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_ColumnLayoutSection["_"]["setDefaultButtonId"]++; }; 
	UCF_ControlInfo.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_ColumnLayoutSection["_"]["setDefaultButtonId"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ColumnLayoutSection["prototype"]["aAttributeNames"] = ["sId","sAccessibilityDescription","sTooltip","sParentSectionId","sDefaultButtonId","sHotkeysId","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ColumnLayoutSection["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ColumnLayoutSection["prototype"]["aMethodNames"] = ["setDefaultButtonId","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_ColumnLayoutSection["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ColumnLayoutSection["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ColumnLayoutSection["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ColumnLayoutSection["prototype"]["sParentSectionId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ColumnLayoutSection["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ColumnLayoutSection["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ColumnLayoutSection["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ColumnLayoutSection["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ColumnLayoutSection["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sAccessibilityDescription"] = '';
	this["sTooltip"] = '';
	this["sParentSectionId"] = '';
	this["sDefaultButtonId"] = '';
	this["sHotkeysId"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("ParentSectionId", '', true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ColumnLayoutSection["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_ColumnLayoutSection.prototype["aPublicMethods"] = ["setDefaultButtonId"].concat(UCF_ColumnLayoutSection.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ComboBox"] = function() {/* global UCF_EditFieldBase */
/// <reference path="./base/EditFieldBase.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_Exception */
/// <reference path="../core/Exception.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_Tracer, _assert, _trace, INFO, DEBUG, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>

/**
 * 
 *
 * @class
 * @extends UCF_EditFieldBase
 *
 * @param {HTMLElement} oDomRef the DOM element of the ComboBox
 * @param {UCF_LS} oLS the LightSpeed instance managing the ComboBox
 */
function UCF_ComboBox(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["UCF_ComboBox"]++; };  // eslint-disable-line @ur/no-memory-leaks
	if (arguments["length"] === 0) {
		return;
	}

	UCF_EditFieldBase["apply"](this, [oDomRef, oLS]);

	/**
	 * Timer for selection with keyboard. For example arrow up/down.
	 *
	 * @private
	 * @type {boolean}
	 */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oSelectTimer"] = null;

	/**
	 * Save key when you start changing the content. Will be updated when change
	 * or select is fired.
	 * @private
	 * @type {string}
	 */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sKeySave"] = this["sKey"];
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sEscapeKey"] = '';

	/**
	 * Save value when you start changing the content. Will be updated when
	 * change or select is fired.
	 * @private
	 * @type {string}
	 */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sValueSave"] = this["sValue"];
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sEscapeValue"] = '';
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sOldValue"] = this["sValue"];

	/**
	 * The value that was sent in the last ComboBox:Change event
	 * @type {string}
	 */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sLastSubmittedValue"] = this["sValue"];

	/**
	 * The linked item listbox
	 *
	 * @private
	 * @type {UCF_ItemListBox}
	 */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oFieldHelp"] = null;

	/**
	 * Open or closed state of the attached item listbox
	 *
	 * @private
	 * @type {boolean}
	 */
	this["bOpen"] = false;

	/**
	 * Flag to know if the list access event must be fired. Do not fire
	 * the list access event when you interact with the combo box or
	 * directly after the list is loaded.
	 *
	 * @private
	 * @type {boolean}
	 */
	this["bFireListAccess"] = true;

	/**
	 * String to save the typed characters. Necessary for virtual typing for drop
	 * downs.
	 * @private
	 * @type {string}
	 */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sSearchString"] = '';

	/**
	 * flag to know if the last action was a list naviagtion, e.g. [UP]/[DOWN]
	 * @private
	 * @type {boolean}
	 */
	this["bListNavigation"] = false;

	/**
	 * time stamp when the last keypress occurred
	 *
	 * @private
	 * @type {number}
	 */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iLastKeypress"] = null;

	this["oLS"]["attachEvent"](
		this["oLS"]["E_EVENTS"]["Lock"],
		this,
		'lockListAccess'
	);
	this["oLS"]["attachEvent"](
		this["oLS"]["E_EVENTS"]["Unlock"],
		this,
		'onlsunlock'
	);
	this["attachEvent"](
		this["E_EVENTS"]["WillDestroy"],
		this,
		'onWillDestroyComboBox'
	);

	this["lockListAccessEvents"] = false;

	// attach events for enabled input fields
	if (this["bIsWriteable"]()) {
		// use blur instead of lsblur to fire change event because value has not
		// changed on lsblur when you drag the value away
		// attach blur only for ie, blur is already attached in firefox
		if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
			this["attachBrowserEvent"]('blur', oDomRef);
		}
	}

	// Force select event delayed
	this["forceDelayed"] = false;

	/** @type {boolean} */
	this["bIgnoreNextFocuslost"] = false;
	/** @type {boolean} */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bShouldCloseListboxOnResize"] = !this["bUsedInSapTable"]
		// eslint-disable-next-line no-magic-numbers
		&& !UCF_UserAgent["bIsTrident"](4)
		&& !UCF_UserAgent["bIsEdgeHtml"]();

	/** @type {number} */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iOptimalNumberOfItems"] = null;

	/** @type {boolean} */
	// true if the ListAccess was triggered explicitly by pressing
	// [ALT][DOWN] or [ALT][UP] or [UP] or [DOWN]
	this["bIsExplicitListAccess"] = false;

	this["attachEvent"](this["E_EVENTS"]["WillFireChange"], this, 'onWillFireChange');
	this["attachEvent"](this["E_EVENTS"]["FireChange"], this, 'onFireChange');
	this["attachEvent"](this["E_EVENTS"]["DidFireChange"], this, 'onDidFireChange');
};window["UCF_ComboBox"] = UCF_ComboBox; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ComboBox"); UCF_ComboBox["_"] = {UCF_ComboBox: 0}; }; ;
UCF_ComboBox["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EditFieldBase"))(); UCF_ComboBox.prototype["sClassName"] = "UCF_ComboBox";

/**
 * @private
 * @override
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 * @throws {UCF_Exception} if not enabled
 */
UCF_ComboBox["prototype"]["onBeforeLsFocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeLsFocus"]++; }; 
	if (!this["getEnabled"]()) {
		oBrowserEvent["cancelBubble"]();
		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('not enabled => canceling lsfocus');
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeLsFocus"] = 0; };

/**
 * @private
 * @override
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_ComboBox["prototype"]["onAfterLsFocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsFocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBox.js(214): onAfterLsFocus"); };

	this["sOldValue"] = this["sGetValue"]();
	this["sEscapeValue"] = this["sOldValue"];
	this["sEscapeKey"] = this["sKey"];
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsFocus"] = 0; };

/**
 * @protected
 * @param {UCF_Event} oEvent the AfterRequest
 */
UCF_ComboBox["prototype"]["onAfterResponse"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterResponse"]++; }; 
	this["oLS"]["detachBeforeEvent"](this["oLS"]["E_EVENTS"]["AfterResponse"], this, 'onAfterResponse');
	this["unlockListAccess"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterResponse"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["onBeforeHideRequiredIndicator"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeHideRequiredIndicator"]++; }; 
	if (!this["sValue"] && this["sGetDomRefValue"]() && this["oFieldHelp"] && this["sKey"]) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sValue"] = this["oFieldHelp"]["sGetItemValue"](this["sKey"]);
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Value", this["sValue"], true);
	}
	UCF_EditFieldBase.prototype["onBeforeHideRequiredIndicator"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeHideRequiredIndicator"] = 0; };

/**
 * Handles the onclick event of the browser
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_ComboBox["prototype"]["onAfterClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterClick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBox.js(247): onAfterClick"); };

	// check if it is a combo box click, do not handles list box clicks
	if (
		oBrowserEvent["oGetSourceControl"]() === this &&
		!this["bSkipEventProcessing"](oBrowserEvent)
	) {
		if (
			(this["sBehavior"] === 'DROPDOWNSELECT' && (
				!this["getEnabled"]() ||
				!this["bHasEventListeners"]('Activate'))) ||
			oBrowserEvent["oSource"] === this["oGetHelpButtonRef"]()
		) {
			this["handleHelpButtonPress"]();
		}

		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterClick"] = 0; };

/**
 * @override
 * @return {boolean} `true` if a change should be fired, otherwise `false`
 */
UCF_ComboBox["prototype"]["bShouldFireChangeOnDblclick"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldFireChangeOnDblclick"]++; }; 
	return this["sBehavior"] === 'FREETEXT' && UCF_EditFieldBase.prototype["bShouldFireChangeOnDblclick"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldFireChangeOnDblclick"] = 0; };

UCF_ComboBox["prototype"]["onBeforeLsBlur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeLsBlur"]++; }; 
	var oRelatedRef;
	var oRelatedControl;

	if (UCF_UserAgent["bIsFirefox"]() && this["bOpen"] && this["oFieldHelp"]) {
		oRelatedRef = UCF_DomUtil["oGetRelatedTarget"](oBrowserEvent["oDomEvent"]);

		if (oRelatedRef) {
			oRelatedControl = this["oLS"]["oControlFactory"]["oGetEnclosingControlByDomRef"](
				oRelatedRef
			);

			if (
				(oRelatedControl && oRelatedControl["oGetParent"]() === this["oFieldHelp"]) ||
				oRelatedControl === this
			) {
				throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('Firefox fires blur when clicking ListBox');
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeLsBlur"] = 0; };

/**
 * @override
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsblur
 */
UCF_ComboBox["prototype"]["onAfterLsBlur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsBlur"]++; }; 
	/** @type {HTMLElement} */
	var oSource;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBox.js(306): onAfterLsBlur"); };

	oSource = oBrowserEvent["oGetSource"]();

	if (oSource === this["oDomRef"] ||
		oSource === this["oRootRef"]) {
		// load listbox again when you come back to the field
		if (this["oFieldHelp"] &&
			this["bHasEventListeners"]('FieldHelpPress') &&
			this["sSuggestFilter"] === 'OFF'
		) {
			this["oFieldHelp"]["bAvailable"] = false;
		}

		// Set the fire list access flag to true to ensure that the list access
		// event ist fired when you start interaction with the combo box the next
		// time
		this["bFireListAccess"] = true;

		// do not close list box if the soft keyboard is hidden on a touch device
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'closing listbox', "ComboBox.js(326): onAfterLsBlur"); };
		if (!this["bShouldShowOverlay"]()) {
			this["closeFieldHelp"]();
		}

		// initialize listbox
		if (this["oFieldHelp"]) {
			this["oFieldHelp"]["detachAllEvents"](this);
			this["oFieldHelp"] = null;
		}

		// 1780119710: as a workaround we need to add aria attributes also in 508
		// else JAWS 17/18 does not announce the items within a list properly
		if (window["UCF_System"]["bIsAria"] || window["UCF_System"]["bIs508"]) {
			UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], '');
		}
	}

	UCF_EditFieldBase.prototype["onAfterLsBlur"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsBlur"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the blur
 * @private
 */
UCF_ComboBox["prototype"]["onblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onblur"]++; }; 
	if ((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) &&
		oBrowserEvent["oSource"] !== this["oDomRef"]
	) {
		if (this["bNoBlur"]) {
			// eslint-disable-next-line @ur/no-memory-leaks
			this["bNoBlur"] = false; // allow blur the next time
		} else if (!window["UCF_System"]["bIs508"] &&
			(window["UCF_System"]["sDevice"] === 'standards' || !this["sInputPrompt"] || (
				this["sInputPrompt"] &&
				this["sGetValue"]() !== this["sInputPrompt"])) &&
			// CSN 1570843318
			!this["bIsPerceivedChild"](UCF_DomUtil["oGetActiveElement"]())
		) {
			// necessary for drag to check again if value has changed
			try {
				this["prepareFireChange"]();
			} catch (oException) {
				this["handleEarlyHandlerLeave"](oException);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onblur"] = 0; };

/**
 * @param {HTMLElement} oElement the DOM element that should be checked
 * @return {boolean} `true` if the element is a perceived child of the
 * combobox, otherwise `false`
 * @private
 */
UCF_ComboBox["prototype"]["bIsPerceivedChild"] = function(oElement) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bIsPerceivedChild"]++; }; 
	/** @type {UCF_Control} */
	var oControl;
	/**
	 * @type {Array.<string>} aPredicates using text references instead of
	 * functions directly to keep `this` at the right value
	 */
	var aPredicates = ['bIsCorrespondingItemListBoxItem'];
	/** @type {number} */
	var i;

	if (oElement) {
		oControl =
			(this["oFieldHelp"] && this["oFieldHelp"]["oGetControlByDomRef"](oElement)) ||
			this["oLS"]["oControlFactory"]["oGetEnclosingControlByDomRef"](oElement);

		// faster than aPredicates.reduce((v, p) -> v || p(oControl), false)
		// as this is allows leaving the loop early
		for (i = 0; i < aPredicates["length"]; i += 1) {
			if (this[aPredicates[i]](oControl)) {
				return true;
			}
		}

		return false;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bIsPerceivedChild"] = 0; };

/**
 * @private
 * @param {UCF_Control} oControl the control to be checked
 * @return {boolean} `true` if `oControl` is an ItemListBoxItem of the
 * connected ItemListBox, otherwise `false`
 */
UCF_ComboBox["prototype"]["bIsCorrespondingItemListBoxItem"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bIsCorrespondingItemListBoxItem"]++; }; 
	return (
		UCF_JsUtil["bInstanceOf"](oControl, 'UCF_ItemListBoxItem') ||
		UCF_JsUtil["bInstanceOf"](oControl, 'UCF_Listbox_Item')
	) && this["oLS"]["oControlFactory"]["oGetEnclosingControlByDomRef"](
		oControl["oDomRef"]["parentElement"]
	)["sId"] === this["oFieldHelp"]["sId"];
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bIsCorrespondingItemListBoxItem"] = 0; };

/**
 * @param {UCF_Control} oControl the control to check
 * @return {boolean} `true` if control is connected to the ComboBox,
 * otherwise `false`
 */
UCF_ComboBox["prototype"]["bIsConnectedControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bIsConnectedControl"]++; }; 
	return UCF_EditFieldBase.prototype["bIsConnectedControl"]["call"](this, oControl) ||
		(
			this["bOpen"] &&
			this["oFieldHelp"] &&
			UCF_DomUtil["bContains"](this["oFieldHelp"]["oRootRef"], oControl["oDomRef"])
		);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bIsConnectedControl"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the keydown
 * @throws {UCF_Exception} if keydown handling should be canceled
 */
UCF_ComboBox["prototype"]["onBeforeKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeKeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBox.js(446): onBeforeKeydown"); };

	if (this["bShouldWorkaroundFirefoxDoubleTabs"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('Firefox duplicate tab occurred');
	}

	if (this["oDataTip"]) {
		this["oDataTip"]["close"]();
	}

	if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["BACKSPACE"]
		)) {
		this["handleBackspaceKeydown"](oBrowserEvent);
	} else if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["ARROW_UP"],
			'A'
		) && !oBrowserEvent["bRepeat"]()) {
		this["handleAltUpKeydown"](oBrowserEvent);
	} else if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["ARROW_DOWN"],
			'A'
		) && !oBrowserEvent["bRepeat"]()) {
		this["handleAltDownKeydown"](oBrowserEvent);
	} else if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["F4"]
		) && !oBrowserEvent["bRepeat"]()) {
		this["handleF4Keydown"](oBrowserEvent);
	} else if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["DELETE"]
		)) {
		this["handleDeleteKeydown"](oBrowserEvent);
	}

	UCF_EditFieldBase.prototype["onBeforeKeydown"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeKeydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the keydown
 * @return {boolean} `true` if the workaround should be applied,
 * otherwise `false`
 */
UCF_ComboBox["prototype"]["bShouldWorkaroundFirefoxDoubleTabs"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldWorkaroundFirefoxDoubleTabs"]++; }; 
	return UCF_UserAgent["bIsFirefox"]()
		&& this["bUsedInSapTable"]
		&& oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["TAB"]
		&& this["sSuggestFilter"] !== 'OFF';
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldWorkaroundFirefoxDoubleTabs"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the [BACKSPACE] keydown
 */
UCF_ComboBox["prototype"]["handleBackspaceKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleBackspaceKeydown"]++; }; 
	if (this["sBehavior"] === 'DROPDOWNSELECT' || !this["bIsWriteable"]()) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('[BACKSPACE] in readonly field');
	} else if (document["selection"] && this["sGetValue"]() !== '') {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleBackspaceKeydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the [ALT][UP] keydown
 */
UCF_ComboBox["prototype"]["handleAltUpKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleAltUpKeydown"]++; }; 
	this["bIsExplicitListAccess"] = true;
	this["handleFieldHelpPressKeydown"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleAltUpKeydown"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent a keydown that triggers a FieldHelpPress
 * @throws {UCF_Exception} if field is readonly
 */
UCF_ComboBox["prototype"]["handleFieldHelpPressKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleFieldHelpPressKeydown"]++; }; 
	// ALT + up/down or F4: open or close the list box
	if (this["getEnabled"]()) {
		if (this["oFieldHelp"] && this["oFieldHelp"]["bOpened"]) {
			// fires a possible action item event
			this["oFieldHelp"]["sGetSelectedItemKey"]();
		}

		this["handleHelpButtonPress"](oBrowserEvent["iKeyCode"]() !== UCF_KeyCodes["F4"]);

		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	} else {
		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('[ALT][UP]/[ALT][DOWN]/[F4] in readonly field');
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleFieldHelpPressKeydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the [ALT][DOWN] keydown
 */
UCF_ComboBox["prototype"]["handleAltDownKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleAltDownKeydown"]++; }; 
	this["bIsExplicitListAccess"] = true;
	this["handleFieldHelpPressKeydown"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleAltDownKeydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the [F4] keydown
 */
UCF_ComboBox["prototype"]["handleF4Keydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleF4Keydown"]++; }; 
	this["bIsExplicitListAccess"] = true;
	this["handleFieldHelpPressKeydown"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleF4Keydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the [DELETE] keydown
 */
UCF_ComboBox["prototype"]["handleDeleteKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleDeleteKeydown"]++; }; 
	/** @type {string} */
	var sValue;
	/** @type {string} */
	var sKey;
	/** @type {UCF_ItemListBoxItem} */
	var oSelectedItem;
	/** @type {number} */
	var iCursorPos;
	/** @type {string} */
	var userSelection;

	// required to stop timer to avoid a value change after deleting
	// a deletable history item
	this["bIsDeleteOnHistoryItem"] = false;

	if (this["oNavigation"]["bIsEditMode"]()) {
		// only dropdown: select item with initial key when you hit delete
		if (this["sBehavior"] === 'DROPDOWNSELECT' && this["oFieldHelp"]) {
			sValue = this["oFieldHelp"]["sGetItemValue"]('');
			if (sValue) {
				this["oFieldHelp"]["selectItem"]('');
				this["updateValue"]('', sValue, true);
			}
			oBrowserEvent["cancel"]();
		} else if (this["bOpen"]) {
			oSelectedItem = this["oFieldHelp"]["oGetSelectedItem"]();
			if (oSelectedItem && oSelectedItem["bIsDeletable"]) {
				// check whether the cursor is at the end of the fields text
				iCursorPos = this["iGetSelectionEnd"]();
				if (__UCF_IE6__) {
					userSelection = document["selection"]["createRange"]();
				}
				if (
					(userSelection && !userSelection["text"]) || (
						iCursorPos > 0 &&
						iCursorPos === this["sGetCurrentValue"]()["length"] &&
						iCursorPos === this["iGetSelectionStart"]())
				) {
					this["bIsDeleteOnHistoryItem"] = true;
					sKey = oSelectedItem["sKey"];
					this["oFieldHelp"]["handleDeleteItem"]();
					this["fireDeleteItem"](this["sId"], sKey);
					oBrowserEvent["cancel"]();
				}

			} else {
				sValue = this["getText"]();
				if (sValue) {
					this["updateValue"]('', sValue, true);
				}
			}
		}

		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleDeleteKeydown"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["onAfterPaste"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterPaste"]++; }; 
	if (this["sKey"]) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sKey"] = '';
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Key", '', true);
		this["setInteractionState"]({ "FocusOnInput": true });
		if (this["oFieldHelp"]) {
			this["oFieldHelp"]["clearFocus"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterPaste"] = 0; };

/**
 * @override
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleft
 */
UCF_ComboBox["prototype"]["onAfterLsLeft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsLeft"]++; }; 
	if (this["sBehavior"] === 'DROPDOWNSELECT') {
		oBrowserEvent["cancel"]();
	}
	this["setInteractionState"]({ "FocusOnInput": true });
	if (this["oFieldHelp"]) {
		this["oFieldHelp"]["clearFocus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsLeft"] = 0; };

/**
 * @override
 * @param {UCF_BrowserEvent} oBrowserEvent the lsright
 */
UCF_ComboBox["prototype"]["onAfterLsRight"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsRight"]++; }; 
	if (this["sBehavior"] === 'DROPDOWNSELECT') {
		oBrowserEvent["cancel"]();
	}
	this["setInteractionState"]({ "FocusOnInput": true });
	if (this["oFieldHelp"]) {
		this["oFieldHelp"]["clearFocus"]();
	}

};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsRight"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["bShouldHandleLsUp"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldHandleLsUp"]++; }; 
	return this["bIsOpen"]() || UCF_EditFieldBase.prototype["bShouldHandleLsUp"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldHandleLsUp"] = 0; };

/**
 * @override
 * @param {UCF_BrowserEvent} oBrowserEvent the lsup
 *
 */
UCF_ComboBox["prototype"]["onAfterLsUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsUp"]++; }; 
	/** @type {UCF_ComboBox} */
	var self = this;

	this["handleLsUpDownKeys"](oBrowserEvent, 'handlePreviousItem', function() {
		if (self["bHasEventListeners"]('ListAccess') &&
			self["getListBox"]() &&
			(
				UCF_JsUtil["bInstanceOf"](self["oFieldHelp"], 'UCF_SuggestBoxListBox') ||
				(UCF_JsUtil["bInstanceOf"](self["oFieldHelp"], 'UCF_Listbox_Popup') && self["oFieldHelp"]["filterList"])
			) &&
			self["oFieldHelp"]["bFiltered"] &&
			!self["oFieldHelp"]["bOpened"]
		) {
			// 1570529528: fire list access if there is a list but it was close due
			// to a none matching filter
			self["oFieldHelp"]["bAvailable"] = false;
			self["bFireListAccess"] = true;
		}
	});
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsUp"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["bShouldHandleLsDown"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldHandleLsDown"]++; }; 
	return this["bIsOpen"]() || UCF_EditFieldBase.prototype["bShouldHandleLsDown"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldHandleLsDown"] = 0; };

/**
 * @override
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdown
 */
UCF_ComboBox["prototype"]["onAfterLsDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsDown"]++; }; 
	/** @type {UCF_ComboBox} */
	var self = this;

	this["handleLsUpDownKeys"](oBrowserEvent, 'handleNextItem', function() {
		if (self["bHasEventListeners"]('ListAccess') &&
			self["getListBox"]() &&
			(
				UCF_JsUtil["bInstanceOf"](self["oFieldHelp"], 'UCF_SuggestBoxListBox') ||
				(UCF_JsUtil["bInstanceOf"](self["oFieldHelp"], 'UCF_Listbox_Popup') && self["oFieldHelp"]["filterList"])
			) &&
			self["oFieldHelp"]["bFiltered"] &&
			!self["oFieldHelp"]["bOpened"]
		) {
			// 1570529528: fire list access if there is a list but it was close due
			// to a none matching filter
			self["oFieldHelp"]["bAvailable"] = false;
			self["bFireListAccess"] = true;
		}
	});
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsDown"] = 0; };

/**
 * fires list access + change events if possible,
 * calls `prepare` before firing the list access (if prepare is defined),
 * calls `action` with the listbox item for `this.sKey`
 *
 * @private
 * @param {UCF_BrowserEvent} oEvent the event that occurred
 * @param {string} sAction the name of the function of this.oFieldHelp that
 * should be performed with `this.oFieldHelp.oGetItem(this.sKey)`
 * @param {function(): any} [fPrepare] the preparation action that is performed
 * before firing the list access event
 */
UCF_ComboBox["prototype"]["handleLsUpDownKeys"] = function(oEvent, sAction, fPrepare) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleLsUpDownKeys"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_BrowserEvent, "oEvent instanceof UCF_BrowserEvent", "ComboBox.js(751): handleLsUpDownKeys"); };

	// 174887 2012 -> don't open F4 Lookup Help for Freetext ComboBoxes in
	// SAP Table
	if (this["sBehavior"] === 'FREETEXT' &&
		this["bUsedInSapTable"] &&
		!this["bOpen"] &&
		(this["sSuggestFilter"] !== 'OFF' ||
			this["sSuggestFilter"] === 'OFF' && this["sFieldHelp"] === 'F4LOOKUP')
	) {
		try {
			this["setInteractionState"]({ "FocusOnInput": false });
			this["prepareFireChange"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
	} else {
		this["getListBox"]();
		if (!this["bAreFieldHelpEventsAttached"]()) {
			this["attachFieldHelpEvents"]();
		}
		if (fPrepare) {
			fPrepare();
		}

		if (!this["oFieldHelp"] || !this["oFieldHelp"]["bIsAvailable"]()) {
			// 434300 2011 New: we fire on key down a listaccess, fieldhelppress
			// events only when pressing F4 or alt cursor down.
			this["bIsExplicitListAccess"] = true;
			this["prepareFireListAccess"]();
			// CSN 1570846786: if the event bubbling is not canceled, the
			// SapTable will handle the lsup/lsdown and focus the next cell. Once
			// the ListAccess is finished, the list will open for the wrong cell.
			// => need to cancel bubbling if a ListAccess is in progress.
			oEvent["cancelBubble"]();
		} else if (this["oFieldHelp"] &&
			(this["sSuggestFilter"] === 'OFF' || this["oFieldHelp"]["bOpened"])
		) {
			this["setInteractionState"]({ "FocusOnInput": false });
			// needs to be synchronous for the list to use the right values for positioning
			this["updateStylesSync"]();
			this["bListNavigation"] = true;

			oItem = this["bIsOpen"]() && window["UCF_System"]["sDevice"] === 'standards'
				? this["oFieldHelp"]["oGetFocusedItem"]() || this["oFieldHelp"]["oGetItem"](this["sKey"])
				: this["oFieldHelp"]["oGetItem"](this["sKey"]);
			this["oFieldHelp"][sAction](oItem);

			oEvent["cancelBubble"]();
		}
	}
	oEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleLsUpDownKeys"] = 0; };

/**
 * Handles the page down event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lspagedown
 */
UCF_ComboBox["prototype"]["onlspagedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlspagedown"]++; }; 
	this["handleLsPageKeys"](oBrowserEvent, 'handlePageDown');
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlspagedown"] = 0; };

/**
 * Handles the page up event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lspageup
 */
UCF_ComboBox["prototype"]["onlspageup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlspageup"]++; }; 
	this["handleLsPageKeys"](oBrowserEvent, 'handlePageUp');
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlspageup"] = 0; };

/**
 * Performs `action` if this.oFieldHelp is defined and open + cancels `event`
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event that occurred
 * @param {string} action the name of the function of this.oFieldHelp that should
 * be performed if the listBox is defined and opened
 */
UCF_ComboBox["prototype"]["handleLsPageKeys"] = function(oBrowserEvent, action) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleLsPageKeys"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBox.js(834): handleLsPageKeys"); };

	this["getListBox"]();

	if (this["oFieldHelp"] && this["oFieldHelp"]["bOpened"]) {
		if (!this["bAreFieldHelpEventsAttached"]()) {
			this["attachFieldHelpEvents"]();
		}

		this["bListNavigation"] = true;
		this["oFieldHelp"][action]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleLsPageKeys"] = 0; };

/**
 * Handles the home key
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshome
 */
UCF_ComboBox["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlshome"]++; }; 
	if (UCF_DomUtil["bHasClass"](this["oRootRef"], 'lsField--interactiontarget')) {
		UCF_DomUtil["setCursorPos"](this["oFocusDomRef"], 0);
	} else {
		this["handleLsItemNavigationKeys"](oBrowserEvent, 'handleFirstItem');
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlshome"] = 0; };

/**
 * Handles the end key
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsend
 */
UCF_ComboBox["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlsend"]++; }; 
	if (UCF_DomUtil["bHasClass"](this["oRootRef"], 'lsField--interactiontarget')) {
		UCF_DomUtil["setCursorPos"](this["oFocusDomRef"], this["sGetDomRefValue"]()["length"]);
	} else {
		this["handleLsItemNavigationKeys"](oBrowserEvent, 'handleLastItem');
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlsend"] = 0; };

/**
 * Performs `action` if the ComboBox has a listBox (along with some other
 * constraints) + cancels the `oBrowserEvent` if successful
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event that occurred
 * @param {string} action the name of the function of this.oFieldHelp that should
 * be performed
 */
UCF_ComboBox["prototype"]["handleLsItemNavigationKeys"] = function(oBrowserEvent, action) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleLsItemNavigationKeys"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBox.js(888): handleLsItemNavigationKeys"); };

	if (
		this["bIsWriteable"]() &&
		(
			this["bOpen"] ||
			(this["oNavigation"]["bIsEditMode"]() && this["sBehavior"] !== 'FREETEXT')
		)
	) {
		oBrowserEvent["cancel"]();

		this["getListBox"]();

		if (this["oFieldHelp"]) {
			if (!this["bAreFieldHelpEventsAttached"]()) {
				this["attachFieldHelpEvents"]();
			}

			this["bListNavigation"] = true;
			this["oFieldHelp"][action]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleLsItemNavigationKeys"] = 0; };

/**
 * Different scenarios and the corresponding eventing:
 *
 * 1. CB NO Enter event registered:
 *   - typing tokens -> LISTACCESS for each token
 *   - listbox open typing + Enter -> SELECT
 *   - listbox closed pressing Enter -> CHANGE
 *   - If default button on page listbox closed pressing Enter -> CHANGE +
 *     BUTTON PRESS (default button if existing)
 *   - listbox open pressing Enter -> SELECT + BUTTON PRESS (default button if
 *     existing)
 *   - tab/click out -> CHANGE
 * 2. CB with Enter event registered:
 *   - typing tokens -> listaccess for each token
 *   - listbox open typing + Enter -> SELECT + ENTER
 *   - listbox closed typing + Enter -> CHANGE + ENTER
 *   - If default button on page listbox closed pressing Enter -> CHANGE +
 *     ENTER (no default button bubbling)
 *   - listbox open pressing Enter -> SELECT + ENTER (no default button
 *     bubbling)
 *   - tab/click out -> CHANGE
 * 3. DD NO Select registered:
 *   - listbox closed SELECT for each cursor up and down
 *   - If default button on page listbox open click -> Select an item + Enter
 *     -> SELECT + BUTTON PRESS (default button if existing)
 * 4. DD with select event registered:
 *   - listbox closed SELECT for each cursor up and down
 *   - If default button on page listbox open click -> Select an item + Enter
 *     -> SELECT
 *
 * @override
 */
UCF_ComboBox["prototype"]["onAfterLsEnter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsEnter"]++; }; 
	/** @type {string} */
	var sKey;
	/** @type {string} */
	var sValue;
	/** @type {boolean} */
	var bActionItemSelected;
	/** @type {UCF_ItemListBoxItem|UCF_ItemListBoxActionItem} */
	var oFocusedItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBox.js(954): onAfterLsEnter"); };

	if (this["bOpen"] && this["oFieldHelp"]) {
		if (window["UCF_System"]["sDevice"] === 'standards') {
			oFocusedItem = this["oFieldHelp"]["oGetFocusedItem"]();
		} {
			oFocusedItem = this["oFieldHelp"]["oGetSelectedItem"]();
		}

		if (
			UCF_JsUtil["bInstanceOf"](oFocusedItem, 'UCF_ItemListBoxActionItem') ||
			UCF_JsUtil["bInstanceOf"](oFocusedItem, 'UCF_Listbox_ActionItem')
		) {
			// set a flag here, because this.oFieldHelp.sGetSelectedItemKey() clears
			// the selection
			bActionItemSelected = true;
		}

		if (this["bListNavigation"] && oFocusedItem && oFocusedItem["bEnabled"]) {
			// The user navigated and selected an item from the list:
			// Select the whole input
			sKey = this["oFieldHelp"]["sGetSelectedItemKey"]();
			sValue = '';
			if (sKey) {
				sValue = this["oFieldHelp"]["sGetItemValue"](sKey);
				this["updateValue"](sKey, sValue, true);
			} else {
				sValue = this["oFieldHelp"]["sGetItemValue"](this["sKeySave"]);
				this["updateValue"](this["sKeySave"], this["sValueSave"], true);
			}
			this["select"]();
			this["closeFieldHelp"]();
		} else if (this["bListNavigation"] && bActionItemSelected) {
			this["oFieldHelp"]["sGetSelectedItemKey"]();
			this["closeFieldHelp"]();
		}
	}

	// @see UCF_Control.prototype.onlsenter
	if (this["bOpen"]) {
		this["bIgnoreDefaultButton"] = true;
	}

	try {
		this["prepareFireChange"](UCF_EditFieldBase["E_CHANGE_REASON"]["Enter"]);

		if (this["bHasSelectSubmitListener"]()) {
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["cancel"]();
		} else {
			this["prepareFireEnter"](oBrowserEvent, !bActionItemSelected);
		}
	} catch (oException) {
		if (!this["bHasSelectSubmitListener"]()) {
			this["prepareFireEnter"](oBrowserEvent, !bActionItemSelected);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsEnter"] = 0; };

/**
 * @private
 * @return {boolean} `true` if `Behavior=DROPDOWNSELECT` and first Select
 * listener has `ClientAction=submit`
 */
UCF_ComboBox["prototype"]["bHasSelectSubmitListener"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bHasSelectSubmitListener"]++; }; 
	/** @type {UCF_ComboBox} */
	var self = this;

	return this["oCache"]["get"]('bHasSelectSubmitListener', function() {
		return self["sBehavior"] === 'DROPDOWNSELECT'
			&& self["mEvents"]["Select"]
			&& self["mEvents"]["Select"][0]
			&& self["mEvents"]["Select"][0]["ClientAction"] === 'submit';
	});
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bHasSelectSubmitListener"] = 0; };

/**
 * This is a workaround to establish correct default button handling in case of
 * dropdownlistboxes. We cancel the event bubbling if we submit the
 * corresponding select event. This is new to the past to cancel bubbling in
 * any case.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsenter
 * @param {boolean} bShouldFire `true` to trigger the fire, `false` to abort
 */
UCF_ComboBox["prototype"]["prepareFireEnter"] = function(oBrowserEvent, bShouldFire) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["prepareFireEnter"]++; }; 
	if (this["bHasEventListeners"]('Enter')) {
		this["bIgnoreDefaultButton"] = true;
		if (bShouldFire) {
			this["fireEnter"](this["sId"]);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
	this["bIgnoreDefaultButton"] = false;
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["prepareFireEnter"] = 0; };

/**
 * Handles the escape key down on the combobox. Current implementation of
 * escape does not set the value back to the old value before the list was
 * opened
 *
 * @override
 */
UCF_ComboBox["prototype"]["onBeforeLsEscape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeLsEscape"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBox.js(1060): onBeforeLsEscape"); };

	if (window["UCF_System"]["bIsAria"] || window["UCF_System"]["bIs508"]) {
		UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], '');
	}

	if (this["bOpen"]) {
		this["getListBox"]();

		this["sKey"] = this["sKeySave"];
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Key", this["sKey"], true);

		this["setCurrentValue"](
			this["oFieldHelp"]["sGetItemValue"](this["sKey"]) ||
			this["sValueSave"]
		);
	} else {
		if (this["oFieldHelp"]) {
			this["oFieldHelp"]["clearSelection"]();
		}
		if (this["sGetCurrentValue"]() !== this["sEscapeValue"]) {
			this["sKey"] = this["sEscapeKey"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeLsEscape"] = 0; };

/**
 * Handles the tab key on a combo box
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstabnext
 */
UCF_ComboBox["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlstabnext"]++; }; 
	this["handleLsTab"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlstabnext"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstabnext/lstabprevious
 */
UCF_ComboBox["prototype"]["handleLsTab"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleLsTab"]++; }; 
	if (this["bOpen"]) {
		this["bNoBlur"] = false;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'closing listbox', "ComboBox.js(1104): handleLsTab"); };
		this["closeFieldHelp"]();
		try {
			this["prepareFireChange"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleLsTab"] = 0; };

/**
 * Handles the shift + tab key on a combo box
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstabprevious
 */
UCF_ComboBox["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlstabprevious"]++; }; 
	this["handleLsTab"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlstabprevious"] = 0; };

/**
 * @override
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey
 */
UCF_ComboBox["prototype"]["handleExternalHotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleExternalHotkey"]++; }; 
	try {
		this["prepareFireChange"]();
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleExternalHotkey"] = 0; };

/**
 * @override
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey event
 * @return {boolean} `true` if the hotkey is handled locally, otherwise `false`
 */
UCF_ComboBox["prototype"]["bIsHotkeyHandledLocally"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bIsHotkeyHandledLocally"]++; }; 
	return UCF_EditFieldBase.prototype["bIsHotkeyHandledLocally"]["call"](this, oBrowserEvent) || this["bCanRaiseFieldHelpPress"](oBrowserEvent) ||
	// CSN 2270168396: if list is complete and available on client, it will open
	// on F4, so the hotkey F4 will be handled locally
	(this["oFieldHelp"] && this["oFieldHelp"]["bComplete"]
		&& this["oFieldHelp"]["bIsAvailable"]() && this["bShowHelpButton"]
		&& UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["F4"])
	);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bIsHotkeyHandledLocally"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey event
 * @return {boolean} `true` if the hotkey will fire a ComboBox:FieldHelpPress,
 * otherwise `false`
 */
UCF_ComboBox["prototype"]["bCanRaiseFieldHelpPress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bCanRaiseFieldHelpPress"]++; }; 
	return this["bShowHelpButton"]
		&& this["bHasEventListeners"]('FieldHelpPress')
		&& (
			(!this["bHasEventListeners"]('Activate') &&
				this["sBehavior"] === 'DROPDOWNSELECT'
			) ||
			(
				this["getEnabled"]() &&
				(
					UCF_KeyboardHelper["bIsEventForKey"](
						oBrowserEvent,
						UCF_KeyCodes["F4"]
					) ||
					UCF_KeyboardHelper["bIsEventForKey"](
						oBrowserEvent,
						UCF_KeyCodes["ARROW_DOWN"],
						'A'
					) ||
					UCF_KeyboardHelper["bIsEventForKey"](
						oBrowserEvent,
						UCF_KeyCodes["ARROW_UP"],
						'A'
					)
				)
			)
		);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bCanRaiseFieldHelpPress"] = 0; };

/**
 * Handles the onkeypress event of the browser Find the next item matching the
 * typed characters.
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the keypress
 */
UCF_ComboBox["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onkeypress"]++; }; 
	/** @type {number} */
	var iKey = oBrowserEvent["iKeyCode"]();
	/** @type {string} */
	var cKey = '';
	/** @type {number} */
	var iNow;
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "ComboBox.js(1204): onkeypress"); };

	// reset explicit ListAccess flag
	this["bIsExplicitListAccess"] = false;

	// the keypress event for [TAB] is fired from Firefox only!
	// IE, IE Quirks and Chrome do not fire keypress for [TAB].
	// We want to handle this in a unique way in LS. Therefore:
	if (iKey !== UCF_KeyCodes["TAB"] &&
		// do nothing for disabled and read only fields
		this["bIsWriteable"]()
	) {
		cKey = String["fromCharCode"](
			UCF_UserAgent["bIsFirefox"]() ? oBrowserEvent["oDomEvent"]["charCode"] : iKey
		);

		if (this["oDataTip"]) {
			this["oDataTip"]["close"]();
		}

		// delete the key for combo boxes when vitrual typing is false or the
		// list is closed, do not selection from the list
		if (this["sBehavior"] === 'FREETEXT' &&
			(!this["bAllowVirtualTyping"] || !this["bOpen"])
		) {
			this["sKey"] = '';
			// eslint-disable-next-line quotes
			this["setClientProperty"]("Key", this["sKey"], true);
		} else {
			this["getListBox"]();
			if (this["oFieldHelp"]) {
				// drop downs
				if (this["sBehavior"] === 'DROPDOWNSELECT') {
					// typing of more than one character supported
					if (this["bAllowVirtualTyping"]) {
						if (this["iLastKeypress"]) {
							iNow = new Date()["getTime"]();
							// eslint-disable-next-line no-magic-numbers
							if (iNow - this["iLastKeypress"] > 750) {
								this["sSearchString"] = cKey;
							} else {
								this["sSearchString"] += cKey;
								if (this["sSearchString"]["length"] > 1 &&
									this["sSearchString"]["toUpperCase"]() ===
									this["sGetCurrentValue"]()["substr"](
										0,
										this["sSearchString"]["length"]
									)["toUpperCase"]()
								) {
									return;
								}
							}
							this["iLastKeypress"] = iNow;
						} else {
							this["iLastKeypress"] = new Date()["getTime"]();
							this["sSearchString"] = cKey;
						}
					} else {
						// only typing of the first character supported
						this["sSearchString"] = cKey;
					}

					if (iKey === UCF_KeyCodes["SPACE"]) {
						oBrowserEvent["cancel"]();
						oBrowserEvent["cancelBubble"]();
					}

					// find and item matching the typed characters
					oItem = this["oFieldHelp"]["oFindItem"](
						this["sSearchString"],
						this["oFieldHelp"]["oGetItem"](this["sKey"])
					);

					if (oItem) {
						this["updateValue"](
							oItem["sKey"],
							this["oFieldHelp"]["sGetItemValue"](oItem["sKey"]),
							true
						);
						this["oFieldHelp"]["selectItem"](oItem["sKey"]);
						if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'vTyping->sKey = ' + oItem["sKey"], "ComboBox.js(1284): onkeypress"); };
					}
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onkeypress"] = 0; };

/**
 * Handles the onkeyup event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the keyup
 */
UCF_ComboBox["prototype"]["onBeforeKeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeKeyup"]++; }; 
	/** @type {number} */
	var iKey;
	/** @type {string} */
	var sValue;
	/** @type {UCF_ItemListBoxItem} */
	var oItem;
	/** @type {string} */
	var sItemValue;
	/** @type {RegExp} */
	var oRegExp;
	/** @type {Range} */
	var oTextRange;
	/** @type {string} */
	var sSelection;
	/** @type {number} */
	var iChars;

	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '->()', "ComboBox.js(1316): onBeforeKeyup"); };

	if (this["sBehavior"] === 'DROPDOWNSELECT') {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # Dropdownselect, nothing to do', "ComboBox.js(1319): onBeforeKeyup"); };
	} else {
		iKey = oBrowserEvent["iKeyCode"]();

		if (iKey === UCF_KeyCodes["A"] &&
			!oBrowserEvent["bShift"]() &&
			oBrowserEvent["bCtrl"]() &&
			!oBrowserEvent["bAlt"]() || oBrowserEvent["bCtrl"]()
		) {
			this["setInteractionState"]({ "FocusOnInput": true });
			if (this["oFieldHelp"]) {
				this["oFieldHelp"]["clearFocus"]();
			}
			if (!this["bShouldShowOverlay"]()) {
				this["closeFieldHelp"]();
			}
		} else if (UCF_KeyboardHelper["bIsEditKey"](iKey) &&
			!this["bShouldShowOverlay"]()) {
			if (window["UCF_System"]["sDevice"] === 'standards' &&
				this["oFieldHelp"] && this["oFieldHelp"]["oGetFocusedItem"]() &&
				!this["oFieldHelp"]["oGetFocusedItem"]()["bEnabled"] &&
				(iKey === UCF_KeyCodes["ENTER"] || iKey === UCF_KeyCodes["SPACE"])) {
					// do nothing if disabled item is focused while
					// enter or space is pressed
			} else {
				this["closeFieldHelp"]();
			}
		}

		this["handleEditEvents"](oBrowserEvent);

		// do nothing for combo boxes when vitrual typing is false or the
		// list is closed
		if (this["sBehavior"] === 'FREETEXT' &&
			(!this["bAllowVirtualTyping"] || !this["bOpen"])
		) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # Freetext + closed', "ComboBox.js(1355): onBeforeKeyup"); };
		} else {
			if (iKey === UCF_KeyCodes["BACKSPACE"] || iKey === UCF_KeyCodes["DELETE"]) {
				if (!this["oFieldHelp"] && this["sGetValue"]() === '') {
					if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # Delete + empty', "ComboBox.js(1359): onBeforeKeyup"); };

					return;
				}
			} else if (!UCF_KeyboardHelper["bIsEditKey"](iKey)) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # no edit key', "ComboBox.js(1364): onBeforeKeyup"); };

				return;
			}

			if (this["bListLoadInProgress"]) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # waiting for list to load', "ComboBox.js(1370): onBeforeKeyup"); };
			} else {
				this["getListBox"]();

				// return if no list box exists
				if (this["oFieldHelp"]) {
					// handle suggest list

					if (this["bAllowVirtualTyping"]) {
						sValue = this["sGetValue"]();
						this["sSearchString"] = sValue;
					}
					oItem = this["oFieldHelp"]["oFindItem"](this["sSearchString"], '');

					if (oItem) {
						this["oFieldHelp"]["selectItem"](oItem["sKey"]);
						// copy the value to the combo box if the match is from the
						// beginning with the key value
						sItemValue = this["oFieldHelp"]["sGetItemValue"](oItem["sKey"]);
						oRegExp = new RegExp(this["sSearchString"], 'i');

						if (sItemValue["search"](oRegExp)) {
							this["updateValue"](
								oItem["sKey"],
								this["oFieldHelp"]["sGetItemValue"](oItem["sKey"]),
								true
							);

							// select autocompleted text
							if (this["oDomRef"]["createTextRange"]) {
								// IE
								oTextRange = this["oDomRef"]["createTextRange"]();
								sSelection = this["sGetValue"]()["substr"](
									this["sSearchString"]["length"],
									this["sGetValue"]()["length"] - this["sSearchString"]["length"]
								);

								if (sSelection !== '') {
									iChars = sSelection["length"] * -1;
									oTextRange["findText"](sSelection, iChars);
									oTextRange["select"]();
								}
							} else if (this["oDomRef"]["selectionStart"]) {
								// Firefox
								this["oDomRef"]["selectionStart"] = this["sSearchString"]["length"];
								this["oDomRef"]["selectionEnd"] = this["sGetValue"]()["length"];
							}
							if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()->', "ComboBox.js(1417): onBeforeKeyup"); };
						} else {
							if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # found item does not match', "ComboBox.js(1419): onBeforeKeyup"); };
						}
					} else {
						if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()->', "ComboBox.js(1422): onBeforeKeyup"); };
					}
				} else {
					if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # no listbox', "ComboBox.js(1425): onBeforeKeyup"); };
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeKeyup"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["onBeforeResize"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeResize"]++; }; 
	if (this["bShouldCloseListboxOnResize"] &&
		this["oFieldHelp"] &&
		this["oFieldHelp"]["bOpened"] &&
		!this["bIsInOverlayMode"]()
	) {
		this["closeFieldHelp"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeResize"] = 0; };

/** @private */
UCF_ComboBox["prototype"]["onWillPageResize"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onWillPageResize"]++; }; 
	if (this["oFieldHelp"] && this["oFieldHelp"]["bOpened"]) {
		this["oFieldHelp"]["applyWidth"](this["iGetWidthPx"]());
		this["oFieldHelp"]["applyHeight"]();
		this["oFieldHelp"]["setPosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onWillPageResize"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["onBeforeMousedownFieldHelpAnyEvent"] = function(oMousedown) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeMousedownFieldHelpAnyEvent"]++; }; 
	/** @type {HTMLElement} */
	var oSourceRoot = oMousedown["oGetSourceRoot"]();
	/** @type {UCF_Control} */
	var oSourceControl =
		(this["oFieldHelp"] && !this["oFieldHelp"]["bIsDestroyed"] && this["oFieldHelp"]["oGetControlByDomRef"](oSourceRoot)) ||
		this["oLS"]["oGetControlByDomRef"](oSourceRoot);

	if (oSourceControl &&
		oSourceControl !== this &&
		oSourceControl !== this["oFieldHelp"] &&
		!UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_Listbox_Item') &&
		!UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_ItemListBoxItem') &&
		!UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_ItemListBoxActionItem') &&
		oSourceControl["oConnectedControl"] !== this
	) {
		try {
			// in case of keyboard navigation with open listbox (I-0674199 2012) ...
			this["prepareFireChange"](
				UCF_EditFieldBase["E_CHANGE_REASON"]["Other"],
				this["forceDelayed"]
			);
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
		this["bNoBlur"] = this["forceDelayed"];
		this["forceDelayed"] = false;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'closing listbox', "ComboBox.js(1480): onBeforeMousedownFieldHelpAnyEvent"); };
		this["closeFieldHelp"]();
		this["hideButton"]();
	} else {
		this["bIgnoreNextFocuslost"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeMousedownFieldHelpAnyEvent"] = 0; };

/**
 * TODO replace direct usages of this.bOpen with this method
 * @override
 * @private
 * @return {boolean}
 */
UCF_ComboBox["prototype"]["bIsOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bIsOpen"]++; }; 
	return this["bOpen"];
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bIsOpen"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["oGetFieldHelpRootRef"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["oGetFieldHelpRootRef"]++; }; 
	return this["oFieldHelp"] && this["oFieldHelp"]["oRootRef"];
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["oGetFieldHelpRootRef"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["oGetFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["oGetFieldHelp"]++; }; 
	return this["oFieldHelp"];
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["oGetFieldHelp"] = 0; };

/**
 * Handles a listbox activation
 *
 * @private
 * @param {UCF_Event} oEvent the internal event
 */
UCF_ComboBox["prototype"]["onListBoxActivate"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onListBoxActivate"]++; }; 
	this["bNoBlur"] = true;
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onListBoxActivate"] = 0; };

/**
 * Handles a listbox action activation
 *
 * @private
 * @param {UCF_Event} oEvent the internal event
 */
UCF_ComboBox["prototype"]["onListBoxActionActivate"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onListBoxActionActivate"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "ComboBox.js(1525): onListBoxActionActivate"); };

	this["oFocusDomRef"]["focus"]();
	this["fireActionItemActivate"](this["sId"], oEvent["oGetParam"]('sId'));
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onListBoxActionActivate"] = 0; };
/**
 * Handles a listbox action delete of an item
 *
 * @private
 * @param {UCF_Event} oEvent the internal event
 */
UCF_ComboBox["prototype"]["onListBoxDeleteItem"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onListBoxDeleteItem"]++; }; 
	/** @type {string} */
	var sKey = oEvent["oGetParam"]('sKey');
	/** @type {UCF_ItemListBoxItem|UCF_Listbox_Item} */
	var oItemToDelete = this["oFieldHelp"]["oGetItem"](sKey);

	if (oItemToDelete) {
		this["oFieldHelp"]["deleteItem"](oItemToDelete);
		this["oFocusDomRef"]["focus"]();
		// fire delete item event
		this["fireDeleteItem"](this["sId"], sKey);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onListBoxDeleteItem"] = 0; };

/**
 * @param {UCF_Event} oEvent
 */
UCF_ComboBox["prototype"]["onListBoxFocusChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onListBoxFocusChange"]++; }; 
	this["oInteractionState"]["FocusOnInput"] = !oEvent["mGetParameters"]()["oNewItem"];
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onListBoxFocusChange"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["onAfterHelpButtonMousedown"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterHelpButtonMousedown"]++; }; 
	if (this["bIsOpen"]()) {
		this["bNoBlur"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterHelpButtonMousedown"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["onBeforeHelpButtonPress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeHelpButtonPress"]++; }; 
	this["handleHelpButtonPress"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeHelpButtonPress"] = 0; };

/**
 * Handles a click on the field help button.
 *
 * @private
 * @param {boolean} bToggleList `true` to force toggling the ItemListbox,
 * `false` to fire a ComboBox: FieldHelpPress if there are handlers for it
 * explicitly by pressing[ALT][DOWN]
 */
UCF_ComboBox["prototype"]["handleHelpButtonPress"] = function(bToggleList) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleHelpButtonPress"]++; }; 
	/** @type {UCF_PopupManager} */
	var oPopupManager;

	// set focus to the input field
	if (UCF_DomUtil["oGetActiveElement"]() !== this["oFocusDomRef"]) {
		this["oNavigation"]["keepEditMode"]();
		this["oFocusDomRef"]["focus"]();
	}

	if (this["bEnabled"] && (!this["bReadonly"] || this["bShowHelpButtonAlways"])) {
		// get the associated list box
		this["getListBox"]();
	}

	// fire FieldHelpPress event if somebody is registered
	if (this["bHasEventListeners"]('FieldHelpPress') && !bToggleList) {
		if (this["bOpen"]
			&& !this["bShouldShowOverlay"]()
		) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'closing listbox', "ComboBox.js(1597): handleHelpButtonPress"); };
			this["closeFieldHelp"]();
		}
		// detach events for not permanent help button
		if (!this["bUsedInSapTable"]) {
			// CSN 2080447256: flying help button click
			// detach is too early so that hover styles remain in table
			this["detachHelpButtonEvents"]();
		}
		try {
			this["prepareFireChange"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
		oPopupManager = this["oLS"]["oGetPopupManagerInternal"]();
		if (oPopupManager) {
			oPopupManager["attachEvent"](
				oPopupManager["E_EVENTS"]["WindowOpen"],
				this,
				'handlePopupWindowOpen'
			);
		}

		this["handleFieldHelpPress"]();
	} else {
		// open the listbox
		this["bNoBlur"] = false;
		if (this["bOpen"]
			&& !this["bShouldShowOverlay"]()
		) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'closing listbox', "ComboBox.js(1627): handleHelpButtonPress"); };
			this["closeFieldHelp"]();
		} else {
			if (UCF_UserAgent["bIsIOS"]() && this["sBehavior"] === 'DROPDOWNSELECT') {
				this["bNoBlur"] = true;
			}
			if (this["oFieldHelp"] && this["oFieldHelp"]["bComplete"] && this["oFieldHelp"]["bIsAvailable"]()) {
				/*if (this.oFieldHelp.filterList) {
					this.oFieldHelp.filterList(
						this.sGetValue(),
						this.sSuggestFilter === 'CLIENT_SERVER_PREFIX',
						this.sSuggestFilterCondition === 'VALUE1_OR_VALUE2'
					);
				}*/
				this["openFieldHelp"]();
			} else if (!this["bListLoadInProgress"]) {
				this["bFireListAccess"] = true;
				this["prepareFireListAccess"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleHelpButtonPress"] = 0; };

/**
 * Checks if FieldHelp can be fired and if true fires it
 *
 * @private
 * @return {boolean} `true` if a ComboBox:FieldHelpPress
 * was fired, otherwise `false`
 */
UCF_ComboBox["prototype"]["handleFieldHelpPress"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleFieldHelpPress"]++; }; 
	if (this["bShowHelpButton"]) {
		this["emitFieldHelpPress"]();

		return true;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handleFieldHelpPress"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["aGetFieldHelpPressArguments"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["aGetFieldHelpPressArguments"]++; }; 
	/** @type {UCF_ComboBox} */
	var self = this;

	return this["oCache"]["get"]('aFieldHelpPressArguments', function() {
		return [self["sId"]];
	});
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["aGetFieldHelpPressArguments"] = 0; };

/**
 * Handles the popup window open event
 *
 * @private
 */
UCF_ComboBox["prototype"]["handlePopupWindowOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handlePopupWindowOpen"]++; }; 
	var oPopupManager = this["oLS"]["oGetPopupManagerInternal"]();

	this["updateStyles"]();
	this["hideButton"]();
	this["bNoBlur"] = false;

	if (oPopupManager) {
		oPopupManager["detachEvent"](
			oPopupManager["E_EVENTS"]["WindowOpen"],
			this,
			'handlePopupWindowOpen'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["handlePopupWindowOpen"] = 0; };

/**
 * Event handler for selection in the ItemListBox
 *
 * @private
 * @param {UCF_Event} oEvent the event object
 */
UCF_ComboBox["prototype"]["onListBoxSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onListBoxSelect"]++; }; 
	/** @type {string} */
	var sKey = oEvent["oGetParam"]('sKey');
	/** @type {string} */
	var sValue = oEvent["oGetParam"]('sValue');
	/** @type {boolean} */
	var bFireSelect = oEvent["oGetParam"]('bFireSelect');
	/** @type {string} */
	var sEventName = oEvent["oGetParam"]('sEventName');
	/** @type {string} */
	var sIconSrc = oEvent["oGetParam"]('sIconSrc');
	/** @type {UCF_Listbox_Item} */
	var oItem;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'sKey = ' + sKey + ' sValue = ' + sValue + ' bFireSelect = ' + bFireSelect + ' sEventName = ' + sEventName, "ComboBox.js(1718): onListBoxSelect"); };

	this["setInteractionState"]({ "FocusOnInput": false });

	if (!sKey && !sValue && sEventName === 'leave') {
		// _trace(ERROR, 'Using filtered itemlistbox, needs to be unfiltered.');
		this["oFieldHelp"]["selectItem"](this["sKey"]);
	} else {
		// CSN 676011 / 2018: bIgnoreDefaultButton=false is set too late (during
		// closeFieldHelp(), but the lscontainerfocus already happened then). Have
		// to set bIgnoreDefaultButton=false before this.updateValue()
		this["bIgnoreDefaultButton"] = false;

		this["updateValue"](sKey, sValue, !bFireSelect);
		if (sEventName === 'click' || sEventName === 'touchend') {
			this["oNavigation"]["keepEditMode"]();
			this["focus"]();
			this["select"]();
		}
		// update semantic color
		oItem = this["oFieldHelp"]["oGetItem"](sKey);
		if (oItem) {
			// eslint-disable-next-line @ur/no-memory-leaks
			this["sSemanticColor"] = oItem["sSemanticTextColor"];
			// eslint-disable-next-line quotes
			this["setClientProperty"]("SemanticColor", this["sSemanticColor"], true);
			this["updateStyles"]();
		}

		this["setIconSrc"](sIconSrc);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onListBoxSelect"] = 0; };

/**
 * Sets the icon source to the given value if the ComboBox has an icon column.
 * Re-renders the icon if the source changed.
 *
 * @protected
 * @param {string} sIconSrc the new icon src
 */
UCF_ComboBox["prototype"]["setIconSrc"] = function(sIconSrc) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setIconSrc"]++; }; 
	/** @type {HTMLImageElement|SVGElement|HTMLSpanElement} */
	var oOldIconRef;
	/** @type {HTMLDivElement} */
	var oTempContainerRef;
	/** @type {HTMLImageElement|SVGElement|HTMLSpanElement} */
	var oNewIconRef;

	if (this["bHasIconColumn"] && sIconSrc && sIconSrc !== this["sIconSrc"]) {
		oOldIconRef = UCF_DomUtil["$"](this["sId"] + '-icon');

		// eslint-disable-next-line @ur/no-memory-leaks
		this["sIconSrc"] = sIconSrc;
		this["setClientProperty"]('IconSrc', this["sIconSrc"], true);

		oTempContainerRef = document["createElement"]('div');
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](oTempContainerRef, this["oLS"]["oGetRenderManager"]()["callFragment"](
			'ComboBoxIconFragment',
			'ComboBox', { "Id": this["sId"], "IconSrc": this["sIconSrc"] }
		));
		oNewIconRef = oTempContainerRef["firstChild"];

		UCF_DomUtil["replaceElement"](oOldIconRef, oNewIconRef);

		UCF_DomUtil["removeFromDom"](oTempContainerRef);

		if (UCF_UserAgent["bIsSafari"]()) {
			this["updateStyles"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setIconSrc"] = 0; };

/**
 * Selects a text in the inputfield of the ComboBox.
 *
 * @private
 * @param {string} sSelectionText Text to be selected in the field
 */
UCF_ComboBox["prototype"]["selectText"] = function(sSelectionText) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["selectText"]++; }; 
	/** @type {Range} */
	var oTextRange;

	// Internet Explorer
	if (this["oFocusDomRef"]["createTextRange"]) {
		oTextRange = this["oFocusDomRef"]["createTextRange"]();

		oTextRange["moveStart"](
			'character',
			(sSelectionText && sSelectionText !== '')
			? oTextRange["text"]["lastIndexOf"](sSelectionText)
			: 0
		);
		oTextRange["select"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["selectText"] = 0; };

/** @return {HTMLTableDataCellElement|HTMLSpanElement|HTMLTableElement} */
UCF_ComboBox["prototype"]["oGetOpenRef"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["oGetOpenRef"]++; }; 
	/** @type {HTMLTableDataCellElement} */
	var oParentCell;
	/** @type {HTMLTableDataCellElement|HTMLSpanElement|HTMLHeaderElement} */
	var oOpenRef;

	if (this["bShouldShowOverlay"]() && this["oOverlayDelegate"]) {
		oOpenRef = this["oOverlayDelegate"]["oGetOpenRef"]();
	}

	if (oOpenRef) {
		return oOpenRef;
	} else if (this["bUsedInSapTable"] && !UCF_DomUtil["bIsRTL"]) {
		oParentCell = UCF_DomUtil["oGetParentByTagName"](this["oRootRef"], 'TD');
		if (oParentCell && oParentCell["clientHeight"] === this["oRootRef"]["clientHeight"]) {
			return oParentCell || this["oRootRef"];
		} else {
			return this["oRootRef"];
		}
	} else {
		return this["oRootRef"];
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["oGetOpenRef"] = 0; };

/**
 * @override
 * @param {boolean} [bImmediate=false]
 */
UCF_ComboBox["prototype"]["onBeforeOpenFieldHelp"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeOpenFieldHelp"]++; }; 
	/** @type {number} */
	var iSuggestedItems;
	/** @type {UCF_ItemListBoxItem} */
	var oItem;
	/** @type {HTMLTableDataCellElement|HTMLSpanElement|HTMLTableElement} */
	var oOpenerRef;

	// you can open a listbox only for enabled combo boxes
	// or read only combo box where the help button is visible
	if (this["bEnabled"] && (!this["bReadonly"] || this["bShowHelpButtonAlways"])) {
		// get the associated list box
		// note 2103719: avoid opening an already destroyed listbox
		this["getListBox"]();

		if (this["oFieldHelp"]) {
			// set reference element
			oOpenerRef = this["oGetOpenRef"]();
			this["oFieldHelp"]["setShouldDisplayOverlay"](
				this["bShouldShowOverlay"]()
			);
			if (this["oFieldHelp"]["oGetOpenerRef"]() !== oOpenerRef) {
				this["oFieldHelp"]["setOpenerRef"](oOpenerRef);
			}
			this["setInteractionState"]({ "FocusOnInput": true });
			this["oFieldHelp"]["clearFocus"]();
			this["oFieldHelp"]["applyWidth"](this["iGetWidthPx"]());
			this["oFieldHelp"]["applyHeight"]();
			this["oFieldHelp"]["setEventDefaultHandler"](this);
			this["oFieldHelp"]["open"](bImmediate);
			this["bOpen"] = true;

			iSuggestedItems = this["oFieldHelp"]["iGetSuggestedItems"]();
			if (iSuggestedItems > 0) {
				oItem = this["oFieldHelp"]["oGetItem"](this["sKey"]);
				if (oItem) { // eslint-disable-line max-depth
					// eslint-disable-next-line max-depth
					if (window["UCF_System"]["bIsAria"] || window["UCF_System"]["bIs508"]) {
						UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], oItem["sId"]);
					}
					// move focus into list if there is a match
					if (!this["bReadonly"]) {
						this["setInteractionState"]({ "FocusOnInput": false });
					}
				} else {
					this["setInteractionState"]({ "FocusOnInput": true });
					this["oFieldHelp"]["clearFocus"]();
				}

				// aria-expanded needs to be at the input element itself
				if (window["UCF_System"]["bIsAria"]) { // eslint-disable-line max-depth
					if (UCF_DomUtil["sGetAttribute"](this["oDomRef"], 'role') === 'combobox') {
						UCF_AriaStateHelper["setExpanded"](this["oDomRef"], true);
					}
				}

			}

			// a data tip should not overlap the listbox, open the data tip on the
			// opposite side
			if (this["oDataTip"] && !this["bIsOpen"]() &&
				(this["oDataTip"]["sText"] || this["oDataTip"]["sExplanationText"])
			) {
				this["oDataTip"]["close"]();
				this["oDataTip"]["setAlignment"](
					this["oFieldHelp"]["bOpenedOnTop"]()
					? UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]
					: UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"]
				);
				this["oDataTip"]["open"]();
			}

			// set item selection
			this["oFieldHelp"]["clearSelection"]();
			if (!this["bReadonly"]) {
				this["oFieldHelp"]["selectItem"](this["sKey"]);
			}

			if (this["bShouldCloseListboxOnResize"]) {
				this["attachOnce"]('resize');
			}

			// disable the default button while the listbox is open
			this["bIgnoreDefaultButton"] = true;

			this["attachEvent"](this["E_EVENTS"]["WillPageResize"], this, 'onWillPageResize');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onBeforeOpenFieldHelp"] = 0; };

/**
 * Attaches listbox events
 * @private
 */
UCF_ComboBox["prototype"]["attachFieldHelpEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["attachFieldHelpEvents"]++; }; 

	if (this["oFieldHelp"] && !this["bAreFieldHelpEventsAttached"]()) {
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Select"],
			this,
			'onListBoxSelect'
		);
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Close"],
			this,
			'onFieldHelpClose'
		);
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Activate"],
			this,
			'onListBoxActivate'
		);
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["ActionActivate"],
			this,
			'onListBoxActionActivate'
		);
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["DeleteItem"],
			this,
			'onListBoxDeleteItem'
		);
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["FocusChange"],
			this,
			'onListBoxFocusChange'
		);
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["WillDestroy"],
			this,
			'onWillDestroyFieldHelp'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["attachFieldHelpEvents"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["detachFieldHelpEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["detachFieldHelpEvents"]++; }; 
	// don't generally detach in closefieldhelp because values can be
	// changed via keyboard although field help is closed
	if (this["bShouldShowOverlay"]() && this["bAreFieldHelpEventsAttached"]()) {
		this["oFieldHelp"]["detachAllEvents"](this);
		UCF_EditFieldBase.prototype["detachFieldHelpEvents"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["detachFieldHelpEvents"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_ComboBox["prototype"]["bAreFieldHelpEventsAttached"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bAreFieldHelpEventsAttached"]++; }; 
	// we assume all events are attached if one is attached
	return this["oFieldHelp"] && this["oFieldHelp"]["E_EVENTS"]
		&& this["oFieldHelp"]["bIsListener"](this["oFieldHelp"]["E_EVENTS"]["Select"], this, 'onListBoxSelect');
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bAreFieldHelpEventsAttached"] = 0; };

/**
 * @override
 * @param {boolean} [bImmediate=false]
 */
UCF_ComboBox["prototype"]["onAfterCloseFieldHelp"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterCloseFieldHelp"]++; }; 

	// TODO mlh: need to clear focus border on field help after close
	// but can't do it here because FF will throw errors
	//this.oFieldHelp.clearFocus();

	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["BeforeHotkey"], this, 'close');

	if (this["oFieldHelp"] &&
		!this["oFieldHelp"]["bIsDestroyed"] &&
		this["oFieldHelp"]["bIsValid"]()
	) { // close listbox
		this["bOpen"] = false;
		this["bNoBlur"] = false;
		this["bIgnoreDefaultButton"] = false; // activate default button
		this["oFieldHelp"]["clearSelection"]();
		this["oFieldHelp"]["close"](bImmediate);
	}

	if (!this["oHelpButton"] && this["bShouldCloseListboxOnResize"]) {
		this["detachOnce"]('resize');
	}

	this["detachEvent"](this["E_EVENTS"]["WillPageResize"], this, 'onWillPageResize');
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterCloseFieldHelp"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["bShouldDetachResizeWhenHidingButton"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldDetachResizeWhenHidingButton"]++; }; 
	return (!this["bShouldCloseListboxOnResize"] ||
			!this["oFieldHelp"] ||
			!this["oFieldHelp"]["bOpen"]
		)
		&& UCF_EditFieldBase.prototype["bShouldDetachResizeWhenHidingButton"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldDetachResizeWhenHidingButton"] = 0; };

/**
 * Gets or creates the ListBox belonging to this ComboBox
 * @private
 * @return {UCF_ItemListBox} the ListBox object
 */
UCF_ComboBox["prototype"]["getListBox"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["getListBox"]++; }; 
	/** @type {boolean} */
	var bDidConnectToNewListbox = !this["oFieldHelp"];
	/** @type {UCF_ComboBoxListBox} */
	var oFieldHelp;

	if (!this["oFieldHelp"] || this["oFieldHelp"]["bIsDestroyed"]) {
		if (this["sItemListBoxId"]) {
			oFieldHelp = this["oLS"]["oControlFactory"]["oGetControlById"](this["sItemListBoxId"]);

			if (oFieldHelp) {
				if (oFieldHelp["bIsAvailable"]()) {
					if (oFieldHelp !== this["oFieldHelp"]) {
						this["oFieldHelp"] = oFieldHelp;
					}
					this["oFieldHelp"]["bIsPopup"] = true;
				} else {
					oFieldHelp["checkRootRef"]();
					if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Failed to get listbox id = ' + this["sItemListBoxId"], "ComboBox.js(2061): getListBox"); };

					return null;
				}
			}
		}

		if (this["oFieldHelp"]) {
			if (!this["bAreFieldHelpEventsAttached"]()) {
				this["attachFieldHelpEvents"]();
			}

			if (bDidConnectToNewListbox) {
				this["oFieldHelp"]["clearFocus"]();
				this["oFieldHelp"]["clearSelection"]();
				// set read only state for the list box if combo box is read only
				this["oFieldHelp"]["setReadonly"](this["bReadonly"]);
			}
		}
	}

	if (
		this["oFieldHelp"] &&
		!this["oFieldHelp"]["bIsDestroyed"] &&
		!this["bAreFieldHelpEventsAttached"]()
	) {
		this["attachFieldHelpEvents"]();
	}

	return this["oFieldHelp"];
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["getListBox"] = 0; };

/**
 * fires list access event
 * explicitly by pressing[ALT][DOWN]
 * @private
 */
UCF_ComboBox["prototype"]["prepareFireListAccess"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["prepareFireListAccess"]++; }; 
	/** @type {string} */
	var sValue;

	// No listaccess when LS is locked, I-868391 2010
	if (this["lockListAccessEvents"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'List access eventing is blocked...', "ComboBox.js(2104): prepareFireListAccess"); };
	} else if (!this["oFieldHelp"] || !this["oFieldHelp"]["bIsAvailable"]() ||
		!this["oFieldHelp"]["bComplete"] ||
		this["oFieldHelp"]["oGetOpenerRef"]() !== this["oGetOpenRef"]()
	) {
		sValue = this["sSuggestFilter"] === 'OFF' ? '' : this["sGetValue"]();

		if (this["bFireListAccess"]) {
			this["fireListAccessInternal"](sValue);
			if (this["bHasEventListeners"]('ListAccess')) {
				this["oNavigation"]["keepEditMode"]();
				this["focus"]();
				if (!this["bShouldShowOverlay"]()) {
					this["bListLoadInProgress"] = true;
					this["bFireListAccess"] = false;
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["prepareFireListAccess"] = 0; };

/**
 * @private
 * @throws {UCF_Exception} if no event is fired, an exception is thrown
 */
UCF_ComboBox["prototype"]["onWillFireChange"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onWillFireChange"]++; }; 
	/** @type {boolean} */
	var bChanged = false;
	/** @type {string} */
	var sValue = this["sGetCurrentValue"]();

	// clear delayed call which is not yet fired
	if (this["oSelectTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["oSelectTimer"]);
		this["oSelectTimer"] = null;
		bChanged = true; // select or change event must be fired again
	}

	// check if key or value has changed
	if (!bChanged && (
			this["sKey"] !== this["sKeySave"] ||
			sValue !== this["sValueSave"] ||
			(
				sValue !== this["sLastSubmittedValue"] &&
				this["sBehavior"] === 'FREETEXT' &&
				this["sKey"] === ''
			)
		)) {
		bChanged = !this["bIsCurrentValueRequiredIndicator"]();
	}

	if (bChanged) {
		// COMBOBOX: initialize key if only value has changed
		if (
			this["sBehavior"] === 'FREETEXT' &&
			this["sKey"] === this["sKeySave"] &&
			sValue !== this["sValueSave"] &&
			sValue !== this["sLastSubmittedValue"]
		) {
			this["sKey"] = '';
			// eslint-disable-next-line quotes
			this["setClientProperty"]("Key", this["sKey"], true);
		}
	} else {
		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('value unchanged => did not fire Change event');
	}

	if (this["sBehavior"] === 'FREETEXT' && this["sKey"] === '') {
		this["sLastSubmittedValue"] = sValue;
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onWillFireChange"] = 0; };

/**
 * fires select or change event depending on if you have selected a value from
 * the list (key not initial) or you have entered a value (key is initial)
 *
 * @private
 * @param {UCF_EditFieldBase_FireChangeEvent} oEvent
 */
UCF_ComboBox["prototype"]["onFireChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onFireChange"]++; }; 
	/** @type {UCF_EditFieldBase_ChangeReason} */
	var iReason = oEvent["oGetParam"]('iReason');
	/** @type {boolean} */
	var bDelayed = oEvent["oGetParam"]('bDelayed');
	/** @type {string} */
	var sValue = this["sGetCurrentValue"]();

	// fire change event for combo boxes if you entered a new value
	if (this["sBehavior"] === 'FREETEXT' && this["sKey"] === '') {
		this["fireChange"](this["sId"], sValue);
		this["setPendingChange"](false);
	} else if (bDelayed) {
		// fire select event delayed
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Firing select delayed...', "ComboBox.js(2197): onFireChange"); };
		this["oSelectTimer"] = UCF_JsUtil["delayedCall"](
			500, // eslint-disable-line no-magic-numbers
			this,
			'fireSelectDelayCallback', [
				this["sId"],
				this["sKey"],
				iReason === UCF_EditFieldBase["E_CHANGE_REASON"]["Enter"]
			]
		);
	} else {
		// fire select event direct
		this["setInputState"]('INVALIDATE');
		this["fireSelect"](
			this["sId"],
			this["sKey"],
			iReason === UCF_EditFieldBase["E_CHANGE_REASON"]["Enter"]
		);
		this["setPendingChange"](false);
	}

};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onFireChange"] = 0; };

/** @private */
UCF_ComboBox["prototype"]["onDidFireChange"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onDidFireChange"]++; }; 
	this["sKeySave"] = this["sKey"];
	this["sValueSave"] = this["sGetCurrentValue"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onDidFireChange"] = 0; };

/** @param {string} sValue the value to submit in the ComboBox:ListAccess event
 */
UCF_ComboBox["prototype"]["fireListAccessInternal"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireListAccessInternal"]++; }; 
	if (!this["iOptimalNumberOfItems"]) {
		this["iOptimalNumberOfItems"] = this["oFieldHelp"]
			? this["oFieldHelp"]["iGetOptimalNumberOfItems"]()
			: 10; // eslint-disable-line no-magic-numbers
	}

	if (this["oFieldHelp"] && UCF_StringUtil["bEndsWith"](this["oFieldHelp"]["sId"], '-templistbox')) {
		UCF_DomUtil["removeFromDom"](this["oFieldHelp"]["oDomRef"]);
		this["oFieldHelp"] = null;
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Optimal Number of Listbox Items: ' + this["iOptimalNumberOfItems"], "ComboBox.js(2240): fireListAccessInternal"); };

	// On touch devices, the virtual keyboard should open for ListAccess Events.
	// Hence, reset the FocusDomRef to the DomRef instead of RootRef
	this["oFocusDomRef"] = this["oDomRef"];
	this["fireEvent"](this["E_EVENTS"]["WillFireListAccess"], {});

	// lock the combobox, so that it can't fire a second ListAccess while the
	// first one is still in progress
	this["lockListAccess"]();

	// attach to the afterResponse event, so that we can unlock the combobox
	// once the request was answered
	this["oLS"]["attachBeforeEvent"](
		this["oLS"]["E_EVENTS"]["AfterResponse"],
		this, 'onAfterResponse'
	);

	this["fireListAccess"](
		this["sId"],
		this["sItemListBoxId"],
		sValue,
		this["iOptimalNumberOfItems"],
		this["bIsExplicitListAccess"]
	);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireListAccessInternal"] = 0; };

/**
 * Fires the select event and resets the event timer
 *
 * @private
 * @param {string} sId identifier of the control
 * @param {string} sKey the key value
 * @param {boolean} bOnEnter is enter key pressed
 */
UCF_ComboBox["prototype"]["fireSelectDelayCallback"] = function(sId, sKey, bOnEnter) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireSelectDelayCallback"]++; }; 
	this["oSelectTimer"] = null;
	this["fireSelect"](sId, sKey, bOnEnter);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireSelectDelayCallback"] = 0; };

/**
 * Fires the validate event
 *
 * @private
 * @param {string} sId identifier of the control
 * @param {string} sValue the value of the control
 */
UCF_ComboBox["prototype"]["fireValidateWithStateChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireValidateWithStateChange"]++; }; 
	if (this["bHasEventListeners"]('Validate')) {
		this["bIgnoreDefaultButton"] = true;
		this["setInputState"]('INVALIDATELOADING');
		this["fireValidate"](sId, sValue);
	} else {
		this["setInputState"]('INVALIDATE');
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireValidateWithStateChange"] = 0; };

/**
 * Sets a new value for the combobox
 *
 * @private
 * @param {string} sKey the key of the selected entry
 * @param {string} sValue the value of the selected entry
 * @param {boolean} bKeyboard whether the change has been caused by keyboard
 */
UCF_ComboBox["prototype"]["updateValue"] = function(sKey, sValue, bKeyboard) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["updateValue"]++; }; 
	/** @type {UCF_ComboBoxListBox} */
	var oFieldHelp;
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	oFieldHelp = this["getListBox"]();
	if (oFieldHelp) {
		oItem = oFieldHelp["oGetItem"](sKey);
		if (oItem) {
			// 1780119710: as a workaround we need to add aria attributes also in 508
			// else JAWS 17/18 does not announce the items within a list properly
			if (window["UCF_System"]["bIsAria"] || window["UCF_System"]["bIs508"]) {
				UCF_AriaStateHelper["setActivedescendant"](
					this["oDomRef"],
					oItem["sId"]
				);
			}
		}
	}

	if (this["bShouldUpdateValue"](sKey, sValue, bKeyboard)) {
		this["sKey"] = sKey;
		this["setClientProperty"]('Key', this["sKey"], true);

		this["setCurrentValue"](sValue);

		if (this["sBehavior"] === 'DROPDOWNSELECT' && this["sSuggestFilter"] === 'OFF') {
			UCF_DomUtil["setCursorPos"](this["oFocusDomRef"], 0);
		}

		if (oItem) {
			this["setIconSrc"](oItem["sIconSrc"]);
		}

		// refocus in accessibility mode to get the correct screen reader tool tip
		if (window["UCF_System"]["bIs508"]) {
			this["refocus"](this["oFocusDomRef"]);
		}

		// clear timer
		if (this["oSelectTimer"]) {
			UCF_JsUtil["clearDelayedCall"](this["oSelectTimer"]);
		}

		// clear input state
		this["setInputState"]('INVALIDATE');
		if (this["oDataTip"]) {
			this["oDataTip"]["close"]();
		}

		// if list box is open and you navigate with keyboard don't fire change
		if (this["bOpen"] && bKeyboard) {
			this["forceDelayed"] = true;
		} else {
			// if list box is closed or a listbox item has been clicked fire change
			try {
				this["prepareFireChange"](
					UCF_EditFieldBase["E_CHANGE_REASON"]["Other"],
					bKeyboard,
					true
				);
			} catch (oException) {
				this["handleEarlyHandlerLeave"](oException);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["updateValue"] = 0; };

/**
 * @private
 * @param {string} sKey the new key
 * @param {string} sValue the new value
 * @param {boolean} bKeyboard `true` if the update originated from a keyboard
 * event
 * @return {boolean} `true` if an update should be performed, otherwise `false`
 */
UCF_ComboBox["prototype"]["bShouldUpdateValue"] = function(sKey, sValue, bKeyboard) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldUpdateValue"]++; }; 
	return this["bIsWriteable"]()
		&& (this["sKey"] !== sKey ||
			this["sGetValue"]() !== sValue ||
			bKeyboard ||
			this["sKey"] !== this["sKeySave"]);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldUpdateValue"] = 0; };

/**
 * Returns the value of the ComboBox
 * @return {string} the actual value of this combobox
 * @private
 */
UCF_ComboBox["prototype"]["sGetValue"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["sGetValue"]++; }; 
	return this["oDomRef"] ? this["sGetCurrentValue"]() : '';
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["sGetValue"] = 0; };

/**
 * Opens a combo box delayed. Use this function if you want to open a combo box
 * after a server round trip.
 * @public
 * @param {boolean} [bImmediate=false]
 */
UCF_ComboBox["prototype"]["open"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["open"]++; }; 
	/** @type {HTMLElement} */
	var oActiveElement = UCF_DomUtil["oGetActiveElement"]();
	/** @type {UCF_PopupManager} */
	var oPopupManager = this["oLS"]["oGetPopupManagerInternal"]();

	if (oPopupManager) {
		oPopupManager["detachEvent"](
			oPopupManager["E_EVENTS"]["WindowOpen"],
			this,
			'handlePopupWindowOpen'
		);
	}

	this["bFireListAccess"] = false;
	this["bListLoadInProgress"] = false;

	this["openFieldHelp"](bImmediate);

	if (oActiveElement !== this["oDomRef"] &&
		oActiveElement !== this["oGetHelpButtonRef"]()
	) {
		this["bIgnoreNextFocuslost"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["open"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element
 * within the control gets the focus.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_ComboBox["prototype"]["onAfterLsAccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsAccessibility"]++; }; 
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	/** @type {boolean} */
	var bNavigation = false;
	/** @type {HTMLElement} */
	var oFrom = oBrowserEvent["oGetFromElement"]();
	/** @type {string} */
	var sValue;
	/** @type {string} */
	var sDescription;
	/** @type {number} */
	var iItemCount;
	/** @type {number} */
	var iItemIndex;
	/** @type {boolean} */
	var bIsTutorEnabled;

	// check if you navigate within the control or if you enter the control
	if (oFrom && this["oFocusDomRef"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'oFrom == ' + oFrom["outerHTML"]["slice"](0, 30) + '... (should be ' + this["oFocusDomRef"]["outerHTML"]["slice"](0, 30) + '...)', "ComboBox.js(2458): onAfterLsAccessibility"); }; // eslint-disable-line no-magic-numbers
		if (oFrom === this["oFocusDomRef"]) {
			bNavigation = true;
		}
	}

	// get the listbox but do not fire list access event if the listbox is not
	// availbale
	this["getListBox"]();

	// set value
	sValue = this["sGetValue"]();
	if (sValue === '') {
		oAccessibilityHelper["setEmpty"](true);
	}
	sDescription = '';
	if (this["oFieldHelp"] && this["sKey"]) {
		sDescription = this["oFieldHelp"]["sGetItemDescription"](this["sKey"]);
		if (sDescription) {
			sValue = sValue + ' ' + sDescription;
		}
	}
	oAccessibilityHelper["setText"](sValue);

	// set control type
	if (!bNavigation) {
		if (this["sBehavior"] === 'DROPDOWNSELECT') {
			oAccessibilityHelper["setControlType"]('CB_DD');
		} else if (this["sFieldHelp"] === 'F4LOOKUP') {
			oAccessibilityHelper["setControlType"]('I');
		} else {
			oAccessibilityHelper["setControlType"]('CB');
		}

		oAccessibilityHelper["applyLabelingInfo"](
			this,
			'',
			this["sLabelText"],
			this["sInputPrompt"]
		);
		oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

		bIsTutorEnabled = this["bIsWriteable"]() && this["bShowHelpButton"];
		if (this["sFieldHelp"] === 'SEARCH') {
			oAccessibilityHelper["addEnabledTutor"]('CB_SEARCH_TUT', bIsTutorEnabled);
		} else if (this["sFieldHelp"] === 'F4LOOKUP') {
			oAccessibilityHelper["addEnabledTutor"]('I_F4_TUT', bIsTutorEnabled);
		} else if (this["bOpen"]) {
			oAccessibilityHelper["addEnabledTutor"]('ILBS_TUT', bIsTutorEnabled);
		} else {
			oAccessibilityHelper["addEnabledTutor"]('CB_TUT', bIsTutorEnabled);
		}
	}

	// set item count and index
	if (this["oFieldHelp"]) {
		iItemCount = this["oFieldHelp"]["iGetItemCount"]();
		iItemIndex = this["oFieldHelp"]["iGetItemIndex"](this["sKey"]);
		if (iItemCount > 0) {
			oAccessibilityHelper["setItemCount"](iItemCount);
		}
		if (iItemIndex > 0) {
			oAccessibilityHelper["setItemIndex"](iItemIndex);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterLsAccessibility"] = 0; };

/**
 * Set changed flag. If the changed flag is set a change or select event is
 * fired regardless if the key or value has changed.
 *
 * @public
 */
UCF_ComboBox["prototype"]["setChanged"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setChanged"]++; }; 
	this["sKeySave"] = null;
	this["sValueSave"] = null;
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setChanged"] = 0; };

/**
 * Sets the key value of the ComboBox
 *
 * @public
 * @param {string} sKey the key of the selected entry
 */
UCF_ComboBox["prototype"]["setValue"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setValue"]++; }; 
	if (this["bIsWriteable"]() && this["sKey"] !== sKey) {
		this["sKey"] = sKey;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Key", this["sKey"], true);
		try {
			this["prepareFireChange"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setValue"] = 0; };

/**
 * Returns the key value of the ComboBox
 *
 * @public
 * @return {string} the actual key value of this combobox
 */
UCF_ComboBox["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["getValue"]++; }; 
	return this["sKey"];
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["getValue"] = 0; };

/**
 * Returns the selected readable value of the ComboBox
 *
 * @public
 * @return {string} the actual value of this combobox
 */
UCF_ComboBox["prototype"]["getText"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["getText"]++; }; 
	return this["sGetValue"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["getText"] = 0; };

/**
 * Returns the entered value of the ComboBox
 *
 * @public
 * @return {string} the actual value of this combobox WITHOUT input prompt!
 */
UCF_ComboBox["prototype"]["getEnteredText"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["getEnteredText"]++; }; 
	return this["sGetCurrentValue"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["getEnteredText"] = 0; };

/**
 * Sets the selected readable value of the ComboBox
 *
 * @public
 * @param {string} sText the the text to set for the oDomRef
 */
UCF_ComboBox["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setText"]++; }; 
	if (this["bIsWriteable"]() && this["sGetValue"]() !== sText) {
		this["setCurrentValue"](sText);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setText"] = 0; };

/**
 * Returns the text which is displayed on the screen
 *
 * @private
 * @see UCF_Control
 * @return {string} the displayed text
 */
UCF_ComboBox["prototype"]["sGetDisplayedText"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["sGetDisplayedText"]++; }; 
	return this["sGetValue"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["sGetDisplayedText"] = 0; };

/**
 * Sets the id of another itemlistbox associated with this combobox
 *
 * @public
 * @param {string} sItemListBoxId the id of the new itemlistbox
 */
UCF_ComboBox["prototype"]["setItemListBoxId"] = function(sItemListBoxId) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setItemListBoxId"]++; }; 
	/** @type {UCF_ItemListBox} */
	var oNewItemListBox;

	if (this["sItemListBoxId"] !== sItemListBoxId) {
		oNewItemListBox = this["oLS"]["oControlFactory"]["oGetControlById"](sItemListBoxId);

		if (oNewItemListBox) {
			// close listbox if the listbox is still open
			if (this["oFieldHelp"]) {
				if (this["bOpen"]) {
					if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'closing listbox', "ComboBox.js(2625): setItemListBoxId"); };
					this["closeFieldHelp"]();
				}
				// detach listbox events
				this["detachFieldHelpEvents"]();

				this["oFieldHelp"]["detachEvent"](
					this["oFieldHelp"]["E_EVENTS"]["Select"],
					this,
					'onListBoxSelect'
				);
				this["oFieldHelp"]["detachEvent"](
					this["oFieldHelp"]["E_EVENTS"]["Close"],
					this,
					'onFieldHelpClose'
				);
				this["oFieldHelp"]["detachEvent"](
					this["oFieldHelp"]["E_EVENTS"]["Activate"],
					this,
					'onListBoxActivate'
				);
				this["oFieldHelp"]["detachEvent"](
					this["oFieldHelp"]["E_EVENTS"]["ActionActivate"],
					this,
					'onListBoxActionActivate'
				);
				this["oFieldHelp"]["detachEvent"](
					this["oFieldHelp"]["E_EVENTS"]["DeleteItem"],
					this,
					'onListBoxDeleteItem'
				);
			}

			// hide not permanent help button
			if (this["oHelpButton"]) {
				this["hideButton"]();
			}

			// eslint-disable-next-line @ur/no-memory-leaks
			this["sItemListBoxId"] = sItemListBoxId;
			// eslint-disable-next-line quotes
			this["setClientProperty"]("ItemListBoxId", this["sItemListBoxId"], true);

			this["oFieldHelp"] = oNewItemListBox;

			this["attachFieldHelpEvents"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setItemListBoxId"] = 0; };

/**
 * Locking possible list access events
 *
 * @public
 */
UCF_ComboBox["prototype"]["lockListAccess"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["lockListAccess"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Locking list access...', "ComboBox.js(2681): lockListAccess"); };
	this["lockListAccessEvents"] = true;
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["lockListAccess"] = 0; };

/**
 * Unlocking possible list access events
 *
 * @public
 */
UCF_ComboBox["prototype"]["unlockListAccess"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["unlockListAccess"]++; }; 
	// make sure that LS is not locked when then flag is set to true
	// as this coding is also called when LS is locked/unlocked
	if (!this["oLS"]["bIsLocked"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Unlocking list access...', "ComboBox.js(2694): unlockListAccess"); };
		this["lockListAccessEvents"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["unlockListAccess"] = 0; };

/**
 * Unlocking possible list access events after UCF_LS.unlock fires Unlock Event
 *
 * @public
 */
UCF_ComboBox["prototype"]["onlsunlock"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlsunlock"]++; }; 
	// UCF_LS.unlock fires unlock before setting this.bIsLocked = false;
	// UCF_ComboBox.unlockListAccess() might be processed before the
	// this.bIsLocked = false is set, thus this.lockListAccessEvents would
	// not be set to false
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Unlocking list access...', "ComboBox.js(2709): onlsunlock"); };
	this["lockListAccessEvents"] = false;
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onlsunlock"] = 0; };

/** @override */
UCF_ComboBox["prototype"]["onAfterImportValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterImportValue"]++; }; 
	/** @type {boolean} */
	var bFound = true;
	/** @type {number} */
	var i;
	/** @type {Array.<UCF_ItemListBoxItem>} */
	var aItems;

	if (this["sBehavior"] === 'DROPDOWNSELECT') {
		this["getListBox"]();
		if (!this["oFieldHelp"]) {
			return;
		}
		bFound = false;
		aItems = this["oFieldHelp"]["aGetItems"]();
		for (i = 0; i < aItems["length"]; i += 1) {
			// TODO shouldn't this be this.oFieldHelp.sGetItemValue(aItems[i])?
			if (aItems[i]["sValue1"] === sValue) {
				bFound = true;
				this["setValue"](aItems[i]["sKey"]);
				break;
			}
		}
	}

	if (bFound) {
		this["setText"](sValue);
		try {
			this["prepareFireChange"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onAfterImportValue"] = 0; };

/**
 * @protected
 * @return {boolean} `true` when yuo can enter text in the field by keyboard,
 *  'false' otherwise (i.e. you can choose a value from a list only).
 */
UCF_ComboBox["prototype"]["bShouldSelect"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldSelect"]++; }; 
	return this["sBehavior"] === 'FREETEXT';
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bShouldSelect"] = 0; };

/**
 * Sets the suggest filter algorithm to use.
 *
 * @public
 * @param {string} sFilter the filter to use
 */
UCF_ComboBox["prototype"]["setSuggestFilterCondition"] = function(sFilter) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setSuggestFilterCondition"]++; }; 
	if (this["sSuggestFilterCondition"] === 'VALUE1_OR_VALUE2' ||
		this["sSuggestFilterCondition"] === 'VALUE1'
	) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sSuggestFilterCondition"] = sFilter;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("SuggestFilterCondition", this["sSuggestFilterCondition"], true);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setSuggestFilterCondition"] = 0; };

/**
 * Sets the DomRef which should be focused
 *
 * @private
 * @param {element} oDomRef
 */
UCF_ComboBox["prototype"]["setFocusDomRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setFocusDomRef"]++; }; 
	if (oDomRef && oDomRef !== this["oDomRef"] && oDomRef !== this["oRootRef"]) {
		return;
	}
	if (oDomRef) {
		this["oFocusDomRef"] = oDomRef;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'set FocusDomRef' + oDomRef["id"], "ComboBox.js(2787): setFocusDomRef"); };
	} else {
		this["oFocusDomRef"] = this["oGetFocusDomRef"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'reset FocusDomRef', "ComboBox.js(2790): setFocusDomRef"); };
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setFocusDomRef"] = 0; };
// ===== Performance: Render Fake Input Field =================================

/**
 * @private
 * @return {Object}
 */
UCF_ComboBox["prototype"]["oGetClientAccessObject"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["oGetClientAccessObject"]++; }; 
	return {
		"Id": this["sId"],
		"Name": this["sName"],
		"ControlType": this["oDomRef"]["getAttribute"]('ct'),
		"Width": this["sWidth"],
		"Enabled": this["bEnabled"],
		"Readonly": this["bReadonly"],
		"Invalid": this["bInvalid"],
		"Required": this["bRequired"],
		"Key": this["sKey"],
		"Value": this["sGetCurrentValue"](),
		"Behavior": this["sBehavior"],
		"AllowVirtualTyping": this["bAllowVirtualTyping"],
		"ItemListBoxId": this["sItemListBoxId"],
		"ItemCount": this["iItemCount"],
		"HasIconColumn": this["bHasIconColumn"],
		"TextDirection": this["sTextDirection"],
		"Visibility": this["sVisibility"],
		"Tooltip": this["sTooltip"],
		"IconSrc": this["sIconSrc"],
		"DisabledIconSrc": this["sDisabledIconSrc"],
		"LabelText": this["sLabelText"],
		"LabelFor": this["sLabelFor"],
		"IMEMode": this["sIMEMode"],
		"InputState": this["sInputState"],
		"ContainerWidthSet": this["bContainerWidthSet"],
		"UsedInSapTable": this["bUsedInSapTable"],
		"PaddingInSapTable": this["sPaddingInSapTable"],
		"MaxLength": this["iMaxLength"],
		"Align": this["sAlign"],
		"Type": this["sType"],
		"ShowHelpButtonAlways": this["bShowHelpButtonAlways"],
		"AccessKey": this["sAccessKey"],
		"SuggestFilter": this["sSuggestFilter"],
		"FieldHelp": this["sFieldHelp"],
		"Design": this["sDesign"],
		"ShowRequiredIndicator": this["bShowRequiredIndicator"],
		"DisplayAsText": this["bDisplayAsText"],
		"HideFieldHelp": this["bHideFieldHelp"],
		"InputPrompt": this["sInputPrompt"],
		"Length": this["iLength"],
		"ShowHelpButton": this["bShowHelpButton"],
		"SuggestAutoComplete": this["bSuggestAutoComplete"],
		"SuggestFilterCondition": this["sSuggestFilterCondition"],
		"UsedInToolbar": this["bUsedInToolbar"],
		"FieldHelpFloating": this["bFieldHelpFloating"],
		"CustomData": typeof this["sCustomData"] === 'string'
			? this["sCustomData"]
			: UCF_JsUtil["sJsonStringify"](this["sCustomData"]) || '',
		"CustomStyle": this["sCustomStyle"],
		"TextStyle": this["sTextStyle"],
		"SemanticColor": this["sSemanticColor"],
		"EmbeddingBehaviour": this["sEmbeddingBehaviour"],
		"Hidden": this["bHidden"],
		"PasswordField": this["bPasswordField"],
		"TextOverflowEllipsis": this["bTextOverflowEllipsis"],
		"SapTableFieldDesign": this["sSapTableFieldDesign"],
		"FieldHelpEmbedding": this["bFieldHelpEmbedding"],
		"Height": this["sHeight"],
		"LabelledBy": this["sLabelledBy"],
		"ShowClearButton": this["bShowClearButton"],
		"Hint": this["sHint"],
		"TabBehaviour": this["sTabBehaviour"],
		"DescribedBy": this["sDescribedBy"]
	};
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["oGetClientAccessObject"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_ComboBox["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
		}
	}

	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["bPrepareAria"] = 0; };

/**
 * Will open the listbox in overlay mode
 */
UCF_ComboBox["prototype"]["onDidClickToOpenOverlay"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onDidClickToOpenOverlay"]++; }; 
	/** @type {UCF_ClientItemListBox} */
	var oClientItemListBox;
	/** @type {HTMLDivElement} */
	var oAssoAreaRef;
	/** @type {HTMLTableDataCellElement|HTMLSpanElement|HTMLTableElement} */
	var oOpenerRef;
	/** @type {UCF_Page} */
	var oPage;

	oPage = this["oLS"]["oGetPageInternal"]();
	if (oPage) {
		oPage["attachEvent"](oPage["E_EVENTS"]["WindowResize"], this, 'onWindowResize');
	}

	this["getListBox"]();

	if (!this["oFieldHelp"]) {
		// create client side field help with given sItemListBoxId
		oClientItemListBox = this["oLS"]["oCreateClientControl"]('ItemListBox');
		oClientItemListBox["setIsPopup"](true);
		oClientItemListBox["bAvailable"] = false;
		oClientItemListBox["sId"] = this["sId"] + '-templistbox';
		oAssoAreaRef = this["oLS"]["oGetAssociatedAreaRef"]();

		oClientItemListBox["placeAt"](oAssoAreaRef);
		this["oFieldHelp"] = oClientItemListBox["getUCFInstanceInternal"](true);
		this["oFieldHelp"]["bAvailable"] = false;
		this["oFieldHelp"]["bComplete"] = false;

		this["oFieldHelp"]["setShouldDisplayOverlay"](
			this["bShouldShowOverlay"]()
		);

		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'created oClientItemListBox', "ComboBox.js(2926): onDidClickToOpenOverlay"); };
	}

	if (!this["oFieldHelp"]["oOpenerRef"]) {
		oOpenerRef = this["oGetOpenRef"]();
		if (this["oFieldHelp"]["oGetOpenerRef"]() !== oOpenerRef) {
			this["oFieldHelp"]["setOpenerRef"](oOpenerRef);
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'setOpenerRef: ' + oOpenerRef["id"] + ' for FieldHelp ' + this["oFieldHelp"]["sId"], "ComboBox.js(2933): onDidClickToOpenOverlay"); };
		}
	}

	if (!this["bIsOpen"]() && this["bHasVisibleFocus"]()) {
		if (
			this["oFieldHelp"] &&
			this["oFieldHelp"]["bComplete"] && this["oFieldHelp"]["bIsAvailable"]()
			&& (
				this["oFieldHelp"]["oGetOpenerRef"]() === this["oGetOpenRef"]() ||
				this["oFieldHelp"]["oGetOpenerRef"]() === null)
		) {
			this["open"]();
		} else if (!this["bListLoadInProgress"]) {
			this["bFireListAccess"] = true;
			this["prepareFireListAccess"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onDidClickToOpenOverlay"] = 0; };

/**
 * @private
 * @override
 */
UCF_ComboBox["prototype"]["onWillDestroyComboBox"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onWillDestroyComboBox"]++; }; 
	/** @type {UCF_PopupManager} */
	var oPopupManager;
	/** @type {UCF_Page} */
	var oPage = this["oLS"]["oGetPageInternal"]();

	if (oPage) {
		oPage["detachEvent"](oPage["E_EVENTS"]["WindowResize"], this, 'onWindowResize');

	}

	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this);
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this);
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["BeforeHotkey"], this, 'close');
	this["oLS"]["detachBeforeEvent"](this["oLS"]["E_EVENTS"]["AfterResponse"], this, 'onAfterResponse');

	oPopupManager = this["oLS"]["oGetPopupManagerInternal"]();

	if (oPopupManager && !oPopupManager["bIsDestroyed"]) {
		oPopupManager["detachEvent"](
			oPopupManager["E_EVENTS"]["WindowOpen"],
			this,
			'handlePopupWindowOpen'
		);
	}

	if (this["oFieldHelp"]) {
		this["oFieldHelp"]["detachAllEvents"](this);
	}

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	this["oSelectTimer"] = null;

	this["sKeySave"] = null;
	this["sEscapeKey"] = null;
	this["sValueSave"] = null;
	this["sEscapeValue"] = null;
	this["sOldValue"] = null;
	this["sLastSubmittedValue"] = null;
	this["sSearchString"] = null;
	this["sValue"] = null; // eslint-disable-line @ur/no-missing-setClientProperty
	this["sKey"] = null; // eslint-disable-line @ur/no-missing-setClientProperty
	this["sSemanticColor"] = null; // eslint-disable-line @ur/no-missing-setClientProperty
	this["sIconSrc"] = null;
	this["sItemListBoxId"] = null; // eslint-disable-line @ur/no-missing-setClientProperty
	this["sSuggestFilterCondition"] = null; // eslint-disable-line @ur/no-missing-setClientProperty

	this["iLastKeypress"] = null;
	this["iOptimalNumberOfItems"] = null;

	this["bShouldCloseListboxOnResize"] = null;
	this["bNoBlur"] = null;
	this["bIsExplicitListAccess"] = null;
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onWillDestroyComboBox"] = 0; };

/**
 * @private
 * @override
 */
UCF_ComboBox["prototype"]["onWillDestroyFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onWillDestroyFieldHelp"]++; }; 
	if (!this["bShouldShowOverlay"]()) {
		this["closeFieldHelp"](true);

		// getListBox() may create a new reference to this.oFieldHelp
		// this is what happened in UCF_Tokenizer.onAnyEvent, after leaving
		// blur() and destroy() cleared all listbox references but in onAnyEvent
		// a reference to this.oFieldHelp was newly created -> JS error
		// we need to make sure that after destroying the FieldHelp all
		// references to it will be deleted
		this["oFieldHelp"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onWillDestroyFieldHelp"] = 0; };

/**
 * @private
 */
UCF_ComboBox["prototype"]["onWindowResize"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onWindowResize"]++; }; 
	this["iOptimalNumberOfItems"] = null;
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'reset this.iOptimalNumberOfItems: ' + this["iOptimalNumberOfItems"], "ComboBox.js(3036): onWindowResize"); };
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["onWindowResize"] = 0; };

/**
 * Returns the Rectangle used for Help
 *
 * @private
 * @return {DOMRect}
 */
UCF_ComboBox["prototype"]["oGetClientRectForHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["oGetClientRectForHelp"]++; }; 
	var oDomRect = this["oDomRef"]["getBoundingClientRect"]();
	if (this["bShowHelpButton"] && !this["bHideFieldHelp"]) {
		if (window["UCF_System"]["bIsRTL"]) {
			oDomRect["x"] = oDomRect["left"] - oDomRect["height"];
		} else {
			oDomRect["right"] = oDomRect["right"] + oDomRect["height"];
		}
		oDomRect["width"] = oDomRect["width"] + oDomRect["height"];
	}
	return oDomRect;
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["oGetClientRectForHelp"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ComboBox["prototype"]["aAttributeNames"] = ["sWidth","sBehavior","bAllowVirtualTyping","sItemListBoxId","sKey","sValue","sVisibility","bContainerWidthSet","sLabelText","sLabelFor","sIMEMode","sType","bShowHelpButtonAlways","sAccessKey","sSuggestFilter","bDisplayAsText","bHideFieldHelp","bShowHelpButton","bSuggestAutoComplete","sSuggestFilterCondition","bFieldHelpFloating","sCustomData","sCustomStyle","sTextStyle","sSemanticColor","sEmbeddingBehaviour","sSapTableFieldDesign","bFieldHelpEmbedding","sHeight","sLabelledBy","sTabBehaviour","sDescribedBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ComboBox["prototype"]["aEventNames"] = ["ActionItemActivate","Change","DeleteItem","Select","Enter","ListAccess","Validate","FieldHelpPress","DoubleClick","ClipboardTablePaste","Activate"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ComboBox["prototype"]["aMethodNames"] = ["setChanged","open","update","setInputState","setCursorPosition","setSelection","iGetSelectionStart","iGetSelectionEnd","setEnabled","getEnabled","setEditable","getEditable","setRequired","getRequired","setValueState","getValueState","getValue","setValue","getText","setText","setItemListBoxId","setSuggestFilterCondition","createDataTip","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ComboBoxBehavior}
 */
UCF_ComboBox["prototype"]["sBehavior"] = "DROPDOWNSELECT";

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBox["prototype"]["bAllowVirtualTyping"] = true;

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sItemListBoxId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sValue"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ComboBox["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBox["prototype"]["bContainerWidthSet"] = false;

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sLabelText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sLabelFor"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.IMEMode}
 */
UCF_ComboBox["prototype"]["sIMEMode"] = "AUTO";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputFieldType}
 */
UCF_ComboBox["prototype"]["sType"] = "STRING";

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBox["prototype"]["bShowHelpButtonAlways"] = false;

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SuggestFilterType}
 */
UCF_ComboBox["prototype"]["sSuggestFilter"] = "OFF";

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBox["prototype"]["bDisplayAsText"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBox["prototype"]["bHideFieldHelp"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBox["prototype"]["bShowHelpButton"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBox["prototype"]["bSuggestAutoComplete"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SuggestFilterCondition}
 */
UCF_ComboBox["prototype"]["sSuggestFilterCondition"] = "VALUE1_OR_VALUE2";

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBox["prototype"]["bFieldHelpFloating"] = true;

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputFieldTextStyle}
 */
UCF_ComboBox["prototype"]["sTextStyle"] = "NORMAL";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_ComboBox["prototype"]["sSemanticColor"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.EmbeddingBehaviour}
 */
UCF_ComboBox["prototype"]["sEmbeddingBehaviour"] = "COMPATIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TableFieldDesign}
 */
UCF_ComboBox["prototype"]["sSapTableFieldDesign"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBox["prototype"]["bFieldHelpEmbedding"] = false;

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TabBehaviour}
 */
UCF_ComboBox["prototype"]["sTabBehaviour"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_ComboBox["prototype"]["sDescribedBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ComboBox["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setDefaultValues"]++; }; 
	this["sWidth"] = '';
	this["sBehavior"] = "DROPDOWNSELECT";
	this["bAllowVirtualTyping"] = true;
	this["sItemListBoxId"] = '';
	this["sKey"] = '';
	this["sValue"] = '';
	this["sVisibility"] = "VISIBLE";
	this["bContainerWidthSet"] = false;
	this["sLabelText"] = '';
	this["sLabelFor"] = '';
	this["sIMEMode"] = "AUTO";
	this["sType"] = "STRING";
	this["bShowHelpButtonAlways"] = false;
	this["sAccessKey"] = '';
	this["sSuggestFilter"] = "OFF";
	this["bDisplayAsText"] = false;
	this["bHideFieldHelp"] = false;
	this["bShowHelpButton"] = true;
	this["bSuggestAutoComplete"] = false;
	this["sSuggestFilterCondition"] = "VALUE1_OR_VALUE2";
	this["bFieldHelpFloating"] = true;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sTextStyle"] = "NORMAL";
	this["sSemanticColor"] = "NONE";
	this["sEmbeddingBehaviour"] = "COMPATIBLE";
	this["sSapTableFieldDesign"] = "NONE";
	this["bFieldHelpEmbedding"] = false;
	this["sHeight"] = '';
	this["sLabelledBy"] = '';
	this["sTabBehaviour"] = "STANDARD";
	this["sDescribedBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("Behavior", "DROPDOWNSELECT", true);
		this["setClientProperty"]("AllowVirtualTyping", true, true);
		this["setClientProperty"]("ItemListBoxId", '', true);
		this["setClientProperty"]("Key", '', true);
		this["setClientProperty"]("Value", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ContainerWidthSet", false, true);
		this["setClientProperty"]("LabelText", '', true);
		this["setClientProperty"]("LabelFor", '', true);
		this["setClientProperty"]("IMEMode", "AUTO", true);
		this["setClientProperty"]("Type", "STRING", true);
		this["setClientProperty"]("ShowHelpButtonAlways", false, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("SuggestFilter", "OFF", true);
		this["setClientProperty"]("DisplayAsText", false, true);
		this["setClientProperty"]("HideFieldHelp", false, true);
		this["setClientProperty"]("ShowHelpButton", true, true);
		this["setClientProperty"]("SuggestAutoComplete", false, true);
		this["setClientProperty"]("SuggestFilterCondition", "VALUE1_OR_VALUE2", true);
		this["setClientProperty"]("FieldHelpFloating", true, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("TextStyle", "NORMAL", true);
		this["setClientProperty"]("SemanticColor", "NONE", true);
		this["setClientProperty"]("EmbeddingBehaviour", "COMPATIBLE", true);
		this["setClientProperty"]("SapTableFieldDesign", "NONE", true);
		this["setClientProperty"]("FieldHelpEmbedding", false, true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("TabBehaviour", "STANDARD", true);
		this["setClientProperty"]("DescribedBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sActionItemId Identifier of the action
 * @fires ComboBox::ActionItemActivate
 */
UCF_ComboBox["prototype"]["fireActionItemActivate"] = function(sId, sActionItemId) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireActionItemActivate"]++; }; 
	/** @type {{Id: string, ActionItemId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ComboBox.js(3355): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ComboBox.js(3356): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ComboBox.js(3357): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sActionItemId != null, "sActionItemId != null", "ComboBox.js(3358): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sActionItemId) == "string", "typeof(sActionItemId) == \"string\"", "ComboBox.js(3359): fireActionItemActivate"); };
	mParams = {
		"Id": sId,
		"ActionItemId": sActionItemId
	};
	
	
	this["fireSemanticEvent"]("ComboBox", "ActionItemActivate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireActionItemActivate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue The entered value
 * @fires ComboBox::Change
 */
UCF_ComboBox["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ComboBox.js(3379): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ComboBox.js(3380): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ComboBox.js(3381): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "ComboBox.js(3382): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "ComboBox.js(3383): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("ComboBox", "Change", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sKey The key of the item that will be deleted
 * @fires ComboBox::DeleteItem
 */
UCF_ComboBox["prototype"]["fireDeleteItem"] = function(sId, sKey) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireDeleteItem"]++; }; 
	/** @type {{Id: string, Key: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ComboBox.js(3403): fireDeleteItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ComboBox.js(3404): fireDeleteItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ComboBox.js(3405): fireDeleteItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sKey != null, "sKey != null", "ComboBox.js(3406): fireDeleteItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sKey) == "string", "typeof(sKey) == \"string\"", "ComboBox.js(3407): fireDeleteItem"); };
	mParams = {
		"Id": sId,
		"Key": sKey
	};
	
	
	this["fireSemanticEvent"]("ComboBox", "DeleteItem", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireDeleteItem"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sKey The selected key
 * @param {boolean} bByEnter Select event was caused by pressing the enter key in the ListBox - Enter event will follow.
 * @fires ComboBox::Select
 */
UCF_ComboBox["prototype"]["fireSelect"] = function(sId, sKey, bByEnter) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, Key: string, ByEnter: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "ComboBox.js(3428): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ComboBox.js(3429): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ComboBox.js(3430): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sKey != null, "sKey != null", "ComboBox.js(3431): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sKey) == "string", "typeof(sKey) == \"string\"", "ComboBox.js(3432): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bByEnter != null, "bByEnter != null", "ComboBox.js(3433): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bByEnter) == "boolean", "typeof(bByEnter) == \"boolean\"", "ComboBox.js(3434): fireSelect"); };
	mParams = {
		"Id": sId,
		"Key": sKey,
		"ByEnter": bByEnter
	};
	
	
	
	this["fireSemanticEvent"]("ComboBox", "Select", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires ComboBox::Enter
 */
UCF_ComboBox["prototype"]["fireEnter"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireEnter"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "ComboBox.js(3455): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ComboBox.js(3456): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ComboBox.js(3457): fireEnter"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("ComboBox", "Enter", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireEnter"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sItemListBoxId Identifier of the ItemListBox of the ComboBox that contains the values.
 * @param {string} sFilterValue Value used to filter the list.
 * @param {number} iOptimalNumberOfItems Optimal number of list items that can be displayed in the available space
 * @param {boolean} bExplicit True if the ListAccess was triggered explicitly by pressing ALT + DOWN. The information that no matches were found may only be displayed if the ListAccess was triggered explicitly.
 * @fires ComboBox::ListAccess
 */
UCF_ComboBox["prototype"]["fireListAccess"] = function(sId, sItemListBoxId, sFilterValue, iOptimalNumberOfItems, bExplicit) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireListAccess"]++; }; 
	/** @type {{Id: string, ItemListBoxId: string, FilterValue: string, OptimalNumberOfItems: number, Explicit: boolean}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "ComboBox.js(3480): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ComboBox.js(3481): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ComboBox.js(3482): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemListBoxId != null, "sItemListBoxId != null", "ComboBox.js(3483): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemListBoxId) == "string", "typeof(sItemListBoxId) == \"string\"", "ComboBox.js(3484): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFilterValue != null, "sFilterValue != null", "ComboBox.js(3485): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFilterValue) == "string", "typeof(sFilterValue) == \"string\"", "ComboBox.js(3486): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOptimalNumberOfItems != null, "iOptimalNumberOfItems != null", "ComboBox.js(3487): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOptimalNumberOfItems) == "number", "typeof(iOptimalNumberOfItems) == \"number\"", "ComboBox.js(3488): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bExplicit != null, "bExplicit != null", "ComboBox.js(3489): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bExplicit) == "boolean", "typeof(bExplicit) == \"boolean\"", "ComboBox.js(3490): fireListAccess"); };
	mParams = {
		"Id": sId,
		"ItemListBoxId": sItemListBoxId,
		"FilterValue": sFilterValue,
		"OptimalNumberOfItems": iOptimalNumberOfItems,
		"Explicit": bExplicit
	};
	
	if (sItemListBoxId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemListBoxId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemListBoxId");
			}
		}
	
	
	
	this["fireSemanticEvent"]("ComboBox", "ListAccess", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireListAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue New value that should be validated
 * @fires ComboBox::Validate
 */
UCF_ComboBox["prototype"]["fireValidate"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireValidate"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ComboBox.js(3521): fireValidate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ComboBox.js(3522): fireValidate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ComboBox.js(3523): fireValidate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "ComboBox.js(3524): fireValidate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "ComboBox.js(3525): fireValidate"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("ComboBox", "Validate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireValidate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires ComboBox::FieldHelpPress
 */
UCF_ComboBox["prototype"]["fireFieldHelpPress"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireFieldHelpPress"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "ComboBox.js(3544): fireFieldHelpPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ComboBox.js(3545): fireFieldHelpPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ComboBox.js(3546): fireFieldHelpPress"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("ComboBox", "FieldHelpPress", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireFieldHelpPress"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires ComboBox::DoubleClick
 */
UCF_ComboBox["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "ComboBox.js(3563): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ComboBox.js(3564): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ComboBox.js(3565): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("ComboBox", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue The clipboard contents.
 * @fires ComboBox::ClipboardTablePaste
 */
UCF_ComboBox["prototype"]["fireClipboardTablePaste"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireClipboardTablePaste"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ComboBox.js(3583): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ComboBox.js(3584): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ComboBox.js(3585): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "ComboBox.js(3586): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "ComboBox.js(3587): fireClipboardTablePaste"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("ComboBox", "ClipboardTablePaste", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireClipboardTablePaste"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires ComboBox::Activate
 * @deprecated
 */
UCF_ComboBox["prototype"]["fireActivate"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireActivate"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "ComboBox.js(3607): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ComboBox.js(3608): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ComboBox.js(3609): fireActivate"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("ComboBox", "Activate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ComboBox["_"]["fireActivate"] = 0; };

UCF_ComboBox.prototype["aPublicMethods"] = ["open","setChanged","setValue","getValue","getText","getEnteredText","setText","setItemListBoxId","lockListAccess","unlockListAccess","onlsunlock","setSuggestFilterCondition"].concat(UCF_ComboBox.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ComboBoxListBox"] = function() {/* global __UCF_TRACE__ */
/* global _assert, _trace, DEBUG, INFO, WARNING, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_RenderManager */
/// <reference path="../core/RenderManager.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemListBox_ie6 */
/// <reference path="./base/ItemListBox_ie6.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * @typedef {Object} UCF_ComboBoxListBox_TableData
 * @property {Array<UCF_ComboBoxListBox_Column>} definition
 * @property {Array} items
 * @property {Array} historyItems
 * @property {number} iItemHeight
 * @property {number} iHeaderHeight
 * @property {number} iHeadlineHeight
 */
/**
 * @typedef {Object} UCF_ComboBoxListBox_Column
 * @property {string} sWidth
 * @property {string} Label
 * @property {string} Type
 * @property {number} Length
 * @property {string} Visibility
 */
/**
 * @typedef {Object} UCF_ComboBoxListBox_ItemData
 * @property {Object} Events
 * @property {string} IconSrc
 * @property {string} DisabledIconSrc
 * @property {string} ToolTip
 * @property {string} Value
 * @property {boolean} Enabled
 * @property {boolean} Readonly
 * @property {string} ColumnVisibility
 * @property {boolean} IsBeforeSeparator
 * @property {boolean} IsAfterSeparator
 * @property {string} TextDirection
 * @property {string} Align
 * @property {string} Design
 * @property {string} SemanticColor
 * @property {boolean} TextOverflow
 * @property {number} ColSpan
 */

/**
 * 
 *
 * @class
 * @extends UCF_ItemListBox
 * @param {HTMLElement} oDomRef the DOM element that represents the control
 * @param {UCF_LS} oLS the LightSpeed instance that manages the control
 */
function UCF_ComboBoxListBox(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["UCF_ComboBoxListBox"]++; }; 
	/** @type {Array.<HTMLTableRowElement>} */
	var aItemsDomRef;
	/** @type {number} */
	var i;

	if (arguments["length"] === 0) {
		return; // needed for inheritance
	}

	UCF_ItemListBox_ie6["apply"](this, [oDomRef, oLS]);

	this["defineEvents"]([
		'Close',
		'Select',
		'Activate',
		'ActionActivate',
		'DeleteItem',
		'FocusChange',
		'Open',
		'HeightChange',
		'GetActionItems',
		'LayeredControlResize',
		'WillDestroy'
	]);

	/** @type {HTMLElement} the itemlistbox container */
	this["oScrollRef"] = UCF_DomUtil["$"](this["sId"] + '-scrl');

	/** @type {HTMLElement} the itemlistbox table */
	this["oTableRef"] = UCF_DomUtil["$"](this["sId"] + '-tab');

	/** @type {number} */
	this["iMinWidth"] = this["oTableRef"] ? this["oTableRef"]["offsetWidth"] : 0;
	UCF_DomUtil["setStyle"](
		this["oDomRef"],
		'width',
		// use different width-handling in case of table data passed by JSON string
		typeof this["oTableData"] === 'undefined' ? this["iMinWidth"] + 'px' : ''
	);

	/** @type {boolean} */
	this["bReadonly"] = false;

	/** @type {UCF_ItemListBoxItem} */
	this["oSelectedItem"] = null;

	aItemsDomRef = this["aGetItemsDomRefs"]();
	for (i = 0; i < aItemsDomRef["length"]; i++) {
		if (aItemsDomRef[i]["getAttribute"]('ct')) {
			this["oLS"]["oGetControlByDomRef"](aItemsDomRef[i])["select"](false);
			/** @type {number} */
			this["iItemHeight"] = Math["max"](
				this["iItemHeight"],
				UCF_DomUtil["oGetObjectRect"](aItemsDomRef[i])["height"]
			);
		}
	}

	if (this["oTableData"]) {
		this["setSafetyDistance"](UCF_LayeredControl["MIN_BORDER_DISTANCE"]);
	}

	/** @type {UCF_ComboBox} */
	this["oEventDefaultHandler"] = null;
	/** @type {number} */
	this["iTouchDeltaX"] = 0;
	/** @type {number} */
	this["iTouchDeltaY"] = 0;
	/** @type {boolean} */
	this["bTouchNoEventing"] = false;
	/** @type {boolean} */
	this["bIgnoreHover"] = false;
};window["UCF_ComboBoxListBox"] = UCF_ComboBoxListBox; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ComboBoxListBox"); UCF_ComboBoxListBox["_"] = {UCF_ComboBoxListBox: 0}; }; ;
UCF_ComboBoxListBox["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemListBox_ie6"))(); UCF_ComboBoxListBox.prototype["sClassName"] = "UCF_ComboBoxListBox";

/**
 * @protected
 * @type {number}
 */
UCF_ComboBoxListBox["iActionItemsHeight"] = 0;

/**
 * @private
 * @const {number} MIN_GESTURE_DISTANCE in px
 */
UCF_ComboBoxListBox["MIN_GESTURE_DISTANCE"] = 2;

/**
 * @private
 * @const {number} TOUCH_HANDLING_DELAY in ms
 */
UCF_ComboBoxListBox["TOUCH_HANDLING_DELAY"] = 0;

/**
 * @private
 * @const {number} PW_SAFETY_DISTANCE in px
 */
UCF_ComboBoxListBox["PW_SAFETY_DISTANCE"] = 20;

/**
 * @private
 * @const {number} MIN_COL_WIDTH in chars
 */
UCF_ComboBoxListBox["MIN_COL_WIDTH"] = 7;

/**
 * @private
 * @const {number} MAX_COL_WIDTH in chars
 */
UCF_ComboBoxListBox["MAX_COL_WIDTH"] = 40;

/**
 * @private
 * @const {number} COL_VALUE_LENGTH_CHAR_RATIO ratio when converting the length
 * of a value column to chars
 */
UCF_ComboBoxListBox["COL_VALUE_LENGTH_CHAR_RATIO"] = 0.2;

/**
 * @private
 * @const {number} COL_CHAR_EM_RATIO ratio when converting chars to ems
 */
UCF_ComboBoxListBox["COL_CHAR_EM_RATIO"] = 0.5;

/**
 * @private
 * @param {any} oControl the control
 * @return {boolean}
 */
UCF_ComboBoxListBox["bIsActionItem"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsActionItem"]++; }; 
	return UCF_JsUtil["bInstanceOf"](oControl, 'UCF_ItemListBoxActionItem');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsActionItem"] = 0; };

/** @override */
UCF_ComboBoxListBox["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["destroy"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["WillDestroy"]);

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	this["oDomRef"] = null;
	this["oSelectedItem"] = null;
	this["oScrollRef"] = null;
	this["oTableRef"] = null;
	this["iMinWidth"] = null;
	this["oEventDefaultHandler"] = null;
	this["iTouchDeltaX"] = null;
	this["iTouchDeltaY"] = null;
	this["bTouchNoEventing"] = null;
	this["iHeadlineWidth"] = null;
	this["oTableData"] = null;
	this["sDeletable"] = null;
	this["sHistoryItem"] = null;
	this["sSuggestItem"] = null;

	UCF_ItemListBox_ie6.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["destroy"] = 0; };

/**
 * @private
 * @return {HTMLTableElement}
 */
UCF_ComboBoxListBox["prototype"]["oGetContentDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["oGetContentDomRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + '-tab');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["oGetContentDomRef"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_ComboBoxListBox["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onclick"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBoxListBox.js(246): onclick"); };

	if (!this["bReadonly"]) {
		// handle only item clicks
		oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);
		if (!oItem || (oItem && !oItem["bIsEnabled"]())) {
			return;
		}
		// check whether the delete cell was clicked
		if (UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem')) {
			if (
				UCF_DomUtil["bHasClass"](
					oBrowserEvent["oGetSource"](),
					'lsItemlistbox__button--delete'
				) &&
				oItem["bIsDeletable"] &&
				oItem["bEnabled"]
			) {
				this["fireDeleteItem"]({ "sKey": oItem["sKey"] });
			} else {
				this["fireSelect"]({
					"sKey": oItem["sKey"],
					"sValue": this["sGetItemValue"](oItem["sKey"]),
					"bFireSelect": true,
					"sEventName": 'click',
					"sIconSrc": oItem["sIconSrc"]
				});
				this["fireClose"]();
			}
		} else if (UCF_ComboBoxListBox["bIsActionItem"](oItem)) {
			this["emitActionActivate"]({ "sId": oItem["sId"] });
		} else {
			this["fireActivate"]();
		}
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onclick"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the contextmenu
 */
UCF_ComboBoxListBox["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["oncontextmenu"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "ComboBoxListBox.js(289): oncontextmenu"); };
	// do not allow a context menu for open list boxes
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["oncontextmenu"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_ComboBoxListBox["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "ComboBoxListBox.js(300): onlsfocus"); };
	this["fireActivate"]();

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlsfocus"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mousedown
 */
UCF_ComboBoxListBox["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "ComboBoxListBox.js(311): onmousedown"); };

	this["fireActivate"]();

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onmousedown"] = 0; };

/**
 * Handles the touch start event, we will store the actual touch position and
 * verify it in touch move to identify a scrolling within the listbox.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstouchstart
 */
UCF_ComboBoxListBox["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlstouchstart"]++; }; 
	/** @type {{clientX: number, clientY: number}} */
	var touchPoints;

	this["bTouchNoEventing"] = false;

	touchPoints = oBrowserEvent["aGetChangedTouches"]();
	if (touchPoints[0]) {
		this["iTouchDeltaX"] = touchPoints[0]["clientX"];
		this["iTouchDeltaY"] = touchPoints[0]["clientY"];
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlstouchstart"] = 0; };

/**
 * Handles the touch move event, a possible delta to the initial position will
 * tell us the user wants to scroll within the listbox.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstouchmove
 */
UCF_ComboBoxListBox["prototype"]["onlstouchmove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlstouchmove"]++; }; 
	/** @type {Array<{clientX: number, clientY: number}>} */
	var touchPoint = oBrowserEvent["aGetChangedTouches"]();
	/** @type {number} */
	var iFromX = this["iTouchDeltaX"];
	/** @type {number} */
	var iFromY = this["iTouchDeltaY"];
	/** @type {number} */
	var iToX = touchPoint[0]["clientX"];
	/** @type {number} */
	var iToY = touchPoint[0]["clientY"];
	/** @type {number} */
	var iDifferenceX;
	/** @type {number} */
	var iDifferenceY;

	if (touchPoint && touchPoint[0]) {
		iDifferenceX = Math["abs"](iFromX - iToX);
		iDifferenceY = Math["abs"](iFromY - iToY);

		this["bTouchNoEventing"] =
			iDifferenceX > UCF_ComboBoxListBox["MIN_GESTURE_DISTANCE"] ||
			iDifferenceY > UCF_ComboBoxListBox["MIN_GESTURE_DISTANCE"];

		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'touch moving x=' + iFromX + ' y=' + iFromY + ' tx=' + iToX + ' ty=' + iToY + ' dx=' + iDifferenceX + ' dy=' + iDifferenceY, "ComboBoxListBox.js(369): onlstouchmove"); };
	}

	this["selectItemFromBrowserEvent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlstouchmove"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstouchend
 */
UCF_ComboBoxListBox["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlstouchend"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;
	/** @type {string} */
	var sValue;
	/** @type {string} */
	var sEventName;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBoxListBox.js(387): onlstouchend"); };

	if (!this["bTouchNoEventing"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'touch end', "ComboBoxListBox.js(390): onlstouchend"); };
		if (this["bReadonly"]) {
			return;
		}

		// handle only item clicks
		oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);
		if (!oItem || (oItem && !oItem["bIsEnabled"]())) {
			return;
		}

		if (UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem')) {
			if (
				UCF_DomUtil["bHasClass"](
					oBrowserEvent["oGetSource"](),
					'lsItemlistbox__button--delete'
				) &&
				oItem["bIsDeletable"] &&
				oItem["bEnabled"]
			) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'delete item', "ComboBoxListBox.js(410): onlstouchend"); };
				this["fireDeleteItem"]({ "sKey": oItem["sKey"] });
			} else {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'select item', "ComboBoxListBox.js(413): onlstouchend"); };
				this["selectItemFromBrowserEvent"](oBrowserEvent);

				sValue = this["sGetItemValue"](oItem["sKey"]);
				sEventName = oBrowserEvent["sGetName"]();

				// we need to delay the select and close event. Otherwise the click on an
				// underlaying element (after the close of the list) will be triggered.
				UCF_JsUtil["delayedCall"](UCF_ComboBoxListBox["TOUCH_HANDLING_DELAY"], this, 'fireSelect', [{
					"sKey": oItem["sKey"],
					"sValue": sValue,
					"bFireSelect": true,
					"sEventName": sEventName
				}]);
				UCF_JsUtil["delayedCall"](UCF_ComboBoxListBox["TOUCH_HANDLING_DELAY"], this, 'fireClose');
			}
			oBrowserEvent["cancel"]();
		} else if (UCF_ComboBoxListBox["bIsActionItem"](oItem)) {
			this["selectItemFromBrowserEvent"](oBrowserEvent);

			// we need to delay the select and close event. Otherwise the click on an
			// underlaying element (after the close of the list) will be triggered.
			UCF_JsUtil["delayedCall"](
				UCF_ComboBoxListBox["TOUCH_HANDLING_DELAY"],
				this,
				'emitActionActivate', [{ "sId": oItem["sId"] }]
			);
			oBrowserEvent["cancel"]();
		} else {
			this["fireActivate"]();
		}

	}

	oBrowserEvent["cancelBubble"]();
	this["iTouchDeltaX"] = 0;
	this["iTouchDeltaY"] = 0;
	this["bTouchNoEventing"] = false;
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlstouchend"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseover
 */
UCF_ComboBoxListBox["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onmouseover"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBoxListBox.js(461): onmouseover"); };
	if (this["bIgnoreHover"]) {
		this["bIgnoreHover"] = false;

		return;
	}
	if (!this["bReadonly"]) {
		oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);

		if (oItem && oItem["sClassName"] === 'UCF_ItemListBoxItem_ie6') {
			oItem["select"](true);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onmouseover"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseout
 */
UCF_ComboBoxListBox["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onmouseout"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBoxListBox.js(484): onmouseout"); };

	oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);

	if (
		oItem &&
		oItem["sClassName"] === 'UCF_ItemListBoxItem_ie6' &&
		this["oSelectedItem"] !== oItem
	) {
		oItem["select"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onmouseout"] = 0; };

/**
 * Checks if the control has a valid DOM reference. This can be used for
 * timeout methods, that may be called after the HTML of the control has
 * already been removed.
 *
 * @private
 * @return {boolean} `true` if the control has a valid DOM reference
 */
UCF_ComboBoxListBox["prototype"]["bIsValid"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsValid"]++; }; 
	return !this["oRootRef"] || this["oRootRef"] === UCF_DomUtil["$"](this["sId"] + '-r');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsValid"] = 0; };

/**
 * Return whether the list is currently available or just a placehoder for a
 * List that is dynamically loaded from the server
 *
 * @public
 * @return {boolean} `true` if available, otherwise `false`
 */
UCF_ComboBoxListBox["prototype"]["bIsAvailable"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsAvailable"]++; }; 
	return this["bAvailable"];
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsAvailable"] = 0; };

/**
 * Change the scroll position (if any) so that the specified item is made
 * visible
 *
 * @private
 * @param {string} sKey the key of the item
 */
UCF_ComboBoxListBox["prototype"]["scrollIntoView"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["scrollIntoView"]++; }; 
	/** @type {string} */
	var sOverflow = this["oScrollRef"]["style"]["overflowY"];
	/** @type {UCF_ItemListBoxItem} */
	var oSelectedItem;
	/** @type {number} */
	var iScrollTop;
	/** @type {number} */
	var iOffsetHeight;
	/** @type {number} */
	var iSelectedItemOffsetTop;

	if ((sOverflow === 'scroll' || sOverflow === 'auto') &&
		(oSelectedItem = this["mGetItems"]()[sKey])) {
		iScrollTop = this["oScrollRef"]["scrollTop"];
		iOffsetHeight = this["oScrollRef"]["offsetHeight"];
		iSelectedItemOffsetTop = oSelectedItem["oDomRef"]["offsetTop"];

		// selected is above the visible area
		if (iSelectedItemOffsetTop < iScrollTop) {
			this["oScrollRef"]["scrollTop"] = iSelectedItemOffsetTop;
		}

		// selected is below the visible area
		if (
			iSelectedItemOffsetTop + this["iItemHeight"] > iScrollTop + iOffsetHeight
		) {
			this["oScrollRef"]["scrollTop"] = iSelectedItemOffsetTop -
				iOffsetHeight +
				this["iItemHeight"] +
				2; // eslint-disable-line no-magic-numbers
			this["bIgnoreHover"] = true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["scrollIntoView"] = 0; };

/**
 * Returns the key of the selected item.
 *
 * @private
 * @return {string} Key of the selected item
 */
UCF_ComboBoxListBox["prototype"]["sGetSelectedItemKey"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["sGetSelectedItemKey"]++; }; 
	if (this["oSelectedItem"]) {
		if (UCF_ComboBoxListBox["bIsActionItem"](this["oSelectedItem"])) {
			this["emitActionActivate"]({ "sId": this["oSelectedItem"]["sId"] });
		} else {
			return this["oSelectedItem"]["sKey"];
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["sGetSelectedItemKey"] = 0; };

/**
 * Returns the currently selected item of the list box
 *
 * @public
 * @return {UCF_ItemListBoxItem} the actual selected item
 */
UCF_ComboBoxListBox["prototype"]["oGetSelectedItem"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["oGetSelectedItem"]++; }; 
	return this["oSelectedItem"];
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["oGetSelectedItem"] = 0; };

/**
 * Returns the currently selected item of the list box
 *
 * @param {UCF_ItemListBoxItem} oItem The item that is deleted
 * @public
 */
UCF_ComboBoxListBox["prototype"]["deleteItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["deleteItem"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {HTMLElement} */
	var oNext;
	/** @type {number} */
	var i;
	/** @type {Array.<DomRefs>} */
	var aItemsDomRef;

	if (oItem === this["oSelectedItem"]) {
		this["clearSelection"]();
	}

	oDomRef = oItem["oDomRef"];
	if (oDomRef) {
		oNext = oDomRef["nextSibling"];
		if (
			oNext &&
			oNext["getAttribute"]('name') === 'HLine' &&
			(
				oDomRef["previousSibling"] == null ||
				oDomRef["previousSibling"]["style"]["display"] === 'none'
			)
		) {
			oNext["style"]["display"] = 'none';
		}
		oDomRef["parentNode"]["removeChild"](oDomRef);

		this["aItems"] = null;
		this["oCache"]["invalidate"]('mItems');
		this["oCache"]["invalidate"]('aGetItemsDomRefs');

		aItemsDomRef = this["aGetItemsDomRefs"]();

		for (i = 0; i < aItemsDomRef["length"]; i++) {
			if (aItemsDomRef[i]["getAttribute"]('ct') &&
				aItemsDomRef[i]["offsetHeight"] > this["iItemHeight"]
			) {
				this["iItemHeight"] = aItemsDomRef[i]["offsetHeight"];
			}
		}
		this["applyHeight"]();
		this["setPosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["deleteItem"] = 0; };

/**
 * Deselects all items
 *
 * @private
 */
UCF_ComboBoxListBox["prototype"]["clearSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["clearSelection"]++; }; 
	if (
		this["oSelectedItem"] &&
		!this["oSelectedItem"]["bIsDestroyed"] &&
		this["oSelectedItem"]["bIsValid"]()
	) {
		this["oSelectedItem"]["select"](false);
		this["oSelectedItem"]["showFocus"](false);
	}
	this["oSelectedItem"] = null;
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["clearSelection"] = 0; };

/**
 * Clear focus visualisation on item
 * @see UCF_ComboBox# onAfterPaste
 * @see UCF_Combobox# onAfterLsLeft
 * @see UCF_ComboBox# onAfterLsRight
 *
 * @protected
 */
UCF_ComboBoxListBox["prototype"]["clearFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["clearFocus"]++; }; 
	/** @type {UCF_ComboBoxListBox_ActionItem} */
	var oSelectedActionItem = this["oGetSelectedItem"]();

	this["clearSelection"]();
	if (oSelectedActionItem) {
		this["selectItem"](oSelectedActionItem["sKey"]);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["clearFocus"] = 0; };

/**
 * Select item, deselects previously selected item
 *
 * @private
 * @param {string} sKey the key of the Item that should be selected
 */
UCF_ComboBoxListBox["prototype"]["selectItem"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["selectItem"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem = this["mGetItems"]()[sKey];

	if (oItem) {
		if (this["oSelectedItem"]) {
			this["oSelectedItem"]["select"](false);
			this["oSelectedItem"]["showFocus"](false);
		}
		oItem["select"](true);
		oItem["showFocus"](true);
		this["fireFocusChange"]({ "oNewItem": oItem });

		this["oSelectedItem"] = oItem;
		this["scrollIntoView"](sKey);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["selectItem"] = 0; };

/**
 * Select item, deselects previously selected item and fires select event
 *
 * @private
 * @param {UCF_ItemListBoxItem} oItem the Item that should be selected
 * @param {string} [sEventName] passed to the fired ComboBoxListBox:Select
 */
UCF_ComboBoxListBox["prototype"]["selectItemAndFire"] = function(oItem, sEventName) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["selectItemAndFire"]++; }; 
	/** @type {boolean} */
	var bFireSelect;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem'), "UCF_JsUtil.bInstanceOf(oItem, 'UCF_ItemListBoxItem')", "ComboBoxListBox.js(714): selectItemAndFire"); };

	bFireSelect = !this["bOpened"];

	if (oItem) {
		this["selectItem"](oItem["sKey"]);
	}

	if (
		(this["oSelectedItem"] && this["oSelectedItem"]["bIsEnabled"]()) ||
		this["oLS"]["oSystem"]["bIs508"]
	) {
		this["fireSelect"]({
			"sKey": this["oSelectedItem"]["sKey"],
			"sValue": this["sGetItemValue"](this["oSelectedItem"]["sKey"]),
			"bFireSelect": bFireSelect,
			"sEventName": sEventName,
			"sIconSrc": this["oSelectedItem"]["sIconSrc"]
		});
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["selectItemAndFire"] = 0; };

/**
 * Selects an action item, deselects previously selected item
 *
 * @private
 * @param {UCF_ItemListBoxActionItem} oItem the action item to select
 */
UCF_ComboBoxListBox["prototype"]["selectActionItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["selectActionItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_ComboBoxListBox["bIsActionItem"](oItem), "UCF_ComboBoxListBox.bIsActionItem(oItem)", "ComboBoxListBox.js(743): selectActionItem"); };

	if (oItem) {
		// 1780119710: as a workaround we need to add aria attributes also in 508
		// else JAWS 17/18 does not announce the items within a list properly
		if ((window["UCF_System"]["bIsAria"] || this["oLS"]["oSystem"]["bIs508"]) && this["oOpenerRef"]) {
			UCF_AriaStateHelper["setActivedescendant"](
				UCF_DomUtil["$"](this["oOpenerRef"]["id"]["split"]('-r')[0]),
				oItem["sId"]
			);
		}
		if (this["oSelectedItem"]) {
			this["oSelectedItem"]["select"](false);
			this["oSelectedItem"]["showFocus"](false);
		}
		oItem["select"](true);
		oItem["showFocus"](true);
		this["oSelectedItem"] = oItem;
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["selectActionItem"] = 0; };

/**
 * Selects first item in the list
 *
 * @private
 */
UCF_ComboBoxListBox["prototype"]["handleFirstItem"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handleFirstItem"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oFirstItem = this["oGetFirstItem"]();

	if (oFirstItem) {
		if (
			UCF_ComboBoxListBox["bIsActionItem"](this["oSelectedItem"]) &&
			this["oGetFirstActionItem"]() !== this["oSelectedItem"]
		) {
			oFirstItem = this["oGetFirstActionItem"]();
			this["selectActionItem"](oFirstItem);
		} else if (oFirstItem !== this["oSelectedItem"]) {
			this["selectItem"](oFirstItem["sKey"]);
			if (this["oSelectedItem"]) {
				this["fireSelect"]({
					"sKey": this["oSelectedItem"]["sKey"],
					"sValue": this["sGetItemValue"](this["oSelectedItem"]["sKey"]),
					"bFireSelect": false,
					"sEventName": 'firstitem'
				});
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handleFirstItem"] = 0; };

/**
 * Selects last item in the list
 *
 * @private
 */
UCF_ComboBoxListBox["prototype"]["handleLastItem"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handleLastItem"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oLastItem = this["oGetLastItem"]();

	if (oLastItem) {
		if (oLastItem === this["oSelectedItem"] &&
			this["aGetActionItems"]()["length"] > 0
		) {
			this["selectActionItem"](this["oGetLastActionItem"]());
		} else if (oLastItem !== this["oSelectedItem"]) {
			this["selectItem"](oLastItem["sKey"]);
			if (this["oSelectedItem"]) {
				this["fireSelect"]({
					"sKey": this["oSelectedItem"]["sKey"],
					"sValue": this["sGetItemValue"](this["oSelectedItem"]["sKey"]),
					"bFireSelect": false,
					"sEventName": 'lastitem'
				});
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handleLastItem"] = 0; };

/**
 * Select next item
 *
 * @private
 * @param {UCF_ItemListBoxItem|UCF_ItemListBoxActionItem} [oItem] the next item that should be handled
 */
UCF_ComboBoxListBox["prototype"]["handleNextItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handleNextItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!oItem || UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem') || UCF_ComboBoxListBox["bIsActionItem"](oItem), "!oItem || UCF_JsUtil.bInstanceOf(oItem, 'UCF_ItemListBoxItem') || UCF_ComboBoxListBox.bIsActionItem(oItem)", "ComboBoxListBox.js(829): handleNextItem"); };

	// if an item in the list is selected, take this one
	if (this["oSelectedItem"]) {
		oItem = this["oSelectedItem"];
	}

	if (UCF_ComboBoxListBox["bIsActionItem"](this["oSelectedItem"])) {
		// if an actionitem is currently selected, navigate in the action item list
		this["selectActionItem"](this["oGetNextActionItem"](this["oSelectedItem"]));
	} else if (
		oItem === this["oGetLastItem"]() && this["aGetActionItems"]()["length"] > 0
	) {
		// if the item is the last one in the list and there are actionitem,
		// select the first action item
		this["selectActionItem"](this["oGetFirstActionItem"]());
	} else {
		// select the next item or the first item if no item is passed
		this["selectItemAndFire"](oItem ?
			this["oGetNextItem"](oItem) :
			this["oGetFirstItem"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handleNextItem"] = 0; };

/**
 * Select previous item
 *
 * @private
 * @param {UCF_ItemListBoxItem|UCF_ItemListBoxActionItem} [oItem] the previous item that should be handled
 */
UCF_ComboBoxListBox["prototype"]["handlePreviousItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handlePreviousItem"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oPreviousItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(!oItem || UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem') || UCF_ComboBoxListBox["bIsActionItem"](oItem), "!oItem || UCF_JsUtil.bInstanceOf(oItem, 'UCF_ItemListBoxItem') || UCF_ComboBoxListBox.bIsActionItem(oItem)", "ComboBoxListBox.js(863): handlePreviousItem"); };

	// if an item in the list is selected, take this one
	if (this["oSelectedItem"]) {
		oItem = this["oSelectedItem"];
	}

	if (UCF_ComboBoxListBox["bIsActionItem"](this["oSelectedItem"])) {
		// if an action item is currently selected, navigate in action item list
		oPreviousItem = this["oGetPreviousActionItem"](this["oSelectedItem"]);
		if (this["oSelectedItem"] === oPreviousItem) {
			oPreviousItem = this["oGetLastItem"]();
			this["selectItem"](oPreviousItem["sKey"]);
			if (this["oSelectedItem"]) {
				this["fireSelect"]({
					"sKey": this["oSelectedItem"]["sKey"],
					"sValue": this["sGetItemValue"](this["oSelectedItem"]["sKey"]),
					"bFireSelect": false,
					"sEventName": 'previousitem'
				});
			}
		} else {
			this["selectActionItem"](oPreviousItem);
		}
	} else {
		// select the previous item or the last item if no item is passed
		this["selectItemAndFire"](oItem ?
			this["oGetPreviousItem"](oItem) :
			this["oGetLastItem"]());
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handlePreviousItem"] = 0; };
/**
 * Show next page
 *
 * @private
 */
UCF_ComboBoxListBox["prototype"]["handlePageDown"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handlePageDown"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem = this["oSelectedItem"] || this["oGetFirstItem"]();
	/** @type {number} */
	var i;

	if (UCF_ComboBoxListBox["bIsActionItem"](oItem)) {
		this["selectActionItem"](this["oGetLastActionItem"]());
	} else {
		for (i = 0; i < this["iVisibleItems"] - 1; i++) {
			oItem = this["oGetNextItem"](oItem);
			if (!oItem) {
				oItem = this["oGetLastItem"]();
				break;
			}
		}

		this["selectItem"](oItem["sKey"]);
		if (this["oSelectedItem"]) {
			this["fireSelect"]({
				"sKey": this["oSelectedItem"]["sKey"],
				"sValue": this["sGetItemValue"](this["oSelectedItem"]["sKey"]),
				"bFireSelect": false,
				"sEventName": 'pagedown'
			});
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handlePageDown"] = 0; };

/**
 * Show previous page
 *
 * @private
 */
UCF_ComboBoxListBox["prototype"]["handlePageUp"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handlePageUp"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem = this["oSelectedItem"] || this["oGetFirstItem"]();
	/** @type {number} */
	var i;

	if (UCF_ComboBoxListBox["bIsActionItem"](oItem)) {
		this["selectItemAndFire"](this["oGetLastItem"]());
	} else {
		for (i = 0; i < this["iVisibleItems"] - 1; i++) {
			oItem = this["oGetPreviousItem"](oItem);
			if (!oItem) {
				oItem = this["oGetFirstItem"]();
				break;
			}
		}

		this["selectItem"](oItem["sKey"]);
		if (this["oSelectedItem"]) {
			this["fireSelect"]({
				"sKey": this["oSelectedItem"]["sKey"],
				"sValue": this["sGetItemValue"](this["oSelectedItem"]["sKey"]),
				"bFireSelect": false,
				"sEventName": 'pageup'
			});
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["handlePageUp"] = 0; };

/**
 * Determines and applies the height of the ItemListBox
 *
 * @private
 */
UCF_ComboBoxListBox["prototype"]["applyHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyHeight"]++; }; 
	if (this["oTableData"]) {
		this["applyHeightTableDataMode"]();
	} else {
		this["applyHeightControlsMode"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyHeight"] = 0; };

/** @private */
UCF_ComboBoxListBox["prototype"]["applyHeightTableDataMode"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyHeightTableDataMode"]++; }; 
	/** @type {number} */
	var iMaxAvailableHeightForScrollRef;
	/** @type {number} */
	var iRequiredHeightForScrollRef;
	/** @type {number} */
	var iCurrentlyVisibleItems = this["aGetVisibleItems"]()["length"];
	/** @type {number} */
	var iCurrentlyVisibleHistoryItems = this["aGetVisibleHistoryItems"]()["length"];
	/** @type {number} */
	var iActionItemsHeight;

	iRequiredHeightForScrollRef = Math["min"](
		iCurrentlyVisibleItems + iCurrentlyVisibleHistoryItems,
		this["iVisibleItems"]
	) * this["oTableData"]["iItemHeight"];

	// if there are items: add height for "Search Results" + table header
	if (iCurrentlyVisibleItems) {
		iRequiredHeightForScrollRef += this["oTableData"]["iHeadlineHeight"] +
			this["oTableData"]["iHeaderHeight"];
	}

	this["oCache"]["invalidate"]('aGetActionItemDomRefs');
	this["oCache"]["invalidate"]('aGetActionItems');

	// assume that an action item has the same height as an item
	iActionItemsHeight = this["aGetActionItems"]()["length"] *
		this["oTableData"]["iItemHeight"];
	iMaxAvailableHeightForScrollRef =
		Math["max"](0, this["iGetMaxAvailableHeight"]() - iActionItemsHeight - UCF_LayeredControl["MIN_BORDER_DISTANCE"]);

	if (
		(
			iCurrentlyVisibleItems + iCurrentlyVisibleHistoryItems >
			this["iVisibleItems"]
		) ||
		iMaxAvailableHeightForScrollRef < iRequiredHeightForScrollRef
	) {
		this["oScrollRef"]["style"]["height"] = Math["min"](
			iMaxAvailableHeightForScrollRef,
			iRequiredHeightForScrollRef
		) + 'px';
		this["oScrollRef"]["style"]["overflowY"] = 'auto';
	} else {
		this["oScrollRef"]["style"]["height"] = 'auto';
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyHeightTableDataMode"] = 0; };

/**
 * @private
 * @return {Array.<HTMLTableRowElement>} a list of all non-hidden item elements
 */
UCF_ComboBoxListBox["prototype"]["aGetVisibleItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["aGetVisibleItems"]++; }; 
	/** @type {UCF_ComboBoxListBox} */
	var self = this;

	return UCF_JsUtil["filter"](this["aGetItemsDomRefs"](), function(oRef) {
		return UCF_DomUtil["bHasClass"](oRef, 'lsItemlistbox__item--suggest')
			&& !self["bIsRefHidden"](oRef);
	});
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["aGetVisibleItems"] = 0; };

/**
 * @private
 * @return {Array.<HTMLTableRowElement>} a list of all non-hidden item elements
 */
UCF_ComboBoxListBox["prototype"]["aGetVisibleHistoryItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["aGetVisibleHistoryItems"]++; }; 
	/** @type {UCF_ComboBoxListBox} */
	var self = this;

	return UCF_JsUtil["filter"](this["aGetItemsDomRefs"](), function(oRef) {
		return UCF_DomUtil["bHasClass"](oRef, 'lsItemlistbox__item--history')
			&& !self["bIsRefHidden"](oRef);
	});
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["aGetVisibleHistoryItems"] = 0; };

/** @private */
UCF_ComboBoxListBox["prototype"]["applyHeightControlsMode"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyHeightControlsMode"]++; }; 
	/** @type {Array.<HTMLTableRowElement>} */
	var aInitiallyVisibleItemsChildRefs =
		this["aGetInitiallyVisibleItemsChildRefs"]();
	/** @type {string} */
	var sCssRootRefDisplay = this["oRootRef"]["style"]["display"];
	/** @type {number} */
	var iRealHeight;

	this["oRootRef"]["style"]["display"] = 'block';
	iRealHeight = UCF_JsUtil["reduce"](
		aInitiallyVisibleItemsChildRefs,
		function(iSum, oItemRef) { return iSum + oItemRef["offsetHeight"]; },
		0
	);
	this["oRootRef"]["style"]["display"] = sCssRootRefDisplay;

	// Set the height and possible scrollbars
	this["oScrollRef"]["style"]["height"] = iRealHeight + 'px';
	this["oScrollRef"]["style"]["overflowY"] = (
			iRealHeight > 0 &&
			aInitiallyVisibleItemsChildRefs["length"] <
			this["aGetVisibleItemsChildRefs"]()["length"]
		)
		? 'auto'
		: 'hidden';

	if (__UCF_TRACE__) {
		this["traceItems"](aInitiallyVisibleItemsChildRefs);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyHeightControlsMode"] = 0; };

/**
 * @private
 * @return {Array.<HTMLTableRowElement>} a list of all non-hidden item elements
 */
UCF_ComboBoxListBox["prototype"]["aGetVisibleItemsChildRefs"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["aGetVisibleItemsChildRefs"]++; }; 
	/** @type {UCF_ComboBoxListBox} */
	var self = this;

	return UCF_JsUtil["filter"](this["aGetItemsDomRefs"](), function(oRef) {
		return !self["bIsRefHidden"](oRef);
	});
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["aGetVisibleItemsChildRefs"] = 0; };

/**
 * @private
 * @return {Array.<HTMLTableRowElement>} a list of all initially visible item elements
 */
UCF_ComboBoxListBox["prototype"]["aGetInitiallyVisibleItemsChildRefs"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["aGetInitiallyVisibleItemsChildRefs"]++; }; 
	/** @type {Array.<HTMLTableRowElement>} */
	var aAllVisibleItemsChildRefs = this["aGetVisibleItemsChildRefs"]();
	/** @type {number} */
	var iDisplayItemCount = Math["min"](
		Math["max"](1, aAllVisibleItemsChildRefs["length"]),
		this["iGetItemCountForOptimalPosition"](),
		this["iVisibleItems"] > 0
		? this["iVisibleItems"] +
		UCF_JsUtil["filter"](this["aGetItemsDomRefs"](), this["bIsRefSeparator"])["length"]
		: Number["POSITIVE_INFINITY"]
	);
	/** @type {Array.<HTMLTableRowElement>} */
	var aVisibleItemsChildRefs = aAllVisibleItemsChildRefs["slice"](
		0,
		iDisplayItemCount
	);
	/** @type {number} */
	var i;

	for (i = aVisibleItemsChildRefs["length"] - 1; i > -1; i--) {
		if (this["bIsRefSeparator"](aVisibleItemsChildRefs[i])) {
			aVisibleItemsChildRefs["pop"]();
		} else {
			break;
		}
	}

	return aVisibleItemsChildRefs;
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["aGetInitiallyVisibleItemsChildRefs"] = 0; };

/**
 * @param {HTMLElement} oDomRef a DOM element from #aItemsDomRef
 * @return {boolean} `true` if the item matches [name='HLine']
 */
UCF_ComboBoxListBox["prototype"]["bIsRefSeparator"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsRefSeparator"]++; }; 
	return oDomRef && oDomRef["getAttribute"]('name') === 'HLine';
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsRefSeparator"] = 0; };

/**
 * @param {HTMLElement} oDomRef an html element that could be hidden
 * @return {boolean} `true` if display:none is applied to the element, otherwise `false`
 */
UCF_ComboBoxListBox["prototype"]["bIsRefHidden"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsRefHidden"]++; }; 
	return oDomRef["style"]["display"] === 'none';
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsRefHidden"] = 0; };

/** @param {HTMLElement} oDomRef the html element to apply display:none to */
UCF_ComboBoxListBox["prototype"]["hideRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["hideRef"]++; }; 
	oDomRef["style"]["display"] = 'none';
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["hideRef"] = 0; };

/** @param {HTMLElement} oDomRef the html element to remove display:none from */
UCF_ComboBoxListBox["prototype"]["showRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["showRef"]++; }; 
	oDomRef["style"]["display"] = '';
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["showRef"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_ComboBoxListBox["prototype"]["iGetSuggestedItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetSuggestedItems"]++; }; 
	return this["iVisibleItems"];
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetSuggestedItems"] = 0; };

/** @return {number} the height in px the ComboBoxListBox would have if placed optimally */
UCF_ComboBoxListBox["prototype"]["iGetMaxAvailableHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetMaxAvailableHeight"]++; }; 
	var oViewportRect = this["oLS"]["oGetViewportObjectRect"](
		this["oOpenerRef"],
		this["oLS"]["oGetVisualViewport"](UCF_LayeredControl["MIN_BORDER_DISTANCE"])
	);

	return Math["max"](oViewportRect["bottom"], oViewportRect["top"]);
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetMaxAvailableHeight"] = 0; };

/** @return {number} the number of items that can be visible if the ComboBoxListBox is placed optimally */
UCF_ComboBoxListBox["prototype"]["iGetItemCountForOptimalPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetItemCountForOptimalPosition"]++; }; 
	return Math["abs"](Math["floor"]((this["iGetMaxAvailableHeight"]() - UCF_LayeredControl["MIN_BORDER_DISTANCE"]) / this["iItemHeight"]));
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetItemCountForOptimalPosition"] = 0; };

/** @param {Array.<HTMLElement>} aItemRefs a list of items to have their outerText traced  */
UCF_ComboBoxListBox["prototype"]["traceItems"] = function(aItemRefs) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["traceItems"]++; }; 
	UCF_JsUtil["forEach"](aItemRefs, function(oItemRef) {
		/* @type {string} */
		var sName = oItemRef["getAttribute"]('outerText');

		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, sName ? '<' + sName + '>' : '----------------', "ComboBoxListBox.js(1189): traceItems"); };
	});
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["traceItems"] = 0; };

/**
 * Sets the width of the ComboBoxListBox
 *
 * @param {number} _iWidth width of the listbox in pixel
 * @private
 */
UCF_ComboBoxListBox["prototype"]["applyWidth"] = function(_iWidth) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyWidth"]++; }; 
	/** @type {number} */
	var iWidth = parseInt(_iWidth);

	if (this["oTableData"]) {
		this["applyWidthTableDataMode"](iWidth);
	} else if (iWidth && iWidth > 0 && this["oDomRef"]) {
		this["applyWidthControlsMode"](iWidth);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyWidth"] = 0; };

/**
 * @private
 * @param {number} iWidth the width in px
 */
UCF_ComboBoxListBox["prototype"]["applyWidthTableDataMode"] = function(iWidth) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyWidthTableDataMode"]++; }; 
	/** @type {HTMLDivElement} */
	var oScrollRef = UCF_DomUtil["$"](this["sId"] + '-scrl');

	// maxWidth = window-width - 2 x min. border distance in combination with the
	// "safetyDistance" (which is the min distance from the right...) guarantees
	// that the list box is not wider than the screen plus a nice centering.
	var iMaxWidth = (
		UCF_UserAgent["bIsIOS"]()
		? (window["matchMedia"]('(orientation: landscape)')["matches"]
			? screen["height"]
			: screen["width"]
		)
		: (window["innerWidth"] || window["document"]["body"]["clientWidth"]) // IE-Quirks!
	) - 2 * UCF_LayeredControl["MIN_BORDER_DISTANCE"];

	this["setSafetyDistance"](UCF_LayeredControl["MIN_BORDER_DISTANCE"]);

	UCF_DomUtil["setStyle"](this["oDomRef"], { "width": '' });
	UCF_DomUtil["setStyle"](
		oScrollRef, {
			"minWidth": Math["max"](
				iWidth,
				Math["min"](
					this["iGetHeadlineWidth"](oScrollRef),
					iMaxWidth
				)
			) + 'px',
			"width": (
					this["oTableData"]["historyItems"]["length"] +
					this["oTableData"]["items"]["length"] > 0
				)
				? this["oTableData"]["sCssTotalWidth"]
				: 0,
			"maxWidth": iMaxWidth + 'px'
		}
	);

};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyWidthTableDataMode"] = 0; };

/**
 * @private
 * @param {HTMLDivElement} oScrollRef the $Id-scrl element
 * @return {number}
 */
UCF_ComboBoxListBox["prototype"]["iGetHeadlineWidth"] = function(oScrollRef) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetHeadlineWidth"]++; }; 
	/** @type {HTMLTableRowElement} */
	var oHeadlineRef;
	/** @type {HTMLTableDataCellElement} */
	var oHeadlineTdRef;

	if (typeof this["iHeadlineWidth"] !== 'number') {
		oHeadlineRef = UCF_DomUtil["$"](this["sId"] + '-headline');

		if (oHeadlineRef) {
			if (!oScrollRef) {
				oScrollRef = UCF_DomUtil["$"](this["sId"] + '-scrl');
			}
			oHeadlineTdRef = UCF_DomUtil["oGetFirstChild"](oHeadlineRef);

			UCF_DomUtil["setStyle"](oScrollRef, { "width": 0 });

			this["iHeadlineWidth"] = oHeadlineTdRef["scrollWidth"] +
				(parseInt(UCF_DomUtil["sGetCurrentStyle"](
					oHeadlineTdRef,
					window["UCF_System"]["bIsRTL"] ? 'paddingLeft' : 'paddingRight'
				)) || 0) +
				UCF_DomUtil["iGetScrollbarWidth"]();
		} else {
			this["iHeadlineWidth"] = 0;
		}
	}

	return this["iHeadlineWidth"];
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetHeadlineWidth"] = 0; };

/**
 * @private
 * @param {number} iWidth the width in px
 */
UCF_ComboBoxListBox["prototype"]["applyWidthControlsMode"] = function(iWidth) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyWidthControlsMode"]++; }; 
	/** @type {UCF_ComboBoxListBox} */
	var self = this;
	/** @type {number} */
	var iScrollbarWidth = UCF_DomUtil["iGetScrollbarWidth"]();
	// if display:none on oRootRef, oDomRef will not have an offsetWidth
	// => set to display:block, reset after calculations
	/** @type {string} */
	var sRootRefCssDisplay = this["oRootRef"]["style"]["display"];

	this["oRootRef"]["style"]["display"] = 'block';

	// remove width set in previous applyWidth() call
	this["oDomRef"]["style"]["width"] = '';

	iWidth = Math["max"](
		iWidth,
		UCF_JsUtil["contains"](['scroll', 'auto'], this["oScrollRef"]["style"]["overflowY"])
		? this["iMinWidth"] + iScrollbarWidth
		: 0,
		Math["max"](this["iGetMinimumItemWidth"](), this["oDomRef"]["offsetWidth"]) + iScrollbarWidth,
		UCF_JsUtil["reduce"](this["aGetActionItemDomRefs"](), function(iMax, oActionItem) {
			/** @type {UCF_Rectangle} */
			var oRect = self["oGetObjectRect"](oActionItem);

			return (oRect && oRect["width"]) ? Math["max"](iMax, oRect["width"]) : iMax;
		}, 0) + iScrollbarWidth,
		this["iMinWidth"] + iScrollbarWidth
	);

	this["oRootRef"]["style"]["display"] = sRootRefCssDisplay;

	this["oScrollRef"]["style"]["overflowX"] = 'hidden';
	this["oDomRef"]["style"]["width"] = iWidth + 'px';
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["applyWidthControlsMode"] = 0; };

/**
 * @return {number} sum of the offsetWidths of all `<td>`s in the first `<tr>` of #oTableRef
 */
UCF_ComboBoxListBox["prototype"]["iGetMinimumItemWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetMinimumItemWidth"]++; }; 
	/** @type {string} */
	var sRootRefCssDisplay;
	/** @type {string} */
	var sDomRefCssWidth;
	/** @type {string} */
	var sScrollRefCssWidth;
	/** @type {string} */
	var sTableRefCssWidth;
	/** @type {number} */
	var iResult = 0;

	// if display:none on oRootRef, the <tr> won't have an offsetWidth
	// => set to display:block, reset later
	sRootRefCssDisplay = this["oRootRef"]["style"]["display"];
	this["oRootRef"]["style"]["display"] = 'block';

	// need to make sure <tr>'s offsetWidth is actually right
	// => make enough room (i.e. width:99999px on oDomRef)
	// and fit children into it with width:auto, reset later
	sDomRefCssWidth = this["oDomRef"]["style"]["width"];
	this["oDomRef"]["style"]["width"] = '99999px';

	sScrollRefCssWidth = this["oScrollRef"]["style"]["width"];
	this["oScrollRef"]["style"]["width"] = 'auto';

	sTableRefCssWidth = this["oTableRef"]["style"]["width"];
	this["oTableRef"]["style"]["width"] = 'auto';

	iResult = this["oTableRef"]["getElementsByTagName"]('TR')[0]["offsetWidth"];

	// reset temporarily changed css
	this["oTableRef"]["style"]["width"] = sTableRefCssWidth;
	this["oScrollRef"]["style"]["width"] = sScrollRefCssWidth;
	this["oDomRef"]["style"]["width"] = sDomRefCssWidth;
	this["oRootRef"]["style"]["display"] = sRootRefCssDisplay;

	return iResult;
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetMinimumItemWidth"] = 0; };

/**
 * Handles the up arrow key
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ComboBoxListBox["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlsup"]++; }; 
	this["forwardToEventDefaultHandlerAndCancel"](oBrowserEvent, 'onlsup');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlsup"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event to forward
 * @param {string} sHandler the name of the handler function in this.oEventDefaultHandler (e.g. 'onlsup')
 */
UCF_ComboBoxListBox["prototype"]["forwardToEventDefaultHandlerAndCancel"] = function(oBrowserEvent, sHandler) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["forwardToEventDefaultHandlerAndCancel"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBoxListBox.js(1388): forwardToEventDefaultHandlerAndCancel"); };

	if (this["oEventDefaultHandler"]) {
		this["oEventDefaultHandler"][sHandler](oBrowserEvent);
	}

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["forwardToEventDefaultHandlerAndCancel"] = 0; };

/**
 * Handles the down arrow key
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ComboBoxListBox["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlsdown"]++; }; 
	this["forwardToEventDefaultHandlerAndCancel"](oBrowserEvent, 'onlsdown');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlsdown"] = 0; };

/**
 * Handles the home key
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ComboBoxListBox["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlshome"]++; }; 
	this["forwardToEventDefaultHandlerAndCancel"](oBrowserEvent, 'onlshome');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlshome"] = 0; };

/**
 * Handles the pageup key
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ComboBoxListBox["prototype"]["onlspageup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlspageup"]++; }; 
	this["forwardToEventDefaultHandlerAndCancel"](oBrowserEvent, 'onlspageup');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlspageup"] = 0; };

/**
 * Handles the page down key
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ComboBoxListBox["prototype"]["onlspagedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlspagedown"]++; }; 
	this["forwardToEventDefaultHandlerAndCancel"](oBrowserEvent, 'onlspagedown');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlspagedown"] = 0; };

/**
 * Handles the end key
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ComboBoxListBox["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlsend"]++; }; 
	this["forwardToEventDefaultHandlerAndCancel"](oBrowserEvent, 'onlsend');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlsend"] = 0; };

/**
 * Handles the enter key
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ComboBoxListBox["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlsenter"]++; }; 
	this["forwardToEventDefaultHandlerAndCancel"](oBrowserEvent, 'onlsenter');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["onlsenter"] = 0; };

/**
 * Set the default event handler
 *
 * @param {UCF_Object} oEventSource object handling the event
 * @private
 */
UCF_ComboBoxListBox["prototype"]["setEventDefaultHandler"] = function(oEventSource) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["setEventDefaultHandler"]++; }; 
	this["oEventDefaultHandler"] = oEventSource;
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["setEventDefaultHandler"] = 0; };

/**
 * Select a possible item from given browser event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent browser event
 * @private
 */
UCF_ComboBoxListBox["prototype"]["selectItemFromBrowserEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["selectItemFromBrowserEvent"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ComboBoxListBox.js(1478): selectItemFromBrowserEvent"); };

	oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);

	if (this["oSelectedItem"]) {
		this["oSelectedItem"]["select"](false);
	}
	if (!UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem')) {
		return;
	}
	oItem["select"](true);
	this["oSelectedItem"] = oItem;
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["selectItemFromBrowserEvent"] = 0; };

/**
 * Reads the given string as JSON and returns the result array
 * This is only used with multi column items in the list
 *
 * @private
 * @param {string} sData the string of the JSON array data for multi column lists
 * @return {Object} sData parsed to a JS object
 */
UCF_ComboBoxListBox["prototype"]["getJSONTableData"] = function(sData) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["getJSONTableData"]++; }; 
	/** @type {Object} */
	var oData;

	try {
		oData = UCF_JsUtil["oJsonParse"](sData);
	} catch (ignored) {
		// CSN 2080043553: Strings with unicode RTL content (e.g. Hebrew) that
		// use the unicode-bidi algorithm to be displayed from right to left.
		// The ITS creates suggest lists on the client (ComboBoxListBox directly)
		// and in RTL languages, the TableData is possibly rendered with
		// unicode-bidi, and it may contain encoded double-quotes (this is where
		// the problem occurs). Now during creation -> rendering
		// (via UCF_ComboBoxListBoxRenderer#render()) -> control creation, the
		// unicode-bidi information is lost and "\ (which was a bidi-swapped \")
		// now terminates the string. With that, JSON.parse(sData) and eval(sData)
		// throw an exception, because the JSON-array is terminated early. The old
		// behavior was to ignore this exception, and we have to preserve that.
	}

	if (!oData || !UCF_JsUtil["bIsArray"](oData)) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'No valid TableData', "ComboBoxListBox.js(1521): getJSONTableData"); };

		return null;
	} else {
		return oData;
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["getJSONTableData"] = 0; };

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBoxListBox["bFiori"] = undefined;

/**
 * Returns whether the used theme is a Fiori theme or not
 * @private
 * @static
 * @return {boolean} Fiori?
 */
UCF_ComboBoxListBox["bIsFiori"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsFiori"]++; }; 
	/** @type {{Tags: Array<string>}} */
	var oCssMetaData;

	if (typeof UCF_ComboBoxListBox["bFiori"] === 'undefined') {
		oCssMetaData = UCF_ResourceUtil["oExtractCssMetaData"]();

		UCF_ComboBoxListBox["bFiori"] = oCssMetaData
			&& oCssMetaData["Tags"]
			&& UCF_JsUtil["some"](
				oCssMetaData["Tags"],
				function(sTag) { return sTag === 'Fiori_2' || sTag === 'Fiori_3'; }
			);
	}

	return UCF_ComboBoxListBox["bFiori"];
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bIsFiori"] = 0; };

/**
 * Renders the table data to the this.sId + '-tab' dom ref
 *  @private
 */
UCF_ComboBoxListBox["prototype"]["renderTableData"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderTableData"]++; }; 
	/** @type {Object} */
	var oRenderManager;
	/** @type {Object} */
	var oColumn;
	/** @type {number} */
	var i;
	/** @type {Object} */
	var sHtmlDiv;

	this["calculateTableMetaData"]();

	oRenderManager = this["oLS"]["oGetRenderManager"]();
	oRenderManager["write"]('<table tabindex="1" id="' + this["sId"] + '-tab" class="lsItemlistbox__list" style="table-layout: fixed">');
	for (i = 0; i < this["oTableData"]["definition"]["length"]; i++) {
		oColumn = this["oTableData"]["definition"][i];
		if (oColumn["Visibility"] === 'NONE') {
			continue;
		}
		oRenderManager["write"]('<col class="lsItemlistbox__col" style="width:' + oColumn["sWidth"] + '" />');
	}
	if (this["oTableData"]["historyItems"]["length"] > 0) {
		oRenderManager["write"]('<col class="lsItemlistbox__col lsItemlistbox__col--delete"/>');
	}
	this["renderTableRows"](this["oTableData"]["historyItems"], oRenderManager, true, this["oTableData"]["historyItems"]["length"] > 0); //history items
	if (this["oTableData"]["items"]["length"] > 0) {
		// var sTableHeaderTD = this.renderTableHeader(this.oTableData.historyItems.length > 0);
		oRenderManager["write"]('<tr id="' + this["sId"] + '-headline" class="lsItemlistbox__item lsItemlistbox__item--headline">'); //headline "Search Results"
		oRenderManager["write"]('<td class="lsItemlistbox__content" colspan="' + this["oTableData"]["iColspan"] + '">' + this["oTableData"]["sTextHeadline"] + '</td>');
		oRenderManager["write"]('</tr>');
		oRenderManager["write"](this["renderTableHeader"](this["oTableData"]["historyItems"]["length"] > 0)); //tableheader
		this["renderTableRows"](this["oTableData"]["items"], oRenderManager, false, this["oTableData"]["historyItems"]["length"] > 0); //items
	}
	oRenderManager["write"]('</table>');

	sHtmlDiv = document["createElement"]('DIV');
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](sHtmlDiv, oRenderManager["getHTMLString"]());
	UCF_DomUtil["$"](this["sId"] + '-scrl')["replaceChild"](sHtmlDiv["firstChild"], UCF_DomUtil["$"](this["sId"] + '-tab'));
	oRenderManager["clearBuffer"]();

	this["renderNoResults"](oRenderManager);

	if (this["oTableData"]["items"]["length"] > 0) {
		this["oTableData"]["iItemHeight"] = UCF_DomUtil["$"](this["sId"] + '_item0')["offsetHeight"];
		this["oTableData"]["iHeaderHeight"] = UCF_DomUtil["$"](this["sId"] + '-header')["offsetHeight"];
		this["oTableData"]["iHeadlineHeight"] = UCF_DomUtil["$"](this["sId"] + '-headline')["offsetHeight"];
	} else if (this["oTableData"]["historyItems"]["length"] > 0) {
		this["oTableData"]["iItemHeight"] = UCF_DomUtil["$"](this["sId"] + '_hItem0')["offsetHeight"];
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderTableData"] = 0; };

/**
 * Calculates all relevant metadata (like colspan, visible colums, key column, value column, item height, header height, headline height) to render and display the suggest list.
 * All meta data is encapsulated in the object this.oTableData
 *  @private
 */
UCF_ComboBoxListBox["prototype"]["calculateTableMetaData"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["calculateTableMetaData"]++; }; 
	/** @type {number} */
	var iTotalLength = 0;
	/** @type {UCF_ComboBoxListBox_Column} */
	var oColumn;
	/** @type {number} */
	var i;

	this["oTableData"] = {
		"definition": this["getJSONTableData"](this["sTableDataDefinition"] || '[]') || [],
		"items": this["getJSONTableData"](this["sItemTableData"] || '[]') || [],
		"historyItems": this["getJSONTableData"](this["sHistoryTableData"] || '[]') || [],
		"iItemHeight": 0,
		"iHeaderHeight": 0,
		"iHeadlineHeight": 0
	};

	if (this["oTableData"]["definition"]["length"] === 0) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'TableDataDefinition Empty', "ComboBoxListBox.js(1638): calculateTableMetaData"); };
	}

	this["oTableData"]["bHistoryOnly"] = this["sItemTableData"] ? false : true;
	this["oTableData"]["iKeyColumn"] = -1;
	this["oTableData"]["iValueColumn"] = -1;
	for (i = 0; i < this["oTableData"]["definition"]["length"]; i++) {
		oColumn = this["oTableData"]["definition"][i];
		if (oColumn["Type"] === 'Key') {
			this["oTableData"]["iKeyColumn"] = i;
		}
		if (oColumn["Type"] === 'Value') {
			this["oTableData"]["iValueColumn"] = i;
		}
		if (oColumn["Visibility"] === 'NONE') {
			continue;
		}
		if (!oColumn["Length"]) {
			oColumn["Length"] = 10;
		}
		if (oColumn["Length"] < UCF_ComboBoxListBox["MIN_COL_WIDTH"]) {
			oColumn["Length"] = UCF_ComboBoxListBox["MIN_COL_WIDTH"];
		}
		if (oColumn["Length"] > UCF_ComboBoxListBox["MAX_COL_WIDTH"]) {
			oColumn["Length"] = UCF_ComboBoxListBox["MAX_COL_WIDTH"];
		}
		if (oColumn["Type"] === 'Value') {
			oColumn["Length"] += Math["round"](oColumn["Length"] * UCF_ComboBoxListBox["COL_VALUE_LENGTH_CHAR_RATIO"]);
		}

		if (typeof oColumn["Length"] === 'number') {
			iTotalLength += oColumn["Length"];
		}
	}
	this["oTableData"]["sCssTotalWidth"] = Math["round"](iTotalLength * UCF_ComboBoxListBox["COL_CHAR_EM_RATIO"]) + 'em';

	this["oTableData"]["iColspan"] = 0;
	for (i = 0; i < this["oTableData"]["definition"]["length"]; i++) {
		oColumn = this["oTableData"]["definition"][i];
		if (oColumn["Visibility"] === 'NONE') {
			continue;
		}
		// eslint-disable-next-line no-magic-numbers
		oColumn["sWidth"] = (oColumn["Length"] / iTotalLength * 100) + '%';
		++this["oTableData"]["iColspan"];
	}
	if (this["oTableData"]["historyItems"]["length"] > 0) {
		++this["oTableData"]["iColspan"];
	}

	if (this["oTableData"]["iKeyColumn"] === -1) {
		this["oTableData"]["iKeyColumn"] = 0;
	}
	if (this["oTableData"]["iValueColumn"] === -1) {
		this["oTableData"]["iValueColumn"] = this["oTableData"]["iKeyColumn"];
	}

	// calculate number of visible cols
	this["oTableData"]["iVisibleCols"] = this["oTableData"]["definition"]["length"];
	for (i = 0; i < this["oTableData"]["definition"]["length"]; i++) {
		if (this["oTableData"]["definition"][i]["Visibility"] === 'NONE') {
			this["oTableData"]["iVisibleCols"]--;
			continue;
		}
	}

	// text for "Search Results" in suggest list
	this["oTableData"]["sTextHeadline"] = this["oLS"]["sGetText"](
		'SAPUR_IL_SUGGEST_HEADLINE'
	) || 'Search Results';
	// text for no results in suggest list
	this["oTableData"]["sTextNoResults"] = this["oLS"]["sGetText"](
		'SAPUR_IL_SUGGEST_NORESULTS'
	) || 'We did not find any matches for "{0}"';
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["calculateTableMetaData"] = 0; };

/** @private */
UCF_ComboBoxListBox["prototype"]["renderNoResults"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderNoResults"]++; }; 
	/** @type {UCF_RenderManager} */
	var oRenderManager = new (UCF_ClassLoader["oGetClass"]("UCF_RenderManager"))(this["oLS"]);
	/** @type {UCF_ComboBoxListBoxRender} */
	var oItemListBoxRenderer = oRenderManager["getRenderer"]('ItemListBox');
	/** @type {HTMLDivElement} */
	var oDiv;
	/** @type {HTMLTableDataCellElement} */
	var oTd;

	oRenderManager["write"]('<table tabindex="1" id="' + this["sId"] + '-nrtab" class="lsItemlistbox__list" role="list" style="display:none"><tbody>');
	oRenderManager["write"]('<tr id="' + this["sId"] + '_nrItem" role="option" class="lsItemlistbox__item lsItemlistbox__item--noresult">');
	oItemListBoxRenderer["renderItemListBoxItemCellFragment"]({
		"Events": null,
		"IconSrc": '',
		"DisabledIconSrc": '',
		"Tooltip": '',
		"Value": '',
		"Enabled": true,
		"Readonly": true,
		"ColumnVisibility": '',
		"IsBeforeSeparator": false,
		"IsAfterSeparator": false,
		"TextDirection": 'INHERIT',
		"Align": 'BEGINOFLINE',
		"SemanticColor": 'STANDARD',
		"Design": 'STANDARD',
		"Classes": '',
		"Id": this["sId"] + '_nrItem',
		"Selected": false,
		"CurrentIndex": 1,
		"SetSize": 1,
		"TextOverflow": false,
		"ColSpan": 1
	}, oRenderManager);
	oItemListBoxRenderer["renderItemListBoxItemCellFragment"]({
		"Events": null,
		"IconSrc": '',
		"DisabledIconSrc": '',
		"Tooltip": '',
		"Value": this["oTableData"]["sTextNoResults"],
		"Enabled": true,
		"Readonly": true,
		"ColumnVisibility": '',
		"IsBeforeSeparator": false,
		"IsAfterSeparator": false,
		"TextDirection": 'INHERIT',
		"Align": 'BEGINOFLINE',
		"SemanticColor": 'STANDARD',
		"Design": 'STANDARD',
		"Classes": '',
		"Id": this["sId"] + '_nrItem',
		"Selected": false,
		"CurrentIndex": 1,
		"SetSize": 1,
		"TextOverflow": false,
		"ColSpan": 1
	}, oRenderManager);
	oRenderManager["write"]('</tr>');
	oRenderManager["write"]('</tbody></table>');

	oDiv = document["createElement"]('DIV');

	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oDiv, oRenderManager["getHTMLString"]()["replace"](
		/(\{0\}|_NEVER_TRANSLATE_THIS_)/,
		'<span id="' + this["sId"] +
		'-fltr" class="lsItemlistbox__content--highlighted"></span>'
	));

	oTd = oDiv["getElementsByTagName"]('TD')[0];
	UCF_DomUtil["addClass"](oTd, 'lsItemlistbox__icon--noresult');

	UCF_DomUtil["$"](this["sId"])["appendChild"](oDiv["firstChild"]);

	this["oCache"]["invalidate"]('aGetActionItemDomRefs');
	this["oCache"]["invalidate"]('aGetActionItems');

	oRenderManager["clearBuffer"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderNoResults"] = 0; };

/**
 * @private
 * @param {string} sFilter the text the $Id-fltr element should have
 * @return {boolean} `true` if no results row was shown, otherwise `false`
 */
UCF_ComboBoxListBox["prototype"]["bShowNoResults"] = function(sFilter) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bShowNoResults"]++; }; 
	/** @type {HTMLElement} the itemlistbox container */
	var oScrollRef = UCF_DomUtil["$"](this["sId"] + '-scrl');
	/** @type {HTMLElement} the noresults container */
	var oNoResultsRef = UCF_DomUtil["$"](this["sId"] + '-nrtab');
	/** @type {HTMLElement} the filter container */
	var oFilterRef = UCF_DomUtil["$"](this["sId"] + '-fltr');

	if (this["bSupportsNoResults"]() && !this["oTableData"]["bHistoryOnly"]) {
		UCF_JsUtil["forEach"](
			UCF_DomUtil["$"](this["sId"])["getElementsByTagName"]('a'),
			function(oA) { UCF_DomUtil["setStyle"](oA, { "display": 'none' }); }
		);
		if (oFilterRef) { oFilterRef["textContent"] = sFilter; }
		if (oNoResultsRef) { UCF_DomUtil["setStyle"](oNoResultsRef, { "display": '' }); }
		if (oScrollRef) { UCF_DomUtil["setStyle"](oScrollRef, { "display": 'none' }); }

		return true;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bShowNoResults"] = 0; };

/** @private */
UCF_ComboBoxListBox["prototype"]["hideNoResults"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["hideNoResults"]++; }; 
	/** @type {HTMLElement} the itemlistbox container */
	var oScrollRef = UCF_DomUtil["$"](this["sId"] + '-scrl');
	/** @type {HTMLElement} the noresults container */
	var oNoResultsRef = UCF_DomUtil["$"](this["sId"] + '-nrtab');

	if (this["bSupportsNoResults"]()) {
		UCF_JsUtil["forEach"](
			UCF_DomUtil["$"](this["sId"])["getElementsByTagName"]('a'),
			function(obj) {
				obj["style"]["display"] = '';
			}
		);
		if (oScrollRef) { oScrollRef["style"]["display"] = 'none'; }
		if (oNoResultsRef) { UCF_DomUtil["$"](this["sId"] + '-scrl')["style"]["display"] = ''; }
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["hideNoResults"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_ComboBoxListBox["prototype"]["bSupportsNoResults"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bSupportsNoResults"]++; }; 
	return this["oTableData"] && UCF_ComboBoxListBox["bIsFiori"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bSupportsNoResults"] = 0; };

/**
 * Renders the table header data to the given render manager
 *
 * @private
 * @param {boolean} bHistoryItemsAvailable - will render history items if `true`
 * @return {Array.<HTMLTableDataElement>} the table header
 */
UCF_ComboBoxListBox["prototype"]["renderTableHeader"] = function(bHistoryItemsAvailable) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderTableHeader"]++; }; 
	/** @type {Array.<UCF_ComboBoxListBox_Column>} */
	var aDefinitions = this["oTableData"]["definition"];
	/** @type {Array.<UCF_ComboBoxListBox_Column> */
	var aRenderHeader = [];
	/** @type {number} */
	var i;
	/** @type {Array.<HTMLTableDataCellElement>} */
	var aTd = [];

	for (i = 0; i < aDefinitions["length"]; i++) {
		if (aDefinitions[i]["Visibility"] === 'NONE') {
			continue;
		}
		aRenderHeader["push"](aDefinitions[i]);
	}

	aTd["push"]('<tr ' +
		'id="' + this["sId"] + '-header" ' +
		'class="lsItemlistbox__item lsItemlistbox__item--header">');
	for (i = 0; i < aRenderHeader["length"]; i++) {
		if (!bHistoryItemsAvailable && i === aRenderHeader["length"] - 1) {
			aTd["push"]('<th ' +
				'class="urIlb2IHdCell lsItemlistbox__content" ' +
				'style="box-sizing:border-box;border-right-style:none" ' +
				'title="' + aRenderHeader[i]["Label"] + '">' +
				aRenderHeader[i]["Label"] +
				'</td>');
		} else {
			aTd["push"]('<th ' +
				'class="urIlb2IHdCell lsItemlistbox__content" ' +
				'style="box-sizing:border-box" ' +
				'title="' + aRenderHeader[i]["Label"] + '">' +
				aRenderHeader[i]["Label"] +
				'</td>'
			);
		}
	}
	if (bHistoryItemsAvailable) {
		aTd["push"]('<th ' +
			'id="' + this["sId"] + '-thscrl" ' +
			'class="urIlb2IHdCell lsItemlistbox__content" ' +
			'style="' +
			'width:16px;' +
			'box-sizing:border-box;' +
			'border:none;' +
			'padding:6px;' +
			'text-overflow:ellipsis;' +
			'overflow:hidden;">' +
			'</td>'
		);
		// ++this.oTableData.iColspan;
	}
	aTd["push"]('</tr>');

	return aTd["join"]('');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderTableHeader"] = 0; };

/**
 * Renders the table rows data to the given render manager
 * @param {Array.JSON} aRows content
 * @param {UCF_RenderManager} oRenderManager the render manager
 * @param {boolean} bHistory will render history items if `true`, otherwise items
 * @param {boolean} bHistoryItemsAvailable will render delete icons for the items if `true`
 *
 * @private
 */
UCF_ComboBoxListBox["prototype"]["renderTableRows"] = function(aRows, oRenderManager, bHistory, bHistoryItemsAvailable) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderTableRows"]++; };  // eslint-disable-line complexity
	/** @type {Array<UCF_ComboBoxListBox_Column>} */
	var aDefinitions;
	/** @type {UCF_ItemListBoxRender} */
	var oRenderer;
	/** @type {number} */
	var iKeyColumn;
	/** @type {number} */
	var iValueColumn;
	/** @type {number} */
	var j;

	if (aRows && aRows["length"] > 0) {
		aDefinitions = this["oTableData"]["definition"];
		oRenderer = oRenderManager["getRenderer"]('ItemListBox');
		iKeyColumn = this["oTableData"]["iKeyColumn"];
		iValueColumn = this["oTableData"]["iValueColumn"];

		// texts for ARIA
		this["sDeletable"] = this["oLS"]["sGetText"]('SAPUR_TOKEN_DELETABLE') || 'Deletable'; // "Deletable"
		this["sHistoryItem"] = this["oLS"]["sGetText"]('SAPUR_CB_HI_TUT') || 'History Item'; // "History Item"
		this["sSuggestItem"] = this["oLS"]["sGetText"]('SAPUR_CB_SUGGEST_TUT') || 'Search Result Item'; // "Search Result Item"

		for (j = 0; j < aRows["length"]; j++) {
			this["renderTableRow"](
				oRenderManager,
				oRenderer,
				bHistory,
				bHistoryItemsAvailable,
				iKeyColumn,
				iValueColumn,
				aDefinitions,
				aRows[j],
				j
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderTableRows"] = 0; };

/**
 * @private
 * @param {string|Object} oColumn the column
 * @return {string}
 */
UCF_ComboBoxListBox["sGetKeyFromColumn"] = function(oColumn) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["sGetKeyFromColumn"]++; }; 
	if (typeof oColumn === 'string') {
		return oColumn;
	} else if (oColumn) {
		return oColumn["Key"] || oColumn["Value"] || '';
	} else {
		return '';
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["sGetKeyFromColumn"] = 0; };

/**
 * @private
 * @param {string|Object} oColumn the column
 * @return {string}
 */
UCF_ComboBoxListBox["sGetValueFromColumn"] = function(oColumn) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["sGetValueFromColumn"]++; }; 
	if (typeof oColumn === 'string') {
		return oColumn;
	} else if (oColumn && oColumn["Value"]) {
		return oColumn["Value"];
	} else {
		return UCF_ComboBoxListBox["sGetKeyFromColumn"](oColumn);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["sGetValueFromColumn"] = 0; };

/**
 * @private
 * @param {UCF_RenderManager} oRenderManager the render manager
 * @param {UCF_ComboBoxListBoxRenderer} oRenderer the renderer
 * @param {boolean} bHistory `true` if the delete column is rendered
 * @param {boolean} bHistoryItemsAvailable `true` if there are history items
 * @param {number} iKeyColumn the index of the column that contains the key
 * @param {number} iValueColumn the index of the column that contains the value
 * @param {Array<UCF_ComboBoxListBox_Column>} aDefinitions the columns
 * @param {Object} oRow the row
 * @param {number} j the row index
 */
UCF_ComboBoxListBox["prototype"]["renderTableRow"] = function(oRenderManager, oRenderer, bHistory, bHistoryItemsAvailable, iKeyColumn, iValueColumn, aDefinitions, oRow, j) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderTableRow"]++; }; 
	/** @type {UCF_ComboBoxListBox_Column} */
	var oColumn;
	/** @type {string} */
	var sItemId = this["sId"] + (bHistory ? '_hItem' : '_item') + j;
	/** @type {UCF_ComboBoxListBox_ItemData} */
	var oItemData;
	/** @type {number} */
	var iColVisible;
	/** @type {number} */
	var i;
	/** @type {boolean} */
	var bHighlights = false;
	/** @type {Array<number>} */
	var aStartIndices;
	/** @type {Array<number>} */
	var aEndIndices;
	/** @type {string} */
	var sNewHtml;
	/** @type {UCF_RenderManager} */
	var oTmpRenderManager;
	/** @type {{oItemData: UCF_ComboBoxListBox_ItemData, bHighlights: boolean}} */
	var oItemDataResult;

	oRenderManager["write"]('<tr ' +
		'ct="ILBI" ' +
		// TODO change when clientaccess properties in interface change
		'lsdata=\'{"3":' + bHistory + '}\' ' +
		'data-value="' + oRenderManager["sGetEscaped"](UCF_ComboBoxListBox["sGetValueFromColumn"](oRow[iValueColumn])) + '"' +
		'data-itemkey="' + oRenderManager["sGetEscaped"](UCF_ComboBoxListBox["sGetKeyFromColumn"](oRow[iKeyColumn])) + '"' +
		'role="option" ' +
		'aria-label="' + this["getAriaLabel"](aDefinitions, oRow, bHistory) + '" ' +
		'id="' + sItemId + '" ' +
		'history="' + bHistory + '" ' +
		'class="lsItemlistbox__item' +
		(bHistory
			? ' lsItemlistbox__item--history'
			: ' lsItemlistbox__item--suggest') +
		'">');

	iColVisible = 0;
	for (i = 0; i < aDefinitions["length"]; i++) {
		oColumn = aDefinitions[i];
		if (oColumn["Visibility"] === 'NONE') {
			iColVisible++;
		} else {
			// default item data for UCF_ItemListBoxRenderer.renderItemListBoxItemCellFragment
			oItemDataResult = this["oGetItemDataForCell"](oColumn, oRow[i], bHistory);
			oItemData = oItemDataResult["oItemData"];
			bHighlights = oItemDataResult["bHighlights"];

			if (bHighlights) {
				// "ABCD", [[0,2],[4,5]] ==> "<span>AB</span>C<span>D</span>
				aStartIndices = UCF_JsUtil["map"](
					oRow[i]["Highlights"],
					function(h) { return h[0]; }
				);
				aEndIndices = UCF_JsUtil["map"](
					oRow[i]["Highlights"],
					function(h) { return h[1] - 1; }
				);
				sNewHtml = UCF_JsUtil["reduce"](
					oRow[i]["Value"]["split"](''),
					function(sHtml, char, i) {
						/** @type {string} */
						var sValue = sHtml;

						if (UCF_JsUtil["contains"](aStartIndices, i)) {
							sValue = sValue + '<span class="lsItemlistbox__content--highlighted">';
						}
						sValue = sValue + char;
						if (UCF_JsUtil["contains"](aEndIndices, i)) {
							sValue = sValue + '</span>';
						}

						return sValue;
					},
					''
				);

				oTmpRenderManager = new (UCF_ClassLoader["oGetClass"]("UCF_RenderManager"))(this["oLS"]);
				if (typeof oRow[i + 1] === 'undefined') {
					oItemData["ColSpan"] = this["oTableData"]["iVisibleCols"] - i + iColVisible;
					i = aDefinitions["length"]; // set loop control variable stop criterion
				}
				oRenderer["renderItemListBoxItemCellFragment"](oItemData, oTmpRenderManager);
				oRenderManager["write"](oTmpRenderManager["getHTMLString"]()["replace"](/(<.+>).*(<.+>)/, '$1' + sNewHtml + '$2'));
			} else {
				if (typeof oRow[i + 1] === 'undefined') {
					oItemData["ColSpan"] = this["oTableData"]["iVisibleCols"] - i + iColVisible;
					i = aDefinitions["length"]; // set loop control variable stop criterion
				}
				oRenderer["renderItemListBoxItemCellFragment"](oItemData, oRenderManager);
			}
		}
	}
	if (bHistoryItemsAvailable) {
		UCF_ComboBoxListBox["renderDeleteColumn"](oRenderManager, sItemId, bHistory);
	}
	oRenderManager["write"]('</tr>');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderTableRow"] = 0; };

/**
 * @private
 * @param {Object} oColumn the column
 * @param {string|Object} oData the cell data
 * @param {boolean} bHistory `true` if there are history items
 * @return {{oItemData: UCF_ComboBoxListBox_ItemData, bHighlights: boolean}}
 */
UCF_ComboBoxListBox["prototype"]["oGetItemDataForCell"] = function(oColumn, oData, bHistory) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["oGetItemDataForCell"]++; }; 
	/** @type {UCF_ComboBoxListBox_ItemData} */
	var oItemData = {
		"Events": null,
		"IconSrc": '',
		"DisabledIconSrc": '',
		"Tooltip": oColumn["Label"] || '',
		"Value": '',
		"Enabled": true,
		"Readonly": false,
		"ColumnVisibility": 'VISIBLE',
		"IsBeforeSeparator": bHistory,
		"IsAfterSeparator": !bHistory,
		"TextDirection": oColumn["TextDirection"] || 'INHERIT',
		"Align": oColumn["Align"] || 'LEFT',
		"SemanticColor": 'INHERIT',
		"Design": this["sTableDataItemDesign"],
		"Classes": '',
		"Id": '',
		"Selected": false,
		"CurrentIndex": 0,
		"SetSize": 0,
		"TextOverflow": true,
		"ColSpan": 1
	};
	/** @type {string} */
	var n;
	/** @type {boolean} */
	var bHighlights;

	if (typeof oData === 'string') {
		UCF_JsUtil["extend"](
			oItemData,
			UCF_ComboBoxListBox["oGetItemDataPartFromString"](oColumn, oData)
		);
	} else {
		for (n in oData) {
			if (n === 'Value' && oColumn["Type"] === 'Icon') {
				if (!('IconSrc' in oData)) {
					oItemData["IconSrc"] = oData["Value"];
				}
				if (!('DisabledIconSrc' in oData)) {
					oItemData["DisabledIconSrc"] = oData["Value"];
				}
			} else if (n === 'Value') {
				if (!('Highlight' in oData)) {
					bHighlights = UCF_ComboBoxListBox["bHasValidHighlights"](oData);
				}
				if (!('Tooltip' in oData)) {
					oItemData["Tooltip"] = oData["Value"];
				}
				oItemData["Classes"] = 'lsItemlistbox__content--value';
			}
			if (n !== 'Highlights') {
				// copy from raw data to oItemData
				oItemData[n] = oData[n] || oItemData[n];
			}
		}
		if (oColumn["Type"] === 'Icon') {
			UCF_JsUtil["extend"](oItemData, { "Value": '', "TextOverflow": false });
		}
	}

	return { "oItemData": oItemData, "bHighlights": bHighlights };
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["oGetItemDataForCell"] = 0; };

/** @typedef {{IconSrc:string,DisabledIconSrc:string}|{Value:string,Tooltip:string}} UCF_ComboBoxListBox_ItemDataPart */
/**
 * @private
 * @static
 * @param {Object} oColumn the column
 * @param {string} sData the value
 * @return {UCF_ComboBoxListBox_ItemDataPart}
 */
UCF_ComboBoxListBox["oGetItemDataPartFromString"] = function(oColumn, sData) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["oGetItemDataPartFromString"]++; }; 
	/** @type {UCF_ComboBoxListBox_ItemDataPart} */
	var oItemData = {};

	if (oColumn["Type"] === 'Icon') {
		oItemData["IconSrc"] = sData;
		oItemData["DisabledIconSrc"] = sData;
	} else {
		oItemData["Value"] = sData;
		oItemData["Tooltip"] = sData;
	}

	return oItemData;
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["oGetItemDataPartFromString"] = 0; };

UCF_ComboBoxListBox["bHasValidHighlights"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bHasValidHighlights"]++; }; 
	return UCF_JsUtil["reduce"](
		UCF_JsUtil["map"](
			oCell["Highlights"],
			function(h) {
				/** @type {boolean} */
				var bResult = h[0] < h[1] && h[1] <= oCell["Value"]["length"];

				if (!bResult) {
					if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Invalid format for Highlights: [' + UCF_JsUtil["sJsonStringify"](oCell) + ']', "ComboBoxListBox.js(2213): bHasValidHighlights"); };
				}

				return bResult;
			}
		),
		function(a, b) { return a && b; },
		true
	);
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["bHasValidHighlights"] = 0; };

/**
 * @private
 * @static
 * @param {UCF_RenderManager} oRenderManager the render manager
 * @param {string} sItemId the id of the item
 * @param {boolean} bIsHistoryItem `true` if the item is a history item,
 * otherwise `false`
 */
UCF_ComboBoxListBox["renderDeleteColumn"] = function(oRenderManager, sItemId, bIsHistoryItem) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderDeleteColumn"]++; }; 
	oRenderManager["write"]('<td');
	if (bIsHistoryItem) {
		oRenderManager["write"](' id="' + sItemId + '-delete"');
	}
	oRenderManager["write"](' style="overflow:hidden" class="lsItemlistbox__content');
	if (bIsHistoryItem) {
		oRenderManager["write"](' lsItemlistbox__button lsItemlistbox__button--delete');
	}
	oRenderManager["write"]('">&nbsp;</td>');
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["renderDeleteColumn"] = 0; };

/**
 * creates the ARIA label for a listbox item
 * @param {Array.JSON} aDefinitions definitions
 * @param {UCF_ItemListBoxItem} oContent content
 * @param {boolean} bHistory history item?
 * @return {string} ARIA label
 *
 * @private
 */
UCF_ComboBoxListBox["prototype"]["getAriaLabel"] = function(aDefinitions, oContent, bHistory) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["getAriaLabel"]++; }; 
	/** @type {UCF_ComboBoxListBox_Column} */
	var oColumn;
	/** @type {string} */
	var sAriaLabel = '';
	/** @type {string} */
	var attribute;
	/** @type {integer} */
	var i;

	for (i = 0; i < aDefinitions["length"]; i++) {
		oColumn = aDefinitions[i];
		if (oColumn["Visibility"] === 'NONE') {
			continue;
		}
		if (typeof(oContent[i]) === 'string') {
			if (oColumn["Type"] !== 'Icon') {
				sAriaLabel += ' ' + oColumn["Label"] + ' ' + oContent[i];
			}
		} else {
			for (attribute in oContent[i]) {
				if (attribute === 'Value' && oColumn["Type"] !== 'Icon') {
					sAriaLabel += ' ' + oColumn["Label"] + ' ' + oContent[i][attribute];
				}
			}
		}
	}

	if (bHistory) {
		sAriaLabel += ' ' + this["sHistoryItem"] + ' ' + this["sDeletable"];
	} else {
		sAriaLabel += ' ' + this["sSuggestItem"];
	}

	return UCF_XSSEncoder["encodeXML"](sAriaLabel);
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["getAriaLabel"] = 0; };

/**
 * @private
 */
UCF_ComboBoxListBox["prototype"]["fireClose"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireClose"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Close"]);
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireClose"] = 0; };

/**
 * @private
 */
UCF_ComboBoxListBox["prototype"]["fireActivate"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireActivate"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Activate"]);
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireActivate"] = 0; };

/**
 * @private
 * @param {Object} oPayload payload for the ComboBoxListBox:Select event
 */
UCF_ComboBoxListBox["prototype"]["fireSelect"] = function(oPayload) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireSelect"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Select"], oPayload);
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireSelect"] = 0; };

/**
 * @private
 * @param {Object} oPayload The object to be passed with the action activate event
 */
UCF_ComboBoxListBox["prototype"]["fireActionActivate"] = function(oPayload) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireActionActivate"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["ActionActivate"], oPayload);
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireActionActivate"] = 0; };

/**
 * @private
 * @param {Object} oPayload the payload for the deleteitem event
 */
UCF_ComboBoxListBox["prototype"]["fireDeleteItem"] = function(oPayload) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireDeleteItem"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["DeleteItem"], oPayload);
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireDeleteItem"] = 0; };

// ----- focuschange ----------------------------------------------------------
/**
 * @private
 * @param {Object} oPayload the event payload
 */
UCF_ComboBoxListBox["prototype"]["fireFocusChange"] = function(oPayload) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireFocusChange"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["FocusChange"], oPayload);
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["fireFocusChange"] = 0; };

/**
 * @private
 * @param {Object} oPayload the payload for the actionactivate event
 */
UCF_ComboBoxListBox["prototype"]["emitActionActivate"] = function(oPayload) {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["emitActionActivate"]++; }; 
	this["fireActionActivate"](oPayload);
	this["close"]();
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["emitActionActivate"] = 0; };

// #region iGetOptimalNumberOfItems -------------------------------------------
/**
 * @protected
 * @return {number}
 */
UCF_ComboBoxListBox["prototype"]["iGetOptimalNumberOfItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetOptimalNumberOfItems"]++; }; 
	return 10; // eslint-disable-line no-magic-numbers
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["iGetOptimalNumberOfItems"] = 0; };
// #endregion
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ComboBoxListBox["prototype"]["aAttributeNames"] = ["iVisibleItems","sHeight","sIconVisibility","sFirstValueVisibility","sSecondValueVisibility","bAvailable","sServerFilter","bComplete","bFiltered","sTableDataDefinition","sItemTableData","sHistoryTableData","sCustomData","sCustomStyle","sTableDataItemDesign"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ComboBoxListBox["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ComboBoxListBox["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_ComboBoxListBox["prototype"]["iVisibleItems"] = 10;

/**
 * @private
 * @type {string}
 */
UCF_ComboBoxListBox["prototype"]["sHeight"] = '0';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ItemListBoxVisibility}
 */
UCF_ComboBoxListBox["prototype"]["sIconVisibility"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ItemListBoxVisibility}
 */
UCF_ComboBoxListBox["prototype"]["sFirstValueVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ItemListBoxVisibility}
 */
UCF_ComboBoxListBox["prototype"]["sSecondValueVisibility"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBoxListBox["prototype"]["bAvailable"] = true;

/**
 * @private
 * @type {string}
 */
UCF_ComboBoxListBox["prototype"]["sServerFilter"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBoxListBox["prototype"]["bComplete"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_ComboBoxListBox["prototype"]["bFiltered"] = true;

/**
 * @private
 * @type {string}
 */
UCF_ComboBoxListBox["prototype"]["sTableDataDefinition"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ComboBoxListBox["prototype"]["sItemTableData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ComboBoxListBox["prototype"]["sHistoryTableData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ComboBoxListBox["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ComboBoxListBox["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputDesign}
 */
UCF_ComboBoxListBox["prototype"]["sTableDataItemDesign"] = "STANDARD";

//#JSCOVER_EXCL_START
/** @protected */
UCF_ComboBoxListBox["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["setDefaultValues"]++; }; 
	this["iVisibleItems"] = 10;
	this["sHeight"] = '0';
	this["sIconVisibility"] = "NONE";
	this["sFirstValueVisibility"] = "VISIBLE";
	this["sSecondValueVisibility"] = "NONE";
	this["bAvailable"] = true;
	this["sServerFilter"] = '';
	this["bComplete"] = true;
	this["bFiltered"] = true;
	this["sTableDataDefinition"] = '';
	this["sItemTableData"] = '';
	this["sHistoryTableData"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sTableDataItemDesign"] = "STANDARD";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("VisibleItems", 10, true);
		this["setClientProperty"]("Height", '0', true);
		this["setClientProperty"]("IconVisibility", "NONE", true);
		this["setClientProperty"]("FirstValueVisibility", "VISIBLE", true);
		this["setClientProperty"]("SecondValueVisibility", "NONE", true);
		this["setClientProperty"]("Available", true, true);
		this["setClientProperty"]("ServerFilter", '', true);
		this["setClientProperty"]("Complete", true, true);
		this["setClientProperty"]("Filtered", true, true);
		this["setClientProperty"]("TableDataDefinition", '', true);
		this["setClientProperty"]("ItemTableData", '', true);
		this["setClientProperty"]("HistoryTableData", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("TableDataItemDesign", "STANDARD", true);
	}
};;if (__UCF_COVERAGE__) { UCF_ComboBoxListBox["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_ComboBoxListBox.prototype["aPublicMethods"] = ["bIsAvailable","oGetSelectedItem","deleteItem"].concat(UCF_ComboBoxListBox.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Container"] = function() {/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * Container
 *
 * <br>
 * <b>Java Control references</b><br>
 * <a href="../javadoc/com/sap/tc/ls/api/controls/LSContainer.html">LSContainer</a>
 *
 * 
 *
 * @version
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Container(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Container["_"]["UCF_Container"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Container.js(37): UCF_Container"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Container.js(38): UCF_Container"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Container.js(39): UCF_Container"); };
	//super
	UCF_Control["apply"](this, [oDomRef, oLS]);

	//Blindlayer is an object from LS.oGetBlindLayer(), it is not visual
	this["oBlindLayer"] = null;

	//LockLayer is the visual object with opacity and loading animation that overlays the container
	this["oLockLayer"] = null;

	//TimoutId for dimension update
	this["sTimeOutId"] = "";

	//Defines whether the loading animation is already visible
	//Normally there is a delay of the loading animation of 2 sec
	//Used to decide whether to show the loading animation immediately after an any event occurred or not
	this["bLoadingAnimationVisible"] = false;

	this["oDomRefEnd"] = UCF_DomUtil["$"](this["sId"] + "-TsEnd");

};window["UCF_Container"] = UCF_Container; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Container"); UCF_Container["_"] = {UCF_Container: 0}; }; ;
UCF_Container["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Container.prototype["sClassName"] = "UCF_Container";

/*
 * Destroys the container and the locking image if necessary
 */
UCF_Container["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["destroy"]++; }; 
	var oWindow = this["oLS"]["oBrowserWindow"];

	if (this["sTimeOutId"] != null) UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);

	oWindow["detachEvent"](oWindow["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
	oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	this["cleanUpLockedUI"]();

	this["oDomRefEnd"] = null;
	this["sTimeOutId"] = null;
	this["sLockedDesign"] = null;
	this["sLockedMessage"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["destroy"] = 0; };

/**
 * Initializes the control
 * This method is only called if the container is locked (see Container.renderer)
 */
UCF_Container["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["initialize"]++; }; 
	//	this.oDomRef.style.width = "100%"; // BLI WDAUIUR1-1454

	// Locked is set by the server,
	// so set the locked flag back to false and let the client lock it
	if (this["bLocked"]) {
		this["bLocked"] = false;
		this["setClientProperty"]("Locked", this["bLocked"], true);
		this["lock"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["initialize"] = 0; };

/**
 * Locks the container for further event processing
 * @public
 */
UCF_Container["prototype"]["lock"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["lock"]++; }; 
	if (this["bLocked"]) return;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Container " + this["sId"] + " locked.", "Container.js(106): lock"); };

	//attach to any and layout change event
	var oWindow = this["oLS"]["oBrowserWindow"];
	oWindow["attachEvent"](oWindow["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
	oWindow["attachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	//set the locked state
	this["bLocked"] = true;
	this["setClientProperty"]("Locked", this["bLocked"], true);

	// activate the local trackswitch, non-accessiblity mode only
	if (!this["oLS"]["oSystem"]["bIs508"]) {
		if (this["oDomRefEnd"]) UCF_DomUtil["setTabIndex"](this["oDomRefEnd"], 0);
	}

	//set the tabindex and focus myself if the currently focused element is contained in me
	UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
	if (UCF_DomUtil["bContains"](this["oDomRef"], UCF_DomUtil["oGetActiveElement"]()))
		this["focus"]();

	//update the ui
	this["updateLockedUI"]();
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["lock"] = 0; };

/**
 * Unlocks the container for further event processing
 * @public
 */
UCF_Container["prototype"]["unlock"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["unlock"]++; }; 

	if (!this["bLocked"]) return;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Container " + this["sId"] + " unlocked.", "Container.js(139): unlock"); };

	//detach from any and layout change event
	var oWindow = this["oLS"]["oBrowserWindow"];
	oWindow["detachEvent"](oWindow["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
	oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	//set the locked state
	this["bLocked"] = false;
	this["setClientProperty"]("Locked", this["bLocked"], true);

	//a loading animation is not visible anymore. if this container is locked again,
	//display the loading animation again with a timeout
	this["bLoadingAnimationVisible"] = false;

	// deactivate the local trackswitch, non-accessiblity mode only
	if (!this["oLS"]["oSystem"]["bIs508"]) {
		if (this["oDomRefEnd"]) UCF_DomUtil["resetTabIndex"](this["oDomRefEnd"]);
	}

	//reset the tab index
	UCF_DomUtil["resetTabIndex"](this["oDomRef"]);
	//set the focus to the next focusable element

	//update the ui
	this["updateLockedUI"]();

	//set the focus to next focusable childs, in 508 mode
	// TODO check if the current Container is focused
	if (this["oLS"]["oSystem"]["bIs508"]) {
		var oNextControl = this["oGetFirstFocusableChildRecursive"](this["oDomRef"]);
		if (oNextControl) {
			oNextControl["moveFocus"]();
			//return true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["unlock"] = 0; };

/**
 * Sets the locked design of the container
 * @param {string} sLockedDesign The new locked design (TRANSPARENT,BORDER,LOADING,SEMI,SEMI_BORDER,SEMI_LOADING)
 */
UCF_Container["prototype"]["setLockedDesign"] = function(sLockedDesign) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["setLockedDesign"]++; }; 

	this["sLockedDesign"] = sLockedDesign;
	this["setClientProperty"]("LockedDesign", this["sLockedDesign"], true);
	if (this["bLocked"]) this["updateLockedUI"]();
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["setLockedDesign"] = 0; };

/**
 * Sets the locked text of the container
 * @param {string} sLockedMessage The new locked text
 */
UCF_Container["prototype"]["setLockedMessage"] = function(sLockedMessage) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["setLockedMessage"]++; }; 

	this["sLockedMessage"] = sLockedMessage;
	this["setClientProperty"]("LockedMessage", this["sLockedMessage"], true);
	if (this["bLocked"]) this["updateLockedUI"]();
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["setLockedMessage"] = 0; };

/**
 * Updates the containers locked visualization
 */
UCF_Container["prototype"]["updateLockedUI"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLockedUI"]++; }; 
	if (this["bLocked"]) {

		//get a new blind layer if needed
		if (!this["oBlindLayer"]) {
			this["oBlindLayer"] = this["oLS"]["oGetBlindLayer"]();

			//set the z index of the blind layer
			this["oBlindLayer"]["oDomRef"]["iZIndex"] = "" + this["iGetParentZIndex"]() + UCF_LS["E_LAYERS"]["BLINDLAYER"] + 1;
		}

		//get a new lock layer if needed
		if (!this["oLockLayer"] && this["sLockedDesign"] !== "TRANSPARENT") {
			this["oLockLayer"] = this["oCreateLockLayer"]();
			UCF_DomUtil["oAddLayeredElement"](this["oLockLayer"]["oDomRef"], null, this["oDomRef"]);
		}

		//update the dimensions of layers after a timeout
		if (this["sTimeOutId"] != null) UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, "updateLockedUIDimensions");

	} else {
		this["cleanUpLockedUI"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLockedUI"] = 0; };

/**
 * Cleanup the lock UI
 * @private
 */
UCF_Container["prototype"]["cleanUpLockedUI"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["cleanUpLockedUI"]++; }; 
	if (this["oBlindLayer"]) {
		this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
		this["oBlindLayer"] = null;
	}

	if (this["oLockLayer"]) {
		UCF_DomUtil["removeFromDom"](this["oLockLayer"]["oDomRef"]);
		this["oLockLayer"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["cleanUpLockedUI"] = 0; };

/**
 * Updates the dimensions of the lock layer dimensions
 */
UCF_Container["prototype"]["updateLockedUIDimensions"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLockedUIDimensions"]++; }; 
	if (!this["bLocked"]) return;

	var oRect = null;

	//apply the dimension to the blind layer
	if (this["oBlindLayer"]) {
		oRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);
		this["applyRect"](this["oBlindLayer"]["oDomRef"], oRect);
	}

	//apply the dimension to the lock layer
	if (this["oLockLayer"]) {
		oRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"], this["oDomRef"]);

		this["applyRect"](this["oLockLayer"]["oDomRef"], oRect);
		//set the position of the loading animation to the center
		if (this["oLockLayer"]["oLoadingDomRef"]) {
			if (!this["bLoadingAnimationVisible"]) {
				UCF_JsUtil["delayedCall"](2000, this, "updateLoadingAnimation", [oRect]);
			} else {
				this["updateLoadingAnimation"](oRect);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLockedUIDimensions"] = 0; };

/**
 * Updates the position of the loading animation
 * and makes it visible if it is currently not visible
 */
UCF_Container["prototype"]["updateLoadingAnimation"] = function(oRect) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLoadingAnimation"]++; }; 
	if (this["oLockLayer"] && this["oLockLayer"]["oLoadingDomRef"]) {
		var o = this["oLockLayer"]["oLoadingDomRef"];
		//calculate the position of the loading animation
		var iDivWidth = o["offsetWidth"];
		//the loading animation div should always be 2 px smaller then the LockContainer; smaler 0 is not supported
		if (iDivWidth > oRect["width"]) o["style"]["width"] = (oRect["width"] > 1 ? (oRect["width"] - 2) : 0) + "px";

		/* //center
		var iLeft = Math.round((oRect.width - iDivWidth) / 2),
			iTop  = Math.round((iTotalHeight - iDivHeight) / 2);
			*/
		// D039230 PB113 - Pioneer - Change TopLeft Position in LS for Loading Text of Locked Container
		var iLeft = 0,
			iTop = 0;
		o["style"]["top"] = iTop > 0 ? iTop + "px" : "0px";
		if (window["UCF_System"]["bIsRTL"]) {
			//just apply to the right
			o["style"]["right"] = iLeft > 0 ? iLeft + "px" : "0px";
		} else {
			o["style"]["left"] = iLeft > 0 ? iLeft + "px" : "0px";
		}
		this["oLockLayer"]["oLoadingDomRef"]["style"]["visibility"] = "visible";
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLoadingAnimation"] = 0; };

/**
 * Creates the lock layer of the container
 * with or without a loading animation or border depending on the locked design
 * @private
 */
UCF_Container["prototype"]["oCreateLockLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["oCreateLockLayer"]++; }; 
	var oDomRef = document["createElement"]("CENTER"),
		bLoading = this["sLockedDesign"]["indexOf"]("LOADING") > -1,
		bBorder = this["sLockedDesign"]["indexOf"]("BORDER") > -1,
		bSemi = this["sLockedDesign"]["indexOf"]("SEMI") > -1,
		iZIndex = this["iGetParentZIndex"]() + UCF_LS["E_LAYERS"]["BLINDLAYER"] + 2,
		sLoadingDiv = '',
		oLoadingDomRef = null,
		sText = null,
		sTextLength = null,
		bLockAnim = "<div class=\"lsLockAItem lsLockAItem1Display lsLockAItem1Delay\"></div>" +
		"<div class=\"lsLockAItem lsLockAItem2Display lsLockAItem2Delay\"></div>" +
		"<div class=\"lsLockAItem lsLockAItem3Display lsLockAItem3Delay\"></div>";

	oDomRef["setAttribute"]("id", "ls-containerlayer-" + this["sId"]);
	UCF_DomUtil["setStyle"](oDomRef, {
		"position": 'absolute',
		"top": '-10000px',
		"overflow": 'hidden',
		"height": '1px',
		"width": '1px',
		"zIndex": iZIndex
	});
	UCF_DomUtil["setClass"](oDomRef, "urBorderBox lsnoprint " + (bBorder ? "urContBdr" : ""));

	if (bLoading || bSemi) {
		//load the text for the loading animation from messagebundle
		sText = this["sLockedMessage"];
		if (sText == null || sText === '') {
			sText = this["oLS"]["sGetText"]("SAPUR_LOADINGANIM");
		}
		sLoadingDiv = "<div id=\"" + this["sId"] + "-text\" class=\"lsContainer--text urTxtStd urTxtColor urBorderBox urContLoading\" >" + bLockAnim + UCF_XSSEncoder["encodeXML"](sText) +
			"</div>";
		sTextLength = sText["length"] + 'em';
	}
	// eslint-disable-next-line no-unsanitized/property
	oDomRef["innerHTML"] = sLoadingDiv;
	if (sTextLength) {
		UCF_DomUtil["setStyle"](oDomRef["firstChild"], {
			"width": sTextLength
		});
	}

	if (bSemi) {
		UCF_DomUtil["setOpacityStyle"](oDomRef["firstChild"], 65);
	}

	oLoadingDomRef = bLoading ? oDomRef["lastChild"] : null;

	//Correction of the loadng animation if RTL
	if (oLoadingDomRef && window["UCF_System"]["bIsRTL"]) {
		var iDivWidth = oLoadingDomRef["offsetWidth"],
			iLeftBgPos = parseInt(UCF_DomUtil["sGetCurrentStyle"](oLoadingDomRef, "backgroundPositionX")),
			iPaddingRight = parseInt(UCF_DomUtil["sGetCurrentStyle"](oLoadingDomRef, "paddingRight"));

		if (!isNaN(iLeftBgPos)) {
			oLoadingDomRef["style"]["backgroundPositionX"] = (iDivWidth - iPaddingRight + iLeftBgPos) + "px";
		} else {
			oLoadingDomRef["style"]["backgroundPositionX"] = (iDivWidth - iPaddingRight + 5) + "px";
		}
	}

	// Ensure valid refernces to dependant objects (see also 1378409 2010)
	return {
		"oDomRef": oDomRef,
		"oSemiDomRef": bSemi ? oDomRef["firstChild"] : null,
		"oLoadingDomRef": oLoadingDomRef
	};

};;if (__UCF_COVERAGE__) { UCF_Container["_"]["oCreateLockLayer"] = 0; };

/**
 * Sets the postion o
 * The object is positioned away from the screen if height or width is 0
 * @param {Element} oDomRef the dom element that
 */
UCF_Container["prototype"]["applyRect"] = function(oDomRef, oRect) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["applyRect"]++; }; 
	if (!oDomRef) return;
	var oStyle = oDomRef["style"];
	if (oRect["height"] === 0 || oRect["width"] === 0) {
		oStyle["top"] = "-10000px";
		oStyle["height"] = "1px";
		oStyle["width"] = "1px";
	} else {
		for (var n in oRect) oStyle[n] = oRect[n] + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["applyRect"] = 0; };

/**
 * Listener of the any event
 * This listener is only attached if the container is currently locked
 * @private
 */
UCF_Container["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["onAnyEvent"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oEvent) === "object", "typeof(oEvent) === \"object\"", "Container.js(404): onAnyEvent"); };
	var oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent"),
		sName = oBrowserEvent["sGetName"](),
		oSource = oBrowserEvent["oGetSource"](),
		oFocusTo;

	// skip locked container for non-508, forward tabbing (Tab)
	if (!this["oLS"]["oSystem"]["bIs508"] && this["bLocked"]) {
		if (this["oDomRef"] === oSource && (sName === "focusin" || sName === "focus")) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Skip locked Container forward", "Container.js(413): onAnyEvent"); };

			var oNext;
			oNext = UCF_DomUtil["oGetNextSibling"](this["oDomRef"], true);
			if (oNext) oFocusTo = UCF_DomUtil["oGetTabbableElementForward"](oNext, true);

			if (oFocusTo) {
				UCF_DomUtil["focusDomElement"](oFocusTo);
			} else {
				this["oLS"]["focusEnd"]();
			}
			return;
		}
	}

	// skip locked container for non-508, backward tabbing (Shift-Tab)
	if (!this["oLS"]["oSystem"]["bIs508"] && this["bLocked"]) {
		if (this["oDomRefEnd"] === oSource && (sName === "focusin" || sName === "focus")) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Skip locked Container backward", "Container.js(431): onAnyEvent"); };

			var oPrevious;
			oPrevious = UCF_DomUtil["oGetPreviousSibling"](this["oDomRef"], true);
			if (oPrevious) oFocusTo = UCF_DomUtil["oGetTabbableElementBackward"](oPrevious, true);

			if (oFocusTo) {
				UCF_DomUtil["focusDomElement"](oFocusTo);
			} else {
				this["oLS"]["focusEnd"]();
			}
			return;
		}
	}

	//check whether the event occurred on a source element that is inside my dom element
	if (UCF_DomUtil["bContains"](this["oDomRef"], oSource) && this["oDomRef"] != oSource) {

		//set the locked property on the browser event to avoid handling
		oBrowserEvent["bLocked"] = this["bLocked"];

		//check for native focus events and focus myself
		if (sName === "focusin" || sName === "focus") this["focus"]();
	}

	//for scroll and resize event change the dimension of the blindlayer
	else if (sName === "resize" || sName === "scroll") this["updateLockedUI"]();
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["onAnyEvent"] = 0; };

/**
 * Handles the layout change event
 */
UCF_Container["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["onLayoutChange"]++; }; 
	this["updateLockedUI"]();
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["onLayoutChange"] = 0; };

/*
 * Focus the container if it is locked and it recieves a focus inside.
 */
UCF_Container["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["focus"]++; }; 
	if (this["bLocked"]) {
		UCF_DomUtil["focusDomElement"](this["oDomRef"]);
		//D039230 - set this.oFocusDomRef
		this["oFocusDomRef"] = this["oDomRef"];
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["focus"] = 0; };

/*
 * Focus the next element if tab is pressed if locked
 */
UCF_Container["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["onlstabnext"]++; }; 
	if (this["bLocked"]) {
		var focussed = this["focusNextControl"](); //try to focus next sibling and their children
		if (focussed) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		} else {
			//No focusable control after the tab strip then leave it up to ls object to find the next element
			this["oLS"]["focusEnd"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["onlstabnext"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Container["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Container.js(502): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() != this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (this["bLocked"]) {
		// display the message
		oAccessibilityHelper["setText"](this["oLS"]["sGetText"]("SAPUR_CO"));
		var bLoading = this["sLockedDesign"]["indexOf"]("LOADING") > -1;
		if (bLoading) {
			// add the loading message
			var sText = this["sLockedMessage"];
			if (sText == null || sText === "") {
				sText = this["oLS"]["sGetText"]("SAPUR_LOADINGANIM");
			}
			oAccessibilityHelper["addTutor"](sText);
		}
		// TODO: Change the text 'to skip press tab'
		oAccessibilityHelper["addTutor"](this["oLS"]["sGetText"]("SAPUR_CO_TUT"));
	}

	// This gets only called for 508 when tabstop is activated
	// on locked container:

	// TODO: Accessiblity
	//   - introduce a new parameter "AccessiblityDescription"
	//   - consider convenient default text (i.e. "Locked Container"
	// var sText = "Locked Container" + " " + this.sId;
	// oAccessibilityHelper.setText(sText);
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Container["prototype"]["aAttributeNames"] = ["bLocked","bPrintable","bPrintArea","sLockedDesign","sLockedMessage","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Container["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Container["prototype"]["aMethodNames"] = ["lock","unlock","setLockedDesign","setLockedMessage","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {boolean}
 */
UCF_Container["prototype"]["bLocked"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Container["prototype"]["bPrintable"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_Container["prototype"]["bPrintArea"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LockedDesign}
 */
UCF_Container["prototype"]["sLockedDesign"] = "TRANSPARENT";

/**
 * @private
 * @type {string}
 */
UCF_Container["prototype"]["sLockedMessage"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Container["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Container["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Container["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["setDefaultValues"]++; }; 
	this["bLocked"] = false;
	this["bPrintable"] = true;
	this["bPrintArea"] = false;
	this["sLockedDesign"] = "TRANSPARENT";
	this["sLockedMessage"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Locked", false, true);
		this["setClientProperty"]("Printable", true, true);
		this["setClientProperty"]("PrintArea", false, true);
		this["setClientProperty"]("LockedDesign", "TRANSPARENT", true);
		this["setClientProperty"]("LockedMessage", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_Container.prototype["aPublicMethods"] = ["lock","unlock"].concat(UCF_Container.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ContainerOutliner"] = function() {/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * Helper class to illustrate nesting of the HTML by giving them an 1px border
 *
 * 
 * @class
 */
function UCF_ContainerOutliner() {if (__UCF_COVERAGE__) { UCF_ContainerOutliner["_"]["UCF_ContainerOutliner"]++; }; 
	UCF_Object["apply"](this);

	/** @type {boolean} */
	this["bRunning"] = false;
};window["UCF_ContainerOutliner"] = UCF_ContainerOutliner; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ContainerOutliner"); UCF_ContainerOutliner["_"] = {UCF_ContainerOutliner: 0}; }; 
UCF_ContainerOutliner["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_ContainerOutliner.prototype["sClassName"] = "UCF_ContainerOutliner";

UCF_ContainerOutliner["OUTLINE_PROPERTY"] = window["UCF_System"]["sDevice"] === 'ie6' ? 'border' : 'outline';

/** @override */
UCF_ContainerOutliner["prototype"]["trigger"] = function() {;if (__UCF_COVERAGE__) { UCF_ContainerOutliner["_"]["trigger"]++; }; 
	/** @type {CSSStyleSheet} */
	var stylesheet = document["styleSheets"][0];

	if (this["bRunning"]) {
		stylesheet["removeRule"](stylesheet["rules"]["length"] - 1);
		stylesheet["removeRule"](stylesheet["rules"]["length"] - 1);
		stylesheet["removeRule"](stylesheet["rules"]["length"] - 1);
		this["bRunning"] = false;
	} else {
		stylesheet["addRule"]('DIV', UCF_ContainerOutliner["OUTLINE_PROPERTY"] + ':1px solid blue');
		stylesheet["addRule"]('SPAN', UCF_ContainerOutliner["OUTLINE_PROPERTY"] + ':1px solid green');
		stylesheet["addRule"]('TABLE', UCF_ContainerOutliner["OUTLINE_PROPERTY"] + ':1px solid red');
		this["bRunning"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_ContainerOutliner["_"]["trigger"] = 0; };

};
sap["ls"]["preload"]["UCF_ContentArea"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ContentArea(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["UCF_ContentArea"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ContentArea.js(23): UCF_ContentArea"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ContentArea.js(24): UCF_ContentArea"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ContentArea.js(25): UCF_ContentArea"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oScrollArea"] = (this["sScrollingMode"] !== "NONE") //scroll area only exists when a height is provided
		? UCF_ClassLoader["oGetClass"]("UCF_ScrollArea")["oCreateAndConnectScrollArea"](this, this["sScrollingMode"], "onScroll")
		: null;
	if (this["oScrollArea"] && this["oScrollArea"]["oDomRef"]) {
		this["oScrollArea"]["oDomRef"]["setAttribute"]("bUseAsPosRefContainer", "X"); // Needed by oGetParentPositionReferenceContainer() in UCF_DomUtil and UCF_DTContainer
	}

	//initialize the default button for this control
	this["setDefaultButtonId"](this["sDefaultButtonId"]);
	this["oContainerContent"] = null;
	this["iPaddingHorizontal"] = 0;
	this["iPaddingVertical"] = 0;
};window["UCF_ContentArea"] = UCF_ContentArea; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ContentArea"); UCF_ContentArea["_"] = {UCF_ContentArea: 0}; }; ;

UCF_ContentArea["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ContentArea.prototype["sClassName"] = "UCF_ContentArea";

UCF_ContentArea["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["initialize"]++; }; 
	if (this["oScrollArea"]) {
		this["oScrollArea"]["setScrollPosition"](this["iScrollTop"], this["iScrollLeft"]);
	}

};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["initialize"] = 0; };

UCF_ContentArea["prototype"]["createScrollHelper"] = function() {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["createScrollHelper"]++; }; 
	var oScrollDomRef = UCF_DomUtil["$"](this["sId"] + "-scrl");
	this["oScrollArea"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(oScrollDomRef);
	this["attachBrowserEvent"]("scroll", oScrollDomRef);
	this["oScrollArea"]["attachEvent"](this["oScrollArea"]["E_EVENTS"]["Scroll"], this, "onScroll");
	this["addDelegate"](this["oScrollArea"]);
};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["createScrollHelper"] = 0; };

/**
 * Handle the area scroll event
 *
 * @param {UCF_Event} oEvent
 */
UCF_ContentArea["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["onScroll"]++; }; 
	var iScrollTop = oEvent["oGetParam"]("iScrollTop"),
		iScrollLeft = oEvent["oGetParam"]("iScrollLeft");
	this["fireScroll"](this["sId"], iScrollTop, iScrollLeft);
};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["onScroll"] = 0; };

/**
 * Destructor
 */
UCF_ContentArea["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["destroy"]++; }; 
	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}
	this["oContainerContent"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sVisibility"] = null;
	this["iPaddingHorizontal"] = null;
	this["iPaddingVertical"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["destroy"] = 0; };

/**
 * Sets the visibility state of this ContentArea
 * @param {string} sVisibility
 * @public
 */
UCF_ContentArea["prototype"]["setVisibility"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["setVisibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sVisibility) === "string", "typeof(sVisibility) === \"string\"", "ContentArea.js(94): setVisibility"); };

	UCF_DomUtil["setVisibility"](this["oDomRef"], sVisibility);
	this["sVisibility"] = sVisibility;
	this["setClientProperty"]("Visibility", this["sVisibility"], true);
};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["setVisibility"] = 0; };

/*
 * ########### ACC Section
 */

UCF_ContentArea["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["onlsaccessibility"]++; }; 

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource != null && oSource["id"] && oSource["id"] === this["sId"] + "-end") {
		var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
		oAccessibilityHelper["setControlType"]("G_END");
	}
};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["onlsaccessibility"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 * @public
 */
UCF_ContentArea["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["setDefaultButtonId"]++; }; 
	UCF_Control.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["setDefaultButtonId"] = 0; };

/**
 * Gets the height of content of the ContentArea
 * @return {integer}
 * @public
 */
UCF_ContentArea["prototype"]["getContentHeightPx"] = function() {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["getContentHeightPx"]++; }; 
	this["retrieveContainerContent"]();
	return (this["oContainerContent"]["offsetHeight"] - this["iPaddingVertical"]);
};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["getContentHeightPx"] = 0; };

/**
 * Gets the height of content of the ContentArea
 * @return {integer}
 * @public
 */
UCF_ContentArea["prototype"]["getContentWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["getContentWidthPx"]++; }; 
	this["retrieveContainerContent"]();
	return (this["oContainerContent"]["offsetWidth"] - this["iPaddingHorizontal"]);
};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["getContentWidthPx"] = 0; };

/**
 * Gets the height of content of the ContentArea
 * @return {HTMLElement} the content container
 * @public
 */
UCF_ContentArea["prototype"]["retrieveContainerContent"] = function() {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["retrieveContainerContent"]++; }; 

	if (this["oContainerContent"] == null) {
		var oScrollDomRef = UCF_DomUtil["$"](this["sId"] + "-scrl"),
			oContentAreaRef = UCF_DomUtil["$"](this["sId"] + "-caCnt");
		if (oScrollDomRef) {
			this["oContainerContent"] = UCF_DomUtil["oGetFirstChild"](oScrollDomRef);
		} else if (oContentAreaRef) {
			this["oContainerContent"] = UCF_DomUtil["oGetFirstChild"](oContentAreaRef);
		} else
			this["oContainerContent"] = this["oDomRef"];
		var iPaddngLeft = parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oContainerContent"], "paddingLeft")),
			iPaddngRight = parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oContainerContent"], "paddingRight")),
			iPaddngTop = parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oContainerContent"], "paddingTop")),
			iPaddngBottom = parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oContainerContent"], "paddingBottom"));
		if (!iPaddngLeft) {
			iPaddngLeft = parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oContainerContent"], "padding"));
			if (!isNaN(iPaddngLeft)) {
				iPaddngRight = iPaddngLeft;
				iPaddngTop = iPaddngLeft;
				iPaddngBottom = iPaddngLeft;
			} else
				iPaddngLeft = 0;
		}
		this["iPaddingHorizontal"] = iPaddngLeft + iPaddngRight;
		this["iPaddingVertical"] = iPaddngTop + iPaddngBottom;
	}

	return this["oContainerContent"];
};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["retrieveContainerContent"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ContentArea["prototype"]["aAttributeNames"] = ["sVisibility","sScrollingMode","iScrollTop","iScrollLeft","sDefaultButtonId","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ContentArea["prototype"]["aEventNames"] = ["Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ContentArea["prototype"]["aMethodNames"] = ["setVisibility","getVisibility","setDefaultButtonId","getContentHeightPx","getContentWidthPx","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ContentArea["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ScrollingMode}
 */
UCF_ContentArea["prototype"]["sScrollingMode"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_ContentArea["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_ContentArea["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_ContentArea["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ContentArea["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ContentArea["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ContentArea["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sScrollingMode"] = "NONE";
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["sDefaultButtonId"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ScrollingMode", "NONE", true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires ContentArea::Scroll
 */
UCF_ContentArea["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "ContentArea.js(280): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ContentArea.js(281): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ContentArea.js(282): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "ContentArea.js(283): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "ContentArea.js(284): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "ContentArea.js(285): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "ContentArea.js(286): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("ContentArea", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ContentArea["_"]["fireScroll"] = 0; };

UCF_ContentArea.prototype["aPublicMethods"] = ["setVisibility","setDefaultButtonId","getContentHeightPx","getContentWidthPx","retrieveContainerContent"].concat(UCF_ContentArea.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ContextualPanel"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ContextualPanel(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["UCF_ContextualPanel"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ContextualPanel.js(20): UCF_ContextualPanel"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ContextualPanel.js(21): UCF_ContextualPanel"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ContextualPanel.js(22): UCF_ContextualPanel"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_ContextualPanel"] = UCF_ContextualPanel; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ContextualPanel"); UCF_ContextualPanel["_"] = {UCF_ContextualPanel: 0}; }; ;
UCF_ContextualPanel["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ContextualPanel.prototype["sClassName"] = "UCF_ContextualPanel";

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ContextualPanel["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ContextualPanel.js(36): onclick"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var sSourceId = oSource["getAttribute"]("id");
	if (!sSourceId) return;

	if (sSourceId["indexOf"]("-help") > -1) {
		this["fireHelp"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	} else if (sSourceId["indexOf"]("-pers") > -1) {
		this["firePersonalize"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["onclick"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ContextualPanel["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["onlsselect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ContextualPanel.js(61): onlsselect"); };
	var oSource = oBrowserEvent["oGetSource"]();
	var sSourceId = oSource["getAttribute"]("id");

	if (sSourceId["indexOf"]("-help") > -1) {
		this["fireHelp"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	} else if (sSourceId["indexOf"]("-pers") > -1) {
		this["firePersonalize"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}

};;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["onlsselect"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ContextualPanel["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ContextualPanel["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["onlsskipback"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_ContextualPanel["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ContextualPanel.js(104): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSource = oBrowserEvent["oGetSource"]();

	if (oSource === this["oDomRef"]) {
		oAccessibilityHelper["setControlType"]("CXP");
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
	} else if (oSource["id"]["indexOf"]("-pers") > -1) {
		oAccessibilityHelper["setControlType"]("PERS");
		oAccessibilityHelper["addTutor"]("LN_TUT");
	} else if (oSource["id"]["indexOf"]("-help") > -1) {
		oAccessibilityHelper["setControlType"]("HELP");
		oAccessibilityHelper["addTutor"]("LN_TUT");
	} else if (oSource["id"]["indexOf"]("-end") > -1) {
		oAccessibilityHelper["setControlType"]("CXP_END");
	}
};;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ContextualPanel["prototype"]["aAttributeNames"] = ["bExpandable","bExpanded","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ContextualPanel["prototype"]["aEventNames"] = ["Expand","Collapse","Help","Personalize"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ContextualPanel["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {boolean}
 */
UCF_ContextualPanel["prototype"]["bExpandable"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_ContextualPanel["prototype"]["bExpanded"] = true;

/**
 * @private
 * @type {string}
 */
UCF_ContextualPanel["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ContextualPanel["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["setDefaultValues"]++; }; 
	this["bExpandable"] = false;
	this["bExpanded"] = true;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Expandable", false, true);
		this["setClientProperty"]("Expanded", true, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires ContextualPanel::Expand
 */
UCF_ContextualPanel["prototype"]["fireExpand"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["fireExpand"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "ContextualPanel.js(188): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ContextualPanel.js(189): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ContextualPanel.js(190): fireExpand"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("ContextualPanel", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["fireExpand"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires ContextualPanel::Collapse
 */
UCF_ContextualPanel["prototype"]["fireCollapse"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "ContextualPanel.js(207): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ContextualPanel.js(208): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ContextualPanel.js(209): fireCollapse"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("ContextualPanel", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["fireCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires ContextualPanel::Help
 */
UCF_ContextualPanel["prototype"]["fireHelp"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["fireHelp"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "ContextualPanel.js(226): fireHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ContextualPanel.js(227): fireHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ContextualPanel.js(228): fireHelp"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("ContextualPanel", "Help", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["fireHelp"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires ContextualPanel::Personalize
 */
UCF_ContextualPanel["prototype"]["firePersonalize"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["firePersonalize"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "ContextualPanel.js(245): firePersonalize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ContextualPanel.js(246): firePersonalize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ContextualPanel.js(247): firePersonalize"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("ContextualPanel", "Personalize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ContextualPanel["_"]["firePersonalize"] = 0; };

};
sap["ls"]["preload"]["UCF_ControlGhost"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_Ghost */
/// <reference path="./Ghost.js"/>

/**
 * controls for the control ghost should implement the methods
 *
 * @class
 * 
 * @param {UCF_Control} oControl
 */
function UCF_ControlGhost(oControl) {if (__UCF_COVERAGE__) { UCF_ControlGhost["_"]["UCF_ControlGhost"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oControl instanceof UCF_Control, "oControl instanceof UCF_Control", "ControlGhost.js(16): UCF_ControlGhost"); };

	this["oControl"] = oControl;
	this["oDomRef"] = oControl["oDomRef"];
};window["UCF_ControlGhost"] = UCF_ControlGhost; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ControlGhost"); UCF_ControlGhost["_"] = {UCF_ControlGhost: 0}; }; ;
UCF_ControlGhost["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Ghost"))(); UCF_ControlGhost.prototype["sClassName"] = "UCF_ControlGhost";

/**
 * this method should add the ghost to the dom
 * @param {HTMLElement} oRootContainerDomRef
 */
UCF_ControlGhost["prototype"]["create"] = function(oRootContainerDomRef) {;if (__UCF_COVERAGE__) { UCF_ControlGhost["_"]["create"]++; }; 

	this["oControl"]["createOnClient"](oRootContainerDomRef);

};;if (__UCF_COVERAGE__) { UCF_ControlGhost["_"]["create"] = 0; };

/**
 * this method should update the ghost according to mosue position etc
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ControlGhost["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ControlGhost["_"]["update"]++; }; 

	this["oControl"]["update"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_ControlGhost["_"]["update"] = 0; };

UCF_ControlGhost["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ControlGhost["_"]["destroy"]++; }; 

	this["oControl"]["destroy"]();
	this["oControl"] = null;
	this["oDomRef"] = null;
	UCF_Ghost.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ControlGhost["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_ControlModel"] = function() {/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_Model */
/// <reference path="../Model.js"/>
/* global UCF_ControlPropertyBinding */
/// <reference path="./ControlPropertyBinding.js"/>

/**
 * Constructor for a new ControlModel.
 *
 * Model implementation for Control model
 * 
 * @version 1.7.0-SNAPSHOT
 *
 * @extends UCF_Model
 * @class
 *
 * @constructor
 */
function UCF_ControlModel() {if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["UCF_ControlModel"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Model["apply"](this, arguments);
		this["oList"] = {};
		this["oElements"] = [];
	}
};window["UCF_ControlModel"] = UCF_ControlModel; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ControlModel"); UCF_ControlModel["_"] = {UCF_ControlModel: 0}; }; ;
//chain the prototypes
UCF_ControlModel["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Model"))(); UCF_ControlModel.prototype["sClassName"] = "UCF_ControlModel";

/** @override */
UCF_ControlModel["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["destroy"]++; }; 
	this["oList"] = null;
	this["oElements"] = null;

	UCF_Model.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["destroy"] = 0; };

/**
 * @protected
 * @param {Object} oData
 */
UCF_ControlModel["prototype"]["setData"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["setData"]++; }; 
	this["oList"] = oData;
	this["checkUpdate"]();
};;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["setData"] = 0; };

/** @param {Object} oElement */
UCF_ControlModel["prototype"]["addFacadeComponent"] = function(oElement) {;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["addFacadeComponent"]++; }; 
	/** @type {number} */
	var i = UCF_JsUtil["iObjectIndexInArray"](oElement, this["oElements"]);

	if (i < 0) {
		this["oElements"]["push"](oElement);
		oElement["attachEvent"]('_change', this["checkUpdate"], this);
	}
};;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["addFacadeComponent"] = 0; };

/** @param {Object} oElement */
UCF_ControlModel["prototype"]["removeFacadeComponent"] = function(oElement) {;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["removeFacadeComponent"]++; }; 
	/** @type {number} */
	var i = UCF_JsUtil["iObjectIndexInArray"](oElement, this["oElements"]);

	if (i >= 0) {
		this["oElements"]["splice"](i, 1);
		oElement["detachEvent"]('_change', this["checkUpdate"], this);
	}
};;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["removeFacadeComponent"] = 0; };

/**
 * @see UCF_Model.prototype.bindProperty
 * @param {string} sPath path to bind
 * @param {UCF_BindingContext} oContext context object
 * @return {UCF_ControlPropertyBinding}
 */
UCF_ControlModel["prototype"]["bindProperty"] = function(sPath, oContext) {;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["bindProperty"]++; }; 
	/** @type {string} */
	var sId = sPath["split"]('/')[1];
	/** @type {UCF_Control} */
	var oControl;

	sPath = sPath["split"]('/')[2]; // eslint-disable-line no-magic-numbers
	oContext = oContext || this["oList"];
	oControl = oContext[sId];

	if (oControl) {
		oControl["attachPropertyChange"](this, 'checkUpdate');
	}

	if (oContext !== this["oList"]) {
		this["addFacadeComponent"](oContext);
	}

	return new (UCF_ClassLoader["oGetClass"]("UCF_ControlPropertyBinding"))(this, sPath, oControl);
};;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["bindProperty"] = 0; };

/** @param {UCF_Event} oEvent */
UCF_ControlModel["prototype"]["checkUpdate"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["checkUpdate"]++; }; 
	if (this["_onchange"]) {
		this["_onchange"](oEvent);
	}
	if (this["aBindings"]["length"]) {
		// TODO optimize with info from event object (control & property)
		UCF_JsUtil["forEach"](this["aBindings"]["slice"](0), function(oBinding) {
			oBinding["checkUpdate"]();
		});
	}
};;if (__UCF_COVERAGE__) { UCF_ControlModel["_"]["checkUpdate"] = 0; };

};
sap["ls"]["preload"]["UCF_ControlPropertyBinding"] = function() {/* global UCF_PropertyBinding */
/// <reference path="../PropertyBinding.js"/>

/**
 * Property binding implementation for JSON format
 *
 * @class
 * @param {UCF_Model} oModel
 * @param {string} sPath
 * @param {UCF_BindingContext} oContext
 */
function UCF_ControlPropertyBinding(oModel, sPath, oContext) {if (__UCF_COVERAGE__) { UCF_ControlPropertyBinding["_"]["UCF_ControlPropertyBinding"]++; }; 
	if (arguments["length"] > 0) {
		UCF_PropertyBinding["apply"](this, arguments);
		this["oValue"] = this["_getValue"]();
	}
};window["UCF_ControlPropertyBinding"] = UCF_ControlPropertyBinding; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ControlPropertyBinding"); UCF_ControlPropertyBinding["_"] = {UCF_ControlPropertyBinding: 0}; }; ;
UCF_ControlPropertyBinding["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PropertyBinding"))(); UCF_ControlPropertyBinding.prototype["sClassName"] = "UCF_ControlPropertyBinding";

/** @override */
UCF_ControlPropertyBinding["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ControlPropertyBinding["_"]["destroy"]++; }; 
	this["oValue"] = null;

	UCF_PropertyBinding.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ControlPropertyBinding["_"]["destroy"] = 0; };

/** @return {Object} the current value of the bound target */
UCF_ControlPropertyBinding["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_ControlPropertyBinding["_"]["getValue"]++; }; 
	return this["oValue"];
};;if (__UCF_COVERAGE__) { UCF_ControlPropertyBinding["_"]["getValue"] = 0; };

/** @return {Object} the current value of the bound target (incl. re-evaluation) */
UCF_ControlPropertyBinding["prototype"]["_getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_ControlPropertyBinding["_"]["_getValue"]++; }; 
	return this["oContext"]["getProperty"](this["sPath"]);
};;if (__UCF_COVERAGE__) { UCF_ControlPropertyBinding["_"]["_getValue"] = 0; };

/** @param {UCF_BindingContext} oContext */
UCF_ControlPropertyBinding["prototype"]["setContext"] = function(oContext) {;if (__UCF_COVERAGE__) { UCF_ControlPropertyBinding["_"]["setContext"]++; }; 
	this["oContext"] = oContext;
	this["checkUpdate"]();
};;if (__UCF_COVERAGE__) { UCF_ControlPropertyBinding["_"]["setContext"] = 0; };

/**
 * Check whether this Binding would provide new values and in case it changed,
 * inform interested parties about this.
 * @protected
 */
UCF_ControlPropertyBinding["prototype"]["checkUpdate"] = function() {;if (__UCF_COVERAGE__) { UCF_ControlPropertyBinding["_"]["checkUpdate"]++; }; 
	/** @type {Object} */
	var oValue = this["_getValue"]();

	// optimize for not firing the events when unneeded
	if (oValue !== this["oValue"]) {
		this["oValue"] = oValue;
		this["_fireChange"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ControlPropertyBinding["_"]["checkUpdate"] = 0; };

};
sap["ls"]["preload"]["UCF_DOMAnalyzer"] = function() {/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* eslint no-magic-numbers:0 */

/**
 * DOM Analyzer for more detailed information about the current page.
 *
 * 
 *
 * Numbers:
 * Nodes: Total amout of nodes in the DOM for
 * Element Nodes: Real Tags in the dom
 * Attribute Nodes: Attributes of tags in the dom
 * Text Nodes: The data text displayed
 * Comment Nodes: HTML comments in the DOM
 *
 * @class
 */
function UCF_DOMAnalyzer() {if (__UCF_COVERAGE__) { UCF_DOMAnalyzer["_"]["UCF_DOMAnalyzer"]++; }; 
	/** @type {number} */
	this["iCount"] = 0;
	/** @type {number} */
	this["iElementCount"] = 0;
	/** @type {number} */
	this["iAttributeCount"] = 0;
	/** @type {number} */
	this["iTextCount"] = 0;
	/** @type {number} */
	this["iCommentCount"] = 0;
	/** @type {Object<string,number>} */
	this["mTagCount"] = {};

	/** @type {number} */
	this["iAttributeLengthSum"] = 0;
	/** @type {number} */
	this["iAttributeMaxLength"] = 0;
	/** @type {number} */
	this["fAttributeAvgLength"] = 0;
	/** @type {number} */
	this["iTextLengthSum"] = 0;
	/** @type {number} */
	this["iTextMaxLength"] = 0;
	/** @type {number} */
	this["fTextAvgLength"] = 0;

	/** @type {number} */
	this["fAttributesPerElement"] = 0;
	/** @type {number} */
	this["fElementsPerText"] = 0;

};window["UCF_DOMAnalyzer"] = UCF_DOMAnalyzer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DOMAnalyzer"); UCF_DOMAnalyzer["_"] = {UCF_DOMAnalyzer: 0}; }; ;
UCF_DOMAnalyzer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_DOMAnalyzer.prototype["sClassName"] = "UCF_DOMAnalyzer";

/** @constant {number} */
UCF_DOMAnalyzer["MAX_DOM_NODES_WARNING"] = 40000;
/** @constant {number} */
UCF_DOMAnalyzer["MAX_ELEMENT_NODES_WARNING"] = 8000;
/** @constant {number} */
UCF_DOMAnalyzer["MAX_ATTRIBUTE_NODES_WARNING"] = 40000;
/** @constant {number} */
UCF_DOMAnalyzer["MAX_TEXT_NODES_WARNING"] = 500;
/** @constant {number} */
UCF_DOMAnalyzer["MAX_COMMENT_NODES_WARNING"] = 5;
/** @constant {number} */
UCF_DOMAnalyzer["MAX_ELEMENTATTRIBUTERATIO_WARNING"] = Math["round"](UCF_DOMAnalyzer["MAX_ATTRIBUTE_NODES_WARNING"] / UCF_DOMAnalyzer["MAX_ELEMENT_NODES_WARNING"] * 100) / 100;

/** @override */
UCF_DOMAnalyzer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DOMAnalyzer["_"]["destroy"]++; }; 
	this["fElementsPerText"] = null;
	this["fAttributesPerElement"] = null;
	this["fTextAvgLength"] = null;
	this["iAttributeLengthSum"] = null;
	this["iAttributeMaxLength"] = null;
	this["fAttributeAvgLength"] = null;
	this["iTextLengthSum"] = null;
	this["iTextMaxLength"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DOMAnalyzer["_"]["destroy"] = 0; };

/**
 * Trigger DOM Analyzer
 * @protected
 */
UCF_DOMAnalyzer["prototype"]["trigger"] = function() {;if (__UCF_COVERAGE__) { UCF_DOMAnalyzer["_"]["trigger"]++; }; 
	this["reset"]();
	this["analyze"](document["documentElement"]);
	this["fAttributeAvgLength"] = Math["round"](this["iAttributeLengthSum"] / this["iAttributeCount"] * 100) / 100;
	this["fTextAvgLength"] = Math["round"](this["iTextLengthSum"] / this["iTextCount"] * 100) / 100;
	this["fAttributesPerElement"] = Math["round"](this["iAttributeCount"] / this["iElementCount"] * 100) / 100;
	this["fElementsPerText"] = Math["round"](this["iElementCount"] / this["iTextCount"] * 100) / 100;
	alert(this["createReport"]());
};;if (__UCF_COVERAGE__) { UCF_DOMAnalyzer["_"]["trigger"] = 0; };

/**
 * Traverse DOM and collect
 *
 * @param {Element} node
 */
UCF_DOMAnalyzer["prototype"]["analyze"] = function(node) {;if (__UCF_COVERAGE__) { UCF_DOMAnalyzer["_"]["analyze"]++; }; 
	/** @type {number} */
	var nodeType = node["nodeType"];
	/** @type {string} */
	var sTagName;
	/** @type {NodeListOf<ChildNode>} */
	var childNodes;
	/** @type {number} */
	var i;
	/** @type {NamedNodeMap} */
	var attributes;
	/** @type {string} */
	var value;
	/** @type {number} */
	var length;

	switch (nodeType) {
		case 1: // ELEMENT_NODE
			sTagName = node["tagName"];

			this["iCount"]++;
			this["iElementCount"]++;
			if (!this["mTagCount"][sTagName]) {
				this["mTagCount"][sTagName] = 0;
			}
			this["mTagCount"][sTagName]++;

			childNodes = node["childNodes"];
			for (i = 0; i < childNodes["length"]; i++) {
				this["analyze"](childNodes[i]);
			}

			attributes = node["attributes"];
			for (i = 0; i < attributes["length"]; i++) {
				this["analyze"](attributes[i]);
			}

			break;

		case 2: // ATTRIBUTE_NODE
			value = node["nodeValue"];
			if (value && value !== 'inherit') {
				this["iCount"]++;
				this["iAttributeCount"]++;
				if (typeof value === 'number' || typeof value === 'boolean') {
					value = '' + value;
				}
				length = value["length"];
				if (length > this["iAttributeMaxLength"]) {
					this["iAttributeMaxLength"] = length;
				}
				this["iAttributeLengthSum"] += length;
			}
			break;

		case 3: // TEXT_NODE
			this["iCount"]++;
			this["iTextCount"]++;
			length = node["nodeValue"]["length"];
			if (length > this["iTextMaxLength"]) {
				this["iTextMaxLength"] = length;
			}
			this["iTextLengthSum"] += length;
			break;

		case 8: // COMMENT_NODE
			this["iCount"]++;
			this["iCommentCount"]++;
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_DOMAnalyzer["_"]["analyze"] = 0; };

/** */
UCF_DOMAnalyzer["prototype"]["reset"] = function() {;if (__UCF_COVERAGE__) { UCF_DOMAnalyzer["_"]["reset"]++; }; 
	this["iCount"] = 0;
	this["iElementCount"] = 0;
	this["iAttributeCount"] = 0;
	this["iTextCount"] = 0;
	this["iCommentCount"] = 0;
	this["mTagCount"] = {};

	this["iAttributeLengthSum"] = 0;
	this["iAttributeMaxLength"] = 0;
	this["fAttributeAvgLength"] = 0;
	this["iTextLengthSum"] = 0;
	this["iTextMaxLength"] = 0;
	this["fTextAvgLength"] = 0;

	this["fAttributesPerElement"] = 0;
	this["fElementsPerText"] = 0;
};;if (__UCF_COVERAGE__) { UCF_DOMAnalyzer["_"]["reset"] = 0; };

/** @return {string} */
UCF_DOMAnalyzer["prototype"]["createReport"] = function() {;if (__UCF_COVERAGE__) { UCF_DOMAnalyzer["_"]["createReport"]++; }; 
	/** @type {string} */
	var sReport = '';
	/** @type {string} */
	var i;

	sReport += 'DOM Nodes: ' + this["iCount"] + '\n\n';

	sReport += 'Element Nodes: ' + this["iElementCount"] + '\n';
	sReport += 'Attribute Nodes: ' + this["iAttributeCount"] + '\n';
	sReport += 'Text Nodes: ' + this["iTextCount"] + '\n';
	sReport += 'Comment Nodes: ' + this["iCommentCount"] + '\n\n';

	sReport += 'Element/Attribute Ratio: ' + this["fAttributesPerElement"] + '\n';
	sReport += 'Text/Element Ratio: ' + this["fElementsPerText"] + '\n\n';

	sReport += 'Attribute Length Sum: ' + this["iAttributeLengthSum"] + '\n';
	sReport += 'Average Attribute Length: ' + this["fAttributeAvgLength"] + '\n';
	sReport += 'Maximum Attribute Length: ' + this["iAttributeMaxLength"] + '\n\n';

	sReport += 'Text Length Sum: ' + this["iTextLengthSum"] + '\n';
	sReport += 'Average Text Length: ' + this["fTextAvgLength"] + '\n';
	sReport += 'Maximum Text Length: ' + this["iTextMaxLength"] + '\n\n';

	for (i in this["mTagCount"]) {
		sReport += i + ': ' + this["mTagCount"][i] + '\n';
	}
	sReport += '\n';

	return sReport;
};;if (__UCF_COVERAGE__) { UCF_DOMAnalyzer["_"]["createReport"] = 0; };

};
sap["ls"]["preload"]["UCF_DOMTreeInspector"] = function() {/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global _trace, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>

/* eslint no-magic-numbers:0 */

/** @typedef {0x01} UCF_DOMTreeInspector_TreeGraphFeature */
/** @typedef {0x10} UCF_DOMTreeInspector_CtNormalFeature */
/** @typedef {0x20} UCF_DOMTreeInspector_CtLayoutFeature */
/** @typedef {0x40} UCF_DOMTreeInspector_CtSpecialFeature */
/** @typedef {0x80} UCF_DOMTreeInspector_CtUndefinedFeature */
/** @typedef {0x70} UCF_DOMTreeInspector_CtControlFeature */
/** @typedef {0xF0} UCF_DOMTreeInspector_CtAnyFeature */
/** @typedef {UCF_DOMTreeInspector_TreeGraphFeature|UCF_DOMTreeInspector_CtNormalFeature|UCF_DOMTreeInspector_CtLayoutFeature|UCF_DOMTreeInspector_CtSpecialFeature|UCF_DOMTreeInspector_CtUndefinedFeature|UCF_DOMTreeInspector_CtControlFeature|UCF_DOMTreeInspector_CtAnyFeature} UCF_DOMTreeInspector_Feature */
/**
 * @typedef {Object} UCF_DOMTreeInspector_FeatureEnum
 * @property {UCF_DOMTreeInspector_TreeGraphFeature} TREE_GRAPH
 * @property {UCF_DOMTreeInspector_CtNormalFeature} CT_NORMAL
 * @property {UCF_DOMTreeInspector_CtLayoutFeature} CT_LAYOUT
 * @property {UCF_DOMTreeInspector_CtSpecialFeature} CT_SPECIAL
 * @property {UCF_DOMTreeInspector_CtUndefinedFeature} CT_UNDEFINED
 * @property {UCF_DOMTreeInspector_CtControlFeature} CT_CONTROL
 * @property {UCF_DOMTreeInspector_CtAnyFeature} CT_ANY
 */
/** @typedef {'ML'} UCF_DOMTreeInspector_MatrixLayoutCt */
/** @typedef {'PL'} UCF_DOMTreeInspector_PageLayoutCt */
/** @typedef {'CL'} UCF_DOMTreeInspector_ColumnLayoutCt */
/** @typedef {'SL'} UCF_DOMTreeInspector_SingleColumnLayoutCt */
/** @typedef {'GL'} UCF_DOMTreeInspector_GridLayoutCt */
/** @typedef {'GLC'} UCF_DOMTreeInspector_GridLayoutCellCt */
/** @typedef {'MLC'} UCF_DOMTreeInspector_MatrixLayoutCellCt */
/** @typedef {UCF_DOMTreeInspector_MatrixLayoutCt|UCF_DOMTreeInspector_PageLayoutCt|UCF_DOMTreeInspector_ColumnLayoutCt|UCF_DOMTreeInspector_SingleColumnLayoutCt|UCF_DOMTreeInspector_GridLayoutCt|UCF_DOMTreeInspector_GridLayoutCellCt|UCF_DOMTreeInspector_MatrixLayoutCellCt} UCF_DOMTreeInspector_LayoutCt  */
/** @typedef {'SY'} UCF_DOMTreeInspector_SystemCt */
/** @typedef {UCF_DOMTreeInspector_SystemCt} UCF_DOMTreeInspector_SpecialCt */
/** @typedef {'IHUB'} UCF_DOMTreeInspector_IHubCt */
/** @typedef {UCF_DOMTreeInspector_LayoutCt|UCF_DOMTreeInspector_SpecialCt|UCF_DOMTreeInspector_IHubCt} UCF_DOMTreeInspector_Ct */
/**
 * @typedef {Object} UCF_DOMTreeInspector_ViewConfig
 * @property {'*'|'CT*'|'CTN'|'CTL'|'CTS'} aspect
 * @property {string} [extra]
 */

/**
 * Traversing of DOM-subtree, to find UR-Specific controls connected to DOM
 * IMPLEMENTED AS SINGLETON
 *
 * https://developer.mozilla.org/en/DOM/element
 * http://technologypost.blogspot.com/2008/07/ie-and-firefox-dom-differences_05.html
 *
 * @class
 * 
 */
function UCF_DOMTreeInspector() {if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["UCF_DOMTreeInspector"]++; }; 
	UCF_Object["apply"](this);
};window["UCF_DOMTreeInspector"] = UCF_DOMTreeInspector; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DOMTreeInspector"); UCF_DOMTreeInspector["_"] = {UCF_DOMTreeInspector: 0}; }; 
UCF_DOMTreeInspector["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_DOMTreeInspector.prototype["sClassName"] = "UCF_DOMTreeInspector";

/** @override */
UCF_DOMTreeInspector["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["destroy"]++; }; 
	this["oLS"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["destroy"] = 0; };

/** @protected */
UCF_DOMTreeInspector["prototype"]["trigger"] = function() {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["trigger"]++; }; 
	this["dumpTreeToWindow"](window);
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["trigger"] = 0; };

// Feature switches and Bit-maps ----------------
/** @type {UCF_DOMTreeInspector_FeatureEnum} */
UCF_DOMTreeInspector["prototype"]["FEATURE"] = {
	"TREE_GRAPH": 0x01, //  nesting graph
	"CT_NORMAL": 0x10,
	"CT_LAYOUT": 0x20,
	"CT_SPECIAL": 0x40,
	"CT_UNDEFINED": 0x80,
	"CT_CONTROL": 0x70,
	"CT_ANY": 0xF0
};

/**
 * @param {UCF_DOMTreeInspector_Feature} iMode
 * @param {UCF_DOMTreeInspector_Feature} iFeatureFlag
 * @return {boolean}
 */
UCF_DOMTreeInspector["prototype"]["bModeMatch"] = function(iMode, iFeatureFlag) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["bModeMatch"]++; }; 
	return (iMode & iFeatureFlag) > 0;
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["bModeMatch"] = 0; };

// ------ CT Translation & classification -----------------------------
//
// TODO: to be reimplemented when more reliable classification //
//       of control is supported

/** @type {string} */
UCF_DOMTreeInspector["prototype"]["CT_LAYOUT"] = ',ML,PL,CL,SL,GL,GLC,MLC,';
/** @type {string} */
UCF_DOMTreeInspector["prototype"]["CT_SPECIAL"] = ',SY,';
/** @type {string} */
UCF_DOMTreeInspector["prototype"]["CT_SPECIAL_IHUB_PREFIX"] = 'IHUB';

/**
 * @param {string} sCt
 * @return {boolean}
 */
UCF_DOMTreeInspector["prototype"]["bIsCtLayout"] = function(sCt) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["bIsCtLayout"]++; }; 
	return this["CT_LAYOUT"]["indexOf"](',' + sCt + ',') >= 0;
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["bIsCtLayout"] = 0; };

/**
 * @param {string} sCt
 * @return {boolean}
 */
UCF_DOMTreeInspector["prototype"]["bIsCtSpecial"] = function(sCt) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["bIsCtSpecial"]++; }; 
	if (!sCt || sCt["length"] === 0) {
		return false;
	}
	if ((sCt["indexOf"](this["CT_SPECIAL_IHUB_PREFIX"])) === 0) {
		return true;
	}
	if ((this["CT_SPECIAL"]["indexOf"](',' + sCt + ',')) >= 0) {
		return true;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["bIsCtSpecial"] = 0; };

/**
 * @param {string} sCt
 * @param {UCF_DOMTreeInspector_Feature} iMode
 * @return {boolean}
 */
UCF_DOMTreeInspector["prototype"]["bTestCt"] = function(sCt, iMode) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["bTestCt"]++; }; 
	/** @type {boolean} */
	var bCtUndefined = false;
	/** @type {boolean} */
	var bCtNormal = false;
	/** @type {boolean} */
	var bCtLayout = false;
	/** @type {boolean} */
	var bCtSpecial = false;

	if (sCt == null || sCt["length"] === 0) {
		bCtUndefined = true;
	} else {
		bCtLayout = this["bIsCtLayout"](sCt);
		bCtSpecial = this["bIsCtSpecial"](sCt);
		bCtNormal = !(bCtLayout || bCtSpecial);
	}

	return (bCtUndefined && this["bModeMatch"](iMode, this["FEATURE"]["CT_UNDEFINED"]))
		|| (bCtNormal && this["bModeMatch"](iMode, this["FEATURE"]["CT_NORMAL"]))
		|| (bCtLayout && this["bModeMatch"](iMode, this["FEATURE"]["CT_LAYOUT"]))
		|| (bCtSpecial && this["bModeMatch"](iMode, this["FEATURE"]["CT_SPECIAL"]));
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["bTestCt"] = 0; };

/**
 * @param {string} sCt
 * @param {Object<string,string>} mControlTypes
 * @return {string}
 */
UCF_DOMTreeInspector["prototype"]["sGetCtVerbose"] = function(sCt, mControlTypes) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sGetCtVerbose"]++; }; 
	/** @type {string} */
	var sVerbose = mControlTypes[sCt];

	// eslint-disable-next-line no-magic-numbers
	if (sVerbose && sVerbose["length"] > 4 && sVerbose["indexOf"]('UCF_') === 0) {
		sVerbose = sVerbose["substring"](4); // eslint-disable-line no-magic-numbers
	}

	return sVerbose;
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sGetCtVerbose"] = 0; };

// --------------

/** @type {string} */
UCF_DOMTreeInspector["prototype"]["UNKNOWN_TAG"] = '[unknown tag]';

/**
 * @param {UCF_DOMTreeInspector_ViewConfig} oConfig
 * @param {Object<string,string>} mControlTypes
 * @param {UCF_LS} oLS
 * @return {string}
 */
UCF_DOMTreeInspector["prototype"]["sGetView"] = function(oConfig, mControlTypes, oLS) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sGetView"]++; }; 
	/** @type {UCF_DOMTreeInspector_Feature} */
	var iMode;
	/** @type {string[]} */
	var aExtraKeys;
	/** @type {string[]} */
	var aRawExtraKeys;
	/** @type {number} */
	var i;

	this["oLS"] = oLS;

	iMode = 0x00;
	switch (oConfig["aspect"]) {
		case '*':
			iMode |= this["FEATURE"]["CT_ANY"];
			break;
		case 'CT*':
			iMode |= this["FEATURE"]["CT_CONTROL"];
			break;
		case 'CTN':
			iMode |= this["FEATURE"]["CT_NORMAL"];
			break;
		case 'CTL':
			iMode |= this["FEATURE"]["CT_LAYOUT"];
			break;
		case 'CTS':
			iMode |= this["FEATURE"]["CT_SPECIAL"];
			break;
		default:
			break;
	}
	iMode |= this["FEATURE"]["TREE_GRAPH"];

	aExtraKeys = [];

	if (oConfig["extra"] != null && oConfig["extra"]["length"] > 0) {
		aRawExtraKeys = oConfig["extra"]["split"](/[;,| \t\n\r\f\v]+/);

		for (i = 0; i < aRawExtraKeys["length"]; i++) {
			if (aRawExtraKeys[i] != null && aRawExtraKeys[i]["length"] > 0) {
				aExtraKeys["push"](aRawExtraKeys[i]);
			}
		}
	}

	if (mControlTypes == null) {
		mControlTypes = {};
	}

	return this["sPrintDom"](
		document["documentElement"],
		iMode,
		aExtraKeys,
		mControlTypes
	);
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sGetView"] = 0; };

// ---- traversing -------------------------------------

/**
 * @param {Element} oDomRef
 * @param {UCF_DOMTreeInspector_Feature} iMode
 * @param {string[]} aExtraKeys
 * @param {Object<string,string>} mControlTypes
 * @return {string}
 */
UCF_DOMTreeInspector["prototype"]["sPrintDom"] = function(oDomRef, iMode, aExtraKeys, mControlTypes) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sPrintDom"]++; }; 
	/** @type {UCF_DOMTreeInspector} */
	var self = this;
	/** @type {string[]} */
	var aBuff = [];

	this["renderDumpBegin"](aBuff);
	this["renderHeader"](aBuff, iMode, aExtraKeys);

	UCF_JsUtil["forEach"](aExtraKeys, function(sExtraKey) {
		if (sExtraKey["indexOf"]('(') === 0) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Eval attributes have been removed from UCF_DOMTreeInspector for CSP (without unsafe-eval) compliance. "' + sExtraKey + '" will be treated as "' + self["sTrimBrackets"](sExtraKey, '(', ')')["split"]('.')[0] + '".', "DOMTreeInspector.js(267): sPrintDom"); };
		}
	});

	this["traverseTree"](oDomRef, 0, aBuff, iMode, aExtraKeys, mControlTypes);

	this["renderDumpEnd"](aBuff);

	return aBuff["join"]('');
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sPrintDom"] = 0; };

/**
 * @param {Node} oNode
 * @param {number} iDepth
 * @param {string[]} aBuff
 * @param {UCF_DOMTreeInspector_Feature} iMode
 * @param {string[]} aExtraKeys
 * @param {Object<string,string>} mControlTypes
 */
UCF_DOMTreeInspector["prototype"]["traverseTree"] = function(oNode, iDepth, aBuff, iMode, aExtraKeys, mControlTypes) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["traverseTree"]++; }; 
	/** @type {number} */
	var iNodeType = oNode["nodeType"];
	/** @type {string} */
	var sExtraKey = null;
	/** @type {number} */
	var i = 0;
	/** @type {string} */
	var sTagName;
	/** @type {string} */
	var sId;
	/** @type {string} */
	var sCt;
	/** @type {string} */
	var sCtVerbose;
	/** @type {string[]} */
	var aExtraValues;

	switch (iNodeType) {
		case 1: // ELEMENT_NODE
			sTagName = oNode["tagName"];
			sId = oNode["getAttribute"]('id');
			sCt = oNode["getAttribute"]('ct');
			sCtVerbose = this["sGetCtVerbose"](sCt, mControlTypes);
			aExtraValues = [];

			if (this["bTestCt"](sCt, iMode)) {
				for (i = 0; i < aExtraKeys["length"]; i++) {
					switch (aExtraKeys[i]["charAt"](0)) {
						case '[': // pure attributes
							sExtraKey = this["sTrimBrackets"](aExtraKeys[i], '[', ']');
							aExtraValues[i] = this["sSafeValue"](oNode["getAttribute"](sExtraKey));
							break;
						case '(': // eval attribute
							sExtraKey = this["sTrimBrackets"](aExtraKeys[i], '(', ')')["split"]('.')[0];
							aExtraValues[i] = this["sSafeValue"](oNode[sExtraKey]);
							break;
						default: // node attribute
							aExtraValues[i] = this["sSafeValue"](oNode[aExtraKeys[i]]);
							break;
					}
				}

				this["renderEntry"](
					aBuff,
					iMode,
					iDepth,
					sTagName,
					sId,
					sCt,
					sCtVerbose,
					aExtraValues
				);
			}

			for (i = 0; i < oNode["childNodes"]["length"]; i++) {
				this["traverseTree"](
					oNode["childNodes"][i],
					iDepth + 1,
					aBuff,
					iMode,
					aExtraKeys,
					mControlTypes
				);
			};
			break;

		case 2: // ATTRIBUTE_NODE
		case 3: // TEXT_NODE
		case 4: // CDATA_SECTION_NODE
		case 5: // ENTITY_REFERENCE_NODE
		case 6: // ENTITY_NODE
		case 7: // PROCESSING_INSTRUCTON_NODE
		case 8: // COMMENT_NODE
		case 9: // DOCUMENT_NODE
		case 10: // DOCUMENT_TYPE_NODE
		case 11: // DOCUMENT_FRAGMENT_NODE
		case 12: // NOTATION_NODE
		default:
			break;
	}

};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["traverseTree"] = 0; };

// ------------ Output renderers -----------------------------------

/** @param {string[]} aBuff */
UCF_DOMTreeInspector["prototype"]["renderDumpBegin"] = function(aBuff) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["renderDumpBegin"]++; }; 
	aBuff["push"]('<table class="domv">');
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["renderDumpBegin"] = 0; };

/** @param {string[]} aBuff */
UCF_DOMTreeInspector["prototype"]["renderDumpEnd"] = function(aBuff) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["renderDumpEnd"]++; }; 
	aBuff["push"]('</table>');
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["renderDumpEnd"] = 0; };

/**
 * @param {string[]} aBuff
 * @param {UCF_DOMTreeInspector_Feature} iMode
 * @param {string[]} aExtraKeys
 */
UCF_DOMTreeInspector["prototype"]["renderHeader"] = function(aBuff, iMode, aExtraKeys) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["renderHeader"]++; }; 
	/** @type {number} */
	var i;

	aBuff["push"]('<tr class="domv_head">');

	aBuff["push"]('<th class="domv_head">HtmlTag</th>');
	aBuff["push"]('<th class="domv_head">Depth</th>');
	if (this["bModeMatch"](iMode, this["FEATURE"]["TREE_GRAPH"])) {
		aBuff["push"]('<th class="domv_head">Tree</th>');
	}
	aBuff["push"]('<th class="domv_head">Ct</th>');
	aBuff["push"]('<th class="domv_head">CtVerbose</th>');
	aBuff["push"]('<th class="domv_head">Id</th>');
	if (this["oLS"]) {
		aBuff["push"]('<th class="domv_head">CustomData</th>');
	}
	for (i = 0; i < aExtraKeys["length"]; i++) {
		aBuff["push"]('<th class="domv_head">');
		aBuff["push"](this["sSafeHeaderText"](aExtraKeys[i]));
		aBuff["push"]('</th>');
	}

	aBuff["push"]('</tr>');
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["renderHeader"] = 0; };

/**
 * @param {string[]} aBuff
 * @param {UCF_DOMTreeInspector_Feature} iMode
 * @param {number} iDepth
 * @param {string} sTagName
 * @param {string} sId
 * @param {string} sCt
 * @param {string} sCtVerbose
 * @param {string[]} aExtraValues
 */
UCF_DOMTreeInspector["prototype"]["renderEntry"] = function(aBuff, iMode, iDepth, sTagName, sId, sCt, sCtVerbose, aExtraValues) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["renderEntry"]++; }; 
	/** @type {number} */
	var iColorPart = iDepth < 96 ? (256 - iDepth * 2) : 64;
	/** @type {UCF_Control} */
	var oControl;
	/** @type {number} */
	var i;

	aBuff["push"]('<tr class="domv_data"');
	aBuff["push"](' data-colorpart="' + iColorPart + '"');	
	aBuff["push"]('>');

	aBuff["push"]('<td class="domv_data">');
	aBuff["push"](sTagName);
	aBuff["push"]('</td>');

	aBuff["push"]('<td class="domv_data">');
	aBuff["push"](this["sFormatFixWidth"](iDepth, 3, '0', true));
	aBuff["push"]('</td>');

	if (this["bModeMatch"](iMode, this["FEATURE"]["TREE_GRAPH"])) {
		aBuff["push"]('<td class="domv_tree">');
		aBuff["push"](this["sFormatTreeNode"](iDepth, sCtVerbose));
		aBuff["push"]('</td>');
	}

	aBuff["push"]('<td class="domv_data">');
	aBuff["push"](sCt);
	aBuff["push"]('</td>');

	aBuff["push"]('<td class="domv_data">');
	aBuff["push"](sCtVerbose);
	aBuff["push"]('</td>');

	aBuff["push"]('<td class="domv_data">');
	aBuff["push"](this["sInjectCIDLink"](sId));
	aBuff["push"]('</td>');
	if (this["oLS"] && sId && sId !== 'UCF_System') {
		aBuff["push"]('<td class="domv_data">');
		oControl = this["oLS"]["oGetControlById"](sId);
		if (oControl && oControl["sGetCustomData"]()) {
			aBuff["push"](oControl["sGetCustomData"]());
			if (oControl["getCustomData"]()) {
				aBuff["push"]('&nbsp;JSON');
			}
		}
		aBuff["push"]('</td>');
	}

	for (i = 0; i < aExtraValues["length"]; i++) {
		aBuff["push"]('<td class="domv_data">');
		aBuff["push"](aExtraValues[i]);
		aBuff["push"]('</td>');
	}

	aBuff["push"]('</tr>');
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["renderEntry"] = 0; };

/**
 * @param {string} sSample
 * @return {string}
 */
UCF_DOMTreeInspector["prototype"]["sSafeValue"] = function(sSample) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sSafeValue"]++; }; 
	return (sSample == null) ? '' : sSample;
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sSafeValue"] = 0; };

/**
 * @param {string} sSample
 * @return {string}
 */
UCF_DOMTreeInspector["prototype"]["sSafeHeaderText"] = function(sSample) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sSafeHeaderText"]++; }; 
	return sSample["replace"](/&/g, '&amp;')
		["replace"](/</g, '&lt;')
		["replace"](/>/g, '&gt;');
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sSafeHeaderText"] = 0; };

/**
 * @param {string} sSample
 * @param {string} sBracketOpen
 * @param {string} sBracketClose
 * @return {string}
 */
UCF_DOMTreeInspector["prototype"]["sTrimBrackets"] = function(sSample, sBracketOpen, sBracketClose) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sTrimBrackets"]++; }; 
	/** @type {number} */
	var iOpen = sSample["indexOf"](sBracketOpen);
	/** @type {number} */
	var iClose = sSample["lastIndexOf"](sBracketClose);

	if (iOpen === 0) {
		if (iClose === (sSample["length"] - 1)) {
			return sSample["substring"](1, iClose);
		} else {
			return sSample["substring"](1);
		}
	} else {
		return sSample;
	}
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sTrimBrackets"] = 0; };

/**
 * @param {string} sValue
 * @param {number} iSize
 * @param {string} cFillChar
 * @param {boolean} bRightPadding
 * @return {string}
 */
UCF_DOMTreeInspector["prototype"]["sFormatFixWidth"] = function(sValue, iSize, cFillChar, bRightPadding) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sFormatFixWidth"]++; }; 
	/** @type {string} */
	var sSafeValue = (sValue == null) ? '' : ('' + sValue);
	/** @type {number} */
	var iGap = iSize - sSafeValue["length"];
	/** @type {string[]} */
	var xBuff;
	/** @type {number} */
	var i;
	/** @type {string} */
	var sFiller;

	if (iGap > 0) {
		xBuff = [];

		for (i = 0; i < iGap; i++) { xBuff["push"](cFillChar); }

		sFiller = xBuff["join"]('');

		return (bRightPadding === true)
			? (sFiller + sSafeValue)
			: (sSafeValue + sFiller);
	} else {
		return sSafeValue;
	}
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sFormatFixWidth"] = 0; };

/**
 * @param {number} iSize
 * @param {string} sText
 * @return {boolean}
 */
UCF_DOMTreeInspector["prototype"]["sFormatTreeNode"] = function(iSize, sText) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sFormatTreeNode"]++; }; 
	return iSize < 0
		? ''
		: this["sFormatFixWidth"]('', iSize, '&nbsp;', false) + ((sText) ? sText : 'o');
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sFormatTreeNode"] = 0; };

// Injection of Links to make Control-Ids linked to preview & control tree --------------

/** @type {string} */
UCF_DOMTreeInspector["prototype"]["CIDL_1"] = '<a href="#" onclick="try{top.testFramework.highlightByControlId(\'';
/** @type {string} */
UCF_DOMTreeInspector["prototype"]["CIDL_2"] = '\');}catch(ex){};inspectId(this.innerHTML,event);return false;">';
/** @type {string} */
UCF_DOMTreeInspector["prototype"]["CIDL_3"] = '</a>';

/**
 * @param {string} sPrefix
 * @param {string} sKey
 * @param {string} sSuffix
 * @return {string}
 */
UCF_DOMTreeInspector["prototype"]["sGetCIDLGeneric"] = function(sPrefix, sKey, sSuffix) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sGetCIDLGeneric"]++; }; 
	sPrefix = (sPrefix) ? sPrefix : '';
	sSuffix = (sSuffix) ? sSuffix : '';

	return sPrefix + this["CIDL_1"] + sKey + this["CIDL_2"] + sKey + this["CIDL_3"] + sSuffix;
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sGetCIDLGeneric"] = 0; };

/**
 * @param {string} sId
 * @return {string}
 */
UCF_DOMTreeInspector["prototype"]["sInjectCIDLink"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sInjectCIDLink"]++; }; 
	return (sId == null || sId["length"] === 0)
		? ''
		: this["CIDL_1"] + sId + this["CIDL_2"] + sId + this["CIDL_3"];
};;if (__UCF_COVERAGE__) { UCF_DOMTreeInspector["_"]["sInjectCIDLink"] = 0; };

/** @type {UCF_DOMTreeInspector} Singleton */
window["UCF_domTreeInspector"] = new (UCF_ClassLoader["oGetClass"]("UCF_DOMTreeInspector"))();


};
sap["ls"]["preload"]["UCF_DTContainer"] = function() {/* global _assert, _trace, DEBUG, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_BrowserWindow */
/// <reference path="../browser/BrowserWindow.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DTElement */
/// <reference path="./DTElement.js"/>
/* global sap */

/**
 * Designtime Container
 *
 * @class
 * @param {HTMLElement} oDomRef The DOM node
 * @param {UCF_LS} oLS The LS instance
 */
function UCF_DTContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["UCF_DTContainer"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "DTContainer.js(35): UCF_DTContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "DTContainer.js(36): UCF_DTContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DTContainer.js(37): UCF_DTContainer"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["defineEvents"](['DragStart', 'DragStop', 'ModeSwitch']);

	this["aElements"] = null;

	this["oRootRasterLayoutControl"] = null; // Used by ghost and resize code to calculate the raster points
	this["oRootRasterLayoutDTElement"] = null;
	this["aRasterLayoutList"] = [];
	this["aScrollContainerList"] = [];
	this["oResizeGhost"] = null;
	this["oSelectionRectangleSession"] = null;

	this["bResizing"] = false;
	//this.iMode = UCF_DTContainer.MODES.DEFAULT;
	this["bAbsoluteRectsCalculated"] = false;

	//flag for initialization
	this["bInitialized"] = false;
	this["bPausePositioning"] = false;
};window["UCF_DTContainer"] = UCF_DTContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DTContainer"); UCF_DTContainer["_"] = {UCF_DTContainer: 0}; }; ;
UCF_DTContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_DTContainer.prototype["sClassName"] = "UCF_DTContainer";

UCF_DTContainer["prototype"]["ID_SEL_RECT"] = "LS-DT-selectionrectangle";
UCF_DTContainer["prototype"]["ID_RES_GHOST"] = "LS-DT-resizeghost";

// Offset for zindex that is added to the elements zindex after initialization
UCF_DTContainer["prototype"]["ZINDEX_RESIZE"] = {
	"HANDLES": 1,
	"GHOST": 2
};

// "virtual" layers (The real zindex value is different) in RasterMode: Use for setZIndex() method of elements
// The control elements need to be on a higher level than the layouts because a control can be moved from
// a parent layout to the area of a child layout. With the same zindex and DOM-order it would be behind the layout and not selectable!
UCF_DTContainer["prototype"]["ZINDEX_LAYERS"] = {
	"RASTER_LAYOUT_ELEMENTS": 1,
	"CONTROL_ELEMENTS": 2,
	"DD_ROOT_RL_ELEMENT": 3
};

/**
 * zindex base value for all DTElements
 * @const {number}
 */
UCF_DTContainer["prototype"]["ZINDEX_BASE"] = UCF_LS["E_LAYERS"]["DT_ELEMENTS"];

UCF_DTContainer["prototype"]["ACCESS_TYPE"] = {
	"STANDARD": "STANDARD",
	"RANGE": "RANGE",
	"TOGGLE": "TOGGLE",
	"SELECT_ALL": "SELECT_ALL",
	"DESELECT_ALL": "DESELECT_ALL",
	"LIST": "LIST"
};

UCF_DTContainer["SELRECT_OFF"] = 2;

UCF_DTContainer["prototype"]["initialized"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initialized"]++; }; 
	return this["bInitialized"];
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initialized"] = 0; };

UCF_DTContainer["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initialize"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RL Mode: " + this["sRasterMode"], "DTContainer.js(102): initialize"); };

	if (!this["oHitZone"]) {
		this["oHitZone"] = {};
		this["oHitZone"]["ROOT"] = document["createElement"]("DIV");
		this["oHitZone"]["ROOT"]["setAttribute"]("id", "ls-dt-hitzone");
		this["oHitZone"]["ROOT"]["style"]["boxSizing"] = "border-box";
		this["oDomRef"]["appendChild"](this["oHitZone"]["ROOT"]);
		this["oHitZone"]["ROOT"]["innerHTML"] = "" +
			"<div id=\"ls-dt-hitzone-move-top\" class=\"lsDTHitzone--movevertical\"></div>" +
			"<div id=\"ls-dt-hitzone-move-bottom\" class=\"lsDTHitzone--movevertical\"></div>" +
			"<div id=\"ls-dt-hitzone-move-left\"  class=\"lsDTHitzone--movehorizontal\"></div>" +
			"<div id=\"ls-dt-hitzone-move-right\" class=\"lsDTHitzone--movehorizontal\"></div>" +
			"<div id=\"ls-dt-hitzone-resizehandle-N\" class=\"lsDTResizeHandle lsDTResizeHandle--initial lsCursor--s-resize\" enabled=\"false\"></div>" +
			"<div id=\"ls-dt-hitzone-resizehandle-NE\" class=\"lsDTResizeHandle lsDTResizeHandle--initial lsCursor--ne-resize\" enabled=\"false\"></div>" +
			"<div id=\"ls-dt-hitzone-resizehandle-NW\" class=\"lsDTResizeHandle  lsDTResizeHandle--initial lsCursor--se-resize\" enabled=\"false\"></div>" +
			"<div id=\"ls-dt-hitzone-resizehandle-S\" class=\"lsDTResizeHandle lsDTResizeHandle--initial lsCursor--s-resize\" enabled=\"false\"></div>" +
			"<div id=\"ls-dt-hitzone-resizehandle-SE\" class=\"lsDTResizeHandle lsDTResizeHandle--initial lsCursor--se-resize\" enabled=\"false\"></div>" +
			"<div id=\"ls-dt-hitzone-resizehandle-SW\" class=\"lsDTResizeHandle lsDTResizeHandle--initial lsCursor--ne-resize\" enabled=\"false\"></div>" +
			"<div id=\"ls-dt-hitzone-resizehandle-W\" class=\"lsDTResizeHandle lsDTResizeHandle--initial lsCursor--e-resize\" enabled=\"false\" ></div>" +
			"<div id=\"ls-dt-hitzone-resizehandle-E\" class=\"lsDTResizeHandle lsDTResizeHandle--initial lsCursor--e-resize\" enabled=\"false\"></div>" +
			"";
		this["oHitZone"]["MOVETOP"] = UCF_DomUtil["$"]("ls-dt-hitzone-move-top");
		this["oHitZone"]["MOVELEFT"] = UCF_DomUtil["$"]("ls-dt-hitzone-move-left");
		this["oHitZone"]["MOVEBOTTOM"] = UCF_DomUtil["$"]("ls-dt-hitzone-move-bottom");
		this["oHitZone"]["MOVERIGHT"] = UCF_DomUtil["$"]("ls-dt-hitzone-move-right");
		this["oHitZone"]["N"] = UCF_DomUtil["$"]("ls-dt-hitzone-resizehandle-N");
		this["oHitZone"]["W"] = UCF_DomUtil["$"]("ls-dt-hitzone-resizehandle-W");
		this["oHitZone"]["E"] = UCF_DomUtil["$"]("ls-dt-hitzone-resizehandle-E");
		this["oHitZone"]["S"] = UCF_DomUtil["$"]("ls-dt-hitzone-resizehandle-S");
		this["oHitZone"]["SE"] = UCF_DomUtil["$"]("ls-dt-hitzone-resizehandle-SE");
		this["oHitZone"]["SW"] = UCF_DomUtil["$"]("ls-dt-hitzone-resizehandle-SW");
		this["oHitZone"]["NW"] = UCF_DomUtil["$"]("ls-dt-hitzone-resizehandle-NW");
		this["oHitZone"]["NE"] = UCF_DomUtil["$"]("ls-dt-hitzone-resizehandle-NE");
	}

	this["initRasterLayouts"]();
	this["initScrollContainers"]();
	this["initElements"](); // Does not longer set the element positions => call this.updatePositions()
	this["updatePositions"](); // DELAYED
	this["updateResizeHandles"]();

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["InvisibilityChanged"], this, "onInvisibilityChanged");

	//UCF_DomUtil.setTabIndex(this.oDomRef, -1);
	this["bInitialized"] = true;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initialize"] = 0; };

UCF_DTContainer["prototype"]["onInvisibilityChanged"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onInvisibilityChanged"]++; }; 
	if (this["iInvisibilityChangeTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["iInvisibilityChangeTimer"]);
	}
	this["iInvisibilityChangeTimer"] = UCF_JsUtil["delayedCall"](1, this, "handleInvisibilityChanged"); // eslint-disable-line @ur/no-memory-leaks
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onInvisibilityChanged"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["handleInvisibilityChanged"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleInvisibilityChanged"]++; }; 
	if (!this["bEnableAdvancedElementFeatures"]) return;

	var f = function(oDTContainer, oElement) {
		if (oElement["bIsDestroyed"]) return;

		// setInvisibility is called during rendering (UCF_RenderManager.reinitializeUCFControls)
		// References may be out-dated => call oGetConnectedControl with bAutoRefresh=true
		var oConnectedControl = oElement["oGetConnectedControl"](true);
		if (!oConnectedControl || oConnectedControl["bIsDestroyed"]) {
			// Should not happen
			return;
		}

		// Only the top-level container with invisibility gets a small element to enable selection
		// Nested controls with invisibility inside a invisible container also get display:none
		if (oConnectedControl["oGetParent"]() && oConnectedControl["oGetParent"]()["sClassName"] !== "UCF_RasterLayoutItem" && oConnectedControl["bIsAncestorInvisible"]()) {
			oElement["oDomRef"]["style"]["display"] = "none";
		} else if (oConnectedControl["bGetInvisibility"]()) {
			oElement["oDomRef"]["style"]["height"] = "16px";
			if (oConnectedControl["oRootRef"]["offsetWidth"] === 0) {
				oElement["oDomRef"]["style"]["width"] = "16px";
			}
			UCF_JsUtil["delayedCall"](1, oDTContainer, "updateHitZones");
			oElement["oDomRef"]["style"]["display"] = "block";
			oElement["highlightPositionParent"]();
		} else {
			oElement["oDomRef"]["style"]["marginTop"] = "0px";
			oElement["oDomRef"]["style"]["display"] = "block";
			UCF_JsUtil["delayedCall"](1, oDTContainer, "updateHitZones");
		}
	};
	this["loopElements"](f);

	this["updatePositions"](false);
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleInvisibilityChanged"] = 0; };

/**
 * @private
 * @param {string} id
 * @return {string}
 */
UCF_DTContainer["prototype"]["isInScrollContainersWithScrollbars"] = function(id) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["isInScrollContainersWithScrollbars"]++; }; 
	return (" " + this["sScrollContainersWithScrollbars"] + " ")["indexOf"](" " + id + " ") === 0;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["isInScrollContainersWithScrollbars"] = 0; };

/**
 * "simple" SC support (Personas 2): Simply remove all scrollbars by expanding the containers to scrollWidth/Height
 * @private
 */
UCF_DTContainer["prototype"]["initScrollContainers"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initScrollContainers"]++; }; 
	if (!this["bScrollContainerSupport"]) return;
	if (this["bScrollContainerSupportAdvanced"]) return;
	this["aScrollContainerList"] = [];

	this["findScrollContainers"](this["oDomRef"], 1);

	for (var i = this["aScrollContainerList"]["length"] - 1; i >= 0; i--) {
		var oSCDom = this["aScrollContainerList"][i];

		if (!this["isInScrollContainersWithScrollbars"](oSCDom["id"])) {
			var oOverflowDiv = UCF_DomUtil["$"](oSCDom["id"] + "-scrl");
			if (oOverflowDiv) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Scrollcontainer: " + oSCDom["id"] + ", setting height to " + oOverflowDiv["scrollHeight"] + "px", "DTContainer.js(227): initScrollContainers"); };
				var w = UCF_UserAgent["bIsChromium"]() ? 20 : 0;
				oOverflowDiv["style"]["height"] = oOverflowDiv["scrollHeight"] + "px";
				oOverflowDiv["style"]["width"] = (oOverflowDiv["scrollWidth"] + w) + "px";
			}
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Scrollcontainer with scrollbars (skipped): " + oSCDom["id"], "DTContainer.js(233): initScrollContainers"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initScrollContainers"] = 0; };

/**
 * @private
 * @param oDomRefNode
 * @param iLevel
 */
UCF_DTContainer["prototype"]["findScrollContainers"] = function(oDomRefNode, iLevel) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["findScrollContainers"]++; }; 
	var oChildren = oDomRefNode["childNodes"];
	for (var i = 0; i < oChildren["length"]; i++) {
		var o = oChildren[i];
		if (o["nodeType"] === 1 && o["getAttribute"]("ct") === "SC") {
			this["aScrollContainerList"]["push"](o);
		}
		this["findScrollContainers"](o, iLevel + 1);
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["findScrollContainers"] = 0; };

/**
 * Init. all RasterLayouts so they will have width/height.
 */
UCF_DTContainer["prototype"]["initRasterLayouts"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initRasterLayouts"]++; }; 
	if (this["sRasterMode"] === "NONE") return;

	this["aRasterLayoutList"] = [];

	// Fills this.aRasterLayoutList
	this["findRasterLayouts"](this["oDomRef"], 1);

	// Workaround for 0px size of RasterLayout
	for (var i = 0; i < this["aRasterLayoutList"]["length"]; i++) {
		var oRLDom = this["aRasterLayoutList"][i]["oDomRef"];
		var oSize = this["aRasterLayoutList"][i]["getInnerSize"]();
		if (oSize["width"]) {
			oRLDom["style"]["width"] = oSize["width"] + "px";
		} else {
			oRLDom["style"]["width"] = "100%";
		}
		if (oSize["height"]) {
			oRLDom["style"]["height"] = oSize["height"] + "px";
		} else {
			oRLDom["style"]["height"] = "100%";
		}

		// 100% width/height for the RL only works in nested case if the parent RLI also has a width/height (Do not overwrite existing values!)
		var oParentRLI = UCF_DomUtil["oGetParentByAttribute"](oRLDom, "ct", "RLI");
		if (oParentRLI && oParentRLI["style"]["width"] === "" && oParentRLI["style"]["height"] === "") {
			oParentRLI["style"]["width"] = "100%";
			oParentRLI["style"]["height"] = "100%";
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initRasterLayouts"] = 0; };

/**
 * Find all RasterLayouts and remember the nesting level.
 * @param {HTMLElement} oDomRefNode
 * @param {int} iLevel
 * @private
 */
UCF_DTContainer["prototype"]["findRasterLayouts"] = function(oDomRefNode, iLevel) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["findRasterLayouts"]++; }; 
	var oChildren = oDomRefNode["childNodes"];
	for (var i = 0; i < oChildren["length"]; i++) {
		var o = oChildren[i];
		// (temp.) workaround: Ignore strange empty RasterLayouts (ITS "updatecontainer")
		if (o["nodeType"] === 1 && o["getAttribute"]("ct") === "RL" && o["id"] !== "updatecontainer") {
			var oRL = this["oGetControlByDomRef"](o, true);
			if (oRL) {
				this["aRasterLayoutList"]["push"](oRL);
				oRL["iDesigntimeLevel"] = iLevel;
			}
		}
		this["findRasterLayouts"](o, iLevel + 1);
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["findRasterLayouts"] = 0; };

UCF_DTContainer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["destroy"]++; }; 

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["InvisibilityChanged"], this);

	this["cleanUpElements"]();

	//this.oLS.detachEvent(this.oLS.E_EVENTS.UpdateDocumentComplete, this);

	this["oCalcContainer"] = null;
	this["oRootRasterLayoutControl"] = null;
	this["oRootRasterLayoutDTElement"] = null;
	this["oResizeGhost"] = null;
	this["oFireToggleSelectOnElement"] = null;
	this["oFireSelectOnElement"] = null;
	this["oUpdateTimer"] = null;
	this["oPosRect"] = null;
	this["oDragSourceRasterLayoutControl"] = null;
	this["oCurrentDragSessionDecoratorSettings"] = null;
	this["oRasterLayoutGridInfo"] = null;

	//UCF_JsUtil.clearDelayedCallsOfObject(this);
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["destroy"] = 0; };

UCF_DTContainer["prototype"]["cleanUpElements"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["cleanUpElements"]++; }; 
	this["aElements"] = null;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["cleanUpElements"] = 0; };

UCF_DTContainer["prototype"]["initElements"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initElements"]++; }; 
	var oDomRefElements = UCF_DomUtil["$"](this["sId"] + "-elements"),
		oIterator = UCF_DomUtil["childNodes"](oDomRefElements);

	this["oCalcContainer"] = this["oDomRef"];

	if (oIterator["length"] > 0) {
		var oElement = null;
		this["aElements"] = [];
		for (var i = 0; i < oIterator["length"]; i++) {
			oElement = this["oLS"]["oControlFactory"]["oGetControlById"](oIterator[i]["getAttribute"]("id"));
			this["aElements"]["push"](oElement);

			// In RasterMode the zindex values are managed internally and initial value is forced to 1
			oElement["init"](this, this["sRasterMode"] !== "NONE" ? this["ZINDEX_LAYERS"]["RASTER_LAYOUT_ELEMENTS"] : i);

			// Reference to the the raster layout is assigned to DT element in RasterMode
			var bIsRasterLayoutElement = false;
			for (var x = 0; x < this["aRasterLayoutList"]["length"]; x++) {
				var oRL = this["aRasterLayoutList"][x];

				if (oElement["sControlIds"] === oRL["sId"]) {
					bIsRasterLayoutElement = true;
					oElement["oMyRasterLayoutControl"] = oRL;
					oElement["iMyRasterLayoutControlLevel"] = oRL["iDesigntimeLevel"];
					if (!this["oRootRasterLayoutControl"]) {
						this["oRootRasterLayoutControl"] = oRL;
						this["oRootRasterLayoutDTElement"] = oElement;
					}

					if (!oElement["sDropTargetInfoTop"]) {
						if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Missing sDropTargetInfoTop for DTElement " + oElement["sId"] + " of RasterLayout " + oRL["sId"], "DTContainer.js(373): initElements"); };
					}
					break;
				}
			}
			if (!bIsRasterLayoutElement && this["sRasterMode"] === "NESTED_RL_DROP_RELATIVE") {
				oElement["setZIndex"](this["ZINDEX_LAYERS"]["CONTROL_ELEMENTS"]);
			}
		}

		// Second phase:
		// For advanced SC support we have to associate each element with its scroll "parent" for relative positioning
		// and to support dragscroll
		if (this["bScrollContainerSupportAdvanced"]) {
			for (i = 0; i < this["aElements"]["length"]; i++) {
				oElement = this["aElements"][i];
				if (oElement["aValidControlIDs"] == null) continue;
				if (oElement["aValidControlIDs"]["length"] === 0) continue;
				//if (oElement.oCalcContainer == null) continue;

				var oTheControl = this["oGetControlById"](oElement["aValidControlIDs"][0]);

				// Support also sub-controls here, e.g. SapTableHeaderCell ...
				if (oTheControl == null) {
					var oDom = UCF_DomUtil["$"](oElement["aValidControlIDs"][0]);
					if (oDom && oDom["getAttribute"]("subct")) {
						var oControlDom = this["oGetParentForAttribute"](oDom, "ct");
						if (oControlDom) {
							oTheControl = this["oGetControlByDomRef"](oControlDom, true);
						}
					}
				}

				if (oTheControl) {
					var findScrollElementForParentControlWithScrollArea = function(oElement, oTheControl, oNext) {
						var oExt = this["oGetDTExtensionForId"](oElement["aValidControlIDs"][0], oElement);
						var oParentSCControl = null;
						if (oNext) {
							oParentSCControl = oNext["oGetParentScrollAreaControl"]();
						} else if (oExt) {
							oParentSCControl = oExt["oGetParentScrollAreaControl"](oElement["aValidControlIDs"][0]);
						} else {
							oParentSCControl = oTheControl["oGetParentScrollAreaControl"]();
						}
						if (oParentSCControl) {
							// Does this control have an associated ScrollElement with scroll-area (overflow)? This is the "parent scroll element"
							for (var j = 0; j < this["aElements"]["length"] && oElement["oMyParentScrollElement"] == null; j++) {
								var oSearchElement = this["aElements"][j];
								if (oSearchElement["bIsScrollElement"] && oSearchElement["oMyScrollContainer"] && oSearchElement["oMyScrollContainer"] === oParentSCControl) {
									oElement["oMyParentScrollElement"] = oSearchElement;
									if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Parent scroll element of " + oElement["sId"] + " is " + oSearchElement["sId"], "DTContainer.js(423): initElements"); };
									// Relocate in DOM
									oElement["oRefContainer"] = UCF_DTElement["oAddLayeredElement"](oElement["oDomRef"], null, oElement["oMyParentScrollElement"]["oDomRef"]);
									// TODO: Check if this is still needed in Personas
									if (oElement["oRefContainer"] && oElement["oRefContainer"]["style"]["zIndex"] == "") {
										oElement["oRefContainer"]["style"]["zIndex"] = oElement["oMyParentScrollElement"]["oDomRef"]["style"]["zIndex"];
									}
									return null;
								}
							}
							return oParentSCControl; // No ScrollElement found for this - try with next parent SC-Control in loop below...
						} else {
							return null;
						}
					}["bind"](this);

					// Support scroll-containers without associated DTElements: Search for any parent SC that has one
					var oNextParentSCControl = null;
					do {
						oNextParentSCControl = findScrollElementForParentControlWithScrollArea(oElement, oTheControl, oNextParentSCControl);
					}
					while (oNextParentSCControl != null);
				}
			}
		}
		oDomRefElements["style"]["display"] = "block";
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initElements"] = 0; };

UCF_DTContainer["prototype"]["oGetParentForAttribute"] = function(oDomRef, sAttribute) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetParentForAttribute"]++; }; 
	while (oDomRef && oDomRef["tagName"] !== "BODY") {
		if (!oDomRef["getAttribute"])
			return null;
		if (oDomRef["getAttribute"](sAttribute)) {
			return oDomRef;
		}
		oDomRef = oDomRef["parentNode"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetParentForAttribute"] = 0; };

UCF_DTContainer["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onkeydown"]++; }; 
	var iKey = oBrowserEvent["iKeyCode"]();

	if (iKey === UCF_KeyCodes["ALT"] && !oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]() && !oBrowserEvent["bRepeat"]()) {
		this["showCoveredElements"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		return;
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onkeydown"] = 0; };

UCF_DTContainer["prototype"]["onkeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onkeyup"]++; }; 
	var iKey = oBrowserEvent["iKeyCode"]();
	if (iKey === UCF_KeyCodes["ALT"] || iKey === UCF_KeyCodes["ESC"]) {
		this["hideCoveredElements"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		return;
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onkeyup"] = 0; };

UCF_DTContainer["prototype"]["showDraggedElements"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showDraggedElements"]++; }; 
	if (this["bIsPersonasEnabled"]()) {
		if (this["aDraggedElementInfos"]) {
			for (var i = 0; i < this["aDraggedElementInfos"]["length"]; i++) {
				var oInfo = this["aDraggedElementInfos"][i];
				if (oInfo["object"]) {
					oInfo["object"]["style"]["opacity"] = oInfo["sOpacity"];
				}
				UCF_DomUtil["addClass"](oInfo["element"]["oDomRef"], "lsDTBorder");
			}
		}
		this["aDraggedElementInfos"] = null;
	}

};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showDraggedElements"] = 0; };

UCF_DTContainer["prototype"]["hideDraggedElements"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hideDraggedElements"]++; }; 
	if (this["bIsPersonasEnabled"]()) {
		if (!this["bDragProgress"]) {
			// Workaround: This function is called delayed in startDrag() with 10ms, which means "in 10ms or later"
			// If the user drags very fast the drag session may already be over and stopDrag() is called in the meantime
			return;
		}
		var aSelElements = this["aListSelectedElements"]();
		this["showDraggedElements"]();
		this["aDraggedElementInfos"] = [];

		for (var i = 0; i < aSelElements["length"]; i++) {
			var oTargetElement = aSelElements[i];
			var oControl = oTargetElement["oGetConnectedControl"]();
			var oInfo = { "element": oTargetElement };
			if (oControl && oControl["oRootRef"]) {
				oInfo["object"] = oControl["oRootRef"];
				oInfo["sOpacity"] = oControl["oRootRef"]["style"]["opacity"];
				oControl["oRootRef"]["style"]["opacity"] = "0.001";
			}
			this["aDraggedElementInfos"]["push"](oInfo);
			UCF_DomUtil["removeClass"](oTargetElement["oDomRef"], "lsDTBorder");

		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hideDraggedElements"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["showCoveredElements"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showCoveredElements"]++; }; 
	var aSelElements = this["aListSelectedElements"]();
	this["hideCoveredElements"]();
	this["oCoveredElementInfos"] = [];
	var isPointInRect = function(x, y, oRect) {
		return (x >= oRect["left"] &&
			x <= oRect["right"] &&
			y >= oRect["top"] &&
			y <= oRect["bottom"]);
	};
	for (var i = 0; i < aSelElements["length"]; i++) {
		var oTargetElement = aSelElements[i];
		var oControl = oTargetElement["oGetConnectedControl"]();
		if (oControl) {
			var oCoveredElementInfo = {};
			oCoveredElementInfo["oElement"] = oControl["oRootRef"];
			oCoveredElementInfo["sOpacity"] = oCoveredElementInfo["oElement"]["style"]["opacity"];
			var oRect = oTargetElement["oGetObjectRect"]();
			oRect["right"] = oRect["left"] + oRect["width"];
			oRect["bottom"] = oRect["top"] + oRect["height"];
			oCoveredElementInfo["aElements"] = [];
			//var bFound = false;
			this["loopElements"](function(oDTContainer, oElement) {
				if (oElement == oTargetElement) return;
				var oCheckRect = oElement["oGetObjectRect"]();
				oCheckRect["right"] = oCheckRect["left"] + oCheckRect["width"];
				oCheckRect["bottom"] = oCheckRect["top"] + oCheckRect["height"];

				if (isPointInRect(oCheckRect["left"], oCheckRect["top"], oRect) ||
					isPointInRect(oCheckRect["left"], oCheckRect["bottom"], oRect) ||
					isPointInRect(oCheckRect["right"], oCheckRect["top"], oRect) ||
					isPointInRect(oCheckRect["right"], oCheckRect["bottom"], oRect)) {
					var oInfo = { "object": oElement, "zIndex": oElement["iZIndex"] };
					oCoveredElementInfo["aElements"]["push"](oInfo);
					oElement["setZIndex"](oTargetElement["iZIndex"] + 1);
					if (oElement["oGetConnectedControl"]()) {
						oInfo["sOpacity"] = oElement["oGetConnectedControl"]()["oRootRef"]["style"]["opacity"];
						oElement["oGetConnectedControl"]()["oRootRef"]["style"]["opacity"] = "0.5";
					}
					//bFound = true;
				}
			});
			oCoveredElementInfo["oElement"]["style"]["opacity"] = "0.5";
			this["oCoveredElementInfos"]["push"](oCoveredElementInfo);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showCoveredElements"] = 0; };

UCF_DTContainer["prototype"]["hideCoveredElements"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hideCoveredElements"]++; }; 
	if (this["oCoveredElementInfos"]) {
		for (var i = 0; i < this["oCoveredElementInfos"]["length"]; i++) {
			var oCoveredElementInfo = this["oCoveredElementInfos"][i];
			for (var j = 0; j < oCoveredElementInfo["aElements"]["length"]; j++) {
				var oElementInfo = oCoveredElementInfo["aElements"][j];
				oElementInfo["object"]["setZIndex"](oElementInfo["zIndex"]);
				if (oElementInfo["object"]["oGetConnectedControl"]()) {
					oElementInfo["object"]["oGetConnectedControl"]()["oRootRef"]["style"]["opacity"] = oElementInfo["sOpacity"];
				}
			}
			oCoveredElementInfo["oElement"]["style"]["opacity"] = oCoveredElementInfo["sOpacity"];
		}
	}
	this["oCoveredElementInfos"] = null;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hideCoveredElements"] = 0; };

UCF_DTContainer["prototype"]["selectElement"] = function(oDTElement, bToggle) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["selectElement"]++; }; 
	this["handleElementMouseDown"](oDTElement, bToggle);
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["selectElement"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["handleElementMouseDown"] = function(oDTElement, bToggle) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleElementMouseDown"]++; }; 
	this["bFireCommmit"] = true;
	this["hideCoveredElements"]();
	if (oDTElement["bIsSelectable"]()) {
		if (bToggle) {
			this["oFireToggleSelectOnElement"] = oDTElement;
			return;
		}
		if (!oDTElement["bIsSelected"]()) {
			// Visualize selected state in browser. Server state change and UI-update will be triggered by mouseup (CommitSelection event)
			this["deselectAll"]();
			if (oDTElement["fireExtensionEvent"](oDTElement["EXTENSION_EVENT"]["onElementSelect"], "before")) return;
			oDTElement["toggleSelection"]();
			this["fireSelect"](this["sId"], oDTElement["sId"], this["ACCESS_TYPE"]["STANDARD"]);
			if (oDTElement["fireExtensionEvent"](oDTElement["EXTENSION_EVENT"]["onElementSelect"], "after")) return;
		} else {
			if (this["bHasMultiSelection"]()) {
				// Click on already selected element of multi-selection
				this["oFireSelectOnElement"] = oDTElement;
			} else {
				// Single element was already selected (no multi-selection):
				// do nothing here AND in handleMouseUp() !
				this["bFireCommmit"] = false;
				oDTElement["displayResizeHandles"](true);
			}
		}
	} else {
		if (!bToggle) {
			this["deselectAll"]();
			this["fireSelect"](this["sId"], "", this["ACCESS_TYPE"]["DESELECT_ALL"]);
		} else {
			// Ctrl-click on unselectable element will not cause any event
			this["bFireCommmit"] = false;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleElementMouseDown"] = 0; };

UCF_DTContainer["prototype"]["handleMouseUp"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleMouseUp"]++; }; 
	if (this["oFireToggleSelectOnElement"]) {
		this["oFireToggleSelectOnElement"]["toggleSelection"]();
		this["updateResizeHandles"]();
		this["fireSelect"](this["sId"], this["oFireToggleSelectOnElement"]["sId"], this["ACCESS_TYPE"]["TOGGLE"]);
		this["oFireToggleSelectOnElement"] = null;
	} else if (this["oFireSelectOnElement"]) {
		this["fireSelect"](this["sId"], this["oFireSelectOnElement"]["sId"], this["ACCESS_TYPE"]["STANDARD"]);
		var oElement = this["oFireSelectOnElement"];
		this["deselectAll"]();
		oElement["toggleSelection"]();
		this["oFireSelectOnElement"] = null;
	}

	// Update ActionMenus
	this["loopElements"](function(oDTContainer, oElement) {
		oElement["hideActionMenu"]();
	});
	//if (!this.bHasMultiSelection()) {
	this["loopElements"](function(oDTContainer, oElement) {
		oElement["showActionMenu"]();
	});
	//}

	this["updateHitZones"]();
	if (this["bFireCommmit"]) {
		this["fireCommitSelection"](this["sId"]);
		this["bFireCommmit"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleMouseUp"] = 0; };

UCF_DTContainer["prototype"]["handleDDCancel"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleDDCancel"]++; }; 
	this["oFireToggleSelectOnElement"] = null;
	this["oFireSelectOnElement"] = null;

	if (this["bFireCommmit"]) {
		this["fireCommitSelection"](this["sId"]);
		this["bFireCommmit"] = false;
	}

	this["handleGridModeSingleSelection"]();
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleDDCancel"] = 0; };

UCF_DTContainer["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onAnyEvent"]++; }; 
	var oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent");
	if (oBrowserEvent["sGetName"]() === "mouseup" && oBrowserEvent["eGetMouseButtonState"]() === oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"]) {
		this["handleMouseUp"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onAnyEvent"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["bHasMultiSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bHasMultiSelection"]++; }; 
	if (!this["aElements"]) {
		return false;
	}
	var iCount = 0;
	for (var i = 0; i < this["aElements"]["length"] && iCount < 2; i++) {
		var oElement = this["aElements"][i];
		if (oElement["bIsSelected"]()) iCount++;
	}
	return (iCount > 1);
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bHasMultiSelection"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["getSelectedElements"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["getSelectedElements"]++; }; 
	return this["aListSelectedElements"]();
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["getSelectedElements"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["updateResizeHandles"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["updateResizeHandles"]++; }; 
	var aSelected = this["aListSelectedElements"]();
	if (aSelected["length"] === 0) {
		return;
	}

	if (this["bHasMultiSelection"]()) {
		// Hide resize handles of all selected elements
		for (var i = 0; i < aSelected["length"]; i++) {
			aSelected[i]["displayResizeHandles"](false);
		}
	} else {
		// Ensure resize handles are shown for the single element
		// This is for the case when you start with multi-selection and deselect until only a single element is selected
		aSelected[0]["displayResizeHandles"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["updateResizeHandles"] = 0; };

/**
 * Returns an array of DTElement controls with state 'SELECTED'.
 * @returns {Array.<UCF_DTElement>} An array of elements
 * @public
 */
UCF_DTContainer["prototype"]["aListSelectedElements"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["aListSelectedElements"]++; }; 
	var aResult = [];
	if (!this["aElements"]) return aResult;
	for (var i = 0; i < this["aElements"]["length"]; i++) {
		var oElement = this["aElements"][i];
		if (!oElement["bInitError"] && oElement["bIsSelected"]()) aResult["push"](oElement);
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["aListSelectedElements"] = 0; };

UCF_DTContainer["prototype"]["deselectAll"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["deselectAll"]++; }; 
	if (!this["aElements"]) {
		return;
	}
	for (var i = 0; i < this["aElements"]["length"]; i++) {
		var oDTElement = this["aElements"][i],
			oSelectedElement = null;
		if (!oDTElement["bIsValid"]()) {
			continue;
		}
		if (oDTElement["bIsSelected"]()) {
			oSelectedElement = oDTElement;
			if (oDTElement["fireExtensionEvent"](oDTElement["EXTENSION_EVENT"]["onElementDeselect"], "before")) return;
		}
		oDTElement["setSelectionState"](oDTElement["eSelectionState"]["NONE"]);
		if (oSelectedElement) {
			if (oDTElement["fireExtensionEvent"](oDTElement["EXTENSION_EVENT"]["onElementDeselect"], "after")) return;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["deselectAll"] = 0; };

UCF_DTContainer["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onLayoutChange"]++; }; 
	if (this["bIsPersonasEnabled"]()) {

		//keep the page scroll
		var oPage = this["oLS"]["oGetPageInternal"]();
		if (oPage) {
			if (oPage["oScrollArea"]) {
				var oScrollPos = oPage["oScrollArea"]["oGetScrollPosition"]();
				oPage["oScrollArea"]["setIgnoreScrollEvent"](true);
			}
		}

		//force a repaint of DTContainer. weired behavior in chrome in some cases.
		this["oDomRef"]["style"]["display"] = "none";
		this["oDomRef"]["offsetHeight"]; // eslint-disable-line no-unused-expressions
		this["oDomRef"]["style"]["display"] = "block";
		if (this["getClientControl"]() && this["getClientControl"]()["getUCFInstance"]()) {
			this["updatePositions"]();
		}

		if (this["oLS"] && oPage && !this["bIsDestoyed"]) {
			if (oPage["oScrollArea"]) {
				//reset the page scroll
				oPage["oScrollArea"]["setScrollPosition"](oScrollPos["top"], oScrollPos["left"]);
				oPage["oScrollArea"]["setIgnoreScrollEvent"](false);
			}
		}
	} else {
		this["updatePositions"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onLayoutChange"] = 0; };

/**
 * Update positions of all DTElements according to the connected controls.
 * @param {boolean} bDelayed Specifies that this call was done via UCF_JsUtil.delayedCall()
 * @public
 */
UCF_DTContainer["prototype"]["updatePositions"] = function(bDelayed) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["updatePositions"]++; }; 
	if (!this["aElements"]) {
		return;
	}

	if (!bDelayed) {
		if (this["oUpdateTimer"]) {
			UCF_JsUtil["clearDelayedCall"](this["oUpdateTimer"]);
		}
		this["oUpdateTimer"] = UCF_JsUtil["delayedCall"](1, this, "updatePositions", [true]);
		return;
	}

	// If this call of updatePositions was delayed and LS is locked, discard it
	if (this["oLS"]["bLocked"]()) {
		return;
	}
	this["oUpdateTimer"] = null;

	this["initScrollContainers"]();
	this["initRasterLayouts"]();

	this["oPositioningLoopContext"] = {};
	var i;
	for (i = 0; i < this["aElements"]["length"]; i++) {
		if (!this["aElements"][i]["bInitError"]) {
			this["aElements"][i]["updateMyContentReferences"]();
		}
	}
	for (i = 0; i < this["aElements"]["length"]; i++) {
		if (!this["aElements"][i]["bIsHidden"]) {
			this["aElements"][i]["updatePositionInternal"]();
		}
	}
	this["oPositioningLoopContext"] = null;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["updatePositions"] = 0; };

UCF_DTContainer["prototype"]["showPositionByBrowserEvent"] = function(oBrowserEvent, oTargetElement) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showPositionByBrowserEvent"]++; }; 
	var oPosition = { "left": oBrowserEvent["iPageX"](), "top": oBrowserEvent["iPageY"]() };
	//oNewRect = {left: oBrowserEvent.iPageX(), top:oBrowserEvent.iPageY()},
	var oGhost = oBrowserEvent["oDragAndDropManager"]["oDragSession"]["oGetGhost"]();
	if (oGhost) {
		oPosition["left"] += oGhost["iOffsetLeft"];
		oPosition["top"] += oGhost["iOffsetTop"];
	}
	this["showPosition"](oPosition["left"], oPosition["top"], oTargetElement);
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showPositionByBrowserEvent"] = 0; };

UCF_DTContainer["prototype"]["showPosition"] = function(iX, iY, oTargetElement) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showPosition"]++; }; 
	if (
		__UCF_DEBUG__ &&
		!oTargetElement["bIsHidden"] &&
		this["bIsPersonasEnabled"]()
	) {
		this["oPosRect"] = UCF_DomUtil["$"]("ls-debug-show-position");
		if (!this["oPosRect"]) {
			var oPos = document["createElement"]("DIV");
			oPos["setAttribute"]("id", "ls-debug-show-position");
			oPos["className"] = "lsDTMovePosition";
			this["oPosRect"] = oPos;
			document["body"]["appendChild"](oPos);
		}
		var oRect = this["oGetObjectRect"](oTargetElement["oDomRef"]);
		this["oPosRect"]["style"]["top"] = (oRect["top"] - 14) + "px";
		this["oPosRect"]["style"]["left"] = (oRect["left"] - 1) + "px";
		this["oPosRect"]["style"]["display"] = "block";
		this["oPosRect"]["style"]["width"] = Math["min"](oRect["width"], 100) + "px";
		if (oTargetElement["oGetConnectedControl"]) {
			// eslint-disable-next-line no-unsanitized/property
			this["oPosRect"]["innerHTML"] = (iX - oRect["left"]) + "x" + (iY - oRect["top"]) + ":" + oTargetElement["oGetConnectedControl"]()["sId"];
		} else {
			// eslint-disable-next-line no-unsanitized/property
			this["oPosRect"]["innerHTML"] = (iX) + "," + (iY);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showPosition"] = 0; };

UCF_DTContainer["prototype"]["hidePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hidePosition"]++; }; 
	if (
		__UCF_DEBUG__ &&
		this["bIsPersonasEnabled"]() &&
		this["oPosRect"]
	) {
		this["oPosRect"]["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hidePosition"] = 0; };

/**
 * Raster-mode: Prepare the elements for special DD-mode with raster layout
 * @param {HTML_Element} oDraggedElement
 * @param {string} sControlID
 * @private
 */
UCF_DTContainer["prototype"]["initRasterDD"] = function(oDraggedElement, sControlID) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initRasterDD"]++; }; 
	// Z-Index:
	//
	// NESTED_RL_DROP_ON_ELEMENT:
	// All DTElements for RasterLayout controls need to be in front of all other DT elements and
	// they need to be layered according to their nesting in the DOM
	//
	// NESTED_RL_DROP_RELATIVE:
	// Only the DTElement of the root RasterLayout is in front of everything else
	if (this["sRasterMode"] == "NESTED_RL_DROP_RELATIVE") {
		// Find the RasterLayout that the control of this DTElement belongs to
		var oRLDom = UCF_DomUtil["oGetParentByAttribute"](UCF_DomUtil["$"](sControlID), "ct", "RL");
		if (oRLDom) {
			// There is no drag session yet (!?)
			//this.oLS.oGetDragSession().oDragSourceRasterLayoutControl = this.oGetControlByDomRef(oRLDom);
			this["oDragSourceRasterLayoutControl"] = this["oGetControlByDomRef"](oRLDom, true);

			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "oDragSourceRasterLayoutControl=" + this["oDragSourceRasterLayoutControl"]["sGetId"](), "DTContainer.js(916): initRasterDD"); };
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Cannot drag control " + sControlID + ". It is not contained in a RasterLayout", "DTContainer.js(918): initRasterDD"); };
			return;
		}

		// With client-side-rendering the RasterLayout maybe re-rendered while the DTContainer is not (for some unknown reason) => Update the invalid reference
		if (!this["oRootRasterLayoutControl"]["oRootRef"]) {
			this["oRootRasterLayoutControl"] = this["oGetControlById"](this["oRootRasterLayoutControl"]["sId"]);
		}
		this["oRootRasterLayoutControl"]["showGrid"]();
		this["oRootRasterLayoutDTElement"]["setZIndex"](this["ZINDEX_LAYERS"]["DD_ROOT_RL_ELEMENT"]);
	} else {
		//
		// This "feature" is no longer needed - the same effect is achieved by hideNoneMatchingElements()
		// Workaround: It is only used for Personas ITS editor version "before refactoring"
		//
		if (sap && sap["personas"] && sap["personas"]["core"] && sap["personas"]["core"]["ITSFacade"]) {
			for (var i = 0; i < this["aElements"]["length"]; i++) {
				var oDE = this["aElements"][i];
				if (!oDE["bInitError"] && oDE["oMyRasterLayoutControl"]) {
					oDE["setZIndex"](this["ZINDEX_LAYERS"]["DD_ROOT_RL_ELEMENT"] + oDE["iMyRasterLayoutControlLevel"]);
					// In combination with AdvancedScrollContainerSupport we have to take into account the SC-elements for the zindex modification
					// The SC-element gets the minimum (first) zIndex value of all contained RasterLayout-elements
					if (oDE["oMyParentScrollElement"] && oDE["oMyParentScrollElement"]["bZIndexModified"] == false) {
						//console.log(">>> initRasterDD: e=" + oDE.sId + ", old=" + oDE.oMyParentScrollElement.oDomRef.style.zIndex + ", new=" + oDE.oDomRef.style.zIndex);
						oDE["oMyParentScrollElement"]["oDomRef"]["style"]["zIndex"] = oDE["oDomRef"]["style"]["zIndex"];
						oDE["oMyParentScrollElement"]["bZIndexModified"] = true;
					}
				}
				// Hack for Toolbar items to make ToolbarDTExtension work with themes that do not have space between the items/buttons (=blue-crystal)
				if (oDE["oGetConnectedControl"]()["oGetParent"]()["sClassName"] == "UCF_Toolbar") {
					if (oDE !== oDraggedElement) oDE["hide"]();
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["initRasterDD"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["endRasterDD"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["endRasterDD"]++; }; 
	if (this["sRasterMode"] == "NESTED_RL_DROP_RELATIVE") {
		this["oDragSourceRasterLayoutControl"] = null;
		this["oRootRasterLayoutControl"]["hideGrid"]();
		this["oRootRasterLayoutDTElement"]["setZIndex"](this["ZINDEX_LAYERS"]["RASTER_LAYOUT_ELEMENTS"]);
	} else {
		if (sap && sap["personas"] && sap["personas"]["core"] && sap["personas"]["core"]["ITSFacade"]) {
			for (var i = 0; i < this["aElements"]["length"]; i++) {
				var oDE = this["aElements"][i];
				if (oDE["oMyRasterLayoutControl"]) {
					if (!oDE["oMyRasterLayoutControl"]["bIsValid"]()) {
						oDE["oMyRasterLayoutControl"] = this["oGetControlById"](oDE["oMyRasterLayoutControl"]["sId"]);
					}
					oDE["oMyRasterLayoutControl"]["hideGrid"]();
					oDE["setZIndex"](this["ZINDEX_LAYERS"]["RASTER_LAYOUT_ELEMENTS"]);
					if (oDE["oMyParentScrollElement"] && oDE["oMyParentScrollElement"]["bZIndexModified"]) {
						oDE["oMyParentScrollElement"]["setZIndex"](this["ZINDEX_LAYERS"]["CONTROL_ELEMENTS"]);
						oDE["oMyParentScrollElement"]["bZIndexModified"] = false;
					}
				}

				if (oDE["oGetConnectedControl"]()["oGetParent"]()["sClassName"] == "UCF_Toolbar") {
					oDE["show"]();
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["endRasterDD"] = 0; };

/**
 * Lazy creation of a resize ghost element. Initial position and size is that of the given DT element.
 * @private
 * @returns.
 */
UCF_DTContainer["prototype"]["oInitResizeGhost"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oInitResizeGhost"]++; }; 
	var style;
	if (this["oResizeGhost"] == null) {
		this["oResizeGhost"] = window["document"]["createElement"]("DIV");
		style = this["oResizeGhost"]["style"];
		style["border"] = "2px dashed rgba(138, 196, 250, 0.9)";
		style["borderRadius"] = "2px";
		style["position"] = "absolute";
		style["display"] = "block";
		style["boxSizing"] = "border-box";
		style["zIndex"] = oDTElement["iGetDOMZIndex"]() + this["ZINDEX_RESIZE"]["GHOST"];
		style["backgroundColor"] = "rgba(255,255,255, 0.3)";
		//	    if (oDTElement.oRefContainer) {
		//	    	oDTElement.oRefContainer.appendChild(this.oResizeGhost);
		//	    }
		//	    else {
		UCF_DomUtil["$"](this["sId"] + "-elements")["appendChild"](this["oResizeGhost"]);
		//	    }
	}
	// This is an offset so the rounded corners look nice
	// Must take into account when calculating event parameters in DTElement.stopResize() !!!
	var o = UCF_DTContainer["SELRECT_OFF"];

	var w = oDTElement["oDomRef"]["offsetWidth"] + 2 * o;
	var h = oDTElement["oDomRef"]["offsetHeight"] + 2 * o;

	style = this["oResizeGhost"]["style"];
	style["display"] = "block";

	// Position relative to the DTContainer because the ghost was appended to the list of DTElements
	var oAbsRect = UCF_DomUtil["oGetObjectRect"](oDTElement["oDomRef"], this["oDomRef"]);
	style["top"] = (oAbsRect["top"] - o) + "px";
	style["left"] = (oAbsRect["left"] - o) + "px";
	style["width"] = w + "px";
	style["height"] = h + "px";

	return this["oResizeGhost"];
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oInitResizeGhost"] = 0; };

UCF_DTContainer["prototype"]["releaseResizeGhost"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["releaseResizeGhost"]++; }; 
	// if (false) {
	// 	// Reuse single DOM element
	// 	// ==> TODO remove this.oResizeGhost and use only DOM
	// 	this.oResizeGhost.style.display = "none";
	// 	this.oResizeGhost.style.top = "-10000px";
	// }
	// else {
	this["oResizeGhost"]["parentNode"]["removeChild"](this["oResizeGhost"]);
	this["oResizeGhost"] = null;
	//}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["releaseResizeGhost"] = 0; };

/**
 * Handles the onlscontainerfocus event: Break the tab-chain so that content can not be reached via tab.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DTContainer["prototype"]["onlscontainerfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onlscontainerfocus"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource !== this["oDomRef"] && UCF_DomUtil["bContains"](this["oDomRef"], oSource)) {
		var oFocusTo = null;
		var oPrevious = UCF_DomUtil["oGetPreviousSibling"](this["oDomRef"], true);
		if (oPrevious) oFocusTo = UCF_DomUtil["oGetTabbableElementBackward"](oPrevious, true);
		if (oFocusTo) {
			UCF_DomUtil["focusDomElement"](oFocusTo);
		} else {
			this["oLS"]["focusEnd"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onlscontainerfocus"] = 0; };

/**
 * Handles the onlsfocus event: Break the tab-chain so that content can not be reached via tab.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DTContainer["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onlsfocus"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();

	// Do not handle focus events that are caused by element selection and config buttons
	if (oSource["id"] && (oSource["id"]["indexOf"]("-hover") > 0 || oSource["id"]["indexOf"]("-buttonrow") > 0 || oSource["id"]["indexOf"]("-config") > 0 || oSource["id"]["indexOf"]("-close") > 0)) {
		return;
	}

	var oFocusTo = null;
	if (oSource === this["oDomRef"]) {
		var oNext = UCF_DomUtil["oGetNextSibling"](this["oDomRef"], true);
		if (oNext) oFocusTo = UCF_DomUtil["oGetTabbableElementForward"](oNext, true);
	}
	// else {
	// 	var oPrevious = UCF_DomUtil.oGetPreviousSibling(this.oDomRef, true);
	// 	if(oPrevious) oFocusTo = UCF_DomUtil.oGetTabbableElementBackward(oPrevious, true);
	// }
	if (oFocusTo) {
		UCF_DomUtil["focusDomElement"](oFocusTo);
	} else {
		this["oLS"]["focusEnd"]();
	}

};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onlsfocus"] = 0; };

/**
 * Returns the DTElement control that is associated with the given control ID.
 * @param {string} sControlId The control ID
 * @param {boolean} bIncludeSubControls Also returns UCF_ControlInfo instances
 * @return {UCF_DTElement?} The element instance or null
 * @public
 */
UCF_DTContainer["prototype"]["oGetDTElement"] = function(sControlId, bIncludeSubControls) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetDTElement"]++; }; 
	for (var i = 0; i < this["aElements"]["length"]; i++) {
		if (this["aElements"][i]["oGetConnectedControl"]() && this["aElements"][i]["oGetConnectedControl"]()["sGetId"]() === sControlId && !this["aElements"][i]["bIsScrollElement"] ||
			bIncludeSubControls === true && this["aElements"][i]["bHasConnectedSubControl"]() && this["aElements"][i]["aValidControlIDs"][0] === sControlId) {
			return this["aElements"][i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetDTElement"] = 0; };

/**
 * Returns the DTElement with IsScrollElement=true that is associated with the given control ID.
 * @param {string} sControlId The control ID
 * @return {UCF_DTElement?} The element instance or null
 * @public
 */
UCF_DTContainer["prototype"]["oGetScrollDTElement"] = function(sControlId) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetScrollDTElement"]++; }; 
	for (var i = 0; i < this["aElements"]["length"]; i++) {
		if (this["aElements"][i]["oGetConnectedControl"]() && this["aElements"][i]["oGetConnectedControl"]()["sGetId"]() === sControlId && this["aElements"][i]["bIsScrollElement"]) {
			return this["aElements"][i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetScrollDTElement"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["getDTElement"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["getDTElement"]++; }; 
	if (oControl) {
		return this["oGetDTElement"](oControl["sGetId"]());
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["getDTElement"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["oGetDTElementById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetDTElementById"]++; }; 
	for (var i = 0; i < this["aElements"]["length"]; i++) {
		if (this["aElements"][i]["sId"] == sId) {
			return this["aElements"][i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetDTElementById"] = 0; };

/**
 * @private
 * @param oDomRef
 * @param iOpacity
 */
UCF_DTContainer["prototype"]["setOpacity"] = function(oDomRef, iOpacity) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["setOpacity"]++; }; 
	UCF_DomUtil["setOpacityStyle"](oDomRef, iOpacity);
	// Crazy workaround for IE embedded in eclipse (WDAiE): Use filter property although IE is in Standards Mode
	if ((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && UCF_UserAgent["bIsStandardsMode"]()) {
		if (oDomRef["style"]["opacity"] == 0 && (iOpacity / 100) > 0) {
			oDomRef["style"]["filter"] = (iOpacity === 100 ? "" : "alpha(opacity=" + (iOpacity < 10 ? "0" : "") + iOpacity + ")");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["setOpacity"] = 0; };

/**
 * @private
 * @param oBrowserEvent
 */
UCF_DTContainer["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onmousedown"]++; }; 
	var sTheId = oBrowserEvent["oGetSource"]()["id"] || "";
	if (this["bEnableRectangleSelection"] && oBrowserEvent["bShift"]() && sTheId["indexOf"]("-resizehandle-") === -1) {
		// Start of rectangle-selection: Do not set/change the focus
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		this["startSelectionRectangle"](oBrowserEvent["iPageX"](), oBrowserEvent["iPageY"]());
		this["hideHitZones"]();
	} else {
		if (sTheId["indexOf"]("-resizehandle-") > -1) {
			var aElements = this["getSelectedElements"]();
			if (aElements["length"] == 1) {
				var oElement = aElements[0];
				this["hideHitZones"]();
				oElement["startResize"](sTheId, oBrowserEvent["iScreenX"](), oBrowserEvent["iScreenY"]());
				oBrowserEvent["cancelBubble"]();
				oBrowserEvent["cancel"]();
				return;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onmousedown"] = 0; };

UCF_DTContainer["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onlsdragstart"]++; }; 
	var sTheId = oBrowserEvent["oGetSource"]()["id"];
	if (sTheId) {
		var redirectDragStartToElement = function(oElement, oBrowserEvent) {
			oElement["createDragDelegate"](oBrowserEvent);
			oBrowserEvent["oDragAndDropManager"]["sDragSourceId"] = oElement["sId"] + "-hover"; //pipeline the source to the dt elements hover div
			if (oElement["oDragDelegate"]) {
				oBrowserEvent["oSourceControl"] = oElement;
				oElement["oDragDelegate"]["onlsdragstart"](oBrowserEvent);
			}
		};

		// 1. Enable dragging with "HitZone" DIVs
		// 2. Personas for WebGUI: Workaround for unselectable RasterLayouts, see also DTElement.onmousedown()
		var oDraggedElement = null;
		if (sTheId["indexOf"]("-hover") > -1) {
			oDraggedElement = this["oGetDTElementById"](sTheId["replace"]("-hover", ""));
		}
		if (sTheId["indexOf"]("-move-") > -1 ||
			this["bIsPersonasEnabled"]() && oDraggedElement && !oDraggedElement["bIsSelectable"]() && oDraggedElement["oGetConnectedControl"]() && oDraggedElement["oGetConnectedControl"]()["sClassName"] == "UCF_RasterLayout") {
			var aElements = this["getSelectedElements"]();
			if (aElements["length"] === 1) {
				redirectDragStartToElement(aElements[0], oBrowserEvent);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onlsdragstart"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["onSelectionHandleMouseUp"] = function(oDomEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onSelectionHandleMouseUp"]++; }; 
	this["stopSelectionRectangle"]();
	oDomEvent["cancelBubble"] = true;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onSelectionHandleMouseUp"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["onSelectionHandleMouseMove"] = function(oDomEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onSelectionHandleMouseMove"]++; }; 
	/** @type {UCF_BrowserEvent} */
	// eslint-disable-next-line @ur/no-memory-leaks
	var oBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oDomEvent);

	this["calculateRectangleAndSelection"](oBrowserEvent);

	oBrowserEvent["destroy"]();
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["onSelectionHandleMouseMove"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["startSelectionRectangle"] = function(iStartX, iStartY) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["startSelectionRectangle"]++; }; 
	var that = this;
	this["handleEvent"] = function(oDomEvent) { // eslint-disable-line @ur/no-memory-leaks
		switch (oDomEvent["type"]) {
			case "mousemove":
				that["onSelectionHandleMouseMove"](oDomEvent);
				break;
			case "mouseup":
				that["onSelectionHandleMouseUp"](oDomEvent);
				break;
		}
	};

	UCF_DomUtil["attachEvent"](document["body"], "mousemove", this["handleEvent"], true);
	UCF_DomUtil["attachEvent"](document["body"], "mouseup", this["handleEvent"], true);

	this["oLS"]["oBrowserWindow"]["lock"](UCF_BrowserWindow["LOCKTYPES"]["DRAGDROP"]);

	if (UCF_UserAgent["bIsChromium"]()) UCF_DomUtil["addClass"](document["body"], "urNoUserSelect");
	UCF_DomUtil["removeSelection"](); //Found in DDManager - what is it for ???

	this["oSelectionRectangleSession"] = {};
	this["oSelectionRectangleSession"]["aCurrentSelection"] = [];
	this["oSelectionRectangleSession"]["oRect"] = { "x": 0, "y": 0, "width": 0, "height": 0 };
	this["oSelectionRectangleSession"]["oDomRectangle"] = this["oInitSelectionRectangle"](iStartX, iStartY);
	this["oSelectionRectangleSession"]["iStartX"] = iStartX;
	this["oSelectionRectangleSession"]["iStartY"] = iStartY;

	this["deselectAll"]();

	// We need the absolute positions of all elements
	// (already calculated positions during init may be relative to a parent scrollcontainer)
	this["loopElements"](function(oDTContainer, oElement) { oElement["calculateAbsoluteRect"](); });

};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["startSelectionRectangle"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["stopSelectionRectangle"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["stopSelectionRectangle"]++; }; 
	UCF_DomUtil["detachEvent"](document["body"], "mousemove", this["handleEvent"], true);
	UCF_DomUtil["detachEvent"](document["body"], "mouseup", this["handleEvent"], true);

	this["oLS"]["oBrowserWindow"]["unlock"](UCF_BrowserWindow["LOCKTYPES"]["DRAGDROP"]);

	if (UCF_UserAgent["bIsChromium"]()) UCF_DomUtil["removeClass"](document["body"], "urNoUserSelect");

	var oRecStyle = this["oSelectionRectangleSession"]["oDomRectangle"]["style"];
	oRecStyle["display"] = "none";
	oRecStyle["top"] = "-10000px";

	this["updateResizeHandles"]();
	this["fireSelect"](this["sId"], this["oSelectionRectangleSession"]["aCurrentSelection"]["join"](" "), this["ACCESS_TYPE"]["LIST"]);
	this["fireCommitSelection"](this["sId"]);

	this["oSelectionRectangleSession"] = null;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["stopSelectionRectangle"] = 0; };

/**
 * Lazy creation of a selection ghost element.
 * @private
 * @returns.
 */
UCF_DTContainer["prototype"]["oInitSelectionRectangle"] = function(iStartX, iStartY) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oInitSelectionRectangle"]++; }; 
	var oSelRect = UCF_DomUtil["$"](this["ID_SEL_RECT"]);
	var style;
	if (oSelRect == null) {
		oSelRect = window["document"]["createElement"]("DIV");
		oSelRect["id"] = this["ID_SEL_RECT"];
		style = oSelRect["style"];
		style["border"] = "2px dashed rgba(138, 196, 250, 0.9)";
		style["borderRadius"] = "2px";
		style["position"] = "absolute";
		style["display"] = "block";
		style["zIndex"] = UCF_LS["E_LAYERS"]["CONTROLS"] + 1000; // DTElements have "+ 500"
		style["backgroundColor"] = "transparent"; //"#FFFFFF";
		//this.setOpacity(this.oSelectionRectangle, 60);
		this["oLS"]["oGetAssociatedAreaRef"]()["appendChild"](oSelRect);
		//oSelRect.innerHTML = "<div style\"position:abso>"
	} else {
		style = oSelRect["style"];
		style["display"] = "block";
		style["top"] = iStartY + "px";
		style["left"] = iStartX + "px";
		style["width"] = "0px";
		style["height"] = "0px";
	}
	return oSelRect;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oInitSelectionRectangle"] = 0; };

/**
 * Calculate the new rectangle and all elements that are selected.
 * @private
 */
UCF_DTContainer["prototype"]["calculateRectangleAndSelection"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["calculateRectangleAndSelection"]++; }; 
	this["oSelectionRectangleSession"]["oRect"]["height"] = Math["abs"](this["oSelectionRectangleSession"]["iStartY"] - oBrowserEvent["iPageY"]());
	this["oSelectionRectangleSession"]["oRect"]["width"] = Math["abs"](this["oSelectionRectangleSession"]["iStartX"] - oBrowserEvent["iPageX"]());
	this["oSelectionRectangleSession"]["oRect"]["y"] = Math["min"](this["oSelectionRectangleSession"]["iStartY"], oBrowserEvent["iPageY"]());
	this["oSelectionRectangleSession"]["oRect"]["x"] = Math["min"](this["oSelectionRectangleSession"]["iStartX"], oBrowserEvent["iPageX"]());

	// Size limits to avoid enlarging the body document and causing scrollbars to apear
	// TODO: RTL...
	// TODO: Automatic scrolling...
	var iDist = 5;
	var oScrollOffset = UCF_DomUtil["oGetScrollOffset"]();
	var iBodyScrollLeft = oScrollOffset["x"];
	if (this["oSelectionRectangleSession"]["oRect"]["x"] - iBodyScrollLeft + this["oSelectionRectangleSession"]["oRect"]["width"] > UCF_DomUtil["iClientWidth"]() - iDist) {
		this["oSelectionRectangleSession"]["oRect"]["width"] = UCF_DomUtil["iClientWidth"]() - this["oSelectionRectangleSession"]["oRect"]["x"] + iBodyScrollLeft - iDist;
	}
	var iBodyScrollTop = oScrollOffset["y"];
	if (this["oSelectionRectangleSession"]["oRect"]["y"] - iBodyScrollTop + this["oSelectionRectangleSession"]["oRect"]["height"] > UCF_DomUtil["iClientHeight"]() - iDist) {
		this["oSelectionRectangleSession"]["oRect"]["height"] = UCF_DomUtil["iClientHeight"]() - this["oSelectionRectangleSession"]["oRect"]["y"] + iBodyScrollTop - iDist;
	}

	var oRecStyle = this["oSelectionRectangleSession"]["oDomRectangle"]["style"];
	oRecStyle["height"] = this["oSelectionRectangleSession"]["oRect"]["height"] + "px";
	oRecStyle["width"] = this["oSelectionRectangleSession"]["oRect"]["width"] + "px";
	oRecStyle["top"] = this["oSelectionRectangleSession"]["oRect"]["y"] + "px";
	oRecStyle["left"] = this["oSelectionRectangleSession"]["oRect"]["x"] + "px";

	var oDomRectStyle = this["oSelectionRectangleSession"]["oDomRectangle"]["style"];
	oDomRectStyle["visibility"] = "hidden";
	oDomRectStyle["display"] = "none";

	this["oSelectionRectangleSession"]["aCurrentSelection"] = [];
	for (var i = 0; i < this["aElements"]["length"]; i++) {
		var oElement = this["aElements"][i];
		if (oElement["aValidControlIDs"]["length"] == 0) continue;

		if (oElement["bIsSelectable"]()) {
			//			var oPositioningDIV = null;
			//			if (oElement.bIsScrollElement) {
			//				// Temp. remove the child elements that could completely cover a selectable scroll-element in some cases (plain ScrollContainer,
			//				// Group that has no header, SplitterCell, etc.)
			//				oPositioningDIV = UCF_DomUtil.$(oElement.sId + "-layered");
			//				if (oPositioningDIV) {
			//					oPositioningDIV.style.display = "none";
			//				}
			//			}
			if (this["bElementSelected_ONE_POINT"](oElement, oElement["oGetAbsoluteRect"]())) {
				oElement["setSelectionState"](oElement["eSelectionState"]["SELECTED"]);
				oElement["displayResizeHandles"](false);
				this["oSelectionRectangleSession"]["aCurrentSelection"]["push"](oElement["sGetId"]());
			} else {
				oElement["setSelectionState"](oElement["eSelectionState"]["NONE"]);
			}

			//			if (oPositioningDIV) {
			//				oPositioningDIV.style.display = "block";
			//			}
		}
	}
	oDomRectStyle["visibility"] = "visible";
	oDomRectStyle["display"] = "block";
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["calculateRectangleAndSelection"] = 0; };

/**
 * Calculate 4 corners and some other points of all selectable elements
 * If at least one point is inside the rectangle and it is visible (elementFromPoint()) => element selected
 * Note: If this approximation is not good enough we can simply calculate more points ....
 */
UCF_DTContainer["prototype"]["bElementSelected_ONE_POINT"] = function(oElement, oRect) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bElementSelected_ONE_POINT"]++; }; 
	return this["bPointSelectedAndVisible"](oElement, oRect["left"], oRect["top"]) ||
		this["bPointSelectedAndVisible"](oElement, oRect["left"] + oRect["width"] - 2, oRect["top"]) ||
		this["bPointSelectedAndVisible"](oElement, oRect["left"], oRect["top"] + oRect["height"] - 2) ||
		this["bPointSelectedAndVisible"](oElement, oRect["left"] + oRect["width"] - 2, oRect["top"] + oRect["height"] - 2);
	/*||

	this.bPointSelectedAndVisible(oElement, oRect.left + Math.floor((oRect.width - 2) / 2), oRect.top + Math.floor((oRect.height - 2) / 2) ||

	this.bPointSelectedAndVisible(oElement, oRect.left + Math.floor((oRect.width - 2) / 2), oRect.top) ||
	this.bPointSelectedAndVisible(oElement, oRect.left + Math.floor((oRect.width - 2) / 2), oRect.top + oRect.height - 2) ||
	this.bPointSelectedAndVisible(oElement, oRect.left, oRect.top + Math.floor((oRect.height - 2) / 2)) ||
	this.bPointSelectedAndVisible(oElement, oRect.left + oRect.width - 2, oRect.top + Math.floor((oRect.height - 2) / 2)*/
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bElementSelected_ONE_POINT"] = 0; };

/**
 * All 4 corner points must be selected and visible.
 */
UCF_DTContainer["prototype"]["bElementSelected_FULL"] = function(oElement, oRect) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bElementSelected_FULL"]++; }; 
	// Needed for IE+FF: Otherwise it will not consistently hit the corner with elementFropmPoint (selection goes on and off when moving the rectangle)
	var x = UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]() || UCF_UserAgent["bIsFirefox"]() ? 1 : 0;

	// Workarounds for lower corners:
	// -2: Needed for all browsers
	// Or
	// -4: for height seems strange but in WDA screens it is necessary for FlowLayouts
	//     otherwise elementFromPoint() for the lower corners would "hit" the upper corners of the next control
	//     It is not possible to use only this value because then it may hit nested inner elements in other scenarios...

	return this["bPointSelectedAndVisible"](oElement, oRect["left"] + x, oRect["top"] + x) &&
		this["bPointSelectedAndVisible"](oElement, oRect["left"] + oRect["width"] - 2, oRect["top"] + x) &&
		(this["bPointSelectedAndVisible"](oElement, oRect["left"] + x, oRect["top"] + oRect["height"] - 2) &&
			this["bPointSelectedAndVisible"](oElement, oRect["left"] + oRect["width"] - 2, oRect["top"] + oRect["height"] - 2)
			||
			this["bPointSelectedAndVisible"](oElement, oRect["left"] + x, oRect["top"] + oRect["height"] - 4) &&
			this["bPointSelectedAndVisible"](oElement, oRect["left"] + oRect["width"] - 2, oRect["top"] + oRect["height"] - 4));
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bElementSelected_FULL"] = 0; };

/**
 * @private
 */
UCF_DTContainer["prototype"]["bPointSelectedAndVisible"] = function(oElement, iX, iY) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bPointSelectedAndVisible"]++; }; 
	var oRect = this["oSelectionRectangleSession"]["oRect"];
	if (iX > oRect["x"] && iX < oRect["x"] + oRect["width"] && iY > oRect["y"] && iY < oRect["y"] + oRect["height"]) {
		var oEFP = document["elementFromPoint"](iX, iY);

		//		if (oElement.sId == "xxx") {
		//			if (console) console.log(">>>>> iX=" + iX + ", iY=" + iY + ", oEFP=" + (oEFP ? oEFP.id : "-"));
		//		}

		if (oEFP && oEFP["id"] && (oEFP["id"] == oElement["oDomRef"]["id"] || oEFP["id"] == oElement["oDomRef"]["id"] + "-hover" || oEFP["id"] == oElement["oDomRef"]["id"] + "-content")) {
			return true;
		} else {
			//			if (oEFP && oElement.bIsScrollElement) {
			//				// Special case for scroll-element that is also selectable (ScrollContainer):
			//				// We hit a child element that has the same position and covers the area, except scrollbars (In Personas3 that should be the child RasterLayout)
			//				var r1 = UCF_DomUtil.oGetObjectRect(oEFP);
			//				var r2 = oElement.oGetAbsoluteRect();
			//				console.log(">>> oEFP.id=" + oEFP.id + ", id=" + oElement.sId + ", r1.top=" + r1.top + ", r2.top=" + r2.top + ", r1.left=" + r1.left + ", r2.left=" + r2.left);
			//				if (r1.top == r2.top && r1.left == r2.left) {
			//					return true;
			//				}
			//			}
		}
	}
	//	else {
	//		if (oElement.sId == "xxx") {
	//			console.log({ x: iX, y: iY, r: oRect });
	//		}
	//	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bPointSelectedAndVisible"] = 0; };

/**
 * Loops over all elements and calls the given callback function for each element.
 * The signature of the callback is function(oContainer,oElement)
 * @rparam {function} fCallback The callback function to be called for each element in this DTContainer.
 */
UCF_DTContainer["prototype"]["loopElements"] = function(fCallback) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["loopElements"]++; }; 
	if (!this["aElements"]) return;
	for (var i = 0; i < this["aElements"]["length"]; i++) {
		var oElement = this["aElements"][i];
		if (!oElement["bInitError"]) {
			fCallback(this, oElement);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["loopElements"] = 0; };

/**
 * Loops over all selected elements and calls the given callback function for each element.
 * The signature of the callback is function(oContainer,oElement)
 * @rparam {function} fCallback The callback function to be called for each element in this DTContainer.
 */
UCF_DTContainer["prototype"]["loopSelectedElements"] = function(fCallback) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["loopSelectedElements"]++; }; 
	if (!this["aElements"]) return;
	for (var i = 0; i < this["aElements"]["length"]; i++) {
		var oElement = this["aElements"][i];
		if (!oElement["bInitError"] && oElement["bIsSelected"]()) {
			fCallback(this, oElement);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["loopSelectedElements"] = 0; };

/**
 * Called by the DTElementXXXDragDelegate before the DragSession is created and this.stratDrag() is called.
 */
UCF_DTContainer["prototype"]["beforeDragSession"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["beforeDragSession"]++; }; 
	// Ask Personas editor extension for decorator and ghost settings. They may depend on the control that is dragged.
	if (this["getClientControl"]() && this["getClientControl"]()["bPersonasEnabled"]) {
		var oCC = oDTElement["oGetConnectedControl"]();
		if (oCC && oCC["getClientControl"]()) {
			var oExt = oCC["getClientControl"]()["getCustomObject"]("DTExtension");
			if (oExt && oExt["getDecoratorAndGhostSettings"]) {
				this["oCurrentDragSessionDecoratorSettings"] = oExt["getDecoratorAndGhostSettings"](oDTElement);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["beforeDragSession"] = 0; };

/**
 * Called by the DTElementXXXDragDelegate after the DragSession was created.
 */
UCF_DTContainer["prototype"]["startDrag"] = function(oDTElement, oDragDropManager) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["startDrag"]++; }; 
	this["hideNoneMatchingElements"](oDragDropManager, oDTElement);
	this["fireEvent"](this["E_EVENTS"]["DragStart"], { "Element": oDTElement });
	this["bDragProgress"] = true;
	this["hideHitZones"]();
	// Workaround for drag-start: mousedown causes select, which in personas does a re-rendering of the connected control. It may not be rendered completely yet...
	UCF_JsUtil["delayedCall"](10, this, "hideDraggedElements");
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["startDrag"] = 0; };

/**
 * Hide elements that do not have matching DropSource/TargetInfo "Tags" during a DnD operation.
 * This also applies to scroll-elements: If a scroll elements is "hidden" based on the Tags, all contained elements will also be hidden regardless of their Tags.
 */
UCF_DTContainer["prototype"]["hideNoneMatchingElements"] = function(oDragDropManager, oDTElement) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hideNoneMatchingElements"]++; }; 
	var f = function(oDTContainer, oElement) {
		if (oElement === oDTElement) {
			return;
		}
		if (oElement === oDTElement["oMyParentScrollElement"]) {
			// When starting to drag do NOT hide the scroll-element of this element, otherwise drag-scroll will not work!
			return;
		}

		var oControl = oElement["oGetConnectedControl"]();
		if (oControl && !oElement["oGetConnectedControl"]()["bGetInvisibility"]()) {
			// Ask extension: E.g. Toolbar should not be hidden but drag cursor shows a forbidden-sign
			var bExtDoHide = true;
			var oExt = oControl["oGetDTExtension"](oElement);
			if (oExt) {
				bExtDoHide = oExt["bHideWhenDropNotAllowed"]();
			}

			if (bExtDoHide && !oDragDropManager["bGetDropAllowed"](oElement["getDropTags"]())) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD hide on dragstart: " + oElement["sId"] + " tags: " + oElement["getDropTags"](), "DTContainer.js(1560): hideNoneMatchingElements"); };
				oElement["hide"]();
			}
		}

	};
	if (this["getClientControl"]() && this["getClientControl"]()["bHideNoneMatchingElements"]) {
		this["loopElements"](f);
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hideNoneMatchingElements"] = 0; };

UCF_DTContainer["prototype"]["showAllElements"] = function(oDragDropManager) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showAllElements"]++; }; 
	var f = function(oDTContainer, oElement) {
		oElement["show"]();
	};
	this["loopElements"](f);
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showAllElements"] = 0; };

UCF_DTContainer["prototype"]["stopDrag"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["stopDrag"]++; }; 
	this["bDragProgress"] = false;
	this["hidePosition"]();
	if (this["getClientControl"]() && this["getClientControl"]()["bInvalidated"]) {
		return;
	}
	if (this["oCurrentTargetElement"]) {
		this["oCurrentTargetElement"]["setDropZone"](false);
		this["oCurrentTargetElement"] = null;
	}

	this["showAllElements"]();
	this["fireEvent"](this["E_EVENTS"]["DragStop"], { "Element": oDTElement });
	this["oFireSelectOnElement"] = null;
	this["oCurrentDragSessionDecoratorSettings"] = null;
	this["showDraggedElements"]();

	this["handleGridModeStopDrag"]();
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["stopDrag"] = 0; };

UCF_DTContainer["prototype"]["getNextDTElementInControlOrder"] = function(oDTElement, bSelectable) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["getNextDTElementInControlOrder"]++; }; 
	var that = this,
		oConnectedControl = oDTElement["oGetConnectedControl"](),
		checkDTElement = function(oControl) {
			if (oControl instanceof UCF_Control && oControl["bIsVisible"]()) {
				var oDTElement = that["getDTElement"](oControl);
				if (oDTElement && (!bSelectable || (bSelectable && oDTElement["bIsSelectable"]()))) {
					return true;
				}
			}
			return false;
		},
		aContainedControls = this["aGetContainedControls"](checkDTElement);
	for (var i = 0; i < aContainedControls["length"] - 1; i++) {
		if (aContainedControls[i] == oConnectedControl) {
			return this["getDTElement"](aContainedControls[i + 1]);
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["getNextDTElementInControlOrder"] = 0; };

UCF_DTContainer["prototype"]["getPreviousDTElementInControlOrder"] = function(oDTElement, bSelectable) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["getPreviousDTElementInControlOrder"]++; }; 
	var that = this,
		oConnectedControl = oDTElement["oGetConnectedControl"](),
		checkDTElement = function(oControl) {
			if (oControl instanceof UCF_Control && oControl["bIsVisible"]()) {
				var oDTElement = that["getDTElement"](oControl);
				if (oDTElement && (!bSelectable || (bSelectable && oDTElement["bIsSelectable"]()))) {
					return true;
				}
			}
			return false;
		},
		aContainedControls = this["aGetContainedControls"](checkDTElement);
	for (var i = 0; i < aContainedControls["length"]; i++) {
		if (aContainedControls[i] == oConnectedControl && i > 0) {
			return this["getDTElement"](aContainedControls[i - 1]);
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["getPreviousDTElementInControlOrder"] = 0; };

/**
 * Calculate the target elements based on the position of all selected elements during a DragSession.
 * @private
 */
UCF_DTContainer["prototype"]["calculateMoveTargets"] = function(iPageX, iPageY, oDTMovedElement, oTargetElement) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["calculateMoveTargets"]++; }; 
	var aSelected = this["aListSelectedElements"]();
	if (aSelected["length"] == 0) {
		return [];
	}
	var oRect;
	var aResult = [];
	var iGhostOffsetLeft = 0,
		iGhostOffsetTop = 0;
	var oDS = UCF_DomUtil["oGetTopWindow"]()["oDragSession"];
	if (!oDS) return aResult;
	var oGhost = oDS["oGetGhost"]();
	if (!oGhost || !oGhost["oRect"]) return aResult;
	iGhostOffsetLeft = oGhost["iOffsetLeft"];
	iGhostOffsetTop = oGhost["iOffsetTop"];

	// Calculate move-distance based on the dragged element
	var iX = iPageX + iGhostOffsetLeft;
	var iY = iPageY + iGhostOffsetTop;
	oRect = oDTMovedElement["oGetConnectedControl"]()["oGetObjectRect"]();
	var iMovedX = iX - oRect["left"];
	var iMovedY = iY - oRect["top"];

	oGhost["hide"]();

	// Use elementFromPoint() to find target-DTElement for each moved element
	for (var i = 0; i < aSelected["length"]; i++) {
		var oMovedDTElement = aSelected[i];
		oRect = oMovedDTElement["oGetConnectedControl"]()["oGetObjectRect"]();
		var oHit = document["elementFromPoint"](oRect["left"] + iMovedX, oRect["top"] + iMovedY);
		if (!oHit) continue;
		oHit = oHit["parentNode"];
		if (oHit["getAttribute"]("ct") == "DTE") {
			var oTarget = this["oGetControlById"](oHit["id"]);
			var oTargetRect = oTarget["oGetConnectedControl"]()["oGetObjectRect"]();
			aResult["push"]({
				"element": oMovedDTElement,
				"x": oRect["left"] + iMovedX - oTargetRect["left"],
				"y": oRect["top"] + iMovedY - oTargetRect["top"],
				"parentId": oTarget["oGetConnectedControl"]()["sGetId"](),
				"targetElement": oTarget,
				"fire": true
			});
		}
	}

	oGhost["show"]();

	return aResult;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["calculateMoveTargets"] = 0; };

/**
 * Fire move events for all elements that are currently selected.
 * This is called by the Persona-WDA DesignTimeHandler in onDrop() so an active DragSession exists.
 * @param {number} iPageX The mouse X position from the LS BrowserEvent
 * @param {number} iPageY The mouse Y position from the LS BrowserEvent
 * @param {UCF_DTElement} oDTMovedElement The element that is currently dragged
 * @param {UCF_DTElement} oTargetElement The drop target element from the DTContainer'S Drop event
 * @param {UCF_DTElement} oOriginalTargetElement If a "selection forwarding" logic was applied in Personas Editor we need to know the original target
 * @public
 */
UCF_DTContainer["prototype"]["fireMove"] = function(iPageX, iPageY, oDTMovedElement, oTargetElement, oOriginalTargetElement) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["fireMove"]++; }; 
	var aSelected = this["aListSelectedElements"]();
	if (aSelected["length"] === 0) {
		return;
	}
	var aMoves = [];
	// This is a workaround to be compatible with versions of DesignTimeHandlerEvents.js where the last parameter was not changed
	var bNoOriginalTarget = (typeof(oOriginalTargetElement) === "undefined" || typeof(oOriginalTargetElement) === "boolean");
	if (aSelected["length"] > 1 || bNoOriginalTarget) {
		aMoves = this["calculateMoveTargets"](iPageX, iPageY, oDTMovedElement, oTargetElement);
	} else {
		var iGhostOffsetLeft = 0,
			iGhostOffsetTop = 0;
		var oDS = UCF_DomUtil["oGetTopWindow"]()["oDragSession"];
		if (oDS) {
			var oGhost = oDS["oGetGhost"]();
			if (!oGhost || !oGhost["oRect"]) return;
			iGhostOffsetLeft = oGhost["iOffsetLeft"];
			iGhostOffsetTop = oGhost["iOffsetTop"];
		}

		var iOffsetLeft = iPageX /*- oRect.left*/ + iGhostOffsetLeft;
		var iOffsetTop = iPageY /* oRect.top*/ + iGhostOffsetTop;

		var oTargetRect = oOriginalTargetElement["oGetConnectedControl"]()["oGetObjectRect"]();
		aMoves = [];
		for (var i = 0; i < aSelected["length"]; i++) {
			var oDTElement = aSelected[i];
			var iConnectedOffsetLeft = 0;
			var iConnectedOffsetTop = 0;
			if (oDTElement["oGetConnectedControl"]()["oGetParent"]()["sClassName"] === "UCF_RasterLayoutItem") {
				iConnectedOffsetLeft = oDTElement["oGetConnectedControl"]()["oRootRef"]["offsetLeft"];
				iConnectedOffsetTop = oDTElement["oGetConnectedControl"]()["oRootRef"]["offsetTop"];
			}
			aMoves["push"]({
				"element": oDTElement,
				"x": /*oRect.left +*/ iOffsetLeft - oTargetRect["left"] - iConnectedOffsetLeft,
				"y": /*oRect.top +*/ iOffsetTop - oTargetRect["top"] - iConnectedOffsetTop,
				"parentId": oTargetElement["oGetConnectedControl"]()["sGetId"](),
				"fire": true
			});
		}
	}

	this["executeMoves"](aMoves);
	this["updateHitZones"]();
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["fireMove"] = 0; };

UCF_DTContainer["prototype"]["executeMoves"] = function(aMoves) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["executeMoves"]++; }; 
	for (var i = 0; i < aMoves["length"]; i++) {
		var oMove = aMoves[i];
		oMove["element"]["move"](oMove["x"], oMove["y"], oMove["parentId"], oMove["fire"], i > 0);
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["executeMoves"] = 0; };

UCF_DTContainer["prototype"]["bIsPersonasEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bIsPersonasEnabled"]++; }; 
	if (this["getClientControl"]()) {
		return this["getClientControl"]()["bPersonasEnabled"];
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bIsPersonasEnabled"] = 0; };

UCF_DTContainer["prototype"]["bHideControlOnDragStart"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bHideControlOnDragStart"]++; }; 
	if (this["getClientControl"]()) {
		return this["getClientControl"]()["hideControlOnDragStart"]();
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bHideControlOnDragStart"] = 0; };

UCF_DTContainer["prototype"]["getHighestZIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["getHighestZIndex"]++; }; 
	var iZIndex = 0;
	var f = function(oDTContainer, oDTElement) {
		iZIndex = Math["max"](iZIndex, oDTElement["iGetDOMZIndex"]());
	};
	try {
		this["loopElements"](f);
	} catch (ex) {}
	return iZIndex;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["getHighestZIndex"] = 0; };

UCF_DTContainer["prototype"]["hideHitZones"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hideHitZones"]++; }; 
	if (!this["bIsPersonasEnabled"]()) return;
	if (this["oHitZone"]) this["oHitZone"]["ROOT"]["style"]["display"] = "none";
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hideHitZones"] = 0; };

UCF_DTContainer["prototype"]["updateHitZones"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["updateHitZones"]++; }; 
	if (!this["bIsPersonasEnabled"]() && this["bDragProgress"]) return;
	var aSelectedElements = this["getSelectedElements"]();
	if (aSelectedElements && aSelectedElements["length"] === 1) {
		aSelectedElements[0]["displayResizeHandles"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["updateHitZones"] = 0; };

/**
 * Called by DTElement(Raster)DragDelegate
 */
UCF_DTContainer["prototype"]["hideSelectedControlsOnDragStart"] = function(oDragSourceControl, bChildren) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hideSelectedControlsOnDragStart"]++; }; 
	if ((oDragSourceControl["oGetDTExtension"]() && oDragSourceControl["oGetDTExtension"]()["hideControlOnDragStart"]()) || this["bHideControlOnDragStart"]()) {
		var f = function(oDTContainer, oElement) {
			// Personas WDA: Consider selected elements including "selection forwarding":
			// When the selection was "forwarded" from a child-element to its parent, the parent is selected and the child deselected -> both must be hidden!
			if (!oElement["bInitError"] && (oElement["bIsSelected"]() /*|| oElement.sSelectionForwardedTo*/ )) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD: hide selected controls on dragstart: " + oElement["sId"], "DTContainer.js(1807): hideSelectedControlsOnDragStart" /*+ (oElement.sSelectionForwardedTo ? " (->" + oElement.sSelectionForwardedTo + ")" : "")*/ ); };
				oElement["hideConnectedControl"]();
				oElement["hide"]();
				if (bChildren) {
					// All DTElements for child-controls of dragged elements have to be hidden. In Personas-WebGUI this applied to DTElements of RasterLayouts
					// and the scroll-DTElements of Groups (GuiBox)
					var aChildren = oElement["oGetConnectedControl"]()["aGetContainedControls"]();
					for (var i = 0; i < aChildren["length"]; i++) {
						var oDTE = this["oGetDTElement"](aChildren[i]["sId"]);
						if (oDTE) {
							if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD: hide selected controls on dragstart - hide DTElements for child: " + oDTE["sId"], "DTContainer.js(1817): hideSelectedControlsOnDragStart"); };
							oDTE["hide"]();
							// Remember hidden contained elements for showSelectedControlsOnDragEnd() ...
							oElement["aHiddenChildElementsOnDragStart"] = oElement["aHiddenChildElementsOnDragStart"] || [];
							oElement["aHiddenChildElementsOnDragStart"]["push"](oDTE);
						}
						var oScrollDTE = this["oGetScrollDTElement"](aChildren[i]["sId"]);
						if (oScrollDTE) {
							if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD: hide selected controls on dragstart - hide extra DTElements for child scroll-container: " + oScrollDTE["sId"], "DTContainer.js(1825): hideSelectedControlsOnDragStart"); };
							oScrollDTE["hide"]();
							oElement["aHiddenChildElementsOnDragStart"] = oElement["aHiddenChildElementsOnDragStart"] || [];
							oElement["aHiddenChildElementsOnDragStart"]["push"](oScrollDTE);
						}
					}
				}
			}
		}["bind"](this);
		this["loopElements"](f);
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["hideSelectedControlsOnDragStart"] = 0; };

UCF_DTContainer["prototype"]["showSelectedControlsOnDragEnd"] = function(oDragSourceControl) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showSelectedControlsOnDragEnd"]++; }; 
	if ((oDragSourceControl["oGetDTExtension"]() && oDragSourceControl["oGetDTExtension"]()["hideControlOnDragStart"]()) || this["bHideControlOnDragStart"]()) {
		var f = function(oDTContainer, oElement) {
			if (!oElement["bInitError"] && (oElement["bIsSelected"]() /*|| oElement.sSelectionForwardedTo*/ )) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD: show selected controls on dragend: " + oElement["sId"], "DTContainer.js(1842): showSelectedControlsOnDragEnd"); };
				oElement["showConnectedControl"]();
				oElement["show"]();
				if (oElement["aHiddenChildElementsOnDragStart"]) {
					for (var i = 0; i < oElement["aHiddenChildElementsOnDragStart"]["length"]; i++) {
						if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD: show selected controls on dragsend - show DTElements for contained RL: " + oElement["aHiddenChildElementsOnDragStart"][i]["sId"], "DTContainer.js(1847): showSelectedControlsOnDragEnd"); };
						oElement["aHiddenChildElementsOnDragStart"][i]["show"]();
					}
					delete oElement["aHiddenChildElementsOnDragStart"];
				}
			}
		};
		this["loopElements"](f);
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["showSelectedControlsOnDragEnd"] = 0; };

// ============================= Grid for RasterLayout editor in Personas WDA =============================

UCF_DTContainer["prototype"]["GRID_ID"] = "ls-dt-rasterlayoutgrid";
UCF_DTContainer["prototype"]["TABLE_CLASSNAME"] = "lsDTGridTable";
UCF_DTContainer["prototype"]["CELL_CLASSNAME"] = "lsDTGridCell";
UCF_DTContainer["prototype"]["CELL_HOVER_CLASSNAME"] = "lsDTGridCellHover";
UCF_DTContainer["prototype"]["GRID_TR_ID_PREFIX"] = UCF_DTContainer["prototype"]["GRID_ID"] + "-tr-";
UCF_DTContainer["prototype"]["GRID_TD_ID_PREFIX"] = UCF_DTContainer["prototype"]["GRID_ID"] + "-td-";
UCF_DTContainer["prototype"]["BORDER_SIZE"] = 1; // This is hereby hard-coded and not allowed to change in cell CSS class
//UCF_DTContainer.prototype.GHOST_OFFSET = 12;

/**
 * @typedef {Object} GridCellCoords
 * @property {number} row Zero-based index of the row
 * @property {number} column Zero-based index of the column
 */

/**
 * @typedef {Object} GridCellSize
 * @property {number} height Height of an element in grid-rows
 * @property {number} width Width of an element in grid-columns
 */

/**
 * Returns true if the element is inside a RasterLayout that should have a grid.
 */
UCF_DTContainer["prototype"]["bParentIsRasterLayoutItem"] = function(oConnectedControl) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bParentIsRasterLayoutItem"]++; }; 
	// This is a Hack:
	// Do NOT consider RasterLayoutItems used for absolute positioning in other layouts. Currently the only Unterscheidungsmerkmal is the WDA-internal ID suffix "-dtri" ...
	// There should be a special attribute added to the RLIs for RasterItems-parameter in the renderer of layouts - but abs. positioning will not be used anymore by WDA in the future(?)
	return oConnectedControl && oConnectedControl["oGetParent"]()["sClassName"] === "UCF_RasterLayoutItem" && oConnectedControl["oGetParent"]()["sId"]["indexOf"]("-dtri") === -1;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["bParentIsRasterLayoutItem"] = 0; };

/**
 * Display grid if needed for a single selection.
 */
UCF_DTContainer["prototype"]["handleGridModeSingleSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleGridModeSingleSelection"]++; }; 
	if (!(this["getClientControl"]() && this["getClientControl"]()["bEnableRasterLayoutGridMode"] === true)) return;
	this["removeRasterLayoutGrid"]();
	var aSelected = this["aListSelectedElements"]();
	if (aSelected["length"] === 0) return;
	var oConnectedControl = aSelected[0]["oGetConnectedControl"]();
	if (oConnectedControl && oConnectedControl["bIsDestroyed"] === false && this["bParentIsRasterLayoutItem"](oConnectedControl)) {
		var oLayout = oConnectedControl["oGetParent"]()["oGetParent"]();
		if (oLayout["sClassName"] === "UCF_RasterLayout") {
			this["addRasterLayoutGrid"](oLayout);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleGridModeSingleSelection"] = 0; };

/**
 * Handle Browser window resize.
 */
UCF_DTContainer["prototype"]["handleGridModeWindowResize"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleGridModeWindowResize"]++; }; 
	if (!(this["getClientControl"]() && this["getClientControl"]()["bEnableRasterLayoutGridMode"] === true)) return;
	if (this["oRasterLayoutGridInfo"]) {
		var oRL = this["oRasterLayoutGridInfo"]["oRL"];
		this["removeRasterLayoutGrid"]();
		this["addRasterLayoutGrid"](oRL);
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleGridModeWindowResize"] = 0; };

/**
 * Calculates the new size after a resize in Grid-rows and -cols for the given DTElement. Called by UCF_DTElement.stopResize().
 * @param {number} iPxWidth The width of the resize ghost in pixels
 * @param {number} iPxHeight The height of the resize ghost in pixels
 * @param {UCF_DTElement} oElement The DTElement that was resized
 * @return {GridCellSize|undefined} The new size
 */
UCF_DTContainer["prototype"]["oCalcResizedGridSize"] = function(iPxWidth, iPxHeight, oElement) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oCalcResizedGridSize"]++; }; 
	if (!(this["getClientControl"]() && this["getClientControl"]()["bEnableRasterLayoutGridMode"] === true)) return;
	if (!this["bParentIsRasterLayoutItem"](oElement["oGetConnectedControl"]())) return;
	var oRasterLayout = oElement["oGetConnectedControl"]()["oGetParent"]()["oGetParent"]();
	var oCellSize = oRasterLayout["oGetRasterSizePx"]();
	return {
		"width": Math["round"](iPxWidth / oCellSize["width"]),
		"height": Math["round"](iPxHeight / oCellSize["height"])
	};
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oCalcResizedGridSize"] = 0; };

/**
 * Creates a new grid based on the given RasterLayout. Called by DTElementDropDelegate.handleDragOverGridMode()
 * @param {UCF_RasterLayout} oRasterLayout The RasterLayout control instance
 * @param {UCF_Ghost} [oGhost] The ghost of the current DragSession, if called by a drag-and-drop delegate
 */
UCF_DTContainer["prototype"]["addRasterLayoutGrid"] = function(oRasterLayout, oGhost) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["addRasterLayoutGrid"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oRasterLayout != null, "oRasterLayout != null", "DTContainer.js(1944): addRasterLayoutGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oRasterLayout["sClassName"] === "UCF_RasterLayout", "oRasterLayout.sClassName === \"UCF_RasterLayout\"", "DTContainer.js(1945): addRasterLayoutGrid"); };

	var oCellSize = oRasterLayout["oGetRasterSizePx"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "oCellSize.width:" + oCellSize["width"] + ", oCellSize.height:" + oCellSize["height"], "DTContainer.js(1948): addRasterLayoutGrid"); };

	// Grid is already rendered by selection when this function is called for a new drag-session inside the same RasterLayout
	if (this["oRasterLayoutGridInfo"] && oGhost) {
		this["oRasterLayoutGridInfo"]["iDragSourceHeight"] = Math["round"](oGhost["oDomRef"]["clientHeight"] / oCellSize["height"]);
		this["oRasterLayoutGridInfo"]["iDragSourceWidth"] = Math["round"](oGhost["oDomRef"]["clientWidth"] / oCellSize["width"]);
		return;
	}

	// Overall size of the RL
	var oRect = oRasterLayout["oGetObjectRect"]();
	var iWidth = oRect["width"];
	var iHeight = oRect["height"];
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "iWidth:" + iWidth + ", iHeight:" + iHeight, "DTContainer.js(1961): addRasterLayoutGrid"); };

	// Grid size
	var iGridX = Math["round"](iWidth / oCellSize["width"]);
	var iGridY = Math["round"](iHeight / oCellSize["height"]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "iGridX:" + iGridX + ", iGridY:" + iGridY, "DTContainer.js(1966): addRasterLayoutGrid"); };

	/**
	 * Data on the active (hovered) Grid
	 */
	this["oRasterLayoutGridInfo"] = {
		"oDiv": null,
		"oGridTable": null,
		"oHoverTable": null,
		"oRL": oRasterLayout,
		"oRLDTE": null,
		"oRect": oRect,
		"oHoveredCellDomRef": null,
		"oCellSize": oCellSize,
		"iGridX": iGridX,
		"iGridY": iGridY,

		/*  Size of the dragged element (based on the ghost) */
		"iDragSourceHeight": oGhost ? Math["round"](oGhost["oDomRef"]["clientHeight"] / oCellSize["height"]) : undefined,
		"iDragSourceWidth": oGhost ? Math["round"](oGhost["oDomRef"]["clientWidth"] / oCellSize["width"]) : undefined,

		"bAttachedToPageResize": false

		// aFreeCells: null,

		// initFreeCells: function() {
		//     this.aFreeCells = [];
		//     for (var r = 0; r < this.iGridY; r++) {
		//         var aCol = [];
		//         for (var c = 0; c < this.iGridX; c++) aCol[c] = true;
		//         this.aFreeCells[r] = aCol;
		//     }
		// },

		// bCellIsOcupied: function(iRow, iColumn) {
		//     return !this.aFreeCells[iRow][iColumn];
		// },

		// setCellOcupied: function(iRow, iColumn) {
		//     this.aFreeCells[iRow][iColumn] = false;
		// },

		// setCellsOcupied: function(iRow, iColumn, iRowSpan, iColSpan) {
		//     for (var r = iRow; r < iRow + iRowSpan; r++) {
		//         for (var c = iColumn; c < iColumn + iColSpan; c++) {
		//             this.setCellOcupied(r, c);
		//         }
		//     }
		// }
	};

	// Create DIV for table
	var oDiv = this["oRasterLayoutGridInfo"]["oDiv"] = document["createElement"]("DIV");
	oDiv["setAttribute"]("id", this["GRID_ID"]);
	oDiv["style"]["width"] = iWidth + "px";
	oDiv["style"]["height"] = iHeight + "px";
	this["oRasterLayoutGridInfo"]["oRLDTE"] = this["oGetDTElement"](oRasterLayout["sId"]);
	oDiv["style"]["top"] = this["oRasterLayoutGridInfo"]["oRLDTE"]["oDomRef"]["style"]["top"];
	oDiv["style"]["left"] = this["oRasterLayoutGridInfo"]["oRLDTE"]["oDomRef"]["style"]["left"];
	oDiv["style"]["position"] = "absolute";
	oDiv["style"]["zIndex"] = UCF_LS["E_LAYERS"]["DT_DECORATORS"];

	var createTable = function(bHover) {
		var sIdSuffix = (bHover ? "hover-" : "");
		var oTable = oDiv["appendChild"](document["createElement"]("TABLE"));
		oTable["style"]["borderCollapse"] = "collapse";
		oTable["style"]["position"] = (bHover ? "absolute" : "");
		oTable["style"]["top"] = (bHover ? "0px" : "");
		oTable["style"]["zIndex"] = UCF_LS["E_LAYERS"]["DT_DECORATORS"];
		oTable["className"] = this["TABLE_CLASSNAME"];
		//var MAGIC_FOUR = 4; // Currently I have no good explanation for this
		// Create TBODY, TR, TH, TD
		var oTableBody = oTable["appendChild"](document["createElement"]("TBODY"));
		var oTR = oTableBody["appendChild"](document["createElement"]("TR"));
		//for (var y = this.oRasterLayoutGridInfo.oCellSize.width; y <= iWidth + MAGIC_FOUR; y += this.oRasterLayoutGridInfo.oCellSize.width) {
		var x;
		for (x = 0; x < this["oRasterLayoutGridInfo"]["iGridX"]; x++) {
			var oTH = oTR["appendChild"](document["createElement"]("TH"));
			oTH["style"]["border"] = "none";
			oTH["style"]["padding"] = "0px";
			oTH["style"]["width"] = this["oRasterLayoutGridInfo"]["oCellSize"]["width"] + "px";
			oTH["style"]["height"] = "0px";
		}
		for (var y = 0; y < this["oRasterLayoutGridInfo"]["iGridY"]; y++) {
			oTR = oTableBody["appendChild"](document["createElement"]("TR"));
			oTR["id"] = this["GRID_TR_ID_PREFIX"] + sIdSuffix + y;
			for (x = 0; x < this["oRasterLayoutGridInfo"]["iGridX"]; x++) {
				var oTD = oTR["appendChild"](document["createElement"]("TD"));
				oTD["style"]["width"] = this["oRasterLayoutGridInfo"]["oCellSize"]["width"] + "px";
				oTD["style"]["padding"] = "0px";
				if (bHover) {
					oTD["style"]["height"] = this["oRasterLayoutGridInfo"]["oCellSize"]["height"] + "px";
				} else {
					oTD["style"]["borderWidth"] = this["BORDER_SIZE"] + "px";
					oTD["className"] = this["CELL_CLASSNAME"];
					oTD["style"]["height"] = (this["oRasterLayoutGridInfo"]["oCellSize"]["height"] - this["BORDER_SIZE"]) + "px";

				}
				oTD["id"] = this["GRID_TD_ID_PREFIX"] + sIdSuffix + y + "," + x;
			}
		}
		return oTable;
	}["bind"](this);

	this["oRasterLayoutGridInfo"]["oGridTable"] = createTable(false);

	//this.oRasterLayoutGridInfo.oHoverTable = createTable(true); // Create a second invisible table without row/col-spans for hover-effect during dragging
	//this.oRasterLayoutGridInfo.initFreeCells();

	// Append to the same parent as DTElement of RasterLayout (could be nested scroll-elements)
	this["oRasterLayoutGridInfo"]["oRLDTE"]["oDomRef"]["parentNode"]["appendChild"](oDiv);

	if (oGhost === undefined) {
		// Selection: Handle browser window resizing
		var oPage = this["oLS"]["oGetPageInternal"]();
		if (oPage) {
			oPage["attachEvent"](oPage["E_EVENTS"]["WindowResize"], this, 'handleGridModeWindowResize');
			this["oRasterLayoutGridInfo"]["bAttachedToPageResize"] = true;
		}
	}

	// Calculate rowspan and colspan based on DOM properties of RasterLayoutItems.
	// var span = function(iRow, iColumn, iRowSpan, iColSpan) {
	//     if (iRowSpan === 1 && iColSpan === 1) {
	//         //this.oRasterLayoutGridInfo.setCellOcupied(iRow, iColumn);
	//         return;
	//     }
	//     var o = UCF_DomUtil.$(this.GRID_TD_ID_PREFIX + iRow + "," + iColumn);
	//     if (o && iRowSpan > 1) o.rowSpan = iRowSpan;
	//     if (o && iColSpan > 1) o.colSpan = iColSpan;
	//     for (var r = iRow; r < iRow + iRowSpan; r++) {
	//         for (var c = iColumn; c < iColumn + iColSpan; c++) {
	//             //this.oRasterLayoutGridInfo.setCellOcupied(r, c);
	//             if (r === iRow && c === iColumn) continue;
	//             o = UCF_DomUtil.$(this.GRID_TD_ID_PREFIX + r + "," + c);
	//             if (o) {
	//                 o.style.display = "none";
	//             }
	//         }
	//     }
	// }.bind(this);

	// Calculate ocupied cells, take into account RasterLayoutItems containing invisible controls
	// var ocupiedCells = function (oRLI, iRow, iColumn, iRowSpan, iColSpan) {
	//     var oRLIContent = oRLI.getClientControl().getContent();
	//     if (!oRLIContent.getUCFInstance().bGetInvisibility()) { // this.oLS.oControlFactory.oGetControlById(oRLIContent.sId).bGetInvisibility();
	//         this.oRasterLayoutGridInfo.setCellsOcupied(iRow, iColumn, iRowSpan, iColSpan);
	//     }
	// }.bind(this);

	// var oRLIs = oRasterLayout.oGetItems();
	// UCF_JsUtil.each(oRLIs, function(sId, oControl) {
	//     var oRLIContent = oControl.getClientControl().getContent();
	//     var bHidden = oRLIContent ? oRLIContent.getUCFInstance().bGetInvisibility() : false;
	//     if (!bHidden) {
	//         var iRow = Math.round(oControl.oDomRef.offsetTop / oCellSize.height);
	//         var iColumn = Math.round(oControl.oDomRef.offsetLeft / oCellSize.width);
	//         var iRowSpan = Math.round(oControl.oDomRef.offsetHeight / oCellSize.height);
	//         var iColSpan = Math.round(oControl.oDomRef.offsetWidth / oCellSize.width);
	//         if (iRow + iRowSpan > iGridY) iRowSpan = iGridY - iRow;
	//         if (iColumn + iColSpan > iGridX) iColSpan = iGridX - iColumn;

	//         _trace(INFO, "row and col span: oControl.sId:" + oControl.sId + ", iRow:" + iRow + ", iColumn:" + iColumn + ", iRowSpan:" + iRowSpan + ", iColSpan:" + iColSpan);
	//         span(iRow, iColumn, iRowSpan, iColSpan);
	//         //ocupiedCells(oControl, iRow, iColumn, iRowSpan, iColSpan);
	//     }
	// }.bind(this));
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["addRasterLayoutGrid"] = 0; };

/**
 * Calculate row and column number (zero-based) using the mouse position. Called by UCF_DTElementDropDelegate.onlsdrop().
 * Will return null if there is no DragSession, or if no grid is currently hovered during a DragSession.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent The browser event
 * @returns {GridCellCoords|null} Row and column
 */
UCF_DTContainer["prototype"]["oGetMousePositionInCurrentGrid"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetMousePositionInCurrentGrid"]++; }; 
	// The Grid gets a temporary z-index higher than the DTElements so elementFromPoint() can be used to determine the hovered TD:
	// Nested layouts increase the value of zindex, e.g. in WDA in steps of 100. So we need to add a value large enough to make sure we always get the grid before all DTElements
	// eslint-disable-next-line no-magic-numbers
	// this.oRasterLayoutGridInfo.oDiv.style.zIndex = this.oRasterLayoutGridInfo.oHoverTable.style.zIndex = this.ZINDEX_BASE + 2000;
	// this.oRasterLayoutGridInfo.oGridTable.style.zIndex = this.oRasterLayoutGridInfo.oHoverTable.style.zIndex - 1;
	// eslint-disable-next-line no-magic-numbers
	if (!this["oRasterLayoutGridInfo"]) return null;
	var iOffsetLeft = oBrowserEvent["iPageX"]() - this["oRasterLayoutGridInfo"]["oRect"]["left"];
	var iOffsetTop = oBrowserEvent["iPageY"]() - this["oRasterLayoutGridInfo"]["oRect"]["top"];
	var iRow = Math["ceil"](iOffsetTop / this["oRasterLayoutGridInfo"]["oCellSize"]["height"]) - 1;
	var iColumn = Math["ceil"](iOffsetLeft / this["oRasterLayoutGridInfo"]["oCellSize"]["width"]) - 1;
	return { "row": iRow, "column": iColumn };
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetMousePositionInCurrentGrid"] = 0; };

/**
 * Calculate row and column number (zero-based) using the upper-left corner of the ghost.  Called by UCF_DTElementDropDelegate.onlsdrop().
 * Will return null if there is no DragSession, or if the ghost is not completely inside the grid currently hovered.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent The browser event
 * @returns {GridCellCoords|null} Row and column
 */
UCF_DTContainer["prototype"]["oGetGhostPositionInCurrentGrid"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetGhostPositionInCurrentGrid"]++; }; 
	var oElement = this["oGetElementAtGhostPosition"](oBrowserEvent);
	if (oElement && oElement["id"] && oElement["id"]["indexOf"](this["GRID_TD_ID_PREFIX"]) === 0) {
		var xy = oElement["id"]["replace"](this["GRID_TD_ID_PREFIX"] /*+ "hover-"*/ , "")["split"](",");
		return { "row": parseInt(xy[0]), "column": parseInt(xy[1]) };
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetGhostPositionInCurrentGrid"] = 0; };

/**
 * @return {UCF_DTElement}
 */
UCF_DTContainer["prototype"]["oGetElementAtGhostPosition"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetElementAtGhostPosition"]++; }; 
	this["oRasterLayoutGridInfo"]["oDiv"]["style"]["zIndex"] = this["oRasterLayoutGridInfo"]["oGridTable"]["style"]["zIndex"] = this["ZINDEX_BASE"] + 2000;
	var oGhost = oBrowserEvent["oDragAndDropManager"]["oDragSession"]["oGetGhost"]();
	var iCheckX = oBrowserEvent["iClientX"]() + oGhost["iOffsetLeft"];
	var iCheckY = oBrowserEvent["iClientY"]() + oGhost["iOffsetTop"];
	oGhost["hide"]();
	var oElement = document["elementFromPoint"](iCheckX, iCheckY);
	oGhost["show"]();
	this["oRasterLayoutGridInfo"]["oDiv"]["style"]["zIndex"] =
		this["oRasterLayoutGridInfo"]["oGridTable"]["style"]["zIndex"] =
		/*this.oRasterLayoutGridInfo.oHoverTable.style.zIndex =*/
		UCF_LS["E_LAYERS"]["DT_DECORATORS"];
	return oElement;
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetElementAtGhostPosition"] = 0; };

/**
 * Returns the size of the dragged element based on the ghost.
 * Will return null if there is no DragSession, or if no grid is currently hovered during a DragSession.
 * @returns {GridCellSize|null} Height and Width
 */
UCF_DTContainer["prototype"]["oGetDragSourceSizeInCurrentGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetDragSourceSizeInCurrentGrid"]++; }; 
	if (!this["oRasterLayoutGridInfo"]) return null;
	return { "height": this["oRasterLayoutGridInfo"]["iDragSourceHeight"], "width": this["oRasterLayoutGridInfo"]["iDragSourceWidth"] };
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["oGetDragSourceSizeInCurrentGrid"] = 0; };

/**
 * Called by DTElementDragDelegate.onlsdrag().
 * @param {UCF_BrowserEvent} oBrowserEvent The browser event
 */
UCF_DTContainer["prototype"]["handleDragForRasterLayoutGrid"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleDragForRasterLayoutGrid"]++; }; 
	if (!this["oRasterLayoutGridInfo"]) return;
	var oElement = this["oGetElementAtGhostPosition"](oBrowserEvent);
	if (oElement && oElement["id"] && oElement["id"]["indexOf"](this["GRID_TD_ID_PREFIX"]) === 0 && this["oRasterLayoutGridInfo"]["oHoveredCellDomRef"] !== oElement) {
		var allTDs = this["oRasterLayoutGridInfo"]["oGridTable"]["getElementsByTagName"]("TD"); //this.oRasterLayoutGridInfo.oHoverTable.getElementsByTagName("TD");
		for (var i = 0; i < allTDs["length"]; i++) {
			UCF_DomUtil["removeClass"](allTDs[i], this["CELL_HOVER_CLASSNAME"]);
		}
		this["oRasterLayoutGridInfo"]["oHoveredCellDomRef"] = oElement;

		// Extend hover-effect to more cells to the right and bottom according to the size of the dragged element (pixel size of the ghost)
		var xy = oElement["id"]["replace"](this["GRID_TD_ID_PREFIX"] /*+ "hover-"*/ , "")["split"](",");
		var iHoverRow = parseInt(xy[0]);
		var iHoverColumn = parseInt(xy[1]);
		// Size in rows and colls
		var oGhost = oBrowserEvent["oDragAndDropManager"]["oDragSession"]["oGetGhost"]();
		var iCols = Math["ceil"](oGhost["oDomRef"]["clientWidth"] / this["oRasterLayoutGridInfo"]["oCellSize"]["width"]);
		var iRows = Math["ceil"](oGhost["oDomRef"]["clientHeight"] / this["oRasterLayoutGridInfo"]["oCellSize"]["height"]);
		// Apply hover style to all cells
		for (var r = iHoverRow; r < iHoverRow + iRows; r++) {
			for (var c = iHoverColumn; c < iHoverColumn + iCols; c++) {
				var e = UCF_DomUtil["$"](this["GRID_TD_ID_PREFIX"] + /*"hover-" + */ r + "," + c);
				if (e) {
					UCF_DomUtil["addClass"](e, this["CELL_HOVER_CLASSNAME"]);
				}
			}
		}

		// Hovered cell is free or occupied? Set the drag cursor accordingly
		//oBrowserEvent.oDragAndDropManager.oDragSession.setCursor(this.oRasterLayoutGridInfo.bCellIsOcupied(iHoverRow, iHoverColumn) ? UCF_DragSession.E_CURSOR.NOT_ALLOWED : UCF_DragSession.E_CURSOR.ALLOWED);
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleDragForRasterLayoutGrid"] = 0; };

/**
 * Remove the current Grid from the DOM.
 */
UCF_DTContainer["prototype"]["removeRasterLayoutGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["removeRasterLayoutGrid"]++; }; 
	if (this["oRasterLayoutGridInfo"]) {
		if (this["oRasterLayoutGridInfo"]["oDiv"] && this["oRasterLayoutGridInfo"]["oDiv"]["parentNode"]) {
			this["oRasterLayoutGridInfo"]["oDiv"]["parentNode"]["removeChild"](this["oRasterLayoutGridInfo"]["oDiv"]);
		}
		if (this["oRasterLayoutGridInfo"]["bAttachedToPageResize"]) {
			var oPage = this["oLS"]["oGetPageInternal"]();
			if (oPage) {
				oPage["detachEvent"](oPage["E_EVENTS"]["WindowResize"], this, 'handleGridModeWindowResize');
			}
		}
		this["oRasterLayoutGridInfo"]["oDiv"] = null;
		this["oRasterLayoutGridInfo"]["oGridTable"] = null;
		this["oRasterLayoutGridInfo"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["removeRasterLayoutGrid"] = 0; };

/**
 * Remove the hover styles, while the grid remains visible after drop
 */
UCF_DTContainer["prototype"]["handleGridModeStopDrag"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleGridModeStopDrag"]++; }; 
	if (this["oRasterLayoutGridInfo"]) {
		var allTDs = this["oRasterLayoutGridInfo"]["oGridTable"]["getElementsByTagName"]("TD"); //this.oRasterLayoutGridInfo.oHoverTable.getElementsByTagName("TD");
		for (var i = 0; i < allTDs["length"]; i++) {
			UCF_DomUtil["removeClass"](allTDs[i], this["CELL_HOVER_CLASSNAME"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["handleGridModeStopDrag"] = 0; };

// ======================================================================================================

// /**
//  * Provide internal stuff for QUnit test recording and playback
//  */
// UCF_DTElement.prototype.oGetTestData = function () {
// 	var o = _super();
// 	if (this.oRasterLayoutGridInfo) {
//         o.internals["bRasterLayoutGridIsVisible"] = true;
// 		o.internals["this.oRasterLayoutGridInfo.oRect"] = this.oRasterLayoutGridInfo.oRect;
//         o.internals["this.oRasterLayoutGridInfo.oHoveredCellDomRef"] = this.oRasterLayoutGridInfo.oHoveredCellDomRef
//         o.internals["this.oRasterLayoutGridInfo.oCellSize.width"] = this.oRasterLayoutGridInfo.oCellSize.width;
//         o.internals["this.oRasterLayoutGridInfo.oCellSize.height"] = this.oRasterLayoutGridInfo.oCellSize.width;
//         o.internals["this.oRasterLayoutGridInfo.iGridX"] = this.oRasterLayoutGridInfo.iGridX;
//         o.internals["this.oRasterLayoutGridInfo.iGridY"] = this.oRasterLayoutGridInfo.iGridY;
//         o.internals["this.oRasterLayoutGridInfo.iDragSourceHeight"] = this.oRasterLayoutGridInfo.iDragSourceHeight;
//         o.internals["this.oRasterLayoutGridInfo.iDragSourceWidth"] = this.oRasterLayoutGridInfo.iDragSourceWidth;
// 	}
//     else {
//         o.internals["bRasterLayoutGridIsVisible"] = false;
//     }
// 	return o;
// };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_DTContainer["prototype"]["aAttributeNames"] = ["sRasterMode","bScrollContainerSupport","sScrollContainersWithScrollbars","bDragAndDropLayoutMode","sCustomData","bScrollContainerSupportAdvanced","bEnableRectangleSelection","bEnableInplaceEdit","bEnableAdvancedElementFeatures","bEnableTabChainMode","sDropTargetInfo"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_DTContainer["prototype"]["aEventNames"] = ["Select","CommitSelection","Drop","DropOnRaster"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_DTContainer["prototype"]["aMethodNames"] = ["updatePositions","oGetDTElement","aListSelectedElements","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DTRasterMode}
 */
UCF_DTContainer["prototype"]["sRasterMode"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_DTContainer["prototype"]["bScrollContainerSupport"] = false;

/**
 * @private
 * @type {string}
 */
UCF_DTContainer["prototype"]["sScrollContainersWithScrollbars"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_DTContainer["prototype"]["bDragAndDropLayoutMode"] = false;

/**
 * @private
 * @type {string}
 */
UCF_DTContainer["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_DTContainer["prototype"]["bScrollContainerSupportAdvanced"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_DTContainer["prototype"]["bEnableRectangleSelection"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_DTContainer["prototype"]["bEnableInplaceEdit"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_DTContainer["prototype"]["bEnableAdvancedElementFeatures"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_DTContainer["prototype"]["bEnableTabChainMode"] = false;

/**
 * @private
 * @type {string}
 */
UCF_DTContainer["prototype"]["sDropTargetInfo"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_DTContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["setDefaultValues"]++; }; 
	this["sRasterMode"] = "NONE";
	this["bScrollContainerSupport"] = false;
	this["sScrollContainersWithScrollbars"] = '';
	this["bDragAndDropLayoutMode"] = false;
	this["sCustomData"] = '';
	this["bScrollContainerSupportAdvanced"] = false;
	this["bEnableRectangleSelection"] = false;
	this["bEnableInplaceEdit"] = false;
	this["bEnableAdvancedElementFeatures"] = false;
	this["bEnableTabChainMode"] = false;
	this["sDropTargetInfo"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("RasterMode", "NONE", true);
		this["setClientProperty"]("ScrollContainerSupport", false, true);
		this["setClientProperty"]("ScrollContainersWithScrollbars", '', true);
		this["setClientProperty"]("DragAndDropLayoutMode", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("ScrollContainerSupportAdvanced", false, true);
		this["setClientProperty"]("EnableRectangleSelection", false, true);
		this["setClientProperty"]("EnableInplaceEdit", false, true);
		this["setClientProperty"]("EnableAdvancedElementFeatures", false, true);
		this["setClientProperty"]("EnableTabChainMode", false, true);
		this["setClientProperty"]("DropTargetInfo", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The ID of the DTContainer.
 * @param {string} sElementId The ID of the selected / toggled elements or a list of currently selected element IDs.
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select, TOGGLE for a selection toggle, DESELECT_ALL for deselction of all elements, SELECT_ALL for selcetion of all elements, LIST for a list of selected elements.
 * @fires DTContainer::Select
 */
UCF_DTContainer["prototype"]["fireSelect"] = function(sId, sElementId, sAccessType) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, ElementId: string, AccessType: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "DTContainer.js(2424): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTContainer.js(2425): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTContainer.js(2426): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sElementId != null, "sElementId != null", "DTContainer.js(2427): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sElementId) == "string", "typeof(sElementId) == \"string\"", "DTContainer.js(2428): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "DTContainer.js(2429): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "DTContainer.js(2430): fireSelect"); };
	mParams = {
		"Id": sId,
		"ElementId": sElementId,
		"AccessType": sAccessType
	};
	
	
	
	this["fireSemanticEvent"]("DTContainer", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId The ID of the DTContainer
 * @fires DTContainer::CommitSelection
 */
UCF_DTContainer["prototype"]["fireCommitSelection"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["fireCommitSelection"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "DTContainer.js(2451): fireCommitSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTContainer.js(2452): fireCommitSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTContainer.js(2453): fireCommitSelection"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("DTContainer", "CommitSelection", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["fireCommitSelection"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDragTargetDTElement Identifier of the element that was the target
 * @param {string} sPosition Top, Above, Below, Before, After
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {string} sDropIndex The drop index in parent/child scenario
 * @param {number} iDropGridRow The row number of a RasterLayout in grid-mode - zero based. Contains -1 if the grid-mode is not enabled or the drop occurs on a target that has no grid or the left-upper corner of the ghost is not inside the boundaries of the hovered grid.
 * @param {number} iDropGridColumn The column number of a grid-like RasterLayout - zero based. Contains -1 if the grid-mode is not enabled or the drop occurs on a target that has no grid or the left-upper corner of the ghost is not inside the boundaries of the hovered grid.
 * @param {number} iDragSourceGridHeight The height of the dragged element in grid rows. Contains -1 if the grid-mode is not enabled or the drop occurs on a target that has no grid.
 * @param {number} iDragSourceGridWidth The width of the dragged element in grid columns. Contains -1 if the grid-mode is not enabled or the drop occurs on a target that has no grid.
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires DTContainer::Drop
 */
UCF_DTContainer["prototype"]["fireDrop"] = function(sId, sDragSource, sDragTargetDTElement, sPosition, sDropTargetInfo, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropIndex, iDropGridRow, iDropGridColumn, iDragSourceGridHeight, iDragSourceGridWidth, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DragTargetDTElement: string, Position: string, DropTargetInfo: string, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropIndex: string, DropGridRow: number, DropGridColumn: number, DragSourceGridHeight: number, DragSourceGridWidth: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 17, "arguments.length == 17", "DTContainer.js(2486): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTContainer.js(2487): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTContainer.js(2488): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "DTContainer.js(2489): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "DTContainer.js(2490): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragTargetDTElement != null, "sDragTargetDTElement != null", "DTContainer.js(2491): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragTargetDTElement) == "string", "typeof(sDragTargetDTElement) == \"string\"", "DTContainer.js(2492): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPosition != null, "sPosition != null", "DTContainer.js(2493): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPosition) == "string", "typeof(sPosition) == \"string\"", "DTContainer.js(2494): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "DTContainer.js(2495): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "DTContainer.js(2496): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "DTContainer.js(2497): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "DTContainer.js(2498): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "DTContainer.js(2499): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "DTContainer.js(2500): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "DTContainer.js(2501): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "DTContainer.js(2502): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "DTContainer.js(2503): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "DTContainer.js(2504): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "DTContainer.js(2505): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "DTContainer.js(2506): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "DTContainer.js(2507): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "DTContainer.js(2508): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropIndex != null, "sDropIndex != null", "DTContainer.js(2509): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropIndex) == "string", "typeof(sDropIndex) == \"string\"", "DTContainer.js(2510): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDropGridRow != null, "iDropGridRow != null", "DTContainer.js(2511): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDropGridRow) == "number", "typeof(iDropGridRow) == \"number\"", "DTContainer.js(2512): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDropGridColumn != null, "iDropGridColumn != null", "DTContainer.js(2513): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDropGridColumn) == "number", "typeof(iDropGridColumn) == \"number\"", "DTContainer.js(2514): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDragSourceGridHeight != null, "iDragSourceGridHeight != null", "DTContainer.js(2515): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDragSourceGridHeight) == "number", "typeof(iDragSourceGridHeight) == \"number\"", "DTContainer.js(2516): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDragSourceGridWidth != null, "iDragSourceGridWidth != null", "DTContainer.js(2517): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDragSourceGridWidth) == "number", "typeof(iDragSourceGridWidth) == \"number\"", "DTContainer.js(2518): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "DTContainer.js(2519): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "DTContainer.js(2520): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DragTargetDTElement": sDragTargetDTElement,
		"Position": sPosition,
		"DropTargetInfo": sDropTargetInfo,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropIndex": sDropIndex,
		"DropGridRow": iDropGridRow,
		"DropGridColumn": iDropGridColumn,
		"DragSourceGridHeight": iDragSourceGridHeight,
		"DragSourceGridWidth": iDragSourceGridWidth,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("DTContainer", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the DT element which was dragged
 * @param {string} sDragTargetDTElement Identifier of raster layout DT element. Only DTRasterMode.NESTED_RL_DROP_ON_ELEMENT, empty otherwise.
 * @param {string} sDragSourceRasterLayout Identifier of raster layout which the dragged DT element belongs to. Only  DTRasterMode.NESTED_RL_DROP_RELATIVE, empty otherwise.
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iRasterPosX The horizontal raster position, RasterMode=NESTED_RL_DROP_RELATIVE: The position is relative to the source RL (the RL the control belongs to) and maybe negative.	RasterMode=NESTED_RL_DROP_ON_ELEMENT: The position is relative to the target RL (where the element was dropped).
 * @param {number} iRasterPosY The vertical raster position
 * @param {string} sMultiDropRelPositions JSON: An array with relative positions of all elements in a selection to the element that was dragged (DragSource). Positions are available in px and raster units of the root RasterLayout. [{id, leftPx, topPx, leftRaster, topRaster}]
 * @fires DTContainer::DropOnRaster
 */
UCF_DTContainer["prototype"]["fireDropOnRaster"] = function(sId, sDragSource, sDragTargetDTElement, sDragSourceRasterLayout, sDropTargetInfo, sData, sMimeType, sDragSourceTags, iMouseButton, iRasterPosX, iRasterPosY, sMultiDropRelPositions) {;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["fireDropOnRaster"]++; }; 
	/** @type {{Id: string, DragSource: string, DragTargetDTElement: string, DragSourceRasterLayout: string, DropTargetInfo: string, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, RasterPosX: number, RasterPosY: number, MultiDropRelPositions: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 12, "arguments.length == 12", "DTContainer.js(2580): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTContainer.js(2581): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTContainer.js(2582): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "DTContainer.js(2583): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "DTContainer.js(2584): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragTargetDTElement != null, "sDragTargetDTElement != null", "DTContainer.js(2585): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragTargetDTElement) == "string", "typeof(sDragTargetDTElement) == \"string\"", "DTContainer.js(2586): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceRasterLayout != null, "sDragSourceRasterLayout != null", "DTContainer.js(2587): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceRasterLayout) == "string", "typeof(sDragSourceRasterLayout) == \"string\"", "DTContainer.js(2588): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "DTContainer.js(2589): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "DTContainer.js(2590): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "DTContainer.js(2591): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "DTContainer.js(2592): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "DTContainer.js(2593): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "DTContainer.js(2594): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "DTContainer.js(2595): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "DTContainer.js(2596): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "DTContainer.js(2597): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "DTContainer.js(2598): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRasterPosX != null, "iRasterPosX != null", "DTContainer.js(2599): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRasterPosX) == "number", "typeof(iRasterPosX) == \"number\"", "DTContainer.js(2600): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRasterPosY != null, "iRasterPosY != null", "DTContainer.js(2601): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRasterPosY) == "number", "typeof(iRasterPosY) == \"number\"", "DTContainer.js(2602): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMultiDropRelPositions != null, "sMultiDropRelPositions != null", "DTContainer.js(2603): fireDropOnRaster"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMultiDropRelPositions) == "string", "typeof(sMultiDropRelPositions) == \"string\"", "DTContainer.js(2604): fireDropOnRaster"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DragTargetDTElement": sDragTargetDTElement,
		"DragSourceRasterLayout": sDragSourceRasterLayout,
		"DropTargetInfo": sDropTargetInfo,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"RasterPosX": iRasterPosX,
		"RasterPosY": iRasterPosY,
		"MultiDropRelPositions": sMultiDropRelPositions
	};
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("DTContainer", "DropOnRaster", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_DTContainer["_"]["fireDropOnRaster"] = 0; };

UCF_DTContainer.prototype["aPublicMethods"] = ["aListSelectedElements","updatePositions","oGetDTElement","oGetScrollDTElement","fireMove"].concat(UCF_DTContainer.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_DTContainerDropDelegate"] = function() {/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_DTContainerDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_DTContainerDropDelegate["_"]["UCF_DTContainerDropDelegate"]++; }; 
	if (arguments["length"] === 0) return;
	UCF_DropDelegate["apply"](this, [oLS]);
	this["oLS"] = oLS;
	this["setDropTargetControl"](oDropTargetControl);
};window["UCF_DTContainerDropDelegate"] = UCF_DTContainerDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DTContainerDropDelegate"); UCF_DTContainerDropDelegate["_"] = {UCF_DTContainerDropDelegate: 0}; }; ;
UCF_DTContainerDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_DTContainerDropDelegate.prototype["sClassName"] = "UCF_DTContainerDropDelegate";

UCF_DTContainerDropDelegate["prototype"]["onlsdrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTContainerDropDelegate["_"]["onlsdrop"]++; }; 
	var oDraggedControl = null;

	if (oBrowserEvent && oBrowserEvent["oDragAndDropManager"] && oBrowserEvent["oDragAndDropManager"]["oDragSession"]) {
		oDraggedControl = this["oLS"]["oControlFactory"]["oGetControlById"](oBrowserEvent["oDragAndDropManager"]["oDragSession"]["sGetDragSourceId"]());
		if (oDraggedControl && oDraggedControl["handleMoved"] &&
			('Move' in oBrowserEvent["oDragAndDropManager"]["oDragSession"]["mGetMatchingTags"](this["sGetDropTags"]())
				|| 'DROP_ON_CONTAINER' in oBrowserEvent["oDragAndDropManager"]["oDragSession"]["mGetMatchingTags"](this["sGetDropTags"]()))) {
			oDraggedControl["handleMoved"](oBrowserEvent);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_DTContainerDropDelegate["_"]["onlsdrop"] = 0; };

};
sap["ls"]["preload"]["UCF_DTElement"] = function() {/* global _assert, _trace, DEBUG, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DTElementDragDelegate */
/// <reference path="./delegates/DTElementDragDelegate.js"/>
/* global UCF_DTElementDropDelegate */
/// <reference path="./delegates/DTElementDropDelegate.js"/>
/* global UCF_DTElementRasterDragDelegate */
/// <reference path="./delegates/DTElementRasterDragDelegate.js"/>
/* global UCF_DTElementRasterDropDelegate */
/// <reference path="./delegates/DTElementRasterDropDelegate.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>
/* global UCF_DTContainer */
/// <reference path="./DTContainer.js"/>
/* global sap */

/**
 * Design Time Container Element.
 *
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 * @param {string} sId
 */
function UCF_DTElement(oDomRef, oLS, sId) {if (__UCF_COVERAGE__) { UCF_DTElement["_"]["UCF_DTElement"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "DTElement.js(47): UCF_DTElement"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DTElement.js(48): UCF_DTElement"); };

	UCF_Control["apply"](this, arguments);

	this["defineEvents"](['Select', 'Deselect', 'Scroll', 'Update']);

	this["oDTContainer"] = null;
	this["aValidControlIDs"] = null;
	this["oMyRect"] = null;
	this["oAbsoluteRect"] = null;
	this["bMouseOverAndHoverBorder"] = false;
	this["aNextLayerElements"] = null;
	this["aPreviousLayerElements"] = null;
	this["aSiblingLayerElements"] = null;
	this["bTooSmallForButtons"] = false;

	this["oResizeSession"] = null;

	this["bIsHidden"] = false; // Element can be hidden via ClientDTElement method
	this["oCalcContainer"] = null;
	this["oRefContainer"] = null; // The result of addLayeredElement()
	this["oMyScrollContainer"] = null; // The assoc. scroll-container in the DT content
	this["oMyParentScrollElement"] = null;
	this["oSCOverflow"] = null; // The DOM element of the assoc. control that is the ScrollArea (advanced SC support)
	this["bDragInProgress"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["bInitError"] = false;
	this["bPositioned"] = false;

	this["bSelected"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["bResizing"] = false;

	this["bTempRatio"] = false; // eslint-disable-line @ur/no-memory-leaks

	this["bOutlined"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["oDTExtension"] = null;

	this["bZIndexModified"] = false;
};window["UCF_DTElement"] = UCF_DTElement; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DTElement"); UCF_DTElement["_"] = {UCF_DTElement: 0}; }; ;

UCF_DTElement["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_DTElement.prototype["sClassName"] = "UCF_DTElement";

// TODO: Read from stylesheet in class lsDTBorder
UCF_DTElement["BORDER_SIZE"] = 2;

UCF_DTElement["prototype"]["eSelectionState"] = {
	"NONE": "SELECTABLE",
	"SELECTED": "SELECTED",
	"NOT_SELECTABLE": "UNSELECTABLE"
};

UCF_DTElement["prototype"]["HOVER_OPACITY"] = {
	"LAYER1": 25,
	"LAYER2": 50
};

UCF_DTElement["prototype"]["EXTENSION_EVENT"] = {
	"onElementSelect": 0,
	"onElementDeselect": 2,
	"onElementScroll": 3,
	"onElementPositonChanged": 4,
	"onElementHidden": 7,
	"onElementDragStart": 8,
	"onElementDragEnd": 9,
	"onElementDragCancel": 10,
	"onElementDrop": 11,
	"onElementKeyDown": 12,
	"onElementMouseOver": 13,
	"onElementMouseOut": 14,
	"onElementDragOver": 15,
	"onElementDrag": 16
};

UCF_DTElement["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["destroy"]++; }; 

	this["highlightPositionParent"](false);

	//detach to the DTContainer events for dragging
	if (!this["bInitError"] && this["oDTContainer"] && this["oDTContainer"]["E_EVENTS"]) {
		this["oDTContainer"]["detachEvent"](this["oDTContainer"]["E_EVENTS"]["DragStart"], this, "handleDragStateChange");
		this["oDTContainer"]["detachEvent"](this["oDTContainer"]["E_EVENTS"]["DragStop"], this, "handleDragStateChange");
	}

	if (this["oDomRef"] && this["oMyScrollContainer"] != null) {
		this["detachBrowserEvent"]("scroll", this["oDomRef"]);
	}

	this["oDTContainer"] = null;
	this["aControlIds"] = null;
	this["oMyRect"] = null;
	this["oAbsoluteRect"] = null;
	this["oCalcContainer"] = null;
	this["oRefContainer"] = null;
	this["oMyScrollContainer"] = null;
	this["oMyParentScrollElement"] = null;
	this["oSCOverflow"] = null;
	this["oDTExtension"] = null;
	this["oButtonRowDom"] = null;
	this["oActionMenuDom"] = null;
	if (this["oInplaceEditDelegate"]) {
		this["oInplaceEditDelegate"]["destroy"]();
		this["oInplaceEditDelegate"] = null;
	}
	this["oConnectedControl"] = null;
	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}

	this["oHoveredElement"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["destroy"] = 0; };

UCF_DTElement["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onmousedown"]++; }; 
	// If this is a special element for a scroll-container we are not interested in any events other than scroll
	if (this["oSCOverflow"]) return;

	if (oBrowserEvent["eGetMouseButtonState"]() === oBrowserEvent["MOUSE_BUTTON_STATE"]["Right"]) {
		return;
	}

	// Pressing a button shall not have an effect on selection
	var sTheId = oBrowserEvent["oGetSource"]()["id"] || "";
	if (sTheId === this["sId"] + '-config' || sTheId === this["sId"] + '-close' || sTheId === this["sId"] + '-buttonrow') {
		oBrowserEvent["cancelBubble"]();
		return;
	} else {
		this["setHoverDesign"](false);
	}

	// ActionMenuItem shall not have an effect on selection
	if (oBrowserEvent["oGetSource"]()["getAttribute"]("dt_ami") != null || oBrowserEvent["oGetSource"]()["id"] === this["sId"] + "-actionmenu") {
		oBrowserEvent["cancelBubble"]();
		return;
	}

	if (oBrowserEvent["bShift"]()) {
		return;
	}

	if (this["bIsPersonasEnabled"]() && !this["bIsSelectable"]()) {
		// Personas scenarios: RasterLayouts are not selectable => forward select to a selectable parent element
		// - A RasterLayout could completely cover the area of a ScrollContainer that is selectable
		// - A RasterLayout inside the content of a Group (without ScrollContainer)
		// Note: This workaround turned out to be a major Personas-WebGUI "feature". Without it, you cannot select or drag a group in its content area where the RasterLayout is layered on top...
		// Note: This also needs to be considered for drag-start, see DTContainer onlsdragstart()
		if (this["oGetConnectedControl"]() && this["oGetConnectedControl"]()["sClassName"] === "UCF_RasterLayout") {
			this["selectParent"](oBrowserEvent);
			return;
		}
	}

	this["oDTContainer"]["handleElementMouseDown"](this, oBrowserEvent["bCtrl"]());
	// TODO: This could also be an option for mouse-selection if it works reliably
	//if (this.bIsPersonasEnabled()) UCF_DTElement.handleOutsideViewPort(this);

};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onmousedown"] = 0; };

/**
 * Handle scroll-position of a DTElement that is about to be selected (via TAB-key in Personas).
 * @param {UCF_DTElement} oElement The element to handle
 * @private
 */
UCF_DTElement["handleOutsideViewPort"] = function(oElement) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["handleOutsideViewPort"]++; }; 
	var oRect = oElement["oGetAbsoluteRect"]();
	var oVisibleRect = UCF_DomUtil["oGetViewPort"](oElement["oDomRef"]);
	// if (console) console.log(">>> handleOutsideViewPort oRect: " + oRect.top + "," + oRect.left + "," + oRect.height + "," + oRect.width);
	// if (console) console.log(">>> handleOutsideViewPort oVisibleRect: " + oVisibleRect.top + "," + oVisibleRect.left + "," + oVisibleRect.height + "," + oVisibleRect.width);
	var BORDER = 2;
	if (oRect["height"] > oVisibleRect["height"] + BORDER && oRect["top"] === oVisibleRect["top"]) {
		// Cut off at the bottom
		oElement["oDomRef"]["scrollIntoView"](false);
	} else if (oRect["top"] + BORDER < oVisibleRect["top"] && oRect["top"] < oVisibleRect["top"]) {
		// Cut off at the top
		oElement["oDomRef"]["scrollIntoView"](true);
	} else if (oRect["width"] > oVisibleRect["width"] + BORDER || oRect["left"] + BORDER < oVisibleRect["left"]) {
		// Cut off left or right
		oElement["oDomRef"]["scrollIntoView"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["handleOutsideViewPort"] = 0; };

UCF_DTElement["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onkeydown"]++; }; 
	var iKey = oBrowserEvent["iKeyCode"]();
	if (iKey === UCF_KeyCodes["SPACE"]) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		return;
	}
	if (this["bIsPersonasEnabled"]() && iKey === UCF_KeyCodes["TAB"]) {
		if (!this["oDTContainer"]["bEnableAdvancedElementFeatures"]) return;
		var oDTElement;
		if (!oBrowserEvent["bShift"]() && !oBrowserEvent["bCtrl"]() && !oBrowserEvent["bAlt"]()) {
			oDTElement = this["oDTContainer"]["getNextDTElementInControlOrder"](this, true);
			if (oDTElement) {
				this["oDTContainer"]["handleElementMouseDown"](oDTElement, false);
				oDTElement["focus"]();
				UCF_DTElement["handleOutsideViewPort"](oDTElement);
				this["oDTContainer"]["updateHitZones"]();
			}
		} else if (oBrowserEvent["bShift"]() && !oBrowserEvent["bCtrl"]() && !oBrowserEvent["bAlt"]()) {
			oDTElement = this["oDTContainer"]["getPreviousDTElementInControlOrder"](this, true);
			if (oDTElement) {
				this["oDTContainer"]["handleElementMouseDown"](oDTElement, false);
				oDTElement["focus"]();
				UCF_DTElement["handleOutsideViewPort"](oDTElement);
				this["oDTContainer"]["updateHitZones"]();
			}
		}
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		return;
	}
	if (iKey === UCF_KeyCodes["F2"] && !oBrowserEvent["bAlt"]() && !oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]()) {
		if (this["bHasEventListeners"]("InplaceEditStart")) {
			this["fireInplaceEditStart"](this["sId"]);
		} else {
			// Hmm... let's fake the parameter, otherwise we would have to fire an event from this to this
			this["onInplaceEditStart"]({ "mParameters": { "oBrowserEvent": oBrowserEvent } });
		}
	} else if (this["bIsPersonasEnabled"]() && iKey === UCF_KeyCodes["ESCAPE"] && !oBrowserEvent["bAlt"]() && !oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]()) {
		if (!this["oDTContainer"]["bEnableAdvancedElementFeatures"]) return;
		this["selectParent"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onkeydown"] = 0; };

/**
 * @private
 */
UCF_DTElement["prototype"]["selectParent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["selectParent"]++; }; 
	var oControl = this["oGetConnectedControl"]();
	var oDTElement, oParent;
	if (oControl) {
		oDTElement = null;
		oParent = oControl["oGetParent"]();
		while (oParent) {
			oDTElement = this["oDTContainer"]["oGetDTElement"](oParent["sGetId"]());
			if (oDTElement && oDTElement["sSelectionState"] !== this["eSelectionState"]["NOT_SELECTABLE"]) {
				break;
			}
			oParent = oParent["oGetParent"]();
		}
		if (oDTElement) {
			this["oDTContainer"]["handleElementMouseDown"](oDTElement, oBrowserEvent["bCtrl"]());
			this["oDTContainer"]["updateHitZones"]();
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["cancel"]();
		}
	} else {
		//check whether there is a control id and select the parent based on that. This is the case for sap table header cell currently
		oDTElement = null;
		oParent = this["oLS"]["oGetControlByDomRef"](UCF_DomUtil["$"](this["sControlIds"]));
		while (oParent) {
			oDTElement = this["oDTContainer"]["oGetDTElement"](oParent["sGetId"]());
			if (oDTElement && oDTElement["sSelectionState"] !== this["eSelectionState"]["NOT_SELECTABLE"]) {
				break;
			}
			oParent = oParent["oGetParent"]();
		}
		if (oDTElement) {
			this["oDTContainer"]["handleElementMouseDown"](oDTElement, oBrowserEvent["bCtrl"]());
			this["oDTContainer"]["updateHitZones"]();
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["selectParent"] = 0; };

UCF_DTElement["prototype"]["calculateAbsoluteRect"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["calculateAbsoluteRect"]++; }; 
	this["oAbsoluteRect"] = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["calculateAbsoluteRect"] = 0; };

UCF_DTElement["prototype"]["oGetAbsoluteRect"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetAbsoluteRect"]++; }; 
	if (!this["oAbsoluteRect"]) {
		this["calculateAbsoluteRect"]();
	}
	return this["oAbsoluteRect"];
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetAbsoluteRect"] = 0; };

UCF_DTElement["prototype"]["setOutline"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setOutline"]++; }; 
	UCF_DomUtil["removeClass"](this["oDomRef"], "lsDTOutlineDefault");
	UCF_DomUtil["removeClass"](this["oDomRef"], "lsDTOutlineDashed");
	UCF_DomUtil["removeClass"](this["oDomRef"], "lsDTBorderUnselected");
	if (sValue === "NONE") {
		UCF_DomUtil["addClass"](this["oDomRef"], "lsDTBorderUnselected");
		this["sOutline"] = sValue; // eslint-disable-line @ur/no-memory-leaks
		this["setClientProperty"]("Outline", sValue);
	} else if (sValue === "DEFAULT") {
		UCF_DomUtil["addClass"](this["oDomRef"], "lsDTOutlineDefault");
		this["sOutline"] = sValue;
		this["setClientProperty"]("Outline", sValue);
	} else if (sValue === "DASHED") {
		UCF_DomUtil["addClass"](this["oDomRef"], "lsDTOutlineDashed");
		this["sOutline"] = sValue;
		this["setClientProperty"]("Outline", sValue);
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setOutline"] = 0; };

UCF_DTElement["prototype"]["getDropTags"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["getDropTags"]++; }; 
	var aTags = [];
	var oDropTargetInfoControl;
	if (this["sDropTargetInfoTop"]) {
		oDropTargetInfoControl = this["oGetControlById"](this["sDropTargetInfoTop"]);
		if (oDropTargetInfoControl) {
			aTags["push"](oDropTargetInfoControl["sGetTags"]());
		}
	}

	if (this["sDropTargetInfoAbove"]) {
		oDropTargetInfoControl = this["oGetControlById"](this["sDropTargetInfoAbove"]);
		if (oDropTargetInfoControl) {
			aTags["push"](oDropTargetInfoControl["sGetTags"]());
		}
	}

	if (this["sDropTargetInfoBefore"]) {
		oDropTargetInfoControl = this["oGetControlById"](this["sDropTargetInfoBefore"]);
		if (oDropTargetInfoControl) {
			aTags["push"](oDropTargetInfoControl["sGetTags"]());
		}
	}

	if (this["sDropTargetInfoAfter"]) {
		oDropTargetInfoControl = this["oGetControlById"](this["sDropTargetInfoAfter"]);
		if (oDropTargetInfoControl) {
			aTags["push"](oDropTargetInfoControl["sGetTags"]());
		}
	}

	if (this["sDropTargetInfoBelow"]) {
		oDropTargetInfoControl = this["oGetControlById"](this["sDropTargetInfoBelow"]);
		if (oDropTargetInfoControl) {
			aTags["push"](oDropTargetInfoControl["sGetTags"]());
		}
	}
	return aTags["join"](" ");
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["getDropTags"] = 0; };

UCF_DTElement["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onclick"]++; }; 
	// If this is a special element for a scroll-container we are not interested in any events other than scroll
	if (this["oSCOverflow"]) return;

	var oSourceDom = oBrowserEvent["oGetSource"]();

	if (oBrowserEvent["oGetSource"]()["getAttribute"]("dt_ami") != null) {
		this["fireActionPress"](this["sId"], oBrowserEvent["oGetSource"]()["id"]);
		return;
	} else if (oSourceDom["tagName"] === "A") {
		this["fireButtonPress"](this["sId"], oSourceDom["getAttribute"]("dtbuttonname")["toUpperCase"]());
		return;
	}
	if (oSourceDom["id"] && oSourceDom["id"]["indexOf"]("-resizehandle-") > -1) {
		this["stopResize"]();
		oBrowserEvent["cancel"]();
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onclick"] = 0; };

UCF_DTElement["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["ondblclick"]++; }; 
	// If this is a special element for a scroll-container we are not interested in any events other than scroll
	if (this["oSCOverflow"]) return;
	oBrowserEvent["cancelBubble"]();

	if (oBrowserEvent["oGetSource"]()["getAttribute"]("dt_ami") != null || oBrowserEvent["oGetSource"]()["id"] === this["sId"] + "-actionmenu") {
		return;
	}
	var sTheId = oBrowserEvent["oGetSource"]()["id"] || "";
	if (sTheId["indexOf"]("-resizehandle-") > -1) {
		return;
	}
	var oSourceDom = oBrowserEvent["oGetSource"]();
	if (oSourceDom["tagName"] === "A") {
		return;
	} else {
		if (this["bIsSelectable"]()) {
			if (this["bHasEventListeners"]("DoubleClick")) {
				this["fireDoubleClick"](this["sId"]);
				return;
			}

			// On elements that have no special handling for DC event it can be
			// used to activate InplaceEdit
			if (this["bHasEventListeners"]("InplaceEditStart")) {
				this["fireInplaceEditStart"](this["sId"]);
				return;
			}
			if (!this["oInplaceEditDelegate"] && this["getClientControl"]() && this["getClientControl"]()["getInplaceEditRefId"]()) {
				this["setInplaceEditable"](this["getClientControl"]()["getInplaceEditRefId"]());
			}
			if (this["oInplaceEditDelegate"] && !this["oDTContainer"]["bHasMultiSelection"]()) {
				this["oInplaceEditDelegate"]["openInplaceEdit"](oBrowserEvent);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["ondblclick"] = 0; };

/**
 * Called by DTElementDragDelegate.onlsdragend()
 */
UCF_DTElement["prototype"]["forwardDDCancel"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["forwardDDCancel"]++; }; 
	this["oDTContainer"]["handleDDCancel"]();

	this["fireDragEnd"](this["sId"], this["sDragSourceInfo"]);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["forwardDDCancel"] = 0; };

UCF_DTElement["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onmouseover"]++; }; 
	if (this["oDTContainer"]["bResizing"] ||
		this["oDTContainer"]["oSelectionRectangleSession"] ||
		oBrowserEvent["bShift"]() ||
		this["bDragInProgress"]
		/*||
		oBrowserEvent.eGetMouseButtonState() != oBrowserEvent.MOUSE_BUTTON_STATE.None*/
	) {
		return;
	};

	if (this["fireExtensionEvent"](this["EXTENSION_EVENT"]["onElementMouseOver"], "before", oBrowserEvent)) return;

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource["id"] === this["sId"] + "-config" || oSource["id"] === this["sId"] + "-close") {
		oSource["className"] += "  lsDTButtonHover";
	}
	// Avoid flickering effect when the mouse moves slowly over borders
	var sFromId = null;
	if (oBrowserEvent["oDomEvent"]["fromElement"]) {
		sFromId = oBrowserEvent["oDomEvent"]["fromElement"]["id"];
	} else if (oBrowserEvent["oDomEvent"]["relatedTarget"]) {
		sFromId = oBrowserEvent["oDomEvent"]["relatedTarget"]["id"];
	}
	if (sFromId && sFromId["indexOf"](this["sId"]) === 0) {
		return;
	}
	if (this["oDTContainer"]["oHoveredElement"]) {
		this["oDTContainer"]["oHoveredElement"]["setHoverDesign"](false);
	}
	this["setHoverDesign"](true);
	this["oDTContainer"]["oHoveredElement"] = this;

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

	if (this["fireExtensionEvent"](this["EXTENSION_EVENT"]["onElementMouseOver"], "after", oBrowserEvent)) return;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onmouseover"] = 0; };

UCF_DTElement["prototype"]["destroyControlDTDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["destroyControlDTDelegate"]++; }; 
	var oControl = this["oGetConnectedControl"]();
	if (oControl && oControl["getClientControl"]()) {
		oControl["destroyDTDelegate"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["destroyControlDTDelegate"] = 0; };

UCF_DTElement["prototype"]["setHoverDesign"] = function(bOnOff) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setHoverDesign"]++; }; 
	if (!this["oDTContainer"]) {
		return;
	}
	if (this["oDTContainer"]["oSelectionRectangleSession"]) {
		return;
	}
	var oHover, i, o;
	// This is an additional hover-effect that uses CSS-outline - It is incompatible with "Outline" API-parameter
	var oCC = this["oGetConnectedControl"]();
	var oDTCC = this["oDTContainer"]["getClientControl"]();
	if ((oCC && !oCC["bGetInvisibility"]() || this["bHasConnectedSubControl"]()) &&
		oDTCC && oDTCC["bPersonasEnabled"] && oDTCC["bHoverOutline"] &&
		this["bIsSelectable"]() && (!this["bIsSelected"]() /*&& !this.sSelectionForwardedTo*/ )) {

		if (bOnOff) {
			this["oDomRef"]["style"]["transition"] = "outline-color 500ms ease-in";
			this["oDomRef"]["style"]["outlineColor"] = "";
			UCF_DomUtil["addClass"](this["oDomRef"], "lsDTHoverOutline");
		} else {
			this["oDomRef"]["style"]["transition"] = "";
			UCF_DomUtil["removeClass"](this["oDomRef"], "lsDTHoverOutline");
			this["oDomRef"]["style"]["outlineColor"] = "transparent";
		}
		return;
	}

	if (bOnOff) {
		if (this["sGetLayerDesignParameter"]() !== "NONE") {

			oHover = UCF_DomUtil["$"](this["sId"] + "-hover"); // UCF_DomUtil.firstChild(this.oDomRef);

			if (this["sGetLayerDesignParameter"]() === "DEFAULT") {
				this["oDTContainer"]["setOpacity"](oHover, 80);
				if (this["_bHiddenDesign"]) {
					oHover["className"] = "lsDTElement--hover lsDTHoverColor";
				} else {
					oHover["className"] = "lsDTElement--hover lsDTHoverColor";
				}
			} else if (this["sGetLayerDesignParameter"]() === "LAYER_AND_HOVER") {
				this["bMouseOverAndHoverBorder"] = true;
				this["setPermamentHoverEffect"](true, 1);

				// "Inverted" hover-effect and border for ancestor elements
				this["findAncestorLayerElements"](false);
				for (i = 0; i < this["aNextLayerElements"]["length"]; i++) {
					this["aNextLayerElements"][i]["setPermamentHoverEffect"](true, 2);
				}
				for (i = 0; i < this["aPreviousLayerElements"]["length"]; i++) {
					this["aPreviousLayerElements"][i]["setPermamentHoverEffect"](true, 0);
				}
			}

			// Show config button
			if (this["oButtonRowDom"]) {
				o = UCF_DomUtil["$"](this["sId"] + '-config');
				if (o) {
					o["style"]["visibility"] = "visible";
				}
			}

		}
	} else {
		if (this["sGetLayerDesignParameter"]() !== "NONE") {

			if (this["sGetLayerDesignParameter"]() === "DEFAULT") {
				oHover = UCF_DomUtil["$"](this["sId"] + "-hover"); // UCF_DomUtil.firstChild(this.oDomRef);

				if (this["_bHiddenDesign"]) {
					this["oDTContainer"]["setOpacity"](oHover, 50);
					oHover["className"] = "lsDTElement--hover lsDTLayerColorLight";
				} else {
					this["oDTContainer"]["setOpacity"](oHover, 0);
					oHover["className"] = "lsDTElement--hover lsDTHoverColorOff";
				}

			} else if (this["sGetLayerDesignParameter"]() === "LAYER_AND_HOVER") {
				this["setPermamentHoverEffect"](false, 1);

				// Remove "Inverted" hover-effect and border for ancestor elements
				this["findAncestorLayerElements"](false);
				for (i = 0; i < this["aNextLayerElements"]["length"]; i++) {
					this["aNextLayerElements"][i]["setPermamentHoverEffect"](false, 2);
				}
				for (i = 0; i < this["aPreviousLayerElements"]["length"]; i++) {
					this["aPreviousLayerElements"][i]["setPermamentHoverEffect"](false, 0);
				}
			}

			// Hide config button
			if (this["oButtonRowDom"]) {
				o = UCF_DomUtil["$"](this["sId"] + '-config');
				if (o) {
					o["style"]["visibility"] = "hidden";
				}
			}

		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setHoverDesign"] = 0; };

UCF_DTElement["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onmouseout"]++; }; 
	if (this["oDTContainer"]["oSelectionRectangleSession"]) {
		return;
	}

	if (this["bDragInProgress"]) return;

	var oSource = oBrowserEvent["oGetSource"]();

	// Avoid flickering on separators between buttons
	if (oSource["id"] === this["sId"] + "-buttonrow") {
		return;
	}

	var sToId = null;
	if (oBrowserEvent["oDomEvent"]["toElement"]) {
		sToId = oBrowserEvent["oDomEvent"]["toElement"]["id"];
	} else if (oBrowserEvent["oDomEvent"]["relatedTarget"]) {
		sToId = oBrowserEvent["oDomEvent"]["relatedTarget"]["id"];
	}

	// Button hover-effect
	if (oSource["id"] === this["sId"] + "-config") {
		oSource["className"] = "lsDTElement--button lsDTButtonConfig";
		// If we leave the element via a button there is no mouseout event on the element-DIV ot hover-DIV (?)
		if (sToId && sToId["indexOf"](this["sId"]) === -1) {
			this["setHoverDesign"](false);
		}
		return;
	} else if (oSource["id"] === this["sId"] + "-close") {
		oSource["className"] = "lsDTElement--button lsDTButtonClose";
		if (sToId && sToId["indexOf"](this["sId"]) === -1) {
			this["setHoverDesign"](false);
		}
		return;
	}

	// Avoid flickering effect when the mouse moves slowly over borders
	if (sToId && sToId["indexOf"](this["sId"]) === 0) {
		return;
	}
	// Avoid flickering when using selection-rectangle over element with hover effect
	if (sToId && sToId === this["oDTContainer"]["ID_SEL_RECT"]) {
		return;
	}
	if (this["fireExtensionEvent"](this["EXTENSION_EVENT"]["onElementMouseOut"], "before", oBrowserEvent)) return;

	this["bMouseOverAndHoverBorder"] = false;
	this["setHoverDesign"](false);

	if (this["fireExtensionEvent"](this["EXTENSION_EVENT"]["onElementMouseOut"], "after", oBrowserEvent)) return;

};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onmouseout"] = 0; };

UCF_DTElement["prototype"]["removeHoverStyle"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["removeHoverStyle"]++; }; 
	this["setHoverDesign"](false);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["removeHoverStyle"] = 0; };

/**
 * Search for:
 * 1. Elements with "this.zIndex + 1" inside the bounds of this element.
 * 2. The elements with "this.zIndex - 1" that is the "parent" of this element.
 * 3. Elements with the same zIndex and "parent" as this element.
 *
 * This "feature" requires that the ZIndex parameter of all elements is set properly and uses an increment of 1.
 * @private
 */
UCF_DTElement["prototype"]["findAncestorLayerElements"] = function(bSeparateSiblings) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["findAncestorLayerElements"]++; }; 
	if (this["aNextLayerElements"] == null) {
		var oParent = null;
		this["aNextLayerElements"] = [];
		this["aPreviousLayerElements"] = [];
		this["aSiblingLayerElements"] = [];
		var i, l, oElement;
		for (i = 0, l = this["oDTContainer"]["aElements"]["length"]; i < l; i++) {
			oElement = this["oDTContainer"]["aElements"][i];
			if (oElement["bInitError"] /*.oDomRef.style.display == "none"*/ ) {
				// Has an invalid control ID -> no rect
				continue;
			}
			if (oElement["oMyRect"] == null) {
				// How can this happen ?
				continue;
			}
			if (oElement["iZIndex"] === this["iZIndex"] + 1
				&& oElement["oMyRect"]["top"] <= this["oMyRect"]["top"] + this["oMyRect"]["height"]
				&& oElement["oMyRect"]["top"] >= this["oMyRect"]["top"]
				&& oElement["oMyRect"]["left"] >= this["oMyRect"]["left"]
				&& oElement["oMyRect"]["left"] <= this["oMyRect"]["left"] + this["oMyRect"]["width"]) {

				this["aNextLayerElements"]["push"](oElement);
			} else {
				if (oParent == null
					&& oElement["iZIndex"] === this["iZIndex"] - 1
					&& this["oMyRect"]["top"] <= oElement["oMyRect"]["top"] + oElement["oMyRect"]["height"]
					&& this["oMyRect"]["top"] >= oElement["oMyRect"]["top"]
					&& this["oMyRect"]["left"] >= oElement["oMyRect"]["left"]
					&& this["oMyRect"]["left"] <= oElement["oMyRect"]["left"] + oElement["oMyRect"]["width"]) {

					this["aPreviousLayerElements"]["push"](oElement);
					oParent = oElement;
				}
			}
		}
		if (oParent) {
			for (i = 0, l = this["oDTContainer"]["aElements"]["length"]; i < l; i++) {
				oElement = this["oDTContainer"]["aElements"][i];
				if (oElement["iZIndex"] === this["iZIndex"]
					&& oElement["sId"] !== this["sId"]
					&& oElement["oMyRect"]["top"] <= oParent["oMyRect"]["top"] + oParent["oMyRect"]["height"]
					&& oElement["oMyRect"]["top"] >= oParent["oMyRect"]["top"]
					&& oElement["oMyRect"]["left"] >= oParent["oMyRect"]["left"]
					&& oElement["oMyRect"]["left"] <= oParent["oMyRect"]["left"] + oParent["oMyRect"]["width"]) {

					if (bSeparateSiblings) this["aSiblingLayerElements"]["push"](oElement);
					else this["aPreviousLayerElements"]["push"](oElement);
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["findAncestorLayerElements"] = 0; };

/**
 * @param {boolean} bOn
 * @param {number} iLayer 1: hovered element, 2: child elements, 0: parent and sibling elements
 * @private
 */
UCF_DTElement["prototype"]["setPermamentHoverEffect"] = function(bOn, iLayer) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setPermamentHoverEffect"]++; }; 
	var oHover = UCF_DomUtil["$"](this["sId"] + "-hover");

	if (bOn) {
		if (iLayer === 2 || iLayer === 0) {
			oHover["className"] = "lsDTElement--hover urBorderBox lsDTPermanentHoverColorLayer2";
			this["oDTContainer"]["setOpacity"](oHover, this["HOVER_OPACITY"]["LAYER2"]);
		} else {
			oHover["className"] = "lsDTElement--hover urBorderBox lsDTPermanentHoverColor";

			this["oDTContainer"]["setOpacity"](oHover, this["HOVER_OPACITY"]["LAYER1"]);
		}

		if (iLayer !== 0) {
			// Show hover-border only if there is not already a selection-border
			if (this["sSelectionState"] !== this["eSelectionState"]["SELECTED"]) {
				this["oDomRef"]["className"] = "lsDTElement urBorderBox lsDTHoverBorder";
				this["adjustButtonPositionForBorder"](true);
			}
		}
	} else {
		oHover["className"] = "lsDTElement--hover urBorderBox lsDTPermanentHoverColorOff";
		if (iLayer === 2 || iLayer === 0) {
			this["oDTContainer"]["setOpacity"](oHover, this["HOVER_OPACITY"]["LAYER1"]);
		}

		if (iLayer !== 0) {
			if (this["sSelectionState"] !== this["eSelectionState"]["SELECTED"]) {
				this["oDomRef"]["className"] = "lsDTElement urBorderBox lsDTBorderUnselected";
				this["adjustButtonPositionForBorder"](false);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setPermamentHoverEffect"] = 0; };

/**
 * Adjust button position when 2px border is shown or reset button position when border is removed.
 */
UCF_DTElement["prototype"]["adjustButtonPositionForBorder"] = function(bOn) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["adjustButtonPositionForBorder"]++; }; 
	if (this["oButtonRowDom"]) {
		if (bOn) {
			this["oButtonRowDom"]["style"]["marginTop"] = UCF_DTElement["BORDER_SIZE"] + "px";
			this["oButtonRowDom"]["style"]["marginLeft"] = "-" + UCF_DTElement["BORDER_SIZE"] + "px";
			if (this["bTooSmallForButtons"]) {
				this["oButtonRowDom"]["style"]["top"] = (-this["oMyRect"]["height"] - 8) + "px";
			}
		} else {
			this["oButtonRowDom"]["style"]["marginTop"] = "0px";
			this["oButtonRowDom"]["style"]["marginLeft"] = "0px";
			if (this["bTooSmallForButtons"]) {
				this["oButtonRowDom"]["style"]["top"] = (-this["oMyRect"]["height"] - 4) + "px";
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["adjustButtonPositionForBorder"] = 0; };

UCF_DTElement["prototype"]["init"] = function(oDTContainer, iZIndex) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["init"]++; }; 
	this["oDTContainer"] = oDTContainer;
	if (UCF_StringUtil["sTrim"](this["sControlIds"]) === "") {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "DTElement parameter sControlIds is empty", "DTElement.js(789): init"); };
		this["bInitError"] = true;
		this["oDomRef"]["style"]["display"] = "none";
		return;
	}
	this["aControlIds"] = this["sControlIds"]["split"](" ");
	this["aValidControlIDs"] = [];

	this["setZIndex"]((this["iZIndex"] === -1) ? iZIndex : this["iZIndex"]);

	if (this["sSelectionState"] === this["eSelectionState"]["SELECTED"]) {
		this["displayResizeHandles"](true);
	}

	this["oButtonRowDom"] = UCF_DomUtil["$"](this["sId"] + "-buttonrow");
	this["oActionMenuDom"] = UCF_DomUtil["$"](this["sId"] + "-actionmenu");

	this["oFocusDomRef"] = UCF_DomUtil["$"](this["sId"] + "-focus");
	var o;
	if (!this["oFocusDomRef"]) {
		o = document["createElement"]("DIV");
		o["setAttribute"]("id", this["sId"] + "-focus");
		o["style"]["position"] = "absolute";
		o["style"]["top"] = "0px";
		o["style"]["left"] = "0px";
		o["style"]["width"] = "0px";
		o["style"]["height"] = "0px";
		o["style"]["outline"] = "none"; // overwrite Belize focus rect
		this["oDomRef"]["appendChild"](o);
		this["oFocusDomRef"] = o;
	}

	// Validate the given control IDs
	for (var i = 0; i < this["aControlIds"]["length"]; i++) {
		o = UCF_DomUtil["$"](this["aControlIds"][i] + "-r") || UCF_DomUtil["$"](this["aControlIds"][i]);
		if (o != null) {
			this["aValidControlIDs"]["push"](this["aControlIds"][i]);
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "DTElement " + this["sId"] + ": did not find DOM element for id " + this["aControlIds"][i], "DTElement.js(827): init"); };
		}
	}

	if (this["aValidControlIDs"]["length"] === 0) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "DTElement " + this["sId"] + " has no valid referencing control ids", "DTElement.js(832): init"); };
		this["bInitError"] = true;
		this["oDomRef"]["style"]["display"] = "none";
		return;
	}
	this["createDTExtension"]();

	//attach to the DTContainer events for dragging
	this["oDTContainer"]["attachEvent"](this["oDTContainer"]["E_EVENTS"]["DragStart"], this, "handleDragStateChange");
	this["oDTContainer"]["attachEvent"](this["oDTContainer"]["E_EVENTS"]["DragStop"], this, "handleDragStateChange");

	this["oCalcContainer"] = this["oDTContainer"]["oCalcContainer"];
	var oExt;
	if (window["UCF_System"]["sDevice"] === "standards") {
		// In standards mode we support scroll containers...
		if (this["oDTContainer"]["bScrollContainerSupport"]) {
			oExt = this["oGetDTExtensionForId"](this["aValidControlIDs"][0], this);
			if (oExt) {
				var oRefFor = oExt["oGetDomRefForParentPosRefContainer"]();
				if (oRefFor == null) {
					oRefFor = UCF_DomUtil["$"](this["aValidControlIDs"][0])["parentNode"];
				}
				var oCC = this["oGetParentPositionReferenceContainer"](oRefFor, true, this["oDTContainer"]["oDomRef"]);
				if (oCC) {
					if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "PPRC: sId=" + this["sId"] + ", PPRC.id=" + oCC["id"] || oCC["parentNode"]["id"] || oCC["parentNode"]["parentNode"]["id"], "DTElement.js(856): init"); };

					this["oCalcContainer"] = oCC;

					if (!this["oDTContainer"]["bScrollContainerSupportAdvanced"]) {
						// The element DIVs will be relocated in the DOM and added to the scroll-container in the content
						this["oRefContainer"] = UCF_DTElement["oAddLayeredElement"](this["oDomRef"], null, this["oCalcContainer"]);

						// Grab the focus when selecting DTElements (if not in a scroll-container the DTContainer would do this)
						this["oRefContainer"]["tabIndex"] = 0;
					}
					// else: In this mode the element DIVs will be relocated in the DOM and added to the scroll-elements
					// See DTContainer initElements()
				}
			}
		}

		// For advanced scroll-container support, a special scroll-element that references a control with ScrollArea in the content
		// will have the same scrollbars and forward the scroll position to the "real" scroll-container...
		if (this["oDTContainer"]["bScrollContainerSupportAdvanced"] && this["bIsScrollElement"] && this["aValidControlIDs"]["length"] === 1) {
			var oSomeControl = this["oGetControlById"](this["aValidControlIDs"][0]);
			if (oSomeControl) {
				oExt = oSomeControl["oGetDTExtension"](this);
				this["oSCOverflow"] = oExt["oGetScrollAreaDomRef"]();
				this["bSapTableScrollingMode"] = false; // eslint-disable-line @ur/no-memory-leaks
				if (this["oSCOverflow"] == null) {
					this["oSCOverflow"] = oExt["oGetSpecialScrollAreaDomRef"]();
					this["bSapTableScrollingMode"] = (this["oSCOverflow"] != null);
				}

				if (this["oSCOverflow"]) {
					// Force the scrollWidth/Height to the same values as the assoc. SC
					this["oMyScrollContainer"] = oSomeControl;
					var oInner = UCF_DomUtil["$"](this["sId"] + "-hover");

					// IE correction-pixel to prevent horiz. scrollbar on the element when the original also has no scrollbar (??)
					var x = (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) ? 1 : 0;
					if (this["bSapTableScrollingMode"]) {
						oInner["style"]["height"] = oExt["oGetSpecialScrollAreaScrollWH"]()["height"] + "px";
						oInner["style"]["width"] = (oExt["oGetSpecialScrollAreaScrollWH"]()["width"] - x) + "px";
					} else {
						var iVerticalScrollbarOffset = this["oSCOverflow"]["offsetWidth"] - this["oSCOverflow"]["clientWidth"];
						//if (iVerticalScrollbarOffset > 0) iVerticalScrollbarOffset += 2;
						oInner["style"]["height"] = (this["oSCOverflow"]["scrollHeight"] - iVerticalScrollbarOffset) + "px";
						oInner["style"]["width"] = (this["oSCOverflow"]["scrollWidth"] - x) + "px";
					}

					oInner["style"]["position"] = "absolute";
					oInner["style"]["top"] = "-2px";
					oInner["style"]["left"] = "-2px";
					if (UCF_UserAgent["bIsChromium"]()) {
						// Workaround for Chrome unnecessary scrollbars:
						// Needs CS-rendering! Must set to "auto" in ClientDTElement.onAfterRendering
						this["oDomRef"]["style"]["overflow"] = "";
					} else {
						this["oDomRef"]["style"]["overflow"] = "auto";
					}

					// Initial scroll position...
					if (this["bSapTableScrollingMode"]) {
						var p = oExt["getScrollPosition"]();
						this["oDomRef"]["scrollTop"] = p["top"];
						this["oDomRef"]["scrollLeft"] = p["left"];
					} else {
						this["oDomRef"]["scrollTop"] = this["oSCOverflow"]["scrollTop"];
						this["oDomRef"]["scrollLeft"] = this["oSCOverflow"]["scrollLeft"];
					}

					if ((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
						this["attachBrowserEvent"]("scroll", this["oDomRef"]);
					}
				} else {
					if (this["sSelectionState"] != "SELECTABLE" && this["sSelectionState"] != "SELECTED") {
						// The control returns no ScrollArea. This is not an error:
						// Only some special internal conditions or parameter combinations may create a ScrollArea, which is unknown to the framework/engine that renders the designtime elements.
						if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Adv. SC support: Control " + this["sId"] + " has returned no ScrollArea DOM ref.", "DTElement.js(931): init"); };
						this["oDomRef"]["style"]["display"] = "none";
					}
				}
			}
		}
		// Init. outline values for hover effect
		if (this["oDTContainer"]["getClientControl"]() && this["oDTContainer"]["getClientControl"]()["bPersonasEnabled"] && this["oDTContainer"]["getClientControl"]()["bHoverOutline"]) {
			//UCF_DomUtil.addClass(this.oDomRef, "lsDTHoverOutline");
			this["oDomRef"]["style"]["outlineColor"] = "transparent";
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["init"] = 0; };

/**
 * Forward scroll position of the element to the underlying scroll-container in the content.
 * @private
 * @param oBrowserEvent
 */
UCF_DTElement["prototype"]["onscroll"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onscroll"]++; }; 
	oBrowserEvent["cancelBubble"]();
	this["forwardScrollPositionToContent"]();
	this["fireEvent"](this["E_EVENTS"]["Scroll"], { "oDTElement": this });
	if (this["oDTContainer"]["bHasMultiSelection"]()) {
		this["highlightPositionParent"](false);
	} else {
		this["highlightPositionParent"](true);
	}
	this["oDTContainer"]["updateHitZones"]();
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onscroll"] = 0; };

/**
 * Called by DTElementRasterDropDelegate for dragscroll feature.
 * @private
 * @param iDeltaTop
 * @param iDeltaLeft
 */
UCF_DTElement["prototype"]["scrollDelta"] = function(iDeltaTop, iDeltaLeft) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["scrollDelta"]++; }; 
	if (iDeltaTop === 0 && iDeltaLeft === 0) return;
	this["oDomRef"]["scrollTop"] += iDeltaTop;
	this["oDomRef"]["scrollLeft"] += iDeltaLeft;
	this["forwardScrollPositionToContent"]();
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["scrollDelta"] = 0; };

/**
 * @private
 */
UCF_DTElement["prototype"]["forwardScrollPositionToContent"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["forwardScrollPositionToContent"]++; }; 
	if (this["oMyScrollContainer"] == null) return;

	if (this["bSapTableScrollingMode"]) {
		this["oGetDTExtension"]()["forwardScrollPosition"](this["oDomRef"]["scrollLeft"], 0);
		return;
	}

	var x = 0; //this.bIsIE8or9() ? 17 : 0;
	if (this["oMyScrollContainer"]["oScrollArea"]) {
		this["oMyScrollContainer"]["oScrollArea"]["setIgnoreScrollEvent"](true); // Note: The ignore-flag is reset during setScrollPostition call.
		this["oMyScrollContainer"]["oScrollArea"]["setScrollPosition"](this["oDomRef"]["scrollTop"] + x, this["oDomRef"]["scrollLeft"]);
		var oClientControl = this["oMyScrollContainer"]["getClientControl"]();
		if (oClientControl && oClientControl["setScrollTop"]) {
			oClientControl["setScrollTop"](this["oDomRef"]["scrollTop"] + x, true);
		}
		if (oClientControl && oClientControl["setScrollLeft"]) {
			oClientControl["setScrollLeft"](this["oDomRef"]["scrollLeft"], true);
		}
	} else {
		// Special handling for Accordion because it does not create an UCF_ScrollArea in some cases
		this["oSCOverflow"]["scrollTop"] = this["oDomRef"]["scrollTop"] + x;
		this["oSCOverflow"]["scrollLeft"] = this["oDomRef"]["scrollLeft"];
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["forwardScrollPositionToContent"] = 0; };

/**
 * Copy of UCF_DomUtil function (21.11.2013). The IE-workaround with nextSibling does not work for us in advanced SC support:
 * The layered element container must be the first child of the SC - BEFORE the RL - because of z-index order!
 * Also needed "padding hack"
 *
 * @param oDomRefLayered
 * @param oDomRefTopLayerArea
 * @param oDomRefReferenceContainer
 * @param bInitialSize
 * @returns The resulting parent element of the oDomRefLayered element.
 */
UCF_DTElement["oAddLayeredElement"] = function(oDomRefLayered, oDomRefTopLayerArea, oDomRefReferenceContainer, bInitialSize) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oAddLayeredElement"]++; }; 
	var oAddTo = null;

	if (oDomRefReferenceContainer) {
		var oInsertAfter = null;

		oAddTo = UCF_DomUtil["oGetFirstElement"](oDomRefReferenceContainer);

		//if((UCF_UserAgent.bIsIE() || UCF_UserAgent.bIsMSEdge()) || (UCF_UserAgent.bIsGecko() && UCF_UserAgent.bIsStandardsMode())) {

		// Removed if statement because this case should also be handled for webkit due to
		// see internal 2123298 2013
		// positioning of elements sometimes generate problems with the wrong calculation of z-indices in IE
		// see 0120031469 0001770213 2011
		// Workaround: Search first none absolute container to bring the collector container to the most last position
		// All absolute elements do not not change the calculation position of the collector container

		// <<<
		//		while(oAddTo && this.sGetCurrentStyle(oAddTo, "position") == "absolute") {
		//			oInsertAfter = oAddTo;
		//			oAddTo = UCF_DomUtil.nextSibling(oAddTo);
		//		}
		// <<<
		//}

		if (!oAddTo || !oAddTo["bIsCollectorContainer"]) {

			oAddTo = document["createElement"]("div");
			oAddTo["style"]["height"] = (oDomRefReferenceContainer["scrollHeight"] - (oDomRefReferenceContainer["offsetHeight"] - oDomRefReferenceContainer["clientHeight"]) - (UCF_DTElement["BORDER_SIZE"] * 2)) + "px";
			oAddTo["style"]["width"] = (oDomRefReferenceContainer["scrollWidth"] - (oDomRefReferenceContainer["offsetWidth"] - oDomRefReferenceContainer["clientWidth"]) - (UCF_DTElement["BORDER_SIZE"] * 2)) + "px";
			oAddTo["style"]["position"] = "absolute";
			oAddTo["style"]["top"] = "0px";
			oAddTo["style"]["left"] = "0px";

			oAddTo["id"] = oDomRefReferenceContainer["id"] + "-layered";

			//If the collector container is in a scrolled container in RTL mode the position of the relative element is set relative to the outer boundaries
			//instead of inner content. This IE bug is corrected here.
			if (window["UCF_System"]["bIsRTL"] && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && (oDomRefReferenceContainer["scrollLeft"] || this["sGetCurrentStyle"](oDomRefReferenceContainer, "overflowX") != "visible")) {
				oAddTo["style"]["left"] = -(oDomRefReferenceContainer["scrollWidth"] - oDomRefReferenceContainer["clientWidth"]) + "px";
			}

			oAddTo["bIsCollectorContainer"] = true;

			//IE causes in a visual gap of collector container when added layeyered element is removed again.
			//It pushes to line height -> Create dummy content which stays always in the collector container.
			if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
				var oDummyContent = document["createElement"]("div");

				oDummyContent["style"]["height"] = "0px";
				oDummyContent["style"]["width"] = "0px";
				oDummyContent["style"]["overflow"] = "hidden";
				oDummyContent["style"]["fontSize"] = "0.1pt";
				oDummyContent["style"]["position"] = "absolute";

				oAddTo["appendChild"](oDummyContent);
			}

			if (!oDomRefReferenceContainer["firstChild"]) {
				//No children at all
				oDomRefReferenceContainer["appendChild"](oAddTo);
			} else {
				if (oInsertAfter) {
					if (oDomRefReferenceContainer["lastChild"] === oInsertAfter) oDomRefReferenceContainer["appendChild"](oAddTo);
					else oDomRefReferenceContainer["insertBefore"](oAddTo, oInsertAfter["nextSibling"]);
				} else {
					//set at first position when oInsertAfter==null
					oDomRefReferenceContainer["insertBefore"](oAddTo, oDomRefReferenceContainer["firstChild"]);
				}
			}
			// HACK: Group, Tray, Panel, TabStripItem: Use a Scrollarea-fragment with added padding
			var oParent = oAddTo["parentNode"];
			//			if (oParent && oParent.className &&
			//				(oParent.className.indexOf("urGrpBdyBoxPd") > -1 || oParent.className.indexOf("urTrcBodyBoxPd") > -1 || oParent.className.indexOf("lsPnCntPadStd") > -1 ||
			//				 oParent.className.indexOf("urTbsCnt") > -1 || oParent.className.indexOf("urGrpBdyWeb1Pd") > -1)) {
			if (oParent) {
				var pt = UCF_DomUtil["sGetCurrentStyle"](oParent, "padding-top");
				var pl = UCF_DomUtil["sGetCurrentStyle"](oParent, "padding-left");
				if (pt && pt !== "" && pt !== "0px") {
					oAddTo["style"]["top"] = "-" + pt;
				}
				if (pl && pl !== "" && pl !== "0px") {
					oAddTo["style"]["left"] = "-" + pl;
				}
			}
		}
	} else if (oDomRefTopLayerArea) {
		oAddTo = oDomRefTopLayerArea;
	}

	if (oDomRefLayered && oAddTo) {
		oDomRefLayered["style"]["top"] = "-10000px";
		oDomRefLayered["style"]["position"] = "absolute";
		if (bInitialSize) {
			oDomRefLayered["style"]["height"] = "1px";
			oDomRefLayered["style"]["width"] = "1px";
		}
		oAddTo["appendChild"](oDomRefLayered);
	}

	return oAddTo;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oAddLayeredElement"] = 0; };

/**
 * Enable InplaceEdit on this element if support flag is activated at the container.
 * @param sId optional, default is parameter ControlIds
 *
 */
UCF_DTElement["prototype"]["setInplaceEditable"] = function(sId /*, bOverwriteListener*/ ) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setInplaceEditable"]++; }; 
	if (!this["oDTContainer"]["bEnableInplaceEdit"]) return;
	//if ((bOverwriteListener === undefined || bOverwriteListener === false) &&
	if (this["bHasEventListeners"]("InplaceEditStart")) return;

	var oControl = this["oGetConnectedControl"]();
	if (!oControl || !oControl["oGetInplaceEditDomRef"]()) {
		// Maybe it is a sub-control that contains a caption (aka SapTableCell...) ?
		var bSubControl = false;
		var oDom = UCF_DomUtil["$"](this["sControlIds"]);
		if (oDom) {
			bSubControl = oDom["getAttribute"]("subct");
		}
		if (!bSubControl) {
			return;
		}
	}

	if (!sId && this["sControlIds"] && this["sControlIds"]["indexOf"](" ") === -1) {
		sId = this["sControlIds"];
	}
	if ((this["_sInplaceEditId"] !== sId || sId !== this["sInplaceEditRefId"]) && this["oInplaceEditDelegate"]) {
		this["oInplaceEditDelegate"]["destroy"]();
	}
	this["_sInplaceEditId"] = sId; // eslint-disable-line @ur/no-memory-leaks
	this["sInplaceEditRefId"] = sId; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("InplaceEditRefId", sId, true);
	this["oInplaceEditDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEditDelegate"))(this["oLS"]);
	this["oInplaceEditDelegate"]["deactivateDelayedDoubleClick"]();
	this["oInplaceEditDelegate"]["attachEvent"](this["oInplaceEditDelegate"]["E_EVENTS"]["InplaceEditBeforeOpen"], this, "onInplaceEditBeforeOpen");
	this["oInplaceEditDelegate"]["attachEvent"](this["oInplaceEditDelegate"]["E_EVENTS"]["InplaceEditStart"], this, "onInplaceEditStart");
	this["oInplaceEditDelegate"]["attachEvent"](this["oInplaceEditDelegate"]["E_EVENTS"]["InplaceEditFinished"], this, "onInplaceEditFinished");
	this["oInplaceEditDelegate"]["attachEvent"](this["oInplaceEditDelegate"]["E_EVENTS"]["InplaceEditClose"], this, "onInplaceEditFinished");
	this["addDelegate"](this["oInplaceEditDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setInplaceEditable"] = 0; };

/**
 * We have to use a slightly different logic than the DomUtil function with the same name.
 * Position relative/absolute is only taken into account when "declared" with attribute bUseAsPosRefContainer
 * because many controls use the position:relative trick to decouple height calculations.
 * @private
 */
UCF_DTElement["prototype"]["oGetParentPositionReferenceContainer"] = function(oDomRef, bIgnoreBody, oStopAtDomRef) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetParentPositionReferenceContainer"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "DTElement.js(1166): oGetParentPositionReferenceContainer"); };
	var bHiddenHasEffect = UCF_UserAgent["bIsIE"]() && !UCF_UserAgent["bIsStandardsMode"]();

	while (oDomRef != null) {
		if (oStopAtDomRef && oDomRef === oStopAtDomRef) {
			return null;
		}
		if (oDomRef == document["body"]) {
			return bIgnoreBody ? null : oDomRef;
		} else {
			if (oDomRef["getAttribute"]("bNoPosRefContainer") == null) {
				var sOverflow = UCF_DomUtil["sGetCurrentStyle"](oDomRef, "overflow");
				// for IE "hidden" is relevant, for other browsers not.
				if ((sOverflow != "visible" && !(!bHiddenHasEffect && sOverflow === "hidden"))
					|| oDomRef["getAttribute"]("bUseAsPosRefContainer")) {

					// Hack for SapTable in IE: Ignore fixed-columns-headers with overflow:hidden
					// TODO: Better to use oGetDomRefForParentPosRefContainer() in SapTableDTExtension!?
					if (!((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && oDomRef["getAttribute"]("hpm") === "left")) {
						return oDomRef;
					}
				} else {
					if (!this["oGetConnectedControl"]() || !this["oGetConnectedControl"]()["bIsValid"]() || !this["oGetConnectedControl"]()["getClientControl"]()) {
						var sPosition = UCF_DomUtil["sGetCurrentStyle"](oDomRef, "position");
						if (((sPosition === "absolute" || sPosition === "relative") && oDomRef["getAttribute"]("bUseAsPosRefContainer"))) {
							return oDomRef;
						}
					}
				}
			}
		}
		oDomRef = oDomRef["parentNode"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetParentPositionReferenceContainer"] = 0; };

/**
 * @public
 */
UCF_DTElement["prototype"]["aGetControlIDs"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["aGetControlIDs"]++; }; 
	return this["aValidControlIDs"];
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["aGetControlIDs"] = 0; };

UCF_DTElement["prototype"]["setTooltip"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setTooltip"]++; }; 
	this["oDomRef"]["title"] = sText;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setTooltip"] = 0; };
/**
 * @public
 */
UCF_DTElement["prototype"]["setHiddenDesign"] = function(bOnOff) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setHiddenDesign"]++; }; 
	var oFirstChild = UCF_DomUtil["firstChild"](this["oDomRef"]);
	if (bOnOff) {
		oFirstChild["className"] = "urBorderBox lsDTLayerColorLight";
		this["oDTContainer"]["setOpacity"](oFirstChild, 50);
	} else {
		oFirstChild["className"] = "urBorderBox lsDTHoverColorOff";
		this["oDTContainer"]["setOpacity"](oFirstChild, 0);
	}
	this["_bHiddenDesign"] = bOnOff; // eslint-disable-line @ur/no-memory-leaks
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setHiddenDesign"] = 0; };

UCF_DTElement["prototype"]["bIsPersonasEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bIsPersonasEnabled"]++; }; 
	if (this["oDTContainer"]) {
		return this["oDTContainer"]["bIsPersonasEnabled"]();
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bIsPersonasEnabled"] = 0; };

UCF_DTElement["prototype"]["hideConnectedControl"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["hideConnectedControl"]++; }; 
	var oControl = this["oGetConnectedControl"]();
	if (oControl) {
		if (oControl["oRootRef"] && oControl["oRootRef"]["style"]) {
			oControl["oRootRef"]["style"]["visibility"] = "hidden";
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["hideConnectedControl"] = 0; };

UCF_DTElement["prototype"]["showConnectedControl"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["showConnectedControl"]++; }; 
	var oControl = this["oGetConnectedControl"]();
	if (oControl) {
		if (oControl["oRootRef"] && oControl["oRootRef"]["style"]) {
			oControl["oRootRef"]["style"]["visibility"] = "inherit";
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["showConnectedControl"] = 0; };

UCF_DTElement["prototype"]["bHasHiddenDesign"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bHasHiddenDesign"]++; }; 
	return this["_bHiddenDesign"];
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bHasHiddenDesign"] = 0; };

UCF_DTElement["prototype"]["updatePositionInternal"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["updatePositionInternal"]++; }; 
	if (this["aControlIds"] == null) return; // Already destroyed
	if (this["aControlIds"]["length"] === 0) return;
	if (this["aValidControlIDs"]["length"] === 0) {
		return;
	}
	this["aNextLayerElements"] = null;
	this["aPreviousLayerElements"] = null;
	var oResultRect = null,
		oControlRect = null;
	var oControlDomRef = null;
	this["oAbsoluteRect"] = null;
	var oDTExtension;
	for (var i = 0; i < this["aValidControlIDs"]["length"]; i++) {
		var sValidId = this["aValidControlIDs"][i];

		oDTExtension = this["oGetDTExtensionForId"](sValidId, this);
		if (oDTExtension && oDTExtension["bIsVisible"](sValidId)) {
			oControlDomRef = this["oGetDomRefForRect"](oDTExtension, sValidId);
			oControlRect = UCF_DomUtil["oGetObjectRect"](oControlDomRef, this["oCalcContainer"]);

			// Height correction
			var o = UCF_DomUtil["$"](sValidId);
			var ct = o["getAttribute"]("ct");
			if (ct !== "C" && ct !== "R") {
				var oFirst = UCF_DomUtil["oGetFirstElement"](oControlDomRef);
				var sOverflow = UCF_DomUtil["sGetCurrentStyle"](oControlDomRef, "overflow");
				if ((sOverflow === "visible" || sOverflow === "inherit") && oFirst && oFirst["offsetHeight"] > oControlRect["height"]) {
					oControlRect["height"] = oFirst["offsetHeight"];
				}
			}

			// Optional post-processing of control-specific designtime extension
			if (oDTExtension && this["oDTContainer"]["bEnableAdvancedElementFeatures"]) {
				oControlRect = oDTExtension["oPostprocessRect"](oControlRect, sValidId, this["bIsScrollElement"]);
			}

			if (i === 0) {
				oResultRect = oControlRect;
			} else {
				if (oControlRect["top"] < oResultRect["top"]) oResultRect["top"] = oControlRect["top"];
				if (oControlRect["left"] < oResultRect["left"]) oResultRect["left"] = oControlRect["left"];
				if (oControlRect["left"] + oControlRect["width"] > oResultRect["left"] + oResultRect["width"])
					oResultRect["width"] = oControlRect["left"] + oControlRect["width"] - oResultRect["left"];
				if (oControlRect["top"] + oControlRect["height"] > oResultRect["top"] + oResultRect["height"])
					oResultRect["height"] = oControlRect["top"] + oControlRect["height"] - oResultRect["top"];
			}
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "DTElement " + this["sId"] + ": control " + sValidId + " reports that it is not visible", "DTElement.js(1305): updatePositionInternal"); };
		}
	}

	if (oResultRect == null) {
		// The control / all controls invisible => Do not show element
		oResultRect = { "top": -10000, "left": 0, "height": 0, "width": 0 };
	}

	// Set dimensions of scroll-container, controls may be hidden => updatePositions is triggered by onInvisibilityChanged
	if (this["oSCOverflow"] != null) {
		var oInner = UCF_DomUtil["$"](this["sId"] + "-hover");
		var iVerticalScrollbarOffset = this["oSCOverflow"]["offsetWidth"] - this["oSCOverflow"]["clientWidth"];
		oInner["style"]["height"] = (this["oSCOverflow"]["scrollHeight"] - iVerticalScrollbarOffset) + "px";
		oInner["style"]["width"] = (this["oSCOverflow"]["scrollWidth"] - 1) + "px";

		// Special correction for the special-browser so the "fake" scrollbars really overlap the real scrollbars in the content
		if (this["bIsIE8or9"]()) {
			if (this["oSCOverflow"]["scrollWidth"] > this["oSCOverflow"]["clientWidth"]) oResultRect["height"] += 17;
			if (this["oSCOverflow"]["scrollHeight"] > this["oSCOverflow"]["clientHeight"]) oResultRect["width"] += 17;
		}
	}

	// Apply the position
	this["oDomRef"]["style"]["top"] = oResultRect["top"] + "px";
	this["oDomRef"]["style"]["left"] = oResultRect["left"] + "px";

	// Apply the size
	if (this["bIsPersonasEnabled"]()) {
		// A fixed height and width was set in onVisibilityChanged()
		// => do not overwrite it here when triggered by subsequent LayoutChange triggered by resize events in controls
		if (this["oGetConnectedControl"]() && !this["oGetConnectedControl"]()["bGetInvisibility"]() || this["bHasConnectedSubControl"]()) {
			this["oDomRef"]["style"]["height"] = oResultRect["height"] + "px";
			this["oDomRef"]["style"]["width"] = oResultRect["width"] + "px";
		}
	} else {
		this["oDomRef"]["style"]["height"] = oResultRect["height"] + "px";
		this["oDomRef"]["style"]["width"] = oResultRect["width"] + "px";
	}

	this["oMyRect"] = oResultRect;

	// Initial scroll position for scroll-elements...
	if (this["bSapTableScrollingMode"]) {
		oDTExtension = this["oGetDTExtensionForId"](this["aValidControlIDs"][0], this);
		if (oDTExtension) {
			var p = oDTExtension["getScrollPosition"]();
			this["applyScrollPositionDelayed"](p["left"], p["top"]);
		}
	} else if (this["oSCOverflow"]) {
		this["applyScrollPositionDelayed"](this["oSCOverflow"]["scrollLeft"], this["oSCOverflow"]["scrollTop"]);
	}

	// Buttonrow: position relative !
	if (this["oButtonRowDom"]) {
		if (oResultRect["height"] < 26) {
			// Additional corrections for position needed if element is too small for buttons
			this["bTooSmallForButtons"] = true;
			this["oButtonRowDom"]["style"]["top"] = (-oResultRect["height"] - 4) + "px";
		} else {
			this["oButtonRowDom"]["style"]["top"] = -oResultRect["height"] + "px";
		}

		// Calculate width and left: 26px each button + separators 4px
		var iNumberOfButtons = UCF_DomUtil["childNodes"](this["oButtonRowDom"], "A")["length"];
		var iWidth = iNumberOfButtons * 26 + (iNumberOfButtons - 1) * 4;
		this["oButtonRowDom"]["style"]["width"] = iWidth + "px";
		this["oButtonRowDom"]["style"]["left"] = (oResultRect["width"] - iWidth) + "px";

		var h = parseInt(this["oButtonRowDom"]["style"]["height"]);
		if (oResultRect["height"] < h) {
			this["oButtonRowDom"]["style"]["height"] = oResultRect["height"] + "px";
		}
		this["oButtonRowDom"]["style"]["display"] = "block";
	}
	this["bPositioned"] = true;
	this["showActionMenu"](); // re-position if items exist
	this["fireEvent"](this["E_EVENTS"]["Update"], { "Element": this });
	if (this["bIsSelected"]()) {
		this["showDebugInfo"]();
		this["oDTContainer"]["updateHitZones"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["updatePositionInternal"] = 0; };

UCF_DTElement["prototype"]["sINITIAL_TOP"] = "-10000px";

UCF_DTElement["prototype"]["applyScrollPositionDelayed"] = function(iLeft, iTop) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["applyScrollPositionDelayed"]++; }; 
	if (UCF_UserAgent["bIsChromium"]()) {
		var CHROME_SCROLLTOP_DELAY = 200; // This really is the minimum value, that worked for Chrome to accept setting a scrollTop value.
		UCF_JsUtil["delayedCall"](CHROME_SCROLLTOP_DELAY, this, "applyScrollPosition", [iLeft, iTop]);
	} else {
		this["applyScrollPosition"](iLeft, iTop);
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["applyScrollPositionDelayed"] = 0; };

UCF_DTElement["prototype"]["applyScrollPosition"] = function(iLeft, iTop) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["applyScrollPosition"]++; }; 
	if (this["oDomRef"] && this["oSCOverflow"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "sId=" + this["sId"] + ", iLeft=" + iLeft + ", iTop=" + iTop, "DTElement.js(1402): applyScrollPosition"); };
		if (iLeft !== undefined && iTop !== undefined) {
			this["oDomRef"]["scrollTop"] = iTop;
			this["oDomRef"]["scrollLeft"] = iLeft;
		} else {
			this["oDomRef"]["scrollTop"] = this["oSCOverflow"]["scrollTop"];
			this["oDomRef"]["scrollLeft"] = this["oSCOverflow"]["scrollLeft"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["applyScrollPosition"] = 0; };

UCF_DTElement["prototype"]["setActionMenuAlignment"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setActionMenuAlignment"]++; }; 
	this["sActionMenuAlignment"] = sValue; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("ActionMenuAlignment", this["sActionMenuAlignment"], true);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setActionMenuAlignment"] = 0; };

UCF_DTElement["prototype"]["hideActionMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["hideActionMenu"]++; }; 
	if (this["oActionMenuDom"]) {
		this["oActionMenuDom"]["style"]["top"] = this["sINITIAL_TOP"];
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["hideActionMenu"] = 0; };

/**
 * (Re-)Positioning of the ActionMenu according to Alignment API parameter.
 */
UCF_DTElement["prototype"]["showActionMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["showActionMenu"]++; }; 
	if (this["oDomRef"] && this["oActionMenuDom"] && !this["bInitError"]) {

		// During update (RenderManager.reinitializedUCFControls) this function might get called (by DTContainer.handleInvisibilityChanged)
		// but because DTContainer.updatePositions() is delayed, the element position was not calculated yet.
		if (!this["bPositioned"]) {
			return;
		}

		var iMenuHeight = this["oActionMenuDom"]["offsetHeight"];
		var iElementHeight = this["oDomRef"]["offsetHeight"];
		var iElementBorder = Math["floor"]((this["oDomRef"]["offsetWidth"] - this["oDomRef"]["clientWidth"]) / 2);

		// If there is not enugh space for the items above the element (body or scroll-container) change alignment to bottom
		this["sUseActionMenuAlignment"] = this["sActionMenuAlignment"]; // eslint-disable-line @ur/no-memory-leaks
		var oElementAbsRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);
		if (this["bIsPersonasEnabled"]()) {
			// Workaround (hack?): Consider the height of the Personas Editor UI for which someone adds a large padding-top to the body
			var iBodyPaddingTop = parseInt(UCF_DomUtil["sGetCurrentStyle"](document["body"], "padding-top"));
			if (!isNaN(iBodyPaddingTop) && iBodyPaddingTop > 50) {
				oElementAbsRect["top"] -= iBodyPaddingTop;
			}
		}
		var iSpaceNeeded = 0;
		if (this["sUseActionMenuAlignment"] == "TOP_LEFT") {
			iSpaceNeeded = iMenuHeight - 2;
		} else if (this["sUseActionMenuAlignment"] == "BOTTOM_LEFT_INSIDE" && iMenuHeight > iElementHeight) {
			iSpaceNeeded = iMenuHeight - iElementHeight - 2;
		}
		if (iSpaceNeeded > 0 && (oElementAbsRect["top"] - UCF_DomUtil["oGetScrollOffset"](window)["y"] < iSpaceNeeded || this["oMyParentScrollElement"] && this["oDomRef"]["offsetTop"] < iSpaceNeeded)) {
			if (this["sUseActionMenuAlignment"] == "TOP_LEFT") {
				this["sUseActionMenuAlignment"] = "BOTTOM_LEFT";
			} else if (this["sUseActionMenuAlignment"] == "BOTTOM_LEFT_INSIDE") {
				this["sUseActionMenuAlignment"] = "TOP_LEFT_INSIDE";
			}
		}
		// Write used alignment to DOM property so that additional CSS rules for padding/margin can be applied
		this["oDomRef"]["setAttribute"]("am_alignment", this["sUseActionMenuAlignment"]);

		// Calculate left,top (position:absolute)
		if (this["sUseActionMenuAlignment"] == "TOP_LEFT") {
			this["oActionMenuDom"]["style"]["top"] = "-" + (iMenuHeight + iElementBorder) + "px";
			this["oActionMenuDom"]["style"]["left"] = "-" + iElementBorder + "px";
		} else if (this["sUseActionMenuAlignment"] == "TOP_LEFT_INSIDE") {
			this["oActionMenuDom"]["style"]["top"] = "-" + iElementBorder + "px";
			this["oActionMenuDom"]["style"]["left"] = "-" + iElementBorder + "px";
		} else if (this["sUseActionMenuAlignment"] == "BOTTOM_LEFT") {
			this["oActionMenuDom"]["style"]["top"] = (iElementHeight - iElementBorder) + "px";
			this["oActionMenuDom"]["style"]["left"] = "-" + iElementBorder + "px";
		} else if (this["sUseActionMenuAlignment"] == "BOTTOM_LEFT_INSIDE") {
			this["oActionMenuDom"]["style"]["top"] = (iElementHeight - iMenuHeight - iElementBorder) + "px";
			this["oActionMenuDom"]["style"]["left"] = "-" + iElementBorder + "px";
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["showActionMenu"] = 0; };

UCF_DTElement["prototype"]["hideAction"] = function(sId, bDelayed) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["hideAction"]++; }; 
	if (UCF_DomUtil["$"](this["sId"] + "-action-" + sId)) {
		UCF_DomUtil["$"](this["sId"] + "-action-" + sId)["style"]["display"] = "none";
	} else if (!bDelayed) {
		UCF_JsUtil["delayedCall"](50, this, "hideAction", [sId, true]);
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["hideAction"] = 0; };

UCF_DTElement["prototype"]["showAction"] = function(sId, bDelayed) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["showAction"]++; }; 
	if (UCF_DomUtil["$"](this["sId"] + "-action-" + sId)) {
		UCF_DomUtil["$"](this["sId"] + "-action-" + sId)["style"]["display"] = "inline-block";
	} else if (!bDelayed) {
		UCF_JsUtil["delayedCall"](50, this, "showAction", [sId, true]);
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["showAction"] = 0; };

/**
 * Adds an action item with the given Id to the DTElement
 * @private
 */
UCF_DTElement["prototype"]["addActionItem"] = function(sId, sCssClass, sTooltip) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["addActionItem"]++; }; 
	if (!this["oActionMenuDom"]) {
		var oTable = document["createElement"]("TABLE"),
			oRow = document["createElement"]("TR");
		oTable["setAttribute"]("id", this["sId"] + "-actionmenu");
		oTable["setAttribute"]("cellpadding", "0");
		oTable["setAttribute"]("cellspacing", "0");
		oTable["className"] = "lsDTActionMenu urCursorClickable";
		oTable["style"]["position"] = "absolute";
		oTable["style"]["top"] = this["sINITIAL_TOP"];
		oTable["insertRow"](oRow);
		this["oDomRef"]["appendChild"](oTable);
		this["oActionMenuDom"] = oTable;
	}
	if (this["oActionMenuDom"]) {
		if (!UCF_DomUtil["$"](this["sId"] + "-action-" + sId)) {
			var oCell = this["oActionMenuDom"]["rows"][0]["insertCell"](),
				aHTML = [];
			aHTML["push"]("<button ");
			aHTML["push"]("id=\"" + this["sId"] + "-action-" + sId + "\" ");
			aHTML["push"]("class=\"" + UCF_XSSEncoder["encodeHTML"](sCssClass) + "\" ");
			aHTML["push"]("title=\"" + UCF_XSSEncoder["encodeHTML"](sTooltip) + "\" ");
			aHTML["push"]("dt_ami=\"true\"></button>");
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oCell, aHTML["join"](""));
		} else {
			this["showAction"](sId);
		}

		// This is another workaround because ActionMenuItems are not actually "rendered" by Client-side-rendering but instead are created here,
		// the initial positioning has to be done also here...
		if (this["oActionMenuDom"]["style"]["top"] === this["sINITIAL_TOP"]) {
			this["showActionMenu"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["addActionItem"] = 0; };

/**
 * Removes the action item with the given Id from the element
 * @private
 */
UCF_DTElement["prototype"]["removeActionItem"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["removeActionItem"]++; }; 
	var oDomRef = UCF_DomUtil["$"](this["sId"] + "-action-" + sId);
	if (oDomRef) {
		oDomRef["parentNode"]["parentNode"]["deleteCell"](oDomRef["parentNode"]["cellIndex"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["removeActionItem"] = 0; };

/**
 * Update position and size of element's DIV.
 * @public
 */
UCF_DTElement["prototype"]["updatePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["updatePosition"]++; }; 
	if (this["oDTContainer"] && this["oDTContainer"]["bPausePositioning"]) {
		return;
	};
	this["oDTContainer"]["updatePositions"]();
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["updatePosition"] = 0; };

/**
 * Decide which element to use for oGetObjectRect() call
 */
UCF_DTElement["prototype"]["oGetDomRefForRect"] = function(oDTExtension, sValidId) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetDomRefForRect"]++; }; 
	var o = null;
	if (oDTExtension) {
		o = oDTExtension["oGetDomRefForRect"](sValidId, this["bIsScrollElement"]);
	}
	if (!o) {
		if (this["bIsScrollElement"] && this["oMyScrollContainer"] && this["oSCOverflow"]) {
			o = this["oSCOverflow"];
		} else {
			o = UCF_DomUtil["$"](sValidId + "-r") || UCF_DomUtil["$"](sValidId);
		}
	}
	return o;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetDomRefForRect"] = 0; };

/**
 * Important for client-side-rendering: Update all control or DOM references of this DTElement that are needed it updatePosisionInternal()
 * Called by LayoutChange handler of DTContainer and updatePositions() because it is delayed.
 * @private
 */
UCF_DTElement["prototype"]["updateMyContentReferences"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["updateMyContentReferences"]++; }; 
	if (this["aControlIds"] == null) return; // Already destroyed
	if (this["aControlIds"]["length"] == 0) return;

	if (window["UCF_System"]["sDevice"] == "standards" && this["oDTContainer"]["bScrollContainerSupport"] && this["aValidControlIDs"]["length"] > 0 && UCF_DomUtil["$"](this["aValidControlIDs"][0])) {
		// TODO: Refactoring - this block is dupilcated code from init().
		var oExt = this["oGetDTExtensionForId"](this["aValidControlIDs"][0], this);
		if (oExt) {
			var oRefFor = oExt["oGetDomRefForParentPosRefContainer"]();
			if (oRefFor == null) {
				oRefFor = UCF_DomUtil["$"](this["aValidControlIDs"][0])["parentNode"];
			}
			var oCC = this["oGetParentPositionReferenceContainer"](oRefFor, true, this["oDTContainer"]["oDomRef"]);
			if (oCC) {
				var traceId = oCC["id"] || oCC["parentNode"]["id"] || oCC["parentNode"]["parentNode"]["id"];
				if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Update PPRC: sId=" + this["sId"] + ", PPRC.id=" + traceId, "DTElement.js(1600): updateMyContentReferences"); };

				this["oCalcContainer"] = oCC;
			}
		}
	}
	if (this["bIsScrollElement"] && this["oMyScrollContainer"]) {
		this["oMyScrollContainer"] = this["oGetControlById"](this["oMyScrollContainer"]["sGetId"]());
		if (this["oMyScrollContainer"]) {
			this["oSCOverflow"] = this["oMyScrollContainer"]["oGetDTExtension"](this)["oGetScrollAreaDomRef"]();
			if (this["oSCOverflow"] == null) this["oSCOverflow"] = this["oMyScrollContainer"]["oGetDTExtension"](this)["oGetSpecialScrollAreaDomRef"]();
		}
	}
	// Lazy init. in oGetConnectedControl()
	this["oConnectedControl"] = null;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["updateMyContentReferences"] = 0; };

/**
 * Show this DTElement. Its position and size is re-calculated based on the connected control(s).
 * @param {boolean} [bDelayed] Specifies whether the position calculation is does delayed (default is false).
 * @public
 */
UCF_DTElement["prototype"]["show"] = function(bDelayed) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["show"]++; }; 
	if (this["bIsDestroyed"]) return;
	this["oDomRef"]["style"]["visibility"] = "visible";
	if (bDelayed) {
		UCF_JsUtil["delayedCall"](200, this, "updatePosition");
	} else {
		this["updatePosition"]();
	}
	this["bIsHidden"] = false;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["show"] = 0; };

/**
 * Hide this DTElement.
 * @public
 */
UCF_DTElement["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["hide"]++; }; 
	this["oDomRef"]["style"]["visibility"] = "hidden";
	this["oDomRef"]["style"]["top"] = "-10000px";
	this["bIsHidden"] = true;
	this["displayResizeHandles"](false);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["hide"] = 0; };

/**
 * @private
 * @param iZIndex
 */
UCF_DTElement["prototype"]["setZIndex"] = function(iZIndex) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setZIndex"]++; }; 
	this["iZIndex"] = iZIndex; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("ZIndex", this["iZIndex"], true);
	this["oDomRef"]["style"]["zIndex"] = this["oDTContainer"]["ZINDEX_BASE"] + iZIndex;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setZIndex"] = 0; };

/**
 * @private
 */
UCF_DTElement["prototype"]["iGetDOMZIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["iGetDOMZIndex"]++; }; 
	return parseInt(this["oDomRef"]["style"]["zIndex"]);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["iGetDOMZIndex"] = 0; };

UCF_DTElement["prototype"]["onInplaceEditBeforeOpen"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onInplaceEditBeforeOpen"]++; }; 
	if (this["oDTContainer"]["bHasMultiSelection"]() || !this["bSelected"]) {
		oEvent["mGetParameters"]["oBrowserEvent"]["bHandled"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onInplaceEditBeforeOpen"] = 0; };

UCF_DTElement["prototype"]["onInplaceEditStart"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onInplaceEditStart"]++; }; 
	if (!this["oDTContainer"]["bEnableInplaceEdit"]) return;

	if (oEvent["mParameters"]["oBrowserEvent"]["bCtrl"]()) return;
	var oInplaceEditControl = this["oGetControlById"](this["sInplaceEditRefId"]);
	if (!oInplaceEditControl) {
		// Maybe it is a sub-control that contains a caption (aka SapTableCell...)
		// see also: setInplaceEditable()
		var oDom = UCF_DomUtil["$"](this["sInplaceEditRefId"]);
		if (oDom) {
			oInplaceEditControl = this["oGetFirstChildRecursive"](oDom, false);
		}
		if (!oInplaceEditControl) return;
	}

	var oInplaceEditRef = oInplaceEditControl["oGetInplaceEditDomRef"]();
	if (!oInplaceEditRef) return;
	var sInnerHTML = oInplaceEditRef["innerHTML"];
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oInplaceEditRef, oInplaceEditRef["innerHTML"] + "&nbsp;"); //Make at least 1 space to avoid collapsing of element.
	var oBoundaries = UCF_DomUtil["oGetObjectRect"](oInplaceEditRef),
		oRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oInplaceEditRef, sInnerHTML);
	var sText = oInplaceEditControl["sGetInplaceEditText"]() || UCF_DomUtil["sGetInnerText"](oInplaceEditRef);
	this["sInplaceEditText"] = sText; // eslint-disable-line @ur/no-memory-leaks
	if (oBoundaries["top"] === this["oDomRef"]["offsetTop"] + this["oDomRef"]["parentElement"]["offsetTop"]) {
		oBoundaries["top"] += 0;
	}
	//get the offset of the oInplaceEditRef inside of the controls dom ref
	if (oBoundaries["left"] === this["oDomRef"]["offsetLeft"] + this["oDomRef"]["parentElement"]["offsetLeft"]) {
		oBoundaries["left"] += 0;
	}
	oBoundaries["maxwidth"] = oRect["width"] - 5 - (oBoundaries["left"] - oRect["left"]);
	this["oInplaceEditDelegate"]["setInplaceEditData"](
		oInplaceEditRef,
		oBoundaries,
		sText
	);
	this["sOriginalFontColor"] = oInplaceEditRef["style"]["color"]; // eslint-disable-line @ur/no-memory-leaks
	oInplaceEditRef["style"]["color"] = "rgba(0,0,0,0)";
	UCF_DomUtil["addClass"](this["oDomRef"], "lsDTInplaceEdit");
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onInplaceEditStart"] = 0; };

UCF_DTElement["prototype"]["onInplaceEditFinished"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onInplaceEditFinished"]++; }; 
	if (!this["oDTContainer"]["bEnableInplaceEdit"]) return;

	if (this["aControlIds"]["length"] === 1) {
		if (document["activeElement"] !== document["body"]) {
			UCF_JsUtil["delayedCall"](0, UCF_DomUtil, "refocusDomElement", [this["oDomRef"]]);
		}
	}

	var sText = "";
	if (oParams && typeof oParams["oGetParam"] === "function" && typeof oParams["oGetParam"]("sText") === "string") {
		sText = oParams["oGetParam"]("sText");
	} else {
		sText = this["sInplaceEditText"];
	}

	if (typeof sText === "string") {
		this["fireInplaceEditFinish"](this["sId"], this["sInplaceEditRefId"], sText);
	}

	var oInplaceEditControl = this["oGetControlById"](this["sInplaceEditRefId"]);
	if (!oInplaceEditControl) return;

	var oInplaceEditRef = oInplaceEditControl["oGetInplaceEditDomRef"]();
	if (!oInplaceEditRef) return;

	oInplaceEditRef["style"]["color"] = this["sOriginalFontColor"];

	UCF_DomUtil["removeClass"](this["oDomRef"], "lsDTInplaceEdit");
	this["updatePosition"]();
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onInplaceEditFinished"] = 0; };

/**
 * Update the internal state of this element and set the CSS classes accordingly.
 * Note: This function is quasi-public: It is used by Personas editor via UCF_ClientDTElement.setSelected()
 * @param {String} sSelectionState An allowed enum value for the selection state (see control interface)
 * @private
 */
UCF_DTElement["prototype"]["setSelectionState"] = function(sSelectionState) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setSelectionState"]++; }; 
	/*var getForwardedElementDragSourceInfo = function(oDTE) {
		if (oDTE.sSelectionForwardedTo) {
			var e = oDTE.oDTContainer.oGetElementById(oDTE.sSelectionForwardedTo);
			if (e) {
				return o.sDragSourceInfo;
			}
		}
		else {
			return false;
		}
	};*/
	var setMoveCursor = function(oDTE) {
		// Personas WDA special switch: Show move-cursor for selected, draggable and visible DTElements
		if (oDTE["oDTContainer"]["getClientControl"]() && oDTE["oDTContainer"]["getClientControl"]()["bMoveCursorForSelectedElement"] &&
			(oDTE["sDragSourceInfo"] /*|| getForwardedElementDragSourceInfo(oDTE)*/ )) {
			var bControlInvisible = oDTE["oGetConnectedControl"]() && oDTE["oGetConnectedControl"]()["bGetInvisibility"]();
			if (!bControlInvisible) {
				oDTE["oDomRef"]["style"]["cursor"] = "move";
			}
		}
	};
	var resetCursor = function(oDTE) {
		if (oDTE["oDTContainer"]["getClientControl"]() && oDTE["oDTContainer"]["getClientControl"]()["bMoveCursorForSelectedElement"]) {
			oDTE["oDomRef"]["style"]["cursor"] = ""; // "auto" ?
		}
	};

	this["bSelected"] = (sSelectionState === this["eSelectionState"]["SELECTED"] && this["bIsSelectable"]());

	if (this["bIsSelectable"]() && sSelectionState !== this["sSelectionState"]) {

		if (sSelectionState === this["eSelectionState"]["SELECTED"]) {
			var self = this;
			UCF_JsUtil["forEach"](["lsDTBorderUnselected", "lsDTOutlineDefault", "lsDTOutlineDashed", "lsDTHoverBorder"], function(sCN) {
				if (UCF_DomUtil["bHasClass"](self["oDomRef"], sCN)) UCF_DomUtil["removeClass"](self["oDomRef"], sCN);
			});
			UCF_DomUtil["addClass"](this["oDomRef"], "lsDTBorder");

			this["adjustButtonPositionForBorder"](true);
			this["adjustChildElementsForBorder"](true);

			setMoveCursor(this);
		} else {
			resetCursor(this);
			//			// "Selection Forward": see ClientDTElement.forwardSelection()
			//			if (!this.sSelectionForwardedTo) {
			//				resetCursor(this);
			//			}
			//			if (this.sSelectionForwardedFrom) {
			//				var oFromElement = this.oDTContainer.oGetDTElementById(this.sSelectionForwardedFrom);
			//				if (oFromElement) {
			//					resetCursor(oFromElement);
			//					oFromElement.sSelectionForwardedTo = null;
			//				}
			//				this.sSelectionForwardedFrom = null;
			//			}

			UCF_DomUtil["removeClass"](this["oDomRef"], "lsDTBorder");

			if (this["bMouseOverAndHoverBorder"]) {
				//this.oDomRef.className = "urBorderBox lsDTHoverBorder";
				UCF_DomUtil["addClass"](this["oDomRef"], "lsDTHoverBorder");
				this["adjustButtonPositionForBorder"](true);
			} else {
				// Note: Outline is only supported for LayerDesign=DEFAULT !
				if (this["sOutline"] !== "NONE") {
					if (this["sOutline"] === "DEFAULT") {
						UCF_DomUtil["addClass"](this["oDomRef"], "lsDTOutlineDefault");
					} else {
						UCF_DomUtil["addClass"](this["oDomRef"], "lsDTOutlineDashed");
					}
				} else {
					UCF_DomUtil["addClass"](this["oDomRef"], "lsDTBorderUnselected");
					this["adjustButtonPositionForBorder"](false);
					this["adjustChildElementsForBorder"](false);
				}
			}
			this["displayResizeHandles"](false);
		}
		if (sSelectionState === this["eSelectionState"]["SELECTED"]) {
			UCF_DomUtil["setTabIndex"](this["oFocusDomRef"], "0");
			if (this["bIsScrollElement"]) {
				// Avoid brower's "scroll into view" feature, which will make the scroll position jump up
				// when a scroll element is selected (only observed in IE)
				this["oFocusDomRef"]["style"]["top"] = (this["oDomRef"]["scrollTop"]) + 1 + "px";
				this["oFocusDomRef"]["style"]["left"] = (this["oDomRef"]["scrollLeft"]) + 1 + "px";
			}
			UCF_JsUtil["delayedCall"](0, this, "focus");
			this["fireEvent"](this["E_EVENTS"]["Select"], { "Element": this });
			this["attachBrowserEvent"]("keydown", this["oFocusDomRef"]);
		} else {
			UCF_DomUtil["setTabIndex"](this["oFocusDomRef"], "-1");
			this["fireEvent"](this["E_EVENTS"]["Deselect"], { "Element": this });
			this["detachBrowserEvent"]("keydown", this["oFocusDomRef"]);
		}

		this["sSelectionState"] = sSelectionState; // eslint-disable-line @ur/no-memory-leaks
		this["setClientProperty"]("SelectionState", this["sSelectionState"], true);
		if (__UCF_DEBUG__) {
			this["showDebugInfo"]();
			if (sSelectionState === this["eSelectionState"]["SELECTED"]) this["traceIDs"]();
		}

		if (this["oDTContainer"]["bHasMultiSelection"]()) {
			this["highlightPositionParent"](false);
		} else {
			if (this["sSelectionState"] === this["eSelectionState"]["SELECTED"]) {
				this["highlightPositionParent"](true);
			}
		}

		this["oDTContainer"]["handleGridModeSingleSelection"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setSelectionState"] = 0; };

UCF_DTElement["prototype"]["highlightPositionParent"] = function(bShow) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["highlightPositionParent"]++; }; 
	if (this["bIsPersonasEnabled"]()) {
		this["hideParentPosition"]();
		if (!bShow) {
			return;
		}
		var oControl = this["oGetConnectedControl"]();
		if (oControl) {
			var oParent = oControl["oGetParent"]();
			if (oParent) {
				if (oParent["sClassName"] === "UCF_RasterLayoutItem" && oParent["oRootRef"]) {
					oParent = oParent["oGetParent"]();
				}
				this["showParentPosition"](oParent);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["highlightPositionParent"] = 0; };

UCF_DTElement["prototype"]["showParentPosition"] = function(oTargetElement) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["showParentPosition"]++; }; 
	if (oTargetElement) {
		oTargetElement["showLayoutRect"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["showParentPosition"] = 0; };

UCF_DTElement["prototype"]["hideParentPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["hideParentPosition"]++; }; 
	this["hideLayoutRect"]();
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["hideParentPosition"] = 0; };

UCF_DTElement["prototype"]["traceIDs"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["traceIDs"]++; }; 
	// Trace "Personas ID" from custom data
	var oConnectedControl = this["oGetConnectedControl"]();
	if (oConnectedControl && oConnectedControl["getClientControl"]()) {
		var s = oConnectedControl["getClientControl"]()["getCustomDataKey"]("SID");
		if (s) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Selected DTElement: " + this["sId"] + ", Personas ID (SID): " + s, "DTElement.js(1900): traceIDs"); };
		} else {
			s = oConnectedControl["getClientControl"]()["getCustomDataKey"]("WDA_ID");
			if (s) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Selected DTElement: " + this["sId"] + ", Personas ID (WDA_ID): " + s, "DTElement.js(1904): traceIDs"); };
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["traceIDs"] = 0; };

UCF_DTElement["prototype"]["showDebugInfo"] = function(bSelected) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["showDebugInfo"]++; }; 
	// if (!__UCF_DEBUG__) {
	// 	return;
	// }

	// if (!UCF_DTElement.oDebugInfo) {
	// 	UCF_DTElement.oDebugInfo = {};
	// 	var o = document.createElement("div");
	// 	o.style.position = "absolute";
	// 	o.style.top = "-15px";
	// 	o.style.fontFamily = "arial";
	// 	o.style.color = "rgb(119, 178, 232)";
	// 	o.style.backgroundColor = "rgba(255, 255, 255,0.7)";
	// 	o.style.padding = "2px 4px";
	// 	o.style.fontSize = "10px";
	// 	o.style.whiteSpace = "nowrap";
	// 	o.style.boxShadow = "0px 0px 6px 2px rgba(255,255,255,0.7)";
	// 	o.style.pointerEvents = "none";
	// 	UCF_DTElement.oDebugInfo.oDomRef = o;
	// }
	// var oConnectedControl = this.oGetConnectedControl();
	// if (oConnectedControl) {
	// 	var oRect = oConnectedControl.oGetObjectRect(),
	// 		sRect = "";
	// 	if (oRect) {
	// 		sRect = "("+oRect.left+","+oRect.top+","+oRect.width+","+oRect.height+")";
	// 	}
	// 	UCF_DTElement.oDebugInfo.oDomRef.innerHTML = oConnectedControl.sClassName + " " + sRect ;
	// 	console.log({dtelement:this,control:oConnectedControl});
	// 	console.log("rect=" + sRect);
	// }
	// var oContentDomRef = this.oGetContentDomRef();
	// if (oContentDomRef) {
	// 	oContentDomRef.appendChild(UCF_DTElement.oDebugInfo.oDomRef);
	// 	oContentDomRef.style.visibility = "visible";
	// }
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["showDebugInfo"] = 0; };

/**
 * @private
 */
UCF_DTElement["prototype"]["displayResizeHandles"] = function(bShow) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["displayResizeHandles"]++; };  // eslint-disable-line complexity

	/* eslint-disable no-magic-numbers */
	if (!this["oDTContainer"] || this["bDragInProgress"]) return;

	if (bShow && this["oGetConnectedControl"]()) {
		bShow = !this["oGetConnectedControl"]()["bGetInvisibility"]();
	}

	var oHitZone = this["oDTContainer"]["oHitZone"];
	if (bShow) {
		// Only draggable elements should have the move-cursor on the hit-zones
		oHitZone["MOVETOP"]["style"]["cursor"] = oHitZone["MOVERIGHT"]["style"]["cursor"] = oHitZone["MOVELEFT"]["style"]["cursor"] = oHitZone["MOVEBOTTOM"]["style"]["cursor"] = this["sDragSourceInfo"] ? "move" : "";

		var sZIndex = this["oDTContainer"]["getHighestZIndex"]() + "";
		oHitZone["ROOT"]["style"]["display"] = "none";
		oHitZone["MOVETOP"]["style"]["visibility"] = "hidden";
		oHitZone["MOVERIGHT"]["style"]["visibility"] = "hidden";
		oHitZone["MOVELEFT"]["style"]["visibility"] = "hidden";
		oHitZone["MOVEBOTTOM"]["style"]["visibility"] = "hidden";
		var iBrowserOffset = 0;
		if (UCF_UserAgent["bIsFirefox"]()) {
			iBrowserOffset = -2;
		}

		var oElementRef = UCF_DomUtil["$"](this["sId"] + "-hover"),
			oElementViewRect = UCF_DomUtil["oGetViewPort"](oElementRef, UCF_DomUtil["oGetParentPositionReferenceContainer"](this["oDTContainer"]["oDomRef"])),
			oElementRect = oElementViewRect["_original"];
		oElementViewRect["bottom"] = oElementViewRect["top"] + oElementViewRect["height"];
		oElementViewRect["right"] = oElementViewRect["left"] + oElementViewRect["width"];
		oElementRect["bottom"] = oElementRect["top"] + oElementRect["height"];
		oElementRect["right"] = oElementRect["left"] + oElementRect["width"];
		var bWidthCenter = oElementViewRect["width"] > ((oElementRect["width"] / 2) + 3),
			bHeightCenter = oElementViewRect["height"] > ((oElementRect["height"] / 2) + 3),
			oStyle;

		oStyle = oHitZone["N"]["style"];
		if (bShow && this["bResizeHandleNorth"] && oElementRect["top"] === oElementViewRect["top"] && bWidthCenter) {
			oStyle["display"] = "block";
			oStyle["top"] = (oElementViewRect["top"] - 4 + iBrowserOffset) + "px";
			oStyle["left"] = Math["floor"](oElementRect["left"] + (oElementRect["width"] / 2) - 3 + iBrowserOffset) + "px";
			oStyle["zIndex"] = sZIndex;
		} else {
			oStyle["display"] = "none";
		}

		oStyle = oHitZone["S"]["style"];
		if (bShow && this["bResizeHandleSouth"] && oElementRect["bottom"] === oElementViewRect["bottom"] && bWidthCenter) {
			oStyle["display"] = "block";
			oStyle["top"] = (oElementViewRect["bottom"] - 2 + iBrowserOffset) + "px";
			oStyle["left"] = Math["floor"](oElementRect["left"] + (oElementRect["width"] / 2) - 3 + iBrowserOffset) + "px";
			oStyle["zIndex"] = sZIndex;
		} else {
			oStyle["display"] = "none";
		}

		oStyle = oHitZone["W"]["style"];
		if (bShow && this["bResizeHandleWest"] && oElementRect["left"] === oElementViewRect["left"] && bHeightCenter) {
			oStyle["display"] = "block";
			oStyle["left"] = (oElementViewRect["left"] - 4 + iBrowserOffset) + "px";
			oStyle["top"] = Math["floor"](oElementRect["top"] + (oElementRect["height"] / 2) - 3 + iBrowserOffset) + "px";
			oStyle["zIndex"] = sZIndex;
		} else {
			oStyle["display"] = "none";
		}

		oStyle = oHitZone["E"]["style"];
		if (bShow && this["bResizeHandleEast"] && oElementRect["right"] === oElementViewRect["right"] && bHeightCenter) {
			oStyle["display"] = "block";
			oStyle["left"] = (oElementViewRect["right"] - 2 + iBrowserOffset) + "px";
			oStyle["top"] = Math["floor"](oElementRect["top"] + (oElementRect["height"] / 2) - 3 + iBrowserOffset) + "px";
			oStyle["zIndex"] = sZIndex;
		} else {
			oStyle["display"] = "none";
		}

		oStyle = oHitZone["SE"]["style"];
		if (bShow && this["bResizeHandleSouth"] && this["bResizeHandleEast"] && oElementRect["right"] === oElementViewRect["right"] && oElementRect["bottom"] === oElementViewRect["bottom"]) {
			oStyle["display"] = "block";
			oStyle["left"] = (oElementViewRect["right"] - 2 + iBrowserOffset) + "px";
			oStyle["top"] = (oElementViewRect["bottom"] - 2 + iBrowserOffset) + "px";
			oStyle["zIndex"] = sZIndex;
		} else {
			oStyle["display"] = "none";
		}

		oStyle = oHitZone["SW"]["style"];
		if (bShow && this["bResizeHandleSouth"] && this["bResizeHandleWest"] && oElementRect["left"] === oElementViewRect["left"] && oElementRect["bottom"] === oElementViewRect["bottom"]) {
			oStyle["display"] = "block";
			oStyle["left"] = (oElementViewRect["left"] - 4 + iBrowserOffset) + "px";
			oStyle["top"] = (oElementViewRect["bottom"] - 2 + iBrowserOffset) + "px";
			oStyle["zIndex"] = sZIndex;
		} else {
			oStyle["display"] = "none";
		}

		oStyle = oHitZone["NW"]["style"];
		if (bShow && this["bResizeHandleNorth"] && this["bResizeHandleWest"] && oElementRect["left"] === oElementViewRect["left"] && oElementRect["top"] === oElementViewRect["top"]) {
			oStyle["display"] = "block";
			oStyle["left"] = (oElementViewRect["left"] - 4 + iBrowserOffset) + "px";
			oStyle["top"] = (oElementViewRect["top"] - 4 + iBrowserOffset) + "px";
			oStyle["zIndex"] = sZIndex;
		} else {
			oStyle["display"] = "none";
		}

		oStyle = oHitZone["NE"]["style"];
		if (bShow && this["bResizeHandleNorth"] && this["bResizeHandleEast"] && oElementRect["right"] === oElementViewRect["right"] && oElementRect["top"] === oElementViewRect["top"]) {
			oStyle["display"] = "block";
			oStyle["left"] = (oElementViewRect["right"] - 2 + iBrowserOffset) + "px";
			oStyle["top"] = (oElementViewRect["top"] - 4 + iBrowserOffset) + "px";
			oStyle["zIndex"] = sZIndex;
		} else {
			oStyle["display"] = "none";
		}

		if (oElementRect["top"] === oElementViewRect["top"]) {
			oStyle = oHitZone["MOVETOP"]["style"];
			oStyle["left"] = (oElementViewRect["left"] - 2 + iBrowserOffset) + "px";
			oStyle["top"] = (oElementRect["top"] - 2 + iBrowserOffset) + "px";
			oStyle["width"] = (oElementViewRect["width"] + 4) + "px";
			oStyle["visibility"] = "visible";
			oStyle["zIndex"] = sZIndex;
		}
		if (oElementRect["bottom"] === oElementViewRect["bottom"]) {
			oStyle = oHitZone["MOVEBOTTOM"]["style"];
			oStyle["left"] = (oElementViewRect["left"] - 2 + iBrowserOffset) + "px";
			oStyle["top"] = (oElementRect["bottom"] - 1 + iBrowserOffset) + "px";
			oStyle["width"] = (oElementViewRect["width"] + 4) + "px";
			oStyle["visibility"] = "visible";
			oStyle["zIndex"] = sZIndex;
		}
		if (oElementRect["left"] === oElementViewRect["left"]) {
			oStyle = oHitZone["MOVELEFT"]["style"];
			oStyle["left"] = (oElementRect["left"] - 2 + iBrowserOffset) + "px";
			oStyle["top"] = (oElementViewRect["top"] - 2 + iBrowserOffset) + "px";
			oStyle["height"] = (oElementViewRect["height"] + 4) + "px";
			oStyle["visibility"] = "visible";
			oStyle["zIndex"] = sZIndex;
		}
		if (oElementRect["right"] === oElementViewRect["right"]) {
			oStyle = oHitZone["MOVERIGHT"]["style"];
			oStyle["left"] = (oElementRect["right"] - 1 + iBrowserOffset) + "px";
			oStyle["top"] = (oElementViewRect["top"] - 2 + iBrowserOffset) + "px";
			oStyle["height"] = (oElementViewRect["height"] + 4) + "px";
			oStyle["visibility"] = "visible";
			oStyle["zIndex"] = sZIndex;
		}
		oHitZone["ROOT"]["style"]["display"] = "block";
	} else {
		oHitZone["ROOT"]["style"]["display"] = "none";
		oHitZone["MOVETOP"]["style"]["visibility"] = "hidden";
		oHitZone["MOVERIGHT"]["style"]["visibility"] = "hidden";
		oHitZone["MOVELEFT"]["style"]["visibility"] = "hidden";
		oHitZone["MOVEBOTTOM"]["style"]["visibility"] = "hidden";

		oHitZone["N"]["style"]["display"] = "none";
		oHitZone["S"]["style"]["display"] = "none";
		oHitZone["W"]["style"]["display"] = "none";
		oHitZone["E"]["style"]["display"] = "none";
		oHitZone["SE"]["style"]["display"] = "none";
		oHitZone["SW"]["style"]["display"] = "none";
		oHitZone["NW"]["style"]["display"] = "none";
		oStyle = oHitZone["NE"]["display"] = "none";
	}
	/* eslint-enable no-magic-numbers */
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["displayResizeHandles"] = 0; };

/**
 * Reverse/compensate the effects of the selection border on the relative positioning of the child-elements and horiz. scroll bar of this scroll-element
 *
 * !!
 * TODO:
 * It seems this is only needed because of box-sizing:border-box which was used because of Quirks mode. In Standards mode we should use content-box instead.
 * !!
 *
 * @private
 * @param bOnOff
 */
UCF_DTElement["prototype"]["adjustChildElementsForBorder"] = function(bOnOff) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["adjustChildElementsForBorder"]++; }; 
	if (!(this["bIsScrollElement"] && this["oSCOverflow"] !== null && this["bIsSelectable"]())) return;

	// Compensate border size by lifting the special DIV for relative positioning up and to the left
	var oAddToDiv = UCF_DomUtil["$"](this["sId"] + "-layered"); // See this.oAddLayeredElement()
	if (oAddToDiv) {
		oAddToDiv["style"]["top"] = bOnOff ? "-" + UCF_DTElement["BORDER_SIZE"] + "px" : "";
		oAddToDiv["style"]["left"] = bOnOff ? "-" + UCF_DTElement["BORDER_SIZE"] + "px" : "";
	}

	// Note: This is NOT possible because left may become negative and if there no padding in the "parent" element
	// the selection border is cut off...
	/*
	// Avoid additional horiz. scrollbar
	if (bOnOff) {
		this.oDomRef.style.top = (this.oMyRect.top - UCF_DTElement.BORDER_SIZE) + "px";
		this.oDomRef.style.left = (this.oMyRect.left - UCF_DTElement.BORDER_SIZE) + "px";
		this.oDomRef.style.width = (this.oMyRect.width + 2 * UCF_DTElement.BORDER_SIZE) + "px";
		this.oDomRef.style.height = (this.oMyRect.height + 2 * UCF_DTElement.BORDER_SIZE) + "px";
	}
	else {
		this.oDomRef.style.top = this.oMyRect.top + "px";
		this.oDomRef.style.left = this.oMyRect.left + "px";
		this.oDomRef.style.width = this.oMyRect.width + "px";
		this.oDomRef.style.height = this.oMyRect.height + "px";
	}
	*/

	// Avoid additional horiz. scrollbar: Compensate border size by reducing width of some elements...
	var oHover = UCF_DomUtil["$"](this["sId"] + "-hover");
	if (bOnOff) {
		oHover["style"]["width"] = (oHover["clientWidth"] - 2 * UCF_DTElement["BORDER_SIZE"]) + "px";
	} else {
		oHover["style"]["width"] = (oHover["clientWidth"] + 2 * UCF_DTElement["BORDER_SIZE"]) + "px";
	}

	if (oAddToDiv) {
		// We assume that this has to be the DTElement of the child RasterLayout
		// Personas 3.0: Each ScrollContainer or control with ScrollArea has to have a child RasterLayout
		var oChildDom = UCF_DomUtil["oGetFirstChild"](oAddToDiv);
		if (oChildDom && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
			oChildDom = oChildDom["nextSibling"];
		}
		var oElement = this["oGetControlByDomRef"](oChildDom);
		if (oElement && oElement["oMyRasterLayoutControl"]) {
			if (bOnOff) {
				oChildDom["style"]["width"] = (parseInt(oChildDom["style"]["width"]) - 2 * UCF_DTElement["BORDER_SIZE"]) + "px";
			} else {
				oChildDom["style"]["width"] = (parseInt(oChildDom["style"]["width"]) + 2 * UCF_DTElement["BORDER_SIZE"]) + "px";
			}
		}

		// This is an alternative solution: Would also require setting the exact h/w on this element
		/*
		oAddToDiv.style.overflow = "hidden";
		*/
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["adjustChildElementsForBorder"] = 0; };

/**
 * Toggles the selection: SELECTED <-> SELECTABLE (NONE)
 * @private
 */
UCF_DTElement["prototype"]["toggleSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["toggleSelection"]++; }; 
	if (this["bIsSelectable"]()) {
		this["setSelectionState"](this["sSelectionState"] === this["eSelectionState"]["SELECTED"] ? this["eSelectionState"]["NONE"] : this["eSelectionState"]["SELECTED"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["toggleSelection"] = 0; };

/**
 * Returns true if the element is selectable.
 */
UCF_DTElement["prototype"]["bIsSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bIsSelectable"]++; }; 
	return this["sSelectionState"] !== this["eSelectionState"]["NOT_SELECTABLE"];
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bIsSelectable"] = 0; };

/**
 * Returns true if the element is selected.
 */
UCF_DTElement["prototype"]["bIsSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bIsSelected"]++; }; 
	return this["sSelectionState"] === this["eSelectionState"]["SELECTED"];
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bIsSelected"] = 0; };

/**
 * Called by UCF_Control.
 * @private
 */
UCF_DTElement["prototype"]["createDragDelegate"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["createDragDelegate"]++; }; 
	if (!this["sDragSourceInfo"]) return;
	if (this["oDTContainer"]["bResizing"]) return;

	// Int. ticket 1670005552
	//	if (UCF_UserAgent.bIsGecko() && this.bIsScrollElement) {
	//		// Workaround: FF will send mousemove events on scroll-bars. Currently no workaround available in DnDManager.
	//		return;
	//	}

	if ((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && oBrowserEvent["eGetMouseButtonState"]() == 0) {
		// Workaround for IE10+11: DnDManager sometimes reports a drag when you use scrollbars
		// The dragEnd will later cause updatePosition if all elements which will slow down scrolling
		// reason: mouseup is missing + after scrolling is finished IE generates wrong mousemove
		// We can recognize this scenario when the mouse button is already released during dragStart
		return;
	}

	if (this["oDTContainer"]["sRasterMode"] !== "NONE") {
		this["oDTContainer"]["initRasterDD"](this, this["aValidControlIDs"][0]);
	}

	if (this["oDragDelegate"]) return;

	if (this["oDTContainer"]["sRasterMode"] !== "NONE") {
		this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTElementRasterDragDelegate"))(this["oLS"], this);
	} else {
		this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTElementDragDelegate"))(this["oLS"], this);
	}
	this["addDelegate"](this["oDragDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["createDragDelegate"] = 0; };

/**
 * Called by UCF_Control.
 * @private
 */
UCF_DTElement["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["createDropDelegate"]++; }; 
	if (this["oDropDelegate"]) return;

	if (this["oDTContainer"]["sRasterMode"] !== "NONE") {

		this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTElementRasterDropDelegate"))(this["oLS"], this);

		// Help DropDelegate base class to find the "drop tags"
		// Alternative: Overwrite sGetTags() in delegate
		this["sDropTargetInfo"] = this["sDropTargetInfoTop"]; // eslint-disable-line @ur/no-memory-leaks
	} else {
		this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTElementDropDelegate"))(this["oLS"], this);
	}
	this["addDelegate"](this["oDropDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["createDropDelegate"] = 0; };

/**
 * Get value of LayerDesign parameter taking into account the deprecated HoverEffect parameter...
 * @private
 */
UCF_DTElement["prototype"]["sGetLayerDesignParameter"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["sGetLayerDesignParameter"]++; }; 
	if (this["sLayerDesign"] === "NONE") {
		// New parameter is not used - map old HoverEffect values
		if (this["sHoverEffect"] === "PERMANENT") {
			return "LAYER_AND_HOVER";
		} else {
			return this["sHoverEffect"]; // NONE or DEFAULT are same values as for LayerDesign;
		}
	} else {
		return this["sLayerDesign"];
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["sGetLayerDesignParameter"] = 0; };

/**
 * @private
 */
UCF_DTElement["prototype"]["calculateResizeGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["calculateResizeGhost"]++; }; 
	var oRL = this["oDTContainer"]["oRootRasterLayoutControl"];
	var iDeltaX = 0,
		iDeltaY = 0;
	var iWidth = this["oResizeSession"]["oStartRect"]["width"];
	var iHeight = this["oResizeSession"]["oStartRect"]["height"];
	var iStartHeight, iStartWidth;
	if (oRL) {
		// "Snap" starting values for width and height to the grid
		// The actual size of a control is not always exactly aligned to raster units, e.g. the raster height may be 25px but the button height is 22px
		iStartHeight = oRL["fRasterHeight"] * Math["round"](iHeight / oRL["fRasterHeight"]);
		iStartWidth = oRL["fRasterWidth"] * Math["round"](iWidth / oRL["fRasterWidth"]);
	} else {
		iStartHeight = this["oResizeSession"]["oStartRect"]["height"];
		iStartWidth = this["oResizeSession"]["oStartRect"]["width"];
	}

	if (this["oResizeSession"]["sArea"] === "N" || this["oResizeSession"]["sArea"] === "S") {
		iDeltaY = this["oResizeSession"]["iScreenY"] - this["oResizeSession"]["iStartY"];
	} else if (this["oResizeSession"]["sArea"] === "W" || this["oResizeSession"]["sArea"] === "E") {
		iDeltaX = this["oResizeSession"]["iScreenX"] - this["oResizeSession"]["iStartX"];
	} else {
		iDeltaY = this["oResizeSession"]["iScreenY"] - this["oResizeSession"]["iStartY"];
		iDeltaX = this["oResizeSession"]["iScreenX"] - this["oResizeSession"]["iStartX"];
	}

	if (this["bKeepRatio"] || this["bTempRatio"]) {
		var iRatio = iStartHeight / iStartWidth;
		if (iRatio < 1) {
			if (this["oResizeSession"]["sArea"] === "SE" || this["oResizeSession"]["sArea"] === "E") {
				iDeltaY = iDeltaX * iRatio;
			} else if (this["oResizeSession"]["sArea"] === "S") {
				iDeltaX = iDeltaY / iRatio;
			}
		} else {
			iRatio = iStartWidth / iStartHeight;
			if (this["oResizeSession"]["sArea"] === "SE" || this["oResizeSession"]["sArea"] === "S") {
				iDeltaX = iDeltaY * iRatio;
			} else if (this["oResizeSession"]["sArea"] === "E") {
				iDeltaY = iDeltaX / iRatio;
			}
		}
	}

	// "Snap" to raster points
	if (oRL) {
		iDeltaX = Math["floor"](iDeltaX / oRL["fRasterWidth"]) * oRL["fRasterWidth"];
		iDeltaY = Math["floor"](iDeltaY / oRL["fRasterHeight"]) * oRL["fRasterHeight"];
	}

	if (this["oResizeSession"]["sArea"]["indexOf"]("N") !== -1) {
		iHeight = iStartHeight - iDeltaY;
	} else {
		iHeight = iStartHeight + iDeltaY;
	}
	if (this["oResizeSession"]["sArea"]["indexOf"]("W") !== -1) {
		iWidth = iStartWidth - iDeltaX;
	} else {
		iWidth = iStartWidth + iDeltaX;
	}

	// Minimum size is one raster ...
	var mMinSize = oRL ? { "width": oRL["fRasterWidth"], "height": oRL["fRasterHeight"] } : { "width": 10, "height": 10 };

	iWidth = Math["floor"](Math["max"](iWidth, mMinSize["width"]));
	iHeight = Math["floor"](Math["max"](iHeight, mMinSize["height"]));

	// Collect the "before"-values for the size-limit calculation
	var oConnectedControl = this["oGetConnectedControl"]();
	var oRootRef = null,
		oChild = null;
	if (oConnectedControl) {
		var oParent = oConnectedControl["oGetParent"]();
		oChild = oConnectedControl;
		if (oParent && oParent["sClassName"] === "UCF_RasterLayoutItem") {
			oConnectedControl = oParent;
		}
		oRootRef = oConnectedControl["oRootRef"];
	}
	var sOldWidth = oRootRef ? oRootRef["style"]["width"] : null,
		sOldHeight = oRootRef ? oRootRef["style"]["height"] : null,
		sOldMinWidth = oRootRef ? oRootRef["style"]["minWidth"] : null,
		sOldMinHeight = oRootRef ? oRootRef["style"]["minHeight"] : null,
		sOldLeft = this["oResizeSession"]["oResizeGhost"]["style"]["left"],
		sOldTop = this["oResizeSession"]["oResizeGhost"]["style"]["top"];

	this["oResizeSession"]["oResizeGhost"]["style"]["width"] = iWidth + "px";
	this["oResizeSession"]["oResizeGhost"]["style"]["height"] = iHeight + "px";

	// Also changed the "position" (dragging N, NE, NW, W, SW) ?
	if (this["oResizeSession"]["sArea"]["indexOf"]("N") !== -1 || this["oResizeSession"]["sArea"]["indexOf"]("W") !== -1) {
		if (this["oResizeSession"]["sArea"] !== "NE") {
			if (iWidth > mMinSize["width"]) {
				this["oResizeSession"]["oResizeGhost"]["style"]["left"] = (this["oResizeSession"]["oStartRect"]["x"] + iDeltaX) + "px";
			} else {
				this["oResizeSession"]["oResizeGhost"]["style"]["left"] = (iStartWidth - mMinSize["width"] + this["oResizeSession"]["oStartRect"]["x"]) + "px";
			}
		}
		if (this["oResizeSession"]["sArea"] !== "SW") {
			if (iHeight > mMinSize["height"]) {
				this["oResizeSession"]["oResizeGhost"]["style"]["top"] = (this["oResizeSession"]["oStartRect"]["y"] + iDeltaY) + "px";
			} else {
				this["oResizeSession"]["oResizeGhost"]["style"]["top"] = (iStartHeight - mMinSize["height"] + this["oResizeSession"]["oStartRect"]["y"]) + "px";
			}
		}
	}

	// check whether a size limit of the control is reached
	//
	// TODO: This fancy feature makes no sense for most controls, except e.g. TextView, Label, InputField, ComboBox, ???
	//		 Should use a white-list instead
	//
	// Ticket 1670246647: Was never required by Personas WebGUI
	// Ticket WDAPERSONAS-91: Did prevent making containers smaller, added UCF_ScrollContainer to the list
	//
	var bPersonasWebGUI = this["bIsPersonasEnabled"]() && sap && sap["its"];
	if (!bPersonasWebGUI && oConnectedControl && oChild["oRootRef"]["tagName"] !== "TEXTAREA" && oChild["sClassName"] !== "UCF_StickyNote" && oChild["sClassName"] !== "UCF_Image" &&
		oChild["sClassName"] !== "UCF_Tabstrip" && oChild["sClassName"] !== "UCF_SapTableCS" && oChild["sClassName"] !== "UCF_SapTable" && oChild["sClassName"] !== "UCF_ScrollContainer") {
		oRootRef["style"]["width"] = Math["max"](iWidth - 4, 0) + "px";
		oRootRef["style"]["height"] = Math["max"](iHeight - 4, 0) + "px";
		oRootRef["style"]["minWidth"] = "";
		oRootRef["style"]["minHeight"] = "";
		var iMinWidth = Math["max"](oRootRef["offsetWidth"], oChild["oRootRef"]["offsetWidth"], iWidth);
		var iMinHeight = Math["max"](oRootRef["offsetHeight"], oChild["oRootRef"]["offsetHeight"], iHeight);
		oRootRef["style"]["width"] = sOldWidth;
		oRootRef["style"]["height"] = sOldHeight;
		oRootRef["style"]["minWidth"] = sOldMinWidth;
		oRootRef["style"]["minHeight"] = sOldMinHeight;

		this["oResizeSession"]["oResizeGhost"]["style"]["width"] = iMinWidth + "px";
		this["oResizeSession"]["oResizeGhost"]["style"]["height"] = iMinHeight + "px";
		if (iWidth !== iMinWidth) this["oResizeSession"]["oResizeGhost"]["style"]["left"] = sOldLeft;
		if (iHeight !== iMinHeight) this["oResizeSession"]["oResizeGhost"]["style"]["top"] = sOldTop;
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["calculateResizeGhost"] = 0; };

/**
 * @private
 */
UCF_DTElement["prototype"]["startResize"] = function(sHandleId, iStartX, iStartY) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["startResize"]++; }; 
	var that = this;
	this["handleEvent"] = function(oDomEvent) { // eslint-disable-line @ur/no-memory-leaks
		switch (oDomEvent["type"]) {
			case "mousemove":
				that["onResizeHandleMouseMove"](oDomEvent);
				break;
			case "mouseup":
				that["onResizeHandleMouseUp"](oDomEvent);
				break;
			case "keydown":
				if (!that["bTempRatio"] && oDomEvent["keyCode"] === UCF_KeyCodes["SHIFT"]) {
					that["bTempRatio"] = true;
				}
				that["calculateResizeGhost"]();
				break;
			case "keyup":
				if (that["bTempRatio"] && oDomEvent["keyCode"] === UCF_KeyCodes["SHIFT"]) {
					that["bTempRatio"] = false;
				}
				that["calculateResizeGhost"]();
				break;
		}
	};

	UCF_DomUtil["attachEvent"](document["body"], "mousemove", this["handleEvent"], true);
	UCF_DomUtil["attachEvent"](document["body"], "mouseup", this["handleEvent"], true);
	UCF_DomUtil["attachEvent"](document["body"], "keydown", this["handleEvent"], true);
	UCF_DomUtil["attachEvent"](document["body"], "keyup", this["handleEvent"], true);

	this["oResizeSession"] = {};
	this["oResizeSession"]["oResizeGhost"] = this["oDTContainer"]["oInitResizeGhost"](this);
	this["oResizeSession"]["sArea"] = sHandleId["substring"](sHandleId["lastIndexOf"]("-") + 1);
	this["oResizeSession"]["oStartRect"] = {
		"x": this["oResizeSession"]["oResizeGhost"]["offsetLeft"],
		"y": this["oResizeSession"]["oResizeGhost"]["offsetTop"],
		"width": this["oResizeSession"]["oResizeGhost"]["offsetWidth"],
		"height": this["oResizeSession"]["oResizeGhost"]["offsetHeight"]
	};

	this["oResizeSession"]["iStartX"] = iStartX;
	this["oResizeSession"]["iStartY"] = iStartY;

	this["bResizing"] = true;
	this["oDTContainer"]["bResizing"] = true;

	if (this["oDTContainer"]) {
		this["oDTContainer"]["hideHitZones"]();
	}

};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["startResize"] = 0; };

/**
 * @private
 */
UCF_DTElement["prototype"]["stopResize"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["stopResize"]++; }; 
	UCF_DomUtil["detachEvent"](document["body"], "mousemove", this["handleEvent"], true);
	UCF_DomUtil["detachEvent"](document["body"], "mouseup", this["handleEvent"], true);
	UCF_DomUtil["detachEvent"](document["body"], "keydown", this["handleEvent"], true);
	UCF_DomUtil["detachEvent"](document["body"], "keyup", this["handleEvent"], true);

	if (this["oHoveredElement"] && !(this["oHoveredElement"]["id"] && this["oHoveredElement"]["id"]["indexOf"]("-resizehandle-") > -1)) {
		this["oHoveredElement"]["style"]["cursor"] = "inherit";
	}

	var o = UCF_DTContainer["SELRECT_OFF"]; // See also: UCF_DTContainer.oInitResizeGhost()
	var gw = this["oResizeSession"]["oResizeGhost"]["offsetWidth"] - 2;
	var gh = this["oResizeSession"]["oResizeGhost"]["offsetHeight"] - 2;
	var gx = parseInt(this["oResizeSession"]["oResizeGhost"]["style"]["left"]) + o;
	var gy = parseInt(this["oResizeSession"]["oResizeGhost"]["style"]["top"]) + o;

	this["oDTContainer"]["releaseResizeGhost"]();
	this["oResizeSession"] = null;
	this["bResizing"] = false;
	this["oDTContainer"]["bResizing"] = false;
	if (this["oDTContainer"]["oRootRasterLayoutControl"] && this["oGetConnectedControl"]() && this["oGetConnectedControl"]()["oGetParent"]()["sClassName"] === "UCF_RasterLayoutItem") {
		// "Raster-mode of" Personas WebGUI: RasterMode == NESTED_RL_DROP_ON_ELEMENT
		this["fireResize"](
			this["sId"],
			Math["floor"](gw / this["oDTContainer"]["oRootRasterLayoutControl"]["fRasterWidth"]),
			Math["floor"](gh / this["oDTContainer"]["oRootRasterLayoutControl"]["fRasterHeight"]),
			Math["floor"](gx / this["oDTContainer"]["oRootRasterLayoutControl"]["fRasterWidth"]),
			Math["floor"](gy / this["oDTContainer"]["oRootRasterLayoutControl"]["fRasterHeight"]));
	} else {
		var oNewGridSize = this["oDTContainer"]["oCalcResizedGridSize"](gw - 2, gh - 2, this);
		if (oNewGridSize) {
			// Personas WDA "Grid Mode"
			this["fireResize"](
				this["sId"],
				gw - 2, gh - 2,
				gx, gy,
				oNewGridSize["width"], oNewGridSize["height"]
			);
		} else {
			// Personas WDA resizing outside grid in other layouts
			this["fireResize"](
				this["sId"],
				gw - 2, gh - 2,
				gx, gy,
				-1, -1
			);
		}
	}

	this["oLS"]["oBrowserWindow"]["notifyLayoutChange"]();
	if (this["oDTContainer"]) {
		UCF_JsUtil["delayedCall"](1, this["oDTContainer"], "updateHitZones");
		this["highlightPositionParent"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["stopResize"] = 0; };

/**
 * @private
 */
UCF_DTElement["prototype"]["onResizeHandleMouseUp"] = function(oDomEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onResizeHandleMouseUp"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	var oBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oDomEvent);
	this["stopResize"]();
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

	oBrowserEvent["destroy"]();
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onResizeHandleMouseUp"] = 0; };

/**
 * @private
 */
UCF_DTElement["prototype"]["onResizeHandleMouseMove"] = function(oDomEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onResizeHandleMouseMove"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	var oBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oDomEvent);
	var oHoveredElement = oBrowserEvent["oGetSource"]();
	if (oHoveredElement && oHoveredElement !== this["oHoveredElement"] && !(oHoveredElement["id"] && oHoveredElement["id"]["indexOf"]("-resizehandle-") > -1)) {
		if (this["oHoveredElement"]) {
			this["oHoveredElement"]["style"]["cursor"] = "inherit";
		}
		oHoveredElement["style"]["cursor"] = this["oResizeSession"]["sArea"]["toLowerCase"]() + "-resize";
		this["oHoveredElement"] = oHoveredElement;
	}
	this["oResizeSession"]["iScreenX"] = oBrowserEvent["iScreenX"]();
	this["oResizeSession"]["iScreenY"] = oBrowserEvent["iScreenY"]();
	this["bTempRatio"] = oBrowserEvent["bShift"]();
	this["calculateResizeGhost"]();
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

	oBrowserEvent["destroy"]();
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["onResizeHandleMouseMove"] = 0; };

/**
 * Returns true only for IE version 8 or 9.
 *
 * @param oBrowserEvent
 * @returns {Boolean}
 */
UCF_DTElement["prototype"]["bIsIE8or9"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bIsIE8or9"]++; }; 
	return UCF_UserAgent["bIsIE"](8, true) || UCF_UserAgent["bIsIE"](9, true);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bIsIE8or9"] = 0; };

/**
 * Returns the content dom ref of the DTElement to allow DTExtensions to render in the content
 * The content element should always have the height and width of the DTElement itself
 * @retunrs {DOMElement} The dom element for the content of this DTElement
 * @private
 */
UCF_DTElement["prototype"]["oGetContentDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetContentDomRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + "-content");
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetContentDomRef"] = 0; };

/**
 * Returns the connected control instance
 * @param {boolean} Auto-Refresh if connected control instance is destroyed
 * @returns {UCF_Control} The control that is connected to this DTElement
 * @private
 */
UCF_DTElement["prototype"]["oGetConnectedControl"] = function(bAutoRefresh) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetConnectedControl"]++; }; 
	if (bAutoRefresh === true && this["oConnectedControl"] && this["oConnectedControl"]["bIsDestroyed"]) this["oConnectedControl"] = null;

	if (this["oConnectedControl"]) return this["oConnectedControl"];

	if (this["aValidControlIDs"]["length"] === 1) {
		this["oConnectedControl"] = this["oGetControlById"](this["aValidControlIDs"][0]);
		return this["oConnectedControl"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetConnectedControl"] = 0; };

/**
 * Returns the connected control info instance
 * @returns {UCF_ControlInfo} The sub control info that is connected to this DTElement
 * @private
 */
UCF_DTElement["prototype"]["oGetConnectedControlInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetConnectedControlInfo"]++; }; 
	if (this["aValidControlIDs"]["length"] === 0) return null;
	var o = UCF_DomUtil["$"](this["aValidControlIDs"][0]);
	if (o && o["getAttribute"] && !o["getAttribute"]("ct")) {
		var oParentDomRef = UCF_DomUtil["oGetParentByAttribute"](o, "ct");
		if (oParentDomRef) {
			var oParentControl = this["oGetControlByDomRef"](oParentDomRef, true);
			if (oParentControl) {
				return oParentControl["oGetContainedControlInfo"](o);
			}
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetConnectedControlInfo"] = 0; };

/**
 * @private
 */
UCF_DTElement["prototype"]["bHasConnectedSubControl"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bHasConnectedSubControl"]++; }; 
	if (this["aValidControlIDs"]["length"] === 0) return false;
	var o = UCF_DomUtil["$"](this["aValidControlIDs"][0]);
	return o && o["getAttribute"] && o["getAttribute"]("subct");
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["bHasConnectedSubControl"] = 0; };

/**
 * Callback for the drag start of this DTElement
 * @private
 */
UCF_DTElement["prototype"]["startDrag"] = function(oDragDropManager) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["startDrag"]++; }; 
	this["highlightPositionParent"](false);
	if (this["oDTContainer"]) {
		this["oDTContainer"]["startDrag"](this, oDragDropManager);
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["startDrag"] = 0; };

/**
 * Callback for the drag end of this DTElement
 * @private
 */
UCF_DTElement["prototype"]["stopDrag"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["stopDrag"]++; }; 
	this["oDTContainer"]["stopDrag"](this);
	this["highlightPositionParent"](true);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["stopDrag"] = 0; };

/**
 * Callback for the any drag state change of this DTElement
 * @private
 */
UCF_DTElement["prototype"]["handleDragStateChange"] = function(oEvt) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["handleDragStateChange"]++; }; 
	this["bDragInProgress"] = oEvt["iId"] === this["oDTContainer"]["E_EVENTS"]["DragStart"];
	if (this["bDragInProgress"]) {
		this["removeHoverStyle"]();
		this["displayResizeHandles"](false);
	} else {
		if (this["sSelectionState"] === this["eSelectionState"]["SELECTED"] && !this["oDTContainer"]["bHasMultiSelection"]()) {
			this["displayResizeHandles"](true);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["handleDragStateChange"] = 0; };

/**
 * Returns the control specific DTExtension and instance of the base class UCF_DTExtension
 * The DTExtension can be used to add control specific functionality to the DTElement
 * @returns {UCF_DTExtesion} the control specific DTExtension and instance of the base class UCF_DTExtesion
 */
UCF_DTElement["prototype"]["oGetDTExtension"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetDTExtension"]++; }; 
	if (this["oDTExtension"] && this["oDTExtension"]["oControl"]) {
		if (this["oDTExtension"]["oControl"]["bIsValid"]()) {
			return this["oDTExtension"];
		} else {
			this["oDTExtension"]["destroy"]();
			this["oDTExtension"] = null;
		}
	}
	return this["createDTExtension"]();
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetDTExtension"] = 0; };

/**
 * Creates the DTExtions for the connected control of this DTElement.
 * Do not use this method. Use oGetDTExtension instead.
 * @returns {UCF_DTExtension} The control specific DTExtension
 * @private
 */
UCF_DTElement["prototype"]["createDTExtension"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["createDTExtension"]++; }; 
	var oControl = this["oGetConnectedControl"]();
	if (oControl && oControl["getClientControl"]() && !this["oDTExtension"]) {
		this["oDTExtension"] = oControl["oGetDTExtension"](this);
		return this["oDTExtension"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["createDTExtension"] = 0; };

/**
 * Moves a DTElement and the connected control to a new parent, and or position and
 * optionally fires the Move event on the DTElement
 * @private
 */
UCF_DTElement["prototype"]["move"] = function(iPosX, iPosY, sParentId, bFireEvent, bMultiple) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["move"]++; }; 
	if (!isNaN(iPosX)) {
		iPosX = iPosX + "px";
	}
	if (!isNaN(iPosY)) {
		iPosY = iPosY + "px";
	}
	var oControl = this["oGetConnectedControl"]();
	if (oControl) {
		if (bFireEvent) {
			this["fireMoved"](this["sId"], this["sMoveMode"], iPosX, iPosY, sParentId, bMultiple);
		}
	}
	this["updatePosition"](); // TODO: Find out if this is needed for Personas-WDA
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["move"] = 0; };

UCF_DTElement["prototype"]["setDropZone"] = function(bDropZone) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setDropZone"]++; }; 
	if (!this["oDTContainer"]["bIsPersonasEnabled"]()) return;

	var oSettings = this["oDTContainer"]["oCurrentDragSessionDecoratorSettings"];
	if (oSettings && oSettings["bShowDropZone"] !== true) return;

	if (bDropZone) {
		UCF_DomUtil["addClass"](this["oDomRef"], "lsDTDropZone");
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], "lsDTDropZone");
	}
	this["oDTContainer"]["oCurrentTargetElement"] = this;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setDropZone"] = 0; };

UCF_DTElement["prototype"]["fireExtensionEvent"] = function(sEvent, sPhase, oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireExtensionEvent"]++; }; 
	var oConnectedControl = this["oGetConnectedControl"]();
	if (!oConnectedControl || !oConnectedControl["bIsValid"]()) return;
	var oEvent = {
		"oSender": this,
		"oControl": oConnectedControl || null,
		"oClientControl": oConnectedControl ? oConnectedControl["getClientControl"]() : null,
		"oClientSender": this["getClientControl"]() || null,
		"bHandled": false,
		"sPhase": sPhase,
		"oBrowserEvent": oBrowserEvent || null
	};
	this["fireEvent"](sEvent, oEvent);
	if (oEvent["bHandled"] && oBrowserEvent) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
	return oEvent["bHandled"];
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireExtensionEvent"] = 0; };

/**
 * Set whether the ratio is kept during resize or not.
 */
UCF_DTElement["prototype"]["setKeepRatio"] = function(bKeep) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setKeepRatio"]++; }; 
	this["bKeepRatio"] = bKeep; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("KeepRatio", bKeep, true);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setKeepRatio"] = 0; };

/**
 * Provide internal stuff for QUnit test recording and playback
 */
UCF_DTElement["prototype"]["oGetTestData"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetTestData"]++; }; 
	var addSID = function(o, sName, oElement) {
		var oConnectedControl = oElement["oGetConnectedControl"]();
		if (oConnectedControl && oConnectedControl["getClientControl"]()) {
			var s = oConnectedControl["getClientControl"]()["getCustomDataKey"]("SID");
			if (s) {
				o["internals"][sName + "CustomData:SID"] = s;
			} else {
				s = oConnectedControl["getClientControl"]()["getCustomDataKey"]("WDA_ID");
				if (s) {
					o["internals"][sName + "CustomData:WDA_ID"] = s;
				}
			}
		}
	};

	var o = UCF_Control.prototype["oGetTestData"]["apply"](this, arguments);
	addSID(o, "", this);
	if (this["oMyParentScrollElement"]) {
		o["internals"]["this.oMyParentScrollElement.sId"] = this["oMyParentScrollElement"]["sId"];
		//addSID(o, "ParentScrollElement:", this.oMyParentScrollElement);
	}
	if (this["oGetParent"]()) {
		o["internals"]["oGetParent().sId"] = this["oGetParent"]()["sGetId"]();
		if (this["oGetParent"]()["sClassName"] == "UCF_DTElement") {
			addSID(o, "oGetParent():", this["oGetParent"]());
		}
	}
	o["internals"]["this.sUseActionMenuAlignment"] = this["sUseActionMenuAlignment"];
	if (this["oActionMenuDom"]) {
		o["internals"]["this.oActionMenuDom.style.top"] = this["oActionMenuDom"]["style"]["top"];
		o["internals"]["this.oActionMenuDom.style.left"] = this["oActionMenuDom"]["style"]["left"];
		o["internals"]["this.oActionMenuDom.offsetTop"] = this["oActionMenuDom"]["offsetTop"];
		o["internals"]["this.oActionMenuDom.offsetLeft"] = this["oActionMenuDom"]["offsetLeft"];
	}
	return o;
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["oGetTestData"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_DTElement["prototype"]["aAttributeNames"] = ["sSelectionState","sHoverEffect","sControlIds","iZIndex","sInplaceEditRefId","sDragSourceInfo","sDropTargetInfoTop","sDropTargetInfoAbove","sDropTargetInfoBefore","sDropTargetInfoAfter","sDropTargetInfoBelow","sDragGhostType","sLayerDesign","bResizeHandleNorth","bResizeHandleSouth","bResizeHandleEast","bResizeHandleWest","sCustomData","sCustomStyle","sOutline","bIsScrollElement","sMoveMode","bKeepRatio","sActionMenuAlignment"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_DTElement["prototype"]["aEventNames"] = ["Drag","ButtonPress","Resize","DragEnd","Moved","DoubleClick","InplaceEditStart","InplaceEditFinish","ActionPress"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_DTElement["prototype"]["aMethodNames"] = ["aGetControlIDs","hide","show","setHiddenDesign","updatePosition","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DTSelectionState}
 */
UCF_DTElement["prototype"]["sSelectionState"] = "SELECTABLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DTHoverEffect}
 */
UCF_DTElement["prototype"]["sHoverEffect"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_DTElement["prototype"]["sControlIds"] = null;

/**
 * @private
 * @type {number}
 */
UCF_DTElement["prototype"]["iZIndex"] = -1;

/**
 * @private
 * @type {string}
 */
UCF_DTElement["prototype"]["sInplaceEditRefId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DTElement["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DTElement["prototype"]["sDropTargetInfoTop"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DTElement["prototype"]["sDropTargetInfoAbove"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DTElement["prototype"]["sDropTargetInfoBefore"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DTElement["prototype"]["sDropTargetInfoAfter"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DTElement["prototype"]["sDropTargetInfoBelow"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DragGhostType}
 */
UCF_DTElement["prototype"]["sDragGhostType"] = "BOX";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DTLayerDesign}
 */
UCF_DTElement["prototype"]["sLayerDesign"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_DTElement["prototype"]["bResizeHandleNorth"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_DTElement["prototype"]["bResizeHandleSouth"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_DTElement["prototype"]["bResizeHandleEast"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_DTElement["prototype"]["bResizeHandleWest"] = false;

/**
 * @private
 * @type {string}
 */
UCF_DTElement["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DTElement["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DTOutlineVisualization}
 */
UCF_DTElement["prototype"]["sOutline"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_DTElement["prototype"]["bIsScrollElement"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DTMoveMode}
 */
UCF_DTElement["prototype"]["sMoveMode"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_DTElement["prototype"]["bKeepRatio"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DTActionMenuAlignment}
 */
UCF_DTElement["prototype"]["sActionMenuAlignment"] = "TOP_LEFT";

//#JSCOVER_EXCL_START
/** @protected */
UCF_DTElement["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setDefaultValues"]++; }; 
	this["sSelectionState"] = "SELECTABLE";
	this["sHoverEffect"] = "NONE";
	this["sControlIds"] = null;
	this["iZIndex"] = -1;
	this["sInplaceEditRefId"] = '';
	this["sDragSourceInfo"] = '';
	this["sDropTargetInfoTop"] = '';
	this["sDropTargetInfoAbove"] = '';
	this["sDropTargetInfoBefore"] = '';
	this["sDropTargetInfoAfter"] = '';
	this["sDropTargetInfoBelow"] = '';
	this["sDragGhostType"] = "BOX";
	this["sLayerDesign"] = "NONE";
	this["bResizeHandleNorth"] = false;
	this["bResizeHandleSouth"] = false;
	this["bResizeHandleEast"] = false;
	this["bResizeHandleWest"] = false;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sOutline"] = "NONE";
	this["bIsScrollElement"] = false;
	this["sMoveMode"] = "NONE";
	this["bKeepRatio"] = false;
	this["sActionMenuAlignment"] = "TOP_LEFT";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("SelectionState", "SELECTABLE", true);
		this["setClientProperty"]("HoverEffect", "NONE", true);
		this["setClientProperty"]("ControlIds", null, true);
		this["setClientProperty"]("ZIndex", -1, true);
		this["setClientProperty"]("InplaceEditRefId", '', true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("DropTargetInfoTop", '', true);
		this["setClientProperty"]("DropTargetInfoAbove", '', true);
		this["setClientProperty"]("DropTargetInfoBefore", '', true);
		this["setClientProperty"]("DropTargetInfoAfter", '', true);
		this["setClientProperty"]("DropTargetInfoBelow", '', true);
		this["setClientProperty"]("DragGhostType", "BOX", true);
		this["setClientProperty"]("LayerDesign", "NONE", true);
		this["setClientProperty"]("ResizeHandleNorth", false, true);
		this["setClientProperty"]("ResizeHandleSouth", false, true);
		this["setClientProperty"]("ResizeHandleEast", false, true);
		this["setClientProperty"]("ResizeHandleWest", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("Outline", "NONE", true);
		this["setClientProperty"]("IsScrollElement", false, true);
		this["setClientProperty"]("MoveMode", "NONE", true);
		this["setClientProperty"]("KeepRatio", false, true);
		this["setClientProperty"]("ActionMenuAlignment", "TOP_LEFT", true);
	}
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires DTElement::Drag
 */
UCF_DTElement["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "DTElement.js(3048): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTElement.js(3049): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTElement.js(3050): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "DTElement.js(3051): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "DTElement.js(3052): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "DTElement.js(3053): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "DTElement.js(3054): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("DTElement", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId The ID of the DTElement.
 * @param {string} sButtonName Value is CONFIG or CLOSE.
 * @fires DTElement::ButtonPress
 */
UCF_DTElement["prototype"]["fireButtonPress"] = function(sId, sButtonName) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireButtonPress"]++; }; 
	/** @type {{Id: string, ButtonName: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "DTElement.js(3076): fireButtonPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTElement.js(3077): fireButtonPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTElement.js(3078): fireButtonPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sButtonName != null, "sButtonName != null", "DTElement.js(3079): fireButtonPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sButtonName) == "string", "typeof(sButtonName) == \"string\"", "DTElement.js(3080): fireButtonPress"); };
	mParams = {
		"Id": sId,
		"ButtonName": sButtonName
	};
	
	
	this["fireSemanticEvent"]("DTElement", "ButtonPress", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireButtonPress"] = 0; };

/**
 * @protected
 * @param {string} sId The ID of the DTElement.
 * @param {number} iRasterWidth The new width in raster units
 * @param {number} iRasterHeight The new height in raster units
 * @param {number} iRasterPosX The new X raster position if the resize handles N, NW, NE, E, SE were used.
 * @param {number} iRasterPosY The new Y raster position if the resize handles N, NW, NE, E, SE were used.
 * @param {number} iGridWidth The new width of the element in grid columns. Contains -1 if the grid-mode is not enabled.
 * @param {number} iGridHeight The new height of the element in grid rows. Contains -1 if the grid-mode is not enabled.
 * @fires DTElement::Resize
 */
UCF_DTElement["prototype"]["fireResize"] = function(sId, iRasterWidth, iRasterHeight, iRasterPosX, iRasterPosY, iGridWidth, iGridHeight) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireResize"]++; }; 
	/** @type {{Id: string, RasterWidth: number, RasterHeight: number, RasterPosX: number, RasterPosY: number, GridWidth: number, GridHeight: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "DTElement.js(3105): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTElement.js(3106): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTElement.js(3107): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRasterWidth != null, "iRasterWidth != null", "DTElement.js(3108): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRasterWidth) == "number", "typeof(iRasterWidth) == \"number\"", "DTElement.js(3109): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRasterHeight != null, "iRasterHeight != null", "DTElement.js(3110): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRasterHeight) == "number", "typeof(iRasterHeight) == \"number\"", "DTElement.js(3111): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRasterPosX != null, "iRasterPosX != null", "DTElement.js(3112): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRasterPosX) == "number", "typeof(iRasterPosX) == \"number\"", "DTElement.js(3113): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRasterPosY != null, "iRasterPosY != null", "DTElement.js(3114): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRasterPosY) == "number", "typeof(iRasterPosY) == \"number\"", "DTElement.js(3115): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iGridWidth != null, "iGridWidth != null", "DTElement.js(3116): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iGridWidth) == "number", "typeof(iGridWidth) == \"number\"", "DTElement.js(3117): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iGridHeight != null, "iGridHeight != null", "DTElement.js(3118): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iGridHeight) == "number", "typeof(iGridHeight) == \"number\"", "DTElement.js(3119): fireResize"); };
	mParams = {
		"Id": sId,
		"RasterWidth": iRasterWidth,
		"RasterHeight": iRasterHeight,
		"RasterPosX": iRasterPosX,
		"RasterPosY": iRasterPosY,
		"GridWidth": iGridWidth,
		"GridHeight": iGridHeight
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("DTElement", "Resize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @fires DTElement::DragEnd
 */
UCF_DTElement["prototype"]["fireDragEnd"] = function(sId, sDragSourceInfo) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireDragEnd"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "DTElement.js(3149): fireDragEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTElement.js(3150): fireDragEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTElement.js(3151): fireDragEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "DTElement.js(3152): fireDragEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "DTElement.js(3153): fireDragEnd"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo
	};
	
	
	this["fireSemanticEvent"]("DTElement", "DragEnd", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireDragEnd"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sPosition ABSOLUTE or RELATIVE
 * @param {string} sPosX The x position relative or absolute depending on the move mode
 * @param {string} sPosY The y position relative or absolute depending on the move mode
 * @param {string} sParentId The id of the parent element that should be used to calculate the positions top left
 * @param {boolean} bMultiple Whether there are multiple controls affected
 * @fires DTElement::Moved
 */
UCF_DTElement["prototype"]["fireMoved"] = function(sId, sPosition, sPosX, sPosY, sParentId, bMultiple) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireMoved"]++; }; 
	/** @type {{Id: string, Position: string, PosX: string, PosY: string, ParentId: string, Multiple: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 6, "arguments.length == 6", "DTElement.js(3177): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTElement.js(3178): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTElement.js(3179): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPosition != null, "sPosition != null", "DTElement.js(3180): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPosition) == "string", "typeof(sPosition) == \"string\"", "DTElement.js(3181): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPosX != null, "sPosX != null", "DTElement.js(3182): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPosX) == "string", "typeof(sPosX) == \"string\"", "DTElement.js(3183): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPosY != null, "sPosY != null", "DTElement.js(3184): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPosY) == "string", "typeof(sPosY) == \"string\"", "DTElement.js(3185): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sParentId != null, "sParentId != null", "DTElement.js(3186): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sParentId) == "string", "typeof(sParentId) == \"string\"", "DTElement.js(3187): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bMultiple != null, "bMultiple != null", "DTElement.js(3188): fireMoved"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bMultiple) == "boolean", "typeof(bMultiple) == \"boolean\"", "DTElement.js(3189): fireMoved"); };
	mParams = {
		"Id": sId,
		"Position": sPosition,
		"PosX": sPosX,
		"PosY": sPosY,
		"ParentId": sParentId,
		"Multiple": bMultiple
	};
	
	
	
	
	
	
	this["fireSemanticEvent"]("DTElement", "Moved", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireMoved"] = 0; };

/**
 * @protected
 * @param {string} sId The ID of the DTElement.
 * @fires DTElement::DoubleClick
 */
UCF_DTElement["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "DTElement.js(3216): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTElement.js(3217): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTElement.js(3218): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("DTElement", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @fires DTElement::InplaceEditStart
 */
UCF_DTElement["prototype"]["fireInplaceEditStart"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireInplaceEditStart"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "DTElement.js(3235): fireInplaceEditStart"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTElement.js(3236): fireInplaceEditStart"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTElement.js(3237): fireInplaceEditStart"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("DTElement", "InplaceEditStart", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireInplaceEditStart"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sInplaceEditRefId The connected ControlId for inplace editing
 * @param {string} sText The new text
 * @fires DTElement::InplaceEditFinish
 */
UCF_DTElement["prototype"]["fireInplaceEditFinish"] = function(sId, sInplaceEditRefId, sText) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireInplaceEditFinish"]++; }; 
	/** @type {{Id: string, InplaceEditRefId: string, Text: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "DTElement.js(3256): fireInplaceEditFinish"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTElement.js(3257): fireInplaceEditFinish"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTElement.js(3258): fireInplaceEditFinish"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sInplaceEditRefId != null, "sInplaceEditRefId != null", "DTElement.js(3259): fireInplaceEditFinish"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sInplaceEditRefId) == "string", "typeof(sInplaceEditRefId) == \"string\"", "DTElement.js(3260): fireInplaceEditFinish"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sText != null, "sText != null", "DTElement.js(3261): fireInplaceEditFinish"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sText) == "string", "typeof(sText) == \"string\"", "DTElement.js(3262): fireInplaceEditFinish"); };
	mParams = {
		"Id": sId,
		"InplaceEditRefId": sInplaceEditRefId,
		"Text": sText
	};
	
	
	
	this["fireSemanticEvent"]("DTElement", "InplaceEditFinish", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireInplaceEditFinish"] = 0; };

/**
 * @protected
 * @param {string} sId The ID of the DTElement.
 * @param {string} sActionItemId The ID of the DTActionMenuItem.
 * @fires DTElement::ActionPress
 */
UCF_DTElement["prototype"]["fireActionPress"] = function(sId, sActionItemId) {;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireActionPress"]++; }; 
	/** @type {{Id: string, ActionItemId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "DTElement.js(3284): fireActionPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DTElement.js(3285): fireActionPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DTElement.js(3286): fireActionPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sActionItemId != null, "sActionItemId != null", "DTElement.js(3287): fireActionPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sActionItemId) == "string", "typeof(sActionItemId) == \"string\"", "DTElement.js(3288): fireActionPress"); };
	mParams = {
		"Id": sId,
		"ActionItemId": sActionItemId
	};
	
	
	this["fireSemanticEvent"]("DTElement", "ActionPress", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DTElement["_"]["fireActionPress"] = 0; };

UCF_DTElement.prototype["aPublicMethods"] = ["aGetControlIDs","setHiddenDesign","updatePosition","show","hide"].concat(UCF_DTElement.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_DTElementDragDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_DTElementDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["UCF_DTElementDragDelegate"]++; }; 

	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);

	var oDTC = oDragSourceControl["oDTContainer"];
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bGridMode"] = oDTC && oDTC["getClientControl"]() && oDTC["getClientControl"]()["bEnableRasterLayoutGridMode"] === true;
};window["UCF_DTElementDragDelegate"] = UCF_DTElementDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DTElementDragDelegate"); UCF_DTElementDragDelegate["_"] = {UCF_DTElementDragDelegate: 0}; }; ;

UCF_DTElementDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_DTElementDragDelegate.prototype["sClassName"] = "UCF_DTElementDragDelegate";

/**
 * Get a ghost for the referenced control or DOM element.
 */
UCF_DTElementDragDelegate["prototype"]["oGetGhost"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["oGetGhost"]++; }; 

	var oDiv = document["createElement"]("DIV");
	var oGhost = null;
	var aControlIds, oClone, s;
	var aElements = this["oDragSourceControl"]["oDTContainer"]["aListSelectedElements"]();
	if (this["oDragSourceControl"]["sMoveMode"] !== "NONE" && aElements["length"] > 1) {
		// Content of all selected controls is combined in one ghost...
		// Determine relative position of all other controls to the one that is dragged with mouse cursor
		var iRefPosTop = this["oDragSourceControl"]["oDomRef"]["offsetTop"];
		var iRefPosLeft = this["oDragSourceControl"]["oDomRef"]["offsetLeft"];

		for (var i = 0; i < aElements["length"]; i++) {
			var oSelectedElement = aElements[i];
			var iPosTop = oSelectedElement["oDomRef"]["offsetTop"];
			var iPosLeft = oSelectedElement["oDomRef"]["offsetLeft"];

			aControlIds = oSelectedElement["sControlIds"]["split"](" ");
			var oChildDiv = document["createElement"]("DIV");
			oClone = this["cloneControlDom"](aControlIds[0]);
			s = oClone["style"];
			s["position"] = "static";
			s["top"] = s["left"] = s["marginLeft"] = s["marginTop"] = "0px";
			s["opacity"] = "0.85";

			oChildDiv["appendChild"](oClone);

			oChildDiv["style"]["position"] = "absolute";
			oChildDiv["style"]["top"] = (iPosTop - iRefPosTop) + "px";
			oChildDiv["style"]["left"] = (iPosLeft - iRefPosLeft) + "px";
			oChildDiv["style"]["width"] = (oSelectedElement["oDomRef"]["clientWidth"] + 2) + "px";
			oChildDiv["style"]["height"] = oSelectedElement["oDomRef"]["clientHeight"] + "px";
			oChildDiv["style"]["display"] = "inline-block";
			oChildDiv["className"] = "lsDTBorder";

			oDiv["appendChild"](oChildDiv);

			// Set size > 0 so that the stuff is rendered...
			oDiv["style"]["width"] = "1px";
			oDiv["style"]["height"] = "1px";
		}

		oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv, true);
		oGhost["disableAnimation"]();
	} else if (this["oDragSourceControl"]["sDragGhostType"] === "CONTENT") {
		// take the content of the first connected control as ghost
		aControlIds = this["oDragSourceControl"]["sControlIds"]["split"](" ");
		var oControl = this["oDragSourceControl"]["oGetControlById"](aControlIds[0]);
		if (oControl) {
			oClone = oControl["oRootRef"]["cloneNode"](true);
			s = oClone["style"];
			s["position"] = "static";
			s["top"] = s["left"] = s["marginLeft"] = s["marginTop"] = "0px";
			s["opacity"] = "0.85";

			oDiv["appendChild"](oClone);

			// Right border cut off on FF and Safari => +2
			oDiv["style"]["width"] = (this["oDragSourceControl"]["oDomRef"]["offsetWidth"]) + "px";
			oDiv["style"]["height"] = (this["oDragSourceControl"]["oDomRef"]["offsetHeight"]) + "px";
			oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv);
			oGhost["disableAnimation"]();
			// ???
			//			if (this.oDragSourceControl.sMoveMode !== "NONE") {
			//				oDiv.className = "lsDTBorder";
			//			}
		}
	} else {
		if (this["oDragSourceControl"]["oDTContainer"]["bHasMultiSelection"]()) {
			oDiv["style"]["width"] = "20px";
			oDiv["style"]["height"] = "17px";
			oDiv["style"]["backgroundRepeat"] = "no-repeat";
			oDiv["className"] = "lsDTGhost";
			oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv);
		} else {
			oDiv["style"]["width"] = this["oDragSourceControl"]["oDomRef"]["offsetWidth"] + "px";
			oDiv["style"]["height"] = this["oDragSourceControl"]["oDomRef"]["offsetHeight"] + "px";

			oDiv["appendChild"](this["oDragSourceControl"]["oDomRef"]["cloneNode"](true));

			UCF_DomUtil["firstChild"](oDiv)["style"]["position"] = "static";
			oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv);
			oGhost["disableAnimation"]();
		}
	}
	if (this["oDragSourceControl"]["sMoveMode"] === "NONE") {
		oGhost["setOffset"](10, 10);
	}
	var oSettings = this["oDragSourceControl"]["oDTContainer"]["oCurrentDragSessionDecoratorSettings"];
	if (oSettings && oSettings["iGhostScaling"]) {
		oGhost["setScaling"](oSettings["iGhostScaling"]);
	}

	// var oRLDom = UCF_DomUtil.oGetParentByAttribute(this.oDragSourceControl.oGetConnectedControl().oDomRef, "ct", "RL");
	// if (oRLDom) {
	// 	var oDragSourceRasterLayoutControl = this.oLS.oControlFactory.oGetControlByDomRef(oRLDom, true);
	//     //var oDTC = this.oDragSourceControl.oDTContainer;
	// 	if (this.bGridMode) {
	// 		// this.oRLRect = UCF_DomUtil.oGetObjectRect(oDragSourceRasterLayoutControl.oDomRef);
	// 		// var oRasterSize = oDragSourceRasterLayoutControl.oGetRasterSizePx();
	// 		// if (oRasterSize) {
	// 		// 	oGhost.setRasterMode(this.oRLRect.left, this.oRLRect.top, oRasterSize.width, oRasterSize.height, true, true);
	// 		// }
	// 		// else {
	// 		// 	oGhost.setRasterMode(this.oRLRect.left, this.oRLRect.top, oDragSourceRasterLayoutControl.fRasterWidth, oDragSourceRasterLayoutControl.fRasterHeight, true, true);
	// 		// }
	//         // Ghost "position"
	// 	}
	// }
	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["oGetGhost"] = 0; };

UCF_DTElementDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["bIsDragPossible"]++; }; 
	//var oDTContainer = this.oDragSourceControl.oDTContainer;
	//if (!oDTContainer.bIsMode(UCF_DTContainer.MODES.DEFAULT)) return false;

	var oCC = this["oDragSourceControl"]["oGetConnectedControl"]();
	// oGetConnectedControl() may return null if a DTElement has more than one ControlID reference
	if (oCC === null) {
		return this["oDragSourceControl"]["sSelectionState"] !== "UNSELECTABLE";
	}
	if (!oCC["bGetInvisibility"]()) {
		return this["oDragSourceControl"]["sSelectionState"] !== "UNSELECTABLE";
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["bIsDragPossible"] = 0; };

UCF_DTElementDragDelegate["prototype"]["onlsdrag"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["onlsdrag"]++; }; 

	if (this["oDragSourceControl"]["fireExtensionEvent"](this["oDragSourceControl"]["EXTENSION_EVENT"]["onElementDrag"], "before", oBrowserEvent)) return;

	if (this["oDragSourceControl"]["sMoveMode"] !== "NONE") {
		// TODO: What is this for ?
		this["oDragSourceControl"]["displayResizeHandles"](false);
		var oPosition = { "left": oBrowserEvent["iPageX"](), "top": oBrowserEvent["iPageY"]() },
			oNewRect = { "left": oBrowserEvent["iPageX"](), "top": oBrowserEvent["iPageY"]() },
			oGhost = oBrowserEvent["oDragAndDropManager"]["oDragSession"]["oGetGhost"]();
		if (oGhost) {
			oPosition["left"] += oGhost["iOffsetLeft"];
			oPosition["top"] += oGhost["iOffsetTop"];
			if (Math["abs"](oNewRect["left"] - oGhost["iForcedLeft"]) > 3) {
				oGhost["iForcedLeft"] = null;
			}
			if (Math["abs"](oNewRect["top"] - oGhost["iForcedTop"]) > 3) {
				oGhost["iForcedTop"] = null;
			}
		}
	}

	if (this["bGridMode"]) {
		this["oDragSourceControl"]["oDTContainer"]["handleDragForRasterLayoutGrid"](oBrowserEvent);
	}

	if (this["oDragSourceControl"]["fireExtensionEvent"](this["oDragSourceControl"]["EXTENSION_EVENT"]["onElementDrag"], "after", oBrowserEvent)) return;

};;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["onlsdrag"] = 0; };

UCF_DTElementDragDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["onlsdragstart"]++; }; 

	// In Designtime we want to be able to disable DnD for selectable elements: If they have no DragSourceInfo, they get no delegate.
	// But since DTElements are nested for ScrollContainer support, the dragstart may bubble up in LS to a parent (scroll-)DTElement
	if (this["oDragSourceControl"]["oDomRef"] !== oBrowserEvent["oGetSource"]()["parentNode"]) {
		var oRealDragSourceControl = this["oLS"]["oControlFactory"]["oGetControlById"](oBrowserEvent["oGetSource"]()["parentNode"]["id"]);
		if (oRealDragSourceControl && oRealDragSourceControl["bIsSelectable"]()) {
			return;
		}
	}

	if (this["oDragSourceControl"]["fireExtensionEvent"](this["oDragSourceControl"]["EXTENSION_EVENT"]["onElementDragStart"], "before", oBrowserEvent)) return;

	if (oBrowserEvent["oGetSource"]()["getAttribute"]("dt_ami") !== null || oBrowserEvent["oGetSource"]() === this["sId"] + "-actionmenu") {
		return;
	}

	if (this["oDragSourceControl"]["bResizing"]) {
		return;
	};

	this["oDragSourceControl"]["oDTContainer"]["beforeDragSession"](this["oDragSourceControl"]);

	UCF_DragDelegate.prototype["onlsdragstart"]["apply"](this, arguments);

	// At this point we may have NO DragSession if UCF_DTElementDragDelegate.bIsDragPossible() returned false when called by UCF_DragDelegate._super()
	// e.g. if the control is invisible!!
	if (oBrowserEvent["oDragAndDropManager"]["oDragSession"] === undefined) return;
	this["oDragSourceControl"]["oDTContainer"]["hideSelectedControlsOnDragStart"](this["oDragSourceControl"]);

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD start drag: element=" + this["oDragSourceControl"]["sId"] + " tags=" + this["oDragSourceControl"]["sDragSourceInfo"], "DTElementDragDelegate.js(218): onlsdragstart"); };
	this["oDragSourceControl"]["startDrag"](oBrowserEvent["oDragAndDropManager"]);

	if (this["oDragSourceControl"]["fireExtensionEvent"](this["oDragSourceControl"]["EXTENSION_EVENT"]["onElementDragStart"], "after", oBrowserEvent)) return;
};;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["onlsdragstart"] = 0; };

UCF_DTElementDragDelegate["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["onlsdragend"]++; }; 

	if (this["oDragSourceControl"]["fireExtensionEvent"](this["oDragSourceControl"]["EXTENSION_EVENT"]["onElementDragEnd"], "before", oBrowserEvent)) return;

	if (!oBrowserEvent["bDropHandled"]) {
		// No drop: Drag was cancelled or drop on an illegal target
		this["oDragSourceControl"]["forwardDDCancel"]();
	}
	this["oDragSourceControl"]["oDTContainer"]["showSelectedControlsOnDragEnd"](this["oDragSourceControl"]);
	this["oDragSourceControl"]["stopDrag"]();

	if (this["oDragSourceControl"]["fireExtensionEvent"](this["oDragSourceControl"]["EXTENSION_EVENT"]["onElementDragEnd"], "after", oBrowserEvent)) return;
};;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["onlsdragend"] = 0; };

UCF_DTElementDragDelegate["prototype"]["cloneControlDom"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["cloneControlDom"]++; }; 
	var oCloneNode = UCF_DomUtil["$"](sId + "-r");
	if (oCloneNode === null) {
		oCloneNode = UCF_DomUtil["$"](sId);
	}
	return oCloneNode["cloneNode"](true);
};;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["cloneControlDom"] = 0; };

/**
 * Destructor
 */
UCF_DTElementDragDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["destroy"]++; }; 

	UCF_DragDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTElementDragDelegate["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_DTElementDropDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="../base/DragSession.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_LineDecorator */
/// <reference path="../decorators/LineDecorator.js"/>

/**
 * UCF_DTElementDropDelegate
 * @class
 *
 * @param {UCF_LS} oLS LS instance
 * @param {UCF_Control} oDropTargetControl The drop target control
 */
function UCF_DTElementDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["UCF_DTElementDropDelegate"]++; }; 

	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);
	this["oLS"] = oLS;

	this["bDecoratorsCreated"] = false;
	this["sDropIndex"] = "";

	this["iCurrentStepY"] = 0;
	this["iCurrentStepX"] = 0;
};window["UCF_DTElementDropDelegate"] = UCF_DTElementDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DTElementDropDelegate"); UCF_DTElementDropDelegate["_"] = {UCF_DTElementDropDelegate: 0}; }; ;
UCF_DTElementDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_DTElementDropDelegate.prototype["sClassName"] = "UCF_DTElementDropDelegate";

/**
 * destructor
 */
UCF_DTElementDropDelegate["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["destroy"]++; }; 

	this["sDropIndex"] = "";
	if (this["oHorizontalDropDecorator"]) {
		this["oHorizontalDropDecorator"]["destroy"]();
		this["oHorizontalDropDecorator"] = null;
	}
	if (this["oVerticalDropDecorator"]) {
		this["oVerticalDropDecorator"]["destroy"]();
		this["oVerticalDropDecorator"] = null;
	}
	this["oDecorator"] = null;
	this["ePosition"] = "";

	UCF_DropDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["destroy"] = 0; };


/**
 * handle dragscroll event
 */
UCF_DTElementDropDelegate["prototype"]["onlsdragscroll"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["onlsdragscroll"]++; }; 
	var oDraggedElement = this["oLS"]["oGetControlByDomRef"](this["oLS"]["oGetDragSession"]()["oGetDragSource"](), true);
	if (oDraggedElement && oDraggedElement["oMyParentScrollElement"]) {
		this["doDragScroll"](oDraggedElement["oMyParentScrollElement"], oBrowserEvent["iPageX"](), oBrowserEvent["iPageY"]());
	}
	UCF_DropDelegate.prototype["onlsdragscroll"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["onlsdragscroll"] = 0; };

/**
 * Implement our own drag-scrolling in advanced SC mode.
 * Basicly the same algo. as in ScrollArea.onlsdragscroll()
 * @private
 */

UCF_DTElementDropDelegate["prototype"]["doDragScroll"] = function (oScrollElement, iMouseX, iMouseY) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["doDragScroll"]++; }; 
	//_trace(INFO, ">>> mx=" + iMouseX + ", my="+ iMouseY);

	var oViewPort = UCF_DomUtil["oGetObjectRect"](oScrollElement["oDomRef"]);
	//_trace(INFO, ">>> vleft=" + oViewPort.left + ", vtop="+ oViewPort.top + ", vheight=" + oViewPort.height);

	var iVerticalZone = Math["min"](35, oViewPort["height"] / 4);
	var iHorizontalZone = Math["min"](35, oViewPort["width"] / 4);

	var iScrollThresholdTop = oViewPort["top"] + iVerticalZone;
	var iScrollThresholdBottom = oViewPort["top"] + oViewPort["height"] - iVerticalZone;

	var iScrollThresholdLeft = oViewPort["left"] + iHorizontalZone;
	var iScrollThresholdRight = oViewPort["left"] + oViewPort["width"] - iHorizontalZone;

	var iStepY = 0,
		iStepX = 0;

	if (iMouseX < iScrollThresholdLeft) {
		iStepX = -Math["round"]((iScrollThresholdLeft - iMouseX) / iHorizontalZone * 10);
	} else if (iMouseX > iScrollThresholdRight) {
		iStepX = Math["round"]((iMouseX - iScrollThresholdRight) / iHorizontalZone * 10);
	}

	if (iMouseY < iScrollThresholdTop) {
		iStepY = -Math["round"]((iScrollThresholdTop - iMouseY) / iVerticalZone * 10);
	} else if (iMouseY > iScrollThresholdBottom) {
		iStepY = Math["round"]((iMouseY - iScrollThresholdBottom) / iVerticalZone * 10);
	}

	if (this["iCurrentStepX"] < iStepX) {
		this["iCurrentStepX"]++;
	} else if (this["iCurrentStepX"] > iStepX) {
		this["iCurrentStepX"]--;
	}

	if (this["iCurrentStepY"] < iStepY) {
		this["iCurrentStepY"]++;
	} else if (this["iCurrentStepY"] > iStepY) {
		this["iCurrentStepY"]--;
	}

	oScrollElement["scrollDelta"](this["iCurrentStepY"], this["iCurrentStepX"]);
};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["doDragScroll"] = 0; };

UCF_DTElementDropDelegate["prototype"]["onlsdragenter"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["onlsdragenter"]++; }; 

	// if (console) console.log(">>> onlsdragENTER: this.oDropTargetControl.sId=" + this.oDropTargetControl.sId);

	this["oDropTargetControl"]["setDropZone"](true);

	this["oDropTargetControl"]["oDTContainer"]["showPositionByBrowserEvent"](oBrowserEvent, this["oDropTargetControl"]);

	this["oDropTargetControl"]["onmouseover"](oBrowserEvent);

	return this["onlsdragover"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["onlsdragenter"] = 0; };

UCF_DTElementDropDelegate["prototype"]["onlsdragover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["onlsdragover"]++; };  // eslint-disable-line complexity
	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];
	var oDropDecorator = null;
	var oDragSession = this["oLS"]["oGetDragSession"]();
	var i;
	var iLeft;
	var iTop;
	var iLength;

	//if (console) console.log(">>> onlsdragover: sId=" + this.oDropTargetControl.sId);

	if (this["oDropTargetControl"]["oDTExtension"] && this["oDropTargetControl"]["oDTExtension"]["bIsDropDelegate"] && this["oDropTargetControl"]["oDTExtension"]["bIsDropDelegate"]()) {
		return;
	}
	//	if (this.oDropTargetControl.oDTContainer.bIsMode(UCF_DTContainer.MODES.TABSEQUENCE)) {
	//		var oData = oBrowserEvent.oDragAndDropManager.oDragSession.oGetCustomData();
	//
	//		oBrowserEvent.oDragAndDropManager.setDropEnabledCursor(UCF_DragSession.E_CURSOR.CROSSHAIR);
	//		return;
	//	}
	if (this["oDropTargetControl"]["oDTContainer"]["bDragAndDropLayoutMode"] === true
		&&
		!this["oDropTargetControl"]["sDropTargetInfo" + UCF_DTElementDropDelegate["POSITION"]["NORTH"]]
		&&
		!this["oDropTargetControl"]["sDropTargetInfo" + UCF_DTElementDropDelegate["POSITION"]["WEST"]]
		&&
		!this["oDropTargetControl"]["sDropTargetInfo" + UCF_DTElementDropDelegate["POSITION"]["EAST"]]
		&&
		!this["oDropTargetControl"]["sDropTargetInfo" + UCF_DTElementDropDelegate["POSITION"]["SOUTH"]]
		&&
		!this["oDropTargetControl"]["sDropTargetInfo" + UCF_DTElementDropDelegate["POSITION"]["TOP"]]) {

		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD dragover: enter bDragAndDropLayoutMode... " + this["oDropTargetControl"]["sId"], "DTElementDropDelegate.js(164): onlsdragover"); };

		// No DropTargetInfo defined
		// On LayoutMode we try to find a "parent" element that can handle the dragover and show decorators
		// We have to remember this in the drag session to later generate a drop event for the correct parent element
		this["oDropTargetControl"]["findAncestorLayerElements"](true);
		if (this["oDropTargetControl"]["aPreviousLayerElements"]["length"] > 0) {
			oDragSession["bDTLayoutMode"] = true;
			this["oDropTargetControl"]["aPreviousLayerElements"][0]["createDropDelegate"]();
			this["oDropTargetControl"]["aPreviousLayerElements"][0]["oDropDelegate"]["onlsdragover"](oBrowserEvent);
		}

		return;
	} else if (oDragSession["bDTLayoutMode"] === true) {
		oDragSession["oDTUseParentElementDelegate"] = this;
	}

	// Note: It is important to also properly handle the event bubbling (see DropDelegate)
	var bEventBubbling = this["bGetEventBubbling"](oBrowserEvent);
	var sDropTags = this["sGetDropTags"](oBrowserEvent);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, this["traceDragOver"](sDropTags), "DTElementDropDelegate.js(184): onlsdragover"); };

	if (!oDragAndDropManager["bGetDropAllowed"](sDropTags)) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD dragover: target=" + this["oDropTargetControl"]["sId"] + " DRAG NOT ALLOWED", "DTElementDropDelegate.js(187): onlsdragover"); };
		if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
		return;
	}
	if (!this["bIsDropPossible"](oBrowserEvent)) {
		if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
		return;
	}

	this["oDropTargetControl"]["findAncestorLayerElements"](true);

	this["createDecorators"](oBrowserEvent);
	this["oHorizontalDropDecorator"]["hide"]();
	this["oVerticalDropDecorator"]["hide"]();
	this["oDecorator"]["hide"]();

	function rectSort(oRectA, oRectB) {
		return oRectA["left"] - oRectB["left"];
	}

	//initialize drop
	var oRect = null;
	var oCurrentRect = null;
	var sc = null;
	if (!this["oDropTargetControl"]["oDTContainer"]["bIsPersonasEnabled"]()) {
		sc = this["oLS"]["oGetControlByDomRef"](this["oLS"]["oGetDragSession"]()["oGetDragSource"](), true);
		if (sc) sc["findAncestorLayerElements"](true);
	}
	this["oDropTargetControl"]["oDTContainer"]["showPositionByBrowserEvent"](oBrowserEvent, this["oDropTargetControl"]);

	if (sc && this["oDropTargetControl"]["oDTContainer"]["bDragAndDropLayoutMode"] === false &&
		(sc && this["oDropTargetControl"]["aPreviousLayerElements"]["length"] === 1 && sc["aPreviousLayerElements"]["length"] === 1 && this["oDropTargetControl"]["aPreviousLayerElements"][0]["sId"] === sc["aPreviousLayerElements"][0]["sId"]
			|| this["oDropTargetControl"]["aNextLayerElements"]["length"] >= 1)) {

		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD dragover: enter parent-child handling... " + this["oDropTargetControl"]["sId"], "DTElementDropDelegate.js(221): onlsdragover"); };
		var aChildLayerElementsRect = [];
		iLeft = 0;
		this["sDropIndex"] = "";

		//get rect of parentNodes as well as all childNodes
		if (this["oDropTargetControl"]["aPreviousLayerElements"]["length"] === 1) {

			//hovering childNodes
			oRect = UCF_DomUtil["oGetObjectRect"](this["oDropTargetControl"]["aPreviousLayerElements"][0]["oDomRef"]);

			oCurrentRect = UCF_DomUtil["oGetObjectRect"](this["oDropTargetControl"]["oDomRef"]);
			if (this["oDropTargetControl"]["sSelectionState"] === this["oDropTargetControl"]["eSelectionState"]["SELECTED"]) {
				oCurrentRect["left"] -= 2;
			}
			aChildLayerElementsRect["push"](oCurrentRect);
			for (i = 0; i < this["oDropTargetControl"]["aSiblingLayerElements"]["length"]; i++) {
				oCurrentRect = UCF_DomUtil["oGetObjectRect"](this["oDropTargetControl"]["aSiblingLayerElements"][i]["oDomRef"]);
				if (this["oDropTargetControl"]["aSiblingLayerElements"][i]["sSelectionState"] === this["oDropTargetControl"]["eSelectionState"]["SELECTED"]) {
					oCurrentRect["left"] -= 2;
				}
				aChildLayerElementsRect["push"](oCurrentRect);
			}
		} else {
			//hovering parentNode
			oRect = UCF_DomUtil["oGetObjectRect"](this["oDropTargetControl"]["oDomRef"]);

			for (i = 0; i < this["oDropTargetControl"]["aNextLayerElements"]["length"]; i++) {
				oCurrentRect = UCF_DomUtil["oGetObjectRect"](this["oDropTargetControl"]["aNextLayerElements"][i]["oDomRef"]);
				if (this["oDropTargetControl"]["aNextLayerElements"][i]["sSelectionState"] === this["oDropTargetControl"]["eSelectionState"]["SELECTED"]) {
					oCurrentRect["left"] -= 2;
				}
				aChildLayerElementsRect["push"](oCurrentRect);
			}
		}

		aChildLayerElementsRect["sort"](rectSort);

		//determine current position to render line decorator
		//first section: from parent left border to half of the space to firstChild left border
		if (oBrowserEvent["_iClientX"] <= (oRect["left"] + ((aChildLayerElementsRect[0]["left"] - oRect["left"]) / 2))) {
			iLeft = oRect["left"];
			this["sDropIndex"] = "begin";
		}
		//second section: from right end of first section to middle of firstChild
		else if (oBrowserEvent["_iClientX"] <= (aChildLayerElementsRect[0]["left"] + (aChildLayerElementsRect[0]["width"] / 2))) {
			iLeft = aChildLayerElementsRect[0]["left"];
			this["sDropIndex"] = 1 + "-before";
		}
		//third section: from middle of lastChild to half of the space to parent right border
		else if (oBrowserEvent["_iClientX"] >= (aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["left"] + aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["width"] / 2) &&
			oBrowserEvent["_iClientX"] <= ((aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["left"] + aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["width"]) +
				((oRect["left"] + oRect["width"]) - (aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["left"] + aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["width"])) / 2)) {
			iLeft = aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["left"] + aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["width"];
			this["sDropIndex"] = aChildLayerElementsRect["length"] + "-after";
		}
		//fourth section: from right end of third section to parent right border
		else if (oBrowserEvent["_iClientX"] >= ((aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["left"] + aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["width"]) +
			((oRect["left"] + oRect["width"]) - (aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["left"] + aChildLayerElementsRect[aChildLayerElementsRect["length"] - 1]["width"])) / 2) &&
			oBrowserEvent["_iClientX"] <= (oRect["left"] + oRect["width"])) {
			iLeft = oRect["left"] + oRect["width"];
			this["sDropIndex"] = "end";
		} else {
			for (var j = 0; j < aChildLayerElementsRect["length"]; j++) {
				if (oBrowserEvent["_iClientX"] <= (aChildLayerElementsRect[j]["left"] + (aChildLayerElementsRect[j]["width"] / 2))) {
					iLeft = aChildLayerElementsRect[j]["left"];
					this["sDropIndex"] = j + 1 + "-before";
					break;
				} else if (j < (aChildLayerElementsRect["length"] - 1)) {
					if (oBrowserEvent["_iClientX"] <= ((aChildLayerElementsRect[j]["left"] + aChildLayerElementsRect[j]["width"]) + ((aChildLayerElementsRect[j + 1]["left"] -
						(aChildLayerElementsRect[j]["left"] + aChildLayerElementsRect[j]["width"])) / 2))) {
						iLeft = aChildLayerElementsRect[j]["left"] + aChildLayerElementsRect[j]["width"];
						this["sDropIndex"] = j + 1 + "-after";
						break;
					}
				}
			}
		}

		iTop = oRect["top"];
		iLength = oRect["height"];

		if (this["sDropIndex"]) {
			this["oVerticalDropDecorator"]["setBounds"](iLeft, iTop, iLength);
			this["oVerticalDropDecorator"]["show"]();
			oDropDecorator = this["oVerticalDropDecorator"];
		}
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD dragover: else... " + this["oDropTargetControl"]["sId"], "DTElementDropDelegate.js(309): onlsdragover"); };

		oRect = UCF_DomUtil["oGetObjectRect"](this["oDropTargetControl"]["oDomRef"]);
		if (this["ePosition"] === UCF_DTElementDropDelegate["POSITION"]["TOP"]) {

			// Personas-WDA: Visualize multi-selection with multiple drop targets - based on the upper-left corner of each dragged element!
			var bSingleSelectionDecorator = true;
			if (this["oDropTargetControl"]["oDTContainer"]["bIsPersonasEnabled"]()) {
				var aSelected = this["oDropTargetControl"]["oDTContainer"]["aListSelectedElements"]();
				if (aSelected["length"] > 1) {
					bSingleSelectionDecorator = false;
					var aOldMoves = this["oLS"]["oGetDragSession"]()["oGetCustomData"]();
					if (aOldMoves) {
						for (i = 0; i < aOldMoves["length"]; i++) {
							//if (console) console.log(">>> decorator HIDE: " + aOldMoves[i].targetElement.sId);
							aOldMoves[i]["targetElement"]["oDropDelegate"]["oDecorator"]["hide"]();
						}
					}
					var oDraggedElement = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](this["oLS"]["oGetDragSession"]()["oGetDragSource"](), true);
					var aMoves = this["oDropTargetControl"]["oDTContainer"]["calculateMoveTargets"](oBrowserEvent["iPageX"](), oBrowserEvent["iPageY"](), oDraggedElement, this["oDropTargetControl"]);
					this["oLS"]["oGetDragSession"]()["setCustomData"](aMoves);
					for (i = 0; i < aMoves["length"]; i++) {
						aMoves[i]["targetElement"]["createDropDelegate"](); // Make sure it exists
						aMoves[i]["targetElement"]["oDropDelegate"]["createDecorators"](oBrowserEvent); // Make sure it exists
						//if (console) console.log(">>> decorator SHOW: " + aMoves[i].targetElement.sId);
						aMoves[i]["targetElement"]["oDropDelegate"]["oDecorator"]["show"]();
					}
				}
			}
			if (bSingleSelectionDecorator) {
				// Normal drop target decorator based on mouse position
				this["oDecorator"]["show"]();
				oDropDecorator = this["oDecorator"];
			}

		} else if (this["ePosition"] === UCF_DTElementDropDelegate["POSITION"]["NORTH"]
			||
			this["ePosition"] === UCF_DTElementDropDelegate["POSITION"]["SOUTH"]) {

			iLeft = oRect["left"];
			iTop = (this["ePosition"] === UCF_DTElementDropDelegate["POSITION"]["NORTH"]) ? oRect["top"] : oRect["top"] + oRect["height"];
			iLength = oRect["width"];

			this["oHorizontalDropDecorator"]["setBounds"](iLeft, iTop, iLength);
			this["oHorizontalDropDecorator"]["show"]();
			oDropDecorator = this["oHorizontalDropDecorator"];

		} else if (this["ePosition"] === UCF_DTElementDropDelegate["POSITION"]["WEST"]
			||
			this["ePosition"] === UCF_DTElementDropDelegate["POSITION"]["EAST"]) {

			iLeft = (this["ePosition"] === UCF_DTElementDropDelegate["POSITION"]["WEST"]) ? oRect["left"] : oRect["left"] + oRect["width"];
			iTop = oRect["top"];
			iLength = oRect["height"];

			this["oVerticalDropDecorator"]["setBounds"](iLeft, iTop, iLength);
			this["oVerticalDropDecorator"]["show"]();
			oDropDecorator = this["oVerticalDropDecorator"];
		}

		this["handleDragOverGridMode"](oBrowserEvent);
	}

	oDragAndDropManager["initDropArea"](
		UCF_DragSession["DROP_TYPE"]["STANDARD"],
		sDropTags,
		oDropDecorator
	);

	oBrowserEvent["cancelBubble"]();

	return oBrowserEvent["bHandled"] = true;
};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["onlsdragover"] = 0; };

/**
 * Handle RasterLayouts for Personas WDA (Note: this is NOT the "RasterMode" feature for ITS)
 * @param oBrowserEvent
 */
UCF_DTElementDropDelegate["prototype"]["handleDragOverGridMode"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["handleDragOverGridMode"]++; }; 

	var oDTC = oBrowserEvent["oGetSourceControl"]()["oDTContainer"];
	if (!(oDTC && oDTC["getClientControl"]() && oDTC["getClientControl"]()["bEnableRasterLayoutGridMode"] === true)) {
		return;
	}

	// Do not consider DTElements that are dragged or are children of dragged elements (which get hidden by DTContainer.hideSelectedControlsOnDragStart())
	if (oBrowserEvent["oGetSourceControl"]()["bIsHidden"] === true) return;

	var oTargetControl = oBrowserEvent["oGetSourceControl"]()["oGetConnectedControl"]();
	var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"];
	if (oTargetControl["sClassName"] !== "UCF_RasterLayout" || oBrowserEvent["oGetSourceControl"]() === this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oDragSession["oDragSource"], true)) {
		if (oDragSession["mCustomData"]["oCurrentTarget"]) {
			oBrowserEvent["oGetSourceControl"]()["oDTContainer"]["removeRasterLayoutGrid"](oDragSession["mCustomData"]["oCurrentTarget"]);
			oDragSession["mCustomData"]["oCurrentTarget"] = null;
			// if (oDragSession.mCustomData.oOriginalGhostOffset) {
			// 	oDragSession.oGetGhost().setOffset(
			// 		oDragSession.mCustomData.oOriginalGhostOffset.left,
			// 		oDragSession.mCustomData.oOriginalGhostOffset.top
			// 	);
			// }
			//oDragSession.oGetGhost().bRasterMode = false;
		}
		return;
	}
	if (oTargetControl && oTargetControl["sClassName"] === "UCF_RasterLayout") {

		if (oTargetControl === oDragSession["mCustomData"]["oCurrentTarget"]) return;

		// // Set raster-mode on ghost ("snap") with values of current RL
		// var oRLRect = UCF_DomUtil.oGetObjectRect(oTargetControl.oDomRef);
		// var oRasterSize = oTargetControl.oGetRasterSizePx();
		// if (oRasterSize) {
		//     oDragSession.oGetGhost().setRasterMode(oRLRect.left, oRLRect.top, oRasterSize.width, oRasterSize.height, true);
		// }
		// else {
		//     oDragSession.oGetGhost().setRasterMode(oRLRect.left, oRLRect.top, oTargetControl.fRasterWidth, oTargetControl.fRasterHeight, true);
		// }

		// Switch grid on/off on previous and current RL
		if (oDragSession["mCustomData"]["oCurrentTarget"]) {
			oBrowserEvent["oGetSourceControl"]()["oDTContainer"]["removeRasterLayoutGrid"](oDragSession["mCustomData"]["oCurrentTarget"]);
		}
		oBrowserEvent["oGetSourceControl"]()["oDTContainer"]["addRasterLayoutGrid"](oTargetControl, oDragSession["oGetGhost"]());

		// WDAPERSONAS-105: Move ghost from under the cursor => This feature is not longer considered helpful

		// Save the original values calculated by DragAndDropManager once so they can be restore when the user drags outside a Grid
		// if (oDragSession.mCustomData.oOriginalGhostOffset === undefined) {
		// 	oDragSession.mCustomData.oOriginalGhostOffset = {
		// 		left: oDragSession.oGetGhost().iGetOffsetLeft(),
		// 		top: oDragSession.oGetGhost().iGetOffsetTop()
		// 	};
		// }
		// On the Grid we need to move the ghost out of the way, so that our super-duper cell-hover-effect is visible under the mouse cursor
		// WDAPERSONAS-105: This feature is not longer considered helpful
		// var OFFSET = oBrowserEvent.oGetSourceControl().oDTContainer.GHOST_OFFSET;
		// oDragSession.oGetGhost().setOffset(OFFSET, OFFSET);

		oDragSession["mCustomData"]["oCurrentTarget"] = oTargetControl;
	} else {
		// if (oDragSession.mCustomData.oOriginalGhostOffset) {
		// 	oDragSession.oGetGhost().setOffset(
		// 		oDragSession.mCustomData.oOriginalGhostOffset.left,
		// 		oDragSession.mCustomData.oOriginalGhostOffset.top
		// 	);
		// }
	}

};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["handleDragOverGridMode"] = 0; };

UCF_DTElementDropDelegate["prototype"]["traceDragOver"] = function (sDropTags) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["traceDragOver"]++; }; 
	return "DnD dragover: target="
		+ this["oDropTargetControl"]["sId"]
		+ " tags="
		+ sDropTags
		+ " type="
		+ (this["oDropTargetControl"]["oGetConnectedControl"]() ? this["oDropTargetControl"]["oGetConnectedControl"]()["sClassName"] : "")
		+ " PersonasID="
		+ (function (c) {
			var oConnectedControl = c["oGetConnectedControl"]();
			if (oConnectedControl && oConnectedControl["getClientControl"]()) {
				var s = oConnectedControl["getClientControl"]()["getCustomDataKey"]("SID");
				return (s ? s : oConnectedControl["getClientControl"]()["getCustomDataKey"]("WDA_ID"));
			}
		})(this["oDropTargetControl"]);
};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["traceDragOver"] = 0; };

UCF_DTElementDropDelegate["prototype"]["createDecorators"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["createDecorators"]++; }; 
	if (!this["bDecoratorsCreated"]) {

		var oDomRef = this["oDropTargetControl"]["oDomRef"],
			oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];

		var sTop = null,
			bDotted = false;
		var oSettings = this["oDropTargetControl"]["oDTContainer"]["oCurrentDragSessionDecoratorSettings"];
		if (oSettings) {
			sTop = oSettings["sTopDecorator"];
			bDotted = oSettings["bLineDecoratorDotted"];
		}

		this["oHorizontalDropDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(this["oDropTargetControl"], true, bDotted);
		this["oHorizontalDropDecorator"]["oParentContainer"] = this["oLS"]["oGetRootRef"]();

		this["oVerticalDropDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(this["oDropTargetControl"], false, bDotted);
		this["oVerticalDropDecorator"]["oParentContainer"] = this["oLS"]["oGetRootRef"]();

		this["oDecorator"] = {

			"oDomRef": oDomRef,
			"bInitialized": false,

			"init": function () {
				if (this["bInitialized"])
					return;

				if (sTop === "box") {
					this["oDomRef"]["style"]["border"] = "2px solid black";
				} else {
					if (oBrowserEvent["oDragAndDropManager"]["oDragSession"]["mCustomData"]["oCurrentTarget"]) {
						// RasterLayout grid-mod
						this["oDomRef"]["style"]["backgroundColor"] = "transparent";
					} else {
						this["oDomRef"]["style"]["backgroundColor"] = "#1490E3";
						UCF_DomUtil["setOpacityStyle"](this["oDomRef"], 50);
					}
				}

				this["bInitialized"] = true;
			},

			"cleanUp": function () {
				if (!this["bInitialized"])
					return;

				if (sTop === "box") {
					this["oDomRef"]["style"]["border"] = "";
				} else {
					this["oDomRef"]["style"]["backgroundColor"] = "";
					UCF_DomUtil["removeOpacityStyle"](this["oDomRef"]);
				}

				this["bInitialized"] = false;
			},

			"update": function () { },
			"hide": function () { this["cleanUp"](); },
			"show": function () { this["init"](); },
			"bIsVisible": function () { return true; }
		};

		this["oDecorator"]["init"](oDragAndDropManager["oDragSession"]);
		this["oVerticalDropDecorator"]["init"](oDragAndDropManager["oDragSession"]);
		this["oHorizontalDropDecorator"]["init"](oDragAndDropManager["oDragSession"]);

		this["bDecoratorsCreated"] = true;
	}

};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["createDecorators"] = 0; };

UCF_DTElementDropDelegate["prototype"]["oRectWithInsets"] = function (oRect, iHorizontalInset, iVerticalInset) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["oRectWithInsets"]++; }; 

	return {
		"top": oRect["top"] + iVerticalInset,
		"left": oRect["left"] + iHorizontalInset,
		"width": oRect["width"] - 2 * iHorizontalInset,
		"height": oRect["height"] - 2 * iVerticalInset
	};

};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["oRectWithInsets"] = 0; };

UCF_DTElementDropDelegate["prototype"]["bRectContainsPoint"] = function (oRect, iX, iY) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["bRectContainsPoint"]++; }; 

	return iX >= oRect["left"] && iX <= oRect["left"] + oRect["width"] && iY >= oRect["top"] && iY <= oRect["top"] + oRect["height"];

};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["bRectContainsPoint"] = 0; };

UCF_DTElementDropDelegate["POSITION"] = {
	"TOP": "Top",
	"NORTH": "Above",
	"WEST": "Before",
	"EAST": "After",
	"SOUTH": "Below"
};

UCF_DTElementDropDelegate["prototype"]["sGetDropTags"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["sGetDropTags"]++; }; 
	var oDropTargetControl = this["oGetDropTargetControl"](oBrowserEvent);
	if (this["oLS"]["oGetDragSession"]()["bDTLayoutMode"] === true) {
		if (this["oLS"]["oGetDragSession"]()["oDTUseParentElementDelegate"]) {
			oDropTargetControl = this["oLS"]["oGetDragSession"]()["oDTUseParentElementDelegate"]["oGetDropTargetControl"](oBrowserEvent);
		}
	}

	//check the position of the mouse
	var oViewPort = UCF_DomUtil["oGetObjectRect"](oDropTargetControl["oDomRef"]),
		oInnerViewPort = this["oRectWithInsets"](oViewPort, oViewPort["width"] / 4.0, oViewPort["height"] / 4.0),
		ePosition = null;

	//find the real position
	if (oDropTargetControl["sDropTargetInfo" + UCF_DTElementDropDelegate["POSITION"]["TOP"]] && this["bRectContainsPoint"](oInnerViewPort, oBrowserEvent["iPageX"](), oBrowserEvent["iPageY"]())) {
		ePosition = UCF_DTElementDropDelegate["POSITION"]["TOP"];

	} else {
		var iNormalizedX = (oBrowserEvent["iPageX"]() - oViewPort["left"]) / oViewPort["width"],
			iNormalizedY = (oBrowserEvent["iPageY"]() - oViewPort["top"]) / oViewPort["height"];

		//top right
		if (iNormalizedX >= iNormalizedY) {

			//top left
			if (1 - iNormalizedX >= iNormalizedY) {
				ePosition = UCF_DTElementDropDelegate["POSITION"]["NORTH"];

			} else {
				ePosition = UCF_DTElementDropDelegate["POSITION"]["EAST"];
			}

		} else {
			//top left
			if (1 - iNormalizedY >= iNormalizedX) {
				ePosition = UCF_DTElementDropDelegate["POSITION"]["WEST"];

			} else {
				ePosition = UCF_DTElementDropDelegate["POSITION"]["SOUTH"];
			}
		}
	}

	//find intelligent position based on existence of droptargetinfo control
	//if there is only a top info -> position is assumed to be top for usability
	if (!oDropTargetControl["sDropTargetInfo" + UCF_DTElementDropDelegate["POSITION"]["NORTH"]]
		&&
		!oDropTargetControl["sDropTargetInfo" + UCF_DTElementDropDelegate["POSITION"]["WEST"]]
		&&
		!oDropTargetControl["sDropTargetInfo" + UCF_DTElementDropDelegate["POSITION"]["EAST"]]
		&&
		!oDropTargetControl["sDropTargetInfo" + UCF_DTElementDropDelegate["POSITION"]["SOUTH"]]) {

		ePosition = UCF_DTElementDropDelegate["POSITION"]["TOP"];
	}

	this["ePosition"] = ePosition;

	if (window["UCF_System"]["bIsRTL"]) {
		if (ePosition === UCF_DTElementDropDelegate["POSITION"]["WEST"])
			ePosition = UCF_DTElementDropDelegate["POSITION"]["EAST"];
		else if (ePosition === UCF_DTElementDropDelegate["POSITION"]["EAST"])
			ePosition = UCF_DTElementDropDelegate["POSITION"]["WEST"];
	}

	var sDropTargetInfoId = oDropTargetControl["sDropTargetInfo" + ePosition];
	if (!sDropTargetInfoId)
		return "";

	var oDropTargetInfoControl = oDropTargetControl["oGetControlById"](sDropTargetInfoId);
	if (!oDropTargetInfoControl)
		return "";

	var sDropTags = oDropTargetInfoControl["sGetTags"]();
	if (!sDropTags)
		return "";

	return sDropTags;

};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["sGetDropTags"] = 0; };

UCF_DTElementDropDelegate["prototype"]["onlsdragleave"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["onlsdragleave"]++; }; 

	this["oDropTargetControl"]["setDropZone"](false);
	this["oDropTargetControl"]["oDTContainer"]["hidePosition"]();

	var o = this;
	if (this["oLS"]["oGetDragSession"]()["bDTLayoutMode"]) {
		o = this["oLS"]["oGetDragSession"]()["oDTUseParentElementDelegate"];
	}

	if (o && o["bDecoratorsCreated"]) {
		o["oHorizontalDropDecorator"]["hide"]();
		o["oVerticalDropDecorator"]["hide"]();
		o["oDecorator"]["hide"]();
	}
	this["oDropTargetControl"]["onmouseout"](oBrowserEvent);

	UCF_DropDelegate.prototype["onlsdragleave"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["onlsdragleave"] = 0; };

UCF_DTElementDropDelegate["prototype"]["onlsdrop"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["onlsdrop"]++; }; 
	var o = this;
	if (this["oLS"]["oGetDragSession"]()["bDTLayoutMode"]) {
		o = this["oLS"]["oGetDragSession"]()["oDTUseParentElementDelegate"];
	}

	if (o && o["bDecoratorsCreated"]) {
		o["oHorizontalDropDecorator"]["hide"]();
		o["oVerticalDropDecorator"]["hide"]();
		o["oDecorator"]["hide"]();
	}

	var oDragSession = this["oLS"]["oGetDragSession"]();
	if (oDragSession["mCustomData"]["oCurrentTarget"]) {
		var oDTC = this["oDropTargetControl"]["oDTContainer"];
		if (oDTC && oDTC["getClientControl"]() && oDTC["getClientControl"]()["bEnableRasterLayoutGridMode"] === true) {
			//oDragSession.mCustomData.oGridDropXY = oDTC.oGetMousePositionInCurrentGrid(oBrowserEvent);
			oDragSession["mCustomData"]["oGridDropXY"] = oDTC["oGetGhostPositionInCurrentGrid"](oBrowserEvent);
			oDragSession["mCustomData"]["oDragSourceSize"] = oDTC["oGetDragSourceSizeInCurrentGrid"]();
			// Do not remove the Grid because the dropped element remains selected
			//oDTC.removeRasterLayoutGrid();
		} else {
			oDragSession["mCustomData"]["oCurrentTarget"]["hideGrid"]();
		}
	}

	// Event maybe already processed by DTExtension that acts as a delegate
	if (oBrowserEvent["bHandled"]) return;

	UCF_DropDelegate.prototype["onlsdrop"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["onlsdrop"] = 0; };

UCF_DTElementDropDelegate["prototype"]["bIsDropPossible"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["bIsDropPossible"]++; }; 

	return UCF_DropDelegate.prototype["bIsDropPossible"]["call"](this, oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["bIsDropPossible"] = 0; };

UCF_DTElementDropDelegate["prototype"]["fGetDropCallBack"] = function (oDragSession) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["fGetDropCallBack"]++; }; 
	if (oDragSession["bDTLayoutMode"] === true) {
		oDragSession["bDTLayoutMode"] = false;
		return oDragSession["oDTUseParentElementDelegate"]["fGetDropCallBack"](oDragSession);
	}

	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo" + this["ePosition"]],
		oDTArea = this["oDropTargetControl"]["oDTContainer"],
		//oDropTargetControl = this.oDropTargetControl,
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDTElementId = this["oDropTargetControl"]["sId"],
		sPosition = this["ePosition"],
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"],
		oGridDropXY = oDragSession["mCustomData"]["oGridDropXY"],
		oDragSourceGridSize = oDragSession["mCustomData"]["oDragSourceSize"];

	if (window["UCF_System"]["bIsRTL"]) {
		if (sPosition === UCF_DTElementDropDelegate["POSITION"]["WEST"])
			sPosition = UCF_DTElementDropDelegate["POSITION"]["EAST"];
		else if (sPosition === UCF_DTElementDropDelegate["POSITION"]["EAST"])
			sPosition = UCF_DTElementDropDelegate["POSITION"]["WEST"];
	}
	return function (sDragData, sMimeType) {
		oDTArea["fireDrop"](
			oDTArea["sId"],
			sDragSourceId,
			sDTElementId,
			sPosition,
			sDropTargetInfoId,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			this["sDropIndex"],
			oGridDropXY ? oGridDropXY["row"] : -1,
			oGridDropXY ? oGridDropXY["column"] : -1,
			oDragSourceGridSize ? oDragSourceGridSize["height"] : -1,
			oDragSourceGridSize ? oDragSourceGridSize["width"] : -1,
			oDragSession["eGetDropEffect"]()
		);
	};
};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["fGetDropCallBack"] = 0; };

/**
 * Overwrite base-class implementation - change "default" return value if the drop-target has no DTI (Personas only!)
 */
UCF_DTElementDropDelegate["prototype"]["bGetEventBubbling"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["bGetEventBubbling"]++; }; 
	if (!this["oDropTargetControl"]) this["oDropTargetControl"] = this["oGetDropTargetControl"](oBrowserEvent);
	if (this["oDropTargetControl"]) {
		var bDefaultResult = this["oDropTargetControl"]["bIsPersonasEnabled"]() ? false : true;
		if (!this["oDropTargetInfoControl"]) {
			if (this["oGetDropTargetInfoId"](oBrowserEvent)) {
				this["oDropTargetInfoControl"] = this["oDropTargetControl"]["oGetControlById"](this["oGetDropTargetInfoId"](oBrowserEvent));
				if (this["oDropTargetInfoControl"]) return this["oDropTargetInfoControl"]["bGetEventBubbling"]();
				else return bDefaultResult;
			} else return bDefaultResult;
		} else return this["oDropTargetInfoControl"]["bGetEventBubbling"]();
	} else return true;
};;if (__UCF_COVERAGE__) { UCF_DTElementDropDelegate["_"]["bGetEventBubbling"] = 0; };

};
sap["ls"]["preload"]["UCF_DTElementRasterDragDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_DTElementRasterDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["UCF_DTElementRasterDragDelegate"]++; }; 
	UCF_DragDelegate["apply"](this, [oLS]);
	this["setDragSourceControl"](oDragSourceControl);
};window["UCF_DTElementRasterDragDelegate"] = UCF_DTElementRasterDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DTElementRasterDragDelegate"); UCF_DTElementRasterDragDelegate["_"] = {UCF_DTElementRasterDragDelegate: 0}; }; ;
UCF_DTElementRasterDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_DTElementRasterDragDelegate.prototype["sClassName"] = "UCF_DTElementRasterDragDelegate";

UCF_DTElementRasterDragDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["onlsdragstart"]++; }; 
	if (this["oDragSourceControl"]["bResizing"]) {
		return;
	};

	UCF_DragDelegate.prototype["onlsdragstart"]["apply"](this, arguments);
	// if (this.oDragSourceControl.oDTContainer.bIsMode(UCF_DTContainer.MODES.TABSEQUENCE)) {
	// 	oBrowserEvent.oDragAndDropManager.oDragSession.setCustomData({oTabChainPaint:this.oPaint,oTabChainElement:this.oDragSourceControl.getTabBeginRef(),oDragSourceControl:this.oDragSourceControl});
	// }
	this["oDragSourceControl"]["oDTContainer"]["hideSelectedControlsOnDragStart"](this["oDragSourceControl"], true);
	this["oDragSourceControl"]["startDrag"](oBrowserEvent["oDragAndDropManager"]);
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["onlsdragstart"] = 0; };

/**
 * Get a ghost for the referenced control or DOM element.
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {UCF_HTMLGhost}
 */
UCF_DTElementRasterDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["oGetGhost"]++; }; 
	// Notes:
	// DragGhostType "CONTENT" is hard-coded default in RasterMode
	// No offset for position (0, 0)
	// setRasterMode() will enable the "snapping" of the ghost to raster positions
	var oDiv = document["createElement"]("DIV");
	var oGhost, aControlIds;
	var aElements = this["oDragSourceControl"]["oDTContainer"]["aListSelectedElements"]();
	if (aElements["length"] > 1) {
		this["oDropInfo"] = [];

		// Content of all selected controls is combined in one ghost...
		// Determine relative position of all other controls to the one that is dragged with mouse cursor
		var iRefPosTop = this["oDragSourceControl"]["oGetAbsoluteRect"]()["top"];
		var iRefPosLeft = this["oDragSourceControl"]["oGetAbsoluteRect"]()["left"];

		for (var i = 0; i < aElements["length"]; i++) {
			var oSelectedElement = aElements[i];

			if (!oSelectedElement["sDragSourceInfo"]) continue;

			var iPosTop = oSelectedElement["oGetAbsoluteRect"]()["top"];
			var iPosLeft = oSelectedElement["oGetAbsoluteRect"]()["left"];

			aControlIds = oSelectedElement["sControlIds"]["split"](" ");
			var oChildDiv = document["createElement"]("DIV");
			var oClone = this["cloneControlDom"](aControlIds[0]);

			oChildDiv["appendChild"](oClone);

			oChildDiv["style"]["position"] = "absolute";
			oChildDiv["style"]["top"] = (iPosTop - iRefPosTop) + "px";
			oChildDiv["style"]["left"] = (iPosLeft - iRefPosLeft) + "px";
			oChildDiv["style"]["width"] = (oSelectedElement["oDomRef"]["clientWidth"] + 2) + "px";
			oChildDiv["style"]["height"] = oSelectedElement["oDomRef"]["clientHeight"] + "px";
			oChildDiv["style"]["display"] = "inline-block";
			oChildDiv["className"] = "lsDDGhostBoxShadow";

			oDiv["appendChild"](oChildDiv);

			// Set size > 0 so that the stuff is rendered...
			oDiv["style"]["width"] = "1px";
			oDiv["style"]["height"] = "1px";

			// Calculate relative positions in raster-units of the RL of the DragSource
			// for the MultiDropRelPositions parameter of the DropOnRaster event
			this["oDropInfo"]["push"]({
				"id": oSelectedElement["sId"],
				"leftRaster": Math["floor"]((iPosLeft - iRefPosLeft) / this["oDragSourceControl"]["oDTContainer"]["oRootRasterLayoutControl"]["fRasterWidth"]),
				"topRaster": Math["floor"]((iPosTop - iRefPosTop) / this["oDragSourceControl"]["oDTContainer"]["oRootRasterLayoutControl"]["fRasterHeight"]),
				"leftPx": iPosLeft - iRefPosLeft,
				"topPx": iPosTop - iRefPosTop
			});
		}
		oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv, true);

		// Note: There is no drag-session yet to store this data but... the ghost
		oGhost["sMultiDropRelPositionsJSON"] = UCF_JsUtil["sJsonStringify"](this["oDropInfo"]);
	} else {
		// Take the content of the first connected control as ghost (only one ID per element
		// is currently supported in RasterMode)
		aControlIds = this["oDragSourceControl"]["sControlIds"]["split"](" ");
		oDiv["appendChild"](this["cloneControlDom"](aControlIds[0]));
		oDiv["style"]["width"] = (this["oDragSourceControl"]["oDomRef"]["clientWidth"] + 2) + "px";
		oDiv["style"]["height"] = this["oDragSourceControl"]["oDomRef"]["clientHeight"] + "px";

		//		var o = UCF_DomUtil.$(aControlIds[0]);
		//		var sCurrentBG = UCF_DomUtil.sGetCurrentStyle(o, "backgroundColor") || UCF_DomUtil.sGetCurrentStyle(o, "backgroundImage");
		//		if (!sCurrentBG || sCurrentBG === "transparent") {
		//			oDiv.style.backgroundColor = UCF_DomUtil.oGetParentFor(UCF_DomUtil.$(aControlIds[0]), UCF_DomUtil.sGetCurrentStyle, [ "backgroundColor" ]);
		//		}

		oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv);
	}

	if (this["oDragSourceControl"]["oDTContainer"]["sRasterMode"] === "NESTED_RL_DROP_RELATIVE" && this["oDragSourceControl"]["oDTContainer"]["oDragSourceRasterLayoutControl"]) {
		// All positions of the ghost and drop event are relative to the RasterLayout of the drag source element/control
		this["oRLRect"] = UCF_DomUtil["oGetObjectRect"](this["oDragSourceControl"]["oDTContainer"]["oDragSourceRasterLayoutControl"]["oDomRef"]);
		var oRL = this["oDragSourceControl"]["oDTContainer"]["oRootRasterLayoutControl"];

		oGhost["setRasterMode"](this["oRLRect"]["left"], this["oRLRect"]["top"], oRL["fRasterWidth"], oRL["fRasterHeight"]);
	}
	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["oGetGhost"] = 0; };

UCF_DTElementRasterDragDelegate["prototype"]["cloneControlDom"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["cloneControlDom"]++; }; 
	var oCloneNode;
	if (this["oDragSourceControl"]["oDTExtension"]) {
		oCloneNode = this["oLS"]["oControlFactory"]["oGetControlById"](sId)["oGetDTExtension"]()["oGetDomRefForRect"](sId);
	}
	if (!oCloneNode) {
		oCloneNode = UCF_DomUtil["$"](sId + "-r");
		if (oCloneNode === null) {
			oCloneNode = UCF_DomUtil["$"](sId);
		}
	}
	var oClone = oCloneNode["cloneNode"](true);
	if (oClone["style"]["position"] === "absolute") {
		oClone["style"]["position"] = "static";
	}

	// The ghost should not react to mouse events, otherwise we may have "effects" on the cloned nodes like e.g. selection of text inside input fields.
	// If the ghost contains IFrames, the dragging would not work if the mouse pointer is over the IFrame inside the ghost.
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		if (UCF_UserAgent["bIsIE"](11) || UCF_UserAgent["bIsMSEdge"]()) {
			oClone["style"]["pointerEvents"] = "none";
		} else {
			// IE 9 and 10 does not support pointerEvents=none on normal DOM nodes
			// Replace certain tags with grey box
			var replaceAll = function(sTagName) {
				var oIFrames = oClone["getElementsByTagName"](sTagName);
				for (var i = 0; i < oIFrames["length"]; i++) {
					var o = oIFrames[i];
					var oReplacement = document["createElement"]("DIV");
					oReplacement["style"]["width"] = o["clientWidth"] + "px";
					oReplacement["style"]["height"] = o["clientHeight"] + "px";
					oReplacement["style"]["backgroundColor"] = "#888888";
					o["parentNode"]["replaceChild"](oReplacement, o);
				}
			};

			replaceAll("IFRAME");
			// Looks too ugly, and selection effects inside input fields are not a show-stopper.
			// In addition, this may be and additional performance-penalty on already slow IE browser versions...
			//replaceAll("INPUT");
			//replaceAll("TEXTAREA");
		}
	} else {
		oClone["style"]["pointerEvents"] = "none";
	}
	return oClone;
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["cloneControlDom"] = 0; };

UCF_DTElementRasterDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["bIsDragPossible"]++; }; 
	return this["oDragSourceControl"]["sSelectionState"] !== "UNSELECTABLE";
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["bIsDragPossible"] = 0; };

UCF_DTElementRasterDragDelegate["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["onlsdragend"]++; }; 
	if (!oBrowserEvent["bDropHandled"]) {
		// No drop: Drag was cancelled or drop on an illegal target
		this["oDragSourceControl"]["forwardDDCancel"]();
		this["oDragSourceControl"]["oDTContainer"]["endRasterDD"]();
	}
	this["oDragSourceControl"]["oDTContainer"]["showSelectedControlsOnDragEnd"](this["oDragSourceControl"]);
	this["oDragSourceControl"]["stopDrag"]();
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["onlsdragend"] = 0; };

/**
 * destructor
 */
UCF_DTElementRasterDragDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["destroy"]++; }; 
	this["oRLRect"] = null;
	UCF_DragDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDragDelegate["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_DTElementRasterDropDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DragSession */
/// <reference path="../base/DragSession.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_DTElementRasterDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["UCF_DTElementRasterDropDelegate"]++; }; 
	UCF_DropDelegate["apply"](this, [oLS]);
	this["setDropTargetControl"](oDropTargetControl);
	this["oLS"] = oLS;

	this["iCurrentStepY"] = 0;
	this["iCurrentStepX"] = 0;
};window["UCF_DTElementRasterDropDelegate"] = UCF_DTElementRasterDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DTElementRasterDropDelegate"); UCF_DTElementRasterDropDelegate["_"] = {UCF_DTElementRasterDropDelegate: 0}; }; ;
UCF_DTElementRasterDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_DTElementRasterDropDelegate.prototype["sClassName"] = "UCF_DTElementRasterDropDelegate";

UCF_DTElementRasterDropDelegate["prototype"]["oCreateDropDecorator"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["oCreateDropDecorator"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["oCreateDropDecorator"] = 0; };

UCF_DTElementRasterDropDelegate["prototype"]["onlsdragenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["onlsdragenter"]++; }; 
	UCF_DropDelegate.prototype["onlsdragenter"]["apply"](this, arguments);
	this["onDragEnterAndOver"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["onlsdragenter"] = 0; };

UCF_DTElementRasterDropDelegate["prototype"]["onlsdragover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["onlsdragover"]++; }; 
	this["onDragEnterAndOver"](oBrowserEvent);
	UCF_DropDelegate.prototype["onlsdragover"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["onlsdragover"] = 0; };

UCF_DTElementRasterDropDelegate["prototype"]["onDragEnterAndOver"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["onDragEnterAndOver"]++; }; 
	if (this["oDropTargetControl"]["oDTContainer"]["sRasterMode"] === "NESTED_RL_DROP_ON_ELEMENT") {
		// If this is a DT element of a RasterLayout, switch the grid display and switch the ghost to raster mode
		var oRL = oBrowserEvent["oGetSourceControl"]()["oGetConnectedControl"]();
		if (oRL) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD: oBrowserEvent.oGetSourceControl().sId=" + oBrowserEvent["oGetSourceControl"]()["sId"], "DTElementRasterDropDelegate.js(44): onDragEnterAndOver"); };
			var oDragSession = this["oLS"]["oGetDragSession"]();
			var sPosData = oDragSession["oGetGhost"]()["sMultiDropRelPositionsJSON"];
			if (sPosData) {
				oDragSession["sMultiDropRelPositionsJSON"] = sPosData;
			}
			if (oRL["sClassName"] !== "UCF_RasterLayout" || oBrowserEvent["oGetSourceControl"]() === this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oDragSession["oDragSource"], true)) {
				if (oDragSession["oCurrentRL"]) {
					oDragSession["oCurrentRL"]["hideGrid"]();
					oDragSession["oCurrentRL"] = null;
					oDragSession["setCursor"](UCF_DragSession["E_CURSOR"]["NOT_ALLOWED"]);
					//this.oDropTargetControl.hide();
				}
				return;
			}

			if (oRL === oDragSession["oCurrentRL"]) return;

			// Set raster-mode on ghost with values of current RL
			var oRLRect = UCF_DomUtil["oGetObjectRect"](oRL["oDomRef"]);
			oDragSession["oGetGhost"]()["setRasterMode"](oRLRect["left"], oRLRect["top"], oRL["fRasterWidth"], oRL["fRasterHeight"]);
			// Switch grid on/off on previous and current RL
			if (oDragSession["oCurrentRL"]) {
				oDragSession["oCurrentRL"]["hideGrid"]();
			}

			oRL["showGrid"]();
			oDragSession["oCurrentRL"] = oRL;
			oDragSession["setCursor"](UCF_DragSession["E_CURSOR"]["ALLOWED"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["onDragEnterAndOver"] = 0; };

/**
 * handle dragscroll event
 */
UCF_DTElementRasterDropDelegate["prototype"]["onlsdragscroll"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["onlsdragscroll"]++; }; 
	var oDraggedElement = this["oLS"]["oGetControlByDomRef"](this["oLS"]["oGetDragSession"]()["oGetDragSource"]());
	if (oDraggedElement["oMyParentScrollElement"]) {
		this["doDragScroll"](oDraggedElement["oMyParentScrollElement"], oBrowserEvent["iPageX"](), oBrowserEvent["iPageY"]());
	}
	UCF_DropDelegate.prototype["onlsdragscroll"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["onlsdragscroll"] = 0; };

/**
 * Implement our own drag-scrolling in advanced SC mode.
 * Basicly the same algo. as in ScrollArea.onlsdragscroll()
 * @private
 */
UCF_DTElementRasterDropDelegate["prototype"]["doDragScroll"] = function(oScrollElement, iMouseX, iMouseY) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["doDragScroll"]++; }; 
	//_trace(INFO, ">>> mx=" + iMouseX + ", my="+ iMouseY);

	var oViewPort = UCF_DomUtil["oGetObjectRect"](oScrollElement["oDomRef"]);
	//_trace(INFO, ">>> vleft=" + oViewPort.left + ", vtop="+ oViewPort.top + ", vheight=" + oViewPort.height);

	var iVerticalZone = Math["min"](35, oViewPort["height"] / 4);
	var iHorizontalZone = Math["min"](35, oViewPort["width"] / 4);

	var iScrollThresholdTop = oViewPort["top"] + iVerticalZone;
	var iScrollThresholdBottom = oViewPort["top"] + oViewPort["height"] - iVerticalZone;

	var iScrollThresholdLeft = oViewPort["left"] + iHorizontalZone;
	var iScrollThresholdRight = oViewPort["left"] + oViewPort["width"] - iHorizontalZone;

	var iStepY = 0,
		iStepX = 0;

	if (iMouseX < iScrollThresholdLeft) {
		iStepX = -Math["round"]((iScrollThresholdLeft - iMouseX) / iHorizontalZone * 10);
	} else if (iMouseX > iScrollThresholdRight) {
		iStepX = Math["round"]((iMouseX - iScrollThresholdRight) / iHorizontalZone * 10);
	}

	if (iMouseY < iScrollThresholdTop) {
		iStepY = -Math["round"]((iScrollThresholdTop - iMouseY) / iVerticalZone * 10);
	} else if (iMouseY > iScrollThresholdBottom) {
		iStepY = Math["round"]((iMouseY - iScrollThresholdBottom) / iVerticalZone * 10);
	}

	if (this["iCurrentStepX"] < iStepX) {
		this["iCurrentStepX"]++;
	} else if (this["iCurrentStepX"] > iStepX) {
		this["iCurrentStepX"]--;
	}

	if (this["iCurrentStepY"] < iStepY) {
		this["iCurrentStepY"]++;
	} else if (this["iCurrentStepY"] > iStepY) {
		this["iCurrentStepY"]--;
	}

	oScrollElement["scrollDelta"](this["iCurrentStepY"], this["iCurrentStepX"]);
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["doDragScroll"] = 0; };

UCF_DTElementRasterDropDelegate["prototype"]["onlsdrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["onlsdrop"]++; }; 
	// Event maybe already processed by DTExtension that acts as a delegate => already destroyed by re-rendering
	if (oBrowserEvent["bHandled"] || this["oDropTargetControl"] === null) return;

	this["oDropTargetControl"]["oDTContainer"]["endRasterDD"]();
	UCF_DropDelegate.prototype["onlsdrop"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["onlsdrop"] = 0; };

UCF_DTElementRasterDropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfoTop"],
		oDTArea = this["oDropTargetControl"]["oDTContainer"],
		//oDropTargetControl = this.oDropTargetControl,
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDTElementId = "",
		sDragSourceRasterLayoutId = "",
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		//oDropPosition = oDragSession.oGetDropPosition(),
		iRasterX = oDragSession["oGetGhost"]()["iGetCurrentRasterX"](),
		iRasterY = oDragSession["oGetGhost"]()["iGetCurrentRasterY"]();

	if (this["oDropTargetControl"] &&
		this["oDropTargetControl"]["oGetConnectedControl"] &&
		this["oDropTargetControl"]["oGetConnectedControl"]() &&
		this["oDropTargetControl"]["oGetConnectedControl"]()["sClassName"] !== "UCF_RasterLayout") {
		return function() {};
	}
	if (this["oDropTargetControl"]["oDTContainer"]["sRasterMode"] === "NESTED_RL_DROP_ON_ELEMENT") {
		sDTElementId = this["oDropTargetControl"]["sId"];
	} else { // NESTED_RL_DROP_RELATIVE
		// Note: DragSourceRasterLayoutControl is calculated in DTContainer.initRasterDD()
		//sDragSourceRasterLayoutId = oDragSession.oDragSourceRasterLayoutControl.sId;
		if (this["oDropTargetControl"]["oDTContainer"]["oDragSourceRasterLayoutControl"]) {
			sDragSourceRasterLayoutId = this["oDropTargetControl"]["oDTContainer"]["oDragSourceRasterLayoutControl"]["sGetId"]();
		} else {
			sDragSourceRasterLayoutId = "";
		}
	}
	var sMultiDropRelPositionsJSON = oDragSession["sMultiDropRelPositionsJSON"];
	if (sMultiDropRelPositionsJSON === undefined || sMultiDropRelPositionsJSON === null) sMultiDropRelPositionsJSON = "";

	return function(sDragData, sMimeType) {

		/*
		 meter name="Id" type="string" docu="Identifier of this control" />
			<parameter name="DragSource" type="string" docu="Identifier of the DT element which was dragged" />
			<parameter name="DragTargetDTElement" type="string" docu="Identifier of raster layout DT element - DTRasterMode.NESTED_RL_DROP_ON_ELEMENT" />
			<parameter name="DragSourceRasterLayout" type="string" docu="Identifier of raster layout which the dragged DT element belongs to - DTRasterMode.NESTED_RL_DROP_RELATIVE" />
			<parameter name="DropTargetInfo" type="string" docu="Identifier of the dropinfo control which is associated to this control" />
			<parameter name="Data" type="string" docu="arbitrary data which has been provided by the drag event from web dynpro" />
			<parameter name="MimeType" type="string" docu="Mime type of the data provided by the drag event from web dynpro" />
			<parameter name="DragSourceTags" type="string" docu="A space-seperated list of the tags of the drag source" />
			<parameter name="MouseButton" type="int" docu="(1:left,2:right)" />
	  		<parameter name="RasterPosX" type="int" docu="The horizontal raster position" />
	  		<parameter name="RasterPosY" type="int" docu="The vertical raster position" />
		*/
		oDTArea["fireDropOnRaster"](
			oDTArea["sId"],
			sDragSourceId,
			sDTElementId,
			sDragSourceRasterLayoutId,
			sDropTargetInfoId,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iRasterX,
			iRasterY,
			sMultiDropRelPositionsJSON
		);
	};
};;if (__UCF_COVERAGE__) { UCF_DTElementRasterDropDelegate["_"]["fGetDropCallBack"] = 0; };

};
sap["ls"]["preload"]["UCF_DTExtension"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_EventProvider */
/// <reference path="../../../core/EventProvider.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>

/**
 * Base class for generic designtime information.
 *
 * 
 *
 * @class
 * @param {UCF_LS} oLS The LS instance
 * @param {UCF_Control} oControl The control reference
 * @param {UCF_DTElement} oDTElement The DTElement reference
 */
function UCF_DTExtension(oLS, oControl, oDTElement) {if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["UCF_DTExtension"]++; }; 
	if (arguments["length"] === 0) return;
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oControl instanceof UCF_Control, "oControl instanceof UCF_Control", "DTExtension.js(22): UCF_DTExtension"); };

	this["oControl"] = oControl;
	this["oLS"] = oLS;
	this["oDTElement"] = oDTElement;
	this["aRulers"] = null;
	this["bDelegate"] = false;
	this["mUIEventHandler"] = null;
	this["mDTElementEventHandler"] = null;
	this["bDestroyed"] = false;
};window["UCF_DTExtension"] = UCF_DTExtension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DTExtension"); UCF_DTExtension["_"] = {UCF_DTExtension: 0}; }; ;
UCF_DTExtension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_DTExtension.prototype["sClassName"] = "UCF_DTExtension";

/**
 * Tells the LS framework that this extension is also a delegate (UCF_Control.oGetDTExtension)
 * @return {boolean} Whether the extension is a delegate or not
 */
UCF_DTExtension["prototype"]["bIsDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["bIsDelegate"]++; }; 
	return this["bDelegate"];
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["bIsDelegate"] = 0; };

/**
 * Checks if the control (or part of the control identified by sElementId) is currently visible. The default implementation calls <code>this.oControl.bIsVisible()</code>
 * regardless of the sElementId.
 * @param {string} sElementId The ID that was provided to the design-time: This may be the control-ID or the ID of a sub-control or sub-element (item, cell, line, etc.).
 * @return {boolean} Whether the control (or part of the control identified by sElementId) is visible or not.
 */
UCF_DTExtension["prototype"]["bIsVisible"] = function(sElementId) {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["bIsVisible"]++; }; 
	var bResult = this["oControl"]["bIsVisible"]();
	if (bResult === false && this["oControl"]["bGetInvisibility"]() && !this["oControl"]["bIsAncestorInvisible"]()) {
		// For the designtime it is still visible because it must display a minimal rectangle to select the "invisible"
		bResult = true;
	}
	return bResult;
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["bIsVisible"] = 0; };

/**
 * Provide the DOM element that shall be used to calculate the position and size of the control or part of the control.
 * @param {string} sElementId The ID that was provided to the design-time: This may be the control-ID or the ID of a sub-control or sub-element (item, cell, line, etc.).
 * @param {boolean} bIsScrollElement A second element for the same control that handles a nested ScrollArea
 * @return {HTMLElement|null} The DOM reference
 */
UCF_DTExtension["prototype"]["oGetDomRefForRect"] = function(sElementId, bIsScrollElement) {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetDomRefForRect"]++; }; 
	if (!sElementId && this["oControl"]["oGetParent"]() && UCF_JsUtil["bInstanceOf"](this["oControl"]["oGetParent"](), "UCF_RasterLayoutItem")) {
		return this["oControl"]["oGetParent"]()["oRootRef"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetDomRefForRect"] = 0; };

/**
 * Provide a element that is used to calculate the "parent position reference container".
 * @returns {HTMLElement|null} DOM element or null
 */
UCF_DTExtension["prototype"]["oGetDomRefForParentPosRefContainer"] = function() {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetDomRefForParentPosRefContainer"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetDomRefForParentPosRefContainer"] = 0; };

/**
 * Returns a DOM reference for the scrollable part of the control or null.
 * @returns {HTMLElement|null} DOM element or null
 */
UCF_DTExtension["prototype"]["oGetScrollAreaDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetScrollAreaDomRef"]++; }; 
	//if (!window.UCF_ScollArea) return null;
	if (this["oControl"]["oScrollArea"] && this["oControl"]["oScrollArea"]["oDomRef"]) {
		return this["oControl"]["oScrollArea"]["oDomRef"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetScrollAreaDomRef"] = 0; };

/**
 * If a control is not using a ScrollArea (or at least overflow-element with scrollTop/Left) at all - e.g. SapTable, provide the element
 * that can be used to calculate the dimensions.
 * oGetScrollAreaDomRef() must return null in this case.
 * @returns {HTMLElement|null} DOM element or null
 */
UCF_DTExtension["prototype"]["oGetSpecialScrollAreaDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetSpecialScrollAreaDomRef"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetSpecialScrollAreaDomRef"] = 0; };

/**
 * Returns the scroll-width and -height of the special scroll area.
 * @returns {object} width, height
 */
UCF_DTExtension["prototype"]["oGetSpecialScrollAreaScrollWH"] = function() {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetSpecialScrollAreaScrollWH"]++; }; 
	return { "width": 0, "height": 0 };
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetSpecialScrollAreaScrollWH"] = 0; };

/**
 * If a control is not using a ScrollArea (or at least overflow-element with scrollTop/Left) at all - e.g. SapTable, provide a function to get
 * the current scroll position (needed for SapTable which can have a initial position).
 * @returns {object} top, left
 */
UCF_DTExtension["prototype"]["getScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["getScrollPosition"]++; }; 
	return { "left": 0, "top": 0 };
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["getScrollPosition"] = 0; };

/**
 * If a control is not using a ScrollArea (or at least overflow-element with scrollTop/Left) at all - e.g. SapTable, provide coding that
 * does the scrolling. The control should NOT send semantic Scroll-events!
 * @param {number} iLeft Left position
 * @param {number} iTop Top position
 */
UCF_DTExtension["prototype"]["forwardScrollPosition"] = function(iLeft, iTop) {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["forwardScrollPosition"]++; }; };;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["forwardScrollPosition"] = 0; };

/**
 * Default implementation: UCF_Control.oGetParentScrollAreaControl()
 * The extension may overwrite this for its own sub-controls, if it is not using a ScrollArea (or at least overflow-element with scrollTop/Left) at all - e.g. SapTable.
 * Note: If the extension code does not compute a return value, you MUST return _super() !
 * @param {string} sId The Id
 * @return {UCF_Control} A control instance
 */
UCF_DTExtension["prototype"]["oGetParentScrollAreaControl"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetParentScrollAreaControl"]++; }; 
	return this["oControl"]["oGetParentScrollAreaControl"]();
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oGetParentScrollAreaControl"] = 0; };

/**
 * Optionally modify the rectangle for this control after the design-time has calculated it.
 * @param {object} oRect The rectangle calculated by the designtime (top,left,width,height).
 * @param {string} sElementId The ID that was provided to the designtime: This may be the control-ID or the ID of a sub-control or sub-element (item, cell, line, etc.).
 * @param {boolean} bIsScrollElement A second element for the same control that handles a nested ScrollArea
 * @returns {object} A rectangle object (top,left,width,height)
 */
UCF_DTExtension["prototype"]["oPostprocessRect"] = function(oRect, sElementId, bIsScrollElement) {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oPostprocessRect"]++; }; 
	return oRect;
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["oPostprocessRect"] = 0; };

/**
 * Tell designtime the desired behaviour regarding drag-start
 * @returns {boolean} true: Hide control on drag-start
 */
UCF_DTExtension["prototype"]["hideControlOnDragStart"] = function() {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["hideControlOnDragStart"]++; }; 
	return this["oControl"]["oGetParent"]() && this["oControl"]["oGetParent"]()["sClassName"] === "UCF_Toolbar";
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["hideControlOnDragStart"] = 0; };

/**
 * Tell the designtime the desired behaviour regarding drag-over
 * @returns {boolean} true: Hide control when drop is not allowed
 */
UCF_DTExtension["prototype"]["bHideWhenDropNotAllowed"] = function() {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["bHideWhenDropNotAllowed"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["bHideWhenDropNotAllowed"] = 0; };

UCF_DTExtension["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["destroy"]++; }; 
	this["bDestroyed"] = true;
	this["oControl"] = null;
	this["oLS"] = null;
	this["oDTElement"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTExtension["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_DTTabSequenceDelegate"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_EventProvider */
/// <reference path="../../../core/EventProvider.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_Canvas */
/// <reference path="../Canvas.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDTElement
 */
function UCF_DTTabSequenceDelegate(oLS, oDTElement) {if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["UCF_DTTabSequenceDelegate"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DTTabSequenceDelegate.js(21): UCF_DTTabSequenceDelegate"); };
	if (arguments["length"] === 0) return;
	UCF_EventProvider["apply"](this);
	this["oLS"] = oLS;
	this["oDTElement"] = oDTElement;
	this["oDTContainer"] = oDTElement["oDTContainer"];
	this["oCanvas"] = null;

};window["UCF_DTTabSequenceDelegate"] = UCF_DTTabSequenceDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DTTabSequenceDelegate"); UCF_DTTabSequenceDelegate["_"] = {UCF_DTTabSequenceDelegate: 0}; }; ;
UCF_DTTabSequenceDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_DTTabSequenceDelegate.prototype["sClassName"] = "UCF_DTTabSequenceDelegate";

UCF_DTTabSequenceDelegate["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["initialize"]++; }; 
	this["oDTElement"]["attachEvent"](this["oDTElement"]["E_EVENTS"]["Select"], this, "handleSelect");
	this["oDTElement"]["attachEvent"](this["oDTElement"]["E_EVENTS"]["Deselect"], this, "handleDeselect");
	this["update"]();
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["initialize"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["update"] = function() {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["update"]++; }; 
	var oNextElement = this["oDTContainer"]["getNextFocusableDTElement"](this["oDTElement"]),
		oPreviousElement = this["oDTContainer"]["getPreviousFocusableDTElement"](this["oDTElement"]);
	if (this["oDTElement"]["bIsSelected"]()) {
		this["handleSelect"]();
	}
	this["oPreviousElement"] = oPreviousElement;
	this["oNextElement"] = oNextElement;
	this["updateConnectionPoints"]();
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["update"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["handleParentScrolled"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["handleParentScrolled"]++; }; 
	if (this["oDTElement"]["bIsSelected"]()) {
		this["showArrow"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["handleParentScrolled"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["updateConnectionPoints"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["updateConnectionPoints"]++; }; 
	UCF_DomUtil["removeClass"](UCF_DomUtil["$"](this["oDTElement"]["sId"] + "-tabsequenceNext"), "target");
	UCF_DomUtil["removeClass"](UCF_DomUtil["$"](this["oDTElement"]["sId"] + "-tabsequencePrevious"), "target");
	if (this["oNextElement"]) {
		UCF_DomUtil["addClass"](UCF_DomUtil["$"](this["oDTElement"]["sId"] + "-tabsequenceNext"), "target");
	}
	if (this["oPreviousElement"]) {
		UCF_DomUtil["addClass"](UCF_DomUtil["$"](this["oDTElement"]["sId"] + "-tabsequencePrevious"), "target");
	}
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["updateConnectionPoints"] = 0; };
UCF_DTTabSequenceDelegate["prototype"]["handleSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["handleSelect"]++; }; 
	var oNextElement = this["oDTContainer"]["getNextFocusableDTElement"](this["oDTElement"]),
		oPreviousElement = this["oDTContainer"]["getPreviousFocusableDTElement"](this["oDTElement"]);
	if (this["oDTElement"]["oMyParentScrollElement"]) {
		this["oDTElement"]["oMyParentScrollElement"]["attachEvent"](this["oDTElement"]["oMyParentScrollElement"]["E_EVENTS"]["Scroll"], this, "handleParentScrolled");
	}
	if (oNextElement) {
		if (
			this["oNextElement"] &&
			oNextElement !== this["oNextElement"] &&
			this["oNextElement"]["oMyParentScrollElement"] &&
			this["oDTElement"]["oMyParentScrollElement"] !== this["oNextElement"]["oMyParentScrollElement"] &&
			this["oNextElement"]["oMyParentScrollElement"]["E_EVENTS"]
		) {
			this["oNextElement"]["oMyParentScrollElement"]["detachEvent"](
				this["oNextElement"]["oMyParentScrollElement"]["E_EVENTS"]["Scroll"],
				this,
				'handleParentScrolled'
			);
		}
		if (oNextElement["oMyParentScrollElement"] && oNextElement["oMyParentScrollElement"] !== this["oDTElement"]["oMyParentScrollElement"]) {
			oNextElement["oMyParentScrollElement"]["attachEvent"](oNextElement["oMyParentScrollElement"]["E_EVENTS"]["Scroll"], this, "handleParentScrolled");
		}
	}
	if (oPreviousElement) {
		if (
			this["oPreviousElement"] &&
			oPreviousElement !== this["oPreviousElement"] &&
			this["oPreviousElement"]["oMyParentScrollElement"] &&
			this["oPreviousElement"]["oMyParentScrollElement"]["E_EVENTS"]
		) {
			this["oPreviousElement"]["oMyParentScrollElement"]["detachEvent"](
				this["oPreviousElement"]["oMyParentScrollElement"]["E_EVENTS"]["Scroll"],
				this,
				'handleParentScrolled'
			);
		}
		if (oPreviousElement["oMyParentScrollElement"] && oPreviousElement["oMyParentScrollElement"] !== this["oDTElement"]["oMyParentScrollElement"]) {
			oPreviousElement["oMyParentScrollElement"]["attachEvent"](oPreviousElement["oMyParentScrollElement"]["E_EVENTS"]["Scroll"], this, "handleParentScrolled");
		}
	}
	this["showArrow"]();
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["handleSelect"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["handleDeselect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["handleDeselect"]++; }; 
	this["hideArrow"]();
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["handleDeselect"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["onkeydown"]++; }; 
	var iKeyCode = oBrowserEvent["iKeyCode"](),
		oDTElement;
	if (iKeyCode === UCF_KeyCodes["TAB"] && !oBrowserEvent["bShift"]()) {
		oDTElement = this["oDTElement"]["oDTContainer"]["getNextFocusableDTElement"](this["oDTElement"]);
		if (oDTElement) {
			this["oDTElement"]["oDTContainer"]["handleElementMouseDown"](oDTElement, false);
		}
	}
	if (iKeyCode === UCF_KeyCodes["TAB"] && oBrowserEvent["bShift"]()) {
		oDTElement = this["oDTElement"]["oDTContainer"]["getPreviousFocusableDTElement"](this["oDTElement"]);
		if (oDTElement) {
			this["oDTElement"]["oDTContainer"]["handleElementMouseDown"](oDTElement, false);
		}
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	return;
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["onkeydown"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["onmousedown"]++; }; 
	this["oDTElement"]["displayResizeHandles"](false);
	if (this["oDTElement"]["bFocusableControlConnected"]()) {
		this["oDTElement"]["oDTContainer"]["handleElementMouseDown"](this["oDTElement"], oBrowserEvent["bCtrl"]());
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	return;
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["onmousedown"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["ondblclick"]++; }; 
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	return;
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["ondblclick"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["onmouseover"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["onmouseover"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["onlsdragstart"]++; }; 
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	return;
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["onlsdragstart"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["getCanvas"] = function() {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["getCanvas"]++; }; 
	if (!this["oCanvas"]) {
		this["oCanvas"] = new (UCF_ClassLoader["oGetClass"]("UCF_Canvas"))(this["oLS"], this["oLS"]["oGetWindow"]()["document"]["body"]);
	}
	this["oCanvas"]["clear"]();
	return this["oCanvas"];
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["getCanvas"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["hideArrow"] = function() {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["hideArrow"]++; }; 
	this["getCanvas"]()["hide"]();
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["hideArrow"] = 0; };
UCF_DTTabSequenceDelegate["prototype"]["showArrow"] = function() {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["showArrow"]++; }; 
	var oCanvas = this["getCanvas"](),
		oNextElement = this["oNextElement"],
		oPreviousElement = this["oPreviousElement"];

	var oStartRect, oStart, oEndRect, oEnd;
	oCanvas["removeAllObjects"]();

	var iZIndex = this["oDTElement"]["iGetDOMZIndex"]() - 1;
	var oOffsetParent = this["oDTElement"]["oMyParentScrollElement"];
	var oOffsetRect = { "top": 0, "left": 0 };
	if (oOffsetParent) {
		oOffsetRect["top"] = oOffsetParent["oDomRef"]["scrollTop"];
		oOffsetRect["left"] = oOffsetParent["oDomRef"]["scrollLeft"];
	}
	if (oNextElement) {
		var oNextOffsetParent = oNextElement["oMyParentScrollElement"];
		var oNextOffsetRect = { "top": 0, "left": 0 };
		if (oNextOffsetParent) {
			oNextOffsetRect["top"] = oNextOffsetParent["oDomRef"]["scrollTop"];
			oNextOffsetRect["left"] = oNextOffsetParent["oDomRef"]["scrollLeft"];
		}
		oStartRect = this["oDTElement"]["oGetAbsoluteRect"]();
		oStart = {
			"x": oStartRect["left"] + oStartRect["width"] - oOffsetRect["left"],
			"y": oStartRect["top"] + Math["floor"](oStartRect["height"] / 2) - oOffsetRect["top"],
			"spaceX": 0,
			"spaceY": Math["floor"](oStartRect["height"] / 2)

		};
		oEndRect = oNextElement["oGetAbsoluteRect"]();
		oEnd = {
			"x": oEndRect["left"] + Math["floor"](oEndRect["width"] / 2) - oNextOffsetRect["left"],
			"y": oEndRect["top"] - oNextOffsetRect["top"],
			"spaceX": Math["floor"](oEndRect["width"] / 2),
			"spaceY": 0
		};
		oCanvas["addBezierConnector"](oStart, oEnd, 3, "#007CC0");
		iZIndex = Math["min"](iZIndex, oNextElement["iGetDOMZIndex"]() - 1);
	}
	if (oPreviousElement) {
		var oPreviousOffsetParent = oPreviousElement["oMyParentScrollElement"];
		var oPreviousOffsetRect = { "top": 0, "left": 0 };
		if (oPreviousOffsetParent) {
			oPreviousOffsetRect["top"] = oPreviousOffsetParent["oDomRef"]["scrollTop"];
			oPreviousOffsetRect["left"] = oPreviousOffsetParent["oDomRef"]["scrollLeft"];
		}
		oStartRect = oPreviousElement["oGetAbsoluteRect"]();
		oStart = {
			"x": oStartRect["left"] + oStartRect["width"] - oPreviousOffsetRect["left"],
			"y": oStartRect["top"] + Math["floor"](oStartRect["height"] / 2) - oPreviousOffsetRect["top"],
			"spaceX": 0,
			"spaceY": Math["floor"](oStartRect["height"] / 2)
		};
		oEndRect = this["oDTElement"]["oGetAbsoluteRect"]();
		oEnd = {
			"x": oEndRect["left"] + Math["floor"](oEndRect["width"] / 2) - oOffsetRect["left"],
			"y": oEndRect["top"] - oOffsetRect["top"],
			"spaceX": Math["floor"](oEndRect["width"] / 2),
			"spaceY": 0
		};
		iZIndex = Math["min"](iZIndex, oPreviousElement["iGetDOMZIndex"]() - 1);
		oCanvas["addBezierConnector"](oStart, oEnd, 3, "#007CC0");
	}

	oCanvas["setZIndex"](iZIndex);
	oCanvas["setPosition"]({ "top": 0, "left": 0, "width": 100, "height": 100 });
	this["getCanvas"]()["show"]();
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["showArrow"] = 0; };

UCF_DTTabSequenceDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["destroy"]++; }; 
	this["oDTElement"]["detachEvent"](this["oDTElement"]["E_EVENTS"]["Select"], this, "handleSelect");
	this["oDTElement"]["detachEvent"](this["oDTElement"]["E_EVENTS"]["Deselect"], this, "handleDeselect");
	if (
		this["oDTElement"]["oMyParentScrollElement"] &&
		this["oDTElement"]["oMyParentScrollElement"]["E_EVENTS"]
	) {
		this["oDTElement"]["oMyParentScrollElement"]["detachEvent"](
			this["oDTElement"]["oMyParentScrollElement"]["E_EVENTS"]["Scroll"],
			this,
			'handleParentScrolled'
		);
	}
	UCF_DomUtil["removeClass"](UCF_DomUtil["$"](this["oDTElement"]["sId"] + "-tabsequenceNext"), "target");
	UCF_DomUtil["removeClass"](UCF_DomUtil["$"](this["oDTElement"]["sId"] + "-tabsequencePrevious"), "target");

	if (
		this["oNextElement"] &&
		this["oNextElement"]["oMyParentScrollElement"] &&
		this["oNextElement"]["oMyParentScrollElement"]["E_EVENTS"]
	) {
		this["oNextElement"]["oMyParentScrollElement"]["detachEvent"](
			this["oNextElement"]["oMyParentScrollElement"]["E_EVENTS"]["Scroll"],
			this,
			'handleParentScrolled'
		);
	}
	if (
		this["oPreviousElement"] &&
		this["oPreviousElement"]["oMyParentScrollElement"] &&
		this["oPreviousElement"]["oMyParentScrollElement"]["E_EVENTS"]
	) {
		this["oPreviousElement"]["oMyParentScrollElement"]["detachEvent"](
			this["oPreviousElement"]["oMyParentScrollElement"]["E_EVENTS"]["Scroll"],
			this,
			'handleParentScrolled'
		);
	}

	if (this["oCanvas"]) {
		this["oCanvas"]["destroy"]();
	}
	this["oLS"] = null;
	this["oDTElement"] = null;
	this["oDTContainer"] = null;
	this["oCanvas"] = null;
	this["oPreviousElement"] = null;
	this["oNextElement"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DTTabSequenceDelegate["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_DataGrid"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>
/* global UCF_DataGridColumnDropDelegate */
/// <reference path="./delegates/DataGridColumnDropDelegate.js"/>
/* global UCF_DataGridRowDropDelegate */
/// <reference path="./delegates/DataGridRowDropDelegate.js"/>
/* global UCF_DragDropDecoration */
/// <reference path="./base/DragDropDecoration.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_DataGrid(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["UCF_DataGrid"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) == "object", "typeof (oDomRef) == \"object\"", "DataGrid.js(43): UCF_DataGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "DataGrid.js(44): UCF_DataGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DataGrid.js(45): UCF_DataGrid"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oDomRef"] = oDomRef;

	this["initInternal"]();

	this["oSelectScrollIntervalId"] = { "xInc": "", "xDec": "", "yInc": "", "yDec": "" };
	this["aRowScrollbars"] = [];
	this["aColumnScrollbars"] = [];

	this["iFocusCellX"] = -1;
	this["iFocusCellY"] = -1;
	this["oFocusSegment"] = null;
	this["oPrimarySelectedCell"] = null;

	this["bScrollbarInInteraction"] = false;
	this["bFocusUpdateCanceled"] = false;
	this["bKeepAlive"] = true;
	new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(); //load urbase

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["LayersVisible"], this, "onLayersVisible");
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["LayersHidden"], this, "onLayersHidden");
	this["bLayersVisible"] = false;

	this["oRowDropDelegate"] = null;
	this["oColumnDropDelegate"] = null;

	this["iMinSegmentColumnWidth"] = 20;
	this["iMinSegmentRowHeight"] = 10;
};window["UCF_DataGrid"] = UCF_DataGrid; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DataGrid"); UCF_DataGrid["_"] = {UCF_DataGrid: 0}; }; ;

UCF_DataGrid["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_DataGrid.prototype["sClassName"] = "UCF_DataGrid";

UCF_DataGrid["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["destroy"]++; }; 

	this["iFocusCellX"] = 0;
	this["iFocusCellY"] = 0;

	this["oFocusSegment"] = null;
	this["oPrimarySelectedCell"] = null;
	if (this["oRowDropDelegate"]) {
		this["oRowDropDelegate"]["destroy"]();
		this["oRowDropDelegate"] = null;
	}
	if (this["oColumnDropDelegate"]) {
		this["oColumnDropDelegate"]["destroy"]();
		this["oColumnDropDelegate"] = null;
	}
	this["aDataGridRows"] = null;
	this["aDataGridColumns"] = null;
	this["aSegmentMatrix"] = null;
	this["oFocusedCell"] = null;

	if (this["_iApplyUpdateSCBTimer"]) {
		clearTimeout(this["_iApplyUpdateSCBTimer"]);
		this["_iApplyUpdateSCBTimer"] = null;
	}
	if (this["_iApplyResizeTimer"]) {
		clearTimeout(this["_iApplyResizeTimer"]);
		this["_iApplyResizeTimer"] = null;
	}
	if (this["iFocusTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["iFocusTimer"]);
		this["iFocusTimer"] = null;
	}

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["destroy"] = 0; };

/**
 *
 */
UCF_DataGrid["prototype"]["reconnectToDom"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["reconnectToDom"]++; }; 
	UCF_Control.prototype["reconnectToDom"]["apply"](this, arguments);

	this["initInternal"]();

	this["detachBrowserEvent"]("resize", this["oDomRef"]);
	this["attachBrowserEvent"]("resize", this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["reconnectToDom"] = 0; };

UCF_DataGrid["prototype"]["initInternal"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["initInternal"]++; }; 
	if (this["getClientControl"]()) {
		this["aDataGridRows"] = this["getClientControl"]()["getRows"]();
		this["aDataGridColumns"] = this["getClientControl"]()["getColumns"]();
		this["aSegmentMatrix"] = this["aGetSegmentMatrix"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["initInternal"] = 0; };

/**
 * Control Initialization
 */
UCF_DataGrid["prototype"]["initialize"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["initialize"]++; }; 
	if (window["UCF_System"]["sDevice"] == "standards" && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
		UCF_DomUtil["initHtmlTableCorrection"](this["oDomRef"]["childNodes"][2]);
	}

	if (this["getClientControl"]()) {
		this["initResize"]();
		this["updateScrollbars"](true);
		this["initSegmentSplitters"]();
		this["getClientControl"]()["updateBindings"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["initialize"] = 0; };

/**
 * implements method from UCF_Control
 * @private
 */
UCF_DataGrid["prototype"]["createDropDelegate"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["createDropDelegate"]++; }; 

	if (!this["oRowDropDelegate"]) {
		// check all rows for dropTargetInfo
		for (var rowIndex = 0; rowIndex < this["aDataGridRows"]["length"]; rowIndex++) {
			if (!this["oRowDropDelegate"] && this["aDataGridRows"][rowIndex]["getDropTargetInfo"]()) {
				this["oRowDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DataGridRowDropDelegate"))(this["oLS"], this);
				this["addDelegate"](this["oRowDropDelegate"]);
			}
		}
	}

	if (!this["oColumnDropDelegate"]) {
		// check all columns for dropTargetInfo
		for (var colIndex = 0; colIndex < this["aDataGridColumns"]["length"]; colIndex++) {
			if (!this["oColumnDropDelegate"] && this["aDataGridColumns"][colIndex]["getDropTargetInfo"]()) {
				this["oColumnDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DataGridColumnDropDelegate"))(this["oLS"], this);
				this["addDelegate"](this["oColumnDropDelegate"]);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["createDropDelegate"] = 0; };

/**
 * Returns an array of all DataGridSegments of DataGridColumn at index iColumnIndex.
 * @param {int} iColumnIndex the index of the DataGridColumn.
 * @return list of DataGridSegments of DataGridColumn at index iColumnIndex.
 * @type {Array}
 */
UCF_DataGrid["prototype"]["aGetSegmentsOfColumn"] = function (iColumnIndex) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["aGetSegmentsOfColumn"]++; }; 

	var aDataGridRows = this["getClientControl"]()["getRows"](),
		aSegments = [];

	for (var i = 0; i < aDataGridRows["length"]; i++) {
		aSegments["push"](aDataGridRows[i]["getSegments"]()[iColumnIndex]);
	}

	return aSegments;
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["aGetSegmentsOfColumn"] = 0; };

/**
 */
UCF_DataGrid["prototype"]["aGetSegmentMatrix"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["aGetSegmentMatrix"]++; }; 

	var aDataGridRows = this["getClientControl"]()["getRows"](),
		aDataGridColumns = this["getClientControl"]()["getColumns"](),
		aSegmentsOfRow = [],
		aSegmentMatrix = [];

	for (var row = 0; row < aDataGridRows["length"]; row++) {
		aSegmentMatrix[row] = [];
		aSegmentsOfRow = aDataGridRows[row]["getSegments"]();
		for (var col = 0; col < aDataGridColumns["length"]; col++) {
			aSegmentMatrix[row][col] = aSegmentsOfRow[col];
		}
	}

	return aSegmentMatrix;
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["aGetSegmentMatrix"] = 0; };

/**
 * Initialize/Update scrollbars.
 * @param {boolean} bInitialize false if scrollPosition is taken from last client interaction, true if scrollPosition is taken from dataGrid API.
 */
UCF_DataGrid["prototype"]["updateScrollbars"] = function (bInitialize, bApply) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["updateScrollbars"]++; }; 

	if (!bInitialize && !bApply) {
		if (this["_iApplyUpdateSCBTimer"]) {
			clearTimeout(this["_iApplyUpdateSCBTimer"]);
		}
		var that = this;
		this["_iApplyUpdateSCBTimer"] = setTimeout(function () {
			that["updateScrollbars"](false, true);
		}, 0);
		return;
	}

	var oDataGridRow = null,
		oDataGridColumn = null,
		oDataGridSegment = null,
		oScrollbar = null,
		oUCFScrollbar = null,
		oScrollEventInfo = null,
		iScrollRange = 0,
		iScrollClipping = 0,
		iScrollPos = 0;
	for (var rowIndex = 0; rowIndex < this["aDataGridRows"]["length"]; rowIndex++) {
		oDataGridRow = this["aDataGridRows"][rowIndex];
		oScrollbar = oDataGridRow["getScrollbar"]();
		if (!oScrollbar) continue;
		oUCFScrollbar = oScrollbar["getUCFInstance"]();

		if (oUCFScrollbar) {
			if (bInitialize) {
				oUCFScrollbar["attachEvent"](oUCFScrollbar["E_EVENTS"]["Scroll"], this, "handleRowScrollEvent");
				oUCFScrollbar["setNotifactionMode"](oUCFScrollbar["NOTIFICATION"]["ALWAYS_WHEN_CHANGED"]);
				oScrollEventInfo = { "iRowIndex": rowIndex, "bCalcVisibleCellRange": true, "bDelayedUpdate": true };
				oUCFScrollbar["setInternalEventInfo"](oScrollEventInfo);
			}
			iScrollRange = oDataGridRow["iGetScrollRange"]();
			iScrollClipping = UCF_DomUtil["$"](oDataGridRow["getId"]())["offsetHeight"];
			iScrollPos = oDataGridRow["iGetScrollPosition"]();

			if (typeof (iScrollRange) != "undefined" && typeof (iScrollPos) != "undefined") {
				oUCFScrollbar["updateDimensions"](iScrollRange, iScrollClipping, iScrollPos);
			}
			this["aRowScrollbars"][rowIndex] = oUCFScrollbar;
		}
	}

	for (var colIndex = 0; colIndex < this["aDataGridColumns"]["length"]; colIndex++) {
		oDataGridColumn = this["aDataGridColumns"][colIndex];
		oScrollbar = oDataGridColumn["getScrollbar"]();

		if (!oScrollbar) continue;
		oUCFScrollbar = oScrollbar["getUCFInstance"]();
		//offsetWidth at COL is not defined -> take Segment TD
		oDataGridSegment = this["aDataGridRows"][0]["getSegments"]()[colIndex];

		if (oUCFScrollbar) {
			if (bInitialize) {
				oUCFScrollbar["attachEvent"](oUCFScrollbar["E_EVENTS"]["Scroll"], this, "handleColScrollEvent");
				oScrollEventInfo = { "iColumnIndex": colIndex, "bCalcVisibleCellRange": true, "bDelayedUpdate": true };
				oUCFScrollbar["setInternalEventInfo"](oScrollEventInfo);
				oUCFScrollbar["setNotifactionMode"](oUCFScrollbar["NOTIFICATION"]["ALWAYS_WHEN_CHANGED"]);
			}
			iScrollRange = oDataGridColumn["iGetScrollRange"]();
			iScrollClipping = UCF_DomUtil["$"](oDataGridSegment["getId"]())["offsetWidth"];
			iScrollPos = oDataGridColumn["iGetScrollPosition"]();

			if (typeof (iScrollRange) != "undefined" && typeof (iScrollPos) != "undefined") {
				oUCFScrollbar["updateDimensions"](iScrollRange, iScrollClipping, iScrollPos);
			}
			this["aColumnScrollbars"][colIndex] = oUCFScrollbar;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["updateScrollbars"] = 0; };

/**
 * Handles DataGridRow scroll event (vertical scrolling).
 * @param {Object} oEvent ScrollEvent.
 * @param {int} iIndex index of the DataGridRow to be scrolled.
 */
UCF_DataGrid["prototype"]["handleRowScrollEvent"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["handleRowScrollEvent"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "DataGrid.js(303): handleRowScrollEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "DataGrid.js(304): handleRowScrollEvent"); };
	var iIndex = oEvent["mParameters"]["oInternalEventInfo"]["iRowIndex"],
		bCalcVisibleCellRange = oEvent["mParameters"]["oInternalEventInfo"]["bCalcVisibleCellRange"],
		bDelayedUpdate = oEvent["mParameters"]["oInternalEventInfo"]["bDelayedUpdate"],
		oDataGridRow = this["aDataGridRows"][iIndex],
		oUCFScrollbar = oDataGridRow["getScrollbar"]()["getUCFInstance"](),
		iFirstVisibleItem = oEvent["oGetParam"]("iFirstVisibleItem") - 1;

	oDataGridRow["setScrollPosition"](iFirstVisibleItem);
	oDataGridRow["scroll"](bCalcVisibleCellRange, bDelayedUpdate);

	this["bScrollbarInInteraction"] = true;

	if (oUCFScrollbar && !oUCFScrollbar["bIsInInteraction"]()) {
		this["bScrollbarInInteraction"] = false;
		if (this["bFocusUpdateCanceled"]) this["focusAfterUpdate"]();
		var iFirstVisibleSegmentRowIndex = oDataGridRow["getFirstVisibleSegmentRowIndex"]();
		this["fireVerticalScroll"](this["sId"],
			iIndex,
			iFirstVisibleSegmentRowIndex,
			oEvent["oGetParam"]("eAction"),
			oEvent["oGetParam"]("eAccessSource"),
			oEvent["oGetParam"]("bShift"),
			oEvent["oGetParam"]("bCtrl"),
			oEvent["oGetParam"]("bAlt")
		);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["handleRowScrollEvent"] = 0; };

/**
 * Handles DataGridColumn scroll event (horizontal scrolling).
 * @param {Object} oEvent ScrollEvent.
 * @param {int} iIndex index of the DataGridColumn to be scrolled.
 */
UCF_DataGrid["prototype"]["handleColScrollEvent"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["handleColScrollEvent"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "DataGrid.js(340): handleColScrollEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "DataGrid.js(341): handleColScrollEvent"); };

	var iIndex = oEvent["mParameters"]["oInternalEventInfo"]["iColumnIndex"],
		bCalcVisibleCellRange = oEvent["mParameters"]["oInternalEventInfo"]["bCalcVisibleCellRange"],
		bDelayedUpdate = oEvent["mParameters"]["oInternalEventInfo"]["bDelayedUpdate"],
		oDataGridColumn = this["aDataGridColumns"][iIndex],
		oUCFScrollbar = oDataGridColumn["getScrollbar"]()["getUCFInstance"](),
		iFirstVisibleItem = oEvent["oGetParam"]("iFirstVisibleItem") - 1;

	oDataGridColumn["setScrollPosition"](iFirstVisibleItem);
	oDataGridColumn["scroll"](bCalcVisibleCellRange, bDelayedUpdate);

	this["bScrollbarInInteraction"] = true;

	if (oUCFScrollbar && !oUCFScrollbar["bIsInInteraction"]()) {
		this["bScrollbarInInteraction"] = false;
		if (this["bFocusUpdateCanceled"]) this["focusAfterUpdate"]();
		var iFirstVisibleSegmentColIndex = oDataGridColumn["getFirstVisibleSegmentColumnIndex"]();
		this["fireHorizontalScroll"](this["sId"],
			iIndex,
			iFirstVisibleSegmentColIndex,
			oEvent["oGetParam"]("eAction"),
			oEvent["oGetParam"]("eAccessSource"),
			oEvent["oGetParam"]("bShift"),
			oEvent["oGetParam"]("bCtrl"),
			oEvent["oGetParam"]("bAlt")
		);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["handleColScrollEvent"] = 0; };

/**
 * Browser resize event handler
 * @param {Object} oBrowserEvent browser resize event
 */
UCF_DataGrid["prototype"]["onresize"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onresize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataGrid.js(376): onresize"); };
	if (!this["oResizeInfo"]) return;
	UCF_JsUtil["feedMassNotificationFilter"](500, this["oResizeInfo"], this, "checkResize", [true]);

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onresize"] = 0; };

/**
 * Attaches browser resize event to DataGrid domRef
 */
UCF_DataGrid["prototype"]["initResize"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["initResize"]++; }; 

	this["oResizeInfo"] = {};
	this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "onLsLock");
	this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "onLsUnlock");
	if (this["oDomRef"] && !this["oLS"]["bIsLocked"]) this["attachBrowserEvent"]("resize", this["oDomRef"]);

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["initResize"] = 0; };

/**
 * Delayed called method to handle browser resize event. Calls checkResize() for all Segments and updates scrollbars.
 */
UCF_DataGrid["prototype"]["checkResize"] = function (bApply) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["checkResize"]++; }; 

	if (!bApply) {
		if (this["_iApplyResizeTimer"]) {
			clearTimeout(this["_iApplyResizeTimer"]);
		}
		var that = this;
		this["_iApplyResizeTimer"] = setTimeout(function () {
			that["checkResize"](true);
		}, 0);
		return;
	}

	if (!this["bIsValid"]()) return;
	if (!this["getClientControl"]()) return;

	this["initInternal"]();

	var oDataGridRow = null,
		oDataGridSegment = null,
		aDataGridSegments = [];

	for (var rowIndex = 0; rowIndex < this["aDataGridRows"]["length"]; rowIndex++) {
		oDataGridRow = this["aDataGridRows"][rowIndex];
		aDataGridSegments = oDataGridRow["getSegments"]();
		for (var colIndex = 0; colIndex < aDataGridSegments["length"]; colIndex++) {
			oDataGridSegment = aDataGridSegments[colIndex];
			if (oDataGridSegment["getUCFInstance"]()) oDataGridSegment["getUCFInstance"]()["checkResize"]();
		}
	}
	this["updateScrollbars"](false);

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["checkResize"] = 0; };

UCF_DataGrid["prototype"]["onLsLock"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onLsLock"]++; }; 
	if (this["oDomRef"]) {
		this["detachBrowserEvent"]("resize", this["oDomRef"]);
		//CleanUp pending delayed resize requests when UI is locked
		UCF_JsUtil["resetMassNotificationFilter"](this["oResizeInfo"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onLsLock"] = 0; };

UCF_DataGrid["prototype"]["onLsUnlock"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onLsUnlock"]++; }; 
	if (this["oDomRef"]) {
		this["attachBrowserEvent"]("resize", this["oDomRef"]);
		this["checkResize"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onLsUnlock"] = 0; };

/**
 * Handles the onlsdragstart event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataGrid["prototype"]["onlsdragstart"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsdragstart"]++; }; 

	if (oBrowserEvent["oSource"]["getAttribute"]('id') && oBrowserEvent["oSource"]["getAttribute"]('id')["indexOf"]('-verticalSplitter') !== -1) {
		this["startDGColumnResize"](oBrowserEvent);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;
	}
	if (oBrowserEvent["oSource"]["getAttribute"]('id') && oBrowserEvent["oSource"]["getAttribute"]('id')["indexOf"]('-horizontalSplitter') !== -1) {
		this["startDGRowResize"](oBrowserEvent);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsdragstart"] = 0; };

/* eslint-disable complexity */
UCF_DataGrid["prototype"]["onlsdrag"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsdrag"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DataGrid.js(470): onlsdrag"); };

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];
	var	oDragSession = oDragAndDropManager["oDragSession"];
	var	oDecorationBoundaries = null;
	var oRefContainer = null;
	var oRefRect = null;
	var oSegmentRect = null;

	if (oDragSession["sGetCustomType"]() === "DG_COL_RESIZE") {
		var iDGMouseX = oBrowserEvent["iClientX"]();
		var oDGResizeColumn = this["getClientControl"]()["getColumn"](oDragSession["oGetCustomData"]()["iColumnIndexOfSegment"]);
		var iColumnWidth;
		var sColumnWidth;

		oSegmentRect = oDragSession["oGetCustomData"]()["oDataGridSegmentRect"];
		oDecorationBoundaries = oDragSession["oGetCustomData"]()["oDecorationBoundaries"];

		if (oDragSession["oGetCustomData"]()["oRefContainer"]) {
			oRefContainer = oDragSession["oGetCustomData"]()["oRefContainer"];
			oRefRect = UCF_DomUtil["oGetObjectRect"](oRefContainer);
			iDGMouseX += (-oRefRect["left"] + oRefContainer["scrollLeft"]);
		}

		iColumnWidth = iDGMouseX - oSegmentRect["left"] - 1;
		if (iColumnWidth < (oDecorationBoundaries["left"] - oSegmentRect["left"])) {
			iColumnWidth = oDecorationBoundaries["left"] - oSegmentRect["left"];
		}
		if (iColumnWidth > (oDecorationBoundaries["left"] + oDecorationBoundaries["width"] - oSegmentRect["left"])) {
			iColumnWidth = oDecorationBoundaries["left"] + oDecorationBoundaries["width"] - oSegmentRect["left"];
		}
		sColumnWidth = iColumnWidth + oDGResizeColumn["getSegmentColumnUnit"]();
		oDragSession["oGetCustomData"]()["sDataGridColumnWidth"] = sColumnWidth;
		this["applyDGColumnResize"](oBrowserEvent);
	}

	if (oDragSession["sGetCustomType"]() === "DG_ROW_RESIZE") {
		var iDGMouseY = oBrowserEvent["iClientY"]();
		var oDGResizeRow = this["getClientControl"]()["getRow"](oDragSession["oGetCustomData"]()["iRowIndexOfSegment"]);
		var iRowHeight;
		var sRowHeight;

		oSegmentRect = oDragSession["oGetCustomData"]()["oDataGridSegmentRect"];
		oDecorationBoundaries = oDragSession["oGetCustomData"]()["oDecorationBoundaries"];

		if (oDragSession["oGetCustomData"]()["oRefContainer"]) {
			oRefContainer = oDragSession["oGetCustomData"]()["oRefContainer"];
			oRefRect = UCF_DomUtil["oGetObjectRect"](oRefContainer);
			iDGMouseY += (-oRefRect["top"] + oRefContainer["scrollTop"]);
		}

		iRowHeight = iDGMouseY - oSegmentRect["top"] - 1;
		if (iRowHeight < (oDecorationBoundaries["top"] - oSegmentRect["top"])) {
			iRowHeight = oDecorationBoundaries["top"] - oSegmentRect["top"];
		}
		if (iRowHeight > (oDecorationBoundaries["top"] + oDecorationBoundaries["height"] - oSegmentRect["top"])) {
			iRowHeight = oDecorationBoundaries["top"] + oDecorationBoundaries["height"] - oSegmentRect["top"];
		}
		sRowHeight = iRowHeight + oDGResizeRow["getSegmentRowUnit"]();
		oDragSession["oGetCustomData"]()["sDataGridRowHeight"] = sRowHeight;
		this["applyDGRowResize"](oBrowserEvent);
	}

	if (oDragSession["sGetCustomType"]() != "SELECTION") return;

	var sDragSourceId = oDragSession["sGetDragSourceId"](),
		oDragSourceRect = UCF_DomUtil["oGetObjectRect"](UCF_DomUtil["$"](sDragSourceId)),
		oDragSource = this["oLS"]["oControlFactory"]["oGetControlById"](sDragSourceId),
		iDragSourceColumnIndex = oDragSource["iGetSegmentColumnIndex"](),
		iDragSourceRowIndex = oDragSource["iGetSegmentRowIndex"](),
		oDataGridRow = oDragSource["oDataGridRow"],
		oDataGridColumn = oDragSource["oDataGridColumn"],
		oSelectionRange = oDragSource["oGetSelectionRange"](),
		oSelectScrollIntervalAction = { "xInc": "", "xDec": "", "yInc": "", "yDec": "" },
		iPosDelta = 0;

	//left top
	if (oBrowserEvent["iClientX"]() < oDragSourceRect["left"] && oBrowserEvent["iClientY"]() < oDragSourceRect["top"]) {
		if (window["UCF_System"]["bIsRTL"]) {
			oSelectScrollIntervalAction = { "xInc": "", "xDec": "clear", "yInc": "clear", "yDec": "" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (this["oSelectScrollIntervalId"]["xInc"] == "" && oSelectionRange["xEnd"] < (oDataGridColumn["getSegmentColumnCount"]() - 1)) {
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] + 1);
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, 2, -1);
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xInc"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, iPosDelta, 1, iDragSourceRowIndex]);
			}
		} else {
			oSelectScrollIntervalAction = { "xInc": "clear", "xDec": "", "yInc": "clear", "yDec": "" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (this["oSelectScrollIntervalId"]["xDec"] == "" && oSelectionRange["xEnd"] > oDataGridColumn["getSegmentColumnIndexOffset"]()) {
				iPosDelta = 0 - (oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] - 1));
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, -2, -1);
				iPosDelta = 0 - oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xDec"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, -100, -1, iDragSourceRowIndex]);
			}
		}
		if (this["oSelectScrollIntervalId"]["yDec"] == "" && oSelectionRange["yEnd"] > oDataGridRow["getSegmentRowIndexOffset"]()) {
			iPosDelta = 0 - oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]) + oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"] - 1);
			this["rowScrollToPosition"](iDragSourceRowIndex, iPosDelta, -2, -1);
			iPosDelta = 0 - oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]);
			this["oSelectScrollIntervalId"]["yDec"] = UCF_JsUtil["intervalCall"](10, this, "rowScrollToPosition", [iDragSourceRowIndex, iPosDelta, -1, iDragSourceColumnIndex]);
		}
		return;
	}
	//right bottom
	if (oBrowserEvent["iClientX"]() > (oDragSourceRect["left"] + oDragSourceRect["width"]) && oBrowserEvent["iClientY"]() > (oDragSourceRect["top"] + oDragSourceRect["height"])) {
		if (window["UCF_System"]["bIsRTL"]) {
			oSelectScrollIntervalAction = { "xInc": "clear", "xDec": "", "yInc": "", "yDec": "clear" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (this["oSelectScrollIntervalId"]["xDec"] == "" && oSelectionRange["xEnd"] > oDataGridColumn["getSegmentColumnIndexOffset"]()) {
				iPosDelta = 0 - oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] - 1);
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, -2, -1);
				iPosDelta = 0 - oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xDec"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, iPosDelta, -1, iDragSourceRowIndex]);
			}
		} else {
			oSelectScrollIntervalAction = { "xInc": "", "xDec": "clear", "yInc": "", "yDec": "clear" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (this["oSelectScrollIntervalId"]["xInc"] == "" && oSelectionRange["xEnd"] < (oDataGridColumn["getSegmentColumnCount"]() - 1)) {
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] + 1);
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, 2, -1);
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xInc"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, iPosDelta, 1, iDragSourceRowIndex]);
			}
		}
		if (this["oSelectScrollIntervalId"]["yInc"] == "" && oSelectionRange["yEnd"] < (oDataGridRow["getSegmentRowCount"]() - 1)) {
			iPosDelta = oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]) + oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"] + 1);
			this["rowScrollToPosition"](iDragSourceRowIndex, iPosDelta, 2, -1);
			iPosDelta = oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]);
			this["oSelectScrollIntervalId"]["yInc"] = UCF_JsUtil["intervalCall"](10, this, "rowScrollToPosition", [iDragSourceRowIndex, iPosDelta, 1, iDragSourceColumnIndex]);
		}
		return;
	}
	//right top
	if (oBrowserEvent["iClientX"]() > (oDragSourceRect["left"] + oDragSourceRect["width"]) && oBrowserEvent["iClientY"]() < oDragSourceRect["top"]) {
		if (window["UCF_System"]["bIsRTL"]) {
			oSelectScrollIntervalAction = { "xInc": "clear", "xDec": "", "yInc": "clear", "yDec": "" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (this["oSelectScrollIntervalId"]["xDec"] == "" && oSelectionRange["xEnd"] > oDataGridColumn["getSegmentColumnIndexOffset"]()) {
				iPosDelta = 0 - (oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] - 1));
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, -2, -1);
				iPosDelta = 0 - oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xDec"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, -100, -1, iDragSourceRowIndex]);
			}
		} else {
			oSelectScrollIntervalAction = { "xInc": "", "xDec": "clear", "yInc": "clear", "yDec": "" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (this["oSelectScrollIntervalId"]["xInc"] == "" && oSelectionRange["xEnd"] < (oDataGridColumn["getSegmentColumnCount"]() - 1)) {
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] + 1);
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, 2, -1);
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xInc"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, iPosDelta, 1, iDragSourceRowIndex]);
			}
		}
		if (this["oSelectScrollIntervalId"]["yDec"] == "" && oSelectionRange["yEnd"] > oDataGridRow["getSegmentRowIndexOffset"]()) {
			iPosDelta = 0 - (oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]) + oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"] - 1));
			this["rowScrollToPosition"](iDragSourceRowIndex, iPosDelta, -2, -1);
			iPosDelta = 0 - oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]);
			this["oSelectScrollIntervalId"]["yDec"] = UCF_JsUtil["intervalCall"](10, this, "rowScrollToPosition", [iDragSourceRowIndex, iPosDelta, -1, iDragSourceColumnIndex]);
		}
		return;
	}
	//left bottom
	if (oBrowserEvent["iClientX"]() < oDragSourceRect["left"] && oBrowserEvent["iClientY"]() > (oDragSourceRect["top"] + oDragSourceRect["height"])) {
		if (window["UCF_System"]["bIsRTL"]) {
			oSelectScrollIntervalAction = { "xInc": "", "xDec": "clear", "yInc": "", "yDec": "clear" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (this["oSelectScrollIntervalId"]["xInc"] == "" && oSelectionRange["xEnd"] < (oDataGridColumn["getSegmentColumnCount"]() - 1)) {
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] + 1);
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, 2, -1);
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xInc"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, iPosDelta, 1, iDragSourceRowIndex]);
			}
		} else {
			oSelectScrollIntervalAction = { "xInc": "clear", "xDec": "", "yInc": "", "yDec": "clear" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (this["oSelectScrollIntervalId"]["xDec"] == "" && oSelectionRange["xEnd"] > oDataGridColumn["getSegmentColumnIndexOffset"]()) {
				iPosDelta = 0 - oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] - 1);
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, -2, -1);
				iPosDelta = 0 - oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xDec"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, iPosDelta, -1, iDragSourceRowIndex]);
			}
		}
		if (this["oSelectScrollIntervalId"]["yInc"] == "" && oSelectionRange["yEnd"] < (oDataGridRow["getSegmentRowCount"]() - 1)) {
			iPosDelta = oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]) + oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"] + 1);
			this["rowScrollToPosition"](iDragSourceRowIndex, iPosDelta, 2, -1);
			iPosDelta = oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]) + oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"] + 1);
			this["oSelectScrollIntervalId"]["yInc"] = UCF_JsUtil["intervalCall"](10, this, "rowScrollToPosition", [iDragSourceRowIndex, iPosDelta, 1, iDragSourceColumnIndex]);
		}
		return;
	}
	//left
	if (oBrowserEvent["iClientX"]() < oDragSourceRect["left"]) {
		if (window["UCF_System"]["bIsRTL"]) {
			oSelectScrollIntervalAction = { "xInc": "", "xDec": "clear", "yInc": "clear", "yDec": "clear" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (this["oSelectScrollIntervalId"]["xInc"] == "" && oSelectionRange["xEnd"] < (oDataGridColumn["getSegmentColumnCount"]() - 1)) {
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] + 1);
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, 2, -1);
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xInc"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, iPosDelta, 1, iDragSourceRowIndex]);
			}
		} else {
			oSelectScrollIntervalAction = { "xInc": "clear", "xDec": "", "yInc": "clear", "yDec": "clear" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (window["UCF_System"]["bIsRTL"] && this["oSelectScrollIntervalId"]["xDec"] == "" && oSelectionRange["xEnd"] > oDataGridColumn["getSegmentColumnIndexOffset"]()) {
				iPosDelta = 0 - oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] - 1);
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, -2, -1);
				iPosDelta = 0 - oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xDec"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, iPosDelta, -1, iDragSourceRowIndex]);
			}
		}
		return;
	}
	//right
	if (oBrowserEvent["iClientX"]() > (oDragSourceRect["left"] + oDragSourceRect["width"])) {
		if (window["UCF_System"]["bIsRTL"]) {
			oSelectScrollIntervalAction = { "xInc": "clear", "xDec": "", "yInc": "clear", "yDec": "clear" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (window["UCF_System"]["bIsRTL"] && this["oSelectScrollIntervalId"]["xDec"] == "" && oSelectionRange["xEnd"] > oDataGridColumn["getSegmentColumnIndexOffset"]()) {
				iPosDelta = 0 - oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] - 1);
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, -2, -1);
				iPosDelta = 0 - oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xDec"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, iPosDelta, -1, iDragSourceRowIndex]);
			}
		} else {
			oSelectScrollIntervalAction = { "xInc": "", "xDec": "clear", "yInc": "clear", "yDec": "clear" };
			this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
			if (this["oSelectScrollIntervalId"]["xInc"] == "" && oSelectionRange["xEnd"] < (oDataGridColumn["getSegmentColumnCount"]() - 1)) {
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]) + oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"] + 1);
				this["columnScrollToPosition"](iDragSourceColumnIndex, iPosDelta, 2, -1);
				iPosDelta = oDataGridColumn["_fGetSegmentColumnWidth"](oSelectionRange["xEnd"]);
				this["oSelectScrollIntervalId"]["xInc"] = UCF_JsUtil["intervalCall"](10, this, "columnScrollToPosition", [iDragSourceColumnIndex, iPosDelta, 1, iDragSourceRowIndex]);
			}
			return;
		}
	}
	//top
	if (oBrowserEvent["iClientY"]() < oDragSourceRect["top"]) {
		oSelectScrollIntervalAction = { "xInc": "clear", "xDec": "clear", "yInc": "clear", "yDec": "" };
		this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
		if (this["oSelectScrollIntervalId"]["yDec"] == "" && oSelectionRange["yEnd"] > oDataGridRow["getSegmentRowIndexOffset"]()) {
			iPosDelta = 0 - (oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]) + oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"] - 1));
			this["rowScrollToPosition"](iDragSourceRowIndex, iPosDelta, -2, -1);
			iPosDelta = 0 - oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]);
			this["oSelectScrollIntervalId"]["yDec"] = UCF_JsUtil["intervalCall"](10, this, "rowScrollToPosition", [iDragSourceRowIndex, iPosDelta, -1, iDragSourceColumnIndex]);
		}
		return;
	}
	//bottom
	if (oBrowserEvent["iClientY"]() > (oDragSourceRect["top"] + oDragSourceRect["height"])) {
		oSelectScrollIntervalAction = { "xInc": "clear", "xDec": "clear", "yInc": "", "yDec": "clear" };
		this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
		if (this["oSelectScrollIntervalId"]["yInc"] == "" && oSelectionRange["yEnd"] < (oDataGridRow["getSegmentRowCount"]() - 1)) {
			iPosDelta = oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]) + oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"] + 1);
			this["rowScrollToPosition"](iDragSourceRowIndex, iPosDelta, 2, -1);
			iPosDelta = oDataGridRow["_fGetSegmentRowHeight"](oSelectionRange["yEnd"]);
			this["oSelectScrollIntervalId"]["yInc"] = UCF_JsUtil["intervalCall"](10, this, "rowScrollToPosition", [iDragSourceRowIndex, iPosDelta, 1, iDragSourceColumnIndex]);
		}
		return;
	}

	oSelectScrollIntervalAction = { "xInc": "clear", "xDec": "clear", "yInc": "clear", "yDec": "clear" };
	this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
	this["oSelectScrollIntervalId"] = { "xInc": "", "xDec": "", "yInc": "", "yDec": "" };

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["bHandled"] = true;

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsdrag"] = 0; };
/* eslint-enable complexity */

/**
 * Handles the drop event of the browser
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_DataGrid["prototype"]["onlsdragend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsdragend"]++; }; 

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		oDragSession = oDragAndDropManager["oDragSession"];

	//dragend of selection
	if (oDragSession["sGetCustomType"]() == "SELECTION") {
		var oSelectScrollIntervalAction = { "xInc": "clear", "xDec": "clear", "yInc": "clear", "yDec": "clear" },
			oUCFSegment = oDragSession["oGetCustomData"]()["oUCFSegment"];

		this["clearIntervalCalls"](this["oSelectScrollIntervalId"], oSelectScrollIntervalAction);
		this["oSelectScrollIntervalId"] = { "xInc": "", "xDec": "", "yInc": "", "yDec": "" };

		oUCFSegment["commitModelSelectionRanges"]();

		return;
	}

	//dragend of row/col resize
	this["applyRowResize"](oBrowserEvent);
	this["applyColumnResize"](oBrowserEvent);
	//dragend of DGRow/DGCol resize
	this["applyDGRowResize"](oBrowserEvent);
	this["applyDGColumnResize"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsdragend"] = 0; };

UCF_DataGrid["prototype"]["startDGRowResize"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["startDGRowResize"]++; }; 

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
			oDecoration = null,
			oUCFSegment = this["oLS"]["oGetControlByDomRef"](oBrowserEvent["oSource"]["parentNode"]["parentNode"]["rows"][Array["from"](oBrowserEvent["oSource"]["parentNode"]["parentNode"]["rows"])["indexOf"](oBrowserEvent["oSource"]["parentNode"]) - 1]["firstChild"]["firstChild"]),
			oDataGridRow = oUCFSegment["oDataGridRow"],
			oRefContainer = UCF_DomUtil["oGetParentPositionReferenceContainer"](this["oDomRef"], true),
			oSegmentRect = UCF_DomUtil["oGetObjectRect"](oUCFSegment["oDomRef"], oRefContainer),
			oTableRef = UCF_DomUtil["oGetParentByTagName"](oUCFSegment["oDomRef"], "TABLE"),
			oDataGridRect = UCF_DomUtil["oGetObjectRect"](oTableRef, oRefContainer),
			oDecorationBoundaries = null,
			iRowIndexOfSegment = oUCFSegment["iGetSegmentRowIndex"](),
			iDecorationBoundariesHeight = 0,
			iMinRowHeight = this["iMinSegmentRowHeight"]; //oDataGridRow.getSegmentRowCount() * this.iMinSegmentRowHeight;

	// resize of DG row only when scrollbar is aggregated
	if (!this["aRowScrollbars"][iRowIndexOfSegment]) return;

	for (var i = oDataGridRow["getSegmentRowIndexOffset"](); i < oDataGridRow["getSegmentRowCount"]() + oDataGridRow["getSegmentRowIndexOffset"](); i++) {
		iDecorationBoundariesHeight += (oDataGridRow["_fGetSegmentRowHeight"](i) - 1);
	}

	oDecorationBoundaries = {
		"top": oSegmentRect["top"] + iMinRowHeight,
		"left": oDataGridRect["left"],
		"width": oDataGridRect["width"],
		"height": iDecorationBoundariesHeight - iMinRowHeight + 1
	};

	oDecoration = new (UCF_ClassLoader["oGetClass"]("UCF_DragDropDecoration"))(this["oLS"], this["oDomRef"], oDecorationBoundaries);

	var oDragSession = oDragAndDropManager["startDragSession"](this["sId"], "", UCF_DragSession["DRAG_TYPE"]["V_RESIZE"], oDecoration, null, null);
	//current drag mode: values: NONE, COL_RESIZE, ROW_RESIZE, COL_RESIZE, ROW_RESIZE, SELECTION
	oDragSession["setCustomType"]("DG_ROW_RESIZE");
	oDragSession["setCustomData"]({
		"iRowIndexOfSegment": iRowIndexOfSegment,
		"oDataGridSegmentRect": oSegmentRect,
		"oDecorationBoundaries": oDecorationBoundaries,
		"oRefContainer": oRefContainer
	});

	oDecoration["init"](oDragAndDropManager["oDragSession"]);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["startDGRowResize"] = 0; };

/**
 * Applies the DG row resize
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_DataGrid["prototype"]["applyDGRowResize"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["applyDGRowResize"]++; }; 

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];
	var	oDragSession = oDragAndDropManager["oDragSession"];
	var oResizeInfo = oDragSession["oGetCustomData"]();
	var oDataGridRow = this["getClientControl"]()["getRow"](oResizeInfo["iRowIndexOfSegment"]);

	if (oDragSession["sGetCustomType"]() === "DG_ROW_RESIZE") {
		oDataGridRow["setHeight"](oResizeInfo["sDataGridRowHeight"], false);
		if (oBrowserEvent["sName"] === "lsdragend") {
			this["fireRowResize"](this["sId"],
				oResizeInfo["iRowIndexOfSegment"],
				oResizeInfo["sDataGridRowHeight"]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["applyDGRowResize"] = 0; };

UCF_DataGrid["prototype"]["startDGColumnResize"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["startDGColumnResize"]++; }; 

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
			oDecoration = null,
			oUCFSegment = this["oLS"]["oGetControlByDomRef"](oBrowserEvent["oSource"]["parentNode"]["cells"][Array["from"](oBrowserEvent["oSource"]["parentNode"]["cells"])["indexOf"](oBrowserEvent["oSource"]) - 1]["firstChild"]),
			oDataGridColumn = oUCFSegment["oDataGridColumn"],
			oRefContainer = UCF_DomUtil["oGetParentPositionReferenceContainer"](this["oDomRef"], true),
			oSegmentRect = UCF_DomUtil["oGetObjectRect"](oUCFSegment["oDomRef"], oRefContainer),
			oTableRef = UCF_DomUtil["oGetParentByTagName"](oUCFSegment["oDomRef"], "TABLE"),
			oDataGridRect = UCF_DomUtil["oGetObjectRect"](oTableRef, oRefContainer),
			oDecorationBoundaries = null,
			iColumnIndexOfSegment = oUCFSegment["iGetSegmentColumnIndex"](),
			iDecorationBoundariesWidth = 0,
			iMinColWidth = this["iMinSegmentColumnWidth"]; //oDataGridColumn.getSegmentColumnCount() * this.iMinSegmentColumnWidth;

	// resize of DG column only when scrollbar is aggregated
	if (!this["aColumnScrollbars"][iColumnIndexOfSegment]) return;

	for (var i = oDataGridColumn["getSegmentColumnIndexOffset"](); i < oDataGridColumn["getSegmentColumnCount"]() + oDataGridColumn["getSegmentColumnIndexOffset"](); i++) {
		iDecorationBoundariesWidth += (oDataGridColumn["_fGetSegmentColumnWidth"](i) - 1);
	}

	oDecorationBoundaries = {
		"top": oDataGridRect["top"],
		"left": oSegmentRect["left"] + iMinColWidth,
		"width": iDecorationBoundariesWidth - iMinColWidth + 1,
		"height": oDataGridRect["height"]
	};

	oDecoration = new (UCF_ClassLoader["oGetClass"]("UCF_DragDropDecoration"))(this["oLS"], this["oDomRef"], oDecorationBoundaries);

	var oDragSession = oDragAndDropManager["startDragSession"](this["sId"], "", UCF_DragSession["DRAG_TYPE"]["H_RESIZE"], oDecoration, null, null);
	//current drag mode: values: NONE, COL_RESIZE, ROW_RESIZE, COL_RESIZE, ROW_RESIZE, SELECTION
	oDragSession["setCustomType"]("DG_COL_RESIZE");
	oDragSession["setCustomData"]({
		"iColumnIndexOfSegment": iColumnIndexOfSegment,
		"oDataGridSegmentRect": oSegmentRect,
		"oDecorationBoundaries": oDecorationBoundaries,
		"oRefContainer": oRefContainer
	});

	oDecoration["init"](oDragAndDropManager["oDragSession"]);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["startDGColumnResize"] = 0; };

/**
 * Applies the DG column resize
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_DataGrid["prototype"]["applyDGColumnResize"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["applyDGColumnResize"]++; }; 

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];
	var	oDragSession = oDragAndDropManager["oDragSession"];
	var oResizeInfo = oDragSession["oGetCustomData"]();
	var oDataGridColumn = this["getClientControl"]()["getColumn"](oResizeInfo["iColumnIndexOfSegment"]);

	if (oDragSession["sGetCustomType"]() === "DG_COL_RESIZE") {
		oDataGridColumn["setWidth"](oResizeInfo["sDataGridColumnWidth"], false);
		if (oBrowserEvent["sName"] === "lsdragend") {
			this["fireColumnResize"](this["sId"],
				oResizeInfo["iColumnIndexOfSegment"],
				oResizeInfo["sDataGridColumnWidth"]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["applyDGColumnResize"] = 0; };

/**
 * Applies the row resize
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_DataGrid["prototype"]["applyRowResize"] = function (oBrowserEvent, bSkipModelUpdate) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["applyRowResize"]++; }; 

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		oDragSession = oDragAndDropManager["oDragSession"];

	if (oDragSession["sGetCustomType"]() === "ROW_RESIZE") {
		var oResizeInfo = oDragSession["oGetCustomData"](),
			oDataGridRow = this["getClientControl"]()["getRow"](oResizeInfo["iRowIndexOfSegment"]),
			oSegmentRow = null,
			oBindingInfo = null,
			iResizeRowCount = 0,
			iOldRowHeight = 0,
			iHeightDelta = 0,
			iNormalizedIndex = 0,
			iSegmentRowHeight = 0,
			bIncreaseHeight = false;

		for (var i = oResizeInfo["oDataGridSegmentRowRange"]["iFrom_y"]; i <= oResizeInfo["oDataGridSegmentRowRange"]["iTo_y"]; i++) {
			iNormalizedIndex = i - oDataGridRow["_iStartIndex"];
			iSegmentRowHeight = oDataGridRow["getSegmentRow"](iNormalizedIndex)["getHeight"]();
			iOldRowHeight += iSegmentRowHeight;
		}
		bIncreaseHeight = (oResizeInfo["iDataGridSegmentRowHeight"] - iOldRowHeight) > 0;
		for (var k = oResizeInfo["oDataGridSegmentRowRange"]["iFrom_y"]; k <= oResizeInfo["oDataGridSegmentRowRange"]["iTo_y"]; k++) {
			iNormalizedIndex = k - oDataGridRow["_iStartIndex"];
			iSegmentRowHeight = oDataGridRow["getSegmentRow"](iNormalizedIndex)["getHeight"]();
			if (bIncreaseHeight) iResizeRowCount++;
			else if (iSegmentRowHeight > this["iMinSegmentRowHeight"]) iResizeRowCount++;
		}
		iHeightDelta = Math["round"]((oResizeInfo["iDataGridSegmentRowHeight"] - iOldRowHeight) / iResizeRowCount);

		for (var j = oResizeInfo["oDataGridSegmentRowRange"]["iFrom_y"]; j <= oResizeInfo["oDataGridSegmentRowRange"]["iTo_y"]; j++) {
			iNormalizedIndex = j - oDataGridRow["_iStartIndex"];
			oSegmentRow = oDataGridRow["getSegmentRow"](iNormalizedIndex);
			iSegmentRowHeight = oSegmentRow["getHeight"]();
			if (!bIncreaseHeight && (iSegmentRowHeight <= this["iMinSegmentRowHeight"])) continue;
			if (bSkipModelUpdate) {
				oBindingInfo = oSegmentRow["mBindingInfos"]["Height"];
				oBindingInfo["skipModelUpdate"] = true;
			}
			else {
				oSegmentRow["bForceUpdate"] = true;
			}
			oSegmentRow["setHeight"]((oSegmentRow["getHeight"]() + iHeightDelta), false);
			if (bSkipModelUpdate) {
				oBindingInfo["skipModelUpdate"] = false;
			}
			oSegmentRow["bForceUpdate"] = false;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["applyRowResize"] = 0; };

/**
 * Applies the column resize
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_DataGrid["prototype"]["applyColumnResize"] = function (oBrowserEvent, bSkipModelUpdate) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["applyColumnResize"]++; }; 

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		oDragSession = oDragAndDropManager["oDragSession"];

	if (oDragSession["sGetCustomType"]() === "COL_RESIZE") {
		var oResizeInfo = oDragSession["oGetCustomData"](),
			oDataGridColumn = this["getClientControl"]()["getColumn"](oResizeInfo["iColumnIndexOfSegment"]),
			oSegmentColumn = null,
			oBindingInfo = null,
			iResizeColumnCount = 0,
			iOldColumnWidth = 0,
			iWidthDelta = 0,
			iNormalizedIndex = 0,
			iSegmentColumnWidth = 0,
			bIncreaseWidth = false;

		for (var i = oResizeInfo["oDataGridSegmentColumnRange"]["iFrom_x"]; i <= oResizeInfo["oDataGridSegmentColumnRange"]["iTo_x"]; i++) {
			iNormalizedIndex = i - oDataGridColumn["_iStartIndex"];
			iSegmentColumnWidth = oDataGridColumn["getSegmentColumn"](iNormalizedIndex)["getWidth"]();
			iOldColumnWidth += iSegmentColumnWidth;
		}
		bIncreaseWidth = (oResizeInfo["iDataGridSegmentColumnWidth"] - iOldColumnWidth) > 0;
		for (var k = oResizeInfo["oDataGridSegmentColumnRange"]["iFrom_x"]; k <= oResizeInfo["oDataGridSegmentColumnRange"]["iTo_x"]; k++) {
			iNormalizedIndex = k - oDataGridColumn["_iStartIndex"];
			iSegmentColumnWidth = oDataGridColumn["getSegmentColumn"](iNormalizedIndex)["getWidth"]();
			if (bIncreaseWidth) iResizeColumnCount++;
			else if (iSegmentColumnWidth > this["iMinSegmentColumnWidth"]) iResizeColumnCount++;
		}
		iWidthDelta = Math["round"]((oResizeInfo["iDataGridSegmentColumnWidth"] - iOldColumnWidth) / iResizeColumnCount);

		for (var j = oResizeInfo["oDataGridSegmentColumnRange"]["iFrom_x"]; j <= oResizeInfo["oDataGridSegmentColumnRange"]["iTo_x"]; j++) {
			iNormalizedIndex = j - oDataGridColumn["_iStartIndex"];
			oSegmentColumn = oDataGridColumn["getSegmentColumn"](iNormalizedIndex);
			iSegmentColumnWidth = oSegmentColumn["getWidth"]();
			if (!bIncreaseWidth && (iSegmentColumnWidth <= this["iMinSegmentColumnWidth"])) continue;
			if (bSkipModelUpdate) {
				oBindingInfo = oSegmentColumn["mBindingInfos"]["Width"];
				oBindingInfo["skipModelUpdate"] = true;
			}
			else {
				oSegmentColumn["bForceUpdate"] = true;
			}
			oSegmentColumn["setWidth"]((oSegmentColumn["getWidth"]() + iWidthDelta), false);
			if (bSkipModelUpdate) {
				oBindingInfo["skipModelUpdate"] = false;
			}
			oSegmentColumn["bForceUpdate"] = false;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["applyColumnResize"] = 0; };

/**
 * Performs a discrete column scroll by iDelta steps (DataGridSegmentColumns)
 * @param {array} aSegmentsOfColumn Segments of the DataGridColumn to be scrolled.
 * @param {int} iDeltaX steps (DataGridSegmentColumns) to be scrolled.
 */
UCF_DataGrid["prototype"]["columnScrollToPosition"] = function (iColumnIndex, iPosDelta, iIndexDelta, iSelectionRowIndex) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["columnScrollToPosition"]++; }; 

	var oUCFScrollbar = this["aColumnScrollbars"][iColumnIndex];

	if (!oUCFScrollbar) return;

	var iScrollPosition = this["aDataGridColumns"][iColumnIndex]["iGetScrollPosition"]() + iPosDelta,
		oScrollEventInfo = oUCFScrollbar["oGetInternalEventInfo"]();

	oScrollEventInfo["bDelayedUpdate"] = false;
	oUCFScrollbar["scrollToPosition"](iScrollPosition);
	oScrollEventInfo["bDelayedUpdate"] = true;

	if (iSelectionRowIndex < 0) return;

	var aSegmentsOfColumn = this["aGetSegmentsOfColumn"](iColumnIndex),
		oSegment = aSegmentsOfColumn[iSelectionRowIndex],
		oUCFSegment = oSegment["getUCFInstance"](),
		oSelectionRange = oUCFSegment["oGetSelectionRange"]();

	oSelectionRange["xEnd"] += iIndexDelta;
	if (oSelectionRange["xEnd"] < 0 || oSelectionRange["yEnd"] < 0) return;
	oUCFSegment["clearModelSelectionRanges"](false);
	oUCFSegment["setSelectionRange"](oSelectionRange, false);
	oUCFSegment["addModelSelectionRange"](oSelectionRange, 2, true);

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["columnScrollToPosition"] = 0; };

/**
 * Performs a discrete row scroll by iDelta steps (DataGridSegmentRows)
 * @param {array} aSegmentsOfRow Segments of the DataGridRow to be scrolled.
 * @param {int} iDeltaY steps (DataGridSegmentRows) to be scrolled.
 */
UCF_DataGrid["prototype"]["rowScrollToPosition"] = function (iRowIndex, iPosDelta, iIndexDelta, iSelectionColumnIndex) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["rowScrollToPosition"]++; }; 

	var oUCFScrollbar = this["aRowScrollbars"][iRowIndex];

	if (!oUCFScrollbar) return;

	var iScrollPosition = this["aDataGridRows"][iRowIndex]["iGetScrollPosition"]() + iPosDelta,
		oScrollEventInfo = oUCFScrollbar["oGetInternalEventInfo"]();

	oScrollEventInfo["bDelayedUpdate"] = false;
	oUCFScrollbar["scrollToPosition"](iScrollPosition);
	oScrollEventInfo["bDelayedUpdate"] = true;

	if (iSelectionColumnIndex < 0) return;

	var aSegmentsOfRow = this["aDataGridRows"][iRowIndex]["getSegments"](),
		oSegment = aSegmentsOfRow[iSelectionColumnIndex],
		oUCFSegment = oSegment["getUCFInstance"](),
		oSelectionRange = oUCFSegment["oGetSelectionRange"]();

	oSelectionRange["yEnd"] += iIndexDelta;
	if (oSelectionRange["xEnd"] < 0 || oSelectionRange["yEnd"] < 0) return;
	oUCFSegment["clearModelSelectionRanges"](false);
	oUCFSegment["setSelectionRange"](oSelectionRange, false);
	oUCFSegment["addModelSelectionRange"](oSelectionRange, 2, true);

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["rowScrollToPosition"] = 0; };

/**
 * Clear the marked SelectScroll Intervall Calls
 * @param {object} oSelectScrollIntervalId SelectScrollIntervalIds.
 * @param {object} oSelectScrollIntervalAction SelectScrollIntervalActions.
 */
UCF_DataGrid["prototype"]["clearIntervalCalls"] = function (oSelectScrollIntervalId, oSelectScrollIntervalAction) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["clearIntervalCalls"]++; }; 

	if (oSelectScrollIntervalAction["xInc"] == "clear") UCF_JsUtil["clearIntervalCall"](oSelectScrollIntervalId["xInc"]);
	if (oSelectScrollIntervalAction["xDec"] == "clear") UCF_JsUtil["clearIntervalCall"](oSelectScrollIntervalId["xDec"]);
	if (oSelectScrollIntervalAction["yInc"] == "clear") UCF_JsUtil["clearIntervalCall"](oSelectScrollIntervalId["yInc"]);
	if (oSelectScrollIntervalAction["yDec"] == "clear") UCF_JsUtil["clearIntervalCall"](oSelectScrollIntervalId["yDec"]);

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["clearIntervalCalls"] = 0; };

//Focus Handling
/**
 * Sets the binding context that currently has the focus.
 * @param {UCF_BindingContext} The binding context to set.
 *
 * @private
 */
UCF_DataGrid["prototype"]["setFocusInfos"] = function (iX, iY, oSegment) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["setFocusInfos"]++; }; 
	this["iFocusCellX"] = iX;
	this["iFocusCellY"] = iY;
	this["oFocusSegment"] = oSegment;
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["setFocusInfos"] = 0; };

/**
 * @see UCF_Control
 */
UCF_DataGrid["prototype"]["collectFocusInfo"] = function (oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["collectFocusInfo"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "DataGrid.js(1121): collectFocusInfo"); };
	var sId = "";
	oFocusInfo["setApplyControl"](this);
	oFocusInfo["addParam"]("iX", this["iFocusCellX"]);
	oFocusInfo["addParam"]("iY", this["iFocusCellY"]);
	if (this["oFocusSegment"]) { sId = this["oFocusSegment"]["sId"]; }
	oFocusInfo["addParam"]("sSegmentId", sId);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["collectFocusInfo"] = 0; };

/**
 * @see UCF_Control
 */
UCF_DataGrid["prototype"]["applyFocusInfo"] = function (oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["applyFocusInfo"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "DataGrid.js(1135): applyFocusInfo"); };

	if (oFocusInfo) {
		var iX = oFocusInfo["oGetParam"]("iX"),
			iY = oFocusInfo["oGetParam"]("iY"),
			sSegmentId = oFocusInfo["oGetParam"]("sSegmentId");
		if (sSegmentId) {
			var oSegment = this["oLS"]["oControlFactory"]["oGetControlById"](sSegmentId);
			if (oSegment) {
				//				in IE9/IE10 editable fields get focused but are still not editable since no cursorPos or selection seems to be defined
				//				IE11 chrome firefox working fine --- therefore call applyFocusInfo instead of focus method
				//				this.focusCell(iX,iY,oSegment);
				var oCell = this["getCell"](iX, iY, oSegment, true);
				if (oCell) {
					if (oCell["getClientControl"]() && oCell["getClientControl"]()["getContent"]() && oCell["getClientControl"]()["getContent"]()["getUCFInstance"]()) {
						oCell["getClientControl"]()["getContent"]()["getUCFInstance"]()["applyFocusInfo"](oFocusInfo);
					}
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["applyFocusInfo"] = 0; };

UCF_DataGrid["prototype"]["onlsskipforward"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsskipforward"]++; }; 
	if (!this["focusNextControl"]()) {
		document["body"]["focus"]();
		return;
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsskipforward"] = 0; };

UCF_DataGrid["prototype"]["onlsskipback"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsskipback"]++; }; 
	if (!this["focusPreviousControl"]()) {
		document["body"]["focus"]();
		return;
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsskipback"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_DataGrid["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onmouseover"]++; }; 

	var oDomRef = null;
	var i;
	var aVSplitterRefs = null;
	var aHSplitterRefs = null;

	if (oBrowserEvent["oSource"]["getAttribute"]('id') &&	oBrowserEvent["oSource"]["getAttribute"]('id')["indexOf"]('-verticalSplitter') !== -1) {
		aVSplitterRefs = UCF_DomUtil["querySelectorAll"]('.lsDGVertSplitterTdResize', this["oDomRef"]);
		for (i = 0; i < aVSplitterRefs["length"]; i++) {
			oDomRef = aVSplitterRefs[i];
			if (!UCF_DomUtil["bHasClass"](oDomRef, 'lsDragDrop--decorator-line')) UCF_DomUtil["addClass"](oDomRef, 'lsDragDrop--decorator-line');
		}
	}
	if (oBrowserEvent["oSource"]["getAttribute"]('id') &&	oBrowserEvent["oSource"]["getAttribute"]('id')["indexOf"]('-horizontalSplitter') !== -1) {
		aHSplitterRefs = UCF_DomUtil["querySelectorAll"]('.lsDGHorSplitterTdResize', this["oDomRef"]);
		for (i = 0; i < aHSplitterRefs["length"]; i++) {
			oDomRef = aHSplitterRefs[i];
			if (!UCF_DomUtil["bHasClass"](oDomRef, 'lsDragDrop--decorator-line')) UCF_DomUtil["addClass"](oDomRef, 'lsDragDrop--decorator-line');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onmouseover"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_DataGrid["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onmouseout"]++; }; 

	var oDomRef = null;
	var i;
	var aVSplitterRefs = null;
	var aHSplitterRefs = null;

	if (oBrowserEvent["oSource"]["getAttribute"]('id') &&	oBrowserEvent["oSource"]["getAttribute"]('id')["indexOf"]('-verticalSplitter') !== -1) {
		aVSplitterRefs = UCF_DomUtil["querySelectorAll"]('.lsDGVertSplitterTdResize', this["oDomRef"]);
		for (i = 0; i < aVSplitterRefs["length"]; i++) {
			oDomRef = aVSplitterRefs[i];
			if (UCF_DomUtil["bHasClass"](oDomRef, 'lsDragDrop--decorator-line')) UCF_DomUtil["removeClass"](oDomRef, 'lsDragDrop--decorator-line');
		}
	}
	if (oBrowserEvent["oSource"]["getAttribute"]('id') &&	oBrowserEvent["oSource"]["getAttribute"]('id')["indexOf"]('-horizontalSplitter') !== -1) {
		aHSplitterRefs = UCF_DomUtil["querySelectorAll"]('.lsDGHorSplitterTdResize', this["oDomRef"]);
		for (i = 0; i < aHSplitterRefs["length"]; i++) {
			oDomRef = aHSplitterRefs[i];
			if (UCF_DomUtil["bHasClass"](oDomRef, 'lsDragDrop--decorator-line')) UCF_DomUtil["removeClass"](oDomRef, 'lsDragDrop--decorator-line');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onmouseout"] = 0; };

UCF_DataGrid["prototype"]["onlsfocus"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsfocus"]++; }; 

	var oSource = oBrowserEvent["oGetSource"](),
		oCellContext = null,
		bCancel = false;
	if (oSource["getAttribute"]("tp") === "START_FROMOUTSIDE" || oSource["getAttribute"]("tp") === "AFTERHEADER_FROMOUTSIDE") {
		//scroll to the first cell in the first segment
		oCellContext = this["getFirstCellContext"]();
	} else if (oSource["getAttribute"]("tp") === "END_FROMOUTSIDE") {
		//scroll to the last cell in the last segment and focus
		oCellContext = this["getLastCellContext"]();
	} else if (oSource["getAttribute"]("tp") === "END_FROMINSIDE") {
		if (!this["focusNextControl"]()) {
			document["body"]["focus"]();
			return;
		}
		bCancel = true;
	} else if (oSource["getAttribute"]("tp") === "START_FROMINSIDE" || oSource["getAttribute"]("tp") === "AFTERHEADER_FROMINSIDE") {
		if (!this["focusPreviousControl"]()) {
			document["body"]["focus"]();
			return;
		}
		bCancel = true;
	}

	if (oCellContext) {
		this["focusCell"](oCellContext["x"], oCellContext["y"], oCellContext["s"]);
		bCancel = true;
	}
	if (bCancel) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}

	// focus visualization
	if (this["oFocusedCell"] && this["oFocusedCell"]["getClientControl"]()) {
		this["oFocusedCell"]["getClientControl"]()["setFocused"](false);
	}
	//get the cell
	while (oSource && oSource["getAttribute"]) {
		if (oSource["getAttribute"]("ct") == "DGSC") {
			break;
		}
		oSource = oSource["parentNode"];
	}
	if (oSource && oSource["getAttribute"]) {
		var oCell = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSource, false);
		oCell["getClientControl"]()["setFocused"](true);
		this["oFocusedCell"] = oCell;
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsfocus"] = 0; };

UCF_DataGrid["prototype"]["onlsblur"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsblur"]++; }; 

	// focus visualization
	if (this["oFocusedCell"] && this["oFocusedCell"]["getClientControl"]()) {
		this["oFocusedCell"]["getClientControl"]()["setFocused"](false);
		if (oBrowserEvent["bIsTouchInteraction"]()) {
			var bIsHeaderCell = (this["oFocusedCell"]["getClientControl"]()["_sRowType"] === "HEADERROW" || this["oFocusedCell"]["getClientControl"]()["_sColumnType"] == "HEADERCOLUMN");
			if (bIsHeaderCell) {
				this["oFocusedCell"]["removeHCTouchLayer"]();
			}
		}
	}
	this["oFocusedCell"] = null;
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsblur"] = 0; };

/**
 * onLayersVisible
 */
UCF_DataGrid["prototype"]["onLayersVisible"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onLayersVisible"]++; }; 
	this["bLayersVisible"] = true;
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onLayersVisible"] = 0; };

/**
 * onLayersHidden
 */
UCF_DataGrid["prototype"]["onLayersHidden"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onLayersHidden"]++; }; 
	this["bLayersVisible"] = false;
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onLayersHidden"] = 0; };

/* eslint-disable complexity */
/**
 * Handles the key down event on a cell.
 * If the edit field is in navigation mode events for arrow keys are not bubbled.
 */
UCF_DataGrid["prototype"]["onkeydown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onkeydown"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataGrid.js(1321): onkeydown"); };

	var iKey = oBrowserEvent["iKeyCode"](),
		bCtrl = oBrowserEvent["bCtrl"](),
		bShift = oBrowserEvent["bShift"](),
		bAlt = oBrowserEvent["bAlt"](),
		bCancel = false,
		oControl = oBrowserEvent["oGetSourceControl"](),
		oToolbar = this["oGetFirstChildControl"](),
		oContent = null;

	while (!UCF_JsUtil["bInstanceOf"](oControl, "UCF_DataGridSegmentCell")) {
		if (oControl == this) return;
		oControl = oControl["oGetParent"]();
	}
	var oCellContext = null,
		oCell = oControl;

	if (oCell["getClientControl"]()["getContent"]() && oCell["getClientControl"]()["getContent"]()["getUCFInstance"]()) {
		oContent = oCell["getClientControl"]()["getContent"]()["getUCFInstance"]();
		if (oContent["bNavigation"]) {
			if (iKey == UCF_KeyCodes["ARROW_LEFT"] || iKey == UCF_KeyCodes["ARROW_RIGHT"] || iKey == UCF_KeyCodes["HOME"] || iKey == UCF_KeyCodes["END"]) {
				oBrowserEvent["cancelBubble"]();
				return;
			}
		}
	}

	if (iKey == UCF_KeyCodes["TAB"] && !bShift) {
		//tab forward
		oCellContext = this["getSurroundingCellContext"](oCell, 1, 0);
		if (!oCellContext) {
			oCellContext = this["getNextCellContext"](oCell);
			if (!oCellContext) {
				if (window["UCF_System"]["bIs508"]) {
					oBrowserEvent["cancel"]();
					oBrowserEvent["cancelBubble"]();
					var oDGEndFromOutSide508Span = this["oDomRef"]["childNodes"][5];
					if (oDGEndFromOutSide508Span) {
						oDGEndFromOutSide508Span["focus"]();
						return;
					}
				} else {
					if (!this["focusNextControl"]()) {
						document["body"]["focus"]();
						return;
					}
				}
			}
		}
	} else if (iKey == UCF_KeyCodes["TAB"] && bShift) {
		//tab back
		oCellContext = this["getSurroundingCellContext"](oCell, -1, 0);
		if (!oCellContext) {
			oCellContext = this["getPreviousCellContext"](oCell);
			if (!oCellContext) {
				// Toolbar embedded -> focus last item of Toolbar
				if (oToolbar && UCF_JsUtil["bInstanceOf"](oToolbar, "UCF_Toolbar_standards")) {
					if (!oCell["focusPreviousControl"]()) {
						document["body"]["focus"]();
						return;
					}
				}
				else {
					if (window["UCF_System"]["bIs508"]) {
						oBrowserEvent["cancel"]();
						oBrowserEvent["cancelBubble"]();
						this["oDomRef"]["focus"]();
						return;
					} else {
						if (!this["focusPreviousControl"]()) {
							document["body"]["focus"]();
							return;
						}
					}
				}
			}
		}
	} else if (iKey == UCF_KeyCodes["ARROW_UP"] && !bShift && !bCtrl && !bAlt) {
		//prev row same column
		oCellContext = this["getSurroundingCellContext"](oCell, 0, -1);
	} else if (iKey == UCF_KeyCodes["ARROW_DOWN"] && !bShift && !bCtrl && !bAlt) {
		//next row same column
		oCellContext = this["getSurroundingCellContext"](oCell, 0, 1);
	} else if (iKey == UCF_KeyCodes["ARROW_LEFT"] && !bShift && bCtrl && !bAlt) {
		//prev cell
		if (window["UCF_System"]["bIsRTL"]) {
			//last cell same row
			oCellContext = this["getLastColContext"](oCell);
		} else {
			//first cell same row
			oCellContext = this["getFirstColContext"](oCell);
		}
	} else if (iKey == UCF_KeyCodes["ARROW_RIGHT"] && !bShift && bCtrl && !bAlt) {
		//next cell
		if (window["UCF_System"]["bIsRTL"]) {
			//first cell same row
			oCellContext = this["getFirstColContext"](oCell);
		} else {
			//last cell same row
			oCellContext = this["getLastColContext"](oCell);
		}
	} else if (iKey == UCF_KeyCodes["ARROW_UP"] && !bShift && bCtrl && !bAlt) {
		//first row same column
		oCellContext = this["getFirstRowContext"](oCell);
	} else if (iKey == UCF_KeyCodes["ARROW_DOWN"] && !bShift && bCtrl && !bAlt) {
		//last cell same column
		oCellContext = this["getLastRowContext"](oCell);
	} else if (iKey == UCF_KeyCodes["HOME"] && !bShift && !bCtrl && !bAlt) {
		//first cell same row
		oCellContext = this["getFirstColContext"](oCell);
	} else if (iKey == UCF_KeyCodes["END"] && !bShift && !bCtrl && !bAlt) {
		//last cell same row
		oCellContext = this["getLastColContext"](oCell);
	} else if (iKey == UCF_KeyCodes["HOME"] && !bShift && bCtrl && !bAlt) {
		//first row same column
		oCellContext = this["getFirstRowContext"](oCell);
	} else if (iKey == UCF_KeyCodes["END"] && !bShift && bCtrl && !bAlt) {
		//last row same column
		oCellContext = this["getLastRowContext"](oCell);
	} else if (iKey == UCF_KeyCodes["PAGE_UP"] && !bShift && !bCtrl && !bAlt) {
		oCellContext = this["getPreviousPageColContext"](oCell);
	} else if (iKey == UCF_KeyCodes["PAGE_DOWN"] && !bShift && !bCtrl && !bAlt) {
		oCellContext = this["getNextPageColContext"](oCell);
	} else if (iKey == UCF_KeyCodes["PAGE_UP"] && !bShift && bCtrl && !bAlt) {
		oCellContext = this["getPreviousPageRowContext"](oCell);
	} else if (iKey == UCF_KeyCodes["PAGE_DOWN"] && !bShift && bCtrl && !bAlt) {
		oCellContext = this["getNextPageRowContext"](oCell);
	} else if (iKey == UCF_KeyCodes["SPACE"]) {
		//trigger selection via keyboard
		oCell["triggerSelection"](oBrowserEvent["bCtrl"]());
	} else if ((iKey == UCF_KeyCodes["NUMPAD_PLUS"] && oCell["getClientControl"]()["getHierarchyState"]()["indexOf"]("COL") != -1) || (iKey == UCF_KeyCodes["NUMPAD_MINUS"] && oCell["getClientControl"]()["getHierarchyState"]()["indexOf"]("EXP") != -1)) {
		//trigger hierarchy state change
		oCell["triggerHierarchyStateChange"]();
	}
	if (oCellContext) {
		this["focusCell"](oCellContext["x"], oCellContext["y"], oCellContext["s"]);
		bCancel = true;
	}
	if (bCancel) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onkeydown"] = 0; };
/* eslint-enable complexity */

UCF_DataGrid["prototype"]["onlsleft"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsleft"]++; }; 
	//prev cell
	var oControl = oBrowserEvent["oGetSourceControl"]();

	while (!UCF_JsUtil["bInstanceOf"](oControl, "UCF_DataGridSegmentCell")) {
		if (oControl == this) return;
		oControl = oControl["oGetParent"]();
	}
	var oCellContext = null;
	var oCell = oControl;
	var bCancel = false;

	if (window["UCF_System"]["bIsRTL"]) {
		oCellContext = this["getSurroundingCellContext"](oCell, 1, 0);
	} else {
		oCellContext = this["getSurroundingCellContext"](oCell, -1, 0);
	}

	if (oCellContext) {
		this["focusCell"](oCellContext["x"], oCellContext["y"], oCellContext["s"]);
		bCancel = true;
	}
	if (bCancel) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsleft"] = 0; };

UCF_DataGrid["prototype"]["onlsright"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsright"]++; }; 
	//next cell
	var oControl = oBrowserEvent["oGetSourceControl"]();

	while (!UCF_JsUtil["bInstanceOf"](oControl, "UCF_DataGridSegmentCell")) {
		if (oControl == this) return;
		oControl = oControl["oGetParent"]();
	}
	var oCellContext = null;
	var oCell = oControl;
	var bCancel = false;

	if (window["UCF_System"]["bIsRTL"]) {
		oCellContext = this["getSurroundingCellContext"](oCell, -1, 0);
	} else {
		oCellContext = this["getSurroundingCellContext"](oCell, 1, 0);
	}

	if (oCellContext) {
		this["focusCell"](oCellContext["x"], oCellContext["y"], oCellContext["s"]);
		bCancel = true;
	}
	if (bCancel) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsright"] = 0; };

UCF_DataGrid["prototype"]["onlsmousewheel"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsmousewheel"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataGrid.js(1525): onlsmousewheel"); };
	var oSource = oBrowserEvent["oGetSource"]();
	//find the segment
	while (oSource) {
		if (oSource["getAttribute"]("ct") == "DGS") {
			break;
		}
		if (oSource == this["oDomRef"]) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			return;
		}
		oSource = oSource["parentNode"];
	}

	if (oSource) { //the source is the segment
		var iRowIndex = this["getSegmentRowIndex"](this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSource, false)),
			oUCFScrollBar = this["aRowScrollbars"][iRowIndex];
		if (oUCFScrollBar) {
			oUCFScrollBar["onlsmousewheel"](oBrowserEvent);
		}
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsmousewheel"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_DataGrid["prototype"]["onlstouchstart"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlstouchstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataGrid.js(1560): onlstouchstart"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var oThead = UCF_DomUtil["$"](this["sId"] + "-thead");

	//touchStart at HCTouchLayer
	if (oSource && oSource["getAttribute"]("id") && oSource["getAttribute"]("id")["indexOf"]("HCTouchLayer") != -1) return;
	//touchStart at header
	if (oThead && oSource && UCF_DomUtil["bContains"](oThead, oSource)) return;

	//find the segment
	while (oSource) {
		if (oSource["getAttribute"]("ct") == "DGS") {
			break;
		}
		if (oSource == this["oDomRef"]) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			return;
		}
		oSource = oSource["parentNode"];
	}

	this["bTouchForSelect"] = true;

	if (oSource) { //the source is the segment
		var oUCFSegment = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSource, false);
		var iRowIndex = this["getSegmentRowIndex"](oUCFSegment);
		var iColumnIndex = oUCFSegment["iGetSegmentColumnIndex"]();
		var oUCFRowScrollBar = this["aRowScrollbars"][iRowIndex];
		var oUCFColumnScrollBar = this["aColumnScrollbars"][iColumnIndex];
		if (oUCFRowScrollBar) oUCFRowScrollBar["onlstouchstart"](oBrowserEvent);
		if (oUCFColumnScrollBar) oUCFColumnScrollBar["onlstouchstart"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlstouchstart"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_DataGrid["prototype"]["onlstouchmove"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlstouchmove"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataGrid.js(1605): onlstouchmove"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var oThead = UCF_DomUtil["$"](this["sId"] + "-thead");

	//touchMove at HCTouchLayer
	if (oSource["getAttribute"]("id") && oSource["getAttribute"]("id")["indexOf"]("HCTouchLayer") != -1) return;
	//touchStart at header
	if (oThead && oSource && UCF_DomUtil["bContains"](oThead, oSource)) return;

	//find the segment
	while (oSource) {
		if (oSource["getAttribute"]("ct") == "DGS") {
			break;
		}
		if (oSource == this["oDomRef"]) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			return;
		}
		oSource = oSource["parentNode"];
	}

	this["bTouchForSelect"] = false;

	if (oSource) { //the source is the segment
		var oUCFSegment = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSource, false);
		var iRowIndex = this["getSegmentRowIndex"](oUCFSegment);
		var iColumnIndex = oUCFSegment["iGetSegmentColumnIndex"]();
		var oUCFRowScrollBar = this["aRowScrollbars"][iRowIndex];
		var oUCFColumnScrollBar = this["aColumnScrollbars"][iColumnIndex];
		if (oUCFRowScrollBar) oUCFRowScrollBar["onlstouchmove"](oBrowserEvent);
		if (oUCFColumnScrollBar) oUCFColumnScrollBar["onlstouchmove"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlstouchmove"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_DataGrid["prototype"]["onlstouchend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlstouchend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataGrid.js(1650): onlstouchend"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var oThead = UCF_DomUtil["$"](this["sId"] + "-thead");

	//touchStart at HCTouchLayer
	if (oSource["getAttribute"]("id") && oSource["getAttribute"]("id")["indexOf"]("HCTouchLayer") != -1) return;
	//touchStart at header
	if (oThead && oSource && UCF_DomUtil["bContains"](oThead, oSource)) return;

	//find the segment
	while (oSource) {
		if (oSource["getAttribute"]("ct") == "DGS") {
			break;
		}
		if (oSource == this["oDomRef"]) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			return;
		}
		oSource = oSource["parentNode"];
	}

	if (oSource) { //the source is the segment
		var oUCFSegment = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSource, false);
		var iRowIndex = this["getSegmentRowIndex"](oUCFSegment);
		var iColumnIndex = oUCFSegment["iGetSegmentColumnIndex"]();
		var oUCFRowScrollBar = this["aRowScrollbars"][iRowIndex];
		var oUCFColumnScrollBar = this["aColumnScrollbars"][iColumnIndex];

		if (this["bTouchForSelect"]) {
			// This let the emulated click events un-canceled. A selection is possible
			// This happens only when no scolling by touchmove has been triggred
			if (oUCFRowScrollBar) oUCFRowScrollBar["stopInteraction"]();
			if (oUCFColumnScrollBar) oUCFColumnScrollBar["stopInteraction"]();
			this["bTouchForSelect"] = false;
		} else {
			if (oUCFRowScrollBar) oUCFRowScrollBar["onlstouchend"](oBrowserEvent);
			if (oUCFColumnScrollBar) oUCFColumnScrollBar["onlstouchend"](oBrowserEvent);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlstouchend"] = 0; };

UCF_DataGrid["prototype"]["getSurroundingCellContext"] = function (oCell, iShiftX, iShiftY) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getSurroundingCellContext"]++; }; 
	var iRow = oCell["getY"](),
		iCol = oCell["getX"](),
		oMergeData = oCell["getClientControl"]()["oMergeData"],
		oSegment = oCell["oGetParent"]();
	if (oMergeData) {
		// take the focus position for further navigation in order not to loose the X/Y postion in merged cells
		if (typeof (this["iFocusCellX"]) == "number" && iShiftY != 0) {
			iCol = this["iFocusCellX"];
		}
		if (typeof (this["iFocusCellY"]) == "number" && iShiftX != 0) {
			iRow = this["iFocusCellY"];
		}
	}
	if (typeof (iCol) == "number") {
		if (oMergeData && (iShiftX > 0)) {
			var iMergeShiftX = Math["max"](iShiftX, (oMergeData["to_x"] - oMergeData["from_x"] + 1));
			iCol += iMergeShiftX;
		} else {
			iCol += iShiftX;
		}
	}
	if (typeof (iRow) == "number") {
		if (oMergeData && (iShiftY > 0)) {
			var iMergeShiftY = Math["max"](iShiftY, (oMergeData["to_y"] - oMergeData["from_y"] + 1));
			iRow += iMergeShiftY;
		} else {
			iRow += iShiftY;
		}
	}
	if (iCol < oSegment["iSegmentColumnIndexOffset"]) {
		//left one segment
		while (oSegment["iSegmentColumnIndex"] > 0) {
			oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment)][oSegment["iSegmentColumnIndex"] - 1]["getUCFInstance"]();
			if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
				return { "x": (oSegment["oDataGridColumn"]["getSegmentColumnCount"]() + oSegment["oDataGridColumn"]["getSegmentColumnIndexOffset"]() - 1), "y": iRow, "s": oSegment };
			}
		}
		return null;
	} else if (iCol > oSegment["oDataGridColumn"]["getSegmentColumnCount"]() + oSegment["oDataGridColumn"]["getSegmentColumnIndexOffset"]() - 1) {
		//right one segment
		while (oSegment["iSegmentColumnIndex"] < this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment)]["length"] - 1) {
			oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment)][oSegment["iSegmentColumnIndex"] + 1]["getUCFInstance"]();
			if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
				return { "x": oSegment["oDataGridColumn"]["getSegmentColumnIndexOffset"](), "y": iRow, "s": oSegment };
			}
		}
		return null;
	}
	if (iRow < oSegment["iSegmentRowIndexOffset"]) {
		//up one segment
		while (this["getSegmentRowIndex"](oSegment) > 0) {
			oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment) - 1][oSegment["iSegmentColumnIndex"]]["getUCFInstance"]();
			if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
				return { "x": iCol, "y": (oSegment["oDataGridRow"]["getSegmentRowCount"]() + oSegment["oDataGridRow"]["getSegmentRowIndexOffset"]() - 1), "s": oSegment };
			}
		}
		return null;
	} else if (iRow > oSegment["oDataGridRow"]["getSegmentRowCount"]() + oSegment["oDataGridRow"]["getSegmentRowIndexOffset"]() - 1) {
		//down one segment
		while (this["getSegmentRowIndex"](oSegment) < this["aSegmentMatrix"]["length"] - 1) {
			oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment) + 1][oSegment["iSegmentColumnIndex"]]["getUCFInstance"]();
			if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
				return { "x": iCol, "y": oSegment["oDataGridRow"]["getSegmentRowIndexOffset"](), "s": oSegment };
			}
		}
		return null;
	}
	return { "x": iCol, "y": iRow, "s": oSegment };
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getSurroundingCellContext"] = 0; };

UCF_DataGrid["prototype"]["focusCell"] = function (iX, iY, oSegment, bCheckPosition) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["focusCell"]++; }; 

	var oCell = this["getCell"](iX, iY, oSegment, true),
		bHandled = false,
		sCellPositonInSegment = "INSIDE";

	if (oCell && bCheckPosition) {
		sCellPositonInSegment = oCell["sGetPosition"]();
	}
	// do not focus cells which are not entirely in the segment to avoid scrollIntoView directly after scrolling
	if (oCell && sCellPositonInSegment == "INSIDE") {
		this["focusCellContent"](oCell);
		bHandled = true;
	}
	// when actively triggering cell focus clear delayed focus call triggered via focusAfterUpdate to avoid overwriting
	if (bHandled && this["iFocusTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["iFocusTimer"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["focusCell"] = 0; };

UCF_DataGrid["prototype"]["selectCell"] = function (iX, iY, oSegment) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["selectCell"]++; }; 
	var oCell = this["getCell"](iX, iY, oSegment, true);
	if (oCell) {
		oCell["triggerSelection"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["selectCell"] = 0; };

UCF_DataGrid["prototype"]["executePrimarySelection"] = function (oCell, oSegment, oSelectionRange) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["executePrimarySelection"]++; }; 

	if (this["oPrimarySelectedCell"]) {
		var oPrimarySelectionSegment = this["oPrimarySelectedCell"]["getClientControl"]()["getParent"]()["getUCFInstance"]();
		oPrimarySelectionSegment["cancelModelSelection"](1);
	}
	this["oPrimarySelectedCell"] = oCell;
	oSegment["addModelSelectionRange"](oSelectionRange, 1, false);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["executePrimarySelection"] = 0; };

UCF_DataGrid["prototype"]["executeSelection"] = function (oCell, iSelectionColumnIndex, iSelectionRowIndex, iSelected, bMultiple) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["executeSelection"]++; }; 

	var iX = oCell["getX"](),
		iY = oCell["getY"](),
		oMergeData = oCell["getClientControl"]()["oMergeData"],
		bHeaderRow = (oCell["getClientControl"]()["_sRowType"] == "HEADERROW"),
		bHeaderColumn = (oCell["getClientControl"]()["_sColumnType"] == "HEADERCOLUMN"),
		bFocusCell = false,
		oSelectionRange = null,
		oSelectionRangeOtherSegments = null,
		oSelectionRangeCurrentSegment = null;

	if (bHeaderRow) {
		if (oMergeData && (oMergeData["from_x"] != oMergeData["to_x"])) {
			oSelectionRangeOtherSegments = { "xStart": oMergeData["from_x"], "yStart": 0, "xEnd": oMergeData["to_x"], "yEnd": "*" };
			oSelectionRangeCurrentSegment = { "xStart": oMergeData["from_x"], "yStart": iY, "xEnd": oMergeData["to_x"], "yEnd": "*" };
		} else {
			oSelectionRangeOtherSegments = { "xStart": iX, "yStart": 0, "xEnd": iX, "yEnd": "*" };
			oSelectionRangeCurrentSegment = { "xStart": iX, "yStart": iY, "xEnd": iX, "yEnd": "*" };
		}
	}
	if (bHeaderColumn) {
		if (oMergeData && (oMergeData["from_y"] != oMergeData["to_y"])) {
			oSelectionRangeOtherSegments = { "xStart": 0, "yStart": oMergeData["from_y"], "xEnd": "*", "yEnd": oMergeData["to_y"] };
			oSelectionRangeCurrentSegment = { "xStart": iX, "yStart": oMergeData["from_y"], "xEnd": "*", "yEnd": oMergeData["to_y"] };
		} else {
			oSelectionRangeOtherSegments = { "xStart": 0, "yStart": iY, "xEnd": "*", "yEnd": iY };
			oSelectionRangeCurrentSegment = { "xStart": iX, "yStart": iY, "xEnd": "*", "yEnd": iY };
		}
	}
	if (!bHeaderRow && !bHeaderColumn) {
		oSelectionRangeOtherSegments = { "xStart": iX, "yStart": iY, "xEnd": iX, "yEnd": iY };
		oSelectionRangeCurrentSegment = { "xStart": iX, "yStart": iY, "xEnd": iX, "yEnd": iY };
	}

	for (var row = 0; row < this["aDataGridRows"]["length"]; row++) {
		for (var col = 0; col < this["aDataGridColumns"]["length"]; col++) {
			if (!bMultiple) {
				this["aSegmentMatrix"][row][col]["getUCFInstance"]()["clearModelSelectionRanges"](true);
			}
			// click into arbitrary cell (not headerRow and not headerColumn)
			if (!bHeaderRow && !bHeaderColumn) {
				oSelectionRange = oSelectionRangeCurrentSegment;
				if (row == iSelectionRowIndex && col == iSelectionColumnIndex) {
					this["aSegmentMatrix"][row][col]["getUCFInstance"]()["setSelectionRange"](oSelectionRange, true);
					this["aSegmentMatrix"][row][col]["getUCFInstance"]()["addModelSelectionRange"](oSelectionRange, iSelected, false);
					this["aSegmentMatrix"][row][col]["getUCFInstance"]()["commitModelSelectionRanges"]();
					this["setFocusInfos"](iX, iY, this["aSegmentMatrix"][row][col]["getUCFInstance"]());
				}
			}
			// click into headerColumn -> entire row gets selected
			if (bHeaderColumn && !bHeaderRow) {
				if (col == iSelectionColumnIndex) {
					oSelectionRange = oSelectionRangeCurrentSegment;
					bFocusCell = true;
				} else {
					oSelectionRange = oSelectionRangeOtherSegments;
					bFocusCell = false;
				}
				if (row == iSelectionRowIndex) {
					this["aSegmentMatrix"][row][col]["getUCFInstance"]()["setSelectionRange"](oSelectionRange, true);
					this["aSegmentMatrix"][row][col]["getUCFInstance"]()["addModelSelectionRange"](oSelectionRange, iSelected, false);
					this["aSegmentMatrix"][row][col]["getUCFInstance"]()["commitModelSelectionRanges"]();
					if (bFocusCell) this["focusCell"](iX, iY, this["aSegmentMatrix"][row][col]["getUCFInstance"]());
				}
			}
			// click into headerRow -> entire column gets selected
			if (!bHeaderColumn && bHeaderRow) {
				if (row == iSelectionRowIndex) {
					oSelectionRange = oSelectionRangeCurrentSegment;
					bFocusCell = true;
				} else {
					oSelectionRange = oSelectionRangeOtherSegments;
					bFocusCell = false;
				}
				if (col == iSelectionColumnIndex) {
					this["aSegmentMatrix"][row][col]["getUCFInstance"]()["setSelectionRange"](oSelectionRange, true);
					this["aSegmentMatrix"][row][col]["getUCFInstance"]()["addModelSelectionRange"](oSelectionRange, iSelected, false);
					this["aSegmentMatrix"][row][col]["getUCFInstance"]()["commitModelSelectionRanges"]();
					if (bFocusCell) this["focusCell"](iX, iY, this["aSegmentMatrix"][row][col]["getUCFInstance"]());
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["executeSelection"] = 0; };

UCF_DataGrid["prototype"]["getCell"] = function (iX, iY, oSegment, bFocus) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getCell"]++; }; 

	var iCurrentFocusX = this["iFocusCellX"],
		iCurrentFocusY = this["iFocusCellY"],
		iCurrentFocusSegment = this["oFocusSegment"];

	if (bFocus) {
		this["setFocusInfos"](iX, iY, oSegment);
	}
	if (iX == -1 || iY == -1 || !oSegment || !oSegment["getClientControl"]() || (oSegment["getClientControl"]()["getCells"]()["length"] == 0)) return null;

	var iSegmentColumnCount = oSegment["oDataGridColumn"]["getSegmentColumnCount"](),
		iSegmentRowCount = oSegment["oDataGridRow"]["getSegmentRowCount"](),
		iSegmentColumnIndexOffset = oSegment["oDataGridColumn"]["getSegmentColumnIndexOffset"](),
		iSegmentRowIndexOffset = oSegment["oDataGridRow"]["getSegmentRowIndexOffset"]();

	if (iCurrentFocusSegment != oSegment) {
		if (iX == iSegmentColumnIndexOffset || iX == iSegmentColumnCount + iSegmentColumnIndexOffset - 1) {
			iCurrentFocusX = oSegment["oDataGridColumn"]["getFirstVisibleSegmentColumnIndex"]() + iSegmentColumnIndexOffset;
		}
		if (iY == iSegmentRowIndexOffset || iY == iSegmentRowCount + iSegmentRowIndexOffset - 1) {
			iCurrentFocusY = oSegment["oDataGridRow"]["getFirstVisibleSegmentRowIndex"]() + iSegmentRowIndexOffset;
		}
	}

	var sId = null;
	if (oSegment["getClientControl"]()) {
		sId = oSegment["getClientControl"]()["getCellId"](iX, iY);
	}
	if (UCF_DomUtil["$"](sId)) {
		var oCell = this["oLS"]["oControlFactory"]["oGetControlById"](sId);
		if (oCell) {
			var oMergeData = oCell["getClientControl"]()["oMergeData"];
			if (oMergeData) {
				var bFound = false;
				for (var x = oMergeData["from_x"]; x < oMergeData["to_x"] + 1; x++) {
					for (var y = oMergeData["from_y"]; y < oMergeData["to_y"] + 1; y++) {
						var sTopLeftCellId = oSegment["getClientControl"]()["getCellId"](x, y);
						if (sTopLeftCellId && UCF_DomUtil["$"](sTopLeftCellId)) {
							var oTopLeftCell = this["oLS"]["oControlFactory"]["oGetControlById"](sTopLeftCellId);
							if (oTopLeftCell) {
								bFound = true;
								break;
							}
						}
					}
					if (bFound) {
						break;
					}
				}
				return oTopLeftCell;
			}
			return oCell;
		}
	} else {
		var iXDeltaDir = (iX - iCurrentFocusX) < 0 ? -1 : 1,
			iYDeltaDir = (iY - iCurrentFocusY) < 0 ? -1 : 1,
			iXDeltaPx = 0,
			iYDeltaPx = 0,
			iXStart = Math["min"](iX, iCurrentFocusX),
			iXEnd = Math["max"](iX, iCurrentFocusX),
			iYStart = Math["min"](iY, iCurrentFocusY),
			iYEnd = Math["max"](iY, iCurrentFocusY);
		for (var i = iXStart; i < iXEnd; i++) {
			iXDeltaPx += oSegment["oDataGridColumn"]["_fGetSegmentColumnWidth"](i);
		}
		for (var j = iYStart; j < iYEnd; j++) {
			iYDeltaPx += oSegment["oDataGridRow"]["_fGetSegmentRowHeight"](j);
		}
		if (iX - iCurrentFocusX != 0 || iCurrentFocusSegment != oSegment) {
			this["columnScrollToPosition"](oSegment["iSegmentColumnIndex"], iXDeltaPx * iXDeltaDir, -1, -1);
		}
		if (iY - iCurrentFocusY != 0 || iCurrentFocusSegment != oSegment) {
			this["rowScrollToPosition"](this["getSegmentRowIndex"](oSegment), iYDeltaPx * iYDeltaDir, -1, -1);
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getCell"] = 0; };

UCF_DataGrid["prototype"]["focusCellContent"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["focusCellContent"]++; }; 
	if (oCell) {
		if (oCell["getClientControl"]()["getContent"]() && oCell["getClientControl"]()["getContent"]()["getUCFInstance"]()) {
			oCell["getClientControl"]()["getContent"]()["getUCFInstance"]()["focus"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["focusCellContent"] = 0; };

UCF_DataGrid["prototype"]["focusAfterUpdate"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["focusAfterUpdate"]++; }; 

	var oFocusSegment = null;
	//do not reapply focus if currently a layer is visible
	if (this["bLayersVisible"]) return;

	// wait until scrollInteraction has been finished to avoid scrollIntoView during scrolling
	if (this["bScrollbarInInteraction"]) {
		this["bFocusUpdateCanceled"] = true;
		return;
	}

	this["bFocusUpdateCanceled"] = false;
	if (this["iFocusTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["iFocusTimer"]);
	}
	// in case of roundtrip with rerendering (not just model update)
	// the UCF instance of DG and DGS are getting invalidated inbetween
	// reapplying the focusInfo when unlocking LS and updating the grid aggregation
	// therefore the UCF segment instance stored in this.oFocusSegment may have to be
	// exchanged with the replaced one having the same Id
	if (this["oFocusSegment"] && !this["oFocusSegment"]["bIsValid"]() && this["oFocusSegment"]["sId"]) {
		oFocusSegment = this["oLS"]["oControlFactory"]["oGetControlById"](this["oFocusSegment"]["sId"]);
		if (oFocusSegment) this["oFocusSegment"] = oFocusSegment;
	}
	this["iFocusTimer"] = UCF_JsUtil["delayedCall"](0, this, "focusCell", [this["iFocusCellX"], this["iFocusCellY"], this["oFocusSegment"], true]);

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["focusAfterUpdate"] = 0; };

UCF_DataGrid["prototype"]["getSegmentRowIndex"] = function (oSegment) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getSegmentRowIndex"]++; }; 
	return this["getClientControl"]()["indexOfAggregation"]("Rows", oSegment["getClientControl"]()["getParent"]());
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getSegmentRowIndex"] = 0; };

UCF_DataGrid["prototype"]["getFirstCellContext"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getFirstCellContext"]++; }; 
	var iSegmentCol = 0;
	var iSegmentRow = 0;
	var oSegment = this["aSegmentMatrix"][iSegmentCol][iSegmentRow];
	while (oSegment["getCells"]()["length"] == 0) {
		iSegmentCol++;
		if (iSegmentCol > this["aSegmentMatrix"][iSegmentRow]["length"] - 1) {
			iSegmentCol = 0;
			iSegmentRow++;
		}
		if (iSegmentRow > this["aSegmentMatrix"]["length"] - 1) {
			return null;

		}
		oSegment = this["aSegmentMatrix"][iSegmentRow][iSegmentCol];
	}
	if (oSegment) {
		oSegment = oSegment["getUCFInstance"]();
		return { "x": oSegment["iSegmentColumnIndexOffset"], "y": oSegment["iSegmentRowIndexOffset"], "s": oSegment };
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getFirstCellContext"] = 0; };

UCF_DataGrid["prototype"]["getLastCellContext"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getLastCellContext"]++; }; 
	var iSegmentCol = 0;
	var iSegmentRow = 0;
	var oSegment = this["aSegmentMatrix"][this["aSegmentMatrix"]["length"] - 1][this["aSegmentMatrix"][this["aSegmentMatrix"]["length"] - 1]["length"] - 1];
	while (oSegment["getCells"]()["length"] == 0) {
		iSegmentCol--;
		if (iSegmentCol == -1) {
			iSegmentCol = this["aSegmentMatrix"][iSegmentRow]["length"] - 1;
			iSegmentRow--;
		}
		if (iSegmentRow == -1) {
			return null;

		}
		oSegment = this["aSegmentMatrix"][iSegmentRow][iSegmentCol];
	}
	if (oSegment) {
		oSegment = oSegment["getUCFInstance"]();
		return { "x": oSegment["oDataGridColumn"]["getSegmentColumnCount"]() - 1 + oSegment["iSegmentColumnIndexOffset"], "y": oSegment["oDataGridRow"]["getSegmentRowCount"]() - 1 + oSegment["iSegmentRowIndexOffset"], "s": oSegment };
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getLastCellContext"] = 0; };

UCF_DataGrid["prototype"]["getNextCellContext"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getNextCellContext"]++; }; 
	var iRow = oCell["getY"]() + 1,
		oMergeData = oCell["getClientControl"]()["oMergeData"],
		oSegment = oCell["oUCFSegment"];

	if (oMergeData) {
		// take the focus position for further navigation in order not to loose the X/Y postion in merged cells
		if (typeof (this["iFocusCellY"]) == "number") {
			iRow = this["iFocusCellY"] + 1;
		}
	}

	if (oSegment["iSegmentColumnIndex"] > 0) {
		oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment)][0]["getUCFInstance"]();
	}
	if (iRow > oSegment["oDataGridRow"]["getSegmentRowCount"]() - 1 + oSegment["iSegmentRowIndexOffset"]) {
		while (this["getSegmentRowIndex"](oSegment) < this["aSegmentMatrix"]["length"] - 1) {
			oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment) + 1][0]["getUCFInstance"]();
			if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
				return { "x": oSegment["iSegmentColumnIndexOffset"], "y": oSegment["iSegmentRowIndexOffset"], "s": oSegment };
			}
		}
		return null;
	}
	return { "x": oSegment["iSegmentColumnIndexOffset"], "y": iRow, "s": oSegment };
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getNextCellContext"] = 0; };

UCF_DataGrid["prototype"]["getPreviousCellContext"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getPreviousCellContext"]++; }; 
	var iRow = oCell["getY"]() - 1,
		oMergeData = oCell["getClientControl"]()["oMergeData"],
		oSegment = oCell["oUCFSegment"],
		iSegmentRowIndex = this["getSegmentRowIndex"](oSegment);

	if (oMergeData) {
		// take the focus position for further navigation in order not to loose the X/Y postion in merged cells
		if (typeof (this["iFocusCellY"]) == "number") {
			iRow = this["iFocusCellY"] - 1;
		}
	}

	if (oSegment["iSegmentColumnIndex"] < this["aSegmentMatrix"][iSegmentRowIndex]["length"] - 1) {
		oSegment = this["aSegmentMatrix"][iSegmentRowIndex][this["aSegmentMatrix"][iSegmentRowIndex]["length"] - 1]["getUCFInstance"]();
	}
	if (iRow < oSegment["iSegmentRowIndexOffset"]) {
		//up one segment
		while (this["getSegmentRowIndex"](oSegment) > 0) {
			oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment) - 1][this["aSegmentMatrix"][iSegmentRowIndex]["length"] - 1]["getUCFInstance"]();
			if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
				return { "x": oSegment["oDataGridColumn"]["getSegmentColumnCount"]() - 1 + oSegment["iSegmentColumnIndexOffset"], "y": oSegment["oDataGridRow"]["getSegmentRowCount"]() - 1 + oSegment["iSegmentRowIndexOffset"], "s": oSegment };
			}
		}
		return null;
	}
	return { "x": oSegment["oDataGridColumn"]["getSegmentColumnCount"]() - 1 + oSegment["iSegmentColumnIndexOffset"], "y": iRow, "s": oSegment };
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getPreviousCellContext"] = 0; };

UCF_DataGrid["prototype"]["getFirstColContext"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getFirstColContext"]++; }; 
	var iRow = oCell["getY"](),
		oSegment = oCell["oUCFSegment"];
	if (oSegment["iSegmentColumnIndex"] > 0) {
		oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment)][0]["getUCFInstance"]();
		if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
			return { "x": oSegment["iSegmentColumnIndexOffset"], "y": iRow, "s": oSegment };
		} else {
			while (oSegment["iSegmentColumnIndex"] < this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment)]["length"]) {
				oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment)][oSegment["iSegmentColumnIndex"] + 1]["getUCFInstance"]();
				if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
					return { "x": oSegment["iSegmentColumnIndexOffset"], "y": iRow, "s": oSegment };
				}
			}
		}
	}
	return { "x": oSegment["iSegmentColumnIndexOffset"], "y": iRow, "s": oSegment };
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getFirstColContext"] = 0; };

UCF_DataGrid["prototype"]["getLastColContext"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getLastColContext"]++; }; 
	var iRow = oCell["getY"](),
		oSegment = oCell["oUCFSegment"],
		iSegmentRowIndex = this["getSegmentRowIndex"](oSegment);
	if (oSegment["iSegmentColumnIndex"] < this["aSegmentMatrix"][iSegmentRowIndex]["length"] - 1) {
		oSegment = this["aSegmentMatrix"][iSegmentRowIndex][this["aSegmentMatrix"][iSegmentRowIndex]["length"] - 1]["getUCFInstance"]();
		if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
			return { "x": oSegment["oDataGridColumn"]["getSegmentColumnCount"]() - 1 + oSegment["iSegmentColumnIndexOffset"], "y": iRow, "s": oSegment };
		} else {
			while (oSegment["iSegmentColumnIndex"] > 0) {
				oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment)][oSegment["iSegmentColumnIndex"] - 11]["getUCFInstance"]();
				if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
					return { "x": oSegment["oDataGridColumn"]["getSegmentColumnCount"]() - 1 + oSegment["iSegmentColumnIndexOffset"], "y": iRow, "s": oSegment };
				}
			}
		}
	}
	return { "x": oSegment["oDataGridColumn"]["getSegmentColumnCount"]() - 1 + oSegment["iSegmentColumnIndexOffset"], "y": iRow, "s": oSegment };
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getLastColContext"] = 0; };

UCF_DataGrid["prototype"]["getFirstRowContext"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getFirstRowContext"]++; }; 
	var iCol = oCell["getX"](),
		oSegment = oCell["oUCFSegment"],
		iSegmentRowIndex = this["getSegmentRowIndex"](oSegment);
	if (iSegmentRowIndex > 0) {
		oSegment = this["aSegmentMatrix"][0][oSegment["iSegmentColumnIndex"]]["getUCFInstance"]();
		if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
			return { "x": iCol, "y": oSegment["iSegmentRowIndexOffset"], "s": oSegment };
		} else {
			while (this["getSegmentRowIndex"](oSegment) < this["aSegmentMatrix"]["length"]) {
				oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment) + 1][oSegment["iSegmentColumnIndex"]]["getUCFInstance"]();
				if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
					return { "x": iCol, "y": oSegment["iSegmentRowIndexOffset"], "s": oSegment };
				}
			}
		}
	}
	return { "x": iCol, "y": oSegment["iSegmentRowIndexOffset"], "s": oSegment };
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getFirstRowContext"] = 0; };

UCF_DataGrid["prototype"]["getLastRowContext"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getLastRowContext"]++; }; 
	var iCol = oCell["getX"](),
		oSegment = oCell["oUCFSegment"],
		iSegmentRowIndex = this["getSegmentRowIndex"](oSegment);
	if (iSegmentRowIndex < this["aSegmentMatrix"]["length"] - 1) {
		oSegment = this["aSegmentMatrix"][this["aSegmentMatrix"]["length"] - 1][oSegment["iSegmentColumnIndex"]]["getUCFInstance"]();
		if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
			return { "x": iCol, "y": oSegment["oDataGridRow"]["getSegmentRowCount"]() - 1 + oSegment["iSegmentRowIndexOffset"], "s": oSegment };
		} else {
			while (this["getSegmentRowIndex"](oSegment) > 0) {
				oSegment = this["aSegmentMatrix"][this["getSegmentRowIndex"](oSegment) - 1][oSegment["iSegmentColumnIndex"]]["getUCFInstance"]();
				if (oSegment["getClientControl"]()["getCells"]()["length"] > 0) {
					return { "x": iCol, "y": oSegment["oDataGridRow"]["getSegmentRowCount"]() - 1 + oSegment["iSegmentRowIndexOffset"], "s": oSegment };
				}
			}
		}
	}
	return { "x": iCol, "y": oSegment["oDataGridRow"]["getSegmentRowCount"]() - 1 + oSegment["iSegmentRowIndexOffset"], "s": oSegment };
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getLastRowContext"] = 0; };

UCF_DataGrid["prototype"]["getPreviousPageColContext"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getPreviousPageColContext"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getPreviousPageColContext"] = 0; };

UCF_DataGrid["prototype"]["getNextPageColContext"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getNextPageColContext"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getNextPageColContext"] = 0; };

UCF_DataGrid["prototype"]["getPreviousPageRowContext"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getPreviousPageRowContext"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getPreviousPageRowContext"] = 0; };

UCF_DataGrid["prototype"]["getNextPageRowContext"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getNextPageRowContext"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["getNextPageRowContext"] = 0; };

/**
 * Writes the appropriate accessibility text
 * @private
 */
UCF_DataGrid["prototype"]["onlsaccessibility"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataGrid.js(2211): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSource"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		iColCount = 0,
		iRowCount = 0,
		oUCFSegment = null;

	if (oSource["getAttribute"]("tp") && oSource["getAttribute"]("tp") == "END_FROMOUTSIDE_508") {
		oAccessibilityHelper["setControlType"]("DG_END");
	} else {
		for (var row = 0; row < this["aSegmentMatrix"]["length"]; row++) {
			oUCFSegment = this["aSegmentMatrix"][row][0]["getUCFInstance"]();
			iRowCount += oUCFSegment["oDataGridRow"]["getSegmentRowCount"]();
		}
		for (var col = 0; col < this["aSegmentMatrix"][0]["length"]; col++) {
			oUCFSegment = this["aSegmentMatrix"][0][col]["getUCFInstance"]();
			iColCount += oUCFSegment["oDataGridColumn"]["getSegmentColumnCount"]();
		}

		oAccessibilityHelper["setControlType"]("DG", [iColCount, iRowCount]);
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["onlsaccessibility"] = 0; };

/**
 * Prepare ARIA
 * @param {Object} oBrowserEvent
 * @return {boolean}
 */
UCF_DataGrid["prototype"]["bPrepareAria"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["bPrepareAria"]++; }; 
	/** @type {Object} */
	var oSapTableInfo;

	if (oBrowserEvent["oSource"]["getAttribute"]("tp") === "START_FROMOUTSIDE" ||
		oBrowserEvent["oSource"]["getAttribute"]("tp") === "START_FROMINSIDE" ||
		oBrowserEvent["oSource"]["getAttribute"]("tp") === "END_FROMOUTSIDE" ||
		oBrowserEvent["oSource"]["getAttribute"]("tp") === "END_FROMINSIDE") {
		return false;
	}

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;
		oSapTableInfo = this["oInSapTable"]();
		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			if (this["oDomRef"]["getAttribute"]('role') != null) {
				UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
				return true;
			}
		}
	}
	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["bPrepareAria"] = 0; };

UCF_DataGrid["prototype"]["initSegmentSplitters"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["initSegmentSplitters"]++; }; 

	var aVSplitterRefs = UCF_DomUtil["querySelectorAll"]('.lsDGVertSplitterTd', this["oDomRef"]);
	var aHSplitterRefs = UCF_DomUtil["querySelectorAll"]('.lsDGHorSplitterTd', this["oDomRef"]);
	var oDomRef = null;
	var bResizeable = false;
	var i;

	for (i = 0; i < aVSplitterRefs["length"]; i++) {
		oDomRef = aVSplitterRefs[i];
		bResizeable = this["aColumnScrollbars"] && this["aColumnScrollbars"][parseInt(oDomRef["getAttribute"]("iColIndex"))];
		if (bResizeable) UCF_DomUtil["addClass"](oDomRef, 'lsDGVertSplitterTdResize');
	}
	for (i = 0; i < aHSplitterRefs["length"]; i++) {
		oDomRef = aHSplitterRefs[i];
		bResizeable = this["aRowScrollbars"] && this["aRowScrollbars"][parseInt(oDomRef["getAttribute"]("iRowIndex"))];
		if (bResizeable) UCF_DomUtil["addClass"](oDomRef, 'lsDGHorSplitterTdResize');
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["initSegmentSplitters"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_DataGrid["prototype"]["aAttributeNames"] = ["sCustomData","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_DataGrid["prototype"]["aEventNames"] = ["VerticalScroll","HorizontalScroll","RowDrop","ColumnDrop","RowResize","ColumnResize"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_DataGrid["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_DataGrid["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DataGrid["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_DataGrid["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {number} iDataGridRowIndex The index of the DataGrid row that has been scrolled.
 * @param {number} iFirstVisibleSegmentRowIndex The index of the segment row to which was scrolled to.
 * @param {string} sAction The action which lead to the scroll event: NONE, PREVIOUS, NEXT, BEGIN, END, NEXT_PAGE, PREVIOUS_PAGE, DIRECT
 * @param {string} sAccessType The type of access which lead to the scroll event. SCROLLBAR for a direct scrollbar access and  EXTERNAL for a method call from a none-scrollbar control like the datagrid itself.
 * @param {boolean} bShift True if the SHIFT modifier is pressed.
 * @param {boolean} bCtrl True if the CTRL modifier is pressed.
 * @param {boolean} bAlt True if the ALT modifier is pressed.
 * @fires DataGrid::VerticalScroll
 */
UCF_DataGrid["prototype"]["fireVerticalScroll"] = function(sId, iDataGridRowIndex, iFirstVisibleSegmentRowIndex, sAction, sAccessType, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireVerticalScroll"]++; }; 
	/** @type {{Id: string, DataGridRowIndex: number, FirstVisibleSegmentRowIndex: number, Action: string, AccessType: string, Shift: boolean, Ctrl: boolean, Alt: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 8, "arguments.length == 8", "DataGrid.js(2348): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DataGrid.js(2349): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DataGrid.js(2350): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridRowIndex != null, "iDataGridRowIndex != null", "DataGrid.js(2351): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridRowIndex) == "number", "typeof(iDataGridRowIndex) == \"number\"", "DataGrid.js(2352): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleSegmentRowIndex != null, "iFirstVisibleSegmentRowIndex != null", "DataGrid.js(2353): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleSegmentRowIndex) == "number", "typeof(iFirstVisibleSegmentRowIndex) == \"number\"", "DataGrid.js(2354): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAction != null, "sAction != null", "DataGrid.js(2355): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAction) == "string", "typeof(sAction) == \"string\"", "DataGrid.js(2356): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "DataGrid.js(2357): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "DataGrid.js(2358): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "DataGrid.js(2359): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "DataGrid.js(2360): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "DataGrid.js(2361): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "DataGrid.js(2362): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "DataGrid.js(2363): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "DataGrid.js(2364): fireVerticalScroll"); };
	mParams = {
		"Id": sId,
		"DataGridRowIndex": iDataGridRowIndex,
		"FirstVisibleSegmentRowIndex": iFirstVisibleSegmentRowIndex,
		"Action": sAction,
		"AccessType": sAccessType,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt
	};
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("DataGrid", "VerticalScroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireVerticalScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {number} iDataGridColIndex The index of the DataGrid column that has been scrolled.
 * @param {number} iFirstVisibleSegmentColIndex The index of the segment column to which was scrolled to.
 * @param {string} sAction The action which lead to the scroll event: NONE, PREVIOUS, NEXT, BEGIN, END, NEXT_PAGE, PREVIOUS_PAGE, DIRECT
 * @param {string} sAccessType The type of access which lead to the scroll event. SCROLLBAR for a direct scrollbar access and  EXTERNAL for a method call from a none-scrollbar control like the datagrid itself.
 * @param {boolean} bShift True if the SHIFT modifier is pressed.
 * @param {boolean} bCtrl True if the CTRL modifier is pressed.
 * @param {boolean} bAlt True if the ALT modifier is pressed.
 * @fires DataGrid::HorizontalScroll
 */
UCF_DataGrid["prototype"]["fireHorizontalScroll"] = function(sId, iDataGridColIndex, iFirstVisibleSegmentColIndex, sAction, sAccessType, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireHorizontalScroll"]++; }; 
	/** @type {{Id: string, DataGridColIndex: number, FirstVisibleSegmentColIndex: number, Action: string, AccessType: string, Shift: boolean, Ctrl: boolean, Alt: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 8, "arguments.length == 8", "DataGrid.js(2402): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DataGrid.js(2403): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DataGrid.js(2404): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridColIndex != null, "iDataGridColIndex != null", "DataGrid.js(2405): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridColIndex) == "number", "typeof(iDataGridColIndex) == \"number\"", "DataGrid.js(2406): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleSegmentColIndex != null, "iFirstVisibleSegmentColIndex != null", "DataGrid.js(2407): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleSegmentColIndex) == "number", "typeof(iFirstVisibleSegmentColIndex) == \"number\"", "DataGrid.js(2408): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAction != null, "sAction != null", "DataGrid.js(2409): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAction) == "string", "typeof(sAction) == \"string\"", "DataGrid.js(2410): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "DataGrid.js(2411): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "DataGrid.js(2412): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "DataGrid.js(2413): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "DataGrid.js(2414): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "DataGrid.js(2415): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "DataGrid.js(2416): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "DataGrid.js(2417): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "DataGrid.js(2418): fireHorizontalScroll"); };
	mParams = {
		"Id": sId,
		"DataGridColIndex": iDataGridColIndex,
		"FirstVisibleSegmentColIndex": iFirstVisibleSegmentColIndex,
		"Action": sAction,
		"AccessType": sAccessType,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt
	};
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("DataGrid", "HorizontalScroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireHorizontalScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {number} iDataGridRowIndex The index of the DataGridRow where the drop occured
 * @param {number} iDataGridColumnIndex The index of the DataGridColumn where the drop occured
 * @param {number} iDataGridSegmentRowIndex The index of the DataGridSegment row where the drop occured
 * @param {number} iDataGridSegmentRowOffset The Offset relative to the DataGridSegment row where the drop occured (signum)
 * @param {string} sData Arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @fires DataGrid::RowDrop
 */
UCF_DataGrid["prototype"]["fireRowDrop"] = function(sId, sDragSource, sDropTargetInfo, iDataGridRowIndex, iDataGridColumnIndex, iDataGridSegmentRowIndex, iDataGridSegmentRowOffset, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireRowDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, DataGridRowIndex: number, DataGridColumnIndex: number, DataGridSegmentRowIndex: number, DataGridSegmentRowOffset: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 13, "arguments.length == 13", "DataGrid.js(2461): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DataGrid.js(2462): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DataGrid.js(2463): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "DataGrid.js(2464): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "DataGrid.js(2465): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "DataGrid.js(2466): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "DataGrid.js(2467): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridRowIndex != null, "iDataGridRowIndex != null", "DataGrid.js(2468): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridRowIndex) == "number", "typeof(iDataGridRowIndex) == \"number\"", "DataGrid.js(2469): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridColumnIndex != null, "iDataGridColumnIndex != null", "DataGrid.js(2470): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridColumnIndex) == "number", "typeof(iDataGridColumnIndex) == \"number\"", "DataGrid.js(2471): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridSegmentRowIndex != null, "iDataGridSegmentRowIndex != null", "DataGrid.js(2472): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridSegmentRowIndex) == "number", "typeof(iDataGridSegmentRowIndex) == \"number\"", "DataGrid.js(2473): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridSegmentRowOffset != null, "iDataGridSegmentRowOffset != null", "DataGrid.js(2474): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridSegmentRowOffset) == "number", "typeof(iDataGridSegmentRowOffset) == \"number\"", "DataGrid.js(2475): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "DataGrid.js(2476): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "DataGrid.js(2477): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "DataGrid.js(2478): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "DataGrid.js(2479): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "DataGrid.js(2480): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "DataGrid.js(2481): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "DataGrid.js(2482): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "DataGrid.js(2483): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "DataGrid.js(2484): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "DataGrid.js(2485): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "DataGrid.js(2486): fireRowDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "DataGrid.js(2487): fireRowDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"DataGridRowIndex": iDataGridRowIndex,
		"DataGridColumnIndex": iDataGridColumnIndex,
		"DataGridSegmentRowIndex": iDataGridSegmentRowIndex,
		"DataGridSegmentRowOffset": iDataGridSegmentRowOffset,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("DataGrid", "RowDrop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireRowDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {number} iDataGridColumnIndex The index of the DataGridColumn where the drop occured
 * @param {number} iDataGridRowIndex The index of the DataGridRow where the drop occured
 * @param {number} iDataGridSegmentColumnIndex The index of the DataGridSegmentColumn where the drop occured
 * @param {number} iDataGridSegmentColumnOffset The Offset relative to the DataGridSegmentColumn where the drop occured (signum)
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @fires DataGrid::ColumnDrop
 */
UCF_DataGrid["prototype"]["fireColumnDrop"] = function(sId, sDragSource, sDropTargetInfo, iDataGridColumnIndex, iDataGridRowIndex, iDataGridSegmentColumnIndex, iDataGridSegmentColumnOffset, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireColumnDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, DataGridColumnIndex: number, DataGridRowIndex: number, DataGridSegmentColumnIndex: number, DataGridSegmentColumnOffset: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 13, "arguments.length == 13", "DataGrid.js(2540): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DataGrid.js(2541): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DataGrid.js(2542): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "DataGrid.js(2543): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "DataGrid.js(2544): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "DataGrid.js(2545): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "DataGrid.js(2546): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridColumnIndex != null, "iDataGridColumnIndex != null", "DataGrid.js(2547): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridColumnIndex) == "number", "typeof(iDataGridColumnIndex) == \"number\"", "DataGrid.js(2548): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridRowIndex != null, "iDataGridRowIndex != null", "DataGrid.js(2549): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridRowIndex) == "number", "typeof(iDataGridRowIndex) == \"number\"", "DataGrid.js(2550): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridSegmentColumnIndex != null, "iDataGridSegmentColumnIndex != null", "DataGrid.js(2551): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridSegmentColumnIndex) == "number", "typeof(iDataGridSegmentColumnIndex) == \"number\"", "DataGrid.js(2552): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridSegmentColumnOffset != null, "iDataGridSegmentColumnOffset != null", "DataGrid.js(2553): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridSegmentColumnOffset) == "number", "typeof(iDataGridSegmentColumnOffset) == \"number\"", "DataGrid.js(2554): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "DataGrid.js(2555): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "DataGrid.js(2556): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "DataGrid.js(2557): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "DataGrid.js(2558): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "DataGrid.js(2559): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "DataGrid.js(2560): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "DataGrid.js(2561): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "DataGrid.js(2562): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "DataGrid.js(2563): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "DataGrid.js(2564): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "DataGrid.js(2565): fireColumnDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "DataGrid.js(2566): fireColumnDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"DataGridColumnIndex": iDataGridColumnIndex,
		"DataGridRowIndex": iDataGridRowIndex,
		"DataGridSegmentColumnIndex": iDataGridSegmentColumnIndex,
		"DataGridSegmentColumnOffset": iDataGridSegmentColumnOffset,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("DataGrid", "ColumnDrop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireColumnDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {number} iDataGridRowIndex The index of the DataGrid row that has been resized.
 * @param {string} sHeight The new height of the DataGridRow including its css unit.
 * @fires DataGrid::RowResize
 */
UCF_DataGrid["prototype"]["fireRowResize"] = function(sId, iDataGridRowIndex, sHeight) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireRowResize"]++; }; 
	/** @type {{Id: string, DataGridRowIndex: number, Height: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "DataGrid.js(2609): fireRowResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DataGrid.js(2610): fireRowResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DataGrid.js(2611): fireRowResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridRowIndex != null, "iDataGridRowIndex != null", "DataGrid.js(2612): fireRowResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridRowIndex) == "number", "typeof(iDataGridRowIndex) == \"number\"", "DataGrid.js(2613): fireRowResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHeight != null, "sHeight != null", "DataGrid.js(2614): fireRowResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHeight) == "string", "typeof(sHeight) == \"string\"", "DataGrid.js(2615): fireRowResize"); };
	mParams = {
		"Id": sId,
		"DataGridRowIndex": iDataGridRowIndex,
		"Height": sHeight
	};
	
	
	
	this["fireSemanticEvent"]("DataGrid", "RowResize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireRowResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {number} iDataGridColIndex The index of the DataGrid column that has been resized.
 * @param {string} sWidth The new width of the DataGridColumn including its css unit.
 * @fires DataGrid::ColumnResize
 */
UCF_DataGrid["prototype"]["fireColumnResize"] = function(sId, iDataGridColIndex, sWidth) {;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireColumnResize"]++; }; 
	/** @type {{Id: string, DataGridColIndex: number, Width: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "DataGrid.js(2638): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DataGrid.js(2639): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DataGrid.js(2640): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDataGridColIndex != null, "iDataGridColIndex != null", "DataGrid.js(2641): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDataGridColIndex) == "number", "typeof(iDataGridColIndex) == \"number\"", "DataGrid.js(2642): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sWidth != null, "sWidth != null", "DataGrid.js(2643): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sWidth) == "string", "typeof(sWidth) == \"string\"", "DataGrid.js(2644): fireColumnResize"); };
	mParams = {
		"Id": sId,
		"DataGridColIndex": iDataGridColIndex,
		"Width": sWidth
	};
	
	
	
	this["fireSemanticEvent"]("DataGrid", "ColumnResize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DataGrid["_"]["fireColumnResize"] = 0; };

};
sap["ls"]["preload"]["UCF_DataGridColumnDropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_BoxDecorator */
/// <reference path="./BoxDecorator.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * a wrapper for the line decorator
 * needed for the draganddropmanager to hide / unhide the decorators
 *
 * @class
 * 
 * @param {UCF_Control} oControl
 */
function UCF_DataGridColumnDropDecorator(oControl) {if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["UCF_DataGridColumnDropDecorator"]++; }; 
	if (arguments["length"] === 0) return;

	this["oDropTargetControl"] = oControl;
	this["oLineDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(oControl);
	this["oBoxDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_BoxDecorator"))(oControl);

	this["oDropLocation"] = null;
	this["bInitialized"] = false;
};window["UCF_DataGridColumnDropDecorator"] = UCF_DataGridColumnDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DataGridColumnDropDecorator"); UCF_DataGridColumnDropDecorator["_"] = {UCF_DataGridColumnDropDecorator: 0}; }; ;

UCF_DataGridColumnDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_DataGridColumnDropDecorator.prototype["sClassName"] = "UCF_DataGridColumnDropDecorator";

/**
 * destructor
 */
UCF_DataGridColumnDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["destroy"]++; }; 
	this["oDropTargetControl"] = null;
	this["oDropLocation"] = null;
	this["oLineDecorator"]["destroy"]();
	this["oLineDecorator"] = null;
	this["oBoxDecorator"]["destroy"]();
	this["oBoxDecorator"] = null;
	this["oLineWasVisible"] = null;
	this["oBoxWasVisible"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["destroy"] = 0; };

/**
 * creates dom
 *
 */
UCF_DataGridColumnDropDecorator["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["init"]++; }; 
	if (this["bInitialized"]) return;

	this["oLineDecorator"]["init"]();
	this["oBoxDecorator"]["init"]();
	this["bInitialized"] = true;
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["init"] = 0; };

/**
 * removes elements from DOM
 */
UCF_DataGridColumnDropDecorator["prototype"]["cleanUp"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["cleanUp"]++; }; 
	this["oLineDecorator"]["hide"]();
	this["oBoxDecorator"]["hide"]();
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["cleanUp"] = 0; };

UCF_DataGridColumnDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["update"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();
	var oCellRef = null;
	var iDecoratorLeft = -1;
	// var iDataGridSegmentColumnOffset = 0;

	while (oSource && oSource["getAttribute"]) {
		if (oSource["getAttribute"]("ct") === "DGSC") {
			oCellRef = oSource;
		}
		if (oSource["getAttribute"]("ct") === "DGS") {
			break;
		}
		oSource = oSource["parentNode"];
	}
	if (!oSource || !oSource["getAttribute"] || !oCellRef) return;

	// var oSegmentRef = oSource;
	var oUCFSegment = this["oDropTargetControl"]["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSource, false);
	var oUCFCell = this["oDropTargetControl"]["oLS"]["oControlFactory"]["oGetControlByDomRef"](oCellRef, false);
	var oDataGridRect = UCF_DomUtil["oGetObjectRect"](this["oDropTargetControl"]["oDomRef"]);
	var oCellRect = UCF_DomUtil["oGetObjectRect"](oCellRef);

	var oScrollbar = null,
		colIndex = 0;
	while (colIndex < this["oDropTargetControl"]["aDataGridColumns"]["length"]) {
		oScrollbar = this["oDropTargetControl"]["aDataGridColumns"][colIndex]["getScrollbar"]();
		if (oScrollbar) {
			break;
		}
		colIndex++;
	}

	if (oScrollbar) {
		var oScrollbarRect = UCF_DomUtil["oGetObjectRect"](oScrollbar["getUCFInstance"]()["oDomRef"]);
		oDataGridRect["height"] -= oScrollbarRect["height"];
	}

	this["oLineDecorator"]["hide"]();
	this["oBoxDecorator"]["hide"]();
	this["oDropLocation"] = null;
	if (oBrowserEvent["iPageX"]() < (oCellRect["left"] + (oCellRect["width"] / 4))) {
		iDecoratorLeft = oCellRect["left"] - 1;
		if (((oBrowserEvent["iPageX"]() - oCellRect["left"]) / oCellRect["width"]) < ((oBrowserEvent["iPageY"]() - oCellRect["top"]) / oCellRect["height"]) &&
			((oBrowserEvent["iPageX"]() - oCellRect["left"]) / oCellRect["width"]) < ((oCellRect["top"] + oCellRect["height"] - oBrowserEvent["iPageY"]()) / oCellRect["height"])) {
			this["oLineDecorator"]["setBounds"](iDecoratorLeft, oDataGridRect["top"], oDataGridRect["height"]);
			this["oLineDecorator"]["show"]();
			this["oDropLocation"] = { "iDataGridColumnIndex": oUCFSegment["iGetSegmentColumnIndex"](), "iDataGridSegmentColumnIndex": oUCFCell["getX"](), "iDataGridSegmentColumnOffset": -1, "iDataGridRowIndex": oUCFSegment["iGetSegmentRowIndex"]() };
		}
	} else if (oBrowserEvent["iPageX"]() > (oCellRect["left"] + (3 * oCellRect["width"] / 4))) {
		iDecoratorLeft = oCellRect["left"] + oCellRect["width"] - 2;
		if (((oCellRect["left"] + oCellRect["width"] - oBrowserEvent["iPageX"]()) / oCellRect["width"]) < ((oBrowserEvent["iPageY"]() - oCellRect["top"]) / oCellRect["height"]) &&
			((oCellRect["left"] + oCellRect["width"] - oBrowserEvent["iPageX"]()) / oCellRect["width"]) < ((oCellRect["top"] + oCellRect["height"] - oBrowserEvent["iPageY"]()) / oCellRect["height"])) {
			this["oLineDecorator"]["setBounds"](iDecoratorLeft, oDataGridRect["top"], oDataGridRect["height"]);
			this["oLineDecorator"]["show"]();
			this["oDropLocation"] = { "iDataGridColumnIndex": oUCFSegment["iGetSegmentColumnIndex"](), "iDataGridSegmentColumnIndex": oUCFCell["getX"](), "iDataGridSegmentColumnOffset": 1, "iDataGridRowIndex": oUCFSegment["iGetSegmentRowIndex"]() };
		}
	} else if ((oBrowserEvent["iPageY"]() >= (oCellRect["top"] + (oCellRect["height"] / 4))) && (oBrowserEvent["iPageY"]() <= (oCellRect["top"] + (3 * oCellRect["height"] / 4))) &&
		((oBrowserEvent["iPageX"]() >= (oCellRect["left"] + (oCellRect["width"] / 4))) && (oBrowserEvent["iPageX"]() <= (oCellRect["left"] + 3 * (oCellRect["width"] / 8))) ||
			(oBrowserEvent["iPageX"]() >= (oCellRect["left"] + (5 * oCellRect["width"] / 8))) && (oBrowserEvent["iPageX"]() <= (oCellRect["left"] + 6 * (oCellRect["width"] / 8))))) {
		iDecoratorLeft = oCellRect["left"] - 1;
		this["oBoxDecorator"]["setBounds"](iDecoratorLeft, oDataGridRect["top"], oDataGridRect["height"], (oCellRect["width"] + 1));
		this["oBoxDecorator"]["show"]();
		this["oDropLocation"] = { "iDataGridColumnIndex": oUCFSegment["iGetSegmentColumnIndex"](), "iDataGridSegmentColumnIndex": oUCFCell["getX"](), "iDataGridSegmentColumnOffset": 0, "iDataGridRowIndex": oUCFSegment["iGetSegmentRowIndex"]() };
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["update"] = 0; };

UCF_DataGridColumnDropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["oGetDropLocation"]++; }; 
	return this["oDropLocation"];
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["oGetDropLocation"] = 0; };

/**
 * @override
 * need to override since we do our hide/wasVisible/show handling in this class
 *
 */

UCF_DataGridColumnDropDecorator["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["bIsVisible"]++; }; 
	return (this["oLineDecorator"]["bIsVisible"]() || this["oBoxDecorator"]["bIsVisible"]());
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["bIsVisible"] = 0; };

/**
 * needed to determine the hovered element
 */
UCF_DataGridColumnDropDecorator["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["hide"]++; }; 
	this["oLineWasVisible"] = this["oLineDecorator"]["bIsVisible"]();
	if (this["oLineWasVisible"]) {
		this["oLineDecorator"]["hide"]();
	}
	this["oBoxWasVisible"] = this["oBoxDecorator"]["bIsVisible"]();
	if (this["oBoxWasVisible"]) {
		this["oBoxDecorator"]["hide"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["hide"] = 0; };
UCF_DataGridColumnDropDecorator["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["show"]++; }; 
	if (this["oLineWasVisible"]) {
		this["oLineDecorator"]["show"]();
	}
	if (this["oBoxWasVisible"]) {
		this["oBoxDecorator"]["show"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDecorator["_"]["show"] = 0; };

};
sap["ls"]["preload"]["UCF_DataGridColumnDropDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_DataGridColumnDropDecorator */
/// <reference path="../decorators/DataGridColumnDropDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_DataGridColumnDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["UCF_DataGridColumnDropDelegate"]++; }; 
	UCF_DropDelegate["apply"](this, [oLS]);
	this["setDropTargetControl"](oDropTargetControl);
};window["UCF_DataGridColumnDropDelegate"] = UCF_DataGridColumnDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DataGridColumnDropDelegate"); UCF_DataGridColumnDropDelegate["_"] = {UCF_DataGridColumnDropDelegate: 0}; }; ;
UCF_DataGridColumnDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_DataGridColumnDropDelegate.prototype["sClassName"] = "UCF_DataGridColumnDropDelegate";

/**
 * destructor
 */
UCF_DataGridColumnDropDelegate["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["destroy"]++; }; 
	UCF_DropDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["destroy"] = 0; };

UCF_DataGridColumnDropDelegate["prototype"]["oCreateDropDecorator"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["oCreateDropDecorator"]++; }; 
	if (this["oDropDecorator"]) return this["oDropDecorator"];

	return this["oDropDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_DataGridColumnDropDecorator"))(this["oDropTargetControl"], true); // eslint-disable-line @ur/no-memory-leaks
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["oCreateDropDecorator"] = 0; };

UCF_DataGridColumnDropDelegate["prototype"]["bIsDropPossible"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["bIsDropPossible"]++; }; 
	this["oCreateDropDecorator"]()["update"](oBrowserEvent);
	if (!this["oDropDecorator"]["oGetDropLocation"]()) return false;

	return UCF_DropDelegate.prototype["bIsDropPossible"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["bIsDropPossible"] = 0; };

UCF_DataGridColumnDropDelegate["prototype"]["oGetDomRefToBeFocussed"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["oGetDomRefToBeFocussed"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["oGetDomRefToBeFocussed"] = 0; };

UCF_DataGridColumnDropDelegate["prototype"]["oGetDropTargetInfoId"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["oGetDropTargetInfoId"]++; }; 
	var oDropTargetControl = this["oGetDropTargetControl"](oBrowserEvent);

	if (oDropTargetControl) {
		// get the segment
		var oSource = oBrowserEvent["oGetSource"]();

		while (oSource && oSource["getAttribute"]) {
			if (oSource["getAttribute"]('ct') === 'DGS') {
				break;
			}
			oSource = oSource["parentNode"];
		}
		if (oSource && oSource["getAttribute"]) {
			var oSegment = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSource, false);

			// eslint-disable-next-line @ur/no-memory-leaks
			this["sDropTargetInfo"] = oSegment["oDataGridColumn"]["getDropTargetInfo"](); // eslint-disable-line @ur/no-missing-setClientProperty

			return this["sDropTargetInfo"];
		} else {
			return null;
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["oGetDropTargetInfoId"] = 0; };

UCF_DataGridColumnDropDelegate["prototype"]["fGetDropCallBack"] = function (oDragSession) {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["sDropTargetInfo"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropLocation = this["oDropDecorator"]["oGetDropLocation"](),
		iDataGridColumnIndex = oDropLocation["iDataGridColumnIndex"],
		iDataGridRowIndex = oDropLocation["iDataGridRowIndex"],
		iDataGridSegmentColumnIndex = oDropLocation["iDataGridSegmentColumnIndex"],
		iDataGridSegmentColumnOffset = oDropLocation["iDataGridSegmentColumnOffset"],
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function (sDragData, sMimeType) {
		oDropTargetControl["fireColumnDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			iDataGridColumnIndex,
			iDataGridRowIndex,
			iDataGridSegmentColumnIndex,
			iDataGridSegmentColumnOffset,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY
		);
	};

};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["fGetDropCallBack"] = 0; };

UCF_DataGridColumnDropDelegate["prototype"]["onlsdragscroll"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["onlsdragscroll"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'onlsdragscroll', "DataGridColumnDropDelegate.js(111): onlsdragscroll"); };

	var sDropTags = this["sGetDropTags"](oBrowserEvent),
		sValidMimeTypes = this["sGetValidMimeTypes"](oBrowserEvent),
		oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		bEventBubbling = this["bGetEventBubbling"](oBrowserEvent);

	if (!oDragAndDropManager["bGetDropAllowed"](sDropTags, sValidMimeTypes)) {
		if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
		return;
	}

	//get the segment
	var oSource = oBrowserEvent["oGetSource"]();
	while (oSource && oSource["getAttribute"]) {
		if (oSource["getAttribute"]('ct') === 'DGS') {
			break;
		}
		oSource = oSource["parentNode"];
	}
	if (oSource && oSource["getAttribute"]) {
		var oSegment = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSource, false);
		var iDataGridColumnIndex = oSegment["iGetSegmentColumnIndex"]();
		var oDataGridSegmentRect = UCF_DomUtil["oGetObjectRect"](oSegment["oDomRef"]);
		var oDropTargetControl = this["oGetDropTargetControl"](oBrowserEvent);
		var oDataGridColumn = oDropTargetControl["aDataGridColumns"][iDataGridColumnIndex];
		var oColumnScrollbar = oDataGridColumn["getScrollbar"]();

		if (!oColumnScrollbar) return;

		// scroll right
		if ((oBrowserEvent["_iClientX"]) > (oDataGridSegmentRect["left"] + oDataGridSegmentRect["width"] - 10)) {
			if (oColumnScrollbar["getUCFInstance"]()["bEndPosition"]()) return;
			if (this["oDropDecorator"]) this["oDropDecorator"]["hide"]();
			this["oDropTargetControl"]["columnScrollToPosition"](iDataGridColumnIndex, 10, -1, -1);
		}
		// scroll left
		if ((oBrowserEvent["_iClientX"]) < (oDataGridSegmentRect["left"] + 10)) {
			if (oColumnScrollbar["getUCFInstance"]()["bStartPosition"]()) return;
			if (this["oDropDecorator"]) this["oDropDecorator"]["hide"]();
			this["oDropTargetControl"]["columnScrollToPosition"](iDataGridColumnIndex, -10, -1, -1);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridColumnDropDelegate["_"]["onlsdragscroll"] = 0; };

};
sap["ls"]["preload"]["UCF_DataGridRowDropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_BoxDecorator */
/// <reference path="./BoxDecorator.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * a wrapper for the line decorator
 * needed for the draganddropmanager to hide / unhide the decorators
 *
 * @class
 * 
 * @param {UCF_Control} oControl
 */
function UCF_DataGridRowDropDecorator(oControl) {if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["UCF_DataGridRowDropDecorator"]++; }; 
	if (arguments["length"] === 0) return;

	this["oDropTargetControl"] = oControl;
	this["oLineDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(oControl, true);
	this["oBoxDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_BoxDecorator"))(oControl);

	this["oDropLocation"] = null;
	this["bInitialized"] = false;
};window["UCF_DataGridRowDropDecorator"] = UCF_DataGridRowDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DataGridRowDropDecorator"); UCF_DataGridRowDropDecorator["_"] = {UCF_DataGridRowDropDecorator: 0}; }; ;

UCF_DataGridRowDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_DataGridRowDropDecorator.prototype["sClassName"] = "UCF_DataGridRowDropDecorator";

/**
 * destructor
 */
UCF_DataGridRowDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["destroy"]++; }; 
	this["oDropTargetControl"] = null;
	this["oDropLocation"] = null;
	this["oLineDecorator"]["destroy"]();
	this["oLineDecorator"] = null;
	this["oBoxDecorator"]["destroy"]();
	this["oBoxDecorator"] = null;
	this["oLineWasVisible"] = null;
	this["oBoxWasVisible"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["destroy"] = 0; };

/**
 * creates dom
 *
 */
UCF_DataGridRowDropDecorator["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["init"]++; }; 
	if (this["bInitialized"]) return;

	this["oLineDecorator"]["init"]();
	this["oBoxDecorator"]["init"]();
	this["bInitialized"] = true;
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["init"] = 0; };

/**
 * removes elements from DOM
 */
UCF_DataGridRowDropDecorator["prototype"]["cleanUp"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["cleanUp"]++; }; 
	this["oLineDecorator"]["hide"]();
	this["oBoxDecorator"]["hide"]();
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["cleanUp"] = 0; };

UCF_DataGridRowDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["update"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();
	var oCellRef = null;
	var iDecoratorTop = -1;
	// var iDataGridSegmentRowOffset = 0;
	while (oSource && oSource["getAttribute"]) {
		if (oSource["getAttribute"]("ct") === "DGSC") {
			oCellRef = oSource;
		}
		if (oSource["getAttribute"]("ct") === "DGS") {
			break;
		}
		oSource = oSource["parentNode"];
	}
	if (!oSource || !oSource["getAttribute"] || !oCellRef) return;

	// var oSegmentRef = oSource;
	var oUCFSegment = this["oDropTargetControl"]["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSource, false);
	var oUCFCell = this["oDropTargetControl"]["oLS"]["oControlFactory"]["oGetControlByDomRef"](oCellRef, false);
	var oDataGridRect = UCF_DomUtil["oGetObjectRect"](this["oDropTargetControl"]["oDomRef"]);
	var oCellRect = UCF_DomUtil["oGetObjectRect"](oCellRef);

	var oScrollbar = null,
		rowIndex = 0;
	while (rowIndex < this["oDropTargetControl"]["aDataGridRows"]["length"]) {
		oScrollbar = this["oDropTargetControl"]["aDataGridRows"][rowIndex]["getScrollbar"]();
		if (oScrollbar) {
			break;
		}
		rowIndex++;
	}

	if (oScrollbar) {
		var oScrollbarRect = UCF_DomUtil["oGetObjectRect"](oScrollbar["getUCFInstance"]()["oDomRef"]);
		oDataGridRect["width"] -= oScrollbarRect["width"];
	}

	this["oLineDecorator"]["hide"]();
	this["oBoxDecorator"]["hide"]();
	this["oDropLocation"] = null;
	if (oBrowserEvent["iPageY"]() < (oCellRect["top"] + (oCellRect["height"] / 4))) {
		iDecoratorTop = oCellRect["top"] - 1;
		if (((oBrowserEvent["iPageY"]() - oCellRect["top"]) / oCellRect["height"]) < ((oBrowserEvent["iPageX"]() - oCellRect["left"]) / oCellRect["width"]) &&
			((oBrowserEvent["iPageY"]() - oCellRect["top"]) / oCellRect["height"]) < ((oCellRect["left"] + oCellRect["width"] - oBrowserEvent["iPageX"]()) / oCellRect["width"])) {
			this["oLineDecorator"]["setBounds"](oDataGridRect["left"], iDecoratorTop, oDataGridRect["width"]);
			this["oLineDecorator"]["show"]();
			this["oDropLocation"] = { "iDataGridRowIndex": oUCFSegment["iGetSegmentRowIndex"](), "iDataGridSegmentRowIndex": oUCFCell["getY"](), "iDataGridSegmentRowOffset": -1, "iDataGridColumnIndex": oUCFSegment["iGetSegmentColumnIndex"]() };
		}
	} else if (oBrowserEvent["iPageY"]() > (oCellRect["top"] + (3 * oCellRect["height"] / 4))) {
		iDecoratorTop = oCellRect["top"] + oCellRect["height"] - 2;
		if (((oCellRect["top"] + oCellRect["height"] - oBrowserEvent["iPageY"]()) / oCellRect["height"]) < ((oBrowserEvent["iPageX"]() - oCellRect["left"]) / oCellRect["width"]) &&
			((oCellRect["top"] + oCellRect["height"] - oBrowserEvent["iPageY"]()) / oCellRect["height"]) < ((oCellRect["left"] + oCellRect["width"] - oBrowserEvent["iPageX"]()) / oCellRect["width"])) {
			this["oLineDecorator"]["setBounds"](oDataGridRect["left"], iDecoratorTop, oDataGridRect["width"]);
			this["oLineDecorator"]["show"]();
			this["oDropLocation"] = { "iDataGridRowIndex": oUCFSegment["iGetSegmentRowIndex"](), "iDataGridSegmentRowIndex": oUCFCell["getY"](), "iDataGridSegmentRowOffset": 1, "iDataGridColumnIndex": oUCFSegment["iGetSegmentColumnIndex"]() };
		}
	} else if ((oBrowserEvent["iPageX"]() > (oCellRect["left"] + (3 * oCellRect["width"] / 8))) && (oBrowserEvent["iPageX"]() < (oCellRect["left"] + (5 * oCellRect["width"] / 8)))) {
		iDecoratorTop = oCellRect["top"] - 1;
		this["oBoxDecorator"]["setBounds"](oDataGridRect["left"], iDecoratorTop, (oCellRect["height"] + 1), oDataGridRect["width"]);
		this["oBoxDecorator"]["show"]();
		this["oDropLocation"] = { "iDataGridRowIndex": oUCFSegment["iGetSegmentRowIndex"](), "iDataGridSegmentRowIndex": oUCFCell["getY"](), "iDataGridSegmentRowOffset": 0, "iDataGridColumnIndex": oUCFSegment["iGetSegmentColumnIndex"]() };
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["update"] = 0; };

UCF_DataGridRowDropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["oGetDropLocation"]++; }; 
	return this["oDropLocation"];
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["oGetDropLocation"] = 0; };

UCF_DataGridRowDropDecorator["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["bIsVisible"]++; }; 
	return (this["oLineDecorator"]["bIsVisible"]() || this["oBoxDecorator"]["bIsVisible"]());
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["bIsVisible"] = 0; };

UCF_DataGridRowDropDecorator["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["hide"]++; }; 
	this["oLineWasVisible"] = this["oLineDecorator"]["bIsVisible"]();
	if (this["oLineWasVisible"]) {
		this["oLineDecorator"]["hide"]();
	}
	this["oBoxWasVisible"] = this["oBoxDecorator"]["bIsVisible"]();
	if (this["oBoxWasVisible"]) {
		this["oBoxDecorator"]["hide"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["hide"] = 0; };
UCF_DataGridRowDropDecorator["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["show"]++; }; 
	if (this["oLineWasVisible"]) {
		this["oLineDecorator"]["show"]();
	}
	if (this["oBoxWasVisible"]) {
		this["oBoxDecorator"]["show"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDecorator["_"]["show"] = 0; };

};
sap["ls"]["preload"]["UCF_DataGridRowDropDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_DataGridRowDropDecorator */
/// <reference path="../decorators/DataGridRowDropDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_DataGridRowDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["UCF_DataGridRowDropDelegate"]++; }; 
	UCF_DropDelegate["apply"](this, [oLS]);
	this["setDropTargetControl"](oDropTargetControl);
};window["UCF_DataGridRowDropDelegate"] = UCF_DataGridRowDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DataGridRowDropDelegate"); UCF_DataGridRowDropDelegate["_"] = {UCF_DataGridRowDropDelegate: 0}; }; ;
UCF_DataGridRowDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_DataGridRowDropDelegate.prototype["sClassName"] = "UCF_DataGridRowDropDelegate";

/**
 * destructor
 */
UCF_DataGridRowDropDelegate["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["destroy"]++; }; 
	UCF_DropDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["destroy"] = 0; };

UCF_DataGridRowDropDelegate["prototype"]["oCreateDropDecorator"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["oCreateDropDecorator"]++; }; 
	if (this["oDropDecorator"]) return this["oDropDecorator"];

	return this["oDropDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_DataGridRowDropDecorator"))(this["oDropTargetControl"]); // eslint-disable-line @ur/no-memory-leaks
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["oCreateDropDecorator"] = 0; };

UCF_DataGridRowDropDelegate["prototype"]["bIsDropPossible"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["bIsDropPossible"]++; }; 
	this["oCreateDropDecorator"]()["update"](oBrowserEvent);
	if (!this["oDropDecorator"]["oGetDropLocation"]()) return false;

	return UCF_DropDelegate.prototype["bIsDropPossible"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["bIsDropPossible"] = 0; };

UCF_DataGridRowDropDelegate["prototype"]["oGetDomRefToBeFocussed"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["oGetDomRefToBeFocussed"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["oGetDomRefToBeFocussed"] = 0; };

UCF_DataGridRowDropDelegate["prototype"]["oGetDropTargetInfoId"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["oGetDropTargetInfoId"]++; }; 
	var oDropTargetControl = this["oGetDropTargetControl"](oBrowserEvent);

	if (oDropTargetControl) {
		//get the segment
		var oSource = oBrowserEvent["oGetSource"]();
		while (oSource && oSource["getAttribute"]) {
			if (oSource["getAttribute"]('ct') === 'DGS') {
				break;
			}
			oSource = oSource["parentNode"];
		}
		if (oSource && oSource["getAttribute"]) {
			var oSegment = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSource, false);

			// eslint-disable-next-line @ur/no-memory-leaks
			this["sDropTargetInfo"] = oSegment["oDataGridRow"]["getDropTargetInfo"](); // eslint-disable-line @ur/no-missing-setClientProperty

			return this["sDropTargetInfo"];
		} else {
			return null;
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["oGetDropTargetInfoId"] = 0; };

UCF_DataGridRowDropDelegate["prototype"]["fGetDropCallBack"] = function (oDragSession) {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["sDropTargetInfo"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropLocation = this["oDropDecorator"]["oGetDropLocation"](),
		iDataGridRowIndex = oDropLocation["iDataGridRowIndex"],
		iDataGridColumnIndex = oDropLocation["iDataGridColumnIndex"],
		iDataGridSegmentRowIndex = oDropLocation["iDataGridSegmentRowIndex"],
		iDataGridSegmentRowOffset = oDropLocation["iDataGridSegmentRowOffset"],
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function (sDragData, sMimeType) {
		oDropTargetControl["fireRowDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			iDataGridRowIndex,
			iDataGridColumnIndex,
			iDataGridSegmentRowIndex,
			iDataGridSegmentRowOffset,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY
		);
	};

};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["fGetDropCallBack"] = 0; };

UCF_DataGridRowDropDelegate["prototype"]["onlsdragscroll"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["onlsdragscroll"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'onlsdragscroll', "DataGridRowDropDelegate.js(110): onlsdragscroll"); };

	var sDropTags = this["sGetDropTags"](oBrowserEvent),
		sValidMimeTypes = this["sGetValidMimeTypes"](oBrowserEvent),
		oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		bEventBubbling = this["bGetEventBubbling"](oBrowserEvent);

	if (!oDragAndDropManager["bGetDropAllowed"](sDropTags, sValidMimeTypes)) {
		if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
		return;
	}

	// get the segment
	var oSource = oBrowserEvent["oGetSource"]();

	while (oSource && oSource["getAttribute"]) {
		if (oSource["getAttribute"]('ct') === 'DGS') {
			break;
		}
		oSource = oSource["parentNode"];
	}
	if (oSource && oSource["getAttribute"]) {
		var oSegment = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oSource, false);
		var iDataGridRowIndex = oSegment["iGetSegmentRowIndex"]();
		var oDataGridSegmentRect = UCF_DomUtil["oGetObjectRect"](oSegment["oDomRef"]);
		var oDropTargetControl = this["oGetDropTargetControl"](oBrowserEvent);
		var oDataGridRow = oDropTargetControl["aDataGridRows"][iDataGridRowIndex];
		var oRowScrollbar = oDataGridRow["getScrollbar"]();

		if (!oRowScrollbar) return;

		// scroll down
		if ((oBrowserEvent["_iClientY"]) > (oDataGridSegmentRect["top"] + oDataGridSegmentRect["height"] - 10)) {
			if (oRowScrollbar["getUCFInstance"]()["bEndPosition"]()) return;
			if (this["oDropDecorator"]) this["oDropDecorator"]["hide"]();
			this["oDropTargetControl"]["rowScrollToPosition"](iDataGridRowIndex, 10, -1, -1);
		}
		// scroll up
		if ((oBrowserEvent["_iClientY"]) < (oDataGridSegmentRect["top"] + 10)) {
			if (oRowScrollbar["getUCFInstance"]()["bStartPosition"]()) return;
			if (this["oDropDecorator"]) this["oDropDecorator"]["hide"]();
			this["oDropTargetControl"]["rowScrollToPosition"](iDataGridRowIndex, -10, -1, -1);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridRowDropDelegate["_"]["onlsdragscroll"] = 0; };

};
sap["ls"]["preload"]["UCF_DataGridSegment"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_DataGridSegment(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["UCF_DataGridSegment"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "DataGridSegment.js(29): UCF_DataGridSegment"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "DataGridSegment.js(30): UCF_DataGridSegment"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DataGridSegment.js(31): UCF_DataGridSegment"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oDomRef"] = oDomRef;
	this["iOffsetHeight"] = 0;
	this["iOffsetWidth"] = 0;

	this["initInternal"]();

	this["bKeepAlive"] = true;
};window["UCF_DataGridSegment"] = UCF_DataGridSegment; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DataGridSegment"); UCF_DataGridSegment["_"] = {UCF_DataGridSegment: 0}; }; ;

UCF_DataGridSegment["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_DataGridSegment.prototype["sClassName"] = "UCF_DataGridSegment";

UCF_DataGridSegment["prototype"]["aCellCaptureEvents"] = ["mousedown", "click"];

/**
 * Attaches/activates the event capturing
 */
UCF_DataGridSegment["prototype"]["attachContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["attachContentListening"]++; }; 

	for (var i = 0; i < this["aCellCaptureEvents"]["length"]; i++) {
		this["oLS"]["attachCaptureEvent"](this["aCellCaptureEvents"][i], this, "onContentEventCapture");
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Event capturing of \"" + this["sId"] + "\" attached", "DataGridSegment.js(56): attachContentListening"); };
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["attachContentListening"] = 0; };

/**
 * detaches/deactivates the event capturing
 */
UCF_DataGridSegment["prototype"]["detachContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["detachContentListening"]++; }; 

	for (var i = 0; i < this["aCellCaptureEvents"]["length"]; i++) {
		this["oLS"]["detachCaptureEvent"](this["aCellCaptureEvents"][i], this);

	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Event capturing of \"" + this["sId"] + "\" detached", "DataGridSegment.js(68): detachContentListening"); };
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["detachContentListening"] = 0; };

/**
 * Processes the captured events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_DataGridSegment["prototype"]["onContentEventCapture"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["onContentEventCapture"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataGridSegment.js(77): onContentEventCapture"); };
	var oCell = oBrowserEvent["oGetSourceControl"](),
		sHandlerName = "on" + oBrowserEvent["sGetName"]();
	while (oCell && !UCF_JsUtil["bInstanceOf"](oCell, "UCF_DataGridSegmentCell")) {
		oCell = oCell["oGetParent"]();
	}
	if (oCell && oCell[sHandlerName]) {
		oCell[sHandlerName](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["onContentEventCapture"] = 0; };

UCF_DataGridSegment["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["destroy"]++; }; 
	this["detachContentListening"]();

	this["iOffsetHeight"] = 0;
	this["iOffsetWidth"] = 0;
	this["iSegmentColumnIndex"] = 0;
	this["iSegmentColumnIndexOffset"] = 0;
	this["iSegmentRowIndexOffset"] = 0;

	this["oSelectionRange"] = null;
	this["oDataGridRow"] = null;
	this["oDataGrid"] = null;
	this["oDataGridColumn"] = null;
	this["oRasterDivContainer"] = null;

	if (this["iResizeTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["iResizeTimer"]);
		this["iResizeTimer"] = null;
	}

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["destroy"] = 0; };

UCF_DataGridSegment["prototype"]["reconnectToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["reconnectToDom"]++; }; 
	UCF_Control.prototype["reconnectToDom"]["apply"](this, arguments);
	this["detachContentListening"]();
	this["initInternal"]();

};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["reconnectToDom"] = 0; };

UCF_DataGridSegment["prototype"]["initInternal"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["initInternal"]++; }; 

	if (this["getClientControl"]()) {
		this["initInstance"]();
		this["attachContentListening"]();
	}

	this["oSelectionRange"] = { "xStart": Number["NaN"], "yStart": Number["NaN"], "xEnd": Number["NaN"], "yEnd": Number["NaN"] };

	var iScrollPositionX = this["oDataGridColumn"]["iGetScrollPosition"](),
		iScrollPositionY = this["oDataGridRow"]["iGetScrollPosition"]();

	if (!this["oDomRef"] || !this["oDomRef"]["firstChild"]) return;

	this["oDomRef"]["firstChild"]["style"]["position"] = "absolute";

	this["iOffsetHeight"] = this["oDomRef"]["offsetHeight"];
	this["iOffsetWidth"] = this["oDomRef"]["offsetWidth"];

	if (window["UCF_System"]["bIsRTL"]) {
		this["oDomRef"]["firstChild"]["style"]["right"] = (-iScrollPositionX) + "px";
	} else {
		this["oDomRef"]["firstChild"]["style"]["left"] = (-iScrollPositionX) + "px";
	}
	this["oDomRef"]["firstChild"]["style"]["top"] = (-iScrollPositionY) + "px";

	this["createRasterContainer"](iScrollPositionX, iScrollPositionY);

	this["aXRasterDivs"] = [];
	this["paintRasterX"](iScrollPositionX);

	this["aYRasterDivs"] = [];
	this["paintRasterY"](iScrollPositionY);

};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["initInternal"] = 0; };

UCF_DataGridSegment["prototype"]["initResize"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["initResize"]++; }; 
	this["initInstance"]();
	this["iOffsetHeight"] = this["oDomRef"]["offsetHeight"];
	this["iOffsetWidth"] = this["oDomRef"]["offsetWidth"];
	this["oDataGridColumn"]["calcVisibleCellRange"]();
	this["oDataGridRow"]["calcVisibleCellRange"]();
	this["resizeRasterContainer"]();
	this["paintRasterX"](this["oDataGridColumn"]["iGetScrollPosition"]());
	this["paintRasterY"](this["oDataGridRow"]["iGetScrollPosition"]());
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["initResize"] = 0; };

UCF_DataGridSegment["prototype"]["initInstance"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["initInstance"]++; }; 

	if (this["getClientControl"]()) {
		this["oDataGridRow"] = this["getClientControl"]()["getParent"]();
		this["oDataGrid"] = this["oDataGridRow"]["getParent"]();
		this["iSegmentColumnIndex"] = this["iGetSegmentColumnIndex"]();
		this["oDataGridColumn"] = this["oDataGrid"]["getColumn"](this["iSegmentColumnIndex"]);
		this["iSegmentColumnIndexOffset"] = this["oDataGridColumn"]["getSegmentColumnIndexOffset"]();
		this["iSegmentRowIndexOffset"] = this["oDataGridRow"]["getSegmentRowIndexOffset"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["initInstance"] = 0; };

/**
 */
UCF_DataGridSegment["prototype"]["createRasterContainer"] = function(iScrollPositionX, iScrollPositionY) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["createRasterContainer"]++; }; 

	if (this["oRasterDivContainer"]) {
		try {
			this["oDomRef"]["firstChild"]["removeChild"](this["oRasterDivContainer"]);
		} catch (err) {

		}
	}

	this["iOffsetWidth"] = this["oDomRef"]["offsetWidth"];
	this["iOffsetHeight"] = this["oDomRef"]["offsetHeight"];

	this["oRasterDivContainer"] = document["createElement"]("DIV");
	this["oDomRef"]["firstChild"]["appendChild"](this["oRasterDivContainer"]);

	this["oRasterDivContainer"]["className"] = "lsDGSRasterDiv";
	this["oRasterDivContainer"]["style"]["width"] = this["iOffsetWidth"] + "px";
	this["oRasterDivContainer"]["style"]["height"] = this["iOffsetHeight"] + "px";
	if (window["UCF_System"]["bIsRTL"]) {
		this["oRasterDivContainer"]["style"]["right"] = iScrollPositionX + "px";
	} else {
		this["oRasterDivContainer"]["style"]["left"] = iScrollPositionX + "px";
	}
	this["oRasterDivContainer"]["style"]["top"] = iScrollPositionY + "px";
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["createRasterContainer"] = 0; };

/**
 */
UCF_DataGridSegment["prototype"]["resizeRasterContainer"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["resizeRasterContainer"]++; }; 

	this["iOffsetWidth"] = this["oDomRef"]["offsetWidth"];
	this["iOffsetHeight"] = this["oDomRef"]["offsetHeight"];

	this["oRasterDivContainer"]["style"]["width"] = this["iOffsetWidth"] + "px";
	this["oRasterDivContainer"]["style"]["height"] = this["iOffsetHeight"] + "px";

	for (var x = 0; x < this["aXRasterDivs"]["length"]; x++) {
		this["aXRasterDivs"][x]["style"]["height"] = this["iOffsetHeight"] + "px";
	}
	for (var y = 0; y < this["aYRasterDivs"]["length"]; y++) {
		this["aYRasterDivs"][y]["style"]["width"] = this["iOffsetWidth"] + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["resizeRasterContainer"] = 0; };

/**
 * Returns the index of the current DataGridSegment within the DataGridRow.
 * @return index of the current DataGridSegment within the DataGridRow.
 * @type {int}
 */
UCF_DataGridSegment["prototype"]["iGetSegmentColumnIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["iGetSegmentColumnIndex"]++; }; 
	return this["oDataGridRow"]["indexOfAggregation"]("Segments", this["getClientControl"]());
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["iGetSegmentColumnIndex"] = 0; };

/**
 * Returns the index of the current DataGridSegment within the DataGridColumn.
 * @return index of the current DataGridSegment within the DataGridColumn.
 * @type {int}
 */
UCF_DataGridSegment["prototype"]["iGetSegmentRowIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["iGetSegmentRowIndex"]++; }; 
	return this["oDataGrid"]["indexOfAggregation"]("Rows", this["oDataGridRow"]);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["iGetSegmentRowIndex"] = 0; };

/**
 */
UCF_DataGridSegment["prototype"]["paintRasterX"] = function(iScrollPositionX) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["paintRasterX"]++; }; 

	if (window["UCF_System"]["bIsRTL"]) {
		this["oRasterDivContainer"]["style"]["right"] = iScrollPositionX + "px";
	} else {
		this["oRasterDivContainer"]["style"]["left"] = iScrollPositionX + "px";
	}

	var i = 0,
		oRasterDiv = null,
		bSkip = false,
		iTopLeftX = this["oDataGridColumn"]["getFirstVisibleSegmentColumnIndex"](),
		iBottomRightX = this["oDataGridColumn"]["iGetLastVisibleSegmentColumnIndex"]();

	if (iTopLeftX == null || iBottomRightX == null) return;

	//for the case that visibleRange has not yet been calculated take column.iMaxCols
	if ((iBottomRightX - iTopLeftX) > this["oDataGridColumn"]["iMaxCols"]) {
		iBottomRightX = iTopLeftX + this["oDataGridColumn"]["iMaxCols"];
	}

	for (var x = iTopLeftX; x < iBottomRightX; x++) {
		if (bSkip) {
			bSkip = false;
			continue;
		}
		bSkip = true;
		oRasterDiv = this["aXRasterDivs"][i];
		if (!oRasterDiv) {
			oRasterDiv = document["createElement"]("DIV");
			this["oRasterDivContainer"]["appendChild"](oRasterDiv);
			this["aXRasterDivs"]["push"](oRasterDiv);
			oRasterDiv["className"] = "lsDGSRasterXItem";
			oRasterDiv["style"]["height"] = this["iOffsetHeight"] + "px";
		}

		oRasterDiv["style"]["display"] = "block";
		if (this["oDataGridColumn"]["_getSegmentColumn"](x)) {
			if (window["UCF_System"]["bIsRTL"]) {
				oRasterDiv["style"]["right"] = (this["oDataGridColumn"]["_fGetSegmentColumnLeft"](x) - iScrollPositionX) + "px";
			} else {
				oRasterDiv["style"]["left"] = (this["oDataGridColumn"]["_fGetSegmentColumnLeft"](x) - iScrollPositionX) + "px";
			}
			if (this["oDataGridColumn"]["_getSegmentColumn"](x + 1)) oRasterDiv["style"]["width"] = (this["oDataGridColumn"]["_fGetSegmentColumnLeft"](x + 1) - this["oDataGridColumn"]["_fGetSegmentColumnLeft"](x) - 1) + "px";
		}
		i++;
	}

	for (var xInv = i; xInv < this["aXRasterDivs"]["length"]; xInv++) {
		this["aXRasterDivs"][xInv]["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["paintRasterX"] = 0; };

/**
 */
UCF_DataGridSegment["prototype"]["paintRasterY"] = function(iScrollPositionY) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["paintRasterY"]++; }; 

	this["oRasterDivContainer"]["style"]["top"] = iScrollPositionY + "px";

	var i = 0,
		bSkip = false,
		iTopLeftY = this["oDataGridRow"]["getFirstVisibleSegmentRowIndex"](),
		iBottomRightY = this["oDataGridRow"]["iGetLastVisibleSegmentRowIndex"]();

	if (iTopLeftY == null || iBottomRightY == null) return;

	//for the case that visibleRange has not yet been calculated take row.iMaxRows
	if ((iBottomRightY - iTopLeftY) > this["oDataGridRow"]["iMaxRows"]) {
		iBottomRightY = iTopLeftY + this["oDataGridRow"]["iMaxRows"];
	}

	for (var y = iTopLeftY; y < iBottomRightY; y++) {
		if (bSkip) {
			bSkip = false;
			continue;
		}
		bSkip = true;
		var oRasterDiv = this["aYRasterDivs"][i];
		if (!oRasterDiv) {
			oRasterDiv = document["createElement"]("DIV");
			this["oRasterDivContainer"]["appendChild"](oRasterDiv);
			this["aYRasterDivs"]["push"](oRasterDiv);
			oRasterDiv["className"] = "lsDGSRasterYItem";
			oRasterDiv["style"]["width"] = this["iOffsetWidth"] + "px";
		}

		oRasterDiv["style"]["display"] = "block";
		if (this["oDataGridRow"]["_getSegmentRow"](y)) {
			oRasterDiv["style"]["top"] = (this["oDataGridRow"]["_fGetSegmentRowTop"](y) - iScrollPositionY) + "px";
			if (this["oDataGridRow"]["_getSegmentRow"](y + 1)) oRasterDiv["style"]["height"] = (this["oDataGridRow"]["_fGetSegmentRowTop"](y + 1) - this["oDataGridRow"]["_fGetSegmentRowTop"](y) - 1) + "px";
		}
		i++;
	}

	for (var yInv = i; yInv < this["aYRasterDivs"]["length"]; yInv++) {
		this["aYRasterDivs"][yInv]["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["paintRasterY"] = 0; };

/**
 * Returns the current topLeft x index.
 * @return the current topLeft x index.
 * @type {int}
 */
UCF_DataGridSegment["prototype"]["iGetTopLeftX"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["iGetTopLeftX"]++; }; 
	return this["oDataGridColumn"]["getFirstVisibleSegmentColumnIndex"]();
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["iGetTopLeftX"] = 0; };

/**
 * Returns the current topLeft y index.
 * @return the current topLeft y index.
 * @type {int}
 */
UCF_DataGridSegment["prototype"]["iGetTopLeftY"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["iGetTopLeftY"]++; }; 
	return this["oDataGridRow"]["getFirstVisibleSegmentRowIndex"]();
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["iGetTopLeftY"] = 0; };

/**
 * Performs resize actions for the current DataGridSegment
 * Triggers calculation of visible cell range.
 * Updates clientControl aggregation
 */
UCF_DataGridSegment["prototype"]["checkResize"] = function(bApply) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["checkResize"]++; }; 
	if (this["iResizeTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["iResizeTimer"]);
		this["iResizeTimer"] = null;
	}
	if (bApply && this["oDomRef"] && !this["oLS"]["bIsLocked"]) {
		this["initResize"]();
		this["getClientControl"]()["updateAggregation"]("Cells");
	} else {
		this["iResizeTimer"] = UCF_JsUtil["delayedCall"](0, this, "checkResize", [true]);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["checkResize"] = 0; };

/**
 * Handles the onlsdragstart event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataGridSegment["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["onlsdragstart"]++; }; 

	// no drag selection for touch devices
	if (oBrowserEvent["bIsTouchInteraction"]()) return;

	// no drag selection at headerCells
	var oEventSrcCoords = this["oGetEventSrcCoords"](oBrowserEvent);
	var bIsHeaderCell = this["oDataGridColumn"]["_sGetSegmentColumnType"](oEventSrcCoords["x"]) == "HEADERCOLUMN" || this["oDataGridRow"]["_sGetSegmentRowType"](oEventSrcCoords["y"]) == "HEADERROW";
	if (bIsHeaderCell) return;

	// no drag selection at cell editors
	var oCTElement = UCF_DomUtil["oGetCTElement"](oBrowserEvent["oSource"]);
	if (oCTElement["getAttribute"]("ct") != "DGSC") return;

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];

	if (oDragAndDropManager) {
		oDragAndDropManager["startDragSession"](this["sId"], null, UCF_DragSession["DRAG_TYPE"]["NONE"], null, null, null);
		//current drag mode: values: NONE, COL_RESIZE, ROW_RESIZE, SELECTION
		oDragAndDropManager["oDragSession"]["setCustomType"]("SELECTION");
		oDragAndDropManager["oDragSession"]["setCustomData"]({
			"oUCFSegment": this
		});
		this["clearModelSelectionRanges"](true);
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["bHandled"] = true;
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["onlsdragstart"] = 0; };

UCF_DataGridSegment["prototype"]["onlsdrag"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["onlsdrag"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DataGridSegment.js(417): onlsdrag"); };

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		oDragSession = oDragAndDropManager["oDragSession"],
		oDragDecoration = oDragAndDropManager["oGetDragDecoration"](),
		oDGSRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]),
		oUCFDataGrid = this["oDataGrid"]["getUCFInstance"](),
		iSegmentColumnIndex = this["iGetSegmentColumnIndex"](),
		iSegmentRowIndex = this["iGetSegmentRowIndex"](),
		oDataGridSegmentRect = null,
		oDecorationBoundaries = null,
		oRefContainer = null,
		oDataGridSegmentCellRect = null;

	if (oDragSession["sGetCustomType"]() == "SELECTION") {
		var oEventSrcCoords = this["oGetEventSrcCoords"](oBrowserEvent),
			oSelectionRangeOld = { "xStart": this["oSelectionRange"]["xStart"], "yStart": this["oSelectionRange"]["yStart"], "xEnd": this["oSelectionRange"]["xEnd"], "yEnd": this["oSelectionRange"]["yEnd"] };

		if (oBrowserEvent["iClientX"]() >= oDGSRect["left"] &&
			oBrowserEvent["iClientX"]() <= (oDGSRect["left"] + oDGSRect["width"]) &&
			oBrowserEvent["iClientY"]() >= oDGSRect["top"] &&
			oBrowserEvent["iClientY"]() <= (oDGSRect["top"] + oDGSRect["height"])) {

			this["oSelectionRange"]["xEnd"] = oEventSrcCoords["x"] - this["oDataGridColumn"]["getSegmentColumnIndexOffset"]();
			this["oSelectionRange"]["yEnd"] = oEventSrcCoords["y"] - this["oDataGridRow"]["getSegmentRowIndexOffset"]();

			if (this["oSelectionRange"]["xEnd"] != oSelectionRangeOld["xEnd"] || this["oSelectionRange"]["yEnd"] != oSelectionRangeOld["yEnd"]) {
				this["clearModelSelectionRanges"](false);
				this["addModelSelectionRange"](this["oSelectionRange"], 2, true);
			}
		}
	}
	if (oDragSession["sGetCustomType"]() == "ROW_RESIZE") {
		var iDGSMouseY = oBrowserEvent["iClientY"]();
		var iMinRowHeight = (oDragSession["oGetCustomData"]()["oDataGridSegmentRowRange"]["iTo_y"] - oDragSession["oGetCustomData"]()["oDataGridSegmentRowRange"]["iFrom_y"] + 1) * oUCFDataGrid["iMinSegmentRowHeight"];
		oDataGridSegmentRect = oDragSession["oGetCustomData"]()["oDataGridSegmentRect"];
		oDecorationBoundaries = oDragSession["oGetCustomData"]()["oDecorationBoundaries"];

		if (oDragSession["oGetCustomData"]()["oRefContainer"]) {
			oRefContainer = oDragSession["oGetCustomData"]()["oRefContainer"];
			var oRefRect = UCF_DomUtil["oGetObjectRect"](oRefContainer);
			iDGSMouseY += (-oRefRect["top"] + oRefContainer["scrollTop"]);
		}

		if (iDGSMouseY < oDecorationBoundaries["top"]) {
			if (oDecorationBoundaries["top"] < oDataGridSegmentRect["top"] + iMinRowHeight) {
				oUCFDataGrid["rowScrollToPosition"](iSegmentRowIndex, -2, -1, -1);
				oDecorationBoundaries["top"] += 1;
				oDecorationBoundaries["height"] -= 1;
				oDragDecoration["updateBoundaries"](oDecorationBoundaries);
			}
			iDGSMouseY = oDecorationBoundaries["top"];
		}
		if (iDGSMouseY > (oDecorationBoundaries["top"] + oDecorationBoundaries["height"])) {
			oUCFDataGrid["rowScrollToPosition"](iSegmentRowIndex, 2, -1, -1);
			oDecorationBoundaries["top"] = Math["max"]((oDecorationBoundaries["top"] - 1), oDataGridSegmentRect["top"]);
			oDecorationBoundaries["height"] = Math["min"]((oDecorationBoundaries["height"] + 1), oDataGridSegmentRect["height"]);
			oDragDecoration["updateBoundaries"](oDecorationBoundaries);
			iDGSMouseY = oDecorationBoundaries["top"] + oDecorationBoundaries["height"];
		}

		oDragSession["oGetCustomData"]()["iDataGridSegmentRowHeight"] = iDGSMouseY - oDecorationBoundaries["top"] + iMinRowHeight;
		oUCFDataGrid["applyRowResize"](oBrowserEvent, true);
	}
	if (oDragSession["sGetCustomType"]() == "COL_RESIZE") {
		var iDGSMouseX = oBrowserEvent["iClientX"]();
		var iMinColWidth = (oDragSession["oGetCustomData"]()["oDataGridSegmentColumnRange"]["iTo_x"] - oDragSession["oGetCustomData"]()["oDataGridSegmentColumnRange"]["iFrom_x"] + 1) * oUCFDataGrid["iMinSegmentColumnWidth"];
		oDataGridSegmentRect = oDragSession["oGetCustomData"]()["oDataGridSegmentRect"];
		oDataGridSegmentCellRect = oDragSession["oGetCustomData"]()["oDataGridSegmentCellRect"];
		oDecorationBoundaries = oDragSession["oGetCustomData"]()["oDecorationBoundaries"];

		if (window["UCF_System"]["bIsRTL"]) {
			if (oDragSession["oGetCustomData"]()["oRefContainer"]) {
				oRefContainer = oDragSession["oGetCustomData"]()["oRefContainer"];
				oRefRect = UCF_DomUtil["oGetObjectRect"](oRefContainer);
				iDGSMouseX += (-oRefRect["left"] + oRefContainer["scrollLeft"]);
			}

			if (iDGSMouseX > (oDecorationBoundaries["left"] + oDecorationBoundaries["width"])) {
				//				if (oDecorationBoundaries.left < oDataGridSegmentRect.left + iMinColWidth) {
				//					oUCFDataGrid.columnScrollToPosition(iSegmentColumnIndex, -2, -1, -1);
				//					oDecorationBoundaries.left += 1;
				//					oDecorationBoundaries.width -= 1;
				//					oDragDecoration.updateBoundaries(oDecorationBoundaries);
				//				}
				iDGSMouseX = oDecorationBoundaries["left"] + oDecorationBoundaries["width"];
			}
			if (iDGSMouseX < oDecorationBoundaries["left"]) {
				oUCFDataGrid["columnScrollToPosition"](iSegmentColumnIndex, 2, -1, -1);
				oDecorationBoundaries["width"] = Math["min"]((oDecorationBoundaries["width"] + 1), oDataGridSegmentRect["width"]);
				oDragDecoration["updateBoundaries"](oDecorationBoundaries);
				iDGSMouseX = oDecorationBoundaries["left"];
				oDataGridSegmentCellRect["left"] = oDecorationBoundaries["left"];
				oDataGridSegmentCellRect["width"] = oDecorationBoundaries["width"] + iMinColWidth;
			}
			oDragSession["oGetCustomData"]()["iDataGridSegmentColumnWidth"] = oDataGridSegmentCellRect["left"] + oDataGridSegmentCellRect["width"] - iDGSMouseX;
		} else {
			if (oDragSession["oGetCustomData"]()["oRefContainer"]) {
				oRefContainer = oDragSession["oGetCustomData"]()["oRefContainer"];
				oRefRect = UCF_DomUtil["oGetObjectRect"](oRefContainer);
				iDGSMouseX += (-oRefRect["left"] + oRefContainer["scrollLeft"]);
			}

			if (iDGSMouseX < oDecorationBoundaries["left"]) {
				if (oDecorationBoundaries["left"] < oDataGridSegmentRect["left"] + iMinColWidth) {
					oUCFDataGrid["columnScrollToPosition"](iSegmentColumnIndex, -2, -1, -1);
					oDecorationBoundaries["left"] += 1;
					oDecorationBoundaries["width"] -= 1;
					oDragDecoration["updateBoundaries"](oDecorationBoundaries);
				}
				iDGSMouseX = oDecorationBoundaries["left"];
			}
			if (iDGSMouseX > (oDecorationBoundaries["left"] + oDecorationBoundaries["width"])) {
				oUCFDataGrid["columnScrollToPosition"](iSegmentColumnIndex, 2, -1, -1);
				oDecorationBoundaries["left"] = Math["max"]((oDecorationBoundaries["left"] - 1), oDataGridSegmentRect["left"]);
				oDecorationBoundaries["width"] = Math["min"]((oDecorationBoundaries["width"] + 1), oDataGridSegmentRect["width"]);
				oDragDecoration["updateBoundaries"](oDecorationBoundaries);
				iDGSMouseX = oDecorationBoundaries["left"] + oDecorationBoundaries["width"];
			}
			oDragSession["oGetCustomData"]()["iDataGridSegmentColumnWidth"] = iDGSMouseX - oDecorationBoundaries["left"] + iMinColWidth;
		}
		oUCFDataGrid["applyColumnResize"](oBrowserEvent, true);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["onlsdrag"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * Key down handler for rangeSelection
 * not located in DataGrid.js because entirely different behaviour (focus and therefore browserEventSource stays at the first selected cell)
 */
UCF_DataGridSegment["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DataGridSegment.js(550): onkeydown"); };

	var iKey = oBrowserEvent["iKeyCode"](),
		oUCFDataGrid = this["oDataGrid"]["getUCFInstance"](),
		aSegmentMatrix = oUCFDataGrid["aSegmentMatrix"],
		iSegmentColumnIndex = this["iGetSegmentColumnIndex"](),
		iSegmentRowIndex = this["iGetSegmentRowIndex"](),
		iScrollDelta = 0,
		iTopLeftX = this["oDataGridColumn"]["getFirstVisibleSegmentColumnIndex"](),
		iTopLeftY = this["oDataGridRow"]["getFirstVisibleSegmentRowIndex"](),
		iBottomRightX = this["oDataGridColumn"]["iGetLastVisibleSegmentColumnIndex"]() - this["oDataGridColumn"]["getSegmentColumnIndexOffset"](),
		iBottomRightY = this["oDataGridRow"]["iGetLastVisibleSegmentRowIndex"]() - this["oDataGridRow"]["getSegmentRowIndexOffset"](),
		bCtrl = oBrowserEvent["bCtrl"](),
		bShift = oBrowserEvent["bShift"](),
		bCancel = false;

	if (iKey == UCF_KeyCodes["A"] && bCtrl) {
		var oSelectionRange = { "xStart": 0, "yStart": 0, "xEnd": "*", "yEnd": "*" };
		for (var row = 0; row < oUCFDataGrid["aDataGridRows"]["length"]; row++) {
			for (var col = 0; col < oUCFDataGrid["aDataGridColumns"]["length"]; col++) {
				aSegmentMatrix[row][col]["getUCFInstance"]()["clearModelSelectionRanges"](true);
				aSegmentMatrix[row][col]["getUCFInstance"]()["addModelSelectionRange"](oSelectionRange, 2, true);
				aSegmentMatrix[row][col]["getUCFInstance"]()["commitModelSelectionRanges"]();
			}
		}
		bCancel = true;
	} else if ((!window["UCF_System"]["bIsRTL"] && iKey == UCF_KeyCodes["ARROW_RIGHT"] && bShift && this["oSelectionRange"]["xEnd"] < (this["oDataGridColumn"]["getSegmentColumnCount"]() - 1)) ||
		(window["UCF_System"]["bIsRTL"] && iKey == UCF_KeyCodes["ARROW_LEFT"] && bShift && this["oSelectionRange"]["xEnd"] < (this["oDataGridColumn"]["getSegmentColumnCount"]() - 1))) {
		if ((this["oSelectionRange"]["xEnd"] + this["oDataGridColumn"]["getSegmentColumnIndexOffset"]() + 1) == (iBottomRightX - 2)) {
			iScrollDelta = this["oDataGridColumn"]["_fGetSegmentColumnWidth"](this["oSelectionRange"]["xEnd"]);
			oUCFDataGrid["columnScrollToPosition"](iSegmentColumnIndex, iScrollDelta, 1, -1);
		}
		this["oSelectionRange"]["xEnd"] += 1;
		this["clearModelSelectionRanges"](true);
		this["addModelSelectionRange"](this["oSelectionRange"], 2, true);
		this["commitModelSelectionRanges"]();
		bCancel = true;
	} else if ((!window["UCF_System"]["bIsRTL"] && iKey == UCF_KeyCodes["ARROW_LEFT"] && bShift && this["oSelectionRange"]["xEnd"] > 0) ||
		(window["UCF_System"]["bIsRTL"] && iKey == UCF_KeyCodes["ARROW_RIGHT"] && bShift && this["oSelectionRange"]["xEnd"] > 0)) {
		if (this["oSelectionRange"]["xEnd"] == (iTopLeftX + 1)) {
			iScrollDelta = 0 - this["oDataGridColumn"]["_fGetSegmentColumnWidth"](this["oSelectionRange"]["xEnd"]);
			oUCFDataGrid["columnScrollToPosition"](iSegmentColumnIndex, iScrollDelta, -1, -1);
		}
		this["oSelectionRange"]["xEnd"] -= 1;
		this["clearModelSelectionRanges"](true);
		this["addModelSelectionRange"](this["oSelectionRange"], 2, true);
		this["commitModelSelectionRanges"]();
		bCancel = true;
	} else if (iKey == UCF_KeyCodes["ARROW_DOWN"] && bShift && this["oSelectionRange"]["yEnd"] < (this["oDataGridRow"]["getSegmentRowCount"]() - 1)) {
		if ((this["oSelectionRange"]["yEnd"] + this["oDataGridRow"]["getSegmentRowIndexOffset"]() + 1) == (iBottomRightY - 2)) {
			iScrollDelta = this["oDataGridRow"]["_fGetSegmentRowHeight"](this["oSelectionRange"]["yEnd"]);
			oUCFDataGrid["rowScrollToPosition"](iSegmentRowIndex, iScrollDelta, 1, -1);
		}
		this["oSelectionRange"]["yEnd"] += 1;
		this["clearModelSelectionRanges"](true);
		this["addModelSelectionRange"](this["oSelectionRange"], 2, true);
		this["commitModelSelectionRanges"]();
		bCancel = true;
	} else if (iKey == UCF_KeyCodes["ARROW_UP"] && bShift && this["oSelectionRange"]["yEnd"] > 0) {
		if (this["oSelectionRange"]["yEnd"] == (iTopLeftY + 1)) {
			iScrollDelta = 0 - this["oDataGridRow"]["_fGetSegmentRowHeight"](this["oSelectionRange"]["yEnd"]);
			oUCFDataGrid["rowScrollToPosition"](iSegmentRowIndex, iScrollDelta, -1, -1);
		}
		this["oSelectionRange"]["yEnd"] -= 1;
		this["clearModelSelectionRanges"](true);
		this["addModelSelectionRange"](this["oSelectionRange"], 2, true);
		this["commitModelSelectionRanges"]();
		bCancel = true;
	}
	if (bCancel) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["onkeydown"] = 0; };

UCF_DataGridSegment["prototype"]["oGetEventSrcCoords"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["oGetEventSrcCoords"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DataGridSegment.js(626): oGetEventSrcCoords"); };

	var iX = 0,
		iY = 0,
		oEventSrcCoords = { "x": 0, "y": 0 },
		oDGSRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]),
		iPositionX = Math["max"](0, this["oDataGridColumn"]["iGetScrollPosition"]() + oBrowserEvent["iClientX"]() - oDGSRect["left"]),
		iPositionY = Math["max"](0, this["oDataGridRow"]["iGetScrollPosition"]() + oBrowserEvent["iClientY"]() - oDGSRect["top"]);

	if (window["UCF_System"]["bIsRTL"]) {
		iPositionX = Math["max"](0, this["oDataGridColumn"]["iGetScrollPosition"]() + oDGSRect["left"] + oDGSRect["width"] - oBrowserEvent["iClientX"]());
	}

	iX = this["oDataGridColumn"]["iCalcXindex"](iPositionX);
	iY = this["oDataGridRow"]["iCalcYindex"](iPositionY);

	oEventSrcCoords = { "x": iX, "y": iY };
	return oEventSrcCoords;
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["oGetEventSrcCoords"] = 0; };

UCF_DataGridSegment["prototype"]["setSelectionRange"] = function(oSelectionRange, bNormalizeToIndexOffset) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["setSelectionRange"]++; }; 

	this["oSelectionRange"]["xStart"] = bNormalizeToIndexOffset ? oSelectionRange["xStart"] - this["iSegmentColumnIndexOffset"] : oSelectionRange["xStart"];
	this["oSelectionRange"]["xEnd"] = bNormalizeToIndexOffset ? oSelectionRange["xEnd"] - this["iSegmentColumnIndexOffset"] : oSelectionRange["xEnd"];
	this["oSelectionRange"]["yStart"] = bNormalizeToIndexOffset ? oSelectionRange["yStart"] - this["iSegmentRowIndexOffset"] : oSelectionRange["yStart"];
	this["oSelectionRange"]["yEnd"] = bNormalizeToIndexOffset ? oSelectionRange["yEnd"] - this["iSegmentRowIndexOffset"] : oSelectionRange["yEnd"];
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["setSelectionRange"] = 0; };

UCF_DataGridSegment["prototype"]["oGetSelectionRange"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["oGetSelectionRange"]++; }; 
	return this["oSelectionRange"];
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["oGetSelectionRange"] = 0; };

UCF_DataGridSegment["prototype"]["addModelSelectionRange"] = function(oRange, iSelectionState, bNormalizeToIndexOffset) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["addModelSelectionRange"]++; }; 

	// no selection without model binding
	if (!this["getClientControl"]() || !this["getClientControl"]()["mBindingInfos"]["Cells"]) return;

	var xStartNormalized = (oRange["xStart"] == "*") ? oRange["xStart"] : bNormalizeToIndexOffset ? oRange["xStart"] + this["iSegmentColumnIndexOffset"] : oRange["xStart"],
		xEndNormalized = (oRange["xEnd"] == "*") ? oRange["xEnd"] : bNormalizeToIndexOffset ? oRange["xEnd"] + this["iSegmentColumnIndexOffset"] : oRange["xEnd"],
		yStartNormalized = (oRange["yStart"] == "*") ? oRange["yStart"] : bNormalizeToIndexOffset ? oRange["yStart"] + this["iSegmentRowIndexOffset"] : oRange["yStart"],
		yEndNormalized = (oRange["yEnd"] == "*") ? oRange["yEnd"] : bNormalizeToIndexOffset ? oRange["yEnd"] + this["iSegmentRowIndexOffset"] : oRange["yEnd"],
		xRangeStart = (xStartNormalized == "*" || xEndNormalized == "*") ? xStartNormalized : Math["min"](xStartNormalized, xEndNormalized),
		xRangeEnd = (xStartNormalized == "*" || xEndNormalized == "*") ? xEndNormalized : Math["max"](xStartNormalized, xEndNormalized),
		yRangeStart = (yStartNormalized == "*" || yEndNormalized == "*") ? yStartNormalized : Math["min"](yStartNormalized, yEndNormalized),
		yRangeEnd = (yStartNormalized == "*" || yEndNormalized == "*") ? yEndNormalized : Math["max"](yStartNormalized, yEndNormalized);

	var oBinding = this["getClientControl"]()["getBinding"]("Cells");
	oBinding["addSelection"](xRangeStart, yRangeStart, xRangeEnd, yRangeEnd, iSelectionState);

};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["addModelSelectionRange"] = 0; };

UCF_DataGridSegment["prototype"]["clearModelSelectionRanges"] = function(bCommitSelection) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["clearModelSelectionRanges"]++; }; 

	// no selection without model binding
	if (!this["getClientControl"]() || !this["getClientControl"]()["mBindingInfos"]["Cells"]) return;

	var oBinding = this["getClientControl"]()["getBinding"]("Cells");
	oBinding["clearSelections"](bCommitSelection);

};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["clearModelSelectionRanges"] = 0; };

UCF_DataGridSegment["prototype"]["commitModelSelectionRanges"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["commitModelSelectionRanges"]++; }; 

	// no selection without model binding
	if (!this["getClientControl"]() || !this["getClientControl"]()["mBindingInfos"]["Cells"]) return;

	var oBinding = this["getClientControl"]()["getBinding"]("Cells");
	oBinding["commitSelection"]();
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["commitModelSelectionRanges"] = 0; };

UCF_DataGridSegment["prototype"]["aGetModelSelectionRanges"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["aGetModelSelectionRanges"]++; }; 

	// no selection without model binding
	if (!this["getClientControl"]() || !this["getClientControl"]()["mBindingInfos"]["Cells"]) return;

	var oBinding = this["getClientControl"]()["getBinding"]("Cells"),
		aSelectionRanges = oBinding["aGetSelections"]();

	return aSelectionRanges;
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["aGetModelSelectionRanges"] = 0; };

UCF_DataGridSegment["prototype"]["cancelModelSelection"] = function(iSelectionState) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["cancelModelSelection"]++; }; 

	// no selection without model binding
	if (!this["getClientControl"]() || !this["getClientControl"]()["mBindingInfos"]["Cells"]) return;

	var oBinding = this["getClientControl"]()["getBinding"]("Cells");
	oBinding["cancelSelection"](iSelectionState);

};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["cancelModelSelection"] = 0; };

UCF_DataGridSegment["prototype"]["oGetModelSelection"] = function(iSelectionState) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["oGetModelSelection"]++; }; 

	// no selection without model binding
	if (!this["getClientControl"]() || !this["getClientControl"]()["mBindingInfos"]["Cells"]) return null;

	var oBinding = this["getClientControl"]()["getBinding"]("Cells"),
		oSelection = oBinding["aGetSelection"](iSelectionState);

	return oSelection;
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["oGetModelSelection"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_DataGridSegment["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_DataGridSegment["prototype"]["aEventNames"] = ["CellSelect"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_DataGridSegment["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_DataGridSegment["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_DataGridSegment["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the DataGridSegment
 * @param {number} iXIndex Index x coordinate of selected cell.
 * @param {number} iYIndex Index y coordinate of selected cell.
 * @fires DataGridSegment::CellSelect
 */
UCF_DataGridSegment["prototype"]["fireCellSelect"] = function(sId, iXIndex, iYIndex) {;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["fireCellSelect"]++; }; 
	/** @type {{Id: string, XIndex: number, YIndex: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "DataGridSegment.js(778): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DataGridSegment.js(779): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DataGridSegment.js(780): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iXIndex != null, "iXIndex != null", "DataGridSegment.js(781): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iXIndex) == "number", "typeof(iXIndex) == \"number\"", "DataGridSegment.js(782): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iYIndex != null, "iYIndex != null", "DataGridSegment.js(783): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iYIndex) == "number", "typeof(iYIndex) == \"number\"", "DataGridSegment.js(784): fireCellSelect"); };
	mParams = {
		"Id": sId,
		"XIndex": iXIndex,
		"YIndex": iYIndex
	};
	
	
	
	this["fireSemanticEvent"]("DataGridSegment", "CellSelect", mParams, true, false, false);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegment["_"]["fireCellSelect"] = 0; };

};
sap["ls"]["preload"]["UCF_DataGridSegmentCell"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragDropDecoration */
/// <reference path="./base/DragDropDecoration.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_DataGridSegmentCellDragDelegate */
/// <reference path="./delegates/DataGridSegmentCellDragDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_DataGridSegmentCell(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["UCF_DataGridSegmentCell"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) == "object", "typeof (oDomRef) == \"object\"", "DataGridSegmentCell.js(37): UCF_DataGridSegmentCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "DataGridSegmentCell.js(38): UCF_DataGridSegmentCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DataGridSegmentCell.js(39): UCF_DataGridSegmentCell"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oDomRef"] = oDomRef;

	this["oActionMenu"] = null;
	this["oDGSRect"] = null;
	this["oUCFSegment"] = null;
	this["oUCFDataGrid"] = null;
	this["oDragDelegate"] = null;
	this["bHCTouchLayer"] = false;
	this["bHCTouchLayerActivated"] = false;
};window["UCF_DataGridSegmentCell"] = UCF_DataGridSegmentCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DataGridSegmentCell"); UCF_DataGridSegmentCell["_"] = {UCF_DataGridSegmentCell: 0}; }; ;

UCF_DataGridSegmentCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_DataGridSegmentCell.prototype["sClassName"] = "UCF_DataGridSegmentCell";

UCF_DataGridSegmentCell["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["destroy"]++; }; 

	this["oActionMenu"] = null;
	this["oUCFSegment"] = null;
	this["oUCFDataGrid"] = null;
	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	this["sDragSourceInfo"] = null; // eslint-disable-line @ur/no-missing-setClientProperty
	this["oSegment"] = null;
	this["oDataGrid"] = null;
	this["aMenuItems"] = null;

	this["HCTouchLayerMenu"] = null;
	this["HCTouchLayerResize"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["destroy"] = 0; };

UCF_DataGridSegmentCell["prototype"]["createDragDelegate"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["createDragDelegate"]++; }; 

	if (!this["sDragSourceInfo"]) {
		if (this["oDragDelegate"]) {
			this["removeDelegate"](this["oDragDelegate"]);
		}
		return;
	}

	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["setDragSourceControl"](this);
		return;
	}

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DataGridSegmentCellDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["createDragDelegate"] = 0; };

UCF_DataGridSegmentCell["prototype"]["setDragSourceInfo"] = function (sDragSourceInfo) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["setDragSourceInfo"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (sDragSourceInfo) == "string", "typeof (sDragSourceInfo) == \"string\"", "DataGridSegmentCell.js(96): setDragSourceInfo"); };

	this["sDragSourceInfo"] = sDragSourceInfo;
	this["setClientProperty"]("DragSourceInfo", sDragSourceInfo, true);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["setDragSourceInfo"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_DataGridSegmentCell["prototype"]["onclick"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DataGridSegmentCell.js(108): onclick"); };

	this["handleClickEvent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onclick"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_DataGridSegmentCell["prototype"]["onmousedown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DataGridSegmentCell.js(119): onmousedown"); };

	if (oBrowserEvent["eGetMouseButtonState"]() != oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"]) return;

	if (oBrowserEvent["oDomEvent"]["srcElement"]["getAttribute"]("id") && oBrowserEvent["oDomEvent"]["srcElement"]["getAttribute"]("id")["indexOf"]("HCTouchLayer") != -1) {
		this["bHCTouchLayerActivated"] = true;
	} else {
		this["bHCTouchLayerActivated"] = false;
	}

	this["handleMouseDownEvent"](oBrowserEvent);

	// for browsers other than IE cancel mousedown event (when clicking the dataGridCell and not the cellEditor itself) to avoid focusing the outer DataGrid
	if (!(UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && oBrowserEvent["oSource"]["className"]["indexOf"]("lsDGSC") != -1) {
		oBrowserEvent["cancel"]();
	}
	// cancel in case clicking resize handle
	if (oBrowserEvent["oSource"]["style"]["cursor"] == "col-resize" || oBrowserEvent["oSource"]["style"]["cursor"] == "row-resize") {
		oBrowserEvent["cancel"]();
	}
	// cancel in case of cell being a dragsource in order to avoid text selection before starting the dragsession
	if (this["sDragSourceInfo"]) {
		oBrowserEvent["cancel"]();
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onmousedown"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_DataGridSegmentCell["prototype"]["onlsfocus"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DataGridSegmentCell.js(152): onlsfocus"); };

	this["checkScrollIntoView"]();

	//MS: Added focus handling
	if (oBrowserEvent["eGetMouseButtonState"]() != oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"]) return;
	this["oGetUCFDataGrid"]()["setFocusInfos"](this["getX"](), this["getY"](), this["oUCFSegment"]);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onlsfocus"] = 0; };

UCF_DataGridSegmentCell["prototype"]["handleClickEvent"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["handleClickEvent"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DataGridSegmentCell.js(162): handleClickEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oBrowserEvent) === "object", "typeof (oBrowserEvent) === \"object\"", "DataGridSegmentCell.js(163): handleClickEvent"); };

	var bHandled = false;

	//focus cell at click instead of mousedown
	if (!oBrowserEvent["bIsTouchInteraction"]()) {
		this["oGetUCFDataGrid"]()["focusCell"](this["getX"](), this["getY"](), this["oGetUCFSegment"]());
	}

	if (oBrowserEvent["oSource"]["className"]["indexOf"]("lsDGSCHierFrag") !== -1) {
		this["triggerHierarchyStateChange"]();
		bHandled = true;
	}

	if (oBrowserEvent["oSource"]["className"]["indexOf"]("lsDGSCSortFrag") !== -1 ||
		oBrowserEvent["oSource"]["className"]["indexOf"]("lsDGSCFilterFrag") !== -1 ||
		oBrowserEvent["oSource"]["className"]["indexOf"]("lsDGSCDividerFrag") !== -1) {

		var sActionMenuId = this["getClientControl"]()["getActionMenuId"]();
		if (!sActionMenuId || sActionMenuId === "") return;
		this["fireMenuAccess"](this["sId"], sActionMenuId);

		this["oActionMenu"] = this["oGetControlById"](sActionMenuId, true);
		if (this["oActionMenu"]) {
			if (this["oActionMenu"]["bOpened"]) {
				this["oActionMenu"]["close"]();
			} else {
				this["openMenu"](false, sActionMenuId, oBrowserEvent["bIsTouchInteraction"]());
			}
		}
		bHandled = true;
	}

	if (bHandled) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["handleClickEvent"] = 0; };

UCF_DataGridSegmentCell["prototype"]["triggerHierarchyStateChange"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["triggerHierarchyStateChange"]++; }; 
	if (this["getClientControl"]()) {
		switch (this["getClientControl"]()["getHierarchyState"]()) {
			case "EXPANDED":
				this["fireCollapse"](this["sId"]);
				break;
			case "EXPANDEDMINUS":
				this["fireCollapse"](this["sId"]);
				break;
			case "COLLAPSED":
				this["fireExpand"](this["sId"]);
				break;
			case "COLLAPSEDPLUS":
				this["fireExpand"](this["sId"]);
				break;
			default:
				break;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["triggerHierarchyStateChange"] = 0; };

UCF_DataGridSegmentCell["prototype"]["handleMouseDownEvent"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["handleMouseDownEvent"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DataGridSegmentCell.js(225): handleMouseDownEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oBrowserEvent) === "object", "typeof (oBrowserEvent) === \"object\"", "DataGridSegmentCell.js(226): handleMouseDownEvent"); };

	if (oBrowserEvent["bIsTouchInteraction"]()) {
		var sDataGridId = this["oGetUCFDataGrid"]()["sId"];

		if (this["bHCTouchLayer"] && oBrowserEvent["oSource"]["getAttribute"]("id") === "HCTouchLayerMenu") {
			var sActionMenuId = this["getClientControl"]()["getActionMenuId"]();
			if (sActionMenuId) {
				this["fireMenuAccess"](this["sId"], sActionMenuId);
				this["oActionMenu"] = this["oGetControlById"](sActionMenuId, true);
			} else {
				sActionMenuId = sDataGridId + "-HCMenu";
				this["oActionMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](sActionMenuId, true);
			}

			if (this["oActionMenu"]) {
				if (this["oActionMenu"]["bOpened"]) {
					this["oActionMenu"]["close"]();
				} else {
					this["openMenu"](false, sActionMenuId, oBrowserEvent["bIsTouchInteraction"]());
				}
			}
		}

		var bIsHeaderCell = (this["getClientControl"]()["_sRowType"] == "HEADERROW" || this["getClientControl"]()["_sColumnType"] == "HEADERCOLUMN");
		if (bIsHeaderCell) {
			this["createHCTouchLayer"]();
			return;
		}
	}

	// no selection when resizing, sorting, filtering, openActionMenu, expand, collapse
	if (oBrowserEvent["oSource"]["style"]["cursor"] != "col-resize" && oBrowserEvent["oSource"]["style"]["cursor"] != "row-resize" &&
		oBrowserEvent["oSource"]["className"]["indexOf"]("lsDGSCSortFrag") == -1 &&
		oBrowserEvent["oSource"]["className"]["indexOf"]("lsDGSCFilterFrag") == -1 &&
		oBrowserEvent["oSource"]["className"]["indexOf"]("lsDGSCDividerFrag") == -1 &&
		oBrowserEvent["oSource"]["className"]["indexOf"]("lsDGSCHierFrag") == -1) {
		// set focus info anyway to keep it in case of selection change rountrip
		this["oGetUCFDataGrid"]()["setFocusInfos"](this["getX"](), this["getY"](), this["oGetUCFSegment"]());
		this["triggerSelection"](oBrowserEvent["bCtrl"]());
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["handleMouseDownEvent"] = 0; };

/**
 * Handles the keydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataGridSegmentCell["prototype"]["onkeydown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onkeydown"]++; }; 

	var iKey = oBrowserEvent["iKeyCode"](),
		bShift = oBrowserEvent["bShift"]();

	if (bShift && (iKey == UCF_KeyCodes["ARROW_RIGHT"] || iKey == UCF_KeyCodes["ARROW_LEFT"] || iKey == UCF_KeyCodes["ARROW_UP"] || iKey == UCF_KeyCodes["ARROW_DOWN"])) {
		if (!this["getClientControl"]() || !this["getClientControl"]()["mBindingInfos"]["SelectionState"] ||
			this["getClientControl"]()["_sRowType"] == "HEADERROW" || this["getClientControl"]()["_sColumnType"] == "HEADERCOLUMN") {
			// no selection without model binding
			// no range selection at headerCells
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["bHandled"] = true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onkeydown"] = 0; };

/**
 * Handles the onlsdragstart event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataGridSegmentCell["prototype"]["onlsdragstart"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onlsdragstart"]++; }; 

	if (oBrowserEvent["oSource"]["style"]["cursor"] === "col-resize" ||
		(oBrowserEvent["bIsTouchInteraction"]() &&
			oBrowserEvent["oSource"]["getAttribute"]("id") &&
			oBrowserEvent["oSource"]["getAttribute"]("id")["indexOf"]("HCTouchLayerResize") != -1 &&
			this["getClientControl"]()["_sRowType"] === "HEADERROW")) {
		this["startColumnResize"](oBrowserEvent);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;
	} else if (oBrowserEvent["oSource"]["style"]["cursor"] === "row-resize" ||
		(oBrowserEvent["bIsTouchInteraction"]() &&
			oBrowserEvent["oSource"]["getAttribute"]("id") &&
			oBrowserEvent["oSource"]["getAttribute"]("id")["indexOf"]("HCTouchLayerResize") !== -1 &&
			this["getClientControl"]()["_sColumnType"] === "HEADERCOLUMN")) {
		this["startRowResize"](oBrowserEvent);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;
	}

	this["createDragDelegate"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onlsdragstart"] = 0; };

/**
 * Handles the onlsdrag event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataGridSegmentCell["prototype"]["onlsdragend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onlsdragend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DataGridSegmentCell.js(330): onlsdragend"); };
	if (!oBrowserEvent["bIsTouchInteraction"]()) return;
	this["bHCTouchLayerActivated"] = false;
	this["removeHCTouchLayer"]();
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onlsdragend"] = 0; };

/**
 * Open menu
 *
 * @param {boolean} bWithKeyboard determines if popup was opened with keyboard or mouse
 * @public
 */
UCF_DataGridSegmentCell["prototype"]["openMenu"] = function (bWithKeyboard, sActionMenuId, bIsTouchInteraction) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["openMenu"]++; }; 

	if (!sActionMenuId || sActionMenuId === "") return;
	this["oActionMenu"] = this["oGetControlById"](sActionMenuId, true);
	if (!this["oActionMenu"]) return;

	this["oActionMenu"]["setAutoRefocus"](true);
	this["oActionMenu"]["setOpenerRef"](this["oDomRef"]);
	this["oActionMenu"]["setOpenerId"](this["sId"]);
	if (bIsTouchInteraction) {
		this["oActionMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);
	} else {
		this["oActionMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
	}
	if (bIsTouchInteraction) {
		this["oActionMenu"]["attachEvent"](this["oActionMenu"]["E_EVENTS"]["Close"], this, "onActionMenuCloseByTouch");
	} else {
		this["oActionMenu"]["attachEvent"](this["oActionMenu"]["E_EVENTS"]["Close"], this, "onActionMenuClose");
	}

	if (bIsTouchInteraction) {
		this["oActionMenu"]["attachEvent"](this["oActionMenu"]["E_EVENTS"]["Select"], this, 'selectPopupMenu');
	}
	this["oActionMenu"]["open"](bWithKeyboard);

	if (!bIsTouchInteraction) return;
	this["bHCTouchLayerActivated"] = false;
	this["removeHCTouchLayer"]();
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["openMenu"] = 0; };

UCF_DataGridSegmentCell["prototype"]["onActionMenuClose"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onActionMenuClose"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "DataGridSegmentCell.js(373): onActionMenuClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "DataGridSegmentCell.js(374): onActionMenuClose"); };

	this["cleanUpActionMenu"](false);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onActionMenuClose"] = 0; };

UCF_DataGridSegmentCell["prototype"]["onActionMenuCloseByTouch"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onActionMenuCloseByTouch"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "DataGridSegmentCell.js(380): onActionMenuCloseByTouch"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "DataGridSegmentCell.js(381): onActionMenuCloseByTouch"); };

	this["cleanUpActionMenu"](true);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onActionMenuCloseByTouch"] = 0; };

UCF_DataGridSegmentCell["prototype"]["cleanUpActionMenu"] = function (bIsTouchInteraction) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["cleanUpActionMenu"]++; }; 
	if (this["oActionMenu"]) {
		this["oActionMenu"]["detachEvent"](this["oActionMenu"]["E_EVENTS"]["Close"], this);
		if (bIsTouchInteraction) {
			this["oActionMenu"]["detachEvent"](this["oActionMenu"]["E_EVENTS"]["Select"], this);
		}
		this["oActionMenu"] = null;

		if (!bIsTouchInteraction) return;
		this["bHCTouchLayerActivated"] = false;
		this["removeHCTouchLayer"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["cleanUpActionMenu"] = 0; };

/**
 * Returns the UCF_DataGridSegment instance this cell belongs to.
 * @return {UCF_DataGridSegment} the UCF_DataGridSegment instance this cell belongs to.
 */
UCF_DataGridSegmentCell["prototype"]["oGetUCFSegment"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["oGetUCFSegment"]++; }; 

	if (this["oUCFSegment"]) return this["oUCFSegment"];

	this["oUCFSegment"] = this["getClientControl"]()["getParent"]()["getUCFInstance"]();
	return this["oUCFSegment"];
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["oGetUCFSegment"] = 0; };

/**
 * Returns the DataGridSegment instance this cell belongs to.
 * @return {DataGridSegment} the DataGridSegment instance this cell belongs to.
 */
UCF_DataGridSegmentCell["prototype"]["oGetSegment"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["oGetSegment"]++; }; 

	if (this["oSegment"]) return this["oSegment"];

	this["oSegment"] = this["getClientControl"]()["getParent"]();
	return this["oSegment"];
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["oGetSegment"] = 0; };

/**
 * Returns the UCF_DataGrid instance this cell belongs to.
 * @return {UCF_DataGrid} the UCF_DataGrid instance this cell belongs to.
 */
UCF_DataGridSegmentCell["prototype"]["oGetUCFDataGrid"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["oGetUCFDataGrid"]++; }; 

	if (this["oUCFDataGrid"]) return this["oUCFDataGrid"];

	this["oUCFDataGrid"] = this["oGetUCFSegment"]()["oDataGrid"]["getUCFInstance"]();
	return this["oUCFDataGrid"];
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["oGetUCFDataGrid"] = 0; };

/**
 * Returns the DataGrid instance this cell belongs to.
 * @return {DataGrid} the DataGrid instance this cell belongs to.
 */
UCF_DataGridSegmentCell["prototype"]["oGetDataGrid"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["oGetDataGrid"]++; }; 

	if (this["oDataGrid"]) return this["oDataGrid"];

	this["oDataGrid"] = this["oGetSegment"]()["getParent"]()["getParent"]();
	return this["oDataGrid"];
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["oGetDataGrid"] = 0; };

UCF_DataGridSegmentCell["prototype"]["getX"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["getX"]++; }; 
	return this["getClientControl"]()["getBindingContext"]()["oParameter"]["x"];
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["getX"] = 0; };

UCF_DataGridSegmentCell["prototype"]["getY"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["getY"]++; }; 
	return this["getClientControl"]()["getBindingContext"]()["oParameter"]["y"];
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["getY"] = 0; };

UCF_DataGridSegmentCell["prototype"]["triggerPrimarySelection"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["triggerPrimarySelection"]++; }; 

	var iX = this["getX"](),
		iY = this["getY"](),
		oSelectionRange = { "xStart": iX, "yStart": iY, "xEnd": iX, "yEnd": iY },
		oSegment = this["getClientControl"]()["getParent"](),
		oUCFSegment = oSegment["getUCFInstance"](),
		oUCFDataGrid = oUCFSegment["oDataGrid"]["getUCFInstance"]();

	oUCFDataGrid["executePrimarySelection"](this, oUCFSegment, oSelectionRange);

};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["triggerPrimarySelection"] = 0; };

UCF_DataGridSegmentCell["prototype"]["triggerSelection"] = function (bMultiple) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["triggerSelection"]++; }; 

	var iX = this["getX"](),
		iY = this["getY"](),
		iSelected = 0,
		oSegment = this["getClientControl"]()["getParent"](),
		oUCFSegment = oSegment["getUCFInstance"](),
		oUCFDataGrid = oUCFSegment["oDataGrid"]["getUCFInstance"](),
		iSelectionColumnIndex = oUCFSegment["iGetSegmentColumnIndex"](),
		iSelectionRowIndex = oUCFSegment["iGetSegmentRowIndex"]();

	if (bMultiple && (this["getClientControl"]()["getSelectionState"]() == "SELECTED" || this["getClientControl"]()["getSelectionState"]() == "PRIMARY_SELECTED")) {
		iSelected = 0;
	} else {
		iSelected = 2;
	}

	//fire cell select
	oUCFSegment["fireCellSelect"](oSegment["getId"](), iX, iY);
	oUCFDataGrid["executeSelection"](this, iSelectionColumnIndex, iSelectionRowIndex, iSelected, bMultiple);

};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["triggerSelection"] = 0; };

UCF_DataGridSegmentCell["prototype"]["sGetPosition"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["sGetPosition"]++; }; 

	var oUCFSegment = this["oGetUCFSegment"](),
		iSegmentLeft = -oUCFSegment["oDomRef"]["firstChild"]["offsetLeft"],
		iSegmentTop = -oUCFSegment["oDomRef"]["firstChild"]["offsetTop"],
		iSegmentWidth = oUCFSegment["oDomRef"]["offsetWidth"],
		iSegmentHeight = oUCFSegment["oDomRef"]["offsetHeight"],
		iSegmentRight = iSegmentWidth - oUCFSegment["oDomRef"]["firstChild"]["offsetLeft"],
		iSegmentBottom = iSegmentHeight - oUCFSegment["oDomRef"]["firstChild"]["offsetTop"],
		iCellLeft = parseInt(this["getClientControl"]()["_sLeft"]),
		iCellTop = parseInt(this["getClientControl"]()["_sTop"]),
		iCellWidth = parseInt(this["getClientControl"]()["_sWidth"]),
		iCellHeight = parseInt(this["getClientControl"]()["_sHeight"]),
		iCellRight = iCellLeft + iCellWidth - 1,
		iCellBottom = iCellTop + iCellHeight - 1;

	if (window["UCF_System"]["bIsRTL"]) {
		iSegmentLeft = oUCFSegment["oDomRef"]["firstChild"]["offsetLeft"] - iSegmentWidth;
		iSegmentRight = oUCFSegment["oDomRef"]["firstChild"]["offsetLeft"];
	}

	if (iCellRight < iSegmentLeft || iCellBottom < iSegmentTop || iCellLeft > iSegmentRight || iCellTop > iSegmentBottom) {
		return "OUTSIDE";
	} else if (iCellLeft >= iSegmentLeft && iCellTop >= iSegmentTop && iCellRight <= iSegmentRight && iCellBottom <= iSegmentBottom) {
		return "INSIDE";
	} else {
		return "BORDER";
	}

};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["sGetPosition"] = 0; };

UCF_DataGridSegmentCell["prototype"]["checkScrollIntoView"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["checkScrollIntoView"]++; }; 

	// scrollIntoView logic
	var oUCFSegment = this["oGetUCFSegment"](),
		iSegmentColumnIndex = oUCFSegment["iGetSegmentColumnIndex"](),
		iSegmentRowIndex = oUCFSegment["iGetSegmentRowIndex"](),
		iSegmentWidth = oUCFSegment["oDomRef"]["offsetWidth"] - oUCFSegment["oDomRef"]["firstChild"]["offsetLeft"],
		iSegmentHeight = oUCFSegment["oDomRef"]["offsetHeight"] - oUCFSegment["oDomRef"]["firstChild"]["offsetTop"],
		iScrollPositionX = oUCFSegment["oDataGridColumn"]["iGetScrollPosition"](),
		iScrollPositionY = oUCFSegment["oDataGridRow"]["iGetScrollPosition"](),
		iCellLeft = parseInt(this["getClientControl"]()["_sLeft"]),
		iCellTop = parseInt(this["getClientControl"]()["_sTop"]),
		iCellWidth = parseInt(this["getClientControl"]()["_sWidth"]),
		iCellHeight = parseInt(this["getClientControl"]()["_sHeight"]),
		iCellRight = iCellLeft + iCellWidth,
		iCellBottom = iCellTop + iCellHeight,
		oUCFScrollBar = null,
		oScrollEventInfo = null;

	if (window["UCF_System"]["bIsRTL"]) {
		iSegmentWidth = oUCFSegment["oDomRef"]["firstChild"]["offsetLeft"];
	}

	if (iCellRight > iSegmentWidth) iScrollPositionX += (iCellRight - iSegmentWidth + 2);
	if (iCellLeft < (-oUCFSegment["oDomRef"]["firstChild"]["offsetLeft"])) iScrollPositionX = iCellLeft;

	if (iCellBottom > iSegmentHeight) iScrollPositionY += (iCellBottom - iSegmentHeight + 2);
	if (iCellTop < (-oUCFSegment["oDomRef"]["firstChild"]["offsetTop"])) iScrollPositionY = iCellTop;

	if (iScrollPositionX != oUCFSegment["oDataGridColumn"]["iGetScrollPosition"]()) {
		oUCFScrollBar = this["getClientControl"]()["getParent"]()["getParent"]()["getParent"]()["getUCFInstance"]()["aColumnScrollbars"][iSegmentColumnIndex];

		if (!oUCFScrollBar) return;

		oScrollEventInfo = oUCFScrollBar["oGetInternalEventInfo"]();
		oScrollEventInfo["bCalcVisibleCellRange"] = false;
		oUCFScrollBar["scrollToPosition"](iScrollPositionX);
		oScrollEventInfo["bCalcVisibleCellRange"] = true;
		oUCFSegment["oDomRef"]["scrollLeft"] = 0;
	}
	if (iScrollPositionY != oUCFSegment["oDataGridRow"]["iGetScrollPosition"]()) {
		oUCFScrollBar = this["getClientControl"]()["getParent"]()["getParent"]()["getParent"]()["getUCFInstance"]()["aRowScrollbars"][iSegmentRowIndex];

		if (!oUCFScrollBar) return;

		oScrollEventInfo = oUCFScrollBar["oGetInternalEventInfo"]();
		oScrollEventInfo["bCalcVisibleCellRange"] = false;
		oUCFScrollBar["scrollToPosition"](iScrollPositionY);
		oScrollEventInfo["bCalcVisibleCellRange"] = true;
		oUCFSegment["oDomRef"]["scrollLeft"] = 0;
	}

};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["checkScrollIntoView"] = 0; };

UCF_DataGridSegmentCell["prototype"]["startColumnResize"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["startColumnResize"]++; }; 

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		oDecoration = null,
		oCell = this["getClientControl"](),
		oSegment = oCell["getParent"](),
		oUCFSegment = oSegment["getUCFInstance"](),
		oDataGridColumn = oUCFSegment["oDataGridColumn"],
		oUCFDataGrid = oUCFSegment["oDataGrid"]["getUCFInstance"](),
		oRefContainer = UCF_DomUtil["oGetParentPositionReferenceContainer"](oUCFDataGrid["oDomRef"], true),
		oCellRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"], oRefContainer),
		oSegmentRect = UCF_DomUtil["oGetObjectRect"](oUCFSegment["oDomRef"], oRefContainer),
		iSegmentRight = oSegmentRect["left"] + oSegmentRect["width"],
		oTableRef = UCF_DomUtil["oGetParentByTagName"](oUCFSegment["oDomRef"], "TABLE"),
		oDataGridRect = UCF_DomUtil["oGetObjectRect"](oTableRef, oRefContainer),
		oScrollbarRect = null,
		iScrollbarHeight = 0,
		oDecorationBoundaries = null,
		oDataGridSegmentColumnRange = null,
		iColumnIndexOfSegment = oUCFSegment["iGetSegmentColumnIndex"](),
		iDecorationBoundariesWidth = 0,
		iDecorationBoundariesLeft = 0,
		iNormalizedIndex = 0,
		iFrom_x = 0,
		iTo_x = 0,
		iMinColWidth = oUCFDataGrid["iMinSegmentColumnWidth"];

	if (oCell["bIsMerged"]()) {
		iFrom_x = oCell["oMergeData"]["from_x"];
		for (var i = iFrom_x; i < this["getX"](); i++) {
			iNormalizedIndex = i - oDataGridColumn["_iStartIndex"];
			oCellRect["left"] -= oDataGridColumn["getSegmentColumn"](iNormalizedIndex)["getWidth"]();
			oCellRect["width"] += oDataGridColumn["getSegmentColumn"](iNormalizedIndex)["getWidth"]();
		}
		iMinColWidth = (oCell["oMergeData"]["to_x"] - oCell["oMergeData"]["from_x"] + 1) * iMinColWidth;
	}

	if (oUCFDataGrid["aColumnScrollbars"] && oUCFDataGrid["aColumnScrollbars"][0]) {
		oScrollbarRect = UCF_DomUtil["oGetObjectRect"](oUCFDataGrid["aColumnScrollbars"][0]["oDomRef"], oRefContainer);
		iScrollbarHeight = oScrollbarRect["height"];
	}

	if (oUCFDataGrid["aColumnScrollbars"] && oUCFDataGrid["aColumnScrollbars"][iColumnIndexOfSegment]) {
		if (window["UCF_System"]["bIsRTL"]) {
			iDecorationBoundariesLeft = oSegmentRect["left"];
			iDecorationBoundariesWidth = oCellRect["left"] + oCellRect["width"] - iMinColWidth - oSegmentRect["left"];
		} else {
			iDecorationBoundariesWidth = iSegmentRight - (oCellRect["left"] + iMinColWidth);
		}
	} else {
		if (window["UCF_System"]["bIsRTL"]) {
			iDecorationBoundariesLeft = 0;
			iDecorationBoundariesWidth = oCellRect["left"] + oCellRect["width"] - iMinColWidth - iDecorationBoundariesLeft;
		} else {
			iDecorationBoundariesWidth = oUCFDataGrid["oDomRef"]["offsetWidth"];
		}
	}

	if (window["UCF_System"]["bIsRTL"]) {
		oDecorationBoundaries = {
			"top": oDataGridRect["top"],
			"left": iDecorationBoundariesLeft,
			"width": iDecorationBoundariesWidth,
			"height": oDataGridRect["height"] - iScrollbarHeight
		};
	} else {
		oDecorationBoundaries = {
			"top": oDataGridRect["top"],
			"left": oCellRect["left"] + iMinColWidth,
			"width": iDecorationBoundariesWidth,
			"height": oDataGridRect["height"] - iScrollbarHeight
		};
	}

	oDecoration = new (UCF_ClassLoader["oGetClass"]("UCF_DragDropDecoration"))(oUCFDataGrid["oLS"], oUCFDataGrid["oDomRef"], oDecorationBoundaries);

	if (oCell["bIsMerged"]()) {
		iFrom_x = oCell["oMergeData"]["from_x"] - oUCFSegment["iSegmentColumnIndexOffset"];
		iTo_x = oCell["oMergeData"]["to_x"] - oUCFSegment["iSegmentColumnIndexOffset"];
	} else {
		iFrom_x = oCell["getBindingContext"]()["oParameter"]["x"] - oUCFSegment["iSegmentColumnIndexOffset"];
		iTo_x = iFrom_x;
	}
	oDataGridSegmentColumnRange = { "iFrom_x": iFrom_x, "iTo_x": iTo_x };

	var oDragSession = oDragAndDropManager["startDragSession"](oUCFDataGrid["sId"], "", UCF_DragSession["DRAG_TYPE"]["H_RESIZE"], oDecoration, null, null);
	//current drag mode: values: NONE, COL_RESIZE, ROW_RESIZE, SELECTION
	oDragSession["setCustomType"]("COL_RESIZE");
	oDragSession["setCustomData"]({
		"iColumnIndexOfSegment": iColumnIndexOfSegment,
		"oDataGridSegmentRect": oSegmentRect,
		"oDataGridSegmentCellRect": oCellRect,
		"iDataGridSegmentColumnIndex": oCell["getBindingContext"]()["oParameter"]["x"] - oUCFSegment["iSegmentColumnIndexOffset"],
		"oDataGridSegmentColumnRange": oDataGridSegmentColumnRange,
		"oDecorationBoundaries": oDecorationBoundaries,
		"oRefContainer": oRefContainer
	});

	oDecoration["init"](oDragAndDropManager["oDragSession"]);

};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["startColumnResize"] = 0; };

UCF_DataGridSegmentCell["prototype"]["startRowResize"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["startRowResize"]++; }; 

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		oDecoration = null,
		oCell = this["getClientControl"](),
		oSegment = oCell["getParent"](),
		oUCFSegment = oSegment["getUCFInstance"](),
		oDataGridRow = oUCFSegment["oDataGridRow"],
		oUCFDataGrid = oUCFSegment["oDataGrid"]["getUCFInstance"](),
		oRefContainer = UCF_DomUtil["oGetParentPositionReferenceContainer"](oUCFDataGrid["oDomRef"], true),
		oCellRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"], oRefContainer),
		oSegmentRect = UCF_DomUtil["oGetObjectRect"](oUCFSegment["oDomRef"], oRefContainer),
		iSegmentBottom = oSegmentRect["top"] + oSegmentRect["height"],
		oTableRef = UCF_DomUtil["oGetParentByTagName"](oUCFSegment["oDomRef"], "TABLE"),
		oDataGridRect = UCF_DomUtil["oGetObjectRect"](oTableRef, oRefContainer),
		oScrollbarRect = null,
		iScrollbarWidth = 0,
		oDecorationBoundaries = null,
		oDataGridSegmentRowRange = null,
		iRowIndexOfSegment = oUCFSegment["iGetSegmentRowIndex"](),
		iDecorationBoundariesHeight = 0,
		iNormalizedIndex = 0,
		iFrom_y = 0,
		iTo_y = 0,
		iMinRowHeight = oUCFDataGrid["iMinSegmentRowHeight"];

	if (oCell["bIsMerged"]()) {
		iFrom_y = oCell["oMergeData"]["from_y"];
		for (var i = iFrom_y; i < this["getY"](); i++) {
			iNormalizedIndex = i - oDataGridRow["_iStartIndex"];
			oCellRect["top"] -= oDataGridRow["getSegmentRow"](iNormalizedIndex)["getHeight"]();
			oCellRect["height"] += oDataGridRow["getSegmentRow"](iNormalizedIndex)["getHeight"]();
		}
		iMinRowHeight = (oCell["oMergeData"]["to_y"] - oCell["oMergeData"]["from_y"] + 1) * iMinRowHeight;
	}

	if (oUCFDataGrid["aRowScrollbars"] && oUCFDataGrid["aRowScrollbars"][0]) {
		oScrollbarRect = UCF_DomUtil["oGetObjectRect"](oUCFDataGrid["aRowScrollbars"][0]["oDomRef"], oRefContainer);
		iScrollbarWidth = oScrollbarRect["width"];
	}

	if (oUCFDataGrid["aRowScrollbars"] && oUCFDataGrid["aRowScrollbars"][iRowIndexOfSegment]) {
		iDecorationBoundariesHeight = iSegmentBottom - (oCellRect["top"] + iMinRowHeight);
	} else {
		iDecorationBoundariesHeight = oUCFDataGrid["oDomRef"]["offsetHeight"];
	}

	oDecorationBoundaries = {
		"top": oCellRect["top"] + iMinRowHeight,
		"left": oDataGridRect["left"],
		"width": oDataGridRect["width"] - iScrollbarWidth,
		"height": iDecorationBoundariesHeight
	};

	oDecoration = new (UCF_ClassLoader["oGetClass"]("UCF_DragDropDecoration"))(oUCFDataGrid["oLS"], oUCFDataGrid["oDomRef"], oDecorationBoundaries);

	if (oCell["bIsMerged"]()) {
		iFrom_y = oCell["oMergeData"]["from_y"] - oUCFSegment["iSegmentRowIndexOffset"];
		iTo_y = oCell["oMergeData"]["to_y"] - oUCFSegment["iSegmentRowIndexOffset"];
	} else {
		iFrom_y = oCell["getBindingContext"]()["oParameter"]["y"] - oUCFSegment["iSegmentRowIndexOffset"];
		iTo_y = iFrom_y;
	}
	oDataGridSegmentRowRange = { "iFrom_y": iFrom_y, "iTo_y": iTo_y };

	var oDragSession = oDragAndDropManager["startDragSession"](oUCFDataGrid["sId"], "", UCF_DragSession["DRAG_TYPE"]["V_RESIZE"], oDecoration, null, null);
	//current drag mode: values: NONE, COL_RESIZE, ROW_RESIZE, SELECTION
	oDragSession["setCustomType"]("ROW_RESIZE");
	oDragSession["setCustomData"]({
		"iRowIndexOfSegment": iRowIndexOfSegment,
		"oDataGridSegmentRect": oSegmentRect,
		"iDataGridSegmentRowIndex": oCell["getBindingContext"]()["oParameter"]["y"] - oUCFSegment["iSegmentRowIndexOffset"],
		"oDataGridSegmentRowRange": oDataGridSegmentRowRange,
		"oDecorationBoundaries": oDecorationBoundaries,
		"oRefContainer": oRefContainer
	});

	oDecoration["init"](oDragAndDropManager["oDragSession"]);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["startRowResize"] = 0; };

/**
 * Writes the appropriate accessibility text
 * @private
 */
UCF_DataGridSegmentCell["prototype"]["onlsaccessibility"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataGridSegmentCell.js(764): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		iSegmentColumnIndex = this["oGetUCFSegment"]()["iGetSegmentColumnIndex"](),
		iSegmentRowIndex = this["oGetUCFSegment"]()["iGetSegmentRowIndex"](),
		aSegmentMatrix = this["oGetUCFDataGrid"]()["aSegmentMatrix"],
		oCell = this["getClientControl"](),
		sAccControlType = "DGSC",
		bIsHeaderCell = (oCell["_sRowType"] == "HEADERROW" || oCell["_sColumnType"] == "HEADERCOLUMN"),
		sSelectionState = oCell["getSelectionState"](),
		bFiltered = oCell["getFiltered"](),
		sSortState = oCell["getSortState"](),
		sHierarchyState = oCell["getHierarchyState"](),
		iHierarchyLevel = oCell["getHierarchyLevel"](),
		sSemanticColor = oCell["getSemanticColor"](),
		oUCFSegment = null,
		sDataGridId = this["oGetUCFDataGrid"]()["sId"],
		iXoffset = 0,
		iYoffset = 0;

	for (var row = 0; row < iSegmentRowIndex; row++) {
		oUCFSegment = aSegmentMatrix[row][0]["getUCFInstance"]();
		iYoffset += oUCFSegment["oDataGridRow"]["getSegmentRowCount"]();
	}

	for (var col = 0; col < iSegmentColumnIndex; col++) {
		oUCFSegment = aSegmentMatrix[0][col]["getUCFInstance"]();
		iXoffset += oUCFSegment["oDataGridColumn"]["getSegmentColumnCount"]();
	}

	if (bIsHeaderCell) sAccControlType = "DGSC_HDR";

	var sRowParam = iYoffset + this["getY"](),
		sColumnParam = iXoffset + this["getX"](),
		sHeaderRowAccInfo = this["sGetHeaderRowAccInfo"](),
		sHeaderColumnAccInfo = this["sGetHeaderColumnAccInfo"]();

	if (sHeaderRowAccInfo != "") sRowParam = sHeaderRowAccInfo;
	if (sHeaderColumnAccInfo != "") sColumnParam = sHeaderColumnAccInfo;

	oAccessibilityHelper["setControlType"](sAccControlType, [sRowParam, sColumnParam]);
	if (sSelectionState == "SELECTED" || sSelectionState == "PRIMARY_SELECTED") {
		oAccessibilityHelper["setSelected"](true);
		oAccessibilityHelper["addEnabledTutor"]("ST_SC_S_TUT", true);
	} else {
		oAccessibilityHelper["addEnabledTutor"]("SELECT_TUT", true);
	}
	if (bFiltered) oAccessibilityHelper["setFiltered"](true);
	if (sSortState == "ASCENDING") oAccessibilityHelper["setSortedAscending"](true);
	if (sSortState == "DESCENDING") oAccessibilityHelper["setSortedDescending"](true);
	if (sHierarchyState["indexOf"]("EXP") != -1) {
		oAccessibilityHelper["setExpanded"](true);
		oAccessibilityHelper["addEnabledTutor"]("ST_COL_TUT", true);
	}
	if (sHierarchyState["indexOf"]("COL") != -1) {
		oAccessibilityHelper["setCollapsed"](true);
		oAccessibilityHelper["addEnabledTutor"]("ST_EXP_TUT", true);
	}
	if (sHierarchyState["indexOf"]("EXP") != -1 || sHierarchyState["indexOf"]("COL") != -1) oAccessibilityHelper["setLevel"](iHierarchyLevel);
	if (!bIsHeaderCell && sSemanticColor != "") {
		var oLegendDomRef = UCF_DomUtil["$"](sDataGridId + '-legend');
		if (oLegendDomRef) oAccessibilityHelper["setLegendJSDomRef"](oLegendDomRef);
		oAccessibilityHelper["addSemantic"](sSemanticColor);
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["onlsaccessibility"] = 0; };

UCF_DataGridSegmentCell["prototype"]["sGetHeaderColumnAccInfo"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["sGetHeaderColumnAccInfo"]++; }; 

	var aSegmentMatrix = this["oGetUCFDataGrid"]()["aSegmentMatrix"],
		iSegmentRowIndex = this["oGetUCFSegment"]()["iGetSegmentRowIndex"](),
		iSegmentColumnIndex = this["oGetUCFSegment"]()["iGetSegmentColumnIndex"](),
		sAccText = "",
		iX = this["getX"](),
		iMaxIndex,
		oCell;

	for (var iDataGridRow = 0; iDataGridRow <= iSegmentRowIndex; iDataGridRow++) {
		var oSegment = aSegmentMatrix[iDataGridRow][iSegmentColumnIndex],
			oUCFSegment = oSegment["getUCFInstance"]();
		//only take headerCells of non scrollable rows into account ... those which do always stay visible
		if (!oUCFSegment["oDataGridRow"]["getScrollbar"]()) {
			if (iDataGridRow == iSegmentRowIndex) {
				iMaxIndex = this["getY"]();
			} else {
				iMaxIndex = oUCFSegment["oDataGridRow"]["getSegmentRowCount"]() + oUCFSegment["oDataGridRow"]["getSegmentRowIndexOffset"]();
			}
			for (var iSegmentRow = oUCFSegment["oDataGridRow"]["getSegmentRowIndexOffset"](); iSegmentRow < iMaxIndex; iSegmentRow++) {
				var sId = null,
					sSegmentRowType = oUCFSegment["oDataGridRow"]["_sGetSegmentRowType"](iSegmentRow);
				if (sSegmentRowType == "HEADERROW") {
					sId = oSegment["getCellId"](iX, iSegmentRow);
					if (UCF_DomUtil["$"](sId)) {
						oCell = this["oLS"]["oControlFactory"]["oGetClientControlById"](sId);
						if (oCell) {
							var oEditor = oCell["getContent"]();
							if (oEditor["sClassName"] == "TextView") {
								if (sAccText == "") sAccText = oEditor["getText"]();
								else sAccText += " - " + oEditor["getText"]();
							} else if (oEditor["sClassName"] == "InputField") {
								if (sAccText == "") sAccText = oEditor["getValue"]();
								else sAccText += " - " + oEditor["getValue"]();
							}
						}
					}
				}
			}
		}
	}
	return sAccText;
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["sGetHeaderColumnAccInfo"] = 0; };

UCF_DataGridSegmentCell["prototype"]["sGetHeaderRowAccInfo"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["sGetHeaderRowAccInfo"]++; }; 

	var aSegmentMatrix = this["oGetUCFDataGrid"]()["aSegmentMatrix"],
		iSegmentRowIndex = this["oGetUCFSegment"]()["iGetSegmentRowIndex"](),
		iSegmentColumnIndex = this["oGetUCFSegment"]()["iGetSegmentColumnIndex"](),
		sAccText = "",
		iY = this["getY"](),
		iMaxIndex,
		oCell;

	for (var iDataGridCol = 0; iDataGridCol <= iSegmentColumnIndex; iDataGridCol++) {
		var oSegment = aSegmentMatrix[iSegmentRowIndex][iDataGridCol],
			oUCFSegment = oSegment["getUCFInstance"]();
		//only take headerCells of non scrollable columns into account ... those which do always stay visible
		if (!oUCFSegment["oDataGridColumn"]["getScrollbar"]()) {
			if (iDataGridCol == iSegmentColumnIndex) {
				iMaxIndex = this["getX"]();
			} else {
				iMaxIndex = oUCFSegment["oDataGridColumn"]["getSegmentColumnCount"]() + oUCFSegment["oDataGridColumn"]["getSegmentColumnIndexOffset"]();
			}
			for (var iSegmentCol = oUCFSegment["oDataGridRow"]["getSegmentRowIndexOffset"](); iSegmentCol < iMaxIndex; iSegmentCol++) {
				var sId = null,
					sSegmentColType = oUCFSegment["oDataGridColumn"]["_sGetSegmentColumnType"](iSegmentCol);
				if (sSegmentColType == "HEADERCOLUMN") {
					sId = oSegment["getCellId"](iSegmentCol, iY);
					if (UCF_DomUtil["$"](sId)) {
						oCell = this["oLS"]["oControlFactory"]["oGetClientControlById"](sId);
						if (oCell) {
							var oEditor = oCell["getContent"]();
							if (oEditor["sClassName"] == "TextView") {
								if (sAccText == "") sAccText = oEditor["getText"]();
								else sAccText += " - " + oEditor["getText"]();
							} else if (oEditor["sClassName"] == "InputField") {
								if (sAccText == "") sAccText = oEditor["getValue"]();
								else sAccText += " - " + oEditor["getValue"]();
							}
						}
					}
				}
			}
		}
	}
	return sAccText;
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["sGetHeaderRowAccInfo"] = 0; };

UCF_DataGridSegmentCell["prototype"]["createHCTouchLayer"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["createHCTouchLayer"]++; }; 

	if (this["bHCTouchLayer"]) return;

	this["HCTouchLayerMenu"] = document["createElement"]("DIV");
	this["HCTouchLayerMenu"]["setAttribute"]("id", "HCTouchLayerMenu");
	this["HCTouchLayerMenu"]["setAttribute"]("tabindex", "1");
	this["HCTouchLayerMenu"]["style"]["lineHeight"] = this["getClientControl"]()["_sHeight"];
	this["HCTouchLayerMenu"]["style"]["zIndex"] = "1";
	UCF_DomUtil["setClass"](this["HCTouchLayerMenu"], "lsSTHCTouchLayerMenu");
	this["oDomRef"]["appendChild"](this["HCTouchLayerMenu"]);

	var oClientCell = this["getClientControl"]();
	var sActionMenuId = oClientCell["getActionMenuId"]();
	var oActionMenu = null;
	var oActionMenuItem = null;
	var sDataGridId = this["oGetUCFDataGrid"]()["sId"];
	if (!sActionMenuId) sActionMenuId = sDataGridId + "-HCMenu";
	oActionMenu = this["oGetControlById"](sActionMenuId, true);
	if (!oActionMenu) {
		oActionMenu = this["oLS"]["oCreateClientControl"]({
			"PopupMenu": {
				"Id": sActionMenuId
			}
		});
		oActionMenu["placeAt"](this["oLS"]["oGetAssociatedAreaRef"]());
	}

	oActionMenu = this["oGetControlById"](sActionMenuId, true);
	if (oActionMenu) {
		// attach internal Select event
		// oActionMenu.attachEvent(oActionMenu.E_EVENTS.Select, this, 'selectPopupMenu');
		//first of all remove all added items
		this["aMenuItems"] = [{ "Id": sDataGridId + "-ColumnSelect", "Text": "Select Column" },
		{ "Id": sDataGridId + "-RowSelect", "Text": "Select Row" },
		{ "Id": sDataGridId + "-Expand", "Text": "Expand" },
		{ "Id": sDataGridId + "-Collapse", "Text": "Collapse" }];
		for (var i = 0; i < this["aMenuItems"]["length"]; i++) {
			oActionMenuItem = this["oGetControlById"](this["aMenuItems"][i]["Id"], false);
			if (oActionMenuItem) {
				oActionMenu["removeItem"](oActionMenuItem);
			}
		}
		if (oClientCell["_sRowType"] == "HEADERROW") {
			this["aMenuItems"] = [{ "Id": sDataGridId + "-ColumnSelect", "Text": "Select Column" }];
		}
		if (oClientCell["_sColumnType"] == "HEADERCOLUMN") {
			this["aMenuItems"] = [{ "Id": sDataGridId + "-RowSelect", "Text": "Select Row" }];
			if (oClientCell["getHierarchyState"]()["indexOf"]("EXP") != -1) {
				this["aMenuItems"]["push"]({ "Id": sDataGridId + "-Expand", "Text": "Expand" });
			}
			if (oClientCell["getHierarchyState"]()["indexOf"]("COL") != -1) {
				this["aMenuItems"]["push"]({ "Id": sDataGridId + "-Collapse", "Text": "Collapse" });
			}
		}
		for (var j = 0; j < this["aMenuItems"]["length"]; j++) {
			oActionMenu["addItem"](this["aMenuItems"][j]["Id"], this["aMenuItems"][j]["Text"], false, false, false, true, "", false, "", false, "", false, "", "", false, "", "", 1);
		}
	}

	this["HCTouchLayerResize"] = document["createElement"]("DIV");
	this["HCTouchLayerResize"]["setAttribute"]("id", "HCTouchLayerResize");
	this["HCTouchLayerResize"]["setAttribute"]("tabindex", "1");
	this["HCTouchLayerResize"]["style"]["lineHeight"] = this["getClientControl"]()["_sHeight"];
	this["HCTouchLayerResize"]["style"]["zIndex"] = "1";
	if (!sActionMenuId) {
		this["HCTouchLayerResize"]["style"]["width"] = "100%";
	}

	if (oClientCell["_sColumnType"] == "HEADERCOLUMN") {
		UCF_DomUtil["setClass"](this["HCTouchLayerResize"], "lsDGHCTouchLayerRowResize");
	}
	if (oClientCell["_sRowType"] == "HEADERROW") {
		UCF_DomUtil["setClass"](this["HCTouchLayerResize"], "lsDGHCTouchLayerColResize");
	}

	this["oDomRef"]["appendChild"](this["HCTouchLayerResize"]);

	this["bHCTouchLayer"] = true;
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["createHCTouchLayer"] = 0; };

UCF_DataGridSegmentCell["prototype"]["removeHCTouchLayer"] = function () {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["removeHCTouchLayer"]++; }; 
	if (!this["bHCTouchLayer"] || this["bHCTouchLayerActivated"]) return;

	if (this["HCTouchLayerMenu"]) this["oDomRef"]["removeChild"](this["HCTouchLayerMenu"]);
	if (this["HCTouchLayerResize"]) this["oDomRef"]["removeChild"](this["HCTouchLayerResize"]);

	this["bHCTouchLayer"] = false;
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["removeHCTouchLayer"] = 0; };

UCF_DataGridSegmentCell["prototype"]["selectPopupMenu"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["selectPopupMenu"]++; }; 

	var bHandled = false;
	var sDataGridId = this["oGetUCFDataGrid"]()["sId"];
	switch (oEvent["mParameters"]["sItemId"]) {
		case sDataGridId + "-RowSelect":
			this["triggerSelection"](false);
			bHandled = true;
			break;
		case sDataGridId + "-ColumnSelect":
			this["triggerSelection"](false);
			bHandled = true;
			break;
		case sDataGridId + "-Expand":
			this["triggerHierarchyStateChange"]();
			bHandled = true;
			break;
		case sDataGridId + "-Collapse":
			this["triggerHierarchyStateChange"]();
			bHandled = true;
			break;
		default:
			break;
	}
	if (bHandled) {
		if (this["oActionMenu"] && this["oActionMenu"]["bOpened"]) {
			this["oActionMenu"]["close"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["selectPopupMenu"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_DataGridSegmentCell["prototype"]["aAttributeNames"] = ["sCustomData","sDragSourceInfo"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_DataGridSegmentCell["prototype"]["aEventNames"] = ["Expand","Collapse","MenuAccess"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_DataGridSegmentCell["prototype"]["aMethodNames"] = ["openMenu","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_DataGridSegmentCell["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DataGridSegmentCell["prototype"]["sDragSourceInfo"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_DataGridSegmentCell["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';
	this["sDragSourceInfo"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("DragSourceInfo", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the dataGrid.
 * @fires DataGridSegmentCell::Expand
 */
UCF_DataGridSegmentCell["prototype"]["fireExpand"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["fireExpand"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "DataGridSegmentCell.js(1099): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DataGridSegmentCell.js(1100): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DataGridSegmentCell.js(1101): fireExpand"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("DataGridSegmentCell", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["fireExpand"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the dataGrid.
 * @fires DataGridSegmentCell::Collapse
 */
UCF_DataGridSegmentCell["prototype"]["fireCollapse"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "DataGridSegmentCell.js(1118): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DataGridSegmentCell.js(1119): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DataGridSegmentCell.js(1120): fireCollapse"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("DataGridSegmentCell", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["fireCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Button control in the current HTML document context. The Id of any control should be unique within the document.
 * @param {string} sPopupMenuId Identifier assigned PopupMenu in the current HTML document context. The Id of any control should be unique within the document.
 * @fires DataGridSegmentCell::MenuAccess
 */
UCF_DataGridSegmentCell["prototype"]["fireMenuAccess"] = function(sId, sPopupMenuId) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string, PopupMenuId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "DataGridSegmentCell.js(1138): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DataGridSegmentCell.js(1139): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DataGridSegmentCell.js(1140): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPopupMenuId != null, "sPopupMenuId != null", "DataGridSegmentCell.js(1141): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPopupMenuId) == "string", "typeof(sPopupMenuId) == \"string\"", "DataGridSegmentCell.js(1142): fireMenuAccess"); };
	mParams = {
		"Id": sId,
		"PopupMenuId": sPopupMenuId
	};
	
	
	this["fireSemanticEvent"]("DataGridSegmentCell", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCell["_"]["fireMenuAccess"] = 0; };

UCF_DataGridSegmentCell.prototype["aPublicMethods"] = ["openMenu"].concat(UCF_DataGridSegmentCell.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_DataGridSegmentCellDragDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Animation */
/// <reference path="../../anim/Animation.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_DataGridSegmentCellDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_DataGridSegmentCellDragDelegate["_"]["UCF_DataGridSegmentCellDragDelegate"]++; }; 
	UCF_DragDelegate["apply"](this, [oLS]);
	this["setDragSourceControl"](oDragSourceControl);
};window["UCF_DataGridSegmentCellDragDelegate"] = UCF_DataGridSegmentCellDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DataGridSegmentCellDragDelegate"); UCF_DataGridSegmentCellDragDelegate["_"] = {UCF_DataGridSegmentCellDragDelegate: 0}; }; ;

UCF_DataGridSegmentCellDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_DataGridSegmentCellDragDelegate.prototype["sClassName"] = "UCF_DataGridSegmentCellDragDelegate";

UCF_DataGridSegmentCellDragDelegate["prototype"]["oGetGhost"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCellDragDelegate["_"]["oGetGhost"]++; }; 

	var oDragSourceControl = this["oGetDragSourceControl"](oBrowserEvent),
		sDragSourceInfoId = this["oGetDragSourceInfoId"](oBrowserEvent),
		oDragSourceInfoControl = oDragSourceControl["oGetControlById"](sDragSourceInfoId),
		oGhost = null,
		oDataGrid = oDragSourceControl["oGetUCFDataGrid"]();

	var sHint = oDragSourceInfoControl["sHint"];

	if (sHint["indexOf"]('column') > -1) {
		this["sCellDragMode"] = 'column';
	}
	else {
		this["sCellDragMode"] = 'row';
	}

	var oRectMain = UCF_DomUtil["oGetObjectRect"](oDataGrid["oDomRef"]),
		oDomRefTmp = null,
		oRectTmp = UCF_DomUtil["oGetObjectRect"](this["oDragSourceControl"]["oDomRef"], oDataGrid["oDomRef"]),
		sClassName = 'urBorderBox lsDGSCDivRowHead',
		iLeftBegin = -1,
		iLeftEnd = -1,
		iTopBegin = -1,
		iTopEnd = -1,
		iWidthBegin = -1,
		iWidthEnd = -1,
		iHeightBegin = -1,
		iHeightEnd = -1;

	if (this["oDragSourceControl"]["getClientControl"]()["getSelectionState"]() === 'SELECTED' || this["oDragSourceControl"]["getClientControl"]()["getSelectionState"]() === 'PRIMARY_SELECTED') {
		sClassName += ' lsDGSCDivSel';
	}

	oDomRefTmp = document["createElement"]('div');
	var oStyleTmp = oDomRefTmp["style"];

	UCF_DomUtil["setClass"](oDomRefTmp, sClassName);

	iLeftEnd = oRectTmp["left"];
	iTopEnd = oRectTmp["top"];

	if (this["sCellDragMode"] === 'column') {
		iWidthEnd = 10;
		iHeightEnd = 150;
	} else {
		iWidthEnd = 150;
		iHeightEnd = 10;
	}

	if (window["UCF_System"]["bUseAnimation"]) {
		var oAnimation = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(oDomRefTmp, 1000);

		if (this["sCellDragMode"] === 'column') {
			iLeftBegin = iLeftEnd;
			iTopBegin = oRectTmp["top"];
			iWidthBegin = oRectTmp["width"];
			iHeightBegin = oRectMain["height"];
		} else {
			iLeftBegin = oRectTmp["left"];
			iTopBegin = iTopEnd;
			iWidthBegin = oRectMain["width"];
			iHeightBegin = oRectTmp["height"];
		}

		oStyleTmp["left"] = iLeftBegin + 'px';
		oStyleTmp["top"] = iTopBegin + 'px';
		oStyleTmp["width"] = iWidthBegin + 'px';
		oStyleTmp["height"] = iHeightBegin + 'px';

		oAnimation["addStyleChange"]('left', '', 'px', iLeftBegin, iLeftEnd, oAnimation["M_TRANSITIONS"]["EaseIn"]);
		oAnimation["addStyleChange"]('top', '', 'px', iTopBegin, iTopEnd, oAnimation["M_TRANSITIONS"]["EaseIn"]);
		oAnimation["addStyleChange"]('width', '', 'px', iWidthBegin, iWidthEnd, oAnimation["M_TRANSITIONS"]["EaseIn"]);
		oAnimation["addStyleChange"]('height', '', 'px', iHeightBegin, iHeightEnd, oAnimation["M_TRANSITIONS"]["EaseIn"]);
		oAnimation["play"]();
	} else {
		oStyleTmp["left"] = iLeftEnd + 'px';
		oStyleTmp["top"] = iTopEnd + 'px';
		oStyleTmp["width"] = iWidthEnd + 'px';
		oStyleTmp["height"] = iHeightEnd + 'px';
	}

	oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDomRefTmp, true);
	oGhost["applyAlphaFilter"](false);
	oGhost["setOffset"](0, 0);

	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCellDragDelegate["_"]["oGetGhost"] = 0; };

UCF_DataGridSegmentCellDragDelegate["prototype"]["bIsDragPossible"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCellDragDelegate["_"]["bIsDragPossible"]++; }; 

	var oDragSourceControl = this["oGetDragSourceControl"](oBrowserEvent),
		oCell = oDragSourceControl["getClientControl"](),
		bIsHeaderCell = (oCell["_sRowType"] === 'HEADERROW' || oCell["_sColumnType"] === 'HEADERCOLUMN');

	if (bIsHeaderCell) {
		return true;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_DataGridSegmentCellDragDelegate["_"]["bIsDragPossible"] = 0; };

};
sap["ls"]["preload"]["UCF_DataTip"] = function() {/* global _assert, _trace, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Animation */
/// <reference path="../anim/Animation.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_DataTip(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_DataTip["_"]["UCF_DataTip"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DataTip.js(34): UCF_DataTip"); };

	UCF_LayeredControl["apply"](this, [oDomRef, oLS]);
	// stores whether the control had got the focus already, if yes the datatip might not be shown a second time
	this["bIsFirstFocus"] = true;
	// checks if the datatip should be shown onfocus. If e.g. Label is hovered the DataTip should not be shown on focus (see Label)
	this["bShowOnActivate"] = true;
	// the dom reference that needs to be hovered to open the datatip
	this["oHoverDomRef"] = null;
	// the id of the timeout in case of mouse events opens the datatip
	this["sTimeOutId"] = '';
	// default alignment of the datatip, is overwritten in case e.g. datepicker, calendar and combobox checkbox with tooltip etc.
	this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);

	if (this["sDesign"] === 'NOTE') {
		this["setOffsetTop"](15);
	}

	// default datatip overlaps 1px of the opener control
	this["iOverlap"] = 1;
	this["iWidth"] = 0;
	if (oDomRef) {
		var id = oDomRef["id"]["split"]('-dtip')[0];
		if (window["UCF_System"]["bIsAria"]) {
			UCF_AriaStateHelper["addDescribedby"](UCF_DomUtil["$"](id), oDomRef["id"]);
		}

		// if (UCF_System.bIsAria) {
		// 	var sCt = UCF_DomUtil.$(id).getAttribute('ct');
		// 	if (sCt && (sCt === 'C_standards' || sCt === 'R_standards')) {
		// 		UCF_AriaStateHelper.addDescribedby(UCF_DomUtil.$(id), oDomRef.id);
		// 	}
		// }
	}
	this["bRootRefChecked"] = false;

	// In Control.onselectstart the bubbling of the selectstart will be
	// cancelled if text selection is not allowed for the DataTip. So it
	// won't be possible to select text in an InputField with attached DataTip.
	// CSN 442899 / 2020: we need the DataTip to allow text selection or we
	// have to change Control.onselectstart.
	this["allowTextSelection"]();
};window["UCF_DataTip"] = UCF_DataTip; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DataTip"); UCF_DataTip["_"] = {UCF_DataTip: 0}; }; ;

UCF_DataTip["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_DataTip.prototype["sClassName"] = "UCF_DataTip";

// UCF_DataTip.bIsAnyOpened prevents that a datatip can be opened when another dataTip is
// already opened
UCF_DataTip["bIsAnyOpened"] = false;

/**
 * Destructor
 */
UCF_DataTip["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["destroy"]++; }; 
	this["oOpenerRef"] = null;
	// UCF_JsUtil.clearDelayedCallsOfObject(this); Done in close() now
	this["close"]();
	this["remove"]();

	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sType"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sText"] = null;
	this["oHoverDomRefExcluded"] = null;
	this["sTimerId"] = null;
	this["bOpendedWithMouse"] = null;
	this["sDelayedOpen"] = null;
	this["iWidth"] = null;
	this["sTimeOutId"] = null;
	this["oHoverDomRef"] = null;

	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["destroy"] = 0; };

/**
 * @override
 * Setting the alignment while opened needs to reposition the data tip
 * @param { int } iAlignment The new alignment
 */
UCF_DataTip["prototype"]["setAlignment"] = function(iAlignment) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setAlignment"]++; }; 
	UCF_LayeredControl.prototype["setAlignment"]["apply"](this, arguments);
	if (this["bOpen"] && this["iAlignment"] !== iAlignment) {
		this["close"]();
		this["open"](); // open at the new position;
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setAlignment"] = 0; };

/**
 * Creates and renders the DataTip and applies it to the current root element of lightspeed
 *
 * @param { string } sId the id of the connected control
 * @param { UCF_LS } oLS
 */
UCF_DataTip["prototype"]["render"] = function(sId, oLS) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["render"]++; }; 
	this["connectToDom"](UCF_DataTip["render"](sId, oLS));
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["render"] = 0; };

/**
 * Creates and renders the DataTip and applies it to the current root element of lightspeed
 *  Innitially the DataTip will have display:none and
 *  it'll get display:block while setting the Text
 *
 * @param { string } sId the id of the connected control
 * @param { UCF_LS } oLS
 */

UCF_DataTip["render"] = function(sId, oLS) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["render"]++; }; 

	var oRenderManager = oLS["oGetRenderManager"](),
		oDiv;

	oRenderManager["write"](oLS["oGetRenderManager"]()["callFragment"](
		'DataTipFragment',
		'DataTip', {
			"ConnectedControlId": sId,
			"Text": this["sText"] ? this["sText"] : ' ',
			"Type": this["sType"] ? this["sType"] : 'TEXT',
			"TextDesign": this["sTextDesign"] ? this["sTextDesign"] : 'STANDARD',
			"ExplanationText": this["sExplanationText"] ? this["sExplanationText"] : '',
			"AutoShowOnFocus": true,
			"AutoShowOnFirstFocus": false,
			"AutoHideTimeout": 0,
			"EscapeText": true,
			"EscapeExplanationText": true,
			"Design": this["sDesign"] ? this["sDesign"] : 'DEFAULT',
			"CustomData": ''
		}
	));

	oDiv = oRenderManager["oGetElementFromHtml"]();
	oRenderManager["clearBuffer"]();
	oLS["oGetAssociatedAreaRef"]()["appendChild"](oDiv);
	// the initial for the content disply:none
	// in setText() the display:block will be set
	if (oDiv && oDiv["firstChild"]) {
		oDiv["firstChild"]["style"]["display"] = 'none';
	}

	return oDiv;
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["render"] = 0; };

/**
 * Set the SemanticColor for the
 * @param { string } sType - the semanticColor set via API
 * @return {Object} -
 */
UCF_DataTip["prototype"]["sDataTipGetIconClass"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["sDataTipGetIconClass"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'DataTipGetIconClass',
		'DataTip', { "Type": sType, "TextDesign": 'STANDARD', "Design": 'DEFAULT' }
	);
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["sDataTipGetIconClass"] = 0; };

/**
 * Set the SemanticColor for the
 * @param { string } sType - the semanticColor set via API
 * @return {Object} -
 */
UCF_DataTip["prototype"]["sDataTipGetTypeClass"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["sDataTipGetTypeClass"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'DataTipGetTypeClass',
		'DataTip', { "Type": sType, "Design": 'DEFAULT' }
	);
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["sDataTipGetTypeClass"] = 0; };

/**
 * Remove data tips HTML from DOM
 */
UCF_DataTip["prototype"]["remove"] = function() {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["remove"]++; }; 
	var oDomRef = this["oDomRef"];

	// CSN 1132921 2012: removeFromDom has to be called delayed, otherwise scrollsbars may not be rendererd correctly in IE.
	// This workaround can cause a side effect: the datatip may not be refreshed or it may not be removed correctly.
	// Reason is that the datatip is newly initialized while the old datatip has not yet been removed from the DOM
	// due to the delayed call. To make sure that the old data of the datatip is not retrieved from the DOM we
	// have to change its ID. 'markForDetetion' marks the datatip to be deleted delayed. Awful hack.
	if (oDomRef) {
		oDomRef["id"] = '';
		oDomRef["markForDeletion"] = 'true';
	}
	UCF_JsUtil["delayedCall"](0, this, 'removeFromDom');
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["remove"] = 0; };

/**
 * Removes the DataTip from dom and control factory.
 * @private
 */
UCF_DataTip["prototype"]["removeFromDom"] = function() {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["removeFromDom"]++; }; 
	if (this["oDomRef"]) {
		UCF_DomUtil["removeFromDom"](this["oDomRef"]);
	}
	if (this["oLS"]) {
		this["oLS"]["oControlFactory"]["purgeControl"](this);
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["removeFromDom"] = 0; };

/**
 * Handles the onlsfocus event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataTip["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onlsfocus"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataTip.js(238): onlsfocus"); };
	// checks if the datatip should be shown onfocus. If e.g. Label is hovered the DataTip should not be shown on focus (see Label)
	if (!this["bShowOnActivate"] || (!this["sText"] && !this["sExplanationText"])) return;

	// check the interface flags. show the datatip if it was the first focus or every time.
	if ((this["bAutoShowOnFirstFocus"] && this["bIsFirstFocus"]) || this["bAutoShowOnFocus"]) {
		// Wait until set into viewport has been processed
		this["sDelayedOpen"] = UCF_JsUtil["delayedCall"](100, this, 'open');
		this["bIsFirstFocus"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onlsfocus"] = 0; };

/**
 * Handles the hotkey event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataTip["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onlshotkey"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataTip.js(258): onlshotkey"); };
	// Ctrl + Shift + I
	var iKeyCode = oBrowserEvent["iKeyCode"]();
	if (iKeyCode === UCF_KeyCodes["I"] && oBrowserEvent["bCtrl"]() && !oBrowserEvent["bAlt"]() && oBrowserEvent["bShift"]()) {
		if (this["bOpened"]) this["close"]();
		else this["open"](true);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onlshotkey"] = 0; };

/**
 * Handles the onlsescape event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataTip["prototype"]["onlsescape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onlsescape"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataTip.js(277): onlsescape"); };

	if (this["bOpened"]) {
		this["close"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onlsescape"] = 0; };

/**
 * Handles the lsblur event event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataTip["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onlsblur"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataTip.js(294): onlsblur"); };
	UCF_JsUtil["clearDelayedCall"](this["sDelayedOpen"]);
	this["sDelayedOpen"] = null;
	this["close"]();
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onlsblur"] = 0; };

/**
 * Handles the mouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataTip["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onmouseover"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataTip.js(308): onmouseover"); };

	if (!this["oHoverDomRef"]) return;

	var oSource = oBrowserEvent["oGetSource"]();
	if (!this["bOpened"] &&
		this["oHoverDomRef"] &&
		UCF_DomUtil["bContains"](this["oHoverDomRef"], oSource) &&
		this["oHoverDomRefExclude"] !== oSource) {
		if (this["sTimeOutId"]) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](400, this, 'open', [true, true]);
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onmouseover"] = 0; };

/**
 * Handles the mouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataTip["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onmouseout"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataTip.js(332): onmouseout"); };
	if (this["sTimeOutId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
	}
	if (this["oHoverDomRef"] && this["bOpendedWithMouse"]) {
		this["bOpendedWithMouse"] = false;
		this["close"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onmouseout"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DataTip["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DataTip.js(351): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, this["sText"], "DataTip.js(354): onlsaccessibility"); };
	oAccessibilityHelper["setDataTip"](this["sText"]);
	oAccessibilityHelper["setExplanationText"](this["sExplanationText"]);

};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["onlsaccessibility"] = 0; };

/**
 * @param { boolean } bWithoutCloseTimeout
 *  @param { boolean } bOpendedWithMouse
 * Opens the datatip
 */
UCF_DataTip["prototype"]["open"] = function(bWithoutCloseTimeout, bOpendedWithMouse) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["open"]++; }; 

	// exit if another datatip is already open
	if (UCF_DataTip["bIsAnyOpened"]) return;
	if (this["bInvalidated"] && !this["sExplanationText"]) return;
	// the datatip has no text or explanation text then ignore the open
	if ((!this["sText"] || this["sText"] === '') &&
		(!this["sExplanationText"] || this["sExplanationText"] === '')) return;
	// somehow an invalid refernce is used
	if (!this["oLS"]) return;
	this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, 'close');
	if (!(this["oRootRef"] && this["oOpenerRef"]))
		return;
	// update sizes of control within DOM for changed DIVs above

	this["oDomRef"]["style"]["visibility"] = 'hidden';
	this["oDomRef"]["style"]["display"] = 'none';
	// Allow to display long words without disturbing the state icon
	if (this["iWidth"] === 0) {
		var oFirstChild = this["oDomRef"]["firstChild"];
		var asWords = (UCF_DomUtil["sGetInnerText"](oFirstChild["firstChild"]) + ' ' +
			UCF_DomUtil["sGetInnerText"](oFirstChild["lastChild"]))["split"](' ');
		var iLongest = UCF_DomUtil["oGetTextSize"](asWords[0], 'lsDataTip__text')["width"];
		var temp;
		for (var i = 1; i < asWords["length"]; i++) {
			temp = UCF_DomUtil["oGetTextSize"](asWords[i], 'lsDataTip__text')["width"];
			if (iLongest < temp)
				iLongest = temp;
		}
		if (this["sType"] !== 'Text')
			this["iWidth"] = 35 + iLongest;
		else
			this["iWidth"] = iLongest;
		if (this["iWidth"] < 200)
			this["iWidth"] = 200;
		this["oDomRef"]["style"]["width"] = this["iWidth"] + 'px';
	}

	if (this["oOpenerRef"]["id"] && this["oGetControlById"](this["oOpenerRef"]["id"])
		&& this["oGetControlById"](this["oOpenerRef"]["id"])["bScrolledIntoView"]
		&& !this["oGetControlById"](this["oOpenerRef"]["id"])["bScrolledIntoView"]())
		this["bMoveIntoViewPort"] = false;

	this["openBase"]();

	// special handling for scroll containers
	// var oDomRefSearchStart = this.oOpenerRef.parentNode;
	/* Note 2205368: If oPosContainer is a TABLE element, the button is not displayed (only IE Quirks).
	 * Hence, we search for the next parent scroll container which is a DIV
	 */
	// var bIgnoreTables = (UCF_UserAgent.bIsIE() && UCF_System.sDevice != 'standards') ? true : false;
	var iTopOffset = 4;
	var oPositionContainer = this["oGetParentScrollAreaDomRef"]();
	if (!oPositionContainer && this["oGetControlById"](this["oOpenerRef"]["id"])) {
		oPositionContainer = this["oGetControlById"](this["oOpenerRef"]["id"])["oGetParentScrollAreaDomRef"]();
		iTopOffset = 2;
	}
	var iWidth = this["oDomRef"]["clientWidth"];
	if (iWidth < 200)
		iWidth = 200;
	var iHeight = this["oDomRef"]["clientHeight"];
	UCF_DomUtil["oAddLayeredElement"](this["oDomRef"], this["oLS"]["oGetAssociatedAreaRef"](), oPositionContainer);
	this["oDomRef"]["style"]["width"] = iWidth + 'px';
	this["oDomRef"]["style"]["height"] = iHeight + 'px';
	var oRealParentRef = this["oOpenerRef"];
	if (oRealParentRef)
		if (this["oGetControlById"](oRealParentRef["id"]) && this["oGetControlById"](oRealParentRef["id"])["bUsedInSapTable"] === true)
			oRealParentRef = UCF_DomUtil["oGetParentElement"](this["oGetControlById"](oRealParentRef["id"])["oRootRef"]);
	var oObjectRect = UCF_DomUtil["oGetObjectRect"](oRealParentRef, oPositionContainer);
	var iTop = oObjectRect["top"] + this["oOpenerRef"]["clientHeight"] + iTopOffset;
	if (this["oOpenerRef"] && this["oGetControlById"](this["oOpenerRef"]["id"]) && this["oGetControlById"](this["oOpenerRef"]["id"])["bUsedInSapTable"] === true)
		iTop += 3;
	if (this["sDesign"] === 'NOTE')
		iTop = iTop + 15;
	var iScrollheight;
	if (oPositionContainer)
		iScrollheight = oPositionContainer["scrollHeight"];
	else
		iScrollheight = document["body"]["scrollHeight"];
	if (iTop + iHeight > iScrollheight) {
		// Do not extend the scrolling area
		iTop = oObjectRect["top"] - this["oOpenerRef"]["clientHeight"] - 14;
		if (this["sDesign"] === 'NOTE')
			iTop = iTop - 15;
	}
	// Do not overlap the opener control
	if (oObjectRect["top"] > iTop && oObjectRect["top"] < iTop + iHeight)
		iTop = oObjectRect["top"] + oObjectRect["height"] + 2;
	if (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"] && (iTop - iHeight - oObjectRect["height"]) >= 0)
		this["oDomRef"]["style"]["top"] = (iTop - iHeight - oObjectRect["height"]) + 'px';
	else
		this["oDomRef"]["style"]["top"] = iTop + 'px';
	// we have to avoid the appearance of onneeded scrollbars:
	// Internal Incident: EWM940SAT:Issue with scroll bar in Found HU screen - 1670136798
	var iLeft;
	if (this["oLS"]["oSystem"]["bIsRTL"])
		if (oPositionContainer)
			iLeft = oObjectRect["left"] + oObjectRect["width"] - iWidth - 3;
		else
			iLeft = oObjectRect["left"] + oObjectRect["width"] - iWidth;
	else
		iLeft = oObjectRect["left"];
	if (oPositionContainer)
		if (iLeft + iWidth > oPositionContainer["offsetWidth"])
			iLeft = oPositionContainer["offsetWidth"] - iWidth - 20;
	this["oDomRef"]["style"]["left"] = iLeft + 'px';

	// UCF_DataTip.bIsAnyOpened prevents that a datatip can be opened when another dataTip is
	// already opened
	UCF_DataTip["bIsAnyOpened"] = true;
	if (window["UCF_System"]["bIsAria"] && this["oDomRef"]) {
		this["oDomRef"]["setAttribute"]('aria-hidden', 'false');
	}

	this["bOpendedWithMouse"] = bOpendedWithMouse;
	if (this["iAutoHideTimeout"] > 0 && !bWithoutCloseTimeout) {
		this["sTimerId"] = UCF_JsUtil["delayedCall"](this["iAutoHideTimeout"] * 1000, this, 'close');
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["open"] = 0; };

/**
 * Closes the datatip
 */
UCF_DataTip["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["close"]++; }; 

	//Close the layered control in any case
	this["closeBase"]();

	if (window["UCF_System"]["bIsAria"] && this["oDomRef"]) {
		this["oDomRef"]["setAttribute"]('aria-hidden', 'true');
	}

	if (UCF_DataTip["bIsAnyOpened"]) {
		UCF_DataTip["bIsAnyOpened"] = false;
	}

	if (this["sTimeOutId"]) { //clear timer of method mouseover
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
	}
	if (this["oLS"])
		this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, 'close');
	UCF_JsUtil["clearDelayedCall"](this["sTimerId"]); //clear timer of method open
	UCF_JsUtil["clearDelayedCallsOfObject"](this);
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["close"] = 0; };

/**
 * Hides the explanation text part of the datatip
 */
UCF_DataTip["prototype"]["hideExplanation"] = function() {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["hideExplanation"]++; }; 
	if (this["sExplanationText"]) {

		// TODO: replace by UCF_DomUtil.lastChild(this.oDomRef) to avoid problems with text node
		this["oDomRef"]["lastChild"]["style"]["display"] = 'none';
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["hideExplanation"] = 0; };

/**
 * Shows the explanation text part of the datatip
 */
UCF_DataTip["prototype"]["showExplanation"] = function() {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["showExplanation"]++; }; 
	if (this["sExplanationText"]) {

		// TODO: replace by UCF_DomUtil.lastChild(this.oDomRef) to avoid problems with text node
		this["oDomRef"]["lastChild"]["style"]["display"] = 'block';
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["showExplanation"] = 0; };

/**
 * Fade in
 */
UCF_DataTip["prototype"]["fadeIn"] = function() {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["fadeIn"]++; }; 
	var iDelay = 600;
	if (this["sText"] && this["sText"]["length"] > 20) {
		iDelay = this["sText"]["length"] * 30;
	}

	UCF_JsUtil["delayedCall"](iDelay, this, 'fadeOut');
	this["open"]();

	UCF_DomUtil["setOpacityStyle"](this["oRootRef"], 0);

	var oAnim = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(this["oRootRef"], 200);
	oAnim["addOpacityChange"](10, 100, oAnim["M_TRANSITIONS"]["Linear"]);
	oAnim["play"]();

};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["fadeIn"] = 0; };

/**
 * Fade out
 */
UCF_DataTip["prototype"]["fadeOut"] = function() {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["fadeOut"]++; }; 
	this["close"]();
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["fadeOut"] = 0; };

/**
 * Sets the dom reference where the datatip should be shown on hover
 * @param {Element} oHoverDomRef the dom ref where the datatip should be shown
 */
UCF_DataTip["prototype"]["setHoverDomRef"] = function(oHoverDomRef) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setHoverDomRef"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oHoverDomRef) === 'object', "typeof(oHoverDomRef) === 'object'", "DataTip.js(564): setHoverDomRef"); };
	this["oHoverDomRef"] = oHoverDomRef;
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setHoverDomRef"] = 0; };

/**
 * Sets the dom reference where the datatip should be explicitly not shown on hover
 * @param {Element} oHoverDomRefExcluded the dom ref where the datatip should not be shown
 */
UCF_DataTip["prototype"]["setHoverDomRefExcluded"] = function(oHoverDomRefExcluded) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setHoverDomRefExcluded"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oHoverDomRefExcluded) === 'object', "typeof(oHoverDomRefExcluded) === 'object'", "DataTip.js(573): setHoverDomRefExcluded"); };
	this["oHoverDomRefExcluded"] = oHoverDomRefExcluded;
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setHoverDomRefExcluded"] = 0; };

/**
 * Set a new text for the datatip
 * @param { string } sText the text to be set
 */
UCF_DataTip["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setText"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sText) === 'string', "typeof(sText) === 'string'", "DataTip.js(583): setText"); };
	// set display:block for the parent which it might be set in render() function
	if (this["oDomRef"]
		&& this["oDomRef"]["firstChild"]
		&& this["oDomRef"]["firstChild"]["style"]["display"] === 'none') {
		this["oDomRef"]["firstChild"]["style"]["display"] = 'block';
	}

	if (this["oDomRef"]
		&& this["oDomRef"]["firstChild"]
		&& this["oDomRef"]["firstChild"]["firstChild"]) {
		this["oDomRef"]["firstChild"]["firstChild"]["innerText"] = sText;
	}

	this["sText"] = sText;
	// eslint-disable-next-line quotes
	this["setClientProperty"]("Text", this["sText"], true);
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setText"] = 0; };

/**
 * Set the type of the DataTip
 *
 * @param {string} sType
 */
UCF_DataTip["prototype"]["setType"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setType"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sType) === 'string', "typeof(sType) === 'string'", "DataTip.js(609): setType"); };
	this["setInvalidated"](false);
	var
		sNewIconClass = this["sDataTipGetIconClass"](sType),
		sNewTypeClass = this["sDataTipGetTypeClass"](sType);

	// TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	// Use this syntax because otherwise the class setting is not going to work
	// change the classes to the container
	if (this["oDomRef"] && this["oDomRef"]["firstChild"]) {
		UCF_DomUtil["setClass"](this["oDomRef"]["firstChild"], sNewTypeClass);
	}
	//change the classes for the Icon
	if (this["oDomRef"] && this["oDomRef"]["firstChild"] && this["oDomRef"]["firstChild"]["firstChild"]) {
		UCF_DomUtil["setClass"](this["oDomRef"]["firstChild"]["firstChild"], sNewIconClass);
	}

	this["sType"] = sType;
	// eslint-disable-next-line quotes
	this["setClientProperty"]("Type", this["sType"], true);

};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setType"] = 0; };

/**
 * Sets or removes the datatips invalidated state
 * Use this state in case the corresponding field was changed but not yet confirmed to be corrected
 * @param {boolean} bInvalidated The invalidated state
 */
UCF_DataTip["prototype"]["setInvalidated"] = function(bInvalidated) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setInvalidated"]++; }; 

	if (this["sText"] === '' || this["oDomRef"] == null) return;

	// TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	var oText = this["oDomRef"]["firstChild"],
		oImg = this["oDomRef"]["firstChild"]["firstChild"];
	if (bInvalidated) {
		oText["style"]["color"] = '#999';
		if (oImg["nodeType"] === 1) {
			UCF_DomUtil["setOpacityStyle"](oImg, 30);
		}
		this["bInvalidated"] = true;
	} else {
		oText["style"]["color"] = '';
		if (oImg["nodeType"] === 1) {
			UCF_DomUtil["setOpacityStyle"](oImg, 100);
		}
		this["bInvalidated"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setInvalidated"] = 0; };

/**
 * Check position of the root ref in the DOM and replace if needed.
 * If there is an old version of the same element remove it.
 * basically copied from the LayeredControl class
 */
UCF_DataTip["prototype"]["checkRootRef"] = function() {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["checkRootRef"]++; }; 
	if (this["bRootRefChecked"])
		return;
	this["bRootRefChecked"] = true;
	var oLSRootRef = this["oLS"]["oGetRootRef"](),
		oAssoArea = this["oLS"]["oGetAssociatedAreaRef"]();
	// if the menu is alread in the associated area of page exit without adding a placeholder
	if (oLSRootRef !== oAssoArea && UCF_DomUtil["bContains"](oAssoArea, this["oRootRef"])) return;

	if (this["oRootRef"]["parentNode"] !== oLSRootRef && UCF_DomUtil["bContains"](oLSRootRef, this["oRootRef"])) {
		this["oPlaceHolderRef"] = document["createElement"]('span');
		this["oPlaceHolderRef"]["style"]["display"] = 'none';
		this["oPlaceHolderRef"]["id"] = this["sId"] + '-ph';
		this["oRootRef"]["parentNode"]["replaceChild"](this["oPlaceHolderRef"], this["oRootRef"]);
		oLSRootRef["appendChild"](this["oRootRef"]);

		if (UCF_DomUtil["bContains"](this["oRootRef"], this["oDomRef"])) {
			// All ID duplicates which can be found by getElementById have to be
			// removed from DOM see CSN 2596413 2008
			UCF_DomUtil["removePreviousIdDuplicates"](this["oRootRef"]);
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Inconsistent oRootRef/oDomRef in control "' + this["sId"] + '"', "DataTip.js(685): checkRootRef"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["checkRootRef"] = 0; };

/**
 * Implementation to support generic texts for touch-contextmenu.
 * @private
 * @param {Array<Object>} aEntries
 */
UCF_DataTip["prototype"]["aChangeTouchContextMenuEntries"] = function(aEntries) {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["aChangeTouchContextMenuEntries"]++; }; 
	aEntries["push"]({
		"sType": 'DATATIP',
		"sText": this["sText"]
	});
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["aChangeTouchContextMenuEntries"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_DataTip["prototype"]["aAttributeNames"] = ["sText","sType","sTextDesign","sExplanationText","bAutoShowOnFocus","bAutoShowOnFirstFocus","iAutoHideTimeout","sDesign","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_DataTip["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_DataTip["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_DataTip["prototype"]["sText"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DataTipType}
 */
UCF_DataTip["prototype"]["sType"] = "TEXT";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputDesign}
 */
UCF_DataTip["prototype"]["sTextDesign"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_DataTip["prototype"]["sExplanationText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_DataTip["prototype"]["bAutoShowOnFocus"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_DataTip["prototype"]["bAutoShowOnFirstFocus"] = false;

/**
 * @private
 * @type {number}
 */
UCF_DataTip["prototype"]["iAutoHideTimeout"] = 0;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DataTipDesign}
 */
UCF_DataTip["prototype"]["sDesign"] = "DEFAULT";

/**
 * @private
 * @type {string}
 */
UCF_DataTip["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_DataTip["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["sType"] = "TEXT";
	this["sTextDesign"] = "STANDARD";
	this["sExplanationText"] = '';
	this["bAutoShowOnFocus"] = true;
	this["bAutoShowOnFirstFocus"] = false;
	this["iAutoHideTimeout"] = 0;
	this["sDesign"] = "DEFAULT";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Type", "TEXT", true);
		this["setClientProperty"]("TextDesign", "STANDARD", true);
		this["setClientProperty"]("ExplanationText", '', true);
		this["setClientProperty"]("AutoShowOnFocus", true, true);
		this["setClientProperty"]("AutoShowOnFirstFocus", false, true);
		this["setClientProperty"]("AutoHideTimeout", 0, true);
		this["setClientProperty"]("Design", "DEFAULT", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_DataTip["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Date"] = function() {/* global _assert, _trace, DEBUG, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_RequestUtil */
/// <reference path="../../core/util/RequestUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_MessageBundle */
/// <reference path="../helper/MessageBundle.js" />
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Properties */

/**
 * Class UCF_Date
 *
 * date object
 *
 * 
 * @class
 * @version
 * @param {number} iYear
 * @param {number} iMonth
 * @param {number} iDate
 * @param {number} iHours
 * @param {number} iMinutes
 * @param {number} iSeconds
 */
function UCF_Date(iYear, iMonth, iDate, iHours, iMinutes, iSeconds) {if (__UCF_COVERAGE__) { UCF_Date["_"]["UCF_Date"]++; }; 
	UCF_Object["apply"](this);

	this["oDate"] = new Date();
	if (typeof iYear === 'number' && iYear === Math["floor"](iYear)) {
		this["oDate"]["setFullYear"](iYear);
	}
	if (typeof iDate === 'number' && iDate === Math["floor"](iDate)) {
		this["oDate"]["setDate"](iDate);
	}
	if (typeof iMonth === 'number' && iMonth === Math["floor"](iMonth)) {
		this["oDate"]["setMonth"](iMonth);
	}
	if (typeof iHours === 'number' && iHours === Math["floor"](iHours)) {
		this["oDate"]["setHours"](iHours);
	} else {
		this["oDate"]["setHours"](0);
	}
	if (typeof iMinutes === 'number' && iMinutes === Math["floor"](iMinutes)) {
		this["oDate"]["setMinutes"](iMinutes);
	} else {
		this["oDate"]["setMinutes"](0);
	}
	if (typeof iSeconds === 'number' && iSeconds === Math["floor"](iSeconds)) {
		this["oDate"]["setSeconds"](iSeconds);
	} else {
		this["oDate"]["setSeconds"](0);
	}
	this["oDate"]["setMilliseconds"](0);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iMinimalDaysInFirstWeek"] = 4;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iFirstDayOfWeek"] = 0;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iFirstDayOfFirstWeek"] = -1;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iFirstDayOfFirstWeekYear"] = -1;
	if (UCF_System && typeof window["UCF_System"]["iFirstDayOfWeek"] === 'number') {
		this["iFirstDayOfWeek"] = window["UCF_System"]["iFirstDayOfWeek"];
	}
	if (UCF_System && typeof window["UCF_System"]["iMinimalDaysInFirstWeek"] === 'number') {
		this["iMinimalDaysInFirstWeek"] = window["UCF_System"]["iMinimalDaysInFirstWeek"];
	}
	if (UCF_System) {
		this["aWeekendDays"] = window["UCF_System"]["aGetWeekendDays"]();
	} else {
		this["aWeekendDays"] = null;
	}

	// eslint-disable-next-line @ur/no-memory-leaks
	this["sFormat"] = 'MM/dd/yyyy';

	if (!UCF_Date["oMessageBundle"]) {
		UCF_Date["oMessageBundle"] = new (UCF_ClassLoader["oGetClass"]("UCF_MessageBundle"))();
		UCF_Date["oMessageBundle"]["loadTexts"]();

		//Here the languages that need a lowercase of day and month are maintained.
		//Translation group always sets first letter to uppercase.

		var sLowerCaseFormatLanguages = ',mk,hu,sv,is,cs,it,no,ro,nl,ko,ru,lv,iw,hr,et,fi,es,be,ca,fr,sr,uk,vi,sq,ar,ja,sl,sk,da,pl,',
			sLoadedLanguage = UCF_Date["oMessageBundle"]["sGetLanguage"](),
			bToLowerLanguage = false;

		if (sLowerCaseFormatLanguages["indexOf"](',' + sLoadedLanguage["substring"](0, 2) + ',') > -1) {
			bToLowerLanguage = true;
		}
		// months
		for (var i = 0; i < 12; i++) {
			UCF_Date["aMonthNames"][i] = UCF_Date["oMessageBundle"]["sGetText"]('SAPUR_' + UCF_Date["MONTHNAMES"][i]);
			UCF_Date["aMonthNames3"][i] = UCF_Date["aMonthNames"][i]["substring"](0, 3);
			if (bToLowerLanguage) {
				UCF_Date["aFormatMonthNames"][i] = UCF_Date["aMonthNames"][i]["toLowerCase"]();
				UCF_Date["aFormatMonthNames3"][i] = UCF_Date["aMonthNames"][i]["substring"](0, 3)["toLowerCase"]();
			} else {
				UCF_Date["aFormatMonthNames"][i] = UCF_Date["aMonthNames"][i];
				UCF_Date["aFormatMonthNames3"][i] = UCF_Date["aMonthNames"][i]["substring"](0, 3);
			}
		}
		// days
		for (i = 0; i < 7; i++) {
			UCF_Date["aDayNames"][i] = UCF_Date["oMessageBundle"]["sGetText"]('SAPUR_' + UCF_Date["DAYNAMES"][i]);
			UCF_Date["aDayNamesAbbrev"][i] = UCF_Date["oMessageBundle"]["sGetText"]('SAPUR_' + UCF_Date["DAYNAMES"][i] + '_ABBREV');
			UCF_Date["aDayNames2"][i] = UCF_Date["aDayNames"][i]["substring"](0, 2);
			UCF_Date["aDayNames3"][i] = UCF_Date["aDayNames"][i]["substring"](0, 3);
			if (bToLowerLanguage) {
				UCF_Date["aFormatDayNames"][i] = UCF_Date["aDayNames"][i]["toLowerCase"]();
				UCF_Date["aFormatDayNames3"][i] = UCF_Date["aDayNames"][i]["substring"](0, 3)["toLowerCase"]();
			} else {
				UCF_Date["aFormatDayNames"][i] = UCF_Date["aDayNames"][i];
				UCF_Date["aFormatDayNames3"][i] = UCF_Date["aDayNames"][i]["substring"](0, 3);
			}
		}
	}
};window["UCF_Date"] = UCF_Date; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Date"); UCF_Date["_"] = {UCF_Date: 0}; }; ;
UCF_Date["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Date.prototype["sClassName"] = "UCF_Date";

/**
 * Milliseconds of one day
 */
UCF_Date["DAY"] = 86400000;

/**
 * Milliseconds of one week
 */
UCF_Date["WEEK"] = 86400000 * 7; //

/**
 * Threshold for 1 or 2 digit year parsing.
 * Years less than currentyear + threshold belong to the current century,
 * Years that are greater or equal currentyear + threshold belong to the last century
 * In 2007 parsing year string 37 will lead to 2037, parsing 38 will lead to 1938
 * In 2008 parsing year string 38 will lead to 2038, parsing 39 will lead to 1939
 *
 */
UCF_Date["YEAR2DIGITTHRESHOLD"] = 30;

/**
 * In 2008 parsing year string 38 will lead to 2038, parsing 39 will lead to 1939
 */
UCF_Date["MINYEAR"] = 1;
UCF_Date["MAXYEAR"] = 9999;

/**
 * Array of Monthnames
 */
UCF_Date["oMessageBundle"] = null;
UCF_Date["MONTHNAMES"] = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
UCF_Date["aMonthNames3"] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
UCF_Date["aFormatMonthNames3"] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
UCF_Date["aMonthNames"] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
UCF_Date["aFormatMonthNames"] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

/**
 * Array of Daynames
 */
UCF_Date["DAYNAMES"] = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
UCF_Date["aDayNames3"] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
UCF_Date["aFormatDayNames3"] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
UCF_Date["aDayNames2"] = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
UCF_Date["aDayNames"] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
UCF_Date["aFormatDayNames"] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
UCF_Date["aDayNamesAbbrev"] = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

/**
 * Static helper UCF_Date.bFormatContainsTime( sFormat )
 */

UCF_Date["bFormatContainsTime"] = function(sFormat) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["bFormatContainsTime"]++; }; 
	return (/.*[ahmsH].*/g["exec"](sFormat) != null);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["bFormatContainsTime"] = 0; };

/** @override */
UCF_Date["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["destroy"]++; }; 
	this["sFormat"] = null;
	this["aWeekendDays"] = null;
	this["iFirstDayOfFirstWeekYear"] = null;
	this["iFirstDayOfWeek"] = null;
	this["iFirstDayOfFirstWeek"] = null;
	this["iMinimalDaysInFirstWeek"] = null;
	this["oDate"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["destroy"] = 0; };

/**
 * Method iGetYear
 *
 * returns the year as a full year with all digits
 * @return {number}
 */
UCF_Date["prototype"]["iGetYear"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetYear"]++; }; 
	return this["oDate"]["getFullYear"]();
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetYear"] = 0; };

/**
 * Method setYear
 *
 * sets the year as a full year with all digits.
 * returns the UCF_Date instance
 *
 * @param {int} iYear the year as full year
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["setYear"] = function(iYear) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setYear"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iYear === 'number', "typeof iYear === 'number'", "Date.js(220): setYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iYear === Math["floor"](iYear), "iYear === Math.floor(iYear)", "Date.js(221): setYear"); };

	this["oDate"]["setFullYear"](iYear);
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setYear"] = 0; };

/**
 * Method iGetMonth
 *
 * returns the month
 * @return {int}
 */
UCF_Date["prototype"]["iGetMonth"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetMonth"]++; }; 
	return this["oDate"]["getMonth"]();
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetMonth"] = 0; };

/**
 * Method setMonth
 *
 * sets month starting at 0 for january.
 * returns the UCF_Date instance
 *
 * @param {int} iMonth the month
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["setMonth"] = function(iMonth) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setMonth"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iMonth === 'number', "typeof iMonth === 'number'", "Date.js(248): setMonth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMonth === Math["floor"](iMonth), "iMonth === Math.floor(iMonth)", "Date.js(249): setMonth"); };

	this["oDate"]["setMonth"](iMonth);
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setMonth"] = 0; };

/**
 * Method setMonthChecked
 *
 * sets month starting at 0 for january and adjusts the day.
 * returns the UCF_Date instance
 *
 * @param {int} iMonth the month
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["setMonthChecked"] = function(iMonth) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setMonthChecked"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iMonth === 'number', "typeof iMonth === 'number'", "Date.js(265): setMonthChecked"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMonth === Math["floor"](iMonth), "iMonth === Math.floor(iMonth)", "Date.js(266): setMonthChecked"); };

	var oMonthArray = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var iDate = this["iGetDate"]();
	if (oMonthArray[iMonth] <= iDate) {
		iDate = oMonthArray[iMonth];
		if (iMonth === 1 && !this["bGetLeapYear"]() && iDate === 29) {
			iDate = 28;
		}
	}
	this["setDate"](iDate);
	this["setMonth"](iMonth);
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setMonthChecked"] = 0; };

/**
 * Returns the last day in the month for this date.
 * @return {int} last day in the month for this date.
 *
 * @private
 */
UCF_Date["prototype"]["iGetLastDateInMonth"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetLastDateInMonth"]++; }; 
	var aDays = [31, this["iGetMonth"]() === 1 && this["bGetLeapYear"]() ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	return aDays[this["iGetMonth"]()];
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetLastDateInMonth"] = 0; };

/**
 * Moves the month by the given iMonths and and saves the date to be at the last date of the month if the current day would not exist
 * in the target month.
 * Example 03/31/2003 -> moveMonth(-1) will set 02/28/2003 not 02/03/2003 as in addMonth(-1)
 * @param {int} iMonths The months to move
 *
 * @private
 */
UCF_Date["prototype"]["moveMonths"] = function(iMonths) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["moveMonths"]++; }; 
	var oTargetDate = this["oGetClone"](),
		iDate = oTargetDate["iGetDate"]();
	this["setDate"](15);
	this["addMonths"](iMonths);
	var iLastDate = this["iGetLastDateInMonth"]();
	if (iDate > iLastDate) {
		iDate = iLastDate;
	}
	this["setDate"](iDate);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["moveMonths"] = 0; };

/**
 * Moves the year by the given iYears and and saves the date to be at the last date of the month if the current day would not exist
 * in the target month.
 * @see UCF_Date.prototype.moveMonths
 * @param {int} iYears The years to move
 *
 * @private
 */
UCF_Date["prototype"]["moveYears"] = function(iYears) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["moveYears"]++; }; 
	this["moveMonths"](iYears * 12);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["moveYears"] = 0; };

/**
 * Method iGetDate
 *
 * returns the date of the month
 * @return {int}
 */

UCF_Date["prototype"]["iGetDate"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetDate"]++; }; 
	return this["oDate"]["getDate"]();
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetDate"] = 0; };

/**
 * Method setDate
 *
 * sets the day of the month starting at 1.
 * returns the UCF_Date instance
 *
 * @param {int} iDate the day of the month
 * @see addDays
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["setDate"] = function(iDate) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setDate"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iDate === 'number', "typeof iDate === 'number'", "Date.js(347): setDate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDate === Math["floor"](iDate), "iDate === Math.floor(iDate)", "Date.js(348): setDate"); };

	this["oDate"]["setDate"](iDate);
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setDate"] = 0; };

/**
 * Method getFirstDayOfFirstWeek
 *
 * returns milliseconds since 1970 of the first day of the first week of a year
 * The algorythm uses the objects attributes iFirstDayOfWeek, iMinimalDaysInFirstWeek
 *
 * @param {int} iFullYear the full year as integer
 */

UCF_Date["prototype"]["getFirstDayOfFirstWeek"] = function(iFullYear) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["getFirstDayOfFirstWeek"]++; }; 
	var oFirstDay = new Date(iFullYear, 0, this["iMinimalDaysInFirstWeek"], 0, 0, 0);
	var iFirstDay = oFirstDay["getDay"]();
	var iDiff = iFirstDay - this["iFirstDayOfWeek"];
	if (iDiff < 0)
		iDiff += 7;
	var ilFirstDayOfFirstWeek =
		oFirstDay["getTime"]() - (iDiff) * UCF_Date["DAY"];
	return ilFirstDayOfFirstWeek;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["getFirstDayOfFirstWeek"] = 0; };

/**
 * Method iGetWeek
 *
 * returns the week number of the date
 * @return {integer}
 */
UCF_Date["prototype"]["iGetWeek"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetWeek"]++; }; 

	var oCurrentDate = new Date(this["oDate"]);
	oCurrentDate["setHours"](0);
	if (this["iFirstDayOfFirstWeek"] === -1 || this["iFirstDayOfFirstWeekYear"] !== oCurrentDate["getFullYear"]()) {
		this["iFirstDayOfFirstWeek"] = this["getFirstDayOfFirstWeek"](oCurrentDate["getFullYear"]());
		this["iFirstDayOfFirstWeekYear"] = oCurrentDate["getFullYear"]();
	}
	var iWeekNum = Math["floor"]((oCurrentDate["getTime"]() - this["iFirstDayOfFirstWeek"]) / UCF_Date["WEEK"] + .5) + 1;
	if (iWeekNum >= 53) {
		var itFirstDayOfFirstYear = this["getFirstDayOfFirstWeek"](oCurrentDate["getFullYear"]() + 1);
		if (itFirstDayOfFirstYear - oCurrentDate["getTime"]() < UCF_Date["WEEK"])
			iWeekNum = 1;
	}
	return iWeekNum;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetWeek"] = 0; };

/**
 * Method iGetDay
 *
 * returns the week day of the date 0:Sunday (default) 1:Monday...
 * @return {int}
 */
UCF_Date["prototype"]["iGetDay"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetDay"]++; }; 
	return this["oDate"]["getDay"]();
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetDay"] = 0; };

/**
 * Method iGetTime
 *
 * returns the time of the date in milliseconds after 1970-1-1 00:00:00
 * @return {int}
 */
UCF_Date["prototype"]["iGetTime"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetTime"]++; }; 
	return this["oDate"]["getTime"]();
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetTime"] = 0; };

/**
 * Method setTime
 *
 * sets the time of the date in milliseconds after 1970-1-1 00:00:00.
 * returns the UCF_Date instance
 *
 * @param {int} iTime milliseconds after 1970-1-1 00:00:00
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["setTime"] = function(iTime) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setTime"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iTime === 'number', "typeof iTime === 'number'", "Date.js(428): setTime"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iTime === Math["floor"](iTime), "iTime === Math.floor(iTime)", "Date.js(429): setTime"); };

	this["oDate"]["setTime"](iTime);
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setTime"] = 0; };

/**
 * Method iGetHours
 *
 * returns the hours
 * @return {int}
 */
UCF_Date["prototype"]["iGetHours"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetHours"]++; }; 
	return this["oDate"]["getHours"]();
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetHours"] = 0; };
/**
 * Method setHours
 *
 * sets the hours of the date
 * returns the UCF_Date instance
 *
 * @param {int} iHours the hours
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["setHours"] = function(iHours) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setHours"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iHours === 'number', "typeof iHours === 'number'", "Date.js(455): setHours"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iHours === Math["floor"](iHours), "iHours === Math.floor(iHours)", "Date.js(456): setHours"); };

	this["oDate"]["setHours"](iHours);
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setHours"] = 0; };
/**
 * Method iGetMinutes
 *
 * returns the minutes
 * @return {int}
 */
UCF_Date["prototype"]["iGetMinutes"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetMinutes"]++; }; 
	return this["oDate"]["getMinutes"]();
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetMinutes"] = 0; };

/**
 * Method setMinutes
 *
 * sets the minutes of the date
 * returns the UCF_Date instance
 *
 * @param {int} iMinutes the minutes
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["setMinutes"] = function(iMinutes) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setMinutes"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iMinutes === 'number', "typeof iMinutes === 'number'", "Date.js(482): setMinutes"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMinutes === Math["floor"](iMinutes), "iMinutes === Math.floor(iMinutes)", "Date.js(483): setMinutes"); };

	this["oDate"]["setMinutes"](iMinutes);
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setMinutes"] = 0; };
/**
 * Method iGetSeconds
 *
 * returns the seconds
 * @return {int}
 */

UCF_Date["prototype"]["iGetSeconds"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetSeconds"]++; }; 
	return this["oDate"]["getSeconds"]();
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetSeconds"] = 0; };

/**
 * Method setSeconds
 *
 * sets the seconds of the date
 * returns the UCF_Date instance
 *
 * @param {int} iSeconds the seconds
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["setSeconds"] = function(iSeconds) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setSeconds"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iSeconds === 'number', "typeof iSeconds === 'number'", "Date.js(510): setSeconds"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iSeconds === Math["floor"](iSeconds), "iSeconds === Math.floor(iSeconds)", "Date.js(511): setSeconds"); };

	this["oDate"]["setSeconds"](iSeconds);
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setSeconds"] = 0; };
/**
 * Method iGetMilliseconds
 *
 * returns the milliseconds
 */

UCF_Date["prototype"]["iGetMilliseconds"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetMilliseconds"]++; }; 
	return this["oDate"]["getMiliseconds"]();
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetMilliseconds"] = 0; };

/**
 * Method setMilliseconds
 *
 * sets the milliseconds of the date
 * returns the UCF_Date instance
 *
 * @param {int} iMilliseconds the milliseconds
 * @return {UCF_Date}
 */

UCF_Date["prototype"]["setMilliseconds"] = function(iMilliseconds) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setMilliseconds"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iMilliseconds === 'number', "typeof iMilliseconds === 'number'", "Date.js(538): setMilliseconds"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMilliseconds === Math["floor"](iMilliseconds), "iMilliseconds === Math.floor(iMilliseconds)", "Date.js(539): setMilliseconds"); };

	this["oDate"]["setMiliseconds"](iMilliseconds);
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setMilliseconds"] = 0; };
/**
 * Method iGetFirstDayOfWeek
 *
 * returns the first day of the week. default is 0 (sunday)
 * @return {int}
 */

UCF_Date["prototype"]["iGetFirstDayOfWeek"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetFirstDayOfWeek"]++; }; 
	return this["iFirstDayOfWeek"];
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetFirstDayOfWeek"] = 0; };

/**
 * Method setFirstDayOfWeek
 *
 * sets the first day of week for the date
 * based on the first day of week the oGetStartOfWeekDate returns a different day
 * returns the UCF_Date instance
 *
 * @param {int} iFirstDayOfWeek the first day of the week for the date
 * @see oGetStartOfWeekDate
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["setFirstDayOfWeek"] = function(iFirstDayOfWeek) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setFirstDayOfWeek"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iFirstDayOfWeek === 'number', "typeof iFirstDayOfWeek === 'number'", "Date.js(568): setFirstDayOfWeek"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstDayOfWeek === Math["floor"](iFirstDayOfWeek), "iFirstDayOfWeek === Math.floor(iFirstDayOfWeek)", "Date.js(569): setFirstDayOfWeek"); };

	this["iFirstDayOfWeek"] = iFirstDayOfWeek;
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setFirstDayOfWeek"] = 0; };

/**
 * Finds the date element the cursor is currently in.
 *
 * If the cursor is positioned in a text token (e.g. '23.| Dec 2015'),
 * the next date element is chosen ('month' in the example).
 *
 * A cursor at the end of the formatted string is considered
 * to be in the last date element found.
 *
 * @example <caption>cursor in date element</caption>
 * // let this format to "Wednesday, 23 December 2015" and
 * // let | indicate the cursor
 * this.sGetSelectedDateElement("Wednesd|ay, 23 December 2015".indexOf('|')) // => 'dayname'
 *
 * @example <caption>cursor in text token</caption>
 * // let this be the same as in the previous example
 * // let | indicate the cursor
 * this.sGetSelectedDateElement("Wednesday, |23 December 2015".indexOf('|')) // => 'day'
 *
 * @example <caption>cursor at the end</caption>
 * // let this be the same as before
 * // let | indicate the cursor
 * this.sGetSelectedDateElement("Wednesday, 23 December 2015|".indexOf('|')) // => 'year'
 *
 * @param {int} iCursorIndex the index of the cursor relative
 * to the beginning of the formatted date string
 * @return {'day|dayname|month|emperor|year'} the via cursor
 * selected date element of the formatted date string
 */
UCF_Date["prototype"]["sGetSelectedDateElement"] = function(iCursorIndex) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetSelectedDateElement"]++; }; 
	var self = this,
		aDateFormatArray = UCF_JsUtil["map"](this["aGetDateFormatArray"](''), function(oToken) {
			switch (oToken["sType"]) {
				case 'day':
					return UCF_JsUtil["extend"](oToken, {
						"iLength": Math["max"](oToken["iDigits"], String(self["iGetDate"]())["length"])
					});
				case 'dayname':
					return UCF_JsUtil["extend"](oToken, {
						"iLength": UCF_Date['aFormatDayNames' + (oToken["iDigits"] < 4 ? '3' : '')][self["iGetDay"]()]["length"]
					});
				case 'month':
					return UCF_JsUtil["extend"](oToken, {
						"iLength": ((oToken["iDigits"] < 3) ?
							UCF_StringUtil["fillChars"](String(self["iGetMonth"]() + 1), '0', oToken["iDigits"], true) :
							UCF_Date['aFormatMonthNames' + (oToken["iDigits"] < 4 ? '3' : '')][self["iGetMonth"]()])["length"]
					});
				case 'emperor':
					return UCF_JsUtil["extend"](oToken, {
						"iLength": self["sGetEmperorYearChar"]()["length"]
					});
				case 'Hours':
				case 'hours':
				case 'hours0':
					return UCF_JsUtil["extend"](oToken, {
						"iLength": Math["max"](oToken["iDigits"], String(self["iGetHours"]())["length"])
					});
				case 'minutes':
					return UCF_JsUtil["extend"](oToken, {
						"iLength": Math["max"](oToken["iDigits"], String(self["iGetMinutes"]())["length"])
					});
				case 'seconds':
					return UCF_JsUtil["extend"](oToken, {
						"iLength": Math["max"](oToken["iDigits"], String(self["iGetSeconds"]())["length"])
					});
				case 'ampm':
					return UCF_JsUtil["extend"](oToken, {
						"iLength": 2
					});
				case 'year':
					return UCF_JsUtil["extend"](oToken, {
						"iLength": UCF_StringUtil["fillChars"](String(self['iGet' + (self["bJapaneseDate"] && self["sGetEmperorYearChar"]() !== '' ? 'Emperor' : '') + 'Year']()), '0', oToken["iDigits"], true)["length"]
					});
				case 'text':
				default:
					return UCF_JsUtil["extend"](oToken, {
						"iLength": oToken["sValue"]["length"]
					});
			}
		}),
		oToken, i;

	iCursorIndex--;
	if (iCursorIndex < 0) {
		iCursorIndex = 0;
	}

	for (i = 0; i < aDateFormatArray["length"]; i++) {
		oToken = aDateFormatArray[i];
		if (iCursorIndex < oToken["iLength"] && oToken["sType"] !== 'text') {
			return oToken["sType"];
		}
		iCursorIndex -= oToken["iLength"];
	}

	return aDateFormatArray[aDateFormatArray["length"] - 1]["sType"];
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetSelectedDateElement"] = 0; };

/**
 * Method addDays
 *
 * adds a amount of days to the date. substracts if the given value negative
 * returns the UCF_Date instance
 *
 * @param {int} iNumberOfDays number of days to add or substract
 * @see addMonths
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["addDays"] = function(iNumberOfDays) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["addDays"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iNumberOfDays === 'number', "typeof iNumberOfDays === 'number'", "Date.js(685): addDays"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iNumberOfDays === Math["floor"](iNumberOfDays), "iNumberOfDays === Math.floor(iNumberOfDays)", "Date.js(686): addDays"); };
	var iHours = this["oDate"]["getHours"]();
	this["oDate"]["setHours"](12);
	this["oDate"]["setDate"](this["oDate"]["getDate"]() + iNumberOfDays);
	//	this.oDate.setHours(12); //CSN 620320 2015: If we set 00:00 Safari subtracts an aditional hour when AEST switches to daylight saving time and returns the date of the previous day with time set to 23:00
	this["oDate"]["setHours"](iHours);
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["addDays"] = 0; };

/**
 * Method addMonths
 *
 * adds a amount of months to the date. substracts if the given value negative
 * if a corresponding day does not exist after the months
 * were added the date is corrected to next valid day of the month.
 * i.e adding 1 month to 2001-1-31 will lead to 2001-2-28, the last valid day of next month
 * returns the UCF_Date instance
 *
 * @param {int} iNumberOfMonths number of months to add or substract
 * @see addMonths
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["addMonths"] = function(iNumberOfMonths) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["addMonths"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iNumberOfMonths === 'number', "typeof iNumberOfMonths === 'number'", "Date.js(710): addMonths"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iNumberOfMonths === Math["floor"](iNumberOfMonths), "iNumberOfMonths === Math.floor(iNumberOfMonths)", "Date.js(711): addMonths"); };

	var iHours = this["oDate"]["getHours"]();
	var iDate = this["oDate"]["getDate"]();
	this["oDate"]["setHours"](12);
	this["oDate"]["setDate"](15 + (30 * iNumberOfMonths));
	var iMonth = this["oDate"]["getMonth"]();
	this["oDate"]["setDate"](iDate);
	if (iMonth < this["oDate"]["getMonth"]()) {
		this["oDate"]["setDate"](iDate);
	}
	this["oDate"]["setHours"](iHours);
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["addMonths"] = 0; };

/**
 * Method bGetLeapYear
 *
 * returns whether the date in a leap year.
 * @return {boolean}
 *
 */
UCF_Date["prototype"]["bGetLeapYear"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["bGetLeapYear"]++; }; 
	var iYear = this["oDate"]["getFullYear"]();
	return ((iYear % 400 === 0) || ((iYear % 4 === 0) && (iYear % 100 !== 0)));
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["bGetLeapYear"] = 0; };

/**
 * Method iGetMinimalDaysInFirstWeek
 *
 * returns the minimal days in the first week. the default is 4.
 * this value is used for the calculation of calendar weeks.
 * i.e the calendar week 1 is the week where at least 4 days are in the new year
 * in other words the week where at least the thursday is in the new year.

 * @see iGetWeek
 * @return {int}
 */
UCF_Date["prototype"]["iGetMinimalDaysInFirstWeek"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetMinimalDaysInFirstWeek"]++; }; 
	return this["iMinimalDaysInFirstWeek"];
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetMinimalDaysInFirstWeek"] = 0; };

/**
 * Method setMinimalDaysInFirstWeek
 *
 * sets the minimal days in the first week.
 * this value is used for the calculation of calendar weeks.
 * i.e the calendar week 1 is the week where at least 4 days are in the new year
 * in other words the week where at least the thursday is in the new year.
 * returns the UCF_Date instance
 *
 * @param {int} iMinimalDaysInFirstWeek minimal days in the first week
 * @see iGetWeek
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["setMinimalDaysInFirstWeek"] = function(iMinimalDaysInFirstWeek) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setMinimalDaysInFirstWeek"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iMinimalDaysInFirstWeek === 'number', "typeof iMinimalDaysInFirstWeek === 'number'", "Date.js(768): setMinimalDaysInFirstWeek"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMinimalDaysInFirstWeek === Math["floor"](iMinimalDaysInFirstWeek), "iMinimalDaysInFirstWeek === Math.floor(iMinimalDaysInFirstWeek)", "Date.js(769): setMinimalDaysInFirstWeek"); };

	this["iMinimalDaysInFirstWeek"] = iMinimalDaysInFirstWeek;
	return this;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setMinimalDaysInFirstWeek"] = 0; };

/**
 * Method oGetClone
 *
 * @return {UCF_Date}
 */
UCF_Date["prototype"]["oGetClone"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["oGetClone"]++; }; 
	var oClone = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
	oClone["setTime"](this["iGetTime"]());
	oClone["setFirstDayOfWeek"](this["iFirstDayOfWeek"]);
	oClone["setMinimalDaysInFirstWeek"](this["iMinimalDaysInFirstWeek"]);
	oClone["setFormatString"](this["sFormat"]);
	return oClone;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["oGetClone"] = 0; };

/**
 * Method oGetStartOfWeekDate
 *
 * returns a new date object with the date where the current dates week starts.
 *
 * @see setFirstDayOfWeek
 * @return {int}
 */
UCF_Date["prototype"]["oGetStartOfWeekDate"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["oGetStartOfWeekDate"]++; }; 
	//initialize the clone
	var oWeekStartDate = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
	oWeekStartDate["setTime"](this["iGetTime"]());
	oWeekStartDate["setFirstDayOfWeek"](this["iFirstDayOfWeek"]);
	oWeekStartDate["setMinimalDaysInFirstWeek"](this["iMinimalDaysInFirstWeek"]);

	var iDays = this["iGetDay"]();
	if (this["iFirstDayOfWeek"] <= iDays) {
		oWeekStartDate["addDays"]((iDays * (-1)) + this["iFirstDayOfWeek"]);
	} else {
		oWeekStartDate["addDays"](((iDays + 7) * (-1)) + this["iFirstDayOfWeek"]);
	}
	return oWeekStartDate;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["oGetStartOfWeekDate"] = 0; };

/**
 * Method sGetDate
 *
 * returns the string representation of the date of the month with leading 0
 * @return {string}
 *
 */
UCF_Date["prototype"]["sGetDate"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetDate"]++; }; 
	return UCF_StringUtil["fillChars"](String(this["iGetDate"]()), '0', 2, true);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetDate"] = 0; };

/**
 * Method sGetMonth
 *
 * returns the string representation of the month with leading 0
 * @return {string}
 *
 */
UCF_Date["prototype"]["sGetMonth"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetMonth"]++; }; 
	return UCF_StringUtil["fillChars"](String(this["iGetMonth"]() + 1), '0', 2, true);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetMonth"] = 0; };

/**
 * Method sGetYear
 *
 * returns the string representation of the year
 * @return {string}
 *
 */
UCF_Date["prototype"]["sGetYear"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetYear"]++; }; 
	return String(this["iGetYear"]());
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetYear"] = 0; };

/**
 * Method sGetHours
 *
 * returns the string representation of the hours with leading 0
 * @return {string}
 *
 */
UCF_Date["prototype"]["sGetHours"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetHours"]++; }; 
	return UCF_StringUtil["fillChars"](String(this["iGetHours"]()), '0', 2, true);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetHours"] = 0; };

/**
 * Method sGetMinutes
 *
 * returns the string representation of the minutes with leading 0
 * @return {string}
 *
 */
UCF_Date["prototype"]["sGetMinutes"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetMinutes"]++; }; 
	return UCF_StringUtil["fillChars"](String(this["iGetMinutes"]()), '0', 2, true);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetMinutes"] = 0; };

/**
 * Method sGetSeconds
 *
 * returns the string representation of the seconds with leading 0
 * @return { string }
 *
 */
UCF_Date["prototype"]["sGetSeconds"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetSeconds"]++; }; 
	return UCF_StringUtil["fillChars"](String(this["iGetSeconds"]()), '0', 2, true);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetSeconds"] = 0; };

/**
 * Method sGetWeek
 *
 * returns the string representation of the week with leading 0
 * @return { string }
 *
 */
UCF_Date["prototype"]["sGetWeek"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetWeek"]++; }; 
	return UCF_StringUtil["fillChars"](String(this["iGetWeek"]()), '0', 2, true);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetWeek"] = 0; };

/**
 * Method toString
 *
 * returns the string representation of the date
 * @return { string }
 *
 */
UCF_Date["prototype"]["toString"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["toString"]++; }; 
	return this["oDate"]["toString"]();
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["toString"] = 0; };

/**
 * Method toDebugString
 * returns the string representation of the date for debugging purposes
 * @param {boolean} bShort - generates a shorter format
 * @return { string }
 *
 */
UCF_Date["prototype"]["toDebugString"] = function(bShort) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["toDebugString"]++; }; 
	var debugString = new Array(),
		sYear = UCF_StringUtil["fillChars"](String(this["iGetYear"]()), '0', 4, true),
		sMonth = this["sGetMonth"](),
		sDate = this["sGetDate"](),
		sDay = this["sGetDate"](),
		sHours = this["sGetHours"](),
		sMinutes = this["sGetMinutes"](),
		sSeconds = this["sGetSeconds"](),
		sFirst = String(this["iGetFirstDayOfWeek"]()),
		sWeek = UCF_StringUtil["fillChars"](String(this["iGetWeek"]()), '0', 2, true);
	if (bShort) {
		debugString["push"](sMonth);
		debugString["push"]('/' + sDate);
		debugString["push"]('/' + sYear);
		debugString["push"](' ' + sHours);
		debugString["push"](':' + sMinutes);
		debugString["push"](':' + sSeconds);
	} else {
		debugString["push"](sYear);
		debugString["push"]('-' + sMonth);
		debugString["push"]('-' + sDate);
		debugString["push"](' ' + sHours);
		debugString["push"](':' + sMinutes);
		debugString["push"](':' + sSeconds);
		debugString["push"](' ' + sMonth);
		debugString["push"](' WD:' + sDay);
		debugString["push"](' FD: ' + sFirst);
		debugString["push"](' CW: ' + sWeek + '\t');
		debugString["push"](' LY: ' + this["bGetLeapYear"]());
	}
	return debugString["join"]('');
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["toDebugString"] = 0; };

/**
 * Loads the DateFormat properties from the server
 * this file contains japanese emperor data
 */
UCF_Date["loadDateFormatProperties"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["loadDateFormatProperties"]++; }; 
	if (UCF_Date["mProperties"]) {
		return;
	}

	var sPath = UCF_ResourceUtil["sGetMessageBundlesRoot"]() + '/',
		sFile = 'dateformat',
		oResponse = {};

	if (!window["UCF_System"]["bUseActiveX"] && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
		oResponse["sText"] = UCF_Properties[sFile];
		oResponse["bSuccess"] = oResponse["sText"] && oResponse["sText"] !== null;
	} else {
		oResponse = UCF_RequestUtil["sendSyncRequest"](sPath + sFile + '.properties');
	}
	if (oResponse["bSuccess"]) {
		var aLines = oResponse["sText"]["split"]('\n');
		UCF_Date["mProperties"] = {};
		for (var i = 0; i < aLines["length"]; i++) {
			if (aLines[i]["indexOf"]('#') === 0) continue;
			var iSeperatorPos = aLines[i]["indexOf"]('='),
				sKey = aLines[i]["substring"](0, iSeperatorPos),
				sValue = aLines[i]["substring"](iSeperatorPos + 1)["replace"](/^\s+|\s+$/, '');
			sValue = sValue["replace"](/"/g, '\\\"');
			try {
				UCF_Date["mProperties"][sKey] = UCF_JsUtil["oJsonParse"]('"' + sValue + '"');
			} catch (e) {}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["loadDateFormatProperties"] = 0; };

/**
 * Returns the Japanese Emperor Char for the date
 * @return { string }
 */
UCF_Date["prototype"]["sGetEmperorYearChar"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetEmperorYearChar"]++; }; 
	return UCF_Date["sGetEmperorYearCharStatic"](this["iGetYear"]());
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetEmperorYearChar"] = 0; };

UCF_Date["sGetEmperorYearCharStatic"] = function( iYear ){;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetEmperorYearCharStatic"]++; }; 
	UCF_Date["loadDateFormatProperties"]();
	var	aEmperors = null;
	if (!UCF_Date["mProperties"]['JAPANESE_EMPERORS']) return '';

	aEmperors = UCF_Date["mProperties"]['JAPANESE_EMPERORS']["split"](',');
	for (var i = 0; i < aEmperors["length"]; i++) {
		var n = aEmperors[i],
			iStartYear = parseInt(UCF_Date["mProperties"][n + '_BEGIN']);
		if (isNaN(iStartYear)) iStartYear = 0;
		if (iYear > iStartYear) {
			return UCF_Date["mProperties"][n + '_1'];
		}
	}
	return '';
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetEmperorYearCharStatic"] = 0; };

/**
 * Returns the Japanese Emperor representation for a gregorian year
 * @return {int}
 */
UCF_Date["prototype"]["iGetEmperorYear"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetEmperorYear"]++; }; 
	return UCF_Date["iGetEmperorYearStatic"](this["iGetYear"]());
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetEmperorYear"] = 0; };

UCF_Date["iGetEmperorYearStatic"] = function( iYear ){;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetEmperorYearStatic"]++; }; 
	UCF_Date["loadDateFormatProperties"]();
	var aEmperors = null,
		iEmperorYear = 0;
	if (!UCF_Date["mProperties"]['JAPANESE_EMPERORS']) return iEmperorYear;
	aEmperors = UCF_Date["mProperties"]['JAPANESE_EMPERORS']["split"](',');
	for (var i = 0; i < aEmperors["length"]; i++) {
		var n = aEmperors[i],
			iStartYear = parseInt(UCF_Date["mProperties"][n + '_BEGIN']);
		if (isNaN(iStartYear)) iStartYear = 0;
		iEmperorYear = iYear - iStartYear;

		if (iYear > iStartYear) {
			return iEmperorYear;
		}
	}
	return 0;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetEmperorYearStatic"] = 0; };
/**
 * Returns the year Japanese Empereor representation for a gregorian year
 * @param {string} sString
 * @return {int}
 *
 */
UCF_Date["prototype"]["iGetEmperorStartYear"] = function(sString) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetEmperorStartYear"]++; }; 

	UCF_Date["loadDateFormatProperties"]();
	if (!UCF_Date["mProperties"]['JAPANESE_EMPERORS']) return 0;
	var aEmperors = UCF_Date["mProperties"]['JAPANESE_EMPERORS']["split"](',');
	for (var i = 0; i < aEmperors["length"]; i++) {
		var n = aEmperors[i];
		if (sString === UCF_Date["mProperties"][n + '_1']) return parseInt(UCF_Date["mProperties"][n + '_BEGIN']);
		if (sString === UCF_Date["mProperties"][n + '_2']) return parseInt(UCF_Date["mProperties"][n + '_BEGIN']);
	}
	return 0;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["iGetEmperorStartYear"] = 0; };

// eslint-disable-next-line complexity
UCF_Date["prototype"]["parse"] = function(sDateString, sFormatString) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["parse"]++; }; 
	var j;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sDateString === 'string', "typeof sDateString === 'string'", "Date.js(1051): parse"); };

	if (sFormatString) this["sFormat"] = sFormatString;

	var aFormatArray = this["aGetDateFormatArray"](''),
		iPos = 0,
		bError = false,
		iYear = this["iGetYear"](),
		iMonth = this["iGetMonth"](),
		iDate = this["iGetDate"](),
		iHours = this["iGetHours"](),
		iMinutes = this["iGetMinutes"](),
		iSeconds = this["iGetSeconds"](),
		iStartYear = 0,
		bHasDayName = false,
		bHasMonthName = false,
		sAmPm = '';

	var sChar, iStartPos, sDay, sEmperor;
	sDateString = sDateString["toLowerCase"]();
	var bOnlyDigits = /^[0-9]*$/["test"](sDateString);

	for (var i = 0; i < aFormatArray["length"]; i++) {
		var oPart = aFormatArray[i];
		switch (oPart["sType"]) {
			case 'text':
				if (sDateString["substr"](iPos, oPart["sValue"]["length"]) === oPart["sValue"]) {
					iPos += oPart["sValue"]["length"];
				} else {
					bError = true;
				}
				break;
			case 'emperor':
				sEmperor = sDateString["charAt"](iPos);
				// is there an emperor - Jahr before 1867 ?
				if (isNaN(parseInt(sEmperor))) {
					iStartYear = this["iGetEmperorStartYear"](sEmperor);
					if (iStartYear === 0) {
						iPos++;
						sChar = sDateString["charAt"](iPos);
						sEmperor += sChar;
						iStartYear = this["iGetEmperorStartYear"](sEmperor);
					}
					if (iStartYear === 0)
						bError = true;
					iPos++;
				} else
					sEmperor = '';
				break;
			case 'dayname':
				var bFound = false;
				sDay = '';
				sChar = sDateString["charAt"](iPos);

				bHasDayName = true;
				if (oPart["iDigits"] === 1) {
					iStartPos = iPos;

					for (j = 0; j < UCF_Date["aDayNames3"]["length"]; j++) {
						var sDayName3 = UCF_Date["aDayNames3"][j]["toLowerCase"]();
						iPos = iStartPos;
						sDay = '';
						sChar = sDateString["charAt"](iPos);
						while (sDayName3["substring"](0, iPos - iStartPos) === sDay) {
							if (iPos - iStartPos === sDayName3["length"]) {
								iPos = iStartPos + sDayName3["length"];
								bFound = true;
								break;
							}
							sDay += sChar;
							iPos++;
							sChar = sDateString["charAt"](iPos);
						}
						if (bFound) break;
					}
				} else if (oPart["iDigits"] >= 2) {
					iStartPos = iPos;
					for (j = 0; j < UCF_Date["aDayNames"]["length"]; j++) {
						var sDayName = UCF_Date["aDayNames"][j]["toLowerCase"]();
						iPos = iStartPos;
						sDay = '';
						sChar = sDateString["charAt"](iPos);
						while (sDayName["substring"](0, iPos - iStartPos) === sDay) {
							if (iPos - iStartPos === sDayName["length"]) {
								iPos = iStartPos + sDayName["length"];
								bFound = true;
								break;
							}
							sDay += sChar;
							iPos++;
							sChar = sDateString["charAt"](iPos);
						}
						if (bFound) break;
					}
				}
				if (!bFound) bError = true;
				break;
			case 'day':
				sDay = '';
				sChar = sDateString["charAt"](iPos);
				while (sChar >= '0' && sChar <= '9' && (!bOnlyDigits || (bOnlyDigits && sDay["length"] < aFormatArray[i]["iDigits"]))) {
					sDay += sChar;
					iPos++;
					sChar = sDateString["charAt"](iPos);
				}
				iDate = parseInt(sDay, 10);
				break;
			case 'month':
				var sMonth = '';
				sChar = sDateString["charAt"](iPos);
				if (oPart["iDigits"] === 3) {
					bHasMonthName = true;
					iMonth = -1;
					iStartPos = iPos;
					for (j = 0; j < UCF_Date["aMonthNames3"]["length"]; j++) {
						var sMonthName3 = UCF_Date["aMonthNames3"][j]["toLowerCase"]();
						iPos = iStartPos;
						sMonth = '';
						sChar = sDateString["charAt"](iPos);
						while (sMonthName3["substring"](0, iPos - iStartPos) === sMonth) {
							if (iPos - iStartPos === sMonthName3["length"]) {
								iMonth = j;
								iPos = iStartPos + sMonthName3["length"];
								break;
							}
							sMonth += sChar;
							iPos++;
							sChar = sDateString["charAt"](iPos);
						}
						if (iMonth > -1) break;
					}
				} else if (oPart["iDigits"] >= 4) {
					bHasMonthName = true;
					iMonth = -1;
					iStartPos = iPos;
					for (j = 0; j < UCF_Date["aMonthNames"]["length"]; j++) {
						var sMonthName = UCF_Date["aMonthNames"][j]["toLowerCase"]();
						iPos = iStartPos;
						sMonth = '';
						sChar = sDateString["charAt"](iPos);
						while (sMonthName["substring"](0, iPos - iStartPos) === sMonth) {
							if (iPos - iStartPos === sMonthName["length"]) {
								iMonth = j;
								iPos = iStartPos + sMonthName["length"];
								break;
							}
							sMonth += sChar;
							iPos++;
							sChar = sDateString["charAt"](iPos);
						}
						if (iMonth > -1) break;
					}
				} else {
					while (sChar >= '0' && sChar <= '9' && (!bOnlyDigits || (bOnlyDigits && sMonth["length"] < aFormatArray[i]["iDigits"]))) {
						sMonth += sChar;
						iPos++;
						sChar = sDateString["charAt"](iPos);
					}
					iMonth = parseInt(sMonth, 10) - 1;
					if (0 > iMonth || 11 < iMonth)
						bError = true;
				}
				break;
			case 'AMPM':
				sAmPm = sDateString["charAt"](iPos)["toUpperCase"]();
				break;
			case 'ampm':
				sAmPm = sDateString["charAt"](iPos)["toLowerCase"]();
				break;
			case 'hours':
			case 'hours0':
				// b12Hours = true;
			case 'Hours':
				sDay = '';
				sChar = sDateString["charAt"](iPos);
				while (sChar >= '0' && sChar <= '9' && (!bOnlyDigits || (bOnlyDigits && sDay["length"] < aFormatArray[i]["iDigits"]))) {
					sDay += sChar;
					iPos++;
					sChar = sDateString["charAt"](iPos);
				}
				iHours = parseInt(sDay, 10);
				break;
			case 'minutes':
				sDay = '';
				sChar = sDateString["charAt"](iPos);
				while (sChar >= '0' && sChar <= '9' && (!bOnlyDigits || (bOnlyDigits && sDay["length"] < aFormatArray[i]["iDigits"]))) {
					sDay += sChar;
					iPos++;
					sChar = sDateString["charAt"](iPos);
				}
				iMinutes = parseInt(sDay, 10);
				break;
			case 'seconds':
				sDay = '';
				sChar = sDateString["charAt"](iPos);
				while (sChar >= '0' && sChar <= '9' && (!bOnlyDigits || (bOnlyDigits && sDay["length"] < aFormatArray[i]["iDigits"]))) {
					sDay += sChar;
					iPos++;
					sChar = sDateString["charAt"](iPos);
				}
				iSeconds = parseInt(sDay, 10);
				break;
			case 'year':
				var sYear = '';
				sChar = sDateString["charAt"](iPos);
				while (sChar >= '0' && sChar <= '9' && (!bOnlyDigits || (bOnlyDigits && sYear["length"] < aFormatArray[i]["iDigits"]))) {
					sYear += sChar;
					iPos++;
					sChar = sDateString["charAt"](iPos);
				}
				//fallback for 2 digit years
				if (sYear["length"] <= 2 && !this["bJapaneseDate"]) {
					iYear = parseInt(sYear, 10);
					var sFill = '',
						iCurrentYear = (new Date())["getFullYear"](),
						sCurrentCentury = String(iCurrentYear)["substring"](0, 2),
						sLastCentury = String(iCurrentYear - 100)["substring"](0, 2),
						iThresholdYear = iCurrentYear + UCF_Date["YEAR2DIGITTHRESHOLD"] - parseInt(sCurrentCentury + '00');
					if (sYear["length"] === 1) sFill = '0';
					if (iYear > iThresholdYear) sYear = sLastCentury + sFill + sYear;
					if (iYear <= iThresholdYear) sYear = sCurrentCentury + sFill + sYear;
					iYear = parseInt(sYear, 10);
				} else if (this["bJapaneseDate"]) {
					if (iStartYear > 0 || sEmperor === '') {
						iYear = parseInt(sYear, 10);
						iYear = iStartYear + iYear;
					} else {
						var jPos = 0;
						for (j = 0; j < aFormatArray["length"]; j++) {
							if (aFormatArray[j]["sType"] === 'emperor') {
								sEmperor = sDateString["charAt"](jPos);
								iStartYear = this["iGetEmperorStartYear"](sEmperor);
								if (iStartYear === 0) {
									jPos++;
									sChar = sDateString["charAt"](jPos);
									sEmperor += sChar;
									iStartYear = this["iGetEmperorStartYear"](sEmperor);
								}
								if (iStartYear === 0)
									bError = true;
								iYear = iStartYear + parseInt(sYear, 10);
							} else {
								if (aFormatArray[j]["iDigits"])
									jPos += aFormatArray[j]["iDigits"];
								else if (aFormatArray[j]["sValue"])
									jPos += aFormatArray[j]["sValue"]["length"];
							}
						}
					}
				} else {
					iYear = parseInt(sYear, 10);
				}
				if (isNaN(iYear)) {
					bError = true;
					iYear = (new Date())["getFullYear"]();
				}
				break;
		}
		if (bError) break;
	}
	if (!bError) {
		if (iMonth > 11) iMonth = 11;
		this["setYear"](iYear);
		var oMonthArray = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		if (oMonthArray[iMonth] <= iDate) {
			iDate = oMonthArray[iMonth];
			if (iMonth === 1 && !this["bGetLeapYear"]() && iDate === 29) {
				iDate = 28;
			}
		}
		// CSN: 1054903 2013, set the day first to avoid that the month changes
		this["setDate"](iDate);
		this["setMonth"](iMonth);
		// CSN: 0001110369 2014, set the day again it may have changed
		this["setDate"](iDate);
		if (sAmPm["toUpperCase"]() === 'P') {
			iHours += 12;
			if (iHours === 24)
				iHours = 0;
		}
		if (iHours === 0 && sAmPm["toUpperCase"]() === 'A')
			iHours = 12;
		if (iHours === 12 && sAmPm["toUpperCase"]() === 'P')
			iHours = 0;
		this["setHours"](iHours);
		this["setMinutes"](iMinutes);
		this["setSeconds"](iSeconds);
	} else {
		var sTempFormat, sNewFormatString;
		this["bJapaneseDate"] = false;
		//fallback formats
		if (bHasDayName) {
			sTempFormat = sFormatString;
			sNewFormatString = sFormatString["replace"](/E ?/g, '');
			bError = this["parse"](sDateString, sNewFormatString);
			this["sFormat"] = sTempFormat;
		} else if (bHasMonthName) {
			sTempFormat = sFormatString;
			sNewFormatString = sFormatString["replace"](/MMMMM/g, 'M')["replace"](/MMMM/g, 'M')["replace"](/MMM/g, 'M');
			bError = this["parse"](sDateString, sNewFormatString);
			this["sFormat"] = sTempFormat;
		} else {
			if ('MM/dd/yyyy' !== sFormatString && 'dd.MM.yyyy' !== sFormatString && 'yyyy-MM-dd' !== sFormatString) {
				sTempFormat = sFormatString;
				bError = this["parse"](sDateString, 'yyyy-MM-dd');
				if (bError) {
					bError = this["parse"](sDateString, 'MM/dd/yyyy');
				}
				if (bError) {
					bError = this["parse"](sDateString, 'dd.MM.yyyy');
				}
				this["sFormat"] = sTempFormat;
			}
		}
	}
	return bError;

};;if (__UCF_COVERAGE__) { UCF_Date["_"]["parse"] = 0; };

/**
 * @param {string} [sFormatString]
 * @param {string} [sPartOfDate]
 * @return {string}
 */
UCF_Date["prototype"]["sGetFormattedDate"] = function(sFormatString, sPartOfDate) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetFormattedDate"]++; }; 

	if (!sFormatString)
		sFormatString = this["sFormat"];

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sFormatString === 'string', "typeof sFormatString === 'string'", "Date.js(1380): sGetFormattedDate"); };

	var aFormatArray = this["aGetDateFormatArray"](sFormatString),
		aBuffer = [],
		oPart,
		iHours;
	for (var i = 0; i < aFormatArray["length"]; i++) {
		oPart = aFormatArray[i];
		if (!sPartOfDate || sPartOfDate === oPart["sType"]) {
			switch (oPart["sType"]) {
				case 'text':
					aBuffer["push"](oPart["sValue"]);
					if (sPartOfDate)
						return (aBuffer);
					break;
				case 'day':
					aBuffer["push"](UCF_StringUtil["fillChars"](String(this["iGetDate"]()), '0', oPart["iDigits"], true));
					break;
				case 'dayname':
					if (oPart["iDigits"] < 4) {
						aBuffer["push"](UCF_Date["aFormatDayNames3"][this["iGetDay"]()]);
					} else if (oPart["iDigits"] >= 4) {
						aBuffer["push"](UCF_Date["aFormatDayNames"][this["iGetDay"]()]);
					}
					break;
				case 'month':
					if (oPart["iDigits"] === 3) {
						aBuffer["push"](UCF_Date["aFormatMonthNames3"][this["iGetMonth"]()]);
					} else if (oPart["iDigits"] >= 4) {
						aBuffer["push"](UCF_Date["aFormatMonthNames"][this["iGetMonth"]()]);
					} else {
						aBuffer["push"](UCF_StringUtil["fillChars"](String(this["iGetMonth"]() + 1), '0', oPart["iDigits"], true));
					}
					break;
				case 'emperor':
					aBuffer["push"](this["sGetEmperorYearChar"]());
					break;
				case 'year':
					if (this["bJapaneseDate"] && this["sGetEmperorYearChar"]() !== '') {
						aBuffer["push"](UCF_StringUtil["fillChars"](String(this["iGetEmperorYear"]()), '0', oPart["iDigits"], true));
					} else {
						aBuffer["push"](UCF_StringUtil["fillChars"](String(this["iGetYear"]()), '0', oPart["iDigits"], true));
					}
					break;
				case 'hours':
					iHours = this["iGetHours"]();
					if (iHours > 12)
						iHours -= 12;
					if (iHours === 0)
						iHours = 12;
					aBuffer["push"](UCF_StringUtil["fillChars"](String(iHours), '0', oPart["iDigits"], true));
					break;
				case 'hours0':
					iHours = this["iGetHours"]();
					if (iHours > 12)
						iHours -= 12;
					if (iHours === 12)
						iHours = 0;
					aBuffer["push"](UCF_StringUtil["fillChars"](String(iHours), '0', oPart["iDigits"], true));
					break;
				case 'Hours':
					aBuffer["push"](UCF_StringUtil["fillChars"](String(this["iGetHours"]()), '0', oPart["iDigits"], true));
					break;
				case 'minutes':
					aBuffer["push"](UCF_StringUtil["fillChars"](String(this["iGetMinutes"]()), '0', oPart["iDigits"], true));
					break;
				case 'seconds':
					aBuffer["push"](UCF_StringUtil["fillChars"](String(this["iGetSeconds"]()), '0', oPart["iDigits"], true));
					break;
				case 'ampm':
					if (this["iGetHours"]() > 12 || this["iGetHours"]() === 0)
						aBuffer["push"]('pm');
					else
						aBuffer["push"]('am');
					break;
				case 'AMPM':
					if (this["iGetHours"]() > 12 || this["iGetHours"]() === 0)
						aBuffer["push"]('PM');
					else
						aBuffer["push"]('AM');
					break;
			}
		}
	}

	return aBuffer["join"]('');

};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetFormattedDate"] = 0; };

UCF_Date["prototype"]["aGetDateFormatArray"] = function(sFormat) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["aGetDateFormatArray"]++; }; 
	var aFormatArray = [];
	if (sFormat === '')
		sFormat = this["sFormat"];

	var bQuoted = false,
		oCurrentObject = null,
		sState = '';

	for (var i = 0; i < sFormat["length"]; i++) {
		var sCurChar = sFormat["charAt"](i),
			sNextChar, sPrevChar;
		if (bQuoted) {
			if (sCurChar === "'") {
				sPrevChar = sFormat["charAt"](i - 1);
				sNextChar = sFormat["charAt"](i + 1);
				// handle abc''def correctly
				if (sPrevChar === "'") {
					bQuoted = false;
				}
				// handle 'abc''def' correctly
				else if (sNextChar === "'") {
					i += 1;
				}
				//  normal quote 'abcdef'
				else {
					bQuoted = false;
					continue;
				}
			}
			if (sState === 'text') {
				oCurrentObject["sValue"] += sCurChar;
			} else {
				oCurrentObject = {
					"sType": 'text',
					"sValue": sCurChar
				};
				aFormatArray["push"](oCurrentObject);
				sState = 'text';
			}

		} else {
			switch (sCurChar) {
				case "'":
					bQuoted = true;
					break;

				case 'd':
					if (!bQuoted) {
						if (sState === 'day') {
							oCurrentObject["iDigits"]++;
						} else {
							oCurrentObject = {
								"sType": 'day',
								"iDigits": 1
							};
							aFormatArray["push"](oCurrentObject);
							sState = 'day';
						}
						break;
					}
					case 'M':
						if (!bQuoted) {
							if (sState === 'month') {
								oCurrentObject["iDigits"]++;
							} else {
								oCurrentObject = {
									"sType": 'month',
									"iDigits": 1
								};
								aFormatArray["push"](oCurrentObject);
								sState = 'month';
							}
							break;
						}
						case 'G':
							if (!bQuoted) {
								oCurrentObject = {
									"sType": 'emperor',
									"sValue": sCurChar
								};
								aFormatArray["push"](oCurrentObject);
								this["bJapaneseDate"] = true;
								break;
							}
							case 'y':
								if (!bQuoted) {
									if (sState === 'year') {
										oCurrentObject["iDigits"]++;
									} else {
										oCurrentObject = {
											"sType": 'year',
											"iDigits": 1
										};
										aFormatArray["push"](oCurrentObject);
										sState = 'year';
									}
									break;
								}
								case 'E':
									if (!bQuoted) {
										if (sState === 'dayname') {
											oCurrentObject["iDigits"]++;
										} else {
											oCurrentObject = {
												"sType": 'dayname',
												"iDigits": 1
											};
											aFormatArray["push"](oCurrentObject);
											sState = 'dayname';
										}
										break;
									}
									case 'H':
										if (!bQuoted) {
											if (sState === 'Hours') {
												oCurrentObject["iDigits"]++;
											} else {
												oCurrentObject = {
													"sType": 'Hours',
													"iDigits": 1
												};
												aFormatArray["push"](oCurrentObject);
												sState = 'Hours';
											}
											break;
										}
										case 'h':
											if (!bQuoted) {
												if (sState === 'hours') {
													oCurrentObject["iDigits"]++;
												} else {
													oCurrentObject = {
														"sType": 'hours',
														"iDigits": 1
													};
													aFormatArray["push"](oCurrentObject);
													sState = 'hours';
												}
												break;
											}
											case 't':
												if (!bQuoted) {
													if (sState === 'hours0') {
														oCurrentObject["iDigits"]++;
													} else {
														oCurrentObject = {
															"sType": 'hours0',
															"iDigits": 1
														};
														aFormatArray["push"](oCurrentObject);
														sState = 'hours0';
													}
													break;
												}
												case 'm':
													if (!bQuoted) {
														if (sState === 'minutes') {
															oCurrentObject["iDigits"]++;
														} else {
															oCurrentObject = {
																"sType": 'minutes',
																"iDigits": 1
															};
															aFormatArray["push"](oCurrentObject);
															sState = 'minutes';
														}
														break;
													}
													case 's':
														if (!bQuoted) {
															if (sState === 'seconds') {
																oCurrentObject["iDigits"]++;
															} else {
																oCurrentObject = {
																	"sType": 'seconds',
																	"iDigits": 1
																};
																aFormatArray["push"](oCurrentObject);
																sState = 'seconds';
															}
															break;
														}
														case 'a':
															if (!bQuoted) {
																if (sState === 'ampm') {
																	oCurrentObject["iDigits"]++;
																} else {
																	oCurrentObject = {
																		"sType": 'ampm',
																		"iDigits": 1
																	};
																	aFormatArray["push"](oCurrentObject);
																	sState = 'ampm';
																}
																break;
															}
															case 'A':
																if (!bQuoted) {
																	if (sState === 'AMPM') {
																		oCurrentObject["iDigits"]++;
																	} else {
																		oCurrentObject = {
																			"sType": 'AMPM',
																			"iDigits": 1
																		};
																		aFormatArray["push"](oCurrentObject);
																		sState = 'AMPM';
																	}
																	break;
																}
																default:
																	if (sState === 'text') {
																		oCurrentObject["sValue"] += sCurChar;
																	} else {
																		oCurrentObject = {
																			"sType": 'text',
																			"sValue": sCurChar
																		};
																		aFormatArray["push"](oCurrentObject);
																		sState = 'text';
																	}
			}
		}

	}
	return aFormatArray;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["aGetDateFormatArray"] = 0; };

/**
 * Returns the String for a Month's title dependent of the Format
 * @return {string}
 */
UCF_Date["prototype"]["sGetMonthTitle"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetMonthTitle"]++; }; 
	var aFormat = this["aGetDateFormatArray"]('');
	var sFormat = new String();
	for (var i = 0; i < aFormat["length"]; i++) {
		if (aFormat[i]["sType"] === 'emperor')
			sFormat += aFormat[i]["sValue"];
		if (aFormat[i]["sType"] === 'year')
			for (var j = 0; j < aFormat[i]["iDigits"]; j++)
				sFormat += 'y';
	}
	var sYear = '';
	if (sFormat["length"])
		sYear = this["sGetFormattedDate"](sFormat);
	if (window["UCF_System"]["sLanguage"] === 'ja')
		return (sYear + ' ' + UCF_Date["oMessageBundle"]["sGetText"]('SAPUR_YEAR') + ' ' + (this["iGetMonth"]() + 1) + UCF_Date["oMessageBundle"]["sGetText"]('SAPUR_CAL_MONTHHEADER'));
	else if (UCF_StringUtil["bStartsWith"](window["UCF_System"]["sLanguage"], 'zh', true))
		return (sYear + ' ' + UCF_Date["oMessageBundle"]["sGetText"]('SAPUR_YEAR') + ' ' + UCF_Date["aMonthNames"][this["iGetMonth"]()]);
	else
		return (UCF_Date["aMonthNames"][this["iGetMonth"]()] + ' ' + sYear);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["sGetMonthTitle"] = 0; };
/**
 * Method setFormatString
 *
 * API for setting the Formatstring
 * @param {string} sFormat
 *
 */
UCF_Date["prototype"]["setFormatString"] = function(sFormat) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setFormatString"]++; }; 
	this["sFormat"] = sFormat;
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setFormatString"] = 0; };
/**
 * Method bIsWeekend
 * @return {boolean}
 *
 */
UCF_Date["prototype"]["bIsWeekend"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["bIsWeekend"]++; }; 
	var iDay = this["oDate"]["getDay"]();
	return this["aWeekendDays"][iDay];
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["bIsWeekend"] = 0; };
/**
 * Method bIsSameDay
 * @param {UCF_Date} oOtherDay
 * @return {boolean}
 *
 */
UCF_Date["prototype"]["bIsSameDay"] = function(oOtherDay) {;if (__UCF_COVERAGE__) { UCF_Date["_"]["bIsSameDay"]++; }; 
	return oOtherDay
		&& this["iGetYear"]() === oOtherDay["iGetYear"]()
		&& this["iGetMonth"]() === oOtherDay["iGetMonth"]()
		&& this["iGetDate"]() === oOtherDay["iGetDate"]();
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["bIsSameDay"] = 0; };

/**
 * Detach Events and clear all delayed calls
 * @private
 */
UCF_Date["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["destroy"]++; }; 
	this["oDate"] = null;
	this["aWeekendDays"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["destroy"] = 0; };

/**
 * Method setDateWithSystemUTCOffset
 */
UCF_Date["prototype"]["setDateWithSystemUTCOffset"] = function() {;if (__UCF_COVERAGE__) { UCF_Date["_"]["setDateWithSystemUTCOffset"]++; }; 
	var iOffsetMinutes = window["UCF_System"]["iGetUTCOffsetMinutes"]();
	this["oDate"]["setTime"](this["oDate"]["getTime"]() + (iOffsetMinutes + this["oDate"]["getTimezoneOffset"]()) * 60 * 1000);
};;if (__UCF_COVERAGE__) { UCF_Date["_"]["setDateWithSystemUTCOffset"] = 0; };


};
sap["ls"]["preload"]["UCF_DateNavigator"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_Date */
/// <reference path="../types/Date.js"/>

/**
 * 
 * @version 0.9
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_DateNavigator(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["UCF_DateNavigator"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "DateNavigator.js(30): UCF_DateNavigator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "DateNavigator.js(31): UCF_DateNavigator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DateNavigator.js(32): UCF_DateNavigator"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["createKeyboardNavigation"]();
	this["createFocusObjects"]();
	this["oFocusedElementInfo"] = { "iMonthIndex": 0, "iRowIndex": -1, "iCellIndex": -1 };
	this["bAllowDeselection"] = false;
	if (oDomRef["getAttribute"] && oDomRef["getAttribute"]("AllowDeselection") === "true")
		this["bAllowDeselection"] = true;
	this["setClientProperty"]("AllowDeselection", this["bAllowDeselection"], true);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sSelectedDayId"] = null;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sFocusRectedDayId"] = null;
	this["sSelectionCssClass"] = 'urDNSelected'; // 'urSel5';
};window["UCF_DateNavigator"] = UCF_DateNavigator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DateNavigator"); UCF_DateNavigator["_"] = {UCF_DateNavigator: 0}; }; ;

UCF_DateNavigator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_DateNavigator.prototype["sClassName"] = "UCF_DateNavigator";

/** initialize
 * @private
 */
UCF_DateNavigator["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["initialize"]++; }; 
	if (window["UCF_System"]["sDevice"] !== 'standards')
		return;
	var aDays = this["oDomRef"]["querySelectorAll"]('[cl="D"]');
	if (!aDays[0]["getAttribute"]("aria-label"))
		return;
	UCF_ClassLoader["oGetClass"]('UCF_Date');
	var sDateFormat = window["UCF_System"]["sGetDataTypeFormat"]("Date");
	var sMonthName;
	var aPositions =
		/([dmygDMYG].*)[\/\.\-\s]([dmygDMYG].*)[\/\.\-\s]([dmygDMYG].*)/gm["exec"](sDateFormat);
	if (!aPositions || aPositions["length"]  < 4){
		aPositions=new Array();
		aPositions["push"]("dd.MM.yyyy");
		aPositions["push"]("d");
		aPositions["push"]("M");
		aPositions["push"]("y");
	}
	for (var index = 0; index < aDays["length"]; index++) {
		var aParts = aDays[index]["getAttribute"]("aria-label")["split"](' ');
		var aDateParts = aParts[0]["split"]('.');
		aParts[0] = '';
		for (var i = 1; i < aPositions["length"]; i++) {
			switch (aPositions[i]["charAt"](0)){
				case 'd': aParts[0] = aParts[0] + aDateParts[0] + ' ';
				break;
				case 'D': aParts[0] = aParts[0] + aDateParts[0] + ' ';
				break;
				case 'M': {
					switch (aDateParts[1]) {
						case '0': sMonthName = this["oLS"]["sGetText"]('SAPUR_JANUARY');
						break;
						case '1': sMonthName = this["oLS"]["sGetText"]('SAPUR_FEBRUARY');
						break;
						case '2': sMonthName = this["oLS"]["sGetText"]('SAPUR_MARCH');
						break;
						case '3': sMonthName = this["oLS"]["sGetText"]('SAPUR_APRIL');
						break;
						case '4': sMonthName = this["oLS"]["sGetText"]('SAPUR_MAY');
						break;
						case '5': sMonthName = this["oLS"]["sGetText"]('SAPUR_JUNE');
						break;
						case '6': sMonthName = this["oLS"]["sGetText"]('SAPUR_JULY');
						break;
						case '7': sMonthName = this["oLS"]["sGetText"]('SAPUR_AUGUST');
						break;
						case '8': sMonthName = this["oLS"]["sGetText"]('SAPUR_SEPTEMBER');
						break;
						case '9': sMonthName = this["oLS"]["sGetText"]('SAPUR_OCTOBER');
						break;
						case '10': sMonthName = this["oLS"]["sGetText"]('SAPUR_NOVEMBER');
						break;
						case '11': sMonthName = this["oLS"]["sGetText"]('SAPUR_DECEMBER');
						break;
					}
				}
				aParts[0] = aParts[0] + sMonthName + ' ';
				break;
				case 'y': aParts[0] = aParts[0] + aDateParts[2] +' ';
				break;
				case 'Y': aParts[0] = aParts[0] + aDateParts[2] + ' ';
				break;
				case 'G':
					aParts[0] = aParts[0] + UCF_Date["sGetEmperorYearCharStatic"](parseInt(aDateParts[2])) +
						UCF_Date["iGetEmperorYearStatic"](parseInt(aDateParts[2])) +' ';
				break;
			}
		}
		aDays[index]["setAttribute"]("aria-label", aParts["join"](' '));
		if (!aDays[index]["getAttribute"]("title"))
			aDays[index]["setAttribute"]("title", aParts["join"](' '));
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["initialize"] = 0; };

//
/** @override */
UCF_DateNavigator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["destroy"]++; }; 
	this["iTouchesLength"] = null;
	this["iOldClientY"] = null;
	this["iOldClientX"] = null;
	this["oTouchstart"] = null;
	this["iLastTouchend"] = null;
	this["sCurrentWeek"] = null;
	this["sCurrentDay"] = null;
	this["aFocusElements"] = null;
	this["iCells"] = null;
	this["iRows"] = null;
	this["sFocusRectedDayId"] = null;
	this["sSelectedDayId"] = null;
	this["oFocusedElementInfo"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["destroy"] = 0; };

/**
 * Create a cell matrix for keyboard navigation
 */
UCF_DateNavigator["prototype"]["createKeyboardNavigation"] = function() {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["createKeyboardNavigation"]++; }; 

	if (this["aKeyboardMatrix"]) return;

	this["aKeyboardMatrix"] = [];
	this["aMonths"] = [];
	var aTables = this["oDomRef"]["getElementsByTagName"]("TABLE");

	for (var i = 0; i < aTables["length"]; i++) {
		//check if we are in a month table. this could otherwise be the legend.
		if (aTables[i]["getAttribute"]("tp") !== "MONTH") continue;
		this["aMonths"]["push"](aTables[i]);
		this["aKeyboardMatrix"]["push"]([]);
		var iMonthIndex = this["aKeyboardMatrix"]["length"] - 1;

		for (var iRows = 2; iRows < aTables[i]["rows"]["length"]; iRows++) {
			var oRow = aTables[i]["rows"][iRows];
			this["aKeyboardMatrix"][iMonthIndex]["push"]([]);
			var iRowIndex = this["aKeyboardMatrix"][iMonthIndex]["length"] - 1;
			for (var iCells = 0; iCells < oRow["cells"]["length"]; iCells++) {
				this["aKeyboardMatrix"][iMonthIndex][iRowIndex] = oRow["cells"];
			}
		}
	}
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iRows"] = this["aKeyboardMatrix"][iMonthIndex]["length"];
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iCells"] = this["aKeyboardMatrix"][iMonthIndex][0]["length"];
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["createKeyboardNavigation"] = 0; };

/**
 * Create an array for the focussed elements
 */
UCF_DateNavigator["prototype"]["createFocusObjects"] = function() {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["createFocusObjects"]++; }; 
	var iMonths = this["aKeyboardMatrix"]["length"];
	this["aFocusElements"] = new Array();
	for (var i = 0; i < iMonths; i++)
		this["aFocusElements"]["push"](this["aKeyboardMatrix"][i][0][0]);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["createFocusObjects"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onclick"]++; }; 
	this["onlsselect"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onclick"] = 0; };

/**
 * Handles the oncontextmenu event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["oncontextmenu"]++; }; 
	var sType = "",
		oSource = oBrowserEvent["oGetSource"]();
	if (oSource["getAttribute"] && oSource["getAttribute"]("cl") === "D") sType = "DAY";
	if (oSource["parentNode"] && oSource["parentNode"]["getAttribute"] && oSource["parentNode"]["getAttribute"]("cl") === "D") sType = "DAY";
	if (oSource["getAttribute"] && oSource["getAttribute"]("cl") === "W") sType = "WEEK";
	var sPartId = oSource["id"];
	if (oSource["getAttribute"] && oSource["getAttribute"]("cl") === "M") {
		sType = "MONTH";
		while (oSource["getAttribute"] && oSource["getAttribute"]("tp") !== "MONTH") {
			oSource = oSource["parentNode"];
		}
		sPartId = oSource["id"];
	}

	var iPosX = oBrowserEvent["iPageX"](),
		iPosY = oBrowserEvent["iPageY"]();

	if (sType && sPartId) {
		this["fireContextMenu"](this["sId"], sType, sPartId, iPosX, iPosY, oBrowserEvent["bShift"](), oBrowserEvent["bCtrl"](), oBrowserEvent["bAlt"]());
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["oncontextmenu"] = 0; };

/**
 * Handles the onmousedown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onmousedown"]++; }; 
	//set the focus to the element that was clicked
	var oSource = oBrowserEvent["oGetSource"](),
		oTable = UCF_DomUtil["oGetParentByAttribute"](oSource, "tp", "MONTH");
	if (oSource["tagName"] === "DIV")
		oSource = UCF_DomUtil["oGetParentElement"](oSource);
	if (oSource["tagName"] === "TD" || oSource["tagName"] === "TABLE") {
		if (oTable) {
			var iCellIndex = oSource["cellIndex"],
				iRowIndex = oSource["parentNode"]["rowIndex"] - 2,
				iMonthIndex = this["iGetMonthIndex"](oTable);
			if (iRowIndex < 0) {
				iRowIndex = -1;
				iCellIndex = -1;
			}
			this["oFocusedElementInfo"]["iRowIndex"] = iRowIndex;
			this["oFocusedElementInfo"]["iCellIndex"] = iCellIndex;
			this["oFocusedElementInfo"]["iMonthIndex"] = iMonthIndex;
			this["focusElementInfo"](this["oFocusedElementInfo"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onmousedown"] = 0; };

/**
 * sets the focus to the element by the meintained oFocusedElementInfo
 * @param { Object } oFocusedElementInfo
 */
UCF_DateNavigator["prototype"]["focusElementInfo"] = function(oFocusedElementInfo) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["focusElementInfo"]++; }; 
	var iCellIndex = oFocusedElementInfo["iCellIndex"];
	var iRowIndex = oFocusedElementInfo["iRowIndex"];
	var iMonthIndex = oFocusedElementInfo["iMonthIndex"];
	var oElement = null;
	if (iCellIndex < 0 || iRowIndex < 0) {
		oElement = this["aMonths"][iMonthIndex];
	} else {
		oElement = this["aKeyboardMatrix"][iMonthIndex][iRowIndex][iCellIndex];
	}
	if (oElement)
		this["focusElement"](oElement);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["focusElementInfo"] = 0; };

/**
 * Handles the onlsright event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsright"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(288): onlsright"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource["tagName"] === "TD" && oSource["getAttribute"]("tp") !== "MONTH") {
		var iRowIndex = oSource["parentNode"]["rowIndex"] - 2;
		if (window["UCF_System"]["bIsRTL"]) {
			if (oSource["previousSibling"]) {
				this["oFocusedElementInfo"]["iCellIndex"]--;
				this["oFocusedElementInfo"]["iRowIndex"] = iRowIndex;
				this["focusElementInfo"](this["oFocusedElementInfo"]);
			} else {
				if (iRowIndex > 0) {
					this["oFocusedElementInfo"]["iRowIndex"] = iRowIndex - 1;
					this["oFocusedElementInfo"]["iCellIndex"] = this["iCells"] - 1;
					this["focusElementInfo"](this["oFocusedElementInfo"]);
				}
			}
		} else {
			if (oSource["nextSibling"]) {
				this["oFocusedElementInfo"]["iCellIndex"]++;
				this["oFocusedElementInfo"]["iRowIndex"] = iRowIndex;
				this["focusElementInfo"](this["oFocusedElementInfo"]);
			} else {
				if (++iRowIndex < this["iRows"]) {
					this["oFocusedElementInfo"]["iCellIndex"] = 0;
					this["oFocusedElementInfo"]["iRowIndex"] = iRowIndex;
					this["focusElementInfo"](this["oFocusedElementInfo"]);
				}
			}
		}
	}
	if (oSource["tagName"] === "TABLE" || oSource["getAttribute"]("tp") === "MONTH") {
		var iMonthIndex;
		if (window["UCF_System"]["bIsRTL"])
			iMonthIndex = this["iGetMonthIndex"](oSource) - 1;
		else
			iMonthIndex = this["iGetMonthIndex"](oSource) + 1;
		if (iMonthIndex === this["aMonths"]["length"]) {
			this["nextMonth"]();
			return;
		} else if (iMonthIndex === -1) {
			this["previousMonth"]();
			return;
		} else {
			this["oFocusedElementInfo"]["iCellIndex"] = -1;
			this["oFocusedElementInfo"]["iRowIndex"] = -1;
			this["oFocusedElementInfo"]["iMonthIndex"] = iMonthIndex;
			this["focusElementInfo"](this["oFocusedElementInfo"]);
		}
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	return;
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsright"] = 0; };

/**
 * Handles the onlsrightmodifier event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsrightmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsrightmodifier"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(350): onlsrightmodifier"); };

	var iMonthIndex;
	var oSource = oBrowserEvent["oGetSource"]();
	if ((oBrowserEvent["bCtrl"]() || oBrowserEvent["bAlt"]()) && oSource["tagName"] === "TD") {
		if (window["UCF_System"]["bIsRTL"])
			iMonthIndex = this["oFocusedElementInfo"]["iMonthIndex"] - 1;
		else
			iMonthIndex = this["oFocusedElementInfo"]["iMonthIndex"] + 1;
		if (iMonthIndex === this["aMonths"]["length"]) {
			this["nextMonth"]();
			return;
		} else if (iMonthIndex === -1) {
			this["previousMonth"]();
			return;
		} else {
			if (oBrowserEvent["bAlt"]()) {
				this["oFocusedElementInfo"]["iCellIndex"] = -1;
				this["oFocusedElementInfo"]["iRowIndex"] = -1;
			}
			this["oFocusedElementInfo"]["iMonthIndex"] = iMonthIndex;
			this["focusElementInfo"](this["oFocusedElementInfo"]);
		}
	}
	if (oSource["tagName"] === "TABLE") {
		if (window["UCF_System"]["bIsRTL"])
			iMonthIndex = this["iGetMonthIndex"](oSource) - 1;
		else
			iMonthIndex = this["iGetMonthIndex"](oSource) + 1;
		if (iMonthIndex === this["aMonths"]["length"]) {
			this["nextMonth"]();
			return;
		} else if (iMonthIndex === -1) {
			this["previousMonth"]();
			return;
		} else {
			this["oFocusedElementInfo"]["iCellIndex"] = -1;
			this["oFocusedElementInfo"]["iRowIndex"] = -1;
			this["oFocusedElementInfo"]["iMonthIndex"] = iMonthIndex;
			this["focusElementInfo"](this["oFocusedElementInfo"]);
		}
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	return;
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsrightmodifier"] = 0; };
/**
 * Handles the onlsleftmodifier event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsleftmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsleftmodifier"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(404): onlsleftmodifier"); };
	var iMonthIndex;
	var oSource = oBrowserEvent["oGetSource"]();
	if ((oBrowserEvent["bCtrl"]() || oBrowserEvent["bAlt"]()) && oSource["tagName"] === "TD") {
		if (window["UCF_System"]["bIsRTL"])
			iMonthIndex = this["oFocusedElementInfo"]["iMonthIndex"] + 1;
		else
			iMonthIndex = this["oFocusedElementInfo"]["iMonthIndex"] - 1;
		if (iMonthIndex === -1) {
			this["previousMonth"]();
			return;
		} else if (iMonthIndex === this["aMonths"]["length"]) {
			this["nextMonth"]();
			return;
		} else {
			if (oBrowserEvent["bAlt"]()) {
				this["oFocusedElementInfo"]["iCellIndex"] = -1;
				this["oFocusedElementInfo"]["iRowIndex"] = -1;
			}
			this["oFocusedElementInfo"]["iMonthIndex"] = iMonthIndex;
			this["focusElementInfo"](this["oFocusedElementInfo"]);
		}
	}
	if (oSource["tagName"] === "TABLE") {
		if (window["UCF_System"]["bIsRTL"])
			iMonthIndex = this["iGetMonthIndex"](oSource) + 1;
		else
			iMonthIndex = this["iGetMonthIndex"](oSource) - 1;
		if (iMonthIndex === -1) {
			this["previousMonth"]();
			return;
		} else if (iMonthIndex === this["aMonths"]["length"]) {
			this["nextMonth"]();
			return;
		} else {
			this["oFocusedElementInfo"]["iCellIndex"] = -1;
			this["oFocusedElementInfo"]["iRowIndex"] = -1;
			this["oFocusedElementInfo"]["iMonthIndex"] = iMonthIndex;
			this["focusElementInfo"](this["oFocusedElementInfo"]);
			return;
		}
	}

};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsleftmodifier"] = 0; };

/**
 * Returns the month index for a given oDomRef
 *
 * @param {element} oDomRef
 * @return {integer}
 *
 */
UCF_DateNavigator["prototype"]["iGetMonthIndex"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["iGetMonthIndex"]++; }; 
	if (!this["aMonths"]) return -1;
	for (var i = 0; i < this["aMonths"]["length"]; i++) {
		if (this["aMonths"][i] === oDomRef) return i;
	}
	return -1;
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["iGetMonthIndex"] = 0; };

/**
 * Handles the lsleft event for the date navigation
 * left on a month will focus the previous month or trigger the previous month event
 * left on a day or will focus the
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsleft"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(474): onlsleft"); };

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource["tagName"] === "TD") {
		var iRowIndex = oSource["parentNode"]["rowIndex"] - 2;
		if (window["UCF_System"]["bIsRTL"]) {
			if (oSource["nextSibling"]) {
				this["oFocusedElementInfo"]["iCellIndex"]++;
				this["focusElementInfo"](this["oFocusedElementInfo"]);
			} else {
				if (++iRowIndex < this["iRows"]) {
					this["oFocusedElementInfo"]["iCellIndex"] = 0;
					this["oFocusedElementInfo"]["iRowIndex"] = iRowIndex;
					this["focusElementInfo"](this["oFocusedElementInfo"]);
				}
			}
		} else {
			if (oSource["previousSibling"]) {
				this["oFocusedElementInfo"]["iCellIndex"]--;
				this["focusElementInfo"](this["oFocusedElementInfo"]);
			} else {
				if (iRowIndex > 0) {
					this["oFocusedElementInfo"]["iCellIndex"] = this["iCells"] - 1;
					this["oFocusedElementInfo"]["iRowIndex"]--;
					this["focusElementInfo"](this["oFocusedElementInfo"]);
				}
			}
		}
	}
	if (oSource["tagName"] === "TABLE") {
		var iMonthIndex;
		if (window["UCF_System"]["bIsRTL"])
			iMonthIndex = this["iGetMonthIndex"](oSource) + 1;
		else
			iMonthIndex = this["iGetMonthIndex"](oSource) - 1;
		if (iMonthIndex === -1) {
			this["previousMonth"]();
			return;
		} else if (iMonthIndex === this["aMonths"]["length"]) {
			this["nextMonth"]();
			return;
		} else {
			this["oFocusedElementInfo"]["iCellIndex"] = -1;
			this["oFocusedElementInfo"]["iRowIndex"] = -1;
			this["oFocusedElementInfo"]["iMonthIndex"] = iMonthIndex;
			this["focusElementInfo"](this["oFocusedElementInfo"]);
			return;
		}
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	return;
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsleft"] = 0; };

/**
 * Handles the onlsup event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsup"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(536): onlsup"); };

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource["tagName"] === "TD") {
		var iRowIndex = oSource["parentNode"]["rowIndex"] - 2;
		if (iRowIndex > 0) {
			this["oFocusedElementInfo"]["iRowIndex"]--;
			this["focusElementInfo"](this["oFocusedElementInfo"]);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
	if (oSource["tagName"] === "TABLE") {
		if (this["iGetMonthIndex"](oSource) === 0 && this["bHasYearNavigation"])
			this["previousYear"]();
		else
			this["onlsleft"](oBrowserEvent);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsup"] = 0; };

/**
 * Handles the onlsdownevent of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsdown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(565): onlsdown"); };

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource["tagName"] === "TD") {
		if (oSource["parentNode"]["nextSibling"]) {
			this["oFocusedElementInfo"]["iRowIndex"]++;
			this["focusElementInfo"](this["oFocusedElementInfo"]);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
	if (oSource["tagName"] === "TABLE") {
		if (this["iGetMonthIndex"](oSource) === this["aMonths"]["length"] - 1 && this["bHasYearNavigation"])
			this["nextYear"]();
		else
			this["onlsright"](oBrowserEvent);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsdown"] = 0; };

/**
 * Handles the onlspageup event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlspageup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlspageup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DateNavigator.js(593): onlspageup"); };
	var iCurrentMonthIndex = this["iGetCurrentMonthIndex"](oBrowserEvent["oSource"]);
	if (iCurrentMonthIndex === 0 ||
		(oBrowserEvent["oSource"]["getAttribute"]("cl") !== "D" && oBrowserEvent["oSource"]["getAttribute"]("cl") !== "W"))
		this["previousMonth"]();
	else this["focusMonth"](iCurrentMonthIndex - 1, true);
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlspageup"] = 0; };

/**
 * Handles the onlspagedown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlspagedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlspagedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DateNavigator.js(610): onlspagedown"); };
	var iCurrentMonthIndex = this["iGetCurrentMonthIndex"](oBrowserEvent["oSource"]);
	if (iCurrentMonthIndex === this["aMonths"]["length"] - 1 ||
		(oBrowserEvent["oSource"]["getAttribute"]("cl") !== "D" && oBrowserEvent["oSource"]["getAttribute"]("cl") !== "W"))
		this["nextMonth"]();
	else this["focusMonth"](iCurrentMonthIndex + 1, false);
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlspagedown"] = 0; };

/**
 * Handles the onlspageupmodifier event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlspageupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlspageupmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DateNavigator.js(627): onlspageupmodifier"); };
	if (oBrowserEvent["bShift"]()) {
		if (this["bHasYearNavigation"])
			this["previousYear"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlspageupmodifier"] = 0; };

/**
 * Handles the onlspagedownmodifier event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlspagedownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlspagedownmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DateNavigator.js(641): onlspagedownmodifier"); };
	if (oBrowserEvent["bShift"]()) {
		if (this["bHasYearNavigation"])
			this["nextYear"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlspagedownmodifier"] = 0; };

/**
 * Handles the onlsfocus event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsfocus"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource["tagName"] === "TD" || oSource["tagName"] === "TABLE") {
		var oTable = UCF_DomUtil["oGetParentByAttribute"](oSource, "tp", "MONTH");
		if (oTable) {
			var iCellIndex = oSource["cellIndex"],
				iRowIndex = oSource["parentNode"]["rowIndex"] - 2,
				iMonthIndex = this["iGetMonthIndex"](oTable);
			if (iRowIndex < 0) {
				iRowIndex = -1;
				iCellIndex = -1;
			}
			this["oFocusedElementInfo"]["iRowIndex"] = iRowIndex;
			this["oFocusedElementInfo"]["iCellIndex"] = iCellIndex;
			this["oFocusedElementInfo"]["iMonthIndex"] = iMonthIndex;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsfocus"] = 0; };

/**
 * Focus an element in the date navigator
 *
 * @param {Object} oElement
 */
UCF_DateNavigator["prototype"]["focusElement"] = function(oElement) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["focusElement"]++; }; 
	var iMonthIndex = -1;
	var oTable = UCF_DomUtil["oGetParentByAttribute"](oElement, "tp", "MONTH");
	if (oTable)
		iMonthIndex = this["iGetMonthIndex"](oTable);
	if (iMonthIndex > -1) {
		var oFocusElement = this["aFocusElements"][iMonthIndex];
		if (oFocusElement &&
			//			oFocusElement.bResetTabIndex &&
			(oElement["getAttribute"]("cl") === "W" || oElement["getAttribute"]("cl") === "D") &&
			UCF_DomUtil["bHasTabIndex"](oFocusElement)) {
			UCF_DomUtil["resetTabIndex"](oFocusElement);
			this["aFocusElements"][iMonthIndex] = null;
		}
		if (oElement["getAttribute"]("cl") === "W" || oElement["getAttribute"]("cl") === "D") {
			if (!UCF_DomUtil["bHasTabIndex"](oElement)) {
				oElement["bResetTabIndex"] = true;
			}
			UCF_DomUtil["setTabIndex"](oElement, 0);
			this["aFocusElements"][iMonthIndex] = oElement;
		}
	}
	UCF_DomUtil["focusDomElement"](oElement);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["focusElement"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(710): ondblclick"); };

	var oSourceDomRef = oBrowserEvent["oGetSource"]();
	if (oSourceDomRef) {
		var bIsClickable = oSourceDomRef["getAttribute"] && oSourceDomRef["getAttribute"]('data-isclickable') === "true";
		if (!bIsClickable)
			return;

		if (oSourceDomRef["getAttribute"]("cl") === "D") {
			if (this["mEvents"]["DayDoubleClick"]) {
				this["fireDayDoubleClick"](this["sId"], oSourceDomRef["id"]);
				oBrowserEvent["cancelBubble"]();
			}
		} else if (oSourceDomRef["parentNode"]["getAttribute"]("cl") === "D") {
			if (this["mEvents"]["DayDoubleClick"]) {
				this["fireDayDoubleClick"](this["sId"], oSourceDomRef["parentNode"]["id"]);
				oBrowserEvent["cancelBubble"]();
			}
		} else if (oSourceDomRef["getAttribute"]("cl") === "M") {
			if (this["mEvents"]["MonthDoubleClick"]) {
				this["fireMonthDoubleClick"](this["sId"], UCF_DomUtil["oGetParentByAttribute"](oSourceDomRef, "tp")["id"]);
				oBrowserEvent["cancelBubble"]();
			}
		} else if (oSourceDomRef["getAttribute"]("tp") === "MONTH") {
			if (this["mEvents"]["MonthDoubleClick"]) {
				this["fireMonthDoubleClick"](this["sId"], oSourceDomRef["id"]);
				oBrowserEvent["cancelBubble"]();
			}
		} else if (oSourceDomRef["getAttribute"]("cl") === "W") {
			if (this["mEvents"]["WeekDoubleClick"]) {
				this["fireWeekDoubleClick"](this["sId"], oSourceDomRef["id"]);
				oBrowserEvent["cancelBubble"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["ondblclick"] = 0; };

/**
 * Handle the lsselectmodifer event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsselectmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsselectmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(754): onlsselectmodifier"); };

	if (!oBrowserEvent["bAlt"]() && (oBrowserEvent["bShift"]() || oBrowserEvent["bCtrl"]()))
		this["onlsselect"](oBrowserEvent);
	else {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsselectmodifier"] = 0; };

/**
 * Handle the lsselect event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(771): onlsselect"); };

	var oSourceDomRef = oBrowserEvent["oGetSource"]();
	var bIsClickable = oSourceDomRef["getAttribute"] && oSourceDomRef["getAttribute"]('data-isclickable') === "true";
	if (oSourceDomRef) {
		if (oSourceDomRef["getAttribute"]("cl") === "P") {
			this["previousMonth"]();
		} else if (oSourceDomRef["getAttribute"]("cl") === "PY") {
			this["previousYear"]();
		} else if (oSourceDomRef["getAttribute"]("cl") === "N") {
			this["nextMonth"]();
		} else if (oSourceDomRef["getAttribute"]("cl") === "NY") {
			this["nextYear"]();
		} else if (oSourceDomRef["getAttribute"]("cl") === "D") {
			this["handleDaySelect"](oSourceDomRef, oBrowserEvent["bShift"](), oBrowserEvent["bCtrl"](), oBrowserEvent["sName"]);
		} else if (oSourceDomRef["parentNode"]["getAttribute"]("cl") === "D") {
			this["handleDaySelect"](oSourceDomRef["parentNode"], oBrowserEvent["bShift"](), oBrowserEvent["bCtrl"](), oBrowserEvent["sName"]);
		} else if ((oSourceDomRef["getAttribute"]("cl") === "M" && bIsClickable)
			|| (oSourceDomRef["getAttribute"]("cl") === "MC" && bIsClickable)) {
			this["monthSelect"](UCF_DomUtil["oGetParentByAttribute"](oSourceDomRef["parentNode"], "id"), oBrowserEvent["bShift"](), oBrowserEvent["bCtrl"]());
		} else if (oSourceDomRef["getAttribute"]("tp") === "MONTH") {
			this["monthSelect"](oSourceDomRef, oBrowserEvent["bShift"](), oBrowserEvent["bCtrl"]());
		} else if (oSourceDomRef["getAttribute"]("cl") === "W") {
			this["weekSelect"](oSourceDomRef, oBrowserEvent["bShift"](), oBrowserEvent["bCtrl"]());
		} else if (oSourceDomRef["parentNode"]["getAttribute"]("cl") === "W") {
			this["weekSelect"](oSourceDomRef["parentNode"], oBrowserEvent["bShift"](), oBrowserEvent["bCtrl"]());
		}
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsselect"] = 0; };

/**
 * Handle the day selection event
 *
 * @param {HTMLElement} oDayDomRef
 * @param {boolean} bShift
 * @param {boolean} bControl
 * @param {string} sEventName
 * @private
 */
UCF_DateNavigator["prototype"]["handleDaySelect"] = function(oDayDomRef, bShift, bControl, sEventName) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["handleDaySelect"]++; }; 
	if (sEventName === 'lstouchend' && this["bHasSelection"]) {
		if (this["sSelectType"] === 'RANGE') {
			this["daySelect"](oDayDomRef, true, bControl);
			this["sSelectType"] = 'STANDARD';
		} else {
			this["daySelect"](oDayDomRef, bShift, bControl);
			this["sSelectType"] = 'RANGE';
		}
		this["setClientProperty"]("SelectType", this["sSelectType"], true);
	} else
		this["daySelect"](oDayDomRef, bShift, bControl);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["handleDaySelect"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsskipback"] = 0; };

/**
 * Navigates the next month
 */
UCF_DateNavigator["prototype"]["nextMonth"] = function() {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["nextMonth"]++; }; 
	if (this["bCanNavigate"]) {
		this["fireNextMonth"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["nextMonth"] = 0; };

/**
 * Navigates the previous month
 */
UCF_DateNavigator["prototype"]["previousMonth"] = function() {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["previousMonth"]++; }; 
	if (this["bCanNavigate"]) {
		this["firePreviousMonth"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["previousMonth"] = 0; };

/**
 * Navigates the next year
 */
UCF_DateNavigator["prototype"]["nextYear"] = function() {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["nextYear"]++; }; 
	if (this["bCanNavigate"]) {
		this["fireNextYear"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["nextYear"] = 0; };

/**
 * Navigates the previous year
 */
UCF_DateNavigator["prototype"]["previousYear"] = function() {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["previousYear"]++; }; 
	if (this["bCanNavigate"]) {
		this["firePreviousYear"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["previousYear"] = 0; };

/**
 * Selects a day
 *
 * @param {element} oDayDomRef
 * @param { boolean } bShift
 * @param { boolean } bCtrl
 */
UCF_DateNavigator["prototype"]["daySelect"] = function(oDayDomRef, bShift, bCtrl) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["daySelect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDayDomRef != null, "oDayDomRef != null", "DateNavigator.js(892): daySelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDayDomRef) === "object", "typeof(oDayDomRef) === \"object\"", "DateNavigator.js(893): daySelect"); };

	var bIsClickable = oDayDomRef["getAttribute"] && oDayDomRef["getAttribute"]('data-isclickable') === "true";
	if (!bIsClickable)
		return;

	var sDayId = oDayDomRef["getAttribute"]("id");
	if (this["bHasSelection"] && bShift)
		this["fireDaySelect"](this["sId"], sDayId, "RANGE");
	else
	if (this["bHasSelection"] && bCtrl)
		this["fireDaySelect"](this["sId"], sDayId, "TOGGLE");
	else
		this["fireDaySelect"](this["sId"], sDayId, "STANDARD");
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["daySelect"] = 0; };

/**
 * Selects a month
 *
 * @param {element} oMonthDomRef
 * @param { boolean } bShift
 * @param { boolean } bCtrl
 */
UCF_DateNavigator["prototype"]["monthSelect"] = function(oMonthDomRef, bShift, bCtrl) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["monthSelect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oMonthDomRef != null, "oMonthDomRef != null", "DateNavigator.js(918): monthSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oMonthDomRef) === "object", "typeof(oMonthDomRef) === \"object\"", "DateNavigator.js(919): monthSelect"); };

	var sMonthId = oMonthDomRef["getAttribute"]("id");
	if (this["bHasSelection"] && bShift)
		this["fireMonthSelect"](this["sId"], sMonthId, "RANGE");
	else
	if (this["bHasSelection"] && bCtrl)
		this["fireMonthSelect"](this["sId"], sMonthId, "TOGGLE");
	else
		this["fireMonthSelect"](this["sId"], sMonthId, "STANDARD");
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["monthSelect"] = 0; };

/**
 * Selects a week
 *
 * @param {element} oWeekDomRef
 * @param { boolean } bShift
 * @param { boolean } bCtrl
 */
UCF_DateNavigator["prototype"]["weekSelect"] = function(oWeekDomRef, bShift, bCtrl) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["weekSelect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oWeekDomRef != null, "oWeekDomRef != null", "DateNavigator.js(940): weekSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oWeekDomRef) === "object", "typeof(oWeekDomRef) === \"object\"", "DateNavigator.js(941): weekSelect"); };

	var bIsClickable = oWeekDomRef["getAttribute"] && oWeekDomRef["getAttribute"]('data-isclickable') === "true";
	if (!bIsClickable)
		return;

	var sWeekId = oWeekDomRef["getAttribute"]("id");
	if (this["bHasSelection"] && bShift)
		this["fireWeekSelect"](this["sId"], sWeekId, "RANGE");
	else
	if (this["bHasSelection"] && bCtrl)
		this["fireWeekSelect"](this["sId"], sWeekId, "TOGGLE");
	else
		this["fireWeekSelect"](this["sId"], sWeekId, "STANDARD");
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["weekSelect"] = 0; };
/**
 * @see UCF_Control
 * @param {Object} oFocusInfo
 */
UCF_DateNavigator["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "DateNavigator.js(961): collectFocusInfo"); };
	if (this["oFocusedElementInfo"]) {
		oFocusInfo["setApplyControl"](this);
		if (isNaN(this["oFocusedElementInfo"]["iRowIndex"])) this["oFocusedElementInfo"]["iRowIndex"] = -1;
		if (isNaN(this["oFocusedElementInfo"]["iCellIndex"])) this["oFocusedElementInfo"]["iCellIndex"] = -1;
		oFocusInfo["addParam"]("iRowIndex", this["oFocusedElementInfo"]["iRowIndex"]);
		oFocusInfo["addParam"]("iCellIndex", this["oFocusedElementInfo"]["iCellIndex"]);
		oFocusInfo["addParam"]("iMonthIndex", this["oFocusedElementInfo"]["iMonthIndex"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["collectFocusInfo"] = 0; };

/**
 * @see UCF_Control
 * @param { Object } oFocusInfo
 */
UCF_DateNavigator["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "DateNavigator.js(977): applyFocusInfo"); };
	this["oFocusedElementInfo"] = {
		"iRowIndex": oFocusInfo["oGetParam"]("iRowIndex"),
		"iCellIndex": oFocusInfo["oGetParam"]("iCellIndex"),
		"iMonthIndex": oFocusInfo["oGetParam"]("iMonthIndex")
	};
	this["focusElementInfo"](this["oFocusedElementInfo"]);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["applyFocusInfo"] = 0; };

/**
 * Returns whether the day with a given id is selected
 * @public
 * @param {string} sDayId pass a day id of the day that should be selected
 * @return {boolean}
 */
UCF_DateNavigator["prototype"]["bIsDaySelected"] = function(sDayId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["bIsDaySelected"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDayId) === "string", "typeof(sDayId) === \"string\"", "DateNavigator.js(993): bIsDaySelected"); };
	var oDay = UCF_DomUtil["$"](sDayId);
	if (oDay) {
		return oDay["className"] && oDay["className"]["indexOf"](this["sSelectionCssClass"]) > -1;
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["bIsDaySelected"] = 0; };

/**
 * Returns whether the day with a given id has the selection state 5
 * which may allow a deselection
 * @public
 * @param {string} sDayId pass a day id of the day that should be selected
 * @return {boolean}
 */
UCF_DateNavigator["prototype"]["bIsDaySelected5"] = function(sDayId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["bIsDaySelected5"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDayId) === "string", "typeof(sDayId) === \"string\"", "DateNavigator.js(1009): bIsDaySelected5"); };
	var oDay = UCF_DomUtil["$"](sDayId);
	if (oDay) {
		return oDay["className"] && oDay["className"]["indexOf"](this["sSelectionCssClass"]) > -1;
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["bIsDaySelected5"] = 0; };

/**
 * Returns whether the week with a given id is selected
 * @public
 * @param {string} sWeekId pass a day id of the day that should be selected
 * @return {boolean}
 */
UCF_DateNavigator["prototype"]["bIsWeekSelected"] = function(sWeekId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["bIsWeekSelected"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sWeekId) === "string", "typeof(sWeekId) === \"string\"", "DateNavigator.js(1024): bIsWeekSelected"); };
	var oWeek = UCF_DomUtil["$"](sWeekId);
	if (oWeek) {
		if (oWeek["allSelected"] && oWeek["allSelected"] === "true")
			return true;
		return false;
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["bIsWeekSelected"] = 0; };

/**
 * Select a day in the DateNavigator
 * @public
 * @param {string} sDayId pass a day id of the day that should be selected
 * @param {string} sMonthID pass a month id of the month that should be selected
 * @param {boolean} bRemoveOldSelection
 * @return {boolean}
 */
UCF_DateNavigator["prototype"]["selectDay"] = function(sDayId, sMonthID, bRemoveOldSelection) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["selectDay"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDayId) === "string", "typeof(sDayId) === \"string\"", "DateNavigator.js(1043): selectDay"); };
	var oDay = UCF_DomUtil["$"](sDayId);
	var retval = false;
	if (oDay && oDay["getAttribute"]("cl") === "D") {
		if (oDay["className"]["indexOf"](this["sSelectionCssClass"]) === -1) UCF_DomUtil["addClass"](oDay, this["sSelectionCssClass"]);
		retval = true;
	} else if (oDay && oDay["parentNode"] && oDay["parentNode"]["getAttribute"]("cl") === "D") {
		if (oDay["parentNode"]["className"]["indexOf"](this["sSelectionCssClass"]) === -1) UCF_DomUtil["addClass"](oDay["parentNode"], this["sSelectionCssClass"]);
		retval = true;
	}
	if (bRemoveOldSelection) {
		if (this["sSelectedDayId"])
			this["deselectDay"](this["sSelectedDayId"]);
		this["sSelectedDayId"] = sDayId;
	}
	if (sMonthID && retval)
		this["oLS"]["scrollIntoView"](sMonthID, true);
	return retval;
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["selectDay"] = 0; };

/**
 * Deselect a day in the DateNavigator
 * @public
 * @param {string} sDayId pass a day id of the day that should be deselected
 */
UCF_DateNavigator["prototype"]["deselectDay"] = function(sDayId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["deselectDay"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDayId) === "string", "typeof(sDayId) === \"string\"", "DateNavigator.js(1069): deselectDay"); };
	var oDay = UCF_DomUtil["$"](sDayId);
	if (oDay && oDay["getAttribute"]("cl") === "D") {
		UCF_DomUtil["removeClass"](oDay, this["sSelectionCssClass"]);
	} else if (oDay && oDay["parentNode"] && oDay["parentNode"]["getAttribute"]("cl") === "D") {
		UCF_DomUtil["removeClass"](oDay["parentNode"], this["sSelectionCssClass"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["deselectDay"] = 0; };

/**
 * Select a week in the DateNavigator
 * @public
 * @param {string} sWeekId pass a week id of the week that should be selected
 */
UCF_DateNavigator["prototype"]["selectWeek"] = function(sWeekId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["selectWeek"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sWeekId) === "string", "typeof(sWeekId) === \"string\"", "DateNavigator.js(1084): selectWeek"); };
	var oWeek = UCF_DomUtil["$"](sWeekId);
	if (oWeek && oWeek["getAttribute"]("cl") === "W") {
		var oRow = oWeek["parentNode"];
		for (var i = 0; i < oRow["childNodes"]["length"]; i++) {
			var oCell = oRow["childNodes"][i];
			if (oCell["className"]["indexOf"](this["sSelectionCssClass"]) === -1) UCF_DomUtil["addClass"](oCell, this["sSelectionCssClass"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["selectWeek"] = 0; };

/**
 * Deselect a week in the DateNavigator
 * @public
 * @param {string} sWeekId pass a week id of the week that should be deselected
 */
UCF_DateNavigator["prototype"]["deselectWeek"] = function(sWeekId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["deselectWeek"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sWeekId) === "string", "typeof(sWeekId) === \"string\"", "DateNavigator.js(1101): deselectWeek"); };
	var oWeek = UCF_DomUtil["$"](sWeekId);
	if (oWeek && oWeek["getAttribute"]("cl") === "W") {
		var oRow = oWeek["parentNode"];
		for (var i = 0; i < oRow["childNodes"]["length"]; i++) {
			var oCell = oRow["childNodes"][i];
			UCF_DomUtil["removeClass"](oCell, this["sSelectionCssClass"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["deselectWeek"] = 0; };

/**
 * Select a month in the DateNavigator
 * @public
 * @param {string} sMonthId pass a month id of the month that should be selected
 */
UCF_DateNavigator["prototype"]["selectMonth"] = function(sMonthId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["selectMonth"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMonthId) === "string", "typeof(sMonthId) === \"string\"", "DateNavigator.js(1118): selectMonth"); };
	var oTable = UCF_DomUtil["$"](sMonthId);
	if (oTable) {
		var oCells = oTable["getElementsByTagName"]("TD");
		for (var i = 0; i < oCells["length"]; i++) {
			var oCell = oCells[i];
			if (oCell["getAttribute"]("cl") === "W" || oCell["getAttribute"]("cl") === "D") {
				if (oCell["className"]["indexOf"](this["sSelectionCssClass"]) === -1) UCF_DomUtil["addClass"](oCell, this["sSelectionCssClass"]);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["selectMonth"] = 0; };

/**
 * Deselect a month in the DateNavigator
 * @public
 * @param {string} sMonthId pass a month id of the month that should be deselected
 */
UCF_DateNavigator["prototype"]["deselectMonth"] = function(sMonthId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["deselectMonth"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMonthId) === "string", "typeof(sMonthId) === \"string\"", "DateNavigator.js(1137): deselectMonth"); };
	var oTable = UCF_DomUtil["$"](sMonthId);
	if (oTable) {
		var oCells = oTable["getElementsByTagName"]("TD");
		for (var i = 0; i < oCells["length"]; i++) {
			var oCell = oCells[i];
			if (oCell["getAttribute"]("cl") === "W" || oCell["getAttribute"]("cl") === "D") {
				UCF_DomUtil["removeClass"](oCell, this["sSelectionCssClass"]);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["deselectMonth"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 *  @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_DateNavigator["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(1157): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSource = oBrowserEvent["oGetSource"](),
		sType = oSource["getAttribute"]("tp");

	if (oSource === this["oDomRef"]) {
		oAccessibilityHelper["setText"](this["sAccessibilityDescription"]);

		oAccessibilityHelper["setControlType"]("DN");
		oAccessibilityHelper["addTutor"]("DN_TUT_SI", [oAccessibilityHelper["sGetSkipContainerText"]()]);
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sCurrentDay"] = null;
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sCurrentWeek"] = null;
	} else if (sType === "MONTH") {
		var oMonthname;
		if (oSource["nodeName"] && oSource["nodeName"] === "SPAN")
			oMonthname = oSource;
		else
			oMonthname = oSource["getElementsByTagName"]("SPAN")[0];
		oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](oMonthname));
		oAccessibilityHelper["setTooltip"](oMonthname["getAttribute"]("tt"));
		var sTutorTexts = oSource["getAttribute"]("tutortexts");
		if (sTutorTexts) {
			var aTutorTexts = sTutorTexts["split"](' ');
			for (var i = 0; i < aTutorTexts["length"]; i++) {
				switch (aTutorTexts[i]) {
					case 'ARIA_DN_YPREV_TUT':
						oAccessibilityHelper["addTutor"]("DN_YPREV_TUT");
						oAccessibilityHelper["addTutor"]("DN_PREV_TUT");
						break;
					case 'ARIA_DN_YNEXT_TUT':
						oAccessibilityHelper["addTutor"]("DN_YNEXT_TUT");
						oAccessibilityHelper["addTutor"]("DN_NEXT_TUT");
						break;
					case 'ARIA_DN_PREV_TUT':
						oAccessibilityHelper["addTutor"]("DN_PREV_TUT");
						break;
					case 'ARIA_DN_NEXT_TUT':
						oAccessibilityHelper["addTutor"]("DN_NEXT_TUT");
						break;
				}
			}

		}
		oAccessibilityHelper["addTutor"]("DN_TUT", [oAccessibilityHelper["sGetSkipContainerText"]()]);
		this["sCurrentDay"] = null;
		this["sCurrentWeek"] = null;
		if (oMonthname["getAttribute"]("cl") === "M") {
			if (UCF_DomUtil["oGetParentByAttribute"](oSource, "allSelected")["allSelected"] === "true") {
				if (this["bAllowDeselection"])
					oAccessibilityHelper["addTutor"]("DESELECT_TUT");
				else
					oAccessibilityHelper["addTutor"]("SELECTED");
			} else
				oAccessibilityHelper["addTutor"]("SELECT_TUT");
		}
	} else if (sType === "WEEK") {
		var oWeek = oSource;
		oAccessibilityHelper["setText"](oAccessibilityHelper["sGetText"]("DN_WEEK", [UCF_DomUtil["sGetInnerText"](oWeek)]));
		oAccessibilityHelper["setTooltip"](oWeek["getAttribute"]("tt"));
		this["sCurrentDay"] = null;
		if (oWeek["getAttribute"]("cl") === "W") {
			if (this["bIsWeekSelected"](oSource["id"])) {
				if (this["bAllowDeselection"])
					oAccessibilityHelper["addTutor"]("DESELECT_TUT");
				else
					oAccessibilityHelper["addTutor"]("SELECTED");
			} else
				oAccessibilityHelper["addTutor"]("SELECT_TUT");
		}
	} else if (sType === "DAY") {
		var oDay = oSource,
			bEnabled = (oDay["className"]["indexOf"]("Dsbl") === -1);
		if (oSource["getAttribute"] && oSource["getAttribute"]("t") && oSource["getAttribute"]("t") !== "") {
			oAccessibilityHelper["setText"](oSource["getAttribute"]("t"));
		} else {
			oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](oDay));
		}
		if (oSource["getAttribute"] && oSource["getAttribute"]("tt") && oSource["getAttribute"]("tt") !== "")
			oAccessibilityHelper["setTooltip"](oSource["getAttribute"]("tt"));
		oAccessibilityHelper["setEnabled"](bEnabled);
		if (bEnabled && oDay["getAttribute"]("cl") === "D") {
			if (this["bIsDaySelected5"](oSource["id"])) {
				if (this["bAllowDeselection"])
					oAccessibilityHelper["addTutor"]("DESELECT_TUT");
				else
					oAccessibilityHelper["addTutor"]("SELECTED");
			} else
				oAccessibilityHelper["addTutor"]("SELECT_TUT");
		}
		var sNewDay = oDay["parentNode"]["parentNode"]["parentNode"]["rows"][1]["cells"][oDay["cellIndex"]]["title"],
			sNewWeek = UCF_DomUtil["sGetInnerText"](oDay["parentNode"]["firstChild"]);
		if (this["sCurrentDay"] !== sNewDay) {
			this["sCurrentDay"] = sNewDay;
			oAccessibilityHelper["setDataTip"](sNewDay);
		}
		if (this["sCurrentWeek"] !== sNewWeek) {
			this["sCurrentWeek"] = sNewWeek;
			oAccessibilityHelper["setDataTip"](sNewDay + '- ' + oAccessibilityHelper["sGetText"]("DN_WEEK", sNewWeek));
		}

		var oLegendDomRef = UCF_DomUtil["$"](this["sId"] + '-legend');
		if (oLegendDomRef) oAccessibilityHelper["setLegendJSDomRef"](oLegendDomRef);
		var sSemantic = oSource["getAttribute"]("sem");
		if (oDay["className"]["indexOf"]("urToday") !== -1 && sSemantic !== "TODAY")
			oAccessibilityHelper["addSemantic"]("TODAY");
		// Do not set unavaiable twice
		if (sSemantic !== "DISABLED")
			oAccessibilityHelper["addSemantic"](sSemantic);
	} else {
		var sCL = oSource["getAttribute"]("cl");
		if (sCL === "PY" || sCL === "P" || sCL === "N" || sCL === "NY") {
			oAccessibilityHelper["setTooltip"](oSource["getAttribute"]("tt"));
			if (this["bCanNavigate"])
				oAccessibilityHelper["addTutor"]("B_TUT");
			else
				oAccessibilityHelper["setEnabled"](false);

		}
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsaccessibility"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */

UCF_DateNavigator["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(1289): onmouseover"); };

	if (!__UCF_IE6__)
		return;
	if (oBrowserEvent && oBrowserEvent["oSource"]) {
		var sClAttr = oBrowserEvent["oSource"]["getAttribute"]("cl");
		if (sClAttr === "N")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "urCalArrNext urCalArrNextHover");
		if (sClAttr === "P")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "urCalArrPrev urCalArrPrevHover");
		if (sClAttr === "M")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"]["parentNode"], "urCalHdr urCalHdrHover");
		if (sClAttr === "MC")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "urCalHdr urCalHdrHover");
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onmouseover"] = 0; };

/**
 * Handles the onmouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DateNavigator.js(1313): onmouseout"); };

	if (!__UCF_IE6__)
		return;
	if (oBrowserEvent && oBrowserEvent["oSource"]) {
		var sClAttr = oBrowserEvent["oSource"]["getAttribute"]("cl");
		if (sClAttr === "N")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "urCalArrNext");
		if (sClAttr === "P")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "urCalArrPrev");
		if (sClAttr === "M")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"]["parentNode"], "urCalHdr");
		if (sClAttr === "MC")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "urCalHdr");
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onmouseout"] = 0; };

UCF_DateNavigator["prototype"]["drawFocusRect"] = function(sDayId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["drawFocusRect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDayId) === "string", "typeof(sDayId) === \"string\"", "DateNavigator.js(1331): drawFocusRect"); };
	var oDay;
	if (this["sFocusRectedDayId"]) {
		oDay = UCF_DomUtil["$"](this["sFocusRectedDayId"]);
		if (!oDay)
			return false;
		oDay = UCF_DomUtil["oGetParentByAttribute"](oDay, "cl", "D");
		if (oDay) {
			UCF_DomUtil["removeClass"](oDay, "lsDNFocusRect");
		}
	}
	var retval = false;
	this["sFocusRectedDayId"] = null;
	oDay = UCF_DomUtil["$"](sDayId);
	if (!oDay)
		return false;
	oDay = UCF_DomUtil["oGetParentByAttribute"](oDay, "cl", "D");
	if (oDay) {
		retval = true;
		UCF_DomUtil["addClass"](oDay, "lsDNFocusRect");
	}
	if (retval) {
		this["sFocusRectedDayId"] = sDayId;
		var oMonth = UCF_DomUtil["oGetParentByAttribute"](oDay, "tp", "MONTH");
		if (oMonth)
			this["oLS"]["scrollIntoView"](oMonth["id"] + "div", false);
	}
	return retval;
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["drawFocusRect"] = 0; };

UCF_DateNavigator["iMoveThreshold"] = 20;

UCF_DateNavigator["prototype"]["oTouchDist"] = function(oTouches) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["oTouchDist"]++; }; 
	var iX = 0,
		iY = 0;
	if (oTouches["length"] === 0)
		return ({ 'iX': 0, 'iY': 0 });
	for (var i = 0; i < oTouches["length"]; i++) {
		iX += oTouches[i]["clientX"];
		iY += oTouches[i]["clientY"];
	}
	return ({ 'iX': iX / i, 'iY': iY / i });
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["oTouchDist"] = 0; };

UCF_DateNavigator["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlstouchstart"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iLastTouchend"] = 0;
	if (!this["oTouchstart"]) {
		this["oTouchstart"] = oBrowserEvent["oDomEvent"];
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iOldClientX"] = oBrowserEvent["oDomEvent"]["touches"][0]["clientX"];
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iOldClientY"] = oBrowserEvent["oDomEvent"]["touches"][0]["clientY"];
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlstouchstart"] = 0; };

UCF_DateNavigator["prototype"]["onlstouchmove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlstouchmove"]++; }; 

	var iDist = this["oTouchDist"](oBrowserEvent["oDomEvent"]["touches"])["iX"] - this["iOldClientX"];
	if (Math["abs"](iDist) > UCF_DateNavigator["iMoveThreshold"]) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iTouchesLength"] = oBrowserEvent["oDomEvent"]["touches"]["length"];
		if (this["iTouchesLength"] > 1) {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsDatePicker--cycleyear');
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cyclemonth');
		} else {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsDatePicker--cyclemonth');
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cycleyear');
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cycleyear');
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cyclemonth');
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlstouchmove"] = 0; };

UCF_DateNavigator["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlstouchend"]++; }; 
	var iDist = this["oTouchDist"](oBrowserEvent["oDomEvent"]["changedTouches"])["iX"] - this["iOldClientX"];
	var iTime = new Date()["getTime"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Touchend with ' + oBrowserEvent["oDomEvent"]["touches"]["length"] + ' fingers, started with ' + this["iTouchesLength"], "DateNavigator.js(1411): onlstouchend"); };
	if (oBrowserEvent["oDomEvent"]["touches"]["length"] === 0) {
		if (Math["abs"](iDist) <= UCF_DateNavigator["iMoveThreshold"])
			if (Math["abs"](this["oTouchDist"](oBrowserEvent["oDomEvent"]["changedTouches"])["iY"] - this["iOldClientY"])
				<= UCF_DateNavigator["iMoveThreshold"])
				this["onlsselect"](oBrowserEvent);
			else {
				if (this["iTouchesLength"] > 1 || (iTime - this["iLastTouchend"]) < 500) {
					if (iDist < 0) this["nextYear"]();
					else if (iDist > 0) this["previousYear"]();
				} else {
					if (iDist < 0) this["nextMonth"]();
					else if (iDist > 0) this["previousMonth"]();
				}
			}
		this["oTouchstart"] = null;
	}
	this["iLastTouchend"] = iTime;
	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cycleyear');
	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cyclemonth');
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlstouchend"] = 0; };

UCF_DateNavigator["prototype"]["iGetCurrentMonthIndex"] = function(oDayDomRef) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["iGetCurrentMonthIndex"]++; }; 
	var oMonthDomRef = UCF_DomUtil["oGetParentByAttribute"](oDayDomRef, "tp", "MONTH");
	for (var iIndex = 0; iIndex < this["aMonths"]["length"]; iIndex++)
		if (this["aMonths"][iIndex]["id"] === oMonthDomRef["id"])
			return iIndex;
	return -1;
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["iGetCurrentMonthIndex"] = 0; };

UCF_DateNavigator["prototype"]["focusMonth"] = function(iIndex, bLast) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["focusMonth"]++; }; 
	var oCurrentMonth = this["aMonths"][iIndex];
	var oDay;
	if (!bLast) {
		oDay = UCF_DomUtil["oGetFirstChildByAttribute"](oCurrentMonth, "cl", "D");
		while (oDay && oDay["getAttribute"]('design') === "DISABLED")
			oDay = UCF_DomUtil["nextSibling"](oDay, "TD");
	} else {
		oDay = UCF_DomUtil["oGetLastChildByAttribute"](oCurrentMonth, "cl", "D");
		while (oDay && oDay["getAttribute"]('design') === "DISABLED") {
			oDay = UCF_DomUtil["previousSibling"](oDay, "TD");
			if (oDay && oDay["getAttribute"]('cl') === "W") {
				oDay = UCF_DomUtil["previousSibling"](oDay["parentElement"], "TR");
				if (oDay)
					oDay = UCF_DomUtil["oGetLastChildByAttribute"](oDay, "cl", "D");
			}
		}
	}
	if (oDay) {
		this["oFocusedElementInfo"]["iCellIndex"] = oDay["cellIndex"];
		this["oFocusedElementInfo"]["iRowIndex"] = oDay["parentNode"]["rowIndex"] - 2;
		this["oFocusedElementInfo"]["iMonthIndex"] = iIndex;
		this["focusElementInfo"](this["oFocusedElementInfo"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["focusMonth"] = 0; };

/**
 * Handles the end event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DateNavigator.js(1476): onlsend"); };
	if (oBrowserEvent["oSource"]["getAttribute"]("cl") !== "D") return;
	this["focusMonth"](this["oFocusedElementInfo"]["iMonthIndex"], true);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlsend"] = 0; };

/**
 * Handles the home event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DateNavigator["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlshome"]++; }; 
	if (oBrowserEvent["oSource"]["getAttribute"]("cl") !== "D" && oBrowserEvent["oSource"]["getAttribute"]("cl") !== "W") return;
	this["focusMonth"](this["oFocusedElementInfo"]["iMonthIndex"], false);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["onlshome"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_DateNavigator["prototype"]["aAttributeNames"] = ["bCanNavigate","bHasLegend","sAccessibilityDescription","sVisibility","bHasSelection","bAllowDeselection","bHasYearNavigation","sCustomData","sSelectType"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_DateNavigator["prototype"]["aEventNames"] = ["DaySelect","MonthSelect","WeekSelect","DayDoubleClick","WeekDoubleClick","MonthDoubleClick","NextMonth","PreviousMonth","NextYear","PreviousYear","ContextMenu"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_DateNavigator["prototype"]["aMethodNames"] = ["selectMonth","deselectMonth","selectWeek","deselectWeek","selectDay","deselectDay","bIsDaySelected","bIsWeekSelected","drawFocusRect","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {boolean}
 */
UCF_DateNavigator["prototype"]["bCanNavigate"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_DateNavigator["prototype"]["bHasLegend"] = false;

/**
 * @private
 * @type {string}
 */
UCF_DateNavigator["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_DateNavigator["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_DateNavigator["prototype"]["bHasSelection"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_DateNavigator["prototype"]["bAllowDeselection"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_DateNavigator["prototype"]["bHasYearNavigation"] = false;

/**
 * @private
 * @type {string}
 */
UCF_DateNavigator["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DateNavigatorSelectType}
 */
UCF_DateNavigator["prototype"]["sSelectType"] = "STANDARD";

//#JSCOVER_EXCL_START
/** @protected */
UCF_DateNavigator["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["setDefaultValues"]++; }; 
	this["bCanNavigate"] = true;
	this["bHasLegend"] = false;
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["bHasSelection"] = false;
	this["bAllowDeselection"] = false;
	this["bHasYearNavigation"] = false;
	this["sCustomData"] = '';
	this["sSelectType"] = "STANDARD";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CanNavigate", true, true);
		this["setClientProperty"]("HasLegend", false, true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("HasSelection", false, true);
		this["setClientProperty"]("AllowDeselection", false, true);
		this["setClientProperty"]("HasYearNavigation", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("SelectType", "STANDARD", true);
	}
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the DateNavigator
 * @param {string} sDayId Identifier of the of the DateNavigatorDay
 * @param {string} sAccessType Indicates if the select was done using modifier keys on the client. STANDARD for the standard select, RANGE for an intended range select.
 * @fires DateNavigator::DaySelect
 */
UCF_DateNavigator["prototype"]["fireDaySelect"] = function(sId, sDayId, sAccessType) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireDaySelect"]++; }; 
	/** @type {{Id: string, DayId: string, AccessType: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "DateNavigator.js(1611): fireDaySelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DateNavigator.js(1612): fireDaySelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DateNavigator.js(1613): fireDaySelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDayId != null, "sDayId != null", "DateNavigator.js(1614): fireDaySelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDayId) == "string", "typeof(sDayId) == \"string\"", "DateNavigator.js(1615): fireDaySelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "DateNavigator.js(1616): fireDaySelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "DateNavigator.js(1617): fireDaySelect"); };
	mParams = {
		"Id": sId,
		"DayId": sDayId,
		"AccessType": sAccessType
	};
	
	if (sDayId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sDayId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "DayId");
			}
		}
	
	this["fireSemanticEvent"]("DateNavigator", "DaySelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireDaySelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sMonthId Identifier of the DateNavigatorMonth
 * @param {string} sAccessType Indicates if the select was done using modifier keys on the client. STANDARD for the standard select, RANGE for an intended range select.
 * @fires DateNavigator::MonthSelect
 */
UCF_DateNavigator["prototype"]["fireMonthSelect"] = function(sId, sMonthId, sAccessType) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireMonthSelect"]++; }; 
	/** @type {{Id: string, MonthId: string, AccessType: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "DateNavigator.js(1647): fireMonthSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DateNavigator.js(1648): fireMonthSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DateNavigator.js(1649): fireMonthSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMonthId != null, "sMonthId != null", "DateNavigator.js(1650): fireMonthSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMonthId) == "string", "typeof(sMonthId) == \"string\"", "DateNavigator.js(1651): fireMonthSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "DateNavigator.js(1652): fireMonthSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "DateNavigator.js(1653): fireMonthSelect"); };
	mParams = {
		"Id": sId,
		"MonthId": sMonthId,
		"AccessType": sAccessType
	};
	
	if (sMonthId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sMonthId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "MonthId");
			}
		}
	
	this["fireSemanticEvent"]("DateNavigator", "MonthSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireMonthSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sWeekId Identifier of the DateNavigatorWeek
 * @param {string} sAccessType Indicates if the select was done using modifier keys on the client. STANDARD for the standard select, RANGE for an intended range select.
 * @fires DateNavigator::WeekSelect
 */
UCF_DateNavigator["prototype"]["fireWeekSelect"] = function(sId, sWeekId, sAccessType) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireWeekSelect"]++; }; 
	/** @type {{Id: string, WeekId: string, AccessType: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "DateNavigator.js(1683): fireWeekSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DateNavigator.js(1684): fireWeekSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DateNavigator.js(1685): fireWeekSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sWeekId != null, "sWeekId != null", "DateNavigator.js(1686): fireWeekSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sWeekId) == "string", "typeof(sWeekId) == \"string\"", "DateNavigator.js(1687): fireWeekSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "DateNavigator.js(1688): fireWeekSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "DateNavigator.js(1689): fireWeekSelect"); };
	mParams = {
		"Id": sId,
		"WeekId": sWeekId,
		"AccessType": sAccessType
	};
	
	if (sWeekId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sWeekId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "WeekId");
			}
		}
	
	this["fireSemanticEvent"]("DateNavigator", "WeekSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireWeekSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the DateNavigator
 * @param {string} sDayId Identifier of the of the DateNavigatorDay
 * @fires DateNavigator::DayDoubleClick
 */
UCF_DateNavigator["prototype"]["fireDayDoubleClick"] = function(sId, sDayId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireDayDoubleClick"]++; }; 
	/** @type {{Id: string, DayId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "DateNavigator.js(1718): fireDayDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DateNavigator.js(1719): fireDayDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DateNavigator.js(1720): fireDayDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDayId != null, "sDayId != null", "DateNavigator.js(1721): fireDayDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDayId) == "string", "typeof(sDayId) == \"string\"", "DateNavigator.js(1722): fireDayDoubleClick"); };
	mParams = {
		"Id": sId,
		"DayId": sDayId
	};
	
	if (sDayId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sDayId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "DayId");
			}
		}
	this["fireSemanticEvent"]("DateNavigator", "DayDoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireDayDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the DateNavigator
 * @param {string} sWeekId Identifier of the of the DateNavigatorDay
 * @fires DateNavigator::WeekDoubleClick
 */
UCF_DateNavigator["prototype"]["fireWeekDoubleClick"] = function(sId, sWeekId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireWeekDoubleClick"]++; }; 
	/** @type {{Id: string, WeekId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "DateNavigator.js(1749): fireWeekDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DateNavigator.js(1750): fireWeekDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DateNavigator.js(1751): fireWeekDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sWeekId != null, "sWeekId != null", "DateNavigator.js(1752): fireWeekDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sWeekId) == "string", "typeof(sWeekId) == \"string\"", "DateNavigator.js(1753): fireWeekDoubleClick"); };
	mParams = {
		"Id": sId,
		"WeekId": sWeekId
	};
	
	if (sWeekId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sWeekId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "WeekId");
			}
		}
	this["fireSemanticEvent"]("DateNavigator", "WeekDoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireWeekDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the DateNavigator
 * @param {string} sMonthId Identifier of the of the DateNavigatorDay
 * @fires DateNavigator::MonthDoubleClick
 */
UCF_DateNavigator["prototype"]["fireMonthDoubleClick"] = function(sId, sMonthId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireMonthDoubleClick"]++; }; 
	/** @type {{Id: string, MonthId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "DateNavigator.js(1780): fireMonthDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DateNavigator.js(1781): fireMonthDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DateNavigator.js(1782): fireMonthDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMonthId != null, "sMonthId != null", "DateNavigator.js(1783): fireMonthDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMonthId) == "string", "typeof(sMonthId) == \"string\"", "DateNavigator.js(1784): fireMonthDoubleClick"); };
	mParams = {
		"Id": sId,
		"MonthId": sMonthId
	};
	
	if (sMonthId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sMonthId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "MonthId");
			}
		}
	this["fireSemanticEvent"]("DateNavigator", "MonthDoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireMonthDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires DateNavigator::NextMonth
 */
UCF_DateNavigator["prototype"]["fireNextMonth"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireNextMonth"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "DateNavigator.js(1808): fireNextMonth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DateNavigator.js(1809): fireNextMonth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DateNavigator.js(1810): fireNextMonth"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("DateNavigator", "NextMonth", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireNextMonth"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires DateNavigator::PreviousMonth
 */
UCF_DateNavigator["prototype"]["firePreviousMonth"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["firePreviousMonth"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "DateNavigator.js(1827): firePreviousMonth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DateNavigator.js(1828): firePreviousMonth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DateNavigator.js(1829): firePreviousMonth"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("DateNavigator", "PreviousMonth", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["firePreviousMonth"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires DateNavigator::NextYear
 */
UCF_DateNavigator["prototype"]["fireNextYear"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireNextYear"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "DateNavigator.js(1846): fireNextYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DateNavigator.js(1847): fireNextYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DateNavigator.js(1848): fireNextYear"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("DateNavigator", "NextYear", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireNextYear"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires DateNavigator::PreviousYear
 */
UCF_DateNavigator["prototype"]["firePreviousYear"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["firePreviousYear"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "DateNavigator.js(1865): firePreviousYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DateNavigator.js(1866): firePreviousYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DateNavigator.js(1867): firePreviousYear"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("DateNavigator", "PreviousYear", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["firePreviousYear"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sType Indicates whether the 'DAY', 'WEEK', 'MONTH' was clicked
 * @param {string} sPartId The id of the part that was clicked
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {boolean} bShift Indicates whether the shift key was pressed when the event occured.
 * @param {boolean} bCtrl Indicates whether the control key was pressed when the event occured.
 * @param {boolean} bAlt Indicates whether the alt key was pressed when the event occured.
 * @fires DateNavigator::ContextMenu
 */
UCF_DateNavigator["prototype"]["fireContextMenu"] = function(sId, sType, sPartId, iPosX, iPosY, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireContextMenu"]++; }; 
	/** @type {{Id: string, Type: string, PartId: string, PosX: number, PosY: number, Shift: boolean, Ctrl: boolean, Alt: boolean}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 8, "arguments.length == 8", "DateNavigator.js(1893): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DateNavigator.js(1894): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DateNavigator.js(1895): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sType != null, "sType != null", "DateNavigator.js(1896): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sType) == "string", "typeof(sType) == \"string\"", "DateNavigator.js(1897): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPartId != null, "sPartId != null", "DateNavigator.js(1898): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPartId) == "string", "typeof(sPartId) == \"string\"", "DateNavigator.js(1899): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "DateNavigator.js(1900): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "DateNavigator.js(1901): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "DateNavigator.js(1902): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "DateNavigator.js(1903): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "DateNavigator.js(1904): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "DateNavigator.js(1905): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "DateNavigator.js(1906): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "DateNavigator.js(1907): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "DateNavigator.js(1908): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "DateNavigator.js(1909): fireContextMenu"); };
	mParams = {
		"Id": sId,
		"Type": sType,
		"PartId": sPartId,
		"PosX": iPosX,
		"PosY": iPosY,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt
	};
	
	
	if (sPartId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sPartId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "PartId");
			}
		}
	
	
	
	
	
	this["fireSemanticEvent"]("DateNavigator", "ContextMenu", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DateNavigator["_"]["fireContextMenu"] = 0; };

UCF_DateNavigator.prototype["aPublicMethods"] = ["bIsDaySelected","bIsDaySelected5","bIsWeekSelected","selectDay","deselectDay","selectWeek","deselectWeek","selectMonth","deselectMonth"].concat(UCF_DateNavigator.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_DatePicker"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Date */
/// <reference path="../types/Date.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * A datepicker to select a date on the client
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 * @param {string} sId
 */
function UCF_DatePicker(oDomRef, oLS, sId) {if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["UCF_DatePicker"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Control["apply"](this, [oDomRef, oLS, sId]); // Why not UCF_LayeredControl?

		this["defineEvents"](['Close', 'Select']);

		//initialize the control
		// eslint-disable-next-line @ur/no-memory-leaks
		this["bIncludeWeek"] = true;
		// eslint-disable-next-line @ur/no-memory-leaks
		this["bEnabled"] = true;
		this["oSelectedDate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
		this["oStartDate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
		this["oStartDate"]["setDate"](1);
		this["aDays"] = new Array();
		this["oConnectedControl"] = null;

		var oDom = this["oCreateDom"]();
		if (!this["bEmbedded"]) {
			oLS["oGetAssociatedAreaRef"]()["appendChild"](oDom);
			this["connectToDom"](oDom);
			this["bEnhancePopupWindows"] = true;
			UCF_LayeredControl["apply"](this, [oDom, oLS]);
			this["setMoveIntoViewPortXY"](true, true);
		} else {
			document["getElementById"](this["sId"] + '-container')["appendChild"](oDom);
			this["connectToDom"](oDom);
		}

		this["bTutorRead"] = true;
		this["bKeepAlive"] = true;

		this["sDateFormat"] = "DEFAULT";
	}
};window["UCF_DatePicker"] = UCF_DatePicker; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DatePicker"); UCF_DatePicker["_"] = {UCF_DatePicker: 0}; }; ;
UCF_DatePicker["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_DatePicker.prototype["sClassName"] = "UCF_DatePicker";

UCF_DatePicker["prototype"]["addClassesOnOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["addClassesOnOpen"]++; }; 
	if (!UCF_DomUtil["bHasClass"](this["oRootRef"], UCF_LayeredControl["BOX_SHADOW_CLASS"])) {
		UCF_DomUtil["addClass"](this["oRootRef"], UCF_LayeredControl["BOX_SHADOW_CLASS"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["addClassesOnOpen"] = 0; };

UCF_DatePicker["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setDefaultValues"]++; }; };;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setDefaultValues"] = 0; };

/**
 * Connects to the DOM
 * @param {HTMLElement} oDomRef
 */
UCF_DatePicker["prototype"]["connectToDom"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["connectToDom"]++; }; 
	UCF_LayeredControl.prototype["connectToDom"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["connectToDom"] = 0; };

/**
 * Renders the HTML
 * @return {HTMLElement}
 */
UCF_DatePicker["prototype"]["oCreateDom"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["oCreateDom"]++; }; 
	var oDiv = document["createElement"]("DIV");
	oDiv["setAttribute"]("ct", "DatePicker");
	oDiv["setAttribute"]("id", this["sId"]);
	oDiv["setAttribute"]("aria-describedby", "ARIA_DP_TUT");
	oDiv["setAttribute"]("role", "application");
	if ("ls-datepicker" === this["sId"])
		this["bEmbedded"] = false;
	else
		this["bEmbedded"] = true;
	if (!this["bEmbedded"]) {
		oDiv["style"]["position"] = "absolute";
		oDiv["style"]["top"] = "-1000px";
	}
	UCF_DomUtil["addClass"](oDiv, "lsDatePicker");
	return oDiv;
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["oCreateDom"] = 0; };

/**
 * Sets the connected control where the datepicker should align to
 *
 * @param {UCF_Control} oControl the control instance
 */
UCF_DatePicker["prototype"]["setConnectedControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setConnectedControl"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oControl) === "object", "typeof(oControl) === \"object\"", "DatePicker.js(111): setConnectedControl"); };
	this["oConnectedControl"] = oControl;
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setConnectedControl"] = 0; };

/**
 * Sets the selected date for the datepicker
 * If no start date is set the selected date is used to render the
 * initialy rendered month.
 *
 * @param {UCF_Date} oSelectedDate the selected date in the datepicker
 */
UCF_DatePicker["prototype"]["setSelectedDate"] = function(oSelectedDate) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setSelectedDate"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oSelectedDate) === "object", "typeof(oSelectedDate) === \"object\"", "DatePicker.js(123): setSelectedDate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSelectedDate instanceof UCF_Date, "oSelectedDate instanceof UCF_Date", "DatePicker.js(124): setSelectedDate"); };
	// Same behaviour as SAPGui/Windows see Incident 88852 / 2017
	if (oSelectedDate && (oSelectedDate["iGetYear"]() > 8999 || oSelectedDate["iGetYear"]() < 10))
		this["oSelectedDate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
	else
		this["oSelectedDate"] = oSelectedDate;
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setSelectedDate"] = 0; };

/**
 * returns the selected date for the datepicker
 *
 * @return {UCF_Date}
 */
UCF_DatePicker["prototype"]["oGetSelectedDate"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["oGetSelectedDate"]++; }; 
	return this["oSelectedDate"];
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["oGetSelectedDate"] = 0; };

/**
 * sets the start date for the datepicker
 *
 * @param {UCF_Date} oStartDate the starting date of the datepicker
 */
UCF_DatePicker["prototype"]["setStartDate"] = function(oStartDate) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setStartDate"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oStartDate) === "object", "typeof(oStartDate) === \"object\"", "DatePicker.js(147): setStartDate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oStartDate instanceof UCF_Date, "oStartDate instanceof UCF_Date", "DatePicker.js(148): setStartDate"); };

	if (oStartDate["iGetYear"]() > 8999 || oStartDate["iGetYear"]() < 10 || isNaN(oStartDate["iGetYear"]()))
		this["oStartDate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
	else
		this["oStartDate"] = oStartDate;

	this["oStartDate"]["setDate"](1);
	// Do not show weeks for years before 100
	this["setIncludeWeek"](this["oStartDate"]["iGetYear"]() > 100);
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setStartDate"] = 0; };

/**
 * sets wheather calendar weeks are shown or not
 *
 * @param {boolean} bIncludeWeek sets the week
 */
UCF_DatePicker["prototype"]["setIncludeWeek"] = function(bIncludeWeek) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setIncludeWeek"]++; }; 
	this["bIncludeWeek"] = bIncludeWeek;
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setIncludeWeek"] = 0; };

/**
 * open the datepicker
 */
UCF_DatePicker["prototype"]["open"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["open"]++; }; 
	this["bOpen"] = true;
	this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);
	this["setOpenerRef"](this["oConnectedControl"]["oRootRef"]);
	this["render"]();
	this["bTutorRead"] = false;
	if (!this["bEmbedded"]) {
		this["openBase"]();
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sDelayId"] = UCF_JsUtil["delayedCall"](100, this, "attachAnyEvent");
		this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["BeforeHotkey"], this, "close");
	}
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["open"] = 0; };

/** @private */
UCF_DatePicker["prototype"]["attachAnyEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["attachAnyEvent"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oWindow;

	if (this["bOpen"]) {
		oWindow = this["oLS"]["oBrowserWindow"];
		oWindow["attachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
	}
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["attachAnyEvent"] = 0; };

/**
 * close the datepicker
 */
UCF_DatePicker["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["close"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oWindow;

	if (this["bOpen"] && !this["bIsDestroyed"]) {
		// detach listening on any events
		oWindow = this["oLS"]["oBrowserWindow"];
		this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["BeforeHotkey"], this, 'close');
		oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');

		if (this["oDomRef"]) {
			UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
		}

		// close date picker
		this["bOpen"] = false;
		this["closeBase"]();
		this["bTutorRead"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["close"] = 0; };

/**
 * sets the datepickers enabled state
 *
 * @param {boolean} bEnabled
 */
UCF_DatePicker["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setEnabled"]++; }; 
	this["bEnabled"] = bEnabled;
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["setEnabled"] = 0; };

UCF_DatePicker["iMoveThreshold"] = 20;

UCF_DatePicker["prototype"]["oTouchDist"] = function(oTouches) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["oTouchDist"]++; }; 
	var iX = 0,
		iY = 0;
	if (oTouches["length"] === 0)
		return ({ 'iX': 0, 'iY': 0 });
	for (var i = 0; i < oTouches["length"]; i++) {
		iX += oTouches[i]["clientX"];
		iY += oTouches[i]["clientY"];
	}
	return ({ 'iX': iX / i, 'iY': iY / i });
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["oTouchDist"] = 0; };

UCF_DatePicker["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlstouchstart"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iLastTouchend"] = 0;
	if (!this["oTouchstart"]) {
		this["oTouchstart"] = oBrowserEvent["oDomEvent"];
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iOldClientX"] = oBrowserEvent["oDomEvent"]["touches"][0]["clientX"];
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iOldClientY"] = oBrowserEvent["oDomEvent"]["touches"][0]["clientY"];
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlstouchstart"] = 0; };

UCF_DatePicker["prototype"]["onlstouchmove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlstouchmove"]++; }; 
	var iDist = this["oTouchDist"](oBrowserEvent["oDomEvent"]["touches"])["iX"] - this["iOldClientX"];
	if (Math["abs"](iDist) > UCF_DatePicker["iMoveThreshold"]) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iTouchesLength"] = oBrowserEvent["oDomEvent"]["touches"]["length"];
		if (this["iTouchesLength"] > 1) {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsDatePicker--cycleyear');
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cyclemonth');
		} else {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsDatePicker--cyclemonth');
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cycleyear');
		}
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cycleyear');
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cyclemonth');
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlstouchmove"] = 0; };

UCF_DatePicker["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlstouchend"]++; }; 
	if (!oBrowserEvent["oDomEvent"]["changedTouches"])
		return;
	var iDist = this["oTouchDist"](oBrowserEvent["oDomEvent"]["changedTouches"])["iX"] - this["iOldClientX"];
	var iTime = new Date()["getTime"]();
	if (oBrowserEvent["oDomEvent"]["touches"]["length"] === 0) {
		if (Math["abs"](iDist) <= UCF_DatePicker["iMoveThreshold"])
			this["onclick"](oBrowserEvent);
		else {
			if (this["iTouchesLength"] > 1 || (iTime - this["iLastTouchend"]) < 500) {
				if (iDist < 0) this["gotoNextYear"]();
				else this["gotoPreviousYear"]();
			} else {
				if (iDist < 0) this["gotoNextMonth"]();
				else this["gotoPreviousMonth"]();
			}
		}
		this["oTouchstart"] = null;
	}
	this["iLastTouchend"] = iTime;
	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cycleyear');
	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDatePicker--cyclemonth');
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlstouchend"] = 0; };

// /**
//  * @param {UCF_BrowserEvent} oBrowserEvent The corresponding 'touchend' event of the 'swipe'.
//  * @private
//  */
// UCF_DatePicker.prototype.onlsswipeleft = function(oBrowserEvent) {
// 	this.gotoNextMonth();
//  	oBrowserEvent.cancel();
//  	oBrowserEvent.cancelBubble();
// };

// /**
//  * @param {UCF_BrowserEvent} oBrowserEvent The corresponding 'touchend' event of the 'swipe'.
//  * @private
//  */
// UCF_DatePicker.prototype.onlsswiperight = function(oBrowserEvent) {
// 	this.gotoPreviousMonth();
// 	oBrowserEvent.cancel();
// 	oBrowserEvent.cancelBubble();
// };

// /**
//  * Handle 'touchmove' in addition to 'swipe' events for visualization of button states
//  * @param {UCF_BrowserEvent} oBrowserEvent
//  * @private
// */
// UCF_DatePicker.prototype.onlstouchmove = function(oBrowserEvent) {
// 	if (oBrowserEvent.bSwipeThresholdExceeded()) {
// 		UCF_DomUtil.removeClass(this.oDomRef, 'lsDatePicker--cycleyear');
// 		UCF_DomUtil.removeClass(this.oDomRef, 'lsDatePicker--cyclemonth');
// 	}
// };

/**
 * Handles all events of the browser on the datepicker
 *
 * @param {UCF_Event} oEvent the event object
 * @private
 */
UCF_DatePicker["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onAnyEvent"]++; }; 
	var oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent");
	var oSource = oBrowserEvent["oGetSource"]();
	var oSourceRoot = oBrowserEvent["oGetSourceRoot"]();

	// close date picker if you click somewhere outside the date picker
	if ((oBrowserEvent["sGetName"]() === 'click' || oBrowserEvent["sGetName"]() === 'touchstart') &&
		oSourceRoot !== this["oDomRef"] &&
		oSourceRoot !== this["oConnectedControl"]["oDomRef"] &&
		(oSource !== this["oConnectedControl"]["oGetHelpButtonRef"]() || this["oConnectedControl"]["bFieldHelpFloating"])
	) {
		this["close"]();
	} else if (oBrowserEvent["sGetName"]() === 'lsfocuslost' && !(UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]() || window["UCF_System"]["sDevice"] === 'standards')) {
		this["close"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onAnyEvent"] = 0; };

/**
 * Handles the click event on the DatePicker
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DatePicker["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DatePicker.js(366): onclick"); };

	var oDateDomRef = oBrowserEvent["oSource"];
	var oOldSelected;

	//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	if (oDateDomRef["tagName"] === "TD")
		oDateDomRef = oDateDomRef["firstChild"];
	var iDateValue = parseInt(oDateDomRef["getAttribute"]("date")),
		sGoto = oDateDomRef["getAttribute"]("goto");
	if (!isNaN(iDateValue)) {
		oOldSelected = UCF_DomUtil["oGetFirstChildByAttribute"](oDateDomRef["parentNode"]["parentNode"]["parentNode"],
			'date', this["sSelectedDay"]);
		if (oOldSelected)
			UCF_DomUtil["removeClass"](oOldSelected, 'urSel5');
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sSelectedDay"] = oDateDomRef["getAttribute"]("date");
		UCF_DomUtil["addClass"](oDateDomRef, 'urSel5');
		this["oSelectedDate"]["setTime"](iDateValue);
		this["fireEvent"](this["E_EVENTS"]["Select"], { "date": this["oSelectedDate"], "bTouchInteraction": oBrowserEvent["bIsTouchInteraction"]() });
		this["close"]();
	} else if (sGoto) {
		this[sGoto]();
	} else {
		if (this["aDays"][this["iCurrentDay"]]) {
			UCF_DomUtil["focusDomElement"](this["aDays"][this["iCurrentDay"]]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onclick"] = 0; };

/**
 * Handles left arrow key event on the DatePicker
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DatePicker["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsleft"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var iCurrentDay = this["iGetDayFromSource"](oSource);
	if (window["UCF_System"]["bIsRTL"])
		this["focusOnNextDay"](iCurrentDay);
	else
		this["focusOnPreviousDay"](iCurrentDay);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsleft"] = 0; };

/**
 * Sets the focus to the Previous day
 *
 * @param {number} iCurrentDay the current day
 * @private
 */
UCF_DatePicker["prototype"]["focusOnPreviousDay"] = function(iCurrentDay) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["focusOnPreviousDay"]++; }; 
	var iPreviousDay = iCurrentDay - 1;
	if (iPreviousDay < 0) {
		if (this["oStartDate"]["iGetYear"]() === 1 &&
			this["oStartDate"]["iGetMonth"]() === 0) {
			return;
		}
		this["gotoPreviousMonth"]();
		if (this["sDelayedCallId"])
			UCF_JsUtil["clearDelayedCall"](this["sDelayedCallId"]);
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sDelayedCallId"] = null;
		iPreviousDay = this["aDays"]["length"] - 1;
	} else {
		UCF_DomUtil["setTabIndex"](this["aDays"][iCurrentDay], -1);
	}
	UCF_DomUtil["setTabIndex"](this["aDays"][iPreviousDay], 0);
	UCF_DomUtil["focusDomElement"](this["aDays"][iPreviousDay]);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iCurrentDay"] = iPreviousDay;
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["focusOnPreviousDay"] = 0; };

/**
 * Handles right arrow key event on the DatePicker
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DatePicker["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsright"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var iCurrentDay = this["iGetDayFromSource"](oSource);
	if (window["UCF_System"]["bIsRTL"])
		this["focusOnPreviousDay"](iCurrentDay);
	else
		this["focusOnNextDay"](iCurrentDay);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsright"] = 0; };

/**
 * Sets the focus to the next day
 *
 * @param {number} iCurrentDay the current day
 * @private
 */
UCF_DatePicker["prototype"]["focusOnNextDay"] = function(iCurrentDay) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["focusOnNextDay"]++; }; 
	var iNextDay = iCurrentDay + 1;
	if (iNextDay >= this["aDays"]["length"]) {
		if (this["oStartDate"]["iGetYear"]() === 9999 &&
			this["oStartDate"]["iGetMonth"]() === 11) {
			return;
		}
		this["gotoNextMonth"]();
		if (this["sDelayedCallId"])
			UCF_JsUtil["clearDelayedCall"](this["sDelayedCallId"]);
		this["sDelayedCallId"] = null;
		iNextDay = 0;
	} else {
		UCF_DomUtil["setTabIndex"](this["aDays"][iCurrentDay], -1);
	}
	UCF_DomUtil["setTabIndex"](this["aDays"][iNextDay], 0);
	UCF_DomUtil["focusDomElement"](this["aDays"][iNextDay]);
	this["iCurrentDay"] = iNextDay;
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["focusOnNextDay"] = 0; };

/**
 * Handles home key event on the DatePicker
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DatePicker["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlshome"]++; }; 
	var oSource = oBrowserEvent["oGetSource"](),
		iCurrentDay = this["iGetDayFromSource"](oSource),
		iNewIndex = iCurrentDay - oSource["parentNode"]["cellIndex"] + 1;
	while (iNewIndex < 0) iNewIndex++;
	UCF_DomUtil["setTabIndex"](this["aDays"][iNewIndex], 0);
	UCF_DomUtil["focusDomElement"](this["aDays"][iNewIndex]);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlshome"] = 0; };

/**
 * Handles end key event on the DatePicker
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DatePicker["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsend"]++; }; 
	var oSource = oBrowserEvent["oGetSource"](),
		iCurrentDay = this["iGetDayFromSource"](oSource),
		iNewIndex = iCurrentDay + (oSource["parentNode"]["parentNode"]["childNodes"]["length"] - 1 - oSource["parentNode"]["cellIndex"]);
	while (iNewIndex > this["aDays"]["length"] - 1) iNewIndex--;
	UCF_DomUtil["setTabIndex"](this["aDays"][iNewIndex], 0);
	UCF_DomUtil["focusDomElement"](this["aDays"][iNewIndex]);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsend"] = 0; };

/**
 * Handles up arrow key event on the DatePicker
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DatePicker["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsup"]++; }; 
	var oSource = oBrowserEvent["oGetSource"](),
		iCurrentDay = this["iGetDayFromSource"](oSource),
		iPreviousWeek = iCurrentDay - 7;
	if (iPreviousWeek < 0) {
		if (this["oStartDate"]["iGetYear"]() === 1 &&
			this["oStartDate"]["iGetMonth"]() === 0) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			return;
		}
		this["gotoPreviousMonth"]();
		iPreviousWeek = this["aDays"]["length"] + iPreviousWeek;
	} else {
		UCF_DomUtil["setTabIndex"](this["aDays"][iCurrentDay], -1);
	}
	UCF_DomUtil["setTabIndex"](this["aDays"][iPreviousWeek], 0);
	UCF_DomUtil["focusDomElement"](this["aDays"][iPreviousWeek]);
	this["iCurrentDay"] = iPreviousWeek;
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsup"] = 0; };

/**
 * Handles down arrow key event on the DatePicker
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DatePicker["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsdown"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var iCurrentDay = this["iGetDayFromSource"](oSource);
	var iNextWeek = iCurrentDay + 7;
	if (iNextWeek >= this["aDays"]["length"]) {
		if (this["oStartDate"]["iGetYear"]() === 9999 &&
			this["oStartDate"]["iGetMonth"]() === 11) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			return;
		}
		iNextWeek = iNextWeek - this["aDays"]["length"];
		this["gotoNextMonth"]();
	} else {
		UCF_DomUtil["setTabIndex"](this["aDays"][iCurrentDay], -1);
	}
	UCF_DomUtil["setTabIndex"](this["aDays"][iNextWeek], 0);
	UCF_DomUtil["focusDomElement"](this["aDays"][iNextWeek]);
	this["iCurrentDay"] = iNextWeek;
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsdown"] = 0; };

/**
 * Handles the keydown event on the DatePicker
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DatePicker["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onkeydown"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DatePicker.js(584): onkeydown"); };

	var iKeyCode = oBrowserEvent["iKeyCode"]();
	var bShift = oBrowserEvent["bShift"]();
	var bAlt = oBrowserEvent["bAlt"]();

	if (!this["bAriaTutorRemoved"]) {
		this["bAriaremoved"] = true;
		this["oAriaHack"]["removeAttribute"]("aria-describedby");
	}
	if (iKeyCode === UCF_KeyCodes["TAB"]) {
		if (!this["bEmbedded"]) {
			UCF_DomUtil["focusDomElement"](this["oConnectedControl"]);
			this["close"]();
		}
	} else if (iKeyCode === UCF_KeyCodes["ESCAPE"] ||
		iKeyCode === UCF_KeyCodes["F4"] ||
		iKeyCode === UCF_KeyCodes["F2"] ||
		(iKeyCode === UCF_KeyCodes["ARROW_UP"] && bAlt)) {
		if (!this["bEmbedded"]) {
			this["oConnectedControl"]["oNavigation"]["keepEditMode"]();
			this["oConnectedControl"]["focus"]();
			this["close"]();
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	} else if (iKeyCode === UCF_KeyCodes["PAGE_DOWN"] && !bShift) {
		this["gotoNextMonth"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (iKeyCode === UCF_KeyCodes["PAGE_DOWN"] && bShift) {
		this["gotoNextYear"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (iKeyCode === UCF_KeyCodes["PAGE_UP"] && !bShift) {
		this["gotoPreviousMonth"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (iKeyCode === UCF_KeyCodes["PAGE_UP"] && bShift) {
		this["gotoPreviousYear"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (iKeyCode === UCF_KeyCodes["ENTER"]) {
		this["onclick"](oBrowserEvent);
		if (!this["bEmbedded"]) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	} else if (iKeyCode === UCF_KeyCodes["SPACE"]) {
		this["onclick"](oBrowserEvent);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onkeydown"] = 0; };

/**
 * Renders the datepickers HTML
 */
UCF_DatePicker["prototype"]["render"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["render"]++; };  // eslint-disable-line complexity
	var mDatePicker = new Array(),
		iMonthNumber = this["oStartDate"]["iGetMonth"](),
		iYear = this["oStartDate"]["iGetYear"]();

	var sNBSP = (window["UCF_System"]["sDevice"] === "standards" ? "" : "&nbsp;");

	mDatePicker["push"]('<div class="urCalPicWhl"');
	if (window["UCF_System"]["bIsAria"])
		mDatePicker["push"](' aria-roledescription="' +
			this["oLS"]["sGetText"]('SAPUR_CAL_DAY_SHORTNAME') + '" role="application"');
	mDatePicker["push"]('>');

	// ===== date picker navigation row and header ============================

	mDatePicker["push"]('<table cellpadding="0" cellspacing="0" border="0" class="lsControl--fullwidth lsCalPicHeader"');
	if (window["UCF_System"]["bIsAria"]) mDatePicker["push"]('role="application" ');

	if (window["UCF_System"]["sDevice"] === 'standards') {
		this["sPrevYearClass"] = 'lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconHv lsCalArrBtnIconYear lsCalArrPrevYear lsMirrorRtl  lsDateNavigator--button';
		this["sNextYearClass"] = 'lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconHv lsCalArrBtnIconYear lsCalArrNextYear lsMirrorRtl lsDateNavigator--button';
		this["sPrevYearClassDsbl"] = 'lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconYear lsCalArrBtnIconDsbl lsCalArrPrevYearDsbl lsMirrorRtl  lsDateNavigator--button';
		this["sNextYearClassDsbl"] = 'lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconYear lsCalArrBtnIconDsbl lsCalArrNextYearDsbl lsMirrorRtl lsDateNavigator--button';
	} else {
		this["sPrevYearClass"] = 'lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconHv lsCalArrBtnIconYear lsCalArrPrevYear lsMirrorRtl';
		this["sNextYearClass"] = 'lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconHv lsCalArrBtnIconYear lsCalArrNextYear lsMirrorRtl';
		this["sPrevYearClassDsbl"] = 'lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconYear lsCalArrBtnIconDsbl lsCalArrPrevYearDsbl lsMirrorRtl';
		this["sNextYearClassDsbl"] = 'lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconYear lsCalArrBtnIconDsbl lsCalArrNextYearDsbl lsMirrorRtl';
	}

	if (window["UCF_System"]["sDevice"] === 'standards') {
		mDatePicker["push"]('<tr>');
		mDatePicker["push"]('<td class="lsDateNavigator--header" align="center" colspan="8" role="row">');
		// do not allow navigation to years less than 0
		if (iYear === 1) {
			mDatePicker["push"]('<span id="' + this["sId"] + '-prevyear" cl="PY" class="' + this["sPrevYearClassDsbl"] + '"></span>');
		} else {
			mDatePicker["push"]('<span id="' + this["sId"] + '-prevyear" cl="PY" goto="gotoPreviousYear" class="' + this["sPrevYearClass"] + '" title="' + this["oLS"]["sGetText"]('SAPUR_DN_YPREV') + '"></span>');
		}

		// do not allow navigation to previous months if year is 1 and month is 0
		if (iYear === 1 && iMonthNumber === 0) {
			mDatePicker["push"]('<span class="lsDateNavigator--button lsDateNavigator--hasYear lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconDsbl urCalArrPrevDsbl lsMirrorRtl"></span>');
		} else {
			mDatePicker["push"]('<span cl="P" goto="gotoPreviousMonth" class="lsDateNavigator--button lsDateNavigator--hasYear lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconHv urCalArrPrev lsMirrorRtl" title="' + this["oLS"]["sGetText"]("SAPUR_DN_PREV") + '"></span>');
		}
		mDatePicker["push"]('<span colspan="4" id="' + this["sId"] + '-monthtitle" class="urCalHdrDsbl lsDateNavigator--month lsCalendar--month lsControl--center" nowrap align="center">');
		mDatePicker["push"](this["oStartDate"]["sGetMonthTitle"]());
		mDatePicker["push"]('</span>');
		//do not allow navigation to next months if year is 9999 and month is 11
		if (iYear === 9999 && iMonthNumber === 11) {
			mDatePicker["push"]('<span class="lsDateNavigator--button lsCalArrowBtn lsDateNavigator--hasYear lsCalArrBtnIcon lsCalArrBtnIconDsbl urCalArrNextDsbl lsMirrorRtl"></span>');
		} else {
			mDatePicker["push"]('<span cl="N" goto="gotoNextMonth" class="lsDateNavigator--button lsDateNavigator--hasYear lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconHv urCalArrNext lsMirrorRtl" title="' + this["oLS"]["sGetText"]("SAPUR_DN_NEXT") + '">' + sNBSP + '</span>');
		}

		//do not allow navigation to years greater than 9999
		if (iYear === 9999) {
			mDatePicker["push"]('<span id="' + this["sId"] + '-nextyear" cl="NY" class="' + this["sNextYearClassDsbl"] + '"></span>');
		} else {
			mDatePicker["push"]('<span id="' + this["sId"] + '-nextyear" cl="NY" goto="gotoNextYear" class="' + this["sNextYearClass"] + '" title="' + this["oLS"]["sGetText"]("SAPUR_DN_YNEXT") + '"></span>');
		}

		mDatePicker["push"]('</td>');
		mDatePicker["push"]('</tr>');
	} else {
		mDatePicker["push"]('<tr class="lsDateNavigator--header">');
		// do not allow navigation to years less than 0
		if (iYear === 1) {
			mDatePicker["push"]('<th id="' + this["sId"] + '-prevyear" class="' + this["sPrevYearClassDsbl"] + '">' + sNBSP + '</th>');
		} else {
			mDatePicker["push"]('<th id="' + this["sId"] + '-prevyear" cl="PY" goto="gotoPreviousYear" class="' + this["sPrevYearClass"] + '" title="' + this["oLS"]["sGetText"]('SAPUR_DN_YPREV') + '">' + sNBSP + '</th>');
		}

		// do not allow navigation to previous months if year is 1 and month is 0
		if (iYear === 1 && iMonthNumber === 0) {
			mDatePicker["push"]('<th class="lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconDsbl urCalArrPrevDsbl lsMirrorRtl">' + sNBSP + '</th>');
		} else {
			mDatePicker["push"]('<th cl="P" goto="gotoPreviousMonth" class="lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconHv urCalArrPrev lsMirrorRtl" title="' + this["oLS"]["sGetText"]("SAPUR_DN_PREV") + '">' + sNBSP + '</th>');
		}

		mDatePicker["push"]('<th colspan="4" id="' + this["sId"] + '-monthtitle" class="urCalHdrDsbl" nowrap align="center">');
		mDatePicker["push"](this["oStartDate"]["sGetMonthTitle"]());
		mDatePicker["push"]('</th>');

		//do not allow navigation to next months if year is 9999 and month is 11
		if (iYear === 9999 && iMonthNumber === 11) {
			mDatePicker["push"]('<th class="lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconDsbl urCalArrNextDsbl lsMirrorRtl">' + sNBSP + '</th>');
		} else {
			mDatePicker["push"]('<th cl="N" goto="gotoNextMonth" class="lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconHv urCalArrNext lsMirrorRtl" title="' + this["oLS"]["sGetText"]("SAPUR_DN_NEXT") + '">' + sNBSP + '</th>');
		}

		//do not allow navigation to years greater than 9999
		if (iYear === 9999) {
			mDatePicker["push"]('<th id="' + this["sId"] + '-nextyear" class="' + this["sNextYearClassDsbl"] + '">' + sNBSP + '</th>');
		} else {
			mDatePicker["push"]('<th id="' + this["sId"] + '-nextyear" cl="NY" goto="gotoNextYear" class="' + this["sNextYearClass"] + '" title="' + this["oLS"]["sGetText"]("SAPUR_DN_YNEXT") + '">' + sNBSP + '</th>');
		}
		mDatePicker["push"]('</tr>');
	}
	mDatePicker["push"]('</table>');

	// ===== dates ============================================================

	mDatePicker["push"]('<table id="' + this["sId"] + '-month-content" cellpadding="0" cellspacing="0" border="0" class="lsControl--fullwidth"');
	if (window["UCF_System"]["bIsAria"]) mDatePicker["push"](' role="application" ');
	mDatePicker["push"]('>');

	mDatePicker["push"](this["sGetInnerHTMLForMonthTable"]());

	mDatePicker["push"]('</table>');
	mDatePicker["push"]('</div');

	// eslint-disable-next-line no-unsanitized/property
	this["oDomRef"]["innerHTML"] = mDatePicker["join"]('');
	this["completeState"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["render"] = 0; };

UCF_DatePicker["prototype"]["completeState"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["completeState"]++; };  // eslint-disable-line complexity

	var iYear = this["oStartDate"]["iGetYear"]();

	if (iYear === 1)
		document["getElementById"](this["sId"] + '-prevyear')["className"] = this["sPrevYearClassDsbl"];
	else
		document["getElementById"](this["sId"] + '-prevyear')["className"] = this["sPrevYearClass"];
	if (iYear === 9999)
		document["getElementById"](this["sId"] + '-nextyear')["className"] = this["sNextYearClassDsbl"];
	else
		document["getElementById"](this["sId"] + '-nextyear')["className"] = this["sNextYearClass"];

	// update days of the month
	this["aDays"] = [];
	var aDays = this["oDomRef"]["getElementsByTagName"]("TD");
	// focus day, try selected day, then today, the first day of month
	var iSelectedDay = -1;
	var iToday = -1;
	for (var i = 0; i < aDays["length"]; i++) {
		if (UCF_DomUtil["bHasClass"](aDays[i], 'urCalIna')
			|| UCF_DomUtil["bHasClass"](aDays[i], 'lsDateNavigator--header')) {
			continue;
		}

		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
		var oDay = aDays[i]["firstChild"];
		this["aDays"]["push"](oDay);
		if (UCF_DomUtil["bHasClass"](oDay, "urTodayPicI")) {
			iToday = this["aDays"]["length"] - 1;
		}
		if (UCF_DomUtil["bHasClass"](oDay, "urSel5")) {
			iSelectedDay = this["aDays"]["length"] - 1;
		}
	}
	if (!this["bOpened"] && iSelectedDay > -1) {
		this["iCurrentDay"] = iSelectedDay;
	} else if (!this["bOpened"] && iToday > -1) {
		this["iCurrentDay"] = iToday;
	} else if (!this["bOpened"]) {
		this["iCurrentDay"] = 0;
	}
	if (!this["aDays"][this["iCurrentDay"]]) this["iCurrentDay"] = this["aDays"]["length"] - 1;
	UCF_DomUtil["setTabIndex"](this["aDays"][this["iCurrentDay"]], 0);
	this["aDays"][this["iCurrentDay"]]["setAttribute"]('aria-describedby', "ARIA_DP_TUT");
	this["oAriaHack"] = this["aDays"][this["iCurrentDay"]];
	this["sDelayedCallId"] =
		UCF_JsUtil["delayedCall"](0, UCF_DomUtil, "focusDomElement", [this["aDays"][this["iCurrentDay"]]]);
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["completeState"] = 0; };

UCF_DatePicker["prototype"]["sGetInnerHTMLForMonthTable"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["sGetInnerHTMLForMonthTable"]++; };  // eslint-disable-line complexity

	this["oStartDate"]["setDate"](1);
	var mDatePicker = [],
		iDaynumber = this["oStartDate"]["iGetFirstDayOfWeek"](),
		oToday = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))(),
		oRealStartDate = this["oStartDate"]["oGetStartOfWeekDate"](),
		oCalcDate;

	if (window["UCF_System"]["sUTCOffset"] !== "") {
		var oTmpDate = new Date();
		oToday["setHours"](oTmpDate["getHours"]());
		oToday["setMinutes"](oTmpDate["getMinutes"]());
		oToday["setDateWithSystemUTCOffset"]();
	}

	if (this["oSelectedDate"] === this["oStartDate"])
		this["oSelectedDate"] = this["oStartDate"]["oGetClone"]();

	if (oRealStartDate["bIsSameDay"](this["oStartDate"])) {
		oRealStartDate["addDays"](-7);
	}

	oCalcDate = oRealStartDate;

	// ----- column headers ---------------------------------------------------

	mDatePicker["push"]('<tr class="urCalRow">');
	if (this["bIncludeWeek"]) {
		mDatePicker["push"]('<th class="lsDateNavigator--cell lsDate--weeknumber">&nbsp;</th>');
	}
	for (var n = 0; n < 7; n++) {
		mDatePicker["push"]('<th class="urCalName" title="' + UCF_Date["aDayNames"][iDaynumber] + '">');
		mDatePicker["push"](UCF_Date["aDayNamesAbbrev"][iDaynumber]);
		mDatePicker["push"]('</th>');
		iDaynumber++;
		if (iDaynumber > 6) {
			iDaynumber = 0;
		}
	}
	mDatePicker["push"]('</tr>');

	// ----- weeks and days ---------------------------------------------------

	var aWeek = new Array();
	for (var iWeek = 0; iWeek < 6; iWeek++) {
		mDatePicker["push"]('<tr class="urCalRow');
		if (oCalcDate["iGetMonth"]() !== this["oStartDate"]["iGetMonth"]()) {
			oCalcDate["addDays"](6);
			if (oCalcDate["iGetMonth"]() !== this["oStartDate"]["iGetMonth"]()) {
				mDatePicker["push"](' lsDatepicker__week--differentmonth');
			}
			oCalcDate["addDays"](-6);
		}
		mDatePicker["push"]('">');
		if (this["bIncludeWeek"]) {
			var iWeekNumber = oCalcDate["iGetWeek"]();
			mDatePicker["push"]('<th class="lsDateNavigator--cell lsDate--weeknumber" ');
			if (window["UCF_System"]["bIsAria"]) {
				mDatePicker["push"](' aria-label="');
				aWeek[0] = iWeekNumber;
				mDatePicker["push"](this["oLS"]["sGetText"]('SAPUR_DN_WEEK', aWeek));
				mDatePicker["push"]('"');
			}
			mDatePicker["push"]('>');
			if (iWeekNumber > 0) {
				mDatePicker["push"](iWeekNumber);
			} else {
				mDatePicker["push"]('&nbsp;');
			}
			mDatePicker["push"]('</th>');
		}
		for (var iDay = 0; iDay < 7; iDay++) {
			mDatePicker["push"]('<td');
			mDatePicker["push"](' class="lsDateNavigator--cell');
			if (oCalcDate["iGetMonth"]() !== this["oStartDate"]["iGetMonth"]()) {
				mDatePicker["push"](' urCalIna');
			} else {
				mDatePicker["push"](' lsDateNavigator--cell-active');
			}
			if (oToday["bIsSameDay"](oCalcDate)) {
				mDatePicker["push"](' urToday');
			}
			mDatePicker["push"]('"');
			mDatePicker["push"]('>');
			mDatePicker["push"]('<div');
			if (oCalcDate["iGetYear"]() > -1 && oCalcDate["iGetYear"]() < 10000) {
				mDatePicker["push"](' date="' + oCalcDate["iGetTime"]() + '"');
			}

			mDatePicker["push"](' class="urBorderBox');
			if (oCalcDate["iGetMonth"]() === this["oStartDate"]["iGetMonth"]())
				mDatePicker["push"](' .urCursorClickable');
			if (oCalcDate["iGetMonth"]() === this["oStartDate"]["iGetMonth"]()) {
				if (this["oSelectedDate"]["bIsSameDay"](oCalcDate)) {
					this["sSelectedDay"] = '' + oCalcDate["iGetTime"]() + '';
					mDatePicker["push"](' urSel5');
				}
				//				else {
				if (oCalcDate["bIsWeekend"]())
					mDatePicker["push"](' urCalWeekend');
				else
					mDatePicker["push"](' urCalWeekday');
				//				}
			}

			//            if (this.oSelectedDate.bIsSameDay(oCalcDate)) {
			//                mDatePicker.push(' lsDatepicker__day--selected');
			//            }
			if (oToday["bIsSameDay"](oCalcDate)) {
				//                mDatePicker.push(' lsDatepicker__day--today urTodayPicI');
				mDatePicker["push"](' urTodayPicI');
			} else {
				mDatePicker["push"](' urCalPicDay');
			}
			// 0 == Sunday
			// 6 == Saturday
			/*            if (UCF_JsUtil.contains([0, 6], oCalcDate.iGetDay())) {
			                mDatePicker.push(' lsDatepicker__day--weekend');
			            }
			            if (oCalcDate.iGetMonth() !== this.oStartDate.iGetMonth()) {
			                mDatePicker.push(' lsDatepicker__day--differentmonth');
			            }
			            */
			mDatePicker["push"]('"');
			if (window["UCF_System"]["bIsAria"]) {
				mDatePicker["push"](' aria-label="');
				mDatePicker["push"](this["oStartDate"]["sGetMonthTitle"]());
				mDatePicker["push"](' ');
				mDatePicker["push"](oCalcDate["iGetDate"]());
				mDatePicker["push"](' ' + UCF_Date["aDayNames"][oCalcDate["iGetDay"]()] + ' ');
				aWeek[0] = iWeekNumber;
				mDatePicker["push"](this["oLS"]["sGetText"]('SAPUR_DN_WEEK', aWeek));
				if (this["oSelectedDate"]["bIsSameDay"](oCalcDate) || oToday["bIsSameDay"](oCalcDate)) {
					mDatePicker["push"](' ' + this["oLS"]["sGetText"]('SAPUR_CHECKED'));
				}
				mDatePicker["push"]('"');
			}
			//            mDatePicker.push(' tabindex="0" ');
			mDatePicker["push"]('>');
			mDatePicker["push"](oCalcDate["iGetDate"]());
			mDatePicker["push"]('</td>');
			oCalcDate["addDays"](1);
		}
		mDatePicker["push"]('</tr>');
	}
	return mDatePicker["join"]('');
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["sGetInnerHTMLForMonthTable"] = 0; };

UCF_DatePicker["prototype"]["reRender"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["reRender"]++; }; 
	// eslint-disable-next-line no-unsanitized/property
	document["getElementById"](this["sId"] + '-month-content')["innerHTML"] = this["sGetInnerHTMLForMonthTable"]();
	document["getElementById"](this["sId"] + '-monthtitle')["textContent"] = this["oStartDate"]["sGetMonthTitle"]();
	this["completeState"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["reRender"] = 0; };

/**
 * Go to the next month in the date picker
 * @return {void}
 */
UCF_DatePicker["prototype"]["gotoNextMonth"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["gotoNextMonth"]++; }; 

	//do not allow to navigate to years > 9999
	if (this["oStartDate"]["iGetYear"]() === 9999 && this["oStartDate"]["iGetMonth"]() === 11) return;

	this["oStartDate"]["addMonths"](1);
	if (window["UCF_System"]["sDevice"] === 'standards')
		this["reRender"]();
	else
		this["render"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["gotoNextMonth"] = 0; };

/**
 * Go to the next year in the date picker
 * @return {void}
 */
UCF_DatePicker["prototype"]["gotoNextYear"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["gotoNextYear"]++; }; 

	//do not allow to navigate to years > 10000
	if (this["oStartDate"]["iGetYear"]() === 9999) return;

	this["oStartDate"]["addMonths"](12);
	if (window["UCF_System"]["sDevice"] === 'standards')
		this["reRender"]();
	else
		this["render"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["gotoNextYear"] = 0; };

/**
 * Go to the previous month in the date picker
 * @return {void}
 */
UCF_DatePicker["prototype"]["gotoPreviousMonth"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["gotoPreviousMonth"]++; }; 

	//do not allow to navigate to years < 0
	if (this["oStartDate"]["iGetYear"]() === 1 && this["oStartDate"]["iGetMonth"]() === 0) return;

	this["oStartDate"]["addMonths"](-1);
	if (window["UCF_System"]["sDevice"] === 'standards')
		this["reRender"]();
	else
		this["render"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["gotoPreviousMonth"] = 0; };

/**
 * Go to the previous year in the date picker
 * @return {void}
 */
UCF_DatePicker["prototype"]["gotoPreviousYear"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["gotoPreviousYear"]++; }; 

	//do not allow to navigate to years < 0
	if (this["oStartDate"]["iGetYear"]() === 1) return;

	this["oStartDate"]["addMonths"](-12);
	if (window["UCF_System"]["sDevice"] === 'standards')
		this["reRender"]();
	else
		this["render"]();
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["gotoPreviousYear"] = 0; };

/**
 * get the day value
 * @param {HTMLElement} oSource
 * @return {void}
 */
UCF_DatePicker["prototype"]["iGetDayFromSource"] = function(oSource) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["iGetDayFromSource"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oSource) === "object", "typeof(oSource) === \"object\"", "DatePicker.js(1036): iGetDayFromSource"); };

	var iDay = 0;
	var sDay = UCF_DomUtil["sGetInnerText"](oSource);
	if (sDay) iDay = parseInt(sDay) - 1;
	if (isNaN(iDay)) iDay = this["iCurrentDay"];
	this["iCurrentDay"] = iDay;
	return iDay;
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["iGetDayFromSource"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 * @return {void}
 */
UCF_DatePicker["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DatePicker.js(1055): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oDateDomRef = oBrowserEvent["oSource"];

	//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	if (oDateDomRef["tagName"] === "TD")
		oDateDomRef = oDateDomRef["firstChild"];

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	//value
	var sFormat = this["oConnectedControl"]["sGetFormatString"](),
		sDate = oDateDomRef["getAttribute"]("date");
	if (sDate) {
		var oTodaysDate = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))(),
			oFocusedDate = (new (UCF_ClassLoader["oGetClass"]("UCF_Date"))())["setTime"](parseInt(sDate));

		/*		if (UCF_System.sUTCOffset !== "")
					oTodaysDate = oTodaysDate.oGetDateWithSystemUTCOffset(UCF_System.sUTCOffset);
		*/
		sDate = oFocusedDate["sGetFormattedDate"](sFormat);
		oAccessibilityHelper["setText"](sDate);
		if (this["oSelectedDate"] && this["oSelectedDate"]["bIsSameDay"](oFocusedDate)) {
			oAccessibilityHelper["setSelected"](true);
		}
		if (oFocusedDate["bIsSameDay"](oTodaysDate)) {
			oAccessibilityHelper["setToday"](true);
		}

		if (!this["bTutorRead"]) {
			this["bTutorRead"] = true;
			oAccessibilityHelper["addTutor"]("DP_TUT");
		}
		var oDay = oBrowserEvent["oGetSource"]();
		if (oDay["parentElement"]["cellIndex"]) {
			var sNewDay = oDay["parentNode"]["parentNode"]["parentNode"]["rows"][0]["cells"][oDay["parentElement"]["cellIndex"]]["title"],
				sNewWeek = UCF_DomUtil["sGetInnerText"](oDay["parentNode"]["parentNode"]["cells"][0]);
			oAccessibilityHelper["setDataTip"](sNewDay + " " + oAccessibilityHelper["sGetText"]("DN_WEEK", sNewWeek));
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlsaccessibility"] = 0; };

/**
 * Handles the onlshotkey event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */

UCF_DatePicker["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlshotkey"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DatePicker.js(1107): onlshotkey"); };
	if (oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["ENTER"]) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onlshotkey"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */

UCF_DatePicker["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DatePicker.js(1122): onmouseover"); };

	if (!__UCF_IE6__)
		return;
	if (oBrowserEvent && oBrowserEvent["oSource"]) {
		var sClAttr = oBrowserEvent["oSource"]["getAttribute"]("cl");
		if (sClAttr === "N")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "urCalArrNext urCalArrNextHover");
		else if (sClAttr === "P")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "urCalArrPrev urCalArrPrevHover");
		else if (sClAttr === "NY")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "lsCalArrNextYear lsCalArrNextYearHover");
		else if (sClAttr === "PY")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "lsCalArrPrevYear lsCalArrPrevYearHover");
	}
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onmouseover"] = 0; };

/**
 * Handles the onmouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 * @return {void}
 */
UCF_DatePicker["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DatePicker.js(1147): onmouseout"); };

	if (!__UCF_IE6__)
		return;
	if (oBrowserEvent && oBrowserEvent["oSource"]) {
		var sClAttr = oBrowserEvent["oSource"]["getAttribute"]("cl");
		if (sClAttr === "N")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "urCalArrNext lsMirrorRtl");
		else if (sClAttr === "P")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "urCalArrPrev lsMirrorRtl");
		else if (sClAttr === "NY")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "lsCalArrNextYear lsMirrorRtl");
		else if (sClAttr === "PY")
			UCF_DomUtil["setClass"](oBrowserEvent["oSource"], "lsCalArrPrevYear lsMirrorRtl");
	}
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["onmouseout"] = 0; };

/**
 * Detach Events and clear all delayed calls
 * @private
 */
UCF_DatePicker["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["destroy"]++; }; 
	/** @type {UCF_BrowserWindow} */

	var oWindow = this["oLS"]["oBrowserWindow"];
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["BeforeHotkey"], this, "close");
	oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");
	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	UCF_DomUtil["removeFromDom"](this["oDomRef"]);
	if (this["oSelectedDate"])
		this["oSelectedDate"]["destroy"]();
	this["oSelectedDate"] = null;
	if (this["oStartDate"])
		this["oStartDate"]["destroy"]();
	this["oStartDate"] = null;
	this["oConnectedControl"] = null;
	this["oTouchstart"] = null;
	this["aDays"] = null;
	this["oAriaHack"] = null;
	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DatePicker["_"]["destroy"] = 0; };


};
sap["ls"]["preload"]["UCF_DatePickerSlider"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Date */
/// <reference path="../types/Date.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * A DateTimePicker to select a date/time on the client
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 * @param {string} sId
 * @depends UCF_PickerSlider
 *
 */
function UCF_DatePickerSlider(oDomRef, oLS, sId) {if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["UCF_DatePickerSlider"]++; }; 
	if (arguments["length"] === 0) {
		return;
	}
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DatePickerSlider.js(42): UCF_DatePickerSlider"); };

	//initialize the control
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bIncludeWeek"] = true;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bEnabled"] = true;
	this["oSelectedDate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
	this["oStartDate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
	this["oConnectedControl"] = null;
	this["bIncludeWeek"] = true;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sDateFormat"] = "DEFAULT";
	this["iVisibleItems"] = 7; // visible items per slider
	this["bEnhancePopupWindows"] = true;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sId"] = sId;

	var oDom = this["oCreateDom"]();
	oLS["oGetAssociatedAreaRef"]()["appendChild"](oDom);

	this["oLS"] = oLS;

	UCF_LayeredControl["apply"](this, [oDom, oLS]);
	this["defineEvents"](['Close', 'Select']);
	this["bKeepAlive"] = true;
	this["setMoveIntoViewPortXY"](true, true);
};window["UCF_DatePickerSlider"] = UCF_DatePickerSlider; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DatePickerSlider"); UCF_DatePickerSlider["_"] = {UCF_DatePickerSlider: 0}; }; ;
UCF_DatePickerSlider["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_DatePickerSlider.prototype["sClassName"] = "UCF_DatePickerSlider";

UCF_DatePickerSlider["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setDefaultValues"]++; }; };;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setDefaultValues"] = 0; };

UCF_DatePickerSlider["prototype"]["setDateFormat"] = function(sDateFormat) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setDateFormat"]++; }; 
	this["sDateFormat"] = sDateFormat;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setDateFormat"] = 0; };

UCF_DatePickerSlider["prototype"]["setFormatString"] = function(sDateFormat) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setFormatString"]++; }; 
	this["sDateFormat"] = sDateFormat;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setFormatString"] = 0; };

UCF_DatePickerSlider["prototype"]["sGetFormatString"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["sGetFormatString"]++; }; 
	return this["sDateFormat"];
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["sGetFormatString"] = 0; };

UCF_DatePickerSlider["prototype"]["addClassesOnOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["addClassesOnOpen"]++; }; 
	if (!UCF_DomUtil["bHasClass"](this["oRootRef"], UCF_LayeredControl["BOX_SHADOW_CLASS"])) {
		UCF_DomUtil["addClass"](this["oRootRef"], UCF_LayeredControl["BOX_SHADOW_CLASS"]);
	}
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["addClassesOnOpen"] = 0; };

/**
 * Connects to the DOM
 *  @param {HTMLElement} oDomRef
 */
UCF_DatePickerSlider["prototype"]["connectToDom"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["connectToDom"]++; }; 
	UCF_LayeredControl.prototype["connectToDom"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["connectToDom"] = 0; };

/**
 * Renders the HTML
 * @return {HTMLElement}
 */
UCF_DatePickerSlider["prototype"]["oCreateDom"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oCreateDom"]++; }; 
	var oDiv = document["createElement"]("DIV");
	oDiv["setAttribute"]("ct", "DatePickerSlider");
	oDiv["setAttribute"]("id", this["sId"]);
	oDiv["style"]["position"] = "absolute";
	oDiv["style"]["top"] = "-1000px";
	UCF_DomUtil["addClass"](oDiv, "lsDatePickerSlider");
	return oDiv;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oCreateDom"] = 0; };

/**
 * Sets the connected control where the DatePickerSlider should align to
 *
 * @param {UCF_Control} oControl the control instance
 */
UCF_DatePickerSlider["prototype"]["setConnectedControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setConnectedControl"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oControl) === "object", "typeof(oControl) === \"object\"", "DatePickerSlider.js(120): setConnectedControl"); };
	this["oConnectedControl"] = oControl;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setConnectedControl"] = 0; };

/**
 * Sets the selected date for the DatePickerSlider
 * If no start date is set the selected date is used to render the
 * initialy rendered month.
 *
 * @param {UCF_Date} oSelectedDate the selected date in the DatePickerSlider
 */
UCF_DatePickerSlider["prototype"]["setSelectedDate"] = function(oSelectedDate) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setSelectedDate"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oSelectedDate) === "object", "typeof(oSelectedDate) === \"object\"", "DatePickerSlider.js(132): setSelectedDate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSelectedDate instanceof UCF_Date, "oSelectedDate instanceof UCF_Date", "DatePickerSlider.js(133): setSelectedDate"); };
	// Same behaviour as SAPGui/Windows see Incident 88852 / 2017
	if (oSelectedDate && (oSelectedDate["iGetYear"]() > 8999 || oSelectedDate["iGetYear"]() < 10))
		this["oSelectedDate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
	else
		this["oSelectedDate"] = oSelectedDate;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setSelectedDate"] = 0; };

/**
 * returns the selected date for the DatePickerSlider
 *
 * @return {UCF_Date}
 */
UCF_DatePickerSlider["prototype"]["oGetSelectedDate"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oGetSelectedDate"]++; }; 
	return this["oSelectedDate"];
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oGetSelectedDate"] = 0; };

/**
 * sets the start date for the DatePickerSlider
 *
 * @param {UCF_Date} oStartDate the starting date of the DatePickerSlider
 */
UCF_DatePickerSlider["prototype"]["setStartDate"] = function(oStartDate) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setStartDate"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oStartDate) === "object", "typeof(oStartDate) === \"object\"", "DatePickerSlider.js(156): setStartDate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oStartDate instanceof UCF_Date, "oStartDate instanceof UCF_Date", "DatePickerSlider.js(157): setStartDate"); };

	if (oStartDate["iGetYear"]() > 8999 || oStartDate["iGetYear"]() < 10 || isNaN(oStartDate["iGetYear"]()))
		this["oStartDate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
	else
		this["oStartDate"] = oStartDate;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setStartDate"] = 0; };

/**
 * sets wheather calendar weeks are shown or not
 *
 * @param {boolean} bIncludeWeek sets the week
 */
UCF_DatePickerSlider["prototype"]["setIncludeWeek"] = function(bIncludeWeek) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setIncludeWeek"]++; }; 
	this["bIncludeWeek"] = bIncludeWeek;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setIncludeWeek"] = 0; };

/**
 * open the DatePickerSlider
 * @param {boolean} bCombineWithDatePicker sets the week
 */
UCF_DatePickerSlider["prototype"]["open"] = function(bCombineWithDatePicker) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["open"]++; }; 
	var iIndex;
	var iSliderIndex = 0;
	var sSliderId;
	var sWorkFormat = this["sDateFormat"];

	this["bOpen"] = true;
	this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);
	this["setOpenerRef"](this["oConnectedControl"]["oRootRef"]);
	this["aSliders"] = new Array();

	this["oStartDate"]["setFormatString"](this["sDateFormat"]);
	this["oDate"] = this["oStartDate"]["oGetClone"]();
	this["oDate"]["setFormatString"](this["sDateFormat"]);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sDelimiter"] = this["oDate"]["sGetFormattedDate"](null, 'text');
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iYearIndex"] = -1;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iMonthIndex"] = -1;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iDayIndex"] = -1;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iHours"] = -1;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["ihours"] = -1;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sAmPm"] = 'AM';
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bCombineWithDatePicker"] = true;

	if (bCombineWithDatePicker !== undefined)
		this["bCombineWithDatePicker"] = bCombineWithDatePicker;

	if (this["bCombineWithDatePicker"])
		this["iVisibleItems"] = 5;
	else
		this["iVisibleItems"] = 7;

	this["render"]();

	var bHasDateEntries = false;
	sWorkFormat = this["sDateFormat"]["replace"](/[^A-Za-z]/g, this["sDelimiter"]);
	var aEntries = sWorkFormat["split"](this["sDelimiter"]);
	for (iIndex = 0; iIndex < aEntries["length"]; iIndex++) {
		sSliderId = '';
		if ( /*aEntries[iIndex].indexOf("G") != -1 || */ aEntries[iIndex]["indexOf"]("y") !== -1) {
			bHasDateEntries = true;
			if (!this["bCombineWithDatePicker"]) {
				this["iYearIndex"] = iSliderIndex++;
				sSliderId = this["sId"] + '-slider-Year';
			}
		} else if (aEntries[iIndex]["indexOf"]("M") !== -1) {
			bHasDateEntries = true;
			if (!this["bCombineWithDatePicker"]) {
				this["iMonthIndex"] = iSliderIndex++;
				sSliderId = this["sId"] + '-slider-Month';
			}
		} else if (aEntries[iIndex]["indexOf"]("d") !== -1) {
			bHasDateEntries = true;
			if (!this["bCombineWithDatePicker"]) {
				this["iDayIndex"] = iSliderIndex++;
				sSliderId = this["sId"] + '-slider-Day';
			}
		} else if (aEntries[iIndex]["indexOf"]("A") !== -1) {
			if (this["oDate"]["iGetHours"]() > 0 && this["oDate"]["iGetHours"]() < 13)
				this["setAmPm"]('AM');
			else
				this["setAmPm"]('PM');
			// eslint-disable-next-line @ur/no-memory-leaks
			this["iAmPm"] = iSliderIndex++;
			sSliderId = this["sId"] + '-slider-AmPm';
		} else if (aEntries[iIndex]["indexOf"]("a") !== -1) {
			if (this["oDate"]["iGetHours"]() > 0 && this["oDate"]["iGetHours"]() < 13)
				this["setAmPm"]('am');
			else
				this["setAmPm"]('pm');
			this["iAmPm"] = iSliderIndex++;
			sSliderId = this["sId"] + '-slider-AmPm';
		} else if (aEntries[iIndex]["indexOf"]("H") !== -1) {
			if (iIndex !== 0 && !this["bCombineWithDatePicker"]) {
				iSliderIndex++;
				this["aSliders"]["push"](this["oCreateSlider"](this["sId"] + '-slider-separator'));
			}
			this["iHours"] = iSliderIndex++;
			sSliderId = this["sId"] + '-slider-Hours';
		} else if (aEntries[iIndex]["indexOf"]("h") !== -1) {
			if (iIndex !== 0 && !this["bCombineWithDatePicker"]) {
				iSliderIndex++;
				this["aSliders"]["push"](this["oCreateSlider"](this["sId"] + '-slider-separator'));
			}
			this["ihours"] = iSliderIndex++;
			sSliderId = this["sId"] + '-slider-hours';
		} else if (aEntries[iIndex]["indexOf"]("t") !== -1) {
			if (iIndex !== 0 && !this["bCombineWithDatePicker"]) {
				iSliderIndex++;
				this["aSliders"]["push"](this["oCreateSlider"](this["sId"] + '-slider-separator'));
			}
			this["ihours"] = iSliderIndex++;
			sSliderId = this["sId"] + '-slider-hours';
		} else if (aEntries[iIndex]["indexOf"]("m") !== -1) {
			// eslint-disable-next-line @ur/no-memory-leaks
			this["iMinutes"] = iSliderIndex++;
			sSliderId = this["sId"] + '-slider-minutes';
		} else if (aEntries[iIndex]["indexOf"]("s") !== -1) {
			// eslint-disable-next-line @ur/no-memory-leaks
			this["iSeconds"] = iSliderIndex++;
			sSliderId = this["sId"] + '-slider-seconds';
		}
		if (sSliderId !== '')
			this["aSliders"]["push"](this["oCreateSlider"](sSliderId, aEntries[iIndex], this["oDate"]));
	}
	if (this["bCombineWithDatePicker"] && !bHasDateEntries)
		this["bCombineWithDatePicker"] = false;
	if (this["bCombineWithDatePicker"]) {
		this["oDatePicker"] = this["oLS"]["oControlFactory"]["oGetControl"](
			'UCF_DatePicker',
			this["sId"] + '-dp'
		);
		this["oDatePicker"]["setSelectedDate"](this["oStartDate"]);
		this["oDatePicker"]["oStartDate"] = this["oDate"]["oGetClone"]();
		this["oDatePicker"]["oStartDate"]["setDate"](1);
		this["oDatePicker"]["setConnectedControl"](this);

		this["oDatePicker"]["open"]( /* this.sId + '-dp-container' */ );
		this["oDatePicker"]["attachEvent"](
			this["oDatePicker"]["E_EVENTS"]["Select"],
			this,
			'onDatepickerSelect'
		);
	}
	for (var i = 0; i < this["aSliders"]["length"]; i++)
		this["aSliders"][i]["render"]();

	this["openBase"]();

	if (!this["bCombineWithDatePicker"]) {
		if ([this["iDayIndex"]] && this["aSliders"][this["iDayIndex"]])
			this["aSliders"][this["iDayIndex"]]["focus"]();
		else
			this["aSliders"][0]["focus"]();
	}

	for (i = 0; i < this["aSliders"]["length"]; i++) {
		this["aSliders"][i]["initAfterRendering"]();
		this["aSliders"][i]["attachEvent"](
			this["aSliders"][i]["E_EVENTS"]["Change"],
			this,
			'onSliderChange'
		);
		this["aSliders"][i]["attachEvent"](
			this["aSliders"][i]["E_EVENTS"]["Drag"],
			this,
			'onSliderDrag'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["open"] = 0; };

UCF_DatePickerSlider["prototype"]["setAmPm"] = function(sAmPm) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setAmPm"]++; }; 
	this["sAmPm"] = sAmPm;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setAmPm"] = 0; };

UCF_DatePickerSlider["prototype"]["sGetAmPm"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["sGetAmPm"]++; }; 
	return (this["sAmPm"]);
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["sGetAmPm"] = 0; };

/**
 * close the DatePickerSlider
 */
UCF_DatePickerSlider["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["close"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oWindow;

	if (this["bOpen"] && !this["bIsDestroyed"]) {
		// detach listening on any events
		oWindow = this["oLS"]["oBrowserWindow"];
		oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');

		if (this["oDomRef"]) {
			UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
		}

		// close date picker slider
		this["bOpen"] = false;
		this["closeBase"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["close"] = 0; };

UCF_DatePickerSlider["prototype"]["onmousemove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onmousemove"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DatePickerSlider.js(367): onmousemove"); };
	var oSlider = this["oGetSliderByElement"](oBrowserEvent["oSource"]);
	if (oSlider)
		oSlider["onmousemove"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onmousemove"] = 0; };

UCF_DatePickerSlider["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DatePickerSlider.js(375): onmousedown"); };
	var oSlider = this["oGetSliderByElement"](oBrowserEvent["oSource"]);
	if (oSlider)
		oSlider["onmousedown"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onmousedown"] = 0; };

UCF_DatePickerSlider["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onmouseup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DatePickerSlider.js(383): onmouseup"); };
	var oSlider = this["oGetSliderByElement"](oBrowserEvent["oSource"]);
	if (oSlider)
		oSlider["onmouseup"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onmouseup"] = 0; };

/**
 * sets the DatePickerSliders enabled state
 *
 * @param {boolean} bEnabled
 */
UCF_DatePickerSlider["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setEnabled"]++; }; 
	this["bEnabled"] = bEnabled;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setEnabled"] = 0; };

UCF_DatePickerSlider["iMoveThreshold"] = 20;

UCF_DatePickerSlider["prototype"]["oTouchDist"] = function(oTouches) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oTouchDist"]++; }; 
	var iX = 0,
		iY = 0;
	if (oTouches["length"] === 0)
		return ({ 'iX': 0, 'iY': 0 });
	for (var i = 0; i < oTouches["length"]; i++) {
		iX += oTouches[i]["clientX"];
		iY += oTouches[i]["clientY"];
	}
	return ({ 'iX': iX / i, 'iY': iY / i });
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oTouchDist"] = 0; };

UCF_DatePickerSlider["prototype"]["oGetSliderByElement"] = function(oElement) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oGetSliderByElement"]++; }; 
	var oSlider = oElement;
	while (oSlider && oSlider["id"]["indexOf"](this["sId"] + '-slider-') !== 0)
		oSlider = oSlider["parentElement"];
	if (!oSlider)
		return null;
	return this["oGetSliderControl"](oSlider["id"]);
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oGetSliderByElement"] = 0; };

UCF_DatePickerSlider["prototype"]["oGetSliderControl"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oGetSliderControl"]++; }; 
	for (var i = 0; i < this["aSliders"]["length"]; i++)
		if (sId["indexOf"](this["aSliders"][i]["sId"]) === 0)
			return this["aSliders"][i];
	return null;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oGetSliderControl"] = 0; };

UCF_DatePickerSlider["prototype"]["iGetSliderIndex"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["iGetSliderIndex"]++; }; 
	for (var i = 0; i < this["aSliders"]["length"]; i++)
		if (sId["indexOf"](this["aSliders"][i]["sId"]) === 0)
			return i;
	return -1;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["iGetSliderIndex"] = 0; };

/**
 * Handles the keydown event on the DatePickerSlider
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_DatePickerSlider["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onkeydown"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DatePickerSlider.js(444): onkeydown"); };

	var iKeyCode = oBrowserEvent["iKeyCode"]();
	var bAlt = oBrowserEvent["bAlt"]();

	if (iKeyCode === UCF_KeyCodes["ESCAPE"] ||
		iKeyCode === UCF_KeyCodes["F4"] ||
		(iKeyCode === UCF_KeyCodes["ARROW_UP"] && bAlt)) {
		this["oConnectedControl"]["oNavigation"]["keepEditMode"]();
		this["oConnectedControl"]["focus"]();
		this["cancel"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (iKeyCode === UCF_KeyCodes["ENTER"]) {
		this["okPressed"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (iKeyCode === UCF_KeyCodes["ARROW_LEFT"] || iKeyCode === UCF_KeyCodes["ARROW_RIGHT"]) {
		if (this["bHandleKeyLeftRight"](oBrowserEvent)) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onkeydown"] = 0; };

/**
 * Handles left/right key strokes
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @return {boolean} handled
 * @private
 */
UCF_DatePickerSlider["prototype"]["bHandleKeyLeftRight"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["bHandleKeyLeftRight"]++; }; 
	var bUp = (oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["ARROW_RIGHT"]);
	var iSource = this["iGetSliderIndexById"](oBrowserEvent["oSourceControl"]["sId"]);
	if (iSource === -1)
		return false;
	if (window["UCF_System"]["bIsRTL"]) {
		bUp = !bUp;
	}
	if (bUp)
		iSource++;
	else
		iSource--;
	if (iSource === -1 || iSource >= this["aSliders"]["length"])
		return false;
	this["setExpanded"](this["aSliders"][iSource]);
	return true;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["bHandleKeyLeftRight"] = 0; };

/**
 * Renders the DatePickerSliders HTML
 */
UCF_DatePickerSlider["prototype"]["render"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["render"]++; };  // eslint-disable-line complexity
	var mDatePickerSlider = new Array(),
		oRealStartDate = this["oStartDate"]["oGetStartOfWeekDate"]();
	var bContainsTime = UCF_Date["bFormatContainsTime"](this["sGetFormatString"]());
	var oDate = this["oStartDate"]["oGetClone"]();
	oDate["setDate"](1);
	oDate["setFormatString"](this["sDateFormat"]);

	if (this["oSelectedDate"] === this["oStartDate"])
		this["oSelectedDate"] = this["oStartDate"]["oGetClone"]();

	if (oRealStartDate["bIsSameDay"](this["oStartDate"])) {
		oRealStartDate["addDays"](-7);
	}

	mDatePickerSlider["push"]('<div id="' + this["sId"] + '-cont" class="lsDatePickerSliderDropDown"');
	if (window["UCF_System"]["sAccessibility"] === "ARIA")
		mDatePickerSlider["push"]('aria-describedby="ARIA_DP_TUT"');
	mDatePickerSlider["push"]('>');
	if (this["bCombineWithDatePicker"]) {
		mDatePickerSlider["push"]('<div class="lsDatePickerSliderDropDownCnt">');
		mDatePickerSlider["push"]('<div id="' + this["sId"] + '-dp-container" class="lsDatePickerSliderDbContainer" > ');
		mDatePickerSlider["push"]('</div>');
		if (bContainsTime)
			mDatePickerSlider["push"]('<div class="lsPickerSliderSep" ></div>');
	}
	if (this["bCombineWithDatePicker"] === false) {
		mDatePickerSlider["push"]('<div id="' + this["sId"] + '-Sliders" class="lsDatePickerSliderContainer" aria-label="Uhrzeitauswahl"  >');
		mDatePickerSlider["push"]('</div>');
	} else if (bContainsTime) {
		mDatePickerSlider["push"]('<div id="' + this["sId"] + '-Sliders" class="lsDatePickerSliderContainerSmall" aria-label="Uhrzeitauswahl"  >');
		mDatePickerSlider["push"]('</div>');
	}

	mDatePickerSlider["push"]('</div>');
	mDatePickerSlider["push"]('<footer div id="' + this["sId"] + 'footer" class="lsDatePickerSliderContainerFooter">');
	mDatePickerSlider["push"]('</footer>');

	mDatePickerSlider["push"]('</div>');

	// eslint-disable-next-line no-unsanitized/property
	this["oDomRef"]["innerHTML"] = mDatePickerSlider["join"]('');
	document["getElementById"](this["sId"] + '-cont')["style"]["minWidth"] = this["oConnectedControl"]["oDomRef"]["offsetWidth"] + 'px';

	this["oLS"]["oCreateClientControl"]({
		"Toolbar": {
			"Design": 'FOOTER',
			"Id": this["sId"] + '-toolbar',
			"RightItems": [
				{
					"ToolbarButton": {
						"Id": this["sId"] + '-toolbar-ok',
						"Text": this["oLS"]["sGetText"]('SAPUR_CALC_OK'),
						"Design": 'EMPHASIZED'
					}
				},
				{
					"ToolbarButton": {
						"Id": this["sId"] + '-toolbar-cancel',
						"Text": this["oLS"]["sGetText"]('SAPUR_CALC_CANCEL')
					}
				}
			]
		}
	})["placeAt"](this["sId"] + 'footer');
	var that = this;
	this["oLS"]["oGetClientControlById"](this["sId"] + '-toolbar-cancel')["attachPress"](function() {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'cancel!', "DatePickerSlider.js(563): render"); };
		that["cancel"]();
	});
	this["oLS"]["oGetClientControlById"](this["sId"] + '-toolbar-ok')["attachPress"](function() {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'OK! -> ' + that["oDate"]["toString"](), "DatePickerSlider.js(567): render"); };
		that["okPressed"]();
	});

	var oWindow = this["oLS"]["oBrowserWindow"];
	oWindow["attachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["render"] = 0; };

UCF_DatePickerSlider["prototype"]["cancel"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["cancel"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Close"], {});
	for (var i = 0; i < this["aSliders"]["length"]; i++)
		this["oLS"]["oControlFactory"]["purgeControl"](this["aSliders"][i]);
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["cancel"] = 0; };

UCF_DatePickerSlider["prototype"]["okPressed"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["okPressed"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Select"], { "date": this["oDate"] });
	for (var i = 0; i < this["aSliders"]["length"]; i++)
		this["oLS"]["oControlFactory"]["purgeControl"](this["aSliders"][i]);
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["okPressed"] = 0; };

/**
 * get the day value
 * @param {HTMLElement} oSource
 * @return {int}
 */
UCF_DatePickerSlider["prototype"]["iGetDayFromSource"] = function(oSource) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["iGetDayFromSource"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oSource) === "object", "typeof(oSource) === \"object\"", "DatePickerSlider.js(593): iGetDayFromSource"); };

	var iDay = 0;
	var sDay = UCF_DomUtil["sGetInnerText"](oSource);
	if (sDay) iDay = parseInt(sDay) - 1;
	if (isNaN(iDay)) iDay = this["iCurrentDay"];
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iCurrentDay"] = iDay;
	return iDay;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["iGetDayFromSource"] = 0; };

/**
 * Expand the slider
 * @param {UCF_PickerSlider} oExpanded
 */
UCF_DatePickerSlider["prototype"]["setExpanded"] = function(oExpanded) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setExpanded"]++; }; 
	for (var i = 0; i < this["aSliders"]["length"]; i++)
		if (this["aSliders"][i] !== oExpanded) this["aSliders"][i]["setExpanded"](false);
	oExpanded["setExpanded"](true);
	oExpanded["focus"]();
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["setExpanded"] = 0; };

/**
 * Insert 5 years before
 * @param {string} sId
 * @param {string} sValue
 */
UCF_DatePickerSlider["prototype"]["insertBefore"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["insertBefore"]++; }; 
	var aYears = [];
	var oSlider = this["oGetSliderControl"](sId);
	var oWorkDate = this["oDate"]["oGetClone"]();
	oWorkDate["setFormatString"](this["sDateFormat"]);
	oWorkDate["setYear"](parseInt(sValue));
	for (var i = 0; i < 5; i++) {
		oWorkDate["setYear"](oWorkDate["iGetYear"]() - 1);
		aYears["push"]({ "value": this["sGetYearString"](oWorkDate), "key": oWorkDate["iGetYear"]() });
	}
	aYears = aYears["reverse"]();
	oSlider["insertBefore"](aYears);
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["insertBefore"] = 0; };
/**
 * Append 5 years after
 * @param {string} sId
 * @param {string} sValue
 */
UCF_DatePickerSlider["prototype"]["appendAfter"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["appendAfter"]++; }; 
	var aYears = [];
	var oSlider = this["oGetSliderControl"](sId);
	var oWorkDate = this["oDate"]["oGetClone"]();
	oWorkDate["setFormatString"](this["sDateFormat"]);
	oWorkDate["setYear"](parseInt(sValue));
	for (var i = 0; i < 5; i++) {
		oWorkDate["setYear"](oWorkDate["iGetYear"]() + 1);
		aYears["push"]({ "value": this["sGetYearString"](oWorkDate), "key": oWorkDate["iGetYear"]() });
	}
	oSlider["appendAfter"](aYears);
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["appendAfter"] = 0; };

UCF_DatePickerSlider["prototype"]["onSliderDrag"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onSliderDrag"]++; }; 
	try {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["bDragging"] = JSON["parse"](oEvent["mParameters"]["bValue"]);
	} catch (e) {}
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onSliderDrag"] = 0; };

UCF_DatePickerSlider["prototype"]["onDatepickerSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onDatepickerSelect"]++; }; 
	console["log"]('Datepicker fired: ' + oEvent["mParameters"]["date"]["sGetFormattedDate"]());
	this["oDate"]["setMonth"](oEvent["mParameters"]["date"]["iGetMonth"]());
	this["oDate"]["setYear"](oEvent["mParameters"]["date"]["iGetYear"]());
	this["oDate"]["setDate"](oEvent["mParameters"]["date"]["iGetDate"]());
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onDatepickerSelect"] = 0; };

UCF_DatePickerSlider["prototype"]["onSliderChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onSliderChange"]++; }; 
	var aListItems;
	var iHours;
	var oOptions = {};
	try {
		oOptions = JSON["parse"](oEvent["mParameters"]["sOptions"]);
	} catch (e) {}
	if (oOptions["InsertBefore"])
		this["insertBefore"](oEvent["mParameters"]["sId"], oOptions["InsertBefore"]);
	else if (oOptions["AppendAfter"])
		this["appendAfter"](oEvent["mParameters"]["sId"], oOptions["AppendAfter"]);
	if (oEvent["mParameters"]["sId"]["indexOf"]('Year') !== -1)
		this["oDate"]["setYear"](parseInt(oEvent["mParameters"]["sKey"]));
	else if (oEvent["mParameters"]["sId"]["indexOf"]('Month') !== -1)
		this["oDate"]["setMonth"](parseInt(oEvent["mParameters"]["sKey"]));
	else if (oEvent["mParameters"]["sId"]["indexOf"]('Day') !== -1)
		this["oDate"]["setDate"](parseInt(oEvent["mParameters"]["sKey"]));
	else if (oEvent["mParameters"]["sId"]["indexOf"]('minutes') !== -1)
		this["oDate"]["setMinutes"](parseInt(oEvent["mParameters"]["sKey"]));
	else if (oEvent["mParameters"]["sId"]["indexOf"]('seconds') !== -1)
		this["oDate"]["setSeconds"](parseInt(oEvent["mParameters"]["sKey"]));
	else if (oEvent["mParameters"]["sId"]["indexOf"]('Hours') !== -1)
		this["oDate"]["setHours"](parseInt(oEvent["mParameters"]["sKey"]));
	else if (oEvent["mParameters"]["sId"]["indexOf"]('hours') !== -1) {
		if (this["sGetAmPm"]()[0]["toUpperCase"]() === "A") this["oDate"]["setHours"](parseInt(oEvent["mParameters"]["sKey"]));
		else {
			iHours = parseInt(oEvent["mParameters"]["sKey"]);
			if (iHours < 12)
				iHours += 12;
			if (iHours === 12)
				iHours = 0;
			this["oDate"]["setHours"](iHours);
		}
	} else if (oEvent["mParameters"]["sId"]["indexOf"]('hours0') !== -1) {
		if (this["sGetAmPm"]()[0]["toUpperCase"]() === "A") this["oDate"]["setHours"](parseInt(oEvent["mParameters"]["sKey"]));
		else {
			iHours = parseInt(oEvent["mParameters"]["sKey"]);
			if (iHours < 12)
				iHours += 12;
			if (iHours === 12)
				iHours = 0;
			this["oDate"]["setHours"](iHours);
		}
	} else if (oEvent["mParameters"]["sId"]["indexOf"]('AmPm') !== -1) {
		this["setAmPm"](oEvent["mParameters"]["sKey"]);
		iHours = this["oDate"]["iGetHours"]();
		if (this["sGetAmPm"]() === 'AM') {
			if (iHours > 12) this["oDate"]["setHours"](iHours - 12);
			if (iHours === 0) this["oDate"]["setHours"](12);
		} else {
			if (iHours < 13) this["oDate"]["setHours"](iHours + 12);
		}
	}
	//	this.oDate.parse(sValue, this.sDateFormat);
	if (oEvent["mParameters"]["sId"]["indexOf"]('Year') !== -1) {
		aListItems = this["aGetDayEntries"](this["sDateFormat"], this["oDate"]);
		this["oGetSliderControl"](this["sId"] + '-slider-Day')["setListItems"](aListItems);
		aListItems = this["aGetMonthEntries"](this["sDateFormat"], this["oDate"]);
		this["oGetSliderControl"](this["sId"] + '-slider-Month')["setListItems"](aListItems);
	} else if (oEvent["mParameters"]["sId"]["indexOf"]('Month') !== -1) {
		aListItems = this["aGetDayEntries"](this["sDateFormat"], this["oDate"]);
		this["oGetSliderControl"](this["sId"] + '-slider-Day')["setSelectedItem"](this["oDate"]["iGetDate"]() - 1);
		this["oGetSliderControl"](this["sId"] + '-slider-Day')["setListItems"](aListItems);
	}
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onSliderChange"] = 0; };

/**
 * @param {string} sSliderId
 * @param {string} sFormatPart
 * @param {UCF_Date} oDate
 * @return { UCF_PickerSlider }
 */
UCF_DatePickerSlider["prototype"]["oCreateSlider"] = function(sSliderId, sFormatPart, oDate) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oCreateSlider"]++; }; 
	//	var oSlider = new UCF_PickerSlider(null, this.oLS, sSliderId);
	var oSlider = this["oLS"]["oControlFactory"]["oGetControl"](
		'UCF_PickerSlider',
		sSliderId
	);
	if (sFormatPart)
		oSlider["setProperties"](this["oGetDateEntries"](sFormatPart, oDate));
	else
		oSlider["setProperties"]({
			"sParentId": this["sId"] + "-Sliders"
		});
	return oSlider;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oCreateSlider"] = 0; };

/**
 * @param {string} sFormatPart
 * @param {UCF_Date} oDate
 * @return {Array}
 */
UCF_DatePickerSlider["prototype"]["oGetDateEntries"] = function(sFormatPart, oDate) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oGetDateEntries"]++; }; 
	switch (sFormatPart[0]) {
		case 'd':
		case 'E':
			return ({
				"bCyclic": true,
				"iVisibleItems": this["iVisibleItems"],
				"iSelectedItem": oDate["iGetDate"]() - 1,
				"bComplete": true,
				"oParent": this,
				"sTitle": this["oLS"]["sGetText"]('SAPUR_DAY'),
				"aListItems": this["aGetDayEntries"](this["sDateFormat"], oDate),
				"sParentId": this["sId"] + "-Sliders"
			});
		case 'M':
			return ({
				"bCyclic": true,
				"iVisibleItems": this["iVisibleItems"],
				"iSelectedItem": oDate["iGetMonth"](),
				"bComplete": true,
				"oParent": this,
				"sTitle": this["oLS"]["sGetText"]('SAPUR_CAL_MONTHHEADER'),
				"aListItems": this["aGetMonthEntries"](this["sDateFormat"], oDate),
				"sParentId": this["sId"] + "-Sliders"
			});
		case 'y':
		case 'G':
			return ({
				"bCyclic": false,
				"iVisibleItems": this["iVisibleItems"],
				"iSelectedItem": 10,
				"bComplete": false,
				"oParent": this,
				"sTitle": this["oLS"]["sGetText"]('SAPUR_YEAR'),
				"aListItems": this["aGetYearEntries"](this["sDateFormat"], oDate),
				"sParentId": this["sId"] + "-Sliders"
			});
		case 'a':
			return ({
				"bCyclic": false,
				"iVisibleItems": this["iVisibleItems"],
				"iSelectedItem": this["sGetAmPm"]()[0] === 'a' ? 0 : 1,
				"bComplete": true,
				"oParent": this,
				"sTitle": '',
				"sLabel": 'am/pm',
				"aListItems": [{ "value": 'am', "key": 'AM' }, { "value": 'pm', "key": 'PM' }],
				"sParentId": this["sId"] + "-Sliders"
			});
		case 'A':
			return ({
				"bCyclic": false,
				"iVisibleItems": this["iVisibleItems"],
				"iSelectedItem": this["sGetAmPm"]()[0] === 'A' ? 0 : 1,
				"bComplete": true,
				"oParent": this,
				"sTitle": '',
				"sLabel": 'am/pm',
				"aListItems": [{ "value": 'AM', "key": 'AM' }, { "value": 'PM', "key": 'PM' }],
				"sParentId": this["sId"] + "-Sliders"
			});
		case 'h':
			return ({
				"bCyclic": true,
				"iVisibleItems": this["iVisibleItems"],
				"iSelectedItem": oDate["iGetHours"]() === 0 ? 11 : oDate["iGetHours"]() - 1,
				"bComplete": true,
				"oParent": this,
				"sTitle": this["oLS"]["sGetText"]('SAPUR_HOURS_ABBREV'),
				"sLabel": this["oLS"]["sGetText"]('SAPUR_HOURS'),
				"aListItems": [{ "value": '01', "key": 1 },
					{ "value": '02', "key": 2 },
					{ "value": '03', "key": 3 },
					{ "value": '04', "key": 4 },
					{ "value": '05', "key": 5 },
					{ "value": '06', "key": 6 },
					{ "value": '07', "key": 7 },
					{ "value": '08', "key": 8 },
					{ "value": '09', "key": 9 },
					{ "value": '10', "key": 10 },
					{ "value": '11', "key": 11 },
					{ "value": '12', "key": 12 }
				],
				"sParentId": this["sId"] + "-Sliders"
			});
		case 't':
			return ({
				"bCyclic": true,
				"iVisibleItems": this["iVisibleItems"],
				"iSelectedItem": oDate["iGetHours"]() === 0 ? 11 : oDate["iGetHours"]() - 1,
				"bComplete": true,
				"oParent": this,
				"sTitle": this["oLS"]["sGetText"]('SAPUR_HOURS_ABBREV'),
				"sLabel": this["oLS"]["sGetText"]('SAPUR_HOURS'),
				"aListItems": [{ "value": '01', "key": 1 },
					{ "value": '02', "key": 2 },
					{ "value": '03', "key": 3 },
					{ "value": '04', "key": 4 },
					{ "value": '05', "key": 5 },
					{ "value": '06', "key": 6 },
					{ "value": '07', "key": 7 },
					{ "value": '08', "key": 8 },
					{ "value": '09', "key": 9 },
					{ "value": '10', "key": 10 },
					{ "value": '11', "key": 11 },
					{ "value": '00', "key": 0 }
				],
				"sParentId": this["sId"] + "-Sliders"
			});
		case 'H':
			return ({
				"bCyclic": true,
				"iVisibleItems": this["iVisibleItems"],
				"iSelectedItem": oDate["iGetHours"](),
				"bComplete": true,
				"oParent": this,
				"sTitle": this["oLS"]["sGetText"]('SAPUR_HOURS_ABBREV'),
				"sLabel": this["oLS"]["sGetText"]('SAPUR_HOURS'),
				"aListItems": [
					{ "value": '00', "key": 0 },
					{ "value": '01', "key": 1 },
					{ "value": '02', "key": 2 },
					{ "value": '03', "key": 3 },
					{ "value": '04', "key": 4 },
					{ "value": '05', "key": 5 },
					{ "value": '06', "key": 6 },
					{ "value": '07', "key": 7 },
					{ "value": '08', "key": 8 },
					{ "value": '09', "key": 9 },
					{ "value": '10', "key": 10 },
					{ "value": '11', "key": 11 },
					{ "value": '12', "key": 12 },
					{ "value": '13', "key": 13 },
					{ "value": '14', "key": 14 },
					{ "value": '15', "key": 15 },
					{ "value": '16', "key": 16 },
					{ "value": '17', "key": 17 },
					{ "value": '18', "key": 18 },
					{ "value": '19', "key": 19 },
					{ "value": '20', "key": 20 },
					{ "value": '21', "key": 21 },
					{ "value": '22', "key": 22 },
					{ "value": '23', "key": 23 }
				],
				"sParentId": this["sId"] + "-Sliders"
			});
		case 'm':
			return ({
				"bCyclic": true,
				"iVisibleItems": this["iVisibleItems"],
				"iSelectedItem": oDate["iGetMinutes"](),
				"bComplete": true,
				"oParent": this,
				"sTitle": this["oLS"]["sGetText"]('SAPUR_MINUTES_ABBREV'),
				"sLabel": this["oLS"]["sGetText"]('SAPUR_MINUTES'),
				"aListItems": this["aGetMinuteEntries"](),
				"sParentId": this["sId"] + "-Sliders"
			});
		case 's':
			return ({
				"bCyclic": true,
				"iVisibleItems": this["iVisibleItems"],
				"iSelectedItem": oDate["iGetSeconds"](),
				"bComplete": true,
				"oParent": this,
				"sTitle": this["oLS"]["sGetText"]('SAPUR_SECONDS_ABBREV'),
				"sLabel": this["oLS"]["sGetText"]('SAPUR_SECONDS'),
				"aListItems": this["aGetMinuteEntries"](),
				"sParentId": this["sId"] + "-Sliders"
			});
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["oGetDateEntries"] = 0; };

/**
 * @return {Array}
 */
UCF_DatePickerSlider["prototype"]["aGetMinuteEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["aGetMinuteEntries"]++; }; 
	var aMinutes = new Array(),
		sTmp = '';
	for (var i = 0; i < 60; i++) {
		if (i < 10)
			sTmp = '0' + i;
		else
			sTmp = String(i);
		aMinutes["push"]({ "value": UCF_StringUtil["fillChars"](sTmp, '0', 2, true), "key": i });
	}
	return aMinutes;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["aGetMinuteEntries"] = 0; };

/**
 * @param {string} sFormat
 * @param {UCF_Date} oDate
 * @return {Array}
 */
UCF_DatePickerSlider["prototype"]["aGetDayEntries"] = function(sFormat, oDate) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["aGetDayEntries"]++; }; 
	var oWorkDate = oDate["oGetClone"]();
	oWorkDate["setFormatString"](sFormat);
	var aItems = [];
	oWorkDate["setDate"](1);
	var iMonth = oWorkDate["iGetMonth"]();
	while (oWorkDate["iGetMonth"]() === iMonth) {
		if (sFormat["indexOf"]('E') !== -1)
			aItems["push"]({
				"value": oWorkDate["sGetFormattedDate"](null, 'dayname') + ' ' +
					oWorkDate["sGetFormattedDate"](null, 'day'),
				"key": oWorkDate["iGetDate"]()
			});
		else
			aItems["push"]({ "value": oWorkDate["sGetFormattedDate"](null, 'day'), "key": oWorkDate["iGetDate"]() });
		oWorkDate["addDays"](1);
	}
	return aItems;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["aGetDayEntries"] = 0; };

/**
 * @param {string} sFormat
 * @param {UCF_Date} oDate
 * @return {Array}
 */
UCF_DatePickerSlider["prototype"]["aGetMonthEntries"] = function(sFormat, oDate) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["aGetMonthEntries"]++; }; 
	var oWorkDate = oDate["oGetClone"]();
	oWorkDate["setFormatString"](sFormat);
	var aItems = [];
	oWorkDate["setMonth"](0);
	oWorkDate["setDate"](1);
	var iYear = oWorkDate["iGetYear"]();
	while (oWorkDate["iGetYear"]() === iYear) {
		aItems["push"]({ "value": oWorkDate["sGetFormattedDate"](null, 'month'), "key": oWorkDate["iGetMonth"]() });
		oWorkDate["addMonths"](1);
	}
	return aItems;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["aGetMonthEntries"] = 0; };

/**
 * @param {string} sFormat
 * @param {UCF_Date} oDate
 * @return {Array}
 */
UCF_DatePickerSlider["prototype"]["aGetYearEntries"] = function(sFormat, oDate) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["aGetYearEntries"]++; }; 
	var oWorkDate = oDate["oGetClone"]();
	oWorkDate["setFormatString"](sFormat);
	var aListItems = [];

	oWorkDate["setYear"](oWorkDate["iGetYear"]() - 10);
	for (var i = 0; i < 21; i++) {
		aListItems["push"]({ "value": this["sGetYearString"](oWorkDate), "key": oWorkDate["iGetYear"]() });
		oWorkDate["setYear"](oWorkDate["iGetYear"]() + 1);
	}
	return aListItems;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["aGetYearEntries"] = 0; };

/**
 * @param {UCF_Date} oDate
 * @return { string }
 */
// Date has a format string already
UCF_DatePickerSlider["prototype"]["sGetYearString"] = function(oDate) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["sGetYearString"]++; }; 
	var sYear = oDate["sGetFormattedDate"](null, 'year');
	var sEmp = oDate["sGetFormattedDate"](null, 'emperor');
	return sEmp + sYear;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["sGetYearString"] = 0; };

/**
 * @param {UCF_Event} oEvent
 */
UCF_DatePickerSlider["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onAnyEvent"]++; }; 
	var oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');
	var oSource = oBrowserEvent["oGetSource"]();
	var oSourceRoot = oBrowserEvent["oGetSourceRoot"]();

	// close date picker slider if you click somewhere outside
	if ((oBrowserEvent["sGetName"]() === 'click' || oBrowserEvent["sGetName"]() === 'touchstart') &&
		oSourceRoot !== this["oDomRef"] &&
		oSourceRoot !== this["oConnectedControl"]["oDomRef"] &&
		oSourceRoot["getAttribute"]('ct') !== 'PickerSlider' &&
		(oSourceRoot["id"] && oSourceRoot["id"]["indexOf"]('ls-datepickerslider') !== 0) &&
		(oSource !== this["oConnectedControl"]["oGetHelpButtonRef"]() || this["oConnectedControl"]["bFieldHelpFloating"])
	) {
		this["cancel"]();
	} else if (oBrowserEvent["sGetName"]() === 'lsfocuslost' && !(UCF_UserAgent["bIsGecko"]() ||
			UCF_UserAgent["bIsWebKit"]() || window["UCF_System"]["sDevice"] === 'standards')) {
		this["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["onAnyEvent"] = 0; };

/**
 * iGetSliderIndexById
 *
 * @param {string}	sId
 * @return {integer}
 */
UCF_DatePickerSlider["prototype"]["iGetSliderIndexById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["iGetSliderIndexById"]++; }; 
	var iIndex;
	for (iIndex = 0; iIndex < this["aSliders"]["length"]; iIndex++)
		if (this["aSliders"][iIndex]["sId"] === sId)
			return iIndex;
	return -1;
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["iGetSliderIndexById"] = 0; };

/**
 * Detach Events and clear all delayed calls
 * @private
 */
UCF_DatePickerSlider["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["destroy"]++; }; 
	this["oLS"]["oBrowserWindow"]["detachEvent"](
		this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
	UCF_JsUtil["clearDelayedCall"](this["sDelayId"]);
	this["oDatePicker"] = null;
	this["oConnectedControl"] = null;
	this["aSliders"] = null;
	this["oDate"] = null;
	if (this["oSelectedDate"])
		this["oSelectedDate"]["destroy"]();
	this["oSelectedDate"] = null;
	if (this["oStartDate"])
		this["oStartDate"]["destroy"]();
	this["oStartDate"] = null;

	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DatePickerSlider["_"]["destroy"] = 0; };


};
sap["ls"]["preload"]["UCF_DebugWindow"] = function() {/* global UCF_Tracer, _trace, DEBUG, INFO, WARNING, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_domTreeInspector */
/// <reference path="./DOMTreeInspector.js"/>
/* global UCF_EventQueueDebugHelper */
/// <reference path="./EventQueueDebugHelper.js"/>

/**
 * Forwards to onPageUnLoad
 */
window["_debugUnload"] = function() {
	window["UCF_debugWindow"]["onPageUnload"]();
};

/**
 * Forwards to onDebugLoad
 */
window["_debugWinLoad"] = function() {
	window["UCF_debugWindow"]["onDebugLoad"]();
};

// ===== delegates to Event Queue =============================================

/**
 * delegates to Event Queue Dump
 * @return {string} the dump
 */
window["_debugEventQueue"] = function() {
	return window["UCF_debugWindow"]["onEventQueueDump"]();
};

/**
 * @param {boolean} bStat the state
 * @return {undefined}
 */
window["_debugEventQueueSetRecordingStatus"] = function(bStat) {
	return window["UCF_debugWindow"]["onEventQueueSetRecordingStatus"](bStat);
};

/**
 * @param {number} idx the snapshot index
 * @return {string} the snapshot
 */
window["_debugEventQueueGetSnapshotByIdx"] = function(idx) {
	return window["UCF_debugWindow"]["onGetSnapshotByIdx"](idx);
};

/**
 * @return {number} the number of snapshots
 */
window["_debugEventQueueGetSnapshotLength"] = function() {
	return window["UCF_debugWindow"]["onGetSnapshotLength"]();
};

/** */
window["_debugEventQueueClearSnapshots"] = function() {
	window["UCF_debugWindow"]["onClearSnapshots"]();
};

/**
 * @param {string} sSample the sample
 * @return {string} the snapshot
 */
window["_debugEventQueueConvertFromHttp"] = function(sSample) {
	return window["UCF_debugWindow"]["onConvertFromHttp"](sSample);
};

// ===== delegates to DOM View ================================================

/**
 * delegates to DOM View
 * @param {Object} oConfig the configuration
 * @return {string} the result
 */
window["_debugDomViewShow"] = function(oConfig) {
	return window["UCF_debugWindow"]["onDomViewShow"](oConfig);
};

/**
 * Subscribes to the Tracer for trace output, oLS for semantic events and oBrowserWindow for browser
 * events and taks care to output all this to either the trace-area in the Lightspeed Testsuite or
 * a separate trace window for standalone applications
 *
 * ---
 * **WARNING:** this subscribes for trace output. Therefore you may not use `_trace`/`_assert` inside
 * or it will lead to infinite loops.
 *
 * @class
 * 
 *
 * @depends UCF_Tracer
 * @depends UCF_DomUtil
 */
function UCF_DebugWindow() {if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["UCF_DebugWindow"]++; }; 
	if (window["UCF_debugWindow"]) {
		return window["UCF_debugWindow"];
	}
	UCF_Object["apply"]();

	/** @type {Window} */
	this["oWindow"] = null;
	/** @type {HTMLDocument} */
	this["oDocument"] = null;

	/** @type {Array.<{sClassName: string, iTimeStamp: number, sText: string, sLocation: string, sColor: string, sBgColor: string}>} */
	this["aCache"] = [];
	/** @type {boolean} */
	this["bReady"] = false;
	/** @type {boolean} */
	this["bOpened"] = false;

	/** @type {boolean} */
	this["bIsPopup"] = false;
	/** @type {number} */
	this["iPopupCount"] = 0;
	/** @type {number} */
	this["iPopupNum"] = 0;

	/** @type {UCF_EventHandler} */
	this["oEventHandler"] = null;
	/** @type {Array.<string>} */
	this["aEventQueueSnapshot"] = [];
	/** @type {Array.<{time: number, reason: string, title: string}>} */
	this["aEventQueueMetadata"] = [];
	/** @type {boolean} */
	this["bEventRecordingStatus"] = false;

	/** @type {Object} */
	this["mControlTypes"] = null;

	/** @type {string} */
	this["aOldTrace"] = null;

	// Attach to tracer immediately to get startup trace output
	UCF_Tracer["addListener"](this, 'onTrace');

	UCF_DomUtil["attachEvent"](window, 'unload', window["_debugUnload"]);

	/** @type {boolean} */
	this["bDocked"] = false;
};window["UCF_DebugWindow"] = UCF_DebugWindow; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DebugWindow"); UCF_DebugWindow["_"] = {UCF_DebugWindow: 0}; }; ;
UCF_DebugWindow["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_DebugWindow.prototype["sClassName"] = "UCF_DebugWindow";

/**
 * Determine, whether the running in the LS Testsuite or not
 * @return {boolean} `true` if running in testsuite (i.e. LSSampleDebug is a
 * top level frame), otherwise `false`
 */
UCF_DebugWindow["prototype"]["bInTestSuite"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["bInTestSuite"]++; }; 
	try {
		if (top["frames"]["LSSampleDebug"]) {
			return true;
		}
	} catch (ex) {
		// ignored
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["bInTestSuite"] = 0; };

/** @override */
UCF_DebugWindow["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["destroy"]++; }; 
	this["onPageUnload"]();
	UCF_DomUtil["detachEvent"](window, 'unload', window["_debugUnload"]);

	this["mControlTypes"] = null;

	if (this["oEventHandler"]) {
		this["oEventHandler"]["detachEvent"](
			this["oEventHandler"]["E_EVENTS"]["EventQueueDataComplete"],
			this
		);
	}
	this["oEventHandler"] = null;
	this["aEventQueueSnapshot"] = null;
	this["aEventQueueMetadata"] = null;

	this["oWindow"] = null;
	this["oDocument"] = null;
	this["iPopupNum"] = null;
	this["bEventRecordingStatus"] = null;
	this["aOldTrace"] = null;
	this["oDocked"] = null;
	this["oMainDebugWindow"] = null;
	this["oLS"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["destroy"] = 0; };

/** If application is unloaded also close the trace window */
UCF_DebugWindow["prototype"]["onPageUnload"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onPageUnload"]++; }; 
	if (this["bIsOpened"]) {
		if (this["bIsPopup"]) {
			this["oMainDebugWindow"]["iPopupCount"]--;
		} else {
			this["close"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onPageUnload"] = 0; };

/**
 * After the trace window is loaded, it can be initialized. Timeout is needed
 * because it can happen, that onload fires, before this.oWindow has been set
 */
UCF_DebugWindow["prototype"]["onDebugLoad"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onDebugLoad"]++; }; 
	// load may be fired, before this.oWindow is set
	UCF_JsUtil["delayedCall"](0, this, 'initialize');
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onDebugLoad"] = 0; };

/** @return {string} the url to use as the iframe src */
UCF_DebugWindow["prototype"]["sGetIframeJSSource"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["sGetIframeJSSource"]++; }; 
	return UCF_DomUtil["sGetIframeJSSource"]('<!DOCTYPE html>' +
		'<html class="height100">' +
		'<head>' +
		'<meta http-equiv="X-UA-Compatible" content="IE=EDGE">' +
		'<script nonce="' + window["UCF_System"]["sNonce"] + '">window.sBaseUrl="' + this["sGetResourcePath"]() + '";</script>' +
		'<link rel="stylesheet" type="text/css" href="' + this["sGetResourcePath"]() + '/debug.css">' +
		'<script src="' + this["sGetResourcePath"]() + '/debug.js"></script>' +
		'</head>' +
		'<body class="noDisplay"></body>' +
		'</html>'
	);
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["sGetIframeJSSource"] = 0; };

/**
 * Opens the trace window. If it is already available directly call initialize
 * @param {boolean} bDocked Determines whether the debug window should appear
 * docked or not
 * @param {string} [sWindowOptions] options for the debug window
 * (see window.open)
 */
UCF_DebugWindow["prototype"]["open"] = function(bDocked, sWindowOptions) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["open"]++; }; 
	/** @type {string} */
	var sUrl = this["sGetIframeJSSource"]();
	/** @type {string} */
	var sWindowId;
	/** @type {HTMLBodyElement} */
	var oBody;
	/** @type {HTMLIFrameElement} */
	var oIFrame;
	/** @type {HTMLDivElement} */
	var oPlaceHolder;

	// if application is running in testsuite, use the debug frame for output
	sWindowId = this["bInTestSuite"]()
		? 'LSSampleDebug'
		: 'debug' + UCF_JsUtil["sGetUID"]();

	if (bDocked) {
		this["bDocked"] = true;

		oBody = window["document"]["getElementsByTagName"]('body')[0];
		oIFrame = window["document"]["createElement"]('IFRAME');
		oPlaceHolder = window["document"]["createElement"]('DIV');

		oIFrame["setAttribute"]('id', '_debugwindow');
		oIFrame["name"] = sWindowId;
		oIFrame["style"]["width"] = '100%';
		oIFrame["style"]["height"] = '250px';
		oIFrame["style"]["bottom"] = '0px';
		oIFrame["style"]["left"] = '0px';
		oIFrame["style"]["position"] = 'fixed';
		oIFrame["style"]["border"] = '1px solid #c0c0c0';

		oPlaceHolder["style"]["height"] = '250px';
		UCF_DomUtil["setInnerHtml"](oPlaceHolder, '&nbsp;');
		oPlaceHolder["style"]["display"] = 'block';

		oIFrame["setAttribute"]('docked', 'true');
		oBody["appendChild"](oIFrame);
		oBody["appendChild"](oPlaceHolder);
		this["oDocked"] = {
			"frame": oIFrame,
			"placeholder": oPlaceHolder
		};
		oIFrame["src"] = sUrl;
		this["oWindow"] = oIFrame["contentWindow"];
	} else {
		this["oWindow"] = window["open"](
			sUrl,
			sWindowId,
			sWindowOptions ? sWindowOptions : 'width=640,height=480,resizable=yes'
		);
	}

	if (this["oWindow"]) {
		this["bOpened"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["open"] = 0; };

/** Closes the trace window */
UCF_DebugWindow["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["close"]++; }; 
	/** @type {HTMLElement} */
	var oOldTrace = this["oWindow"]["document"]["getElementById"]('trace_content');
	/** @type {HTMLBodyElement} */
	var oBody;

	if (oOldTrace) {
		this["aOldTrace"] = oOldTrace["childNodes"];
	}

	if (this["bDocked"]) {
		try {
			oBody = window["document"]["getElementsByTagName"]('body')[0];
			if (this["oDocked"]) {
				oBody["removeChild"](this["oDocked"]["frame"]);
				oBody["removeChild"](this["oDocked"]["placeholder"]);
			}
		} catch (e) {
			// ignored
		};
	}

	if (this["bInTestSuite"]()) {
		if (!this["bDocked"]) {
			this["oWindow"]["close"]();
		}
	} else {
		try {
			if (!this["bDocked"]) {
				this["oWindow"]["close"]();
			}
		} catch (e) {
			// ignored
		};
	}
	this["bReady"] = false;
	this["bOpened"] = false;
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["close"] = 0; };

/**
 * Trigger open/close of the trace window, called by DebugHelper
 * @protected
 */
UCF_DebugWindow["prototype"]["trigger"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["trigger"]++; }; 
	if (this["bOpened"]) {
		if (this["oWindow"]["closed"]) {
			this["open"]();
		} else {
			this["close"]();
		}
	} else {
		this["open"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["trigger"] = 0; };

/**
 * When the trace window is ready, it is initialized and all trace statements
 * occuring until know are shown
 */
UCF_DebugWindow["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["initialize"]++; }; 
	var self = this;
	try {
		this["oWindow"]["setAppWindow"](window);
		this["oWindow"]["clearPanel"]();
		this["oDocument"] = this["oWindow"]["document"];
		this["oWindow"]["oLS"] = this["oLS"];
		if (this["aOldTrace"]) {
			UCF_JsUtil["forEach"](this["aOldTrace"], function(child) {
				self["oWindow"]["document"]["getElementById"]('trace_content')["appendChild"](child);
			});
		}
		this["oWindow"]["document"]["title"] = document["title"] + ' - LS Trace';
		this["oWindow"]["initialize"]();
	} catch (e) {
		alert(e);
	};

	this["bReady"] = true;
	this["dumpCache"]();
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["initialize"] = 0; };

/**
 * Attach to LS and BrowserWindow
 * @param {UCF_LS} oLS the LightSpeed instance to attach to
 * @param {Window} oMainWindow the window to attach to
 */
UCF_DebugWindow["prototype"]["attachToLS"] = function(oLS, oMainWindow) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["attachToLS"]++; }; 
	/** @type {Window} */
	var oMainDebugWindow;

	if (oLS["oControlFactory"]) {
		this["mControlTypes"] = oLS["oControlFactory"]["M_TYPES"];
	}

	this["oLS"] = oLS;
	if (oLS["oEventHandler"]) {
		this["oEventHandler"] = oLS["oEventHandler"];
		this["oEventHandler"]["attachEvent"](
			this["oEventHandler"]["E_EVENTS"]["EventQueueDataComplete"],
			this,
			'onEventQueueDataComplete'
		);
	}

	oLS["attachEvent"](oLS["E_EVENTS"]["SemanticEvent"], this, 'onSemanticEvent');
	oLS["oBrowserWindow"]["attachEvent"](
		oLS["oBrowserWindow"]["E_EVENTS"]["AnyEvent"],
		this,
		'onBrowserEvent'
	);
	if (window === oMainWindow) {
		if (this["bInTestSuite"]()) {
			this["open"]();
		} else {
			oLS["addDebugHandler"](UCF_KeyCodes["T"], this, 'Show/hide trace window');
		}
	} else {
		this["bIsPopup"] = true;

		oMainDebugWindow = oMainWindow["UCF_debugWindow"];
		if (oMainDebugWindow["bReady"]) {
			this["oMainDebugWindow"] = oMainDebugWindow;
			UCF_Tracer["setTraceLevel"](oMainWindow["UCF_Tracer"]["iTraceLevel"]);
			this["iPopupNum"] = oMainDebugWindow["iPopupCount"]++;
			this["oWindow"] = oMainDebugWindow["oWindow"];
			this["oDocument"] = oMainDebugWindow["oDocument"];
			this["bOpened"] = true;
			this["bReady"] = true;
			this["dumpCache"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["attachToLS"] = 0; };

/**
 * Write trace output coming form the Tracer
 * @param {{sText: string, iTimeStamp: number, sLocation: string}} mParameters
 * the trace event parameters
 */
UCF_DebugWindow["prototype"]["onTrace"] = function(mParameters) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onTrace"]++; }; 
	/** @type {string} */
	var sText;
	/** @type {string} */
	var sEscapedText;
	/** @type {string} */
	var sColor = null;
	/** @type {string} */
	var sBgColor;

	switch (mParameters["iLevel"]) {
		case ERROR:
			sColor = 'red';
			break;
		case WARNING:
			sColor = 'brown';
			break;
		case INFO:
			sColor = 'black';
			break;
		case DEBUG:
			sColor = 'gray';
			break;
	}

	sText = '' + mParameters["sText"];
	sEscapedText = sText
		["replace"](/&/g, '&amp;')
		["replace"](/</g, '&lt;')
		["replace"](/\'/gi, '&quot;');

	// QUnit traces
	if (sText["indexOf"]('QUnit-trace:') > -1) {
		if (sText["indexOf"]('result=true') > -1) {
			sBgColor = '#80e080';
		} else if (sText["indexOf"]('result=false') > -1) {
			sBgColor = '#e08080';
		} else {
			sBgColor = '#e0e080';
		}
	}

	this["write"](
		'trace',
		mParameters["iTimeStamp"],
		sEscapedText,
		mParameters["sLocation"],
		sColor,
		sBgColor
	);
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onTrace"] = 0; };

/**
 * Write trace output for semantic events that occured
 * @param {UCF_Event} oEvent the semantic event
 */
UCF_DebugWindow["prototype"]["onSemanticEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onSemanticEvent"]++; }; 
	/** @type {UCF_SemanticEvent} */
	var oSemanticEvent = oEvent["oGetParam"]('oSemanticEvent');

	this["write"](
		'semantic',
		new Date()["getTime"](),
		'<strong>' + oSemanticEvent["sGetControl"]() + ':' + oSemanticEvent["sGetName"]() + '</strong>' + UCF_JsUtil["reduce"]([
			oSemanticEvent["mGetParameters"](),
			oSemanticEvent["mGetUcfParameters"](),
			oSemanticEvent["mGetCustomParameters"]()
		], function(sSerialized, oParameters) {
			return oParameters == null
				? sSerialized
				: sSerialized + ' ' + UCF_JsUtil["sJsonStringify"](oParameters)
				["replace"](/&/g, '&amp;')
				["replace"](/</g, '&lt;')
				["replace"](/>/g, '&gt;')
				["replace"](/\'/gi, '&quot;');
		}, ''),
		null,
		'blue'
	);
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onSemanticEvent"] = 0; };

/**
 * Write trace output for browser events that occured
 * @param {UCF_Event} oEvent the browser event
 */
UCF_DebugWindow["prototype"]["onBrowserEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onBrowserEvent"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');
	/** @type {HTMLElement} */
	var oSourceRoot = oBrowserEvent["oGetSourceRoot"]();
	/** @type {string} */
	var sSourceRootCt = oSourceRoot && oSourceRoot["getAttribute"]('ct');
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();

	this["write"](
		'browser',
		new Date()["getTime"](),
		'<strong>' + oBrowserEvent["sGetName"]() + '</strong> ' +
		(sSourceRootCt
			? 'ct: <span class="colorBlack">' + sSourceRootCt + '</span>, id: <span class="colorBlack">' + oSourceRoot["id"] + '</span>, '
			: '') +
		(oSource
			? '&lt;<span class="colorBlack">' + oSource["tagName"] + '</span>&gt;, '
			: '') +
		'X: <span class="colorBlack">' + oBrowserEvent["iClientX"]() + '</span>, ' +
		'Y: <span class="colorBlack">' + oBrowserEvent["iClientY"]() + '</span>',
		null,
		'green'
	);
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onBrowserEvent"] = 0; };

/**
 * Add an entry to the trace cache
 *
 * @param {string} sClassName the name of the class the trace entry originated at
 * @param {number} iTimeStamp the time stamp the entry occurred
 * @param {string} sText the text traced
 * @param {string} sLocation the location (in code) it occurred
 * @param {string} sColor the color the text should have
 * @param {string} sBgColor the background color the entry should have
 */
UCF_DebugWindow["prototype"]["addToCache"] = function(sClassName, iTimeStamp, sText, sLocation, sColor, sBgColor) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["addToCache"]++; }; 
	this["aCache"]["push"]({
		"sClassName": sClassName,
		"iTimeStamp": iTimeStamp,
		"sText": sText,
		"sLocation": sLocation,
		"sColor": sColor,
		"sBgColor": sBgColor
	});
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["addToCache"] = 0; };

/**
 * Write all entries in the cache to the debug window
 */
UCF_DebugWindow["prototype"]["dumpCache"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["dumpCache"]++; }; 
	/** @type {UCF_DebugWindow} */
	var self = this;

	UCF_JsUtil["forEach"](this["aCache"], function(oEntry) {
		self["write"](
			oEntry["sClassName"],
			oEntry["iTimeStamp"],
			oEntry["sText"],
			oEntry["sLocation"],
			oEntry["sColor"],
			oEntry["sBgColor"]
		);
	});

	this["aCache"] = [];
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["dumpCache"] = 0; };

/**
 * Write a trace line to the debug window. If not ready, add it to the cache
 * instead
 *
 * @param {string} sClassName the name of the class the trace entry originated
 * at
 * @param {number} iTimeStamp the time stamp the entry occurred
 * @param {string} sText the text traced
 * @param {string} sLocation the location (in code) it occurred
 * @param {string} sColor the color the text should have
 * @param {string} sBgColor the background color the entry should have
 */
UCF_DebugWindow["prototype"]["write"] = function(sClassName, iTimeStamp, sText, sLocation, sColor, sBgColor) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["write"]++; }; 
	/** @type {HTMLSpanElement} */
	var oSpan;

	if (!this["bReady"]) {
		this["addToCache"](sClassName, iTimeStamp, sText, sLocation, sColor, sBgColor);

		return;
	}

	// In case something goes wrong, don't show endless error messages
	try {
		oSpan = this["oDocument"]["createElement"]('span');
		oSpan["className"] = sClassName;
		if (sColor) {
			oSpan["style"]["color"] = sColor;
		}
		if (sBgColor) {
			oSpan["style"]["backgroundColor"] = sBgColor;
		}
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](oSpan, this["sGetTimeStamp"](iTimeStamp)
			+ (this["bIsPopup"] ? '<b>' + this["iPopupNum"] + '&gt;</b> ' : '')
			+ (sLocation ? sLocation + ' : ' : '')
			+ sText);
		oSpan["appendChild"](this["oDocument"]["createElement"]('br'));
		this["oWindow"]["addLine"](oSpan);
	} catch (e) {}
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["write"] = 0; };

/**
 * Get a timestamp in a human readable format
 *
 * @param {number} iTimeStamp the timestamp to format
 * @return {string} the timestamp formatted as `HH:mm:ss.SSS`
 */
UCF_DebugWindow["prototype"]["sGetTimeStamp"] = function(iTimeStamp) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["sGetTimeStamp"]++; }; 
	var oTime = new Date(iTimeStamp),
		sHours = '' + oTime["getHours"](),
		sMinutes = '' + oTime["getMinutes"](),
		sSeconds = '' + oTime["getSeconds"](),
		sMillis = '' + oTime["getMilliseconds"]();

	return UCF_StringUtil["fillChars"](sHours, '0', 2, true) + ':' // eslint-disable-line no-magic-numbers
		+ UCF_StringUtil["fillChars"](sMinutes, '0', 2, true) + ':' // eslint-disable-line no-magic-numbers
		+ UCF_StringUtil["fillChars"](sSeconds, '0', 2, true) + '.' // eslint-disable-line no-magic-numbers
		+ UCF_StringUtil["fillChars"](sMillis, '0', 3, true); // eslint-disable-line no-magic-numbers
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["sGetTimeStamp"] = 0; };

/**
 * Fills a text with &nbsp; for simple HTML formatting (monospace font)
 *
 * @param {string} sText the text
 * @param {number} iLength the length the text should have
 * @return {string} the text + nbsps
 */
UCF_DebugWindow["prototype"]["sFill"] = function(sText, iLength) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["sFill"]++; }; 
	/** @type {string} */
	var sFilledText = sText;
	/** @type {number} */
	var iMissing = iLength - sText["length"];
	/** @type {number} */
	var i;

	for (i = 0; i < iMissing; i++) {
		sFilledText += '&nbsp;';
	}

	return sFilledText;
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["sFill"] = 0; };

/**
 * @return {string} the resource path
 */
UCF_DebugWindow["prototype"]["sGetResourcePath"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["sGetResourcePath"]++; }; 
	/** @type {string} */
	var sResourcePath = UCF_ResourceUtil["sGetHtmlRoot"]() + '/debug';

	if (sResourcePath["indexOf"]('/') === 0) {
		sResourcePath = window["location"]["protocol"] + '//' + window["location"]["hostname"] + (window["location"]["port"] ? ':' + window["location"]["port"] : '') + sResourcePath;
	}

	return sResourcePath;
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["sGetResourcePath"] = 0; };

// ===== Event Queue Snaphot handling =========================================

/**
 * Activate/Deactivate recorder
 * @param {boolean} bState the state the recording status is set to
 */
UCF_DebugWindow["prototype"]["onEventQueueSetRecordingStatus"] = function(bState) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onEventQueueSetRecordingStatus"]++; }; 
	this["bEventRecordingStatus"] = !!bState;
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onEventQueueSetRecordingStatus"] = 0; };

/**
 * Dump current content of all event queues formatted for Trace Window
 * @return {string} the result
 */
UCF_DebugWindow["prototype"]["onEventQueueDump"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onEventQueueDump"]++; }; 
	/** @type {UCF_EventQueueDebugHelper} */
	var UCF_EventQueueDebugHelper = window["UCF_eventQueueDebugHelper"] || (
		UCF_ClassLoader["oGetClass"]('UCF_EventQueueDebugHelper') &&
		window["UCF_eventQueueDebugHelper"]
	);
	/** @type {string} */
	var sNewSnapshot;
	/** @type {number} */
	var iLen;
	/** @type {number} */
	var iNow;

	if (UCF_EventQueueDebugHelper && this["oEventHandler"]) {
		sNewSnapshot = UCF_EventQueueDebugHelper["sDumpQueues"](
			this["oEventHandler"],
			UCF_EventQueueDebugHelper["MODE_CURRENT"]
		);
		iLen = this["aEventQueueSnapshot"]["length"];
		iNow = (new Date())["getTime"]();

		if (this["bEventRecordingStatus"]) {
			this["aEventQueueMetadata"][iLen] = {
				"time": iNow,
				"reason": 'Manual',
				"title": 'Manual Record, ' + iNow
			};
			this["aEventQueueSnapshot"][iLen] = sNewSnapshot;
		}

		return sNewSnapshot;
	} else {
		return 'Not available';
	}
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onEventQueueDump"] = 0; };

/**
 * Store Event Queue Snapshots immediatly before each submit
 */
UCF_DebugWindow["prototype"]["onEventQueueDataComplete"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onEventQueueDataComplete"]++; }; 
	/** @type {UCF_EventQueueDebugHelper} */
	var UCF_EventQueueDebugHelper = window["UCF_eventQueueDebugHelper"] || (
		UCF_ClassLoader["oGetClass"]('UCF_EventQueueDebugHelper') &&
		window["UCF_eventQueueDebugHelper"]
	);
	/** @type {string} */
	var sNewSnapshot;
	/** @type {number} */
	var iLen;
	/** @type {number} */
	var iNow;

	if (
		this["bEventRecordingStatus"] &&
		UCF_EventQueueDebugHelper &&
		this["oEventHandler"]
	) {
		sNewSnapshot = UCF_EventQueueDebugHelper["sDumpQueues"](
			this["oEventHandler"],
			UCF_EventQueueDebugHelper["MODE_ONSUBMIT"]
		);
		iLen = this["aEventQueueSnapshot"]["length"];
		iNow = (new Date())["getTime"]();

		if (this["bEventRecordingStatus"]) {
			this["aEventQueueMetadata"][iLen] = {
				"time": iNow,
				"reason": 'Submit',
				"title": ('Submit Record, ' + iNow)
			};
			this["aEventQueueSnapshot"][iLen] = sNewSnapshot;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onEventQueueDataComplete"] = 0; };

/**
 * Get Event Queue Snapshot stored on given index
 * @param {number} idx the snapshot index
 * @return {string} the snapshot
 */
UCF_DebugWindow["prototype"]["onGetSnapshotByIdx"] = function(idx) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onGetSnapshotByIdx"]++; }; 
	if (0 <= idx && idx < this["aEventQueueSnapshot"]["length"]) {
		return this["aEventQueueSnapshot"][idx];
	}

	return '';
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onGetSnapshotByIdx"] = 0; };
/**
 * Get Snapshot Size
 * @return {number} the length of #aEventQueueSnapshot
 */
UCF_DebugWindow["prototype"]["onGetSnapshotLength"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onGetSnapshotLength"]++; }; 
	return this["aEventQueueSnapshot"]["length"];
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onGetSnapshotLength"] = 0; };

/**  */
UCF_DebugWindow["prototype"]["onClearSnapshots"] = function() {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onClearSnapshots"]++; }; 
	this["aEventQueueSnapshot"] = [];
	this["aMetadateSnapshot"] = [];
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onClearSnapshots"] = 0; };
/**
 * @param {string} sSample the sample
 * @return {string} the snapshot
 */
UCF_DebugWindow["prototype"]["onConvertFromHttp"] = function(sSample) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onConvertFromHttp"]++; }; 
	/** @type {UCF_EventQueueDebugHelper} */
	var UCF_EventQueueDebugHelper = window["UCF_eventQueueDebugHelper"] || (
		UCF_ClassLoader["oGetClass"]('UCF_EventQueueDebugHelper') &&
		window["UCF_eventQueueDebugHelper"]
	);
	/** @type {string} */
	var sNewSnapshot = UCF_EventQueueDebugHelper["sConvertFromHttp"](
		sSample,
		UCF_EventQueueDebugHelper["MODE_ONCONVERT"]
	);
	/** @type {number} */
	var iLen = this["aEventQueueSnapshot"]["length"];
	/** @type {number} */
	var iNow = (new Date())["getTime"]();

	if (this["bEventRecordingStatus"]) {
		this["aEventQueueMetadata"][iLen] = {
			"time": iNow,
			"reason": 'Convert',
			"title": ('Convert from HTTP Traffic')
		};
		this["aEventQueueSnapshot"][iLen] = sNewSnapshot;
	}

	return sNewSnapshot;
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onConvertFromHttp"] = 0; };

// ===== Dom View handling ====================================================

/**
 * @param {UCF_DOMTreeInspector_ViewConfig} oConfig
 * @return {string}
 */
UCF_DebugWindow["prototype"]["onDomViewShow"] = function(oConfig) {;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onDomViewShow"]++; }; 
	/** @type {UCF_DOMTreeInspector} */
	var UCF_DOMTreeInspector = window["UCF_domTreeInspector"] || (
		UCF_ClassLoader["oGetClass"]('UCF_DOMTreeInspector') &&
		window["UCF_domTreeInspector"]
	);

	return UCF_DOMTreeInspector["sGetView"](oConfig, this["mControlTypes"], this["oLS"]);
};;if (__UCF_COVERAGE__) { UCF_DebugWindow["_"]["onDomViewShow"] = 0; };


};
sap["ls"]["preload"]["UCF_Decorator"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Decorator(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Decorator["_"]["UCF_Decorator"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "Decorator.js(15): UCF_Decorator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Decorator.js(16): UCF_Decorator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Decorator.js(17): UCF_Decorator"); };
	if (arguments["length"] === 0) return;
	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_Decorator"] = UCF_Decorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Decorator"); UCF_Decorator["_"] = {UCF_Decorator: 0}; }; ;
UCF_Decorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Decorator.prototype["sClassName"] = "UCF_Decorator";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Decorator["prototype"]["aAttributeNames"] = [];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Decorator["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Decorator["prototype"]["aMethodNames"] = [];


//#JSCOVER_EXCL_START
/** @protected */
UCF_Decorator["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Decorator["_"]["setDefaultValues"]++; }; 
	

	if (this["getClientControl"]() && !this["bKeepAlive"]) ;
};;if (__UCF_COVERAGE__) { UCF_Decorator["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Dimension"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../../core/Object.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_Control} oRelativeParent
 */
function UCF_Dimension(oDomRef, oRelativeParent) {if (__UCF_COVERAGE__) { UCF_Dimension["_"]["UCF_Dimension"]++; }; 
	UCF_Object["apply"](this);
	this["oRect"] = null;
	this["oDomRef"] = oDomRef;
	this["oElement"] = null;
	this["oRelativeParent"] = oRelativeParent;
};window["UCF_Dimension"] = UCF_Dimension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Dimension"); UCF_Dimension["_"] = {UCF_Dimension: 0}; }; ;
UCF_Dimension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Dimension.prototype["sClassName"] = "UCF_Dimension";

UCF_Dimension["prototype"]["iGetStyleValue"] = function(sStyle) {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iGetStyleValue"]++; }; 
	return Math["round"](parseFloat(window["getComputedStyle"](this["oDomRef"])[sStyle])) || 0;
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iGetStyleValue"] = 0; };

UCF_Dimension["prototype"]["recalc"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["recalc"]++; }; 
	this["oRect"] = UCF_DomUtil["oGetObjectRect"](this["oDomRef"], this["oRelativeParent"]);
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["recalc"] = 0; };

UCF_Dimension["prototype"]["setRelativeParent"] = function(oRelativeParent) {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["setRelativeParent"]++; }; 
	this["oRelativeParent"] = oRelativeParent;
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["setRelativeParent"] = 0; };

UCF_Dimension["prototype"]["setDomRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["setDomRef"]++; }; 
	this["oDomRe"] = oDomRef;
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["setDomRef"] = 0; };

UCF_Dimension["prototype"]["iTop"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iTop"]++; }; 
	if (!this["oRect"]) this["recalc"]();
	return this["oRect"]["top"];
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iTop"] = 0; };

UCF_Dimension["prototype"]["iLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iLeft"]++; }; 
	if (!this["oRect"]) this["recalc"]();
	return this["oRect"]["left"];
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iLeft"] = 0; };

UCF_Dimension["prototype"]["iHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iHeight"]++; }; 
	if (!this["oRect"]) this["recalc"]();
	return this["oRect"]["height"];
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iHeight"] = 0; };

UCF_Dimension["prototype"]["iWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iWidth"]++; }; 
	if (!this["oRect"]) this["recalc"]();
	return this["oRect"]["width"];
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iWidth"] = 0; };

UCF_Dimension["prototype"]["iPaddingTop"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iPaddingTop"]++; }; 
	return this["iGetStyleValue"]("paddingTop");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iPaddingTop"] = 0; };

UCF_Dimension["prototype"]["iPaddingLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iPaddingLeft"]++; }; 
	return this["iGetStyleValue"]("paddingLeft");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iPaddingLeft"] = 0; };

UCF_Dimension["prototype"]["iPaddingBottom"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iPaddingBottom"]++; }; 
	return this["iGetStyleValue"]("paddingBottom");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iPaddingBottom"] = 0; };

UCF_Dimension["prototype"]["iPaddingRight"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iPaddingRight"]++; }; 
	return this["iGetStyleValue"]("paddingRight");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iPaddingRight"] = 0; };

UCF_Dimension["prototype"]["iMarginTop"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iMarginTop"]++; }; 
	return this["iGetStyleValue"]("marginTop");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iMarginTop"] = 0; };

UCF_Dimension["prototype"]["iMarginLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iMarginLeft"]++; }; 
	return this["iGetStyleValue"]("marginLeft");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iMarginLeft"] = 0; };

UCF_Dimension["prototype"]["iMarginBottom"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iMarginBottom"]++; }; 
	return this["iGetStyleValue"]("marginBottom");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iMarginBottom"] = 0; };

UCF_Dimension["prototype"]["iMarginRight"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iMarginRight"]++; }; 
	return this["iGetStyleValue"]("marginRight");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iMarginRight"] = 0; };

UCF_Dimension["prototype"]["iBorderTop"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iBorderTop"]++; }; 
	return this["iGetStyleValue"]("borderTop");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iBorderTop"] = 0; };

UCF_Dimension["prototype"]["iBorderLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iBorderLeft"]++; }; 
	return this["iGetStyleValue"]("borderLeft");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iBorderLeft"] = 0; };

UCF_Dimension["prototype"]["iBorderBottom"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iBorderBottom"]++; }; 
	return this["iGetStyleValue"]("borderBottom");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iBorderBottom"] = 0; };

UCF_Dimension["prototype"]["iBorderRight"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iBorderRight"]++; }; 
	return this["iGetStyleValue"]("borderRight");
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["iBorderRight"] = 0; };

UCF_Dimension["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["show"]++; }; 
	if (!this["oElement"]) {
		this["oElement"] = document["createElement"]("DIV");
		this["oElement"]["style"]["position"] = "absolute";
		this["oElement"]["style"]["boxSizing"] = "border-box";
		this["oBorderElement"] = document["createElement"]("DIV");
		this["oBorderElement"]["style"]["boxSizing"] = "border-box";
		this["oPaddingElement"] = document["createElement"]("DIV");
		this["oPaddingElement"]["style"]["boxSizing"] = "border-box";
		this["oContentElement"] = document["createElement"]("DIV");
		this["oContentElement"]["style"]["boxSizing"] = "border-box";
		this["oElement"]["appendChild"](this["oBorderElement"]);
		this["oBorderElement"]["appendChild"](this["oPaddingElement"]);
		this["oPaddingElement"]["appendChild"](this["oContentElement"]);
		document["body"]["appendChild"](this["oElement"]);
	}
	var iMarginTop = this["iMarginTop"]();
	var iMarginBottom = this["iMarginBottom"]();
	var iMarginRight = this["iMarginRight"]();
	var iMarginLeft = this["iMarginLeft"]();
	if (window["getComputedStyle"](this["oDomRef"])["boxSizing"] === "content-box") {
		this["oElement"]["style"]["top"] = (this["iTop"]() - iMarginTop - this["iBorderTop"]() - this["iPaddingTop"]()) + "px";
	} else {
		this["oElement"]["style"]["top"] = (this["iTop"]() - iMarginTop - this["iBorderTop"]()) + "px";
	}
	if (window["getComputedStyle"](this["oDomRef"])["boxSizing"] === "content-box") {
		this["oElement"]["style"]["left"] = (this["iLeft"]() - iMarginLeft - this["iBorderLeft"]() - this["iPaddingLeft"]()) + "px";
	} else {
		this["oElement"]["style"]["left"] = (this["iLeft"]() - iMarginLeft - this["iBorderLeft"]()) + "px";
	}
	if (window["getComputedStyle"](this["oDomRef"])["boxSizing"] === "content-box") {
		this["oElement"]["style"]["height"] = (this["iHeight"]() + iMarginTop + iMarginBottom + this["iBorderTop"]() + this["iPaddingTop"]() + this["iBorderBottom"]() + this["iPaddingBottom"]()) + "px";
	} else {
		this["oElement"]["style"]["height"] = (this["iHeight"]() + iMarginTop + iMarginBottom) + "px";
	}
	if (window["getComputedStyle"](this["oDomRef"])["boxSizing"] === "content-box") {
		this["oElement"]["style"]["width"] = (this["iWidth"]() + iMarginLeft + iMarginRight + this["iBorderLeft"]() + this["iPaddingLeft"]() + this["iBorderRight"]() + this["iPaddingRight"]()) + "px";
	} else {
		this["oElement"]["style"]["width"] = (this["iWidth"]() + iMarginLeft + iMarginRight) + "px";
	}
	this["oElement"]["style"]["backgroundColor"] = "rgba(252, 224, 151, 0.5)";

	this["oElement"]["style"]["paddingTop"] = iMarginTop + "px";
	this["oElement"]["style"]["paddingBottom"] = iMarginBottom + "px";
	this["oElement"]["style"]["paddingLeft"] = iMarginLeft + "px";
	this["oElement"]["style"]["paddingRight"] = iMarginRight + "px";

	this["oBorderElement"]["style"]["width"] = "100%";
	this["oBorderElement"]["style"]["height"] = "100%";
	this["oBorderElement"]["style"]["paddingTop"] = this["iBorderTop"]() + "px";
	this["oBorderElement"]["style"]["paddingBottom"] = this["iBorderBottom"]() + "px";
	this["oBorderElement"]["style"]["paddingLeft"] = this["iBorderLeft"]() + "px";
	this["oBorderElement"]["style"]["paddingRight"] = this["iBorderRight"]() + "px";
	this["oBorderElement"]["style"]["backgroundColor"] = "rgba(211, 255, 205, 0.50)";

	this["oPaddingElement"]["style"]["width"] = "100%";
	this["oPaddingElement"]["style"]["height"] = "100%";
	this["oPaddingElement"]["style"]["paddingTop"] = this["iPaddingTop"]() + "px";
	this["oPaddingElement"]["style"]["paddingBottom"] = this["iPaddingBottom"]() + "px";
	this["oPaddingElement"]["style"]["paddingLeft"] = this["iPaddingLeft"]() + "px";
	this["oPaddingElement"]["style"]["paddingRight"] = this["iPaddingRight"]() + "px";
	this["oPaddingElement"]["style"]["backgroundColor"] = "rgba(211, 255, 205, 0.50)";

	this["oContentElement"]["style"]["width"] = "100%";
	this["oContentElement"]["style"]["height"] = "100%";
	this["oContentElement"]["style"]["backgroundColor"] = "rgba(100,100,255,0.5)";
	this["oContentElement"]["style"]["border"] = "1px solid black";

	this["oElement"]["style"]["display"] = "block";
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["show"] = 0; };

UCF_Dimension["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["hide"]++; }; 
	if (this["oElement"]) {
		this["oElement"]["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["hide"] = 0; };

UCF_Dimension["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["destroy"]++; }; 
	if (this["oElement"]) {
		this["oElement"]["parentNode"]["removeChild"](this["oElement"]);
	}
	this["oRect"] = null;
	this["oDomRef"] = null;
	this["oElement"] = null;
	this["oRelativeParent"] = null;
	this["oBorderElement"] = null;
	this["oPaddingElement"] = null;
	this["oContentElement"] = null;
	this["oDomRe"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Dimension["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_DragAndDropDelegate"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>

/**
 * @class
 * @param {UCF_Control} oDragAndDropHandler
 */
function UCF_DragAndDropDelegate(oDragAndDropHandler) {if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["UCF_DragAndDropDelegate"]++; }; 
	this["oDragAndDropHandler"] = oDragAndDropHandler;
};window["UCF_DragAndDropDelegate"] = UCF_DragAndDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DragAndDropDelegate"); UCF_DragAndDropDelegate["_"] = {UCF_DragAndDropDelegate: 0}; }; ;

UCF_DragAndDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_DragAndDropDelegate.prototype["sClassName"] = "UCF_DragAndDropDelegate";

UCF_DragAndDropDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragstart"]++; }; 
	this["processEvent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragstart"] = 0; };
UCF_DragAndDropDelegate["prototype"]["onlsdragover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragover"]++; }; 
	this["processEvent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragover"] = 0; };
UCF_DragAndDropDelegate["prototype"]["onlsdraghover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdraghover"]++; }; 
	this["processEvent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdraghover"] = 0; };
UCF_DragAndDropDelegate["prototype"]["onlsdragscroll"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragscroll"]++; }; 
	this["processEvent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragscroll"] = 0; };
UCF_DragAndDropDelegate["prototype"]["onlsdrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdrop"]++; }; 
	this["processEvent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdrop"] = 0; };
UCF_DragAndDropDelegate["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragend"]++; }; 
	this["processEvent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragend"] = 0; };
UCF_DragAndDropDelegate["prototype"]["onlsdragenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragenter"]++; }; 
	this["processEvent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragenter"] = 0; };
UCF_DragAndDropDelegate["prototype"]["onlsdragleave"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragleave"]++; }; 
	this["processEvent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["onlsdragleave"] = 0; };

UCF_DragAndDropDelegate["prototype"]["processEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["processEvent"]++; }; 
	var oDragAndDropHandler = this["oDragAndDropHandler"];
	if (!oDragAndDropHandler)
		return;

	var fCallback = oDragAndDropHandler["on" + oBrowserEvent["sGetName"]()];
	if (fCallback) {
		var oDomEvent = oBrowserEvent["oDomEvent"],
			oSourceRef = oBrowserEvent["oGetSource"]();

		var bResult = fCallback["apply"](oDragAndDropHandler, [oDomEvent, oSourceRef]);
		if (bResult) {
			oBrowserEvent["cancelBubble"]();
		}

	}
};;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["processEvent"] = 0; };

/**
 * destructor
 */
UCF_DragAndDropDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["destroy"]++; }; 

	this["oDragAndDropHandler"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropDelegate["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_DragAndDropManager"] = function() {/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_BrowserWindow */
/// <reference path="../browser/BrowserWindow.js"/>
/* global UCF_DragSession */
/// <reference path="../controls/base/DragSession.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../controls/base/HTMLGhost.js" />
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * Drag and Drop Manager
 * 
 * @param {UCF_BrowserWindow} oBrowserWindow the browser window object
 * @class
 */
function UCF_DragAndDropManager(oBrowserWindow) {if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["UCF_DragAndDropManager"]++; }; 

	this["oBrowserWindow"] = oBrowserWindow;
	this["iDragStartX"] = -1;
	this["iDragStartY"] = -1;
	this["oLastMousePosition"] = { "left": -1, "top": -1 };

	//load class in advance (needed for inter-iframe scenario)
	new (UCF_ClassLoader["oGetClass"]("UCF_DragSession"))();
	this["eDropEnabledCursor"] = UCF_DragSession["E_CURSOR"]["ALLOWED"];
	this["oGhost"] = null;
	this["oDragDecoration"] = null;
	this["oDropDecoration"] = null;
	// Drag state for Drag/Drop
	this["setDragState"](this["E_DRAGSTATE"]["NoDrag"]);
	this["oPreviouslyHoveredDomRef"] = null;

	this["bCancelContextMenuEvent"] = false;
	this["sDelayedHoverCallId"] = null;
	this["sDragScrollIntervalId"] = null;
	this["sDragSourceId"] = null;
	this["oPage"] = null;

	this["bIgnoreClick"] = false;
	var that = this;
	this["fHideGhost"] = function() {
		if (that["oGhost"]) that["oGhost"]["hide"]();

		//fire dragleave once at last mouseout event --  iRaiseDragLeaveTimerM -> mouse events
		if (!that["oPage"] || that["oPage"]["bGetSubscribedToDragOver"]() || !that["oDragSession"] || that["oDragSession"]["eDragType"] != UCF_DragSession["DRAG_TYPE"]["STANDARD"]) return;
		that["_iRaiseDragLeaveTimerM"] = UCF_JsUtil["delayedCall"](100, that["oPage"], "raiseDragLeave");
	};

	//for drag scroll
	this["iCurrentStepY"] = 0;
	this["iCurrentStepX"] = 0;
	var oScrollOffset = UCF_DomUtil["oGetScrollOffset"]();
	this["oScrollRange"] = {
		"width": oScrollOffset["x"] - UCF_DomUtil["iClientWidth"](),
		"height": oScrollOffset["y"] - UCF_DomUtil["iClientHeight"]()
	};

	//left or right
	this["iMouseButtonState"] = null;

	//only handle mouse move when the D&D-Manager attached them
	this["bMouseListenerAttached"] = false;
	//native browser Drag/Drop mode
	this["bBrowserDragDrop"] = false;
	this["oDragImage"] = null;
	this["iMouseMoveCounter"] = 0;
	this["bBodyNoUserSelect"] = UCF_DomUtil["bHasClass"](document["body"], "urNoUserSelect");
	this["bSelectionMode"] = false;
	this["oSelectionAnchorNode"] = null;
	this["bSelectStart"] = false;
};window["UCF_DragAndDropManager"] = UCF_DragAndDropManager; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DragAndDropManager"); UCF_DragAndDropManager["_"] = {UCF_DragAndDropManager: 0}; }; ;

UCF_DragAndDropManager["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_DragAndDropManager.prototype["sClassName"] = "UCF_DragAndDropManager";

UCF_DragAndDropManager["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["destroy"]++; }; 

	this["finishDragSession"]();

	this["oBrowserWindow"] = null;
	this["oLastMousePosition"] = null;
	this["oDragDecoration"] = null;
	this["oPage"] = null;
	this["oScrollRange"] = null;
	this["oDragImage"] = null;
	this["sDragSourceId"] = null;
	this["iMouseButtonState"] = null;

	this["iDragStartX"] = 0;
	this["iDragStartY"] = 0;
	this["eDropEnabledCursor"] = "";
	this["iCurrentStepY"] = 0;
	this["iCurrentStepX"] = 0;
	this["bBodyNoUserSelect"] = false;
	this["sSerializedDragSourceDomRef"] = "";
	this["iDDThreshold"] = 0;
	this["sCurrentBrowserEvent"] = "";
	this["iHorResizePageY"] = 0;
	this["iHorResizeClientY"] = 0;
	this["iDragScrollLastX"] = 0;
	this["iDragScrollLastY"] = 0;
	this["eDragState"] = "";

	if (this["_iRaiseDragLeaveTimerM"]) {
		UCF_JsUtil["clearDelayedCall"](this["_iRaiseDragLeaveTimerM"]);
		this["_iRaiseDragLeaveTimerM"] = "";
	}
	if (this["_iRaiseDragLeaveTimerD"]) {
		UCF_JsUtil["clearDelayedCall"](this["_iRaiseDragLeaveTimerD"]);
		this["_iRaiseDragLeaveTimerD"] = "";
	}

	this["fHideGhost"] = null;
	this["fMoveHandler"] = null;
	this["oSelectionAnchorNode"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["destroy"] = 0; };

/**
 * mouse move threshold after which drag is started
 */
UCF_DragAndDropManager["prototype"]["iDDTHRESHOLD"] = 6;

UCF_DragAndDropManager["prototype"]["TAG_MATCHING"] = {
	"SEPERATOR": " ",
	"WILDCARD": "*"
};
/**
 * Enumeration for the possible states of the browser window
 */
UCF_DragAndDropManager["prototype"]["E_DRAGSTATE"] = {
	"PreDrag": 0,
	//from mouse down until threshold is exceeded
	"Drag": 1,
	//while dragging
	"DropPending": 2,
	//when drop is waiting for drag event to return
	"NoDrag": -1
};

UCF_DragAndDropManager["prototype"]["I_INTERVAL"] = {
	"DragHover": 500,
	//ms
	"DragScroll": 10 //ms
};

/**
 * handles a mousedown and starts listening to mousemove
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_DragAndDropManager["prototype"]["notifyMouseDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseDown"]++; }; 

	//lightspeed DD
	this["bBrowserDragDrop"] = false;
	//store actual body size
	this["oScrollRange"] = {
		"width": document["body"]["scrollWidth"] - document["body"]["clientWidth"],
		"height": document["body"]["scrollHeight"] - document["body"]["clientHeight"]
	};

	//ignore events
	if (this["oDragSession"] && this["oDragSession"]["bDropPending"]) return;

	var iMouseButtonState = oBrowserEvent["eGetMouseButtonState"]();

	if (this["eDragState"] == this["E_DRAGSTATE"]["NoDrag"]) {

		if (iMouseButtonState == oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"] || iMouseButtonState == oBrowserEvent["MOUSE_BUTTON_STATE"]["Right"]) {
			this["prepareDragSession"](oBrowserEvent);
		}
		this["bSelectStart"] = true;
	} else {
		//both left and right button
		var bWasChordClick = iMouseButtonState == oBrowserEvent["MOUSE_BUTTON_STATE"]["Left_Right"];

		if (UCF_UserAgent["bIsFirefox"]() || UCF_UserAgent["bIsSafari"]()) {
			//Malte: MOUSE_BUTTON_STATE.Left_Right not supported in FF?
			bWasChordClick = true;
		}

		if (bWasChordClick) {

			this["fireDragEnd"](oBrowserEvent, false);
			this["finishDragSession"]();
			//right click cancels drag session and
			//does not show context menu in this case
			this["bCancelContextMenuEvent"] = true;

		} else {
			//fire drop event on mouse down,
			//when mouse down occurred outside of the browser
			this["notifyMouseUp"](oBrowserEvent);
		}

	}
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseDown"] = 0; };

/**
 * Enter the state, where a drag is possible but not occurred yet.
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_DragAndDropManager["prototype"]["prepareDragSession"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["prepareDragSession"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "prepareDragSession", "DragAndDropManager.js(218): prepareDragSession"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(219): prepareDragSession"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["eDragState"] == this["E_DRAGSTATE"]["NoDrag"], "this.eDragState == this.E_DRAGSTATE.NoDrag", "DragAndDropManager.js(220): prepareDragSession"); };

	this["bSelectionMode"] = false;

	//position of mosuedown
	this["iDragStartX"] = oBrowserEvent["iPageX"]();
	this["iDragStartY"] = oBrowserEvent["iPageY"]();

	//left or right
	this["iMouseButtonState"] = oBrowserEvent["eGetMouseButtonState"]();

	//get the control's dom ref
	var oDragSource = UCF_DomUtil["oGetParentByAttribute"](oBrowserEvent["oGetSource"](), "id");
	if (!oDragSource) return;

	this["sDragSourceId"] = oDragSource["id"];

	//serialize drag source element as a path
	//needed for sap table which changes its dom on mousedown (select)
	this["sSerializedDragSourceDomRef"] = UCF_DomUtil["sSerializeDomRef"](oBrowserEvent["oGetSource"]());

	// The drag and drop threshold can be defined by the DOM. e.g. Scrollbar handle needs a threshold of 1
	var iDomDefinedThreshold = oBrowserEvent["oGetSource"]()["getAttribute"]("iDDThreshold");
	if (iDomDefinedThreshold) {
		this["iDDThreshold"] = iDomDefinedThreshold;
	} else {
		//check all ct elements up to the page
		var oCTElement = UCF_DomUtil["oGetCTElement"](oDragSource),
			oParentRef = null;

		while (oCTElement && !oCTElement["getAttribute"]("iDDThreshold") && oCTElement != document["body"]) {
			oParentRef = oCTElement["parentNode"];
			oCTElement = UCF_DomUtil["oGetCTElement"](oParentRef);
		}
		if (oCTElement && oCTElement["getAttribute"]("iDDThreshold")) {
			this["iDDThreshold"] = oCTElement["getAttribute"]("iDDThreshold");
		} else {
			this["iDDThreshold"] = this["iDDTHRESHOLD"];
		}
	}

	this["setDragState"](this["E_DRAGSTATE"]["PreDrag"]);
	// attach mousemove lazy, because of performance reasons
	this["bMouseListenerAttached"] = true;
	this["oBrowserWindow"]["attachBrowserEvent"]("mousemove", document);
	this["oBrowserWindow"]["attachBrowserEvent"]("mouseup", document);
	this["oBrowserWindow"]["attachBrowserEvent"]("dragend", document);
	this["oBrowserWindow"]["attachBrowserEvent"]("drop", document);
	UCF_DomUtil["attachEvent"](document, "mouseout", this["fHideGhost"], false);

	//prevent dragging images in FF
	//need to flag them with mozUserSelect = none
	//else mousedowning an image can cause focus/blur events not to fire
	if (UCF_UserAgent["bIsGecko"]()) {
		var oSource = oBrowserEvent["oGetSource"]();

		if (oSource && oSource["tagName"]["toUpperCase"]() == "IMG" && oSource["style"]["MozUserSelect"] == "none") {
			if (oBrowserEvent["oDomEvent"]["preventDefault"]) oBrowserEvent["oDomEvent"]["preventDefault"]();
		}
	}

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["prepareDragSession"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean} true, if the current mouse location has exceeded a square of 6 pixels
 * around the coordinates where the mouse down occurred
 * @private
 */
UCF_DragAndDropManager["prototype"]["bThresholdExceeded"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["bThresholdExceeded"]++; }; 
	//_trace(INFO, "bThresholdExceeded");
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(291): bThresholdExceeded"); };

	return (Math["abs"](this["iDragStartX"] - oBrowserEvent["iPageX"]()) > this["iDDThreshold"] || Math["abs"](this["iDragStartY"] - oBrowserEvent["iPageY"]()) > this["iDDThreshold"]);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["bThresholdExceeded"] = 0; };

UCF_DragAndDropManager["prototype"]["notifyDragStart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyDragStart"]++; }; 

	var oDomEvent = oBrowserEvent["oDomEvent"];
	if (!oDomEvent) return;

	//ignore native dragstart event in case of already existing DragSession
	if (this["oDragSession"]) {
		return;
	}

	//do not handle drop event triggered from domElements flagged with "handledragdropevents" -> visBiz
	var oSourceElement = oDomEvent["srcElement"] || oDomEvent["target"];
	if (oSourceElement && oSourceElement["getAttribute"] && oSourceElement["getAttribute"]("data-sap-handledragdropevents") == "true") {
		return;
	}

	//native browser DD
	this["bBrowserDragDrop"] = true;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyDragStart"] = 0; };

UCF_DragAndDropManager["prototype"]["notifyDragOver"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyDragOver"]++; }; 

	//cleanupDragImage
	if (this["oDragImage"]) this["cleanupDragImage"]();

	if (this["oDragSession"] && this["oDragSession"]["bGetSubscribeDragEvents"]()) {
		this["notifyMouseMove"](oBrowserEvent);

		if (!this["oPage"] || !this["oPage"]["bGetSubscribedToDragOver"]()) return;
		//fire dragleave once at last mouseout event --  iRaiseDragLeaveTimerD -> drag events
		if (this["_iRaiseDragLeaveTimerD"]) {
			UCF_JsUtil["clearDelayedCall"](this["_iRaiseDragLeaveTimerD"]);
		}
		this["_iRaiseDragLeaveTimerD"] = UCF_JsUtil["delayedCall"](300, this["oPage"], "raiseDragLeave");
	}
	// native browser drag from extern
	else if (!this["oDragSession"]) {
		//return if not supported
		if (!oBrowserEvent["oDomEvent"]["dataTransfer"] || !oBrowserEvent["oDomEvent"]["dataTransfer"]["types"]) return;

		var oDragSessionData = {};

		oDragSessionData["sControlId"] = "";
		oDragSessionData["sDragTags"] = "*";
		oDragSessionData["sDragData"] = "";

		//dataTransfer.types is in IE DomStringList but no Array -> join method not supported -> first manually split into array then join into string
		//		oDragSessionData.sMimeType = oBrowserEvent.oDomEvent.dataTransfer.types.join(" ");
		var oDataTransferTypes = oBrowserEvent["oDomEvent"]["dataTransfer"]["types"];
		var aMimeTypes = [];
		for (var i = 0; i < oDataTransferTypes["length"]; i++) {
			aMimeTypes["push"](oDataTransferTypes[i]);
		}
		oDragSessionData["sMimeType"] = aMimeTypes["join"](" ");
		oDragSessionData["sGhostHtml"] = "";
		oDragSessionData["bSubscribeDragEvents"] = "true";

		this["sCreateDragSession"]("(" + JSON["stringify"](oDragSessionData) + ")");
		this["bBrowserDragDrop"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyDragOver"] = 0; };

UCF_DragAndDropManager["prototype"]["notifyDragEnd"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyDragEnd"]++; }; 

	var oDomEvent = oBrowserEvent["oDomEvent"];
	if (!oDomEvent) return;

	//do not handle dragend event triggered from domElements flagged with "handledragdropevents" -> visBiz
	var oSourceElement = oDomEvent["srcElement"] || oDomEvent["target"];
	if (oSourceElement && oSourceElement["getAttribute"] && oSourceElement["getAttribute"]("data-sap-handledragdropevents") == "true") {
		return;
	}
	if (this["oDragSession"] && this["oDragSession"]["bGetSubscribeDragEvents"]()) {
		this["notifyMouseUp"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyDragEnd"] = 0; };

UCF_DragAndDropManager["prototype"]["notifyDrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyDrop"]++; }; 

	var oDomEvent = oBrowserEvent["oDomEvent"];
	if (!oDomEvent) return;

	//do not handle drop event triggered from domElements flagged with "handledragdropevents" -> visBiz
	var oSourceElement = oDomEvent["srcElement"] || oDomEvent["target"];
	if (oSourceElement && oSourceElement["getAttribute"] && oSourceElement["getAttribute"]("data-sap-handledragdropevents") == "true") {
		return;
	}
	if (this["oDragSession"] && this["oDragSession"]["bGetSubscribeDragEvents"]()) {
		//set drag data in ls dragSession
		if (oDomEvent["dataTransfer"] && oDomEvent["dataTransfer"]["getData"]("text")) {
			this["oDragSession"]["setDragData"](oDomEvent["dataTransfer"]["getData"]("text"), "text");
		}
		this["notifyMouseUp"](oBrowserEvent);

		//Firefox navigates at valid drop even if the datatransfer object just contains data of mimetype Text
		if (UCF_UserAgent["bIsGecko"]()) {
			oDomEvent["preventDefault"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyDrop"] = 0; };

// eslint-disable-next-line complexity
UCF_DragAndDropManager["prototype"]["notifyMouseMove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseMove"]++; }; 
	//actually when any control attaches a mousemove the D&D-Manager will receive them too, so:
	//only listen to mouse move events when the D&D has attached them by itself
	if (!this["bMouseListenerAttached"] && !this["bBrowserDragDrop"]) return;

	//fire dragleave once at last mouseout event --  iRaiseDragLeaveTimerM -> mouse events
	if (this["_iRaiseDragLeaveTimerM"]) {
		UCF_JsUtil["clearDelayedCall"](this["_iRaiseDragLeaveTimerM"]);
	}
	//fire dragenter once
	if (this["oPage"] && !this["oPage"]["bGetSubscribedToDragOver"]() && this["oPage"]["bDragLeaveRaised"]) {
		this["oPage"]["raiseDragEnter"]();
	}

	if (oBrowserEvent["oDomEvent"] && oBrowserEvent["oDomEvent"]["dataTransfer"] && this["oDragSession"] && this["oDragSession"]["bGetValidDropZone"]() && oBrowserEvent["oDomEvent"]["type"] == "dragover") {
		//do not preventDefault when dragover event triggered from domElements flagged with "handledragdropevents" -> visBiz
		if (!oBrowserEvent["oDomEvent"]["srcElement"] || oBrowserEvent["oDomEvent"]["srcElement"]["getAttribute"]("data-sap-handledragdropevents") != "true") {
			oBrowserEvent["oDomEvent"]["preventDefault"]();
		}
	}

	var oLastMousePosition = this["oLastMousePosition"],
		iPageX = oBrowserEvent["iPageX"](),
		iPageY = oBrowserEvent["iPageY"](),
		oHoveredDomRef = null;

	//ignore unneccessary mouse move events
	//Android - preventDefault anyway in order to avoid native scroll events to be triggered
	if (UCF_UserAgent["bIsAndroid"]() && oLastMousePosition["left"] == iPageX && oLastMousePosition["top"] == iPageY) oBrowserEvent["oDomEvent"]["preventDefault"]();
	if (oLastMousePosition["left"] == iPageX && oLastMousePosition["top"] == iPageY) return;

	oLastMousePosition["left"] = iPageX;
	oLastMousePosition["top"] = iPageY;

	if (oBrowserEvent["oDomEvent"]["dataTransfer"] && this["oDragSession"]) {
		this["oDragSession"]["setValidDropZone"](false);
	}

	//_trace("notifyMouseMove");

	this["transferDragSession"](oBrowserEvent);

	oHoveredDomRef = this["oGetHoveredDomRef"](oBrowserEvent);

	if (this["oDragSession"] && this["oDragSession"]["bDropPending"]) {

		this["applyCursorStyle"](oHoveredDomRef);
		this["oPreviouslyHoveredDomRef"] = oHoveredDomRef;

		return;
	}

	if (this["eDragState"] == this["E_DRAGSTATE"]["PreDrag"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "predrag", "DragAndDropManager.js(451): notifyMouseMove"); };
		//IE at native scrollbar fires mousedown but no mouseup
		//therefore it is necessary to check mousebuttonstate here (mousedown has been raised because of predrag state)
		//and call finishdragsssion to reset all states and dettach events
		//and furthermore return to avoid starting a dragsession
		if (oBrowserEvent["eGetMouseButtonState"]() == oBrowserEvent["MOUSE_BUTTON_STATE"]["None"]) {
			this["finishDragSession"](oBrowserEvent);
			return;
		}
		//IE11 does not indicate the released mousebutton at mousemove via event.which nor event.button but event.buttons
		if ((UCF_UserAgent["bIsTrident"](7) || UCF_UserAgent["bIsEdgeHtml"]()) && oBrowserEvent["oDomEvent"]["buttons"] == oBrowserEvent["MOUSE_BUTTON_STATE"]["None"] && oBrowserEvent["oDomEvent"]["type"] == "mousemove") {
			// Skip this for synthetic events of QUnit tests  - We can only set the "button" property but IE11 will not set "buttons" accordingly
			if (!(this["bSyntheticEvents"] === true)) {
				this["finishDragSession"](oBrowserEvent);
				return;
			}
		}
		if (this["bSelectStart"] && document["getSelection"]) {
			// inform controls about document.getSelection()
			var oSelection = null;
			oSelection = document["getSelection"]();
			if (oSelection && oSelection["type"] !== 'None') {
				this["oSelectionAnchorNode"] = oSelection["anchorNode"];
				this["fireSelectStart"](oBrowserEvent);
			}
			this["bSelectStart"] = false;
		}
		if (this["bSelectionMode"]) {
			//fire dragstart after document.getSelection.focusNode has been changed
			if (document["getSelection"]()["focusNode"] === this["oSelectionAnchorNode"]) return;
		}
		else {
			//fire dragstart after exceeding a specific threshold
			if (!this["bThresholdExceeded"](oBrowserEvent)) return;
		}

		//fire drag start on source control
		this["fireDragStart"](oBrowserEvent);
		//control should initiate a drag session on dragstart here
		if (this["oDragSession"] != null) {

			//for events outside of the LS root
			this["oBrowserWindow"]["attachBrowserEvent"]("mousedown", document);
			this["setDragState"](this["E_DRAGSTATE"]["Drag"], oBrowserEvent["bIsTouchInteraction"]());
			//instantly fire drag event for the case
			//the drag source could also be drop target

			//prevent native scrolling triggered by touchmove in IOS as soon as Dragsession has been started
			if (UCF_UserAgent["bIsIOS"]() || UCF_UserAgent["bIsAndroid"]()) oBrowserEvent["oDomEvent"]["preventDefault"]();
			this["fireDragEvents"](oBrowserEvent, oHoveredDomRef);

		} else {
			//end dragsession
			oBrowserEvent["cancelBubble"]();
			this["finishDragSession"](oBrowserEvent);
		}

	} else if (this["oDragSession"] && this["eDragState"] == this["E_DRAGSTATE"]["Drag"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "drag", "DragAndDropManager.js(509): notifyMouseMove"); };

		//finish dragSession if the mouseButton has been released outside the window
		//bSyntheticEvents=true: This is a QUnit test => Skip this code because sometimes some browsers generate "real" mouse events although the mouse is actually not moved
		if (!(this["bSyntheticEvents"] === true) &&
			(oBrowserEvent["eGetMouseButtonState"]() == oBrowserEvent["MOUSE_BUTTON_STATE"]["None"] ||
				(UCF_UserAgent["bIsTrident"](7) || UCF_UserAgent["bIsEdgeHtml"]()) && oBrowserEvent["oDomEvent"]["buttons"] == oBrowserEvent["MOUSE_BUTTON_STATE"]["None"] && oBrowserEvent["oDomEvent"]["type"] == "mousemove")) {
			if (this["bBrowserDragDrop"]) {
				//in case of browser DD sometimes the native drop event gets raised after one single mousemove event
				//therefore finish dragsession after the second mousemove event with button state none
				this["iMouseMoveCounter"]++;
				if (this["iMouseMoveCounter"] === 2) {
					this["cancelTimedEvents"]();
					// fire drag end on source
					this["fireDragEnd"](oBrowserEvent, false);
					if (this["oDragSession"]) this["finishDragSession"](oBrowserEvent);
					this["iMouseMoveCounter"] = 0;
				}
				return;
			} else {
				if (UCF_UserAgent["bIsIE"](9, true) || UCF_UserAgent["bIsIE"](10, true) || UCF_UserAgent["bIsIE"](11, true)) {
					//in IE9 and IE10 and IE11 sometimes the mouse button state is 0 for one single mousemove event although the mouse button has not been released
					//therefore finish dragsession after the second mousemove event with button state none
					this["iMouseMoveCounter"]++;
					if (this["iMouseMoveCounter"] === 2) {
						this["cancelTimedEvents"]();
						// fire drag end on source
						this["fireDragEnd"](oBrowserEvent, false);
						if (this["oDragSession"]) this["finishDragSession"](oBrowserEvent);
						this["iMouseMoveCounter"] = 0;
					}
				} else {
					this["cancelTimedEvents"]();
					// fire drag end on source
					this["fireDragEnd"](oBrowserEvent, false);
					if (this["oDragSession"]) this["finishDragSession"](oBrowserEvent);
				}
				return;
			}
		} else {
			this["iMouseMoveCounter"] = 0;
		}

		//fire events
		this["fireDragEvents"](oBrowserEvent, oHoveredDomRef);
		this["updateGhostAndDecorators"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseMove"] = 0; };

/**
 * Fires a drag enter or drag leave event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the original event
 * @param {HTMLElement} oHoveredDomRef hovered dom ref
 * @return {boolean}
 */
UCF_DragAndDropManager["prototype"]["fireDragEvents"] = function(oBrowserEvent, oHoveredDomRef) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragEvents"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(566): fireDragEvents"); };

	if (!this["oDragSession"] || !oHoveredDomRef) return false;
	var bHandled = false;

	this["sCurrentBrowserEvent"] = oBrowserEvent["serialize"]();

	/**************** fire events ***********************/
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "fireDragEvents " + "dragover:" + (oHoveredDomRef ? oHoveredDomRef["id"] : "null") + " sLastDragOver:" + (this["oPreviouslyHoveredDomRef"] ? this["oPreviouslyHoveredDomRef"]["id"] : 'null'), "DragAndDropManager.js(574): fireDragEvents"); };
	if (this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["STANDARD"] || this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["BLOCK_SELECT"] || this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["DRAG_SELECT"]) {
		if (this["oPreviouslyHoveredDomRef"] != oHoveredDomRef) {

			//Hack for FF2: parte uno
			//itemlistbox: mouse hovers over / enters decorator, fires dragleave and thus removes decorator
			//and fireDragEnter won't be processed cause hoveredDomRef becomes invalid
			var oParent = oHoveredDomRef["parentNode"];
			if (this["oPreviouslyHoveredDomRef"] != null) {
				bHandled = this["fireDragLeave"](oBrowserEvent, this["oPreviouslyHoveredDomRef"]);
			}

			//hack for FF2: parte dos
			if (!oHoveredDomRef["parentNode"]) oHoveredDomRef = oParent;

			bHandled = this["fireDragEnter"](oBrowserEvent, oHoveredDomRef) || bHandled;

		}

		//fire drag over on target
		bHandled = bHandled || this["fireDragOver"](oBrowserEvent, oHoveredDomRef);
	}
	//fire drag on source
	bHandled = this["fireDrag"](oBrowserEvent) || bHandled;

	//special handling -> drag type none = scrolling
	if (this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["STANDARD"] || this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["H_RESIZE"] || this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["BLOCK_SELECT"] || this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["DRAG_SELECT"]) {

		//call fireDragHover delayed
		if (this["sDelayedHoverCallId"]) UCF_JsUtil["clearDelayedCall"](this["sDelayedHoverCallId"]);
		this["sDelayedHoverCallId"] = UCF_JsUtil["delayedCall"](this["I_INTERVAL"]["DragHover"], this, "fireDragHover", [oBrowserEvent, oHoveredDomRef, UCF_JsUtil["oClone"](oBrowserEvent["oDomEvent"], false)]);

		//fire drag scroll
		this["initiateDragSroll"](oBrowserEvent, oHoveredDomRef);
	}

	this["applyCursorStyle"](oHoveredDomRef);

	this["oPreviouslyHoveredDomRef"] = oHoveredDomRef;

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragEvents"] = 0; };

UCF_DragAndDropManager["prototype"]["applyCursorStyle"] = function(oHoveredDomRef) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["applyCursorStyle"]++; }; 
	// cursor handling (must be done on every mouse move)
	//restore cursor

	//do not apply cursor style for native browser DD
	if (this["bBrowserDragDrop"]) return;

	if ((UCF_UserAgent["bIsTrident"](5, true) || UCF_UserAgent["bIsTrident"](6, true)) && this["oPreviouslyHoveredDomRef"] && this["oDragSession"] && (this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["STANDARD"])) {
		UCF_DomUtil["detachEvent"](this["oPreviouslyHoveredDomRef"], "mousemove", this["fMoveHandler"], false);
		this["oPreviouslyHoveredDomRef"]["style"]["cursor"] = "default";
	}

	if (this["oPreviouslyHoveredDomRef"] && this["sAppliedCursorStyle"]) {
		UCF_DomUtil["removeClass"](this["oPreviouslyHoveredDomRef"], this["sAppliedCursorStyle"]);
	}

	var eDragSessionCursor = this["oDragSession"]["eGetCursor"]();

	if (eDragSessionCursor) {
		// cursor in the dragssession has higher priority than our
		this["sAppliedCursorStyle"] = eDragSessionCursor;
	} else {
		if (this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["STANDARD"]) {
			this["sAppliedCursorStyle"] = this["bGetDropAllowed"]() || this["oDragSession"]["bDropPending"] ? this["eDropEnabledCursor"] : UCF_DragSession["E_CURSOR"]["NOT_ALLOWED"];
		} else {
			//drag and move (e.g. scrolling) never shows forbidden cursor
			this["sAppliedCursorStyle"] = this["eDropEnabledCursor"];
		}
	}

	UCF_DomUtil["addClass"](oHoveredDomRef, this["sAppliedCursorStyle"]);

	if (this["oGhost"]) this["oGhost"]["setCursor"](this["sAppliedCursorStyle"]);

	if (!(UCF_UserAgent["bIsTrident"](5, true) || UCF_UserAgent["bIsTrident"](6, true)) || !this["oDragSession"] || (this["oDragSession"]["eDragType"] != UCF_DragSession["DRAG_TYPE"]["STANDARD"])) return;

	this["fMoveHandler"] = (function(that, oHoveredDomRef) {
		return function(oEvt) {
			if (that["oPreviouslyHoveredDomRef"]) {
				that["oPreviouslyHoveredDomRef"]["style"]["cursor"] = "default";
			}
			if (that["sAppliedCursorStyle"] && that["sAppliedCursorStyle"] == UCF_DragSession["E_CURSOR"]["NOT_ALLOWED"]) {
				oHoveredDomRef["style"]["cursor"] = "not-allowed";
			}
		};
	})(this, oHoveredDomRef);

	UCF_DomUtil["attachEvent"](oHoveredDomRef, "mousemove", this["fMoveHandler"], false);

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["applyCursorStyle"] = 0; };

/**
 *  should occur when entering an iframe during drag and drop
 * @param {UCF_BrowserEvent} oBrowserEvent
 *
 */
UCF_DragAndDropManager["prototype"]["notifyMouseOver"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseOver"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(674): notifyMouseOver"); };
	//_trace(INFO, "notifyMouseOver");
	//for iframe scenario
	//focus must be on the (i)frame's window to process events
	//else no key events!
	//CSN: 0002083137 2008
	if (UCF_UserAgent["bIsFirefox"]() && this["eDragState"] == this["E_DRAGSTATE"]["Drag"]) {
		try {
			window["focus"]();
		} catch (e) {}
	}

	this["transferDragSession"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseOver"] = 0; };

/**
 * handling for the inter-iframe-scenario
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_DragAndDropManager["prototype"]["transferDragSession"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["transferDragSession"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(695): transferDragSession"); };

	//get the shared drag session
	var oExternalDragSession = UCF_DomUtil["oGetTopWindow"]()["oDragSession"];

	if (oExternalDragSession) {
		//no internal drag session
		//scenario: on first entering another frame
		if (!this["oDragSession"]) {
			this["setDragState"](this["E_DRAGSTATE"]["Drag"], oBrowserEvent["bIsTouchInteraction"]());
			this["oDragSession"] = oExternalDragSession;
			this["bMouseListenerAttached"] = true;
			this["oBrowserWindow"]["attachBrowserEvent"]("mousemove", document);
			this["oBrowserWindow"]["attachBrowserEvent"]("mouseup", document);
			this["oBrowserWindow"]["attachBrowserEvent"]("mousedown", document);
			this["oBrowserWindow"]["attachBrowserEvent"]("dragend", document);
			this["oBrowserWindow"]["attachBrowserEvent"]("drop", document);
			UCF_DomUtil["attachEvent"](document, "mouseout", this["fHideGhost"], false);

			this["transferGhost"](oExternalDragSession);

		} else //reentering
		{
			//check if dragsession has changed
			this["setDragState"](this["E_DRAGSTATE"]["Drag"], oBrowserEvent["bIsTouchInteraction"]());
			//this.oBrowserWindow.attachBrowserEvent("mousemove", document);
			if (this["oDragSession"] != oExternalDragSession) {
				this["oDragSession"] = oExternalDragSession;
				this["transferGhost"](oExternalDragSession);
			}
		}
	} else {

		//re-entering a frame when drag session has been finished in another iframe
		if (this["oDragSession"]) {

			this["finishDragSession"]();
		}
	}

	//show / hide ghost when entering / leaving iframe
	if (this["oGhost"]) {
		var oHoveredDomRef = this["oGetHoveredDomRef"](oBrowserEvent);
		if (oHoveredDomRef) {
			//when entering an iframe
			if (oHoveredDomRef["tagName"] == "IFRAME") {
				this["oGhost"]["hide"]();
			} else if (!this["oDragSession"]["bDropPending"]) {
				this["oGhost"]["show"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["transferDragSession"] = 0; };

UCF_DragAndDropManager["prototype"]["transferGhost"] = function(oExternalDragSession) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["transferGhost"]++; }; 

	var sGhostHTML = oExternalDragSession["sGetGhostHTML"]();

	//remove internal ghost
	if (this["oGhost"]) {
		this["oGhost"]["doDestroy"]();
		this["oGhost"] = null;
	}

	if (sGhostHTML && !this["oGhost"]) {

		var oContainer = document["createElement"]("div");
		//need to check if sGostHTMl can be trusted - need to double check
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](oContainer, sGhostHTML);
		document["body"]["appendChild"](oContainer);

		this["oGhost"] = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(UCF_DomUtil["oGetFirstChild"](oContainer));
		this["oGhost"]["create"](document["body"]);

		var oGhost = oExternalDragSession["oGhost"];
		this["oGhost"]["setOffset"](oGhost["iOffsetLeft"], oGhost["iOffsetTop"]);

	}
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["transferGhost"] = 0; };

/**
 * should occur when leaving an iframe during drag and drop
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_DragAndDropManager["prototype"]["notifyMouseOut"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseOut"]++; }; 
	//_trace(INFO, "notifyMouseOut");
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(782): notifyMouseOut"); };

	//will be called in the main page when leaving iframe
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseOut"] = 0; };

UCF_DragAndDropManager["prototype"]["notifyMouseUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseUp"]++; }; 

	if (this["oDragSession"] && this["oDragSession"]["bDropPending"]) return;

	if (this["eDragState"] == this["E_DRAGSTATE"]["PreDrag"]) {
		this["finishDragSession"]();
	} else if (this["eDragState"] == this["E_DRAGSTATE"]["Drag"]) {
		//cancel draghover / dragscroll events
		this["cancelTimedEvents"]();

		if (this["oDragSession"]) this["oDragSession"]["setDropPosition"](oBrowserEvent["iPageX"](), oBrowserEvent["iPageY"]());

		//fire drop on target
		var bHandled = false;

		if (this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["STANDARD"]) {
			bHandled = this["fireDrop"](oBrowserEvent);
		}

		// fire drag end on source
		this["fireDragEnd"](oBrowserEvent, bHandled);

		if (this["oGhost"]) {
			this["oGhost"]["destroy"](bHandled);
			this["oGhost"] = null;
			delete this["oGhost"];
		}

		if (this["oDragSession"] && !this["oDragSession"]["bDropPending"]) {
			this["finishDragSession"]();
		}

		if (this["bBrowserDragDrop"]) return;

		//cancel mouseups to prevent context menu and unwanted deselection
		//in itemlistbox etc. CSN 1623865 2008
		oBrowserEvent["cancelBubble"]();

		// do not cancel so that others can register
		oBrowserEvent["cancel"]();
		this["ignoreClickEvent"]();
	}

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseUp"] = 0; };

UCF_DragAndDropManager["prototype"]["ignoreClickEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["ignoreClickEvent"]++; }; 

	this["bIgnoreClick"] = true;
	UCF_JsUtil["delayedCall"](1, this, "cancelIgnoreClickEvent", []);

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["ignoreClickEvent"] = 0; };

UCF_DragAndDropManager["prototype"]["cancelIgnoreClickEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["cancelIgnoreClickEvent"]++; }; 

	this["bIgnoreClick"] = false;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["cancelIgnoreClickEvent"] = 0; };

UCF_DragAndDropManager["prototype"]["notifyMouseClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseClick"]++; }; 

	if (this["bIgnoreClick"]) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		//this.bIgnoreClick = false;
		return;
	}

	if (this["oDragSession"]) {
		this["notifyMouseUp"](oBrowserEvent);
	}

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyMouseClick"] = 0; };

UCF_DragAndDropManager["prototype"]["notifyEscapePressed"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyEscapePressed"]++; }; 

	this["cancelTimedEvents"]();
	// fire drag end on source
	this["fireDragEnd"](oBrowserEvent, false);

	if (this["oDragSession"]) this["finishDragSession"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyEscapePressed"] = 0; };

/**
 * this method will be called if the user activates the context menu
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_DragAndDropManager["prototype"]["notifyContextMenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyContextMenu"]++; }; 

	//_trace(INFO,"iNrOfMouseUpsToCancel:" + this.iNrOfMouseUpsToCancel);
	// prevent context menu if drag session
	// has been canceled with chord click
	if (this["bCancelContextMenuEvent"]) {

		this["bCancelContextMenuEvent"] = false;

		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();

	}

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyContextMenu"] = 0; };

UCF_DragAndDropManager["prototype"]["notifyKeyDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyKeyDown"]++; }; 

	if (!this["oDragSession"]) return;

	//ctrl or alt
	var iKey = oBrowserEvent["iKeyCode"]();

	if (iKey == UCF_KeyCodes["CONTROL"]) {
		this["oDragSession"]["setModifier"](this["oDragSession"]["MODIFIER"]["CONTROL"]);
		if (this["oGhost"]) {
			if (this["bGetDropAllowed"]()) {
				this["oGhost"]["setDropEffect"](this["oDragSession"]["DROP_EFFECT"]["COPY"], this["oPage"]["oLS"]["sGetText"]("SAPUR_COPY"));
				this["oGhost"]["showDropEffect"]();
			} else {
				this["oGhost"]["hideDropEffect"]();
			}
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

	if (iKey == UCF_KeyCodes["ALT"]) {
		this["oDragSession"]["setModifier"](this["oDragSession"]["MODIFIER"]["ALT"]);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

	if (iKey == UCF_KeyCodes["SHIFT"]) {
		this["oDragSession"]["setModifier"](this["oDragSession"]["MODIFIER"]["SHIFT"]);
		if (this["oGhost"]) {
			if (this["bGetDropAllowed"]()) {
				this["oGhost"]["setDropEffect"](this["oDragSession"]["DROP_EFFECT"]["MOVE"], this["oPage"]["oLS"]["sGetText"]("SAPUR_MOVE"));
				this["oGhost"]["showDropEffect"]();
			} else {
				this["oGhost"]["hideDropEffect"]();
			}
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyKeyDown"] = 0; };

UCF_DragAndDropManager["prototype"]["notifyKeyUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyKeyUp"]++; }; 

	if (!this["oDragSession"]) return;

	//ctrl or alt
	var iKey = oBrowserEvent["iKeyCode"]();

	if (iKey == UCF_KeyCodes["CONTROL"] || iKey == UCF_KeyCodes["ALT"] || iKey == UCF_KeyCodes["SHIFT"]) {
		this["oDragSession"]["setModifier"](this["oDragSession"]["MODIFIER"]["NONE"]);
		if (this["oGhost"]) {
			this["oGhost"]["hideDropEffect"]();
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["notifyKeyUp"] = 0; };

UCF_DragAndDropManager["prototype"]["fireDragStart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragStart"]++; }; 
	/** @type {UCF_BrowserEvent} */
	// eslint-disable-next-line @ur/no-memory-leaks
	var oNewBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oBrowserEvent["oDomEvent"]);
	/** @type {boolean} */
	var bHandled;
	var oDragSourceDomRef = null;

	oNewBrowserEvent["setName"](this["oBrowserWindow"]["E_LS_EVENTS"]["dragstart"]);

	//keep y-coordinate to prevent vertical scrolling at horizintal resize
	this["iHorResizePageY"] = oBrowserEvent["iPageY"]();
	this["iHorResizeClientY"] = oBrowserEvent["iClientY"]();

	oDragSourceDomRef = UCF_DomUtil["oDeserializeDomRef"](this["sSerializedDragSourceDomRef"]);

	oNewBrowserEvent["setSource"](oDragSourceDomRef);
	oNewBrowserEvent["oDragAndDropManager"] = this;

	this["oBrowserWindow"]["processBrowserEvent"](oNewBrowserEvent);

	bHandled = oNewBrowserEvent["bHandled"];

	oNewBrowserEvent["destroy"]();

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragStart"] = 0; };

/**
 * Fire a drag event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_DragAndDropManager["prototype"]["fireDrag"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDrag"]++; }; 
	/** @type {boolean} */
	var bHandled;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(987): fireDrag"); };

	if (!this["oDragSession"]) return false;

	// eslint-disable-next-line @ur/no-memory-leaks
	var oNewBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oBrowserEvent["oDomEvent"]);

	oNewBrowserEvent["setName"](this["oBrowserWindow"]["E_LS_EVENTS"]["drag"]);
	var oDragSourceDomRef = document["getElementById"](this["sDragSourceId"]);
	oNewBrowserEvent["setSource"](oDragSourceDomRef);
	oNewBrowserEvent["oDragAndDropManager"] = this;
	this["oBrowserWindow"]["processBrowserEvent"](oNewBrowserEvent);

	bHandled = oNewBrowserEvent["bHandled"];

	oNewBrowserEvent["destroy"]();

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDrag"] = 0; };

/**
 * Fire a drag event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {HTMLElement} oHoveredDomRef
 * @return {boolean}
 */
UCF_DragAndDropManager["prototype"]["fireDragOver"] = function(oBrowserEvent, oHoveredDomRef) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragOver"]++; }; 
	/** @type {boolean} */
	var bHandled;

	//_trace(INFO,"D&D");
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(1019): fireDragOver"); };

	// eslint-disable-next-line @ur/no-memory-leaks
	var oNewBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oBrowserEvent["oDomEvent"]);

	oNewBrowserEvent["oDragAndDropManager"] = this;
	oNewBrowserEvent["setName"](this["oBrowserWindow"]["E_LS_EVENTS"]["dragover"]);
	oNewBrowserEvent["setSource"](oHoveredDomRef);

	this["oBrowserWindow"]["processBrowserEvent"](oNewBrowserEvent);

	bHandled = oNewBrowserEvent["bHandled"];

	oNewBrowserEvent["destroy"]();

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragOver"] = 0; };

UCF_DragAndDropManager["prototype"]["fireDragHover"] = function(oBrowserEvent, oHoveredDomRef, oDomEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragHover"]++; }; 
	/** @type {boolean} */
	var bHandled;

	//_trace(INFO,"D&D");
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(1042): fireDragHover"); };

	// eslint-disable-next-line @ur/no-memory-leaks
	var oNewBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oDomEvent);
	oNewBrowserEvent["oDragAndDropManager"] = this;
	oNewBrowserEvent["setName"](this["oBrowserWindow"]["E_LS_EVENTS"]["draghover"]);
	oNewBrowserEvent["setSource"](oHoveredDomRef);

	//call fireDragHover delayed
	//TODO: really fire again??
	if (this["sDelayedHoverCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sDelayedHoverCallId"]);
	}
	//this.sDelayedHoverCallId = UCF_JsUtil.delayedCall(this.I_INTERVAL.DragHover,this,"fireDragHover",[oNewBrowserEvent,oHoveredDomRef,UCF_JsUtil.oClone(oNewBrowserEvent.oDomEvent,false)]);

	// eslint-disable-next-line @ur/no-memory-leaks
	var oDeserializedBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))();
	oDeserializedBrowserEvent["deserialize"](this["sCurrentBrowserEvent"]);

	oNewBrowserEvent["_iClientX"] = oDeserializedBrowserEvent["iClientX"]();
	oNewBrowserEvent["_iClientY"] = oDeserializedBrowserEvent["iClientY"]();
	oNewBrowserEvent["_iScreenX"] = oDeserializedBrowserEvent["iScreenX"]();
	oNewBrowserEvent["_iScreenY"] = oDeserializedBrowserEvent["iScreenY"]();
	oNewBrowserEvent["_iParentX"] = oDeserializedBrowserEvent["iParentX"]();
	oNewBrowserEvent["_iParentY"] = oDeserializedBrowserEvent["iParentY"]();
	oNewBrowserEvent["_iPageX"] = oDeserializedBrowserEvent["iPageX"]();
	oNewBrowserEvent["_iPageY"] = oDeserializedBrowserEvent["iPageY"]();

	this["oBrowserWindow"]["processBrowserEvent"](oNewBrowserEvent);

	bHandled = oNewBrowserEvent["bHandled"];

	oDeserializedBrowserEvent["destroy"]();
	oNewBrowserEvent["destroy"]();

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragHover"] = 0; };

UCF_DragAndDropManager["prototype"]["initiateDragSroll"] = function(oBrowserEvent, oHoveredDomRef) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["initiateDragSroll"]++; }; 
	if (this["sDragScrollIntervalId"]) {
		UCF_JsUtil["clearIntervalCall"](this["sDragScrollIntervalId"]);
	}
	this["sDragScrollIntervalId"] = UCF_JsUtil["intervalCall"](this["I_INTERVAL"]["DragScroll"], this, "fireDragScroll", [oBrowserEvent, oHoveredDomRef, UCF_JsUtil["oClone"](oBrowserEvent["oDomEvent"], false)]);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["initiateDragSroll"] = 0; };

UCF_DragAndDropManager["prototype"]["cleanUpDragSroll"] = function(oBrowserEvent, oHoveredDomRef) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["cleanUpDragSroll"]++; }; 
	if (this["sDragScrollIntervalId"]) {
		UCF_JsUtil["clearIntervalCall"](this["sDragScrollIntervalId"]);
		this["sDragScrollIntervalId"] = null;

		this["iDragScrollLastScreenX"] = null;
		this["iDragScrollLastScreenY"] = null;
		this["iDragScrollLastTime"] = null;
	}

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["cleanUpDragSroll"] = 0; };

UCF_DragAndDropManager["prototype"]["fireDragScroll"] = function(oBrowserEvent, oHoveredDomRef, oDomEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragScroll"]++; }; 
	/** @type {boolean} */
	var bHandled;

	//_trace(INFO,"D&D");
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(1104): fireDragScroll"); };

	// eslint-disable-next-line @ur/no-memory-leaks
	var oNewBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oDomEvent);
	var iDragScrollX = oNewBrowserEvent["iPageX"](),
		iDragScrollY = oNewBrowserEvent["iPageY"](),
		iDragScrollTime = new Date()["valueOf"](),
		iDragScrollLastX = this["iDragScrollLastX"],
		iDragScrollLastY = this["iDragScrollLastY"],
		iDragScrollLastTime = this["iDragScrollLastTime"];

	// Igniction of drag scroll events only for low mouse speed
	// Speed calculation is processed in the next lines
	this["iDragScrollLastX"] = iDragScrollX;
	this["iDragScrollLastY"] = iDragScrollY;
	this["iDragScrollLastTime"] = iDragScrollTime;

	if (iDragScrollLastTime && iDragScrollTime !== iDragScrollLastTime) {
		var fDistance = Math["sqrt"](Math["pow"](iDragScrollX - iDragScrollLastX, 2) + Math["pow"](iDragScrollY - iDragScrollLastY, 2)),
			fPixelsPerMs = fDistance / (iDragScrollTime - iDragScrollLastTime);

		// Mouse speed too fast. Do not fire DragScroll
		// 100 pixels per second empirical determined (=0.1 pixel/ms)
		if (fPixelsPerMs > 0.1) return;

	} else {
		return;
	}

	oNewBrowserEvent["oDragAndDropManager"] = this;
	oNewBrowserEvent["setName"](this["oBrowserWindow"]["E_LS_EVENTS"]["dragscroll"]);
	oNewBrowserEvent["setSource"](oHoveredDomRef);

	// eslint-disable-next-line @ur/no-memory-leaks
	var oDeserializedBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))();
	oDeserializedBrowserEvent["deserialize"](this["sCurrentBrowserEvent"]);

	oNewBrowserEvent["_iClientX"] = oDeserializedBrowserEvent["iClientX"]();
	oNewBrowserEvent["_iClientY"] = oDeserializedBrowserEvent["iClientY"]();
	oNewBrowserEvent["_iScreenX"] = oDeserializedBrowserEvent["iScreenX"]();
	oNewBrowserEvent["_iScreenY"] = oDeserializedBrowserEvent["iScreenY"]();
	oNewBrowserEvent["_iParentX"] = oDeserializedBrowserEvent["iParentX"]();
	oNewBrowserEvent["_iParentY"] = oDeserializedBrowserEvent["iParentY"]();
	oNewBrowserEvent["_iPageX"] = oDeserializedBrowserEvent["iPageX"]();
	oNewBrowserEvent["_iPageY"] = oDeserializedBrowserEvent["iPageY"]();

	// prevent vertical scrolling at horizontal resize
	if (this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["H_RESIZE"] && this["iHorResizePageY"] && this["iHorResizeClientY"]) {
		oNewBrowserEvent["_iPageY"] = this["iHorResizePageY"];
		oNewBrowserEvent["_iClientY"] = this["iHorResizeClientY"];
	}

	this["oBrowserWindow"]["processBrowserEvent"](oNewBrowserEvent);

	this["handleDragScroll"](oNewBrowserEvent);

	bHandled = oNewBrowserEvent["bHandled"];

	oDeserializedBrowserEvent["destroy"]();
	oNewBrowserEvent["destroy"]();

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragScroll"] = 0; };

/**
 * Fire a virtual drag end event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {boolean} bDropHandled
 *
 * @return {boolean}
 */
UCF_DragAndDropManager["prototype"]["fireDragEnd"] = function(oBrowserEvent, bDropHandled) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragEnd"]++; }; 
	/** @type {boolean} */
	var bHandled;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "D&D", "DragAndDropManager.js(1180): fireDragEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(1181): fireDragEnd"); };

	//check the drag drop object if we are in a drag mode
	if (!this["oDragSession"]) return false;

	//create a virtual browser event based on the actual mouseup dom event
	// eslint-disable-next-line @ur/no-memory-leaks
	var oNewBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oBrowserEvent["oDomEvent"]);
	oNewBrowserEvent["setName"](this["oBrowserWindow"]["E_LS_EVENTS"]["dragend"]);
	var oDragSourceDomRef = document["getElementById"](this["sDragSourceId"]);
	oNewBrowserEvent["setSource"](oDragSourceDomRef);
	oNewBrowserEvent["oDragAndDropManager"] = this;
	oNewBrowserEvent["bDropHandled"] = bDropHandled;

	if (UCF_UserAgent["bIsIOS"]() && oBrowserEvent["sGetName"]() == "touchend") {
		oNewBrowserEvent["_iPageX"] = oBrowserEvent["_iPageX"];
		oNewBrowserEvent["_iPageY"] = oBrowserEvent["_iPageY"];
	}

	this["oBrowserWindow"]["processBrowserEvent"](oNewBrowserEvent);
	bHandled = oNewBrowserEvent["bHandled"];

	oNewBrowserEvent["destroy"]();

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragEnd"] = 0; };

/**
 * Fire a virtual drop event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_DragAndDropManager["prototype"]["fireDrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDrop"]++; }; 
	/** @type {boolean} */
	var bHandled;

	//_assert(oBrowserEvent instanceof UCF_BrowserEvent);
	//check the drag drop object if we are in a drag mode
	if (!this["oDragSession"]) return false;

	var oHoveredDomRef = this["oGetHoveredDomRef"](oBrowserEvent),
		// eslint-disable-next-line @ur/no-memory-leaks
		oNewBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oBrowserEvent["oDomEvent"]);

	oNewBrowserEvent["oDragAndDropManager"] = this;
	oNewBrowserEvent["setName"](this["oBrowserWindow"]["E_LS_EVENTS"]["drop"]);
	oNewBrowserEvent["setSource"](oHoveredDomRef);

	this["oBrowserWindow"]["processBrowserEvent"](oNewBrowserEvent);

	bHandled = oNewBrowserEvent["bHandled"];

	oNewBrowserEvent["destroy"]();

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDrop"] = 0; };

/**
 * Fire a drag enter event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the original event
 * @param {element} oSource the dom element that was entered
 * @return {boolean}
 */
UCF_DragAndDropManager["prototype"]["fireDragEnter"] = function(oBrowserEvent, oSource) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragEnter"]++; }; 
	/** @type {boolean} */
	var bHandled;

	//_trace(INFO,"D&D");
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(1251): fireDragEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSource != null, "oSource != null", "DragAndDropManager.js(1252): fireDragEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oDragSession"] != null, "this.oDragSession != null", "DragAndDropManager.js(1253): fireDragEnter"); };

	// eslint-disable-next-line @ur/no-memory-leaks
	var oNewBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oBrowserEvent["oDomEvent"]);

	oNewBrowserEvent["setName"](this["oBrowserWindow"]["E_LS_EVENTS"]["dragenter"]);
	oNewBrowserEvent["setSource"](oSource);
	oNewBrowserEvent["oDragAndDropManager"] = this;

	this["oBrowserWindow"]["processBrowserEvent"](oNewBrowserEvent);

	bHandled = oNewBrowserEvent["bHandled"];

	oNewBrowserEvent["destroy"]();

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragEnter"] = 0; };

/**
 * Fire a drag leave event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the original event
 * @param {element} oSource the dom element that was left
 * @return {boolean}
 */
UCF_DragAndDropManager["prototype"]["fireDragLeave"] = function(oBrowserEvent, oSource) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragLeave"]++; }; 
	/** @type {boolean} */
	var bHandled;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(1282): fireDragLeave"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSource != null, "oSource != null", "DragAndDropManager.js(1283): fireDragLeave"); };

	if (!this["oDragSession"]) {
		return false;
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DragLeave " + oSource["id"], "DragAndDropManager.js(1289): fireDragLeave"); };
	// eslint-disable-next-line @ur/no-memory-leaks
	var oNewBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oBrowserEvent["oDomEvent"]);

	oNewBrowserEvent["setName"](this["oBrowserWindow"]["E_LS_EVENTS"]["dragleave"]);
	oNewBrowserEvent["setSource"](oSource);
	oNewBrowserEvent["oDragAndDropManager"] = this;

	this["oBrowserWindow"]["processBrowserEvent"](oNewBrowserEvent);

	bHandled = oNewBrowserEvent["bHandled"];

	oNewBrowserEvent["destroy"]();

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireDragLeave"] = 0; };

/**
 * Fire a selectStart event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the original event
 * @return {boolean}
 */
UCF_DragAndDropManager["prototype"]["fireSelectStart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireSelectStart"]++; }; 
	/** @type {boolean} */
	var bHandled;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragAndDropManager.js(1316): fireSelectStart"); };

	var oNewBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oBrowserEvent["oDomEvent"]);

	oNewBrowserEvent["setName"]('lsselectstart');
	oNewBrowserEvent["setSource"](oBrowserEvent["oSource"]);
	oNewBrowserEvent["oDragAndDropManager"] = this;

	this["oBrowserWindow"]["processBrowserEvent"](oNewBrowserEvent);

	bHandled = oNewBrowserEvent["bHandled"];

	oNewBrowserEvent["destroy"]();

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["fireSelectStart"] = 0; };

/**
 * cleans up the current session after drag session is over
 *
 */
UCF_DragAndDropManager["prototype"]["finishDragSession"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["finishDragSession"]++; }; 

	//fire dragleave once at last mouseout event --  iRaiseDragLeaveTimerD -> drag events
	//do not fire dragleave if drop/dragend has taken place before

	if (this["_iRaiseDragLeaveTimerD"]) {
		UCF_JsUtil["clearDelayedCall"](this["_iRaiseDragLeaveTimerD"]);
		if (this["oPage"]) this["oPage"]["bDragEnterRaised"] = false;
	}

	this["setDragState"](this["E_DRAGSTATE"]["NoDrag"]);
	this["iDragStartX"] = -1;
	this["iDragStartY"] = -1;
	this["cancelTimedEvents"]();

	if (this["oDragDecoration"]) {
		this["oDragDecoration"]["cleanUp"]();
		this["oDragDecoration"] = null;
	}

	if (this["oDragSession"]) {
		this["oDragSession"]["destroy"]();
		this["oDragSession"] = null;
	}
	UCF_DomUtil["oGetTopWindow"]()["oDragSession"] = null;

	// stop selection in chrome during dragsession .. reactivate in finishDragSession
	if (!this["bBodyNoUserSelect"] && (UCF_UserAgent["bIsChromium"]() || UCF_UserAgent["bIsSafari"]() || UCF_UserAgent["bIsGecko"]())) UCF_DomUtil["removeClass"](document["body"], "urNoUserSelect");

	this["bMouseListenerAttached"] = false;
	this["oBrowserWindow"]["detachBrowserEvent"]("mousemove", document);
	this["oBrowserWindow"]["detachBrowserEvent"]("mouseup", document);
	this["oBrowserWindow"]["detachBrowserEvent"]("mousedown", document);
	this["oBrowserWindow"]["detachBrowserEvent"]("dragend", document);
	this["oBrowserWindow"]["detachBrowserEvent"]("drop", document);
	UCF_DomUtil["detachEvent"](document, "mouseout", this["fHideGhost"], false);

	if (this["oGhost"]) {
		this["oGhost"]["destroy"](false);
		this["oGhost"] = null;
		delete this["oGhost"];
	}

	if (this["oDropDecoration"]) {
		this["oDropDecoration"]["cleanUp"]();
		this["oDropDecoration"] = null;
	}
	this["cleanUpDropArea"]();

	if (this["oPreviouslyHoveredDomRef"] && this["sAppliedCursorStyle"]) {
		UCF_DomUtil["removeClass"](this["oPreviouslyHoveredDomRef"], this["sAppliedCursorStyle"]);

		//workaround
		//IE does not reflect this until mouse is moved
		//window.resizeBy(0,1);
		//window.resizeBy(0,-1);

	}

	if ((UCF_UserAgent["bIsTrident"](5, true) || UCF_UserAgent["bIsTrident"](6, true)) && this["oPreviouslyHoveredDomRef"] && this["oDragSession"] && (this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["STANDARD"])) {
		UCF_DomUtil["detachEvent"](this["oPreviouslyHoveredDomRef"], "mousemove", this["fMoveHandler"], false);
		this["oPreviouslyHoveredDomRef"]["style"]["cursor"] = "default";
	}

	this["oPreviouslyHoveredDomRef"] = null;
	this["sAppliedCursorStyle"] = null;
	this["setDropEnabledCursor"](UCF_DragSession["E_CURSOR"]["ALLOWED"]);

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["finishDragSession"] = 0; };

/**
 * Gets the dom element behind the mouse
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {HTMLElement}
 */
UCF_DragAndDropManager["prototype"]["oGetHoveredDomRef"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["oGetHoveredDomRef"]++; }; 

	//window.status = new Date().valueOf();
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "DragAndDropManager.js(1415): oGetHoveredDomRef"); };
	var oHoveredDomRef = null,
		bGhostWasVisble = false,
		oFrameElement = null;

	if (!document["elementFromPoint"]) return oBrowserEvent["oGetSource"]();

	if (this["oGhost"]) {
		bGhostWasVisble = this["oGhost"]["bVisible"];
		if (bGhostWasVisble) this["oGhost"]["hide"]();
	}
	var bDropDecoratorWasVisible = false;
	if (this["oDropDecoration"]) {
		if (bDropDecoratorWasVisible = this["oDropDecoration"]["bIsVisible"]()) {
			this["oDropDecoration"]["hide"]();
		}
	}

	if (this["oDragDecoration"]) this["oDragDecoration"]["hide"]();

	//workaround for IE8/IE9 bug in standardsModes in iFrame in RTL
	//invert x position
	var iClientX = oBrowserEvent["iClientX"]();

	// CSN ticket 1131071 2013
	try {
		oFrameElement = window["frameElement"];
	} catch (e) {
		oFrameElement = null;
	}

	if ((UCF_UserAgent["bIsIE"](8, true) || UCF_UserAgent["bIsIE"](9, true)) && window["UCF_System"]["bIsRTL"] && window["UCF_System"]["sDevice"] === "standards" && oFrameElement) {
		iClientX = oFrameElement["offsetWidth"] - oBrowserEvent["iClientX"]();
	}

	oHoveredDomRef = document["elementFromPoint"](iClientX, oBrowserEvent["iClientY"]());

	if (this["oGhost"] && bGhostWasVisble) this["oGhost"]["show"]();

	if (this["oDropDecoration"] && bDropDecoratorWasVisible) {
		this["oDropDecoration"]["show"]();
	}

	if (this["oDragDecoration"]) this["oDragDecoration"]["show"]();

	return oHoveredDomRef;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["oGetHoveredDomRef"] = 0; };

UCF_DragAndDropManager["prototype"]["oGetDropDecoration"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["oGetDropDecoration"]++; }; 
	return this["oDropDecoration"];
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["oGetDropDecoration"] = 0; };

UCF_DragAndDropManager["prototype"]["oGetDragDecoration"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["oGetDragDecoration"]++; }; 
	return this["oDragDecoration"];
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["oGetDragDecoration"] = 0; };

UCF_DragAndDropManager["prototype"]["cleanUpDropArea"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["cleanUpDropArea"]++; }; 

	if (!this["oDragSession"]) return;

	//every drop delegate should handle the lifecycle of their
	//decorator themself
	//if (this.oDropDecoration)
	//	this.oDropDecoration.cleanUp();
	this["oDropDecoration"] = null;

	this["oDragSession"]["sDropTags"] = "";
	this["oDragSession"]["eDropType"] = UCF_DragSession["DROP_TYPE"]["NONE"];

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["cleanUpDropArea"] = 0; };

/**
 * completes the initialization of the drop target
 * @param {string} eDropType
 * @param {string} sDropTags - a white space seperated list of tags
 * @param {object} oDropDecoration - drop decorations
 * @return {boolean}
 *
 */
UCF_DragAndDropManager["prototype"]["initDropArea"] = function(eDropType, sDropTags, oDropDecoration) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["initDropArea"]++; }; 
	//_trace(INFO, "tags" + sDropTags);
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(eDropType) == "number", "typeof(eDropType) == \"number\"", "DragAndDropManager.js(1496): initDropArea"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTags) == "string", "typeof(sDropTags) == \"string\"", "DragAndDropManager.js(1497): initDropArea"); };
	// oDecoration is optional
	var oDragSession = UCF_DomUtil["oGetTopWindow"]()["oDragSession"];
	if (!oDragSession) return;

	this["oDragSession"] = oDragSession;
	this["oDragSession"]["eDropType"] = eDropType;
	this["oDragSession"]["sDropTags"] = sDropTags;

	if (oDropDecoration) this["oDropDecoration"] = oDropDecoration;

	return this["bGetDropAllowed"]();

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["initDropArea"] = 0; };

UCF_DragAndDropManager["prototype"]["setDropEnabledCursor"] = function(eCursor) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["setDropEnabledCursor"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(eCursor) === "string", "typeof(eCursor) === \"string\"", "DragAndDropManager.js(1513): setDropEnabledCursor"); };
	this["eDropEnabledCursor"] = eCursor;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["setDropEnabledCursor"] = 0; };

UCF_DragAndDropManager["prototype"]["bGetDropAllowed"] = function(sDropTags, sValidMimeTypes) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["bGetDropAllowed"]++; }; 
	// sDropTags is optional
	if (this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["NONE"] || this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["BLOCK_SELECT"]) return false;

	//check mime types only for native browserDragDrop
	if (typeof(sValidMimeTypes) != "undefined" && this["bBrowserDragDrop"]) {
		var sSourceMimeTypes = this["oDragSession"]["sGetMimeType"]();
		if (!this["bGetTypeMatch"](sSourceMimeTypes, sValidMimeTypes)) {
			return false;
		}
	}

	if (typeof(sDropTags) == "undefined") sDropTags = this["oDragSession"]["sDropTags"];

	//if (this.oDragSession.sDragTags == "" || sDropTags == "")
	//	return false;
	return this["bGetTagMatch"](this["oDragSession"]["sDragTags"], sDropTags);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["bGetDropAllowed"] = 0; };

/**
 * Checks if at least one tag of sSourceTypes matches with one of sTargetTypes
 *
 * @param {string} sSourceTypes ' '-separated list of types
 * @param {string} sTargetTypes ' '-separated list of types
 * @return {boolean} true if type of sSourceType matches with one of sTargetTypes
 */
UCF_DragAndDropManager["prototype"]["bGetTypeMatch"] = function(sSourceTypes, sTargetTypes) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["bGetTypeMatch"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTargetTypes) === "string", "typeof(sTargetTypes) === \"string\"", "DragAndDropManager.js(1544): bGetTypeMatch"); };

	var aSourceTypes = sSourceTypes["split"](this["TAG_MATCHING"]["SEPERATOR"]);
	var aTargetTypes = sTargetTypes["split"](this["TAG_MATCHING"]["SEPERATOR"]);
	for (var i = 0; i < aSourceTypes["length"]; i++) {
		var sSourceType = aSourceTypes[i];
		if (sSourceType == "Text" || sSourceType == "text") {
			sSourceType = "text/plain";
		}
		for (var j = 0; j < aTargetTypes["length"]; j++) {
			var sTargetType = aTargetTypes[j];
			if (sSourceType == sTargetType) {
				return true;
			}
		}
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["bGetTypeMatch"] = 0; };

/**
 * Checks if at least one tag of sSourceTags matches with one of sTargetTags
 *
 * @param {string} sSourceTags ' '-separated list of tags
 * @param {string} sTargetTags ' '-separated list of tags
 * @return {booelan} true if at least one tag of sSourceTags matches with one of sTargetTags
 */
UCF_DragAndDropManager["prototype"]["bGetTagMatch"] = function(sSourceTags, sTargetTags) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["bGetTagMatch"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSourceTags) === "string", "typeof(sSourceTags) === \"string\"", "DragAndDropManager.js(1571): bGetTagMatch"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTargetTags) === "string", "typeof(sTargetTags) === \"string\"", "DragAndDropManager.js(1572): bGetTagMatch"); };

	var aSourceTags = sSourceTags["split"](this["TAG_MATCHING"]["SEPERATOR"]);
	var aTargetTags = sTargetTags["split"](this["TAG_MATCHING"]["SEPERATOR"]);
	for (var i = 0; i < aSourceTags["length"]; i++) {
		var sSourceTag = aSourceTags[i];
		for (var j = 0; j < aTargetTags["length"]; j++) {
			var sTargetTag = aTargetTags[j];
			if (this["bGetSingleTagMatch"](sSourceTag, sTargetTag)) {
				//_trace(INFO,"SourceTag :" + sSourceTag + " TargetTag : " + sTargetTag);
				return true;
			}
		}
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["bGetTagMatch"] = 0; };
/**
 * determines if two strings equal match using * as wildcard
 * @param {string} sSourceTag
 * @param {string} sTargetTag
 *
 * @return {boolean} true, if strings match
 */
UCF_DragAndDropManager["prototype"]["bGetSingleTagMatch"] = function(sSourceTag, sTargetTag) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["bGetSingleTagMatch"]++; }; 
	var iBase = -1;
	var iWildcard = sSourceTag["indexOf"](this["TAG_MATCHING"]["WILDCARD"]);

	if (iWildcard !== -1) {
		iBase = iWildcard;
	}

	iWildcard = sTargetTag["indexOf"](this["TAG_MATCHING"]["WILDCARD"]);

	if (iWildcard !== -1) {
		if (iBase === -1) iBase = iWildcard;
		else iBase = Math["min"](iBase, iWildcard);

	}

	if (iBase !== -1) {
		sSourceTag = sSourceTag["substr"](0, iBase);
		sTargetTag = sTargetTag["substr"](0, iBase);
	}

	return sSourceTag == sTargetTag;

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["bGetSingleTagMatch"] = 0; };

/**
 * Handles the standard drag and drop appearance
 *
 * @param {string} sDragSourceId
 * @param {string} sDragTags
 * @param {object} eDragType
 * @param {object} oDragDecoration
 * @param {object} oGhost
 * @param {string} sHint
 *
 * @return {object} drag session
 **/
UCF_DragAndDropManager["prototype"]["startDragSession"] = function(sDragSourceId, sDragTags, eDragType, oDragDecoration, oGhost, sHint) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["startDragSession"]++; }; 

	this["oDragSession"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragSession"))(this["iMouseButtonState"]);
	UCF_DomUtil["oGetTopWindow"]()["oDragSession"] = this["oDragSession"];

	this["oDragSession"]["sDragSourceId"] = sDragSourceId;
	this["oDragSession"]["eDragType"] = eDragType;
	this["oDragSession"]["sHint"] = sHint;

	// stop selection in chrome during dragsession .. reactivate in finishDragSession
	if (!this["bBodyNoUserSelect"] && (UCF_UserAgent["bIsChromium"]() || UCF_UserAgent["bIsSafari"]() || UCF_UserAgent["bIsGecko"]())) UCF_DomUtil["addClass"](document["body"], "urNoUserSelect");
	UCF_DomUtil["removeSelection"]();

	switch (eDragType) {
		case UCF_DragSession["DRAG_TYPE"]["STANDARD"]:
			this["oDragSession"]["sDragTags"] = sDragTags;
			this["setDropEnabledCursor"](UCF_DragSession["E_CURSOR"]["ALLOWED"]);
			break;
		case UCF_DragSession["DRAG_TYPE"]["H_RESIZE"]:
			this["setDropEnabledCursor"](UCF_DragSession["E_CURSOR"]["H_RESIZE"]);
			break;
		case UCF_DragSession["DRAG_TYPE"]["V_RESIZE"]:
			this["setDropEnabledCursor"](UCF_DragSession["E_CURSOR"]["V_RESIZE"]);
			break;
	}

	if (oDragDecoration) {
		if (this["oDragDecoration"]) this["oDragDecoration"]["cleanUp"]();
		this["oDragDecoration"] = oDragDecoration;
		this["oDragDecoration"]["init"](this["oDragSession"]);
	}

	if (!this["bBrowserDragDrop"] && oGhost) {

		this["oGhost"] = oGhost;
		this["oGhost"]["create"](document["body"]);

		this["oDragSession"]["setGhostHTML"](this["oGhost"]["oDomRef"]["innerHTML"]);
		this["oDragSession"]["oGhost"] = this["oGhost"];

		if (!this["oGhost"]["bHasOffsetSet"]()) {

			//automatically calculate offset
			var oDragFragmentRect = UCF_DomUtil["oGetObjectRect"](UCF_DomUtil["$"](sDragSourceId));
			//UCF_DomUtil.oGetObjectRect return undefined values for SVG
			if (typeof(oDragFragmentRect["top"]) === "number" && typeof(oDragFragmentRect["left"]) === "number" && typeof(oDragFragmentRect["width"]) === "number" && typeof(oDragFragmentRect["height"]) === "number") {
				if (window["UCF_System"]["bIsRTL"]) {
					this["oGhost"]["setOffset"](-oDragFragmentRect["left"] - oDragFragmentRect["width"] + this["iDragStartX"], oDragFragmentRect["top"] - this["iDragStartY"]);
				} else {
					this["oGhost"]["setOffset"](oDragFragmentRect["left"] - this["iDragStartX"], oDragFragmentRect["top"] - this["iDragStartY"]);
				}
			}
		}
	}

	return this["oDragSession"];
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["startDragSession"] = 0; };

/**
 * @return {E_DRAGSTATE } the current drag state
 */
UCF_DragAndDropManager["prototype"]["eGetDragState"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["eGetDragState"]++; }; 
	return this["eDragState"];
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["eGetDragState"] = 0; };

UCF_DragAndDropManager["prototype"]["setDragState"] = function(eDragState, bTriggeredByTouchInteraction) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["setDragState"]++; }; 

	if (this["eDragState"] == eDragState) return;

	this["eDragState"] = eDragState;

	if (eDragState == this["E_DRAGSTATE"]["Drag"] || eDragState == this["E_DRAGSTATE"]["DropPending"]) {
		// Focus blur before locking browserWindow ... see scrollBar
		if (!bTriggeredByTouchInteraction) UCF_DomUtil["blurActiveElement"](true);
		this["oBrowserWindow"]["lock"](UCF_BrowserWindow["LOCKTYPES"]["DRAGDROP"]);
	} else {
		this["oBrowserWindow"]["unlock"](UCF_BrowserWindow["LOCKTYPES"]["DRAGDROP"]);
	}

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["setDragState"] = 0; };

/**
 * sets the dragData of the dragSession
 * @param {string} sDragData
 * @param {string} sMimeType
 * @param {string} sDragSessionId
 */
UCF_DragAndDropManager["prototype"]["setDragData"] = function(sDragData, sMimeType, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["setDragData"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragData) === "string", "typeof(sDragData) === \"string\"", "DragAndDropManager.js(1721): setDragData"); };
	//_assert(typeof(sDragSessionId) == "string");
	if (!this["oDragSession"]) return;

	//temporary: no dragsessionid is ok (else do the check)
	if (sDragSessionId && sDragSessionId != this["oDragSession"]["sId"]) return; //simply ignore outdated dragsession information
	this["oDragSession"]["setDragData"](sDragData, sMimeType);

	//if UI was locked the session must be finished here
	if (this["oDragSession"]["bDropPending"]) {
		this["finishDragSession"]();
	}

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["setDragData"] = 0; };

UCF_DragAndDropManager["prototype"]["cancelTimedEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["cancelTimedEvents"]++; }; 

	if (this["sDelayedHoverCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sDelayedHoverCallId"]);
		this["sDelayedHoverCallId"] = null;
	}

	this["cleanUpDragSroll"]();
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["cancelTimedEvents"] = 0; };

/**
 * Handle drag scroll event.
 * TODO: move this into the page control
 * when WD JAVA has finished transition
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_DragAndDropManager["prototype"]["handleDragScroll"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["handleDragScroll"]++; }; 
	var oMouseLocation = {
			"x": oBrowserEvent["iClientX"](),
			"y": oBrowserEvent["iClientY"]()
		},
		oViewPort = UCF_DomUtil["oGetInnerSize"](window),
		oScrollOffset = UCF_DomUtil["oGetScrollOffset"](window);

	oViewPort["left"] = 0;
	oViewPort["top"] = 0;

	var iVerticalZone = Math["min"](35, oViewPort["height"] / 4),
		iHorizontalZone = Math["min"](35, oViewPort["width"] / 4),
		iScrollThresholdTop = oViewPort["top"] + iVerticalZone,
		iScrollThresholdBottom = oViewPort["top"] + oViewPort["height"] - iVerticalZone,
		iScrollThresholdLeft = oViewPort["left"] + iHorizontalZone,
		iScrollThresholdRight = oViewPort["left"] + oViewPort["width"] - iHorizontalZone,
		iStepY = 0,
		iStepX = 0;

	if (oMouseLocation["x"] < iScrollThresholdLeft) {
		iStepX = -Math["round"]((iScrollThresholdLeft - oMouseLocation["x"]) / iHorizontalZone * 10);
	} else if (oMouseLocation["x"] > iScrollThresholdRight) {
		iStepX = Math["round"]((oMouseLocation["x"] - iScrollThresholdRight) / iHorizontalZone * 10);
	}

	if (oMouseLocation["y"] < iScrollThresholdTop) {
		iStepY = -Math["round"]((iScrollThresholdTop - oMouseLocation["y"]) / iVerticalZone * 10);
	} else if (oMouseLocation["y"] > iScrollThresholdBottom) {
		iStepY = Math["round"]((oMouseLocation["y"] - iScrollThresholdBottom) / iVerticalZone * 10);
	}

	if (this["iCurrentStepX"] < iStepX) this["iCurrentStepX"]++;
	else if (this["iCurrentStepX"] > iStepX) this["iCurrentStepX"]--;

	if (this["iCurrentStepY"] < iStepY) this["iCurrentStepY"]++;
	else if (this["iCurrentStepY"] > iStepY) this["iCurrentStepY"]--;

	oScrollOffset = UCF_DomUtil["oGetScrollOffset"](window);

	//don't enlarge the document
	if (oScrollOffset["y"] >= this["oScrollRange"]["height"]) this["iCurrentStepY"] = Math["min"](this["iCurrentStepY"], 0);

	if (oScrollOffset["x"] >= this["oScrollRange"]["width"]) this["iCurrentStepX"] = Math["min"](this["iCurrentStepX"], 0);

	window["scrollBy"](this["iCurrentStepX"], this["iCurrentStepY"]);
	if (this["iCurrentStepX"] !== 0 || this["iCurrentStepY"] !== 0) {
		this["updateGhostAndDecorators"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["handleDragScroll"] = 0; };

/**
 * updates the position of ghost and decorators
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 *
 */
UCF_DragAndDropManager["prototype"]["updateGhostAndDecorators"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["updateGhostAndDecorators"]++; }; 
	//update UI
	if (this["oDragDecoration"]) {
		this["oDragDecoration"]["update"](oBrowserEvent);
	}
	if (this["oGhost"]) {
		this["oGhost"]["update"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["updateGhostAndDecorators"] = 0; };

UCF_DragAndDropManager["prototype"]["sGetDragSession"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["sGetDragSession"]++; }; 

	if (!this["oDragSession"]) return null;

	return UCF_DragAndDropManager["asString"](this["oDragSession"]);

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["sGetDragSession"] = 0; };

UCF_DragAndDropManager["asString"] = function(oObject) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["asString"]++; }; 

	var sString = "{";
	for (var oProperty in oObject) {
		var sType = typeof(oObject[oProperty]);
		if (sType == "string" || sType == "number") {
			sString += oProperty + ":'" + oObject[oProperty] + "',";
		}
	}

	if (sString["lastIndexOf"](",") !== -1) sString = sString["substring"](0, sString["lastIndexOf"](","));

	sString += "}";

	return sString;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["asString"] = 0; };

UCF_DragAndDropManager["prototype"]["sCreateDragSession"] = function(sDragSessionData) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["sCreateDragSession"]++; }; 

	var oData = null;

	if (typeof(sDragSessionData) == "object") {
		oData = sDragSessionData;
	} else {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionData) === "string", "typeof(sDragSessionData) === \"string\"", "DragAndDropManager.js(1852): sCreateDragSession"); };
		// oData = eval('oData = ' + sDragSessionData); //eslint-disable-line no-eval
		oData = UCF_JsUtil["oJsonParse"](sDragSessionData);
	}

	var sControlId = oData["sControlId"],
		sTags = oData["sDragTags"],
		sDragData = oData["sDragData"],
		sMimeType = oData["sMimeType"],
		sGhostHtml = oData["sGhostHtml"],
		bSubscribeDragEvents = oData["bSubscribeDragEvents"],
		oGhost = null;

	if (sGhostHtml) {
		var oDiv = document["createElement"]("DIV");
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](oDiv, sGhostHtml);
		document["body"]["appendChild"](oDiv);
		oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv);
		oGhost["setOffset"](0, 0);
	}

	var oDragSession = this["oCreateDragSession"](sControlId, sTags, oGhost);
	oDragSession["setDragData"](sDragData, sMimeType);
	if (bSubscribeDragEvents) oDragSession["setSubscribeDragEvents"](bSubscribeDragEvents);

	return oDragSession["sId"];
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["sCreateDragSession"] = 0; };

UCF_DragAndDropManager["prototype"]["destroyDragSession"] = function(sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["destroyDragSession"]++; }; 

	if (this["oDragSession"] && this["oDragSession"]["sId"] == sDragSessionId) this["finishDragSession"]();

};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["destroyDragSession"] = 0; };

UCF_DragAndDropManager["prototype"]["oCreateDragSession"] = function(sDragSourceId, sDragTags, oGhost) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["oCreateDragSession"]++; }; 

	this["iMouseButtonState"] = 1;

	this["oDragSession"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragSession"))(this["iMouseButtonState"]);
	UCF_DomUtil["oGetTopWindow"]()["oDragSession"] = this["oDragSession"];

	this["sDragSourceId"] = sDragSourceId;
	this["setDragState"](this["E_DRAGSTATE"]["Drag"]);

	// attach mousemove lazy, because of performance reasons
	this["bMouseListenerAttached"] = true;
	this["oBrowserWindow"]["attachBrowserEvent"]("mousemove", document);
	this["oBrowserWindow"]["attachBrowserEvent"]("mouseup", document);
	this["oBrowserWindow"]["attachBrowserEvent"]("mousedown", document);
	this["oBrowserWindow"]["attachBrowserEvent"]("dragend", document);
	this["oBrowserWindow"]["attachBrowserEvent"]("drop", document);

	this["startDragSession"](sDragSourceId, sDragTags, UCF_DragSession["DRAG_TYPE"]["STANDARD"], null, oGhost, null);

	return this["oDragSession"];
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["oCreateDragSession"] = 0; };

UCF_DragAndDropManager["prototype"]["setPage"] = function(oPage) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["setPage"]++; }; 
	this["oPage"] = oPage;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["setPage"] = 0; };

UCF_DragAndDropManager["prototype"]["setDragImage"] = function(oBrowserEvent, oDomRef) {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["setDragImage"]++; }; 
	if (oBrowserEvent["oDomEvent"]["type"] != "dragstart" || !oBrowserEvent["oDomEvent"]["dataTransfer"]["setDragImage"]) return;
	//set DragImage
	this["oDragImage"] = oDomRef;
	this["oDragImage"]["style"]["position"] = "absolute";
	this["oDragImage"]["style"]["zIndex"] = "-10";
	this["oDragImage"]["style"]["left"] = oBrowserEvent["iClientX"]() + "px";
	this["oDragImage"]["style"]["top"] = oBrowserEvent["iClientY"]() + "px";
	document["body"]["appendChild"](this["oDragImage"]);
	oBrowserEvent["oDomEvent"]["dataTransfer"]["setDragImage"](this["oDragImage"], 0, 0);
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["setDragImage"] = 0; };

/**
 *
 */
UCF_DragAndDropManager["prototype"]["cleanupDragImage"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["cleanupDragImage"]++; }; 
	document["body"]["removeChild"](this["oDragImage"]);
	this["oDragImage"] = null;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["cleanupDragImage"] = 0; };

/**
 *
 */
UCF_DragAndDropManager["prototype"]["activateSelectionMode"] = function() {;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["activateSelectionMode"]++; }; 
	this["bSelectionMode"] = true;
};;if (__UCF_COVERAGE__) { UCF_DragAndDropManager["_"]["activateSelectionMode"] = 0; };

};
sap["ls"]["preload"]["UCF_DragDelegate"] = function() {/* global _trace, DEBUG */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_DragSession */
/// <reference path="./DragSession.js"/>
/* global UCF_HTMLGhost */
/// <reference path="./HTMLGhost.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>

/**
 * @class
 * 
 */
function UCF_DragDelegate(oLS) {if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["UCF_DragDelegate"]++; }; 
	this["oLS"] = oLS;
	this["oDragSourceControl"] = null;

};window["UCF_DragDelegate"] = UCF_DragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DragDelegate"); UCF_DragDelegate["_"] = {UCF_DragDelegate: 0}; }; ;
UCF_DragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_DragDelegate.prototype["sClassName"] = "UCF_DragDelegate";

/**
 * destructor
 */
UCF_DragDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["destroy"]++; }; 
	this["oDragSourceControl"] = null;
	this["oLS"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["destroy"] = 0; };

/**
 *
 */
UCF_DragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["oGetGhost"]++; }; 
	var oDiv = document["createElement"]("DIV"),
		oTemp = document["createElement"]("DIV");

	oTemp["appendChild"](this["oDragSourceControl"]["oDomRef"]["cloneNode"](true));

	//direct cloning can cause errors because of attached events
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oDiv, oTemp["innerHTML"]);

	return new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv);

};;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["oGetGhost"] = 0; };
/**
 *
 */
UCF_DragDelegate["prototype"]["setDragSourceControl"] = function(oDragSourceControl) {;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["setDragSourceControl"]++; }; 
	this["oDragSourceControl"] = oDragSourceControl;
};;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["setDragSourceControl"] = 0; };
/**
 *
 */
UCF_DragDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["onlsdragstart"]++; }; 
	//	debugger;
	//	_trace(INFO,"dragstart");

	var oDragSourceControl = this["oGetDragSourceControl"](oBrowserEvent);

	var sDragSourceInfoId = this["oGetDragSourceInfoId"](oBrowserEvent);
	if (!sDragSourceInfoId) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No drag session started: No sDragSourceInfo", "DragDelegate.js(65): onlsdragstart"); };
		return;
	}

	var oDragSourceInfoControl = oDragSourceControl["oGetControlById"](sDragSourceInfoId);
	if (!oDragSourceInfoControl) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No drag session started: No control found for sDragSourceInfoId=" + sDragSourceInfoId, "DragDelegate.js(71): onlsdragstart"); };
		return;
	}

	//ignore lsdragstart event for dragSources using browserDragDrop
	if (oDragSourceInfoControl["bBrowserDragDrop"]) return;

	var sTags = oDragSourceInfoControl["sGetTags"]();
	if (!sTags) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No drag session started: No tags on drag source info", "DragDelegate.js(80): onlsdragstart"); };
		return;
	}

	if (!this["bIsDragPossible"](oBrowserEvent)) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No drag session started: bIsDragPossible returned false", "DragDelegate.js(85): onlsdragstart"); };
		return;
	}

	//	var oDragAndDropManager = oBrowserEvent.oDragAndDropManager,
	var oDragAndDropManager = oDragSourceControl["oLS"]["oBrowserWindow"]["oDragAndDropManager"],
		oDragSession = oDragAndDropManager["startDragSession"](oDragSourceControl["sId"], sTags, UCF_DragSession["DRAG_TYPE"]["STANDARD"], null, this["oGetGhost"](oBrowserEvent), oDragSourceInfoControl["sHint"]);

	//set dragSource
	oDragSession["oSetDragSource"](oDragSourceControl["oDomRef"]);

	//if Drag-Event is registered
	if (oDragSourceControl["mEvents"]["Drag"]) {
		oDragSourceControl["fireDrag"](oDragSourceControl["sId"], sDragSourceInfoId, oDragSession["sId"]);
	}

	//if DataAccess is registered
	if (oDragSourceInfoControl["mEvents"]["DataAccess"]) {
		//use mime type from drag source info
		//server can override it with a non-null value
		oDragSession["sMimeType"] = oDragSourceInfoControl["sGetMimeType"]();

		oDragSourceInfoControl["fireDataAccess"](sDragSourceInfoId, oDragSourceControl["sId"], oDragSession["sId"]);

	} else {
		//use data from drag source info control
		oDragSession["setDragData"](oDragSourceInfoControl["sGetData"](), oDragSourceInfoControl["sGetMimeType"]());
	}

	oBrowserEvent["bHandled"] = true;
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["onlsdragstart"] = 0; };

UCF_DragDelegate["prototype"]["ondragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["ondragstart"]++; }; 

	var oDragSourceControl = this["oGetDragSourceControl"](oBrowserEvent),
		oDragAndDropManager = oDragSourceControl["oLS"]["oBrowserWindow"]["oDragAndDropManager"];

	var sDragSourceInfoId = this["oGetDragSourceInfoId"](oBrowserEvent);

	if (!sDragSourceInfoId) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No drag session started: No sDragSourceInfo", "DragDelegate.js(127): ondragstart"); };
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oDragAndDropManager["setDragState"](oDragAndDropManager["E_DRAGSTATE"]["NoDrag"]);
		return;
	}

	var oDragSourceInfoControl = oDragSourceControl["oGetControlById"](sDragSourceInfoId);
	if (!oDragSourceInfoControl) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No drag session started: No control found for sDragSourceInfoId=" + sDragSourceInfoId, "DragDelegate.js(136): ondragstart"); };
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oDragAndDropManager["setDragState"](oDragAndDropManager["E_DRAGSTATE"]["NoDrag"]);
		return;
	}

	var sTags = oDragSourceInfoControl["sGetTags"]();
	if (!sTags) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oDragAndDropManager["setDragState"](oDragAndDropManager["E_DRAGSTATE"]["NoDrag"]);
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No drag session started: No tags on drag source info", "DragDelegate.js(148): ondragstart"); };
		return;
	}

	if (!this["bIsDragPossible"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oDragAndDropManager["setDragState"](oDragAndDropManager["E_DRAGSTATE"]["NoDrag"]);
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No drag session started: bIsDragPossible returned false", "DragDelegate.js(156): ondragstart"); };
		return;
	}

	var oDragSession = oDragAndDropManager["startDragSession"](oDragSourceControl["sId"], sTags, UCF_DragSession["DRAG_TYPE"]["STANDARD"], null, this["oGetGhost"](oBrowserEvent), oDragSourceInfoControl["sHint"]);

	//set dragSource
	oDragSession["oSetDragSource"](oDragSourceControl["oDomRef"]);

	//if Drag-Event is registered
	if (oDragSourceControl["mEvents"]["Drag"]) {
		oDragSourceControl["fireDrag"](oDragSourceControl["sId"], sDragSourceInfoId, oDragSession["sId"]);
	}

	//if DataAccess is registered
	if (oDragSourceInfoControl["mEvents"]["DataAccess"]) {
		//use mime type from drag source info
		//server can override it with a non-null value
		oDragSession["sMimeType"] = oDragSourceInfoControl["sGetMimeType"]();

		oDragSourceInfoControl["fireDataAccess"](sDragSourceInfoId, oDragSourceControl["sId"], oDragSession["sId"]);

	} else {
		//use data from drag source info control
		oDragSession["setDragData"](oDragSourceInfoControl["sGetData"](), oDragSourceInfoControl["sGetMimeType"]());
	}

	oBrowserEvent["bHandled"] = true;
	oBrowserEvent["cancelBubble"]();

	//browser dragstart event
	//ie accepts boths values 'text' as well as 'url'
	var sSourceMimeType = oDragSourceInfoControl["sGetMimeType"]();
	if (sSourceMimeType == "text/plain" || sSourceMimeType == "Text") {
		sSourceMimeType = "text";
	}
	//set effectAllowed to make it work for visbiz
	oBrowserEvent["oDomEvent"]["dataTransfer"]["effectAllowed"] = 'move';
	oBrowserEvent["oDomEvent"]["dataTransfer"]["setData"](sSourceMimeType, oDragSourceInfoControl["sGetData"]());
	oDragAndDropManager["oDragSession"]["setSubscribeDragEvents"](true);

	//set DragImage
	//oDragAndDropManager.setDragImage(oBrowserEvent, this.oGetGhost(oBrowserEvent).oGhostRef);

};;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["ondragstart"] = 0; };

/**
 * default implementation - may be overridden
 * @return true if dragging is allowed
 * @type boolean
 */
UCF_DragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["bIsDragPossible"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["bIsDragPossible"] = 0; };
/**
 * default implementation - may be overridden
 * @return the drag source control
 * @type UCF_Control
 *
 */
UCF_DragDelegate["prototype"]["oGetDragSourceControl"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["oGetDragSourceControl"]++; }; 

	return this["oDragSourceControl"];

};;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["oGetDragSourceControl"] = 0; };

/**
 * default implementation - may be overridden
 * @return the id of the dragSourceInfo control
 * @type string
 *
 */
UCF_DragDelegate["prototype"]["oGetDragSourceInfoId"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["oGetDragSourceInfoId"]++; }; 

	var oDragSourceControl = this["oGetDragSourceControl"](oBrowserEvent);
	if (oDragSourceControl) {
		return oDragSourceControl["sDragSourceInfo"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DragDelegate["_"]["oGetDragSourceInfoId"] = 0; };


};
sap["ls"]["preload"]["UCF_DragDropDecoration"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./DragSession.js"/>

/**
 * @class
 * Class DragDropInfo
 *
 * Implements the object which contains data and functions needed for Drag and Drop operations
 *
 * 
 *
 * @version
 * @param {UCF_LS} oLS
 * @param {HTMLElement} oDomRefAffectedElement
 * @param {Object} oBoundaries
 */
function UCF_DragDropDecoration(oLS, oDomRefAffectedElement, oBoundaries) {if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["UCF_DragDropDecoration"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefAffectedElement != null, "oDomRefAffectedElement != null", "DragDropDecoration.js(28): UCF_DragDropDecoration"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBoundaries != null, "oBoundaries != null", "DragDropDecoration.js(29): UCF_DragDropDecoration"); };

	this["oLS"] = oLS;
	this["oBoundaries"] = oBoundaries;
	this["oCleanBoundaries"] = null;

	this["oDomRefAffectedElement"] = oDomRefAffectedElement;
	this["oReferenceContainer"] = null;
	this["oReferenceRect"] = null;

	this["iArrowOffset"] = 0;
	this["aRaster"] = null;
	this["bIsDragDecoration"] = false;
	this["bIsInsert"] = false;
	this["bIsVertical"] = false;
	this["bIsLine"] = false;
	this["iHtmlPosTop"] = -10000;
	this["iHtmlPosLeft"] = 100;

	this["bDebugMode"] = false;
	this["bHiddenMode"] = false;

};window["UCF_DragDropDecoration"] = UCF_DragDropDecoration; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DragDropDecoration"); UCF_DragDropDecoration["_"] = {UCF_DragDropDecoration: 0}; }; ;
UCF_DragDropDecoration["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_DragDropDecoration.prototype["sClassName"] = "UCF_DragDropDecoration";

/**
 * Destructor
 */
UCF_DragDropDecoration["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["destroy"]++; }; 

	this["oBoundaries"] = null;
	this["oCleanBoundaries"] = null;
	this["oDomRefAffectedElement"] = null;
	this["oReferenceContainer"] = null;
	this["oReferenceRect"] = null;
	this["iArrowOffset"] = 0;
	this["aRaster"] = null;
	this["bIsDragDecoration"] = false;
	this["iHtmlPosTop"] = 0;
	this["iHtmlPosLeft"] = 0;
	this["bHiddenMode"] = false;
	this["oDragSession"] = null;
	this["oDomRefLine"] = null;
	this["oDomRefArrow"] = null;
	this["oDomRefBRect"] = null;
	this["oCurrentRasterPoint"] = null;

	this["oLS"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["destroy"] = 0; };

UCF_DragDropDecoration["prototype"]["init"] = function (oDragSession) {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["init"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDragSession instanceof UCF_DragSession, "oDragSession instanceof UCF_DragSession", "DragDropDecoration.js(82): init"); };
	this["oDragSession"] = oDragSession;

	this["bIsDragDecoration"] = (this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["H_RESIZE"] || this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["V_RESIZE"]);

	if (this["oDragSession"]["eDropType"] == UCF_DragSession["DROP_TYPE"]["H_INSERT"] || this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["H_RESIZE"]) {
		this["bIsVertical"] = false;
		this["bIsLine"] = true;
		if (this["oDragSession"]["eDropType"] == UCF_DragSession["DROP_TYPE"]["H_INSERT"]) this["bIsInsert"] = true;
	} else if (this["oDragSession"]["eDropType"] == UCF_DragSession["DROP_TYPE"]["V_INSERT"] || this["oDragSession"]["eDragType"] == UCF_DragSession["DRAG_TYPE"]["V_RESIZE"]) {
		this["bIsVertical"] = true;
		this["bIsLine"] = true;
		if (this["oDragSession"]["eDropType"] == UCF_DragSession["DROP_TYPE"]["V_INSERT"]) this["bIsInsert"] = true;
	}

	this["oCleanBoundaries"] = {
		"top": this["oBoundaries"]["top"],
		"left": this["oBoundaries"]["left"],
		"width": this["oBoundaries"]["width"],
		"height": this["oBoundaries"]["height"]
	};

	this["createHtml"]();
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["init"] = 0; };

UCF_DragDropDecoration["prototype"]["cleanUp"] = function () {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["cleanUp"]++; }; 
	UCF_DomUtil["removeFromDom"](this["oDomRefLine"]);
	this["oDomRefLine"] = null;

	UCF_DomUtil["removeFromDom"](this["oDomRefArrow"]);
	this["oDomRefArrow"] = null;

	if (this["bDebugMode"]) {
		UCF_DomUtil["removeFromDom"](this["oDomRefBRect"]);
		this["oDomRefBRect"] = null;
	}

	this["oBoundaries"] = null;
	this["oCleanBoundaries"] = null;

	this["oReferenceContainer"] = null;
	this["oReferenceRect"] = null;

	this["oDomRefAffectedElement"] = null;

	this["aRaster"] = null;
	this["oDragSession"] = null;
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["cleanUp"] = 0; };

UCF_DragDropDecoration["prototype"]["setArrowOffset"] = function (iArrowOffset) {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["setArrowOffset"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (iArrowOffset) == "number", "typeof (iArrowOffset) == \"number\"", "DragDropDecoration.js(132): setArrowOffset"); };
	this["iArrowOffset"] = iArrowOffset;
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["setArrowOffset"] = 0; };

UCF_DragDropDecoration["prototype"]["setHiddenMode"] = function (bHiddenMode) {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["setHiddenMode"]++; }; 
	this["bHiddenMode"] = bHiddenMode;
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["setHiddenMode"] = 0; };

UCF_DragDropDecoration["prototype"]["addRasterPoint"] = function (iOffset, iSnapRange, oRasterPointData) {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["addRasterPoint"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (iOffset) == "number", "typeof (iOffset) == \"number\"", "DragDropDecoration.js(141): addRasterPoint"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (iSnapRange) == "number", "typeof (iSnapRange) == \"number\"", "DragDropDecoration.js(142): addRasterPoint"); };

	if (!this["aRaster"]) this["aRaster"] = new Array();
	if (!oRasterPointData) oRasterPointData = {};
	oRasterPointData["iOffset"] = iOffset;
	oRasterPointData["iSnapRange"] = iSnapRange;
	this["aRaster"][this["aRaster"]["length"]] = oRasterPointData;
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["addRasterPoint"] = 0; };

UCF_DragDropDecoration["prototype"]["oGetRasterPoint"] = function () {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["oGetRasterPoint"]++; }; 
	return this["oCurrentRasterPoint"];
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["oGetRasterPoint"] = 0; };

UCF_DragDropDecoration["prototype"]["createHtml"] = function () {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["createHtml"]++; }; 
	if (this["bHiddenMode"]) return;

	var oDomRefLine = null;

	if (this["bIsLine"]) {
		var sBorderStyle = "1px solid gray";
		var sLineSize = "3px";

		oDomRefLine = this["oDomRefLine"] ? this["oDomRefLine"] : document["createElement"]("DIV");

		oDomRefLine["className"] = "urBorderBox";

		oDomRefLine["style"]["position"] = "absolute";
		oDomRefLine["style"]["zIndex"] = 100000;
		oDomRefLine["style"]["textAlign"] = "center";
		oDomRefLine["style"]["verticalAlign"] = "middle";
		oDomRefLine["style"]["fontSize"] = "1px";
		UCF_DomUtil["setOpacityStyle"](oDomRefLine, 60);

		if (this["bIsInsert"]) {
			var oDomRefArrow = this["oDomRefArrow"] ? this["oDomRefArrow"] : document["createElement"]("DIV");
			oDomRefArrow["style"]["position"] = "absolute";
			oDomRefArrow["style"]["zIndex"] = 100000;
			oDomRefArrow["style"]["backgroundRepeat"] = "no-repeat";
			oDomRefArrow["style"]["backgroundPosition"] = "top left";
			oDomRefArrow["style"]["width"] = "12px";
			oDomRefArrow["style"]["height"] = "12px";
			oDomRefArrow["style"]["overflow"] = "hidden";

			if (this["bIsVertical"]) {
				if (window["UCF_System"]["bIsRTL"]) {
					oDomRefArrow["className"] = "urDDDecoRight urBorderBox";
					oDomRefArrow["style"]["backgroundPosition"] = "top right";
				} else {
					oDomRefArrow["className"] = "urDDDecoLeft urBorderBox";
				}

			} else {
				oDomRefArrow["className"] = "urDDDecoTop urBorderBox";
			}

			this["oDomRefArrow"] = oDomRefArrow;

			if (!oDomRefArrow["parentNode"]) {
				this["addToDom"](oDomRefArrow);
			}
		}

		oDomRefLine["style"]["backgroundColor"] = "black";
		UCF_DomUtil["addClass"](oDomRefLine, 'lsDragDrop--decorator-line');

		if (this["bIsVertical"]) {
			oDomRefLine["style"]["borderTop"] = sBorderStyle;
			oDomRefLine["style"]["borderBottom"] = sBorderStyle;
			oDomRefLine["style"]["width"] = this["oCleanBoundaries"]["width"] + "px";
			oDomRefLine["style"]["height"] = sLineSize;
		} else {
			oDomRefLine["style"]["borderLeft"] = sBorderStyle;
			oDomRefLine["style"]["borderRight"] = sBorderStyle;
			oDomRefLine["style"]["width"] = sLineSize;
			oDomRefLine["style"]["height"] = this["oCleanBoundaries"]["height"] + "px";
		}

		if (!oDomRefLine["parentNode"]) {
			this["addToDom"](oDomRefLine);
		}
	}

	if (this["bDebugMode"]) {
		if (!this["oDomRefBRect"]) {
			this["oDomRefBRect"] = document["createElement"]("DIV");
			this["addToDom"](this["oDomRefBRect"]);
		}

		this["oDomRefBRect"]["style"]["position"] = "absolute";
		this["oDomRefBRect"]["style"]["zIndex"] = 100000;
		this["oDomRefBRect"]["style"]["border"] = "1px solid red";
		this["oDomRefBRect"]["style"]["top"] = this["oCleanBoundaries"]["top"] + "px";
		this["oDomRefBRect"]["style"]["left"] = this["oCleanBoundaries"]["left"] + "px";
		this["oDomRefBRect"]["style"]["width"] = this["oCleanBoundaries"]["width"] + "px";
		this["oDomRefBRect"]["style"]["height"] = this["oCleanBoundaries"]["height"] + "px";
	}

	if (oDomRefLine !== this["oDomRefLine"]) {
		this["oDomRefLine"] = oDomRefLine;
		this["hide"]();
	}
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["createHtml"] = 0; };

UCF_DragDropDecoration["prototype"]["hide"] = function () {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["hide"]++; }; 
	if (this["bHiddenMode"]) return;

	if (this["oDomRefLine"]) {
		this["oDomRefLine"]["style"]["top"] = "-10000px";
		this["oDomRefLine"]["style"]["left"] = "100px";
	}

	if (this["oDomRefArrow"]) {
		this["oDomRefArrow"]["style"]["top"] = "-10000px";
		this["oDomRefArrow"]["style"]["left"] = "100px";
	}
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["hide"] = 0; };

UCF_DragDropDecoration["prototype"]["show"] = function () {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["show"]++; }; 
	this["setHtmlPosition"](this["iHtmlPosTop"], this["iHtmlPosLeft"]);
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["show"] = 0; };

UCF_DragDropDecoration["prototype"]["setHtmlPosition"] = function (iTop, iLeft) {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["setHtmlPosition"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!isNaN(iTop), "!isNaN(iTop)", "DragDropDecoration.js(264): setHtmlPosition"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!isNaN(iLeft), "!isNaN(iLeft)", "DragDropDecoration.js(265): setHtmlPosition"); };

	if (this["bHiddenMode"]) return;

	var iTopOffset = 0,
		iLeftOffset = 0;

	this["iHtmlPosTop"] = iTop;
	this["iHtmlPosLeft"] = iLeft;

	if (this["bIsLine"]) {
		if (this["bIsVertical"]) iTopOffset = -1;
		else iLeftOffset = -1;
	}

	if (this["oDomRefLine"]) {
		this["oDomRefLine"]["style"]["top"] = (this["oCleanBoundaries"]["top"] + iTop + iTopOffset) + "px";

		if (window["UCF_System"]["bIsRTL"] && this["bIsVertical"]) {
			this["oDomRefLine"]["style"]["left"] = (this["oCleanBoundaries"]["left"] + iLeft + iLeftOffset - this["iArrowOffset"]) + "px";
		} else {
			this["oDomRefLine"]["style"]["left"] = (this["oCleanBoundaries"]["left"] + iLeft + iLeftOffset) + "px";
		}
	}

	if (this["oDomRefArrow"]) {
		if (this["bIsVertical"]) {

			if (window["UCF_System"]["bIsRTL"]) {
				iTopOffset = -6;
				iLeftOffset = this["oCleanBoundaries"]["width"] - 6 + iLeftOffset;

			} else {
				iTopOffset = -6;
				iLeftOffset = -10 - this["iArrowOffset"];
			}

		} else {
			iTopOffset = -10 - this["iArrowOffset"];
			iLeftOffset = -6;
		}
		this["oDomRefArrow"]["style"]["top"] = (parseInt(this["oCleanBoundaries"]["top"] + iTop + iTopOffset)) + "px";
		this["oDomRefArrow"]["style"]["left"] = (parseInt(this["oCleanBoundaries"]["left"] + iLeft + iLeftOffset)) + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["setHtmlPosition"] = 0; };

UCF_DragDropDecoration["prototype"]["oGetSnappedRasterPoint"] = function (iPos) {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["oGetSnappedRasterPoint"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!isNaN(iPos), "!isNaN(iPos)", "DragDropDecoration.js(312): oGetSnappedRasterPoint"); };

	if (this["aRaster"]) {
		var oRasterPoint, iDistance;
		for (var i = 0; i < this["aRaster"]["length"]; i++) {
			oRasterPoint = this["aRaster"][i];
			iDistance = Math["abs"](iPos - oRasterPoint["iOffset"]);
			if (iDistance <= oRasterPoint["iSnapRange"]) {
				return oRasterPoint;
			}
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["oGetSnappedRasterPoint"] = 0; };

UCF_DragDropDecoration["prototype"]["update"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["update"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "DragDropDecoration.js(328): update"); };

	var iTop = this["iGetPageY"](oBrowserEvent) - this["oCleanBoundaries"]["top"] - 2,
		iLeft = this["iGetPageX"](oBrowserEvent) - this["oCleanBoundaries"]["left"] - 2,
		bShow = false;

	iTop = Math["max"](0, iTop);
	iTop = Math["min"](this["oCleanBoundaries"]["height"], iTop);
	iLeft = Math["max"](0, iLeft);
	iLeft = Math["min"](this["oCleanBoundaries"]["width"], iLeft);

	if (this["bIsVertical"]) {
		iLeft = 0;
		if (this["aRaster"]) {
			this["oCurrentRasterPoint"] = this["oGetSnappedRasterPoint"](iTop);
			if (this["oCurrentRasterPoint"]) {
				iTop = this["oCurrentRasterPoint"]["iOffset"];
				bShow = true;
			}
		} else {
			bShow = true;
		}
	} else {
		iTop = 0;
		if (this["aRaster"]) {
			this["oCurrentRasterPoint"] = this["oGetSnappedRasterPoint"](iLeft);
			if (this["oCurrentRasterPoint"]) {
				iLeft = this["oCurrentRasterPoint"]["iOffset"] + (window["UCF_System"]["bIsRTL"] ? -2 : 0);
				bShow = true;
			}
		} else {
			bShow = true;
		}
	}

	if (bShow) this["setHtmlPosition"](iTop, iLeft);
	else this["hide"]();
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["update"] = 0; };

UCF_DragDropDecoration["prototype"]["bIsVisible"] = function () {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["bIsVisible"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["bIsVisible"] = 0; };

UCF_DragDropDecoration["prototype"]["addToDom"] = function (oDomRef) {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["addToDom"]++; }; 
	UCF_DomUtil["oAddLayeredElement"](oDomRef, this["oLS"]["oGetAssociatedAreaRef"](), this["oGetReferenceContainer"]());
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["addToDom"] = 0; };

UCF_DragDropDecoration["prototype"]["oGetReferenceContainer"] = function () {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["oGetReferenceContainer"]++; }; 
	if (!this["oReferenceContainer"]) {
		this["oReferenceContainer"] = UCF_DomUtil["oGetParentPositionReferenceContainer"](this["oDomRefAffectedElement"], true);
	}

	return this["oReferenceContainer"];
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["oGetReferenceContainer"] = 0; };

UCF_DragDropDecoration["prototype"]["oGetReferenceRect"] = function () {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["oGetReferenceRect"]++; }; 
	if (!this["oReferenceRect"]) {
		if (this["oGetReferenceContainer"]()) {
			this["oReferenceRect"] = UCF_DomUtil["oGetObjectRect"](this["oGetReferenceContainer"]());
		} else {
			this["oReferenceRect"] = { "top": 0, "left": 0, "width": 0, "height": 0 };
		}
	}

	return this["oReferenceRect"];
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["oGetReferenceRect"] = 0; };

UCF_DragDropDecoration["prototype"]["iGetPageX"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["iGetPageX"]++; }; 
	var iPageX = oBrowserEvent["iPageX"]() + (window["UCF_System"]["bIsRTL"] ? +3 : 0);

	if (this["oGetReferenceContainer"]()) {
		if (window["UCF_System"]["bIsRTL"]) iPageX -= UCF_DomUtil["iGetVerticalScrollbarOffset"](this["oGetReferenceContainer"]());
		iPageX += UCF_DomUtil["iGetScrollLeft"](this["oGetReferenceContainer"]()) - this["oGetReferenceRect"]()["left"];
	}

	return iPageX;
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["iGetPageX"] = 0; };

UCF_DragDropDecoration["prototype"]["iGetPageY"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["iGetPageY"]++; }; 
	var iPageY = oBrowserEvent["iPageY"]();

	if (this["oGetReferenceContainer"]()) {
		iPageY += this["oGetReferenceContainer"]()["scrollTop"] - this["oGetReferenceRect"]()["top"];
	}

	return iPageY;
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["iGetPageY"] = 0; };

UCF_DragDropDecoration["prototype"]["updateBoundaries"] = function (oBoundaries) {;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["updateBoundaries"]++; }; 
	this["oBoundaries"] = oBoundaries;
	this["oCleanBoundaries"] = {
		"top": this["oBoundaries"]["top"],
		"left": this["oBoundaries"]["left"],
		"width": this["oBoundaries"]["width"],
		"height": this["oBoundaries"]["height"]
	};
};;if (__UCF_COVERAGE__) { UCF_DragDropDecoration["_"]["updateBoundaries"] = 0; };

};
sap["ls"]["preload"]["UCF_DragSession"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>

/**
 * A DragSession of the DragAndDropManager.
 * Holds the data of the current active drag operation.
 * @param {number} iMouseButtonState Mouse button state
 * @class
 */
function UCF_DragSession(iMouseButtonState) {if (__UCF_COVERAGE__) { UCF_DragSession["_"]["UCF_DragSession"]++; }; 
	this["sDragSourceId"] = ""; // the id of the source element
	this["sDragSource"] = null; // the reference of the source element
	this["eDragType"] = UCF_DragSession["DRAG_TYPE"]["NONE"]; //currently only standard is used, SapTable uses specialized types
	this["eDropType"] = UCF_DragSession["DRAG_TYPE"]["NONE"]; //currently only standard is used, SapTable uses specialized types
	this["sDragTags"] = ""; // the tags of the source element
	this["sDropTags"] = ""; // the tags of the target, when hovering a valid drop target

	this["oCustomData"] = null; //used by SapTable
	this["sCustomType"] = ""; //used by SapTable
	this["sGhostHTML"] = null; //the html code of the ghost next to the mouse
	this["oGhost"] = null; //the UCF_Ghost
	this["sDragData"] = null; //data defined by application
	this["sMimeType"] = null; //the mime type of sDragData
	this["bSubscribeDragEvents"] = false; //flag to control wether browser drag events are taken into account (eclipse browser plugin scenario)
	this["bValidDropZone"] = false; //flag to control wether the current dragOver event was fired by a valid dropZone (UCF control with DropDelegate implementation - native browser DragDrop scenario)

	this["bDropPending"] = false; //true if the user dropped but the drag data is not yet available
	this["fDragDataChangeListener"] = null; //one can register a listener, if sDragData is not yet available from the source application

	this["eModifier"] = this["MODIFIER"]["NONE"];

	this["eCursor"] = null;

	this["sId"] = UCF_JsUtil["iGetTimeStamp"]() + "";

	this["iGetMouseButtonState"] = function () {

		return iMouseButtonState;

	};

	var oDropPosition = null;
	this["setDropPosition"] = function (iX, iY) {
		oDropPosition = { "left": iX, "top": iY };
	};

	this["oGetDropPosition"] = function () {
		return oDropPosition;
	};

	this["mCustomData"] = {};
};window["UCF_DragSession"] = UCF_DragSession; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DragSession"); UCF_DragSession["_"] = {UCF_DragSession: 0}; }; ;

UCF_DragSession["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_DragSession.prototype["sClassName"] = "UCF_DragSession";

/**
 * The possible values for setCursor() method.
 */
UCF_DragSession["E_CURSOR"] = {
	"ALLOWED": "DDCursorDefault",
	"NOT_ALLOWED": "DDCursorNotAllowed",
	"H_RESIZE": "DDCursorColResize",
	"V_RESIZE": "DDCursorRowResize",
	"MOVE": "DDCursorMove",
	"CROSSHAIR": "DDCursorCrosshair"

};

UCF_DragSession["prototype"]["MOUSE_BUTTON_STATES"] = {
	"LEFT": 1,
	"RIGHT": 2
};

UCF_DragSession["prototype"]["MODIFIER"] = {
	"NONE": 0,
	"CONTROL": 1,
	"ALT": 2,
	"SHIFT": 3
};

UCF_DragSession["DRAG_TYPE"] = {
	"NONE": 0,
	"STANDARD": 1,
	"H_RESIZE": 2,
	"V_RESIZE": 3,
	"BLOCK_SELECT": 4,
	"DRAG_SELECT": 5
};

UCF_DragSession["DROP_TYPE"] = {
	"NONE": 0,
	"STANDARD": 1,
	"H_INSERT": 2,
	"V_INSERT": 3
};

UCF_DragSession["prototype"]["DROP_EFFECT"] = {
	"NONE": "NONE",
	"MOVE": "MOVE",
	"COPY": "COPY",
	"LINK": "LINK"
};

/**
 * Destructor
 */
UCF_DragSession["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["destroy"]++; }; 
	//ghost gets destroyed by DDManager
	if (this["oGhost"]) {
		this["oGhost"] = null;
	}

	this["eDragType"] = "";
	this["eDropType"] = "";
	this["sDragTags"] = "";
	this["sCustomType"] = "";
	this["sDragData"] = null;
	this["sMimeType"] = null;
	this["bSubscribeDragEvents"] = false;
	this["bValidDropZone"] = false;
	this["sGhostHTML"] = null;
	this["oCustomData"] = null;
	this["mCustomData"] = null;
	this["fDragDataChangeListener"] = null;

	this["eModifier"] = "";
	this["eCursor"] = null;
	this["sId"] = "";
	this["iGetMouseButtonState"] = null;
	this["setDropPosition"] = null;
	this["oGetDropPosition"] = null;
	this["oDragSource"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["destroy"] = 0; };

UCF_DragSession["prototype"]["sGetDragSourceId"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetDragSourceId"]++; }; 
	return this["sDragSourceId"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetDragSourceId"] = 0; };

UCF_DragSession["prototype"]["eGetDragType"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["eGetDragType"]++; }; 
	return this["eDragType"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["eGetDragType"] = 0; };

UCF_DragSession["prototype"]["sGetDragTags"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetDragTags"]++; }; 
	return this["sDragTags"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetDragTags"] = 0; };

UCF_DragSession["prototype"]["eGetDropType"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["eGetDropType"]++; }; 
	return this["eDropType"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["eGetDropType"] = 0; };

UCF_DragSession["prototype"]["setCustomType"] = function (sCustomType) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setCustomType"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (sCustomType) == "string", "typeof (sCustomType) == \"string\"", "DragSession.js(158): setCustomType"); };
	this["sCustomType"] = sCustomType;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setCustomType"] = 0; };

UCF_DragSession["prototype"]["sGetCustomType"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetCustomType"]++; }; 
	return this["sCustomType"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetCustomType"] = 0; };

UCF_DragSession["prototype"]["setCustomData"] = function (oCustomData) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setCustomData"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCustomData != null, "oCustomData != null", "DragSession.js(167): setCustomData"); };
	this["oCustomData"] = oCustomData;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setCustomData"] = 0; };

UCF_DragSession["prototype"]["oGetCustomData"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["oGetCustomData"]++; }; 
	return this["oCustomData"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["oGetCustomData"] = 0; };

UCF_DragSession["prototype"]["setGhostHTML"] = function (sGhostHTML) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setGhostHTML"]++; }; 

	this["sGhostHTML"] = sGhostHTML;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setGhostHTML"] = 0; };

UCF_DragSession["prototype"]["setDragTags"] = function (sDragTags) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setDragTags"]++; }; 

	this["sDragTags"] = sDragTags;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setDragTags"] = 0; };

UCF_DragSession["prototype"]["sGetGhostHTML"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetGhostHTML"]++; }; 
	return this["sGhostHTML"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetGhostHTML"] = 0; };
UCF_DragSession["prototype"]["setDragData"] = function (sDragData, sMimeType) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setDragData"]++; }; 
	this["sDragData"] = sDragData;

	if (sMimeType != null)
		this["sMimeType"] = sMimeType;

	if (this["fDragDataChangeListener"])
		this["fDragDataChangeListener"]["apply"](this, [sDragData, sMimeType]);

};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setDragData"] = 0; };
UCF_DragSession["prototype"]["sGetDragData"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetDragData"]++; }; 
	return this["sDragData"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetDragData"] = 0; };
UCF_DragSession["prototype"]["sGetMimeType"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetMimeType"]++; }; 
	return this["sMimeType"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["sGetMimeType"] = 0; };

UCF_DragSession["prototype"]["oGetGhost"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["oGetGhost"]++; }; 
	return this["oGhost"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["oGetGhost"] = 0; };
UCF_DragSession["prototype"]["setGhost"] = function (oGhost) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setGhost"]++; }; 
	this["oGhost"] = oGhost;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setGhost"] = 0; };

/**
 * The change-listener will be called, when drag data has been set by the drag source
 * @param {function} fChangeListener
 */
UCF_DragSession["prototype"]["setDragDataChangeListener"] = function (fChangeListener) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setDragDataChangeListener"]++; }; 
	this["fDragDataChangeListener"] = fChangeListener;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setDragDataChangeListener"] = 0; };

/**
 * Set a mouse cursor to override the default cursor set by the D&D manager.
 *  @param {string} eCursor The type of cursor (UCF_DragSession.E_CURSOR)
 */
UCF_DragSession["prototype"]["setCursor"] = function (eCursor) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setCursor"]++; }; 
	this["eCursor"] = eCursor;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setCursor"] = 0; };

UCF_DragSession["prototype"]["eGetCursor"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["eGetCursor"]++; }; 
	return this["eCursor"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["eGetCursor"] = 0; };

UCF_DragSession["prototype"]["oSetDragSource"] = function (oDragSource) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["oSetDragSource"]++; }; 
	this["oDragSource"] = oDragSource;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["oSetDragSource"] = 0; };

UCF_DragSession["prototype"]["oGetDragSource"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["oGetDragSource"]++; }; 
	return this["oDragSource"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["oGetDragSource"] = 0; };

UCF_DragSession["prototype"]["setSubscribeDragEvents"] = function (bSubscribeDragEvents) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setSubscribeDragEvents"]++; }; 
	this["bSubscribeDragEvents"] = bSubscribeDragEvents;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setSubscribeDragEvents"] = 0; };

UCF_DragSession["prototype"]["bGetSubscribeDragEvents"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["bGetSubscribeDragEvents"]++; }; 
	return this["bSubscribeDragEvents"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["bGetSubscribeDragEvents"] = 0; };

UCF_DragSession["prototype"]["setValidDropZone"] = function (bValidDropZone) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setValidDropZone"]++; }; 
	this["bValidDropZone"] = bValidDropZone;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setValidDropZone"] = 0; };

UCF_DragSession["prototype"]["bGetValidDropZone"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["bGetValidDropZone"]++; }; 
	return this["bValidDropZone"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["bGetValidDropZone"] = 0; };

UCF_DragSession["prototype"]["mGetMatchingTags"] = function (sDropTags) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["mGetMatchingTags"]++; }; 
	var mResult = {},
		aDropTags = sDropTags["split"](" "),
		aDragTags = this["sGetDragTags"]()["split"](" ");
	for (var i = 0; i < aDragTags["length"]; i++) {
		for (var j = 0; j < aDropTags["length"]; j++) {
			if (aDragTags[i] == aDropTags[j]) {
				mResult[aDragTags[i]] = true;
			}
		}
	}
	return mResult;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["mGetMatchingTags"] = 0; };

UCF_DragSession["prototype"]["eGetDropEffect"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["eGetDropEffect"]++; }; 
	switch (this["eModifier"]) {
		case this["MODIFIER"]["CONTROL"]:
			return this["DROP_EFFECT"]["COPY"];
		case this["MODIFIER"]["SHIFT"]:
			return this["DROP_EFFECT"]["MOVE"];
		default:
			return this["DROP_EFFECT"]["MOVE"];
	}
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["eGetDropEffect"] = 0; };

UCF_DragSession["prototype"]["setModifier"] = function (eModifier) {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setModifier"]++; }; 
	this["eModifier"] = eModifier;
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["setModifier"] = 0; };

UCF_DragSession["prototype"]["eGetModifier"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["eGetModifier"]++; }; 
	return this["eModifier"];
};;if (__UCF_COVERAGE__) { UCF_DragSession["_"]["eGetModifier"] = 0; };

};
sap["ls"]["preload"]["UCF_DragSourceInfo"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_DragSourceInfo(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["UCF_DragSourceInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "DragSourceInfo.js(17): UCF_DragSourceInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "DragSourceInfo.js(18): UCF_DragSourceInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DragSourceInfo.js(19): UCF_DragSourceInfo"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_DragSourceInfo"] = UCF_DragSourceInfo; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DragSourceInfo"); UCF_DragSourceInfo["_"] = {UCF_DragSourceInfo: 0}; }; ;
UCF_DragSourceInfo["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_DragSourceInfo.prototype["sClassName"] = "UCF_DragSourceInfo";

/**
 * Destructor
 * @private
 */
UCF_DragSourceInfo["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["destroy"]++; }; 
	this["sTags"] = "";
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["destroy"] = 0; };

/**
 * @public
 * @return {string}
 */
UCF_DragSourceInfo["prototype"]["sGetTags"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["sGetTags"]++; }; 
	return this["sTags"];
};;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["sGetTags"] = 0; };

/**
 * @public
 * @param {string} sWhitespaceSeperatedTags a whitespace seperated list of tags
 */
UCF_DragSourceInfo["prototype"]["setTags"] = function (sWhitespaceSeperatedTags) {;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["setTags"]++; }; 
	this["sTags"] = sWhitespaceSeperatedTags;
	this["setClientProperty"]('Tags', this["sTags"], true);
};;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["setTags"] = 0; };

/**
 * @public
 * @return {string} the drag data if provided
 */
UCF_DragSourceInfo["prototype"]["sGetData"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["sGetData"]++; }; 
	return this["sData"];
};;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["sGetData"] = 0; };

/**
 * @public
 * @return {string} the mime type data if provided
 */
UCF_DragSourceInfo["prototype"]["sGetMimeType"] = function () {;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["sGetMimeType"]++; }; 
	return this["sMimeType"];
};;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["sGetMimeType"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_DragSourceInfo["prototype"]["aAttributeNames"] = ["sTags","sData","sMimeType","sHint","sCustomData","bBrowserDragDrop"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_DragSourceInfo["prototype"]["aEventNames"] = ["DataAccess"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_DragSourceInfo["prototype"]["aMethodNames"] = ["setTags","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_DragSourceInfo["prototype"]["sTags"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DragSourceInfo["prototype"]["sData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DragSourceInfo["prototype"]["sMimeType"] = 'text/plain';

/**
 * @private
 * @type {string}
 */
UCF_DragSourceInfo["prototype"]["sHint"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DragSourceInfo["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_DragSourceInfo["prototype"]["bBrowserDragDrop"] = false;

//#JSCOVER_EXCL_START
/** @protected */
UCF_DragSourceInfo["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["setDefaultValues"]++; }; 
	this["sTags"] = '';
	this["sData"] = '';
	this["sMimeType"] = 'text/plain';
	this["sHint"] = '';
	this["sCustomData"] = '';
	this["bBrowserDragDrop"] = false;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tags", '', true);
		this["setClientProperty"]("Data", '', true);
		this["setClientProperty"]("MimeType", 'text/plain', true);
		this["setClientProperty"]("Hint", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("BrowserDragDrop", false, true);
	}
};;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sControlId Identifier of the drag source control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires DragSourceInfo::DataAccess
 */
UCF_DragSourceInfo["prototype"]["fireDataAccess"] = function(sId, sControlId, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["fireDataAccess"]++; }; 
	/** @type {{Id: string, ControlId: string, DragSessionId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "DragSourceInfo.js(159): fireDataAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DragSourceInfo.js(160): fireDataAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DragSourceInfo.js(161): fireDataAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sControlId != null, "sControlId != null", "DragSourceInfo.js(162): fireDataAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sControlId) == "string", "typeof(sControlId) == \"string\"", "DragSourceInfo.js(163): fireDataAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "DragSourceInfo.js(164): fireDataAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "DragSourceInfo.js(165): fireDataAccess"); };
	mParams = {
		"Id": sId,
		"ControlId": sControlId,
		"DragSessionId": sDragSessionId
	};
	
	if (sControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ControlId");
			}
		}
	
	this["fireSemanticEvent"]("DragSourceInfo", "DataAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_DragSourceInfo["_"]["fireDataAccess"] = 0; };

UCF_DragSourceInfo.prototype["aPublicMethods"] = ["sGetTags","setTags","sGetData","sGetMimeType"].concat(UCF_DragSourceInfo.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_DropDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./DragSession.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS
 */
function UCF_DropDelegate(oLS) {if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["UCF_DropDelegate"]++; }; 

	this["oLS"] = oLS;
	this["oDropTargetControl"] = null;
	this["oDropDecorator"] = null;
	this["oDropTargetInfoControl"] = null;
};window["UCF_DropDelegate"] = UCF_DropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DropDelegate"); UCF_DropDelegate["_"] = {UCF_DropDelegate: 0}; }; ;
UCF_DropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_DropDelegate.prototype["sClassName"] = "UCF_DropDelegate";

/**
 * destructor
 */
UCF_DropDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["destroy"]++; }; 

	if (this["oDropDecorator"]) this["oDropDecorator"]["destroy"]();
	this["oDropTargetControl"] = null;
	this["oDropTargetInfoControl"] = null;
	this["oDropDecorator"] = null;
	this["oLS"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["destroy"] = 0; };

UCF_DropDelegate["prototype"]["setDropTargetControl"] = function(oDropTargetControl) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["setDropTargetControl"]++; }; 
	this["oDropTargetControl"] = oDropTargetControl;
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["setDropTargetControl"] = 0; };

UCF_DropDelegate["prototype"]["sGetDropTags"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["sGetDropTags"]++; }; 

	var oDropTargetControl = this["oGetDropTargetControl"](oBrowserEvent),
		sDropTargetInfoId = this["oGetDropTargetInfoId"](oBrowserEvent);
	if (!sDropTargetInfoId)
		return "";

	var oDropTargetInfoControl = oDropTargetControl["oGetControlById"](sDropTargetInfoId);
	if (!oDropTargetInfoControl)
		return "";

	var sDropTags = oDropTargetInfoControl["sGetTags"]();
	if (!sDropTags)
		return "";

	return sDropTags;
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["sGetDropTags"] = 0; };

UCF_DropDelegate["prototype"]["bSupportsRightMouseButton"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["bSupportsRightMouseButton"]++; }; 

	var oDropTargetControl = this["oGetDropTargetControl"](oBrowserEvent);
	var sDropTargetInfoId = this["oGetDropTargetInfoId"](oBrowserEvent);
	if (!sDropTargetInfoId)
		return false;

	var oDropTargetInfoControl = oDropTargetControl["oGetControlById"](sDropTargetInfoId);
	if (!oDropTargetInfoControl)
		return false;

	return oDropTargetInfoControl["bSupportRightMouseButton"];
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["bSupportsRightMouseButton"] = 0; };

UCF_DropDelegate["prototype"]["bGetEventBubbling"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["bGetEventBubbling"]++; }; 

	if (!this["oDropTargetControl"]) this["oDropTargetControl"] = this["oGetDropTargetControl"](oBrowserEvent);
	if (this["oDropTargetControl"]) {
		if (!this["oDropTargetInfoControl"]) {
			if (this["oGetDropTargetInfoId"](oBrowserEvent)) {
				this["oDropTargetInfoControl"] = this["oDropTargetControl"]["oGetControlById"](this["oGetDropTargetInfoId"](oBrowserEvent));
				if (this["oDropTargetInfoControl"]) return this["oDropTargetInfoControl"]["bGetEventBubbling"]();
				else return true;
			} else return true;
		} else return this["oDropTargetInfoControl"]["bGetEventBubbling"]();
	} else return true;
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["bGetEventBubbling"] = 0; };

UCF_DropDelegate["prototype"]["sGetValidMimeTypes"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["sGetValidMimeTypes"]++; }; 
	var oDropTargetControl = this["oGetDropTargetControl"](oBrowserEvent),
		sDropTargetInfoId = this["oGetDropTargetInfoId"](oBrowserEvent);
	if (!sDropTargetInfoId) {
		return "";
	}
	var oDropTargetInfoControl = oDropTargetControl["oGetControlById"](sDropTargetInfoId);
	if (!oDropTargetInfoControl) {
		return "";
	}
	var sValidMimeTypes = oDropTargetInfoControl["sGetValidMimeTypes"]();
	if (!sValidMimeTypes) {
		return "";
	}
	return sValidMimeTypes;
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["sGetValidMimeTypes"] = 0; };

UCF_DropDelegate["prototype"]["onlsdragenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["onlsdragenter"]++; }; 
	var sDropTags = this["sGetDropTags"](oBrowserEvent),
		sValidMimeTypes = this["sGetValidMimeTypes"](oBrowserEvent),
		oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		bEventBubbling = this["bGetEventBubbling"](oBrowserEvent);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD: oBrowserEvent.oGetSource().id=" + oBrowserEvent["oGetSource"]()["id"], "DropDelegate.js(111): onlsdragenter"); };
	if (!oDragAndDropManager["bGetDropAllowed"](sDropTags, sValidMimeTypes)) {
		if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
		return;
	}
	if (!this["bIsDropPossible"](oBrowserEvent)) {
		if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
		return;
	}
	//initialize drop

	oDragAndDropManager["oDragSession"]["setValidDropZone"](true);

	if (!this["oDropDecorator"])
		this["oDropDecorator"] = this["oCreateDropDecorator"]();

	if (this["oDropDecorator"]) {
		this["oDropDecorator"]["init"](oDragAndDropManager["oDragSession"]);
		this["oDropDecorator"]["update"](oBrowserEvent);
	}
	oDragAndDropManager["initDropArea"](
		UCF_DragSession["DROP_TYPE"]["STANDARD"],
		sDropTags,
		this["oDropDecorator"]
	);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["bHandled"] = true;
	return oBrowserEvent["bHandled"];
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["onlsdragenter"] = 0; };

UCF_DropDelegate["prototype"]["onlsdrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["onlsdrop"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "drop", "DropDelegate.js(143): onlsdrop"); };

	var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"],
		sDropTags = this["sGetDropTags"](oBrowserEvent),
		sValidMimeTypes = this["sGetValidMimeTypes"](oBrowserEvent),
		bEventBubbling = this["bGetEventBubbling"](oBrowserEvent);

	if (oBrowserEvent["oDragAndDropManager"]["bGetDropAllowed"](sDropTags, sValidMimeTypes) && this["bIsDropPossible"](oBrowserEvent)) {
		var mMatchingTags = oDragSession["mGetMatchingTags"](this["sGetDropTags"](oBrowserEvent));
		if (__UCF_DEBUG__) {
			var sMatchingTags = "";
			for (var n in mMatchingTags) {
				sMatchingTags += " " + n;
			}
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "MATCHING " + sMatchingTags, "DropDelegate.js(157): onlsdrop"); };
		}
		var oDomRefToBeFocussed = this["oGetDomRefToBeFocussed"](oBrowserEvent);
		if (oDomRefToBeFocussed) UCF_DomUtil["focusDomElement"](oDomRefToBeFocussed);

		var sDragData = oDragSession["sGetDragData"](),
			sMimeType = oDragSession["sGetMimeType"]();

		//drag response not yet available
		if (sDragData == null) {
			oDragSession["setDragDataChangeListener"](this["fGetDropCallBack"](oDragSession));
			oDragSession["bDropPending"] = true;
		} else {
			this["fGetDropCallBack"](oDragSession)["apply"](this, [sDragData, sMimeType]);
		}
		oBrowserEvent["bHandled"] = true;
		oBrowserEvent["cancelBubble"]();
	} else {
		if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
	}

	if (this["oDropDecorator"])
		this["oDropDecorator"]["cleanUp"]();

	//do not initialize DropDecorator here to be able to destroy via destroy method
	//	this.oDropDecorator = null;

	oBrowserEvent["oDragAndDropManager"]["cleanUpDropArea"]();

};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["onlsdrop"] = 0; };

UCF_DropDelegate["prototype"]["oCreateDropDecorator"] = function() {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["oCreateDropDecorator"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["oCreateDropDecorator"] = 0; };

/**
 * should return the dom ref which should be focussed after the roundtrip
 * returns the control itself as default implementation
 * should be overriden by extending drop delegates
 */
UCF_DropDelegate["prototype"]["oGetDomRefToBeFocussed"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["oGetDomRefToBeFocussed"]++; }; 

	return this["oGetDropTargetControl"](oBrowserEvent)["oDomRef"];

};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["oGetDomRefToBeFocussed"] = 0; };

/**
 *
 */
UCF_DropDelegate["prototype"]["onlsdragover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["onlsdragover"]++; }; 
	var sDropTags = this["sGetDropTags"](oBrowserEvent),
		sValidMimeTypes = this["sGetValidMimeTypes"](oBrowserEvent),
		oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		bEventBubbling = this["bGetEventBubbling"](oBrowserEvent);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "DnD: oBrowserEvent.oGetSource().id=" + oBrowserEvent["oGetSource"]()["id"], "DropDelegate.js(211): onlsdragover"); };
	if (!oDragAndDropManager["bGetDropAllowed"](sDropTags, sValidMimeTypes)) {
		if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
		return;
	}
	if (!this["bIsDropPossible"](oBrowserEvent)) {
		if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
		return;
	}

	oDragAndDropManager["oDragSession"]["setValidDropZone"](true);

	if (this["oDropDecorator"]) {
		this["oDropDecorator"]["update"](oBrowserEvent);

	}
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["onlsdragover"] = 0; };

UCF_DropDelegate["prototype"]["onlsdragscroll"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["onlsdragscroll"]++; }; 

	//_trace(INFO,"");
	var sDropTags = this["sGetDropTags"](oBrowserEvent),
		sValidMimeTypes = this["sGetValidMimeTypes"](oBrowserEvent),
		oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		bEventBubbling = this["bGetEventBubbling"](oBrowserEvent);

	if (!oDragAndDropManager["bGetDropAllowed"](sDropTags, sValidMimeTypes)) {
		if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
		return;
	}
	if (!this["bIsDropPossible"](oBrowserEvent)) {
		if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
		return;
	}
	if (this["oDropDecorator"])
		this["oDropDecorator"]["update"](oBrowserEvent);

	//oBrowserEvent.cancelBubble();
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["onlsdragscroll"] = 0; };

/**
 *
 */
UCF_DropDelegate["prototype"]["onlsdragleave"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["onlsdragleave"]++; }; 

	var bEventBubbling = this["bGetEventBubbling"](oBrowserEvent);

	oBrowserEvent["oDragAndDropManager"]["cleanUpDropArea"]();
	if (this["oDropDecorator"])
		this["oDropDecorator"]["cleanUp"]();

	if (!bEventBubbling) oBrowserEvent["cancelBubble"]();

	//oBrowserEvent.cancelBubble();
	//oBrowserEvent.bHandled = true;

};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["onlsdragleave"] = 0; };
/**
 *
 */
UCF_DropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["fGetDropCallBack"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["fGetDropCallBack"] = 0; };

/**
 * Don't mix up this function with bGetDropAllowed(). The latter returns TRUE
 * when the tags of drag source and drop target match.
 */
UCF_DropDelegate["prototype"]["bIsDropPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["bIsDropPossible"]++; }; 

	//check if right mouse button is supported
	//when user drags with right mouse button
	var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"],
		iMouseButton = oDragSession["iGetMouseButtonState"]();

	if (iMouseButton == oDragSession["MOUSE_BUTTON_STATES"]["RIGHT"])
		return this["bSupportsRightMouseButton"](oBrowserEvent);

	return true;
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["bIsDropPossible"] = 0; };

/**
 * default implementation - may be overridden
 * @return the drop target
 * @type UCF_Control
 */
UCF_DropDelegate["prototype"]["oGetDropTargetControl"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["oGetDropTargetControl"]++; }; 

	return this["oDropTargetControl"];

};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["oGetDropTargetControl"] = 0; };

/**
 * default implementation - may be overridden
 * @return the id of the dropTargetInfo control
 * @type string
 *
 */
UCF_DropDelegate["prototype"]["oGetDropTargetInfoId"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["oGetDropTargetInfoId"]++; }; 

	var oDropTargetControl = this["oGetDropTargetControl"](oBrowserEvent);
	if (oDropTargetControl) {
		return oDropTargetControl["sDropTargetInfo"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_DropDelegate["_"]["oGetDropTargetInfoId"] = 0; };

};
sap["ls"]["preload"]["UCF_DropTarget"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_DropTargetDropDelegate */
/// <reference path="./delegates/DropTargetDropDelegate.js"/>

/**
 * 
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_DropTarget(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_DropTarget["_"]["UCF_DropTarget"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "DropTarget.js(17): UCF_DropTarget"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "DropTarget.js(18): UCF_DropTarget"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DropTarget.js(19): UCF_DropTarget"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_DropTarget"] = UCF_DropTarget; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DropTarget"); UCF_DropTarget["_"] = {UCF_DropTarget: 0}; }; ;
UCF_DropTarget["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_DropTarget.prototype["sClassName"] = "UCF_DropTarget";

/**
 * Destructor
 * @private
 */
UCF_DropTarget["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_DropTarget["_"]["destroy"]++; }; 

	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DropTarget["_"]["destroy"] = 0; };

/**
 * implements method from UCF_Control
 * @private
 */
UCF_DropTarget["prototype"]["createDropDelegate"] = function () {;if (__UCF_COVERAGE__) { UCF_DropTarget["_"]["createDropDelegate"]++; }; 
	if (!this["sDropTargetInfo"])
		return;

	if (this["oDropDelegate"])
		return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropTargetDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_DropTarget["_"]["createDropDelegate"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_DropTarget["prototype"]["aAttributeNames"] = ["sDropTargetInfo","sHoverVisualizationType","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_DropTarget["prototype"]["aEventNames"] = ["Drop"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_DropTarget["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_DropTarget["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HoverVisualizationType}
 */
UCF_DropTarget["prototype"]["sHoverVisualizationType"] = "BORDERANDBACKGROUND";

/**
 * @private
 * @type {string}
 */
UCF_DropTarget["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_DropTarget["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DropTarget["_"]["setDefaultValues"]++; }; 
	this["sDropTargetInfo"] = '';
	this["sHoverVisualizationType"] = "BORDERANDBACKGROUND";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("HoverVisualizationType", "BORDERANDBACKGROUND", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_DropTarget["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires DropTarget::Drop
 */
UCF_DropTarget["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_DropTarget["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 10, "arguments.length == 10", "DropTarget.js(128): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "DropTarget.js(129): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "DropTarget.js(130): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "DropTarget.js(131): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "DropTarget.js(132): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "DropTarget.js(133): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "DropTarget.js(134): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "DropTarget.js(135): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "DropTarget.js(136): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "DropTarget.js(137): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "DropTarget.js(138): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "DropTarget.js(139): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "DropTarget.js(140): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "DropTarget.js(141): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "DropTarget.js(142): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "DropTarget.js(143): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "DropTarget.js(144): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "DropTarget.js(145): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "DropTarget.js(146): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "DropTarget.js(147): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "DropTarget.js(148): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	if (sDragSource) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sDragSource);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "DragSource");
			}
		}
	if (sDropTargetInfo) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sDropTargetInfo);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "DropTargetInfo");
			}
		}
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("DropTarget", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_DropTarget["_"]["fireDrop"] = 0; };

};
sap["ls"]["preload"]["UCF_DropTargetDropDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_DropTargetDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_DropTargetDropDelegate["_"]["UCF_DropTargetDropDelegate"]++; }; 
	UCF_DropDelegate["apply"](this, [oLS]);
	this["setDropTargetControl"](oDropTargetControl);
};window["UCF_DropTargetDropDelegate"] = UCF_DropTargetDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DropTargetDropDelegate"); UCF_DropTargetDropDelegate["_"] = {UCF_DropTargetDropDelegate: 0}; }; ;
UCF_DropTargetDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_DropTargetDropDelegate.prototype["sClassName"] = "UCF_DropTargetDropDelegate";

UCF_DropTargetDropDelegate["prototype"]["oCreateDropDecorator"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_DropTargetDropDelegate["_"]["oCreateDropDecorator"]++; }; 
	var oDomRef = this["oDropTargetControl"]["oDomRef"],
		sHoverVisualizationType = this["oDropTargetControl"]["sHoverVisualizationType"];

	if (!this["oDecorator"])
		this["oDecorator"] = {

			"oDomRef": oDomRef,
			"sHoverVisualizationType": sHoverVisualizationType,
			"sHoverColor": '#ffc54e',
			"bInitialized": false,
			"oDiv": null,

			"init": function() {

				if (this["bInitialized"])
					return;

				if (this["sHoverVisualizationType"] === 'NONE')
					return;
				//D039230 PB 153 - set the classstyle for the hover
				/* if (this.sHoverVisualizationType === 'BACKGROUND' || this.sHoverVisualizationType === 'BORDERANDBACKGROUND' )
				{
					this.sBackgroundColor = this.oDomRef.style.backgroundColor;
					this.oDomRef.style.backgroundColor = this.sHoverColor;
				}

				if (this.sHoverVisualizationType === 'BORDER' || this.sHoverVisualizationType === 'BORDERANDBACKGROUND' )
				{
					this.oDomRef.style.padding = '0px';
					this.oDomRef.style.border = '1px dotted ' + this.sHoverColor;
				}*/

				if (this["sHoverVisualizationType"] === 'BACKGROUND') {
					// padding 0px, border 0px
					this["sBackgroundColor"] = this["oDomRef"]["style"]["backgroundColor"];
					UCF_DomUtil["addClass"](this["oDomRef"], 'lsDropTargetBackground');
				} else if (this["sHoverVisualizationType"] === 'BORDER') {
					// padding 1px, border 1px
					UCF_DomUtil["addClass"](this["oDomRef"], 'lsDropTargetBorder');
					UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDropTargetPadding');
					UCF_DomUtil["addClass"](this["oDomRef"], 'lsDropTargetNoPadding');

				} else if (this["sHoverVisualizationType"] === 'BORDERANDBACKGROUND') {
					//padding 1px, border 1px
					this["sBackgroundColor"] = this["oDomRef"]["style"]["backgroundColor"];
					UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDropTargetPadding');
					UCF_DomUtil["addClass"](this["oDomRef"], 'lsDropTargetBorder');
					UCF_DomUtil["addClass"](this["oDomRef"], 'lsDropTargetBackground');
					UCF_DomUtil["addClass"](this["oDomRef"], 'lsDropTargetNoPadding');

				} else if (this["sHoverVisualizationType"] === 'OVERLAY') {
					// (re-)calculate position and size of overlay DIV and display it
					this["oDiv"] = UCF_DomUtil["$"](oDomRef["id"] + '-ovl');
					var oRefContainer = UCF_DomUtil["oGetParentPositionReferenceContainer"](oDomRef, true);

					if (oRefContainer) {
						UCF_DomUtil["oAddLayeredElement"](this["oDiv"], null, oRefContainer);
					}
					var oRect = UCF_DomUtil["oGetObjectRect"](oDomRef, oRefContainer);
					var oStyle = this["oDiv"]["style"];

					oStyle["top"] = oRect["top"] + 'px';
					oStyle["left"] = oRect["left"] + 'px';
					oStyle["height"] = oRect["height"] + 'px';
					oStyle["width"] = oRect["width"] + 'px';
					oStyle["zIndex"] = UCF_LS["E_LAYERS"]["CONTROLS"] + 500;
					oStyle["display"] = 'block';
				}

				this["bInitialized"] = true;

			},

			"cleanUp": function() {

				if (!this["bInitialized"])
					return;

				if (this["sHoverVisualizationType"] === 'NONE')
					return;

				if (this["sHoverVisualizationType"] === 'BACKGROUND' || this["sHoverVisualizationType"] === 'BORDERANDBACKGROUND') {
					this["oDomRef"]["style"]["backgroundColor"] = this["sBackgroundColor"];
					UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDropTargetBackground');

				}

				if (this["sHoverVisualizationType"] === 'BORDER' || this["sHoverVisualizationType"] === 'BORDERANDBACKGROUND') {
					UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDropTargetBorder');
					UCF_DomUtil["removeClass"](this["oDomRef"], 'lsDropTargetNoPadding');
					UCF_DomUtil["addClass"](this["oDomRef"], 'lsDropTargetPadding');
				}

				if (this["sHoverVisualizationType"] === 'OVERLAY') {
					this["oDiv"] = UCF_DomUtil["$"](oDomRef["id"] + '-ovl');
					this["oDiv"]["style"]["display"] = 'none';
					this["oDiv"] = null;
				}

				this["bInitialized"] = false;

			},

			"destroy": function() {
				this["oDomRef"] = null;
				this["oDiv"] = null;
			},

			"update": function() {},
			"hide": function() {
				if (this["oDiv"]) {
					this["oDiv"]["style"]["visibility"] = 'hidden';
					this["oDiv"]["style"]["display"] = 'none';
				}
			},
			"show": function() {
				if (this["oDiv"]) {
					this["oDiv"]["style"]["visibility"] = 'visible';
					this["oDiv"]["style"]["display"] = 'block';
				}
			},
			"bIsVisible": function() { return true; }

		};

	return this["oDecorator"];

};;if (__UCF_COVERAGE__) { UCF_DropTargetDropDelegate["_"]["oCreateDropDecorator"] = 0; };

UCF_DropTargetDropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_DropTargetDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function(sDragData, sMimeType) {

		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);
	};

};;if (__UCF_COVERAGE__) { UCF_DropTargetDropDelegate["_"]["fGetDropCallBack"] = 0; };

/**
 * destructor
 */
UCF_DropTargetDropDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_DropTargetDropDelegate["_"]["destroy"]++; }; 

	this["oDecorator"] = null;
	this["oDiv"] = null;
	this["sBackgroundColor"] = null;
	UCF_DropDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DropTargetDropDelegate["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_DropTargetInfo"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_DropTargetInfo(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["UCF_DropTargetInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "DropTargetInfo.js(17): UCF_DropTargetInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "DropTargetInfo.js(18): UCF_DropTargetInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "DropTargetInfo.js(19): UCF_DropTargetInfo"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_DropTargetInfo"] = UCF_DropTargetInfo; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_DropTargetInfo"); UCF_DropTargetInfo["_"] = {UCF_DropTargetInfo: 0}; }; ;
UCF_DropTargetInfo["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_DropTargetInfo.prototype["sClassName"] = "UCF_DropTargetInfo";

/**
 * Destructor
 * @private
 */
UCF_DropTargetInfo["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["destroy"]++; }; 
	this["sTags"] = "";
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["destroy"] = 0; };

UCF_DropTargetInfo["prototype"]["sGetTags"] = function () {;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["sGetTags"]++; }; 
	return this["sTags"] || "";
};;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["sGetTags"] = 0; };

/**
 * @public
 * @param {string} sWhitespaceSeperatedTags a whitespace seperated list of tags
 */
UCF_DropTargetInfo["prototype"]["setTags"] = function (sWhitespaceSeperatedTags) {;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["setTags"]++; }; 
	this["sTags"] = sWhitespaceSeperatedTags;
	this["setClientProperty"]("Tags", this["sTags"], true);
};;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["setTags"] = 0; };
/**
 * @public
 * @return the eventBubbling setting if provided
 * @type string
 */
UCF_DropTargetInfo["prototype"]["bGetEventBubbling"] = function () {;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["bGetEventBubbling"]++; }; 
	return this["bEventBubbling"];
};;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["bGetEventBubbling"] = 0; };

/**
 * @public
 * @return valid mime types
 * @type string
 */
UCF_DropTargetInfo["prototype"]["sGetValidMimeTypes"] = function () {;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["sGetValidMimeTypes"]++; }; 
	return this["sValidMimeTypes"];
};;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["sGetValidMimeTypes"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_DropTargetInfo["prototype"]["aAttributeNames"] = ["sTags","bSupportRightMouseButton","bEventBubbling","sCustomData","sValidMimeTypes"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_DropTargetInfo["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_DropTargetInfo["prototype"]["aMethodNames"] = ["setTags","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_DropTargetInfo["prototype"]["sTags"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_DropTargetInfo["prototype"]["bSupportRightMouseButton"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_DropTargetInfo["prototype"]["bEventBubbling"] = true;

/**
 * @private
 * @type {string}
 */
UCF_DropTargetInfo["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_DropTargetInfo["prototype"]["sValidMimeTypes"] = 'text/plain';

//#JSCOVER_EXCL_START
/** @protected */
UCF_DropTargetInfo["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["setDefaultValues"]++; }; 
	this["sTags"] = '';
	this["bSupportRightMouseButton"] = false;
	this["bEventBubbling"] = true;
	this["sCustomData"] = '';
	this["sValidMimeTypes"] = 'text/plain';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tags", '', true);
		this["setClientProperty"]("SupportRightMouseButton", false, true);
		this["setClientProperty"]("EventBubbling", true, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("ValidMimeTypes", 'text/plain', true);
	}
};;if (__UCF_COVERAGE__) { UCF_DropTargetInfo["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_DropTargetInfo.prototype["aPublicMethods"] = ["setTags","bGetEventBubbling","sGetValidMimeTypes"].concat(UCF_DropTargetInfo.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_EditFieldBase"] = function() {/**
 * @fileoverview
 * ## Terminology
 *
 * - *Help Button* is the button right to the InputField that opens a field
 *   help (or fires an InputField:ListAccess)
 * - *Field Help* is the InputField-managed value selection dialog that is
 *   opened with [F4]/[ALT][DOWN]/[ALT][UP] or the help button
 */
// #region imports ############################################################
/* global UCF_InputFieldHelpButton */
/// <reference path="../InputFieldHelpButton.js"/>
/* global UCF_FieldNavigationDelegate */
/// <reference path="../delegates/FieldNavigationDelegate.js"/>
/* global UCF_Fields_AutoTabDelegate */
/// <reference path="../delegates/Fields_AutoTabDelegate.js"/>
/* global UCF_Fields_HideFakeFieldDelegate */
/// <reference path="../delegates/Fields_HideFakeFieldDelegate.js"/>
/* global UCF_Fields_FirefoxSelectDelegate */
/// <reference path="../delegates/Fields_FirefoxSelectDelegate.js"/>
/* global UCF_TableFieldNavigationDelegate */
/// <reference path="../delegates/TableFieldNavigationDelegate.js"/>
/* global UCF_ToolbarFieldNavigationDelegate */
/// <reference path="../delegates/ToolbarFieldNavigationDelegate.js"/>
/* global UCF_Fields_OverlayDelegate */
/// <reference path="../delegates/Fields_OverlayDelegate.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_Exception */
/// <reference path="../../core/Exception.js"/>
/* global UCF_FocusInfo */
/// <reference path="../../core/FocusInfo.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../../core/ResourceUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_Event */
/// <reference path="../../../core/Event.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_Tracer, _assert, _trace, DEBUG, INFO, ERROR, WARNING */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../../core/util/AriaStateHelper.js"/>
/* global UCF_Cache */
/// <reference path="../../../core/util/Cache.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_ClipboardUtil */
/// <reference path="../../../core/util/ClipboardUtil.js"/>
// #endregion
// #region types ##############################################################
/** @typedef {UCF_ComboBoxListBox|UCF_Listbox_Popup|UCF_Calendar|UCF_Calculator} UCF_EditFieldBase_FieldHelp */
/**
 * @typedef {Object} UCF_EditFieldBase_ControlState the current state of the control
 * @property {boolean} Hidden
 * @property {UCF_ClientInterfaces.E.EmbeddingBehaviour} EmbeddingBehaviour
 * @property {boolean} UsedInSapTable
 * @property {boolean} ShouldRenderHelp
 * @property {boolean} Enabled
 * @property {boolean} Readonly
 * @property {boolean} Invalid
 * @property {UCF_ClientInterfaces.E.InputState} InputState
 * @property {boolean} DisplayAsText
 * @property {string} CustomStyle
 * @property {boolean} IsContainerWidthSet
 * @property {string} Width
 * @property {string} Height
 * @property {string} Value
 * @property {string} InputPrompt
 * @property {UCF_ClientInterfaces.E.TableFieldDesign} SapTableFieldDesign
 * @property {UCF_ClientInterfaces.E.InputDesign} Design
 * @property {boolean} ShowRequiredIndicator
 * @property {boolean} PasswordField
 * @property {boolean} HideFieldHelp
 * @property {boolean} ShowHelpButton
 * @property {boolean} ShowHelpButtonAlways
 * @property {UCF_ClientInterfaces.E.InputFieldTextStyle} TextStyle
 * @property {UCF_ClientInterfaces.E.SapTableCellDesign} SemanticColor
 * @property {boolean} TextOverflowEllipsis
 * @property {boolean} UsedInToolbar
 * @property {boolean} [HasIconColumn]
 * @property {UCF_ClientInterfaces.E.InputFieldFieldHelp} FieldHelp
 * @property {UCF_ClientInterfaces.E.InputFieldType} Type
 * @property {boolean} [SpinnerBoundsCheck]
 * @property {number} [SpinnerMin]
 * @property {number} [SpinnerMax]
 * @property {UCF_ClientInterfaces.E.IMEMode} IMEMode
 */
/**
 * @typedef {Object} UCF_EditFieldBase_MouseInteractionState derived from
 * UCF_EditFieldBase_MousePosition and other state indicators in the field
 * @property {boolean} [IsHovered] `true` to indicate that the Field is
 * hovered
 * @property {boolean} [IsFocused] `true` to indicate that the Field is
 * focused
 * @property {boolean} [IsHighlighted]
 * @property {boolean} [IsHighlightFocused]
 * @property {boolean} [IsOpen] `true` to indicate that the Field Help is open
 * @property {boolean} [IsUpperHelpButtonHalfHovered] `true` to indicate that
 * the upper half of the Help Button is hovered
 * @property {boolean} [IsLowerHelpButtonHalfHovered] `true` to indicate that
 * the lower half of the Help Button is hovered
 * @property {boolean} [IsDown] `true` to indicate that the mouse is pressed
 * @property {boolean} [IsUpperHelpButtonHalfDown]
 * @property {boolean} [IsLowerHelpButtonHalfDown]
 * @property {boolean} [IsClearHovered]
 * @property {boolean} [IsClearDown]
 */
/**
 * @typedef {Object} UCF_EditFieldBase_MousePosition
 * @property {boolean} MouseOnInput
 * @property {boolean} MouseOnFieldHelp
 * @property {boolean} MouseOnClear
 * @property {boolean} MouseOnDown
 * @property {boolean} MouseOnUpperHelpButtonHalf
 * @property {boolean} MouseOnLowerHelpButtonHalf
 * @property {boolean} Overlay
 * @property {boolean} FocusOnInput
 * // in the future we might need a FocusOnFieldHelp/FocusOnClear/... as well
 */
/**
 * @typedef {Object} UCF_EditFieldBase_AnyEventHandler
 * @property {function(UCF_BrowserEvent): boolean} fWhen predicate that is run
 * against all AnyEvents
 * @property {function(UCF_BrowserEvent): void} fThen called when fWhen returns
 * true
 */
/**
 * @typedef {Object} UCF_EditFieldBase_Metadata
 * @property {boolean} supportsOverlay
 * @property {number} inputFontSize
 */

/** @typedef {0} UCF_EditFieldBase_ChangeReason_Other */
/** @typedef {1} UCF_EditFieldBase_ChangeReason_BlurByTab */
/** @typedef {2} UCF_EditFieldBase_ChangeReason_Enter */
/** @typedef {UCF_EditFieldBase_ChangeReason_Other|UCF_EditFieldBase_ChangeReason_BlurByTab|UCF_EditFieldBase_ChangeReason_Enter} UCF_EditFieldBase_ChangeReason */
/**
 * @typedef {Object} UCF_EditFieldBase_ChangeReasonEnum
 * @property {UCF_EditFieldBase_ChangeReason_Other} Other
 * @property {UCF_EditFieldBase_ChangeReason_BlurByTab} BlurByTab
 * @property {UCF_EditFieldBase_ChangeReason_Enter} Enter
 */
/**
 * @typedef {Object} UCF_EditFieldBase_FireChangeEvent
 * @property {UCF_EditFieldBase_ChangeReason} iReason
 * @property {boolean} bDelayed
 * @property {boolean} bForced
 */
// #endregion
// #region constructor ########################################################
/**
 * 
 * @constructor
 * @extends UCF_Control
 * @param {HTMLInputElement|HTMLSpanElement} oDomRef the element the EditField
 * is mounted on
 * @param {UCF_LS} oLS the LightSpeed instance managing the EditField
 */
function UCF_EditFieldBase(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["UCF_EditFieldBase"]++; }; 
	/** @type {UCF_Page} */
	var oPage;
	/** @type {HTMLElement} */
	var oCtParentRef;

	if (arguments["length"] > 0) {
		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["defineEvents"]([
			// ClickToOpenOverlay
			'DidClickToOpenOverlay',
			// OpenFieldHelp
			'WillOpenFieldHelp',
			// CloseFieldHelp
			'DidCloseFieldHelp',
			// UpdateStyles
			'DidUpdateStyles',
			// Destroy
			'WillDestroy',
			// SubmitPendingRequest
			'WillSubmitPendingRequest',
			// FireListAccess
			'WillFireListAccess',
			// PageResize
			'WillPageResize',
			// FireChange
			'WillFireChange',
			'FireChange',
			'DidFireChange',
			'EditMode',
			'NavigationMode'
		]);

		this["readLsdata"]();

		oPage = this["oLS"]["oGetPageInternal"]();

		/**
		 * @type {boolean} Allow text selection for all entry fields also when they
		 * are disabled
		 */
		this["bAllowTextSelection"] = true;

		/** @type {boolean} bNoBlur flag to avoid blurs */
		this["bNoBlur"] = false;

		/**
		 * @type {boolean} bIsAsteriskRequiredIndicator indicates if '*' in
		 * oDomRef.value is a required indicator or actually a value
		 */
		this["bIsAsteriskRequiredIndicator"] = this["bRequired"] &&
			this["bShowRequiredIndicator"] &&
			this["sValue"] === '' &&
			this["sGetDomRefValue"]() === '*';
		/** @type {boolean} */
		this["bCurrentValueInputPrompt"] = this["bUsesValueForIndicators"]() &&
			this["sInputPrompt"] !== '' &&
			this["sValue"] === '';

		/** @type {boolean} */
		this["bIsHighlighted"] = false;
		/** @type {boolean} */
		this["bIsHighlightFocused"] = false;

		/** @type {boolean}
		 * used to remove the -arialabel from aria-labelledby if the label text
		 * and the tooltip of the field are identical to avoid that the
		 * screen reader announces the text twice
		 */
		this["bLabelTextRemoved"] = false;

		/**
		 * CSN 141430 2016: space is ignored in InputField and ComboBox
		 *
		 * blur+focus may be caused by a .refocus() call, where the
		 * navigation mode should not be triggered (otherwise the
		 * oBrowserEvent could be canceled on lsspace).
		 *
		 * @type {boolean}
		 */
		this["bRefocusInProgress"] = false;

		/** @type {number} */
		this["iSelectionStart"] = 0;

		/** @type {number} */
		this["iSelectionEnd"] = 0;

		/** @type {number} */
		this["iCursorPos"] = 0;

		// disable default button if enter is implemented
		if (this["bHasEventListeners"]('Enter')) {
			/** @type {boolean} */
			this["bIgnoreDefaultButton"] = true;
		}

		// get F4 help button
		if (this["bDisplayAsText"]) {
			/** @type {boolean} */
			this["bHideFieldHelp"] = true;
			// eslint-disable-next-line quotes
			this["setClientProperty"]("HideFieldHelp", this["bHideFieldHelp"], true);
		}

		/** @type {HTMLElement} oHelpButtonRef the permanent button */
		this["oHelpButtonRef"] = null;
		/** @type {UCF_InputFieldHelpButton} oHelpButton the floating button */
		this["oHelpButton"] = null;

		/** @type {boolean} bIsDirty changes after controls was edited */
		this["bIsDirty"] = false;

		// Attach to the page before resize event, ITS speciale
		if (oPage) {
			oPage["attachEvent"](
				oPage["E_EVENTS"]["BeforeResize"],
				this,
				'onBeforeResizePage'
			);
		}
		this["attachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"], 'onPendingRequest');

		this["sCustomStyle"] = UCF_StringUtil["sTrim"](this["sCustomStyle"]);
		// eslint-disable-next-line quotes
		this["setClientProperty"]("CustomStyle", this["sCustomStyle"], true);

		// Note 2354091: Strange symptom in Firefox: The creation of the
		// InputFieldRenderer, which is done in 'sGetClass' etc, and executed in
		// the 'blur' event leads to an issue with TAB for InputFields in SapTable:
		// After entering something inside an InputField and pressing TAB, the next
		// possible InputField is skipped and the cursor jumps to the InputField
		// next to it. The issue happens only once; after the InputFieldRenderer is
		// created, tabbing works as expected => Fix: For Firefox, we create the
		// InputFieldRenderer in the constructor, and not lazy in the 'blur' event
		// handler.
		if (UCF_UserAgent["bIsFirefox"]()) {
			this["oLS"]["oGetRenderManager"]()["getRenderer"]('InputField');
			UCF_ClassLoader["oGetClass"]('UCF_UrBaseRenderer');
		}

		/**
		 * #onmouseover() could trigger opening a datatip. This is done
		 * asynchronously, and the id of the asynchronous call is stored in
		 * sTimeOutId (to cancel it in case of the EditField getting destroyed
		 * during the timeout)
		 *
		 * @type {string}
		 */
		this["sTimeOutId"] = null;

		/** @type {UCF_EditFieldBase_MousePosition} */
		this["oInteractionState"] = {
			"TouchInteraction": false,
			"MouseOnInput": false,
			"MouseOnFieldHelp": false,
			"MouseOnClear": false,
			"MouseOnUpperHelpButtonHalf": false,
			"MouseOnLowerHelpButtonHalf": false,
			"MouseOnDown": false,
			"FocusOnInput": true,
			"Overlay": false
		};

		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

		/**
		 * Cache for browserevent handler references.
		 * @see UCF_EditFieldBase#detachOnce
		 * @type {Object.<string,number>}
		 */
		this["mAttachedHandlerCache"] = {};

		// ..... AnyEvent Handlers ................................................

		/**
		 * Id to remove the help button AnyEvent handler
		 * @see UCF_EditFieldBase#showButton()
		 * @type {string}
		 */
		this["sHelpButtonAnyEventHandlerId"] = null;

		/**
		 * Id to remove the field help AnyEvent handler
		 * @see UCF_EditFieldBase#openFieldHelp()
		 * @type {string}
		 */
		this["sFieldHelpAnyEventHandlerId"] = null;

		/**
		 * Id to remove the blur AnyEvent handler
		 * @see UCF_EditFieldBase#onlsfocus()
		 * @type {string}
		 */
		this["sBlurAnyEventHandlerId"] = null;

		/** @type {Object.<string, UCF_EditFieldBase_AnyEventHandler>} */
		this["oAnyEventHandlers"] = [];

		oCtParentRef = UCF_DomUtil["oGetParentByAttribute"](this["oRootRef"], 'ct');
		/** @type {boolean} */
		this["bUsedInDataGrid"] = oCtParentRef && oCtParentRef["getAttribute"]('ct') === 'DGSC';
		this["bUsedInToolbar"] = oCtParentRef && oCtParentRef["getAttribute"]('ct') === 'T';

		// ..... Delegates ........................................................
		this["oNavigation"] = this["bUsedInToolbar"]
			? new (UCF_ClassLoader["oGetClass"]("UCF_ToolbarFieldNavigationDelegate"))(this)
			: (this["bUsedInSapTable"] || this["bUsedInDataGrid"])
			? new (UCF_ClassLoader["oGetClass"]("UCF_TableFieldNavigationDelegate"))(this)
			: new (UCF_ClassLoader["oGetClass"]("UCF_FieldNavigationDelegate"))(this);
		this["addDelegate"](this["oNavigation"], true);

		/** @type {boolean} */
		this["bIsFakeField"] = this["oDomRef"]["nodeName"] === 'SPAN';
		/** @type {boolean} */
		this["bFakeFieldExchangeInProcess"] = false;
		if (this["bIsFakeField"] && this["bIsWriteable"]()) {
			// replace <span> by <input> for read only and writeable fields only
			// eslint-disable-next-line @ur/no-memory-leaks
			this["oFakeFieldDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Fields_HideFakeFieldDelegate"))(this);
			this["addDelegate"](this["oFakeFieldDelegate"], true);
		}

		if (!this["bUsedInSapTable"] && UCF_UserAgent["bIsFirefox"]()) {
			this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_Fields_FirefoxSelectDelegate"))(this));
		}

		if (this["sTabBehaviour"] !== 'STANDARD') {
			this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_Fields_AutoTabDelegate"))(this));
		}

		/** @type {boolean} */
		this["bDataTipAutoShowOnFocus"] = false;

		/** @type {boolean} */
		this["bDataTipAutoShowOnFirstFocus"] = false;

		/**
		 * Fields of type InputFieldFieldHelp.SEARCH will provide a clear button,
		 * by pressing the button the value within the field will be cleared
		 *
		 * @type {HTMLSpanElement}
		 */
		this["oClearRef"] = null;
		if (this["sFieldHelp"] === 'SEARCH') {
			this["oClearRef"] = UCF_DomUtil["$"](this["sId"] + '-clear');
		}
	}
};window["UCF_EditFieldBase"] = UCF_EditFieldBase; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_EditFieldBase"); UCF_EditFieldBase["_"] = {UCF_EditFieldBase: 0}; }; ;
UCF_EditFieldBase["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_EditFieldBase.prototype["sClassName"] = "UCF_EditFieldBase";
// #endregion
// #region constants ##########################################################
/** @constant {string} */
UCF_EditFieldBase["HELPBUTTON_ID"] = 'ls-inputfieldhelpbutton';
/**
 * @protected
 * @type {UCF_EditFieldBase_ChangeReasonEnum}
 */
UCF_EditFieldBase["E_CHANGE_REASON"] = {
	"Other": 0,
	"BlurByTab": 1,
	"Enter": 2
};
// #endregion
// #region lifecycle ##########################################################
// #region   constructor ======================================================
/** @private */
UCF_EditFieldBase["prototype"]["readLsdata"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["readLsdata"]++; }; 
	/** @type {string[]} */
	var aClasses = this["oRootRef"]["className"]["split"](/\s+/g);

	/** @type {boolean} */
	this["bHasIconColumn"] = UCF_JsUtil["contains"](aClasses, 'lsField--hasicon');

	/** @type {boolean} */
	this["bPasswordField"] = this["oDomRef"]["getAttribute"]('type') === 'password';

	/** @type {boolean} */
	this["bEnabled"] = !UCF_JsUtil["contains"](aClasses, 'lsField--disabled');

	/** @type {string} */
	this["sName"] = this["oDomRef"]["getAttribute"]('name') || '';

	/** @type {boolean} */
	this["bUsedInSapTable"] = UCF_JsUtil["contains"](aClasses, 'lsField--table');

	/** @type {boolean} */
	this["bReadonly"] = UCF_JsUtil["contains"](aClasses, 'lsField--readonly');

	/** @type {boolean} */
	this["bInvalid"] = false;
	/** @type {string} */
	this["sInputState"] = 'NONE';
	if (UCF_JsUtil["contains"](aClasses, 'lsField--warning')) {
		/** @type {string} */
		this["sInputState"] = 'WARNING';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--error')) {
		/** @type {boolean} */
		this["bInvalid"] = true;
		/** @type {string} */
		this["sInputState"] = 'ERROR';
	}

	/** @type {number} */
	this["iLength"] = parseInt(this["oDomRef"]["getAttribute"]('size') || '20');

	/** @type {number} */
	this["iMaxLength"] = parseInt(this["oDomRef"]["getAttribute"]('maxlength') || '0');

	/** @type {string} */
	this["sTooltip"] = this["oDomRef"]["getAttribute"]('title') || '';

	if (UCF_JsUtil["contains"](aClasses, 'lsField--list')) {
		/** @type {string} */
		this["sFieldHelp"] = 'DEFAULT';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--calendar') ||
		UCF_JsUtil["contains"](aClasses, 'lsField--datetime') ||
		UCF_JsUtil["contains"](aClasses, 'lsField--time')) {
		/** @type {string} */
		this["sFieldHelp"] = 'CALENDAR';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--f4')) {
		/** @type {string} */
		this["sFieldHelp"] = 'F4LOOKUP';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--filterfields')) {
		/** @type {string} */
		this["sFieldHelp"] = 'FILTERFIELDS';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--calculator')) {
		/** @type {string} */
		this["sFieldHelp"] = 'CALCULATOR';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--spinner')) {
		/** @type {string} */
		this["sFieldHelp"] = 'SPINNER';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--search')) {
		/** @type {string} */
		this["sFieldHelp"] = 'SEARCH';
	}

	/** @type {string} */
	this["sDesign"] = UCF_JsUtil["contains"](aClasses, 'lsField--monospace')
		? 'MONOSPACE'
		: 'STANDARD';

	/** @type {boolean} */
	this["bRequired"] = UCF_JsUtil["contains"](aClasses, 'lsField--required');

	/** @type {boolean} */
	this["bShowRequiredIndicator"] = UCF_JsUtil["contains"](aClasses, 'lsField--requiredindicator');

	// can't use this.bIsTableRenderMode() because constructor is not run
	// completely and we'd end up in an endless loop
	/** @type {string} */
	this["sWidth"] = (UCF_JsUtil["contains"](aClasses, 'lsField--explicitwidth') && (
		this["oRootRef"]["nodeName"] === 'TABLE'
		? this["oRootRef"]["style"]["width"]
		: this["oDomRef"]["style"]["width"]
	)) || '';

	/** @type {string} */
	this["sHeight"] = (UCF_JsUtil["contains"](aClasses, 'lsField--explicitheight') &&
		this["oRootRef"]["style"]["height"]) || '';

	/** @type {boolean} */
	this["bTextOverflowEllipsis"] = UCF_JsUtil["contains"](aClasses, 'lsField--hasellipsis');

	/** @type {string} */
	this["sInputPrompt"] = (
		!this["bShowRequiredIndicator"] &&
		UCF_JsUtil["contains"](aClasses, 'lsField--inputprompt') &&
		this["bUsesValueForIndicators"]()
		? this["sGetDomRefValue"]()
		: this["oDomRef"]["getAttribute"]('placeholder')
	) || '';

	/** @type {boolean} */
	this["bUpperCase"] = UCF_JsUtil["contains"](aClasses, 'lsField--uppercase');

	/** @type {boolean} */
	this["bAutocorrect"] = this["oDomRef"]["getAttribute"]('autocorrect') === 'on';

	/** @type {string} */
	this["sTextStyle"] = UCF_EditFieldBase["sGetTextStyle"](this["oRootRef"]); // eslint-disable-line @ur/no-missing-setClientProperty

	/** @type {string} */
	this["sAlign"] = 'LEFT';
	if (UCF_JsUtil["contains"](aClasses, 'lsField--forcedleft')) {
		/** @type {string} */
		this["sAlign"] = 'FORCEDLEFT';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--center')) {
		/** @type {string} */
		this["sAlign"] = 'CENTER';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--right')) {
		/** @type {string} */
		this["sAlign"] = 'RIGHT';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--endofline')) {
		/** @type {string} */
		this["sAlign"] = 'ENDOFLINE';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--forcedright')) {
		/** @type {string} */
		this["sAlign"] = 'FORCEDRIGHT';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--beginofline')) {
		/** @type {string} */
		this["sAlign"] = 'BEGINOFLINE';
	}

	/** @type {string} */
	this["sTextDirection"] = 'INHERIT';
	if (UCF_JsUtil["contains"](aClasses, 'lsField--ltr')) {
		/** @type {string} */
		this["sTextDirection"] = 'LTR';
	}
	if (UCF_JsUtil["contains"](aClasses, 'lsField--rtl')) {
		/** @type {string} */
		this["sTextDirection"] = 'RTL';
	}

	/** @type {string} */
	this["sPaddingInSapTable"] = (this["bUsedInSapTable"] && this["oDomRef"]["style"]["padding"]) || '';
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["readLsdata"] = 0; };

/**
 * @private
 * @static
 * @param {HTMLSpanElement|HTMLTableElement} oRootRef
 * @return {string}
 */
UCF_EditFieldBase["sGetTextStyle"] = function(oRootRef) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetTextStyle"]++; }; 
	/** @type {boolean} */
	var bBold = UCF_DomUtil["bHasClass"](oRootRef, 'lsField--bold');
	/** @type {boolean} */
	var bItalic = UCF_DomUtil["bHasClass"](oRootRef, 'lsField--italic');
	/** @type {boolean} */
	var bUnderline = UCF_DomUtil["bHasClass"](oRootRef, 'lsField--underline');
	/** @type {boolean} */
	var bHotspot = UCF_DomUtil["bHasClass"](oRootRef, 'lsField--hotspot');

	return UCF_JsUtil["filter"](
		[
			bBold && 'BOLD',
			bItalic && 'ITALIC',
			bUnderline && 'UNDERLINE',
			bHotspot && 'HOTSPOT'
		],
		function(b) { return b; }
	)["join"]('_');
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetTextStyle"] = 0; };
// #endregion
// #region   initialize =======================================================
/**
 * initialize called even if derived class is combobox
 *
 * @private
 */
UCF_EditFieldBase["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["initialize"]++; }; 
	this["applyWorkarounds"]();
	this["onAfterInitialize"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["initialize"] = 0; };
// #region after --------------------------------------------------------------
/** @protected */
UCF_EditFieldBase["prototype"]["onAfterInitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterInitialize"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterInitialize"] = 0; };
// #endregion
// #endregion
// #region   destroy ==========================================================
/**
 * @private
 * @final
 */
UCF_EditFieldBase["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["destroy"]++; }; 
	/** @type {UCF_Page} */
	var oPage;
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow;

	if (!this["bIsDestroyed"]) {
		this["fireEvent"](this["E_EVENTS"]["WillDestroy"], {});

		this["onBeforeDestroy"]();

		// CSN 483172 / 2020: closeFieldHelp() may result in oDataTip.open()  which
		// creates the field again, which results in an infinite loop. Calling
		// removeDataTip() before (which otherwise happens in UCF_Control#destroy())
		// circumvents that.
		this["removeDataTip"]();

		this["closeFieldHelp"](true);

		if (this["sTimeOutId"]) { // clear timer of method mouseover
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}

		// hide not permanent help button
		if (this["oHelpButton"] && !this["oHelpButton"]["bIsDestroyed"]) {
			this["hideButton"]();
			this["oHelpButton"] = null;
		}
		this["oHelpButtonRef"] = null;

		this["detachOnce"]('resize');

		oBrowserWindow = this["oLS"]["oBrowserWindow"];
		if (oBrowserWindow) {
			oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Tap"], this, 'onTap');
			oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
			oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["LayoutChange"], this, 'onLayoutChange');
		}
		this["oAnyEventHandlers"] = {};
		this["mAttachedHandlerCache"]["AnyEvent"] = undefined;

		// Detach the page before resize event, ITS speciale
		if (this["oLS"]["bAlternativeKeyboardHandling"]) {
			oPage = this["oLS"]["oGetPageInternal"]();
			if (oPage && !oPage["bIsDestroyed"]) {
				oPage["detachEvent"](
					oPage["E_EVENTS"]["BeforeResize"],
					this,
					'onBeforeResizePage'
				);
			}
		}
		this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);

		this["oCache"]["destroy"]();

		if (this["bUsedInSapTable"] &&
			this["oParentControl"] &&
			(UCF_JsUtil["bInstanceOf"](this["oParentControl"], 'UCF_SapTable') || UCF_JsUtil["bInstanceOf"](this["oParentControl"], 'UCF_SapTableCS'))) {
			this["detachEvent"](this["E_EVENTS"]["EditMode"], this["oParentControl"], "onCellEditorEditMode");
			this["detachEvent"](this["E_EVENTS"]["NavigationMode"], this["oParentControl"], "onCellEditorNavigationMode");
		}

		this["bIsAsteriskRequiredIndicator"] = null;
		this["bCurrentValueInputPrompt"] = null;
		this["bIsHighlightFocused"] = null;
		this["bInvalid"] = null;
		this["iSelectionStart"] = null;
		this["iSelectionEnd"] = null;
		this["iCursorPos"] = null;
		this["sCustomStyle"] = null; // eslint-disable-line @ur/no-missing-setClientProperty

		this["oInteractionState"] = null;
		this["oCache"] = null;
		this["oNavigation"] = null;
		this["oFakeFieldDelegate"] = null;
		this["oClearRef"] = null;
		this["oOverlayDelegate"] = null; // eslint-disable-line @ur/no-memory-leaks

		this["sHelpButtonAnyEventHandlerId"] = null;
		this["sFieldHelpAnyEventHandlerId"] = null;
		this["sBlurAnyEventHandlerId"] = null;
		this["bUsedInDataGrid"] = null;
		this["bUsedInToolbar"] = null;
		this["bDataTipAutoShowOnFocus"] = null;
		this["bDataTipAutoShowOnFirstFocus"] = null;
		this["bHasIconColumn"] = null;
		this["bPasswordField"] = null;
		this["bEnabled"] = null;
		this["sName"] = null;
		this["bUsedInSapTable"] = null;
		this["bReadonly"] = null;
		this["iLength"] = null;
		this["iMaxLength"] = null;
		this["sTooltip"] = null;
		this["sDesign"] = null;
		this["bRequired"] = null;
		this["bShowRequiredIndicator"] = null;
		this["sWidth"] = null;
		this["sHeight"] = null;
		this["bTextOverflowEllipsis"] = null;
		this["sInputPrompt"] = null;
		this["bUpperCase"] = null;
		this["bAutocorrect"] = null;
		this["sTextStyle"] = null; // eslint-disable-line @ur/no-missing-setClientProperty
		this["sPaddingInSapTable"] = null;
		this["sOriginalWidth"] = null;
		this["bLabelTextRemoved"] = null;
		this["sInputState"] = null;
		this["sVisibility"] = null;
		this["bIsFakeField"] = null;
		this["bFakeFieldExchangeInProcess"] = null;
	}

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["destroy"] = 0; };
// #region     before ---------------------------------------------------------
/** @protected */
UCF_EditFieldBase["prototype"]["onBeforeDestroy"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeDestroy"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeDestroy"] = 0; };
// #endregion
// #endregion
// #region   iGetOptimalWidth =================================================
/**
 * @override
 * @see {UCF_Control#iGetOptimalWidth}
 * @return {number} the optimal width for the control based on the current value
 */
UCF_EditFieldBase["prototype"]["iGetOptimalWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["iGetOptimalWidth"]++; }; 
	/** @type {HTMLSpanElement|HTMLTableElement} */
	var oCloneRootRef = this["oRootRef"]["cloneNode"](true);
	/** @type {HTMLInputElement|HTMLSpanElement} */
	var oCloneDomRef = UCF_DomUtil["oGetFirstChildByAttribute"](oCloneRootRef, 'id', this["sId"]);
	/** @type {NodeListOf<HTMLTableDataCellElement>} */
	var aCloneInputContainerRefs = oCloneRootRef["getElementsByTagName"]('TD') || [];
	/** @type {HTMLTableDataCellElement} */
	var oCloneInputContainerRef = UCF_JsUtil["find"](aCloneInputContainerRefs, function(oRef) {
		return UCF_DomUtil["bHasClass"](oRef, 'lsField__inputcontainer');
	});
	/** @type {HTMLSpanElement} */
	var oCloneSpanRef = document["createElement"]('span');
	/** @type {number} */
	var iWidth;

	UCF_DomUtil["setStyle"](oCloneRootRef, {
		"position": 'absolute',
		"top": '-99999px',
		"left": '-99999px',
		"width": 'auto',
		"tableLayout": 'auto'
	});

	if (oCloneDomRef["nodeName"] === 'INPUT') {
		oCloneSpanRef = document["createElement"]('span');
		UCF_DomUtil["setClass"](oCloneSpanRef, UCF_DomUtil["sGetClass"](oCloneDomRef));
		UCF_DomUtil["setInnerText"](oCloneSpanRef, oCloneDomRef["value"]);
		UCF_DomUtil["replaceElement"](oCloneDomRef, oCloneSpanRef);
	} else {
		oCloneSpanRef = oCloneDomRef;
	}

	if (oCloneInputContainerRef) {
		UCF_DomUtil["setStyle"](oCloneInputContainerRef, { "width": 'auto' });
	}

	UCF_DomUtil["setStyle"](oCloneSpanRef, { "width": 'auto' });

	UCF_DomUtil["prepend"](this["oLS"]["oGetAssociatedAreaRef"](), oCloneRootRef);

	iWidth = oCloneRootRef["offsetWidth"];

	UCF_DomUtil["removeFromDom"](oCloneRootRef);

	return iWidth;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["iGetOptimalWidth"] = 0; };
// #endregion
// #region   colorizeHighlightedText ==========================================
/**
 * @override
 * @private
 * @see {UCF_Control#colorizeHighlightedText}
 * @param {number} iStart
 * @param {number} iLength
 * @param {string} sTextProperty
 * @param {boolean} bFocused
 */
UCF_EditFieldBase["prototype"]["colorizeHighlightedText"] = function(iStart, iLength, sTextProperty, bFocused) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["colorizeHighlightedText"]++; }; 
	this["bIsHighlighted"] = true;
	this["bIsHighlightFocused"] = !!bFocused;

	this["updateStyles"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["colorizeHighlightedText"] = 0; };
// #endregion
// #region   collectFocusInfo =================================================

/**
 * @see UCF_Control.prototype.collectFocusInfo
 * @param {UCF_FocusInfo} oFocusInfo the focus info to collect to
 * @private
 */
UCF_EditFieldBase["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["collectFocusInfo"]++; }; 
	/** @type {number} */
	var iCursorPos;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oFocusInfo, 'UCF_FocusInfo'), "UCF_JsUtil.bInstanceOf(oFocusInfo, 'UCF_FocusInfo')", "EditFieldBase.js(860): collectFocusInfo"); };

	iCursorPos = UCF_DomUtil["iGetCursorPos"](this["oDomRef"]);

	oFocusInfo["setApplyControl"](this);
	oFocusInfo["addParam"]('iSelectionStart', this["iGetSelectionStart"]());
	oFocusInfo["addParam"]('iSelectionEnd', this["iGetSelectionEnd"]());
	if (iCursorPos >= 0) {
		oFocusInfo["addParam"]('iCursorPos', iCursorPos);
	}

	// store sValue to check in applyFocusInfo if the value was changed
	// on the backend side
	oFocusInfo["addParam"]('sValue', this["sGetCurrentValue"]());

	if (this["bUsedInSapTable"] || this["bUsedInToolbar"]) {
		oFocusInfo["addParam"]('bEditMode', this["oNavigation"]["bIsEditMode"]());
		oFocusInfo["setApplyControl"](this);
	}

};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["collectFocusInfo"] = 0; };
// #endregion
// #region   applyFocusInfo ===================================================
/**
 * @see UCF_Control.prototype.applyFocusInfo
 * @param {UCF_FocusInfo} oFocusInfo the focus info to apply
 * @return {boolean} false if focusing failed
 * @private
 */
// eslint-disable-next-line complexity
UCF_EditFieldBase["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["applyFocusInfo"]++; }; 
	/** @type {boolean} */
	var bEditMode;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oFocusInfo, 'UCF_FocusInfo'), "UCF_JsUtil.bInstanceOf(oFocusInfo, 'UCF_FocusInfo')", "EditFieldBase.js(894): applyFocusInfo"); };

	// sometimes the first focus doesn't work. Focus is lost.
	// Second try solved the issue - strange fix. CSN 0000239033 2012
	if (!UCF_DomUtil["bFocusDomElement"](this["oFocusDomRef"])) {
		try {
			this["oFocusDomRef"]["focus"]();
		} catch (oException) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, oException + ' ', "EditFieldBase.js(902): applyFocusInfo"); };

			this["oFocusDomRef"] = this["oGetFocusDomRef"]();

			return false;
		}
	}

	if (this["sGetCurrentValue"]() === oFocusInfo["oGetParam"]('sValue')) {
		this["iCursorPos"] = oFocusInfo["oGetParam"]('iCursorPos');
		this["iSelectionStart"] = oFocusInfo["oGetParam"]('iSelectionStart');
		this["iSelectionEnd"] = oFocusInfo["oGetParam"]('iSelectionEnd');

		if (this["iSelectionStart"] >= 0 &&
			this["iSelectionStart"] <= this["iSelectionEnd"]
		) {
			this["setSelectionInternal"](this["oFocusDomRef"], this["iSelectionStart"], this["iSelectionEnd"]);
		} else if (this["iCursorPos"] >= 0) {
			UCF_DomUtil["setCursorPos"](this["oFocusDomRef"], this["iCursorPos"]);
		}
	} else {
		// if the value has been changed by the backend we select it
		// to prevent the wrong focusInfo from being applied
		// like only partly highlighting the value or wrong cursor position
		this["select"]();
	}

	if (this["bUsedInSapTable"] || this["bUsedInToolbar"]) {
		bEditMode = oFocusInfo["oGetParam"]('bEditMode');
		if (this["oNavigation"]["bIsEditMode"]() !== bEditMode) {
			if (bEditMode) {
				this["oNavigation"]["editMode"]();
			} else {
				this["oNavigation"]["navigationMode"]();
			}
		}
	}
	this["oFocusDomRef"] = this["oGetFocusDomRef"]();

	return true;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["applyFocusInfo"] = 0; };
// #endregion
// #region onPendingRequest ===================================================
/**
 * @private
 * @param {UCF_Event} oEvent
 */
UCF_EditFieldBase["prototype"]["onPendingRequest"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onPendingRequest"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["WillSubmitPendingRequest"], {
		"oPendingRequest": oEvent["oGetParam"]('oPendingRequest')
	});
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onPendingRequest"] = 0; };
// #endregion
// #region   select ===========================================================
/** @protected */
UCF_EditFieldBase["prototype"]["select"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["select"]++; }; 
	if (this["bIsWriteable"]() && this["bShouldSelect"]() && this["oFocusDomRef"]["select"]) {
		this["setSelectionInternal"](
			this["oFocusDomRef"],
			0,
			this["sGetDomRefValue"]()["length"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["select"] = 0; };

/**
 * @protected
 * @return {boolean} `true` (default).
 */
UCF_EditFieldBase["prototype"]["bShouldSelect"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldSelect"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldSelect"] = 0; };
// #endregion
// #region   focus ============================================================
/**
 * @see UCF_Control#focus
 * @override
 */
UCF_EditFieldBase["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["focus"]++; }; 
	if (UCF_DomUtil["oGetActiveElement"]() !== this["oFocusDomRef"]) {
		this["bNoBlur"] = false;

		// CSN 288956 2019: focusin/lsfocus is not dispatched while BrowserWindow
		// is locked => hide fake field manually
		if (this["oFakeFieldDelegate"]) {
			this["oFakeFieldDelegate"]["hideFakeField"]();
		}

		UCF_Control.prototype["focus"]["apply"](this, arguments);

		// WDAUIUR1-2290: customer requirement is to initially select the value
		this["select"]();
	}
	this["oFocusDomRef"] = this["oGetFocusDomRef"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["focus"] = 0; };
// #endregion
// #region   refocus ==========================================================
/**
 * CSN 141430 2016: space is ignored in InputField and ComboBox
 *
 * UCF_Control#refocus really focuses a different HTMLElement whereas
 * UCF_DomUtil#refocusDomElement simply calls .blur() .focus() on the
 * given HTMLElement. The former seems to trigger way more event handling
 * than the latter (i.e. the inputfield value gets selected => a keystroke
 * afterwards deletes everything previously in the inputfield)
 *
 * @private
 * @param {HTMLElement?} oDomRef the element to focus. Defaults to
 * {{this.oFocusDomRef || this.oDomRef}}
 */
UCF_EditFieldBase["prototype"]["refocus"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["refocus"]++; }; 
	this["bRefocusInProgress"] = true;
	if (window["UCF_System"]["bIs508"]) {
		this["oNavigation"]["keepEditMode"]();
		UCF_DomUtil["refocusDomElement"](oDomRef || this["oFocusDomRef"] || this["oDomRef"]);
	}
	this["bRefocusInProgress"] = false;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["refocus"] = 0; };
// #endregion
// #region   moveFocus ========================================================
/**
 * @see UCF_Control
 * @private
 */
UCF_EditFieldBase["prototype"]["moveFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["moveFocus"]++; }; 
	if (this["bReadonly"] &&
		this["getEnabled"]() &&
		this["oDomRef"] &&
		this["oDomRef"]["tagName"] === 'INPUT' &&
		// eslint-disable-next-line no-magic-numbers
		UCF_UserAgent["bIsTrident"](4, true)
	) {
		this["focus"]();
		UCF_DomUtil["setCursorPos"](this["oFocusDomRef"], this["sGetDomRefValue"]()["length"]);
	} else {
		UCF_Control.prototype["moveFocus"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["moveFocus"] = 0; };
// #endregion
// #endregion
// #region event handlers #####################################################
// #region   AnyEvent =========================================================
/**
 * Listens for the AnyEvent. Add/remove handlers via sAddAnyEventHandler/
 * removeAnyEventHandler.
 *
 * @param {UCF_Event} oEvent the AnyEvent
 */
UCF_EditFieldBase["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAnyEvent"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');

	UCF_JsUtil["forEach"](
		UCF_JsUtil["values"](this["oAnyEventHandlers"]),
		function(oHandler) {
			if (oHandler["fWhen"](oBrowserEvent)) {
				oHandler["fThen"](oBrowserEvent);
			}
		}
	);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAnyEvent"] = 0; };
// #endregion
// #region   HelpButtonPress ==================================================
/**
 * @private
 * @final
 * @param {UCF_Event} oEvent the help button click event
 */
UCF_EditFieldBase["prototype"]["onHelpButtonPress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonPress"]++; }; 
	this["onBeforeHelpButtonPress"](oEvent);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonPress"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_Event} oEvent the help button click
 */
UCF_EditFieldBase["prototype"]["onBeforeHelpButtonPress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeHelpButtonPress"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeHelpButtonPress"] = 0; };
// #endregion
// #endregion
// #region   HelpButtonMousedown ==============================================
/**
 * @private
 * @final
 * @param {UCF_Event} oEvent the help button mousedown
 */
UCF_EditFieldBase["prototype"]["onHelpButtonMousedown"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonMousedown"]++; }; 
	/** @type {boolean} */
	var bIsOnUpperHalf = oEvent["oGetParam"]('bIsOnUpperHalf');

	if (oEvent["oGetParam"]('sConnectedControlId') === this["sId"]) {
		// if you click on the upper half and immediately after that on the
		// lower half, no mouseover is triggered and the mouse position still
		// contains the UpperHelpButtonHalf:true => need to update on mousedown
		this["setInteractionState"]({
			"MouseOnDown": true,
			"MouseOnUpperHelpButtonHalf": bIsOnUpperHalf,
			"MouseOnLowerHelpButtonHalf": !bIsOnUpperHalf
		});

		// set bMouseInteraction flag, so that the field is swapped onclick
		// required if user clicks on help button, not on the field itself
		if (this["oFakeFieldDelegate"]) {
			this["oFakeFieldDelegate"]["bMouseInteraction"] = true;
		}

		if (UCF_DomUtil["oGetActiveElement"]() !== this["oFocusDomRef"]) {
			this["oFocusDomRef"]["focus"]();
		}

		this["onAfterHelpButtonMousedown"](oEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonMousedown"] = 0; };
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_Event} oEvent the event
 */
UCF_EditFieldBase["prototype"]["onAfterHelpButtonMousedown"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterHelpButtonMousedown"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterHelpButtonMousedown"] = 0; };
// #endregion
// #endregion
// #region   HelpButtonMouseup ================================================
/**
 * @private
 * @final
 * @param {UCF_Event} oEvent the mouseup
 */
UCF_EditFieldBase["prototype"]["onHelpButtonMouseup"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonMouseup"]++; }; 
	if (oEvent["oGetParam"]('sConnectedControlId') === this["sId"]) {
		this["setInteractionState"]({ "MouseOnDown": false });
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonMouseup"] = 0; };
// #endregion
// #region   HelpButtonMouseover ==============================================
/**
 * @private
 * @final
 * @param {UCF_Event} oEvent the help button mouseover
 */
UCF_EditFieldBase["prototype"]["onHelpButtonMouseover"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonMouseover"]++; }; 
	/** @type {boolean} */
	var bIsOnUpperHalf = oEvent["oGetParam"]('bIsOnUpperHalf');

	if (oEvent["oGetParam"]('sConnectedControlId') === this["sId"]) {
		this["setInteractionState"]({
			"MouseOnInput": false,
			"MouseOnFieldHelp": false,
			"MouseOnClear": false,
			"MouseOnUpperHelpButtonHalf": bIsOnUpperHalf,
			"MouseOnLowerHelpButtonHalf": !bIsOnUpperHalf
		});
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonMouseover"] = 0; };
// #endregion
// #region   HelpButtonMouseout ===============================================
/**
 * @private
 * @final
 * @param {UCF_Event} oEvent the help button mouseout
 */
UCF_EditFieldBase["prototype"]["onHelpButtonMouseout"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonMouseout"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');

	if (oEvent["oGetParam"]('sConnectedControlId') === this["sId"]) {
		this["setMousePositionFromMouseout"](oBrowserEvent);

		if (this["bUsedInSapTable"] || (this["bDisplayAsText"] && !this["bHasVisibleFocus"]())) {
			if (!this["bIsMouseOverConnectedControl"](
					UCF_DomUtil["oGetRelatedTarget"](oBrowserEvent["oDomEvent"])
				) &&
				!this["oLS"]["bAlternativeKeyboardHandling"]
			) {
				this["hideButton"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonMouseout"] = 0; };
// #endregion
// #region   HelpButtonConnect ================================================
/**
 * @private
 * @final
 * @param {UCF_Event} oEvent the help button connect
 */
UCF_EditFieldBase["prototype"]["onHelpButtonConnect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonConnect"]++; }; 
	if (
		oEvent["oGetParam"]('sConnectedControlId') === this["sId"] &&
		this["bFieldHelpEmbedding"] &&
		typeof this["sOriginalWidth"] !== 'string'
	) {
		this["sOriginalWidth"] = this["oDomRef"]["style"]["width"];
		UCF_DomUtil["setStyle"](
			this["oDomRef"], { "width": (this["oDomRef"]["offsetWidth"] - oEvent["oGetParam"]('iWidth')) + 'px' }
		);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonConnect"] = 0; };
// #endregion
// #region   HelpButtonDisconnect =============================================
/**
 * @private
 * @final
 * @param {UCF_Event} oEvent the help button disconnect
 */
UCF_EditFieldBase["prototype"]["onHelpButtonDisconnect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonDisconnect"]++; }; 
	if (oEvent["oGetParam"]('sConnectedControlId') === this["sId"]) {
		if (this["bFieldHelpEmbedding"]) {
			UCF_DomUtil["setStyle"](this["oDomRef"], { "width": this["sOriginalWidth"] });
			delete this["sOriginalWidth"];
		}
		if (oEvent["oGetParam"]('bHasFocus')) {
			this["focus"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onHelpButtonDisconnect"] = 0; };
// #endregion
// #region   ResizePage =======================================================
/**
 * @private
 * @param {UCF_Event} oEvent the page resize
 */
UCF_EditFieldBase["prototype"]["onBeforeResizePage"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeResizePage"]++; }; 
	try {
		this["fireEvent"](this["E_EVENTS"]["WillPageResize"], oEvent);
		if (
			this["oDomRef"] &&
			this["oLS"]["bAlternativeKeyboardHandling"] &&
			this["bIsWriteable"]()
		) {
			this["prepareFireChange"]();
		}
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeResizePage"] = 0; };
// #endregion
// #region   CellDataUpdate ===================================================
/**
 * @private
 * @final
 */
UCF_EditFieldBase["prototype"]["onBeforeCellDataUpdate"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeCellDataUpdate"]++; }; 
	try {
		this["prepareFireChange"]();
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeCellDataUpdate"] = 0; };
// #endregion
// #region   dblclick =========================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the dblclick
 */
UCF_EditFieldBase["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["ondblclick"]++; }; 
	if (this["bShouldHandleDblclick"]()) {
		if (this["bShouldFireChangeOnDblclick"]()) {
			try {
				this["prepareFireChange"]();
			} catch (oException) {
				this["handleEarlyHandlerLeave"](oException);
			}
		}
		this["fireDoubleClick"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
	this["onAfterDblclick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["ondblclick"] = 0; };

// #region should? ------------------------------------------------------------
/**
 * @private
 * @return {boolean}
 */
UCF_EditFieldBase["prototype"]["bShouldHandleDblclick"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldHandleDblclick"]++; }; 
	return this["bHasEventListeners"]('DoubleClick')
		|| this["mEvents"]["DoubleClick"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldHandleDblclick"] = 0; };

/**
 * @protected
 * @return {boolean} `true` if a change should be fired, otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bShouldFireChangeOnDblclick"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldFireChangeOnDblclick"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldFireChangeOnDblclick"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the dblclick
 */
UCF_EditFieldBase["prototype"]["onAfterDblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterDblclick"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterDblclick"] = 0; };
// #endregion
// #endregion
// #region   contextmenu ======================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the contextmenu
 */
UCF_EditFieldBase["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oncontextmenu"]++; }; 
	try {
		this["prepareFireChange"]();
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oncontextmenu"] = 0; };
// #endregion
// #region   keydown ==========================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the keydown
 */
UCF_EditFieldBase["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onkeydown"]++; }; 
	try {
		// IE11 doesn't fire paste events on readonly inputs. The ComboBox in
		// Behavior=DROPDOWNLISTBOX has a readonly input and therefore does not
		// get paste events. Simulating the paste event ([CTRL][V] keydown -> call
		// onpaste()) does not work because the clipboard access in onpaste() would
		// not be from a first-class event. So we have to remove the readonly
		// attribute and add it after the keyup.
		if (
			UCF_UserAgent["bIsIE"]() &&
			UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["V"], 'C') &&
			this["oDomRef"]["getAttribute"]('readonly')
		) {
			this["oDomRef"]["removeAttribute"]('readonly');
			this["oDomRef"]["setAttribute"]('data-readonly', true);
		}

		if (UCF_BrowserEvent["bTouchInteraction"]) {
			this["handleFieldOverlayEvents"]();
		}

		this["onBeforeKeydown"](oBrowserEvent);

		if (this["bRequired"] &&
			this["bShowRequiredIndicator"] &&
			this["sValue"] === '' &&
			this["sGetDomRefValue"]() === '*'
		) {
			this["bIsAsteriskRequiredIndicator"] = false;
		}
		if (this["bCurrentValueInputPrompt"]) {
			this["bCurrentValueInputPrompt"] = false;
		}

		this["onAfterKeydown"](oBrowserEvent);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onkeydown"] = 0; };
// #region before -------------------------------------------------------------
/**
 * Lifecycle hook called before handling the keydown in the EditFieldBase
 *
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the keydown
 */
UCF_EditFieldBase["prototype"]["onBeforeKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeKeydown"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeKeydown"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the keydown
 */
UCF_EditFieldBase["prototype"]["onAfterKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterKeydown"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterKeydown"] = 0; };
// #endregion
// #endregion
// #region   onkeyup ==========================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oKeyup
 */
UCF_EditFieldBase["prototype"]["onkeyup"] = function(oKeyup) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onkeyup"]++; }; 
	try {
		this["onBeforeKeyup"](oKeyup);

		this["updateStyles"]();

		this["onAfterKeyup"](oKeyup);

		if (UCF_UserAgent["bIsIE"]() && UCF_DomUtil["dataset"](this["oDomRef"])["readonly"]) {
			this["oDomRef"]["removeAttribute"]('data-readonly');
			this["oDomRef"]["setAttribute"]('readonly', true);
		}
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onkeyup"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oKeyup
 */
UCF_EditFieldBase["prototype"]["onBeforeKeyup"] = function(oKeyup) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeKeyup"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeKeyup"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oKeyup
 */
UCF_EditFieldBase["prototype"]["onAfterKeyup"] = function(oKeyup) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterKeyup"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterKeyup"] = 0; };
// #endregion
// #endregion
// #region   paste ============================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the paste
 * @return {boolean}
 */
UCF_EditFieldBase["prototype"]["onpaste"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onpaste"]++; }; 
	if (this["bHasEventListeners"]('ClipboardTablePaste')) {
		UCF_ClipboardUtil["parseClipboard"](oBrowserEvent);
		if (UCF_ClipboardUtil["isTable"]()) {
			// eslint-disable-next-line no-magic-numbers
			if (UCF_UserAgent["bIsTrident"](7) || UCF_UserAgent["bIsEdgeHtml"]()) {
				UCF_JsUtil["delayedCall"](
					0,
					this,
					'fireClipboardTablePaste',
					[this["sId"], UCF_ClipboardUtil["getClipboardContents"]()]
				);
			} else {
				this["fireClipboardTablePaste"](
					this["sId"],
					UCF_ClipboardUtil["getClipboardContents"]()
				);
			}
			UCF_ClipboardUtil["cleanup"]();

			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();

			return true;
		}
	} else if (this["bUsedInSapTable"]) {
		if (UCF_ClipboardUtil["pasteToTable"](this, oBrowserEvent)) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();

			return true;
		}
	}

	this["onAfterPaste"](oBrowserEvent);

	UCF_JsUtil["delayedCall"](0, this, 'handleEditEvents', [oBrowserEvent]);

	return false;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onpaste"] = 0; };
// #region     handleEditEvents -----------------------------------------------
/** @private */
UCF_EditFieldBase["prototype"]["handleEditEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleEditEvents"]++; }; 
	if (this["bValueEdited"]() && !this["bIsDirty"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Checked value for changes ' + this["sGetValue"]() + ' !== ' + this["sValue"] + ' -> setting dirty state now!', "EditFieldBase.js(1475): handleEditEvents"); };
		this["bIsDirty"] = true;
		this["markDirty"](true);
		this["setPendingChange"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleEditEvents"] = 0; };
// #endregion
// #region     bValueEdited ---------------------------------------------------
/**
 * @private
 * @return {boolean} returns `true` if the value has been changed, else `false`
 */
UCF_EditFieldBase["prototype"]["bValueEdited"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bValueEdited"]++; }; 
	return this["sGetValue"]() !== this["sValue"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bValueEdited"] = 0; };
// #endregion
// #region     after ----------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_EditFieldBase["prototype"]["onAfterPaste"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterPaste"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterPaste"] = 0; };
// #endregion
// #endregion
// #region   cut ==============================================================
/**
 * @protected
 * @param {UCF_BrowserEvent} oCut the cut
 */
UCF_EditFieldBase["prototype"]["oncut"] = function(oCut) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oncut"]++; }; 
	UCF_JsUtil["delayedCall"](0, this, 'handleEditEvents', [oCut]);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oncut"] = 0; };
// #endregion
// #region   drop =============================================================
/**
 * @protected
 * @param {UCF_BrowserEvent} oDrop the drop
 */
UCF_EditFieldBase["prototype"]["ondrop"] = function(oDrop) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["ondrop"]++; }; 
	this["hideRequiredIndicator"]();

	UCF_JsUtil["delayedCall"](0, this, 'handleEditEvents', [oDrop]);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["ondrop"] = 0; };
// #endregion
// #region   lsleft ===========================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleft
 */
UCF_EditFieldBase["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsleft"]++; }; 
	try {
		this["onBeforeLsLeft"](oBrowserEvent);
		this["onAfterLsLeft"](oBrowserEvent);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsleft"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleft
 */
UCF_EditFieldBase["prototype"]["onBeforeLsLeft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsLeft"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsLeft"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleft
 */
UCF_EditFieldBase["prototype"]["onAfterLsLeft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsLeft"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsLeft"] = 0; };
// #endregion
// #endregion
// #region   lsright ==========================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsright
 */
UCF_EditFieldBase["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsright"]++; }; 
	try {
		this["onBeforeLsRight"](oBrowserEvent);
		this["onAfterLsRight"](oBrowserEvent);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsright"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsright
 */
UCF_EditFieldBase["prototype"]["onBeforeLsRight"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsRight"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsRight"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsright
 */
UCF_EditFieldBase["prototype"]["onAfterLsRight"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsRight"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsRight"] = 0; };
// #endregion
// #endregion
// #region   lsup =============================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsup
 */
UCF_EditFieldBase["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsup"]++; }; 
	try {
		this["onBeforeLsUp"](oBrowserEvent);
		if (this["bShouldHandleLsUp"](oBrowserEvent)) {
			this["onAfterLsUp"](oBrowserEvent);
		}
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsup"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsup
 */
UCF_EditFieldBase["prototype"]["onBeforeLsUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsUp"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsUp"] = 0; };
// #endregion
// #region should? ------------------------------------------------------------
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsup
 * @return {boolean} `true` if the lsup should be handled, otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bShouldHandleLsUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldHandleLsUp"]++; }; 
	return this["oNavigation"]["bIsEditMode"]() && this["bIsWriteable"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldHandleLsUp"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsup
 */
UCF_EditFieldBase["prototype"]["onAfterLsUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsUp"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsUp"] = 0; };
// #endregion
// #endregion
// #region   lsdown ===========================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdown
 */
UCF_EditFieldBase["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsdown"]++; }; 
	try {
		this["onBeforeLsDown"](oBrowserEvent);
		if (this["bShouldHandleLsDown"](oBrowserEvent)) {
			this["onAfterLsDown"](oBrowserEvent);
		}
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsdown"] = 0; };
// #region  lsdragstart =======================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdragstart
 */
UCF_EditFieldBase["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsdragstart"]++; }; 
	this["resetMousePosition"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsdragstart"] = 0; };
// #endregion
// #region  lsdragend =======================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdragend
 */
UCF_EditFieldBase["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsdragend"]++; }; 
	this["resetMousePosition"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsdragend"] = 0; };
// #endregion

// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdown
 */
UCF_EditFieldBase["prototype"]["onBeforeLsDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsDown"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsDown"] = 0; };
// #endregion
// #region should? ------------------------------------------------------------
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdown
 * @return {boolean} `true` if the lsdown should be handled, otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bShouldHandleLsDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldHandleLsDown"]++; }; 
	return this["oNavigation"]["bIsEditMode"]() && this["bIsWriteable"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldHandleLsDown"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdown
 */
UCF_EditFieldBase["prototype"]["onAfterLsDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsDown"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsDown"] = 0; };
// #endregion
// #endregion
// #region   resize ===========================================================
/** @protected */
UCF_EditFieldBase["prototype"]["onresize"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onresize"]++; }; 
	/** @type {UCF_InputFieldHelpButton} */
	var oHelpButton;

	try {
		// sensor animation frame might fire after field is destroyed, but sensor
		// does not know the control instance => can't clean up animation frames
		// in #destroy(), need to check here
		if (!this["bIsDestroyed"]) {
			this["onBeforeResize"]();

			oHelpButton = this["oGetHelpButton"]();
			if (oHelpButton && oHelpButton["bIsConnected"](this)) {
				oHelpButton["setPosition"]();
			}
		}
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onresize"] = 0; };
// #region   onLayoutChange ===================================================
/** @protected
 * @param { UCF_BrowserEvent } oEvent the event
 **/
UCF_EditFieldBase["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onLayoutChange"]++; }; 
	// resize will also occur when soft keyboard comes up on iPhone
	// but we don't want to close the overlay / field help then
	if (this["bIsInOverlayMode"]() && !UCF_UserAgent["bIsPhone"]()
		&& !UCF_UserAgent["bIsTablet"]()
		&& oEvent["oGetParam"]('bIsWindowResize') === true
	) {
		this["closeFieldHelp"]();
		this["fireEvent"](this["E_EVENTS"]["DidCloseFieldHelp"], {});
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onLayoutChange"] = 0; };
// #endregion
// #region before -------------------------------------------------------------
/** @protected */
UCF_EditFieldBase["prototype"]["onBeforeResize"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeResize"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeResize"] = 0; };
// #endregion
// #endregion
// #region   click ============================================================
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_EditFieldBase["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onclick"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	try {
		// reset focus to input element
		if (this["bShouldShowOverlay"]() &&
			this === oBrowserEvent["oGetSourceControl"]()) {
			this["handleFieldOverlayEvents"]();
			this["requestAnimationFrame"](function() {
				self["fireEvent"](self["E_EVENTS"]["DidClickToOpenOverlay"], {});
			});
		}

		this["onBeforeClick"](oBrowserEvent);

		// reset value if clear button was clicked
		if (oBrowserEvent["oGetSource"]() === this["oClearRef"]) {
			this["setCurrentValue"]('');
		}

		// in a table the floating help button needs to be displayed
		if (this["bHideFieldHelp"] && this["bUsedInSapTable"]) {
			this["showButton"]();
		}

		// An activate on the inputfield has to be fired when enabled -> ITS hotspot
		if (this["getEnabled"]() && this["bHasEventListeners"]('Activate')) {
			this["fireActivate"](this["sId"]);
		}

		this["onAfterClick"](oBrowserEvent);
		this["updateStyles"]();
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onclick"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_EditFieldBase["prototype"]["onBeforeClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeClick"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeClick"] = 0; };
// #endregion
// #endregion

// #region   mouseover ========================================================
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseover
 */
UCF_EditFieldBase["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onmouseover"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();

	// New behavior hovering over will launch the field help if within saptable
	// cell...
	if (
		this["bShouldConnectButtonOnHover"]() &&
		oSource !== this["oGetHelpButtonRef"]()
	) {
		this["showButton"]();
	}

	this["setMousePositionFromMouseover"](oBrowserEvent);
	this["setOverflowTooltip"]();
	this["setOverflowPlaceholder"]();

	this["onAfterMouseover"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onmouseover"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseout
 */
UCF_EditFieldBase["prototype"]["setMousePositionFromMouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setMousePositionFromMouseout"]++; }; 
	/** @type {HTMLElement} */
	var oRelatedRef = oBrowserEvent["oDomEvent"]["toElement"] ||
		oBrowserEvent["oDomEvent"]["relatedTarget"];
	/** @type {UCF_EditFieldBase_FieldHelp} */
	var oFieldHelp = this["oGetFieldHelp"]();

	if (
		UCF_DomUtil["bContains"](this["oRootRef"], oRelatedRef) ||
		oRelatedRef === this["oRootRef"] ||
		oRelatedRef === this["oGetHelpButtonRef"]() || (
			oFieldHelp &&
			UCF_DomUtil["bContains"](oFieldHelp["oRootRef"], oRelatedRef)
		)
	) {
		if (this["oHelpButton"] && this["oHelpButton"]["oConnectedControl"] === this) {
			this["setMousePositionFromMouseover"](oBrowserEvent, oRelatedRef);
		} else {
			this["resetMousePosition"]();
		}
	} else {
		this["resetMousePosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setMousePositionFromMouseout"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseover
 * @param {HTMLElement} [oSource=oBrowserEvent.oGetSource()] the source
 */
UCF_EditFieldBase["prototype"]["setMousePositionFromMouseover"] = function(oBrowserEvent, oSource) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setMousePositionFromMouseover"]++; }; 
	/** @type {boolean} */
	var bIsOnUpperHelpButtonHalf;
	/** @type {HTMLSpanElement|HTMLInputElement} */
	var oHelpButtonRef = this["oGetHelpButtonRef"]();
	var oSrc = oSource || oBrowserEvent["oGetSource"]();
	/** @type {boolean} */
	var bMouseButtonPressed = oBrowserEvent["oDomEvent"]["buttons"] === oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"];

	if (bMouseButtonPressed && this["bUsedInSapTable"]) {
		// if a Drag Session or Lasso Operation has been started in a table
		// don't update styles as the following events will be cancelled during
		// Drag and Drop, so that the input styles freeze, e.g. hover
		this["resetMousePosition"]();
	} else {
			if (oSrc === this["oDomRef"] || oSrc === this["oRootRef"]) {
				this["setInteractionState"]({
					"MouseOnInput": true,
					"MouseOnFieldHelp": false,
					"MouseOnClear": false,
					"MouseOnUpperHelpButtonHalf": false,
					"MouseOnLowerHelpButtonHalf": false
				});
			} else if (oSrc === oHelpButtonRef) {
				bIsOnUpperHelpButtonHalf = oBrowserEvent["iOffsetY"]() <
					// eslint-disable-next-line no-magic-numbers
					oHelpButtonRef["offsetHeight"] / 2;
				this["setInteractionState"]({
					"MouseOnInput": false,
					"MouseOnFieldHelp": false,
					"MouseOnClear": false,
					"MouseOnUpperHelpButtonHalf": bIsOnUpperHelpButtonHalf,
					"MouseOnLowerHelpButtonHalf": !bIsOnUpperHelpButtonHalf
				});
			} else if (oSrc === this["oClearRef"] || this["oClearRef"] && oSrc === this["oClearRef"]["parentElement"]) {
				this["setInteractionState"]({
					"MouseOnInput": false,
					"MouseOnFieldHelp": false,
					"MouseOnClear": true,
					"MouseOnUpperHelpButtonHalf": false,
					"MouseOnLowerHelpButtonHalf": false
				});
			} else {
			this["resetMousePosition"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setMousePositionFromMouseover"] = 0; };

/** @private */
UCF_EditFieldBase["prototype"]["resetMousePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["resetMousePosition"]++; }; 
	this["setInteractionState"]({
		"MouseOnInput": false,
		"MouseOnFieldHelp": false,
		"MouseOnClear": false,
		"MouseOnUpperHelpButtonHalf": false,
		"MouseOnLowerHelpButtonHalf": false
		// MouseOnDown: is not reset here, do this in onmousedown/onmouseup explicitly
	});
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["resetMousePosition"] = 0; };

/**
 * @private
 * @param { UCF_EditFieldBase_MousePosition } oInteractionState the mouse position
 */
UCF_EditFieldBase["prototype"]["setInteractionState"] = function(oInteractionState) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setInteractionState"]++; }; 
	this["oInteractionState"] = UCF_JsUtil["extend"](
		this["oInteractionState"],
		oInteractionState,
		UCF_BrowserEvent["bTouchInteraction"] ? {
			"MouseOnInput": false,
			"MouseOnUpperHelpButtonHalf": false,
			"MouseOnLowerHelpButtonHalf": false,
			"MouseOnFieldHelp": false,
			"MouseOnClear": false
		} : {}
	);
	this["updateStyles"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setInteractionState"] = 0; };

/**
 * @see #bShouldApplyOverflow
 * @private
 */
UCF_EditFieldBase["prototype"]["setOverflowTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setOverflowTooltip"]++; }; 
	if (this["bShouldApplyOverflow"]()) {
		this["oDomRef"]["title"] = UCF_DomUtil["sCreateTooltipText"](
			this["bHasOverflow"]() && this["sGetCurrentValue"](),
			this["sTooltip"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setOverflowTooltip"] = 0; };

/**
 * @see #bShouldApplyOverflow
 * @private
 */
UCF_EditFieldBase["prototype"]["setOverflowPlaceholder"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setOverflowPlaceholder"]++; }; 
	if (this["bShouldApplyOverflow"]() && !this["sGetCurrentValue"]()) {
		this["oDomRef"]["title"] = UCF_DomUtil["sCreateTooltipText"](
			this["bHasOverflowPlaceholder"]() && this["oDomRef"]["getAttribute"]('placeholder'),
			this["sTooltip"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setOverflowPlaceholder"] = 0; };

/**
 * @private
 * @return {boolean} `true` if the DomRef has an overflow, otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bHasOverflow"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bHasOverflow"]++; }; 
	return ((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())
		? UCF_DomUtil["oGetTextSize"](
			this["sGetCurrentValue"](),
			this["oDomRef"]["className"]
		)["width"]
		: this["oDomRef"]["scrollWidth"]) > this["oDomRef"]["clientWidth"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bHasOverflow"] = 0; };

/**
 * @private
 * @return {boolean} `true` if the DomRef has an overflow, otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bHasOverflowPlaceholder"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bHasOverflowPlaceholder"]++; }; 
	/** @type {number} */
	var iButtonWidth = this["oHelpButtonRef"] ? this["oHelpButtonRef"]["clientWidth"] : 0;

	return UCF_DomUtil["oGetTextSize"](
		this["oDomRef"]["getAttribute"]('placeholder') || "",
		this["oDomRef"]["className"] || ""
	)["width"] > this["oDomRef"]["clientWidth"] - iButtonWidth;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bHasOverflowPlaceholder"] = 0; };

/**
 * @private
 * @return {boolean} `true` if the current value or placeholder should be set as tooltip,
 * otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bShouldApplyOverflow"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldApplyOverflow"]++; }; 
	// show never in 508 mode (title is used for acc text there)
	return !window["UCF_System"]["bIs508"] && !this["bPasswordField"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldApplyOverflow"] = 0; };

// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseover
 */
UCF_EditFieldBase["prototype"]["onAfterMouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterMouseover"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterMouseover"] = 0; };
// #endregion
// #endregion
// #region   mouseout =========================================================
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseout
 */
UCF_EditFieldBase["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onmouseout"]++; }; 
	/** @type {HTMLElement} */
	var oRelatedTarget;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "EditFieldBase.js(2018): onmouseout"); };

	oRelatedTarget = oBrowserEvent["oDomEvent"]["toElement"]
		|| oBrowserEvent["oDomEvent"]["relatedTarget"];

	if (this["bShouldConnectButtonOnHover"]() &&
		!this["bIsMouseOverConnectedControl"](oRelatedTarget)
	) {
		this["hideButton"]();
	}

	// if (this.oHelpButton && this.oHelpButton.oConnectedControl === this) {
		this["setMousePositionFromMouseout"](oBrowserEvent);
	// }

	this["onAfterMouseout"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onmouseout"] = 0; };
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseout
 */
UCF_EditFieldBase["prototype"]["onAfterMouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterMouseout"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterMouseout"] = 0; };

/**
 * @param {HTMLElement} oRelatedTarget the target the mouse is over now
 * @return {boolean} `true` if the mouse is over a connected control (i.e. the
 * help button), otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bIsMouseOverConnectedControl"] = function(oRelatedTarget) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsMouseOverConnectedControl"]++; }; 
	return this["bIsMouseOverHelpButton"](oRelatedTarget)
		|| this["bIsMouseOverFieldHelp"](oRelatedTarget);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsMouseOverConnectedControl"] = 0; };
// #endregion
// #endregion
// #region   mousedown ========================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the mousedown
 */
UCF_EditFieldBase["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onmousedown"]++; }; 
	/** @type {HTMLElement} */
	var oSource;

	try {
		if (this["bEnabled"] || window["UCF_System"]["bIs508"]) {
			this["onBeforeMousedown"](oBrowserEvent);

			this["setMousePositionFromMouseover"](oBrowserEvent);
			this["setInteractionState"]({ "MouseOnDown": true });

			if (!this["bSkipEventProcessing"](oBrowserEvent)) {
				oSource = oBrowserEvent["oGetSource"]();

				if (
					(oSource === this["oGetHelpButtonRef"]() || oSource === this["oClearRef"]) &&
					UCF_DomUtil["oGetActiveElement"]() === this["oFocusDomRef"]
				) {
					this["bNoBlur"] = true;
				}

				if (this["getEnabled"]()) {
					oBrowserEvent["cancelBubble"]();
				}

				this["onAfterMousedown"](oBrowserEvent);
			}
		}
		// do not cancel the event for disabled fields to allow seletion with mouse
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onmousedown"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mousedown
 */
UCF_EditFieldBase["prototype"]["onBeforeMousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeMousedown"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeMousedown"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mousedown
 */
UCF_EditFieldBase["prototype"]["onAfterMousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterMousedown"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterMousedown"] = 0; };
// #endregion
// #endregion
// #region   mouseup ==========================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseup
 */
UCF_EditFieldBase["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onmouseup"]++; }; 
	try {
		this["onBeforeMouseup"](oBrowserEvent);

		this["setInteractionState"]({ "MouseOnDown": false });

		this["onAfterMouseup"](oBrowserEvent);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onmouseup"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseup
 */
UCF_EditFieldBase["prototype"]["onBeforeMouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeMouseup"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeMouseup"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseup
 */
UCF_EditFieldBase["prototype"]["onAfterMouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterMouseup"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterMouseup"] = 0; };
// #endregion
// #endregion
// #region   lshotkey =========================================================
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey
 */
UCF_EditFieldBase["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlshotkey"]++; }; 
	// todo: implement special treatment for table. Question is how to handle
	// ctrl+a. Suggestion is in navigation mode ctrl+a select the row but in
	// edit mode ctrl+a selects the text.
	if (this["bIsHotkeyHandledLocally"](oBrowserEvent)) {
		oBrowserEvent["cancelBubble"]();
	} else if (this["bIsWriteable"]() || (this["bUsedInSapTable"] && this["bReadonly"])) {
		this["handleExternalHotkey"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlshotkey"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey
 * @return {boolean} `true` if the hotkey is handled locally, otherwise `false`
 */
// eslint-disable-next-line complexity
UCF_EditFieldBase["prototype"]["bIsHotkeyHandledLocally"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsHotkeyHandledLocally"]++; }; 
	return UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["C"], 'C')
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["X"], 'C')
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["V"], 'C')
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["Z"], 'C')
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["Y"], 'C')
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["DELETE"])
		|| UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["INSERT"])
		// || (UCF_KeyboardHelper.bIsEventForKey(oBrowserEvent, UCF_KeyCodes.F2)
		// 	&& this.bUsedInSapTable)
		|| (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["A"], 'C')
			&& (!this["bUsedInSapTable"] || this["oNavigation"]["bIsEditMode"]()));
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsHotkeyHandledLocally"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey
 */
UCF_EditFieldBase["prototype"]["handleExternalHotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleExternalHotkey"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleExternalHotkey"] = 0; };
// #endregion
// #region   lsenter ==========================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsenter
 */
UCF_EditFieldBase["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsenter"]++; }; 
	try {
		this["onBeforeLsEnter"](oBrowserEvent);
		this["onAfterLsEnter"](oBrowserEvent);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsenter"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsenter
 */
UCF_EditFieldBase["prototype"]["onBeforeLsEnter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsEnter"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsEnter"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsenter
 */
UCF_EditFieldBase["prototype"]["onAfterLsEnter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsEnter"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsEnter"] = 0; };
// #endregion
// #region   onlsentermodifier ================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsenter
 */
UCF_EditFieldBase["prototype"]["onlsentermodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsentermodifier"]++; }; 
	if (oBrowserEvent["bIsTouchInteraction"]()) {
		this["onlsenter"](oBrowserEvent);
	}
	if (!oBrowserEvent["bCtrl"]()) return;
	try {
		this["prepareFireChange"]();
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsentermodifier"] = 0; };

// #endregion
// #region   lsnext ===========================================================
/**
 * @param {UCF_BrowserEvent} oBrowserEvent the lsnext
 * @private
 */
UCF_EditFieldBase["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsnext"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsnext"] = 0; };
// #endregion
// #region   lsprevious =======================================================
/**
 * @param {UCF_BrowserEvent} oBrowserEvent the lsprevious
 * @private
 */
UCF_EditFieldBase["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsprevious"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsprevious"] = 0; };
// #endregion
// #region   lsexpand =========================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsexpand
 */
UCF_EditFieldBase["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsexpand"]++; }; 
	try {
		this["onBeforeLsExpand"](oBrowserEvent);

		oBrowserEvent["cancelBubble"]();

		this["onAfterLsExpand"](oBrowserEvent);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsexpand"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsexpand
 */
UCF_EditFieldBase["prototype"]["onBeforeLsExpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsExpand"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsExpand"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsexpand
 */
UCF_EditFieldBase["prototype"]["onAfterLsExpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsExpand"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsExpand"] = 0; };
// #endregion
// #endregion
// #region   lscollapse =======================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lscollapse
 */
UCF_EditFieldBase["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlscollapse"]++; }; 
	try {
		this["onBeforeLsCollapse"](oBrowserEvent);

		oBrowserEvent["cancelBubble"]();

		this["onAfterLsCollapse"](oBrowserEvent);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlscollapse"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lscollapse
 */
UCF_EditFieldBase["prototype"]["onBeforeLsCollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsCollapse"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsCollapse"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lscollapse
 */
UCF_EditFieldBase["prototype"]["onAfterLsCollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsCollapse"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsCollapse"] = 0; };
// #endregion
// #endregion
// #region   lsescape =========================================================
/**
 * restores `#sEscapeValue` when [ESC] is hit
 *
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_EditFieldBase["prototype"]["onlsescape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsescape"]++; }; 
	try {
		this["onBeforeLsEscape"](oBrowserEvent);

		if (this["bIsOpen"]()) {
			if (!this["oNavigation"]["bIsEditMode"]()) {
				// call select when the table-field is in navigation mode
				this["oNavigation"]["navigationMode"]();
			}

			this["closeFieldHelp"]();

			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["cancel"]();
		}

		if (this["sGetCurrentValue"]() !== this["sEscapeValue"]) {
			this["setCurrentValue"](this["sEscapeValue"]);
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["cancel"]();
		}

		this["onAfterLsEscape"](oBrowserEvent);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsescape"] = 0; };
// #region     before ---------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oEscape the escape
 */
UCF_EditFieldBase["prototype"]["onBeforeLsEscape"] = function(oEscape) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsEscape"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsEscape"] = 0; };
// #endregion
// #region     after ----------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oEscape the escape
 */
UCF_EditFieldBase["prototype"]["onAfterLsEscape"] = function(oEscape) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsEscape"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsEscape"] = 0; };
// #endregion
// #endregion
// #region   lstabsequenceprevious ============================================
/**
 * @override
 * @private
 * @param {UCF_BrowserEvent} oEvent the lstabsequenceprevious
 */
UCF_EditFieldBase["prototype"]["onBeforeLsTabSequencePrevious"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsTabSequencePrevious"]++; }; 
	this["handleBeforeLsTabSequence"](oEvent);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsTabSequencePrevious"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oEvent the lstabsequence(previous|next)
 */
UCF_EditFieldBase["prototype"]["handleBeforeLsTabSequence"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleBeforeLsTabSequence"]++; }; 
	/** @type {HTMLElement} */
	var oActiveElement;

	// CSN 1680171253: Field which is next in Tabchain but not in LS TabSequence
	// has its whole text selected although it is not focussed (b/c the focus is
	// moved to the next element in the TabSequence) in IE/Edge.
	//
	// #clearSelection() should do the job, but the current implementation does
	// nothing (!) -- which is the only behavior that works in Chrome+Firefox.
	// => implementing a "clearSelection2" here, only for IE/Edge
	// if (UCF_UserAgent.bIsIE() || UCF_UserAgent.bIsMSEdge()) {
	if (__UCF_IE6__) {
		oEvent["cancel"]();

		oActiveElement = UCF_DomUtil["oGetActiveElement"]();

		// setting the selection moves the focus to this.oDomRef
		// => need to refocus active element afterwards
		this["setSelectionInternal"](this["oFocusDomRef"], 0, 0);

		UCF_DomUtil["moveFocusDomElement"](oActiveElement, true);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleBeforeLsTabSequence"] = 0; };
// #endregion
// #region   lstabsequencenext ================================================
/**
 * @override
 * @private
 * @param {UCF_BrowserEvent} oEvent the lstabsequencenext
 */
UCF_EditFieldBase["prototype"]["onBeforeLsTabSequenceNext"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsTabSequenceNext"]++; }; 
	this["handleBeforeLsTabSequence"](oEvent);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsTabSequenceNext"] = 0; };
// #endregion
// #region   lsfocus ==========================================================
/**
 * @override
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_EditFieldBase["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsfocus"]++; }; 
	try {
		this["updateStyles"]();

		this["onBeforeLsFocus"](oBrowserEvent);

		this["hideInputPrompt"]();
		this["hideRequiredIndicator"]();
		if (this["bHideFieldHelp"]) {

			this["showButton"]();
		}

		this["sBlurAnyEventHandlerId"] = this["sAddAnyEventHandler"](
			this["oBlurAnyEventHandler"]()
		);

		this["onAfterLsFocus"](oBrowserEvent);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsfocus"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 * @throws {UCF_Exception} if focus handling should be left
 */
UCF_EditFieldBase["prototype"]["onBeforeLsFocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsFocus"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsFocus"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_EditFieldBase["prototype"]["onAfterLsFocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsFocus"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsFocus"] = 0; };
// #endregion
// #endregion
// #region   lsblur ===========================================================
/**
 * @override
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsblur
 */
UCF_EditFieldBase["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsblur"]++; }; 
	/** @type {Element} */
	var oRelatedTarget;
	/** @type {UCF_Control} */
	var oRelatedControl;

	if (this["bRefocusInProgress"]) {
		this["bNoBlur"] = false;
		oBrowserEvent["cancel"]();
	} else {
		try {
			this["onBeforeLsBlur"](oBrowserEvent);

			oRelatedTarget = UCF_DomUtil["oGetRelatedTarget"](oBrowserEvent["oDomEvent"]);
			oRelatedControl = this["oLS"]["oGetControlByDomRef"](oRelatedTarget);
			if (this["bNoBlur"] ||
				(oRelatedControl && this["bIsConnectedControl"](oRelatedControl))
			) {
				this["bNoBlur"] = false;
				oBrowserEvent["cancelBubble"]();
				oBrowserEvent["cancel"]();
			} else {
				if (this["bShouldHideButton"](oRelatedTarget)) {
					this["hideButton"]();
				}

				this["storeSelection"]();

				if (this["bIsWriteable"]()) {
					// eslint-disable-next-line max-depth
					try {
						this["prepareFireChange"]();
					} catch (oException) {
						this["handleEarlyHandlerLeave"](oException);
					}
				}

				this["onAfterLsBlur"](oBrowserEvent);

				this["showRequiredIndicator"]();

				this["showInputPrompt"]();

				this["updateStyles"]();

				if (this["sBlurAnyEventHandlerId"]) {
					this["removeAnyEventHandler"](this["sBlurAnyEventHandlerId"]);
					this["sBlurAnyEventHandlerId"] = undefined;
				}
			}
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsblur"] = 0; };

/**
 * stores the selection
 *
 * @private
 */
UCF_EditFieldBase["prototype"]["storeSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["storeSelection"]++; }; 
	// save selection start and end
	this["iSelectionStart"] = UCF_DomUtil["iGetSelectionStart"](this["oDomRef"]);
	this["iSelectionEnd"] = UCF_DomUtil["iGetSelectionEnd"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["storeSelection"] = 0; };
// #region before -------------------------------------------------------------
/**
 * Lifecycle hook called before lsblur handling in EditFieldBase
 *
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsblur
 */
UCF_EditFieldBase["prototype"]["onBeforeLsBlur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsBlur"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsBlur"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * Lifecycle hook called after an lsblur has been handled by the EditFieldBase
 *
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsblur
 */
UCF_EditFieldBase["prototype"]["onAfterLsBlur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsBlur"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsBlur"] = 0; };
// #endregion
// #endregion
// #region   select ===========================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oSelect the select
 */
UCF_EditFieldBase["prototype"]["onselect"] = function(oSelect) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onselect"]++; }; 
	try {
		this["onBeforeSelect"](oSelect);
		this["onAfterSelect"](oSelect);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onselect"] = 0; };
// #region     before ---------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oSelect the select
 */
UCF_EditFieldBase["prototype"]["onBeforeSelect"] = function(oSelect) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeSelect"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeSelect"] = 0; };
// #endregion
// #region     after ----------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oSelect the select
 */
UCF_EditFieldBase["prototype"]["onAfterSelect"] = function(oSelect) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterSelect"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterSelect"] = 0; };
// #endregion
// #endregion
// #region   lsaccessibility ==================================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_EditFieldBase["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper;

	try {
		this["onBeforeLsAccessibility"](oBrowserEvent);

		if (oBrowserEvent["oGetSourceControl"]() === this) {
			oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

			oAccessibilityHelper["setTooltip"](this["sTooltip"]);
			oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
			oAccessibilityHelper["setEnabled"](this["getEnabled"]());
			oAccessibilityHelper["setReadonly"](this["bReadonly"]);
			oAccessibilityHelper["setRequired"](this["bRequired"]);
			if (this["bInvalid"] || this["sInputState"] === 'ERROR') {
				oAccessibilityHelper["setInvalid"](true);
			}
			if (this["sInputState"] === 'WARNING') {
				oAccessibilityHelper["setWarning"](true);
			}
			// Sets the data type e.g. date field in the state section.
			// The default 'string' is not announced. There's no translation text.
			if (this["sType"] !== 'STRING') {
				oAccessibilityHelper["addDataType"](this["sType"]);
			}

			if (this["bIsOpen"]()) {
				oBrowserEvent["cancelBubble"]();
			}

			this["onAfterLsAccessibility"](oBrowserEvent);
		}
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlsaccessibility"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_EditFieldBase["prototype"]["onBeforeLsAccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsAccessibility"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeLsAccessibility"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_EditFieldBase["prototype"]["onAfterLsAccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsAccessibility"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterLsAccessibility"] = 0; };
// #endregion
// #endregion
// #endregion
// #region help button ########################################################
// #region   oGetHelpButton ===================================================
/**
 * @protected
 * @return {UCF_InputFieldHelpButton}
 */
UCF_EditFieldBase["prototype"]["oGetHelpButton"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetHelpButton"]++; }; 
	if (this["bShowHelpButton"] && this["bHideFieldHelp"]) {
		if (this["oHelpButton"] && this["oHelpButton"]["bIsDestroyed"]) {
			this["oLS"]["oControlFactory"]["purgeControl"](this["oHelpButton"]);
			this["oHelpButton"] = null;
		}
		if (!this["oHelpButton"]) {
			this["oHelpButton"] = this["oLS"]["oControlFactory"]["oGetControl"](
				'UCF_InputFieldHelpButton',
				UCF_EditFieldBase["HELPBUTTON_ID"]
			);
			this["oHelpButtonRef"] = this["oHelpButton"]["oDomRef"];
		}

		return this["oHelpButton"];
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetHelpButton"] = 0; };
// #endregion
// #region   oGetHelpButtonRef ================================================
/**
 * @protected
 * @return {HTMLSpanElement}
 */
UCF_EditFieldBase["prototype"]["oGetHelpButtonRef"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetHelpButtonRef"]++; }; 
	/** @type {HTMLSpanElement} */
	var oHelpButton;

	if (this["oHelpButtonRef"] === null) {
		oHelpButton = this["oGetHelpButton"]();

		this["oHelpButtonRef"] = oHelpButton
			? oHelpButton["oDomRef"]
			: UCF_DomUtil["$"](this["sId"] + '-btn');
	}

	return this["oHelpButtonRef"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetHelpButtonRef"] = 0; };
// #endregion
// #region   show =============================================================
/** @protected */
UCF_EditFieldBase["prototype"]["showButton"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["showButton"]++; }; 
	/** @type {UCF_InputFieldHelpButton} */

	var oHelpButton = this["oGetHelpButton"]();

	if (this["bShouldShowButton"]()) {
		oHelpButton["detachAllEvents"](this);
		oHelpButton["connect"](this);
		this["attachHelpButtonEvents"]();

		this["attachOnce"]('resize');

		if (this["bFieldHelpEmbedding"] && !this["sHelpButtonAnyEventHandlerId"]) {
			this["sHelpButtonAnyEventHandlerId"] = this["sAddAnyEventHandler"](
				this["oHelpButtonAnyEventHandler"]()
			);
		}
	} else if (oHelpButton && oHelpButton["bIsConnected"](this)) {
		oHelpButton["alignStylesWithControl"](this);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["showButton"] = 0; };

/**
 * @private
 * @return {boolean} `true` if the help button should be made visible,
 * otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bShouldShowButton"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldShowButton"]++; }; 
	/** @type {UCF_InputFieldHelpButton} */
	var oHelpButton = this["oGetHelpButton"]();

	return oHelpButton
		&& !oHelpButton["bIsConnected"](this)
		&& this["getEnabled"]()
		&& (!this["bReadonly"] || this["bShowHelpButtonAlways"]);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldShowButton"] = 0; };
// #endregion
// #region   hide =============================================================
/** @protected */
UCF_EditFieldBase["prototype"]["hideButton"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["hideButton"]++; }; 
	/** @type {UCF_InputFieldHelpButton} */

	var oHelpButton = this["oGetHelpButton"]();

	if (oHelpButton) {
		if (oHelpButton["bIsConnected"](this)) {
			oHelpButton["disconnect"]();
		}
		this["detachHelpButtonEvents"]();

		if (this["bShouldDetachResizeWhenHidingButton"]()) {
			this["detachOnce"]('resize');
		}

		if (this["bFieldHelpEmbedding"]) {
			this["removeAnyEventHandler"](this["sHelpButtonAnyEventHandlerId"]);
			this["sHelpButtonAnyEventHandlerId"] = undefined;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["hideButton"] = 0; };

/**
 * @protected
 * @return {boolean} `true` to detach resize in `UCF_EditFieldBase#hideButton()`,
 * otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bShouldDetachResizeWhenHidingButton"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldDetachResizeWhenHidingButton"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldDetachResizeWhenHidingButton"] = 0; };

/**
 * @protected
 * @param {HTMLElement} oFocusTargetRef the element the focus moves to when
 * hiding onlsblur
 * @return {boolean} `true` if help button should be hidden, otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bShouldHideButton"] = function(oFocusTargetRef) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldHideButton"]++; }; 
	return !this["bHasVisibleFocus"]()
		&& !this["bIsConnectedControl"](
			this["oLS"]["oControlFactory"]["oGetEnclosingControlByDomRef"](
				oFocusTargetRef,
				true
			)
		)
		&& (
			!UCF_BrowserEvent["bTouchInteraction"] ||
			oFocusTargetRef !== this["oFocusDomRef"]
		);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldHideButton"] = 0; };

/**
 * @protected
 * @param {UCF_Control} oControl the control to check
 * @return {boolean} `true` if the control is connected to the editfield,
 * otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bIsConnectedControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsConnectedControl"]++; }; 
	return oControl && (
		(oControl === this["oHelpButton"] && oControl["bIsConnected"](this)) ||
		oControl === this
	);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsConnectedControl"] = 0; };
// #endregion
// #region   HelpButton events ================================================
/** @private */
UCF_EditFieldBase["prototype"]["attachHelpButtonEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["attachHelpButtonEvents"]++; }; 
	var oHelpButton = this["oGetHelpButton"]();
	var self;

	if (oHelpButton) {
		self = this;

		UCF_JsUtil["forEach"](
			UCF_JsUtil["entries"](oHelpButton["E_EVENTS"]),
			function(oEntry) {
				oHelpButton["attachEvent"](oEntry[1], self, 'onHelpButton' + oEntry[0]);
			}
		);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["attachHelpButtonEvents"] = 0; };

/** @private */
UCF_EditFieldBase["prototype"]["detachHelpButtonEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["detachHelpButtonEvents"]++; }; 
	/** @type {UCF_InputFieldHelpButton} */
	var oHelpButton = this["oGetHelpButton"]();
	/** @type {UCF_EditFieldBase} */
	var self;

	if (oHelpButton) {
		self = this;

		UCF_JsUtil["forEach"](
			UCF_JsUtil["entries"](oHelpButton["E_EVENTS"]),
			function(oEntry) {
				oHelpButton["detachEvent"](oEntry[1], self, 'onHelpButton' + oEntry[0]);
			}
		);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["detachHelpButtonEvents"] = 0; };
// #endregion
// #region   AnyEvent handler =================================================
/** @return {UCF_EditFieldBase_AnyEventHandler} the handler */
UCF_EditFieldBase["prototype"]["oHelpButtonAnyEventHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oHelpButtonAnyEventHandler"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	return {
		"fWhen": function(oBrowserEvent) {
			return self["oDomRef"]
				&& oBrowserEvent["sGetName"]() === 'mousedown';
		},
		"fThen": function(oBrowserEvent) {
			/** @type {UCF_Control} */
			var oSourceRoot = self["oLS"]["oGetControlByDomRef"](
				oBrowserEvent["oGetSourceRoot"]()
			);

			if (
				oSourceRoot !== self &&
				!UCF_JsUtil["bInstanceOf"](oSourceRoot, 'UCF_InputFieldHelpButton') &&
				(!oSourceRoot["oConnectedControl"] || oSourceRoot["oConnectedControl"] !== self)
			) {
				self["hideButton"]();
			}
		}
	};
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oHelpButtonAnyEventHandler"] = 0; };

/** @return {UCF_EditFieldBase_AnyEventHandler} the handler */
UCF_EditFieldBase["prototype"]["oFieldHelpAnyEventHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oFieldHelpAnyEventHandler"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	return {
		"fWhen": function(oBrowserEvent) {
			var sEventName = oBrowserEvent["sGetName"]();

			// For touch devices, the field help should be closed, if the user taps
			// outside the field help. But the field help should not be closed, if
			// the user swipes vertically outside the field help: In that case, we
			// assume that the user wants to reposition the field help for better
			// usage.
			// So we have to differentiate between a touchend without preceding
			// touchmove (=tap) and a touchend with preceeding touchmove (=swipe)
			//
			// Furthermore, there's no scroll event for Android but for iOS.
			// So we strictly distinguish here between touch devices (touch
			// events) and "mouse" devices (mouse events)
			return self["oDomRef"]
				&& (
					sEventName === 'mousedown' && !(UCF_UserAgent["bIsAndroid"]() || UCF_UserAgent["bIsIOS"]()) ||
					sEventName === 'scroll' && self["oGetFieldHelp"]() && !(UCF_UserAgent["bIsAndroid"]() || UCF_UserAgent["bIsIOS"]()) ||
					sEventName === 'touchmove' && self["oGetFieldHelp"]() && (UCF_UserAgent["bIsAndroid"]() || UCF_UserAgent["bIsIOS"]()) ||
					sEventName === 'lsfocuslost' && !(UCF_UserAgent["bIsAndroid"]() || UCF_UserAgent["bIsIOS"]())
				);
		},
		"fThen": function(oBrowserEvent) {
			switch (oBrowserEvent["sGetName"]()) {
				case 'mousedown':
					self["handleMousedownFieldHelpAnyEvent"](oBrowserEvent);
					break;
				case 'scroll':
					self["handleScrollFieldHelpAnyEvent"](oBrowserEvent);
					break;
				case 'touchmove':
					self["handleScrollFieldHelpAnyEvent"](oBrowserEvent);
					break;
				case 'lsfocuslost':
					self["handleLsFocuslostFieldHelpAnyEvent"](oBrowserEvent);
					break;
			}
		}
	};
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oFieldHelpAnyEventHandler"] = 0; };

/** @return {UCF_EditFieldBase_AnyEventHandler} */
UCF_EditFieldBase["prototype"]["oBlurAnyEventHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oBlurAnyEventHandler"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	return {
		"fWhen": function(oBrowserEvent) {
			/** @type {HTMLElement} */
			var oSourceRoot;

			return oBrowserEvent["sGetName"]() === 'lsfocus' &&
				// the assignment is intentional
				(oSourceRoot = oBrowserEvent["oGetSourceRoot"]()) &&
				!self["bIsConnectedControl"](self["oLS"]["oGetControlByDomRef"](oSourceRoot));
		},
		"fThen": function() {
			self["updateStyles"]();

			if (self["sBlurAnyEventHandlerId"]) {
				self["removeAnyEventHandler"](self["sBlurAnyEventHandlerId"]);
				self["sBlurAnyEventHandlerId"] = undefined;
			}
		}
	};
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oBlurAnyEventHandler"] = 0; };
// #endregion
// #region   handleScrollFieldHelpAnyEvent ====================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oScroll the scroll
 */
UCF_EditFieldBase["prototype"]["handleScrollFieldHelpAnyEvent"] = function(oScroll) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleScrollFieldHelpAnyEvent"]++; }; 
	/** @type {UCF_EditFieldBase_FieldHelp} */
	var oFieldHelp;

	if (!this["bShouldShowOverlay"]() && !this["bScrolledIntoView"]()) {
		this["closeFieldHelp"]();
		this["hideButton"]();
	} else {
		oFieldHelp = this["oGetFieldHelp"]();
		if (oFieldHelp && !oFieldHelp["bIsDestroyed"]) {
			oFieldHelp["setPosition"]();
		}

		if (this["oDataTip"]) {
			this["oDataTip"]["close"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleScrollFieldHelpAnyEvent"] = 0; };
// #endregion
// #region   handleLsFocuslostFieldHelpAnyEvent ===============================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oLsFocuslost
 */
UCF_EditFieldBase["prototype"]["handleLsFocuslostFieldHelpAnyEvent"] = function(oLsFocuslost) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleLsFocuslostFieldHelpAnyEvent"]++; }; 
	if (this["bIgnoreNextFocuslost"]) {
		this["bIgnoreNextFocuslost"] = false;
	} else {
		try {
			this["prepareFireChange"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
		if (this["bIsInOverlayMode"]() && UCF_BrowserEvent["bTouchInteraction"]) {
			// don't close, the overlay will remain open
		} else {
			this["closeFieldHelp"]();
		}
		this["bNoBlur"] = false;
		this["hideButton"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleLsFocuslostFieldHelpAnyEvent"] = 0; };
// #endregion
// #region   handleMousedownFieldHelpAnyEvent =================================
/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oMousedown
 */
UCF_EditFieldBase["prototype"]["handleMousedownFieldHelpAnyEvent"] = function(oMousedown) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleMousedownFieldHelpAnyEvent"]++; }; 
	try {
		this["onBeforeMousedownFieldHelpAnyEvent"](oMousedown);
		// ...
		this["onAfterMousedownFieldHelpAnyEvent"](oMousedown);
	} catch (e) {
		this["handleEarlyHandlerLeave"](e);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleMousedownFieldHelpAnyEvent"] = 0; };
// #endregion
// #region   onBeforeMousedownFieldHelpAnyEvent ===============================
/**
 * @protected
 * @param {UCF_BrowserEvent} oMousedown
 */
UCF_EditFieldBase["prototype"]["onBeforeMousedownFieldHelpAnyEvent"] = function(oMousedown) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeMousedownFieldHelpAnyEvent"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeMousedownFieldHelpAnyEvent"] = 0; };
// #endregion
// #region   onAfterMousedownFieldHelpAnyEvent ================================
/**
 * @protected
 * @param {UCF_BrowserEvent} oMousedown
 */
UCF_EditFieldBase["prototype"]["onAfterMousedownFieldHelpAnyEvent"] = function(oMousedown) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterMousedownFieldHelpAnyEvent"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterMousedownFieldHelpAnyEvent"] = 0; };
// #endregion
// #region   onTap ============================================================
/**
 * @private
 * @param {UCF_Event<{oBrowserEvent: UCF_BrowserEvent}>} oTap
 */
UCF_EditFieldBase["prototype"]["onTap"] = function(oTap) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onTap"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oTap["mGetParameters"]()["oBrowserEvent"]["oGetSource"]();
	/** @type {UCF_Control} */
	var oSourceControl = oSource && this["oLS"]["oControlFactory"]["oGetEnclosingControlByDomRef"](oSource);

	if (!oSourceControl || !this["bIsConnectedControl"](oSourceControl)) {
		this["handleLsFocuslostFieldHelpAnyEvent"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onTap"] = 0; };
// #endregion
// #region   hover ============================================================
/**
 * @param {HTMLElement} oRelatedTarget the element the mouse is over now
 * @return {boolean} `true` if the mouse is over the help button,
 * otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bIsMouseOverHelpButton"] = function(oRelatedTarget) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsMouseOverHelpButton"]++; }; 
	return oRelatedTarget === this["oGetHelpButtonRef"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsMouseOverHelpButton"] = 0; };

/**
 * @protected
 * @return {boolean} `true` if the help button should connect to EditFields on
 * hover (i.e. follow the mouse), otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bShouldConnectButtonOnHover"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldConnectButtonOnHover"]++; }; 
	return this["bUsedInSapTable"]
		&& this["bFieldHelpFloating"]
		&& this["bHideFieldHelp"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldConnectButtonOnHover"] = 0; };
// #endregion
// #endregion
// #region input prompt #######################################################
// #region   show =============================================================
/** @private */
UCF_EditFieldBase["prototype"]["showInputPrompt"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["showInputPrompt"]++; }; 
	if (
		this["bUsesValueForIndicators"]() &&
		this["sInputPrompt"] &&
		this["bIsWriteable"]() &&
		this["sGetDomRefValue"]() === ''
	) {
		this["setDomRefValue"](this["sInputPrompt"]);
		this["bCurrentValueInputPrompt"] = true;
		this["updateStyles"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["showInputPrompt"] = 0; };
// #endregion
// #region   hide =============================================================
/** @private */
UCF_EditFieldBase["prototype"]["hideInputPrompt"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["hideInputPrompt"]++; }; 
	if (
		this["bUsesValueForIndicators"]() &&
		this["sInputPrompt"] &&
		this["bIsWriteable"]() &&
		this["bIsCurrentValueInputPrompt"]()
	) {
		this["setDomRefValue"]('');
		this["bCurrentValueInputPrompt"] = false;
		this["updateStyles"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["hideInputPrompt"] = 0; };
// #endregion
// #region   bUsesValueForIndicators ==========================================
/**
 * @private
 * @return {boolean}
 */
UCF_EditFieldBase["prototype"]["bUsesValueForIndicators"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bUsesValueForIndicators"]++; }; 
	return __UCF_IE6__ || this["oDomRef"]["nodeName"] === 'SPAN';
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bUsesValueForIndicators"] = 0; };
// #endregion
// #endregion
// #region required indicator #################################################
// #region   show =============================================================
/** @private */
UCF_EditFieldBase["prototype"]["showRequiredIndicator"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["showRequiredIndicator"]++; }; 
	if (
		this["bUsesValueForIndicators"]() &&
		this["bIsWriteable"]() &&
		this["bRequired"] &&
		this["bShowRequiredIndicator"] &&
		this["sGetDomRefValue"]() === ''
	) {
		if (!this["bPasswordField"]) {
			this["setDomRefValue"]('*');
			this["bIsAsteriskRequiredIndicator"] = true;
		}

		this["updateStyles"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["showRequiredIndicator"] = 0; };
// #endregion
// #region   hide =============================================================
/** @private */
UCF_EditFieldBase["prototype"]["hideRequiredIndicator"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["hideRequiredIndicator"]++; }; 
	if (this["bShouldHideRequiredIndicator"]()) {
		try {
			this["onBeforeHideRequiredIndicator"]();

			if (
				!this["bPasswordField"] &&
				UCF_DomUtil["bHasClass"](this["oRootRef"], 'lsField--requiredindicator')
			) {
				this["setDomRefValue"]('');
				this["bIsAsteriskRequiredIndicator"] = false;
			}

			this["updateStyles"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["hideRequiredIndicator"] = 0; };
// #region before -------------------------------------------------------------
/**
 * Lifecycle hook called before the EditFieldBase hides the required indicator
 *
 * @protected
 */
UCF_EditFieldBase["prototype"]["onBeforeHideRequiredIndicator"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeHideRequiredIndicator"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeHideRequiredIndicator"] = 0; };
// #endregion
// #region should? ------------------------------------------------------------
/**
 * @private
 * @return {boolean} `true` if the field should attempt to hide the required
 * indicator
 */
UCF_EditFieldBase["prototype"]["bShouldHideRequiredIndicator"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldHideRequiredIndicator"]++; }; 
	return this["bUsesValueForIndicators"]()
		&& this["bIsWriteable"]()
		&& this["bRequired"]
		&& this["bShowRequiredIndicator"]
		&& (
			(this["sGetDomRefValue"]() === '*' && this["bIsAsteriskRequiredIndicator"]) ||
			this["bPasswordField"]);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldHideRequiredIndicator"] = 0; };
// #endregion
// #endregion
// #endregion
// #region styles #############################################################
// #region   updateStyles =====================================================
/**
 * THIS SHOULD BE THE ONLY METHOD CALLED TO UPDATE THE STYLES OF THE EDITFIELD.
 *
 * Requests an animation frame to apply all css classes from the renderer
 * to the elements of the editfield.
 *
 * @param {UCF_EditFieldBase_MouseInteractionState} [oState] the state to represent
 * @private
 */
UCF_EditFieldBase["prototype"]["updateStyles"] = function(oState) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["updateStyles"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	this["requestAnimationFrame"](function() {
		self["updateStylesSync"]();
	}, 'updateStyles');
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["updateStyles"] = 0; };
// #endregion
// #region   updateStylesSync =================================================
// #region     updateStylesSync -----------------------------------------------
/**
 * DO NOT CALL THIS METHOD. CALL #updateStyles() INSTEAD
 *
 * Synchronously applies all css classes from the renderer to all necessary
 * elements of the editfield.
 * @private
 */
UCF_EditFieldBase["prototype"]["updateStylesSync"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["updateStylesSync"]++; }; 
	/** @type {Object} */
	var oState = this["oGetStyleState"]();
	/** @type {string} */
	var sRootClass;
	/** @type {string} */
	var sClass;
	/** @type {UCF_InputFieldHelpButton} */
	var oHelpButton;
	/** @type {boolean} */
	var bIsClearVisible;
	/** @type {boolean} */
	var bWillMakeClearVisible;

	if (!UCF_JsUtil["bEqual"](oState, this["oCache"]["get"]('oLastStyleState'))) {
		oHelpButton = this["oGetHelpButton"]();
		sRootClass = this["sGetCssRootClass"](oState);
		sClass = this["sGetCssClass"](oState);

		if (this["oClearRef"]) {
			bIsClearVisible = UCF_DomUtil["bHasClass"](this["oRootRef"], 'lsField--clearvisible');
			bWillMakeClearVisible = UCF_StringUtil["bContains"](sRootClass, 'lsField--clearvisible');
		}

		UCF_DomUtil["setClass"](this["oRootRef"], sRootClass);
		UCF_DomUtil["setClass"](this["oDomRef"], sClass);

		this["adjustWidthToClearButton"](bIsClearVisible, bWillMakeClearVisible);

		if (oHelpButton && oHelpButton["bIsConnected"](this)) {
			oHelpButton["alignStylesWithControl"](this);
		}

		this["oCache"]["set"]('oLastStyleState', oState);

		this["fireEvent"](this["E_EVENTS"]["DidUpdateStyles"], {});
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["updateStylesSync"] = 0; };

/**
 * @private
 * @param {boolean} bWasClearVisible
 * @param {boolean} bIsClearVisible
 */
UCF_EditFieldBase["prototype"]["adjustWidthToClearButton"] = function(bWasClearVisible, bIsClearVisible) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["adjustWidthToClearButton"]++; }; 
	/** @type {string} */
	var sWidth;

	if (
		this["oClearRef"] &&
		UCF_EditFieldBase["bHasSearchClear"](this["oClearRef"], bIsClearVisible) &&
		!this["bIsTableRenderMode"]() &&
		!this["bUsedInSapTable"]
	) {
		if (!bWasClearVisible && bIsClearVisible) {
			sWidth = this["sWidth"] || this["oDomRef"]["offsetWidth"] + 'px';
			// :-( this will cause a 2nd forced reflow. But we have to pick the
			// right width according to the applied styles and therefore can't
			// cache the clear width
			UCF_DomUtil["setStyle"](this["oDomRef"], {
				"width": 'calc(' + sWidth + ' - ' + this["oClearRef"]["offsetWidth"] + 'px)'
			});
		} else if (bWasClearVisible && !bIsClearVisible) {
			UCF_DomUtil["setStyle"](this["oDomRef"], { "width": this["sWidth"] });
		}
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["adjustWidthToClearButton"] = 0; };

/** @type {boolean} */
UCF_EditFieldBase["bSearchClear"] = undefined;

/**
 * @private
 * @static
 * @param {HTMLSpanElement} oClearRef the ref of the clear span
 * @param {boolean} bIsClearVisible
 * @return {boolean}
 */
UCF_EditFieldBase["bHasSearchClear"] = function(oClearRef, bIsClearVisible) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bHasSearchClear"]++; }; 
	if (bIsClearVisible && typeof UCF_EditFieldBase["bSearchClear"] !== 'boolean') {
		UCF_EditFieldBase["bSearchClear"] = oClearRef["offsetWidth"] > 0;
	}

	return UCF_EditFieldBase["bSearchClear"] || false;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bHasSearchClear"] = 0; };
// #endregion
// #region     style state ----------------------------------------------------
/**
 * @private
 * @return {Object}
 */
UCF_EditFieldBase["prototype"]["oGetStyleState"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetStyleState"]++; }; 
	return UCF_JsUtil["extend"]({},
		this["oGetMouseInteractionState"](),
		this["oGetControlState"]()
	);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetStyleState"] = 0; };
// #region       mouse interaction ............................................
/**
 * @private
 * @return {UCF_EditFieldBase_MouseInteractionState}
 */
UCF_EditFieldBase["prototype"]["oGetMouseInteractionState"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetMouseInteractionState"]++; }; 
	return {
		"IsHovered": this["oInteractionState"]["MouseOnInput"]
			|| this["oInteractionState"]["MouseOnUpperHelpButtonHalf"]
			|| this["oInteractionState"]["MouseOnLowerHelpButtonHalf"]
			|| this["oInteractionState"]["MouseOnClear"],
		"IsFocused": this["bHasVisibleFocus"](),
		"IsHighlighted": this["bIsHighlighted"],
		"IsHighlightFocused": this["bIsHighlightFocused"],
		"IsOpen": this["bIsOpen"](),
		"IsUpperHelpButtonHalfHovered": this["oInteractionState"]["MouseOnUpperHelpButtonHalf"],
		"IsLowerHelpButtonHalfHovered": this["oInteractionState"]["MouseOnLowerHelpButtonHalf"],
		"IsUpperHelpButtonHalfDown": this["oInteractionState"]["MouseOnUpperHelpButtonHalf"]
			&& this["oInteractionState"]["MouseOnDown"],
		"IsLowerHelpButtonHalfDown": this["oInteractionState"]["MouseOnLowerHelpButtonHalf"]
			&& this["oInteractionState"]["MouseOnDown"],
		"IsClearHovered": this["oInteractionState"]["MouseOnClear"],
		"IsClearDown": this["oInteractionState"]["MouseOnClear"] && this["oInteractionState"]["MouseOnDown"],
		"IsFieldInteraction": this["oInteractionState"]["FocusOnInput"],
		"IsOverlay": this["oInteractionState"]["Overlay"]
	};
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetMouseInteractionState"] = 0; };
// #endregion
// #region       control state ................................................
/**
 * @protected
 * @return {UCF_EditFieldBase_ControlState}
 */
UCF_EditFieldBase["prototype"]["oGetControlState"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetControlState"]++; }; 
	return {
		"Hidden": this["bIsTypeHidden"](),
		"EmbeddingBehaviour": this["sEmbeddingBehaviour"],
		"UsedInSapTable": this["bUsedInSapTable"],
		"UsedInToolbar": this["bUsedInToolbar"],
		"UsedInDataGrid": this["bUsedInDataGrid"],
		"ShouldRenderHelp": this["oGetHelpButton"]()
			? this["bIsConnectedControl"](this["oGetHelpButton"])
			: this["oGetHelpButtonRef"](),
		"ShowHelpButton": this["bShowHelpButton"],
		"ShowHelpButtonAlways": this["bShowHelpButtonAlways"],
		"HideFieldHelp": this["bHideFieldHelp"],
		"HasIconColumn": this["bHasIconColumn"],
		"Enabled": this["bEnabled"],
		"Readonly": this["bReadonly"],
		"Invalid": this["bInvalid"],
		"InputState": this["sInputState"],
		"DisplayAsText": this["bDisplayAsText"],
		"CustomStyle": this["sCustomStyle"],
		"IsContainerWidthSet": this["bContainerWidthSet"],
		"Width": this["sWidth"],
		"Height": this["sHeight"],
		"Value": this["sGetCurrentValue"](),
		"InputPrompt": this["sInputPrompt"],
		"IsHpif": this["oDomRef"]["nodeName"] === 'SPAN',
		"Design": this["sDesign"],
		"SapTableFieldDesign": this["sSapTableFieldDesign"],
		"Align": this["sAlign"],
		"TextStyle": this["sTextStyle"],
		"TextDirection": this["sTextDirection"],
		"TextOverflowEllipsis": this["bTextOverflowEllipsis"],
		"FieldHelp": this["sFieldHelp"],
		"FieldHelpFloating": this["bFieldHelpFloating"],
		"FieldHelpEmbedding": this["bFieldHelpEmbedding"],
		"Type": this["sType"],
		"SpinnerBoundsCheck": this["bSpinnerBoundsCheck"],
		"SpinnerMin": this["iSpinnerMin"],
		"SpinnerMax": this["iSpinnerMax"],
		"Required": this["bRequired"],
		"ShowRequiredIndicator": this["bShowRequiredIndicator"],
		"PasswordField": this["bPasswordField"],
		"UpperCase": this["bUpperCase"],
		"SemanticColor": this["sSemanticColor"],
		"FormatString": this["sFormatString"],
		"PaddingInSapTable": this["sPaddingInSapTable"],
		"Visibility": this["sVisibility"],
		"IMEMode": this["sIMEMode"]
	};
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetControlState"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_EditFieldBase["prototype"]["bHasVisibleFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bHasVisibleFocus"]++; }; 
	/** @type {HTMLElement} */
	var oActiveElement = UCF_DomUtil["oGetActiveElement"]();

	return UCF_DomUtil["bContains"](this["oRootRef"], oActiveElement)
		|| this["oRootRef"] === oActiveElement
		|| this["bIsConnectedControl"](
			this["oLS"]["oControlFactory"]["oGetEnclosingControlByDomRef"](oActiveElement)
		)
		|| this["bIsOpen"]() && UCF_DomUtil["bContains"](
			this["oGetFieldHelpRootRef"](),
			oActiveElement
		);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bHasVisibleFocus"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_EditFieldBase["prototype"]["bIsInOverlayMode"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsInOverlayMode"]++; }; 
	return this["bIsOpen"]()
		&& UCF_DomUtil["bHasClass"](this["oRootRef"], 'lsField--overlay')
		||
		!this["bIsOpen"]() && this["bHasVisibleFocus"]()
		&& this["bShouldShowOverlay"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsInOverlayMode"] = 0; };

/**
 * @private
 * @return {boolean} `true` if the field is rendered as a <table>, otherwise
 * `false`
 */
UCF_EditFieldBase["prototype"]["bIsTableRenderMode"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsTableRenderMode"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	return this["oCache"]["get"]('bIsTableRenderMode', function() {
		return self["oRootRef"]["tagName"] === 'TABLE';
	});
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsTableRenderMode"] = 0; };

/**
 * @private
 * @return {boolean} `true` if the EditField is an input[type="hidden"],
 * otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bIsTypeHidden"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsTypeHidden"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	return this["oCache"]["get"]('bIsTypeHidden', function() {
		return self["oDomRef"]["getAttribute"]('type') === 'hidden';
	});
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsTypeHidden"] = 0; };
// #endregion
// #endregion
// #region     style classes --------------------------------------------------
/**
 * @private
 * @param {UCF_EditFieldBase_MouseInteractionState} oState the state to represent
 * @return {string} the css classes for the root ref
 */
UCF_EditFieldBase["prototype"]["sGetCssRootClass"] = function(oState) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetCssRootClass"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'InputFieldGetRootClass',
		'InputField',
		UCF_JsUtil["extend"]({}, oState, {
			"IsHelpUpperHovered": oState["IsUpperHelpButtonHalfHovered"],
			"IsHelpLowerHovered": oState["IsLowerHelpButtonHalfHovered"],
			"IsHelpUpperDown": oState["IsUpperHelpButtonHalfDown"],
			"IsHelpLowerDown": oState["IsLowerHelpButtonHalfDown"]
		})
	);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetCssRootClass"] = 0; };

/**
 * @private
 * @param {UCF_EditFieldBase_MouseInteractionState} oState the state to represent
 * @return {string} the css classes for the dom ref
 */
UCF_EditFieldBase["prototype"]["sGetCssClass"] = function(oState) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetCssClass"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'InputFieldGetClass',
		'InputField',
		oState
	);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetCssClass"] = 0; };
// #endregion
// #endregion
// #endregion
// #region FieldHelp ##########################################################
// #region   oGetFieldHelpRootRef =============================================
/**
 * @protected
 * @return {HTMLElement}
 */
UCF_EditFieldBase["prototype"]["oGetFieldHelpRootRef"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetFieldHelpRootRef"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, this["sClassName"] + '" did not override #oGetFieldHelpRootRef(). Returning null.', "EditFieldBase.js(3510): oGetFieldHelpRootRef"); };

	return null;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetFieldHelpRootRef"] = 0; };
// #endregion
// #region   oGetFieldHelp ====================================================
/**
 * @protected
 * @return {UCF_EditFieldBase_FieldHelp}
 */
UCF_EditFieldBase["prototype"]["oGetFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetFieldHelp"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, this["sClassName"] + '" did not override #oGetFieldHelp(). Returning null.', "EditFieldBase.js(3521): oGetFieldHelp"); };

	return null;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetFieldHelp"] = 0; };
// #endregion
// #region   bIsMouseOverFieldHelp ============================================
/**
 * @protected
 * @param {HTMLElement} oRelatedRef the element the mouse is over
 * @return {boolean}
 */
UCF_EditFieldBase["prototype"]["bIsMouseOverFieldHelp"] = function(oRelatedRef) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsMouseOverFieldHelp"]++; }; 
	/** @type {UCF_EditFieldBase_FieldHelp} */
	var oFieldHelp = this["oGetFieldHelp"]();

	return oFieldHelp && UCF_DomUtil["bContains"](oFieldHelp["oRootRef"], oRelatedRef);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsMouseOverFieldHelp"] = 0; };
// #endregion
// #region   open =============================================================
/**
 * @protected
 * @final
 * @param {boolean} [bImmediate=false]
 */
UCF_EditFieldBase["prototype"]["openFieldHelp"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["openFieldHelp"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow;

	if (this["bIsDestroyed"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, this["oDomRef"] + ' has already been destroyed.', "EditFieldBase.js(3550): openFieldHelp"); };
		return;
	}

	try {
		if (this["bShouldShowOverlay"]()) {
			this["fireEvent"](this["E_EVENTS"]["WillOpenFieldHelp"], {});
		}

		this["onBeforeOpenFieldHelp"](bImmediate);

		if (!this["sFieldHelpAnyEventHandlerId"]) {
			this["sFieldHelpAnyEventHandlerId"] = this["sAddAnyEventHandler"](
				this["oFieldHelpAnyEventHandler"]()
			);
		}
		if (this["oGetFieldHelp"]()) {
			oBrowserWindow = this["oLS"]["oBrowserWindow"];
			if (oBrowserWindow) {
				oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["Tap"], this, 'onTap');
			}
		}

		if (this["oDataTip"]) {
			this["bDataTipAutoShowOnFocus"] = this["oDataTip"]["bAutoShowOnFocus"];
			this["oDataTip"]["bAutoShowOnFocus"] = false;
			this["bDataTipAutoShowOnFirstFocus"] = this["oDataTip"]["bAutoShowOnFirstFocus"];
			this["oDataTip"]["bAutoShowOnFirstFocus"] = false;
			UCF_JsUtil["clearDelayedCall"](this["oDataTip"]["sDelayedOpen"]);
		}

		this["updateStyles"]();

		this["onAfterOpenFieldHelp"](bImmediate);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["openFieldHelp"] = 0; };
// #region before -------------------------------------------------------------
/**
 * @protected
 * @param {boolean} [bImmediate=false]
 */
UCF_EditFieldBase["prototype"]["onBeforeOpenFieldHelp"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeOpenFieldHelp"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onBeforeOpenFieldHelp"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {boolean} [bImmediate=false]
 */
UCF_EditFieldBase["prototype"]["onAfterOpenFieldHelp"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterOpenFieldHelp"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterOpenFieldHelp"] = 0; };
// #endregion
// #endregion
// #region   bIsOpen ==========================================================
/**
 * @protected
 * @return {boolean} `true` if the field help / listbox is open, or `false`
 */
UCF_EditFieldBase["prototype"]["bIsOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsOpen"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, this["sClassName"] + '" did not override #bIsOpen(). Returning false.', "EditFieldBase.js(3613): bIsOpen"); };

	return false;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsOpen"] = 0; };
// #endregion
// #region   emitFieldHelpPress ===============================================
/**
 * @protected
 * @final
 */
UCF_EditFieldBase["prototype"]["emitFieldHelpPress"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["emitFieldHelpPress"]++; }; 
	this["bFieldHelpPressInProgress"] = true;
	this["fireFieldHelpPress"]["apply"](this, this["aGetFieldHelpPressArguments"]());
	this["bFieldHelpPressInProgress"] = false;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["emitFieldHelpPress"] = 0; };

/**
 * @protected
 * @return {Array.<string>}
 */
UCF_EditFieldBase["prototype"]["aGetFieldHelpPressArguments"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["aGetFieldHelpPressArguments"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, this["sClassName"] + ' did not override #aGetFieldHelpPressArguments. Returning [this.sId, this.sFieldHelp].', "EditFieldBase.js(3637): aGetFieldHelpPressArguments"); };

	return this["oCache"]["get"]('aFieldHelpPressArguments', function() {
		return [self["sId"], self["sFieldHelp"]];
	});
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["aGetFieldHelpPressArguments"] = 0; };
// #endregion
// #region   close ============================================================
/**
 * Event handler for list box close event
 *
 * @param {UCF_Event} oEvent the event object
 * @private
 */
UCF_EditFieldBase["prototype"]["onFieldHelpClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onFieldHelpClose"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "EditFieldBase.js(3652): onFieldHelpClose"); };

	this["closeFieldHelp"]();
	if (!this["bHasVisibleFocus"]()) {
		this["hideButton"]();
	}

	// 1780119710: as a workaround we need to add aria attributes also in 508
	// else JAWS 17/18 does not announce the items within a list properly
	if (window["UCF_System"]["bIsAria"] || window["UCF_System"]["bIs508"]) {
		UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], '');
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onFieldHelpClose"] = 0; };
// #region closeFieldHelp -----------------------------------------------------
/**
 * @protected
 * @final
 * @param {boolean} [bImmediate=false]
 */
UCF_EditFieldBase["prototype"]["closeFieldHelp"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["closeFieldHelp"]++; }; 
	/** @type {UCF_Control} */
	var oFieldHelp = this["oGetFieldHelp"]();
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow;
	/** @type {HTMLElement} */
	var oOpenRef;

	if (this["bIsDestroyed"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, this["oDomRef"] + ' has already been destroyed.', "EditFieldBase.js(3680): closeFieldHelp"); };
		return;
	}

	try {
		if (this["sFieldHelpAnyEventHandlerId"]) {
			this["removeAnyEventHandler"](this["sFieldHelpAnyEventHandlerId"]);
			this["sFieldHelpAnyEventHandlerId"] = undefined;
		}

		oBrowserWindow = this["oLS"]["oBrowserWindow"];
		if (oBrowserWindow) {
			oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Tap"], this);
		}

		if (window["UCF_System"]["bIsAria"]) {
			if (UCF_DomUtil["sGetAttribute"](this["oDomRef"], 'role') === 'combobox') {
				UCF_AriaStateHelper["setExpanded"](this["oDomRef"], false);
			}
		}

		// CSN 676011/2018: ensure bIgnoreDefaultButton=false when the FieldHelp
		// is closed
		this["bIgnoreDefaultButton"] = false;

		if (this["oDataTip"] && this["bIsOpen"]()) {
			this["oDataTip"]["bAutoShowOnFocus"] = this["bDataTipAutoShowOnFocus"];
			this["oDataTip"]["bAutoShowOnFirstFocus"] = this["bDataTipAutoShowOnFirstFocus"];
			this["oDataTip"]["open"]();
		}

		if (oFieldHelp && !oFieldHelp["bIsDestroyed"]) {
			oOpenRef = this["oGetOpenRef"]();

			if (!UCF_JsUtil["bInstanceOf"](oFieldHelp, 'UCF_LayeredControl') ||
				oFieldHelp["oOpenerRef"] === oOpenRef || (
					oFieldHelp["oOpenerRef"] &&
					oFieldHelp["oOpenerRef"]["firstChild"] === oOpenRef
				)) {
				this["detachFieldHelpEvents"]();
			}

			this["onAfterCloseFieldHelp"](bImmediate);
		}
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}

	this["setInteractionState"]({ "FocusOnInput": true });
	this["fireEvent"](this["E_EVENTS"]["DidCloseFieldHelp"], {});
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["closeFieldHelp"] = 0; };
// #endregion
// #region oGetOpenRef --------------------------------------------------------
/**
 * @protected
 * @return {HTMLElement}
 */
UCF_EditFieldBase["prototype"]["oGetOpenRef"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetOpenRef"]++; }; 
	return this["oRootRef"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetOpenRef"] = 0; };
// #endregion
// #region after --------------------------------------------------------------
/**
 * @protected
 * @param {boolean} bImmediate
 */
UCF_EditFieldBase["prototype"]["onAfterCloseFieldHelp"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterCloseFieldHelp"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterCloseFieldHelp"] = 0; };
// #endregion
// #endregion
// #region   detach ===========================================================
/** @protected */
UCF_EditFieldBase["prototype"]["detachFieldHelpEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["detachFieldHelpEvents"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["detachFieldHelpEvents"] = 0; };
// #endregion
// #endregion
// #region workarounds ########################################################
/** @private */
UCF_EditFieldBase["prototype"]["applyWorkarounds"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["applyWorkarounds"]++; }; 
	if (this["bShouldWorkaroundQuirksPosition"]()) {
		this["quirksPositionWorkaround"]();
	}
	if (this["bShouldWorkaroundJumpingInputPromptWidth"]()) {
		this["jumpingInputPromptWidthWorkaround"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["applyWorkarounds"] = 0; };
// #region   quirks position ==================================================
// #region should? ------------------------------------------------------------
/**
 * @private
 * @return {boolean} `true` if quirks position should be workarounded
 */
UCF_EditFieldBase["prototype"]["bShouldWorkaroundQuirksPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldWorkaroundQuirksPosition"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	return this["oCache"]["get"]('bShouldWorkaroundQuirksPosition', function() {
		return self["oLS"]["oGetRenderManager"]()["callFragment"](
			'InputFieldShouldWorkaroundQuirksPosition',
			'InputField', { "UsedInSapTable": self["bUsedInSapTable"] }
		);
	});
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldWorkaroundQuirksPosition"] = 0; };
// #endregion
// #region workaround ---------------------------------------------------------
/**
 * CSN 278084/2019 (D064766):
 * Fields in Quirks (not UsedInSapTable) have position:relative to make Quirks
 * show the top border. They are misplaced in Iframe PopupWindows (move to the
 * top of the iframe). Triggering a forced reflow repositions them correctly.
 *
 * @private
 */
UCF_EditFieldBase["prototype"]["quirksPositionWorkaround"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["quirksPositionWorkaround"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	UCF_JsUtil["requestIdleCallback"](function() {
		UCF_DomUtil["setStyle"](self["oRootRef"], 'position', '');
	});
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["quirksPositionWorkaround"] = 0; };
// #endregion
// #endregion
// #region   jumping InputPrompt width ========================================
// #region should? ------------------------------------------------------------
/**
 * @private
 * @return {boolean} `true` if the jumping width of an EditField with an InputPrompt
 * should be workarounded, otherwise `false`
 */
UCF_EditFieldBase["prototype"]["bShouldWorkaroundJumpingInputPromptWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldWorkaroundJumpingInputPromptWidth"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	return this["oCache"]["get"](
		'bShouldWorkaroundJumpingInputPromptWidth',
		function() {
			return self["oLS"]["oGetRenderManager"]()["callFragment"](
				'InputFieldShouldWorkaroundJumpingInputPromptWidth',
				'InputField', {
					"Hidden": false,
					"InputPrompt": self["sInputPrompt"],
					"Width": self["sWidth"]
				}
			);
		}
	) && UCF_DomUtil["bIsVisible"](this["oDomRef"], true);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldWorkaroundJumpingInputPromptWidth"] = 0; };
// #endregion
// #region workaround ---------------------------------------------------------
/**
 * If no width is specified and the EditField has an InputPrompt (which is
 * italic in some themes), the width of the EditField jumps once it is focused
 * (as the italic font-style is removed and the width is character-width
 * based). This is workarounded by freezing the `offsetWidth` to the element
 * style.
 *
 * @private
 */
UCF_EditFieldBase["prototype"]["jumpingInputPromptWidthWorkaround"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["jumpingInputPromptWidthWorkaround"]++; }; 
	/** @type {CSSStyleDeclaration} */
	var oDomRefComputedStyle;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["bShouldWorkaroundJumpingInputPromptWidth"](), "this.bShouldWorkaroundJumpingInputPromptWidth()", "EditFieldBase.js(3845): jumpingInputPromptWidthWorkaround"); };

	oDomRefComputedStyle = UCF_DomUtil["oGetComputedStyle"](this["oDomRef"]);

	// CSN 1680289547: IE6 throws an error when assigning calc(...) to the width
	// which causes the initialize (and all further initializes) to break
	UCF_DomUtil["setStyle"](
		this["oDomRef"],
		'width',
		(__UCF_IE6__ ||
			oDomRefComputedStyle["boxSizing"] === 'border-box')
		? this["oDomRef"]["offsetWidth"] + 'px'
		: 'calc('
		+ this["oDomRef"]["offsetWidth"] + 'px - '
		+ oDomRefComputedStyle["borderLeftWidth"] + ' - '
		+ oDomRefComputedStyle["borderRightWidth"] + ')');
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["jumpingInputPromptWidthWorkaround"] = 0; };
// #endregion
// #endregion
// #endregion
// #region public api #########################################################
// #region   sGetValue ========================================================
// #endregion
// #region   setChanged =======================================================
UCF_EditFieldBase["prototype"]["setChanged"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setChanged"]++; }; 
	throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('#setChanged() not overwritten in . Don\'t know how to mark this ' + this["sClassName"] + 'as changed.');
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setChanged"] = 0; };
// #endregion
// #region   setInputState ====================================================
/**
 * Sets the input state of an input field
 *
 * @param {'ERROR'|'WARNING'|'NONE'|'INVALIDATE'|'INVALIDATELOADING'|'OK'} sInputState
 * the state
 * @param {string} sText text to display in the data tip
 * @public
 * @deprecated use method setValueState
 */
// eslint-disable-next-line complexity
UCF_EditFieldBase["prototype"]["setInputState"] = function(sInputState, sText) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setInputState"]++; }; 
	/** @type {UCF_DataTip} */
	var oDataTip;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sInputState === 'ERROR' || sInputState === 'WARNING' || sInputState === 'NONE' || sInputState === 'INVALIDATE' || sInputState === 'INVALIDATELOADING' || sInputState === 'OK', "sInputState === 'ERROR' || sInputState === 'WARNING' || sInputState === 'NONE' || sInputState === 'INVALIDATE' || sInputState === 'INVALIDATELOADING' || sInputState === 'OK'", "EditFieldBase.js(3888): setInputState"); };

	if (this["oDataTip"] && !this["oDataTip"]["bIsValid"]()) {
		this["oDataTip"]["removeFromDom"]();
		this["oDataTip"]["destroy"]();
		this["oDataTip"] = null;
	}

	oDataTip = this["oDataTip"];
	if (!oDataTip && sText) {
		UCF_JsUtil["delayedCall"](0, this, 'createDataTipDelayed');
	}

	// set new state .. the RO or disabled status is not considered
	// comment all the operation for styles and build the style below
	switch (sInputState) {
		case 'ERROR':
			this["setMessageBarsState"](sText, 'ERROR');
			if (oDataTip) {
				oDataTip["setType"]('ERROR');
				oDataTip["setText"](sText);
				if (this["bHasFocus"]()) {
					oDataTip["open"]();
				}
			}
			break;
		case 'WARNING':
			this["setMessageBarsState"](sText, 'WARNING');
			if (oDataTip) {
				oDataTip["setType"]('WARNING');
				oDataTip["setText"](sText);
				if (this["bHasFocus"]()) {
					oDataTip["open"]();
				}
			}
			break;
		case 'OK':
			if (oDataTip) {
				oDataTip["setType"]('OK');
				oDataTip["setText"](sText);
			}
			this["setMessageBarsState"](sText, 'OK');
			break;
		case 'NONE':
			if (oDataTip) {
				this["removeDataTip"]();
			}
			break;
		case 'INVALIDATE':
			this["setMessageBarsState"](sText, 'INVALIDATE');
			if (oDataTip) {
				oDataTip["setInvalidated"](true);
			}
			break;
		case 'INVALIDATELOADING':
			this["setMessageBarsState"](sText, 'INVALIDATELOADING');
			if (oDataTip) {
				oDataTip["setInvalidated"](true);
			}
			break;
	}

	if (
		(
			sInputState === 'WARNING' ||
			sInputState === 'ERROR' ||
			sInputState === 'OK' ||
			this["sInputState"] === 'WARNING' ||
			this["sInputState"] === 'ERROR' ||
			this["sInputState"] === 'OK'
		) && (sInputState !== this["sInputState"])
	) {
		// we can call updateStyles() before updating this.sInputState, b/c this only
		// requests an AnimationFrame, and by the time the AnimationFrame is fired,
		// this.sInputState will have been updated properly
		this["updateStyles"]();
	}

	this["sInputState"] = sInputState;
	this["bInvalid"] = this["sInputState"] === 'ERROR';
	// eslint-disable-next-line quotes
	this["setClientProperty"]("InputState", this["sInputState"], true);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setInputState"] = 0; };

/**
 * Creates and assigns a Datatip - has to be done delayed since xmlhttp request
 * is disabled during a paste event
 *
 * @private
 */
UCF_EditFieldBase["prototype"]["createDataTipDelayed"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["createDataTipDelayed"]++; }; 
	if (!this["oDataTip"]) {
		this["oDataTip"] = this["createDataTip"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["createDataTipDelayed"] = 0; };

/**
 * Sets the state of all corresponding Message Bars of this input field
 *
 * @private
 * @param {string} sText the text of the message bar
 * @param {string} sType the type of the message bar
 */
UCF_EditFieldBase["prototype"]["setMessageBarsState"] = function(sText, sType) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setMessageBarsState"]++; }; 
	/** @type {UCF_EditFieldBase} */
	var self = this;

	UCF_JsUtil["forEach"](
		this["oLS"]["oControlFactory"]["oGetCurrentControlsByClassName"](
			'UCF_MessageBar',
			false
		),
		function(messageBar) {
			if (messageBar["sConnectedControlId"] === self["sId"]) {
				if (sType === 'INVALIDATE') {
					messageBar["setInvalidated"](true);
				} else if (sType === 'INVALIDATELOADING') {
					messageBar["setInvalidated"](true);
					messageBar["setType"]('LOADING');
				} else {
					messageBar["setText"](sText);
					messageBar["setType"](sType);
				}
			}
		}
	);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setMessageBarsState"] = 0; };
// #endregion
// #region   setCursorPosition ================================================
/**
 * Set cursor position
 *
 * @public
 * @param {number} iPos the position where the cursor should be set
 */
UCF_EditFieldBase["prototype"]["setCursorPosition"] = function(iPos) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setCursorPosition"]++; }; 
	/** @type {UCF_FocusInfo} */
	var oFocusInfo = new (UCF_ClassLoader["oGetClass"]("UCF_FocusInfo"))(this["oLS"]);

	oFocusInfo["setApplyControl"](this);
	oFocusInfo["setFocussedId"](this["sId"]);
	oFocusInfo["addParam"]('iCursorPos', iPos);
	oFocusInfo["addParam"]('iSelectionStart', -1);
	oFocusInfo["addParam"]('bEditMode', true);
	oFocusInfo["addParam"]('sValue', this["sGetCurrentValue"]());
	this["oLS"]["focusElement"](oFocusInfo["sSerialize"]());

	// show help button
	if (this["bHideFieldHelp"]) {
		this["showButton"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setCursorPosition"] = 0; };
// #endregion
// #region   setSelection =====================================================
/**
 * Set selection
 *
 * @see UCF_DomUtil.setSelection
 * @param {number} iStart position of the start of the selection
 * @param {number} iEnd position of the end of the selection
 * @public
 */
UCF_EditFieldBase["prototype"]["setSelection"] = function(iStart, iEnd) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setSelection"]++; }; 
	/** @type {UCF_FocusInfo} */
	var oFocusInfo = new (UCF_ClassLoader["oGetClass"]("UCF_FocusInfo"))(this["oLS"]);

	oFocusInfo["setApplyControl"](this);
	oFocusInfo["setFocussedId"](this["sId"]);
	oFocusInfo["addParam"]('iSelectionStart', iStart);
	oFocusInfo["addParam"]('iSelectionEnd', iEnd);
	oFocusInfo["addParam"]('iSelectionEnd', iEnd);
	oFocusInfo["addParam"]('bEditMode', true);
	oFocusInfo["addParam"]('sValue', this["sGetCurrentValue"]());
	this["oLS"]["focusElement"](oFocusInfo["sSerialize"]());

	if (this["bHideFieldHelp"]) {
		this["showButton"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setSelection"] = 0; };
// #endregion
// #region   setSelectionInternal =============================================
/**
 * Set selection
 *
 * @see UCF_DomUtil.setSelection
 * @param {element} oDomRef Dom element which should be selected
 * @param {number} iStart position of the start of the selection
 * @param {number} iEnd position of the end of the selection
 * @protected
 */
UCF_EditFieldBase["prototype"]["setSelectionInternal"] = function(oDomRef, iStart, iEnd) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setSelectionInternal"]++; }; 
	UCF_DomUtil["setSelection"](oDomRef, parseInt(iStart) || 0, parseInt(iEnd) || 0);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setSelectionInternal"] = 0; };
// #endregion
// #region   iGetSelectionStart ===============================================
/**
 * Get start of selection
 *
 * @see UCF_EditFieldBase.prototype.getSelectionCursor
 * @return {number} start of selection
 * @public
 */
UCF_EditFieldBase["prototype"]["iGetSelectionStart"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["iGetSelectionStart"]++; }; 
	return this["getSelectionCursor"]('Start');
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["iGetSelectionStart"] = 0; };

/**
 * Gets start (`sStartEnd == 'Start'`) or end (`sStartEnd == 'End'`)
 * of the current selection
 *
 * @private
 * @param {'Start'|'End'} sStartEnd wether to get the 'Start' or the 'End' of
 * the selection
 * @return {number} position of selection `sStartEnd`, or 0 if exception was
 * thrown
 */
UCF_EditFieldBase["prototype"]["getSelectionCursor"] = function(sStartEnd) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["getSelectionCursor"]++; }; 
	try {
		if (UCF_DomUtil["oGetActiveElement"]() === this["oDomRef"]
			|| this["oDomRef"]['selection' + sStartEnd]) {
			return UCF_DomUtil['iGetSelection' + sStartEnd](this["oDomRef"]);
		} else {
			return this['iSelection' + sStartEnd];
		}
	} catch (exception) {
		return 0;
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["getSelectionCursor"] = 0; };
// #endregion
// #region   iGetSelectionEnd =================================================
/**
 * Get end of selection
 *
 * @see UCF_EditFieldBase.prototype.getSelectionCursor
 * @public
 * @return {number} end of selection
 */
UCF_EditFieldBase["prototype"]["iGetSelectionEnd"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["iGetSelectionEnd"]++; }; 
	return this["getSelectionCursor"]('End');
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["iGetSelectionEnd"] = 0; };
// #endregion
// #region   getValue =========================================================
// #endregion
// #region   setValue =========================================================
// #endregion
// #region   setCurrentValue ==================================================
/**
 * Set current value for Fields
 *
 * @public
 * @param {string} sCurrentValue the new value
 */
UCF_EditFieldBase["prototype"]["setCurrentValue"] = function(sCurrentValue) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setCurrentValue"]++; }; 
	this["setDomRefValue"](sCurrentValue);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setCurrentValue"] = 0; };
// #endregion
// #region   setEnabled =======================================================
/**
 * Set enabled
 *
 * @public
 * @param {boolean} bEnabled the new enabled value
 */
UCF_EditFieldBase["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setEnabled"]++; }; 
	if (this["getEnabled"]() !== bEnabled) {
		this["bEnabled"] = bEnabled;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Enabled", this["getEnabled"](), true);

		this["oDomRef"]["readOnly"] = this["bReadonly"] || !bEnabled;

		this["setTabIndex"]();

		if (window["UCF_System"]["bIsAria"]) {
			UCF_AriaStateHelper["setDisabled"](this["oDomRef"], !this["getEnabled"]());
		}

		this["updateStyles"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setEnabled"] = 0; };

/**
 * sets the tabindex of `#oDomRef` to either 0 or -1, depending on
 * accessibility mode as well as enabled and readonly flags
 *
 * @private
 */
UCF_EditFieldBase["prototype"]["setTabIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setTabIndex"]++; }; 
	UCF_DomUtil["setTabIndex"](
		this["oDomRef"],
		(window["UCF_System"]["bIs508"] || this["bIsWriteable"]()) ? 0 : -1
	);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setTabIndex"] = 0; };
// #endregion
// #region   getEnabled =======================================================
/**
 * Get enabled
 *
 * @public
 * @return {boolean} the enabled state
 */
UCF_EditFieldBase["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["getEnabled"]++; }; 
	return this["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["getEnabled"] = 0; };
// #endregion
// #region   setEditable ======================================================
/**
 * Set the editable state
 *
 * @param {boolean} bEditable the new editable value
 * @public
 */
UCF_EditFieldBase["prototype"]["setEditable"] = function(bEditable) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setEditable"]++; }; 
	/** @type {boolean} */
	var bReadonly = !bEditable;

	if (this["bReadonly"] === bReadonly) {
		// nothing to do
	} else if (this["getEnabled"]()) {
		this["oDomRef"]["readOnly"] = bReadonly;
		this["bReadonly"] = bReadonly;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Readonly", this["bReadonly"], true);

		this["setTabIndex"]();

		if (window["UCF_System"]["bIsAria"]) {
			UCF_AriaStateHelper["setReadonly"](this["oDomRef"], this["bReadonly"]);
		}

		this["updateStyles"]();
	} else {
		this["bReadonly"] = bReadonly;
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setEditable"] = 0; };
// #endregion
// #region   getEditable ======================================================
/**
 * Get the editable state
 *
 * @return {boolean} the editable state
 * @public
 */
UCF_EditFieldBase["prototype"]["getEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["getEditable"]++; }; 
	return !this["bReadonly"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["getEditable"] = 0; };
// #endregion
// #region   setRequired ======================================================
/**
 * Set required
 *
 * @public
 * @param {boolean} bRequired the new required value
 */
UCF_EditFieldBase["prototype"]["setRequired"] = function(bRequired) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setRequired"]++; }; 
	if (this["bRequired"] !== bRequired) {
		this["bRequired"] = bRequired;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Required", this["bRequired"], true);

		this["updateStyles"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setRequired"] = 0; };
// #endregion
// #region   getRequired ======================================================
/**
 * Get required
 *
 * @return {boolean} the required state
 * @public
 */
UCF_EditFieldBase["prototype"]["getRequired"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["getRequired"]++; }; 
	return this["bRequired"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["getRequired"] = 0; };
// #endregion
// #region   setValueState ====================================================
/**
 * Sets the value state of an input field
 *
 * @param {'ERROR'|'WARNING'|'NONE'} sValueState value state
 * @param {string} sText for the data tip
 * @public
 */
UCF_EditFieldBase["prototype"]["setValueState"] = function(sValueState, sText) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setValueState"]++; }; 
	this["setInputState"](sValueState, sText);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setValueState"] = 0; };
// #endregion
// #region   getValueState ====================================================
/**
 * Gets the input state of this edit field
 *
 * @return {string} the required state
 * @public
 */
UCF_EditFieldBase["prototype"]["getValueState"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["getValueState"]++; }; 
	return this["sInputState"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["getValueState"] = 0; };
// #endregion
// #region   sGetFormatString =================================================
// #endregion
// #region   sGetUnformattedValue =============================================
// #endregion
// #region   createDataTip ====================================================
// #endregion

// #region   notify the Toolbar for changes ====================================================
/**
 * Notify the Toolbar for changes
 * @private
 */
UCF_EditFieldBase["prototype"]["notifyToolbarForChanges"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["notifyToolbarForChanges"]++; }; 

	var oParent = this["oGetParent"]();
	if (oParent && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_Toolbar_standards')) {
		oParent["onContentChange"]();
	}

};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["notifyToolbarForChanges"] = 0; };
// #endregion

// #region   setVisibility ====================================================
/**
 * Sets the visibility state of the InputField control.
 * @param {string} sVisibility the visibility
 * @public
 */
UCF_EditFieldBase["prototype"]["setVisibility"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setVisibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sVisibility === 'string', "typeof sVisibility === 'string'", "EditFieldBase.js(4315): setVisibility"); };

	UCF_DomUtil["setVisibility"](this["oRootRef"], sVisibility);
	this["sVisibility"] = sVisibility;
	// eslint-disable-next-line quotes
	this["setClientProperty"]("Visibility", this["sVisibility"], true);

	if (this["bUsedInToolbar"]) {
		UCF_DomUtil["setVisibility"](UCF_DomUtil["$"](this["sId"] + '-tr'), sVisibility);
		this["notifyToolbarForChanges"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setVisibility"] = 0; };
// #endregion
// #endregion
// #region framework-internal api #############################################
// #region   toggleNavigationMode =============================================
/**
 * Needed for DataGrid: todo: refactor
 * @protected
 */
UCF_EditFieldBase["prototype"]["toggleNavigationMode"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["toggleNavigationMode"]++; }; 
	if (this["oNavigation"]["bIsEditMode"]()) {
		this["oNavigation"]["navigationMode"]();
	} else {
		this["oNavigation"]["editMode"]();
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["toggleNavigationMode"] = 0; };
// #endregion
// #region   bIsUserTextSelection =============================================
/**
 * SapTable needs information if a text selection is caused by the user or not:
 * If the selection is set to visualize the table navigation mode (which is not
 * caused by the user, a "cellSelect" (and following rowSelect) can be
 * triggered by the table. A real user selection (mouse down and drag) should
 * NOT trigger a cellSelect!
 *
 * @protected
 * @return {boolean} `true` if the control text is selected (by the user), `false` otherweise
 */
UCF_EditFieldBase["prototype"]["bIsUserTextSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsUserTextSelection"]++; }; 
	if ((this["oNavigation"]["bIsEditMode"]() || this["bReadonly"]) && this["sGetCurrentValue"]()) {
		return UCF_DomUtil["sGetSelectionText"](this["oDomRef"]) ? true : false;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsUserTextSelection"] = 0; };
// #endregion
// #region   importValue ======================================================
/**
 * Set a value if the control is ready for input and fires a change event
 *
 * @see UCF_ClipboardUtil.pasteIntoTable
 * @protected
 * @final
 * @param {string} sValue the value to import
 */
UCF_EditFieldBase["prototype"]["importValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["importValue"]++; }; 
	if (this["bShouldImportValue"](sValue)) {
		this["onAfterImportValue"](this["sValidImportValue"](sValue));
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["importValue"] = 0; };

/**
 * @private
 * @param {string} sValue the value to import
 * @return {boolean}
 */
UCF_EditFieldBase["prototype"]["bShouldImportValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldImportValue"]++; }; 
	return this["bIsWriteable"]() && this["sGetCurrentValue"]() !== sValue;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldImportValue"] = 0; };

/**
 * @private
 * @param {string} sValue the value to import
 * @return {string} the value cut at iMaxLength
 */
UCF_EditFieldBase["prototype"]["sValidImportValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sValidImportValue"]++; }; 
	return this["iMaxLength"] > 0
		? sValue["substring"](0, this["iMaxLength"])
		: sValue;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sValidImportValue"] = 0; };

/**
 * @protected
 * @param {string} sValue the new value
 */
UCF_EditFieldBase["prototype"]["onAfterImportValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterImportValue"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onAfterImportValue"] = 0; };
// #endregion
// #region   iGetWidthPx ======================================================
/**
 * @override
 * @return {number} width in px
 */
UCF_EditFieldBase["prototype"]["iGetWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["iGetWidthPx"]++; }; 
	/** @type {UCF_InputFieldHelpButton} */
	var oHelpButton = this["oGetHelpButton"]();

	return UCF_Control.prototype["iGetWidthPx"]["apply"](this, arguments) + ((oHelpButton && oHelpButton["bIsConnected"](this))
		? oHelpButton["iGetWidthPx"]()
		: 0
	);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["iGetWidthPx"] = 0; };
// #endregion
// #endregion
// #region child-control-internal api #########################################
// #region   prepareFireChange ================================================
/**
 * @protected
 * @param {UCF_EditFieldBase_ChangeReason} [iReason] the reason for the change
 * @param {boolean} [bDelayed] `true` to fire change with 500ms delay
 * @param {boolean} [bForced] `true` to override the value change check
 * @throws {UCF_Exception} if no event is fired, an exception is thrown
 */
UCF_EditFieldBase["prototype"]["prepareFireChange"] = function(iReason, bDelayed, bForced) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["prepareFireChange"]++; }; 
	/** @type {UCF_EditFieldBase_FireChangeEvent} */
	var oData = { "iReason": iReason, "bDelayed": bDelayed, "bForced": bForced };
	/** @type {boolean} */
	var bFireValidate;
	/** @type {booleanyy} */
	var bInvalidate;

	if (bForced) {
		this["setChanged"]();
	}

	this["fireEvent"](this["E_EVENTS"]["WillFireChange"], oData);
	this["fireEvent"](this["E_EVENTS"]["FireChange"], oData);

	bFireValidate = this["bShouldFireValidate"](iReason);
	bInvalidate = this["sInputState"] !== 'ERROR' && this["sInputState"] !== 'WARNING';
	if (this["bHasEventListeners"]('Validate')) {
		this["bIgnoreDefaultButton"] = true;
		if (bInvalidate) {
			this["setInputState"]('INVALIDATELOADING');
		}
		if (bFireValidate) {
			this["fireValidate"](this["sId"], this["sGetCurrentValue"]());
		}
	} else if (bInvalidate) {
		this["setInputState"]('INVALIDATE');
	}

	this["fireEvent"](this["E_EVENTS"]["DidFireChange"], oData);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["prepareFireChange"] = 0; };
// #endregion
// #region   bShouldFireValidate ==============================================
/**
 * @protected
 * @param {UCF_EditFieldBase_ChangeReason} iReason
 * @return {boolean}
 */
UCF_EditFieldBase["prototype"]["bShouldFireValidate"] = function(iReason) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldFireValidate"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldFireValidate"] = 0; };
// #endregion
// #region   bScrolledIntoView ================================================
/**
 * Verifies if the control is visible within a possible scroll container
 *
 * @private
 * @return {boolean} false if scrolling failed
 */
UCF_EditFieldBase["prototype"]["bScrolledIntoView"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bScrolledIntoView"]++; }; 
	/** @type {HTMLElement} */
	var oScrollDomRef = UCF_DomUtil["oGetParentScrollContainer"](this["oRootRef"], false, false, true);
	/** @type {number} */
	/** the amount of pixels the page in the window has been scrolled */
	var iScrollTop;
	/** @type {_ObjectRect} */
	var oRect;

	if (!oScrollDomRef) {
		return true;
	}

	iScrollTop = UCF_DomUtil["iGetScrollTop"](oScrollDomRef);
	// CSN 1880381685: unnecesary scroll event in Chrome
	if (iScrollTop === 0) { return true; }

	oRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"], oScrollDomRef);
	if (UCF_UserAgent["bIsAndroid"]()) {
		oRect = this["oLS"]["oGetViewportObjectRect"](this["oDomRef"]);
	}

	return !oRect
		|| ((oRect["top"] + oRect["height"] >= iScrollTop)
			&& (oRect["top"] <= iScrollTop + oScrollDomRef["offsetHeight"]));
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bScrolledIntoView"] = 0; };
// #endregion
// #region   sGetTabBehaviour =================================================
/**
 * @protected
 * @return {string} the tabbehaviour of the EditFieldBase
 */
UCF_EditFieldBase["prototype"]["sGetTabBehaviour"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetTabBehaviour"]++; }; 
	return typeof this["sTabBehaviour"] === 'string' ? this["sTabBehaviour"] : 'STANDARD';
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetTabBehaviour"] = 0; };
// #endregion
// #region   iGetMaxLength ====================================================
/**
 * @protected
 * @return {number}
 */
UCF_EditFieldBase["prototype"]["iGetMaxLength"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["iGetMaxLength"]++; }; 
	return typeof this["iMaxLength"] === 'number' ? this["iMaxLength"] : -1;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["iGetMaxLength"] = 0; };
// #endregion
// #region   sGetCurrentValue =================================================
/**
 * @protected
 * @return {string} the current this.oDomRef.value or '' (if the value is a
 * fake for the required indicator or the input prompt)
 */
UCF_EditFieldBase["prototype"]["sGetCurrentValue"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetCurrentValue"]++; }; 
	return (
			this["bIsCurrentValueRequiredIndicator"]() ||
			this["bIsCurrentValueInputPrompt"]()
		)
		? ''
		: this["sGetDomRefValue"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetCurrentValue"] = 0; };

/**
 * @private
 * @return {boolean} `true` if the current this.oDomRef.value is actually the
 * required indicator
 */
UCF_EditFieldBase["prototype"]["bIsCurrentValueRequiredIndicator"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsCurrentValueRequiredIndicator"]++; }; 
	return this["bUsesValueForIndicators"]()
		&& this["bRequired"]
		&& this["bShowRequiredIndicator"]
		&& this["bIsAsteriskRequiredIndicator"]
		&& this["sGetDomRefValue"]() === '*';
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsCurrentValueRequiredIndicator"] = 0; };

/**
 * @private
 * @return {boolean} `true` if the current this.oDomRef.value is actually the
 * input prompt
 */
UCF_EditFieldBase["prototype"]["bIsCurrentValueInputPrompt"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsCurrentValueInputPrompt"]++; }; 
	return this["bUsesValueForIndicators"]()
		&& this["bCurrentValueInputPrompt"]
		&& this["sGetDomRefValue"]() === this["sInputPrompt"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsCurrentValueInputPrompt"] = 0; };

/**
 * Due to HPIFs one can't rely on this.oDomRef.value. This is not a problem
 * after the HPIF <span> is exchanged to the <input>, but before it is (e.g.
 * in the constructor, or in the onlsblur that is triggered from exchanging
 * the HPIF <span>).
 *
 * @protected
 * @return {string}
 */
UCF_EditFieldBase["prototype"]["sGetDomRefValue"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetDomRefValue"]++; }; 
	/** @type {string} */
	var sValue = 'value' in this["oDomRef"]
		? this["oDomRef"]["value"]
		: (this["oLS"]["oSystem"]["sDevice"] === 'standards'
			? this["oDomRef"]["textContent"]
			: this["oDomRef"]["innerHTML"]);

	return (sValue && this["bUpperCase"]) ? sValue["toUpperCase"]() : sValue;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sGetDomRefValue"] = 0; };

/**
 * @protected
 * @param {string} sValue the value to set
 */
UCF_EditFieldBase["prototype"]["setDomRefValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setDomRefValue"]++; }; 
	if (this["oDomRef"]["nodeName"] === 'SPAN') {
		if (this["oLS"]["oSystem"]["sDevice"] === 'standards') {
			this["oDomRef"]["textContent"] = sValue;
		} else {
			this["oDomRef"]["innerText"] = sValue;
		}
	} else {
		this["oDomRef"]["value"] = sValue;
		this["setClientProperty"]("Value", sValue, true);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["setDomRefValue"] = 0; };
// #endregion
// #region   bSkipEventProcessing =============================================

/**
 * Determines if according to the state of the control a event processing makes
 * sense
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @return {boolean} if the event processing has to be stopped
 * @private
 */
UCF_EditFieldBase["prototype"]["bSkipEventProcessing"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bSkipEventProcessing"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent, "oBrowserEvent", "EditFieldBase.js(4611): bSkipEventProcessing"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oBrowserEvent === 'object', "typeof oBrowserEvent === 'object'", "EditFieldBase.js(4612): bSkipEventProcessing"); };

	return !this["getEnabled"]() // Skip when disabled
		|| (
			// Skip when readonly and help button is not active
			this["bReadonly"] &&
			(!this["bShowHelpButtonAlways"] ||
				oBrowserEvent["oGetSource"]() !== this["oGetHelpButtonRef"]()
			)
		);
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bSkipEventProcessing"] = 0; };
// #endregion
// #region   attachOnce =======================================================
/**
 * @see #detachOnce
 * @protected
 * @final
 * @param {string} sBrowserEvent the name of the browser event to attach to
 * @param {HTMLElement} [oDomRef=this.oDomRef] the DOM element to attach to
 */
UCF_EditFieldBase["prototype"]["attachOnce"] = function(sBrowserEvent, oDomRef) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["attachOnce"]++; }; 
	if (!this["mAttachedHandlerCache"]) {
		this["mAttachedHandlerCache"] = {};
	}
	if (sBrowserEvent in this["mAttachedHandlerCache"]) {
		this["mAttachedHandlerCache"][sBrowserEvent] += 1;
	} else {
		this["attachBrowserEvent"](sBrowserEvent, oDomRef || this["oDomRef"]);
		this["mAttachedHandlerCache"][sBrowserEvent] = 1;
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["attachOnce"] = 0; };
// #endregion
// #region   detachOnce =======================================================
/**
 * detaches from `sBrowserEvent` if there is no longer a need to be attached
 * to it (i.e. reference counting). detaches immediately if no references were
 * counted for sBrowserEvent.
 *
 * @example
 * this.attachOnce('resize') // => 1 handler, 1x attached
 * this.attachOnce('resize') // => 2 handlers, 1x attached
 * this.detachOnce('resize') // => 1 handler, 1x attached
 * this.detachOnce('resize') // => 0 handlers, detached
 *
 * @example
 * this.detachOnce('blur') // => no handler counted, detached
 *
 * @protected
 * @final
 * @param {string} sBrowserEvent the name of the browser event to detach from
 * @param {HTMLElement} [oDomRef=this.oDomRef] the DOM element to detach from
 */
UCF_EditFieldBase["prototype"]["detachOnce"] = function(sBrowserEvent, oDomRef) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["detachOnce"]++; }; 
	if (!this["mAttachedHandlerCache"]) {
		this["mAttachedHandlerCache"] = {};
	}
	if (sBrowserEvent in this["mAttachedHandlerCache"]) {
		this["mAttachedHandlerCache"][sBrowserEvent] -= 1;
		if (this["mAttachedHandlerCache"][sBrowserEvent] === 0) {
			this["detachBrowserEvent"](sBrowserEvent, oDomRef || this["oDomRef"]);
		}
	} else {
		this["detachBrowserEvent"](sBrowserEvent, oDomRef || this["oDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["detachOnce"] = 0; };
// #endregion
// #region   sAddAnyEventHandler ==============================================
/**
 * @param {{fWhen: function(UCF_BrowserEvent): boolean, fThen: function(UCF_BrowserEvent): void}} oHandler the AnyEvent handler
 * @return {string} uuid of the handler - to call #removeAnyEventHandler() with
 */
UCF_EditFieldBase["prototype"]["sAddAnyEventHandler"] = function(oHandler) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sAddAnyEventHandler"]++; }; 
	/** @type {string} */
	var sUid = UCF_JsUtil["sGetUID"]();

	this["oAnyEventHandlers"][sUid] = oHandler;

	if (!this["mAttachedHandlerCache"]) {
		this["mAttachedHandlerCache"] = {};
	}
	if ('AnyEvent' in this["mAttachedHandlerCache"]) {
		this["mAttachedHandlerCache"]["AnyEvent"] += 1;
	} else {
		this["oLS"]["oBrowserWindow"]["attachEvent"](
			this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"],
			this,
			'onAnyEvent'
		);
		this["mAttachedHandlerCache"]["AnyEvent"] = 1;
	}

	return sUid;
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["sAddAnyEventHandler"] = 0; };
// #endregion
// #region   removeAnyEventHandler ============================================
/**
 * @protected
 * @param {string} sUid the ID of the any event handler to remove
 */
UCF_EditFieldBase["prototype"]["removeAnyEventHandler"] = function(sUid) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["removeAnyEventHandler"]++; }; 
	if (!this["mAttachedHandlerCache"]) {
		this["mAttachedHandlerCache"] = {};
	}
	if ('AnyEvent' in this["mAttachedHandlerCache"]) {
		this["mAttachedHandlerCache"]["AnyEvent"] -= 1;
		try {
			delete this["oAnyEventHandlers"][sUid];
		} catch (e) {
			this["oAnyEventHandlers"][sUid] = function() {};
		}

		if (this["mAttachedHandlerCache"]["AnyEvent"] === 0) {
			this["oLS"]["oBrowserWindow"]["detachEvent"](
				this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"],
				this,
				'onAnyEvent'
			);
			try {
				delete this["mAttachedHandlerCache"]["AnyEvent"];
			} catch (ignored) {
				this["mAttachedHandlerCache"]["AnyEvent"] = undefined;
			}
		}
	} else {
		this["oLS"]["oBrowserWindow"]["detachEvent"](
			this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"],
			this,
			'onAnyEvent'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["removeAnyEventHandler"] = 0; };
// #endregion
// #region   handleEarlyHandlerLeave ==========================================
/**
 * @private
 * @param {UCF_Exception} oException the exception thrown to leave the handler early
 */
UCF_EditFieldBase["prototype"]["handleEarlyHandlerLeave"] = function(oException) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleEarlyHandlerLeave"]++; }; 
	if (UCF_JsUtil["bInstanceOf"](oException, 'UCF_Exception')) {
		// regular way of leaving handling early is to throw a UCF_Exception
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, oException["message"], "EditFieldBase.js(4752): handleEarlyHandlerLeave"); };
	} else {
		throw oException;
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleEarlyHandlerLeave"] = 0; };
// #endregion
// #endregion
// #region control-internal helpers ###########################################
// #region   update references ================================================
/**
 * updates references, e.g. after exchanging the field on the client side
 * @param {HTMLElement} oDomRef Dom reference
 * @private
 */
UCF_EditFieldBase["prototype"]["updateReferences"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["updateReferences"]++; }; 
	// update references
	this["oDomRef"] = oDomRef || UCF_DomUtil["$"](this["sId"]);
	this["oRootRef"] = UCF_DomUtil["$"](this["sId"] + '-r');
	this["oFocusDomRef"] = this["oDomRef"];
	if (this["oDataTip"]) {
		this["oDataTip"]["setOpenerRef"](this["oDomRef"]);
	}
	if (this["bShowHelpButton"] && !this["bHideFieldHelp"]) {
		this["oHelpButtonRef"] = UCF_DomUtil["$"](this["sId"] + '-btn');
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["updateReferences"] = 0; };

// #endregion
// #region   oGetFocusDomRef ==================================================
/**
 * returns the DomRef which is to be focused
 * @return {element} oFocusDomRef
 * @protected
 */
UCF_EditFieldBase["prototype"]["oGetFocusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetFocusDomRef"]++; }; 
	return this["oDomRef"]["getAttribute"]('ti') === '0'
		? this["oDomRef"]
		: this["oRootRef"]["getAttribute"]('ti') === '0'
		? this["oRootRef"]
		: this["oDomRef"];

};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetFocusDomRef"] = 0; };
// #endregion
// #region   bIsFieldsOverlayEnabled ==========================================
/**
 * @private
 * @static
 * @type {boolean}
 */
UCF_EditFieldBase["bFieldsOverlayEnabled"] = null;

/**
 * @private
 * @return {boolean}
 */
UCF_EditFieldBase["prototype"]["bIsFieldsOverlayEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsFieldsOverlayEnabled"]++; }; 
	if (typeof UCF_EditFieldBase["bFieldsOverlayEnabled"] !== 'boolean') {
		UCF_EditFieldBase["bFieldsOverlayEnabled"] = this["oLS"]["oGetRenderManager"]()["callFragment"](
			'IsEnabled',
			'FeatureFlags', { "Feature": 'Fields.Overlay' }
		);
	}

	return UCF_EditFieldBase["bFieldsOverlayEnabled"];
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bIsFieldsOverlayEnabled"] = 0; };
// #endregion
// #region   bShouldShowOverlay ===============================================
/**
 * returns the DomRef which is to be focused
 * @return {boolean} `true` if phone overlay should be displayed
 * otherwise `false`
 * @protected
 */
UCF_EditFieldBase["prototype"]["bShouldShowOverlay"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldShowOverlay"]++; }; 
	return this["bIsWriteable"]()
		&& (UCF_JsUtil["bInstanceOf"](this, 'UCF_SuggestBox')
			|| UCF_JsUtil["bInstanceOf"](this, 'UCF_ComboBox')
			&& this["bIsWriteable"]()
		)
		&& this["bIsFieldsOverlayEnabled"]()
		&& this["oGetMetadata"]()["supportsOverlay"]
		&& (this["bShouldDisplayOverlay"]() ||
			UCF_UserAgent["bIsPhone"]() ||
			this["bIsOpen"]() && UCF_DomUtil["bHasClass"](this["oRootRef"], 'lsField--overlay'));
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["bShouldShowOverlay"] = 0; };
// #endregion
// #region   oGetMetadata =====================================================
/**
 * @protected
 * @static
 * @return {UCF_EditFieldBase_Metadata}
 */
UCF_EditFieldBase["prototype"]["oGetMetadata"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetMetadata"]++; }; 
	return this["oCache"]["get"]('oMetadata', function() {
		return UCF_ResourceUtil["oGetMetadataFromTheme"]('lsField__metadata');
	});
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["oGetMetadata"] = 0; };
// #endregion
// #region   onTouchStart =====================================================
/**
 * @param {UCF_BrowserEvent} oTouchStart
 */
UCF_EditFieldBase["prototype"]["onlstouchstart"] = function(oTouchStart) {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlstouchstart"]++; }; 
	this["setInteractionState"]({ "TouchInteraction": true });
	this["handleFieldOverlayEvents"]();
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["onlstouchstart"] = 0; };
// #endregion
// #region   handleFieldOverlayEvents =========================================
/**
 * @private
 */
UCF_EditFieldBase["prototype"]["handleFieldOverlayEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleFieldOverlayEvents"]++; }; 
	if (this["bShouldShowOverlay"]()) {
		/** @type {UCF_Fields_OverlayDelegate} */
		if (!this["oOverlayDelegate"]) {
			this["oOverlayDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Fields_OverlayDelegate"))(this);
			this["addDelegate"](this["oOverlayDelegate"]);
			this["attachEvent"](
				this["E_EVENTS"]["WillOpenFieldHelp"],
				this["oOverlayDelegate"],
				'onWillOpenFieldHelp'
			);
			this["attachEvent"](
				this["E_EVENTS"]["WillDestroy"],
				this["oOverlayDelegate"],
				'onWillDestroyField'
			);
			this["attachEvent"](
				this["E_EVENTS"]["DidCloseFieldHelp"],
				this["oOverlayDelegate"],
				'onDidCloseFieldHelp'
			);
			this["attachEvent"](
				this["E_EVENTS"]["WillFireListAccess"],
				this["oOverlayDelegate"],
				'onWillFireListAccess'
			);
			this["attachEvent"](this["E_EVENTS"]["DidClickToOpenOverlay"],
				this,
				'onDidClickToOpenOverlay'
			);
			this["oLS"]["oBrowserWindow"]["attachEvent"](
				this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"],
				this,
				'onLayoutChange'
			);
		}
	} else if (this["oOverlayDelegate"]) {
		this["removeDelegate"](this["oOverlayDelegate"]);
		this["detachEvent"](
			this["E_EVENTS"]["WillOpenFieldHelp"],
			this["oOverlayDelegate"],
			'onWillOpenFieldHelp'
		);
		this["detachEvent"](
			this["E_EVENTS"]["DidCloseFieldHelp"],
			this["oOverlayDelegate"],
			'onDidCloseFieldHelp'
		);
		this["detachEvent"](
			this["E_EVENTS"]["WillDestroy"],
			this["oOverlayDelegate"],
			'onWillDestroyField'
		);
		this["detachEvent"](
			this["E_EVENTS"]["WillFireListAccess"],
			this["oOverlayDelegate"],
			'onWillFireListAccess'
		);
		this["detachEvent"](this["E_EVENTS"]["DidClickToOpenOverlay"],
			this,
			'onDidClickToOpenOverlay'
		);
		this["oLS"]["oBrowserWindow"]["detachEvent"](
			this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"],
			this,
			'onLayoutChange'
		);
		this["oOverlayDelegate"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_EditFieldBase["_"]["handleFieldOverlayEvents"] = 0; };
// #endregion

UCF_EditFieldBase.prototype["aPublicMethods"] = ["setCursorPosition","setSelection","iGetSelectionStart","iGetSelectionEnd","setCurrentValue","setEnabled","getEnabled","setEditable","getEditable","setRequired","getRequired","setValueState","getValueState","setVisibility"].concat(UCF_EditFieldBase.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_EventQueueDebugHelper"] = function() {/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_EventQueueItem */
/// <reference path="../ucf/EventQueueItem.js"/>

/** @typedef {0x01} UCF_EventQueueDebugHelper_SkipIfUnselectedFeature */
/** @typedef {0x02} UCF_EventQueueDebugHelper_SkipIfEmptyFeature */
/** @typedef {0x04} UCF_EventQueueDebugHelper_HighlightSelectedFeature */
/** @typedef {0x10} UCF_EventQueueDebugHelper_InjectLinksFeature */
/** @typedef {0x20} UCF_EventQueueDebugHelper_WaitingQueueFeature */
/** @typedef {UCF_EventQueueDebugHelper_SkipIfUnselectedFeature|UCF_EventQueueDebugHelper_SkipIfEmptyFeature|UCF_EventQueueDebugHelper_HighlightSelectedFeature|UCF_EventQueueDebugHelper_InjectLinksFeature|UCF_EventQueueDebugHelper_WaitingQueueFeature} UCF_EventQueueDebugHelper_Feature */
/**
 * @typedef {Object} UCF_EventQueueDebugHelper_FeatureEnum
 * @property {UCF_EventQueueDebugHelper_SkipIfUnselectedFeature} SKIP_IF_UNSELECTED
 * @property {UCF_EventQueueDebugHelper_SkipIfEmptyFeature} SKIP_IF_EMPTY
 * @property {UCF_EventQueueDebugHelper_HighlightSelectedFeature} HIGHLIGHT_SELECTED
 * @property {UCF_EventQueueDebugHelper_InjectLinksFeature} INJECT_LINKS
 * @property {UCF_EventQueueDebugHelper_WaitingQueueFeature} WAITING_QUEUE
 */
/** @typedef {0x32} UCF_EventQueueDebugHelper_CurrentMode */
/** @typedef {0x36} UCF_EventQueueDebugHelper_OnSubmitMode */
/** @typedef {0x12} UCF_EventQueueDebugHelper_OnConvertMode */
/** @typedef {UCF_EventQueueDebugHelper_CurrentMode|UCF_EventQueueDebugHelper_OnSubmitMode|UCF_EventQueueDebugHelper_OnConvertMode} UCF_EventQueueDebugHelper_Mode */

/**
 * Helper class for displaying of formatted as the part of the trace window
 * IMPLEMENTED AS SINGLETON
 *
 * Important Note: the EventHandler and there contained Event- and Waiting-Queues
 * are injected on level of private methods, thus this all class has to be seen
 * as the integral part of UCF and adopted anytime when changes on Event-Queue
 * model are performed.
 *
 * CSS classes used for rendering:
 *    .eq, .eq_head
 *    .eqsel, .eqsel_head
 *    .eq_ctrl, .eq_evt, .eq_id, .eq_data
 *    .eq_err
 *
 * @class
 * 
 */
function UCF_EventQueueDebugHelper() {if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["UCF_EventQueueDebugHelper"]++; }; 
	UCF_Object["apply"](this);
};window["UCF_EventQueueDebugHelper"] = UCF_EventQueueDebugHelper; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_EventQueueDebugHelper"); UCF_EventQueueDebugHelper["_"] = {UCF_EventQueueDebugHelper: 0}; }; 
UCF_EventQueueDebugHelper["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_EventQueueDebugHelper.prototype["sClassName"] = "UCF_EventQueueDebugHelper";

// Feature switches and Bit-maps ----------------

/** @type {UCF_EventQueueDebugHelper_FeatureEnum} */
UCF_EventQueueDebugHelper["prototype"]["FEATURE"] = {
	"SKIP_IF_UNSELECTED": 0x01, // x  ignore queues, that are not marked as selected
	"SKIP_IF_EMPTY": 0x02, // x  ignore queues, without entries
	"HIGHLIGHT_SELECTED": 0x04, //    hightlight selected queue
	"INJECT_LINKS": 0x10, //    inject links to data section
	"WAITING_QUEUE": 0x20 //    display content of waiting queue
};

/** @type {0x32} */
UCF_EventQueueDebugHelper["prototype"]["MODE_CURRENT"] = 0x32;
/** @type {0x36} */
UCF_EventQueueDebugHelper["prototype"]["MODE_ONSUBMIT"] = 0x36;
/** @type {0x12} */
UCF_EventQueueDebugHelper["prototype"]["MODE_ONCONVERT"] = 0x12;

/**
 * @param {UCF_EventQueueDebugHelper_Mode} iMode
 * @param {UCF_EventQueueDebugHelper_Feature} iFeatureFlag
 * @return {boolean}
 */
UCF_EventQueueDebugHelper["prototype"]["bModeMatch"] = function(iMode, iFeatureFlag) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["bModeMatch"]++; }; 
	return ((iMode & iFeatureFlag) > 0);
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["bModeMatch"] = 0; };

// --------------------------------------------------------------------------
//  Dump of all Queues, based on currrent Event Handler
// --------------------------------------------------------------------------
/**
 * @param {UCF_EventHandler} oEventHandler
 * @param {UCF_EventQueueDebugHelper_Mode} iMode
 * @return {string}
 */
UCF_EventQueueDebugHelper["prototype"]["sDumpQueues"] = function(oEventHandler, iMode) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sDumpQueues"]++; }; 
	/** @type {string[]} */
	var sBuff = [];
	/** @type {UCF_EventQueue} */
	var oPageQueue;
	/** @type {Object<string, UCF_EventQueue>} */
	var mFormQueues;
	/** @type {UCF_WaitingEventQueue} */
	var oWEQueue;
	/** @type {boolean} */
	var bPageQueueEnabled;
	/** @type {string} */
	var sPageQueueSubstitute;
	/** @type {string} */
	var sFQueue;
	/** @type {string} */
	var sLabel;

	this["renderDumpBegin"](sBuff);

	if (oEventHandler) {
		oPageQueue = oEventHandler["oQueue"];
		mFormQueues = oEventHandler["mFormQueues"];
		oWEQueue = oEventHandler["oWEQueue"];

		bPageQueueEnabled = oEventHandler["bPageQueueEnabled"];
		sPageQueueSubstitute = oEventHandler["sPageQueueSubstitute"];

		if (oPageQueue) {
			if (bPageQueueEnabled) {
				this["dumpOneQueue"](oPageQueue, sBuff, iMode, 'Page EventQueue');
			} else {
				this["dumpPageQueueSubstitute"](
					oPageQueue,
					sBuff,
					iMode,
					'Page EventQueue',
					sPageQueueSubstitute
				);
			}
		}
		for (sFQueue in mFormQueues) {
			sLabel = 'Form EventQueue for ' + this["sInjectCIDLink"](sFQueue);
			this["dumpOneQueue"](mFormQueues[sFQueue], sBuff, iMode, sLabel);
		}

		if (this["bModeMatch"](iMode, this["FEATURE"]["WAITING_QUEUE"])) {
			this["dumpWaitingEventQueue"](oWEQueue, sBuff, iMode, 'WaitingEventQueue');
		}

	} else {
		this["renderErrorMessage"](sBuff, 'No EventHandler or Queues available');
	}

	this["renderDumpEnd"](sBuff);

	return sBuff["join"]('');
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sDumpQueues"] = 0; };

// --------------------------------------------------------------------------
//    DUMP ONE QUEUE  reference when handed over to another queue
// --------------------------------------------------------------------------

/**
 * @param {UCF_EventQueue} oQueue
 * @param {string} sBuff
 * @param {UCF_EventQueueDebugHelper_Mode} iMode
 * @param {string} sLabel
 * @param {string} sSubstitute
 */
UCF_EventQueueDebugHelper["prototype"]["dumpPageQueueSubstitute"] = function(oQueue, sBuff, iMode, sLabel, sSubstitute) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["dumpPageQueueSubstitute"]++; }; 
	/** @type {UCF_EventQueueItem[]} */
	var aEntries = oQueue["aQueue"];
	/** @type {number} */
	var iLen = aEntries["length"];
	/** @type {boolean} */
	var bSelected = oQueue["bDebugMarker"];
	/** @type {string} */
	var sTechLabel = oQueue["sDebugLabel"];
	/** @type {string} */
	var sClass;

	sLabel = sLabel + ' delegated to Form: ' + this["sInjectCIDLink"](sSubstitute);

	// skip empty queues -----
	if (this["bModeMatch"](iMode, this["FEATURE"]["SKIP_IF_EMPTY"]) && iLen <= 0) {
		return;
	}

	// skip not selected queues  ----
	if (this["bModeMatch"](iMode, this["FEATURE"]["SKIP_IF_UNSELECTED"]) && !bSelected) {
		return;
	}

	// resolve style classes representing selection
	sClass = 'eq';
	if (this["bModeMatch"](iMode, this["FEATURE"]["HIGHLIGHT_SELECTED"])) {
		sClass = bSelected ? 'eqsel' : 'eq';
	}

	//  RENDER HEAD -----------
	this["renderEventQueueHead"](sBuff, sClass, sLabel, sTechLabel, iLen);
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["dumpPageQueueSubstitute"] = 0; };

// --------------------------------------------------------------------------
//    DUMP ONE QUEUE  directly form EventQueue object
// -----------------------------------------------------------------------

/**
 * @param {UCF_EventQueue} oQueue
 * @param {string} sBuff
 * @param {UCF_EventQueueDebugHelper_Mode} iMode
 * @param {string} sLabel
 */
UCF_EventQueueDebugHelper["prototype"]["dumpOneQueue"] = function(oQueue, sBuff, iMode, sLabel) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["dumpOneQueue"]++; }; 
	/** @type {UCF_EventQueueItem[]} */
	var aEntries = oQueue["aQueue"];
	/** @type {number} */
	var iLen = aEntries["length"];
	/** @type {boolean} */
	var bSelected = oQueue["bDebugMarker"];
	/** @type {string} */
	var sTechLabel = oQueue["sDebugLabel"];
	/** @type {string} */
	var sClass;
	/** @type {number} */
	var i;
	/** @type {string} */
	var sCtrlId;
	/** @type {string} */
	var sCtrlName;
	/** @type {string} */
	var sEventName;
	/** @type {string} */
	var sData;

	// skip empty queues -----
	if (this["bModeMatch"](iMode, this["FEATURE"]["SKIP_IF_EMPTY"]) && iLen <= 0) {
		return;
	}

	// skip not selected queues  ----
	if (this["bModeMatch"](iMode, this["FEATURE"]["SKIP_IF_UNSELECTED"]) && !bSelected) {
		return;
	}

	// resolve style classes representing selection
	sClass = 'eq';
	if (this["bModeMatch"](iMode, this["FEATURE"]["HIGHLIGHT_SELECTED"])) {
		sClass = bSelected ? 'eqsel' : 'eq';
	}

	//  RENDER HEAD -----------
	this["renderEventQueueHead"](sBuff, sClass, sLabel, sTechLabel, iLen);

	// RENDER ENTRIES ---------
	for (i = 0; i < iLen; i++) {
		sCtrlId = aEntries[i]["sGetControlId"]();
		sCtrlName = aEntries[i]["sGetControlName"]();
		sEventName = aEntries[i]["sGetEventName"]();
		sData = this["sFormatEventEntryDelimiters"](
			aEntries[i]["sGetSerializedData"](),
			true
		);

		if (iMode & this["FEATURE"]["INJECT_LINKS"]) {
			sCtrlId = this["sInjectCIDLink"](sCtrlId);
			sData = this["sInjectSemanticToData"](sData);
		}
		this["renderEventEntry"](
			sBuff,
			sClass,
			i,
			sCtrlId,
			sCtrlName,
			sEventName,
			sData
		);
	}
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["dumpOneQueue"] = 0; };

// --------------------------------------------------------------------------
// DUMP ONE QUEUE, indirectly from string sample on HTTP traffic
//
// see also:   http://www.regular-expressions.info/javascriptexample.html
// --------------------------------------------------------------------------

/** @type {boolean} fatal error, no recovery possible */
UCF_EventQueueDebugHelper["prototype"]["FATAL"] = true;
/** @type {boolean} recovery possible, i.e. for next item */
UCF_EventQueueDebugHelper["prototype"]["ERROR"] = false;

/**
 * @param {string} sSample
 * @param {UCF_EventQueueDebugHelper_Mode} iMode
 * @return {string}
 */
UCF_EventQueueDebugHelper["prototype"]["sConvertFromHttp"] = function(sSample, iMode) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sConvertFromHttp"]++; }; 
	/** @type {string[]} */
	var aBuff = [];
	/** @type {string} */
	var sTheParam = '';
	/** @type {number} */
	var i = 0;
	/** @type {string[]} */
	var aParams = null;
	/** @type {string} */
	var sValidPattern = '';
	/** @type {string[]} */
	var aMatchResult = null;
	/** @type {string} */
	var sRawData = '';
	/** @type {string} */
	var sAllData = '';
	/** @type {string} */
	var sEncodingType = '[UNKNOWN]';
	/** @type {string[]} */
	var aEntries = null;
	/** @type {boolean} */
	var bSelected = false;
	/** @type {string} */
	var sTheEntry = '';
	/** @type {string} */
	var sTechLabel = '';
	/** @type {string} */
	var sCtrlId = '';
	/** @type {string} */
	var sCtrlName = '';
	/** @type {string} */
	var sEventName = '';
	/** @type {string} */
	var sData = this["sFormatEventEntryDelimiters"](sTheEntry, true);
	/** @type {string} */
	var sValidFirstSection = /([^_]+)_([^\ue002]+)\ue002.+/;
	/** @type {string[]} */
	var aMatchResultFirstSection = null;
	/** @type {string} */
	var sValidControlId = /[^\ue002]+\ue002Id\ue004([^\ue003\ue005]+)[\ue003\ue005].+/;
	/** @type {string[]} */
	var aMatchResultControlId = null;
	/** @type {string} */
	var sClass;

	this["renderDumpBegin"](aBuff);

	// Assume worst-case with several parameters i.e. from request body, thus
	// extract the given parameter first
	if (sSample["indexOf"]('&') >= 0) {
		aParams = sSample["split"]('&');
		for (i = 0; i < aParams["length"]; i++) {
			if (aParams[i]["indexOf"]('SAPEVENTQUEUE') === 0) {
				sTheParam = aParams[i];
				break;
			}
		}
		if (sTheParam === '') {
			return this["renderErrorMsg"](
				aBuff,
				'Parameter SAPEVENTQUEUE not found',
				this["FATAL"]
			);
		}
	} else {
		sTheParam = sSample;
	}

	// consider that eventually a value without a key, but with whithespace
	// characters are used, strip them to get pure data block
	sValidPattern = /(SAPEVENTQUEUE)?(\s)*(=)?(\s)*([\w-.~%]+)([^\w-.~%]*)?/;
	aMatchResult = sTheParam["match"](sValidPattern);

	// eslint-disable-next-line no-magic-numbers
	if (aMatchResult == null || aMatchResult[5]["length"] === 0) {
		return this["renderErrorMsg"](
			aBuff,
			'Invalid Data block of EventQueue',
			this["FATAL"]
		);
	};
	sRawData = aMatchResult[5]; // eslint-disable-line no-magic-numbers

	// Guess encoding, based on given delimiters and convert the data block
	// into well-defined format with single-chars separators from range
	// \ue001-\ue006
	try {
		if (this["bIsTransportEncoded"](sRawData)) {
			sAllData = this["sTransportDecode"](sRawData);
			sEncodingType = '[UCF-Safe-Transport]';
		} else if (this["bIsUTF8Encoded"](sRawData)) {
			sAllData = this["sUTF8Decode"](sRawData);
			sEncodingType = '[UTF-8]';
		} else if (this["bIsTransportAndUTF8Encoded"]) {
			sAllData = this["sTransportDecode"](this["sUTF8Decode"](sRawData));
			sEncodingType = '[UTF-8] over [UCF-Safe-Transport]';
		} else {
			return this["renderErrorMsg"](
				aBuff,
				'Unknown Encoding of Data Block',
				this["FATAL"]
			);
		}
	} catch (ex) {
		return this["renderErrorMsg"](
			aBuff,
			'Invalid Data block of EventQueue: Decoding Failed',
			this["FATAL"]
		);
	}

	// Now we have all our delimiters as single chars \ue001-ue005
	// Remove transport decoding & split
	aEntries = sAllData["split"]('\ue001');
	bSelected = false;

	// resolve style classes representing selection
	sClass = 'eq';
	if (this["bModeMatch"](iMode, this["FEATURE"]["HIGHLIGHT_SELECTED"])) {
		sClass = bSelected ? 'eqsel' : 'eq';
	}

	//  RENDER HEAD -----------
	sTechLabel = ' - guessed Encoding ' + sEncodingType;
	this["renderEventQueueHead"](
		aBuff,
		sClass,
		'SAPEVENTQUEUE converted',
		sTechLabel,
		aEntries["length"]
	);

	// RENDER ENTRIES ---------
	for (i = 0; i < aEntries["length"]; i++) {
		sTheEntry = aEntries[i];

		if (sTheEntry == null || sTheEntry === '') {
			this["renderErrorMsg"](aBuff, 'EventQueueItem missing', this["ERROR"]);
			continue;
		}

		aMatchResultFirstSection = sTheEntry["match"](sValidFirstSection);
		aMatchResultControlId = sTheEntry["match"](sValidControlId);

		if (
			aMatchResultFirstSection == null ||
			aMatchResultFirstSection[1]["length"] === 0 ||
			aMatchResultFirstSection[1]["length"] === 0 ||
			aMatchResultControlId == null ||
			aMatchResultControlId[1]["length"] === 0
		) {
			this["renderErrorMsg"](
				aBuff,
				'Keys for EventQueueItem not recognized',
				this["ERROR"]
			);
			continue;
		}

		// match brackets
		if (!this["bSectionMatch"](sTheEntry)) {
			this["renderErrorMsg"](
				aBuff,
				'EventQueueItem Format Missmatch: Unpaired Delimiters',
				this["ERROR"]
			);
			continue;
		}

		// obtain key fields & data
		sCtrlId = aMatchResultControlId[1];
		sCtrlName = aMatchResultFirstSection[1];
		// eslint-disable-next-line no-magic-numbers
		sEventName = aMatchResultFirstSection[2];

		sData = this["sFormatEventEntryDelimiters"](sTheEntry, true);

		if (iMode & this["FEATURE"]["INJECT_LINKS"]) {
			sCtrlId = this["sInjectCIDLink"](sCtrlId);
			sData = this["sInjectSemanticToData"](sData);
		}

		this["renderEventEntry"](
			aBuff,
			sClass,
			i,
			sCtrlId,
			sCtrlName,
			sEventName,
			sData
		);
	}

	this["renderDumpEnd"](aBuff);

	return aBuff["join"]('');
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sConvertFromHttp"] = 0; };

// ------------------------------------------------
//  Dump the content of Waiting Queue
// ------------------------------------------------
/**
 * @param {UCF_WaitingEventQueue} oWEQueue
 * @param {string[]} aBuff
 * @param {UCF_EventQueueDebugHelper_Mode} iMode
 * @param {string} sLabel
 */
UCF_EventQueueDebugHelper["prototype"]["dumpWaitingEventQueue"] = function(oWEQueue, aBuff, iMode, sLabel) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["dumpWaitingEventQueue"]++; }; 
	/** @type {UCF_SemanticEvent[]} */
	var aEntries = oWEQueue["aQueue"];
	/** @type {string} */
	var iLen = aEntries["length"];
	/** @type {string} */
	var sClass;
	/** @type {number} */
	var i;
	/** @type {UCF_SemanticEvent} */
	var oSemanticEvent;
	/** @type {UCF_EventQueueItem} */
	var oEventQueueItem;
	/** @type {string} */
	var sCtrlId;
	/** @type {string} */
	var sCtrlName;
	/** @type {string} */
	var sEventName;
	/** @type {string} */
	var sData;

	// skip empty queues -----
	if (this["bModeMatch"](iMode, this["FEATURE"]["SKIP_IF_EMPTY"]) && iLen <= 0) {
		return;
	}

	sClass = 'eq';

	//  RENDER HEAD -----------
	this["renderEventQueueHead"](aBuff, sClass, sLabel, '', iLen);

	// RENDER ENTRIES ---------
	for (i = 0; i < iLen; i++) {
		oSemanticEvent = aEntries[i];
		oEventQueueItem = new (UCF_ClassLoader["oGetClass"]("UCF_EventQueueItem"))(oSemanticEvent);
		sCtrlId = oEventQueueItem["sGetControlId"]();
		sCtrlName = oEventQueueItem["sGetControlName"]();
		sEventName = oEventQueueItem["sGetEventName"]();
		sData = this["sFormatEventEntryDelimiters"](
			oEventQueueItem["sGetSerializedData"](),
			true
		);

		if (iMode & this["FEATURE"]["INJECT_LINKS"]) {
			sCtrlId = this["sInjectCIDLink"](sCtrlId);
			sData = this["sInjectSemanticToData"](sData);
		}
		this["renderEventEntry"](
			aBuff,
			sClass,
			i,
			sCtrlId,
			sCtrlName,
			sEventName,
			sData
		);

		oSemanticEvent = null;
		oEventQueueItem = null;
	}
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["dumpWaitingEventQueue"] = 0; };

//  ------ Helper methods for rendering -----------------

/** @param {string[]} aBuff */
UCF_EventQueueDebugHelper["prototype"]["renderDumpBegin"] = function(aBuff) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["renderDumpBegin"]++; }; 
	aBuff["push"]('<table class="eq">');
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["renderDumpBegin"] = 0; };

/** @param {string[]} aBuff */
UCF_EventQueueDebugHelper["prototype"]["renderDumpEnd"] = function(aBuff) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["renderDumpEnd"]++; }; 
	aBuff["push"]('</table>');
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["renderDumpEnd"] = 0; };

/**
 * @param {string[]} aBuff
 * @param {string} sMsg
 * @param {boolean} bFatalError
 * @return {string}
 */
UCF_EventQueueDebugHelper["prototype"]["renderErrorMsg"] = function(aBuff, sMsg, bFatalError) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["renderErrorMsg"]++; }; 
	if (bFatalError) {
		aBuff["push"]('<tr class="eq"><td class="eq eq_err eq_num">FATAL ERROR</td><td class="eq_err" colspan="4">');
		aBuff["push"](sMsg);
		aBuff["push"]('</td></tr>');

		this["renderDumpEnd"](aBuff);

		return aBuff["join"]('');
	} else {
		return '';
	}
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["renderErrorMsg"] = 0; };

/**
 * @param {string[]} aBuff
 * @param {string} sClass
 * @param {string} sLabel
 * @param {string} sTechLabel
 * @param {string} sLen
 */
UCF_EventQueueDebugHelper["prototype"]["renderEventQueueHead"] = function(aBuff, sClass, sLabel, sTechLabel, sLen) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["renderEventQueueHead"]++; }; 
	aBuff["push"]('<tr class="eq"><th colspan="5" class="' + sClass + '_head">');
	aBuff["push"](sLabel);
	aBuff["push"](' ( ');
	aBuff["push"](sLen);
	aBuff["push"](' Entries )  ');
	aBuff["push"](sTechLabel);
	aBuff["push"]('</th></tr>');
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["renderEventQueueHead"] = 0; };

/**
 * @param {string[]} aBuff
 * @param {string} sClass
 * @param {number} i
 * @param {string} sCtrlId
 * @param {string} sCtrlName
 * @param {string} sEventName
 * @param {string} sData
 */
UCF_EventQueueDebugHelper["prototype"]["renderEventEntry"] = function(aBuff, sClass, i, sCtrlId, sCtrlName, sEventName, sData) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["renderEventEntry"]++; }; 
	aBuff["push"]('<tr class="' + sClass + '"><td class="' + sClass + ' eq_num">');
	aBuff["push"](i);
	aBuff["push"]('</td><td class="' + sClass + ' eq_id">');
	aBuff["push"](sCtrlId);
	aBuff["push"]('</td><td class="' + sClass + ' eq_ctrl">');
	aBuff["push"](sCtrlName);
	aBuff["push"]('</td><td class="' + sClass + ' eq_evt">');
	aBuff["push"](sEventName);
	aBuff["push"]('</td><td class="' + sClass + ' eq_data">');
	aBuff["push"](sData);
	aBuff["push"]('</td></tr>');
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["renderEventEntry"] = 0; };

// ---- Convertors & Replacers ------------------------

/** @type {string} */
UCF_EventQueueDebugHelper["prototype"]["CIDL_1"] = '<a href="#" onclick="try{top.testFramework.highlightByControlId(\'';
/** @type {string} */
UCF_EventQueueDebugHelper["prototype"]["CIDL_2"] = '\');}catch(ex){};inspectId(this.innerHTML,event);return false;">';
/** @type {string} */
UCF_EventQueueDebugHelper["prototype"]["CIDL_3"] = '</a>';

/**
 * @param {string} [sPrefix='']
 * @param {string} sKey
 * @param {string} [sSuffix]
 * @return {string}
 */
UCF_EventQueueDebugHelper["prototype"]["sGetCIDLGeneric"] = function(sPrefix, sKey, sSuffix) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sGetCIDLGeneric"]++; }; 
	return (sPrefix || '') + this["CIDL_1"] + sKey + this["CIDL_2"] + sKey + this["CIDL_3"] + (sSuffix || '');
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sGetCIDLGeneric"] = 0; };

/**
 * @param {string} sId
 * @param {string} sText
 * @return {boolean}
 */
UCF_EventQueueDebugHelper["prototype"]["sInjectCIDLink"] = function(sId, sText) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sInjectCIDLink"]++; }; 
	return this["CIDL_1"] + sId + this["CIDL_2"] + (sText || sId) + this["CIDL_3"];
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sInjectCIDLink"] = 0; };

/**
 * @param {string} sData
 * @return {string}
 */
UCF_EventQueueDebugHelper["prototype"]["sInjectSemanticToData"] = function(sData) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sInjectSemanticToData"]++; }; 
	return sData
		["replace"](/(Id=)([\w\.-]+)/g, this["sGetCIDLGeneric"]('$1', '$2', ''))
		["replace"](/(Id': ')([\w\.-]+)(')/g, this["sGetCIDLGeneric"]('$1', '$2', '$3'));
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sInjectSemanticToData"] = 0; };

/**
 * @param {string} sEventEntry
 * @param {boolean} bCutFirstSection
 * @return {string}
 */
UCF_EventQueueDebugHelper["prototype"]["sFormatEventEntryDelimiters"] = function(sEventEntry, bCutFirstSection) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sFormatEventEntryDelimiters"]++; }; 
	return (bCutFirstSection
		? sEventEntry["substring"](sEventEntry["indexOf"]('\ue002'))
		: sEventEntry
	)
		["replace"](/\ue001/g, ' ')
		["replace"](/\ue002/g, '{')
		["replace"](/\ue003/g, '}')
		["replace"](/\ue004/g, '=')
		["replace"](/\ue005/g, ',')
		["replace"](/\ue006/g, '|');
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sFormatEventEntryDelimiters"] = 0; };

/**
 * @param {string} sSample
 * @return {boolean}
 */
UCF_EventQueueDebugHelper["prototype"]["bSectionMatch"] = function(sSample) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["bSectionMatch"]++; }; 
	return (!sSample || sSample === '')
		? true
		: sSample["replace"](/[^\ue002]/g, '')["length"] ===
			sSample["replace"](/[^\ue003]/g, '')["length"];
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["bSectionMatch"] = 0; };

// Encoders & Decoders -----------------------------------------------
//
//   1) UCF own Transport encoding  (i.e with WD ABAP, LSF...)
//
//   SAPEVENTQUEUE=InputField_Validate~E002Id~E004fruitsFirstname~E005Value~E
//   004Petr~E003~E002~E003~E002~E003~E001InputField_Change~E002Id~E004fruits
//   Firstname~E005Value~E004Petr~E003~E002Delay~E004full~E003~E002~E003~E001
//   ...
//
//   2) Pure UTF8 browser encoding (i.e. with WD Java)
//
//   SAPEVENTQUEUE=Button_Press%EE%80%82Id%EE%80%84HHAA.BusinessPartnerSearch
//   .Search%EE%80%83%EE%80%82ClientAction%EE%80%84submit%EE%80%83%EE%80%82ur
//   EventName%EE%80%84BUTTONCLICK%EE%80%83%EE%80%81 ...
//
//   3) UCF own transport encoded into UTF8 (i.e .wiht WD ABAP, LSF ..) when
//   the data are obtained from streamed the POST-BODY
//
//   SAPEVENTQUEUE=InputField_Validate%7EE002Id%7EE004colorFirstname%7EE005Va
//   lue%7EE004Happy%7E0026%7E0026%7E0026%7EE003%7EE002%7EE003%7EE002%7EE003%
//   7EE001InputField_Change%7EE002Id%7EE004colorFirstname%7EE005Value%7EE004
//   Happy%7E0026%7E0026%7E0026%7EE003%7EE002Delay%7EE004full%7EE003%7EE002%7
//   EE003%7EE001 ...
//
//
//   Encoding will be guessed based on existence of 2 delimiters that has
//   to occurs (not 100% reliable but seems to be sufficient in most cases)

/**
 * @param {string} sRawData
 * @return {boolean}
 */
UCF_EventQueueDebugHelper["prototype"]["bIsTransportEncoded"] = function(sRawData) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["bIsTransportEncoded"]++; }; 
	return (sRawData["indexOf"]('~E002') >= 0 && sRawData["indexOf"]('~E003') >= 0);
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["bIsTransportEncoded"] = 0; };

/**
 * @param {string} sRawData
 * @return {boolean}
 */
UCF_EventQueueDebugHelper["prototype"]["bIsUTF8Encoded"] = function(sRawData) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["bIsUTF8Encoded"]++; }; 
	return (sRawData["indexOf"]('%EE%80%82') >= 0 && sRawData["indexOf"]('%EE%80%83') >= 0);
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["bIsUTF8Encoded"] = 0; };

/**
 * @param {string} sRawData
 * @return {boolean}
 */
UCF_EventQueueDebugHelper["prototype"]["bIsTransportAndUTF8Encoded"] = function(sRawData) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["bIsTransportAndUTF8Encoded"]++; }; 
	return (sRawData["indexOf"]('%7EE002') >= 0 && sRawData["indexOf"]('%7EE003') >= 0);
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["bIsTransportAndUTF8Encoded"] = 0; };

/**
 * @param {string} sRawData
 * @return {string}
 */
UCF_EventQueueDebugHelper["prototype"]["sUTF8Decode"] = function(sRawData) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sUTF8Decode"]++; }; 
	return decodeURIComponent(sRawData);
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sUTF8Decode"] = 0; };

/**
 * @param {string} sRawData
 * @return {string}
 */
UCF_EventQueueDebugHelper["prototype"]["sTransportDecode"] = function(sRawData) {;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sTransportDecode"]++; }; 
	/** @type {string[]} */
	var aDecodeBuff = [];
	/** @type {number} */
	var i;
	/** @type {number} */
	var c;
	/** @type {string} */
	var ucc;
	/** @type {number} */
	var uc;

	for (i = 0; i < sRawData["length"];) {
		c = sRawData["charAt"](i);

		if (c === '~') {
			// eslint-disable-next-line no-magic-numbers
			ucc = sRawData["substring"](i + 1, i + 5);
			uc = parseInt(ucc, 16);
			aDecodeBuff["push"](String["fromCharCode"](uc));
			i += 5; // eslint-disable-line no-magic-numbers
		} else {
			aDecodeBuff["push"](c);
			i++;
		}
	}

	return aDecodeBuff["join"]('');
};;if (__UCF_COVERAGE__) { UCF_EventQueueDebugHelper["_"]["sTransportDecode"] = 0; };

/** @type {UCF_EventQueueDebugHelper} Singleton */
window["UCF_eventQueueDebugHelper"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventQueueDebugHelper"))();

};
sap["ls"]["preload"]["UCF_Expander"] = function() {/* global UCF_Object */
/// <reference path="../../core/Object.js"/>

/**
 * Class UCF_Expander
 *
 * Utility class for expanding/collapsing areas
 *
 * 
 * @class
 * @param {HTMLElement} oDomRef
 * @version
 */
function UCF_Expander(oDomRef) {if (__UCF_COVERAGE__) { UCF_Expander["_"]["UCF_Expander"]++; }; 

	UCF_Object["apply"](this);
	this["oDomRef"] = oDomRef;

	this["targetHeight"] = 0;

};window["UCF_Expander"] = UCF_Expander; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Expander"); UCF_Expander["_"] = {UCF_Expander: 0}; }; ;
UCF_Expander["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Expander.prototype["sClassName"] = "UCF_Expander";

/**
 * Method collapse
 *
 * collapses the area given to the expander constructor as oDomRef
 *
 */
UCF_Expander["prototype"]["collapse"] = function() {;if (__UCF_COVERAGE__) { UCF_Expander["_"]["collapse"]++; }; 

	//this.oDomRef.style.overflow = "hidden";
	this["oDomRef"]["style"]["display"] = "none";
	//this.collapseAnim();

};;if (__UCF_COVERAGE__) { UCF_Expander["_"]["collapse"] = 0; };

/**
 * Method expand
 *
 * expands the area given to the expander constructor as oDomRef
 *
 * @param {int} iTargetHeight
 */
UCF_Expander["prototype"]["expand"] = function(iTargetHeight) {;if (__UCF_COVERAGE__) { UCF_Expander["_"]["expand"]++; }; 

	this["oDomRef"]["style"]["overflow"] = "hidden";
	this["oDomRef"]["style"]["display"] = "block";
	this["oDomRef"]["style"]["height"] = "1px";

	if (iTargetHeight && iTargetHeight > 0) this["iTargetHeight"] = iTargetHeight;
	else this["iTargetHeight"] = this["oDomRef"]["scrollHeight"];

	this["expandAnim"]();
};;if (__UCF_COVERAGE__) { UCF_Expander["_"]["expand"] = 0; };

/**
 * Method collapseAnim
 *
 * private function for the collapse mechanism
 *
 */
UCF_Expander["prototype"]["collapseAnim"] = function() {;if (__UCF_COVERAGE__) { UCF_Expander["_"]["collapseAnim"]++; }; 

	var oExpander = this,
		oDomRef = this["oDomRef"];

	if (oDomRef["offsetHeight"] - Math["ceil"](oDomRef["offsetHeight"] / 3) > 1) {
		oDomRef["style"]["height"] = (oDomRef["offsetHeight"] - Math["ceil"](oDomRef["offsetHeight"] / 3)) + "px";
		setTimeout(function() { oExpander["collapseAnim"](); }, 20);
	} else {
		oDomRef["style"]["display"] = "none";
	}

};;if (__UCF_COVERAGE__) { UCF_Expander["_"]["collapseAnim"] = 0; };

/**
 * Method expandAnim
 *
 * private function for the expand mechanism
 *
 *  */
UCF_Expander["prototype"]["expandAnim"] = function() {;if (__UCF_COVERAGE__) { UCF_Expander["_"]["expandAnim"]++; }; 

	var oExpander = this,
		oDomRef = this["oDomRef"];
	if (oDomRef["offsetHeight"] + Math["ceil"](oDomRef["offsetHeight"] / 3) < this["iTargetHeight"]) {
		oDomRef["style"]["height"] = (oDomRef["offsetHeight"] + Math["ceil"]((this["iTargetHeight"] - oDomRef["offsetHeight"]) / 3)) + "px";
		setTimeout(function() { oExpander["expandAnim"](); }, 20);
	} else {
		oDomRef["style"]["height"] = this["iTargetHeight"] + "px";
		oDomRef["style"]["overflow"] = "";
	}

};;if (__UCF_COVERAGE__) { UCF_Expander["_"]["expandAnim"] = 0; };

/**
 * Destructor
 */
UCF_Expander["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Expander["_"]["destroy"]++; }; 
	this["oDomRef"] = null;
	this["iTargetHeight"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Expander["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_FieldNavigationDelegate"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>

/**
 * @class UCF_FieldNavigationDelegate
 * @extends UCF_Object
 * @param {UCF_EditFieldBase} oControl the field
 */
function UCF_FieldNavigationDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["UCF_FieldNavigationDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		this["oControl"] = oControl;
		this["oDomRef"] = this["oControl"]["oDomRef"];
		this["bEditMode"] = true;
	}
};window["UCF_FieldNavigationDelegate"] = UCF_FieldNavigationDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FieldNavigationDelegate"); UCF_FieldNavigationDelegate["_"] = {UCF_FieldNavigationDelegate: 0}; }; ;
UCF_FieldNavigationDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_FieldNavigationDelegate.prototype["sClassName"] = "UCF_FieldNavigationDelegate";

/** @override */
UCF_FieldNavigationDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["destroy"]++; }; 
	this["oDomRef"] = null;
	this["oControl"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["destroy"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oLsLeft the lsleft
 */
UCF_FieldNavigationDelegate["prototype"]["onlsleft"] = function(oLsLeft) {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsleft"]++; }; 
	oLsLeft["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsleft"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oLsRight the lsright
 */
UCF_FieldNavigationDelegate["prototype"]["onlsright"] = function(oLsRight) {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsright"]++; }; 
	oLsRight["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsright"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oLsSpace the lsspace
 */
UCF_FieldNavigationDelegate["prototype"]["onlsspace"] = function(oLsSpace) {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsspace"]++; }; 
	oLsSpace["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsspace"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oLsSpaceModifier the lsspacemodifier
 */
UCF_FieldNavigationDelegate["prototype"]["onlsspacemodifier"] = function(oLsSpaceModifier) {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsspacemodifier"]++; }; 
	oLsSpaceModifier["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsspacemodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oLsSelectModifier the lsselectmodifier
 */
UCF_FieldNavigationDelegate["prototype"]["onlsselectmodifier"] = function(oLsSelectModifier) {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsselectmodifier"]++; }; 
	if (this["oControl"]["bIsWriteable"]()) {
		oLsSelectModifier["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsselectmodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oLsHome the lshome
 */
UCF_FieldNavigationDelegate["prototype"]["onlshome"] = function(oLsHome) {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlshome"]++; }; 
	oLsHome["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlshome"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oLsEnd the lsend
 */
UCF_FieldNavigationDelegate["prototype"]["onlsend"] = function(oLsEnd) {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsend"]++; }; 
	oLsEnd["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["onlsend"] = 0; };

/** @protected */
UCF_FieldNavigationDelegate["prototype"]["navigationMode"] = function() {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["navigationMode"]++; }; 
	// nothing to do
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["navigationMode"] = 0; };

/** @protected */
UCF_FieldNavigationDelegate["prototype"]["editMode"] = function() {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["editMode"]++; }; 
	// nothing to do
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["editMode"] = 0; };

/** @protected */
UCF_FieldNavigationDelegate["prototype"]["keepEditMode"] = function() {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["keepEditMode"]++; }; 
	// nothing to do
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["keepEditMode"] = 0; };

/**
 * @protected
 * @return {boolean} `true`, because non-table fields are always in edit mode
 */
UCF_FieldNavigationDelegate["prototype"]["bIsEditMode"] = function() {;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["bIsEditMode"]++; }; 
	return this["bEditMode"];
};;if (__UCF_COVERAGE__) { UCF_FieldNavigationDelegate["_"]["bIsEditMode"] = 0; };

};
sap["ls"]["preload"]["UCF_Fields_AutoTabDelegate"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>

/**
 * @typedef {Object} UCF_AutoTabbableControl
 * @property {function(): number} iGetMaxLength
 * @property {function(): string} sGetTabBehaviour
 * @property {function(): string} sGetCurrentValue
 * @property {function(): void} [select]
 * @property {function(number): void} [setCursorPosition]
 * @property {function(): void} focus
 */

/**
 * @class UCF_Fields_AutoTabDelegate
 * @extends UCF_Object
 * @param {UCF_EditFieldBase} oControl
 */
function UCF_Fields_AutoTabDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["UCF_Fields_AutoTabDelegate"]++; }; 
	if (arguments["length"] > 0) {
		/** @type {UCF_EditFieldBase} */
		this["oControl"] = oControl;
		/** @type {UCF_LS} */
		this["oLS"] = this["oControl"]["oLS"];
		/** @type {boolean} */
		this["bSelected"] = false;
		/** @type {number} */
		this["iCursorPos"] = 0;
		/** @type {number} */
		this["iLastCursorPos"] = 0;
		/** @type {number} */
		this["iMaxLength"] = this["oControl"]["iGetMaxLength"]();
		/** @type {'STANDARD'|'AUTOINTRA'|'AUTOINTER'} */
		this["sTabBehaviour"] = this["oControl"]["sGetTabBehaviour"]();

		this["oControl"]["attachEvent"](
			this["oControl"]["E_EVENTS"]["DidFireChange"],
			this,
			'onDidFireChange'
		);
	}
};window["UCF_Fields_AutoTabDelegate"] = UCF_Fields_AutoTabDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Fields_AutoTabDelegate"); UCF_Fields_AutoTabDelegate["_"] = {UCF_Fields_AutoTabDelegate: 0}; }; ;
UCF_Fields_AutoTabDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Fields_AutoTabDelegate.prototype["sClassName"] = "UCF_Fields_AutoTabDelegate";

/** @override */
UCF_Fields_AutoTabDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["destroy"]++; }; 
	this["sTabBehaviour"] = null;
	this["iMaxLength"] = null;
	this["iLastCursorPos"] = null;
	this["iCursorPos"] = null;
	this["bSelected"] = null;
	this["oControl"] = null;
	this["oLS"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["destroy"] = 0; };

/**
 * @private
 * @param {UCF_Event<UCF_EditFieldBase_FireChangeEvent>} oEvent
 */
UCF_Fields_AutoTabDelegate["prototype"]["onDidFireChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onDidFireChange"]++; }; 
	/** @type {UCF_Fields_AutoTabDelegate} */
	var self = this;

	if (oEvent["oGetParam"]('bForced')) {
		// after prepareFireChange additional things may happen in the current
		// stacktrace, especially the ComboBox may set the focus back to the input
		// element, which removes the autotab -> have to perform after the stack
		if (this["oControl"]["sGetCurrentValue"]() === '') {
			UCF_JsUtil["setImmediate"](function() { self["autoTabBackward"](); });
		} else {
			UCF_JsUtil["setImmediate"](function() { self["autoTabForward"](); });
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onDidFireChange"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oClick
 */
UCF_Fields_AutoTabDelegate["prototype"]["onclick"] = function(oClick) {;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onclick"]++; }; 
	if (
		!this["oControl"]["bSkipEventProcessing"](oClick) &&
		this["oControl"]["sType"] === 'DATE' &&
		this["oControl"]["sFieldHelp"] === 'SPINNER'
	) {
		this["iCursorPos"] = UCF_DomUtil["iGetCursorPos"](this["oControl"]["oDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onclick"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oKeydown
 */
UCF_Fields_AutoTabDelegate["prototype"]["onkeydown"] = function(oKeydown) {;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onkeydown"]++; }; 
	/** @type {HTMLElement} */
	var oActiveElement;
	/** @type {number} */
	var iSelectionStart;
	/** @type {number} */
	var iSelectionEnd;

	if (
		this["oControl"]["getEnabled"]() &&
		(!this["oControl"]["bReadonly"] || this["oControl"]["bShowHelpButtonAlways"]) &&
		this["oControl"]["oNavigation"]["bIsEditMode"]()
	) {
		oActiveElement = UCF_DomUtil["oGetActiveElement"]();
		iSelectionStart = UCF_DomUtil["iGetSelectionStart"](this["oControl"]["oDomRef"]);
		iSelectionEnd = UCF_DomUtil["iGetSelectionEnd"](this["oControl"]["oDomRef"]);

		this["iCursorPos"] = oActiveElement === this["oControl"]["oDomRef"]
			? UCF_DomUtil["iGetCursorPos"](this["oControl"]["oDomRef"])
			: -1;
		this["bSelected"] = oActiveElement === this["oControl"]["oDomRef"] &&
			iSelectionStart > -1 &&
			iSelectionEnd > -1 &&
			iSelectionStart < iSelectionEnd;

		if (
			!this["bSelected"] && (
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["BACKSPACE"]) ||
				(
					UCF_Fields_AutoTabDelegate["bIsValidAutoTab"](oKeydown) &&
					this["iLastCursorPos"] !== this["iMaxLength"]
				)
			)
		) {
			if (window["UCF_System"]["bIsRTL"]) {
				this["onAutoTabRtl"](oKeydown);
			} else {
				this["onAutoTabLtr"](oKeydown);
			}
		}

		this["iLastCursorPos"] = this["oControl"]["iCursorPos"];
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onkeydown"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oKeyup
 */
UCF_Fields_AutoTabDelegate["prototype"]["onkeyup"] = function(oKeyup) {;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onkeyup"]++; }; 
	/** @type {boolean} */
	var bAutoTabBeforeMaxLength;
	/** @type {boolean} */
	var bCursorAtStart;
	/** @type {boolean} */
	var bCursorAtMaxLength;
	/** @type {boolean} */
	var bArrowLeft;
	/** @type {boolean} */
	var bArrowRight;

	if (this["oControl"]["oNavigation"]["bIsEditMode"]()) {
		this["iLastCursorPos"] = UCF_DomUtil["iGetCursorPos"](this["oControl"]["oDomRef"]);

		bAutoTabBeforeMaxLength = UCF_Fields_AutoTabDelegate["bIsValidAutoTab"](oKeyup) &&
			(this["iCursorPos"] !== this["iMaxLength"]);
		bCursorAtStart = this["iCursorPos"] === 0;
		bCursorAtMaxLength = this["iCursorPos"] === this["iMaxLength"];
		bArrowLeft = UCF_KeyboardHelper["bIsEventForKey"](oKeyup, UCF_KeyCodes["ARROW_LEFT"]);
		bArrowRight = UCF_KeyboardHelper["bIsEventForKey"](oKeyup, UCF_KeyCodes["ARROW_RIGHT"]);

		if (
			bAutoTabBeforeMaxLength ||
			(
				!this["bSelected"] && (UCF_Fields_AutoTabDelegate["bNavigationFlipped"]
					? (
						(bCursorAtStart && bArrowRight) ||
						(bCursorAtMaxLength && bArrowLeft)
					)
					: (
						(bCursorAtStart && bArrowLeft) ||
						(bCursorAtMaxLength && bArrowRight)
					)
				)
			)
		) {
			if (window["UCF_System"]["bIsRTL"]) {
				this["onAutoTabRtl"](oKeyup);
			} else {
				this["onAutoTabLtr"](oKeyup);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onkeyup"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Fields_AutoTabDelegate["prototype"]["onAutoTabLtr"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onAutoTabLtr"]++; }; 
	/** @type {number} */
	var iCursorPos = UCF_DomUtil["iGetCursorPos"](this["oControl"]["oDomRef"]);
	/** @type {boolean} */
	var bBackspace = UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["BACKSPACE"]);
	/** @type {boolean} */
	var bArrowLeft = UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["ARROW_LEFT"]);
	/** @type {boolean} */
	var bArrowRight = UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["ARROW_RIGHT"]);

	if (
		this["iMaxLength"] > 0 &&
		iCursorPos === this["iMaxLength"] &&
		this["oControl"]["sGetCurrentValue"]()["length"] === this["iMaxLength"] &&
		!bBackspace &&
		!bArrowLeft
	) {
		this["autoTabForward"](bArrowRight);
	} else if (iCursorPos === 0 && (bBackspace || bArrowLeft)) {
		this["autoTabBackward"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onAutoTabLtr"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Fields_AutoTabDelegate["prototype"]["onAutoTabRtl"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onAutoTabRtl"]++; }; 
	/** @type {number} */
	var iCursorPos = UCF_DomUtil["iGetCursorPos"](this["oControl"]["oDomRef"]);
	/** @type {boolean} */
	var bCursorAtStart = iCursorPos === (UCF_UserAgent["bIsSafari"](4)
		? this["iMaxLength"]
		: 0);
	/** @type {boolean} */
	var bCursorAtMaxLength = iCursorPos === (UCF_UserAgent["bIsSafari"](4)
		? 0
		: this["iMaxLength"]);
	/** @type {boolean} */
	var bArrowLeft = UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["ARROW_LEFT"]);
	/** @type {boolean} */
	var bArrowRight = UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["ARROW_RIGHT"]);
	/** @type {boolean} */
	var bBehindLast = UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()
		? (bArrowRight && iCursorPos === this["iMaxLength"])
		: (bArrowRight && iCursorPos === 0);
	/** @type {boolean} */
	var bBackspace = UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["BACKSPACE"]);

	if (
		this["iMaxLength"] > 0 &&
		bCursorAtMaxLength &&
		this["oControl"]["sGetCurrentValue"]()["length"] === this["iMaxLength"] &&
		(bBackspace || iCursorPos !== this["iMaxLength"]) &&
		!bBehindLast
	) {
		this["autoTabForward"](UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()
			? bArrowLeft
			: bArrowRight);
	} else if (
		bCursorAtStart &&
		(((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())
			? bArrowRight
			: bArrowLeft) || bBackspace)
	) {
		this["autoTabBackward"](!bBackspace && !bArrowLeft && !bArrowRight);
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["onAutoTabRtl"] = 0; };

/**
 * @private
 * @param {boolean} bSelect `true` to try to select the next control
 */
UCF_Fields_AutoTabDelegate["prototype"]["autoTabForward"] = function(bSelect) {;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["autoTabForward"]++; }; 
	/** @type {HTMLElement} */
	var oNextRef = UCF_DomUtil["oGetNextSibling"](this["oControl"]["oDomRef"], true);
	/** @type {UCF_Control} */
	var oNextControl;

	if (oNextRef) {
		oNextRef = UCF_DomUtil["oGetTabbableElementForward"](oNextRef, true);
	}

	if (oNextRef) {
		oNextControl = this["oLS"]["oGetControlByDomRef"](oNextRef);

		if (oNextControl && (this["sTabBehaviour"] === 'AUTOINTER' || (
				this["sTabBehaviour"] === 'AUTOINTRA' &&
				UCF_JsUtil["bIsFunction"](oNextControl["sGetTabBehaviour"]) &&
				oNextControl["sGetTabBehaviour"]() !== 'STANDARD'
			)
		)) {
			if (bSelect && UCF_JsUtil["bIsFunction"](oNextControl["select"])) {
				oNextControl["select"]();
			} else if (UCF_JsUtil["bIsFunction"](oNextControl["setCursorPosition"])) {
				oNextControl["setCursorPosition"](0);
			} else {
				oNextControl["focus"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["autoTabForward"] = 0; };

/**
 * @private
 * @param {boolean} bSelect
 */
UCF_Fields_AutoTabDelegate["prototype"]["autoTabBackward"] = function(bSelect) {;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["autoTabBackward"]++; }; 
	/** @type {HTMLElement} */
	var oPrevRef = UCF_DomUtil["oGetPreviousSibling"](this["oControl"]["oDomRef"], true);
	/** @type {UCF_Control} */
	var oPrevControl;

	if (oPrevRef) {
		oPrevRef = UCF_DomUtil["oGetTabbableElementBackward"](oPrevRef, true);
	}

	if (oPrevRef) {
		oPrevControl = this["oLS"]["oGetControlByDomRef"](oPrevRef);

		if (
			oPrevControl &&
			UCF_JsUtil["bIsFunction"](oPrevControl["sGetTabBehaviour"]) &&
			oPrevControl["sGetTabBehaviour"]() !== 'STANDARD' &&
			UCF_JsUtil["bIsFunction"](oPrevControl["sGetCurrentValue"]) &&
			UCF_JsUtil["bIsFunction"](oPrevControl["iGetMaxLength"]) &&
			oPrevControl["sGetCurrentValue"]()["length"] === oPrevControl["iGetMaxLength"]()
		) {
			if (bSelect && UCF_JsUtil["bIsFunction"](oPrevControl["select"])) {
				oPrevControl["select"]();
			} else if (UCF_JsUtil["bIsFunction"](oPrevControl["setCursorPosition"])) {
				oPrevControl["setCursorPosition"](oPrevControl["iGetMaxLength"]());
			} else {
				oPrevControl["focus"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["autoTabBackward"] = 0; };

/**
 * @private
 * @static
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_Fields_AutoTabDelegate["bIsValidAutoTab"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["bIsValidAutoTab"]++; }; 
	var iKeyCode = oBrowserEvent["iKeyCode"]();

	return !oBrowserEvent["bAlt"]() &&
		!oBrowserEvent["bCtrl"]() && (
			(iKeyCode >= UCF_KeyCodes["_0"] && iKeyCode <= UCF_KeyCodes["_9"]) ||
			iKeyCode === 59 || // eslint-disable-line no-magic-numbers
			iKeyCode === 61 || // eslint-disable-line no-magic-numbers
			(iKeyCode >= UCF_KeyCodes["A"] && iKeyCode <= UCF_KeyCodes["Z"]) ||
			(iKeyCode >= UCF_KeyCodes["NUMPAD_0"] && iKeyCode <= UCF_KeyCodes["NUMPAD_PLUS"]) ||
			(iKeyCode >= UCF_KeyCodes["NUMPAD_MINUS"] && iKeyCode <= UCF_KeyCodes["NUMPAD_SLASH"]) ||
			(iKeyCode >= UCF_KeyCodes["PLUS"] && iKeyCode <= UCF_KeyCodes["SEMICOLON"]) ||
			(iKeyCode >= UCF_KeyCodes["MINUS"] && iKeyCode <= UCF_KeyCodes["SINGLE_QUOTE"]) ||
			iKeyCode === UCF_KeyCodes["BACKSLASH"]
		);
};;if (__UCF_COVERAGE__) { UCF_Fields_AutoTabDelegate["_"]["bIsValidAutoTab"] = 0; };

};
sap["ls"]["preload"]["UCF_Fields_FakeFieldDelegate"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>

/**
 * @class UCF_Fields_FakeFieldDelegate
 * @extends UCF_Object
 * @param {UCF_EditFieldBase} oControl the field
 */
function UCF_Fields_FakeFieldDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_Fields_FakeFieldDelegate["_"]["UCF_Fields_FakeFieldDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		this["oControl"] = oControl;
		this["oLS"] = this["oControl"]["oLS"];
		this["sRenderer"] = UCF_JsUtil["bInstanceOf"](this["oControl"], 'UCF_InputField')
			? 'InputField'
			: 'ComboBox';
	}
};window["UCF_Fields_FakeFieldDelegate"] = UCF_Fields_FakeFieldDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Fields_FakeFieldDelegate"); UCF_Fields_FakeFieldDelegate["_"] = {UCF_Fields_FakeFieldDelegate: 0}; }; ;
UCF_Fields_FakeFieldDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Fields_FakeFieldDelegate.prototype["sClassName"] = "UCF_Fields_FakeFieldDelegate";

/**
 * @private
 */
UCF_Fields_FakeFieldDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_FakeFieldDelegate["_"]["destroy"]++; }; 
	this["oControl"] = null;
	this["oLS"] = null;
	this["sRenderer"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Fields_FakeFieldDelegate["_"]["destroy"] = 0; };

/**
 * checkes if a fake input field should be rendered
 *
 * @private
 * @return {boolean}
 */
UCF_Fields_FakeFieldDelegate["prototype"]["bShouldRenderFakeInputField"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_FakeFieldDelegate["_"]["bShouldRenderFakeInputField"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'InputFieldShouldRenderFakeField',
		'InputField', {
			"UsedInSapTable": this["oControl"]["bUsedInSapTable"],
			"ContainerWidthSet": this["oControl"]["bContainerWidthSet"],
			"PasswordField": this["oControl"]["bPasswordField"],
			"Height": this["oControl"]["sHeight"]
		}
	);
};;if (__UCF_COVERAGE__) { UCF_Fields_FakeFieldDelegate["_"]["bShouldRenderFakeInputField"] = 0; };

};
sap["ls"]["preload"]["UCF_Fields_FirefoxSelectDelegate"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>

/**
 * @constructor UCF_Fields_FirefoxSelectDelegate
 * @extends UCF_Object
 * @param {UCF_EditFieldBase} oControl the field
 */
function UCF_Fields_FirefoxSelectDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_Fields_FirefoxSelectDelegate["_"]["UCF_Fields_FirefoxSelectDelegate"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow;

	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		this["oControl"] = oControl;

		oBrowserWindow = this["oControl"]["oLS"]["oBrowserWindow"];
		oBrowserWindow["attachEvent"](
			oBrowserWindow["E_EVENTS"]["AnyEvent"],
			this,
			'onAnyEvent'
		);
	}
};window["UCF_Fields_FirefoxSelectDelegate"] = UCF_Fields_FirefoxSelectDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Fields_FirefoxSelectDelegate"); UCF_Fields_FirefoxSelectDelegate["_"] = {UCF_Fields_FirefoxSelectDelegate: 0}; }; ;
UCF_Fields_FirefoxSelectDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Fields_FirefoxSelectDelegate.prototype["sClassName"] = "UCF_Fields_FirefoxSelectDelegate";

/** @override */
UCF_Fields_FirefoxSelectDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_FirefoxSelectDelegate["_"]["destroy"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow = this["oControl"]["oLS"]["oBrowserWindow"];

	oBrowserWindow["detachEvent"](
		oBrowserWindow["E_EVENTS"]["AnyEvent"],
		this,
		'onAnyEvent'
	);

	this["oControl"] = null;
	this["bTabInProgress"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Fields_FirefoxSelectDelegate["_"]["destroy"] = 0; };

/**
 * @private
 * @param {UCF_Event} oAnyEvent
 */
UCF_Fields_FirefoxSelectDelegate["prototype"]["onAnyEvent"] = function(oAnyEvent) {;if (__UCF_COVERAGE__) { UCF_Fields_FirefoxSelectDelegate["_"]["onAnyEvent"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oAnyEvent["oGetParam"]('oBrowserEvent');

	switch (oBrowserEvent["sGetName"]()) {
		case 'keydown':
			this["bTabInProgress"] = UCF_KeyboardHelper["bIsEventForKey"](
				oBrowserEvent,
				UCF_KeyCodes["TAB"]
			) || UCF_KeyboardHelper["bIsEventForKey"](
				oBrowserEvent,
				UCF_KeyCodes["TAB"],
				'S'
			);
			break;
		case 'keyup':
			this["bTabInProgress"] = false;
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_FirefoxSelectDelegate["_"]["onAnyEvent"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oSelect the select
 */
UCF_Fields_FirefoxSelectDelegate["prototype"]["onselect"] = function(oSelect) {;if (__UCF_COVERAGE__) { UCF_Fields_FirefoxSelectDelegate["_"]["onselect"]++; }; 
	if (
		this["bTabInProgress"] &&
		this["oControl"]["bHasVisibleFocus"]() &&
		typeof this["oControl"]["oDomRef"]["selectionStart"] === 'number' &&
		typeof this["oControl"]["oDomRef"]["selectionEnd"] === 'number' &&
		this["oControl"]["oDomRef"]["selectionStart"] === this["oControl"]["oDomRef"]["selectionEnd"] &&
		this["oControl"]["oDomRef"]["value"]
	) {
		this["oControl"]["select"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_FirefoxSelectDelegate["_"]["onselect"] = 0; };

};
sap["ls"]["preload"]["UCF_Fields_HideFakeFieldDelegate"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_RenderManager */
/// <reference path="../../core/RenderManager.js"/>
/* global UCF_Fields_FakeFieldDelegate */
/// <reference path="./Fields_FakeFieldDelegate.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_EditFieldBase */
/// <reference path="../base/EditFieldBase.js"/>

/**
 * @class UCF_Fields_HideFakeFieldDelegate
 * @extends UCF_Object
 * @param {UCF_EditFieldBase} oControl the field
 */
function UCF_Fields_HideFakeFieldDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["UCF_Fields_HideFakeFieldDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Fields_FakeFieldDelegate["apply"](this, [oControl]);

		/** @type {boolean} bMouseInteraction flag avoids hiding fake field delayed */
		this["bMouseInteraction"] = false;
		/** @type {number} */
		this["iStartForcedReflowAF"] = null;
		/** @type {number} */
		this["iEndForcedReflowAF"] = null;
		/** @type {string} */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sFragment"] = 'render' + this["sRenderer"] + 'FieldFragment';
	}
};window["UCF_Fields_HideFakeFieldDelegate"] = UCF_Fields_HideFakeFieldDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Fields_HideFakeFieldDelegate"); UCF_Fields_HideFakeFieldDelegate["_"] = {UCF_Fields_HideFakeFieldDelegate: 0}; }; ;
UCF_Fields_HideFakeFieldDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Fields_FakeFieldDelegate"))(); UCF_Fields_HideFakeFieldDelegate.prototype["sClassName"] = "UCF_Fields_HideFakeFieldDelegate";

/**
 * @private
 */
UCF_Fields_HideFakeFieldDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["destroy"]++; }; 
	if (this["iStartForcedReflowAF"]) {
		UCF_JsUtil["cancelAnimationFrame"](this["iStartForcedReflowAF"]);
		this["iStartForcedReflowAF"] = null;
	}
	if (this["iEndForcedReflowAF"]) {
		UCF_JsUtil["cancelAnimationFrame"](this["iEndForcedReflowAF"]);
		this["iEndForcedReflowAF"] = null;
	}
	this["sFragment"] = null;
	UCF_Fields_FakeFieldDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["destroy"] = 0; };

/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_Fields_HideFakeFieldDelegate["prototype"]["onfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["onfocus"]++; }; 
	// we used to hide the fake field in onlsfocus but it turned out with
	// CSN 1980370864 that the default button logic might not work
	// so we now hide the field earlier in onfocus / onfocusin
	if (!this["bMouseInteraction"] && !UCF_BrowserEvent["bTouchInteraction"]) {
		// hide fake field - keyboard case
		this["hideFakeField"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["onfocus"] = 0; };

/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_Fields_HideFakeFieldDelegate["prototype"]["onfocusin"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["onfocusin"]++; }; 
	if (!this["bMouseInteraction"] && !UCF_BrowserEvent["bTouchInteraction"]) {
		// hide fake field - keyboard case
		this["hideFakeField"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["onfocusin"] = 0; };

/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the onmousedown
 */
UCF_Fields_HideFakeFieldDelegate["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["onmousedown"]++; }; 
	this["bMouseInteraction"] = true;
};;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["onmousedown"] = 0; };

/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the onclick
 */
UCF_Fields_HideFakeFieldDelegate["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["onclick"]++; }; 
	this["hideFakeField"]();
	this["bMouseInteraction"] = false;
};;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["onclick"] = 0; };

/**
 * @private
 */
UCF_Fields_HideFakeFieldDelegate["prototype"]["hideFakeField"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["hideFakeField"]++; }; 
	/** @type {UCF_RenderManager} */
	var oRenderManager;
	/** @type {HTMLSpanElement} */
	var oOldDomRef = this["oControl"]["oDomRef"];
	/** @type {HTMLInputElement} */
	var oNewDomRef;
	/** @type {boolean} */
	var bIsOldDomRefFocused;

	if (this["bShouldRenderFakeInputField"]() && oOldDomRef["tagName"] === 'SPAN') {
		bIsOldDomRefFocused = oOldDomRef === UCF_DomUtil["oGetActiveElement"]();

		oRenderManager = this["oLS"]["oGetRenderManager"]();
		this["renderOriginalField"](oRenderManager);
		oNewDomRef = oRenderManager["oGetElementFromHtml"]();
		this["oControl"]["updateReferences"](oNewDomRef);

		UCF_DomUtil["replaceElement"](oOldDomRef, oNewDomRef);

		this["oControl"]["bFakeFieldExchangeInProcess"] = true;
		oRenderManager["clearBuffer"]();

		// create a datatip for the control, if it exists
		this["oControl"]["initializeDataTip"]();

		if (UCF_UserAgent["bIsSafari"]()) {
			this["oControl"]["attachEvent"](this["oControl"]["E_EVENTS"]["DidUpdateStyles"], this, 'onDidUpdateStyles');
		}

		if (bIsOldDomRefFocused) {
			UCF_DomUtil["focusDomElement"](oNewDomRef);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["hideFakeField"] = 0; };

/**
 * 02/2019: Safari needs a forced reflow to align <input> with width:100% in
 * table-mode fields properly
 *
 * @private
 */
UCF_Fields_HideFakeFieldDelegate["prototype"]["onDidUpdateStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["onDidUpdateStyles"]++; }; 
	/** @type {UCF_Fields_HideFakeFieldDelegate} */
	var self = this;

	this["iStartForcedReflowAF"] = UCF_JsUtil["requestAnimationFrame"](function() {
		UCF_DomUtil["setStyle"](self["oControl"]["oRootRef"], { "display": 'inline' });

		self["iEndForcedReflowAF"] = UCF_JsUtil["requestAnimationFrame"](function() {
			UCF_DomUtil["setStyle"](self["oControl"]["oRootRef"], { "display": '' });
		});
	});

	this["oControl"]["detachEvent"](this["oControl"]["E_EVENTS"]["DidUpdateStyles"], this);
};;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["onDidUpdateStyles"] = 0; };

/**
 * Render original field after rending fake field
 *
 * @param {Object} oRenderManager the render manager
 * @private
 */
UCF_Fields_HideFakeFieldDelegate["prototype"]["renderOriginalField"] = function(oRenderManager) {;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["renderOriginalField"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oRenderManager instanceof UCF_RenderManager, "oRenderManager instanceof UCF_RenderManager", "Fields_HideFakeFieldDelegate.js(170): renderOriginalField"); };

	oRenderManager["getRenderer"](this["sRenderer"])[this["sFragment"]](
		this["oControl"]["oGetClientAccessObject"](),
		oRenderManager
	);
};;if (__UCF_COVERAGE__) { UCF_Fields_HideFakeFieldDelegate["_"]["renderOriginalField"] = 0; };

};
sap["ls"]["preload"]["UCF_Fields_OverlayDelegate"] = function() {/* global _trace, INFO, DEBUG */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_EditFieldBase */
/// <reference path="../base/EditFieldBase.js"/>
/* global UCF_RenderManager */
/// <reference path="../../core/RenderManager.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_SapTable */
/// <reference path="../../controls/SapTable.js"/>

/**
 * @constructor UCF_Fields_OverlayDelegate
 * @extends UCF_Object
 * @param {UCF_EditFieldBase} oControl the field
 */
function UCF_Fields_OverlayDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["UCF_Fields_OverlayDelegate"]++; }; 
	if (arguments["length"] > 0) {
		/** @type {UCF_Listbox_Popup} */
		this["oControl"] = oControl;
		/** @type {UCF_LS} */
		this["oLS"] = this["oControl"]["oLS"];
	}
};window["UCF_Fields_OverlayDelegate"] = UCF_Fields_OverlayDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Fields_OverlayDelegate"); UCF_Fields_OverlayDelegate["_"] = {UCF_Fields_OverlayDelegate: 0}; }; ;
UCF_Fields_OverlayDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Fields_OverlayDelegate.prototype["sClassName"] = "UCF_Fields_OverlayDelegate";

/**
 * @private
 * @static
 **/
UCF_Fields_OverlayDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["destroy"]++; }; 
	this["oLS"] = null;
	this["oControl"] = null;
	this["oPlaceHolder"] = null;
	this["oHeaderContainer"] = null;
	this["bFieldHelpEmbedding"] = null; // eslint-disable-line @ur/no-missing-setClientProperty
	this["bUsedInSapTable"] = null; // eslint-disable-line @ur/no-missing-setClientProperty
	this["bInputPromptChanged"] = null;
	this["bShowHelpButtonAlways"] = null; // eslint-disable-line @ur/no-missing-setClientProperty
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["destroy"] = 0; };

/**
 * @private
 * @static
 * @param {HTMLElement} oDomRef the html element representing the control
 * Adds the placeholder
 */
UCF_Fields_OverlayDelegate["prototype"]["addPlaceHolder"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["addPlaceHolder"]++; }; 
	/** @type {HTMLDivElement} */
	var oAssoAreaRef = this["oLS"]["oGetAssociatedAreaRef"]();

	/** @type {HTMLDivElement} */
	this["oPlaceHolder"] = document["createElement"]('div');
	this["oPlaceHolder"]["id"] = this["oControl"]["sId"] + '-ph';
	this["oPlaceHolder"]["style"]["visibility"] = 'hidden';
	this["oPlaceHolder"]["className"] = oDomRef["className"];
	this["oPlaceHolder"]["tabIndex"] = '-1';

	if (oAssoAreaRef !== this["oControl"]["oRootRef"]["parentNode"]) {
		this["oControl"]["oRootRef"]["parentNode"]["insertBefore"](
			this["oPlaceHolder"],
			this["oRootRef"]
		);
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Added placeholder ' + this["oControl"]["sId"] + '-ph', "Fields_OverlayDelegate.js(72): addPlaceHolder"); };
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["addPlaceHolder"] = 0; };

/**
 * @private
 * @static
 * @param {HTMLElement} oDomRef the html element representing the control
 * Adds the container in which the field will be placed
 */
UCF_Fields_OverlayDelegate["prototype"]["addContainer"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["addContainer"]++; }; 
	/** @type {HTMLDivElement} */
	var oAssoAreaRef = this["oLS"]["oGetAssociatedAreaRef"]();

	this["oHeaderContainer"] = document["createElement"]('header');
	this["oHeaderContainer"]["id"] = oDomRef["id"] + '-header';
	this["oHeaderContainer"]["className"] = 'lsField__overlayheader';

	oAssoAreaRef["appendChild"](this["oHeaderContainer"]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Added container ' + oDomRef["id"] + '-header', "Fields_OverlayDelegate.js(90): addContainer"); };

	if (this["oControl"] && this["oControl"]["oFieldHelp"]) {
		this["oControl"]["oFieldHelp"]["setOpenerRef"](this["oHeaderContainer"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["addContainer"] = 0; };

/**
 * @private
 * @static
 * @param {HTMLElement} oDomRef the html element representing the control
 * Removes the container from the DOM
 */
UCF_Fields_OverlayDelegate["prototype"]["removeContainer"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["removeContainer"]++; }; 
	/** @type {HTMLHeaderElement} */
	var oContainer = document["getElementById"](oDomRef["id"] + '-header');

	UCF_DomUtil["removeFromDom"](oContainer);
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["removeContainer"] = 0; };

/**
 * @private
 * @static
 * @param {HTMLElement} oDomRef the html element representing the control
 * Adds the cancel button to the container in which the field will be placed
 */
UCF_Fields_OverlayDelegate["prototype"]["addContainerButton"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["addContainerButton"]++; }; 
	/** @type {HTMLHeaderElement} */
	var oContainer = this["oHeaderContainer"];
	/** @type {Button} */
	var oClose = this["oLS"]["oCreateClientControl"]({
		"Button": {
			"Text": '',
			"HasIcon": true,
			"UpIconSrc": 'sap-icon://decline',
			"DownIconSrc": 'sap-icon://decline',
			"Id": this["oControl"]["sId"] + '-close',
			"Design": 'TRANSPARENT'
		}
	});
	/** @type {UCF_Fields_OverlayDelegate} */
	var self = this;

	oClose["attachPress"](function() {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'close', "Fields_OverlayDelegate.js(134): addContainerButton"); };
		if (self["oControl"] && self["oControl"]["oFieldHelp"]) {
			self["oControl"]["oFieldHelp"]["close"]();
		}
	});

	oClose["placeAt"](oContainer);
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["addContainerButton"] = 0; };

/**
 * @private
 * @param {UCF_Control} oControl
 * @return {UCF_SapTable}
 */
UCF_Fields_OverlayDelegate["prototype"]["oGetParentSapTable"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["oGetParentSapTable"]++; }; 
	return oControl instanceof UCF_SapTable
		? oControl
		: oControl["oGetParent"]()
		? this["oControl"]["oGetParent"]()
		: null;
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["oGetParentSapTable"] = 0; };

/**
 * @private
 */
UCF_Fields_OverlayDelegate["prototype"]["addInputPrompt"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["addInputPrompt"]++; }; 
	/** @type {string} */
	var sLabelText;
	/** @type {Control} */
	var oLabelledByControl;
	/** @type {UCF_SapTable} */
	var oSapTable;
	/** @type {Array} */
	var oSapTableInfo;
	/** @type {Array} */
	var aColumnCellInfos;

	/** @type {boolean} */
	this["bInputPromptChanged"] = false;

	if (this["oControl"]["sLabelledBy"]) {
		oLabelledByControl = this["oLS"]["oControlFactory"]["oGetControlById"](this["oControl"]["sLabelledBy"]);
		sLabelText = oLabelledByControl["sText"] || oLabelledByControl["sLabelText"];
	} else if (this["bUsedInSapTable"]) {
		oSapTable = this["oGetParentSapTable"](this["oControl"]);
		if (oSapTable) {
			oSapTableInfo = this["oControl"]["oInSapTable"]();
			if (oSapTableInfo) {
				aColumnCellInfos = oSapTable["aGetCellInfosOfColumn"](oSapTableInfo["iColIndex"]);
				sLabelText = UCF_JsUtil["map"](UCF_JsUtil["filter"](aColumnCellInfos, function(oCellInfo) {
					return oCellInfo["eCellType"] === oSapTable["SUBCONTROL"]["HEADER_CELL"];
				}), function(oCellInfo) {
					return UCF_DomUtil["sGetInnerText"](oCellInfo["oDomRefCell"]);
				})["join"](' ');
			}
		}
	}
	if (sLabelText) {
		this["oControl"]["oDomRef"]["setAttribute"]('placeholder', sLabelText);
		this["bInputPromptChanged"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["addInputPrompt"] = 0; };

/**
 * Will open the listbox in overlay mode on phones
 * The field will be moved into the asso area on open
 *
 * @private
 */
UCF_Fields_OverlayDelegate["prototype"]["undock"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["undock"]++; }; 
	/** @type {HTMLDivElement} */
	var oContainer;
	/** @type {HTMLDivElement} */
	var oPlaceHolder = document["getElementById"](this["oControl"]["sId"] + '-ph');
	// /** @type {HTMLDivElement} */
	var oScrollRef = UCF_DomUtil["$"](this["oControl"]["sItemListBoxId"] + '-scrl');
	/** @type {UCF_Fields_OverlayDelegate} */
	var self;

	if (oPlaceHolder) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'PlaceHolder already exists', "Fields_OverlayDelegate.js(214): undock"); };
	} else {
		self = this;

		this["addPlaceHolder"](this["oControl"]["oRootRef"]);
		this["addContainer"](this["oControl"]["oRootRef"]);

		// render all field styles, also if original field is bUsedInSapTable
		this["bUsedInSapTable"] = this["oControl"]["bUsedInSapTable"];
		this["oControl"]["bUsedInSapTable"] = false;
		// eslint-disable-next-line quotes
		this["oControl"]["setClientProperty"]("bUsedInSapTable", this["oControl"]["bUsedInSapTable"], false);

		// eslint-disable-next-line @ur/no-missing-setClientProperty
		this["bFieldHelpEmbedding"] = this["oControl"]["bFieldHelpEmbedding"];
		this["oControl"]["bFieldHelpEmbedding"] = true;
		// eslint-disable-next-line quotes
		this["oControl"]["setClientProperty"]("bFieldHelpEmbedding", this["oControl"]["bFieldHelpEmbedding"], true);

		// eslint-disable-next-line @ur/no-missing-setClientProperty
		this["bShowHelpButtonAlways"] = this["oControl"]["bShowHelpButtonAlways"];
		this["oControl"]["bShowHelpButtonAlways"] = true;
		// eslint-disable-next-line quotes
		this["oControl"]["setClientProperty"]("bShowHelpButtonAlways", this["oControl"]["bShowHelpButtonAlways"], true);
		oContainer = this["oHeaderContainer"];
		oContainer["appendChild"](this["oControl"]["oRootRef"]);
		this["addContainerButton"](this["oControl"]["oRootRef"]);

		// if there's no placeholder or value set, we use the label as placeholder
		if (!this["oControl"]["sInputPrompt"]) {
			this["addInputPrompt"]();
		}

		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'undock: moved ' + this["oControl"]["oRootRef"]["id"] + ' to asso area', "Fields_OverlayDelegate.js(247): undock"); };

		// do not connect to dom bc it will read lsdata and reset bUsedInSapTable etc.
		// this.oControl.updateStylesSync();
		// this.oControl.connectToDom(UCF_DomUtil.$(this.oControl.sId));

		if (UCF_UserAgent["bIsIOS"] && (UCF_UserAgent["bIsTablet"]() || UCF_UserAgent["bIsPhone"]())) {
			// do not focus on iPad or iPhone to avoid soft keyboard from coming up
		} else {
			this["oControl"]["oDomRef"]["focus"]();
		}

		// avoid overscroll in undocked overlay
		UCF_DomUtil["setStyle"](document["body"], {
			"position": 'fixed',
			"overflow": 'hidden',
			"minWidth": '100%'
		});
		UCF_DomUtil["setStyle"](oScrollRef, {
			"height": '100%',
			"overflow": 'scroll',
			'-webkit-overflow-scrolling': 'touch'
		});

		UCF_JsUtil["forEach"](UCF_JsUtil["arrayFrom"](UCF_DomUtil["querySelectorAll"]('input[tabindex="0"]')), function(oInput) {
			if (oInput !== self["oControl"]["oDomref"]) {
				oInput["setAttribute"]('data-tabindex', 0);
				oInput["setAttribute"]('tabindex', -1);
			}
		});

		this["oControl"]["attachEvent"](this["oControl"]["E_EVENTS"]["WillSubmitPendingRequest"], this, 'onWillSubmitPendingRequest');
		// ITS does not use our event queue, therefore we don't get a PendingRequest
		// => at least register to the BeforeHotkey to close then
		this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["BeforeHotkey"], this, 'dock');
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["undock"] = 0; };

/**
 * @private
 * @param {UCF_Event} oEvent
 */
UCF_Fields_OverlayDelegate["prototype"]["onWillSubmitPendingRequest"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["onWillSubmitPendingRequest"]++; }; 
	/** @type {UCF_PendingRequest} */
	var oPendingRequest = oEvent["oGetParam"]('oPendingRequest');

	if (!this["bIsOnlyOwnListAccess"](oPendingRequest)) {
		oPendingRequest["suspend"](this["oControl"]["sId"] + '-overlay');
		this["dock"]();
		oPendingRequest["resume"](this["oControl"]["sId"] + '-overlay');
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["onWillSubmitPendingRequest"] = 0; };

/**
 * @private
 * @param {UCF_PendingRequest} oPendingRequest
 * @return {boolean}
 */
UCF_Fields_OverlayDelegate["prototype"]["bIsOnlyOwnListAccess"] = function(oPendingRequest) {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["bIsOnlyOwnListAccess"]++; }; 
	return oPendingRequest
		&& oPendingRequest["oQueue"]
		&& oPendingRequest["oQueue"]["aQueue"]
		&& oPendingRequest["oQueue"]["aQueue"]["length"] === 1
		&& oPendingRequest["oQueue"]["aQueue"][0]["sEventName"] === 'ListAccess'
		&& (oPendingRequest["oQueue"]["aQueue"][0]["sControlId"] === this["oControl"]["sId"] ||
			// tokenizer
			oPendingRequest["oQueue"]["aQueue"][0]["sControlId"] + '-input' === this["oControl"]["sId"]
		);
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["bIsOnlyOwnListAccess"] = 0; };

/**
 * Will close phone overlay
 * The field will be removed from the asso area on fieldhelpclose
 * The placeholder will be replaced
 *
 * @private
 */
UCF_Fields_OverlayDelegate["prototype"]["dock"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["dock"]++; }; 
	/** @type {HTMLDivElement} */
	var oScrollRef;

	if (!this["oControl"] || this["oControl"]["bIsDestroyed"]) {
		return;
	}

	oScrollRef = UCF_DomUtil["$"](this["oControl"]["sItemListBoxId"] + '-scrl');

	this["oControl"]["detachEvent"](this["oControl"]["E_EVENTS"]["WillSubmitPendingRequest"], this);
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["BeforeHotkey"], this);

	if (this["oPlaceHolder"] instanceof HTMLElement) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'dock: move ' + this["oControl"]["oRootRef"]["id"] + ' back to where placeholder was', "Fields_OverlayDelegate.js(338): dock"); };

		this["oPlaceHolder"]["parentNode"]["replaceChild"](this["oControl"]["oRootRef"], this["oPlaceHolder"]);
		this["removeContainer"](this["oControl"]["oRootRef"]);

		// remove overflow prevention from body
		UCF_DomUtil["setStyle"](document["body"], { "position": '', "overflow": '' });
		UCF_DomUtil["setStyle"](oScrollRef, { "height": '', "width": '' });

		if (this["bUsedInSapTable"]) {
			UCF_DomUtil["addClass"](this["oControl"]["oRootRef"], 'lsField--table');
			this["oControl"]["bUsedInSapTable"] = true;
			// eslint-disable-next-line quotes
			this["oControl"]["setClientProperty"]("bUsedInSapTable", this["oControl"]["bUsedInSapTable"], true);
		}
		if (this["bFieldHelpEmbedding"]) {
			this["oControl"]["bFieldHelpEmbedding"] = false;
			// eslint-disable-next-line quotes
			this["oControl"]["setClientProperty"]("bFieldHelpEmbedding", this["oControl"]["bFieldHelpEmbedding"], false);
		}
		if (this["bInputPromptChanged"]) {
			this["oControl"]["oDomRef"]["removeAttribute"]('placeholder');
			this["bInputPromptChanged"] = false;
		}

		this["oControl"]["reconnectToDom"]();
		this["oPlaceHolder"] = null;

		UCF_JsUtil["forEach"](UCF_JsUtil["arrayFrom"](UCF_DomUtil["querySelectorAll"]('input[data-tabindex="0"]')), function(oInput) {
			oInput["removeAttribute"]('data-tabindex');
			oInput["setAttribute"]('tabindex', 0);
		});

		// this.oControl.oDomRef.focus(); might lose focus after closing overlay
		// via click on x button right to the field in overlay mode
		// to avoid losing the focus we move the focus delayed
		// UCF_DomUtil.moveFocusDomElement(this.oControl.oDomRef, false);
		this["oControl"]["updateStyles"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["dock"] = 0; };

/** @protected */
UCF_Fields_OverlayDelegate["prototype"]["onWillOpenFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["onWillOpenFieldHelp"]++; }; 
	/** @type {HTMLDivElement} */
	var oContainer;

	this["oControl"]["setInteractionState"]({
		"Overlay": true
	});

	this["undock"]();
	oContainer = this["oHeaderContainer"];
	if (oContainer) {
		UCF_DomUtil["addClass"](oContainer, 'lsField__overlayheader--open');
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["onWillOpenFieldHelp"] = 0; };

/** @protected */
UCF_Fields_OverlayDelegate["prototype"]["onWillFireListAccess"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["onWillFireListAccess"]++; }; 
	/** @type {HTMLDivElement} */
	var oContainer;

	// .lsField__overlayheader will display a white box-shadow
	// which is overwritten in .lsField__overlayheader--open
	// remove .lsField__overlayheader--open to show box-shadow
	// and avoid flickering during round trip while list is refreshed
	oContainer = this["oHeaderContainer"];
	if (oContainer) {
		UCF_DomUtil["removeClass"](oContainer, 'lsField__overlayheader--open');
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["onWillFireListAccess"] = 0; };

/** @protected */
UCF_Fields_OverlayDelegate["prototype"]["onDidCloseFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["onDidCloseFieldHelp"]++; }; 
	// call dock delayed as it may occur that during the replace
	// a javascript error will come up
	UCF_JsUtil["delayedCall"](0, this, 'dock');

	this["oControl"]["setInteractionState"]({
		"Overlay": false
	});
	if (this["oControl"] && this["oControl"]["oFieldHelp"]) {
		this["oControl"]["oFieldHelp"]["oOpenerRef"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["onDidCloseFieldHelp"] = 0; };

/** @protected */
UCF_Fields_OverlayDelegate["prototype"]["onWillDestroyField"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["onWillDestroyField"]++; }; 
	this["dock"]();
	this["oControl"]["setInteractionState"]({
		"Overlay": false
	});
	if (this["oControl"] && this["oControl"]["oFieldHelp"]) {
		this["oControl"]["oFieldHelp"]["oOpenerRef"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["onWillDestroyField"] = 0; };

/** @protected
 * @return {HTMLHeaderElement}
 */
UCF_Fields_OverlayDelegate["prototype"]["oGetOpenRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["oGetOpenRef"]++; }; 

	return this["oHeaderContainer"];
};;if (__UCF_COVERAGE__) { UCF_Fields_OverlayDelegate["_"]["oGetOpenRef"] = 0; };

};
sap["ls"]["preload"]["UCF_FileUpload"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/**
 * 
 * @class UCF_FileUpload
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef the DOM element of the FileUpload
 * @param {UCF_LS} oLS the LightSpeed instance managing the FileUpload
 */
function UCF_FileUpload(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["UCF_FileUpload"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["attachBrowserEvent"]('change', oDomRef);
		this["attachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"], 'onPendingRequest');

		/** @type {HTMLInputElement|HTMLSpanElement} */
		this["oFocusDomRef"] = (!this["bEnabled"] || this["bReadonly"])
			? UCF_DomUtil["$"](this["sId"] + '-r')
			: this["oDomRef"];
		/** @type {boolean} */
		this["bAllowTextSelection"] = true;
		/** @type {boolean} */
		this["bIsFileSelected"] = false;
		/** @type {boolean} */
		this["bIsUploading"] = false;
		/** @type {boolean} */
		this["bIsUploadComplete"] = false;
		/** @type {UCF_PendingRequest} */
		this["oPendingRequest"] = null;
		/** @type {string} */
		this["sValue"] = '';
		/** @type {boolean} */
		this["bChanged"] = false;
		/**
		 * @type {number} iHistoryLengthBeforeUpload
		 * CSN 350267 2020: with backprevention disabled, an upload creates an
		 * unwanted history entry, with which the user has to press [BACK] an
		 * additional time to navigate back from the WDA application to the FLP.
		 *
		 * To mitigate that we store the history.length before the form submit
		 * and go back in history when the iframe load event fires until we're at
		 * the same state as before.
		 */
		this["iHistoryLengthBeforeUpload"] = null;
	}
};window["UCF_FileUpload"] = UCF_FileUpload; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FileUpload"); UCF_FileUpload["_"] = {UCF_FileUpload: 0}; }; ;
UCF_FileUpload["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_FileUpload.prototype["sClassName"] = "UCF_FileUpload";

/** @protected */
UCF_FileUpload["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["destroy"]++; }; 
	if (this["oDomRef"]) {
		this["detachBrowserEvent"]('change', this["oDomRef"]);
		this["oDomRef"] = null;
	}
	if (this["oIFrameRef"]) {
		this["detachBrowserEvent"]('load', this["oIFrameRef"]);
		this["oIFrameRef"] = null;
	}
	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);

	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	this["oPendingRequest"] = null;
	this["oFocusDomRef"] = null;
	this["bIsFileSelected"] = null;
	this["sValue"] = null;
	this["sStyles"] = null;
	this["iHistoryLengthBeforeUpload"] = null;
	this["aoSelectedFiles"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["destroy"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the change
 */
UCF_FileUpload["prototype"]["onchange"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onchange"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FileUpload.js(97): onchange"); };
	if (!this["bEnabled"] || this["bReadOnly"] || this["sValue"] === this["oDomRef"]["value"]) {
		if (this["sValue"] === '') {
			this["bIsFileSelected"] = false;
		}
		// let enter pass, it is required to open file in ARIA as per announcement
	} else {
		if (__UCF_IE6__)
			this["sValue"] = this["oDomRef"]["value"];
		else{
			this["aoSelectedFiles"] = oBrowserEvent["oDomEvent"]["target"]["files"];
			if (this["bMultiple"]) {
				this["sValue"] = '';
				var oFiles = new Array();
				for (var index = 0; index < this["aoSelectedFiles"]["length"]; index++)
					oFiles["push"]( this["aoSelectedFiles"][index]["name"] );
				this["sValue"] = UCF_JsUtil["sJsonStringify"](oFiles);
			} else
				this["sValue"] = this["oDomRef"]["value"];
		}
		this["bChanged"] = true;

		this["bIsFileSelected"] = this["sValue"] !== '';
		if (this["bIsFileSelected"]) {
			if (this["sUploadBehavior"] !== 'STANDARD') {
				this["prepareUploadFrame"]();
			}
			if (this["sUploadBehavior"] === 'IMMEDIATE') {
				this["upload"]();
			} else if (
				this["sUploadBehavior"] === 'STANDARD' &&
				!this["oPendingRequest"]
			) {
				this["fireChange"](this["sId"], this["sValue"]);
				this["bChanged"] = false;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onchange"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_FileUpload["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FileUpload.js(142): onclick"); };

	if (this["bEnabled"] && !this["bReadonly"]) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onclick"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsenter
 */
UCF_FileUpload["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FileUpload.js(154): onlsenter"); };

	this["onchange"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onlsenter"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the load event of the iframe
 */
UCF_FileUpload["prototype"]["onload"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onload"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FileUpload.js(164): onload"); };

	// Initial load needs to be ignored
	if (this["bIsUploading"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Upload complete.', "FileUpload.js(168): onload"); };

		this["detachBrowserEvent"]('load', this["oIFrameRef"]);

		if (history["length"] > this["iHistoryLengthBeforeUpload"]) {
			/* CSN 173094/2021: history.go() does not work properly on Safari (in
			 * either OS); this is a temporary fix that (of course) invalidates
			 * CM 394936 2020 on Safari */
			if (!UCF_UserAgent["bIsSafari"]())
				history["go"](this["iHistoryLengthBeforeUpload"] - history["length"]);
			this["iHistoryLengthBeforeUpload"] = null;
		}

		this["bIsUploading"] = false;
		// in some cases the control is not purged after roundtrip a
		// (CSN 0004617897 2012). This is a temporary fix as we must purge the
		// control to remove the file selection.
		this["bIsFileSelected"] = false;
		this["bIsUploadComplete"] = true;

		if (this["oPendingRequest"]) {
			this["oPendingRequest"]["resume"](this["sId"]);
			this["oPendingRequest"] = null;
		}

		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onload"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_FileUpload["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FileUpload.js(205): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() === this) {
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
		oAccessibilityHelper["setControlType"]('FU');

		oAccessibilityHelper["applyLabelingInfo"](this);
		oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

		oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
		if (this["oDomRef"]["value"] !== '') {
			oAccessibilityHelper["setText"](this["oDomRef"]["value"]);
		}

		oAccessibilityHelper["setEnabled"](this["bEnabled"]);
		oAccessibilityHelper["setReadonly"](this["bReadonly"]);
		oAccessibilityHelper["setRequired"](this["bRequired"]);

		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		oAccessibilityHelper["addEnabledTutor"](
			'FU_TUT',
			this["bEnabled"] && !this["bReadonly"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onlsaccessibility"] = 0; };

/**
 * Handles the PendingRequest event. If behavior is ONSUBMIT, trigger upload
 * and suspend pending request. If behavior is IMMEDIATE check whether upload
 * is still running and only suspend if necessary.
 *
 * @protected
 * @param {UCF_BrowserEvent} oEvent the event that occurred
 */
UCF_FileUpload["prototype"]["onPendingRequest"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onPendingRequest"]++; }; 
	/** @type {UCF_PendingRequest} */
	var oPendingRequest;

	if (this["bIsFileSelected"]) {
		oPendingRequest = oEvent["oGetParam"]('oPendingRequest');

		if (oPendingRequest["oGetQueue"]()["bAsync"]) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'No Upload Submit within delta requests...', "FileUpload.js(247): onPendingRequest"); };
		} else {
			this["oPendingRequest"] = oPendingRequest;
			this["oPendingRequest"]["suspend"](this["sId"]);

			if (this["bChanged"]) {
				// after changing to the suspended request, to put the event in the
				// pending request queue...
				this["fireChange"](this["sId"], this["sValue"]);
				this["bChanged"] = false;
			}
			// wait for upload to return
			if (this["sUploadBehavior"] === 'ONSUBMIT') {
				this["upload"]();
			} else if (this["sUploadBehavior"] === 'IMMEDIATE' && this["bIsUploading"]) {
				// nothing to do
			} else {
				this["oPendingRequest"]["resume"](this["sId"]);
				this["oPendingRequest"] = null;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onPendingRequest"] = 0; };

/** @private */
UCF_FileUpload["prototype"]["upload"] = function() {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["upload"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Upload started.', "FileUpload.js(273): upload"); };

	this["bIsUploading"] = true;
	this["bIsUploadComplete"] = false;

	try {
		this["iHistoryLengthBeforeUpload"] = history["length"];
		this["oRootRef"]["submit"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Upload submitted form...', "FileUpload.js(281): upload"); };
	} catch (e) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Could not submit file upload form.', "FileUpload.js(283): upload"); };
		this["bIsUploading"] = false;
		this["bIsUploadComplete"] = false;

		this["fireError"](this["sId"]);

		if (this["oPendingRequest"]) {
			this["oPendingRequest"]["resume"](this["sId"]);
			this["oPendingRequest"] = null;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["upload"] = 0; };

/** @private */
UCF_FileUpload["prototype"]["prepareUploadFrame"] = function() {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["prepareUploadFrame"]++; }; 
	/** @type {string} */
	var sIFrameId;
	/** @type {HTMLIframeElement} */
	var oIFrameRef;

	if (!this["oIFrameRef"]) {
		// in case of problems, verify to use lowercase letters
		sIFrameId = this["sId"] + '-frame';

		// IE11 workaround, seems to be fixed by MS, see CL210468 for details
		oIFrameRef = document["createElement"]('iframe');

		oIFrameRef["id"] = sIFrameId;
		// to force domain relaxing use UCF_ResourceUtil.sGetHtmlRoot() + "/blank.html"
		oIFrameRef["src"] = UCF_DomUtil["sGetIframeJSSource"]('<script nonce="' + window["UCF_System"]["sNonce"] + '">window.name = "' + sIFrameId + '"</script>');
		UCF_DomUtil["addClass"](oIFrameRef, 'lsControl--invisible');
		this["oRootRef"]["appendChild"](oIFrameRef);

		this["oIFrameRef"] = oIFrameRef;

		this["attachBrowserEvent"]('load', this["oIFrameRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["prepareUploadFrame"] = 0; };

/** @protected */
UCF_FileUpload["prototype"]["onlsfocus"] = function() {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onlsfocus"]++; }; 
	/** @type {string} */
	var sFocusStyle;

	if (this["bEnabled"] || window["UCF_System"]["bIs508"]) {
		sFocusStyle = 'lsEdFieldFocus';

		this["sStyles"] = this["oDomRef"]["className"];

		if (this["bReadonly"] || !this["bEnabled"]) {
			sFocusStyle += 'Dsbl';
		}
		if (this["sInputState"] === 'ERROR') {
			sFocusStyle += 'Inv';
		} else if (this["sInputState"] === 'WARNING') {
			sFocusStyle += 'Warn';
		}

		UCF_DomUtil["addClass"](this["oDomRef"], sFocusStyle);
		this["oDomRef"]["style"]["backgroundImage"] = 'none';

		UCF_DomUtil["addClass"](this["oRootRef"], 'lsFileupload--focus');
	}
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onlsfocus"] = 0; };

/** @protected */
UCF_FileUpload["prototype"]["onlsblur"] = function() {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onlsblur"]++; }; 
	if (this["sStyles"]) {
		this["oDomRef"]["className"] = this["sStyles"];
	}
	UCF_DomUtil["removeClass"](this["oRootRef"], 'lsFileupload--focus');
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onlsblur"] = 0; };

/**
 * Handles the keydown event. Since IE8 we cancel it.
 *
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the keydown
 */
UCF_FileUpload["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onkeydown"]++; }; 
	/** @type {number} */
	var iKeyCode;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FileUpload.js(366): onkeydown"); };

	iKeyCode = oBrowserEvent["iKeyCode"]();
	if (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["A"], 'C')) {
		this["oDomRef"]["select"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (
		UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["C"], 'C')
	) {
		oBrowserEvent["cancelBubble"]();
	} else if (
		iKeyCode === UCF_KeyCodes["DELETE"] ||
		iKeyCode === UCF_KeyCodes["BACKSPACE"]
	) {
		this["sValue"] = this["oDomRef"]["value"] = '';
	} else if (
		iKeyCode !== UCF_KeyCodes["TAB"] &&
		iKeyCode !== UCF_KeyCodes["F6"] &&
		iKeyCode !== UCF_KeyCodes["ARROW_LEFT"] &&
		iKeyCode !== UCF_KeyCodes["ARROW_RIGHT"] &&
		iKeyCode !== UCF_KeyCodes["HOME"] &&
		iKeyCode !== UCF_KeyCodes["END"] &&
		iKeyCode !== UCF_KeyCodes["SPACE"] &&
		// let enter pass, it is required to open file in ARIA as per announcement
		iKeyCode !== UCF_KeyCodes["ENTER"] &&
		// let accesskeys pass through
		!(UCF_KeyboardHelper["bShouldHandleAccessKey"](oBrowserEvent, iKeyCode)) &&
		!(UCF_KeyboardHelper["bShouldHandleAccessKeyBack"](oBrowserEvent, iKeyCode))
	) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onkeydown"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the paste
 */
UCF_FileUpload["prototype"]["onpaste"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onpaste"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FileUpload.js(406): onpaste"); };
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["onpaste"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the dblclick
 */
UCF_FileUpload["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FileUpload.js(416): ondblclick"); };
	this["oDomRef"]["click"]();
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["ondblclick"] = 0; };

UCF_FileUpload["prototype"]["openFileSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["openFileSelection"]++; }; 
	this["oDomRef"]["click"]();
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["openFileSelection"] = 0; };

UCF_FileUpload["prototype"]["aGetSelectedFiles"] = function() {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["aGetSelectedFiles"]++; }; 
	return this["aoSelectedFiles"];
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["aGetSelectedFiles"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_FileUpload["prototype"]["aAttributeNames"] = ["sInputState","sTooltip","bEnabled","bReadonly","sTextDesign","sVisibility","sAccessKey","sUploadBehavior","bRequired","sCustomData","bUsedInSapTable","sLabelledBy","bMultiple","bHidden","sAccept"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_FileUpload["prototype"]["aEventNames"] = ["Change","Error"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_FileUpload["prototype"]["aMethodNames"] = ["aGetSelectedFiles","openFileSelection","addFormField","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputState}
 */
UCF_FileUpload["prototype"]["sInputState"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_FileUpload["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_FileUpload["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_FileUpload["prototype"]["bReadonly"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputDesign}
 */
UCF_FileUpload["prototype"]["sTextDesign"] = "STANDARD";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_FileUpload["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_FileUpload["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.FileUploadBehavior}
 */
UCF_FileUpload["prototype"]["sUploadBehavior"] = "STANDARD";

/**
 * @private
 * @type {boolean}
 */
UCF_FileUpload["prototype"]["bRequired"] = false;

/**
 * @private
 * @type {string}
 */
UCF_FileUpload["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_FileUpload["prototype"]["bUsedInSapTable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_FileUpload["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_FileUpload["prototype"]["bMultiple"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_FileUpload["prototype"]["bHidden"] = false;

/**
 * @private
 * @type {string}
 */
UCF_FileUpload["prototype"]["sAccept"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_FileUpload["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["setDefaultValues"]++; }; 
	this["sInputState"] = "NONE";
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["bReadonly"] = false;
	this["sTextDesign"] = "STANDARD";
	this["sVisibility"] = "VISIBLE";
	this["sAccessKey"] = '';
	this["sUploadBehavior"] = "STANDARD";
	this["bRequired"] = false;
	this["sCustomData"] = '';
	this["bUsedInSapTable"] = false;
	this["sLabelledBy"] = '';
	this["bMultiple"] = false;
	this["bHidden"] = false;
	this["sAccept"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("InputState", "NONE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Readonly", false, true);
		this["setClientProperty"]("TextDesign", "STANDARD", true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("UploadBehavior", "STANDARD", true);
		this["setClientProperty"]("Required", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("UsedInSapTable", false, true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("Multiple", false, true);
		this["setClientProperty"]("Hidden", false, true);
		this["setClientProperty"]("Accept", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue Value of the field
 * @fires FileUpload::Change
 */
UCF_FileUpload["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "FileUpload.js(589): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "FileUpload.js(590): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "FileUpload.js(591): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "FileUpload.js(592): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "FileUpload.js(593): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("FileUpload", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires FileUpload::Error
 */
UCF_FileUpload["prototype"]["fireError"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["fireError"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "FileUpload.js(612): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "FileUpload.js(613): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "FileUpload.js(614): fireError"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("FileUpload", "Error", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_FileUpload["_"]["fireError"] = 0; };

};
sap["ls"]["preload"]["UCF_FlashContainer"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ActiveComponent */
/// <reference path="./base/ActiveComponent.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_FlashContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_FlashContainer["_"]["UCF_FlashContainer"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "FlashContainer.js(21): UCF_FlashContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "FlashContainer.js(22): UCF_FlashContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "FlashContainer.js(23): UCF_FlashContainer"); };

	UCF_ActiveComponent["apply"](this, [oDomRef, oLS]);

};window["UCF_FlashContainer"] = UCF_FlashContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FlashContainer"); UCF_FlashContainer["_"] = {UCF_FlashContainer: 0}; }; ;
UCF_FlashContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ActiveComponent"))(); UCF_FlashContainer.prototype["sClassName"] = "UCF_FlashContainer";

/**
 * Destructor, needs to take care of removing JS functions attached to the object to
 * avoid memory leak in IE
 */
UCF_FlashContainer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_FlashContainer["_"]["destroy"]++; }; 

	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		for (var i in this["oDomRef"]) {
			if (typeof(this["oDomRef"][i]) == "function") this["oDomRef"][i] = null;
		}
	}
	UCF_ActiveComponent.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_FlashContainer["_"]["destroy"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 */
UCF_FlashContainer["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FlashContainer["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FlashContainer.js(48): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() != this) return;

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource["getAttribute"]("tp") == "END") {
		oAccessibilityHelper["setControlType"]("FLC_END");
	} else if (oSource["getAttribute"]("tp") == "START") {
		oAccessibilityHelper["setControlType"]("FLC");
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	} else {
		oAccessibilityHelper["setControlType"]("FLC");
	}
};;if (__UCF_COVERAGE__) { UCF_FlashContainer["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_FlashContainer["prototype"]["aAttributeNames"] = ["sVisibility","sTooltip","sLifeCycle","bTransparent","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_FlashContainer["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_FlashContainer["prototype"]["aMethodNames"] = ["setKeepAlive","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_FlashContainer["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_FlashContainer["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_FlashContainer["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {boolean}
 */
UCF_FlashContainer["prototype"]["bTransparent"] = true;

/**
 * @private
 * @type {string}
 */
UCF_FlashContainer["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_FlashContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_FlashContainer["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sLifeCycle"] = "BROWSER";
	this["bTransparent"] = true;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("Transparent", true, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_FlashContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_FlowLayout"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_FlowLayout(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_FlowLayout["_"]["UCF_FlowLayout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "FlowLayout.js(17): UCF_FlowLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "FlowLayout.js(18): UCF_FlowLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "FlowLayout.js(19): UCF_FlowLayout"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_FlowLayout"] = UCF_FlowLayout; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FlowLayout"); UCF_FlowLayout["_"] = {UCF_FlowLayout: 0}; }; ;
UCF_FlowLayout["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_FlowLayout.prototype["sClassName"] = "UCF_FlowLayout";

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_FlowLayout["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FlowLayout["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FlowLayout["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_FlowLayout["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FlowLayout["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FlowLayout["_"]["onlsskipback"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_FlowLayout["prototype"]["aAttributeNames"] = ["sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_FlowLayout["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_FlowLayout["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_FlowLayout["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_FlowLayout["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_FlowLayout["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_FlowLayout["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_FlowLayout["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_FluidLayout"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Animation */
/// <reference path="../anim/Animation.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_FluidLayoutDragDelegate */
/// <reference path="./delegates/FluidLayoutDragDelegate.js"/>
/* global UCF_FluidLayoutDropDelegate */
/// <reference path="./delegates/FluidLayoutDropDelegate.js"/>
/* global UCF_FluidLayoutCell */
/// <reference path="./FluidLayoutCell.js"/>

/**
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_FluidLayout(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["UCF_FluidLayout"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "FluidLayout.js(35): UCF_FluidLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "FluidLayout.js(36): UCF_FluidLayout"); };
	UCF_Control["apply"](this, arguments);

	this["bDragAndResizeMode"] = false;
	this["sDragAndResizeMode"] = UCF_FluidLayoutCell["eDragAndResizeMode"]["NONE"];
	this["iRectRightPos"] = 0;
	this["iRectBottomPos"] = 0;
	this["iColWidth"] = Number["NaN"];
	this["iRowHeight"] = Number["NaN"];
	this["iColSpanDelta"] = 0;
	this["iRowSpanDelta"] = 0;
	this["iCursorRightFailedPos"] = Number["NaN"];
	this["iCursorLeftFailedPos"] = Number["NaN"];
	this["iCursorTopFailedPos"] = Number["NaN"];
	this["iCursorBottomFailedPos"] = Number["NaN"];
	this["oDRGhost"] = null;
	this["oRect"] = null;
	this["oFLLRect"] = null;
	this["oScrollOffset"] = null;
	this["oDragSession"] = null;
	this["iSModePosOffset"] = -1;
	this["iSModeSizeOffset"] = -4;

};window["UCF_FluidLayout"] = UCF_FluidLayout; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FluidLayout"); UCF_FluidLayout["_"] = {UCF_FluidLayout: 0}; }; ;

UCF_FluidLayout["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_FluidLayout.prototype["sClassName"] = "UCF_FluidLayout";

/**
 * Destructor
 * @private
 */
UCF_FluidLayout["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["destroy"]++; }; 

	this["bDragAndResizeMode"] = false;
	this["sDragAndResizeMode"] = "";
	this["iRectRightPos"] = 0;
	this["iRectBottomPos"] = 0;
	this["iColWidth"] = 0;
	this["iRowHeight"] = 0;
	this["iColSpanDelta"] = 0;
	this["iRowSpanDelta"] = 0;
	this["iCursorRightFailedPos"] = 0;
	this["iCursorLeftFailedPos"] = 0;
	this["iCursorTopFailedPos"] = 0;
	this["iCursorBottomFailedPos"] = 0;
	this["iSModePosOffset"] = 0;
	this["iSModeSizeOffset"] = 0;

	this["oRect"] = null;
	this["oFLLRect"] = null;
	this["oScrollOffset"] = null;
	this["oMouseDownCellRef"] = null;
	this["oStartCellRef"] = null;
	this["oFluidLayoutContainer"] = null;

	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}
	this["DRGhostDestroy"]();
	if (this["oDragSession"]) {
		this["oDragSession"]["destroy"]();
		this["oDragSession"] = null;
	}

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["destroy"] = 0; };


/**
 * implements method from UCF_Control
 * @private
 */
UCF_FluidLayout["prototype"]["createDragDelegate"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["createDragDelegate"]++; }; 
	//drag source info is at the cells
	//if (!this.sDragSourceInfo)
	//	return;

	if (this["oDragDelegate"])
		return;

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_FluidLayoutDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["createDragDelegate"] = 0; };

/**
 * implements method from UCF_Control
 * @private
 */
UCF_FluidLayout["prototype"]["createDropDelegate"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["createDropDelegate"]++; }; 

	if (!this["sDropTargetInfo"])
		return;

	if (this["oDropDelegate"])
		return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_FluidLayoutDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["createDropDelegate"] = 0; };

/**
 * Handles the mousedown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_FluidLayout["prototype"]["onmousedown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onmousedown"]++; }; 

	this["oMouseDownCellRef"] = UCF_DomUtil["oGetElementFromPoint"](oBrowserEvent["_iClientX"], oBrowserEvent["_iClientY"]);

	this["oStartCellRef"] = UCF_DomUtil["oGetParentByAttribute"](this["oMouseDownCellRef"], "ct", "FLCL");
	var oStartControl = this["oLS"]["oGetControlByDomRef"](this["oStartCellRef"]);
	this["bDragAndResizeMode"] = oStartControl["bIsDragAndResizeMode"]();
	this["sDragAndResizeMode"] = oStartControl["sGetDragAndResizeMode"]();

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onmousedown"] = 0; };

/**
 * Handles the lsdragstart event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_FluidLayout["prototype"]["bHandleDragStart"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bHandleDragStart"]++; }; 

	if (this["bDragAndResizeMode"]) {
		this["iColSpanDelta"] = 0;
		this["iRowSpanDelta"] = 0;
		this["iCursorRightFailedPos"] = Number["NaN"];
		this["iCursorLeftFailedPos"] = Number["NaN"];
		this["iCursorTopFailedPos"] = Number["NaN"];
		this["iCursorBottomFailedPos"] = Number["NaN"];
		//		this.oRect = UCF_DomUtil.oGetObjectRect(this.oStartCellRef);
		this["oRect"] = UCF_DomUtil["oGetViewPort"](this["oStartCellRef"]);
		this["oScrollOffset"] = UCF_DomUtil["oGetScrollOffset"](window);
		//		if (!this.oFLLRect) this.oFLLRect = UCF_DomUtil.oGetObjectRect(this.oDomRef);
		this["oFLLRect"] = UCF_DomUtil["oGetViewPort"](this["oDomRef"]);
		var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];
		if (oDragAndDropManager) {
			if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["BEGIN_RESIZE"] || this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["END_RESIZE"]) {
				this["oDragSession"] = oDragAndDropManager["startDragSession"](this["sId"], null, UCF_DragSession["DRAG_TYPE"]["H_RESIZE"], null, null, null);
			} else if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["TOP_RESIZE"] || this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["BOTTOM_RESIZE"]) {
				this["oDragSession"] = oDragAndDropManager["startDragSession"](this["sId"], null, UCF_DragSession["DRAG_TYPE"]["V_RESIZE"], null, null, null);
			}
		}
		this["DRGhostCreate"](this["sDragAndResizeMode"]);
		document["body"]["appendChild"](this["oDRGhost"]);

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;
		return true;
	} else return false;
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bHandleDragStart"] = 0; };

/**
 * Handles the lsdrag event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_FluidLayout["prototype"]["onlsdrag"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onlsdrag"]++; }; 

	var iColWidth = this["iGetColWidth"]();
	var iRowHeight = this["iGetRowHeight"]();

	if (this["oDRGhost"]) {
		if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["BEGIN_RESIZE"]) {
			if (this["bGetValidResizeBegin"](oBrowserEvent)) {
				this["iColSpanDelta"] = this["iGetColSpanDelta"](oBrowserEvent, this["oStartCellRef"], this["sDragAndResizeMode"]);
				this["DRGhostUpdate"](this["sDragAndResizeMode"], iColWidth, iRowHeight);
				this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["H_RESIZE"]);
			} else this["determineCursorBegin"](oBrowserEvent, iColWidth, iRowHeight);
		} else if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["END_RESIZE"]) {
			if (this["bGetValidResizeEnd"](oBrowserEvent)) {
				this["iColSpanDelta"] = this["iGetColSpanDelta"](oBrowserEvent, this["oStartCellRef"], this["sDragAndResizeMode"]);
				this["DRGhostUpdate"](this["sDragAndResizeMode"], iColWidth, iRowHeight);
				this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["H_RESIZE"]);
			} else this["determineCursorEnd"](oBrowserEvent, iColWidth, iRowHeight);
		} else if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["TOP_RESIZE"]) {
			if (this["bGetValidResizeTop"](oBrowserEvent)) {
				this["iRowSpanDelta"] = this["iGetRowSpanDelta"](oBrowserEvent, this["oStartCellRef"], this["sDragAndResizeMode"]);
				this["DRGhostUpdate"](this["sDragAndResizeMode"], iColWidth, iRowHeight);
				this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["V_RESIZE"]);
			} else this["determineCursorTop"](oBrowserEvent, iColWidth, iRowHeight);
		} else if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["BOTTOM_RESIZE"]) {
			if (this["bGetValidResizeBottom"](oBrowserEvent)) {
				this["iRowSpanDelta"] = this["iGetRowSpanDelta"](oBrowserEvent, this["oStartCellRef"], this["sDragAndResizeMode"]);
				this["DRGhostUpdate"](this["sDragAndResizeMode"], iColWidth, iRowHeight);
				this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["V_RESIZE"]);
			} else this["determineCursorBottom"](oBrowserEvent, iColWidth, iRowHeight);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onlsdrag"] = 0; };

UCF_FluidLayout["prototype"]["onlsdragend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onlsdragend"]++; }; 

	if (this["bDragAndResizeMode"]) {
		this["bDragAndResizeMode"] = false;

		if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["BEGIN_RESIZE"] || this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["END_RESIZE"]) {
			if (this["iColSpanDelta"] !== 0) {
				// fire semantic Event
				this["fireCellResize"](this["sId"], this["oStartCellRef"]["id"], this["iColSpanDelta"], this["sDragAndResizeMode"]);
			}
		} else if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["TOP_RESIZE"] || this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["BOTTOM_RESIZE"]) {
			if (this["iRowSpanDelta"] !== 0) {
				// fire semantic Event
				this["fireCellResize"](this["sId"], this["oStartCellRef"]["id"], this["iRowSpanDelta"], this["sDragAndResizeMode"]);
			}
		}

		if (window["UCF_System"]["bUseAnimation"]) {
			var oAnimation = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(this["oDRGhost"], 300);
			oAnimation["addInitialOpacityValue"](100);
			oAnimation["addOpacityChange"](100, 20, oAnimation["M_TRANSITIONS"]["EaseIn"]);
			oAnimation["callbackFinish"](this, "DRGhostDestroy");
			oAnimation["play"]();
		} else {
			this["DRGhostDestroy"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onlsdragend"] = 0; };

UCF_FluidLayout["prototype"]["DRGhostDestroy"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostDestroy"]++; }; 

	if (!this["oDRGhost"]) return;
	this["detachBrowserEvent"]("mousemove", this["oDRGhost"]);
	this["detachBrowserEvent"]("mouseup", this["oDRGhost"]);

	UCF_DomUtil["removeFromDom"](this["oDRGhost"]);
	this["oDRGhost"] = null;
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostDestroy"] = 0; };

UCF_FluidLayout["prototype"]["onlsdragscroll"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onlsdragscroll"]++; }; 

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onlsdragscroll"] = 0; };

UCF_FluidLayout["prototype"]["iGetColSpanDeltaRight"] = function (oBrowserEvent, oCellRef) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetColSpanDeltaRight"]++; }; 
	var oFLCLRect = UCF_DomUtil["oGetObjectRect"](oCellRef);
	var iColWidth = this["iGetColWidth"]();
	var iXPos = oBrowserEvent["_iClientX"] + this["oScrollOffset"]["x"];

	var iColSpanDelta = Math["round"]((iXPos - (oFLCLRect["left"] + oFLCLRect["width"])) / iColWidth);
	return iColSpanDelta;

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetColSpanDeltaRight"] = 0; };

UCF_FluidLayout["prototype"]["iGetColSpanDeltaLeft"] = function (oBrowserEvent, oCellRef) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetColSpanDeltaLeft"]++; }; 
	var oFLCLRect = UCF_DomUtil["oGetObjectRect"](oCellRef);
	var iColWidth = this["iGetColWidth"]();
	var iXPos = oBrowserEvent["_iClientX"] + this["oScrollOffset"]["x"];

	var iColSpanDelta = Math["round"]((oFLCLRect["left"] - iXPos) / iColWidth);
	return iColSpanDelta;

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetColSpanDeltaLeft"] = 0; };

UCF_FluidLayout["prototype"]["iGetColSpanDelta"] = function (oBrowserEvent, oCellRef, sDragAndResizeMode) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetColSpanDelta"]++; }; 

	if (window["UCF_System"]["bIsRTL"]) {
		if (sDragAndResizeMode === UCF_FluidLayoutCell["eDragAndResizeMode"]["END_RESIZE"]) {
			return this["iGetColSpanDeltaLeft"](oBrowserEvent, oCellRef);
		} else if (sDragAndResizeMode === UCF_FluidLayoutCell["eDragAndResizeMode"]["BEGIN_RESIZE"]) {
			return this["iGetColSpanDeltaRight"](oBrowserEvent, oCellRef);
		}
	} else {
		if (sDragAndResizeMode === UCF_FluidLayoutCell["eDragAndResizeMode"]["END_RESIZE"]) {
			return this["iGetColSpanDeltaRight"](oBrowserEvent, oCellRef);
		} else if (sDragAndResizeMode === UCF_FluidLayoutCell["eDragAndResizeMode"]["BEGIN_RESIZE"]) {
			return this["iGetColSpanDeltaLeft"](oBrowserEvent, oCellRef);
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetColSpanDelta"] = 0; };

UCF_FluidLayout["prototype"]["iGetColWidth"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetColWidth"]++; }; 

	//if (!isNaN(this.iColWidth)) return this.iColWidth;

	var oFLLRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);
	return this["iColWidth"] = oFLLRect["width"] / this["iColumnCount"];

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetColWidth"] = 0; };

UCF_FluidLayout["prototype"]["iGetRowSpanDelta"] = function (oBrowserEvent, oCellRef, sDragAndResizeMode) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetRowSpanDelta"]++; }; 
	var oFLCLRect = UCF_DomUtil["oGetObjectRect"](oCellRef);
	var iRowHeight = this["iGetRowHeight"]();
	var iYPos = oBrowserEvent["_iClientY"] + this["oScrollOffset"]["y"];

	var iRowSpanDelta;
	if (sDragAndResizeMode === UCF_FluidLayoutCell["eDragAndResizeMode"]["BOTTOM_RESIZE"]) {
		iRowSpanDelta = Math["round"]((iYPos - (oFLCLRect["top"] + oFLCLRect["height"])) / iRowHeight);
	} else if (sDragAndResizeMode === UCF_FluidLayoutCell["eDragAndResizeMode"]["TOP_RESIZE"]) {
		iRowSpanDelta = Math["round"]((oFLCLRect["top"] - iYPos) / iRowHeight);
	}

	return iRowSpanDelta;

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetRowSpanDelta"] = 0; };

UCF_FluidLayout["prototype"]["iGetRowHeight"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetRowHeight"]++; }; 

	//if (!isNaN(this.iRowHeight)) return this.iRowHeight;

	var oFLLRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);
	return this["iRowHeight"] = oFLLRect["height"] / this["oDomRef"]["rows"]["length"];

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["iGetRowHeight"] = 0; };

UCF_FluidLayout["prototype"]["bGetValidResizeTop"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeTop"]++; }; 

	var iXPos = this["oRect"]["left"] - this["oScrollOffset"]["x"];
	var iYPos = oBrowserEvent["_iClientY"] + this["oScrollOffset"]["y"];

	//first check the top failed position (top failed position is the topmost cursor position at which no further top resizing was possible
	//for example due to an not empty cell)
	//if the current cursor position is higher than the top failed position further resizing in that direction is not allowed
	if (!isNaN(this["iCursorTopFailedPos"]) && (iYPos < this["iCursorTopFailedPos"])) return false;
	//then check wether the top border of the FluidLayout has been reached
	if (iYPos < (this["oFLLRect"]["top"] + this["iRowHeight"])) return false;
	//if we deal with a cell of rowSpan>1 then reducing the rowspan to down to 1 is always allowed
	if ((this["oStartCellRef"]["rowSpan"] > 1) &&
		(iYPos > (this["iRectBottomPos"] - (this["oStartCellRef"]["rowSpan"] * this["iGetRowHeight"]()))) &&
		(iYPos < (this["iRectBottomPos"] - this["iGetRowHeight"]()))) return true;
	else if (iYPos >= (this["iRectBottomPos"] - this["iGetRowHeight"]())) return false;

	//now check all relevant sibling element and determine top failed position
	var bResizeable = true;
	var oSiblingRef = null;
	this["DRGhostHide"]();
	for (var i = 0; i < this["oStartCellRef"]["colSpan"]; i++) {
		//subtract UCF_FluidLayoutCell.iVResizeRange to be sure to get the sibling elements in the border area
		oSiblingRef = UCF_DomUtil["oGetElementFromPoint"]((iXPos + (this["iGetColWidth"]() / 2) + (i * this["iGetColWidth"]())), (oBrowserEvent["_iClientY"] - UCF_FluidLayoutCell["iVResizeRange"]));
		if ((!oSiblingRef) || (!this["bIsEmptyFLCell"](oSiblingRef))) {
			this["iCursorTopFailedPos"] = iYPos;
			bResizeable = false;
			break;
		}
	}
	this["DRGhostShow"]();
	return bResizeable;

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeTop"] = 0; };

UCF_FluidLayout["prototype"]["determineCursorTop"] = function (oBrowserEvent, iColWidth, iRowHeight) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorTop"]++; }; 
	var iYPos = oBrowserEvent["_iClientY"] + this["oScrollOffset"]["y"];
	var iDRGhostTop = (this["iRectBottomPos"] - ((this["oStartCellRef"]["rowSpan"] + this["iRowSpanDelta"]) * iRowHeight));

	//set mouse cursor in the range of UCF_FluidLayoutCell.iVResizeRange around the border
	//all other areas are handled in method onlsdrag
	if (!isNaN(this["iCursorTopFailedPos"]) && (iYPos <= this["iCursorTopFailedPos"]) && (iYPos > iDRGhostTop)) {
		this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["V_RESIZE"]);
	} else this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["NOT_ALLOWED"]);

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorTop"] = 0; };

UCF_FluidLayout["prototype"]["bGetValidResizeBottom"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeBottom"]++; }; 

	//for documentation see bGetValidResizeTop
	var iXPos = this["oRect"]["left"] - this["oScrollOffset"]["x"];
	var iYPos = oBrowserEvent["_iClientY"] + this["oScrollOffset"]["y"];

	if (!isNaN(this["iCursorBottomFailedPos"]) && (iYPos > this["iCursorBottomFailedPos"])) return false;
	if (iYPos > (this["oFLLRect"]["top"] + this["oFLLRect"]["height"])) return false;
	if ((this["oStartCellRef"]["rowSpan"] > 1) &&
		(iYPos < (this["oRect"]["top"] + (this["oStartCellRef"]["rowSpan"] * this["iGetRowHeight"]()))) &&
		(iYPos > (this["oRect"]["top"] + this["iGetRowHeight"]()))) return true;
	else if (iYPos <= (this["oRect"]["top"] + this["iGetRowHeight"]())) return false;

	var bResizeable = true;
	var oSiblingRef = null;
	this["DRGhostHide"]();
	for (var i = 0; i < this["oStartCellRef"]["colSpan"]; i++) {
		oSiblingRef = UCF_DomUtil["oGetElementFromPoint"]((iXPos + (this["iGetColWidth"]() / 2) + (i * this["iGetColWidth"]())), (oBrowserEvent["_iClientY"] + UCF_FluidLayoutCell["iVResizeRange"]));
		if ((!oSiblingRef) || (!this["bIsEmptyFLCell"](oSiblingRef))) {
			this["iCursorBottomFailedPos"] = iYPos;
			bResizeable = false;
			break;
		}
	}
	this["DRGhostShow"]();
	return bResizeable;

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeBottom"] = 0; };

UCF_FluidLayout["prototype"]["determineCursorBottom"] = function (oBrowserEvent, iColWidth, iRowHeight) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorBottom"]++; }; 
	var iYPos = oBrowserEvent["_iClientY"] + this["oScrollOffset"]["y"];
	var iDRGhostBottom = (this["oRect"]["top"] + ((this["oStartCellRef"]["rowSpan"] + this["iRowSpanDelta"]) * iRowHeight));

	//set mouse cursor
	if (!isNaN(this["iCursorBottomFailedPos"]) && (iYPos >= this["iCursorBottomFailedPos"]) && (iYPos < iDRGhostBottom)) {
		this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["V_RESIZE"]);
	} else this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["NOT_ALLOWED"]);

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorBottom"] = 0; };

UCF_FluidLayout["prototype"]["bGetValidResizeRight"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeRight"]++; }; 

	//for documentation see bGetValidResizeTop
	var iXPos = oBrowserEvent["_iClientX"] + this["oScrollOffset"]["x"];
	var iYPos = this["oRect"]["top"] - this["oScrollOffset"]["y"];

	if (!isNaN(this["iCursorRightFailedPos"]) && (iXPos > this["iCursorRightFailedPos"])) return false;
	if (iXPos > (this["oFLLRect"]["left"] + this["oFLLRect"]["width"])) return false;
	if ((this["oStartCellRef"]["colSpan"] > 1) &&
		(iXPos < (this["oRect"]["left"] + (this["oStartCellRef"]["colSpan"] * this["iGetColWidth"]()))) &&
		(iXPos > (this["oRect"]["left"] + this["iGetColWidth"]()))) return true;
	else if (iXPos <= (this["oRect"]["left"] + this["iGetColWidth"]())) return false;

	var bResizeable = true;
	var oSiblingRef = null;
	this["DRGhostHide"]();
	for (var i = 0; i < this["oStartCellRef"]["rowSpan"]; i++) {
		oSiblingRef = UCF_DomUtil["oGetElementFromPoint"]((oBrowserEvent["_iClientX"] + UCF_FluidLayoutCell["iHResizeRange"]), (iYPos + (this["iGetRowHeight"]() / 2) + (i * this["iGetRowHeight"]())));
		if ((!oSiblingRef) || (!this["bIsEmptyFLCell"](oSiblingRef))) {
			this["iCursorRightFailedPos"] = iXPos;
			bResizeable = false;
			break;
		}
	}
	this["DRGhostShow"]();
	return bResizeable;

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeRight"] = 0; };

UCF_FluidLayout["prototype"]["determineCursorRight"] = function (oBrowserEvent, iColWidth, iRowHeight) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorRight"]++; }; 

	//for documentation see determineCursorTop
	var iXPos = oBrowserEvent["_iClientX"] + this["oScrollOffset"]["x"];
	var iDRGhostRight = (this["oRect"]["left"] + ((this["oStartCellRef"]["colSpan"] + this["iColSpanDelta"]) * iColWidth));

	//set mouse cursor
	if (!isNaN(this["iCursorRightFailedPos"]) && (iXPos >= this["iCursorRightFailedPos"]) && (iXPos < iDRGhostRight)) {
		this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["H_RESIZE"]);
	} else this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["NOT_ALLOWED"]);

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorRight"] = 0; };

UCF_FluidLayout["prototype"]["bGetValidResizeLeft"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeLeft"]++; }; 

	//for documentation see bGetValidResizeTop
	var iXPos = oBrowserEvent["_iClientX"] + this["oScrollOffset"]["x"];
	var iYPos = this["oRect"]["top"] - this["oScrollOffset"]["y"];

	if (!isNaN(this["iCursorLeftFailedPos"]) && (iXPos < this["iCursorLeftFailedPos"])) return false;
	if (iXPos < this["oFLLRect"]["left"]) return false;
	if ((this["oStartCellRef"]["colSpan"] > 1) &&
		(iXPos > (this["iRectRightPos"] - (this["oStartCellRef"]["colSpan"] * this["iGetColWidth"]()))) &&
		(iXPos < (this["iRectRightPos"] - this["iGetColWidth"]()))) return true;
	else if (iXPos >= (this["iRectRightPos"] - this["iGetColWidth"]())) return false;

	var bResizeable = true;
	var oSiblingRef = null;
	this["DRGhostHide"]();
	for (var i = 0; i < this["oStartCellRef"]["rowSpan"]; i++) {
		oSiblingRef = UCF_DomUtil["oGetElementFromPoint"]((oBrowserEvent["_iClientX"] - UCF_FluidLayoutCell["iHResizeRange"]), (iYPos + (this["iGetRowHeight"]() / 2) + (i * this["iGetRowHeight"]())));
		if ((!oSiblingRef) || (!this["bIsEmptyFLCell"](oSiblingRef))) {
			this["iCursorLeftFailedPos"] = iXPos;
			bResizeable = false;
			break;
		}
	}
	this["DRGhostShow"]();
	return bResizeable;

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeLeft"] = 0; };

UCF_FluidLayout["prototype"]["determineCursorLeft"] = function (oBrowserEvent, iColWidth, iRowHeight) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorLeft"]++; }; 

	//for documentation see determineCursorTop
	var iXPos = oBrowserEvent["_iClientX"] + this["oScrollOffset"]["x"];
	var iDRGhostLeft = (this["iRectRightPos"] - ((this["oStartCellRef"]["colSpan"] + this["iColSpanDelta"]) * iColWidth));

	//set mouse cursor
	if (!isNaN(this["iCursorLeftFailedPos"]) && (iXPos <= this["iCursorLeftFailedPos"]) && (iXPos > iDRGhostLeft)) {
		this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["H_RESIZE"]);
	} else this["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["NOT_ALLOWED"]);

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorLeft"] = 0; };

UCF_FluidLayout["prototype"]["bGetValidResizeEnd"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeEnd"]++; }; 

	if (window["UCF_System"]["bIsRTL"]) return this["bGetValidResizeLeft"](oBrowserEvent);
	else return this["bGetValidResizeRight"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeEnd"] = 0; };

UCF_FluidLayout["prototype"]["bGetValidResizeBegin"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeBegin"]++; }; 

	if (window["UCF_System"]["bIsRTL"]) return this["bGetValidResizeRight"](oBrowserEvent);
	else return this["bGetValidResizeLeft"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bGetValidResizeBegin"] = 0; };

UCF_FluidLayout["prototype"]["determineCursorEnd"] = function (oBrowserEvent, iColWidth, iRowHeight) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorEnd"]++; }; 

	if (window["UCF_System"]["bIsRTL"]) this["determineCursorLeft"](oBrowserEvent, iColWidth, iRowHeight);
	else this["determineCursorRight"](oBrowserEvent, iColWidth, iRowHeight);

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorEnd"] = 0; };

UCF_FluidLayout["prototype"]["determineCursorBegin"] = function (oBrowserEvent, iColWidth, iRowHeight) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorBegin"]++; }; 

	if (window["UCF_System"]["bIsRTL"]) this["determineCursorRight"](oBrowserEvent, iColWidth, iRowHeight);
	else this["determineCursorLeft"](oBrowserEvent, iColWidth, iRowHeight);

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["determineCursorBegin"] = 0; };

UCF_FluidLayout["prototype"]["DRGhostShow"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostShow"]++; }; 

	this["oDRGhost"]["style"]["visibility"] = "visible";
	this["oDRGhost"]["style"]["display"] = "";

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostShow"] = 0; };

UCF_FluidLayout["prototype"]["DRGhostHide"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostHide"]++; }; 

	this["oDRGhost"]["style"]["visibility"] = "hidden";
	this["oDRGhost"]["style"]["display"] = "none";

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostHide"] = 0; };

UCF_FluidLayout["prototype"]["DRGhostLeftUpdate"] = function (sDragAndResizeMode, iColWidth, iRowHeight) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostLeftUpdate"]++; }; 

	if (window["UCF_System"]["sDevice"] === "standards") {
		this["oDRGhost"]["style"]["left"] = ((this["iRectRightPos"] - ((this["oStartCellRef"]["colSpan"] + this["iColSpanDelta"]) * iColWidth)) + this["iSModePosOffset"]) + "px";
		this["oDRGhost"]["style"]["width"] = (((this["oStartCellRef"]["colSpan"] + this["iColSpanDelta"]) * iColWidth) + this["iSModeSizeOffset"]) + "px";
	} else {
		this["oDRGhost"]["style"]["left"] = (this["iRectRightPos"] - ((this["oStartCellRef"]["colSpan"] + this["iColSpanDelta"]) * iColWidth)) + "px";
		this["oDRGhost"]["style"]["width"] = ((this["oStartCellRef"]["colSpan"] + this["iColSpanDelta"]) * iColWidth) + "px";
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostLeftUpdate"] = 0; };

UCF_FluidLayout["prototype"]["DRGhostRightUpdate"] = function (sDragAndResizeMode, iColWidth, iRowHeight) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostRightUpdate"]++; }; 

	if (window["UCF_System"]["sDevice"] === "standards") {
		this["oDRGhost"]["style"]["width"] = (((this["oStartCellRef"]["colSpan"] + this["iColSpanDelta"]) * iColWidth) + this["iSModeSizeOffset"]) + "px";
	} else {
		this["oDRGhost"]["style"]["width"] = ((this["oStartCellRef"]["colSpan"] + this["iColSpanDelta"]) * iColWidth) + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostRightUpdate"] = 0; };

UCF_FluidLayout["prototype"]["DRGhostTopUpdate"] = function (sDragAndResizeMode, iColWidth, iRowHeight) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostTopUpdate"]++; }; 

	if (window["UCF_System"]["sDevice"] === "standards") {
		this["oDRGhost"]["style"]["top"] = ((this["iRectBottomPos"] - ((this["oStartCellRef"]["rowSpan"] + this["iRowSpanDelta"]) * iRowHeight)) + this["iSModePosOffset"]) + "px";
		this["oDRGhost"]["style"]["height"] = (((this["oStartCellRef"]["rowSpan"] + this["iRowSpanDelta"]) * iRowHeight) + this["iSModeSizeOffset"]) + "px";
	} else {
		this["oDRGhost"]["style"]["top"] = (this["iRectBottomPos"] - ((this["oStartCellRef"]["rowSpan"] + this["iRowSpanDelta"]) * iRowHeight)) + "px";
		this["oDRGhost"]["style"]["height"] = ((this["oStartCellRef"]["rowSpan"] + this["iRowSpanDelta"]) * iRowHeight) + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostTopUpdate"] = 0; };

UCF_FluidLayout["prototype"]["DRGhostBottomUpdate"] = function (sDragAndResizeMode, iColWidth, iRowHeight) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostBottomUpdate"]++; }; 

	if (window["UCF_System"]["sDevice"] === "standards") {
		this["oDRGhost"]["style"]["height"] = (((this["oStartCellRef"]["rowSpan"] + this["iRowSpanDelta"]) * iRowHeight) + this["iSModeSizeOffset"]) + "px";
	} else {
		this["oDRGhost"]["style"]["height"] = ((this["oStartCellRef"]["rowSpan"] + this["iRowSpanDelta"]) * iRowHeight) + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostBottomUpdate"] = 0; };

UCF_FluidLayout["prototype"]["DRGhostUpdate"] = function (sDragAndResizeMode, iColWidth, iRowHeight) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostUpdate"]++; }; 

	if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["BEGIN_RESIZE"]) {
		if (window["UCF_System"]["bIsRTL"]) {
			this["DRGhostRightUpdate"](sDragAndResizeMode, iColWidth, iRowHeight);
		} else {
			this["DRGhostLeftUpdate"](sDragAndResizeMode, iColWidth, iRowHeight);
		}
	} else if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["END_RESIZE"]) {
		if (window["UCF_System"]["bIsRTL"]) {
			this["DRGhostLeftUpdate"](sDragAndResizeMode, iColWidth, iRowHeight);
		} else {
			this["DRGhostRightUpdate"](sDragAndResizeMode, iColWidth, iRowHeight);
		}
	} else if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["TOP_RESIZE"]) {
		this["DRGhostTopUpdate"](sDragAndResizeMode, iColWidth, iRowHeight);
	} else if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["BOTTOM_RESIZE"]) {
		this["DRGhostBottomUpdate"](sDragAndResizeMode, iColWidth, iRowHeight);
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostUpdate"] = 0; };

UCF_FluidLayout["prototype"]["DRGhostCreate"] = function (sDragAndResizeMode) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostCreate"]++; }; 

	this["oDRGhost"] = document["createElement"]("DIV");
	this["attachBrowserEvent"]("mousemove", this["oDRGhost"]);
	this["attachBrowserEvent"]("mouseup", this["oDRGhost"]);
	this["oDRGhost"]["id"] = "DragResize";
	this["oDRGhost"]["style"]["position"] = "absolute";
	if (window["UCF_System"]["sDevice"] === "standards") {
		this["oDRGhost"]["style"]["left"] = (this["oRect"]["left"] + this["iSModePosOffset"]) + "px";
		this["oDRGhost"]["style"]["top"] = (this["oRect"]["top"] + this["iSModePosOffset"]) + "px";
		this["oDRGhost"]["style"]["width"] = (this["oRect"]["width"] + this["iSModeSizeOffset"]) + "px";
		this["oDRGhost"]["style"]["height"] = (this["oRect"]["height"] + this["iSModeSizeOffset"]) + "px";
	} else {
		this["oDRGhost"]["style"]["left"] = this["oRect"]["left"] + "px";
		this["oDRGhost"]["style"]["top"] = this["oRect"]["top"] + "px";
		this["oDRGhost"]["style"]["width"] = this["oRect"]["width"] + "px";
		this["oDRGhost"]["style"]["height"] = this["oRect"]["height"] + "px";
	}

	if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["BEGIN_RESIZE"] || this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["END_RESIZE"]) {
		this["iRectRightPos"] = this["oRect"]["left"] + this["oRect"]["width"];
		this["oDRGhost"]["style"]["borderLeft"] = "2px solid black";
		this["oDRGhost"]["style"]["borderRight"] = "2px solid black";
		this["oDRGhost"]["style"]["borderTop"] = "2px dashed black";
		this["oDRGhost"]["style"]["borderBottom"] = "2px dashed black";

		this["oDRGhost"]["style"]["cursor"] = UCF_DragSession["E_CURSOR"]["H_RESIZE"];
	} else if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["TOP_RESIZE"] || this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["BOTTOM_RESIZE"]) {
		this["iRectBottomPos"] = this["oRect"]["top"] + this["oRect"]["height"];
		this["oDRGhost"]["style"]["borderTop"] = "2px solid black";
		this["oDRGhost"]["style"]["borderBottom"] = "2px solid black";
		this["oDRGhost"]["style"]["borderLeft"] = "2px dashed black";
		this["oDRGhost"]["style"]["borderRight"] = "2px dashed black";

		this["oDRGhost"]["style"]["cursor"] = UCF_DragSession["E_CURSOR"]["V_RESIZE"];
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["DRGhostCreate"] = 0; };

UCF_FluidLayout["prototype"]["oGetFluidLayoutContainer"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["oGetFluidLayoutContainer"]++; }; 

	if (this["oFluidLayoutContainer"]) return this["oFluidLayoutContainer"];

	var oFLCRef = UCF_DomUtil["oGetParentByAttribute"](this["oDomRef"], "ct", "FLCO");

	return this["oFluidLayoutContainer"] = this["oLS"]["oControlFactory"]["oGetControlById"](oFLCRef["id"]);

};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["oGetFluidLayoutContainer"] = 0; };

UCF_FluidLayout["prototype"]["oGetFirstCell"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["oGetFirstCell"]++; }; 

	var aTDs = this["oDomRef"]["getElementsByTagName"]("TD");
	for (var x = 0, len = aTDs["length"]; x < len; x++) {
		var sId = aTDs[x]["id"];
		if (!sId) continue;
		var oCell = this["oLS"]["oControlFactory"]["oGetControlById"](sId);
		if (UCF_JsUtil["bInstanceOf"](oCell, "UCF_FluidLayoutCell")) return oCell;
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["oGetFirstCell"] = 0; };

UCF_FluidLayout["prototype"]["bIsEmptyFLCell"] = function (oDomRef) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bIsEmptyFLCell"]++; }; 

	var oFLCell = this["oLS"]["oGetControlByDomRef"](oDomRef);

	if (oFLCell && UCF_JsUtil["bInstanceOf"](oFLCell, "UCF_FluidLayoutCell") && !oFLCell["bOccupied"]) {
		return true;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["bIsEmptyFLCell"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_FluidLayout["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FluidLayout.js(708): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_FluidLayout["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FluidLayout.js(720): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
  oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["onlsskipback"] = 0; };

//********* The following implementation realizes a client side rendering after drag and resize *************
//********* Because of complexity reasons at client side not activated                          *************

///**
// * Handles the lsdragstart event of the browser
// *
// * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
// * @private
// */
//UCF_FluidLayout.prototype.bHandleDragStart = function(oBrowserEvent) {
//
//	if (this.bDragAndResizeMode) {
//		this.iColSpanDelta = 0;
//		this.iRowSpanDelta = 0;
//		var iXPos = 0;
//		var iYPos = 0;
//		this.iInitialColSpan = this.oStartCellRef.colSpan;
//		this.oRect = UCF_DomUtil.oGetObjectRect(this.oStartCellRef);
//		if (!this.oFLLRect) this.oFLLRect = UCF_DomUtil.oGetObjectRect(this.oDomRef);
//		var oDragAndDropManager = oBrowserEvent.oDragAndDropManager;
//		var oSiblingRef = null;
//		var oSiblingRootRef = null;
//		this.aSiblingRootRef = new Array();
//		if (oDragAndDropManager) {
//			if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.BEGIN_RESIZE || this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.END_RESIZE) {
//				oDragAndDropManager.startDragSession(this.sId, null,UCF_DragSession.DRAG_TYPE.H_RESIZE, null, null, null);
//
//				this.DRGhostCreate(this.sDragAndResizeMode);
//
//				iYPos = this.oRect.top + (this.iGetRowHeight()/2);
//
//				if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.BEGIN_RESIZE) {
//					this.DRGhostHide();
//					if (UCF_System.bIsRTL) iXPos = (this.oRect.left + this.oRect.width) + (this.iGetColWidth()/2);
//					else iXPos = this.oRect.left - (this.iGetColWidth()/2);
//					for (var i = 0; i < this.oStartCellRef.rowSpan; i++) {
//						if (UCF_System.bIsRTL) {
//							oSiblingRef = UCF_DomUtil.oGetElementFromPoint(iXPos, (iYPos + (i * this.iGetRowHeight())));
//						}
//						else {
//							oSiblingRef = UCF_DomUtil.oGetElementFromPoint(iXPos, (iYPos + (i * this.iGetRowHeight())));
//						}
//						oSiblingRootRef = UCF_DomUtil.oGetParentByAttribute(oSiblingRef, "ct", "FLCL");
//						if (oSiblingRootRef) this.aSiblingRootRef.push(oSiblingRootRef);
//					}
//					this.DRGhostShow();
//				}
//				else if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.END_RESIZE) {
//					this.DRGhostHide();
//					if (UCF_System.bIsRTL) iXPos = this.oRect.left - (this.iGetColWidth()/2);
//					else iXPos = (this.oRect.left + this.oRect.width) + (this.iGetColWidth()/2);
//					for (var i = 0; i < this.oStartCellRef.rowSpan; i++) {
//						if (UCF_System.bIsRTL) {
//							oSiblingRef = UCF_DomUtil.oGetElementFromPoint(iXPos, (iYPos + (i * this.iGetRowHeight())));
//						}
//						else {
//							oSiblingRef = UCF_DomUtil.oGetElementFromPoint(iXPos, (iYPos + (i * this.iGetRowHeight())));
//						}
//						oSiblingRootRef = UCF_DomUtil.oGetParentByAttribute(oSiblingRef, "ct", "FLCL");
//						if (oSiblingRootRef) this.aSiblingRootRef.push(oSiblingRootRef);
//					}
//					this.DRGhostShow();
//				}
//			}
//			else if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.TOP_RESIZE || this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.BOTTOM_RESIZE) {
//				oDragAndDropManager.startDragSession(this.sId, null,UCF_DragSession.DRAG_TYPE.V_RESIZE, null, null, null);
//
//				this.DRGhostCreate(this.sDragAndResizeMode);
//
//			}
//		}
//
//		//this.oDomRef.parentNode.appendChild(this.oDRGhost);
//		document.body.appendChild(this.oDRGhost);
//
//		oBrowserEvent.cancel();
//		oBrowserEvent.cancelBubble();
//		oBrowserEvent.bHandled = true;
//		return true;
//	}
//	else return false;
//};
//
//UCF_FluidLayout.prototype.onlsdrag = function(oBrowserEvent) {
//
//	var oSiblingRef = null;
//	var oSiblingRootRef = null;
//	var oSiblingBelowRef = null;
//	var oSiblingBelowRootRef = null;
//	var oGhostRect = null;
//	var iXPos = 0;
//	var iYPos = 0;
//
//	var iColWidth = this.iGetColWidth();
//	var iRowHeight = this.iGetRowHeight();
//
//	if (this.oDRGhost) {
//		if ((this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.BEGIN_RESIZE) && this.bGetValidResizeBegin(oBrowserEvent)) {
//			this.iColSpanDelta = this.iGetColSpanDelta(oBrowserEvent, this.oStartCellRef, this.sDragAndResizeMode);
//			this.DRGhostUpdate(this.sDragAndResizeMode, iColWidth, iRowHeight);
//		}
//		else if ((this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.END_RESIZE) && this.bGetValidResizeEnd(oBrowserEvent)){
//			this.iColSpanDelta = this.iGetColSpanDelta(oBrowserEvent, this.oStartCellRef, this.sDragAndResizeMode);
//			this.DRGhostUpdate(this.sDragAndResizeMode, iColWidth, iRowHeight);
//		}
//		else if ((this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.TOP_RESIZE) && this.bGetValidResizeTop(oBrowserEvent)){
//			this.iRowSpanDelta = this.iGetRowSpanDelta(oBrowserEvent, this.oStartCellRef, this.sDragAndResizeMode);
//			this.DRGhostUpdate(this.sDragAndResizeMode, iColWidth, iRowHeight);
//
//			iXPos = this.oRect.left + (this.iGetColWidth()/2);
//			if (this.iRowSpanDelta > 0) {
//				if (this.iRowSpanDeltaOld < this.iRowSpanDelta) {
//					oGhostRect = UCF_DomUtil.oGetObjectRect(this.oDRGhost);
//					iYPos = oGhostRect.top + (this.iGetRowHeight()/2);
//					this.DRGhostHide();
//					for (var i = 0; i < this.oStartCellRef.colSpan; i++) {
//						oSiblingRef = UCF_DomUtil.oGetElementFromPoint((iXPos + (i * this.iGetColWidth())), iYPos);
//						oSiblingRootRef = UCF_DomUtil.oGetParentByAttribute(oSiblingRef, "ct", "FLCL");
//						if (oSiblingRootRef) this.aSiblingRootRef.push(oSiblingRootRef);
//					}
//					this.DRGhostShow();
//					this.iRowSpanDeltaOld = this.iRowSpanDelta;
//				}
//				else if (this.iRowSpanDeltaOld > this.iRowSpanDelta) {
//					this.DRGhostHide();
//					for (var i = 1; i <= this.oStartCellRef.colSpan; i++) {
//						this.aSiblingRootRef.pop();
//					}
//					this.DRGhostShow();
//					this.iRowSpanDeltaOld = this.iRowSpanDelta;
//				}
//			}
//		}
//		else if ((this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.BOTTOM_RESIZE) && this.bGetValidResizeBottom(oBrowserEvent)){
//			this.iRowSpanDelta = this.iGetRowSpanDelta(oBrowserEvent, this.oStartCellRef, this.sDragAndResizeMode);
//			this.DRGhostUpdate(this.sDragAndResizeMode, iColWidth, iRowHeight);
//
//			iXPos = this.oRect.left + (this.iGetColWidth()/2);
//			if (this.iRowSpanDelta > 0) {
//				if (this.iRowSpanDeltaOld < this.iRowSpanDelta) {
//					oGhostRect = UCF_DomUtil.oGetObjectRect(this.oDRGhost);
//					iYPos = (oGhostRect.top + oGhostRect.height) - (this.iGetRowHeight()/2);
//					this.DRGhostHide();
//					for (var i = 0; i < this.oStartCellRef.colSpan; i++) {
//						oSiblingRef = UCF_DomUtil.oGetElementFromPoint((iXPos + (i * this.iGetColWidth())), iYPos);
//						oSiblingRootRef = UCF_DomUtil.oGetParentByAttribute(oSiblingRef, "ct", "FLCL");
//						if (oSiblingRootRef) this.aSiblingRootRef.push(oSiblingRootRef);
//					}
//					this.DRGhostShow();
//					this.iRowSpanDeltaOld = this.iRowSpanDelta;
//				}
//				else if (this.iRowSpanDeltaOld > this.iRowSpanDelta) {
//					this.DRGhostHide();
//					for (var i = 1; i <= this.oStartCellRef.colSpan; i++) {
//						this.aSiblingRootRef.pop();
//					}
//					this.DRGhostShow();
//					this.iRowSpanDeltaOld = this.iRowSpanDelta;
//				}
//			}
//		}
//	}
//
//};
//
//UCF_FluidLayout.prototype.onlsdragend = function(oBrowserEvent) {
//
//	var oSiblingRef = null;
//	var oSiblingParentRef = null;
//	var oNextSiblingRef = null;
//	var oPrevSiblingRef = null;
//	this.iRowSpanDeltaOld = 0;
//
//	if (this.bDragAndResizeMode) {
//		this.bDragAndResizeMode = false;
//
//		if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.BEGIN_RESIZE || this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.END_RESIZE) {
//			if (this.iColSpanDelta != 0) {
//				// add/remove cells
//				if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.END_RESIZE) {
//					if (this.iColSpanDelta > 0) {
//						//remove cells
//						for (var j = 0; j < this.aSiblingRootRef.length; j++) {
//							oSiblingRef = this.aSiblingRootRef[j];
//							for (var i = 0; i < this.iColSpanDelta; i++) {
//								oNextSiblingRef = UCF_DomUtil.nextSibling(oSiblingRef, "TD");
//								UCF_DomUtil.removeFromDom(oSiblingRef, "TD");
//								oSiblingRef = oNextSiblingRef;
//							}
//						}
//					}
//					else if (this.iColSpanDelta < 0)  {
//						//add cells
//						this.RebuildAfterHResize();
//					}
//				}
//				else if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.BEGIN_RESIZE) {
//					if (this.iColSpanDelta > 0) {
//						//remove cells
//						for (var j = 0; j < this.aSiblingRootRef.length; j++) {
//							oSiblingRef = this.aSiblingRootRef[j];
//							for (var i = 0; i < this.iColSpanDelta; i++) {
//								oPrevSiblingRef = UCF_DomUtil.previousSibling(oSiblingRef, "TD");
//								UCF_DomUtil.removeFromDom(oSiblingRef, "TD");
//								oSiblingRef = oPrevSiblingRef;
//							}
//						}
//					}
//					else if (this.iColSpanDelta < 0)  {
//						//add cells
//						this.RebuildAfterHResize();
//					}
//				}
//
//				// set colSpan
//				var iInitialColSpan = this.oStartCellRef.colSpan;
//				this.oStartCellRef.colSpan = iInitialColSpan + this.iColSpanDelta;
//
//				if (iInitialColSpan != this.oStartCellRef.colSpan) {
//					// fire semantic Event
//					this.fireCellResize(this.sId, this.oStartCellRef.id, this.iColSpanDelta, this.sDragAndResizeMode);
//				}
//			}
//		}
//		else if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.TOP_RESIZE || this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.BOTTOM_RESIZE) {
//
//			var iInitialRowSpan = this.oStartCellRef.rowSpan;
//
//			if (this.iRowSpanDelta != 0) {
//				// add/remove cells
//				if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.BOTTOM_RESIZE) {
//					if (this.iRowSpanDelta > 0) {
//						for (var j = 0; j < this.aSiblingRootRef.length; j++) {
//							//remove cells
//							UCF_DomUtil.removeFromDom(this.aSiblingRootRef[j], "TD");
//						}
//					}
//					else if (this.iRowSpanDelta < 0)  {
//						//add cells
//						this.RebuildAfterVResize();
//					}
//
//				}
//				else if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.TOP_RESIZE) {
//					if (this.iRowSpanDelta > 0) {
//						for (var j = 0; j < this.aSiblingRootRef.length; j++) {
//							oSiblingRef = this.aSiblingRootRef[j];
//							oSiblingParentRef = UCF_DomUtil.oGetParentByTagName(oSiblingRef, "TR");
//							//remove/replace cells
//							if (j == (this.aSiblingRootRef.length - 1)) {
//								oSiblingParentRef.replaceChild(this.oStartCellRef, oSiblingRef);
//							}
//							else {
//								UCF_DomUtil.removeFromDom(oSiblingRef, "TD");
//							}
//						}
//					}
//					else if (this.iRowSpanDelta < 0)  {
//						//add cells
//						this.RebuildAfterVResize();
//					}
//				}
//			}
//			// set rowSpan
//			this.oStartCellRef.rowSpan = iInitialRowSpan + this.iRowSpanDelta;
//
//			if (iInitialRowSpan != this.oStartCellRef.rowSpan) {
//				// fire semantic Event
//				this.fireCellResize(this.sId, this.oStartCellRef.id, this.iRowSpanDelta, this.sDragAndResizeMode);
//			}
//		}
//
//		if (UCF_System.bUseAnimation){
//			var oAnimation = new UCF_Animation(this.oDRGhost, 300);
//			oAnimation.addInitialOpacityValue(100);
//			oAnimation.addOpacityChange(100, 20, oAnimation.M_TRANSITIONS.EaseIn);
//			oAnimation.callbackFinish(this,"destroyDecoration");
//			oAnimation.play();
//		}
//		else {
//			this.destroyDecoration();
//		}
//	}
//
//};

//UCF_FluidLayout.prototype.RebuildAfterHResize = function() {
//
//	var oSiblingRef = null;
//	var oSiblingParentRef = null;
//	var iCurrentYIndex = 0;
//	var iXPos = (this.oRect.left + this.oRect.width + (this.iGetColWidth()/2));
//	var oStartControl = this.oLS.oGetControlByDomRef(this.oStartCellRef);
//	this.aSiblingInsertRef = new Array();
//	this.aSiblingAppendRef = new Array();
//
//	for (var j = 1; j < this.oStartCellRef.rowSpan; j++) {
//		iXPos = (this.oRect.left + this.oRect.width + (this.iGetColWidth()/2));
//		oSiblingRef = null;
//		while (iXPos < (this.oFLLRect.left + this.oFLLRect.width)) {
//			oInnerSiblingRef = UCF_DomUtil.oGetElementFromPoint(iXPos, (this.oRect.top + (this.iGetRowHeight()/2) + (j * this.iGetRowHeight())));
//			oSiblingRef = UCF_DomUtil.oGetParentByAttribute(oInnerSiblingRef, "ct", "FLCL");
//			oSiblingControl = this.oLS.oGetControlByDomRef(oSiblingRef);
//			if (oSiblingControl.oGetCoordinates().y == (oStartControl.oGetCoordinates().y + j)) {
//				if (oSiblingRef) this.aSiblingInsertRef.push(oSiblingRef);
//				break;
//			}
//			else oSiblingRef = null;
//			iXPos = iXPos + this.oRect.width;
//		}
//		if (!oSiblingRef) {
//			iXPos = (this.oRect.left - (this.iGetColWidth()/2));
//			while (iXPos > this.oFLLRect.left) {
//				oInnerSiblingRef = UCF_DomUtil.oGetElementFromPoint(iXPos, (this.oRect.top + (this.iGetRowHeight()/2) + (j * this.iGetRowHeight())));
//				oSiblingRef = UCF_DomUtil.oGetParentByAttribute(oInnerSiblingRef, "ct", "FLCL");
//				oSiblingControl = this.oLS.oGetControlByDomRef(oSiblingRef);
//				if (oSiblingControl.oGetCoordinates().y == (oStartControl.oGetCoordinates().y + j)) {
//					if (oSiblingRef) this.aSiblingAppendRef.push(oSiblingRef);
//					break;
//				}
//				else oSiblingRef = null;
//				iXPos = iXPos - this.oRect.width;
//			}
//		}
//		if (!oSiblingRef) {
//			//append row
//		}
//	}
//
//	for (var k = 0; k < this.aSiblingInsertRef.length; k++) {
//		oSiblingParentRef = UCF_DomUtil.oGetParentByTagName(this.aSiblingInsertRef[k], "TR");
//		iCurrentYIndex = this.oLS.oGetControlByDomRef(this.aSiblingInsertRef[k]).oGetCoordinates().y;
//		for (var i = 0; i < Math.abs(this.iColSpanDelta); i++) {
//			oTdRef = document.createElement("TD");
//			oTdRef.setAttribute("id", this.sId + "_FlCell_" + this.iIdCounter);
//			this.iIdCounter++;
//			oTdRef.setAttribute("ct", "FLCL");
//			UCF_DomUtil.addClass(oTdRef, "urFLCell");
//			UCF_DomUtil.addClass(oTdRef, "urFLCellWdt");
//			if (iCurrentYIndex == this.iMaxRowIndex) UCF_DomUtil.addClass(oTdRef, "urFLCellBrdBottom");
//			this.oControlFactory.oCreateControlByDomRef(oTdRef);
//			oSiblingParentRef.insertBefore(oTdRef, this.aSiblingInsertRef[k]);
//		}
//	}
//
//	for (var l = 0; l < this.aSiblingAppendRef.length; l++) {
//		oSiblingParentRef = UCF_DomUtil.oGetParentByTagName(this.aSiblingAppendRef[l], "TR");
//		iCurrentYIndex = this.oLS.oGetControlByDomRef(this.aSiblingAppendRef[l]).oGetCoordinates().y;
//		for (var i = 0; i < Math.abs(this.iColSpanDelta); i++) {
//			oTdRef = document.createElement("TD");
//			oTdRef.setAttribute("id", this.sId + "_FlCell_" + this.iIdCounter);
//			this.iIdCounter++;
//			oTdRef.setAttribute("ct", "FLCL");
//			UCF_DomUtil.addClass(oTdRef, "urFLCell");
//			UCF_DomUtil.addClass(oTdRef, "urFLCellWdt");
//			UCF_DomUtil.addClass(oTdRef, "urFLCellBrdRight");
//			if (iCurrentYIndex == this.iMaxRowIndex) UCF_DomUtil.addClass(oTdRef, "urFLCellBrdBottom");
//			this.oControlFactory.oCreateControlByDomRef(oTdRef);
//			oSiblingParentRef.appendChild(oTdRef);
//		}
//	}
//
//	oSiblingParentRef = UCF_DomUtil.oGetParentByTagName(this.oStartCellRef, "TR");
//	iCurrentYIndex = this.oLS.oGetControlByDomRef(this.oStartCellRef).oGetCoordinates().y;
//	for (var i = 0; i < Math.abs(this.iColSpanDelta); i++) {
//		oTdRef = document.createElement("TD");
//		oTdRef.setAttribute("id", this.sId + "_FlCell_" + this.iIdCounter);
//		this.iIdCounter++;
//		oTdRef.setAttribute("ct", "FLCL");
//		UCF_DomUtil.addClass(oTdRef, "urFLCell");
//		UCF_DomUtil.addClass(oTdRef, "urFLCellWdt");
//		if (iCurrentYIndex == this.iMaxRowIndex) UCF_DomUtil.addClass(oTdRef, "urFLCellBrdBottom");
//		this.oControlFactory.oCreateControlByDomRef(oTdRef);
//		if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.BEGIN_RESIZE)	oSiblingParentRef.insertBefore(oTdRef, this.oStartCellRef);
//		else if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.END_RESIZE) {
//			if (UCF_DomUtil.nextSibling(this.oStartCellRef, "TD")) oSiblingParentRef.insertBefore(oTdRef, UCF_DomUtil.nextSibling(this.oStartCellRef, "TD"));
//			else {
//				UCF_DomUtil.addClass(oTdRef, "urFLCellBrdRight");
//				oSiblingParentRef.appendChild(oTdRef);
//			}
//		}
//	}
//
//};
//
//UCF_FluidLayout.prototype.RebuildAfterVResize = function() {
//
//	var oSiblingRef = null;
//	var oSiblingParentRef = null;
//	var oSiblingReplaceInsertRef = null;
//	var oSiblingReplaceAppendRef = null;
//	var iXPos = (this.oRect.left + this.oRect.width + (this.iGetColWidth()/2));
//	var iYPos = 0;
//	var iCurrentYCoordinate = 0;
//	var oStartControl = this.oLS.oGetControlByDomRef(this.oStartCellRef);
//	this.aSiblingInsertRef = new Array();
//	this.aSiblingAppendRef = new Array();
//
//	for (var j = 0; j <  Math.abs(this.iRowSpanDelta); j++) {
//		iXPos = (this.oRect.left + this.oRect.width + (this.iGetColWidth()/2));
//		oSiblingRef = null;
//		if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.TOP_RESIZE) {
//			iYPos = (this.oRect.top + (this.iGetRowHeight()/2) + (j * this.iGetRowHeight()));
//			iCurrentYCoordinate = (oStartControl.oGetCoordinates().y + j)
//		}
//		else if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.BOTTOM_RESIZE) {
//			iYPos = (this.oRect.top - (this.iGetRowHeight()/2) + ((this.oStartCellRef.rowSpan * this.iGetRowHeight()) - (j * this.iGetRowHeight())));
//			iCurrentYCoordinate = (oStartControl.oGetCoordinates().y + this.oStartCellRef.rowSpan - 1 - j);
//		}
//		while (iXPos < (this.oFLLRect.left + this.oFLLRect.width)) {
//			oInnerSiblingRef = UCF_DomUtil.oGetElementFromPoint(iXPos, iYPos);
//			oSiblingRef = UCF_DomUtil.oGetParentByAttribute(oInnerSiblingRef, "ct", "FLCL");
//			oSiblingControl = this.oLS.oGetControlByDomRef(oSiblingRef);
//			if (oSiblingControl.oGetCoordinates().y == iCurrentYCoordinate) {
//				if (oSiblingRef) this.aSiblingInsertRef.push(oSiblingRef);
//				break;
//			}
//			else oSiblingRef = null;
//			iXPos = iXPos + this.oRect.width;
//		}
//		if (!oSiblingRef) {
//			iXPos = (this.oRect.left - (this.iGetColWidth()/2));
//			while (iXPos > this.oFLLRect.left) {
//				oInnerSiblingRef = UCF_DomUtil.oGetElementFromPoint(iXPos, iYPos);
//				oSiblingRef = UCF_DomUtil.oGetParentByAttribute(oInnerSiblingRef, "ct", "FLCL");
//				oSiblingControl = this.oLS.oGetControlByDomRef(oSiblingRef);
//				if (oSiblingControl.oGetCoordinates().y == iCurrentYCoordinate) {
//					if (oSiblingRef) this.aSiblingAppendRef.push(oSiblingRef);
//					break;
//				}
//				else oSiblingRef = null;
//				iXPos = iXPos - this.oRect.width;
//			}
//		}
//		if (!oSiblingRef) {
//			//TODO append row
//		}
//	}
//
//	if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.TOP_RESIZE) {
//		oSiblingRef = null;
//		oSiblingParentRef = null;
//		iXPos = (this.oRect.left + this.oRect.width + (this.iGetColWidth()/2));
//		iYPos = (this.oRect.top + (this.iGetRowHeight()/2) + (Math.abs(this.iRowSpanDelta) * this.iGetRowHeight()));
//		iCurrentYCoordinate = (oStartControl.oGetCoordinates().y + Math.abs(this.iRowSpanDelta));
//
//		while (iXPos < (this.oFLLRect.left + this.oFLLRect.width)) {
//			oInnerSiblingRef = UCF_DomUtil.oGetElementFromPoint(iXPos, iYPos);
//			oSiblingRef = UCF_DomUtil.oGetParentByAttribute(oInnerSiblingRef, "ct", "FLCL");
//			oSiblingControl = this.oLS.oGetControlByDomRef(oSiblingRef);
//			if (oSiblingControl.oGetCoordinates().y == iCurrentYCoordinate) {
//				if (oSiblingRef) oSiblingReplaceInsertRef = oSiblingRef;
//				break;
//			}
//			else oSiblingRef = null;
//			iXPos = iXPos + this.oRect.width;
//		}
//		if (!oSiblingRef) {
//			iXPos = (this.oRect.left - (this.iGetColWidth()/2));
//			while (iXPos > this.oFLLRect.left) {
//				oInnerSiblingRef = UCF_DomUtil.oGetElementFromPoint(iXPos, iYPos);
//				oSiblingRef = UCF_DomUtil.oGetParentByAttribute(oInnerSiblingRef, "ct", "FLCL");
//				oSiblingControl = this.oLS.oGetControlByDomRef(oSiblingRef);
//				if (oSiblingControl.oGetCoordinates().y == iCurrentYCoordinate) {
//					if (oSiblingRef) oSiblingReplaceAppendRef = oSiblingRef;
//					break;
//				}
//				else oSiblingRef = null;
//				iXPos = iXPos - this.oRect.width;
//			}
//		}
//		if (!oSiblingRef) {
//			//TODO append row
//		}
//	}
//
//	for (var k = 0; k < this.aSiblingInsertRef.length; k++) {
//		oSiblingParentRef = UCF_DomUtil.oGetParentByTagName(this.aSiblingInsertRef[k], "TR");
//		iCurrentYIndex = this.oLS.oGetControlByDomRef(this.aSiblingInsertRef[k]).oGetCoordinates().y;
//		for (var i = 0; i < this.oStartCellRef.colSpan; i++) {
//			oTdRef = document.createElement("TD");
//			oTdRef.setAttribute("id", this.sId + "_FlCell_" + this.iIdCounter);
//			this.iIdCounter++;
//			oTdRef.setAttribute("ct", "FLCL");
//			UCF_DomUtil.addClass(oTdRef, "urFLCell");
//			UCF_DomUtil.addClass(oTdRef, "urFLCellWdt");
//			if (iCurrentYIndex == this.iMaxRowIndex) UCF_DomUtil.addClass(oTdRef, "urFLCellBrdBottom");
//			this.oControlFactory.oCreateControlByDomRef(oTdRef);
//			oSiblingParentRef.insertBefore(oTdRef, this.aSiblingInsertRef[k]);
//		}
//	}
//
//	for (var l = 0; l < this.aSiblingAppendRef.length; l++) {
//		oSiblingParentRef = UCF_DomUtil.oGetParentByTagName(this.aSiblingAppendRef[l], "TR");
//		iCurrentYIndex = this.oLS.oGetControlByDomRef(this.aSiblingAppendRef[l]).oGetCoordinates().y;
//		for (var i = 0; i < this.oStartCellRef.colSpan; i++) {
//			oTdRef = document.createElement("TD");
//			oTdRef.setAttribute("id", this.sId + "_FlCell_" + this.iIdCounter);
//			this.iIdCounter++;
//			oTdRef.setAttribute("ct", "FLCL");
//			UCF_DomUtil.addClass(oTdRef, "urFLCell");
//			UCF_DomUtil.addClass(oTdRef, "urFLCellWdt");
//			UCF_DomUtil.addClass(oTdRef, "urFLCellBrdRight");
//			if (iCurrentYIndex == this.iMaxRowIndex) UCF_DomUtil.addClass(oTdRef, "urFLCellBrdBottom");
//			this.oControlFactory.oCreateControlByDomRef(oTdRef);
//			oSiblingParentRef.appendChild(oTdRef);
//		}
//	}
//
//	if (this.sDragAndResizeMode == UCF_FluidLayoutCell.eDragAndResizeMode.TOP_RESIZE) {
//		iCurrentYIndex = this.oLS.oGetControlByDomRef(this.oStartCellRef).oGetCoordinates().y;
//		if (iCurrentYIndex == this.iMaxRowIndex) UCF_DomUtil.addClass(this.oStartCellRef, "urFLCellBrdBottom");
//
//		if (oSiblingReplaceAppendRef) {
//			oSiblingParentRef = UCF_DomUtil.oGetParentByTagName(oSiblingReplaceAppendRef, "TR");
//			oSiblingParentRef.appendChild(this.oStartCellRef);
//		}
//		else if (oSiblingReplaceInsertRef) {
//			oSiblingParentRef = UCF_DomUtil.oGetParentByTagName(oSiblingReplaceInsertRef, "TR");
//			oSiblingParentRef.insertBefore(this.oStartCellRef, oSiblingReplaceInsertRef);
//		}
//	}
//
//};
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_FluidLayout["prototype"]["aAttributeNames"] = ["sColumnWidth","iColumnCount","sVisibility","sDragSourceInfo","sDropTargetInfo","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_FluidLayout["prototype"]["aEventNames"] = ["Drop","CellResize"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_FluidLayout["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_FluidLayout["prototype"]["sColumnWidth"] = '70';

/**
 * @private
 * @type {number}
 */
UCF_FluidLayout["prototype"]["iColumnCount"] = 5;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_FluidLayout["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_FluidLayout["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_FluidLayout["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_FluidLayout["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_FluidLayout["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["setDefaultValues"]++; }; 
	this["sColumnWidth"] = '70';
	this["iColumnCount"] = 5;
	this["sVisibility"] = "VISIBLE";
	this["sDragSourceInfo"] = '';
	this["sDropTargetInfo"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("ColumnWidth", '70', true);
		this["setClientProperty"]("ColumnCount", 5, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {number} iRowIndex The row index of the table row where the drop occured
 * @param {number} iRowOffset The Offset relative to the table row where the drop occured (signum)
 * @param {number} iColIndex The col index of the table row where the drop occured
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {string} sCellId The id of the cell the user dropped on
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires FluidLayout::Drop
 */
UCF_FluidLayout["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, iRowIndex, iRowOffset, iColIndex, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sCellId, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, RowIndex: number, RowOffset: number, ColIndex: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, CellId: string, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 14, "arguments.length == 14", "FluidLayout.js(1350): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "FluidLayout.js(1351): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "FluidLayout.js(1352): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "FluidLayout.js(1353): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "FluidLayout.js(1354): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "FluidLayout.js(1355): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "FluidLayout.js(1356): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "FluidLayout.js(1357): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "FluidLayout.js(1358): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowOffset != null, "iRowOffset != null", "FluidLayout.js(1359): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowOffset) == "number", "typeof(iRowOffset) == \"number\"", "FluidLayout.js(1360): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "FluidLayout.js(1361): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "FluidLayout.js(1362): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "FluidLayout.js(1363): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "FluidLayout.js(1364): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "FluidLayout.js(1365): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "FluidLayout.js(1366): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "FluidLayout.js(1367): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "FluidLayout.js(1368): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "FluidLayout.js(1369): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "FluidLayout.js(1370): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "FluidLayout.js(1371): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "FluidLayout.js(1372): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "FluidLayout.js(1373): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "FluidLayout.js(1374): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "FluidLayout.js(1375): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "FluidLayout.js(1376): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "FluidLayout.js(1377): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "FluidLayout.js(1378): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"RowIndex": iRowIndex,
		"RowOffset": iRowOffset,
		"ColIndex": iColIndex,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"CellId": sCellId,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("FluidLayout", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sCellId The id of the cell that has been resized
 * @param {number} iResizeDelta The colSpan/rowSpan delta of the cell during resize
 * @param {UCF_ClientInterfaces.E.FluidResizeHandlePos} sResizeHandlePos The position of the cell resize handle. For possible values see enum FluidResizeHandlePos
 * @fires FluidLayout::CellResize
 */
UCF_FluidLayout["prototype"]["fireCellResize"] = function(sId, sCellId, iResizeDelta, sResizeHandlePos) {;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["fireCellResize"]++; }; 
	/** @type {{Id: string, CellId: string, ResizeDelta: number, ResizeHandlePos: UCF_ClientInterfaces.E.FluidResizeHandlePos}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "FluidLayout.js(1426): fireCellResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "FluidLayout.js(1427): fireCellResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "FluidLayout.js(1428): fireCellResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "FluidLayout.js(1429): fireCellResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "FluidLayout.js(1430): fireCellResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iResizeDelta != null, "iResizeDelta != null", "FluidLayout.js(1431): fireCellResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iResizeDelta) == "number", "typeof(iResizeDelta) == \"number\"", "FluidLayout.js(1432): fireCellResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sResizeHandlePos != null, "sResizeHandlePos != null", "FluidLayout.js(1433): fireCellResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sResizeHandlePos) == "string", "typeof(sResizeHandlePos) == \"string\"", "FluidLayout.js(1434): fireCellResize"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"ResizeDelta": iResizeDelta,
		"ResizeHandlePos": sResizeHandlePos
	};
	
	if (sCellId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sCellId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "CellId");
			}
		}
	
	
	this["fireSemanticEvent"]("FluidLayout", "CellResize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_FluidLayout["_"]["fireCellResize"] = 0; };

};
sap["ls"]["preload"]["UCF_FluidLayoutCell"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_FluidLayoutCell(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["UCF_FluidLayoutCell"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "FluidLayoutCell.js(27): UCF_FluidLayoutCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "FluidLayoutCell.js(28): UCF_FluidLayoutCell"); };
	UCF_Control["apply"](this, arguments);

	this["sDragAndResizeMode"] = UCF_FluidLayoutCell["eDragAndResizeMode"]["NONE"];
	this["iYCoordinate"] = Number["NaN"];
	this["iRowHeight"] = Number["NaN"];
	this["iColWidth"] = Number["NaN"];
	this["oRect"] = null;
	this["oFLLRect"] = null;
	this["oScrollOffset"] = null;

	this["attachBrowserEvent"]("mousemove", this["oDomRef"]);

	if (this["bRangeSelectionStartMarker"]) this["oGetFluidLayoutContainer"]()["setRangeSelectionStartMarkerCell"](this);
	if (this["bRangeSelectionEndMarker"]) this["oGetFluidLayoutContainer"]()["setRangeSelectionEndMarkerCell"](this);

	this["attachContentListening"]();

};window["UCF_FluidLayoutCell"] = UCF_FluidLayoutCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FluidLayoutCell"); UCF_FluidLayoutCell["_"] = {UCF_FluidLayoutCell: 0}; }; ;

UCF_FluidLayoutCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_FluidLayoutCell.prototype["sClassName"] = "UCF_FluidLayoutCell";

UCF_FluidLayoutCell["eSelectionState"] = {
	"SELECTABLE": "SELECTABLE",
	"SELECTED": "SELECTED",
	"UNSELECTABLE": "UNSELECTABLE"
};

UCF_FluidLayoutCell["eDragAndResizeMode"] = {
	"NONE": "NONE",
	"TOP_RESIZE": "TOP",
	"BOTTOM_RESIZE": "BOTTOM",
	"BEGIN_RESIZE": "BEGIN",
	"END_RESIZE": "END"
};

UCF_FluidLayoutCell["iHResizeRange"] = 10;

UCF_FluidLayoutCell["iVResizeRange"] = 10;

UCF_FluidLayoutCell["prototype"]["oGetFluidLayoutContainer"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetFluidLayoutContainer"]++; }; 

	if (this["oFluidLayoutContainer"]) return this["oFluidLayoutContainer"];

	var oFLCRef = UCF_DomUtil["oGetParentByAttribute"](this["oDomRef"], "ct", "FLCO");

	return this["oFluidLayoutContainer"] = this["oLS"]["oControlFactory"]["oGetControlById"](oFLCRef["id"]);

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetFluidLayoutContainer"] = 0; };

UCF_FluidLayoutCell["prototype"]["oGetFluidLayout"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetFluidLayout"]++; }; 

	if (this["oFluidLayout"]) return this["oFluidLayout"];

	var oFLRef = UCF_DomUtil["oGetParentByAttribute"](this["oDomRef"], "ct", "FLL");

	return this["oFluidLayout"] = this["oLS"]["oControlFactory"]["oGetControlById"](oFLRef["id"]);

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetFluidLayout"] = 0; };

UCF_FluidLayoutCell["prototype"]["bGetResizeableTop"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableTop"]++; }; 

	var iXPos = this["oRect"]["left"] - this["oScrollOffset"]["x"];
	var iYPos = oBrowserEvent["_iClientY"] + this["oScrollOffset"]["y"];

	if (this["oDomRef"]["rowSpan"] > 1) return true;
	if ((iYPos - (UCF_FluidLayoutCell["iVResizeRange"] + 1)) <= (this["oFLLRect"]["top"] + this["iRowHeight"])) return false;
	var bResizeable = true;
	var oSiblingRef = null;
	for (var i = 0; i < this["oDomRef"]["colSpan"]; i++) {
		oSiblingRef = UCF_DomUtil["oGetElementFromPoint"]((iXPos + (this["iColWidth"] / 2) + (i * this["iColWidth"])), (oBrowserEvent["_iClientY"] - UCF_FluidLayoutCell["iVResizeRange"]));
		if ((!oSiblingRef) || (!this["oGetFluidLayout"]()["bIsEmptyFLCell"](oSiblingRef))) {
			bResizeable = false;
			break;
		}
	}
	return bResizeable;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableTop"] = 0; };

UCF_FluidLayoutCell["prototype"]["bGetResizeableBottom"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableBottom"]++; }; 

	var iXPos = this["oRect"]["left"] - this["oScrollOffset"]["x"];
	var iYPos = oBrowserEvent["_iClientY"] + this["oScrollOffset"]["y"];

	if (this["oDomRef"]["rowSpan"] > 1) return true;
	if ((iYPos + (UCF_FluidLayoutCell["iVResizeRange"] + 1)) >= (this["oFLLRect"]["top"] + this["oFLLRect"]["height"])) return false;
	var bResizeable = true;
	var oSiblingRef = null;
	for (var i = 0; i < this["oDomRef"]["colSpan"]; i++) {
		oSiblingRef = UCF_DomUtil["oGetElementFromPoint"]((iXPos + (this["iColWidth"] / 2) + (i * this["iColWidth"])), (oBrowserEvent["_iClientY"] + UCF_FluidLayoutCell["iVResizeRange"]));
		if ((!oSiblingRef) || (!this["oGetFluidLayout"]()["bIsEmptyFLCell"](oSiblingRef))) {
			bResizeable = false;
			break;
		}
	}
	return bResizeable;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableBottom"] = 0; };

UCF_FluidLayoutCell["prototype"]["bGetResizeableRight"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableRight"]++; }; 

	var iXPos = oBrowserEvent["_iClientX"] + this["oScrollOffset"]["x"];
	var iYPos = this["oRect"]["top"] - this["oScrollOffset"]["y"];

	if (this["oDomRef"]["colSpan"] > 1) return true;
	if ((iXPos + (UCF_FluidLayoutCell["iHResizeRange"] + 1)) >= (this["oFLLRect"]["left"] + this["oFLLRect"]["width"])) return false;
	var bResizeable = true;
	var oSiblingRef = null;
	for (var i = 0; i < this["oDomRef"]["rowSpan"]; i++) {
		oSiblingRef = UCF_DomUtil["oGetElementFromPoint"]((oBrowserEvent["_iClientX"] + UCF_FluidLayoutCell["iHResizeRange"]), (iYPos + (this["iRowHeight"] / 2) + (i * this["iRowHeight"])));
		if ((!oSiblingRef) || (!this["oGetFluidLayout"]()["bIsEmptyFLCell"](oSiblingRef))) {
			bResizeable = false;
			break;
		}
	}
	return bResizeable;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableRight"] = 0; };

UCF_FluidLayoutCell["prototype"]["bGetResizeableLeft"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableLeft"]++; }; 

	var iXPos = oBrowserEvent["_iClientX"] + this["oScrollOffset"]["x"];
	var iYPos = this["oRect"]["top"] - this["oScrollOffset"]["y"];

	if (this["oDomRef"]["colSpan"] > 1) return true;
	if ((iXPos - (UCF_FluidLayoutCell["iHResizeRange"] + 1)) <= this["oFLLRect"]["left"]) return false;
	var bResizeable = true;
	var oSiblingRef = null;
	for (var i = 0; i < this["oDomRef"]["rowSpan"]; i++) {
		oSiblingRef = UCF_DomUtil["oGetElementFromPoint"]((oBrowserEvent["_iClientX"] - UCF_FluidLayoutCell["iHResizeRange"]), (iYPos + (this["iRowHeight"] / 2) + (i * this["iRowHeight"])));
		if ((!oSiblingRef) || (!this["oGetFluidLayout"]()["bIsEmptyFLCell"](oSiblingRef))) {
			bResizeable = false;
			break;
		}
	}
	return bResizeable;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableLeft"] = 0; };

UCF_FluidLayoutCell["prototype"]["bGetResizeableBegin"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableBegin"]++; }; 

	if (window["UCF_System"]["bIsRTL"]) return this["bGetResizeableRight"](oBrowserEvent);
	else return this["bGetResizeableLeft"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableBegin"] = 0; };

UCF_FluidLayoutCell["prototype"]["bGetResizeableEnd"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableEnd"]++; }; 

	if (window["UCF_System"]["bIsRTL"]) return this["bGetResizeableLeft"](oBrowserEvent);
	else return this["bGetResizeableRight"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bGetResizeableEnd"] = 0; };

UCF_FluidLayoutCell["prototype"]["bIsResizeAreaTop"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaTop"]++; }; 

	var iYPos = oBrowserEvent["_iClientY"] + this["oScrollOffset"]["y"];
	return (iYPos < (this["oRect"]["top"] + UCF_FluidLayoutCell["iVResizeRange"]));

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaTop"] = 0; };

UCF_FluidLayoutCell["prototype"]["bIsResizeAreaBottom"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaBottom"]++; }; 

	var iYPos = oBrowserEvent["_iClientY"] + this["oScrollOffset"]["y"];
	return (iYPos > (this["oRect"]["top"] + this["oRect"]["height"] - UCF_FluidLayoutCell["iVResizeRange"]));

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaBottom"] = 0; };

UCF_FluidLayoutCell["prototype"]["bIsResizeAreaRight"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaRight"]++; }; 

	var iXPos = oBrowserEvent["_iClientX"] + this["oScrollOffset"]["x"];
	return (iXPos > (this["oRect"]["left"] + this["oRect"]["width"] - UCF_FluidLayoutCell["iHResizeRange"]));

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaRight"] = 0; };

UCF_FluidLayoutCell["prototype"]["bIsResizeAreaLeft"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaLeft"]++; }; 

	var iXPos = oBrowserEvent["_iClientX"] + this["oScrollOffset"]["x"];
	return (iXPos < (this["oRect"]["left"] + UCF_FluidLayoutCell["iHResizeRange"]));

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaLeft"] = 0; };

UCF_FluidLayoutCell["prototype"]["bIsResizeAreaBegin"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaBegin"]++; }; 

	if (window["UCF_System"]["bIsRTL"]) return this["bIsResizeAreaRight"](oBrowserEvent);
	else return this["bIsResizeAreaLeft"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaBegin"] = 0; };

UCF_FluidLayoutCell["prototype"]["bIsResizeAreaEnd"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaEnd"]++; }; 

	if (window["UCF_System"]["bIsRTL"]) return this["bIsResizeAreaLeft"](oBrowserEvent);
	else return this["bIsResizeAreaRight"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsResizeAreaEnd"] = 0; };

UCF_FluidLayoutCell["prototype"]["onmousedown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onmousedown"]++; }; 
	//only process left mouse down
	if (oBrowserEvent["eGetMouseButtonState"]() !== oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"]) return;

	this["oGetFluidLayoutContainer"]()["handleMouseDownOnCell"](this, oBrowserEvent["bCtrl"](), oBrowserEvent["bShift"]());

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onmousedown"] = 0; };

UCF_FluidLayoutCell["prototype"]["onmouseup"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onmouseup"]++; }; 
	//only process left mouse up
	if (oBrowserEvent["eGetMouseButtonState"]() !== oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"]) return;

	this["oGetFluidLayoutContainer"]()["handleMouseUpOnCell"](this, oBrowserEvent["bCtrl"](), oBrowserEvent["bShift"]());

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onmouseup"] = 0; };

UCF_FluidLayoutCell["prototype"]["onmouseover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onmouseover"]++; }; 

	var aAssociatedCells = this["aGetAssociatedCells"]();

	if (this["sSelectionState"] === UCF_FluidLayoutCell["eSelectionState"]["SELECTABLE"]) {
		UCF_DomUtil["addClass"](this["oDomRef"], "urFLCellHover");
	}

	for (var x = 0, iNumCells = aAssociatedCells["length"]; x < iNumCells; x++) {
		if (aAssociatedCells[x]["sSelectionState"] === UCF_FluidLayoutCell["eSelectionState"]["SELECTABLE"]) {
			UCF_DomUtil["addClass"](aAssociatedCells[x]["oDomRef"], "urFLCellHover");
		}
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onmouseover"] = 0; };

UCF_FluidLayoutCell["prototype"]["onmouseout"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onmouseout"]++; }; 

	var aAssociatedCells = this["aGetAssociatedCells"]();

	UCF_DomUtil["removeClass"](this["oDomRef"], "urFLCellHover");

	for (var x = 0, iNumCells = aAssociatedCells["length"]; x < iNumCells; x++) {
		UCF_DomUtil["removeClass"](aAssociatedCells[x]["oDomRef"], "urFLCellHover");
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onmouseout"] = 0; };

UCF_FluidLayoutCell["prototype"]["onmousemove"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onmousemove"]++; }; 

	this["oScrollOffset"] = UCF_DomUtil["oGetScrollOffset"](window);

	if (isNaN(this["iYCoordinate"])) this["iYCoordinate"] = this["oGetCoordinates"]()["y"];
	//	if (!this.oRect) this.oRect = UCF_DomUtil.oGetObjectRect(this.oDomRef);
	this["oRect"] = UCF_DomUtil["oGetViewPort"](this["oDomRef"]);
	//	if (!this.oFLLRect) this.oFLLRect = UCF_DomUtil.oGetObjectRect(UCF_DomUtil.oGetParentByAttribute(this.oDomRef, "ct", "FLL"));
	this["oFLLRect"] = UCF_DomUtil["oGetViewPort"](UCF_DomUtil["oGetParentByAttribute"](this["oDomRef"], "ct", "FLL"));
	this["iRowHeight"] = this["oGetFluidLayout"]()["iGetRowHeight"]();
	this["iColWidth"] = this["oGetFluidLayout"]()["iGetColWidth"]();

	if (this["iYCoordinate"] !== 0) {
		//		this.oRect = UCF_DomUtil.oGetObjectRect(this.oDomRef);
		this["oRect"] = UCF_DomUtil["oGetViewPort"](this["oDomRef"]);
		if (this["bResizeableBegin"] && this["bIsResizeAreaBegin"](oBrowserEvent) && this["bGetResizeableBegin"](oBrowserEvent)) {
			this["oDomRef"]["style"]["cursor"] = "col-resize";
			this["sDragAndResizeMode"] = UCF_FluidLayoutCell["eDragAndResizeMode"]["BEGIN_RESIZE"];
		} else if (this["bResizeableEnd"] && this["bIsResizeAreaEnd"](oBrowserEvent) && this["bGetResizeableEnd"](oBrowserEvent)) {
			this["oDomRef"]["style"]["cursor"] = "col-resize";
			this["sDragAndResizeMode"] = UCF_FluidLayoutCell["eDragAndResizeMode"]["END_RESIZE"];
		} else if (this["bResizeableTop"] && this["bIsResizeAreaTop"](oBrowserEvent) && this["bGetResizeableTop"](oBrowserEvent)) {
			this["oDomRef"]["style"]["cursor"] = "row-resize";
			this["sDragAndResizeMode"] = UCF_FluidLayoutCell["eDragAndResizeMode"]["TOP_RESIZE"];
		} else if (this["bResizeableBottom"] && this["bIsResizeAreaBottom"](oBrowserEvent) && this["bGetResizeableBottom"](oBrowserEvent)) {
			this["oDomRef"]["style"]["cursor"] = "row-resize";
			this["sDragAndResizeMode"] = UCF_FluidLayoutCell["eDragAndResizeMode"]["BOTTOM_RESIZE"];
		} else {
			this["oDomRef"]["style"]["cursor"] = "auto";
			this["sDragAndResizeMode"] = UCF_FluidLayoutCell["eDragAndResizeMode"]["NONE"];
		}
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onmousemove"] = 0; };

UCF_FluidLayoutCell["prototype"]["onkeydown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onkeydown"]++; }; 

	var iKeyCode = oBrowserEvent["iKeyCode"](),
		bHandled = false;

	if (oBrowserEvent["bShift"]() &&
		this["bIsSelected"]() &&
		((iKeyCode === UCF_KeyCodes["ARROW_LEFT"]) ||
			(iKeyCode === UCF_KeyCodes["ARROW_RIGHT"]) ||
			(iKeyCode === UCF_KeyCodes["ARROW_UP"]) ||
			(iKeyCode === UCF_KeyCodes["ARROW_DOWN"]))) {
		bHandled = this["oGetFluidLayoutContainer"]()["bHandleKeyDownOnCell"](this, oBrowserEvent["bCtrl"](), oBrowserEvent["bShift"](), iKeyCode);
		if (bHandled) oBrowserEvent["cancel"]();
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onkeydown"] = 0; };

UCF_FluidLayoutCell["prototype"]["bIsDragAndResizeMode"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsDragAndResizeMode"]++; }; 

	if (this["sDragAndResizeMode"] === UCF_FluidLayoutCell["eDragAndResizeMode"]["NONE"]) return false;
	else return true;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsDragAndResizeMode"] = 0; };

UCF_FluidLayoutCell["prototype"]["sGetDragAndResizeMode"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["sGetDragAndResizeMode"]++; }; 

	return this["sDragAndResizeMode"];

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["sGetDragAndResizeMode"] = 0; };

UCF_FluidLayoutCell["prototype"]["toggleSelection"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["toggleSelection"]++; }; 

	if (this["sSelectionState"] === UCF_FluidLayoutCell["eSelectionState"]["SELECTABLE"]) {
		this["select"]();
	} else if (this["sSelectionState"] === UCF_FluidLayoutCell["eSelectionState"]["SELECTED"]) {
		this["deselect"]();
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["toggleSelection"] = 0; };

UCF_FluidLayoutCell["prototype"]["select"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["select"]++; }; 
	if (this["sSelectionState"] === UCF_FluidLayoutCell["eSelectionState"]["SELECTABLE"]
		|| this["sSelectionState"] === UCF_FluidLayoutCell["eSelectionState"]["SELECTED"]) {

		if (!this["bIsSelected"]()) this["oGetFluidLayoutContainer"]()["addToggledCell"](this);

		this["sSelectionState"] = UCF_FluidLayoutCell["eSelectionState"]["SELECTED"];
		this["setClientProperty"]("SelectionState", this["sSelectionState"], true);
		UCF_DomUtil["addClass"](this["oDomRef"], "urFLCellSel");

	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["select"] = 0; };
UCF_FluidLayoutCell["prototype"]["bIsSelected"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsSelected"]++; }; 

	return this["sSelectionState"] === UCF_FluidLayoutCell["eSelectionState"]["SELECTED"];

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["bIsSelected"] = 0; };

UCF_FluidLayoutCell["prototype"]["deselect"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["deselect"]++; }; 

	if (this["sSelectionState"] === UCF_FluidLayoutCell["eSelectionState"]["SELECTABLE"]
		|| this["sSelectionState"] === UCF_FluidLayoutCell["eSelectionState"]["SELECTED"]) {

		if (this["bIsSelected"]()) this["oGetFluidLayoutContainer"]()["addToggledCell"](this);

		this["sSelectionState"] = UCF_FluidLayoutCell["eSelectionState"]["SELECTABLE"];
		this["setClientProperty"]("SelectionState", this["sSelectionState"], true);
		UCF_DomUtil["removeClass"](this["oDomRef"], "urFLCellSel");

	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["deselect"] = 0; };

UCF_FluidLayoutCell["prototype"]["oGetGhostHtml"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetGhostHtml"]++; }; 

	var oTableRef = document["createElement"]("TABLE"),
		oRowRef = document["createElement"]("TR");

	oTableRef["className"] = "urFLTbl";
	oTableRef["style"]["width"] = "140px"; //TODO:
	oTableRef["cellPadding"] = 0;
	oTableRef["appendChild"](oRowRef);

	oRowRef["appendChild"](this["oDomRef"]["cloneNode"](true));
	//	for (var x in aCells) {
	//		oRowRef.appendChild(aCells[x].oDomRef.cloneNode(true));
	//	}

	return oTableRef;
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetGhostHtml"] = 0; };

UCF_FluidLayoutCell["prototype"]["aGetAssociatedCells"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["aGetAssociatedCells"]++; }; 

	var aCells = [],
		aIds = this["sAssociatedCellIds"]["split"](" ");
	if (aIds == "") return aCells;

	for (var i = 0; i < aIds["length"]; i++) {
		var oCell = this["oLS"]["oControlFactory"]["oGetControlById"](aIds[i]);
		if (oCell && UCF_JsUtil["bInstanceOf"](oCell, "UCF_FluidLayoutCell")) aCells["push"](oCell);
	}
	return aCells;
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["aGetAssociatedCells"] = 0; };

UCF_FluidLayoutCell["prototype"]["aGetSelectedCells"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["aGetSelectedCells"]++; }; 

	var aCells = [],
		aSelectedCells = [],
		oFluidLayout = this["oGetFluidLayout"](),
		aRows = oFluidLayout["oDomRef"]["rows"];

	for (var y = 0, iNumRows = aRows["length"]; y < iNumRows; y++) {
		aCells = aRows[y]["cells"];
		for (var x = 0, iNumCells = aCells["length"]; x < iNumCells; x++) {
			var oCell = this["oLS"]["oControlFactory"]["oGetControlById"](aCells[x]["id"]);
			if (oCell && UCF_JsUtil["bInstanceOf"](oCell, "UCF_FluidLayoutCell") && oCell["bIsSelected"]()) aSelectedCells["push"](oCell);
		}
	}
	return aSelectedCells;
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["aGetSelectedCells"] = 0; };

UCF_FluidLayoutCell["prototype"]["oGetCoordinates"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetCoordinates"]++; }; 

	var oFluidLayout = this["oGetFluidLayout"](),
		aRows = oFluidLayout["oDomRef"]["rows"];

	for (var y = 0, iNumRows = aRows["length"]; y < iNumRows; y++) {
		var aCells = aRows[y]["cells"];
		for (var x = 0, iNumCells = aCells["length"]; x < iNumCells; x++) {

			if (aCells[x] === this["oDomRef"]) return { "x": x, "y": y };
		}

	}

	return null;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetCoordinates"] = 0; };

UCF_FluidLayoutCell["prototype"]["oGetAbsCoordinates"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetAbsCoordinates"]++; }; 

	var oFluidLayout = this["oGetFluidLayout"](),
		aRows = oFluidLayout["oDomRef"]["rows"],
		oSpanCorr = null,
		aSpanCorr = [];

	for (var y = 0, iNumRows = aRows["length"]; y < iNumRows; y++) {
		var aCells = aRows[y]["cells"];
		var iAbsXCounter = 0;
		for (var x = 0, iNumCells = aCells["length"]; x < iNumCells; x++) {

			for (var i = 0, iNumCorr = aSpanCorr["length"]; i < iNumCorr; i++) {
				oSpanCorr = aSpanCorr[i];
				if ((oSpanCorr["x"] === x) &&
					(oSpanCorr["y"] !== y) &&
					((oSpanCorr["y"] + oSpanCorr["rowSpan"] - 1) >= y)) {
					iAbsXCounter = iAbsXCounter + oSpanCorr["colSpan"];
				}
			}

			if (aCells[x] === this["oDomRef"]) return { "x": iAbsXCounter, "y": y };

			if (aCells[x]["rowSpan"] > 1) {
				oSpanCorr = { "x": iAbsXCounter, "y": y, "colSpan": aCells[x]["colSpan"], "rowSpan": aCells[x]["rowSpan"] };
				aSpanCorr["push"](oSpanCorr);
			}

			iAbsXCounter = iAbsXCounter + aCells[x]["colSpan"];
		}

	}

	return null;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetAbsCoordinates"] = 0; };

UCF_FluidLayoutCell["prototype"]["aGetRangeSelectCells"] = function (bLastRangeSelection) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["aGetRangeSelectCells"]++; }; 

	var aCells = [];
	var aRangeSelectCells = [];
	var oRangeSelectionStartMarkerCell = this["oGetFluidLayoutContainer"]()["oGetRangeSelectionStartMarkerCell"](this);
	if (!oRangeSelectionStartMarkerCell) return aCells;

	var oCoordRangeSelectionStartMarkerCell = oRangeSelectionStartMarkerCell["oGetAbsCoordinates"]();
	var oCoordSelCell = null;
	var oFluidLayout = this["oGetFluidLayout"]();
	var aRows = oFluidLayout["oDomRef"]["rows"];

	if (bLastRangeSelection) {
		var oRangeSelectionEndMarkerCell = this["oGetFluidLayoutContainer"]()["oGetRangeSelectionEndMarkerCell"](this);
		if (!oRangeSelectionEndMarkerCell) return aCells;
		//range selection only for one single fluidlayout at the same time
		if (oRangeSelectionStartMarkerCell["oGetFluidLayout"]() === oRangeSelectionEndMarkerCell["oGetFluidLayout"]()) oCoordSelCell = oRangeSelectionEndMarkerCell["oGetAbsCoordinates"]();
		else return aCells;
	} else {
		//range selection only for one single fluidlayout at the same time
		if (oFluidLayout === oRangeSelectionStartMarkerCell["oGetFluidLayout"]()) oCoordSelCell = this["oGetAbsCoordinates"]();
		else return aCells;
	}

	for (var y = 0; y < aRows["length"]; y++) {
		aCells = aRows[y]["cells"];
		for (var x = 0; x < aCells["length"]; x++) {
			if (aCells[x] && aCells[x]["id"]) {
				var oCell = this["oLS"]["oControlFactory"]["oGetControlById"](aCells[x]["id"]);
				var oAbsCoord = oCell["oGetAbsCoordinates"]();
				if (oCell && UCF_JsUtil["bInstanceOf"](oCell, "UCF_FluidLayoutCell")
					&& ((oAbsCoord["x"] + aCells[x]["colSpan"] - 1) >= Math["min"](oCoordRangeSelectionStartMarkerCell["x"], oCoordSelCell["x"]))
					&& (oAbsCoord["x"] <= Math["max"](oCoordRangeSelectionStartMarkerCell["x"], oCoordSelCell["x"]))
					&& (oAbsCoord["y"] >= Math["min"](oCoordRangeSelectionStartMarkerCell["y"], oCoordSelCell["y"]))
					&& (oAbsCoord["y"] <= Math["max"](oCoordRangeSelectionStartMarkerCell["y"], oCoordSelCell["y"]))
				) aRangeSelectCells["push"](oCell);
			}
		}
	}

	return aRangeSelectCells;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["aGetRangeSelectCells"] = 0; };

UCF_FluidLayoutCell["prototype"]["aRangeSelect"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["aRangeSelect"]++; }; 

	var aCells = this["aGetRangeSelectCells"](false);
	for (var x = 0; x < aCells["length"]; x++) {
		aCells[x]["select"]();
		var aAssociatedCells = aCells[x]["aGetAssociatedCells"]();
		for (var i = 0; i < aAssociatedCells["length"]; i++) {
			aAssociatedCells[i]["select"]();
		}
	}
	return aCells;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["aRangeSelect"] = 0; };

UCF_FluidLayoutCell["prototype"]["oGetNeighboredCell"] = function (iKeyCode) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetNeighboredCell"]++; }; 

	var oCoordCurrentCell = this["oGetAbsCoordinates"]();
	var oFluidLayout = this["oGetFluidLayout"]();
	var aRows = oFluidLayout["oDomRef"]["rows"];

	for (var y = 0; y < aRows["length"]; y++) {
		var aCells = aRows[y]["cells"];
		for (var x = 0; x < aCells["length"]; x++) {
			if (aCells[x] && aCells[x]["id"]) {
				var oCell = this["oLS"]["oControlFactory"]["oGetControlById"](aCells[x]["id"]);
				var oAbsCoord = oCell["oGetAbsCoordinates"]();
				if (oCell && UCF_JsUtil["bInstanceOf"](oCell, "UCF_FluidLayoutCell")) {
					switch (iKeyCode) {
						case UCF_KeyCodes["ARROW_LEFT"]:
							if (((oCoordCurrentCell["y"] >= oAbsCoord["y"]) && (oCoordCurrentCell["y"] <= (oAbsCoord["y"] + aCells[x]["rowSpan"] - 1))) &&
								(((oCoordCurrentCell["x"] - 1) >= oAbsCoord["x"]) && ((oCoordCurrentCell["x"] - 1) <= (oAbsCoord["x"] + aCells[x]["colSpan"] - 1)))) return oCell;
							break;
						case UCF_KeyCodes["ARROW_RIGHT"]:
							if (((oCoordCurrentCell["y"] >= oAbsCoord["y"]) && (oCoordCurrentCell["y"] <= (oAbsCoord["y"] + aCells[x]["rowSpan"] - 1))) &&
								(((oCoordCurrentCell["x"] + this["oDomRef"]["colSpan"]) >= oAbsCoord["x"]) && ((oCoordCurrentCell["x"] + this["oDomRef"]["colSpan"]) <= (oAbsCoord["x"] + aCells[x]["colSpan"] - 1)))) return oCell;
							break;
						case UCF_KeyCodes["ARROW_UP"]:
							if ((((oCoordCurrentCell["y"] - 1) >= oAbsCoord["y"]) && ((oCoordCurrentCell["y"] - 1) <= (oAbsCoord["y"] + aCells[x]["rowSpan"] - 1))) &&
								((oCoordCurrentCell["x"] >= oAbsCoord["x"]) && (oCoordCurrentCell["x"] <= (oAbsCoord["x"] + aCells[x]["colSpan"] - 1))) &&
								oAbsCoord["y"] !== 0) return oCell;
							break;
						case UCF_KeyCodes["ARROW_DOWN"]:
							if ((((oCoordCurrentCell["y"] + this["oDomRef"]["rowSpan"]) >= oAbsCoord["y"]) && ((oCoordCurrentCell["y"] + this["oDomRef"]["rowSpan"]) <= (oAbsCoord["y"] + aCells[x]["rowSpan"] - 1))) &&
								((oCoordCurrentCell["x"] >= oAbsCoord["x"]) && (oCoordCurrentCell["x"] <= (oAbsCoord["x"] + aCells[x]["colSpan"] - 1)))) return oCell;
							break;
					}
				}
			}
		}
	}

	return null;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["oGetNeighboredCell"] = 0; };

UCF_FluidLayoutCell["prototype"]["aCellCaptureEvents"] = ["mousedown", "click"];

/**
 * Attaches/activates the event capturing
 */
UCF_FluidLayoutCell["prototype"]["attachContentListening"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["attachContentListening"]++; }; 

	for (var i = 0; i < this["aCellCaptureEvents"]["length"]; i++) {
		this["oLS"]["attachCaptureEvent"](this["aCellCaptureEvents"][i], this, "onContentEventCapture");
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Event capturing of \"" + this["sId"] + "\" attached", "FluidLayoutCell.js(589): attachContentListening"); };
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["attachContentListening"] = 0; };

/**
 * detaches/deactivates the event capturing
 */
UCF_FluidLayoutCell["prototype"]["detachContentListening"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["detachContentListening"]++; }; 

	for (var i = 0; i < this["aCellCaptureEvents"]["length"]; i++) {
		this["oLS"]["detachCaptureEvent"](this["aCellCaptureEvents"][i], this);

	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Event capturing of \"" + this["sId"] + "\" detached", "FluidLayoutCell.js(601): detachContentListening"); };
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["detachContentListening"] = 0; };

/**
 * Processes the captured events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_FluidLayoutCell["prototype"]["onContentEventCapture"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onContentEventCapture"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FluidLayoutCell.js(610): onContentEventCapture"); };

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

	switch (oBrowserEvent["sGetName"]()) {
		case "mousedown":
			UCF_DomUtil["focusDomElement"](this["oDomRef"]);

			if (oBrowserEvent["oSourceControl"]["sClassName"] === "UCF_DTElement") {
				oBrowserEvent["oSourceControl"]["onmousedown"](oBrowserEvent);
			}

			break;
	}

	var sHandlerName = "on" + oBrowserEvent["sGetName"]();

	if (this[sHandlerName])
		this[sHandlerName](oBrowserEvent);

	var oFluidLayout = this["oGetFluidLayout"]();

	if (oFluidLayout[sHandlerName])
		oFluidLayout[sHandlerName](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["onContentEventCapture"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_FluidLayoutCell["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["destroy"]++; }; 

	this["detachContentListening"]();

	this["sDragAndResizeMode"] = "";
	this["iYCoordinate"] = 0;
	this["iRowHeight"] = 0;
	this["iColWidth"] = 0;
	this["sSelectionState"] = "";
	this["oRect"] = null;
	this["oFLLRect"] = null;
	this["oScrollOffset"] = null;
	this["oFluidLayoutContainer"] = null;
	this["oFluidLayout"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_FluidLayoutCell["prototype"]["aAttributeNames"] = ["sAssociatedCellIds","sSelectionState","bOccupied","bResizeableTop","bResizeableBottom","bResizeableBegin","bResizeableEnd","bRangeSelectionStartMarker","bRangeSelectionEndMarker","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_FluidLayoutCell["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_FluidLayoutCell["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_FluidLayoutCell["prototype"]["sAssociatedCellIds"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.DTSelectionState}
 */
UCF_FluidLayoutCell["prototype"]["sSelectionState"] = "SELECTABLE";

/**
 * @private
 * @type {boolean}
 */
UCF_FluidLayoutCell["prototype"]["bOccupied"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_FluidLayoutCell["prototype"]["bResizeableTop"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_FluidLayoutCell["prototype"]["bResizeableBottom"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_FluidLayoutCell["prototype"]["bResizeableBegin"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_FluidLayoutCell["prototype"]["bResizeableEnd"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_FluidLayoutCell["prototype"]["bRangeSelectionStartMarker"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_FluidLayoutCell["prototype"]["bRangeSelectionEndMarker"] = false;

/**
 * @private
 * @type {string}
 */
UCF_FluidLayoutCell["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_FluidLayoutCell["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["setDefaultValues"]++; }; 
	this["sAssociatedCellIds"] = '';
	this["sSelectionState"] = "SELECTABLE";
	this["bOccupied"] = false;
	this["bResizeableTop"] = false;
	this["bResizeableBottom"] = false;
	this["bResizeableBegin"] = false;
	this["bResizeableEnd"] = false;
	this["bRangeSelectionStartMarker"] = false;
	this["bRangeSelectionEndMarker"] = false;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("AssociatedCellIds", '', true);
		this["setClientProperty"]("SelectionState", "SELECTABLE", true);
		this["setClientProperty"]("Occupied", false, true);
		this["setClientProperty"]("ResizeableTop", false, true);
		this["setClientProperty"]("ResizeableBottom", false, true);
		this["setClientProperty"]("ResizeableBegin", false, true);
		this["setClientProperty"]("ResizeableEnd", false, true);
		this["setClientProperty"]("RangeSelectionStartMarker", false, true);
		this["setClientProperty"]("RangeSelectionEndMarker", false, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutCell["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_FluidLayoutContainer"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_FluidLayoutCell */
/// <reference path="./FluidLayoutCell.js"/>

/**
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_FluidLayoutContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["UCF_FluidLayoutContainer"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "FluidLayoutContainer.js(25): UCF_FluidLayoutContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "FluidLayoutContainer.js(26): UCF_FluidLayoutContainer"); };
	UCF_Control["apply"](this, arguments);

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");
	this["bShouldFireCommitSelection"] = false;
	this["bShouldHandleSelection"] = false;
	this["iRowHeight"] = Number["NaN"];

	this["aRangeSelectCells"] = [];
	this["aToggledCells"] = [];

	this["oRangeSelectionStartMarkerCell"] = null;
	this["oRangeSelectionEndMarkerCell"] = null;
};window["UCF_FluidLayoutContainer"] = UCF_FluidLayoutContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FluidLayoutContainer"); UCF_FluidLayoutContainer["_"] = {UCF_FluidLayoutContainer: 0}; }; ;

UCF_FluidLayoutContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_FluidLayoutContainer.prototype["sClassName"] = "UCF_FluidLayoutContainer";

/**
 * Initializes the control
 */
UCF_FluidLayoutContainer["prototype"]["initialize"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["initialize"]++; }; 
	this["calculateCellHeight"]();
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["initialize"] = 0; };

UCF_FluidLayoutContainer["ACCESS_TYPE"] = {
	"STANDARD": "STANDARD",
	"RANGE": "RANGE",
	"TOGGLE": "TOGGLE",
	"SELECT_ALL": "SELECT_ALL",
	"DESELECT_ALL": "DESELECT_ALL"
};

UCF_FluidLayoutContainer["prototype"]["handleMouseDownOnCell"] = function (oCell, bCtrl, bShift) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["handleMouseDownOnCell"]++; }; 

	if ((!bCtrl && !oCell["bIsSelected"]()) || bShift) this["handleSelection"](oCell, bCtrl, bShift);
	else this["bShouldHandleSelection"] = true;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["handleMouseDownOnCell"] = 0; };

UCF_FluidLayoutContainer["prototype"]["handleMouseUpOnCell"] = function (oCell, bCtrl, bShift) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["handleMouseUpOnCell"]++; }; 

	var bOtherCellsSelected = (oCell["aGetSelectedCells"]()["length"] !== (oCell["aGetAssociatedCells"]()["length"] + 1));
	if ((bCtrl || bOtherCellsSelected) && this["bShouldHandleSelection"] && !bShift) this["handleSelection"](oCell, bCtrl, bShift);
	this["bShouldHandleSelection"] = false;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["handleMouseUpOnCell"] = 0; };

UCF_FluidLayoutContainer["prototype"]["handleDragStartOnCell"] = function (oCell, bCtrl, bShift) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["handleDragStartOnCell"]++; }; 

	if (bCtrl && !oCell["bIsSelected"]()) this["handleSelection"](oCell, bCtrl, bShift);
	this["bShouldHandleSelection"] = false;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["handleDragStartOnCell"] = 0; };

UCF_FluidLayoutContainer["prototype"]["bHandleKeyDownOnCell"] = function (oCell, bCtrl, bShift, iKeyCode) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["bHandleKeyDownOnCell"]++; }; 

	var oNeighboredCell = oCell["oGetNeighboredCell"](iKeyCode),
		bHandled = false;

	if (oNeighboredCell) {
		UCF_DomUtil["focusDomElement"](oNeighboredCell["oDomRef"]);
		this["handleSelection"](oNeighboredCell, bCtrl, bShift);
		bHandled = true;
	} else bHandled = false;

	return bHandled;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["bHandleKeyDownOnCell"] = 0; };

UCF_FluidLayoutContainer["prototype"]["handleSelection"] = function (oCell, bCtrl, bShift) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["handleSelection"]++; }; 
	var x;

	if (oCell["sSelectionState"] !== UCF_FluidLayoutCell["eSelectionState"]["UNSELECTABLE"]) {
		var aAssociatedCells = oCell["aGetAssociatedCells"]();
		var sToggledElementId = '';
		this["aToggledCells"] = [];

		if (bCtrl) {
			oCell["toggleSelection"]();
			this["setRangeSelectionStartMarkerCell"](oCell);
			for (x = 0; x < aAssociatedCells["length"]; x++) {
				aAssociatedCells[x]["toggleSelection"]();
			}

			sToggledElementId = this["sBuildToggledElementId"]();
			this["fireSelect"](this["sId"], oCell["sId"], UCF_FluidLayoutContainer["ACCESS_TYPE"]["TOGGLE"], sToggledElementId);
			this["bShouldFireCommitSelection"] = true;
		} else {
			if (bShift) {
				this["initRangeSelect"](oCell);
				this["aRangeSelectCells"] = oCell["aRangeSelect"]();
				this["setRangeSelectionEndMarkerCell"](oCell);

				sToggledElementId = this["sBuildToggledElementId"]();
				this["fireSelect"](this["sId"], oCell["sId"], UCF_FluidLayoutContainer["ACCESS_TYPE"]["RANGE"], sToggledElementId);
				this["bShouldFireCommitSelection"] = true;
			} else {
				this["deselectAll"]();
				oCell["select"]();
				this["setRangeSelectionStartMarkerCell"](oCell);
				for (x = 0; x < aAssociatedCells["length"]; x++) {
					aAssociatedCells[x]["select"]();
				}

				sToggledElementId = this["sBuildToggledElementId"]();
				this["fireSelect"](this["sId"], oCell["sId"], UCF_FluidLayoutContainer["ACCESS_TYPE"]["STANDARD"], sToggledElementId);
				this["bShouldFireCommitSelection"] = true;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["handleSelection"] = 0; };

/**
 * Catches all events occurring on the window
 * handles mouse up for firing commitSelection
 *
 * @param {UCF_Event} oEvent the Event object of Lightspeed
 * @private
 */
UCF_FluidLayoutContainer["prototype"]["onAnyEvent"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["onAnyEvent"]++; }; 

	var oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent"),
		sName = oBrowserEvent["sGetName"]();

	//mouse up won't be fired when the user drops and this is the way we want it to be
	//else there would be 2 events triggering 2 roundtrips -> bad!
	if (sName === "click" || sName === "keyup") {

		//only commit when really a select has been fired
		if (this["bShouldFireCommitSelection"]) {

			this["bShouldFireCommitSelection"] = false;
			UCF_JsUtil["delayedCall"](1, this, "fireCommitSelection", [this["sId"]]);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["onAnyEvent"] = 0; };

UCF_FluidLayoutContainer["prototype"]["triggerCommitSelection"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["triggerCommitSelection"]++; }; 

	if (this["bShouldFireCommitSelection"]) {
		this["bShouldFireCommitSelection"] = false;
		UCF_JsUtil["delayedCall"](1, this, "fireCommitSelection", [this["sId"]]);
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["triggerCommitSelection"] = 0; };

UCF_FluidLayoutContainer["prototype"]["aGetCells"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["aGetCells"]++; }; 
	if (this["aCells"]) return this["aCells"];

	var aCells = [];
	var aTDs = this["oDomRef"]["getElementsByTagName"]("TD");
	for (var x = 0, len = aTDs["length"]; x < len; x++) {
		if (aTDs[x]["getAttribute"]("ct") !== "FLCL") continue;
		var sId = aTDs[x]["id"];
		var oCell = this["oLS"]["oControlFactory"]["oGetControlById"](sId);
		if (UCF_JsUtil["bInstanceOf"](oCell, "UCF_FluidLayoutCell") && oCell["oGetParent"]()["oGetFluidLayoutContainer"]() === this) aCells["push"](oCell);
	}

	return this["aCells"] = aCells;
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["aGetCells"] = 0; };

UCF_FluidLayoutContainer["prototype"]["iGetRowHeight"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["iGetRowHeight"]++; }; 

	if (!isNaN(this["iRowHeight"])) return this["iRowHeight"];

	//get reference to first cell of header (table-tbody-tr-td-table-tbody-tr-->th)
	var oCellRef = this["oDomRef"]["firstChild"]; //tbody
	oCellRef = oCellRef["firstChild"]; //tr
	oCellRef = oCellRef["firstChild"]; //td
	oCellRef = oCellRef["firstChild"]; //table
	oCellRef = oCellRef["firstChild"]; //tbody
	oCellRef = oCellRef["firstChild"]; //tr
	oCellRef = oCellRef["firstChild"]; //th

	var oCellRefRect = UCF_DomUtil["oGetObjectRect"](oCellRef);

	return this["iRowHeight"] = oCellRefRect["height"];

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["iGetRowHeight"] = 0; };

UCF_FluidLayoutContainer["prototype"]["calculateCellHeight"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["calculateCellHeight"]++; }; 

	var aCells = this["aGetCells"]();

	for (var x = 0, len = aCells["length"]; x < len; x++) {
		if (aCells[x]["oDomRef"]["rowSpan"] > 1 || window["UCF_System"]["sDevice"] === "standards") {
			var oChildRef = aCells[x]["oDomRef"]["firstChild"];
			if (oChildRef && (oChildRef["id"] === (aCells[x]["sId"] + "-div"))) {
				// in standards mode also for rowSpan=1 an additonally DIV is rendered (to achieve overflow hidden)
				// to keep cell content alignment set height only for the case that cells content is higher than cell
				if (window["UCF_System"]["sDevice"] === "standards" && aCells[x]["oDomRef"]["rowSpan"] === 1) {
					if (oChildRef["offsetHeight"] > this["iGetRowHeight"]()) {
						oChildRef["style"]["height"] = ((aCells[x]["oDomRef"]["rowSpan"] * this["iGetRowHeight"]()) - 2) + "px";
					}
				} else {
					oChildRef["style"]["height"] = ((aCells[x]["oDomRef"]["rowSpan"] * this["iGetRowHeight"]()) - 2) + "px";
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["calculateCellHeight"] = 0; };

UCF_FluidLayoutContainer["prototype"]["deselectAll"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["deselectAll"]++; }; 

	var aCells = this["aGetCells"]();

	for (var x = 0; x < aCells["length"]; x++) {
		aCells[x]["deselect"]();
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["deselectAll"] = 0; };

UCF_FluidLayoutContainer["prototype"]["initRangeSelect"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["initRangeSelect"]++; }; 

	var aCells = this["aRangeSelectCells"];

	if (aCells["length"] === 0) aCells = oCell["aGetRangeSelectCells"](true);

	for (var x = 0; x < aCells["length"]; x++) {
		aCells[x]["deselect"]();
		var aAssociatedCells = aCells[x]["aGetAssociatedCells"]();
		for (var i = 0; i < aAssociatedCells["length"]; i++) {
			aAssociatedCells[i]["deselect"]();
		}
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["initRangeSelect"] = 0; };

UCF_FluidLayoutContainer["prototype"]["sBuildToggledElementId"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["sBuildToggledElementId"]++; }; 

	var aToggledCellIds = [],
		aMultiToggledCellIds = [],
		sToggledElementId = null,
		sCurrentCellId = null,
		sDuplicateElementId = null,
		sLastElementId = null,
		bCurrentDuplicateElement = false,
		x;

	for (x = 0; x < this["aToggledCells"]["length"]; x++) {
		aMultiToggledCellIds["push"](this["aToggledCells"][x]["sId"]);
	}

	aMultiToggledCellIds["sort"]();

	//delete adjacent duplicates
	for (x = 0; x < aMultiToggledCellIds["length"]; x++) {
		if (sCurrentCellId) {
			if (sCurrentCellId !== aMultiToggledCellIds[x] && sCurrentCellId !== sDuplicateElementId) {
				bCurrentDuplicateElement = false;
			} else {
				bCurrentDuplicateElement = true;
				sDuplicateElementId = sCurrentCellId;
			}
			if (!bCurrentDuplicateElement) {
				aToggledCellIds["push"](sCurrentCellId);
			}
		}
		sLastElementId = sCurrentCellId;
		sCurrentCellId = aMultiToggledCellIds[x];
	}

	if (!sLastElementId || (sCurrentCellId && sLastElementId !== sCurrentCellId)) {
		aToggledCellIds["push"](sCurrentCellId);
	}

	sToggledElementId = aToggledCellIds["join"](" ");

	return sToggledElementId;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["sBuildToggledElementId"] = 0; };

UCF_FluidLayoutContainer["prototype"]["setRangeSelectionStartMarkerCell"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["setRangeSelectionStartMarkerCell"]++; }; 

	this["oRangeSelectionStartMarkerCell"] = oCell;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["setRangeSelectionStartMarkerCell"] = 0; };

UCF_FluidLayoutContainer["prototype"]["oGetRangeSelectionStartMarkerCell"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["oGetRangeSelectionStartMarkerCell"]++; }; 

	if (!this["oRangeSelectionStartMarkerCell"]) this["oRangeSelectionStartMarkerCell"] = oCell["oGetFluidLayout"]()["oGetFirstCell"]();
	return this["oRangeSelectionStartMarkerCell"];

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["oGetRangeSelectionStartMarkerCell"] = 0; };

UCF_FluidLayoutContainer["prototype"]["setRangeSelectionEndMarkerCell"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["setRangeSelectionEndMarkerCell"]++; }; 

	this["oRangeSelectionEndMarkerCell"] = oCell;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["setRangeSelectionEndMarkerCell"] = 0; };

UCF_FluidLayoutContainer["prototype"]["oGetRangeSelectionEndMarkerCell"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["oGetRangeSelectionEndMarkerCell"]++; }; 

	return this["oRangeSelectionEndMarkerCell"];

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["oGetRangeSelectionEndMarkerCell"] = 0; };

UCF_FluidLayoutContainer["prototype"]["addToggledCell"] = function (oCell) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["addToggledCell"]++; }; 

	this["aToggledCells"]["push"](oCell);

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["addToggledCell"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_FluidLayoutContainer["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["destroy"]++; }; 

	var oWindow = this["oLS"]["oBrowserWindow"];
	oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	this["iRowHeight"] = 0;
	this["aRangeSelectCells"] = null;
	this["aToggledCells"] = null;
	this["oRangeSelectionStartMarkerCell"] = null;
	this["oRangeSelectionEndMarkerCell"] = null;
	this["aCells"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_FluidLayoutContainer["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_FluidLayoutContainer["prototype"]["aEventNames"] = ["Select","CommitSelection"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_FluidLayoutContainer["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_FluidLayoutContainer["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_FluidLayoutContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The ID of the FluidLayoutContainer.
 * @param {string} sElementId Space seperated list of currently selected control IDs.
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select , TOGGLE for a selection toggle, DESELECT_ALL for deselction of all rows, SELECT_ALL for selection of all cells
 * @param {string} sToggledElementId Space seperated list of toggled control IDs.
 * @fires FluidLayoutContainer::Select
 */
UCF_FluidLayoutContainer["prototype"]["fireSelect"] = function(sId, sElementId, sAccessType, sToggledElementId) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, ElementId: string, AccessType: string, ToggledElementId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "FluidLayoutContainer.js(399): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "FluidLayoutContainer.js(400): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "FluidLayoutContainer.js(401): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sElementId != null, "sElementId != null", "FluidLayoutContainer.js(402): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sElementId) == "string", "typeof(sElementId) == \"string\"", "FluidLayoutContainer.js(403): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "FluidLayoutContainer.js(404): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "FluidLayoutContainer.js(405): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sToggledElementId != null, "sToggledElementId != null", "FluidLayoutContainer.js(406): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sToggledElementId) == "string", "typeof(sToggledElementId) == \"string\"", "FluidLayoutContainer.js(407): fireSelect"); };
	mParams = {
		"Id": sId,
		"ElementId": sElementId,
		"AccessType": sAccessType,
		"ToggledElementId": sToggledElementId
	};
	
	
	
	
	this["fireSemanticEvent"]("FluidLayoutContainer", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId The ID of the FluidLayoutContainer.
 * @fires FluidLayoutContainer::CommitSelection
 */
UCF_FluidLayoutContainer["prototype"]["fireCommitSelection"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["fireCommitSelection"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "FluidLayoutContainer.js(430): fireCommitSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "FluidLayoutContainer.js(431): fireCommitSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "FluidLayoutContainer.js(432): fireCommitSelection"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("FluidLayoutContainer", "CommitSelection", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutContainer["_"]["fireCommitSelection"] = 0; };

};
sap["ls"]["preload"]["UCF_FluidLayoutDragDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_FluidLayoutDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_FluidLayoutDragDelegate["_"]["UCF_FluidLayoutDragDelegate"]++; }; 

	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);

};window["UCF_FluidLayoutDragDelegate"] = UCF_FluidLayoutDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FluidLayoutDragDelegate"); UCF_FluidLayoutDragDelegate["_"] = {UCF_FluidLayoutDragDelegate: 0}; }; ;

UCF_FluidLayoutDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_FluidLayoutDragDelegate.prototype["sClassName"] = "UCF_FluidLayoutDragDelegate";

UCF_FluidLayoutDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDragDelegate["_"]["oGetGhost"]++; }; 

	var oDiv = document["createElement"]("DIV"),
		oTemp = document["createElement"]("DIV"),
		// oCellRef = UCF_DomUtil.oGetParentByAttribute(oBrowserEvent.oGetSource(), "ct", "FLCL"),
		// oCell = this.oLS.oControlFactory.oGetControlById(oCellRef.id);
		oCell = this["oGetCell"](oBrowserEvent);

	oTemp["appendChild"](oCell["oGetGhostHtml"]());
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oDiv, oTemp["innerHTML"]);

	var oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv);
	oGhost["setOffset"](12, 12);

	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDragDelegate["_"]["oGetGhost"] = 0; };

UCF_FluidLayoutDragDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDragDelegate["_"]["onlsdragstart"]++; }; 

	if (!this["oDragSourceControl"]["bHandleDragStart"](oBrowserEvent)) {

		UCF_DragDelegate.prototype["onlsdragstart"]["call"](this, oBrowserEvent);

		var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"];
		if (oDragSession) {
			/* calculate smallest all associated cells enclosing rectangle */
			var iMinColSpan = 1,
				iMinRowSpan = 1,
				iMaxColSpan = 1,
				iMaxRowSpan = 1,
				oCell = this["oGetCell"](oBrowserEvent),
				oMyCoords = oCell["oGetCoordinates"](),
				iMinX = oMyCoords["x"],
				iMaxX = oMyCoords["x"],
				iMinY = oMyCoords["y"],
				iMaxY = oMyCoords["y"],
				iMaxXSpan = oMyCoords["x"],
				iMaxYSpan = oMyCoords["y"],
				oMyAbsCoords = oCell["oGetAbsCoordinates"](),
				iAbsMinX = oMyAbsCoords["x"],
				iAbsMaxX = oMyAbsCoords["x"],
				iAbsMinY = oMyAbsCoords["y"],
				iAbsMaxY = oMyAbsCoords["y"],
				iAbsMaxXSpan = oMyAbsCoords["x"],
				iAbsMaxYSpan = oMyAbsCoords["y"];

			this["oDragSourceControl"]["oGetFluidLayoutContainer"]()["handleDragStartOnCell"](oCell, oBrowserEvent["bCtrl"](), oBrowserEvent["bShift"]());

			var aSelectedCells = oCell["aGetSelectedCells"]();

			for (var x = 0; x < aSelectedCells["length"]; x++) {
				var oCurrentCoords = aSelectedCells[x]["oGetCoordinates"]();
				iMinX = Math["min"](iMinX, oCurrentCoords["x"]);
				iMaxX = Math["max"](iMaxX, oCurrentCoords["x"]);
				iMaxXSpan = Math["max"](iMaxXSpan, (oCurrentCoords["x"] + aSelectedCells[x]["oDomRef"]["colSpan"] - 1));
				iMinY = Math["min"](iMinY, oCurrentCoords["y"]);
				iMaxY = Math["max"](iMaxY, oCurrentCoords["y"]);
				iMaxYSpan = Math["max"](iMaxYSpan, (oCurrentCoords["y"] + aSelectedCells[x]["oDomRef"]["rowSpan"] - 1));
				var oCurrentAbsCoords = aSelectedCells[x]["oGetAbsCoordinates"]();
				iAbsMinX = Math["min"](iAbsMinX, oCurrentAbsCoords["x"]);
				iAbsMaxX = Math["max"](iAbsMaxX, oCurrentAbsCoords["x"]);
				iAbsMaxXSpan = Math["max"](iAbsMaxXSpan, (oCurrentAbsCoords["x"] + aSelectedCells[x]["oDomRef"]["colSpan"] - 1));
				iAbsMinY = Math["min"](iAbsMinY, oCurrentAbsCoords["y"]);
				iAbsMaxY = Math["max"](iAbsMaxY, oCurrentAbsCoords["y"]);
				iAbsMaxYSpan = Math["max"](iAbsMaxYSpan, (oCurrentAbsCoords["y"] + aSelectedCells[x]["oDomRef"]["rowSpan"] - 1));
			}

			iMinColSpan = iMaxX - iMinX + 1;
			iMinRowSpan = iMaxY - iMinY + 1;
			iMaxColSpan = iAbsMaxXSpan - iAbsMinX + 1;
			iMaxRowSpan = iAbsMaxYSpan - iAbsMinY + 1;

			var sHint = "{fluidLayoutDimensions:{iMinColSpan:" + iMinColSpan + ",iMaxColSpan:" + iMaxColSpan + ",iMinRowSpan:" + iMinRowSpan + ",iMaxRowSpan:" + iMaxRowSpan + "}}";

			oDragSession["sHint"] = sHint;

		}
	}

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDragDelegate["_"]["onlsdragstart"] = 0; };

UCF_FluidLayoutDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDragDelegate["_"]["bIsDragPossible"]++; }; 

	var bSuperIsDragPossible = UCF_DragDelegate.prototype["bIsDragPossible"]["call"](this, oBrowserEvent),
		oCell = this["oGetCell"](oBrowserEvent);

	if (!oCell) return false;

	var bOccupied = oCell["bOccupied"],
		bDragAndResizeMode = oCell["bIsDragAndResizeMode"]();

	return bSuperIsDragPossible && bOccupied && !bDragAndResizeMode;
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDragDelegate["_"]["bIsDragPossible"] = 0; };

UCF_FluidLayoutDragDelegate["prototype"]["oGetCell"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDragDelegate["_"]["oGetCell"]++; }; 
	var oCellRef = null,
		oDomRef = null,
		sId = null;

	if (oBrowserEvent["oSource"]["id"] === "DragResize") {
		oBrowserEvent["oSource"]["style"]["visibility"] = "hidden";
		oBrowserEvent["oSource"]["style"]["display"] = "none";
		oDomRef = UCF_DomUtil["oGetElementFromPoint"](oBrowserEvent["_iClientX"], oBrowserEvent["_iClientY"]);
		oCellRef = UCF_DomUtil["oGetParentByAttribute"](oDomRef, "ct", "FLCL");
		oBrowserEvent["oSource"]["style"]["visibility"] = "visible";
		oBrowserEvent["oSource"]["style"]["display"] = "";
	} else {
		oCellRef = UCF_DomUtil["oGetParentByAttribute"](oBrowserEvent["oGetSource"](), "ct", "FLCL");
	}

	sId = oCellRef["id"];

	if (!sId) return null;
	var oCell = this["oLS"]["oControlFactory"]["oGetControlById"](oCellRef["id"]);

	if (!UCF_JsUtil["bInstanceOf"](oCell, "UCF_FluidLayoutCell")) return null;

	return oCell;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDragDelegate["_"]["oGetCell"] = 0; };

};
sap["ls"]["preload"]["UCF_FluidLayoutDropDecorator"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_BoxDecorator */
/// <reference path="./BoxDecorator.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * a wrapper for the line and the box decorator
 * needed for the draganddropmanager to hide / unhide the decorators
 *
 * 
 * @class UCF_FluidLayoutDropDecorator
 *
 * @param {UCF_Control} oControl the decorated Control
 */
function UCF_FluidLayoutDropDecorator(oControl) {if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["UCF_FluidLayoutDropDecorator"]++; }; 
	if (arguments["length"] > 0) {
		this["oDropTargetControl"] = oControl;

		this["oLineDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(oControl, true);

		this["oBoxDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_BoxDecorator"))(oControl);
		this["oBoxDecorator"]["bDashed"] = true;

		this["oDropLocation"] = null;
		this["bInitialized"] = false;
	}
};window["UCF_FluidLayoutDropDecorator"] = UCF_FluidLayoutDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FluidLayoutDropDecorator"); UCF_FluidLayoutDropDecorator["_"] = {UCF_FluidLayoutDropDecorator: 0}; }; ;

UCF_FluidLayoutDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_FluidLayoutDropDecorator.prototype["sClassName"] = "UCF_FluidLayoutDropDecorator";

/** destructor */
UCF_FluidLayoutDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["destroy"]++; }; 
	this["oDropTargetControl"] = null;
	this["oDropLocation"] = null;
	this["oLineDecorator"]["destroy"]();
	this["oBoxDecorator"]["destroy"]();
	this["oLineDecorator"] = null;
	this["oBoxDecorator"] = null;
	this["oLineWasVisible"] = null;
	this["oBoxWasVisible"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["destroy"] = 0; };

/** creates dom */
UCF_FluidLayoutDropDecorator["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["init"]++; }; 
	if (!this["bInitialized"]) {
		this["oLineDecorator"]["init"]();
		this["oBoxDecorator"]["init"]();
		this["bInitialized"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["init"] = 0; };

/** removes elements from DOM */
UCF_FluidLayoutDropDecorator["prototype"]["cleanUp"] = function() {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["cleanUp"]++; }; 
	this["oLineDecorator"]["hide"]();
	this["oBoxDecorator"]["hide"]();
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["cleanUp"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_FluidLayoutDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["update"]++; }; 
	/** @type {HTMLTableDataCellElement} */
	var oCellRef;
	/** @type {HTMLTableRowElement} */
	var oRowRef;
	/** @type {number} */
	var iColCount;
	/** @type {number} */
	var iHoveredColumn;
	/** @type {number} */
	var iHoveredRow;
	/** @type {HTMLTableElement} */
	var oTableRef;
	/** @type {number} */
	var iRowCount;
	/** @type {UCF_Rectangle} */
	var oCellRect;
	/** @type {number} */
	var iMouseY;
	/** @type {number} */
	var iQuarterHeight;
	/** @type {number} */
	var iOffset;
	/** @type {UCF_Rectangle} */
	var oRowRect;
	/** @type {number} */
	var iTop;
	/** @type {number} */
	var iMinColSpan;
	/** @type {number} */
	var iMaxColSpan;
	/** @type {number} */
	var iMinRowSpan;
	/** @type {number} */
	var iMaxRowSpan;
	/** @type {string} */
	var sHint;
	/** @type {Object}} */
	var oHint;
	/** @type {number} */
	var iDecoratorRowSpan;
	/** @type {number} */
	var iDecoratorColSpan;
	/** @type {UCF_FluidLayoutDropDecorator} */
	var self;
	/** @type {boolean} */
	var bCanDropHere;
	/** @type {UCF_Rectangle} */
	var oEndCellRect;
	/** @type {number} */
	var iWidth;
	/** @type {number} */
	var iHeight;

	/**
	 * @param {number} iWidth width
	 * @param {number} iHeight height
	 * @return {boolean}
	 */
	function fits(iWidth, iHeight) {
		/** @type {number} */
		var iRow;
		/** @type {number} */
		var iCol;
		/** @type {HTMLTableRowElement} */
		var oRowRef;
		/** @type {HTMLTableDataCellElement} */
		var oCellRef;
		/** @type {UCF_FluidLayoutCell} */
		var oCell;

		for (iRow = 0; iRow < iHeight; iRow++) {
			for (iCol = 0; iCol < iWidth; iCol++) {
				oRowRef = oTableRef["rows"][iHoveredRow + iRow];
				if (!oRowRef) {
					return false;
				}

				oCellRef = oRowRef["cells"][iHoveredColumn + iCol];
				if (!oCellRef) {
					return false;
				}

				oCell = self["oDropTargetControl"]["oLS"]["oControlFactory"]["oGetControlById"](
					oCellRef["id"]
				);
				if (oCell["bOccupied"]) {
					return false;
				}
			}
		}

		return true;
	}

	this["oLineDecorator"]["hide"]();
	this["oBoxDecorator"]["hide"]();

	oCellRef = UCF_DomUtil["oGetParentByAttribute"](
		oBrowserEvent["oGetSource"](),
		'ct',
		'FLCL'
	);

	this["oDropLocation"] = null;
	if (!UCF_DomUtil["bContains"](this["oDropTargetControl"]["oDomRef"], oCellRef)) {
		return;
	}

	oRowRef = oCellRef["parentNode"];
	iColCount = oRowRef["cells"]["length"];
	iHoveredColumn = 0;

	while (iHoveredColumn < iColCount) {
		if (oRowRef["cells"][iHoveredColumn] === oCellRef) {
			break;
		}
		iHoveredColumn++;
	}

	iHoveredRow = 1; // 1 because first is header row
	oTableRef = this["oDropTargetControl"]["oDomRef"];
	iRowCount = oTableRef["rows"]["length"];

	// dropping on header currently forbidden
	// if possible eventually remove this line and set iHoveredRow = 0
	if (oTableRef["rows"][0] === oRowRef) {
		return;
	}

	while (iHoveredRow < iRowCount) {
		if (oTableRef["rows"][iHoveredRow] === oRowRef) {
			break;
		}
		iHoveredRow++;
	}

	// check in which part of the cell the mouse is
	oCellRect = UCF_DomUtil["oGetObjectRect"](oCellRef);
	iMouseY = oBrowserEvent["iPageY"]();
	// eslint-disable-next-line no-magic-numbers
	iQuarterHeight = oCellRect["height"] / 4.0;
	iOffset = 0;

	if (iMouseY <= oCellRect["top"] + iQuarterHeight) {
		iOffset = -1;
	} else if (iMouseY >= oCellRect["top"] + oCellRect["height"] - iQuarterHeight) {
		iOffset = 1;
	}

	if (iOffset === 0) {
		// show box decorator

		// default values for the drop decorator dimension
		iMinColSpan = 1;
		iMaxColSpan = 1;
		iMinRowSpan = 1;
		iMaxRowSpan = 1;

		sHint = oBrowserEvent["oDragAndDropManager"]["oDragSession"]["sHint"];
		oHint = null;
		if (sHint) {
			oHint = UCF_JsUtil["oJsonParse"](sHint);

			if (oHint["fluidLayoutDimensions"]) {
				oHint = oHint["fluidLayoutDimensions"];
				iMinColSpan = oHint["iMinColSpan"] || iMinColSpan;
				iMaxColSpan = oHint["iMaxColSpan"] || iMaxColSpan;
				iMinRowSpan = oHint["iMinRowSpan"] || iMinRowSpan;
				iMaxRowSpan = oHint["iMaxRowSpan"] || iMaxRowSpan;
			}
		}

		iDecoratorRowSpan = iMinRowSpan;
		iDecoratorColSpan = 0;
		self = this;

		while (iDecoratorColSpan < iMaxColSpan
			&& fits(iDecoratorColSpan + 1, iDecoratorRowSpan)
		) {
			iDecoratorColSpan++;
		}

		while (iDecoratorRowSpan < iMaxRowSpan
			&& fits(iDecoratorColSpan, iDecoratorRowSpan + 1)
		) {
			iDecoratorRowSpan++;
		}

		bCanDropHere = iDecoratorColSpan >= iMinColSpan;
		if (bCanDropHere) {
			// show box decorator for the iFreeCellcount cells
			oEndCellRect = UCF_DomUtil["oGetObjectRect"](
				oTableRef
				["rows"][iHoveredRow + iDecoratorRowSpan - 1]
				["cells"][iHoveredColumn + iDecoratorColSpan - 1]
			);
			iWidth = oEndCellRect["left"] + oEndCellRect["width"] - oCellRect["left"] + 1;
			iHeight = oEndCellRect["top"] + oEndCellRect["height"] - oCellRect["top"] + 1;

			// box model / border-collapse corrections
			if (UCF_UserAgent["bIsGecko"]() || (
					window["UCF_System"]["sDevice"] === 'standards' &&
					(UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())
				)) {
				// 2 for the box model, 2 for the border-collapse
				iWidth -= 4; // eslint-disable-line no-magic-numbers
				iHeight -= 4; // eslint-disable-line no-magic-numbers
			}

			this["oBoxDecorator"]["setBounds"](
				oCellRect["left"],
				oCellRect["top"],
				iHeight,
				iWidth
			);
			this["oBoxDecorator"]["show"]();
			this["oDropLocation"] = {
				"iRowIndex": iHoveredRow,
				"iOffset": iOffset,
				"iColIndex": iHoveredColumn,
				"sCellId": oCellRef["id"]
			};
		}
	} else {
		// show line decorator
		// calculate and set decorator position
		oRowRect = UCF_DomUtil["oGetObjectRect"](oRowRef);
		iTop = iOffset === -1 ? oRowRect["top"] : oRowRect["top"] + oRowRect["height"];

		this["oLineDecorator"]["setBounds"](oRowRect["left"], iTop, oRowRect["width"]);
		this["oLineDecorator"]["show"]();
		this["oDropLocation"] = {
			"iRowIndex": iHoveredRow,
			"iOffset": iOffset,
			"iColIndex": iHoveredColumn,
			"sCellId": oCellRef["id"]
		};
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["update"] = 0; };

UCF_FluidLayoutDropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["oGetDropLocation"]++; }; 
	return this["oDropLocation"];
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["oGetDropLocation"] = 0; };

/**
 * @override
 * need to override since we do our hide/wasVisible/show handling in this class
 * @return {boolean} constant `true`
 */
UCF_FluidLayoutDropDecorator["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["bIsVisible"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["bIsVisible"] = 0; };

/** needed to determine the hovered element */
UCF_FluidLayoutDropDecorator["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["hide"]++; }; 
	this["oLineWasVisible"] = this["oLineDecorator"]["bIsVisible"]();
	if (this["oLineWasVisible"]) {
		this["oLineDecorator"]["hide"]();
	}

	this["oBoxWasVisible"] = this["oBoxDecorator"]["bIsVisible"]();
	if (this["oBoxWasVisible"]) {
		this["oBoxDecorator"]["hide"]();
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["hide"] = 0; };

UCF_FluidLayoutDropDecorator["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["show"]++; }; 
	if (this["oLineWasVisible"]) {
		this["oLineDecorator"]["show"]();
	}

	if (this["oBoxWasVisible"]) {
		this["oBoxDecorator"]["show"]();
	}
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDecorator["_"]["show"] = 0; };

};
sap["ls"]["preload"]["UCF_FluidLayoutDropDelegate"] = function() {/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_FluidLayoutDropDecorator */
/// <reference path="../decorators/FluidLayoutDropDecorator.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_FluidLayoutDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["UCF_FluidLayoutDropDelegate"]++; }; 
	UCF_DropDelegate["apply"](this, [oLS]);
	this["setDropTargetControl"](oDropTargetControl);

};window["UCF_FluidLayoutDropDelegate"] = UCF_FluidLayoutDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FluidLayoutDropDelegate"); UCF_FluidLayoutDropDelegate["_"] = {UCF_FluidLayoutDropDelegate: 0}; }; ;
UCF_FluidLayoutDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_FluidLayoutDropDelegate.prototype["sClassName"] = "UCF_FluidLayoutDropDelegate";

/**
 * destructor
 */
UCF_FluidLayoutDropDelegate["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["destroy"]++; }; 
	UCF_DropDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["destroy"] = 0; };

UCF_FluidLayoutDropDelegate["prototype"]["oCreateDropDecorator"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["oCreateDropDecorator"]++; }; 

	if (this["oDropDecorator"]) return this["oDropDecorator"];
	return this["oDropDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_FluidLayoutDropDecorator"))(this["oDropTargetControl"]); // eslint-disable-line @ur/no-memory-leaks

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["oCreateDropDecorator"] = 0; };
UCF_FluidLayoutDropDelegate["prototype"]["bIsDropPossible"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["bIsDropPossible"]++; }; 

	this["oCreateDropDecorator"]()["update"](oBrowserEvent);
	if (!this["oDropDecorator"]["oGetDropLocation"]()) return false;

	return UCF_DropDelegate.prototype["bIsDropPossible"]["call"](this, oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["bIsDropPossible"] = 0; };

UCF_FluidLayoutDropDelegate["prototype"]["onlsdragover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["onlsdragover"]++; }; 

	if (!this["onlsdragenter"](oBrowserEvent))
		oBrowserEvent["oDragAndDropManager"]["cleanUpDropArea"]();

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["onlsdragover"] = 0; };

UCF_FluidLayoutDropDelegate["prototype"]["onlsdragend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["onlsdragend"]++; }; 

	if (!oBrowserEvent["bDropHandled"]) this["oDropTargetControl"]["oGetFluidLayoutContainer"]()["triggerCommitSelection"]();

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["onlsdragend"] = 0; };

UCF_FluidLayoutDropDelegate["prototype"]["oGetDomRefToBeFocussed"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["oGetDomRefToBeFocussed"]++; }; 

	return null;

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["oGetDomRefToBeFocussed"] = 0; };

UCF_FluidLayoutDropDelegate["prototype"]["fGetDropCallBack"] = function (oDragSession) {;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropLocation = this["oDropDecorator"]["oGetDropLocation"](),
		iRowIndex = oDropLocation["iRowIndex"],
		iOffset = oDropLocation["iOffset"],
		iColIndex = oDropLocation["iColIndex"],
		sCellId = oDropLocation["sCellId"],
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function (sDragData, sMimeType) {

		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			iRowIndex,
			iOffset,
			iColIndex,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			sCellId,
			oDragSession["eGetDropEffect"]()
		);
	};

};;if (__UCF_COVERAGE__) { UCF_FluidLayoutDropDelegate["_"]["fGetDropCallBack"] = 0; };

};
sap["ls"]["preload"]["UCF_Form"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * A Form, for purpose of JSF integration,
 * supports collection and transport of semantic events to the back-end

 * 
 * @version 1.0.0.0
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Form(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Form["_"]["UCF_Form"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "Form.js(23): UCF_Form"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Form.js(24): UCF_Form"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Form.js(25): UCF_Form"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["defineEvents"](['Destroy']);
};window["UCF_Form"] = UCF_Form; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Form"); UCF_Form["_"] = {UCF_Form: 0}; }; ;
UCF_Form["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Form.prototype["sClassName"] = "UCF_Form";

/**
 *Intializes event handlers for the form
 *@private
 */
UCF_Form["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["initialize"]++; }; 

	// store old submit handler reference on the DOM object !!
	this["oDomRef"]["_SAP_UCF_oldHandlerSubmit_"] = this["oDomRef"]["submit"];

	this["attachBrowserEvent"]("submit", this["oDomRef"]);
	this["attachBrowserEvent"]("reset", this["oDomRef"]);

	// for direct javascript calls the original handler has to be called
	var that = this;
	this["oDomRef"]["submit"] = function(event) {
		that["fireSubmit"](that["sId"]);
	};
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["initialize"] = 0; };

UCF_Form["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["destroy"]++; }; 
	if (this["oDomRef"]) {
		this["oDomRef"]["submit"] = null;
		this["oDomRef"]["_SAP_UCF_oldHandlerSubmit_"] = null;
	}

	// notify event handler, who has to delete form-related queue data
	this["fireEvent"](this["E_EVENTS"]["Destroy"], { "Id": this["sId"] });

	if (this["oDomRef"]) {
		this["detachBrowserEvent"]("submit", this["oDomRef"]);
		this["detachBrowserEvent"]("reset", this["oDomRef"]);
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["destroy"] = 0; };

/**
 * onsubmit handler for browser event.
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Form["prototype"]["onsubmit"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["onsubmit"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Form.js(73): onsubmit"); };
	this["fireSubmit"](this["sId"]);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["onsubmit"] = 0; };

/**
 * mapi call allowing submit the form from other controls
 */
UCF_Form["prototype"]["submit"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["submit"]++; }; 
	this["oDomRef"]['_SAP_UCF_oldHandlerSubmit_']();
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["submit"] = 0; };

/**
 * onreset handler for browser event.
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Form["prototype"]["onreset"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["onreset"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Form.js(90): onreset"); };
	this["fireReset"](this["sId"]);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["onreset"] = 0; };

/**
 * appends new hidden field to the form
 * @param {string} sName
 * @param {string} sValue
 */
UCF_Form["prototype"]["appendHiddenField"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["appendHiddenField"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) == "string", "typeof(sName) == \"string\"", "Form.js(102): appendHiddenField"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != "", "sName != \"\"", "Form.js(103): appendHiddenField"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Form.js(104): appendHiddenField"); };

	// Due to MSIE specialites (Aaagr!!!) we have to use following nasty code
	// see also:
	//   http://msdn2.microsoft.com/en-us/library/ms534184.aspx
	//   http://www.thunderguy.com/semicolon/2005/05/23/setting-the-name-attribute-in-internet-explorer/
	//   http://alt-tag.com/blog/archives/2006/02/ie-dom-bugs/
	var oElem = null;
	try {
		// MSIE nasty hack
		oElem = document["createElement"]("<input type='hidden' name='" + sName + "'/>");
		oElem["value"] = sValue;
		this["oDomRef"]["appendChild"](oElem);
	} catch (e) {}
	if (!oElem || oElem["nodeName"] != "INPUT") {
		// Non MSIE browser, take standard canonical methods for named element
		oElem = document["createElement"]("input");
		oElem["type"] = "hidden";
		oElem["name"] = sName;
		oElem["value"] = sValue;
		this["oDomRef"]["appendChild"](oElem);
	}
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["appendHiddenField"] = 0; };

/**
 * associates new value to given form field. if such field not yet
 * exists, it is automatically created.
 * @param {string} sName
 * @param {string} sValue
 */
UCF_Form["prototype"]["putHiddenField"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["putHiddenField"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) == "string", "typeof(sName) == \"string\"", "Form.js(136): putHiddenField"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != "", "sName != \"\"", "Form.js(137): putHiddenField"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Form.js(138): putHiddenField"); };

	//all names that are function on this.oDomRef.elements are not supported
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != "id", "sName != \"id\"", "Form.js(141): putHiddenField"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != "name", "sName != \"name\"", "Form.js(142): putHiddenField"); };

	// Check whether the form contains the hidden field
	// with given name - conside there can be more of them
	var oElem = this["oDomRef"]["elements"][sName];
	if (oElem) {
		if (oElem["length"]) {
			// several elements found, iterate backwards and find first right match
			for (var i = oElem["length"] - 1; i >= 0; i--) {
				if (oElem[i] && oElem[i]["type"] && (oElem[i]["type"] == "hidden")) {
					oElem[i]["value"] = sValue;
					return;
				}
			}
		} else {
			// single node found, just try this
			if (oElem && oElem["type"] && (oElem["type"] == "hidden")) {
				oElem["value"] = sValue;
				return;
			}
		}
	}

	// not found, add it to the current form
	this["appendHiddenField"](sName, sValue);
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["putHiddenField"] = 0; };

/**
 * creates or modifies hidden form fields specified by name/value map
 * @private
 */
UCF_Form["prototype"]["putHiddenFieldsByMap"] = function(mFieldMap) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["putHiddenFieldsByMap"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(mFieldMap) == "object", "typeof(mFieldMap) == \"object\"", "Form.js(175): putHiddenFieldsByMap"); };
	for (var sName in mFieldMap) {
		this["putHiddenField"](sName, mFieldMap[sName]);
	}
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["putHiddenFieldsByMap"] = 0; };

/**
 * Sets the action method / URL of the form, SubmitMethod, see also ActionMethod property on control interface
 * @param {String} sActionMethod
 */
UCF_Form["prototype"]["setActionMethod"] = function(sActionMethod) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["setActionMethod"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sActionMethod) == "string", "typeof(sActionMethod) == \"string\"", "Form.js(187): setActionMethod"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sActionMethod != "", "sActionMethod != \"\"", "Form.js(188): setActionMethod"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Form.action changed to:" + sActionMethod, "Form.js(189): setActionMethod"); };

	this["oDomRef"]["action"] = sActionMethod;
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["setActionMethod"] = 0; };

/**
 * Sets the submit method of the form, see also SubmitMethod property on control interface
 * @param {String} sSubmitMethod
 */
UCF_Form["prototype"]["setSubmitMethod"] = function(sSubmitMethod) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["setSubmitMethod"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSubmitMethod) == "string", "typeof(sSubmitMethod) == \"string\"", "Form.js(200): setSubmitMethod"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSubmitMethod != "", "sSubmitMethod != \"\"", "Form.js(201): setSubmitMethod"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Form.method chagned to:" + sSubmitMethod, "Form.js(202): setSubmitMethod"); };

	this["oDomRef"]["method"] = sSubmitMethod;
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["setSubmitMethod"] = 0; };

/**
 * Sets the Target of the form, see also Target property on control interface
 * @param {String} sTarget
 */
UCF_Form["prototype"]["setTarget"] = function(sTarget) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["setTarget"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTarget) == "string", "typeof(sTarget) == \"string\"", "Form.js(213): setTarget"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTarget != "", "sTarget != \"\"", "Form.js(214): setTarget"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Form.target changed to:" + sTarget, "Form.js(215): setTarget"); };

	this["oDomRef"]["target"] = sTarget;
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["setTarget"] = 0; };

/**
 * Sets the action of the form
 *
 * @param {String} sAction
 */
UCF_Form["prototype"]["setAction"] = function(sAction) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["setAction"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAction) == "string", "typeof(sAction) == \"string\"", "Form.js(226): setAction"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAction != "", "sAction != \"\"", "Form.js(227): setAction"); };

	this["oDomRef"]["action"] = sAction;
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["setAction"] = 0; };

/**
 * Returns the action of the form
 */
UCF_Form["prototype"]["sGetAction"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["sGetAction"]++; }; 
	return this["oDomRef"]["action"];
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["sGetAction"] = 0; };

/**
 * Saves the content of all autocomplete enabled fields in this form
 */
UCF_Form["prototype"]["saveAutoComplete"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["saveAutoComplete"]++; }; 
	if (window["external"] && "AutoCompleteSaveForm" in window["external"]) {
		window["external"]["AutoCompleteSaveForm"](this["oDomRef"]);
	} else {
		var sEncType = this["oDomRef"]["enctype"];

		this["oDomRef"]["enctype"] = "application/x-www-form-urlencoded";

		this["oDomRef"]["_SAP_UCF_oldHandlerSubmit_"]();

		this["oDomRef"]["enctype"] = sEncType;
	}
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["saveAutoComplete"] = 0; };

/** WDA only: for stateless until REST channel was established
 * @deprecated
 * @public
 */
UCF_Form["prototype"]["getId"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["getId"]++; }; 
	return this["sId"];
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["getId"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Form["prototype"]["aAttributeNames"] = ["bHasEventQueue","sResponseData","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Form["prototype"]["aEventNames"] = ["Submit","Reset","Request"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Form["prototype"]["aMethodNames"] = ["submit","appendHiddenField","putHiddenField","setActionMethod","setSubmitMethod","setTarget","getId","saveAutoComplete","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {boolean}
 */
UCF_Form["prototype"]["bHasEventQueue"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.FormResponseData}
 */
UCF_Form["prototype"]["sResponseData"] = "FULL";

/**
 * @private
 * @type {string}
 */
UCF_Form["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Form["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["setDefaultValues"]++; }; 
	this["bHasEventQueue"] = false;
	this["sResponseData"] = "FULL";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("HasEventQueue", false, true);
		this["setClientProperty"]("ResponseData", "FULL", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control in the current HTML document context. The Id of any control should be unique within the document.
 * @fires Form::Submit
 */
UCF_Form["prototype"]["fireSubmit"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireSubmit"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Form.js(327): fireSubmit"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Form.js(328): fireSubmit"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Form.js(329): fireSubmit"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Form", "Submit", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireSubmit"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control in the current HTML document context. The Id of any control should be unique within the document.
 * @fires Form::Reset
 * @deprecated
 */
UCF_Form["prototype"]["fireReset"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireReset"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Form.js(347): fireReset"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Form.js(348): fireReset"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Form.js(349): fireReset"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Form", "Reset", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireReset"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the page control
 * @param {boolean} bAsync Determines whether the request is sent synchronously (false,default) or asynchronously(true)
 * @param {string} sFocusInfo Detailed focus information including cursor position and internal control settings. Pass this string to the method setFocus() on the page to the client in order to apply the focus information again after a roundtrip.
 * @param {string} sHash Hash part of the current URL
 * @param {boolean} bDomChanged Determines whether the client side browser dom was changed on the client by a user interaction after the last request.
 * @param {boolean} bIsDirty Deterimines the current value of Dirty Flag needed for WorkProtect feature.
 * @fires Form::Request
 */
UCF_Form["prototype"]["fireRequest"] = function(sId, bAsync, sFocusInfo, sHash, bDomChanged, bIsDirty) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireRequest"]++; }; 
	/** @type {{Id: string, Async: boolean, FocusInfo: string, Hash: string, DomChanged: boolean, IsDirty: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 6, "arguments.length == 6", "Form.js(371): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Form.js(372): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Form.js(373): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAsync != null, "bAsync != null", "Form.js(374): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAsync) == "boolean", "typeof(bAsync) == \"boolean\"", "Form.js(375): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFocusInfo != null, "sFocusInfo != null", "Form.js(376): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFocusInfo) == "string", "typeof(sFocusInfo) == \"string\"", "Form.js(377): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHash != null, "sHash != null", "Form.js(378): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHash) == "string", "typeof(sHash) == \"string\"", "Form.js(379): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bDomChanged != null, "bDomChanged != null", "Form.js(380): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bDomChanged) == "boolean", "typeof(bDomChanged) == \"boolean\"", "Form.js(381): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsDirty != null, "bIsDirty != null", "Form.js(382): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsDirty) == "boolean", "typeof(bIsDirty) == \"boolean\"", "Form.js(383): fireRequest"); };
	mParams = {
		"Id": sId,
		"Async": bAsync,
		"FocusInfo": sFocusInfo,
		"Hash": sHash,
		"DomChanged": bDomChanged,
		"IsDirty": bIsDirty
	};
	
	
	
	
	
	
	this["fireSemanticEvent"]("Form", "Request", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireRequest"] = 0; };

UCF_Form.prototype["aPublicMethods"] = ["getId"].concat(UCF_Form.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_FormattedTextView"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * @typedef {Object} UCF_FormattedTextView_LinkData
 * @property {'client'|'server'} target
 * @property {string} [url]
 */

/**
 * @class
 * @extends UCF_Control
 * 
 * @param {HTMLElement} oDomRef the DOM element of the FormattedTextView
 * @param {UCF_LS} oLS the LightSpeed instance managing the control
 */
function UCF_FormattedTextView(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["UCF_FormattedTextView"]++; }; 
	/** @type {number} */
	var iChildNodeCount;
	/** @type {number} */
	var iChildAnchorCount;
	/** @type {string} */
	var sText;
	/** @type {string} */
	var sInnerText;
	/** @type {HTMLElement} */
	var oChildNode;

	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "FormattedTextView.js(46): UCF_FormattedTextView"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "FormattedTextView.js(47): UCF_FormattedTextView"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "FormattedTextView.js(48): UCF_FormattedTextView"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["allowTextSelection"]();
		/** @type {boolean} */
		this["bForwardFocus"] = false;
		/** @type {Object<string,UCF_FormattedTextView_LinkData>} */
		this["oLinkData"] = UCF_JsUtil["oJsonParse"](this["sLinkData"]);

		if (window["UCF_System"]["bIs508"]) {
			iChildNodeCount = 0;
			iChildAnchorCount = 0;
			sText = UCF_DomUtil["sGetInnerText"](this["oDomRef"]);
			sInnerText = '';

			// AccessibilityHelper overwrites title attribute -> store title of child
			// Anchors in origTitle
			oChildNode = UCF_DomUtil["firstChild"](this["oDomRef"]);
			while (oChildNode != null) {
				if (oChildNode["tagName"] === 'A' && oChildNode["getAttribute"]('href')) {
					oChildNode["setAttribute"]('origTitle', oChildNode["title"]);
					iChildAnchorCount++;
				}
				sInnerText = sInnerText["concat"](UCF_DomUtil["sGetInnerText"](oChildNode));
				oChildNode = UCF_DomUtil["nextSibling"](oChildNode);
				iChildNodeCount++;
			}
			// Check for exactly one child anchor. Then don't process tabstop at
			// FormattedTextView control but at child anchor
			if (iChildNodeCount === 1 &&
				iChildAnchorCount === 1 &&
				sText === sInnerText
			) {
				UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
				/** @type {boolean} */
				this["bForwardFocus"] = true;
			}
		}
	}
};window["UCF_FormattedTextView"] = UCF_FormattedTextView; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FormattedTextView"); UCF_FormattedTextView["_"] = {UCF_FormattedTextView: 0}; }; ;
UCF_FormattedTextView["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_FormattedTextView.prototype["sClassName"] = "UCF_FormattedTextView";

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_FormattedTextView["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["onclick"]++; }; 
	/** @type {string} */
	var sUrl = this["sGetActivateUrl"](oBrowserEvent) || '';

	if (this["bHasEventListeners"]('LinkActivate') && sUrl) {
		this["fireLinkActivate"](this["sId"], sUrl);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["onclick"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {string}
 */
UCF_FormattedTextView["prototype"]["sGetActivateUrl"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["sGetActivateUrl"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {UCF_FormattedTextView_LinkData} */
	var oLinkData;

	while (oSource && oSource !== this["oDomRef"]) {
		if (oSource["tagName"] === 'A') {
			oLinkData = this["oLinkData"] && this["oLinkData"][oSource["getAttribute"]('id')];

			if (!oLinkData || oLinkData["target"] === 'server') {
				// fire server side event if LinkData doesn't exists (legacy
				// implementaion) or for the given sId no LinkData exists or for the
				// given sId target=server is defined
				// else assume client side link --> don't fire LinkActivate and don't
				// cancel
				return (oLinkData && oLinkData["url"])
					? oLinkData["url"]
					: oSource["getAttribute"]('href');
			}
		}
		oSource = oSource["parentNode"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["sGetActivateUrl"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_FormattedTextView["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["onmousedown"]++; }; 
	if (
		this["bHasEventListeners"]('LinkActivate') &&
		this["sGetActivateUrl"](oBrowserEvent)
	) {
		// CSN 1970275714: SapTableCS fires RowSelect on mousedown => need do
		// cancelBubble the mousedown when a click will fire the LinkActivate
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["onmousedown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_FormattedTextView["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FormattedTextView.js(159): onlsfocus"); };

	if (window["UCF_System"]["bIs508"]) {
		if (this["bForwardFocus"] && oBrowserEvent["oGetSource"]() === this["oDomRef"]) {
			UCF_DomUtil["focusDomElement"](UCF_DomUtil["firstChild"](this["oDomRef"]));
			this["bForwardFocus"] = false;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["onlsfocus"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_FormattedTextView["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	/** @type {string} */
	var sText = UCF_DomUtil["sGetInnerText"](this["oDomRef"]);
	/** @type {string} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {string} */
	var sOrigTitle;
	/** @type {string} */
	var sAccesskey;

	if (oSource === this["oDomRef"]) {
		if (UCF_StringUtil["bIsEmpty"](sText)) {
			oAccessibilityHelper["setEmpty"](true);
		} else {
			oAccessibilityHelper["setText"](sText);
		}

		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		oAccessibilityHelper["applyLabelingInfo"](this);
		oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());
	} else if (oSource["tagName"] === 'A') {
		sText = UCF_DomUtil["sGetInnerText"](oSource);
		if (UCF_StringUtil["bIsEmpty"](sText)) {
			oAccessibilityHelper["setEmpty"](true);
		} else {
			oAccessibilityHelper["setText"](sText);
		}

		sOrigTitle = oSource["getAttribute"]('origTitle');
		if (sOrigTitle !== '') {
			oAccessibilityHelper["setTooltip"](sOrigTitle);
		}

		sAccesskey = oSource["getAttribute"]('accesskey');
		if (sAccesskey !== '') {
			oAccessibilityHelper["setAccessKey"](sAccesskey);
		}

		oAccessibilityHelper["setControlType"]('LN');
		oAccessibilityHelper["addEnabledTutor"]('LN_TUT', true);
	}
};;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["onlsaccessibility"] = 0; };

UCF_FormattedTextView["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["destroy"]++; }; 

	this["oLinkData"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_FormattedTextView["prototype"]["aAttributeNames"] = ["sTextDesign","sTooltip","sVisibility","sCustomData","sLabelledBy","sCustomStyle","sLinkData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_FormattedTextView["prototype"]["aEventNames"] = ["LinkActivate"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_FormattedTextView["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputDesign}
 */
UCF_FormattedTextView["prototype"]["sTextDesign"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_FormattedTextView["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_FormattedTextView["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_FormattedTextView["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_FormattedTextView["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {string}
 */
UCF_FormattedTextView["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_FormattedTextView["prototype"]["sLinkData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_FormattedTextView["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["setDefaultValues"]++; }; 
	this["sTextDesign"] = "STANDARD";
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';
	this["sCustomStyle"] = '';
	this["sLinkData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("TextDesign", "STANDARD", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("LinkData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the FormattedTextView control.
 * @param {string} sUrl The URL of the clicked link.
 * @fires FormattedTextView::LinkActivate
 */
UCF_FormattedTextView["prototype"]["fireLinkActivate"] = function(sId, sUrl) {;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["fireLinkActivate"]++; }; 
	/** @type {{Id: string, Url: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "FormattedTextView.js(320): fireLinkActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "FormattedTextView.js(321): fireLinkActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "FormattedTextView.js(322): fireLinkActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sUrl != null, "sUrl != null", "FormattedTextView.js(323): fireLinkActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sUrl) == "string", "typeof(sUrl) == \"string\"", "FormattedTextView.js(324): fireLinkActivate"); };
	mParams = {
		"Id": sId,
		"Url": sUrl
	};
	
	
	this["fireSemanticEvent"]("FormattedTextView", "LinkActivate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_FormattedTextView["_"]["fireLinkActivate"] = 0; };

};
sap["ls"]["preload"]["UCF_FreeContextualArea"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Expander */
/// <reference path="../anim/Expander.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

//to do: Trigger Default Button
/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_FreeContextualArea(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["UCF_FreeContextualArea"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "FreeContextualArea.js(29): UCF_FreeContextualArea"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "FreeContextualArea.js(30): UCF_FreeContextualArea"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "FreeContextualArea.js(31): UCF_FreeContextualArea"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	//initialize the default button for this control
	this["setDefaultButtonId"](this["sDefaultButtonId"]);
	// declare properties
	if (this["bExpandable"]) {
		this["oExpandIcon"] = document["getElementById"](this["sId"] + "-exp");
		this["oContent"] = document["getElementById"](this["sId"] + "-cnt");
		this["oExpander"] = new (UCF_ClassLoader["oGetClass"]("UCF_Expander"))(this["oContent"]);
	}

};window["UCF_FreeContextualArea"] = UCF_FreeContextualArea; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FreeContextualArea"); UCF_FreeContextualArea["_"] = {UCF_FreeContextualArea: 0}; }; ;
UCF_FreeContextualArea["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_FreeContextualArea.prototype["sClassName"] = "UCF_FreeContextualArea";

/**
 * Handles the onclick event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_FreeContextualArea["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FreeContextualArea.js(54): onclick"); };

	var oSource = oBrowserEvent["oGetSource"](),
		sSourceId = oSource["getAttribute"]("id");
	if (this["bExpandable"] && sSourceId && sSourceId["indexOf"]("-exp") > -1 && this["bExpandable"]) {
		this["toggle"](oBrowserEvent);
	} else if (sSourceId && sSourceId["indexOf"]("-pers") > -1) {
		this["firePersonalize"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onclick"] = 0; };

/**
 * Handles the expanding
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_FreeContextualArea["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onlsexpand"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FreeContextualArea.js(72): onlsexpand"); };
	if (this["bExpandable"] && this["oDomRef"] === oBrowserEvent["oGetSource"]()) {
		this["expand"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onlsexpand"] = 0; };

UCF_FreeContextualArea["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onlscollapse"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FreeContextualArea.js(81): onlscollapse"); };
	if (this["bExpandable"] && this["oDomRef"] === oBrowserEvent["oGetSource"]()) {
		this["collapse"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onlscollapse"] = 0; };

/**
 * Handles the keydown event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_FreeContextualArea["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onkeydown"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FreeContextualArea.js(97): onkeydown"); };

	if (oBrowserEvent["bAlt"]() || oBrowserEvent["bCtrl"]() || oBrowserEvent["bShift"]()) {
		return;
	}

	var iKey = oBrowserEvent["iKeyCode"](),
		oSource = oBrowserEvent["oGetSource"](),
		sSourceId = oSource["getAttribute"]("id");

	if (iKey === UCF_KeyCodes["ENTER"] && sSourceId["indexOf"]("-pers") > -1) {
		this["firePersonalize"](this["sId"]);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onkeydown"] = 0; };

/**
 * Handles the onlsskipforward event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_FreeContextualArea["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FreeContextualArea.js(121): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onlsskipforward"] = 0; };

/**
 * Handles the onlsskipback event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_FreeContextualArea["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FreeContextualArea.js(132): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onlsskipback"] = 0; };

UCF_FreeContextualArea["prototype"]["expand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["expand"]++; }; 
	if (!this["bExpanded"]) {
		UCF_DomUtil["replaceClass"](this["oExpandIcon"], "urFRAExpClo", "urFRAExpOp");
		UCF_DomUtil["$"](this["sId"] + "-cnt")["style"]["display"] = "block";
		this["fireExpand"](this["sId"]);
		this["bExpanded"] = true;
		this["setClientProperty"]("Expanded", this["bExpanded"], true);
	}

};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["expand"] = 0; };

UCF_FreeContextualArea["prototype"]["collapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["collapse"]++; }; 
	if (this["bExpanded"]) {
		UCF_DomUtil["replaceClass"](this["oExpandIcon"], "urFRAExpOp", "urFRAExpClo");

		UCF_DomUtil["$"](this["sId"] + "-cnt")["style"]["display"] = "none";
		this["fireCollapse"](this["sId"]);
		this["bExpanded"] = false;
		this["setClientProperty"]("Expanded", this["bExpanded"], true);
	}
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["collapse"] = 0; };

/**
 * Handles opening and closing of free contextual area
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_FreeContextualArea["prototype"]["toggle"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["toggle"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FreeContextualArea.js(163): toggle"); };

	var sSourceId = oBrowserEvent["oGetSource"]()["id"],
		bIsFCA = (UCF_JsUtil["bInstanceOf"](oBrowserEvent["oGetSourceControl"](), "UCF_FreeContextualArea") && sSourceId["indexOf"]("-pers") === -1 && sSourceId["indexOf"]("-end") === -1);

	if (!bIsFCA)
		return;

	if (this["bExpanded"]) {
		this["collapse"]();
	} else {
		this["expand"]();
	}
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["toggle"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_FreeContextualArea["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "FreeContextualArea.js(183): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this)
		return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSource = oBrowserEvent["oGetSource"]();

	if (oSource === this["oDomRef"]) {
		oAccessibilityHelper["setText"](this["sTitle"]);
		oAccessibilityHelper["setControlType"]("FRA");

		oAccessibilityHelper["applyContainerEntryBehaviour"](this["bExpandable"], true, !this["bExpanded"]);
	} else if (oSource["id"]["indexOf"]("-pers") > -1) {
		oAccessibilityHelper["setControlType"]("PERS");
		oAccessibilityHelper["addTutor"]("LN_TUT");
	} else if (oSource["id"]["indexOf"]("-end") > -1) {
		oAccessibilityHelper["setControlType"]("G_END");
	}
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["onlsaccessibility"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @public
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 */
UCF_FreeContextualArea["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["setDefaultButtonId"]++; }; 
	UCF_Control.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["setDefaultButtonId"] = 0; };

UCF_FreeContextualArea["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["destroy"]++; }; 

	this["oExpandIcon"] = null;
	this["oContent"] = null;
	if (this["oExpander"]) {
		this["oExpander"]["destroy"]();
		this["oExpander"] = null;
	}

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_FreeContextualArea["prototype"]["aAttributeNames"] = ["sTitle","bExpandable","bExpanded","bPersonalizable","sDefaultButtonId","iHeadingLevel","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_FreeContextualArea["prototype"]["aEventNames"] = ["Expand","Collapse","Personalize"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_FreeContextualArea["prototype"]["aMethodNames"] = ["setDefaultButtonId","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_FreeContextualArea["prototype"]["sTitle"] = 'Title';

/**
 * @private
 * @type {boolean}
 */
UCF_FreeContextualArea["prototype"]["bExpandable"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_FreeContextualArea["prototype"]["bExpanded"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_FreeContextualArea["prototype"]["bPersonalizable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_FreeContextualArea["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_FreeContextualArea["prototype"]["iHeadingLevel"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_FreeContextualArea["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_FreeContextualArea["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["setDefaultValues"]++; }; 
	this["sTitle"] = 'Title';
	this["bExpandable"] = false;
	this["bExpanded"] = true;
	this["bPersonalizable"] = false;
	this["sDefaultButtonId"] = '';
	this["iHeadingLevel"] = 0;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Title", 'Title', true);
		this["setClientProperty"]("Expandable", false, true);
		this["setClientProperty"]("Expanded", true, true);
		this["setClientProperty"]("Personalizable", false, true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires FreeContextualArea::Expand
 */
UCF_FreeContextualArea["prototype"]["fireExpand"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["fireExpand"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "FreeContextualArea.js(321): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "FreeContextualArea.js(322): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "FreeContextualArea.js(323): fireExpand"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("FreeContextualArea", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["fireExpand"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires FreeContextualArea::Collapse
 */
UCF_FreeContextualArea["prototype"]["fireCollapse"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "FreeContextualArea.js(340): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "FreeContextualArea.js(341): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "FreeContextualArea.js(342): fireCollapse"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("FreeContextualArea", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["fireCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires FreeContextualArea::Personalize
 */
UCF_FreeContextualArea["prototype"]["firePersonalize"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["firePersonalize"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "FreeContextualArea.js(359): firePersonalize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "FreeContextualArea.js(360): firePersonalize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "FreeContextualArea.js(361): firePersonalize"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("FreeContextualArea", "Personalize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_FreeContextualArea["_"]["firePersonalize"] = 0; };

UCF_FreeContextualArea.prototype["aPublicMethods"] = ["setDefaultButtonId"].concat(UCF_FreeContextualArea.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_GeoMap"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * GeoMap
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_GeoMap(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["UCF_GeoMap"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "GeoMap.js(28): UCF_GeoMap"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "GeoMap.js(29): UCF_GeoMap"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "GeoMap.js(30): UCF_GeoMap"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_GeoMap"] = UCF_GeoMap; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_GeoMap"); UCF_GeoMap["_"] = {UCF_GeoMap: 0}; }; ;
UCF_GeoMap["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_GeoMap.prototype["sClassName"] = "UCF_GeoMap";

/**
 * Handles events on the access fragments of the control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_GeoMap["prototype"]["handleAccessFragments"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["handleAccessFragments"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "GeoMap.js(45): handleAccessFragments"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessFragment = this["oGetAccessFragment"](oSource);

	if (!oAccessFragment) return;

	var bHandled = false,
		sKey = oAccessFragment["sKey"],
		oValue = oAccessFragment["oValue"],
		oEvent, iX, iY;
	switch (sKey) {
		case "GEOMAPMOVE": {
			this["fireMove"](this["sId"], oValue["iX"], oValue["iY"]);
			bHandled = true;
			break;
		}
		case "GEOMAPZOOMSTEP": {
			this["fireZoomStep"](this["sId"], oValue["iZoomStep"]);
			bHandled = true;
			break;
		}
		case "GEOMAPZOOMIN": {
			this["fireZoomIn"](this["sId"]);
			bHandled = true;
			break;
		}
		case "GEOMAPZOOMOUT": {
			this["fireZoomOut"](this["sId"]);
			bHandled = true;
			break;
		}
		case "GEOMAPIMAGEMOVE": {
			oEvent = oBrowserEvent["oDomEvent"];
			iX = oEvent["offsetX"];
			iY = oEvent["offsetY"];
			this["fireImageMove"](this["sId"], iX, iY);
			bHandled = true;
			break;
		}
		case "GEOMAPIMAGEZOOM": {
			oEvent = oBrowserEvent["oDomEvent"];
			iX = oEvent["offsetX"];
			iY = oEvent["offsetY"];
			this["fireImageZoom"](this["sId"], iX, iY);
			bHandled = true;
			break;
		}
		case "GEOMAPRESET": {
			this["fireReset"](this["sId"]);
			bHandled = true;
			break;
		}
	}
	if (bHandled) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["handleAccessFragments"] = 0; };

/** @typedef {HTMLTableDataCellElement|HTMLImageElement|HTMLDivElement|HTMLAnchorElement} UCF_GeoMap_FragmentElement */
/**
 * @typedef {Object} UCF_GeoMap_PositionDelta
 * @property {number} iX
 * @property {number} iY
 */
/**
 * @typedef {Object} UCF_GeoMap_ZoomDelta
 * @property {number} iZoomStep
 */
/** @typedef {UCF_GeoMap_PositionDelta|UCF_GeoMap_ZoomDelta} UCF_GeoMap_Delta */
/**
 * Returns an access fragment object
 *
 * @param {HTMLElement} oDomRef The dom reference where to look for the access fragment
 * @return {{oDomRef: UCF_GeoMap_FragmentElement, sKey: string, oValue: UCF_GeoMap_Delta}}
 */
UCF_GeoMap["prototype"]["oGetAccessFragment"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["oGetAccessFragment"]++; }; 
	/** @type {UCF_GeoMap_FragmentElement} */
	var oFragmentDomRef = UCF_DomUtil["oGetParentByAttribute"](oDomRef, 'acf');

	return UCF_DomUtil["bContains"](this["oDomRef"], oFragmentDomRef)
		? {
			"oDomRef": oFragmentDomRef,
			"sKey": UCF_DomUtil["sGetAttribute"](oFragmentDomRef, 'acf'),
			"oValue": UCF_JsUtil["oJsonParse"](UCF_DomUtil["sGetAttribute"](oFragmentDomRef, 'acfvalue'))
		}
		: null;
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["oGetAccessFragment"] = 0; };

/**
 * Handles all clicks and dispatches to access fragments
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_GeoMap["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "GeoMap.js(143): onclick"); };

	if (oBrowserEvent["bIsTouchInteraction"]()) return;

	var oSourceRef = oBrowserEvent["oGetSource"]();
	if (oSourceRef["tagName"]["toLowerCase"]() === "area") {
		var sAreaId = oSourceRef["getAttribute"]("areaid");
		this["fireImageMapClick"](this["sId"], sAreaId);
	} else {
		this["handleAccessFragments"](oBrowserEvent);
	}

};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onclick"] = 0; };

UCF_GeoMap["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlstouchend"]++; }; 

	var oSourceRef = oBrowserEvent["oGetSource"]();
	if (oSourceRef["tagName"]["toLowerCase"]() === "area") {
		var sAreaId = oSourceRef["getAttribute"]("areaid");
		this["fireImageMapClick"](this["sId"], sAreaId);
	} else {
		this["handleAccessFragments"](oBrowserEvent);
	}

};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlstouchend"] = 0; };

/**
 * Handles lsup and fires a move if the focus is on the image of the geomap
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_GeoMap["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "GeoMap.js(176): onlsup"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessFragment = this["oGetAccessFragment"](oSource);

	if (!oAccessFragment) return;
	if (oAccessFragment["sKey"] === "GEOMAPIMAGEMOVE") {
		this["fireMove"](this["sId"], 0, -1);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsup"] = 0; };

/**
 * Handles lsdown and fires a move if the focus is on the image of the geomap
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_GeoMap["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsdown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "GeoMap.js(197): onlsdown"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessFragment = this["oGetAccessFragment"](oSource);

	if (!oAccessFragment) return;

	if (oAccessFragment["sKey"] === "GEOMAPIMAGEMOVE") {
		this["fireMove"](this["sId"], 0, 1);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsdown"] = 0; };

/**
 * Handles lsleft and fires a move if the focus is on the image of the geomap
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_GeoMap["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsleft"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "GeoMap.js(218): onlsleft"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessFragment = this["oGetAccessFragment"](oSource);

	if (!oAccessFragment) return;

	if (oAccessFragment["sKey"] === "GEOMAPIMAGEMOVE") {
		this["fireMove"](this["sId"], -1, 0);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsleft"] = 0; };

/**
 * Handles lsleft and fires a move if the focus is on the image of the geomap
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_GeoMap["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsright"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "GeoMap.js(239): onlsright"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessFragment = this["oGetAccessFragment"](oSource);

	if (!oAccessFragment) return;

	if (oAccessFragment["sKey"] === "GEOMAPIMAGEMOVE") {
		this["fireMove"](this["sId"], 1, 0);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsright"] = 0; };

/**
 * Handles lsselect and dispatches to the access fragment handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_GeoMap["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "GeoMap.js(260): onlsselect"); };
	this["handleAccessFragments"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsselect"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_GeoMap["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_GeoMap["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsskipback"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_GeoMap["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "GeoMap.js(295): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setControlType"]("GM");
	oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["applyContainerEntryBehaviour"]();

};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_GeoMap["prototype"]["aAttributeNames"] = ["sAccessibilityDescription","sVisibility","sTooltip","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_GeoMap["prototype"]["aEventNames"] = ["Move","ImageMove","ImageZoom","ImageMapClick","ZoomIn","ZoomOut","ZoomStep","Reset"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_GeoMap["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_GeoMap["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_GeoMap["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_GeoMap["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_GeoMap["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_GeoMap["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["setDefaultValues"]++; }; 
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iDirectionX Returns the movement in x direction (horizontal) in the GeoMap control.
 * @param {number} iDirectionY Returns the movement in y direction (vertical) in the GeoMap control.
 * @fires GeoMap::Move
 */
UCF_GeoMap["prototype"]["fireMove"] = function(sId, iDirectionX, iDirectionY) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireMove"]++; }; 
	/** @type {{Id: string, DirectionX: number, DirectionY: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "GeoMap.js(381): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "GeoMap.js(382): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "GeoMap.js(383): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDirectionX != null, "iDirectionX != null", "GeoMap.js(384): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDirectionX) == "number", "typeof(iDirectionX) == \"number\"", "GeoMap.js(385): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDirectionY != null, "iDirectionY != null", "GeoMap.js(386): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDirectionY) == "number", "typeof(iDirectionY) == \"number\"", "GeoMap.js(387): fireMove"); };
	mParams = {
		"Id": sId,
		"DirectionX": iDirectionX,
		"DirectionY": iDirectionY
	};
	
	
	
	this["fireSemanticEvent"]("GeoMap", "Move", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireMove"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iPositionX Horizontal offset of the click inside the image
 * @param {number} iPositionY Vertical offset of the click inside the image
 * @fires GeoMap::ImageMove
 */
UCF_GeoMap["prototype"]["fireImageMove"] = function(sId, iPositionX, iPositionY) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireImageMove"]++; }; 
	/** @type {{Id: string, PositionX: number, PositionY: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "GeoMap.js(410): fireImageMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "GeoMap.js(411): fireImageMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "GeoMap.js(412): fireImageMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionX != null, "iPositionX != null", "GeoMap.js(413): fireImageMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionX) == "number", "typeof(iPositionX) == \"number\"", "GeoMap.js(414): fireImageMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionY != null, "iPositionY != null", "GeoMap.js(415): fireImageMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionY) == "number", "typeof(iPositionY) == \"number\"", "GeoMap.js(416): fireImageMove"); };
	mParams = {
		"Id": sId,
		"PositionX": iPositionX,
		"PositionY": iPositionY
	};
	
	
	
	this["fireSemanticEvent"]("GeoMap", "ImageMove", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireImageMove"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iPositionX Horizontal offset of the click inside the image
 * @param {number} iPositionY Vertical offset of the click inside the image
 * @fires GeoMap::ImageZoom
 */
UCF_GeoMap["prototype"]["fireImageZoom"] = function(sId, iPositionX, iPositionY) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireImageZoom"]++; }; 
	/** @type {{Id: string, PositionX: number, PositionY: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "GeoMap.js(439): fireImageZoom"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "GeoMap.js(440): fireImageZoom"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "GeoMap.js(441): fireImageZoom"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionX != null, "iPositionX != null", "GeoMap.js(442): fireImageZoom"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionX) == "number", "typeof(iPositionX) == \"number\"", "GeoMap.js(443): fireImageZoom"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionY != null, "iPositionY != null", "GeoMap.js(444): fireImageZoom"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionY) == "number", "typeof(iPositionY) == \"number\"", "GeoMap.js(445): fireImageZoom"); };
	mParams = {
		"Id": sId,
		"PositionX": iPositionX,
		"PositionY": iPositionY
	};
	
	
	
	this["fireSemanticEvent"]("GeoMap", "ImageZoom", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireImageZoom"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sAreaId Id of the area that was clicked in the connected image map 
 * @fires GeoMap::ImageMapClick
 */
UCF_GeoMap["prototype"]["fireImageMapClick"] = function(sId, sAreaId) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireImageMapClick"]++; }; 
	/** @type {{Id: string, AreaId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "GeoMap.js(467): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "GeoMap.js(468): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "GeoMap.js(469): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAreaId != null, "sAreaId != null", "GeoMap.js(470): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAreaId) == "string", "typeof(sAreaId) == \"string\"", "GeoMap.js(471): fireImageMapClick"); };
	mParams = {
		"Id": sId,
		"AreaId": sAreaId
	};
	
	
	this["fireSemanticEvent"]("GeoMap", "ImageMapClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireImageMapClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires GeoMap::ZoomIn
 */
UCF_GeoMap["prototype"]["fireZoomIn"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireZoomIn"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "GeoMap.js(490): fireZoomIn"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "GeoMap.js(491): fireZoomIn"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "GeoMap.js(492): fireZoomIn"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("GeoMap", "ZoomIn", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireZoomIn"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires GeoMap::ZoomOut
 */
UCF_GeoMap["prototype"]["fireZoomOut"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireZoomOut"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "GeoMap.js(509): fireZoomOut"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "GeoMap.js(510): fireZoomOut"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "GeoMap.js(511): fireZoomOut"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("GeoMap", "ZoomOut", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireZoomOut"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iStepNumber Returns the step number.
 * @fires GeoMap::ZoomStep
 */
UCF_GeoMap["prototype"]["fireZoomStep"] = function(sId, iStepNumber) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireZoomStep"]++; }; 
	/** @type {{Id: string, StepNumber: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "GeoMap.js(529): fireZoomStep"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "GeoMap.js(530): fireZoomStep"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "GeoMap.js(531): fireZoomStep"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iStepNumber != null, "iStepNumber != null", "GeoMap.js(532): fireZoomStep"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iStepNumber) == "number", "typeof(iStepNumber) == \"number\"", "GeoMap.js(533): fireZoomStep"); };
	mParams = {
		"Id": sId,
		"StepNumber": iStepNumber
	};
	
	
	this["fireSemanticEvent"]("GeoMap", "ZoomStep", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireZoomStep"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires GeoMap::Reset
 */
UCF_GeoMap["prototype"]["fireReset"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireReset"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "GeoMap.js(552): fireReset"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "GeoMap.js(553): fireReset"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "GeoMap.js(554): fireReset"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("GeoMap", "Reset", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_GeoMap["_"]["fireReset"] = 0; };

};
sap["ls"]["preload"]["UCF_Ghost"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_Animation */
/// <reference path="../../anim/Animation.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>

/**
 * Abstract Implementation of a Ghost that is used for drag and drop operations.
 * @class
 * 
 * @param {HTMLElement} oGhostRef A DOM reference
 */
function UCF_Ghost(oGhostRef) {if (__UCF_COVERAGE__) { UCF_Ghost["_"]["UCF_Ghost"]++; }; 

	this["bApplyAlphaFilter"] = false;
	this["bVisible"] = true;
	this["iOffsetLeft"] = 0;
	this["iOffsetTop"] = 0;
	this["iExtensionOffsetLeft"] = -1;
	this["iExtensionOffsetTop"] = -1;
	this["bOffsetSet"] = false;
	this["oGhostRef"] = oGhostRef;
	this["bHandlerAttached"] = false;
	this["bRasterMode"] = false;

	this["fMoveHandler"] = null;
	this["fContextMenuHandler"] = null;

	//this.aRulers = null;
	this["oRulerRectManager"] = null;

	this["iScaling"] = null;
};window["UCF_Ghost"] = UCF_Ghost; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Ghost"); UCF_Ghost["_"] = {UCF_Ghost: 0}; }; ;

UCF_Ghost["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Ghost.prototype["sClassName"] = "UCF_Ghost";

UCF_Ghost["prototype"]["DROP_EFFECT"] = {
	"NONE": "NONE",
	"MOVE": "MOVE",
	"COPY": "COPY",
	"LINK": "LINK"
};

/**
 * this method should add the ghost to the dom
 */
UCF_Ghost["prototype"]["create"] = function (oRootContainerDomRef) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["create"]++; }; 

	//create shim overlay to prevent events
	//from getting lost in an iframe etc
	this["createShim"](oRootContainerDomRef);
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["create"] = 0; };

/**
 * Initialize this ghost for "raster" mode (e.g. for use in design time container combined with a raster layout).
 * The ghost position will "snap" to raster points during dragging.
 * @param iAreaLeft Page X position of the raster root
 * @param iAreaTop Page Y position of the raster root
 * @param iRasterWidth Raster width in pixel
 * @param iRasterHeight Raster height in pixel
 */
UCF_Ghost["prototype"]["setRasterMode"] = function (iAreaLeft, iAreaTop, iRasterWidth, iRasterHeight) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setRasterMode"]++; }; 
	this["bRasterMode"] = true;
	this["iAreaLeft"] = iAreaLeft;
	this["iAreaTop"] = iAreaTop;
	this["iRasterWidth"] = iRasterWidth;
	this["iRasterHeight"] = iRasterHeight;
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setRasterMode"] = 0; };

UCF_Ghost["prototype"]["iGetCurrentRasterX"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["iGetCurrentRasterX"]++; }; 
	return this["iCurrentRasterX"];
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["iGetCurrentRasterX"] = 0; };

UCF_Ghost["prototype"]["disableAnimation"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["disableAnimation"]++; }; 
	return this["bAnimationDisabled"] = true;
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["disableAnimation"] = 0; };

UCF_Ghost["prototype"]["iGetCurrentRasterY"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["iGetCurrentRasterY"]++; }; 
	return this["iCurrentRasterY"];
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["iGetCurrentRasterY"] = 0; };

/**
 * Support (down-)scaling of the ghost with CSS transform and transition
 * @param {number} iScaling Percent value (1..99)
 */
UCF_Ghost["prototype"]["setScaling"] = function (iScaling) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setScaling"]++; }; 
	this["iScaling"] = iScaling;
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setScaling"] = 0; };

/**
 * this method should update the ghost according to mouse position etc
 */
UCF_Ghost["prototype"]["update"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["update"]++; }; 

	var iX = oBrowserEvent["iPageX"](),
		iY = oBrowserEvent["iPageY"]();

	var iLeft; //, iCursorLeft;
	if (window["UCF_System"]["bIsRTL"]) {
		iLeft = iX - this["iOffsetLeft"] - this["iOriginalWidth"];
		//iCursorLeft = iX - this.iOriginalWidth - 10;
	} else {
		iLeft = iX + this["iOffsetLeft"];
		//iCursorLeft = iX - 10;
	}

	var iTop = iY + this["iOffsetTop"];
	//var iCursorTop = iY - 10;

	// TODO: RTL....
	// Make the ghost "snap" to raster points during dragging ...
	if (this["bRasterMode"]) {
		// The position of the ghost based on the mouse position
		var iRelX = iX - this["iAreaLeft"] + this["iOffsetLeft"];
		var iRelY = iY - this["iAreaTop"] + this["iOffsetTop"];

		// The desired raster position of the ghost
		this["iCurrentRasterX"] = Math["floor"](iRelX / this["iRasterWidth"]);
		this["iCurrentRasterY"] = Math["floor"](iRelY / this["iRasterHeight"]);

		// The "snap" position in page coords
		iLeft = this["iAreaLeft"] + this["iCurrentRasterX"] * this["iRasterWidth"];
		iTop = this["iAreaTop"] + this["iCurrentRasterY"] * this["iRasterHeight"];
	}

	// Scaling transformation: The outer DIV is not transformed but position and width/height are calculated and body-clipping is taken into account

	var iScalingFactor = this["iScaling"] ? this["iScaling"] / 100 : 1;
	var iRelPosX = iX - iLeft;
	var iRelPosY = iY - iTop;
	if (this["iScaling"]) {
		iLeft = iLeft + Math["floor"](iRelPosX - iScalingFactor * iRelPosX);
		iTop = iTop + Math["floor"](iRelPosY - iScalingFactor * iRelPosY);
	}

	this["oDomRef"]["style"]["left"] = iLeft + "px";
	this["oDomRef"]["style"]["top"] = iTop + "px";
	this["oShimRef"]["style"]["left"] = iLeft + "px";
	this["oShimRef"]["style"]["top"] = iTop + "px";
	if (this["oIFrameRef"]) {
		this["oIFrameRef"]["style"]["left"] = iLeft + "px";
		this["oIFrameRef"]["style"]["top"] = iTop + "px";
	}

	//	if (this.oCursorShimRef) {
	//		this.oCursorShimRef.style.left = iCursorLeft + "px";
	//		this.oCursorShimRef.style.top = iCursorTop + "px";
	//		this.oCursorShimRef.style.width = "20px";
	//		this.oCursorShimRef.style.height= "20px";
	//	}

	//clip to lower and right to avoid scrollbars
	var oViewportSize = UCF_DomUtil["oGetInnerSize"](window);
	var scrollOffset = UCF_DomUtil["oGetScrollOffset"](window);
	var iWidth;
	if (window["UCF_System"]["bIsRTL"]) {
		//20 is for the scrollbar bug
		iWidth = Math["min"](Math["floor"](this["iOriginalWidth"] * iScalingFactor), Math["max"](oViewportSize["width"] + scrollOffset["x"] - iLeft, 0) - 20);
		//iWidth = Math.min(this.iOriginalWidth, Math.max(oViewportSize.width + scrollOffset.x - iLeft,0) - 20);
	} else {
		iWidth = Math["min"](Math["floor"](this["iOriginalWidth"] * iScalingFactor), Math["max"](oViewportSize["width"] + scrollOffset["x"] - iLeft, 0));
		//iWidth = Math.min(this.iOriginalWidth, Math.max(oViewportSize.width + scrollOffset.x - iLeft, 0));
	}
	this["oDomRef"]["style"]["width"] = iWidth + "px";
	this["oShimRef"]["style"]["width"] = iWidth + "px";

	var iHeight = Math["min"](Math["floor"](this["iOriginalHeight"] * iScalingFactor), Math["max"](oViewportSize["height"] + scrollOffset["y"] - iTop, 0));
	//var iHeight = Math.min(this.iOriginalHeight, Math.max(oViewportSize.height + scrollOffset.y - iTop, 0));

	//hide the ghost so that it does not enlarge the document and causes endless scrolling
	if (iHeight == 0) {
		this["oDomRef"]["style"]["display"] = this["oShimRef"]["style"]["display"] = "none";
		if (this["oIFrameRef"]) {
			this["oIFrameRef"]["style"]["display"] = "none";
		}
	} else {
		this["oDomRef"]["style"]["display"] = this["oShimRef"]["style"]["display"] = "block";
		if (this["oIFrameRef"]) {
			this["oIFrameRef"]["style"]["display"] = "block";
		}
	}

	this["oDomRef"]["style"]["height"] = iHeight + "px";
	this["oShimRef"]["style"]["height"] = iHeight + "px";
	if (this["oIFrameRef"]) {
		this["oIFrameRef"]["style"]["width"] = iWidth + "px";
		this["oIFrameRef"]["style"]["height"] = iHeight + "px";
	}

	if (this["iExtensionOffsetLeft"] == -1 && this["iExtensionOffsetTop"] == -1) {
		this["oExtensionDomRef"]["style"]["left"] = iLeft + iWidth / 2 + "px";
		this["oExtensionDomRef"]["style"]["top"] = iTop + iHeight + 2 + "px";
	} else {
		this["oExtensionDomRef"]["style"]["left"] = iLeft + this["iExtensionOffsetLeft"] + "px";
		this["oExtensionDomRef"]["style"]["top"] = iTop + this["iExtensionOffsetTop"] + "px";
	}

	this["oRect"] = {
		"left": iLeft,
		"top": iTop,
		"width": iWidth,
		"height": iHeight
	};

	if (this["iScaling"] && this["oGhostRef"]["style"]["transition"] != undefined) {
		// The inner DIV will get the original size (without clipping calculations above!) that will be used for the transformation
		this["oGhostRef"]["style"]["width"] = this["iOriginalWidth"] + "px";
		this["oGhostRef"]["style"]["height"] = this["iOriginalHeight"] + "px";

		// Transformation:
		// The transform-origin is the relative mouse-pointer position on the ghost
		var sScale = "0." + (this["iScaling"] / 10);
		this["oGhostRef"]["style"]["transform"] = "scale(" + sScale + ")";
		this["oGhostRef"]["style"]["transformOrigin"] = iRelPosX + "px " + iRelPosY + "px";

		// Adjust the position inside the outer DIV to compensate the shrink-transformation position-offset
		this["oGhostRef"]["style"]["position"] = "relative";
		this["oGhostRef"]["style"]["left"] = "-" + Math["floor"](iRelPosX - iScalingFactor * iRelPosX) + "px";
		this["oGhostRef"]["style"]["top"] = "-" + Math["floor"](iRelPosY - iScalingFactor * iRelPosY) + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["update"] = 0; };

UCF_Ghost["prototype"]["applyAlphaFilter"] = function (bApplyAlphaFilter) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["applyAlphaFilter"]++; }; 
	//no longer alpha filter since there is an iframe as shim
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["applyAlphaFilter"] = 0; };

/**
 * Destroys the ghost, removes the ghost DOM element from the document
 */
UCF_Ghost["prototype"]["destroy"] = function (bDropHandled) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["destroy"]++; }; 

	if (this["bIsDestroyed"]) return;

	// if (this.aRulers) {
	// 	for (var i=0;i<this.aRulers.length;i++) {
	// 		if (this.aRulers[i].getElement() && this.aRulers[i].getElement().parentNode) {
	// 			this.aRulers[i].getElement().parentNode.removeChild(this.aRulers[i].getElement());
	// 		}
	// 	}
	// }

	UCF_DomUtil["removeFromDom"](this["oExtensionDomRef"]);

	if (!window["UCF_System"]["bUseAnimation"] || this["bAnimationDisabled"]) {
		this["doDestroy"]();
		return;
	}

	if (window["UCF_System"]["sDevice"] == "standards") {
		if (bDropHandled) {
			this["oDomRef"]["className"] += " lsDDGhostTransOk lsDDGhostTransfOk";
			UCF_JsUtil["delayedCall"](250, this, "doDestroy");
		} else {
			this["oDomRef"]["className"] += " lsDDGhostTransNok lsDDGhostTransfNok";
			UCF_JsUtil["delayedCall"](1000, this, "doDestroy");
		}
	} else {
		var oAnimation = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(this["oDomRef"], 300);
		oAnimation["addInitialOpacityValue"](100);
		oAnimation["addOpacityChange"](100, 20, oAnimation["M_TRANSITIONS"]["EaseIn"]);
		oAnimation["callbackFinish"](this, "doDestroy");
		oAnimation["play"]();
	}

	this["iOffsetLeft"] = 0;
	this["iOffsetTop"] = 0;
	this["iExtensionOffsetLeft"] = 0;
	this["iExtensionOffsetTop"] = 0;
	this["iScaling"] = null;
	this["iAreaLeft"] = 0;
	this["iAreaTop"] = 0;
	this["iRasterWidth"] = 0;
	this["iRasterHeight"] = 0;
	this["iCurrentRasterX"] = 0;
	this["iCurrentRasterY"] = 0;
	this["bLeapAside"] = false;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["destroy"] = 0; };

/**
 *
 */
UCF_Ghost["prototype"]["doDestroy"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["doDestroy"]++; }; 
	UCF_DomUtil["removeFromDom"](this["oDomRef"]);
	UCF_DomUtil["removeFromDom"](this["oShimRef"]);
	UCF_DomUtil["removeFromDom"](this["oIFrameRef"]);
	//	if (this.oCursorShimRef) UCF_DomUtil.removeFromDom(this.oCursorShimRef);

	this["oGhostRef"] = null;
	//this.aRulers = null;
	this["oRulerRectManager"] = null;

	if (this["fMoveHandler"]) {
		UCF_DomUtil["detachEvent"](this["oShimRef"], "mousemove", this["fMoveHandler"], false);
		this["fMoveHandler"] = null;
	}

	if (this["fContextMenuHandler"]) {
		UCF_DomUtil["detachEvent"](this["oShimRef"], "contextmenu", this["fContextMenuHandler"], false);
		this["fContextMenuHandler"] = null;
	}

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	this["oDomRef"] = null;
	this["oShimRef"] = null;
	this["oIFrameRef"] = null;
	//	this.oCursorShimRef = null;
	this["oRect"] = null;

};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["doDestroy"] = 0; };

/**
 * creates a shim for catching events when ghost contains an iframe
 */
UCF_Ghost["prototype"]["createShim"] = function (oRootContainerDomRef) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["createShim"]++; }; 

	//create shim layer for ghost with iframes
	this["oShimRef"] = document["createElement"]("IMG");
	this["oShimRef"]["src"] = UCF_ResourceUtil["sGetSpacerImageUrl"]();

	oRootContainerDomRef["appendChild"](this["oShimRef"]);

	var oStyle = this["oShimRef"]["style"];
	oStyle["position"] = "absolute";
	oStyle["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"] + 100;
	oStyle["overflow"] = "hidden";
	oStyle["top"] = "-1000px";
	oStyle["cursor"] = "default";

	//	if (UCF_UserAgent.bIsTrident(5) && !this.bPageProbablyContainsPDF()) {
	//	if (false) {
	//		//create shim layer underneath cursor to emulate cursor style
	//		this.oCursorShimRef = document.createElement("IMG");
	//		this.oCursorShimRef.src = UCF_ResourceUtil.sGetSpacerImageUrl();
	//
	//		oRootContainerDomRef.appendChild(this.oCursorShimRef);
	//
	//		oStyle = this.oCursorShimRef.style;
	//		oStyle.position = "absolute";
	//		oStyle.zIndex = UCF_LS.E_LAYERS.GHOSTS + 200;
	//		oStyle.overflow = "hidden";
	//		oStyle.top = "-1000px";
	//		oStyle.cursor = "default";
	//		oStyle.backgroundRepeat = "no-repeat";
	//	}

	if (this["bPageProbablyContainsPDF"]()) {
		//create iframe that ghost appears in front of active components (PDF)
		this["oIFrameRef"] = document["createElement"]("IFRAME");
		this["oIFrameRef"]["setAttribute"]("scrolling", "no");
		this["oIFrameRef"]["setAttribute"]("frameBorder", "0");

		oStyle = this["oIFrameRef"]["style"];
		oStyle["position"] = "absolute";
		oStyle["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"] - 1;
		oStyle["overflow"] = "hidden";
		oStyle["top"] = "-1000px";

		UCF_DomUtil["setOpacityStyle"](this["oIFrameRef"], 0);

		//be sure to append the iframe after setting the properties
		//else border settings would be ignored
		oRootContainerDomRef["appendChild"](this["oIFrameRef"]);
	}

	this["fContextMenuHandler"] = function (event) {
		event = event || window["event"];
		if (!event)
			return false;
		event["returnValue"] = false;
		if (event["preventDefault"])
			event["preventDefault"]();
		return false;
	};

	UCF_DomUtil["attachEvent"](this["oShimRef"], "contextmenu", this["fContextMenuHandler"], false);

};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["createShim"] = 0; };

/**
 *
 *
 */
UCF_Ghost["prototype"]["show"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["show"]++; }; 
	this["oDomRef"]["style"]["visibility"] = "visible";
	this["oDomRef"]["style"]["display"] = "";

	if (this["oShimRef"])
		this["oShimRef"]["style"]["visibility"] = "visible";

	if (this["oIFrameRef"])
		this["oIFrameRef"]["style"]["visibility"] = "visible";

	//	if (this.oCursorShimRef)
	//		this.oCursorShimRef.style.visibility = "visible";

	this["bVisible"] = true;
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["show"] = 0; };

/**
 *
 */
UCF_Ghost["prototype"]["hide"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["hide"]++; }; 

	this["oDomRef"]["style"]["visibility"] = "hidden";
	this["oDomRef"]["style"]["display"] = "none";

	if (this["oShimRef"])
		this["oShimRef"]["style"]["visibility"] = "hidden";

	if (this["oIFrameRef"])
		this["oIFrameRef"]["style"]["visibility"] = "hidden";

	//	if (this.oCursorShimRef)
	//		this.oCursorShimRef.style.visibility = "hidden";

	this["bVisible"] = false;

};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["hide"] = 0; };

UCF_Ghost["prototype"]["showDropEffect"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["showDropEffect"]++; }; 
	this["oExtensionDomRef"]["style"]["visibility"] = "visible";
	this["oExtensionDomRef"]["style"]["display"] = "";
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["showDropEffect"] = 0; };

UCF_Ghost["prototype"]["hideDropEffect"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["hideDropEffect"]++; }; 
	this["oExtensionDomRef"]["style"]["visibility"] = "hidden";
	this["oExtensionDomRef"]["style"]["display"] = "none";
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["hideDropEffect"] = 0; };

UCF_Ghost["prototype"]["setDropEffect"] = function (sDropEffect, sText) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setDropEffect"]++; }; 
	var oExtensionIconDomRef = this["oExtensionDomRef"]["firstChild"],
		oExtensionTextDomRef = this["oExtensionDomRef"]["lastChild"];
	switch (sDropEffect) {
		case this["DROP_EFFECT"]["COPY"]:
			UCF_DomUtil["setClass"](oExtensionIconDomRef, "lsDDGhostExtensionIcon lsDDGhostExtensionCopyIcon");
			if (window["UCF_System"]["bIsRTL"]) {
				UCF_DomUtil["addClass"](oExtensionIconDomRef, "lsDDGhostExtensionIconRTL");
				UCF_DomUtil["addClass"](oExtensionIconDomRef, "lsMirrorRtl");
			}
			break;
		case this["DROP_EFFECT"]["MOVE"]:
			UCF_DomUtil["setClass"](oExtensionIconDomRef, "lsDDGhostExtensionIcon lsDDGhostExtensionMoveIcon");
			if (window["UCF_System"]["bIsRTL"]) {
				UCF_DomUtil["addClass"](oExtensionIconDomRef, "lsDDGhostExtensionIconRTL");
				UCF_DomUtil["addClass"](oExtensionIconDomRef, "lsMirrorRtl");
			}
			break;
	}
	oExtensionTextDomRef["textContent"] = sText;
	this["oExtensionDomRef"]["style"]["display"] = "";
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setDropEffect"] = 0; };

/**
 * Set offset of the ghost
 *
 * @param {int} iLeft Offset from the mouse pointer position in X direction
 * @param {int} iTop Offset from the mouse pointer position in Y direction
 */
UCF_Ghost["prototype"]["setOffset"] = function (iLeft, iTop) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setOffset"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (iLeft) == "number", "typeof (iLeft) == \"number\"", "Ghost.js(477): setOffset"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (iTop) == "number", "typeof (iTop) == \"number\"", "Ghost.js(478): setOffset"); };

	if (document["elementFromPoint"]) {
		this["iOffsetLeft"] = iLeft;
		this["iOffsetTop"] = iTop;
	} else {
		//firefox 2 does not support getELementFromPoint
		//so we cannot reveal the real element behind the ghost
		this["iOffsetLeft"] = 12;
		this["iOffsetTop"] = 12;
	}

	this["bOffsetSet"] = true;
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setOffset"] = 0; };

/**
 * Set offset of the ghost extension
 *
 * @param {int} iLeft Offset from the mouse pointer position in X direction
 * @param {int} iTop Offset from the mouse pointer position in Y direction
 */
UCF_Ghost["prototype"]["setExtensionOffset"] = function (iLeft, iTop) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setExtensionOffset"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (iLeft) == "number", "typeof (iLeft) == \"number\"", "Ghost.js(501): setExtensionOffset"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (iTop) == "number", "typeof (iTop) == \"number\"", "Ghost.js(502): setExtensionOffset"); };

	this["iExtensionOffsetLeft"] = iLeft;
	this["iExtensionOffsetTop"] = iTop;
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setExtensionOffset"] = 0; };

/**
 * Returns the X (left) offset value provided with the last call of setOffset()
 */
UCF_Ghost["prototype"]["iGetOffsetLeft"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["iGetOffsetLeft"]++; }; 
	return this["iOffsetLeft"];
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["iGetOffsetLeft"] = 0; };

/**
 * Returns the Y (top) offset value provided with the last call of setOffset()
 */
UCF_Ghost["prototype"]["iGetOffsetTop"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["iGetOffsetTop"]++; }; 
	return this["iOffsetTop"];
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["iGetOffsetTop"] = 0; };

/**
 * Returns true when setOffset() was called - regardless of the provided values.
 */
UCF_Ghost["prototype"]["bHasOffsetSet"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["bHasOffsetSet"]++; }; 
	return this["bOffsetSet"];
};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["bHasOffsetSet"] = 0; };

/**
 * sets a cursor style
 */
UCF_Ghost["prototype"]["setCursor"] = function (sCursor) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setCursor"]++; }; 

	if (this["oShimRef"]) {
		this["oShimRef"]["className"] = sCursor;
	}

	if (!UCF_UserAgent["bIsTrident"](9, true) && !UCF_UserAgent["bIsTrident"](10, true)) return;

	if (!this["bHandlerAttached"]) {
		var that = this; // eslint-disable-line no-unused-vars
		this["fMoveHandler"] = (function (that, sCursor) {
			return function (oEvt) {
				that["oShimRef"]["className"] = sCursor;
			};
		})(this, sCursor);

		UCF_DomUtil["attachEvent"](this["oShimRef"], "mousemove", this["fMoveHandler"], false);
		this["bHandlerAttached"] = true;
	}

	//	if (this.oCursorShimRef) {
	//		if (sCursor == UCF_DragSession.E_CURSOR.NOT_ALLOWED) this.oCursorShimRef.className = sCursor + " lsDDCursorNoDropBG";
	//		else this.oCursorShimRef.className = sCursor + " lsDDCursorDropBG";
	//	}

};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["setCursor"] = 0; };

/**
 * deletes ids on the domref to avoid ambiguities
 */
UCF_Ghost["prototype"]["deleteIds"] = function (oDomRef) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["deleteIds"]++; }; 

	if (oDomRef["setAttribute"])
		oDomRef["setAttribute"]("id", "");

	for (var x = 0; x < oDomRef["childNodes"]["length"]; x++)
		this["deleteIds"](oDomRef["childNodes"][x]);

};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["deleteIds"] = 0; };
/**
 * tells the ghost whether to display next to the mouse or in its desired position
 * used to allow event processing for active components
 */
UCF_Ghost["prototype"]["leapAside"] = function (bLeapAside) {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["leapAside"]++; }; 

	this["bLeapAside"] = bLeapAside;

};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["leapAside"] = 0; };

UCF_Ghost["prototype"]["bPageProbablyContainsPDF"] = function () {;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["bPageProbablyContainsPDF"]++; }; 

	return document["getElementsByTagName"]("object")["length"] ||
		document["getElementsByTagName"]("embed")["length"];

};;if (__UCF_COVERAGE__) { UCF_Ghost["_"]["bPageProbablyContainsPDF"] = 0; };

// UCF_Ghost.prototype.setRulerRectManager = function(oRulerRectManager){
// 	this.oRulerRectManager = oRulerRectManager;
// };

// UCF_Ghost.prototype.addRulers = function(aRulers,oDomRef){
// 	this.aRulers = aRulers;
// 	if (this.aRulers) {
// 		for (var i=0;i<this.aRulers.length;i++) {
// 			oDomRef.appendChild(this.aRulers[i].getElement());
// 		}
// 	}
// };

//UCF_Ghost.prototype.updateRulers = function() {
//	if (this.aRulers && this.oRulerRectManager) {
//		var mMatching = {};
//		for (var i=0;i<this.aRulers.length;i++) {
//			var oRuler = this.aRulers[i],
//				oRulerRect = {left: this.oRect.left, top: this.oRect.top, width: this.oRect.width, height: this.oRect.height};
//			if (oRuler.sType == "BASELINE") {
//				oRulerRect.height = 1;
//			} else if (oRuler.sType == "TOP") {
//				oRulerRect.height = 1;
//			} else if (oRuler.sType == "BOTTOM") {
//				oRulerRect.top = oRulerRect.top + oRulerRect.height;
//				oRulerRect.height = 1;
//			} else if (oRuler.sType == "LEFT") {
//				oRulerRect.width = 1;
//			} else if (oRuler.sType == "RIGHT") {
//				oRulerRect.left = oRulerRect.left + oRulerRect.width;
//				oRulerRect.width = 1;
//			}
//			oRuler.snap(false);
//			oRuler.hideDistance();
//			var oMatchingRect = oRuler.getMatchingRect(this.oRulerRectManager,oRulerRect,this,this.bSnap);
//			oRuler.minimize();
//			if (oMatchingRect) {
//				if (oMatchingRect.oCustomData.ruler) {
//					mMatching[oRuler.sType] = {rect:oMatchingRect.oRectangle, elementRect : oMatchingRect.oCustomData.elementRect, ruler : oRuler};
//				}
//			}
//		}
//		var bDistanceV = false,
//			bDistanceH = false;
//
//		if (this.bSnap) {
//			if (mMatching["BASELINE"]) {
//				this.oRect.top = mMatching["BASELINE"].elementRect.top ;
//				this.oDomRef.style.top =  this.oRect.top + "px";
//				mMatching["BASELINE"].ruler.snap(true);
//				if (!bDistanceH) {
//					mMatching["BASELINE"].ruler.showDistance();
//				}
//				bDistanceH = true;
//			} else if (mMatching["TOP"]) {
//				this.oRect.top = mMatching["TOP"].elementRect.top;
//				this.oDomRef.style.top =  this.oRect.top + "px";
//				mMatching["TOP"].ruler.snap(true);
//				if (!bDistanceH) {
//					mMatching["TOP"].ruler.showDistance();
//				}
//				bDistanceH = true;
//			} else if (mMatching["BOTTOM"]) {
//				this.oRect.top = (mMatching["BOTTOM"].elementRect.top + mMatching["BOTTOM"].elementRect.height - this.oRect.height);
//				this.oDomRef.style.top =this.oRect.top + "px";
//				mMatching["BOTTOM"].ruler.snap(true);
//				if (!bDistanceH) {
//					mMatching["BOTTOM"].ruler.showDistance();
//				}
//				bDistanceH = true;
//			}
//			if (mMatching["LEFT"]) {
//				this.oRect.left = mMatching["LEFT"].elementRect.left;
//				this.oDomRef.style.left =this.oRect.left + "px";
//				mMatching["LEFT"].ruler.snap(true);
//				if (!bDistanceV) {
//					mMatching["LEFT"].ruler.showDistance();
//				}
//				bDistanceV = true;
//			} else if (mMatching["RIGHT"]) {
//				this.oRect.left = (mMatching["RIGHT"].elementRect.left + mMatching["RIGHT"].elementRect.width - this.oRect.width);
//				this.oDomRef.style.left = this.oRect.left + "px";
//				mMatching["RIGHT"].ruler.snap(true);
//				if (!bDistanceV) {
//					mMatching["RIGHT"].ruler.showDistance();
//				}
//				bDistanceV = true;
//			}
//		}
//		var aMatchingElements = [];
//		for (var n in mMatching) {
//			mMatching[n].ruler.show(mMatching[n].rect,this.oRect,mMatching[n].elementRect);
//			aMatchingElements.push(mMatching[n].element);
//			if (!bDistanceH && n == "BASELINE") {
//				mMatching[n].ruler.showDistance();
//				bDistanceH = true;
//			}
//			if (!bDistanceH && n == "TOP") {
//				mMatching[n].ruler.showDistance();
//				bDistanceH = true;
//			}
//			if (!bDistanceH && n == "BOTTOM") {
//				mMatching[n].ruler.showDistance();
//				bDistanceH = true;
//			}
//			if (!bDistanceV && n == "LEFT") {
//				mMatching[n].ruler.showDistance();
//				bDistanceV = true;
//			}
//			if (!bDistanceV && n == "RIGHT") {
//				mMatching[n].ruler.showDistance();
//				bDistanceV = true;
//			}
//		}
//	}
//};

};
sap["ls"]["preload"]["UCF_GridBinding"] = function() {/* global UCF_Binding */
/// <reference path="./Binding.js"/>

/**
 * Constructor for GridBinding
 *
 *
 * The GridBinding is a specific binding for lists in the model, which can be
 * used to populate Tables or ItemLists.
 *
 * @class
 * @param {UCF_Model} oModel
 * @param {string} sPath
 * @param {UCF_BindingContext} oContext
 * @param {UCF_ListBinding_Sorter} oSorter
 * @param {Array} aFilters
 * @param {Object} mParameters
 *
 * @see {@link ./topics/DataBinding.html}
 * @public
 */
function UCF_GridBinding(oModel, sPath, oContext, oSorter, aFilters, mParameters) {if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["UCF_GridBinding"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Binding["apply"](this, [oModel, sPath, oContext, mParameters]);

		this["defineEvents"](['Sort', 'Filter']);

		this["oSorter"] = oSorter;
		this["aFilters"] = aFilters;
	}
};window["UCF_GridBinding"] = UCF_GridBinding; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_GridBinding"); UCF_GridBinding["_"] = {UCF_GridBinding: 0}; }; ;
UCF_GridBinding["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Binding"))(); UCF_GridBinding.prototype["sClassName"] = "UCF_GridBinding";

/** @override */
UCF_GridBinding["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["destroy"]++; }; 
	this["oSorter"] = null;
	this["aFilters"] = null;

	UCF_Binding.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["destroy"] = 0; };

// the 'abstract methods' to be implemented by child classes
/**
 * Returns the current value of the bound target
 *
 * @public
 * @function
 * @name UCF_GridBinding.prototype.getContexts
 * @return {Array} the array of contexts for each row of the bound list
 */

/**
 * Filters the list according to the filter definitions
 *
 * @public
 * @function
 * @name UCF_GridBinding.prototype.filter
 * @param {Array} aFilters Array of UCF_Filter objects
 */

/**
 * Sorts the list according to the sorter object
 *
 * @public
 * @function
 * @name UCF_GridBinding.prototype.sort
 * @param {UCF_ListBinding_Sorter} oSorter the Sorter object which defines the
 * sort order
 */

// base methods, may be overridden by child classes
/**
 * Returns list of distinct values for the given relative binding path
 *
 * @public
 * @param {string} sPath the relative binding path
 * @return {Array} the array of distinct values.
 */
UCF_GridBinding["prototype"]["getDistinctValues"] = function(sPath) {;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["getDistinctValues"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["getDistinctValues"] = 0; };

//Eventing and related
/**
 * Attach event-handler <code>fnFunction</code> to the '_sort' event of this
 * <code>UCF_GridBinding</code>.<br/>
 *
 * @protected
 * @param {Object} [oListener] object on which to call the given function.
 * @param {function} fnFunction The function to call, when the event occurs.
 */
UCF_GridBinding["prototype"]["attachSort"] = function(oListener, fnFunction) {;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["attachSort"]++; }; 
	this["attachEvent"](this["E_EVENTS"]["Sort"], oListener, fnFunction);
};;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["attachSort"] = 0; };

/**
 * Detach event-handler <code>fnFunction</code> from the '_sort' event of this
 * <code>UCF_GridBinding</code>.<br/>
 *
 * @protected
 * @param {Object} [oListener] object on which to call the given function.
 * @param {function} fnFunction The function to call, when the event occurs.
 */
UCF_GridBinding["prototype"]["detachSort"] = function(oListener, fnFunction) {;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["detachSort"]++; }; 
	this["detachEvent"](this["E_EVENTS"]["Sort"], oListener, fnFunction);
};;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["detachSort"] = 0; };

/**
 * Fire event 'sort' to attached listeners.
 *
 * @private
 * @param {Object} [mArguments] the arguments to pass along with the event.
 */
UCF_GridBinding["prototype"]["_fireSort"] = function(mArguments) {;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["_fireSort"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Sort"], mArguments);
};;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["_fireSort"] = 0; };

/**
 * Attach event-handler <code>fnFunction</code> to the '_filter' event of this
 * <code>UCF_GridBinding</code>.<br/>
 *
 * @protected
 * @param {Object} [oListener] object on which to call the given function.
 * @param {function} fnFunction The function to call, when the event occurs.
 */
UCF_GridBinding["prototype"]["attachFilter"] = function(oListener, fnFunction) {;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["attachFilter"]++; }; 
	this["attachEvent"](this["E_EVENTS"]["Filter"], oListener, fnFunction);
};;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["attachFilter"] = 0; };

/**
 * Detach event-handler <code>fnFunction</code> from the '_filter' event of
 * this <code>UCF_GridBinding</code>.<br/>
 *
 * @protected
 * @param {Object} [oListener] object on which to call the given function.
 * @param {function} fnFunction The function to call, when the event occurs.
 */
UCF_GridBinding["prototype"]["detachFilter"] = function(oListener, fnFunction) {;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["detachFilter"]++; }; 
	this["detachEvent"](this["E_EVENTS"]["Filter"], oListener, fnFunction);
};;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["detachFilter"] = 0; };

/**
 * Fire event _filter to attached listeners.
 * @param {Object} [mArguments] the arguments to pass along with the event.
 * @private
 */
UCF_GridBinding["prototype"]["_fireFilter"] = function(mArguments) {;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["_fireFilter"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Filter"], mArguments);
};;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["_fireFilter"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_GridBinding["prototype"]["aAttributeNames"] = [];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_GridBinding["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_GridBinding["prototype"]["aMethodNames"] = [];


//#JSCOVER_EXCL_START
/** @protected */
UCF_GridBinding["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["setDefaultValues"]++; }; 
	

	if (this["getClientControl"]() && !this["bKeepAlive"]) ;
};;if (__UCF_COVERAGE__) { UCF_GridBinding["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_GridBinding.prototype["aPublicMethods"] = ["UCF_GridBinding","getDistinctValues"].concat(UCF_GridBinding.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_GridLayout"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_SimpleLayoutDragDelegate */
/// <reference path="./delegates/SimpleLayoutDragDelegate.js"/>
/* global UCF_SimpleLayoutDropDelegate */
/// <reference path="./delegates/SimpleLayoutDropDelegate.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_GridLayout(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["UCF_GridLayout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "GridLayout.js(30): UCF_GridLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "GridLayout.js(31): UCF_GridLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "GridLayout.js(32): UCF_GridLayout"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_GridLayout"] = UCF_GridLayout; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_GridLayout"); UCF_GridLayout["_"] = {UCF_GridLayout: 0}; }; ;
UCF_GridLayout["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_GridLayout.prototype["sClassName"] = "UCF_GridLayout";

UCF_GridLayout["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["initialize"]++; }; 
	if (window["UCF_System"]["sDevice"] === "standards" && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && this["sHeight"]) {
		UCF_DomUtil["initHtmlTableCorrection"](this["oDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["initialize"] = 0; };

/**
 * @return {string}
 */
UCF_GridLayout["prototype"]["sGetDragSourceInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["sGetDragSourceInfo"]++; }; 

	return this["sDragSourceInfo"];
};;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["sGetDragSourceInfo"] = 0; };

/**
 * implements method from UCF_Control
 */
UCF_GridLayout["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["createDragDelegate"]++; }; 

	if (!this["sDragSourceInfo"])
		return;

	if (this["oDragDelegate"])
		return;

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_SimpleLayoutDragDelegate"))(this["oLS"], this, this["sDropDecoratorType"]);
	this["addDelegate"](this["oDragDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["createDragDelegate"] = 0; };

/**
 * implements method from UCF_Control
 */
UCF_GridLayout["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["createDropDelegate"]++; }; 
	if (!this["sDropTargetInfo"])
		return;

	if (this["oDropDelegate"])
		return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_SimpleLayoutDropDelegate"))(this["oLS"], this, this["sDropDecoratorType"]);
	this["addDelegate"](this["oDropDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["createDropDelegate"] = 0; };

/**
 * @see UCF_DTExtension
 * @param { UCF_HTMLElement } oDTElement the lsaccessibility
 * @return { UCF_DTExtesion } the control specific DTExtension and instance of the base class UCF_DTExtesion
 * @private
 * @see UCF_DTExtension
 */
UCF_GridLayout["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["oGetDTExtension"]++; }; 
	return UCF_Control.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]("UCF_LayoutEditorExtension"));
};;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["oGetDTExtension"] = 0; };

UCF_GridLayout["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["destroy"]++; }; 

	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_GridLayout["prototype"]["aAttributeNames"] = ["sHeight","sVisibility","sDragSourceInfo","sDropTargetInfo","sDropDecoratorType","sCustomStyle","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_GridLayout["prototype"]["aEventNames"] = ["Drag","Drop"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_GridLayout["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_GridLayout["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_GridLayout["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_GridLayout["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_GridLayout["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LayoutDropDecorator}
 */
UCF_GridLayout["prototype"]["sDropDecoratorType"] = "BOX";

/**
 * @private
 * @type {string}
 */
UCF_GridLayout["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_GridLayout["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_GridLayout["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["setDefaultValues"]++; }; 
	this["sHeight"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sDragSourceInfo"] = '';
	this["sDropTargetInfo"] = '';
	this["sDropDecoratorType"] = "BOX";
	this["sCustomStyle"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("DropDecoratorType", "BOX", true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires GridLayout::Drag
 */
UCF_GridLayout["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "GridLayout.js(206): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "GridLayout.js(207): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "GridLayout.js(208): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "GridLayout.js(209): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "GridLayout.js(210): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "GridLayout.js(211): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "GridLayout.js(212): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("GridLayout", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sCell The Id of the gridlayoutcell where the drop occured
 * @param {number} iOffset The Offset relative to the gridlayoutcell where the drop occured (signum)
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the Tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires GridLayout::Drop
 */
UCF_GridLayout["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, sCell, iOffset, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, Cell: string, Offset: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 12, "arguments.length == 12", "GridLayout.js(244): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "GridLayout.js(245): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "GridLayout.js(246): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "GridLayout.js(247): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "GridLayout.js(248): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "GridLayout.js(249): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "GridLayout.js(250): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCell != null, "sCell != null", "GridLayout.js(251): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCell) == "string", "typeof(sCell) == \"string\"", "GridLayout.js(252): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOffset != null, "iOffset != null", "GridLayout.js(253): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOffset) == "number", "typeof(iOffset) == \"number\"", "GridLayout.js(254): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "GridLayout.js(255): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "GridLayout.js(256): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "GridLayout.js(257): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "GridLayout.js(258): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "GridLayout.js(259): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "GridLayout.js(260): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "GridLayout.js(261): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "GridLayout.js(262): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "GridLayout.js(263): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "GridLayout.js(264): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "GridLayout.js(265): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "GridLayout.js(266): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "GridLayout.js(267): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "GridLayout.js(268): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"Cell": sCell,
		"Offset": iOffset,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("GridLayout", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_GridLayout["_"]["fireDrop"] = 0; };

};
sap["ls"]["preload"]["UCF_GridLayoutCell"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_AccessibilityHelper */
/// <reference path="../helper/AccessibilityHelper.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_GridLayoutCell(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_GridLayoutCell["_"]["UCF_GridLayoutCell"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "GridLayoutCell.js(24): UCF_GridLayoutCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "GridLayoutCell.js(25): UCF_GridLayoutCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "GridLayoutCell.js(26): UCF_GridLayoutCell"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oAccessibilityHelper"] = null;

};window["UCF_GridLayoutCell"] = UCF_GridLayoutCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_GridLayoutCell"); UCF_GridLayoutCell["_"] = {UCF_GridLayoutCell: 0}; }; ;

UCF_GridLayoutCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_GridLayoutCell.prototype["sClassName"] = "UCF_GridLayoutCell";

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_GridLayoutCell["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_GridLayoutCell["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "GridLayoutCell.js(44): onlsaccessibility"); };

	if (this["sSemanticColor"] === "NONE") return;
	var oEventAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	this["oAccessibilityHelper"] = new (UCF_ClassLoader["oGetClass"]("UCF_AccessibilityHelper"))(this["oLS"]);

	var parentGrid = UCF_DomUtil["oGetParentByTagName"](this["oDomRef"], "TABLE");
	if (parentGrid) {
		var oLegendDomRef = UCF_DomUtil["$"](parentGrid["id"] + "-legend");
		if (oLegendDomRef) this["oAccessibilityHelper"]["setLegendJSDomRef"](oLegendDomRef);
	}
	this["oAccessibilityHelper"]["addSemantic"](this["sSemanticColor"]);

	oEventAccessibilityHelper["addContainerHelper"](this["oAccessibilityHelper"]);

};;if (__UCF_COVERAGE__) { UCF_GridLayoutCell["_"]["onlsaccessibility"] = 0; };

UCF_GridLayoutCell["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_GridLayoutCell["_"]["destroy"]++; }; 
	if (this["oAccessibilityHelper"]) {
		this["oAccessibilityHelper"]["destroy"]();
		this["oAccessibilityHelper"] = null;
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_GridLayoutCell["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_GridLayoutCell["prototype"]["aAttributeNames"] = ["sDragData","sSemanticColor","sCustomData","sLayoutCellPosition","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_GridLayoutCell["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_GridLayoutCell["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_GridLayoutCell["prototype"]["sDragData"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_GridLayoutCell["prototype"]["sSemanticColor"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_GridLayoutCell["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LayoutCellPosition}
 */
UCF_GridLayoutCell["prototype"]["sLayoutCellPosition"] = "DEFAULT";

/**
 * @private
 * @type {string}
 */
UCF_GridLayoutCell["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_GridLayoutCell["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_GridLayoutCell["_"]["setDefaultValues"]++; }; 
	this["sDragData"] = '';
	this["sSemanticColor"] = "NONE";
	this["sCustomData"] = '';
	this["sLayoutCellPosition"] = "DEFAULT";
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("DragData", '', true);
		this["setClientProperty"]("SemanticColor", "NONE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LayoutCellPosition", "DEFAULT", true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_GridLayoutCell["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Group"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Group(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Group["_"]["UCF_Group"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Group.js(31): UCF_Group"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Group.js(32): UCF_Group"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Group.js(33): UCF_Group"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["allowTextSelection"]();

	this["oScrollArea"] = this["sScrollingMode"] !== "NONE"
		? UCF_ClassLoader["oGetClass"]("UCF_ScrollArea")["oCreateAndConnectScrollArea"](this, this["sScrollingMode"], "onScroll")
		: null;

	//initialize the default button for this control
	this["setDefaultButtonId"](this["sDefaultButtonId"]);
};window["UCF_Group"] = UCF_Group; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Group"); UCF_Group["_"] = {UCF_Group: 0}; }; ;
UCF_Group["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Group.prototype["sClassName"] = "UCF_Group";

/**
 * Intialize in case scroll positions have to be applied
 */
UCF_Group["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Group["_"]["initialize"]++; }; 

	if (window["UCF_System"]["sDevice"] === "standards" && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && this["sHeight"]) {
		UCF_DomUtil["initHtmlTableCorrection"](this["oDomRef"]);
	}

	if (this["oScrollArea"]) {
		this["oScrollArea"]["setScrollPosition"](this["iScrollTop"], this["iScrollLeft"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["initialize"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 * @return {UCF_HTMLElement}
 */
UCF_Group["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Group["_"]["oGetInplaceEditDomRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + "-groupheader");
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["oGetInplaceEditDomRef"] = 0; };

/** @override */
UCF_Group["prototype"]["sGetInplaceEditText"] = function() {;if (__UCF_COVERAGE__) { UCF_Group["_"]["sGetInplaceEditText"]++; }; 
	var oClientContol = this["getClientControl"]();
	if (oClientContol) {
		if (oClientContol["getIsTextTitle"]()) {
			return this["getClientProperty"]("Title");
		} else if (oClientContol["getTitleCaption"]()) {
			var oCaption = oClientContol["getTitleCaption"]();
			return oCaption["getText"]();
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["sGetInplaceEditText"] = 0; };

/**
 * Sets the text typed in InplaceEdit field
 * @param {string} sTitle
 * @see UCF_Control.setInplaceEditDomRef
 */
UCF_Group["prototype"]["setInplaceEditText"] = function(sTitle) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["setInplaceEditText"]++; }; 
	var oClientContol = this["getClientControl"]();
	if (oClientContol) {
		if (oClientContol["getIsTextTitle"]()) {
			this["sTitle"] = sTitle;
			this["setClientProperty"]("Title", sTitle);
		} else if (oClientContol["getTitleCaption"]()) {
			var oCaption = oClientContol["getTitleCaption"]();
			oCaption["setText"](sTitle);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["setInplaceEditText"] = 0; };

/**
 * Destructor
 */
UCF_Group["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Group["_"]["destroy"]++; }; 
	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}

	this["sTitle"] = null;
	this["oCaption"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["destroy"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Group["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Group["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["onlsskipback"] = 0; };

/**
 * Handle the area scroll event
 *
 * @param {UCF_Event} oEvent
 */
UCF_Group["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["onScroll"]++; }; 
	var iScrollTop = oEvent["oGetParam"]("iScrollTop"),
		iScrollLeft = oEvent["oGetParam"]("iScrollLeft");

	this["fireScroll"](this["sId"], iScrollTop, iScrollLeft);
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["onScroll"] = 0; };

/**
 * Sets the scroll position programmatically
 *
 * @param {int} iScrollLeft
 * @param {int} iScrollTop
 */
UCF_Group["prototype"]["setScrollPosition"] = function(iScrollLeft, iScrollTop) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["setScrollPosition"]++; }; 
	this["oScrollArea"](iScrollTop, iScrollLeft);
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["setScrollPosition"] = 0; };

/**
 * Handle hotkey events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Group["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["onlshotkey"]++; }; 
	if (this["sHotkeysId"] === '') return;

	var oHotkeys = this["oGetControlById"](this["sHotkeysId"]);
	if (oHotkeys == null) return;

	var oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["onlshotkey"] = 0; };

UCF_Group["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]('UCF_Hotkeys')["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["onkeypress"] = 0; };

UCF_Group["prototype"]["oGetCaption"] = function() {;if (__UCF_COVERAGE__) { UCF_Group["_"]["oGetCaption"]++; }; 
	var oCaptionRef;

	if (this["bHasTitleCaption"] && !this["oCaption"]) {
		oCaptionRef = UCF_DomUtil["oGetFirstChildByAttribute"](this["oGetInplaceEditDomRef"](), 'ct', 'CP');

		if (oCaptionRef) {
			this["oCaption"] = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](
				oCaptionRef,
				true
			);
		}
	}

	return this["oCaption"];
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["oGetCaption"] = 0; };

UCF_Group["prototype"]["sGetCaptionText"] = function() {;if (__UCF_COVERAGE__) { UCF_Group["_"]["sGetCaptionText"]++; }; 
	/** @type {UCF_Caption} */
	var oCaption = this["oGetCaption"]();

	return oCaption && oCaption["sGetText"]();
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["sGetCaptionText"] = 0; };

UCF_Group["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["onmouseover"]++; }; 
	var oSource;
	var oTitleSource;

	if (!window["UCF_System"]["bIs508"]) {
		oSource = oBrowserEvent["oGetSource"]();
		oTitleSource = UCF_DomUtil["$"](this["sId"] + '-title');

		if (
			oSource === oTitleSource ||
			UCF_DomUtil["bContains"](oTitleSource, oSource)
		) {
			UCF_DomUtil["checkTooltip"](
				oTitleSource,
				this["sTooltip"],
				oTitleSource,
				this["sGetCaptionText"]()
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["onmouseover"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Group["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Group.js(248): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSource"]();

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource["getAttribute"]("tp") === "END") {
		oAccessibilityHelper["setControlType"]("G_END");
	} else {
		oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
		oAccessibilityHelper["setText"](this["sTitle"]);
		oAccessibilityHelper["setControlType"]("G");
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["onlsaccessibility"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 * @public
 */
UCF_Group["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["setDefaultButtonId"]++; }; 
	UCF_Control.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["setDefaultButtonId"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Group["prototype"]["aAttributeNames"] = ["sHeight","sTitle","sTooltip","sScrollingMode","bHasTitleCaption","sVisibility","sDefaultButtonId","iScrollTop","iScrollLeft","sAccessKey","sHotkeysId","iHeadingLevel","sCustomStyle","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Group["prototype"]["aEventNames"] = ["Scroll","Hotkey"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Group["prototype"]["aMethodNames"] = ["setDefaultButtonId","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Group["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Group["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Group["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ScrollingMode}
 */
UCF_Group["prototype"]["sScrollingMode"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_Group["prototype"]["bHasTitleCaption"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Group["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_Group["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_Group["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_Group["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_Group["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Group["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_Group["prototype"]["iHeadingLevel"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_Group["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Group["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Group["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Group["_"]["setDefaultValues"]++; }; 
	this["sHeight"] = '';
	this["sTitle"] = '';
	this["sTooltip"] = '';
	this["sScrollingMode"] = "NONE";
	this["bHasTitleCaption"] = false;
	this["sVisibility"] = "VISIBLE";
	this["sDefaultButtonId"] = '';
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["sAccessKey"] = '';
	this["sHotkeysId"] = '';
	this["iHeadingLevel"] = 0;
	this["sCustomStyle"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("ScrollingMode", "NONE", true);
		this["setClientProperty"]("HasTitleCaption", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires Group::Scroll
 */
UCF_Group["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Group.js(430): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Group.js(431): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Group.js(432): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "Group.js(433): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "Group.js(434): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "Group.js(435): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "Group.js(436): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("Group", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires Group::Hotkey
 */
UCF_Group["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_Group["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Group.js(459): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Group.js(460): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Group.js(461): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "Group.js(462): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "Group.js(463): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "Group.js(464): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "Group.js(465): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	
	
	this["fireSemanticEvent"]("Group", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Group["_"]["fireHotkey"] = 0; };

UCF_Group.prototype["aPublicMethods"] = ["setDefaultButtonId"].concat(UCF_Group.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Guide"] = function() {/* global UCF_Object */
/// <reference path="../../../../core/Object.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../../core/util/DomUtil.js"/>
/**
 * 
 *
 * @class
 * @param {Object} oOwner
 * @param {HTMLElement} oParentDomRef
 * @param {string} sDirection
 * @param {string} sAlign
 * @param {string} sPosition
 */
function UCF_Guide(oOwner, oParentDomRef, sDirection, sAlign, sPosition) {if (__UCF_COVERAGE__) { UCF_Guide["_"]["UCF_Guide"]++; }; 
	UCF_Object["apply"](this);
	this["oOwner"] = oOwner;
	this["oParentDomRef"] = oParentDomRef;
	this["sDirection"] = sDirection;
	this["sAlign"] = sAlign;
	this["sPosition"] = sPosition;
	this["oDomRef"] = null;
};window["UCF_Guide"] = UCF_Guide; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Guide"); UCF_Guide["_"] = {UCF_Guide: 0}; }; ;
UCF_Guide["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Guide.prototype["sClassName"] = "UCF_Guide";

UCF_Guide["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_Guide["_"]["show"]++; }; 
	var oDiv;
	if (!this["oDomRef"]) {
		oDiv = document["createElement"]("div");
		var aHTML = [];
		if (this["sDirection"] === "horizontal") {
			oDiv["className"] = "urHGuide";
			aHTML["push"]("<div class=\"urHGuideLine\">");
		} else {
			oDiv["className"] = "urVGuide";
			aHTML["push"]("<div class=\"urVGuideLine\">");
		}
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](oDiv, aHTML["join"](""));
		this["oParentDomRef"]["appendChild"](oDiv);
		this["oDomRef"] = oDiv;
	}
	oDiv = this["oDomRef"];
	if (this["sDirection"] === "horizontal") {
		if (this["sAlign"] === "bottom") {
			oDiv["style"]["bottom"] = this["sPosition"];
		} else {
			oDiv["style"]["top"] = this["sPosition"];
		}
	} else {
		if (this["sAlign"] === "right") {
			oDiv["style"]["right"] = this["sPosition"];
		} else {
			oDiv["style"]["left"] = this["sPosition"];
		}
	}
	oDiv["style"]["display"] = "block";
};;if (__UCF_COVERAGE__) { UCF_Guide["_"]["show"] = 0; };

UCF_Guide["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_Guide["_"]["hide"]++; }; 
	if (this["oDomRef"]) {
		this["oDomRef"]["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_Guide["_"]["hide"] = 0; };

UCF_Guide["prototype"]["getLeftPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_Guide["_"]["getLeftPosition"]++; }; 
	if (this["sDirection"] === "vertical" && this["sAlign"] === "left") {
		return this["sPosition"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Guide["_"]["getLeftPosition"] = 0; };

UCF_Guide["prototype"]["getRightPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_Guide["_"]["getRightPosition"]++; }; 
	if (this["sDirection"] === "vertical" && this["sAlign"] === "right") {
		return this["sPosition"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Guide["_"]["getRightPosition"] = 0; };

UCF_Guide["prototype"]["getTopPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_Guide["_"]["getTopPosition"]++; }; 
	if (this["sDirection"] === "horizontal" && this["sAlign"] === "top") {
		return this["sPosition"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Guide["_"]["getTopPosition"] = 0; };

UCF_Guide["prototype"]["getBottomPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_Guide["_"]["getBottomPosition"]++; }; 
	if (this["sDirection"] === "horizontal" && this["sAlign"] === "bottom") {
		return this["sPosition"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Guide["_"]["getBottomPosition"] = 0; };

UCF_Guide["prototype"]["getRect"] = function() {;if (__UCF_COVERAGE__) { UCF_Guide["_"]["getRect"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_Guide["_"]["getRect"] = 0; };

UCF_Guide["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Guide["_"]["destroy"]++; }; 
	this["oDomRef"] = null;
	this["oOwner"] = null;
	this["oParentDomRef"] = null;
	this["sDirection"] = null;
	this["sAlign"] = null;
	this["sPosition"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Guide["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_HTMLGhost"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Ghost */
/// <reference path="./Ghost.js"/>

/**
 * A simple ghost for displaying HTML content.
 * @class
 *
 * @param {HTMLElement} oGhostRef The ghost DOM
 */
function UCF_HTMLGhost(oGhostRef, bOverflow, bHideDropShadow) {if (__UCF_COVERAGE__) { UCF_HTMLGhost["_"]["UCF_HTMLGhost"]++; }; 

	if (!arguments["length"])
		return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oGhostRef) == "object", "typeof (oGhostRef) == \"object\"", "HTMLGhost.js(23): UCF_HTMLGhost"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oGhostRef != null, "oGhostRef != null", "HTMLGhost.js(24): UCF_HTMLGhost"); };

	UCF_Ghost["apply"](this, [oGhostRef]);

	this["bOverflow"] = bOverflow;
	this["bHideDropShadow"] = bHideDropShadow;
};window["UCF_HTMLGhost"] = UCF_HTMLGhost; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HTMLGhost"); UCF_HTMLGhost["_"] = {UCF_HTMLGhost: 0}; }; 

UCF_HTMLGhost["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Ghost"))(); UCF_HTMLGhost.prototype["sClassName"] = "UCF_HTMLGhost";

/**
 * destructor
 */
UCF_HTMLGhost["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_HTMLGhost["_"]["destroy"]++; }; 

	this["bOverflow"] = false;
	this["bHideDropShadow"] = false;
	this["iOriginalWidth"] = 0;
	this["iOriginalHeight"] = 0;
	UCF_Ghost.prototype["destroy"]["apply"](this, arguments);
	this["oExtensionDomRef"] = null;
};;if (__UCF_COVERAGE__) { UCF_HTMLGhost["_"]["destroy"] = 0; };


UCF_HTMLGhost["prototype"]["create"] = function (oRootContainerDomRef) {;if (__UCF_COVERAGE__) { UCF_HTMLGhost["_"]["create"]++; }; 
	var oRowRef;
	/**
	 * Creates a table with a single row
	 *
	 * @param {document} oDocument
	 * @param {string} sWidth (CSSSize)
	 * @param {string} sHeight (CSSSize)
	 * @type element
	 */
	var createRow = function (oDocument, sWidth, sHeight) {
		var oTableRef = oDocument["createElement"]("TABLE");
		oTableRef["cellPadding"] = "0";
		oTableRef["cellSpacing"] = "0";
		oTableRef["border"] = "0";
		oTableRef["style"]["tableLayout"] = "fixed";
		oTableRef["style"]["borderCollapse"] = "collapse";
		if (sWidth) oTableRef["style"]["width"] = sWidth;
		if (sHeight) oTableRef["style"]["height"] = sHeight;

		var oTableBody = oDocument["createElement"]("TBODY"),
			oTableRow = oDocument["createElement"]("TR");

		oTableBody["appendChild"](oTableRow);
		oTableRef["appendChild"](oTableBody);

		return oTableRow;
	};

	//create the ghost element and add it to the body of the document
	var oDocument = UCF_DomUtil["oGetDocument"](this["oGhostRef"]);
	var oDomRef = oDocument["createElement"]("DIV"),
		oStyle = oDomRef["style"];

	oStyle["position"] = "absolute";
	oStyle["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"] + 10;
	if (!(this["bOverflow"] === true)) {
		oStyle["overflow"] = "hidden";
	} else {
		oStyle["overflow"] = "visible";
	}
	oStyle["top"] = "-10000px";
	oStyle["cursor"] = "default";

	if (this["bOverflow"] !== true && this["bHideDropShadow"] !== true) {
		oDomRef["className"] = "lsDDGhostBoxShadow";
	}

	//check if the domref is a table element
	if (this["oGhostRef"]["tagName"] == "TR") {
		oRowRef = createRow(oDocument, this["oGhostRef"]["style"]["width"], this["oGhostRef"]["style"]["height"]);
		oRowRef["parentNode"]["replaceChild"](this["oGhostRef"], oRowRef);
		this["oGhostRef"] = this["oGhostRef"]["parentNode"]["parentNode"];
	} else if (this["oGhostRef"]["tagName"] == "TD" || this["oGhostRef"]["tagName"] == "TH") {
		oRowRef = createRow(oDocument, this["oGhostRef"]["style"]["width"], this["oGhostRef"]["style"]["height"]);
		oRowRef["appendChild"](this["oGhostRef"]);
		this["oGhostRef"] = oRowRef["parentNode"]["parentNode"];
	}

	oDomRef["appendChild"](this["oGhostRef"]);
	this["oDomRef"] = oDomRef;
	oRootContainerDomRef["appendChild"](oDomRef);

	this["iOriginalWidth"] = oDomRef["offsetWidth"];
	this["iOriginalHeight"] = oDomRef["offsetHeight"];

	this["deleteIds"](this["oDomRef"]);

	this["createShim"](oRootContainerDomRef);

	if (this["bApplyAlphaFilter"]) {
		//apply a nice alpha filter that fades out at the edges
		if (!oDomRef["style"]["opacity"]) { //TODO: opacity is supported
			oDomRef["style"]["filter"] = "progid:DXImageTransform.Microsoft.Alpha( style=1,opacity=80,finishOpacity=20,startX=0,finishX=" + this["iOriginalWidth"] + ",startY=0,finishY=" + this["iOriginalHeight"] + ")";
		} else {
			oDomRef["style"]["opacity"] = "0.6";
		}
	}

	//create the ghost extension for dropEffect visualization
	var oExtensionDomRef = oDocument["createElement"]("SPAN"),
		oExtensionIconDomRef = oDocument["createElement"]("SPAN"),
		oExtensionTextDomRef = oDocument["createElement"]("SPAN"),
		oExtensionStyle = oExtensionDomRef["style"];

	UCF_DomUtil["setClass"](oExtensionDomRef, "lsDDGhostExtension urTxtColor");
	UCF_DomUtil["setClass"](oExtensionIconDomRef, "lsDDGhostExtensionIcon");
	if (window["UCF_System"]["bIsRTL"]) {
		UCF_DomUtil["addClass"](oExtensionIconDomRef, "lsDDGhostExtensionIconRTL");
		UCF_DomUtil["addClass"](oExtensionIconDomRef, "lsMirrorRtl");
	}

	oExtensionStyle["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"] + 10;
	if (!(this["bOverflow"] === true)) {
		oExtensionStyle["overflow"] = "hidden";
	} else {
		oExtensionStyle["overflow"] = "visible";
	}
	oExtensionStyle["top"] = "-10000px";
	oExtensionStyle["visibility"] = "hidden";
	oExtensionStyle["display"] = "none";

	oExtensionDomRef["appendChild"](oExtensionIconDomRef);
	oExtensionDomRef["appendChild"](oExtensionTextDomRef);
	oRootContainerDomRef["appendChild"](oExtensionDomRef);
	this["oExtensionDomRef"] = oExtensionDomRef;
};;if (__UCF_COVERAGE__) { UCF_HTMLGhost["_"]["create"] = 0; };

};
sap["ls"]["preload"]["UCF_HTMLTextView"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_DragAndDropDelegate */
/// <reference path="./delegates/DragAndDropDelegate.js"/>
/* global UCF_TextView */
/// <reference path="./TextView.js"/>

/**
 * 
 * @version 1.0.0.0
 *
 * @class
 * @extends UCF_TextView
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_HTMLTextView(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["UCF_HTMLTextView"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "HTMLTextView.js(26): UCF_HTMLTextView"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HTMLTextView.js(27): UCF_HTMLTextView"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HTMLTextView.js(28): UCF_HTMLTextView"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	if (this["bSelectable"]) {
		this["allowTextSelection"]();
	}

	// acc: two tab strokes are requires otherwise
	if (this["oGetParent"]() && this["oGetParent"]()["sClassName"] === "UCF_Link")
		oDomRef["setAttribute"]("tabIndex", "-1");
};window["UCF_HTMLTextView"] = UCF_HTMLTextView; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HTMLTextView"); UCF_HTMLTextView["_"] = {UCF_HTMLTextView: 0}; }; ;
UCF_HTMLTextView["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_TextView"))(); UCF_HTMLTextView.prototype["sClassName"] = "UCF_HTMLTextView";

/** @private */
UCF_HTMLTextView["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["initialize"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["initialize"] = 0; };

/**
 * set a handler for drag and drop processing
 * @public
 * @param {Object} oDragAndDropHandler a drag and drop handler implementing lsdragstart, lsdrag, lsdragover, lsdraghover, lsdragscroll, lsdrop, lsdragend, lsdragenter, lsdragleave,
 * @deprecated
 */
UCF_HTMLTextView["prototype"]["setDragAndDropHandler"] = function(oDragAndDropHandler) {;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["setDragAndDropHandler"]++; }; 

	if (this["oDragAndDropDelegate"])
		this["removeDelegate"](this["oDragAndDropDelegate"]);

	if (!oDragAndDropHandler)
		return;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oDragAndDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragAndDropDelegate"))(oDragAndDropHandler);
	this["addDelegate"](this["oDragAndDropDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["setDragAndDropHandler"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_HTMLTextView["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["oncontextmenu"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HTMLTextView.js(72): oncontextmenu"); };

	var oParentDomRefWithId = UCF_DomUtil["oGetParentByAttribute"](oBrowserEvent["oGetSource"](), "id"),
		bShowBrowserMenu = oBrowserEvent["bCtrl"]() && oBrowserEvent["bAlt"]() && oBrowserEvent["bShift"]();

	//let the page handle the browser context menu
	if (!this["mEvents"]["ContextMenu"] || bShowBrowserMenu) {
		return;
	}

	this["fireContextMenu"](
		this["sId"],
		oBrowserEvent["iPageX"](),
		oBrowserEvent["iPageY"](),
		oBrowserEvent["bShift"](),
		oBrowserEvent["bCtrl"](),
		oBrowserEvent["bAlt"](),
		oParentDomRefWithId ? oParentDomRefWithId["getAttribute"]("id") : ""
	);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["oncontextmenu"] = 0; };

/** Destructor
 * @private
 */
UCF_HTMLTextView["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["destroy"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oDragAndDropDelegate"] = null;

	UCF_TextView.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["destroy"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_HTMLTextView["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["onlsaccessibility"]++; }; 

	if (!this["bIsLayout"]) {
		UCF_TextView.prototype["onlsaccessibility"]["call"](this, oBrowserEvent);
	} else {
		var oControl = oBrowserEvent["oGetSourceControl"](),
			oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

		//Apply label and accDescription
		oAccessibilityHelper["applyLabelingInfo"](this);

		// retrieve the text of the inner child
		var oInnerChild = oControl["oDomRef"]["childNodes"][0];
		while (oInnerChild && oInnerChild["childNodes"]["length"])
			oInnerChild = oInnerChild["childNodes"][0];
		if (oInnerChild)
			oAccessibilityHelper["setText"](oInnerChild["nodeValue"]);
		UCF_DomUtil["checkTooltip"](this["oDomRef"], this["sTooltip"]);
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	}
};;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_HTMLTextView["prototype"]["aAttributeNames"] = ["sTooltip","sVisibility","bSelectable","bIsLayout","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_HTMLTextView["prototype"]["aEventNames"] = ["ContextMenu"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_HTMLTextView["prototype"]["aMethodNames"] = ["setDragAndDropHandler","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_HTMLTextView["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_HTMLTextView["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_HTMLTextView["prototype"]["bSelectable"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_HTMLTextView["prototype"]["bIsLayout"] = true;

/**
 * @private
 * @type {string}
 */
UCF_HTMLTextView["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_HTMLTextView["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["bSelectable"] = true;
	this["bIsLayout"] = true;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Selectable", true, true);
		this["setClientProperty"]("IsLayout", true, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The Id of the HTMLTextView control
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {boolean} bShift Indicates whether the shift key was pressed when the event occured.
 * @param {boolean} bCtrl Indicates whether the control key was pressed when the event occured.
 * @param {boolean} bAlt Indicates whether the alt key was pressed when the event occured.
 * @param {string} sSourceId the id of the dom node the context menu occured on (ascends the dom to search for the next element with an id)
 * @fires HTMLTextView::ContextMenu
 * @deprecated
 */
UCF_HTMLTextView["prototype"]["fireContextMenu"] = function(sId, iPosX, iPosY, bShift, bCtrl, bAlt, sSourceId) {;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["fireContextMenu"]++; }; 
	/** @type {{Id: string, PosX: number, PosY: number, Shift: boolean, Ctrl: boolean, Alt: boolean, SourceId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "HTMLTextView.js(219): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "HTMLTextView.js(220): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "HTMLTextView.js(221): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "HTMLTextView.js(222): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "HTMLTextView.js(223): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "HTMLTextView.js(224): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "HTMLTextView.js(225): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "HTMLTextView.js(226): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "HTMLTextView.js(227): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "HTMLTextView.js(228): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "HTMLTextView.js(229): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "HTMLTextView.js(230): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "HTMLTextView.js(231): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSourceId != null, "sSourceId != null", "HTMLTextView.js(232): fireContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSourceId) == "string", "typeof(sSourceId) == \"string\"", "HTMLTextView.js(233): fireContextMenu"); };
	mParams = {
		"Id": sId,
		"PosX": iPosX,
		"PosY": iPosY,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt,
		"SourceId": sSourceId
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("HTMLTextView", "ContextMenu", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_HTMLTextView["_"]["fireContextMenu"] = 0; };

UCF_HTMLTextView.prototype["aPublicMethods"] = ["setDragAndDropHandler"].concat(UCF_HTMLTextView.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_HeaderArea"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_PanelBase */
/// <reference path="./base/PanelBase.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_HeaderArea(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["UCF_HeaderArea"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "HeaderArea.js(23): UCF_HeaderArea"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HeaderArea.js(24): UCF_HeaderArea"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HeaderArea.js(25): UCF_HeaderArea"); };

	UCF_PanelBase["apply"](this, [oDomRef, oLS]);
	//create inplace edit objects and fields
	if (this["bHasEditableTitle"]) {
		var oInplaceEditDelegate = this["oInplaceEditDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEditDelegate"))(oLS);
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this, "onInplaceEditStart");
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this, "onInplaceEditFinished");
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this, 'onInplaceEditClosed');
		this["addDelegate"](oInplaceEditDelegate);
	}
};window["UCF_HeaderArea"] = UCF_HeaderArea; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HeaderArea"); UCF_HeaderArea["_"] = {UCF_HeaderArea: 0}; }; ;
UCF_HeaderArea["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PanelBase"))(); UCF_HeaderArea.prototype["sClassName"] = "UCF_HeaderArea";

/**
 * Destructor
 * @private
 */
UCF_HeaderArea["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["destroy"]++; }; 
	if (this["oInplaceEditDelegate"]) {
		this["oInplaceEditDelegate"]["destroy"]();
		this["oInplaceEditDelegate"] = null;
	}
	UCF_PanelBase.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["destroy"] = 0; };

/**
 * Returns the current control height in pixel
 * @return {int}
 * @public
 */
UCF_HeaderArea["prototype"]["getHeightPx"] = function() {;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["getHeightPx"]++; }; 
	return this["iGetHeightPx"]();
};;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["getHeightPx"] = 0; };

/**
 * Returns the current control width in pixel
 * @return {int}
 * @public
 */
UCF_HeaderArea["prototype"]["getWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["getWidthPx"]++; }; 
	return this["iGetWidthPx"]();
};;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["getWidthPx"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_HeaderArea["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;
	/** @type {Node} */
	var oNode;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			oNode = UCF_DomUtil["oGetFirstChildByAttribute"](
				this["oDomRef"],
				this["sId"] + '-titletext',
				'true'
			);
			if (oNode)
				UCF_Control["addAriaGeneric"](oNode, oSapTableInfo);
			this["bNeedsAriaGeneric"] = true;
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
		}
	}
	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["bPrepareAria"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_HeaderArea["prototype"]["aAttributeNames"] = ["sVisibility","sTooltip","sTitle","bHasEditableTitle","sAccessibilityDescription","sImageSrc","bIsCollapsible","bClientCollapse","bCollapsed","bEnabled","sHeaderDesign","bIsDragHandle","bTitleOverflow","iHeadingLevel","sAccessKey","sCustomData","sCustomStyle","iAriaHeadingLevel"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_HeaderArea["prototype"]["aEventNames"] = ["Collapse","Expand","Change","MenuAccess"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_HeaderArea["prototype"]["aMethodNames"] = ["openOnRequest","getHeightPx","getWidthPx","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_HeaderArea["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_HeaderArea["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HeaderArea["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_HeaderArea["prototype"]["bHasEditableTitle"] = false;

/**
 * @private
 * @type {string}
 */
UCF_HeaderArea["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HeaderArea["prototype"]["sImageSrc"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_HeaderArea["prototype"]["bIsCollapsible"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_HeaderArea["prototype"]["bClientCollapse"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_HeaderArea["prototype"]["bCollapsed"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_HeaderArea["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HeaderDesign}
 */
UCF_HeaderArea["prototype"]["sHeaderDesign"] = "STANDARD";

/**
 * @private
 * @type {boolean}
 */
UCF_HeaderArea["prototype"]["bIsDragHandle"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_HeaderArea["prototype"]["bTitleOverflow"] = false;

/**
 * @private
 * @type {number}
 */
UCF_HeaderArea["prototype"]["iHeadingLevel"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_HeaderArea["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HeaderArea["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HeaderArea["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {number}
 */
UCF_HeaderArea["prototype"]["iAriaHeadingLevel"] = 0;

//#JSCOVER_EXCL_START
/** @protected */
UCF_HeaderArea["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sTitle"] = '';
	this["bHasEditableTitle"] = false;
	this["sAccessibilityDescription"] = '';
	this["sImageSrc"] = '';
	this["bIsCollapsible"] = true;
	this["bClientCollapse"] = true;
	this["bCollapsed"] = false;
	this["bEnabled"] = true;
	this["sHeaderDesign"] = "STANDARD";
	this["bIsDragHandle"] = false;
	this["bTitleOverflow"] = false;
	this["iHeadingLevel"] = 0;
	this["sAccessKey"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["iAriaHeadingLevel"] = 0;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("HasEditableTitle", false, true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("ImageSrc", '', true);
		this["setClientProperty"]("IsCollapsible", true, true);
		this["setClientProperty"]("ClientCollapse", true, true);
		this["setClientProperty"]("Collapsed", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("HeaderDesign", "STANDARD", true);
		this["setClientProperty"]("IsDragHandle", false, true);
		this["setClientProperty"]("TitleOverflow", false, true);
		this["setClientProperty"]("HeadingLevel", 0, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("AriaHeadingLevel", 0, true);
	}
};;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The id of the HeaderArea.
 * @fires HeaderArea::Collapse
 */
UCF_HeaderArea["prototype"]["fireCollapse"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "HeaderArea.js(282): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "HeaderArea.js(283): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "HeaderArea.js(284): fireCollapse"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("HeaderArea", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["fireCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the HeaderArea.
 * @fires HeaderArea::Expand
 */
UCF_HeaderArea["prototype"]["fireExpand"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["fireExpand"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "HeaderArea.js(301): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "HeaderArea.js(302): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "HeaderArea.js(303): fireExpand"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("HeaderArea", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["fireExpand"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the Accordion.
 * @param {string} sValue The new tile.
 * @fires HeaderArea::Change
 */
UCF_HeaderArea["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "HeaderArea.js(321): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "HeaderArea.js(322): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "HeaderArea.js(323): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "HeaderArea.js(324): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "HeaderArea.js(325): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("HeaderArea", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the PopupTrigger control
 * @param {string} sPopupMenuId Identifier of the popupmenu associated to the item.
 * @param {boolean} bWithKeyboard Determines whether the menu is opened by a keyboard action or by a mouse action.
 * @fires HeaderArea::MenuAccess
 * @deprecated
 */
UCF_HeaderArea["prototype"]["fireMenuAccess"] = function(sId, sPopupMenuId, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string, PopupMenuId: string, WithKeyboard: boolean}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "HeaderArea.js(349): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "HeaderArea.js(350): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "HeaderArea.js(351): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPopupMenuId != null, "sPopupMenuId != null", "HeaderArea.js(352): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPopupMenuId) == "string", "typeof(sPopupMenuId) == \"string\"", "HeaderArea.js(353): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bWithKeyboard != null, "bWithKeyboard != null", "HeaderArea.js(354): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bWithKeyboard) == "boolean", "typeof(bWithKeyboard) == \"boolean\"", "HeaderArea.js(355): fireMenuAccess"); };
	mParams = {
		"Id": sId,
		"PopupMenuId": sPopupMenuId,
		"WithKeyboard": bWithKeyboard
	};
	
	if (sPopupMenuId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sPopupMenuId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "PopupMenuId");
			}
		}
	
	this["fireSemanticEvent"]("HeaderArea", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_HeaderArea["_"]["fireMenuAccess"] = 0; };

UCF_HeaderArea.prototype["aPublicMethods"] = ["getHeightPx","getWidthPx"].concat(UCF_HeaderArea.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_HierarchicalView"] = function() {/* global _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_HierarchicalView_ControlManager */
/// <reference path="./HierarchicalView_ControlManager.js"/>
/* global UCF_HierarchicalView_ItemManager */
/// <reference path="./HierarchicalView_ItemManager.js"/>
/* global UCF_HierarchicalView_SegmentManager */
/// <reference path="./HierarchicalView_SegmentManager.js"/>
// #region Typedefs ===========================================================
/** @typedef {'NONE'|'BREADCRUMB_SELF'|'BREADCRUMB_PARENT'|'BREADCRUMB_FULL'} UCF_HierarchicalView_Navigation */
// #endregion
// #region Lifecycle ==========================================================
// #region constructor --------------------------------------------------------
/**
 * @class
 * @extends UCF_Control
 * @depends UCF_HierarchicalView_ControlManager
 * @depends UCF_HierarchicalView_ItemManager
 * @depends UCF_HierarchicalView_SegmentManager
 * @param {HTMLDivElement} oDomRef the dom element
 * @param {UCF_LS} oLS the LightSpeed instance
 * 
 */
function UCF_HierarchicalView(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["UCF_HierarchicalView"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["defineEvents"]([
			'NavigationIntent',
			'FocusItemIntent',
			'FocusControlIntent',
			'ControlEvent',
			'ActivateItemIntent',
			'DeactivateItemIntent',
			'ManageSegmentIntent'
		]);

		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

		// have to create the ItemManager eagerly to make readonly items readonly
		// initially
		this["oGetItemManager"]();
	}
};window["UCF_HierarchicalView"] = UCF_HierarchicalView; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HierarchicalView"); UCF_HierarchicalView["_"] = {UCF_HierarchicalView: 0}; }; 
UCF_HierarchicalView["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_HierarchicalView.prototype["sClassName"] = "UCF_HierarchicalView";

/** @const {number} */
UCF_HierarchicalView["LARGE_STEP"] = 10;
// #endregion
// #region destroy ------------------------------------------------------------
/** @override */
UCF_HierarchicalView["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["destroy"]++; }; 
	if ('oSegmentManager' in this["oCache"]["mEntries"]) {
		this["oCache"]["mEntries"]["oSegmentManager"]["destroy"]();
	}

	if ('oItemManager' in this["oCache"]["mEntries"]) {
		this["oCache"]["mEntries"]["oItemManager"]["destroy"]();
	}

	if ('oControlManager' in this["oCache"]["mEntries"]) {
		this["oCache"]["mEntries"]["oControlManager"]["destroy"]();
	}

	this["oCache"]["destroy"]();
	this["oCache"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["destroy"] = 0; };
// #endregion
// #endregion
// #region Events =============================================================
// #region SegmentWillChange --------------------------------------------------
/**
 * @private
 * @param {UCF_Event<{sOldSegmentId: string, sSegmentId: string}>} oEvent
 */
UCF_HierarchicalView["prototype"]["onSegmentWillChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onSegmentWillChange"]++; }; 
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsHierarchicalview--iegridworkaround');
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onSegmentWillChange"] = 0; };
// #endregion
// #region SegmentDidChange ---------------------------------------------------
/**
 * @private
 * @param {UCF_Event<{sOldSegmentId: string, sSegmentId: string}>} oEvent
 */
UCF_HierarchicalView["prototype"]["onSegmentDidChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onSegmentDidChange"]++; }; 
	/** @type {string} */
	var sSegmentId = oEvent["oGetParam"]('sSegmentId');
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oItemManager = this["oGetItemManager"]();

	this["fireDeactivateItemIntent"](oItemManager["oGetActiveOfSegment"](
		oEvent["oGetParam"]('sOldSegmentId')
	));

	this["fireFocusItemIntent"](
		oItemManager["oGetFocusedOfSegment"](sSegmentId) ||
		oItemManager["oGetFirstOfSegment"](sSegmentId)
	);
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsHierarchicalview--iegridworkaround');
	}

	this["fireSegmentChange"](
		this["sId"],
		oEvent["oGetParam"]('sOldSegmentId'),
		sSegmentId
	);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onSegmentDidChange"] = 0; };
// #endregion
// #region FocusedItemDidChange -----------------------------------------------
/**
 * @private
 * @param {UCF_Event<{oItem: UCF_HierarchicalView_ItemManager_Item, oOldItem: UCF_HierarchicalView_ItemManager_Item}>} oEvent
 */
UCF_HierarchicalView["prototype"]["onFocusedItemDidChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onFocusedItemDidChange"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;

	this["oCache"]["get"]('bDidRemoveTabindex', function() {
		/** @type {HTMLDivElement} */
		var oCloseRef = self["oGetCloseRef"]();

		UCF_DomUtil["setTabIndex"](self["oRootRef"], -1);
		if (oCloseRef) {
			UCF_DomUtil["setTabIndex"](oCloseRef, -1);
		}

		return true;
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onFocusedItemDidChange"] = 0; };
// #endregion
// #region FocusLostToControl -------------------------------------------------
/**
 * @private
 * @param {UCF_Event<{oItem: UCF_HierarchicalView_ItemManager_Item}>} oEvent
 */
UCF_HierarchicalView["prototype"]["onFocusLostToControl"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onFocusLostToControl"]++; }; 
	this["fireFocusItemIntent"](oEvent["oGetParam"]('oControl')["sId"]);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onFocusLostToControl"] = 0; };
// #endregion
// #region ProxyEvent ---------------------------------------------------------
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_HierarchicalView["prototype"]["onProxyEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onProxyEvent"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {HTMLElement} */
	var oParent = UCF_DomUtil["oGetParentElement"](oSource);
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oItemManager = this["oGetItemManager"]();

	if (this["oGetControlManager"]()["bIsEventOnControlRef"](oBrowserEvent)) {
		if (oItemManager["bIsEnabledItemRef"](oSource)) {
			// event on <tr>
			if (!oItemManager["bIsItemRefWithSegment"](oSource)) {
				this["fireControlEvent"](oBrowserEvent);
			}
		} else {
			// event on <td>
			oParent = UCF_DomUtil["oGetParentElement"](oSource);

			if (oItemManager["bIsEnabledItemRef"](oParent)) {
				if (!oItemManager["bIsItemRefWithSegment"](oParent)) {
					oBrowserEvent["oSource"] = oParent;

					this["fireControlEvent"](oBrowserEvent);
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onProxyEvent"] = 0; };
// #endregion
// #region ItemNavigationEvent ------------------------------------------------
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {number} iStep
 */
UCF_HierarchicalView["prototype"]["onItemNavigationEvent"] = function(oBrowserEvent, iStep) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onItemNavigationEvent"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oItemManager = this["oGetItemManager"]();

	if (oItemManager["bIsItemRef"](oSource)) {
		this["fireFocusItemIntent"](oItemManager["oGetRelativeOfSegment"](
			this["oGetSegmentManager"]()["sGetActiveSegmentId"](),
			oSource,
			iStep
		));

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onItemNavigationEvent"] = 0; };
// #endregion
// #region lsfocus ------------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsFocus */
UCF_HierarchicalView["prototype"]["onlsfocus"] = function(oLsFocus) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsfocus"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oLsFocus["oGetSource"]();
	/** @type {UCF_Control} */
	var oSourceControl;
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oItemManager = this["oGetItemManager"]();
	/** @type {UCF_HierarchicalView_SegmentManager_SegmentId} */
	var sActiveSegmentId = this["oGetSegmentManager"]()["sGetActiveSegmentId"]();

	if (
		(oSource === this["oRootRef"] && !this["bHasFocusInside"]()) ||
		oSource === this["oGetCloseRef"]()
	) {
		this["fireFocusItemIntent"](
			oItemManager["oGetFocusedOfSegment"](sActiveSegmentId) ||
			oItemManager["oGetFirstOfSegment"](sActiveSegmentId)
		);

		oLsFocus["cancel"]();
		oLsFocus["cancelBubble"]();
	} else {
		oSourceControl = oLsFocus["oGetSourceControl"]();

		if (oItemManager["bIsContainedControl"](oSourceControl)) {
			if (this["bHasFocusInside"]()) {
				this["fireFocusControlIntent"](oSourceControl);
			} else {
				this["fireFocusItemIntent"](
					oItemManager["oGetItemRefFromControl"](oSourceControl) ||
					oItemManager["oGetFocusedOfSegment"](sActiveSegmentId) ||
					oItemManager["oGetFirstOfSegment"](sActiveSegmentId)
				);
			}
			oLsFocus["cancel"]();
			oLsFocus["cancelBubble"]();
		} else if (oSourceControl !== this) {
			this["fireFocusItemIntent"](oSourceControl["sId"]);
			oLsFocus["cancel"]();
			oLsFocus["cancelBubble"]();
		}
	}

	UCF_DomUtil["addClass"](this["oRootRef"], 'lsHierarchicalview--focus');
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsfocus"] = 0; };
// #endregion
// #region lsblur -------------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsBlur */
UCF_HierarchicalView["prototype"]["onlsblur"] = function(oLsBlur) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsblur"]++; }; 
	/** @type {HTMLElement} */
	var oRelatedTarget = UCF_DomUtil["oGetRelatedTarget"](oLsBlur["oDomEvent"]);

	if (!UCF_DomUtil["bContains"](this["oRootRef"], oRelatedTarget)) {
		UCF_DomUtil["removeClass"](this["oRootRef"], 'lsHierarchicalview--focus');
		this["fireDeactivateItemIntent"](this["oGetItemManager"]()["oGetActiveOfSegment"](
			this["oGetSegmentManager"]()["sGetActiveSegmentId"]()
		));
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsblur"] = 0; };
// #endregion
// #region lsaccessibility ----------------------------------------------------
/** @param {UCF_BrowserEvent} oLsAccessibility */
UCF_HierarchicalView["prototype"]["onlsaccessibility"] = function(oLsAccessibility) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsaccessibility"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oLsAccessibility["oGetSource"]();
	/** @type {UCF_HierarchicalView_SegmentManager} */
	var oSM = this["oGetSegmentManager"]();
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oIM = this["oGetItemManager"]();
	/** @type {UCF_HierarchicalView_ControlManager} */
	var oCM = this["oGetControlManager"]();
	/** @type {UCF_AccessibilityHelper} */
	var oAH = oLsAccessibility["oAccessibilityHelper"];
	/** @type {UCF_HierarchicalView_SegmentManager_SegmentId} */
	var sActiveSegmentId = oSM["sGetActiveSegmentId"]();
	/** @type {UCF_Control} */
	var oControl;

	if (oIM["bIsItemRefWithSegment"](oSource)) {
		oControl = oCM["oGetControl"](oSource);
		this["fireManageSegmentIntent"]({ "oItem": oSource });

		oAH["setText"](oIM["sGetItemText"](oSource));
		oAH["setTooltip"](oControl["sTooltip"]);
		oAH["setHotkey"](oControl["sHotkey"]);
		oAH["setControlType"](oControl["oDomRef"]["getAttribute"]('ct'));
		oAH["setItemIndex"](oSM["iGetItemIndexOfSegment"](
			oCM["sGetControlId"](oSource),
			sActiveSegmentId
		) + 1);
		oAH["setItemCount"](oSM["iGetItemCountOfSegment"](sActiveSegmentId));
		oAH["setContainingItemCount"](oSM["iGetItemCountOfSegment"](
			oIM["sGetReferencedSegmentIdFromItemRef"](oSource)
		));
		oAH["setLevel"](oSM["iGetLevelOfSegment"](sActiveSegmentId));
		oAH["setParentControlType"]('HV');
		oAH["addTutor"]('HV_TUT');
	} else if (oIM["bIsContainerItemRef"](oSource)) {
		oAH["setControlType"](oCM["oGetControl"](oSource)["sGetAccControlName"]());
		oAH["setItemIndex"](oSM["iGetItemIndexOfSegment"](
			oCM["sGetControlId"](oSource),
			sActiveSegmentId
		) + 1);
		oAH["setItemCount"](oSM["iGetItemCountOfSegment"](sActiveSegmentId));
		oAH["setContainingItemCount"](1);
		oAH["setLevel"](oSM["iGetLevelOfSegment"](sActiveSegmentId));
		oAH["setParentControlType"]('HV');
		oAH["addTutor"]('HV_TUT');
	} else if (oIM["bIsItemRef"](oSource)) {
		this["fireControlEvent"](oLsAccessibility);

		oAH["setEnabled"](!oIM["bHasState"](
			oSource,
			UCF_HierarchicalView_ItemManager["E_STATES"]["Disabled"]
		));
		oAH["setItemIndex"](oSM["iGetItemIndexOfSegment"](
			oCM["sGetControlId"](oSource),
			sActiveSegmentId
		) + 1);
		oAH["setItemCount"](oSM["iGetItemCountOfSegment"](sActiveSegmentId));
		oAH["setLevel"](oSM["iGetLevelOfSegment"](sActiveSegmentId));
		oAH["setParentControlType"]('HV');
		oAH["addTutor"]('HV_TUT');
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsaccessibility"] = 0; };
// #endregion
// #region lsescape -----------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsEscape */
UCF_HierarchicalView["prototype"]["onlsescape"] = function(oLsEscape) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsescape"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oIM = this["oGetItemManager"]();
	/** @type {UCF_Control} */
	var oSourceControl = oLsEscape["oGetSourceControl"]();

	if (oIM["bIsContainedControl"](oSourceControl)) {
		this["fireFocusItemIntent"](oSourceControl["sGetId"]());

		oLsEscape["cancel"]();
		oLsEscape["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsescape"] = 0; };
// #endregion
// #region lsleft -------------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsLeft */
UCF_HierarchicalView["prototype"]["onlsleft"] = function(oLsLeft) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsleft"]++; }; 
	/** @type {string} */
	var sActiveParentSegmentId = this["oGetSegmentManager"]()["sGetActiveParentSegmentId"]();

	if (typeof sActiveParentSegmentId === 'string') {
		this["fireNavigationIntent"]({ "sSegmentId": sActiveParentSegmentId });

		oLsLeft["cancel"]();
		oLsLeft["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsleft"] = 0; };
// #endregion
// #region lsright ------------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsRight */
UCF_HierarchicalView["prototype"]["onlsright"] = function(oLsRight) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsright"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oLsRight["oGetSource"]();
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oIM = this["oGetItemManager"]();

	if (oIM["bIsEnabledItemRef"](oSource) && oIM["bIsItemRefWithSegment"](oSource)) {
		this["fireNavigationIntent"]({ "oItem": oSource });

		oLsRight["cancel"]();
		oLsRight["cancelBubble"]();
	} else if (oIM["bIsContainerItemRef"](oSource)) {
		this["fireFocusControlIntent"](
			this["oLS"]["oControlFactory"]["oGetControlById"](
				UCF_DomUtil["oGetFirstChild"](
					UCF_DomUtil["oGetFirstChild"](oSource)
				)["id"]["replace"](/-.*$/g, ''),
				true
			)
		);

		oLsRight["cancel"]();
		oLsRight["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsright"] = 0; };
// #endregion
// #region lshome -------------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsHome */
UCF_HierarchicalView["prototype"]["onlshome"] = function(oLsHome) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlshome"]++; }; 
	this["onItemNavigationEvent"](oLsHome, Number["NEGATIVE_INFINITY"]);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlshome"] = 0; };
// #endregion
// #region lspageup -----------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsPageUp */
UCF_HierarchicalView["prototype"]["onlspageup"] = function(oLsPageUp) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlspageup"]++; }; 
	this["onItemNavigationEvent"](oLsPageUp, -UCF_HierarchicalView["LARGE_STEP"]);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlspageup"] = 0; };
// #endregion
// #region lsup ---------------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsUp */
UCF_HierarchicalView["prototype"]["onlsup"] = function(oLsUp) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsup"]++; }; 
	this["onItemNavigationEvent"](oLsUp, -1);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsup"] = 0; };
// #endregion
// #region lsdown -------------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsDown */
UCF_HierarchicalView["prototype"]["onlsdown"] = function(oLsDown) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsdown"]++; }; 
	this["onItemNavigationEvent"](oLsDown, 1);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsdown"] = 0; };
// #endregion
// #region lspagedown ---------------------------------------------------------
UCF_HierarchicalView["prototype"]["onlspagedown"] = function(oLsPageDown) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlspagedown"]++; }; 
	this["onItemNavigationEvent"](oLsPageDown, UCF_HierarchicalView["LARGE_STEP"]);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlspagedown"] = 0; };
// #endregion
// #region lsend --------------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsEnd */
UCF_HierarchicalView["prototype"]["onlsend"] = function(oLsEnd) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsend"]++; }; 
	this["onItemNavigationEvent"](oLsEnd, Number["POSITIVE_INFINITY"]);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsend"] = 0; };
// #endregion
// #region keydown ------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oKeyDown
 */
UCF_HierarchicalView["prototype"]["onkeydown"] = function(oKeyDown) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onkeydown"]++; }; 
	switch (oKeyDown["iKeyCode"]()) {
		case UCF_KeyCodes["SPACE"]:
		case UCF_KeyCodes["ENTER"]:
			this["fireActivateItemIntent"](oKeyDown["oGetSource"]());
			break;
	}

	this["onProxyEvent"](oKeyDown);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onkeydown"] = 0; };
// #endregion
// #region keypress -----------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oKeyPress
 */
UCF_HierarchicalView["prototype"]["onkeypress"] = function(oKeyPress) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onkeypress"]++; }; 
	this["onProxyEvent"](oKeyPress);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onkeypress"] = 0; };
// #endregion
// #region keyup --------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oKeyUp
 */
UCF_HierarchicalView["prototype"]["onkeyup"] = function(oKeyUp) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onkeyup"]++; }; 
	switch (oKeyUp["iKeyCode"]()) {
		case UCF_KeyCodes["SPACE"]:
		case UCF_KeyCodes["ENTER"]:
			this["fireDeactivateItemIntent"](oKeyUp["oGetSource"]());
			break;
	}

	this["onProxyEvent"](oKeyUp);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onkeyup"] = 0; };
// #endregion
// #region lsspace ------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oLsSpace
 */
UCF_HierarchicalView["prototype"]["onlsspace"] = function(oLsSpace) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsspace"]++; }; 
	this["onProxyEvent"](oLsSpace);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsspace"] = 0; };
// #endregion
// #region lsenter ------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oLsEnter
 */
UCF_HierarchicalView["prototype"]["onlsenter"] = function(oLsEnter) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsenter"]++; }; 
	this["onProxyEvent"](oLsEnter);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsenter"] = 0; };

// #endregion
// #region lsselect -----------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsSelect */
UCF_HierarchicalView["prototype"]["onlsselect"] = function(oLsSelect) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsselect"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oLsSelect["oGetSource"]();
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oItemManager = this["oGetItemManager"]();

	if (oItemManager["bIsEnabledItemRef"](oSource)) {
		if (oItemManager["bIsItemRefWithSegment"](oSource)) {
			this["fireNavigationIntent"]({ "oItem": oSource });

			oLsSelect["cancel"]();
			oLsSelect["cancelBubble"]();
		} else {
			this["fireControlEvent"](oLsSelect);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsselect"] = 0; };

// #endregion
// #region lsselect -----------------------------------------------------------
/** @param {UCF_BrowserEvent} oLsSelect */
UCF_HierarchicalView["prototype"]["onlsselectup"] = function(oLsSelect) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsselectup"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oLsSelect["oGetSource"]();
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oItemManager = this["oGetItemManager"]();

	if (oItemManager["bIsEnabledItemRef"](oSource)) {
		if (oItemManager["bIsItemRefWithSegment"](oSource)) {
			this["fireNavigationIntent"]({ "oItem": oSource });

			oLsSelect["cancel"]();
			oLsSelect["cancelBubble"]();
		} else {
			this["fireControlEvent"](oLsSelect);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onlsselectup"] = 0; };

// #endregion
// #region mousedown ----------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oMouseDown
 */
UCF_HierarchicalView["prototype"]["onmousedown"] = function(oMouseDown) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onmousedown"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oIM = this["oGetItemManager"]();
	/** @type {HTMLElement} */
	var oSource = oMouseDown["oGetSource"]();
	/** @type {HTMLElement} */
	var oParent;

	if (oIM["bIsItemRef"](oSource)) {
		this["fireActivateItemIntent"](oSource);
	} else {
		oParent = UCF_DomUtil["oGetParentElement"](oSource);

		if (oIM["bIsItemRef"](oParent)) {
			this["fireActivateItemIntent"](oParent);
		}
	}

	this["onProxyEvent"](oMouseDown);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onmousedown"] = 0; };
// #endregion
// #region mouseup ------------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oMouseUp
 */
UCF_HierarchicalView["prototype"]["onmouseup"] = function(oMouseUp) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onmouseup"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oIM = this["oGetItemManager"]();
	/** @type {HTMLElement} */
	var oSource = oMouseUp["oGetSource"]();
	/** @type {HTMLElement} */
	var oParent = UCF_DomUtil["oGetParentElement"](oSource);

	if (oIM["bIsItemRef"](oSource)) {
		this["fireDeactivateItemIntent"](oSource);
	} else {
		oParent = UCF_DomUtil["oGetParentElement"](oSource);

		if (oIM["bIsItemRef"](oParent)) {
			this["fireDeactivateItemIntent"](oParent);
		}
	}

	this["onProxyEvent"](oMouseUp);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onmouseup"] = 0; };
// #endregion
// #region mouseout -----------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oMouseOut
 */
UCF_HierarchicalView["prototype"]["onmouseout"] = function(oMouseOut) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onmouseout"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oIM = this["oGetItemManager"]();
	/** @type {HTMLElement} */
	var oSource = oMouseOut["oGetSource"]();
	/** @type {HTMLElement} */
	var oParent = UCF_DomUtil["oGetParentElement"](oSource);

	if (oIM["bIsItemRef"](oSource)) {
		this["fireDeactivateItemIntent"](oSource);
	} else {
		oParent = UCF_DomUtil["oGetParentElement"](oSource);

		if (oIM["bIsItemRef"](oParent)) {
			this["fireDeactivateItemIntent"](oParent);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onmouseout"] = 0; };
// #endregion
// #region click --------------------------------------------------------------
/** @param {UCF_BrowserEvent} oClick */
UCF_HierarchicalView["prototype"]["onclick"] = function(oClick) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onclick"]++; }; 
	/** @type {HTMLElement} */
	var oSourceRef = oClick["oGetSource"]();
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oItemManager = this["oGetItemManager"]();
	/** @type {HTMLElement} */
	var oParentRef;

	if (UCF_HierarchicalView_SegmentManager["bIsNavigationItemRef"](oSourceRef)) {
		this["fireNavigationIntent"](
			this["sGetNavigation"]() === 'BREADCRUMB_SELF'
			? { "sSegmentId": this["oGetSegmentManager"]()["sGetActiveParentSegmentId"]() }
			: { "oItem": oSourceRef }
		);

		oClick["cancel"]();
		oClick["cancelBubble"]();
	} else if (oItemManager["bIsEnabledItemRef"](oSourceRef)) {
		this["fireControlEvent"](oClick);

		oClick["cancel"]();
		oClick["cancelBubble"]();
	} else {
		oParentRef = UCF_DomUtil["oGetParentElement"](oSourceRef);

		if (oItemManager["bIsEnabledItemRef"](oParentRef)) {
			oClick["oSource"] = oParentRef;

			this["fireFocusItemIntent"](oParentRef);

			if (oItemManager["bIsItemRefWithSegment"](oParentRef)) {
				this["fireNavigationIntent"]({ "oItem": oParentRef });
			} else {
				this["fireControlEvent"](oClick);
			}

			oClick["cancel"]();
			oClick["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["onclick"] = 0; };
// #endregion
// #region dblclick -----------------------------------------------------------
/**
 * @protected
 * @param {UCF_BrowserEvent} oDblClick
 */
UCF_HierarchicalView["prototype"]["ondblclick"] = function(oDblClick) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["ondblclick"]++; }; 
	this["onProxyEvent"](oDblClick);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["ondblclick"] = 0; };
// #endregion
// #endregion
// #region (cached) Control properties ========================================
// #region oGetCloseRef -------------------------------------------------------
/**
 * @private
 * @return {HTMLDivElement}
 */
UCF_HierarchicalView["prototype"]["oGetCloseRef"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["oGetCloseRef"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;

	return this["oCache"]["get"]('oCloseRef', function() {
		return UCF_DomUtil["querySelector"](
			'[id="' + self["sId"] + '-navigation"] [ct="B"]'
		);
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["oGetCloseRef"] = 0; };
// #endregion
// #region bHasFocusInside ----------------------------------------------------
/**
 * @private
 * @return {boolean}
 */
UCF_HierarchicalView["prototype"]["bHasFocusInside"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["bHasFocusInside"]++; }; 
	return UCF_DomUtil["bHasClass"](this["oRootRef"], 'lsHierarchicalview--focus');
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["bHasFocusInside"] = 0; };
// #endregion
// #region sGetNavigation -----------------------------------------------------
/**
 * @protected
 * @return {UCF_HierarchicalView_Navigation}
 */
UCF_HierarchicalView["prototype"]["sGetNavigation"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["sGetNavigation"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;

	return this["oCache"]["get"]('sNavigation', function() {
		if (UCF_DomUtil["bHasClass"](self["oRootRef"], 'lsHierarchicalview--breadcrumbfull')) {
			return 'BREADCRUMB_FULL';
		} else if (UCF_DomUtil["bHasClass"](self["oRootRef"], 'lsHierarchicalview--breadcrumbparent')) {
			return 'BREADCRUMB_PARENT';
		} else if (UCF_DomUtil["bHasClass"](self["oRootRef"], 'lsHierarchicalview--breadcrumbself')) {
			return 'BREADCRUMB_SELF';
		} else {
			return 'NONE';
		}
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["sGetNavigation"] = 0; };
// #endregion
// #region oGetSegmentManager -------------------------------------------------
/**
 * @protected
 * @return {UCF_HierarchicalView_SegmentManager}
 */
UCF_HierarchicalView["prototype"]["oGetSegmentManager"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["oGetSegmentManager"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;

	return this["oCache"]["get"]('oSegmentManager', function() {
		/** @type {UCF_HierarchicalView_SegmentManager} */
		var oSegmentManager = new (UCF_ClassLoader["oGetClass"]("UCF_HierarchicalView_SegmentManager"))(self);

		self["attachEvent"](
			self["E_EVENTS"]["NavigationIntent"],
			oSegmentManager,
			'onNavigationIntent'
		);

		self["attachEvent"](
			self["E_EVENTS"]["ManageSegmentIntent"],
			oSegmentManager,
			'onManageSegmentIntent'
		);

		oSegmentManager["attachEvent"](
			oSegmentManager["E_EVENTS"]["SegmentWillChange"],
			self,
			'onSegmentWillChange'
		);

		oSegmentManager["attachEvent"](
			oSegmentManager["E_EVENTS"]["SegmentDidChange"],
			self,
			'onSegmentDidChange'
		);

		return oSegmentManager;
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["oGetSegmentManager"] = 0; };
// #endregion
// #region oGetItemManager ----------------------------------------------------
/**
 * @protected
 * @return {UCF_HierarchicalView_ItemManager}
 */
UCF_HierarchicalView["prototype"]["oGetItemManager"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["oGetItemManager"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;

	return this["oCache"]["get"]('oItemManager', function() {
		/** @type {UCF_HierarchicalView_ItemManager} */
		var oItemManager = new (UCF_ClassLoader["oGetClass"]("UCF_HierarchicalView_ItemManager"))(self);
		/** @type {UCF_HierarchicalView_SegmentManager} */
		var oSegmentManager = self["oGetSegmentManager"]();

		self["attachEvent"](
			self["E_EVENTS"]["FocusItemIntent"],
			oItemManager,
			'onFocusItemIntent'
		);

		self["attachEvent"](
			self["E_EVENTS"]["FocusControlIntent"],
			oItemManager,
			'onFocusControlIntent'
		);

		self["attachEvent"](
			self["E_EVENTS"]["ActivateItemIntent"],
			oItemManager,
			'onActivateItemIntent'
		);

		self["attachEvent"](
			self["E_EVENTS"]["DeactivateItemIntent"],
			oItemManager,
			'onDeactivateItemIntent'
		);

		oItemManager["attachEvent"](
			oItemManager["E_EVENTS"]["FocusedItemDidChange"],
			self,
			'onFocusedItemDidChange'
		);

		oSegmentManager["attachEvent"](
			oSegmentManager["E_EVENTS"]["SegmentDidChange"],
			oItemManager,
			'onSegmentDidChange'
		);

		return oItemManager;
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["oGetItemManager"] = 0; };
// #endregion
// #region oGetControlManager -------------------------------------------------
/**
 * @protected
 * @return {UCF_HierarchicalView_ControlManager}
 */
UCF_HierarchicalView["prototype"]["oGetControlManager"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["oGetControlManager"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;

	return this["oCache"]["get"]('oControlManager', function() {
		var oControlManager = new (UCF_ClassLoader["oGetClass"]("UCF_HierarchicalView_ControlManager"))(self);

		self["attachEvent"](
			self["E_EVENTS"]["ControlEvent"],
			oControlManager,
			'onControlEvent'
		);

		oControlManager["attachEvent"](
			oControlManager["E_EVENTS"]["FocusLostToControl"],
			self,
			'onFocusLostToControl'
		);

		return oControlManager;
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["oGetControlManager"] = 0; };
// #endregion
// #endregion
// #region Event emitters =====================================================
// #region fireNavigationIntent -----------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_SegmentManager_ShowSegmentOptions} oOptions
 */
UCF_HierarchicalView["prototype"]["fireNavigationIntent"] = function(oOptions) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireNavigationIntent"]++; }; 
	this["oGetSegmentManager"]();

	if (oOptions) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '#' + this["sId"] + ' intent to navigate to segment "' + (typeof oOptions["sSegmentId"] === 'string' ? oOptions["sSegmentId"] : (this["oGetItemManager"]()["sGetReferencedSegmentIdFromItemRef"](oOptions["oItem"]))) + '"', "HierarchicalView.js(852): fireNavigationIntent"); };
	}

	this["fireEvent"](this["E_EVENTS"]["NavigationIntent"], oOptions);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireNavigationIntent"] = 0; };
// #endregion
// #region fireFocusItemIntent ------------------------------------------------
/**
 * @private
 * @param {string|UCF_HierarchicalView_ItemManager_Item} oItem
 */
UCF_HierarchicalView["prototype"]["fireFocusItemIntent"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireFocusItemIntent"]++; }; 
	/** @type {string} */
	var sControlId = typeof oItem === 'string'
		? this["sId"] + '-' + oItem
		: (oItem ? oItem["id"] : '');

	this["oGetItemManager"]();

	if (oItem) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '#' + this["sId"] + ' intent to focus item "' + sControlId + '"', "HierarchicalView.js(872): fireFocusItemIntent"); };
	}

	this["fireEvent"](this["E_EVENTS"]["FocusItemIntent"], { "sControlId": sControlId });
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireFocusItemIntent"] = 0; };
// #endregion
// #region fireFocusControlIntent ---------------------------------------------
/**
 * @private
 * @param {UCF_Control} oControl
 */
UCF_HierarchicalView["prototype"]["fireFocusControlIntent"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireFocusControlIntent"]++; }; 
	this["oGetItemManager"]();

	if (oControl) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '#' + this["sId"] + ' intent to focus control "' + oControl["sId"] + '"', "HierarchicalView.js(887): fireFocusControlIntent"); };
	}

	this["fireEvent"](this["E_EVENTS"]["FocusControlIntent"], { "oControl": oControl });
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireFocusControlIntent"] = 0; };
// #endregion
// #region fireControlEvent ---------------------------------------------------
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_HierarchicalView["prototype"]["fireControlEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireControlEvent"]++; }; 
	this["oGetControlManager"]();

	this["fireEvent"](this["E_EVENTS"]["ControlEvent"], { "oBrowserEvent": oBrowserEvent });
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireControlEvent"] = 0; };
// #endregion
// #region fireActivateItemIntent ---------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_ItemManager_Item} oItem
 */
UCF_HierarchicalView["prototype"]["fireActivateItemIntent"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireActivateItemIntent"]++; }; 
	this["oGetItemManager"]();

	if (oItem) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '#' + this["sId"] + ' intent to activate item "' + oItem["id"] + '"', "HierarchicalView.js(913): fireActivateItemIntent"); };
	}

	this["fireEvent"](this["E_EVENTS"]["ActivateItemIntent"], { "oItem": oItem });
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireActivateItemIntent"] = 0; };
// #endregion
// #region fireDeactivateItemIntent -------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_ItemManager_Item} oItem
 */
UCF_HierarchicalView["prototype"]["fireDeactivateItemIntent"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireDeactivateItemIntent"]++; }; 
	this["oGetItemManager"]();

	if (oItem) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '#' + this["sId"] + ' intent to deactivate item "' + oItem["id"] + '"', "HierarchicalView.js(928): fireDeactivateItemIntent"); };
	}

	this["fireEvent"](this["E_EVENTS"]["DeactivateItemIntent"], { "oItem": oItem });
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireDeactivateItemIntent"] = 0; };
// #endregion
// #region fireManageSegmentIntent --------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_SegmentManager_ShowSegmentOptions} oOptions
 */
UCF_HierarchicalView["prototype"]["fireManageSegmentIntent"] = function(oOptions) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireManageSegmentIntent"]++; }; 
	this["oGetSegmentManager"]();

	if (oOptions) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '#' + this["sId"] + ' intent to manage segment "' + (typeof oOptions["sSegmentId"] === 'string' ? oOptions["sSegmentId"] : (this["oGetItemManager"]()["sGetReferencedSegmentIdFromItemRef"](oOptions["oItem"]))) + '"', "HierarchicalView.js(943): fireManageSegmentIntent"); };
	}

	this["fireEvent"](this["E_EVENTS"]["ManageSegmentIntent"], oOptions);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireManageSegmentIntent"] = 0; };
// #endregion
// #endregion
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_HierarchicalView["prototype"]["aAttributeNames"] = ["sSegmentId"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_HierarchicalView["prototype"]["aEventNames"] = ["SegmentChange"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_HierarchicalView["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_HierarchicalView["prototype"]["sSegmentId"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_HierarchicalView["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["setDefaultValues"]++; }; 
	this["sSegmentId"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("SegmentId", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId undefined
 * @param {string} sOldSegmentId undefined
 * @param {string} sNewSegmentId undefined
 * @fires HierarchicalView::SegmentChange
 */
UCF_HierarchicalView["prototype"]["fireSegmentChange"] = function(sId, sOldSegmentId, sNewSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireSegmentChange"]++; }; 
	/** @type {{Id: string, OldSegmentId: string, NewSegmentId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "HierarchicalView.js(1000): fireSegmentChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "HierarchicalView.js(1001): fireSegmentChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "HierarchicalView.js(1002): fireSegmentChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sOldSegmentId != null, "sOldSegmentId != null", "HierarchicalView.js(1003): fireSegmentChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sOldSegmentId) == "string", "typeof(sOldSegmentId) == \"string\"", "HierarchicalView.js(1004): fireSegmentChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNewSegmentId != null, "sNewSegmentId != null", "HierarchicalView.js(1005): fireSegmentChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNewSegmentId) == "string", "typeof(sNewSegmentId) == \"string\"", "HierarchicalView.js(1006): fireSegmentChange"); };
	mParams = {
		"Id": sId,
		"OldSegmentId": sOldSegmentId,
		"NewSegmentId": sNewSegmentId
	};
	
	
	
	this["fireSemanticEvent"]("HierarchicalView", "SegmentChange", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView["_"]["fireSegmentChange"] = 0; };

};
sap["ls"]["preload"]["UCF_HierarchicalView_ControlManager"] = function() {/* global _trace, DEBUG, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_EventProvider */
/// <reference path="../../core/EventProvider.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_HierarchicalView */
/// <reference path="./HierarchicalView.js"/>
// #region types ==============================================================
/** @typedef {0} UCF_HierarchicalView_ControlManager_FocusLostToControlEvent */
/** @typedef {UCF_HierarchicalView_ControlManager_FocusLostToControlEvent} UCF_HierarchicalView_ControlManager_Event */
// #endregion
// #region lifecycle ==========================================================
// #region constructor --------------------------------------------------------
/**
 * @class
 * @extends UCF_EventProvider
 * @param {UCF_HierarchicalView} oControl
 */
function UCF_HierarchicalView_ControlManager(oControl) {if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["UCF_HierarchicalView_ControlManager"]++; }; 
	if (arguments["length"] > 0) {
		UCF_EventProvider["apply"](this);

		this["defineEvents"](['FocusLostToControl']);

		/** @type {UCF_HierarchicalView} */
		this["oControl"] = oControl;
		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
	}
};window["UCF_HierarchicalView_ControlManager"] = UCF_HierarchicalView_ControlManager; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HierarchicalView_ControlManager"); UCF_HierarchicalView_ControlManager["_"] = {UCF_HierarchicalView_ControlManager: 0}; }; ;
UCF_HierarchicalView_ControlManager["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_HierarchicalView_ControlManager.prototype["sClassName"] = "UCF_HierarchicalView_ControlManager";
// #endregion
// #region destroy ------------------------------------------------------------
/** @override */
UCF_HierarchicalView_ControlManager["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["destroy"]++; }; 
	this["oCache"]["destroy"]();
	this["oCache"] = null;
	this["oControl"] = null;
	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["destroy"] = 0; };
// #endregion
// #endregion
// #region event handlers =====================================================
// #region onControlEvent -----------------------------------------------------
// #region handler ............................................................
/**
 * @protected
 * @param {UCF_Event<{oBrowserEvent: UCF_BrowserEvent}>} oEvent
 */
UCF_HierarchicalView_ControlManager["prototype"]["onControlEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onControlEvent"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {UCF_Control} */
	var oRealControl = this["oGetControl"](oSource);
	/** @type {UCF_BrowserEvent} */
	var oRealBrowserEvent;
	/** @type {string} */
	var sName;
	/** @type {string} */
	var sHandlerName;
	/** @type {string} */
	var sHandlerNameUp;
	/** @type {string} */
	var sLocalHandlerName;

	if (oRealControl) {
		oRealBrowserEvent = this["cloneBrowserEvent"](oBrowserEvent);
		oRealBrowserEvent["oSource"] = oRealControl["oDomRef"];
		oRealBrowserEvent["oSourceControl"] = oRealControl;

		sName = oBrowserEvent["sGetName"]();
		sHandlerName = 'on' + sName;
		sHandlerNameUp = 'on' + sName + 'up';
		sLocalHandlerName = 'on' + oRealControl["sClassName"] + '_' + sName;

		if (sLocalHandlerName in this) {
			this[sLocalHandlerName](oRealControl, oRealBrowserEvent);
		} else if (sHandlerName in oRealControl && sHandlerNameUp in oRealControl) {
			oRealControl[sHandlerName](oRealBrowserEvent);
			oRealControl[sHandlerNameUp](oRealBrowserEvent);
		} else if (sHandlerName in oRealControl) {
			oRealControl[sHandlerName](oRealBrowserEvent);
		} else if (sHandlerNameUp in oRealControl) {
			oRealControl[sHandlerNameUp](oRealBrowserEvent);
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '"' + sName + '" handler neither known locally nor found in control -- dropping event', "HierarchicalView_ControlManager.js(95): onControlEvent"); };
		}

		oRealBrowserEvent["destroy"]();
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'no control for "' + sHandlerName + '" on ' + oSource["nodeName"]["toLowerCase"]() + (oSource["id"] ? '#' + oSource["id"] : '') + (oSource["getAttribute"]('ct') ? '[ct="' + oSource["getAttribute"]('ct') + '"]' : '') + (oSource["className"] ? '.' + oSource["className"]["replace"](/ /g, '.') : '') + ' -- dropping event', "HierarchicalView_ControlManager.js(100): onControlEvent"); };
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onControlEvent"] = 0; };
// #endregion
// #region cloneBrowserEvent ..................................................
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {UCF_BrowserEvent}
 */
UCF_HierarchicalView_ControlManager["prototype"]["cloneBrowserEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["cloneBrowserEvent"]++; }; 
	/** @type {Event} */
	var oDomEvent = oBrowserEvent["oDomEvent"];
	/** @type {UCF_BrowserEvent} */
	// eslint-disable-next-line @ur/no-memory-leaks
	var oNew = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oDomEvent);

	oNew["oDomEvent"] = oDomEvent;
	oNew["oAccessibilityHelper"] = oBrowserEvent["oAccessibilityHelper"];

	return oNew;
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["cloneBrowserEvent"] = 0; };
// #endregion
// #endregion
// #region UCF_ToolbarLink ----------------------------------------------------
// #region onUCF_ToolbarLink_click ............................................
/**
 * @private
 * @param {UCF_ToolbarLink} oToolbarLink
 * @param {UCF_BrowserEvent} oClick
 */
UCF_HierarchicalView_ControlManager["prototype"]["onUCF_ToolbarLink_click"] = function(oToolbarLink, oClick) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onUCF_ToolbarLink_click"]++; }; 
	oToolbarLink["onlsselect"](oClick);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onUCF_ToolbarLink_click"] = 0; };
// #endregion
// #endregion
// #region UCF_Link -----------------------------------------------------------
// #region onUCF_Link_click ...................................................
/**
 * @private
 * @param {UCF_Link} oLink
 * @param {UCF_BrowserEvent} oClick
 */
UCF_HierarchicalView_ControlManager["prototype"]["onUCF_Link_click"] = function(oLink, oClick) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onUCF_Link_click"]++; }; 
	oLink["onlsselect"](oClick);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onUCF_Link_click"] = 0; };
// #endregion
// #endregion
// #region UCF_PopupMenu ------------------------------------------------------
// #region onUCF_PopupMenuItem_lsselect .......................................
/**
 * @private
 * @param {UCF_PopupMenuItem} oPopupMenuItem
 * @param {UCF_BrowserEvent} oLsSelect
 */
UCF_HierarchicalView_ControlManager["prototype"]["onUCF_PopupMenuItem_lsselect"] = function(oPopupMenuItem, oLsSelect) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onUCF_PopupMenuItem_lsselect"]++; }; 
	if (!oPopupMenuItem["oMenu"]) {
		oPopupMenuItem["oGetParent"]()["aGetVisibleItems"]();
	}
	oPopupMenuItem["oMenu"]["setSelectedItem"](oPopupMenuItem);
	oPopupMenuItem["oMenu"]["selectItem"](oLsSelect);

	this["fireFocusLostToControl"](oPopupMenuItem);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onUCF_PopupMenuItem_lsselect"] = 0; };
// #endregion
// #region onUCF_PopupMenuItem_click ..........................................
/**
 * @private
 * @param {UCF_PopupMenuItem} oPopupMenuItem
 * @param {UCF_BrowserEvent} oClick
 */
UCF_HierarchicalView_ControlManager["prototype"]["onUCF_PopupMenuItem_click"] = function(oPopupMenuItem, oClick) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onUCF_PopupMenuItem_click"]++; }; 
	if (!oPopupMenuItem["oMenu"]) {
		oPopupMenuItem["oGetParent"]()["aGetVisibleItems"]();
	}
	oPopupMenuItem["oMenu"]["setSelectedItem"](oPopupMenuItem);
	oPopupMenuItem["oMenu"]["selectItem"](oClick);

	this["fireFocusLostToControl"](oPopupMenuItem);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onUCF_PopupMenuItem_click"] = 0; };
// #endregion
// #region onUCF_PopupMenuItem_lsaccessibility ................................
/**
 * @private
 * @param {UCF_PopupMenuItem} oPopupMenuItem
 * @param {UCF_BrowserEvent} oLsAccessibility
 */
UCF_HierarchicalView_ControlManager["prototype"]["onUCF_PopupMenuItem_lsaccessibility"] = function(oPopupMenuItem, oLsAccessibility) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onUCF_PopupMenuItem_lsaccessibility"]++; }; 
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper = oLsAccessibility["oAccessibilityHelper"];

	oAccessibilityHelper["setText"](oPopupMenuItem["sText"]);
	oAccessibilityHelper["setHotkey"](oPopupMenuItem["sHotkey"]);
	oAccessibilityHelper["setEnabled"](oPopupMenuItem["bEnabled"]);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["onUCF_PopupMenuItem_lsaccessibility"] = 0; };
// #endregion
// #endregion
// #endregion
// #region control inspection =================================================
// #region sGetControlId ------------------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_ItemManager_Item} oItemRef
 * @return {string}
 */
UCF_HierarchicalView_ControlManager["prototype"]["sGetControlId"] = function(oItemRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["sGetControlId"]++; }; 
	/** @type {UCF_HierarchicalView_ControlManager} */
	var self = this;

	return oItemRef && this["oCache"]["get"]('sControlId' + oItemRef["id"], function() {
		return UCF_HierarchicalView_ControlManager["sGetControlIdStatic"](
			self["oControl"],
			oItemRef
		);
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["sGetControlId"] = 0; };
// #region sGetControlIdStatic ................................................
/**
 * @protected
 * @static
 * @param {UCF_HierarchicalView} oControl
 * @param {UCF_HierarchicalView_ItemManager_Item} oItemRef
 * @return {string}
 */
UCF_HierarchicalView_ControlManager["sGetControlIdStatic"] = function(oControl, oItemRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["sGetControlIdStatic"]++; }; 
	return oControl
		&& oControl["sId"]
		&& oItemRef
		&& oItemRef["id"]
		// might be an $Id-r with a <xmp> in it (PopupMenu)
		&& oItemRef["id"]["slice"]((oControl["sId"] + '-')["length"])["replace"](/-.*$/, '');
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["sGetControlIdStatic"] = 0; };
// #endregion
// #endregion
// #region oGetControl --------------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_ItemManager_Item} oItemRef
 * @return {UCF_Control}
 */
UCF_HierarchicalView_ControlManager["prototype"]["oGetControl"] = function(oItemRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["oGetControl"]++; }; 
	return this["oControl"]["oLS"]["oControlFactory"]["oGetControlById"](
		this["sGetControlId"](oItemRef)
	);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["oGetControl"] = 0; };
// #region oGetControlStatic ..................................................
/**
 * @protected
 * @static
 * @param {UCF_HierarchicalView} oControl
 * @param {UCF_HierarchicalView_ItemManager_Item} oItemRef
 * @return {UCF_Control}
 */
UCF_HierarchicalView_ControlManager["oGetControlStatic"] = function(oControl, oItemRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["oGetControlStatic"]++; }; 
	return oControl["oLS"]["oControlFactory"]["oGetControlById"](
		UCF_HierarchicalView_ControlManager["sGetControlIdStatic"](oControl, oItemRef)
	);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["oGetControlStatic"] = 0; };
// #endregion
// #endregion
// #region bIsEventOnControlRef -----------------------------------------------
UCF_HierarchicalView_ControlManager["prototype"]["bIsEventOnControlRef"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["bIsEventOnControlRef"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oItemManager = this["oControl"]["oGetItemManager"]();

	return oItemManager["bIsEnabledItemRef"](oSource)
		|| oItemManager["bIsEnabledItemRef"](UCF_DomUtil["oGetParentElement"](oSource));
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["bIsEventOnControlRef"] = 0; };
// #endregion
// #endregion
// #region event providers ====================================================
// #region fireFocusLostToControl ---------------------------------------------
/**
 * @private
 * @param {UCF_Control} oControl
 */
UCF_HierarchicalView_ControlManager["prototype"]["fireFocusLostToControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["fireFocusLostToControl"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["FocusLostToControl"], {
		"oControl": oControl
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ControlManager["_"]["fireFocusLostToControl"] = 0; };
// #endregion
// #endregion

};
sap["ls"]["preload"]["UCF_HierarchicalView_ItemManager"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_EventProvider */
/// <reference path="../../core/EventProvider.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_HierarchicalView_SegmentManager */
/// <reference path="./HierarchicalView_SegmentManager.js"/>

// #region typedefs ===========================================================
/** @typedef {HTMLTableRowElement} UCF_HierarchicalView_ItemManager_Item */
/** @typedef {0} UCF_HierarchicalView_ItemManager_Disabled */
/** @typedef {1} UCF_HierarchicalView_ItemManager_Readonly */
/** @typedef {2} UCF_HierarchicalView_ItemManager_Active */
/** @typedef {3} UCF_HierarchicalView_ItemManager_Focus */
/** @typedef {4} UCF_HierarchicalView_ItemManager_HasSegment */
/** @typedef {5} UCF_HierarchicalView_ItemManager_IsContainer */
/** @typedef {6} UCF_HierarchicalView_ItemManager_IsActive */
/** @typedef {7} UCF_HierarchicalView_ItemManager_Hoverable */
/** @typedef {UCF_HierarchicalView_ItemManager_Disabled|UCF_HierarchicalView_ItemManager_Readonly|UCF_HierarchicalView_ItemManager_Active|UCF_HierarchicalView_ItemManager_Focus|UCF_HierarchicalView_ItemManager_HasSegment|UCF_HierarchicalView_ItemManager_IsContainer} UCF_HierarchicalView_ItemManager_State */
// #endregion
// #region Lifecycle ==========================================================
// #region constructor --------------------------------------------------------
/**
 * @class
 * @extends UCF_EventProvider
 * @param {UCF_HierarchicalView} oControl
 */
function UCF_HierarchicalView_ItemManager(oControl) {if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["UCF_HierarchicalView_ItemManager"]++; }; 
	if (arguments["length"] > 0) {
		UCF_EventProvider["apply"](this);

		this["defineEvents"](['FocusedItemDidChange']);

		/** @type {UCF_HierarchicalView} */
		this["oControl"] = oControl;
		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

		// the segment already changed before the ItemManager was created
		// => fake a segmentDidChange event initially
		this["onSegmentDidChange"](new (UCF_ClassLoader["oGetClass"]("UCF_Event"))(
			1, // (new UCF_HierarchicalView_SegmentManager(oControl)).E_EVENTS.SegmentDidChange
			{ "sSegmentId": this["oControl"]["sSegmentId"] }
		));
	}
};window["UCF_HierarchicalView_ItemManager"] = UCF_HierarchicalView_ItemManager; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HierarchicalView_ItemManager"); UCF_HierarchicalView_ItemManager["_"] = {UCF_HierarchicalView_ItemManager: 0}; }; ;
UCF_HierarchicalView_ItemManager["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_HierarchicalView_ItemManager.prototype["sClassName"] = "UCF_HierarchicalView_ItemManager";
// #endregion
// #region constants ----------------------------------------------------------
// #region E_STATES ...........................................................
/**
 * @constant
 * @enum {UCF_HierarchicalView_ItemManager_State}
 */
UCF_HierarchicalView_ItemManager["E_STATES"] = {
	// Focusable: -2 (faked by bIsFocusableItemRef)
	// Enabled: -1 (faked by bIsEnabledItemRef)
	"Disabled": 0,
	"Readonly": 1,
	"Active": 2,
	"Focus": 3,
	"HasSegment": 4,
	"IsContainer": 5,
	"IsActive": 6,
	"Hoverable": 7
};
// #endregion
// #region E_STATE_CLASSES ....................................................
/** @enum {string} */
UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"] = {};
UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"][
	UCF_HierarchicalView_ItemManager["E_STATES"]["Disabled"]
] = 'lsHierarchicalview__item--disabled';
UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"][
	UCF_HierarchicalView_ItemManager["E_STATES"]["Readonly"]
] = 'lsHierarchicalview__item--readonly';
UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"][
	UCF_HierarchicalView_ItemManager["E_STATES"]["Active"]
] = 'lsHierarchicalview__item--active';
UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"][
	UCF_HierarchicalView_ItemManager["E_STATES"]["IsActive"]
] = 'lsHierarchicalview__item--isactive';
UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"][
	UCF_HierarchicalView_ItemManager["E_STATES"]["HasSegment"]
] = 'lsHierarchicalview__item--hassegment';
UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"][
	UCF_HierarchicalView_ItemManager["E_STATES"]["IsContainer"]
] = 'lsHierarchicalview__item--container';
UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"][
	UCF_HierarchicalView_ItemManager["E_STATES"]["Hoverable"]
] = 'lsHierarchicalview__item--hoverable';
// #endregion
// #endregion
// #region destroy ------------------------------------------------------------
/** @override */
UCF_HierarchicalView_ItemManager["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["destroy"]++; }; 

	this["oCache"]["destroy"]();
	this["oCache"] = null;
	this["oControl"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["destroy"] = 0; };
// #endregion
// #endregion
// #region Event handlers =====================================================
// #region FocusItemIntent ----------------------------------------------------
/**
 * @protected
 * @param {UCF_Event} oEvent
 */
UCF_HierarchicalView_ItemManager["prototype"]["onFocusItemIntent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["onFocusItemIntent"]++; }; 
	// need to pass id and re-access element from DOM to always have valid refs
	this["focusItem"](UCF_DomUtil["$"](oEvent["oGetParam"]('sControlId')));
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["onFocusItemIntent"] = 0; };
// #endregion
// #region FocusControlIntent -------------------------------------------------
/**
 * @protected
 * @param {UCF_Event} oEvent
 */
UCF_HierarchicalView_ItemManager["prototype"]["onFocusControlIntent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["onFocusControlIntent"]++; }; 
	this["focusControl"](oEvent["oGetParam"]('oControl'));
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["onFocusControlIntent"] = 0; };
// #endregion
// #region onActivateItemIntent -----------------------------------------------
/**
 * @protected
 * @param {UCF_Event} oEvent
 */
UCF_HierarchicalView_ItemManager["prototype"]["onActivateItemIntent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["onActivateItemIntent"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager_Item} */
	var oItem = oEvent["oGetParam"]('oItem');

	if (
		this["bIsItemRef"](oItem) &&
		!this["bHasState"](oItem, UCF_HierarchicalView_ItemManager["E_STATES"]["Disabled"]) &&
		!this["bHasState"](oItem, UCF_HierarchicalView_ItemManager["E_STATES"]["Readonly"])
	) {
		this["addState"](oItem, UCF_HierarchicalView_ItemManager["E_STATES"]["Active"]);
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["onActivateItemIntent"] = 0; };
// #endregion
// #region onDeactivateItemIntent ---------------------------------------------
/**
 * @protected
 * @param {UCF_Event} oEvent
 */
UCF_HierarchicalView_ItemManager["prototype"]["onDeactivateItemIntent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["onDeactivateItemIntent"]++; }; 
	this["removeState"](
		oEvent["oGetParam"]('oItem'),
		UCF_HierarchicalView_ItemManager["E_STATES"]["Active"]
	);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["onDeactivateItemIntent"] = 0; };
// #endregion
// #region onSegmentDidChange -------------------------------------------------
/**
 * @protected
 * @param {UCF_Event} oEvent
 */
UCF_HierarchicalView_ItemManager["prototype"]["onSegmentDidChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["onSegmentDidChange"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;
	/** @type {string} */
	var sSegmentId = oEvent["oGetParam"]('sSegmentId');

	this["oCache"]["get"]('sActiveSegment(' + sSegmentId + ')', function() {
		UCF_JsUtil["forEach"](
			self["aGetAllOfSegment"](sSegmentId),
			function(oItemRef) {
				/** @type {UCF_Control} */
				var oControl = self["oControl"]["oGetControlManager"]()["oGetControl"](oItemRef);

				if (
					(
						UCF_JsUtil["bInstanceOf"](oControl, 'UCF_Label') ||
						UCF_JsUtil["bInstanceOf"](oControl, 'UCF_TextView') ||
						UCF_JsUtil["bInstanceOf"](oControl, 'UCF_ToolbarLabel')
					) &&
					!oControl["bHasEventListeners"]('Activate') &&
					!oControl["bHasEventListeners"]('DoubleClick')
				) {
					self["addState"](
						self["oGetItemRefFromControl"](oControl),
						UCF_HierarchicalView_ItemManager["E_STATES"]["Readonly"]
					);

					self["removeState"](
						self["oGetItemRefFromControl"](oControl),
						UCF_HierarchicalView_ItemManager["E_STATES"]["Hoverable"]
					);
					self["removeState"](
						self["oGetItemRefFromControl"](oControl),
						UCF_HierarchicalView_ItemManager["E_STATES"]["IsActive"]
					);
				}
			}
		);
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["onSegmentDidChange"] = 0; };
// #endregino
// #endregion
// #region bIsItemRef ---------------------------------------------------------
/**
 * @protected
 * @param {HTMLElement} oRef
 * @return {boolean}
 */
UCF_HierarchicalView_ItemManager["prototype"]["bIsItemRef"] = function(oRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsItemRef"]++; }; 
	return oRef &&
		typeof oRef["id"] === 'string' &&
		this["oCache"]["get"]('bItemRef(' + oRef["id"] + ')', function() {
			return UCF_DomUtil["bHasClass"](oRef, 'lsHierarchicalview__item');
		});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsItemRef"] = 0; };
// #endregion
// #region bIsEnabledItemRef --------------------------------------------------
/**
 * @protected
 * @param {HTMLElement} oRef
 * @return {boolean}
 */
UCF_HierarchicalView_ItemManager["prototype"]["bIsEnabledItemRef"] = function(oRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsEnabledItemRef"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	return this["bIsItemRef"](oRef)
		&& this["oCache"]["get"]('bHasState(' + oRef["id"] + ',-1)', function() {
			return !self["bHasState"](
				oRef,
				UCF_HierarchicalView_ItemManager["E_STATES"]["Disabled"]
			);
		});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsEnabledItemRef"] = 0; };
// #endregion
// #region bIsFocusableItemRef ------------------------------------------------
/**
 * @protected
 * @param {HTMLElement} oRef
 * @return {boolean}
 */
UCF_HierarchicalView_ItemManager["prototype"]["bIsFocusableItemRef"] = function(oRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsFocusableItemRef"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	return this["bIsItemRef"](oRef)
		&& this["oCache"]["get"]('bHasState(' + oRef["id"] + ',-2)', function() {
			if (window["UCF_System"]["bIs508"] || window["UCF_System"]["sAccessibility"] === 'CLASSIC') {
				return true;
			} else if (window["UCF_System"]["bIsAria"]) {
				return !self["bHasState"](
					oRef,
					UCF_HierarchicalView_ItemManager["E_STATES"]["Disabled"]
				);
			} else {
				return !self["bHasState"](
					oRef,
					UCF_HierarchicalView_ItemManager["E_STATES"]["Disabled"]
				) && !self["bHasState"](
					oRef,
					UCF_HierarchicalView_ItemManager["E_STATES"]["Readonly"]
				);
			}
		});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsFocusableItemRef"] = 0; };
// #endregion
// #region bHasItemSegment ----------------------------------------------------
/**
 * @protected
 * @param {HTMLElement} oRef
 * @return {boolean}
 */
UCF_HierarchicalView_ItemManager["prototype"]["bIsItemRefWithSegment"] = function(oRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsItemRefWithSegment"]++; }; 
	return this["bHasState"](oRef, UCF_HierarchicalView_ItemManager["E_STATES"]["HasSegment"]);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsItemRefWithSegment"] = 0; };
// #endregion
// #region bIsContainerItemRef ------------------------------------------------
/**
 * @protected
 * @param {HTMLElement} oRef
 * @return {boolean}
 */
UCF_HierarchicalView_ItemManager["prototype"]["bIsContainerItemRef"] = function(oRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsContainerItemRef"]++; }; 
	return this["bHasState"](oRef, UCF_HierarchicalView_ItemManager["E_STATES"]["IsContainer"]);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsContainerItemRef"] = 0; };
// #endregion
// #region sGetSegmentIdFromItemRef -------------------------------------------
/**
 * @protected
 * @param {HTMLElement} oRef
 * @return {boolean}
 */
UCF_HierarchicalView_ItemManager["prototype"]["sGetSegmentIdFromItemRef"] = function(oRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["sGetSegmentIdFromItemRef"]++; }; 
	return this["bIsItemRef"](oRef)
		&& this["oCache"]["get"]('sSegmentIdFromItemRef(' + oRef["id"] + ')', function() {
			/** @type {UCF_HierarchicalView_SegmentManager_ItemsSegmentId} */
			var sItemsSegmentId = UCF_DomUtil["oGetParentByTagName"](oRef, 'DIV')["id"];

			return sItemsSegmentId["slice"](sItemsSegmentId["lastIndexOf"]('-') + 1);
		});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["sGetSegmentIdFromItemRef"] = 0; };
// #endregion
// #region sGetReferencedSegmentIdFromItemRef ---------------------------------
/**
 * @protected
 * @param {HTMLElement} oRef
 * @return {string}
 */
UCF_HierarchicalView_ItemManager["prototype"]["sGetReferencedSegmentIdFromItemRef"] = function(oRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["sGetReferencedSegmentIdFromItemRef"]++; }; 
	return oRef
		? (oRef["id"]
			? this["oCache"]["get"]('sReferencedSegmentIdFromItemRef(' + oRef["id"] + ')', function() {
				return UCF_DomUtil["dataset"](oRef)["segmentid"] || '';
			})
			: UCF_DomUtil["dataset"](oRef)["segmentid"])
		: '';
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["sGetReferencedSegmentIdFromItemRef"] = 0; };
// #endregion
// #region oGetItemRefFromControl ---------------------------------------------
/**
 * @private
 * @param {UCF_Control} oControl
 * @return {UCF_HierarchicalView_ItemManager_Item}
 */
UCF_HierarchicalView_ItemManager["prototype"]["oGetItemRefFromControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["oGetItemRefFromControl"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	return oControl
		&& typeof oControl["sId"] === 'string'
		&& this["oCache"]["get"]('oItemRefFromControl(' + oControl["sId"] + ')', function() {
			return UCF_DomUtil["$"](self["oControl"]["oLS"]["oGetRenderManager"]()["callFragment"](
				'HierarchicalViewItemGetFullId',
				'HierarchicalViewItem', {
					"Id": self["oControl"]["sId"],
					"ItemId": oControl["sId"]
				}));
		});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["oGetItemRefFromControl"] = 0; };
// #endregion
// #region sGetItemText -------------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_ItemManager_Item} oRef
 * @return {string}
 */
UCF_HierarchicalView_ItemManager["prototype"]["sGetItemText"] = function(oRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["sGetItemText"]++; }; 
	return this["bIsItemRef"](oRef)
		&& this["oCache"]["get"]('sItemText(' + oRef["id"] + ')', function() {
			return UCF_DomUtil["sGetInnerText"](UCF_DomUtil["querySelector"](
				'[id="' + oRef["id"] + '"] ' +
				'.lsHierarchicalview__itemtext'
			));
		});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["sGetItemText"] = 0; };
// #endregion
// #region bIsContainedControl ------------------------------------------------
/**
 * @protected
 * @param {UCF_Control} oControl
 * @return {boolean}
 */
UCF_HierarchicalView_ItemManager["prototype"]["bIsContainedControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsContainedControl"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	return oControl
		&& typeof oControl["sId"] === 'string'
		&& this["oCache"]["get"]('bContainedControl(' + oControl["sId"] + ')', function() {
			return self["bIsContainerItemRef"](self["oGetItemRefFromControl"](oControl));
		});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsContainedControl"] = 0; };
// #endregion
// #region oGetFirstOfActiveSegment -------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {UCF_HierarchicalView_ItemManager_Item}
 */
UCF_HierarchicalView_ItemManager["prototype"]["oGetFirstOfSegment"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["oGetFirstOfSegment"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	return this["oCache"]["get"]('oFirstOfSegment(' + sSegmentId + ')', function() {
		/** @type {UCF_HierarchicalView_ItemManager_Item[]} */
		var aAll = UCF_JsUtil["filter"](
			self["aGetAllOfSegment"](sSegmentId),
			function(oRef) {
				return !self["bHasState"](
					oRef,
					UCF_HierarchicalView_ItemManager["E_STATES"]["Disabled"]
				);
			}
		);

		return aAll["length"] > 0 && aAll[0];
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["oGetFirstOfSegment"] = 0; };
// #endregion
// #region aGetAllOfSegment ---------------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {NodeListOf<UCF_HierarchicalView_ItemManager_Item>}
 */
UCF_HierarchicalView_ItemManager["prototype"]["aGetAllOfSegment"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["aGetAllOfSegment"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	return this["oCache"]["get"]('aAllOfSegment(' + sSegmentId + ')', function() {
		return UCF_HierarchicalView_ItemManager["aGetAllOfSegmentStatic"](
			self["oControl"],
			sSegmentId
		);
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["aGetAllOfSegment"] = 0; };
// #region aGetAllOfSegmentStatic .............................................
/**
 * @protected
 * @static
 * @param {UCF_HierarchicalView} oControl
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {NodeListOf<UCF_HierarchicalView_ItemManager_Item>}
 */
UCF_HierarchicalView_ItemManager["aGetAllOfSegmentStatic"] = function(oControl, sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["aGetAllOfSegmentStatic"]++; }; 
	return UCF_JsUtil["arrayFrom"](UCF_DomUtil["querySelectorAll"](
		'[id="' + (UCF_ClassLoader["oGetClass"]('UCF_HierarchicalView_SegmentManager'))["sGetItemsSegmentIdStatic"](oControl, sSegmentId) + '"] ' +
		'.lsHierarchicalview__item'
	));
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["aGetAllOfSegmentStatic"] = 0; };
// #endregion
// #endregion
// #region oGetRelativeOfSegment ----------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @param {UCF_HierarchicalView_ItemManager_Item} oRef
 * @param {number} [iStep=0]
 * @return {UCF_HierarchicalView_ItemManager_Item}
 */
UCF_HierarchicalView_ItemManager["prototype"]["oGetRelativeOfSegment"] = function(sSegmentId, oRef, iStep) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["oGetRelativeOfSegment"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	return this["oCache"]["get"]('oRelativeOfSegment(' + sSegmentId + ',' + oRef["id"] + ',' + iStep + ')', function() {
		/** @type {NodeListOf<UCF_HierarchicalView_ItemManager_Item>} */
		var aAll = UCF_JsUtil["filter"](
			self["aGetAllOfSegment"](sSegmentId),
			function(oItem) {
				return oItem === oRef || self["bIsFocusableItemRef"](oItem);
			}
		);
		/** @type {number} */
		var iIndex = UCF_JsUtil["indexOf"](
			UCF_JsUtil["map"](aAll, function(o) { return o["id"]; }),
			oRef["id"]
		);

		return aAll["length"] > 0 && aAll[
			// 0 <= iIndex+iStep < aAll.length
			Math["min"](Math["max"]((iIndex || 0) + iStep, 0), aAll["length"] - 1)
		];
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["oGetRelativeOfSegment"] = 0; };
// #endregion
// #region oGetFocusedOfSegment -----------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {UCF_HierarchicalView_ItemManager_Item}
 */
UCF_HierarchicalView_ItemManager["prototype"]["oGetFocusedOfSegment"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["oGetFocusedOfSegment"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	return UCF_JsUtil["find"](
		this["aGetAllOfSegment"](sSegmentId),
		function(oRef) {
			return self["bHasState"](
				oRef,
				UCF_HierarchicalView_ItemManager["E_STATES"]["Focus"]
			);
		}
	);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["oGetFocusedOfSegment"] = 0; };
// #endregion
// #region oGetActiveOfSegment ------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {UCF_HierarchicalView_ItemManager_Item}
 */
UCF_HierarchicalView_ItemManager["prototype"]["oGetActiveOfSegment"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["oGetActiveOfSegment"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	return UCF_JsUtil["find"](
		this["aGetAllOfSegment"](sSegmentId),
		function(oRef) {
			return self["bHasState"](
				oRef,
				UCF_HierarchicalView_ItemManager["E_STATES"]["Active"]
			);
		}
	);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["oGetActiveOfSegment"] = 0; };
// #endregion
// #region focusItem ----------------------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_ItemManager_Item} oRef
 */
UCF_HierarchicalView_ItemManager["prototype"]["focusItem"] = function(oRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["focusItem"]++; }; 
	/** @type {string} */
	var sSegmentId;
	/** @type {UCF_HierarchicalView_ItemManager_Item} */
	var oFocusedItem;

	if (this["bIsFocusableItemRef"](oRef)) {
		sSegmentId = this["sGetSegmentIdFromItemRef"](oRef);
		oFocusedItem = this["oGetFocusedOfSegment"](sSegmentId);

		this["deactivateAllOfSegment"](sSegmentId);
		this["removeAllOfSegmentFromTabchain"](sSegmentId);
		this["addToTabchain"](sSegmentId, oRef);

		UCF_DomUtil["moveFocusDomElement"](oRef, true);

		this["fireFocusedItemDidChange"](oRef, oFocusedItem);
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["focusItem"] = 0; };
// #endregion
// #region focusControl -------------------------------------------------------
/**
 * @private
 * @param {UCF_Control} oControl
 */
UCF_HierarchicalView_ItemManager["prototype"]["focusControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["focusControl"]++; }; 
	/** @type {UCF_HierarchicalView_SegmentManager_SegmentId} */
	var sSegmentId;
	/** @type {UCF_HierarchicalView_ItemManager_Item} */
	var oItemRef;

	if (oControl) {
		oItemRef = this["oGetItemRefFromControl"](oControl);

		if (this["bIsFocusableItemRef"](oItemRef)) {
			sSegmentId = this["sGetSegmentIdFromItemRef"](oItemRef);

			this["deactivateAllOfSegment"](sSegmentId);
			this["removeAllOfSegmentFromTabchain"](sSegmentId);
			this["addToTabchain"](sSegmentId, oItemRef);

			oControl["focus"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["focusControl"] = 0; };
// #endregion
// #region addToTabchain ------------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @param {UCF_HierarchicalView_ItemManager_Item} oRef
 */
UCF_HierarchicalView_ItemManager["prototype"]["addToTabchain"] = function(sSegmentId, oRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["addToTabchain"]++; }; 
	if (this["bIsFocusableItemRef"](oRef)) {
		this["addState"](oRef, UCF_HierarchicalView_ItemManager["E_STATES"]["Focus"]);

		if (this["bIsContainerItemRef"](oRef)) {
			this["addState"](
				this["oGetRelativeOfSegment"](sSegmentId, oRef, 1),
				UCF_HierarchicalView_ItemManager["E_STATES"]["Focus"]
			);

			UCF_JsUtil["forEach"](
				UCF_DomUtil["querySelectorAll"](
					'[id="' + oRef["id"] + '"] [data-hierarchicalview-tabindex]'
				),
				function(oR) {
					oR["removeAttribute"]('data-hierarchicalview-tabindex');
					UCF_DomUtil["setTabIndex"](oR, 0);
				}
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["addToTabchain"] = 0; };
// #endregion
// #region removeAllOfSegmentFromTabchain -------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 */
UCF_HierarchicalView_ItemManager["prototype"]["removeAllOfSegmentFromTabchain"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["removeAllOfSegmentFromTabchain"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	UCF_JsUtil["forEach"](
		UCF_DomUtil["querySelectorAll"](
			'[id="' + (UCF_ClassLoader["oGetClass"]('UCF_HierarchicalView_SegmentManager'))["sGetItemsSegmentIdStatic"](this["oControl"], sSegmentId) + '"] ' +
			'[tabindex="0"]'
		),
		function(oRef) {
			if (self["bIsItemRef"](oRef)) {
				self["removeState"](oRef, UCF_HierarchicalView_ItemManager["E_STATES"]["Focus"]);
			} else {
				UCF_DomUtil["setTabIndex"](oRef, -1);
				oRef["setAttribute"]('data-hierarchicalview-tabindex', '0');
			}
		}
	);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["removeAllOfSegmentFromTabchain"] = 0; };
// #endregion
// #region deactivateAllOfSegment ---------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 */
UCF_HierarchicalView_ItemManager["prototype"]["deactivateAllOfSegment"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["deactivateAllOfSegment"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	UCF_JsUtil["forEach"](
		this["aGetAllOfSegment"](sSegmentId),
		function(oRef) {
			self["removeState"](oRef, UCF_HierarchicalView_ItemManager["E_STATES"]["Active"]);
		}
	);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["deactivateAllOfSegment"] = 0; };
// #endregion
// #region state handling =====================================================
// #region addState -----------------------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_ItemManager_Item} oItem
 * @param {UCF_HierarchicalView_ItemManager_State} eState
 */
UCF_HierarchicalView_ItemManager["prototype"]["addState"] = function(oItem, eState) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["addState"]++; }; 
	if (this["bIsItemRef"](oItem)) {
		if (eState in UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"]) {
			UCF_DomUtil["addClass"](
				oItem,
				UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"][eState]
			);
		} else {
			switch (eState) {
				case UCF_HierarchicalView_ItemManager["E_STATES"]["Focus"]:
					UCF_DomUtil["setTabIndex"](oItem, 0);
					break;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["addState"] = 0; };
// #endregion
// #region removeState --------------------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_ItemManager_Item} oItem
 * @param {UCF_HierarchicalView_ItemManager_State} eState
 */
UCF_HierarchicalView_ItemManager["prototype"]["removeState"] = function(oItem, eState) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["removeState"]++; }; 
	if (this["bIsItemRef"](oItem)) {
		if (eState in UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"]) {
			UCF_DomUtil["removeClass"](
				oItem,
				UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"][eState]
			);
		} else {
			switch (eState) {
				case UCF_HierarchicalView_ItemManager["E_STATES"]["Focus"]:
					UCF_DomUtil["setTabIndex"](oItem, -1);
					break;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["removeState"] = 0; };
// #endregion
// #region bHasState ----------------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_ItemManager_Item} oItem
 * @param {UCF_HierarchicalView_ItemManager_State} eState
 * @return {boolean}
 */
UCF_HierarchicalView_ItemManager["prototype"]["bHasState"] = function(oItem, eState) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bHasState"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var self = this;

	if (this["bIsItemRef"](oItem)) {
		if (UCF_HierarchicalView_ItemManager["bIsCacheableState"](eState)) {
			return this["oCache"]["get"](
				'bHasState(' + oItem["id"] + ',' + eState + ')',
				function() { return self["_bHasState"](oItem, eState); }
			);
		} else {
			return this["_bHasState"](oItem, eState);
		}
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bHasState"] = 0; };

/**
 * @private
 * @static
 * @param {UCF_HierarchicalView_ItemManager_State} eState
 * @return {boolean}
 */
UCF_HierarchicalView_ItemManager["bIsCacheableState"] = function(eState) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsCacheableState"]++; }; 
	return eState === UCF_HierarchicalView_ItemManager["E_STATES"]["Disabled"]
		|| eState === UCF_HierarchicalView_ItemManager["E_STATES"]["Readonly"]
		|| eState === UCF_HierarchicalView_ItemManager["E_STATES"]["HasSegment"]
		|| eState === UCF_HierarchicalView_ItemManager["E_STATES"]["IsContainer"];
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["bIsCacheableState"] = 0; };

/**
 * @private
 * @param {UCF_HierarchicalView_ItemManager_Item} oItem
 * @param {UCF_HierarchicalView_ItemManager_State} eState
 * @return {boolean}
 */
UCF_HierarchicalView_ItemManager["prototype"]["_bHasState"] = function(oItem, eState) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["_bHasState"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["bIsItemRef"](oItem), "this.bIsItemRef(oItem)", "HierarchicalView_ItemManager.js(733): _bHasState"); };

	if (eState in UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"]) {
		return UCF_DomUtil["bHasClass"](
			oItem,
			UCF_HierarchicalView_ItemManager["E_STATE_CLASSES"][eState]
		);
	} else {
		switch (eState) {
			case UCF_HierarchicalView_ItemManager["E_STATES"]["Focus"]:
				return UCF_DomUtil["bHasTabIndex"](oItem);
			default:
				return false;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["_bHasState"] = 0; };
// #endregion
// #endregion
// #region event emitters =====================================================
// #region fireFocusedItemDidChange -------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_ItemManager_Item} oItem
 * @param {UCF_HierarchicalView_ItemManager_Item} oOldItem
 */
UCF_HierarchicalView_ItemManager["prototype"]["fireFocusedItemDidChange"] = function(oItem, oOldItem) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["fireFocusedItemDidChange"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["FocusedItemDidChange"], {
		"oItem": oItem,
		"oOldItem": oOldItem
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_ItemManager["_"]["fireFocusedItemDidChange"] = 0; };
// #endregion
// #endregion

};
sap["ls"]["preload"]["UCF_HierarchicalView_RenderInfoBuilder"] = function() {/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>

/**
 * @typedef {Object} UCF_HierarchicalView_PopupMenuRenderInfo
 * @property {'PopupMenu'} _sControlClassName
 * @property {{Position: number, length: number, [x: number]: UCF_HierarchicalView_PopupMenuItemRenderInfo}} Items
 */
/**
 * @typedef {Object} UCF_HierarchicalView_PopupMenuItemRenderInfo
 * @property {'PopupMenuItem'} _sControlClassName
 * @property {string} Id
 * @property {string} Text
 * @property {boolean} Enabled
 * @property {boolean} HasSubMenu
 * @property {boolean} HasSeparator
 * @property {string} SubMenuId
 * @property {string} Hotkey
 * @property {boolean} Checked
 * @property {boolean} CanCheck
 */
/**
 * @typedef {Object} UCF_HierarchicalView_ButtonRenderInfo
 * @property {'Button'} _sControlClassName
 * @property {string} Id
 * @property {string} Text
 * @property {boolean} Enabled
 * @property {boolean} HasPopupMenu
 * @property {string} PopupMenuId
 * @property {string} Hotkey
 * @property {boolean} HasIcon
 * @property {string} UpIconSrc
 * @property {string} DownIconSrc
 * @property {string} DisabledIconSrc
 */
/**
 * @typedef {Object} UCF_HierarchicalView_ToolbarButtonRenderInfo
 * @property {'ToolbarButton'} _sControlClassName
 * @property {string} Id
 * @property {string} Text
 * @property {boolean} Enabled
 * @property {boolean} HasPopupMenu
 * @property {string} PopupMenuId
 * @property {string} Hotkey
 * @property {boolean} HasIcon
 * @property {string} UpIconSrc
 * @property {string} DownIconSrc
 * @property {string} DisabledIconSrc
 */
/** @typedef {UCF_HierarchicalView_PopupMenuRenderInfo|UCF_HierarchicalView_PopupMenuItemRenderInfo|UCF_HierarchicalView_ButtonRenderInfo|UCF_HierarchicalView_ToolbarButtonRenderInfo} UCF_HierarchicalView_RenderInfo */

/**
 * @class
 * @extends UCF_Object
 * @param {UCF_LS} oLS
 */
function UCF_HierarchicalView_RenderInfoBuilder(oLS) {if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["UCF_HierarchicalView_RenderInfoBuilder"]++; }; 
	if (arguments["length"] > 0) {
		this["oLS"] = oLS;
	}
};window["UCF_HierarchicalView_RenderInfoBuilder"] = UCF_HierarchicalView_RenderInfoBuilder; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HierarchicalView_RenderInfoBuilder"); UCF_HierarchicalView_RenderInfoBuilder["_"] = {UCF_HierarchicalView_RenderInfoBuilder: 0}; }; 
UCF_HierarchicalView_RenderInfoBuilder["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_HierarchicalView_RenderInfoBuilder.prototype["sClassName"] = "UCF_HierarchicalView_RenderInfoBuilder";
// #region destroy ------------------------------------------------------------
/** @override */
UCF_HierarchicalView_RenderInfoBuilder["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["destroy"]++; }; 

	this["oLS"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["destroy"] = 0; };
// #endregion
// #region oFromId ------------------------------------------------------------
/**
 * @protected
 * @param {string} sId
 * @return {UCF_HierarchicalView_RenderInfo}
 */
UCF_HierarchicalView_RenderInfoBuilder["prototype"]["oFromId"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["oFromId"]++; }; 
	/** @type {UCF_Control} */
	var oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sId);

	if (oControl) {
		if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_PopupMenu')) {
			return this["oFromPopupMenu"](oControl);
		} else if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_PopupMenuItem')) {
			return this["oFromPopupMenuItem"](oControl);
		} else if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_Button')) {
			return this["oFromButton"](oControl);
		} else if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_ToolbarButton')) {
			return this["oFromToolbarButton"](oControl);
		} {
			return null;
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["oFromId"] = 0; };
// #endregion
// #region oFromPopupMenu -----------------------------------------------------
/**
 * @private
 * @param {UCF_PopupMenu} oPopupMenu
 * @return {UCF_HierarchicalView_PopupMenuRenderInfo}
 */
UCF_HierarchicalView_RenderInfoBuilder["prototype"]["oFromPopupMenu"] = function(oPopupMenu) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["oFromPopupMenu"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;
	/** @type {UCF_PopupMenuItem[]} */
	var aItems = oPopupMenu["aGetItems"]() || [];

	return {
		"_sControlClassName": 'PopupMenu',
		"Items": UCF_JsUtil["reduce"](aItems, function(oItems, oItem, i) {
			oItems[i] = self["oFromPopupMenuItem"](oItem);

			return oItems;
		}, { "Position": 0, "length": aItems["length"] })
	};
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["oFromPopupMenu"] = 0; };
// #endregion
// #region oFromPopupMenuItem -------------------------------------------------
/**
 * @private
 * @param {UCF_PopupMenuItem} oPopupMenuItem
 * @return {UCF_HierarchicalView_PopupMenuItemRenderInfo}
 */
UCF_HierarchicalView_RenderInfoBuilder["prototype"]["oFromPopupMenuItem"] = function(oPopupMenuItem) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["oFromPopupMenuItem"]++; }; 
	return {
		"_sControlClassName": 'PopupMenuItem',
		"Id": oPopupMenuItem["sId"],
		"Enabled": oPopupMenuItem["bEnabled"],
		"HasSubMenu": oPopupMenuItem["bHasSubMenu"],
		"SubMenuId": oPopupMenuItem["sSubMenuId"],
		"Text": oPopupMenuItem["sText"],
		"Hotkey": oPopupMenuItem["sHotkey"],
		"HasSeparator": oPopupMenuItem["bHasSeparator"],
		"Checked": oPopupMenuItem["bChecked"],
		"CanCheck": oPopupMenuItem["bCanCheck"]
	};
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["oFromPopupMenuItem"] = 0; };
// #endregion
// #region oFromButton --------------------------------------------------------
/**
 * @private
 * @param {UCF_Button} oButton
 * @return {UCF_HierarchicalView_ButtonRenderInfo}
 */
UCF_HierarchicalView_RenderInfoBuilder["prototype"]["oFromButton"] = function(oButton) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["oFromButton"]++; }; 
	return {
		"_sControlClassName": 'Button',
		"Id": oButton["sId"],
		"Enabled": oButton["bEnabled"],
		"HasPopupMenu": oButton["bHasPopupMenu"],
		"PopupMenuId": oButton["sPopupMenuId"],
		"Text": oButton["sText"],
		"Hotkey": oButton["sHotkey"],
		"HasIcon": oButton["bHasIcon"],
		"UpIconSrc": oButton["sUpIconSrc"],
		"DownIconSrc": oButton["sDownIconSrc"],
		"DisabledIconSrc": oButton["sDisabledIconSrc"]
	};
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["oFromButton"] = 0; };
// #endregion
// #region oFromToolbarButton -------------------------------------------------
/**
 * @private
 * @param {UCF_ToolbarButton} oToolbarButton
 * @return {UCF_HierarchicalView_ToolbarButtonRenderInfo}
 */
UCF_HierarchicalView_RenderInfoBuilder["prototype"]["oFromToolbarButton"] = function(oToolbarButton) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["oFromToolbarButton"]++; }; 
	return {
		"_sControlClassName": 'ToolbarButton',
		"Id": oToolbarButton["sId"],
		"Enabled": oToolbarButton["bEnabled"],
		"HasPopupMenu": oToolbarButton["bHasPopupMenu"],
		"PopupMenuId": oToolbarButton["sPopupMenuId"],
		"Text": oToolbarButton["sText"],
		"Hotkey": oToolbarButton["sHotkey"],
		"HasIcon": oToolbarButton["bHasIcon"],
		"UpIconSrc": oToolbarButton["sUpIconSrc"],
		"DownIconSrc": oToolbarButton["sDownIconSrc"],
		"DisabledIconSrc": oToolbarButton["sDisabledIconSrc"]
	};
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_RenderInfoBuilder["_"]["oFromToolbarButton"] = 0; };
// #endregion

};
sap["ls"]["preload"]["UCF_HierarchicalView_SegmentManager"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_EventProvider */
/// <reference path="../../core/EventProvider.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_HierarchicalView_ControlManager */
/// <reference path="./HierarchicalView_ControlManager.js"/>
/* global UCF_HierarchicalView_ItemManager */
/// <reference path="./HierarchicalView_ItemManager.js"/>
/* global UCF_HierarchicalView_RenderInfoBuilder */
/// <reference path="./HierarchicalView_RenderInfoBuilder.js"/>

// #region typedefs ===========================================================
/**
 * A single segment/page of the hierarchy. E.g. consider the following:
 *
 * ```
 * - 1st level 1:
 *   - 2nd level 1
 *   - 2nd level 2
 *   - 2nd level 3
 * - 1st level 2
 * - 1st level 3:
 *   - 2nd level 4
 *   - 2nd level 5
 *   - 2nd level 6
 * ```
 *
 * These are 3 segments:
 * - the implicit top level segment, containing "1st level 1..3"
 * - the "1st level 1" segment, containing "2nd level 1..3"
 * - the "1st level 3" segment, containing "2nd level 4..6"
 *
 * @typedef {Object} UCF_HierarchicalView_SegmentManager_Segment
 * @property {string} sName
 * @property {UCF_HierarchicalView_SegmentManager_SegmentId} [sSegmentId] i.e. `<segmentid>`
 * @property {string} [sId] i.e. `<controlid>-itemssegment-<segmentid>`
 * @property {string|HTMLElement} [oRef]
 * @property {UCF_Control[]} [aControls]
 */
/**
 * @typedef {string} UCF_HierarchicalView_SegmentManager_SegmentId i.e.
 * `<segmentid>` in `<controlid>-itemssegment-<segmentid>`
 */
/**
 * @typedef {string} UCF_HierarchicalView_SegmentManager_ItemsSegmentId i.e.
 * `<controlid>-itemssegment-<segmentid>`
 */
/**
 * @typedef {Object} UCF_HierarchicalView_SegmentManager_ShowSegmentStringOptions
 * @property {string} sSegmentId
 */
/**
 * @typedef {Object} UCF_HierarchicalView_SegmentManager_ShowSegmentItemOptions
 * @property {UCF_HierarchicalView_ItemManager_Item} oItem
 */
/** @typedef {UCF_HierarchicalView_SegmentManager_ShowSegmentStringOptions|UCF_HierarchicalView_SegmentManager_ShowSegmentItemOptions} UCF_HierarchicalView_SegmentManager_ShowSegmentOptions */
// #endregion

/**
 * @class
 * @extends UCF_EventProvider
 * @depends UCF_HierarchicalView_RenderInfoBuilder
 * @param {UCF_HierarchicalView} oControl
 */
function UCF_HierarchicalView_SegmentManager(oControl) {if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["UCF_HierarchicalView_SegmentManager"]++; }; 
	/** @type {HTMLDivElement} */
	var oNavigationTitleRef;

	if (arguments["length"] > 0) {
		UCF_EventProvider["apply"](this, []);

		this["defineEvents"](['SegmentWillChange', 'SegmentDidChange']);

		/** @type {UCF_HierarchicalView} */
		this["oControl"] = oControl;

		/** @type {UCF_LS} */
		this["oLS"] = this["oControl"]["oLS"];

		/** @type {string} */
		this["sId"] = this["oControl"]["sId"];

		/** @type {UCF_HierarchicalView_SegmentManager_SegmentId} */
		this["sSegmentId"] = this["oControl"]["sSegmentId"]; // eslint-disable-line @ur/no-missing-setClientProperty

		/** @type {UCF_HierarchicalView_RenderInfoBuilder} */
		this["oRenderInfoBuilder"] = new (UCF_ClassLoader["oGetClass"]("UCF_HierarchicalView_RenderInfoBuilder"))(this["oLS"]);

		/** @type {UCF_HierarchicalView_SegmentManager_SegmentId[]} */
		this["aBreadCrumb"] = [this["sSegmentId"]];

		/** @type {Object<string, UCF_HierarchicalView_SegmentManager_Segment>} */
		this["oSegments"] = {};

		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

		oNavigationTitleRef = UCF_DomUtil["$"](this["sId"] + '-navigationtitle');
		this["manageSegment"]({
			"sName": oNavigationTitleRef
				? UCF_DomUtil["sGetInnerText"](oNavigationTitleRef)
				: '',
			"sSegmentId": this["sSegmentId"]
		});
		this["createSegmentUcfControls"](this["sSegmentId"]);
		this["addAriaToSegment"](this["sSegmentId"]);
	}
};window["UCF_HierarchicalView_SegmentManager"] = UCF_HierarchicalView_SegmentManager; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HierarchicalView_SegmentManager"); UCF_HierarchicalView_SegmentManager["_"] = {UCF_HierarchicalView_SegmentManager: 0}; }; ;
UCF_HierarchicalView_SegmentManager["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_HierarchicalView_SegmentManager.prototype["sClassName"] = "UCF_HierarchicalView_SegmentManager";

// #region Lifecycle ==========================================================
// #region destroy ------------------------------------------------------------
/** @override */
UCF_HierarchicalView_SegmentManager["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["destroy"]++; }; 
	this["oCache"]["destroy"]();
	this["oCache"] = null;

	this["oRenderInfoBuilder"]["destroy"]();
	this["oRenderInfoBuilder"] = null;

	this["aBreadCrumb"] = null;
	this["oSegments"] = null;
	this["sSegmentId"] = null;
	this["oControl"] = null;
	this["oLS"] = null;
	this["sId"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["destroy"] = 0; };
// #endregion
// #endregion
// #region Segment management =================================================
// #region manageSegment ------------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_Segment} oSegment
 * @return {void}
 */
UCF_HierarchicalView_SegmentManager["prototype"]["manageSegment"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["manageSegment"]++; }; 
	/** @type {UCF_Hierarchicalview_SegmentManager_ItemsSegmentId} */
	var sId = oSegment["sId"] || this["sGetItemsSegmentId"](oSegment["sSegmentId"]);

	UCF_JsUtil["forEach"](
		UCF_DomUtil["querySelectorAll"](
			'[id="' + this["sGetSegmentControlsId"](oSegment["sSegmentId"]) + '"] ' +
			'[tabindex="0"]'
		),
		function(oControlRef) {
			UCF_DomUtil["setTabIndex"](oControlRef, -1);
		}
	);

	this["oSegments"][oSegment["sSegmentId"]] = {
		"sName": UCF_StringUtil["sTrim"](oSegment["sName"]),
		"sId": sId,
		"oRef": oSegment["oRef"] || UCF_DomUtil["$"](sId)
	};
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["manageSegment"] = 0; };
// #endregion
// #region addAriaToSegment ---------------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 */
UCF_HierarchicalView_SegmentManager["prototype"]["addAriaToSegment"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["addAriaToSegment"]++; }; 
	/** @type {UCF_HierarchicalView_SegmentManager} */
	var self;

	if (window["UCF_System"]["bIsAria"]) {
		self = this;

		UCF_JsUtil["forEach"](
			UCF_DomUtil["querySelectorAll"](
				'[id="' + this["oControl"]["sId"] + '-itemssegment-' + sSegmentId + '"] ' +
				'[role="listitem"]'
			),
			function(oTr, iIndex, aTrs) {
				UCF_AriaStateHelper["setPosinset"](oTr, iIndex + 1);
				UCF_AriaStateHelper["setSetsize"](oTr, aTrs["length"]);
				UCF_AriaStateHelper["setAttribute"](oTr, 'aria-level', self["aBreadCrumb"]["length"]);
			}
		);
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["addAriaToSegment"] = 0; };
// #endregion
// #region addSegment ---------------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_Segment} oSegment
 */
UCF_HierarchicalView_SegmentManager["prototype"]["addSegment"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["addSegment"]++; }; 
	this["manageSegment"](oSegment);
	this["renderSegmentContent"](oSegment["sSegmentId"]);
	this["createSegmentUcfControls"](oSegment["sSegmentId"]);
	this["addAriaToSegment"](oSegment["sSegmentId"]);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["addSegment"] = 0; };
// #endregion
// #region renderSegmentContent -----------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 */
UCF_HierarchicalView_SegmentManager["prototype"]["renderSegmentContent"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["renderSegmentContent"]++; }; 
	/** @type {UCF_HierarchicalView_SegmentManager_Segment} */
	var oSegment = this["oSegments"][sSegmentId];
	/** @type {HTMLDivElement} */
	var oSegmentRef = UCF_DomUtil["$"](oSegment["sId"]);
	/** @type {HTMLDivElement} */
	var oTmpRef = document["createElement"]('div');

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sSegmentId === 'string', "typeof sSegmentId === 'string'", "HierarchicalView_SegmentManager.js(223): renderSegmentContent"); };

	if (oSegmentRef) {
		UCF_DomUtil["removeFromDom"](oSegmentRef);
	}

	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oTmpRef, this["oLS"]["oGetRenderManager"]()["callFragment"](
		'HierarchicalViewItemsSegmentFragment',
		'HierarchicalView', {
			"Id": this["sId"],
			"SegmentId": sSegmentId,
			"Items": [this["oRenderInfoBuilder"]["oFromId"](sSegmentId)],
			"IsActive": false,
			"Navigation": this["oControl"]["sGetNavigation"]()
		}
	));
	UCF_DomUtil["append"](this["oGetItemsRef"](), oTmpRef["firstChild"]);

	oSegment["oRef"] = UCF_DomUtil["$"](oSegment["sId"]);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["renderSegmentContent"] = 0; };
// #endregion
// #region createSegmentUcfControls -------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 */
UCF_HierarchicalView_SegmentManager["prototype"]["createSegmentUcfControls"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["createSegmentUcfControls"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;

	// step 1: create UCF controls for all children of -itemssegmentcontrols-
	UCF_JsUtil["forEach"](
		UCF_DomUtil["childNodes"](UCF_DomUtil["$"](this["sGetSegmentControlsId"](sSegmentId))),
		function(oRef) {
			// might be an $Id-r with a <xmp> in it (PopupMenu)
			return self["oLS"]["oControlFactory"]["oGetControlById"](oRef["id"]["replace"](/-.*$/, ''));
		}
	);

	// step 2: store UCF controls for all items
	this["oSegments"][sSegmentId]["aControls"] = UCF_JsUtil["map"](
		UCF_HierarchicalView_ItemManager["aGetAllOfSegmentStatic"](this["oControl"], sSegmentId),
		function(oItemRef) {
			return UCF_HierarchicalView_ControlManager["oGetControlStatic"](
				self["oControl"],
				oItemRef
			);
		}
	);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["createSegmentUcfControls"] = 0; };
// #endregion
// #region aGetControlsOfSegment ----------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {UCF_Control[]}
 */
UCF_HierarchicalView_SegmentManager["prototype"]["aGetControlsOfSegment"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["aGetControlsOfSegment"]++; }; 
	return (
		this["oSegments"] &&
		this["oSegments"][sSegmentId] &&
		this["oSegments"][sSegmentId]["aControls"]
	) || [];
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["aGetControlsOfSegment"] = 0; };
// #endregion
// #region iGetItemCountOfSegment ---------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {number}
 */
UCF_HierarchicalView_SegmentManager["prototype"]["iGetItemCountOfSegment"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["iGetItemCountOfSegment"]++; }; 
	/** @type {UCF_HierarchicalView_SegmentManager} */
	var self = this;

	return this["oCache"]["get"]('iItemCountOfSegment-' + sSegmentId, function() {
		return self["aGetControlsOfSegment"](sSegmentId)["length"];
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["iGetItemCountOfSegment"] = 0; };
// #endregion
// #region iGetItemIndexOfSegment ---------------------------------------------
/**
 * @protected
 * @param {string} sId
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {number}
 */
UCF_HierarchicalView_SegmentManager["prototype"]["iGetItemIndexOfSegment"] = function(sId, sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["iGetItemIndexOfSegment"]++; }; 
	/** @type {UCF_HierarchicalView_SegmentManager} */
	var self = this;

	return this["oCache"]["get"]('iItemIndexOfSegment-' + sId + '-' + sSegmentId, function() {
		return UCF_JsUtil["indexOf"](
			UCF_JsUtil["map"](self["aGetControlsOfSegment"](sSegmentId), function(oControl) {
				return oControl["sId"];
			}),
			sId
		);
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["iGetItemIndexOfSegment"] = 0; };
// #endregion
// #region iGetLevelOfSegment -------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {number}
 */
UCF_HierarchicalView_SegmentManager["prototype"]["iGetLevelOfSegment"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["iGetLevelOfSegment"]++; }; 
	/** @type {UCF_HierarchicalView_SegmentManager_SegmentId} */
	var self = this;

	// need to include the breadcrumb in the cache key to allow same segment in
	// multiple items
	return this["oCache"]["get"]('iLevelOfSegment-[' + this["aBreadCrumb"]["join"](',') + ']-' + sSegmentId, function() {
		/** @type {number} */
		var iIndex = UCF_JsUtil["indexOf"](self["aBreadCrumb"], sSegmentId);

		return (iIndex > -1) ? iIndex + 1 : -1;
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["iGetLevelOfSegment"] = 0; };
// #endregion
/**
 * @private
 * @param {UCF_HierarchicalView_SegmentManager_ShowSegmentOptions} oOptions
 * @return {UCF_HierarchicalView_SegmentManager_Segment}
 */
UCF_HierarchicalView_SegmentManager["prototype"]["oResolveSegmentOptions"] = function(oOptions) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["oResolveSegmentOptions"]++; }; 
	/** @type {UCF_HierarchicalView_ItemManager} */
	var oItemManager;

	if (typeof oOptions["sSegmentId"] === 'string') {
		return {
			"sSegmentId": oOptions["sSegmentId"],
			"sName": this["sGetSegmentName"](oOptions["sSegmentId"])
		};
	} else if (oOptions["oItem"]) {
		oItemManager = this["oControl"]["oGetItemManager"]();

		return {
			"sSegmentId": oItemManager["sGetReferencedSegmentIdFromItemRef"](oOptions["oItem"]),
			"sName": oItemManager["sGetItemText"](oOptions["oItem"])
		};
	} else {
		throw new Error('Neither sSegmentId nor oItem provided. [at UCF_HierarchicalView_SegmentManager<' + this["oControl"]["sId"] + '>#showSegment()]');
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["oResolveSegmentOptions"] = 0; };
// #region showSegment --------------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_ShowSegmentOptions} oOptions
 */
UCF_HierarchicalView_SegmentManager["prototype"]["showSegment"] = function(oOptions) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["showSegment"]++; }; 
	/** @type {UCF_HierarchicalView_SegmentManager_Segment} */
	var oSegment = this["oResolveSegmentOptions"](oOptions);
	/** @type {UCF_HierarchicalView_SegmentManager_SegmentId} */
	var sSegmentId = oSegment["sSegmentId"];
	/** @type {number} */
	var iSegmentIndex;
	/** @type {string} */
	var sOldSegmentId;

	if (!(sSegmentId in this["oSegments"])) {
		this["addSegment"](oSegment);
	}

	sOldSegmentId = this["sGetActiveSegmentId"]();

	this["fireSegmentWillChange"](sSegmentId, sOldSegmentId);

	if (typeof oSegment["sName"] === 'string') {
		this["oSegments"][sSegmentId]["sName"] = UCF_StringUtil["sTrim"](oSegment["sName"]);
	}
	iSegmentIndex = UCF_JsUtil["indexOf"](this["aBreadCrumb"], sSegmentId);
	if (iSegmentIndex > -1) {
		this["aBreadCrumb"]["splice"](
			iSegmentIndex,
			this["aBreadCrumb"]["length"] - iSegmentIndex
		);
	}

	this["showSegmentContent"](sSegmentId);

	if (this["oControl"]["sGetNavigation"]() !== 'NONE') {
		this["renderNavigation"](sSegmentId);
	}

	this["aBreadCrumb"]["push"](sSegmentId);

	UCF_JsUtil["delayedCall"](
		// eslint-disable-next-line no-magic-numbers
		this["fGetTransitionDuration"]() * 1000,
		this,
		'fireSegmentDidChange',
		[sSegmentId, sOldSegmentId]
	);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["showSegment"] = 0; };
// #endregion
// #region

// #endregion
// #region onNavigationIntent -------------------------------------------------
/**
 * @protected
 * @param {UCF_Event<UCF_HierarchicalView_SegmentManager_ShowSegmentOptions>} oEvent
 */
UCF_HierarchicalView_SegmentManager["prototype"]["onNavigationIntent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["onNavigationIntent"]++; }; 
	this["showSegment"](oEvent["mGetParameters"]());
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["onNavigationIntent"] = 0; };
// #endregion
// #region onManageSegmentIntent ----------------------------------------------
/**
 * @protected
 * @param {UCF_Event<UCF_HierarchicalView_SegmentManager_ShowSegmentOptions>} oEvent
 */
UCF_HierarchicalView_SegmentManager["prototype"]["onManageSegmentIntent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["onManageSegmentIntent"]++; }; 
	/** @type {UCF_HierarchicalView_SegmentManager_Segment} */
	var oSegment = this["oResolveSegmentOptions"](oEvent["mGetParameters"]());

	if (
		!(oSegment["sId"] in this["oSegments"]) &&
		typeof oSegment["sSegmentId"] === 'string'
	) {
		this["addSegment"](oSegment);
	}
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["onManageSegmentIntent"] = 0; };
// #endregion
// #region sGetActiveSegmentId ------------------------------------------------
/**
 * @protected
 * @return {string}
 */
UCF_HierarchicalView_SegmentManager["prototype"]["sGetActiveSegmentId"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetActiveSegmentId"]++; }; 
	return this["aBreadCrumb"][this["aBreadCrumb"]["length"] - 1];
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetActiveSegmentId"] = 0; };
// #endregion
// #region sGetActiveParentSegmentId ------------------------------------------
/**
 * @protected
 * @return {string}
 */
UCF_HierarchicalView_SegmentManager["prototype"]["sGetActiveParentSegmentId"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetActiveParentSegmentId"]++; }; 
	return this["aBreadCrumb"]["length"] > 1
		// eslint-disable-next-line no-magic-numbers
		&& this["aBreadCrumb"][this["aBreadCrumb"]["length"] - 2];
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetActiveParentSegmentId"] = 0; };
// #endregion
// #region showSegmentContent -------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 */
UCF_HierarchicalView_SegmentManager["prototype"]["showSegmentContent"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["showSegmentContent"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;

	// need delayedCall to execute after animation frame
	UCF_JsUtil["delayedCall"](0, {
		"s": function() {
			/** @type {string} */
			var sId = self["oSegments"][sSegmentId]["sId"];
			/** @type {HTMLDivElement} */
			var oSegmentRef = UCF_DomUtil["$"](sId);

			UCF_DomUtil["addClass"](oSegmentRef, 'lsHierarchicalview__itemssegment--active');

			if (window["UCF_System"]["bIsAria"]) {
				UCF_JsUtil["forEach"](
					UCF_DomUtil["querySelectorAll"](
						'[id="' + self["sGetItemsSegmentId"](sSegmentId) + '"] ' +
						'[role="listitem"]'
					),
					function(oTr) {
						UCF_AriaStateHelper["setAttribute"](oTr, 'aria-level', self["aBreadCrumb"]["length"]);
					}
				);
			}

			UCF_JsUtil["forEach"](
				UCF_DomUtil["childNodes"](self["oGetItemsRef"]()),
				function(oItemsSegmentRef) {
					if (oItemsSegmentRef !== oSegmentRef) {
						UCF_DomUtil["removeClass"](
							oItemsSegmentRef,
							'lsHierarchicalview__itemssegment--active'
						);
					}
				}
			);
		}
	}, 's');
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["showSegmentContent"] = 0; };
// #endregion
// #region renderNavigation ---------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {void}
 */
UCF_HierarchicalView_SegmentManager["prototype"]["renderNavigation"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["renderNavigation"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;
	/** @type {UCF_RenderManager} */
	var oRenderManager = this["oLS"]["oGetRenderManager"]();
	/** @type {string} */
	var sName = this["sGetSegmentName"](sSegmentId);
	/** @type {UCF_HierarchicalView_Navigation} */
	var sNavigation = this["oControl"]["sGetNavigation"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNavigation !== 'NONE', "sNavigation !== 'NONE'", "HierarchicalView_SegmentManager.js(532): renderNavigation"); };

	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["$"](this["sId"] + '-navigationitems')["outerHTML"] = this["oLS"]["oGetRenderManager"]()["callFragment"](
		'HierarchicalViewNavigationItemsFragment',
		'HierarchicalView', {
			"Id": this["sId"],
			"Name": sName,
			"Navigation": sNavigation,
			// hacky hack hack:
			// $Parents is an Array<HierarchicalView>, but only accesses $Parent.sName
			// => with duck-typing, we can add arbitrary names
			"Parents": UCF_JsUtil["map"](this["aBreadCrumb"], function(sId) {
				return { "Name": self["sGetSegmentName"](sId), "SegmentId": sId };
			})
		}
	);

	oRenderManager["clearBuffer"]();
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["renderNavigation"] = 0; };
// #endregion
// #region sGetSegmentName ----------------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {string}
 */
UCF_HierarchicalView_SegmentManager["prototype"]["sGetSegmentName"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetSegmentName"]++; }; 
	return sSegmentId in this["oSegments"]
		? this["oSegments"][sSegmentId]["sName"]
		: '';
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetSegmentName"] = 0; };
// #endregion
// #region sGetItemsSegmentId -------------------------------------------------
/**
 * @protected
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {UCF_HierarchicalView_SegmentManager_ItemsSegmentId} `${sId}-itemssegment-${sSegmentId}`
 */
UCF_HierarchicalView_SegmentManager["prototype"]["sGetItemsSegmentId"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetItemsSegmentId"]++; }; 
	/** @type {UCF_HierarchicalView_SegmentManager} */
	var self = this;

	return this["oCache"]["get"]('sItemsSegmentId-' + sSegmentId, function() {
		return UCF_HierarchicalView_SegmentManager["sGetItemsSegmentIdStatic"](
			self["oControl"],
			sSegmentId
		);
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetItemsSegmentId"] = 0; };
// #region sGetItemsSegmentIdStatic ...........................................
/**
 * @protected
 * @static
 * @param {UCF_HierarchicalView} oControl
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {UCF_HierarchicalView_SegmentManager_ItemsSegmentId} `${oControl.sId}-itemssegment-${sSegmentId}`
 */
UCF_HierarchicalView_SegmentManager["sGetItemsSegmentIdStatic"] = function(oControl, sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetItemsSegmentIdStatic"]++; }; 
	return oControl["oLS"]["oGetRenderManager"]()["callFragment"](
		'HierarchicalViewGetItemsSegmentId',
		'HierarchicalView', {
			"Id": oControl["sId"],
			"SegmentId": sSegmentId
		}
	);
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetItemsSegmentIdStatic"] = 0; };
// #endregion
// #endregion
// #region sGetSegmentControlsId ----------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @return {string} `${sId}-itemssegmentcontrols-${sSegmentId}`
 */
UCF_HierarchicalView_SegmentManager["prototype"]["sGetSegmentControlsId"] = function(sSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetSegmentControlsId"]++; }; 
	/** @type {UCF_HierarchicalView_SegmentManager} */
	var self = this;

	return this["oCache"]["get"]('sSegmentControlsId-' + sSegmentId, function() {
		return self["oLS"]["oGetRenderManager"]()["callFragment"](
			'HierarchicalViewGetItemsSegmentControlsId',
			'HierarchicalView', { "Id": self["sId"], "SegmentId": sSegmentId }
		);
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["sGetSegmentControlsId"] = 0; };
// #endregion
// #region bIsNavigationItemRef -----------------------------------------------
/**
 * @protected
 * @static
 * @param {HTMLElement} oRef
 * @return {boolean}
 */
UCF_HierarchicalView_SegmentManager["bIsNavigationItemRef"] = function(oRef) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["bIsNavigationItemRef"]++; }; 
	return oRef && UCF_DomUtil["bHasClass"](oRef, 'lsHierarchicalview__navigationitem');
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["bIsNavigationItemRef"] = 0; };
// #endregion
// #region oGetItemsRef -------------------------------------------------------
/**
 * @private
 * @return {HTMLDivElement}
 */
UCF_HierarchicalView_SegmentManager["prototype"]["oGetItemsRef"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["oGetItemsRef"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;

	return this["oCache"]["get"]('oItemsRef', function() {
		return UCF_DomUtil["$"](self["sId"] + '-items');
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["oGetItemsRef"] = 0; };
// #endregion
// #region fGetTransitionDuration ---------------------------------------------
/**
 * @private
 * @return {number} in seconds
 */
UCF_HierarchicalView_SegmentManager["prototype"]["fGetTransitionDuration"] = function() {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["fGetTransitionDuration"]++; }; 
	return this["oCache"]["get"]('fTransitionDuration', function() {
		return parseFloat(
			UCF_DomUtil["sGetCurrentStyle"](
				UCF_DomUtil["querySelector"](
					'.lsHierarchicalview__itemssegment'
				),
				'transitionDuration'
			)
		);
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["fGetTransitionDuration"] = 0; };
// #endregion
// #region fireSegmentWillChange ----------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sOldSegmentId
 */
UCF_HierarchicalView_SegmentManager["prototype"]["fireSegmentWillChange"] = function(sSegmentId, sOldSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["fireSegmentWillChange"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["SegmentWillChange"], {
		"sSegmentId": sSegmentId,
		"sOldSegmentId": sOldSegmentId
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["fireSegmentWillChange"] = 0; };
// #region fireSegmentDidChange -----------------------------------------------
/**
 * @private
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sSegmentId
 * @param {UCF_HierarchicalView_SegmentManager_SegmentId} sOldSegmentId
 */
UCF_HierarchicalView_SegmentManager["prototype"]["fireSegmentDidChange"] = function(sSegmentId, sOldSegmentId) {;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["fireSegmentDidChange"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["SegmentDidChange"], {
		"sSegmentId": sSegmentId,
		"sOldSegmentId": sOldSegmentId
	});
};;if (__UCF_COVERAGE__) { UCF_HierarchicalView_SegmentManager["_"]["fireSegmentDidChange"] = 0; };
// #endregion

};
sap["ls"]["preload"]["UCF_HorizontalContextualPanel"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * HorizontalContextualPanel
 *
 * 
 *
 * @class
 * @param {HMTLElement} oDomRef DOM reference
 * @param {UCF_LS} oLS LS instance
 */
function UCF_HorizontalContextualPanel(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["UCF_HorizontalContextualPanel"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "HorizontalContextualPanel.js(39): UCF_HorizontalContextualPanel"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HorizontalContextualPanel.js(40): UCF_HorizontalContextualPanel"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HorizontalContextualPanel.js(41): UCF_HorizontalContextualPanel"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_HorizontalContextualPanel"] = UCF_HorizontalContextualPanel; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HorizontalContextualPanel"); UCF_HorizontalContextualPanel["_"] = {UCF_HorizontalContextualPanel: 0}; }; ;
UCF_HorizontalContextualPanel["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_HorizontalContextualPanel.prototype["sClassName"] = "UCF_HorizontalContextualPanel";

/**
 * Destructor
 * @private
 */
UCF_HorizontalContextualPanel["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["destroy"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_HorizontalContextualPanel["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel.js(62): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_HorizontalContextualPanel["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel.js(74): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
  oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["onlsskipback"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_HorizontalContextualPanel["prototype"]["aAttributeNames"] = ["iSelectedTabIndex","sVisibility","bClientSelect","sAccessibilityDescription","sCustomData","iHeadingLevel","bScrollable","iFirstVisibleOnMainLevel","iFirstVisibleOnSubLevel","sPopupMenuId","sCustomStyle","sMenuItemsDesign"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_HorizontalContextualPanel["prototype"]["aEventNames"] = ["Select","Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_HorizontalContextualPanel["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_HorizontalContextualPanel["prototype"]["iSelectedTabIndex"] = 0;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_HorizontalContextualPanel["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_HorizontalContextualPanel["prototype"]["bClientSelect"] = true;

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanel["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanel["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {number}
 */
UCF_HorizontalContextualPanel["prototype"]["iHeadingLevel"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_HorizontalContextualPanel["prototype"]["bScrollable"] = false;

/**
 * @private
 * @type {number}
 */
UCF_HorizontalContextualPanel["prototype"]["iFirstVisibleOnMainLevel"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_HorizontalContextualPanel["prototype"]["iFirstVisibleOnSubLevel"] = -1;

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanel["prototype"]["sPopupMenuId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanel["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HorizontalContextualPanelMenuItemsDesign}
 */
UCF_HorizontalContextualPanel["prototype"]["sMenuItemsDesign"] = "TAB";

//#JSCOVER_EXCL_START
/** @protected */
UCF_HorizontalContextualPanel["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["setDefaultValues"]++; }; 
	this["iSelectedTabIndex"] = 0;
	this["sVisibility"] = "VISIBLE";
	this["bClientSelect"] = true;
	this["sAccessibilityDescription"] = '';
	this["sCustomData"] = '';
	this["iHeadingLevel"] = 0;
	this["bScrollable"] = false;
	this["iFirstVisibleOnMainLevel"] = -1;
	this["iFirstVisibleOnSubLevel"] = -1;
	this["sPopupMenuId"] = '';
	this["sCustomStyle"] = '';
	this["sMenuItemsDesign"] = "TAB";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("SelectedTabIndex", 0, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ClientSelect", true, true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
		this["setClientProperty"]("Scrollable", false, true);
		this["setClientProperty"]("FirstVisibleOnMainLevel", -1, true);
		this["setClientProperty"]("FirstVisibleOnSubLevel", -1, true);
		this["setClientProperty"]("PopupMenuId", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("MenuItemsDesign", "TAB", true);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier the HCNP control (Root object).
 * @param {string} sItemId Identifier of the selected tab or menu item. 
 * @param {string} sSubItemId Identifier of the selected tab or menu item. 
 * @param {number} iFirstVisibleOnMainLevel Index of the first visible item on main level. 
 * @param {number} iFirstVisibleOnSubLevel Index of the first visible item on sub level. 
 * @fires HorizontalContextualPanel::Select
 */
UCF_HorizontalContextualPanel["prototype"]["fireSelect"] = function(sId, sItemId, sSubItemId, iFirstVisibleOnMainLevel, iFirstVisibleOnSubLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, ItemId: string, SubItemId: string, FirstVisibleOnMainLevel: number, FirstVisibleOnSubLevel: number}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "HorizontalContextualPanel.js(220): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "HorizontalContextualPanel.js(221): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "HorizontalContextualPanel.js(222): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "HorizontalContextualPanel.js(223): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "HorizontalContextualPanel.js(224): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSubItemId != null, "sSubItemId != null", "HorizontalContextualPanel.js(225): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSubItemId) == "string", "typeof(sSubItemId) == \"string\"", "HorizontalContextualPanel.js(226): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleOnMainLevel != null, "iFirstVisibleOnMainLevel != null", "HorizontalContextualPanel.js(227): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleOnMainLevel) == "number", "typeof(iFirstVisibleOnMainLevel) == \"number\"", "HorizontalContextualPanel.js(228): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleOnSubLevel != null, "iFirstVisibleOnSubLevel != null", "HorizontalContextualPanel.js(229): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleOnSubLevel) == "number", "typeof(iFirstVisibleOnSubLevel) == \"number\"", "HorizontalContextualPanel.js(230): fireSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"SubItemId": sSubItemId,
		"FirstVisibleOnMainLevel": iFirstVisibleOnMainLevel,
		"FirstVisibleOnSubLevel": iFirstVisibleOnSubLevel
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	
	
	this["fireSemanticEvent"]("HorizontalContextualPanel", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iFirstVisibleOnMainLevel Index of the first visible item on main level. 
 * @param {number} iFirstVisibleOnSubLevel Index of the first visible item on sub level. 
 * @fires HorizontalContextualPanel::Scroll
 */
UCF_HorizontalContextualPanel["prototype"]["fireScroll"] = function(sId, iFirstVisibleOnMainLevel, iFirstVisibleOnSubLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, FirstVisibleOnMainLevel: number, FirstVisibleOnSubLevel: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "HorizontalContextualPanel.js(262): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "HorizontalContextualPanel.js(263): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "HorizontalContextualPanel.js(264): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleOnMainLevel != null, "iFirstVisibleOnMainLevel != null", "HorizontalContextualPanel.js(265): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleOnMainLevel) == "number", "typeof(iFirstVisibleOnMainLevel) == \"number\"", "HorizontalContextualPanel.js(266): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleOnSubLevel != null, "iFirstVisibleOnSubLevel != null", "HorizontalContextualPanel.js(267): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleOnSubLevel) == "number", "typeof(iFirstVisibleOnSubLevel) == \"number\"", "HorizontalContextualPanel.js(268): fireScroll"); };
	mParams = {
		"Id": sId,
		"FirstVisibleOnMainLevel": iFirstVisibleOnMainLevel,
		"FirstVisibleOnSubLevel": iFirstVisibleOnSubLevel
	};
	
	
	
	this["fireSemanticEvent"]("HorizontalContextualPanel", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel["_"]["fireScroll"] = 0; };

};
sap["ls"]["preload"]["UCF_HorizontalContextualPanelItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * HorizontalContextualPanelItem
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_HorizontalContextualPanelItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem["_"]["UCF_HorizontalContextualPanelItem"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "HorizontalContextualPanelItem.js(21): UCF_HorizontalContextualPanelItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HorizontalContextualPanelItem.js(22): UCF_HorizontalContextualPanelItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HorizontalContextualPanelItem.js(23): UCF_HorizontalContextualPanelItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_HorizontalContextualPanelItem"] = UCF_HorizontalContextualPanelItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HorizontalContextualPanelItem"); UCF_HorizontalContextualPanelItem["_"] = {UCF_HorizontalContextualPanelItem: 0}; }; ;
UCF_HorizontalContextualPanelItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_HorizontalContextualPanelItem.prototype["sClassName"] = "UCF_HorizontalContextualPanelItem";

/**
 * Destructor
 * @private
 */
UCF_HorizontalContextualPanelItem["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_HorizontalContextualPanelItem["prototype"]["aAttributeNames"] = ["iIndex","iSelectedTabMenuIndex","sTooltip","bEnabled","sAccessKey","sCustomData","sPopupMenuId","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_HorizontalContextualPanelItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_HorizontalContextualPanelItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_HorizontalContextualPanelItem["prototype"]["iIndex"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_HorizontalContextualPanelItem["prototype"]["iSelectedTabMenuIndex"] = -1;

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanelItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_HorizontalContextualPanelItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanelItem["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanelItem["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanelItem["prototype"]["sPopupMenuId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanelItem["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_HorizontalContextualPanelItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem["_"]["setDefaultValues"]++; }; 
	this["iIndex"] = 0;
	this["iSelectedTabMenuIndex"] = -1;
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["sAccessKey"] = '';
	this["sCustomData"] = '';
	this["sPopupMenuId"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Index", 0, true);
		this["setClientProperty"]("SelectedTabMenuIndex", -1, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("PopupMenuId", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_HorizontalContextualPanelItem_ie6"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_HorizontalContextualPanelItem */
/// <reference path="./HorizontalContextualPanelItem.js"/>

/**
 * HorizontalContextualPanelItem
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_HorizontalContextualPanelItem_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_ie6["_"]["UCF_HorizontalContextualPanelItem_ie6"]++; }; 

		if (arguments["length"] === 0) return;
		
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "HorizontalContextualPanelItem_ie6.js(23): UCF_HorizontalContextualPanelItem_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HorizontalContextualPanelItem_ie6.js(24): UCF_HorizontalContextualPanelItem_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HorizontalContextualPanelItem_ie6.js(25): UCF_HorizontalContextualPanelItem_ie6"); };

	UCF_HorizontalContextualPanelItem["apply"](this, [oDomRef, oLS]);

	this["oFocusDomRef"] = this["oDomRef"]["childNodes"][1];
};window["UCF_HorizontalContextualPanelItem_ie6"] = UCF_HorizontalContextualPanelItem_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HorizontalContextualPanelItem_ie6"); UCF_HorizontalContextualPanelItem_ie6["_"] = {UCF_HorizontalContextualPanelItem_ie6: 0}; }; ;
UCF_HorizontalContextualPanelItem_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_HorizontalContextualPanelItem"))(); UCF_HorizontalContextualPanelItem_ie6.prototype["sClassName"] = "UCF_HorizontalContextualPanelItem_ie6";

/**
 * Destructor
 * @private
 */
UCF_HorizontalContextualPanelItem_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_ie6["_"]["destroy"]++; }; 
	UCF_HorizontalContextualPanelItem.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_ie6["_"]["destroy"] = 0; };

/**
 * Provide internal stuff for QUnit test recording and playback
 * @return {UCF_HorizontalContextualPanel}
 */
UCF_HorizontalContextualPanelItem_ie6["prototype"]["oGetTestData"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_ie6["_"]["oGetTestData"]++; }; 
	var o = UCF_HorizontalContextualPanelItem.prototype["oGetTestData"]["apply"](this, arguments);
	o["internals"]["DOM:title"] = this["oFocusDomRef"]["title"]; // UCF_DomUtil.$(this.sId + "-title").title;
	return o;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_ie6["_"]["oGetTestData"] = 0; };

UCF_HorizontalContextualPanelItem_ie6["prototype"]["select"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_ie6["_"]["select"]++; }; 
	this["oGetParent"]()["select"](this);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_ie6["_"]["select"] = 0; };

};
sap["ls"]["preload"]["UCF_HorizontalContextualPanelItem_standards"] = function() {/* eslint-disable jsdoc/require-param */
/* eslint-disable @ur/no-memory-leaks */
/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_HorizontalContextualPanelItem */
/// <reference path="./HorizontalContextualPanelItem.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_ClientPopupMenuHelper */
/// <reference path="../helper/ClientPopupMenuHelper.js"/>
/* global UCF_LayeredControl */
/// <reference path="base/LayeredControl.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/**
 * HorizontalContextualPanelItem
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_HorizontalContextualPanelItem_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["UCF_HorizontalContextualPanelItem_standards"]++; }; 

	if (arguments["length"] === 0) return;
		
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "HorizontalContextualPanelItem_standards.js(32): UCF_HorizontalContextualPanelItem_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HorizontalContextualPanelItem_standards.js(33): UCF_HorizontalContextualPanelItem_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HorizontalContextualPanelItem_standards.js(34): UCF_HorizontalContextualPanelItem_standards"); };

	UCF_HorizontalContextualPanelItem["apply"](this, [oDomRef, oLS]);

	this["oFocusDomRef"] = UCF_DomUtil["$"](this["sId"] + "-title");
	/** @type {UCF_Cache} */
	this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
};window["UCF_HorizontalContextualPanelItem_standards"] = UCF_HorizontalContextualPanelItem_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HorizontalContextualPanelItem_standards"); UCF_HorizontalContextualPanelItem_standards["_"] = {UCF_HorizontalContextualPanelItem_standards: 0}; }; ;
UCF_HorizontalContextualPanelItem_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_HorizontalContextualPanelItem"))(); UCF_HorizontalContextualPanelItem_standards.prototype["sClassName"] = "UCF_HorizontalContextualPanelItem_standards";

/**
 * Destructor
 * @private
 */
UCF_HorizontalContextualPanelItem_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["destroy"]++; }; 
	this["oCache"] = null;
	UCF_HorizontalContextualPanelItem.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["destroy"] = 0; };

/**
 * Provide internal stuff for QUnit test recording and playback
 * @return {UCF_HorizontalContextualPanel}
 */
UCF_HorizontalContextualPanelItem_standards["prototype"]["oGetTestData"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["oGetTestData"]++; }; 
	var o = UCF_HorizontalContextualPanelItem.prototype["oGetTestData"]["apply"](this, arguments);
	o["internals"]["DOM:title"] = UCF_DomUtil["$"](this["sId"] + "-title")["title"];
	return o;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["oGetTestData"] = 0; };

/**
 * Selects an item
 * @public
 */
UCF_HorizontalContextualPanelItem_standards["prototype"]["select"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["select"]++; }; 
	var oParent = this["oGetParent"]();

	oParent["setItemToSelect"](this);
	oParent["select"](this);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["select"] = 0; };

/**
 * creates the PopupMenu
 * @return {UCF_PopupMenu} the popupmenu with the
 * @public
 */
UCF_HorizontalContextualPanelItem_standards["prototype"]["oGetPopupMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["oGetPopupMenu"]++; }; 

	/** @type {UCF_AbapList} */
	var self = this;

	return this["oCache"]["get"]('oGetPopupMenu', function() {
		/** @type {HTMLElement} */
		var oMenuItemsDomRef = UCF_DomUtil["$"]('HCNP_tab' + self["sId"]);
		if (!oMenuItemsDomRef) return null;

		/** @type {Array} */
		var aDomItems = oMenuItemsDomRef["childNodes"];
		/** @type {int} */
		var i;
		/** @type {HCNP_Item} */
		var oItem;
		var oMenuItemsJSON = [];
		var oPopupMenu;
		for (i = 0; i < aDomItems["length"]; i++) {
			oItem = self["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[i], true);
			if (oItem)
				oMenuItemsJSON["push"](oItem["oGetPopupMenuJSON"]());
		}
		if (oMenuItemsJSON["length"] > 0) {
			var oMenuHelper = new (UCF_ClassLoader["oGetClass"]("UCF_ClientPopupMenuHelper"))(self["oLS"]);
			oPopupMenu = oMenuHelper["oRenderMenu"](self["sId"] + '-popupmenu',
				null,
				oMenuItemsJSON
			);
			//The dom reference of the opener control, that should be used for alignment.
			oPopupMenu["setOpenerRef"](UCF_DomUtil["$"](self["sId"] + '-tabmenu'));
			//control id of the control that opened the PopupMenu
			oPopupMenu["setOpenerId"](self["sId"] + '-tabmenu');
			oPopupMenu["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
			oPopupMenu["bAutoRefocus"] = false;
			oPopupMenu["attachEvent"](oPopupMenu["E_EVENTS"]["Close"], self, "onMenuClose");
			oPopupMenu["attachEvent"](oPopupMenu["E_EVENTS"]["Select"], self, "onMenuItemSelect");
			oPopupMenu["bContentChanged"] = false;

			return oPopupMenu;

		} else {
			return null;
		}
	});

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["oGetPopupMenu"] = 0; };

/**
 * Selects an item
 * @public
 */
UCF_HorizontalContextualPanelItem_standards["prototype"]["onMenuItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["onMenuItemSelect"]++; }; 
	var sMenuItemId = oEvent["oGetParam"]("sItemId"),
		sMenuId = sMenuItemId["split"]("-")[0];
	if (!this["oDomRef"])	{
		//on clientSever the control is not yet initialized
		if (this["sId"]) {
			this["oFocusDomRef"] = UCF_DomUtil["$"](this["sId"] + "-title");
			this["oDomRef"] = UCF_DomUtil["$"](this["sId"]);
			this["oRootRef"] = UCF_DomUtil["$"](this["sId"]);
		}
	}
	var oParent = this["oGetParent"]();
	if (oParent)
		oParent["fireSelect"](oParent["sId"], this["sId"], sMenuId, 0, -1);

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["onMenuItemSelect"] = 0; };

/**
 * Selects an item
 * @public
 */
UCF_HorizontalContextualPanelItem_standards["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["onMenuClose"]++; }; 
	//focus this panelitem
	UCF_DomUtil["focusDomElement"](this["oFocusDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelItem_standards["_"]["onMenuClose"] = 0; };

UCF_HorizontalContextualPanelItem_standards.prototype["aPublicMethods"] = ["select","oGetPopupMenu","onMenuItemSelect","onMenuClose"].concat(UCF_HorizontalContextualPanelItem_standards.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_HorizontalContextualPanelMenuItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * HorizontalContextualPaneMenulItem
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_HorizontalContextualPanelMenuItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem["_"]["UCF_HorizontalContextualPanelMenuItem"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "HorizontalContextualPanelMenuItem.js(24): UCF_HorizontalContextualPanelMenuItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HorizontalContextualPanelMenuItem.js(25): UCF_HorizontalContextualPanelMenuItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HorizontalContextualPanelMenuItem.js(26): UCF_HorizontalContextualPanelMenuItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	this["oFocusDomRef"] = UCF_DomUtil["oGetFirstChild"](this["oDomRef"]);
};window["UCF_HorizontalContextualPanelMenuItem"] = UCF_HorizontalContextualPanelMenuItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HorizontalContextualPanelMenuItem"); UCF_HorizontalContextualPanelMenuItem["_"] = {UCF_HorizontalContextualPanelMenuItem: 0}; }; ;
UCF_HorizontalContextualPanelMenuItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_HorizontalContextualPanelMenuItem.prototype["sClassName"] = "UCF_HorizontalContextualPanelMenuItem";
/**
 * Destructor
 * @private
 */
UCF_HorizontalContextualPanelMenuItem["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_HorizontalContextualPanelMenuItem["prototype"]["aAttributeNames"] = ["iTabIndex","iIndex","sTooltip","bEnabled","sAccessKey","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_HorizontalContextualPanelMenuItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_HorizontalContextualPanelMenuItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_HorizontalContextualPanelMenuItem["prototype"]["iTabIndex"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_HorizontalContextualPanelMenuItem["prototype"]["iIndex"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanelMenuItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_HorizontalContextualPanelMenuItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanelMenuItem["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanelMenuItem["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HorizontalContextualPanelMenuItem["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_HorizontalContextualPanelMenuItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem["_"]["setDefaultValues"]++; }; 
	this["iTabIndex"] = 0;
	this["iIndex"] = 0;
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["sAccessKey"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("TabIndex", 0, true);
		this["setClientProperty"]("Index", 0, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_HorizontalContextualPanelMenuItem_ie6"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_HorizontalContextualPanelMenuItem */
/// <reference path="./HorizontalContextualPanelMenuItem.js"/>

/**
 * HorizontalContextualPaneMenulItem
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_HorizontalContextualPanelMenuItem_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_ie6["_"]["UCF_HorizontalContextualPanelMenuItem_ie6"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "HorizontalContextualPanelMenuItem_ie6.js(26): UCF_HorizontalContextualPanelMenuItem_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HorizontalContextualPanelMenuItem_ie6.js(27): UCF_HorizontalContextualPanelMenuItem_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HorizontalContextualPanelMenuItem_ie6.js(28): UCF_HorizontalContextualPanelMenuItem_ie6"); };

	UCF_HorizontalContextualPanelMenuItem["apply"](this, [oDomRef, oLS]);
	this["oFocusDomRef"] = UCF_DomUtil["oGetFirstChild"](this["oDomRef"]);
};window["UCF_HorizontalContextualPanelMenuItem_ie6"] = UCF_HorizontalContextualPanelMenuItem_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HorizontalContextualPanelMenuItem_ie6"); UCF_HorizontalContextualPanelMenuItem_ie6["_"] = {UCF_HorizontalContextualPanelMenuItem_ie6: 0}; }; ;
UCF_HorizontalContextualPanelMenuItem_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_HorizontalContextualPanelMenuItem"))(); UCF_HorizontalContextualPanelMenuItem_ie6.prototype["sClassName"] = "UCF_HorizontalContextualPanelMenuItem_ie6";

/**
 * Destructor
 * @private
 */
UCF_HorizontalContextualPanelMenuItem_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_ie6["_"]["destroy"]++; }; 
	UCF_HorizontalContextualPanelMenuItem.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_ie6["_"]["destroy"] = 0; };

UCF_HorizontalContextualPanelMenuItem_ie6["prototype"]["onSubItemAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_ie6["_"]["onSubItemAccess"]++; }; 
	this["oGetParent"]()["onSubItemAccess"](oEvent);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_ie6["_"]["onSubItemAccess"] = 0; };

UCF_HorizontalContextualPanelMenuItem_ie6["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_ie6["_"]["onlsselect"]++; }; 
	this["oGetParent"]()["onlsselect"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_ie6["_"]["onlsselect"] = 0; };

/**
 * Provide internal stuff for QUnit test recording and playback
 * @return {UCF_HorizontalContextualPanel}
 */
UCF_HorizontalContextualPanelMenuItem_ie6["prototype"]["oGetTestData"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_ie6["_"]["oGetTestData"]++; }; 
	var o = UCF_HorizontalContextualPanelMenuItem.prototype["oGetTestData"]["apply"](this, arguments);
	o["internals"]["DOM:title"] = this["oFocusDomRef"]["title"];
	return o;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_ie6["_"]["oGetTestData"] = 0; };

};
sap["ls"]["preload"]["UCF_HorizontalContextualPanelMenuItem_standards"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_HorizontalContextualPanelMenuItem */
/// <reference path="./HorizontalContextualPanelMenuItem.js"/>

/**
 * HorizontalContextualPaneMenulItem
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_HorizontalContextualPanelMenuItem_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_standards["_"]["UCF_HorizontalContextualPanelMenuItem_standards"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "HorizontalContextualPanelMenuItem_standards.js(26): UCF_HorizontalContextualPanelMenuItem_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HorizontalContextualPanelMenuItem_standards.js(27): UCF_HorizontalContextualPanelMenuItem_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HorizontalContextualPanelMenuItem_standards.js(28): UCF_HorizontalContextualPanelMenuItem_standards"); };

	UCF_HorizontalContextualPanelMenuItem["apply"](this, [oDomRef, oLS]);
	this["oFocusDomRef"] = UCF_DomUtil["oGetFirstChild"](this["oDomRef"]);
};window["UCF_HorizontalContextualPanelMenuItem_standards"] = UCF_HorizontalContextualPanelMenuItem_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HorizontalContextualPanelMenuItem_standards"); UCF_HorizontalContextualPanelMenuItem_standards["_"] = {UCF_HorizontalContextualPanelMenuItem_standards: 0}; }; ;
UCF_HorizontalContextualPanelMenuItem_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_HorizontalContextualPanelMenuItem"))(); UCF_HorizontalContextualPanelMenuItem_standards.prototype["sClassName"] = "UCF_HorizontalContextualPanelMenuItem_standards";

/**
 * Destructor
 * @private
 */
UCF_HorizontalContextualPanelMenuItem_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_standards["_"]["destroy"]++; }; 
	UCF_HorizontalContextualPanelMenuItem.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_standards["_"]["destroy"] = 0; };

UCF_HorizontalContextualPanelMenuItem_standards["prototype"]["onSubItemAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_standards["_"]["onSubItemAccess"]++; }; 
	this["oGetParent"]()["onSubItemAccess"](oEvent);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_standards["_"]["onSubItemAccess"] = 0; };

UCF_HorizontalContextualPanelMenuItem_standards["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_standards["_"]["onlsselect"]++; }; 
	this["oGetParent"]()["onlsselect"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_standards["_"]["onlsselect"] = 0; };

/**
 * Provide internal stuff for QUnit test recording and playback
 * @return {UCF_HorizontalContextualPanel}
 */
UCF_HorizontalContextualPanelMenuItem_standards["prototype"]["oGetTestData"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_standards["_"]["oGetTestData"]++; }; 
	var o = UCF_HorizontalContextualPanelMenuItem.prototype["oGetTestData"]["apply"](this, arguments);
	o["internals"]["DOM:title"] = this["oFocusDomRef"]["title"];
	return o;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_standards["_"]["oGetTestData"] = 0; };

/**
 * Create a PopupMenuItem with the values of a current
 * @return {PopupMenuItem} - the JSON for clientside PopupMenuItem
 * @private
 */
UCF_HorizontalContextualPanelMenuItem_standards["prototype"]["oGetPopupMenuJSON"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_standards["_"]["oGetPopupMenuJSON"]++; }; 
	var sCaption = this["oDomRef"]["getAttribute"]('data-caption');
	return {
		"PopupMenuItem": {
			"Id": this["sId"] + "-hcnp_menuitem",
			"Text": sCaption,
			"Enabled": this["bEnabled"],
			"Tooltip": this["sTooltip"]
		}
	};
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanelMenuItem_standards["_"]["oGetPopupMenuJSON"] = 0; };

};
sap["ls"]["preload"]["UCF_HorizontalContextualPanel_ie6"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_HorizontalContextualPanel */
/// <reference path="./HorizontalContextualPanel.js"/>

/**
 * HorizontalContextualPanel
 *
 * 
 *
 * @class
 * @param {HMTLElement} oDomRef DOM reference
 * @param {UCF_LS} oLS LS instance
 */
function UCF_HorizontalContextualPanel_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["UCF_HorizontalContextualPanel_ie6"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "HorizontalContextualPanel_ie6.js(41): UCF_HorizontalContextualPanel_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HorizontalContextualPanel_ie6.js(42): UCF_HorizontalContextualPanel_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HorizontalContextualPanel_ie6.js(43): UCF_HorizontalContextualPanel_ie6"); };

	UCF_HorizontalContextualPanel["apply"](this, [oDomRef, oLS]);

	this["createGenericFields"]();

	this["oItemNavigation"]["oMainItems"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]["oMainItems"]);

	this["oItemNavigation"]["oMainItems"]["attachEvent"](this["oItemNavigation"]["oMainItems"]["E_EVENTS"]["Select"], this, 'onMainItemAccess');

	if (this["bIsScrollable"]()) {
		this["oItemNavigation"]["oMainItems"]["attachEvent"](this["oItemNavigation"]["oMainItems"]["E_EVENTS"]["Activate"], this, 'onMainItemActivate');
		this["attachBrowserEvent"]('resize', this["oDomRef"]);
	}

	this["createMainItems"]();

	if (this["iSelectedTabIndex"] > -1 && this["oHCNP"]["aMainItems"]["length"] > 0) {
		this["createSubItems"](this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]]);
	}

};window["UCF_HorizontalContextualPanel_ie6"] = UCF_HorizontalContextualPanel_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HorizontalContextualPanel_ie6"); UCF_HorizontalContextualPanel_ie6["_"] = {UCF_HorizontalContextualPanel_ie6: 0}; }; ;
UCF_HorizontalContextualPanel_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_HorizontalContextualPanel"))(); UCF_HorizontalContextualPanel_ie6.prototype["sClassName"] = "UCF_HorizontalContextualPanel_ie6";

/**
 * ############################################################
 *
 * Everything that needs do be done during initialization
 *
 * ############################################################
 */

/**
 * central objects that stores all control objects necessary for:
 * 	- Selection
 *   - Scrolling
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["createGenericFields"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["createGenericFields"]++; }; 

	this["oHCNP"] = {};
	this["oHCNP"]["aMainItems"] = [];
	this["oHCNP"]["oMainMenu"] = null;
	this["oHCNP"]["aSubMenus"] = null;

	this["oItemNavigation"] = {};
	this["oSelectionData"] = {};

	this["oNavigationData"] = {};
	this["oLastScrolled"] = null;

	this["iWidth"] = this["oDomRef"]["offsetWidth"];
	this["iVisibilityThreasholdMain"] = 0;
	this["iVisibilityThreasholdSub"] = 0;
	this["bUsePopUpMenu"] = (this["sPopupMenuId"] !== '' && this["bIsScrollable"]());
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["createGenericFields"] = 0; };

/**
 * collects all items on top level
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["createMainItems"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["createMainItems"]++; }; 

	/** @type {HTMLDivElement} */
	var oMainItemsRef = UCF_DomUtil["$"](this["sId"] + '-mainItems')["childNodes"];
	/** @type {UCF_HorizontalContextualPanel} */
	var self = this;

	this["oHCNP"]["aMainItems"] = UCF_JsUtil["reduce"](UCF_JsUtil["arrayFrom"](oMainItemsRef), function(aItems, oItemRef) {
		var oItem = self["oLS"]["oControlFactory"]["oGetControlByDomRef"](oItemRef, true);

		if (UCF_JsUtil["bInstanceOf"](oItem, 'UCF_HorizontalContextualPanelItem_ie6')) {

			aItems["push"](oItem);

			if (oItem["bEnabled"] || window["UCF_System"]["bIs508"]) {
				self["oItemNavigation"]["oMainItems"]["addItem"](oItem, oItem["iIndex"] === self["iSelectedTabIndex"]);
			}
		}

		return aItems;
	}, []);

	this["oItemNavigation"]["oMainItems"]["oItemContainer"] = UCF_DomUtil["$"](this["sId"] + '-mainItems');
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["createMainItems"] = 0; };

/**
 * collects all menu items
 * @param {UCF_Control} oMainItem index of the selected tab
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["createSubItems"] = function(oMainItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["createSubItems"]++; }; 

	/** @type {HTMLDivElement[]} */
	var aDomItems = UCF_JsUtil["arrayFrom"](UCF_DomUtil["$"]('subItemsOf-' + oMainItem["sId"])["childNodes"]);
	/** @type {UCF_HorizontalContextualPanel} */
	var self = this;

	if (!aDomItems || aDomItems["length"] === 0) return;

	this["oItemNavigation"]['subItemsOf-' + oMainItem["sId"]] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();

	this["oHCNP"]['subItemsOf-' + oMainItem["sId"]] = UCF_JsUtil["reduce"](aDomItems, function(aItems, oItemRef) {

		var oItem = self["oLS"]["oControlFactory"]["oGetControlByDomRef"](oItemRef, true);

		if (UCF_JsUtil["bInstanceOf"](oItem, 'UCF_HorizontalContextualPanelMenuItem_ie6')) {

			aItems["push"](oItem);

			if (oItem["bEnabled"] || window["UCF_System"]["bIs508"]) {
				self["oItemNavigation"]['subItemsOf-' + oMainItem["sId"]]["addItem"](oItem, oItem["iIndex"] === oMainItem["iSelectedTabMenuIndex"]);
			}

		}
		return aItems;
	}, []);

	this["addDelegate"](this["oItemNavigation"]['subItemsOf-' + oMainItem["sId"]]);
	this["oItemNavigation"]['subItemsOf-' + oMainItem["sId"]]["attachEvent"](this["oItemNavigation"]['subItemsOf-' + oMainItem["sId"]]["E_EVENTS"]["Select"], this, 'onSubItemAccess');
	this["oItemNavigation"]['subItemsOf-' + oMainItem["sId"]]["attachEvent"](this["oItemNavigation"]['subItemsOf-' + oMainItem["sId"]]["E_EVENTS"]["Activate"], this, 'onSubItemActivate');
	this["oItemNavigation"]['subItemsOf-' + oMainItem["sId"]]["oItemContainer"] = UCF_DomUtil["$"]('subItemsOf-' + oMainItem["sId"]);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["createSubItems"] = 0; };

/**
 * Initialization of the HCNP
 * * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["initialize"]++; }; 

	if (!this["bIsScrollable"]()) return;

	this["aActionItems"] = this["aGetActionButtons"]();

	var oSelectedOnMainLevel = this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]];
	var oSelectedOnSubLevel = this["bMainItemHasSubItems"](oSelectedOnMainLevel) ? this["oHCNP"]['subItemsOf-' + oSelectedOnMainLevel["sId"]][oSelectedOnMainLevel["iSelectedTabMenuIndex"]] : null;
	var bSetMainLevelScrollSwitch = (this["iFirstVisibleOnMainLevel"] === -1 && this["bIsInNextHiddenItems"](oSelectedOnMainLevel, this["eLevel"]["MAIN"]));
	var bSetSubLevelScrollSwitch = (this["iFirstVisibleOnSubLevel"] === -1 && oSelectedOnSubLevel && this["bIsInNextHiddenItems"](oSelectedOnSubLevel, this["eLevel"]["SUB"]));

	if (bSetMainLevelScrollSwitch) {
		this["setScrollSwitch"](this["eScrollSwitch"]["ON"], this["eLevel"]["MAIN"]);
	}

	if (bSetSubLevelScrollSwitch) {
		this["setScrollSwitch"](this["eScrollSwitch"]["ON"], this["eLevel"]["SUB"]);
	}
	this["updateActionButtons"]();
	this["updateStyles"](this["eAction"]["SCROLL_TO_PREVIOUS_MAIN_ITEMS"]);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["initialize"] = 0; };

/**
 * ############################################################################
 *
 * SECTION FOR ACTION BUTTONS These are
 *
 * SCROLL-LEFT + SCROLL-RIGHT + OPEN-MENU for main- and sub-items
 *
 * All routines handling the interaction on the panel with the scroll-
 * and menu buttons
 *
 * ############################################################################
 */

/**
 * An enumerations with all actions that can be triggered on click
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["eAction"] = {
	"SCROLL_TO_PREVIOUS_MAIN_ITEMS": 'SCROLL_TO_PREVIOUS_MAIN_ITEMS',
	"SCROLL_TO_NEXT_MAIN_ITEMS": 'SCROLL_TO_NEXT_MAIN_ITEMS',
	"SCROLL_TO_PREVIOUS_SUB_ITEMS": 'SCROLL_TO_PREVIOUS_SUB_ITEMS',
	"SCROLL_TO_NEXT_SUB_ITEMS": 'SCROLL_TO_NEXT_SUB_ITEMS',
	"ACCESS_MENU": 'ACCESS_MENU'
};

/**
 * Determines the action that needs to be triggered on click
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {string} value of HTML attribute action
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["sDetermineAction"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sDetermineAction"]++; }; 
	var oButton = oBrowserEvent["oSource"],
		sAction = oButton["getAttribute"]('action');

	return sAction;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sDetermineAction"] = 0; };

/**
 * Handles the ontouch event on a tablett
 * for the buttons and the item menu
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
// UCF_HorizontalContextualPanel_ie6.prototype.onlstouchend = function(oBrowserEvent) {
// 	_assert(oBrowserEvent instanceof UCF_BrowserEvent);

// 	this.onclick(oBrowserEvent);
// };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel_ie6.js(252): onclick"); };

	//if (oBrowserEvent.sName === 'click' && UCF_System.sInteractionType === 'TOUCH') return;

	switch (this["sDetermineAction"](oBrowserEvent)) {
		case this["eAction"]["SCROLL_TO_PREVIOUS_MAIN_ITEMS"]:
			this["pageToPreviousHcnpItems"](this["eLevel"]["MAIN"]);
			this["updateActionButtons"]();
			this["updateStyles"](this["eAction"]["SCROLL_TO_PREVIOUS_MAIN_ITEMS"]);
			this["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ITEM_SCROLLING"];
			break;

		case this["eAction"]["SCROLL_TO_NEXT_MAIN_ITEMS"]:
			this["pageToNextHcnpItems"](this["eLevel"]["MAIN"]);
			this["updateActionButtons"]();
			this["updateStyles"](this["eAction"]["SCROLL_TO_NEXT_MAIN_ITEMS"]);
			this["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ITEM_SCROLLING"];
			break;

		case this["eAction"]["SCROLL_TO_PREVIOUS_SUB_ITEMS"]:
			this["pageToPreviousHcnpItems"](this["eLevel"]["SUB"]);
			this["updateActionButtons"]();
			this["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ITEM_SCROLLING"];
			break;

		case this["eAction"]["SCROLL_TO_NEXT_SUB_ITEMS"]:
			this["pageToNextHcnpItems"](this["eLevel"]["SUB"]);
			this["updateActionButtons"]();
			this["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ITEM_SCROLLING"];
			break;

		case this["eAction"]["ACCESS_MENU"]:
			if (!this["oHCNP"]["oMainMenu"] && this["bIsScrollable"]() && this["bUsePopUpMenu"]) {
				this["createMainMenu"]();
				this["createSubMenus"]();
				this["openMenu"]();
			} else {
				this["openMenu"]();
			}
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onclick"] = 0; };

UCF_HorizontalContextualPanel_ie6["prototype"]["updateStyles"] = function(sAction) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["updateStyles"]++; }; 
	/** @type {UCF_HorizontalContextualPanelItem_ie6} */
	var oItem = this["oGetFirstItemInViewPort"](this["eLevel"]["MAIN"]);
	/** @type {HTML_Element} */
	var oAngle = oItem["oDomRef"]["firstChild"];
	/** @type {UCF_HorizontalContextualPanelItem_ie6} */
	var oLast;

	if (this["oLastScrolled"] !== null) {
		oLast = this["oLastScrolled"]["oDomRef"]["firstChild"];
		if (oItem["iIndex"] === this["iSelectedTabIndex"]) {
			UCF_DomUtil["replaceClass"](oLast, oLast["className"], this["eStyles"]["ITEM_LEFT_ANGLE_SELECTED"]);
		} else {
			UCF_DomUtil["replaceClass"](oLast, oLast["className"], this["eStyles"]["ITEM_LEFT_ANGLE_DESELECTED"]);
		}
	}

	if (oItem["iIndex"] > 0) {
		if (oItem["iIndex"] === this["iSelectedTabIndex"]) {
			UCF_DomUtil["replaceClass"](oAngle, oAngle["className"], this["eStyles"]["FIRST_ITEM_LEFT_ANGLE_SELECTED"]);
		} else {
			UCF_DomUtil["replaceClass"](oAngle, oAngle["className"], this["eStyles"]["FIRST_ITEM_LEFT_ANGLE_DESELECTED"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["updateStyles"] = 0; };

/**
 * Collects all action items from the HTML
 *
 * @private
 * @return {Array} contains all action buttons
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["aGetActionButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["aGetActionButtons"]++; }; 

	var aActionButtons = [
		{ 'PREV_BTN_MAIN': UCF_DomUtil["$"](this["sId"] + '-prevMainItems') },
		{ 'NEXT_BTN_MAIN': UCF_DomUtil["$"](this["sId"] + '-nextMainItems') },
		{ 'PREV_BTN_SUB': UCF_DomUtil["$"](this["sId"] + '-prevSubItems') },
		{ 'NEXT_BTN_SUB': UCF_DomUtil["$"](this["sId"] + '-nextSubItems') }
	     ];

	if (this["bUsePopUpMenu"]) {
		aActionButtons["push"]({ 'MENU_BTN': UCF_DomUtil["$"](this["sId"] + '-menu') });
	}

	return aActionButtons;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["aGetActionButtons"] = 0; };

/**
 * Sets a bool to a field that determines whether the corresponding action is is to be
 * switched on visible.
 * @return {Object} contains states of action buttons
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["oStatesOfActionButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["oStatesOfActionButtons"]++; }; 
	var o = {
		'PREV_BTN_MAIN': this["bIsInPreviousHiddenItems"](this["oHCNP"]["aMainItems"][0], this["eLevel"]["MAIN"]),
		'NEXT_BTN_MAIN': this["bIsInNextHiddenItems"](this["oHCNP"]["aMainItems"][this["oHCNP"]["aMainItems"]["length"] - 1], this["eLevel"]["MAIN"]),
		'PREV_BTN_SUB': (this["bHasSubItems"] && !this["bFirstHcnpTabIsInViewPort"](this["eLevel"]["SUB"])) ? true : false,
		'NEXT_BTN_SUB': (this["bHasSubItems"] && !this["bLastHcnpTabIsInViewPort"](this["eLevel"]["SUB"])) ? true : false
	};

	if (this["bUsePopUpMenu"]) {
		if (o["PREV_BTN_MAIN"] || o["NEXT_BTN_MAIN"] || (this["bHasSubItems"] && o["PREV_BTN_SUB"]) || (this["bHasSubItems"] && o["NEXT_BTN_SUB"])) {
			o['MENU_BTN'] = true;
		} else {
			o['MENU_BTN'] = false;
		}
	}

	return o;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["oStatesOfActionButtons"] = 0; };

/**
 * Iterates over all action items in a call back and switches the styles accordingly
 *
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["updateActionButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["updateActionButtons"]++; }; 

	if (!this["bIsScrollable"]()) return;

	var oItemToCheck = (this["oSelectionData"]["oMainLevelItem"] != null) ? this["oSelectionData"]["oMainLevelItem"] : this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]];

	this["bHasSubItems"] = this["bMainItemHasSubItems"](oItemToCheck);

	var oHcnpItemsVisibility = this["oStatesOfActionButtons"](),
		fSetEndFix = function(bSwitchOn) { return (bSwitchOn ? '_ON' : '_OFF'); };

	UCF_JsUtil["forEach"](this["aActionItems"], function(oActionItem) {

		var oHcnpItemsVisibility = this[1];
		var fSetEndFix = this[2];
		var oStyles = this[3];

		for (var n in oActionItem) {
			// looks like this ==>	  oActionItem['MENU_BTN'], oStyles['MENU_BTN' + '_OFF'], oStylesoStyles['MENU_BTN' + '_ON']
			UCF_DomUtil["replaceClass"](oActionItem[n], oStyles[n + fSetEndFix(!oHcnpItemsVisibility[n])], oStyles[n + fSetEndFix(oHcnpItemsVisibility[n])]);
		}
	}, [this["bHasSubItems"], oHcnpItemsVisibility, fSetEndFix, this["eStyles"]]);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["updateActionButtons"] = 0; };

/**
 * ############################################################################
 *
 * SECTION THAT CONDUCTS ALL OPERATIONS OF AND FOR THE OVERFLOW MENU
 *
 * ############################################################################
 */

/**
 * Create creates the menu which is on main level of hierarchical
 * menu and assigns all references
 *
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["createMainMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["createMainMenu"]++; }; 

	var oMainMenu = this["oLS"]["oControlFactory"]["oGetControlById"](this["sPopupMenuId"]);

	this["attacheMenuEvents"](oMainMenu);
	oMainMenu["setOpenerId"](this["sId"] + '-menu');
	oMainMenu["setOpenerRef"](UCF_DomUtil["$"](this["sId"] + '-menu'));
	oMainMenu["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
	this["oHCNP"]["oMainMenu"] = oMainMenu;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["createMainMenu"] = 0; };

/**
 * Create creates the menus which an on sub level of hierarchical
 * menu and assigns all references
 *
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["createSubMenus"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["createSubMenus"]++; }; 
	var self;

	if (!this["bSubMenusAssigned"]()) {
		return;
	}

	self = this;

	this["oHCNP"]["aSubMenus"] = UCF_JsUtil["reduce"](self["oHCNP"]["aMainItems"], function(aSubMenus, oTopLevelTab) {

		var sPopupMenuId = oTopLevelTab["sPopupMenuId"];
		if (!UCF_StringUtil["bIsEmpty"](sPopupMenuId)) {

			var oSubMenu = self["oLS"]["oControlFactory"]["oGetControlById"](sPopupMenuId, true);

			self["attacheMenuEvents"](oSubMenu);

			if (UCF_JsUtil["bInstanceOf"](oSubMenu, 'UCF_PopupMenu')) {
				aSubMenus["push"](oSubMenu);
			}
		}
		return aSubMenus;
	}, []);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["createSubMenus"] = 0; };

/**
 * Checks whether or not sub menus are assigned to the main menu items
 *
 * @private
 * @return {boolean}
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["bSubMenusAssigned"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bSubMenusAssigned"]++; }; 

	var aMainItems = this["oHCNP"]["oMainMenu"]["aGetItems"]();

	for (var i = 0; i < aMainItems["length"]; i++) {
		if (aMainItems[i]["bGetHasSubMenu"]()) {
			return true;
		}
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bSubMenusAssigned"] = 0; };

/**
 * Attaches all necessary events to a menu
 *
 * @private
 * @param {UCF_Menu} oMenu
 */

UCF_HorizontalContextualPanel_ie6["prototype"]["attacheMenuEvents"] = function(oMenu) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["attacheMenuEvents"]++; }; 
	if (oMenu) {
		oMenu["attachEvent"](oMenu["E_EVENTS"]["Select"], this, 'onMenuItemAccess');
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["attacheMenuEvents"] = 0; };

/**
 * Opens the associated menu
 *
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["openMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["openMenu"]++; }; 

	if (this["oHCNP"]["oMainMenu"]["bOpened"]) {
		this["oHCNP"]["oMainMenu"]["close"]();
	} else {
		this["oHCNP"]["oMainMenu"]["open"]();
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["openMenu"] = 0; };

/**
 * Checks whether or not the menu item can be selected
 *
 * @private
 * @param {UCF_MenuItem} oMenuItem
 */

UCF_HorizontalContextualPanel_ie6["prototype"]["sGetMenuItemStatus"] = function(oMenuItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sGetMenuItemStatus"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oMenuItem != null && oMenuItem !== 'undefined', "oMenuItem != null && oMenuItem !== 'undefined'", "HorizontalContextualPanel_ie6.js(509): sGetMenuItemStatus"); };

	if (!oMenuItem["bEnabled"])
		return this["eStatusOfItemToSelect"]["INACCESSIBLE"];

	if (oMenuItem["bChecked"] && oMenuItem["oMenu"]["sId"] !== this["sPopupMenuId"] && oMenuItem["iIndex"] !== 0)
		return this["eStatusOfItemToSelect"]["SELECTED_SUB_MENU_ITEM"];

	if (oMenuItem["bChecked"] && oMenuItem["oMenu"]["sId"] !== this["sPopupMenuId"] && oMenuItem["iIndex"] === 0)
		return this["eStatusOfItemToSelect"]["SELECTED_MAIN_MENU_ITEM"];

	if (oMenuItem["bChecked"] && oMenuItem["oMenu"]["sId"] === this["sPopupMenuId"])
		return this["eStatusOfItemToSelect"]["SELECTED_MAIN_MENU_ITEM"];

	return this["eStatusOfItemToSelect"]["ACCESSIBLE"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sGetMenuItemStatus"] = 0; };

/**
 * Determines the popup menu item type
 *
 * @private
 * @param {UCF_MenuItem} oMenuItem
 */

UCF_HorizontalContextualPanel_ie6["prototype"]["getMeansOfMenuSelection"] = function(oMenuItemToCheck) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["getMeansOfMenuSelection"]++; }; 

	if (oMenuItemToCheck["oMenu"]["sId"] === this["sPopupMenuId"]) {
		this["oSelectionData"]["sMeansOfSelection"] = this["eMeansOfSelection"]["MAIN_MENU_ITEM"];
	} else if (oMenuItemToCheck["oMenu"]["sId"] !== this["sPopupMenuId"] && oMenuItemToCheck["iIndex"] === 0) {
		this["oSelectionData"]["sMeansOfSelection"] = this["eMeansOfSelection"]["MAIN_MENU_ITEM_IN_SUB_MENU"];
	} else if (oMenuItemToCheck["oMenu"]["sId"] !== this["sPopupMenuId"] && oMenuItemToCheck["iIndex"] !== 0) {
		this["oSelectionData"]["sMeansOfSelection"] = this["eMeansOfSelection"]["SUB_MENU_ITEM"];
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["getMeansOfMenuSelection"] = 0; };

/**
 * Handle MenuItemSelect event
 *
 * @param {UCF_Event} oEvent the event object that occurred
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onMenuItemAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onMenuItemAccess"]++; }; 
	var sLevel, oMenuItemToCheck;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "HorizontalContextualPanel_ie6.js(553): onMenuItemAccess"); };

	oMenuItemToCheck = this["oGetControlById"](oEvent["mParameters"]["sItemId"]);
	this["getMeansOfMenuSelection"](oMenuItemToCheck);
	sLevel = (this["oSelectionData"]["sMeansOfSelection"]["indexOf"](this["eLevel"]["SUB"]) > -1) ? this["eLevel"]["SUB"] : this["eLevel"]["MAIN"];

	switch (this["sEvaluateSelectability"](oMenuItemToCheck, sLevel)) {
		case this["eStatusOfItemToSelect"]["SELECTED_MAIN_MENU_ITEM"]:
		case this["eStatusOfItemToSelect"]["INACCESSIBLE"]:
			this["purgeSelectionData"]();
			return;

		case this["eStatusOfItemToSelect"]["SUBITEMS_NOT_CREATED"]:
			this["createSubItems"](this["oHCNP"]["aMainItems"][oMenuItemToCheck["oMenu"]["oOpenerItem"]["iIndex"]]);

		case this["eStatusOfItemToSelect"]["SELECTED_SUB_MENU_ITEM"]:
		case this["eStatusOfItemToSelect"]["ACCESSIBLE"]:

			if (this["bClientSelect"]) {
				this["collectSelectionData"](oMenuItemToCheck);
				this["switchCheckedMenuItems"](oMenuItemToCheck);
				this["switchSubLevels"]();
				this["adjustHcnpScrollPosition"]();
				this["processGenericTabSwitchSteps"](oEvent);
			} else {
				this["fireSelectEvent"]();
			}
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onMenuItemAccess"] = 0; };

/**
 * Scrolls the seleted item in the view port if it is hidden
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["adjustHcnpScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["adjustHcnpScrollPosition"]++; }; 

	var oSelectionData = this["oSelectionData"];
	var sLevel = null;
	var oData = { 'oMainLevelItem': '', 'oSubLevelItem': '' };

	for (var n in oData) {

		sLevel = n === 'oMainLevelItem' ? this["eLevel"]["MAIN"] : this["eLevel"]["SUB"];

		switch (this["sGetItemScrollPosition"](oSelectionData[n], sLevel)) {
			case this["eItemScrollPosition"]["IN_PREVIOUS_HIDDEN"]:
				this["scrollFromPreviousHiddenToViewPort"](oSelectionData[n], sLevel);
				break;
			case this["eItemScrollPosition"]["IN_NEXT_HIDDEN"]:
				this["scrollFromNextHiddenToViewPort"](oSelectionData[n], sLevel);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["adjustHcnpScrollPosition"] = 0; };

/**
 * Checks the selected item and unchecks the previous selected
 * @private
 * @param {UCF_MenuItem} oMenuItem
 */

UCF_HorizontalContextualPanel_ie6["prototype"]["switchCheckedMenuItems"] = function(oMenuItemToCheck) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["switchCheckedMenuItems"]++; }; 
	var aMenusToUncheck, oSubMenu, oSubMenuItem, oMainMenuItem;

	if (!this["bIsScrollable"]() || !this["bUsePopUpMenu"]) return;

	if (this["oHCNP"]["aSubMenus"]) {
		aMenusToUncheck = this["oHCNP"]["aSubMenus"];
		aMenusToUncheck["push"](this["oHCNP"]["oMainMenu"]);
	} else {
		aMenusToUncheck = [];
		aMenusToUncheck["push"](this["oHCNP"]["oMainMenu"]);
	}

	UCF_JsUtil["forEach"](aMenusToUncheck, function(oMenu) {
		var aItems = oMenu["aGetItems"]();

		UCF_JsUtil["forEach"](aItems, function(oItem) {

			if (oItem["bIsChecked"]())
				oItem["setChecked"](false);
		}, []);

	}, []);

	/* Check Menu Items*/

	switch (this["oSelectionData"]["sMeansOfSelection"]) {
		case this["eMeansOfSelection"]["MAIN_MENU_ITEM"]:
			oMenuItemToCheck["setChecked"](true);
			break;
		case this["eMeansOfSelection"]["SUB_MENU_ITEM"]:
			oMenuItemToCheck["oMenu"]["aGetItems"]()[0]["setChecked"](true);
			oMenuItemToCheck["setChecked"](true);
			break;

		case this["eMeansOfSelection"]["MAIN_MENU_ITEM_IN_SUB_MENU"]:
			var iSelectedSubMenuIndex = this["oHCNP"]["aMainItems"][this["oSelectionData"]["iMainLevelIdx"]]["iSelectedTabMenuIndex"] + 1;
			oSubMenu = oMenuItemToCheck["oMenu"];
			oSubMenuItem = oSubMenu["aGetItems"]()[iSelectedSubMenuIndex];

			oSubMenuItem["setChecked"](true);
			oMenuItemToCheck["setChecked"](true);
			break;

		case this["eMeansOfSelection"]["MAIN_HCNP_ITEM"]:

			if (this["bMainItemHasSubItems"](this["oSelectionData"]["oMainLevelItem"])) {
				oSubMenu = this["oLS"]["oGetControlById"](this["oHCNP"]["oMainMenu"]["aGetItems"]()[this["oSelectionData"]["iMainLevelIdx"]]["sSubMenuId"]);
			}

			oMainMenuItem = (oSubMenu != null) ? oSubMenu["aGetItems"]()[0] : this["oHCNP"]["oMainMenu"]["aGetItems"]()[this["oSelectionData"]["iMainLevelIdx"]];
			oSubMenuItem = (oSubMenu != null) ? oSubMenu["aGetItems"]()[this["oSelectionData"]["oMainLevelItem"]["iSelectedTabMenuIndex"] + 1] : null;

			oMainMenuItem["setChecked"](true);
			if (oSubMenuItem) oSubMenuItem["setChecked"](true);
			break;

		case this["eMeansOfSelection"]["SUB_HCNP_ITEM"]:
			oMainMenuItem = this["oHCNP"]["oMainMenu"]["aGetItems"]()[this["oSelectionData"]["iMainLevelIdx"]];
			var aSubMenuItems = this["oLS"]["oGetControlById"](oMainMenuItem["sSubMenuId"])["aGetItems"]();

			aSubMenuItems[0]["setChecked"](true);
			aSubMenuItems[this["oSelectionData"]["iSubLevelIdx"] + 1]["setChecked"](true);
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["switchCheckedMenuItems"] = 0; };
/**
 * detaches the menu events
 * @param {UCF_Menu} oItemMenu
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["detachEvents"] = function(oItemMenu) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["detachEvents"]++; }; 
	oItemMenu["detachEvent"](oItemMenu["E_EVENTS"]["Select"], self, 'onMenuItemAccess');
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["detachEvents"] = 0; };

/**
 * ############################################################################
 * SECTION THAT ORCHESTRATES THE SCROLLING OF THE ITEMS OF THE DIFFERENT LEVELS
 *
 * SCROLL-LEFT + SCROLL-RIGHT + OPEN-MENU for main- and sub-items
 *
 * All routines handling the interaction on the panel with the scroll-
 * and menu buttons
 *
 * ############################################################################
 */

UCF_HorizontalContextualPanel_ie6["prototype"]["bIsScrollable"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bIsScrollable"]++; }; 
	return window["UCF_System"]["sDevice"] === 'standards' && this["bScrollable"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bIsScrollable"] = 0; };

/**
 * Used for tab item selection through the menu.
 * Scrolls the associated tab item that is in the are of the next
 * items into the view port.
 *
 * @private
 * @param {HCNP_Item}
 * @param {string}
 */

UCF_HorizontalContextualPanel_ie6["prototype"]["scrollFromNextHiddenToViewPort"] = function(oItem, sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["scrollFromNextHiddenToViewPort"]++; }; 

	var oFirstInViewPort = this["oGetFirstItemInViewPort"](sLevel),
		aHcnpItems, oViewPort, i;

	switch (sLevel) {
		case this["eLevel"]["MAIN"]:
			aHcnpItems = this["oHCNP"]["aMainItems"];
			break;
		case this["eLevel"]["SUB"]:
			aHcnpItems = this["oHCNP"]['subItemsOf-' + oItem["oDomRef"]["getAttribute"]('associatedMainItem')];
	}

	if (this["sGetScrollSwitch"](sLevel) === this["eScrollSwitch"]["OFF"]) {
		this["setScrollSwitch"](this["eScrollSwitch"]["ON"], sLevel);
	}

	for (i = oFirstInViewPort["iIndex"]; i < oItem["iIndex"]; i++) {
		if (!this["bIsInNextHiddenItems"](oItem, sLevel)) {
			break;
		}
		UCF_DomUtil["addClass"](aHcnpItems[i]["oDomRef"], this["eStyles"]["HIDDEN_TAB"]);
	}
	oViewPort = oItem["oDomRef"]["parentNode"];
	oViewPort["scrollTop"] = 0;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["scrollFromNextHiddenToViewPort"] = 0; };

/**
 * Used for tab item selection through the menu.
 * Scrolls the associated tab item that is in the are of the previous
 * items into the view port.
 *
 * @private
 * @param {HCNP_Item}
 * @param {string}
 */

UCF_HorizontalContextualPanel_ie6["prototype"]["scrollFromPreviousHiddenToViewPort"] = function(oItem, sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["scrollFromPreviousHiddenToViewPort"]++; }; 

	var oFirstInViewPort = this["oGetFirstItemInViewPort"](sLevel),
		aHcnpItems, i, oViewPort;

	if (oFirstInViewPort["iIndex"] === 0) {
		return;
	}

	switch (sLevel) {
		case this["eLevel"]["MAIN"]:
			aHcnpItems = this["oHCNP"]["aMainItems"];
			break;
		case this["eLevel"]["SUB"]:
			aHcnpItems = this["oHCNP"]['subItemsOf-' + oItem["oDomRef"]["getAttribute"]('associatedMainItem')];
	}

	for (i = oFirstInViewPort["iIndex"] - 1; i >= oItem["iIndex"]; i--) {
		UCF_DomUtil["removeClass"](aHcnpItems[i]["oDomRef"], this["eStyles"]["HIDDEN_TAB"]);
	}

	if (this["sGetScrollSwitch"](sLevel) === this["eScrollSwitch"]["OFF"]) {
		this["setScrollSwitch"](this["eScrollSwitch"]["ON"], sLevel);
	}

	oViewPort = oItem["oDomRef"]["parentNode"];
	oViewPort["scrollTop"] = 0;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["scrollFromPreviousHiddenToViewPort"] = 0; };

/**
 * Finds and returns the first item in the view port depending on the passed on level
 *
 * @param {string} sLevel
 * @return {HCNP_Item}
 * @private
 */
// eslint-disable-next-line consistent-return
UCF_HorizontalContextualPanel_ie6["prototype"]["oGetFirstItemInViewPort"] = function(sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["oGetFirstItemInViewPort"]++; }; 

	var oMainLevelItem = (this["oSelectionData"]["oMainLevelItem"] != null) ? this["oSelectionData"]["oMainLevelItem"] : this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]],
		aItems, i;

	switch (sLevel) {
		case this["eLevel"]["MAIN"]:
			aItems = this["oHCNP"]["aMainItems"];
			break;
		case this["eLevel"]["SUB"]:
			aItems = this["oHCNP"]['subItemsOf-' + oMainLevelItem["sId"]];
	}

	if (this["sGetScrollSwitch"](sLevel) === this["eScrollSwitch"]["OFF"]) {
		// eslint-disable-next-line consistent-return
		return aItems[0];
	}

	for (i = 0; i < aItems["length"]; i++) {
		if (aItems[i]["oDomRef"]["className"]["indexOf"](this["eStyles"]["HIDDEN_TAB"]) < 0) {
			// eslint-disable-next-line consistent-return
			return aItems[i];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["oGetFirstItemInViewPort"] = 0; };

/**
 *
 * Finds and returns the last item in the view port depending on the
 * passed on level
 *
 * @private
 * @param {string} sLevel
 * @retun {UCF_HorizontalContextualPanelItem_standards}
 */
// eslint-disable-next-line consistent-return
UCF_HorizontalContextualPanel_ie6["prototype"]["oGetLastItemInViewPort"] = function(sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["oGetLastItemInViewPort"]++; }; 

	var oMainLevelItem = (this["oSelectionData"]["oMainLevelItem"] != null) ? this["oSelectionData"]["oMainLevelItem"] : this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]],
		aItems, i;

	switch (sLevel) {
		case this["eLevel"]["MAIN"]:
			aItems = this["oHCNP"]["aMainItems"];
			break;
		case this["eLevel"]["SUB"]:
			aItems = this["oHCNP"]['subItemsOf-' + oMainLevelItem["sId"]];
	}

	for (i = aItems["length"] - 1; i >= 0; i--) {
		if (aItems[i]["oDomRef"]["offsetTop"] < aItems[i]["oDomRef"]["offsetHeight"] / 2) {
			return aItems[i];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["oGetLastItemInViewPort"] = 0; };

/**
 * A list of the different levels of the HCNP
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["eLevel"] = {
	"MAIN": 'MAIN',
	"SUB": 'SUB',
	"NONE": 'NONE'
};

/**
 * An enumerations that lists the state of the scrolling mode of the previous items
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["eScrollSwitch"] = {
	"ON": 'ON',
	"OFF": 'OFF'
};

/**
 * Pages to the items that are located before the view port
 * @param {string} sLevel
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["pageToPreviousHcnpItems"] = function(sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["pageToPreviousHcnpItems"]++; }; 

	var aItems = null,
		i,
		oFirstVisible = this["oGetFirstItemInViewPort"](sLevel);

	if (oFirstVisible["iIndex"] === 0) {
		return;
	}

	switch (sLevel) {
		case this["eLevel"]["MAIN"]:
			aItems = this["oHCNP"]["aMainItems"];
			break;
		case this["eLevel"]["SUB"]:
			aItems = this["oHCNP"]['subItemsOf-' + this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]]["sId"]];
	}

	for (i = oFirstVisible["iIndex"]; i >= 0; i--) {
		if (this["bIsInNextHiddenItems"](oFirstVisible, sLevel)) break;

		UCF_DomUtil["removeClass"](aItems[i]["oDomRef"], this["eStyles"]["HIDDEN_TAB"]);
	}

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["pageToPreviousHcnpItems"] = 0; };

/**
 * Pages to the items that are located after the view port
 * @private
 * @param {string} sLevel
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["pageToNextHcnpItems"] = function(sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["pageToNextHcnpItems"]++; }; 

	var aItems = null,
		i,
		oLastInViewPort = this["oGetLastItemInViewPort"](sLevel);

	switch (sLevel) {
		case this["eLevel"]["MAIN"]:
			aItems = this["oHCNP"]["aMainItems"];
			break;
		case this["eLevel"]["SUB"]:
			aItems = this["oHCNP"]['subItemsOf-' + this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]]["sId"]];
	}

	if (oLastInViewPort["iIndex"] === aItems["length"] - 1) {
		return;
	}

	if (this["sGetScrollSwitch"](sLevel) === this["eScrollSwitch"]["OFF"]) {
		this["setScrollSwitch"](this["eScrollSwitch"]["ON"], sLevel);
	}

	for (i = oLastInViewPort["iIndex"]; i >= 0; i--) {
		if (this["bIsInPreviousHiddenItems"](aItems[i], sLevel)) break;
		UCF_DomUtil["addClass"](aItems[i]["oDomRef"], this["eStyles"]["HIDDEN_TAB"]);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["pageToNextHcnpItems"] = 0; };

/**
 * Returns the current scrolling mode of the previous items of the different levels
 * @private
 * @param {string} sLevel
 * @return {string}
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["sGetScrollSwitch"] = function(sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sGetScrollSwitch"]++; }; 
	var oViewPort = null;
	var iIndex = (this["oSelectionData"]["iMainLevelIdx"] != null) ? this["oSelectionData"]["iMainLevelIdx"] : this["iSelectedTabIndex"];

	if (!this["bIsScrollable"]()) {
		return;
	}

	switch (sLevel) {
		case this["eLevel"]["MAIN"]:
			oViewPort = UCF_DomUtil["$"](this["sId"] + '-mainItems');
			break;
		case this["eLevel"]["SUB"]:
			oViewPort = UCF_DomUtil["$"]('subItemsOf-' + this["oHCNP"]["aMainItems"][iIndex]["sId"]);
			break;
	}
	// eslint-disable-next-line consistent-return
	return oViewPort["getAttribute"]('scrolltoprevious')["toUpperCase"]();
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sGetScrollSwitch"] = 0; };

/**
 * Sets scrolling mode of the previous items for the different levels
 * @private
 * @param {string} sMode
 * @param {string} sLevel
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["setScrollSwitch"] = function(sMode, sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["setScrollSwitch"]++; }; 

	var oViewPort = null;
	var oSelected = (this["oSelectionData"]["oMainLevelItem"] != null) ? this["oSelectionData"]["oMainLevelItem"] : this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]];

	if (!this["bIsScrollable"]()) {
		return;
	}

	switch (sLevel) {
		case this["eLevel"]["MAIN"]:
			oViewPort = UCF_DomUtil["$"](this["sId"] + '-mainItems');
			break;
		case this["eLevel"]["SUB"]:
			oViewPort = UCF_DomUtil["$"]('subItemsOf-' + oSelected["sId"]);
			break;
	}

	oViewPort["setAttribute"]('scrolltoprevious', sMode);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["setScrollSwitch"] = 0; };

/**
 * Determines whether an item is not in the view port
 * @private
 * @param {string} sLevel
 * @return {boolean}
 */
// eslint-disable-next-line consistent-return
UCF_HorizontalContextualPanel_ie6["prototype"]["bLastHcnpTabIsInViewPort"] = function(sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bLastHcnpTabIsInViewPort"]++; }; 

	var oSelected = (this["oSelectionData"]["oMainLevelItem"] != null) ? this["oSelectionData"]["oMainLevelItem"] : this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]];

	switch (sLevel) {
		case this["eLevel"]["MAIN"]:
			return !this["bIsInNextHiddenItems"](this["oHCNP"]["aMainItems"][this["oHCNP"]["aMainItems"]["length"] - 1], sLevel);
		case this["eLevel"]["SUB"]:
			return !this["bIsInNextHiddenItems"](this["oHCNP"]['subItemsOf-' + oSelected["sId"]][this["oHCNP"]['subItemsOf-' + oSelected["sId"]]["length"] - 1], sLevel);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bLastHcnpTabIsInViewPort"] = 0; };

/**
 * Determines whether an item is not in the view port
 * @private
 * @param {string} sLevel
 * @return {boolean}
 */
// eslint-disable-next-line consistent-return
UCF_HorizontalContextualPanel_ie6["prototype"]["bFirstHcnpTabIsInViewPort"] = function(sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bFirstHcnpTabIsInViewPort"]++; }; 

	var oSelected = (this["oSelectionData"]["oMainLevelItem"] != null) ? this["oSelectionData"]["oMainLevelItem"] : this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]];

	switch (sLevel) {
		case this["eLevel"]["MAIN"]:
			return !this["bIsInPreviousHiddenItems"](this["oHCNP"]["aMainItems"][0], sLevel);
		case this["eLevel"]["SUB"]:
			return !this["bIsInPreviousHiddenItems"](this["oHCNP"]['subItemsOf-' + oSelected["sId"]][0], sLevel);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bFirstHcnpTabIsInViewPort"] = 0; };

/**
 * Determines whether an item is within the items hidden on the left side
 * @private
 * @param {UCF_Control} oItem
 * @param {string} sLevel
 * @return {boolean}
 */
// eslint-disable-next-line consistent-return
UCF_HorizontalContextualPanel_ie6["prototype"]["bIsInPreviousHiddenItems"] = function(oItem, sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bIsInPreviousHiddenItems"]++; }; 

	var oViewPort = oItem["oDomRef"]["parentNode"],
		iThreshold = oItem["oDomRef"]["offsetHeight"] / 2;

	switch (this["sGetScrollSwitch"](sLevel)) {
		case this["eScrollSwitch"]["ON"]:
			return oItem["oDomRef"]["className"]["indexOf"](this["eStyles"]["HIDDEN_TAB"]) > -1;
		case this["eScrollSwitch"]["OFF"]:
			return oItem["oDomRef"]["offsetTop"] < oViewPort["scrollTop"] - iThreshold;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bIsInPreviousHiddenItems"] = 0; };

/**
 * Determines whether an item is within the items hidden on the right side
 * @private
 * @param {UCF_Control} oItem a HCNP item
 * @param {string} sLevel an enum value from eLevel
 * @return {boolean}
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["bIsInNextHiddenItems"] = function(oItem, sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bIsInNextHiddenItems"]++; }; 

	var oViewPort = oItem["oDomRef"]["parentNode"],
		iThreshold = oItem["oDomRef"]["offsetHeight"] / 2;

	return oItem["oDomRef"]["offsetTop"] > oViewPort["scrollTop"] + iThreshold;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bIsInNextHiddenItems"] = 0; };

/**
 * Determines whether an item is hidden on the left, on the right, or is visible
 * @private
 * @param {UCF_Control} oItem a HCNP item
 * @param {string} sLevel an enum value from eLevel
 * @return {boolean}
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["sGetItemScrollPosition"] = function(oItem, sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sGetItemScrollPosition"]++; }; 

	if (window["UCF_System"]["sDevice"] === 'standards') {
		return;
	}

	if (!this["bIsScrollable"]() || !this["bIsHidden"](oItem, sLevel)) {
		// eslint-disable-next-line consistent-return
		return this["eItemScrollPosition"]["IN_VIEWPORT"];
	}

	if (this["bIsInPreviousHiddenItems"](oItem, sLevel)) {
		// eslint-disable-next-line consistent-return
		return this["eItemScrollPosition"]["IN_PREVIOUS_HIDDEN"];
	}

	if (this["bIsInNextHiddenItems"](oItem, sLevel)) {
		// eslint-disable-next-line consistent-return
		return this["eItemScrollPosition"]["IN_NEXT_HIDDEN"];
	}

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sGetItemScrollPosition"] = 0; };

/**
 * Enumeration that indicates whether a HCNP item is within the viewport or outside
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["eItemScrollPosition"] = {
	"IN_VIEWPORT": 'IN_VIEWPORT',
	"IN_PREVIOUS_HIDDEN": 'IN_PREVIOUS_HIDDEN',
	"IN_NEXT_HIDDEN": 'IN_NEXT_HIDDEN'
};

/**
 * Determines whether an item is not in the view port
 * @private
 * @param {UCF_Control} oItem a HCNP item
 * @param {string} sLevel an enum value from eLevel
 * @return {boolean}
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["bIsHidden"] = function(oItem, sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bIsHidden"]++; }; 
	if (!oItem) {

		return;
	}

	if (!this["bIsScrollable"]()) {
		// eslint-disable-next-line consistent-return
		return false;
	}
	// eslint-disable-next-line consistent-return
	return this["bIsInPreviousHiddenItems"](oItem, sLevel) ||
		this["bIsInNextHiddenItems"](oItem, sLevel);

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bIsHidden"] = 0; };

/**
 * ############################################################################
 *
 *  SECTION RESPONSIBLE FOR THE SELECTION
 *
 * ############################################################################
 */

/**
 * enumeration that lists the different statuses of an
 * HCNP item that is to be selected
 *
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["eStatusOfItemToSelect"] = {
	"ACCESSIBLE": 'ACCESSIBLE',
	"INACCESSIBLE": 'INACCESSIBLE',
	"SELECTED_MAIN_MENU_ITEM": 'SELECTED_MAIN_MENU_ITEM',
	"SELECTED_SUB_MENU_ITEM": 'SELECTED_SUB_MENU_ITEM',
	"SELECTED_HCNP_ITEM": 'SELECTED_HCNP_ITEM',
	"SUBITEMS_NOT_CREATED": 'SUBITEMS_NOT_CREATED'
};

/**
 * enumeration that lists the different statuses of an HCNP item that is
 * to be deselected
 *
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["eStatusOfItemToDeselect"] = {
	"SELECTED": 'SELECTED',
	"DESELECTED": 'DESELECTED',
	"INACCESSIBLE_AND_SELECTED": 'INACCESSIBLE_AND_SELECTED'
};

/**
 * enumeration that lists the different means by which
 * a tab item can be selected
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["eMeansOfSelection"] = {
	"MAIN_HCNP_ITEM": 'MAIN_HCNP_ITEM',
	"SUB_HCNP_ITEM": 'SUB_HCNP_ITEM',
	"MAIN_MENU_ITEM": 'MAIN_MENU_ITEM',
	"SUB_MENU_ITEM": 'SUB_MENU_ITEM',
	"MAIN_MENU_ITEM_IN_SUB_MENU": 'MAIN_MENU_ITEM_IN_SUB_MENU',
	"CALL": 'CALL'
};

/**
 * determines the status of the HCNP item that is to be deselected
 * @param {UCF_Control} oItem
 * @return {string}
 */
// eslint-disable-next-line consistent-return
UCF_HorizontalContextualPanel_ie6["prototype"]["sGetStatusOfHcnpItemToDeselect"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sGetStatusOfHcnpItemToDeselect"]++; }; 

	if (oItem["oDomRef"]["className"]["indexOf"](this["eStyles"]["SUB_ITEM_SELECTED"]) > -1)
		return this["eStatusOfItemToDeselect"]["SELECTED"];

	if (oItem["oDomRef"]["className"]["indexOf"](this["eStyles"]["MAIN_ITEM_SELECTED"]) > -1)
		return this["eStatusOfItemToDeselect"]["SELECTED"];

	if (oItem["oDomRef"]["className"]["indexOf"](this["eStyles"]["SUB_ITEM_DESELECTED"]) > -1)
		return this["eStatusOfItemToDeselect"]["DESELECTED"];

	if (oItem["oDomRef"]["className"]["indexOf"](this["eStyles"]["MAIN_ITEM_DESELECTED"]) > -1)
		return this["eStatusOfItemToDeselect"]["DESELECTED"];

	if (!oItem["bEnabled"] && oItem["sClassName"] === 'UCF_HorizontalContextualPanelItem_ie6' && oItem["iIndex"] === this["iSelectedTabIndex"])
		return this["eStatusOfItemToDeselect"]["INACCESSIBLE_AND_SELECTED"];

	if (!oItem["bEnabled"] && oItem["sClassName"] === 'UCF_HorizontalContextualPanelMenuItem_ie6' && oItem["iIndex"] === this["oHCNP"][this["iSelectedTabIndex"]]["iSelectedTabMenuIndex"])
		return this["eStatusOfItemToDeselect"]["INACCESSIBLE_AND_SELECTED"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sGetStatusOfHcnpItemToDeselect"] = 0; };

/**
 * Returns the status of a HCNP main and sub item
 * @param {HCNP_Item} oItem
 * @param {string} sLevel
 * @return {enum-value}
 * @private
 */
// eslint-disable-next-line consistent-return
UCF_HorizontalContextualPanel_ie6["prototype"]["sGetStatusOfHcnpItemToSelect"] = function(oItem, sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sGetStatusOfHcnpItemToSelect"]++; }; 

	var iSelected = (sLevel === this["eLevel"]["MAIN"]) ? this["iSelectedTabIndex"] : this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]]["iSelectedTabMenuIndex"];

	if (sLevel === this["eLevel"]["MAIN"] && oItem["iIndex"] !== iSelected && this["bMainItemHasSubItems"](oItem) && !this["bSubItemsCreated"](oItem)) {
		return this["eStatusOfItemToSelect"]["SUBITEMS_NOT_CREATED"];
	}

	if (!oItem["bEnabled"] && oItem["iIndex"] === iSelected)
		return this["eStatusOfItemToSelect"]["INACCESSIBLE_AND_SELECTED"];

	if (!oItem["bEnabled"] && oItem["iIndex"] !== iSelected)
		return this["eStatusOfItemToSelect"]["INACCESSIBLE"];

	if (oItem["bEnabled"] && oItem["iIndex"] === iSelected)
		return this["eStatusOfItemToSelect"]["SELECTED"];

	if (oItem["bEnabled"] && oItem["iIndex"] !== iSelected)
		return this["eStatusOfItemToSelect"]["ACCESSIBLE"];

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sGetStatusOfHcnpItemToSelect"] = 0; };

/**
 * It is not possible to rely on the value -1 for the property SelectedTabMenuItemIndex
 * With this helper we look whether items are assinged within the DOM
 *
 * @private
 * @param {UCF_Control} oMainItem
 * @return {boolean}
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["bMainItemHasSubItems"] = function(oMainItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bMainItemHasSubItems"]++; }; 
	return UCF_DomUtil["$"]('subItemsOf-' + oMainItem["sId"])["childNodes"]["length"] > 0;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bMainItemHasSubItems"] = 0; };

/**
 * Checks if the subitems of the HCNP item to be selected have been created
 *
 * @private
 * @param {UCF_Control} oMainItem
 * @return {boolean}
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["bSubItemsCreated"] = function(oMainItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bSubItemsCreated"]++; }; 
	return this["oHCNP"]['subItemsOf-' + oMainItem["sId"]] != null;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["bSubItemsCreated"] = 0; };

/**
 * Returns the index on the main and the index on the sub level of the HCNP that has to be selected
 *
 * @private
 * @param {UCF_Control} oSelectedItem
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["collectSelectionData"] = function(oSelectedItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["collectSelectionData"]++; }; 
	var oData = this["oSelectionData"];

	switch (oData["sMeansOfSelection"]) {
		case this["eMeansOfSelection"]["MAIN_HCNP_ITEM"]:
			oData["iMainLevelIdx"] = oSelectedItem["iIndex"];
			oData["oMainLevelItem"] = oSelectedItem;
			oData["iSubLevelIdx"] = (this["bMainItemHasSubItems"](oData["oMainLevelItem"])) ? oSelectedItem["iSelectedTabMenuIndex"] : -1;
			oData["oSubLevelItem"] = (this["bMainItemHasSubItems"](oData["oMainLevelItem"])) ? this["oHCNP"]['subItemsOf-' + oData["oMainLevelItem"]["sId"]][oData["iSubLevelIdx"]] : null;
			oData["sStatusOfDeselectedItem"] = (this["iSelectedTabIndex"] === -1) ? this["eStatusOfItemToDeselect"]["DESELECTED"] : this["eStatusOfItemToDeselect"]["SELECTED"];
			break;

		case this["eMeansOfSelection"]["SUB_HCNP_ITEM"]:
			oData["iMainLevelIdx"] = this["iSelectedTabIndex"];
			oData["oMainLevelItem"] = this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]];
			oData["iSubLevelIdx"] = oSelectedItem["iIndex"];
			oData["oSubLevelItem"] = oSelectedItem;
			oData["sStatusOfDeselectedItem"] = (oData["oMainLevelItem"]["iSelectedTabMenuIndex"] === -1) ? this["eStatusOfItemToDeselect"]["DESELECTED"] : this["eStatusOfItemToDeselect"]["SELECTED"];
			break;

		case this["eMeansOfSelection"]["MAIN_MENU_ITEM"]:
			oData["iMainLevelIdx"] = oSelectedItem["iIndex"];
			oData["oMainLevelItem"] = this["oHCNP"]["aMainItems"][oData["iMainLevelIdx"]];
			oData["iSubLevelIdx"] = (this["bMainItemHasSubItems"](oData["oMainLevelItem"])) ? this["oHCNP"]["aMainItems"][oSelectedItem["iIndex"]]["iSelectedTabMenuIndex"] : -1;
			oData["sStatusOfDeselectedItem"] = (this["iSelectedTabIndex"] === -1) ? this["eStatusOfItemToDeselect"]["DESELECTED"] : this["eStatusOfItemToDeselect"]["SELECTED"];
			break;

		case this["eMeansOfSelection"]["SUB_MENU_ITEM"]:
			oData["iMainLevelIdx"] = oSelectedItem["oMenu"]["oOpenerItem"]["iIndex"];
			oData["oMainLevelItem"] = this["oHCNP"]["aMainItems"][oData["iMainLevelIdx"]];
			oData["iSubLevelIdx"] = oSelectedItem["iIndex"] - 1;
			oData["oSubLevelItem"] = this["oHCNP"]['subItemsOf-' + oData["oMainLevelItem"]["sId"]][oData["iSubLevelIdx"]];
			oData["sStatusOfDeselectedItem"] = (oData["oMainLevelItem"]["iSelectedTabMenuIndex"] === -1) ? this["eStatusOfItemToDeselect"]["DESELECTED"] : this["eStatusOfItemToDeselect"]["SELECTED"];
			break;

		case this["eMeansOfSelection"]["MAIN_MENU_ITEM_IN_SUB_MENU"]:
			oData["iMainLevelIdx"] = oSelectedItem["oMenu"]["oOpenerItem"]["iIndex"];
			oData["iSubLevelIdx"] = this["oHCNP"]["aMainItems"][oData["iMainLevelIdx"]]["iSelectedTabMenuIndex"];
			oData["oMainLevelItem"] = this["oHCNP"]["aMainItems"][oData["iMainLevelIdx"]];
			oData["oSubLevelItem"] = this["oHCNP"]['subItemsOf-' + oData["oMainLevelItem"]["sId"]][oData["iSubLevelIdx"]];
			oData["sStatusOfDeselectedItem"] = (oData["oMainLevelItem"]["iSelectedTabMenuIndex"] === -1) ? this["eStatusOfItemToDeselect"]["DESELECTED"] : this["eStatusOfItemToDeselect"]["SELECTED"];

	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["collectSelectionData"] = 0; };

/**
 * determines whether a menu- or hcnp item can be accessed
 * @param {HCNP_Item} oItemToSelect
 * @param {enum-value} sLevel
 * @return {enum-value}
 * @private
 */
// eslint-disable-next-line consistent-return
UCF_HorizontalContextualPanel_ie6["prototype"]["sEvaluateSelectability"] = function(oItemToSelect, sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sEvaluateSelectability"]++; }; 

	var oSelectionData = this["oSelectionData"],
		_STATUS_;

	switch (oSelectionData["sMeansOfSelection"]) {

		case this["eMeansOfSelection"]["MAIN_MENU_ITEM"]:
			return this["sGetMenuItemStatus"](oItemToSelect);

		case this["eMeansOfSelection"]["MAIN_MENU_ITEM_IN_SUB_MENU"]:
		case this["eMeansOfSelection"]["SUB_MENU_ITEM"]:

			_STATUS_ = this["sGetMenuItemStatus"](oItemToSelect);

			switch (_STATUS_) {

				case this["eStatusOfItemToSelect"]["SELECTED"]:
				case this["eStatusOfItemToSelect"]["INACCESSIBLE"]:
				case this["eStatusOfItemToSelect"]["INACCESSIBLE_AND_SELECTED"]:
					return _STATUS_;

				case this["eStatusOfItemToSelect"]["ACCESSIBLE"]:
					var iIndex = oItemToSelect["oMenu"]["oOpenerItem"]["iIndex"];

					if (this["bSubItemsCreated"](this["oHCNP"]["aMainItems"][iIndex])) {
						return _STATUS_;
					} else {
						return this["eStatusOfItemToSelect"]["SUBITEMS_NOT_CREATED"];
					}
			}
			break;

		case this["eMeansOfSelection"]["MAIN_HCNP_ITEM"]:
			return this["sGetStatusOfHcnpItemToSelect"](oItemToSelect, this["eLevel"]["MAIN"]);

		case this["eMeansOfSelection"]["SUB_HCNP_ITEM"]:
			return this["sGetStatusOfHcnpItemToSelect"](oItemToSelect, this["eLevel"]["SUB"]);
	}

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["sEvaluateSelectability"] = 0; };

/**
 * Returns the HCNP items that correspond with a certain menu item
 * @private
 * @param {UCF_PopupMenuItem} oMenuItem
 * @return {Object}
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["oGetHcnpItemsFromMenuItem"] = function(oMenuItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["oGetHcnpItemsFromMenuItem"]++; }; 

	var oItems = { 'oMainItem': '', 'oSubItem': '' },
		iIndex;

	switch (this["oSelectionData"]["sMeansOfSelection"]) {

		case this["eMeansOfSelection"]["MAIN_MENU_ITEM"]:
			oItems["oMainItem"] = this["oHCNP"]["aMainItems"][oMenuItem["iIndex"]];
			oItems["oSubItem"] = null;
			break;

		case this["eMeansOfSelection"]["MAIN_MENU_ITEM_IN_SUB_MENU"]:
		case this["eMeansOfSelection"]["SUB_MENU_ITEM"]:

			iIndex = oMenuItem["oMenu"]["oOpenerItem"]["iIndex"];
			oItems["oMainItem"] = this["oHCNP"]["aMainItems"][iIndex];

			if (this["bMainItemHasSubItems"](oItems["oMainItem"])) {
				oItems["oSubItem"] = this["oHCNP"]['subItemsOf-' + oItems["oMainItem"]["sId"]][oItems["oMainItem"]["iSelectedTabMenuIndex"]];
			} else {
				oItems["oSubItem"] = null;
			}
	}

	return oItems;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["oGetHcnpItemsFromMenuItem"] = 0; };

/**
 * Returns the menu items that correspond with a certain HCNP item
 * @private
 * @param {UCF_Control} oHcnpItem
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["oGetMenuItemFromHcnpItem"] = function(oHcnpItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["oGetMenuItemFromHcnpItem"]++; }; 
	switch (this["oSelectionData"]["sMeansOfSelection"]) {
		case this["eMeansOfSelection"]["MAIN_HCNP_ITEM"]:
		case this["eMeansOfSelection"]["SUB_HCNP_ITEM"]:
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["oGetMenuItemFromHcnpItem"] = 0; };

/**
 * Finds the HCNP item to be deselected and stores it with the selection data.
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["collectItemsToDeselect"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["collectItemsToDeselect"]++; }; 

	var oSelectionData = this["oSelectionData"];

	if (oSelectionData["sStatusOfDeselectedItem"] === this["eStatusOfItemToDeselect"]["DESELECTED"]) {
		return;
	}

	switch (this["oSelectionData"]["sMeansOfSelection"]) {
		case this["eMeansOfSelection"]["MAIN_MENU_ITEM"]:
		case this["eMeansOfSelection"]["MAIN_MENU_ITEM_IN_SUB_MENU"]:
		case this["eMeansOfSelection"]["MAIN_HCNP_ITEM"]:
			this["oSelectionData"]["oItemToDeselect"] = this["oHCNP"][this["iSelectedTabIndex"]];
			break;
		case this["eMeansOfSelection"]["SUB_MENU_ITEM"]:
		case this["eMeansOfSelection"]["SUB_HCNP_ITEM"]:
			this["oSelectionData"]["oItemToDeselect"] = this["oHCNP"]['subItemsOf-' + oSelectionData["oMainLevelItem"]["sId"]][oSelectionData["oMainLevelItem"]["iSelectedTabMenuIndex"]];
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["collectItemsToDeselect"] = 0; };

/**
 * everything that needs to be done when a HCNP item on main level is selected
 * @private
 * @param {Event} oEvent
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onMainItemAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onMainItemAccess"]++; }; 

	var oItemToSelect = (oEvent["mParameters"]) ? oEvent["mParameters"]["oItem"] : oEvent["oSourceControl"];
	this["oSelectionData"]["sMeansOfSelection"] = this["eMeansOfSelection"]["MAIN_HCNP_ITEM"];

	if (this["oHCNP"]["oMainMenu"] === null && this["bIsScrollable"]() && this["bUsePopUpMenu"]) {
		this["createMainMenu"]();

		if (this["bMainItemHasSubItems"](oItemToSelect))
			this["createSubMenus"]();
	}

	switch (this["sEvaluateSelectability"](oItemToSelect, this["eLevel"]["MAIN"])) {

		case this["eStatusOfItemToSelect"]["SUBITEMS_NOT_CREATED"]:
			this["createSubItems"](oItemToSelect);
		case this["eStatusOfItemToSelect"]["ACCESSIBLE"]:
			this["collectSelectionData"](oItemToSelect, this["oSelectionData"]["sMeansOfSelection"]);

			if (this["bClientSelect"]) {
				this["switchSubLevels"]();
				this["switchCheckedMenuItems"]();
				this["adjustHcnpScrollPosition"]();
				this["processGenericTabSwitchSteps"](oEvent);
			} else {
				this["fireSelectEvent"]();
			}
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onMainItemAccess"] = 0; };

/**
 * everything that needs to be done when a HCNP item on sub level is selected
 * @private
 * @param {Event} oEvent
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onSubItemAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onSubItemAccess"]++; }; 

	var oItemToSelect = (oEvent["mParameters"]) ? oEvent["mParameters"]["oItem"] : oEvent["oSourceControl"];

	this["oSelectionData"]["sMeansOfSelection"] = this["eMeansOfSelection"]["SUB_HCNP_ITEM"];
	this["collectSelectionData"](oItemToSelect, this["oSelectionData"]["sMeansOfSelection"]);

	if (this["oHCNP"]["oMainMenu"] === null && this["bIsScrollable"]() && this["bUsePopUpMenu"]) {
		this["createMainMenu"]();
		this["createSubMenus"]();
	}

	if (this["sEvaluateSelectability"](oItemToSelect, this["eLevel"]["SUB"]) === this["eStatusOfItemToSelect"]["ACCESSIBLE"]) {
		if (this["bClientSelect"]) {
			this["switchCheckedMenuItems"]();
			this["switchSubLevels"]();
			this["processGenericTabSwitchSteps"](oEvent);
		} else {
			this["fireSelectEvent"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onSubItemAccess"] = 0; };

/**
 * everything that needs to be done when a HCNP item is selected
 * @public
 * @param { UCF_HorizontalContextualPanelItem_ie6 } oItem
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["select"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["select"]++; }; 
	this["oSelectionData"]["sMeansOfSelection"] = this["eMeansOfSelection"]["MAIN_HCNP_ITEM"];
	this["collectSelectionData"](oItem);

	switch (oItem["sClassName"]) {
		case 'UCF_HorizontalContextualPanelItem_ie6':
			this["mainItemClientSelect"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["select"] = 0; };

UCF_HorizontalContextualPanel_ie6["prototype"]["mainItemClientSelect"] = function(oItemToSelect) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["mainItemClientSelect"]++; }; 

	if (this["bClientSelect"]) {
		this["adjustHcnpScrollPosition"]();
		this["performSelection"]();
		this["performDeselection"]();
		this["updateActionButtons"]();
		oItemToSelect["moveFocus"](true); // jo: set focus synchronously to update indices for select event!
		UCF_DomUtil["setTabIndex"](this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]]["oFocusDomRef"], -1);
		// this.updateAriaSelectionProperties();
		this["updateSelectionIndeces"]();
		this["fireSelectEvent"]();
		this["purgeSelectionData"]();
	} else {
		this["fireSelectEvent"]();
	}

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["mainItemClientSelect"] = 0; };

/**
 * The modulised selection steps shared by all means of selection
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["processGenericTabSwitchSteps"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["processGenericTabSwitchSteps"]++; }; 
	this["performSelection"]();
	this["performDeselection"]();
	this["updateActionButtons"]();
	this["focusByMeansOfSelection"](oEvent);
	this["unFocusByMeansOfSelection"]();
	// this.updateAriaSelectionProperties();
	this["updateSelectionIndeces"]();
	this["fireSelectEvent"]();
	this["purgeSelectionData"]();
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["processGenericTabSwitchSteps"] = 0; };

/**
 * The updates all ARIA properties
 * @private
 */
// UCF_HorizontalContextualPanel_ie6.prototype.updateAriaSelectionProperties = function() {

// 	var oSelectedItem, oDeselectedItem, oItemNavigation;

// 	switch (this.oSelectionData.sMeansOfSelection) {
// 		case this.eMeansOfSelection.MAIN_HCNP_ITEM:
// 		case this.eMeansOfSelection.MAIN_MENU_ITEM:
// 			oSelectedItem = this.oSelectionData.oMainLevelItem;
// 			if (this.iSelectedTabIndex > -1) {
// 				oDeselectedItem = this.oHCNP.aMainItems[this.iSelectedTabIndex];
// 				UCF_AriaStateHelper.setSelected(oDeselectedItem.oFocusDomRef, false);
// 			}
// 			oItemNavigation = this.oItemNavigation.oMainItems;
// 			UCF_AriaStateHelper.setActivedescendant(oItemNavigation.oItemContainer, oSelectedItem.sId);
// 			UCF_AriaStateHelper.setSelected(oSelectedItem.oFocusDomRef, true);
// 			break;

// 		case this.eMeansOfSelection.SUB_HCNP_ITEM:
// 		case this.eMeansOfSelection.SUB_MENU_ITEM:
// 			var aSubItems = this.oHCNP['subItemsOf-' + this.oHCNP.aMainItems[this.iSelectedTabIndex].sId];
// 			if (aSubItems) {
// 				var sMainItemId = this.oHCNP.aMainItems[this.iSelectedTabIndex].sId;
// 				var iSelectedTabMenuIndex = this.oHCNP.aMainItems[this.iSelectedTabIndex].iSelectedTabMenuIndex;
// 				aSubItems = this.oHCNP['subItemsOf-' + sMainItemId];
// 				oSelectedItem = this.oSelectionData.oSubLevelItem;
// 				if (iSelectedTabMenuIndex > -1) {
// 					oDeselectedItem = aSubItems[iSelectedTabMenuIndex];
// 					UCF_AriaStateHelper.setSelected(oDeselectedItem.oFocusDomRef, false);
// 				}
// 				oItemNavigation = this.oItemNavigation['subItemsOf-' + sMainItemId];
// 				UCF_AriaStateHelper.setSelected(oSelectedItem.oFocusDomRef, true);
// 				UCF_AriaStateHelper.setActivedescendant(oItemNavigation.oItemContainer, oSelectedItem.sId);
// 			}
// 	}
// };

/**
 *
 * Collects and assigns the right IDs to the semantic SELECT event
 * and fires it
 *
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["fireSelectEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["fireSelectEvent"]++; }; 
	if (this["bIsScrollable"]()) {
		this["fireSelect"](this["sId"],
			this["oSelectionData"]["oMainLevelItem"]["sId"],
			this["oSelectionData"]["oSubLevelItem"] ? this["oSelectionData"]["oSubLevelItem"]["sId"] : '',
			this["oGetFirstItemInViewPort"](this["eLevel"]["MAIN"])["iIndex"],
			this["oSelectionData"]["oSubLevelItem"] ? this["oGetFirstItemInViewPort"](this["eLevel"]["MAIN"])["iIndex"] : -1);
	} else {

		var oItemToSelect = null;

		switch (this["oSelectionData"]["sMeansOfSelection"]) {
			case this["eMeansOfSelection"]["MAIN_HCNP_ITEM"]:
				oItemToSelect = this["oSelectionData"]["oMainLevelItem"];
				break;

			case this["eMeansOfSelection"]["SUB_HCNP_ITEM"]:
				oItemToSelect = this["oSelectionData"]["oSubLevelItem"];
				break;

		}
		this["fireSelect"](this["sId"], oItemToSelect["sId"], '', 0, -1);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["fireSelectEvent"] = 0; };

/**
 * assigns all necessary styles to an hcnp item so as to reflect selection
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["performSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["performSelection"]++; }; 
	/** @type {Object} */
	var oSelectionData = this["oSelectionData"];
	/** @type {HTML_Element} */
	var oAngleAtEnd;
	/** @type {Array} */
	var aAngles;
	/** @type {HTML_Element} */
	var oAngleAtStart;
	/** @type {HTML_Element} */
	var oTitle;
	/** @type {function} */
	var bIsFirst;
	/** @type {UCF_HorizontalContextualPanel_ie6} */
	var self;

	if (oSelectionData["iMainLevelIdx"] !== null && oSelectionData["iMainLevelIdx"] > -1 && this["iSelectedTabIndex"] !== oSelectionData["iMainLevelIdx"]) {

		oAngleAtEnd = oSelectionData["oMainLevelItem"]["oDomRef"];
		aAngles = oAngleAtEnd["childNodes"];
		oAngleAtStart = aAngles[0];
		oTitle = aAngles[1];
		self = this;

		bIsFirst = function() {
			var oFirst = self["oGetFirstItemInViewPort"](self["eLevel"]["MAIN"]);
			return oSelectionData["iMainLevelIdx"] === 0 || oSelectionData["oMainLevelItem"]["iIndex"] === oFirst["iIndex"];
		};

		if (bIsFirst()) {
			UCF_DomUtil["replaceClass"](oAngleAtStart, oAngleAtStart["className"], this["eStyles"]["FIRST_ITEM_LEFT_ANGLE_SELECTED"]);
		} else {
			UCF_DomUtil["replaceClass"](oAngleAtStart, this["eStyles"]["LEFT_ANGLE_DESELECTED"], this["eStyles"]["LEFT_ANGLE_SELECTED"]);
		}

		UCF_DomUtil["replaceClass"](oAngleAtEnd, this["eStyles"]["RIGHT_ANGLE_DESELECTED"], this["eStyles"]["RIGHT_ANGLE_SELECTED"]);
		UCF_DomUtil["replaceClass"](oTitle, this["eStyles"]["TITLE_DESELECTED"], this["eStyles"]["TITLE_SELECTED"]);
	}

	if (oSelectionData["oSubLevelItem"] && oSelectionData["iSubLevelIdx"] != null && oSelectionData["iSubLevelIdx"] > -1) {

		var oSubItem = oSelectionData["oSubLevelItem"]["oDomRef"]["firstChild"];
		UCF_DomUtil["replaceClass"](oSubItem, this["eStyles"]["SUB_ITEM_DESELECTED"], this["eStyles"]["SUB_ITEM_SELECTED"]);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["performSelection"] = 0; };

/**
 * assigns all necessary styles to an hcnp item so as to reflect de-selection
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["performDeselection"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["performDeselection"]++; }; 
	/** @type {Object} */
	var oSelectionData = this["oSelectionData"];
	/** @type {HTML_Element} */
	var oAngleAtEnd;
	/** @type {Array} */
	var aAngles;
	/** @type {HTML_Element} */
	var oAngleAtStart;
	/** @type {HTML_Element} */
	var oTitle;
	/** @type {UCF_HorizontalContextualPanel_ie6} */
	var self;
	/** @type {function} */
	var bIsFirst;

	if (oSelectionData["sStatusOfDeselectedItem"] === this["eStatusOfItemToDeselect"]["DESELECTED"]) return;

	if (this["iSelectedTabIndex"] != null && this["iSelectedTabIndex"] > -1 && oSelectionData["iMainLevelIdx"] !== this["iSelectedTabIndex"]) {

		oAngleAtEnd = this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]]["oDomRef"];
		aAngles = oAngleAtEnd["childNodes"];
		oAngleAtStart = aAngles[0];
		oTitle = aAngles[1];
		self = this;
		bIsFirst = function() {
			var oFirst = self["oGetFirstItemInViewPort"](self["eLevel"]["MAIN"]);
			return self["iSelectedTabIndex"] === 0 || self["iSelectedTabIndex"] === oFirst["iIndex"];
		};

		if (bIsFirst()) {
			UCF_DomUtil["replaceClass"](oAngleAtStart, oAngleAtStart["className"], this["eStyles"]["FIRST_ITEM_LEFT_ANGLE_DESELECTED"]);
		} else {
			UCF_DomUtil["replaceClass"](oAngleAtStart, this["eStyles"]["LEFT_ANGLE_SELECTED"], this["eStyles"]["LEFT_ANGLE_DESELECTED"]);
		}

		UCF_DomUtil["replaceClass"](oAngleAtEnd, this["eStyles"]["RIGHT_ANGLE_SELECTED"], this["eStyles"]["RIGHT_ANGLE_DESELECTED"]);

		if (this["sGetStatusOfHcnpItemToDeselect"](this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]]) === this["eStatusOfItemToDeselect"]["INACCESSIBLE_AND_SELECTED"]) {
			UCF_DomUtil["replaceClass"](oTitle, this["eStyles"]["TITLE_DISABLED_AND_SELECTED"], this["eStyles"]["TITLE_DISABLED"]);
		} else {
			UCF_DomUtil["replaceClass"](oTitle, this["eStyles"]["TITLE_SELECTED"], this["eStyles"]["TITLE_DESELECTED"]);
		}

	}

	if (oSelectionData["iSubLevelIdx"] != null && oSelectionData["iSubLevelIdx"] > -1) {

		if (oSelectionData["oMainLevelItem"]["iSelectedTabMenuIndex"] !== oSelectionData["iSubLevelIdx"]) {

			var aSubItems = this["oHCNP"]['subItemsOf-' + oSelectionData["oMainLevelItem"]["sId"]],
				oDomRef = aSubItems[oSelectionData["oMainLevelItem"]["iSelectedTabMenuIndex"]]["oDomRef"]["firstChild"];

			UCF_DomUtil["replaceClass"](oDomRef, this["eStyles"]["SUB_ITEM_SELECTED"], this["eStyles"]["SUB_ITEM_DESELECTED"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["performDeselection"] = 0; };

/**
 * shows the sub items of a main hcnp item if there are any
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["switchSubLevels"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["switchSubLevels"]++; }; 

	var oSelectionData = this["oSelectionData"],
		oItemToCheck = (this["oSelectionData"]["oMainLevelItem"] != null) ? this["oSelectionData"]["oMainLevelItem"] : this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]];;

	if (this["iSelectedTabIndex"] === oSelectionData["iMainLevelIdx"]) return;

	var oSubContainerToShow = UCF_DomUtil["$"]('subItemsOf-' + this["oHCNP"]["aMainItems"][oSelectionData["iMainLevelIdx"]]["sId"]);
	oSubContainerToShow["style"]["display"] = (this["bMainItemHasSubItems"](oSelectionData["oMainLevelItem"])) ? '' : 'none';

	if (this["iSelectedTabIndex"] > -1) {
		var oSubContainerToHide = UCF_DomUtil["$"]('subItemsOf-' + this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]]["sId"]);
		oSubContainerToHide["style"]["display"] = 'none';
	}

	if (this["bIsScrollable"]()) {
		if (this["bMainItemHasSubItems"](oItemToCheck)) {
			UCF_DomUtil["oGetParentElement"](this["aActionItems"][2]['PREV_BTN_SUB'])["className"] = 'lsScrollBtnContainerLeft lsMirrorRtl urHcnpTabBottomDivider2 lsHcnp-ActBtnCnt';
			UCF_DomUtil["oGetParentElement"](this["aActionItems"][3]['NEXT_BTN_SUB'])["className"] = 'lsScrollBtnContainerRight urHcnpTabBottomDivider2  lsHcnp-ActBtnCnt';
		} else {
			UCF_DomUtil["oGetParentElement"](this["aActionItems"][2]['PREV_BTN_SUB'])["className"] = 'lsScrollBtnContainerLeft lsMirrorRtl';
			UCF_DomUtil["oGetParentElement"](this["aActionItems"][3]['NEXT_BTN_SUB'])["className"] = 'lsScrollBtnContainerRight';
		}
	}

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["switchSubLevels"] = 0; };

/**
 * updates all properties of the HCNP that are necessary for selectability
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["updateSelectionIndeces"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["updateSelectionIndeces"]++; }; 

	var oSelectionData = this["oSelectionData"];
	this["iSelectedTabIndex"] = oSelectionData["iMainLevelIdx"];
	this["setClientProperty"]("SelectedTabIndex", oSelectionData["iMainLevelIdx"], true);

	if (oSelectionData["iSubLevelIdx"] != null && oSelectionData["iSubLevelIdx"] > -1) {
		this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]]["setClientProperty"]("SelectedTabMenuIndex", oSelectionData["iSubLevelIdx"], true);
		this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]]["iSelectedTabMenuIndex"] = oSelectionData["iSubLevelIdx"];
	}

	switch (oSelectionData["sMeansOfSelection"]) {
		case this["eMeansOfSelection"]["MAIN_MENU_ITEM"]:
			this["oItemNavigation"]["oMainItems"]["iSelectedIndex"] = oSelectionData["iMainLevelIdx"];
			this["oItemNavigation"]["oMainItems"]["iFocusedIndex"] = oSelectionData["iMainLevelIdx"];
			break;
		case this["eMeansOfSelection"]["SUB_MENU_ITEM"]:
			this["oItemNavigation"]['subItemsOf-' + oSelectionData["oMainLevelItem"]["sId"]]["iSelectedIndex"] = oSelectionData["iSubLevelIdx"];
			this["oItemNavigation"]['subItemsOf-' + oSelectionData["oMainLevelItem"]["sId"]]["iFocusedIndex"] = oSelectionData["iSubLevelIdx"];
			this["oItemNavigation"]["oMainItems"]["iFocusedIndex"] = oSelectionData["iMainLevelIdx"];
			this["oItemNavigation"]["oMainItems"]["iSelectedIndex"] = oSelectionData["iMainLevelIdx"];
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["updateSelectionIndeces"] = 0; };

/**
 * removes the sored data so as to avoid interference with the next client-side selection
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["purgeSelectionData"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["purgeSelectionData"]++; }; 
	this["oSelectionData"]["sMeansOfSelection"] = null;
	this["oSelectionData"]["oMainLevelItem"] = null;
	this["oSelectionData"]["oSubLevelItem"] = null;
	this["oSelectionData"]["iMainLevelIdx"] = null;
	this["oSelectionData"]["iSubLevelIdx"] = null;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["purgeSelectionData"] = 0; };

/**#####################################################################################
 *
 *  SECTION WHERE ALL HCNP STYLES ARE MAINTAINED
 *
 * #####################################################################################
 * */

/**
 * A list of all objects along with their states that require styles
 *
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["eStyles"] = {

	"TITLE_SELECTED": 'lsHcnpTabText2Sel',
	"TITLE_DESELECTED": 'lsHcnpTabText2',
	"TITLE_DISABLED": 'lsHcnpTabText2Dsbl',
	"TITLE_DISABLED_AND_SELECTED": 'lsHcnpTabText3SelDsbl',

	"FIRST_ITEM_LEFT_ANGLE_SELECTED": 'lsHcnpfirstAng3Sel',
	"FIRST_ITEM_LEFT_ANGLE_DESELECTED": 'lsHcnpfirstAng3',

	"LEFT_ANGLE_SELECTED": 'lsHcnpTabStart2Sel',
	"LEFT_ANGLE_DESELECTED": 'lsHcnpTabStart2',

	"RIGHT_ANGLE_SELECTED": 'lsHcnpTabEnd3Sel',
	"RIGHT_ANGLE_DESELECTED": 'lsHcnpTabEnd3',

	"SUB_ITEM_SELECTED": 'lsHcnpMenu3Sel',
	"SUB_ITEM_DESELECTED": 'lsHcnpMenu3',

	"PREV_BTN_MAIN_OFF": 'lsHcnp-PageToPrevMainOff',
	"NEXT_BTN_MAIN_OFF": 'lsHcnp-PageToNextMainOff',
	"PREV_BTN_MAIN_ON": 'lsHcnp-PageToPrevMainOn',
	"NEXT_BTN_MAIN_ON": 'lsHcnp-PageToNextMainOn',
	"PREV_BTN_SUB_OFF": 'lsHcnp-PageToPrevSubOff',
	"NEXT_BTN_SUB_OFF": 'lsHcnp-PageToNextSubOff',
	"PREV_BTN_SUB_ON": 'lsHcnp-PageToPrevSubOn',
	"NEXT_BTN_SUB_ON": 'lsHcnp-PageToNextSubOn',
	"MENU_BTN_OFF": 'lsHcnp-MenuOff',
	"MENU_BTN_ON": 'lsHcnp-MenuOn',

	"HIDDEN_TAB": 'lsHcnp-ItemHidden'

};

/**#####################################################################################

 * SECTION THAT HANDLES RESIZING

 * #####################################################################################
 * */

/**
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onresize"]++; }; 

	if (!this["bIsScrollable"]()) return;

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oDomRef"]) {

		if (this["sTimeOutId"] != null) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResize');
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onresize"] = 0; };

/**
 * This function is called after resizing has finished
 *
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onAfterResize"]++; }; 

	if (!this["bIsValid"]() || this["iWidth"] === this["oDomRef"]["offsetWidth"]) return;

	this["updateActionButtons"]();
	this["iWidth"] = this["oDomRef"]["offsetWidth"];

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onAfterResize"] = 0; };

/**########################################################################
 *
 * SECTION THAT HANDLES ACCESS KEYS
 *
 * #######################################################################
 **/

UCF_HorizontalContextualPanel_ie6["prototype"]["onMainItemActivate"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onMainItemActivate"]++; }; 
	var oBrowserEvent = oEvent["mParameters"]["oBrowserEvent"];
	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ACCESS_KEY"];
	this["oNavigationData"]["oSourceControl"] = oBrowserEvent["oSourceControl"];
	this["scrollFocusedIntoViewPort"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onMainItemActivate"] = 0; };

UCF_HorizontalContextualPanel_ie6["prototype"]["onSubItemActivate"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onSubItemActivate"]++; }; 
	var oBrowserEvent = oEvent["mParameters"]["oBrowserEvent"];
	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ACCESS_KEY"];
	this["oNavigationData"]["oSourceControl"] = oBrowserEvent["oSourceControl"];
	this["scrollFocusedIntoViewPort"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onSubItemActivate"] = 0; };
/**#####################################################################################

 * SECTION THAT HANDLES FOCUS NAVIGATION

 * ##################################################################################### * */

UCF_HorizontalContextualPanel_ie6["prototype"]["onlsfocus"] = function(oBowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsfocus"]++; }; 

	if (oBowserEvent["oSource"]["className"]["indexOf"]('Btn') > -1 ||
		this["oNavigationData"]["sMeansOfFocusNavigation"] === this["eMeansOfFocusNavigation"]["NONE"]) return;
	this["scrollFocusedIntoViewPort"](oBowserEvent);

	this["oNavigationData"]["sMeansOfFocusNavigation"] = '';
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsfocus"] = 0; };

/**
 * An enumeration with all types of focus navigation
 *
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["eMeansOfFocusNavigation"] = {
	"ARROW_NAVIGATION": 'ARROW_NAVIGATION',
	"TAB_NAVIGATION": 'TAB_NAVIGATION',
	"ITEM_SCROLLING": 'ITEM_SCROLLING',
	"ACCESS_KEY": 'ACCESS_KEY',
	"NONE": 'NONE'
};

/**
 * Moves the focus to the element that is to be focused.
 *
 * @param {UCF_Event} oEvent the browser event object, that occurred
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["focusByMeansOfSelection"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["focusByMeansOfSelection"]++; }; 
	/** @type {UCF_HorizontalContextualPanelItem_ie6} */
	var oMainLevelSelected;
	/** @type {UCF_HorizontalContextualPanelMenuItem_ie6} */
	var oSubLevelSelected;

	if (oEvent === 'undefined'
		|| oEvent === undefined
		|| oEvent === null) return;

	/**
	 * @return {string}
	 * @param {UCF_Event} oEvent
	 * @private
	 */
	function sGetEventType(oEvent) {
		if (oEvent["sName"]) {
			return oEvent["sName"];
		} else if (oEvent["mGetParameters"]) {
			return oEvent["mGetParameters"]()["oBrowserEvent"]["sName"];
		} else {
			return 'NONE';
		}
	}

	oMainLevelSelected = this["oSelectionData"]["oMainLevelItem"];
	oSubLevelSelected = this["oSelectionData"]["oSubLevelItem"];

	switch (this["oSelectionData"]["sMeansOfSelection"]) {
		case this["eMeansOfSelection"]["MAIN_MENU_ITEM_IN_SUB_MENU"]:
		case this["eMeansOfSelection"]["MAIN_MENU_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelSelected["oFocusDomRef"], 0);
			if (sGetEventType(oEvent) !== 'click')
				oMainLevelSelected["moveFocus"]();
			break;

		case this["eMeansOfSelection"]["SUB_MENU_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelSelected["oFocusDomRef"], 0);
			UCF_DomUtil["setTabIndex"](oSubLevelSelected["oFocusDomRef"], 0);
			if (sGetEventType(oEvent) !== 'click')
				oSubLevelSelected["moveFocus"]();
			break;

		case this["eMeansOfSelection"]["MAIN_HCNP_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelSelected["oFocusDomRef"], 0);
			if (sGetEventType(oEvent) !== 'click')
				oMainLevelSelected["moveFocus"]();
			break;

		case this["eMeansOfSelection"]["SUB_HCNP_ITEM"]:
			UCF_DomUtil["setTabIndex"](oSubLevelSelected["oFocusDomRef"], 0);
			if (sGetEventType(oEvent) !== 'click')
				oSubLevelSelected["moveFocus"]();
	}

	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["SELECTION"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["focusByMeansOfSelection"] = 0; };

/**
 * Removes the tabIndex
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["unFocusByMeansOfSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["unFocusByMeansOfSelection"]++; }; 

	if (this["oSelectionData"]["sStatusOfDeselectedItem"] === this["eStatusOfItemToDeselect"]["DESELECTED"]) return;

	var oMainLevelDeselected = this["oHCNP"]["aMainItems"][this["iSelectedTabIndex"]]["oFocusDomRef"],
		oSubLevelDeselected = null;

	if (this["oSelectionData"]["oSubLevelItem"] != null) {
		oSubLevelDeselected = this["oHCNP"]['subItemsOf-' + this["oSelectionData"]["oMainLevelItem"]["sId"]][this["oSelectionData"]["oMainLevelItem"]["iSelectedTabMenuIndex"]]["oFocusDomRef"];
	}

	switch (this["oSelectionData"]["sMeansOfSelection"]) {
		case this["eMeansOfSelection"]["MAIN_HCNP_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelDeselected, -1);
			break;

		case this["eMeansOfSelection"]["SUB_HCNP_ITEM"]:
			UCF_DomUtil["setTabIndex"](oSubLevelDeselected, -1);
			break;

		case this["eMeansOfSelection"]["MAIN_MENU_ITEM_IN_SUB_MENU"]:
		case this["eMeansOfSelection"]["MAIN_MENU_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelDeselected, -1);
			break;

		case this["eMeansOfSelection"]["SUB_MENU_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelDeselected, -1);
			UCF_DomUtil["setTabIndex"](oSubLevelDeselected, -1);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["unFocusByMeansOfSelection"] = 0; };

/**
 * Collects and returns all object and information that is necessary during
 * focus navigation depending on the level where focus navigation occurs
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["collectNavigationData"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["collectNavigationData"]++; }; 

	var oSourceControl = oBrowserEvent["oSourceControl"];
	this["oNavigationData"]["oSourceControl"] = oSourceControl;
	this["oNavigationData"]["oViewPort"] = oSourceControl["oDomRef"]["parentNode"];

	switch (oSourceControl["sClassName"]) {
		case 'UCF_HorizontalContextualPanelItem_ie6':
			this["oNavigationData"]["sLevel"] = this["eLevel"]["MAIN"];
			this["oNavigationData"]["iFocusedIndex"] = this["oItemNavigation"]["oMainItems"]["iFocusedIndex"];
			this["oNavigationData"]["aNavItems"] = this["oItemNavigation"]["oMainItems"]["aItems"];
			this["oNavigationData"]["aHcnpItems"] = this["oHCNP"]["aMainItems"];
			this["oNavigationData"]["oFirstItemInViewPort"] = (this["bIsScrollable"]()) ? this["oGetFirstItemInViewPort"](this["oNavigationData"]["sLevel"]) : this["oHCNP"]["aMainItems"][0];
			this["oNavigationData"]["oLastItemInViewPort"] = (this["bIsScrollable"]()) ? this["oGetLastItemInViewPort"](this["oNavigationData"]["sLevel"]) : this["oHCNP"]["aMainItems"][this["oHCNP"]["aMainItems"]["length"] - 1];
			this["oNavigationData"]["oItemNavigation"] = this["oItemNavigation"]["oMainItems"];
			break;

		case 'UCF_HorizontalContextualPanelMenuItem_ie6':
			this["oNavigationData"]["sLevel"] = this["eLevel"]["SUB"];
			this["oNavigationData"]["sMainItemId"] = oSourceControl["oDomRef"]["getAttribute"]('associatedMainItem');
			this["oNavigationData"]["iFocusedIndex"] = this["oItemNavigation"]['subItemsOf-' + this["oNavigationData"]["sMainItemId"]]["iFocusedIndex"];
			this["oNavigationData"]["aNavItems"] = this["oItemNavigation"]['subItemsOf-' + this["oNavigationData"]["sMainItemId"]]["aItems"];
			this["oNavigationData"]["aHcnpItems"] = this["oHCNP"]['subItemsOf-' + this["oNavigationData"]["sMainItemId"]];
			this["oNavigationData"]["oFirstItemInViewPort"] = (this["bIsScrollable"]()) ? this["oGetFirstItemInViewPort"](this["oNavigationData"]["sLevel"]) : this["oNavigationData"]["aHcnpItems"][0];
			this["oNavigationData"]["oLastItemInViewPort"] = (this["bIsScrollable"]()) ? this["oGetLastItemInViewPort"](this["oNavigationData"]["sLevel"]) : this["oNavigationData"]["aHcnpItems"][this["oNavigationData"]["aHcnpItems"]["length"] - 1];
			this["oNavigationData"]["oItemNavigation"] = this["oItemNavigation"][this["oNavigationData"]["oViewPort"]["id"]];
	}

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["collectNavigationData"] = 0; };

/**
 * Scrolls the item to the view port that both has a tab index and is the the hidden area
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["scrollFocusedIntoViewPort"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["scrollFocusedIntoViewPort"]++; }; 

	if (!this["bIsScrollable"]()) return;

	if ((this["oNavigationData"]["sMeansOfFocusNavigation"] === this["eMeansOfFocusNavigation"]["TAB_NAVIGATION"] ||
			this["oNavigationData"]["sMeansOfFocusNavigation"] === this["eMeansOfFocusNavigation"]["ACCESS_KEY"]) &&
		this["oNavigationData"]["oSourceControl"] != null &&
		(this["oNavigationData"]["oSourceControl"]["sClassName"] === 'UCF_HorizontalContextualPanelItem_ie6' ||
			this["oNavigationData"]["oSourceControl"]["sClassName"] === 'UCF_HorizontalContextualPanelMenuItem_ie6')) {

		this["collectNavigationData"](oBrowserEvent);
		var oNavData = this["oNavigationData"];

		if (this["bIsInPreviousHiddenItems"](oNavData["oSourceControl"], oNavData["sLevel"])) {
			this["scrollFromPreviousHiddenToViewPort"](oNavData["oSourceControl"], oNavData["sLevel"]);
			oNavData["oViewPort"]["scrollTop"] = 0;
		} else if (this["bIsInNextHiddenItems"](oNavData["oSourceControl"], oNavData["sLevel"])) {
			this["scrollFromNextHiddenToViewPort"](oNavData["oSourceControl"], oNavData["sLevel"]);
			oNavData["oViewPort"]["scrollTop"] = 0;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["scrollFocusedIntoViewPort"] = 0; };

/**
 * Provides information as to the navigation type
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onlstabnext"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlstabnext"]++; }; 
	if (!this["bIsScrollable"]()) return;
	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["TAB_NAVIGATION"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlstabnext"] = 0; };

/**
 * Provides information as to the navigation type
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onlstabprevious"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlstabprevious"]++; }; 
	if (!this["bIsScrollable"]()) return;
	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["TAB_NAVIGATION"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlstabprevious"] = 0; };

/**
 * Handles the navigation to the next item, regardless if it is a menuItem or a tabItem
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsnext"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel_ie6.js(2108): onlsnext"); };

	if (!this["bIsScrollable"]()) return;

	this["collectNavigationData"](oBrowserEvent);
	var oNavData = this["oNavigationData"];

	var iFocusedIndex = (oNavData["iFocusedIndex"] + 1 >= oNavData["aNavItems"]["length"]) ? 0 : oNavData["iFocusedIndex"] + 1;

	if (oNavData["oLastItemInViewPort"] !== oNavData["oSourceControl"] && !this["bIsHidden"](oNavData["aNavItems"][iFocusedIndex], oNavData["sLevel"])) return;

	if (iFocusedIndex === 0) {
		this["scrollFromPreviousHiddenToViewPort"](oNavData["aHcnpItems"][0], oNavData["sLevel"]);
	} else {
		this["pageToNextHcnpItems"](oNavData["sLevel"]);
	}

	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ARROW_NAVIGATION"];
	oNavData["oViewPort"]["scrollTop"] = 0;
	this["updateActionButtons"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsnext"] = 0; };

/**
 * Handles the keydown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsprevious"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel_ie6.js(2139): onlsprevious"); };

	if (!this["bIsScrollable"]()) return;

	this["collectNavigationData"](oBrowserEvent);
	var oNavData = this["oNavigationData"];
	var iFocusedIndex = (oNavData["iFocusedIndex"] - 1 < 0) ? oNavData["aHcnpItems"]["length"] - 1 : oNavData["iFocusedIndex"] - 1;

	if (oNavData["oFirstItemInViewPort"] !== oNavData["oSourceControl"] && !this["bIsHidden"](oNavData["aNavItems"][iFocusedIndex], oNavData["sLevel"])) return;

	if (iFocusedIndex === oNavData["aHcnpItems"]["length"] - 1) {
		this["scrollFromNextHiddenToViewPort"](oNavData["aHcnpItems"][oNavData["aHcnpItems"]["length"] - 1], oNavData["sLevel"]);
	} else {
		this["pageToPreviousHcnpItems"](oNavData["sLevel"]);
	}
	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ARROW_NAVIGATION"];
	oNavData["oViewPort"]["scrollTop"] = 0;
	this["updateActionButtons"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsprevious"] = 0; };

/**
 * Handles the navigation to first item
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlshome"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel_ie6.js(2168): onlshome"); };

	if (!this["bIsScrollable"]()) return;

	this["collectNavigationData"](oBrowserEvent);
	var oNavData = this["oNavigationData"];

	if (oNavData["oFirstItemInViewPort"] === oNavData["aHcnpItems"][0]) return;

	this["scrollFromPreviousHiddenToViewPort"](oNavData["aHcnpItems"][0], oNavData["sLevel"]);

	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ARROW_NAVIGATION"];
	oNavData["oViewPort"]["scrollTop"] = 0;
	this["updateActionButtons"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlshome"] = 0; };

/**
 * Handles the navigation to last item
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel_ie6.js(2193): onlsend"); };

	if (!this["bIsScrollable"]()) return;

	this["collectNavigationData"](oBrowserEvent);
	var oNavData = this["oNavigationData"];

	if (oNavData["oLastItemInViewPort"] === oNavData["aHcnpItems"][oNavData["aHcnpItems"]["length"] - 1]) return;

	this["scrollFromNextHiddenToViewPort"](oNavData["aHcnpItems"][oNavData["aHcnpItems"]["length"] - 1], oNavData["sLevel"]);

	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ARROW_NAVIGATION"];
	oNavData["oViewPort"]["scrollTop"] = 0;
	this["updateActionButtons"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsend"] = 0; };

/**
 * Handles item selection by keyboard. Recognizes the item type and calls the appropriate function that changes its design.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel_ie6.js(2218): onlsselect"); };

	var oSourceControl = oBrowserEvent["oSourceControl"];

	switch (oSourceControl["sClassName"]) {
		case 'UCF_HorizontalContextualPanelItem_ie6':
			this["onMainItemAccess"](oBrowserEvent);
			break;
		case 'UCF_HorizontalContextualPanelMenuItem_ie6':
			this["onSubItemAccess"](oBrowserEvent);
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsselect"] = 0; };

/**
 * Sets the correct acc text
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel_ie6.js(2239): onlsaccessibility"); };

	if (window["UCF_System"]["bIsAria"]) return;

	this["collectNavigationData"](oBrowserEvent);

	if (!UCF_JsUtil["bInstanceOf"](this["oNavigationData"]["oSourceControl"], 'UCF_HorizontalContextualPanelMenuItem_ie6') &&
		!UCF_JsUtil["bInstanceOf"](this["oNavigationData"]["oSourceControl"], 'UCF_HorizontalContextualPanelItem_ie6')) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	var oSource = this["oNavigationData"]["oSourceControl"];
	var sControlType = (UCF_JsUtil["bInstanceOf"](oSource, 'UCF_HorizontalContextualPanelMenuItem_ie6')) ? 'HCNP_LNK' : 'HCNP';
	var iItemCount = this["oNavigationData"]["oItemNavigation"]["aItems"]["length"];
	var iItemIndex = UCF_JsUtil["indexOf"](this["oNavigationData"]["aNavItems"], oSource);
	var bSelected = this["sGetStatusOfHcnpItemToSelect"](oSource, this["oNavigationData"]["sLevel"]) === this["eStatusOfItemToSelect"]["SELECTED_HCNP_ITEM"];
	var bEnabled = oSource["bEnabled"];

	oAccessibilityHelper["setControlType"](sControlType);
	oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](oSource["oDomRef"]));
	oAccessibilityHelper["setTooltip"](oSource["sTooltip"]);
	oAccessibilityHelper["setAccessKey"](oSource["sAccessKey"]);
	//oAccessibilityHelper.setContainingItemCount(iItemCount);
	oAccessibilityHelper["setItemCount"](iItemCount);
	oAccessibilityHelper["setItemIndex"](iItemIndex + 1);
	oAccessibilityHelper["setSelected"](bSelected);
	oAccessibilityHelper["setEnabled"](bEnabled);
	if (!bSelected && bEnabled)
		oAccessibilityHelper["addTutor"]('SELECT_TUT');
	oAccessibilityHelper["addTutor"]('LRNAV_TUT');
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_HorizontalContextualPanel_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["destroy"]++; }; 

	if (this["bIsScrollable"]()) {
		this["detachBrowserEvent"]('resize', this["oDomRef"]);
	}

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	for (var n in this["oItemNavigation"]) {
		this["oItemNavigation"][n]["destroy"]();
	}

	this["oHCNP"] = null;
	this["oSelectionData"] = null;
	this["oNavigationData"] = null;
	this["iWidth"] = null;
	this["bUsePopUpMenu"] = null;
	this["aActionItems"] = null;
	this["sMeansOfFocusNavigation"] = null;
	this["bHasSubItems"] = null;
	this["iSelectedTabIndex"] = null;
	this["sTimeOutId"] = null;

	UCF_HorizontalContextualPanel.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_ie6["_"]["destroy"] = 0; };

UCF_HorizontalContextualPanel_ie6.prototype["aPublicMethods"] = ["select"].concat(UCF_HorizontalContextualPanel_ie6.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_HorizontalContextualPanel_standards"] = function() {/* global _assert, _trace, _measure, DEBUG, ERROR, START, STOP */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_HorizontalContextualPanel */
/// <reference path="./HorizontalContextualPanel.js"/>
/* global UCF_ItemScrollingDelegate */
/// <reference path="./delegates/ItemScrollingDelegate.js"/>

/**
 * HorizontalContextualPanel
 *
 * 
 *
 * @class
 * @param {HMTLElement} oDomRef DOM reference
 * @param {UCF_LS} oLS LS instance
 */
function UCF_HorizontalContextualPanel_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["UCF_HorizontalContextualPanel_standards"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "HorizontalContextualPanel_standards.js(43): UCF_HorizontalContextualPanel_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HorizontalContextualPanel_standards.js(44): UCF_HorizontalContextualPanel_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HorizontalContextualPanel_standards.js(45): UCF_HorizontalContextualPanel_standards"); };

	UCF_HorizontalContextualPanel["apply"](this, [oDomRef, oLS]);

	this["createGenericFields"]();

	if (this["bIsScrollable"]()) {
		this["attachBrowserEvent"]('resize', this["oDomRef"]);

		this["oScrolling"]["oMainItems"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemScrollingDelegate"))();
		this["addDelegate"](this["oScrolling"]["oMainItems"]);
	}

	this["oNavigation"]["oMainItems"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oNavigation"]["oMainItems"]);

	this["oNavigation"]["oMainItems"]["attachEvent"](this["oNavigation"]["oMainItems"]["E_EVENTS"]["Select"], this, 'onMainItemAccess');
	this["oNavigation"]["oMainItems"]["attachEvent"](this["oNavigation"]["oMainItems"]["E_EVENTS"]["Activate"], this, 'onMainItemActivate');
	this["oNavigation"]["oMainItems"]["setServerSelection"](!this["bClientSelect"]);

	this["createMainItems"]();

	if (this["iSelectedTabIndex"] > -1 && this["aMainItems"]["length"] > 0) {
		this["createSubItems"](this["aMainItems"][this["iSelectedTabIndex"]]);
		this["oFocusDomRef"] = this["aMainItems"][this["iSelectedTabIndex"]]["oDomRef"]["firstChild"];
	}

};window["UCF_HorizontalContextualPanel_standards"] = UCF_HorizontalContextualPanel_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HorizontalContextualPanel_standards"); UCF_HorizontalContextualPanel_standards["_"] = {UCF_HorizontalContextualPanel_standards: 0}; }; ;
UCF_HorizontalContextualPanel_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_HorizontalContextualPanel"))(); UCF_HorizontalContextualPanel_standards.prototype["sClassName"] = "UCF_HorizontalContextualPanel_standards";

/**
 * Destructor
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["destroy"]++; }; 

	if (this["bIsScrollable"]()) {
		this["detachBrowserEvent"]('resize', this["oDomRef"]);
	}

	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	var n;

	if (this["oNavigation"]) {
		for (n in this["oNavigation"]) {
			this["oNavigation"][n]["destroy"]();
		}
		this["oNavigation"] = null;
	}

	if (this["oScrolling"]) {
		for (n in this["oScrolling"]) {
			this["oScrolling"][n]["destroy"]();
		}
		this["oScrolling"] = null;
	}

	this["oViewPortMainItems"] = null;
	this["oViewPortSubItems"] = null;
	this["aMainItems"] = null;
	this["oSubItems"] = null;
	this["sMeansOfSelection"] = null;
	this["oItemToSelect"] = null;
	this["oSelectionData"] = null;
	this["oNavigationData"] = null;
	this["iWidth"] = null;
	this["bUsePopUpMenu"] = null;
	this["oActionItems"] = null;
	this["sMeansOfFocusNavigation"] = null;
	this["iSelectedTabIndex"] = null;
	this["sTimeOutId"] = null;
	this["oStoredFirstVisible"] = null;
	this["oNavigation"] = null;
	UCF_HorizontalContextualPanel.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["destroy"] = 0; };

/**
 * ############################################################
 *
 * Everything that needs do be done during initialization
 *
 * ############################################################
 */

UCF_HorizontalContextualPanel_standards["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["initialize"]++; }; 
	/** @type {string} */
	var sField;

	if (this["bIsScrollable"]) {
		this["oScrolling"]["oMainItems"]["initialize"]();
	}
	if (this["bSubItemsCreated"]()) {
		sField = this["sGetSubItemField"]();
		this["oScrolling"][sField]["initialize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["initialize"] = 0; };

/**
 * central objects that stores all control objects necessary for:
 * 	- Selection
 *   - Scrolling
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["createGenericFields"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["createGenericFields"]++; }; 
	/** @type {UCF_HorizontalContextualPanel_ie6} */
	var self = this;
	/** @type {Object} */
	this["oMainMenu"] = null;
	/** @type {Array} */
	this["aSubMenus"] = null;
	/** @type {string} */
	this["sMeansOfSelection"] = null;
	/** @type {Object} */
	this["oItemToSelect"] = null;
	/** @type {Array} */
	this["aMainItems"] = [];
	/** @type {Object} */
	this["oSubItems"] = {};
	/** @type {Object} */
	this["oNavigation"] = {};
	/** @type {Object} */
	this["oSelectionData"] = {};
	/** @type {Object} */
	this["oNavigationData"] = {};
	/** @type {Object} */
	this["oStoredFirstVisible"] = null;
	/** @type {int} */
	this["iWidth"] = this["oDomRef"]["offsetWidth"];
	/** @type {Object} */
	this["oViewPortMainItems"] = null;
	/** @type {Object} */
	this["oViewPortSubItems"] = null;

	if (this["bIsScrollable"]()) {
		/** @type {Object} */
		this["oScrolling"] = {};
		/** @type {boolean} */
		this["bUsePopUpMenu"] = (this["sPopupMenuId"] !== '');
		/** @type {Object} */
		this["oActionItems"] = {
			"PREV_BTN_MAIN": UCF_DomUtil["$"](self["sId"] + '-prevMainItems'),
			"NEXT_BTN_MAIN": UCF_DomUtil["$"](self["sId"] + '-nextMainItems'),
			"PREV_BTN_SUB": UCF_DomUtil["$"](self["sId"] + '-prevSubItems'),
			"NEXT_BTN_SUB": UCF_DomUtil["$"](self["sId"] + '-nextSubItems')
		};
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["createGenericFields"] = 0; };

/**
 * collects all items on top level
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["createMainItems"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["createMainItems"]++; }; 
	/** @type {int} */
	var i;
	/** @type {HTMLDivElement} */
	this["oViewPortMainItems"] = UCF_DomUtil["$"](this["sId"] + '-mainItems');
	/** @type {HTML-collection} */
	var oMainItemsRef = this["oViewPortMainItems"]["childNodes"];
	/** @type {UCF_HorizontalContextualPanelItem} */
	var oItem;

	for (i = 0; i < oMainItemsRef["length"]; i++) {
		oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oMainItemsRef[i], true);
		if (this["bIsMainItem"](oItem)) {
			oItem["iIndex"] = i;
			this["aMainItems"]["push"](oItem);
			this["oNavigation"]["oMainItems"]["addItem"](oItem, oItem["iIndex"] === this["iSelectedTabIndex"]);
		}
	}

	if (this["bIsScrollable"]()) {
		this["oScrolling"]["oMainItems"]["setSelectedIndex"](this["iSelectedTabIndex"]);
		this["oScrolling"]["oMainItems"]["addItems"](this["aMainItems"]);
		this["oScrolling"]["oMainItems"]["addViewPort"](this["oViewPortMainItems"]);
		this["oScrolling"]["oMainItems"]["addActionItems"]([this["sId"] + '-prevMainItems', this["sId"] + '-nextMainItems']);
		this["oScrolling"]["oMainItems"]["attachEvent"](this["oScrolling"]["oMainItems"]["E_EVENTS"]["ItemsScrolled"], this, 'onItemsScrolled');
		this["oScrolling"]["oMainItems"]["setFirstVisibleItem"](this["iFirstVisibleOnMainLevel"]);
	}

	this["oNavigation"]["oMainItems"]["oItemContainer"] = this["oViewPortMainItems"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["createMainItems"] = 0; };

/**
 * collects all menu items
 * @param {UCF_Control} oMainItem index of the selected tab
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["createSubItems"] = function(oMainItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["createSubItems"]++; }; 
	/** @type {string} - Id of submenu viewport*/
	var sId = this["sCreateId"](oMainItem);
	/** @type {HTMLElement} */
	var oSubItemsContainer = UCF_DomUtil["$"](sId);
	if (!oSubItemsContainer) return;

	/** @type {Array} */
	var aDomItems = UCF_DomUtil["$"](sId)["childNodes"];
	/** @type {int} */
	var i;
	/** @type {HCNP_Item} */
	var oItem;

	if (!aDomItems || aDomItems["length"] === 0) return;

	this["oViewPortSubItems"] = UCF_DomUtil["$"](sId);
	this["oNavigation"][sId] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["oSubItems"][sId] = [];

	for (i = 0; i < aDomItems["length"]; i++) {
		oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[i], true);

		if (this["bIsSubItem"](oItem)) {
			this["oSubItems"][sId]["push"](oItem);
			this["oNavigation"][sId]["addItem"](oItem, oItem["iIndex"] === oMainItem["iSelectedTabMenuIndex"]);
		}
	}

	this["addDelegate"](this["oNavigation"][sId]);
	this["oNavigation"][sId]["attachEvent"](this["oNavigation"][sId]["E_EVENTS"]["Select"], this, 'onSubItemAccess');
	this["oNavigation"][sId]["attachEvent"](this["oNavigation"][sId]["E_EVENTS"]["Activate"], this, 'onSubItemActivate');
	this["oNavigation"][sId]["oItemContainer"] = UCF_DomUtil["$"](sId);
	this["oNavigation"][sId]["setServerSelection"](!this["bClientSelect"]);

	if (this["bIsScrollable"]()) {
		this["oScrolling"][sId] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemScrollingDelegate"))();
		this["addDelegate"](this["oScrolling"][sId]);
		this["oScrolling"][sId]["addViewPort"](UCF_DomUtil["$"](sId));
		this["oScrolling"][sId]["setSelectedIndex"](oMainItem["iSelectedTabMenuIndex"]);
		this["oScrolling"][sId]["addItems"](this["oSubItems"][sId]);
		this["oScrolling"][sId]["addActionItems"]([this["sId"] + '-prevSubItems', this["sId"] + '-nextSubItems']);
		this["oScrolling"][sId]["attachEvent"](this["oScrolling"]["oMainItems"]["E_EVENTS"]["ItemsScrolled"], this, 'onItemsScrolled');
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["createSubItems"] = 0; };

/**
 * ############################################################################
 *
 * SECTION WITH HELPER FUNCTIONS
 *
 * ############################################################################
 */

/**
 * @private
 * @param {HCNP_Item} oItem
 * @return { string } the name of the field in this.oSubItems that stores
 * the sub items of the selected main item
 */
UCF_HorizontalContextualPanel_standards["prototype"]["sCreateId"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["sCreateId"]++; }; 
	/** @type {string} */
	var sId;

	if (oItem) {
		sId = 'subItemsOf-' + oItem["sId"];
		return sId;
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["sCreateId"] = 0; };

/**
 * @private
 * @param { HCNP_Item } oItem - faculatative
 * @return { string } the name of the field in this.oSubItems that stores
 * the sub items of the selected main item
 */
UCF_HorizontalContextualPanel_standards["prototype"]["sGetSubItemField"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["sGetSubItemField"]++; }; 
	/** @type {HCNP_Item} */
	var oMainItem;
	/** @type {string} */
	var sField;
	/** @type {HCNP_Item} */
	var oItemToSelect = this["oGetItemToSelect"]();

	if (oItem) {
		sField = this["sCreateId"](oItem);
	} else if (oItemToSelect && this["bIsMainItem"](oItemToSelect)) {
		oMainItem = this["oGetSelectedMainItem"]();
		sField = this["sCreateId"](oItemToSelect);
	} else {
		oMainItem = this["oGetSelectedMainItem"]();
		sField = this["sCreateId"](oMainItem);
	}
	return sField;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["sGetSubItemField"] = 0; };

/**
 * @private
 * @param { HCNP_Item } oItem
 * @return { boolean } determines that paassed on parameter is main item
 */
UCF_HorizontalContextualPanel_standards["prototype"]["bIsMainItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bIsMainItem"]++; }; 

	if (oItem) {
		return UCF_JsUtil["bInstanceOf"](oItem,
			'UCF_HorizontalContextualPanelItem_standards');
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No item found', "HorizontalContextualPanel_standards.js(342): bIsMainItem"); };
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bIsMainItem"] = 0; };

/**
 * @private
 * @return { boolean }
 */
//eslint-disable-next-line
UCF_HorizontalContextualPanel_standards["prototype"]["bHasIcon"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bHasIcon"]++; }; 
	/** @type {HCNP_Item} */
	var oItem;

	if (this["aMainItems"] && this["aMainItems"]["length"] > 0) {
		oItem = this["aMainItems"][0];
		if ((oItem &&
				oItem["oDomRef"] &&
				oItem["oDomRef"]["firstChild"] &&
				oItem["oDomRef"]["firstChild"]["getAttribute"]('data-src'))
			||
			(oItem &&
				oItem["oDomRef"] &&
				oItem["oDomRef"]["tagName"] === 'svg')) {
			return true;
		}
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No item found', "HorizontalContextualPanel_standards.js(369): bHasIcon"); };
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bHasIcon"] = 0; };

/**
 * @private
 * @param { HCNP_Item } oItem
 * @return { boolean } determines that paassed on parameter is sub item
 */
UCF_HorizontalContextualPanel_standards["prototype"]["bIsSubItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bIsSubItem"]++; }; 

	if (oItem) {
		return UCF_JsUtil["bInstanceOf"](oItem,
			'UCF_HorizontalContextualPanelMenuItem_standards');
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No item found', "HorizontalContextualPanel_standards.js(385): bIsSubItem"); };
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bIsSubItem"] = 0; };

/**
 * @private
 * @return { HCNP_Item }
 */
UCF_HorizontalContextualPanel_standards["prototype"]["oGetSelectedMainItem"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["oGetSelectedMainItem"]++; }; 
	/** @type {int} */
	var iSelected = this["iSelectedTabIndex"];
	/** @type {Array} */
	var aItems = this["aMainItems"];
	if (iSelected > -1) {
		return aItems[iSelected];
	} else {
		return aItems[0];
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["oGetSelectedMainItem"] = 0; };

/**
 * @private
 * @return { HCNP_Item }
 */
UCF_HorizontalContextualPanel_standards["prototype"]["oGetSelectedSubItem"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["oGetSelectedSubItem"]++; }; 
	/** @type {int} */
	var iSelected = this["iGetSelectedSubIndex"]();
	/** @type {Array} */
	var aItems;

	if (iSelected > -1) {
		aItems = this["aGetSubItems"]();
		return aItems[iSelected];
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["oGetSelectedSubItem"] = 0; };

/**
 * @private
 * @return {int}
 */
UCF_HorizontalContextualPanel_standards["prototype"]["iGetSelectedMainIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["iGetSelectedMainIndex"]++; }; 
	return this["iSelectedTabIndex"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["iGetSelectedMainIndex"] = 0; };

/**
 * @private
 * @return { int }
 */
UCF_HorizontalContextualPanel_standards["prototype"]["iGetSelectedSubIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["iGetSelectedSubIndex"]++; }; 
	/** @type {HCNP_Item} */
	var oMain = this["oGetSelectedMainItem"]();
	return oMain["iSelectedTabMenuIndex"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["iGetSelectedSubIndex"] = 0; };

/**
 * @private
 * @return { HCNP_Item } this is either a main or a sub-item. It has just been
 * accessed during the selection process
 */
UCF_HorizontalContextualPanel_standards["prototype"]["oGetItemToSelect"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["oGetItemToSelect"]++; }; 
	return this["oItemToSelect"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["oGetItemToSelect"] = 0; };

/**
 * @private
 * @param {UCF_HorizontalContextualPanelItem_standards} oItem
 * accessed during the selection process
 */
UCF_HorizontalContextualPanel_standards["prototype"]["setItemToSelect"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["setItemToSelect"]++; }; 
	if (oItem) {
		this["oItemToSelect"] = oItem;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No item to select found', "HorizontalContextualPanel_standards.js(460): setItemToSelect"); };
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["setItemToSelect"] = 0; };

/**
 * @private
 * @return { HCNP_Item } this is either a main or a sub - item. It the currently
 * selected item that has to be replaced by this.oItemToSelect;
 */
UCF_HorizontalContextualPanel_standards["prototype"]["oGetItemToDeselect"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["oGetItemToDeselect"]++; }; 
	/** @type {HCNP_Item} */
	var oItemToSelect = this["oGetItemToSelect"]();
	/** @type {int} */
	var iIndex;
	/** @type {Array} */
	var aItems;

	if (this["bIsMainItem"](oItemToSelect)) {
		iIndex = this["iGetSelectedMainIndex"]();
		aItems = this["aMainItems"];

	} else if (this["bSubItemsCreated"]() && this["bIsSubItem"](oItemToSelect)) {
		iIndex = this["iGetSelectedSubIndex"]();
		aItems = this["aGetSubItems"]();
	}

	if (iIndex > -1) {
		return aItems[iIndex];
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["oGetItemToDeselect"] = 0; };

/**
 * @private
 * @return { Array }
 */
UCF_HorizontalContextualPanel_standards["prototype"]["aGetSubItems"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["aGetSubItems"]++; }; 
	/** @type {string} */
	var sField;
	/** @type {HCNP_Item} */
	var oMainItem = this["oGetSelectedMainItem"]();

	if (this["bSubItemsCreated"](oMainItem)) {
		sField = this["sGetSubItemField"]();
		return this["oSubItems"][sField];
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["aGetSubItems"] = 0; };

/**
 * It is not possible to rely on the value -1 for the property SelectedTabMenuItemIndex
 * With this helper we look whether items are assinged within the DOM
 *
 * @private
 * @param {HCNP_Item} oMainItem
 * @return {boolean}
 */
UCF_HorizontalContextualPanel_standards["prototype"]["bSubItemsInDom"] = function(oMainItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bSubItemsInDom"]++; }; 
	/** @type {string} */
	var sField = this["sCreateId"](oMainItem);

	return (sField &&
		UCF_DomUtil["$"](sField) &&
		UCF_DomUtil["$"](sField)["childNodes"] &&
		UCF_DomUtil["$"](sField)["childNodes"]["length"] > 0);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bSubItemsInDom"] = 0; };

/**
 * Checks if the subitems of the HCNP item to be selected have been created
 *
 * @private
 * @param {UCF_HorizontalContextualPanelItem_standards} oMainItem
 * @return {boolean}
 */
UCF_HorizontalContextualPanel_standards["prototype"]["bSubItemsCreated"] = function(oMainItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bSubItemsCreated"]++; }; 
	/** @type {string} */
	var sField;

	if (!oMainItem)
		oMainItem = this["oGetSelectedMainItem"]();

	sField = this["sGetSubItemField"](oMainItem);

	return typeof this["oSubItems"] === 'object' &&
		typeof this["oSubItems"][sField] !== 'undefined' &&
		typeof this["oSubItems"][sField] !== undefined;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bSubItemsCreated"] = 0; };

/**
 * Scrolling is only available in standards mode
 * @return {boolean}
 */
UCF_HorizontalContextualPanel_standards["prototype"]["bIsScrollable"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bIsScrollable"]++; }; 
	return window["UCF_System"]["sDevice"] === 'standards' && this["bScrollable"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bIsScrollable"] = 0; };

/**
 * A list of the different levels of the HCNP
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["eLevel"] = {
	"MAIN": 'MAIN',
	"SUB": 'SUB',
	"NONE": 'NONE',
	"MENU": 'MENU'
};

/**
 * ############################################################################
 *
 * SECTION FOR ACTION BUTTONS These are
 *
 * SCROLL-LEFT + SCROLL-RIGHT + OPEN-MENU for main- and sub-items
 *
 * All routines handling the interaction on the panel with the scroll-
 * and menu buttons
 *
 * ############################################################################
 */

/**
 * @private
 * Items scroll during:
 * - initialization
 * - triggering of scroll buttons
 * - selection if new main item has subitems that need to be initialized
 *
 */
UCF_HorizontalContextualPanel_standards["prototype"]["onItemsScrolled"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onItemsScrolled"]++; }; 
	this["updateStyles"]();
	this["updateActionItems"]('SCROLLING');
	var oFirst = this["oScrolling"]["oMainItems"]["oGetFirstItemInViewPort"](this["eLevel"]["MAIN"]);
	this["fireScroll"](this["sId"], oFirst ? oFirst["iIndex"] : 0, -1);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onItemsScrolled"] = 0; };

/**
 * @private
 * Scroll buttons and menubutton
 * @param {string} sMeans
 * @return {Object}
 */
UCF_HorizontalContextualPanel_standards["prototype"]["oGetActionItemsStates"] = function(sMeans) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["oGetActionItemsStates"]++; }; 
	/** @type {Object} */
	var oActionItemsStates = {};
	/** @type {HCNP_Item} */
	var oMainItem;
	/** @type {UCF_ItemScrollingDelegate} */
	var oScrolling = this["oScrolling"]["oMainItems"];
	/** @type {string} */
	var sField;

	switch (sMeans) {
		case 'SCROLLING':
			oMainItem = this["oGetSelectedMainItem"]();
			break;
		case 'SELECTION':
			oMainItem = this["oGetItemToSelect"]();
	}

	oActionItemsStates['PREV_BTN_MAIN'] = oScrolling["bFirstHidden"]();
	oActionItemsStates['NEXT_BTN_MAIN'] = oScrolling["bLastHidden"]();

	if (this["bSubItemsCreated"](oMainItem)) {
		sField = this["sGetSubItemField"]();
		oScrolling = this["oScrolling"][sField];
		oActionItemsStates['PREV_BTN_SUB'] = oScrolling["bFirstHidden"]();
		oActionItemsStates['NEXT_BTN_SUB'] = oScrolling["bLastHidden"]();
	}

	return oActionItemsStates;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["oGetActionItemsStates"] = 0; };

/**
 * @private
 * @param {string} sMeans
 */
UCF_HorizontalContextualPanel_standards["prototype"]["updateActionItems"] = function(sMeans) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateActionItems"]++; }; 
	/** @type {Object} */
	var oActionItems;
	/** @type {Object} */
	var oActionItemsStates;
	/** @type {enum-list} */
	var eStyles;
	/** @type {string} */
	var n;
	/** @type {HCNP_Item} */
	var oItemToSelect;
	/** @type {HTML_Element} */
	var oPrevButton;
	/** @type {HTML_Element} */
	var oNextButton;

	if (this["bIsScrollable"]()) {
		eStyles = this["eStyles"];
		oActionItemsStates = {};
		oActionItemsStates = this["oGetActionItemsStates"](sMeans);
		oActionItems = this["oActionItems"];
		oItemToSelect = this["oGetItemToSelect"]();
		oNextButton = UCF_DomUtil["$"](this["sId"] + '-nextSubItemsCnt');
		oPrevButton = UCF_DomUtil["$"](this["sId"] + '-prevSubItemsCnt');

		if (oActionItems) {
			for (n in oActionItems) {
				if (oActionItemsStates[n] !== undefined) {
					if (oActionItemsStates[n] === true) {
						UCF_DomUtil["replaceClass"](oActionItems[n], eStyles[n + '_OFF'], eStyles[n + '_ON']);
					} else {
						UCF_DomUtil["replaceClass"](oActionItems[n], eStyles[n + '_ON'], eStyles[n + '_OFF']);
					}
				}
			}
		}
	}

	if (!oNextButton) return;

	if (oItemToSelect && this["bSubItemsInDom"](oItemToSelect)) {
		UCF_DomUtil["addClass"](oNextButton, eStyles["BUTTON_CONTAINER"]);
		UCF_DomUtil["addClass"](oPrevButton, eStyles["BUTTON_CONTAINER"]);

	} else if (oItemToSelect && !this["bSubItemsInDom"](oItemToSelect)) {
		UCF_DomUtil["removeClass"](oNextButton, eStyles["BUTTON_CONTAINER"]);
		UCF_DomUtil["removeClass"](oPrevButton, eStyles["BUTTON_CONTAINER"]);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateActionItems"] = 0; };

/**
 * @private
 * Add and remove style for first visible item
 */
UCF_HorizontalContextualPanel_standards["prototype"]["updateStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateStyles"]++; }; 

	/** @type {UCF_HorizontalContextualPanelItem_standards} */
	var oStored = this["oStoredFirstVisible"];
	/** @type {UCF_HorizontalContextualPanelItem_standards} */
	var oFirst;
	/** @type {enum-list} */
	var eStyles = this["eStyles"];
	/** @type {string} */
	var sOldKeyFirst;
	/** @type {string} */
	var sNewKeyFirst;
	/** @type {int} */
	var iSelected = this["iSelectedTabIndex"];

	if (!this["bIsScrollable"]()) return;

	oFirst = this["oScrolling"]["oMainItems"]["oGetFirstItemInViewPort"](this["eLevel"]["MAIN"]);

	if (oStored !== null) {
		if (oStored["iIndex"] === iSelected) {
			sOldKeyFirst = (oStored["bEnabled"]) ? 'TAB_SELECTED' : 'TAB_SELECTED_DISABLED';
		} else {
			sOldKeyFirst = (oStored["bEnabled"]) ? 'TAB_DESELECTED' : 'TAB_DESELECTED_DISABLED';
		}
		UCF_DomUtil["replaceClass"](oStored["oDomRef"], eStyles['FIRST_' + sOldKeyFirst], eStyles[sOldKeyFirst]);
	}

	if (oFirst["iIndex"] === iSelected) {
		sNewKeyFirst = (oFirst["bEnabled"]) ? 'TAB_SELECTED' : 'TAB_SELECTED_DISABLED';
	} else {
		sNewKeyFirst = (oFirst["bEnabled"]) ? 'TAB_DESELECTED' : 'TAB_DESELECTED_DISABLED';
	}
	UCF_DomUtil["replaceClass"](oFirst["oDomRef"], eStyles[sNewKeyFirst], eStyles['FIRST_' + sNewKeyFirst]);

	this["oStoredFirstVisible"] = oFirst;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateStyles"] = 0; };

/**
 * ############################################################################
 *
 *  SECTION RESPONSIBLE FOR THE SELECTION
 *
 * ############################################################################
 */

/**
 * enumeration that lists the different statuses of an
 * HCNP item that is to be selected
 *
 */
UCF_HorizontalContextualPanel_standards["prototype"]["eStatusOfItemToSelect"] = {
	"CLIENT_SELECTION": 'CLIENT_SELECTION',
	"SERVER_SELECTION": 'SERVER_SELECTION',
	"SERVER_SELECTION_MENU": 'SERVER_SELECTION_MENU',
	"INACCESSIBLE": 'INACCESSIBLE',
	"SELECTED_MAIN_MENU_ITEM": 'SELECTED_MAIN_MENU_ITEM',
	"SELECTED_SUB_MENU_ITEM": 'SELECTED_SUB_MENU_ITEM',
	"SELECTED_HCNP_ITEM": 'SELECTED_HCNP_ITEM',
	"CREATE_MENUITEMS_MENU": 'SELECTED_HCNP_MENUITEM_POPUP',
	"CREATE_SUBITEMS": 'CREATE_SUBITEMS'
};

/**
 * enumeration that lists the different statuses of an HCNP item that is
 * to be deselected
 *
 */
UCF_HorizontalContextualPanel_standards["prototype"]["eStatusOfItemToDeselect"] = {
	"SELECTED": 'SELECTED',
	"DESELECTED": 'DESELECTED',
	"INACCESSIBLE_AND_SELECTED": 'INACCESSIBLE_AND_SELECTED'
};

/**
 * enumeration that lists the different means by which
 * a tab item can be selected
 */
UCF_HorizontalContextualPanel_standards["prototype"]["eMeansOfSelection"] = {
	"MAIN_HCNP_ITEM": 'MAIN_HCNP_ITEM',
	"SUB_HCNP_ITEM": 'SUB_HCNP_ITEM',
	"MAIN_MENU_ITEM": 'MAIN_MENU_ITEM',
	"SUB_MENU_ITEM": 'SUB_MENU_ITEM',
	"MAIN_MENU_ITEM_IN_SUB_MENU": 'MAIN_MENU_ITEM_IN_SUB_MENU',
	"CALL": 'CALL',
	"ICON": 'ICON'
};

/**
 * determines the status of the HCNP item that is to be deselected
 * @param {UCF_Control} oItem
 * @return {string}
 */
// eslint-disable-next-line consistent-return
UCF_HorizontalContextualPanel_standards["prototype"]["sGetStatusOfHcnpItemToDeselect"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["sGetStatusOfHcnpItemToDeselect"]++; }; 

	if (oItem["oDomRef"]["className"]["indexOf"](this["eStyles"]["SUB_ITEM_SELECTED"]) > -1)
		return this["eStatusOfItemToDeselect"]["SELECTED"];

	if (oItem["oDomRef"]["className"]["indexOf"](this["eStyles"]["MAIN_ITEM_SELECTED"]) > -1)
		return this["eStatusOfItemToDeselect"]["SELECTED"];

	if (oItem["oDomRef"]["className"]["indexOf"](this["eStyles"]["SUB_ITEM_DESELECTED"]) > -1)
		return this["eStatusOfItemToDeselect"]["DESELECTED"];

	if (oItem["oDomRef"]["className"]["indexOf"](this["eStyles"]["MAIN_ITEM_DESELECTED"]) > -1)
		return this["eStatusOfItemToDeselect"]["DESELECTED"];

	if (!oItem["bEnabled"] && this["bIsMainItem"](oItem) && oItem["iIndex"] === this["iGetSelectedSubIndex"]())
		return this["eStatusOfItemToDeselect"]["INACCESSIBLE_AND_SELECTED"];

	if (!oItem["bEnabled"] && this["bIsSubItem"](oItem) && oItem["iIndex"] === this["iGetSelectedSubIndex"]())
		return this["eStatusOfItemToDeselect"]["INACCESSIBLE_AND_SELECTED"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["sGetStatusOfHcnpItemToDeselect"] = 0; };

/**
 * Returns the status of a HCNP main and sub item
 * @param {HCNP_Item} oItem
 * @param {string} sLevel
 * @return {enum-value}
 * @private
 */
// eslint-disable-next-line consistent-return
UCF_HorizontalContextualPanel_standards["prototype"]["sGetStatusOfHcnpItemToSelect"] = function(oItem, sLevel) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["sGetStatusOfHcnpItemToSelect"]++; }; 
	/** @type {int} */
	var iSelected;

	if (sLevel === this["eLevel"]["MAIN"]) {
		iSelected = this["iGetSelectedMainIndex"]();
	} else {
		iSelected = this["iGetSelectedSubIndex"]();
	}

	if (sLevel === this["eLevel"]["MAIN"]
		&& oItem["iIndex"] !== iSelected
		&& this["bSubItemsInDom"](oItem)
		&& !this["bSubItemsCreated"](oItem)) {
		return this["eStatusOfItemToSelect"]["CREATE_SUBITEMS"];
	}

	if (!oItem["bEnabled"] && oItem["iIndex"] === iSelected)
		return this["eStatusOfItemToSelect"]["INACCESSIBLE_AND_SELECTED"];

	if (!oItem["bEnabled"] && oItem["iIndex"] !== iSelected)
		return this["eStatusOfItemToSelect"]["INACCESSIBLE"];

	if (oItem["bEnabled"] && oItem["iIndex"] === iSelected)
		return this["eStatusOfItemToSelect"]["SELECTED"];

	if (oItem["bEnabled"] && oItem["iIndex"] !== iSelected && this["bClientSelect"])
		return this["eStatusOfItemToSelect"]["CLIENT_SELECTION"];

	if (oItem["bEnabled"] && oItem["iIndex"] !== iSelected && !this["bClientSelect"])
		return this["eStatusOfItemToSelect"]["SERVER_SELECTION"];

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["sGetStatusOfHcnpItemToSelect"] = 0; };

/**
 * Returns the index on the main and the index on the sub level of the HCNP that has to be selected
 *
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["updateSelectionData"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateSelectionData"]++; }; 
	/** @type {Object} */
	var oSD = this["oSelectionData"];
	/** @type {string} */
	var sField;
	/** @type {enum-list} */
	var eStatus = this["eStatusOfItemToDeselect"];
	/** @type {boolean} */
	var bHasSubItems;
	/** @type {enum-list} */
	var eMeans = this["eMeansOfSelection"];
	/** @type {HCNP_Item} */
	var oItemToSelect = this["oGetItemToSelect"]();

	switch (oSD["sMeansOfSelection"]) {
		case eMeans["ICON"]:
		case eMeans["MAIN_HCNP_ITEM"]:
			sField = this["sCreateId"](oItemToSelect);
			bHasSubItems = this["bSubItemsInDom"](oItemToSelect);
			oSD["iMainLevelIdx"] = oItemToSelect["iIndex"];
			oSD["oMainLevelItem"] = oItemToSelect;
			oSD["iSubLevelIdx"] = (bHasSubItems) ? oItemToSelect["iSelectedTabMenuIndex"] : -1;
			oSD["oSubLevelItem"] = (bHasSubItems) ? this["oSubItems"][sField][oSD["iSubLevelIdx"]] : null;
			oSD["sStatusOfDeselectedItem"] = (this["iSelectedTabIndex"] === -1) ? eStatus["DESELECTED"] : eStatus["SELECTED"];
			break;

		case eMeans["SUB_HCNP_ITEM"]:
			oSD["iMainLevelIdx"] = this["iSelectedTabIndex"];
			oSD["oMainLevelItem"] = this["aMainItems"][this["iSelectedTabIndex"]];
			oSD["iSubLevelIdx"] = oItemToSelect["iIndex"];
			oSD["oSubLevelItem"] = oItemToSelect;
			oSD["sStatusOfDeselectedItem"] = (oSD["oMainLevelItem"]["iSelectedTabMenuIndex"] === -1) ? eStatus["DESELECTED"] : eStatus["SELECTED"];
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateSelectionData"] = 0; };

UCF_HorizontalContextualPanel_standards["prototype"]["purgeSelectionData"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["purgeSelectionData"]++; }; 
	this["oItemToSelect"] = null;
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["purgeSelectionData"] = 0; };

/**
 * determines whether hcnp item can be accessed
 * @param {HCNP_Item} oItemToSelect
 * @param {enum-value} sLevel
 * @param {boolean} bIsMenuAccess
 * @return {enum-value}
 * @private
 */
// eslint-disable-next-line consistent-return
UCF_HorizontalContextualPanel_standards["prototype"]["sEvaluateSelectability"] = function(oItemToSelect, sLevel, bIsMenuAccess) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["sEvaluateSelectability"]++; }; 
	/** @type {enum} */
	var eState = this["eStatusOfItemToSelect"];
	/** @type {enum} */
	var eLevel = this["eLevel"];
	/** @type {HCNP_Item} */
	var oItemToDeselect = this["oGetItemToDeselect"]();

	/*subitems need to be created*/
	if (sLevel === eLevel["MAIN"] &&
		this["bClientSelect"] === true &&
		bIsMenuAccess)
		return eState["CREATE_MENUITEMS_MENU"];

	/*subitems need to be created*/
	if (sLevel === eLevel["MAIN"] &&
		this["bClientSelect"] === true &&
		this["bSubItemsInDom"](oItemToSelect) === true &&
		this["bSubItemsCreated"](oItemToSelect) === false)
		return eState["CREATE_SUBITEMS"];

	/*there is no previously selected  item*/
	if (oItemToSelect &&
		!oItemToDeselect &&
		this["bClientSelect"] === true &&
		!oItemToDeselect)
		return eState["CLIENT_SELECTION"];

	/*there is a previously selected  item*/
	if (oItemToSelect &&
		oItemToDeselect &&
		this["bClientSelect"] === true &&
		oItemToDeselect["iIndex"] !== oItemToSelect["iIndex"])
		return eState["CLIENT_SELECTION"];
	/** open just the menu */
	if (oItemToSelect &&
		this["bClientSelect"] === false
		&& bIsMenuAccess)
		return eState["SERVER_SELECTION_MENU"];

	if (oItemToSelect &&
		this["bClientSelect"] === false)
		return eState["SERVER_SELECTION"];

	/*item is inaccessible*/
	if (oItemToSelect["bEnabled"] === false
		|| (oItemToDeselect &&
			oItemToSelect["iIndex"] === oItemToDeselect["iIndex"]))
		return eState["INACCESSIBLE"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["sEvaluateSelectability"] = 0; };

/**
 * Prevents the item navigation from frem setting the focus
 * if selction takes place on the server.
 * Needed to avoid a programmatic focus with virtual cursor mode
 *
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["onmousedown"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onmousedown"]++; }; 
	if (this["bClientSelect"] === false) {
		this["oNavigation"]["oMainItems"]["setIgnoreFocus"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onmousedown"] = 0; };

/**
 * Prevents the item navigation from frem setting the focus
 * if selction takes place on the server.
 * Needed to avoid a programmatic focus with virtual cursor mode
 *
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["onmouseup"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onmouseup"]++; }; 
	if (this["bClientSelect"] === false) {
		this["oNavigation"]["oMainItems"]["setIgnoreFocus"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onmouseup"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 * @return { boolean }
 */
//eslint-disable-next-line
UCF_HorizontalContextualPanel_standards["prototype"]["bIsMenuAccess"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bIsMenuAccess"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel_standards.js(987): bIsMenuAccess"); };
	/** @type {HTMLElement} */
	var oSourceDomRef = oBrowserEvent ? oBrowserEvent["oSource"] : null;
	return oSourceDomRef && UCF_StringUtil["bEndsWith"](oSourceDomRef["id"], '-tabmenu');
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bIsMenuAccess"] = 0; };

/**
 * everything that needs to be done when a HCNP item on main level is selected
 * @private
 * @param {Event} oEvent
 */
UCF_HorizontalContextualPanel_standards["prototype"]["onMainItemAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onMainItemAccess"]++; }; 
	/** @type {UCF_HorizontalContextualPanelItem_standards} */
	var oItemToSelect = oEvent["mParameters"]["oItem"];
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oEvent["mParameters"]["oBrowserEvent"];
	/** @type {enum-list} */
	var eMeans = this["eMeansOfSelection"];
	/** @type {enum-value} */
	var sState;
	/** @type {enum-list} */
	var eStates = this["eStatusOfItemToSelect"];

	this["sMeansOfSelection"] = eMeans["MAIN_HCNP_ITEM"];
	// check whether main items have icons
	if (this["bHasIcon"]()) {
		this["sMeansOfSelection"] = eMeans["ICON"];
	}
	this["setItemToSelect"](oItemToSelect);
	sState = this["sEvaluateSelectability"](oItemToSelect, this["eLevel"]["MAIN"], this["bIsMenuAccess"](oBrowserEvent));

	switch (sState) {
		case eStates["CREATE_SUBITEMS"]:
			this["createSubItems"](oItemToSelect);
		case eStates["CLIENT_SELECTION"]:
			this["switchSubLevels"]();
			this["scrollSelectedSubItem"]();
			this["selectMainItem"]();
			this["deselectMainItem"]();
			this["updateActionItems"]('SELECTION');
			this["focusByMeansOfSelection"]();
			this["unFocusByMeansOfSelection"]();
			this["updateAria"]();
			this["updateIndeces"]();
			this["updateScrolling"]();
			this["purgeSelectionData"]();
			this["fireSelectEvent"](oItemToSelect);
			break;
		case eStates["SERVER_SELECTION"]:
			this["fireSelectEvent"](oItemToSelect);
			break;
		case eStates["SERVER_SELECTION_MENU"]:
			this["createAndOpenMenu"](oItemToSelect);
			break;
		case eStates["CREATE_MENUITEMS_MENU"]:
			this["selectMainItem"]();
			this["deselectMainItem"]();
			this["updateActionItems"]('SELECTION');
			this["focusByMeansOfSelection"]();
			this["unFocusByMeansOfSelection"]();
			this["updateAria"]();
			this["updateIndeces"]();
			this["updateScrolling"]();
			this["purgeSelectionData"]();
			this["createAndOpenMenu"](oItemToSelect);
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onMainItemAccess"] = 0; };

/**
 *
 * Collects and assigns the right IDs to the semantic SELECT event
 * and fires it
 * @private
 * @param {HCNP_Item} oItemToSelect
 *
 */
UCF_HorizontalContextualPanel_standards["prototype"]["createAndOpenMenu"] = function(oItemToSelect) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["createAndOpenMenu"]++; }; 

	if (!oItemToSelect) return;

	//creates the PopupMenu
	var oPopupMenu = oItemToSelect["oGetPopupMenu"]();
	// The Panel might not have items
	if (!oPopupMenu) return;

	if (oPopupMenu && oPopupMenu["bOpened"]) {
		oPopupMenu["close"]();
	} else {
		oPopupMenu["open"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["createAndOpenMenu"] = 0; };

/**
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["scrollSelectedSubItem"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["scrollSelectedSubItem"]++; }; 
	/** @type {string} */
	var sField;
	/** @type {int} */
	var oItemToSelect = this["oGetItemToSelect"]();

	if (this["bIsScrollable"]() && this["bSubItemsInDom"](oItemToSelect)) {
		sField = this["sGetSubItemField"](oItemToSelect);
		this["oScrolling"][sField]["initialize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["scrollSelectedSubItem"] = 0; };

/**
 * everything that needs to be done when a HCNP item on sub level is selected
 * @private
 * @param {Event} oEvent
 */
UCF_HorizontalContextualPanel_standards["prototype"]["onSubItemAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onSubItemAccess"]++; }; 
	/** @type {HCNP_Item} */
	var oItemToSelect = oEvent["mParameters"]["oItem"];
	/** @type {enum-value} */
	var sState;
	/** @type {enum-list} */
	var eStates = this["eStatusOfItemToSelect"];

	this["setItemToSelect"](oItemToSelect);
	this["sMeansOfSelection"] = this["eMeansOfSelection"]["SUB_HCNP_ITEM"];
	sState = this["sEvaluateSelectability"](oItemToSelect, this["eLevel"]["SUB"], false);

	switch (sState) {
		case eStates["CLIENT_SELECTION"]:
			this["selectSubItem"]();
			this["deselectSubItem"]();
			this["focusByMeansOfSelection"](oEvent);
			this["unFocusByMeansOfSelection"]();
			this["updateAria"]();
			this["updateIndeces"]();
			this["updateScrolling"]();
			this["purgeSelectionData"]();
			this["fireSelectEvent"](oItemToSelect);
			break;
		case eStates["SERVER_SELECTION"]:
			this["fireSelectEvent"](oItemToSelect);

	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onSubItemAccess"] = 0; };

/**
 * everything that needs to be done when a HCNP item is selected
 * @public
 * @param { UCF_HorizontalContextualPanelItem_standards } oItem
 */
UCF_HorizontalContextualPanel_standards["prototype"]["select"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["select"]++; }; 
	this["oSelectionData"]["sMeansOfSelection"] = this["eMeansOfSelection"]["MAIN_HCNP_ITEM"];
	this["updateSelectionData"](oItem);

	switch (oItem["sClassName"]) {
		case 'UCF_HorizontalContextualPanelItem_standards':
			this["sMeansOfSelection"] = this["eMeansOfSelection"]["MAIN_HCNP_ITEM"];
			this["mainItemClientSelect"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["select"] = 0; };

UCF_HorizontalContextualPanel_standards["prototype"]["mainItemClientSelect"] = function(oItemToSelect) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["mainItemClientSelect"]++; }; 
	/** @type {HCNP_Item} */
	var oSelectedItem;

	if (this["bClientSelect"]) {
		oSelectedItem = this["oGetSelectedMainItem"]();
		this["selectMainItem"]();
		this["deselectMainItem"]();
		this["updateActionItems"]('SELECTION');
		this["focusByMeansOfSelection"]();
		this["unFocusByMeansOfSelection"]();
		oItemToSelect["moveFocus"](true); // jo: set focus synchronously to update indices for select event!
		UCF_DomUtil["setTabIndex"](oSelectedItem["oFocusDomRef"], -1);
		this["updateAria"]();
		this["updateIndeces"]();
		this["updateScrolling"]();
		this["fireSelectEvent"](oItemToSelect);
	} else {
		this["fireSelectEvent"](oItemToSelect);
	}

};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["mainItemClientSelect"] = 0; };

/**
 * The updates all ARIA properties
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["updateAria"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateAria"]++; }; 
	/** @type {HCNP_Item} */
	var oSelected = this["oGetItemToSelect"]();
	/** @type {HCNP_Item} */
	var oDeselected = this["oGetItemToDeselect"]();

	if (oSelected && oDeselected &&
		oSelected["iIndex"] !== oDeselected["iIndex"]) {
		UCF_AriaStateHelper["setSelected"](oDeselected["oFocusDomRef"], false);
		UCF_AriaStateHelper["setSelected"](oSelected["oFocusDomRef"], true);
		UCF_AriaStateHelper["setActivedescendant"](oSelected["oDomRef"], oSelected["sId"] + '-cnt');
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateAria"] = 0; };

/**
 *
 * Collects and assigns the right IDs to the semantic SELECT event
 * and fires it
 * @private
 * @param {HCNP_Item} oItemToSelect
 *
 */
UCF_HorizontalContextualPanel_standards["prototype"]["fireSelectEvent"] = function(oItemToSelect) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["fireSelectEvent"]++; }; 
	/** @type {string} */
	var sMainId;
	/** @type {string} */
	var sSubId;
	/** @type {HCNP_Item} */
	var oMainItem;

	/**@type {int} */
	var iFirstVisibleOnMainLevel;

	iFirstVisibleOnMainLevel = 0;
	if (!oItemToSelect) return;

	if (this["bIsScrollable"]()) {
		if (this["bIsMainItem"](oItemToSelect)) {
			sMainId = oItemToSelect["sId"];
			sSubId = '';
			iFirstVisibleOnMainLevel = this["oScrolling"]["oMainItems"]["iGetFirstVisibleInViewPort"](this["eLevel"]["MAIN"]);
	} else {
			oMainItem = this["oGetSelectedMainItem"]();
			sMainId = oMainItem["sId"];
			sSubId = oItemToSelect["sId"];
		}

	} else {
		sMainId = oItemToSelect["sId"];
		sSubId = '';
	}

	this["fireSelect"](
		this["sId"], sMainId, sSubId, iFirstVisibleOnMainLevel, -1);
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["fireSelectEvent"] = 0; };

/**
 * assigns all necessary styles to an hcnp item so as to reflect selection
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["selectMainItem"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["selectMainItem"]++; }; 
	/** @type {HCNP_Item} */
	var oItemToSelect = this["oGetItemToSelect"]();
	/** @type {HTML_Element} */
	var oTitle;
	/** @type {enum-list} */
	var _;
	/** @type {HTML_Element} */
	var oTab;
	/** @type {UCF_HorizontalContextualPanelItem} */
	var oFirst;
	/** @type {UCF_ItemScrollingDelegate} */
	var oScrolling;

	if (this["bCanSelect"]()) {

		_ = this["eStyles"];
		oTab = oItemToSelect["oDomRef"];
		oTitle = UCF_DomUtil["$"](oItemToSelect["sId"] + '-title');

		if (this["bIsScrollable"]() && !this["bHasIcon"]()) {
			oScrolling = this["oScrolling"]["oMainItems"];
			oFirst = oScrolling["oGetFirstItemInViewPort"]();
		} else {
			oFirst = this["aMainItems"][0];
		}

		if (oItemToSelect["iIndex"] === 0 || oItemToSelect["iIndex"] === oFirst["iIndex"]) {
			UCF_DomUtil["replaceClass"](oTab, _["FIRST_TAB_DESELECTED"], _["FIRST_TAB_SELECTED"]);
		} else {
			UCF_DomUtil["replaceClass"](oTab, _["TAB_DESELECTED"], _["TAB_SELECTED"]);
		}

		UCF_DomUtil["replaceClass"](oTitle, _["TITLE_DESELECTED"], _["TITLE_SELECTED"]);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["selectMainItem"] = 0; };

/**
 * assigns all necessary styles to an hcnp item so as to reflect selection
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["selectSubItem"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["selectSubItem"]++; }; 
	/** @type {HCNP_Item} */
	var oItemToSelect = this["oGetItemToSelect"]();
	/** @type {enum-list} */
	var _;
	/** @type {HTML_Element} */
	var oDomRef;

	if (this["bCanSelect"]()) {

		oDomRef = UCF_DomUtil["$"](oItemToSelect["sId"] + '-title');
		_ = this["eStyles"];

		UCF_DomUtil["replaceClass"](oDomRef, _["SUB_ITEM_DESELECTED"], _["SUB_ITEM_SELECTED"]);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["selectSubItem"] = 0; };

UCF_HorizontalContextualPanel_standards["prototype"]["bCanSelect"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bCanSelect"]++; }; 
	/** @type {HCNP_Item} */
	var oItemToSelect = this["oGetItemToSelect"]();
	/** @type {HCNP_Item} */
	var oSelected;
	/** @type {int} */
	var iSelected = this["iGetSelectedSubIndex"]();

	if (this["bIsMainItem"](oItemToSelect)) {
		oSelected = this["oGetSelectedMainItem"]();
	} else {
		oSelected = this["oGetSelectedSubItem"]();
	}

	if (
		typeof iSelected === 'number' &&
		iSelected === -1) {
		return true;

	} else if (
		typeof iSelected === 'number' &&
		iSelected > -1 &&
		oSelected &&
		oItemToSelect["iIndex"] !== oSelected["iIndex"]) {
		return true;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bCanSelect"] = 0; };

/**
 * assigns all necessary styles to an hcnp item so as to reflect de-selection
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["deselectMainItem"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["deselectMainItem"]++; }; 
	/** @type {enum-list} */
	var _ = this["eStyles"];
	/** @type {HCNP_Item} */
	var oItemToDeselect = this["oGetItemToDeselect"]();
	/** @type {HTML_Element} */
	var oTitle;
	/** @type {HTML_Element} */
	var oTab;
	/** @type {string} */
	var FIRST_TAB_DESELECTED;
	/** @type {string} */
	var FIRST_TAB_SELECTED;
	/** @type {string} */
	var TAB_DESELECTED;
	/** @type {string} */
	var TAB_SELECTED;
	/** @type {string} */
	var TITLE_SELECTED;
	/** @type {string} */
	var TITLE_DESELECTED;
	/** @type {string} */
	var DSBL;

	if (this["bCanDeselect"]()) {

		oTab = oItemToDeselect["oDomRef"];
		oTitle = UCF_DomUtil["$"](oItemToDeselect["sId"] + '-title');
		DSBL = (oItemToDeselect["bEnabled"]) ? '' : '_DISABLED';

		FIRST_TAB_DESELECTED = _["FIRST_TAB_DESELECTED"] + DSBL;
		FIRST_TAB_SELECTED = _["FIRST_TAB_SELECTED"] + DSBL;
		TAB_DESELECTED = _["TAB_DESELECTED"] + DSBL;
		TAB_SELECTED = _["TAB_SELECTED"] + DSBL;
		TITLE_SELECTED = _["TITLE_SELECTED"] + DSBL;
		TITLE_DESELECTED = _["TITLE_DESELECTED"] + DSBL;

		if (oTab["className"]["indexOf"]('first') > -1) {
			UCF_DomUtil["replaceClass"](oTab, FIRST_TAB_SELECTED, FIRST_TAB_DESELECTED);
		} else {
			UCF_DomUtil["replaceClass"](oTab, TAB_SELECTED, TAB_DESELECTED);
		}

		UCF_DomUtil["replaceClass"](oTitle, TITLE_SELECTED, TITLE_DESELECTED);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["deselectMainItem"] = 0; };

/**
 * assigns all necessary styles to an hcnp item so as to reflect de-selection
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["deselectSubItem"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["deselectSubItem"]++; }; 
	/** @type {HCNP_Item} */
	var oItemToDeselect = this["oGetItemToDeselect"]();
	/** @type {HTML_Element} */
	var oTitle;

	if (this["bCanDeselect"]()) {

		oTitle = UCF_DomUtil["$"](oItemToDeselect["sId"] + '-title');
		UCF_DomUtil["replaceClass"](oTitle,
			this["eStyles"]["SUB_ITEM_SELECTED"],
			this["eStyles"]["SUB_ITEM_DESELECTED"]);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["deselectSubItem"] = 0; };

/**
 * @private
 * @return {boolean}
 */
//eslint-disable-next-line
UCF_HorizontalContextualPanel_standards["prototype"]["bCanDeselect"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bCanDeselect"]++; }; 
	/** @type {HCNP_Item} */
	var oItemToDeselect = this["oGetItemToDeselect"]();
	/** @type {HCNP_Item} */
	var oItemToSelect = this["oGetItemToSelect"]();

	if (!oItemToDeselect) {
		return false;

	} else if (
		oItemToDeselect &&
		oItemToSelect &&
		oItemToDeselect["iIndex"] !== oItemToSelect["iIndex"]) {
		return true;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["bCanDeselect"] = 0; };

/**
 * shows the sub items of a main hcnp item if there are any
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["switchSubLevels"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["switchSubLevels"]++; }; 
	/** @type {HCNP_Item} */
	var oItemToSelect = this["oGetItemToSelect"]();
	/** @type {HCNP_Item} */
	var oItemToDeselect = this["oGetItemToDeselect"]();
	/** @type {string} */
	var sIdToSelect;
	/** @type {string} */
	var sIdToDeselect;
	/** @type {HTML_Element} */
	var oSubContainerToShow;
	/** @type {HTML_Element} */
	var oSubContainerToHide;

	if (oItemToSelect) {
		sIdToSelect = this["sCreateId"](oItemToSelect);
		oSubContainerToShow = UCF_DomUtil["$"](sIdToSelect);
		if (oSubContainerToShow)
			oSubContainerToShow["style"]["display"] = '';
	}

	if (oItemToDeselect) {
		sIdToDeselect = this["sCreateId"](oItemToDeselect);
		oSubContainerToHide = UCF_DomUtil["$"](sIdToDeselect);
		if (oSubContainerToHide)
			oSubContainerToHide["style"]["display"] = 'none';
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["switchSubLevels"] = 0; };

/**
 * updates all properties of the HCNP that are necessary for selectability
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["updateIndeces"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateIndeces"]++; }; 
	/** @type {Object} */
	var oNavigation = this["oNavigation"];
	/** @type {Object} */
	var oNavMainItems = oNavigation["oMainItems"];
	/** @type {HCNP_Item} */
	var oItemToSelect = this["oGetItemToSelect"]();
	/** @type {HCNP_Item} */
	var oSelectedMainItem;
	/** @type {enum-value} */
	var sMeans = this["sMeansOfSelection"];
	/** @type {enum-list} */
	var eMeans = this["eMeansOfSelection"];
	/** @type {string} */
	var sField;
	/** @type {int} */
	var iSelected;

	switch (sMeans) {
		case eMeans["MAIN_HCNP_ITEM"]:
		case eMeans["ICON"]:
			iSelected = oItemToSelect["iIndex"];
			this["iSelectedTabIndex"] = iSelected;
			this["setClientProperty"]("SelectedTabIndex", iSelected, true);
			oNavMainItems["iSelectedIndex"] = iSelected;
			break;
		case eMeans["SUB_HCNP_ITEM"]:
			iSelected = oItemToSelect["iIndex"];
			oSelectedMainItem = this["oGetSelectedMainItem"]();
			oSelectedMainItem["iSelectedTabMenuIndex"] = iSelected;
			oSelectedMainItem["setClientProperty"]("SelectedTabMenuIndex", iSelected, true);
			sField = this["sGetSubItemField"]();
			oNavigation[sField]["iSelectedIndex"] = iSelected;
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateIndeces"] = 0; };

/**
 * updates all properties of the HCNP that are necessary for selectability
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["updateScrolling"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateScrolling"]++; }; 
	/** @type {UCF_ItemScrollingDelegate} */
	var oScrolling;
	/** @type {Array} */
	var aItems;
	/** @type {int} */
	var iIndex;
	/** @type {string} */
	var sField;
	/** @type {enum-value} */
	var sMeans = this["sMeansOfSelection"];
	/** @type {enum-list} */
	var eMeans = this["eMeansOfSelection"];

	if (this["bIsScrollable"]()) {
		switch (sMeans) {
			case eMeans["MAIN_HCNP_ITEM"]:
			case eMeans["ICON"]:
				oScrolling = this["oScrolling"]["oMainItems"];
				iIndex = this["iGetSelectedMainIndex"]();
				oScrolling["setSelectedIndex"](iIndex);
				break;
			case eMeans["SUB_HCNP_ITEM"]:
				sField = this["sGetSubItemField"]();
				oScrolling = this["oScrolling"][sField];
				aItems = this["aGetSubItems"]();
				iIndex = this["iGetSelectedSubIndex"]();
				oScrolling["setSelectedIndex"](iIndex);
				oScrolling["addItems"](aItems);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["updateScrolling"] = 0; };

/**#####################################################################################
 *
 *  SECTION WHERE ALL HCNP STYLES ARE MAINTAINED
 *
 * #####################################################################################
 * */

/**
 * A list of all objects along with their states that require styles
 *
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["eStyles"] = {

	"TAB_SELECTED": 'lsHcnp2__tab--selected',
	"TAB_DESELECTED": 'lsHcnp2__tab',
	"TAB_DESELECTED_DISABLED": 'lsHcnp2__tab--disabled',
	"TAB_SELECTED_DISABLED": 'lsHcnp2__tab--selected--disabled',

	"FIRST_TAB_SELECTED": 'lsHcnp2__firstTab--selected',
	"FIRST_TAB_DESELECTED": 'lsHcnp2__firstTab',
	"FIRST_TAB_DESELECTED_DISABLED": 'lsHcnp2__firstTab--disabled',
	"FIRST_TAB_SELECTED_DISABLED": 'lsHcnp2__firstTab--selected--disabled',

	"TITLE_SELECTED": 'lsHcnp2__title--selected',
	"TITLE_DESELECTED": 'lsHcnp2__title',
	"TITLE_DESELECTED_DISABLED": 'lsHcnp2__title--disabled',
	"TITLE_SELECTED_DISABLED": 'lsHcnp2__title--selected--disabled',

	"SUB_ITEM_SELECTED": 'lsHcnpMenu3Sel',
	"SUB_ITEM_DESELECTED": 'lsHcnpMenu3',

	"PREV_BTN_MAIN_OFF": 'lsHcnp-PageToPrevMainOff',
	"NEXT_BTN_MAIN_OFF": 'lsHcnp-PageToNextMainOff',
	"PREV_BTN_MAIN_ON": 'lsHcnp-PageToPrevMainOn',
	"NEXT_BTN_MAIN_ON": 'lsHcnp-PageToNextMainOn',
	"PREV_BTN_SUB_OFF": 'lsHcnp-PageToPrevSubOff',
	"NEXT_BTN_SUB_OFF": 'lsHcnp-PageToNextSubOff',
	"PREV_BTN_SUB_ON": 'lsHcnp-PageToPrevSubOn',
	"NEXT_BTN_SUB_ON": 'lsHcnp-PageToNextSubOn',
	"MENU_BTN_OFF": 'lsHcnp-MenuOff',
	"MENU_BTN_ON": 'lsHcnp-MenuOn',

	"HIDDEN_TAB": 'lsHcnp-ItemHidden',
	"BUTTON_CONTAINER": 'lsHCNP__buttonContainer'

};

/**#####################################################################################

 * SECTION THAT HANDLES RESIZING

 * #####################################################################################
 * */

/**
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onresize"]++; }; 

	if (!this["bIsScrollable"]()) return;

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oDomRef"]) {

		if (this["sTimeOutId"] != null) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResize');
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onresize"] = 0; };

/**
 * This function is called after resizing has finished
 *
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onAfterResize"]++; }; 
	/** @type {UCF_ItemScrollingDelegate} */
	var oScrolling;
	/** @type {string} */
	var sField;

	if (!this["bIsValid"]() || this["iWidth"] === this["oDomRef"]["offsetWidth"]) return;

	oScrolling = this["oScrolling"]["oMainItems"];
	oScrolling["onItemsResized"]();

	if (this["bSubItemsCreated"]()) {
		sField = this["sGetSubItemField"]();
		oScrolling = this["oScrolling"][sField];
		oScrolling["onItemsResized"]();
	}
	this["iWidth"] = this["oDomRef"]["offsetWidth"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onAfterResize"] = 0; };

/**########################################################################
 *
 * SECTION THAT HANDLES ACCESS KEYS
 *
 * #######################################################################
 **/

UCF_HorizontalContextualPanel_standards["prototype"]["onMainItemActivate"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onMainItemActivate"]++; }; 
	var oBrowserEvent = oEvent["mParameters"]["oBrowserEvent"];
	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ACCESS_KEY"];
	this["oNavigationData"]["oSourceControl"] = oBrowserEvent["oSourceControl"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onMainItemActivate"] = 0; };

UCF_HorizontalContextualPanel_standards["prototype"]["onSubItemActivate"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onSubItemActivate"]++; }; 
	var oBrowserEvent = oEvent["mParameters"]["oBrowserEvent"];
	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["ACCESS_KEY"];
	this["oNavigationData"]["oSourceControl"] = oBrowserEvent["oSourceControl"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onSubItemActivate"] = 0; };
/**#####################################################################################

 * SECTION THAT HANDLES FOCUS NAVIGATION

 * ##################################################################################### * */

UCF_HorizontalContextualPanel_standards["prototype"]["onlsfocus"] = function(oBowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onlsfocus"]++; }; 

	if (oBowserEvent["oSource"]["className"]["indexOf"]('Btn') > -1
		|| this["oNavigationData"]["sMeansOfFocusNavigation"] === this["eMeansOfFocusNavigation"]["NONE"]) return;
	// this.scrollFocusedIntoViewPort(oBowserEvent);
	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["NONE"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onlsfocus"] = 0; };

/**
 * An enumeration with all types of focus navigation
 *
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["eMeansOfFocusNavigation"] = {
	"ARROW_NAVIGATION": 'ARROW_NAVIGATION',
	"TAB_NAVIGATION": 'TAB_NAVIGATION',
	"ITEM_SCROLLING": 'ITEM_SCROLLING',
	"ACCESS_KEY": 'ACCESS_KEY',
	"ICON": 'ICON',
	"NONE": 'NONE'
};

/**
 * Moves the focus to the element that is to be focused.
 *
 * @param {UCF_Event} oEvent the browser event object, that occurred
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["focusByMeansOfSelection"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["focusByMeansOfSelection"]++; }; 
	/** @type {UCF_HorizontalContextualPanelItem_standards} */
	var oMainLevelSelected;
	/** @type {UCF_HorizontalContextualPanelMenuItem_standards} */
	var oSubLevelSelected;

	if (oEvent === 'undefined'
		|| oEvent === undefined
		|| oEvent === null) return;

	/**
	 * @return {string}
	 * @param {UCF_Event} oEvent
	 * @private
	 */
	function sGetEventType(oEvent) {
		if (oEvent["sName"]) {
			return oEvent["sName"];
		} else if (oEvent["mGetParameters"]) {
			return oEvent["mGetParameters"]()["oBrowserEvent"]["sName"];
		} else {
			return 'NONE';
		}
	}

	oMainLevelSelected = this["oSelectionData"]["oMainLevelItem"];
	oSubLevelSelected = this["oSelectionData"]["oSubLevelItem"];

	switch (this["oSelectionData"]["sMeansOfSelection"]) {
		case this["eMeansOfSelection"]["MAIN_MENU_ITEM_IN_SUB_MENU"]:
		case this["eMeansOfSelection"]["MAIN_MENU_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelSelected["oFocusDomRef"], 0);
			if (sGetEventType(oEvent) !== 'click')
				oMainLevelSelected["moveFocus"]();
			break;

		case this["eMeansOfSelection"]["SUB_MENU_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelSelected["oFocusDomRef"], 0);
			UCF_DomUtil["setTabIndex"](oSubLevelSelected["oFocusDomRef"], 0);
			if (sGetEventType(oEvent) !== 'click')
				oSubLevelSelected["moveFocus"]();
			break;

		case this["eMeansOfSelection"]["MAIN_HCNP_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelSelected["oFocusDomRef"], 0);
			if (sGetEventType(oEvent) !== 'click')
				oMainLevelSelected["moveFocus"]();
			break;

		case this["eMeansOfSelection"]["SUB_HCNP_ITEM"]:
			UCF_DomUtil["setTabIndex"](oSubLevelSelected["oFocusDomRef"], 0);
			if (sGetEventType(oEvent) !== 'click')
				oSubLevelSelected["moveFocus"]();
			break;

		case this["eMeansOfSelection"]["ICON"]:
			UCF_DomUtil["setTabIndex"](oMainLevelSelected["oFocusDomRef"], 0);
			oMainLevelSelected["moveFocus"]();
			break;
	}
	this["oNavigationData"]["sMeansOfFocusNavigation"] = this["eMeansOfFocusNavigation"]["SELECTION"];
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["focusByMeansOfSelection"] = 0; };

/**
 * Removes the tabIndex
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["unFocusByMeansOfSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["unFocusByMeansOfSelection"]++; }; 
	/** @type {Object} */
	var oData = this["oSelectionData"];
	/** @type {HCNP_Item} */
	var oMainLevelDeselected;
	/** @type {HCNP_Item} */
	var oSubLevelDeselected;
	/** @type {string} */
	var sField;
	/** @type {int} */
	var iIndex;

	if (oData["sStatusOfDeselectedItem"] === this["eStatusOfItemToDeselect"]["DESELECTED"]) return;

	sField = this["sCreateId"](oData["oMainLevelItem"]);
	oMainLevelDeselected = this["oGetSelectedMainItem"]();
	oMainLevelDeselected = oMainLevelDeselected["oDomRef"];
	oSubLevelDeselected = null;
	iIndex = this["iGetSelectedSubIndex"]();

	if (sField && oData["oSubLevelItem"] != null) {
		oSubLevelDeselected = this["oSubItems"][sField][iIndex]["oFocusDomRef"];
	}

	switch (oData["sMeansOfSelection"]) {
		case this["eMeansOfSelection"]["MAIN_HCNP_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelDeselected, -1);
			break;

		case this["eMeansOfSelection"]["SUB_HCNP_ITEM"]:
			UCF_DomUtil["setTabIndex"](oSubLevelDeselected, -1);
			break;

		case this["eMeansOfSelection"]["MAIN_MENU_ITEM_IN_SUB_MENU"]:
		case this["eMeansOfSelection"]["MAIN_MENU_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelDeselected, -1);
			break;

		case this["eMeansOfSelection"]["SUB_MENU_ITEM"]:
			UCF_DomUtil["setTabIndex"](oMainLevelDeselected, -1);
			UCF_DomUtil["setTabIndex"](oSubLevelDeselected, -1);
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["unFocusByMeansOfSelection"] = 0; };

/**
 * Collects and returns all object and information that is necessary during
 * focus navigation depending on the level where focus navigation occurs
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["collectNavigationData"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["collectNavigationData"]++; }; 
	/** @type {UCF_HorizontalContextualPanelItem_standards} */
	var oControl = oBrowserEvent["oSourceControl"];
	/** @type {UCF_HorizontalContextualPanelItem_standards} */
	var oFirst;
	/** @type {UCF_HorizontalContextualPanelItem_standards} */
	var oLast;
	/** @type {Object} */
	var oData = this["oNavigationData"];
	/** @type {string} */
	var sField;
	/** @type {Array} */
	var aMainItems = this["aMainItems"];
	/** @type {Array} */
	var aSubItems;
	/** @type {boolean} */
	var bScrolling = this["bIsScrollable"]();
	/** @type {Delegate} */
	var oScrolling = this["oScrolling"];
	/** @type {Delegate} */
	var oNavigation = this["oNavigation"];
	/** @type {HCNP_Item} */
	var oSourceControl = oBrowserEvent["oSourceControl"];
	/** @type {enum-list} */
	var _ = this["eLevel"];

	/** Collect necessary Data */
	if (this["bIsMainItem"](oControl) && bScrolling) {
		oScrolling = oScrolling["oMainItems"];
		oFirst = oScrolling["oGetFirstItemInViewPort"]();
		oLast = oScrolling["oGetLastItemInViewPort"]();

	} else if (this["bIsMainItem"](oControl) && !bScrolling) {
		oFirst = aMainItems[0];
		oLast = aMainItems[aMainItems["length"] - 1];

	} else if (this["bIsSubItem"](oControl) && bScrolling) {
		sField = this["sGetSubItemField"]();
		oFirst = oScrolling["oGetFirstItemInViewPort"]();
		oLast = oScrolling["oGetLastItemInViewPort"]();

	} else if (this["bIsSubItem"](oControl) && !bScrolling) {
		sField = this["sGetSubItemField"]();
		aSubItems = UCF_DomUtil["$"](sField);
		aSubItems = aSubItems["childNodes"];
		oFirst = aSubItems[0];
		oLast = aSubItems[aSubItems["length"] - 1];
	}

	oData["oSourceControl"] = oBrowserEvent["oSourceControl"];
	oData["oViewPort"] = oData["oSourceControl"]["oDomRef"]["parentNode"];

	if (this["bIsMainItem"](oControl)) {
		oData["sLevel"] = _["MAIN"];
		oData["iFocusedIndex"] = oNavigation["oMainItems"]["iFocusedIndex"];
		oData["aNavItems"] = oNavigation["oMainItems"]["aItems"];
		oData["aHcnpItems"] = aMainItems;
		oData["oFirstItemInViewPort"] = oFirst;
		oData["oLastItemInViewPort"] = oLast;
		oData["oNavigation"] = oNavigation["oMainItems"];
	} else {
		oData["sLevel"] = _["SUB"];
		oData["sMainItemId"] = oSourceControl["oDomRef"]["getAttribute"]('associatedMainItem');
		oData["iFocusedIndex"] = oNavigation[sField]["iFocusedIndex"];
		oData["aNavItems"] = oNavigation[sField]["aItems"];
		oData["aHcnpItems"] = aSubItems;
		oData["oFirstItemInViewPort"] = oFirst;
		oData["oLastItemInViewPort"] = oLast;
		oData["oNavigation"] = oNavigation[oData["oViewPort"]["id"]];
	}
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["collectNavigationData"] = 0; };

/**
 * Handles item selection by keyboard. Recognizes the item type and calls the appropriate function that changes its design.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel_standards.js(1871): onlsselect"); };
	/** @type {HCNP_Item} */
	var oSourceControl = oBrowserEvent["oSourceControl"];
	/** @type {HCNP_Item} */
	var oEvent = {};

	oEvent["mParameters"] = {};
	oEvent["mParameters"]["oItem"] = oSourceControl;

	switch (oSourceControl["sClassName"]) {
		case 'UCF_HorizontalContextualPanelItem_standards':
			this["onMainItemAccess"](oEvent);
			break;
		case 'UCF_HorizontalContextualPanelMenuItem_standards':
			this["onSubItemAccess"](oEvent);
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onlsselect"] = 0; };

/**
 * Handles the onlsshow event
 * [F4] or[ALT] + [DOWN]
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onlsshow"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel_standards.js(1898): onlsshow"); };
	/** @type {HCNP_Item} */
	var oItemToSelect = oBrowserEvent["oSourceControl"];

	var bHasMenuItems = UCF_DomUtil["$"](oItemToSelect["sId"] + '-tabmenu') != null;
	if (bHasMenuItems) {
		this["setItemToSelect"](oItemToSelect);
		this["selectMainItem"]();
		this["deselectMainItem"]();
		this["updateActionItems"]('SELECTION');
		this["focusByMeansOfSelection"]();
		this["unFocusByMeansOfSelection"]();
		this["updateAria"]();
		this["updateIndeces"]();
		this["updateScrolling"]();
		this["purgeSelectionData"]();
		this["createAndOpenMenu"](oItemToSelect);
	}

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onlsshow"] = 0; };

/**
 * Sets the correct acc text
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_HorizontalContextualPanel_standards["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "HorizontalContextualPanel_standards.js(1927): onlsaccessibility"); };

	if (window["UCF_System"]["bIsAria"]) return;

	this["collectNavigationData"](oBrowserEvent);

	if (!UCF_JsUtil["bInstanceOf"](this["oNavigationData"]["oSourceControl"], 'UCF_HorizontalContextualPanelMenuItem_standards') &&
		!UCF_JsUtil["bInstanceOf"](this["oNavigationData"]["oSourceControl"], 'UCF_HorizontalContextualPanelItem_standards')) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	var oSource = this["oNavigationData"]["oSourceControl"];
	var sControlType = (UCF_JsUtil["bInstanceOf"](oSource, 'UCF_HorizontalContextualPanelMenuItem_standards')) ? 'HCNP_LNK' : 'HCNP';
	var iItemCount = this["oNavigationData"]["oNavigation"]["aItems"]["length"];
	var iItemIndex = UCF_JsUtil["indexOf"](this["oNavigationData"]["aNavItems"], oSource);
	var bSelected = this["sGetStatusOfHcnpItemToSelect"](oSource, this["oNavigationData"]["sLevel"]) === this["eStatusOfItemToSelect"]["SELECTED_HCNP_ITEM"];
	var bEnabled = oSource["bEnabled"];

	oAccessibilityHelper["setControlType"](sControlType);
	oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](oSource["oDomRef"]));
	oAccessibilityHelper["setTooltip"](oSource["sTooltip"]);
	oAccessibilityHelper["setAccessKey"](oSource["sAccessKey"]);
	//oAccessibilityHelper.setContainingItemCount(iItemCount);
	oAccessibilityHelper["setItemCount"](iItemCount);
	oAccessibilityHelper["setItemIndex"](iItemIndex + 1);
	oAccessibilityHelper["setSelected"](bSelected);
	oAccessibilityHelper["setEnabled"](bEnabled);
	if (!bSelected && bEnabled)
		oAccessibilityHelper["addTutor"]('SELECT_TUT');
	oAccessibilityHelper["addTutor"]('LRNAV_TUT');
};;if (__UCF_COVERAGE__) { UCF_HorizontalContextualPanel_standards["_"]["onlsaccessibility"] = 0; };

UCF_HorizontalContextualPanel_standards.prototype["aPublicMethods"] = ["select"].concat(UCF_HorizontalContextualPanel_standards.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Hotkey"] = function() {/* global UCF_ControlInfo */
/// <reference path="../core/ControlInfo.js"/>

/**
 * 
 *
 * @class
 * @extends UCF_ControlInfo
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Hotkey(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Hotkey["_"]["UCF_Hotkey"]++; }; 
	UCF_ControlInfo["apply"](this, [oDomRef, oLS]);
};window["UCF_Hotkey"] = UCF_Hotkey; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Hotkey"); UCF_Hotkey["_"] = {UCF_Hotkey: 0}; }; ;
UCF_Hotkey["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ControlInfo"))(); UCF_Hotkey.prototype["sClassName"] = "UCF_Hotkey";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Hotkey["prototype"]["aAttributeNames"] = ["sHotkey","sProviderId","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Hotkey["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Hotkey["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HotkeyValue}
 */
UCF_Hotkey["prototype"]["sHotkey"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_Hotkey["prototype"]["sProviderId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Hotkey["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Hotkey["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Hotkey["_"]["setDefaultValues"]++; }; 
	this["sHotkey"] = "NONE";
	this["sProviderId"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Hotkey", "NONE", true);
		this["setClientProperty"]("ProviderId", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Hotkey["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Hotkeys"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_Hotkey */
/// <reference path="./Hotkey.js"/>

/**
 * Handles a collection of hotkeys including helper functionality for the controls using hotkeys
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Hotkeys(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["UCF_Hotkeys"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "Hotkeys.js(31): UCF_Hotkeys"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Hotkeys.js(32): UCF_Hotkeys"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Hotkeys.js(33): UCF_Hotkeys"); };

	this["bInitialized"] = false;
	this["mHotkeys"] = {};

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_Hotkeys"] = UCF_Hotkeys; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Hotkeys"); UCF_Hotkeys["_"] = {UCF_Hotkeys: 0}; }; ;
UCF_Hotkeys["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Hotkeys.prototype["sClassName"] = "UCF_Hotkeys";

/**
 * Initializes the Hotkeys
 *
 * @private
 */
UCF_Hotkeys["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["init"]++; }; 
	this["createHotkeyMap"]();
	this["bInitialized"] = true;
};;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["init"] = 0; };

/**
 * Destructor
 *
 * @private
 */
UCF_Hotkeys["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["destroy"]++; }; 
	for (var sHotKey in this["mHotkeys"]) this["mHotkeys"][sHotKey]["destroy"]();

	this["mHotkeys"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["destroy"] = 0; };

/**
 * Creates a map of hotkeys.
 *
 * @private
 */
UCF_Hotkeys["prototype"]["createHotkeyMap"] = function() {;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["createHotkeyMap"]++; }; 

	var oDomHotkeys = UCF_DomUtil["$"](this["sId"]);
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomHotkeys != null, "oDomHotkeys != null", "Hotkeys.js(72): createHotkeyMap"); };

	if (!this["bInitialized"] && oDomHotkeys) {
		var aChildNodes = UCF_DomUtil["childNodes"](oDomHotkeys, "SPAN"),
			oHotkey;

		for (var i = 0; i < aChildNodes["length"]; i++) {
			oHotkey = new (UCF_ClassLoader["oGetClass"]("UCF_Hotkey"))(aChildNodes[i], this["oLS"]);
			if (oHotkey)
				if (!this["mHotkeys"][oHotkey["sHotkey"]]) this["mHotkeys"][oHotkey["sHotkey"]] = oHotkey;
		}
		return this["mHotkeys"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["createHotkeyMap"] = 0; };

/**
 * Extracts the necessary keyboard information of the browser event and
 * returns the hotkey data or null if hotkeyList doesn't include the given hotkey.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Hotkeys["prototype"]["oGetHotkeyFromEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["oGetHotkeyFromEvent"]++; }; 

	var iKey = oBrowserEvent["iKeyCode"](),
		bShift = oBrowserEvent["bShift"]();

	if ((typeof iKey == "undefined" || iKey === 0) && oBrowserEvent["oDomEvent"]["type"] === "help") //special handling of the IE onhelp
		iKey = UCF_KeyCodes["F1"];

	if (iKey===13 && oBrowserEvent["bIsTouchInteraction"]()) {
		//IOS enables shift automatically for the first character in an InputField. (tested with onscreen keyboard and attached keyboard and in both cases was bIsTouchInteraction = true)
		//Ignore shift for enter (iKey==13)
		bShift = false;
	}

	return this["oGetHotkey"](iKey, oBrowserEvent["bCtrl"](), oBrowserEvent["bAlt"](), bShift);
};;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["oGetHotkeyFromEvent"] = 0; };

/**
 * returns the hotkey data or null if hotkeyList doesn't include the given hotkey
 *
 * @private
 */
UCF_Hotkeys["prototype"]["oGetHotkey"] = function(iKey, bCtrl, bAlt, bShift) {;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["oGetHotkey"]++; }; 
	if (!this["bInitialized"]) this["init"]();

	var sHotkey = UCF_KeyboardHelper["sHotkeyValue"](iKey, bCtrl, bAlt, bShift);
	return this["mHotkeys"][sHotkey];

};;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["oGetHotkey"] = 0; };

/**
 * returns if the hotkey was handled locally
 * e.g. Link with reference can't be handled on server therefore fire event on client
 *
 * @param {UCF_Control} oHotkey the hotkey control
 *
 * @return true if hotkey was handled locally on client
 * @type boolean
 */
UCF_Hotkeys["prototype"]["bHandleHotkeyOnClient"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["bHandleHotkeyOnClient"]++; }; 

	if (oHotkey && oHotkey["sProviderId"] != "") {
		var oProviderControl = this["oGetControlById"](oHotkey["sProviderId"], true);

		if (oProviderControl != null && (UCF_JsUtil["bInstanceOf"](oProviderControl, "UCF_Link") || UCF_JsUtil["bInstanceOf"](oProviderControl, "UCF_ToolbarLink"))) {
			if (oProviderControl["bHasReference"]) {
				oProviderControl["oDomRef"]["click"]();
				return true;
			}
		}
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["bHandleHotkeyOnClient"] = 0; };

/**
 * Should be used by the control implementation of onlshotkey() to determine
 * wether the event must be canceled or not.
 */
UCF_Hotkeys["bMustCancelLSHotKey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["bMustCancelLSHotKey"]++; }; 
	// Special handling for ctrl-F4 on Firefox: To prevent default action (close window),
	// the keypress event must be canceled AND lshotkey (keydown) must NOT be canceled!
	if (UCF_UserAgent["bIsFirefox"]() && oBrowserEvent["iKeyCode"]() == UCF_KeyCodes["F4"] && !oBrowserEvent["bAlt"]() && !oBrowserEvent["bShift"]() && oBrowserEvent["bCtrl"]()) {
		return false;
	} else {
		return true;
	}
};;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["bMustCancelLSHotKey"] = 0; };

/**
 * Should be used by the control implementation of onkeypress() to determine
 * wether the event must be canceled or not.
 */
UCF_Hotkeys["bMustCancelKeyPress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["bMustCancelKeyPress"]++; }; 
	if (UCF_UserAgent["bIsFirefox"]() && oBrowserEvent["iKeyCode"]() == UCF_KeyCodes["F4"] && !oBrowserEvent["bAlt"]() && !oBrowserEvent["bShift"]() && oBrowserEvent["bCtrl"]()) {
		return true;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["bMustCancelKeyPress"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Hotkeys["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Hotkeys["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Hotkeys["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_Hotkeys["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Hotkeys["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Hotkeys["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_HtmlIsland"] = function() {/* global _assert, _trace, _measure, START, STOP, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserWindow */
/// <reference path="../browser/BrowserWindow.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_DragAndDropDelegate */
/// <reference path="./delegates/DragAndDropDelegate.js"/>
/* global UCF_PlaceHolder */
/// <reference path="./base/PlaceHolder.js"/>

/**
 * A HtmlIsland control is a wrapper for custom HTML, JS, and CSS.
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_HtmlIsland(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["UCF_HtmlIsland"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "HtmlIsland.js(27): UCF_HtmlIsland"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "HtmlIsland.js(28): UCF_HtmlIsland"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "HtmlIsland.js(29): UCF_HtmlIsland"); };

	UCF_PlaceHolder["apply"](this, [oDomRef, oLS]);
	this["bAllowTextSelection"] = true; // If switched off, no selection works inside custom HTML, even not in input fields
	this["oPublicEventRegistration"] = {}; // Event registrations (currently allowed: contextmenu)

	// If HtmlIsland is run as placeholder control with keepalive = true, an isolated area is required,
	// so events are not handled by lightspeed. However, for some events
	// like context menu, which occurs on window level, we still need to use lightspeed eventing (IsolatedAreaEvent)
	if (this["bKeepAlive"]) {
		this["oLS"]["addIsolatedArea"](oDomRef); // Do not handle events in lightspeed for HtmlIslands
	}
	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["IsolatedAreaEvent"], this, "onisolatedareaevent");
};window["UCF_HtmlIsland"] = UCF_HtmlIsland; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_HtmlIsland"); UCF_HtmlIsland["_"] = {UCF_HtmlIsland: 0}; }; ;

UCF_HtmlIsland["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PlaceHolder"))(); UCF_HtmlIsland.prototype["sClassName"] = "UCF_HtmlIsland";

/** Constructor
 * @private
 */
UCF_HtmlIsland["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["initialize"]++; }; 
	if (__UCF_MEASURE__) { UCF_Tracer.measure(START, "UCF_HtmlIsland.initialize"); };
	UCF_PlaceHolder.prototype["initialize"]["apply"](this, arguments);
	if (this["bKeepAlive"]) {
		// Placeholder has a fixed width, therefore we can set the Html Island <div> to 100%
		this["oDomRef"]["style"]["width"] = "100%";
		this["oDomRef"]["style"]["height"] = "100%";
	}

	var oMetaDomRef = UCF_DomUtil["$"](this["sId"] + "-meta");

	// If we use placeholder, the -meta info, where scripts are stored, might be in XMP area
	if (!oMetaDomRef && this["bKeepAlive"]) {
		oMetaDomRef = UCF_DomUtil["$"](this["sId"] + "-obj");
		if (oMetaDomRef) {
			var div = document["createElement"]("div");
			UCF_DomUtil["setInnerHtml"](div, oMetaDomRef["innerHTML"]); // convert content of XMP into nodes
			// Find control element in XMP
			oMetaDomRef = UCF_DomUtil["firstChild"](div);
			while (oMetaDomRef) {
				if (oMetaDomRef["getAttribute"]("id") === this["sId"]) break;
				oMetaDomRef = UCF_DomUtil["nextSibling"](oMetaDomRef);
			}
			if (oMetaDomRef) {
				// Find -meta element in XMP
				oMetaDomRef = UCF_DomUtil["firstChild"](oMetaDomRef);
				while (oMetaDomRef) {
					if (oMetaDomRef["getAttribute"]("id") === (this["sId"] + "-meta")) {
						break;
					}
					oMetaDomRef = UCF_DomUtil["nextSibling"](oMetaDomRef);
				}
			}
			div = null;
		}
	}

	var sStyleScriptJSON = oMetaDomRef ? UCF_DomUtil["sGetInnerText"](oMetaDomRef) : null;

	if (sStyleScriptJSON) {
		// Content of oMetaDomRef is JSON serialized scripts and styles. Extract them...
		var oPage = this["oLS"]["oGetPageInternal"](),
			oScriptsStyles = {},
			oEntry = {};

		try {
			oScriptsStyles = UCF_JsUtil["oJsonParse"](sStyleScriptJSON);
		} catch (e) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Cannot convert " + sStyleScriptJSON + " to JSON Object in HTMLIsland " + this["sId"], "HtmlIsland.js(97): initialize"); };
		}
		// .. and add them to the page
		while (oScriptsStyles["styles"] && oScriptsStyles["styles"]["length"] > 0) {
			oEntry = oScriptsStyles["styles"]["shift"]();
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Adding style with src="' + oEntry["src"] + '", content="' + oEntry["content"] + '"', "HtmlIsland.js(102): initialize"); };
			if (oPage)
				oPage["addStyle"](oEntry["src"], oEntry["content"]);
		}

		while (oPage && oScriptsStyles["scripts"] && oScriptsStyles["scripts"]["length"] > 0) {
			oEntry = oScriptsStyles["scripts"]["shift"]();
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Adding script with src="' + oEntry["src"] + '", content="' + oEntry["content"] + '"', "HtmlIsland.js(109): initialize"); };
			oPage["addScript"](oEntry["src"], oEntry["content"], oEntry["customAttributes"]);
		}
	}
	// Remove node so next time we get it fresh
	if (oMetaDomRef && oMetaDomRef["parentNode"]) {
		oMetaDomRef["parentNode"]["removeChild"](oMetaDomRef);
	}

	/*
	 * lock and unlock could be passed to the application
	 */
	//this.attachLSEvent(this.oLS.E_EVENTS.Lock, "lock");
	//this.attachLSEvent(this.oLS.E_EVENTS.Unlock, "unlock");
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["initialize"] = 0; };

/** Destructor
 * @private
 */
UCF_HtmlIsland["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["destroy"]++; }; 
	if (__UCF_MEASURE__) { UCF_Tracer.measure(START, "UCF_HtmlIsland.destroy"); };

	if (this["sTimerId"]) UCF_JsUtil["clearDelayedCall"](this["sTimerId"]);

	// Application can register a unload/destroy call, execute it now
	if (this["sUnLoad"]) {
		UCF_JsUtil["eval"](this["sUnLoad"]);
	}

	// eslint-disable-next-line @ur/no-memory-leaks
	this["oDragAndDropDelegate"] = null;
	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["IsolatedAreaEvent"], this, "onisolatedareaevent");
	this["removeAllEventListeners"]();
	this["oPublicEventRegistration"] = null;
	/*
	 * lock and unlock could be passed to the application
	 */
	//	this.detachLSEvent(this.oLS.E_EVENTS.Lock, "lock");
	//	this.detachLSEvent(this.oLS.E_EVENTS.Unlock, "unlock");
	UCF_PlaceHolder.prototype["destroy"]["apply"](this, arguments);
	if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, "UCF_HtmlIsland.destroy", "HtmlIsland " + this["sId"] + " destroyed  "); };
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["destroy"] = 0; };

/**
 * @public
 * @return {boolean} whether it is alive
 * @see UCF_PlaceHolder
 */
UCF_HtmlIsland["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["bDoKeepAlive"]++; }; 
	return (this["bKeepAlive"] && UCF_DomUtil["$"](this["sId"] + "-ph")) ? true : false;
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["bDoKeepAlive"] = 0; };

/**
 * set a handler for drag and drop processing
 * @public
 * @param {UCF_DragAndDropHandler} oDragAndDropHandler a drag and drop handler implementing lsdragstart, lsdrag, lsdragover, lsdraghover, lsdragscroll, lsdrop, lsdragend, lsdragenter, lsdragleave,
 */
UCF_HtmlIsland["prototype"]["setDragAndDropHandler"] = function(oDragAndDropHandler) {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["setDragAndDropHandler"]++; }; 

	if (this["oDragAndDropDelegate"])
		this["removeDelegate"](this["oDragAndDropDelegate"]);

	if (!oDragAndDropHandler)
		return;

	this["oDragAndDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragAndDropDelegate"))(oDragAndDropHandler);
	this["addDelegate"](this["oDragAndDropDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["setDragAndDropHandler"] = 0; };

/**
 * HtmlIsland is an isolated area, however, events that occur on window level (like context menu)
 * should also be available to the island developer.
 * @public
 * @param {UCF_Event} oEvent browser event
 */
UCF_HtmlIsland["prototype"]["onisolatedareaevent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["onisolatedareaevent"]++; }; 
	var oBrowserEvent = oEvent["mParameters"]["oBrowserEvent"];

	if (!this["oPublicEventRegistration"] || !this["oPublicEventRegistration"][oEvent["mParameters"]["type"]] || !UCF_DomUtil["bContains"](this["oDomRef"], oBrowserEvent["oSource"])) {
		// No registration for this event or event does not belong to this instance of isolated area
		if (oEvent["mParameters"]["type"] === "contextmenu" && typeof(oBrowserEvent["bContinue"]) === "undefined") {
			// For the context menu event, we trigger the normal behavior
			oBrowserEvent["bContinue"] = true;
		}
		return;
	}

	var aRegistrations = this["oPublicEventRegistration"][oEvent["mParameters"]["type"]];
	for (var i = 0, max = aRegistrations["length"]; i < max; i++) {
		aRegistrations[i](oBrowserEvent["oDomEvent"]);
	}
	if (!oBrowserEvent["oDomEvent"]["cancelBubble"]) {
		// If the island developer does not cancelBubble, we continue with the normal behavior ...
		oBrowserEvent["bContinue"] = true;
	} else {
		// ... otherwise we stop processing
		oBrowserEvent["bContinue"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["onisolatedareaevent"] = 0; };

UCF_HtmlIsland["prototype"]["addEventListener"] = function(sName, fHandler) {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["addEventListener"]++; }; 
	if (!sName || !fHandler || typeof fHandler !== "function" || !this["oDomRef"]) {
		return;
	}

	// Currently we only support to add event handler for "contextmenu". More event registrations may follow
	if (sName !== "contextmenu") {
		return;
	}

	if (!this["oPublicEventRegistration"][sName]) {
		this["oPublicEventRegistration"][sName] = [];
	}
	// Add the registration
	this["oPublicEventRegistration"][sName]["push"](fHandler);
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["addEventListener"] = 0; };

UCF_HtmlIsland["prototype"]["removeEventListener"] = function(sName, fHandler) {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["removeEventListener"]++; }; 
	if (!this["oPublicEventRegistration"] || !sName || !this["oPublicEventRegistration"][sName] || !fHandler || typeof fHandler !== "function") {
		return;
	}

	var aRegistrations = this["oPublicEventRegistration"][sName];

	// Remove event registration.
	// (The first that occurs for given event name and function. If multiple are registered, this needs to be done multiple times as well)
	var i = aRegistrations["indexOf"](fHandler);
	if (i !== -1) {
		aRegistrations["splice"](i, 1);
	}

	if (this["oPublicEventRegistration"][sName]["length"] === 0) {
		this["oPublicEventRegistration"][sName] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["removeEventListener"] = 0; };

UCF_HtmlIsland["prototype"]["removeAllEventListeners"] = function() {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["removeAllEventListeners"]++; }; 
	for (var sName in this["oPublicEventRegistration"]) {
		this["oPublicEventRegistration"][sName] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["removeAllEventListeners"] = 0; };

UCF_HtmlIsland["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["applyFocusInfo"]++; }; 
	// Focus could lead to troubles with custom context menues
	// However, we could let the HtmlIsland custom code register
	// on focus event
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["applyFocusInfo"] = 0; };

// lock and unlock could be passed to the application
/*
UCF_HtmlIsland.prototype.lock = function(oEvent) {
};

UCF_HtmlIsland.prototype.unlock = function(oEvent) {
};
*/

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_HtmlIsland["prototype"]["aAttributeNames"] = ["sId","sUnLoad","sVisibility","sLifeCycle","sCustomData","sLabelledBy","sTooltip","sAccessibilityDescription"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_HtmlIsland["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_HtmlIsland["prototype"]["aMethodNames"] = ["setDragAndDropHandler","setKeepAlive","addEventListener","removeEventListener","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sUnLoad"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_HtmlIsland["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_HtmlIsland["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_HtmlIsland["prototype"]["sAccessibilityDescription"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_HtmlIsland["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sUnLoad"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sLifeCycle"] = "BROWSER";
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';
	this["sTooltip"] = '';
	this["sAccessibilityDescription"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("UnLoad", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_HtmlIsland["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_HtmlIsland.prototype["aPublicMethods"] = ["bDoKeepAlive","setDragAndDropHandler","onisolatedareaevent"].concat(UCF_HtmlIsland.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_IHub"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * Class LS IHub
 *
 * Integration Hub  - main class
 *
 * 
 * @class
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS}   oLS   reference to Lightspeed object
 */
function UCF_IHub(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_IHub["_"]["UCF_IHub"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "IHub.js(22): UCF_IHub"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "IHub.js(23): UCF_IHub"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "IHub.js(24): UCF_IHub"); };

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "IHub.js(26): UCF_IHub"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_IHub"] = UCF_IHub; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_IHub"); UCF_IHub["_"] = {UCF_IHub: 0}; }; ;
UCF_IHub["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_IHub.prototype["sClassName"] = "UCF_IHub";

UCF_IHub["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["destroy"]++; }; 
	this["mTargets"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["destroy"] = 0; };

//--------------------------------------
//  <span id="aaa" ct="IHUB">
//     <span id="bbb" ct="IHUBEVENTING">
//     <span id="bbb" ct="IHUBNAVIGATION">
//     <span id="bbb" ct="IHUBWORKPROTECT">
//     ...

// --------- plugin synchronisation & forced load -----------------

/**
 * List of Plugins that need perform actions immediatly
 * the main IHUB control gets initialized
 *
 * @public
 */
UCF_IHub["prototype"]["M_FORCED_LOAD"] = ["IHUBWEBSOCKET", "IHUBWORKPROTECT", "IHUBLEGACYWDJ", "IHUBFRAMEPROTECT", "IHUBPOSTMESSAGE"];
UCF_IHub["prototype"]["HUBPLUGIN_TAG"] = "SPAN";

/**
 * Check whether the plugin specified by control type must be
 * loaded directly after the IHub is present - typically needed
 * for those plugins that rely on onload-actions and i.e. hooking events
 * @param {string} sControlType
 * @return {boolean}
 *
 */
UCF_IHub["prototype"]["bIsForcedLoad"] = function(sControlType) {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["bIsForcedLoad"]++; }; 
	for (var i = 0; i < this["M_FORCED_LOAD"]["length"]; i++) {
		if (sControlType == this["M_FORCED_LOAD"][i]) return true;
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["bIsForcedLoad"] = 0; };

/**
 * Initialize IHub - see also initalizeIds sections
 */
UCF_IHub["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["initialize"]++; }; 

	this["mTargets"] = this["connectTargets"]();

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Dependant IHub-Plugins - check for forced load ", "IHub.js(78): initialize"); };

	var mNodes = UCF_DomUtil["childNodes"](this["oDomRef"], this["HUBPLUGIN_TAG"]);
	for (var i = 0; i < mNodes["length"]; i++) {
		var sCt = mNodes[i]["getAttribute"]("ct");
		if ((sCt) && this["bIsForcedLoad"](sCt)) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "ForcedLoad for " + sCt, "IHub.js(84): initialize"); };
			var sPluginId = mNodes[i]["getAttribute"]("id");
			var oPluginDomRef = UCF_DomUtil["$"](sPluginId);
			this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oPluginDomRef, true);
		}
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Dependant IHUB-Plugins loaded & created", "IHub.js(91): initialize"); };
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["initialize"] = 0; };

// --------------- Constants ----
/**
 *  @public
 */
UCF_IHub["prototype"]["E_TARGETS"] = {
	"EPCM": "EPCM",
	"LSAPI": "LSAPI", // depends on EPCM, do not change the order !
	"PAGESUPPORT": "pageSupport"
};

// -------------  Access to target objects -------------

/**
 * Fetch the reference to neede target objects and keep it for later usage
 * @return {map} mTargetMap
 */
UCF_IHub["prototype"]["connectTargets"] = function() {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["connectTargets"]++; }; 
	var mTargetMap = {};
	var oRef = null;

	for (var sKey in this["E_TARGETS"]) {

		var sTargetName = this["E_TARGETS"][sKey];

		switch (sTargetName) {
			case this["E_TARGETS"]["EPCM"]:
				oRef = this["findEPCM"]();
				break;

			case this["E_TARGETS"]["PAGESUPPORT"]:
				oRef = this["findPageSupport"]();
				break;

			case this["E_TARGETS"]["LSAPI"]:
				oRef = this["findLSAPI"](mTargetMap[this["E_TARGETS"]["EPCM"]]);
				break;

			default:
				oRef = null;
				break;
		}
		mTargetMap[sTargetName] = oRef;
	}
	return mTargetMap;
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["connectTargets"] = 0; };

/**
 * Generic search for any JavaScript object, starting from current frame upwards
 * @param {string} sName   object name we are searching for
 * @param {Object} oBaseFrameRef  frame reference we start from
 * @param {int} iLevelUpMin minimal parent level needed  (0= oBaseFrameRef, 1=parent, 2=parent.parent ...)
 * @param {int} iLevelUpMax maximal parent level allowed (0= oBaseFrameRef, 1=parent, 2=parent.parent ...)
 * @return {object}
 * @private
 */
UCF_IHub["prototype"]["findObject"] = function(sName, oBaseFrameRef, iLevelUpMin, iLevelUpMax) {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["findObject"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iLevelUpMin >= 0, "iLevelUpMin >= 0", "IHub.js(150): findObject"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iLevelUpMax >= iLevelUpMin, "iLevelUpMax >= iLevelUpMin", "IHub.js(151): findObject"); };

	var oFrame = oBaseFrameRef;
	try {
		for (var iLevel = 0; iLevel <= iLevelUpMax; iLevel++) {

			if (iLevel >= iLevelUpMin) {
				if (oFrame[sName]) {
					if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Object: " + sName + " found on parent level " + iLevel + " (expected " + iLevelUpMin + "-" + iLevelUpMax + ")", "IHub.js(159): findObject"); };
					return oFrame[sName];
				}
			}
			if (oFrame != top) {
				oFrame = oFrame["parent"];
			}
		}
	} catch (ex) {; }
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Object: " + sName + " not found  - (expected on parent level " + iLevelUpMin + "-" + iLevelUpMax + ")", "IHub.js(168): findObject"); };
	return null;
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["findObject"] = 0; };

/*
 * Find LSAPI (LShape API) object
 */
UCF_IHub["prototype"]["findLSAPI"] = function(oEPCM) {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["findLSAPI"]++; }; 

	// try native external LSAPI object first
	try {
		if (window["external"] && window["external"]["LSAPI"]) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Object: LSAPI found on window.external", "IHub.js(180): findLSAPI"); };
			return window["external"]["LSAPI"];
		}
	} catch (ex) {; }

	// check the SAP topmost fraem via EPCM
	var oLSAPI = null;

	try {
		oLSAPI = oEPCM["getSAPTop"]()["LSAPI"];
		if (oLSAPI) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Object: LSAPI found on SAP-top frame", "IHub.js(191): findLSAPI"); };
			return oLSAPI;
		}
	} catch (ex) {; }

	// last fallback is to directly search for up to 2 levels
	return this["findObject"](this["E_TARGETS"]["LSAPI"], window, 0, 2);
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["findLSAPI"] = 0; };

/*
 * Find EPCM (Enterprise Portal Client Manager) object
 */
UCF_IHub["prototype"]["findEPCM"] = function() {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["findEPCM"]++; }; 
	// search only in the current or eventually parent frame
	return this["findObject"](this["E_TARGETS"]["EPCM"], window, 0, 1);
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["findEPCM"] = 0; };

/*
 * Find pageSupport object
 */
UCF_IHub["prototype"]["findPageSupport"] = function() {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["findPageSupport"]++; }; 
	// ingore local level and search it on parent only, to avoid sideeffects in WDJ
	return this["findObject"](this["E_TARGETS"]["PAGESUPPORT"], window, 1, 1);
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["findPageSupport"] = 0; };

// ------- Access to target objects ------------------------------
/**
 * Get a target object by its name
 * @param {string} sName name of the object
 * @return {object} the object
 * @public
 */
UCF_IHub["prototype"]["oGetTargetObject"] = function(sName) {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["oGetTargetObject"]++; }; 
	return this["mTargets"][sName];
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["oGetTargetObject"] = 0; };

/**
 * Get LShape API object
 * @public
 * @return {object} the object
 */
UCF_IHub["prototype"]["oGetLSAPI"] = function() {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["oGetLSAPI"]++; }; 
	return this["mTargets"][this["E_TARGETS"]["LSAPI"]];
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["oGetLSAPI"] = 0; };

/**
 * Get EPCM object
 * @public
 * @return {object} the object
 */
UCF_IHub["prototype"]["oGetEPCM"] = function() {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["oGetEPCM"]++; }; 
	return this["mTargets"][this["E_TARGETS"]["EPCM"]];
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["oGetEPCM"] = 0; };

/**
 * Get pageSupport object
 * @public
 * @return {object} the object
 */
UCF_IHub["prototype"]["oGetPageSupport"] = function() {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["oGetPageSupport"]++; }; 
	return this["mTargets"][this["E_TARGETS"]["PAGESUPPORT"]];
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["oGetPageSupport"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_IHub["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_IHub["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_IHub["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_IHub["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_IHub["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_IHub["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_IHub["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_IHub.prototype["aPublicMethods"] = ["oGetTargetObject","oGetLSAPI","oGetEPCM","oGetPageSupport"].concat(UCF_IHub.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_IHubEventing"] = function() {/* global _assert, _trace, INFO, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * Class LS IHub Eventing
 *
 * Integration Hub Plugin for (Portal) Eventing
 *
 * 
 * @class
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS}   oLS   reference to Lightspeed object
 */
function UCF_IHubEventing(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["UCF_IHubEventing"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "IHubEventing.js(21): undefined"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "IHubEventing.js(22): undefined"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "IHubEventing.js(23): undefined"); };

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "IHubEventing.js(25): undefined"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["defineEvents"](['InternalEvent']);

	this["oIHub"] = this["oGetParent"]();
	this["oEPCM"] = this["oIHub"]["oGetEPCM"]();

	this["sExternalEventHandler"] = "UCF_externalEventHandler_" + this["sId"];

	var oHubEventing = this;
	window[this["sExternalEventHandler"]] = function(oExternalEvent) {
		oHubEventing["externalEventHandler"](oExternalEvent);
	};

	this["mSubscrMap"] = {};

};window["UCF_IHubEventing"] = UCF_IHubEventing; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_IHubEventing"); UCF_IHubEventing["_"] = {UCF_IHubEventing: 0}; }; ;
UCF_IHubEventing["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_IHubEventing.prototype["sClassName"] = "UCF_IHubEventing";

UCF_IHubEventing["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["destroy"]++; }; 

	this["unsubscribeAllEvents"]();

	this["oEPCM"] = null;
	this["oIHub"] = null;
	window[this["sExternalEventHandler"]] = undefined;
	try {
		delete window[this["sExternalEventHandler"]];
	} catch (e) {}

	this["mSubscrMap"] = null;
	this["sExternalEventHandler"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["destroy"] = 0; };

// ----------------- API ----------------

UCF_IHubEventing["prototype"]["UNIQUE_SEPARATOR"] = "#";

/**
 * creates unique event id as the combination of namespace and name
 * @param {string} sNamespace
 * @param {string} sName
 * @return {string} the unique id
 */
UCF_IHubEventing["prototype"]["sCreateUniqueId"] = function(sNamespace, sName) {;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["sCreateUniqueId"]++; }; 

	if (sNamespace !== "") return sNamespace + this["UNIQUE_SEPARATOR"] + sName;
	else return sName;
};;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["sCreateUniqueId"] = 0; };

/**
 * external event handler used for delegation of portal event calls to the framework
 * @param {Object} oExternalEvent the external Event
 */
UCF_IHubEventing["prototype"]["externalEventHandler"] = function(oExternalEvent) {;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["externalEventHandler"]++; }; 
	var sName = oExternalEvent["eventName"],
		sNamespace = oExternalEvent["eventNamespace"],
		sDataObject = oExternalEvent["dataObject"];

	this["fireEvent"](this["E_EVENTS"]["InternalEvent"], { "sName": sName, "sNamespace": sNamespace, "sDataObject": sDataObject });
	this["fireExternalEvent"](this["sId"], sNamespace, sName, sDataObject);
};;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["externalEventHandler"] = 0; };

/**
 *   Raise Event
 *   @param {string} sNamespace  Event Namespace
 *   @param {string} sName       Event Name
 *   @param {string} sData       Event Data passed along with Event
 *   @public
 */
UCF_IHubEventing["prototype"]["raiseEvent"] = function(sNamespace, sName, sData) {;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["raiseEvent"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNamespace != null, "sNamespace != null", "IHubEventing.js(101): raiseEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNamespace) === "string", "typeof(sNamespace) === \"string\"", "IHubEventing.js(102): raiseEvent"); };

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != null, "sName != null", "IHubEventing.js(104): raiseEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) === "string", "typeof(sName) === \"string\"", "IHubEventing.js(105): raiseEvent"); };

	var sUniqueEventId = this["sCreateUniqueId"](sNamespace, sName);

	try {
		//------------------
		this["oEPCM"]["raiseEvent"](sNamespace, sName, sData);
		//------------------
	} catch (ex) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "IHub.Eventing.raiseEvent :: failed " + sUniqueEventId, "IHubEventing.js(114): raiseEvent"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["raiseEvent"] = 0; };

/**
 *   Subscribe Event
 *   @param {string} sNamespace  Event Namespace
 *   @param {string} sName       Event Name
 *   @param {boolean} bIsReliable       Event Data passed along with Event
 *   @public
 */
UCF_IHubEventing["prototype"]["subscribeEvent"] = function(sNamespace, sName, bIsReliable) {;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["subscribeEvent"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNamespace != null, "sNamespace != null", "IHubEventing.js(127): subscribeEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNamespace) === "string", "typeof(sNamespace) === \"string\"", "IHubEventing.js(128): subscribeEvent"); };

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != null, "sName != null", "IHubEventing.js(130): subscribeEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) === "string", "typeof(sName) === \"string\"", "IHubEventing.js(131): subscribeEvent"); };

	var sUniqueEventId = this["sCreateUniqueId"](sNamespace, sName),
		oSubscrItem = this["mSubscrMap"][sUniqueEventId];

	// avoid duplicate subscriptions
	if (oSubscrItem && oSubscrItem["isSubscribed"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "IHub.Eventing.subscribeItem :: already subscribed, skip " + sUniqueEventId, "IHubEventing.js(138): subscribeEvent"); };
		return;
	}

	try {
		var PortalELID;
		// ------------------
		if (bIsReliable) PortalELID = this["oEPCM"]["subscribeEventReliable"](sNamespace, sName, window, this["sExternalEventHandler"]);
		else PortalELID = this["oEPCM"]["subscribeEvent"](sNamespace, sName, window, this["sExternalEventHandler"]);
		// ------------------
		var oNewSubscrItem = { "EvtNamespace": sNamespace, "EvtName": sName, "PortalELID": PortalELID, "isSubscribed": true };
		this["mSubscrMap"][sUniqueEventId] = oNewSubscrItem;

		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "IHub.Eventing.subscribeEvent :: subscribed " + sUniqueEventId + " ELID:" + PortalELID, "IHubEventing.js(151): subscribeEvent"); };

	} catch (ex) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "IHub.Eventing.subscribeEvent :: failed " + sUniqueEventId, "IHubEventing.js(154): subscribeEvent"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["subscribeEvent"] = 0; };

/**
 *   Unsubscribe Event
 *   @param {string} sNamespace  Event Namespace
 *   @param {string} sName       Event Name
 *   @public
 */
UCF_IHubEventing["prototype"]["unsubscribeEvent"] = function(sNamespace, sName) {;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["unsubscribeEvent"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNamespace != null, "sNamespace != null", "IHubEventing.js(166): unsubscribeEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNamespace) === "string", "typeof(sNamespace) === \"string\"", "IHubEventing.js(167): unsubscribeEvent"); };

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != null, "sName != null", "IHubEventing.js(169): unsubscribeEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) === "string", "typeof(sName) === \"string\"", "IHubEventing.js(170): unsubscribeEvent"); };

	var sUniqueEventId = this["sCreateUniqueId"](sNamespace, sName);
	var oSubscrItem = this["mSubscrMap"][sUniqueEventId];

	try {
		if (oSubscrItem && oSubscrItem["isSubscribed"]) {
			// ------------------
			this["oEPCM"]["unsubscribeEvent"](sNamespace, sName, oSubscrItem["PortalELID"]);
			// ------------------
			oSubscrItem["isSubscribed"] = false;
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "IHub.Eventing.subscribeItem :: unsubscribed " + sUniqueEventId + " ELID:" + oSubscrItem["PortalELID"], "IHubEventing.js(181): unsubscribeEvent"); };
		}
	} catch (ex) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "IHub.Eventing.unsubscribeEvent :: failed " + sUniqueEventId, "IHubEventing.js(184): unsubscribeEvent"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["unsubscribeEvent"] = 0; };

/**
 * Unsubscribe all events - used internally for cleanup of the plugin
 */
UCF_IHubEventing["prototype"]["unsubscribeAllEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["unsubscribeAllEvents"]++; }; 

	var oSubscrItem;

	// unsubscribe all items
	for (var sUniqueEventId in this["mSubscrMap"]) {
		oSubscrItem = this["mSubscrMap"][sUniqueEventId];

		if (oSubscrItem && oSubscrItem["isSubscribed"]) {
			this["unsubscribeEvent"](oSubscrItem["EvtNamespace"], oSubscrItem["EvtName"], oSubscrItem["PortalELID"]);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["unsubscribeAllEvents"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_IHubEventing["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_IHubEventing["prototype"]["aEventNames"] = ["ExternalEvent"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_IHubEventing["prototype"]["aMethodNames"] = ["raiseEvent","subscribeEvent","unsubscribeEvent","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_IHubEventing["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_IHubEventing["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control 
 * @param {string} sNamespace Event Namespace
 * @param {string} sName Event Name
 * @param {string} sData Event Data
 * @fires IHubEventing::ExternalEvent
 */
UCF_IHubEventing["prototype"]["fireExternalEvent"] = function(sId, sNamespace, sName, sData) {;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["fireExternalEvent"]++; }; 
	/** @type {{Id: string, Namespace: string, Name: string, Data: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "IHubEventing.js(256): fireExternalEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "IHubEventing.js(257): fireExternalEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "IHubEventing.js(258): fireExternalEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNamespace != null, "sNamespace != null", "IHubEventing.js(259): fireExternalEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNamespace) == "string", "typeof(sNamespace) == \"string\"", "IHubEventing.js(260): fireExternalEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != null, "sName != null", "IHubEventing.js(261): fireExternalEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) == "string", "typeof(sName) == \"string\"", "IHubEventing.js(262): fireExternalEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "IHubEventing.js(263): fireExternalEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "IHubEventing.js(264): fireExternalEvent"); };
	mParams = {
		"Id": sId,
		"Namespace": sNamespace,
		"Name": sName,
		"Data": sData
	};
	
	
	
	
	this["fireSemanticEvent"]("IHubEventing", "ExternalEvent", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_IHubEventing["_"]["fireExternalEvent"] = 0; };

UCF_IHubEventing.prototype["aPublicMethods"] = ["raiseEvent","subscribeEvent","unsubscribeEvent"].concat(UCF_IHubEventing.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_IHubFrameProtect"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserWindow */
/// <reference path="../browser/BrowserWindow.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * Class LS IHubFrameProtect
 *
 * Integration Hub Plugin for Handling of Frame Protect mode (ClickJack prevention)
 *
 * 
 * @class
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS}   oLS   reference to Lightspeed object
 */
function UCF_IHubFrameProtect(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["UCF_IHubFrameProtect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "IHubFrameProtect.js(27): UCF_IHubFrameProtect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "IHubFrameProtect.js(28): UCF_IHubFrameProtect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "IHubFrameProtect.js(29): UCF_IHubFrameProtect"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oIHub"] = this["oGetParent"]();

	UCF_IHubFrameProtect["sWhitelist"] = oDomRef["getAttribute"]('wl');
	UCF_IHubFrameProtect["sMessageWhitelist"] = oDomRef["getAttribute"]('msgwhitelist');
	UCF_IHubFrameProtect["sMessageNoResponse"] = oDomRef["getAttribute"]('msgnoresponse');
	UCF_IHubFrameProtect["sMessageNoWhiteListService"] = oDomRef["getAttribute"]('msgwsnotreached');
	UCF_IHubFrameProtect["sProtectMethod"] = oDomRef["getAttribute"]('prm');

	UCF_IHubFrameProtect["oLS"] = oLS;
	var head = document["getElementsByTagName"]('head')[0];

	if (UCF_IHubFrameProtect["sProtectMethod"] === 'LOCKEVENTS') {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_IHubFrameProtect locking events.', "IHubFrameProtect.js(45): UCF_IHubFrameProtect"); };
		oLS["oBrowserWindow"]["lock"](UCF_BrowserWindow["LOCKTYPES"]["FRAMEPROTECT"]);
	} else if (UCF_IHubFrameProtect["sProtectMethod"] === 'HIDEBODY') {
		var style = document["createElement"]('style');
		style["id"] = 'SAP-antiClickjackStyle';
		style["nonce"] = window["UCF_System"]["sNonce"];
		head["appendChild"](style);
		try {
			style["innerHTML"] = 'body { display: none !important; }';
		} catch (e) {
			// Quirks Mode must be done after head.appendChild(style); :-(
			style["styleSheet"]["cssText"] = 'body { display: none !important; }';
		}
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_IHubFrameProtect White list: ' + UCF_IHubFrameProtect["sWhitelist"] + '.', "IHubFrameProtect.js(59): UCF_IHubFrameProtect"); };

	if (oDomRef["getAttribute"]('ClickjackProtectionScript') &&
		oDomRef["getAttribute"]('ClickjackProtectionScript') !== '') {
		var script = document["createElement"]('script');
		script["type"] = 'text/javascript';
		script["src"] = oDomRef["getAttribute"]('ClickjackProtectionScript');
		script["id"] = 'SAP-antiClickjackScript';
		if (oDomRef["getAttribute"]('wl'))
			script["setAttribute"]('data-whiteList', oDomRef["getAttribute"]('wl'));
		if (oDomRef["getAttribute"]('WhitelistService'))
			script["setAttribute"]('data-checkService', oDomRef["getAttribute"]('WhitelistService'));
		if (oDomRef["getAttribute"]('msgwhitelist'))
			script["setAttribute"]('data-deniedMessage', oDomRef["getAttribute"]('msgwhitelist'));
		if (oDomRef["getAttribute"]('msgnoresponse'))
			script["setAttribute"]('data-releaseTimeoutMessage', oDomRef["getAttribute"]('msgnoresponse'));
		if (oDomRef["getAttribute"]("timeoutvalue"))
			script["setAttribute"]('data-releaseTimeoutValue', oDomRef["getAttribute"]('timeoutvalue'));
		if (oDomRef["getAttribute"]('msgwsnotreached'))
			script["setAttribute"]('data-whiteListServiceNotReachedMessage', oDomRef["getAttribute"]('msgwsnotreached'));
		if (oDomRef["getAttribute"]('AllowSameOrigin'))
			script["setAttribute"]('data-allowSameOrigin', oDomRef["getAttribute"]('AllowSameOrigin'));
		if (UCF_IHubFrameProtect["sProtectMethod"] === 'LOCKEVENTS')
			script["setAttribute"]('data-applyProtectionCallback', 'UCF_IHubFrameProtect.applyProtection');
		else
			script["setAttribute"]('data-styleId', 'SAP-antiClickjackStyle');
		head["appendChild"](script);
	} else {
		if (!UCF_IHubFrameProtect["sWhitelist"])
			UCF_IHubFrameProtect["sWhitelist"] = '';
		UCF_IHubFrameProtect["initDeprecated"]();
	}
};window["UCF_IHubFrameProtect"] = UCF_IHubFrameProtect; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_IHubFrameProtect"); UCF_IHubFrameProtect["_"] = {UCF_IHubFrameProtect: 0}; }; ;
UCF_IHubFrameProtect["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_IHubFrameProtect.prototype["sClassName"] = "UCF_IHubFrameProtect";

UCF_IHubFrameProtect["sWhitelist"] = '';
UCF_IHubFrameProtect["sMessageWhitelist"] = '';
UCF_IHubFrameProtect["sMessageNoResponse"] = '';
UCF_IHubFrameProtect["sMessageNoWhiteListService"] = '';

UCF_IHubFrameProtect["cEnabled"] = '';
UCF_IHubFrameProtect["sProtectMethod"] = '';
UCF_IHubFrameProtect["oLS"] = null;

UCF_IHubFrameProtect["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["destroy"]++; }; 
	this["oIHub"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["destroy"] = 0; };

UCF_IHubFrameProtect["applyProtection"] = function(bProtection) {;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["applyProtection"]++; }; 
	if (bProtection)
		UCF_IHubFrameProtect["oLS"]["oBrowserWindow"]["unlock"](UCF_BrowserWindow["LOCKTYPES"]["FRAMEPROTECT"]);
};;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["applyProtection"] = 0; };

// Deprecated Code - just for compatibility
UCF_IHubFrameProtect["initDeprecated"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["initDeprecated"]++; }; 
	UCF_DomUtil["attachEvent"](window, 'message', UCF_IHubFrameProtect["onMessage"], false);
	if (window["parent"] !== self || window["opener"] != null) {
		// are the iframes from the same domain
		// just try to access all of the frames until top
		try {
			var test = window["parent"]["window"];
			var bOk = false;
			do {
				var test1 = test["document"]["domain"];
				if (test === top) {
					// eslint-disable-next-line eqeqeq
					if (test1 != undefined)
						bOk = true;
					break;
				}
				test = test["parent"]["window"];
			}
			while (true);
			if (bOk) {
				UCF_IHubFrameProtect["cEnabled"] = 'S';
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_IHubFrameProtect: Can access top.', "IHubFrameProtect.js(135): initDeprecated"); };
				UCF_IHubFrameProtect["release"]();
				UCF_IHubFrameProtect["notifyChildFrames"]();
			} else {
				window["parent"]["postMessage"]('SAPFrameProtection*require-origin', '*');
				window["setTimeout"](UCF_IHubFrameProtect["NoResponseAlert"], 5000);
			}
		} catch (e) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_IHubFrameProtect: cannot access top, sending SAP require origin message.', "IHubFrameProtect.js(143): initDeprecated"); };
			window["parent"]["postMessage"]('SAPFrameProtection*require-origin', '*');
			window["setTimeout"](UCF_IHubFrameProtect["NoResponseAlert"], 5000);
		}
	} else /* toplevel */ {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_IHubFrameProtect: Top level document.', "IHubFrameProtect.js(148): initDeprecated"); };
		UCF_IHubFrameProtect["release"]();
		UCF_IHubFrameProtect["notifyChildFrames"]();
	}
};;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["initDeprecated"] = 0; };

UCF_IHubFrameProtect["release"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["release"]++; }; 
	UCF_IHubFrameProtect["cEnabled"] = 'S';
	if (UCF_IHubFrameProtect["sProtectMethod"] === 'HIDEBODY') {
		var oAntiClickjackStyle = document["getElementById"]('SAP-antiClickjackStyle');
		if (oAntiClickjackStyle)
			oAntiClickjackStyle["parentNode"]["removeChild"](oAntiClickjackStyle);
	} else
		UCF_IHubFrameProtect["oLS"]["oBrowserWindow"]["unlock"](UCF_BrowserWindow["LOCKTYPES"]["FRAMEPROTECT"]);
};;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["release"] = 0; };

UCF_IHubFrameProtect["onMessage"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["onMessage"]++; }; 
	try {
		if (oEvent["data"] === 'SAPFrameProtection*parent-unlocked') {
			if (oEvent["source"] === window["parent"] && UCF_IHubFrameProtect["checkHostName"](oEvent["origin"])) {
				UCF_IHubFrameProtect["release"]();
				UCF_IHubFrameProtect["notifyChildFrames"]();
			}
		} else if (oEvent["data"] === 'SAPFrameProtection*require-origin' && window["event"]["source"] !== window) {
			if (UCF_IHubFrameProtect["cEnabled"] === "S")
				oEvent["source"]["postMessage"]('SAPFrameProtection*parent-unlocked', '*');
			else
				oEvent["source"]["postMessage"]('SAPFrameProtection*parent-origin', '*');
		}
	} catch (e) {}
};;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["onMessage"] = 0; };

UCF_IHubFrameProtect["checkHostName"] = function(origin) {;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["checkHostName"]++; }; 
	if (UCF_IHubFrameProtect["cEnabled"] !== '')
		return UCF_IHubFrameProtect["cEnabled"] === 'S';
	if (origin === document["location"]["origin"])
		return true;
	if (UCF_IHubFrameProtect["sWhitelist"] === '') {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_IHubFrameProtect: Whitelist is empty -> returning.', "IHubFrameProtect.js(186): checkHostName"); };
		if (UCF_IHubFrameProtect["sMessageWhitelist"] !== '')
			UCF_IHubFrameProtect["alert"](UCF_IHubFrameProtect["sMessageWhitelist"], origin);
		UCF_IHubFrameProtect["cEnabled"] = 'F';
		return false;
	}

	var sCheckString = origin["substring"](origin["indexOf"]('/') + 2);;
	if (sCheckString["indexOf"](':') > -1)
		sCheckString = sCheckString["substring"](0, sCheckString["indexOf"](':'));
	while (sCheckString["indexOf"]('.') > -1) {
		if (UCF_IHubFrameProtect["sWhitelist"]["indexOf"]('/' + sCheckString + '/') > -1) {
			UCF_IHubFrameProtect["cEnabled"] = 'S';
			document["getElementsByTagName"]('body')[0]["style"]["display"] = 'block';
			UCF_IHubFrameProtect["oLS"]["oBrowserWindow"]["unlock"](UCF_BrowserWindow["LOCKTYPES"]["FRAMEPROTECT"]);
			UCF_IHubFrameProtect["notifyChildFrames"]();
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_IHubFrameProtect: Check of hostname succeeded.', "IHubFrameProtect.js(202): checkHostName"); };
			return true;
		}
		sCheckString = sCheckString["substring"](sCheckString["indexOf"]('.') + 1);
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_IHubFrameProtect: Hostname not part of whitelist -> failed.', "IHubFrameProtect.js(207): checkHostName"); };
	if (UCF_IHubFrameProtect["sMessageWhitelist"] !== '')
		UCF_IHubFrameProtect["alert"](UCF_IHubFrameProtect["sMessageWhitelist"], origin);
	UCF_IHubFrameProtect["cEnabled"] = 'F';
	return false;
};;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["checkHostName"] = 0; };

UCF_IHubFrameProtect["NoResponseAlert"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["NoResponseAlert"]++; }; 
	if (UCF_IHubFrameProtect["cEnabled"] === '' && UCF_IHubFrameProtect["sMessageNoResponse"] !== '')
		alert(UCF_IHubFrameProtect["sMessageNoResponse"]);
};;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["NoResponseAlert"] = 0; };

UCF_IHubFrameProtect["alert"] = function(sMessage, origin) {;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["alert"]++; }; 
	alert(sMessage + ' ' + origin);
};;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["alert"] = 0; };

UCF_IHubFrameProtect["notifyChildFrames"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["notifyChildFrames"]++; }; 
	var oFrames = document["getElementsByTagName"]('iframe');
	for (var i = 0; i < oFrames["length"]; i++)
		oFrames[i]["contentWindow"]["postMessage"]('SAPFrameProtection*parent-unlocked', '*');
};;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["notifyChildFrames"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_IHubFrameProtect["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_IHubFrameProtect["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_IHubFrameProtect["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_IHubFrameProtect["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_IHubFrameProtect["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_IHubFrameProtect["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_IHubLegacyWDJ"] = function() {/* global _assert, _trace, INFO, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * Class LS IHubLegacyWDJ
 *
 * Integration Hub Plugin for Legacy integration code of Web Dynpro for Java
 *
 * 
 *
 * @version
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS}   oLS   reference to Lightspeed object
 */
function UCF_IHubLegacyWDJ(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["UCF_IHubLegacyWDJ"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "IHubLegacyWDJ.js(24): UCF_IHubLegacyWDJ"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "IHubLegacyWDJ.js(25): UCF_IHubLegacyWDJ"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "IHubLegacyWDJ.js(26): UCF_IHubLegacyWDJ"); };

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "IHubLegacyWDJ.js(28): UCF_IHubLegacyWDJ"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oIHub"] = this["oGetParent"]();
	this["oEPCM"] = this["oIHub"]["oGetEPCM"]();
	this["oLSAPI"] = this["oIHub"]["oGetLSAPI"]();
	this["oPageSupport"] = this["oIHub"]["oGetPageSupport"]();

	// couple resizing into portal
	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "onBrowserWindowLayoutChange");
	this["currentIVIewHeight"] = 0;

	// couple Event Based navigation
	this["bAllowedEBN"] = false;
	this["checkEBN"]();

	// couple performance optimization for opening a new window
	this["clearPreNavigate"]();

	var oEventHandler = this["oLS"]["oEventHandler"];
	if (oEventHandler) {
		oEventHandler["attachEvent"](oEventHandler["E_EVENTS"]["AfterRequestSubmit"], this, "onPreNavigateNotify");
	}

};window["UCF_IHubLegacyWDJ"] = UCF_IHubLegacyWDJ; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_IHubLegacyWDJ"); UCF_IHubLegacyWDJ["_"] = {UCF_IHubLegacyWDJ: 0}; }; ;
UCF_IHubLegacyWDJ["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_IHubLegacyWDJ.prototype["sClassName"] = "UCF_IHubLegacyWDJ";

UCF_IHubLegacyWDJ["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["destroy"]++; }; 

	this["disableEBN"]();
	this["clearPreNavigate"]();

	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this);

	var oEventHandler = this["oLS"]["oEventHandler"];
	if (oEventHandler) {
		oEventHandler["detachEvent"](oEventHandler["E_EVENTS"]["AfterRequestSubmit"], this);
	}

	this["oPageSupport"] = null;
	this["oLSAPI"] = null;
	this["oEPCM"] = null;
	this["oIHub"] = null;
	this["currentIVIewHeight"] = null;
	this["bAllowedEBN"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["destroy"] = 0; };

//======================================================================================
//                                       A P I
//======================================================================================

// -- Area: Cross Window communication  ------------------------------------------------
//
// Method used for demo of child to opener communication, remaining
// here just for compatibility reasons

/**
 *   Raise Event
 *   @param {string} sNamespace  Event Namespace
 *   @param {string}      sName  Event Name
 *   @param {string}      sData  Event Data passed along with Event
 *   @public
 */
UCF_IHubLegacyWDJ["prototype"]["raisePortalEventToOpener"] = function(sNamespace, sName, sData) {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["raisePortalEventToOpener"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNamespace != null, "sNamespace != null", "IHubLegacyWDJ.js(96): raisePortalEventToOpener"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) === "string", "typeof(sName) === \"string\"", "IHubLegacyWDJ.js(97): raisePortalEventToOpener"); };

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != null, "sName != null", "IHubLegacyWDJ.js(99): raisePortalEventToOpener"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) === "string", "typeof(sName) === \"string\"", "IHubLegacyWDJ.js(100): raisePortalEventToOpener"); };

	try {
		//------------------
		top["opener"]["EPCM"]["raiseEvent"](sNamespace, sName, sData);
		//------------------
	} catch (ex) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "API call failed : " + sNamespace + "#" + sName, "IHubLegacyWDJ.js(107): raisePortalEventToOpener"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["raisePortalEventToOpener"] = 0; };

// -- Area: EBN support -------------------------------------------------------------------
//
// Event Based navigation is mutual agreement between WD-Java and Portal PB+navigation.
// The WDJ has to singnalizes readiness for this scenario (enableEBN), crucial here is
// that there is a subscriber for the given event - otherwise the standard navigation
// has to be used instead.

UCF_IHubLegacyWDJ["prototype"]["EBN_NAMESPACE"] = "urn:com.sapportals:navigation";
UCF_IHubLegacyWDJ["prototype"]["EBN_EVENT_CONSUMER"] = "EventBasedNavigate";

UCF_IHubLegacyWDJ["prototype"]["EBN_EVENT_TO_ENABLE"] = "EnableEBN";
UCF_IHubLegacyWDJ["prototype"]["EBN_EVENT_TO_DISABLE"] = "DisableEBN";

/**
 * Checks/Initializes Event-Based Navigation hook via given event and enables it
 * when possible.
 */
UCF_IHubLegacyWDJ["prototype"]["checkEBN"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["checkEBN"]++; }; 

	var bPageSupport = (this["oPageSupport"] != null),
		bAnyConsumer = false;

	try {
		bAnyConsumer = this["oEPCM"]["isSubscribed"](this["EBN_NAMESPACE"], this["EBN_EVENT_CONSUMER"]);
	} catch (ex) {}

	this["bAllowedEBN"] = bAnyConsumer && bPageSupport;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, " checking EBN assertions :  allowedEBN=" + this["bAllowedEBN"] + " [isConsumer=" + bAnyConsumer + "; isPageSupport=" + bPageSupport + "]", "IHubLegacyWDJ.js(139): checkEBN"); };
	this["enableEBN"]();
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["checkEBN"] = 0; };

/**
 * Enables Event-Based Navigation hook
 */
UCF_IHubLegacyWDJ["prototype"]["enableEBN"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["enableEBN"]++; }; 
	if (!this["bAllowedEBN"]) return;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Enabling EBN", "IHubLegacyWDJ.js(149): enableEBN"); };
	try {
		this["oEPCM"]["raiseEvent"](this["EBN_NAMESPACE"], this["EBN_EVENT_TO_ENABLE"]);
	} catch (ex) {}
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["enableEBN"] = 0; };

/**
 * Disables Event-Based Navigation hook
 */
UCF_IHubLegacyWDJ["prototype"]["disableEBN"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["disableEBN"]++; }; 
	if (!this["bAllowedEBN"]) return;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Disabling EBN", "IHubLegacyWDJ.js(161): disableEBN"); };
	try {
		this["oEPCM"]["raiseEvent"](this["EBN_NAMESPACE"], this["EBN_EVENT_TO_DISABLE"]);
	} catch (ex) {}
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["disableEBN"] = 0; };

//-- Area: Improve performance for opening a new window -----------------------------
//
// Basic idea behindd is tha that the WDJ can detect the navigation goes to the
// new window in ADVANCE. In such case the window is opened immediatly AFTER
// submit of request, re-using the "idle" time where the browser is
// waiting for response - this improves perceived responsetime ~300 ms !
//
// Current solution still uses "ugly-hack" in Event Hander. This mechanism
// should be replaced later on, with some more convenient technique (similar
// to those used in pending requests.

UCF_IHubLegacyWDJ["prototype"]["NWIN_NAMESPACE"] = "urn:com.sapportals:navigation";
UCF_IHubLegacyWDJ["prototype"]["NWIN_NAME"] = "PreNavigate";
UCF_IHubLegacyWDJ["prototype"]["NWIN_HINT_PARAM"] = "hint:portalNavigation.openNewWindow";

/**
 *	resets all flags for NewWindow-otimization scenario
 */
UCF_IHubLegacyWDJ["prototype"]["clearPreNavigate"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["clearPreNavigate"]++; }; 

	this["bNewWindowNavigation"] = false;
	this["sNewWindowOptions"] = "";
	this["sNewWindowId"] = "";

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "PreNavigate flags cleared", "IHubLegacyWDJ.js(191): clearPreNavigate"); };
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["clearPreNavigate"] = 0; };

/**
 *  Sets thee Hint to perforrm PreNavigate actions to the new window
 *  and mutual WDJ<->optisation
 *  @param {string} sOptions
 *  @param {string} sUserData
 *  @return {string} new window id
 *  @public
 */
UCF_IHubLegacyWDJ["prototype"]["setPreNavigate"] = function(sOptions, sUserData) {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["setPreNavigate"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sOptions != null, "sOptions != null", "IHubLegacyWDJ.js(204): setPreNavigate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sOptions) === "string", "typeof(sOptions) === \"string\"", "IHubLegacyWDJ.js(205): setPreNavigate"); };

	sUserData = (sUserData) ? sUserData : "";

	this["bNewWindowNavigation"] = true;
	this["sNewWindowOptions"] = sOptions;
	this["sNewWindowId"] = "WIDwtf" + new Date()["valueOf"]();

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "PreNavigate started for {WinId:" + this["sNewWindowId"] + ", Options:" + this["sNewWindowOptions"] + ", UserData:" + sUserData, "IHubLegacyWDJ.js(213): setPreNavigate"); };

	// put newWindowId to eventQueue enclosed in new event
	this["firePendingPreNavigate"](this["sId"], this["sNewWindowId"], sUserData);

	return this["sNewWindowId"];
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["setPreNavigate"] = 0; };

/**
 *  triggers opening a new window via PreNavigate event on API
 */
UCF_IHubLegacyWDJ["prototype"]["onPreNavigateNotify"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["onPreNavigateNotify"]++; }; 

	// triggers opening a new window via PreNavigate event on API
	if (!this["bNewWindowNavigation"]) return;

	try {
		// force PreNavigate-Event
		this["oEPCM"]["raiseEvent"](this["NWIN_NAMESPACE"], this["NWIN_NAME"], {
			"winfeatures": this["sNewWindowOptions"],
			"winname": this["sNewWindowId"]
		});
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "PreNavigate notified to portal WinId=" + this["sNewWindowId"], "IHubLegacyWDJ.js(235): onPreNavigateNotify"); };
	} catch (ex) {}

	this["clearPreNavigate"]();
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["onPreNavigateNotify"] = 0; };

//-- Area: LSHAPE with Fallbacks -----------------------------------------------------
//
// Collection if methods that access LSAPI. Later on we can consider
// to move them into another plugin for reuse, but for the first hit
// let keep it here in this legacy plugin

/**
 *  sets Window title via LSAPI or via via document.title
 *  @param {string} sTitle window title
 *  @public
 */
UCF_IHubLegacyWDJ["prototype"]["setWindowTitle"] = function(sTitle) {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["setWindowTitle"]++; }; 

	var bDoTitleFallback = true;
	try {
		this["oLSAPI"]["getVisualPlugin"]()["setCanvasTitle"](sTitle);
		bDoTitleFallback = false;
	} catch (ex) {; }

	if (bDoTitleFallback) {
		document["title"] = sTitle;
	}
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["setWindowTitle"] = 0; };

/**
 * Capture Screnn via Capturing plugin of LSAPI
 *  @param {boolean} bSilent use silent mode without user interaction
 *  @public
 */
UCF_IHubLegacyWDJ["prototype"]["captureScreen"] = function(bSilent) {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["captureScreen"]++; }; 

	try {
		//--------
		this["oLSAPI"]["getScreenCapturingPlugin"]()["captureScreen"](bSilent);
		//--------
	} catch (ex) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "IHubLegacyWDJ.captureScreen :: failed or not supported", "IHubLegacyWDJ.js(277): captureScreen"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["captureScreen"] = 0; };

UCF_IHubLegacyWDJ["prototype"]["CLOSEWIN_NAMESPACE"] = "urn:com.sapportals:navigation";
UCF_IHubLegacyWDJ["prototype"]["CLOSEWIN_NAME"] = "CloseWindow";

/**
 * Closing an Window
 *  @public
 */
UCF_IHubLegacyWDJ["prototype"]["closeWindow"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["closeWindow"]++; }; 

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "IHubLegacyWDJ.closeWindow", "IHubLegacyWDJ.js(290): closeWindow"); };
	// First approach - use LSAPI to let close window
	if (this["oLSAPI"]) {
		try {
			//--------
			this["oLSAPI"]["getSessionPlugin"]()["closeSession"]();
			return;
			//--------
		} catch (ex) {}
	}

	// Second second approach, use portal eventing
	if (this["oEPCM"]) {
		try {
			//--------
			this["oEPCM"]["raiseEvent"](this["CLOSEWIN_NAMESPACE"], this["CLOSEWIN_NAME"]);
			return;
			//--------
		} catch (ex) {}
	}

	//last fall back approach, see also Page.close().
	window["open"]('', '_self');
	window["close"]();
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["closeWindow"] = 0; };

//-- Area: PageSupport related methods -----------------------------------------------------
//
//  Resizing / adjusting of iIView heights is to be calle in the portal
//  when

/**
 * Uses a function of parentPageSupport to adjust IView height
 * @param {WINDOWS} oWinRef
 */
UCF_IHubLegacyWDJ["prototype"]["adjustIViewHeight"] = function(oWinRef) {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["adjustIViewHeight"]++; }; 

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "height adjustment check", "IHubLegacyWDJ.js(327): adjustIViewHeight"); };
	if (!this["oPageSupport"]) return;

	/* CSN 910531/2014: To avoid endless loops we need to provide the calculated document height in the call of
	 * this.oPageSupport.adjustHeight (recommendation of Portal experts). The reason is that the portal adds margin
	 * and border to the document.body.scrollHeight which results in a resize event => call of adjustIViewHeight => endless loop
	 */
	var newHeight = Math["max"](document["body"]["scrollHeight"], document["documentElement"]["scrollHeight"],
		document["body"]["offsetHeight"], document["documentElement"]["offsetHeight"],
		document["body"]["clientHeight"], document["documentElement"]["clientHeight"]);

	if (newHeight != this["currentIVIewHeight"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "height adjustment triggered via PageSupport", "IHubLegacyWDJ.js(339): adjustIViewHeight"); };

		try {
			//--------
			var myIvuFrameObj = this["oPageSupport"]["getIvuFrameObj"](this["oPageSupport"]["getIvuId"](oWinRef));
			if (myIvuFrameObj) {
				this["oPageSupport"]["adjustHeight"](myIvuFrameObj, newHeight);
			}
			//--------
		} catch (ex) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "PageSupport was unable to find frame or caused error in internal script", "IHubLegacyWDJ.js(349): adjustIViewHeight"); };
		}
		this["currentIVIewHeight"] = newHeight;
	}
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["adjustIViewHeight"] = 0; };

UCF_IHubLegacyWDJ["prototype"]["onBrowserWindowLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["onBrowserWindowLayoutChange"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "IHubLegacyWDJ.js(357): onBrowserWindowLayoutChange"); };
	this["adjustIViewHeight"](window);

};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["onBrowserWindowLayoutChange"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_IHubLegacyWDJ["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_IHubLegacyWDJ["prototype"]["aEventNames"] = ["PendingPreNavigate"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_IHubLegacyWDJ["prototype"]["aMethodNames"] = ["raisePortalEventToOpener","setWindowTitle","enableEBN","disableEBN","checkEBN","captureScreen","setPreNavigate","closeWindow","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_IHubLegacyWDJ["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_IHubLegacyWDJ["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control 
 * @param {string} sNewWindowId ID of the new window which is being opened
 * @param {string} sUserData Additional data
 * @fires IHubLegacyWDJ::PendingPreNavigate
 */
UCF_IHubLegacyWDJ["prototype"]["firePendingPreNavigate"] = function(sId, sNewWindowId, sUserData) {;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["firePendingPreNavigate"]++; }; 
	/** @type {{Id: string, NewWindowId: string, UserData: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "IHubLegacyWDJ.js(411): firePendingPreNavigate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "IHubLegacyWDJ.js(412): firePendingPreNavigate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "IHubLegacyWDJ.js(413): firePendingPreNavigate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNewWindowId != null, "sNewWindowId != null", "IHubLegacyWDJ.js(414): firePendingPreNavigate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNewWindowId) == "string", "typeof(sNewWindowId) == \"string\"", "IHubLegacyWDJ.js(415): firePendingPreNavigate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sUserData != null, "sUserData != null", "IHubLegacyWDJ.js(416): firePendingPreNavigate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sUserData) == "string", "typeof(sUserData) == \"string\"", "IHubLegacyWDJ.js(417): firePendingPreNavigate"); };
	mParams = {
		"Id": sId,
		"NewWindowId": sNewWindowId,
		"UserData": sUserData
	};
	
	
	
	this["fireSemanticEvent"]("IHubLegacyWDJ", "PendingPreNavigate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_IHubLegacyWDJ["_"]["firePendingPreNavigate"] = 0; };

UCF_IHubLegacyWDJ.prototype["aPublicMethods"] = ["raisePortalEventToOpener","setPreNavigate","setWindowTitle","captureScreen","closeWindow"].concat(UCF_IHubLegacyWDJ.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_IHubMessaging"] = function() {/* global _assert, _trace, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_RegistrationMap */
/// <reference path="../helper/RegistrationMap.js"/>
/* global RTMFProxy */

/**
 * Class LS IHubMessaging
 *
 * Integration Hub Plugin for Messaging
 *
 * 
 * @class
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS}  oLS reference to Lightspeed object
 */
function UCF_IHubMessaging(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["UCF_IHubMessaging"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "IHubMessaging.js(24): fExecutionCallbackHandler"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "IHubMessaging.js(25): fExecutionCallbackHandler"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "IHubMessaging.js(26): fExecutionCallbackHandler"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["defineEvents"](['InternalReceive']);

		// eslint-disable-next-line @ur/no-memory-leaks
		this["oRegistrationMap"] = null;
		this["bServiceAvailable"] = false;
		this["mService"] = this["SERVICE"]["RTMF"];
		this["aMessageQueue"] = null;

		var oMessageHub = this;
		this["fExecutionCallbackHandler"] = function(oParam1, oParam2, oParam3) {
			oMessageHub["executionCallbackHandler"](oParam1, oParam2, oParam3);
		};

		this["fErrorCallbackHandler"] = function(oParam1, oParam2, oParam3) {
			oMessageHub["errorCallbackHandler"](oParam1, oParam2, oParam3);
		};

	}
};window["UCF_IHubMessaging"] = UCF_IHubMessaging; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_IHubMessaging"); UCF_IHubMessaging["_"] = {UCF_IHubMessaging: 0}; }; ;

UCF_IHubMessaging["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_IHubMessaging.prototype["sClassName"] = "UCF_IHubMessaging";

UCF_IHubMessaging["prototype"]["SERVICE"] = {
	"NONE": 0,
	"RTMF": 1
};

// Note: Due to separator clash in Event queue the usage of
//       dividers with "\ue003", "\ue004" is discontinued in favor
//       of new values below.

UCF_IHubMessaging["prototype"]["DIVIDER"] = {
	"DATA_SET": "\ue010",
	"DATA_ENTRY": "\ue011"
};

UCF_IHubMessaging["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["destroy"]++; }; 
	this["fExecutionCallbackHandler"] = null;
	this["fErrorCallbackHandler"] = null;

	if (this["oRegistrationMap"]) {
		this["oRegistrationMap"]["cleanUpRegistration"]();
		this["oRegistrationMap"] = null;
	}

	if (this["mService"] === this["SERVICE"]["RTMF"]) {
		this["cleanUpRtmfProxy"]();
		this["mService"] = null;
	}

	if (this["aMessageQueue"]) {
		this["aMessageQueue"] = null;
		this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "onUnlock");
	}

	this["bServiceAvailable"] = false;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["destroy"] = 0; };

UCF_IHubMessaging["prototype"]["bCheckService"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["bCheckService"]++; }; 
	if (this["mService"] === this["SERVICE"]["RTMF"]) {
		if (!this["oRtmfProxy"])
			this["bServiceAvailable"] = this["bInitRtmfProxy"]();
	}

	if (!this["bServiceAvailable"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Messaging service not available", "IHubMessaging.js(97): bCheckService"); };
	}

	return this["bServiceAvailable"];
};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["bCheckService"] = 0; };

UCF_IHubMessaging["prototype"]["errorCallbackHandler"] = function(oParam1, oParam2, oParam3) {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["errorCallbackHandler"]++; }; 
	if (this["mService"] === this["SERVICE"]["RTMF"]) {
		var sErrorText = oParam1;
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Messaging Error occurred: " + sErrorText, "IHubMessaging.js(106): errorCallbackHandler"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["errorCallbackHandler"] = 0; };

UCF_IHubMessaging["prototype"]["executionCallbackHandler"] = function(oParam1, oParam2, oParam3) {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["executionCallbackHandler"]++; }; 
	if (this["oLS"]["bIsLocked"]) {
		if (!this["aMessageQueue"]) {
			this["aMessageQueue"] = [];
			this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "onUnlock");
		}

		this["aMessageQueue"]["push"]({ "oParam1": oParam1, "oParam2": oParam2, "oParam3": oParam3 });
	} else {
		this["processMessage"](oParam1, oParam2, oParam3);
	}
};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["executionCallbackHandler"] = 0; };

UCF_IHubMessaging["prototype"]["processMessage"] = function(oParam1, oParam2, oParam3) {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["processMessage"]++; }; 
	if (this["mService"] === this["SERVICE"]["RTMF"]) {
		var oRtmfMessage = oParam1;
		this["processRtmfMessage"](oRtmfMessage);
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Receiving RTMF Message: " + oRtmfMessage["getEvent"](), "IHubMessaging.js(127): processMessage"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["processMessage"] = 0; };

UCF_IHubMessaging["prototype"]["onUnlock"] = function(oParam1, oParam2, oParam3) {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["onUnlock"]++; }; 
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "onUnlock");
	if (this["aMessageQueue"]) {
		var oMessage = null;

		for (var i = 0; i < this["aMessageQueue"]["length"]; i++) {
			oMessage = this["aMessageQueue"][i];
			this["processMessage"](oMessage["oParam1"], oMessage["oParam2"], oMessage["oParam3"]);
		}

		this["aMessageQueue"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["onUnlock"] = 0; };

/*
 * API
 *
 */

UCF_IHubMessaging["prototype"]["subscribeMessage"] = function(sName, sReference) {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["subscribeMessage"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != null, "sName != null", "IHubMessaging.js(151): subscribeMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) === "string", "typeof(sName) === \"string\"", "IHubMessaging.js(152): subscribeMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sReference != null, "sReference != null", "IHubMessaging.js(153): subscribeMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sReference) === "string", "typeof(sReference) === \"string\"", "IHubMessaging.js(154): subscribeMessage"); };

	if (!this["bCheckService"]()) return;

	if (!this["oRegistrationMap"]) {
		this["oRegistrationMap"] = new (UCF_ClassLoader["oGetClass"]("UCF_RegistrationMap"))();
	}

	this["oRegistrationMap"]["register"](sName, sReference);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RegistrationMap: " + this["oRegistrationMap"]["toString"](), "IHubMessaging.js(163): subscribeMessage"); };

	if (this["mService"] === this["SERVICE"]["RTMF"]) {
		this["oRtmfProxy"]["callFunction"]("register", [sName, this["fExecutionCallbackHandler"], [], this["fErrorCallbackHandler"]]);
	}

};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["subscribeMessage"] = 0; };

UCF_IHubMessaging["prototype"]["unsubscribeMessage"] = function(sName, sReference) {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["unsubscribeMessage"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != null, "sName != null", "IHubMessaging.js(172): unsubscribeMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) === "string", "typeof(sName) === \"string\"", "IHubMessaging.js(173): unsubscribeMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sReference != null, "sReference != null", "IHubMessaging.js(174): unsubscribeMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sReference) === "string", "typeof(sReference) === \"string\"", "IHubMessaging.js(175): unsubscribeMessage"); };

	if (!this["bCheckService"]()) return;

	if (this["oRegistrationMap"]) {
		this["oRegistrationMap"]["unregister"](sName, sReference);
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RegistrationMap: " + this["oRegistrationMap"]["toString"](), "IHubMessaging.js(181): unsubscribeMessage"); };
	}

	if (this["mService"] === this["SERVICE"]["RTMF"]) {
		this["oRtmfProxy"]["callFunction"]("unRegister", [sName, this["fExecutionCallbackHandler"]]);
	}

};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["unsubscribeMessage"] = 0; };

/*
 * RTMF Service
 *
 */
UCF_IHubMessaging["prototype"]["bInitRtmfProxy"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["bInitRtmfProxy"]++; }; 
	if (window["RTMFProxy"]) {
		if (!this["oRtmfProxy"]) {
			this["oRtmfProxy"] = new RTMFProxy();
		}
		return true;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RTMF proxy creation failed", "IHubMessaging.js(201): bInitRtmfProxy"); };
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["bInitRtmfProxy"] = 0; };

UCF_IHubMessaging["prototype"]["cleanUpRtmfProxy"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["cleanUpRtmfProxy"]++; }; 
	if (this["oRtmfProxy"]) {
		this["oRtmfProxy"]["callFunction"]("unSubscribeAll");
		this["oRtmfProxy"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["cleanUpRtmfProxy"] = 0; };

UCF_IHubMessaging["prototype"]["processRtmfMessage"] = function(oRtmfMessage) {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["processRtmfMessage"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oRtmfMessage != null, "oRtmfMessage != null", "IHubMessaging.js(215): processRtmfMessage"); };

	var sMessageName = oRtmfMessage["getEvent"](),
		aReferences = this["oRegistrationMap"]["aGetRegistrationEntries"](sMessageName),
		i = 0;

	if (aReferences) {
		var aParams = oRtmfMessage["getParams"](),
			sData = "",
			aValues = null;

		for (i = 0; i < aParams["length"]; i++) {
			if (i > 0) sData += this["DIVIDER"]["DATA_SET"];
			sData += aParams[i]["getKey"]();
			sData += this["DIVIDER"]["DATA_SET"];

			aValues = aParams[i]["getValues"]();
			if (aValues != null) {
				for (var j = 0; j < aValues["length"]; j++) {
					if (j > 0) sData += this["DIVIDER"]["DATA_ENTRY"];
					sData += aValues[j];
				}
			} else {
				sData += aParams[i]["getValue"]();
			}
		}

		for (i = 0; i < aReferences["length"]; i++) {
			this["fireReceive"](this["sId"], sMessageName, aReferences[i], sData);

			//fire also internal event
			this["fireEvent"](this["E_EVENTS"]["InternalReceive"], { "sName": sMessageName, "sReference": aReferences[i], "sData": sData });
		}
	}
};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["processRtmfMessage"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_IHubMessaging["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_IHubMessaging["prototype"]["aEventNames"] = ["Receive"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_IHubMessaging["prototype"]["aMethodNames"] = ["subscribeMessage","unsubscribeMessage","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_IHubMessaging["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_IHubMessaging["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control 
 * @param {string} sName Name of the message
 * @param {string} sReference A reference the message is related to (e.g. a control id)
 * @param {string} sData Message payload
 * @fires IHubMessaging::Receive
 */
UCF_IHubMessaging["prototype"]["fireReceive"] = function(sId, sName, sReference, sData) {;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["fireReceive"]++; }; 
	/** @type {{Id: string, Name: string, Reference: string, Data: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "IHubMessaging.js(301): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "IHubMessaging.js(302): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "IHubMessaging.js(303): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != null, "sName != null", "IHubMessaging.js(304): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) == "string", "typeof(sName) == \"string\"", "IHubMessaging.js(305): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sReference != null, "sReference != null", "IHubMessaging.js(306): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sReference) == "string", "typeof(sReference) == \"string\"", "IHubMessaging.js(307): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "IHubMessaging.js(308): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "IHubMessaging.js(309): fireReceive"); };
	mParams = {
		"Id": sId,
		"Name": sName,
		"Reference": sReference,
		"Data": sData
	};
	
	
	
	
	this["fireSemanticEvent"]("IHubMessaging", "Receive", mParams, true, false, false);
};;if (__UCF_COVERAGE__) { UCF_IHubMessaging["_"]["fireReceive"] = 0; };

};
sap["ls"]["preload"]["UCF_IHubNavigation"] = function() {/* global _assert, _trace, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * Class LS IHub Navigation
 *
 * Integration Hub Plugin for (Portal) Navigation
 *
 * 
 *
 * @class
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS}   oLS   reference to Lightspeed object
 */
function UCF_IHubNavigation(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_IHubNavigation["_"]["UCF_IHubNavigation"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "IHubNavigation.js(24): UCF_IHubNavigation"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "IHubNavigation.js(25): UCF_IHubNavigation"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "IHubNavigation.js(26): UCF_IHubNavigation"); };

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "IHubNavigation.js(28): UCF_IHubNavigation"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oIHub"] = this["oGetParent"]();
	this["oEPCM"] = this["oIHub"]["oGetEPCM"]();
};window["UCF_IHubNavigation"] = UCF_IHubNavigation; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_IHubNavigation"); UCF_IHubNavigation["_"] = {UCF_IHubNavigation: 0}; }; 
UCF_IHubNavigation["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_IHubNavigation.prototype["sClassName"] = "UCF_IHubNavigation";

UCF_IHubNavigation["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubNavigation["_"]["destroy"]++; }; 
	this["oEPCM"] = null;
	this["oIHub"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_IHubNavigation["_"]["destroy"] = 0; };

// ----------------- API ----------------

/**
 *   @public
 *
 * @param {string} sNavigationTarget
 * @param {string} sNavigationMode
 * @param {string} sWindowFeatures
 * @param {string} sWindowName
 * @param {string} sHistoryMode
 * @param {string} sTargetTitle
 * @param {string} sContextUrl
 * @param {string}	sPostBody
 */
UCF_IHubNavigation["prototype"]["navigateAbsolute"] = function(sNavigationTarget, sNavigationMode, sWindowFeatures, sWindowName, sHistoryMode, sTargetTitle, sContextUrl, sPostBody) {;if (__UCF_COVERAGE__) { UCF_IHubNavigation["_"]["navigateAbsolute"]++; }; 

	try {
		var sTargetTitleMarshaled = (sTargetTitle == null || sTargetTitle == "null")
			? null
			: sTargetTitle;
		//-------
		this["oLS"]["lockByNavigation"]();
		this["oEPCM"]["doNavigate"](sNavigationTarget, sNavigationMode,
			sWindowFeatures, sWindowName,
			sHistoryMode, sTargetTitleMarshaled, sContextUrl, UCF_JsUtil["oJsonParse"](sPostBody));
		UCF_JsUtil["delayedCall"](1500, this["oLS"], "unlockByNavigation", []);
		//-------
	} catch (ex) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "IHub.Navigation.navigateAbsolute :: failed", "IHubNavigation.js(72): navigateAbsolute"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubNavigation["_"]["navigateAbsolute"] = 0; };

/**
 *   @public
 *
 * @param { string } sBaseUrl
 * @param {string} sLevelsUp
 * @param {string} sNavigationPath
 * @param {string} sNavigationMode
 * @param {string} sWindowFeatures
 * @param {string} sWindowName
 * @param {string} sHistoryMode
 * @param {string} sTargetTitle
 * @param {string} sContextUrl
 * @param {string} sPostBody
 * @param {string} sAddParams
 */
UCF_IHubNavigation["prototype"]["navigateRelative"] = function(sBaseUrl, sLevelsUp, sNavigationPath, sNavigationMode, sWindowFeatures, sWindowName, sHistoryMode, sTargetTitle, sContextUrl, sPostBody, sAddParams) {;if (__UCF_COVERAGE__) { UCF_IHubNavigation["_"]["navigateRelative"]++; }; 

	try {
		var sTargetTitleMarshaled = (sTargetTitle == null || sTargetTitle == "null")
			? null
			: sTargetTitle;
		//-------
		this["oLS"]["lockByNavigation"]();
		this["oEPCM"]["doRelativeNavigate"](sBaseUrl, sLevelsUp, sNavigationPath, sNavigationMode,
			sWindowFeatures, sWindowName,
			sHistoryMode, sAddParams, sTargetTitleMarshaled, sContextUrl, UCF_JsUtil["oJsonParse"](sPostBody));
		UCF_JsUtil["delayedCall"](1500, this["oLS"], "unlockByNavigation", []);
		//-------

	} catch (ex) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "IHub.Navigation.navigateRelative :: failed", "IHubNavigation.js(106): navigateRelative"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubNavigation["_"]["navigateRelative"] = 0; };

/**
 *   @public
 * @param {string} sSystem
 * @param {string} sObjectType
 * @param {string} sObjectValue
 * @param {string} sOperation
 * @param {string} sResolvingMode
 * @param {string} sPostBody
 */
UCF_IHubNavigation["prototype"]["navigateObjectBased"] = function(sSystem, sObjectType, sObjectValue, sOperation, sResolvingMode, sPostBody) {;if (__UCF_COVERAGE__) { UCF_IHubNavigation["_"]["navigateObjectBased"]++; }; 

	try {
		// CSN C- 0000231215 2011 - External Popup opens in background
		// To avoid this behaviour in OBN scenario the current window is locked, which keeps the Focus from being set on it
		// until the window open is triggered. Problem in OBN is that the window opens and then sends an iframe request. This
		// has lead to mixed results depending on network latency.
		this["oLS"]["lockByNavigation"]();

		//-------
		this["oEPCM"]["doObjBasedNavigate"](sSystem, sObjectType, sObjectValue, sOperation, UCF_JsUtil["oJsonParse"](sPostBody), sResolvingMode);

		//Unlock is called after iFrame request is (hopefully) processed
		UCF_JsUtil["delayedCall"](1500, this["oLS"], "unlockByNavigation", []);

	} catch (ex) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "IHub.Navigation.navigateObjectBased :: failed", "IHubNavigation.js(135): navigateObjectBased"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubNavigation["_"]["navigateObjectBased"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_IHubNavigation["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_IHubNavigation["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_IHubNavigation["prototype"]["aMethodNames"] = ["navigateAbsolute","navigateRelative","navigateObjectBased","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_IHubNavigation["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_IHubNavigation["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubNavigation["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_IHubNavigation["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_IHubNavigation.prototype["aPublicMethods"] = ["navigateAbsolute","navigateRelative","navigateObjectBased"].concat(UCF_IHubNavigation.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_IHubWebSocketBase"] = function() {/* global _assert, _trace, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * Class LS IHubWebSocketBase
 *
 * Integration Hub Plugin for WebSockets
 *
 * 
 * @class
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS}  oLS reference to Lightspeed object
 */
function UCF_IHubWebSocketBase(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["UCF_IHubWebSocketBase"]++; }; 

	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "IHubWebSocketBase.js(22): UCF_IHubWebSocketBase"); };
		//		_assert(oDomRef != null);
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "IHubWebSocketBase.js(24): UCF_IHubWebSocketBase"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["defineEvents"](['InternalReceiveText', 'InternalReceiveBinary']);

		this["fOpenHandler"] = null;
		this["fCloseHandler"] = null;
		this["fMessageHandler"] = null;
		this["fErrorHandler"] = null;
		this["oConnections"] = {};

		this["oError"] = { "sCode": '', "sText": '' };

	}
};window["UCF_IHubWebSocketBase"] = UCF_IHubWebSocketBase; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_IHubWebSocketBase"); UCF_IHubWebSocketBase["_"] = {UCF_IHubWebSocketBase: 0}; }; ;

UCF_IHubWebSocketBase["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_IHubWebSocketBase.prototype["sClassName"] = "UCF_IHubWebSocketBase";

/**
 * ready states
 */
UCF_IHubWebSocketBase["prototype"]["E_READY_STATE"] = {
	"CONNECTING": 0,
	"OPEN": 1,
	"CLOSING": 2,
	"CLOSED": 3
};

UCF_IHubWebSocketBase["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["destroy"]++; }; 

	this["cleanup"]();
	this["oError"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["destroy"] = 0; };

UCF_IHubWebSocketBase["prototype"]["cleanup"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["cleanup"]++; }; 

	this["fOpenHandler"] = null;
	this["fCloseHandler"] = null;
	this["fMessageHandler"] = null;
	this["fErrorHandler"] = null;
	this["oConnections"] = null;

};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["cleanup"] = 0; };

UCF_IHubWebSocketBase["prototype"]["open"] = function(sConnectionId, sUrl, sSubprotocol, sProtocolLibrary) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["open"]++; }; 

	var oConnection = this["oPrepareConnection"](sConnectionId, sUrl, sSubprotocol, sProtocolLibrary);
	if (oConnection) {
		oConnection = this["oOpenConnection"](oConnection);
		if (!oConnection)
			return;
		this["attachHandlers"](oConnection);
	}

};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["open"] = 0; };

UCF_IHubWebSocketBase["prototype"]["oPrepareConnection"] = function(sConnectionId, sUrl, sSubprotocol, sProtocolLibrary) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["oPrepareConnection"]++; }; 

	// Check if browser supports WebSocket
	if (!window["WebSocket"]) {
		this["oError"] = { "sCode": 'NOT_SUPPORTED', "sText": 'Browser does not support WebSockets' };
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, this["oError"]["sText"], "IHubWebSocketBase.js(87): oPrepareConnection"); };
		this["cleanup"]();
		return null;
	}
	if (!sUrl || typeof sUrl !== 'string' || sUrl === '') {
		this["oError"] = { "sCode": 'CONFIGURATION_ERROR', "sText": 'No WebSocket URL provided' };
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, this["oError"]["sText"], "IHubWebSocketBase.js(93): oPrepareConnection"); };
		this["cleanup"]();
		return null;
	}

	var oConnection = {};
	oConnection["sConnectionId"] = sConnectionId;
	oConnection["sUrl"] = sUrl;
	oConnection["sSubprotocol"] = sSubprotocol;
	oConnection["sProtocolLibrary"] = sProtocolLibrary;

	return oConnection;

};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["oPrepareConnection"] = 0; };

UCF_IHubWebSocketBase["prototype"]["oOpenConnection"] = function(oConnection) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["oOpenConnection"]++; }; 

	if (!oConnection) return null;

	try {
		oConnection["oWebSocket"] = new WebSocket(oConnection["sUrl"], [oConnection["sSubprotocol"]]);
	} catch (oException) {
		this["oError"] = { "sCode": 'CANNOT_CONNECT', "sText": oException + ' ' };
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, this["oError"]["sText"], "IHubWebSocketBase.js(116): oOpenConnection"); };
		this["cleanup"]();
		return null;
	}

	return oConnection;
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["oOpenConnection"] = 0; };

UCF_IHubWebSocketBase["prototype"]["attachHandlers"] = function(oConnection) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["attachHandlers"]++; }; 

	if (!oConnection) return;

	oConnection["oWebSocket"]["onmessage"] = this["fMessageHandler"] = function(oEvent) {
		this["onmessage"](oEvent, oConnection);
	}["bind"](this);

	oConnection["oWebSocket"]["onerror"] = this["fErrorHandler"] = function(sError) {
		this["onerror"](sError, oConnection);
	}["bind"](this);

	oConnection["oWebSocket"]["onclose"] = this["fCloseHandler"] = function(oParam) {
		this["onclose"](oParam, oConnection);
	}["bind"](this);

	oConnection["oWebSocket"]["onopen"] = this["fOpenHandler"] = function() {
		this["onopen"](oConnection);
	}["bind"](this);

	this["oConnections"][oConnection["sConnectionId"]] = oConnection;

};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["attachHandlers"] = 0; };

UCF_IHubWebSocketBase["prototype"]["sendInternal"] = function(sConnectionId, sData) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["sendInternal"]++; }; 

	var oConnection = this["oConnections"][sConnectionId];

	if (!oConnection) {
		this["fireError"](this["sId"], sConnectionId, this["oError"]["sCode"], this["oError"]["sText"]);
	}

	if (oConnection["oWebSocket"]["readyState"] === this["E_READY_STATE"]["OPEN"]) {
		//connection open => send directly
		oConnection["oWebSocket"]["send"](sData);
	} else if (oConnection["oWebSocket"]["readyState"] === this["E_READY_STATE"]["CONNECTING"]) {
		//connection opening => attach on open
		oConnection["oWebSocket"]["onopen"] = this["fOpenHandler"] = function() {
			this["sendInternal"](sConnectionId, sData);
		}["bind"](this);
	} else if (oConnection["oWebSocket"]["readyState"] === this["E_READY_STATE"]["CLOSED"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Connection closed, Try to reopen connection', "IHubWebSocketBase.js(165): sendInternal"); };
		this["openConnection"](oConnection);
		//connection opening => attach on open
		this["oWebSocket"]["onopen"] = this["fOpenHandler"] = function() {
			this["sendInternal"](sConnectionId, sData);
		}["bind"](this);
	} else {
		//connection closed or closing => sendError
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Connection closing, Cannot send message', "IHubWebSocketBase.js(173): sendInternal"); };
		this["fireError"](this["sId"], sConnectionId, 'CONNECTION_CLOSING', 'Connection closing, Cannot send message');
	}

};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["sendInternal"] = 0; };

UCF_IHubWebSocketBase["prototype"]["send"] = function(sConnectionId, sData) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["send"]++; }; 

	this["sendInternal"](sConnectionId, sData);

};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["send"] = 0; };

UCF_IHubWebSocketBase["prototype"]["onmessage"] = function(oEvent, oConnection) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["onmessage"]++; }; 

	//check that oEvent.data is of type string
	if (typeof oEvent["data"] === 'string') {
		this["fireReceive"](this["sId"], oConnection["sConnectionId"], oConnection["sSubprotocol"], oEvent["data"]);
		this["fireEvent"](this["E_EVENTS"]["InternalReceiveText"], { "sConnectionId": oConnection["sConnectionId"], "sSubprotocol": oConnection["sSubprotocol"], "sData": oEvent["data"] });
	} else {
		//raise only internal events for binary messages
		oConnection["oWebSocket"]["binaryType"] = 'blob';
		this["fireEvent"](this["E_EVENTS"]["InternalReceiveBinary"], { "sConnectionId": oConnection["sConnectionId"], "sSubprotocol": oConnection["sSubprotocol"], "sData": oEvent["data"] });
	}

};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["onmessage"] = 0; };

UCF_IHubWebSocketBase["prototype"]["onerror"] = function(sError, oConnection) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["onerror"]++; }; 

	if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Error from WebSocket connection:' + sError, "IHubWebSocketBase.js(201): onerror"); };
	if (oConnection["oWebSocket"]["readyState"] === window["WebSocket"]["OPEN"])
		this["fireError"](this["sId"], oConnection["sConnectionId"], 'CONNECTION_ERROR', sError);

};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["onerror"] = 0; };
UCF_IHubWebSocketBase["prototype"]["onclose"] = function(oParam, oConnection) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["onclose"]++; }; 

	//	this.cleanup();
	if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Close of WebSocket connection: Code: ' + oParam["code"] + ' Reason: ' + oParam["reason"], "IHubWebSocketBase.js(209): onclose"); };
	this["fireClose"](this["sId"], oConnection["sConnectionId"], oParam["code"], oParam["reason"]);

};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["onclose"] = 0; };

UCF_IHubWebSocketBase["prototype"]["onopen"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["onopen"]++; }; 

	//	this.cleanup();

};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketBase["_"]["onopen"] = 0; };

};
sap["ls"]["preload"]["UCF_IHubWebSocketPcp"] = function() {/* global UCF_IHubWebSocketBase */
/// <reference path="./IHubWebSocketBase.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/* global SapPcpWebSocket */

/* UCF_IHubWebSocketPcp uses the (ABAP-) PCP protocol which is implemented elsewhere - by default in
 * '/sap/bc/webdynpro/sap/ur/sap-pcp-websocket.js'
 * for synchronizing that we use a callback
 * 'loadPcpCallback'
 * which is called after that implementation has been loaded
 *
 * oConnectionProperties =
 * [
 * {'connectionId': 'WDA_FRAMEWORK',
 * 'protocol': 'v10.pcp.sap.com',
 * 'socketUrl': 'wss://ldciu1y.wdf.sap.corp:44355/sap/bc/apc/sap/zau_wda',
 * 'aChannels': [
 * 		{
 * 		'pcp_fields': {
 *	 		'amc_application_id' : 'SYSTEM_CHANNELS',
 * 			'amc_channel_id' : '/system_messages',
 * 			'amc_channel_extension_id':'fa163e8d39f61ed6a89c58ca592a630e'
 *	 		} ,
 * 		'oControl' : {
 * 			'onMessage':'myMessageHandler',
 * 			'sListenerId':'lsListenerObject'
 * 			}
 * 	...
 * 		]
 * }
 *
 */

/**
 * Class LS IHubWebSocketPcp
 *
 * Integration Hub Plugin for WebSockets based on the ABAP Pcp Subprotocol
 *
 * 
 * @class
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS}  oLS reference to Lightspeed object
 */
function UCF_IHubWebSocketPcp(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["UCF_IHubWebSocketPcp"]++; }; 

	if (arguments["length"] === 0) {
		return;
	}

	UCF_IHubWebSocketBase["apply"](this, [oDomRef, oLS]);

	var sProtocolUrl = '/sap/public/bc/ur/sap-pcp-websocket.js';
	// eslint-disable-next-line no-undef
	if (__UCF_DEBUG__)
		sProtocolUrl = '/sap/public/bc/ur/sap-pcp-websocket-dbg.js';
	this["oPendingOpenRequests"] = [];
	this["oPendingSendRequests"] = [];
	var sContents = '';
	if (oDomRef)
		sContents = oDomRef["innerHTML"]["substring"](11, oDomRef["innerHTML"]["length"] - 5);
	if (sContents && sContents !== '') {
		try {
			this["oConnectionProperties"] = JSON["parse"](sContents);
			if (this["oConnectionProperties"]["aChannels"]) {
				var aInitChannels = this["oConnectionProperties"]["aChannels"];
				var aChannels = {};
				var index;
				for (index = 0; index < aInitChannels["length"]; index++) {
					var sID = 'amc://' + aInitChannels[index]["pcp_fields"]["amc_application_id"]["toLowerCase"]() + aInitChannels[index]["pcp_fields"]["amc_channel_id"];
					aChannels[sID] = aInitChannels[index];
				}
				this["oConnectionProperties"]["aChannels"] = aChannels;
			}
		} catch (e) {}
	}
	sProtocolUrl = oDomRef["getAttribute"]('data-protocolimpl');
	if (!sProtocolUrl || sProtocolUrl === '' || sProtocolUrl["indexOf"]('websocket') !== -1) {
		sProtocolUrl = '/sap/public/bc/ur/sap-pcp-websocket.js';
	}
	if (!window["SapPcpWebSocket"])
		oLS["oPage"]["addScript"](sProtocolUrl, null, null, this, 'loadPcpCallback');
};window["UCF_IHubWebSocketPcp"] = UCF_IHubWebSocketPcp; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_IHubWebSocketPcp"); UCF_IHubWebSocketPcp["_"] = {UCF_IHubWebSocketPcp: 0}; }; ;

UCF_IHubWebSocketPcp["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_IHubWebSocketBase"))(); UCF_IHubWebSocketPcp.prototype["sClassName"] = "UCF_IHubWebSocketPcp";

UCF_IHubWebSocketPcp["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["destroy"]++; }; 
	this["oPendingOpenRequests"] = null;
	this["oPendingSendRequests"] = null;
	this["oConnectionProperties"] = null;
	UCF_IHubWebSocketBase.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["destroy"] = 0; };

UCF_IHubWebSocketPcp["prototype"]["open"] = function(sId, sUrl, sProtocol, sProtocolUrl) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["open"]++; }; 
	if (UCF_IHubWebSocketPcp["bPcpLoaded"] === true)
		UCF_IHubWebSocketBase.prototype["open"]["call"](this, sId, sUrl, sProtocol, sProtocolUrl);
	else
		this["oPendingOpenRequests"][sId] = this["oPrepareConnection"](sId, sUrl, sProtocol, sProtocolUrl);
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["open"] = 0; };

UCF_IHubWebSocketPcp["prototype"]["loadPcpCallback"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["loadPcpCallback"]++; }; 
	UCF_IHubWebSocketPcp["bPcpLoaded"] = true;
	for (var sId in this["oPendingOpenRequests"])
		this["open"](this["oPendingOpenRequests"][sId]["sConnectionId"],
			this["oPendingOpenRequests"][sId]["sUrl"],
			this["oPendingOpenRequests"][sId]["sSubprotocol"],
			this["oPendingOpenRequests"][sId]["sProtocolLibrary"]);
	this["oOpenRequests"] = [];
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["loadPcpCallback"] = 0; };

UCF_IHubWebSocketPcp["prototype"]["oPrepareConnection"] = function(sConnectionId, sUrl, sSubprotocol, sProtocolLibrary) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["oPrepareConnection"]++; }; 

	var oConnection = null;

	//If no sub protocol and/or library is supplied => fall back to base implementation
	if (sProtocolLibrary === '' || sSubprotocol === '') {
		return UCF_IHubWebSocketBase.prototype["oPrepareConnection"]["call"](this, sConnectionId, sUrl, sSubprotocol, sProtocolLibrary);
	}
	if (oConnection == null) {
		oConnection = new Object();
		oConnection["sConnectionId"] = sConnectionId;
		if (sUrl["indexOf"]('//') !== -1)
			oConnection["sUrl"] = sUrl;
		else {
			var sProtocol = 'wss:';
			if (window["location"]["protocol"] === 'http:')
				sProtocol = 'ws:';
			oConnection["sUrl"] = sProtocol + '//' + window["location"]["host"] + sUrl;
		}
		oConnection["sSubprotocol"] = sSubprotocol;
		oConnection["sProtocolLibrary"] = sProtocolLibrary;
	}
	return oConnection;
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["oPrepareConnection"] = 0; };

UCF_IHubWebSocketPcp["prototype"]["onopen"] = function(oConnection) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["onopen"]++; }; 
	var oImmernochPending = [];
	for (var i = 0; i < this["oPendingSendRequests"]["length"]; i++) {
		if (this["oPendingSendRequests"][i]["sConnectionId"] === oConnection["sConnectionId"])
			this["send"](this["oPendingSendRequests"][i]["sConnectionId"],
				this["oPendingSendRequests"][i]["sData"], this["oPendingSendRequests"][i]["oPcpFields"]);
		else
			oImmernochPending["push"](this["oPendingSendRequests"][i]);
	}
	this["oPendingSendRequests"] = oImmernochPending;
	/*
		var aChannels = oConnection.aChannels;
		for (sChannelId in aChannels){
			var oPCPFields = aChannels[sChannelId].pcp_fields;
			oPCPFields["wda-command"] = "bind";
			oPCPFields["pcp-action"] = "MESSAGE";
			oPCPFields["pcp-body-type"] = "text";
			if (oConnection.oWebSocket)
				oConnection.oWebSocket.send ("", oPCPFields);
		}
	    */
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["onopen"] = 0; };

UCF_IHubWebSocketPcp["prototype"]["oOpenConnection"] = function(oConnection) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["oOpenConnection"]++; }; 

	if (!oConnection) return null;

	// If no sub protocol and/or library is supplied => fall back to base implementation
	if (oConnection["sProtocolLibrary"] === '' || oConnection["sSubprotocol"] === '') {
		return UCF_IHubWebSocketBase.prototype["oOpenConnection"]["call"](this, oConnection);
	}

	// Create Pcp Websocket
	if (SapPcpWebSocket["MUX"])
		oConnection["oWebSocket"] = new SapPcpWebSocket(oConnection["sUrl"], [oConnection["sSubprotocol"]], SapPcpWebSocket["MUX"]["AUTO"]);
	else
		oConnection["oWebSocket"] = new SapPcpWebSocket(oConnection["sUrl"], [oConnection["sSubprotocol"]]);
	return oConnection;
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["oOpenConnection"] = 0; };

UCF_IHubWebSocketPcp["prototype"]["close"] = function(sConnectionId, sMessage) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["close"]++; }; 
	var oConnection = this["oConnections"][sConnectionId];
	if (!oConnection) return;
	oConnection["oWebSocket"]["onclose"] = function() {};
	if (sMessage && sMessage !== "")
		oConnection["oWebSocket"]["close"](1000, sMessage);
	else
		oConnection["oWebSocket"]["close"]();
	if (this["oRegisteredActions"] && this["oRegisteredActions"][oConnection["sConnectionId"]]) {
		var oAction = this["oRegisteredActions"][oConnection["sConnectionId"]];
		if (oAction["onClose"]) {
			try {
				var retval;
				if (oAction["sListenerId"]) {
					var oListener;
					if (typeof oAction["sListenerId"] === 'string')
						oListener = this["oLS"]["oGetControlById"](oAction["sListenerId"]);
					else
						oListener = oAction["sListenerId"];
					retval = oListener[oAction["onClose"]]["apply"](oListener, [sMessage]);
				} else if (oAction["oListener"]) {
					retval = oAction["oListener"][oAction["onClose"]]["apply"](oAction["oListener"], [sMessage]);
				} else
					retval = window[oAction["onClose"]](sMessage);
			} catch (e) {
				if (retval !== true) return;
			}
		}
		this["oConnections"][sConnectionId] = null;
		if (this["oRegisteredActions"] && this["oRegisteredActions"][sConnectionId])
			this["oRegisteredActions"][sConnectionId] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["close"] = 0; };

UCF_IHubWebSocketPcp["prototype"]["onmessage"] = function(oEvent, oConnection) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["onmessage"]++; }; 

	var sData = '',
		sType = 'string';

	// If no sub protocol and/or library is supplied => fall back to base implementation
	if (oConnection["sProtocolLibrary"] === '' || oConnection["sSubprotocol"] === '') {
		UCF_IHubWebSocketBase.prototype["onmessage"]["call"](this, oEvent, oConnection);
	}

	/* if this is a pcp message, there are:
	 * oEvent.pcpFields (object)
	 * oEvent.data
	 */
	if (oEvent["pcpFields"]) {

		sType = typeof oEvent["data"];
		//		if (oConnection.oWebSocket._serializePcpFields) {
		//			sData = oConnection.oWebSocket._serializePcpFields(oEvent.pcpFields, sType, "MESSAGE") + oEvent.data;
		//		} else {
		sData = oEvent["data"];
		//		}
		if (this["oRegisteredActions"] && this["oRegisteredActions"][oConnection["sConnectionId"]]) {
			var oAction = this["oRegisteredActions"][oConnection["sConnectionId"]];
			if (oAction["onMessage"]) {
				var retval;
				var oCargo;
				if (oAction["bPayLoadOnly"])
					oCargo = oEvent["data"];
				else
					oCargo = oEvent;
				try {
					if (oAction["sListenerId"]) {
						var oListener;
						if (typeof oAction["sListenerId"] === 'string')
							oListener = this["oLS"]["oGetControlById"](oAction["sListenerId"]);
						else
							oListener = oAction["sListenerId"];
						retval = oListener[oAction["onMessage"]]["apply"](oListener, [oCargo]);
					} else if (oAction["oListener"]) {
						retval = oAction["oListener"][oAction["onMessage"]]["apply"](oAction["oListener"], [oCargo]);
					} else
						retval = window[oAction["onMessage"]](oCargo);
				} catch (e) {}
				if (retval !== true) return;
			}
		}
		switch (oEvent["pcpFields"]["sEventSeverity"]) {
			case ('0'):
				this["fireReceivePcpEventSeverity0"](this["sId"], oConnection["sConnectionId"], oConnection["sSubprotocol"], sData);
				break;
			case ('1'):
				this["fireReceivePcpEventSeverity1"](this["sId"], oConnection["sConnectionId"], oConnection["sSubprotocol"], sData);
				break;
			default:
				this["fireReceivePcpEventSeverity0"](this["sId"], oConnection["sConnectionId"], oConnection["sSubprotocol"], JSON["stringify"](oEvent));
		}

		if (sType === 'string') {
			this["fireEvent"](this["E_EVENTS"]["InternalReceiveText"], { "sConnectionId": oConnection["sConnectionId"], "sSubprotocol": oConnection["sSubprotocol"], "sData": sData });
		} else {
			//raise only internal events for binary messages
			oConnection["oWebSocket"]["binaryType"] = 'blob';
			this["fireEvent"](this["E_EVENTS"]["InternalReceiveBinary"], { "sConnectionId": oConnection["sConnectionId"], "sSubprotocol": oConnection["sSubprotocol"], "sData": sData });
		}
	} else {
		UCF_IHubWebSocketBase.prototype["onmessage"]["call"](this, oEvent, oConnection);
	}
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["onmessage"] = 0; };

UCF_IHubWebSocketPcp["prototype"]["send"] = function(sConnectionId, sData, oPcpFields) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["send"]++; }; 
	if (UCF_IHubWebSocketPcp["bPcpLoaded"] !== true) {
		this["oPendingSendRequests"]["push"]({ 'sConnectionId': sConnectionId, 'sData': sData, 'oPcpFields': oPcpFields });
		return;
	}
	var oConnection = this["oConnections"][sConnectionId];

	if (!oConnection || !oConnection["oWebSocket"]) {
		this["fireError"](this["sId"], sConnectionId, this["oError"]["sCode"], this["oError"]["sText"]);
		return;
	}
	if (oConnection["oWebSocket"]["readyState"] === this["E_READY_STATE"]["OPEN"])
		oConnection["oWebSocket"]["send"](sData, oPcpFields);
	// eslint-disable-next-line eqeqeq
	else if (oConnection["oWebSocket"]["readyState"] === this["E_READY_STATE"]["CONNECTING"] || oConnection["oWebSocket"]["readyState"] == undefined)
		this["oPendingSendRequests"]["push"]({ 'sConnectionId': sConnectionId, 'sData': sData, 'oPcpFields': oPcpFields });
	else
		this["fireError"](this["sId"], sConnectionId, this["oError"]["sCode"], this["oError"]["sText"]);
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["send"] = 0; };

UCF_IHubWebSocketPcp["prototype"]["register"] = function(sConnectionId, oAction) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["register"]++; }; 
	if (!this["oRegisteredActions"])
		this["oRegisteredActions"] = {};
	this["oRegisteredActions"][sConnectionId] = oAction;
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["register"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_IHubWebSocketPcp["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_IHubWebSocketPcp["prototype"]["aEventNames"] = ["Receive","ReceivePcpEventSeverity0","ReceivePcpEventSeverity1","Error","Close"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_IHubWebSocketPcp["prototype"]["aMethodNames"] = ["open","send","register","close","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_IHubWebSocketPcp["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_IHubWebSocketPcp["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control 
 * @param {string} sConnectionId Id of the WebSocket connection
 * @param {string} sSubprotocol Used Subprotocol
 * @param {string} sData Message payload
 * @fires IHubWebSocketPcp::Receive
 */
UCF_IHubWebSocketPcp["prototype"]["fireReceive"] = function(sId, sConnectionId, sSubprotocol, sData) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["fireReceive"]++; }; 
	/** @type {{Id: string, ConnectionId: string, Subprotocol: string, Data: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "IHubWebSocketPcp.js(358): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "IHubWebSocketPcp.js(359): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "IHubWebSocketPcp.js(360): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectionId != null, "sConnectionId != null", "IHubWebSocketPcp.js(361): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectionId) == "string", "typeof(sConnectionId) == \"string\"", "IHubWebSocketPcp.js(362): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSubprotocol != null, "sSubprotocol != null", "IHubWebSocketPcp.js(363): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSubprotocol) == "string", "typeof(sSubprotocol) == \"string\"", "IHubWebSocketPcp.js(364): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "IHubWebSocketPcp.js(365): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "IHubWebSocketPcp.js(366): fireReceive"); };
	mParams = {
		"Id": sId,
		"ConnectionId": sConnectionId,
		"Subprotocol": sSubprotocol,
		"Data": sData
	};
	
	
	
	
	this["fireSemanticEvent"]("IHubWebSocketPcp", "Receive", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["fireReceive"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control 
 * @param {string} sConnectionId Id of the WebSocket connection
 * @param {string} sSubprotocol Used Subprotocol
 * @param {string} sData Message payload
 * @fires IHubWebSocketPcp::ReceivePcpEventSeverity0
 */
UCF_IHubWebSocketPcp["prototype"]["fireReceivePcpEventSeverity0"] = function(sId, sConnectionId, sSubprotocol, sData) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["fireReceivePcpEventSeverity0"]++; }; 
	/** @type {{Id: string, ConnectionId: string, Subprotocol: string, Data: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "IHubWebSocketPcp.js(392): fireReceivePcpEventSeverity0"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "IHubWebSocketPcp.js(393): fireReceivePcpEventSeverity0"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "IHubWebSocketPcp.js(394): fireReceivePcpEventSeverity0"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectionId != null, "sConnectionId != null", "IHubWebSocketPcp.js(395): fireReceivePcpEventSeverity0"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectionId) == "string", "typeof(sConnectionId) == \"string\"", "IHubWebSocketPcp.js(396): fireReceivePcpEventSeverity0"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSubprotocol != null, "sSubprotocol != null", "IHubWebSocketPcp.js(397): fireReceivePcpEventSeverity0"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSubprotocol) == "string", "typeof(sSubprotocol) == \"string\"", "IHubWebSocketPcp.js(398): fireReceivePcpEventSeverity0"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "IHubWebSocketPcp.js(399): fireReceivePcpEventSeverity0"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "IHubWebSocketPcp.js(400): fireReceivePcpEventSeverity0"); };
	mParams = {
		"Id": sId,
		"ConnectionId": sConnectionId,
		"Subprotocol": sSubprotocol,
		"Data": sData
	};
	
	
	
	
	this["fireSemanticEvent"]("IHubWebSocketPcp", "ReceivePcpEventSeverity0", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["fireReceivePcpEventSeverity0"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control 
 * @param {string} sConnectionId Id of the WebSocket connection
 * @param {string} sSubprotocol Used Subprotocol
 * @param {string} sData Message payload
 * @fires IHubWebSocketPcp::ReceivePcpEventSeverity1
 */
UCF_IHubWebSocketPcp["prototype"]["fireReceivePcpEventSeverity1"] = function(sId, sConnectionId, sSubprotocol, sData) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["fireReceivePcpEventSeverity1"]++; }; 
	/** @type {{Id: string, ConnectionId: string, Subprotocol: string, Data: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "IHubWebSocketPcp.js(426): fireReceivePcpEventSeverity1"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "IHubWebSocketPcp.js(427): fireReceivePcpEventSeverity1"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "IHubWebSocketPcp.js(428): fireReceivePcpEventSeverity1"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectionId != null, "sConnectionId != null", "IHubWebSocketPcp.js(429): fireReceivePcpEventSeverity1"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectionId) == "string", "typeof(sConnectionId) == \"string\"", "IHubWebSocketPcp.js(430): fireReceivePcpEventSeverity1"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSubprotocol != null, "sSubprotocol != null", "IHubWebSocketPcp.js(431): fireReceivePcpEventSeverity1"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSubprotocol) == "string", "typeof(sSubprotocol) == \"string\"", "IHubWebSocketPcp.js(432): fireReceivePcpEventSeverity1"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "IHubWebSocketPcp.js(433): fireReceivePcpEventSeverity1"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "IHubWebSocketPcp.js(434): fireReceivePcpEventSeverity1"); };
	mParams = {
		"Id": sId,
		"ConnectionId": sConnectionId,
		"Subprotocol": sSubprotocol,
		"Data": sData
	};
	
	
	
	
	this["fireSemanticEvent"]("IHubWebSocketPcp", "ReceivePcpEventSeverity1", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["fireReceivePcpEventSeverity1"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control 
 * @param {string} sConnectionId Id of the WebSocket connection
 * @param {UCF_ClientInterfaces.E.IhubWebSocketErrorCode} sErrorCode Error Code
 * @param {string} sError Error Message
 * @fires IHubWebSocketPcp::Error
 */
UCF_IHubWebSocketPcp["prototype"]["fireError"] = function(sId, sConnectionId, sErrorCode, sError) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["fireError"]++; }; 
	/** @type {{Id: string, ConnectionId: string, ErrorCode: UCF_ClientInterfaces.E.IhubWebSocketErrorCode, Error: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "IHubWebSocketPcp.js(460): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "IHubWebSocketPcp.js(461): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "IHubWebSocketPcp.js(462): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectionId != null, "sConnectionId != null", "IHubWebSocketPcp.js(463): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectionId) == "string", "typeof(sConnectionId) == \"string\"", "IHubWebSocketPcp.js(464): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sErrorCode != null, "sErrorCode != null", "IHubWebSocketPcp.js(465): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sErrorCode) == "string", "typeof(sErrorCode) == \"string\"", "IHubWebSocketPcp.js(466): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sError != null, "sError != null", "IHubWebSocketPcp.js(467): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sError) == "string", "typeof(sError) == \"string\"", "IHubWebSocketPcp.js(468): fireError"); };
	mParams = {
		"Id": sId,
		"ConnectionId": sConnectionId,
		"ErrorCode": sErrorCode,
		"Error": sError
	};
	
	
	
	
	this["fireSemanticEvent"]("IHubWebSocketPcp", "Error", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["fireError"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control 
 * @param {string} sConnectionId Id of the WebSocket connection
 * @param {number} iCode Code
 * @param {string} sReason Reason
 * @fires IHubWebSocketPcp::Close
 */
UCF_IHubWebSocketPcp["prototype"]["fireClose"] = function(sId, sConnectionId, iCode, sReason) {;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["fireClose"]++; }; 
	/** @type {{Id: string, ConnectionId: string, Code: number, Reason: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "IHubWebSocketPcp.js(494): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "IHubWebSocketPcp.js(495): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "IHubWebSocketPcp.js(496): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectionId != null, "sConnectionId != null", "IHubWebSocketPcp.js(497): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectionId) == "string", "typeof(sConnectionId) == \"string\"", "IHubWebSocketPcp.js(498): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iCode != null, "iCode != null", "IHubWebSocketPcp.js(499): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iCode) == "number", "typeof(iCode) == \"number\"", "IHubWebSocketPcp.js(500): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sReason != null, "sReason != null", "IHubWebSocketPcp.js(501): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sReason) == "string", "typeof(sReason) == \"string\"", "IHubWebSocketPcp.js(502): fireClose"); };
	mParams = {
		"Id": sId,
		"ConnectionId": sConnectionId,
		"Code": iCode,
		"Reason": sReason
	};
	
	
	
	
	this["fireSemanticEvent"]("IHubWebSocketPcp", "Close", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_IHubWebSocketPcp["_"]["fireClose"] = 0; };

};
sap["ls"]["preload"]["UCF_IHubWorkProtect"] = function() {/* global _assert, _trace, INFO, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * Class LS IHubWorkProtect
 *
 * Integration Hub Plugin for Handling of WorkProtect mode in the Portal
 *
 * 
 *
 * @class
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS}   oLS   reference to Lightspeed object
 */
function UCF_IHubWorkProtect(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_IHubWorkProtect["_"]["UCF_IHubWorkProtect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "IHubWorkProtect.js(24): UCF_WorkProtectHandler"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "IHubWorkProtect.js(25): UCF_WorkProtectHandler"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "IHubWorkProtect.js(26): UCF_WorkProtectHandler"); };

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "IHubWorkProtect.js(28): UCF_WorkProtectHandler"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oIHub"] = this["oGetParent"]();
	this["oEPCM"] = this["oIHub"]["oGetEPCM"]();

	var oHubWorkProtect = this;
	window["UCF_WorkProtectHandler"] = function(oPortalEvent) {

		// This caused a very ugly regression because portal will call this function in a 1-second interval !!
		//		// force blur in edit fields, e.g. if the browser window is closed
		//		// This will fire a CHANGE event, which has markDirty=true
		//		var sId = oHubWorkProtect.oLS.sGetFocusedElementId();
		//		if (sId) {
		//			document.body.focus();
		//			oHubWorkProtect.oLS.focusElement(sId);
		//		}

		// Report dirty-flag as true if a roundtrip is in progress in LS
		return oHubWorkProtect["oLS"]["bIsDirty"]() || ((window["UCF_System"]["bSetDirtyForRoundtrips"] || window["UCF_System"]["sSetDirtyForRoundtrips"] === "true") && oLS["bLocked"]());
	};

	this["sPortalELID"] = "";
	this["bSubscibed"] = false;

	this["subscribeInquiryHandler"]();

};window["UCF_IHubWorkProtect"] = UCF_IHubWorkProtect; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_IHubWorkProtect"); UCF_IHubWorkProtect["_"] = {UCF_IHubWorkProtect: 0}; }; ;
UCF_IHubWorkProtect["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_IHubWorkProtect.prototype["sClassName"] = "UCF_IHubWorkProtect";

UCF_IHubWorkProtect["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubWorkProtect["_"]["destroy"]++; }; 

	this["unsubscribeInquiryHandler"]();
	window["UCF_WorkProtectHandler"] = null;
	this["oEPCM"] = null;
	this["oIHub"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_IHubWorkProtect["_"]["destroy"] = 0; };

UCF_IHubWorkProtect["prototype"]["WPI_EVENT_NAMESPACE"] = "urn:com.sapportals.portal:workprotect";
UCF_IHubWorkProtect["prototype"]["WPI_EVENT_NAME"] = "inquiryProtection";
UCF_IHubWorkProtect["prototype"]["WPI_HANDLER_NAME"] = "UCF_WorkProtectHandler";

UCF_IHubWorkProtect["prototype"]["subscribeInquiryHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubWorkProtect["_"]["subscribeInquiryHandler"]++; }; 
	try {
		//--------
		this["sPortalELID"] = this["oEPCM"]["subscribeEvent"](this["WPI_EVENT_NAMESPACE"], this["WPI_EVENT_NAME"], window, this["WPI_HANDLER_NAME"]);
		//--------
		this["bSubscribed"] = true;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "IHubWorkProtect.subscribeInquiry :: success ", "IHubWorkProtect.js(79): subscribeInquiryHandler"); };
	} catch (ex) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "IHubWorkProtect.subscribeInquiry :: failed ", "IHubWorkProtect.js(81): subscribeInquiryHandler"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubWorkProtect["_"]["subscribeInquiryHandler"] = 0; };

UCF_IHubWorkProtect["prototype"]["unsubscribeInquiryHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubWorkProtect["_"]["unsubscribeInquiryHandler"]++; }; 

	if (!this["bSubscribed"]) return;

	try {
		//--------
		this["oEPCM"]["unsubscribeEvent"](this["WPI_EVENT_NAMESPACE"], this["WPI_NAME"], this["sPortalELID"]);
		//--------
		this["bSubscribed"] = false;
		this["sPortalELID"] = "";
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "IHubWorkProtect.unsubscribeInquiry :: success ", "IHubWorkProtect.js(95): unsubscribeInquiryHandler"); };
	} catch (ex) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "IHubWorkProtect.unsubscribeInquiry :: failed ", "IHubWorkProtect.js(97): unsubscribeInquiryHandler"); };
	}
};;if (__UCF_COVERAGE__) { UCF_IHubWorkProtect["_"]["unsubscribeInquiryHandler"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_IHubWorkProtect["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_IHubWorkProtect["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_IHubWorkProtect["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_IHubWorkProtect["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_IHubWorkProtect["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_IHubWorkProtect["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_IHubWorkProtect["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Iframe"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_RequestUtil */
/// <reference path="../../core/util/RequestUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_PlaceHolder */
/// <reference path="./base/PlaceHolder.js"/>

/**
 * 
 *
 * @class
 * @extends UCF_PlaceHolder
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Iframe(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Iframe["_"]["UCF_Iframe"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Iframe.js(29): UCF_Iframe"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Iframe.js(30): UCF_Iframe"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Iframe.js(31): UCF_Iframe"); };

	UCF_PlaceHolder["apply"](this, [oDomRef, oLS]);

	this["attachBrowserEvent"]("load", this["oDomRef"]);
	if (this["bAutoHeight"]) {
		this["attachBrowserEvent"]("resize", this["oDomRef"]);
	}

	var self = this;
	UCF_DomUtil["attachEvent"](window, "message", this["postMessageHandler"] = function(oEvent) {
		if (oDomRef["contentWindow"] === oEvent["source"])
			self["fireSemanticEvent"]("Iframe", "Message", { "Id": self["sId"], "Data": oEvent["data"] }, false, false, false);
	});

	this["bLocked"] = false;
	this["bLoaded"] = false;
	this["bStopAdapting"] = false;
	this["bResizeInProgress"] = false;

	this["oLastSize"] = { "iHeight": 0, "iWidth": 0 };
	this["oSize"] = null;
	this["sCssHeight"] = null;
	this["sInitialHeight"] = this["sHeight"];

};window["UCF_Iframe"] = UCF_Iframe; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Iframe"); UCF_Iframe["_"] = {UCF_Iframe: 0}; }; ;

UCF_Iframe["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PlaceHolder"))(); UCF_Iframe.prototype["sClassName"] = "UCF_Iframe";

/**
 * Initialize, register the onload event of the iframe,
 * if the IFrame is already loaded, fire the Load event.
 *
 * The "loaded" attribute in the DOM is set by a script
 * directly defined in the renderer, as the onload
 * event of the iframe may occur before LightSpeed
 * has been initialized.
 */
UCF_Iframe["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["initialize"]++; }; 

	// If autoheight is enabled, and the height has been calculated before, set
	// the placeholder height, before calling super
	if (this["bKeepAlive"] && this["bAutoHeight"] && this["sCssHeight"]) {
		this["oGetRootRef"]()["style"]["height"] = this["sCssHeight"];
	}

	UCF_PlaceHolder.prototype["initialize"]["apply"](this, arguments);

	if (this["sPostParameters"]) {
		// do a post request but skip for frames that are marked with
		// loadedPOST flag (see 404550 2010).
		if (!this["oDomRef"]["loadedPOST"]) {
			var mParameters = UCF_JsUtil["mDecodeURIParameters"](this["sPostParameters"]);
			var sName = this["oDomRef"]["getAttribute"]("name");
			if (!sName) {
				sName = "iframe" + UCF_JsUtil["sGetUID"]();
				this["oDomRef"]["setAttribute"]("name", sName);
				this["oDomRef"]["contentWindow"]["name"] = sName;
			}
			UCF_RequestUtil["sendFormRequest"]("POST", this["sUrl"], mParameters, sName);
			this["oDomRef"]["loadedPOST"] = true;
		}

	} else if (this["oDomRef"]["loaded"]) {

		UCF_JsUtil["delayedCall"](0, this, "processLoad");

	} else if (!UCF_UserAgent["bIsIE"]()) {
		// support CSP and remove onload handler from HTML
		this["setUrl"](this["sUrl"]);

	}

	if (this["sLockBehavior"] === "ROUNDTRIP") {
		this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "lock");
		this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "unlock");
		if (this["oLS"]["bIsLocked"]) this["lock"]();
	};

};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["initialize"] = 0; };

/**
 * Destructor
 */
UCF_Iframe["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["destroy"]++; }; 

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	// In rare cases the IFrame is destroyed twice (due to the delayed purgeControl of the PlaceHolder)
	if (this["oDomRef"]) {
		// change URL otherwise IFRAME unload on MSIE is not fired in reliable way - int.CSN 601001 2010
		if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
			this["setUrl"]("about:blank");
		}

		this["detachBrowserEvent"]("load", this["oDomRef"]);
		if (this["bAutoHeight"]) {
			this["detachBrowserEvent"]("resize", this["oDomRef"]);
			this["clearIntervalCall"]();
		}

		UCF_DomUtil["detachEvent"](window, "message", this["postMessageHandler"]);

		if (this["sLockBehavior"] === "ROUNDTRIP") {
			this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "lock");
			this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "unlock");
			this["unlock"]();
		}
	}

	this["removeBlindLayer"]();

	this["oLastSize"] = null;
	this["oSize"] = null;
	this["oWebKitDiv"] = null;

	this["postMessageHandler"] = null;
	this["sCssHeight"] = null;
	this["sInitialHeight"] = null;
	this["sInterval"] = null;
	this["sHeight"] = null;

	UCF_PlaceHolder.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["destroy"] = 0; };

/**
 * Iframe onload handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Iframe["prototype"]["onload"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onload"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Iframe.js(164): onload"); };

	this["oDomRef"]["loaded"] = true;
	this["processLoad"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onload"] = 0; };

/**
 * Iframe resize handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Iframe["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onresize"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Iframe.js(178): onresize"); };

	UCF_PlaceHolder.prototype["onresize"]["apply"](this, arguments);

	if (this["bLocked"]) {
		this["adaptBlindLayerSize"]();
	}
	if (this["bAutoHeight"]) {
		if (!this["bCanAccessFrame"]()) return;
		if (this["bLoaded"] && !this["bResizeInProgress"]) {
			this["checkSize"]();
		}
	}

	// In IE and Edge we get some wrong resize events in case of IFrame inside scroll-container and/or a vertical scrollbar exist:
	// - the Placeholder will change the oRootRef height or
	// - checkSize() will change the oDomRef height again
	// which will cause endless-resizing-loops unless we skip one check-intervall of the ResizeEventHelper
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		this["oLS"]["oBrowserWindow"]["oResizeEventHelper"]["reset"](this["oRootRef"], this);
		this["oLS"]["oBrowserWindow"]["oResizeEventHelper"]["reset"](this["oDomRef"], this);
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onresize"] = 0; };

/**
 * Processing after Iframe is loaded
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Iframe["prototype"]["processLoad"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["processLoad"]++; }; 

	this["bLoaded"] = true;
	this["bStopAdapting"] = false;

	this["fireLoad"](this["sId"]);

	if (this["bAutoHeight"]) {
		if (!this["bCanAccessFrame"]()) return;
		if (this["oWebKitDiv"]) {
			this["oWebKitDiv"] = null;
		}
		if (!this["sInterval"]) {
			this["sInterval"] = UCF_JsUtil["intervalCall"](100, this, "checkSize");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["processLoad"] = 0; };

/**
 * Check the size of the iframe content
 */
UCF_Iframe["prototype"]["checkSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["checkSize"]++; }; 

	if (this["bResizeInProgress"]) return;
	if (!this["bCanAccessFrame"]()) return;

	this["oSize"] = this["oGetContentSize"]();
	if (this["oSize"]["iHeight"] !== this["oLastSize"]["iHeight"]) {
		this["adaptHeight"]();
		this["oLastSize"] = this["oSize"];
	}

};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["checkSize"] = 0; };

/**
 * Adapt the height of the iframe to the height of its content
 */
UCF_Iframe["prototype"]["adaptHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["adaptHeight"]++; }; 

	if (!this["bCanAccessFrame"]()) return;
	if (this["bStopAdapting"]) return;
	this["bResizeInProgress"] = true;

	var oNewSize;

	// Applying new height to the iframe
	this["oSize"] = this["oGetContentSize"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Height 1: " + this["oSize"]["iHeight"], "Iframe.js(255): adaptHeight"); };
	this["sCssHeight"] = (this["oSize"]["iHeight"] + 1) + "px";
	this["setHeight"](this["sCssHeight"]);

	// If the width has changed (e.g. due to a scrollbar) apply height again
	oNewSize = this["oGetContentSize"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Height 2: " + oNewSize["iHeight"], "Iframe.js(261): adaptHeight"); };
	if (oNewSize["iWidth"] !== this["oSize"]["iWidth"]) {
		this["oSize"] = oNewSize;
		this["sCssHeight"] = (this["oSize"]["iHeight"] + 1) + "px";
		this["setHeight"](this["sCssHeight"]);
	}

	// Continue after timeout to let the browser recalc iframe content size
	UCF_JsUtil["delayedCall"](0, this, "continueAdaptHeight", [0]);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["adaptHeight"] = 0; };

/**
 * Adapt the height of the iframe to the height of its content
 * @param { int } iCount
 */
UCF_Iframe["prototype"]["continueAdaptHeight"] = function(iCount) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["continueAdaptHeight"]++; }; 

	if (!this["bCanAccessFrame"]()) return;

	// If height is growing compared to before resize stop adapting
	var oNewSize = this["oGetContentSize"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Height 3: " + oNewSize["iHeight"], "Iframe.js(282): continueAdaptHeight"); };
	if (oNewSize["iHeight"] !== this["oSize"]["iHeight"]) {
		// Try multiple times, in case the content size change was not caused by the iframe resize
		if (iCount < 3) {
			this["oSize"] = oNewSize;
			this["sCssHeight"] = (this["oSize"]["iHeight"] + 1) + "px";
			this["setHeight"](this["sCssHeight"]);
			UCF_JsUtil["delayedCall"](0, this, "continueAdaptHeight", [iCount + 1]);
			return;
		}
		// Iframe content is growing with iframe size - stop adapting
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Stop adapting as content is growing or shrinking with iframe size", "Iframe.js(293): continueAdaptHeight"); };
		this["sCssHeight"] = this["sInitialHeight"];
		this["setHeight"](this["sCssHeight"]);
		this["clearIntervalCall"]();
		this["bStopAdapting"] = true;
	}

	if (this["sCssHeight"] !== this["sHeight"]) {
		this["sHeight"] = this["sCssHeight"];
		this["setClientProperty"]("Height", this["sHeight"], true);
		this["fireResize"](this["sId"], this["sHeight"]);
	}

	this["notifyLayoutChange"]();
	this["bResizeInProgress"] = false;
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["continueAdaptHeight"] = 0; };

/**
 * Set iframe height
 *
 * @param {string} sCssHeight
 */
UCF_Iframe["prototype"]["setHeight"] = function(sCssHeight) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setHeight"]++; }; 
	this["oGetRootRef"]()["style"]["height"] = sCssHeight;
	this["oGetObjectRef"]()["style"]["height"] = sCssHeight;
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setHeight"] = 0; };

/**
 * Clear interval call
 *
 */
UCF_Iframe["prototype"]["clearIntervalCall"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["clearIntervalCall"]++; }; 
	if (this["sInterval"]) {
		UCF_JsUtil["clearIntervalCall"](this["sInterval"]);
		this["sInterval"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["clearIntervalCall"] = 0; };

/**
 * Method to determine whether the frame content can be accessed
 * @return { boolean } bCanAccessFrame
 */
UCF_Iframe["prototype"]["bCanAccessFrame"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["bCanAccessFrame"]++; }; 
	var bCanAccessFrame = false;
	var iHeight;
	try {
		iHeight = this["oDomRef"]["contentWindow"]["document"]["body"]["offsetHeight"];
		bCanAccessFrame = true;
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "IFrame content can be accessed, content height is " + iHeight, "Iframe.js(341): bCanAccessFrame"); };
	} catch (e) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "IFrame content can not be accessed (different protocol/domain)", "Iframe.js(343): bCanAccessFrame"); };
	}
	return bCanAccessFrame;
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["bCanAccessFrame"] = 0; };

/**
 * Find out the actual height of the content inside the iframe
 * @return { Object } {iHeight: iContentHeight, iWidth: iContentWidth}
 */
UCF_Iframe["prototype"]["oGetContentSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["oGetContentSize"]++; }; 
	var oFrameDocument = this["oDomRef"]["contentWindow"]["document"],
		oFrameBody = oFrameDocument["body"],
		iMarginTop = parseInt(UCF_DomUtil["sGetCurrentStyle"](oFrameBody, "marginTop"), 10),
		iMarginBottom = parseInt(UCF_DomUtil["sGetCurrentStyle"](oFrameBody, "marginBottom"), 10),
		iContentHeight, iContentWidth;

	if ((UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== "standards") && oFrameDocument["documentMode"] !== 8) {
		iContentHeight = oFrameBody["scrollHeight"];
		iContentWidth = oFrameBody["scrollWidth"];
	} else if (UCF_UserAgent["bIsWebKit"]()) {
		// WebKit does not provide any data about the content height, so as a workaround we
		// add a little div at the bottom of the page and ask for its top position
		if (!this["oWebKitDiv"]) {
			this["oWebKitDiv"] = oFrameDocument["createElement"]("div");
			this["oWebKitDiv"]["style"]["height"] = "1px";
		}
		oFrameDocument["body"]["appendChild"](this["oWebKitDiv"]);
		iContentWidth = oFrameBody["offsetWidth"];
		iContentHeight = this["oWebKitDiv"]["offsetTop"] + iMarginBottom;
		oFrameDocument["body"]["removeChild"](this["oWebKitDiv"]);
	} else {
		iContentHeight = oFrameBody["offsetHeight"] + iMarginTop + iMarginBottom;
		iContentWidth = oFrameBody["offsetWidth"];
	}

	return {
		"iHeight": iContentHeight,
		"iWidth": iContentWidth
	};
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["oGetContentSize"] = 0; };

/**
 * Sets the size of the blind layer
 */
UCF_Iframe["prototype"]["adaptBlindLayerSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["adaptBlindLayerSize"]++; }; 
	if (!this["oBlindLayer"]) return;
	var oRect = this["oGetObjectRect"](this["oDomRef"]),
		oStyle = this["oBlindLayer"]["oDomRef"]["style"];
	oStyle["top"] = oRect["top"];
	oStyle["left"] = oRect["left"];
	oStyle["width"] = oRect["width"];
	oStyle["height"] = oRect["height"];
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["adaptBlindLayerSize"] = 0; };

/**
 * Adds the blind layer to capture events
 */
UCF_Iframe["prototype"]["addBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["addBlindLayer"]++; }; 
	if (!this["oBlindLayer"]) {
		this["oBlindLayer"] = this["oLS"]["oGetBlindLayer"]();
		this["oBlindLayer"]["oDomRef"]["className"] = "lsnoprint";
	}
	this["adaptBlindLayerSize"]();
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["addBlindLayer"] = 0; };

/**
 * removes the blind layer
 */
UCF_Iframe["prototype"]["removeBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["removeBlindLayer"]++; }; 
	if (this["oBlindLayer"]) {
		this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
		this["oBlindLayer"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["removeBlindLayer"] = 0; };

/**
 * Locks the container for further event processing
 * @public
 */
UCF_Iframe["prototype"]["lock"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["lock"]++; }; 

	if (this["sLockBehavior"] === "OFF") return;

	if (!this["bLocked"]) {
		if (!this["bAutoHeight"]) {
			this["attachBrowserEvent"]("resize", this["oDomRef"]);
		}
		this["addBlindLayer"]();
		this["bLocked"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["lock"] = 0; };

/**
 * Unlocks the iframe for further event processing
 * @public
 */
UCF_Iframe["prototype"]["unlock"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["unlock"]++; }; 
	if (this["bLocked"]) {
		if (!this["bAutoHeight"]) {
			this["detachBrowserEvent"]("resize", this["oDomRef"]);
		}
		this["removeBlindLayer"]();
		this["bLocked"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["unlock"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occured
 */
UCF_Iframe["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occured
 */
UCF_Iframe["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsskipback"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occured
 */
UCF_Iframe["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Iframe.js(477): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource["getAttribute"]("tp") === "END") {
		oAccessibilityHelper["setControlType"]("IF_END");
	} else if (oSource["getAttribute"]("tp") === "START") {
		oAccessibilityHelper["setControlType"]("IF");
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	} else {
		oAccessibilityHelper["setControlType"]("IF");
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsaccessibility"] = 0; };

/**
 * sets the url of the iframe
 *
 * @param {string} sUrl the url to set
 */
UCF_Iframe["prototype"]["setUrl"] = function(sUrl) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setUrl"]++; }; 
	this["oDomRef"]["src"] = sUrl;
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setUrl"] = 0; };

/**
 * send a message via postMessage api
 *
 * @param { string } sMessage the post message
 */
UCF_Iframe["prototype"]["postMessage"] = function(sMessage) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["postMessage"]++; }; 
	this["oDomRef"]["contentWindow"]["postMessage"](sMessage, "*");
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["postMessage"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Iframe["prototype"]["aAttributeNames"] = ["sHeight","sUrl","sTooltip","sVisibility","sLifeCycle","sPostParameters","bAutoHeight","sLockBehavior","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Iframe["prototype"]["aEventNames"] = ["Load","Resize","Message"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Iframe["prototype"]["aMethodNames"] = ["setKeepAlive","setUrl","postMessage","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Iframe["prototype"]["sHeight"] = '150px';

/**
 * @private
 * @type {string}
 */
UCF_Iframe["prototype"]["sUrl"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Iframe["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Iframe["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_Iframe["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_Iframe["prototype"]["sPostParameters"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Iframe["prototype"]["bAutoHeight"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LockBehavior}
 */
UCF_Iframe["prototype"]["sLockBehavior"] = "ROUNDTRIP";

/**
 * @private
 * @type {string}
 */
UCF_Iframe["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Iframe["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setDefaultValues"]++; }; 
	this["sHeight"] = '150px';
	this["sUrl"] = '';
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sLifeCycle"] = "BROWSER";
	this["sPostParameters"] = '';
	this["bAutoHeight"] = false;
	this["sLockBehavior"] = "ROUNDTRIP";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Height", '150px', true);
		this["setClientProperty"]("Url", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("PostParameters", '', true);
		this["setClientProperty"]("AutoHeight", false, true);
		this["setClientProperty"]("LockBehavior", "ROUNDTRIP", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Iframe::Load
 */
UCF_Iframe["prototype"]["fireLoad"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireLoad"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Iframe.js(624): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Iframe.js(625): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Iframe.js(626): fireLoad"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Iframe", "Load", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireLoad"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sHeight The new height after resizing
 * @fires Iframe::Resize
 */
UCF_Iframe["prototype"]["fireResize"] = function(sId, sHeight) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireResize"]++; }; 
	/** @type {{Id: string, Height: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Iframe.js(644): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Iframe.js(645): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Iframe.js(646): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHeight != null, "sHeight != null", "Iframe.js(647): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHeight) == "string", "typeof(sHeight) == \"string\"", "Iframe.js(648): fireResize"); };
	mParams = {
		"Id": sId,
		"Height": sHeight
	};
	
	
	this["fireSemanticEvent"]("Iframe", "Resize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sData Message data
 * @fires Iframe::Message
 */
UCF_Iframe["prototype"]["fireMessage"] = function(sId, sData) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireMessage"]++; }; 
	/** @type {{Id: string, Data: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Iframe.js(668): fireMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Iframe.js(669): fireMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Iframe.js(670): fireMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "Iframe.js(671): fireMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "Iframe.js(672): fireMessage"); };
	mParams = {
		"Id": sId,
		"Data": sData
	};
	
	
	this["fireSemanticEvent"]("Iframe", "Message", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireMessage"] = 0; };

UCF_Iframe.prototype["aPublicMethods"] = ["lock","unlock"].concat(UCF_Iframe.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Image"] = function() {/* global _assert, _trace, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_ImageUtil */
/// <reference path="../core/ImageUtil.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ImageDragDelegate */
/// <reference path="./delegates/ImageDragDelegate.js"/>
/* global UCF_ImageDropDelegate */
/// <reference path="./delegates/ImageDropDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Image(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Image["_"]["UCF_Image"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Image.js(36): UCF_Image"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef !== null, "oDomRef !== null", "Image.js(37): UCF_Image"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Image.js(38): UCF_Image"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["initializeHandle"](oDomRef);

	//same expression in renderer
	this["bAdjustImageSize"] = this["bAdjustImageSize"]
		&& this["sVisibility"] !== "NONE"
		&& (this["sWidth"] || this["sHeight"]);
	this["setClientProperty"]("AdjustImageSize", this["bAdjustImageSize"], true);
	this["bIsSVGTag"] = this["oDomRef"]["tagName"]["toUpperCase"]() === "SVG";
	//same expression in renderer
	this["bCanLayoutChange"] = this["bAdjustImageSize"]
		|| !this["sWidth"]
		|| !this["sHeight"]
		|| this["sWidth"]["indexOf"]("%") !== -1
		|| this["sHeight"]["indexOf"]("%") !== -1;

	this["bImageSizeAdjusted"] = false;
	this["bLayoutChangeProcessed"] = false;
	this["iInitialImgWidth"] = null;
	this["iInitialImgHeight"] = null;
	//next code is needed for the ITS image
	if (this["bItsMode"]) {
		this["bItsModeStretch"] = this["bItsMode"] && (this["sItsDisplayMode"] === "STRETCH" || this["sItsDisplayMode"] === "FIT" || this["sItsDisplayMode"] === "FITCENTER" || this["sItsDisplayMode"] === "FILL");
		this["bItsModeNormal"] = this["bItsMode"] && (this["sItsDisplayMode"] === "NORMAL" || this["sItsDisplayMode"] === "NORMALCENTER");
		this["oItsImgRef"] = null;
		if (this["bItsModeStretch"]) {
			this["oItsImgRef"] = UCF_DomUtil["$"](this["sId"] + "-r") || UCF_DomUtil["$"](this["sId"] + "-rITS");
			if (this["oItsImgRef"] && window["UCF_System"]["sDevice"] === "standards" && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]() || UCF_UserAgent["bIsGecko"]())) {
				// Decouple-height-trick for IE11 when Image in ITS-mode is contained inside RasterLayoutItem which has the height defined and image has 100%
				// Otherwise IE will push the Image outside the scroll-container div
				this["oItsImgRef"]["style"]["position"] = "relative"; // div
				UCF_DomUtil["oGetFirstChild"](this["oItsImgRef"])["style"]["position"] = "absolute"; // table
			}
		}
		if (this["bItsModeNormal"]) {
			this["oItsImgRef"] = UCF_DomUtil["$"](this["sId"] + "-r") || UCF_DomUtil["$"](this["sId"] + "-rITS");
			this["oImgDomRef"] = UCF_DomUtil["$"](this["sId"]);
			if (this["oItsImgRef"] && this["oImgDomRef"] && window["UCF_System"]["sDevice"] !== "standards" && UCF_UserAgent["bIsIE"]()) {
				// For IE Quirks mode and Normal Display Mode, reset the table-layout
				UCF_DomUtil["oGetFirstChild"](this["oItsImgRef"])["style"]["tableLayout"] = "auto"; // table
			}
		}
		this["iITSWidth"] = 0;
		this["iITSHeight"] = 0;
		this["sFillVAlign"] = this["sVerticalTextAlign"]["toLowerCase"]();
		this["sFillHAlign"] = this["sHorizontalTextAlign"]["toLowerCase"]();
		this["oItsAlignRef"] = UCF_DomUtil["$"](this["sId"] + "-align");
	}
	this["bIgnoreLoad"] = this["bIsSVGTag"];
};window["UCF_Image"] = UCF_Image; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Image"); UCF_Image["_"] = {UCF_Image: 0}; }; ;
UCF_Image["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Image.prototype["sClassName"] = "UCF_Image";

/**
 * Destructor
 */
UCF_Image["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["destroy"]++; }; 

	if (this["bCanLayoutChange"]) {
		UCF_JsUtil["clearDelayedCallsOfObject"](this);
		if (this["oDomRef"]) this["detachBrowserEvent"]("load", this["oDomRef"]);
		UCF_JsUtil["resetMassNotificationFilter"](UCF_Image);
	}

	if (this["oDomRef"]) this["detachBrowserEvent"]("error", this["oDomRef"]);
	this["bImageSizeAdjusted"] = false;
	this["bLayoutChangeProcessed"] = false;
	this["bCanLayoutChange"] = false;
	if (this["bItsModeStretch"] && this["oItsImgRef"] !== null) {
		this["detachBrowserEvent"]("resize", this["oItsImgRef"]);
	}
	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}
	this["bAdjustImageSize"] = null;
	this["bIsSVGTag"] = null;
	this["bIgnoreLoad"] = null;
	this["oItsImgRef"] = null;
	this["oItsAlignRef"] = null;
	this["oImgDomRef"] = null;
	this["sFillHAlign"] = null;
	this["sFillVAlign"] = null;
	this["iITSHeight"] = 0;
	this["iITSWidth"] = 0;
	this["iInitialImgHeight"] = 0;
	this["iInitialImgWidth"] = 0;
	this["bItsModeNormal"] = false;
	this["bItsModeStretch"] = false;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["destroy"] = 0; };

/**
 * Initialized the image, if automatic sizing is used
 */
UCF_Image["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["initialize"]++; }; 
	//See docu of method delayedInitialize
	UCF_JsUtil["delayedCall"](0, this, "delayedInitialize");
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["initialize"] = 0; };

/**
 * The delayed initialization
 * The initialization is made in a phase where the onload of the images are not processed though
 * the images are maybe already loaded.
 * If this is the case the "loaded" flag in the DOM element is not set and the image control needs to attach to the
 * "load" event. In the performance regression test we realized that this is performance relevant.
 * A delayed call to decouple the threads solved the problem. The DOM flag "loaded" is set if the
 * image is already loaded and the "load" event has not to be attached that often.
 *
 * This effect only occurs within applying the response of a delta request and not when a page is initially loaded
 */
UCF_Image["prototype"]["delayedInitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["delayedInitialize"]++; }; 
	// SVG images do not set always the load flag
	if (this["oDomRef"]["bLoaded"] || this["oDomRef"]["complete"] || this["bIgnoreLoad"]) {
		// If Image already has been loaded before control has been instanciated
		// trigger onload "manually" without attaching load event handler
		this["processLoad"]();
	} else {
		if (window["UCF_System"]["sDevice"] !== 'standards' || !this["oDomRef"]["complete"])
			this["attachBrowserEvent"]("load", this["oDomRef"]);
	}

	if (this["oDomRef"]["bError"] || this["oDomRef"]["getAttribute"]("berror")) {
		this["processError"]();
	} else {
		this["attachBrowserEvent"]("error", this["oDomRef"]);
	}
	if (this["bItsModeStretch"] && this["oItsImgRef"] !== null) {
		this["attachBrowserEvent"]("resize", this["oItsImgRef"]);
		this["oItsImgRef"]["style"]["overflow"] = "hidden";
	}

	if (this["bItsModeNormal"] && this["oItsImgRef"]) {
		try {
			var sOverflowImgStr = UCF_DomUtil["sGetCurrentStyle"](this["oItsImgRef"], "overflow");
			if (sOverflowImgStr === "hidden" && !(UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
				// for Chrome the overflow is not working so I have to set the values
				// for e correct calculation
				this["oDomRef"]["style"]["display"] = "none";
				var iContainerHeight = this["oItsImgRef"]["clientHeight"];
				this["oDomRef"]["style"]["display"] = "";
				this["oItsImgRef"]["style"]["height"] = iContainerHeight + "px";
			}

		} catch (oException) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, oException + " ", "Image.js(190): delayedInitialize"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["delayedInitialize"] = 0; };

UCF_Image["prototype"]["iGetInitialImgWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetInitialImgWidth"]++; }; 
	if (this["iInitialImgWidth"] === null) {
		this["iInitialImgWidth"] = this["oDomRef"]["offsetWidth"];
		if (!this["iInitialImgWidth"] && this["bIsSVGTag"]) {
			this["iInitialImgWidth"] = this["oDomRef"]["clientWidth"];
		}
	}

	return this["iInitialImgWidth"];
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetInitialImgWidth"] = 0; };

UCF_Image["prototype"]["iGetInitialImgHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetInitialImgHeight"]++; }; 
	if (this["iInitialImgHeight"] === null) {
		this["iInitialImgHeight"] = this["oDomRef"]["offsetHeight"];
		if (!this["iInitialImgHeight"] && this["bIsSVGTag"]) {
			this["iInitialImgHeight"] = this["oDomRef"]["clientHeight"];
		}
	}

	return this["iInitialImgHeight"];
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetInitialImgHeight"] = 0; };

UCF_Image["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onresize"]++; }; 

	this["adjustITSImageSize"]();

};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onresize"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Image["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(231): onclick"); };

	this["activate"](oBrowserEvent);

	if (this["bIsInteractive"]) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onclick"] = 0; };

UCF_Image["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(241): onmousedown"); };

	if (this["bIsInteractive"]) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onmousedown"] = 0; };

UCF_Image["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["ondblclick"]++; }; 
	if (this["mEvents"]["DoubleClick"]) {
		this["fireDoubleClick"](this["sId"], oBrowserEvent["_iClientX"], oBrowserEvent["_iClientY"]);
		if (this["bIsInteractive"]) oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["ondblclick"] = 0; };

UCF_Image["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(256): onlsselect"); };

	this["activate"](oBrowserEvent);
	if (this["bIsInteractive"]) oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onlsselect"] = 0; };

/**
 * Returns the DOM element that should be focussed if the controls focus method
 * is called. Please do overide if the DOM element is other than the oRootRef
 * or the oDomRef.
 *
 * @return {HTMLElement} the DOM element that should be focussed if the
 * controls focus method is called.
 */
UCF_Image["prototype"]["oGetForcedFocusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["oGetForcedFocusDomRef"]++; }; 
	return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["oGetForcedFocusDomRef"] = 0; };

UCF_Image["prototype"]["activate"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["activate"]++; }; 
	var oSourceRef = oBrowserEvent["oGetSource"]();

	if (oSourceRef["tagName"]["toLowerCase"]() === "area") {
		var sAreaId = oSourceRef["getAttribute"]("areaid");
		this["fireImageMapClick"](this["sId"], sAreaId);
	} else {
		if (!this["bIsInteractive"]) return;
		this["fireActivate"](this["sId"], oBrowserEvent["_iClientX"], oBrowserEvent["_iClientY"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["activate"] = 0; };

UCF_Image["prototype"]["onload"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onload"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(287): onload"); };

	this["processLoad"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onload"] = 0; };

UCF_Image["prototype"]["processLoad"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["processLoad"]++; }; 
	if (this["bCanLayoutChange"]) {
		this["adjustImageSize"]();
		this["processLayoutChange"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["processLoad"] = 0; };

UCF_Image["prototype"]["onerror"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onerror"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(301): onerror"); };
	this["processError"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onerror"] = 0; };

UCF_Image["prototype"]["processError"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["processError"]++; }; 

	if (this["bCanLayoutChange"] && this["sErrorImageSrc"]) {
		//try adjust with the error image
		this["adjustImageSize"]();
		this["processLayoutChange"]();
	} else {

		this["oDomRef"]["style"]["height"] = this["sHeight"];
		this["oDomRef"]["style"]["width"] = this["sWidth"];

		this["show"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["processError"] = 0; };

/**
 * In some cases the dimension of the image is not known before it is loaded. In this case the browser shows an
 * loading icon in a standard size while the screen is already calculated and visualized.
 * After the image is loaded the actual image dimensions are known, the image is correctly displayed and the
 * browser adapts the whole screen.
 * Some controls calculate their visualization depended on a UI state of a specific point in time. They need
 * to be notified when there are changes in the Layout so that they check their current visualization and
 * update it when necessary  (e.g. their position).
 *
 * This method is called to notify the framework about an potentional layout change
 * The method is centralized for all images loading. This means that only the last image loaded
 * should trigger the notification.
 *
 */
UCF_Image["prototype"]["processLayoutChange"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["processLayoutChange"]++; }; 

	if (this["bCanLayoutChange"] && !this["bLayoutChangeProcessed"]) {
		UCF_JsUtil["feedMassNotificationFilter"](1000, UCF_Image, this, "notifyLayoutChange");
	}
	this["bLayoutChangeProcessed"] = true;
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["processLayoutChange"] = 0; };

/**
 *  Adjust the ITS Image height/width
 *  	//Contract: %, em, ex width or height is not allowed to be used for adjust image mode
 */
UCF_Image["prototype"]["adjustITSImageSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["adjustITSImageSize"]++; }; 
	var dFactorHeight;
	var dFactorWidth;
	var iCurrentWidth;
	var iCurrentHeight;

	if (this["bItsModeStretch"] && this["oItsImgRef"] !== null) {
		var bApplyWidth = this["iITSHeight"] !== this["oItsImgRef"]["clientHeight"] ||
			this["iITSWidth"] !== this["oItsImgRef"]["clientWidth"];

		if (bApplyWidth) {
			this["iITSHeight"] = this["oItsImgRef"]["clientHeight"];
			this["iITSWidth"] = this["oItsImgRef"]["clientWidth"];
			if (this["sItsDisplayMode"] === "STRETCH") {
				var sStyleHeight = this["oDomRef"]["style"]["height"];
				if (sStyleHeight === "100%" && UCF_UserAgent["bIsWebKit"]()) {
					this["oDomRef"]["style"]["display"] = "none";
				}
				if (this["oItsImgRef"]["clientHeight"] !== this["oDomRef"]["clientHeight"] || sStyleHeight === "100%") {
					this["oDomRef"]["style"]["height"] = this["oItsImgRef"]["clientHeight"] + "px";
				}
				if (sStyleHeight === "100%" && UCF_UserAgent["bIsWebKit"]()) {
					this["oDomRef"]["style"]["display"] = "";
				}
			} else if (this["sItsDisplayMode"] === "FILL") {
				/*	o	Image aspect ratio is not changed
					o	Image is resized until the container is fully covered
					o	If image is larger than the container, the overlapping parts are simple cut off (no scrollbars)
					o	Algorithm:
					o	Calculate resize factor f = max( cx / ix, cy / iy )
					o	Multiply ix with f and iy
				 */
				/*	if ( !this.bIsSVGTag && !(UCF_UserAgent.bIsIE() || UCF_UserAgent.bIsMSEdge())) {
						// for Chrome the overflow is not working so I have to set the values
						// for e correct calculation
						this.oDomRef.style.display = "none";
						this.oItsImgRef.style.height = "100%";
					} */

				if (!this["bIsSVGTag"]) {
					dFactorHeight = this["oItsImgRef"]["clientHeight"] / this["iGetInitialImgHeight"]();
					dFactorWidth = this["oItsImgRef"]["clientWidth"] / this["iGetInitialImgWidth"]();
					var dFactorMax = Math["max"](dFactorHeight, dFactorWidth);
					var iContainerHeight = this["oItsImgRef"]["clientHeight"];
					iCurrentWidth = Math["round"](this["iGetInitialImgWidth"]() * dFactorMax);
					iCurrentHeight = Math["round"](this["iGetInitialImgHeight"]() * dFactorMax);
				} else {
					iCurrentWidth = Math["max"](this["oItsImgRef"]["clientWidth"], this["oItsImgRef"]["clientHeight"]);
					iCurrentHeight = iCurrentWidth;
				}

				//_trace(INFO, "== Image - " + this.sId + "; display: " + this.sItsDisplayMode + " - dFactorMax -  " + dFactorMax);

				this["oDomRef"]["style"]["height"] = iCurrentHeight + "px";
				this["oDomRef"]["style"]["width"] = iCurrentWidth + "px";
				if (!(UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
					// for Chrome the overflow is not working so I have to set the values
					// for e correct calculation
					this["oDomRef"]["style"]["display"] = "";
					this["oItsImgRef"]["style"]["height"] = iContainerHeight + "px";
				}
				//Set the Align for the image

				this["oDomRef"]["style"]["top"] = "0";
				this["oDomRef"]["style"]["left"] = "0";
				if (this["sFillVAlign"] !== "" && this["sFillVAlign"] !== "top") {
					if (iCurrentHeight > this["oItsImgRef"]["clientHeight"]) {
						var iTopPosition = 0;
						if (this["sFillVAlign"] === "middle") {
							iTopPosition = Math["round"]((iCurrentHeight - this["oItsImgRef"]["clientHeight"]) / 2);
						} else if (this["sFillVAlign"] === "bottom") {
							iTopPosition = Math["round"](iCurrentHeight - this["oItsImgRef"]["clientHeight"]);
						}
						//_trace(INFO, "== Image - " + this.sId + "- image - iTopPosition:" + iTopPosition );
						if (iTopPosition !== 0) {
							this["oDomRef"]["style"]["top"] = -iTopPosition + "px";
						}
					}
				}
				if (this["sFillHAlign"] !== "" && this["sFillHAlign"] !== "left") {
					if (iCurrentWidth > this["oItsImgRef"]["clientWidth"]) {
						var iLeftPosition = 0;
						if (this["sFillHAlign"] === "center") {
							iLeftPosition = Math["round"]((iCurrentWidth - this["oItsImgRef"]["clientWidth"]) / 2);
						} else if (this["sFillHAlign"] === "right") {
							iLeftPosition = Math["round"](iCurrentWidth - this["oItsImgRef"]["clientWidth"]);
						}
						//_trace(INFO, "== Image - " + this.sId + "- image - iLeftPosition:" + iLeftPosition );
						if (iLeftPosition !== 0) {
							this["oDomRef"]["style"]["left"] = -iLeftPosition + "px";
						}
					}
				}
			} else {
				/*
					o	Image aspect ratio is not changed
					o	Image is resized until the full image is visible with its maximum size
					o	Algorithm:
					o	Calculate resize factor f = min( cx / ix, cy / iy )
					o	Multiply ix with f and iy
				 */
				if (!this["bIsSVGTag"]) {
					dFactorHeight = this["oItsImgRef"]["clientHeight"] / this["iGetInitialImgHeight"]();
					dFactorWidth = this["oItsImgRef"]["clientWidth"] / this["iGetInitialImgWidth"]();
					var dFactorMin = Math["min"](dFactorHeight, dFactorWidth);

					this["oDomRef"]["style"]["height"] = Math["round"](this["iGetInitialImgHeight"]() * dFactorMin) + "px";
					this["oDomRef"]["style"]["width"] = Math["round"](this["iGetInitialImgWidth"]() * dFactorMin) + "px";
				} else {
					iCurrentWidth = Math["min"](this["oItsImgRef"]["offsetWidth"], this["oItsImgRef"]["offsetHeight"]);
					iCurrentHeight = iCurrentWidth;
					this["oDomRef"]["style"]["height"] = iCurrentHeight + "px";
					this["oDomRef"]["style"]["width"] = iCurrentWidth + "px";
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["adjustITSImageSize"] = 0; };

UCF_Image["prototype"]["adjustImageSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["adjustImageSize"]++; }; 
	//Contract: %, em, ex width or height is not allowed to be used for adjust image mode

	this["adjustITSImageSize"]();

	if (!this["bAdjustImageSize"] || this["bImageSizeAdjusted"]) return;

	this["bImageSizeAdjusted"] = true;

	if (!this["bCanLayoutChange"] || this["bIsSVGTag"]) return;

	var iTargetWidth = parseInt(this["sWidth"]),
		iTargetHeight = parseInt(this["sHeight"]);

	if (isNaN(iTargetWidth) || iTargetWidth < 0) iTargetWidth = 0;
	if (isNaN(iTargetHeight) || iTargetHeight < 0) iTargetHeight = 0;

	//If one of these values is not defined, then the renderer
	//sets the other on the image and the browser calculates
	//the missing value proportionally

	if (iTargetWidth > 0 && iTargetHeight > 0) {
		var iPropHeight = iTargetHeight;

		if (this["oDomRef"]["offsetHeight"] && this["oDomRef"]["offsetWidth"]) { // if DOM element has a valid values
			iPropHeight = this["iGetProportionalSize"](iTargetWidth, this["oDomRef"]["offsetWidth"], this["oDomRef"]["offsetHeight"]);
		}

		//TargetWidth and TargetHeight have a defined value. In this scenario we assume
		//that the larger dimension is the one to be kept.
		//We leave calculation of the second proportional value to
		//the browser
		if (iPropHeight >= iTargetHeight) {
			this["oDomRef"]["style"]["height"] = iTargetHeight + "px";
		} else {
			this["oDomRef"]["style"]["width"] = iTargetWidth + "px";
		}
	}

	this["show"]();
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["adjustImageSize"] = 0; };

/**
 * Returns the proportional size dependend on the actual and maximal related size
 *
 * @param {int} iActSize
 * @param {int} iRelatedSize
 * @param {int} iRelatedMax
 * @return {integer}
 */
UCF_Image["prototype"]["iGetProportionalSize"] = function(iActSize, iRelatedSize, iRelatedMax) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetProportionalSize"]++; }; 
	return Math["floor"](iActSize * (iRelatedMax / iRelatedSize));
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetProportionalSize"] = 0; };

/**
 * Make the image visible
 */
UCF_Image["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["show"]++; }; 
	if (this["sVisibility"] === "VISIBLE") {
		this["oDomRef"]["style"]["visibility"] = "visible";
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsControl--hidden');
	}
	if (this["bItsMode"]) {
		this["oRootRef"]["style"]["height"] = "100%";
		this["oRootRef"]["style"]["width"] = "100%";
	} else {
		this["oRootRef"]["style"]["height"] = "auto";
		this["oRootRef"]["style"]["width"] = "auto";
	}
	this["oRootRef"]["style"]["display"] = "block";

};;if (__UCF_COVERAGE__) { UCF_Image["_"]["show"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_Image["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(544): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setControlType"]("IMG");

	oAccessibilityHelper["setEnabled"](this["bEnabled"]);

	if (!this["bIsDectorative"] && this["sSrc"] === '' && this["sTooltip"] === '' && !this["bIsNested"] && !this["bHasImageMap"]) {
		//image is in tabchain which have no tooltip and src should be read as 'image not available'
		oAccessibilityHelper["setTooltip"](oAccessibilityHelper["sGetText"]("EMPTY_IMG"));
	} else {
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	}

	//Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this, "", this["sLabelText"]);

	oAccessibilityHelper["addEnabledTutor"]("B_TUT", this["bEnabled"] && this["bIsInteractive"]);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onlsaccessibility"] = 0; };

/**
 * implements method from UCF_Control
 */
UCF_Image["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["createDragDelegate"]++; }; 

	if (!this["sDragSourceInfo"])
		return;

	if (this["oDragDelegate"])
		return;

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_ImageDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["createDragDelegate"] = 0; };

/**
 * implements method from UCF_Control
 */
UCF_Image["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["createDropDelegate"]++; }; 

	if (!this["sDropTargetInfo"])
		return;

	if (this["oDropDelegate"])
		return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_ImageDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_Image["_"]["createDropDelegate"] = 0; };

/**
 * Activates native browser dragging by setting draggable attribute
 *
 * @private
 */
UCF_Image["prototype"]["setDraggable"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["setDraggable"]++; }; 
	if (this["sDragSourceInfo"]) {
		var oDragSourceInfo = this["oLS"]["oControlFactory"]["oGetControlById"](this["sDragSourceInfo"]);
		if (oDragSourceInfo) {
			if (oDragSourceInfo["bBrowserDragDrop"]) {
				this["bDraggable"] = true;
				this["oRootRef"]["setAttribute"]("draggable", true);
				this["oRootRef"]["setAttribute"]("iDDThreshold", 10000);
				this["oRootRef"]["ondragstart"] = null;
			} else {
				//explicitly set draggable to false to avoid native browser drag/drop if it isn't set in dragSourceInfo
				this["oRootRef"]["setAttribute"]("draggable", false);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["setDraggable"] = 0; };

/**
 * Returns the image source
 *
 * @return {string}
 * @private
 */
UCF_Image["prototype"]["sGetImageSource"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["sGetImageSource"]++; }; 
	return UCF_ImageUtil["sGetImageSource"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["sGetImageSource"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_Image["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;
	/** @type {Node} */
	var oParent;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			this["oDomRef"]["setAttribute"]('role', 'gridcell');
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
			oParent = this["oDomRef"]["parentNode"];
			UCF_Control["addAriaGeneric"](oParent, oSapTableInfo);
			if (this["oDomRef"]["getAttribute"]("aria-labelledby"))
				oParent["setAttribute"]("aria-labelledby", this["oDomRef"]["getAttribute"]("aria-labelledby"));
			oParent["setAttribute"]('role', 'presentation');
		}
	}
	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["bPrepareAria"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Image["prototype"]["aAttributeNames"] = ["sTooltip","sWidth","sHeight","sSrc","bIsInteractive","bHasImageMap","sVisibility","bIsNested","sLabelText","bAdjustImageSize","sDragSourceInfo","bIsDragHandle","bEnabled","sErrorImageSrc","sCustomData","bItsMode","sItsDisplayMode","sCustomStyle","sDropTargetInfo","sVerticalTextAlign","sHorizontalTextAlign","bUsedInSapTable","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Image["prototype"]["aEventNames"] = ["Activate","ImageMapClick","Drag","Drop","DoubleClick"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Image["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sSrc"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bIsInteractive"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bHasImageMap"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Image["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bIsNested"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sLabelText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bAdjustImageSize"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bIsDragHandle"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sErrorImageSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bItsMode"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ImageItsDisplayMode}
 */
UCF_Image["prototype"]["sItsDisplayMode"] = "NORMAL";

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.VerticalTextAlign}
 */
UCF_Image["prototype"]["sVerticalTextAlign"] = "MIDDLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HorizontalTextAlign}
 */
UCF_Image["prototype"]["sHorizontalTextAlign"] = "CENTER";

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bUsedInSapTable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Image["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sWidth"] = '';
	this["sHeight"] = '';
	this["sSrc"] = '';
	this["bIsInteractive"] = false;
	this["bHasImageMap"] = false;
	this["sVisibility"] = "VISIBLE";
	this["bIsNested"] = false;
	this["sLabelText"] = '';
	this["bAdjustImageSize"] = false;
	this["sDragSourceInfo"] = '';
	this["bIsDragHandle"] = false;
	this["bEnabled"] = true;
	this["sErrorImageSrc"] = '';
	this["sCustomData"] = '';
	this["bItsMode"] = false;
	this["sItsDisplayMode"] = "NORMAL";
	this["sCustomStyle"] = '';
	this["sDropTargetInfo"] = '';
	this["sVerticalTextAlign"] = "MIDDLE";
	this["sHorizontalTextAlign"] = "CENTER";
	this["bUsedInSapTable"] = false;
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("Src", '', true);
		this["setClientProperty"]("IsInteractive", false, true);
		this["setClientProperty"]("HasImageMap", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("IsNested", false, true);
		this["setClientProperty"]("LabelText", '', true);
		this["setClientProperty"]("AdjustImageSize", false, true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("IsDragHandle", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("ErrorImageSrc", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("ItsMode", false, true);
		this["setClientProperty"]("ItsDisplayMode", "NORMAL", true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("VerticalTextAlign", "MIDDLE", true);
		this["setClientProperty"]("HorizontalTextAlign", "CENTER", true);
		this["setClientProperty"]("UsedInSapTable", false, true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the Image
 * @param {number} iPositionX Horizontal offset of the click inside the image
 * @param {number} iPositionY Vertical offset of the click inside the image
 * @fires Image::Activate
 */
UCF_Image["prototype"]["fireActivate"] = function(sId, iPositionX, iPositionY) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireActivate"]++; }; 
	/** @type {{Id: string, PositionX: number, PositionY: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Image.js(884): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Image.js(885): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Image.js(886): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionX != null, "iPositionX != null", "Image.js(887): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionX) == "number", "typeof(iPositionX) == \"number\"", "Image.js(888): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionY != null, "iPositionY != null", "Image.js(889): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionY) == "number", "typeof(iPositionY) == \"number\"", "Image.js(890): fireActivate"); };
	mParams = {
		"Id": sId,
		"PositionX": iPositionX,
		"PositionY": iPositionY
	};
	
	
	
	this["fireSemanticEvent"]("Image", "Activate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireActivate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Image
 * @param {string} sAreaId Identifier of the clicked area
 * @fires Image::ImageMapClick
 */
UCF_Image["prototype"]["fireImageMapClick"] = function(sId, sAreaId) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireImageMapClick"]++; }; 
	/** @type {{Id: string, AreaId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Image.js(912): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Image.js(913): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Image.js(914): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAreaId != null, "sAreaId != null", "Image.js(915): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAreaId) == "string", "typeof(sAreaId) == \"string\"", "Image.js(916): fireImageMapClick"); };
	mParams = {
		"Id": sId,
		"AreaId": sAreaId
	};
	
	
	this["fireSemanticEvent"]("Image", "ImageMapClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireImageMapClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires Image::Drag
 */
UCF_Image["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Image.js(937): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Image.js(938): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Image.js(939): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "Image.js(940): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "Image.js(941): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "Image.js(942): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "Image.js(943): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("Image", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSourceId Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires Image::Drop
 */
UCF_Image["prototype"]["fireDrop"] = function(sId, sDragSourceId, sDropTargetInfo, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSourceId: string, DropTargetInfo: string, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 10, "arguments.length == 10", "Image.js(973): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Image.js(974): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Image.js(975): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceId != null, "sDragSourceId != null", "Image.js(976): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceId) == "string", "typeof(sDragSourceId) == \"string\"", "Image.js(977): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "Image.js(978): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "Image.js(979): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "Image.js(980): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "Image.js(981): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "Image.js(982): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "Image.js(983): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "Image.js(984): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "Image.js(985): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "Image.js(986): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "Image.js(987): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "Image.js(988): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "Image.js(989): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "Image.js(990): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "Image.js(991): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "Image.js(992): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "Image.js(993): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSourceId": sDragSourceId,
		"DropTargetInfo": sDropTargetInfo,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("Image", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Image control.
 * @param {number} iPositionX Horizontal offset of the double click inside the image
 * @param {number} iPositionY Vertical offset of the double click inside the image
 * @fires Image::DoubleClick
 */
UCF_Image["prototype"]["fireDoubleClick"] = function(sId, iPositionX, iPositionY) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string, PositionX: number, PositionY: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Image.js(1030): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Image.js(1031): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Image.js(1032): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionX != null, "iPositionX != null", "Image.js(1033): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionX) == "number", "typeof(iPositionX) == \"number\"", "Image.js(1034): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionY != null, "iPositionY != null", "Image.js(1035): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionY) == "number", "typeof(iPositionY) == \"number\"", "Image.js(1036): fireDoubleClick"); };
	mParams = {
		"Id": sId,
		"PositionX": iPositionX,
		"PositionY": iPositionY
	};
	
	
	
	this["fireSemanticEvent"]("Image", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDoubleClick"] = 0; };

};
sap["ls"]["preload"]["UCF_ImageDragDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_ImageDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_ImageDragDelegate["_"]["UCF_ImageDragDelegate"]++; }; 

	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);

};window["UCF_ImageDragDelegate"] = UCF_ImageDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ImageDragDelegate"); UCF_ImageDragDelegate["_"] = {UCF_ImageDragDelegate: 0}; }; ;

UCF_ImageDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_ImageDragDelegate.prototype["sClassName"] = "UCF_ImageDragDelegate";

/**
 * Handler for the native drag start event which initializes the drag session
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_ImageDragDelegate["prototype"]["ondragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ImageDragDelegate["_"]["ondragstart"]++; }; 

	if (UCF_UserAgent["bIsGecko"]()) {
		// FF raises native dragstart event even if draggable is set to false in
		// DOM and dragstart is set to return false in DOM
		// therefore it is neccessary to check in dragstart handler of
		// the delegate which only exists if there is a dragsourceinfo attached
		// wether the dragstart event is wanted (browserDragDrop = true) or
		// not (browserDragDrop = false)
		// if not wanted the return statement avoids running into
		// the super method because lsdragstart handler should take action
		var sDragSourceInfoId = this["oGetDragSourceInfoId"](oBrowserEvent),
			oDragSourceInfo, oDragAndDropManager;

		if (sDragSourceInfoId) {
			oDragSourceInfo = this["oLS"]["oControlFactory"]["oGetControlById"](sDragSourceInfoId);

			if (oDragSourceInfo) {
				if (!oDragSourceInfo["bBrowserDragDrop"]) {
					oDragAndDropManager = oDragSourceInfo["oLS"]["oBrowserWindow"]["oDragAndDropManager"];

					oDragAndDropManager["bBrowserDragDrop"] = false;

					return;
				}
			}
		}
	}
	UCF_DragDelegate.prototype["ondragstart"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ImageDragDelegate["_"]["ondragstart"] = 0; };

UCF_ImageDragDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ImageDragDelegate["_"]["onlsdragstart"]++; }; 
	if (UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsIE"]()
		|| UCF_UserAgent["bIsMSEdge"]()) {
		// Firefox sends mousemove events when scrolling in ITS mode
		// avoid starting a dragSession when moving the scrollHandle
		if (oBrowserEvent["oSource"]
			&& UCF_DomUtil["bHasClass"](oBrowserEvent["oSource"], 'lsImgItsScrl')) {

			return;
		}
	}
	UCF_DragDelegate.prototype["onlsdragstart"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ImageDragDelegate["_"]["onlsdragstart"] = 0; };

};
sap["ls"]["preload"]["UCF_ImageDropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_BoxDecorator */
/// <reference path="./BoxDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_Image} oImage
 * @param {UCF_LS} oLS
 */
function UCF_ImageDropDecorator(oImage, oLS) {if (__UCF_COVERAGE__) { UCF_ImageDropDecorator["_"]["UCF_ImageDropDecorator"]++; }; 

	UCF_BoxDecorator["apply"](this, [oImage]);
	this["oLS"] = oLS;
};window["UCF_ImageDropDecorator"] = UCF_ImageDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ImageDropDecorator"); UCF_ImageDropDecorator["_"] = {UCF_ImageDropDecorator: 0}; }; ;

/**
 *
 */
UCF_ImageDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_BoxDecorator"))(); UCF_ImageDropDecorator.prototype["sClassName"] = "UCF_ImageDropDecorator";

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ImageDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ImageDropDecorator["_"]["update"]++; }; 
	var oImageRect = UCF_DomUtil["oGetObjectRect"](this["oControl"]["oRootRef"]);

	this["setBounds"](oImageRect["left"], oImageRect["top"], oImageRect["height"], oImageRect["width"]);
	this["show"]();
};;if (__UCF_COVERAGE__) { UCF_ImageDropDecorator["_"]["update"] = 0; };

/**
 * Returns the drop location on which image the drop appeared
 * @type Object
 * @return Object containing sItemId or the menu item and the iOffset on the item.
 */

UCF_ImageDropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_ImageDropDecorator["_"]["oGetDropLocation"]++; }; 
	return { "sItemId": this["sId"] + "-draghandle", "iOffset": this["iOffset"] };

};;if (__UCF_COVERAGE__) { UCF_ImageDropDecorator["_"]["oGetDropLocation"] = 0; };

/**
 * destructor
 */
UCF_ImageDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ImageDropDecorator["_"]["destroy"]++; }; 
	this["oLS"] = null;

	UCF_BoxDecorator.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ImageDropDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_ImageDropDelegate"] = function() {/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_ImageDropDecorator */
/// <reference path="../decorators/ImageDropDecorator.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_ImageDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_ImageDropDelegate["_"]["UCF_ImageDropDelegate"]++; }; 

	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);
	this["iCurrentStep"] = 0;
	this["oLS"] = oLS;

};window["UCF_ImageDropDelegate"] = UCF_ImageDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ImageDropDelegate"); UCF_ImageDropDelegate["_"] = {UCF_ImageDropDelegate: 0}; }; ;
UCF_ImageDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_ImageDropDelegate.prototype["sClassName"] = "UCF_ImageDropDelegate";

/**
 * @override
 */
UCF_ImageDropDelegate["prototype"]["oCreateDropDecorator"] = function() {;if (__UCF_COVERAGE__) { UCF_ImageDropDelegate["_"]["oCreateDropDecorator"]++; }; 

	return new (UCF_ClassLoader["oGetClass"]("UCF_ImageDropDecorator"))(this["oDropTargetControl"], this["oLS"]);
};;if (__UCF_COVERAGE__) { UCF_ImageDropDelegate["_"]["oCreateDropDecorator"] = 0; };

/**
 *
 */

UCF_ImageDropDelegate["prototype"]["oGetDropLocation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ImageDropDelegate["_"]["oGetDropLocation"]++; }; 

	return this["oDropDecorator"]["oGetDropLocation"]();
};;if (__UCF_COVERAGE__) { UCF_ImageDropDelegate["_"]["oGetDropLocation"] = 0; };

/**
 *
 */

UCF_ImageDropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_ImageDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function(sDragData, sMimeType) {

		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);
	};

};;if (__UCF_COVERAGE__) { UCF_ImageDropDelegate["_"]["fGetDropCallBack"] = 0; };

};
sap["ls"]["preload"]["UCF_ImageMap"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ImageMap(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ImageMap["_"]["UCF_ImageMap"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ImageMap.js(18): UCF_ImageMap"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ImageMap.js(19): UCF_ImageMap"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ImageMap.js(20): UCF_ImageMap"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_ImageMap"] = UCF_ImageMap; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ImageMap"); UCF_ImageMap["_"] = {UCF_ImageMap: 0}; }; ;
UCF_ImageMap["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ImageMap.prototype["sClassName"] = "UCF_ImageMap";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ImageMap["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ImageMap["prototype"]["aEventNames"] = ["ImageMapClick"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ImageMap["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ImageMap["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ImageMap["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ImageMap["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ImageMap["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the Image Map.
 * @param {string} sAreaId Identifier of the clicked area.
 * @fires ImageMap::ImageMapClick
 */
UCF_ImageMap["prototype"]["fireImageMapClick"] = function(sId, sAreaId) {;if (__UCF_COVERAGE__) { UCF_ImageMap["_"]["fireImageMapClick"]++; }; 
	/** @type {{Id: string, AreaId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ImageMap.js(77): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ImageMap.js(78): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ImageMap.js(79): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAreaId != null, "sAreaId != null", "ImageMap.js(80): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAreaId) == "string", "typeof(sAreaId) == \"string\"", "ImageMap.js(81): fireImageMapClick"); };
	mParams = {
		"Id": sId,
		"AreaId": sAreaId
	};
	
	if (sAreaId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sAreaId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "AreaId");
			}
		}
	this["fireSemanticEvent"]("ImageMap", "ImageMapClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ImageMap["_"]["fireImageMapClick"] = 0; };

};
sap["ls"]["preload"]["UCF_ImageMapArea"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * ImageMapArea
 *
 * 
 * @class
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ImageMapArea(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ImageMapArea["_"]["UCF_ImageMapArea"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ImageMapArea.js(25): UCF_ImageMapArea"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ImageMapArea.js(26): UCF_ImageMapArea"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ImageMapArea.js(27): UCF_ImageMapArea"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_ImageMapArea"] = UCF_ImageMapArea; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ImageMapArea"); UCF_ImageMapArea["_"] = {UCF_ImageMapArea: 0}; }; ;
UCF_ImageMapArea["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ImageMapArea.prototype["sClassName"] = "UCF_ImageMapArea";

/**
 * Handles the onmouseup event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ImageMapArea["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ImageMapArea["_"]["onmouseup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ImageMapArea.js(41): onmouseup"); };

	// IE has a bug in standards mode so that the area receives an mousedown and mouseup but not the onclick
	// The onclick is fired on the underlying image.
	if ((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && window["UCF_System"]["sDevice"] === "standards") {
		this["fireImageMapClick"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ImageMapArea["_"]["onmouseup"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ImageMapArea["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ImageMapArea["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ImageMapArea.js(58): onclick"); };
	// IE has a bug in standards mode so that the area receives an mousedown and mouseup but not the onclick
	// The onclick is fired on the underlying image.
	if (!((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && window["UCF_System"]["sDevice"] === "standards")) {
		this["fireImageMapClick"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ImageMapArea["_"]["onclick"] = 0; };

/**
 * Handles the touch event on an iPad
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ImageMapArea["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ImageMapArea["_"]["onlstouchend"]++; }; 
	this["onclick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ImageMapArea["_"]["onlstouchend"] = 0; };

/**
 * Fires the image map click on the parent control
 */
UCF_ImageMapArea["prototype"]["fireImageMapClick"] = function() {;if (__UCF_COVERAGE__) { UCF_ImageMapArea["_"]["fireImageMapClick"]++; }; 
	var oParent = this["oGetParent"]();
	oParent["fireImageMapClick"](oParent["sId"], this["sId"]);
};;if (__UCF_COVERAGE__) { UCF_ImageMapArea["_"]["fireImageMapClick"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ImageMapArea["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ImageMapArea["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ImageMapArea["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ImageMapArea["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ImageMapArea["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ImageMapArea["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ImageMapArea["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_InplaceEdit"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Animation */
/// <reference path="../anim/Animation.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_InplaceEdit(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["UCF_InplaceEdit"]++; }; 

	if (arguments["length"] !== 2)
		return;

	this["oLS"] = oLS;
	this["oDomRef"] = oDomRef;
	this["bOpened"] = false;

	UCF_Control["apply"](this, [this["oDomRef"], oLS]);

	this["bIsDirty"] = false;
	this["bAllowTextSelection"] = true;
	this["bAlignRight"] = false;
};window["UCF_InplaceEdit"] = UCF_InplaceEdit; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_InplaceEdit"); UCF_InplaceEdit["_"] = {UCF_InplaceEdit: 0}; }; ;

UCF_InplaceEdit["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_InplaceEdit.prototype["sClassName"] = "UCF_InplaceEdit";

UCF_InplaceEdit["STYLES"] = ['fontSize', 'fontColor', 'fontWeight', 'fontFamily'];

/**
 * Open the overlay input field
 * @public
 */

UCF_InplaceEdit["prototype"]["open"] = function(oReferenceDomRef, oBoundaries, sText) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["open"]++; }; 

	if (this["bOpened"])
		return;

	UCF_JsUtil["delayedCall"](1, this, 'addAnyEventListener', []);

	var oDomRefStyle = this["oDomRef"]["style"];

	this["oBoundaries"] = oBoundaries;
	if (!this["oBoundaries"]["maxwidth"]) {
		this["oBoundaries"]["maxwidth"] = UCF_DomUtil["iClientWidth"]();
	}

	for (var x = 0; x < UCF_InplaceEdit["STYLES"]["length"]; x++)
		oDomRefStyle[UCF_InplaceEdit["STYLES"][x]] = UCF_DomUtil["sGetCurrentStyle"](oReferenceDomRef, UCF_InplaceEdit["STYLES"][x]);

	this["sText"] = sText;
	this["bIsDirty"] = false;
	this["oDomRef"]["setAttribute"]('value', sText);

	this["iMinimalWidth"] = null;
	var iCurrentWidth = this["iGetOptimalWidthFor"](this["oDomRef"]);

	oDomRefStyle["width"] = Math["min"](iCurrentWidth - 3, this["oBoundaries"]["maxwidth"]) + 'px';
	// oDomRefStyle.height = oBoundaries.height + 'px';

	this["iMinimalWidth"] = iCurrentWidth;

	if (window["UCF_System"]["bUseAnimation"]) {

		UCF_DomUtil["setOpacityStyle"](this["oDomRef"], 0);

		var oAnimation = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(this["oDomRef"], 100);

		if ((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
			oAnimation["addOpacityChange"](0, 100, oAnimation["M_TRANSITIONS"]["EaseIn"]);
		} else {
			oAnimation["addFinalOpacityValue"](100);
			oAnimation["addInitialOpacityValue"](100);
		}
		oAnimation["play"]();
	}

	oDomRefStyle["display"] = 'block';
	this["relocate"]();

	UCF_DomUtil["moveFocusDomElement"](this["oDomRef"]);
	if (UCF_UserAgent["bIsFirefox"]()) {
		UCF_DomUtil["setSelection"](
			this["oDomRef"],
			this["oDomRef"]["selectionStart"] || 0,
			this["oDomRef"]["selectionEnd"] || this["oDomRef"]["value"]["length"]
		);
	} else {
		this["oDomRef"]["select"]();
	}
	this["oDomRef"]["focus"]();
	this["bOpened"] = true;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Move Focus on  ' + this["oDomRef"]["id"], "InplaceEdit.js(108): open"); };
	// debugger;

};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["open"] = 0; };

UCF_InplaceEdit["prototype"]["addAnyEventListener"] = function() {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["addAnyEventListener"]++; }; 

	var oWindow = this["oLS"]["oBrowserWindow"];

	oWindow["attachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
	oWindow["attachEvent"](oWindow["E_EVENTS"]["IsolatedAreaEvent"], this, 'onIsolatedAreaEvent');

};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["addAnyEventListener"] = 0; };

UCF_InplaceEdit["create"] = function(oLS, sId) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["create"]++; }; 

	var oInputDomRef = UCF_DomUtil["$"](sId);

	if (oInputDomRef) {
		return oInputDomRef;
	}
	oInputDomRef = document["createElement"]('INPUT');
	oInputDomRef["setAttribute"]('id', sId);
	oInputDomRef["setAttribute"]('ct', 'INPL');
	oInputDomRef["setAttribute"]('type', 'text');
	UCF_DomUtil["setClass"](oInputDomRef, 'lsInplaceEdit');
	var oStyle = oInputDomRef["style"];

	oStyle["zIndex"] = 99999;

	oLS["oGetRootRef"]()["appendChild"](oInputDomRef);

	UCF_InplaceEdit["sCurrentId"] = sId;

	return oInputDomRef;
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["create"] = 0; };

/**
 * Returns whether the value was edited by the user
 * @private
 */

UCF_InplaceEdit["prototype"]["bValueEdited"] = function() {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["bValueEdited"]++; }; 
	return this["oDomRef"]["value"] !== this["sText"];
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["bValueEdited"] = 0; };

/**
 * Handler for events that are fired during a field is edited.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InplaceEdit["prototype"]["handleEditEvents"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["handleEditEvents"]++; }; 
	if (this["bValueEdited"]() && !this["bIsDirty"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Checked value for changes ' + this["oDomRef"]["value"] + ' !== ' + this["sText"] + ' -> setting dirty state now!', "InplaceEdit.js(162): handleEditEvents"); };
		this["bIsDirty"] = true;
		this["markDirty"](true);
		this["setPendingChange"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["handleEditEvents"] = 0; };

UCF_InplaceEdit["prototype"]["userFinish"] = function(bApply) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["userFinish"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bApply) === 'boolean', "typeof(bApply) === 'boolean'", "InplaceEdit.js(170): userFinish"); };

	if (!this["bOpened"])
		return;

	this["bOpened"] = false;

	if (this["oFinishedHandler"]) {
		this["oFinishedHandler"]["oObject"][this["oFinishedHandler"]["sHandlerMethod"]]["apply"](this["oFinishedHandler"]["oObject"], [this["oDomRef"]["value"], bApply]);
	}
	this["setPendingChange"](false);
	this["destroy"]();
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["userFinish"] = 0; };

UCF_InplaceEdit["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onkeydown"]++; }; 

	if (!this["bOpened"])
		return;

	var iKey = oBrowserEvent["iKeyCode"]();

	if (iKey === UCF_KeyCodes["ESCAPE"]) {
		this["userFinish"](false);
	} else if (iKey === UCF_KeyCodes["TAB"] || iKey === UCF_KeyCodes["F2"]) {
		this["userFinish"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onkeydown"] = 0; };

/**
 * Handles the keyup event and checks whether the value of the field changed to propagate the dirty state
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InplaceEdit["prototype"]["onkeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onkeyup"]++; }; 

	this["relocate"]();
	this["handleEditEvents"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onkeyup"] = 0; };

UCF_InplaceEdit["prototype"]["relocate"] = function() {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["relocate"]++; }; 
	var oDomRefStyle = this["oDomRef"]["style"],
		iWidth = this["iGetOptimalWidthFor"](this["oDomRef"]);

	if (iWidth > this["oBoundaries"]["maxwidth"]) {
		iWidth = this["oBoundaries"]["maxwidth"];
	}
	oDomRefStyle["width"] = iWidth + 'px';
	oDomRefStyle["top"] = this["oBoundaries"]["top"] - Math["round"]((this["oDomRef"]["offsetHeight"] - this["oBoundaries"]["height"]) / 2) + 'px';
	if (this["bAlignRight"]) {
		oDomRefStyle["left"] = (this["oBoundaries"]["left"] + 1 + this["oBoundaries"]["width"] - iWidth) + 'px';
	} else {
		oDomRefStyle["left"] = this["oBoundaries"]["left"] - 1 + 'px';
	}
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["relocate"] = 0; };

/**
 * Handles the onpaste event and checks whether the value of the field changed to propagate the dirty state
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InplaceEdit["prototype"]["onpaste"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onpaste"]++; }; 
	UCF_JsUtil["delayedCall"](0, this, 'handleEditEvents', [oBrowserEvent]);
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onpaste"] = 0; };

/**
 * Handles the oncut event and checks whether the value of the field changed to propagate the dirty state
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InplaceEdit["prototype"]["oncut"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["oncut"]++; }; 
	UCF_JsUtil["delayedCall"](0, this, 'handleEditEvents', [oBrowserEvent]);
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["oncut"] = 0; };

/**
 * Handles the ondrop event and checks whether the value of the field changed to propagate the dirty state
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InplaceEdit["prototype"]["ondrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["ondrop"]++; }; 
	UCF_JsUtil["delayedCall"](0, this, 'handleEditEvents', [oBrowserEvent]);
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["ondrop"] = 0; };

UCF_InplaceEdit["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onlsenter"]++; }; 

	this["userFinish"](true);

};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onlsenter"] = 0; };

UCF_InplaceEdit["prototype"]["setFinishedHandler"] = function(oObject, sHandlerMethod) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["setFinishedHandler"]++; }; 

	this["oFinishedHandler"] = {
		"oObject": oObject,
		"sHandlerMethod": sHandlerMethod
	};

};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["setFinishedHandler"] = 0; };

UCF_InplaceEdit["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onAnyEvent"]++; }; 

	var oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent'),
		oSource = oBrowserEvent["oGetSource"](),
		sName = oBrowserEvent["sGetName"]();

	if (sName === 'focusout') {
		this["userFinish"](false);
	} else if (sName === 'mousedown' && oSource !== this["oDomRef"]) {
		this["userFinish"](true);
	} else if (sName === 'focusin' && oSource !== this["oDomRef"]) {
		this["userFinish"](false);
	}

};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onAnyEvent"] = 0; };

UCF_InplaceEdit["prototype"]["onIsolatedAreaEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onIsolatedAreaEvent"]++; }; 
	if (oEvent["mParameters"]["type"] === 'mousedown') {
		this["userFinish"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["onIsolatedAreaEvent"] = 0; };

UCF_InplaceEdit["prototype"]["iGetOptimalWidthFor"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["iGetOptimalWidthFor"]++; }; 

	var oCloneDomRef = document["createElement"]('span');

	oCloneDomRef["style"]["display"] = 'block';
	oCloneDomRef["style"]["position"] = 'absolute';
	oCloneDomRef["style"]["top"] = '-1000px';

	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oCloneDomRef, oDomRef["value"]["replace"](/ /g, "&nbsp;"));

	for (var x = 0; x < UCF_InplaceEdit["STYLES"]["length"]; x++)
		oCloneDomRef["style"][UCF_InplaceEdit["STYLES"][x]] = UCF_DomUtil["sGetCurrentStyle"](oDomRef, UCF_InplaceEdit["STYLES"][x]);

	UCF_DomUtil["prepend"](document["body"], oCloneDomRef);

	var iOffsetWidth = oCloneDomRef["offsetWidth"];

	iOffsetWidth += 8;

	// min size
	iOffsetWidth = Math["max"](iOffsetWidth, 20);

	if (this["iMinimalWidth"])
		iOffsetWidth = Math["max"](iOffsetWidth, this["iMinimalWidth"]);

	UCF_DomUtil["removeFromDom"](oCloneDomRef);

	// determine max size in relation to parent scroll container
	var oPSC = UCF_DomUtil["oGetParentScrollContainer"](oDomRef, false);

	if (oPSC) {
		var iScrollbar = oPSC["offsetWidth"] - oPSC["clientWidth"];

		iOffsetWidth = Math["min"](iOffsetWidth, oPSC["offsetWidth"] - oDomRef["offsetLeft"] - iScrollbar);
	}

	return iOffsetWidth;
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["iGetOptimalWidthFor"] = 0; };

UCF_InplaceEdit["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["destroy"]++; }; 
	try {
		if (this["oLS"]) {
			var oWindow = this["oLS"]["oBrowserWindow"];

			oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
			oWindow["detachEvent"](oWindow["E_EVENTS"]["IsolatedAreaEvent"], this, 'onIsolatedAreaEvent');
		}
	} catch (ex) {}

	UCF_DomUtil["removeFromDom"](this["oDomRef"]);
	this["oBoundaries"] = null;
	this["sText"] = null;
	this["iMinimalWidth"] = null;
	this["oFinishedHandler"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InplaceEdit["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_InplaceEditDelegate"] = function() {/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_EventProvider */
/// <reference path="../../../core/EventProvider.js"/>
/* global UCF_InplaceEdit */
/// <reference path="../InplaceEdit.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 */
function UCF_InplaceEditDelegate(oLS) {if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["UCF_InplaceEditDelegate"]++; }; 

	if (arguments["length"] !== 1) {
		return;
	}

	UCF_EventProvider["apply"](this);

	this["defineEvents"]([
		'InplaceEditFinished',
		'InplaceEditStart',
		'InplaceEditClose',
		'InplaceEditBeforeOpen'
	]);

	this["oLS"] = oLS;
	// this.bAlignRight;

	this["bUseDDC"] = true;
};window["UCF_InplaceEditDelegate"] = UCF_InplaceEditDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_InplaceEditDelegate"); UCF_InplaceEditDelegate["_"] = {UCF_InplaceEditDelegate: 0}; }; ;

UCF_InplaceEditDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_InplaceEditDelegate.prototype["sClassName"] = "UCF_InplaceEditDelegate";

/**
 * @private
 * @final
 */
UCF_InplaceEditDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["destroy"]++; }; 
	this["oLS"] = null;
	this["bAlignRight"] = null;
	this["oInplaceEdit"] = null;
	this["oInplaceEditData"] = null;
	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["destroy"] = 0; };

/**
 * set to true if the source control is right aligned
 */

UCF_InplaceEditDelegate["prototype"]["setAlignRight"] = function(bAlignRight) {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["setAlignRight"]++; }; 

	this["bAlignRight"] = bAlignRight;
};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["setAlignRight"] = 0; };

/**
 *
 */

UCF_InplaceEditDelegate["prototype"]["onlsdelayeddoubleclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["onlsdelayeddoubleclick"]++; }; 
	if (!this["bUseDDC"]) return;

	this["fireEvent"](this["E_EVENTS"]["InplaceEditBeforeOpen"], { "oBrowserEvent": oBrowserEvent });
	if (!oBrowserEvent["bHandled"]) {
		this["openInplaceEdit"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["onlsdelayeddoubleclick"] = 0; };

/**
 * Deactivate handling of the lsdelayeddoubleclick event. Call this immediately after constructor and
 * it will not be available during lifetime of the control (in cannot be activated again).
 * @private
 */
UCF_InplaceEditDelegate["prototype"]["deactivateDelayedDoubleClick"] = function() {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["deactivateDelayedDoubleClick"]++; }; 
	this["bUseDDC"] = false;
};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["deactivateDelayedDoubleClick"] = 0; };

/**
 *
 */

UCF_InplaceEditDelegate["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["onkeydown"]++; }; 

	var iKey = oBrowserEvent["iKeyCode"]();

	if (iKey === UCF_KeyCodes["F2"]) {
		this["openInplaceEdit"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["onkeydown"] = 0; };

/**
 * should be called by the source control
 */

UCF_InplaceEditDelegate["prototype"]["setInplaceEditData"] = function(oReferenceDomRef, oBoundaries, sText) {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["setInplaceEditData"]++; }; 

	this["oInplaceEditData"] = {
		"oReferenceDomRef": oReferenceDomRef,
		"oBoundaries": oBoundaries,
		"sText": sText
	};

};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["setInplaceEditData"] = 0; };

/**
 * Determines the inner Text incl. accesskey
 * @private
 */

UCF_InplaceEditDelegate["sGetInnerText"] = function(oReferenceDomRef) {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["sGetInnerText"]++; }; 

	// TODO: replace by UCF_DomUtil
	var oChildNode = oReferenceDomRef["firstChild"],
		sText = '';

	while (oChildNode != null) {
		// delete the text in all text nodes
		// eslint-disable-line no-magic-numbers
		if (oChildNode["nodeType"] !== 3 || typeof(oChildNode["data"]) === 'undefined') {
			if (oChildNode["nodeType"] === 1) {
				sText += UCF_InplaceEditDelegate["sGetInnerText"](oChildNode);
			}
		} else {
			sText += oChildNode["data"];
		}

		// TODO: replace by UCF_DomUtil.nextSibling
		oChildNode = oChildNode["nextSibling"];
	}

	return sText;
};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["sGetInnerText"] = 0; };

/**
 * Returns the accesskey
 * @private
 */

UCF_InplaceEditDelegate["sGetAccessKey"] = function(oReferenceDomRef) {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["sGetAccessKey"]++; }; 

	// TODO: replace by UCF_DomUtil.firstChild(oReferenceDomRef) and similar
	var oChildNode = oReferenceDomRef["firstChild"],
		sAccesskey = '';

	while (oChildNode != null) {
		if (oChildNode["nodeType"] === 1
			&& typeof(oChildNode["className"]) !== 'undefined') {
			if (oChildNode["className"]["indexOf"]('urAccessKey') > -1
				&& typeof(oChildNode["data"]) !== 'undefined') {
				sAccesskey += UCF_InplaceEditDelegate["sGetInnerText"](oChildNode);
			}
			sAccesskey += UCF_InplaceEditDelegate["sGetAccessKey"](oChildNode);
		}

		// TODO: replace by UCF_DomUtil.nextSibling
		oChildNode = oChildNode["nextSibling"];
	}

	return sAccesskey;
};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["sGetAccessKey"] = 0; };

/**
 * Changes the inner Text while restoring the accesskey
 * @private
 */

UCF_InplaceEditDelegate["clearInnerText"] = function(oReferenceDomRef) {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["clearInnerText"]++; }; 

	// TODO: replace by UCF_DomUtil.firstChild(oReferenceDomRef) and similar
	var oChildNode = oReferenceDomRef["firstChild"];

	while (oChildNode != null) {
		// delete the text in all text nodes
		if (oChildNode["nodeType"] !== 3 || typeof(oChildNode["data"]) === 'undefined') {
			UCF_InplaceEditDelegate["clearInnerText"](oChildNode);
		} else {
			oChildNode["data"] = '';
		}
		// TODO: replace by UCF_DomUtil.nextSibling
		oChildNode = oChildNode["nextSibling"];
	}
};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["clearInnerText"] = 0; };

/**
 * Changes the inner Text while restoring the accesskey
 * @private
 */

UCF_InplaceEditDelegate["setInnerText"] = function(oReferenceDomRef, sText) {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["setInnerText"]++; }; 
	// eslint-disable-next-line no-magic-numbers
	var oChildNode = oReferenceDomRef["firstChild"],
		sAccesskey = UCF_InplaceEditDelegate["sGetAccessKey"](oReferenceDomRef),
		iAccesskey = sAccesskey === '' ? -10 : sText["indexOf"](sAccesskey),
		iState = 0; //

	UCF_InplaceEditDelegate["clearInnerText"](oReferenceDomRef);
	while (oChildNode != null) {
		// eslint-disable-next-line no-magic-numbers
		if (iState === 0 && iAccesskey < -2) {
			if (oChildNode["nodeType"] === 3 // eslint-disable-line no-magic-numbers
				&& typeof(oChildNode["data"]) !== 'undefined') {
				oChildNode["data"] = sText;
				break;
			}
		}
		/* TODO - support complex nested structures
		else if (iState == 0 && iAccesskey > 0){
			if (oChildNode.nodeType == 3 && typeof(oChildNode.data) != 'undefined') {
				var sText1 = sText.substring(0,iAccesskey);
				oChildNode.data = sText1;
				iState++;
			}
		} else if (iState == 1 && oChildNode.nodeType == 1 && typeof(oChildNode.className) != 'undefined' && oChildNode.className.indexOf('urAccessKey') > -1){
			var oTextNode = oReferenceDomRef.firstChild;
			if (oTextNode.nodeType == 3 && typeof(oTextNode.data) != 'undefined') {
				oTextNode.data = sAccesskey;
				iState++;
			}
		} else if (iState == 2 && iAccesskey > 0) {
			if (oChildNode.nodeType == 3 && typeof(oChildNode.data) != 'undefined') {
				var sText1 = sText.substring(iAccesskey + sAccesskey.length);
				oChildNode.data = sText1;
				//iState++;
			}
		} */

		// TODO: replace by UCF_DomUtil.nextSibling
		oChildNode = oChildNode["nextSibling"];
	}
};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["setInnerText"] = 0; };

/**
 *
 */

UCF_InplaceEditDelegate["prototype"]["openInplaceEdit"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["openInplaceEdit"]++; }; 

	this["oInplaceEditData"] = null;

	this["fireEvent"](this["E_EVENTS"]["InplaceEditStart"], { "oBrowserEvent": oBrowserEvent });

	if (!this["oInplaceEditData"]) {
		return;
	}

	if (oBrowserEvent) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

	// needed for lazy loading
	new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEdit"))();

	var sControlId = UCF_JsUtil["sGetUID"]() + 'Inplaceedit';

	UCF_InplaceEdit["create"](this["oLS"], sControlId);
	this["oInplaceEdit"] = this["oLS"]["oControlFactory"]["oGetControlById"](sControlId);

	this["oInplaceEdit"]["setFinishedHandler"](this, 'handleInplaceEditFinished');
	this["oInplaceEdit"]["bAlignRight"] = this["bAlignRight"];
	this["oInplaceEdit"]["open"](
		this["oInplaceEditData"]["oReferenceDomRef"],
		this["oInplaceEditData"]["oBoundaries"],
		this["oInplaceEditData"]["sText"]);

};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["openInplaceEdit"] = 0; };

/**
 *
 */

UCF_InplaceEditDelegate["prototype"]["handleInplaceEditFinished"] = function(sText, bApply) {;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["handleInplaceEditFinished"]++; }; 

	// only fire if text has really been changed by the user
	if (bApply && this["oInplaceEditData"]["sText"] !== sText) {
		this["fireEvent"](this["E_EVENTS"]["InplaceEditFinished"], { "sText": sText });
	} else {
		this["fireEvent"](this["E_EVENTS"]["InplaceEditClose"], {});
	}
};;if (__UCF_COVERAGE__) { UCF_InplaceEditDelegate["_"]["handleInplaceEditFinished"] = 0; };

/*
UCF_InplaceEditDelegate.prototype.onmouseover = function(oBrowserEvent){

	if (UCF_System.bUseAnimation)	{
		var oDomRef = oBrowserEvent.oGetSourceControl().oDomRef;

		var oAnimation = this.oAnim = new UCF_Animation(oDomRef, 400);

		oAnimation.addColorChange("backgroundColor","#EAF1F6", "#FEF09E", oAnimation.M_TRANSITIONS.EaseIn);
		oAnimation.play();
	}
};
UCF_InplaceEditDelegate.prototype.onmouseout = function(oBrowserEvent){

	if (this.oAnim)
		this.oAnim.stop();
	var oDomRef = oBrowserEvent.oGetSourceControl().oDomRef;
	oDomRef.style.backgroundColor = "#EAF1F6";

};
*/
// TODO: accessibility generically?

};
sap["ls"]["preload"]["UCF_InputAssistant"] = function() {/* global _assert, _trace, ERROR */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LayeredControl */
/// <reference path="./LayeredControl.js"/>

/**
 * @class Class UCF_InputAssistant
 *
 * @version
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 * @param {string} sId identifier of the Keyboard
 */
function UCF_InputAssistant(oDomRef, oLS, sId) {if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["UCF_InputAssistant"]++; }; 
	if (arguments["length"] > 0) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sId"] = sId;

		oDomRef = this["oCreateDom"]();
		oLS["oGetAssociatedAreaRef"]()["appendChild"](oDomRef);

		UCF_LayeredControl["apply"](this, arguments);

		this["defineEvents"](['Close', 'Select']);

		/** @type {string} */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sValue"] = null;
	}
};window["UCF_InputAssistant"] = UCF_InputAssistant; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_InputAssistant"); UCF_InputAssistant["_"] = {UCF_InputAssistant: 0}; }; ;
UCF_InputAssistant["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_InputAssistant.prototype["sClassName"] = "UCF_InputAssistant";

UCF_InputAssistant["fCallback"] = null;

UCF_InputAssistant["prototype"]["registerInputAssistant"] = function(fCallback, sType) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["registerInputAssistant"]++; }; 
	UCF_InputAssistant["fCallback"] = fCallback;
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["registerInputAssistant"] = 0; };

UCF_InputAssistant["prototype"]["unRegisterInputAssistant"] = function(fCallback, sType) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["unRegisterInputAssistant"]++; }; 
	UCF_InputAssistant["fCallback"] = null;
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["unRegisterInputAssistant"] = 0; };

/**
 * Renders the HTML of the root container
 * @return {HTMLDivElement}
 */
UCF_InputAssistant["prototype"]["oCreateDom"] = function() {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["oCreateDom"]++; }; 
	/** @type {HTMLDivElement} */
	var oDiv = document["createElement"]("DIV");

	oDiv["setAttribute"]("ct", "InputAssistant");
	oDiv["setAttribute"]("id", this["sId"]);
	oDiv["style"]["position"] = "absolute";
	oDiv["style"]["top"] = "-1000px";

	return oDiv;
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["oCreateDom"] = 0; };

/**
 * Sets the connected control. The connected control is the control for which
 * you opened the Keyboard.
 *
 * @param {UCF_Control} oControl
 *            oControl the control instance
 */
UCF_InputAssistant["prototype"]["setConnectedControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["setConnectedControl"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oControl) === "object", "typeof(oControl) === \"object\"", "InputAssistant.js(73): setConnectedControl"); };
	this["oConnectedControl"] = oControl;
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["setConnectedControl"] = 0; };

/**
 * Sets the value of the onscreen Keyboard input field
 *
 * @param {string} sValue
 *            sValue value of the onscreen Keyboard input field
 */
UCF_InputAssistant["prototype"]["setValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["setValue"]++; }; 
	this["sValue"] = sValue;
	// needed to enable cancel and set the old value in the input field
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["setValue"] = 0; };

/**
 * Opens the Keyboard
 */
UCF_InputAssistant["prototype"]["open"] = function() {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["open"]++; }; 
	var oWindow = this["oLS"]["oBrowserWindow"];

	// listen to all events
	oWindow["attachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	// open
	this["bOpen"] = true;
	this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);
	this["setOverlap"](1);
	this["setOpenerRef"](this["oConnectedControl"]["oDomRef"]);

	this["openBase"]();
	var oInputFieldDomRef = this["oConnectedControl"]["oDomRef"];
	// Call the third party callback for the initial rendering
	this["oLS"]["fInputAssistantCallBack"](this["oGetInterface"](this["aPublicMethods"]));
	// refocus field again instead of opener button
	oInputFieldDomRef["focus"]();
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["open"] = 0; };

/**
 * close the input assistant
 * @param {boolean} bCancelled
 */
UCF_InputAssistant["prototype"]["close"] = function(bCancelled) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["close"]++; }; 
	if (!this["bOpen"])
		return;

	var oInputFieldDomRef = this["oConnectedControl"]["oDomRef"];

	// set the old value to cancel
	if (bCancelled) {
		oInputFieldDomRef["value"] = this["sValue"];
	} else {
		if (oInputFieldDomRef["value"] !== this["sValue"]) {
			this["oConnectedControl"]["fireChange"](this["oConnectedControl"]["sId"],
				oInputFieldDomRef["value"]);
		}
	}

	// detach listening on any events
	var oWindow = this["oLS"]["oBrowserWindow"];
	oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);

	// close
	this["bOpen"] = false;
	this["closeBase"]();
	if (bCancelled)
		this["oConnectedControl"]["focus"]();
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["close"] = 0; };

/**
 * Handles all events
 *
 * @param { UCF_Event } oEvent
 *            oEvent the event object
 */
UCF_InputAssistant["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["onAnyEvent"]++; }; 
	var oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent");
	var oSource = oBrowserEvent["oGetSource"]();

	// close Keyboard if you click somewhere outside
	if (oBrowserEvent["sGetName"]() === "click" || oBrowserEvent["sGetName"]() === "mousedown") {
		if (oBrowserEvent["oGetSourceRoot"]() !== this["oDomRef"] &&
			oSource !== this["oConnectedControl"]["oDomRef"] &&
			oSource !== this["oConnectedControl"]["oGetHelpButtonRef"]()) {
			this["close"](true);
			this["oConnectedControl"]["onlsblur"](oBrowserEvent);
			if (oSource !== this["oConnectedControl"]["oDomRef"]) {
				this["oConnectedControl"]["bNoBlur"] = false;
				this["oConnectedControl"]["onlsblur"](oBrowserEvent);
			}
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	} else if (oBrowserEvent["sGetName"]() === "lsfocuslost" &&
		!UCF_UserAgent["bIsWebKit"]() && !UCF_UserAgent["bIsGecko"]()) {
		this["close"](true);
		this["oConnectedControl"]["onlsblur"](oBrowserEvent);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (oBrowserEvent["sGetName"]() === "lstabnext" || oBrowserEvent["sGetName"]() === "lstabprevious") {
		if (this["oInputAssisantImplementation"]["onTabKey"])
			this["oInputAssisantImplementation"]["onTabKey"](oBrowserEvent);
		else {
			this["close"](true);
			this["oConnectedControl"]["onlsblur"](oBrowserEvent);
		}
	} else if (oBrowserEvent["sGetName"]() === "lsenter") {
		if (this["oConnectedControl"]["sClassName"] !== "UCF_TextEdit") {
			this["close"](false);
			this["oConnectedControl"]["onlsblur"](oBrowserEvent);
		}
	} else if (oBrowserEvent["sGetName"]() === "lsescape") {
		this["close"](true);
		this["oConnectedControl"]["onlsblur"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["onAnyEvent"] = 0; };

/**
 * Handles the click event on the InputAssistant
 * Call the registered handler
 * @param { UCF_BrowserEvent } oBrowserEvent
 *            oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputAssistant["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["onclick"]++; }; 
	if (this["oInputAssisantImplementation"]["onclick"])
		this["oInputAssisantImplementation"]["onclick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["onclick"] = 0; };

/**
 * Calculates and returns current cursor position of the connected input text
 * control.
 *
 * @param { HTMLElement } inputElement
 *            a connected text inout controlHTMLElement
 * @return {integer} - current cursor position
 */
UCF_InputAssistant["prototype"]["getCursorPosition"] = function(inputElement) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["getCursorPosition"]++; }; 
	var cursorPosition = 0;
	if (document["selection"]) {
		inputElement["focus"]();
		var selectionRange = document["selection"]["createRange"]();
		selectionRange["moveStart"]("character", -inputElement["value"]["length"] + 1);
		cursorPosition = selectionRange["text"]["length"];
	} else if (inputElement["selectionStart"] ||
		inputElement["selectionStart"] === "0") {
		cursorPosition = inputElement["selectionStart"];
	}
	return cursorPosition;
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["getCursorPosition"] = 0; };

/**
 * Add the value to the original input field
 *
 * @param {string}  sValue
 *
 */
UCF_InputAssistant["prototype"]["addKeyToInputField"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["addKeyToInputField"]++; }; 
	var oInputFieldDomRef = this["oConnectedControl"]["oDomRef"];
	oInputFieldDomRef["focus"]();
	if (oInputFieldDomRef["type"] && oInputFieldDomRef["type"] === 'password') { // selections do not work
		oInputFieldDomRef["value"] += sValue;
		return;
	}
	if (typeof document["selection"] !== 'undefined') {
		var oRange = document["selection"]["createRange"](),
			sOldSelectedText = oRange["text"];
		oRange["text"] = sValue;
		oRange = document["selection"]["createRange"]();
		if (sValue === "\r\n")
			oRange["move"]('character', 0);
		else
			oRange["move"]('character', -sValue["length"] + 1);
		oRange["select"]();
	} else if (typeof oInputFieldDomRef["selectionStart"] !== 'undefined') {
		//FF
		var sOldValue = oInputFieldDomRef["value"],
			iStartPos = oInputFieldDomRef["selectionStart"],
			iEndPos = oInputFieldDomRef["selectionEnd"];
		sOldSelectedText = sOldValue["substring"](iStartPos, iEndPos);
		oInputFieldDomRef["value"] = sOldValue["substr"](0, iStartPos) +
			sValue +
			sOldValue["substr"](iEndPos);

		var pos = iStartPos + sValue["length"] +
			(sOldSelectedText["length"] === 0 ? sOldSelectedText["length"] : 0);
		if (sValue === "\r\n")
			pos--;
		oInputFieldDomRef["selectionStart"] = pos;
		oInputFieldDomRef["selectionEnd"] = pos;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Error not text selection JS function for OnScreen Keyboard found", "InputAssistant.js(266): addKeyToInputField"); };
	}
	return;
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["addKeyToInputField"] = 0; };

/**
 * Remove the selection or the character before the Caret
 */
UCF_InputAssistant["prototype"]["removeKeyFromInputField"] = function() {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["removeKeyFromInputField"]++; }; 
	var oInputFieldDomRef = this["oConnectedControl"]["oDomRef"];
	oInputFieldDomRef["focus"]();
	if (oInputFieldDomRef["type"] && oInputFieldDomRef["type"] === 'password') { // selections do not work
		if (oInputFieldDomRef["value"]["length"] > 0)
			oInputFieldDomRef["value"] =
			oInputFieldDomRef["value"]["substring"](0, oInputFieldDomRef["value"]["length"] - 1);
		return;
	}
	if (typeof document["selection"] !== 'undefined') {
		var oRange = document["selection"]["createRange"]();
		if (oRange["text"]["length"] === 0)
			oRange["moveStart"]('character', -1);
		oRange["text"] = "";
		oRange = document["selection"]["createRange"]();
		oRange["move"]('character', 0);
		oRange["select"]();
	} else if (typeof oInputFieldDomRef["selectionStart"] !== 'undefined') {
		//FF
		var sOldValue = oInputFieldDomRef["value"],
			iStartPos = oInputFieldDomRef["selectionStart"],
			iEndPos = oInputFieldDomRef["selectionEnd"];
		if (iStartPos === iEndPos)
			iStartPos--;
		oInputFieldDomRef["value"] = sOldValue["substr"](0, iStartPos) +
			sOldValue["substr"](iEndPos);
		oInputFieldDomRef["selectionStart"] = iStartPos;
		oInputFieldDomRef["selectionEnd"] = iStartPos;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Error no text selection JS function for OnScreen Keyboard found", "InputAssistant.js(303): removeKeyFromInputField"); };
	}
	return;
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["removeKeyFromInputField"] = 0; };

/**
 * Apply the HTML to the DOM
 * @public
 *
 * @param {string} sHmtl
 */
UCF_InputAssistant["prototype"]["applyHTML"] = function(sHmtl) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["applyHTML"]++; }; 
	// this sHtml is provided by the framework and implements an on screen keyboard
	// we cannot encode it
	UCF_DomUtil["setInnerHtml"](this["oDomRef"], sHmtl);
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["applyHTML"] = 0; };

/**
 * @public
 *
 * @return {string}
 *
 */
UCF_InputAssistant["prototype"]["sGetFieldType"] = function() {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["sGetFieldType"]++; }; 
	if (!this["oConnectedControl"]["sType"])
		return ("string");
	return this["oConnectedControl"]["sType"]["toLowerCase"]();
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["sGetFieldType"] = 0; };

/**
 * @public
 *
 * @return {string}
 *
 */
UCF_InputAssistant["prototype"]["sGetLanguage"] = function() {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["sGetLanguage"]++; }; 
	return this["oLS"]["oSystem"]["sLanguage"]["toLowerCase"]();
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["sGetLanguage"] = 0; };

/**
 * @public
 *
 * @param {string} sKey
 */
UCF_InputAssistant["prototype"]["applyKeystroke"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["applyKeystroke"]++; }; 
	if (sKey === "\b")
		this["removeKeyFromInputField"]();
	else
		this["addKeyToInputField"](sKey);
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["applyKeystroke"] = 0; };

/**
 * @public
 *
 * @param {boolean} bCancelled
 *
 */
UCF_InputAssistant["prototype"]["closeInputAssistant"] = function(bCancelled) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["closeInputAssistant"]++; }; 
	this["close"](bCancelled);
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["closeInputAssistant"] = 0; };

/**
 * @public
 *
 * @return {string}
 *
 */
UCF_InputAssistant["prototype"]["sGetCancel"] = function() {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["sGetCancel"]++; }; 
	return this["oLS"]["sGetText"]("SAPUR_CALC_CANCEL");
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["sGetCancel"] = 0; };

/**
 * @public
 *
 * @return { string }
 *
 */
UCF_InputAssistant["prototype"]["sGetOK"] = function() {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["sGetOK"]++; }; 
	return this["oLS"]["sGetText"]("SAPUR_CALC_OK");
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["sGetOK"] = 0; };

/**
 * @public
 *
 * @param {UCF_Control} oControl
 */
UCF_InputAssistant["prototype"]["setImplementation"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["setImplementation"]++; }; 
	this["oInputAssisantImplementation"] = oControl;
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["setImplementation"] = 0; };

/**
 * @public
 *
 * @return {HTMLElement}
 *
 */
UCF_InputAssistant["prototype"]["getFieldtype"] = function() {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["getFieldtype"]++; }; 
	var oInputFieldDomRef = this["oConnectedControl"]["oDomRef"];
	if (oInputFieldDomRef)
		return oInputFieldDomRef["type"];
	else
		return null;
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["getFieldtype"] = 0; };

/**
 * @private
 */
UCF_InputAssistant["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["destroy"]++; }; 
	this["oConnectedControl"] = null;
	this["oInputAssisantImplementation"] = null;
	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputAssistant["_"]["destroy"] = 0; };


UCF_InputAssistant.prototype["aPublicMethods"] = ["applyHTML","sGetFieldType","sGetLanguage","applyKeystroke","closeInputAssistant","sGetCancel","sGetOK","setImplementation","getFieldtype"].concat(UCF_InputAssistant.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_InputField"] = function() {/* global UCF_InputFieldHelpButton */
/// <reference path="./InputFieldHelpButton.js"/>
/* global UCF_EditFieldBase */
/// <reference path="./base/EditFieldBase.js"/>
/* global UCF_PasswordFieldDelegate */
/// <reference path="./delegates/PasswordFieldDelegate.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_Exception */
/// <reference path="../core/Exception.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_RenderManager */
/// <reference path="../core/RenderManager.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Date */
/// <reference path="../types/Date.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_ClipboardUtil */
/// <reference path="../../core/util/ClipboardUtil.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Tracer, _assert, _trace, INFO, DEBUG, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/**
 * @class
 * @extends UCF_EditFieldBase
 *
 * @param {HTMLElement} oDomRef the DOM element that represents the control
 * @param {UCF_LS} oLS the LightSpeed instance that manages the control
 */
function UCF_InputField(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_InputField["_"]["UCF_InputField"]++; };  // eslint-disable-line @ur/no-memory-leaks
	if (arguments["length"] > 0) {
		UCF_EditFieldBase["apply"](this, [oDomRef, oLS]);

		UCF_ClassLoader["oGetClass"]('UCF_InputFieldHelpButton');

		/** @type {string} */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sOldValue"] = this["sValue"];
		/** @type {string} */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sEscapeValue"] = '';
		/** @type {boolean} */
		this["bForceChange"] = false;
		/** @type {UCF_Date} */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["oDate"] = null;
		/** @type {boolean} */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["bTabPressed"] = false;

		if (this["oDomRef"]["type"] === 'password') {
			/** @type {UCF_PasswordFieldDelegate} */
			// eslint-disable-next-line @ur/no-memory-leaks
			this["oPasswordDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_PasswordFieldDelegate"))(this);
			this["addDelegate"](this["oPasswordDelegate"], true);
		}

		if (this["bIsWriteable"]()) {
			// use blur instead of lsblur to fire change event because value has not
			// changed on lsblur when you drag the value away
			// attach blur only for ie, blur is already attached in firefox
			if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
				this["attachBrowserEvent"]('blur', oDomRef);
			}
		}

		if (this["sType"] !== 'INTEGER') {
			/** @type {boolean} */
			this["bSpinnerBoundsCheck"] = false;
			// eslint-disable-next-line quotes
			this["setClientProperty"]("SpinnerBoundsCheck", this["bSpinnerBoundsCheck"], true);
		}

		this["attachEvent"](
			this["E_EVENTS"]["WillDestroy"],
			this,
			'onWillDestroyInputField'
		);

		this["attachEvent"](this["E_EVENTS"]["WillFireChange"], this, 'onWillFireChange');
		this["attachEvent"](this["E_EVENTS"]["FireChange"], this, 'onFireChange');
		this["attachEvent"](this["E_EVENTS"]["DidFireChange"], this, 'onDidFireChange');
	}
};window["UCF_InputField"] = UCF_InputField; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_InputField"); UCF_InputField["_"] = {UCF_InputField: 0}; }; ;
UCF_InputField["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EditFieldBase"))(); UCF_InputField.prototype["sClassName"] = "UCF_InputField";

/** @type {UCF_Control} */
UCF_InputField["oPendingFieldHelp"] = null;

/**
 * Handles the onlsfocus event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_InputField["prototype"]["onAfterLsFocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterLsFocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InputField.js(113): onAfterLsFocus"); };

	if (this["sType"] === 'DATE' && this["sFieldHelp"] === 'SPINNER' && !this["oDate"]) {
		this["initializeDateSpinner"]();
	}
	this["sEscapeValue"] = this["sGetValue"]();
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterLsFocus"] = 0; };

/**
 * Initialize the date object for Inputdate fields using spinners
 *
 * @private
 */
UCF_InputField["prototype"]["initializeDateSpinner"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["initializeDateSpinner"]++; }; 
	if (!this["oDate"]) {
		this["bUseWheelForSpinner"] = true;
		this["possiblyUpdateDate"]();
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["initializeDateSpinner"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
// eslint-disable-next-line complexity
UCF_InputField["prototype"]["onAfterClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterClick"]++; }; 
	/** @type {HTMLElement} */
	var oSource;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InputField.js(144): onAfterClick"); };

	oSource = oBrowserEvent["oGetSource"]();

	if (!this["bSkipEventProcessing"](oBrowserEvent)) {
		if (this["sType"] === 'DATE' && this["sFieldHelp"] === 'SPINNER') {
			if (!this["oDate"]) {
				this["initializeDateSpinner"]();
			}
			this["iCursorPos"] = UCF_DomUtil["iGetCursorPos"](this["oFocusDomRef"]);
		}

		// process field help
		if (oSource && oSource === this["oGetHelpButtonRef"]()) {
			this["onHelpButtonPress"](this["oCreateHelpButtonPress"](oBrowserEvent));
		} else if (
			this["oLS"]["fInputAssistantCallBack"] &&
			(!this["oFieldHelp"] || !this["oFieldHelp"]["bOpen"])
		) {
			this["openFieldHelp"]();
		}

		// handle label click for toolbar input fields
		if (oSource["tagName"] === 'LABEL') {
			this["bNoBlur"] = true;
			this["oFocusDomRef"]["focus"]();
		}

		// has to be canceled anyway to avoid e.g. unnecessary selection in
		// container controls (especially saptable)
		if (this["getEnabled"]()) {
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterClick"] = 0; };

/**
 * @override
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the dblclick
 */
UCF_InputField["prototype"]["onAfterDblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterDblclick"]++; }; 
	if (this["getEnabled"]()) {
		// Spinner: the user might want to 'spin' fast which causes additional
		// dblclick events all browsers (even Edge) but IE11 Quirks fire "click
		// click dblclick" on a double click, IE11 Quirks fires "click dblclick"
		if (oBrowserEvent["oGetSource"]() === this["oGetHelpButtonRef"]() &&
			UCF_UserAgent["bIsIECompatibilityMode"]()
		) {
			this["onHelpButtonPress"](this["oCreateHelpButtonPress"](oBrowserEvent));
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterDblclick"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event
 * @return {UCF_Event} the help button press
 */
UCF_InputField["prototype"]["oCreateHelpButtonPress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oCreateHelpButtonPress"]++; }; 
	return new (UCF_ClassLoader["oGetClass"]("UCF_Event"))(
		(this["oHelpButton"] && this["oHelpButton"]["E_EVENTS"]["Press"]) || 0, {
			"sConnectedControlId": this["sId"],
			"bIsOnUpperHalf": oBrowserEvent &&
				// eslint-disable-next-line no-magic-numbers
				oBrowserEvent["iOffsetY"]() < (this["oDomRef"]["offsetHeight"] / 2)
		}
	);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oCreateHelpButtonPress"] = 0; };

/**
 * @override
 * @return {boolean} `true` if the dblclick should be handled, otherwise
 * `false`
 */
UCF_InputField["prototype"]["bShouldHandleDblclick"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldHandleDblclick"]++; }; 
	return this["getEnabled"]() && UCF_EditFieldBase.prototype["bShouldHandleDblclick"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldHandleDblclick"] = 0; };

/**
 * Handles the onscroll
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the scroll
 */
UCF_InputField["prototype"]["onscroll"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onscroll"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent, "oBrowserEvent", "InputField.js(231): onscroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oBrowserEvent) === 'object', "typeof(oBrowserEvent) === 'object'", "InputField.js(232): onscroll"); };

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onscroll"] = 0; };

/**
 * Handles the semantical mousewheel event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsmousewheel
 */
// eslint-disable-next-line complexity
UCF_InputField["prototype"]["onlsmousewheel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onlsmousewheel"]++; }; 
	/** @type {number} */
	var oActiveElement;
	/** @type {number} */
	var iIncrement;

	if (
		this["sFieldHelp"] === 'SPINNER' &&
		this["bUseWheelForSpinner"] &&
		this["bIsWriteable"]()
	) {
		// We want the wheel action only if the control has the focus -
		// otherwise the wheel might be used for scrolling
		oActiveElement = UCF_DomUtil["oGetActiveElement"]();
		if (
			oActiveElement === this["oFocusDomRef"] ||
			oActiveElement === this["oGetHelpButtonRef"]()
		) {
			// spinning on Type=INTEGER did never work because bUseWheelForSpinner
			// only turned true for Type=DATE
			if (this["sType"] === 'DATE') {
				if (oBrowserEvent["iWheelDelta"]) {
					// eslint-disable-next-line no-magic-numbers
					iIncrement = oBrowserEvent["iWheelDelta"]() / 3;
				} else if (window["event"]["detail"]) {
					// Firefox
					// eslint-disable-next-line no-magic-numbers
					iIncrement = -window["event"]["detail"] / 3;
				}
				this["changeDate"](iIncrement);
			}
			// Avoid scrolling if wheel is used for the spinner
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	} else if (this["bIsOpen"]()) {
		this["closeFieldHelp"]();
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onlsmousewheel"] = 0; };

/**
 * @return {boolean} `true` if a field help is attached and open, otherwise
 * `false`
 */
UCF_InputField["prototype"]["bIsOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsOpen"]++; }; 
	return this["oFieldHelp"] && this["oFieldHelp"]["bOpen"] && this["bIsConnectedControl"](this["oFieldHelp"]);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsOpen"] = 0; };

/**
 * @param {HTMLElement} oRelatedTarget the element the mouse is over now
 * @return {boolean} `true` if the mouse is over a connected control (e.g.
 * ls-datepicker or ls-inputfieldhelpbutton or ${id}-btn), otherwise `false`
 */
UCF_InputField["prototype"]["bIsMouseOverConnectedControl"] = function(oRelatedTarget) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsMouseOverConnectedControl"]++; }; 
	return UCF_EditFieldBase.prototype["bIsMouseOverConnectedControl"]["call"](this, oRelatedTarget)
		|| this["bIsMouseOverFieldHelp"](oRelatedTarget);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsMouseOverConnectedControl"] = 0; };

/**
 * @param {HTMLElement} oRelatedTarget the element the mouse is over now
 * @return {boolean} `true` if the mouse is over the field help, otherwise
 * `false`
 */
UCF_InputField["prototype"]["bIsMouseOverFieldHelp"] = function(oRelatedTarget) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsMouseOverFieldHelp"]++; }; 
	return this["oFieldHelp"]
		&& !this["oFieldHelp"]["bIsDestroyed"]
		&& UCF_DomUtil["bContains"](this["oFieldHelp"]["oDomRef"], oRelatedTarget);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsMouseOverFieldHelp"] = 0; };

/** @override */
UCF_InputField["prototype"]["oGetFieldHelpRootRef"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oGetFieldHelpRootRef"]++; }; 
	return this["oFieldHelp"] && this["oFieldHelp"]["oRootRef"];
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oGetFieldHelpRootRef"] = 0; };

/** @override */
UCF_InputField["prototype"]["oGetFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oGetFieldHelp"]++; }; 
	return this["oFieldHelp"];
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oGetFieldHelp"] = 0; };

/**
 * Handles the onmouseout event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseout
 */
UCF_InputField["prototype"]["onAfterMouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterMouseout"]++; }; 
	// hovering over will launch the field help if within saptable cell...
	if (this["bShouldConnectButtonOnHover"]()) {
		if (this["bIsOpen"]()) {
			this["oFieldHelp"]["setPosition"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterMouseout"] = 0; };

/**
 * @private
 * @override
 * @param {HTMLElement} oFocusTargetRef the element the focus moves to
 * @return {boolean} `true` if the help button should be hidden, otherwise
 * `false`
 */
UCF_InputField["prototype"]["bShouldHideButton"] = function(oFocusTargetRef) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldHideButton"]++; }; 
	return UCF_EditFieldBase.prototype["bShouldHideButton"]["call"](this, oFocusTargetRef) && !this["bIsOpen"]();
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldHideButton"] = 0; };

/**
 * @param {UCF_Control} oControl the control to check
 * @return {boolean} `true` if control is connected to the InputField,
 * otherwise `false`
 */
UCF_InputField["prototype"]["bIsConnectedControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsConnectedControl"]++; }; 
	return UCF_EditFieldBase.prototype["bIsConnectedControl"]["call"](this, oControl) || (
		oControl === this["oFieldHelp"] &&
		this["oFieldHelp"] &&
		this["oFieldHelp"]["oConnectedControl"] === this
	) || (
		this["oFieldHelp"] &&
		this["oFieldHelp"]["oConnectedControl"] === this &&
		UCF_DomUtil["bContains"](this["oFieldHelp"]["oDomRef"], oControl["oDomRef"])
	);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsConnectedControl"] = 0; };

/**
 * Handles the onblur event
 *
 * @private
 */
UCF_InputField["prototype"]["onblur"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onblur"]++; }; 
	if (this["bNoBlur"]) {
		this["bNoBlur"] = false; // allow blur the next time
	} else {
		// necessary for drag to check again if value has changed
		try {
			this["prepareFireChange"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
		this["showInputPrompt"]();
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onblur"] = 0; };

/**
 * Changes the date for Inputdate fields using spinners
 *
 * @private
 * @param {integer} change direction
 */

UCF_InputField["prototype"]["changeDate"] = function(iUpdown) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["changeDate"]++; }; 
	/** @type {number} */
	var iDay;
	/** @type {number} */
	var iMonth;
	/** @type {number} */
	var iYear;

	if (iUpdown < 0) {
		iUpdown = Math["round"](iUpdown);
	} else {
		// eslint-disable-next-line no-magic-numbers
    iUpdown = Math["round"](iUpdown - .5);
  }
	if (!this["oDate"]) {
		this["initializeDateSpinner"]();
	}

	iDay = this["oDate"]["iGetDate"]();
	iMonth = this["oDate"]["iGetMonth"]();
	iYear = this["oDate"]["iGetYear"]();

	this["oFocusDomRef"]["focus"]();

	if (!this["iCursorPos"]) {
		this["iCursorPos"] = 0;
	}

	switch (this["oDate"]["sGetSelectedDateElement"](this["iCursorPos"])) {
		case 'Hours':
		case 'hours':
			this["oDate"]["setHours"](this["oDate"]["iGetHours"]() + iUpdown);
			break;
		case 'minutes':
			this["oDate"]["setMinutes"](this["oDate"]["iGetMinutes"]() + iUpdown);
			break;
		case 'seconds':
			this["oDate"]["setSeconds"](this["oDate"]["iGetSeconds"]() + iUpdown);
			break;
		case 'ampm':
			this["oDate"]["setHours"](this["oDate"]["iGetHours"]() + 12 * iUpdown);
			break;
		case 'year':
			iYear += iUpdown;
			this["oDate"]["setYear"](iYear);
			break;
		case 'month':
			iMonth += iUpdown;
			this["oDate"]["setMonthChecked"](iMonth);
			break;
		case 'day':
		case 'dayname':
		default:
			iDay += iUpdown;
			this["oDate"]["setDate"](iDay);
	}
	if (this["oDate"]["iGetYear"]() < 1) {
		this["oDate"]["setYear"](1);
	}
	if (this["oDate"]["iGetYear"]() > 9999) { // eslint-disable-line no-magic-numbers
		this["oDate"]["setYear"](9999); // eslint-disable-line no-magic-numbers
	}
	this["setValueInternal"](this["oDate"]["sGetFormattedDate"](this["sGetFormatString"]()));
	UCF_DomUtil["setCursorPos"](this["oFocusDomRef"], this["iCursorPos"]);
	this["fireSpin"](this["sId"], this["sValue"]);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["changeDate"] = 0; };

/**
 * Handles key down/spinner down event for Inputdate fields using spinners
 *
 * @private
 */
UCF_InputField["prototype"]["decrementDate"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["decrementDate"]++; }; 
	this["changeDate"](-1);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["decrementDate"] = 0; };

/**
 * Handles key up/spinner up event for Inputdate fields using spinners
 *
 * @private
 */
UCF_InputField["prototype"]["incrementDate"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["incrementDate"]++; }; 
	this["changeDate"](1);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["incrementDate"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the keydown
 */
// eslint-disable-next-line complexity
UCF_InputField["prototype"]["onBeforeKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeKeydown"]++; }; 
	/** @type {number} */
	var iKey;
	/** @type {boolean} */
	var shouldCancelBubble;
	/** @type {UCF_Event} */
	var oEvent;

	if (!this["getEnabled"]() || (this["bReadonly"] && !this["bShowHelpButtonAlways"])) {
		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))(
			'disabled || readonly w/o showHelpButtonAlways => drop event'
		);
	}

	iKey = oBrowserEvent["iKeyCode"]();

	// open field help
	if (this["bIsFieldHelpOpenRequest"](oBrowserEvent)) {
		if (UCF_KeyboardHelper["bIsEventForKey"](
				oBrowserEvent,
				UCF_KeyCodes["ARROW_DOWN"],
				'A'
			)) {
			oEvent = new (UCF_ClassLoader["oGetClass"]("UCF_Event"))(
				(this["oHelpButton"] && this["oHelpButton"]["E_EVENTS"]["Press"]) || 0, { "sConnectedControlId": this["sId"], "bIsOnUpperHalf": false }
			);
		} else if (UCF_KeyboardHelper["bIsEventForKey"](
				oBrowserEvent,
				UCF_KeyCodes["ARROW_UP"],
				'A'
			)) {
			oEvent = new (UCF_ClassLoader["oGetClass"]("UCF_Event"))(
				(this["oHelpButton"] && this["oHelpButton"]["E_EVENTS"]["Press"]) || 0, { "sConnectedControlId": this["sId"], "bIsOnUpperHalf": true }
			);
		}
		this["onHelpButtonPress"](oEvent || oBrowserEvent);

		// already checked if it's only [F4] in surrounding `if`
		if (iKey === UCF_KeyCodes["F4"]) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))(
			'[ALT][UP] / [ALT][DOWN] / [F4] => fieldhelp opened'
		);
	}

	// toggle navigation mode for table input fields
	if (this["bUsedInSapTable"] &&
		UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["F2"])
	) {
		// ITS speciale, do not cancel the event if second time and within nav mode
		shouldCancelBubble = !this["oLS"]["bAlternativeKeyboardHandling"]
			|| this["oNavigation"]["bIsEditMode"]();
		this["refocus"]();

		if (shouldCancelBubble) {
			oBrowserEvent["cancelBubble"]();
		}

		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('[F2] in SapTable => navigation mode toggled');
	}

	if (this["oNavigation"]["bIsEditMode"]()) {
		// This IF is needed: see CSN 2140651 2011
		this["iCursorPos"] = UCF_DomUtil["oGetActiveElement"]() === this["oDomRef"]
			? UCF_DomUtil["iGetCursorPos"](this["oDomRef"])
			: -1;
	}

	/* 0000411745 2011:
	 * Error case: Open DatePicker click into InputField (without clicking in
	 * DatePicker). Enter a date and do roundtrip -> no change is fired because
	 * bNoBlur is still true. reset on keydown */
	this["bNoBlur"] = false;
	if (this["oDate"]) {
		this["handleDateKeydown"](oBrowserEvent);
	}

	this["bTabPressed"] = (iKey === UCF_KeyCodes["TAB"]);

	UCF_EditFieldBase.prototype["onBeforeKeydown"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeKeydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event that could be seen as a
 * request to open the field help
 * @return {boolean} `true` if in processing the event a field help could be
 * opened, otherwise `false`
 */
UCF_InputField["prototype"]["bIsFieldHelpOpenRequest"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsFieldHelpOpenRequest"]++; }; 
	switch (oBrowserEvent["sGetName"]()) {
		case 'keydown':
			return UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["F4"])
				|| UCF_KeyboardHelper["bIsEventForKey"](
					oBrowserEvent,
					UCF_KeyCodes["ARROW_DOWN"],
					'A'
				)
				|| UCF_KeyboardHelper["bIsEventForKey"](
					oBrowserEvent,
					UCF_KeyCodes["ARROW_UP"],
					'A'
				);
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsFieldHelpOpenRequest"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the keydown
 */
// eslint-disable-next-line complexity
UCF_InputField["prototype"]["handleDateKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["handleDateKeydown"]++; }; 
	/** @type {string} */
	var charovw;
	/** @type {number} */
	var i;
	/** @type {string} */
	var sCharAtCursor;

	if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["ARROW_DOWN"]
		)) {
		this["decrementDate"]();
		oBrowserEvent["cancelBubble"]();
	} else if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["ARROW_UP"]
		)) {
		this["incrementDate"]();
		oBrowserEvent["cancelBubble"]();
	} else {
		charovw = 'X';
		// eslint-disable-next-line no-magic-numbers
		for (i = 0; i < 10; i += 1) {
			if (UCF_KeyboardHelper["bIsEventForKey"](
					oBrowserEvent,
					UCF_KeyCodes['_' + i]
				) || UCF_KeyboardHelper["bIsEventForKey"](
				oBrowserEvent,
				UCF_KeyCodes['NUMPAD_' + i]
				)) {
				charovw = i;
				break;
			}
		}
		if (charovw !== 'X') {
			sCharAtCursor = this["sValue"]["charAt"](this["iCursorPos"]);
			if (sCharAtCursor <= '9' && sCharAtCursor >= '0') {
				// eslint-disable-next-line @ur/no-memory-leaks
				this["sValue"] = this["sValue"]["substring"](0, this["iCursorPos"])
					+ charovw
					+ this["sValue"]["substring"](this["iCursorPos"] + 1);

				if (this["oDate"]["parse"](this["sValue"], this["sGetFormatString"]())) {
					this["sValue"] = this["sGetCurrentValue"]();
				} else {
					this["iCursorPos"] += 1;
					this["setCurrentValue"](this["sValue"]);
					UCF_DomUtil["setCursorPos"](this["oFocusDomRef"], this["iCursorPos"]);
					this["fireSpin"](this["sId"], this["sValue"]);
				}

				// eslint-disable-next-line quotes
				this["setClientProperty"]("Value", this["sValue"], true);
			}
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["cancel"]();
		}
		if (
			UCF_KeyboardHelper["bIsEventForKey"](
				oBrowserEvent,
				UCF_KeyCodes["BACKSPACE"]
			) &&
			this["iCursorPos"] !== 0
		) {
			this["iCursorPos"] -= 1;
			UCF_DomUtil["setCursorPos"](this["oFocusDomRef"], this["iCursorPos"]);
		}
		if (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["END"])) {
			this["iCursorPos"] -= 1;
			UCF_DomUtil["setCursorPos"](this["oFocusDomRef"], this["iLength"]);
		}
		if (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["HOME"])) {
			this["iCursorPos"] -= 1;
			UCF_DomUtil["setCursorPos"](this["oFocusDomRef"], 0);
		}
	}
	if (!UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["TAB"]) &&
		!UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["TAB"], 's') &&
		!UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["ARROW_LEFT"]
		) &&
		!UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["ARROW_RIGHT"]
		) &&
		!UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["ESCAPE"])
	) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["handleDateKeydown"] = 0; };

/**
 * Handles the onkeyupevent
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the keyup
 */
UCF_InputField["prototype"]["onBeforeKeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeKeyup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InputField.js(699): onBeforeKeyup"); };

	this["handleEditEvents"](oBrowserEvent);

	if (this["sFieldHelp"] === 'CALCULATOR' && this["oFieldHelp"]) {
		this["oFieldHelp"]["setValue"](this["sGetCurrentValue"]());
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeKeyup"] = 0; };

/**
 * Handles the lsup event
 *
 * @override
 * @param {UCF_BrowserEvent} oBrowserEvent the lsup
 * @see #handleLsKeyUpDown(UCF_BrowserEvent,boolean)
 */
UCF_InputField["prototype"]["onAfterLsUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterLsUp"]++; }; 
	this["handleLsUpDownKeys"](oBrowserEvent, true);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterLsUp"] = 0; };

/**
 * Handles the lsdown event
 *
 * @override
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdown
 * @see #handleLsKeyUpDown(UCF_BrowserEvent,boolean)
 */
UCF_InputField["prototype"]["onAfterLsDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterLsDown"]++; }; 
	this["handleLsUpDownKeys"](oBrowserEvent, false);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterLsDown"] = 0; };

/**
 * Spins the spinner up/down based on `isIncrease` if possible.
 * Fires a change with reason=OTHER and cancels the `event` bubbling.
 *
 * @param {UCF_BrowserEvent} event the event to be handled
 * @param {boolean} bIsIncrease indicates if the spinner is spinned up or down
 */
UCF_InputField["prototype"]["handleLsUpDownKeys"] = function(event, bIsIncrease) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["handleLsUpDownKeys"]++; }; 
	this["setValueInternal"](this["iSpin"](!bIsIncrease));

	try {
		this["prepareFireChange"]();
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
	event["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["handleLsUpDownKeys"] = 0; };

/**
 * @private
 * @return {boolean} `true` if up/down should be handled
 */
UCF_InputField["prototype"]["bShouldHandleLsKeyUpDown"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldHandleLsKeyUpDown"]++; }; 
	return this["bShowHelpButton"]
		&& this["sFieldHelp"] === 'SPINNER'
		&& this["sType"] === 'INTEGER';
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldHandleLsKeyUpDown"] = 0; };

/** @override */
UCF_InputField["prototype"]["bShouldHandleLsUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldHandleLsUp"]++; }; 
	return this["bShouldHandleLsKeyUpDown"]() && UCF_EditFieldBase.prototype["bShouldHandleLsUp"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldHandleLsUp"] = 0; };

/** @override */
UCF_InputField["prototype"]["bShouldHandleLsDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldHandleLsDown"]++; }; 
	return this["bShouldHandleLsKeyUpDown"]() && UCF_EditFieldBase.prototype["bShouldHandleLsDown"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldHandleLsDown"] = 0; };

/** @override */
UCF_InputField["prototype"]["onBeforeLsExpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeLsExpand"]++; }; 
	if (!this["bIsWriteable"]()) {
		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('not writeable -> do not handle lsexpand');
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeLsExpand"] = 0; };

/** @override */
UCF_InputField["prototype"]["onBeforeLsCollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeLsCollapse"]++; }; 
	if (!this["bIsWriteable"]()) {
		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('not writeable -> do not handle lscollapse');
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeLsCollapse"] = 0; };

/** @override */
UCF_InputField["prototype"]["onAfterLsEnter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterLsEnter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InputField.js(785): onAfterLsEnter"); };

	try {
		this["prepareFireChange"](UCF_EditFieldBase["E_CHANGE_REASON"]["Enter"]);
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}

	if (this["bHasEventListeners"]('Enter')) {
		// avoid default button handling in case enter is fired
		this["bIgnoreDefaultButton"] = true;
		this["fireEnter"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterLsEnter"] = 0; };

/**
 * Handles internal datepicker close event from field help datepicker.
 * CSN 331072 2020: in IE11 the click may be processed before the blur event,
 * so in fields within a table with a floating help button a value change
 * may affect more than just the currently selected field
 * @private
 * @param {UCF_Event} oEvent the internal event
 */
UCF_InputField["prototype"]["onFieldHelpClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onFieldHelpClose"]++; }; 
	this["detachHelpButtonEvents"]();
	UCF_EditFieldBase.prototype["onFieldHelpClose"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onFieldHelpClose"] = 0; };

/**
 * Handles internal datepicker select event from field help datepicker.
 *
 * @private
 * @param {UCF_Event} oEvent the internal event
 */
UCF_InputField["prototype"]["onFieldHelpSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onFieldHelpSelect"]++; }; 
	// select -> close field help -> copy value to field-> focus field and select value
	this["closeFieldHelp"]();

	// CSN 331072 2020: in IE11 the click may be processed before the blur event,
	// so in fields within a table with a floating help button a value change
	// may affect more than just the currently selected field
	// CSN 396779 2020: in Chrome there might be a similar issue in older themes
	// like sap_corbu
	this["detachHelpButtonEvents"]();

	if (!this["bReadonly"]) {
		this["setValueInternal"](this["sGetValueFromSelect"](oEvent));
		try {
			this["prepareFireChange"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}

		if (!oEvent["mGetParameters"]()["bTouchInteraction"]) {
			this["oNavigation"]["keepEditMode"]();
			// in IE11 we may have focus borders on more than one field
			// in a SapTable if we don't focus() here
			if (UCF_UserAgent["bIsIE"]()) {
				this["focus"]();
			}
			this["select"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onFieldHelpSelect"] = 0; };

/**
 * @private
 * @param {UCF_Event} oEvent the select
 * @return {string}
 */
UCF_InputField["prototype"]["sGetValueFromSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetValueFromSelect"]++; }; 
	switch (this["sFieldHelp"]) {
		case 'CALENDAR':
			return oEvent["oGetParam"]('date')
				["sGetFormattedDate"](this["sGetFormatString"]());
		case 'CALCULATOR':
			return oEvent["oGetParam"]('value');
		case 'SPINNER':
			return oEvent["oGetParam"]('date')
				["sGetFormattedDate"](this["sGetFormatString"]());
		default:
			return '';
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetValueFromSelect"] = 0; };

/** @override */
UCF_InputField["prototype"]["detachFieldHelpEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["detachFieldHelpEvents"]++; }; 
	UCF_InputField["oPendingFieldHelp"] = null;
	if (this["oFieldHelp"]) {
		this["oFieldHelp"]["detachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Select"],
			this,
			'onFieldHelpSelect'
		);
		this["oFieldHelp"]["detachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Close"],
			this,
			'onFieldHelpClose'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["detachFieldHelpEvents"] = 0; };

/**
 * Attaches a suitable field help to the input field. Field helps available in
 * javascript are: CALENDAR
 *
 * @private
 */
UCF_InputField["prototype"]["attachFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachFieldHelp"]++; }; 
	switch (this["sFieldHelp"]) {
		case 'CALENDAR':
			UCF_ClassLoader["oGetClass"]('UCF_Date');
			if (UCF_Date["bFormatContainsTime"](this["sGetFormatString"]()))
				this["attachDatePickerSlider"]();
			else
				this["attachCalendar"]();
			break;
		case 'CALCULATOR':
			this["attachCalculator"]();
			break;
		default:
			this["attachInputAssistant"]();
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachFieldHelp"] = 0; };

/** @private */
UCF_InputField["prototype"]["attachInputAssistant"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachInputAssistant"]++; }; 
	// TODO: Raik Touch Screen
	if ((!this["oFieldHelp"] || !this["oFieldHelp"]["bOpen"]) &&
		this["oLS"]["fInputAssistantCallBack"]
	) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["oFieldHelp"] = this["oLS"]["oControlFactory"]["oGetControl"](
			'UCF_InputAssistant',
			'ls-InputAssistant'
		);
		this["oFieldHelp"]["setConnectedControl"](this);
		this["oFieldHelp"]["setValue"](this["sGetCurrentValue"]());
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Select"],
			this,
			'onFieldHelpSelect'
		);
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Close"],
			this,
			'onFieldHelpClose'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachInputAssistant"] = 0; };

/** @private */
UCF_InputField["prototype"]["attachCalculator"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachCalculator"]++; }; 
	this["oFieldHelp"] = this["oLS"]["oControlFactory"]["oGetControl"](
		'UCF_Calculator',
		'ls-calculator'
	);
	this["oFieldHelp"]["setConnectedControl"](this);
	this["oFieldHelp"]["setFormat"](this["sGetFormatString"]('Decimal'));
	this["oFieldHelp"]["setValue"](this["sGetCurrentValue"]());
	this["oFieldHelp"]["attachEvent"](
		this["oFieldHelp"]["E_EVENTS"]["Select"],
		this,
		'onFieldHelpSelect'
	);
	this["oFieldHelp"]["attachEvent"](
		this["oFieldHelp"]["E_EVENTS"]["Close"],
		this,
		'onFieldHelpClose'
	);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachCalculator"] = 0; };

/** @private */
UCF_InputField["prototype"]["attachCalendar"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachCalendar"]++; }; 
	/** @type {UCF_InputField} */
	var self = this;
	/** @type {UCF_Date} */
	var oSelectedDate;
	/** @type {UCF_Date} */
	var oStartDate;
	/** @type {UCF_InputField} */
	var oStartDateField;
	/** @type {boolean} */
	var bError;

	/**
	 * @param {UCF_Date} date the date to initialize
	 * @param {UCF_InputField} startDateField the control referenced by
	 * #sDatePickerStartRefId
	 */
	function initializeDate(date, startDateField) {
		date["setDate"](1);
		date["setMonth"](0);
		date["parse"](startDateField["sGetValue"](), self["sGetFormatString"]());
	}

	this["oFieldHelp"] = this["oLS"]["oControlFactory"]["oGetControl"](
		'UCF_DatePicker',
		'ls-datepicker'
	);
	this["oFieldHelp"]["setConnectedControl"](this);

	// initialize datepicker
	oSelectedDate = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
	if (window["UCF_System"]["sUTCOffset"] !== "") {
		var oTmpDate = new Date();
		oSelectedDate["setHours"](oTmpDate["getHours"]());
		oSelectedDate["setMinutes"](oTmpDate["getMinutes"]());
		oSelectedDate["setDateWithSystemUTCOffset"]();
	}
	oSelectedDate["setFormatString"](this["sGetFormatString"]());
	oStartDate = oSelectedDate["oGetClone"]();


	if (this["iFirstDayOfWeek"] > -1) {
		// eslint-disable-next-line no-magic-numbers
		oStartDate["setFirstDayOfWeek"](this["iFirstDayOfWeek"] % 7);
		// eslint-disable-next-line no-magic-numbers
		oSelectedDate["setFirstDayOfWeek"](this["iFirstDayOfWeek"] % 7);
	}
	bError = false;
	if (this["sGetValue"]()) {
		bError = oStartDate["parse"](this["sGetValue"](), this["sGetFormatString"]());
		if (!bError) {
			oSelectedDate["setDate"](1);
			oSelectedDate["setMonth"](0);
			oSelectedDate["setTime"](oStartDate["iGetTime"]());
		}
	} else if (this["sDatePickerStartRefId"]) {
		oStartDateField = this["oLS"]["oControlFactory"]["oGetControlById"](
			this["sDatePickerStartRefId"]
		);
		if (oStartDateField) {
			initializeDate(oStartDate, oStartDateField);
			initializeDate(oSelectedDate, oStartDateField);
		}
	}

	this["oFieldHelp"]["setSelectedDate"](oSelectedDate);
	this["oFieldHelp"]["setStartDate"](oStartDate);

	if (this["bReadonly"]) {
		this["oFieldHelp"]["setEnabled"](false);
	} else {
		this["oFieldHelp"]["setEnabled"](true);
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Select"],
			this,
			'onFieldHelpSelect'
		);
	}
	this["oFieldHelp"]["attachEvent"](
		this["oFieldHelp"]["E_EVENTS"]["Close"],
		this,
		'onFieldHelpClose'
	);

};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachCalendar"] = 0; };

/**
 * Handles a click on the field help button.
 *
 * @private
 * @param {UCF_Event} oEvent the internal event
 */
UCF_InputField["prototype"]["onBeforeHelpButtonPress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeHelpButtonPress"]++; }; 
	if (this["oPendingFieldHelp"]) {
		this["oPendingFieldHelp"]["oConnectedControl"]["closeFieldHelp"]();
		this["oPendingFieldHelp"] = null;
	}

	if (oEvent && oEvent instanceof UCF_BrowserEvent && oEvent["bRepeat"]()) {
		return;
	}

	if (this["bShowHelpButton"]) {
		// Handle 'spinner' button
		if (this["sFieldHelp"] === 'SPINNER') {
			//TODO: if (this.sType === 'INTEGER') {
				this["onSpinnerClick"](oEvent);
			//}
			// fire FieldHelpClick event if the field help is not implemented in js
		} else if (this["bIsServerSideFieldHelp"]()) {
			// close a soft keyboard
			if (this["bIsOpen"]()) {
				this["oFieldHelp"]["close"](true);
			}
			try {
				this["prepareFireChange"]();
			} catch (oException) {
				this["handleEarlyHandlerLeave"](oException);
			}
			if (UCF_DomUtil["oGetActiveElement"]() !== this["oFocusDomRef"]) {
				this["oFocusDomRef"]["focus"]();
			}
			// this.hideButton();
			this["updateStyles"]();
			this["emitFieldHelpPress"]();
		} else {
			// open clientside field help (calendar,...),
			// when the focus was outside the inputfield
			this["bNoBlur"] = true;
			if (this["bIsOpen"]()) {
				this["closeFieldHelp"]();
			} else {
				this["openFieldHelp"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeHelpButtonPress"] = 0; };

/** @override */
UCF_InputField["prototype"]["aGetFieldHelpPressArguments"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["aGetFieldHelpPressArguments"]++; }; 
	/** @type {UCF_InputField} */
	var self = this;

	return this["oCache"]["get"]('aFieldHelpPressArguments', function() {
		return [self["sId"], self["sFieldHelp"]];
	});
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["aGetFieldHelpPressArguments"] = 0; };

/**
 * @private
 * @return {boolean} `true` if the field help is filled server-side, otherwise
 * (i.e. 'CALENDAR'/'CALCULATOR'/...) `false`
 */
UCF_InputField["prototype"]["bIsServerSideFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsServerSideFieldHelp"]++; }; 
	return this["sFieldHelp"] === 'F4LOOKUP'
		|| this["sFieldHelp"] === 'FILTERFIELDS'
		|| this["sFieldHelp"] === 'DEFAULT'
		|| this["sFieldHelp"] === 'SEARCH';
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsServerSideFieldHelp"] = 0; };

/**
 * @private
 * @param {UCF_Event} oEvent the click from InputFieldHelpButton, or
 * undefined (if called via #onclick)
 */
UCF_InputField["prototype"]["onSpinnerClick"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onSpinnerClick"]++; }; 
	/** @type {boolean} */
	var bIsOnUpperHalf;

	if (this["bIsWriteable"]()) {
		bIsOnUpperHalf = oEvent instanceof UCF_BrowserEvent
			? undefined
			:	oEvent && oEvent["oGetParam"]('bIsOnUpperHalf');

		// Modify value
		if (this["sType"] === 'DATE') {
			if (typeof bIsOnUpperHalf !== 'boolean') {
				this["attachDatePickerSlider"]();
				this["attachFieldHelpEvents"]();
				this["oFieldHelp"]["open"]();
				return;
			} else if (this["iSpinnerIncrement"] > 0 && bIsOnUpperHalf) {
				this["incrementDate"]();
			} else {
				this["decrementDate"]();
			}
		} else if (typeof bIsOnUpperHalf === 'boolean') {
			this["setValueInternal"](this["iSpin"](!bIsOnUpperHalf));
		}

		this["updateStyles"]();

		try {
			this["prepareFireChange"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}

		/*
		 * Workaround for 'noblur': The 'noblur' handling used by DatePicker and
		 * Calculater does not work for the spinner. We must set the focus and
		 * reset the noblur flag after each HelpButton-click otherwise the
		 * InputField with a spinner will never get the focus back ...
		 */
		this["bNoBlur"] = false;
		UCF_DomUtil["focusDomElement"](this["oFocusDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onSpinnerClick"] = 0; };

/**
 * @override
 * @param {boolean} [bImmediate=false]
 */
UCF_InputField["prototype"]["onBeforeOpenFieldHelp"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeOpenFieldHelp"]++; }; 
	if (
		this["sFieldHelp"] === 'CALENDAR' ||
		this["sFieldHelp"] === 'CALCULATOR' ||
		this["oLS"]["fInputAssistantCallBack"]
	) {
		this["attachFieldHelp"]();
		this["oFieldHelp"]["open"](bImmediate);
		if (this["oDataTip"] && !this["bIsOpen"]()) {
			this["oDataTip"]["close"]();
		}
		if (window["UCF_System"]["bIsAria"]) {
			UCF_AriaStateHelper["setExpanded"](this["oDomRef"], true);
		}
		this["controlPopupWindow"](function(popup) {
			popup["openLayeredControl"]();
		});
		UCF_InputField["oPendingFieldHelp"] = this["oFieldHelp"];
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onBeforeOpenFieldHelp"] = 0; };

/**
 * @override
 * @param {boolean} [bImmediate=false]
 */
UCF_InputField["prototype"]["onAfterCloseFieldHelp"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterCloseFieldHelp"]++; }; 
	if (this["bIsOpen"]()) {
		this["oFieldHelp"]["close"](bImmediate);
		this["controlPopupWindow"](function(popup) {
			popup["closeLayeredControl"]();
		});
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterCloseFieldHelp"] = 0; };

/**
 * calls `action` with the popup window associated with this inputfield if
 * possible
 *
 * @param {function(UCF_PopupWindow): void} action the action that should be
 * performed with the popup window
 */
UCF_InputField["prototype"]["controlPopupWindow"] = function(action) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["controlPopupWindow"]++; }; 
	var oPopupWindowDomRef;

	if (!this["oLS"]["bIsMainLS"]()) {
		oPopupWindowDomRef = UCF_DomUtil["oGetParentByAttribute"](
			this["oDomRef"],
			'ct',
			'PW'
		);
		if (oPopupWindowDomRef) {
			action(this["oGetControlByDomRef"](oPopupWindowDomRef, false));
		}
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["controlPopupWindow"] = 0; };

/**
 * Set the value of the InputField to `sValue`. This is
 * the public API for setting the value, the InputField
 * will assume the value is known to the server and not
 * send it back again in the next change event.
 *
 * @public
 * @param {string} sValue the value to set
 */
UCF_InputField["prototype"]["setValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setValue"]++; }; 
	this["setValueInternal"](sValue);
	this["sOldValue"] = sValue;
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setValue"] = 0; };

/**
 * CSN 1670531243: calling setValue() before prepareFireChange()
 * will never fire the change event, because it will only fire if
 * this.sValue != this.sOldValue and in setValue() *both* are
 * updated. The behavior of setValue() may not change as it is the
 * public API, and if the backend calls it, it makes perfectly sense
 * to update sOldValue as well. But internally we should never set
 * sOldValue unless we fired a change with that value. Therefore
 * we use this internal method instead.
 *
 * @private
 * @param {string} sValue the value to set
 */
UCF_InputField["prototype"]["setValueInternal"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setValueInternal"]++; }; 
	if (sValue !== '') {
		this["hideInputPrompt"]();
	} else if (!this["bHasFocus"]()) {
		this["showInputPrompt"]();
	}

	if (this["bUpperCase"]) {
		sValue["toUpperCase"]();
	}

	this["setCurrentValue"](sValue);

	this["sValue"] = sValue;
	// eslint-disable-next-line quotes
	this["setClientProperty"]("Value", this["sValue"], true);

	this["possiblyUpdateDate"]();
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setValueInternal"] = 0; };

/** @private */
UCF_InputField["prototype"]["possiblyUpdateDate"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["possiblyUpdateDate"]++; }; 
	if (this["sType"] === 'DATE' && this["sFieldHelp"] === 'SPINNER') {
		this["oDate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
		this["oDate"]["parse"](this["sValue"], this["sGetFormatString"]());
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["possiblyUpdateDate"] = 0; };

/**
 * Sets the tooltip of a inputField control
 *
 * @public
 * @param {string} sTooltip the new tooltip of the inputField
 */
UCF_InputField["prototype"]["setTooltip"] = function(sTooltip) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setTooltip"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTooltip) === 'string', "typeof(sTooltip) === 'string'", "InputField.js(1292): setTooltip"); };

	// Todo: refocus
	UCF_DomUtil["setTooltip"](this["oDomRef"], sTooltip);

	this["sTooltip"] = sTooltip;
	// eslint-disable-next-line quotes
	this["setClientProperty"]("Tooltip", sTooltip, true);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setTooltip"] = 0; };

/**
 * Sets the Align property of a inputField control
 *
 * @public
 * @param {string} sAlign the textAlign style property of the inputField
 * @param {string} sTextDirection the text direction
 */
UCF_InputField["prototype"]["setAlign"] = function(sAlign, sTextDirection) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setAlign"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sAlign === 'string', "typeof sAlign === 'string'", "InputField.js(1310): setAlign"); };

	UCF_DomUtil["setTextAlign"](this["oDomRef"], sAlign, sTextDirection);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sAlign"] = sAlign;
	// eslint-disable-next-line quotes
	this["setClientProperty"]("Align", sAlign, true);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setAlign"] = 0; };

/**
 * Returns the value of the FormatString
 *
 * @public
 * @param {string} sDataType optional To determine the type when no format is
 * defined by this.sType
 * @return {string} the format string
 */
UCF_InputField["prototype"]["sGetFormatString"] = function(sDataType) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetFormatString"]++; }; 
	if (this["sFormatString"]) {
		return this["sFormatString"];
	} else { // Get fallbacks
		if (!sDataType &&
			(this["sType"] === 'DATE' || this["sFieldHelp"] === 'CALENDAR')
		) {
			sDataType = 'Date';
		}

		return window["UCF_System"]["sGetDataTypeFormat"](sDataType);
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetFormatString"] = 0; };

/**
 * Returns the unformatted value
 *
 * @public
 * @return {string} the value string or in case of a date field the year,
 * month, day
 */

UCF_InputField["prototype"]["sGetUnformattedValue"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetUnformattedValue"]++; }; 
	if (this["sType"] === 'DATE') {
		return (
			this["oDate"]["sGetYear"]() +
			this["oDate"]["sGetMonth"]() +
			this["oDate"]["sGetDate"]()
		);
	} else {
		return this["sValue"];
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetUnformattedValue"] = 0; };

/**
 * Returns the value of the InputField
 *
 * @deprecated use method getValue
 * @public
 * @return {string} the corresponding value
 */
UCF_InputField["prototype"]["sGetValue"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetValue"]++; }; 
	var sValue = '';

	if (this["oDomRef"]["tagName"] === 'INPUT') {
		return this["bUpperCase"]
			? this["sGetCurrentValue"]()["toUpperCase"]()
			: this["sGetCurrentValue"]();
	} else {
		sValue = UCF_DomUtil["sGetInnerText"](this["oDomRef"]);
		if (!sValue) {
			sValue = '';
		}
		if (this["bUpperCase"]) {
			sValue = sValue["toUpperCase"]();
		}

		return sValue;
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetValue"] = 0; };

/**
 * Returns the value of the InputField
 *
 * @public
 * @return {string} actual value of this input field
 */
UCF_InputField["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["getValue"]++; }; 
	return this["sGetValue"]();
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["getValue"] = 0; };

/**
 * @private
 * @throws {UCF_Exception} if no event is fired, an exception is thrown
 */
UCF_InputField["prototype"]["onWillFireChange"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onWillFireChange"]++; }; 
	/** @type {string} */
	var sValue = this["sGetCurrentValue"]();

	if (
		UCF_InputField["oPendingFieldHelp"] &&
		UCF_InputField["oPendingFieldHelp"]["sClassName"] === 'UCF_InputAssistant'
	) {
		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('InputAssistant open => did not fire Change event');
	}

	if (this["bForceChange"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'forcing change event...', "InputField.js(1414): onWillFireChange"); };
	} else if (sValue === this["sOldValue"]) {
		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('value unchanged => did not fire Change event');
	}

	this["sOldValue"] = sValue;
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onWillFireChange"] = 0; };

/**
 * @private
 * @param {UCF_EditFieldBase_FireChangeEvent} oEvent
 */
UCF_InputField["prototype"]["onFireChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onFireChange"]++; }; 
	this["fireChange"](this["sId"], this["sGetCurrentValue"]());
	this["setPendingChange"](false);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onFireChange"] = 0; };

/** @private */
UCF_InputField["prototype"]["onDidFireChange"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onDidFireChange"]++; }; 
	// remember the value CSN 492713 2008
	this["sValue"] = this["sGetCurrentValue"]();
	// eslint-disable-next-line quotes
	this["setClientProperty"]("Value", this["sValue"], true);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onDidFireChange"] = 0; };

/**
 * @override
 * @param {UCF_EditFieldBase_ChangeReason} iReason
 * @return {boolean}
 */
UCF_InputField["prototype"]["bShouldFireValidate"] = function(iReason) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldFireValidate"]++; }; 
	return this["sValidationTrigger"] === 'STANDARD' || (
		this["sValidationTrigger"] === 'TAB' &&
		iReason === UCF_EditFieldBase["E_CHANGE_REASON"]["BlurByTab"]
	);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bShouldFireValidate"] = 0; };

/**
 * Handles the ValidationTrigger=TAB; this is needed because old scanners
 * (Manufacturing Execution) fires a tab character to confirm the input.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstabnext
 */
UCF_InputField["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onlstabnext"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InputField.js(1459): onlstabnext"); };

	if (this["sValidationTrigger"] === 'TAB') {
		try {
			this["prepareFireChange"](UCF_EditFieldBase["E_CHANGE_REASON"]["BlurByTab"]);
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
	}

	this["emitTabOut"]();
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onlstabnext"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lstabprevious
 */
UCF_InputField["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onlstabprevious"]++; }; 
	this["emitTabOut"]();
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onlstabprevious"] = 0; };

/** @private */
UCF_InputField["prototype"]["emitTabOut"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["emitTabOut"]++; }; 
	if (this["bHasEventListeners"]('TabOut')) {
		try {
			this["prepareFireChange"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
	}

	this["fireTabOut"](this["sId"], this["sGetCurrentValue"]());
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["emitTabOut"] = 0; };

/**
 * @override
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey
 */
UCF_InputField["prototype"]["handleExternalHotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["handleExternalHotkey"]++; }; 
	try {
		this["prepareFireChange"]();
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["handleExternalHotkey"] = 0; };

/**
 * @override
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey
 * @return {boolean} `true` if the hotkey is handled locally, otherwise `false`
 */
UCF_InputField["prototype"]["bIsHotkeyHandledLocally"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsHotkeyHandledLocally"]++; }; 
	return UCF_EditFieldBase.prototype["bIsHotkeyHandledLocally"]["call"](this, oBrowserEvent)
		|| (this["bShowHelpButton"] &&
			UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["F4"])
		);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bIsHotkeyHandledLocally"] = 0; };

/**
 * @private
 * @param {UCF_AccessibilityHelper} oAccessibilityHelper the accessibility
 * helper
 * @see UCF_AccessibilityHelper
 */
UCF_InputField["prototype"]["applyAccSemantic"] = function(oAccessibilityHelper) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["applyAccSemantic"]++; }; 
	if (this["sSemanticColor"] !== 'NONE') {
		oAccessibilityHelper["addSemantic"](this["sSemanticColor"]);
	}
	if (this["sTextStyle"] !== 'NORMAL' && this["sTextStyle"] !== '') {
		oAccessibilityHelper["addSemantic"](this["sTextStyle"]);
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["applyAccSemantic"] = 0; };

/**
 * Returns caption text
 *
 * @private
 * @return {string} the actual value of this input field
 */
UCF_InputField["prototype"]["sGetText"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetText"]++; }; 
	return this["sValue"];
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetText"] = 0; };

/**
 * @private
 * @return {string} the associated display text
 * @see UCF_Control
 */
UCF_InputField["prototype"]["sGetDisplayedText"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetDisplayedText"]++; }; 
	return this["sGetText"]();
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetDisplayedText"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element
 * within the control gets the focus.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_InputField["prototype"]["onAfterLsAccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterLsAccessibility"]++; }; 
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	/** @type {string} */
	var sValue = this["sGetValue"]();

	oAccessibilityHelper["applyLabelingInfo"](
		this,
		'',
		// ToolbarInputfield has its own label rendering -> provide this label text
		// which is stored in an attribute as local label
		this["sLabelText"] || this["oRootRef"]["getAttribute"]('sLabelText'),
		this["sInputPrompt"]
	);
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

	// value
	if (!this["oPasswordDelegate"]) {
		if (sValue === '') {
			oAccessibilityHelper["setEmpty"](true);
		} else {
			oAccessibilityHelper["setText"](sValue);
		}
	}

	oAccessibilityHelper["setControlType"]('I');

	// tutor text for input fields with value help
	oAccessibilityHelper["addEnabledTutor"](
		this["sGetTutor"](this["sFieldHelp"]),
		this["bIsWriteable"]() && this["bShowHelpButton"]
	);

	this["applyAccSemantic"](oAccessibilityHelper);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterLsAccessibility"] = 0; };

/**
 * @param {string} sFieldHelp the fieldhelp that's mapping
 * to a tutor string should be retrieved
 * @return {string} the tutor mapped to {{sFieldHelp}}
 * @private
 */
UCF_InputField["prototype"]["sGetTutor"] = function(sFieldHelp) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetTutor"]++; }; 
	switch (sFieldHelp) {
		case 'SEARCH':
			return 'CB_SEARCH_TUT';
		case 'SPINNER':
			return 'I_SPINNER_TUT';
		default:
			return 'I_F4_TUT';
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["sGetTutor"] = 0; };

/**
 * Set changed flag. If the changed flag is set a change event is fired
 * regardless if the value has changed.
 *
 * @public
 */
UCF_InputField["prototype"]["setChanged"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setChanged"]++; }; 
	this["bForceChange"] = true;
	this["sOldValue"] = '';
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setChanged"] = 0; };

/**
 * Callback for setting the delay for events to the server if they are
 * configured as delayed
 *
 * @see {@link UCF_EventHandler#finishSemanticEvent}
 * @protected
 * @return {number} in ms
 */
UCF_InputField["getEventDelay"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["getEventDelay"]++; }; 
	return 300; // eslint-disable-line no-magic-numbers
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["getEventDelay"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 * @return {HTMLElement} #oDomRef
 */
UCF_InputField["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oGetInplaceEditDomRef"]++; }; 
	return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oGetInplaceEditDomRef"] = 0; };

// ===== Spinner ==============================================================

/**
 * Get the actual spinner value
 *
 * @private
 * @param {boolean} bDown `true` to spin down, otherwise spin up
 * @return {number} spinner value
 */
UCF_InputField["prototype"]["iSpin"] = function(bDown) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["iSpin"]++; }; 
	/** @type {string} */
	var sVal = this["getValue"]();
	/** @type {number} */
	var iOldValue = parseInt(sVal, 10);
	/** @type {number} */
	var iNewValue;
	/** @type {number} */
	var iIncrement = (bDown ? -1 : 1) * this["iSpinnerIncrement"];

	if (isNaN(iOldValue)) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Error parsing integer value: ' + this["getValue"](), "InputField.js(1664): iSpin"); };

		return sVal;
	}

	iNewValue = iOldValue + iIncrement;
	if (this["bSpinnerBoundsCheck"]) {
		if ((iNewValue <= this["iSpinnerMax"] && iNewValue >= this["iSpinnerMin"])
			|| (iOldValue >= this["iSpinnerMax"] && iIncrement < 0)
			|| (iOldValue <= this["iSpinnerMin"] && iIncrement > 0)) {
			return iNewValue;
		} else {
			return iOldValue;
		}
	} else {
		return iNewValue;
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["iSpin"] = 0; };

// ===== Performance: Render Fake Input Field =================================

/**
 * @private
 * @return {Object} A client access object
 */
UCF_InputField["prototype"]["oGetClientAccessObject"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oGetClientAccessObject"]++; }; 
	return {
		"Id": this["sId"],
		"Name": this["sName"],
		"Tooltip": this["sTooltip"],
		"Value": this["sGetCurrentValue"](),
		"Length": this["iLength"],
		"MaxLength": this["iMaxLength"],
		"Invalid": this["bInvalid"],
		"Required": this["bRequired"],
		"Enabled": this["bEnabled"],
		"Readonly": this["bReadonly"],
		"ShowHelpButton": this["bShowHelpButton"],
		"PasswordField": this["bPasswordField"],
		"Size": this["sSize"],
		"Type": this["sType"],
		"FieldHelp": this["sFieldHelp"],
		"Hidden": this["bHidden"],
		"Width": this["sWidth"],
		"Align": this["sAlign"],
		"TextDirection": this["sTextDirection"],
		"Visibility": this["sVisibility"],
		"LabelText": this["sLabelText"],
		"HideFieldHelp": this["bHideFieldHelp"],
		"ContainerWidthSet": this["bContainerWidthSet"],
		"IMEMode": this["sIMEMode"],
		"UsedInSapTable": this["bUsedInSapTable"],
		"PaddingInSapTable": this["sPaddingInSapTable"],
		"AutoComplete": this["bAutoComplete"],
		"InputState": this["sInputState"],
		"FormatString": this["sFormatString"],
		"ShowHelpButtonAlways": this["bShowHelpButtonAlways"],
		"DatePickerStartRefId": this["sDatePickerStartRefId"],
		"AccessKey": this["sAccessKey"],
		"Design": this["sDesign"],
		"ShowRequiredIndicator": this["bShowRequiredIndicator"],
		"DisplayAsText": this["bDisplayAsText"],
		"InputPrompt": this["sInputPrompt"],
		"TextStyle": this["sTextStyle"],
		"SpinnerIncrement": this["iSpinnerIncrement"],
		"SpinnerBoundsCheck": this["bSpinnerBoundsCheck"],
		"SpinnerMax": this["iSpinnerMax"],
		"SpinnerMin": this["iSpinnerMin"],
		"TextOverflowEllipsis": this["bTextOverflowEllipsis"],
		"SapTableFieldDesign": this["sSapTableFieldDesign"],
		"ValidationTrigger": this["sValidationTrigger"],
		"UpperCase": this["bUpperCase"],
		"TabBehaviour": this["sTabBehaviour"],
		"SemanticColor": this["sSemanticColor"],
		"EmbeddingBehaviour": this["sEmbeddingBehaviour"],
		"UsedInToolbar": this["bUsedInToolbar"],
		"FieldHelpFloating": this["bFieldHelpFloating"],
		"AutoCorrect": this["bAutoCorrect"],
		"FirstDayOfWeek": this["iFirstDayOfWeek"],
		"CustomData": typeof this["sCustomData"] === 'string'
			? this["sCustomData"]
			: UCF_JsUtil["sJsonStringify"](this["sCustomData"]) || '',
		"CustomStyle": this["sCustomStyle"],
		"FieldHelpEmbedding": this["bFieldHelpEmbedding"],
		"Height": this["sHeight"],
		"LabelledBy": this["sLabelledBy"],
		"ShowClearButton": this["bShowClearButton"],
		"Hint": this["sHint"],
		"DescribedBy": this["sDescribedBy"]
	};
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oGetClientAccessObject"] = 0; };

/** @override */
UCF_InputField["prototype"]["onAfterImportValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterImportValue"]++; }; 
	this["setValueInternal"](sValue);
	try {
		this["prepareFireChange"]();
	} catch (e) {
		this["handleEarlyHandlerLeave"](e);
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onAfterImportValue"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_InputField["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
		}
	}

	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["bPrepareAria"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent lstouchstart
 */
UCF_InputField["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onlstouchstart"]++; }; 
	if (this["sType"] === 'DATE' && this["sFieldHelp"] === 'SPINNER') {
		this["attachDatePickerSlider"]();
		this["attachFieldHelpEvents"]();
		this["oFieldHelp"]["open"](false);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onlstouchstart"] = 0; };

UCF_InputField["prototype"]["attachDatePickerSlider"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachDatePickerSlider"]++; }; 
	/** @type {UCF_InputField} */
	var self = this;
	/** @type {UCF_Date} */
	var oSelectedDate;
	/** @type {UCF_Date} */
	var oStartDate;
	/** @type {UCF_InputField} */
	var oStartDateField;
	/** @type {boolean} */
	var bError;

	/**
	 * @param {UCF_Date} date the date to initialize
	 * @param {UCF_InputField} startDateField the control referenced by
	 * #sDatePickerStartRefId
	 */
	function initializeDate(date, startDateField) {
		date["setDate"](1);
		date["setMonth"](0);
		date["parse"](startDateField["sGetValue"](), self["sGetFormatString"]());
	}

	this["oFieldHelp"] = this["oLS"]["oControlFactory"]["oGetControl"](
		'UCF_DatePickerSlider',
		'ls-datepickerslider'
	);
	this["oFieldHelp"]["setConnectedControl"](this);

	this["oFieldHelp"]["setFormatString"](this["sGetFormatString"]());

	// initialize datepicker
	oSelectedDate = new (UCF_ClassLoader["oGetClass"]("UCF_Date"))();
	if (window["UCF_System"]["sUTCOffset"] !== "") {
		var oTmpDate = new Date();
		oSelectedDate["setHours"](oTmpDate["getHours"]());
		oSelectedDate["setMinutes"](oTmpDate["getMinutes"]());
		oSelectedDate["setDateWithSystemUTCOffset"]();
	}
	oStartDate = oSelectedDate["oGetClone"]();

	oSelectedDate["setFormatString"](this["sGetFormatString"]());
	oStartDate["setFormatString"](this["sGetFormatString"]());
	if (this["iFirstDayOfWeek"] > -1) {
		// eslint-disable-next-line no-magic-numbers
		oStartDate["setFirstDayOfWeek"](this["iFirstDayOfWeek"] % 7);
		// eslint-disable-next-line no-magic-numbers
		oSelectedDate["setFirstDayOfWeek"](this["iFirstDayOfWeek"] % 7);
	}
	bError = false;
	if (this["sGetValue"]()) {
		bError = oStartDate["parse"](this["sGetValue"](), this["sGetFormatString"]());
		if (!bError) {
			oSelectedDate["setDate"](1);
			oSelectedDate["setMonth"](0);
			oSelectedDate["setTime"](oStartDate["iGetTime"]());
		}
	} else if (this["sDatePickerStartRefId"]) {
		oStartDateField = this["oLS"]["oControlFactory"]["oGetControlById"](
			this["sDatePickerStartRefId"]
		);
		if (oStartDateField) {
			initializeDate(oStartDate, oStartDateField);
			initializeDate(oSelectedDate, oStartDateField);
		}
	}

	this["oFieldHelp"]["setSelectedDate"](oSelectedDate);
	this["oFieldHelp"]["setStartDate"](oStartDate);

	if (this["bReadonly"]) {
		this["oFieldHelp"]["setEnabled"](false);
	} else {
		this["oFieldHelp"]["setEnabled"](true);
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Select"],
			this,
			'onFieldHelpSelect'
		);
	}
	this["oFieldHelp"]["attachEvent"](
		this["oFieldHelp"]["E_EVENTS"]["Close"],
		this,
		'onFieldHelpClose'
	);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachDatePickerSlider"] = 0; };

UCF_InputField["prototype"]["attachFieldHelpEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachFieldHelpEvents"]++; }; 
	this["oFieldHelp"]["attachEvent"](
		this["oFieldHelp"]["E_EVENTS"]["Close"],
		this,
		'onFieldHelpClose'
	);
	if (this["sFieldHelp"] !== 'CALENDAR' || !this["bReadonly"]) {
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Select"],
			this,
			'onFieldHelpSelect'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["attachFieldHelpEvents"] = 0; };

/**
 * @private
 * @override
 */
UCF_InputField["prototype"]["onWillDestroyInputField"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onWillDestroyInputField"]++; }; 
	this["detachBrowserEvent"]('blur', this["oDomRef"]);

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	this["oDate"] = null;
	this["oPasswordDelegate"] = null;

	this["sOldValue"] = null;
	this["sEscapeValue"] = null;
	this["sValue"] = null; // eslint-disable-line @ur/no-missing-setClientProperty
	this["sAlign"] = null;

	this["bTabPressed"] = null;
	this["bSelected"] = null;
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["onWillDestroyInputField"] = 0; };

/**
 * Returns the Rectangle used for Help
 *
 * @private
 * @return {DOMRect}
 */
UCF_InputField["prototype"]["oGetClientRectForHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oGetClientRectForHelp"]++; }; 
	var oDomRect = this["oDomRef"]["getBoundingClientRect"]();
	if (this["bShowHelpButton"] && !this["bHideFieldHelp"]){
		if (window["UCF_System"]["bIsRTL"]) {
			oDomRect["x"] = oDomRect["left"] - oDomRect["height"];
		} else {
			oDomRect["right"] = oDomRect["right"] + oDomRect["height"];
		}
		oDomRect["width"] = oDomRect["width"] + oDomRect["height"];
	}
	return oDomRect;
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["oGetClientRectForHelp"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_InputField["prototype"]["aAttributeNames"] = ["sValue","bShowHelpButton","sType","sWidth","sVisibility","sLabelText","bHideFieldHelp","bContainerWidthSet","sIMEMode","bAutoComplete","sFormatString","bShowHelpButtonAlways","sDatePickerStartRefId","sAccessKey","bDisplayAsText","sTextStyle","iSpinnerIncrement","bSpinnerBoundsCheck","iSpinnerMax","iSpinnerMin","sSapTableFieldDesign","sValidationTrigger","sTabBehaviour","sSemanticColor","sEmbeddingBehaviour","bFieldHelpFloating","iFirstDayOfWeek","sCustomData","sCustomStyle","bFieldHelpEmbedding","sHeight","sLabelledBy","sDescribedBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_InputField["prototype"]["aEventNames"] = ["Change","FieldHelpPress","Enter","Validate","DoubleClick","Activate","ClipboardTablePaste","Spin","TabOut"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_InputField["prototype"]["aMethodNames"] = ["sGetValue","setChanged","setInputState","setCursorPosition","setSelection","iGetSelectionStart","iGetSelectionEnd","getValue","setValue","setEnabled","getEnabled","setEditable","getEditable","setRequired","getRequired","setValueState","getValueState","sGetFormatString","sGetUnformattedValue","createDataTip","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_InputField["prototype"]["sValue"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_InputField["prototype"]["bShowHelpButton"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputFieldType}
 */
UCF_InputField["prototype"]["sType"] = "STRING";

/**
 * @private
 * @type {string}
 */
UCF_InputField["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_InputField["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_InputField["prototype"]["sLabelText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_InputField["prototype"]["bHideFieldHelp"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_InputField["prototype"]["bContainerWidthSet"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.IMEMode}
 */
UCF_InputField["prototype"]["sIMEMode"] = "AUTO";

/**
 * @private
 * @type {boolean}
 */
UCF_InputField["prototype"]["bAutoComplete"] = false;

/**
 * @private
 * @type {string}
 */
UCF_InputField["prototype"]["sFormatString"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_InputField["prototype"]["bShowHelpButtonAlways"] = false;

/**
 * @private
 * @type {string}
 */
UCF_InputField["prototype"]["sDatePickerStartRefId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_InputField["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_InputField["prototype"]["bDisplayAsText"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputFieldTextStyle}
 */
UCF_InputField["prototype"]["sTextStyle"] = "NORMAL";

/**
 * @private
 * @type {number}
 */
UCF_InputField["prototype"]["iSpinnerIncrement"] = 1;

/**
 * @private
 * @type {boolean}
 */
UCF_InputField["prototype"]["bSpinnerBoundsCheck"] = false;

/**
 * @private
 * @type {number}
 */
UCF_InputField["prototype"]["iSpinnerMax"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_InputField["prototype"]["iSpinnerMin"] = 0;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TableFieldDesign}
 */
UCF_InputField["prototype"]["sSapTableFieldDesign"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ValidationTrigger}
 */
UCF_InputField["prototype"]["sValidationTrigger"] = "STANDARD";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TabBehaviour}
 */
UCF_InputField["prototype"]["sTabBehaviour"] = "STANDARD";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_InputField["prototype"]["sSemanticColor"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.EmbeddingBehaviour}
 */
UCF_InputField["prototype"]["sEmbeddingBehaviour"] = "COMPATIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_InputField["prototype"]["bFieldHelpFloating"] = true;

/**
 * @private
 * @type {number}
 */
UCF_InputField["prototype"]["iFirstDayOfWeek"] = -1;

/**
 * @private
 * @type {string}
 */
UCF_InputField["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_InputField["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_InputField["prototype"]["bFieldHelpEmbedding"] = false;

/**
 * @private
 * @type {string}
 */
UCF_InputField["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_InputField["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {string}
 */
UCF_InputField["prototype"]["sDescribedBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_InputField["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setDefaultValues"]++; }; 
	this["sValue"] = '';
	this["bShowHelpButton"] = false;
	this["sType"] = "STRING";
	this["sWidth"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sLabelText"] = '';
	this["bHideFieldHelp"] = false;
	this["bContainerWidthSet"] = false;
	this["sIMEMode"] = "AUTO";
	this["bAutoComplete"] = false;
	this["sFormatString"] = '';
	this["bShowHelpButtonAlways"] = false;
	this["sDatePickerStartRefId"] = '';
	this["sAccessKey"] = '';
	this["bDisplayAsText"] = false;
	this["sTextStyle"] = "NORMAL";
	this["iSpinnerIncrement"] = 1;
	this["bSpinnerBoundsCheck"] = false;
	this["iSpinnerMax"] = 0;
	this["iSpinnerMin"] = 0;
	this["sSapTableFieldDesign"] = "NONE";
	this["sValidationTrigger"] = "STANDARD";
	this["sTabBehaviour"] = "STANDARD";
	this["sSemanticColor"] = "NONE";
	this["sEmbeddingBehaviour"] = "COMPATIBLE";
	this["bFieldHelpFloating"] = true;
	this["iFirstDayOfWeek"] = -1;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["bFieldHelpEmbedding"] = false;
	this["sHeight"] = '';
	this["sLabelledBy"] = '';
	this["sDescribedBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Value", '', true);
		this["setClientProperty"]("ShowHelpButton", false, true);
		this["setClientProperty"]("Type", "STRING", true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("LabelText", '', true);
		this["setClientProperty"]("HideFieldHelp", false, true);
		this["setClientProperty"]("ContainerWidthSet", false, true);
		this["setClientProperty"]("IMEMode", "AUTO", true);
		this["setClientProperty"]("AutoComplete", false, true);
		this["setClientProperty"]("FormatString", '', true);
		this["setClientProperty"]("ShowHelpButtonAlways", false, true);
		this["setClientProperty"]("DatePickerStartRefId", '', true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("DisplayAsText", false, true);
		this["setClientProperty"]("TextStyle", "NORMAL", true);
		this["setClientProperty"]("SpinnerIncrement", 1, true);
		this["setClientProperty"]("SpinnerBoundsCheck", false, true);
		this["setClientProperty"]("SpinnerMax", 0, true);
		this["setClientProperty"]("SpinnerMin", 0, true);
		this["setClientProperty"]("SapTableFieldDesign", "NONE", true);
		this["setClientProperty"]("ValidationTrigger", "STANDARD", true);
		this["setClientProperty"]("TabBehaviour", "STANDARD", true);
		this["setClientProperty"]("SemanticColor", "NONE", true);
		this["setClientProperty"]("EmbeddingBehaviour", "COMPATIBLE", true);
		this["setClientProperty"]("FieldHelpFloating", true, true);
		this["setClientProperty"]("FirstDayOfWeek", -1, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("FieldHelpEmbedding", false, true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("DescribedBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue New value after the change
 * @fires InputField::Change
 */
UCF_InputField["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InputField.js(2249): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputField.js(2250): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputField.js(2251): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "InputField.js(2252): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "InputField.js(2253): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("InputField", "Change", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.InputFieldFieldHelp} sFieldHelp Type of the field help. For the parameter values see enumeration 'InputFieldFieldHelp'.
 * @fires InputField::FieldHelpPress
 */
UCF_InputField["prototype"]["fireFieldHelpPress"] = function(sId, sFieldHelp) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireFieldHelpPress"]++; }; 
	/** @type {{Id: string, FieldHelp: UCF_ClientInterfaces.E.InputFieldFieldHelp}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InputField.js(2273): fireFieldHelpPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputField.js(2274): fireFieldHelpPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputField.js(2275): fireFieldHelpPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFieldHelp != null, "sFieldHelp != null", "InputField.js(2276): fireFieldHelpPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFieldHelp) == "string", "typeof(sFieldHelp) == \"string\"", "InputField.js(2277): fireFieldHelpPress"); };
	mParams = {
		"Id": sId,
		"FieldHelp": sFieldHelp
	};
	
	
	this["fireSemanticEvent"]("InputField", "FieldHelpPress", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireFieldHelpPress"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires InputField::Enter
 */
UCF_InputField["prototype"]["fireEnter"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireEnter"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "InputField.js(2296): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputField.js(2297): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputField.js(2298): fireEnter"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("InputField", "Enter", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireEnter"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue New value that should be validated
 * @fires InputField::Validate
 */
UCF_InputField["prototype"]["fireValidate"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireValidate"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InputField.js(2316): fireValidate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputField.js(2317): fireValidate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputField.js(2318): fireValidate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "InputField.js(2319): fireValidate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "InputField.js(2320): fireValidate"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("InputField", "Validate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireValidate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires InputField::DoubleClick
 */
UCF_InputField["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "InputField.js(2339): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputField.js(2340): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputField.js(2341): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("InputField", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires InputField::Activate
 */
UCF_InputField["prototype"]["fireActivate"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireActivate"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "InputField.js(2358): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputField.js(2359): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputField.js(2360): fireActivate"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("InputField", "Activate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireActivate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue The clipboard contents.
 * @fires InputField::ClipboardTablePaste
 */
UCF_InputField["prototype"]["fireClipboardTablePaste"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireClipboardTablePaste"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InputField.js(2378): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputField.js(2379): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputField.js(2380): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "InputField.js(2381): fireClipboardTablePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "InputField.js(2382): fireClipboardTablePaste"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("InputField", "ClipboardTablePaste", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireClipboardTablePaste"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue New Value.
 * @fires InputField::Spin
 */
UCF_InputField["prototype"]["fireSpin"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireSpin"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InputField.js(2402): fireSpin"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputField.js(2403): fireSpin"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputField.js(2404): fireSpin"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "InputField.js(2405): fireSpin"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "InputField.js(2406): fireSpin"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("InputField", "Spin", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireSpin"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue New Value.
 * @fires InputField::TabOut
 */
UCF_InputField["prototype"]["fireTabOut"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireTabOut"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InputField.js(2426): fireTabOut"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputField.js(2427): fireTabOut"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputField.js(2428): fireTabOut"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "InputField.js(2429): fireTabOut"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "InputField.js(2430): fireTabOut"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("InputField", "TabOut", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InputField["_"]["fireTabOut"] = 0; };

UCF_InputField.prototype["aPublicMethods"] = ["setValue","setTooltip","setAlign","sGetFormatString","sGetValue","getValue","setChanged"].concat(UCF_InputField.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_InputFieldHelpButton"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ColorUtil */
/// <reference path="../../core/util/ColorUtil.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/** @typedef {number} UCF_InputFieldHelpButton_Usage */
/** @typedef {Object<string,string|UCF_InputFieldHelpButton_StyleValue>} UCF_InputFieldHelpButton_Style */
/**
 * @typedef {Object} UCF_InputFieldHelpButton_StyleValue
 * @property {string} sValue
 * @property {boolean} [bImportant=false]
 */

// #region Control Lifecycle ==================================================
// #region   constructor ------------------------------------------------------
/**
 * @constructor
 * @param {HTMLElement} oDomRef the DOM element of the help button
 * @param {UCF_LS} oLS the LightSpeed instance managing the control
 * @param {string} sId identifier of the button
 * @extends UCF_Control
 */
function UCF_InputFieldHelpButton(oDomRef, oLS, sId) {if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["UCF_InputFieldHelpButton"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Control["apply"](this, [oDomRef, oLS, sId]);

		this["defineEvents"]([
			'Press', // keep at index 0, InputField fakes the event
			'Mousedown',
			'Mouseup',
			'Mouseover',
			'Mouseout',
			'Connect',
			'Disconnect'
		]);

		/** @type {UCF_EditFieldBase} */
		this["oConnectedControl"] = null;
		/** @type {HTMLElement} */
		this["oPositionContainer"] = null;
		/** @type {boolean} if we show this within our inputField... */
		this["bRootWidthAdapted"] = false;
		/** @type {number} */
		this["iRootWidth"] = '';
		/** @type {boolean} */
		this["bIsAnyEventListenerAttached"] = false;
		/** @type {UCF_InputFieldHelpButton_Usage} */
		this["eUsage"] = UCF_InputFieldHelpButton["E_USAGES"]["Disconnected"];

		this["connectToDom"](this["oRenderAt"](this["oLS"]["oGetAssociatedAreaRef"]()));
	}
};window["UCF_InputFieldHelpButton"] = UCF_InputFieldHelpButton; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_InputFieldHelpButton"); UCF_InputFieldHelpButton["_"] = {UCF_InputFieldHelpButton: 0}; }; ;
UCF_InputFieldHelpButton["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_InputFieldHelpButton.prototype["sClassName"] = "UCF_InputFieldHelpButton";
// #endregion -----------------------------------------------------------------
// #region   E_USAGES ---------------------------------------------------------
/**
 * @private
 * @const
 * @enum {UCF_InputFieldHelpButton_Usage}
 */
UCF_InputFieldHelpButton["E_USAGES"] = {
	"Standalone": 0,
	"SapTable": 1,
	"SapTableCS": 2,
	"Disconnected": 3,
	"DataGrid": 4,
	"SapTableAtControl": 5,
	"SapTableCSAtControl": 6
};
// #endregion -----------------------------------------------------------------
// #region   oRenderAt --------------------------------------------------------
/**
 * @private
 * @param {HTMLElement} oParentRef the element to render the help button inside
 * @return {HTMLSpanElement}
 */
UCF_InputFieldHelpButton["prototype"]["oRenderAt"] = function(oParentRef) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["oRenderAt"]++; }; 
	/** @type {HTMLSpanElement} */
	var oDomRef = document["createElement"]('span');

	oDomRef["setAttribute"]('id', this["sId"]);
	oDomRef["setAttribute"]('ct', 'IB');
	UCF_DomUtil["setTabIndex"](oDomRef, -1);
	UCF_InputFieldHelpButton["placeAt"](oDomRef, '25px', '-5000px');

	oParentRef["appendChild"](oDomRef);

	return oDomRef;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["oRenderAt"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   destroy ----------------------------------------------------------
/** @override */
UCF_InputFieldHelpButton["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["destroy"]++; }; 
	this["disconnect"]();

	this["oPositionContainer"] = null;
	this["oConnectedControl"] = null;
	this["eUsage"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["destroy"] = 0; };
// #endregion -----------------------------------------------------------------
// #endregion =================================================================
// #region Utilities ==========================================================
// #region   oGetConnectedRef -------------------------------------------------
/**
 * @private
 * @static
 * @param {UCF_Control} oControl the connected control
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the current usage of the
 * help button
 * @return {HTMLElement}
 */
UCF_InputFieldHelpButton["oGetConnectedRef"] = function(oControl, eUsage) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["oGetConnectedRef"]++; }; 
	switch (eUsage) {
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTable"]:
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"]:
			return UCF_DomUtil["oGetParentByTagName"](oControl["oRootRef"], 'TD');
		default:
			return oControl["oRootRef"];
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["oGetConnectedRef"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   bHasFocus --------------------------------------------------------
/** @return {boolean} */
UCF_InputFieldHelpButton["prototype"]["bHasFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bHasFocus"]++; }; 
	return UCF_DomUtil["oGetActiveElement"]() === this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bHasFocus"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   bIsConnected -----------------------------------------------------
/**
 * Checks if the button is connected to the passed control
 *
 * @protected
 * @param {UCF_EditFieldBase} oConnectedControl the control to check if the
 * button is connected to it
 * @return {boolean} `true` if `oConnectedControl` is the connected control,
 * otherwise `false`
 */
UCF_InputFieldHelpButton["prototype"]["bIsConnected"] = function(oConnectedControl) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bIsConnected"]++; }; 
	return (oConnectedControl === this["oConnectedControl"]);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bIsConnected"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   sGetConnectedControlId -------------------------------------------
/**
 * @private
 * @return {string}
 */
UCF_InputFieldHelpButton["prototype"]["sGetConnectedControlId"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["sGetConnectedControlId"]++; }; 
	return this["oConnectedControl"] && this["oConnectedControl"]["sId"];
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["sGetConnectedControlId"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   bIsOnUpperHalf ---------------------------------------------------
/**
 * @private
 * @param {number} iY the y offset
 * @return {boolean}
 */
UCF_InputFieldHelpButton["prototype"]["bIsOnUpperHalf"] = function(iY) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bIsOnUpperHalf"]++; }; 
	// eslint-disable-next-line no-magic-numbers
	return iY < this["oDomRef"]["offsetHeight"] / 2;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bIsOnUpperHalf"] = 0; };
// #endregion -----------------------------------------------------------------
// #endregion =================================================================
// #region Connecting/Disconnecting ===========================================
// #region   connect ----------------------------------------------------------
/**
 * Show button behind the input field
 * @protected
 * @param {UCF_EditFieldBase} oConnectedControl the EditField that is connected
 */
UCF_InputFieldHelpButton["prototype"]["connect"] = function(oConnectedControl) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["connect"]++; }; 
	/** @type {HTMLElement} */
	var oPositionContainer;

	if (this["oConnectedControl"] !== oConnectedControl) {
		this["disconnect"]();
	}
	this["oConnectedControl"] = oConnectedControl;
	this["eUsage"] = this["eGetUsage"]();

	oPositionContainer = this["oFindPositionContainer"]();
	if (oPositionContainer !== this["oPositionContainer"]) {
		this["oPositionContainer"] = oPositionContainer;

		UCF_DomUtil["oAddLayeredElement"](
			this["oDomRef"],
			this["oLS"]["oGetAssociatedAreaRef"](),
			this["oPositionContainer"]
		);
	}

	this["alignStylesWithControl"](this["oConnectedControl"]);

	this["oDomRef"]["setAttribute"]('title', this["oConnectedControl"]["sTooltip"]);

	this["setPosition"]();

	this["attachRepositionListening"]();
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["connect"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   oFindPositionContainer -------------------------------------------
/**
 * Gets the scroll container the help button should be positioned against.
 * @private
 * @return {HTMLElement} the position container
 */
UCF_InputFieldHelpButton["prototype"]["oFindPositionContainer"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["oFindPositionContainer"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefSearchStart = this["oConnectedControl"]["oRootRef"]["parentNode"];
	/** @type {HTMLElement} */
	var oPositionContainer = (
			// CSN: 1770213 2011: Workaround for z-index bug in IE occuring in ITS
			__UCF_IE6__ &&
			UCF_DomUtil["oGetParentByAttribute"](oDomRefSearchStart, 'ct', 'RL')
		) ||
		UCF_DomUtil["oGetParentScrollContainer"](
			oDomRefSearchStart,
			true,
			// Note 2205368: If oPosContainer is a TABLE element, the button is not
			// displayed (only IE Quirks). Hence, we search for the next parent
			// scroll container which is a DIV
			__UCF_IE6__
		);
	/** @type {UCF_PopupWindow} */
	var oPopupWindow = this["oConnectedControl"]["oGetParentPopupWindow"]();
	/** @type {HTMLDivElement} */
	var oPopupWindowContentRef;
	/** @type {HTMLElement} */
	var oPopupPositionContainer;

	if (oPopupWindow) {
		oPopupWindowContentRef = oPopupWindow["oGetContentRef"]();
		if (UCF_DomUtil["bContains"](oPositionContainer, oPopupWindowContentRef)) {
			return oPopupWindowContentRef;
		} else {
			// can't use UCF_DomUtil.oGetParentPositionReferenceContainer()
			// as it only takes overflow:hidden into consideration in IE and Edge
			oPopupPositionContainer = this["oConnectedControl"]["oGetParentScrollAreaDomRef"]();
			return oPopupPositionContainer ? oPopupPositionContainer : oPositionContainer;
		}
	} else {
		return oPositionContainer;
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["oFindPositionContainer"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   eGetUsage --------------------------------------------------------
/**
 * @private
 * @see UCF_InputFieldHelpButton.E_USAGES
 * @return {number}
 */
UCF_InputFieldHelpButton["prototype"]["eGetUsage"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["eGetUsage"]++; }; 
	/** @type {UCF_Control} */
	var oUsageControl = this["oGetUsageControl"]();

	if (oUsageControl) {
		switch (oUsageControl["sClassName"]) {
			case 'UCF_DataGrid':
				return UCF_InputFieldHelpButton["E_USAGES"]["DataGrid"];
			case 'UCF_SapTableCS':
				return this["oConnectedControl"]["bUsedInSapTable"]
					? (UCF_InputFieldHelpButton["bHasInvisibleBorder"](
							UCF_DomUtil["oGetComputedStyle"](this["oConnectedControl"]["oRootRef"])
						)
						? UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"]
						: UCF_InputFieldHelpButton["E_USAGES"]["SapTableCSAtControl"])
					: UCF_InputFieldHelpButton["E_USAGES"]["Standalone"];
			case 'UCF_SapTable':
				return this["oConnectedControl"]["bUsedInSapTable"]
					? (UCF_InputFieldHelpButton["bHasInvisibleBorder"](
							UCF_DomUtil["oGetComputedStyle"](this["oConnectedControl"]["oRootRef"])
						)
						? UCF_InputFieldHelpButton["E_USAGES"]["SapTable"]
						: UCF_InputFieldHelpButton["E_USAGES"]["SapTableAtControl"])
					: UCF_InputFieldHelpButton["E_USAGES"]["Standalone"];
			default:
				return UCF_InputFieldHelpButton["E_USAGES"]["Standalone"];
		}
	} else {
		return UCF_InputFieldHelpButton["E_USAGES"]["Disconnected"];
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["eGetUsage"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   oGetUsageControl -------------------------------------------------
/**
 * @return {UCF_Control}
 */
UCF_InputFieldHelpButton["prototype"]["oGetUsageControl"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["oGetUsageControl"]++; }; 
	/** @type {UCF_Control} */
	var oUsageControl = null;
	/** @type {UCF_Control} */
	var oParent;

	if (this["oConnectedControl"]) {
		oUsageControl = this["oConnectedControl"];

		do {
			if (
				UCF_JsUtil["bInstanceOf"](oUsageControl, 'UCF_SapTable') ||
				UCF_JsUtil["bInstanceOf"](oUsageControl, 'UCF_DataGrid')
			) {
				return oUsageControl;
			} else {
				oParent = oUsageControl["oGetParent"]();
				if (oParent) {
					oUsageControl = oParent;
				} else {
					return oUsageControl;
				}
			}
		} while (oUsageControl);
	}

	return oUsageControl;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["oGetUsageControl"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   disconnect -------------------------------------------------------
/** @protected */
UCF_InputFieldHelpButton["prototype"]["disconnect"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["disconnect"]++; }; 
	/** @type {string} */
	var sThemeScope;

	this["detachRepositionListening"]();

	if (this["oDomRef"]) {
		UCF_InputFieldHelpButton["placeAt"](this["oDomRef"], '25px', '-5000px');
	}
	if (this["oConnectedControl"]) {
		sThemeScope = UCF_InputFieldHelpButton["sGetThemeScope"](
			this["oConnectedControl"]
		);
		if (sThemeScope) {
			UCF_DomUtil["removeClass"](this["oDomRef"], sThemeScope);
		}
		this["fireDisconnect"]();
	}

	this["oConnectedControl"] = null;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["disconnect"] = 0; };
// #endregion -----------------------------------------------------------------
// #endregion =================================================================
// #region Styles =============================================================
// #region   sGetThemeScope ---------------------------------------------------
/**
 * For a given `UCF_Control`, finds and returns the theme scope of the nearest
 * parent that has a `sContentThemeScope` property.
 *
 * @private
 * @static
 * @param {UCF_Control} oControl the control that's theme scope should be found
 * @return {string} the theme scope found for oControl, or {{undefined}}
 */
UCF_InputFieldHelpButton["sGetThemeScope"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["sGetThemeScope"]++; }; 
	/** @type {UCF_Control} */
	var oCurrentControl = oControl;

	if (__UCF_IE6__ || !oControl["bUsedInSapTable"]) {
		return '';
	} else {
		oCurrentControl = oControl;

		while (oCurrentControl && !oCurrentControl["sContentThemeScope"]) {
			oCurrentControl = oCurrentControl["oGetParent"]();
		}

		return oCurrentControl && oCurrentControl["sContentThemeScope"];
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["sGetThemeScope"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   alignStylesWithControl -------------------------------------------
/**
 * @protected
 * @param {UCF_EditFieldBase} oControl the control to align with
 */
UCF_InputFieldHelpButton["prototype"]["alignStylesWithControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["alignStylesWithControl"]++; }; 
	/** @type {UCF_InputFieldHelpButton} */
	var self;

	this["resetStyles"](oControl);
	if (__UCF_IE6__) {
		self = this;

		// IE Quirks: after resetting .style (e.g. background-color), .style is
		// updated but .currentStyle is not, thus reflecting the wrong value
		// => asynchronously apply new styles
		UCF_JsUtil["requestAnimationFrame"](function() {
			self["applyNewStyles"](oControl);
		});
	} else {
		this["applyNewStyles"](oControl);
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["alignStylesWithControl"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   resetStyles ------------------------------------------------------
/**
 * @private
 * @param {UCF_EditFieldBase} oControl
 */
UCF_InputFieldHelpButton["prototype"]["resetStyles"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["resetStyles"]++; }; 
	/** @type {string} */
	var sThemeScope = UCF_InputFieldHelpButton["sGetThemeScope"](oControl);

	// have to set css classes before computing css style, b/c that style will
	// depend on the new css classes
	UCF_DomUtil["setClass"](
		this["oDomRef"],
		oControl["oRootRef"]["className"] + (sThemeScope ? ' ' + sThemeScope : '')
	);

	UCF_DomUtil["setStyle"](this["oDomRef"], {
		"backgroundColor": '',
		"borderTopStyle": '',
		"borderTopWidth": '',
		"borderTopColor": '',
		"borderRightStyle": '',
		"borderRightWidth": '',
		"borderRightColor": '',
		"borderBottomStyle": '',
		"borderBottomWidth": '',
		"borderBottomColor": '',
		"borderLeftStyle": '',
		"borderLeftColor": ''
	});
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["resetStyles"] = 0; };
// #endregion
// #region   applyNewStyles ---------------------------------------------------
/**
 * @private
 * @param {UCF_EditFieldBase} oControl
 */
UCF_InputFieldHelpButton["prototype"]["applyNewStyles"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["applyNewStyles"]++; }; 
	/** @type {CSSStyleDeclaration} */
	var oCS = UCF_DomUtil["oGetComputedStyle"](this["oDomRef"]);
	/** @type {HTMLElement} */
	var oDimensionRef;
	/** @type {CSSStyleDeclaration} */
	var oDimensionRefCS;
	/** @type {number} */
	var iHeight;
	/** @type {number} */
	var iInnerHeight;
	/** @type {string} */
	/** @type {number} */
	var iZIndex = UCF_InputFieldHelpButton["iGetZIndex"](oControl);
	/** @type {UCF_InputFieldHelpButton_Style} */
	var oTargetStyle = {};

	if (oControl["bFieldHelpEmbedding"]) {
		oDimensionRefCS = UCF_DomUtil["oGetComputedStyle"](oControl["oRootRef"]);
		iInnerHeight = UCF_InputFieldHelpButton["iGetInnerHeight"](
			oControl["oRootRef"],
			oDimensionRefCS,
			this["eUsage"]
		);

		UCF_JsUtil["extend"](oTargetStyle, {
			"zIndex": iZIndex,
			"height": iInnerHeight + 'px',
			"lineHeight": (
				iInnerHeight -
				(parseInt(oDimensionRefCS["borderTopWidth"]) || 0) -
				(parseInt(oDimensionRefCS["borderBottomWidth"]) || 0)
			) + 'px',
			"borderColor": oCS["backgroundColor"]
		});
	} else {
		oDimensionRef = UCF_InputFieldHelpButton["oGetConnectedRef"](oControl, this["eUsage"]);

		if (UCF_ColorUtil["fAlpha"](oCS["backgroundColor"]) !== 1) {
			UCF_JsUtil["extend"](oTargetStyle, {
				"backgroundColor": UCF_DomUtil["sGetPerceivedBackgroundColor"](oControl["oDomRef"])
			});
		}

		if (UCF_InputFieldHelpButton["bHasInvisibleBorder"](oCS)) {
			oDimensionRefCS = UCF_DomUtil["oGetComputedStyle"](
				oDimensionRef
			);
			iHeight = UCF_InputFieldHelpButton["iGetHeight"](
				oDimensionRef,
				this["eUsage"]
			);
			iInnerHeight = UCF_InputFieldHelpButton["iGetInnerHeight"](
				oDimensionRef,
				oDimensionRefCS,
				this["eUsage"]
			);

			// #region borders
			UCF_JsUtil["extend"](oTargetStyle, {
				// IE Quirks doesn't know border shorthands, have to write them out;
				// borderTop/borderRight can be none, but we need a border => always take
				// borderBottom
				"borderTopWidth": oDimensionRefCS["borderBottomWidth"],
				"borderTopStyle": oDimensionRefCS["borderBottomStyle"],
				"borderTopColor": oDimensionRefCS["borderBottomColor"],
				"borderBottomWidth": oDimensionRefCS["borderBottomWidth"],
				"borderBottomStyle": oDimensionRefCS["borderBottomStyle"],
				"borderBottomColor": oDimensionRefCS["borderBottomColor"]
			}, UCF_DomUtil["bIsRTL"] ? {
				"borderLeftWidth": oDimensionRefCS["borderBottomWidth"],
				"borderLeftStyle": oDimensionRefCS["borderBottomStyle"],
				"borderLeftColor": oDimensionRefCS["borderBottomColor"]
			} : {
				"borderRightWidth": oDimensionRefCS["borderBottomWidth"],
				"borderRightStyle": oDimensionRefCS["borderBottomStyle"],
				"borderRightColor": oDimensionRefCS["borderBottomColor"]
			});
			// #endregion
		} else {
			iHeight = UCF_InputFieldHelpButton["iGetHeight"](oDimensionRef, this["eUsage"]);
			iInnerHeight = UCF_InputFieldHelpButton["iGetInnerHeight"](
				oDimensionRef,
				oCS,
				this["eUsage"]
			);
		}
		UCF_JsUtil["extend"](oTargetStyle, {
			"height": iHeight + 'px',
			"lineHeight": iInnerHeight + 'px',
			"zIndex": iZIndex
		});
	}

	UCF_DomUtil["setStyle"](this["oDomRef"], oTargetStyle);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["applyNewStyles"] = 0; };
// #endregion
// #region   bHasInvisibleBorder ----------------------------------------------
/**
 * @private
 * @static
 * @param {CSSStyleDeclaration} oComputedStyle the computed style of the
 * help button
 * @return {boolean}
 */
UCF_InputFieldHelpButton["bHasInvisibleBorder"] = function(oComputedStyle) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bHasInvisibleBorder"]++; }; 
	return UCF_InputFieldHelpButton["bHasZeroWidthBorder"](oComputedStyle)
		|| UCF_InputFieldHelpButton["bHasNoneBorder"](oComputedStyle);
	// no longer looking for transparent border, transparent border with width
	// > 0 means it will be visible soon => already accounting for it
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bHasInvisibleBorder"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   bHasZeroWidthBorder ----------------------------------------------
/**
 * @private
 * @static
 * @param {CSSStyleDeclaration} oComputedStyle a computed style
 * @return {boolean}
 */
UCF_InputFieldHelpButton["bHasZeroWidthBorder"] = function(oComputedStyle) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bHasZeroWidthBorder"]++; }; 
	return oComputedStyle["borderWidth"] === '0px' || (
		oComputedStyle["borderTopWidth"] === '0px' &&
		oComputedStyle["borderBottomWidth"] === '0px' &&
		(UCF_DomUtil["bIsRTL"]
			? oComputedStyle["borderLeftWidth"]
			: oComputedStyle["borderRightWidth"]
		) === '0px'
	);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bHasZeroWidthBorder"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   bHasNoneBorder ---------------------------------------------------
/**
 * @private
 * @static
 * @param {CSSStyleDeclaration} oComputedStyle a computed style
 * @return {boolean}
 */
UCF_InputFieldHelpButton["bHasNoneBorder"] = function(oComputedStyle) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bHasNoneBorder"]++; }; 
	return oComputedStyle["borderStyle"] === 'none' || (
		oComputedStyle["borderTopStyle"] === 'none' &&
		oComputedStyle["borderBottomStyle"] === 'none' &&
		(UCF_DomUtil["bIsRTL"]
			? oComputedStyle["borderLeftStyle"]
			: oComputedStyle["borderRightStyle"]
		) === 'none'
	);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bHasNoneBorder"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetHeight -------------------------------------------------------
/**
 * @private
 * @static
 * @param {HTMLElement} oDomRef the element
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the usage kind
 * @return {number} the height including borders in px
 */
UCF_InputFieldHelpButton["iGetHeight"] = function(oDomRef, eUsage) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetHeight"]++; }; 
	return oDomRef["offsetHeight"] + (
		eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTable"] ||
		eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"]
		? 1
		: 0
	);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetHeight"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetInnerHeight --------------------------------------------------
/**
 * @private
 * @static
 * @param {HTMLElement} oDomRef the element to get the offsetHeight from
 * @param {CSSStyleDeclaration} oComputedStyle the computed style to get the
 * border width from
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the usage kind
 * @return {number} the height (without borders, assuming padding:0) in px
 */
UCF_InputFieldHelpButton["iGetInnerHeight"] = function(oDomRef, oComputedStyle, eUsage) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetInnerHeight"]++; }; 
	return (
		UCF_InputFieldHelpButton["iGetHeight"](oDomRef, eUsage) -
		2 * Math["max"]( // eslint-disable-line no-magic-numbers
			// IE Quirks has borderTopWidth=medium sometimes, which is NaN when
			// parsed to int => default to 1
			(parseInt(oComputedStyle["borderTopWidth"]) || 1),
			(parseInt(oComputedStyle["borderBottomWidth"]) || 1)
		)
	);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetInnerHeight"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetZIndex -------------------------------------------------------
/**
 * @private
 * @static
 * @param {UCF_Control} oControl the connected control
 * @return {number} z-index of the InputFieldHelpButton
 */
UCF_InputFieldHelpButton["iGetZIndex"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetZIndex"]++; }; 
	return UCF_LS["E_LAYERS"]["CONTROLS"] + (oControl["iGetParentZIndex"]() || 0);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetZIndex"] = 0; };
// #endregion -----------------------------------------------------------------
// #endregion =================================================================
// #region Positioning ========================================================
// #region   placeAt ----------------------------------------------------------
/**
 * places `oDomref` at (`top`|`left`) using `transform:translate()` if possible
 *
 * @example
 * UCF_InputFieldHelpButton.placeAt(UCF_DomUtil.$('foo'), '100%', '4vh');
 * // => places #foo at (100%|4vh)
 *
 * @private
 * @static
 * @param {HTMLElement} oDomRef the element to be placed
 * @param {string} sLeft the css dimension expression the element should be
 * placed by to the left (with unit, i.e. '5px', not '5')
 * @param {string} sTop the css dimension expression the element should be
 * placed by to the top
 */
UCF_InputFieldHelpButton["placeAt"] = __UCF_IE6__
	? function(oDomRef, sLeft, sTop) {
		UCF_DomUtil["setStyle"](oDomRef, { "left": sLeft, "top": sTop });
	}
	: function(oDomRef, sLeft, sTop) {
		UCF_DomUtil["setStyle"](oDomRef, {
			"left": '0px',
			"top": '0px',
			"transform": 'translate(' + sLeft + ',' + sTop + ')'
		});
	};
// #endregion -----------------------------------------------------------------
// #region   setPosition ------------------------------------------------------
/**
 * position the InputFieldHelpButton according to the connected control
 * @private
 */
UCF_InputFieldHelpButton["prototype"]["setPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["setPosition"]++; }; 
	/** @type {HTMLInputElement} */
	var oConnectedRef;
	/** @type {CSSStyleDeclaration} */
	var oPositionContainerCS;
	/** @type {CSSStyleDeclaration} */
	var oConnectedRefCS;
	/** @type {_ObjectRect} */
	var oRect;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["eUsage"] !== UCF_InputFieldHelpButton["E_USAGES"]["Disconnected"], "this.eUsage !== UCF_InputFieldHelpButton.E_USAGES.Disconnected", "InputFieldHelpButton.js(689): setPosition"); };

	if (
		this["oConnectedControl"] &&
		!(
			this["oConnectedControl"]["bFieldHelpEmbedding"] &&
			typeof this["oConnectedControl"]["iOriginalWidth"] === 'number'
		)
	) {
		oPositionContainerCS = this["oPositionContainer"] &&
			UCF_DomUtil["oGetComputedStyle"](this["oPositionContainer"]);
		oConnectedRef = UCF_InputFieldHelpButton["oGetConnectedRef"](
			this["oConnectedControl"],
			this["eUsage"]
		);
		oConnectedRefCS = UCF_DomUtil["oGetComputedStyle"](oConnectedRef);
		oRect = UCF_DomUtil["oGetObjectRect"](oConnectedRef, this["oPositionContainer"]);

		if (UCF_UserAgent["bIsIE"]()) {
			// March 2018: InputFieldHelpButton in first NoneFixedCell of SapTable
			// miscalculates border correction in IE, because IE reports
			//   borderRightWidth(prevSibling) == 2px and
			//   borderLeftWidth(connectedRef) == 2px
			// but should be
			//   borderRightWidth(prevSibling) == 4px and
			//   borderLeftWidth(connectedRef) == 1px
			// forcing a reflow on the parent <tr> results in IE reporting the
			// correct values
			UCF_InputFieldHelpButton["forceReflow"](
				UCF_DomUtil["oGetParentByTagName"](oConnectedRef, 'TR')
			);
		}

		UCF_InputFieldHelpButton["placeAt"](
			this["oDomRef"],
			this["iGetOffsetLeft"](
				oRect,
				oConnectedRef,
				oConnectedRefCS,
				oPositionContainerCS
			) + 'px',
			this["iGetOffsetTop"](
				oRect,
				oConnectedRef,
				oConnectedRefCS,
				oPositionContainerCS
			) + 'px'
		);
	}

	this["fireConnect"](this["oDomRef"]["offsetWidth"]);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["setPosition"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   forceReflow ------------------------------------------------------
/**
 * @private
 * @param {HTMLElement} oDomRef the dom element to force the reflow on
 */
UCF_InputFieldHelpButton["forceReflow"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["forceReflow"]++; }; 
	if (oDomRef) {
		UCF_DomUtil["setClass"](oDomRef, oDomRef["className"]);
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["forceReflow"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetOffsetLeft ---------------------------------------------------
/**
 * @private
 * @param {_ObjectRect} oRect the rect of the InputFieldHelpButton
 * @param {HTMLElement} oConnectedRef the DOM element the help button is
 * connected to
 * @param {CSSStyleDeclaration} oConnectedRefCS the computed style for the
 * connected control
 * @param {CSSStyleDeclaration} oPositionContainerCS the computed style for the
 * position container
 * @return {number} offset of the InputFieldHelpButton to the left in pixels
 */
UCF_InputFieldHelpButton["prototype"]["iGetOffsetLeft"] = function(oRect, oConnectedRef, oConnectedRefCS, oPositionContainerCS) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOffsetLeft"]++; }; 
	return Math["min"](
		Math["max"](
			this["iGetOptimalOffsetLeft"](
				oRect,
				oConnectedRef,
				oConnectedRefCS,
				oPositionContainerCS
			),
			this["iGetOffsetLeftMinimumOfParents"](oConnectedRef)
			+ this["iGetPopupWindowOffsetLeftAdjustment"](oConnectedRef),
			UCF_DomUtil["bIsRTL"]
			? Number["NEGATIVE_INFINITY"]
			: (-parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'left')) || 0)
		),
		this["iGetMaximumOffsetLeft"]()
	);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOffsetLeft"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetMaximumOffsetLeft --------------------------------------------
/**
 * @private
 * @return {number} maximum pixels the button may be placed from the left
 */
UCF_InputFieldHelpButton["prototype"]["iGetMaximumOffsetLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetMaximumOffsetLeft"]++; }; 
	/** @type {number} */
	var iScrollWidth = this["oPositionContainer"]
		? UCF_InputFieldHelpButton["iGetCurrentlyScrolledWidth"](
			this["oPositionContainer"]
		)
		: UCF_DomUtil["iWindowScrollWidth"]();
	/** @type {number} */
	var iBodyScrollbarOffset = UCF_DomUtil["iGetVerticalScrollbarOffset"](
		document["body"]
	);

	return iScrollWidth
		- (this["oPositionContainer"]
			? Math["max"](
				iBodyScrollbarOffset,
				UCF_DomUtil["iGetVerticalScrollbarOffset"](this["oPositionContainer"])
			)
			: iBodyScrollbarOffset)
		- this["oDomRef"]["offsetWidth"];

};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetMaximumOffsetLeft"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetCurrentlyScrolledWidth ---------------------------------------
/**
 * @private
 * @static
 * @param {HTMLElement} oScrollContainerRef the scroll container
 * @return {number} width of scroll container + (in LTR) width of scrollbar
 */
UCF_InputFieldHelpButton["iGetCurrentlyScrolledWidth"] = function(oScrollContainerRef) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetCurrentlyScrolledWidth"]++; }; 
	if (oScrollContainerRef) {
		return UCF_DomUtil["bIsRTL"] && !__UCF_IE6__
			? oScrollContainerRef["offsetWidth"]
			: oScrollContainerRef["offsetWidth"] + UCF_DomUtil["iGetScrollLeft"](
				oScrollContainerRef
			);
	} else {
		return 0;
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetCurrentlyScrolledWidth"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetOptimalOffsetLeft --------------------------------------------
/**
 * @private
 * @param {_ObjectRect} oRect the rect of the InputFieldHelpButton
 * @param {HTMLElement} oConnectedRef the DOM element the help button is
 * connected to
 * @param {CSSStyleDeclaration} oConnectedRefCS the computed style for the
 * connected control
 * @param {CSSStyleDeclaration} oPositionContainerCS the computed
 * style for the position container
 * @return {number} the minimum offset for placing the InputFieldHelpButton in
 * pixels
 */
UCF_InputFieldHelpButton["prototype"]["iGetOptimalOffsetLeft"] = function(oRect, oConnectedRef, oConnectedRefCS, oPositionContainerCS) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalOffsetLeft"]++; };  // eslint-disable-line complexity
	/** @type {number} */
	var iWidth = this["oDomRef"]["offsetWidth"];

	oRect["left"] -=
		(oPositionContainerCS && parseInt(oPositionContainerCS["paddingLeft"])) ||
		0;

	return window["UCF_System"]["bIsRTL"]
		? this["iGetOptimalRtlOffsetLeft"](
			iWidth,
			oRect,
			oConnectedRef,
			oConnectedRefCS
		)
		: this["iGetOptimalLtrOffsetLeft"](
			iWidth,
			oRect,
			oConnectedRef,
			oConnectedRefCS
		);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalOffsetLeft"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetOptimalLtrOffsetLeft -----------------------------------------
/**
 * @private
 * @param {number} iWidth the width of the help button
 * @param {_ObjectRect} oConnectedRefRect the rect of the connected ref
 * @param {HTMLElement} oConnectedRef the connected ref
 * @param {CSSStyleDeclaration} oConnectedRefCS the computed style of the
 * connected ref
 * @return {number} in px
 */
UCF_InputFieldHelpButton["prototype"]["iGetOptimalLtrOffsetLeft"] = function(iWidth, oConnectedRefRect, oConnectedRef, oConnectedRefCS) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalLtrOffsetLeft"]++; }; 
	/** @type {number} */
	var iConnectedRefBorderEndWidth = parseInt(oConnectedRefCS["borderRightWidth"]);
	/** @type {number} */
	var iOffsetLeft;

	oConnectedRefRect["width"] -= isNaN(iConnectedRefBorderEndWidth)
		? 1
		: iConnectedRefBorderEndWidth;

	oConnectedRefRect["left"] += UCF_InputFieldHelpButton["iSafariLeftAdjustment"](
		this["eUsage"]
	);
	oConnectedRefRect["width"] += UCF_InputFieldHelpButton["iIEWidthAdjustment"](
		this["eUsage"]
	);
	oConnectedRefRect["width"] += UCF_InputFieldHelpButton["iChromiumWidthAdjustment"](
		this["eUsage"]
	);

	iOffsetLeft = oConnectedRefRect["left"] + oConnectedRefRect["width"];
	if (this["oConnectedControl"]["bFieldHelpEmbedding"]) {
		iOffsetLeft -= iWidth;
	}
	if (
		this["eUsage"] === UCF_InputFieldHelpButton["E_USAGES"]["SapTable"] ||
		this["eUsage"] === UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"]
		// || this.eUsage === UCF_InputFieldHelpButton.E_USAGES.SapTableAtControl
		// || this.eUsage === UCF_InputFieldHelpButton.E_USAGES.SapTableCSAtControl
	) {
		iOffsetLeft -= this["iGetPrevSiblingBorderCorrection"](
			oConnectedRef,
			oConnectedRefCS
		);
	}

	if (
		this["oPositionContainer"] &&
		this["oPositionContainer"]["scrollWidth"] >
		this["oPositionContainer"]["offsetWidth"] &&
		this["oPositionContainer"]["scrollWidth"] < iOffsetLeft + iWidth
	) {
		iOffsetLeft = this["oPositionContainer"]["scrollWidth"] - iWidth;
	}

	return iOffsetLeft;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalLtrOffsetLeft"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetPrevSiblingBorderCorrection ----------------------------------
/**
 * @private
 * @param {HTMLElement} oConnectedRef the connected element
 * @param {CSSStyleDeclaration} oConnectedRefCS the computed style of the
 * connected ref
 * @return {number}
 */
UCF_InputFieldHelpButton["prototype"]["iGetPrevSiblingBorderCorrection"] = function(oConnectedRef, oConnectedRefCS) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetPrevSiblingBorderCorrection"]++; }; 
	/** @type {number} */
	var iBorderWidth;
	/** @type {HTMLTableDataElement} */
	var oPrevSibling;
	/** @type {number} */
	var iPrevSiblingBorderWidth;

	if (oConnectedRef["nodeName"] === 'TD') {
		iBorderWidth = parseInt(oConnectedRefCS["borderLeftWidth"]) || 0;
		oPrevSibling = UCF_DomUtil["previousSibling"](oConnectedRef, 'TD');

		if (oPrevSibling) {
			iPrevSiblingBorderWidth = parseInt(UCF_DomUtil["sGetCurrentStyle"](
				oPrevSibling,
				'borderRightWidth'
			) || iBorderWidth);

			return iPrevSiblingBorderWidth ===
				(parseInt(oConnectedRefCS["borderRightWidth"]) || iBorderWidth)
				? 0
				// eslint-disable-next-line no-magic-numbers
				: Math["ceil"]((iPrevSiblingBorderWidth - iBorderWidth) / 2);
		}
	}

	return 0;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetPrevSiblingBorderCorrection"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iSafariLeftAdjustment --------------------------------------------
/**
 * In (macOS?) Safari, depending on the devicePixelRatio (retina vs. non-retina
 * screen), oRect.left is miscalculated by 1px (non-retina) / 3px (retina).
 *
 * @private
 * @static
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the usage position of the
 * connected control
 * @return {number} in px
 */
UCF_InputFieldHelpButton["iSafariLeftAdjustment"] = function(eUsage) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iSafariLeftAdjustment"]++; }; 
	if (
		(
			eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTableAtControl"] ||
			eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTable"]
		) &&
		UCF_UserAgent["bIsSafari"]()
	) {
		// eslint-disable-next-line no-magic-numbers
		return (window["devicePixelRatio"] && window["devicePixelRatio"] > 1) ? -3 : -1;
	} else {
		return 0;
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iSafariLeftAdjustment"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iIEWidthAdjustment -----------------------------------------------
/**
 * In IE/Edge, in a SapTable, the width of the connected ref is miscalculated
 * by 1px.
 *
 * @private
 * @static
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the usage position of the
 * connected control
 * @return {number} in px
 */
UCF_InputFieldHelpButton["iIEWidthAdjustment"] = function(eUsage) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iIEWidthAdjustment"]++; }; 
	return (
			(eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"] ||
				eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTable"]
			) &&
			(UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())
		)
		? -2 // eslint-disable-line no-magic-numbers
		: 0;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iIEWidthAdjustment"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iChromiumWidthAdjustment -----------------------------------------
/**
 * In IE/Edge, in a SapTable, the left offset of the connected
 * ref in getBoundingClientRect() is a decimal like 8.5.
 * It seems Chromium is rounding differently to UR / math().
 *
 * @private
 * @static
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the usage position of the
 * connected control
 * @return {number} in px
 */
UCF_InputFieldHelpButton["iChromiumWidthAdjustment"] = function(eUsage) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iChromiumWidthAdjustment"]++; }; 
	return (
			(
				eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTableAtControl"] ||
				eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTable"]
			) &&
			UCF_UserAgent["bIsChromium"]()
		)
		? -1 // eslint-disable-line no-magic-numbers
		: 0;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iChromiumWidthAdjustment"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetOptimalRtlOffsetLeft -----------------------------------------
/**
 * @private
 * @param {number} iWidth the width of the help button
 * @param {_ObjectRect} oRect the rect of the connected ref
 * @param {HTMLElement} oConnectedRef the connected ref
 * @param {CSSStyleDeclaration} oConnectedRefCS the computed style of the
 * connected ref
 * @return {number} in px
 */
UCF_InputFieldHelpButton["prototype"]["iGetOptimalRtlOffsetLeft"] = function(iWidth, oRect, oConnectedRef, oConnectedRefCS) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalRtlOffsetLeft"]++; }; 
	/** @type {number} */
	var iConnectedRefBorderEndWidth = parseInt(oConnectedRefCS["borderLeftWidth"]);

	oRect["left"] += UCF_InputFieldHelpButton["iChromeRtlBorderAdjustment"](
		this["eUsage"],
		oConnectedRef
	);

	oRect["left"] += isNaN(iConnectedRefBorderEndWidth)
		? 1
		: iConnectedRefBorderEndWidth;

	return (
			this["oPositionContainer"] &&
			this["oPositionContainer"]["scrollWidth"] > this["oPositionContainer"]["offsetWidth"]
		)
		? this["iGetOptimalRtlScrolledOffsetLeft"](iWidth, oRect)
		: this["iGetOptimalRtlUnscrolledOffsetLeft"](iWidth, oRect, oConnectedRef, oConnectedRefCS);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalRtlOffsetLeft"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetOptimalRtlScrolledOffsetLeft ---------------------------------
/**
 * @private
 * @param {number} iWidth the width of the help button
 * @param {_ObjectRect} oRect the rect of the connected ref
 * @return {number} in px
 */
UCF_InputFieldHelpButton["prototype"]["iGetOptimalRtlScrolledOffsetLeft"] = function(iWidth, oRect) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalRtlScrolledOffsetLeft"]++; }; 
	/** @type {number} */
	var iScrollLeft;

	if (__UCF_IE6__) {
		return oRect["left"] - iWidth;
	} else {
		iScrollLeft = UCF_DomUtil["iGetScrollLeft"](this["oPositionContainer"]);

		return Math["max"](
			oRect["left"]
			+ UCF_InputFieldHelpButton["iGetMinimumOffsetLeftRtlAdjustment"](
				this["eUsage"]
			)
			- iWidth
			- iScrollLeft,
			this["oPositionContainer"]["offsetWidth"]
			+ iScrollLeft
			- this["oPositionContainer"]["scrollWidth"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalRtlScrolledOffsetLeft"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetOptimalRtlUnscrolledOffsetLeft -------------------------------
/**
 * @private
 * @param {number} iWidth the width of the help button
 * @param {_ObjectRect} oRect the rect of the connected ref
 * @param {HTMLElement} oConnectedRef
 * @param {CSSStyleDeclaration} oConnectedRefCS
 * @return {number} in px
 */
UCF_InputFieldHelpButton["prototype"]["iGetOptimalRtlUnscrolledOffsetLeft"] = function(iWidth, oRect, oConnectedRef, oConnectedRefCS) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalRtlUnscrolledOffsetLeft"]++; }; 
	oRect["left"] += UCF_InputFieldHelpButton["iFirefoxRtlScrollbarAdjustment"](
		this["oPositionContainer"]
	);

	return this["oConnectedControl"]["bFieldHelpEmbedding"]
		? oRect["left"]
		: oRect["left"] - iWidth + this["iGetOptimalRtlUnscrolledOffsetLeftAdjustment"](oConnectedRef, oConnectedRefCS);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalRtlUnscrolledOffsetLeft"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetOptimalRtlUnscrolledAdjustment -------------------------------
UCF_InputFieldHelpButton["prototype"]["iGetOptimalRtlUnscrolledOffsetLeftAdjustment"] = function(oConnectedRef, oConnectedRefCS) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalRtlUnscrolledOffsetLeftAdjustment"]++; }; 
	return UCF_UserAgent["bIsChromium"]()
		? 0
		: UCF_UserAgent["bIsFirefox"]()
		? this["iGetOptimalRtlUnscrolledOffsetLeftFirefoxAdjustment"](oConnectedRef)
		: (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())
		? (parseInt(oConnectedRefCS["borderLeftWidth"]) + 2 || 2)
		: (parseInt(oConnectedRefCS["borderLeftWidth"]) || 0);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalRtlUnscrolledOffsetLeftAdjustment"] = 0; };
// #endregion
// #region   iGetOptimalRtlUnscrolledFirefoxAdjustment ------------------------
/**
 * @param {HTMLElement} oConnectedRef
 * @return {number}
 */
UCF_InputFieldHelpButton["prototype"]["iGetOptimalRtlUnscrolledOffsetLeftFirefoxAdjustment"] = function(oConnectedRef) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalRtlUnscrolledOffsetLeftFirefoxAdjustment"]++; }; 
	/** @type {HTMLElement} */
	var oNextSibling;
	/** @type {CSSStyleDeclaration} */
	var oNextSiblingCS;

	switch (this["eGetUsage"]()) {
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTable"]:
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"]:
		case UCF_InputFieldHelpButton["E_USAGES"]["DataGrid"]:
			oNextSibling = UCF_DomUtil["oGetNextSibling"](oConnectedRef);
			if (oNextSibling) {
				oNextSiblingCS = UCF_DomUtil["oGetComputedStyle"](oNextSibling);

				if (oNextSiblingCS) {
					return parseInt(oNextSiblingCS["borderRightWidth"]) + 1 || 0;
				}
			} else {
				return 1;
			}
	}

	return 0;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOptimalRtlUnscrolledOffsetLeftFirefoxAdjustment"] = 0; };
// #endregion
// #region   iGetOffsetLeftMinimumOfParents -----------------------------------
/**
 * @private
 * @param {HTMLElement} oConnectedRef the element the InputFieldHelpButton is
 * connected to
 * @return {number} the minimal offsetLeft of parents that don't have a
 * scrollbar
 */
UCF_InputFieldHelpButton["prototype"]["iGetOffsetLeftMinimumOfParents"] = function(oConnectedRef) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOffsetLeftMinimumOfParents"]++; }; 
	/** @type {HTMLElement} */
	var oCurrentRef = oConnectedRef;
	/** @type {number} */
	var iMinimum = oCurrentRef["offsetLeft"];

	while ((oCurrentRef = oCurrentRef["parentElement"]) !== document["body"]) {
		if (oCurrentRef["offsetLeft"] < iMinimum) {
			iMinimum = oCurrentRef["offsetLeft"];
		}

		if (UCF_InputFieldHelpButton["bHasScrollbar"](oCurrentRef)) {
			return iMinimum;
		}
	}

	return iMinimum;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOffsetLeftMinimumOfParents"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   bHasScrollbar ----------------------------------------------------
/**
 * @private
 * @static
 * @param {HTMLElement} oDomRef the element to be checked for scrollbars
 * @return {boolean} `true` if the element has/can have any scrollbars,
 * otherwise `false`
 */
UCF_InputFieldHelpButton["bHasScrollbar"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bHasScrollbar"]++; }; 
	/** @type {CSSStyleDeclaration} */
	var oComputedStyle = UCF_DomUtil["oGetComputedStyle"](oDomRef);

	return 'auto' === oComputedStyle["overflow"]
		|| 'auto' === oComputedStyle["overflowX"]
		|| 'auto' === oComputedStyle["overflowY"]
		|| 'scroll' === oComputedStyle["overflow"]
		|| 'scroll' === oComputedStyle["overflowX"]
		|| 'scroll' === oComputedStyle["overflowY"];
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bHasScrollbar"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetMinimumOffsetLeftRtlAdjustment -------------------------------
/**
 * In SapTables/SapTableCSs, the oRect.left is miscalculated by 1px (Firefox) /
 * -1px (other browsers).
 *
 * @private
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the usage kind
 * @return {number} pixels to adjust in rtl
 */
UCF_InputFieldHelpButton["iGetMinimumOffsetLeftRtlAdjustment"] = function(eUsage) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetMinimumOffsetLeftRtlAdjustment"]++; }; 
	return (
			eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTable"] ||
			eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"] ||
			eUsage === UCF_InputFieldHelpButton["E_USAGES"]["DataGrid"]
		)
		? UCF_UserAgent["bIsGecko"]()
		? 2 : 1
		: 0;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetMinimumOffsetLeftRtlAdjustment"] = 0; };
// #endregion
// #region   iGetPopupWindowOffsetLeftAdjustment ------------------------------
/**
 * In RTL, in PopupWindows, the oRect.left is miscalculated by the difference
 * between the inner border (`$Id + '-ib'`) of the PopupWindow and the
 * PopupWindow itself.
 *
 * @private
 * @param {HTMLElement} oConnectedRef the DOM element the help button is
 * connected to
 * @return {number} the number of pixels the PopupWindow is shifted to the left
 */
UCF_InputFieldHelpButton["prototype"]["iGetPopupWindowOffsetLeftAdjustment"] = function(oConnectedRef) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetPopupWindowOffsetLeftAdjustment"]++; }; 
	/** @type {UCF_PopupWindow} */
	var oPopupWindow;

	if (UCF_DomUtil["bIsRTL"]) {
		oPopupWindow = this["oConnectedControl"]["oGetParentPopupWindow"]();
		if (oPopupWindow) {
			return Math["max"](
				0,
				UCF_DomUtil["$"](oPopupWindow["sGetId"]() + '-ib')["offsetWidth"] -
				oPopupWindow["oDomRef"]["offsetWidth"]
			);
		}
	}

	return 0;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetPopupWindowOffsetLeftAdjustment"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iGetOffsetTop ----------------------------------------------------
/**
 * @private
 * @param {_ObjectRect} oRect the rect of the InputFieldHelpButton
 * @param {HTMLElement} oConnectedRef the connected ref
 * @param {CSSStyleDeclaration} oConnectedRefCS the computed style for the
 * connected control
 * @param {CSSStyleDeclaration} oPositionContainerCS the computed style for the
 * position container
 * @return {number} offset of the InputFieldHelpButton to the top in pixels
 */
UCF_InputFieldHelpButton["prototype"]["iGetOffsetTop"] = function(oRect, oConnectedRef, oConnectedRefCS, oPositionContainerCS) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOffsetTop"]++; }; 
	/** @type {number} */
	var iOffsetTop = this["oPositionContainer"]
		? -(
			parseInt(oPositionContainerCS["paddingTop"]) ||
			parseInt(oPositionContainerCS["padding"]) ||
			0
		)
		: 0;

	oRect["top"] += UCF_InputFieldHelpButton["iSafariTopAdjustment"](this["eUsage"]);
	oRect["top"] += UCF_InputFieldHelpButton["iIETopAdjustment"](
		this["eUsage"],
		oConnectedRef
	);
	// oRect.top += UCF_InputFieldHelpButton.iFirefoxTopAdjustment(this.eUsage);
	oRect["top"] += UCF_InputFieldHelpButton["iChromiumTopAdjustment"](this["eUsage"]);

	if (this["oConnectedControl"]["bFieldHelpEmbedding"]) {
		iOffsetTop += parseInt(oConnectedRefCS["borderTopWidth"]) || 0;
	}

	if (
		this["eUsage"] === UCF_InputFieldHelpButton["E_USAGES"]["SapTable"] ||
		this["eUsage"] === UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"] ||
		// this.eUsage === UCF_InputFieldHelpButton.E_USAGES.SapTableAtControl ||
		// this.eUsage === UCF_InputFieldHelpButton.E_USAGES.SapTableCSAtControl ||
		this["eUsage"] === UCF_InputFieldHelpButton["E_USAGES"]["DataGrid"]
	) {
		iOffsetTop -= 1;
	}

	return oRect["top"] + iOffsetTop;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iGetOffsetTop"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iSafariTopAdjustment ---------------------------------------------
/**
 * In (macOS?) Safari with retina screen (devicePixelRatio > 1), in SapTables,
 * oRect.top is miscalculated by 2px.
 *
 * @private
 * @static
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the usage position of the
 * connected control
 * @return {number} in px
 */
UCF_InputFieldHelpButton["iSafariTopAdjustment"] = function(eUsage) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iSafariTopAdjustment"]++; }; 
	return (
			(
				eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTableAtControl"] ||
				eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTable"]
			) &&
			UCF_UserAgent["bIsSafari"]() &&
			window["devicePixelRatio"] &&
			window["devicePixelRatio"] > 1
		)
		? -2 // eslint-disable-line no-magic-numbers
		: 0;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iSafariTopAdjustment"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iFirefoxTopAdjustment ---------------------------------------------
/**
 * @private
 * @static
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the usage position of the
 * connected control
 * @return {number} in px
 */
UCF_InputFieldHelpButton["iFirefoxTopAdjustment"] = function(eUsage) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iFirefoxTopAdjustment"]++; }; 
	return (
			(
				eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTableAtControl"] ||
				eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTable"]
			) &&
			UCF_UserAgent["bIsGecko"]()
		)
		? 1 // eslint-disable-line no-magic-numbers
		: 0;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iFirefoxTopAdjustment"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iChromiumTopAdjustment -------------------------------------------
/**
 * In IE / Edge, in a SapTable, the top offset of the connected
 * ref in getBoundingClientRect() is a decimal like 98.5.
 * It seems Chromium is rounding differently to UR / math().
 *
 * @private
 * @static
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the usage position of the
 * connected control
 * @return {number} in px
 */
UCF_InputFieldHelpButton["iChromiumTopAdjustment"] = function(eUsage) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iChromiumTopAdjustment"]++; }; 
	return (
			(
				eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTableAtControl"] ||
				eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTable"]
			) &&
			UCF_UserAgent["bIsChromium"]()
		)
		? -1 // eslint-disable-line no-magic-numbers
		: 0;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iChromiumTopAdjustment"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iChromeRtlBorderAdjustment ---------------------------------------
/**
 * In RTL, in Chrome, in SapTableCSs, the oRect.left is miscalculated by the
 * sum of border-left-widths of the offsetParents of the connected ref.
 *
 * @private
 * @static
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the usage position of the
 * connected control
 * @param {HTMLElement} oConnectedRef the connected element
 * @return {number}
 */
UCF_InputFieldHelpButton["iChromeRtlBorderAdjustment"] = function(eUsage, oConnectedRef) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iChromeRtlBorderAdjustment"]++; }; 
	/** @type {number} */
	var iBorderWidth;
	/** @type {HTMLElement} */
	var oOffsetParent;
	/** @type {number} */
	var iOffsetParentBorderWidth;

	if (
		// eUsage === UCF_InputFieldHelpButton.E_USAGES.SapTableCSAtControl ||
		eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"] &&
		UCF_UserAgent["bIsChromium"]()
	) {
		iBorderWidth = 0;
		oOffsetParent = oConnectedRef["offsetParent"];

		while (oOffsetParent) {
			iOffsetParentBorderWidth = parseInt(
				UCF_DomUtil["sGetCurrentStyle"](oOffsetParent, 'border-left-width')
			);

			iBorderWidth += isNaN(iOffsetParentBorderWidth)
				? 0
				: iOffsetParentBorderWidth;

			oOffsetParent = oOffsetParent["offsetParent"];
		}

		return iBorderWidth;
	} else {
		return 0;
	}

};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iChromeRtlBorderAdjustment"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iFirefoxRtlScrollbarAdjustment -----------------------------------
/**
 * In RTL, in Firefox, oRect.left is miscalculated by the width of a visible
 * scrollbar of the position container.
 *
 * @private
 * @static
 * @param {HTMLElement} oPositionContainer the position container
 * @return {number} in px
 */
UCF_InputFieldHelpButton["iFirefoxRtlScrollbarAdjustment"] = function(oPositionContainer) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iFirefoxRtlScrollbarAdjustment"]++; }; 
	/** @type {number} */
	var iScrollWidth;
	/** @type {number} */
	var iOffsetWidth;

	if (oPositionContainer && UCF_UserAgent["bIsFirefox"]()) {
		iScrollWidth = oPositionContainer["scrollWidth"];
		iOffsetWidth = oPositionContainer["offsetWidth"];

		if (iOffsetWidth > iScrollWidth) {
			return iScrollWidth - iOffsetWidth;
		}
	}

	return 0;
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iFirefoxRtlScrollbarAdjustment"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   iIETopAdjustment -------------------------------------------------
/**
 * @private
 * @static
 * @param {UCF_InputFieldHelpButton_Usage} eUsage the usage position of the
 * connected control
 * @param {HTMLElement} oConnectedRef the connected element
 * @return {number} in px
 */
UCF_InputFieldHelpButton["iIETopAdjustment"] = function(eUsage, oConnectedRef) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iIETopAdjustment"]++; }; 
	if (
		// (eUsage === UCF_InputFieldHelpButton.E_USAGES.SapTableAtControl ||
		eUsage === UCF_InputFieldHelpButton["E_USAGES"]["SapTable"] &&
		(UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())
	) {
		return (!oConnectedRef["getBoundingClientRect"] ||
				!UCF_InputFieldHelpButton["bDidRoundDown"](
					oConnectedRef["getBoundingClientRect"]()["top"]
				)
			)
			? -1
			: 0;
	} else {
		return 0;
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["iIETopAdjustment"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   bDidRoundDown ----------------------------------------------------
/**
 * @private
 * @static
 * @param {number} fDetailedPosition position given by getBoundingClientRect()
 * @return {boolean}
 */
UCF_InputFieldHelpButton["bDidRoundDown"] = function(fDetailedPosition) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bDidRoundDown"]++; }; 
	return Math["floor"](fDetailedPosition) === Math["round"](fDetailedPosition);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["bDidRoundDown"] = 0; };
// #endregion -----------------------------------------------------------------
// #endregion =================================================================
// #region Browser Events =====================================================
// #region   AnyEvent ---------------------------------------------------------
/**
 * @private
 * @param {UCF_Event} oEvent the anyevent
 */
UCF_InputFieldHelpButton["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onAnyEvent"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');

	switch (oBrowserEvent["sGetName"]()) {
		case 'scroll':
			if (this["oPositionContainer"] === oBrowserEvent["oGetSource"]()) {
				this["setPosition"]();
			}
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onAnyEvent"] = 0; };

/** @private */
UCF_InputFieldHelpButton["prototype"]["attachAnyEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["attachAnyEvent"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow = this["oLS"] && this["oLS"]["oBrowserWindow"];

	if (oBrowserWindow && !this["bIsAnyEventListenerAttached"]) {
		oBrowserWindow["attachEvent"](
			oBrowserWindow["E_EVENTS"]["AnyEvent"],
			this,
			'onAnyEvent'
		);
		this["bIsAnyEventListenerAttached"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["attachAnyEvent"] = 0; };

/** @private */
UCF_InputFieldHelpButton["prototype"]["detachAnyEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["detachAnyEvent"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow = this["oLS"] && this["oLS"]["oBrowserWindow"];

	if (oBrowserWindow && this["bIsAnyEventListenerAttached"]) {
		oBrowserWindow["detachEvent"](
			oBrowserWindow["E_EVENTS"]["AnyEvent"],
			this,
			'onAnyEvent'
		);
		this["bIsAnyEventListenerAttached"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["detachAnyEvent"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   SapTableCSScrolling ----------------------------------------------
/** @private */
UCF_InputFieldHelpButton["prototype"]["attachSapTableCSScrolling"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["attachSapTableCSScrolling"]++; }; 
	/** @type {UCF_SapTableCS} */
	var oSapTableCS;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["eUsage"] === UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"] || this["eUsage"] === UCF_InputFieldHelpButton["E_USAGES"]["SapTableCSAtControl"], "this.eUsage === UCF_InputFieldHelpButton.E_USAGES.SapTableCS || this.eUsage === UCF_InputFieldHelpButton.E_USAGES.SapTableCSAtControl", "InputFieldHelpButton.js(1534): attachSapTableCSScrolling"); };

	oSapTableCS = this["oGetUsageControl"]();

	if (oSapTableCS) {
		if (
			UCF_JsUtil["bInstanceOf"](oSapTableCS["oScrollV"], 'UCF_EventProvider') &&
			oSapTableCS["oScrollV"]["E_EVENTS"]
		) {
			oSapTableCS["oScrollV"]["attachEvent"](
				oSapTableCS["oScrollV"]["E_EVENTS"]["Scroll"],
				this,
				'setPosition'
			);
		}
		if (
			UCF_JsUtil["bInstanceOf"](oSapTableCS["oScrollH"], 'UCF_EventProvider') &&
			oSapTableCS["oScrollH"]["E_EVENTS"]
		) {
			oSapTableCS["oScrollH"]["attachEvent"](
				oSapTableCS["oScrollH"]["E_EVENTS"]["Scroll"],
				this,
				'setPosition'
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["attachSapTableCSScrolling"] = 0; };

/** @private */
UCF_InputFieldHelpButton["prototype"]["detachSapTableCSScrolling"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["detachSapTableCSScrolling"]++; }; 
	/** @type {UCF_SapTableCS} */
	var oSapTableCS;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["eUsage"] === UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"] || this["eUsage"] === UCF_InputFieldHelpButton["E_USAGES"]["SapTableCSAtControl"], "this.eUsage === UCF_InputFieldHelpButton.E_USAGES.SapTableCS || this.eUsage === UCF_InputFieldHelpButton.E_USAGES.SapTableCSAtControl", "InputFieldHelpButton.js(1567): detachSapTableCSScrolling"); };

	oSapTableCS = this["oGetUsageControl"]();

	if (oSapTableCS) {
		if (
			UCF_JsUtil["bInstanceOf"](oSapTableCS["oScrollV"], 'UCF_EventProvider') &&
			oSapTableCS["oScrollV"]["E_EVENTS"]
		) {
			oSapTableCS["oScrollV"]["detachEvent"](
				oSapTableCS["oScrollV"]["E_EVENTS"]["Scroll"],
				this,
				'setPosition'
			);
		}
		if (
			UCF_JsUtil["bInstanceOf"](oSapTableCS["oScrollH"], 'UCF_EventProvider') &&
			oSapTableCS["oScrollH"]["E_EVENTS"]
		) {
			oSapTableCS["oScrollH"]["detachEvent"](
				oSapTableCS["oScrollH"]["E_EVENTS"]["Scroll"],
				this,
				'setPosition'
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["detachSapTableCSScrolling"] = 0; };
// #endregion
// #region   RepositionListening ----------------------------------------------
/** @private */
UCF_InputFieldHelpButton["prototype"]["attachRepositionListening"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["attachRepositionListening"]++; }; 
	switch (this["eUsage"]) {
		case UCF_InputFieldHelpButton["E_USAGES"]["Standalone"]:
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTable"]:
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTableAtControl"]:
		case UCF_InputFieldHelpButton["E_USAGES"]["DataGrid"]:
			this["attachAnyEvent"]();
			break;
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"]:
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTableCSAtControl"]:
			this["attachSapTableCSScrolling"]();
			break;
		default: // UCF_InputFieldHelpButton.E_USAGES.Disconnected
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["attachRepositionListening"] = 0; };

/** @private */
UCF_InputFieldHelpButton["prototype"]["detachRepositionListening"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["detachRepositionListening"]++; }; 
	switch (this["eUsage"]) {
		case UCF_InputFieldHelpButton["E_USAGES"]["Standalone"]:
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTable"]:
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTableAtControl"]:
		case UCF_InputFieldHelpButton["E_USAGES"]["DataGrid"]:
			this["detachAnyEvent"]();
			break;
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTableCS"]:
		case UCF_InputFieldHelpButton["E_USAGES"]["SapTableCSAtControl"]:
			this["detachSapTableCSScrolling"]();
			break;
		default: // UCF_InputFieldHelpButton.E_USAGES.Disconnected
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["detachRepositionListening"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   click ------------------------------------------------------------
/**
 * Handles the click event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 * @private
 */
UCF_InputFieldHelpButton["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onclick"]++; }; 
	this["firePress"](oBrowserEvent["iOffsetY"]());

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onclick"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   dblclick ---------------------------------------------------------
/**
 * Events triggered by double click:
 * IE, Edge: click dblclick
 * FF, Safari, Chrome: click click dblclick
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the dblclick
 */
UCF_InputFieldHelpButton["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["ondblclick"]++; }; 
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		this["firePress"](oBrowserEvent["iOffsetY"]());
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["ondblclick"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   mousedown --------------------------------------------------------
/**
 * Handles the onmousedown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the mousedown
 * @private
 */
UCF_InputFieldHelpButton["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onmousedown"]++; }; 
	this["fireMousedown"](oBrowserEvent["iOffsetY"]());

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onmousedown"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   mouseup ----------------------------------------------------------
/** @private */
UCF_InputFieldHelpButton["prototype"]["onmouseup"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onmouseup"]++; }; 
	this["fireMouseup"]();
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onmouseup"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   mouseover --------------------------------------------------------
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseover
 */
UCF_InputFieldHelpButton["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onmouseover"]++; }; 
	this["fireMouseover"](oBrowserEvent["iOffsetY"]());
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onmouseover"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   mouseout ---------------------------------------------------------
/**
 * Handles the onmouseout event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseout
 */
UCF_InputFieldHelpButton["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onmouseout"]++; }; 
	this["fireMouseout"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["onmouseout"] = 0; };
// #endregion -----------------------------------------------------------------
// #endregion =================================================================
// #region Control Events =====================================================
// #region   Mousedown --------------------------------------------------------
/**
 * @private
 * @param {number} iY the y-offset of the mousedown
 * @fires UCF_InputFieldHelpButton.E_EVENTS.Mousedown
 */
UCF_InputFieldHelpButton["prototype"]["fireMousedown"] = function(iY) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireMousedown"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Mousedown"], {
		"sConnectedControlId": this["sGetConnectedControlId"](),
		"bIsOnUpperHalf": this["bIsOnUpperHalf"](iY)
	});
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireMousedown"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   Mouseup ----------------------------------------------------------
/**
 * @private
 * @fires UCF_InputFieldHelpButton.E_EVENTS.Mouseup
 */
UCF_InputFieldHelpButton["prototype"]["fireMouseup"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireMouseup"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Mouseup"], {
		"sConnectedControlId": this["sGetConnectedControlId"]()
	});
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireMouseup"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   Mouseover --------------------------------------------------------
/**
 * @private
 * @param {number} iY the y offset of the click event
 * @fires UCF_InputFieldHelpButton.E_EVENTS.Mouseover
 */
UCF_InputFieldHelpButton["prototype"]["fireMouseover"] = function(iY) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireMouseover"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Mouseover"], {
		"sConnectedControlId": this["sGetConnectedControlId"](),
		"bIsOnUpperHalf": this["bIsOnUpperHalf"](iY)
	});
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireMouseover"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   Mouseout ---------------------------------------------------------
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @fires UCF_InputFieldHelpButton.E_EVENTS.Mouseout
 */
UCF_InputFieldHelpButton["prototype"]["fireMouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireMouseout"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Mouseout"], {
		"sConnectedControlId": this["sGetConnectedControlId"](),
		"oBrowserEvent": oBrowserEvent
	});
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireMouseout"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   Press ------------------------------------------------------------
/**
 * @private
 * @param {number} iY the y offset of the click event
 * @fires UCF_InputFieldHelpButton.E_EVENTS.Press
 */
UCF_InputFieldHelpButton["prototype"]["firePress"] = function(iY) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["firePress"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Press"], {
		"sConnectedControlId": this["sGetConnectedControlId"](),
		"bIsOnUpperHalf": this["bIsOnUpperHalf"](iY)
	});
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["firePress"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   Connect ----------------------------------------------------------
/**
 * @private
 * @param {number} iWidth the width of the help button, in px
 * @fires UCF_InputFieldHelpButton.E_EVENTS.Connect
 */
UCF_InputFieldHelpButton["prototype"]["fireConnect"] = function(iWidth) {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireConnect"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Connect"], {
		"sConnectedControlId": this["sGetConnectedControlId"](),
		"iWidth": iWidth
	});
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireConnect"] = 0; };
// #endregion -----------------------------------------------------------------
// #region   Disconnect -------------------------------------------------------
/**
 * @private
 * @fires UCF_InputFieldHelpButton.E_EVENTS.Disconnect
 */
UCF_InputFieldHelpButton["prototype"]["fireDisconnect"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireDisconnect"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Disconnect"], {
		"sConnectedControlId": this["sGetConnectedControlId"](),
		"bHasFocus": this["bHasFocus"]()
	});
};;if (__UCF_COVERAGE__) { UCF_InputFieldHelpButton["_"]["fireDisconnect"] = 0; };
// #endregion -----------------------------------------------------------------
// #endregion =================================================================

};
sap["ls"]["preload"]["UCF_InputFieldInplaceEdit"] = function() {/* global UCF_InputField */
/// <reference path="./InputField.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>

/**
 * 
 * @class
 * @param {HTMLElement} oDomRef the DOM element that represents the control
 * @param {UCF_LS} oLS the lightspeed instance that manages the control
 */
function UCF_InputFieldInplaceEdit(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["UCF_InputFieldInplaceEdit"]++; }; 
	UCF_InputField["apply"](this, [oDomRef, oLS]);

	this["attachEvent"](
		this["E_EVENTS"]["WillDestroy"],
		this,
		'onWillDestroyInputFieldInplaceEdit'
	);
};window["UCF_InputFieldInplaceEdit"] = UCF_InputFieldInplaceEdit; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_InputFieldInplaceEdit"); UCF_InputFieldInplaceEdit["_"] = {UCF_InputFieldInplaceEdit: 0}; }; ;
UCF_InputFieldInplaceEdit["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_InputField"))(); UCF_InputFieldInplaceEdit.prototype["sClassName"] = "UCF_InputFieldInplaceEdit";

// ===== initialize ===========================================================

/** @override */
UCF_InputFieldInplaceEdit["prototype"]["onAfterInitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onAfterInitialize"]++; }; 
	this["adaptWidth"]();
	UCF_InputField.prototype["onAfterInitialize"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onAfterInitialize"] = 0; };

/** @private */
UCF_InputFieldInplaceEdit["prototype"]["adaptWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["adaptWidth"]++; }; 
	/** @type {HTMLSpanElement} */
	var oCloneDomRef;
	/** @type {CSSStyleDeclaration} */
	var oComputedStyle;
	/** @type {number} */
	var iOffsetWidth;

	if (this["bShouldAdaptWidth"]()) {
		oCloneDomRef = document["createElement"]('div');
		oCloneDomRef["className"] = this["oDomRef"]["className"];
		oCloneDomRef["style"]["position"] = 'absolute';
		oCloneDomRef["style"]["top"] = '-1000px';
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](oCloneDomRef, this["oDomRef"]["value"]["replace"](/ /g, '&nbsp;'));
		this["oLS"]["oGetAssociatedAreaRef"]()["appendChild"](oCloneDomRef);

		oComputedStyle = UCF_DomUtil["oGetComputedStyle"](this["oDomRef"]);

		iOffsetWidth = Math["max"](
			oCloneDomRef["offsetWidth"] +
			(parseInt(oComputedStyle["borderLeftWidth"]) || 0) +
			(parseInt(oComputedStyle["borderRightWidth"]) || 0) +
			(parseInt(oComputedStyle["paddingLeft"]) || 0) +
			(parseInt(oComputedStyle["paddingRight"]) || 0),
			// eslint-disable-next-line no-magic-numbers
			20
		);

		this["oLS"]["oGetAssociatedAreaRef"]()["removeChild"](oCloneDomRef);

		this["oDomRef"]["style"]["width"] = iOffsetWidth + 'px';
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["adaptWidth"] = 0; };

/**
 * @private
 * @return {boolean} `true` if the width should be adapted, otherwise `false`
 */
UCF_InputFieldInplaceEdit["prototype"]["bShouldAdaptWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["bShouldAdaptWidth"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'InputFieldShouldInitializeInplaceEdit',
		'InputField', {
			"DisplayAsText": this["bDisplayAsText"],
			"InputPrompt": this["sInputPrompt"],
			"UsedInSapTable": this["bUsedInSapTable"],
			"Width": this["sWidth"]
		}
	);
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["bShouldAdaptWidth"] = 0; };

// ===== destroy ==============================================================

/**
 * @private
 * @override
 */
UCF_InputFieldInplaceEdit["prototype"]["onWillDestroyInputFieldInplaceEdit"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onWillDestroyInputFieldInplaceEdit"]++; }; 
	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sTimeOutIdInplace"] = null;
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onWillDestroyInputFieldInplaceEdit"] = 0; };

// ===== click ================================================================

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_InputFieldInplaceEdit["prototype"]["onBeforeClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onBeforeClick"]++; }; 
	if (this["bIsWriteable"]()) {
		this["enterEditMode"]();
	}
	UCF_InputField.prototype["onBeforeClick"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onBeforeClick"] = 0; };

// ===== lsfocus ==============================================================

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_InputFieldInplaceEdit["prototype"]["onBeforeLsFocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onBeforeLsFocus"]++; }; 
	if (this["bIsWriteable"]()) {
		this["enterEditMode"]();
	}
	UCF_InputField.prototype["onBeforeLsFocus"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onBeforeLsFocus"] = 0; };

// ===== lsblur ===============================================================

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsblur
 */
UCF_InputFieldInplaceEdit["prototype"]["onBeforeLsBlur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onBeforeLsBlur"]++; }; 
	if (this["bIsWriteable"]()) {
		if (this["sTimeOutIdInplace"]) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutIdInplace"]);
		}
		this["sTimeOutIdInplace"] = UCF_JsUtil["delayedCall"](
			200, // eslint-disable-line no-magic-numbers
			this,
			'enterViewMode'
		);
	}
	UCF_InputField.prototype["onBeforeLsBlur"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onBeforeLsBlur"] = 0; };

// ===== keydown ==============================================================

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the keydown
 */
UCF_InputFieldInplaceEdit["prototype"]["onAfterKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onAfterKeydown"]++; }; 
	if (this["bIsWriteable"]()) {
		this["adaptWidth"]();
	}
	UCF_InputField.prototype["onAfterKeydown"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onAfterKeydown"] = 0; };

// ===== lsenter ==============================================================

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsenter
 */
UCF_InputFieldInplaceEdit["prototype"]["onAfterLsEnter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onAfterLsEnter"]++; }; 
	if (this["bIsWriteable"]()) {
		this["onlsblur"](oBrowserEvent);
	}
	UCF_InputField.prototype["onAfterLsEnter"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onAfterLsEnter"] = 0; };

// ===== mouseover ============================================================

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseover
 */
UCF_InputFieldInplaceEdit["prototype"]["onAfterMouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onAfterMouseover"]++; }; 
	if (oBrowserEvent["oGetSource"]() === this["oDomRef"]) {
		this["showButton"]();
		this["updateStyles"]();
	}
	UCF_InputField.prototype["onAfterMouseover"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onAfterMouseover"] = 0; };

// ===== mouseout =============================================================

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseout
 */
UCF_InputFieldInplaceEdit["prototype"]["onAfterMouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onAfterMouseout"]++; }; 
	/** @type {Element} */
	var oRelatedTarget;
	/** @type {UCF_Control} */
	var oRelatedControl;

	oRelatedTarget = UCF_DomUtil["oGetRelatedTarget"](oBrowserEvent["oDomEvent"]);
	oRelatedControl = this["oLS"]["oGetControlByDomRef"](oRelatedTarget);
	if (!this["bIsOpen"]() && !this["bHasVisibleFocus"]() && (!oRelatedControl || !this["bIsConnectedControl"](oRelatedControl))) {
		this["hideButton"]();
		this["updateStyles"]();
	}
	UCF_InputField.prototype["onAfterMouseout"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["onAfterMouseout"] = 0; };

// ===== edit mode ============================================================

/** @private */
UCF_InputFieldInplaceEdit["prototype"]["enterEditMode"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["enterEditMode"]++; }; 
	if (this["bIsWriteable"]()) {
		this["adaptWidth"]();
		this["selectText"]();
	}
	if (this["sWidth"]) {
		this["oDomRef"]["removeAttribute"]('readOnly');;
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["enterEditMode"] = 0; };

/**
 * selects the whole text of the inputfield
 * @private
 */
UCF_InputFieldInplaceEdit["prototype"]["selectText"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["selectText"]++; }; 
	this["oDomRef"]["select"]();
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["selectText"] = 0; };

// ===== view mode ============================================================

/** @private */
UCF_InputFieldInplaceEdit["prototype"]["enterViewMode"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["enterViewMode"]++; }; 
	if (this["sWidth"]) {
		this["oDomRef"]["setAttribute"]('readOnly', '-1');
	}
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["enterViewMode"] = 0; };

/**
 * Destructor
 */
UCF_InputFieldInplaceEdit["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["destroy"]++; }; 

	UCF_InputField.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputFieldInplaceEdit["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_InputTokenizer"] = function() {/* global _assert, _trace, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_SuggestBox */
/// <reference path="./SuggestBox.js"/>

/**
 * 
 * @version
 *
 * @class
 * @extends UCF_SuggestBox
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_InputTokenizer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["UCF_InputTokenizer"]++; }; 
	if (arguments["length"] == 0) return;
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "InputTokenizer.js(25): UCF_InputTokenizer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "InputTokenizer.js(26): UCF_InputTokenizer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "InputTokenizer.js(27): UCF_InputTokenizer"); };

	//### InputTokenizer specific: Determine predefined values needed for inherited controls###
	this["sBehavior"] = "FREETEXT";
	this["bInvalid"] = this["sInputState"] == "ERROR";
	this["bShowRequiredIndicator"] = false;
	this["bAllowVirtualTyping"] = false;
	this["sFieldHelp"] = "F4LOOKUP";
	if (this["bDisplayAsText"]) {
		this["bHideFieldHelp"] = true;
		this["setClientProperty"]("HideFieldHelp", this["bHideFieldHelp"], true);
	}

	UCF_SuggestBox["apply"](this, [oDomRef, oLS]);

	this["sOldValue"] = this["oDomRef"]["value"];
	this["createTokens"]();
	this["sCameFrom"] = null;
	this["bDropOccured"] = false;
};window["UCF_InputTokenizer"] = UCF_InputTokenizer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_InputTokenizer"); UCF_InputTokenizer["_"] = {UCF_InputTokenizer: 0}; }; ;
UCF_InputTokenizer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SuggestBox"))(); UCF_InputTokenizer.prototype["sClassName"] = "UCF_InputTokenizer";

/**
 * Sets a fixed width, since italic changes the width of the input field
 *
 * @private
 */
UCF_InputTokenizer["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["initialize"]++; }; 
	if (this["sInputPrompt"]) {
		var iWidth = this["oDomRef"]["offsetWidth"];
		this["oDomRef"]["style"]["width"] = iWidth + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["initialize"] = 0; };

/**
 * @override
 * @private
 */
UCF_InputTokenizer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["destroy"]++; }; 
	this["sOldValue"] = null;
	this["bHasClickableToken"] = null;

	UCF_SuggestBox.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["destroy"] = 0; };

/**
 * Handles the click event in the input tokenizer.
 * Selects texts that is regarded as a valid token.
 * Fires the FieldHelpPress event on the F4 button.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputTokenizer["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InputTokenizer.js(81): onclick"); };

	var oSource = oBrowserEvent["oGetSource"]();

	if (this["oDomRef"]["value"] != "" && this["bIsValidToken"]() && this["bEnabled"] && oSource == this["oDomRef"]) {
		UCF_DomUtil["setSelection"](this["oDomRef"], 0, this["oDomRef"]["value"]["length"]);
	}
	UCF_SuggestBox.prototype["onclick"]["apply"](this, arguments);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onclick"] = 0; };

/**
 * Handles a selection on deactivate. Avoids that the text in the
 * inputtokenizer remains selected, if the user clicks anywhere else on the screen.
 * This works in FF because we use the Range object instead of the MS proprietary TextRange object.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputTokenizer["prototype"]["ondeactivate"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["ondeactivate"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InputTokenizer.js(101): ondeactivate"); };
	try {
		var oTextRange = document["selection"]["createRange"]();
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oTextRange != null, "oTextRange != null", "InputTokenizer.js(104): ondeactivate"); };
		if (this["bIsSelected"]()) {
			oTextRange["collapse"]();
			oTextRange["select"]();
		}
	} catch (oException) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Textrange create failed", "InputTokenizer.js(110): ondeactivate"); };
	}
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["ondeactivate"] = 0; };

/**
 * Handles the ondblclick event of the browser. Fires the semantic event: Navigate if
 * tokenizer is flagged as hasClickableToken.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputTokenizer["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InputTokenizer.js(122): ondblclick"); };
	if (!this["bHasClickableToken"] || !this["bIsValidToken"]() || !this["bEnabled"]) return;
	this["fireNavigate"](this["sId"]);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["ondblclick"] = 0; };

/**
 * Handles the keydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputTokenizer["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InputTokenizer.js(135): onkeydown"); };

	var iKey = oBrowserEvent["iKeyCode"]();

	if (!this["bIsValidToken"]() || (this["oFieldHelp"] && this["oFieldHelp"]["bOpened"])) {
		UCF_SuggestBox.prototype["onkeydown"]["apply"](this, arguments);
		return;
	}
	this["bCancelKeyUp"] = false;
	var bMoveToStart = iKey == UCF_KeyCodes["ARROW_LEFT"] || iKey == UCF_KeyCodes["ARROW_UP"],
		bMoveToEnd = iKey == UCF_KeyCodes["ARROW_RIGHT"] || iKey == UCF_KeyCodes["ARROW_DOWN"],
		oDomRef = this["oDomRef"],
		iEndPosition = oDomRef["value"]["length"];

	if (this["oNavigation"]["bIsEditMode"]() && (bMoveToStart || bMoveToEnd)) {
		//Shift is not pressed: only move cursor to start or end position of token
		if (!oBrowserEvent["bShift"]()) {
			UCF_DomUtil["setCursorPos"](oDomRef, bMoveToStart ? 0 : iEndPosition);
		}
		//Shift is pressed: Select and deselect the whole token
		else if (oBrowserEvent["bShift"]()) {
			//right arrow key was pressed
			if (bMoveToEnd) {
				//the token is not selected and the cursor is at start position: select the token
				if (!this["bIsSelected"]() && this["bCursorAtStart"]()) {
					UCF_DomUtil["setSelection"](oDomRef, 0, iEndPosition);
					this["sCameFrom"] = "START";
					oBrowserEvent["cancel"]();
					return;
				}
				//the token is selected: put cursor at end position
				else if (this["bIsSelected"]() && this["sCameFrom"] == "END") {
					UCF_DomUtil["setCursorPos"](oDomRef, iEndPosition);
					oBrowserEvent["cancel"]();
				}
			}
			//left arrow key was pressed
			else if (bMoveToStart) {
				// the token is not selected and the cursor is at end position: select the token
				if ((!this["bIsSelected"]() && this["bCursorAtEnd"]()) || (this["bIsSelected"]() && this["sCameFrom"] == "END")) {
					UCF_DomUtil["setSelection"](oDomRef, 0, iEndPosition);
					this["sCameFrom"] = "END";
					oBrowserEvent["cancel"]();
					return;
				}
				//the token is selected: put cursor at start position
				else if (this["bIsSelected"]() && this["sCameFrom"] == "START") {
					UCF_DomUtil["setCursorPos"](oDomRef, 0);
				}
			}
		}
	}
	//cursor is at end position and backspace was pressed or cursor is at start position and delete was pressed: delete token as a whole
	else if ((iKey == UCF_KeyCodes["BACKSPACE"] && this["bCursorAtEnd"]()) || (iKey == UCF_KeyCodes["DELETE"] && this["bCursorAtStart"]())) {
		oDomRef["value"] = "";
		this["setInitStatus"]();
	} else if (!this["bIsFunctionKey"](iKey)) {
		// allow typing if token is selected
		//ALT+TAB: avoid that valid token is accidatially turned to an invalid
		//todo: find out another way to check whether user tries to type text
		if (this["bIsSelected"]() && ((!oBrowserEvent["bCtrl"]() || (oBrowserEvent["bCtrl"]() && iKey == UCF_KeyCodes["V"])) && (!oBrowserEvent["bAlt"]() && iKey != UCF_KeyCodes["TAB"]))) {
			this["setInitStatus"]();
			// suppress typing, if cursor is at start or end position
		} else if (this["bCursorAtEnd"]() || this["bCursorAtStart"]()) {
			this["bCancelKeyUp"] = true;
			oBrowserEvent["cancel"]();
			return;
		}
	}
	// F2 simulates double click event
	else if (iKey == UCF_KeyCodes["F2"] && this["bHasClickableToken"] && this["bIsValidToken"]() && this["bEnabled"]) {
		this["fireNavigate"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
	UCF_SuggestBox.prototype["onkeydown"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onkeydown"] = 0; };
/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputTokenizer["prototype"]["onkeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onkeyup"]++; }; 
	if (this["bCancelKeyUp"]) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}
	if (this["oDomRef"]["value"] != this["sOldValue"]) {
		this["setInitStatus"]();
	}
	UCF_SuggestBox.prototype["onkeyup"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onkeyup"] = 0; };

/**
 * checks whether the cursor is at start position
 */
UCF_InputTokenizer["prototype"]["bCursorAtStart"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bCursorAtStart"]++; }; 
	return (UCF_DomUtil["iGetSelectionStart"](this["oDomRef"]) == UCF_DomUtil["iGetSelectionEnd"](this["oDomRef"]) && UCF_DomUtil["iGetCursorPos"](this["oDomRef"]) == 0);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bCursorAtStart"] = 0; };

/**
 * Handles the drop event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputTokenizer["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onlsfocus"]++; }; 
	//this is the drop case in the field. focus will be fired right after the drop
	//Problem wenn der drop case beim focus gehandhabt wird: FF geht nach dem Selektieren eines Listenitems hier rein IE tut es nicht. Das liegt daran,
	// dass FF den programmatische focus Aufruf von SuggestBox.onListBoxSelect vor dem close event ausführt.
	// IE macht das anders rum. Das sorgt dafür, dass nach dem Schließen der Liste die setInitStatus Funktion ausgeführt wird
	// und der Unterstrich wieder weggenommen wird.
	if (this["bDropOccured"] && this["oDomRef"]["value"] != this["sOldValue"]) {
		this["bCancelKeyUp"] = false;
		this["setInitStatus"]();
		this["bDropOccured"] = false;
	}
	UCF_SuggestBox.prototype["onlsfocus"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onlsfocus"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputTokenizer["prototype"]["ondrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["ondrop"]++; }; 
	this["bDropOccured"] = true;
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["ondrop"] = 0; };

/**
 * Handles the change event
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputTokenizer["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onlsblur"]++; }; 
	//this is the drag case in the field. blur will be fired right after the drag
	if (this["oDomRef"]["value"] == "") {
		this["setInitStatus"]();
	}
	UCF_SuggestBox.prototype["onlsblur"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onlsblur"] = 0; };
/**
 * checks whether the cursor is at end position
 * @private
 */
UCF_InputTokenizer["prototype"]["bCursorAtEnd"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bCursorAtEnd"]++; }; 
	return (UCF_DomUtil["iGetSelectionStart"](this["oDomRef"]) == UCF_DomUtil["iGetSelectionEnd"](this["oDomRef"]) && UCF_DomUtil["iGetCursorPos"](this["oDomRef"]) == this["oDomRef"]["value"]["length"]);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bCursorAtEnd"] = 0; };

/**
 * @private
 */
UCF_InputTokenizer["prototype"]["bIsSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bIsSelected"]++; }; 
	return (UCF_DomUtil["iGetSelectionStart"](this["oDomRef"]) == 0 && UCF_DomUtil["iGetSelectionEnd"](this["oDomRef"]) == this["oDomRef"]["value"]["length"] && this["oDomRef"]["value"]["length"] > 0);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bIsSelected"] = 0; };

/**
 * Handles the enter key
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputTokenizer["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InputTokenizer.js(296): onlsenter"); };

	// if list box is open, copy slected item and close listbox
	if (this["bOpen"]) {
		var sKey = this["oFieldHelp"]["sGetSelectedItemKey"]();
		var sValue = "";
		if (sKey != null) {
			sValue = this["oFieldHelp"]["sGetItemValue"](sKey);
			this["updateValue"](sKey, sValue, true);
			this["sOldValue"] = sValue;
			this["markAsTokenWithAction"](false);
		}
		this["selectText"](sValue);
		this["onTokenListSelect"]();

		this["closeFieldHelp"]();
	}

	try {
		this["prepareFireChange"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} catch (oException) {
		this["handleEarlyHandlerLeave"](oException);
	}

	// fire enter event
	if (this["mEvents"]["Enter"]) {
		this["fireEnter"](this["sId"], this["sGetValue"]());
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onlsenter"] = 0; };

/**
 * Change the design of the tokenizer value to that of a normal text
 * @private
 */
UCF_InputTokenizer["prototype"]["setInitStatus"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["setInitStatus"]++; }; 

	if (this["bReadonly"] || !this["bEnabled"]) return;

	if (this["bHasClickableToken"]) {
		this["sTextStyle"] = 'UNDERLINE';
		if (this["bEnabled"]) {
			this["sTextStyle"] = 'UNDERLINE_HOTSPOT';
		}
	} else {
		this["sTextStyle"] = 'NORMAL';
	}
	this["updateStyles"]();
	this["sKey"] = "";
	this["setClientProperty"]("Key", this["sKey"], true);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["setInitStatus"] = 0; };

/**
 * If a key is defined for the search string it is a valid token
 * @private
 */
UCF_InputTokenizer["prototype"]["bIsValidToken"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bIsValidToken"]++; }; 
	return this["sKey"] != "";
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bIsValidToken"] = 0; };

/**
 * Registers to the select event of the list box
 * @private
 */
UCF_InputTokenizer["prototype"]["openFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["openFieldHelp"]++; }; 
	this["getListBox"]();
	if (this["oFieldHelp"] != null) {
		this["oFieldHelp"]["attachEvent"](this["oFieldHelp"]["E_EVENTS"]["Select"], this, "onTokenListSelect");
		this["oFieldHelp"]["attachEvent"](this["oFieldHelp"]["E_EVENTS"]["Close"], this, "onTokenListClose");
		this["setInitStatus"]();
	}
	//super call must be here
	UCF_SuggestBox.prototype["openFieldHelp"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["openFieldHelp"] = 0; };

/**
 * Handles the select event of the list box.
 * Everything that comes from the suggest box is regarded a valid token.
 * @private
 */
UCF_InputTokenizer["prototype"]["onTokenListSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onTokenListSelect"]++; }; 

	var sKey = (oEvent != null) ? oEvent["oGetParam"]("sKey") : this["sKey"],
		bHasAction = this["bGetTokenWithAction"](sKey);
	if (this["oFieldHelp"] && this["oFieldHelp"]["bOpened"] && (oEvent && oEvent["oGetParam"]("sEventName") != "click")) return;
	if (bHasAction != null && sKey != "") {
		this["markAsTokenWithAction"](bHasAction);
	}
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onTokenListSelect"] = 0; };

/**
 * Handles the escape key. Sets the value text to the according design, if it is a valid token.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputTokenizer["prototype"]["onlsescape"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onlsescape"]++; }; 
	UCF_SuggestBox.prototype["onlsescape"]["apply"](this, arguments);
	if (this["bIsValidToken"]()) {
		this["onTokenListSelect"]();
	}
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onlsescape"] = 0; };

/**
 * Handles the close event of the list box.
 *
 * @private
 */
UCF_InputTokenizer["prototype"]["onTokenListClose"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onTokenListClose"]++; }; 
	this["resetKey"]();
	this["sOldValue"] = this["oDomRef"]["value"];
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onTokenListClose"] = 0; };

/**
 * Resets the key of the control that is
 * defined on arrow up/down by the combobox. If current value does not match the
 * value behind the key, the key is reset to empty string.
 *
 * @private
 */
UCF_InputTokenizer["prototype"]["resetKey"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["resetKey"]++; }; 
	var sNewValue = this["oFieldHelp"]["sGetItemValue"](this["sKey"]);
	if (sNewValue != this["oDomRef"]["value"]) {
		this["sKey"] = "";
		this["setClientProperty"]("Key", this["sKey"], true);
	}
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["resetKey"] = 0; };

/**
 * checks whether the selected token has an associated action
 *
 * @private
 */
UCF_InputTokenizer["prototype"]["bGetTokenWithAction"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bGetTokenWithAction"]++; }; 

	for (var i = 0; i < this["aKeysWithAction"]["length"]; i++) {
		if (this["aKeysWithAction"][i] == sKey)
			return true;
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bGetTokenWithAction"] = 0; };

/**
 * Change the design of the input value to that of a token
 *
 * @private
 */
UCF_InputTokenizer["prototype"]["markAsTokenWithAction"] = function(bHasAction) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["markAsTokenWithAction"]++; }; 
	bHasAction = this["bEnabled"] && bHasAction;
	if (bHasAction) {
		this["sTextStyle"] = 'UNDERLINE_HOTSPOT';
	} else {
		this["sTextStyle"] = 'UNDERLINE';
	}
	this["updateStyles"]();
	this["bHasClickableToken"] = bHasAction;
	this["setClientProperty"]("HasClickableToken", this["bHasClickableToken"], true);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["markAsTokenWithAction"] = 0; };

/**
 * Creates an array where all tokens with an associated action are stored
 *
 * @private
 */
UCF_InputTokenizer["prototype"]["createTokens"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["createTokens"]++; }; 
	this["aKeysWithAction"] = [];
	if (this["sKey"] != "" && this["bHasClickableToken"]) {
		this["aKeysWithAction"]["push"](this["sKey"]);
	}
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["createTokens"] = 0; };

/**
 * Handle the accessibility of the IT
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_InputTokenizer["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InputTokenizer.js(477): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	//Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this);

	oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setReadonly"](this["bReadonly"]);
	oAccessibilityHelper["setRequired"](this["bRequired"]);
	oAccessibilityHelper["setInvalid"](this["sInputState"] == "ERROR");
	oAccessibilityHelper["setWarning"](this["sInputState"] == "WARNING");
	oAccessibilityHelper["setControlType"]("IT");
	oAccessibilityHelper["setText"](this["sGetValue"]());
	oAccessibilityHelper["setValid"](this["bIsValidToken"]());
	if (this["bHasClickableToken"]) {
		oAccessibilityHelper["addTutor"]("IT_F2");
	}
	oAccessibilityHelper["addEnabledTutor"]("I_F4_TUT", this["bEnabled"] && !this["bReadonly"] && this["bShowHelpButton"]);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["onlsaccessibility"] = 0; };

/**
 * Enumeration with all keys suppressed when IT displays a valid token
 *
 * @private
 */
UCF_InputTokenizer["prototype"]["bIsFunctionKey"] = function(iKey) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bIsFunctionKey"]++; }; 

	return (iKey == UCF_KeyCodes["TAB"] || iKey == UCF_KeyCodes["ENTER"] || iKey == UCF_KeyCodes["SHIFT"] || iKey == UCF_KeyCodes["CONTROL"] ||
		iKey == UCF_KeyCodes["SHIFT"] || iKey == UCF_KeyCodes["CONTROL"] || iKey == UCF_KeyCodes["BREAK"] || iKey == UCF_KeyCodes["CAPS_LOCK"] || iKey == UCF_KeyCodes["ESCAPE"] ||
		iKey == UCF_KeyCodes["PAGE_UP"] || iKey == UCF_KeyCodes["PAGE_DOWN"] || iKey == UCF_KeyCodes["END"] || iKey == UCF_KeyCodes["HOME"] ||
		iKey == UCF_KeyCodes["ARROW_LEFT"] || iKey == UCF_KeyCodes["ARROW_UP"] || iKey == UCF_KeyCodes["ARROW_RIGHT"] || iKey == UCF_KeyCodes["ARROW_DOWN"] || iKey == UCF_KeyCodes["PRINT"] ||
		iKey == UCF_KeyCodes["INSERT"] || iKey == UCF_KeyCodes["WINDOWS"] || iKey == UCF_KeyCodes["CONTEXT_MENU"] || iKey == UCF_KeyCodes["TURN_OFF"] ||
		iKey == UCF_KeyCodes["TURN_OFF"] || iKey == UCF_KeyCodes["SLEEP"] || iKey == UCF_KeyCodes["F1"] || iKey == UCF_KeyCodes["F2"] || iKey == UCF_KeyCodes["F3"] || iKey == UCF_KeyCodes["F4"] ||
		iKey == UCF_KeyCodes["F5"] || iKey == UCF_KeyCodes["F6"] || iKey == UCF_KeyCodes["F7"] || iKey == UCF_KeyCodes["F8"] || iKey == UCF_KeyCodes["F9"] || iKey == UCF_KeyCodes["F10"] || iKey == UCF_KeyCodes["F11"] ||
		iKey == UCF_KeyCodes["F12"] || iKey == UCF_KeyCodes["NUM_LOCK"] || iKey == UCF_KeyCodes["SCROLL_LOCK"]);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["bIsFunctionKey"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_InputTokenizer["prototype"]["aAttributeNames"] = ["sVisibility","sTooltip","bEnabled","bReadonly","bRequired","sInputState","sItemListBoxId","sKey","sValue","sTextDesign","bDisplayAsText","sWidth","bUsedInSapTable","sPaddingInSapTable","bShowHelpButton","bShowHelpButtonAlways","bHideFieldHelp","sSuggestFilter","sAccessKey","bHasClickableToken","sInputPrompt","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_InputTokenizer["prototype"]["aEventNames"] = ["ActionItemActivate","Change","Select","Enter","ListAccess","FieldHelpPress","Navigate"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_InputTokenizer["prototype"]["aMethodNames"] = ["setChanged","open","update","setInputState","setCursorPosition","setSelection","iGetSelectionStart","iGetSelectionEnd","createDataTip","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_InputTokenizer["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_InputTokenizer["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_InputTokenizer["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_InputTokenizer["prototype"]["bReadonly"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_InputTokenizer["prototype"]["bRequired"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputState}
 */
UCF_InputTokenizer["prototype"]["sInputState"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_InputTokenizer["prototype"]["sItemListBoxId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_InputTokenizer["prototype"]["sKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_InputTokenizer["prototype"]["sValue"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputDesign}
 */
UCF_InputTokenizer["prototype"]["sTextDesign"] = "STANDARD";

/**
 * @private
 * @type {boolean}
 */
UCF_InputTokenizer["prototype"]["bDisplayAsText"] = false;

/**
 * @private
 * @type {string}
 */
UCF_InputTokenizer["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_InputTokenizer["prototype"]["bUsedInSapTable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_InputTokenizer["prototype"]["sPaddingInSapTable"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_InputTokenizer["prototype"]["bShowHelpButton"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_InputTokenizer["prototype"]["bShowHelpButtonAlways"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_InputTokenizer["prototype"]["bHideFieldHelp"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SuggestFilterType}
 */
UCF_InputTokenizer["prototype"]["sSuggestFilter"] = "OFF";

/**
 * @private
 * @type {string}
 */
UCF_InputTokenizer["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_InputTokenizer["prototype"]["bHasClickableToken"] = false;

/**
 * @private
 * @type {string}
 */
UCF_InputTokenizer["prototype"]["sInputPrompt"] = '';

/**
 * @private
 * @type {string}
 */
UCF_InputTokenizer["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_InputTokenizer["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_InputTokenizer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["bReadonly"] = false;
	this["bRequired"] = false;
	this["sInputState"] = "NONE";
	this["sItemListBoxId"] = '';
	this["sKey"] = '';
	this["sValue"] = '';
	this["sTextDesign"] = "STANDARD";
	this["bDisplayAsText"] = false;
	this["sWidth"] = '';
	this["bUsedInSapTable"] = false;
	this["sPaddingInSapTable"] = '';
	this["bShowHelpButton"] = false;
	this["bShowHelpButtonAlways"] = false;
	this["bHideFieldHelp"] = false;
	this["sSuggestFilter"] = "OFF";
	this["sAccessKey"] = '';
	this["bHasClickableToken"] = false;
	this["sInputPrompt"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Readonly", false, true);
		this["setClientProperty"]("Required", false, true);
		this["setClientProperty"]("InputState", "NONE", true);
		this["setClientProperty"]("ItemListBoxId", '', true);
		this["setClientProperty"]("Key", '', true);
		this["setClientProperty"]("Value", '', true);
		this["setClientProperty"]("TextDesign", "STANDARD", true);
		this["setClientProperty"]("DisplayAsText", false, true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("UsedInSapTable", false, true);
		this["setClientProperty"]("PaddingInSapTable", '', true);
		this["setClientProperty"]("ShowHelpButton", false, true);
		this["setClientProperty"]("ShowHelpButtonAlways", false, true);
		this["setClientProperty"]("HideFieldHelp", false, true);
		this["setClientProperty"]("SuggestFilter", "OFF", true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("HasClickableToken", false, true);
		this["setClientProperty"]("InputPrompt", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sActionItemId Identifier of the action
 * @fires InputTokenizer::ActionItemActivate
 */
UCF_InputTokenizer["prototype"]["fireActionItemActivate"] = function(sId, sActionItemId) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireActionItemActivate"]++; }; 
	/** @type {{Id: string, ActionItemId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InputTokenizer.js(741): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputTokenizer.js(742): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputTokenizer.js(743): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sActionItemId != null, "sActionItemId != null", "InputTokenizer.js(744): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sActionItemId) == "string", "typeof(sActionItemId) == \"string\"", "InputTokenizer.js(745): fireActionItemActivate"); };
	mParams = {
		"Id": sId,
		"ActionItemId": sActionItemId
	};
	
	
	this["fireSemanticEvent"]("InputTokenizer", "ActionItemActivate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireActionItemActivate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {string} sValue The entered value.
 * @fires InputTokenizer::Change
 */
UCF_InputTokenizer["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InputTokenizer.js(765): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputTokenizer.js(766): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputTokenizer.js(767): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "InputTokenizer.js(768): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "InputTokenizer.js(769): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("InputTokenizer", "Change", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {string} sKey The selected key.
 * @fires InputTokenizer::Select
 */
UCF_InputTokenizer["prototype"]["fireSelect"] = function(sId, sKey) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, Key: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InputTokenizer.js(789): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputTokenizer.js(790): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputTokenizer.js(791): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sKey != null, "sKey != null", "InputTokenizer.js(792): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sKey) == "string", "typeof(sKey) == \"string\"", "InputTokenizer.js(793): fireSelect"); };
	mParams = {
		"Id": sId,
		"Key": sKey
	};
	
	
	this["fireSemanticEvent"]("InputTokenizer", "Select", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {string} sValue The token value.
 * @fires InputTokenizer::Enter
 */
UCF_InputTokenizer["prototype"]["fireEnter"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireEnter"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InputTokenizer.js(813): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputTokenizer.js(814): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputTokenizer.js(815): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "InputTokenizer.js(816): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "InputTokenizer.js(817): fireEnter"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("InputTokenizer", "Enter", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireEnter"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {string} sItemListBoxId Identifier of the suggest list.
 * @param {string} sFilterValue Value used to filter the list.
 * @fires InputTokenizer::ListAccess
 */
UCF_InputTokenizer["prototype"]["fireListAccess"] = function(sId, sItemListBoxId, sFilterValue) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireListAccess"]++; }; 
	/** @type {{Id: string, ItemListBoxId: string, FilterValue: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "InputTokenizer.js(840): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputTokenizer.js(841): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputTokenizer.js(842): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemListBoxId != null, "sItemListBoxId != null", "InputTokenizer.js(843): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemListBoxId) == "string", "typeof(sItemListBoxId) == \"string\"", "InputTokenizer.js(844): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFilterValue != null, "sFilterValue != null", "InputTokenizer.js(845): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFilterValue) == "string", "typeof(sFilterValue) == \"string\"", "InputTokenizer.js(846): fireListAccess"); };
	mParams = {
		"Id": sId,
		"ItemListBoxId": sItemListBoxId,
		"FilterValue": sFilterValue
	};
	
	if (sItemListBoxId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemListBoxId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemListBoxId");
			}
		}
	
	this["fireSemanticEvent"]("InputTokenizer", "ListAccess", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireListAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires InputTokenizer::FieldHelpPress
 */
UCF_InputTokenizer["prototype"]["fireFieldHelpPress"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireFieldHelpPress"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "InputTokenizer.js(872): fireFieldHelpPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputTokenizer.js(873): fireFieldHelpPress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputTokenizer.js(874): fireFieldHelpPress"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("InputTokenizer", "FieldHelpPress", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireFieldHelpPress"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires InputTokenizer::Navigate
 */
UCF_InputTokenizer["prototype"]["fireNavigate"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireNavigate"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "InputTokenizer.js(891): fireNavigate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InputTokenizer.js(892): fireNavigate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InputTokenizer.js(893): fireNavigate"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("InputTokenizer", "Navigate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InputTokenizer["_"]["fireNavigate"] = 0; };

};
sap["ls"]["preload"]["UCF_InteractiveForm"] = function() {/* global _assert, _trace, DEBUG, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Queue */
/// <reference path="../../core/util/Queue.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ActiveComponent */
/// <reference path="./base/ActiveComponent.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_InteractiveForm(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["UCF_InteractiveForm"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "InteractiveForm.js(25): UCF_InteractiveForm"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "InteractiveForm.js(26): UCF_InteractiveForm"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "InteractiveForm.js(27): UCF_InteractiveForm"); };

	UCF_ActiveComponent["apply"](this, [oDomRef, oLS]);

	this["oQueue"] = new (UCF_ClassLoader["oGetClass"]("UCF_Queue"))();
	this["sWaitingFor"] = "zciReady"; // eslint-disable-line @ur/no-memory-leaks
	this["bLocked"] = false;
	this["mAttributes"] = { "readOnly": "false" };
	this["sUpdateType"] = ""; // eslint-disable-line @ur/no-memory-leaks
	this["attachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"], "onPendingRequest");
	this["bResponseFromServerIndicator"] = false;
	this["bServiceRequest"] = false;
	this["iTimeSlice"] = 100;
	this["iTimeoutFactor"] = 1000;
	this["iTimeoutCounter"] = 0; // eslint-disable-line @ur/no-memory-leaks
	this["iMaxZciReadyWaitingTime"] = 1000; // eslint-disable-line @ur/no-memory-leaks
	this["sLogReportingLevel"] = null; // eslint-disable-line @ur/no-memory-leaks
	this["bKeepLockedForF4HelpRequest"] = false;
	this["bEnabled"] = true;
	this["setClientProperty"]("Enabled", this["bEnabled"], true);
	this["iStartTime"] = null; // eslint-disable-line @ur/no-memory-leaks
	//required for Error Handling
	this["aXPathArr"] = null;
	this["aMsgTypeArr"] = null;
	this["aMsgTextArr"] = null;
	this["sErrColorCode"] = "251,233,235";
	this["sErrEdgeColorCode"] = "255,0,0";
	this["sWarnColorCode"] = "255,255,0";
	this["sWarnEdgeColorCode"] = "255,255,0";
	this["bIsRequestForValidation"] = false;
};window["UCF_InteractiveForm"] = UCF_InteractiveForm; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_InteractiveForm"); UCF_InteractiveForm["_"] = {UCF_InteractiveForm: 0}; }; ;
UCF_InteractiveForm["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ActiveComponent"))(); UCF_InteractiveForm.prototype["sClassName"] = "UCF_InteractiveForm";

/**
 * Initialize method is called after rendering
 */
UCF_InteractiveForm["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["initialize"]++; }; 
	UCF_ActiveComponent.prototype["initialize"]["apply"](this, arguments);
	//this.setInvocationXML(this.sInvocationXML);
	this["oObjectRef"] = this["oGetObjectRef"]();
	this["oObjectRef"]["messageHandler"] = this;
	if (this["sInvocationXML"] != null && this["sInvocationXML"] !== "") {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, " SAPADBIFORM: Received InvocationXML :" + this["sInvocationXML"], "InteractiveForm.js(69): initialize"); };
		UCF_JsUtil["delayedCall"](this["iTimeSlice"], this, "checkZCIReady");
		if (!this["bLocked"]) {
			this["getLogReportingLevel"]();
		}
		this["setInvocationXml"](this["sInvocationXML"]);
		if (this["bLocked"] && !this["bKeepLockedForF4HelpRequest"]) {
			if (!this["bIsRequestForValidation"]) {
				this["unlock"]();
			}
		}
		this["bKeepLockedForF4HelpRequest"] = false;
	} else {
		this["bEnabled"] = false;
		this["setClientProperty"]("Enabled", this["bEnabled"], false);
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, " SAPADBIFORM: InvocationXML is :" + this["sInvocationXML"], "InteractiveForm.js(84): initialize"); };
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["initialize"] = 0; };

/**
 * Destroy is called when control is removed
 */
UCF_InteractiveForm["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["destroy"]++; }; 
	if (this["oQueue"]) {
		this["oQueue"]["destroy"]();
		this["oQueue"] = null;
	}
	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);

	this["mAttributes"] = null;
	this["oObjectRef"] = null;
	this["oPendingRequest"] = null;
	this["aXPathArr"] = null;
	this["aMsgTypeArr"] = null;
	this["aMsgTextArr"] = null;

	UCF_ActiveComponent.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["destroy"] = 0; };

UCF_InteractiveForm["prototype"]["checkZCIReady"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["checkZCIReady"]++; }; 
	this["iTimeoutCounter"] = this["iTimeoutCounter"] + 1;
	if (this["sWaitingFor"] === "zciReady") {
		if ((this["iTimeoutCounter"] * this["iTimeSlice"]) <= this["iMaxZciReadyWaitingTime"]) {
			UCF_JsUtil["delayedCall"](this["iTimeSlice"], this, "checkZCIReady");
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: Waiting for zciReady message to come in. Waiting time so far: " + this["iTimeoutCounter"] * this["iTimeSlice"] + ". Max waiting time: " + this["iMaxZciReadyWaitingTime"] + "\n", "InteractiveForm.js(113): checkZCIReady"); };
			try {
				//delete doesn't work for DOM elements in IE quirks mode...
				delete this["oObjectRef"]["messageHandler"];
			} catch (e) {}
			this["oObjectRef"]["messageHandler"] = this;
		} else {
			this["sWaitingFor"] = null;
			this["postNextMessage"]();
			this["iTimeoutCounter"] = 0;
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: Container Foundation js is old/absent/zciReady message has not returned yet. Waited for: " + this["iMaxZciReadyWaitingTime"] + "\n", "InteractiveForm.js(123): checkZCIReady"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["checkZCIReady"] = 0; };

// eslint-disable-next-line complexity
UCF_InteractiveForm["prototype"]["onMessage"] = function(params) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["onMessage"]++; }; 
	var endTime = new Date()["valueOf"]();
	var command = params[0];
	var i;
	var colorArray;
	var edgeColorArray;
	var xPathStr;
	var sMsgTextStr;
	var dirtyState;
	var retrievedUrl;
	var key;
	var pdfSubmitRecommended;
	var sXPath;
	var sValue;
	var finishedSettingData;
	var markValidate;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: Received message:" + params + "\n", "InteractiveForm.js(146): onMessage"); };
	switch (command) {
		case "zciReady":
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: zciReady message returned" + "\n", "InteractiveForm.js(149): onMessage"); };
			this["iTimeoutCounter"] = 0;
			this["sendZCIReadyMessageReceived"]("false");
			if (this["aXPathArr"] != null && this["aMsgTypeArr"] != null && this["aMsgTextArr"] != null) {
				colorArray = new Array(this["aMsgTypeArr"]["length"]);
				edgeColorArray = new Array(this["aMsgTypeArr"]["length"]);
				for (i = 0; i < this["aMsgTypeArr"]["length"]; i++) {
					if (this["aMsgTypeArr"][i] === "error") {
						colorArray[i] = this["sErrColorCode"];
						edgeColorArray[i] = this["sErrEdgeColorCode"];
					} else if (this["aMsgTypeArr"][i] === "warning") {
						colorArray[i] = this["sWarnColorCode"];
						edgeColorArray[i] = this["sWarnEdgeColorCode"];
					}
				}
				xPathStr = "";
				for (i = 0; i < this["aXPathArr"]["length"]; i++) {
					xPathStr = xPathStr + "\"" + this["aXPathArr"][i] + "\"" + ",";
				}
				if (xPathStr["length"] > 0) {
					if (xPathStr["charAt"](xPathStr["length"] - 1) === ',') {
						xPathStr = xPathStr["substring"](0, xPathStr["length"] - 1);
					}
				}
				sMsgTextStr = "";
				for (i = 0; i < this["aMsgTextArr"]["length"]; i++) {
					sMsgTextStr = sMsgTextStr + "\"" + this["aMsgTextArr"][i] + "\"" + ",";
				}
				if (sMsgTextStr["length"] > 0) {
					if (sMsgTextStr["charAt"](sMsgTextStr["length"] - 1) === ',') {
						sMsgTextStr = sMsgTextStr["substring"](0, sMsgTextStr["length"] - 1);
					}
				}
				this["markValidateFailed"](xPathStr, this["sErrColorCode"], this["sErrEdgeColorCode"], sMsgTextStr);
				this["aXPathArr"] = null;
				this["aMsgTypeArr"] = null;
				this["aMsgTextArr"] = null;
			}
			//this.sWaitingFor = null;
			break;
		case "dirtyState":
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Time taken overall by isDocDirty call: " + (endTime - this["iStartTime"]) + " milliseconds" + "\n", "InteractiveForm.js(190): onMessage"); };
			dirtyState = params[1];
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: Dirty State is " + dirtyState + "\n", "InteractiveForm.js(192): onMessage"); };
			// ARCH: Send XML only
			if (dirtyState === "true") {
				this["sendDataToServer"]("xml");
			} else {
				if (this["oPendingRequest"] != null) {
					this["oPendingRequest"]["resume"](this["sId"]);
					this["oPendingRequest"] = null;
				}
			}
			break;
		case "logReportingLevel":
			//Partial Implementation : To be done later
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: Browser Reader Communication channel is present" + "\n", "InteractiveForm.js(205): onMessage"); };
			this["sLogReportingLevel"] = params[1];
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: Log Reporting Level is " + this["sLogReportingLevel"] + "\n", "InteractiveForm.js(207): onMessage"); };
			if (this["mAttributes"]["readerTrace"] != null && this["sLogReportingLevel"] !== this["mAttributes"]["readerTrace"]) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Setting log Reporting on the reader to " + this["mAttributes"]["readerTrace"] + "" + "\n", "InteractiveForm.js(209): onMessage"); };
				this["setLogReportingLevel"](this["mAttributes"]["readerTrace"]);
				this["sLogReportingLevel"] = this["mAttributes"]["readerTrace"];
			}

			break;
		case "submit":
			this["fireSubmit"](this["sId"]);
			break;
		case "check":
			this["fireCheck"](this["sId"]);
			break;
		case "sendDataToServerContentType":
			this["sUpdateType"] = params[1];
			break;
		case "responseFromServer":
			retrievedUrl = params[1];
			key = this["extractKeyFromUrl"](retrievedUrl);
			this["mAttributes"][this["sUpdateType"] + "Source"] = retrievedUrl;
			//_trace(INFO, "SAPADBIFORM: updateType is ," + this.sUpdateType + "\n");
			//_trace(INFO, "SAPADBIFORM: submitType is ," + this.mAttributes.submitType + "\n");
			//Fire an event corresponding to doSetAttribute on Server. Here we need to fire
			//XML change event but no need to immediately send that to server. How the parameters are
			//passed to this method so that they are available on the server.???
			if (this["sUpdateType"] === "xml") {
				this["fireXMLChange"](this["sId"], key);
			} else {
				this["firePDFChange"](this["sId"], key);
			}
			if (this["mAttributes"]["submitType"] === "both" && this["sUpdateType"] === "xml") {
				break;
			}
			// Lock. WD will send a request now. UI must be closed for editing.
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Time taken overall by sendDataToServer: " + (endTime - this["iStartTime"]) + " milliseconds" + "\n", "InteractiveForm.js(242): onMessage"); };
			this["bResponseFromServerIndicator"] = true;
			this["lock"]();
			break;
		case "PDFSubmitRecommended":
			// ARCH: New message introduced by Adobe to know if submission of PDF is required or not
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Time taken overall by isPDFSubmitRequired call: " + (endTime - this["iStartTime"]) + " milliseconds" + "\n", "InteractiveForm.js(248): onMessage"); };
			pdfSubmitRecommended = params[1];
			if (pdfSubmitRecommended === "true") {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: PDFSubmitRecommended by ZCI. PDF to be submitted." + "\n", "InteractiveForm.js(251): onMessage"); };
				this["sendDataToServer"]("pdf");
			} else {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: Data XML to be submitted (if dirty)." + "\n", "InteractiveForm.js(254): onMessage"); };
				this["isDocDirty"]();
			}
			break;
		case "valueHelp":
			// ARCH: set the attribute to true for ValueHelp requests
			this["bServiceRequest"] = true;
			sXPath = params[1];
			sValue = params[2];
			this["fireValueHelp"](this["sId"], sValue, sXPath, "VH");
			break;
		case "valueSelect":
		case "f4HelpOpen":
			// ARCH: set the attribute to true for ValueHelp requests
			this["bServiceRequest"] = true;
			this["bKeepLockedForF4HelpRequest"] = true;
			sXPath = params[1];
			sValue = params[2];
			this["fireValueHelp"](this["sId"], sValue, sXPath, "EVS");
			break;
		case "lockFormComplete":
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Time taken overall by Lock Call: " + (endTime - this["iStartTime"]) + " milliseconds" + "\n", "InteractiveForm.js(275): onMessage"); };
			//_trace(INFO, "SAPADBIFORM: Lock Form Complete" + "\n");
			break;
		case "unlockFormComplete":
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Time taken overall by UnLock Call: " + (endTime - this["iStartTime"]) + " milliseconds" + "\n", "InteractiveForm.js(279): onMessage"); };
			//_trace(INFO, "SAPADBIFORM: Unlock Form Complete" + "\n");
			break;
		case "finishedSettingData":
			finishedSettingData = params[1];
			if (this["aXPathArr"] != null && this["aMsgTypeArr"] != null && this["aMsgTextArr"] != null) {
				colorArray = new Array(this["aMsgTypeArr"]["length"]);
				edgeColorArray = new Array(this["aMsgTypeArr"]["length"]);
				for (i = 0; i < this["aMsgTypeArr"]["length"]; i++) {
					if (this["aMsgTypeArr"][i] === "error") {
						colorArray[i] = this["sErrColorCode"];
						edgeColorArray[i] = this["sErrEdgeColorCode"];
					} else if (this["aMsgTypeArr"][i] === "warning") {
						colorArray[i] = this["sWarnColorCode"];
						edgeColorArray[i] = this["sWarnEdgeColorCode"];
					}
				}
				xPathStr = "";
				for (i = 0; i < this["aXPathArr"]["length"]; i++) {
					xPathStr = xPathStr + "\"" + this["aXPathArr"][i] + "\"" + ",";
				}
				if (xPathStr["length"] > 0) {
					if (xPathStr["charAt"](xPathStr["length"] - 1) === ',') {
						xPathStr = xPathStr["substring"](0, xPathStr["length"] - 1);
					}
				}
				sMsgTextStr = "";
				for (i = 0; i < this["aMsgTextArr"]["length"]; i++) {
					sMsgTextStr = sMsgTextStr + "\"" + this["aMsgTextArr"][i] + "\"" + ",";
				}
				if (sMsgTextStr["length"] > 0) {
					if (sMsgTextStr["charAt"](sMsgTextStr["length"] - 1) === ',') {
						sMsgTextStr = sMsgTextStr["substring"](0, sMsgTextStr["length"] - 1);
					}
				}
				this["markValidateFailed"](xPathStr, this["sErrColorCode"], this["sErrEdgeColorCode"], sMsgTextStr);
				this["aXPathArr"] = null;
				this["aMsgTypeArr"] = null;
				this["aMsgTextArr"] = null;
			}
			//is this ever called - if yes then changes the placement of the above code..?
			if (finishedSettingData === "OK") {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: finishedSettingData. OK." + "\n", "InteractiveForm.js(321): onMessage"); };
				if (this["bLocked"]) {
					this["unlock"]();
				}
			}
			break;
		case "markValidateFailedComplete":
			markValidate = params[1];
			if (markValidate === "OK") {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: markValidateFailed. OK." + "\n", "InteractiveForm.js(330): onMessage"); };
			} else if (markValidate === "ERROR") {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: markValidateFailed. ERROR." + "\n", "InteractiveForm.js(332): onMessage"); };
			}
			this["bIsRequestForValidation"] = false;
			if (this["bLocked"]) {
				this["unlock"]();
			}
			break;

	}
	if (this["sWaitingFor"] === command) this["sWaitingFor"] = null;
	if (!this["sWaitingFor"]) this["postNextMessage"]();
	if (!this["sWaitingFor"] && this["bResponseFromServerIndicator"]) {
		this["bResponseFromServerIndicator"] = false;
		//if(this.bServiceRequest){
		//this.bServiceRequest = false;
		//this.fireValueHelp(this.sId, this.sValue, this.sXPath, "EVS");
		//}else{
		this["oPendingRequest"]["resume"](this["sId"]);
		this["oPendingRequest"] = null;
		//}
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["onMessage"] = 0; };

UCF_InteractiveForm["prototype"]["onPendingRequest"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["onPendingRequest"]++; }; 
	var oPendingRequest;

	if (this["waitingFor"] === "logReportingLevel") {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: Browser Reader Communication channel is absent" + "\n", "InteractiveForm.js(359): onPendingRequest"); };
	} else {
		if (this["sWaitingFor"] === "zciReady") {
			this["sWaitingFor"] = null;
		}
		oPendingRequest = oEvent["oGetParam"]("oPendingRequest");
		oPendingRequest["suspend"](this["sId"]);
		this["oPendingRequest"] = oPendingRequest;
		if (!this["bEnabled"]) {
			this["oPendingRequest"]["resume"](this["sId"]);
			this["oPendingRequest"] = null;
			this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);
			this["bEnabled"] = true;
			this["setClientProperty"]("Enabled", this["bEnabled"], true);
		} else {
			if (!this["bLocked"]) {
				this["lock"]();
			}
			if (this["bServiceRequest"]) {
				this["bServiceRequest"] = false;
				this["isDocDirty"]();
			} else {
				this["isPDFSubmitRequired"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["onPendingRequest"] = 0; };

UCF_InteractiveForm["prototype"]["postMessage"] = function(aMessage, sWaitingFor) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["postMessage"]++; }; 
	this["oQueue"]["push"]({ "aMessage": aMessage, "sWaitingFor": sWaitingFor });
	if (!this["sWaitingFor"]) this["postNextMessage"]();
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["postMessage"] = 0; };

// Post next message in the queue
UCF_InteractiveForm["prototype"]["postNextMessage"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["postNextMessage"]++; }; 
	var oNext;

	if (this["oQueue"]["peek"]()) {
		this["iStartTime"] = new Date()["valueOf"]();
		oNext = this["oQueue"]["get"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: Sending message: " + oNext["aMessage"] + "\n", "InteractiveForm.js(399): postNextMessage"); };
		try {
			this["oObjectRef"]["postMessage"](oNext["aMessage"]);
		} catch (e) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "SAPADBIFORM: Could not send message!\n", "InteractiveForm.js(403): postNextMessage"); };
		}
		this["sWaitingFor"] = oNext["sWaitingFor"];
		if (!this["sWaitingFor"]) this["postNextMessage"]();
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["postNextMessage"] = 0; };

UCF_InteractiveForm["prototype"]["getLogReportingLevel"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["getLogReportingLevel"]++; }; 
	this["postMessage"](["getLogReportingLevel"], "logReportingLevel");
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["getLogReportingLevel"] = 0; };

UCF_InteractiveForm["prototype"]["setLogReportingLevel"] = function(logLevel) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setLogReportingLevel"]++; }; 
	this["postMessage"](["setLogReportingLevel", logLevel]);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setLogReportingLevel"] = 0; };

UCF_InteractiveForm["prototype"]["isDocDirty"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["isDocDirty"]++; }; 
	this["postMessage"](["isDocDirty"], "dirtyState");
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["isDocDirty"] = 0; };

UCF_InteractiveForm["prototype"]["isPDFSubmitRequired"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["isPDFSubmitRequired"]++; }; 
	this["postMessage"](["isPDFSubmitRequired"], "PDFSubmitRecommended");
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["isPDFSubmitRequired"] = 0; };

UCF_InteractiveForm["prototype"]["sendContentToServer"] = function(sSource, sSubmitType) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["sendContentToServer"]++; }; 
	var sAbsoluteURL = this["makeAbsoluteUrl"](sSource);
	sAbsoluteURL = sAbsoluteURL["replace"]("sap-wd-download=4", "sap-wd-download=3");
	this["postMessage"](["sendDataToServer", sAbsoluteURL, document["cookie"], sSubmitType], "responseFromServer");
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["sendContentToServer"] = 0; };

UCF_InteractiveForm["prototype"]["lock"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["lock"]++; }; 
	this["postMessage"](["lock"], "lockFormComplete");
	this["bLocked"] = true;
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["lock"] = 0; };

UCF_InteractiveForm["prototype"]["unlock"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["unlock"]++; }; 
	this["postMessage"](["unlock"], "unlockFormComplete");
	this["bLocked"] = false;
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["unlock"] = 0; };

UCF_InteractiveForm["prototype"]["sendDataToServer"] = function(sSubmitType) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["sendDataToServer"]++; }; 
	if (this["bLocked"]) {
		this["unlock"]();
	}
	/*
	 * In USEPDF mode, if the PDFSubmit is recommended by ZCI, then the XML data must also be sent to the server before
	 * hand as the changes data on the client might be used by the application for further processing. Unlike other modes,
	 * the USEPDF mode is completly discinnected from ADS as long as no extended features have been applied on the server.
	 * Hnece, sending the XML data from the client to the server is the only way to get the data extracted out of the
	 * PDF form. A classis example of the usecase when we need to send the XML data when PDFSubmit is recommended by the
	 * ZCI is the dependent DDL case. Value selected in one DDL must be available on the server for the dependent DDL to
	 * be populated. If a PDFSubmit is recommended and we send only the PDF to the server, the value selected on the
	 * first DDL will not be available. Hence, the following twik.
	 */

	sSubmitType = ((this["mAttributes"]["mode"] === "USEPDF" && sSubmitType === "pdf") || this["mAttributes"]["submitType"] === "both") ? "both" : sSubmitType;
	this["mAttributes"]["submitType"] = (sSubmitType === "both") ? "both" : this["mAttributes"]["submitType"];

	switch (sSubmitType) {
		case "xml":
			this["sendContentToServer"](this["mAttributes"]["xmlSource"], "xml");
			break;
		case "pdf":
			this["sendContentToServer"](this["mAttributes"]["pdfSource"], "pdf");
			break;
		case "both":
			// Removed this as a part of the design change Refer note :0001810871
			//this.sendContentToServer(this.mAttributes.xmlSource, "xml");
			this["sendContentToServer"](this["mAttributes"]["pdfSource"], "pdf");
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["sendDataToServer"] = 0; };

UCF_InteractiveForm["prototype"]["getDataFromServer"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["getDataFromServer"]++; }; 
	var sSource = this["makeAbsoluteUrl"](this["mAttributes"]["xmlSource"]);
	this["postMessage"](["getDataFromServer", sSource, document["cookie"]], "finishedSettingData");
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["getDataFromServer"] = 0; };

UCF_InteractiveForm["prototype"]["setFieldData"] = function(xPath, value) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setFieldData"]++; }; 
	var postArr = ["setFieldData", xPath, value];
	this["postMessage"](postArr);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setFieldData"] = 0; };

UCF_InteractiveForm["prototype"]["setFieldState"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setFieldState"]++; }; 
	var state = (this["mAttributes"]["readOnly"] === "true" ? "readOnly" : "restore"),
		postArr = ["setFieldState", state];
	this["postMessage"](postArr);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setFieldState"] = 0; };

UCF_InteractiveForm["prototype"]["setListData"] = function(xPath, data) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setListData"]++; }; 
	var i;
	var postArr = ["setListData", xPath, "false"];

	for (i in data) {
		postArr["push"](i);
		postArr["push"](data[i]);
	}
	this["postMessage"](postArr);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setListData"] = 0; };

UCF_InteractiveForm["prototype"]["sendZCIReadyMessageReceived"] = function(isReceived) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["sendZCIReadyMessageReceived"]++; }; 
	this["postMessage"](["setZCIReadyMessageSent", isReceived]);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["sendZCIReadyMessageReceived"] = 0; };

UCF_InteractiveForm["prototype"]["markValidateFailed"] = function(xPathArr, colorCode, edgeColorCode, mTextArr) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["markValidateFailed"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: triggering markValidateFailed to Adobe Reader" + "\n", "InteractiveForm.js(507): markValidateFailed"); };
	this["postMessage"](["markValidateFailed", xPathArr, colorCode, edgeColorCode, mTextArr], "markValidateFailedComplete");
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["markValidateFailed"] = 0; };

UCF_InteractiveForm["prototype"]["focus"] = function(focusData) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["focus"]++; }; 
	if (UCF_DomUtil["oGetActiveElement"]() !== this["oDomRef"]) {
		UCF_ActiveComponent.prototype["focus"]["apply"](this, arguments);
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: Focused Interactive Form, Calling setCursor on Adobe Reader" + "\n", "InteractiveForm.js(515): focus"); };
	this["postMessage"](["setCursor", focusData]);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["focus"] = 0; };

UCF_InteractiveForm["prototype"]["makeAbsoluteUrl"] = function(relativeUrl) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["makeAbsoluteUrl"]++; }; 
	var absoluteUrl = location["href"],
		questionMarkPos = absoluteUrl["indexOf"]("?"),
		lastSlashPos;
	// relativeUrl is already an absolute URL
	if (relativeUrl["substr"](0, 4) === "http") return relativeUrl;
	// relativeUrl needs to be resolved
	if (questionMarkPos !== -1) absoluteUrl = absoluteUrl["substr"](0, questionMarkPos);
	lastSlashPos = absoluteUrl["lastIndexOf"]("/");
	absoluteUrl = absoluteUrl["substr"](0, lastSlashPos);
	while (relativeUrl["indexOf"]("../") === 0) {
		relativeUrl = relativeUrl["substr"](3);
		lastSlashPos = absoluteUrl["lastIndexOf"]("/");
		absoluteUrl = absoluteUrl["substr"](0, lastSlashPos);
	}
	absoluteUrl = absoluteUrl + "/" + relativeUrl;
	return absoluteUrl;
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["makeAbsoluteUrl"] = 0; };

UCF_InteractiveForm["prototype"]["extractKeyFromUrl"] = function(url) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["extractKeyFromUrl"]++; }; 
	var beginOfKey = url["indexOf"]("~wd_key"),
		endOfKey = url["indexOf"]("/", beginOfKey);
	return url["substr"](beginOfKey, endOfKey - beginOfKey);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["extractKeyFromUrl"] = 0; };

UCF_InteractiveForm["prototype"]["setInvocationXml"] = function(sInvocationXml) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setInvocationXml"]++; }; 
	var xPath;
	var keyArr;
	var valueArr;
	var paramMap;
	var callCommand;
	var callCommandRE;
	var i;
	//Attributes for Regular Expression needs to be in alphabetical order
	var attributeReg = /<Set name="([^"]+)" requestId="[^"]+" type="[^"]+" value="([^"]+)"\/>/g,
		commandCallReg = /<Call[\s\S]+?<\/Call>/g,
		commandReg = /<Call name="([^"]+)" requestId="[^"]+">/g,
		commandParameterReg = /<Param type="[^"]+" value="([^"]+)"\/>/g,
		command, commandParameters, name, value,
		hasChanged = {};

	// Parse attributes, if xmlSource is changed refresh data in pdf
	while (attributeReg["exec"](sInvocationXml)) {
		name = RegExp["$1"];
		value = this["transformValue"](RegExp["$2"]);
		hasChanged[name] = (value !== this["mAttributes"][name]);
		this["mAttributes"][name] = value;
	}
	if (hasChanged["xmlSource"] && (this["mAttributes"]["xmlSource"] != null) && (this["mAttributes"]["enableClientMerge"] === "true"))
		this["getDataFromServer"]();
	if (hasChanged["readOnly"]) this["setFieldState"]();

	// Set the maxZciReadyWaitingTime received from the server
	this["iMaxZciReadyWaitingTime"] = this["mAttributes"]["zciReadyTimeoutLimit"];

	// Parse commands and call according functions in pdf
	while (commandCallReg["exec"](sInvocationXml)) {
		callCommand = RegExp["lastMatch"];
		callCommandRE = new RegExp(commandReg);

		callCommandRE["exec"](callCommand);
		command = RegExp["$1"];
		commandParameters = [];
		while (commandParameterReg["exec"](callCommand)) {
			commandParameters["push"](this["transformValue"](RegExp["$1"]));
		}

		switch (command) {
			case "SetValueHelp":
				xPath = commandParameters[0];
				keyArr = this["escapeXMLChars"](commandParameters[1])["split"]("#");
				valueArr = this["escapeXMLChars"](commandParameters[2])["split"]("#");
				paramMap = {};
				for (i = 0; i < keyArr["length"]; i++) {
					paramMap[keyArr[i]] = valueArr[i];
				}
				this["setListData"](xPath, paramMap);
				break;
			case "SetFieldData":
				xPath = commandParameters[0];
				value = commandParameters[1];
				this["setFieldData"](xPath, value);
				break;
			case "markValidateFailed":
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "SAPADBIFORM: Erroneous fields present in the form : markValidateFailed returned " + "\n", "InteractiveForm.js(603): setInvocationXml"); };
				this["aXPathArr"] = commandParameters[0]["split"]("#");
				this["aMsgTypeArr"] = commandParameters[1]["split"]("#");
				this["aMsgTextArr"] = commandParameters[2]["split"]("#");
				this["bIsRequestForValidation"] = true;
				break;
		}
	}

	// send ACFRETURNVALUE event, to reset invocation xml
	//var parameters = {};
	//parameters["ControlId"] = this.id;
	//parameters["returnValue"] = "<?xml version=\"1.0\"?><invoke><response></response></invoke>";
	//Fire RETURNVALUE
	this["fireReturnValue"](this["sId"], "<?xml version=\"1.0\"?><invoke><response></response></invoke>");
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setInvocationXml"] = 0; };

//Convert the special characters within ValueHelp
UCF_InteractiveForm["prototype"]["escapeXMLChars"] = function(value) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["escapeXMLChars"]++; }; 
	var temp = document["createElement"]("textarea");
	// eslint-disable-next-line no-unsanitized/property
	temp["innerHTML"] = value["replace"](/</g, "&lt;")["replace"](/>/g, "&gt;")["replace"](/&apos;/g, "'")["replace"](/&quot;/g, '"');
	value = temp["value"];
	return value;
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["escapeXMLChars"] = 0; };

UCF_InteractiveForm["prototype"]["transformValue"] = function(value) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["transformValue"]++; }; 
	value = value["replace"](/&amp;/g, "&")["replace"](/&lt;/g, "<")["replace"](/&gt;/g, ">")["replace"](/&apos;/g, "'")["replace"](/&quot;/g, '"');
	if (value === "@acf_empty") value = "";
	if (value === "@acf_null") value = null;
	return value;
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["transformValue"] = 0; };

// Writes the appropriate acc text into the tooltip
UCF_InteractiveForm["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["onlsaccessibility"]++; }; 
	var oSource;
	var oAccessibilityHelper;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InteractiveForm.js(641): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	oSource = oBrowserEvent["oGetSource"]();
	oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource["getAttribute"]("tp") === "END") {
		oAccessibilityHelper["setControlType"]("AX_END");
	} else {
		oAccessibilityHelper["setControlType"]("AX");
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_InteractiveForm["prototype"]["aAttributeNames"] = ["sVisibility","sTooltip","sLifeCycle","sInvocationXML","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_InteractiveForm["prototype"]["aEventNames"] = ["Check","Submit","ValueHelp","PDFChange","XMLChange","ReturnValue"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_InteractiveForm["prototype"]["aMethodNames"] = ["setKeepAlive","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_InteractiveForm["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_InteractiveForm["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_InteractiveForm["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_InteractiveForm["prototype"]["sInvocationXML"] = '';

/**
 * @private
 * @type {string}
 */
UCF_InteractiveForm["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_InteractiveForm["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sLifeCycle"] = "BROWSER";
	this["sInvocationXML"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("InvocationXML", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The id of the InteractiveForm.
 * @fires InteractiveForm::Check
 */
UCF_InteractiveForm["prototype"]["fireCheck"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["fireCheck"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "InteractiveForm.js(736): fireCheck"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InteractiveForm.js(737): fireCheck"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InteractiveForm.js(738): fireCheck"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("InteractiveForm", "Check", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["fireCheck"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the InteractiveForm.
 * @fires InteractiveForm::Submit
 */
UCF_InteractiveForm["prototype"]["fireSubmit"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["fireSubmit"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "InteractiveForm.js(755): fireSubmit"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InteractiveForm.js(756): fireSubmit"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InteractiveForm.js(757): fireSubmit"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("InteractiveForm", "Submit", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["fireSubmit"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the InteractiveForm.
 * @param {string} sValue The current field value.
 * @param {string} sXPath The XPath expression for the field.
 * @param {string} sType The type of the requested value help.
 * @fires InteractiveForm::ValueHelp
 */
UCF_InteractiveForm["prototype"]["fireValueHelp"] = function(sId, sValue, sXPath, sType) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["fireValueHelp"]++; }; 
	/** @type {{Id: string, Value: string, XPath: string, Type: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "InteractiveForm.js(777): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InteractiveForm.js(778): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InteractiveForm.js(779): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "InteractiveForm.js(780): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "InteractiveForm.js(781): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sXPath != null, "sXPath != null", "InteractiveForm.js(782): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sXPath) == "string", "typeof(sXPath) == \"string\"", "InteractiveForm.js(783): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sType != null, "sType != null", "InteractiveForm.js(784): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sType) == "string", "typeof(sType) == \"string\"", "InteractiveForm.js(785): fireValueHelp"); };
	mParams = {
		"Id": sId,
		"Value": sValue,
		"XPath": sXPath,
		"Type": sType
	};
	
	
	
	
	this["fireSemanticEvent"]("InteractiveForm", "ValueHelp", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["fireValueHelp"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the InteractiveForm.
 * @param {string} sValue The URL for the updated PDF Source
 * @fires InteractiveForm::PDFChange
 */
UCF_InteractiveForm["prototype"]["firePDFChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["firePDFChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InteractiveForm.js(809): firePDFChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InteractiveForm.js(810): firePDFChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InteractiveForm.js(811): firePDFChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "InteractiveForm.js(812): firePDFChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "InteractiveForm.js(813): firePDFChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("InteractiveForm", "PDFChange", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["firePDFChange"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the InteractiveForm.
 * @param {string} sValue The URL for the updated PDF Source.
 * @fires InteractiveForm::XMLChange
 */
UCF_InteractiveForm["prototype"]["fireXMLChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["fireXMLChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InteractiveForm.js(833): fireXMLChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InteractiveForm.js(834): fireXMLChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InteractiveForm.js(835): fireXMLChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "InteractiveForm.js(836): fireXMLChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "InteractiveForm.js(837): fireXMLChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("InteractiveForm", "XMLChange", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["fireXMLChange"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the InteractiveForm.
 * @param {string} sReturnValue The return value of the invoke call.
 * @fires InteractiveForm::ReturnValue
 */
UCF_InteractiveForm["prototype"]["fireReturnValue"] = function(sId, sReturnValue) {;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["fireReturnValue"]++; }; 
	/** @type {{Id: string, ReturnValue: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "InteractiveForm.js(857): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InteractiveForm.js(858): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InteractiveForm.js(859): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sReturnValue != null, "sReturnValue != null", "InteractiveForm.js(860): fireReturnValue"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sReturnValue) == "string", "typeof(sReturnValue) == \"string\"", "InteractiveForm.js(861): fireReturnValue"); };
	mParams = {
		"Id": sId,
		"ReturnValue": sReturnValue
	};
	
	
	this["fireSemanticEvent"]("InteractiveForm", "ReturnValue", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InteractiveForm["_"]["fireReturnValue"] = 0; };

};
sap["ls"]["preload"]["UCF_InteractiveFormAbap"] = function() {/* global _assert, _trace, DEBUG, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Queue */
/// <reference path="../../core/util/Queue.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ActiveComponent */
/// <reference path="./base/ActiveComponent.js"/>

/**
 * Use the InteractiveFormAbap control for embedding SAP Interactive Forms by
 * Adobe in a page.
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_InteractiveFormAbap(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["UCF_InteractiveFormAbap"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "InteractiveFormAbap.js(27): UCF_InteractiveFormAbap"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "InteractiveFormAbap.js(28): UCF_InteractiveFormAbap"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "InteractiveFormAbap.js(29): UCF_InteractiveFormAbap"); };

	UCF_ActiveComponent["apply"](this, [oDomRef, oLS]);
	/** The queue of messages to be sent to the Adobe Reader
	 * @private */
	this["oMessageQueue"] = new (UCF_ClassLoader["oGetClass"]("UCF_Queue"))();
	/** The next message from the Adobe Reader waiting for
	 * @private */
	this["sWaitingFor"] = "zciReady"; // eslint-disable-line @ur/no-memory-leaks

	/** A copy of this.bReadOnly and this.sXmlSource to compare with the current values
	 * @private */
	this["mAttributes"] = { "bReadOnly": false, "sXmlSource": null, "sSendDataUrl": null };
	/** The submit type (XML or PDF) the Adobe Reader has sent the data
	 * @private */
	this["sUpdateType"] = ""; // eslint-disable-line @ur/no-memory-leaks
	/** The interval trying to set the message handler for the ZCI communication
	 * @private */
	this["iTimeSlice"] = 100;
	/** Flag to indicate whether the object has already been initialized
	 * @private */
	this["bInitialized"] = false;
	/** Flag to indicate if a value help request has been sent from the form:
	 *  This is to improve the performance of value help requests: It is not neccessary to send
	 *  the PDF to the server for a valuehelp request - if any, the form data suffice because the
	 *  Web Dynpro (ABAP) application will not get control
	 * @private */
	this["bValueHelpRequest"] = false;
	/** Flag needed in conjunction withbInitialized
	 * @private */
	this["bDelayedPdfSubmit"] = false;
	/** Contains the version of the Adobe ZCI script (splitted in the release and timestamp part).
	 * @private */
	this["aZciVersion"] = ""; // eslint-disable-line @ur/no-memory-leaks

	this["attachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"], "onPendingRequest");

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["Lock"], this, "onBrowserLock");
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["Unlock"], this, "onBrowserUnlock");

	if (oBrowserWindow["bIsLocked"]()) {
		// If a popup will be opened at the same time as the interactive form will be
		// opened, the browser lock event will be risen before the interactive form will
		// be initialized. Nevertheless, the Adobe Reader has to be locked in that case,
		// so we will catch up this now
		this["onBrowserLock"]();
	}
};window["UCF_InteractiveFormAbap"] = UCF_InteractiveFormAbap; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_InteractiveFormAbap"); UCF_InteractiveFormAbap["_"] = {UCF_InteractiveFormAbap: 0}; }; ;
UCF_InteractiveFormAbap["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ActiveComponent"))(); UCF_InteractiveFormAbap.prototype["sClassName"] = "UCF_InteractiveFormAbap";

/**
 * Initialize method is called after rendering
 * @private
 */
UCF_InteractiveFormAbap["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["initialize"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Initialize InteractiveFormAbap. XmlSource=" + this["sXmlSource"] + " PdfSource=" + this["sPdfSource"] + " ReadOnly=" + this["bReadOnly"] + " Offline=" + this["bOffline"] + " PdfOnly=" + this["bPdfOnly"] + " HighlightOnError=" + this["sHighlightOnError"] + " XmlData=" + this["sXmlData"]["substr"](0, 20) + " LegacyAttachmentSupport=" + this["bLegacyAttachmentSupport"], "InteractiveFormAbap.js(85): initialize"); };
	UCF_ActiveComponent.prototype["initialize"]["apply"](this, arguments);

	if (!UCF_JsUtil["bIsActiveComponentEnabled"](UCF_JsUtil["eActiveComponents"]["ACROBAT"])) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Adobe Reader Plugin not available", "InteractiveFormAbap.js(89): initialize"); };

		this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);
		var oBrowserWindow = this["oLS"]["oBrowserWindow"];
		oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Lock"], this);
		oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Lock"], this);

		oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Unlock"], this);

		var div = document["createElement"]("DIV");
		div["id"] = this["sId"] + "-o";
		div["width"] = "100%";
		div["height"] = "100%";
		div["style"]["color"] = "#FF0000"; //red

		var errorText = this["oLS"]["sGetText"]("SAPUR_IFA_NO_PLUGIN");
		//errorText = "ERROR: The Adobe Reader plugin must be enabled to use this page.";
		div["appendChild"](document["createTextNode"](errorText));
		document["getElementById"](this["sId"] + "-o")["parentNode"]["replaceChild"](div, document["getElementById"](this["sId"] + "-o")["parentNode"]["firstChild"]);
		this["fireError"](this["sId"]);
		return;
	}

	if (this["bInitialized"] === false) { // Initial request
		this["bInitialized"] = true;
		this["mAttributes"]["sSendDataUrl"] = this["sXmlSource"]; // For the initial request, the URL to send the data to will be passed in xmlSource

		this["oObjectRef"] = this["oGetObjectRef"]();
		this["oObjectRef"]["messageHandler"] = this;
		UCF_JsUtil["delayedCall"](this["iTimeSlice"], this, "checkZCIReady");

		if (__UCF_DEBUG__) {
			this["postMessage"](["setLogReportingLevel", "debug"]);
			this["postMessage"](["getAcrobatVersion"]);
		}
		// The ZCI version is used to find out if (newer) features are available
		this["postMessage"](["getZCIVersion"]);
	} else if (this["sXmlSource"] !== "") {
		// For all update requests, xmlSource indicates that new data for the form are available on the backend
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "[" + this["sId"] + "] A form data update from the server is available", "InteractiveFormAbap.js(128): initialize"); };
		var requestURL = UCF_JsUtil["sGetResolvedUrl"](this["sXmlSource"], location["href"]);
		this["postMessage"](["getDataFromServer", requestURL, document["cookie"]]); // Ask Reader to get new form data

		// This is a workaround for a ZCI/Reader problem: The Reader will be unlocked in "getDataFromServer",
		// This behaviour isn't intended if a popup will be opened on top of the Reader:
		// As stated in message 0120061532 0001679143 2008 from Adobe, the Reader will be locked again for
		// the very next message (any message) from Web Dynpro. So we ask for the logReportingLevel as proposed...
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "grrrr", "InteractiveFormAbap.js(136): initialize"); };
		this["postMessage"](["getLogReportingLevel"]);
	} else if (this["sXmlData"] !== "") {
		//xmlData isn't empty
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "[" + this["sId"] + "] There are new data for the Adobe Reader.", "InteractiveFormAbap.js(140): initialize"); };
		this["postMessage"](["setFormData", this["sXmlData"]]);
	}

	if (this["bReadOnly"] !== this["mAttributes"]["bReadOnly"]) {
		// readOnly state has changed: switch Reader to corresponding state
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "[" + this["sId"] + "] The readOnly state has been changed from the server", "InteractiveFormAbap.js(146): initialize"); };
		if (this["bReadOnly"] === true) {
			this["postMessage"](["setFieldState", "readOnly"]);
		} else {
			this["postMessage"](["setFieldState", "restore"]);
		}
		this["mAttributes"]["bReadOnly"] = this["bReadOnly"]; //save new readOnly state
	}

	if (this["sHighlightOnError"]) {
		var parameters = this["sHighlightOnError"]["split"]("|");
		this["postMessage"](["markValidateFailed", parameters[0], parameters[1], parameters[2], parameters[3]]);
	} else {
		this["postMessage"](["clearValidateFailed"]);
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["initialize"] = 0; };

/**
 * Destroy is called when control is removed
 * @private
 */
UCF_InteractiveFormAbap["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["destroy"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "destroying", "InteractiveFormAbap.js(168): destroy"); };
	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Lock"], this);
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Unlock"], this);

	if (this["oMessageQueue"]) {
		this["oMessageQueue"]["destroy"]();
		this["oMessageQueue"] = null;
	}

	this["mAttributes"] = null;
	this["oObjectRef"] = null;
	this["oPendingRequest"] = null;
	UCF_ActiveComponent.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["destroy"] = 0; };

/**
 * @private
 */
UCF_InteractiveFormAbap["prototype"]["checkZCIReady"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["checkZCIReady"]++; }; 
	if (this["sWaitingFor"] === "zciReady") {
		UCF_JsUtil["delayedCall"](this["iTimeSlice"], this, "checkZCIReady");
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Waiting for zciReady message to come in.", "InteractiveFormAbap.js(192): checkZCIReady"); };
		try { //delete doesn't work for DOM elements in IE quirks mode...
			delete this["oObjectRef"]["messageHandler"];
		} catch (e) {}
		this["oObjectRef"]["messageHandler"] = this;
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["checkZCIReady"] = 0; };

/**
 * @private
 * @param {[]} params
 */
UCF_InteractiveFormAbap["prototype"]["onMessage"] = function(params) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onMessage"]++; }; 
	var command = params[0];
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Got a message from Adobe Reader: " + params, "InteractiveFormAbap.js(206): onMessage"); };
	switch (command) {
		case "zciReady":
			this["postMessage"](["setZCIReadyMessageSent", "false"]); //reset ZCI internal flag, otherwise offline scenario will hang (see CSN 0120061532 0003017919 2008)
			break;

		case "zciVersion":
			this["aZciVersion"] = params[1]["split"](".", 2);
			break;

		case "acrobatVersion":
			break;

		case "logReportingLevel":
			break;

		case "PDFSubmitRecommended":
			this["pdfSubmitRecommended"](params[1] === "true" ? true : false);
			break;

		case "dirtyState":
			if (this["bOffline"] === true) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "[" + this["sId"] + "] Offline scenario, send data to server independant of dirty state", "InteractiveFormAbap.js(228): onMessage"); };
				this["bOffline"] = false;
				this["setClientProperty"]("Offline", this["bOffline"], true);
				this["sendDataToServer"]("xml");
				break;
			}

			switch (params[1]) { //params[1]=="true" if doc is dirty, "false" if it is clear
				case "true":
					if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "[" + this["sId"] + "] Document has been modified, send data to server", "InteractiveFormAbap.js(237): onMessage"); };
					this["sendDataToServer"](this["bPdfOnly"] ? "pdf" : "xml");
					break;
				case "false":
					if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "[" + this["sId"] + "] Document has not been modified, skip sending data to server. Resume event queue.", "InteractiveFormAbap.js(241): onMessage"); };
					if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oPendingRequest"] != null, "this.oPendingRequest != null", "InteractiveFormAbap.js(242): onMessage", "this.oPendingRequest==null"); };
					if (this["oPendingRequest"] != null) {
						this["oPendingRequest"]["resume"](this["sId"]);
						this["oPendingRequest"] = null;
					}
					break;
				default:
					if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "[" + this["sId"] + "] Adobe Reader protocol error: Unknown dirtyState \"" + params[1] + "\"", "InteractiveFormAbap.js(249): onMessage"); };
			}
			break;

		case "submit":
			this["fireSubmit"](this["sId"]);
			break;

		case "check":
			// Not supported for Web Dynpro ABAP
			break;

		case "sendDataToServerContentType":
			this["sUpdateType"] = params[1];
			break;

		case "responseFromForm":
			if (params[2] === 'OK') {
				this["fireDataChange"](this["sId"], "xml", params[1]);
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "[" + this["sId"] + "] Resume event queue now.", "InteractiveFormAbap.js(268): onMessage"); };
				if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oPendingRequest"] != null, "this.oPendingRequest != null", "InteractiveFormAbap.js(269): onMessage", "this.oPendingRequest==null"); };
				if (this["oPendingRequest"] != null) {
					this["oPendingRequest"]["resume"](this["sId"]);
					this["oPendingRequest"] = null;
				}

			} else {
				if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "[" + this["sId"] + "] Adobe: responseFromForm return code " + params[2], "InteractiveFormAbap.js(276): onMessage"); };
				if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "[" + this["sId"] + "] Adobe: responseFromForm reason " + params[3], "InteractiveFormAbap.js(277): onMessage"); };
			}
			break;

		case "responseFromServer":
			if (params[2] === 'OK' || params[2] === '') {
				this["mAttributes"]["sSendDataUrl"] = params[1]; // The backend returns a new URL to be used to send the data for the data change
				this["fireDataChange"](this["sId"], this["sUpdateType"], ""); // xml|pdf
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "[" + this["sId"] + "] Document was successfully sent to the server. Resume event queue now.", "InteractiveFormAbap.js(285): onMessage"); };
				if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oPendingRequest"] != null, "this.oPendingRequest != null", "InteractiveFormAbap.js(286): onMessage", "this.oPendingRequest==null"); };
				if (this["oPendingRequest"] != null) {
					this["oPendingRequest"]["resume"](this["sId"]);
					this["oPendingRequest"] = null;
				}
			} else {
				if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "[" + this["sId"] + "] Adobe: responseFromServer return code " + params[2], "InteractiveFormAbap.js(292): onMessage"); };
				if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "[" + this["sId"] + "] Adobe: responseFromServer reason " + params[3], "InteractiveFormAbap.js(293): onMessage"); };
			}
			break;

		case "valueHelp":
			// Not supported for Web Dynpro ABAP
			break;

		case "valueSelect":
			this["bValueHelpRequest"] = true;
			this["fireValueHelp"](this["sId"], params[2], params[1], "");
			break;

		case "f4HelpOpen":
			// Not supported for Web Dynpro ABAP
			break;

		case "lockFormComplete":
			break;

		case "unlockFormComplete":
			break;

		case "finishedSettingData":
			if (params[1] !== "OK" && params[1] !== "") {
				if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "[" + this["sId"] + "] AdobeReader error: " + params[1] + ", " + params[2], "InteractiveFormAbap.js(318): onMessage"); };
			}
			break;

		case "log":
			if (params[1] && !params[1]["match"](/^\s*$/)) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "line 1: " + params[1], "InteractiveFormAbap.js(324): onMessage"); };
			}
			if (params[2] && !params[2]["match"](/^\s*$/)) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "line 2: " + params[2], "InteractiveFormAbap.js(327): onMessage"); };
			}
			if (params[3] && !params[3]["match"](/^\s*$/)) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "line 3: " + params[3], "InteractiveFormAbap.js(330): onMessage"); };
			}
	}
	if (this["sWaitingFor"] === command) this["sWaitingFor"] = null;
	if (!this["sWaitingFor"]) this["postNextMessage"]();
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onMessage"] = 0; };

/**
 * @private
 * @param {Object} obj
 */
UCF_InteractiveFormAbap["prototype"]["onError"] = function(obj) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onError"]++; };  // callback, wird vom Reader bei einem Fehler gerufen
	var errorText = "Adobe Reader error: ";
	var i;

	for (i in obj)
		if (i["charCodeAt"](0) !== 95) {
			errorText += i + ": " + obj[i] + "\n";
		}
	if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, errorText, "InteractiveFormAbap.js(349): onError"); };
	alert(errorText);
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onError"] = 0; };

/**
 * @private
 * @param {Object} oEvent
 */
UCF_InteractiveFormAbap["prototype"]["onPendingRequest"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onPendingRequest"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "got a PendingRequest event", "InteractiveFormAbap.js(358): onPendingRequest"); };

	if (!this["oLS"]["oGetPopupManagerInternal"]()["bIsActiveWindow"]()) {
		// Do not suspend the pending request for the requests of other popups
		return;
	}

	var oPendingRequest = oEvent["oGetParam"]("oPendingRequest");
	oPendingRequest["suspend"](this["sId"]);
	this["oPendingRequest"] = oPendingRequest;

	if (this["checkZCIVersion"]("800", "20090205121016")) {
		// 800.20090205121016.525164.525164 is the minimum required ZCI version which supports ZCI command "isPDFSubmitRequired"
		this["postMessage"](["isPDFSubmitRequired"]);
	} else {
		// For older ZCI-script versions, we have to workaround this (with poor performance!):
		// The PDF will always be sent to the server as soon as attachment support has been switched on from the application
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "This version of the ZCI-script does not support message 'isPDFSubmitRequired'. Evaluate LegacyAttachmentSupport flag.", "InteractiveFormAbap.js(375): onPendingRequest"); };
		this["pdfSubmitRecommended"](this["bLegacyAttachmentSupport"]);
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onPendingRequest"] = 0; };

/**
 * @private
 * @param { Object } oEvent
 */
UCF_InteractiveFormAbap["prototype"]["onBrowserLock"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onBrowserLock"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "got a Browser Lock event", "InteractiveFormAbap.js(385): onBrowserLock"); };
	this["postMessage"](["lock"]);
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onBrowserLock"] = 0; };

/**
 * @private
 * @param { Object } oEvent
 */
UCF_InteractiveFormAbap["prototype"]["onBrowserUnlock"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onBrowserUnlock"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "got a Browser Unlock event", "InteractiveFormAbap.js(394): onBrowserUnlock"); };
	this["postMessage"](["unlock"]);
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onBrowserUnlock"] = 0; };

/**
 * @private
 * @param {[]} aMessage
 */
UCF_InteractiveFormAbap["prototype"]["postMessage"] = function(aMessage) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["postMessage"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "queuing message: " + aMessage, "InteractiveFormAbap.js(403): postMessage"); };

	var waitingFor = "";
	switch (aMessage[0]) {
		case "getZCIVersion":
			waitingFor = "zciVersion";
			break;
		case "getAcrobatVersion":
			waitingFor = "acrobatVersion";
			break;
		case "lock":
			waitingFor = "lockFormComplete";
			break;
		case "isPDFSubmitRequired":
			waitingFor = "PDFSubmitRecommended";
			break;
		case "isDocDirty":
			waitingFor = "dirtyState";
			break;
		case "sendDataToServer":
			waitingFor = "sendDataToServerContentType";
			break;
		case "getFormData":
			waitingFor = "responseFromForm";
			break;
		case "setFormData":
			waitingFor = "finishedSettingData";
		case "getDataFromServer":
			waitingFor = "finishedSettingData";
			break;
		case "unlock":
			waitingFor = "unlockFormComplete";
			break;
		case "setFieldState":
			waitingFor = "setFieldStateComplete";
			break;
		case "getViewState":
			waitingFor = "viewState";
			break;
		case "getLogReportingLevel":
			waitingFor = "logReportingLevel";
			break;
		case "getZCIReadyMessageSent":
			waitingFor = "sentZCIReadyMessageState";
			break;
		case "emailDocument":
			waitingFor = "emailDocumentComplete";
			break;
		case "printDocument":
			waitingFor = "printDocumentComplete";
			break;
		default:
			waitingFor = "";
	}

	this["oMessageQueue"]["push"]({ "aMessage": aMessage, "sWaitingFor": waitingFor });
	if (!this["sWaitingFor"]) this["postNextMessage"]();
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["postMessage"] = 0; };

/**
 * @private
 */
UCF_InteractiveFormAbap["prototype"]["postNextMessage"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["postNextMessage"]++; }; 
	if (this["oMessageQueue"]["peek"]()) {
		var oNext = this["oMessageQueue"]["get"]();
		try {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "[" + this["sId"] + "] Posting message to Adobe Reader: " + oNext["aMessage"], "InteractiveFormAbap.js(469): postNextMessage"); };
			this["oObjectRef"]["postMessage"](oNext["aMessage"]);
		} catch (e) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "[" + this["sId"] + "] Could not post message to Adobe Reader: " + e, "InteractiveFormAbap.js(472): postNextMessage"); };
		}
		this["sWaitingFor"] = oNext["sWaitingFor"];
		if (!this["sWaitingFor"]) this["postNextMessage"]();
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["postNextMessage"] = 0; };

/**
 * @private
 * @param {string} sSubmitType
 */
UCF_InteractiveFormAbap["prototype"]["sendDataToServer"] = function(sSubmitType) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["sendDataToServer"]++; }; 
	if (sSubmitType === "xml" && this["checkZCIVersion"]("901", "20091209021135") && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
		// 901.20091209021135.618954.610412 is the minimum required ZCI version which supports the ZCI commands "getFormData" and "setFormData"
		this["postMessage"](["getFormData", ""]);
	} else {
		var requestURL = UCF_JsUtil["sGetResolvedUrl"](this["mAttributes"]["sSendDataUrl"], location["href"]);
		if (UCF_UserAgent["bIsGecko"]()) {
			requestURL += "&" + (new Date())["getTime"]();
		}

		this["postMessage"](["sendDataToServer", requestURL, document["cookie"], sSubmitType, ""]);
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["sendDataToServer"] = 0; };

/**
 * @private
 * @param {boolean} bPDFRecommended
 */
UCF_InteractiveFormAbap["prototype"]["pdfSubmitRecommended"] = function(bPDFRecommended) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["pdfSubmitRecommended"]++; }; 
	if (bPDFRecommended || this["bDelayedPdfSubmit"]) {
		if (this["bValueHelpRequest"]) {
			// This is a performance optimization for valuehelp requests: It is not neccessary to send
			// the PDF to the server for a valuehelp request - if any, the form data suffice because the Web Dynpro application
			// will not get control
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "This is a value help request so we don't ask the Reader to send the whole PDF for performance reasons. Instead, we check if the form data have been changed.", "InteractiveFormAbap.js(507): pdfSubmitRecommended"); };
			this["bDelayedPdfSubmit"] = true;
			this["postMessage"](["isDocDirty"]);
		} else {
			if (this["bDelayedPdfSubmit"]) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "The PDF has to be sent due to the precedent valuehelp request.", "InteractiveFormAbap.js(512): pdfSubmitRecommended"); };
			} else {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "It's recommended to send the whole PDF, so we don't need to check the dirty state anymore.", "InteractiveFormAbap.js(514): pdfSubmitRecommended"); };
			}
			this["bDelayedPdfSubmit"] = false;
			this["sendDataToServer"]("pdf");
		}
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "It's recommended to send the form data (XML) only -> check the dirty state of the document additionally", "InteractiveFormAbap.js(520): pdfSubmitRecommended"); };
		this["postMessage"](["isDocDirty"]);
	}
	this["bValueHelpRequest"] = false;
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["pdfSubmitRecommended"] = 0; };

/**
 * @public
 * @param {string} somExpression
 */
UCF_InteractiveFormAbap["prototype"]["setFocusInternal"] = function(somExpression) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["setFocusInternal"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Focused Interactive Form, Calling setCursor on Adobe Reader", "InteractiveFormAbap.js(531): setFocusInternal"); };
	this["postMessage"](["setCursor", somExpression]);
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["setFocusInternal"] = 0; };

/**
 * @private
 * @param {integer} reqMajorVersion
 * @param {integer} reqTimestamp
 * @return {boolean}
 */
UCF_InteractiveFormAbap["prototype"]["checkZCIVersion"] = function(reqMajorVersion, reqTimestamp) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["checkZCIVersion"]++; }; 
	var iZciVersion = parseInt(this["aZciVersion"][0], 10);
	var iReqMajorVersion = parseInt(reqMajorVersion, 10);
	// Compare major version first
	if (iZciVersion < iReqMajorVersion) {
		return false;
	}
	if (iZciVersion > iReqMajorVersion) {
		return true;
	}
	// Major versions are equal, compare timestamp
	if (this["aZciVersion"][1] < reqTimestamp) {
		return false;
	}
	return true;
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["checkZCIVersion"] = 0; };

UCF_InteractiveFormAbap["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "InteractiveFormAbap.js(559): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource["getAttribute"]("tp") === "END") {
		oAccessibilityHelper["setControlType"]("AX_END");
	} else {
		oAccessibilityHelper["setControlType"]("AX");
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_InteractiveFormAbap["prototype"]["aAttributeNames"] = ["sVisibility","sTooltip","sLifeCycle","sXmlSource","sPdfSource","bReadOnly","bOffline","bPdfOnly","sHighlightOnError","sXmlData","bLegacyAttachmentSupport","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_InteractiveFormAbap["prototype"]["aEventNames"] = ["Submit","ValueHelp","DataChange","Error"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_InteractiveFormAbap["prototype"]["aMethodNames"] = ["setKeepAlive","setFocusInternal","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_InteractiveFormAbap["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_InteractiveFormAbap["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_InteractiveFormAbap["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_InteractiveFormAbap["prototype"]["sXmlSource"] = '';

/**
 * @private
 * @type {string}
 */
UCF_InteractiveFormAbap["prototype"]["sPdfSource"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_InteractiveFormAbap["prototype"]["bReadOnly"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_InteractiveFormAbap["prototype"]["bOffline"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_InteractiveFormAbap["prototype"]["bPdfOnly"] = false;

/**
 * @private
 * @type {string}
 */
UCF_InteractiveFormAbap["prototype"]["sHighlightOnError"] = '';

/**
 * @private
 * @type {string}
 */
UCF_InteractiveFormAbap["prototype"]["sXmlData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_InteractiveFormAbap["prototype"]["bLegacyAttachmentSupport"] = false;

/**
 * @private
 * @type {string}
 */
UCF_InteractiveFormAbap["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_InteractiveFormAbap["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sLifeCycle"] = "BROWSER";
	this["sXmlSource"] = '';
	this["sPdfSource"] = '';
	this["bReadOnly"] = false;
	this["bOffline"] = false;
	this["bPdfOnly"] = false;
	this["sHighlightOnError"] = '';
	this["sXmlData"] = '';
	this["bLegacyAttachmentSupport"] = false;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("XmlSource", '', true);
		this["setClientProperty"]("PdfSource", '', true);
		this["setClientProperty"]("ReadOnly", false, true);
		this["setClientProperty"]("Offline", false, true);
		this["setClientProperty"]("PdfOnly", false, true);
		this["setClientProperty"]("HighlightOnError", '', true);
		this["setClientProperty"]("XmlData", '', true);
		this["setClientProperty"]("LegacyAttachmentSupport", false, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The id of the InteractiveForm.
 * @fires InteractiveFormAbap::Submit
 */
UCF_InteractiveFormAbap["prototype"]["fireSubmit"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["fireSubmit"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "InteractiveFormAbap.js(710): fireSubmit"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InteractiveFormAbap.js(711): fireSubmit"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InteractiveFormAbap.js(712): fireSubmit"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("InteractiveFormAbap", "Submit", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["fireSubmit"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the InteractiveForm.
 * @param {string} sValue The current field value.
 * @param {string} sXPath The XPath expression for the field.
 * @param {string} sType The type of the requested value help.
 * @fires InteractiveFormAbap::ValueHelp
 */
UCF_InteractiveFormAbap["prototype"]["fireValueHelp"] = function(sId, sValue, sXPath, sType) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["fireValueHelp"]++; }; 
	/** @type {{Id: string, Value: string, XPath: string, Type: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "InteractiveFormAbap.js(732): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InteractiveFormAbap.js(733): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InteractiveFormAbap.js(734): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "InteractiveFormAbap.js(735): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "InteractiveFormAbap.js(736): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sXPath != null, "sXPath != null", "InteractiveFormAbap.js(737): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sXPath) == "string", "typeof(sXPath) == \"string\"", "InteractiveFormAbap.js(738): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sType != null, "sType != null", "InteractiveFormAbap.js(739): fireValueHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sType) == "string", "typeof(sType) == \"string\"", "InteractiveFormAbap.js(740): fireValueHelp"); };
	mParams = {
		"Id": sId,
		"Value": sValue,
		"XPath": sXPath,
		"Type": sType
	};
	
	
	
	
	this["fireSemanticEvent"]("InteractiveFormAbap", "ValueHelp", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["fireValueHelp"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the InteractiveForm.
 * @param {string} sSubmitType The submit type the data has been sent (xml|pdf)
 * @param {string} sXmlData The form data from the Adobe Reader
 * @fires InteractiveFormAbap::DataChange
 */
UCF_InteractiveFormAbap["prototype"]["fireDataChange"] = function(sId, sSubmitType, sXmlData) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["fireDataChange"]++; }; 
	/** @type {{Id: string, SubmitType: string, XmlData: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "InteractiveFormAbap.js(765): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InteractiveFormAbap.js(766): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InteractiveFormAbap.js(767): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSubmitType != null, "sSubmitType != null", "InteractiveFormAbap.js(768): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSubmitType) == "string", "typeof(sSubmitType) == \"string\"", "InteractiveFormAbap.js(769): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sXmlData != null, "sXmlData != null", "InteractiveFormAbap.js(770): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sXmlData) == "string", "typeof(sXmlData) == \"string\"", "InteractiveFormAbap.js(771): fireDataChange"); };
	mParams = {
		"Id": sId,
		"SubmitType": sSubmitType,
		"XmlData": sXmlData
	};
	
	
	
	this["fireSemanticEvent"]("InteractiveFormAbap", "DataChange", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["fireDataChange"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the InteractiveForm.
 * @fires InteractiveFormAbap::Error
 */
UCF_InteractiveFormAbap["prototype"]["fireError"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["fireError"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "InteractiveFormAbap.js(792): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "InteractiveFormAbap.js(793): fireError"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "InteractiveFormAbap.js(794): fireError"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("InteractiveFormAbap", "Error", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_InteractiveFormAbap["_"]["fireError"] = 0; };

UCF_InteractiveFormAbap.prototype["aPublicMethods"] = ["setFocusInternal"].concat(UCF_InteractiveFormAbap.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ItemList"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ItemList(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ItemList["_"]["UCF_ItemList"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "ItemList.js(21): UCF_ItemList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ItemList.js(22): UCF_ItemList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ItemList.js(23): UCF_ItemList"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	if (window["UCF_System"]["bIs508"]) {
		this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
		this["addDelegate"](this["oItemNavigation"]);

		this["createItems"]();
		this["oItemNavigation"]["setFocusedIndex"](this["oItemNavigation"]["iFocusedIndex"]);
		UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
	}
};window["UCF_ItemList"] = UCF_ItemList; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemList"); UCF_ItemList["_"] = {UCF_ItemList: 0}; }; ;

UCF_ItemList["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ItemList.prototype["sClassName"] = "UCF_ItemList";

/**
 * Create an item array for keyboard navigation
 */
UCF_ItemList["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemList["_"]["createItems"]++; }; 
	var aDomItems = this["oDomRef"]["getElementsByTagName"]("LI");

	for (var iItemCount = 0; iItemCount < aDomItems["length"]; iItemCount++) {
		var oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[iItemCount], true);
		this["oItemNavigation"]["addItem"](oItem, false);
	}
};;if (__UCF_COVERAGE__) { UCF_ItemList["_"]["createItems"] = 0; };

/**
 * Destructor
 */
UCF_ItemList["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemList["_"]["destroy"]++; }; 
	if (this["oItemNavigation"]) {
		this["oItemNavigation"]["destroy"]();
		this["oItemNavigation"] = null;
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ItemList["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ItemList["prototype"]["aAttributeNames"] = ["sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ItemList["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ItemList["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ItemList["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ItemList["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ItemList["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemList["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ItemList["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ItemListBox"] = function() {/* global UCF_LayeredControl */
/// <reference path="./LayeredControl.js"/>

/**
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ItemListBox(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["UCF_ItemListBox"]++; }; 
	if (arguments["length"] > 0) {
		UCF_LayeredControl["apply"](this, arguments);
	}
};window["UCF_ItemListBox"] = UCF_ItemListBox; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemListBox"); UCF_ItemListBox["_"] = {UCF_ItemListBox: 0}; }; ;
UCF_ItemListBox["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_ItemListBox.prototype["sClassName"] = "UCF_ItemListBox";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ItemListBox["prototype"]["aAttributeNames"] = ["sWidth","iVisibleItems","sHeight","bInvalid","bEnabled","bReadonly","bMultipleSelection","bRequired","bIsPopup","sIconVisibility","sFirstValueVisibility","sSecondValueVisibility","sVisibility","sInputState","sDragSourceInfo","sDropTargetInfo","iScrollTop","sAccessKey","bAvailable","sServerFilter","bComplete","bFiltered","sTableDataDefinition","sItemTableData","sHistoryTableData","sCustomData","sCustomStyle","sTableDataItemDesign","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ItemListBox["prototype"]["aEventNames"] = ["Select","Drag","Drop","Scroll","DoubleClick"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ItemListBox["prototype"]["aMethodNames"] = ["setEnabled","selectItemById","deselectItemById","setTooltip","setValue","setValues","getText","getTexts","getValue","getValues","scrollToItemByIndex","createDataTip","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sWidth"] = '0';

/**
 * @private
 * @type {number}
 */
UCF_ItemListBox["prototype"]["iVisibleItems"] = 10;

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sHeight"] = '0';

/**
 * @private
 * @type {boolean}
 */
UCF_ItemListBox["prototype"]["bInvalid"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_ItemListBox["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_ItemListBox["prototype"]["bReadonly"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_ItemListBox["prototype"]["bMultipleSelection"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_ItemListBox["prototype"]["bRequired"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_ItemListBox["prototype"]["bIsPopup"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ItemListBoxVisibility}
 */
UCF_ItemListBox["prototype"]["sIconVisibility"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ItemListBoxVisibility}
 */
UCF_ItemListBox["prototype"]["sFirstValueVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ItemListBoxVisibility}
 */
UCF_ItemListBox["prototype"]["sSecondValueVisibility"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ItemListBox["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputState}
 */
UCF_ItemListBox["prototype"]["sInputState"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {number}
 */
UCF_ItemListBox["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_ItemListBox["prototype"]["bAvailable"] = true;

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sServerFilter"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_ItemListBox["prototype"]["bComplete"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_ItemListBox["prototype"]["bFiltered"] = true;

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sTableDataDefinition"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sItemTableData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sHistoryTableData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputDesign}
 */
UCF_ItemListBox["prototype"]["sTableDataItemDesign"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_ItemListBox["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ItemListBox["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["setDefaultValues"]++; }; 
	this["sWidth"] = '0';
	this["iVisibleItems"] = 10;
	this["sHeight"] = '0';
	this["bInvalid"] = false;
	this["bEnabled"] = true;
	this["bReadonly"] = false;
	this["bMultipleSelection"] = false;
	this["bRequired"] = false;
	this["bIsPopup"] = false;
	this["sIconVisibility"] = "NONE";
	this["sFirstValueVisibility"] = "VISIBLE";
	this["sSecondValueVisibility"] = "NONE";
	this["sVisibility"] = "VISIBLE";
	this["sInputState"] = "NONE";
	this["sDragSourceInfo"] = '';
	this["sDropTargetInfo"] = '';
	this["iScrollTop"] = 0;
	this["sAccessKey"] = '';
	this["bAvailable"] = true;
	this["sServerFilter"] = '';
	this["bComplete"] = true;
	this["bFiltered"] = true;
	this["sTableDataDefinition"] = '';
	this["sItemTableData"] = '';
	this["sHistoryTableData"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sTableDataItemDesign"] = "STANDARD";
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Width", '0', true);
		this["setClientProperty"]("VisibleItems", 10, true);
		this["setClientProperty"]("Height", '0', true);
		this["setClientProperty"]("Invalid", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Readonly", false, true);
		this["setClientProperty"]("MultipleSelection", false, true);
		this["setClientProperty"]("Required", false, true);
		this["setClientProperty"]("IsPopup", false, true);
		this["setClientProperty"]("IconVisibility", "NONE", true);
		this["setClientProperty"]("FirstValueVisibility", "VISIBLE", true);
		this["setClientProperty"]("SecondValueVisibility", "NONE", true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("InputState", "NONE", true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("Available", true, true);
		this["setClientProperty"]("ServerFilter", '', true);
		this["setClientProperty"]("Complete", true, true);
		this["setClientProperty"]("Filtered", true, true);
		this["setClientProperty"]("TableDataDefinition", '', true);
		this["setClientProperty"]("ItemTableData", '', true);
		this["setClientProperty"]("HistoryTableData", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("TableDataItemDesign", "STANDARD", true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {Array<any>} sKeys Array of the selected keys
 * @fires ItemListBox::Select
 */
UCF_ItemListBox["prototype"]["fireSelect"] = function(sId, sKeys) {;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, Keys: Array<any>}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ItemListBox.js(288): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ItemListBox.js(289): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ItemListBox.js(290): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sKeys != null, "sKeys != null", "ItemListBox.js(291): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sKeys) == "object", "typeof(sKeys) == \"object\"", "ItemListBox.js(292): fireSelect"); };
	mParams = {
		"Id": sId,
		"Keys": sKeys
	};
	
	
	this["fireSemanticEvent"]("ItemListBox", "Select", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires ItemListBox::Drag
 */
UCF_ItemListBox["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "ItemListBox.js(313): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ItemListBox.js(314): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ItemListBox.js(315): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "ItemListBox.js(316): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "ItemListBox.js(317): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "ItemListBox.js(318): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "ItemListBox.js(319): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("ItemListBox", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sKey The key of the ItemListItem where the drop occured
 * @param {number} iOffset The Offset relative to the ItemListItem where the drop occured (signum)
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires ItemListBox::Drop
 */
UCF_ItemListBox["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, sKey, iOffset, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, Key: string, Offset: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 12, "arguments.length == 12", "ItemListBox.js(351): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ItemListBox.js(352): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ItemListBox.js(353): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "ItemListBox.js(354): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "ItemListBox.js(355): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "ItemListBox.js(356): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "ItemListBox.js(357): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sKey != null, "sKey != null", "ItemListBox.js(358): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sKey) == "string", "typeof(sKey) == \"string\"", "ItemListBox.js(359): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOffset != null, "iOffset != null", "ItemListBox.js(360): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOffset) == "number", "typeof(iOffset) == \"number\"", "ItemListBox.js(361): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "ItemListBox.js(362): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "ItemListBox.js(363): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "ItemListBox.js(364): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "ItemListBox.js(365): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "ItemListBox.js(366): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "ItemListBox.js(367): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "ItemListBox.js(368): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "ItemListBox.js(369): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "ItemListBox.js(370): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "ItemListBox.js(371): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "ItemListBox.js(372): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "ItemListBox.js(373): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "ItemListBox.js(374): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "ItemListBox.js(375): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"Key": sKey,
		"Offset": iOffset,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("ItemListBox", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop Sets the distance between the top of the object and the topmost portion of the content currently visible in pixels.
 * @fires ItemListBox::Scroll
 */
UCF_ItemListBox["prototype"]["fireScroll"] = function(sId, iScrollTop) {;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ItemListBox.js(415): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ItemListBox.js(416): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ItemListBox.js(417): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "ItemListBox.js(418): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "ItemListBox.js(419): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop
	};
	
	
	this["fireSemanticEvent"]("ItemListBox", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {Array<any>} sKeys Array of the selected keys
 * @fires ItemListBox::DoubleClick
 */
UCF_ItemListBox["prototype"]["fireDoubleClick"] = function(sId, sKeys) {;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string, Keys: Array<any>}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ItemListBox.js(439): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ItemListBox.js(440): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ItemListBox.js(441): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sKeys != null, "sKeys != null", "ItemListBox.js(442): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sKeys) == "object", "typeof(sKeys) == \"object\"", "ItemListBox.js(443): fireDoubleClick"); };
	mParams = {
		"Id": sId,
		"Keys": sKeys
	};
	
	
	this["fireSemanticEvent"]("ItemListBox", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ItemListBox["_"]["fireDoubleClick"] = 0; };

};
sap["ls"]["preload"]["UCF_ItemListBoxActionItem"] = function() {/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>

/**
 * 
 * @class ItemListBoxActionItem
 * @extends UCF_Control
 * @version
 * @param {element} oDomRef the dom element representing the control
 * @param {UCF_LS} oLS the LightSpeed instance managing the control
 */
function UCF_ItemListBoxActionItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ItemListBoxActionItem["_"]["UCF_ItemListBoxActionItem"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Control["apply"](this, [oDomRef, oLS]);

		/** @type {string} */
		this["sText"] = UCF_DomUtil["sGetInnerText"](this["oDomRef"]) || '';
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Text", this["sText"], true);

		/** @type {string} */
		this["sTooltip"] = this["oDomRef"]["getAttribute"]('title') || '';
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Tooltip", this["sTooltip"], true);
	}
};window["UCF_ItemListBoxActionItem"] = UCF_ItemListBoxActionItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemListBoxActionItem"); UCF_ItemListBoxActionItem["_"] = {UCF_ItemListBoxActionItem: 0}; }; ;
UCF_ItemListBoxActionItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ItemListBoxActionItem.prototype["sClassName"] = "UCF_ItemListBoxActionItem";

/**
 * @private
 */
UCF_ItemListBoxActionItem["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxActionItem["_"]["destroy"]++; }; 
	this["sText"] = null;
	this["sTooltip"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxActionItem["_"]["destroy"] = 0; };

/**
 * add/remove the "selected" visualization to/from the action item
 *
 * @param {boolean} bSelect true to select the item, false to deselect the item
 */
UCF_ItemListBoxActionItem["prototype"]["select"] = function(bSelect) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxActionItem["_"]["select"]++; }; 
	if (bSelect) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsIlb2ISelAct');
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsItemlistbox__action--selected');
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsItemlistbox__action--focus');
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsIlb2ISelAct');
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsItemlistbox__action--selected');
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsItemlistbox__action--focus');
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxActionItem["_"]["select"] = 0; };

/**
 * add/remove the "focus" visualization to/from the action item
 *
 * @param { boolean } bFocus true to show focus borders, false to remove them
 */
UCF_ItemListBoxActionItem["prototype"]["showFocus"] = function(bFocus) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxActionItem["_"]["showFocus"]++; }; 
	if (bFocus) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsItemlistbox__action--focus');
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsItemlistbox__action--focus');
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxActionItem["_"]["showFocus"] = 0; };

/**
 * action items are always enabled.
 *
 * @return {boolean} always true
 */
UCF_ItemListBoxActionItem["prototype"]["bIsEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxActionItem["_"]["bIsEnabled"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxActionItem["_"]["bIsEnabled"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ItemListBoxActionItem["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ItemListBoxActionItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ItemListBoxActionItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ItemListBoxActionItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ItemListBoxActionItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxActionItem["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxActionItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ItemListBoxDragDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_ItemListBoxDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_ItemListBoxDragDelegate["_"]["UCF_ItemListBoxDragDelegate"]++; }; 

	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);

};window["UCF_ItemListBoxDragDelegate"] = UCF_ItemListBoxDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemListBoxDragDelegate"); UCF_ItemListBoxDragDelegate["_"] = {UCF_ItemListBoxDragDelegate: 0}; }; ;
UCF_ItemListBoxDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_ItemListBoxDragDelegate.prototype["sClassName"] = "UCF_ItemListBoxDragDelegate";

UCF_ItemListBoxDragDelegate["prototype"]["oGetGhost"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxDragDelegate["_"]["oGetGhost"]++; }; 

	var oTable = this["oDragSourceControl"]["oDomRef"]["getElementsByTagName"]("table")[0];
	var oGhostFragment = oTable["cloneNode"](true);

	var index = 0;

	for (var i = 0; i < this["oDragSourceControl"]["aItems"]["length"]; i++) {
		if (!this["oDragSourceControl"]["aItems"][i]["bIsSelected"]()) {
			var tr = oGhostFragment["getElementsByTagName"]("tr")[index];

			UCF_DomUtil["removeFromDom"](tr);
		} else {
			index++;
		}

	}

	oGhostFragment["style"]["width"] = oTable["offsetWidth"] + "px";

	var oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oGhostFragment);

	oGhost["setOffset"](12, 12);

	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxDragDelegate["_"]["oGetGhost"] = 0; };

UCF_ItemListBoxDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxDragDelegate["_"]["bIsDragPossible"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem = this["oLS"]["oGetControlByDomRef"](oBrowserEvent["oGetSource"]());
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();

	if (oBrowserEvent["oGetSource"]() === this["oDragSourceControl"]["oDomRef"])
		return false;

	return oBrowserEvent["oGetSourceControl"]()["bEnabled"]
		&& oItem && oItem["bIsSelected"]() &&
		(!oBrowserEvent["bIsTouchInteraction"]()
			|| (oBrowserEvent["bIsTouchInteraction"]()
				&& oSource
				&& UCF_DomUtil["bHasClass"](oSource, 'lsItemlistbox__content')
				&& UCF_DomUtil["bHasClass"](oSource, 'lsItemlistbox__content--draghandle')));
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxDragDelegate["_"]["bIsDragPossible"] = 0; };

};
sap["ls"]["preload"]["UCF_ItemListBoxDropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_ItemListBox_ie6} oItemListBox
 * @param {UCF_LS} oLS
 */
function UCF_ItemListBoxDropDecorator(oItemListBox, oLS) {if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDecorator["_"]["UCF_ItemListBoxDropDecorator"]++; }; 

	UCF_LineDecorator["apply"](this, [oItemListBox, true]);
	this["oLS"] = oLS;
};window["UCF_ItemListBoxDropDecorator"] = UCF_ItemListBoxDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemListBoxDropDecorator"); UCF_ItemListBoxDropDecorator["_"] = {UCF_ItemListBoxDropDecorator: 0}; }; ;

/**
 *
 */
UCF_ItemListBoxDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(); UCF_ItemListBoxDropDecorator.prototype["sClassName"] = "UCF_ItemListBoxDropDecorator";

/**
 *
 */
UCF_ItemListBoxDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDecorator["_"]["update"]++; }; 

	var oViewPort = UCF_DomUtil["oGetObjectRect"](this["oControl"]["oDomRef"]),
		iItemHeight = 0,
		iItemCount = this["oControl"]["iGetItemCount"](),
		aRows = this["oControl"]["oDomRef"]["getElementsByTagName"]("tr"),
		oFirstItem = aRows[0],
		iIndex = -1,
		oItemListBoxItem = null;

	//calcualte item height
	if (oFirstItem && iItemCount > 0) {
		iItemHeight = oFirstItem["offsetHeight"];

		var iOffsetY = oBrowserEvent["iPageY"]() - oViewPort["top"] - 1 + this["oControl"]["oDomRef"]["scrollTop"];

		iIndex = Math["floor"]((iOffsetY + iItemHeight / 2) / iItemHeight);
		//constrain to number of real items since there are dummy rows
		iIndex = Math["min"](iIndex, iItemCount);

	}
	this["oDomRefToBeFocussed"] = null;
	if (iIndex === -1) {
		this["sKey"] = "";
		this["iOffset"] = 0;
	} else if (iIndex < iItemCount) {
		oItemListBoxItem = this["oLS"]["oGetControlByDomRef"](aRows[iIndex], true);
		this["sKey"] = oItemListBoxItem["sKey"];
		this["iOffset"] = -1;
	} else if (iIndex === iItemCount) {
		oItemListBoxItem = this["oLS"]["oGetControlByDomRef"](aRows[iIndex - 1], true);
		this["sKey"] = oItemListBoxItem["sKey"];
		this["iOffset"] = 1;
	}

	if (oItemListBoxItem)
		this["oDomRefToBeFocussed"] = UCF_DomUtil["oGetFirstChild"](oItemListBoxItem["oDomRef"]);

	//window.status = this.sKey + " " + this.iOffset;

	var iTop = iIndex * iItemHeight + oViewPort["top"] - this["oControl"]["oDomRef"]["scrollTop"],
		iWidth = this["oControl"]["oDomRef"]["clientWidth"],
		iLeft = oViewPort["left"] + 1;

	if (window["UCF_System"]["bIsRTL"])
		iLeft += 13;

	this["setBounds"](iLeft, iTop, iWidth);

};;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDecorator["_"]["update"] = 0; };

/**
 *
 */
UCF_ItemListBoxDropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDecorator["_"]["oGetDropLocation"]++; }; 

	return { "sKey": this["sKey"], "iOffset": this["iOffset"] };

};;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDecorator["_"]["oGetDropLocation"] = 0; };

/**
 * destructor
 */
UCF_ItemListBoxDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDecorator["_"]["destroy"]++; }; 
	this["oLS"] = null;
	this["oDomRef"] = null;
	this["oDomRefToBeFocussed"] = null;
	this["sKey"] = null;
	this["iOffset"] = null;

	UCF_LineDecorator.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_ItemListBoxDropDelegate"] = function() {/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_ItemListBoxDropDecorator */
/// <reference path="../decorators/ItemListBoxDropDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS the lightspeed instance
 * @param {UCF_ItemListBox} oDropTargetControl the drop target
 */
function UCF_ItemListBoxDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDelegate["_"]["UCF_ItemListBoxDropDelegate"]++; }; 
	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);
	this["iCurrentStep"] = 0;
	this["oLS"] = oLS;
};window["UCF_ItemListBoxDropDelegate"] = UCF_ItemListBoxDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemListBoxDropDelegate"); UCF_ItemListBoxDropDelegate["_"] = {UCF_ItemListBoxDropDelegate: 0}; }; ;
UCF_ItemListBoxDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_ItemListBoxDropDelegate.prototype["sClassName"] = "UCF_ItemListBoxDropDelegate";

/** @override */
UCF_ItemListBoxDropDelegate["prototype"]["oCreateDropDecorator"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDelegate["_"]["oCreateDropDecorator"]++; }; 
	return new (UCF_ClassLoader["oGetClass"]("UCF_ItemListBoxDropDecorator"))(this["oDropTargetControl"], this["oLS"]);
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDelegate["_"]["oCreateDropDecorator"] = 0; };

/** @override */
UCF_ItemListBoxDropDelegate["prototype"]["oGetDropLocation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDelegate["_"]["oGetDropLocation"]++; }; 
	return this["oDropDecorator"]["oGetDropLocation"]();
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDelegate["_"]["oGetDropLocation"] = 0; };

/** @override */
UCF_ItemListBoxDropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDelegate["_"]["fGetDropCallBack"]++; }; 
	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		oLocation = this["oGetDropLocation"](),
		sKey = oLocation["sKey"],
		iOffset = oLocation["iOffset"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function(sDragData, sMimeType) {
		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			sKey,
			iOffset,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);
	};
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDelegate["_"]["fGetDropCallBack"] = 0; };

/**
 * returns the item where the user has dropped
 * @override
 */
UCF_ItemListBoxDropDelegate["prototype"]["oGetDomRefToBeFocussed"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDelegate["_"]["oGetDomRefToBeFocussed"]++; }; 
	/** @type {HTMLElement} */
	var oItemListBoxItemDomRef = this["oDropDecorator"]["oDomRefToBeFocussed"];

	return oItemListBoxItemDomRef || UCF_DropDelegate.prototype["oGetDomRefToBeFocussed"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxDropDelegate["_"]["oGetDomRefToBeFocussed"] = 0; };

};
sap["ls"]["preload"]["UCF_ItemListBoxItem"] = function() {/* global UCF_Control */
/// <reference path="../core/Control.js"/>

/**
 * 
 * @version
 *
 * @class
 * @extends UCF_Control
 * @param {element} oDomRef the dom element that represents the ItemListBoxItem
 * @param {UCF_LS} oLS the LightSpeed instance that manages the ItemListBoxItem
 */
function UCF_ItemListBoxItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ItemListBoxItem["_"]["UCF_ItemListBoxItem"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Control["apply"](this, arguments);
	}
};window["UCF_ItemListBoxItem"] = UCF_ItemListBoxItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemListBoxItem"); UCF_ItemListBoxItem["_"] = {UCF_ItemListBoxItem: 0}; }; ;
UCF_ItemListBoxItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ItemListBoxItem.prototype["sClassName"] = "UCF_ItemListBoxItem";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ItemListBoxItem["prototype"]["aAttributeNames"] = ["sIconSrc","sDisabledIconSrc","sSemanticTextColor","bIsDeletable","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ItemListBoxItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ItemListBoxItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ItemListBoxItem["prototype"]["sIconSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ItemListBoxItem["prototype"]["sDisabledIconSrc"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_ItemListBoxItem["prototype"]["sSemanticTextColor"] = "STANDARD";

/**
 * @private
 * @type {boolean}
 */
UCF_ItemListBoxItem["prototype"]["bIsDeletable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_ItemListBoxItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ItemListBoxItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem["_"]["setDefaultValues"]++; }; 
	this["sIconSrc"] = '';
	this["sDisabledIconSrc"] = '';
	this["sSemanticTextColor"] = "STANDARD";
	this["bIsDeletable"] = false;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("IconSrc", '', true);
		this["setClientProperty"]("DisabledIconSrc", '', true);
		this["setClientProperty"]("SemanticTextColor", "STANDARD", true);
		this["setClientProperty"]("IsDeletable", false, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ItemListBoxItem_ie6"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ItemListBoxItem */
/// <reference path="./ItemListBoxItem.js"/>

/**
 * ItemListBoxItem
 *
 * <br>
 * <b>Java Control references</b><br>
 * <a href="../javadoc/com/sap/tc/ls/api/controls/LSItemListBox.html">LSItemListBox</a>
 *
 * 
 * @class
 * @extends UCF_ItemListBox
 * @version
 * @param {element} oDomRef the dom element that represents the ItemListBoxItem
 * @param {UCF_LS} oLS the LightSpeed instance that manages the ItemListBoxItem
 */
function UCF_ItemListBoxItem_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["UCF_ItemListBoxItem_ie6"]++; }; 
	/** @type {HTMLTableDataCellElement[]} */
	var aDisabledRefs;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "ItemListBoxItem_ie6.js(28): UCF_ItemListBoxItem_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ItemListBoxItem_ie6.js(29): UCF_ItemListBoxItem_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ItemListBoxItem_ie6.js(30): UCF_ItemListBoxItem_ie6"); };

	UCF_ItemListBoxItem["apply"](this, [oDomRef, oLS]);

	aDisabledRefs = UCF_DomUtil["getElementsByClassName"]('lsItemlistbox__content--disabled', this["oDomRef"]);

	/** @type {number} */
	this["iIndex"] = -1;
	/** @type {string} */
	this["sKey"] = this["oDomRef"]["getAttribute"]('data-itemkey') || '';
	/** @type {string} */
	this["sTooltip"] = this["oDomRef"]["getAttribute"]('data-itemtooltip') || '';
	/** @type {string} */
	this["sValue1"] = this["oDomRef"]["getAttribute"]('data-itemvalue1')
								|| this["oDomRef"]["getAttribute"]('data-value') // suggest history
								|| '';
	/** @type {string} */
	this["sValue2"] = this["oDomRef"]["getAttribute"]('data-itemvalue2') || '';
	/** @type {string} */
	this["sIconToolTip"] = this["oDomRef"]["getAttribute"]('data-itemicontooltip') || '';
	/** @type {boolean} */
	this["bEnabled"] = aDisabledRefs["length"] === 0;
	/** @type {string} */
	this["sGroupTitle"] = UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsItemlistbox__item--group')
		? UCF_DomUtil["sGetInnerText"](UCF_DomUtil["oGetFirstChild"](this["oDomRef"]))
		: '';

	this["oDeleteRef"] = UCF_DomUtil["$"](this["sId"] + '-delete');
};window["UCF_ItemListBoxItem_ie6"] = UCF_ItemListBoxItem_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemListBoxItem_ie6"); UCF_ItemListBoxItem_ie6["_"] = {UCF_ItemListBoxItem_ie6: 0}; }; ;
UCF_ItemListBoxItem_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemListBoxItem"))(); UCF_ItemListBoxItem_ie6.prototype["sClassName"] = "UCF_ItemListBoxItem_ie6";

UCF_ItemListBoxItem_ie6["BEM_CLASSNAME"] = 'lsItemlistbox__item';

/**
 * Destructor
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["destroy"]++; }; 
	this["oDomRef"] = null;
	this["oDeleteRef"] = null;

	this["iIndex"] = null;
	this["bEnabled"] = null;
	this["sKey"] = null;
	this["sTooltip"] = null;
	this["sValue1"] = null;
	this["sValue2"] = null;
	this["sIconToolTip"] = null;
	this["sGroupTitle"] = null;

	UCF_ItemListBoxItem.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["destroy"] = 0; };

/**
 * Select a item
 *
 * @param {boolean} bSelect true to select the item, false to deselect the item
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["select"] = function(bSelect) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["select"]++; }; 
	if (this["oDomRef"]) {
		if (bSelect) {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsItemlistbox__item--selected');
		} else {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsItemlistbox__item--selected');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["select"] = 0; };

/**
 * show focus borders on an item
 *
 * @param {boolean} bFocus true to show focus borders, false to remove them
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["showFocus"] = function(bFocus) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["showFocus"]++; }; 
	if (this["oDomRef"]) {
		if (bFocus) {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsItemlistbox__item--focus');
		} else {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsItemlistbox__item--focus');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["showFocus"] = 0; };

/**
 * Match Value1. Check if a string matches Value1 one from the start of Value1 in the
 * length of the passed string. The case is ignored.
 *
 * @param {string} sString String to search for
 * @return {boolean} true if the string matches, false if not
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["bMatchValue1"] = function(sString) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bMatchValue1"]++; }; 
	/** @type {string} */
	var sSTRING = sString["toUpperCase"]();
	/** @type {string} */
	var sVALUE1 = this["sValue1"]["toUpperCase"]();

	sVALUE1 = sVALUE1["substr"](0, sString["length"]);

	return sSTRING === sVALUE1;
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bMatchValue1"] = 0; };

/**
 * Match Value2. Check if a string matches Value1 one from the start of Value1 in the
 * length of the passed string. The case is ignored.
 *
 * @param {string} sString String to search for
 * @return {boolean} true if the string matches, false if not
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["bMatchValue2"] = function(sString) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bMatchValue2"]++; }; 
	/** @type {string} */
	var sSTRING = sString["toUpperCase"]();
	/** @type {string} */
	var sVALUE2 = this["sValue2"]["toUpperCase"]();

	sVALUE2 = sVALUE2["substr"](0, sString["length"]);

	return sSTRING === sVALUE2;
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bMatchValue2"] = 0; };

/**
 * Checks whether the item is an selectable item that can be selected
 * for the 508 case this is also true for disabled items but not for hidden items
 * @return {boolean} true if being selected, else false
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["bIsSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bIsSelectable"]++; }; 
	/** @type {boolean} */
	var bVisible = this["oDomRef"]["style"]["display"] !== 'none';
	/** @type {boolean} */
	var bActive = (this["bIsEnabled"]() && !this["bIsGroup"]()) || this["oLS"]["oSystem"]["bIs508"];

	return bVisible && bActive;
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bIsSelectable"] = 0; };

/**
 * Checks if an item is enabled
 *
 * @return {boolean} true if being enabled, else false
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["bIsEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bIsEnabled"]++; }; 
	return this["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bIsEnabled"] = 0; };

/**
 * Set the enabled state for this control
 *
 * @param {boolean} bEnabled true to be enabled, else false
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["setEnabled"]++; }; 
	/** @type {HTMLImageElement} */
	var oImg;
	/** @type {HTMLTableDataCellElement} */
	var oTextCell;

	if (this["bEnabled"] !== bEnabled) {
		this["bEnabled"] = bEnabled;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Enabled", this["bEnabled"], true);

		oImg = UCF_DomUtil["firstChild"](this["oDomRef"]["cells"][0], 'IMG');

		if (oImg) {
			oImg["src"] = bEnabled || !this["sDisabledIconSrc"]
				? this["sIconSrc"]
				: this["sDisabledIconSrc"];

			if (!bEnabled && !this["sDisabledIconSrc"]) {
				this["oDomRef"]["style"]["filter"] = 'Gray()';
			}

			oTextCell = this["oDomRef"]["cells"][1];
		} else {
			oTextCell = this["oDomRef"]["cells"][0];
		}

		if (bEnabled) {
			UCF_DomUtil["removeClass"](oTextCell, 'lsItemlistbox__item--disabled');
		} else {
			UCF_DomUtil["addClass"](oTextCell, 'lsItemlistbox__item--disabled');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["setEnabled"] = 0; };

/**
 * Checks if an item is a group item
 *
 * @return {boolean} true if being a group item, else false
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["bIsGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bIsGroup"]++; }; 
	return this["sGroupTitle"] !== '';
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bIsGroup"] = 0; };

/**
 * Checks if an item is selected
 *
 * @return {boolean} true if being selected, else false
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["bIsSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bIsSelected"]++; }; 
	return UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsItemlistbox__item--selected');
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["bIsSelected"] = 0; };

/**
 * Gets the item index
 *
 * @return {number} item index
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["iGetIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["iGetIndex"]++; }; 
	return this["iIndex"] === -1
		? this["oDomRef"]["rowIndex"]
		: this["iIndex"];
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["iGetIndex"] = 0; };

/**
 * Sets the item index
 *
 * @param {int} index set the index of this item
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["setIndex"] = function(index) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["setIndex"]++; }; 
	this["iIndex"] = index;
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["setIndex"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseover
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["onmouseover"]++; }; 
	if (this["bIsDeletable"] && this["oDeleteRef"]) {
		if (oBrowserEvent["oGetSource"]() === this["oDeleteRef"]) {
			UCF_DomUtil["addClass"](this["oDeleteRef"], 'lsControl--hover');
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsControl--hover');
		} else {
			UCF_DomUtil["removeClass"](this["oDeleteRef"], 'lsControl--active');
			UCF_DomUtil["removeClass"](this["oDeleteRef"], 'lsControl--hover');
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsControl--hover');
		}
	} else {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsControl--hover');
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["onmouseover"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseout
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["onmouseout"]++; }; 
	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsControl--hover');
	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsControl--active');
	if (this["oDeleteRef"]) {
		UCF_DomUtil["removeClass"](this["oDeleteRef"], 'lsControl--active');
		UCF_DomUtil["removeClass"](this["oDeleteRef"], 'lsControl--hover');
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["onmouseout"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the mousedown
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["onmousedown"]++; }; 
	if (this["bIsDeletable"] && this["oDeleteRef"] && oBrowserEvent["oGetSource"]() === this["oDeleteRef"]) {
		UCF_DomUtil["addClass"](this["oDeleteRef"], 'lsControl--active');
	} else {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsControl--active');
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["onmousedown"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseup
 * @private
 */
UCF_ItemListBoxItem_ie6["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["onmouseup"]++; }; 
	if (this["oDeleteRef"]) {
		UCF_DomUtil["removeClass"](this["oDeleteRef"], 'lsControl--active');
	}
	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsControl--active');
};;if (__UCF_COVERAGE__) { UCF_ItemListBoxItem_ie6["_"]["onmouseup"] = 0; };

};
sap["ls"]["preload"]["UCF_ItemListBox_ie6"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Cache */
/// <reference path="../../../core/util/Cache.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_ItemListBoxItem */
/// <reference path="../ItemListBoxItem.js"/>
/* global UCF_ItemListBox */
/// <reference path="./ItemListBox.js"/>
/* global UCF_LayeredControl */
/// <reference path="./LayeredControl.js"/>

/**
 * 
 * @class UCF_ItemListBox
 * @extends UCF_LayeredControl
 * @param {HTMLElement} oDomRef the dom ref
 * @param {UCF_LS} oLS the lightspeed instance
 */
function UCF_ItemListBox_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["UCF_ItemListBox_ie6"]++; }; 
	if (arguments["length"] > 0) {
		UCF_ItemListBox["apply"](this, [oDomRef, oLS]);

		/** @type {number} item height */
		this["iItemHeight"] = null;
		/** @type {Array.<UCF_ItemListBoxItem>} */
		this["aItems"] = null;
		/** @type {boolean} */
		this["bEnhancePopupWindows"] = true;
		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

		if (this["getClientControl"]()) {
			this["getClientControl"]()["updateBindings"](true);
		}
	}
};window["UCF_ItemListBox_ie6"] = UCF_ItemListBox_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemListBox_ie6"); UCF_ItemListBox_ie6["_"] = {UCF_ItemListBox_ie6: 0}; }; ;
UCF_ItemListBox_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemListBox"))(); UCF_ItemListBox_ie6.prototype["sClassName"] = "UCF_ItemListBox_ie6";

/** @private */
UCF_ItemListBox_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["destroy"]++; }; 
	this["oCache"]["destroy"]();

	this["iItemHeight"] = null;
	this["aItems"] = null;
	this["oCache"] = null;
	this["bEnabled"] = null;
	this["bReadonly"] = null;

	UCF_ItemListBox.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["destroy"] = 0; };

/**
 * @protected
 * @param {HTMLElement} oDomRef the dom ref
 * @return {UCF_Control}
 */
UCF_ItemListBox_ie6["prototype"]["oGetControlByDomRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetControlByDomRef"]++; }; 
	return this["oLS"]["oControlFactory"]["oGetEnclosingControlByDomRef"](oDomRef);
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetControlByDomRef"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_ItemListBox_ie6["prototype"]["iGetItemHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["iGetItemHeight"]++; }; 
	/** @type {number} */
	var i;
	/** @type {number} */
	var iOffsetHeight;
	/** @type {HTMLSpanElement} */
	var oPlaceholder;
	/** @type {HTMLElement} */
	var oParentRef;
	/** @type {HTMLElement} */
	var oAssociatedAreaRef;
	/** @type {Array.<DomRefs>} */
	var aItemsDomRef;

	if (!this["iItemHeight"]) {
		if (!this["oDomRef"]["offsetParent"]) {
			// ...move control to associated area to avoid wrong calculation of
			// iItemHeight if the control is invisible at the moment
			oPlaceholder = document["createElement"]('span');

			oParentRef = this["oRootRef"]["parentNode"];
			oParentRef["insertBefore"](oPlaceholder, this["oRootRef"]);

			oAssociatedAreaRef = this["oLS"]["oGetAssociatedAreaRef"]();
			oAssociatedAreaRef["appendChild"](this["oRootRef"]);
		}
		aItemsDomRef = this["aGetItemsDomRefs"]();
		for (i = 0; i < aItemsDomRef["length"]; i++) {
			iOffsetHeight = aItemsDomRef[i]["offsetHeight"];

			if (iOffsetHeight > this["iItemHeight"]) {
				this["iItemHeight"] = iOffsetHeight;
			}
		}

		if (oParentRef) {
			// ...and move back
			oParentRef["insertBefore"](this["oRootRef"], oPlaceholder);
			oParentRef["removeChild"](oPlaceholder);
		}
		if (!this["iItemHeight"]) {
			this["iItemHeight"] = 18;
		}
	}

	return this["iItemHeight"];
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["iGetItemHeight"] = 0; };

/**
 * @private
 * @return {Array.<DomRef>}
 */
UCF_ItemListBox_ie6["prototype"]["aGetItemsDomRefs"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["aGetItemsDomRefs"]++; }; 
	/** @type {UCF_ItemListBox_ie6} */
	var self = this;

	return self["oCache"]["get"]('aGetItemsDomRefs', function() {
		if (
			self["renderTableData"] &&
			self["sTableDataDefinition"] &&
			UCF_DomUtil["getElementsByClassName"](
				'lsItemlistbox__content--empty',
				self["oGetContentDomRef"]()
			)["length"] > 0
		) {
			self["renderTableData"]();
		}

		return UCF_JsUtil["arrayFrom"](self["oDomRef"]["getElementsByTagName"]('tr'));
	});
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["aGetItemsDomRefs"] = 0; };

/**
 * @private
 * @return {Array.<UCF_ItemListBoxItem>}
 */
UCF_ItemListBox_ie6["prototype"]["aGetItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["aGetItems"]++; }; 
	/** @type {UCF_ItemListBox} */
	var self = this;
	/** @type {Array.<DomRefs>} */
	var aItemsDomRef;

	if (!this["aItems"]) {
		aItemsDomRef = this["aGetItemsDomRefs"]();
		this["aItems"] = UCF_JsUtil["map"](
			UCF_JsUtil["filter"](
				aItemsDomRef,
				function(oItemDomRef) { return oItemDomRef["getAttribute"]('ct'); }
			),
			function(oItemDomRef, i) {
				/** @type {UCF_ItemListBoxItem} */
				var oItem = self["oLS"]["oGetControlByDomRef"](oItemDomRef);
				oItem["setIndex"](i);
				return oItem;
			}
		);
	}

	return this["aItems"];
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["aGetItems"] = 0; };

/**
 * @private
 * @return {Object.<string,UCF_ItemListBoxItem>}
 */
UCF_ItemListBox_ie6["prototype"]["mGetItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["mGetItems"]++; }; 
	/** @type {UCF_ItemListBox_ie6} */
	var self = this;

	return this["oCache"]["get"]('mItems', function() {
		return UCF_JsUtil["reduce"](
			self["aGetItems"](),
			function(mItems, oItem) {
				mItems[oItem["sKey"]] = oItem;

				return mItems;
			}, {}
		);
	});
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["mGetItems"] = 0; };

/**
 * @private
 * @return {UCF_ItemListBoxActionItem[]}
 */
UCF_ItemListBox_ie6["prototype"]["aGetActionItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["aGetActionItems"]++; }; 
	/** @type {UCF_ItemListBox_ie6} */
	var self = this;

	return this["oCache"]["get"]('aActionItems', function() {
		return UCF_JsUtil["reduce"](
			self["aGetActionItemDomRefs"](),
			function(aActionItems, oItemRef) {
				if (oItemRef["getAttribute"]('ct')) {
					aActionItems["push"](self["oLS"]["oGetControlByDomRef"](oItemRef));
				}

				return aActionItems;
			},
			[]
		);
	});
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["aGetActionItems"] = 0; };

/**
 * @protected
 * @return {HTMLAnchorElement[]}
 */
UCF_ItemListBox_ie6["prototype"]["aGetActionItemDomRefs"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["aGetActionItemDomRefs"]++; }; 
	/** @type {UCF_ItemListBox_ie6} */
	var self = this;

	return self["oCache"]["get"]('aActionItemDomRefs', function() {
		return UCF_JsUtil["filter"](
			UCF_JsUtil["arrayFrom"](self["oDomRef"]["getElementsByTagName"]('a')),
			function(oRef) {
				return UCF_DomUtil["sGetCurrentStyle"](oRef, 'display') !== 'none';
			}
		);
	});
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["aGetActionItemDomRefs"] = 0; };

/**
 * @see UCF_LayeredControl
 * @override
 * @private
 */
UCF_ItemListBox_ie6["prototype"]["addClassesOnOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["addClassesOnOpen"]++; }; 
	if (!UCF_DomUtil["bHasClass"](
			this["oRootRef"],
			UCF_LayeredControl["BOX_SHADOW_CLASS"]
		)) {
		UCF_DomUtil["addClass"](this["oRootRef"], UCF_LayeredControl["BOX_SHADOW_CLASS"]);
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["addClassesOnOpen"] = 0; };

/**
 * @private
 * @return {HTMLElement}
 */
UCF_ItemListBox_ie6["prototype"]["oGetContentDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetContentDomRef"]++; }; 
	return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetContentDomRef"] = 0; };

/**
 * Gets the item
 *
 * @private
 * @param {string} sKey item key
 * @return {UCF_ItemListBoxItem} item with the passed key or null if no item
 * with that key exists
 */
UCF_ItemListBox_ie6["prototype"]["oGetItem"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sKey === 'string', "typeof sKey === 'string'", "ItemListBox_ie6.js(262): oGetItem"); }; // space keys are allowed

	return this["mGetItems"]()[sKey];
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetItem"] = 0; };

/**
 * Gets the item from the event source
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @return {UCF_ItemListBoxItem|UCF_ItemListBoxActionItem} item if the event
 * source is an itemlistbox item, null if not
 */
UCF_ItemListBox_ie6["prototype"]["oGetItemFromBrowserEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetItemFromBrowserEvent"]++; }; 
	/** @type {UCF_ItemListBoxItem|UCF_ItemListBoxActionItem} */
	var oItem = this["oLS"]["oGetControlByDomRef"](oBrowserEvent["oGetSource"]());

	return (UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem')
			|| UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxActionItem'))
		? oItem
		: null;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetItemFromBrowserEvent"] = 0; };
/**
 * Gets the previous selectable/focusable item of an item
 *
 * @param {UCF_ItemListBoxItem} oItem the current item
 * @return {UCF_ItemListBoxItem} the previous item
 * @private
 */
UCF_ItemListBox_ie6["prototype"]["oGetPreviousItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetPreviousItem"]++; }; 
	/** @type {number} */
	var iCurrentIndex;
	/** @type {UCF_ItemListBoxItem} */
	var oPreviousItem;
	/** @type {Array.<UCF_ItemListBoxItem>} */
	var aItems = this["aGetItems"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_ItemListBoxItem, "oItem instanceof UCF_ItemListBoxItem", "ItemListBox_ie6.js(299): oGetPreviousItem"); };

	iCurrentIndex = oItem["iGetIndex"]() - 1;
	oPreviousItem = null;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'iCurrentIndex=' + iCurrentIndex, "ItemListBox_ie6.js(304): oGetPreviousItem"); };

	while (iCurrentIndex >= 0) {
		oPreviousItem = aItems[iCurrentIndex];
		if (oPreviousItem["bIsSelectable"]()) {
			return oPreviousItem;
		}
		iCurrentIndex--;
	}

	return oItem;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetPreviousItem"] = 0; };

/**
 * Gets the next selectable/focusable item of an item
 *
 * @private
 * @param {UCF_ItemListBoxItem} oItem the current item
 * @return {UCF_ItemListBoxItem} the next item
 */
UCF_ItemListBox_ie6["prototype"]["oGetNextItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetNextItem"]++; }; 
	/** @type {number} */
	var iCurrentIndex;
	/** @type {UCF_ItemListBoxItem} */
	var oNextItem;
	/** @type {Array.<UCF_ItemListBoxItem>} */
	var aItems = this["aGetItems"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem != null, "oItem != null", "ItemListBox_ie6.js(332): oGetNextItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_ItemListBoxItem, "oItem instanceof UCF_ItemListBoxItem", "ItemListBox_ie6.js(333): oGetNextItem"); };

	iCurrentIndex = oItem["iGetIndex"]() + 1;
	oNextItem = null;

	while (iCurrentIndex < aItems["length"]) {
		oNextItem = aItems[iCurrentIndex];
		if (oNextItem["bIsSelectable"]()) {
			return oNextItem;
		}
		iCurrentIndex++;
	}

	return oItem;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetNextItem"] = 0; };

/**
 * Finds an item for search string
 *
 * @private
 * @param {string} sSearchString String to search for items
 * @param {UCF_ItemListBoxItem} oStartItem item to start the search
 * @return {UCF_ItemListBoxItem} matching item
 */
UCF_ItemListBox_ie6["prototype"]["oFindItem"] = function(sSearchString, oStartItem) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oFindItem"]++; }; 
	/** @type {boolean} */
	var bStartSearch = false;
	/** @type {UCF_ItemListBoxItem} */
	var oFirstFoundItem = null;
	/** @type {UCF_ItemListBoxItem} */
	var oFoundItem = null;
	/** @type {number} */
	var i;
	/** @type {Array.<UCF_ItemListBoxItem>} */
	var aItems = this["aGetItems"]();

	if (sSearchString) {
		if (!oStartItem) {
			bStartSearch = true;
		}

		for (i = 0; i < aItems["length"]; i++) {
			if (oStartItem === aItems[i]) {
				bStartSearch = true;
			}

			if (this["sFirstValueVisibility"] !== 'NONE') {
				if (aItems[i]["bMatchValue1"](sSearchString)) {
					if (bStartSearch) {
						if (oStartItem !== aItems[i]) {
							oFoundItem = aItems[i];
							break;
						}
					} else if (!oFirstFoundItem) {
						oFirstFoundItem = aItems[i];
					}
				}
			}

			if (this["sSecondValueVisibility"] !== 'NONE') {
				if (aItems[i]["bMatchValue2"](sSearchString)) {
					if (bStartSearch) {
						if (oStartItem !== aItems[i]) {
							oFoundItem = aItems[i];
							break;
						}
					} else if (!oFirstFoundItem) {
						oFirstFoundItem = aItems[i];
					}
				}
			}
		}

		return oFoundItem || oFirstFoundItem;
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oFindItem"] = 0; };

/**
 * Gets the first item
 *
 * @private
 * @return {UCF_ItemListBoxItem} the first selectable item
 */
UCF_ItemListBox_ie6["prototype"]["oGetFirstItem"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetFirstItem"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oFirstItem;
	/** @type {UCF_ItemListBoxItem} */
	var _oFirstItem;
	/** @type {Array.<UCF_ItemListBoxItem>} */
	var aItems = this["aGetItems"]();

	if (aItems["length"] === 0) {
		return null; // empty list
	} else {
		oFirstItem = aItems[0];
		_oFirstItem = oFirstItem;

		while (!oFirstItem["bIsSelectable"]()) {
			oFirstItem = this["oGetNextItem"](oFirstItem);
			if (oFirstItem === _oFirstItem) { // bailout
				break;
			}
		}

		return oFirstItem;
	}

};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetFirstItem"] = 0; };

/**
 * Gets the last item
 *
 * @private
 * @return {UCF_ItemListBoxItem} the last selectable item
 */
UCF_ItemListBox_ie6["prototype"]["oGetLastItem"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetLastItem"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oLastItem;
	/** @type {UCF_ItemListBoxItem} */
	var _oLastItem;
	/** @type {Array.<UCF_ItemListBoxItem>} */
	var aItems = this["aGetItems"]();

	if (aItems["length"] === 0) {
		return null; // empty list
	} else {
		oLastItem = aItems[aItems["length"] - 1];
		_oLastItem = oLastItem;

		while (!oLastItem["bIsSelectable"]()) {
			oLastItem = this["oGetPreviousItem"](oLastItem);
			if (oLastItem === _oLastItem) { // bailout
				break;
			}
		}

		return oLastItem;
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetLastItem"] = 0; };

/**
 * Get item index
 *
 * @private
 * @param {string} sKey the reference item key
 * @return {number} the index of the item
 */
UCF_ItemListBox_ie6["prototype"]["iGetItemIndex"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["iGetItemIndex"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem = this["mGetItems"]()[sKey];

	return oItem ? oItem["oDomRef"]["rowIndex"] + 1 : 0;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["iGetItemIndex"] = 0; };

/**
 * Gets the number of items
 *
 * @private
 * @return {number} number of "real" items (empty item not included)
 */
UCF_ItemListBox_ie6["prototype"]["iGetItemCount"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["iGetItemCount"]++; }; 
	/** @type {Array.<UCF_ItemListBoxItem>} */
	var aItems = this["aGetItems"]();

	return aItems ? aItems["length"] : 0;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["iGetItemCount"] = 0; };

/**
 * Get item value
 *
 * @private
 * @param {string} sKey the item key
 * @return {string} the value of the item
 */
UCF_ItemListBox_ie6["prototype"]["sGetItemValue"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["sGetItemValue"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem = this["mGetItems"]()[sKey];

	if (oItem) {
		return (
				this["sFirstValueVisibility"] === 'VISIBLE' ||
				this["sSecondValueVisibility"] === 'NONE'
			)
			? oItem["sValue1"]
			: oItem["sValue2"];
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["sGetItemValue"] = 0; };

/**
 * Get item description
 *
 * @param {string} sKey the item key
 * @return {string} the description of the item
 * @private
 */
UCF_ItemListBox_ie6["prototype"]["sGetItemDescription"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["sGetItemDescription"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem = this["mGetItems"]()[sKey];

	if (oItem) {
		if (this["sFirstValueVisibility"] === 'DESCRIPTIVE') {
			return oItem["sValue1"];
		} else if (this["sSecondValueVisibility"] === 'DESCRIPTIVE') {
			return oItem["sValue2"];
		} else {
			return '';
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["sGetItemDescription"] = 0; };

/**
 * Gets the first action item
 * @private
 * @return {UCF_ItemListBoxActionItem} first action item
 */
UCF_ItemListBox_ie6["prototype"]["oGetFirstActionItem"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetFirstActionItem"]++; }; 
	/** @type {Array.<UCF_ItemListBoxActionItems>} */
	var aActionItems = this["aGetActionItems"]();

	return aActionItems["length"] > 0
		? aActionItems[0]
		: null;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetFirstActionItem"] = 0; };

/**
 * Gets the last action item
 * @private
 * @return {UCF_ItemListBoxActionItem} last action item
 */
UCF_ItemListBox_ie6["prototype"]["oGetLastActionItem"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetLastActionItem"]++; }; 
	/** @type {Array.<UCF_ItemListBoxActionItems>} */
	var aActionItems = this["aGetActionItems"]();

	return aActionItems["length"] > 0
		? aActionItems[aActionItems["length"] - 1]
		: null;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetLastActionItem"] = 0; };

/**
 * Gets the next action item
 * @private
 * @param {UCF_ItemListBoxActionItem} oItem given itemlistbox action item
 * @return {UCF_ItemListBoxActionItem} next action item
 */
UCF_ItemListBox_ie6["prototype"]["oGetNextActionItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetNextActionItem"]++; }; 
	/** @type {UCF_ItemListBoxActionItem} */
	var oNextItem = oItem;
	/** @type {number} */
	var i;
	/** @type {Array.<UCF_ItemListBoxActionItems>} */
	var aActionItems = this["aGetActionItems"]();

	for (i = 0; i < aActionItems["length"]; i++) {
		if (oItem === aActionItems[i] && i < aActionItems["length"] - 1) {
			oNextItem = aActionItems[i + 1];
		}
	}

	return oNextItem;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetNextActionItem"] = 0; };

/**
 * Gets the previous action item
 * @private
 * @param {UCF_ItemListBoxActionItem} oItem given itemlistbox action item
 * @return {UCF_ItemListBoxActionItem} previous action item
 */
UCF_ItemListBox_ie6["prototype"]["oGetPreviousActionItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetPreviousActionItem"]++; }; 
	/** @type {UCF_ItemListBoxActionItem} */
	var oPreviousItem = oItem;
	/** @type {number} */
	var i;
	/** @type {Array.<UCF_ItemListBoxActionItems>} */
	var aActionItems = this["aGetActionItems"]();

	for (i = aActionItems["length"] - 1; i > 0; i--) {
		if (oItem === aActionItems[i] && i > 0) {
			oPreviousItem = aActionItems[i - 1];
		}
	}

	return oPreviousItem;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["oGetPreviousActionItem"] = 0; };

/**
 * Set readonly state of the ItemListBox
 * @private
 * @param {boolean} bSet set read only state if true, remove read only state if
 * false
 */
UCF_ItemListBox_ie6["prototype"]["setReadonly"] = function(bSet) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["setReadonly"]++; }; 
	if (bSet !== this["bReadonly"]) {
		this["bReadonly"] = bSet;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Readonly", this["bReadonly"], true);
		this["applyReadonlyClass"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["setReadonly"] = 0; };

/** @private */
UCF_ItemListBox_ie6["prototype"]["applyReadonlyClass"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["applyReadonlyClass"]++; }; 
	if (this["bReadonly"]) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsItemlistbox--readonly');
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsItemlistbox--readonly');
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["applyReadonlyClass"] = 0; };

/**
 * Set enabled
 * @public
 * @param {boolean} bEnabled the new enabled value
 */
UCF_ItemListBox_ie6["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["setEnabled"]++; }; 
	if (this["bEnabled"] !== bEnabled) {
		this["bEnabled"] = bEnabled;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Enabled", this["bEnabled"], true);
		this["applyDisabledClass"]();

		UCF_JsUtil["forEach"](this["aGetItems"](), function(item) {
			item["setEnabled"](bEnabled);
		});
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["setEnabled"] = 0; };

/** @private */
UCF_ItemListBox_ie6["prototype"]["applyDisabledClass"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["applyDisabledClass"]++; }; 
	if (this["bEnabled"]) {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsItemlistbox--disabled');
	} else {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsItemlistbox--disabled');
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["applyDisabledClass"] = 0; };

/**
 * Sets the key value of the ItemListBox
 * @public
 * @param {string|Array.<string>} sKey the key of the selected entry or a list
 * of multiple selected keys
 */
UCF_ItemListBox_ie6["prototype"]["setValue"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["setValue"]++; }; 
	if (this["bIsWriteable"]()) {
		this["setValues"](UCF_JsUtil["bIsArray"](sKey) ? sKey : [sKey]);
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["setValue"] = 0; };

/**
 * Sets the key value of the ItemListBox
 *
 * @public
 * @param {string|Array.<string>} sKey the key of the selected entry or a list
 * of multiple selected keys
 */
UCF_ItemListBox_ie6["prototype"]["setValues"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["setValues"]++; }; 
	/** @type {Array.<string>} */
	var aKeys;
	/** @type {boolean} */
	var bIsSelected;
	/** @type {number} */
	var i;
	/** @type {number} */
	var j;
	/** @type {Array.<UCF_ItemListBoxItem>} */
	var aItems = this["aGetItems"]();

	if (this["bIsWriteable"]() && aItems) {
		aKeys = UCF_JsUtil["bIsArray"](sKey) ? sKey : [sKey];

		for (i = 0; i < aItems["length"]; i++) {
			bIsSelected = false;
			for (j = 0; j < aKeys["length"]; j++) {
				if (aItems[i]["sKey"] === aKeys[j]) {
					bIsSelected = true;
					break;
				}
			}
			aItems[i]["select"](bIsSelected);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["setValues"] = 0; };

/**
 * Returns the key value of the ItemListBox
 * @public
 * @return {string} the value of the selected key
 */
UCF_ItemListBox_ie6["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["getValue"]++; }; 
	/** @type {Array.<string>} */
	var aSelectedKeys;

	if (UCF_JsUtil["bIsFunction"](this["aGetSelectedKeys"])) {
		aSelectedKeys = this["aGetSelectedKeys"]();

		if (aSelectedKeys["length"] > 0) {
			return aSelectedKeys[0];
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["getValue"] = 0; };

/**
 * Returns the key values of the ItemListBox
 * @public
 * @return {Array.<string>} the array of selected keys
 */
UCF_ItemListBox_ie6["prototype"]["getValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["getValues"]++; }; 
	if (UCF_JsUtil["bIsFunction"](this["aGetSelectedKeys"])) {
		return this["aGetSelectedKeys"]();
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["getValues"] = 0; };

/**
 * @public
 * @return {Array.<string>} the selected readable value(s) of the ItemListBox
 */
UCF_ItemListBox_ie6["prototype"]["getTexts"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["getTexts"]++; }; 
	/** @type {UCF_ItemListBox} */
	var self;

	if (UCF_JsUtil["bIsFunction"](this["aGetSelectedKeys"])) {
		self = this;

		return UCF_JsUtil["map"](
			this["aGetSelectedKeys"](),
			function(oItem) { return self["sGetItemValue"](oItem); }
		);
	}

	return [];
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["getTexts"] = 0; };

/**
 * Returns the selected readable value of the ItemListBox
 *
 * @public
 * @return {string} null or the first text item
 */
UCF_ItemListBox_ie6["prototype"]["getText"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["getText"]++; }; 
	/** @type {Array.<string>} */
	var aTexts = this["getTexts"]();

	return aTexts["length"] > 0 ? aTexts[0] : null;
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["getText"] = 0; };

// ----- phone overlay---------------------------------------------------------
/**
 * @see {@link UCF_ComboBox#onBeforeOpenFieldHelp()}
 * @param {boolean} bValue `true` if phone overlay should be displayed
 * otherwise `false`
 */
UCF_ItemListBox_ie6["prototype"]["setShouldDisplayOverlay"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["setShouldDisplayOverlay"]++; }; 
	// called by combobox, has no effect
};;if (__UCF_COVERAGE__) { UCF_ItemListBox_ie6["_"]["setShouldDisplayOverlay"] = 0; };


UCF_ItemListBox_ie6.prototype["aPublicMethods"] = ["setEnabled","setValue","setValues","getValue","getValues","getTexts","getText"].concat(UCF_ItemListBox_ie6.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ItemListItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ItemListItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ItemListItem["_"]["UCF_ItemListItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "ItemListItem.js(17): UCF_ItemListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ItemListItem.js(18): UCF_ItemListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ItemListItem.js(19): UCF_ItemListItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oFocusDomRef"] = this["oDomRef"];
};window["UCF_ItemListItem"] = UCF_ItemListItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemListItem"); UCF_ItemListItem["_"] = {UCF_ItemListItem: 0}; }; ;
UCF_ItemListItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ItemListItem.prototype["sClassName"] = "UCF_ItemListItem";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ItemListItem["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ItemListItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ItemListItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ItemListItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ItemListItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemListItem["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ItemListItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ItemNavigation"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_EventProvider */
/// <reference path="../../../core/EventProvider.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>

/**
 * Helper Class for all controls that need an item navigation.
 * Handles the item navigation and selection with the keyboard and
 * fires onlsitemselect and onlsbeforeitemfocus events
 * for a given oControl.
 * @class
 * 
 *
 */
function UCF_ItemNavigation() {if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["UCF_ItemNavigation"]++; }; 
	UCF_EventProvider["apply"](this);

	this["defineEvents"](['Select', 'Focus', 'Activate', 'SelectUp']);

	this["iSelectedIndex"] = 0;
	this["iFocusedIndex"] = 0;
	this["oItemContainer"] = null;

	this["bIgnoreFocus"] = false;
	this["bServerSelection"] = false;
	this["sMeansOfActivation"] = 0;
	// supports keyboard navigation looping
	// if false: if the last element is reached using [RIGHT],
	// it should not navigate to the first item
	// if true: if the last element is reached using [RIGHT],
	// it should navigate to the first item
	// with UR2213 the this.bShouldNavigateInLoop = false
	this["bShouldNavigateInLoop"] = false;
};window["UCF_ItemNavigation"] = UCF_ItemNavigation; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemNavigation"); UCF_ItemNavigation["_"] = {UCF_ItemNavigation: 0}; }; ;
UCF_ItemNavigation["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_ItemNavigation.prototype["sClassName"] = "UCF_ItemNavigation";

/**
 * Destructor
 * @private
 */
UCF_ItemNavigation["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["destroy"]++; }; 
	this["oItemContainer"] = null;
	this["aItems"] = null;
	this["iSelectedIndex"] = null;
	this["iFocusedIndex"] = null;
	this["bIgnoreFocus"] = null;
	this["bServerSelection"] = null;
	this["bShouldNavigateInLoop"] = null;
	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["destroy"] = 0; };

UCF_ItemNavigation["prototype"]["setIgnoreFocus"] = function(bIgnoreFocus) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["setIgnoreFocus"]++; }; 
	this["bIgnoreFocus"] = bIgnoreFocus;
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["setIgnoreFocus"] = 0; };

/**
 * Sets the navigate in looping status
 * if false: if the last element is reached using [RIGHT],
 * it should not navigate to the first item
 * @param {boolean} bNavigateInLoop
 */
UCF_ItemNavigation["prototype"]["setNavigateInLoop"] = function(bNavigateInLoop) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["setNavigateInLoop"]++; }; 
	this["bShouldNavigateInLoop"] = bNavigateInLoop;
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["setNavigateInLoop"] = 0; };

UCF_ItemNavigation["prototype"]["setServerSelection"] = function(bServerSelection) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["setServerSelection"]++; }; 
	this["bServerSelection"] = bServerSelection;
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["setServerSelection"] = 0; };
/**
 * Adds an item to the navigatable items array
 *
 * @private
 *
 * @param {UCF_Control} oItem the item to add
 * @param {boolean} bSelected optional marks the given oItem as the actual selected item
 */
UCF_ItemNavigation["prototype"]["addItem"] = function(oItem, bSelected) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["addItem"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_Control, "oItem instanceof UCF_Control", "ItemNavigation.js(93): addItem"); };

	if (!this["aItems"]) {
		this["aItems"] = [];
	}

	this["aItems"]["push"](oItem);

	if (!oItem["oFocusDomRef"]) {
		oItem["oFocusDomRef"] = oItem["oDomRef"];
	}

	if (bSelected) {
		this["iSelectedIndex"] = this["aItems"]["length"] - 1;
		this["iFocusedIndex"] = this["aItems"]["length"] - 1;
	}
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["addItem"] = 0; };

UCF_ItemNavigation["prototype"]["bHasItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["bHasItems"]++; }; 
	return this["aItems"] && this["aItems"]["length"] > 0;
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["bHasItems"] = 0; };

UCF_ItemNavigation["prototype"]["bIsFirstFocused"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["bIsFirstFocused"]++; }; 
	return this["iFocusedIndex"] === 0;
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["bIsFirstFocused"] = 0; };

UCF_ItemNavigation["prototype"]["bIsLastFocused"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["bIsLastFocused"]++; }; 
	return this["aItems"] && this["iFocusedIndex"] === (this["aItems"]["length"] - 1);
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["bIsLastFocused"] = 0; };

UCF_ItemNavigation["prototype"]["updateSelectedIndex"] = function(iSelected) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["updateSelectedIndex"]++; }; 

	for (var i; i = 0; i++) {

		if (this["aItems"][i]["iIndex"] === iSelected) {
			this["iSelectedIndex"] = i;
			break;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["updateSelectedIndex"] = 0; };

/**
 * Checks if an event occurred inside the oItemContainer
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * the browser event object that occurred
 * @return {boolean}
 * @private
 */
UCF_ItemNavigation["prototype"]["bOccuredInItemContainer"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["bOccuredInItemContainer"]++; }; 
	var oSource;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ItemNavigation.js(145): bOccuredInItemContainer"); };

	oSource = oBrowserEvent["oGetSourceControl"]();

	return UCF_JsUtil["contains"](this["aItems"], oSource);
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["bOccuredInItemContainer"] = 0; };

/**
 * Focus the next item
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ItemNavigation["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsnext"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ItemNavigation.js(160): onlsnext"); };

	if (!this["bOccuredInItemContainer"](oBrowserEvent)) {
		return;
	}
	if (!this["aItems"] || !this["aItems"]["length"] || this["aItems"]["length"] === 0) {
		return;
	}

	if (this["iFocusedIndex"] < this["aItems"]["length"] - 1) {
		this["focusItemByIndex"](this["iFocusedIndex"] + 1);
	} else {
		if (this["bShouldNavigateInLoop"])
			this["onlshome"](oBrowserEvent);
	}
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsnext"] = 0; };

/**
 * Focus the previous item
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ItemNavigation["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsprevious"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ItemNavigation.js(186): onlsprevious"); };

	if (!this["bOccuredInItemContainer"](oBrowserEvent)) {
		return;
	}

	if (!this["aItems"] || !this["aItems"]["length"] || this["aItems"]["length"] === 0) {
		return;
	}

	if (this["iFocusedIndex"] > 0) {
		this["focusItemByIndex"](this["iFocusedIndex"] - 1);
	} else {
		if (this["bShouldNavigateInLoop"])
			this["onlsend"](oBrowserEvent);
	}
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsprevious"] = 0; };

/**
 * Focus the first item
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ItemNavigation["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlshome"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ItemNavigation.js(213): onlshome"); };

	if (!this["bOccuredInItemContainer"](oBrowserEvent)) {
		return;
	}

	if (!this["aItems"] || !this["aItems"]["length"] || this["aItems"]["length"] === 0) {
		return;
	}

	this["focusItemByIndex"](0);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlshome"] = 0; };

/**
 * Focus the last item
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ItemNavigation["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsend"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ItemNavigation.js(235): onlsend"); };

	if (!this["bOccuredInItemContainer"](oBrowserEvent)) {
		return;
	}

	if (!this["aItems"] || !this["aItems"]["length"] || this["aItems"]["length"] === 0) {
		return;
	}

	this["focusItemByIndex"](this["aItems"]["length"] - 1);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsend"] = 0; };

/**
 * Focus the first item
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ItemNavigation["prototype"]["onlstop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlstop"]++; }; 

	if (!this["aItems"] || !this["aItems"]["length"] || this["aItems"]["length"] === 0) {
		return;
	}

	this["onlshome"](oBrowserEvent);
	//oBrowserEvent.cancel();
	/* 1870470255, Ctrl+Pos1 and Ctrl-End not working anymore in editor
	Editable elements that are directly put in the content area of a tabstrip,
	without surrounding layout, do not receive their event back
	Check with LSX: tabstrip > KeyboardEvents
	*/
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlstop"] = 0; };

/**
 * Focus the last item
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ItemNavigation["prototype"]["onlsbottom"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsbottom"]++; }; 
	if (!this["aItems"] || !this["aItems"]["length"] || this["aItems"]["length"] === 0) {
		return;
	}
	//this.onlsend(oBrowserEvent);
	//oBrowserEvent.cancel();
	/* 1870470255, Ctrl+Pos1 and Ctrl-End not working anymore in editor
	Editable elements that are directly put in the content area of a tabstrip,
	without surrounding layout, do not receive their event back
	Check with LSX: tabstrip > KeyboardEvents
	*/
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsbottom"] = 0; };

/**
 * Set the focus to the item defined by the given index
 *
 * @param {int} iNewIndex
 */
UCF_ItemNavigation["prototype"]["focusItemByIndex"] = function(iNewIndex) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["focusItemByIndex"]++; }; 

	if (!this["bHasItems"]() || this["bIgnoreFocus"]) return;

	this["setFocusedIndex"](iNewIndex);

	// fire focus item event on the control
	this["fireEvent"](this["E_EVENTS"]["Focus"], {
		"oItem": this["aItems"][this["iFocusedIndex"]]
	});
	if (window["UCF_System"]["bIs508"]) {
		// due to JAWs bug a delayed call is necessary
		this["aItems"][this["iFocusedIndex"]]["moveFocus"]();
	} else {
		this["aItems"][this["iFocusedIndex"]]["focus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["focusItemByIndex"] = 0; };

/**
 * Sets the focused index to iIndex, adds the tab index and removes
 * the tabindex from the currently focused item
 *
 * @param {int} iIndex The 0-based index of the focused item
 */
UCF_ItemNavigation["prototype"]["setFocusedIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["setFocusedIndex"]++; }; 
	var oFocusDomRef;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iIndex) === 'number', "typeof(iIndex) === 'number'", "ItemNavigation.js(321): setFocusedIndex"); };

	if (!this["bHasItems"]()) {
		return;
	}
	if (iIndex > this["aItems"]["length"] - 1) {
		iIndex = 0;
	}
	if (iIndex < 0) {
		iIndex = this["aItems"]["length"] - 1;
	}

	// remove the old tabstop
	if (this["iFocusedIndex"] !== null && this["iFocusedIndex"] !== undefined) {
		oFocusDomRef = this["aItems"][this["iFocusedIndex"]]["oFocusDomRef"];
	}
	if (oFocusDomRef) {
		UCF_DomUtil["resetTabIndex"](oFocusDomRef);
	}
	// set the new index
	this["iFocusedIndex"] = iIndex;

	// add the next tabstop
	oFocusDomRef = this["aItems"][this["iFocusedIndex"]]["oFocusDomRef"];
	if (oFocusDomRef) {
		UCF_DomUtil["setTabIndex"](oFocusDomRef, 0);
	}
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["setFocusedIndex"] = 0; };

/**
 * Set the focus to the given item
 *
 * @param {UCF_Control} oItem
 */
UCF_ItemNavigation["prototype"]["focusItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["focusItem"]++; }; 
	var i;

	if (!this["bHasItems"]()) {
		return;
	}

	for (i = 0; i < this["aItems"]["length"]; i++) {
		if (this["aItems"][i] === oItem) {
			this["focusItemByIndex"](i);

			return;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["focusItem"] = 0; };

/**
 * Orchestrates the tabIndex.
 * Is necessary for access keys
 *
 * @param {UCF_Control} oBrowserEvent
 */
UCF_ItemNavigation["prototype"]["onfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onfocus"]++; }; 
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsEdgeHtml"]()) {
		return;
	}
	this["activateHandler"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onfocus"] = 0; };

UCF_ItemNavigation["prototype"]["onactivate"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onactivate"]++; }; 
	this["activateHandler"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onactivate"] = 0; };

UCF_ItemNavigation["prototype"]["activateHandler"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["activateHandler"]++; }; 
	var oItem = oBrowserEvent["oSourceControl"],
		iIndex;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ItemNavigation.js(392): activateHandler"); };

	if (!this["bHasItems"]() ||
		!this["bOccuredInItemContainer"](oBrowserEvent) ||
		this["bIgnoreFocus"]) {
		return;
	}

	if (oItem && oItem["bEnabled"]) {
		iIndex = this["iIndexOf"](oItem["oFocusDomRef"]);
		this["setFocusedIndex"](iIndex);
		this["fireEvent"](this["E_EVENTS"]["Activate"], { "oItem": oItem, "oBrowserEvent": oBrowserEvent });
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["activateHandler"] = 0; };

/**
 * Handles the click event end and fires a Select event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ItemNavigation["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ItemNavigation.js(418): onclick"); };
	var oItem = oBrowserEvent["oGetSourceControl"]();
	if (!oItem || (oItem && !oItem["bEnabled"])) return;

	this["onlsselect"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onclick"] = 0; };

UCF_ItemNavigation["prototype"]["onlsselectup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsselectup"]++; }; 
	this["onlsselect"](oBrowserEvent, true);
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsselectup"] = 0; };

/**
 * Handles the select event end and fires a Select event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @param { boolean} [bUp]
 * @private
 */
UCF_ItemNavigation["prototype"]["onlsselect"] = function(oBrowserEvent, bUp) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsselect"]++; }; 
	var oSource, oItem, i;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ItemNavigation.js(439): onlsselect"); };

	if (!this["bHasItems"]() ||
		!this["bOccuredInItemContainer"](oBrowserEvent)) {
		return;
	}

	oSource = oBrowserEvent["oGetSource"]();

	// in this case a click is fired and this is pipelined
	if (oSource["tagName"] === 'A'
		&& oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["ENTER"]) {
		return;
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	oItem = oBrowserEvent["oGetSourceControl"]();

	// check if it is a valid item

	for (i = 0; i < this["aItems"]["length"]; i++) {
		if (this["aItems"][i] === oItem) {
			this["iSelectedIndex"] = i;

			if (!UCF_UserAgent["bIsIE"]() && !this["bServerSelection"]) {
				this["setFocusedIndex"](i);
			}

			this["fireEvent"](bUp ? this["E_EVENTS"]["SelectUp"] : this["E_EVENTS"]["Select"], { "oItem": oItem, "oBrowserEvent": oBrowserEvent });
			break;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["onlsselect"] = 0; };

/**
 * Compares a given DomRef with the FocusDomRefs of all items
 * and returns the index of it if found
 * otherwise -1
 *
 * @param {element} oDomRef the dom reference
 * @return {integer} index of the item or -1
 */
UCF_ItemNavigation["prototype"]["iIndexOf"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["iIndexOf"]++; }; 
	var i;

	if (!this["bHasItems"]() && !oDomRef) {
		return -1;
	}

	for (i = 0; i < this["aItems"]["length"]; i++) {
		if (oDomRef === this["aItems"][i]["oFocusDomRef"]) {

			return i;
		}
	}

	return -1;
};;if (__UCF_COVERAGE__) { UCF_ItemNavigation["_"]["iIndexOf"] = 0; };

};
sap["ls"]["preload"]["UCF_ItemScrollingDelegate"] = function() {/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_EventProvider */
/// <reference path="../../../core/EventProvider.js"/>
/* global _assert, _trace, _measure, DEBUG, ERROR, START, STOP */
/// <reference path="../../../core/debug/Tracer.js"/>

/**
 * @class
 */
function UCF_ItemScrollingDelegate() {if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["UCF_ItemScrollingDelegate"]++; }; 

	UCF_EventProvider["apply"](this);

	this["defineEvents"](['ItemsScrolled']);

	/** @type {Array} all items /
	this.aItems = null;
	/** @type {int} selected item*/
	this["iSelected"] = null;
	/** @type {HTML_Element} the view port container */
	this["oViewPort"] = null;
	/** @type {Object} all buttons that trigger scrollingl*/
	this["aActionItems"] = null;
	/** @type {int} the scroll position */
	this["iScrollPosition"] = null;
	/** @type {int} sometimes items have a default offset top*/
	this["iThreshold"] = null;
	/** @type {int} set the FirstVisibleOnMainLevel or FirstVisibleOnSubLevel on initialize*/
	this["iFirstVisibleItem"] = -1;

};window["UCF_ItemScrollingDelegate"] = UCF_ItemScrollingDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ItemScrollingDelegate"); UCF_ItemScrollingDelegate["_"] = {UCF_ItemScrollingDelegate: 0}; }; ;
UCF_ItemScrollingDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_ItemScrollingDelegate.prototype["sClassName"] = "UCF_ItemScrollingDelegate";

/**
 * @private
 * @final
 */
UCF_ItemScrollingDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["destroy"]++; }; 
	this["aItems"] = null;
	this["iSelected"] = null;
	this["oViewPort"] = null;
	this["aActionItems"] = null;
	this["iScrollPosition"] = null;
	this["setConnectedControlId"] = null;
	this["iThreshold"] = null;
	this["iFirstVisibleItem"] = null;
	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["destroy"] = 0; };

UCF_ItemScrollingDelegate["prototype"]["oGetActionItemStates"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["oGetActionItemStates"]++; }; 
	/** @type {UCF_ItemScrollingDelegate} */
	var self = this;

	return {
		'bScrollToPrevious': self["bFirstHidden"](),
		'bScrollToNext': self["bLastHidden"]()
	};
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["oGetActionItemStates"] = 0; };

/**
 * @private
 */
UCF_ItemScrollingDelegate["prototype"]["fireIemsScrolled"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["fireIemsScrolled"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["ItemsScrolled"]);
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["fireIemsScrolled"] = 0; };

/**
 * An enumerations with all actions that can be triggered on click
 * @private
 */
UCF_ItemScrollingDelegate["prototype"]["eAction"] = {
	"SCROLL_TO_PREVIOUS": 'SCROLL_TO_PREVIOUS',
	"SCROLL_TO_NEXT": 'SCROLL_TO_NEXT'
};

/**
 * @private
 * @param {Array} aItems
 */
UCF_ItemScrollingDelegate["prototype"]["addItems"] = function(aItems) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["addItems"]++; }; 
	if (aItems && aItems["length"] > 0) {
		this["aItems"] = aItems;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No items found', "ItemScrollingDelegate.js(87): addItems"); };
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["addItems"] = 0; };

/**
 * @private
 * @param {HTML_Element} oViewPort
 */
UCF_ItemScrollingDelegate["prototype"]["addViewPort"] = function(oViewPort) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["addViewPort"]++; }; 
	if (oViewPort) {
		this["oViewPort"] = oViewPort;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No viewport found', "ItemScrollingDelegate.js(99): addViewPort"); };
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["addViewPort"] = 0; };

/**
 * @private
 * @param {int} iSelected
 */
UCF_ItemScrollingDelegate["prototype"]["setSelectedIndex"] = function(iSelected) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["setSelectedIndex"]++; }; 
	if (typeof iSelected === 'number') {
		this["iSelected"] = iSelected;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No main-item index found', "ItemScrollingDelegate.js(111): setSelectedIndex"); };
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["setSelectedIndex"] = 0; };

/**
 * @private
 * @param { int } iFirstVisible
 */
UCF_ItemScrollingDelegate["prototype"]["setFirstVisibleItem"] = function(iFirstVisible) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["setFirstVisibleItem"]++; }; 
	if (typeof iFirstVisible === 'number') {
		this["iFirstVisibleItem"] = iFirstVisible;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No main-item index found', "ItemScrollingDelegate.js(123): setFirstVisibleItem"); };
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["setFirstVisibleItem"] = 0; };

/**
 * @private
 * @param {Array} aItems
 */
UCF_ItemScrollingDelegate["prototype"]["addActionItems"] = function(aItems) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["addActionItems"]++; }; 

	if (aItems) {
		this["aActionItems"] = aItems;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Cannot determine action items', "ItemScrollingDelegate.js(136): addActionItems"); };
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["addActionItems"] = 0; };

/**
 * @private
 * @return {Array}
 */
UCF_ItemScrollingDelegate["prototype"]["aGetActionItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["aGetActionItems"]++; }; 
	return this["aActionItems"];
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["aGetActionItems"] = 0; };

UCF_ItemScrollingDelegate["prototype"]["bDelegatedCorrectly"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["bDelegatedCorrectly"]++; }; 
	/** @type {HTML_Element} */
	var oSource;
	/** @type {Array} */
	var aActionItems = this["aGetActionItems"]();
	/** @type {string} */
	var sId;
	/** @type {int} */
	var i;

	if (oBrowserEvent && oBrowserEvent["oSource"] && aActionItems) {
		oSource = oBrowserEvent["oSource"];
		if (oSource && oSource["getAttribute"]('id')) {
			sId = oSource["getAttribute"]('id');
			for (i = 0; i < aActionItems["length"]; i++) {
				if (aActionItems[i] === sId) {
					return true;
				}
			}
			return false;
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Cannot determine delegate of event', "ItemScrollingDelegate.js(169): bDelegatedCorrectly"); };
			return false;
		}
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Cannot determine delegate of event', "ItemScrollingDelegate.js(173): bDelegatedCorrectly"); };
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["bDelegatedCorrectly"] = 0; };

/**
 * @private
 */
UCF_ItemScrollingDelegate["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["initialize"]++; }; 
	/** @type {UCF_Control} */
	var oSelected;
	/** @type {boolean} */
	var bFireScroll = false;

	if (this["aItems"]) {
		oSelected = this["iFirstVisibleItem"] !== -1 ? this["aItems"][this["iFirstVisibleItem"]] : this["aItems"][this["iSelected"]];
		this["iThreshold"] = this["aItems"][0]["oDomRef"]["offsetTop"];
		this["iScrollPosition"] = this["iThreshold"];

		if (oSelected && oSelected["oDomRef"]["offsetTop"] !== this["iThreshold"]) {
			this["iScrollPosition"] = oSelected["oDomRef"]["offsetTop"];
			this["scrollItemIntoViewPort"](oSelected);
			bFireScroll = true;
		}
	}

	if (bFireScroll === false && this["bLastHidden"]()) {
		bFireScroll = true;
	}

	bFireScroll = bFireScroll;

	if (bFireScroll) {
		this["fireIemsScrolled"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["initialize"] = 0; };

/**
 * @private
 * @param {UCF_Control} oItem
 */
UCF_ItemScrollingDelegate["prototype"]["scrollItemIntoViewPort"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["scrollItemIntoViewPort"]++; }; 
	this["iScrollPosition"] = oItem["oDomRef"]["offsetTop"] - this["iThreshold"];
	this["oViewPort"]["scrollTop"] = this["iScrollPosition"];
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["scrollItemIntoViewPort"] = 0; };

/**
 * @private
 * @return {Array}
 */
UCF_ItemScrollingDelegate["prototype"]["oGetSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["oGetSelected"]++; }; 
	/** @type {Array} */
	var aItems = this["aItems"];

	if (aItems &&
		typeof this["iSelected"] === 'number' &&
		this["iSelected"] > -1) {

		return aItems[this["iSelected"]];
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["oGetSelected"] = 0; };

/**
 * Generic paging function
 * @private
 * @return {boolean}
 */
//eslint-disable-next-line
UCF_ItemScrollingDelegate["prototype"]["bFirstHidden"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["bFirstHidden"]++; }; 
	/** @type {HCNP_Item} */
	var oItem;
	/** @type {Array} */
	var aItems = this["aItems"];

	if (aItems && aItems["length"] && aItems["length"] > 0) {
		oItem = aItems[0];
		return this["bIsInViewPort"](oItem) === false;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No items available', "ItemScrollingDelegate.js(253): bFirstHidden"); };
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["bFirstHidden"] = 0; };

/**
 * Generic paging function
 * @private
 * @return {boolean}
 */
//eslint-disable-next-line
UCF_ItemScrollingDelegate["prototype"]["bLastHidden"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["bLastHidden"]++; }; 
	/** @type {HCNP_Item} */
	var oItem;
	/** @type {Array} */
	var aItems = this["aItems"];

	if (aItems && aItems["length"] && aItems["length"] > 0) {
		oItem = aItems[aItems["length"] - 1];
		return this["bIsInViewPort"](oItem) === false;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No items available', "ItemScrollingDelegate.js(273): bLastHidden"); };
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["bLastHidden"] = 0; };

/**
 * Generic the index of the current first visible
 * @private
 * @return {UCF_HorizontalContextualPanelItem_standards}
 */
//eslint-disable-next-line
UCF_ItemScrollingDelegate["prototype"]["iGetFirstVisibleInViewPort"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["iGetFirstVisibleInViewPort"]++; }; 

	/** @type {HTML_Element} */
	var aFirstItem;
	aFirstItem = this["oGetFirstItemInViewPort"]();

	return aFirstItem ? aFirstItem["iIndex"] : 0;

};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["iGetFirstVisibleInViewPort"] = 0; };

/**
 * Generic paging function
 * @private
 * @return {UCF_HorizontalContextualPanelItem_standards}
 */
//eslint-disable-next-line
UCF_ItemScrollingDelegate["prototype"]["oGetFirstItemInViewPort"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["oGetFirstItemInViewPort"]++; }; 
	/** @type {Array} */
	var aItems = this["aItems"];
	/** @type {int} */
	var i;

	if (aItems) {
		for (i = 0; i < aItems["length"]; i++) {
			if (this["bIsInViewPort"](aItems[i])) {
				return aItems[i];
			}
		}
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No items found', "ItemScrollingDelegate.js(312): oGetFirstItemInViewPort"); };
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["oGetFirstItemInViewPort"] = 0; };

/**
 * Generic paging function
 * @private
 * @return {UCF_HorizontalContextualPanelItem_standards}
 */
//eslint-disable-next-line
UCF_ItemScrollingDelegate["prototype"]["oGetLastItemInViewPort"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["oGetLastItemInViewPort"]++; }; 
	/** @type {Array} */
	var aItems = this["aItems"];
	/** @type {int} */
	var i;

	if (aItems) {

		for (i = aItems["length"] - 1; i >= 0; i--) {
			if (this["bIsInViewPort"](aItems[i])) {
				return aItems[i];
			}
		}
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No items found', "ItemScrollingDelegate.js(337): oGetLastItemInViewPort"); };
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["oGetLastItemInViewPort"] = 0; };

/**
 * Generic paging function
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ItemScrollingDelegate["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onclick"]++; }; 
	/** @type {HTML_Element} the scroll button*/
	var oSource = oBrowserEvent["oSource"];
	/** @type {string} */
	var sAction = oSource["getAttribute"]('action');
	/** @type {enum-list} */
	var eAction;

	if (sAction && this["bDelegatedCorrectly"](oBrowserEvent)) {

		eAction = this["eAction"];

		switch (sAction) {
			case eAction["SCROLL_TO_PREVIOUS"]:
				this["scrollToPreviousItems"]();
				break;
			case eAction["SCROLL_TO_NEXT"]:
				this["scrollToNextItems"]();
		}
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onclick"] = 0; };

/**
 * Generic paging function
 * @private
 */
UCF_ItemScrollingDelegate["prototype"]["scrollToPreviousItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["scrollToPreviousItems"]++; }; 
	/** @type {UCF_Control} */
	var oFirstInViewPort = this["oGetFirstItemInViewPort"]();
	/** @type {UCF_Control} */
	var oItemToScrollTo;
	/** @type {int} */
	var iIndex;

	if (oFirstInViewPort) {
		iIndex = oFirstInViewPort["iIndex"] - 1;

		if (iIndex < 0) {
			iIndex = this["aItems"]["length"] - 1;
		}

		oItemToScrollTo = this["aItems"][iIndex];

		if (!this["bIsInViewPort"](oItemToScrollTo)) {
			this["scrollItemIntoViewPort"](oItemToScrollTo);
			this["fireIemsScrolled"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["scrollToPreviousItems"] = 0; };

/**
 * Generic paging function
 * @private
 */
UCF_ItemScrollingDelegate["prototype"]["scrollToNextItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["scrollToNextItems"]++; }; 
	/** @type {UCF_Control} */
	var oLastInViewPort = this["oGetLastItemInViewPort"]();
	/** @type {UCF_Control} */
	var oItemToScrollTo;
	/** @type {int} */
	var iIndex;
	/** @type {Array} */
	var aItems = this["aItems"];
	/** @type {int} */
	var iItemSum = aItems["length"] - 1;

	if (oLastInViewPort) {
		iIndex = oLastInViewPort["iIndex"] + 1;

		if (iIndex > iItemSum) {
			iIndex = 0;
		}

		oItemToScrollTo = aItems[iIndex];

		if (!this["bIsInViewPort"](oItemToScrollTo)) {
			this["scrollItemIntoViewPort"](oItemToScrollTo);
			this["fireIemsScrolled"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["scrollToNextItems"] = 0; };

/**
 * Generic paging function
 * @private
 * @param {UCF_HorizontalContextualPanelItem_standards} oItem
 * @return {boolean}
 */
UCF_ItemScrollingDelegate["prototype"]["bIsInViewPort"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["bIsInViewPort"]++; }; 
	/** @type {int} */
	var iScrollPosition = this["iScrollPosition"];
	/** @type {int} */
	var iThreshold = iScrollPosition + this["iThreshold"];
	/** @type {int} */
	var iPosition = oItem["oDomRef"]["offsetTop"];

	return (iPosition >= iScrollPosition &&
		iPosition <= iThreshold);
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["bIsInViewPort"] = 0; };

/**
 * Generic paging function
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ItemScrollingDelegate["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlshome"]++; }; 
	/** @type {UCF_Control} */
	var oSourceControl = oBrowserEvent["oSourceControl"];
	/** @type {Array} */
	var aItems = this["aItems"];
	/** @type {UCF_Control} */
	var oItemToScrollTo = aItems[0];

	if (oSourceControl !== oItemToScrollTo) {
		this["scrollItemIntoViewPort"](oItemToScrollTo);
		this["fireIemsScrolled"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlshome"] = 0; };

/**
 * Generic paging function
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_ItemScrollingDelegate["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlsend"]++; }; 
	/** @type {UCF_Control} */
	var oSourceControl = oBrowserEvent["oSourceControl"];
	/** @type {Array} */
	var aItems = this["aItems"];
	/** @type {int} */
	var iLast = this["aItems"]["length"] - 1;
	/** @type {UCF_Control} */
	var oItemToScrollTo = aItems[iLast];

	if (oItemToScrollTo !== oSourceControl) {
		this["scrollItemIntoViewPort"](oItemToScrollTo);
		this["fireIemsScrolled"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlsend"] = 0; };

/**
 * Generic paging function
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_ItemScrollingDelegate["prototype"]["onlstop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlstop"]++; }; 
	this["onlsprevious"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlstop"] = 0; };

/**
 * Generic paging function
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_ItemScrollingDelegate["prototype"]["onlsbottom"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlsbottom"]++; }; 
	this["onlsnext"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlsbottom"] = 0; };

/**
 * Generic paging function
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_ItemScrollingDelegate["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlsnext"]++; }; 
	/** @type {UCF_Control} */
	var oSourceControl = oBrowserEvent["oSourceControl"];
	/** @type {UCF_Control} */
	var oLast = this["oGetLastItemInViewPort"]();
	/** @type {int} */
	var iLast = this["aItems"]["length"] - 1;

	if (oSourceControl && oLast && oSourceControl["iIndex"] === oLast["iIndex"] && oLast["iIndex"] < iLast) {
		this["scrollToNextItems"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlsnext"] = 0; };

/**
 * Generic paging function
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_ItemScrollingDelegate["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlsprevious"]++; }; 
	/** @type {UCF_Control} */
	var oSourceControl = oBrowserEvent["oSourceControl"];
	/** @type {UCF_Control} */
	var oFirst = this["oGetFirstItemInViewPort"]();

	if (oSourceControl && oFirst && oSourceControl["iIndex"] === oFirst["iIndex"] && oFirst["iIndex"] > 0) {
		this["scrollToPreviousItems"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onlsprevious"] = 0; };

/**
 * Generic paging function
 * @private
 */
UCF_ItemScrollingDelegate["prototype"]["onItemsResized"] = function() {;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onItemsResized"]++; }; 
	/** @type {UCF_Control} */
	var oSelected = this["oGetSelected"]();

	if (oSelected && !this["bIsInViewPort"](oSelected)) {
		this["scrollItemIntoViewPort"](oSelected);
	}

	this["fireIemsScrolled"]();
};;if (__UCF_COVERAGE__) { UCF_ItemScrollingDelegate["_"]["onItemsResized"] = 0; };

};
sap["ls"]["preload"]["UCF_JSONGridBinding"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_GridBinding */
/// <reference path="../GridBinding.js"/>

/**
 * @typedef {Object} UCF_JSONGridBinding_Range
 * @property {number} iStartX
 * @property {number} iStartY
 * @property {number} iEndX
 * @property {number} iEndY
 */
/**
 * @typedef {Object} UCF_JSONGridBinding_Grid
 */
/**
 * @typedef {Object} UCF_JSONGridBinding_Selection
 * @property {UCF_JSONGridBinding_Range} range
 * @property {string} path
 * @property {string} [coords]
 * @property {0|1|2} state
 */

/**
 * List binding implementation for JSON format
 *
 * @class
 * @param {UCF_Model} oModel
 * @param {string} sPath
 * @param {UCF_BindingContext} oContext
 * @param {UCF_ListBinding_Sorter} oSorter
 * @param {Array} aFilters
 * @param {Object} mParameters
 */
function UCF_JSONGridBinding(oModel, sPath, oContext, oSorter, aFilters, mParameters) {if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["UCF_JSONGridBinding"]++; }; 
	UCF_GridBinding["apply"](this, arguments);
	/** @type {UCF_JSONGridBinding_Range} */
	this["oCurrentRange"] = this["setCurrentRange"](0, 0, 0, 0);
	/** @type {number} */
	this["iMaxX"] = -1;
	/** @type {number} */
	this["iMaxY"] = -1;
	/** @type {UCF_JSONGridBinding_Range[]} */
	this["aRanges"] = [];
	/** @type {string} */
	this["sClassName"] = 'UCF_JSONGridBinding';
	/** @type {UCF_JSONGridBinding_Grid} */
	this["oGrid"] = null;

	this["update"]();

	/** @type {UCF_JSONGridBinding_Selection[]} */
	this["aSelections"] = null;
	/** @type {UCF_JSONGridBinding_Selection} */
	this["oPrimarySelection"] = null;
	/** @type {boolean} */
	this["bManageRange"] = mParameters && ('managerange' in mParameters) && mParameters["managerange"];
};window["UCF_JSONGridBinding"] = UCF_JSONGridBinding; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_JSONGridBinding"); UCF_JSONGridBinding["_"] = {UCF_JSONGridBinding: 0}; }; ;
UCF_JSONGridBinding["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_GridBinding"))(); UCF_JSONGridBinding.prototype["sClassName"] = "UCF_JSONGridBinding";

UCF_JSONGridBinding["mRequestedRangesMatrix"] = {};

/** @override */
UCF_JSONGridBinding["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["destroy"]++; }; 
	this["oCurrentRange"] = null;
	this["iMaxX"] = null;
	this["iMaxY"] = null;
	this["oGrid"] = null;
	this["oPrimarySelection"] = null;
	this["bManageRange"] = null;
	this["aCurrentContexts"] = null;
	this["iLength"] = null;
	this["aIndices"] = null;
	this["oSelection"] = null;

	UCF_GridBinding.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["destroy"] = 0; };

/**
 * Checks whether all data for a given range is available in the model.
 *
 * @return {boolean}
 */
UCF_JSONGridBinding["prototype"]["dataAvailable"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["dataAvailable"]++; }; 
	/** @type {UCF_JSONGridBinding_Range} */
	var oCurrentRange = this["getCurrentRange"]();
	/** @type {string} */
	var sPrefix = this["oModel"]["resolve"](this["sPath"], this["oContext"]) + '/';
	/** @type {number} */
	var i;
	/** @type {number} */
	var j;
	/** @type {string} */
	var sKey;
	/** @type {UCF_BindingContext} */
	var oContext;
	/** @type {Object} */
	var oObject;

	for (i = oCurrentRange["iStartX"]; i < oCurrentRange["iEndX"]; i++) {
		for (j = oCurrentRange["iStartY"]; j < oCurrentRange["iEndY"]; j++) {
			sKey = i + '-' + j;
			oContext = this["oModel"]["getContext"](sPrefix + sKey, true);

			if (!oContext) {
				if (!this["dataRequested"]()) {
					return false;
				}
			}
			if (oContext) {
				oObject = oContext["getObject"]();
				if (oObject === null || typeof(oObject) === 'undefined') {
					return false;
				}
			}
		}
	}

	return true;
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["dataAvailable"] = 0; };

/** @param {boolean} bManage */
UCF_JSONGridBinding["prototype"]["setManageRanges"] = function(bManage) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["setManageRanges"]++; }; 
	this["bManageRange"] = bManage;
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["setManageRanges"] = 0; };

/**
 * Return contexts for the grid or a specified subset of contexts
 *
 * @param {UCF_JSONGridBinding_Range} oRange
 * @return {Array} the contexts array
 * @protected
 */
UCF_JSONGridBinding["prototype"]["getContexts"] = function(oRange) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getContexts"]++; }; 
	/** @type {UCF_JSONGridBinding_Range} */
	var oCurrentRange;
	/** @type {number} */
	var iStartX;
	/** @type {number} */
	var iStartY;
	/** @type {number} */
	var iEndX;
	/** @type {number} */
	var iEndY;
	/** @type {UCF_BindingContext} */
	var oContext;
	/** @type {UCF_BindingContext[]} */
	var aContexts;
	/** @type {string} */
	var sPrefix;
	/** @type {number} */
	var x;
	/** @type {number} */
	var y;
	/** @type {string} */
	var sKey;
	/** @type {UCF_BindingContext} */
	var oLocalContext;

	if (!oRange) {
		return null;
	}

	oCurrentRange = this["getCurrentRange"]();
	iStartX = oRange["iStartX"] || 0;
	iStartY = oRange["iStartY"] || 0;
	iEndX = oRange["iEndX"];
	iEndY = oRange["iEndY"];

	if (!iEndX && this["iMaxX"] > -1) {
		iEndX = Math["min"](iStartX + 20, this["iMaxX"]);
	}
	if (!iEndY && this["iMaxY"] > -1) {
		iEndY = Math["min"](iStartY + 20, this["iMaxY"]);
	}

	if (oCurrentRange && this["aCurrentContexts"]) {
		//check whether the range and deliver the old context if not.
		if (oCurrentRange["iStartX"] === iStartX &&
			oCurrentRange["iStartY"] === iStartY &&
			oCurrentRange["iEndX"] === iEndX &&
			oCurrentRange["iEndY"] === iEndY) {

			return this["aCurrentContexts"];
		}
	}
	this["setCurrentRange"](iStartX, iStartY, iEndX, iEndY);

	if (this["bManageRange"]) {
		if (!this["dataRequested"]()) {
			this["requestCurrentRange"]();
		}
	}

	aContexts = [];
	sPrefix = this["oModel"]["resolve"](this["sPath"], this["oContext"]) + '/';

	for (x = iStartX; x <= iEndX; x++) {
		for (y = iStartY; y <= iEndY; y++) {
			sKey = x + '-' + y;
			oLocalContext = this["oModel"]["getContext"](sPrefix + sKey, true);

			oContext = this["oModel"]["getContext"](sPrefix + sKey);

			if (oContext) {
				oContext["setDataValidity"](
					this["hasValidData"](x, y) || !this["aCurrentContexts"]
				);
				oContext["setBindingParameter"]({
					"key": x + '-' + y,
					"x": x,
					"y": y,
					"templated": oLocalContext !== oContext
				});
				//_trace(INFO,'Context delivered for '+ x + '-' + y );
				aContexts["push"](oContext);
			}
		}
	}
	this["setMissingRangeLoaded"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Context delivered for ' + (iEndX - iStartX + 1) + ' cols and ' + (iEndY - iStartY + 1) + ' rows.', "JSONGridBinding.js(223): getContexts"); };
	this["aCurrentContexts"] = aContexts;

	return aContexts;
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getContexts"] = 0; };

/**
 * Setter for context
 *
 * @param {UCF_BindingContext} oContext the new context object
 */
UCF_JSONGridBinding["prototype"]["setContext"] = function(oContext) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["setContext"]++; }; 
	if (this["oContext"] !== oContext) {
		this["oContext"] = oContext;
		this["update"]();
		this["_fireChange"]();
	}
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["setContext"] = 0; };

/**
 * Update the list, indices array and apply sorting and filtering
 * @private
 */
UCF_JSONGridBinding["prototype"]["update"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["update"]++; }; 
	/** @type {UCF_JSONGridBinding_Grid} */
	var oGrid = this["oModel"]["_getObject"](this["sPath"], this["oContext"]);

	if (oGrid) {
		this["oGrid"] = oGrid;
		this["applyFilter"]();
		this["applySort"]();
	} else {
		this["oGrid"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["update"] = 0; };

/**
 * Checks all created ranges for delivery of data and
 * returns true if data is found
 *
 * @return {boolean} has changed
 */
UCF_JSONGridBinding["prototype"]["currentRangeChanged"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["currentRangeChanged"]++; }; 
	/** @type {string} */
	var sPrefix = this["oModel"]["resolve"](this["sPath"], this["oContext"]) + '/';
	/** @type {boolean} */
	var bChanged = false;
	/** @type {number} */
	var i;
	/** @type {string} */
	var sKey;
	/** @type {UCF_BindingContext} */
	var oContext;
	/** @type {Object} */
	var oObject;

	if (!this["aCurrentContexts"]) {
		return true;
	}

	for (i = 0; i < this["aCurrentContexts"]["length"]; i++) {
		sKey = this["aCurrentContexts"][i]["getBindingParameter"]()["key"];
		oContext = this["oModel"]["getContext"](sPrefix + sKey);
		oObject = oContext["getObject"]();

		if (this["aCurrentContexts"][i]["getObject"]() !== oObject) {
			bChanged = true;
			break;
		}
	}

	return bChanged;
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["currentRangeChanged"] = 0; };

/**
 * Check whether this Binding would provide new values and in case it changed,
 * inform interested parties about this.
 *
 * @param {boolean} bForceUpdate
 */
UCF_JSONGridBinding["prototype"]["checkUpdate"] = function(bForceUpdate) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["checkUpdate"]++; }; 
	/** @type {UCF_JSONGridBinding_Grid} */
	var oGrid = this["oModel"]["_getObject"](this["sPath"], this["oContext"]);

	if (!UCF_JsUtil["bEqual"](this["oGrid"], oGrid) || bForceUpdate) {
		this["update"]();
		this["_fireChange"]();
	} else if (this["currentRangeChanged"]()) {
		this["update"]();
	}
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["checkUpdate"] = 0; };

/**
 * @see UCF_ListBinding.prototype.sort
 * @param {Object} oSorter
 */
UCF_JSONGridBinding["prototype"]["sort"] = function(oSorter) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["sort"]++; }; 
	if (oSorter) {
		this["oSorter"] = oSorter;
		this["applySort"]();
	} else {
		this["oSorter"] = null;
		this["applyFilter"]();
	}
	this["_fireChange"]();
	this["_fireSort"]({ "sorter": oSorter });
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["sort"] = 0; };

/**
 * Sorts the list
 * @private
 */
UCF_JSONGridBinding["prototype"]["applySort"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["applySort"]++; }; 
	/** @type {UCF_JSONGridBinding} */
	var self;
	/** @type {Array} */
	var aSortValues;
	var oValue;
	var fnCompare;

	if (!this["oSorter"]) {
		return;
	}

	self = this;
	aSortValues = [];
	fnCompare = this["oSorter"]["fnCompare"];

	if (!fnCompare) {
		fnCompare = function(a, b) {
			if (b == null) {
				return -1;
			}
			if (a == null) {
				return 1;
			}
			if (typeof a === 'string' && typeof b === 'string') {
				return a["localeCompare"](b);
			}
			if (a < b) {
				return -1;
			}
			if (a > b) {
				return 1;
			}

			return 0;
		};
	}

	UCF_JsUtil["each"](this["aIndices"], function(i, iIndex) {
		oValue = self["oModel"]["_getObject"](self["oSorter"]["sPath"], self["oList"][iIndex]);
		if (typeof oValue === 'string') {
			oValue = oValue["toLocaleUpperCase"]();
		}
		aSortValues[iIndex] = oValue;
	});

	this["aIndices"]["sort"](function(a, b) {
		var valueA = aSortValues[a];
		var valueB = aSortValues[b];
		var returnValue = fnCompare(valueA, valueB);

		if (self["oSorter"]["bDescending"]) {
			returnValue = -returnValue;
		}

		return returnValue;
	});
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["applySort"] = 0; };

/**
 * @see UCF_GridBinding.prototype.filter
 * @param {Array} aFilters
 */
UCF_JSONGridBinding["prototype"]["filter"] = function(aFilters) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["filter"]++; }; 
	this["updateIndices"]();
	if (!aFilters || !UCF_JsUtil["bIsArray"](aFilters) || aFilters["length"] === 0) {
		this["aFilters"] = null;
		this["iLength"] = this["_getLength"]();
	} else {
		this["aFilters"] = aFilters;
		this["applyFilter"]();
	}
	this["applySort"]();
	this["_fireChange"]();
	this["_fireFilter"]({ "filters": aFilters });
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["filter"] = 0; };

/**
 * Filters the list
 * Filters are first grouped according to their binding path.
 * All filters belonging to a group are ORed and after that the
 * results of all groups are ANDed.
 * Usually this means, all filters applied to a single table column
 * are ORed, while filters on different table columns are ANDed.
 *
 * @private
 */
UCF_JSONGridBinding["prototype"]["applyFilter"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["applyFilter"]++; }; 
	/** @type {UCF_JSONGridBinding} */
	var self;
	/** @type {Object<string, UCF_ListBinding_Filter[]>} */
	var oFilterGroups;
	/** @type {UCF_ListBinding_Filter[]} */
	var aFilterGroup;
	/** @type {Array} */
	var aFiltered;
	/** @type {boolean} */
	var bGroupFiltered;
	/** @type {boolean} */
	var bFiltered;

	if (!this["aFilters"]) {
		return;
	}

	self = this;
	oFilterGroups = {};
	aFiltered = [];
	bGroupFiltered = false;
	bFiltered = true;

	UCF_JsUtil["each"](this["aIndices"], function(i, iIndex) {
		bFiltered = true;
		UCF_JsUtil["each"](self["aFilters"], function(j, oFilter) {
			aFilterGroup = oFilterGroups[oFilter["sPath"]];
			if (!aFilterGroup) {
				aFilterGroup = oFilterGroups[oFilter["sPath"]] = [];
			}
			aFilterGroup["push"](oFilter);
		});
		UCF_JsUtil["each"](oFilterGroups, function(sPath, aFilterGroup) {
			var oValue = self["oModel"]["_getObject"](sPath, self["oList"][iIndex]);

			if (typeof oValue == 'string') {
				oValue = oValue["toUpperCase"]();
			}
			bGroupFiltered = false;
			UCF_JsUtil["each"](aFilterGroup, function(j, oFilter) {
				var fnTest = self["getFilterFunction"](oFilter);

				// eslint-disable-next-line eqeqeq
				if (oValue != undefined && fnTest(oValue)) {
					bGroupFiltered = true;

					return false;
				}
			});
			if (!bGroupFiltered) {
				bFiltered = false;

				return false;
			}
		});
		if (bFiltered) {
			aFiltered["push"](iIndex);
		}
	});
	this["aIndices"] = aFiltered;
	this["iLength"] = aFiltered["length"];
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["applyFilter"] = 0; };

/**
 * Provides a JS filter function for the given filter
 * @template T
 * @param {UCF_ListBinding_Filter<T>} oFilter
 * @return {function(number): boolean} JS filter function for the given filter
 */
UCF_JSONGridBinding["prototype"]["getFilterFunction"] = function(oFilter) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getFilterFunction"]++; }; 
	/** @type {T} */
	var oValue1;
	/** @type {T} */
	var oValue2;

	if (oFilter["fnTest"]) {
		return oFilter["fnTest"];
	}

	oValue1 = oFilter["oValue1"];
	oValue2 = oFilter["oValue2"];

	if (typeof oValue1 === 'string') {
		oValue1 = oValue1["toUpperCase"]();
	}
	if (typeof oValue2 === 'string') {
		oValue2 = oValue2["toUpperCase"]();
	}

	switch (oFilter["sOperator"]) {
		case 'EQ':
			// eslint-disable-next-line eqeqeq
			oFilter["fnTest"] = function(value) { return value == oValue1; };
			break;
			case 'NE':
			// eslint-disable-next-line eqeqeq
			oFilter["fnTest"] = function(value) { return value != oValue1; };
			break;
		case 'LT':
			oFilter["fnTest"] = function(value) { return value < oValue1; };
			break;
		case 'LE':
			oFilter["fnTest"] = function(value) { return value <= oValue1; };
			break;
		case 'GT':
			oFilter["fnTest"] = function(value) { return value > oValue1; };
			break;
		case 'GE':
			oFilter["fnTest"] = function(value) { return value >= oValue1; };
			break;
		case 'BT':
			oFilter["fnTest"] = function(value) { return (value > oValue1) && (value < oValue2); };
			break;
		case 'Contains':
			oFilter["fnTest"] = function(value) {
				if (typeof value !== 'string') {
					throw new Error('Only "String" values are supported for the FilterOperator: "Contains".');
				}

				return value["indexOf"](oValue1) !== -1;
			};
			break;
		case 'StartsWith':
			oFilter["fnTest"] = function(value) {
				if (typeof value !== 'string') {
					throw new Error('Only "String" values are supported for the FilterOperator: "StartsWith".');
				}

				return value["indexOf"](oValue1) === 0;
			};
			break;
		case 'EndsWith':
			oFilter["fnTest"] = function(value) {
				var iPos;

				if (typeof value !== 'string') {
					throw new Error('Only "String" values are supported for the FilterOperator: "EndsWith".');
				}

				iPos = value["indexOf"](oValue1);
				if (iPos === -1) {
					return false;
				}

				return iPos === value["length"] - new String(oFilter["oValue1"])["length"];
			};
			break;
		default:
			oFilter["fnTest"] = function(value) { return true; };
	}

	return oFilter["fnTest"];
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getFilterFunction"] = 0; };

/**
 * Get distinct values
 *
 * @protected
 * @param {string} sPath
 * @return {string[]}
 */
UCF_JSONGridBinding["prototype"]["getDistinctValues"] = function(sPath) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getDistinctValues"]++; }; 
	/** @type {string[]} */
	var aResult = [];
	/** @type {Object} */
	var oMap = {};
	/** @type {string} */
	var sValue;
	/** @type {UCF_JSONGridBinding} */
	var self = this;

	UCF_JsUtil["each"](this["oGrid"], function(i, oContext) {
		sValue = self["oModel"]["getProperty"](sPath, oContext);
		if (!oMap[sValue]) {
			oMap[sValue] = true;
			aResult["push"](sValue);
		}
	});

	return aResult;
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getDistinctValues"] = 0; };

/** @return {UCF_JSONGridBinding_Range} */
UCF_JSONGridBinding["prototype"]["getCurrentRange"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getCurrentRange"]++; }; 
	return this["oCurrentRange"];
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getCurrentRange"] = 0; };

/**
 * @param {number} iStartX
 * @param {number} iStartY
 * @param {number} iEndX
 * @param {number} iEndY
 */
UCF_JSONGridBinding["prototype"]["setCurrentRange"] = function(iStartX, iStartY, iEndX, iEndY) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["setCurrentRange"]++; }; 
	this["oCurrentRange"] = {
		"iStartX": iStartX,
		"iStartY": iStartY,
		"iEndX": iEndX,
		"iEndY": iEndY
	};
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["setCurrentRange"] = 0; };

/** @return {UCF_JSONGridBinding_Range} */
UCF_JSONGridBinding["prototype"]["requestCurrentRange"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["requestCurrentRange"]++; }; 
	/** @type {string} */
	var sPath = this["getAbsolutePath"]();
	/** @type {string} */
	var sModel = this["getModel"]()["getId"]();
	/** @type {UCF_JSONGridBinding_Range} */
	var oRange = this["getMissingRange"]();

	if (oRange) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Requesting : ' + sModel + '>' + sPath + '{iStartX: ' + oRange["iStartX"] + ', iStartY: ' + oRange["iStartY"] + ', iEndX: ' + oRange["iEndX"] + ', iEndY : ' + oRange["iEndY"] + '}', "JSONGridBinding.js(635): requestCurrentRange"); };
		this["oModel"]["fireGridUpdate"](this, oRange, 'GET');
	}

	return oRange;
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["requestCurrentRange"] = 0; };

/** @return {boolean} */
UCF_JSONGridBinding["prototype"]["dataRequested"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["dataRequested"]++; }; 
	/** @type {string} */
	var sPath = this["getAbsolutePath"]();
	/** @type {string} */
	var sModel = this["getModel"]()["getId"]();
	/** @type {UCF_JSONGridBinding_Range} */
	var oRange = this["getMissingRange"]();

	if (!UCF_JSONGridBinding["mRequestedRangesMatrix"][sModel + '>' + sPath]) {
		return false;
	}

	return oRange == null;
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["dataRequested"] = 0; };

/**
 * @param {number} x
 * @param {number} y
 * @return {boolean}
 */
UCF_JSONGridBinding["prototype"]["hasValidData"] = function(x, y) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["hasValidData"]++; }; 
	/** @type {UCF_JSONGridBinding_Range[]} */
	var aRanges = UCF_JSONGridBinding["mRequestedRangesMatrix"][
		this["getModel"]()["getId"]() + '>' + this["getAbsolutePath"]()
	];

	if (!aRanges) {
		return true;
	}

	return aRanges[y] && aRanges[y]["charAt"](x) === '1';
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["hasValidData"] = 0; };

/** @protected */
UCF_JSONGridBinding["prototype"]["setMissingRangeLoaded"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["setMissingRangeLoaded"]++; }; 
	this["getMissingRange"](true);
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["setMissingRangeLoaded"] = 0; };

/**
 * Returns the missing range for the current range.
 * Checks which ranges where already requested but not yet delivered.
 * @param {boolean} bLoaded
 * @return {UCF_JSONGridBinding_Range}
 */
UCF_JSONGridBinding["prototype"]["getMissingRange"] = function(bLoaded) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getMissingRange"]++; }; 
	/** @type {string} */
	var sPath = this["getAbsolutePath"]();
	/** @type {string} */
	var sModel = this["getModel"]()["getId"]();
	/** @type {UCF_JSONGridBinding_Range[]} */
	var aRanges;
	/** @type {UCF_JSONGridBinding_Range} */
	var oRange;
	/** @type {number} */
	var iStartX;
	/** @type {number} */
	var iStartY;
	/** @type {number} */
	var iEndX;
	/** @type {number} */
	var iEndY;
	/** @type {boolean} */
	var bInitialize;
	/** @type {boolean} */
	var bStartY;
	/** @type {boolean} */
	var bMissing;
	/** @type {string[]} */
	var aString;
	/** @type {UCF_JSONGridBinding_Range} */
	var s;
	/** @type {number} */
	var iFirst;
	/** @type {number} */
	var iLast;
	/** @type {number} */
	var y;

	if (!UCF_JSONGridBinding["mRequestedRangesMatrix"][sModel + '>' + sPath]) {
		UCF_JSONGridBinding["mRequestedRangesMatrix"][sModel + '>' + sPath] = [];
	}

	aRanges = UCF_JSONGridBinding["mRequestedRangesMatrix"][sModel + '>' + sPath];
	oRange = this["getCurrentRange"]();
	iStartX = Math["min"](oRange["iEndX"], this["iMaxX"] > -1 ? this["iMaxX"] : oRange["iEndX"]);
	iEndX = Math["min"](oRange["iEndX"], this["iMaxX"] > -1 ? this["iMaxX"] : oRange["iEndX"]);
	iStartY = Math["min"](oRange["iEndY"], this["iMaxY"] > -1 ? this["iMaxY"] : oRange["iEndY"]);
	iEndY = Math["min"](oRange["iEndY"], this["iMaxY"] > -1 ? this["iMaxY"] : oRange["iEndY"]);
	bInitialize = true;
	bStartY = false;
	bMissing = false;
	aString = [];
	s = null;
	iFirst = 0;
	iLast = 0;

	if (
		oRange["iStartX"] === oRange["iEndX"] &&
		oRange["iStartY"] === oRange["iEndY"] &&
		aRanges[oRange["iStartY"]] &&
		aRanges[oRange["iStartY"]]["charAt"](oRange["iStartX"]) === '1'
	) {
		return null;
	}

	for (y = oRange["iStartY"]; y <= oRange["iEndY"]; y++) {
		aString = [];
		if (!aRanges[y]) {
			aString = new Array(oRange["iEndX"] + 2);
			aRanges[y] = aString["join"]('0');
		}
		s = aRanges[y];
		if (s["length"] <= oRange["iEndX"]) {
			aString = new Array(oRange["iEndX"] - s["length"] + 2);
			aRanges[y] = aRanges[y] + aString["join"]('0');
		}
		s = aRanges[y]["substring"](oRange["iStartX"], oRange["iEndX"] + 1);
		iFirst = s["indexOf"]('0');
		iLast = s["lastIndexOf"]('0');
		if (iFirst > -1) {
			iStartX = Math["min"](iStartX, iFirst + oRange["iStartX"]);
			if (bInitialize) {
				iEndX = iStartX;
				bInitialize = false;
			}
			iEndX = Math["max"](iEndX, iLast + oRange["iStartX"]);
			if (!bMissing) {
				bMissing = true;
			}
		} else {
			continue;
		}
		if (bLoaded) {
			aString = new Array(iEndX - iStartX + 2);
			aRanges[y] = aRanges[y]["substring"](0, iStartX) +
				aString["join"]('1') +
				aRanges[y]["substring"](iStartX + aString["length"] - 1);
		}
		if (bStartY) {
			iEndY = y;
		} else {
			iStartY = y;
			iEndY = y;
			bStartY = true;
		}
	}
	if (bMissing) {
		return {"iStartX": iStartX, "iStartY": iStartY, "iEndX": iEndX, "iEndY": iEndY};
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getMissingRange"] = 0; };

/**
 * Adds a temporary selection for the given range
 * Event to the model is not fired unless the method commitSelection is called.
 * To cancel a selection call the method cancelSelection
 *
 * @param {string|number} iStartX  the start index of the selection or * for all cells
 * @param {string|number} iStartY  the start index of the selection or * for all cells
 * @param {string|number} iEndX  the end index of the selection or * for all cells
 * @param {string|number} iEndY  the end index of the selection or * for all cells
 * @param {string|number} iState  state
 */
UCF_JSONGridBinding["prototype"]["addSelection"] = function(iStartX, iStartY, iEndX, iEndY, iState) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["addSelection"]++; }; 
	/** @type {string} */
	var sRangeCoords;
	/** @type {Object[]} */
	var aCurrentRanges;
	/** @type {Object} */
	var oNewRange;

	if (iState === 1) {
		if (this["oPrimarySelection"]) {
			this["oModel"]["setPathData"](this["oPrimarySelection"]["path"], { "__selected": null }, true, true);
		}
		this["oPrimarySelection"] = {
			"path": this["getPath"]() + '/' + iStartX + '-' + iStartY,
			"range": {
				"iStartX": iStartX,
				"iStartY": iStartY,
				"iEndX": iEndX,
				"iEndY": iEndY
			}
		};
		this["oModel"]["setPathData"](this["oPrimarySelection"]["path"], { "__selected": 1 }, true, true);
		this["oModel"]["checkAllUpdates"](this["getPath"]());
	} else {
		sRangeCoords = '[' + iStartX + ',' + iStartY + ']-[' + iEndX + ',' + iEndY + ']';
		this["oSelection"] = {
			"path": this["getPath"]() + '/__ranges',
			"coords": sRangeCoords,
			"range": {
				"iStartX": iStartX,
				"iStartY": iStartY,
				"iEndX": iEndX,
				"iEndY": iEndY
			},
			"state": iState
		};

		aCurrentRanges = this["oModel"]["_getObject"](this["oSelection"]["path"], null, true);
		if (!aCurrentRanges) {
			aCurrentRanges = [];
		}
		if (!aCurrentRanges["length"]) {
			aCurrentRanges = [];
		}

		oNewRange = {};
		oNewRange[this["oSelection"]["coords"]] = { "__selected": iState };
		aCurrentRanges["push"](oNewRange);

		this["oModel"]["setPathData"](this["oSelection"]["path"], aCurrentRanges, false, true);
		this["oModel"]["checkAllUpdates"](this["getPath"]());
	}
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["addSelection"] = 0; };

/**
 * Clears all temporary selections
 * Event to the model is not fired unless the method commitSelection is called.
 * @param {boolean} bCommitSelection
 *
 */
UCF_JSONGridBinding["prototype"]["clearSelections"] = function(bCommitSelection) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["clearSelections"]++; }; 
	/** @type {Object[]} */
	var aRanges = this["oModel"]["_getObject"](this["getPath"]() + '/__ranges', null, true);
	/** @type {Object[]} */
	var aDeleteRanges = [];
	/** @type {number} */
	var i = 0;
	/** @type {string} */
	var n = null;
	/** @type {Object} */
	var oRange = null;
	/** @type {boolean} */
	var bAvoidDelete = false;
	/** @type {Array} */
	var aParts;
	/** @type {Array} */
	var aStart;
	/** @type {Array} */
	var aEnd;
	/** @type {UCF_JSONGridBinding_Range} */
	var o;
	/** @type {string} */
	var m;

	if (aRanges) {
		for (i = 0; i < aRanges["length"]; i++) {
			for (n in aRanges[i]) {
				oRange = aRanges[i][n];
				bAvoidDelete = false;
				if (oRange["__selected"] != null) {
					// eslint-disable-next-line max-depth
					if (bCommitSelection && oRange["__selected"] != 0) {
						aParts = n["split"](']-[');
						aStart = aParts[0]["substring"](1)["split"](',');
						aEnd = aParts[1]["substring"](0, aParts[1]["length"] - 1)["split"](',');
						o = {
								"iStartX": aStart[0],
								"iStartY": aStart[1],
								"iEndX": aEnd[0],
								"iEndY": aEnd[1]
							};
						this["oModel"]["fireGridSelectionUpdate"](this, o, 0);
					}
					delete oRange["__selected"];
				}

				for (m in oRange) { //eslint-disable-line no-unused-vars
					bAvoidDelete = true;
				}
				if (!bAvoidDelete) {
					aDeleteRanges["push"](i);
				}
			}
		}
		for (i = aDeleteRanges["length"] - 1; i >= 0; i--) {
			aRanges["splice"](aDeleteRanges[i], 1);
		}
		this["oModel"]["checkAllUpdates"](this["getPath"]());
	}
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["clearSelections"] = 0; };

/**
 * Returns the current selections in the grid binding. Based on the given state
 * the primary (1) or secondary (2) selection is returned. The secondary
 * selection returns an array of selection objects while the primary selection
 * simply returns one selection oblect.
 * The selection object contains {
				path : this.getPath() + '/__ranges',
				coords : sRangeCoords,
				range : {	iStartX:iStartX,
							iStartY:iStartY,
							iEndX:iEndX,
							iEndY:iEndY
				}
 * @param {integer} iState
 * @return {UCF_JSONGridBinding_Selection} An array or object of the selection
 * depending on the state
 */
UCF_JSONGridBinding["prototype"]["getSelection"] = function(iState) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getSelection"]++; }; 
	if (iState === 1) {
		return this["oPrimarySelection"];
	}
	if (iState === 0 || iState === 2) {
		return this["aSelections"];
	}
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["getSelection"] = 0; };

/**
 * Get the selection
 *  @return {UCF_JSONGridBinding_Selection[]} selection ranges
 */
UCF_JSONGridBinding["prototype"]["aGetSelections"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["aGetSelections"]++; }; 
	/** @type {Object[]} */
	var aRanges = this["oModel"]["_getObject"](this["getPath"]() + '/__ranges', null, true);
	/** @type {Object[]} */
	var aSelectionRanges = [];
	/** @type {Object} */
	var oRange = null;
	/** @type {number} */
	var i;
	/** @type {string} */
	var n;
	/** @type {string[]} */
	var aParts;
	/** @type {string[]} */
	var aStart;
	/** @type {string[]} */
	var aEnd;
	/** @type {UCF_JSONGridBinding_Range} */
	var o;

	if (aRanges) {
		for (i = 0; i < aRanges["length"]; i++) {
			for (n in aRanges[i]) {

				oRange = aRanges[i][n];
				if (oRange["__selected"] != null) {
					aParts = n["split"](']-[');
					aStart = aParts[0]["substring"](1)["split"](',');
					aEnd = aParts[1]["substring"](0, aParts[1]["length"] - 1)["split"](',');
					o = {
						"iStartX": aStart[0],
						"iStartY": aStart[1],
						"iEndX": aEnd[0],
						"iEndY": aEnd[1]
					};
					aSelectionRanges["push"](o);
				}
			}
		}
	}

	return aSelectionRanges;
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["aGetSelections"] = 0; };

/**
 * Commits the selection
 */
UCF_JSONGridBinding["prototype"]["commitSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["commitSelection"]++; }; 
	if (this["oSelection"]) {
		this["oModel"]["fireGridSelectionUpdate"](
			this,
			this["oSelection"]["range"],
			this["oSelection"]["state"]
		);
		this["oSelection"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["commitSelection"] = 0; };

/**
 * Cancels the selection and removes the data from the model
 * @param {0|1|2} iState
 */
UCF_JSONGridBinding["prototype"]["cancelSelection"] = function(iState) {;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["cancelSelection"]++; }; 
	if (iState === 2 && this["oSelection"]) {
		this["oModel"]["setPathData"](
			this["oSelection"]["path"] + '/' + this["oSelection"]["coords"],
			null,
			true,
			true
		);
		this["oModel"]["checkAllUpdates"](this["getPath"]());
	}
	if (iState === 1 && this["oPrimarySelection"]) {
		this["oModel"]["setPathData"](
			this["oPrimarySelection"]["path"],
			{ "__selected": null },
			true,
			true
		);
		this["oModel"]["checkAllUpdates"](this["getPath"]());
	}
};;if (__UCF_COVERAGE__) { UCF_JSONGridBinding["_"]["cancelSelection"] = 0; };

};
sap["ls"]["preload"]["UCF_JSONListBinding"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_ListBinding */
/// <reference path="../ListBinding.js"/>

/**
 * @typedef {Object} UCF_JSONListBinding_Range
 * @property {number} iStart
 * @property {number} iEnd
 */

/**
 * List binding implementation for JSON format
 * @class
 * @param {UCF_Model} oModel
 * @param {string} sPath
 * @param {UCF_BindingContext} oContext
 * @param {UCF_ListBinding_Sorter} oSorter
 * @param {Array} aFilters
 * @param {Object} mParameters
 */
function UCF_JSONListBinding(oModel, sPath, oContext, oSorter, aFilters, mParameters) {if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["UCF_JSONListBinding"]++; }; 
	UCF_ListBinding["apply"](this, arguments);
	this["oObject"] = null;
	this["oObjects"] = null;
	this["update"]();
	this["sClassName"] = 'UCF_JSONListBinding';
	this["iStart"] = 0;
	this["iLength"] = this["oModel"]["iSizeLimit"];
	this["iMax"] = -1;
	this["aRanges"] = [];
	this["bManageRange"] = mParameters && ('managerange' in mParameters) && mParameters["managerange"];
};window["UCF_JSONListBinding"] = UCF_JSONListBinding; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_JSONListBinding"); UCF_JSONListBinding["_"] = {UCF_JSONListBinding: 0}; }; ;
UCF_JSONListBinding["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ListBinding"))(); UCF_JSONListBinding.prototype["sClassName"] = "UCF_JSONListBinding";

UCF_JSONListBinding["mRequestedRangesMatrix"] = {};

/** @override */
UCF_JSONListBinding["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["destroy"]++; }; 
	this["oObject"] = null;
	this["iStart"] = null;
	this["iLength"] = null;
	this["_iLength"] = null;
	this["iMax"] = null;
	this["bManageRange"] = null;
	this["oCurrentRange"] = null;
	this["aCurrentContexts"] = null;
	this["aIndices"] = null;
	this["oList"] = null;

	UCF_ListBinding.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["destroy"] = 0; };

/**
 * Checks whether all data for a given range is available in the model.
 * @return {boolean} whether all data for a given range is available in the
 * model
 */
UCF_JSONListBinding["prototype"]["dataAvailable"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["dataAvailable"]++; }; 
	/** @type {UCF_JSONListBinding_Range} */
	var oCurrentRange = this["getCurrentRange"]();
	/** @type {string} */
	var sPrefix = this["oModel"]["resolve"](this["sPath"], this["oContext"]) + '/';
	/** @type {number} */
	var i;
	/** @type {string} */
	var sKey;
	/** @type {UCF_BindingContext} */
	var oContext;
	/** @type {Object} */
	var oObject;

	for (i = oCurrentRange["iStart"]; i < oCurrentRange["iEnd"]; i++) {
		sKey = i + '';
		oContext = this["oModel"]["getContext"](sPrefix + sKey, true);

		if (!oContext) {
			if (!this["dataRequested"]()) {
				return false;
			}
		}

		if (oContext) {
			oObject = oContext["getObject"]();
			if (oObject === null || typeof(oObject) === 'undefined') {
				return false;
			}
		}
	}

	return true;
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["dataAvailable"] = 0; };

/** @return {UCF_JSONListBinding_Range} */
UCF_JSONListBinding["prototype"]["requestCurrentRange"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["requestCurrentRange"]++; }; 
	/** @type {string} */
	var sPath = this["getAbsolutePath"]();
	/** @type {string} */
	var sModel = this["getModel"]()["getId"]();
	/** @type {UCF_JSONListBinding_Range} */
	var oRange = this["getMissingRange"](true);

	if (oRange) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Requesting List: ' + sModel + '>' + sPath + '{iStart: ' + oRange["iStart"] + ', iEnd: ' + oRange["iEnd"] + '}', "JSONListBinding.js(106): requestCurrentRange"); };
		this["oModel"]["fireListUpdate"](this, oRange, 'GET');
	}

	return oRange;
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["requestCurrentRange"] = 0; };

/** @return {boolean} */
UCF_JSONListBinding["prototype"]["dataRequested"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["dataRequested"]++; }; 
	/** @type {string} */
	var sPath = this["getAbsolutePath"]();
	/** @type {string} */
	var sModel = this["getModel"]()["getId"]();
	/** @type {UCF_JSONListBinding_Range} */
	var oRange = this["getMissingRange"]();

	if (!UCF_JSONListBinding["mRequestedRangesMatrix"][sModel + '>' + sPath]) {
		return false;
	}

	return oRange == null;
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["dataRequested"] = 0; };

/**
 * Returns the missing range for the current range.
 * Checks which ranges where already requested but not yet delivered.
 * @param {boolean} bLoaded
 * @return {UCF_JSONListBinding_Range}
 */
UCF_JSONListBinding["prototype"]["getMissingRange"] = function(bLoaded) {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getMissingRange"]++; }; 
	/** @type {string} */
	var sPath = this["getAbsolutePath"]();
	/** @type {string} */
	var sModel = this["getModel"]()["getId"]();
	/** @type {UCF_JSONListBinding_Range[]} */
	var aRanges;
	/** @type {UCF_JSONListBinding_Range} */
	var oRange;
	/** @type {number} */
	var iStart;
	/** @type {number} */
	var iEnd;
	/** @type {boolean} */
	var bMissing;
	/** @type {number} */
	var y;

	if (!UCF_JSONListBinding["mRequestedRangesMatrix"][sModel + '>' + sPath]) {
		UCF_JSONListBinding["mRequestedRangesMatrix"][sModel + '>' + sPath] = [];
	}

	aRanges = UCF_JSONListBinding["mRequestedRangesMatrix"][sModel + '>' + sPath];
	oRange = this["getCurrentRange"]();
	iStart = oRange["iStart"];
	iEnd = oRange["iEnd"];
	bMissing = false;

	if (
		oRange["iStart"] === oRange["iEnd"] &&
		aRanges[oRange["iStart"]] &&
		aRanges[oRange["iStart"]] === true
	) {
		return null;
	}

	for (y = oRange["iStart"]; y <= oRange["iEnd"]; y++) {
		if (aRanges[y] !== true) {
			if (bMissing) {
				iEnd = y;
			} else {
				iStart = y;
				bMissing = true;
			}
			aRanges[y] = false;
		}
		if (bLoaded) {
			aRanges[y] = true;
		}
	}
	if (bMissing) {
		return { "iStart": iStart, "iEnd": iEnd };
	} else {
		return null;
	}

};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getMissingRange"] = 0; };

/** @return {UCF_JSONListBinding_Range} */
UCF_JSONListBinding["prototype"]["getCurrentRange"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getCurrentRange"]++; }; 
	return this["oCurrentRange"];
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getCurrentRange"] = 0; };

/**
 * @param {number} iStart
 * @param {number} iEnd
 */
UCF_JSONListBinding["prototype"]["setCurrentRange"] = function(iStart, iEnd) {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["setCurrentRange"]++; }; 
	this["oCurrentRange"] = {
		"iStart": iStart,
		"iEnd": iEnd
	};
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["setCurrentRange"] = 0; };

/** @param {boolean} bManage */
UCF_JSONListBinding["prototype"]["setManageRanges"] = function(bManage) {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["setManageRanges"]++; }; 
	this["bManageRange"] = bManage;
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["setManageRanges"] = 0; };

/**
 * Return contexts for the list or a specified subset of contexts
 *
 * @protected
 * @param {number} [iStart=0] the startIndex where to start the retrieval of
 * contexts
 * @param {number} [iLength=this.iLength] determines how many contexts to
 * retrieve beginning from the start index. Default is the whole list length.
 * @return {UCF_BindingContext[]} the contexts array
 */
UCF_JSONListBinding["prototype"]["getContexts"] = function(iStart, iLength) {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getContexts"]++; }; 
	/** @type {UCF_JSONListBinding_Range} */
	var oCurrentRange;
	/** @type {UCF_JSONListBinding_Range} */
	var oRange;
	/** @type {number} */
	var iEnd;
	/** @type {UCF_BindingContext} */
	var oContext;
	/** @type {UCF_BindingContext[]} */
	var aContexts;
	/** @type {string} */
	var sPrefix;
	/** @type {number} */
	var i;

	if (!iLength) {
		iLength = Math["min"](this["iLength"], iLength);
	}
	if (!iStart) {
		iStart = 0;
	}

	oCurrentRange = this["getCurrentRange"]();
	oRange = { "iStart": iStart, "iEnd": iStart + iLength };
	iEnd = oRange["iEnd"];
	iStart = oRange["iStart"];

	if (!iEnd && this["iMax"] > -1) {
		iEnd = Math["min"](iStart + 20, this["iMax"]);
	}
	if (oCurrentRange && this["aCurrentContexts"]) {
		//check whether the range and deliver the old context if not.
		if (oCurrentRange["iStart"] === iStart &&
			oCurrentRange["iEnd"] === iEnd) {
			return this["aCurrentContexts"];
		}
	}
	this["setCurrentRange"](iStart, iEnd);

	aContexts = [];
	sPrefix = this["oModel"]["resolve"](this["sPath"], this["oContext"]) + '/';

	this["iStart"] = iStart;
	this["iLength"] = iLength;
	if (this["bManageRange"]) {
		if (!this["dataRequested"]() && !this["dataAvailable"]()) {
			this["requestCurrentRange"]();
		}
	}
	for (i = iStart; i < iEnd; i++) {
		oContext = this["oModel"]["getContext"](sPrefix + i);
		oContext["setBindingParameter"]({
			"x": i
		}); //remember the index in the binding context for virtualization
		aContexts["push"](oContext);
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Context delivered for ' + (iEnd - iStart) + ' list items', "JSONListBinding.js(281): getContexts"); };
	this["aCurrentContexts"] = aContexts;

	return aContexts;
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getContexts"] = 0; };

/**
 * Setter for context
 * @param {UCF_BindingContext} oContext the new context object
 */
UCF_JSONListBinding["prototype"]["setContext"] = function(oContext) {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["setContext"]++; }; 
	if (this["oContext"] !== oContext) {
		this["oContext"] = oContext;
		this["update"]();
		this["_fireChange"]();
	}
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["setContext"] = 0; };

/**
 * Return the length of the list
 *
 * @protected
 * @return {number} the length
 */
UCF_JSONListBinding["prototype"]["getLength"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getLength"]++; }; 
	return this["iLength"];
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getLength"] = 0; };

/**
 * Return the length of the list
 *
 * @return {number} the length
 */
UCF_JSONListBinding["prototype"]["_getLength"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["_getLength"]++; }; 
	if (this["oList"] && !UCF_JsUtil["bIsArray"](this["oList"])) {
		return this["_iLength"];
	} else {
		return this["aIndices"]["length"];
	}
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["_getLength"] = 0; };

/**
 * Update the list, indices array and apply sorting and filtering
 *
 * @private
 */
UCF_JSONListBinding["prototype"]["update"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["update"]++; }; 
	/** @type {Object} */
	var oObject = this["oModel"]["_getObject"](this["sPath"], this["oContext"]);
	/** @type {Object} */
	var oList = oObject;
	/** @type {number} */
	var iLength;
	/** @type {string} */
	var n;
	/** @type {number} */
	var iIndex;
	/** @type {number} */
	var i;

	if (oObject && !UCF_JsUtil["bIsArray"](oObject)) {
		this["oList"] = oList;
		this["oObject"] = oObject;

		iLength = 0;
		for (n in this["oList"]) {
			iIndex = parseInt(n);
			if (isNaN(iIndex)) {
				continue;
			}
			iLength = Math["max"](iLength, iIndex + 1);
		}
		for (i = 0; i < iLength; i++) {
			if (!this["oObjects"]) {
				this["oObjects"] = {};
			}
			this["oObjects"][i + ''] = oObject['' + i];
		}
		this["updateIndices"]();
		this["applyFilter"]();
		this["applySort"]();
		this["iLength"] = this["_getLength"]();
	} else if (oList && UCF_JsUtil["bIsArray"](oList)) {
		this["oList"] = oList["slice"](0);
		this["oObject"] = oObject;
		this["updateIndices"]();
		this["applyFilter"]();
		this["applySort"]();
		this["iLength"] = this["_getLength"]();
	} else {
		this["oObject"] = null;
		this["oList"] = null;
		this["aIndices"] = [];
		this["iLength"] = 0;
	}
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["update"] = 0; };

/**
 * Check whether this Binding would provide new values and in case it changed,
 * inform interested parties about this.
 *
 * @param {boolean} bForceupdate
 */
UCF_JSONListBinding["prototype"]["checkUpdate"] = function(bForceupdate) {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["checkUpdate"]++; }; 
	/** @type {Object} */
	var oObject = this["oModel"]["_getObject"](this["sPath"], this["oContext"]);
	/** @type {boolean} */
	var bFireUpdate;
	/** @type {string} */
	var n;

	if (!UCF_JsUtil["bEqual"](this["oObject"], oObject) || !this["oObjects"] || bForceupdate) {
		this["update"]();
		this["_fireChange"]();
	} else if (this["oObjects"]) {
		bFireUpdate = false;

		for (n in oObject) {
			if (this["oObjects"][n] !== oObject[n]) {
				this["update"]();
				bFireUpdate = true;
				break;
			}
		}
		if (bFireUpdate) {
			this["_fireChange"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["checkUpdate"] = 0; };

/**
 * Get indices of the list
 */
UCF_JSONListBinding["prototype"]["updateIndices"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["updateIndices"]++; }; 
	/** @type {number} */
	var iLength;
	/** @type {string} */
	var n;
	/** @type {number} */
	var iIndex;
	/** @type {number} */
	var i;

	this["aIndices"] = [];
	if (this["oList"] && !UCF_JsUtil["bIsArray"](this["oList"])) {
		iLength = 0;

		for (n in this["oList"]) {
			iIndex = parseInt(n);
			if (isNaN(iIndex)) {
				continue;
			}
			iLength = Math["max"](iLength, iIndex + 1);
		}

		for (i = 0; i < iLength; i++) {
			this["aIndices"]["push"](i);
		}
		this["_iLength"] = iLength;
	} else if (this["oList"]) {
		for (i = 0; i < this["oList"]["length"]; i++) {
			this["aIndices"]["push"](i);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["updateIndices"] = 0; };

/**
 * @see UCF_ListBinding.prototype.sort
 * @param {UCF_ListBinding_Sorter} oSorter
 */
UCF_JSONListBinding["prototype"]["sort"] = function(oSorter) {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["sort"]++; }; 
	if (oSorter) {
		this["oSorter"] = oSorter;
		this["applySort"]();
	} else {
		this["oSorter"] = null;
		this["updateIndices"]();
		this["applyFilter"]();
	}
	this["_fireChange"]();
	this["_fireSort"]({ "sorter": oSorter });
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["sort"] = 0; };

/**
 * Sorts the list
 * @private
 * @template T
 */
UCF_JSONListBinding["prototype"]["applySort"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["applySort"]++; }; 
	/** @type {UCF_JSONListBinding} */
	var self;
	/** @type {T[]} */
	var aSortValues;
	/** @type {T} */
	var oValue;
	/** @type {function(T, T): number} */
	var fnCompare;

	if (!this["oSorter"]) {
		return;
	}

	self = this;
	aSortValues = [];
	fnCompare = this["oSorter"]["fnCompare"];

	if (!fnCompare) {
		fnCompare = function(a, b) {
			if (b == null) {
				return -1;
			}
			if (a == null) {
				return 1;
			}
			if (typeof a === 'string' && typeof b === 'string') {
				return a["localeCompare"](b);
			}
			if (a < b) {
				return -1;
			}
			if (a > b) {
				return 1;
			}

			return 0;
		};
	}

	UCF_JsUtil["each"](this["aIndices"], function(i, iIndex) {
		oValue = self["oModel"]["_getObject"](self["oSorter"]["sPath"], self["oList"][iIndex]);
		if (typeof oValue === 'string') {
			oValue = oValue["toLocaleUpperCase"]();
		}
		aSortValues[iIndex] = oValue;
	});

	this["aIndices"]["sort"](function(a, b) {
		var valueA = aSortValues[a];
		var valueB = aSortValues[b];
		var returnValue = fnCompare(valueA, valueB);

		if (self["oSorter"]["bDescending"]) {
			returnValue = -returnValue;
		}

		return returnValue;
	});
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["applySort"] = 0; };

/**
 * @see UCF_ListBinding.prototype.filter
 * @param {Array} aFilters
 */
UCF_JSONListBinding["prototype"]["filter"] = function(aFilters) {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["filter"]++; }; 
	this["updateIndices"]();
	if (!aFilters || !UCF_JsUtil["bIsArray"](aFilters) || aFilters["length"] === 0) {
		this["aFilters"] = null;
		this["iLength"] = this["_getLength"]();
	} else {
		this["aFilters"] = aFilters;
		this["applyFilter"]();
	}
	this["applySort"]();
	this["_fireChange"]();
	this["_fireFilter"]({ "filters": aFilters });
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["filter"] = 0; };

/**
 * Filters the list
 * Filters are first grouped according to their binding path.
 * All filters belonging to a group are ORed and after that the
 * results of all groups are ANDed.
 * Usually this means, all filters applied to a single table column
 * are ORed, while filters on different table columns are ANDed.
 *
 * @private
 */
UCF_JSONListBinding["prototype"]["applyFilter"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["applyFilter"]++; }; 
	/** @type {UCF_JSONListBinding} */
	var self;
	/** @type {Objecty<string, UCF_ListBinding_Filter[]>} */
	var oFilterGroups;
	/** @type {UCF_ListBinding_Filter[]} */
	var aFilterGroup;
	/** @type {Object[]} */
	var aFiltered;
	/** @type {boolean} */
	var bGroupFiltered;
	/** @type {boolean} */
	var bFiltered;

	if (!this["aFilters"]) {
		return;
	}

	self = this;
	oFilterGroups = {};
	aFiltered = [];
	bGroupFiltered = false;
	bFiltered = true;

	UCF_JsUtil["each"](this["aIndices"], function(i, iIndex) {
		bFiltered = true;
		UCF_JsUtil["each"](self["aFilters"], function(j, oFilter) {
			aFilterGroup = oFilterGroups[oFilter["sPath"]];
			if (!aFilterGroup) {
				aFilterGroup = oFilterGroups[oFilter["sPath"]] = [];
			}
			aFilterGroup["push"](oFilter);
		});
		UCF_JsUtil["each"](oFilterGroups, function(sPath, aFilterGroup) {
			/** @type {Object} */
			var oValue = self["oModel"]["_getObject"](sPath, self["oList"][iIndex]);

			if (typeof oValue == 'string') {
				oValue = oValue["toUpperCase"]();
			}
			bGroupFiltered = false;
			UCF_JsUtil["each"](aFilterGroup, function(j, oFilter) {
				/** @type {function(Object): boolean} */
				var fnTest = self["getFilterFunction"](oFilter);

				if (oValue != undefined && fnTest(oValue)) {
					bGroupFiltered = true;

					return false;
				}
			});
			if (!bGroupFiltered) {
				bFiltered = false;

				return false;
			}
		});
		if (bFiltered) {
			aFiltered["push"](iIndex);
		}
	});
	this["aIndices"] = aFiltered;
	this["iLength"] = aFiltered["length"];
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["applyFilter"] = 0; };

/**
 * Provides a JS filter function for the given filter
 * @param {UCF_ListBinding_Filter} oFilter
 * @return {function(Object): boolean} JS filter function for the given filter
 */
UCF_JSONListBinding["prototype"]["getFilterFunction"] = function(oFilter) {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getFilterFunction"]++; }; 
	/** @type {Object} */
	var oValue1;
	/** @type {Object} */
	var oValue2;

	if (oFilter["fnTest"]) {
		return oFilter["fnTest"];
	}

	oValue1 = oFilter["oValue1"];
	oValue2 = oFilter["oValue2"];

	if (typeof oValue1 === 'string') {
		oValue1 = oValue1["toUpperCase"]();
	}
	if (typeof oValue2 === 'string') {
		oValue2 = oValue2["toUpperCase"]();
	}
	switch (oFilter["sOperator"]) {
		case 'EQ':
			// eslint-disable-next-line eqeqeq
			oFilter["fnTest"] = function(value) { return value == oValue1; };
			break;
		case 'NE':
			// eslint-disable-next-line eqeqeq
			oFilter["fnTest"] = function(value) { return value != oValue1; };
			break;
		case 'LT':
			oFilter["fnTest"] = function(value) { return value < oValue1; };
			break;
		case 'LE':
			oFilter["fnTest"] = function(value) { return value <= oValue1; };
			break;
		case 'GT':
			oFilter["fnTest"] = function(value) { return value > oValue1; };
			break;
		case 'GE':
			oFilter["fnTest"] = function(value) { return value >= oValue1; };
			break;
		case 'BT':
			oFilter["fnTest"] = function(value) { return (value > oValue1) && (value < oValue2); };
			break;
		case 'Contains':
			oFilter["fnTest"] = function(value) {
				if (typeof value !== 'string') {
					throw new Error('Only \'String\' values are supported for the FilterOperator: \'Contains\'.');
				}

				return value["indexOf"](oValue1) !== -1;
			};
			break;
		case 'StartsWith':
			oFilter["fnTest"] = function(value) {
				if (typeof value !== 'string') {
					throw new Error('Only \'String\' values are supported for the FilterOperator: \'StartsWith\'.');
				}

				return value["indexOf"](oValue1) === 0;
			};
			break;
		case 'EndsWith':
			oFilter["fnTest"] = function(value) {
				/** @type {number} */
				var iPos;

				if (typeof value !== 'string') {
					throw new Error('Only \'String\' values are supported for the FilterOperator: \'EndsWith\'.');
				}

				iPos = value["indexOf"](oValue1);
				if (iPos === -1) {
					return false;
				}

				return iPos === value["length"] - new String(oFilter["oValue1"])["length"];
			};
			break;
		default:
			oFilter["fnTest"] = function(value) { return true; };
	}

	return oFilter["fnTest"];
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getFilterFunction"] = 0; };

/**
 * Get distinct values
 *
 * @protected
 * @param {string} sPath
 * @return {string[]}
 */
UCF_JSONListBinding["prototype"]["getDistinctValues"] = function(sPath) {;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getDistinctValues"]++; }; 
	/** @type {string[]} */
	var aResult = [];
	/** @type {Object<string, true>} */
	var oMap = {};
	/** @type {string} */
	var sValue;
	/** @type {UCF_JSONListBinding} */
	var self = this;

	UCF_JsUtil["each"](this["oList"], function(i, oContext) {
		sValue = self["oModel"]["getProperty"](sPath, oContext);
		if (!oMap[sValue]) {
			oMap[sValue] = true;
			aResult["push"](sValue);
		}
	});

	return aResult;
};;if (__UCF_COVERAGE__) { UCF_JSONListBinding["_"]["getDistinctValues"] = 0; };

};
sap["ls"]["preload"]["UCF_JSONModel"] = function() {/* global _trace, INFO, WARNING */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../../core/util/ClassLoader.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_BindingContext */
/// <reference path="../BindingContext.js"/>
/* global UCF_Model */
/// <reference path="../Model.js"/>
/* global UCF_SimpleType */
/// <reference path="../SimpleType.js"/>
/* global UCF_JSONGridBinding */
/// <reference path="./JSONGridBinding.js"/>
/* global UCF_JSONListBinding */
/// <reference path="./JSONListBinding.js"/>
/* global UCF_JSONPropertyBinding */
/// <reference path="./JSONPropertyBinding.js"/>
/* global UCF_JSONTreeBinding */
/// <reference path="./JSONTreeBinding.js"/>

/**
 * Constructor for a new JSONModel.
 * Model implementation for JSON format
 *
 * 
 * @version 1.7.0-SNAPSHOT
 *
 * @class
 * @extends UCF_Model
 *
 * @public
 * @constructor
 * @param {string|Object} oData either the URL where to load the JSON from or a JS object
 */
function UCF_JSONModel(oData) {if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["UCF_JSONModel"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Model["apply"](this, arguments);

		/** @type {boolean} */
		this["bCache"] = false;
		/** @type {UCF_Control} */
		this["oUCFInstance"] = null;

		this["setData"](oData);

		/** @type {string} */
		this["sId"] = '';

		/** @type {TODO} */
		this["mDataTemplates"] = {};
		/** @type {TODO} */
		this["mDataTemplatesByDataPath"] = {};

		/** @type {TODO} */
		this["mRangeFunctions"] = {};
		/** @type {boolean} */
		this["bRequestingData"] = false;
		/** @type {boolean} */
		this["bDataUpdate"] = false;
		/** @type {TODO[]} */
		this["aUpdatePaths"] = [];
	}
};window["UCF_JSONModel"] = UCF_JSONModel; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_JSONModel"); UCF_JSONModel["_"] = {UCF_JSONModel: 0}; }; ;
UCF_JSONModel["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Model"))(); UCF_JSONModel.prototype["sClassName"] = "UCF_JSONModel";

/**
 * Registry for data types. Types are registered with the LS public method
 * registerDataType
 * @static
 * @type {TODO}
 */
UCF_JSONModel["mDataTypeImplementation"] = null;

/**
 * Sets the JSON encoded data to the model.
 *
 * @public
 * @param {string|Object} oData the data to set on the model
 * @param {boolean} [bMerge=false] whether to merge the data instead of
 * replacing it
 */
UCF_JSONModel["prototype"]["setData"] = function (oData, bMerge) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["setData"]++; }; 
	if (typeof oData === 'string') {
		oData = UCF_JsUtil["oJsonParse"](oData);
	}

	if (!UCF_JsUtil["bIsEmpty"](oData)) {
		this["oData"] = bMerge ? UCF_JsUtil["oMergeObjects"](this["oData"], oData) : oData;

		if (this["bLocked"]) {
			this["bDataUpdate"] = true;
		} else {
			this["checkAllUpdates"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["setData"] = 0; };

/**
 * Sets the data for a given path in the model. Depending on the merge
 * parameter the existing object is deleted and a new data is applied or the
 * new data is merged into the path. If the path does not exist the path is
 * created. Called from UCF_PageUpdater.updateModel
 *
 * @private
 * @param {string} sPath the path in the model to set.
 * @param {Object} oData the data to set on the model
 * @param {boolean} [bMerge=false] whether to merge the data instead of
 * replacing it
 */
UCF_JSONModel["prototype"]["setPathData"] = function (sPath, oData, bMerge) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["setPathData"]++; }; 
	/** @type {Object} */
	var oParentObject = null;
	/** @type {string} */
	var sParentPath = '';
	/** @type {Object} */
	var oPathData;

	if (sPath["indexOf"]('>') > -1) {
		sPath = sPath["substring"](sPath["indexOf"]('>') + 1);
	}


	oPathData = this["_getObject"](sPath, null, true);
	if (!oPathData) {
		oPathData = this["createPath"](sPath);
	}

	if (typeof oData === 'object' || UCF_JsUtil["bIsArray"](oData)) {
		if (!bMerge) {
			oParentObject = this["_getObject"](
				sPath["substring"](0, sPath["lastIndexOf"]('/')),
				null,
				true
			);
			if (oParentObject) {
				if (oData == null) {
					oPathData = oData;
					delete oParentObject[sPath["substring"](sPath["lastIndexOf"]('/') + 1)];
				} else {
					// eslint-disable-next-line max-depth
					if (UCF_JsUtil["bIsArray"](oData)) {
						oPathData = [];
					} else {
						oPathData = {};
					}
					oParentObject[sPath["substring"](sPath["lastIndexOf"]('/') + 1)] = oPathData;
				}
			}
			// invalidate requestedRange cache for the case of updating the model
			// without merging
			if (
				window["UCF_JSONGridBinding"] &&
				UCF_JSONGridBinding["mRequestedRangesMatrix"][this["sId"] + '>' + sPath]
			) {
				UCF_JSONGridBinding["mRequestedRangesMatrix"][this["sId"] + '>' + sPath] = null;
			}
			if (
				window["UCF_JSONListBinding"] &&
				UCF_JSONListBinding["mRequestedRangesMatrix"][this["sId"] + '>' + sPath]
			) {
				UCF_JSONListBinding["mRequestedRangesMatrix"][this["sId"] + '>' + sPath] = null;
			}
		}
		if (oPathData !== null) {
			UCF_JsUtil["oMergeObjects"](oPathData, oData);
		}
	} else {
		sParentPath = sPath["substring"](0, sPath["lastIndexOf"]('/'));
		oParentObject = null;
		if (!sParentPath && sPath) {
			oParentObject = this["oData"];
		} else {
			oParentObject = this["_getObject"](sParentPath, null, true);
		}
		if (oParentObject) {
			oParentObject[sPath["substring"](sPath["lastIndexOf"]('/') + 1)] = oData;
		}
	}

	if (this["bLocked"]) {
		this["aUpdatePaths"]["push"](sPath);
	} else {
		this["checkAllUpdates"](sPath);
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["setPathData"] = 0; };

/**
 * Checks all updates of template, range and data updates
 *
 * @private
 * @param {string} sPath
 */
UCF_JSONModel["prototype"]["checkAllUpdates"] = function (sPath) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["checkAllUpdates"]++; }; 
	this["checkTemplateUpdates"]();
	this["checkRangeUpdates"]();
	this["checkUpdate"](false, sPath);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["checkAllUpdates"] = 0; };

/**
 * @private
 * @return {string} the id of the model.
 */
UCF_JSONModel["prototype"]["getId"] = function () {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getId"]++; }; 
	return this["sId"];
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getId"] = 0; };

/**
 * Creates an object path in the current data structure
 *
 * @private
 * @param {string} sPath the path in the model.
 * @return {Object} object reference to the path
 */
UCF_JSONModel["prototype"]["createPath"] = function (sPath) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["createPath"]++; }; 
	/** @type {string[]} */
	var aPath;
	/** @type {number} */
	var i;
	/** @type {Object} */
	var oPathData;
	/** @type {string} */
	var sPart;

	// var oData = this._getObject(sPath,null,true);
	// remove by eslint check ,maybe should be used below instead of this.oData
	if (sPath["indexOf"]('>') > -1) {
		sPath = sPath["substring"](sPath["indexOf"]('>') + 1);
	}

	aPath = sPath["split"]('/');
	i = 1;
	oPathData = this["oData"];
	sPart = aPath[i];

	while (sPart) {
		if (!oPathData[sPart] || typeof oPathData[sPart] !== 'object') {
			oPathData[sPart] = {};
		}
		oPathData = oPathData[sPart];
		i++;
		sPart = aPath[i];
	}

	return this["_getObject"](sPath, null, true);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["createPath"] = 0; };

/**
 * Returns the current JSON data of the model. Be aware that the returned
 * object is a reference to the model data so all changes to that data will
 * also change the model data.
 *
 * @public
 * @return {Object} the JSON data object
 */
UCF_JSONModel["prototype"]["getData"] = function () {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getData"]++; }; 
	return this["oData"];
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getData"] = 0; };

/**
 * Sets the JSON encoded string data to the model.
 *
 * @public
 * @param {string} sJSONText the string data to set on the model
 * @param {boolean} [bMerge=false] whether to merge the data instead of
 * replacing it
 */
UCF_JSONModel["prototype"]["setJSON"] = function (sJSONText, bMerge) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["setJSON"]++; }; 
	/** @type {Object} */
	var oJSONData;

	try {
		oJSONData = UCF_JsUtil["oJsonParse"](sJSONText);
		this["setData"](oJSONData, bMerge);
	} catch (e) {
		alert(e["message"]);
		this["fireParseError"]({
			"url": '',
			"errorCode": -1,
			"reason": '',
			"srcText": e,
			"line": -1,
			"linepos": -1,
			"filepos": -1
		});
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["setJSON"] = 0; };

/**
 * Serializes the current JSON data of the model into a string.
 *
 * @public
 * @return {string} the JSON data serialized as string
 */
UCF_JSONModel["prototype"]["getJSON"] = function () {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getJSON"]++; }; 
	return UCF_JsUtil["sJsonStringify"](this["oData"]);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getJSON"] = 0; };

/**
 * Private method iterating the registered bindings of this model instance and
 * initiating their check for update
 *
 * @private
 * @param {boolean} bForceupdate
 * @param {string} sPath
 */
UCF_JSONModel["prototype"]["checkUpdate"] = function (bForceupdate, sPath) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["checkUpdate"]++; }; 
	/** @type {UCF_Binding[]} */
	var aBindings;

	if (this["oUI5Instance"]) {
		this["oUI5Instance"]["checkUpdate"](bForceupdate);
	}

	aBindings = this["aBindings"]["slice"](0);

	UCF_JsUtil["each"](aBindings, function (iIndex, oBinding) {
		if (!oBinding["bDestroyed"] && (!sPath || oBinding["getAbsolutePath"]()["indexOf"](sPath) === 0)) {
			if (oBinding["oContext"] && oBinding["oContext"]["bValid"] === false) {
				oBinding["oContext"]["setDataValidity"](true);
				//bForceupdate = true;
			}
			oBinding["checkUpdate"](bForceupdate);
		}
	});
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["checkUpdate"] = 0; };

/**
 * Adds a UI5 json model instance
 *
 * @private
 * @param {sap.ui.model.json.JSONModel} oInstance The UI5 instance
 */
UCF_JSONModel["prototype"]["addUI5Instance"] = function (oInstance) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["addUI5Instance"]++; }; 
	this["oUI5Instance"] = oInstance;
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["addUI5Instance"] = 0; };

/**
 * @see UCF_Model.prototype.bindProperty
 *
 * @private
 * @param {string} sPath
 * @param {UCF_BindingContext} oContext
 * @param {Object} mParameters
 * @return {UCF_JSONPropertyBinding} The property binding for the given path
 */
UCF_JSONModel["prototype"]["bindProperty"] = function (sPath, oContext, mParameters) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["bindProperty"]++; }; 
	return new (UCF_ClassLoader["oGetClass"]("UCF_JSONPropertyBinding"))(this, sPath, oContext, mParameters);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["bindProperty"] = 0; };

/**
 * @see UCF_Model.prototype.bindList
 *
 * @private
 * @param {string} sPath
 * @param {UCF_BindingContext} oContext
 * @param {UCF_ListBinding_Sorter} oSorter
 * @param {UCF_ListBinding_Filter[]} aFilters
 * @param {Object} mParameters
 * @return {UCF_JSONListBinding} The list binding for the given path
 */
UCF_JSONModel["prototype"]["bindList"] = function (sPath, oContext, oSorter, aFilters, mParameters) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["bindList"]++; }; 
	return new (UCF_ClassLoader["oGetClass"]("UCF_JSONListBinding"))(this, sPath, oContext, oSorter, aFilters, mParameters);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["bindList"] = 0; };

/**
 * @see UCF_Model.prototype.bindGrid
 * @private
 * @param {string} sPath
 * @param {UCF_BindingContext} oContext
 * @param {UCF_ListBinding_Sorter} oSorter
 * @param {UCF_ListBinding_Filter[]} aFilters
 * @param {Object} mParameters
 * @return {UCF_JSONGridBinding} The grid binding for the given path
 */
UCF_JSONModel["prototype"]["bindGrid"] = function (sPath, oContext, oSorter, aFilters, mParameters) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["bindGrid"]++; }; 
	return new (UCF_ClassLoader["oGetClass"]("UCF_JSONGridBinding"))(this, sPath, oContext, oSorter, aFilters, mParameters);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["bindGrid"] = 0; };

/**
 * @see UCF_Model.prototype.bindTree
 *
 * @private
 * @param {string} sPath
 * @param {UCF_BindingContext} oContext
 * @param {UCF_ListBinding_Filter[]} aFilters
 * @param {Object} [mParameters] additional model specific parameters. If the
 * mParameter <code>arrayNames</code> is specified with an array of string
 * names this names will be checked against the tree data structure and the
 * found data in this array is included in the tree but only if also the parent
 * array is included. If this parameter is not specified then all found arrays
 * in the data structure are bound. If the tree data structure doesn't contain
 * an array you don't have to specify this parameter.
 * @return {UCF_JSONTreeBinding} The property bind for the given path
 */
UCF_JSONModel["prototype"]["bindTree"] = function (sPath, oContext, aFilters, mParameters) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["bindTree"]++; }; 
	return UCF_JSONTreeBinding(this, sPath, oContext, aFilters, mParameters);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["bindTree"] = 0; };

/**
 * @see UCF_Model.prototype.createBindingContext
 * @private
 * @param {string} sPath
 * @param {UCF_BindingContext} [oContext]
 * @param {Object} [mParameters]
 * @param {function} fnCallBack
 */
UCF_JSONModel["prototype"]["createBindingContext"] = function (sPath, oContext, mParameters, fnCallBack) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["createBindingContext"]++; }; 
	/** @type {string} */
	var sContextPath;

	// optional parameter handling
	if (typeof oContext === 'function') {
		fnCallBack = oContext;
		oContext = null;
	}
	if (typeof mParameters === 'function') {
		fnCallBack = mParameters;
		mParameters = null;
	}

	// resolve path and create context
	sContextPath = this["resolve"](sPath, oContext);

	fnCallBack(sContextPath ? this["getContext"](sContextPath) : undefined);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["createBindingContext"] = 0; };

/**
 * @see UCF_Model.prototype.getContext
 * @private
 * @param {string} sPath
 * @param {boolean} bAvoidTemplated Whether contexts coming from template or
 * ranges should be avoided
 * @return {UCF_BindingContext} The binding context for the given path
 */
UCF_JSONModel["prototype"]["getContext"] = function (sPath, bAvoidTemplated) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getContext"]++; }; 
	/** @type {Object} */
	var oObject;

	if (bAvoidTemplated) {
		oObject = this["_getObject"](sPath, null, bAvoidTemplated);
		if (!oObject) {
			return null;
		}
	}

	return UCF_Model["prototype"]["getContext"]["apply"](this, [sPath]);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getContext"] = 0; };

/**
 * @see UCF_Model.prototype.destroyBindingContext
 * @param {UCF_BindingContext} oContext
 * @private
 */
UCF_JSONModel["prototype"]["destroyBindingContext"] = function (oContext) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["destroyBindingContext"]++; }; 
	// TODO: what todo here?
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["destroyBindingContext"] = 0; };

/** @override */
UCF_JSONModel["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["destroy"]++; }; 
	this["bCache"] = null;
	this["sId"] = null;
	this["oData"] = null;
	this["oUCFInstance"] = null;
	this["oUI5Instance"] = null;

	// initialize requestedRange cache
	if (window["UCF_JSONGridBinding"] && UCF_JSONGridBinding["mRequestedRangesMatrix"]) UCF_JSONGridBinding["mRequestedRangesMatrix"] = {};
	if (window["UCF_JSONListBinding"] && UCF_JSONListBinding["mRequestedRangesMatrix"]) UCF_JSONListBinding["mRequestedRangesMatrix"] = {};

	UCF_Model.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["destroy"] = 0; };

/**
 * Sets a new value for the given property <code>sPropertyName</code> in the
 * model. If the model value changed all interested parties are informed.
 *
 * @public
 * @param {string} sPath path of the property to set
 * @param {any} oValue value to set the property to
 * @param {UCF_BindingContext} [oContext] the context which will be used to set
 * the property
 */
UCF_JSONModel["prototype"]["setProperty"] = function (sPath, oValue, oContext) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["setProperty"]++; }; 
	/** @type {string} */
	var sObjectPath = sPath["substring"](0, sPath["lastIndexOf"]('/'));
	/** @type {string} */
	var sProperty = sPath["substr"](sPath["lastIndexOf"]('/') + 1);
	/** @type {Object} */
	var oObject = this["_getObject"](sObjectPath, oContext, true);

	if (!oObject || !(sProperty in oObject)) {
		if (oContext) {
			this["setPathData"](oContext["getPath"]() + '/' + sPath, oValue, false, true);
			this["fireDataChange"](sPath, oValue, oContext);
		} else {
			this["setPathData"](sPath, oValue, false, true);
			this["fireDataChange"](sPath, oValue, null);
		}

		return;
	}

	oObject[sProperty] = oValue;
	this["fireDataChange"](sPath, oValue, oContext);
	this["checkAllUpdates"]();
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["setProperty"] = 0; };

/**
 * Returns the value for the property with the given <code>sPropertyName</code>
 *
 * @public
 * @param {string} sPath the path to the property
 * @param {UCF_BindingContext} oContext  the context which will be used to
 * retrieve the property
 * @return {Object} the value of the property
 */
UCF_JSONModel["prototype"]["getProperty"] = function (sPath, oContext) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getProperty"]++; }; 
	return this["_getObject"](sPath, oContext);

};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getProperty"] = 0; };

/** @typedef {any} TODO */
/**
 * Returns a list of nodes that match the currently requested path. This is
 * used to retrieve the context for range and template nodes in the model. Here
 * the list of mathscing range nodes is returned and if any template nodes.
 * Also the original context node is returned in the array at position 0. All
 * dependent bindings (relative) have to walk the list to find the best match.
 * This is done in the _getObject method
 *
 * @private
 * @param {string} sPath the path of the node used for context.
 * @return {Object} The object for the given path
 */
UCF_JSONModel["prototype"]["_getObjectContext"] = function (sPath) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["_getObjectContext"]++; }; 
	/** @type {Object[]} */
	var aNodes = [];
	/** @type {Object} */
	var oNode = this["_getObject"](sPath, null, true);
	/** @type {TODO[]} */
	var aTemplates = [];
	/** @type {TODO[]} */
	var aRangeTemplates = [];
	/** @type {TODO[]} */
	var aRanges = [];
	/** @type {string} */
	var sCurrentPath = '';
	/** @type {string[]} */
	var aParts;
	/** @type {number} */
	var iIndex;
	/** @type {number} */
	var i;

	if (oNode) {
		aNodes["push"](oNode);
	}

	//collect all ranges and template nodes for the path
	aParts = sPath["split"]('/');
	iIndex = 0;

	if (!aParts[0]) {
		// absolute path starting with slash
		oNode = this["oData"];
		iIndex++;
	}

	while (oNode && aParts[iIndex]) {
		sCurrentPath += '/' + aParts[iIndex];
		oNode = oNode[aParts[iIndex]];
		if (
			aParts[iIndex + 1] &&
			(
				aParts[iIndex + 1]["indexOf"]('-') > -1 ||
				!isNaN(parseInt(aParts[iIndex + 1]))
			)
		) {
			aRanges = aRanges["concat"](this["getDataRangeObjects"](
				sCurrentPath + '/' + aParts[iIndex + 1],
				oNode,
				sCurrentPath,
				false
			));
			for (i = 0; i < aRanges["length"]; i++) {
				aRangeTemplates = aRangeTemplates["concat"](this["getDataTemplateObjects"](
					sCurrentPath + '/__ranges/' + i,
					aRanges[i],
					true
				));
			}
		}
		aTemplates = aTemplates["concat"](
			this["getDataTemplateObjects"](sCurrentPath, oNode, false)
		);
		iIndex++;
	}
	if (aRanges["length"] === 0 && aTemplates["length"] === 0 && aNodes["length"] === 0) {
		return null;
	}
	aRanges = aRanges["reverse"]();
	aRanges = aRanges["concat"](aRangeTemplates);
	aRanges = aRanges["concat"](aTemplates["reverse"]());

	return aNodes["concat"](aRanges);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["_getObjectContext"] = 0; };

/**
 * Returns the data node of the given path
 * @param {string} sPath the path to the object
 * @param {string|UCF_BindingContext} oContext the context of the path if
 * relative
 * @param {boolean} [bAvoidTemplated] if templates should not be taken into
 * account
 * @return {Object} the node of the specified path/context
 * @private
 */
UCF_JSONModel["prototype"]["_getObject"] = function (sPath, oContext, bAvoidTemplated) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["_getObject"]++; };  //eslint-disable-line complexity
	/** @type {Object} */
	var oNode = this["isLegacySyntax"]() ? this["oData"] : null;
	// if path = null context must be respected as well: we handle this as
	// relative here
	/** @type {string} */
	var sCurrentPath = '';
	/** @type {boolean} */
	var bIsRelative = sPath && UCF_StringUtil["bStartsWith"](sPath, '/') ? false : true;
	/** @type {Object[]} */
	var aContextNodes = [];
	/** @type {number} */
	var iCurrentIndex;
	/** @type {number} */
	var i = 0;
	/** @type {string[]} */
	var aParts;
	/** @type {number} */
	var iIndex;
	/** @type {number} */
	var iIndexTemplate;
	/** @type {Object} */
	var oCurrentNode;

	if (bIsRelative && !oContext) {
		return null;
	}

	if (oContext instanceof UCF_BindingContext && bIsRelative) {
		sCurrentPath = oContext["getPath"]();
		if (bAvoidTemplated) {
			oNode = this["_getObject"](sCurrentPath, null, bAvoidTemplated);
		} else {
			oNode = this["_getObjectContext"](sCurrentPath);
		}
	} else if (oContext && bIsRelative) {
		oNode = oContext;
	}

	if (!sPath) {
		return oNode;
	}

	aParts = sPath["split"]('/');
	iIndex = 0;

	if (!aParts[0]) {
		// absolute path starting with slash
		oNode = this["oData"];
		iIndex++;
	}

	if (UCF_JsUtil["bIsArray"](oNode) && bIsRelative && !bAvoidTemplated) {
		aContextNodes = oNode;
		iCurrentIndex = iIndex;

		for (i = 0; i < aContextNodes["length"]; i++) {
			oNode = aContextNodes[i];
			iIndexTemplate = iCurrentIndex;

			while (oNode && aParts[iIndexTemplate]) {
				oNode = oNode[aParts[iIndexTemplate]];
				iIndexTemplate++;
			}
			if (
				oNode ||
				typeof oNode === 'string' ||
				typeof oNode === 'boolean' ||
				typeof oNode === 'number'
			) {
				return oNode;
			}
		}
	}

	// search the node in the real path
	while (oNode && aParts[iIndex]) {
		sCurrentPath += '/' + aParts[iIndex];
		oCurrentNode = oNode;
		oNode = oNode[aParts[iIndex]];
		if (oNode === null || typeof oNode === 'undefined' && oCurrentNode['1']) {
			oNode = oCurrentNode['1'][aParts[iIndex]];
		}
		iIndex++;
	}

	// if not found search also in the ranges and templates for absolute paths
	if (
		aParts[iIndex - 1] &&
		!oNode &&
		typeof oNode !== 'string' &&
		typeof oNode !== 'boolean' &&
		typeof oNode !== 'number' &&
		!bAvoidTemplated
	) {
		if (sCurrentPath !== '') {
			aContextNodes = this["_getObjectContext"](sCurrentPath);
			if (aContextNodes) {
				for (i = 0; i < aContextNodes["length"]; i++) {
					oNode = aContextNodes[i][aParts[iIndex - 1]];
					if (
						oNode ||
						typeof oNode === 'string' ||
						typeof oNode === 'boolean' ||
						typeof oNode === 'number'
					) {
						return oNode;
					}
				}
			}
		}
	}

	if (
		aParts[iIndex] &&
		!oNode &&
		typeof oNode !== 'string' &&
		typeof oNode !== 'boolean' &&
		typeof oNode !== 'number' &&
		!bAvoidTemplated
	) {
		if (sCurrentPath !== '') {
			aContextNodes = this["_getObjectContext"](sCurrentPath);
			if (aContextNodes) {
				for (i = 0; i < aContextNodes["length"]; i++) {
					oNode = aContextNodes[i][aParts[iIndex]];
					if (
						oNode ||
						typeof oNode === 'string' ||
						typeof oNode === 'boolean' ||
						typeof oNode === 'number'
					) {
						return oNode;
					}
				}
			}
		}
	}

	return oNode;
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["_getObject"] = 0; };

/**
 * Returns all range objects that match the current path sPath. Ranges are
 * taken from the given sRangePath
 *
 * @private
 * @param {string} sPath the path to match a range
 * @param {Object} oNode the node of where the ranges are defined
 * @param {string} sRangePath the path where the range is defined.
 * @return {Object} The data ranges objects that matcht the path
 */
UCF_JSONModel["prototype"]["getDataRangeObjects"] = function (sPath, oNode, sRangePath) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getDataRangeObjects"]++; }; 
	/** @type {Object[]} */
	var aNodes = [];
	/** @type {function[]} */
	var aRangeFunctions = [];
	/** @type {number} */
	var i = 0;
	/** @type {Object[]} */
	var aRanges;
	/** @type {Object[]} */
	var aRangeArray;
	/** @type {string} */
	var n;
	/** @type {Object} */
	var oRangeDefinition;
	/** @type {function} */
	var fRangeFunction;

	if (oNode && oNode["__ranges"]) {
		aRanges = oNode["__ranges"];

		if (!this["mRangeFunctions"][sRangePath]) {
			if (typeof aRanges === 'object' && !aRanges["length"]) {
				aRangeArray = [];
				for (n in aRanges) {
					aRangeArray[parseInt(n)] = aRanges[n];
				}
				aRanges = aRangeArray;
			}

			aRangeFunctions = [];

			for (i = 0; i < aRanges["length"]; i++) {
				oRangeDefinition = aRanges[i];

				if (oRangeDefinition) { // eslint-disable-line max-depth
					fRangeFunction = this["createRangeFunction"](oRangeDefinition);

					if (fRangeFunction) { // eslint-disable-line max-depth
						aRangeFunctions["push"](fRangeFunction);
					}
				}
			}
			this["mRangeFunctions"][sRangePath] = aRangeFunctions;
		}

		aRangeFunctions = this["mRangeFunctions"][sRangePath];
		for (i = 0; i < aRangeFunctions["length"]; i++) {
			oNode = aRangeFunctions[i](sPath);
			if (oNode) {
				aNodes["push"](oNode);
			}
		}
	}

	return aNodes;
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getDataRangeObjects"] = 0; };

/**
 * @private
 * @param {Object} oRangeDefinition
 * @return {function(string): Object}
 */
UCF_JSONModel["prototype"]["createRangeFunction"] = function (oRangeDefinition) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["createRangeFunction"]++; }; 
	/** @type {string} */
	var sMatchString;
	/** @type {Object} */
	var oRangeResultNode;
	/** @type {function(string):boolean} */
	var aFunctions;

	for (sMatchString in oRangeDefinition) {
		oRangeResultNode = oRangeDefinition[sMatchString];
		break;
	}

	aFunctions = UCF_JsUtil["map"](sMatchString["split"]('+'), function (sPart) {
		/** @type {(number|string)[]} */
		var aTuple = UCF_JsUtil["map"](
			UCF_StringUtil["bContains"](sPart, '-') ? sPart["split"]('-') : [sPart],
			function (sTuple) {
				return UCF_JsUtil["map"](sTuple["split"](','), function (sEntry) {
					/** @type {number} */
					var iEntry;

					sEntry = sEntry["replace"](/[\[\]]/g, '');
					iEntry = parseInt(sEntry);

					return isNaN(iEntry) ? sEntry : iEntry;
				});
			}
		);
		/** @type {(number|string)[]} */
		var aMin = aTuple[0];
		/** @type {number} */
		var iMinX = aMin && aMin[0];
		/** @type {number} */
		var iMinY = aMin && aMin[1];
		/** @type {(number|string)[]} */
		var aMax = aTuple[1];
		/** @type {number} */
		var iMaxX = aMax && aMax[0];
		/** @type {number} */
		var iMaxY = aMax && aMax[1];
		/** @type {(function(number,number):boolean)[]} */
		var aMatchers = [];

		if (!isNaN(iMinX)) {
			aMatchers["push"](function (iX) { return iX >= iMinX; });
		}
		if (!isNaN(iMinY)) {
			aMatchers["push"](function (_, iY) { return iY >= iMinY; });
		}
		if (!isNaN(iMaxX)) {
			aMatchers["push"](function (iX) { return iX <= iMaxX; });
		}
		if (!isNaN(iMaxY)) {
			aMatchers["push"](function (_, iY) { return iY <= iMaxY; });
		}
		if (typeof iMinY !== typeof iMaxY) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Invalid part "' + sPart + '" in range "' + sMatchString + '". Either both minY and maxY or none of them must be defined. Nothing will match this range. Did you mean "' + iMinX + '-' + iMaxX + '"?', "JSONModel.js(893): createRangeFunction"); };
			aMatchers["push"](function () { return false; });
		}

		return function (sPath) {
			/** @type {string[]} */
			var aNumbers = sPath["split"]('-');
			/** @type {number} */
			var iX = parseInt(aNumbers[0]);
			/** @type {number} */
			var iY = parseInt(aNumbers[1]);

			return UCF_JsUtil["every"](aMatchers, function (f) { return f(iX, iY); });
		};
	});

	return function (sPath) {
		/** @type {string} */
		var sMatchPath = sPath["substring"](sPath["lastIndexOf"]('/') + 1);

		return UCF_JsUtil["some"](aFunctions, function (f) { return f(sMatchPath); })
			? oRangeResultNode
			: null;
	};
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["createRangeFunction"] = 0; };

/**
 * Returns a list of nodes that are used as a template for the given path.
 *
 * @private
 * @param {string} sPath the path to the target node.
 * @param {Object} oNode the node where the template is stored
 * @param {boolean} bForceUpdate the node where the template is stored
 * @return {Object[]} template nodes.
 */
UCF_JSONModel["prototype"]["getDataTemplateObjects"] = function (sPath, oNode, bForceUpdate) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getDataTemplateObjects"]++; }; 
	/** @type {Object[]} */
	var aTemplateData;
	/** @type {Object[]} */
	var aTemplates;
	/** @type {number} */
	var i;
	/** @type {string} */
	var sTemplatePath;
	/** @type {Object} */
	var oTemplateNode;

	if (this["mDataTemplatesByDataPath"][sPath] && !bForceUpdate) {
		return this["mDataTemplatesByDataPath"][sPath];
	}

	aTemplateData = [];

	if (oNode && oNode["__templates"]) {
		aTemplates = oNode["__templates"];

		for (i = 0; i < aTemplates["length"]; i++) {
			sTemplatePath = aTemplates[i];
			oTemplateNode = this["_getObject"](sTemplatePath, null, true);

			if (oTemplateNode) {
				aTemplateData["push"](oTemplateNode);
			}
			if (!this["mDataTemplates"][sTemplatePath]) {
				this["mDataTemplates"][sTemplatePath] = {
					"node": oTemplateNode,
					"paths": {}
				};
			}
			if (!this["mDataTemplates"][sTemplatePath]["paths"][sPath]) {
				this["mDataTemplates"][sTemplatePath]["paths"][sPath] = oNode;
			}
		}
	}
	if (aTemplateData["length"] > 0) {
		this["mDataTemplatesByDataPath"][sPath] = aTemplateData;
	}

	return aTemplateData;
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getDataTemplateObjects"] = 0; };

/**
 * Propagate all bindings to the data nodes that belong to templates that
 * changed
 *
 * @private
 */
UCF_JSONModel["prototype"]["checkTemplateUpdates"] = function () {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["checkTemplateUpdates"]++; }; 
	/** @type {string} */
	var sPath;
	/** @type {Object} */
	var oNewNode;
	/** @type {Object} */
	var oOldNode;
	/** @type {Object<string, Object>} */
	var mDataNodePaths;
	/** @type {string} */
	var sDataNodePath;

	for (sPath in this["mDataTemplates"]) {
		oNewNode = this["_getObject"](sPath);
		oOldNode = this["mDataTemplates"][sPath]["node"];

		if (oNewNode !== oOldNode) {
			mDataNodePaths = this["mDataTemplates"][sPath]["paths"];

			for (sDataNodePath in mDataNodePaths) {
				this["getDataTemplateObjects"](
					sDataNodePath,
					mDataNodePaths[sDataNodePath],
					true
				);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["checkTemplateUpdates"] = 0; };

/**
 * Propagate all bindings to the data nodes that belong to a range that changed
 *
 * @private
 */
UCF_JSONModel["prototype"]["checkRangeUpdates"] = function () {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["checkRangeUpdates"]++; }; 
	/** @type {string} */
	var n;

	for (n in this["mRangeFunctions"]) {
		delete this["mRangeFunctions"][n];
	}
	this["mRangeFunctions"] = {};
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["checkRangeUpdates"] = 0; };

/**
 * update all bindings
 *
 * @public
 * @param {boolean} [bForceUpdate=false] If set to false an update will only be
 * done when the value of a binding changed.
 */
UCF_JSONModel["prototype"]["updateBindings"] = function (bForceUpdate) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["updateBindings"]++; }; 
	this["checkUpdate"](bForceUpdate);
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["updateBindings"] = 0; };

/**
 * Force no caching
 *
 * @public
 * @param {boolean} [bForceNoCache=true] force no cache
 */
UCF_JSONModel["prototype"]["forceNoCache"] = function (bForceNoCache) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["forceNoCache"]++; }; 
	this["bCache"] = !bForceNoCache;
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["forceNoCache"] = 0; };

/**
 * Sets the UCF Instance for the JSONModel that handles the events.
 *
 * @private
 * @param {UCF_Instance} oInstance UCF Instance for the JSONModel that handles
 * the events
 */
UCF_JSONModel["prototype"]["setUCFInstance"] = function (oInstance) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["setUCFInstance"]++; }; 
	this["oUCFInstance"] = oInstance;
	this["sId"] = this["oUCFInstance"]["sId"];
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["setUCFInstance"] = 0; };

/**
 * Fires the data change event for a given path and sets the new value
 *
 * @private
 * @param {string} sPath the path to the target node.
 * @param {Object} oValue
 * @param {UCF_BindingContext} oContext
 */
UCF_JSONModel["prototype"]["fireDataChange"] = function (sPath, oValue, oContext) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["fireDataChange"]++; }; 
	/** @type {string} */
	var sId;

	if (this["oUCFInstance"]) {
		sId = this["oUCFInstance"]["sId"];

		// publish the current the grid data
		this["publishGridContext"]();

		// add data update to queue
		if (oContext) {
			sPath = (typeof oContext === 'string'
				? oContext
				: oContext["sPath"]) + '/' + sPath;
		}

		if (typeof oValue === 'number') {
			oValue += '';
		}

		if (sPath) {
			this["oUCFInstance"]["fireDataChange"](sId, sPath, oValue);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["fireDataChange"] = 0; };

/**
 * Publishes the current grid context
 *
 * @private
 */
UCF_JSONModel["prototype"]["publishGridContext"] = function () {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["publishGridContext"]++; }; 
	/** @type {string} */
	var sId;
	/** @type {number} */
	var i;
	/** @type {UCF_Binding} */
	var oBinding;
	/** @type {string} */
	var sCompletePath;
	/** @type {Object} */
	var oRange;

	if (this["oUCFInstance"]) {
		sId = this["oUCFInstance"]["sId"];

		for (i = 0; i < this["aBindings"]; i++) {
			oBinding = this["aBindings"][i];

			if (oBinding instanceof UCF_JSONGridBinding) {
				sCompletePath = oBinding["getContext"]() + oBinding["getPath"]();
				// add all grid binding info to the queue
				oRange = oBinding["getCurrentRange"]();

				this["oUCFInstance"]["fireUpdateGrid"](
					sId,
					sCompletePath,
					'UPDATE',
					oRange["iStartX"],
					oRange["iStartY"],
					oRange["iEndX"],
					oRange["iEndY"]
				);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["publishGridContext"] = 0; };

/**
 * Fires the updateGrid event on the UCF control for the given binding with the
 * given operation
 *
 * @private
 * @param {UCF_JSONGridBinding} oGridBinding The Grid Binding to
 * @param {UCF_JSONGridBinding_Range} oRange a range object with iStartX,iStartX,iEndX,iEndY content
 * @param {'GET'|'UPDATE'|'DELETE'} sOperation The operation sent to the server
 */
UCF_JSONModel["prototype"]["fireGridUpdate"] = function (oGridBinding, oRange, sOperation) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["fireGridUpdate"]++; }; 
	/** @type {string} */
	var sId;

	if (this["oUCFInstance"]) {
		sId = this["oUCFInstance"]["sId"];
		this["publishGridContext"]();

		if (
			oGridBinding &&
			oGridBinding instanceof UCF_JSONGridBinding
		) {
			if (sOperation === 'DELETE') {
				this["oUCFInstance"]["fireUpdateGrid"](
					sId,
					oGridBinding["sPath"],
					sOperation,
					oRange["iStartX"],
					oRange["iStartY"],
					oRange["iEndX"],
					oRange["iEndY"]
				);
			}
			if (sOperation === 'GET') {
				this["oUCFInstance"]["_fireGetGrid"](
					sId,
					oGridBinding["sPath"],
					oRange["iStartX"],
					oRange["iStartY"],
					oRange["iEndX"],
					oRange["iEndY"]
				);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["fireGridUpdate"] = 0; };

/**
 * Publishes the list context to inform the server about the
 * currently visible list nodes
 *
 * @see {@link UCF_ModelControl}
 * @private
 */
UCF_JSONModel["prototype"]["publishListContext"] = function () {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["publishListContext"]++; }; 
	/** @type {string} */
	var sId;
	/** @type {number} */
	var i;
	/** @type {UCF_JSONListBinding} */
	var oBinding;
	/** @type {string} */
	var sCompletePath;

	if (this["oUCFInstance"]) {
		sId = this["oUCFInstance"]["sId"];

		for (i = 0; i < this["aBindings"]; i++) {
			oBinding = this["aBindings"][i];

			if (oBinding instanceof UCF_JSONListBinding) {
				sCompletePath = oBinding["getContext"]() + oBinding["getPath"]();
				// add all grid binding info to the queue
				this["oUCFInstance"]["fireUpdateList"](
					sId,
					sCompletePath,
					'UPDATE',
					oBinding["iStart"],
					oBinding["iLength"]
				);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["publishListContext"] = 0; };

/**
 * Fires the updateList event on the UCF control for the given binding with the
 * given operation
 *
 * @private
 * @param {UCF_JSONListBinding} oListBinding The Grid Binding to
 * @param {UCF_JSONListBinding_Range} oRange
 * @param {'GET'|'UPDATE'|'DELETE'} sOperation The operation sent to the server
 */
UCF_JSONModel["prototype"]["fireListUpdate"] = function (oListBinding, oRange, sOperation) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["fireListUpdate"]++; }; 
	/** @type {string} */
	var sId;

	if (this["oUCFInstance"]) {
		sId = this["oUCFInstance"]["sId"];
		this["publishListContext"]();

		if (
			oListBinding &&
			oListBinding instanceof UCF_JSONListBinding &&
			(sOperation === 'GET' || sOperation === 'DELETE')
		) {
			this["oUCFInstance"]["fireUpdateList"](
				sId,
				oListBinding["sPath"],
				sOperation,
				oRange["iStart"],
				oRange["iEnd"] - oRange["iStart"]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["fireListUpdate"] = 0; };

/**
 * Fires the updateGridSelection event on the UCF control for the given binding
 * with the given operation
 *
 * @private
 * @param {UCF_JSONListBinding} oGridBinding The Grid Binding to
 * @param {UCF_JSONGridBinding_Range} oObject The range object for the selected
 * range
 * @param {0|1|2} iState the state of the selection where 0 is not selected,
 * 1 primary selected, 2 secondary selected
 */
UCF_JSONModel["prototype"]["fireGridSelectionUpdate"] = function (oGridBinding, oObject, iState) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["fireGridSelectionUpdate"]++; }; 
	/** @type {string} */
	var sId;

	if (this["oUCFInstance"]) {
		sId = this["oUCFInstance"]["sId"];
		this["publishGridContext"]();

		if (oGridBinding && oGridBinding instanceof UCF_JSONGridBinding) {
			if (typeof oObject === 'string') {
				this["oUCFInstance"]["fireUpdateSelection"](sId, oObject, iState);
			} else {
				this["oUCFInstance"]["fireUpdateGridSelection"](
					sId,
					oGridBinding["sPath"],
					oObject["iStartX"] + '',
					oObject["iStartY"] + '',
					oObject["iEndX"] + '',
					oObject["iEndY"] + '', iState
				);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["fireGridSelectionUpdate"] = 0; };

/**
 * Returns the controls that are bound  to a specific path
 * @private
 * @param {string} sPath the path where the control is bound to
 * @return {UCF_Control[]} the controls that match this binding path
 */
UCF_JSONModel["prototype"]["getControlsByBindingPath"] = function (sPath) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getControlsByBindingPath"]++; }; 
	/** @type {UCF_Control[]} */
	var aResult = [];
	/** @type {number} */
	var i;
	/** @type {string} */
	var sBindingPath;

	for (i = 0; i < this["aBindings"]; i++) {
		sBindingPath = this["aBindings"][i]["getAbsolutePath"]();

		if (sBindingPath === sPath) {
			aResult["push"](this["aBindings"][i]["getControl"]());
		}
	}

	return aResult;
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getControlsByBindingPath"] = 0; };

/** @see UCF_Model.prototype.unlock */
UCF_JSONModel["prototype"]["unlock"] = function () {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["unlock"]++; }; 
	/** @type {number} */
	var i;

	if (this["bDataUpdate"]) {
		this["checkAllUpdates"]();
	} else {
		for (i = 0; i < this["aUpdatePaths"]["length"]; i++) {
			this["checkAllUpdates"](this["aUpdatePaths"][i]);
		}
	}

	this["bDataUpdate"] = false;
	this["aUpdatePaths"] = [];
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["unlock"] = 0; };

/**
 * Registers the default types String, Integer, Float, Boolean and Map
 * The default types are handling the formatting and validation of bound values
 * for simple types. The Server can enhance the type using registerDataType
 * method
 *
 * @see {UCF_JSONModel.prototype.registerDataType}
 * @private
 */
UCF_JSONModel["registerDefaultTypes"] = function () {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["registerDefaultTypes"]++; }; 
	if (!UCF_JSONModel["mDataTypeImplementation"]) {
		UCF_JSONModel["mDataTypeImplementation"] = {};
		UCF_JSONModel["registerDataType"]('Map', null, {}, 'UCF_MapType');
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["registerDefaultTypes"] = 0; };

/**
 * Returns the data type class for a given name
 * The data type is always inherited from UCF_SimpleType
 *
 * @private
 * @param {string} sName the name of the type as registered
 * @return {UCF_SimpleType} the data type class for a given name
 */
UCF_JSONModel["getDataType"] = function (sName) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getDataType"]++; }; 
	UCF_JSONModel["registerDefaultTypes"]();

	return UCF_JSONModel["mDataTypeImplementation"][sName] || null;
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["getDataType"] = 0; };

/**
 * Registers a data type
 *
 * @see {@link UCF_LS#registerMapDataType}
 * @see {@link UCF_LS#registerCustomDataType}
 * for convenience implementations
 *
 * @public
 * @template U
 * @template {U} V
 * @param {string} sTypeName the name of the type
 * @param {string} sBaseClass the name of the type that should be used as a
 * base class for the new type in case of oDefaultConfiguration
 * @param {Object} oDefaultConfiguratation the default configuration for an
 * inherited type
 * @param {string} sImplementationUrl the implementation url of a new type
 * baseclass and defaultConfiguration is ignored.
 */
UCF_JSONModel["registerDataType"] = function (sTypeName, sBaseClass, oDefaultConfiguratation, sImplementationUrl) {;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["registerDataType"]++; }; 
	/** @type {function(new: V)} */
	var oClass;
	/** @type {function(new: U)} */
	var oBaseClass;
	/** @type {V} */
	var oInstance;

	if (!UCF_JSONModel["mDataTypeImplementation"]) {
		UCF_JSONModel["mDataTypeImplementation"] = {};
		UCF_JSONModel["registerDataType"]('Map', null, {}, 'UCF_MapType');
	}

	//the same type already exists or was already registered
	oClass = UCF_JSONModel["mDataTypeImplementation"][sTypeName];
	if (oClass) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Class already registered for type: ' + sTypeName, "JSONModel.js(1394): registerDataType"); };

		return;
	}

	oBaseClass = null;
	if (sBaseClass) {
		//load the clase class
		oBaseClass = UCF_JSONModel["mDataTypeImplementation"][sBaseClass];
		if (!oBaseClass) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'A class with the name ' + sBaseClass + ' does not exist and cannot be used as a base class', "JSONModel.js(1404): registerDataType"); };

			return;
		}
	}

	if (oBaseClass && !sImplementationUrl && oDefaultConfiguratation) {
		if (!oBaseClass["createNewType"]) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Cannot derive from ' + oBaseClass["sName"] + '. This type does not allow inheritance', "JSONModel.js(1412): registerDataType"); };
		}
		//dynamically create a new type by factory of existing type with a given default config oDefaultConfiguratation
		UCF_JSONModel["mDataTypeImplementation"][sTypeName] = oBaseClass["createNewType"](
			'UCF_CustomType' + sTypeName,
			oDefaultConfiguratation
		);
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'DataType ' + sTypeName + ' created based on ' + sBaseClass, "JSONModel.js(1419): registerDataType"); };

		return;
	}

	oClass = null;
	if (!sImplementationUrl || !sImplementationUrl["indexOf"]('UCF_') === 0) {
		oClass = UCF_ClassLoader["oGetLoadedClass"](sTypeName);
	}
	if (!oClass && sTypeName && sImplementationUrl) {
		if (sImplementationUrl["indexOf"]('UCF_') === 0) {
			// new type with a new implementation from file
			oClass = UCF_ClassLoader["oGetClass"](sImplementationUrl, null, true);
		} else {
			oClass = UCF_ClassLoader["oGetClass"](sTypeName, sImplementationUrl, true);
		}
	}

	if (oClass) {
		oInstance = new oClass();
		if (oInstance["sName"] === sTypeName && oInstance instanceof UCF_SimpleType) {
			UCF_JSONModel["mDataTypeImplementation"][sTypeName] = oClass;
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'typename differs or loaded class is not of type UCF_SimpleType', "JSONModel.js(1442): registerDataType"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONModel["_"]["registerDataType"] = 0; };

UCF_JSONModel.prototype["aPublicMethods"] = ["UCF_JSONModel","setData","getData","setJSON","getJSON","setProperty","getProperty","updateBindings","forceNoCache","registerDataType"].concat(UCF_JSONModel.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_JSONPropertyBinding"] = function() {/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_PropertyBinding */
/// <reference path="../PropertyBinding.js"/>

/**
 * Property binding implementation for JSON format
 * @class
 * @template T
 * @param {UCF_Model} oModel
 * @param {string} sPath
 * @param {UCF_BindingContext} oContext
 */
function UCF_JSONPropertyBinding(oModel, sPath, oContext) {if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["UCF_JSONPropertyBinding"]++; }; 
	if (arguments["length"] > 0) {
		UCF_PropertyBinding["apply"](this, arguments);

		/** @type {T} */
		this["oValue"] = this["_getValue"]();
		/** @type {'UCF_JSONPropertyBinding'} */
		this["sClassName"] = 'UCF_JSONPropertyBinding';
	}
};window["UCF_JSONPropertyBinding"] = UCF_JSONPropertyBinding; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_JSONPropertyBinding"); UCF_JSONPropertyBinding["_"] = {UCF_JSONPropertyBinding: 0}; }; ;
UCF_JSONPropertyBinding["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PropertyBinding"))(); UCF_JSONPropertyBinding.prototype["sClassName"] = "UCF_JSONPropertyBinding";

/** @override */
UCF_JSONPropertyBinding["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["destroy"]++; }; 
	this["oValue"] = null;

	UCF_PropertyBinding.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["destroy"] = 0; };

/**
 * @see UCF_PropertyBinding.prototype.getValue
 * @return {T}
 */
UCF_JSONPropertyBinding["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["getValue"]++; }; 
	return this["oValue"];
};;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["getValue"] = 0; };

/**
 * Returns the current value of the bound target (incl. re-evaluation)
 * @return {T} the current value of the bound target
 */
UCF_JSONPropertyBinding["prototype"]["_getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["_getValue"]++; }; 
	/** @type {string} */
	var sProperty = this["sPath"]["substr"](this["sPath"]["lastIndexOf"]('/') + 1);
	/** @type {string[]} */
	var aPath;

	if (sProperty === '__name__') {
		aPath = this["oContext"]["split"]('/');

		return aPath[aPath["length"] - 1];
	}

	// ensure to survive also not set model object
	return this["oModel"]["_getObject"](this["sPath"], this["oContext"]);
};;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["_getValue"] = 0; };

/**
 * @see UCF_PropertyBinding.prototype.setValue
 * @param {T} oValue
 */
UCF_JSONPropertyBinding["prototype"]["setValue"] = function(oValue) {;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["setValue"]++; }; 
	if (!UCF_JsUtil["bEqual"](this["oValue"], oValue)) {
		this["oValue"] = oValue;
		this["oModel"]["setProperty"](this["sPath"], oValue, this["oContext"]);
	}
};;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["setValue"] = 0; };

/**
 * Setter for context
 * @param {UCF_BindingContext} oContext
 */
UCF_JSONPropertyBinding["prototype"]["setContext"] = function(oContext) {;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["setContext"]++; }; 
	this["oContext"] = oContext;
	this["checkUpdate"]();
};;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["setContext"] = 0; };

/**
 * Check whether this Binding would provide new values and in case it changed,
 * inform interested parties about this.
 *
 * @param {boolean} bForceupdate
 * @return {boolean}
 *
 */
UCF_JSONPropertyBinding["prototype"]["checkUpdate"] = function(bForceupdate) {;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["checkUpdate"]++; }; 
	/** @type {T} */
	var oValue = this["_getValue"]();

	// optimize for not firing the events when unneeded
	if (!UCF_JsUtil["bEqual"](oValue, this["oValue"]) || bForceupdate) {
		this["oValue"] = oValue;
		this["_fireChange"]();

		return true;
	}
};;if (__UCF_COVERAGE__) { UCF_JSONPropertyBinding["_"]["checkUpdate"] = 0; };

};
sap["ls"]["preload"]["UCF_JSONTreeBinding"] = function() {/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_BindingContext */
/// <reference path="../BindingContext.js"/>
/* global UCF_TreeBinding */
/// <reference path="../TreeBinding.js"/>

/**
 * @typedef {Object} UCF_JSONTreeBinding_FilterInfo
 * @param {Array} aFilteredContexts
 * @param {UCF_BindingContext} oParentContext
 */

/**
 * Tree binding implementation for JSON format.
 *
 * The tree data structure may contain JSON objects and also arrays. If using
 * arrays and don't want to bind every array data in the data structure you can
 * specify a parameter <code>arrayNames</code> in the mParameters which
 * contains the names of the arrays in a string array which should be bound for
 * the tree. An array not included there won't be bound. If an array is
 * included but it is nested in another parent array which isn't included in
 * the names list it won't be bound. So make sure that the parent array name is
 * also included. If the tree data structure doesn't include any arrays you
 * don't have to specify this parameter at all.
 *
 * @class
 * @param {UCF_Model} oModel
 * @param {string} sPath the path pointing to the tree/array that should be
 * bound
 * @param {UCF_BindingContext} [oContext] the context object for this
 * databinding
 * @param {UCF_ListBinding_Filter[]} [aFilters] predefined filter/s contained
 * in an array
 * @param {Object} [mParameters] additional model specific parameters. If the
 * mParameter <code>arrayNames</code> is specified with an array of string
 * names this names will be checked against the tree data structure and the
 * found data in this array is included in the tree but only if also the parent
 * array is included. If this parameter is not specified then all found arrays
 * in the data structure are bound. If the tree data structure doesn't contain
 * an array you don't have to specify this parameter.
 */
function UCF_JSONTreeBinding(oModel, sPath, oContext, aFilters, mParameters) {if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["UCF_JSONTreeBinding"]++; }; 
	if (arguments["length"] > 0) {
		UCF_TreeBinding["apply"](this, arguments);
		if (!this["oContext"]) {
			/** @type {UCF_BindingContext} */
			this["oContext"] = '';
		}
		/** @type {UCF_JSONTreeBinding_FilterInfo} */
		this["filterInfo"] = {
			"aFilteredContexts": [],
			"oParentContext": {}
		};
	}
};window["UCF_JSONTreeBinding"] = UCF_JSONTreeBinding; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_JSONTreeBinding"); UCF_JSONTreeBinding["_"] = {UCF_JSONTreeBinding: 0}; }; ;
UCF_JSONTreeBinding["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_TreeBinding"))(); UCF_JSONTreeBinding.prototype["sClassName"] = "UCF_JSONTreeBinding";

/**
 * Return root contexts for the tree
 *
 * @return {Array} the contexts array
 * @protected
 */
UCF_JSONTreeBinding["prototype"]["getRootContexts"] = function() {;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["getRootContexts"]++; }; 
	/** @type {UCF_BindingContext} */
	var oContext = this["oModel"]["getContext"](this["sPath"]);

	return this["getNodeContexts"](oContext);
};;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["getRootContexts"] = 0; };

/**
 * Return node contexts for the tree
 * @protected
 * @param {UCF_BindingContext} oContext to use for retrieving the node contexts
 * @return {UCF_BindingContext[]} the contexts array
 */
UCF_JSONTreeBinding["prototype"]["getNodeContexts"] = function(oContext) {;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["getNodeContexts"]++; }; 
	/** @type {string} */
	var sContextPath = oContext["getPath"]();
	/** @type {UCF_BindingContext[]} */
	var aContexts = [];
	/** @type {UCF_JSONTreeBinding} */
	var self = this;
	/** @type {Object} */
	var oNode;
	/** @type {string[]} */
	var aArrayNames = this["mParameters"] && this["mParameters"]["arrayNames"];

	if (!UCF_StringUtil["bEndssWith"](sContextPath, '/')) {
		sContextPath = sContextPath + '/';
	}
	if (!UCF_StringUtil["bStartsWith"](sContextPath, '/')) {
		sContextPath = '/' + sContextPath;
	}

	oNode = this["oModel"]["_getObject"](sContextPath);

	if (aArrayNames && UCF_JsUtil["bIsArray"](aArrayNames)) {
		UCF_JsUtil["forEach"](aArrayNames, function(sArrayName) {
			/** @type {Object} */
			var oChild = oNode[sArrayName];

			if (oChild) {
				UCF_JsUtil["each"](oChild, function(sSubName, oSubChild) {
					self["_saveSubContext"](
						oSubChild,
						aContexts,
						sContextPath,
						sArrayName + '/' + sSubName
					);
				});
			}
		});
	} else {
		UCF_JsUtil["each"](oNode, function(sName, oChild) {
			if (UCF_JsUtil["bIsArray"](oChild)) {
				UCF_JsUtil["each"](oChild, function(sSubName, oSubChild) {
					self["_saveSubContext"](oSubChild, aContexts, sContextPath, sName + '/' + sSubName);
				});
			} else if (typeof oChild === 'object') {
				self["_saveSubContext"](oChild, aContexts, sContextPath, sName);
			}
		});
	}

	return aContexts;
};;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["getNodeContexts"] = 0; };

/**
 * @private
 * @param {Object} oNode
 * @param {UCF_BindingContext[]} aContexts
 * @param {string} sContextPath
 * @param {string} sName
 */
UCF_JSONTreeBinding["prototype"]["_saveSubContext"] = function(oNode, aContexts, sContextPath, sName) {;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["_saveSubContext"]++; }; 
	/** @type {UCF_BindingContext} */
	var oNodeContext;

	if (typeof oNode === 'object') {
		oNodeContext = this["oModel"]["getContext"](sContextPath + sName);
		// check if there is a filter on this level applied
		if (this["aFilters"] && !this["bIsFiltering"]) {
			if (UCF_JsUtil["iObjectIndexInArray"](
				oNodeContext,
				this["filterInfo"]["aFilteredContexts"]
			) !== -1) {
				aContexts["push"](oNodeContext);
			}
		} else {
			aContexts["push"](oNodeContext);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["_saveSubContext"] = 0; };

/**
 * Filters the tree according to the filter definitions. The filtering is
 * applied recursively through the tree. The parent nodes of filtered child
 * nodes will also be displayed if they don't match the filter conditions. All
 * filters belonging to a group (=have the same path) are ORed and after that
 * the results of all groups are ANDed.
 *
 * @see UCF_TreeBinding.prototype.filter
 * @public
 * @param {UCF_ListBinding_Filter[]} aFilters Array of UCF_Filter objects
 */
UCF_JSONTreeBinding["prototype"]["filter"] = function(aFilters) {;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["filter"]++; }; 
	// The filtering is applied recursively through the tree and stores all
	// filtered contexts and its parent contexts in an array.

	// reset previous stored filter contexts
	this["filterInfo"]["aFilteredContexts"] = [];
	this["filterInfo"]["oParentContext"] = {};
	if (!aFilters || !UCF_JsUtil["bIsArray"](aFilters) || aFilters["length"] === 0) {
		this["aFilters"] = null;
	} else {
		this["aFilters"] = aFilters;
		// start with binding path root
		this["filterRecursive"](new (UCF_ClassLoader["oGetClass"]("UCF_BindingContext"))(this["oModel"], this["sPath"]));
	}
	this["_fireChange"]();
	this["_fireFilter"]({ "filters": aFilters });
};;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["filter"] = 0; };

/**
 * filters the tree recursively.
 *
 * @private
 * @param {UCF_BindingContext} oParentContext the context where to start. The
 * children of this node context are then filtered recursively.
 */
UCF_JSONTreeBinding["prototype"]["filterRecursive"] = function(oParentContext) {;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["filterRecursive"]++; }; 
	/** @type {UCF_BindingContext[]} */
	var aChildren;
	/** @type {UCF_JSONTreeBinding} */
	var self;

	this["bIsFiltering"] = true;
	aChildren = this["getNodeContexts"](oParentContext);
	this["bIsFiltering"] = false;

	if (aChildren["length"] > 0) {
		self = this;
		UCF_JsUtil["each"](aChildren, function(i, oChildContext) {
			self["filterRecursive"](oChildContext);
		});
		this["applyFilter"](oParentContext);
	}
};;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["filterRecursive"] = 0; };

/**
 * Performs the real filtering and stores all filtered contexts and its parent
 * context into an array.
 *
 * @private
 * @param {UCF_BindingContext} oParentContext the context where to start. The
 * children of this node context are filtered.
 */
UCF_JSONTreeBinding["prototype"]["applyFilter"] = function(oParentContext) {;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["applyFilter"]++; }; 
	/** @type {UCF_JSONTreeBinding_FilterInfo} */
	var self;
	/** @type {Object<string, UCF_ListBinding_Filter[]>} */
	var oFilterGroups;
	/** @type {UCF_ListBinding_Filter[]} */
	var aFilterGroup;
	/** @type {Object[]} */
	var aFiltered;
	/** @type {boolean} */
	var bGroupFiltered;
	/** @type {boolean} */
	var bFiltered;
	/** @type {UCF_BindingContext[]} */
	var aUnfilteredContexts;

	if (!this["aFilters"]) {
		return;
	}

	self = this;
	oFilterGroups = {};
	aFiltered = [];
	bGroupFiltered = false;
	bFiltered = true;

	this["bIsFiltering"] = true;
	aUnfilteredContexts = this["getNodeContexts"](oParentContext);
	this["bIsFiltering"] = false;

	UCF_JsUtil["forEach"](aUnfilteredContexts, function(oUnfilteredContext) {
		bFiltered = true;
		UCF_JsUtil["each"](self["aFilters"], function(j, oFilter) {
			aFilterGroup = oFilterGroups[oFilter["sPath"]];
			if (!aFilterGroup) {
				aFilterGroup = oFilterGroups[oFilter["sPath"]] = [];
			}
			aFilterGroup["push"](oFilter);
		});
		UCF_JsUtil["each"](oFilterGroups, function(sPath, aFilterGroup) {
			/** @type {Object} */
			var oValue = self["oModel"]["_getObject"](sPath, oUnfilteredContext);

			if (typeof oValue === 'string') {
				oValue = oValue["toUpperCase"]();
			}
			bGroupFiltered = false;

			UCF_JsUtil["forEach"](aFilterGroup, function(oFilter) {
				/** @type {function(Object): boolean} */
				var fnTest = self["getFilterFunction"](oFilter);

				if (oValue && fnTest(oValue)) {
					bGroupFiltered = true;

					return false;
				}
			});
			if (!bGroupFiltered) {
				bFiltered = false;

				return false;
			}
		});
		if (bFiltered) {
			aFiltered["push"](oUnfilteredContext);
		}
	});
	if (aFiltered["length"] > 0) {
		UCF_JsUtil["oMergeObjects"](this["filterInfo"]["aFilteredContexts"], aFiltered);
		this["filterInfo"]["aFilteredContexts"]["push"](oParentContext);
		this["filterInfo"]["oParentContext"] = oParentContext;
	}

	// push additionally parentcontexts if any children are already included in
	// filtered contexts
	if (UCF_JsUtil["iObjectIndexInArray"](
		this["filterInfo"]["oParentContext"],
		aUnfilteredContexts
	) !== -1) {
		this["filterInfo"]["aFilteredContexts"]["push"](oParentContext);
		// set the parent context which was added to be the new parent context
		this["filterInfo"]["oParentContext"] = oParentContext;
	}
};;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["applyFilter"] = 0; };

/**
 * Provides a JS filter function for the given filter
 * @private
 * @template T
 * @param {UCF_ListBinding_Filter<T>} oFilter
 * @return {function}
 */
UCF_JSONTreeBinding["prototype"]["getFilterFunction"] = function(oFilter) {;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["getFilterFunction"]++; }; 
	/** @type {T} */
	var oValue1;
	/** @type {T} */
	var oValue2;

	if (oFilter["fnTest"]) {
		return oFilter["fnTest"];
	}

	oValue1 = oFilter["oValue1"];
	oValue2 = oFilter["oValue2"];

	if (typeof oValue1 === 'string') {
		oValue1 = oValue1["toUpperCase"]();
	}
	if (typeof oValue2 === 'string') {
		oValue2 = oValue2["toUpperCase"]();
	}

	switch (oFilter["sOperator"]) {
		case 'EQ':
			// eslint-disable-next-line eqeqeq
			oFilter["fnTest"] = function(value) { return value == oValue1; };
			break;
			case 'NE':
				// eslint-disable-next-line eqeqeq
			oFilter["fnTest"] = function(value) { return value != oValue1; };
			break;
		case 'LT':
			oFilter["fnTest"] = function(value) { return value < oValue1; };
			break;
		case 'LE':
			oFilter["fnTest"] = function(value) { return value <= oValue1; };
			break;
		case 'GT':
			oFilter["fnTest"] = function(value) { return value > oValue1; };
			break;
		case 'GE':
			oFilter["fnTest"] = function(value) { return value >= oValue1; };
			break;
		case 'BT':
			oFilter["fnTest"] = function(value) { return (value > oValue1) && (value < oValue2); };
			break;
		case 'Contains':
			oFilter["fnTest"] = function(value) { return value["indexOf"](oValue1) !== -1; };
			break;
		case 'StartsWith':
			oFilter["fnTest"] = function(value) { return value["indexOf"](oValue1) === 0; };
			break;
		case 'EndsWith':
			oFilter["fnTest"] = function(value) { return value["indexOf"](oValue1) === value["length"] - new String(oFilter["oValue1"])["length"]; };
			break;
		default:
			oFilter["fnTest"] = function(value) { return true; };
	}

	return oFilter["fnTest"];
};;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["getFilterFunction"] = 0; };

/**
 * Check whether this Binding would provide new values and in case it changed,
 * inform interested parties about this.
 *
 * @param {boolean} bForceupdate
 */
UCF_JSONTreeBinding["prototype"]["checkUpdate"] = function(bForceupdate) {;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["checkUpdate"]++; }; 
	this["_fireChange"]();
};;if (__UCF_COVERAGE__) { UCF_JSONTreeBinding["_"]["checkUpdate"] = 0; };

UCF_JSONTreeBinding.prototype["aPublicMethods"] = ["filter"].concat(UCF_JSONTreeBinding.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Keycaster"] = function() {/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_ColorUtil */
/// <reference path="../../core/util/ColorUtil.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_System */
/// <reference path="../core/system.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>

/**
 * @constructor UCF_Keycaster
 * @class UCF_Keycaster
 * @extends UCF_Object
 * @param {UCF_LS} oLS
 */
function UCF_Keycaster(oLS) {if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["UCF_Keycaster"]++; }; 
	/** @type {UCF_ResourceUtil_CssMetaData} */
	var oCssMetaData = UCF_ResourceUtil["oExtractCssMetaData"]();
	/** @type {string} */
	var sDocumentBG = UCF_DomUtil["sGetCurrentStyle"](document["body"], 'background-color');
	/** @type {string} */
	var sBG = UCF_ColorUtil["sContrast"](sDocumentBG, '#000', '#fff');

	UCF_Object["apply"](this, arguments);

	/** @type {UCF_LS} */
	this["oLS"] = oLS;
	/** @type {HTMLDivElement} */
	this["oDomRef"] = null;
	/** @type {HTMLStyleElement} */
	this["oStyleRef"] = UCF_DomUtil["oAddStyle"]('.' + UCF_Keycaster["CLASS"] + ' {\n' +
		'  position: absolute;\n' +
		'  top: -10000px !important;\n' +
		'  bottom: 1rem;\n' +
		'  left: 1rem;\n' +
		'  display: block;\n' +
		'  height: 2rem;\n' +
		'  line-height: 2rem;\n' +
		'  padding: 1rem;\n' +
		'  border-radius: .5rem;\n' +
		'  background-color: ' + UCF_ColorUtil["sFade"](
			sBG, // eslint-disable-next-line no-magic-numbers
			(oCssMetaData && UCF_JsUtil["contains"](oCssMetaData["Tags"] || [], 'HighContrast')) ? 1 : .5
		) + ';\n' +
		'  color: ' + UCF_ColorUtil["sContrast"](sDocumentBG, '#fff', '#000') + ';\n' +
		'  font-size: 2rem;\n' +
		'  text-shadow: 0 0 .25rem ' + sBG + ';\n' +
		'  transform: translateX(-200%);\n' +
		'  opacity: 1;\n' +
		'  transition: opacity .1s ease-out;\n' +
		'  will-change: opacity;\n' +
		'}\n' +
		'.' + UCF_Keycaster["VISIBLE_CLASS"] + ' {\n' +
		'  transform: translateX(0);\n' +
		'  transition: opacity .1s ease-out, transform ' + UCF_Keycaster["ACTIVE_TIMEOUT_MS"] + 'ms ease-in-out;\n' +
		'  top: auto !important;\n' +
		'}\n' +
		'.' + UCF_Keycaster["IDLE_CLASS"] + ' {\n' +
		'  opacity: .38;\n' +
		'  transition-timing-function: ease-in, ease-in-out;\n' +
		'}\n' +
		'.' + UCF_Keycaster["ACTIVE_CLASS"] + ' {\n' +
		'  transform: translate(0,-.25rem);\n' +
		'}\n', window["UCF_System"]["sNonce"]);

	/** @type {string} */
	this["sIdleTimeoutId"] = null;
	/** @type {string} */
	this["sActiveTimeoutId"] = null;

	this["render"]();
	this["connectToDom"]();
};window["UCF_Keycaster"] = UCF_Keycaster; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Keycaster"); UCF_Keycaster["_"] = {UCF_Keycaster: 0}; }; 
UCF_Keycaster["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Keycaster.prototype["sClassName"] = "UCF_Keycaster";

/** @type {'ls-keycaster'} */
UCF_Keycaster["ID"] = 'ls-keycaster';

/** @type {'lsKeycaster'} */
UCF_Keycaster["CLASS"] = 'lsKeycaster';
/** @type {'lsKeycaster--visible'} */
UCF_Keycaster["VISIBLE_CLASS"] = UCF_Keycaster["CLASS"] + '--visible';
/** @type {'lsKeycaster--idle'} */
UCF_Keycaster["IDLE_CLASS"] = UCF_Keycaster["CLASS"] + '--idle';
/** @type {'lsKeycaster--active'} */
UCF_Keycaster["ACTIVE_CLASS"] = UCF_Keycaster["CLASS"] + '--active';

/** @type {'WIN'|'CMD'|'META'} */
UCF_Keycaster["META"] = UCF_UserAgent["bIsWindows"]()
	? 'WIN'
	: UCF_UserAgent["bIsMacOs"]()
	? 'CMD'
	: 'META';
/** @type {'CTRL'} */
UCF_Keycaster["CTRL"] = 'CTRL';
/** @type {'SHIFT'} */
UCF_Keycaster["SHIFT"] = 'SHIFT';
/** @type {'ALT'} */
UCF_Keycaster["ALT"] = 'ALT';

/** @type {2000} */
UCF_Keycaster["IDLE_TIMEOUT_MS"] = 2000;
/** @type {50} */
UCF_Keycaster["ACTIVE_TIMEOUT_MS"] = 50;

/** @override */
UCF_Keycaster["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["destroy"]++; }; 
	this["hide"]();

	this["sActiveTimeoutId"] = null;
	this["sIdleTimeoutId"] = null;

	UCF_DomUtil["removeFromDom"](this["oStyleRef"]);
	this["oStyleRef"] = null;

	UCF_DomUtil["removeFromDom"](this["oDomRef"]);
	this["oDomRef"] = null;

	this["oLS"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["destroy"] = 0; };

/** @private */
UCF_Keycaster["prototype"]["render"] = function() {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["render"]++; }; 
	/** @type {HTMLDivElement} */
	var oDomRef = document["createElement"]('div');

	oDomRef["id"] = UCF_Keycaster["ID"];
	UCF_DomUtil["addClass"](oDomRef, UCF_Keycaster["CLASS"]);

	UCF_DomUtil["oAddLayeredElement"](oDomRef, document["body"]);
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["render"] = 0; };

/** @private */
UCF_Keycaster["prototype"]["connectToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["connectToDom"]++; }; 
	this["oDomRef"] = UCF_DomUtil["$"](UCF_Keycaster["ID"]);
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["connectToDom"] = 0; };

/** @protected */
UCF_Keycaster["prototype"]["trigger"] = function() {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["trigger"]++; }; 
	if (this["bIsVisible"]()) {
		this["hide"]();
	} else {
		this["show"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["trigger"] = 0; };

/** @private */
UCF_Keycaster["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["show"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBW = this["oLS"]["oBrowserWindow"];

	this["awake"]();

	oBW["attachEvent"](oBW["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');

	this["oDomRef"]["textContent"] = '';
	UCF_DomUtil["addClass"](this["oDomRef"], UCF_Keycaster["VISIBLE_CLASS"]);

	this["idle"]();
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["show"] = 0; };

/** @private */
UCF_Keycaster["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["hide"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBW = this["oLS"]["oBrowserWindow"];

	oBW["detachEvent"](oBW["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');

	UCF_DomUtil["removeClass"](this["oDomRef"], UCF_Keycaster["VISIBLE_CLASS"]);
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["hide"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_Keycaster["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["bIsVisible"]++; }; 
	return UCF_DomUtil["bHasClass"](this["oDomRef"], UCF_Keycaster["VISIBLE_CLASS"]);
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["bIsVisible"] = 0; };

/** @param {UCF_Event<{oBrowserEvent: UCF_BrowserEvent}>} oEvent */
UCF_Keycaster["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["onAnyEvent"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');

	switch (oBrowserEvent["sGetName"]()) {
		case 'keydown':
			this["awake"]();

			this["oDomRef"]["textContent"] = this["sToString"](oBrowserEvent["oDomEvent"]);

			this["active"]();
			this["idle"]();
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["onAnyEvent"] = 0; };

/**
 * @param {KeyboardEvent} oDomEvent
 * @return {string}
 */
UCF_Keycaster["prototype"]["sToString"] = function(oDomEvent) {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["sToString"]++; }; 
	return UCF_JsUtil["map"](
		UCF_JsUtil["filter"]([
			oDomEvent["ctrlKey"] ? UCF_Keycaster["CTRL"] : '',
			oDomEvent["metaKey"] ? UCF_Keycaster["META"] : '',
			oDomEvent["shiftKey"] ? UCF_Keycaster["SHIFT"] : '',
			oDomEvent["altKey"] ? UCF_Keycaster["ALT"] : '',
			typeof oDomEvent["key"] === 'string'
				? (
				oDomEvent["key"] === 'Meta' ||
				oDomEvent["key"] === 'Control' ||
				oDomEvent["key"] === 'Shift' ||
				oDomEvent["key"] === 'Alt'
			)
				? ''
				: oDomEvent["key"] === ' '
				? 'SPACE'
				: oDomEvent["key"]["replace"](
				/([A-Z][a-z]+)/g,
				function(_, g) { return '_' + g; }
			)["replace"](/^_/, '')["toUpperCase"]()
				: (UCF_JsUtil["find"](UCF_JsUtil["entries"](UCF_KeyCodes), function(aKey) {
				return aKey[1] === oDomEvent["keyCode"];
			}) || [''])[0]
		], function(_) { return _; }),
		function(sKey) { return '[' + sKey + ']'; }
	)["join"]('');
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["sToString"] = 0; };

/** @private */
UCF_Keycaster["prototype"]["active"] = function() {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["active"]++; }; 
	/** @type {UCF_Keycaster} */
	var self = this;

	if (this["sActiveTimeoutId"]) {
		this["clearTimeout"](this["sActiveTimeoutId"]);
		this["sActiveTimeoutId"] = null;
	}

	UCF_DomUtil["addClass"](this["oDomRef"], UCF_Keycaster["ACTIVE_CLASS"]);

	this["sActiveTimeoutId"] = this["setTimeout"](function() {
		UCF_DomUtil["removeClass"](self["oDomRef"], UCF_Keycaster["ACTIVE_CLASS"]);
	}, UCF_Keycaster["ACTIVE_TIMEOUT_MS"]);
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["active"] = 0; };

/** @private */
UCF_Keycaster["prototype"]["awake"] = function() {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["awake"]++; }; 
	if (this["sIdleTimeoutId"]) {
		this["clearTimeout"](this["sIdleTimeoutId"]);
	}

	UCF_DomUtil["removeClass"](this["oDomRef"], UCF_Keycaster["IDLE_CLASS"]);
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["awake"] = 0; };

/** @private */
UCF_Keycaster["prototype"]["idle"] = function() {;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["idle"]++; }; 
	/** @type {UCF_Keycaster} */
	var self = this;

	this["sIdleTimeoutId"] = this["setTimeout"](function() {
		UCF_DomUtil["addClass"](self["oDomRef"], UCF_Keycaster["IDLE_CLASS"]);
		self["oDomRef"]["textContent"] = '';
	}, UCF_Keycaster["IDLE_TIMEOUT_MS"]);
};;if (__UCF_COVERAGE__) { UCF_Keycaster["_"]["idle"] = 0; };

};
sap["ls"]["preload"]["UCF_Label"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Label(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Label["_"]["UCF_Label"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Label.js(35): UCF_Label"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Label.js(36): UCF_Label"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Label.js(37): UCF_Label"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oTarget"] = null;
	this["bTextSelection"] = this["sText"] !== '';

	if (this["bTextSelection"] && (this["bEditable"] && this["mEvents"]["DoubleClick"])) {
		this["bTextSelection"] = false;
	}
	if (this["bTextSelection"]) {
		this["allowTextSelection"]();
	}

	this["bShowDataTip"] = this["bShowHelp"];

	// inplace edit
	if (this["bEditable"]) {
		var oInplaceEditDelegate = this["oInplaceEditDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEditDelegate"))(oLS);

		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this, 'onInplaceEditStart');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this, 'onInplaceEditFinished');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this, 'onInplaceEditClosed');

		this["addDelegate"](oInplaceEditDelegate);
	}
	this["oFocusDomRef"] = null;
	if (this["sInteractionBehavior"] === 'ACTIVATE' || this["bEditable"])
		this["oFocusDomRef"] = this["oDomRef"];

	this["iTopPosition"] = -1;
	this["iPaddingRight"] = -1;
};window["UCF_Label"] = UCF_Label; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Label"); UCF_Label["_"] = {UCF_Label: 0}; }; ;

UCF_Label["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Label.prototype["sClassName"] = "UCF_Label";

UCF_Label["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["initialize"]++; }; 
	if (window["UCF_System"]["sDevice"] !== "standards") {
		this["quirksPositionWorkaround"]();
		return;
	}
	if (this["sHeight"] === '' || this["bWrapping"] === false)
		return;

	this["calculateHeight"]();

};;if (__UCF_COVERAGE__) { UCF_Label["_"]["initialize"] = 0; };

/**
 * CSN 1870066010 / 2018
 * The position of the Label in PanelStack -> PopupWindows
 * is outside the PanelStack
 *
 * @private
 */
UCF_Label["prototype"]["quirksPositionWorkaround"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["quirksPositionWorkaround"]++; }; 
	/** @type {UCF_Label} */
	var self = this;

	UCF_JsUtil["requestIdleCallback"](function() {
		UCF_DomUtil["setStyle"](self["oDomRef"], 'position', '');
	});
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["quirksPositionWorkaround"] = 0; };

/**
 * Removes a colon and spaces
 * @returns {string} Input but removed the colon.
 * @private
 */
UCF_Label["prototype"]["calculateHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["calculateHeight"]++; }; 

	var oDomRefEllipsis = UCF_DomUtil["$"](this["sId"] + '-multiline');
	if (!oDomRefEllipsis) return;

	var iCurrentOffsetHeight = this["oDomRef"]["offsetHeight"],
		iEllipsisOffsetHeight = oDomRefEllipsis["offsetHeight"],
		iLineHeight = parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'line-height'));
	if (!iLineHeight) {
		iLineHeight = 18;
	}

	if (iCurrentOffsetHeight > iEllipsisOffsetHeight) {
		if (this["iTopPosition"] === -1) {

			var iMarginTop = parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'margin-top')),
				iPaddingTop = parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'padding-top'));

			if (!iMarginTop) iMarginTop = 0;
			if (!iPaddingTop) iPaddingTop = 0;
			this["iTopPosition"] = iMarginTop + iPaddingTop;
		}
		var iHeight = iEllipsisOffsetHeight,
			iCalculateHeight = iHeight - this["iTopPosition"];

		var iVisibleLines = Math["floor"](iCalculateHeight / iLineHeight);

		iCalculateHeight = (iVisibleLines * iLineHeight) + this["iTopPosition"];
		if (iCalculateHeight < iEllipsisOffsetHeight) {
			oDomRefEllipsis["style"]["height"] = iCalculateHeight + 'px';
			UCF_DomUtil["addClass"](oDomRefEllipsis, 'lsLabel--multiline-valign');
		}
	} else {
		UCF_DomUtil["removeClass"](oDomRefEllipsis, 'lsLabel--multiline-valign');
	}
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["calculateHeight"] = 0; };

/**
 * Connect the label with it's labeled control
 *
 * @private
 */
UCF_Label["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["init"]++; }; 
	// get connected control and focusable element of the connected control

	//reset old values
	this["oTarget"] = null;
	this["oTargetRef"] = null;
	this["bShowDataTip"] = this["bShowHelp"] || (this["oTbarRef"] != null);

	if (this["sLabelFor"]) {
		this["oTarget"] = this["oLS"]["oControlFactory"]["oGetControlById"](this["sLabelFor"]);
		if (this["oTarget"]) {
			if (this["oTarget"]["oFocusDomRef"]) {
				this["oTargetRef"] = this["oTarget"]["oFocusDomRef"];
			} else {
				this["oTargetRef"] = this["oDomRef"];
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["init"] = 0; };

/**
 * @param {string} sLabelForId new label for
 */
UCF_Label["prototype"]["setLabelFor"] = function(sLabelForId) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["setLabelFor"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sLabelFor"] = sLabelForId;
	this["setClientProperty"]('LabelFor', this["sLabelFor"], true);
	this["oDomRef"]["setAttribute"]('for', this["sLabelFor"]);
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["setLabelFor"] = 0; };

/**
 * Handles the click on the menu with keyboard or mouse
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Label["prototype"]["handleClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["handleClick"]++; }; 

	// No focus setting to associated control?
	if (this["sInteractionBehavior"] === 'NONE') return;

	if (this["mEvents"]["Activate"] && this["bEnabled"]) {
		this["fireActivate"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}

	if (this["sInteractionBehavior"] === 'ACTIVATE') return;

	// check if the label text has a selection
	// In IE Quirks it can be null when no text is selected
	var sTextSelection = UCF_DomUtil["sGetSelectionText"](this["oDomRef"]);
	if (sTextSelection && sTextSelection !== '') return;

	// init with valid reference
	this["init"]();

	// focus the connected control if one exists
	if (!this["oTarget"]) return;

	if (this["bEditable"]) return;

	if (this["oTarget"]["sClassName"] === 'UCF_CheckBox'
		|| this["oTarget"]["sClassName"] === 'UCF_RadioButton'
		|| this["oTarget"]["sClassName"] === 'UCF_TriStateCheckBox') {
		this["oTargetRef"]["click"]();
	} else if (this["oTarget"]["sClassName"] === 'UCF_RadioButtonGroup'
		|| this["oTarget"]["sClassName"] === 'UCF_CheckBoxGroup'
		|| this["oTarget"]["sClassName"] === 'UCF_MeltingGroup') {
		// focus the control and not a DomRef
		this["oTarget"]["focus"]();
	} else {
		this["oTargetRef"]["focus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["handleClick"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Label["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Label.js(231): onclick"); };
	this["handleClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["onclick"] = 0; };

/**
 * Handles the space event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Label["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["onlsspace"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Label.js(243): onlsspace"); };
	this["handleClick"](oBrowserEvent);
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oDomRef"]) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["onlsspace"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Label["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Label.js(259): ondblclick"); };

	if (this["mEvents"]["DoubleClick"]) {
		this["fireDoubleClick"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["ondblclick"] = 0; };

/**
 * Handles the mouseover event on the label
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Label["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Label.js(274): onmouseover"); };

	//init with valid reference
	this["init"]();

	// show explanation/data tip of the connected control
	if (this["bShowDataTip"] && this["oTarget"] && this["oTarget"]["oDataTip"]) {
		this["bOldShowOnActivate"] = this["oTarget"]["oDataTip"]["bShowOnActivate"];
		this["bOldAutoHideTimeout"] = this["oTarget"]["oDataTip"]["iAutoHideTimeout"];
		// cancel the default handling
		this["oTarget"]["oDataTip"]["bShowOnActivate"] = false;
		// do not hide the data tip automatically after a timeout
		this["oTarget"]["oDataTip"]["iAutoHideTimeout"] = 0;
		if (this["sTimeOutId"]) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](400, this["oTarget"]["oDataTip"], "open");
	}

	if (window["UCF_System"]["bIs508"]) return;
	if (this["sHeight"] !== '' && this["bWrapping"]) {
		this["checkMultiLineLabelTooltip"]();

		return;
	}
	// the text will not be added to the Title when Wrapping=true and the
	// Label is into container which has Overflow
	if (this["bWrapping"]) return;

	var oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + '-ovfl');
	if (!oDomRefOvfl)
		oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + '-text');
	if (oDomRefOvfl) {
		UCF_DomUtil["checkTooltip"](this["oDomRef"], this["sTooltip"], oDomRefOvfl);
	} else {
		UCF_DomUtil["checkTooltip"](this["oDomRef"], this["sTooltip"], null);
	}

};;if (__UCF_COVERAGE__) { UCF_Label["_"]["onmouseover"] = 0; };

/**
 * Checks if the given oDomRef has ellipsis and set the text as tooltip
 *
 * @param {HTMLElement} oDomRef  the domRef of an HTML element for the current style
 * @private
 */

UCF_Label["prototype"]["checkMultiLineLabelTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["checkMultiLineLabelTooltip"]++; }; 
	var oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + "-r"),
		sTooltip = this["sTooltip"];

	var sSepator = (sTooltip !== "") ? " - " : "";

	if (oDomRefOvfl) {
		if (this["iPaddingRight"] === -1) {
			this["iPaddingRight"] = parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], "padding-right"));
			if (!this["iPaddingRight"])
				this["iPaddingRight"] = 0;
		}

		// oDomRef.clientWidth returns always 0 in FF, so I'm using offsetwidth
		//if (oDomRefOvfl.scrollWidth > oDomRefOvfl.clientWidth ||  oDomRef.scrollWidth > oDomRef.offsetWidth) {
		if (oDomRefOvfl["offsetHeight"] < this["oDomRef"]["offsetHeight"] || oDomRefOvfl["offsetWidth"] < (this["oDomRef"]["offsetWidth"] - this["iPaddingRight"])) {
			var sText = this["sText"];

			// if no text is set then no tooltip is set
			if (sText !== "" && sText !== UCF_StringUtil["sTrim"](sTooltip)) {
				this["oDomRef"]["title"] = sText + sSepator + sTooltip;
				oDomRefOvfl["title"] = sText + sSepator + sTooltip;
			}
		} else {
			this["oDomRef"]["title"] = sTooltip;
			oDomRefOvfl["title"] = sTooltip;
		}
	}

};;if (__UCF_COVERAGE__) { UCF_Label["_"]["checkMultiLineLabelTooltip"] = 0; };

/**
 * Removes a colon and spaces
 * @param {string} sString Input
 * @return {string} Input but removed the colon.
 * @private
 */
UCF_Label["prototype"]["removeColon"] = function(sString) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["removeColon"]++; }; 
	var sStringValue = sString;

	if (sStringValue != null && sStringValue !== "") {
		if (UCF_StringUtil["bEndsWith"](sStringValue, ":")) {
			return UCF_StringUtil["sTrim"](sStringValue["substring"](0, sStringValue["length"] - 1));
		}
	}
	return UCF_StringUtil["sTrim"](sStringValue);
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["removeColon"] = 0; };
/**
 * Handles the mouseout event on the label and causes an explanation test to hide
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Label["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["onmouseout"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Label.js(376): onmouseout"); };

	// init this.oTarget with valid reference
	this["init"]();

	if (this["bShowDataTip"] && this["oTarget"] && this["oTarget"]["oDataTip"]) {
		this["oTarget"]["oDataTip"]["close"]();
		this["oTarget"]["oDataTip"]["bShowOnActivate"] = this["bOldShowOnActivate"];
		this["oTarget"]["oDataTip"]["iAutoHideTimeout"] = this["bOldAutoHideTimeout"];
	}
	if (this["sTimeOutId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["onmouseout"] = 0; };

/**
 * @see UCF_Control
 */

UCF_Label["prototype"]["sGetDisplayedText"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["sGetDisplayedText"]++; }; 
	if (window["UCF_System"]["bIs508"]) {
		if (this["sTooltip"] !== "" && this["sTooltip"] !== this["sText"]) {
			return this["sText"] + " - " + this["sTooltip"];
		}
	}
	return this["sText"];

};;if (__UCF_COVERAGE__) { UCF_Label["_"]["sGetDisplayedText"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 */

UCF_Label["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["oGetInplaceEditDomRef"]++; }; 
	return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["oGetInplaceEditDomRef"] = 0; };

/**
 * @see UCF_Control.sGetInplaceEditText
 */

UCF_Label["prototype"]["sGetInplaceEditText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["sGetInplaceEditText"]++; }; 
	return this["getClientProperty"]("Text") || this["sText"];
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["sGetInplaceEditText"] = 0; };

/**
 * @see UCF_Control.setInplaceEditText
 */

UCF_Label["prototype"]["setInplaceEditText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["setInplaceEditText"]++; }; 
	this["sText"] = sText;
	this["setClientProperty"]("Text", sText);
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["setInplaceEditText"] = 0; };

/**
 * Returns the required state
 *
 * @return {boolean} - true if required
 */

UCF_Label["prototype"]["bGetRequired"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["bGetRequired"]++; }; 
	return this["bRequired"];
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["bGetRequired"] = 0; };

/**
 * Sets the screen reader text for the label.
 * The label gets a tabstop if labelfor is empty
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_Label["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Label.js(446): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (this["sLabelFor"] === "" || this["sInteractionBehavior"] === "ACTIVATE") { //All label information are normally read at control but if no control is available the label is included into tab chain
		oAccessibilityHelper["setText"](this["sText"]);
		if (this["sText"] !== this["sTooltip"])
			oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		if (this["sInteractionBehavior"] !== "NONE" && this["sLabelFor"] === '')
			oAccessibilityHelper["setEmpty"](true);
	}

	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["onlsaccessibility"] = 0; };

/**
 * Called when Inplace Edit starts
 */

UCF_Label["prototype"]["onInplaceEditStart"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["onInplaceEditStart"]++; }; 
	this["focus"](false);
	var oBoundaries = this["getBoundaries"]();

	this["oInplaceEditDelegate"]["setAlignRight"](this["sAlign"] === "RIGHT" || this["sAlign"] === "ENDOFLINE");
	this["oInplaceEditDelegate"]["setInplaceEditData"](
		this["oDomRef"],
		oBoundaries,
		this["sText"]
	);

};;if (__UCF_COVERAGE__) { UCF_Label["_"]["onInplaceEditStart"] = 0; };

/**
 * Recalculates the boundaries when it has image
 * @private
 */

UCF_Label["prototype"]["getBoundaries"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["getBoundaries"]++; }; 

	var oBoundaries = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);

	if (window["UCF_System"]["sDevice"] === "standards") {
		var oTextDomRef = UCF_DomUtil["$"](this["sId"] + "-text");

		if (oTextDomRef)
			oBoundaries = UCF_DomUtil["oGetObjectRect"](oTextDomRef);
	} else {
		if (this["bHasIcon"] && this["bImageFirst"]) {
			var oDomRefImg = UCF_DomUtil["$"](this["sId"] + "-img");

			if (oDomRefImg) {
				oBoundaries["left"] = oBoundaries["left"] + oDomRefImg["offsetWidth"];
			} else {
				oBoundaries["left"] = oBoundaries["left"] + 22;
			}
		}
		if (this["bRequired"] && this["bRequiredIndicatorAtFront"]) {
			oBoundaries["left"] = oBoundaries["left"] + 10;
		}
	}

	return oBoundaries;
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["getBoundaries"] = 0; };

/**
 * Called when Inplace Edit is finished
 */

UCF_Label["prototype"]["onInplaceEditFinished"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["onInplaceEditFinished"]++; }; 
	var sText = oParams["oGetParam"]("sText"),
		sTextEncoded = '';

	if (sText === this["sText"]) return;

	sTextEncoded = UCF_XSSEncoder["encodeHTML"](sText);

	if (window["UCF_System"]["sDevice"] === "standards") {
		var sTextWithAccessKey = new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(undefined, this["oLS"])["sAccessKeyTextFragment"](sText, this["sAccessKey"], true, sTextEncoded);
		var oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-text');

		if (oTextDomRef)
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oTextDomRef, sTextWithAccessKey + '');
	} else {
		var sDesignText = UCF_StringUtil["sTrim"](this["sText"]) + (this["sDesignBar"] === 'STANDARD' ? ':' : ''),
			sTypeText = sTextEncoded + (this["sDesignBar"] === 'STANDARD' ? ':' : '');

		if (this["oDomRef"]["childNodes"]["length"] > 1) {
			var aDomItems = this["oDomRef"]["childNodes"],
				oChildNode;

			for (var i = 0; i < aDomItems["length"]; i++) {
				oChildNode = aDomItems[i];
				if (oChildNode["nodeType"] === 3 && typeof(oChildNode["data"]) !== "undefined" && UCF_StringUtil["sTrim"](UCF_StringUtil["sTrim"](oChildNode["data"])) === sDesignText) {
					// Text
					oChildNode["data"] = sTypeText;
					break;
				}
			}
		} else {
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](this["oDomRef"], sTextEncoded);
		}
		var oLabelOverflow = UCF_DomUtil["$"](this["sId"] + '-ovfl');

		if (oLabelOverflow)
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oLabelOverflow, sTextEncoded);
	}

	if (window["UCF_System"]["bIsAria"]) {
		//change aria-label attribute
	}

	this["sText"] = sText;
	this["setClientProperty"]("Text", this["sText"], true);
	this["fireChange"](this["sId"], sText);

	UCF_DomUtil["focusDomElement"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["onInplaceEditFinished"] = 0; };

UCF_Label["prototype"]["onInplaceEditClosed"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["onInplaceEditClosed"]++; }; 
	UCF_DomUtil["focusDomElement"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["onInplaceEditClosed"] = 0; };

UCF_Label["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["destroy"]++; }; 

	var oInplaceEditDelegate = this["oInplaceEditDelegate"];

	if (oInplaceEditDelegate) {
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this);
		this["oInplaceEditDelegate"]["destroy"]();
		this["oInplaceEditDelegate"] = null;
	}
	this["oTarget"] = null;
	this["bTextSelection"] = null;
	this["bShowDataTip"] = null;
	this["oTargetRef"] = null;
	this["sTimeOutId"] = null;
	this["sText"] = null;
	this["bOldAutoHideTimeout"] = null;
	this["bOldShowOnActivate"] = null;
	this["iTopPosition"] = null;
	this["iPaddingRight"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_Label["_"]["destroy"] = 0; };

/**
 * @return { UCF_Control_TouchContextMenuEntry[] }
 * @private
 */
UCF_Label["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	var oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-text');
	if (oTextDomRef && UCF_DomUtil["bHasTextEllipsis"](this["oDomRef"], oTextDomRef)) {
		aResult["push"]({
			"sType": 'TEXT',
			"sText": UCF_DomUtil["removeColon"](UCF_DomUtil["sGetInnerText"](oTextDomRef))
		});
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["aGetTouchContextMenuEntries"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_Label["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;
	/** @type {Node} */
	var oParent;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			this["oDomRef"]["setAttribute"]('role', 'gridcell');
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
			oParent = this["oDomRef"]["parentNode"];
			UCF_Control["addAriaGeneric"](oParent, oSapTableInfo);
			if (this["oDomRef"]["getAttribute"]("aria-labelledby"))
				oParent["setAttribute"]("aria-labelledby", this["oDomRef"]["getAttribute"]("aria-labelledby"));
			oParent["setAttribute"]('role', 'presentation');
		}
	}
	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["bPrepareAria"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Label["prototype"]["aAttributeNames"] = ["sTooltip","sLabelFor","bWrapping","sText","bRequired","bEnabled","sDesignBar","sWidth","bHasIcon","bImageFirst","sVisibility","bShowHelp","sAccessKey","sAlign","bTextOverflow","bRequiredIndicatorAtFront","sInteractionBehavior","bIsLink","bEditable","sCustomData","sCustomStyle","sHeight","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Label["prototype"]["aEventNames"] = ["DoubleClick","Activate","Change"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Label["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_Label["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Label["prototype"]["sLabelFor"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Label["prototype"]["bWrapping"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Label["prototype"]["sText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Label["prototype"]["bRequired"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Label["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LabelDesign}
 */
UCF_Label["prototype"]["sDesignBar"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_Label["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Label["prototype"]["bHasIcon"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Label["prototype"]["bImageFirst"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Label["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_Label["prototype"]["bShowHelp"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Label["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HorizontalAlign}
 */
UCF_Label["prototype"]["sAlign"] = "LEFT";

/**
 * @private
 * @type {boolean}
 */
UCF_Label["prototype"]["bTextOverflow"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Label["prototype"]["bRequiredIndicatorAtFront"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LabelInteractionBehavior}
 */
UCF_Label["prototype"]["sInteractionBehavior"] = "REDIRECT_FOCUS";

/**
 * @private
 * @type {boolean}
 */
UCF_Label["prototype"]["bIsLink"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Label["prototype"]["bEditable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Label["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Label["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Label["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Label["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Label["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Label["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sLabelFor"] = '';
	this["bWrapping"] = false;
	this["sText"] = '';
	this["bRequired"] = false;
	this["bEnabled"] = true;
	this["sDesignBar"] = "STANDARD";
	this["sWidth"] = '';
	this["bHasIcon"] = false;
	this["bImageFirst"] = true;
	this["sVisibility"] = "VISIBLE";
	this["bShowHelp"] = false;
	this["sAccessKey"] = '';
	this["sAlign"] = "LEFT";
	this["bTextOverflow"] = false;
	this["bRequiredIndicatorAtFront"] = false;
	this["sInteractionBehavior"] = "REDIRECT_FOCUS";
	this["bIsLink"] = false;
	this["bEditable"] = false;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sHeight"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("LabelFor", '', true);
		this["setClientProperty"]("Wrapping", false, true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Required", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("DesignBar", "STANDARD", true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("HasIcon", false, true);
		this["setClientProperty"]("ImageFirst", true, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ShowHelp", false, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("Align", "LEFT", true);
		this["setClientProperty"]("TextOverflow", false, true);
		this["setClientProperty"]("RequiredIndicatorAtFront", false, true);
		this["setClientProperty"]("InteractionBehavior", "REDIRECT_FOCUS", true);
		this["setClientProperty"]("IsLink", false, true);
		this["setClientProperty"]("Editable", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires Label::DoubleClick
 */
UCF_Label["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Label.js(865): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Label.js(866): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Label.js(867): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Label", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires Label::Activate
 */
UCF_Label["prototype"]["fireActivate"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["fireActivate"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Label.js(884): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Label.js(885): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Label.js(886): fireActivate"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Label", "Activate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["fireActivate"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the Label.
 * @param {string} sValue The new label.
 * @fires Label::Change
 */
UCF_Label["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_Label["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Label.js(904): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Label.js(905): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Label.js(906): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "Label.js(907): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Label.js(908): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("Label", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Label["_"]["fireChange"] = 0; };

};
sap["ls"]["preload"]["UCF_LargeButton"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * The LargeButton control is a simple button control which provides the
 * possibility to define its dimensions. So the "width" and the "height" must
 * be specified. With that the application can introduce large "click"
 * sensitive areas. Actually the demand for such a control came from the
 * customers using touch screens. From its design and usage the large button is
 * quite aligned to our existing Button control.
 *
 * 
 * @version
 *
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_LargeButton(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["UCF_LargeButton"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "LargeButton.js(38): UCF_LargeButton"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "LargeButton.js(39): UCF_LargeButton"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "LargeButton.js(40): UCF_LargeButton"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["defineEvents"](['Press', 'MouseDown']);

		// ignore the default button if the control gets the focus
		this["bIgnoreDefaultButton"] = true;

		this["sButtonTooltip"] = null;
		this["bHovered"] = false;
	}
};window["UCF_LargeButton"] = UCF_LargeButton; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LargeButton"); UCF_LargeButton["_"] = {UCF_LargeButton: 0}; }; ;
UCF_LargeButton["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_LargeButton.prototype["sClassName"] = "UCF_LargeButton";

UCF_LargeButton["prototype"]["eStyles"] = {
	"BUTTON_HOVERABLE": "lsLargeButton--hoverable",
	"BUTTON_TOUCHABLE": "lsLargeButton--touchable",
	"BUTTON_FOCUSABLE": "lsLargeButton--focusable",
	"BUTTON_DISABLED": "lsLargeButton--disabled"
};
/**
 * Destructor
 */
UCF_LargeButton["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["destroy"]++; }; 
	this["oPopupMenu"] = null;
	this["sButtonTooltip"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sPopupMenuId"] = null;
	this["bHovered"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["bEnabled"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["destroy"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LargeButton["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LargeButton.js(82): onclick"); };

	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}

	this["bHandlePress"](oBrowserEvent, false);
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onclick"] = 0; };

/**
 * Handles the onlsselect event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LargeButton["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LargeButton.js(98): onlsenter"); };

	this["bHandlePress"](oBrowserEvent, true);
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onlsenter"] = 0; };

/**
 * Handles the onlsselect event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LargeButton["prototype"]["onlsspaceup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onlsspaceup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LargeButton.js(110): onlsspaceup"); };

	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}
	if (this["bHandlePress"](oBrowserEvent, true)
		&& oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["SPACE"]) {
		// cancel event to avoid page scrolling in the browser
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onlsspaceup"] = 0; };

/**
 * Handles the onmousedown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LargeButton["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LargeButton.js(130): onmousedown"); };
	this["fireEvent"](this["E_EVENTS"]["MouseDown"], { "sId": this["sId"] });
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onmousedown"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LargeButton["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LargeButton.js(141): onmouseover"); };

	if (oBrowserEvent["bIsMouseHover"]()) {
		this["handleHover"](oBrowserEvent);
	}

	if (window["UCF_System"]["bIs508"]) return;
	if (UCF_StringUtil["bIsEmpty"](this["sGetText"]())) return;

	var oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + '-cnt');

	try {
		if (this["sButtonTooltip"] == null) {
			this["sButtonTooltip"] = UCF_StringUtil["sTrim"](this["oDomRef"]["getAttribute"]('title'));
		}
	} catch (oException) {
		this["sButtonTooltip"] = this["sTooltip"];
	}

	if (oDomRefOvfl) {
		UCF_DomUtil["checkTooltip"](this["oDomRef"], this["sButtonTooltip"], oDomRefOvfl);
	}
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onmouseover"] = 0; };

/**
 * Handles the onmouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LargeButton["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LargeButton.js(172): onmouseout"); };

	this["handleHover"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onmouseout"] = 0; };

/**
 * Handles the mouse hover functionality.
 * It detects if the button is hovered according to the given browserEvent, sets the hover state and triggers
 * the adaption of the UI
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LargeButton["prototype"]["handleHover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["handleHover"]++; }; 
	if (this["bEnabled"]) {
		var oDomRefRelated = oBrowserEvent["oDomEvent"]["toElement"] ? oBrowserEvent["oDomEvent"]["toElement"] : oBrowserEvent["oDomEvent"]["relatedTarget"],
			bHover = UCF_DomUtil["bContains"](this["oDomRef"], oDomRefRelated);

		if (bHover !== this["bHovered"]) {
			this["bHovered"] = bHover;
			this["applyStateToDom"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["handleHover"] = 0; };

/**
 * This method can be called any time. It checks the state of the control and generates the right sum of class statements
 * which can be applied to the root DOM node.
 * All sub HTML structures are controlled by CSS cascades except the image state which additionally adapts the image src attribute.
 *
 * @see applyImageStateToDom
 * @private
 */
UCF_LargeButton["prototype"]["applyStateToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["applyStateToDom"]++; }; 
	var sClassStateAppendix = '';

	sClassStateAppendix += this["bDown"] ? 'Dwn' : 'Up';
	var sRootClass = 'urLBRoot' + sClassStateAppendix,
		sToogleClass = 'urLBTglRoot' + sClassStateAppendix;
	if (this["bEnabled"]) {
		if (UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["BUTTON_DISABLED"])) {
			UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["BUTTON_DISABLED"]);
		}
		if (this["bHovered"]) {
			if (!UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"])) {
				UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"]);
			}
			UCF_DomUtil["replaceClass"](this["oDomRef"], sRootClass, sRootClass + 'Hvr');
			if (this["sInteractionBehaviour"] === 'TOGGLE') {
				UCF_DomUtil["replaceClass"](this["oDomRef"], sToogleClass, sToogleClass + 'Hvr');
			}
		} else {
			UCF_DomUtil["replaceClass"](this["oDomRef"], sRootClass + 'Hvr', sRootClass);
			if (this["sInteractionBehaviour"] === 'TOGGLE') {
				UCF_DomUtil["replaceClass"](this["oDomRef"], sToogleClass + 'Hvr', sToogleClass);
			}
			if (UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"])) {
				UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"]);
			}
		}
	} else {
		if (!UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["BUTTON_DISABLED"])) {
			UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["BUTTON_DISABLED"]);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["applyStateToDom"] = 0; };

/**
 * This method can be seen as an addition to the "applyStateToDom" method. Due to image src cannot be handled by
 * CSS stylesheets it adapts the src to the current state. This is currently only necessary for the "down" and "enabled" state.
 *
 * @see applyStateToDom
 * @private
 */
UCF_LargeButton["prototype"]["applyImageStateToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["applyImageStateToDom"]++; }; 
	var oImage = UCF_DomUtil["$"](this["sId"] + '-img'),
		sOldImageSrc = this["sGetIconSource"](oImage),
		sNewImageSrc = '';

	if (this["bHasIcon"] && oImage) {

		if (this["bDown"] && this["sDownIconSrc"]) {
			sNewImageSrc = this["sDownIconSrc"];
		} else {
			sNewImageSrc = this["sUpIconSrc"];
		}

		if (this["bEnabled"]) {
			UCF_DomUtil["setClass"](oImage, '');
		} else {
			if (this["sDisabledIconSrc"]) {
				sNewImageSrc = this["sDisabledIconSrc"];
			} else {
				UCF_DomUtil["setClass"](oImage, 'urImgDsbl');
			}
		}

	}

	if (oImage && sOldImageSrc !== sNewImageSrc) {
		this["setIconSource"](sNewImageSrc, oImage);
		if (sNewImageSrc) oImage["style"]["display"] = 'inline';
		else oImage["style"]["display"] = 'none';
	}

};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["applyImageStateToDom"] = 0; };

/**
 * Returns the icon source
 *
 * @param {HTMLElement} oIconRef
 * @return {string}
 * @private
 */
UCF_LargeButton["prototype"]["sGetIconSource"] = function(oIconRef) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["sGetIconSource"]++; }; 
	var sIconSrc;

	if (!oIconRef) oIconRef = UCF_DomUtil["$"](this["sId"] + '-img');
	if (!oIconRef) return '';

	if (oIconRef["tagName"] === 'IMG') {
		sIconSrc = oIconRef["getAttribute"]('src');
	} else if (oIconRef["tagName"] === 'SVG') {
		sIconSrc = oIconRef["getAttribute"]('xlink:href');
	} else {
		sIconSrc = '';
	}

	return sIconSrc;
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["sGetIconSource"] = 0; };

/**
 * Sets the icon source
 *
 * @param {string} sIconSrc
 * @param {HTMLElement} oIconRef
 * @private
 */
UCF_LargeButton["prototype"]["setIconSource"] = function(sIconSrc, oIconRef) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["setIconSource"]++; }; 

	if (!oIconRef) oIconRef = UCF_DomUtil["$"](this["sId"] + '-img');
	if (!oIconRef) return;

	if (oIconRef["tagName"] === 'IMG') {
		sIconSrc = oIconRef["setAttribute"]('src', sIconSrc);
	} else if (oIconRef["tagName"] === 'SVG') {
		sIconSrc = oIconRef["setAttribute"]('xlink:href', sIconSrc);
	} else {
		sIconSrc = '';
	}
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["setIconSource"] = 0; };

/**
 * Handles the mouse hover functionality.
 * It detects if the button is hovered according to the given browserEvent, sets the hover state and triggers
 * the adaption of the UI
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @param {boolean} bWithKeyboard It specifies if the event triggered by keyboard
 * @private
 */

UCF_LargeButton["prototype"]["bHandlePress"] = function(oBrowserEvent, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["bHandlePress"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LargeButton.js(336): bHandlePress"); };

	if (!this["bEnabled"]) return false;

	if ((this["bHasPopupMenuSection"]
			&& !UCF_DomUtil["bContains"](this["oDomRef"], oBrowserEvent["oGetSource"]())) ||
		(this["bHasPopupMenu"] && !this["bHasPopupMenuSection"])
	) {
		this["toggleMenu"](bWithKeyboard);
	} else {
		this["fireEvent"](this["E_EVENTS"]["Press"], { "sId": this["sId"] });
		this["firePress"](this["sId"]);
	}

	return true;
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["bHandlePress"] = 0; };

/**
 * Set enabled
 *
 * @param {boolean} bEnabled the new enabled value
 * @public
 */
UCF_LargeButton["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["setEnabled"]++; }; 
	if (this["bEnabled"] !== bEnabled) {
		this["bEnabled"] = bEnabled;
		this["setClientProperty"]("Enabled", this["bEnabled"], true);
		UCF_DomUtil["setTabIndex"](this["oDomRef"], (window["UCF_System"]["bIs508"] || this["bEnabled"]) ? 0 : -1);
		this["applyImageStateToDom"]();
		this["applyStateToDom"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["setEnabled"] = 0; };

/**
 * Returns the enabled state
 * @return {boolean} the bEnabled
 * @public
 */

UCF_LargeButton["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["getEnabled"]++; }; 
	return this["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["getEnabled"] = 0; };

/**
 * @see UCF_Button
 */

UCF_LargeButton["prototype"]["setIsDefaultButton"] = function(bDefault) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["setIsDefaultButton"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bDefault) === 'boolean', "typeof(bDefault) === 'boolean'", "LargeButton.js(384): setIsDefaultButton"); };
	// Empty implementation. TODO See Button.js to fill visualization
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["setIsDefaultButton"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LargeButton["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LargeButton.js(396): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());
	oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
	oAccessibilityHelper["setHotkey"](this["sHotKey"]);
	oAccessibilityHelper["setText"](UCF_StringUtil["sTrim"](this["sGetText"]()));
	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	if (this["bDown"]) oAccessibilityHelper["setPressed"](this["bDown"]);

	if (this["bHasPopupMenu"]) {
		oAccessibilityHelper["setControlType"]('B_MNU');
		oAccessibilityHelper["addEnabledTutor"]('MENU_TUT', this["bEnabled"]);
	} else {
		oAccessibilityHelper["setControlType"]('B');
		oAccessibilityHelper["addEnabledTutor"]('B_TUT', this["bEnabled"]);
	}

};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onlsaccessibility"] = 0; };

/**
 * Returns the button label text
 * @return {string} the text
 * @private
 */

UCF_LargeButton["prototype"]["sGetText"] = function() {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["sGetText"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + '-txt')["innerText"];
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["sGetText"] = 0; };

/**
 * Open menu
 *
 * @param {boolean} bWithKeyboard determines if popup was opened with keyboard or mouse
 * @public
 */
UCF_LargeButton["prototype"]["openMenu"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["openMenu"]++; }; 

	if (!this["bHasPopupMenu"] || this["sPopupMenuId"] === ''
		|| this["oGetControlById"](this["sPopupMenuId"]) === null) return;

	this["oPopupMenu"] = this["oGetControlById"](this["sPopupMenuId"], true);

	if (this["oPopupMenu"] && this["bHasPopupMenu"]) {
		this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onPopupMenuClose");
	}

	this["oPopupMenu"]["setAutoRefocus"](true); // refocus this element if popup menu is closed

	if (this["oPopupMenu"]["bOpened"]) return;

	this["oPopupMenu"]["setOpenerRef"](this["oDomRef"]);
	this["oPopupMenu"]["setOpenerId"](this["sId"]);
	this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);

	if (!this["bDelegateOpenMenu"]) {
		this["oPopupMenu"]["open"](bWithKeyboard); // bWithKeyboard=true --> opened by keyboard --> select first entry
	} else {
		this["fireEvent"](this["E_EVENTS"]["OpenMenu"], { "sId": this["sId"], "sMenuId": this["sPopupMenuId"] });
	}
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["openMenu"] = 0; };

/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @param {UCF_BrowserEvent} oEvent  when the menu is closed
 * @private
 */
UCF_LargeButton["prototype"]["onPopupMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onPopupMenuClose"]++; }; 

	if (this["oPopupMenu"] && this["bHasPopupMenu"]) {
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onPopupMenuClose");
	}
	this["toggleMenuButton"](false);

};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onPopupMenuClose"] = 0; };
/**
 * Toggles the menu visibility and fires all the necessary events
 *
 * @param {boolean} bWithKeyboard determines if popup was opened with keyboard or mouse
 * @private
 */
UCF_LargeButton["prototype"]["toggleMenu"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["toggleMenu"]++; }; 
	if (!this["bHasPopupMenu"]) return;

	if (this["sPopupMenuId"] === ''
		|| this["oGetControlById"](this["sPopupMenuId"]) == null
		|| (this["oPopupMenu"] && !this["oPopupMenu"]["bIsValid"]())) {
		// used for loading on demand menue - fire only event if PopupMenu
		// doesn't exists or isn't valid (e.g. caused by popupMenu.setRemoveOnClose(true))
		this["fireMenuAccess"](this["sId"], this["sPopupMenuId"]);

		return;
	}
	this["oPopupMenu"] = this["oGetControlById"](this["sPopupMenuId"], true);
	if (this["oPopupMenu"] && this["bHasPopupMenu"]) {
		this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onPopupMenuClose");
	}

	if (this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"]();
		this["toggleMenuButton"](false);
		this["oPopupMenu"] = null;
	} else {
		this["fireMenuAccess"](this["sId"], this["sPopupMenuId"]);
		this["openMenu"](bWithKeyboard);
		this["toggleMenuButton"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["toggleMenu"] = 0; };

UCF_LargeButton["prototype"]["toggleMenuButton"] = function(down) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["toggleMenuButton"]++; }; 
	if (!this["bEnabled"]) return;

	if (down) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsLargeButton--menu-push');
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsLargeButton--menu-push');
	}
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["toggleMenuButton"] = 0; };

/**
 * Handles the onlsshow event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LargeButton["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onlsshow"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LargeButton.js(527): onlsshow"); };
	// fired by keyboard - F4 and Alt+cursor down

	if (!this["bEnabled"]) return;

	if (this["bHasPopupMenu"]) {
		this["toggleMenu"](true);
		oBrowserEvent["cancel"](); // cancel event to avoid browser handling of F4
	}

};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["onlsshow"] = 0; };

/**
 * Set ID of the popup menu connected to the button. Cleans up a previous existing popup menu
 *
 * @param {string} sPopupMenuId ID of popup menu
 * @public
 */
UCF_LargeButton["prototype"]["setPopupMenuId"] = function(sPopupMenuId) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["setPopupMenuId"]++; }; 
	if (this["oPopupMenu"] && this["oPopupMenu"]["sId"] !== sPopupMenuId) {
		// clenup an existing PopupMenu object to be able to create a new one
		if (this["oPopupMenu"]["bIsValid"]() && this["oPopupMenu"]["bOpened"])
			this["oPopupMenu"]["close"]();
		this["oPopupMenu"] = null;
	}
	this["sPopupMenuId"] = sPopupMenuId;
	this["setClientProperty"]("PopupMenuId", this["sPopupMenuId"], true);
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["setPopupMenuId"] = 0; };

/**
 * Get ID of the popup menu connected to the button.
 *
 * @return {string} sPopupMenuId ID of popup menu
 * @public
 */

UCF_LargeButton["prototype"]["sGetPopupMenuId"] = function() {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["sGetPopupMenuId"]++; }; 
	return this["sPopupMenuId"];
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["sGetPopupMenuId"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_LargeButton["prototype"]["aAttributeNames"] = ["sTooltip","bEnabled","sVisibility","bDown","bHasIcon","sDisabledIconSrc","sUpIconSrc","sDownIconSrc","sAccessKey","sHotKey","sInteractionBehaviour","sFontSize","bHasPopupMenu","sPopupMenuId","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_LargeButton["prototype"]["aEventNames"] = ["Press","MenuAccess"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_LargeButton["prototype"]["aMethodNames"] = ["setEnabled","getEnabled","openMenu","setPopupMenuId","sGetPopupMenuId","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_LargeButton["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_LargeButton["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_LargeButton["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_LargeButton["prototype"]["bDown"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_LargeButton["prototype"]["bHasIcon"] = true;

/**
 * @private
 * @type {string}
 */
UCF_LargeButton["prototype"]["sDisabledIconSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_LargeButton["prototype"]["sUpIconSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_LargeButton["prototype"]["sDownIconSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_LargeButton["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HotkeyValue}
 */
UCF_LargeButton["prototype"]["sHotKey"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ButtonInteractionBehaviour}
 */
UCF_LargeButton["prototype"]["sInteractionBehaviour"] = "PUSH";

/**
 * @private
 * @type {string}
 */
UCF_LargeButton["prototype"]["sFontSize"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_LargeButton["prototype"]["bHasPopupMenu"] = false;

/**
 * @private
 * @type {string}
 */
UCF_LargeButton["prototype"]["sPopupMenuId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_LargeButton["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_LargeButton["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["sVisibility"] = "VISIBLE";
	this["bDown"] = false;
	this["bHasIcon"] = true;
	this["sDisabledIconSrc"] = '';
	this["sUpIconSrc"] = '';
	this["sDownIconSrc"] = '';
	this["sAccessKey"] = '';
	this["sHotKey"] = "NONE";
	this["sInteractionBehaviour"] = "PUSH";
	this["sFontSize"] = '';
	this["bHasPopupMenu"] = false;
	this["sPopupMenuId"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Down", false, true);
		this["setClientProperty"]("HasIcon", true, true);
		this["setClientProperty"]("DisabledIconSrc", '', true);
		this["setClientProperty"]("UpIconSrc", '', true);
		this["setClientProperty"]("DownIconSrc", '', true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("HotKey", "NONE", true);
		this["setClientProperty"]("InteractionBehaviour", "PUSH", true);
		this["setClientProperty"]("FontSize", '', true);
		this["setClientProperty"]("HasPopupMenu", false, true);
		this["setClientProperty"]("PopupMenuId", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the Button control in the current HTML document context. The Id of any control should be unique within the document.
 * @fires LargeButton::Press
 */
UCF_LargeButton["prototype"]["firePress"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["firePress"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "LargeButton.js(726): firePress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "LargeButton.js(727): firePress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "LargeButton.js(728): firePress"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("LargeButton", "Press", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["firePress"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Button control in the current HTML document context. The Id of any control should be unique within the document.
 * @param {string} sPopupMenuId Identifier assigned PopupMenu in the current HTML document context. The Id of any control should be unique within the document.
 * @fires LargeButton::MenuAccess
 */
UCF_LargeButton["prototype"]["fireMenuAccess"] = function(sId, sPopupMenuId) {;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string, PopupMenuId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "LargeButton.js(748): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "LargeButton.js(749): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "LargeButton.js(750): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPopupMenuId != null, "sPopupMenuId != null", "LargeButton.js(751): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPopupMenuId) == "string", "typeof(sPopupMenuId) == \"string\"", "LargeButton.js(752): fireMenuAccess"); };
	mParams = {
		"Id": sId,
		"PopupMenuId": sPopupMenuId
	};
	
	if (sPopupMenuId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sPopupMenuId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "PopupMenuId");
			}
		}
	this["fireSemanticEvent"]("LargeButton", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_LargeButton["_"]["fireMenuAccess"] = 0; };

UCF_LargeButton.prototype["aPublicMethods"] = ["setEnabled","openMenu","setPopupMenuId"].concat(UCF_LargeButton.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_LayerHelper"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_LayeredControl */
/// <reference path="../controls/base/LayeredControl.js"/>
/* global UCF_PopupManager */
/// <reference path="./PopupManager.js"/>

/**
 * A helper class to handle layering of LayerdControl instances that need to stay opened when a PopupWindow is opened.
 * This is actually not really supported by LS framework. LayeredControls have a higher z-index than PopupWindows - hard-coded in UCF_LS.E_LAYERS.
 * The helper will modify the z-index on-the-fly as a workaround.
 *
 * When fumbling with the z-index, we have to support layering with multible open Popups and also preserve the order of parent/child LayeredControls.
 * To make this work we had to add UCF_PopupManager.ZINDEX_INCREMENT to make room 'between' stacked PopupWindows and/or the BlockLayer.
 * So now there is room for 9 nested LayeredControls between stacked Popups or a Popup and the Blocklayer.
 *
 * When calling handleOpen() during control's initialize() it should be done delayed.
 *
 * @param {UCF_LayeredControl} oLayeredControl The control instance for which the z-index is handled.
 * @class
 * @example <caption>Usage example</caption>
 * function UCF_MyControl(...) {
 *   ...
 *   this.oLH = UCF_ClassLoader.oGetClass('UCF_LayerHelper').create(this);
 * }
 * UCF_MyControl.prototype.destroy = function() {
 *   this.oLH.destroy();
 * }
 * UCF_MyControl.prototype.open = function() {
 *  this.oLH.handleOpen();
 * }
 */
function UCF_LayerHelper(oLayeredControl) {if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["UCF_LayerHelper"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLayeredControl instanceof UCF_LayeredControl, "oLayeredControl instanceof UCF_LayeredControl", "LayerHelper.js(40): UCF_LayerHelper"); };

	/** @type {UCF_LayeredControl} */
	this["oLayeredControl"] = oLayeredControl;

	UCF_Object["apply"](this);

	/** @type {UCF_PopupManager} */
	var oPM = this["oLayeredControl"]["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]();
	oPM["attachEvent"](oPM["E_EVENTS"]["PopupOpen"], this, 'handlePopupOpen');
	oPM["attachEvent"](oPM["E_EVENTS"]["PopupClose"], this, 'handlePopupClose');
	// oPM.attachEvent(oPM.E_EVENTS.WindowOpen, this, 'handlePopupOpen');
	// oPM.attachEvent(oPM.E_EVENTS.WindowClose, this, 'handlePopupClose');

	// This value needs to be calculated and remembered in event handlers handlePopupOpen/Close()
	// but also during handleOpen() to handle also full-updates where the "stacked" popups
	// and PopOvers are not initialized in the stacking order (e.g. in WDA all Popovers are
	// at the end of the list when OpenPopup events were already fired)
	this["sBlockedByPopupId"] = null; // eslint-disable-line @ur/no-memory-leaks
};window["UCF_LayerHelper"] = UCF_LayerHelper; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LayerHelper"); UCF_LayerHelper["_"] = {UCF_LayerHelper: 0}; }; ;
UCF_LayerHelper["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_LayerHelper.prototype["sClassName"] = "UCF_LayerHelper";

/**
 * Call in constructor of control instance.
 * @param {UCF_LayeredControl} oLayeredControl The control instance for which the z-index is handled.
 * @return {UCF_LayerHelper} The helper instance
 * @public
 */
UCF_LayerHelper["create"] = function(oLayeredControl) {;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["create"]++; }; 
	return new (UCF_ClassLoader["oGetClass"]("UCF_LayerHelper"))(oLayeredControl);
};;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["create"] = 0; };

/**
 * Call in destroy method of control instance.
 * @public
 */
UCF_LayerHelper["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["destroy"]++; }; 
	var oPM = this["oLayeredControl"]["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]();
	this["oLayeredControl"] = null;

	oPM["detachEvent"](oPM["E_EVENTS"]["PopupOpen"], this);
	oPM["detachEvent"](oPM["E_EVENTS"]["PopupClose"], this);
	oPM["detachEvent"](oPM["E_EVENTS"]["WindowOpen"], this);
	oPM["detachEvent"](oPM["E_EVENTS"]["WindowClose"], this);
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["destroy"] = 0; };

/**
 * Call in open method of control instance.
 * @public
 */
UCF_LayerHelper["prototype"]["handleOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["handleOpen"]++; }; 
	var sOpenerId = this["oLayeredControl"]["sOpenerId"] || this["oLayeredControl"]["oOpenerRef"]["id"];
	var oParentPopup = this["oLayeredControl"]["oGetParentPopupWindow"](UCF_DomUtil["$"](sOpenerId));
	if (oParentPopup) {
		// The opener is contained inside a popup
		/** @type {UCF_PopupWindow} */
		var oBlockedBy = this["oLayeredControl"]["oLS"]["oGetPopupManagerInternal"]()["oGetNextPopup"](oParentPopup);
		if (oBlockedBy) {
			this["sBlockedByPopupId"] = oBlockedBy["sId"];
			/** @type {UCF_PopupWindow} */
			var oOnTop = this["oLayeredControl"]["oLS"]["oGetPopupManagerInternal"]()["oGetTopPopup"]();
			if (oBlockedBy === oOnTop) {
				this["layerBehindBlockLayer"](oOnTop["bIsDivPopup"]);
			} else {
				this["layerBehindPopup"](this["sBlockedByPopupId"]);
			}
		}
	} else {
		// The opener is on the main-page but maybe blocked by a popup -> get behind BlockLayer (only one popup) OR the first open popup on the stack
		var iPC = this["oLayeredControl"]["oLS"]["oGetPopupManagerInternal"]()["iGetPopupCount"]();
		if (iPC > 0) {
			this["sBlockedByPopupId"] = this["oLayeredControl"]["oLS"]["oGetPopupManagerInternal"]()["oGetFirstModalPopup"]()["sId"];
			if (iPC === 1) {
				this["layerBehindBlockLayer"]();
			} else {
				this["layerBehindPopup"](this["sBlockedByPopupId"]);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["handleOpen"] = 0; };

UCF_LayerHelper["prototype"]["layerBehindBlockLayer"] = function(bIsDivPopup) {;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["layerBehindBlockLayer"]++; }; 
	var iBetween = this["oLayeredControl"]["oLS"]["oGetPopupManagerInternal"]()["oGetBlockLayer"](bIsDivPopup)["iGetZIndex"]() - UCF_PopupManager["ZINDEX_INCREMENT"] + 10;
	this["oLayeredControl"]["oRootRef"]["style"]["zIndex"] = iBetween + this["oLayeredControl"]["iChildLayerZIndexIncrement"]; // See UCF_LayeredControl.handleParentLayersOnOpen()
};;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["layerBehindBlockLayer"] = 0; };

UCF_LayerHelper["prototype"]["layerBehindPopup"] = function(sPWId) {;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["layerBehindPopup"]++; }; 
	// Support IFrame-popups: oGetControlById() needs to be done on the popup-LS-instance
	var oPopupLS = this["oLayeredControl"]["oLS"]["oGetPopupManagerInternal"]()["oGetLSByPopupId"](sPWId);
	var iBetween = oPopupLS["oControlFactory"]["oGetControlById"](sPWId)["iGetZIndex"]() - UCF_PopupManager["ZINDEX_INCREMENT"] + 10;
	this["oLayeredControl"]["oRootRef"]["style"]["zIndex"] = iBetween + this["oLayeredControl"]["iChildLayerZIndexIncrement"]; // See UCF_LayeredControl.handleParentLayersOnOpen()
};;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["layerBehindPopup"] = 0; };

/**
 * @param {UCF_Event} oEvent
 * @param {boolean} bDelayed
 */
UCF_LayerHelper["prototype"]["handlePopupOpen"] = function(oEvent, bDelayed) {;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["handlePopupOpen"]++; }; 
	if (!this["oLayeredControl"]["bOpened"] && bDelayed !== true) {
		// Process delayed: Popup-Open-event fired during initialize, Popover is purged but not yet initialized/opened
		UCF_JsUtil["delayedCall"](0, this, 'handlePopupOpen', [oEvent, true]);
	}
	if (this["sBlockedByPopupId"] == null) {
		this["iStoreZIndex"] = this["oLayeredControl"]["oRootRef"]["style"]["zIndex"]; // eslint-disable-line @ur/no-memory-leaks
		this["sBlockedByPopupId"] = oEvent["mParameters"]["sPopupId"];
		this["layerBehindBlockLayer"]();
	} else {
		// Already blocked by a popup opened before
		// Re-calculate z-index: New nested Popup was created, the referenced popup (sBlockedByPopupId)
		// will have a different z-index (behind the block-layer)
		// by the PopupManager.updateZIndex() algorithm
		var sPopupId = oEvent["mParameters"] ? oEvent["mParameters"]["sPopupId"] : null;
		if (sPopupId) {
			if (this["sBlockedByPopupId"] !== sPopupId) {
				this["layerBehindPopup"](this["sBlockedByPopupId"]);
			}
			// else: Do nothing - z-index already calculated in handleOpen()
		}
		else {
			this["layerBehindPopup"](this["sBlockedByPopupId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["handlePopupOpen"] = 0; };

/**
 * @param {UCF_Event} oEvent
 */
UCF_LayerHelper["prototype"]["handlePopupClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["handlePopupClose"]++; }; 
	if (!this["oLayeredControl"]["bOpened"]) return;
	if (this["sBlockedByPopupId"] == null) return;
	if (oEvent["mParameters"]["sPopupId"] === this["sBlockedByPopupId"]) {
		this["oLayeredControl"]["oRootRef"]["style"]["zIndex"] = this["iStoreZIndex"];
		this["iStoreZIndex"] = null;
		this["sBlockedByPopupId"] = null;
	} else {
		var oTopPW = this["oLayeredControl"]["oLS"]["oGetPopupManagerInternal"]()["oGetTopPopup"]();
		if (oTopPW && this["sBlockedByPopupId"] === oTopPW["sId"]) {
			this["layerBehindBlockLayer"]();
		} else {
			// Re-calculate because z-index of Popup has changed
			this["layerBehindPopup"](this["sBlockedByPopupId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["handlePopupClose"] = 0; };

/**
 * @return {boolean}
 */
UCF_LayerHelper["prototype"]["bIsBehindBlockLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["bIsBehindBlockLayer"]++; }; 
	return this["oLayeredControl"]["oLS"]["oGetPopupManagerInternal"]()["bControlIsBlocked"](this["oLayeredControl"]);
};;if (__UCF_COVERAGE__) { UCF_LayerHelper["_"]["bIsBehindBlockLayer"] = 0; };

UCF_LayerHelper.prototype["aPublicMethods"] = ["create","destroy","handleOpen"].concat(UCF_LayerHelper.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_LayeredControl"] = function() {/* global _assert, _trace, INFO, ERROR, WARNING */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_ChildLayerDelegate */
/// <reference path="./ChildLayerDelegate.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>

/**
 * Implements a layered control that offers certain features for positioning
 * and alignment to other controls.
 *
 * @class
 * @extends UCF_Control
 *
 * @param {HTMLElement} oDomRef the DOM element
 * @param {UCF_LS} oLS the LightSpeed instance
 */
function UCF_LayeredControl(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["UCF_LayeredControl"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "LayeredControl.js(32): UCF_LayeredControl"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["defineEvents"](['Close']);

		/** @type {number} */
		this["iOffsetLeft"] = 0; // eslint-disable-line @ur/no-memory-leaks
		/** @type {number} */
		this["iOffsetTop"] = 0; // eslint-disable-line @ur/no-memory-leaks
		/** @type {number} */
		this["iOverlap"] = 0; // eslint-disable-line @ur/no-memory-leaks
		/** @type {number} */
		this["iTop"] = null; // eslint-disable-line @ur/no-memory-leaks
		/** @type {number} */
		this["iLeft"] = null; // eslint-disable-line @ur/no-memory-leaks
		/** @type {boolean} */
		this["bOpened"] = false; // eslint-disable-line @ur/no-memory-leaks
		/** @type {HTMLElement} */
		this["oOpenerRef"] = null;
		/** @type {HTMLElement} Used only for parent - child layering (QuickView/Popover) */
		this["oOpenerRefForLayering"] = null;
		/** @type {number} */
		this["iOpenYDirection"] = 1;
		/** @type {HTMLElement} */
		this["oPlaceHolderRef"] = null;
		/** @type {boolean} layered control shall be horizontally moved to fit into the viewport */
		this["bMoveX"] = true; // eslint-disable-line @ur/no-memory-leaks
		/** @type {boolean} layered control shall be vertically moved to fit into the viewport */
		this["bMoveY"] = false; // eslint-disable-line @ur/no-memory-leaks
		/** @type {boolean} */
		this["bAlreadyDestroyed"] = false;
		/** @type {boolean} */
		// this.bParentLayerHandlerCalled = false;
		/** @type {number} */
		this["iSafetyDistance"] = 0; // eslint-disable-line @ur/no-memory-leaks

		this["reset"]();

		/**
		 * Default alignment, control may call setAlignment()
		 * @type {number}
		 */
		this["iAlignment"] = UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]; // eslint-disable-line @ur/no-memory-leaks

		/**
		 * Algo. in setPosition() may switch to different alignment or
		 * calculate an additional offset
		 * @type {number}
		 */
		// this.iAlignmentResult = this.iAlignment;
		// /** @type {number} */
		// this.iLeftOffsetResult = 0;

		/**
		 * Default: no "parent" layered control
		 * @type {boolean}
		 */
		this["bIsParent"] = false;

		/**
		 * Currently opened child layer, e.g. PopupMenu inside QuickView
		 * @type {UCF_LayeredControl}
		 */
		this["oChildLayer"] = null;
		/** @type {number} */
		this["iChildLayerZIndex"] = -1; // eslint-disable-line @ur/no-memory-leaks
		/** @type {number} */
		this["iChildLayerZIndexIncrement"] = 0; // eslint-disable-line @ur/no-memory-leaks

		/** @type {Window} */
		this["oWindow"] = window;

		// Default zIndex
		if (this["oRootRef"]) {
			this["oRootRef"]["style"]["zIndex"] = UCF_LS["E_LAYERS"]["POPUPMENUS"];
		}
		// DOM-marker
		oDomRef["setAttribute"]('ls-layeredcontrol', 'X');

		/** @type {boolean} */
		this["bEnhancePopupWindow"] = false;
	}
};window["UCF_LayeredControl"] = UCF_LayeredControl; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LayeredControl"); UCF_LayeredControl["_"] = {UCF_LayeredControl: 0}; }; ;
UCF_LayeredControl["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_LayeredControl.prototype["sClassName"] = "UCF_LayeredControl";

/**
 * Alignment of the layered control
 *
 * @constant
 * @enum {number}
 */
UCF_LayeredControl["ALIGNMENT"] = {
	"TOPLEFT": 0,
	"TOPRIGHT": 1,
	"BOTTOMLEFT": 3,
	"BOTTOMRIGHT": 4,
	"BROWSERCENTER": 5,
	"POSITION": 6,
	"MENUITEM": 7,
	"TOPLEFT_CONTAINER": 8,
	"TOPRIGHT_CONTAINER": 9,
	"TOPCENTER": 10,
	"BOTTOMCENTER": 11,
	"RIGHT": 12,
	"OVERLAY": 13 // full screen (e.g. used for phones)
};

/** @constant {string} */
UCF_LayeredControl["BOX_SHADOW_CLASS"] = 'lsLCDropShadow';

/** @constant {string} */
UCF_LayeredControl["PARENT_LAYER_OPEN"] = 'bIsParentLayerOpen';

/** @constant {number} */
UCF_LayeredControl["MIN_BORDER_DISTANCE"] = UCF_DomUtil["iRem2px"](0.5);

/** @override */
UCF_LayeredControl["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["destroy"]++; }; 
	if (!this["bAlreadyDestroyed"] && this["oRootRef"] != null) {
		if (this["oOpenerRef"]) {
			this["oOpenerRef"] = null;
		}
		this["bAlreadyDestroyed"] = true;
		if (this["bOpened"])
			this["notifyLayeredControlClose"]();
		// We have to release the blind-layer:
		// It is unspecified whether close() must be called before a destroy()
		// or if a control that extends LayeredControl must call close() in its
		// destroy implementation, or ...
		if (this["oBlindLayer"]) {
			this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
			this["oBlindLayer"] = null;
		}

		if (this["oPlaceHolderRef"]) {
			UCF_DomUtil["removeFromDom"](this["oRootRef"]);
			UCF_DomUtil["removeFromDom"](this["oPlaceHolderRef"]);
			this["oPlaceHolderRef"] = null;
		}

		if (UCF_JsUtil["bIsFunction"](UCF_LayeredControl["forwardResizeEvent"])) {
			UCF_DomUtil["detachEvent"](window, 'resize', UCF_LayeredControl["forwardResizeEvent"]);
		}

		this["oChildLayer"] = null;
		this["oWindow"] = null;
		this["_oViewportObjectRect"] = null;
		this["_oVisualViewport"] = null;
		this["_iHeight"] = null;
		this["_iWidth"] = null;
		UCF_Control.prototype["destroy"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["destroy"] = 0; };

/**
 * @private
 * @return {boolean} `true` if this control identifies itself as a parent for
 * other layered controls
 */
UCF_LayeredControl["prototype"]["bIsParentLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsParentLayer"]++; }; 
	return this["bIsParent"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsParentLayer"] = 0; };

/**
 * @private
 * @param {boolean} bOpen `true` to set parent layer opened
 */
UCF_LayeredControl["prototype"]["setParentLayerOpened"] = function(bOpen) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setParentLayerOpened"]++; }; 
	/** @type {HTMLDivElement} */
	var oAssoAreaRef = this["oLS"]["oGetAssociatedAreaRef"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof bOpen === 'boolean', "typeof bOpen === 'boolean'", "LayeredControl.js(204): setParentLayerOpened"); };
	if (bOpen) {
		oAssoAreaRef["setAttribute"](UCF_LayeredControl["PARENT_LAYER_OPEN"], '1');
	} else {
		oAssoAreaRef["removeAttribute"](UCF_LayeredControl["PARENT_LAYER_OPEN"]);
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setParentLayerOpened"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bGetParentLayerOpened"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bGetParentLayerOpened"]++; }; 
	return !!this["oLS"]["oGetAssociatedAreaRef"]()["getAttribute"](
		UCF_LayeredControl["PARENT_LAYER_OPEN"]
	);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bGetParentLayerOpened"] = 0; };

/**
 * Checks if the opener control has a parent that is a LayeredControl.
 * If <code>bIsParentLayer==true</code> the control instance is returned.
 * Returns null if no LayeredControl was found or if <code>bIsParentLayer()==false</code>.
 * @return {UCF_Control}
 * @private
 */
UCF_LayeredControl["prototype"]["oFindParentLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oFindParentLayer"]++; }; 

	// Do not start search if there is currently no parent layer opened
	if (this["bGetParentLayerOpened"]() === false) return null;

	var oStopAtDomRef = this["oLS"]["oGetAssociatedAreaRef"]();
	var oDom = this["oOpenerRefForLayering"] || this["oGetOpenerRef"]();

	while (oDom != null && oDom !== document["body"]) {
		if (oStopAtDomRef && oDom === oStopAtDomRef) return null;

		var oCtrl = this["oGetControlByDomRef"](oDom, false);
		if (oCtrl && UCF_JsUtil["bInstanceOf"](oCtrl, "UCF_LayeredControl") && oCtrl["bIsParentLayer"]()) {
			return oCtrl;
		}

		oDom = oDom["parentNode"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oFindParentLayer"] = 0; };

/**
 * Called in handleParentLayersOnOpen() of child layer.
 * @param {UCF_LayeredControl} oChild
 * @private
 */
UCF_LayeredControl["prototype"]["registerChildLayer"] = function(oChild) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["registerChildLayer"]++; }; 
	// Handle closing: Support only a single child (PopupMenu will close all open submenus)
	if (this["oChildLayer"] == null || this["oChildLayer"]["bAlreadyDestroyed"]) {
		this["oChildLayer"] = oChild;
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["registerChildLayer"] = 0; };

/**
 * Overwrite in derived class. Called by ChildLayerDelegate
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_LayeredControl["prototype"]["notifyChildLayerMouseOver"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyChildLayerMouseOver"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyChildLayerMouseOver"] = 0; };

/**
 * Overwrite in derived class. Called by ChildLayerDelegate
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_LayeredControl["prototype"]["notifyChildLayerMouseOut"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyChildLayerMouseOut"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyChildLayerMouseOut"] = 0; };

/**
 * The dom reference of the opener control, that should be used for alignment.
 *
 * @param {HTMLElement} oDomRef dom object to align with
 */
UCF_LayeredControl["prototype"]["setOpenerRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOpenerRef"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "LayeredControl.js(286): setOpenerRef"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "LayeredControl.js(287): setOpenerRef"); };
	this["oOpenerRef"] = oDomRef;
	// Workaround: Some control sabotage the position calculation (oGetObjectRect) by having a oDomRef element
	// with position:absolute, top:-10000, visibility:hidden (e.g. CheckBox)
	// => Use the oRootRef
	if (UCF_DomUtil["sGetCurrentStyle"](this["oOpenerRef"], 'visibility') === 'hidden') {
		var oTmp = this["oGetControlByDomRef"](this["oOpenerRef"]);
		if (oTmp) {
			this["oOpenerRef"] = oTmp["oRootRef"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOpenerRef"] = 0; };

/**
 * Returns the dom reference of the opener control, that should be used for parent layer calculation.
 * May be overwritten in derived class (e.g. cascading menus should not return the parent menu but the real opener).
 *
 * @return {HTMLElement} oDomRef dom object of the opener control
 */
UCF_LayeredControl["prototype"]["oGetOpenerRef"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetOpenerRef"]++; }; 
	return this["oOpenerRef"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetOpenerRef"] = 0; };

/**
 * Check position of the root ref in the DOM and replace if needed.
 * If there is an old version of the same element remove it.
 */
UCF_LayeredControl["prototype"]["checkRootRef"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["checkRootRef"]++; }; 
	var oLSRootRef = this["oLS"]["oGetRootRef"](),
		oAssoArea = this["oLS"]["oGetAssociatedAreaRef"]();
	// if the menu is alread in the associated area of page exit without adding a placeholder
	if (oLSRootRef !== oAssoArea && UCF_DomUtil["bContains"](oAssoArea, this["oRootRef"])) {
		// Exception: If it is contained inside a DIV-popup, which is located in the asso-area
		var oPopupWindow = this["oGetParentPopupWindow"](this["oRootRef"]);
		if (!(oPopupWindow && oPopupWindow["bIsDivPopup"])) return;
	}
	if (this["oRootRef"]["parentNode"] !== oLSRootRef && UCF_DomUtil["bContains"](oLSRootRef, this["oRootRef"])) {
		this["oPlaceHolderRef"] = document["createElement"]("span");
		this["oPlaceHolderRef"]["style"]["display"] = "none";
		this["oPlaceHolderRef"]["id"] = this["sId"] + "-ph";
		this["oRootRef"]["parentNode"]["replaceChild"](this["oPlaceHolderRef"], this["oRootRef"]);
		// If The iPad-FLP-IFrame-woraround of the Page is used
		// don't move the stuff to the end of the body (LSRootRef), always move into asso. area instead.
		// Because WebGUI will render PopupMenu to the Page-content that get moved AND use Sub-Menus which are rendered in the assoc-area
		// in which case the z-index handling cannot work!
		if (this["oLS"]["oGetPageInternal"]()["bInsideShellIFrameOnIOS"]()) {
			oAssoArea["appendChild"](this["oRootRef"]);
		} else {
			oLSRootRef["appendChild"](this["oRootRef"]);
		}

		if (UCF_DomUtil["bContains"](this["oRootRef"], this["oDomRef"])) {
			// All ID duplicates which can be found by getElementById have to be
			// removed from DOM see CSN 2596413 2008
			UCF_DomUtil["removePreviousIdDuplicates"](this["oRootRef"]);
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Inconsistent oRootRef/oDomRef in control \"" + this["sId"] + "\"", "LayeredControl.js(343): checkRootRef"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["checkRootRef"] = 0; };

/**
 * Checks if the control has a valid DOM reference.
 * This can be used for timeout methods, that may be called after the HTML
 * of the control has already been removed.
 *
 * @return {boolean} Whether the control has a valid DOM reference
 */
UCF_LayeredControl["prototype"]["bIsValid"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsValid"]++; }; 
	var oDomRef = UCF_DomUtil["$"](this["sId"]),
		oRootRef = UCF_DomUtil["$"](this["sId"] + "-r"),
		oPlaceHolderRef = UCF_DomUtil["$"](this["sId"] + "-ph");
	if (!oRootRef) oRootRef = oDomRef;
	if (this["oRootRef"] !== oRootRef) return false;
	if (this["oPlaceHolderRef"]) {
		return (oPlaceHolderRef === this["oPlaceHolderRef"] && oDomRef === this["oDomRef"]);
	} else if (oDomRef) {
		return (oDomRef === this["oDomRef"]);
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsValid"] = 0; };

/**
 * Returns the parent control of this LayeredControl. Special handling is needed in case a
 * placeholder is used.
 *
 * @return {UCF_Control} the parent control
 */
UCF_LayeredControl["prototype"]["oGetParent"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetParent"]++; }; 
	if (!this["oParentControl"]) {
		var oDomRef = this["oPlaceHolderRef"] || this["oRootRef"];
		if (oDomRef) {
			this["oParentControl"] = this["oFindParent"](oDomRef);
		}
	}
	return this["oParentControl"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetParent"] = 0; };

/**
 * Show the layered control
 */
UCF_LayeredControl["prototype"]["open"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["open"]++; }; 
	this["openBase"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["open"] = 0; };

/**
 * Hide the layered control
 */
UCF_LayeredControl["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["close"]++; }; 
	this["closeBase"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["close"] = 0; };

/**
 * Can be overwritten in the control, e.g. if it should have a drop shadow.
 * @private
 */
UCF_LayeredControl["prototype"]["addClassesOnOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["addClassesOnOpen"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["addClassesOnOpen"] = 0; };

/**
 * Call this in your "open" code if you need to overwrite the open/openBase functions !
 */
UCF_LayeredControl["prototype"]["handleParentLayersOnOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handleParentLayersOnOpen"]++; }; 
	// See internal message 2170238387
	// if (this.bParentLayerHandlerCalled) return;

	var oParentLayer = this["oFindParentLayer"]();
	if (oParentLayer) {
		// Make sure z-index is higher than parent layer
		// otherwise we would depend on the DOM order inside asso. area
		this["iChildLayerZIndex"] = parseInt(oParentLayer["oRootRef"]["style"]["zIndex"], 10) + 10;
		this["iChildLayerZIndexIncrement"] = this["iChildLayerZIndex"] - UCF_LS["E_LAYERS"]["POPUPMENUS"];
		this["oRootRef"]["style"]["zIndex"] = this["iChildLayerZIndex"];

		// Parent (e.g. QuickView) has to know the child (close)
		oParentLayer["registerChildLayer"](this);

		// Register delegate that handles mouseover/out and reports to parent layer
		this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_ChildLayerDelegate"))(this["oLS"], oParentLayer));

		//this.bParentLayerHandlerCalled = true;
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handleParentLayersOnOpen"] = 0; };

/**
 * The base method for showing the layered control. This is needed because we do not
 * have the possibility to call the super implementation of a method
 * @return {boolean} Returns whether the control was actually opened (false: it may be already open or already destroyed)
 */
UCF_LayeredControl["prototype"]["openBase"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["openBase"]++; }; 

	if (this["bAlreadyDestroyed"]) {
		return false;
	}

	this["notifyLayeredControlOpen"]();
	this["handlePopupWindowLayerOpen"]();

	// Enable "re-open" (for QuickView)
	// It was kept alive during page update
	if (this["bKeepAlive"] && this["bOpened"] && UCF_DomUtil["sGetCurrentStyle"](this["oRootRef"], 'visibility') === 'hidden') {
		this["bOpened"] = false;
	}

	if (this["bOpened"]) {
		this["setPosition"]();
		return false;
	}

	this["checkRootRef"]();

	// Make it visible first, but set top:-10000 so it does not
	// enlarge the window.innerHeight in case it is moved to the end
	// of the body (by checkRootRef())
	UCF_DomUtil["setStyle"](this["oRootRef"], {
		"visibility": 'visible',
		"display": 'block',
		"overflow": 'visible',
		"top": '-10000px'
	});

	var self = this;
	UCF_LayeredControl["forwardResizeEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["forwardResizeEvent"]++; }; 
		if (!self["bIsDestroyed"]) {
			self["onresize"]();
		}
	};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["forwardResizeEvent"] = 0; };
	UCF_DomUtil["attachEvent"](window, 'resize', UCF_LayeredControl["forwardResizeEvent"]);

	this["applyZIndex"]();
	this["addClassesOnOpen"]();
	this["handleParentLayersOnOpen"]();

	this["setOpened"](true);
	this["setPosition"]();
	this["notifyLayerVisible"]();
	return true;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["openBase"] = 0; };

UCF_LayeredControl["prototype"]["applyZIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["applyZIndex"]++; }; 
	if (this["oRootRef"]) {
		this["oRootRef"]["style"]["zIndex"] = this["iChildLayerZIndex"] !== -1 ? this["iChildLayerZIndex"] : UCF_LS["E_LAYERS"]["POPUPMENUS"];
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["applyZIndex"] = 0; };

UCF_LayeredControl["prototype"]["handlePopupWindowLayerOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handlePopupWindowLayerOpen"]++; }; 
	if (this["bEnhancePopupWindows"]) {
		var oPopupWindow = this["oGetParentPopupWindow"](this["oOpenerRef"]);
		if (oPopupWindow && oPopupWindow["bIsIFramePopup"]()) {
			oPopupWindow["openLayeredControl"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handlePopupWindowLayerOpen"] = 0; };

UCF_LayeredControl["prototype"]["handlePopupWindowLayerClose"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handlePopupWindowLayerClose"]++; }; 
	if (this["bEnhancePopupWindows"]) {
		var oPopupWindow = this["oGetParentPopupWindow"](this["oOpenerRef"]);
		if (oPopupWindow && oPopupWindow["bIsIFramePopup"]()) {
			oPopupWindow["closeLayeredControl"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handlePopupWindowLayerClose"] = 0; };

/**
 * The base method for hiding the layered control. This is needed because we do not
 * have the possibility to call the super implementation of a method
 * @return {boolean} Return true if the control was actually closed (false: Was not open or already destroyed)
 */
UCF_LayeredControl["prototype"]["closeBase"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["closeBase"]++; }; 
	if (!this["bOpened"]) return false;

	this["handlePopupWindowLayerClose"]();

	// This is a workaround:
	// ComboBox calls ListBox.close() in its destroy() method which is a bad idea because ListBox could already be destroyed
	// because the order in LS.purgeControls() is random !
	if (this["bAlreadyDestroyed"]) {
		// Release blind-layer !
		this["setOpened"](false);

		return false;
	}

	if (UCF_JsUtil["bIsFunction"](UCF_LayeredControl["forwardResizeEvent"])) {
		UCF_DomUtil["detachEvent"](window, 'resize', UCF_LayeredControl["forwardResizeEvent"]);
	}

	UCF_DomUtil["setStyle"](this["oRootRef"], {
		// set it in the invisible part of the screen
		"top": (this["oRootRef"]["offsetHeight"] * -1) - 1,
		"visibility": 'hidden',
		"display": 'none'
	});

	this["setOpened"](false);
	this["fireEvent"](this["E_EVENTS"]["Close"]);
	this["notifyLayeredControlClose"]();
	this["notifyLayerHidden"]();

	return true;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["closeBase"] = 0; };

UCF_LayeredControl["prototype"]["notifyLayeredControlClose"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyLayeredControlClose"]++; }; 
	this["oLS"]["oBrowserWindow"]["notifyLayeredControlClose"](this["sId"], this["sClassName"]);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyLayeredControlClose"] = 0; };

UCF_LayeredControl["prototype"]["notifyLayeredControlOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyLayeredControlOpen"]++; }; 
	this["oLS"]["oBrowserWindow"]["notifyLayeredControlOpen"](this["sId"], this["sClassName"]);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyLayeredControlOpen"] = 0; };

/**
 * Sets the alignment type of the layered control
 *
 * @param {int} iAlignment
 */
UCF_LayeredControl["prototype"]["setAlignment"] = function(iAlignment) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setAlignment"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iAlignment === 'number', "typeof iAlignment === 'number'", "LayeredControl.js(564): setAlignment"); };

	this["iAlignment"] = iAlignment;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setAlignment"] = 0; };

/**
 * Defines if the layered control is moved as long as it completly visible.
 * It's possible that it will overlay the opener control.
 * Default is true --> layered control is moved into the viewport
 *
 * @param { boolean } bMoveX
 * @param { boolean } bMoveY
 */
UCF_LayeredControl["prototype"]["setMoveIntoViewPortXY"] = function(bMoveX, bMoveY) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setMoveIntoViewPortXY"]++; }; 
	this["bMoveX"] = bMoveX;
	this["bMoveY"] = bMoveY;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setMoveIntoViewPortXY"] = 0; };

/**
 * Sets the pixel offset from the left that is added to the value
 * calculated by the alignment settings
 * i.e use this function if the layers should overlap the opener control
 *
 * @param {number} iPixel amount of pixels
 * @public
 */
UCF_LayeredControl["prototype"]["setOffsetLeft"] = function(iPixel) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOffsetLeft"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPixel) === "number", "typeof(iPixel) === \"number\"", "LayeredControl.js(591): setOffsetLeft"); };

	this["iOffsetLeft"] = iPixel;
	if (this["bOpened"]) {
		// move the layer if the element is already opened
		this["setPosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOffsetLeft"] = 0; };

/**
 * Sets the pixel offset from the top that is added to the value
 * calculated by the alignment settings.
 * i.e use this function if the layers should overlap the opener control
 *
 * @param {number} iPixel amount of pixels
 * @public
 */
UCF_LayeredControl["prototype"]["setOffsetTop"] = function(iPixel) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOffsetTop"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPixel) === "number", "typeof(iPixel) === \"number\"", "LayeredControl.js(609): setOffsetTop"); };

	this["iOffsetTop"] = iPixel;
	if (this["bOpened"]) {
		// move the layer if the element is already opened
		this["setPosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOffsetTop"] = 0; };

/**
 * Sets the vertical overlap of the layered control in pixel.
 * This is the amount of pixel the layered control is positioned closer to
 * the relative control than the calculated position to create an overlap (in other
 * words it is reduces the 'top' value).
 *
 * @param {number} iPixel amount of pixels
 * @public
 */
UCF_LayeredControl["prototype"]["setOverlap"] = function(iPixel) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOverlap"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPixel) === "number", "typeof(iPixel) === \"number\"", "LayeredControl.js(628): setOverlap"); };

	this["iOverlap"] = iPixel;
	if (this["bOpened"]) { //move the layer if the element is already opened
		this["setPosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOverlap"] = 0; };

/**
 * Set a value for the internal "move into view port" algorithm.
 * @param {int} iPixel amount of pixels
 */
UCF_LayeredControl["prototype"]["setSafetyDistance"] = function(iPixel) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setSafetyDistance"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPixel) === "number", "typeof(iPixel) === \"number\"", "LayeredControl.js(641): setSafetyDistance"); };

	this["iSafetyDistance"] = iPixel;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setSafetyDistance"] = 0; };

/**
 * Resets internally cached values
 */
UCF_LayeredControl["prototype"]["reset"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["reset"]++; }; 
	this["_oViewportObjectRect"] = null;
	this["_oVisualViewport"] = null;

	this["iOffsetTop"] = 0;
	this["iOffsetLeft"] = 0;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["reset"] = 0; };

/** @type {UCF_LS_VisualViewport} oVisualViewport the visual viewport */
/**
 * Returns the (visual) viewport
 * @return {UCF_LS_VisualViewport}
 */
UCF_LayeredControl["prototype"]["oGetVisualViewport"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetVisualViewport"]++; }; 
	if (!this["_oVisualViewport"]) {

		this["_oVisualViewport"] = this["oLS"]["oGetVisualViewport"](this["iSafetyDistance"]);

		// If the DOM of the layered control is located in the assoc. area
		// AND the Page's iPad-FLP-IFrame-workaround is active
		// AND there is a Page margin (which is theme-dependent) ...
		// (TODO: RTL?)
		if (UCF_DomUtil["bContains"](this["oLS"]["oGetAssociatedAreaRef"](), this["oRootRef"]) &&
			this["oLS"]["oGetPageInternal"]()["bInsideShellIFrameOnIOS"]()) {
			var oTD = this["oLS"]["oGetPageInternal"]()["oGetInternalBlockLayerLocation"]();
			var sMargin = UCF_DomUtil["sGetCurrentStyle"](oTD, 'paddingLeft');
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Page margin on Page TD (FLP-IFrame workaround): ' + sMargin, "LayeredControl.js(675): oGetVisualViewport"); };
			var iMargin = 0;
			if (sMargin["indexOf"]('px') > -1) iMargin = parseInt(sMargin);
			if (sMargin["indexOf"]('rem') > -1) iMargin = UCF_DomUtil["iRem2px"](sMargin);
			if (!isNaN(iMargin) && iMargin > 0) {
				this["_oVisualViewport"]["offsetLeft"] = -1 * iMargin;
			}
		}
	}

	return this["_oVisualViewport"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetVisualViewport"] = 0; };

/**
 * Returns the object rect of the DOM node, relative to the (visual) viewport
 * @return {_ObjectRect}
 */
UCF_LayeredControl["prototype"]["oGetViewportObjectRect"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetViewportObjectRect"]++; }; 
	var oOpenerRef = this["oOpenerRef"];
	var oParentPopupWindow;

	if (!this["_oViewportObjectRect"]) {
		if (!oOpenerRef) {
			// Use whole page (body or popupWindow) if there's no openerRef:
			// In iFrame PopUps the BODY may have no height...
			// then take the PopUpWindow for rect calculation
			oOpenerRef = document["getElementsByTagName"]("BODY")[0];
			oParentPopupWindow = this["oGetParentPopupWindow"]();
			if (oParentPopupWindow && !oParentPopupWindow["bIsDivPopup"]) {
				oOpenerRef = oParentPopupWindow["oDomRef"];
			}
		}
		this["_oViewportObjectRect"] = this["oLS"]["oGetViewportObjectRect"](
			oOpenerRef,
			this["oGetVisualViewport"]()
		);
	}
	return this["_oViewportObjectRect"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetViewportObjectRect"] = 0; };

/**
 * Returns the width of the layered control
 * @return {number}
 */
UCF_LayeredControl["prototype"]["iGetWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetWidth"]++; }; 
	if (this["_iWidth"] === null || this["_iWidth"] === undefined) {
		this["_iWidth"] = this["oRootRef"]["scrollWidth"];
	}
	return this["_iWidth"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetWidth"] = 0; };

/**
 * Returns the height of the layered control
 * @return {number}
 */
UCF_LayeredControl["prototype"]["iGetHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetHeight"]++; }; 
	if (this["_iHeight"] === null || this["_iHeight"] === undefined) {
		this["_iHeight"] = this["oRootRef"]["scrollHeight"];
	}
	return this["_iHeight"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetHeight"] = 0; };

UCF_LayeredControl["prototype"]["iGetLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetLeft"]++; }; 
	/** @type {UCF_LS_VisualViewport} */
	var oVisualViewport = this["oGetVisualViewport"]();
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iWidth  the width of the layered control */
	var iWidth = this["iGetWidth"]();
	/** @type {number} iLeft  the left position of the layered control */
	var iLeft;

	// calculate the position relative to the viewport
	// horizontal alignment
	if (this["bIsRightAligned"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'right-aligned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(750): iGetLeft"); };
		iLeft = oViewportObjectRect["left"] + oViewportObjectRect["width"] - iWidth + this["iOffsetLeft"];
	} else if (this["bIsLeftAligned"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'left-aligned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(753): iGetLeft"); };
		iLeft = oViewportObjectRect["left"] - this["iOffsetLeft"];
	} else if (this["bIsRightAttached"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'right-attached, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(756): iGetLeft"); };
		iLeft = oViewportObjectRect["left"] + oViewportObjectRect["width"] - this["iOffsetLeft"];
	} else if (this["bIsLeftAttached"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'left-attached, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(759): iGetLeft"); };
		iLeft = oViewportObjectRect["left"] - iWidth + this["iOffsetLeft"];
	} else if (this["bIsHorizontallyCentered"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'horizontally centered, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(762): iGetLeft"); };
		iLeft = Math["floor"](oViewportObjectRect["left"] + oViewportObjectRect["width"] / 2 - iWidth / 2) + this["iOffsetLeft"];
	} else if (this["bIsHorizontallyBrowserCentered"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'horizontally browser centered, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(765): iGetLeft"); };
		iLeft = Math["floor"]((oVisualViewport["width"] - this["iGetWidth"]()) / 2);
	} else if (this["bIsFullScreen"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'fullscreen, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(768): iGetLeft"); };
		iLeft = 0;
	} else { // horizontally absolutely positioned
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'horizontally absolute positioned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(771): iGetLeft"); };
		iLeft = this["iLeft"] - oVisualViewport["pageLeft"];
	}
	if (this["bMoveX"] && !this["bIsFullScreen"]()) {
		iLeft = Math["max"](0, iLeft); // left
		iLeft = Math["min"](iLeft, oVisualViewport["width"] - iWidth); // right
	}

	return Math["round"](iLeft);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetLeft"] = 0; };

UCF_LayeredControl["prototype"]["iGetTop"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetTop"]++; }; 
	/** @type {UCF_LS_VisualViewport} */
	var oVisualViewport = this["oGetVisualViewport"]();
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iHeight  the height of the layered control */
	var iHeight = this["iGetHeight"]();
	/** @type {number} iTop  the top position of the layered control */
	var iTop;

	if (this["bIsTopAttached"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'top-attached, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(793): iGetTop"); };
		iTop = oViewportObjectRect["top"] - iHeight - this["iOffsetTop"];
	} else if (this["bIsBottomAttached"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'bottom-attached, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(796): iGetTop"); };
		iTop = oViewportObjectRect["top"] + oViewportObjectRect["height"] + this["iOffsetTop"];
		if (this["bShowPointer"]()) {
			iTop += this["iGetPointerHeight"]();
		}
	} else if (this["bIsTopAligned"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'top-aligned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(802): iGetTop"); };
		iTop = oViewportObjectRect["top"] - this["iOffsetTop"];
		if (this["bShowPointer"]()) {
			iTop += this["iGetPointerHeight"]();
		}
	} else if (this["bIsBottomAligned"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'bottom-aligned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(808): iGetTop"); };
		iTop = oViewportObjectRect["top"] + oViewportObjectRect["height"] - iHeight + this["iOffsetTop"];
	} else if (this["bIsVerticallyCentered"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'vertically centered, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(811): iGetTop"); };
		iTop = Math["floor"]((oVisualViewport["height"] - this["iGetHeight"]()) / 2);
	} else if (this["bIsFullScreen"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'fullscreen, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(814): iGetTop"); };
		iTop = 0;
	} else { // vertically absolutely positioned
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'vertically absolute positioned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(817): iGetTop"); };
		iTop = this["iTop"] - oVisualViewport["pageTop"];
	}
	if (this["bMoveY"]) {
		iTop = Math["max"](0, iTop); // top
		iTop = Math["min"](iTop, oVisualViewport["height"] - iHeight + this["iOffsetTop"]);
	}

	return Math["round"](iTop);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetTop"] = 0; };

/**
 * Updates the position of the layered control
 */
UCF_LayeredControl["prototype"]["onBeforeSetPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onBeforeSetPosition"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onBeforeSetPosition"] = 0; };

/**
 * Updates the position of the layered control
 */
UCF_LayeredControl["prototype"]["setPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setPosition"]++; }; 
	if (!this["bOpened"]) {
		return;
	}

	this["reset"]();
	this["onBeforeSetPosition"]();

	/** @type {UCF_LS_VisualViewport} */
	var oVisualViewport = this["oGetVisualViewport"]();

	this["iTop"] = this["iGetTop"]();
	this["iLeft"] = this["iGetLeft"]();
	this["calculatePointerPosition"]();

	if (!this["bIsFullScreen"]()) {
		this["iTop"] += oVisualViewport["pageTop"] + oVisualViewport["offsetTop"];
		this["iLeft"] += oVisualViewport["pageLeft"] + oVisualViewport["offsetLeft"];
	}

	UCF_DomUtil["setStyle"](this["oRootRef"], {
		"top": this["iTop"] + 'px',
		"left": this["iLeft"] + 'px',
		"right": null
	});

	UCF_UserAgent["setResponsiveBreakpointScope"](this["oRootRef"], this["iGetWidth"]());

	this["redrawBlindLayer"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setPosition"] = 0; };

UCF_LayeredControl["prototype"]["calculatePointerPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["calculatePointerPosition"]++; }; 
	/** @type {number} iWidth  the width of the layered control */
	var iWidth;
	/** @type {HTMLElement} oPointer  reference to the pointer */
	var oPointer;
	/** @type {number} iPointerHeight  the height of the pointer */
	var iPointerHeight;
	/** @type {number} iPointerEdgeWidth  the edge width of the pointer */
	var iPointerEdgeWidth;
	/** @type {number} iMinPointerEdgeOffset  the minimal offset of the pointer from a corner */
	var iMinPointerEdgeOffset;
	/** @type {number} iPointerXPos  the resulting x-position of the pointer */
	var iPointerXPos;
	/** @type {_ObjectRect} */
	var oViewportObjectRect;
	/** @type {number} iLayeredControlLeft  the left position of the popup */
	var iLayeredControlLeft;
	/** @type {number} iLayeredControlRight  the right position of the popup */
	var iLayeredControlRight;
	/** @type {number} iMinLayeredControlWidthToHavePointer  it is not possible to display an attractive pointer for smaller layered controls */
	var iMinLayeredControlWidthToHavePointer;
	/** @type {number} iMaxLeft  the start of the region where objectRect and layered control overlap */
	var iMaxLeft;
	/** @type {number} iMinRight  the end of the region where objectRect and layered control overlap */
	var iMinRight;
	/** @type {number} iPointerYPos  the resulting x-position of the pointer */
	var iPointerYPos;
	/** @type {number} iLayeredControlTop  the top position of the layered control */
	var iLayeredControlTop;
	/** @type {number} iLayeredControlBottom  the bottom position of the layered control */
	var iLayeredControlBottom;
	/** @type {number} iMaxTop  the start of the region where objectRect and layered control overlap */
	var iMaxTop;
	/** @type {number} iMinBottom  the end of the region where objectRect and layered control overlap */
	var iMinBottom;

	oPointer = UCF_DomUtil["$"](this["sId"] + "-pointer");
	if (!this["bShowPointer"]()) {
		if (oPointer) {
			oPointer["style"]["display"] = 'none';
			oPointer["style"]["visibility"] = 'hidden';
		}
		return;
	}

	iPointerHeight = this["iGetPointerHeight"]();
	iPointerEdgeWidth = this["iGetPointerEdgeWidth"]();
	iMinPointerEdgeOffset = this["iGetMinPointerEdgeOffset"]();
	oViewportObjectRect = this["oGetViewportObjectRect"]();

	if (this["bIsTopAttached"]() || this["bIsTopAligned"]() || this["bIsBottomAttached"]() || this["bIsBottomAligned"]()) {
		iWidth = this["iGetWidth"]();
		iLayeredControlLeft = this["iLeft"];
		iLayeredControlRight = iLayeredControlLeft + iWidth;
		iMinRight = Math["min"](iLayeredControlRight, oViewportObjectRect["left"] + oViewportObjectRect["width"]);
		iMinLayeredControlWidthToHavePointer = 2 * iMinPointerEdgeOffset + 2 * iPointerHeight;
		if (
			iWidth >= iMinLayeredControlWidthToHavePointer &&
			iLayeredControlRight - oViewportObjectRect["left"] >= iMinPointerEdgeOffset &&
			oViewportObjectRect["left"] + oViewportObjectRect["width"] - iLayeredControlLeft >= iMinPointerEdgeOffset &&
			iPointerHeight > 0 &&
			!this["bMovedY"]
		) {
			iMaxLeft = Math["max"](iLayeredControlLeft, oViewportObjectRect["left"]);
			iPointerXPos = Math["round"]((iMinRight - iMaxLeft) / 2) + iMaxLeft - iLayeredControlLeft;
			iPointerXPos = Math["max"](iPointerXPos, iMinPointerEdgeOffset); // left correction, if pointer would be to close to the left edge of the layered control
			iPointerXPos = Math["min"](iPointerXPos, iWidth - iMinPointerEdgeOffset); // right correction, if pointer would be to close to the right edge of the layered control
			if (this["bIsTopAttached"]() || this["bIsBottomAligned"]()) {
				if (UCF_UserAgent["bIsIECompatibilityMode"]()) {
					UCF_DomUtil["addClass"](oPointer, 'lsQVArrowDownIEQ');
					oPointer["style"]["position"] = 'absolute';
					oPointer["style"]["width"] = '100%';
					oPointer["style"]["top"] = (this["iGetHeight"]() - iPointerHeight - 1) + 'px';
					oPointer["style"]["left"] = (iPointerXPos - iPointerHeight) + 'px';
				} else {
					oPointer["style"]["top"] = '';
					oPointer["style"]["bottom"] = (-1 * iPointerEdgeWidth / 2) + 'px';
					oPointer["style"]["left"] = (iPointerXPos - iPointerEdgeWidth / 2) + 'px';
					oPointer["style"]["transformOrigin"] = 'center';
					oPointer["style"]["transform"] = 'rotate(-135deg)';
				}
			} else {
				this["iOverlap"] = -1 * iPointerHeight;
				if (UCF_UserAgent["bIsIECompatibilityMode"]()) {
					UCF_DomUtil["addClass"](oPointer, 'lsQVArrowUpIEQ');
					oPointer["style"]["position"] = 'absolute';
					oPointer["style"]["width"] = '100%';
					oPointer["style"]["top"] = (-1 * iPointerHeight + 1) + 'px';
					oPointer["style"]["left"] = (iPointerXPos - iPointerHeight) + 'px';
				} else {
					oPointer["style"]["top"] = (-1 * iPointerEdgeWidth / 2) + 'px';
					oPointer["style"]["bottom"] = '';
					oPointer["style"]["left"] = (iPointerXPos - iPointerEdgeWidth / 2) + 'px';
					oPointer["style"]["transformOrigin"] = 'center';
					oPointer["style"]["transform"] = 'rotate(45deg)';
				}
			}
			oPointer["style"]["display"] = '';
			oPointer["style"]["visibility"] = 'visible';
		} else {
			oPointer["style"]["display"] = 'none';
			oPointer["style"]["visibility"] = 'hidden';
		}
	}

	if (this["bIsRightAttached"]() || this["bIsLeftAttached"]()) {
		iLayeredControlTop = this["iTop"] - this["oGetVisualViewport"]()["pageTop"];
		iLayeredControlBottom = iLayeredControlTop + this["iGetHeight"]();
		iMinBottom = Math["min"](iLayeredControlBottom, oViewportObjectRect["top"] + oViewportObjectRect["height"]);
		iMaxTop = Math["max"](iLayeredControlTop, oViewportObjectRect["top"]);
		if (iMinBottom >= iMaxTop && iPointerHeight > 0 && !this["bMovedX"]) {
			iPointerYPos = Math["round"]((iMinBottom - iMaxTop) / 2) + iMaxTop - iLayeredControlTop;
			if (this["bIsRightAttached"]()) {
				oPointer["style"]["top"] = iPointerYPos + 'px';
				oPointer["style"]["left"] = (-1 * iPointerHeight) + 'px';
				oPointer["style"]["transformOrigin"] = 'top left';
				oPointer["style"]["transform"] = 'rotate(-45deg)';
			} else {
				oPointer["style"]["top"] = iPointerYPos + 'px';
				oPointer["style"]["right"] = (-1 * (iPointerEdgeWidth + iPointerHeight)) + 'px';
				oPointer["style"]["transformOrigin"] = 'top left';
				oPointer["style"]["transform"] = 'rotate(135deg)';
			}
			oPointer["style"]["display"] = '';
			oPointer["style"]["visibility"] = 'visible';
		} else {
			oPointer["style"]["display"] = 'none';
			oPointer["style"]["visibility"] = 'hidden';
		}
	}

	this["onAfterPointerCalculation"](oPointer);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["calculatePointerPosition"] = 0; };

UCF_LayeredControl["prototype"]["onAfterPointerCalculation"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onAfterPointerCalculation"]++; }; 
	//abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onAfterPointerCalculation"] = 0; };

/**
 * Returns whether the pointer for the layered control shall be displayed:
 * Per default, it shall not be displayed, but derived controls (like quickview
 * and popupmenu) can overwrite this
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bShowPointer"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bShowPointer"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bShowPointer"] = 0; };

/**
 * Returns the height of the pointer
 * @return {number}
 */
UCF_LayeredControl["prototype"]["iGetPointerHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetPointerHeight"]++; }; 
	var iPointerEdgeWidth = this["iGetPointerEdgeWidth"]();

	return Math["floor"](Math["sqrt"](iPointerEdgeWidth * iPointerEdgeWidth * 2) / 2);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetPointerHeight"] = 0; };

/**
 * Returns the edge width of the pointer:
 * Per default, there is no pointer displayed and the edge width is 0 therefore.
 * But derived controls (like quickview and popupmenu) can overwrite this.
 * @return {number}
 */
UCF_LayeredControl["prototype"]["iGetPointerEdgeWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetPointerEdgeWidth"]++; }; 
	return this["bShowPointer"]() ? 0.75 * 16 : 0; // rem * 16 = 12px
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetPointerEdgeWidth"] = 0; };

/**
 * Returns the minimum distance from the pointer to the edge of the layeres control
 * @return {number}
 */
UCF_LayeredControl["prototype"]["iGetMinPointerEdgeOffset"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetMinPointerEdgeOffset"]++; }; 
	return 2 * this["iGetPointerHeight"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetMinPointerEdgeOffset"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsTopOrBottom"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopOrBottom"]++; }; 
	return !(this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"] ||
		this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["RIGHT"]);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopOrBottom"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsLeftAligned"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsLeftAligned"]++; }; 
	return window["UCF_System"]["bIsRTL"]
		? (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT_CONTAINER"])
		: (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT_CONTAINER"]);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsLeftAligned"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsRightAligned"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsRightAligned"]++; }; 
	return window["UCF_System"]["bIsRTL"]
		? (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT_CONTAINER"])
		: (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT_CONTAINER"]);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsRightAligned"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsLeftAttached"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsLeftAttached"]++; }; 
	return (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["RIGHT"]) &&
		!this["bIsRightAttached"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsLeftAttached"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsRightAttached"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsRightAttached"]++; }; 
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iWidth  the width of the layered control */
	var iWidth = this["iGetWidth"]();

	return window["UCF_System"]["bIsRTL"]
		? (
			(this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["RIGHT"]) &&
			oViewportObjectRect["left"] < iWidth &&
			oViewportObjectRect["right"] >= iWidth
		)
		: (
			(this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["RIGHT"]) &&
			(oViewportObjectRect["right"] >= iWidth ||
				oViewportObjectRect["left"] < iWidth)
		);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsRightAttached"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsTopAligned"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopAligned"]++; }; 
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iHeight  the height of the layered control */
	var iHeight = this["iGetHeight"]();

	return (
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT_CONTAINER"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT_CONTAINER"]
		)
		&&
		(
			oViewportObjectRect["height"] + oViewportObjectRect["bottom"] >= iHeight ||
			oViewportObjectRect["top"] < iHeight
		);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopAligned"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsBottomAligned"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsBottomAligned"]++; }; 
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iHeight  the height of the layered control */
	var iHeight = this["iGetHeight"]();

	return this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"]
		&& oViewportObjectRect["height"] + oViewportObjectRect["bottom"] < iHeight
		&& oViewportObjectRect["top"] + oViewportObjectRect["height"] >= iHeight;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsBottomAligned"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsTopAttached"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopAttached"]++; }; 
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iHeight  the height of the layered control */
	var iHeight = this["iGetHeight"]();

	return (
		( // TOP-attached set and there is enough space above or not enough space below; open above
			(
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPCENTER"]
			)
			&& (oViewportObjectRect["top"] >= iHeight || oViewportObjectRect["bottom"] < iHeight)
		)
		||
		( // BOTTOM-attached set and there is not enough space below, but above: open above
			(
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMCENTER"]
			)
			&& oViewportObjectRect["bottom"] < iHeight && oViewportObjectRect["top"] >= iHeight
		)
		||
		( // TOP-aligned set and there is not enough space below, but above: open above
			(
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT_CONTAINER"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT_CONTAINER"]
			)
			&& oViewportObjectRect["iHeight"] + oViewportObjectRect["bottom"] < iHeight && oViewportObjectRect["top"] >= iHeight
		)
	);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopAttached"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsBottomAttached"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsBottomAttached"]++; }; 
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iHeight  the height of the layered control */
	var iHeight = this["iGetHeight"]();

	return (
		( // BOTTOM-attached set and there is enough space below or not enough space above: open below
			(
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMCENTER"]
			)
			&& (oViewportObjectRect["bottom"] >= iHeight || oViewportObjectRect["top"] < iHeight)
		)
		||
		( // TOP-attached set and there is not enough space above, but below: open below
			(
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPCENTER"]
			)
			&& oViewportObjectRect["top"] < iHeight && oViewportObjectRect["bottom"] >= iHeight
		)
	);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsBottomAttached"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsHorizontallyCentered"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsHorizontallyCentered"]++; }; 
	return (
		this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPCENTER"] ||
		this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMCENTER"]
	);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsHorizontallyCentered"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsHorizontallyBrowserCentered"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsHorizontallyBrowserCentered"]++; }; 
	return this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BROWSERCENTER"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsHorizontallyBrowserCentered"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsVerticallyCentered"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsVerticallyCentered"]++; }; 
	return this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BROWSERCENTER"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsVerticallyCentered"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsFullScreen"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsFullScreen"]++; }; 
	return this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["OVERLAY"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsFullScreen"] = 0; };

/**
 * Sets the left postion
 *
 * @param {int} iLeft
 */
UCF_LayeredControl["prototype"]["setLeft"] = function(iLeft) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setLeft"]++; }; 
	this["iLeft"] = iLeft;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setLeft"] = 0; };

/**
 * Sets the top postion
 *
 * @param {int} iTop
 */
UCF_LayeredControl["prototype"]["setTop"] = function(iTop) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setTop"]++; }; 
	this["iTop"] = iTop;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setTop"] = 0; };

/**
 * Redraws the blind layer of the layered control
 */
UCF_LayeredControl["prototype"]["redrawBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["redrawBlindLayer"]++; }; 
	if (!this["oBlindLayer"])
		this["oBlindLayer"] = this["oLS"]["oGetBlindLayer"]();

	UCF_DomUtil["setStyle"](this["oBlindLayer"]["oDomRef"], {
		"left": this["iLeft"] + 'px',
		"top": this["iTop"] + 'px',
		// This "clean-up" resulted in issue with height on IE !
		// Please don't clean-up again.
		// width: this.iGetWidth() + 'px',
		// height: this.iGetHeight() + 'px'
		"width": this["oRootRef"]["scrollWidth"] + 'px',
		"height": this["oRootRef"]["scrollHeight"] + 'px'
	});
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["redrawBlindLayer"] = 0; };

/**
 * On a resize the position has to be adopted
 * (resize will be fired for orientation change as well)
 */
UCF_LayeredControl["prototype"]["onresize"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onresize"]++; }; 
	if (!this["bIsValid"]()) return;
	this["onBeforeResize"]();
	this["setPosition"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onresize"] = 0; };

/**
 * Hook for Listbox_Popup
 */
UCF_LayeredControl["prototype"]["onBeforeResize"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onBeforeResize"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onBeforeResize"] = 0; };

/**
 * Set open state of the layer
 * @param {boolean} bOpened
 *
 */
UCF_LayeredControl["prototype"]["setOpened"] = function(bOpened) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOpened"]++; }; 
	this["bOpened"] = bOpened;
	if (!bOpened) {
		if (this["oBlindLayer"]) {
			this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
			this["oBlindLayer"] = null;
		}
	} else {
		if (!this["oBlindLayer"])
			this["oBlindLayer"] = this["oLS"]["oGetBlindLayer"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOpened"] = 0; };

/**
 * Returns whether the control is opened to the top of its opener
 * or to the bottom
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bOpenedOnTop"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bOpenedOnTop"]++; }; 
	return this["iOpenYDirection"] === -1;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bOpenedOnTop"] = 0; };

UCF_LayeredControl.prototype["aPublicMethods"] = ["setOffsetLeft","setOffsetTop","setOverlap"].concat(UCF_LayeredControl.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_LayoutEditorExtension"] = function() {/* global UCF_JsUtil */
/// <reference path="../../../../core/util/JsUtil.js"/>
/* global UCF_DTExtension */
/// <reference path="../DTExtension.js"/>
/* global UCF_Guide */
/// <reference path="./Guide.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../../core/util/DomUtil.js"/>
/**
 * Design Time Layout Editor
 *
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oControl
 * @param {UCF_DTElement} oDTElement The DTElement this editor is connected to
 */
function UCF_LayoutEditorExtension(oLS, oControl, oDTElement) {if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["UCF_LayoutEditorExtension"]++; }; 
	if (arguments["length"] === 0) return;
	UCF_DTExtension["apply"](this, arguments);
	this["oDTContainer"] = oDTElement["oDTContainer"];
	this["oDTElement"]["attachEvent"](this["oDTElement"]["E_EVENTS"]["Select"], this, "handleSelect");
	this["oDTElement"]["attachEvent"](this["oDTElement"]["E_EVENTS"]["Deselect"], this, "handleDeselect");
	this["oDTElement"]["attachEvent"](this["oDTElement"]["E_EVENTS"]["Update"], this, "handleUpdate");
	this["oContainer"] = this["oDTElement"]["oGetContentDomRef"]();
	this["aVGuides"] = [];
	this["aHGuides"] = [];

	this["bUICreated"] = false;

	UCF_LayoutEditorExtension["addStyles"](this["oLS"]); //TODO: move this to themes
	this["update"]();

	//	window.setTimeout( function() {
	//	var oRuler = new UCF_Ruler();
	//	var oPosDiv = document.createElement("div");
	//	oPosDiv.style.position="absolute";
	//	oPosDiv.style.width="100%";
	//	oPosDiv.style.height ="0px";
	//	oPosDiv.style.borderTop ="1px solid red";
	//	document.body.appendChild(oPosDiv);
	//	var iBaselineTop = UCF_Ruler.getTextBaseline(document.getElementById("test"));
	//	var oRect = UCF_DomUtil.oGetObjectRect(document.getElementById("test"));
	//	oPosDiv.style.top = (oRect.top + iBaselineTop) + "px";
	//
	//	var oPosDiv = document.createElement("div");
	//	oPosDiv.style.position="absolute";
	//	oPosDiv.style.width="100%";
	//	oPosDiv.style.height ="0px";
	//	oPosDiv.style.borderTop ="1px solid red";
	//	document.body.appendChild(oPosDiv);
	//	var iBaselineTop = UCF_Ruler.getTextBaseline(document.getElementById("test2"));
	//	var oRect = UCF_DomUtil.oGetObjectRect(document.getElementById("test2"));
	//	oPosDiv.style.top = (oRect.top + iBaselineTop) + "px";
	//	},2000);

};window["UCF_LayoutEditorExtension"] = UCF_LayoutEditorExtension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LayoutEditorExtension"); UCF_LayoutEditorExtension["_"] = {UCF_LayoutEditorExtension: 0}; }; ;
UCF_LayoutEditorExtension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTExtension"))(); UCF_LayoutEditorExtension.prototype["sClassName"] = "UCF_LayoutEditorExtension";

UCF_LayoutEditorExtension["prototype"]["update"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["update"]++; }; 
	if (this["oContainer"]) {
		UCF_DomUtil["setInnerHtml"](this["oContainer"], "");
		this["oContainer"]["style"]["display"] = "block";
	}
	this["aVGuides"] = [];
	this["aHGuides"] = [];
	this["bUICreated"] = false;
	if (this["iUpdateTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["iUpdateTimer"]);
	}
	//this.iUpdateTimer = UCF_JsUtil.delayedCall(200,this,"createEditorUI");
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["update"] = 0; };

UCF_LayoutEditorExtension["prototype"]["handleSelect"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["handleSelect"]++; }; 
	//this.showGuideBars();
	//this.showGuides();
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["handleSelect"] = 0; };
UCF_LayoutEditorExtension["prototype"]["handleDeselect"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["handleDeselect"]++; }; 
	//this.hideGuideBars();
	//this.hideGuides();
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["handleDeselect"] = 0; };
UCF_LayoutEditorExtension["prototype"]["handleUpdate"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["handleUpdate"]++; }; 
	this["update"]();
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["handleUpdate"] = 0; };

UCF_LayoutEditorExtension["prototype"]["onlsdragenter"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["onlsdragenter"]++; }; 
	//this.showGuides();
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["onlsdragenter"] = 0; };

UCF_LayoutEditorExtension["prototype"]["onlsdragleave"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["onlsdragleave"]++; }; 
	//this.hideGuides();
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["onlsdragleave"] = 0; };

UCF_LayoutEditorExtension["prototype"]["onlsdrop"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["onlsdrop"]++; }; 
	//this.hideGuides();
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["onlsdrop"] = 0; };

UCF_LayoutEditorExtension["prototype"]["showGuideBars"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["showGuideBars"]++; }; 
	if (this["oVGuideBar"]) {
		this["oVGuideBar"]["style"]["display"] = "block";
	}
	if (this["oHGuideBar"]) {
		this["oHGuideBar"]["style"]["display"] = "block";
	}
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["showGuideBars"] = 0; };

UCF_LayoutEditorExtension["prototype"]["hideGuideBars"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["hideGuideBars"]++; }; 
	if (this["oVGuideBar"]) {
		this["oVGuideBar"]["style"]["display"] = "none";
	}
	if (this["oHGuideBar"]) {
		this["oHGuideBar"]["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["hideGuideBars"] = 0; };

UCF_LayoutEditorExtension["prototype"]["showGuides"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["showGuides"]++; }; 
	for (var i = 0; i < this["aVGuides"]["length"]; i++) {
		this["aVGuides"][i]["show"]();
	}
	for (i = 0; i < this["aHGuides"]["length"]; i++) {
		this["aHGuides"][i]["show"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["showGuides"] = 0; };

UCF_LayoutEditorExtension["prototype"]["hideGuides"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["hideGuides"]++; }; 
	for (var i = 0; i < this["aVGuides"]["length"]; i++) {
		this["aVGuides"][i]["hide"]();
	}
	for (i = 0; i < this["aHGuides"]["length"]; i++) {
		this["aHGuides"][i]["hide"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["hideGuides"] = 0; };

UCF_LayoutEditorExtension["prototype"]["createEditorUI"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["createEditorUI"]++; }; 
	if (!this["bUICreated"]) {
		if (this["oContainer"]) {
			this["createVGuideBar"]();
			this["createHGuideBar"]();
			this["createGuidesFromLayout"]();
			this["hideGuideBars"]();
			this["hideGuides"]();
		}
		this["bUICreated"] = true;
		this["oContainer"]["style"]["left"] = "-2px";
		this["oContainer"]["style"]["top"] = "-2px";
		this["oContainer"]["style"]["bottom"] = "0px";
		this["oContainer"]["style"]["right"] = "0px";
		this["oContainer"]["style"]["width"] = "auto";
		this["oContainer"]["style"]["height"] = "auto";
	}
	if (this["oDTElement"]["bIsSelected"]()) {
		this["handleSelect"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["createEditorUI"] = 0; };

UCF_LayoutEditorExtension["prototype"]["createVGuideBar"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["createVGuideBar"]++; }; 
	if (!this["oVGuideBar"]) {
		var oDiv = document["createElement"]("div");
		oDiv["className"] = "urVGuideBar";
		this["oContainer"]["appendChild"](oDiv);
		this["oVGuideBar"] = oDiv;
	}
	if (!this["oVGuideBar"]["parentNode"]) {
		this["oContainer"]["appendChild"](this["oVGuideBar"]);
	}
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["createVGuideBar"] = 0; };

UCF_LayoutEditorExtension["prototype"]["createHGuideBar"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["createHGuideBar"]++; }; 
	if (!this["oHGuideBar"]) {
		var oDiv = document["createElement"]("div");
		oDiv["className"] = "urHGuideBar";
		this["oHGuideBar"] = oDiv;
	}
	if (!this["oHGuideBar"]["parentNode"]) {
		this["oContainer"]["appendChild"](this["oHGuideBar"]);
	}
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["createHGuideBar"] = 0; };

UCF_LayoutEditorExtension["prototype"]["addVGuide"] = function(sPos) {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["addVGuide"]++; }; 
	var oGuide = new (UCF_ClassLoader["oGetClass"]("UCF_Guide"))(this, this["oContainer"], "vertical", "left", sPos);
	this["aVGuides"]["push"](oGuide);
	oGuide["show"]();

};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["addVGuide"] = 0; };

UCF_LayoutEditorExtension["prototype"]["addHGuide"] = function(sPos) {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["addHGuide"]++; }; 
	var oGuide = new (UCF_ClassLoader["oGetClass"]("UCF_Guide"))(this, this["oContainer"], "horizontal", "top", sPos);
	this["aHGuides"]["push"](oGuide);
	oGuide["show"]();
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["addHGuide"] = 0; };

UCF_LayoutEditorExtension["prototype"]["getRulers"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["getRulers"]++; }; 
	var aResultRect = [],
		oRect;
	for (var i = 0; i < this["aVGuides"]["length"]; i++) {
		oRect = this["aVGuides"][i]["ruler"];
		aResultRect["push"]({ "rect": oRect, "delegateinfo": { "owner": this, "guide": this["aVGuides"][i] } });
	}
	for (i = 0; i < this["aHGuides"]["length"]; i++) {
		oRect = this["aHGuides"][i]["ruler"];
		aResultRect["push"]({ "rect": oRect, "delegateinfo": { "owner": this, "guide": this["aHGuides"][i] } });
	}
	return aResultRect;
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["getRulers"] = 0; };

UCF_LayoutEditorExtension["prototype"]["getGuidePos"] = function(oGuide) {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["getGuidePos"]++; }; 
	if (oGuide) {
		return oGuide["getPosition"]();
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["getGuidePos"] = 0; };

/* eslint-disable consistent-return */
UCF_LayoutEditorExtension["prototype"]["createGuidesFromLayout"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["createGuidesFromLayout"]++; }; 
	if (this["oControl"]) {
		if (UCF_JsUtil["bInstanceOf"](this["oControl"], "UCF_MatrixLayout") || UCF_JsUtil["bInstanceOf"](this["oControl"], "UCF_GridLayout")) {
			var oTable = null;
			if (this["oControl"]["oDomRef"] && this["oControl"]["oDomRef"]["tagName"] === "TABLE") {
				oTable = this["oControl"]["oDomRef"];
			}
			if (!oTable) {
				//special case (only one cell)
				return null;
			}
			var iMaxCellRow = 0,
				iMaxCells = 0;
			var sTop = "0px";
			for (var y = 0; y < oTable["rows"]["length"]; y++) {
				if (oTable["rows"][y]["cells"]["length"] > iMaxCells) {
					iMaxCells = oTable["rows"][y]["cells"]["length"];
					iMaxCellRow = y;
				}
				if (oTable["rows"][y]["cells"]["length"] > 0) {
					var sHeight = oTable["rows"][y]["cells"][0]["style"]["height"];
					if (!sHeight) {
						sHeight = oTable["rows"][y]["cells"][0]["offsetHeight"] + "px";
					}
					if (y < oTable["rows"]["length"] - 1) {
						sTop = sTop + " + " + sHeight;
						this["addHGuide"]("calc(" + sTop + ")");
					}
				}
			}
			var sLeft = "0px";
			for (var x = 0; x < oTable["rows"][iMaxCellRow]["cells"]["length"]; x++) {
				var sWidth = oTable["rows"][iMaxCellRow]["cells"][x]["style"]["width"];
				if (!sWidth) {
					sWidth = (oTable["rows"][iMaxCellRow]["cells"][x]["offsetWidth"] - 2) + "px";
				}
				sLeft = sLeft + " + " + sWidth;
				this["addVGuide"]("calc(" + sLeft + ")");

			};
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["createGuidesFromLayout"] = 0; };

//TODO: Add to theme css
UCF_LayoutEditorExtension["bStyles"] = false;
UCF_LayoutEditorExtension["addStyles"] = function(oLS) {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["addStyles"]++; }; 
	if (!UCF_LayoutEditorExtension["bStyles"]) {
		UCF_LayoutEditorExtension["bStyles"] = true;
		var aCss = [];
		aCss["push"](".urVGuideBar {");
		aCss["push"]("height: 11px;");
		aCss["push"]("background-color: rgba(255,255,255,1);");
		aCss["push"]("position: absolute;");
		aCss["push"]("cursor:none;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("top:-11px;");
		aCss["push"]("left:0px;");
		aCss["push"]("right:-2px;");
		aCss["push"]("border-top-left-radius: 4px;");
		aCss["push"]("border-top-right-radius: 4px;");
		aCss["push"]("border: 1px solid rgba(52, 135, 201, 0.61);");
		aCss["push"]("border-bottom: none;");
		aCss["push"]("}");

		aCss["push"](".urVGuideBar:hover {");
		aCss["push"]("height: 11px;");
		aCss["push"]("}");

		aCss["push"](".urVGuideArrow {");
		aCss["push"]("border-left: 4px solid transparent;");
		aCss["push"]("border-right: 4px solid transparent;");
		aCss["push"]("border-top: 5px solid rgba(13, 92, 165, 1);");
		aCss["push"]("border-bottom: none;");
		aCss["push"]("top:-4px;");
		aCss["push"]("left: -4px;");
		aCss["push"]("cursor: ew-resize;");
		aCss["push"]("width: 0px;");
		aCss["push"]("height: 0px;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("position: absolute;");
		aCss["push"]("z-index:2;");
		aCss["push"]("}");

		aCss["push"](".urVGuide {");
		aCss["push"]("position: absolute;");
		aCss["push"]("top: 0px;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("cursor: ew-resize;");
		aCss["push"]("width: 3px;");
		aCss["push"]("height: 100%;");
		aCss["push"]("margin-left:-2px;");
		aCss["push"]("}");
		aCss["push"](".urVGuideLine {");
		aCss["push"]("border-left: 1px solid rgba(17, 85, 172, 0.3);");
		aCss["push"]("width:0px;");
		aCss["push"]("margin-left:1px;");
		aCss["push"]("position: absolute;");
		aCss["push"]("height:100%");

		aCss["push"]("}");
		aCss["push"](".urVGuide:hover .urVGuideLine{");
		aCss["push"]("border-left: 1px solid rgba(255, 100, 255, 1);");
		aCss["push"]("}");

		aCss["push"](".urVGuide:hover .urVGuideArrow {");
		aCss["push"]("border-top: 5px solid rgba(255, 100, 255, 1);");
		aCss["push"]("}");

		aCss["push"](".urVDistance {");
		aCss["push"]("height: 14px;");
		aCss["push"]("position: absolute;");
		aCss["push"]("top: -1px;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("text-align:center;");
		aCss["push"]("cursor:default;");
		aCss["push"]("border-top-left-radius: 2px;");
		aCss["push"]("border-top-right-radius: 2px;");
		aCss["push"]("width: 100%");
		aCss["push"]("}");
		aCss["push"](".urVDistance:hover {");
		aCss["push"]("border-bottom: 2px solid rgba(255, 0, 255, 0.8);");
		aCss["push"]("background-color: rgba(0, 153, 255,0.5);");
		aCss["push"]("}");

		aCss["push"](".urVDistance:hover .left {");
		aCss["push"]("height:7px;");
		aCss["push"]("position:absolute;");
		aCss["push"]("left:-1px;");
		aCss["push"]("top:12px;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("border-left:1px solid rgba(255, 0, 255, 0.8);");
		aCss["push"]("}");
		aCss["push"](".urVDistance:hover .right {");
		aCss["push"]("height:7px;");
		aCss["push"]("position:absolute;");
		aCss["push"]("right:0px;");
		aCss["push"]("top:12px;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("border-right:1px solid rgba(255, 0, 255, 0.8);");
		aCss["push"]("}");

		aCss["push"](".urHGuideBar {");
		aCss["push"]("width: 11px;");
		aCss["push"]("background-color: rgba(255,255,255,1);");
		aCss["push"]("position: absolute;");
		aCss["push"]("cursor:none;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("display:table;");
		aCss["push"]("left:-11px;");
		aCss["push"]("top:0px;");
		aCss["push"]("bottom:-2px;");
		aCss["push"]("border-top-left-radius: 4px;");
		aCss["push"]("border-bottom-left-radius: 4px;");
		aCss["push"]("border: 1px solid rgba(52, 135, 201, 0.61);");
		aCss["push"]("border-right: none;");
		aCss["push"]("}");

		aCss["push"](".urHGuideBar:hover {");
		aCss["push"]("width: 11px;");
		aCss["push"]("}");

		aCss["push"](".urHGuideArrow {");
		aCss["push"]("border-bottom: 4px solid transparent;");
		aCss["push"]("border-top: 4px solid transparent;");
		aCss["push"]("border-left: 5px solid rgba(13, 92, 165, 1);");
		aCss["push"]("border-right: none;");
		aCss["push"]("left:-4px;");
		aCss["push"]("top: -4px;");
		aCss["push"]("cursor: ns-resize;");
		aCss["push"]("width: 0px;");
		aCss["push"]("height: 0px;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("position: absolute;");
		aCss["push"]("z-index:2;");
		aCss["push"]("}");

		aCss["push"](".urHGuide {");
		aCss["push"]("position: absolute;");
		aCss["push"]("left: 0px;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("cursor: ns-resize;");
		aCss["push"]("height:3px;");
		aCss["push"]("width: 100%;");
		aCss["push"]("margin-top:-1px;");
		aCss["push"]("}");
		aCss["push"](".urHGuideLine {");
		aCss["push"]("border-top: 1px solid rgba(17, 85, 172, 0.3);");
		aCss["push"]("height:0px;");
		aCss["push"]("margin-top:1px;");
		aCss["push"]("position: absolute;");
		aCss["push"]("width:100%");
		aCss["push"]("}");
		aCss["push"](".urHGuide:hover .urHGuideLine{");
		aCss["push"]("border-top: 1px solid rgba(255, 100, 255, 1);");
		aCss["push"]("}");

		aCss["push"](".urHGuide:hover .urHGuideArrow {");
		aCss["push"]("border-left: 4px solid rgba(255, 100, 255, 1);");
		aCss["push"]("}");

		aCss["push"](".urHDistance {");
		aCss["push"]("width: 14px;");
		aCss["push"]("position: absolute;");
		aCss["push"]("left: -1px;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("vertical-align:middle;");
		aCss["push"]("display:table-cell;");
		aCss["push"]("cursor:default;");
		aCss["push"]("border-top-left-radius: 2px;");
		aCss["push"]("border-bottom-left-radius: 2px;");
		aCss["push"]("height: calc(100% - 1px)");
		aCss["push"]("}");
		aCss["push"](".urHDistance:hover {");
		aCss["push"]("border-right: 2px solid rgba(255, 0, 255, 0.8);");
		aCss["push"]("background-color: rgba(0, 153, 255,0.5);");
		aCss["push"]("}");

		aCss["push"](".urHDistance:hover .top {");
		aCss["push"]("width:7px;");
		aCss["push"]("position:absolute;");
		aCss["push"]("top:-1px;");
		aCss["push"]("left:12px;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("border-top:1px solid rgba(255, 0, 255, 0.8);");
		aCss["push"]("}");
		aCss["push"](".urHDistance:hover .bottom {");
		aCss["push"]("width:7px;");
		aCss["push"]("position:absolute;");
		aCss["push"]("bottom:-1px;");
		aCss["push"]("left:12px;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("border-bottom:1px solid rgba(255, 0, 255, 0.8);");
		aCss["push"]("}");
		aCss["push"](".urRulerDistanceV {");
		aCss["push"]("position:absolute;");
		aCss["push"]("margin-left:4px;");
		aCss["push"]("display:none;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("color:rgb(119, 178, 232);");
		aCss["push"]("font-family:arial;");
		aCss["push"]("font-size:10px;");
		aCss["push"]("}");
		aCss["push"](".urRulerDistanceH {");
		aCss["push"]("position:absolute;");
		aCss["push"]("display:none;");
		aCss["push"]("box-sizing:border-box;");
		aCss["push"]("color:rgb(119, 178, 232);");
		aCss["push"]("font-family:arial;");
		aCss["push"]("font-size:10px;");
		aCss["push"]("height:11px;");
		aCss["push"]("text-align:center;");
		aCss["push"]("right:0px;");
		aCss["push"]("}");
		aCss["push"](".urRulerDistanceH span, .urRulerDistanceV span{");
		aCss["push"]("display:inline-block;");
		aCss["push"]("background-color:rgba(255, 255, 255,0.7);");
		aCss["push"]("padding : 1px 3px;");
		aCss["push"]("white-space : nowrap;");
		aCss["push"]("box-shadow : 0px 0px 2px 0px rgba(255,255,255,0.5);");
		aCss["push"]("pointer-events : none;");
		aCss["push"]("line-height : 10px");
		aCss["push"]("}");
		if (oLS["oGetPageInternal"]())
			oLS["oGetPageInternal"]()["addStyle"]("", aCss["join"](""));
	}
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["addStyles"] = 0; };

UCF_LayoutEditorExtension["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["destroy"]++; }; 

	this["oDTContainer"] = null;
	this["oContainer"] = null;
	this["oVGuideBar"] = null;
	this["oHGuideBar"] = null;

	UCF_DTExtension.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_LayoutEditorExtension["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_Legend"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Legend(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Legend["_"]["UCF_Legend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Legend.js(23): UCF_Legend"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Legend.js(24): UCF_Legend"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Legend.js(25): UCF_Legend"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	if (window["UCF_System"]["bIs508"]) {
		this["bSkipMsgSet"] = false;
	}
};window["UCF_Legend"] = UCF_Legend; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Legend"); UCF_Legend["_"] = {UCF_Legend: 0}; }; ;
UCF_Legend["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Legend.prototype["sClassName"] = "UCF_Legend";

/**
 * Handles the lsskipforward event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Legend["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Legend["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Legend["_"]["onlsskipforward"] = 0; };

/**
 * Handles the lsskipback event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Legend["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Legend["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Legend["_"]["onlsskipback"] = 0; };

/**
 * Handles the tab key
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Legend["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Legend["_"]["onlstabprevious"]++; }; 
	this["onlsskipback"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Legend["_"]["onlstabprevious"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Legend["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Legend["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Legend.js(72): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSource = oBrowserEvent["oGetSource"]();

	oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](oSource));

	oAccessibilityHelper["setControlType"]("LEG");
	if (this["bSkipMsgSet"] === false) {
		oAccessibilityHelper["addTutor"]("SKIP");
		this["bSkipMsgSet"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_Legend["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Legend["prototype"]["aAttributeNames"] = ["sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Legend["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Legend["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Legend["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_Legend["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Legend["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Legend["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Legend["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_LineDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>

/**
 * A generic line decorator implementation.
 * @class
 * @param {UCF_Object} oControl Control instance
 * @param {boolean} bHorizontal The direction
 * @param {boolean} [bDashed=false] Dashed line
 */
function UCF_LineDecorator(oControl, bHorizontal, bDashed) {if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["UCF_LineDecorator"]++; }; 

	if (arguments["length"] === 0) return;

	this["oControl"] = oControl;
	this["bHorizontal"] = bHorizontal;
	this["iGap"] = 0;
	this["sId"] = null;

	this["bDashed"] = bDashed;

	this["oParentContainer"] = oControl["oLS"]["oGetRootRef"]();
	//needed for event bubbling in FF
	if (UCF_UserAgent["bIsGecko"]())
		this["oParentContainer"] = this["oControl"]["oDomRef"];

};window["UCF_LineDecorator"] = UCF_LineDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LineDecorator"); UCF_LineDecorator["_"] = {UCF_LineDecorator: 0}; }; ;
UCF_LineDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_LineDecorator.prototype["sClassName"] = "UCF_LineDecorator";

UCF_LineDecorator["SIZES"] = {

	"ARROW_WIDTH": 4,
	"ARROW_HEIGHT": 5

};

UCF_LineDecorator["SUFFIX"] = {

	"FIRST_ARROW": "-fa",
	"SECOND_ARROW": "-sa"

};

UCF_LineDecorator["prototype"]["setContainer"] = function (oContainerDomRef) {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["setContainer"]++; }; 
	this["oParentContainer"] = oContainerDomRef;
};;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["setContainer"] = 0; };

/**
 * destructor
 */
UCF_LineDecorator["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["destroy"]++; }; 
	this["oParentContainer"] = null;
	this["oControl"] = null;
	this["oLineDomRef"] = null;
	this["oFirstArrow"] = null;
	this["oSecondArrow"] = null;
	this["bHorizontal"] = null;
	this["iGap"] = null;
	this["bDashed"] = null;
	this["sId"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["destroy"] = 0; };

/**
 * creates dom
 *
 */
UCF_LineDecorator["prototype"]["init"] = function () {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["init"]++; }; 

	var oLine, oFirstArrow, oSecondArrow = null;
	if (this["sId"]) {
		oLine = UCF_DomUtil["$"](this["sId"]);
		oFirstArrow = UCF_DomUtil["$"](this["sId"] + UCF_LineDecorator["SUFFIX"]["FIRST_ARROW"]);
		oSecondArrow = UCF_DomUtil["$"](this["sId"] + UCF_LineDecorator["SUFFIX"]["SECOND_ARROW"]);
	}

	if (!oLine) {
		oLine = document["createElement"]("DIV");
		oLine["style"]["position"] = "absolute";
		oLine["style"]["fontSize"] = "1px";
		oLine["style"]["zIndex"] = UCF_LS["E_LAYERS"]["DECORATORS"];

		if (this["bHorizontal"])
			oLine["style"]["height"] = "2px";
		else
			oLine["style"]["width"] = "2px";

		if (this["bDashed"])
			oLine["style"]["borderTop"] = "2px dashed black";
		else
			oLine["style"]["backgroundColor"] = "black";

		oLine["id"] = this["sId"];
		UCF_DomUtil["addClass"](oLine, 'lsDragDrop--decorator-line');
		this["oParentContainer"]["appendChild"](oLine);

	}

	if (!oFirstArrow) {

		oFirstArrow = document["createElement"]("div");
		oFirstArrow["style"]["position"] = "absolute";
		oFirstArrow["style"]["backgroundRepeat"] = "no-repeat";
		oFirstArrow["style"]["backgroundPosition"] = "top left";
		oFirstArrow["style"]["width"] = "12px";
		oFirstArrow["style"]["height"] = "12px";
		oFirstArrow["style"]["overflow"] = "hidden";
		oFirstArrow["setAttribute"]("id", this["sId"] + UCF_LineDecorator["SUFFIX"]["FIRST_ARROW"]);
		oFirstArrow["style"]["zIndex"] = UCF_LS["E_LAYERS"]["DECORATORS"];

		this["oParentContainer"]["appendChild"](oFirstArrow);

	}

	if (!oSecondArrow) {
		oSecondArrow = document["createElement"]("div");
		oSecondArrow["style"]["position"] = "absolute";
		oSecondArrow["style"]["backgroundRepeat"] = "no-repeat";
		oSecondArrow["style"]["backgroundPosition"] = "top left";
		oSecondArrow["style"]["width"] = "12px";
		oSecondArrow["style"]["height"] = "12px";
		oSecondArrow["style"]["overflow"] = "hidden";
		oSecondArrow["setAttribute"]("id", this["sId"] + UCF_LineDecorator["SUFFIX"]["SECOND_ARROW"]);
		oSecondArrow["style"]["zIndex"] = UCF_LS["E_LAYERS"]["DECORATORS"];

		this["oParentContainer"]["appendChild"](oSecondArrow);

	}

	if (this["bHorizontal"]) {
		oFirstArrow["className"] = "urDDDecoLeft";
		oSecondArrow["className"] = "urDDDecoRight";
	} else {
		oFirstArrow["className"] = "urDDDecoTop";
		oSecondArrow["className"] = "urDDDecoBottom";
	}

	this["oLineDomRef"] = oLine;
	this["oFirstArrow"] = oFirstArrow;
	this["oSecondArrow"] = oSecondArrow;

};;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["init"] = 0; };

/**
 * removes elements from DOM
 */
UCF_LineDecorator["prototype"]["cleanUp"] = function () {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["cleanUp"]++; }; 

	var oLine = this["oLineDomRef"],
		oFirstArrow = this["oFirstArrow"],
		oSecondArrow = this["oSecondArrow"];

	if (this["sId"]) {
		oLine = UCF_DomUtil["$"](this["sId"]);
		oFirstArrow = UCF_DomUtil["$"](this["sId"] + UCF_LineDecorator["SUFFIX"]["FIRST_ARROW"]);
		oSecondArrow = UCF_DomUtil["$"](this["sId"] + UCF_LineDecorator["SUFFIX"]["SECOND_ARROW"]);
	}

	UCF_DomUtil["removeFromDom"](oLine);
	this["oLineDomRef"] = null;

	UCF_DomUtil["removeFromDom"](oFirstArrow);
	this["oFirstArrow"] = null;

	UCF_DomUtil["removeFromDom"](oSecondArrow);
	this["oSecondArrow"] = null;
};;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["cleanUp"] = 0; };

/**
 * needed to determine the hovered element
 */
UCF_LineDecorator["prototype"]["hide"] = function () {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["hide"]++; }; 

	if (this["oLineDomRef"]) {
		this["oLineDomRef"]["style"]["display"] = "none";
		this["oFirstArrow"]["style"]["display"] = "none";
		this["oSecondArrow"]["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["hide"] = 0; };
UCF_LineDecorator["prototype"]["show"] = function () {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["show"]++; }; 

	if (this["oLineDomRef"]) {
		this["oLineDomRef"]["style"]["display"] = "block";
		this["oFirstArrow"]["style"]["display"] = "block";
		this["oSecondArrow"]["style"]["display"] = "block";
	}

};;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["show"] = 0; };

UCF_LineDecorator["prototype"]["setBounds"] = function (iLeft, iTop, iLength) {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["setBounds"]++; }; 
	//_trace(INFO,"D&D");

	if (!this["oLineDomRef"])
		return;

	if (!isNaN(iLeft)) {

		if (this["bHorizontal"]) {
			if (window["UCF_System"]["bIsRTL"]) {
				this["oLineDomRef"]["style"]["left"] = (iLeft + UCF_LineDecorator["SIZES"]["ARROW_WIDTH"]) + "px";
			}
			else {
				this["oLineDomRef"]["style"]["left"] = (iLeft + UCF_LineDecorator["SIZES"]["ARROW_WIDTH"] + this["iGap"]) + "px";
			}
			this["oFirstArrow"]["style"]["left"] = (iLeft - UCF_LineDecorator["SIZES"]["ARROW_WIDTH"]) + "px";
		} else {
			this["oLineDomRef"]["style"]["left"] = (iLeft) + "px";
			this["oFirstArrow"]["style"]["left"] = (iLeft - UCF_LineDecorator["SIZES"]["ARROW_HEIGHT"]) + "px";
			this["oSecondArrow"]["style"]["left"] = (iLeft - UCF_LineDecorator["SIZES"]["ARROW_HEIGHT"]) + "px";
		}

	}

	if (!isNaN(iTop)) {
		this["oLineDomRef"]["style"]["top"] = (iTop) + "px";
		if (this["bHorizontal"]) {
			this["oFirstArrow"]["style"]["top"] = (iTop - UCF_LineDecorator["SIZES"]["ARROW_HEIGHT"]) + "px";
			this["oSecondArrow"]["style"]["top"] = (iTop - UCF_LineDecorator["SIZES"]["ARROW_HEIGHT"]) + "px";
		} else {
			this["oFirstArrow"]["style"]["top"] = (iTop - UCF_LineDecorator["SIZES"]["ARROW_WIDTH"] + this["iGap"]) + "px";
		}
	}

	if (!isNaN(iLength)) {

		if (this["bHorizontal"]) {
			this["oLineDomRef"]["style"]["width"] = (iLength - this["iGap"] - UCF_LineDecorator["SIZES"]["ARROW_WIDTH"]) + "px";
			this["oSecondArrow"]["style"]["left"] = (iLeft + iLength - 8) + "px";
		} else {
			this["oLineDomRef"]["style"]["height"] = (iLength - this["iGap"] - UCF_LineDecorator["SIZES"]["ARROW_WIDTH"]) + "px";
			this["oSecondArrow"]["style"]["top"] = (iTop + iLength - 8) + "px";
		}
	}

};;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["setBounds"] = 0; };

UCF_LineDecorator["prototype"]["update"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["update"]++; };  };;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["update"] = 0; };

/**
 * @param {integer} iGap
 * sets the gap between first arrow and line
 */
UCF_LineDecorator["prototype"]["setGap"] = function (iGap) {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["setGap"]++; }; 
	this["iGap"] = iGap;
};;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["setGap"] = 0; };

/**
 * @param {string} sId
 * sets the id of the decorator
 * use a id to re-use decorators after a roundtrip
 * (e.g. automatic table scrolling, tree expanding)
 */
UCF_LineDecorator["prototype"]["setId"] = function (sId) {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["setId"]++; }; 
	this["sId"] = sId;
};;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["setId"] = 0; };

UCF_LineDecorator["prototype"]["bIsVisible"] = function () {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["bIsVisible"]++; }; 
	if (!this["oLineDomRef"]) return false;
	return this["oLineDomRef"]["style"]["display"] !== "none";
};;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["bIsVisible"] = 0; };

/**
 * sets the z-index of all involved dom elements
 * @param {integer} iZIndex
 */
UCF_LineDecorator["prototype"]["setZIndex"] = function (iZIndex) {;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["setZIndex"]++; }; 
	if (this["oLineDomRef"])
		this["oLineDomRef"]["style"]["zIndex"] = iZIndex;

	if (this["oFirstArrow"])
		this["oFirstArrow"]["style"]["zIndex"] = iZIndex;

	if (this["oSecondArrow"])
		this["oSecondArrow"]["style"]["zIndex"] = iZIndex;
};;if (__UCF_COVERAGE__) { UCF_LineDecorator["_"]["setZIndex"] = 0; };

};
sap["ls"]["preload"]["UCF_Link"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_RenderManager */
/// <reference path="../core/RenderManager.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ImageUtil */
/// <reference path="../core/ImageUtil.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Link(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Link["_"]["UCF_Link"]++; }; 
	var oLinkIconRef;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Link.js(41): UCF_Link"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Link.js(42): UCF_Link"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Link.js(43): UCF_Link"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["bIgnoreDefaultButton"] = true; //ignore the default button if the control gets the focus

	this["bCheckWrapping"] = false;
	this["sLinkText"] = null;
	this["sLinkTooltip"] = null;
	this["sCaptionTooltip"] = null;
	this["b508MouseOver"] = false;
	this["bAttachedClientUpdateResize"] = false;

	this["bAllowTextSelection"] = true; // to allow a textselection of the link

	oLinkIconRef = UCF_DomUtil["$"](this["sId"] + '-icon');
	// eslint-disable-next-line @ur/no-missing-setClientProperty, @ur/no-memory-leaks
	this["bImageFirst"] = oLinkIconRef && (UCF_DomUtil["bHasClass"](oLinkIconRef, 'lsLinkIcon--before') || UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsLinkImgBefore--overlay'));
	this["setClientProperty"]("ImageFirst", this["bImageFirst"], true);

	this["sHotkeyStr"] = this["sGetHotkeyString"]();
	var sTooltipWithoutHotkey = this["sHotkeyStr"]
		? this["oDomRef"]["title"]["substring"](0, this["oDomRef"]["title"]["indexOf"](this["sHotkeyStr"]) - 1)
		: this["oDomRef"]["title"];

	if (sTooltipWithoutHotkey === this["sTooltip"]) {
		this["sCaptionTooltip"] = "";
	} else if (this["sTooltip"] === "") {
		this["sCaptionTooltip"] = sTooltipWithoutHotkey;
	} else {
		this["sCaptionTooltip"] = sTooltipWithoutHotkey["substring"]((this["sTooltip"] + ' - ')["length"]);
	}
};window["UCF_Link"] = UCF_Link; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Link"); UCF_Link["_"] = {UCF_Link: 0}; }; ;

UCF_Link["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Link.prototype["sClassName"] = "UCF_Link";

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Link["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Link.js(87): onclick"); };

	var oTextNodeRef = UCF_DomUtil["$"](this["sId"] + '-text');

	//do not fire event if Link is disabled or has no text and icon or has a text selection
	if (UCF_DomUtil["bHasSelection"](oTextNodeRef) || !this["bEnabled"] || (this["oDomRef"]["getAttribute"]("st") === "d0")) return;

	if (this["mEvents"]["Activate"]) {

		var bCtrl = oBrowserEvent["bCtrl"](),
			bShift = oBrowserEvent["bShift"]();
		this["fireActivate"](this["sId"], bCtrl, bShift);
	}

	oBrowserEvent["cancelBubble"]();

	if (!this["bHasReference"]) {
		oBrowserEvent["cancel"]();
	} else {
		var url = this["oDomRef"]["href"],
			windowId = this["oDomRef"]["target"];

		if (url && windowId !== "" && windowId !== "_blank" && windowId !== "_top" && windowId !== "_parent" && windowId !== "_self") {
			//named target: open the window and try to focus it. Reason: second click on a named link doesn't bring the named window to the front.
			var bNoOpener = false;
			var sRel = this["getRel"]();
			if (sRel) {
				bNoOpener = sRel["indexOf"]('noopener') > -1;
			}
			var oPage = this["oLS"]["oGetPageInternal"]();
			if (oPage) {
				// This will also focus the new window
				oPage["openExternalWindow"](windowId, url, null, null, null, null, false, false, false, false, bNoOpener);
			}
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["onclick"] = 0; };

/**
 * Handles the onmousedown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Link["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Link.js(133): onmousedown"); };

	if (!this["bEnabled"] || (this["oDomRef"]["getAttribute"]("st") === "d0")) return;

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["onmousedown"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Link["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Link.js(147): ondblclick"); };

	if (!this["bEnabled"] || (this["oDomRef"]["getAttribute"]("st") === "d0") || !this["mEvents"]["DoubleClick"]) return;

	this["fireDoubleClick"](this["sId"]);
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_Link["_"]["ondblclick"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Link["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["onmouseover"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Link.js(165): onmouseover"); };

	if (!this["bHasReference"]) {
		window["status"] = "";
		oBrowserEvent["oDomEvent"]["returnValue"] = true;
	}

	if (window["UCF_System"]["bIs508"]) return;

	try {
		if (this["sLinkTooltip"] == null) {
			this["sLinkTooltip"] = this["oDomRef"]["getAttribute"]("title");
			// Link renderer sets an omit value if no tooltip is set.
			// To avoid a visit an if-block twice an empty string will be applied.
			if (!this["sLinkTooltip"]) {
				this["sLinkTooltip"] = "";
			}
		}
	} catch (oException) {
		this["sLinkTooltip"] = this["sTooltip"];
	}

	if (this["sLinkText"] == null) {
		this["sLinkText"] = this["sText"];
		if (this["sLinkText"] === "") {
			this["sLinkText"] = UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](this["oDomRef"]));
		}
	}

	if (this["sLinkText"] != null && this["sLinkText"] !== "") {
		var oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + "-ovfl");
		if (!oDomRefOvfl) {
			// Link is a inline, inline-block element for some themes and inline-flex element for others
			// TODO - find another way to ask about inline-flex container
			var sDisplayValue = UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'display');
			if (sDisplayValue === 'inline-flex' || sDisplayValue === 'flex') {
				oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + "-text");
			}
		}

		/** @type {{sDomRef: string, sDomRefOvfl: string}} */
		var oTooltip = UCF_DomUtil["oGetTooltip"](this["oDomRef"], this["sLinkTooltip"], oDomRefOvfl, this["sLinkText"]);

		if ('sDomRef' in oTooltip) {
			UCF_DomUtil["setTooltip"](this["oDomRef"], oTooltip["sDomRef"]);
		}

	}

};;if (__UCF_COVERAGE__) { UCF_Link["_"]["onmouseover"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Link["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["onlsselect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Link.js(224): onlsselect"); };

	if (!this["bEnabled"] || (this["oDomRef"]["getAttribute"]("st") === "d0")) return; //do not fire event if Link is disabled or has no text and icon

	this["oDomRef"]["click"](oBrowserEvent); // simulate click event
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_Link["_"]["onlsselect"] = 0; };

/**
 * @return { string }
 */
UCF_Link["prototype"]["sGetTitle"] = function() {;if (__UCF_COVERAGE__) { UCF_Link["_"]["sGetTitle"]++; }; 
	var sTitle = UCF_DomUtil["sGetInnerText"](this["oDomRef"]);
	return sTitle;
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["sGetTitle"] = 0; };

/**
 * Returns the icon source
 *
 * @return {string}
 * @private
 */
UCF_Link["prototype"]["sGetIconSource"] = function() {;if (__UCF_COVERAGE__) { UCF_Link["_"]["sGetIconSource"]++; }; 

	var oParent = this["oGetParent"]();
	var oIconRef = UCF_DomUtil["$"](this["sId"] + '-icon');
	if (oParent && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_Toolbar_standards')) {
		return this["oRootRef"]["getAttribute"]('data-iconsrc') || '';
	} else
		return UCF_ImageUtil["sGetImageSource"](oIconRef);
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["sGetIconSource"] = 0; };

/**
 * Set the Icons source
 *
 * @param {string} sIconSrc Source of the icon
 * @public
 */
UCF_Link["prototype"]["setIconSource"] = function(sIconSrc) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["setIconSource"]++; }; 
	var oRendererManager;
	var oParent = this["oGetParent"]();
	var oImgRef = UCF_DomUtil["$"](this["sId"] + '-icon');

	if (sIconSrc !== "") {
		if (oImgRef) {
			oRendererManager = this["oLS"]["oGetRenderManager"]();
			this["renderLinkImage"](sIconSrc, oRendererManager);
			UCF_DomUtil["replaceElement"](
				oImgRef,
				oRendererManager["oGetElementFromHtml"]()
			);
			oRendererManager["clearBuffer"]();
		}

		if (oParent && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_Toolbar_standards')) {
			if (this["oRootRef"] && this["oRootRef"]["hasAttribute"]('data-iconsrc')) {
				this["oRootRef"]["setAttribute"]('data-iconsrc', sIconSrc);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["setIconSource"] = 0; };

/**
 * @private
 * @param {string} sIconSrc the icon src
 * @param {UCF_RenderManager} oRenderManager the render manager
 */
UCF_Link["prototype"]["renderLinkImage"] = function(sIconSrc, oRenderManager) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["renderLinkImage"]++; }; 
	oRenderManager["write"](this["oLS"]["oGetRenderManager"]()["callFragment"](
		'LinkIconFragment',
		'Link', {
			"Id": this["sId"],
			"Text": this["sText"],
			"ImageFirst": this["bImageFirst"],
			"ImageSrc": sIconSrc,
			"ImageAlt": '',
			"ImageWidth": '',
			"ImageHeight": '',
			"Wrapping": this["bWrapping"],
			"IsLink": true
		}
	));
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["renderLinkImage"] = 0; };

/**
 * @public
 * @param {string} sRel
 */
UCF_Link["prototype"]["setRel"] = function(sRel) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["setRel"]++; }; 
	if (sRel) {
		this["oDomRef"]["setAttribute"]('rel', sRel);
	} else {
		this["oDomRef"]["removeAttribute"]('rel');
	}
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["setRel"] = 0; };

/**
 * @public
 * @return {string}
 */
UCF_Link["prototype"]["getRel"] = function() {;if (__UCF_COVERAGE__) { UCF_Link["_"]["getRel"]++; }; 
	return this["oDomRef"]["getAttribute"]('rel');
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["getRel"] = 0; };

/**
 * Set the text
 *
 * @param {string} sText new text for the link
 * @public
 */
UCF_Link["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["setText"]++; }; 

	/** @type {HTMLSpanElement} */
	var oTextOverFlowRef = UCF_DomUtil["$"](this["sId"] + '-ovfl');
	/** @type {HTMLSpanElement} */
	var oTextNodeRef = UCF_DomUtil["$"](this["sId"] + "-text");
	/** @type {HTMLSpanElement} */
	var oLinkImgRef = UCF_DomUtil["$"](this["sId"] + '-icon');
	/** @type {string} */
	var sCurrentText = this["sText"];

	// Check a title attribute to pick a proper tooltip to update all of the link containers using it.
	if (this["oDomRef"]["title"] === sCurrentText) {
		this["oDomRef"]["title"] = "";
		if (UCF_DomUtil["bNotEmpty"](oTextOverFlowRef, 'title')) {
			oTextOverFlowRef["removeAttribute"]('title');
		}
		if (UCF_DomUtil["bNotEmpty"](oTextNodeRef, 'title')) {
			oTextNodeRef["removeAttribute"]('title');
		}
	}

	// check the image and it's position to use correct css classes
	if (oLinkImgRef && oLinkImgRef === this["oDomRef"]["firstChild"]) {
		//oTextNode = oImgRef.nextSibling; => IE11 and Quirks have <wbr/> as a next sibling
		if (UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsLinkImgBefore--overlay')) {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsLinkImgBefore--overlay');
		}
		if (UCF_DomUtil["bHasClass"](oLinkImgRef, 'lsLinkIcon')) {
			UCF_DomUtil["replaceClass"](oLinkImgRef, 'lsLinkIcon', 'lsLinkIcon--before');
		}
	} else {
		// oTextNode = this.oDomRef.firstChild; => not usefull because of the first if block
		if (UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsLinkImgAfter--overlay')) {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsLinkImgAfter--overlay');
		}
		if (oLinkImgRef && UCF_DomUtil["bHasClass"](oLinkImgRef, 'lsLinkIcon')) {
			UCF_DomUtil["replaceClass"](oLinkImgRef, 'lsLinkIcon', 'lsLinkIcon--after');
		}
	}

	// Set a new text
	if (oTextNodeRef) {
		// check if the accesskey is a part of the text and have the same case letter
		if (this["sAccessKey"] !== '' && this["bShowAccessKey"]) {
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oTextNodeRef, new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(undefined, this["oLS"])["sAccessKeyTextFragment"](
				sText,
				this["sAccessKey"],
				this["bEnabled"]
			));
		} else {
			UCF_DomUtil["setInnerText"](oTextNodeRef, sText);
		}
		// set a correct css class for a emphasized
		if (sText !== '' && this["bEmphasized"]
			&& !UCF_DomUtil["bHasClass"](oTextNodeRef, 'lsLink__text--emph')) {
			UCF_DomUtil["addClass"](oTextNodeRef, 'lsLink__text--emph');
		}
	}
	// Link with an icon and without a text and a reference has a role = 'button'
	// otherwise role = 'link'
	if (window["UCF_System"]["bIsAria"] && this["oDomRef"]["getAttribute"]('role') === 'button' && sText !== '' && this["sContentVisibility"] !== 'ICON') {
		UCF_AriaStateHelper["setRole"](this["oDomRef"], 'link');
	}

	// Update the text for overflow container
	if (oTextOverFlowRef) {
		UCF_DomUtil["setInnerText"](oTextOverFlowRef, sText);
	}

	// eslint-disable-next-line @ur/no-missing-setClientProperty, @ur/no-memory-leaks
	this["sText"] = sText;
	this["sLinkText"] = null;
	this["setClientProperty"]("Text", this["sText"], true);
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["setText"] = 0; };

/**
 * @return {string} the hotkey tooltip string
 */
UCF_Link["prototype"]["sGetHotkeyString"] = function() {;if (__UCF_COVERAGE__) { UCF_Link["_"]["sGetHotkeyString"]++; }; 
	// 'undefinded' is kept from previous version of this method. it seems to work
	return this["sHotkey"] && (this["sHotkey"] !== 'NONE' || this["sHotkey"] !== 'undefinded')
		? this["oLS"]["oGetRenderManager"]()["callFragment"](
			'UrBase_sHotkeyTooltip',
			'UrBase', { "Hotkey": this["sHotkey"] }
		)
		: '';
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["sGetHotkeyString"] = 0; };

/**
 * Sets the tooltip of a Link control
 *
 * @example
 * // with linktooltip = 'hugo', captiontooltip = 'willi'
 * setTooltip("hallo1") // => "hallo1 - willi"
 * setTooltip(undefined, "hallo2") // => "hallo1 - hallo2"
 * setTooltip("hallo", "welt") // => "hallo - welt"
 *
 * @public
 * @param {string} sTooltip the new tooltip of the Link
 * @param {string} sCaptionTooltip
 */
UCF_Link["prototype"]["setTooltip"] = function(sTooltip, sCaptionTooltip) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["setTooltip"]++; }; 
	/** @type {string} */
	var sHotkeyTooltip = this["sGetHotkeyString"]();
	/** @type {string} */
	var sTitle;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sTooltip === 'string', "typeof sTooltip === 'string'", "Link.js(445): setTooltip"); };

	this["sLinkTooltip"] = null;
	this["sLinkText"] = null;

	if (typeof sTooltip === 'string') {
		// eslint-disable-next-line @ur/no-missing-setClientProperty, @ur/no-memory-leaks
		this["sTooltip"] = sTooltip;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Tooltip", this["sTooltip"], true);
	}
	if (typeof sCaptionTooltip === 'string') {
		this["sCaptionTooltip"] = sCaptionTooltip;
	}

	// render a new tooltip
	sTitle = this["oLS"]["oGetRenderManager"]()["callFragment"](
		'LinkGetTooltip',
		'Link', {
			"HasLinkCaption": this["bHasLinkCaption"],
			"LinkCaption": { "Tooltip": this["sCaptionTooltip"] },
			"Tooltip": this["sTooltip"]
		}
	);

	// title = sTitle + sHotkeyTooltip if exits
	if (sHotkeyTooltip !== "") {
		this["oDomRef"]["title"] = sTitle + ' ' + sHotkeyTooltip;
	} else {
		this["oDomRef"]["title"] = sTitle + sHotkeyTooltip;
	}

	// update the content of the attribute tt if bIs508 and tooltip (sTitle) is not empty
	if (window["UCF_System"]["bIs508"] && sTitle !== "") {
		this["oDomRef"]["setAttribute"]('tt', sTitle);
	}

	// to update the screenreader speech output after setting of a new tooltip
	if (window["UCF_System"]["bIs508"] && this["bHasFocus"]()) {
		this["refocus"]();
	}

};;if (__UCF_COVERAGE__) { UCF_Link["_"]["setTooltip"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Link["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Link.js(497): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	var sTooltip = this["oDomRef"]["getAttribute"]("tt"); //tt contains the concatenated tooltip of caption and link
	var oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + "-ovfl");

	var enabled = this["bEnabled"];

	if (this["oDomRef"]["getAttribute"]("st") === "d0") {
		oAccessibilityHelper["setEmpty"](true);
		enabled = false;
	}

	//Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this, "", UCF_StringUtil["sTrim"](this["sLabelText"]));
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

	oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
	oAccessibilityHelper["setHotkey"](this["sHotkey"]);
	oAccessibilityHelper["setEnabled"](enabled);
	if (oDomRefOvfl) {
		oAccessibilityHelper["setText"](UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](oDomRefOvfl)));
	} else {
		oAccessibilityHelper["setText"](UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](this["oDomRef"])));
	}

	if (sTooltip && this["sText"] !== UCF_StringUtil["sTrim"](sTooltip)) oAccessibilityHelper["setTooltip"](UCF_StringUtil["sTrim"](sTooltip));

	oAccessibilityHelper["setControlType"]("LN");
	oAccessibilityHelper["addEnabledTutor"]("LN_TUT", enabled);

	if (this["bEmphasized"] === true) {
		oAccessibilityHelper["addSemantic"]("EMPHASIZED");
	}
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["onlsaccessibility"] = 0; };

UCF_Link["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Link["_"]["destroy"]++; }; 
	if (this["bAttachedClientUpdateResize"]) {
		this["detachBrowserEvent"]("resize", this["oDomRef"]);
	}
	this["sLinkText"] = null;
	this["sLinkTooltip"] = null;
	this["sCaptionTooltip"] = null;
	this["sHotkeyStr"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["destroy"] = 0; };

/**
 * @return {Object}
 * @private
 */
UCF_Link["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_Link["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);

	var oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-text');
	if (this["sText"] !== '' && oTextDomRef && UCF_DomUtil["bHasTextEllipsis"](this["oDomRef"], oTextDomRef)) {
		aResult["push"]({
			"sType": 'TEXT',
			"sText": this["sText"]
		});
	}

	return aResult;
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["aGetTouchContextMenuEntries"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_Link["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_Link["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
		}
	}
	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["bPrepareAria"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Link["prototype"]["aAttributeNames"] = ["sTooltip","sText","bHasReference","bEnabled","bHasLinkCaption","sVisibility","sLabelText","bEmphasized","sAccessKey","bShowAccessKey","sHotkey","sCustomData","sCustomStyle","sLabelledBy","sContentVisibility"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Link["prototype"]["aEventNames"] = ["Activate","DoubleClick"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Link["prototype"]["aMethodNames"] = ["setIconSource","setTooltip","setText","setRel","getRel","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Link["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Link["prototype"]["sText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Link["prototype"]["bHasReference"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Link["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_Link["prototype"]["bHasLinkCaption"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Link["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_Link["prototype"]["sLabelText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Link["prototype"]["bEmphasized"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Link["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Link["prototype"]["bShowAccessKey"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HotkeyValue}
 */
UCF_Link["prototype"]["sHotkey"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_Link["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Link["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Link["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ContentVisibility}
 */
UCF_Link["prototype"]["sContentVisibility"] = "ALL";

//#JSCOVER_EXCL_START
/** @protected */
UCF_Link["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Link["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sText"] = '';
	this["bHasReference"] = false;
	this["bEnabled"] = true;
	this["bHasLinkCaption"] = false;
	this["sVisibility"] = "VISIBLE";
	this["sLabelText"] = '';
	this["bEmphasized"] = false;
	this["sAccessKey"] = '';
	this["bShowAccessKey"] = true;
	this["sHotkey"] = "NONE";
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sLabelledBy"] = '';
	this["sContentVisibility"] = "ALL";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("HasReference", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("HasLinkCaption", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("LabelText", '', true);
		this["setClientProperty"]("Emphasized", false, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("ShowAccessKey", true, true);
		this["setClientProperty"]("Hotkey", "NONE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("ContentVisibility", "ALL", true);
	}
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {boolean} bCtrl 'true' if modifier 'Crtl' was hold while activate the link. This is usually used to open the link in an external tab even if 'Shift' was hold as well.
 * @param {boolean} bShift 'true' if modifier 'Shift' was hold while activate the link. This is usually used to open the link in an external window.
 * @fires Link::Activate
 */
UCF_Link["prototype"]["fireActivate"] = function(sId, bCtrl, bShift) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["fireActivate"]++; }; 
	/** @type {{Id: string, Ctrl: boolean, Shift: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Link.js(747): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Link.js(748): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Link.js(749): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "Link.js(750): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "Link.js(751): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "Link.js(752): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "Link.js(753): fireActivate"); };
	mParams = {
		"Id": sId,
		"Ctrl": bCtrl,
		"Shift": bShift
	};
	
	
	
	this["fireSemanticEvent"]("Link", "Activate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["fireActivate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Link control.
 * @fires Link::DoubleClick
 */
UCF_Link["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Link["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Link.js(774): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Link.js(775): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Link.js(776): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Link", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Link["_"]["fireDoubleClick"] = 0; };

UCF_Link.prototype["aPublicMethods"] = ["setIconSource","setRel","getRel","setText","setTooltip"].concat(UCF_Link.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_LinkChoice"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_LinkChoice(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["UCF_LinkChoice"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "LinkChoice.js(35): UCF_LinkChoice"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "LinkChoice.js(36): UCF_LinkChoice"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "LinkChoice.js(37): UCF_LinkChoice"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["defineEvents"](['OpenMenu']);

	//ignore the default button if the control gets the focus
	this["bIgnoreDefaultButton"] = true;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bDelegateOpenMenu"] = false;

};window["UCF_LinkChoice"] = UCF_LinkChoice; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LinkChoice"); UCF_LinkChoice["_"] = {UCF_LinkChoice: 0}; }; ;
UCF_LinkChoice["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_LinkChoice.prototype["sClassName"] = "UCF_LinkChoice";

UCF_LinkChoice["prototype"]["eStyles"] = {
	"LINKCHOICE_TOUCHABLE": "lsLinkChoice--touchable"
};

/**
 * Handles the onkeydown event of the browser
 *
 * [ALT] + [UP] - toggle the menu
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */

UCF_LinkChoice["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LinkChoice.js(65): onkeydown"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'LinkChoice Id: ' + this["sId"] + ' ================ KeyDown: ' + oBrowserEvent["iKeyCode"](), "LinkChoice.js(67): onkeydown"); };

	if (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["ARROW_UP"], 'A')) {
		this["toggleMenu"](oBrowserEvent, true);
	}

};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onkeydown"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LinkChoice["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LinkChoice.js(82): onclick"); };
	//fired by mouse click

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	this["toggleMenu"](false); //could open the menu
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onclick"] = 0; };

/**
 * Handles the onlsshow event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LinkChoice["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onlsshow"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LinkChoice.js(97): onlsshow"); };
	//fired by keyboard - F4 and Alt+cursor down

	oBrowserEvent["cancel"](); // cancel event to avoid browser handling of F4
	oBrowserEvent["cancelBubble"]();
	this["toggleMenu"](true);
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onlsshow"] = 0; };

/**
 * Handles the onlsselect event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LinkChoice["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LinkChoice.js(112): onlsselect"); };
	//fired by space

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	this["toggleMenu"](true); //should never causes the menu to open
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onlsselect"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LinkChoice["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LinkChoice.js(127): onmouseover"); };

	if (!window["UCF_System"]["bIs508"]) {
		this["updateTitle"]();
	}

	if (oBrowserEvent["bIsMouseHover"]()) {
		if (UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["LINKCHOICE_TOUCHABLE"])) {
			UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["LINKCHOICE_TOUCHABLE"]);
		}
	} else {
		UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["LINKCHOICE_TOUCHABLE"]);
	}
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onmouseover"] = 0; };

/**
 * Checks if the given oDomRef has ellipsis and set the text as tooltip
 *
 * @private
 */
UCF_LinkChoice["prototype"]["updateTitle"] = function() {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["updateTitle"]++; }; 
	/** @type {boolean} */
	var bIsRTL = window["UCF_System"]["bIsRTL"];
	/** @type {boolean} */
	var bIsIEQuirksMode = UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== 'standards';
	/** @type {string} */
	var sTooltip = this["sTooltip"];
	/** @type {string} */
	var sSepator = (sTooltip !== "") ? " - " : "";
	/** @type {HTMLElement} */
	var oDomRefOvfl;
	/** @type {string} */
	var sText;

	if (bIsIEQuirksMode) {
		oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + "-ovfl") || UCF_DomUtil["$"](this["sId"] + "-text");
	}
	if (window["UCF_System"]["sDevice"] === 'standards') {
		oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + '-text');
	}

	if (oDomRefOvfl) {
		sText = UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](oDomRefOvfl));
	} else {
		sText = UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](this["oDomRef"]));
	}

	/** @type {boolean} */
	var bHasTextEllipsisIEQuirks = bIsIEQuirksMode && (oDomRefOvfl["offsetWidth"] >= this["oDomRef"]["offsetWidth"]
		|| Math["floor"](this["oDomRef"]["scrollWidth"] - this["oDomRef"]["offsetWidth"]) > 1
		|| Math["floor"](oDomRefOvfl["scrollWidth"] - oDomRefOvfl["offsetWidth"]) > 1
		|| this["oDomRef"]["offsetWidth"] > this["oDomRef"]["parentNode"]["offsetWidth"]);

	/** @type {boolean} */
	var bHasTextEllipsis = UCF_DomUtil["bHasTextEllipsis"](this["oDomRef"], oDomRefOvfl);

	if (!bHasTextEllipsis && oDomRefOvfl && UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsLinkchoice--hasellipsis')) {
		/** @type {CSSStyleDeclaration} */
		var oComputedStyle = UCF_DomUtil["oGetComputedStyle"](oDomRefOvfl);
		/** @type {number} */
		var iRightPadding,
			iLeftPadding,
			iWidth;

		if (bIsRTL) {
			iLeftPadding = parseInt(oComputedStyle["paddingLeft"]);
			iWidth = oDomRefOvfl["offsetWidth"] - iLeftPadding;
		} else {
			iRightPadding = parseInt(oComputedStyle["paddingRight"]);
			iWidth = oDomRefOvfl["offsetWidth"] - iRightPadding;
		}

		/** @type {number} */
		var iTextwidth = UCF_DomUtil["oGetTextSize"](sText, this["oDomRef"]["className"])["width"];

		// check the textoverflow
		if (iTextwidth > oDomRefOvfl["offsetWidth"]
			|| iTextwidth > iWidth
			|| (oDomRefOvfl["offsetWidth"] >= this["oDomRef"]["offsetWidth"])) {
			bHasTextEllipsis = true;
		}
	}

	if ((bHasTextEllipsis && window["UCF_System"]["sDevice"] === 'standards') || bHasTextEllipsisIEQuirks) {
		// if no text is set then no tooltip is to join
		if (sText !== "" && sText !== null && sText !== UCF_StringUtil["sTrim"](sTooltip)) {
			this["oDomRef"]["title"] = sText + sSepator + sTooltip;
		}
	} else {
		this["oDomRef"]["title"] = sTooltip;
	}
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["updateTitle"] = 0; };

/**
 * Open menu
 *
 * @param {boolean} bWithKeyboard determines if popup was opened with keyboard or mouse
 */
UCF_LinkChoice["prototype"]["openMenu"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["openMenu"]++; }; 
	if (this["sPopupMenuId"] === "" || this["oGetControlById"](this["sPopupMenuId"]) == null) return;

	this["oPopupMenu"] = this["oGetControlById"](this["sPopupMenuId"], true);

	if (this["oPopupMenu"]["bOpened"]) return;

	this["oPopupMenu"]["setAutoRefocus"](true); //refocus this element if popup menu is closed

	this["oPopupMenu"]["setOpenerRef"](this["oDomRef"]);
	UCF_DomUtil["addClass"](this["oDomRef"], "lsLinkChoice--menu-open");
	this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);

	if (!this["bDelegateOpenMenu"]) {
		this["oPopupMenu"]["open"](bWithKeyboard); //bWithKeyboard=true --> opened by keyboard --> select first entry
		this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onPopupMenuClose");
	} else {
		this["fireEvent"](this["E_EVENTS"]["OpenMenu"], { "sId": this["sId"], "sMenuId": this["sPopupMenuId"], "bIsButtonChoice": this["bHasPopupMenuSection"] });
	}

};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["openMenu"] = 0; };

/**
 * Toggle menu
 *
 * @param {boolean} bWithKeyboard determines if popup was opened with keyboard or mouse
 */
UCF_LinkChoice["prototype"]["toggleMenu"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["toggleMenu"]++; }; 
	// cancel event to avoid page scrolling in the browser

	if (!this["bEnabled"]) return;

	if (this["sPopupMenuId"] === "" || (this["sPopupMenuId"] !== "" && this["oGetControlById"](this["sPopupMenuId"]) == null)) { //used for loading on demand menue - no popup ID or Popup Object
		this["fireMenuAccess"](this["sId"], this["sPopupMenuId"]);
		return;
	}

	this["oPopupMenu"] = this["oGetControlById"](this["sPopupMenuId"], true);

	if (this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"]();
	} else {
		this["fireMenuAccess"](this["sId"], this["sPopupMenuId"]);
		this["openMenu"](bWithKeyboard);
	}
	if (!this["oPopupMenu"]["bOpened"]) {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsLinkChoice--menu-open');
	}

};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["toggleMenu"] = 0; };

/**
 * Set ID of the popup menu connected to the linkChoice. Cleans up a previous existing popup menu
 *
 * @param {string} bPopupMenuId ID of popup menu
 */

UCF_LinkChoice["prototype"]["setPopupMenuId"] = function(sPopupMenuId) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["setPopupMenuId"]++; }; 
	if (this["oPopupMenu"] && this["oPopupMenu"]["sId"] !== sPopupMenuId) {
		//clenup an existing PopupMenu object to be able to create a new one
		if (this["oPopupMenu"]["bIsValid"]() && this["oPopupMenu"]["bOpened"]) this["oPopupMenu"]["close"]();
		this["oPopupMenu"] = null;
	}
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sPopupMenuId"] = sPopupMenuId;
	this["setClientProperty"]("PopupMenuId", this["sPopupMenuId"], true);
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["setPopupMenuId"] = 0; };

/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @param {UCF_BrowserEvent} oEvent  when the menu is closed
 * @private
 */
UCF_LinkChoice["prototype"]["onPopupMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onPopupMenuClose"]++; }; 
	if (this["oPopupMenu"]) {
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onPopupMenuClose");
	}
	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsLinkChoice--menu-open');
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onPopupMenuClose"] = 0; };

/**
 * Set the text
 *
 * @param {string} sText new text for the linkchoice
 * @public
 */
UCF_LinkChoice["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["setText"]++; }; 
	/** @type {HTMLSpanElement} */
	var oLinkChoiceAriaLabel = UCF_DomUtil["$"](this["sId"] + '-arialabel');
	var oLinkChoiceAriaLabel_iE6 = UCF_DomUtil["$"](this["sId"] + '-label');
	/** @type {HTMLSpanElement} */
	var oTextOverFlowRef = UCF_DomUtil["$"](this["sId"] + '-ovfl');
	/** @type {HTMLSpanElement} */
	var oTextNodeRef = UCF_DomUtil["$"](this["sId"] + '-text');
	var sAriaLabelledById = this["oDomRef"]["getAttribute"]("aria-labelledby");

	if (sText === '') {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsLinkChoice--empty');
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsLinkChoice--empty');
	}

	// Update the text of linkchoice
	if (oTextNodeRef) {
		UCF_DomUtil["setInnerText"](oTextNodeRef, sText);
	}
	// Update the text for overflow container
	if (oTextOverFlowRef) {
		UCF_DomUtil["setInnerText"](oTextOverFlowRef, sText);
	}
	// Update the text of ARIA label container for JAWS
	if (oLinkChoiceAriaLabel) {
		if (UCF_DomUtil["sGetInnerText"](oLinkChoiceAriaLabel) === '') {
			this["oDomRef"]["setAttribute"]('aria-labelledby', sAriaLabelledById + ' ' + this["sId"] + '-arialabel');
		}
		UCF_DomUtil["setInnerText"](oLinkChoiceAriaLabel, sText);

	} else if (oLinkChoiceAriaLabel_iE6) {
		UCF_DomUtil["setInnerText"](oLinkChoiceAriaLabel_iE6, sText);
		oLinkChoiceAriaLabel_iE6["setAttribute"]('aria-label', sText);
	}

	// eslint-disable-next-line @ur/no-missing-setClientProperty, @ur/no-memory-leaks
	this["sText"] = sText;
	this["setClientProperty"]("Text", this["sText"], true);

	this["oDomRef"]["setAttribute"]('title', this["sTooltip"]);

	// Update title
	this["updateTitle"]();

};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["setText"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LinkChoice["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LinkChoice.js(367): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	//Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this);

	oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setText"](this["sText"]);
	//oAccessibilityHelper.setTooltip(this.sTooltip);
	if (this["sTooltip"] !== this["sText"]) {
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	}
	oAccessibilityHelper["setControlType"]("LNC");
	oAccessibilityHelper["addEnabledTutor"]("LNC_TUT", this["bEnabled"]);
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["onlsaccessibility"] = 0; };

/***###########################################################################***/
/***################ Added for handling of menu in toolbar ####################***/
/***###########################################################################***/

/**
 * @param {boolean} bDelegate
 * @private
 */
UCF_LinkChoice["prototype"]["setDelegateOpenMenu"] = function(bDelegate) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["setDelegateOpenMenu"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bDelegateOpenMenu"] = bDelegate;
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["setDelegateOpenMenu"] = 0; };

/**
 * Returns the title
 * @public
 * @return {string}
 */
UCF_LinkChoice["prototype"]["sGetTitle"] = function() {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["sGetTitle"]++; }; 
	var sTitle = UCF_DomUtil["sGetInnerText"](this["oDomRef"]);
	return sTitle;
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["sGetTitle"] = 0; };

/**
 * Returns the icon source
 *
 * @return {string}
 * @private
 */
UCF_LinkChoice["prototype"]["sGetIconSource"] = function() {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["sGetIconSource"]++; }; 
	return this["sImageSrc"];
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["sGetIconSource"] = 0; };

UCF_LinkChoice["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["destroy"]++; }; 

	this["oPopupMenu"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["destroy"] = 0; };

/**
 * @return {Object}
 * @private
 */
UCF_LinkChoice["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	var oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-text');
	if (oTextDomRef && UCF_DomUtil["bHasTextEllipsis"](this["oDomRef"], oTextDomRef)) {
		aResult["push"]({
			"sType": 'TEXT',
			"sText": UCF_DomUtil["sGetInnerText"](oTextDomRef)
		});
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["aGetTouchContextMenuEntries"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_LinkChoice["prototype"]["aAttributeNames"] = ["sTooltip","sText","bEnabled","sPopupMenuId","sVisibility","sAccessKey","sImageSrc","bImageFirst","sCustomData","sCustomStyle","sLabelledBy","sContentVisibility"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_LinkChoice["prototype"]["aEventNames"] = ["MenuAccess"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_LinkChoice["prototype"]["aMethodNames"] = ["openMenu","setPopupMenuId","setText","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_LinkChoice["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_LinkChoice["prototype"]["sText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_LinkChoice["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_LinkChoice["prototype"]["sPopupMenuId"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_LinkChoice["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_LinkChoice["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_LinkChoice["prototype"]["sImageSrc"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_LinkChoice["prototype"]["bImageFirst"] = true;

/**
 * @private
 * @type {string}
 */
UCF_LinkChoice["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_LinkChoice["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_LinkChoice["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ContentVisibility}
 */
UCF_LinkChoice["prototype"]["sContentVisibility"] = "ALL";

//#JSCOVER_EXCL_START
/** @protected */
UCF_LinkChoice["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sText"] = '';
	this["bEnabled"] = true;
	this["sPopupMenuId"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sAccessKey"] = '';
	this["sImageSrc"] = '';
	this["bImageFirst"] = true;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sLabelledBy"] = '';
	this["sContentVisibility"] = "ALL";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("PopupMenuId", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("ImageSrc", '', true);
		this["setClientProperty"]("ImageFirst", true, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("ContentVisibility", "ALL", true);
	}
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the LinkChoice control in the current HTML document context. The Id of any control should be unique within the document.
 * @param {string} sPopupMenuId Identifier assigned PopupMenu in the current HTML document context. The Id of any control should be unique within the document.
 * @fires LinkChoice::MenuAccess
 */
UCF_LinkChoice["prototype"]["fireMenuAccess"] = function(sId, sPopupMenuId) {;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string, PopupMenuId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "LinkChoice.js(581): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "LinkChoice.js(582): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "LinkChoice.js(583): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPopupMenuId != null, "sPopupMenuId != null", "LinkChoice.js(584): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPopupMenuId) == "string", "typeof(sPopupMenuId) == \"string\"", "LinkChoice.js(585): fireMenuAccess"); };
	mParams = {
		"Id": sId,
		"PopupMenuId": sPopupMenuId
	};
	
	if (sPopupMenuId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sPopupMenuId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "PopupMenuId");
			}
		}
	this["fireSemanticEvent"]("LinkChoice", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_LinkChoice["_"]["fireMenuAccess"] = 0; };

UCF_LinkChoice.prototype["aPublicMethods"] = ["setText","sGetTitle"].concat(UCF_LinkChoice.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_LinkedResource"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_LinkedResource(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_LinkedResource["_"]["UCF_LinkedResource"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "LinkedResource.js(17): UCF_LinkedResource"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "LinkedResource.js(18): UCF_LinkedResource"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "LinkedResource.js(19): UCF_LinkedResource"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_LinkedResource"] = UCF_LinkedResource; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LinkedResource"); UCF_LinkedResource["_"] = {UCF_LinkedResource: 0}; }; ;

UCF_LinkedResource["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_LinkedResource.prototype["sClassName"] = "UCF_LinkedResource";

/**
 * Contructor
 * @private
 */
UCF_LinkedResource["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_LinkedResource["_"]["initialize"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_LinkedResource["_"]["initialize"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_LinkedResource["prototype"]["aAttributeNames"] = [];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_LinkedResource["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_LinkedResource["prototype"]["aMethodNames"] = [];


//#JSCOVER_EXCL_START
/** @protected */
UCF_LinkedResource["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_LinkedResource["_"]["setDefaultValues"]++; }; 
	

	if (this["getClientControl"]() && !this["bKeepAlive"]) ;
};;if (__UCF_COVERAGE__) { UCF_LinkedResource["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ListBinding"] = function() {/* global UCF_Binding */
/// <reference path="./Binding.js"/>

/**
 * @template T
 * @typedef {Object} UCF_ListBinding_Sorter
 * @property {function(T, T): number} fnCompare
 * @property {boolean} bDescending
 */
/**
 * @template T
 * @typedef {Object} UCF_ListBinding_Filter
 * @property {T} oValue1
 * @property {T} oValue2
 * @property {'EQ'|'NE'|'LT'|'LE'|'GT'|'GE'|'BT'|'Contains'|'StartsWith'|'EndsWith'} sOperator
 * @property {function(T): boolean} fnTest
 */

/**
 * Constructor for ListBinding
 *
 *
 * The ListBinding is a specific binding for lists in the model, which can be
 * used to populate Tables or ItemLists.
 *
 * @class
 * @param {UCF_Model} oModel
 * @param {string} sPath
 * @param {UCF_BindingContext} oContext
 * @param {UCF_ListBinding_Sorter} oSorter
 * @param {Array} aFilters
 * @param {Object} mParameters
 * @public
 */
function UCF_ListBinding(oModel, sPath, oContext, oSorter, aFilters, mParameters) {if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["UCF_ListBinding"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Binding["apply"](this, [oModel, sPath, oContext, mParameters]);

		this["defineEvents"](['Sort', 'Filter']);

		/** @type {UCF_ListBinding_Sorter} */
		this["oSorter"] = oSorter;
		this["aFilters"] = aFilters;
	}
};window["UCF_ListBinding"] = UCF_ListBinding; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ListBinding"); UCF_ListBinding["_"] = {UCF_ListBinding: 0}; }; ;
UCF_ListBinding["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Binding"))(); UCF_ListBinding.prototype["sClassName"] = "UCF_ListBinding";

/** @override */
UCF_ListBinding["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["destroy"]++; }; 
	this["oSorter"] = null;
	this["aFilters"] = null;

	UCF_Binding.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["destroy"] = 0; };

// the 'abstract methods' to be implemented by child classes
/**
 * Returns the current value of the bound target
 *
 * @public
 * @function
 * @name UCF_ListBinding.prototype.getContexts
 * @return {Array} the array of contexts for each row of the bound list
 */

/**
 * Filters the list according to the filter definitions
 *
 * @public
 * @function
 * @name UCF_ListBinding.prototype.filter
 * @param {Array} aFilters Array of UCF_Filter objects
 */

/**
 * Sorts the list according to the sorter object
 *
 * @public
 * @function
 * @name UCF_ListBinding.prototype.sort
 * @param {UCF_ListBinding_Sorter} oSorter the Sorter object which defines the
 * sort order
 */

// base methods, may be overridden by child classes
/**
 * Returns list of distinct values for the given relative binding path
 *
 * @public
 * @param {string} sPath the relative binding path
 * @return {Array} the array of distinct values.
 */
UCF_ListBinding["prototype"]["getDistinctValues"] = function(sPath) {;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["getDistinctValues"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["getDistinctValues"] = 0; };

//Eventing and related
/**
 * Attach event-handler <code>fnFunction</code> to the '_sort' event of this
 * <code>UCF_ListBinding</code>.<br/>
 * @protected
 * @param {Object} [oListener] object on which to call the given function.
 * @param {function} fnFunction The function to call, when the event occurs.
 */
UCF_ListBinding["prototype"]["attachSort"] = function(oListener, fnFunction) {;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["attachSort"]++; }; 
	this["attachEvent"](this["E_EVENTS"]["Sort"], oListener, fnFunction);
};;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["attachSort"] = 0; };

/**
 * Detach event-handler <code>fnFunction</code> from the '_sort' event of this
 * <code>UCF_ListBinding</code>.<br/>
 * @protected
 * @param {Object} [oListener] object on which to call the given function.
 * @param {function} fnFunction The function to call, when the event occurs.
 */
UCF_ListBinding["prototype"]["detachSort"] = function(oListener, fnFunction) {;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["detachSort"]++; }; 
	this["detachEvent"](this["E_EVENTS"]["Sort"], oListener, fnFunction);
};;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["detachSort"] = 0; };

/**
 * Fire event 'sort' to attached listeners.
 * @param {Object} [mArguments] the arguments to pass along with the event.
 * @private
 */
UCF_ListBinding["prototype"]["_fireSort"] = function(mArguments) {;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["_fireSort"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Sort"], mArguments);
};;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["_fireSort"] = 0; };

/**
 * Attach event-handler <code>fnFunction</code> to the '_filter' event of this
 * <code>UCF_ListBinding</code>.<br/>
 * @protected
 * @param {Object} [oListener] object on which to call the given function.
 * @param {function} fnFunction The function to call, when the event occurs.
 */
UCF_ListBinding["prototype"]["attachFilter"] = function(oListener, fnFunction) {;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["attachFilter"]++; }; 
	this["attachEvent"](this["E_EVENTS"]["Filter"], oListener, fnFunction);
};;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["attachFilter"] = 0; };

/**
 * Detach event-handler <code>fnFunction</code> from the '_filter' event of
 * this <code>UCF_ListBinding</code>.<br/>
 * @protected
 * @param {Object} [oListener] object on which to call the given function.
 * @param {function} fnFunction The function to call, when the event occurs.
 */
UCF_ListBinding["prototype"]["detachFilter"] = function(oListener, fnFunction) {;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["detachFilter"]++; }; 
	this["detachEvent"](this["E_EVENTS"]["Filter"], oListener, fnFunction);
};;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["detachFilter"] = 0; };

/**
 * Fire event _filter to attached listeners.
 * @private
 * @param {Object} [mArguments] the arguments to pass along with the event.
 */
UCF_ListBinding["prototype"]["_fireFilter"] = function(mArguments) {;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["_fireFilter"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Filter"], mArguments);
};;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["_fireFilter"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ListBinding["prototype"]["aAttributeNames"] = [];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ListBinding["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ListBinding["prototype"]["aMethodNames"] = [];


//#JSCOVER_EXCL_START
/** @protected */
UCF_ListBinding["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["setDefaultValues"]++; }; 
	

	if (this["getClientControl"]() && !this["bKeepAlive"]) ;
};;if (__UCF_COVERAGE__) { UCF_ListBinding["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_ListBinding.prototype["aPublicMethods"] = ["UCF_ListBinding","getDistinctValues"].concat(UCF_ListBinding.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Listbox"] = function() {/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Listbox_Items */
/// <reference path="./Listbox_Items.js"/>
/* global UCF_ItemListBox */
/// <reference path="./base/ItemListBox.js"/>
/* global UCF_Listbox_ActiveInteractionDelegate */
/// <reference path="./delegates/Listbox_ActiveInteractionDelegate.js"/>
/* global UCF_Listbox_Drag */
/// <reference path="./delegates/Listbox_Drag.js"/>
/* global UCF_Listbox_Drop */
/// <reference path="./delegates/Listbox_Drop.js"/>
/* global UCF_Listbox_FocusInteractionDelegate */
/// <reference path="./delegates/Listbox_FocusInteractionDelegate.js"/>
/* global UCF_Listbox_HoverInteractionDelegate */
/// <reference path="./delegates/Listbox_HoverInteractionDelegate.js"/>
/* global UCF_Listbox_TruncationDelegate */
/// <reference path="./delegates/Listbox_TruncationDelegate.js"/>

/**
 * @class UCF_Listbox
 * @extends UCF_ItemListBox
 * @param {HTMLDivElement} oDomRef the dom element
 * @param {UCF_LS} oLS the lightspeed instance
 */
function UCF_Listbox(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Listbox["_"]["UCF_Listbox"]++; }; 
	if (arguments["length"] > 0) {
		UCF_ItemListBox["apply"](this, arguments);

		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

		if (!this["bReadonly"]) {
			this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_ActiveInteractionDelegate"))(this));
		}
		this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_FocusInteractionDelegate"))(this));
		this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_HoverInteractionDelegate"))(this));

		this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_TruncationDelegate"))(this));

		/** @type {UCF_Listbox_Interaction|UCF_Listbox_MultiInteraction} */
		this["oInteraction"] = null;

		/** @type {string} */
		this["sScrollDelayedCallId"] = null;

		/** @type {string} */
		this["sTooltip"] = this["oRootRef"]["title"] || '';

		UCF_DomUtil["setStyle"](this["oRootRef"], { "zIndex": '' });
	}
};window["UCF_Listbox"] = UCF_Listbox; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox"); UCF_Listbox["_"] = {UCF_Listbox: 0}; }; ;
UCF_Listbox["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemListBox"))(); UCF_Listbox.prototype["sClassName"] = "UCF_Listbox";

/** @type {number} ms from the last scroll event to fire the Listbox:Scroll */
UCF_Listbox["SCROLL_FRAME"] = 200;

/**
 * @protected
 * @return {UCF_Listbox_Items}
 */
UCF_Listbox["prototype"]["oGetItemsManager"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["oGetItemsManager"]++; }; 
	/** @type {UCF_Listbox} */
	var self = this;

	return this["oCache"] && this["oCache"]["get"]('oItemsManager', function() {
		var oIM = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_Items"))(self);

		oIM["attachEvent"](UCF_Listbox_Items["EVENT"]["StateChange"], self, 'onStateChange');

		return oIM;
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["oGetItemsManager"] = 0; };
// #region lifecycle ==========================================================
// #region initialize ---------------------------------------------------------
/** @override */
UCF_Listbox["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["initialize"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow = this["oLS"]["oBrowserWindow"];

	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["LayoutChange"], this, 'onLayoutChange');

	this["onLayoutChange"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["initialize"] = 0; };
// #endregion
// #region onLayoutChange -----------------------------------------------------
UCF_Listbox["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["onLayoutChange"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM;

	if (
		!oEvent ||
		!oEvent["oGetParam"]('sSourceControlId') ||
		oEvent["oGetParam"]('sSourceControlId') !== this["sId"]
	) {
		oIM = this["oGetItemsManager"]();

		oIM["applyItemsRefWidthToScrollRef"]();
		oIM["applyGroupTitlesMinWidthToScrollRef"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["onLayoutChange"] = 0; };
// #endregion
// #region destroy ------------------------------------------------------------
/** @override */
UCF_Listbox["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["destroy"]++; }; 
	var oBrowserWindow = this["oLS"] && this["oLS"]["oBrowserWindow"];

	if (oBrowserWindow) {
		oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["LayoutChange"], this);
	}

	if (this["oCache"]) {
		if (this["oCache"]["has"]('oItemsManager')) {
			this["oGetItemsManager"]()["destroy"]();
		}
		this["oCache"]["destroy"]();
		this["oCache"] = null;
	}

	if (this["oInteraction"]) {
		this["oInteraction"]["destroy"]();
		this["oInteraction"] = null;
	}

	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}

	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}

	if (this["sScrollDelayedCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sScrollDelayedCallId"]);
		this["sScrollDelayedCallId"] = null;
	}

	this["bEnabled"] = null;
	this["sTooltip"] = null;

	UCF_ItemListBox.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["destroy"] = 0; };
// #endregion
// #endregion
// #region semantic events ====================================================
// #region Listbox:Scroll -----------------------------------------------------
/**
 * @private
 * @param {UCF_BrowserEvent} oScroll the scroll
 */
UCF_Listbox["prototype"]["onscroll"] = function(oScroll) {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["onscroll"]++; }; 
	if (this["sScrollDelayedCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sScrollDelayedCallId"]);
	}
	this["sScrollDelayedCallId"] = UCF_JsUtil["delayedCall"](
		UCF_Listbox["SCROLL_FRAME"],
		this,
		'fireScrollSync'
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["onscroll"] = 0; };

/** @private */
UCF_Listbox["prototype"]["fireScrollSync"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["fireScrollSync"]++; }; 
	this["fireScroll"](this["sId"], this["oDomRef"]["scrollTop"]);
	delete this["sScrollDelayedCallId"];
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["fireScrollSync"] = 0; };
// #endregion
// #region Listbox:DoubleClick ------------------------------------------------
/**
 * @private
 * @param {UCF_BrowserEvent} oDblclick the dblclick
 */
UCF_Listbox["prototype"]["ondblclick"] = function(oDblclick) {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["ondblclick"]++; }; 
	this["fireDoubleClick"](this["sId"], this["getValues"]());
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["ondblclick"] = 0; };
// #endregion
// #region Listbox:Select -----------------------------------------------------
/**
 * @private
 * @param {UCF_Event} oStateChange the StateChange
 */
UCF_Listbox["prototype"]["onStateChange"] = function(oStateChange) {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["onStateChange"]++; }; 
	switch (oStateChange["oGetParam"]('iState')) {
		case UCF_Listbox_Items["STATE"]["Selected"]:
			this["fireSelect"](
				this["sId"],
				this["getValues"]()
			);
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["onStateChange"] = 0; };
// #endregion
// #endregion
// #region drag/drop ==========================================================
/** @override */
UCF_Listbox["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["createDragDelegate"]++; }; 
	if (this["sDragSourceInfo"] && !this["oDragDelegate"]) {
		this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_Drag"))(this);
		this["addDelegate"](this["oDragDelegate"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["createDragDelegate"] = 0; };

/** @override */
UCF_Listbox["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["createDropDelegate"]++; }; 
	if (this["sDropTargetInfo"] && !this["oDropDelegate"]) {
		this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_Drop"))(this);
		this["addDelegate"](this["oDropDelegate"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["createDropDelegate"] = 0; };
// #endregion
// #region api ================================================================
// #region setEnabled ---------------------------------------------------------
/**
 * @public
 * @param {boolean} bEnabled `true` to enable the Listbox, otherwise `false`
 */
UCF_Listbox["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["setEnabled"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	this["bEnabled"] = bEnabled;
	this["setClientProperty"]("Enabled", bEnabled); // eslint-disable-line quotes

	oIM["clearState"](UCF_Listbox_Items["STATE"]["Disabled"]);
	UCF_JsUtil["forEach"](
		UCF_JsUtil["values"](oIM["oGetItems"]()),
		function(oItem) {
			if (!bEnabled || !oIM["bIsItemEnabled"](oItem)) {
				oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Disabled"]);
			}
		}
	);

	this["rerenderEnabled"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["setEnabled"] = 0; };

/** @private */
UCF_Listbox["prototype"]["rerenderEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["rerenderEnabled"]++; }; 
	if (this["bEnabled"]) {
		UCF_DomUtil["removeClass"](this["oRootRef"], 'lsListbox--disabled');
	} else {
		UCF_DomUtil["addClass"](this["oRootRef"], 'lsListbox--disabled');
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["rerenderEnabled"] = 0; };
// #endregion
// #region selectItemById -----------------------------------------------------
/**
 * @public
 * @param {string} sItemId the id of the item to select
 */
UCF_Listbox["prototype"]["selectItemById"] = function(sItemId) {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["selectItemById"]++; }; 
	this["oInteraction"]["selectItemById"](sItemId);
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["selectItemById"] = 0; };
// #endregion
// #region deselectItemById ---------------------------------------------------
/**
 * @public
 * @param {string} sItemId the id of the item to deselect
 */
UCF_Listbox["prototype"]["deselectItemById"] = function(sItemId) {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["deselectItemById"]++; }; 
	this["oInteraction"]["deselectItemById"](sItemId);
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["deselectItemById"] = 0; };
// #endregion
// #region setTooltip ---------------------------------------------------------
/**
 * @public
 * @param {string} sTooltip the tooltip
 */
UCF_Listbox["prototype"]["setTooltip"] = function(sTooltip) {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["setTooltip"]++; }; 
	this["oRootRef"]["title"] = sTooltip;
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["setTooltip"] = 0; };
// #endregion
// #region setValue -----------------------------------------------------------
/**
 * @public
 * @param {string} sKey the key of the item to select
 */
UCF_Listbox["prototype"]["setValue"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["setValue"]++; }; 
	this["oInteraction"]["selectItemsByKeys"]([sKey]);
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["setValue"] = 0; };
// #endregion
// #region setValues ----------------------------------------------------------

/**
 * @public
 * @param {Array.<string>} aKeys list of keys of items to select
 */
UCF_Listbox["prototype"]["setValues"] = function(aKeys) {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["setValues"]++; }; 
	this["oInteraction"]["selectItemsByKeys"](aKeys);
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["setValues"] = 0; };
// #endregion
// #region getText ------------------------------------------------------------
/**
 * @public
 * @return {string}
 */
UCF_Listbox["prototype"]["getText"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["getText"]++; }; 
	var aTexts = this["getTexts"]();

	return aTexts && aTexts["length"] > 0 && aTexts[0];
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["getText"] = 0; };
// #endregion
// #region getTexts -----------------------------------------------------------
/**
 * @public
 * @return {string[]}
 */
UCF_Listbox["prototype"]["getTexts"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["getTexts"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	return UCF_JsUtil["map"](
		oIM["aFindItemsByState"](UCF_Listbox_Items["STATE"]["Selected"]),
		function(oItem) { return oIM["sGetItemValue"](oItem); }
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["getTexts"] = 0; };
// #endregion
// #region getValue -----------------------------------------------------------
/**
 * @public
 * @return {string}
 */
UCF_Listbox["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["getValue"]++; }; 
	/** @type {string[]} */
	var aValues = this["getValues"]();

	return aValues && aValues["length"] > 0 && aValues[0];
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["getValue"] = 0; };
// #endregion
// #region getValues ----------------------------------------------------------
/**
 * @public
 * @return {string[]}
 */
UCF_Listbox["prototype"]["getValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["getValues"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	return UCF_JsUtil["map"](
		oIM["aFindItemsByState"](UCF_Listbox_Items["STATE"]["Selected"]),
		function(oItem) { return oIM["sGetItemKey"](oItem); }
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["getValues"] = 0; };
// #endregion
// #region scrollToItemByIndex ------------------------------------------------
/**
 * @public
 * @param {string} sItemIndex the index of the item to scroll to
 */
UCF_Listbox["prototype"]["scrollToItemByIndex"] = function(sItemIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["scrollToItemByIndex"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	oIM["scrollIntoView"](oIM["oFindItemByIndex"](sItemIndex));
};;if (__UCF_COVERAGE__) { UCF_Listbox["_"]["scrollToItemByIndex"] = 0; };
// #endregion
// #region createDataTip ------------------------------------------------------
// implemented in Control.js
// #endregion
// #endregion

UCF_Listbox.prototype["aPublicMethods"] = ["setEnabled","selectItemById","deselectItemById","setTooltip","setValue","setValues","getText","getTexts","getValue","getValues","scrollToItemByIndex"].concat(UCF_Listbox.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Listbox_ActionItem"] = function() {/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_ItemListBoxActionItem */
/// <reference path="./ItemListBoxActionItem.js"/>

/**
 * @class UCF_Listbox_ActionItem
 * @extends UCF_Control
 * @param {HTMLDivElement} oDomRef the dom element
 * @param {UCF_LS} oLS the lightspeed instance
 */
function UCF_Listbox_ActionItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Listbox_ActionItem["_"]["UCF_Listbox_ActionItem"]++; }; 
	if (arguments["length"] > 0) {
		UCF_ItemListBoxActionItem["apply"](this, arguments);

		this["bSelected"] = false;
	}
};window["UCF_Listbox_ActionItem"] = UCF_Listbox_ActionItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_ActionItem"); UCF_Listbox_ActionItem["_"] = {UCF_Listbox_ActionItem: 0}; }; ;
UCF_Listbox_ActionItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemListBoxActionItem"))(); UCF_Listbox_ActionItem.prototype["sClassName"] = "UCF_Listbox_ActionItem";

/**
 * @protected
 * @param {number} iSetsize The number of items in the set
 */
UCF_Listbox_ActionItem["prototype"]["setAriaSetsize"] = function(iSetsize) {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItem["_"]["setAriaSetsize"]++; }; 
	UCF_AriaStateHelper["setSetsize"](this["oDomRef"], iSetsize);
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItem["_"]["setAriaSetsize"] = 0; };

/**
 * @protected
 * @param {number} iPosinset The index of item in the set
 */
UCF_Listbox_ActionItem["prototype"]["setAriaPosinset"] = function(iPosinset) {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItem["_"]["setAriaPosinset"]++; }; 
	UCF_AriaStateHelper["setPosinset"](this["oDomRef"], iPosinset);
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItem["_"]["setAriaPosinset"] = 0; };

/** @protected */
UCF_Listbox_ActionItem["prototype"]["select"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItem["_"]["select"]++; }; 
	this["bSelected"] = true;
	this["rerenderSelected"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItem["_"]["select"] = 0; };

/** @protected */
UCF_Listbox_ActionItem["prototype"]["deselect"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItem["_"]["deselect"]++; }; 
	this["bSelected"] = false;
	this["rerenderSelected"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItem["_"]["deselect"] = 0; };

/** @private */
UCF_Listbox_ActionItem["prototype"]["rerenderSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItem["_"]["rerenderSelected"]++; }; 
	if (this["bSelected"]) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsListbox__actionitem--selected');
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsListbox__actionitem--focus');
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsListbox__actionitem--selected');
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsListbox__actionitem--focus');
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItem["_"]["rerenderSelected"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_ActionItems"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>

/**
 * @class UCF_Listbox_ActionItems
 * @extends UCF_Object
 * @param {UCF_Listbox_Popup} oControl the listbox the action items are managed
 * for
 */
function UCF_Listbox_ActionItems(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["UCF_Listbox_ActionItems"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, arguments);

		/** @type {UCF_Listbox_Popup} */
		this["oControl"] = oControl;
		/** @type {UCF_LS} */
		this["oLS"] = oControl["oLS"];
		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
		/** @type {UCF_Listbox_ActionItem} */
		this["oSelectedItem"] = null;
	}
};window["UCF_Listbox_ActionItems"] = UCF_Listbox_ActionItems; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_ActionItems"); UCF_Listbox_ActionItems["_"] = {UCF_Listbox_ActionItems: 0}; }; ;
UCF_Listbox_ActionItems["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Listbox_ActionItems.prototype["sClassName"] = "UCF_Listbox_ActionItems";

/** @override */
UCF_Listbox_ActionItems["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["destroy"]++; }; 
	this["oCache"]["destroy"]();
	this["oCache"] = null;

	this["oControl"] = null;
	this["oLS"] = null;
	this["oSelectedItem"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["destroy"] = 0; };

/**
 * @private
 * @return {Array.<UCF_Listbox_ActionItem>}
 */
UCF_Listbox_ActionItems["prototype"]["aGetItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["aGetItems"]++; }; 
	/** @type {UCF_Listbox_ActionItems} */
	var self = this;

	return this["oCache"]["get"]('aItems', function() {
		return UCF_JsUtil["map"](
			UCF_JsUtil["arrayFrom"](
				UCF_DomUtil["querySelectorAll"](
					'[id="' + self["oControl"]["sId"] + '"] [ct="LIB_AI"]'
				)
			),
			function(oDomRef) { return self["oLS"]["oGetControlByDomRef"](oDomRef); }
		);
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["aGetItems"] = 0; };

/**
 * @protected
 * @return {number}
 */
UCF_Listbox_ActionItems["prototype"]["iGetItemCount"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["iGetItemCount"]++; }; 
	/** @type {Array.<UCF_Listbox_ActionItem>} */
	var aItems = this["aGetItems"]();

	return aItems && aItems["length"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["iGetItemCount"] = 0; };

/**
 * @protected
 * @return {UCF_Listbox_ActionItem}
 */
UCF_Listbox_ActionItems["prototype"]["oGetSelectedItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["oGetSelectedItem"]++; }; 
	return this["oSelectedItem"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["oGetSelectedItem"] = 0; };

/**
 * @protected
 * @param {UCF_Listbox_ActionItem} oItem the action item
 * @return {number}
 */
UCF_Listbox_ActionItems["prototype"]["iGetItemIndex"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["iGetItemIndex"]++; }; 
	// This seems to be a slow (i.e. O(n)) implementation, but the Listbox has a
	// decent problem with many ActionItems anyways (they can't scroll), so n is
	// expected to be small (< 10) in 99% of the cases.
	return UCF_JsUtil["indexOf"](this["aGetItems"](), oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["iGetItemIndex"] = 0; };

/**
 * @protected
 * @param {number} iIndex the index to find
 * @return {UCF_Listbox_ActionItem}
 */
UCF_Listbox_ActionItems["prototype"]["oFindItemByIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["oFindItemByIndex"]++; }; 
	/** @type {Array.<UCF_Listbox_ActionItem>} */
	var aItems = this["aGetItems"]();

	return aItems && iIndex > -1 && iIndex < aItems["length"] && aItems[iIndex];
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["oFindItemByIndex"] = 0; };

/**
 * @protected
 * @param {UCF_Listbox_ActionItem} oItem the action item
 */
UCF_Listbox_ActionItems["prototype"]["selectItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["selectItem"]++; }; 
	UCF_JsUtil["forEach"](this["aGetItems"](), function(o) { o["deselect"](); });
	if (oItem) {
		oItem["select"]();
	}

	if (this["oSelectedItem"] !== oItem) {
		this["oSelectedItem"] = oItem;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["selectItem"] = 0; };

/**
 * @param {string} sId the id of the item
 * @param {string} sText the text of the item
 * @param {string} sTooltip the tooltip of the item
 * @param {string} sDesign the design of the item
 */
UCF_Listbox_ActionItems["prototype"]["addItem"] = function(sId, sText, sTooltip, sDesign) {;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["addItem"]++; }; 
	/** @type {HTMLDivElement} */
	var oTempActionItemRef;
	/** @type {HTMLActionItem} */
	var oActionItemRef;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId !== '', "sId !== ''", "Listbox_ActionItems.js(136): addItem"); };

	oTempActionItemRef = document["createElement"]('div');

	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oTempActionItemRef, this["oLS"]["oGetRenderManager"]()["callFragment"](
		'ListboxActionItemFragment',
		'ItemListBox', {
			"Item": {
				"Id": sId,
				"Text": sText,
				"Tooltip": sTooltip,
				"Design": 'STANDARD',
				"CustomData": ''
			}
		}
	));
	oActionItemRef = oTempActionItemRef["firstChild"];
	// UCF_DomUtil.addClass(oActionItemRef, 'sapContrast');

	UCF_DomUtil["$"](this["oControl"]["sId"])["appendChild"](oActionItemRef);

	this["oCache"]["invalidate"]('aItems');
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActionItems["_"]["addItem"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_ActiveInteractionDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Listbox_InteractionDelegate */
/// <reference path="../delegates/Listbox_InteractionDelegate.js"/>
/* global UCF_Listbox_Items */
/// <reference path="../Listbox_Items.js"/>

/**
 * @class UCF_Listbox_ActiveInteractionDelegate
 * @extends UCF_Listbox_InteractionDelegate
 * @param {UCF_Listbox|UCF_Listbox_Popup} oControl the listbox
 */
function UCF_Listbox_ActiveInteractionDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_ActiveInteractionDelegate["_"]["UCF_Listbox_ActiveInteractionDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox_InteractionDelegate["apply"](this, arguments);
	}
};window["UCF_Listbox_ActiveInteractionDelegate"] = UCF_Listbox_ActiveInteractionDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_ActiveInteractionDelegate"); UCF_Listbox_ActiveInteractionDelegate["_"] = {UCF_Listbox_ActiveInteractionDelegate: 0}; }; ;
UCF_Listbox_ActiveInteractionDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_InteractionDelegate"))(); UCF_Listbox_ActiveInteractionDelegate.prototype["sClassName"] = "UCF_Listbox_ActiveInteractionDelegate";

/**
 * @private
 * @param {UCF_BrowserEvent} oMouseout the mouseout
 */
UCF_Listbox_ActiveInteractionDelegate["prototype"]["onmouseout"] = function(oMouseout) {;if (__UCF_COVERAGE__) { UCF_Listbox_ActiveInteractionDelegate["_"]["onmouseout"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oSourceItem = oIM["oFindItemByDomRef"](oMouseout["oGetSource"]());
	/** @type {HTMLElement} */
	var oRelatedTarget;
	/** @type {_MaybeItem} */
	var oRelatedItem;
	/** @type {boolean} */
	var bIsMouseoutFromItem = true;

	if (oSourceItem) {
		oRelatedTarget = UCF_DomUtil["oGetRelatedTarget"](oMouseout["oDomEvent"]);

		if (oRelatedTarget) {
			oRelatedItem = oIM["oFindItemByDomRef"](oRelatedTarget);

			if (oRelatedItem && oIM["bEqual"](oSourceItem, oRelatedItem)) {
				bIsMouseoutFromItem = false;
			}
		}
	}

	if (bIsMouseoutFromItem) {
		oIM["clearState"](UCF_Listbox_Items["STATE"]["Active"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActiveInteractionDelegate["_"]["onmouseout"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oMousedown the mousedown
 */
UCF_Listbox_ActiveInteractionDelegate["prototype"]["onmousedown"] = function(oMousedown) {;if (__UCF_COVERAGE__) { UCF_Listbox_ActiveInteractionDelegate["_"]["onmousedown"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemByDomRef"](oMousedown["oGetSource"]());

	if (oIM["bIsWriteable"](oItem)) {
		oIM["clearState"](UCF_Listbox_Items["STATE"]["Active"]);

		if (!this["bOnDeleteButton"](oMousedown)) {
			oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Active"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActiveInteractionDelegate["_"]["onmousedown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oEvent the Event
 * @return {boolean}
 */
UCF_Listbox_ActiveInteractionDelegate["prototype"]["bOnDeleteButton"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_ActiveInteractionDelegate["_"]["bOnDeleteButton"]++; }; 
	/** @type {HTMLDivElement} */
	var oS = oEvent["oGetSource"]();

	return oS
		&& UCF_DomUtil["bHasClass"](oS, 'lsListbox__value--deletable')
		&& oS["parentElement"]
		&& UCF_DomUtil["bHasClass"](oS["parentElement"], 'lsListbox__values--delete');
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActiveInteractionDelegate["_"]["bOnDeleteButton"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oMouseup the mouseup
 */
UCF_Listbox_ActiveInteractionDelegate["prototype"]["onmouseup"] = function(oMouseup) {;if (__UCF_COVERAGE__) { UCF_Listbox_ActiveInteractionDelegate["_"]["onmouseup"]++; }; 
	this["oControl"]["oGetItemsManager"]()["clearState"](UCF_Listbox_Items["STATE"]["Active"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_ActiveInteractionDelegate["_"]["onmouseup"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_Drag"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>
/* global UCF_Listbox_Items */
/// <reference path="../Listbox_Items.js"/>

/**
 * @class UCF_Listbox_Drag
 * @extends UCF_DragDelegate
 * @param {UCF_Listbox} oControl the control
 */
function UCF_Listbox_Drag(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_Drag["_"]["UCF_Listbox_Drag"]++; }; 
	if (arguments["length"] > 0) {
		UCF_DragDelegate["apply"](this, [oControl["oLS"]]);
		this["setDragSourceControl"](oControl);
	}
};window["UCF_Listbox_Drag"] = UCF_Listbox_Drag; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_Drag"); UCF_Listbox_Drag["_"] = {UCF_Listbox_Drag: 0}; }; ;
UCF_Listbox_Drag["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_Listbox_Drag.prototype["sClassName"] = "UCF_Listbox_Drag";

/** @override */
UCF_Listbox_Drag["prototype"]["oGetGhost"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Drag["_"]["oGetGhost"]++; }; 
	/** @type {HTMLDivElement} */
	var oItemsRef = this["oDragSourceControl"]["oGetItemsManager"]()["oGetItemsRef"]();
	/** @type {HTMLDivElement} */
	var oFragment = oItemsRef["cloneNode"](true);
	/** @type {UCF_HTMLGhost} */
	var oGhost;

	UCF_JsUtil["forEach"](
		UCF_JsUtil["arrayFrom"](oFragment["childNodes"]), // values column
		function(oValuesRef) {
			UCF_JsUtil["forEach"](
				UCF_JsUtil["arrayFrom"](oValuesRef["childNodes"]), // single value
				function(oValueRef) {
					if (UCF_DomUtil["bHasClass"](
							oValueRef,
							UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["Selected"]]
						)) {
						UCF_JsUtil["forEach"](
							[
								UCF_Listbox_Items["STATE"]["Hover"],
								UCF_Listbox_Items["STATE"]["Focus"],
								UCF_Listbox_Items["STATE"]["Selected"],
								UCF_Listbox_Items["STATE"]["Active"]
							],
							function(iState) {
								UCF_DomUtil["removeClass"](
									oValueRef,
									UCF_Listbox_Items["STATE_CLASS"][iState]
								);
							}
						);
					} else {
						UCF_DomUtil["removeFromDom"](oValueRef);
					}
				}
			);
		}
	);

	UCF_DomUtil["setStyle"](
		oFragment, {
			"width": oItemsRef["offsetWidth"] + 'px',
			"backgroundColor": UCF_DomUtil["sGetPerceivedBackgroundColor"](
				UCF_DomUtil["oGetParentElement"](oItemsRef)
			),
			"height": '',
			"position": 'relative'
		}
	);

	oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oFragment);
	oGhost["setOffset"](12, 12); // eslint-disable-line no-magic-numbers

	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Drag["_"]["oGetGhost"] = 0; };

/** @override */
UCF_Listbox_Drag["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_Drag["_"]["bIsDragPossible"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oDragSourceControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemByDomRef"](oBrowserEvent["oGetSource"]());
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();

	// return true if either source is selected or touch handle
	return oItem &&
		!oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Disabled"]) &&
		oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]) &&
		(!oBrowserEvent["bIsTouchInteraction"]() ||
			(oBrowserEvent["bIsTouchInteraction"]() &&
				oSource &&
				UCF_DomUtil["bHasClass"](oSource, 'lsListbox__value') &&
				UCF_DomUtil["bHasClass"](
					oSource["parentElement"],
					'lsListbox__values--draghandle')
			)
		);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Drag["_"]["bIsDragPossible"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_Drop"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_Listbox_DropDecorator */
/// <reference path="../decorators/Listbox_DropDecorator.js"/>

/**
 * @class UCF_Listbox_Drop
 * @extends UCF_DropDelegate
 * @param {UCF_Listbox} oControl the listbox
 */
function UCF_Listbox_Drop(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_Drop["_"]["UCF_Listbox_Drop"]++; }; 
	if (arguments["length"] > 0) {
		UCF_DropDelegate["apply"](this, [oControl["oLS"]]);

		this["setDropTargetControl"](oControl);

		/** @type {number} */
		this["iScrollStep"] = 0;
	}
};window["UCF_Listbox_Drop"] = UCF_Listbox_Drop; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_Drop"); UCF_Listbox_Drop["_"] = {UCF_Listbox_Drop: 0}; }; ;
UCF_Listbox_Drop["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_Listbox_Drop.prototype["sClassName"] = "UCF_Listbox_Drop";

/** @const {number} */
UCF_Listbox_Drop["MIN_ZONE_HEIGHT"] = 35;
/** @const {number} */
UCF_Listbox_Drop["ZONE_HEIGHT_FACTOR"] = .25;

/** @override */
UCF_Listbox_Drop["prototype"]["onlsdragscroll"] = function(oLsDragScroll) {;if (__UCF_COVERAGE__) { UCF_Listbox_Drop["_"]["onlsdragscroll"]++; }; 
	/** @type {number} */
	var iOffsetY = oLsDragScroll["iPageY"]();
	/** @type {HTMLDivElement} */
	var oItemsRef = this["oDropTargetControl"]["oGetItemsManager"]()["oGetItemsRef"]();
	/** @type {UCF_Rectangle} */
	var oItemsRefObjectRect = UCF_DomUtil["oGetObjectRect"](oItemsRef);
	/** @type {number} */
	var iClientHeight = oItemsRef["clientHeight"];
	/** @type {number} */
	var iZoneHeight = Math["min"](
		UCF_Listbox_Drop["MIN_ZONE_HEIGHT"],
		UCF_Listbox_Drop["ZONE_HEIGHT_FACTOR"] * iClientHeight
	);
	/** @type {number} */
	var iThresholdTop = oItemsRefObjectRect["top"] + iZoneHeight;
	/** @type {number} */
	var iThresholdBottom = oItemsRefObjectRect["top"] + iClientHeight - iZoneHeight;
	/** @type {number} */
	var iScrollStep = 0;

	if (iOffsetY < iThresholdTop) {
		// eslint-disable-next-line no-magic-numbers
		iScrollStep = -Math["round"]((iThresholdTop - iOffsetY) / iThresholdTop * 10);
	} else if (iOffsetY > iThresholdBottom) {
		// eslint-disable-next-line no-magic-numbers
		iScrollStep = Math["round"]((iOffsetY - iThresholdBottom) / iZoneHeight * 10);
	}

	if (this["iScrollStep"] < iScrollStep) {
		this["iScrollStep"]++;
	} else if (this["iScrollStep"] > iScrollStep) {
		this["iScrollStep"]--;
	}

	oItemsRef["scrollTop"] += this["iScrollStep"];
	this["oDropDecorator"]["update"](oLsDragScroll);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Drop["_"]["onlsdragscroll"] = 0; };

/** @override */
UCF_Listbox_Drop["prototype"]["oCreateDropDecorator"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Drop["_"]["oCreateDropDecorator"]++; }; 
	return new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_DropDecorator"))(this["oDropTargetControl"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Drop["_"]["oCreateDropDecorator"] = 0; };

/** @override */
UCF_Listbox_Drop["prototype"]["oGetDropLocation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_Drop["_"]["oGetDropLocation"]++; }; 
	return this["oDropDecorator"]["oGetDropLocation"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Drop["_"]["oGetDropLocation"] = 0; };

/** @override */
UCF_Listbox_Drop["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_Listbox_Drop["_"]["fGetDropCallBack"]++; }; 
	/** @type {UCF_Listbox_Drop} */
	var self = this;

	return function(sDragData, sMimeType) {
		/** @type {UCF_Control} */
		var oControl = self["oDropTargetControl"];
		/** @type {{sKey: string, iOffset: number}} */
		var oLocation = self["oGetDropLocation"]();
		/** @type {{left: number, top: number}} */
		var oDropPosition = oDragSession["oGetDropPosition"]();

		self["oDropTargetControl"]["fireDrop"](
			oControl["sId"],
			oDragSession["sGetDragSourceId"](),
			oControl["sDropTargetInfo"],
			oLocation["sKey"],
			oLocation["iOffset"],
			sDragData,
			sMimeType,
			oDragSession["sGetDragTags"](),
			oDragSession["iGetMouseButtonState"](),
			oDropPosition["left"],
			oDropPosition["top"],
			oDragSession["eGetDropEffect"]()
		);
	};
};;if (__UCF_COVERAGE__) { UCF_Listbox_Drop["_"]["fGetDropCallBack"] = 0; };

/** @override */
UCF_Listbox_Drop["prototype"]["oGetDomRefToBeFocussed"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_Drop["_"]["oGetDomRefToBeFocussed"]++; }; 
	return this["oDropDecorator"]["oDomRefToBeFocussed"] || UCF_DropDelegate.prototype["oGetDomRefToBeFocussed"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Drop["_"]["oGetDomRefToBeFocussed"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_DropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Listbox_Items */
/// <reference path="../Listbox_Items.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * @class UCF_Listbox_DropDecorator
 * @extends UCF_LineDecorator
 * @param {UCF_Listbox} oControl the control
 */
function UCF_Listbox_DropDecorator(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_DropDecorator["_"]["UCF_Listbox_DropDecorator"]++; }; 
	if (arguments["length"] > 0) {
		UCF_LineDecorator["apply"](this, [oControl, true]);

		/** @type {UCF_LS} */
		this["oLS"] = oControl["oLS"];
	}
};window["UCF_Listbox_DropDecorator"] = UCF_Listbox_DropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_DropDecorator"); UCF_Listbox_DropDecorator["_"] = {UCF_Listbox_DropDecorator: 0}; }; ;
UCF_Listbox_DropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(); UCF_Listbox_DropDecorator.prototype["sClassName"] = "UCF_Listbox_DropDecorator";

/**
 * @private
 * @return {number}
 */
UCF_Listbox_DropDecorator["prototype"]["iGetVerticalBorderWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_DropDecorator["_"]["iGetVerticalBorderWidth"]++; }; 
	/** @type {CSSStyleDeclaration} */
	var oComputedStyle;
	/** @type {_MaybeItem} */
	var oItem;

	if (typeof UCF_Listbox_DropDecorator["iVerticalBorderWidth"] !== 'number') {
		oItem = this["oControl"]["oGetItemsManager"]()["oFindItemByIndex"](0);

		if (oItem) {
			oComputedStyle = UCF_DomUtil["oGetComputedStyle"](
				UCF_Listbox_Items["aGetItemValueRefs"](oItem)[0]
			);

			UCF_Listbox_DropDecorator["iVerticalBorderWidth"] =
				parseInt(oComputedStyle["borderTopWidth"]) +
				parseInt(oComputedStyle["borderBottomWidth"]);
		} else {
			// did not find any item => fall back to 1+1px, look again next time
			return 1 + 1;
		}

	}

	return UCF_Listbox_DropDecorator["iVerticalBorderWidth"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_DropDecorator["_"]["iGetVerticalBorderWidth"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Listbox_DropDecorator["prototype"]["iGetScrollbarOffset"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_DropDecorator["_"]["iGetScrollbarOffset"]++; }; 
	if (!this["iScrollbarOffset"]) {
		this["iScrollbarOffset"] = UCF_DomUtil["iGetVerticalScrollbarOffset"](
			this["oControl"]["oGetItemsManager"]()["oGetItemsRef"]()
		);
	}

	return this["iScrollbarOffset"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_DropDecorator["_"]["iGetScrollbarOffset"] = 0; };

/** @override */
UCF_Listbox_DropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_DropDecorator["_"]["update"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {HTMLDivElement} */
	var oItemsRef = oIM["oGetItemsRef"]();
	/** @type {UCF_Rectangle} */
	var oViewport = UCF_DomUtil["oGetObjectRect"](oItemsRef);
	/** @type {number} */
	var iItemHeight = UCF_Listbox_Items["iGetItemHeight"]();
	/** @type {number} */
	var iItemCount = oIM["iGetItemCount"]();
	/** @type {number} */
	var iIndex = -1;
	/** @type {_MaybeItem} */
	var oItem;
	/** @type {number} */
	var iBorderOffset = Math["ceil"](this["iGetVerticalBorderWidth"]() / 2);
	/** @type {number} */
	var iOffsetY = oBrowserEvent["iPageY"]() -
		oViewport["top"] -
		iBorderOffset +
		oItemsRef["scrollTop"];

	if (iItemCount > 0) {
		iIndex = Math["min"](
			Math["floor"]((iOffsetY + iItemHeight / 2) / iItemHeight),
			iItemCount
		);
	}

	this["oDomRefToBeFocussed"] = null;

	if (iIndex === -1) {
		this["sKey"] = '';
		this["iOffset"] = 0;
	} else if (iIndex < iItemCount) {
		oItem = oIM["oFindItemByIndex"](iIndex);
		this["sKey"] = oIM["sGetItemKey"](oItem);
		this["iOffset"] = -1;
	} else if (iIndex === iItemCount) {
		oItem = oIM["oFindItemByIndex"](iIndex - 1);
		this["sKey"] = oIM["sGetItemKey"](oItem);
		this["iOffset"] = 1;
	}

	if (oItem) {
		this["oDomRefToBeFocussed"] = 'oDomRef' in oItem ? oItem["oDomRef"] : oItem;
	}

	this["setBounds"](
		oViewport["left"] + (window["UCF_System"]["bIsRTL"] ? this["iGetScrollbarOffset"]() : 0),
		oViewport["top"] -
		oItemsRef["scrollTop"] +
		(iIndex > -1 ? (iIndex * iItemHeight - iBorderOffset) : 0),
		oItemsRef["clientWidth"]
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_DropDecorator["_"]["update"] = 0; };

/** @override */
UCF_Listbox_DropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_DropDecorator["_"]["oGetDropLocation"]++; }; 
	return { "sKey": this["sKey"], "iOffset": this["iOffset"] };
};;if (__UCF_COVERAGE__) { UCF_Listbox_DropDecorator["_"]["oGetDropLocation"] = 0; };

/**
 * destructor
 */
UCF_Listbox_DropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_DropDecorator["_"]["destroy"]++; }; 

	this["oLS"] = null;
	this["iScrollbarOffset"] = null;
	this["oDomRefToBeFocussed"] = null;
	this["sKey"] = null;
	this["iOffset"] = null;

	UCF_LineDecorator.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_DropDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_FocusInteractionDelegate"] = function() {/* global UCF_AriaStateHelper */
/// <reference path="../../../core/util/AriaStateHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Listbox_Items */
/// <reference path="../Listbox_Items.js"/>
/* global UCF_Listbox_InteractionDelegate */
/// <reference path="./Listbox_InteractionDelegate.js"/>

/**
 * @class UCF_Listbox_FocusInteractionDelegate
 * @extends UCF_Listbox_InteractionDelegate
 * @param {UCF_Listbox|UCF_Listbox_Popup} oControl the listbox
 */
function UCF_Listbox_FocusInteractionDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_FocusInteractionDelegate["_"]["UCF_Listbox_FocusInteractionDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox_InteractionDelegate["apply"](this, arguments);
	}
};window["UCF_Listbox_FocusInteractionDelegate"] = UCF_Listbox_FocusInteractionDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_FocusInteractionDelegate"); UCF_Listbox_FocusInteractionDelegate["_"] = {UCF_Listbox_FocusInteractionDelegate: 0}; }; 
UCF_Listbox_FocusInteractionDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_InteractionDelegate"))(); UCF_Listbox_FocusInteractionDelegate.prototype["sClassName"] = "UCF_Listbox_FocusInteractionDelegate";

/**
 * @private
 * @param {UCF_BrowserEvent} oLsFocus the lsfocus
 */
UCF_Listbox_FocusInteractionDelegate["prototype"]["onlsfocus"] = function(oLsFocus) {;if (__UCF_COVERAGE__) { UCF_Listbox_FocusInteractionDelegate["_"]["onlsfocus"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {UCF_Listbox_Item} */
	var oItem = this["oGetLastInteractedItem"]();
	/** @type {Array.<_MaybeItem>} */
	var aItems;

	if (window["UCF_System"]["bIsAria"]) {
		if (oIM["iGetItemCount"]() === 0) {
			UCF_AriaStateHelper["addLabel"](
				this["oControl"]["oDomRef"],
				this["oLS"]["sGetText"]('SAPUR_EMPTY')
			);
		} else {
			if (oItem) {
				UCF_AriaStateHelper["setActivedescendant"](this["oControl"]["oDomRef"], oItem["id"]);
			}
		}
	}

	// fallback 1: focus first selected item
	if (!oItem) {
		aItems = oIM["aFindItemsByStates"](
			[UCF_Listbox_Items["STATE"]["Selected"]],
			UCF_Listbox_Items["IGNORED_FOCUSABLE_STATES"]
		);
		oItem = aItems["length"] > 0 && aItems[0];
	}

	// fallback 2: focus first writeable item
	if (!oItem) {
		aItems = oIM["aFindItemsByStates"](
			[],
			UCF_Listbox_Items["IGNORED_FOCUSABLE_STATES"]
		);
		oItem = aItems["length"] > 0 && aItems[0];
	}

	if (oItem) {
		this["focusItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_FocusInteractionDelegate["_"]["onlsfocus"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oLsBlur the lsblur
 */
UCF_Listbox_FocusInteractionDelegate["prototype"]["onlsblur"] = function(oLsBlur) {;if (__UCF_COVERAGE__) { UCF_Listbox_FocusInteractionDelegate["_"]["onlsblur"]++; }; 
	this["oControl"]["oGetItemsManager"]()["clearState"](UCF_Listbox_Items["STATE"]["Focus"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_FocusInteractionDelegate["_"]["onlsblur"] = 0; };

/**
 * @private
 * @return {_MaybeItem}
 */
UCF_Listbox_FocusInteractionDelegate["prototype"]["oGetLastInteractedItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_FocusInteractionDelegate["_"]["oGetLastInteractedItem"]++; }; 
	/** @type {Array.<_MaybeItem>} */
	var aItems = this["oControl"]["oGetItemsManager"]()["aFindItemsByState"](
		UCF_Listbox_Items["STATE"]["LastInteractedWith"]
	);

	return aItems && aItems["length"] > 0 && aItems[0];
};;if (__UCF_COVERAGE__) { UCF_Listbox_FocusInteractionDelegate["_"]["oGetLastInteractedItem"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_FocusInteractionDelegate["prototype"]["focusItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_FocusInteractionDelegate["_"]["focusItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {string} */
	var sId;

	if (oIM["bIsFocusable"](oItem)) {
		if (window["UCF_System"]["bIsAria"]) {
			sId = UCF_Listbox_Items["sGetItemId"](oItem);

			UCF_AriaStateHelper["setActivedescendant"](
				this["oControl"]["oDomRef"],
				sId
			);
		}
		oIM["clearState"](UCF_Listbox_Items["STATE"]["Focus"]);
		oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Focus"]);
		oIM["scrollIntoView"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_FocusInteractionDelegate["_"]["focusItem"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_HoverInteractionDelegate"] = function() {/* global UCF_Listbox_Items */
/// <reference path="../Listbox_Items.js"/>
/* global UCF_Listbox_InteractionDelegate */
/// <reference path="./Listbox_InteractionDelegate.js"/>

/**
 * Delegate for Listbox* controls that handles the hover interaction with items
 * @class UCF_Listbox_HoverInteractionDelegate
 * @extends UCF_Object
 * @param {UCF_Listbox|UCF_Listbox_Popup} oControl the control
 */
function UCF_Listbox_HoverInteractionDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_HoverInteractionDelegate["_"]["UCF_Listbox_HoverInteractionDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox_InteractionDelegate["apply"](this, arguments);
	}
};window["UCF_Listbox_HoverInteractionDelegate"] = UCF_Listbox_HoverInteractionDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_HoverInteractionDelegate"); UCF_Listbox_HoverInteractionDelegate["_"] = {UCF_Listbox_HoverInteractionDelegate: 0}; }; ;
UCF_Listbox_HoverInteractionDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_InteractionDelegate"))(); UCF_Listbox_HoverInteractionDelegate.prototype["sClassName"] = "UCF_Listbox_HoverInteractionDelegate";

/**
 * @private
 * @param {UCF_BrowserEvent} oMouseover the mouseover
 */
UCF_Listbox_HoverInteractionDelegate["prototype"]["onmouseover"] = function(oMouseover) {;if (__UCF_COVERAGE__) { UCF_Listbox_HoverInteractionDelegate["_"]["onmouseover"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemByDomRef"](oMouseover["oGetSource"]());

	oIM["clearState"](UCF_Listbox_Items["STATE"]["Hover"]);
	if (oIM["bIsWriteable"](oItem)) {
		oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Hover"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_HoverInteractionDelegate["_"]["onmouseover"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oMouseout the mouseout
 */
UCF_Listbox_HoverInteractionDelegate["prototype"]["onmouseout"] = function(oMouseout) {;if (__UCF_COVERAGE__) { UCF_Listbox_HoverInteractionDelegate["_"]["onmouseout"]++; }; 
	this["oControl"]["oGetItemsManager"]()["clearState"](UCF_Listbox_Items["STATE"]["Hover"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_HoverInteractionDelegate["_"]["onmouseout"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_Interaction"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../../core/util/AriaStateHelper.js"/>
/* global UCF_Cache */
/// <reference path="../../../core/util/Cache.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_Listbox_Items */
/// <reference path="../Listbox_Items.js"/>

/**
 * @class UCF_Listbox_Interaction
 * @extends UCF_Object
 * @param {UCF_Listbox_SingleSelect} oControl the control to decorate
 * @param {UCF_Listbox_Items} [oItems] the items
 */
function UCF_Listbox_Interaction(oControl, oItems) {if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["UCF_Listbox_Interaction"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		/** @type {UCF_Listbox_SingleSelect} */
		this["oControl"] = oControl;
		/** @type {boolean} */
		this["bReadonly"] = this["oControl"]["bReadonly"];
		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
		/** @type {boolean} */
		this["bTouchstartSelected"] = false;

		/** @type {string} */
		this["sAccessibilityCt"] = 'ILBS';

		/** @type {string} */
		this["sSearchPrefix"] = '';
		/** @type {string} */
		this["sSearchId"] = null;
	}
};window["UCF_Listbox_Interaction"] = UCF_Listbox_Interaction; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_Interaction"); UCF_Listbox_Interaction["_"] = {UCF_Listbox_Interaction: 0}; }; 
UCF_Listbox_Interaction["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Listbox_Interaction.prototype["sClassName"] = "UCF_Listbox_Interaction";

/** @constant {number} */
UCF_Listbox_Interaction["LARGE_STEP"] = 10;
/** @constant {number} after the last keystroke that should trigger a search */
UCF_Listbox_Interaction["SEARCH_TIMEOUT_MS"] = 250;

/** @override */
UCF_Listbox_Interaction["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["destroy"]++; }; 
	if (this["oCache"]) {
		this["oCache"]["destroy"]();
		this["oCache"] = null;
	}
	this["oControl"] = null;
	this["bReadonly"] = null;
	this["sSearchId"] = null;
	this["sSearchPrefix"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["destroy"] = 0; };

// ===== browser events =======================================================

// ----- mousedown ------------------------------------------------------------

/**
 * @private
 * @param {UCF_BrowserEvent} oMousedown the mousedown
 */
UCF_Listbox_Interaction["prototype"]["onmousedown"] = function(oMousedown) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onmousedown"]++; }; 
	this["selectItem"](
		this["oControl"]["oGetItemsManager"]()["oFindItemByDomRef"](oMousedown["oGetSource"]())
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onmousedown"] = 0; };

// ----- keydown --------------------------------------------------------------

/**
 * @private
 * @param {UCF_BrowserEvent} oKeydown the keydown
 */
UCF_Listbox_Interaction["prototype"]["onkeydown"] = function(oKeydown) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onkeydown"]++; }; 
	/** @type {boolean} */
	var bHandled = false;
	/** @type {number} */
	var iKeyCode = oKeydown["iKeyCode"]();

	/* beautify preserve:start */
	// [DOWN]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"])) {
		this["selectItem"](this["oGetItemRelativeToFocused"](1));
		bHandled = true;
	} else
	// [UP]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"])) {
		this["selectItem"](this["oGetItemRelativeToFocused"](-1));
		bHandled = true;
	} else
	// [PAGE_DOWN]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_DOWN"])) {
		this["selectItem"](
			this["oGetItemRelativeToFocused"](UCF_Listbox_Interaction["LARGE_STEP"])
		);
		bHandled = true;
	} else
	// [PAGE_UP]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_UP"])) {
		this["selectItem"](
			this["oGetItemRelativeToFocused"](-UCF_Listbox_Interaction["LARGE_STEP"])
		);
		bHandled = true;
	} else
	// [HOME]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["HOME"]) || (
			UCF_UserAgent["bIsMacOs"]() &&
			UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"], 'C')
		)
	) {
		this["selectItem"](this["oGetFirstWriteableItem"]());
		bHandled = true;
	} else
	// [END]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["END"]) || (
			UCF_UserAgent["bIsMacOs"]() &&
			UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"], 'C')
		)
	) {
		this["selectItem"](this["oGetLastWriteableItem"]());
		bHandled = true;
	} else
	// [SPACE] or [ENTER]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"]) ||
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ENTER"])
	) {
		this["selectItem"](this["oGetFocusedItem"]());
		bHandled = true;
	} else
	// [ALT][DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"], 'A')
	) {
		this["focusItem"](this["oGetItemRelativeToFocused"](1));
		bHandled = true;
	} else
	// [ALT][UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"], 'A')
	) {
		this["focusItem"](this["oGetItemRelativeToFocused"](-1));
		bHandled = true;
	} else
	// [ALT][PAGE_DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_DOWN"], 'A')
	) {
		this["focusItem"](this["oGetItemRelativeToFocused"](
			UCF_Listbox_Interaction["LARGE_STEP"]));
		bHandled = true;
	} else
	// [ALT][PAGE_UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_UP"], 'A')
	) {
		this["focusItem"](
			this["oGetItemRelativeToFocused"](-UCF_Listbox_Interaction["LARGE_STEP"])
		);
		bHandled = true;
	} else
	// [ALT][HOME]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["HOME"], 'A') || (
			UCF_UserAgent["bIsMacOs"]() &&
			UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"], 'AC')
		)
	) {
		this["focusItem"](this["oGetFirstWriteableItem"]());
		bHandled = true;
	} else
	// [ALT][END]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["END"], 'A') || (
			UCF_UserAgent["bIsMacOs"]() &&
			UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"], 'AC')
		)
	) {
		this["focusItem"](this["oGetLastWriteableItem"]());
		bHandled = true;
	} else
	// edit key
	if (!oKeydown["bCtrl"]() && UCF_KeyboardHelper["bIsEditKey"](iKeyCode)) {
		this["sSearchPrefix"] += String["fromCharCode"](iKeyCode);
		this["selectItemByPrefix"](this["sSearchPrefix"]);

		if (this["sSearchId"]) {
			UCF_JsUtil["clearDelayedCall"](this["sSearchId"]);
			this["sSearchId"] = null;
		}
		this["sSearchId"] = UCF_JsUtil["delayedCall"](
			UCF_Listbox_Interaction["SEARCH_TIMEOUT_MS"],
			this,
			'onDelayedEditKeydown'
		);
	}
	/* beautify preserve:end */

	if (bHandled) {
		oKeydown["cancel"]();
		oKeydown["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onkeydown"] = 0; };

// ===== onlstouchstart =======================================================
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the touchstart
 */
UCF_Listbox_Interaction["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onlstouchstart"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {Item} */
	var oItem = oIM["oFindItemByDomRef"](oBrowserEvent["oGetSource"]());

	this["bTouchstartSelected"] = false;

	// if touch handle is drag source select item
	if (this["bOnDragHandle"](oBrowserEvent)) {
		if (oIM["bIsWriteable"](oItem) &&
			!oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])) {
			this["bTouchstartSelected"] = true;
			this["selectItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onlstouchstart"] = 0; };

// ===== onlstouchend =========================================================
/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the onlstouchend
 */
UCF_Listbox_Interaction["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onlstouchend"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {Item} */
	var oItem = oIM["oFindItemByDomRef"](oBrowserEvent["oGetSource"]());

	// if touch handle is drag source select item
	if (this["bOnDragHandle"](oBrowserEvent)) {
		if (oIM["bIsWriteable"](oItem) &&
			oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]) &&
			!this["bTouchstartSelected"]) {
			this["selectItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onlstouchend"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_Listbox_Interaction["prototype"]["bOnDragHandle"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["bOnDragHandle"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();

	return oSource
		&& UCF_DomUtil["bHasClass"](oSource, 'lsListbox__value')
		&& UCF_DomUtil["bHasClass"](oSource["parentElement"], 'lsListbox__values--draghandle');
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["bOnDragHandle"] = 0; };

/** @private */
UCF_Listbox_Interaction["prototype"]["onDelayedEditKeydown"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onDelayedEditKeydown"]++; }; 
	if (this["sSearchPrefix"]) {
		this["sSearchPrefix"] = '';
		this["sSearchId"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onDelayedEditKeydown"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element
 * within the control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 * @private
 */
UCF_Listbox_Interaction["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_Control} */
	var oSourceControl = oBrowserEvent["oGetSourceControl"]();
	/** @type {UCF_Listbox_Item} */
	var oItem;
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper;
	/** @type {string} */
	var sSecondValue;
	/** @type {UCF_Listbox_Items} */
	var oIM;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Listbox_Interaction.js(313): onlsaccessibility"); };

	if (oSourceControl === this ||
		UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_ItemListBox')
	) {
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
		oIM = this["oControl"]["oGetItemsManager"]();
		// To convert oToItem to Listbox_Items accessors, we would have to provide
		// nearly the whole lsdata in the dataset of the item => that would be too
		// much, so for the moment we use oToItem here (d064766, 2019-10-09)
		oItem = oIM["oToItem"](this["oGetFocusedItem"]());

		if (oItem) {
			oAccessibilityHelper["setAccessKey"](oItem["sAccessKey"]);
			oAccessibilityHelper["setEnabled"](oItem["bEnabled"]);
			oAccessibilityHelper["setReadonly"](oItem["bReadonly"]);
			oAccessibilityHelper["setRequired"](oItem["bRequired"]);
			oAccessibilityHelper["setInvalid"](oItem["bInvalid"]);
			oAccessibilityHelper["addTooltip"](oItem["sTooltip"]);
			oAccessibilityHelper["setSelected"](
				oItem["bHasState"](UCF_Listbox_Items["STATE"]["Selected"])
			);

			// get text of the focused item
			sSecondValue = '';
			if (this["oControl"]["sSecondValueVisibility"] !== 'NONE') {
				sSecondValue = oItem["sValue2"];
				if (sSecondValue !== '') {
					sSecondValue = ' ' + sSecondValue;
				}
			}
			oAccessibilityHelper["setText"](oItem["sValue1"] + sSecondValue);
			oAccessibilityHelper["setItemCount"](oIM["iGetItemCount"]());
			oAccessibilityHelper["setItemIndex"](oItem["iGetIndex"]() + 1);
			oAccessibilityHelper["setControlType"](this["sAccessibilityCt"]);
			oAccessibilityHelper["applyLabelingInfo"](this["oControl"]);

			if (oIM["bIsWriteable"](oItem)) {
				oAccessibilityHelper["addEnabledTutor"](
					this["sAccessibilityCt"] + '_TUT',
					true
				);
			} else {
				oAccessibilityHelper["addTutor"](
					'UDNAV_TUT', !oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Disabled"])
				);
			}

		} else {
			oAccessibilityHelper["applyLabelingInfo"](this["oControl"]);
			oAccessibilityHelper["setEmpty"](true);
			oAccessibilityHelper["setControlType"](this["sAccessibilityCt"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["onlsaccessibility"] = 0; };

// ===== helpers ==============================================================

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_Interaction["prototype"]["selectItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["selectItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	if (!this["bReadonly"] && oIM["bIsWriteable"](oItem)) {
		oIM["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
		oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
	}
	this["focusItem"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["selectItem"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_Interaction["prototype"]["focusItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["focusItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	if (oIM["bIsFocusable"](oItem)) {
		this["interactWithItem"](oItem);

		oIM["clearState"](UCF_Listbox_Items["STATE"]["Focus"]);
		oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Focus"]);
		if (window["UCF_System"]["bIsAria"] || window["UCF_System"]["bIs508"]) {
			UCF_AriaStateHelper["setActivedescendant"](
				this["oControl"]["oDomRef"],
				UCF_Listbox_Items["sGetItemId"](oItem)
			);
		}
		oIM["scrollIntoView"](oItem);
		if (window["UCF_System"]["bIs508"]) {
			this["oControl"]["refocus"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["focusItem"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_Interaction["prototype"]["interactWithItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["interactWithItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	oIM["clearState"](UCF_Listbox_Items["STATE"]["LastInteractedWith"]);
	oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["LastInteractedWith"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["interactWithItem"] = 0; };

/**
 * @private
 * @return {_MaybeItem}
 */
UCF_Listbox_Interaction["prototype"]["oGetSelectedItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["oGetSelectedItem"]++; }; 
	/** @type {Array<_MaybeItem>} */
	var aItems = this["oControl"]["oGetItemsManager"]()["aFindItemsByStates"](
		[UCF_Listbox_Items["STATE"]["Selected"]], []
	);

	// for Listbox_Interaction, aItems.length should always be 1, so we get the
	// first item
	// for Listbox_MultiInteraction, aItems.length will be > 0, so we get the
	// last selected item
	return aItems && aItems["length"] > 0 && aItems[aItems["length"] - 1];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["oGetSelectedItem"] = 0; };

/**
 * @private
 * @return {_MaybeItem}
 */
UCF_Listbox_Interaction["prototype"]["oGetFocusedItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["oGetFocusedItem"]++; }; 
	/** @type {Array.<_MaybeItem>} */
	var aItems = this["oControl"]["oGetItemsManager"]()["aFindItemsByStates"](
		[UCF_Listbox_Items["STATE"]["Focus"]], []
	);

	return aItems && aItems["length"] > 0 && aItems[0];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["oGetFocusedItem"] = 0; };

/**
 * @private
 * @param {number} iOffset the index offset
 * @return {_MaybeItem}
 */
UCF_Listbox_Interaction["prototype"]["oGetItemRelativeToFocused"] = function(iOffset) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["oGetItemRelativeToFocused"]++; }; 
	/** @type {_MaybeItem} */
	var oFocusedItem = this["oGetFocusedItem"]();
	/** @type {_MaybeItem} */
	var oRelativeItem = this["oControl"]["oGetItemsManager"]()["oFindItemByIndexOffsetAndStates"](
		oFocusedItem,
		iOffset,
		[],
		UCF_Listbox_Items["IGNORED_FOCUSABLE_STATES"]
	);

	return oRelativeItem === oFocusedItem ? null : oRelativeItem;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["oGetItemRelativeToFocused"] = 0; };

/**
 * @private
 * @return {_MaybeItem}
 */
UCF_Listbox_Interaction["prototype"]["oGetFirstWriteableItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["oGetFirstWriteableItem"]++; }; 
	/** @type {UCF_Listbox_Interaction} */
	var self = this;

	return this["oCache"]["get"]('firstWriteableItem', function() {
		/** @type {Array.<_MaybeItem>} */
		var aItems = self["aGetWriteableItems"]();

		return aItems && aItems["length"] > 0 && aItems[0];
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["oGetFirstWriteableItem"] = 0; };

/**
 * @private
 * @return {Array.<_MaybeItem>}
 */
UCF_Listbox_Interaction["prototype"]["aGetWriteableItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["aGetWriteableItems"]++; }; 
	/** @type {UCF_Listbox_Interaction} */
	var self = this;

	return this["oCache"]["get"]('writeableItems', function() {
		return self["oControl"]["oGetItemsManager"]()["aFindItemsByStates"](
			[],
			UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"]
		);
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["aGetWriteableItems"] = 0; };

/**
 * @private
 * @return {_MaybeItem}
 */
UCF_Listbox_Interaction["prototype"]["oGetLastWriteableItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["oGetLastWriteableItem"]++; }; 
	/** @type {UCF_Listbox_Interaction} */
	var self = this;

	return this["oCache"]["get"]('oLastWriteableItem', function() {
		/** @type {Array.<_MaybeItem>} */
		var aItems = self["aGetWriteableItems"]();

		return aItems && aItems["length"] > 0 && aItems[aItems["length"] - 1];
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["oGetLastWriteableItem"] = 0; };

// ===== api ==================================================================

/**
 * @protected
 * @param {string} sId the id of the item to select
 */
UCF_Listbox_Interaction["prototype"]["selectItemById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["selectItemById"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemById"](sId);

	if (!this["bReadonly"] &&
		oIM["bIsWriteable"](oItem) &&
		!oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])
	) {
		this["selectItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["selectItemById"] = 0; };

/**
 * @protected
 * @param {string} sId the id of the item to deselect
 */
UCF_Listbox_Interaction["prototype"]["deselectItemById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["deselectItemById"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemById"](sId);

	if (!this["bReadonly"] &&
		oIM["bIsWriteable"](oItem) &&
		oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])
	) {
		oIM["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
		this["focusItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["deselectItemById"] = 0; };

/**
 * @public
 * @param {Array.<string>} aKeys list of keys of items to select
 */
UCF_Listbox_Interaction["prototype"]["selectItemsByKeys"] = function(aKeys) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["selectItemsByKeys"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM;
	/** @type {_MaybeItem} */
	var oItem;

	if (!this["bReadonly"] && aKeys && aKeys["length"] > 0) {
		oIM = this["oControl"]["oGetItemsManager"]();
		oItem = oIM["oFindItemByKey"](aKeys[0]);

		if (oItem && oIM["bIsWriteable"](oItem)) {
			oIM["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
			this["selectItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["selectItemsByKeys"] = 0; };

/**
 * @private
 * @param {string} sPrefix the search prefix
 */
UCF_Listbox_Interaction["prototype"]["selectItemByPrefix"] = function(sPrefix) {;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["selectItemByPrefix"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	this["selectItem"](oIM["oFindItemByPrefix"](
		sPrefix,
		oIM["iGetItemIndex"](this["oGetSelectedItem"]())
	));
};;if (__UCF_COVERAGE__) { UCF_Listbox_Interaction["_"]["selectItemByPrefix"] = 0; };

UCF_Listbox_Interaction.prototype["aPublicMethods"] = ["selectItemsByKeys"].concat(UCF_Listbox_Interaction.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Listbox_InteractionDelegate"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_Listbox_Items */
/// <reference path="../Listbox_Items.js"/>

/**
 * @class UCF_Listbox_InteractionDelegate
 * @extends UCF_Object
 * @param {UCF_Listbox|UCF_Listbox_Popup} oControl the control this object is
 * the delegate for
 */
function UCF_Listbox_InteractionDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_InteractionDelegate["_"]["UCF_Listbox_InteractionDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		/** @type {UCF_Listbox} */
		this["oControl"] = oControl;
		/** @type {UCF_LS} */
		this["oLS"] = oControl["oLS"];
	}
};window["UCF_Listbox_InteractionDelegate"] = UCF_Listbox_InteractionDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_InteractionDelegate"); UCF_Listbox_InteractionDelegate["_"] = {UCF_Listbox_InteractionDelegate: 0}; }; ;
UCF_Listbox_InteractionDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Listbox_InteractionDelegate.prototype["sClassName"] = "UCF_Listbox_InteractionDelegate";

/** @override */
UCF_Listbox_InteractionDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_InteractionDelegate["_"]["destroy"]++; }; 
	this["oControl"] = null;
	this["oLS"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_InteractionDelegate["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_Item"] = function() {/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemListBoxItem */
/// <reference path="./ItemListBoxItem.js"/>
/* global UCF_Listbox_Items */
/// <reference path="./Listbox_Items.js"/>

/**
 * @typedef {Object} UCF_Listbox_Item_Dataset
 * @property {string} itemid
 * @property {string} itemindex
 * @property {string} itemkey
 * @property {string} itemvalue1
 * @property {string} itemvalue2
 * @property {string} itemtooltip
 * @property {string} itemicontooltip
 * @property {string} itemgrouptitle
 */

/**
 * @class UCF_Listbox_Item
 * @extends UCF_ItemListBoxItem
 * @param {HTMLDivElement} oDomRef the dom element with the ct
 * @param {UCF_LS} oLS the lightspeed instance
 */
function UCF_Listbox_Item(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["UCF_Listbox_Item"]++; }; 
	/** @type {UCF_Listbox_Item_Dataset} */
	var oDataset;

	if (arguments["length"] > 0) {
		UCF_ItemListBoxItem["apply"](this, arguments);

		oDataset = UCF_DomUtil["dataset"](oDomRef);

		this["setIndex"](oDataset["itemindex"]);

		/** @type {boolean} */
		this["bEnabled"] = !UCF_DomUtil["bHasClass"](oDomRef, 'lsListbox__value--disabled');
		/** @type {string} */
		this["sKey"] = oDataset["itemkey"];
		/** @type {string} */
		this["sValue1"] = oDataset["itemvalue1"];
		/** @type {string} */
		this["sValue2"] = oDataset["itemvalue2"];
		/** @type {string} */
		this["sTooltip"] = oDataset["itemtooltip"];
		/** @type {string} */
		this["sIconToolTip"] = oDataset["itemicontooltip"];
		/** @type {string} */
		this["sGroupTitle"] = oDataset["itemgrouptitle"];
		/** @type {HTMLDivElement[]} */
		this["aValueRefs"] = UCF_JsUtil["arrayFrom"](
			UCF_DomUtil["querySelectorAll"]('[data-itemid="' + this["sId"] + '"]')
		);
	}
};window["UCF_Listbox_Item"] = UCF_Listbox_Item; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_Item"); UCF_Listbox_Item["_"] = {UCF_Listbox_Item: 0}; }; ;
UCF_Listbox_Item["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemListBoxItem"))(); UCF_Listbox_Item.prototype["sClassName"] = "UCF_Listbox_Item";

/** @protected */
UCF_Listbox_Item["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["destroy"]++; }; 
	this["bEnabled"] = null;
	this["sKey"] = null;
	this["sValue1"] = null;
	this["sValue2"] = null;
	this["sTooltip"] = null;
	this["sIconToolTip"] = null;
	this["sGroupTitle"] = null;
	this["aValueRefs"] = null;
	this["iIndex"] = null;

	UCF_ItemListBoxItem.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["destroy"] = 0; };

/** @protected */
UCF_Listbox_Item["prototype"]["removeFromDom"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["removeFromDom"]++; }; 
	if (this["aValueRefs"] && this["aValueRefs"]["length"] > 0) {
		UCF_JsUtil["forEach"](this["aValueRefs"], UCF_DomUtil["removeFromDom"]);
	}
	this["destroy"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["removeFromDom"] = 0; };

/**
 * @protected
 * @param {string|number} iIndex the item index
 */
UCF_Listbox_Item["prototype"]["setIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["setIndex"]++; }; 
	this["iIndex"] = parseInt(iIndex, 10);
	UCF_DomUtil["dataset"](this["oDomRef"])["itemindex"] = this["iIndex"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["setIndex"] = 0; };

/**
 * @protected
 * @return {number}
 */
UCF_Listbox_Item["prototype"]["iGetIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["iGetIndex"]++; }; 
	return this["iIndex"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["iGetIndex"] = 0; };

/**
 * @protected
 * @param {number} iSetsize The number of items in the set
 */
UCF_Listbox_Item["prototype"]["setAriaSetsize"] = function(iSetsize) {;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["setAriaSetsize"]++; }; 
	UCF_AriaStateHelper["setSetsize"](this["oDomRef"], iSetsize);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["setAriaSetsize"] = 0; };

/**
 * @protected
 * @param {number} iPosinset The index of item in the set
 */
UCF_Listbox_Item["prototype"]["setAriaPosinset"] = function(iPosinset) {;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["setAriaPosinset"]++; }; 
	UCF_AriaStateHelper["setPosinset"](this["oDomRef"], iPosinset);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["setAriaPosinset"] = 0; };

/**
 * @protected
 * @param {boolean} bHidden The hidden state
 */
UCF_Listbox_Item["prototype"]["setAriaHidden"] = function(bHidden) {;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["setAriaHidden"]++; }; 
	UCF_AriaStateHelper["setHidden"](this["oDomRef"], bHidden);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["setAriaHidden"] = 0; };

// ===== state ================================================================

/**
 * @protected
 * @param {number} iState the state
 * @return {boolean}
 */
UCF_Listbox_Item["prototype"]["bHasState"] = function(iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["bHasState"]++; }; 
	return this["oDomRef"]
		&& UCF_DomUtil["bHasClass"](
			this["oDomRef"],
			UCF_Listbox_Items["STATE_CLASS"][iState]
		);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["bHasState"] = 0; };

/**
 * @protected
 * @param {number} iState the state to add
 */
UCF_Listbox_Item["prototype"]["addState"] = function(iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["addState"]++; }; 
	/** @type {UCF_Listbox_Item} */
	var self;

	if (this["aValueRefs"] && this["aValueRefs"]["length"] > 0) {
		self = this;

		UCF_JsUtil["forEach"](this["aValueRefs"], function(oValueRef) {
			UCF_DomUtil["addClass"](oValueRef, UCF_Listbox_Items["STATE_CLASS"][iState]);

			switch (iState) {
				case UCF_Listbox_Items["STATE"]["Selected"]:
					self["setClientProperty"]('Selected', true, true);
					if (window["UCF_System"]["bIsAria"]) {
						UCF_AriaStateHelper["setSelected"](oValueRef, true);
					}
					break;
			}
		});
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["addState"] = 0; };

/**
 * @protected
 * @param {number} iState the state to remove
 */
UCF_Listbox_Item["prototype"]["removeState"] = function(iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["removeState"]++; }; 
	/** @type {UCF_Listbox_Item} */
	var self;

	if (this["aValueRefs"] && this["aValueRefs"]["length"] > 0) {
		self = this;

		UCF_JsUtil["forEach"](this["aValueRefs"], function(oValueRef) {
			UCF_DomUtil["removeClass"](
				oValueRef,
				UCF_Listbox_Items["STATE_CLASS"][iState]
			);

			switch (iState) {
				case UCF_Listbox_Items["STATE"]["Selected"]:
					self["setClientProperty"]('Selected', false, true);
					if (window["UCF_System"]["bIsAria"]) {
						UCF_AriaStateHelper["setSelected"](oValueRef, false);
					}
					break;
			}
		});
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Item["_"]["removeState"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_Items"] = function() {/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_EventProvider */
/// <reference path="../../core/EventProvider.js"/>
/* global UCF_Tracer, _trace, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Promise */
/// <reference path="../../core/util/Promise.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>

/* global UCF_Cache */
/** @typedef {HTMLDivElement|UCF_Listbox_Item} _MaybeItem */
/** @typedef {0} UCF_Listbox_Items_StateChangeEvent */
/** @typedef {1} UCF_Listbox_Items_WillAccessDomEvent */
/** @typedef {2} UCF_Listbox_Items_WillDeleteItemAnimatedEvent */
/** @typedef {3} UCF_Listbox_Items_DidDeleteItemAnimatedEvent */
/** @typedef {UCF_Listbox_Items_StateChangeEvent|UCF_Listbox_Items_WillAccessDomEvent|UCF_Listbox_Items_WillDeleteItemAnimatedEvent|UCF_Listbox_Items_DidDeleteItemAnimatedEvent} UCF_Listbox_Items_Event */
/**
 * @typedef {Object} UCF_Listbox_Items_EventEnum
 * @property {UCF_Listbox_Items_StateChangeEvent} StateChange
 * @property {UCF_Listbox_Items_WillAccessDomEvent} WillAccessDom
 * @property {UCF_Listbox_Items_WillDeleteItemAnimatedEvent} WillDeleteItemAnimated
 * @property {UCF_Listbox_Items_DidDeleteItemAnimatedEvent} DidDeleteItemAnimated
 */
/** @typedef {0} UCF_Listbox_Items_HoverState */
/** @typedef {1} UCF_Listbox_Items_ActiveState */
/** @typedef {2} UCF_Listbox_Items_SelectedState */
/** @typedef {3} UCF_Listbox_Items_FocusState */
/** @typedef {4} UCF_Listbox_Items_DisabledState */
/** @typedef {5} UCF_Listbox_Items_HiddenState */
/** @typedef {6} UCF_Listbox_Items_LastInteractedWithState */
/** @typedef {7} UCF_Listbox_Items_SeparatorState */
/** @typedef {8} UCF_Listbox_Items_HistoryState */
/** @typedef {9} UCF_Listbox_Items_GroupState */
/** @typedef {10} UCF_Listbox_Items_TableHeaderState */
/** @typedef {11} UCF_Listbox_Items_HeadlineState */
/** @typedef {12} UCF_Listbox_Items_DeletedState */
/** @typedef {UCF_Listbox_Items_HoverState|UCF_Listbox_Items_ActiveState|UCF_Listbox_Items_SelectedState|UCF_Listbox_Items_FocusState|UCF_Listbox_Items_DisabledState|UCF_Listbox_Items_HiddenState|UCF_Listbox_Items_LastInteractedWithState|UCF_Listbox_Items_SeparatorState|UCF_Listbox_Items_HistoryState|UCF_Listbox_Items_GroupState|UCF_Listbox_Items_TableHeaderState|UCF_Listbox_Items_HeadlineState|UCF_Listbox_Items_Deleted} UCF_Listbox_Items_State */
/**
 * @typedef {Object} UCF_Listbox_Items_StateEnum
 * @property {UCF_Listbox_Items_HoverState} HoverState
 * @property {UCF_Listbox_Items_ActiveState} Active
 * @property {UCF_Listbox_Items_SelectedState} Selected
 * @property {UCF_Listbox_Items_FocusState} Focus
 * @property {UCF_Listbox_Items_DisabledState} Disabled
 * @property {UCF_Listbox_Items_HiddenState} Hidden
 * @property {UCF_Listbox_Items_LastInteractedWithState} LastInteractedWith
 * @property {UCF_Listbox_Items_SeparatorState} Separator
 * @property {UCF_Listbox_Items_HistoryState} History
 * @property {UCF_Listbox_Items_GroupState} Group
 * @property {UCF_Listbox_Items_TableHeaderState} TableHeader
 * @property {UCF_Listbox_Items_HeadlineState} Headline
 * @property {UCF_Listbox_Items_DeletedState} Deleted
 */
/**
 * @typedef {Object} _ItemDataSet
 * @property {string} itemid
 * @property {string} itemindex
 * @property {string} itemkey
 * @property {'false'} [itemdisabled]
 * @property {string} [itemsrc]
 * @property {string} itemvalue1
 * @property {string} itemvalue2
 * @property {string} [itemicontooltip]
 * @property {string} [itemtooltip]
 * @property {string} [itemgrouptitle]
 */
/**
 * @typedef {Object} UCF_Listbox_Items_Metadata
 * @property {number} itemHeight
 * @property {number} itemFontSize
 * @property {number} itemDeleteAnimationDurationMs
 * @property {number} appearAnimationDurationMs
 * @property {number} disappearAnimationDurationMs
 * @property {boolean} supportsNoResults
 */
/**
 * Manages the items of a Listbox. Allows for state-based queries on the items.
 * Tries to lazy-evaluate and cache as much as possible.
 *
 * **WARNING:** If you call methods of this class, you can not rely on them
 * returning a UCF_Listbox_Item. They may, if the item has been cached, but
 * they may also return just the HTMLDivElement of the first value. To be sure
 * you have an item at hand, you have to call .oToItem() with the result.
 *
 * @example <caption>Get all selected items</caption>
 * var oIM = this.oGetItemsManager();
 * UCF_JsUtil.map(
 *   oIM.aFindItemsByState(UCF_Listbox_Items.STATE.Selected),
 *   function(o) { return oIM.oToItem(o); }
 * );
 *
 * @class UCF_Listbox_Items
 * @extends UCF_Control
 * @param {UCF_Listbox|UCF_Listbox_Popup} oControl the listbox to manage
 */
function UCF_Listbox_Items(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["UCF_Listbox_Items"]++; }; 
	if (arguments["length"] > 0) {
		UCF_EventProvider["apply"](this, arguments);

		/** @type {UCF_Listbox|UCF_Listbox_Popup} */
		this["oControl"] = oControl;
		/** @type {UCF_LS} */
		this["oLS"] = oControl["oLS"];
		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

		/** @type {Object<string,_MaybeItem>} */
		this["mDeleteAnimations"] = {};
	}
};window["UCF_Listbox_Items"] = UCF_Listbox_Items; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_Items"); UCF_Listbox_Items["_"] = {UCF_Listbox_Items: 0}; }; ;
UCF_Listbox_Items["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_Listbox_Items.prototype["sClassName"] = "UCF_Listbox_Items";

// ##### static properties ####################################################

/**
 * @protected
 * @type {UCF_Listbox_Items_StateEnum}
 */
UCF_Listbox_Items["STATE"] = {
	"Hover": 0,
	"Active": 1,
	"Selected": 2,
	"Focus": 3,
	"Disabled": 4,
	"Hidden": 5,
	"LastInteractedWith": 6,
	"Separator": 7,
	"History": 8,
	"Group": 9,
	"TableHeader": 10,
	"Headline": 11,
	"Deleted": 12
};

/**
 * @private
 * @const {UCF_Listbox_Items_State[]}
 */
UCF_Listbox_Items["IGNORED_FOCUSABLE_STATES"] = [
	UCF_Listbox_Items["STATE"]["Hidden"],
	UCF_Listbox_Items["STATE"]["Group"],
	UCF_Listbox_Items["STATE"]["TableHeader"],
	UCF_Listbox_Items["STATE"]["Headline"],
	UCF_Listbox_Items["STATE"]["Deleted"]
];

/**
 * @private
 * @const {UCF_Listbox_Items_State[]}
 */
UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"] = [
	UCF_Listbox_Items["STATE"]["Hidden"],
	UCF_Listbox_Items["STATE"]["Group"],
	UCF_Listbox_Items["STATE"]["Disabled"],
	UCF_Listbox_Items["STATE"]["TableHeader"],
	UCF_Listbox_Items["STATE"]["Headline"],
	UCF_Listbox_Items["STATE"]["Deleted"]
];

/**
 * @protected
 * @type {UCF_Listbox_Items_EventEnum}
 */
UCF_Listbox_Items["EVENT"] = {
	"StateChange": 0,
	"WillAccessDom": 1,
	"WillDeleteItemAnimated": 2,
	"DidDeleteItemAnimated": 3
};

/**
 * @protected
 * @type {Object<UCF_Listbox_Items_State, string>}
 */
UCF_Listbox_Items["STATE_CLASS"] = {};

UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["Hover"]] =
	'lsListbox__value--hover';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["Active"]] =
	'lsListbox__value--active';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["Selected"]] =
	'lsListbox__value--selected';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["Focus"]] =
	'lsListbox__value--focus';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["Disabled"]] =
	'lsListbox__value--disabled';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["Hidden"]] =
	'lsListbox__value--hidden';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["LastInteractedWith"]] =
	'lsListbox__value--lastinteractedwith';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["Separator"]] =
	'lsListbox__value--separator';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["History"]] =
	'lsListbox__value--history';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["Group"]] =
	'lsListbox__value--group';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["TableHeader"]] =
	'lsListbox__value--tableheader';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["Headline"]] =
	'lsListbox__value--headline';
UCF_Listbox_Items["STATE_CLASS"][UCF_Listbox_Items["STATE"]["Deleted"]] =
	'lsListbox__value--deleted';

/**
 * @private
 * @param {_MaybeItem} oItem the ref to get the item id from
 * @return {string} the item id of the dom ref
 */
UCF_Listbox_Items["sGetItemId"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemId"]++; }; 
	return oItem && (UCF_Listbox_Items["bIsItem"](oItem)
		? oItem["sId"]
		// data-itemid is rendered to all value refs => no need to pick the first
		: UCF_DomUtil["dataset"](oItem)["itemid"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemId"] = 0; };

/**
 * @private
 * @param {HTMLDivElement} oItem
 * @return {_ItemDataSet}
 */
UCF_Listbox_Items["prototype"]["oGetItemData"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetItemData"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;
	/** @type {_ItemDataSet} */
	var oItemDataSet;
	/** @type {string} */
	var sItemId;

	if (oItem) {
		oItemDataSet = UCF_DomUtil["dataset"](oItem);
		sItemId = oItemDataSet["itemid"];

		if (oItem["id"]) {
			return this["oCache"]["get"]('oItemDataSet("' + sItemId + '")', function() {
				/** @type {Object<string,_ItemDataSet>} */
				var oItemDataSets = self["oCache"]["get"]('oItemDataSets("' + self["oControl"]["sId"] + '")', function() {
					/** @type {_ItemDataSet} */
					var oData = {};

					self["fireWillAccessDom"]();

					UCF_JsUtil["forEach"](
						UCF_DomUtil["querySelectorAll"]('[id="' + self["oControl"]["sId"] + '-scrl"] .lsListbox__values > *') || [],
						function(oItemRef) {
							/** @type {_ItemDataSet} */
							var oDataSet = UCF_DomUtil["dataset"](oItemRef);

							if (!(oDataSet["itemid"] in oData)) {
								oData[oDataSet["itemid"]] = {};
							}

							UCF_JsUtil["extend"](oData[oDataSet["itemid"]], oDataSet);
						}
					);

					return oData;
				});

				if (sItemId in oItemDataSets) {
					return oItemDataSets[sItemId];
				} else {
					return oItemDataSet;
				}
			});
		} else {
			return oItemDataSet;
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetItemData"] = 0; };

/**
 * @final
 * @static
 * @return {UCF_Listbox_Items_Metadata}
 */
UCF_Listbox_Items["oGetMetadata"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetMetadata"]++; }; 
	if (!UCF_Listbox_Items["oMetadata"]) {
		UCF_Listbox_Items["oMetadata"] = UCF_JsUtil["extend"]({
			"itemHeight": 17,
			"itemFontSize": 11,
			"supportsNoResults": false,
			"itemDeleteAnimationDurationMs": 0,
			"appearAnimationDurationMs": 0,
			"disappearAnimationDurationMs": 0
		}, UCF_ResourceUtil["oGetMetadataFromTheme"]('lsListbox__metadata'));
	}

	return UCF_Listbox_Items["oMetadata"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetMetadata"] = 0; };

/**
 * @final
 * @static
 * @return {number}
 */
UCF_Listbox_Items["iGetItemDeleteAnimationDurationMs"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetItemDeleteAnimationDurationMs"]++; }; 
	if (typeof UCF_Listbox_Items["iItemDeleteAnimationDurationMs"] !== 'number') {
		UCF_Listbox_Items["iItemDeleteAnimationDurationMs"] = window["UCF_System"]["bUseAnimation"]
			? parseInt(UCF_Listbox_Items["oGetMetadata"]()["itemDeleteAnimationDurationMs"], 10)
			: 0;
	}

	return UCF_Listbox_Items["iItemDeleteAnimationDurationMs"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetItemDeleteAnimationDurationMs"] = 0; };

/**
 * @final
 * @static
 * @return {number}
 */
UCF_Listbox_Items["iGetAppearAnimationDurationMs"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetAppearAnimationDurationMs"]++; }; 
	if (typeof UCF_Listbox_Items["iAppearAnimationDurationMs"] !== 'number') {
		UCF_Listbox_Items["iAppearAnimationDurationMs"] = window["UCF_System"]["bUseAnimation"]
			? parseInt(UCF_Listbox_Items["oGetMetadata"]()["appearAnimationDurationMs"], 10)
			: 0;
	}

	return UCF_Listbox_Items["iAppearAnimationDurationMs"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetAppearAnimationDurationMs"] = 0; };

/**
 * @final
 * @static
 * @return {number}
 */
UCF_Listbox_Items["iGetDisappearAnimationDurationMs"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetDisappearAnimationDurationMs"]++; }; 
	if (typeof UCF_Listbox_Items["iDisappearAnimationDurationMs"] !== 'number') {
		UCF_Listbox_Items["iDisappearAnimationDurationMs"] = window["UCF_System"]["bUseAnimation"]
			? parseInt(UCF_Listbox_Items["oGetMetadata"]()["disappearAnimationDurationMs"], 10)
			: 0;
	}

	return UCF_Listbox_Items["iDisappearAnimationDurationMs"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetDisappearAnimationDurationMs"] = 0; };

/**
 * @private
 * @static
 * @param {_MaybeItem} oItem
 */
UCF_Listbox_Items["removeItemFromDom"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["removeItemFromDom"]++; }; 
	if (UCF_Listbox_Items["bIsItem"](oItem)) {
		oItem["removeFromDom"]();
	} else {
		UCF_JsUtil["forEach"](
			UCF_Listbox_Items["aGetItemValueRefs"](oItem),
			UCF_DomUtil["removeFromDom"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["removeItemFromDom"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem
 * @return {string}
 */
UCF_Listbox_Items["prototype"]["sGetItemKey"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemKey"]++; }; 
	/** @type {_ItemDataSet} */
	var oData;

	if (oItem) {
		if (UCF_Listbox_Items["bIsItem"](oItem)) {
			return oItem["sKey"];
		} else {
			oData = this["oGetItemData"](oItem);

			return oData ? oData["itemkey"] : null;
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemKey"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the ref to get the enabled state from
 * @return {boolean} `true` if the item itself is enabled
 */
UCF_Listbox_Items["prototype"]["bIsItemEnabled"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bIsItemEnabled"]++; }; 
	/** @type {_ItemDataSet} */
	var oData;

	if (oItem) {
		if (UCF_Listbox_Items["bIsItem"](oItem)) {
			return oItem["bEnabled"];
		} else {
			oData = this["oGetItemData"](oItem);

			return oData ? !('itemdisabled' in oData) : false;
		}
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bIsItemEnabled"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the ref to get the icon src from
 * @return {string} the icon src
 */
UCF_Listbox_Items["prototype"]["sGetItemIconSrc"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemIconSrc"]++; }; 
	/** @type {_ItemDataSet} */
	var oData;

	if (oItem) {
		if (UCF_Listbox_Items["bIsItem"](oItem)) {
			return oItem["sIconSrc"];
		} else {
			oData = this["oGetItemData"](oItem);

			return oData ? (oData["itemiconsrc"] || '') : null;
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemIconSrc"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item to get the tooltip from
 * @return {string} the tooltip of the item
 */
UCF_Listbox_Items["prototype"]["sGetItemTooltip"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemTooltip"]++; }; 
	/** @type {_ItemDataSet} */
	var oData;

	if (oItem) {
		if (UCF_Listbox_Items["bIsItem"](oItem)) {
			return oItem["sTooltip"];
		} else {
			oData = this["oGetItemData"](oItem);

			return oData ? (oData["itemtooltip"] || '') : null;
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemTooltip"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item to get the icon tooltip from
 * @return {string} the icon tooltip of the item
 */
UCF_Listbox_Items["prototype"]["sGetItemIconToolTip"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemIconToolTip"]++; }; 
	/** @type {_ItemDataSet} */
	var oData;

	if (oItem) {
		if (UCF_Listbox_Items["bIsItem"](oItem)) {
			return oItem["sIconToolTip"];
		} else {
			oData = this["oGetItemData"](oItem);

			return oData ? (oData["itemicontooltip"] || '') : null;
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemIconToolTip"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item to get the value1 from
 * @return {string} the value1 of the item
 */
UCF_Listbox_Items["prototype"]["sGetItemValue1"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemValue1"]++; }; 
	/** @type {_ItemDataSet} */
	var oData;

	if (oItem) {
		if (UCF_Listbox_Items["bIsItem"](oItem)) {
			return oItem["sValue1"];
		} else {
			oData = this["oGetItemData"](oItem);

			return oData ? (oData["itemvalue1"] || '') : null;
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemValue1"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item to get the value2 from
 * @return {string} the value2 of the item
 */
UCF_Listbox_Items["prototype"]["sGetItemValue2"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemValue2"]++; }; 
	/** @type {_ItemDataSet} */
	var oData;

	if (oItem) {
		if (UCF_Listbox_Items["bIsItem"](oItem)) {
			return oItem["sValue2"];
		} else {
			oData = this["oGetItemData"](oItem);

			return oData ? (oData["itemvalue2"] || '') : null;
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemValue2"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem
 * @return {string}
 */
UCF_Listbox_Items["prototype"]["sGetItemGroupTitle"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemGroupTitle"]++; }; 
	/** @type {_ItemDataSet} */
	var oData;

	if (oItem) {
		if (UCF_Listbox_Items["bIsItem"](oItem)) {
			return oItem["sGroupTitle"];
		} else {
			oData = this["oGetItemData"](oItem);

			return oData ? (oData["itemgrouptitle"] || '') : null;
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemGroupTitle"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the ref to get the item index
 * @return {number} the item index of the dom ref
 */
UCF_Listbox_Items["prototype"]["iGetItemIndex"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetItemIndex"]++; }; 
	/** @type {_ItemDataSet} */
	var oData;
	/** @type {number} */
	var iIndex;

	if (oItem) {
		if (UCF_Listbox_Items["bIsItem"](oItem)) {
			return oItem["iGetIndex"]();
		} else {
			oData = this["oGetItemData"](oItem);

			if (oData) {
				iIndex = parseInt(oData["itemindex"], 10);

				return isNaN(iIndex) ? -1 : iIndex;
			} else {
				return -1;
			}
		}
	} else {
		return -1;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetItemIndex"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem the item
 * @param {number} iIndex the index to set
 */
UCF_Listbox_Items["setItemIndex"] = function(oItem, iIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["setItemIndex"]++; }; 
	if (UCF_Listbox_Items["bIsItem"](oItem)) {
		oItem["setIndex"](iIndex);
	} else if (oItem) {
		UCF_DomUtil["dataset"](
			UCF_Listbox_Items["aGetItemValueRefs"](oItem)[0]
		)["itemindex"] = iIndex;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'trying to setItemIndex(' + oItem + ',' + iIndex + '), oItem must be a UCF_Listbox_Item or an HTMLDivElement belonging to an item.', "Listbox_Items.js(585): setItemIndex"); };
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["setItemIndex"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem The item
 * @param {number} iSetsize The number of items in the set
 */
UCF_Listbox_Items["setItemAriaSetsize"] = function(oItem, iSetsize) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["setItemAriaSetsize"]++; }; 
	if (UCF_Listbox_Items["bIsItem"](oItem)) {
		oItem["setAriaSetsize"](iSetsize);
	} else if (oItem) {
		UCF_AriaStateHelper["setSetsize"](UCF_Listbox_Items["aGetItemValueRefs"](oItem)[0], iSetsize);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'trying to setItemAriaSetsize(' + oItem + ',' + iSetsize + '), oItem bust be a UCF_Listbox_Item or an HTMLDivElement belonging to an item.', "Listbox_Items.js(600): setItemAriaSetsize"); };
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["setItemAriaSetsize"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem The item
 * @param {number} iPosinset The index of item in the set
 */
UCF_Listbox_Items["setItemAriaPosinset"] = function(oItem, iPosinset) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["setItemAriaPosinset"]++; }; 
	if (UCF_Listbox_Items["bIsItem"](oItem)) {
		oItem["setAriaPosinset"](iPosinset);
	} else if (oItem) {
		UCF_AriaStateHelper["setPosinset"](UCF_Listbox_Items["aGetItemValueRefs"](oItem)[0], iPosinset);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'trying to setItemAriaPosinset(' + oItem + ',' + iPosinset + '), oItem bust be a UCF_Listbox_Item or an HTMLDivElement belonging to an item.', "Listbox_Items.js(615): setItemAriaPosinset"); };
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["setItemAriaPosinset"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem The item
 * @param {boolean} bHidden The hidden state
 */
UCF_Listbox_Items["setItemAriaHidden"] = function(oItem, bHidden) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["setItemAriaHidden"]++; }; 
	if (UCF_Listbox_Items["bIsItem"](oItem)) {
		oItem["setAriaHidden"](bHidden);
	} else if (oItem) {
		UCF_AriaStateHelper["setHidden"](UCF_Listbox_Items["aGetItemValueRefs"](oItem)[0], bHidden);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'trying to setItemAriaHidden(' + oItem + ',' + bHidden + '), oItem bust be a UCF_Listbox_Item or an HTMLDivElement belonging to an item.', "Listbox_Items.js(630): setItemAriaHidden"); };
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["setItemAriaHidden"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem the item
 * @return {Array<HTMLDivElement>}
 */
UCF_Listbox_Items["aGetItemValueRefs"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["aGetItemValueRefs"]++; }; 
	return UCF_JsUtil["arrayFrom"](
		UCF_DomUtil["querySelectorAll"](
			'[data-itemid="' + UCF_Listbox_Items["sGetItemId"](oItem) + '"]'
		)
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["aGetItemValueRefs"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem the item
 * @param {number} iState the state
 */
UCF_Listbox_Items["addItemState"] = function(oItem, iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["addItemState"]++; }; 
	if (UCF_Listbox_Items["bIsItem"](oItem)) {
		oItem["addState"](iState);
	} else {
		UCF_JsUtil["forEach"](
			UCF_Listbox_Items["aGetItemValueRefs"](oItem),
			function(o) {
				UCF_DomUtil["addClass"](o, UCF_Listbox_Items["STATE_CLASS"][iState]);
			}
		);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["addItemState"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem the item
 * @param {number} iState the state
 */
UCF_Listbox_Items["removeItemState"] = function(oItem, iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["removeItemState"]++; }; 
	if (UCF_Listbox_Items["bIsItem"](oItem)) {
		oItem["removeState"](iState);
	} else {
		UCF_JsUtil["forEach"](
			UCF_Listbox_Items["aGetItemValueRefs"](oItem),
			function(o) {
				UCF_DomUtil["removeClass"](o, UCF_Listbox_Items["STATE_CLASS"][iState]);
			}
		);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["removeItemState"] = 0; };

/**
 * @private
 * @static
 * @param {UCF_Listbox_Items_State} iState
 * @return {boolean}
 */
UCF_Listbox_Items["bHasItemStateChangeEffectOnControltree"] = function(iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bHasItemStateChangeEffectOnControltree"]++; }; 
	return iState === UCF_Listbox_Items["STATE"]["Selected"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bHasItemStateChangeEffectOnControltree"] = 0; };

/**
 * @param {_MaybeItem} oItem the element or item
 * @param {UCF_Listbox_Items.STATE} iState the state to check
 * @return {boolean}
 */
UCF_Listbox_Items["bHasItemState"] = function(oItem, iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bHasItemState"]++; }; 
	return UCF_Listbox_Items["bIsItem"](oItem)
		? oItem["bHasState"](iState)
		: UCF_DomUtil["bHasClass"](oItem, UCF_Listbox_Items["STATE_CLASS"][iState]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bHasItemState"] = 0; };

/**
 * @param {_MaybeItem} oItem the item
 * @return {boolean}
 */
UCF_Listbox_Items["bIsItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bIsItem"]++; }; 
	return UCF_JsUtil["bInstanceOf"](oItem, 'UCF_Listbox_Item');
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bIsItem"] = 0; };

// ##### instance properties ##################################################

/** @override */
UCF_Listbox_Items["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["destroy"]++; }; 
	UCF_JsUtil["forEach"](UCF_JsUtil["keys"](this["mDeleteAnimations"]), UCF_JsUtil["callDelayedCallRedirect"]);
	this["mDeleteAnimations"] = null;

	UCF_JsUtil["forEach"](
		// use oCache directly to never create controls here,
		// fall back to {} in case oItems was never retrieved
		UCF_JsUtil["values"](this["oCache"]["get"]('oItems', function() { return {}; })),
		function(oItem) {
			if (UCF_Listbox_Items["bIsItem"](oItem)) {
				oItem["destroy"]();
			}
		}
	);
	this["oCache"]["destroy"]();
	this["oCache"] = null;

	this["oControl"] = null;
	this["oLS"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["destroy"] = 0; };

// ===== items ================================================================

/**
 * @protected
 * @return {number}
 */
UCF_Listbox_Items["prototype"]["iGetItemCount"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetItemCount"]++; }; 
	return this["aFindItemsByStates"]([], [UCF_Listbox_Items["STATE"]["Deleted"]])["length"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetItemCount"] = 0; };

/**
 * @private
 * @return {HTMLDivElement}
 */
UCF_Listbox_Items["prototype"]["oGetScrollRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetScrollRef"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	return this["oCache"]["get"]('oScrollRef', function() {
		return UCF_DomUtil["$"](self["oControl"]["sId"] + '-scrl');
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetScrollRef"] = 0; };

/**
 * @private
 * @return {HTMLDivElement}
 */
UCF_Listbox_Items["prototype"]["oGetItemsRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetItemsRef"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	return this["oCache"]["get"]('oItemsRef', function() {
		/** @type {HTMLDivElement} */
		var oScrollRef = self["oGetScrollRef"]();

		return UCF_DomUtil["bHasClass"](oScrollRef, 'lsListbox__items--decoupling')
			? oScrollRef["firstChild"]
			: oScrollRef;
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetItemsRef"] = 0; };

/**
 * @private
 * @return {Object<string,_MaybeItem>} id->item mappings
 */
UCF_Listbox_Items["prototype"]["oGetItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetItems"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	return this["oCache"]["get"]('oItems', function() {
		/** @type {Object<string,_MaybeItem>} */
		var oItems = {};
		/** @type {Object<number,Object<string,_MaybeItem>>} */
		var oStates = self["oGetStates"]();

		self["fireWillAccessDom"]();

		UCF_JsUtil["forEach"](
			UCF_DomUtil["childNodes"](
				// dependency to renderer: first values column has to contain the ids
				UCF_DomUtil["firstChild"](self["oGetItemsRef"](), 'DIV'),
				'DIV'
			),
			function(oRef) {
				oItems[oRef["id"]] = oRef;

				UCF_JsUtil["forEach"](
					UCF_JsUtil["values"](UCF_Listbox_Items["STATE"]),
					function(iState) {
						if (UCF_Listbox_Items["bHasItemState"](oRef, iState)) {
							oStates[iState][oRef["id"]] = oRef;
						}
					}
				);
			}
		);

		return oItems;
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetItems"] = 0; };

/**
 * @param {_MaybeItem} oItem the dom element
 * @return {UCF_Listbox_Item}
 */
UCF_Listbox_Items["prototype"]["oToItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oToItem"]++; }; 
	/** @type {UCF_Listbox_Item} */
	var o;
	/** @type {number} */
	var i;

	if (UCF_Listbox_Items["bIsItem"](oItem)) {
		return oItem;
	} else if (oItem) {
		o = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oItem, true);

		if (
			this["oCache"] &&
			this["oCache"]["mEntries"] &&
			this["oCache"]["mEntries"]["oItems"] &&
			this["oCache"]["mEntries"]["oItems"][o["sId"]] === o
		) {
			this["oCache"]["mEntries"]["oItems"][o["sId"]] = o;
		}
		for (i in this["oStates"]) {
			if (o["sId"] in this["oStates"][i]) {
				this["oStates"][i][o["sId"]] = o;
			}
		}

		return o;
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oToItem"] = 0; };

/**
 * @param {_MaybeItem} oItem1 the first item
 * @param {_MaybeItem} oItem2 the second item
 * @return {boolean}
 */
UCF_Listbox_Items["prototype"]["bEqual"] = function(oItem1, oItem2) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bEqual"]++; }; 
	return (oItem1 && UCF_Listbox_Items["sGetItemId"](oItem1)) ===
		(oItem2 && UCF_Listbox_Items["sGetItemId"](oItem2));
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bEqual"] = 0; };

// ----- item properties ------------------------------------------------------

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 * @return {string}
 */
UCF_Listbox_Items["prototype"]["sGetItemValue"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemValue"]++; }; 
	if (oItem) {
		return (
				this["oControl"]["sFirstValueVisibility"] === 'VISIBLE' ||
				this["oControl"]["sSecondValueVisibility"] === 'NONE'
			)
			? this["sGetItemValue1"](oItem)
			: this["sGetItemValue2"](oItem);
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemValue"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 * @return {string}
 */
UCF_Listbox_Items["prototype"]["sGetItemDescription"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemDescription"]++; }; 
	if (oItem) {
		if (this["oControl"]["sFirstValueVisibility"] === 'DESCRIPTIVE') {
			return this["sGetItemValue1"](oItem);
		} else if (this["oControl"]["sSecondValueVisibility"] === 'DESCRIPTIVE') {
			return this["sGetItemValue2"](oItem);
		} else {
			return '';
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["sGetItemDescription"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item to match with the prefix
 * @param {string} sPrefix the prefix to find in Value1 or Value2 of the item
 * @return {boolean}
 */
UCF_Listbox_Items["prototype"]["bMatches"] = function(oItem, sPrefix) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bMatches"]++; }; 
	if (oItem) {
		return (
			this["oControl"]["sFirstValueVisibility"] !== 'NONE' &&
			UCF_StringUtil["bStartsWith"](this["sGetItemValue1"](oItem), sPrefix, true)
		) || (
			this["oControl"]["sSecondValueVisibility"] !== 'NONE' &&
			UCF_StringUtil["bStartsWith"](this["sGetItemValue2"](oItem), sPrefix, true)
		);
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bMatches"] = 0; };

/**
 * @protected
 * @return {number}
 */
UCF_Listbox_Items["iGetItemHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetItemHeight"]++; }; 
	if (typeof UCF_Listbox_Items["iItemHeight"] !== 'number') {
		UCF_Listbox_Items["iItemHeight"] = parseInt(UCF_Listbox_Items["oGetMetadata"]()["itemHeight"]);
	}

	return UCF_Listbox_Items["iItemHeight"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetItemHeight"] = 0; };

// ===== item lookup ==========================================================

/**
 * @protected
 * @param {string} sId the id of the item to find
 * @return {_MaybeItem}
 */
UCF_Listbox_Items["prototype"]["oFindItemById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemById"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	return this["oCache"]["get"]('oItemById(' + sId + ')', function() {
		return self["oGetItems"]()[sId];
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemById"] = 0; };

/**
 * @protected
 * @param {string} sKey the key of the item to find
 * @return {_MaybeItem}
 */
UCF_Listbox_Items["prototype"]["oFindItemByKey"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByKey"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	return this["oCache"]["get"]('oItemByKey(' + sKey + ')', function() {
		return UCF_JsUtil["find"](
			UCF_JsUtil["values"](self["oGetItems"]()),
			function(oItem) { return self["sGetItemKey"](oItem) === sKey; }
		);
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByKey"] = 0; };

/**
 * @protected
 * @param {HTMLElement} oDomRef the element to find the item for
 * @return {_MaybeItem}
 */
UCF_Listbox_Items["prototype"]["oFindItemByDomRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByDomRef"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef, "oDomRef", "Listbox_Items.js(974): oFindItemByDomRef"); };

	return this["oFindItemById"](
		UCF_Listbox_Items["sGetItemId"](oDomRef) ||
		UCF_Listbox_Items["sGetItemId"](UCF_DomUtil["oGetParentElement"](oDomRef))
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByDomRef"] = 0; };

/**
 * @protected
 * @param {string} sPrefix the prefix to find
 * @param {number} [iStartIndex=0] index of the item to start the search at
 * (exclusive)
 * @return {_MaybeItem}
 */
UCF_Listbox_Items["prototype"]["oFindItemByPrefix"] = function(sPrefix, iStartIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByPrefix"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	return this["oCache"]["get"]('oItemByPrefix(' + sPrefix + ',' + iStartIndex + ')', function() {
		return typeof iStartIndex === 'number'
			? UCF_JsUtil["find"](
				UCF_JsUtil["values"](self["oGetItems"]())["slice"](iStartIndex + 1),
				function(oItem) { return self["bMatches"](oItem, sPrefix); }
			) || self["oFindItemByPrefix"](sPrefix)
			: UCF_JsUtil["find"](
				UCF_JsUtil["values"](self["oGetItems"]()),
				function(oItem) { return self["bMatches"](oItem, sPrefix); }
			);
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByPrefix"] = 0; };

// ----- state-based find -----------------------------------------------------

/**
 * @protected
 * @param {_MaybeItem} oItem the item to start the search from
 * @param {number} iIndexOffset the offset relative to oItem
 * @param {Array<number>} aIncludes the states to include into the search
 * @param {Array<number>} aExcludes the states to exclude from the search
 * @param {boolean} [bExact=false] `true` to find items only with the exact
 * `iIndexOffset`, `false` to find the item closest to `iIndexOffset`
 * @see #aFindItemsByState
 * @return {_MaybeItem}
 */
UCF_Listbox_Items["prototype"]["oFindItemByIndexOffsetAndStates"] = function(oItem, iIndexOffset, aIncludes, aExcludes, bExact) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByIndexOffsetAndStates"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;
	/** @type {Array<_MaybeItem>} */
	var aItems = this["aFindItemsByStates"](aIncludes, aExcludes);
	/** @type {number} */
	var iItemIndex;
	/** @type {number} */
	var iTargetIndex;

	// CSN 2070154475: searching for enabled items relative to a disabled item
	// didn't work because the disabled item was not found in
	// this.aFindItemsByStates(...) => always include the starting item (but only
	// add it if it is not contained already)
	if (
		iIndexOffset !== 0 &&
		!UCF_JsUtil["contains"](UCF_JsUtil["map"](aItems, function(a) {
			return UCF_Listbox_Items["sGetItemId"](a);
		}), UCF_Listbox_Items["sGetItemId"](oItem))
	) {
		aItems["push"](oItem);
	}

	// aFindItemsByStates() may return an arbitrary order => ensure order by index
	aItems["sort"](function(a, b) {
		return self["iGetItemIndex"](a) - self["iGetItemIndex"](b);
	});

	iItemIndex = UCF_JsUtil["indexOf"](
		UCF_JsUtil["map"](aItems, function(a) { return self["iGetItemIndex"](a); }),
		this["iGetItemIndex"](oItem)
	);

	iTargetIndex = bExact
		? iItemIndex + iIndexOffset
		: iIndexOffset > 0
		? Math["min"](iItemIndex + iIndexOffset, aItems["length"] - 1)
		: Math["max"](iItemIndex + iIndexOffset, 0);

	return -1 < iItemIndex
		&& -1 < iTargetIndex
		&& iTargetIndex < aItems["length"]
		&& aItems[iTargetIndex];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByIndexOffsetAndStates"] = 0; };

/**
 * @protected
 * @param {number} iState the state to find
 * @return {Array<_MaybeItem>}
 */
UCF_Listbox_Items["prototype"]["aFindItemsByState"] = function(iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["aFindItemsByState"]++; }; 
	return this["aFindItemsByStates"]([iState], []);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["aFindItemsByState"] = 0; };

/**
 * @example
 * // given items i1, i2 (selected), i3 (hidden), and i4 (selected + hidden)
 * this.aFindItemsByState([UCF_Listbox_Items.STATE.Selected]) // => [i2,i4]
 * this.aFindItemsByState(
 *   [UCF_Listbox_Items.STATE.Selected],
 *   [UCF_Listbox_Items.STATE.Hidden]
 * ) // => [i2]
 * this.aFindItemsByState(null, [UCF_Listbox_Items.STATE.Hidden]) // => [i1,i2]
 * this.aFindItemsByState([], [UCF_Listbox_Items.STATE.Hidden]) // => [i1,i2]
 *
 * @protected
 * @param {Array<number>} [aIncludes] list of states that must all be applied
 * on the item to contain it in the result. if not specified, all states that
 * are not in the aExcludes are considered as aIncludes.
 * @param {Array<number>} [aExcludes] list of states that all must not be
 * applied on the item to contain it in the result
 * @return {Array<_MaybeItem>} list of all items that match all aIncludes
 * and not any of the aExcludes
 */
UCF_Listbox_Items["prototype"]["aFindItemsByStates"] = function(aIncludes, aExcludes) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["aFindItemsByStates"]++; }; 
	/** @type {Array<number>} */
	var aIncludesRest;

	if (UCF_JsUtil["bIsArray"](aIncludes) && aIncludes["length"] > 0) {
		aIncludesRest = aIncludes["slice"](1);

		return UCF_JsUtil["reduce"](
			UCF_JsUtil["values"](this["oGetStates"]()[aIncludes[0]]),
			function(aItems, oItem) {
				if (
					UCF_JsUtil["every"](
						aIncludesRest,
						function(iState) {
							return UCF_Listbox_Items["bHasItemState"](oItem, iState);
						}
					) &&
					UCF_JsUtil["every"](
						aExcludes || [],
						function(iState) {
							return !UCF_Listbox_Items["bHasItemState"](oItem, iState);
						}
					)
				) {
					aItems["push"](oItem);
				}

				return aItems;
			}, []
		);
	} else {
		return UCF_JsUtil["reduce"](
			UCF_JsUtil["values"](this["oGetItems"]()),
			function(aItems, oItem) {
				if (UCF_JsUtil["every"](
						aExcludes,
						function(iState) {
							return !UCF_Listbox_Items["bHasItemState"](oItem, iState);
						}
					)) {
					aItems["push"](oItem);
				}

				return aItems;
			}, []
		);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["aFindItemsByStates"] = 0; };

// ----- index-based find -----------------------------------------------------

/**
 * @protected
 * @param {number} iIndex the index
 * @return {_MaybeItem}
 */
UCF_Listbox_Items["prototype"]["oFindItemByIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByIndex"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	return this["oCache"]["get"]('oItemByIndex(' + iIndex + ')', function() {
		return self["oFindItemById"](
			UCF_Listbox_Items["sGetItemId"](self["oFindItemValueRefByIndex"](iIndex))
		);
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByIndex"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 * @param {number} iIndexOffset the offset relative to the index of oItem
 * @return {_MaybeItem}
 */
UCF_Listbox_Items["prototype"]["oFindItemByIndexOffset"] = function(oItem, iIndexOffset) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByIndexOffset"]++; }; 
	return oItem
		&& this["oFindItemByIndex"](
			this["iGetItemIndex"](oItem) + iIndexOffset
		);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemByIndexOffset"] = 0; };

/**
 * @private
 * @param {number} iIndex the index
 * @return {HTMLDivElement} the first value of the item with the given index
 */
UCF_Listbox_Items["prototype"]["oFindItemValueRefByIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemValueRefByIndex"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	return this["oCache"]["get"]('oItemValueRefByIndex(' + iIndex + ')', function() {
		self["fireWillAccessDom"]();

		return UCF_DomUtil["querySelector"](
			'[id="' + self["oControl"]["sId"] + '"] [data-itemindex="' + iIndex + '"]'
		);
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oFindItemValueRefByIndex"] = 0; };

/**
 * @protected
 * @param {number} [iFrom=0] start index of the range, inclusive
 * @param {number} [iTo=this.iGetItemCount()] end index of the range, inclusive
 * @return {Array<_MaybeItem>}
 */
UCF_Listbox_Items["prototype"]["aFindItemsByIndexRange"] = function(iFrom, iTo) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["aFindItemsByIndexRange"]++; }; 
	/** @type {number} */
	var iItemCount = this["iGetItemCount"]();
	/** @type {Array<_MaybeItem>} */
	var aItems = [];
	/** @type {HTMLDivElement} */
	var oCurrentRef;

	iTo = isNaN(iTo) ? iItemCount : Math["max"](0, Math["min"](iTo, iItemCount));
	iFrom = isNaN(iFrom) ? 0 : Math["min"](Math["max"](0, iFrom), iTo);
	oCurrentRef = this["oFindItemValueRefByIndex"](iFrom);

	while (oCurrentRef && this["iGetItemIndex"](oCurrentRef) <= iTo) {
		aItems["push"](this["oFindItemByDomRef"](oCurrentRef));
		oCurrentRef = UCF_DomUtil["nextSibling"](oCurrentRef, 'DIV');
	}

	return aItems;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["aFindItemsByIndexRange"] = 0; };

// ----- delete ---------------------------------------------------------------

/**
 * @protected
 * @param {_MaybeItem} oItem the item to delete
 */
UCF_Listbox_Items["prototype"]["deleteItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["deleteItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	if (!UCF_JsUtil["bIsEmpty"](this["mDeleteAnimations"])) {
		UCF_JsUtil["forEach"](UCF_JsUtil["entries"](this["mDeleteAnimations"]), function(aAnimation) {
			UCF_JsUtil["clearDelayedCall"](aAnimation[0]);
			self["deleteItemImmediate"](aAnimation[1]);
		});
		this["mDeleteAnimations"] = {};
	}

	UCF_JsUtil["forEach"](
		this["aFindItemsByIndexRange"](this["iGetItemIndex"](oItem) + 1),
		function(o) {
			UCF_Listbox_Items["setItemIndex"](
				// if we're operating on a dom element, there might still be a control
				// for it in the control factory => have to set the index for the
				// control if possible, otherwise there will be a mismatch between
				// control.iIndex and control.oDomRef.dataset.itemindex
				UCF_Listbox_Items["bIsItem"](o)
				? o
				: self["oLS"]["oControlFactory"]["oGetControlByDomRef"](o, false) || o,
				self["iGetItemIndex"](o) - 1
			);
			// index is stored in the dataset => have to reset the dataset here
			self["oCache"]["invalidate"]('oItemDataSet("' + UCF_Listbox_Items["sGetItemId"](o) + '")');
		}
	);
	// dataset is read from cache => have to reset the whole dataset cache
	this["oCache"]["invalidate"]('oItemDataSets("' + this["oControl"]["sId"] + '")');

	this["deleteItemAnimated"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["deleteItem"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem
 */
UCF_Listbox_Items["prototype"]["deleteItemAnimated"] = UCF_Listbox_Items["iGetItemDeleteAnimationDurationMs"]() > 0
	? function(oItem) {
		var iItemDeleteAnimationDurationMs = UCF_Listbox_Items["iGetItemDeleteAnimationDurationMs"]();

		this["fireWillDeleteItemAnimated"](oItem);

		this["addState"](oItem, UCF_Listbox_Items["STATE"]["Deleted"]);

		this["mDeleteAnimations"][UCF_JsUtil["delayedCall"](
			iItemDeleteAnimationDurationMs,
			this,
			'onDidDeleteItemAnimated',
			[oItem]
		)] = oItem;
	}
	: function(oItem) {
		this["fireWillDeleteItemAnimated"](oItem);
		this["deleteItemImmediate"](oItem);
	};

/**
 * @private
 * @param {_MaybeItem} oItem
 */
UCF_Listbox_Items["prototype"]["onDidDeleteItemAnimated"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["onDidDeleteItemAnimated"]++; }; 
	this["mDeleteAnimations"][
		UCF_JsUtil["find"](
			UCF_JsUtil["entries"](this["mDeleteAnimations"]),
			function(_) { return _[1] === oItem; }
		)[0]
	] = undefined;
	this["deleteItemImmediate"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["onDidDeleteItemAnimated"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem
 */
UCF_Listbox_Items["prototype"]["deleteItemImmediate"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["deleteItemImmediate"]++; }; 
	UCF_Listbox_Items["removeItemFromDom"](oItem);
	this["oCache"]["invalidate"]();
	this["buildStates"]();
	this["fireDidDeleteItemAnimated"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["deleteItemImmediate"] = 0; };

// ===== state ================================================================

/**
 * @private
 * @return {Object<number,Object<string,_MaybeItem>>}
 */
UCF_Listbox_Items["prototype"]["oGetStates"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetStates"]++; }; 
	if (!this["oStates"]) {
		this["buildStates"]();
	}

	return this["oStates"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["oGetStates"] = 0; };

/** @private */
UCF_Listbox_Items["prototype"]["buildStates"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["buildStates"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	this["oStates"] = {};
	UCF_JsUtil["forEach"](
		UCF_JsUtil["values"](UCF_Listbox_Items["STATE"]),
		function(iState) { self["oStates"][iState] = {}; }
	);
	this["oGetItems"](); // trigger filling this.oStates
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["buildStates"] = 0; };

/**
 * @protected
 * @param {number} iState the state to clear
 */
UCF_Listbox_Items["prototype"]["clearState"] = function(iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["clearState"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	UCF_JsUtil["forEach"](
		UCF_JsUtil["values"](this["oGetStates"]()[iState]),
		function(oItem) { self["removeState"](oItem, iState); }
	);

	this["fireStateChange"](iState);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["clearState"] = 0; };

// ----- add ------------------------------------------------------------------

/**
 * @protected
 * @param {string|_MaybeItem} oItem the item to add the state to
 * @param {number} iState the state to add
 */
UCF_Listbox_Items["prototype"]["addState"] = function(oItem, iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["addState"]++; }; 
	if (typeof oItem === 'string') {
		oItem = this["oFindItemById"](oItem);
	}
	if (UCF_Listbox_Items["bHasItemStateChangeEffectOnControltree"](iState)) {
		oItem = this["oToItem"](oItem);
	}

	this["pushState"](oItem, iState);
	UCF_Listbox_Items["addItemState"](oItem, iState);

	this["fireStateChange"](iState);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["addState"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem the item to add the state to
 * @param {number} iState the state to store
 */
UCF_Listbox_Items["prototype"]["pushState"] = function(oItem, iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["pushState"]++; }; 
	this["oGetStates"]()[iState][UCF_Listbox_Items["sGetItemId"](oItem)] = oItem;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["pushState"] = 0; };

// ----- remove ---------------------------------------------------------------

/**
 * @protected
 * @param {string|_MaybeItem} oItem the item to remove the state from
 * @param {number} iState the state to remove from the item
 */
UCF_Listbox_Items["prototype"]["removeState"] = function(oItem, iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["removeState"]++; }; 
	if (typeof oItem === 'string') {
		oItem = this["oFindItemById"](oItem);
	}
	if (UCF_Listbox_Items["bHasItemStateChangeEffectOnControltree"](iState)) {
		oItem = this["oToItem"](oItem);
	}

	this["popState"](oItem, iState);
	UCF_Listbox_Items["removeItemState"](oItem, iState);

	this["fireStateChange"](iState);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["removeState"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem the item to remove the state from
 * @param {number} iState the state to remove
 */
UCF_Listbox_Items["prototype"]["popState"] = function(oItem, iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["popState"]++; }; 
	delete this["oGetStates"]()[iState][UCF_Listbox_Items["sGetItemId"](oItem)];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["popState"] = 0; };

// ----- has ------------------------------------------------------------------

/**
 * @protected
 * @param {string|_MaybeItem} oItem the item to get the state info for
 * @param {number} iState the state to get
 * @return {boolean} `true` if the item has the state, otherwise `false`
 */
UCF_Listbox_Items["prototype"]["bHasState"] = function(oItem, iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bHasState"]++; }; 
	return (typeof oItem === 'string'
		? oItem
		: UCF_Listbox_Items["sGetItemId"](oItem)
	) in this["oGetStates"]()[iState];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bHasState"] = 0; };

// ----- writeable shorthand --------------------------------------------------

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 * @return {boolean}
 */
UCF_Listbox_Items["prototype"]["bIsWriteable"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bIsWriteable"]++; }; 
	return this["bIsNotIgnored"](oItem, UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bIsWriteable"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem the item
 * @param {Array<number>} aIgnoredStates the states to ignore
 * @return {boolean}
 */
UCF_Listbox_Items["prototype"]["bIsNotIgnored"] = function(oItem, aIgnoredStates) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bIsNotIgnored"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	return oItem
		&& UCF_JsUtil["every"](
			aIgnoredStates,
			function(iState) { return !self["bHasState"](oItem, iState); }
		);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bIsNotIgnored"] = 0; };

// ----- focusable shorthand --------------------------------------------------

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 * @return {boolean}
 */
UCF_Listbox_Items["prototype"]["bIsFocusable"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bIsFocusable"]++; }; 
	return this["bIsNotIgnored"](oItem, UCF_Listbox_Items["IGNORED_FOCUSABLE_STATES"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["bIsFocusable"] = 0; };

// ===== events ===============================================================

/** @private */
UCF_Listbox_Items["prototype"]["fireWillAccessDom"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["fireWillAccessDom"]++; }; 
	this["fireEvent"](UCF_Listbox_Items["EVENT"]["WillAccessDom"], {});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["fireWillAccessDom"] = 0; };

/**
 * @private
 * @param {number} iState the state that changed
 */
UCF_Listbox_Items["prototype"]["fireStateChange"] = function(iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["fireStateChange"]++; }; 
	this["fireEventAsync"](UCF_Listbox_Items["EVENT"]["StateChange"], { "iState": iState });
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["fireStateChange"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem
 */
UCF_Listbox_Items["prototype"]["fireWillDeleteItemAnimated"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["fireWillDeleteItemAnimated"]++; }; 
	this["fireEvent"](UCF_Listbox_Items["EVENT"]["WillDeleteItemAnimated"], { "oItem": oItem });
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["fireWillDeleteItemAnimated"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem
 */
UCF_Listbox_Items["prototype"]["fireDidDeleteItemAnimated"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["fireDidDeleteItemAnimated"]++; }; 
	this["fireEvent"](UCF_Listbox_Items["EVENT"]["DidDeleteItemAnimated"], { "oItem": oItem });
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["fireDidDeleteItemAnimated"] = 0; };

/**
 * @private
 * @param {number} iEvent the id of the event
 * @param {Object} oPayload the payload for the event
 */
UCF_Listbox_Items["prototype"]["fireEventAsync"] = function(iEvent, oPayload) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["fireEventAsync"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	this["requestAnimationFrame"](
		function() { self["fireEvent"](iEvent, oPayload); },
		'fireEvent:' + iEvent + ':' + UCF_JsUtil["sJsonStringify"](oPayload)
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["fireEventAsync"] = 0; };

// ===== scrolling ============================================================

/**
 * @protected
 * @return {number}
 */
UCF_Listbox_Items["prototype"]["iGetScrollTop"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetScrollTop"]++; }; 
	return this["oGetScrollRef"]()["scrollTop"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetScrollTop"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_Items["prototype"]["scrollIntoView"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["scrollIntoView"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;
	/** @type {HTMLDivElement} */
	var oDomRef;
	/** @type {_MaybeItem} */
	var oItemBefore;

	// scroll visible but not focusable items directly above the item into view
	// as well
	if (this["iGetItemIndex"](oItem) > 0) {
		oItemBefore = this["oFindItemByIndexOffsetAndStates"](
			oItem,
			-1,
			[],
			UCF_Listbox_Items["IGNORED_FOCUSABLE_STATES"]
		);

		oItem = (oItemBefore && oItemBefore !== oItem)
			? this["oFindItemByIndexOffsetAndStates"](oItemBefore, 1, [], [
				UCF_Listbox_Items["STATE"]["Deleted"],
				UCF_Listbox_Items["STATE"]["Hidden"]
			])
			: this["oFindItemByIndex"](0);
	}

	oDomRef = UCF_Listbox_Items["bIsItem"](oItem) ? oItem["oDomRef"] : oItem;

	this["requestAnimationFrame"](function() {
		/** @type {HTMLDivElement} */
		var oScrollRef;
		/** @type {number} */
		var iScrollTop;
		/** @type {number} */
		var iClientHeight;
		/** @type {number} */
		var iOffsetTop;
		/** @type {number} */
		var iOffsetHeight;

		if (oDomRef) {
			oScrollRef = self["oGetScrollRef"]();
			iScrollTop = self["iGetScrollTop"]();
			iClientHeight = oScrollRef["clientHeight"];
			iOffsetTop = oDomRef["offsetTop"];
			iOffsetHeight = oDomRef["offsetHeight"];

			if (iOffsetTop < iScrollTop || iScrollTop + iClientHeight <= iOffsetTop + iOffsetHeight) {
				oScrollRef["scrollTop"] = iOffsetTop;
			}
		}
	}, 'scrollIntoView');
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["scrollIntoView"] = 0; };

/**
 * @protected
 * @see {@link UCF_Listbox#initialize}
 */
UCF_Listbox_Items["prototype"]["applyItemsRefWidthToScrollRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["applyItemsRefWidthToScrollRef"]++; }; 
	/** @type {HTMLDivElement} */
	var oScrollRef = this["oGetScrollRef"]();
	/** @type {number} */
	var iItemsRefWidthPx;
	/** @type {UCF_Listbox_Items} */
	var self;

	if (oScrollRef["offsetParent"] && this["oGetItemsRef"]() !== oScrollRef) {
		iItemsRefWidthPx = this["iGetItemsRefWidthPx"]();

		if (iItemsRefWidthPx !== oScrollRef["offsetWidth"]) {
			self = this;

			UCF_DomUtil["setStyle"](oScrollRef, {
				"width": this["iGetItemsRefWidthPx"]() + 'px'
			});

			this["requestAnimationFrame"](function() {
				self["oControl"]["notifyLayoutChangeFrom"]();
			}, 'notifyLayoutChangeFrom');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["applyItemsRefWidthToScrollRef"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Listbox_Items["prototype"]["iGetItemsRefWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetItemsRefWidthPx"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;
	/** @type {number} */
	var iItemsRefWidthPx = this["oCache"]["get"]('iItemsRefWidthPx', function() {
		/** @type {HTMLDivElement} */
		var oScrollRef = self["oGetScrollRef"]();

		UCF_DomUtil["setStyle"](oScrollRef, 'width', '');

		return Math["max"](
			UCF_JsUtil["reduce"](
				UCF_JsUtil["arrayFrom"](self["oGetItemsRef"]()["childNodes"]),
				function(iWidth, oValuesRef) {
					return iWidth + (oValuesRef["firstElementChild"]
						? oValuesRef["firstElementChild"]["scrollWidth"]
						: 0);
				},
				0
			) + (oScrollRef["offsetWidth"] - oScrollRef["clientWidth"]),
			self["oControl"]["oRootRef"]["scrollWidth"]
		);
	});

	if (iItemsRefWidthPx === 0) {
		this["oCache"]["invalidate"]('iItemsRefWidthPx');
	}

	return iItemsRefWidthPx;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetItemsRefWidthPx"] = 0; };

/**
 * @protected
 * @see {@link UCF_Listbox#initialize}
 */
UCF_Listbox_Items["prototype"]["applyGroupTitlesMinWidthToScrollRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["applyGroupTitlesMinWidthToScrollRef"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self;
	/** @type {number} */
	var iGroupTitlesMinWidthPx;
	/** @type {HTMLDivElement} */
	var oScrollRef;
	/** @type {number} */
	var iScrollRefMinWidthPx;

	if (this["aFindItemsByState"](UCF_Listbox_Items["STATE"]["Group"])["length"] > 0) {
		iGroupTitlesMinWidthPx = this["iGetGroupTitlesMinWidthPx"]();
		oScrollRef = this["oGetScrollRef"]();
		iScrollRefMinWidthPx = parseInt(oScrollRef["style"]["minWidth"]);

		if (
			isNaN(iScrollRefMinWidthPx) ||
			iGroupTitlesMinWidthPx < iScrollRefMinWidthPx
		) {
			self = this;

			UCF_DomUtil["setStyle"](oScrollRef, 'minWidth', iGroupTitlesMinWidthPx + 'px');

			this["requestAnimationFrame"](function() {
				self["oControl"]["notifyLayoutChangeFrom"]();
			}, 'notifyLayoutChangeFrom');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["applyGroupTitlesMinWidthToScrollRef"] = 0; };

/**
 * @static
 * @param {function(HTMLDivElement, HTMLDivElement): void} fnCreate
 * @return {number}
 */
UCF_Listbox_Items["iMeasureListboxWidthPx"] = function(fnCreate) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iMeasureListboxWidthPx"]++; }; 
	/** @type {HTMLDivElement} */
	var oRootRef = document["createElement"]('div');
	/** @type {HTMLDivElement} */
	var oItemsRef = document["createElement"]('div');
	/** @type {number} */
	var iWidth;

	UCF_DomUtil["setClass"](oRootRef, 'lsListbox');
	UCF_DomUtil["setStyle"](oRootRef, {
		"position": 'absolute',
		"top": '-10000px',
		"left": '-10000px',
		"display": 'block'
	});

	UCF_DomUtil["setClass"](oItemsRef, 'lsListbox__items');
	UCF_DomUtil["append"](oRootRef, oItemsRef);

	fnCreate(oItemsRef, oRootRef);

	UCF_DomUtil["prepend"](document["body"], oRootRef);

	iWidth = UCF_Listbox_Items["iGetRefWidthPx"](oRootRef) + UCF_DomUtil["iGetScrollbarWidth"]();

	UCF_DomUtil["removeFromDom"](oRootRef);

	return iWidth;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iMeasureListboxWidthPx"] = 0; };

/**
 * @private
 * @static
 * @param {HTMLElement} oRef
 * @return {number}
 */
UCF_Listbox_Items["iGetRefWidthPx"] = function(oRef) {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetRefWidthPx"]++; }; 
	/** @type {DOMRect} */
	var oBoundingClientRect = oRef["getBoundingClientRect"]();

	return Math["max"](
		typeof oBoundingClientRect["width"] === 'number' ? Math["ceil"](oBoundingClientRect["width"]) : 0,
		oRef["scrollWidth"],
		oRef["offsetWidth"],
		oRef["clientWidth"]
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetRefWidthPx"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Listbox_Items["prototype"]["iGetGroupTitlesMinWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetGroupTitlesMinWidthPx"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var self = this;

	return this["oCache"]["get"]('iGroupTitlesMinWidthPx', function() {
		/** @type {_MaybeItem[]} */
		var aGroups = self["aFindItemsByState"](UCF_Listbox_Items["STATE"]["Group"]);

		return UCF_Listbox_Items["iMeasureListboxWidthPx"](function(oItemsRef) {
			/** @type {HTMLElement} */
			var oValuesRef = document["createElement"]('div');

			UCF_DomUtil["setClass"](oValuesRef, 'lsListbox__values lsListbox__values--first');

			UCF_JsUtil["forEach"](aGroups, function(oGroup) {
				/** @type {HTMLDivElement} */
				var oValueRef = document["createElement"]('div');

				UCF_DomUtil["setClass"](oValueRef, 'lsListbox__value lsListbox__value--group');
				oValueRef["textContent"] = self["sGetItemGroupTitle"](oGroup);

				UCF_DomUtil["append"](oValuesRef, oValueRef);
			});

			UCF_DomUtil["append"](oItemsRef, oValuesRef);
		});
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Items["_"]["iGetGroupTitlesMinWidthPx"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_JsonItems"] = function() {/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Listbox_Items */
/// <reference path="./Listbox_Items.js"/>

/**
 * @class UCF_Listbox_JsonItems
 * @extends UCF_Listbox_Items
 * @param {UCF_Listbox_JsonPopup} oControl the listbox
 */
function UCF_Listbox_JsonItems(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_JsonItems["_"]["UCF_Listbox_JsonItems"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox_Items["apply"](this, arguments);
	}
};window["UCF_Listbox_JsonItems"] = UCF_Listbox_JsonItems; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_JsonItems"); UCF_Listbox_JsonItems["_"] = {UCF_Listbox_JsonItems: 0}; }; ;
UCF_Listbox_JsonItems["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_Items"))(); UCF_Listbox_JsonItems.prototype["sClassName"] = "UCF_Listbox_JsonItems";

/**
 * @override
 * @param {_MaybeItem} oItem
 * @return {string}
 */
UCF_Listbox_JsonItems["prototype"]["sGetItemValue"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonItems["_"]["sGetItemValue"]++; }; 
	/** @type {UCF_Listbox_JsonItems} */
	var self = this;
	/** @type {string} */
	var sKey = this["sGetItemKey"](oItem);

	return this["oCache"]["get"]('sItemValue(' + sKey + ')', function() {
		/** @type {UCF_Listbox_JsonModel_Item} */
		var aItem = self["aFindItemByKey"](sKey);
		/** @type {UCF_Listbox_JsonModel} */
		var oModel;
		/** @type {UCF_Listbox_JsonModel_Value} */
		var oValue;

		if (aItem) {
			oModel = self["oControl"]["oGetModel"]();
			if (oModel["bValid"]) {
				oValue = aItem[oModel["iValueColumnIndex"]];

				return typeof oValue === 'string' ? oValue : oValue["Value"];
			} else {
				return null;
			}
		} else {
			return null;
		}
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonItems["_"]["sGetItemValue"] = 0; };

/**
 * @private
 * @param {string} sKey
 * @return {UCF_Listbox_JsonModel_Item}
 */
UCF_Listbox_JsonItems["prototype"]["aFindItemByKey"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonItems["_"]["aFindItemByKey"]++; }; 
	/** @type {UCF_Listbox_JsonItems} */
	var self = this;

	return this["oCache"]["get"]('aItemByKey(' + sKey + ')', function() {
		/** @type {UCF_Listbox_JsonModel} */
		var oModel = self["oControl"]["oGetModel"]();

		return oModel["bValid"] ? UCF_JsUtil["find"](
			oModel["aHistoryTableData"]["concat"](oModel["aItemTableData"]),
			function(aItem) { return aItem[oModel["iKeyColumnIndex"]] === sKey; }
		) : null;
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonItems["_"]["aFindItemByKey"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_JsonModel"] = function() {/* global _assert, _trace, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_Listbox_JsonPopup */
/// <reference path="./Listbox_JsonPopup.js"/>
/* global UCF_Listbox_Items */
/// <reference path="./Listbox_Items.js"/>

/**
 * @typedef {Object} UCF_Listbox_JsonModel
 * @property {number} iWidthInEm
 * @property {UCF_Listbox_JsonModel_Column[]} aTableDataDefinition
 * @property {UCF_Listbox_JsonModel_Item[]} aItemTableData
 * @property {UCF_Listbox_JsonModel_Item[]} aHistoryTableData
 */
/**
 * @typedef {Object} UCF_Listbox_JsonModel_Column
 * @property {string} Label
 * @property {number|string} Length
 * @property {'VISIBLE'|'NONE'} Visibility
 * @property {'Value'|'Key'} Type
 * @property {string} Width
 */
/**
 * @typedef {Object} UCF_Listbox_JsonModel_HighlightValue
 * @property {string} Value
 * @property {{0:number, 1:number}[]} Highlights
 */
/** @typedef {string|UCF_Listbox_JsonModel_HighlightValue} UCF_Listbox_JsonModel_Value */
/** @typedef {UCF_Listbox_JsonModel_Value[]} UCF_Listbox_JsonModel_Item */
/** @typedef {0} UCF_Listbox_JsonModel_ItemtypeSearchResult */
/** @typedef {1} UCF_Listbox_JsonModel_ItemtypeHistory */
/** @typedef {2} UCF_Listbox_JsonModel_ItemtypeGroup */
/** @typedef {3} UCF_Listbox_JsonModel_ItemtypeTableHeader */
/** @typedef {4} UCF_Listbox_JsonModel_ItemtypeHeadline */
/** @typedef {UCF_Listbox_JsonModel_ItemtypeSearchResult|UCF_Listbox_JsonModel_ItemtypeHistory|UCF_Listbox_JsonModel_ItemtypeGroup|UCF_Listbox_JsonModel_ItemtypeTableHeader|UCF_Listbox_JsonModel_ItemtypeHeadline} UCF_Listbox_JsonModel_Itemtype */
/**
 * @typedef {Object} UCF_Listbox_JsonModel_Itemtype_Enum
 * @property {UCF_Listbox_JsonModel_ItemtypeSearchResult} SearchResult
 * @property {UCF_Listbox_JsonModel_ItemtypeHistory} History
 * @property {UCF_Listbox_JsonModel_ItemtypeGroup} Group
 * @property {UCF_Listbox_JsonModel_ItemtypeTableHeader} TableHeader
 * @property {UCF_Listbox_JsonModel_ItemtypeHeadline} Headline
 */

/**
 * @constructor
 * @param {string} sTableDataDefinition
 * @param {string} sItemTableData
 * @param {string} sHistoryTableData
 */
function UCF_Listbox_JsonModel(sTableDataDefinition, sItemTableData, sHistoryTableData) {if (__UCF_COVERAGE__) { UCF_Listbox_JsonModel["_"]["UCF_Listbox_JsonModel"]++; }; 
	/** @type {UCF_Listbox_JsonModel_Metadata} */
	var oMetadata;
	/** @@type {number} */
	var iLengthSum;
	/** @type {UCF_Listbox_JsonModel} */
	var self;

	if (arguments["length"] > 0) {
		iLengthSum = 0;
		self = this;

		/** @type {boolean} */
		this["bValid"] = false;
		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

		try {
			/** @type {UCF_Listbox_JsonModel_Column[]} */
			this["aTableDataDefinition"] = UCF_JsUtil["map"](
				UCF_JsUtil["oJsonParse"](sTableDataDefinition) || [],
				function( /** @type {UCF_Listbox_JsonModel_Column} */ oCol, i) {
					if (!('Visibility' in oCol)) {
						oCol["Visibility"] = 'VISIBLE';
					}

					oCol["Length"] = typeof oCol["Length"] === 'number'
						// eslint-disable-next-line no-magic-numbers
						? Math["max"](7, Math["min"](oCol["Length"], 40))
						// eslint-disable-next-line no-magic-numbers
						: 10;

					switch (oCol["Type"]) {
						case 'Value':
							// eslint-disable-next-line no-magic-numbers
							oCol["Length"] = Math["round"](oCol["Length"] * 1.2);

							if (typeof self["iValueColumnIndex"] !== 'number') {
								self["iValueColumnIndex"] = i;
							}

							break;
						case 'Key':
							self["iKeyColumnIndex"] = i;
							break;
					}

					if (oCol["Visibility"] !== 'NONE') {
						iLengthSum += oCol["Length"];
					}

					return oCol;
				}
			);
			UCF_JsUtil["forEach"](this["aTableDataDefinition"], function(oCol, i) {
				if (oCol["Visibility"] !== 'NONE') {
					// eslint-disable-next-line no-magic-numbers
					oCol["Width"] = (oCol["Length"] / iLengthSum * 100) + '%';
				}
			});

			/** @type {UCF_Listbox_JsonModel_Item[]} */
			this["aItemTableData"] = UCF_JsUtil["oJsonParse"](sItemTableData) || [];
			/** @type {UCF_Listbox_JsonModel_Item[]} */
			this["aHistoryTableData"] = UCF_JsUtil["oJsonParse"](sHistoryTableData) || [];
			/** @type {boolean} */
			this["bHistoryOnly"] = sItemTableData === '';

			oMetadata = UCF_Listbox_Items["oGetMetadata"]();
			/** @type {string} */ // eslint-disable-next-line no-magic-numbers
			this["sWidthInEm"] = Math["ceil"]((iLengthSum / 1.618) * (oMetadata["itemFontSize"] / oMetadata["itemHeight"])) + 'em';
			/** @type {number} */
			this["iCtColumnIndex"] = UCF_JsUtil["reduce"](this["aTableDataDefinition"], function(iIndex, oCol, i) {
				return iIndex === -1
					? (oCol["Visibility"] === 'NONE' ? iIndex : i)
					: iIndex;
			}, -1);
			/** @type {number} */
			this["iLength"] = this["aItemTableData"]["length"] + this["aHistoryTableData"]["length"];
			/** @type {boolean} */
			this["bHasDeleteColumn"] = this["iCtColumnIndex"] > -1 && this["aHistoryTableData"]["length"] > 0;

			// keep this at the end of the try/catch. only if nothing was thrown,
			// the model is valid
			this["bValid"] = true;
		} catch (e) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, e["message"], "Listbox_JsonModel.js(147): UCF_Listbox_JsonModel"); };
		}
	}
};window["UCF_Listbox_JsonModel"] = UCF_Listbox_JsonModel; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_JsonModel"); UCF_Listbox_JsonModel["_"] = {UCF_Listbox_JsonModel: 0}; }; ;
UCF_Listbox_JsonModel["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Listbox_JsonModel.prototype["sClassName"] = "UCF_Listbox_JsonModel";

/** @override */
UCF_Listbox_JsonModel["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonModel["_"]["destroy"]++; }; 
	if (this["oCache"]) {
		this["oCache"]["destroy"]();
		this["oCache"] = null;
	}
	this["aTableDataDefinition"] = null;
	this["aItemTableData"] = null;
	this["aHistoryTableData"] = null;
	this["bHistoryOnly"] = null;
	this["bHasDeleteColumn"] = null;
	this["iCtColumnIndex"] = null;
	this["iValueColumnIndex"] = null;
	this["iKeyColumnIndex"] = null;
	this["iLength"] = null;
	this["sWidthInEm"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonModel["_"]["destroy"] = 0; };

/**
 * @protected
 * @static
 * @param {string} sHeadlineText
 * @return {number}
 */
UCF_Listbox_JsonModel["iGetHeadlineMinWidthPx"] = function(sHeadlineText) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonModel["_"]["iGetHeadlineMinWidthPx"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sHeadlineText === 'string', "typeof sHeadlineText === 'string'", "Listbox_JsonModel.js(180): iGetHeadlineMinWidthPx"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHeadlineText !== '', "sHeadlineText !== ''", "Listbox_JsonModel.js(181): iGetHeadlineMinWidthPx"); };

	if (typeof UCF_Listbox_JsonModel["iHeadlineMinWidthPx"] !== 'number') {
		UCF_Listbox_JsonModel["iHeadlineMinWidthPx"] = UCF_Listbox_Items["iMeasureListboxWidthPx"](function(oItemsRef, oRootRef) {
			/** @type {HTMLDivElement} */
			var oValuesRef = document["createElement"]('div');
			/** @type {HTMLDivElement} */
			var oHeadlineRef = document["createElement"]('div');

			UCF_DomUtil["addClass"](oRootRef, 'lsListbox--popup lsListbox--jsonpopup');

			UCF_DomUtil["setClass"](oValuesRef, 'lsListbox__values lsListbox__values--first');
			UCF_DomUtil["append"](oItemsRef, oValuesRef);

			UCF_DomUtil["setClass"](oHeadlineRef, 'lsListbox__value lsListbox__value--headline');
			UCF_DomUtil["setInnerText"](oHeadlineRef, sHeadlineText);
			UCF_DomUtil["append"](oValuesRef, oHeadlineRef);
		});
	}

	return UCF_Listbox_JsonModel["iHeadlineMinWidthPx"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonModel["_"]["iGetHeadlineMinWidthPx"] = 0; };

/**
 * @protected
 * @return {number}
 */
UCF_Listbox_JsonModel["prototype"]["iGetHistoryMinWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonModel["_"]["iGetHistoryMinWidthPx"]++; }; 
	/** @type {UCF_Listbox_JsonModel} */
	var self = this;

	return this["oCache"]["get"]('iHistoryMinWidth', function() {
		return self["aHistoryTableData"]["length"] === 0
			? 0
			: UCF_Listbox_Items["iMeasureListboxWidthPx"](function(oItemsRef, oRootRef) {
				/** @type {HTMLDivElement} */
				var oValuesRef;
				/** @type {HTMLDivElement} */
				var oDeletesRef;

				UCF_DomUtil["addClass"](oRootRef, 'lsListbox--popup lsListbox--jsonpopup');

				oValuesRef = document["createElement"]('div');
				UCF_DomUtil["setClass"](oValuesRef, 'lsListbox__values lsListbox__values--first');

				oDeletesRef = document["createElement"]('div');
				UCF_DomUtil["setClass"](oDeletesRef, 'lsListbox__values lsListbox__values--delete');

				UCF_JsUtil["forEach"](self["aHistoryTableData"], function(oRow) {
					/** @type {UCF_Listbox_JsonModel_HighlightValue} */
					var oValue = oRow[self["iValueColumnIndex"]];
					/** @type {HTMLDivElement} */
					var oValueRef = document["createElement"]('div');
					/** @type {HTMLDivElement} */
					var oDeleteRef = document["createElement"]('div');

					UCF_DomUtil["setClass"](oValueRef, 'lsListbox__value lsListbox__value--history lsListbox__value--deletable');
					UCF_DomUtil["setClass"](oDeleteRef, 'lsListbox__value lsListbox__value--history lsListbox__value--deletable');

					if (typeof oValue === 'string') {
						UCF_DomUtil["setInnerText"](oValueRef, oValue);
					} else {
						// eslint-disable-next-line no-unsanitized/property
						UCF_DomUtil["setInnerHtml"](oValueRef, UCF_Listbox_JsonPopup["sHighlightValueHtml"](oValue));
					}

					UCF_DomUtil["append"](oValuesRef, oValueRef);
					UCF_DomUtil["append"](oDeletesRef, oDeleteRef);
				});

				UCF_DomUtil["append"](oItemsRef, oValuesRef);
				UCF_DomUtil["append"](oItemsRef, oDeletesRef);
			});
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonModel["_"]["iGetHistoryMinWidthPx"] = 0; };

/** @type {UCF_Listbox_JsonModel_Itemtype_Enum} */
UCF_Listbox_JsonModel["ITEMTYPE"] = {
	"SearchResult": 0,
	"History": 1,
	"Group": 2,
	"TableHeader": 3,
	"Headline": 4
};

};
sap["ls"]["preload"]["UCF_Listbox_JsonPopup"] = function() {/* global _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_RenderManager */
/// <reference path="../core/RenderManager.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Listbox_Items */
/// <reference path="./Listbox_Items.js"/>
/* global UCF_Listbox_JsonItems */
/// <reference path="./Listbox_JsonItems.js"/>
/* global UCF_Listbox_JsonModel */
/// <reference path="./Listbox_JsonModel.js"/>
/* global UCF_Listbox_Popup */
/// <reference path="./Listbox_Popup.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * @class UCF_Listbox_JsonPopup
 * @extends UCF_Listbox_Popup
 * @depends UCF_Listbox_JsonModel
 * @param {HTMLDivElement} oDomRef the dom element
 * @param {UCF_LS} oLS the lightspeed instance
 */
function UCF_Listbox_JsonPopup(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["UCF_Listbox_JsonPopup"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox_Popup["apply"](this, [oDomRef, oLS]);

		/**
		 * @see {@link UCF_SuggestBox#open}
		 * @type {boolean}
		 */
		this["oTableData"] = true;

		/**
		 * @see {@link UCF_Listbox_JsonPopup#applyWidth}
		 * @see {@link UCF_Listbox_JsonPopup#render}
		 * @type {number}
		 */
		this["iMinWidthPx"] = 0;
	}
};window["UCF_Listbox_JsonPopup"] = UCF_Listbox_JsonPopup; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_JsonPopup"); UCF_Listbox_JsonPopup["_"] = {UCF_Listbox_JsonPopup: 0}; }; ;
UCF_Listbox_JsonPopup["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_Popup"))(); UCF_Listbox_JsonPopup.prototype["sClassName"] = "UCF_Listbox_JsonPopup";

/** @const {number} */
UCF_Listbox_JsonPopup["DELETE_COLUMNINDEX"] = -1;

/** @override */
UCF_Listbox_JsonPopup["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["destroy"]++; }; 
	this["iMinWidthPx"] = null;

	if (this["oCache"]["has"]('oModel')) {
		this["oGetModel"]()["destroy"]();
	}

	UCF_Listbox_Popup.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["destroy"] = 0; };

/** @private */
UCF_Listbox_JsonPopup["prototype"]["ensureRendered"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["ensureRendered"]++; }; 
	if (!this["bIsRendered"]()) {
		this["render"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["ensureRendered"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_Listbox_JsonPopup["prototype"]["bIsRendered"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["bIsRendered"]++; }; 
	return this["oGetItemsManager"]()["oGetItemsRef"]()["children"]["length"] > 0;
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["bIsRendered"] = 0; };

/**
 * @private
 * @param {number} iIndex
 * @return {boolean}
 */
UCF_Listbox_JsonPopup["prototype"]["bIsDeleteColumnIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["bIsDeleteColumnIndex"]++; }; 
	/** @type {number} */
	var iVisibleColumnCount = this["aGetVisibleColumnIndices"]()["length"];

	return iVisibleColumnCount > 1
		? iIndex === iVisibleColumnCount
		: iIndex === UCF_Listbox_JsonPopup["DELETE_COLUMNINDEX"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["bIsDeleteColumnIndex"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Listbox_JsonPopup["prototype"]["aGetVisibleColumnIndices"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["aGetVisibleColumnIndices"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;

	return this["oCache"]["get"]('iVisibleColumnCount', function() {
		return UCF_JsUtil["reduce"](self["oGetModel"]()["aTableDataDefinition"], function(aIndices, oCol, i) {
			return oCol["Visibility"] === 'NONE' ? aIndices : aIndices["concat"]([i]);
		}, []);
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["aGetVisibleColumnIndices"] = 0; };

/**
 * @private
 * @return {UCF_Listbox_JsonModel}
 */
UCF_Listbox_JsonPopup["prototype"]["oGetModel"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["oGetModel"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;

	return this["oCache"]["get"]('oModel', function() {
		return new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_JsonModel"))(
			self["sTableDataDefinition"],
			self["sItemTableData"],
			self["sHistoryTableData"]
		);
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["oGetModel"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_Listbox_JsonPopup["prototype"]["bIsHeadlineVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["bIsHeadlineVisible"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;

	return this["oCache"]["get"]('bHeadlineVisible', function() {
		/** @type {UCF_Listbox_JsonModel} */
		var oModel = self["oGetModel"]();

		return oModel["bValid"] && oModel["aItemTableData"]["length"] > 0;
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["bIsHeadlineVisible"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_Listbox_JsonPopup["prototype"]["bIsHistoryVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["bIsHistoryVisible"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;

	return this["oCache"]["get"]('bHistoryVisible', function() {
		/** @type {UCF_Listbox_JsonModel} */
		var oModel = self["oGetModel"]();

		return oModel["bValid"] && oModel["aHistoryTableData"]["length"] > 0;
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["bIsHistoryVisible"] = 0; };

/**
 * Creates the HTML for the Listbox_JsonPopup and adds it to the ItemsRef.
 * Happens only once (!).
 *
 * @see {@link UCF_Listbox_JsonPopup#ensureRendered}
 * @private
 */
UCF_Listbox_JsonPopup["prototype"]["render"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["render"]++; }; 
	/** @type {UCF_Listbox_JsonModel} */
	var oModel = this["oGetModel"]();
	/** @type {HTMLDivElement} */
	var oItemsRef;
	/** @type {HTMLSpanElement} */
	var oAriaRef;
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {Array.<_MaybeItem>} */
	var aItems;
	/** @type {string} */
	var sAriaOwns;

	if (oModel["bValid"]) {
		UCF_DomUtil["setClass"](this["oRootRef"], this["oLS"]["oGetRenderManager"]()["callFragment"](
			'ListboxGetClass',
			'ItemListBox', {
				"MultipleSelection": false,
				"IsPopup": true,
				"Filtered": this["bFiltered"],
				"Enabled": this["bEnabled"],
				"Readonly": this["bReadonly"],
				"Invalid": this["bInvalid"],
				"InputState": this["sInputState"],
				"Height": this["sHeight"],
				"Width": this["sWidth"],
				"DisplayInline": false,
				"CustomStyle": this["sCustomStyle"],
				"HistoryItems": oModel["aHistoryTableData"],
				"Items": oModel["aTableDataDefinition"],
				"ActionItems": this["oGetActionItemsManager"]()["aGetItems"](),
				"TableDataDefinition": this["sTableDataDefinition"],
				"DragSourceInfo": this["sDragSourceInfo"]
			}
		));

		if (this["bIsHeadlineVisible"]() && this["iVisibleItems"] > 0) {
			/** @type {number} + Headline + Table Head */
			this["iVisibleItems"] += 2;
		}

		oItemsRef = this["oGetItemsManager"]()["oGetItemsRef"]();
		UCF_DomUtil["setStyle"](oItemsRef, 'width', oModel["sWidthInEm"]);
		this["applyWidthBoundaries"]();

		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](oItemsRef, this["sGetItemsInnerHTML"]());

		if (window["UCF_System"]["bIsAria"] && this["bIsRendered"]()) {
			oAriaRef = UCF_DomUtil["$"](this["sId"] + '-aria');

			if (oAriaRef) {
				// eslint-disable-next-line no-unsanitized/property
				UCF_DomUtil["setInnerHtml"](oAriaRef, this["sGetItemsAriaInnerHTML"]());
			}

			aItems = oIM["aFindItemsByStates"]([], UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"]);
			if (aItems["length"] > 0) {
				sAriaOwns = UCF_JsUtil["map"](aItems, function(oItem) {
					return UCF_Listbox_Items["sGetItemId"](oItem);
				})["join"](' ');
				UCF_AriaStateHelper["setOwns"](this["oDomRef"], sAriaOwns);
				UCF_AriaStateHelper["setLabel"](this["oDomRef"], '');
			}
		}

		if (UCF_UserAgent["bIsIE"]()) {
			this["forceReflowOnFullwidthItems"]();
		}

		if (window["UCF_System"]["bIsAria"]) {
			UCF_JsUtil["delayedCall"](
				// eslint-disable-next-line no-magic-numbers
				0,
				this,
				'resetAria'
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["render"] = 0; };

/**
 * IE11 does not display content:attr() initially, but after a forced reflow it
 * will display properly => force a reflow on the history items to display them
 * correctly.
 *
 * @private
 */
UCF_Listbox_JsonPopup["prototype"]["forceReflowOnFullwidthItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["forceReflowOnFullwidthItems"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;
	/** @type {NodeListOf<HTMLDivElement>} */
	var aValueRefs = UCF_DomUtil["querySelectorAll"](
		'[id="' + self["sId"] + '"] .lsListbox__values:first-of-type .lsListbox__value--history'
	);

	if (aValueRefs["length"] > 0) {
		this["requestAnimationFrame"](function() {
			UCF_JsUtil["forEach"](aValueRefs, function(oValueRef) {
				if (UCF_DomUtil["bIsInActiveDom"](oValueRef)) {
					oValueRef["setAttribute"](
						'data-itemvalue1',
						' ' + oValueRef["getAttribute"]('data-itemvalue1')
					);
				}
			});

			self["requestAnimationFrame"](function() {
				UCF_JsUtil["forEach"](aValueRefs, function(oValueRef) {
					if (UCF_DomUtil["bIsInActiveDom"](oValueRef)) {
						oValueRef["setAttribute"](
							'data-itemvalue1',
							oValueRef["getAttribute"]('data-itemvalue1')["slice"](1)
						);
					}
				});
			});
		});
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["forceReflowOnFullwidthItems"] = 0; };

/** @override */
UCF_Listbox_JsonPopup["prototype"]["iGetMinWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["iGetMinWidthPx"]++; }; 
	/** @type {UCF_Listbox_JsonModel} */
	var oModel = this["oGetModel"]();
	// _super() accesses the items, which forces a render() which causes an
	// endless re-render loop => only call _super() if already rendered
	/** @type {number} */
	var iMinWidthPx = this["bIsRendered"]() ? UCF_Listbox_Popup.prototype["iGetMinWidthPx"]["apply"](this, arguments) : 0;

	return oModel["bValid"]
		? Math["max"](
			iMinWidthPx,
			(this["bIsHeadlineVisible"]() && UCF_Listbox_JsonModel["iGetHeadlineMinWidthPx"](this["sGetSearchResultsHeadlineText"]())) || 0,
			(this["bIsHistoryVisible"]() && oModel["iGetHistoryMinWidthPx"]()) || 0
		)
		: iMinWidthPx;
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["iGetMinWidthPx"] = 0; };

/**
 * @private
 * @static
 * @param {UCF_LS} oLS
 * @return {string}
 */
UCF_Listbox_JsonPopup["sGetHistoryItemTutor"] = function(oLS) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetHistoryItemTutor"]++; }; 
	if (typeof UCF_Listbox_JsonPopup["sHistoryItemTutor"] !== 'string') {
		UCF_Listbox_JsonPopup["sHistoryItemTutor"] = oLS["sGetText"]('SAPUR_CB_HI_TUT') || 'History Item';
	}

	return UCF_Listbox_JsonPopup["sHistoryItemTutor"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetHistoryItemTutor"] = 0; };

/**
 * @private
 * @static
 * @param {UCF_LS} oLS
 * @return {string}
 */
UCF_Listbox_JsonPopup["sGetDeletableItemTutor"] = function(oLS) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetDeletableItemTutor"]++; }; 
	if (typeof UCF_Listbox_JsonPopup["sDeletableItemTutor"] !== 'string') {
		UCF_Listbox_JsonPopup["sDeletableItemTutor"] = oLS["sGetText"]('SAPUR_TOKEN_DELETABLE') || 'Deletable';
	}

	return UCF_Listbox_JsonPopup["sDeletableItemTutor"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetDeletableItemTutor"] = 0; };

/**
 * @private
 * @static
 * @param {UCF_LS} oLS
 * @return {string}
 */
UCF_Listbox_JsonPopup["sGetSearchResultItemTutor"] = function(oLS) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetSearchResultItemTutor"]++; }; 
	if (typeof UCF_Listbox_JsonPopup["sSearchResultsItemTutor"] !== 'string') {
		UCF_Listbox_JsonPopup["sSearchResultsItemTutor"] = oLS["sGetText"]('SAPUR_CB_SUGGEST_TUT') || 'Search Results Item';
	}

	return UCF_Listbox_JsonPopup["sSearchResultsItemTutor"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetSearchResultItemTutor"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sGetItemsAriaInnerHTML"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetItemsAriaInnerHTML"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;
  /** @type {string} */
	var sStyleAttributeName = this["oLS"]["sStyleAttributeName"];

	return this["oCache"]["get"]('sItemsAriaHTML', function() {
		/** @type {UCF_Listbox_JsonModel} */
		var oModel = self["oGetModel"]();

		if (oModel["bValid"]) {
			return UCF_JsUtil["reduce"](oModel["aHistoryTableData"], function(sHtml, _, i) {
					return sHtml + '<span' +
						' id="' + self["sGetItemId"](i, UCF_Listbox_JsonModel["ITEMTYPE"]["History"]) + '-ariaItemValues"' +
						' title="\'\'" ' +
						sStyleAttributeName + '="display:none;visibility:hidden">' +
						self["sGetAriaLabel"](UCF_Listbox_JsonModel["ITEMTYPE"]["History"], i) +
						'</span>';
				}, '') +
				'<span id="' + self["sId"] + '-hlitem-0-ariaItemValues" title="\'\'" ' + sStyleAttributeName + '="display:none;visibility:hidden" > < /span>' +
				'<span id="' + self["sId"] + '-thitem-0-ariaItemValues" title="\'\'" ' + sStyleAttributeName + '="display:none;visibility:hidden"></span>' +
				UCF_JsUtil["reduce"](oModel["aItemTableData"], function(sHtml, _, i) {
					return sHtml + '<span' +
						' id="' + self["sGetItemId"](i, UCF_Listbox_JsonModel["ITEMTYPE"]["SearchResult"]) + '-ariaItemValues"' +
						' title="\'\'" ' +
						sStyleAttributeName + '="display:none;visibility:hidden">' +
						self["sGetAriaLabel"](UCF_Listbox_JsonModel["ITEMTYPE"]["SearchResult"], i) +
						'</span>';
				}, '');
		} else {
			return '';
		}
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetItemsAriaInnerHTML"] = 0; };

/**
 * @private
 * @static
 * @param {UCF_Listbox_JsonModel_Item} aItem
 * @param {UCF_Listbox_JsonModel_Column[]} aTableDataDefinition
 * @return {string}
 */
UCF_Listbox_JsonPopup["sGetItemAriaLabel"] = function(aItem, aTableDataDefinition) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetItemAriaLabel"]++; }; 
	return UCF_JsUtil["reduce"](aItem, function(aValues, oValue, i) {
		/** @type {UCF_Listbox_JsonModel_Column} */
		var oCol = aTableDataDefinition[i];

		return (oCol["Visibility"] === 'NONE' || oCol["Type"] === 'Icon')
			? aValues
			: aValues["concat"]([
				oCol["Label"],
				UCF_RenderManager["sGetEscaped"](typeof oValue === 'string' ? oValue : oValue["Value"])
			]);
	}, [])["join"](' ');
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetItemAriaLabel"] = 0; };

/**
 * @private
 * @param {UCF_Listbox_JsonModel_Itemtype} eItemtype
 * @param {number} iItemIndex
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sGetAriaLabel"] = function(eItemtype, iItemIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetAriaLabel"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;

	return this["oCache"]["get"]('sAriaLabel(' + eItemtype + ',' + iItemIndex + ')', function() {
		/** @type {UCF_Listbox_JsonModel} */
		var oModel;

		if (
			(typeof iItemIndex !== 'number') ||
			(iItemIndex < 0) ||
			(eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["Headline"]) ||
			(eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["TableHeader"])
		) {
			return '';
		} else {
			oModel = self["oGetModel"]();

			if (oModel["bValid"]) {
				if (
					(eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["History"]) &&
					(iItemIndex < oModel["aHistoryTableData"]["length"])
				) {
					return UCF_Listbox_JsonPopup["sGetItemAriaLabel"](
							oModel["aHistoryTableData"][iItemIndex],
							oModel["aTableDataDefinition"]
						) +
						' ' + UCF_Listbox_JsonPopup["sGetHistoryItemTutor"](self["oLS"]) +
						' ' + UCF_Listbox_JsonPopup["sGetDeletableItemTutor"](self["oLS"]);
				} else if (
					(eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["SearchResult"]) &&
					(iItemIndex < oModel["aItemTableData"]["length"])
				) {
					return UCF_Listbox_JsonPopup["sGetItemAriaLabel"](
						oModel["aItemTableData"][iItemIndex],
						oModel["aTableDataDefinition"]
					) + ' ' + UCF_Listbox_JsonPopup["sGetSearchResultItemTutor"](self["oLS"]);
				} else {
					return '';
				}
			} else {
				return '';
			}
		}
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetAriaLabel"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sGetItemsInnerHTML"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetItemsInnerHTML"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;

	return this["oCache"]["get"]('sItemsHTML', function() {
		/** @type {UCF_Listbox_JsonModel} */
		var oModel = self["oGetModel"]();
		/** @type {UCF_RenderManager} */
		var oRenderManager;
		/** @type {string} */
		var sValueAlignStyle;
		/** @type {string} */
		var sValueDir;

		if (oModel["bValid"]) {
			oRenderManager = self["oLS"]["oGetRenderManager"]();
			sValueAlignStyle = oRenderManager["callFragment"](
				'UrBase_sTextAlign',
				'UrBase', { "Align": 'LEFT', "TextDirection": 'INHERIT' }
			);
			sValueDir = oRenderManager["callFragment"](
				'UrBase_sTextDir',
				'UrBase', { "TextDirection": 'INHERIT' }
			);

			return UCF_JsUtil["reduce"](oModel["aTableDataDefinition"], function(sHtml, oCol, iColumnIndex) {
					return oCol["Visibility"] === 'NONE'
						? sHtml
						: sHtml + self["sColumn"](oCol, iColumnIndex, sValueAlignStyle, sValueDir);
				}, '') +
				((oModel["bHasDeleteColumn"] && self["aGetVisibleColumnIndices"]()["length"] === 1)
					? self["sColumn"]({}, UCF_Listbox_JsonPopup["DELETE_COLUMNINDEX"], sValueAlignStyle, sValueDir)
					: '');
			// Drag&Drop-icon not rendered on Listbox_Popup
		} else {
			return '';
		}
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetItemsInnerHTML"] = 0; };
/**
 * @private
 * @param {UCF_Listbox_JsonModel_Column} oCol
 * @param {number} iColumnIndex
 * @param {string} sValueAlignStyle
 * @param {string} sValueDir
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sColumn"] = function(oCol, iColumnIndex, sValueAlignStyle, sValueDir) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sColumn"]++; }; 
	/** @type {boolean} */
	var bIsDeleteColumn = this["bIsDeleteColumnIndex"](iColumnIndex);
	/** @type {UCF_Listbox_JsonModel} */
	var oModel = this["oGetModel"]();
	/** @type {string} */
	var sStyleAttributeName = this["oLS"]["sStyleAttributeName"];

	if (oModel["bValid"]) {
		return '<div ' +
			' title=""' +
			(window["UCF_System"]["bIsAria"]
				? ' id="' + this["sId"] + '-' + (bIsDeleteColumn ? 'delete' : iColumnIndex) + '"' +
				(iColumnIndex !== oModel["iCtColumnIndex"] ? ' aria-hidden="true"' : '')
				: '') +
			' class="' + this["oLS"]["oGetRenderManager"]()["callFragment"](
				'ListboxGetValuesClass',
				'ItemListBox', {
					"Classes": bIsDeleteColumn
						? 'lsListbox__values--delete'
						: iColumnIndex === 1
						? 'lsListbox__values--first'
						: iColumnIndex === 2 // eslint-disable-line no-magic-numbers
						? 'lsListbox__values--second'
						: '',
					"Visibility": oCol["Visibility"] || 'VISIBLE',
					"TextDirection": 'INHERIT',
					"CustomStyle": this["sCustomStyle"]
				}
			) + '" ' +
			(('Width' in oCol || sValueAlignStyle !== '')
				? sStyleAttributeName  + '="' + (
					('Width' in oCol) ? 'width:' + oCol["Width"] : ''
				) + (
					('Width' in oCol && (
						sValueAlignStyle !== '' ||
						UCF_UserAgent["bIsIE"]()
					)) ? ';' : ''
				) + (
					(sValueAlignStyle === '') ? '' : 'text-align:' + sValueAlignStyle
				) + ((
					('Width' in oCol || sValueAlignStyle !== '') &&
					UCF_UserAgent["bIsIE"]()
				) ? ';' : '') + (
					(UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())
					// eslint-disable-next-line no-magic-numbers
					? 'height:' + (oModel["iLength"] + (oModel["bHistoryOnly"] ? 0 : 2)) + 'em'
					: ''
				) + '"'
				: ''
			) +
			((sValueDir === '') ? '' : ' dir="' + sValueDir + '"') + '>' +
			this["sHistoryCells"](iColumnIndex) +
			(oModel["aItemTableData"]["length"] > 0
				? (
					this["sSearchResultsHeadlineCell"](iColumnIndex) +
					this["sSearchResultsTableHeaderCell"](iColumnIndex) +
					this["sSearchResultsCells"](iColumnIndex)
				)
				: '') +
			'</div>';
	} else {
		return '';
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sColumn"] = 0; };

/**
 * @private
 * @param {number} iColumnIndex
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sHistoryCells"] = function(iColumnIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sHistoryCells"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;
	/** @type {UCF_Listbox_JsonModel} */
	var oModel = this["oGetModel"]();

	return oModel["bValid"]
		? UCF_JsUtil["reduce"](oModel["aHistoryTableData"], function(sHtml2, aItem, iItemIndex, aItems) {
			return sHtml2 + self["sCallListboxValueFragment"](
				aItem,
				iColumnIndex,
				aItems,
				iItemIndex,
				UCF_Listbox_JsonModel["ITEMTYPE"]["History"]
			);
		}, '')
		: '';
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sHistoryCells"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sGetSearchResultsHeadlineText"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetSearchResultsHeadlineText"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;

	return this["oCache"]["get"]('sSearchResultsHeadlineText', function() {
		return self["oLS"]["sGetText"]('SAPUR_IL_SUGGEST_HEADLINE') || 'Search Results';
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetSearchResultsHeadlineText"] = 0; };

/**
 * @private
 * @param {number} iColumnIndex
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sSearchResultsHeadlineCell"] = function(iColumnIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sSearchResultsHeadlineCell"]++; }; 
	/** @type {UCF_Listbox_JsonModel} */
	var oModel = this["oGetModel"]();
	/** @type {string} */
	var sSearchResultsHeadlineText;
	/** @type {UCF_Listbox_JsonModel_Item} */
	var aSearchResultsItem;

	if (oModel["bValid"]) {
		sSearchResultsHeadlineText = this["sGetSearchResultsHeadlineText"]();
		aSearchResultsItem = UCF_JsUtil["map"](
			Array["apply"](null, new Array(oModel["aTableDataDefinition"]["length"])),
			function() { return sSearchResultsHeadlineText; }
		);

		return this["sCallListboxValueFragment"](
			aSearchResultsItem,
			iColumnIndex,
			[aSearchResultsItem],
			0,
			UCF_Listbox_JsonModel["ITEMTYPE"]["Headline"]
		);
	} else {
		return '';
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sSearchResultsHeadlineCell"] = 0; };

/**
 * @private
 * @param {number} iColumnIndex
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sSearchResultsTableHeaderCell"] = function(iColumnIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sSearchResultsTableHeaderCell"]++; }; 
	/** @type {UCF_Listbox_JsonModel} */
	var oModel = this["oGetModel"]();
	/** @type {UCF_Listbox_JsonModel_Item} */
	var aSearchResultsTableHeaderItem;

	if (oModel["bValid"]) {
		aSearchResultsTableHeaderItem = UCF_JsUtil["map"](
			oModel["aTableDataDefinition"],
			function(oCol) { return oCol["Label"]; }
		);

		return this["sCallListboxValueFragment"](
			aSearchResultsTableHeaderItem,
			iColumnIndex,
			[aSearchResultsTableHeaderItem],
			0,
			UCF_Listbox_JsonModel["ITEMTYPE"]["TableHeader"]
		);
	} else {
		return '';
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sSearchResultsTableHeaderCell"] = 0; };

/**
 * @private
 * @param {number} iColumnIndex
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sSearchResultsCells"] = function(iColumnIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sSearchResultsCells"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;
	/** @type {UCF_Listbox_JsonModel} */
	var oModel = this["oGetModel"]();

	return oModel["bValid"]
		? UCF_JsUtil["reduce"](oModel["aItemTableData"], function(sHtml2, aItem, iItemIndex, aItems) {
			return sHtml2 + self["sCallListboxValueFragment"](
				aItem,
				iColumnIndex,
				aItems,
				iItemIndex,
				UCF_Listbox_JsonModel["ITEMTYPE"]["SearchResult"]
			);
		}, '')
		: '';
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sSearchResultsCells"] = 0; };

/**
 * @private
 * @param {number} iItemIndex
 * @param {UCF_Listbox_JsonModel_Itemtype} eItemtype
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sGetItemId"] = function(iItemIndex, eItemtype) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetItemId"]++; }; 
	return this["sId"] + '-' + (
		eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["History"]
		? 'hi'
		: eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["Headline"]
		? 'hl'
		: eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["TableHeader"]
		? 'th'
		: ''
	) + 'item-' + iItemIndex;
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetItemId"] = 0; };

/**
 * @param {UCF_Listbox_JsonModel_Item} aItem
 * @param {UCF_Listbox_JsonModel_Itemtype} eItemtype
 * @param {number} iKeyColumnIndex
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sGetItemKey"] = function(aItem, eItemtype, iKeyColumnIndex) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetItemKey"]++; }; 
	/** @type {UCF_Listbox_JsonModel} */
	var oModel;

	if (typeof iKeyColumnIndex === 'number') {
		return eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["Headline"]
			? this["sId"] + '-hl'
			: eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["TableHeader"]
			? this["sId"] + '-th'
			: aItem[iKeyColumnIndex];
	} else {
		oModel = this["oGetModel"]();

		return oModel["bValid"]
			? this["sGetItemKey"](aItem, eItemtype, oModel["iKeyColumnIndex"])
			: '';
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sGetItemKey"] = 0; };

/**
 * @private
 * @param {UCF_Listbox_JsonModel_Item} aItem the current item
 * @param {number} iColumnIndex the current index in `aItem`
 * @param {UCF_Listbox_JsonModel_Item[]} aItems
 * @param {number} iItemIndex the current index in `aItems`
 * @param {UCF_Listbox_JsonModel_Itemtype} eItemtype
 * @return {string}
 */
UCF_Listbox_JsonPopup["prototype"]["sCallListboxValueFragment"] = function(aItem, iColumnIndex, aItems, iItemIndex, eItemtype) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sCallListboxValueFragment"]++; }; 
	/** @type {UCF_Listbox_JsonModel} */
	var oModel = this["oGetModel"]();
	/** @type {boolean} */
	var bIsHistoryItem;
	/** @type {boolean} */
	var bIsHeadline;
	/** @type {boolean} */
	var bIsTableHeader;
	/** @type {boolean} */
	var bIsCtColumn;
	/** @type {boolean} */
	var bIsDeleteColumn;
	/** @type {UCF_Listbox_JsonModel_Value} */
	var oValue;
	/** @type {string} */
	var sValue;
	/** @type {string} */
	var sHtml;

	if (oModel["bValid"]) {
		bIsHistoryItem = eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["History"];
		bIsHeadline = eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["Headline"];
		bIsTableHeader = eItemtype === UCF_Listbox_JsonModel["ITEMTYPE"]["TableHeader"];
		bIsCtColumn = iColumnIndex === oModel["iCtColumnIndex"];
		bIsDeleteColumn = this["bIsDeleteColumnIndex"](iColumnIndex) && bIsHistoryItem;
		oValue = (bIsDeleteColumn || iColumnIndex >= aItem["length"] || iColumnIndex < 0 || (bIsHeadline && !bIsCtColumn))
			? ''
			: (UCF_JsUtil["bIsObject"](aItem[iColumnIndex])
				? (aItem[iColumnIndex]["Highlights"]["length"] > 0
					? aItem[iColumnIndex]
					: aItem[iColumnIndex]["Value"]
				)
				: aItem[iColumnIndex]
			);
		sValue = typeof oValue === 'string' ? oValue : UCF_JsUtil["sGetUID"]();
		sHtml = this["oLS"]["oGetRenderManager"]()["callFragment"](
			'ListboxValueFragment',
			'ItemListBox', {
				"Item": {
					"Id": this["sGetItemId"](iItemIndex, eItemtype),
					"Key": this["sGetItemKey"](aItem, eItemtype, oModel["iKeyColumnIndex"]),
					"GroupTitle": '',
					"Selected": false,
					"IsDeletable": bIsHistoryItem,
					"Design": this["sTableDataItemDesign"],
					"SemanticTextColor": 'STANDARD',
					"Enabled": true,
					"IconSrc": '',
					"Tooltip": '',
					"Value1": sValue,
					"Value2": ''
				},
				"IsHistoryItem": bIsHistoryItem,
				"IsTableHeader": bIsTableHeader,
				"IsHeadline": bIsHeadline,
				"IsSeparator": false,
				"ListboxId": this["sId"],
				"Enabled": this["bEnabled"],
				"Index": bIsHistoryItem
					? iItemIndex
					: bIsHeadline
					? oModel["aHistoryTableData"]["length"]
					: bIsTableHeader
					? oModel["aHistoryTableData"]["length"] + 1
					// eslint-disable-next-line no-magic-numbers
					: iItemIndex + 2 + oModel["aHistoryTableData"]["length"],
				"Suffix": bIsDeleteColumn ? 'delete' : iColumnIndex,
				"CustomStyle": this["sCustomStyle"],
				"Value": sValue,
				"GroupTitle": '',
				"IsGroupTitleColumn": false,
				"IsCtColumn": bIsCtColumn,
				"Selected": false,
				"SetSize": aItems["length"],
				"Readonly": this["bReadonly"],
				"iAriaSetSize": oModel["iLength"],
				"iAriaPosInSet": bIsHistoryItem
					? iItemIndex + 1
					: iItemIndex + 1 + oModel["aHistoryTableData"]["length"],
				"FirstValueVisibility": 'VISIBLE',
				"SecondValueVisibility": 'HIDDEN',
				"Filtered": this["bFiltered"],
				"Tooltip": this["sTooltip"]
			});

		if (typeof oValue !== 'string') {
			sHtml = sHtml["replace"](
				new RegExp('>' + sValue + '<', 'g'),
				'>' + UCF_Listbox_JsonPopup["sHighlightValueHtml"](oValue) + '<'
			)["replace"](
				new RegExp(sValue, 'g'),
				UCF_XSSEncoder["encodeJS"](oValue["Value"])
			);
		}

		if (UCF_UserAgent["bIsIE"]()) {
			if (bIsCtColumn) {
				sHtml = sHtml["replace"](
					/aria-label=".*?"/,
					'aria-label="' + UCF_XSSEncoder["encodeHTML"](this["sGetAriaLabel"](eItemtype, iItemIndex)) + '"'
				);
			} else {
				sHtml = sHtml["replace"](/ aria-label=".*?"/, '')["replace"](' role="option"', '');
			}
		}

		return sHtml;
	} else {
		return '';
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sCallListboxValueFragment"] = 0; };

/**
 * @private
 * @static
 * @param {UCF_Listbox_JsonModel_HighlightValue} oValue
 * @return {string}
 */
UCF_Listbox_JsonPopup["sHighlightValueHtml"] = function(oValue) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sHighlightValueHtml"]++; }; 
	/** @type {number[]} */
	var aStartIndices = UCF_JsUtil["map"](oValue["Highlights"], function(h) { return h[0]; });
	/** @type {number[]} */
	var aEndIndices = UCF_JsUtil["map"](oValue["Highlights"], function(h) { return h[1]; });

	return UCF_JsUtil["reduce"](oValue["Value"]["split"](''), function(sHtml, sChar, i) {
			// endindex closes previous element => has to come before next span
			if (UCF_JsUtil["contains"](aEndIndices, i)) {
				sHtml += '</span>';
			}
			if (UCF_JsUtil["contains"](aStartIndices, i)) {
				sHtml += '<span class="lsListbox__highlight">';
			}
			sHtml += sChar;

			return sHtml;
		}, '') +
		// Value.length (== last character highlighted) would not be recognized in
		// reduce => add manually
		(UCF_JsUtil["contains"](aEndIndices, oValue["Value"]["length"]) ? '</span>' : '');
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["sHighlightValueHtml"] = 0; };

/** @override */
UCF_Listbox_JsonPopup["prototype"]["resetSeparator"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["resetSeparator"]++; }; 
	/** @type {UCF_Listbox_JsonItems} */
	var oIM = this["oGetItemsManager"]();
	/** @type {_MaybeItem[]} */
	var aSearchResultItems = oIM["aFindItemsByStates"](
		[], [
			UCF_Listbox_Items["STATE"]["Hidden"],
			UCF_Listbox_Items["STATE"]["History"],
			UCF_Listbox_Items["STATE"]["TableHeader"],
			UCF_Listbox_Items["STATE"]["Headline"]
		]
	);
	/** @type {_MaybeItem[]} */
	var aHeadlineOrTableHeaderItems = oIM["aFindItemsByStates"](
		[UCF_Listbox_Items["STATE"]["Headline"]], []
	)["concat"](oIM["aFindItemsByStates"](
		[UCF_Listbox_Items["STATE"]["TableHeader"]], []
	));

	if (aSearchResultItems["length"] > 0) {
		UCF_JsUtil["forEach"](aHeadlineOrTableHeaderItems, function(oItem) {
			oIM["removeState"](oItem, UCF_Listbox_Items["STATE"]["Hidden"]);
		});
	} else {
		UCF_JsUtil["forEach"](aHeadlineOrTableHeaderItems, function(oItem) {
			oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Hidden"]);
		});
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["resetSeparator"] = 0; };

/** @override */
UCF_Listbox_JsonPopup["prototype"]["applyHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["applyHeight"]++; }; 
	this["ensureRendered"]();

	UCF_Listbox_Popup.prototype["applyHeight"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["applyHeight"] = 0; };

/**
 * @override
 * @return {number}
 */
UCF_Listbox_JsonPopup["prototype"]["iGetVisibleLines"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["iGetVisibleLines"]++; }; 
	/** @type {UCF_Listbox_JsonModel} */
	var oModel = this["oGetModel"]();

	// eslint-disable-next-line no-magic-numbers
	return ((oModel["bValid"] && oModel["aItemTableData"]["length"]) > 0 ? 2 : 0) + UCF_Listbox_Popup.prototype["iGetVisibleLines"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["iGetVisibleLines"] = 0; };

/** @override */
UCF_Listbox_JsonPopup["prototype"]["oGetItemsManager"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["oGetItemsManager"]++; }; 
	/** @type {UCF_Listbox_JsonPopup} */
	var self = this;

	return this["oCache"] && this["oCache"]["get"]('oItemsManager', function() {
		/** @type {UCF_Listbox_JsonItems} */
		var oIM = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_JsonItems"))(self);

		oIM["attachEvent"](UCF_Listbox_Items["EVENT"]["WillAccessDom"], self, 'ensureRendered');
		oIM["attachEvent"](UCF_Listbox_Items["EVENT"]["WillDeleteItemAnimated"], self, 'onWillItemsManagerDeleteItemAnimated');
		oIM["attachEvent"](UCF_Listbox_Items["EVENT"]["DidDeleteItemAnimated"], self, 'onDidItemsManagerDeleteItemAnimated');

		return oIM;
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["oGetItemsManager"] = 0; };

/** @override */
UCF_Listbox_JsonPopup["prototype"]["clearFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["clearFocus"]++; }; 
	if (this["bIsRendered"]()) {
		UCF_Listbox_Popup.prototype["clearFocus"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonPopup["_"]["clearFocus"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_JsonSuggest"] = function() {/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Listbox_Items */
/// <reference path="./Listbox_Items.js"/>
/* global UCF_Listbox_JsonModel */
/// <reference path="./Listbox_JsonModel.js"/>
/* global UCF_Listbox_JsonPopup */
/// <reference path="./Listbox_JsonPopup.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * @class UCF_Listbox_JsonSuggest
 * @extends UCF_Listbox_JsonPopup
 * @param {HTMLDivElement} oDomRef the dom element
 * @param {UCF_LS} oLS the lightspeed instance
 */
function UCF_Listbox_JsonSuggest(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["UCF_Listbox_JsonSuggest"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox_JsonPopup["apply"](this, arguments);
	}
};window["UCF_Listbox_JsonSuggest"] = UCF_Listbox_JsonSuggest; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_JsonSuggest"); UCF_Listbox_JsonSuggest["_"] = {UCF_Listbox_JsonSuggest: 0}; }; ;
UCF_Listbox_JsonSuggest["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_JsonPopup"))(); UCF_Listbox_JsonSuggest.prototype["sClassName"] = "UCF_Listbox_JsonSuggest";

/** @override */
UCF_Listbox_JsonSuggest["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["destroy"]++; }; 
	UCF_Listbox_JsonPopup.prototype["destroy"]["apply"](this, arguments);

	this["oNoResultsRef"] = null;
	this["oNoResultsFilterRef"] = null;
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["destroy"] = 0; };

/** @override */
UCF_Listbox_JsonSuggest["prototype"]["render"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["render"]++; }; 
	/** @type {HTMLDivElement} */
	var oScrollRef = this["oGetItemsManager"]()["oGetScrollRef"]();

	UCF_Listbox_JsonPopup.prototype["render"]["apply"](this, arguments);

	// eslint-disable-next-line no-unsanitized/method
	oScrollRef["insertAdjacentHTML"]('afterend', this["sGetNoResultsHTML"]());

	this["oNoResultsRef"] = UCF_DomUtil["$"](this["sId"] + '-noresults');
	/** @type {HTMLSpanElement} */
	this["oNoResultsFilterRef"] = UCF_DomUtil["$"](this["sId"] + '-noresultsfilter');
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["render"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_Listbox_JsonSuggest["prototype"]["sGetNoResultsHTML"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["sGetNoResultsHTML"]++; }; 
	return '<div id="' + this["sId"] + '-noresults" class="lsListbox__noresults">' +
		'<span class="lsListbox__noresultsicon"></span>' +
		'<span class="lsListbox__noresultstext">' +
		this["sGetNoResultsText"]()["replace"](
			/(\{0\}|_NEVER_TRANSLATE_THIS_)/,
			'<span class="lsListbox__noresultsfilter" id="' + this["sId"] + '-noresultsfilter"></span>'
		) +
		'</span>' +
		'</div>';
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["sGetNoResultsHTML"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_Listbox_JsonSuggest["prototype"]["sGetNoResultsText"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["sGetNoResultsText"]++; }; 
	/** @type {UCF_Listbox_JsonSuggest} */
	var self = this;

	return this["oCache"]["get"]('sNoResultsText', function() {
		return self["oLS"]["sGetText"]('SAPUR_IL_SUGGEST_NORESULTS')
			|| 'We did not find any matches for "{0}"';
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["sGetNoResultsText"] = 0; };

/** @protected */
UCF_Listbox_JsonSuggest["prototype"]["hideNoResults"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["hideNoResults"]++; }; 
	UCF_DomUtil["removeClass"](this["oRootRef"], 'lsListbox--noresults');
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["hideNoResults"] = 0; };

/**
 * @override
 * @protected
 * @param {string} sValue the value no results were found for
 * @return {boolean}
 */
UCF_Listbox_JsonSuggest["prototype"]["bShowNoResults"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["bShowNoResults"]++; }; 
	/** @type {UCF_Listbox_JsonModel} */
	var oModel = this["oGetModel"]();

	if (
		UCF_Listbox_Items["oGetMetadata"]()["supportsNoResults"] &&
		oModel["bValid"] &&
		!oModel["bHistoryOnly"]
	) {
		this["ensureRendered"]();

		this["oNoResultsFilterRef"]["textContent"] = sValue;
		UCF_DomUtil["addClass"](this["oRootRef"], 'lsListbox--noresults');

		return true;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_JsonSuggest["_"]["bShowNoResults"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_MultiInteraction"] = function() {/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Listbox_Items */
/// <reference path="../Listbox_Items.js"/>
/* global UCF_Listbox_Interaction */
/// <reference path="./Listbox_Interaction.js"/>

/**
 * @class UCF_Listbox_MultiInteraction
 * @extends UCF_Listbox_Interaction
 * @param {UCF_Listbox_MultiSelect} oControl the listbox
 * @param {UCF_Listbox_Items} [oItems] the items
 */
function UCF_Listbox_MultiInteraction(oControl, oItems) {if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["UCF_Listbox_MultiInteraction"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox_Interaction["apply"](this, arguments);

		/** @type {string} */
		this["sAccessibilityCt"] = 'ILBM';

		/** @type {boolean} */
		this["bTouchstartSelected"] = false;
	}
};window["UCF_Listbox_MultiInteraction"] = UCF_Listbox_MultiInteraction; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_MultiInteraction"); UCF_Listbox_MultiInteraction["_"] = {UCF_Listbox_MultiInteraction: 0}; }; ;
UCF_Listbox_MultiInteraction["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_Interaction"))(); UCF_Listbox_MultiInteraction.prototype["sClassName"] = "UCF_Listbox_MultiInteraction";

// ===== keydown ==============================================================

/** @override */
// eslint-disable-next-line complexity
UCF_Listbox_MultiInteraction["prototype"]["onkeydown"] = function(oKeydown) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["onkeydown"]++; }; 
	var bHandled = false;

	/* beautify preserve:start */
	// [CTRL][DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetItemRelativeToFocused"](1));
		bHandled = true;
	} else
	// [CTRL][UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetItemRelativeToFocused"](-1));
		bHandled = true;
	} else
	// [CTRL][PAGE_DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_DOWN"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetItemRelativeToFocused"](
			UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [CTRL][PAGE_UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_UP"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetItemRelativeToFocused"](
			-UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [CTRL][HOME]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["HOME"], 'C')) {
		this["extendSelectionWithItem"](this["oGetFirstWriteableItem"]());
		bHandled = true;
	} else
	// [CTRL][END]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["END"], 'C')) {
		this["extendSelectionWithItem"](this["oGetLastWriteableItem"]());
		bHandled = true;
	} else
	// [CTRL][SPACE] and [CTRL][ENTER]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"], 'C') ||
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ENTER"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetFocusedItem"]());
		bHandled = true;
	} else
	// [SHIFT][DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](1));
		bHandled = true;
	} else
	// [SHIFT][UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](-1));
		bHandled = true;
	} else
	// [SHIFT][PAGE_DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_DOWN"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](
			UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [SHIFT][PAGE_UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_UP"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](
			-UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [SHIFT][HOME]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["HOME"], 'S')) {
		this["extendSelectionWithRange"](this["oGetFirstWriteableItem"]());
		bHandled = true;
	} else
	// [SHIFT][END]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["END"], 'S')) {
		this["extendSelectionWithRange"](this["oGetLastWriteableItem"]());
		bHandled = true;
	} else
	// [SHIFT][SPACE] and [SHIFT][ENTER]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"], 'S') ||
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ENTER"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetFocusedItem"]());
		bHandled = true;
	} else {
		UCF_Listbox_Interaction.prototype["onkeydown"]["call"](this, oKeydown);
	}
	/* beautify preserve:end */

	if (bHandled) {
		oKeydown["cancel"]();
		oKeydown["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["onkeydown"] = 0; };

// ===== mousedown ============================================================

/**
 * @private
 * @param {UCF_BrowserEvent} oMousedown the mousedown
 */
UCF_Listbox_MultiInteraction["prototype"]["onmousedown"] = function(oMousedown) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["onmousedown"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemByDomRef"](oMousedown["oGetSource"]());

	if (oIM["bIsWriteable"](oItem)) {
		if (oMousedown && oMousedown["bIsTouchInteraction"]()) {
			// if touch handle is drag source don't toggle selection here
			// as it is handled in onlstouchstart
			if (!this["bOnDragHandle"](oMousedown)) {
				this["extendSelectionWithItem"](oItem);
			}
		} else if (oMousedown["bCtrl"]()) {
			this["extendSelectionWithItem"](oItem);
		} else if (oMousedown["bShift"]()) {
			this["extendSelectionWithRange"](oItem);
		} else if (oIM["aFindItemsByState"](UCF_Listbox_Items["STATE"]["Selected"])["length"] === 0) {
			// select only if no drag & drop is performed
			this["selectItem"](oItem);
		} else {
			this["interactWithItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["onmousedown"] = 0; };

// ===== click ================================================================
/**
 * @private
 * @param {UCF_BrowserEvent} oClick the click
 */
UCF_Listbox_MultiInteraction["prototype"]["onclick"] = function(oClick) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["onclick"]++; }; 
	if (oClick && !oClick["bIsTouchInteraction"]()
		&& !oClick["bCtrl"]()
		&& !oClick["bShift"]()) {
		this["selectItem"](
			this["oControl"]["oGetItemsManager"]()["oFindItemByDomRef"](oClick["oGetSource"]())
		);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["onclick"] = 0; };

// ===== onlstouchstart =======================================================
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the touchstart
 */
UCF_Listbox_MultiInteraction["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["onlstouchstart"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {Item} */
	var oItem = oIM["oFindItemByDomRef"](oBrowserEvent["oGetSource"]());

	this["bTouchstartSelected"] = false;

	// if touch handle is source select item
	if (this["bOnDragHandle"](oBrowserEvent)) {
		if (oIM["bIsWriteable"](oItem) &&
			!oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])) {
			this["bTouchstartSelected"] = true;
			this["extendSelectionWithItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["onlstouchstart"] = 0; };

// ===== onlstouchend =========================================================
/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the onlstouchend
 */
UCF_Listbox_MultiInteraction["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["onlstouchend"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {Item} */
	var oItem = oIM["oFindItemByDomRef"](oBrowserEvent["oGetSource"]());

	// if touch handle is source select item
	if (this["bOnDragHandle"](oBrowserEvent)) {
		if (oIM["bIsWriteable"](oItem) &&
			oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]) &&
			!this["bTouchstartSelected"]) {
			this["extendSelectionWithItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["onlstouchend"] = 0; };

// ===== helpers ==============================================================

/**
 * @private
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_MultiInteraction["prototype"]["extendSelectionWithItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["extendSelectionWithItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	if (!this["bReadonly"] && oIM["bIsWriteable"](oItem)) {
		if (oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])) {
			oIM["removeState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
		} else {
			oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
		}
		this["focusItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["extendSelectionWithItem"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem
 */
UCF_Listbox_MultiInteraction["prototype"]["extendSelectionWithRange"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["extendSelectionWithRange"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {Array.<Array.<_RangeItem>>} */
	var aSelectedRanges = UCF_JsUtil["reduce"](
		oIM["aFindItemsByStates"](
			[UCF_Listbox_Items["STATE"]["Selected"]],
			UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"]
		),
		/**
		 * @param {Array.<Array.<_RangeItem>>} aRanges the ranges
		 * @param {UCF_Listbox_Item} oSelectedItem the item
		 * @return {Array.<Array.<_RangeItem>>}
		 */
		function(aRanges, oSelectedItem) {
			/** @type {number} */
			var iRangesLength = aRanges["length"];
			/** @type {Array.<_RangeItem>} */
			var aLastRange;
			/** @type {number} */
			var iLastRangeLength;

			if (iRangesLength === 0) {
				aRanges["push"]([oSelectedItem]);
			} else {
				aLastRange = aRanges[iRangesLength - 1];
				iLastRangeLength = aLastRange["length"];

				if (
					oIM["iGetItemIndex"](aLastRange[iLastRangeLength - 1]) ===
					oIM["iGetItemIndex"](oSelectedItem) - 1
				) {
					aLastRange["push"](oSelectedItem);
				} else {
					aRanges["push"]([oSelectedItem]);
				}
			}

			return aRanges;
		},
		[]
	);
	/** @type {Array.<UCF_Listbox_Item>} */
	var aLastInteractedRange = UCF_JsUtil["find"](
		aSelectedRanges,
		/**
		 * @param {Array.<UCF_Listbox_Item>} aRange the range
		 * @return {boolean}
		 */
		function(aRange) {
			return UCF_JsUtil["some"](
				aRange,
				/**
				 * @param {UCF_Listbox_Item} o the item
				 * @return {boolean}
				 */
				function(o) {
					return oIM["bHasState"](o, UCF_Listbox_Items["STATE"]["LastInteractedWith"]);
				}
			);
		}
	) || (aSelectedRanges["length"] > 0 && aSelectedRanges[0]);
	/** @type {number} */
	var iCurrentIndex;
	/** @type {number} */
	var iMinIndex;

	if (
		UCF_JsUtil["bIsArray"](aLastInteractedRange) &&
		aLastInteractedRange["length"] > 0
	) {
		iCurrentIndex = oIM["iGetItemIndex"](oItem);
		iMinIndex = oIM["iGetItemIndex"](aLastInteractedRange[0]);

		oIM["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
		UCF_JsUtil["forEach"](
			iCurrentIndex < iMinIndex
			? oIM["aFindItemsByIndexRange"](
				iCurrentIndex,
				oIM["iGetItemIndex"](aLastInteractedRange[aLastInteractedRange["length"] - 1])
			)
			: oIM["aFindItemsByIndexRange"](
				iMinIndex,
				iCurrentIndex
			),
			function(o) {
				if (!oIM["bHasState"](o, UCF_Listbox_Items["STATE"]["Disabled"])) {
					oIM["addState"](o, UCF_Listbox_Items["STATE"]["Selected"]);
				}
			}
		);
	} else {
		oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
	}
	this["focusItem"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["extendSelectionWithRange"] = 0; };

// ===== api ==================================================================

/**
 * @protected
 * @param {string} sId the id of the item to select
 */
UCF_Listbox_MultiInteraction["prototype"]["selectItemById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["selectItemById"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemById"](sId);

	if (
		!this["bReadonly"] &&
		oIM["bIsWriteable"](oItem) &&
		!oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])
	) {
		this["extendSelectionWithItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["selectItemById"] = 0; };

/**
 * @protected
 * @param {string} sId the id of the item to deselect
 */
UCF_Listbox_MultiInteraction["prototype"]["deselectItemById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["deselectItemById"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemById"](sId);

	if (
		!this["bReadonly"] &&
		oIM["bIsWriteable"](oItem) &&
		oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])
	) {
		this["extendSelectionWithItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["deselectItemById"] = 0; };

/**
 * @protected
 * @param {Array.<string>} aKeys the list of keys of items to select
 */
UCF_Listbox_MultiInteraction["prototype"]["selectItemsByKeys"] = function(aKeys) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["selectItemsByKeys"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM;
	/** @type {UCF_Listbox_MultiInteraction} */
	var self;

	if (aKeys && aKeys["length"] > 0) {
		oIM = this["oControl"]["oGetItemsManager"]();
		self = this;

		oIM["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
		UCF_JsUtil["forEach"](aKeys, function(sKey) {
			self["extendSelectionWithItem"](oIM["oFindItemByKey"](sKey));
		});
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiInteraction["_"]["selectItemsByKeys"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_MultiSelect"] = function() {/* global UCF_Listbox_MultiInteraction */
/// <reference path="./delegates/Listbox_MultiInteraction.js"/>
/* global UCF_Listbox */
/// <reference path="./Listbox.js"/>

/**
 * @ct LIB_M
 * @class UCF_Listbox_MultiSelect
 * @extends UCF_ItemListBox
 * @param {HTMLDivElement} oDomRef the DOM element
 * @param {UCF_LS} oLS the LightSpeed instance
 */
function UCF_Listbox_MultiSelect(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelect["_"]["UCF_Listbox_MultiSelect"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox["apply"](this, [oDomRef, oLS]);

		this["oInteraction"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_MultiInteraction"))(this);
		this["addDelegate"](this["oInteraction"]);
	}
};window["UCF_Listbox_MultiSelect"] = UCF_Listbox_MultiSelect; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_MultiSelect"); UCF_Listbox_MultiSelect["_"] = {UCF_Listbox_MultiSelect: 0}; }; ;
UCF_Listbox_MultiSelect["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox"))(); UCF_Listbox_MultiSelect.prototype["sClassName"] = "UCF_Listbox_MultiSelect";

/**
 * Destructor
 * @private
 */
UCF_Listbox_MultiSelect["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelect["_"]["destroy"]++; }; 
	if (this["oInteraction"]) {
		this["oInteraction"]["destroy"]();
		this["oInteraction"] = null;
	}
	UCF_Listbox.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelect["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_MultiSelectionInteraction"] = function() {/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Listbox_Items */
/// <reference path="../Listbox_Items.js"/>
/* global UCF_Listbox_Interaction */
/// <reference path="./Listbox_Interaction.js"/>

/**
 * @class UCF_Listbox_MultiSelectionInteraction
 * @extends UCF_Listbox_Interaction
 * @param {UCF_Listbox_MultiSelect} oControl the listbox
 * @param {UCF_Listbox_Items} [oItems] the items
 */
function UCF_Listbox_MultiSelectionInteraction(oControl, oItems) {if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["UCF_Listbox_MultiSelectionInteraction"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox_Interaction["apply"](this, arguments);

		/** @type {string} */
		this["sAccessibilityCt"] = 'ILBM';

		/** @type {boolean} */
		this["bTouchstartSelected"] = false;
	}
};window["UCF_Listbox_MultiSelectionInteraction"] = UCF_Listbox_MultiSelectionInteraction; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_MultiSelectionInteraction"); UCF_Listbox_MultiSelectionInteraction["_"] = {UCF_Listbox_MultiSelectionInteraction: 0}; }; ;
UCF_Listbox_MultiSelectionInteraction["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_Interaction"))(); UCF_Listbox_MultiSelectionInteraction.prototype["sClassName"] = "UCF_Listbox_MultiSelectionInteraction";

// ===== keydown ==============================================================

/** @override */
// eslint-disable-next-line complexity
UCF_Listbox_MultiSelectionInteraction["prototype"]["onkeydown"] = function(oKeydown) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["onkeydown"]++; }; 
	var bHandled = false;

	/* beautify preserve:start */
	// [DOWN]
if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"])) {
	this["focusItem"](this["oGetItemRelativeToFocused"](1));
	bHandled = true;
} else
	// [UP]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"])) {
		this["focusItem"](this["oGetItemRelativeToFocused"](-1));
		bHandled = true;
	} else
	// [CTRL][DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetItemRelativeToFocused"](1));
		bHandled = true;
	} else
	// [SPACE] or [ENTER]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"]) ||
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ENTER"])
	) {
		if (this["bHasState"](this["oGetFocusedItem"](), UCF_Listbox_Items["STATE"]["Selected"])) {
			this["deselectItem"](this["oGetFocusedItem"]());
		}
		else {
			this["selectItem"](this["oGetFocusedItem"]());
		}
		bHandled = true;
	} else
	// [CTRL][UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetItemRelativeToFocused"](-1));
		bHandled = true;
	} else
	// [CTRL][PAGE_DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_DOWN"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetItemRelativeToFocused"](
			UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [CTRL][PAGE_UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_UP"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetItemRelativeToFocused"](
			-UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [CTRL][HOME]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["HOME"], 'C')) {
		this["extendSelectionWithItem"](this["oGetFirstWriteableItem"]());
		bHandled = true;
	} else
	// [CTRL][END]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["END"], 'C')) {
		this["extendSelectionWithItem"](this["oGetLastWriteableItem"]());
		bHandled = true;
	} else
	// [CTRL][SPACE] and [CTRL][ENTER]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"], 'C') ||
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ENTER"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetFocusedItem"]());
		bHandled = true;
	} else
	// [SHIFT][DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](1));
		bHandled = true;
	} else
	// [SHIFT][UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](-1));
		bHandled = true;
	} else
	// [SHIFT][PAGE_DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_DOWN"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](
			UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [SHIFT][PAGE_UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_UP"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](
			-UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [SHIFT][HOME]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["HOME"], 'S')) {
		this["extendSelectionWithRange"](this["oGetFirstWriteableItem"]());
		bHandled = true;
	} else
	// [SHIFT][END]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["END"], 'S')) {
		this["extendSelectionWithRange"](this["oGetLastWriteableItem"]());
		bHandled = true;
	} else
	// [SHIFT][SPACE] and [SHIFT][ENTER]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"], 'S') ||
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ENTER"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetFocusedItem"]());
		bHandled = true;
	} else {
		UCF_Listbox_Interaction.prototype["onkeydown"]["call"](this, oKeydown);
	}
	/* beautify preserve:end */

	if (bHandled) {
		oKeydown["cancel"]();
		oKeydown["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["onkeydown"] = 0; };

// ===== mousedown ============================================================

/**
 * @private
 * @param {UCF_BrowserEvent} oMousedown the mousedown
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["onmousedown"] = function(oMousedown) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["onmousedown"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemByDomRef"](oMousedown["oGetSource"]());

	if (oIM["bIsWriteable"](oItem)) {
		if (oMousedown && oMousedown["bIsTouchInteraction"]()) {
			// if touch handle is drag source don't toggle selection here
			// as it is handled in onlstouchstart
			if (!this["bOnDragHandle"](oMousedown)) {
				this["extendSelectionWithItem"](oItem);
			}
		} else if (oMousedown["bCtrl"]()) {
			this["extendSelectionWithItem"](oItem);
		} else if (oMousedown["bShift"]()) {
			this["extendSelectionWithRange"](oItem);
		} else if (oIM["aFindItemsByState"](UCF_Listbox_Items["STATE"]["Selected"])["length"] === 0) {
			// select only if no drag & drop is performed
			this["selectItem"](oItem);
		} else {
			this["interactWithItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["onmousedown"] = 0; };

// ===== click ================================================================
/**
 * @private
 * @param {UCF_BrowserEvent} oClick the click
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["onclick"] = function(oClick) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["onclick"]++; }; 
	if (oClick && !oClick["bIsTouchInteraction"]()
		&& !oClick["bCtrl"]()
		&& !oClick["bShift"]()) {
		this["selectItem"](
			this["oControl"]["oGetItemsManager"]()["oFindItemByDomRef"](oClick["oGetSource"]())
		);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["onclick"] = 0; };

// ===== onlstouchstart =======================================================
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the touchstart
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["onlstouchstart"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {Item} */
	var oItem = oIM["oFindItemByDomRef"](oBrowserEvent["oGetSource"]());

	this["bTouchstartSelected"] = false;

	// if touch handle is source select item
	if (this["bOnDragHandle"](oBrowserEvent)) {
		if (oIM["bIsWriteable"](oItem) &&
			!oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])) {
			this["bTouchstartSelected"] = true;
			this["extendSelectionWithItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["onlstouchstart"] = 0; };

// ===== onlstouchend =========================================================
/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the onlstouchend
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["onlstouchend"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {Item} */
	var oItem = oIM["oFindItemByDomRef"](oBrowserEvent["oGetSource"]());

	// if touch handle is source select item
	if (this["bOnDragHandle"](oBrowserEvent)) {
		if (oIM["bIsWriteable"](oItem) &&
			oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]) &&
			!this["bTouchstartSelected"]) {
			this["extendSelectionWithItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["onlstouchend"] = 0; };

// ===== helpers ==============================================================

/**
 * @private
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["extendSelectionWithItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["extendSelectionWithItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	if (!this["bReadonly"] && oIM["bIsWriteable"](oItem)) {
		if (oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])) {
			oIM["removeState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
		} else {
			oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
		}
		this["focusItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["extendSelectionWithItem"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["extendSelectionWithRange"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["extendSelectionWithRange"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {Array.<Array.<_RangeItem>>} */
	var aSelectedRanges = UCF_JsUtil["reduce"](
		oIM["aFindItemsByStates"](
			[UCF_Listbox_Items["STATE"]["Selected"]],
			UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"]
		),
		/**
		 * @param {Array.<Array.<_RangeItem>>} aRanges the ranges
		 * @param {UCF_Listbox_Item} oSelectedItem the item
		 * @return {Array.<Array.<_RangeItem>>}
		 */
		function(aRanges, oSelectedItem) {
			/** @type {number} */
			var iRangesLength = aRanges["length"];
			/** @type {Array.<_RangeItem>} */
			var aLastRange;
			/** @type {number} */
			var iLastRangeLength;

			if (iRangesLength === 0) {
				aRanges["push"]([oSelectedItem]);
			} else {
				aLastRange = aRanges[iRangesLength - 1];
				iLastRangeLength = aLastRange["length"];

				if (
					oIM["iGetItemIndex"](aLastRange[iLastRangeLength - 1]) ===
					oIM["iGetItemIndex"](oSelectedItem) - 1
				) {
					aLastRange["push"](oSelectedItem);
				} else {
					aRanges["push"]([oSelectedItem]);
				}
			}

			return aRanges;
		},
		[]
	);
	/** @type {Array.<UCF_Listbox_Item>} */
	var aLastInteractedRange = UCF_JsUtil["find"](
		aSelectedRanges,
		/**
		 * @param {Array.<UCF_Listbox_Item>} aRange the range
		 * @return {boolean}
		 */
		function(aRange) {
			return UCF_JsUtil["some"](
				aRange,
				/**
				 * @param {UCF_Listbox_Item} o the item
				 * @return {boolean}
				 */
				function(o) {
					return oIM["bHasState"](o, UCF_Listbox_Items["STATE"]["LastInteractedWith"]);
				}
			);
		}
	) || (aSelectedRanges["length"] > 0 && aSelectedRanges[0]);
	/** @type {number} */
	var iCurrentIndex;
	/** @type {number} */
	var iMinIndex;

	if (
		UCF_JsUtil["bIsArray"](aLastInteractedRange) &&
		aLastInteractedRange["length"] > 0
	) {
		iCurrentIndex = oIM["iGetItemIndex"](oItem);
		iMinIndex = oIM["iGetItemIndex"](aLastInteractedRange[0]);

		oIM["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
		UCF_JsUtil["forEach"](
			iCurrentIndex < iMinIndex
			? oIM["aFindItemsByIndexRange"](
				iCurrentIndex,
				oIM["iGetItemIndex"](aLastInteractedRange[aLastInteractedRange["length"] - 1])
			)
			: oIM["aFindItemsByIndexRange"](
				iMinIndex,
				iCurrentIndex
			),
			function(o) {
				if (!oIM["bHasState"](o, UCF_Listbox_Items["STATE"]["Disabled"])) {
					oIM["addState"](o, UCF_Listbox_Items["STATE"]["Selected"]);
				}
			}
		);
	} else {
		oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
	}
	this["focusItem"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["extendSelectionWithRange"] = 0; };

// ===== api ==================================================================

/**
 * @protected
 * @param {string} sId the id of the item to select
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["selectItemById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["selectItemById"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemById"](sId);

	if (
		!this["bReadonly"] &&
		oIM["bIsWriteable"](oItem) &&
		!oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])
	) {
		this["extendSelectionWithItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["selectItemById"] = 0; };

/**
 * @protected
 * @param {string} sId the id of the item to deselect
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["deselectItemById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["deselectItemById"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemById"](sId);

	if (
		!this["bReadonly"] &&
		oIM["bIsWriteable"](oItem) &&
		oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])
	) {
		this["extendSelectionWithItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["deselectItemById"] = 0; };

/**
 * @protected
 * @param {Array.<string>} aKeys the list of keys of items to select
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["selectItemsByKeys"] = function(aKeys) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["selectItemsByKeys"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM;
	/** @type {UCF_Listbox_MultiSelectionInteraction} */
	var self;

	if (aKeys && aKeys["length"] > 0) {
		oIM = this["oControl"]["oGetItemsManager"]();
		self = this;

		oIM["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
		UCF_JsUtil["forEach"](aKeys, function(sKey) {
			self["extendSelectionWithItem"](oIM["oFindItemByKey"](sKey));
		});
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["selectItemsByKeys"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["selectItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["selectItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	if (!this["bReadonly"] && oIM["bIsWriteable"](oItem)) {
		//	oIM.clearState(UCF_Listbox_Items.STATE.Selected);
		oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
	}
	this["focusItem"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["selectItem"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["deselectItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["deselectItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	if (!this["bReadonly"] && oIM["bIsWriteable"](oItem)) {
		//	oIM.clearState(UCF_Listbox_Items.STATE.Selected);
		oIM["removeState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
	}
	this["focusItem"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["deselectItem"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the element or item
 * @param {UCF_Listbox_Items.STATE} iState the state to check
 * @return {boolean}
 */
UCF_Listbox_MultiSelectionInteraction["prototype"]["bHasState"] = function(oItem, iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["bHasState"]++; }; 
	var oIM = this["oControl"]["oGetItemsManager"]();
	return oIM["bHasState"](oItem, iState);
};;if (__UCF_COVERAGE__) { UCF_Listbox_MultiSelectionInteraction["_"]["bHasState"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_OverlayDelegate"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global _trace, INFO, DEBUG */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_LayeredControl */
/// <reference path="../base/LayeredControl.js"/>
/* global UCF_Listbox_Items */
/// <reference path="../Listbox_Items.js"/>
/* global UCF_Fields_OverlayDelegate */
/// <reference path="../delegates/Fields_OverlayDelegate.js"/>

/**
 * @class
 * @extends UCF_Object
 * @param {UCF_Listbox_Popup} oControl
 */
function UCF_Listbox_OverlayDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["UCF_Listbox_OverlayDelegate"]++; }; 
	if (arguments["length"] > 0) {
		/** @type {UCF_Listbox_Popup} */
		this["oControl"] = oControl;
		/** @type {UCF_LS} */
		this["oLS"] = this["oControl"]["oLS"];
		/** @type {UCF_Page} */
		var oPage;

		this["oControl"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["OVERLAY"]);
		this["iSafetyDistance"] = this["oControl"]["iSafetyDistance"];
		this["oControl"]["setSafetyDistance"](0);

		// we need to restore iGetTop() once the delegate is removed
		this["fGetTop"] = this["oControl"]["iGetTop"];

		this["oControl"]["iGetTop"] = function() {
			return this["oOpenerRef"]["offsetHeight"];
		};

		this["oControl"]["attachAfterEvent"](this["oControl"]["E_EVENTS"]["Open"], this, 'onOpen');
		this["oControl"]["attachAfterEvent"](this["oControl"]["E_EVENTS"]["Close"], this, 'onClose');
		this["oControl"]["attachAfterEvent"](this["oControl"]["E_EVENTS"]["HeightChange"], this, 'onHeightChange');
		this["oControl"]["attachAfterEvent"](this["oControl"]["E_EVENTS"]["LayeredControlResize"], this, 'onLayeredControlResize');

		oPage = this["oLS"]["oGetPageInternal"]();
		if (oPage) {
			oPage["attachEvent"](oPage["E_EVENTS"]["WindowResize"], this, 'onWindowResize');
		}
	}
};window["UCF_Listbox_OverlayDelegate"] = UCF_Listbox_OverlayDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_OverlayDelegate"); UCF_Listbox_OverlayDelegate["_"] = {UCF_Listbox_OverlayDelegate: 0}; }; ;
UCF_Listbox_OverlayDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Listbox_OverlayDelegate.prototype["sClassName"] = "UCF_Listbox_OverlayDelegate";

UCF_Listbox_OverlayDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["destroy"]++; }; 
	/** @type {UCF_Page} */
	var oPage = this["oLS"]["oGetPageInternal"]();

	if (oPage) {
		oPage["detachEvent"](oPage["E_EVENTS"]["WindowResize"], this, 'onWindowResize');
	}
	if (this["oControl"]) {
		this["oControl"]["detachAfterEvent"](this["oControl"]["E_EVENTS"]["Open"], this, 'onOpen');
		this["oControl"]["detachAfterEvent"](this["oControl"]["E_EVENTS"]["Close"], this, 'onClose');
		this["oControl"]["detachAfterEvent"](this["oControl"]["E_EVENTS"]["HeightChange"], this, 'onHeightChange');
		this["oControl"]["detachAfterEvent"](this["oControl"]["E_EVENTS"]["LayeredControlResize"], this, 'onLayeredControlResize');

		this["oControl"]["iGetTop"] = this["fGetTop"];
		this["fGetTop"] = null;
		this["oControl"] = null;
		this["iSafetyDistance"] = null;
	}
	this["oLS"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["destroy"] = 0; };

/** @protected */
UCF_Listbox_OverlayDelegate["prototype"]["onOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["onOpen"]++; }; 
	/** @type {string} */
	var sCancelOverlayId = this["oControl"]["sId"] + '-canceloverlay';
	/** @type {HTMLDivElement} */
	var oCancelOverlayRef;

	this["iSafetyDistance"] = this["oControl"]["iSafetyDistance"];
	this["oControl"]["setSafetyDistance"](0);

	if (!UCF_DomUtil["$"](sCancelOverlayId)) {
		this["oControl"]["oActionItems"]["addItem"](
			sCancelOverlayId,
			this["oLS"]["sGetText"]('SAPUR_CALC_OK'),
			'',
			''
		);
	}

	oCancelOverlayRef = document["getElementById"](sCancelOverlayId);
	UCF_DomUtil["addClass"](oCancelOverlayRef, 'lsListbox__canceloverlay');
	UCF_DomUtil["addClass"](this["oControl"]["oRootRef"], 'lsListbox--overlay');
};;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["onOpen"] = 0; };

/** @protected */
UCF_Listbox_OverlayDelegate["prototype"]["onClose"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["onClose"]++; }; 
	// close can come twice:
	// - Listbox fires a Close to SuggestBox and OverlayDelegate
	// - the SuggestBox comes first, closes the ListBox
	// - this fires a second Close event which is dispatched first
	// - after that, the original Close is dispatched to the OverlayDelegate,
	//   but the delegate already got removed
	if (this["oControl"]) {
		UCF_DomUtil["removeClass"](this["oControl"]["oRootRef"], 'lsListbox--overlay');
		UCF_DomUtil["setStyle"](this["oControl"]["oDomRef"], { "height": '' });
		this["oControl"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"]);
		this["oControl"]["iGetTop"] = this["fGetTop"];
		this["oControl"]["iSafetyDistance"] = this["iSafetyDistance"];
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["onClose"] = 0; };

/** @protected */
UCF_Listbox_OverlayDelegate["prototype"]["onHeightChange"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["onHeightChange"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {UCF_LS_VisualViewport} */
	var oVisualViewport;
	/** @type {number} */
	var iItemHeight;
	/** @type {number} */
	var iAvailableHeight;
	/** @type {number} */
	var iActionItemsHeight;
	/** @type {number} */
	var iAvailableWidth;

	this["oControl"]["_oVisualViewport"] = null;
	oVisualViewport = this["oControl"]["oGetVisualViewport"]();
	iAvailableHeight = oVisualViewport["height"] - this["oControl"]["oOpenerRef"]["offsetHeight"];
	iAvailableWidth = oVisualViewport["width"];

	this["onOpen"]();

	// onOpen() creates the "Cancel" ActionItem => have to calculate afterwards
	iItemHeight = UCF_Listbox_Items["iGetItemHeight"]();
	iActionItemsHeight = this["oControl"]["oActionItems"]["iGetItemCount"]() * iItemHeight;

	UCF_DomUtil["setStyle"](this["oControl"]["oDomRef"], {
		"height": iAvailableHeight + 'px',
		"minWidth": iAvailableWidth + 'px'
	});
	UCF_DomUtil["setStyle"](oIM["oGetItemsRef"](), {
		"height": iAvailableHeight - iActionItemsHeight + 'px',
		"maxHeight": iAvailableHeight - iActionItemsHeight + 'px',
		"width": iAvailableWidth + 'px'
	});
	UCF_DomUtil["setStyle"](this["oControl"]["oDomRef"], {
		"top": this["oControl"]["iTop"] + 'px',
		"left": 0 + 'px'
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["onHeightChange"] = 0; };

/** @protected */
UCF_Listbox_OverlayDelegate["prototype"]["onWindowResize"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["onWindowResize"]++; }; 
	/** @type {UCF_Listbox_OverlayDelegate} */
	var self = this;

	// iOS iPhone/iPad workaround: address bar will change clientHeight which is not
	// represented in document.documentElement.clientHeight in iOS 13.2.3
	// still in fullscreen iOS will send wrong clientHeight as in portrait mode
	// the browsers' footer toolbar is missing

	this["oControl"]["requestAnimationFrame"](function() {
		if (self["oControl"] && self["oControl"]["oOpenerRef"]) {
			self["onHeightChange"]();
			if (UCF_UserAgent["bIsIOS"]() && (UCF_UserAgent["bIsTablet"]() || UCF_UserAgent["bIsPhone"]())) {
				UCF_DomUtil["moveFocusDomElement"](self["oControl"]["oRootRef"], true);
			}
		}
	});
	if (UCF_UserAgent["bIsIOS"]() && (UCF_UserAgent["bIsTablet"]() || UCF_UserAgent["bIsPhone"]())) {
		this["oControl"]["requestAnimationFrame"](function() {
			UCF_DomUtil["setStyle"](document["body"]["parentElement"], { "height": '1000px' });
			self["oControl"]["requestAnimationFrame"](function() {
				UCF_DomUtil["setStyle"](document["body"]["parentElement"], { "height": '100%' });
			});
		});
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["onWindowResize"] = 0; };

/** @protected */
UCF_Listbox_OverlayDelegate["prototype"]["onLayeredControlResize"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["onLayeredControlResize"]++; }; 
	this["onWindowResize"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["onLayeredControlResize"] = 0; };

/**
 * @protected
 * @return {number}
 */
UCF_Listbox_OverlayDelegate["prototype"]["iGetOptimalNumberOfItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["iGetOptimalNumberOfItems"]++; }; 
	/** @type {number} */
	var iAvailableHeight;
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {number} */
	var iItemHeight;
	/** @type {number} */
	var iOptimalItems;
	/** @type {number} */
	var iOpenerRefOffsetHeight;
	/** @type {HTMLElement} */
	var oOpenerRef;

	if (oIM && this["oControl"] && this["oControl"]["oOpenerRef"]) {
		iItemHeight = UCF_Listbox_Items["iGetItemHeight"]();
		oOpenerRef = document["getElementById"](this["oControl"]["oOpenerRef"]["id"]);

		// check if overlay header is the openerRef, else create header
		// just so we will find out exactly how many items fit in the overlay
		if (oOpenerRef && UCF_StringUtil["bEndsWith"](oOpenerRef["id"], '-header')) {
			iOpenerRefOffsetHeight = this["oControl"]["oOpenerRef"]["offsetHeight"];
		} else {
			iOpenerRefOffsetHeight = this["iCreateHeaderAndReturnHeight"]();
		}

		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "iOpenerRefOffsetHeight: " + iOpenerRefOffsetHeight, "Listbox_OverlayDelegate.js(226): iGetOptimalNumberOfItems"); };

		iAvailableHeight = window["innerHeight"] -
			iOpenerRefOffsetHeight -
			iItemHeight; // this is the overlay action item (!)

		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "window.innerHeight: " + window["innerHeight"], "Listbox_OverlayDelegate.js(232): iGetOptimalNumberOfItems"); };
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "iItemHeight: " + iItemHeight, "Listbox_OverlayDelegate.js(233): iGetOptimalNumberOfItems"); };

		// -2 for the two lines "Search Result" and the table header
		iOptimalItems = Math["floor"]((iAvailableHeight / iItemHeight) - 2);

		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Optimal Number of Listbox Items: " + iOptimalItems, "Listbox_OverlayDelegate.js(238): iGetOptimalNumberOfItems"); };

		return iOptimalItems;
	} else {
		return 10;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["iGetOptimalNumberOfItems"] = 0; };

/**
 * @protected
 * @return {number}
 */
UCF_Listbox_OverlayDelegate["prototype"]["iCreateHeaderAndReturnHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["iCreateHeaderAndReturnHeight"]++; }; 
	/** @type {UCF_Fields_OverlayDelegate} */
	var oOverlayDelegate = new (UCF_ClassLoader["oGetClass"]("UCF_Fields_OverlayDelegate"))(this);
	/** @type {number} */
	var iContainerOffsetHeight = null;
	/** @type {UCF_oClientComboBox} */
	var oClientComboBox;

	this["oControl"]["addDelegate"](oOverlayDelegate);
	oOverlayDelegate["addContainer"](this["oControl"]["oOpenerRef"]);

	// create InputField in Container
	oClientComboBox = this["oLS"]["oCreateClientControl"]('ComboBox');
	oClientComboBox["sId"] = this["oControl"]["sId"] + '-tempcombobox';
	oClientComboBox["placeAt"](oOverlayDelegate["oHeaderContainer"]);

	iContainerOffsetHeight = oOverlayDelegate["oHeaderContainer"]["offsetHeight"];

	oOverlayDelegate["removeContainer"](this["oControl"]["oOpenerRef"]);
	this["oControl"]["removeDelegate"](oOverlayDelegate);
	this["oControl"]["oOverlayDelegate"] = null;
	this["oControl"]["oOpenerRef"] = null;

	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'setOpenerRef -> null ' + this["oControl"]["sId"], "Listbox_OverlayDelegate.js(273): iCreateHeaderAndReturnHeight"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "iContainerOffsetHeight: " + iContainerOffsetHeight, "Listbox_OverlayDelegate.js(274): iCreateHeaderAndReturnHeight"); };

	return iContainerOffsetHeight;
};;if (__UCF_COVERAGE__) { UCF_Listbox_OverlayDelegate["_"]["iCreateHeaderAndReturnHeight"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_Popup"] = function() {/* global _assert, _trace, DEBUG, INFO, WARNING, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Listbox_Items */
/// <reference path="./Listbox_Items.js"/>
/* global UCF_Listbox_ActionItems */
/// <reference path="./Listbox_ActionItems.js"/>
/* global UCF_ItemListBox */
/// <reference path="./base/ItemListBox.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_Listbox_ActiveInteractionDelegate */
/// <reference path="./delegates/Listbox_ActiveInteractionDelegate.js"/>
/* global UCF_Listbox_HoverInteractionDelegate */
/// <reference path="./delegates/Listbox_HoverInteractionDelegate.js"/>
/* global UCF_Listbox_OverlayDelegate */
/// <reference path="./delegates/Listbox_OverlayDelegate.js"/>
/* global UCF_Listbox_TruncationDelegate */
/// <reference path="./delegates/Listbox_TruncationDelegate.js"/>

/** @typedef {_MaybeItem|UCF_Listbox_ActionItem} _AnyItem */

/** @typedef {0} UCF_Listbox_Popup_CloseEvent */
/** @typedef {1} UCF_Listbox_Popup_SelectEvent */
/** @typedef {2} UCF_Listbox_Popup_ActivateEvent */
/** @typedef {3} UCF_Listbox_Popup_ActionActivateEvent */
/** @typedef {4} UCF_Listbox_Popup_DeleteItemEvent */
/** @typedef {5} UCF_Listbox_Popup_FocusChangeEvent */
/** @typedef {6} UCF_Listbox_Popup_OpenEvent */
/** @typedef {7} UCF_Listbox_Popup_HeightChangeEvent */
/** @typedef {8} UCF_Listbox_Popup_WillDeleteItemEvent */
/** @typedef {9} UCF_Listbox_Popup_LayeredControlResizeEvent */
/** @typedef {10} UCF_Listbox_Popup_DidDeleteItemEvent */
/** @typedef {UCF_Listbox_Popup_CloseEvent|UCF_Listbox_Popup_SelectEvent|UCF_Listbox_Popup_ActivateEvent|UCF_Listbox_Popup_ActionActivateEvent|UCF_Listbox_Popup_DeleteItemEvent|UCF_Listbox_Popup_FocusChangeEvent|UCF_Listbox_Popup_OpenEvent|UCF_Listbox_Popup_HeightChangeEvent|UCF_Listbox_Popup_WillDeleteItemEvent|UCF_Listbox_Popup_LayeredControlResizeEvent|UCF_Listbox_Popup_DidDeleteItemEvent} UCF_Listbox_Popup_Event */
/**
 * @typedef {Object} UCF_Listbox_Popup_EventEnum
 * @property {UCF_Listbox_Popup_CloseEvent} Close
 * @property {UCF_Listbox_Popup_SelectEvent} Select
 * @property {UCF_Listbox_Popup_ActivateEvent} Activate
 * @property {UCF_Listbox_Popup_ActionActivateEvent} ActionActivate
 * @property {UCF_Listbox_Popup_DeleteItemEvent} DeleteItem
 * @property {UCF_Listbox_Popup_FocusChangeEvent} FocusChange
 * @property {UCF_Listbox_Popup_OpenEvent} Open
 * @property {UCF_Listbox_Popup_HeightChangeEvent} HeightChange
 * @property {UCF_Listbox_Popup_WillDeleteItemEvent} WillDeleteItem
 * @property {UCF_Listbox_Popup_LayeredControlResizeEvent} LayeredControlResize
 * @property {UCF_Listbox_Popup_DidDeleteItemEvent} DidDeleteItem
 */
/** @typedef {'firstitem'} UCF_Listbox_Popup_FirstItemSelectType */
/** @typedef {'previousitem'} UCF_Listbox_Popup_PreviousItemSelectType */
/** @typedef {'click'} UCF_Listbox_Popup_ClickSelectType */
/** @typedef {'mouseover'} UCF_Listbox_Popup_MouseoverSelectType */
/** @typedef {'nextitem'} UCF_Listbox_Popup_NextItemSelectType */
/** @typedef {'pagedown'} UCF_Listbox_Popup_PageDownSelectType */
/** @typedef {'lastitem'} UCF_Listbox_Popup_LastItemSelectType */
/** @typedef {UCF_Listbox_Popup_FirstItemSelectType|UCF_Listbox_Popup_PreviousItemSelectType|UCF_Listbox_Popup_ClickSelectType|UCF_Listbox_Popup_MouseoverSelectType|UCF_Listbox_Popup_NextItemSelectType|UCF_Listbox_Popup_PageDownSelectType|UCF_Listbox_Popup_LastItemSelectType} UCF_Listbox_Popup_SelectType */
/**
 * @typedef {Object} UCF_Listbox_Popup_SelectTypeEnum
 * @property {UCF_Listbox_Popup_FirstItemSelectType} FirstItem
 * @property {UCF_Listbox_Popup_PreviousItemSelectType} PreviousItem
 * @property {UCF_Listbox_Popup_ClickSelectType} Click
 * @property {UCF_Listbox_Popup_MouseoverSelectType} Mouseover
 * @property {UCF_Listbox_Popup_NextItemSelectType} NextItem
 * @property {UCF_Listbox_Popup_PageDownSelectType} PageDown
 * @property {UCF_Listbox_Popup_LastItemSelectType} LastItem
 */
/**
 * @class UCF_Listbox_Popup
 * @extends UCF_ItemListBox
 *
 * @param {HTMLDivElement} oDomRef the dom element
 * @param {UCF_LS} oLS the lightspeed instance
 */
function UCF_Listbox_Popup(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["UCF_Listbox_Popup"]++; }; 
	if (arguments["length"] > 0) {
		UCF_ItemListBox["apply"](this, arguments);

		// have to implement at least the same interface as the ComboBoxListBox
		this["defineEvents"]([
			'Close',
			'Select',
			'Activate',
			'ActionActivate',
			'DeleteItem',
			'FocusChange',
			'Open',
			'HeightChange',
			'WillDeleteItem',
			'LayeredControlResize',
			'DidDeleteItem',
			'WillDestroy'
		]);

		/** @type {string} */
		this["sTooltip"] = this["oRootRef"]["title"] || '';
		/** @type {number} */
		this["iMinWidthPx"] = null;
		/** @type {string} */
		this["sSelectEvent"] = null;
		/** @type {boolean} */
		this["bShouldFireSelect"] = false;
		/** @type {number} */
		this["iCurrentlyVisibleItems"] = this["iVisibleItems"];
		/** @type {UCF_Cache} */
		this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

		/** @override @type {boolean} magic magic that makes iframe popups larger */
		this["bEnhancePopupWindows"] = true;
		/** @type {boolean} */
		this["bTopAttached"] = null;
		/** @type {boolean} */
		this["bOpenCloseImmediate"] = false;

		// adds/removes any UCF_Listbox_ActiveInteractionDelegate
		this["setReadonly"](this["bReadonly"]);
		this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_HoverInteractionDelegate"))(this));

		this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_TruncationDelegate"))(this));

		/** @type {boolean} */
		this["bShouldShowOverlay"] = false;

		if (/S$/["test"](this["oDomRef"]["getAttribute"]('ct'))) {
			// need "multi-inheritance" for Listbox_Suggest and Listbox_JsonSuggest
			UCF_ClassLoader["oGetClass"]('UCF_Listbox_Suggest')["extend"](this);
		}

		this["setSafetyDistance"](UCF_LayeredControl["MIN_BORDER_DISTANCE"]);

		/** @type {string} */
		this["sAppearDelayedCallId"] = null;
		/** @type {string} */
		this["sDisappearDelayedCallId"] = null;
	}
};window["UCF_Listbox_Popup"] = UCF_Listbox_Popup; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_Popup"); UCF_Listbox_Popup["_"] = {UCF_Listbox_Popup: 0}; }; ;
UCF_Listbox_Popup["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemListBox"))(); UCF_Listbox_Popup.prototype["sClassName"] = "UCF_Listbox_Popup";

/**
 * @protected
 * @type {UCF_Listbox_Popup_SelectTypeEnum}
 */
UCF_Listbox_Popup["SELECTTYPE"] = {
	"FirstItem": 'firstitem',
	"PageUp": 'pageup',
	"PreviousItem": 'previousitem',
	"Click": 'click',
	"Mouseover": 'mouseover',
	"NextItem": 'nextitem',
	"PageDown": 'pagedown',
	"LastItem": 'lastitem'
};

/** @const {0} in ms */
UCF_Listbox_Popup["TOUCH_HANDLING_DELAY"] = 0;

/** @const {20} in px */
UCF_Listbox_Popup["POPUP_SAFETY_DISTANCE"] = 20;

// ===== control ==============================================================

/** @override */
UCF_Listbox_Popup["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["destroy"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["WillDestroy"]);

	if (this["sAppearDelayedCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sAppearDelayedCallId"]);
		this["sAppearDelayedCallId"] = null;
	}
	if (this["sDisappearDelayedCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sDisappearDelayedCallId"]);
		this["sDisappearDelayedCallId"] = null;
	}

	this["bOpenCloseImmediate"] = null;

	this["iCurrentlyVisibleItems"] = null;
	this["bReadonly"] = null;
	this["oEventDefaultHandler"] = null;

	if (this["oActiveInteractionDelegate"]) {
		this["oActiveInteractionDelegate"]["destroy"]();
		this["oActiveInteractionDelegate"] = null;
	}

	if (this["oCache"]["has"]('oItemsManager')) {
		this["oGetItemsManager"]()["destroy"]();
	}
	if (this["oCache"]["has"]('oActionItemsManager')) {
		this["oGetActionItemsManager"]()["destroy"]();
	}

	this["oCache"]["destroy"]();
	this["oCache"] = null;

	this["removeOverlay"]();
	this["bShouldShowOverlay"] = null;

	this["iMinWidthPx"] = null;
	this["sTooltip"] = null;
	this["bTopAttached"] = null;

	UCF_ItemListBox.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["destroy"] = 0; };

/**
 * @protected
 * @return {UCF_Listbox_Items}
 */
UCF_Listbox_Popup["prototype"]["oGetItemsManager"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetItemsManager"]++; }; 
	/** @type {UCF_Listbox_Popup} */
	var self = this;

	return this["oCache"] && this["oCache"]["get"]('oItemsManager', function() {
		/** @type {UCF_Listbox_Items} */
		var oIM = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_Items"))(self);

		oIM["attachEvent"](UCF_Listbox_Items["EVENT"]["WillDeleteItemAnimated"], self, 'onWillItemsManagerDeleteItemAnimated');
		oIM["attachEvent"](UCF_Listbox_Items["EVENT"]["DidDeleteItemAnimated"], self, 'onDidItemsManagerDeleteItemAnimated');

		if (UCF_JsUtil["bInstanceOf"](self, "UCF_Listbox_PopupMultiSelect")) {
			oIM["attachEvent"](UCF_Listbox_Items["EVENT"]["StateChange"], self, 'onStateChange');
			// oIM.attachEvent(UCF_Listbox_Items.EVENT.Activate, self, 'onActivate');
		}

		return oIM;
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetItemsManager"] = 0; };

/**
 * @protected
 * @return {UCF_Listbox_ActionItems}
 */
UCF_Listbox_Popup["prototype"]["oGetActionItemsManager"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetActionItemsManager"]++; }; 
	/** @type {UCF_Listbox_Popup} */
	var self = this;

	return this["oCache"]["get"]('oActionItemsManager', function() {
		return new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_ActionItems"))(self);
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetActionItemsManager"] = 0; };

// ===== layered control ======================================================

/** @override */
UCF_Listbox_Popup["prototype"]["open"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["open"]++; }; 
	this["bOpenCloseImmediate"] = !!bImmediate;

	if (this["sDisappearDelayedCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sDisappearDelayedCallId"]);
		this["sDisappearDelayedCallId"] = null;
	}

	if (!this["bOpened"]) {
		UCF_ItemListBox.prototype["open"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["open"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["close"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["close"]++; }; 
	/** @type {number} */
	var iDisappearAnimationDurationMs = UCF_Listbox_Items["iGetDisappearAnimationDurationMs"]();

	this["bOpenCloseImmediate"] = !!bImmediate;

	if (this["sAppearDelayedCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sAppearDelayedCallId"]);
		this["sAppearDelayedCallId"] = null;
	}

	if (this["bOpened"]) {
		if (iDisappearAnimationDurationMs > 0 && !this["bOpenCloseImmediate"]) {
			UCF_DomUtil["addClass"](this["oRootRef"], 'lsListbox--disappearing');
			this["sDisappearDelayedCallId"] = UCF_JsUtil["delayedCall"](
				iDisappearAnimationDurationMs,
				this,
				'onDidDisappear'
			);
		} else {
			UCF_ItemListBox.prototype["close"]["apply"](this, arguments);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["close"] = 0; };

/** @private */
UCF_Listbox_Popup["prototype"]["onDidDisappear"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onDidDisappear"]++; }; 
	this["sDisappearDelayedCallId"] = null;
	if (this["oRootRef"]) {
		UCF_DomUtil["removeClass"](this["oRootRef"], 'lsListbox--disappearing');
	}
	this["closeBase"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onDidDisappear"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["notifyLayerVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["notifyLayerVisible"]++; }; 
	/** @type {number} */
	var iAppearAnimationDurationMs = UCF_Listbox_Items["iGetAppearAnimationDurationMs"]();

	UCF_ItemListBox.prototype["notifyLayerVisible"]["apply"](this, arguments);

	this["bTopAttached"] = this["bIsTopAttached"]();

	if (this["bTopAttached"]) {
		UCF_DomUtil["addClass"](this["oRootRef"], 'lsListbox--topattached');
	}

	if (iAppearAnimationDurationMs > 0 && !this["bOpenCloseImmediate"]) {
		UCF_DomUtil["addClass"](this["oRootRef"], 'lsListbox--appearing');
		this["sAppearDelayedCallId"] = UCF_JsUtil["delayedCall"](
			iAppearAnimationDurationMs,
			this,
			'onDidAppear'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["notifyLayerVisible"] = 0; };

/** @private */
UCF_Listbox_Popup["prototype"]["onDidAppear"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onDidAppear"]++; }; 
	this["sAppearDelayedCallId"] = null;
	UCF_DomUtil["removeClass"](this["oRootRef"], 'lsListbox--appearing');
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onDidAppear"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["notifyLayerHidden"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["notifyLayerHidden"]++; }; 
	UCF_ItemListBox.prototype["notifyLayerHidden"]["apply"](this, arguments);

	this["bTopAttached"] = null;

	// reset default
	this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);
	UCF_DomUtil["removeClass"](this["oRootRef"], 'lsListbox--topattached');
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["notifyLayerHidden"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["setPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["setPosition"]++; }; 
	if (typeof this["bTopAttached"] === 'boolean') {
		this["setAlignment"](this["bTopAttached"]
			? UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"]
			: UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);
	}
	UCF_ItemListBox.prototype["setPosition"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["setPosition"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["addClassesOnOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["addClassesOnOpen"]++; }; 

	UCF_DomUtil["addClass"](this["oRootRef"], UCF_LayeredControl["BOX_SHADOW_CLASS"]);
	if (this["bShouldShowOverlay"]) {
		this["fireEvent"](this["E_EVENTS"]["Open"], {});
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["addClassesOnOpen"] = 0; };

/**
 * @see UCF_ComboBox#onBeforeOpenFieldHelp
 *
 * @override
 */
UCF_Listbox_Popup["prototype"]["applyWidth"] = function(iWidth) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["applyWidth"]++; }; 
	this["iMinWidthPx"] = iWidth;

	this["oRootRef"]["style"]["minWidth"] = iWidth + 'px';

	this["applyWidthBoundaries"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["applyWidth"] = 0; };

/** @private */
UCF_Listbox_Popup["prototype"]["applyWidthBoundaries"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["applyWidthBoundaries"]++; }; 
	/** @type {number} */
	var iMaxWidthPx = this["oGetVisualViewport"]()["width"];
	/** @type {number} */
	var iMinWidthPx = this["iGetMinWidthPx"]();

	UCF_DomUtil["setStyle"](this["oGetItemsManager"]()["oGetItemsRef"](), {
		"maxWidth": iMaxWidthPx + 'px',
		"minWidth": (iMinWidthPx > 0 && iMinWidthPx > this["iMinWidthPx"])
			? Math["min"](iMinWidthPx, iMaxWidthPx) + 'px'
			: 'inherit'
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["applyWidthBoundaries"] = 0; };

/**
 * @protected
 * @return {number}
 */
UCF_Listbox_Popup["prototype"]["iGetMinWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetMinWidthPx"]++; }; 
	return Math["max"](
		this["oGetItemsManager"]()["iGetGroupTitlesMinWidthPx"](),
		UCF_UserAgent["bIsIE"]()
		? this["iGetVisibleItemsWidthPx"]()
		: Number["NEGATIVE_INFINITY"]
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetMinWidthPx"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Listbox_Popup["prototype"]["iGetVisibleItemsWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetVisibleItemsWidthPx"]++; }; 
	/** @type {UCF_Listbox_Popup} */
	var self = this;

	return this["oCache"]["get"]('iVisibleItemsWidthPx', function() {
		/** @type {_MaybeItem[]} */
		var aVisibleItems = self["aGetVisibleItems"]
			? self["aGetVisibleItems"]()
			: self["aGetItems"]();

		return UCF_Listbox_Items["iMeasureListboxWidthPx"](function(oItemsRef) {
			/** @type {HTMLDivElement} */
			var oValuesIconRef;
			/** @type {HTMLDivElement} */
			var oValues1Ref;
			/** @type {HTMLDivElement} */
			var oValues2Ref;

			if (self["sIconVisibility"] !== 'NONE') {
				oValuesIconRef = document["createElement"]('div');
				UCF_DomUtil["setClass"](oValuesIconRef, 'lsListbox__values lsListbox__values--icon');
				UCF_JsUtil["forEach"](aVisibleItems, function(oItem) {
					/** @type {HTMLDivElement} */
					var oValueRef = document["createElement"]('div');

					UCF_DomUtil["setClass"](oValueRef, 'lsListbox__value');
					// eslint-disable-next-line no-unsanitized/property
					UCF_DomUtil["setInnerHtml"](oValueRef, self["oLS"]["oGetRenderManager"]()["callFragment"]('UrBase_IconFragment', 'UrBase', {
						"Id": '',
						"Src": UCF_Listbox_Items["bIsItem"](oItem)
							? oItem["sIconSrc"]
							: UCF_DomUtil["dataset"](oItem)["itemsrc"],
						"SrcOnError": '',
						"Width": '',
						"Height": '',
						"Tooltip": '',
						"AlternativeText": '',
						"CssClass": '',
						"PreventDraging": false
					}));
					UCF_DomUtil["append"](oValuesIconRef, oValueRef);
				});
				UCF_DomUtil["append"](oItemsRef, oValuesIconRef);
			}

			if (self["sFirstValueVisibility"] !== 'NONE') {
				oValues1Ref = document["createElement"]('div');
				UCF_DomUtil["setClass"](oValues1Ref, 'lsListbox__values');
				UCF_JsUtil["forEach"](aVisibleItems, function(oItem) {
					/** @type {HTMLDivElement} */
					var oValueRef = document["createElement"]('div');
					/** @type {{itemvalue1: string, value?: string}} */
					var oData = UCF_Listbox_Items["bIsItem"](oItem)
						? { "itemvalue1": oItem["sValue1"] }
						: UCF_DomUtil["dataset"](oItem);

					UCF_DomUtil["setClass"](oValueRef, 'lsListbox__value');
					// don't use sGetItemValue1() here because it accesses the DOM, which
					// leads to a re-render loop in UCF_Listbox_JsonPopup => access data-itemvalue1
					// directly
					UCF_DomUtil["setInnerText"](oValueRef, oData["value"] || oData["itemvalue1"]);
					UCF_DomUtil["append"](oValues1Ref, oValueRef);
				});
				UCF_DomUtil["append"](oItemsRef, oValues1Ref);
			}

			if (self["sSecondValueVisibility"] !== 'NONE') {
				oValues2Ref = document["createElement"]('div');
				UCF_DomUtil["setClass"](oValues2Ref, 'lsListbox__values');
				UCF_JsUtil["forEach"](aVisibleItems, function(oItem) {
					/** @type {HTMLDivElement} */
					var oValueRef = document["createElement"]('div');
					/** @type {{itemvalue2: string}} */
					var oData = UCF_Listbox_Items["bIsItem"](oItem)
						? { "itemvalue2": oItem["sValue1"] }
						: UCF_DomUtil["dataset"](oItem);

					UCF_DomUtil["setClass"](oValueRef, 'lsListbox__value');
					// see above
					UCF_DomUtil["setInnerText"](oValueRef, oData["itemvalue2"]);
					UCF_DomUtil["append"](oValues2Ref, oValueRef);
				});
				UCF_DomUtil["append"](oItemsRef, oValues2Ref);
			}
		});
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetVisibleItemsWidthPx"] = 0; };

/**
 * @see UCF_ComboBox#onBeforeOpenFieldHelp
 *
 * @override
 */
UCF_Listbox_Popup["prototype"]["applyHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["applyHeight"]++; }; 
	/** @type {HTMLDivElement} */
	var oItemsRef = this["oGetItemsManager"]()["oGetItemsRef"]();
	/** @type {string} */
	var sHeight;
	/** @type {string} */
	var sValuesHeight;

	if (this["bShouldShowOverlay"]) {
		this["addOverlay"]();
	}

	this["iCurrentlyVisibleItems"] = this["iGetMaxVisibleItems"]();
	sHeight = this["iCurrentlyVisibleItems"] + 'em';
	UCF_DomUtil["setStyle"](oItemsRef, {
		"height": sHeight,
		"maxHeight": sHeight
	});

	sValuesHeight = this["iGetVisibleLines"]() + 'em';

	if (UCF_UserAgent["bIsIE"]()) {
		UCF_JsUtil["forEach"](UCF_JsUtil["arrayFrom"](oItemsRef["childNodes"]), function(oValuesRef) {
			UCF_DomUtil["setStyle"](oValuesRef, { "height": sValuesHeight });
		});
	}

	if (this["bShouldShowOverlay"]) {
		this["fireEvent"](this["E_EVENTS"]["HeightChange"], {
			"iVisibleItems": this["iCurrentlyVisibleItems"]
		});
	}

	// reset internal height cache of LayeredControl
	this["_iHeight"] = null;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["applyHeight"] = 0; };

/**
 * {@link UCF_Listbox_Popup#iGetSuggestedItems} for the Listbox_Popup, but may
 * include Headline + Table Header for the Listbox_JsonPopup.
 *
 * @protected
 * @return {number}
 */
UCF_Listbox_Popup["prototype"]["iGetVisibleLines"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetVisibleLines"]++; }; 
	return this["iGetSuggestedItems"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetVisibleLines"] = 0; };

/**
 * @private
 */
UCF_Listbox_Popup["prototype"]["onBeforeResize"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onBeforeResize"]++; }; 
	/** @type {number} */
	var iMaxWidthPx = this["oGetVisualViewport"]()["width"];

	UCF_DomUtil["setStyle"](this["oGetItemsManager"]()["oGetItemsRef"](), {
		"maxWidth": iMaxWidthPx + 'px'
	});

	if (this["bShouldShowOverlay"]) {
		this["fireEvent"](this["E_EVENTS"]["LayeredControlResize"], {});
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onBeforeResize"] = 0; };

/**
 * @private
 */
UCF_Listbox_Popup["prototype"]["addOverlay"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["addOverlay"]++; }; 
	if (this["bShouldShowOverlay"] && !this["oListboxOverlayDelegate"]) {
		this["oListboxOverlayDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_OverlayDelegate"))(this);
		this["addDelegate"](this["oListboxOverlayDelegate"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["addOverlay"] = 0; };

/**
 * @private
 */
UCF_Listbox_Popup["prototype"]["removeOverlay"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["removeOverlay"]++; }; 

	if (this["oListboxOverlayDelegate"]) {
		this["removeDelegate"](this["oListboxOverlayDelegate"]);
		this["oListboxOverlayDelegate"]["destroy"]();
		this["oListboxOverlayDelegate"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["removeOverlay"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Listbox_Popup["prototype"]["iGetMaxVisibleItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetMaxVisibleItems"]++; }; 
	/** @type {UCF_Rect} */
	var oOpenerObjectRect = UCF_DomUtil["oGetObjectRect"](this["oOpenerRef"]);
	/** @type {number} */
	var iScrollTop = UCF_DomUtil["oGetScrollOffset"]()["y"];

	return Math["min"](
		// max visible items
		Math["floor"](
			// max space available
			Math["max"](
				// space above
				oOpenerObjectRect["top"] - iScrollTop,
				// space below
				iScrollTop + this["iGetViewportHeight"]() - oOpenerObjectRect["top"] - oOpenerObjectRect["height"]
			) / UCF_Listbox_Items["iGetItemHeight"]() -
			this["oGetActionItemsManager"]()["iGetItemCount"]()
		),
		this["iGetVisibleLines"](),
		this["iVisibleItems"] > 0 ? this["iVisibleItems"] : Number["POSITIVE_INFINITY"]
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetMaxVisibleItems"] = 0; };

/**
 * @see UCF_Listbox_Suggest#iGetSuggestedItems
 * @protected
 * @return {number} the number of items visible (includes scrolling)
 */
UCF_Listbox_Popup["prototype"]["iGetSuggestedItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetSuggestedItems"]++; }; 
	return this["iGetItemCount"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetSuggestedItems"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Listbox_Popup["prototype"]["iGetViewportHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetViewportHeight"]++; }; 
	/** @type {UCF_Interface} */
	var oPopupWindow = this["oGetParentPopupWindow"]();
	/** @type {UCF_PopupWindow} */
	var oPopupWindowInternal;
	/** @type {HTMLElement} */
	var oFrameElement;

	if (oPopupWindow) {
		oPopupWindowInternal = this["oLS"]["oControlFactory"]["oGetControlById"](
			oPopupWindow["sGetId"]()
		);

		if (oPopupWindowInternal && oPopupWindowInternal["bIsIFramePopup"]()) {
			oFrameElement = this["oLS"]["oWindow"]["frameElement"];

			return oPopupWindow["bEnlargeIFrameForLayeredControlsEnabled"]()
				? Math["max"](
					oFrameElement["offsetHeight"] + UCF_Listbox_Popup["POPUP_SAFETY_DISTANCE"],
					oFrameElement["offsetParent"]["offsetHeight"] - oFrameElement["offsetTop"]
				)
				: oFrameElement["offsetHeight"] + UCF_Listbox_Popup["POPUP_SAFETY_DISTANCE"];
		} else {
			return UCF_DomUtil["iClientHeight"]();
		}
	} else {
		return UCF_DomUtil["iClientHeight"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetViewportHeight"] = 0; };

// ===== browser events =======================================================

/** @override */
UCF_Listbox_Popup["prototype"]["onlsfocus"] = function(oLsFocus) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlsfocus"]++; }; 
	this["fireActivate"]();
	oLsFocus["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlsfocus"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onmousedown"] = function(oMousedown) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onmousedown"]++; }; 
	this["fireActivate"]();

	oMousedown["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onmousedown"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onlstouchstart"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlstouchstart"]++; }; 
	this["bTouchWithoutMove"] = true;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlstouchstart"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onlstouchmove"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlstouchmove"]++; }; 
	this["bTouchWithoutMove"] = false;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlstouchmove"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onlstouchend"] = function(oLsTouchend) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlstouchend"]++; }; 
	/** @type {_AnyItem} */
	var oItem;

	if (this["bTouchWithoutMove"]) {
		if (!this["bReadonly"]) {
			oItem = this["oGetItemsManager"]()["oFindItemByDomRef"](oLsTouchend["oGetSource"]());

			if (oItem) {
				this["handleLsTouchendOnItem"](oLsTouchend, oItem);
			} else {
				oItem = oLsTouchend["oGetSourceControl"]();
				if (this["bIsActionItem"](oItem)) {
					this["handleLsTouchendOnActionItem"](oLsTouchend, oItem);
				} else {
					this["handleLsTouchendOnContainer"]();
				}
			}
		}
	} else {
		this["bTouchWithoutMove"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlstouchend"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oLsTouchend the lstouchend
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_Popup["prototype"]["handleLsTouchendOnItem"] = function(oLsTouchend, oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleLsTouchendOnItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	if (this["bOnDeleteButton"](oLsTouchend)) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'delete item', "Listbox_Popup.js(723): handleLsTouchendOnItem"); };
		this["fireDeleteItem"]({ "sKey": oIM["sGetItemKey"](oItem) });
	} else if (oIM["bIsWriteable"](oItem)) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'select item', "Listbox_Popup.js(726): handleLsTouchendOnItem"); };
		this["_selectItem"](oItem, UCF_Listbox_Popup["SELECTTYPE"]["Click"], true, true);
		UCF_JsUtil["delayedCall"](
			UCF_Listbox_Popup["TOUCH_HANDLING_DELAY"],
			this,
			'fireClose', []
		);
		UCF_JsUtil["delayedCall"](
			UCF_Listbox_Popup["TOUCH_HANDLING_DELAY"],
			this,
			'removeOverlay', []
		);
	}
	oLsTouchend["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleLsTouchendOnItem"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oLsTouchend the lstouchend
 * @param {UCF_Listbox_ActionItem} oItem the action item
 */
UCF_Listbox_Popup["prototype"]["handleLsTouchendOnActionItem"] = function(oLsTouchend, oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleLsTouchendOnActionItem"]++; }; 
	this["selectItem"](oItem);

	UCF_JsUtil["delayedCall"](
		UCF_Listbox_Popup["TOUCH_HANDLING_DELAY"],
		this,
		'fireActionActivate', [{ "sId": oItem["sId"] }]
	);
	UCF_JsUtil["delayedCall"](
		UCF_Listbox_Popup["TOUCH_HANDLING_DELAY"],
		this,
		'fireClose', []
	);
	UCF_JsUtil["delayedCall"](
		UCF_Listbox_Popup["TOUCH_HANDLING_DELAY"],
		this,
		'removeOverlay', []
	);

	oLsTouchend["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleLsTouchendOnActionItem"] = 0; };

/** @private */
UCF_Listbox_Popup["prototype"]["handleLsTouchendOnContainer"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleLsTouchendOnContainer"]++; }; 
	UCF_JsUtil["delayedCall"](
		UCF_Listbox_Popup["TOUCH_HANDLING_DELAY"],
		this,
		'fireActivate', []
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleLsTouchendOnContainer"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onclick"] = function(oClick) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onclick"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM;
	/** @type {_AnyItem} */
	var oItem;

	if (!this["bReadonly"]) {
		oIM = this["oGetItemsManager"]();

		oItem = oIM["oFindItemByDomRef"](oClick["oGetSource"]());

		if (oItem) {
			if (this["bOnDeleteButton"](oClick)) {
				this["fireDeleteItem"]({ "sKey": oIM["sGetItemKey"](oItem) });
			} else {
				this["handleClickOnItem"](oItem);
			}
		} else {
			oItem = oClick["oGetSourceControl"]();

			if (this["bIsActionItem"](oItem)) {
				this["handleClickOnActionItem"](oItem);
			} else {
				this["handleClickOnContainer"]();
			}
		}

		oClick["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onclick"] = 0; };

/**
 * @private
 * @param {UCF_Event} oEvent the event
 * @return {boolean}
 */
UCF_Listbox_Popup["prototype"]["bOnDeleteButton"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["bOnDeleteButton"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oEvent["oGetSource"]();

	return oSource
		&& UCF_DomUtil["bHasClass"](oSource, 'lsListbox__value--deletable')
		&& oSource["parentElement"]
		&& UCF_DomUtil["bHasClass"](
			oSource["parentElement"],
			'lsListbox__values--delete'
		);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["bOnDeleteButton"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_Popup["prototype"]["handleClickOnItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleClickOnItem"]++; }; 
	if (this["oGetItemsManager"]()["bIsWriteable"](oItem)) {
		this["_selectItem"](
			oItem,
			UCF_Listbox_Popup["SELECTTYPE"]["Click"],
			true
		);
		this["fireClose"]();
		this["removeOverlay"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleClickOnItem"] = 0; };

/**
 * @private
 * @param {UCF_Listbox_ActionItem} oItem the action item
 */
UCF_Listbox_Popup["prototype"]["handleClickOnActionItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleClickOnActionItem"]++; }; 
	this["fireActionActivate"]({ "sId": oItem["sId"] });
	this["fireClose"]();
	this["removeOverlay"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleClickOnActionItem"] = 0; };

/** @private */
UCF_Listbox_Popup["prototype"]["handleClickOnContainer"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleClickOnContainer"]++; }; 
	this["fireActivate"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleClickOnContainer"] = 0; };

/**
 * Context menu is not allowed on popup listboxes => cancel the event
 * @override
 */
UCF_Listbox_Popup["prototype"]["oncontextmenu"] = function(oContextmenu) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oncontextmenu"]++; }; 
	oContextmenu["cancel"]();
	oContextmenu["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oncontextmenu"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onlshome"] = function(oLsHome) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlshome"]++; }; 
	this["forwardToDefaultHandler"](oLsHome);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlshome"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onlspageup"] = function(oLsPageUp) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlspageup"]++; }; 
	this["forwardToDefaultHandler"](oLsPageUp);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlspageup"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onlsup"] = function(oLsUp) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlsup"]++; }; 
	this["forwardToDefaultHandler"](oLsUp);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlsup"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onlsdown"] = function(oLsDown) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlsdown"]++; }; 
	this["forwardToDefaultHandler"](oLsDown);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlsdown"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onlspagedown"] = function(oLsPageDown) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlspagedown"]++; }; 
	this["forwardToDefaultHandler"](oLsPageDown);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlspagedown"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onlsend"] = function(oLsEnd) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlsend"]++; }; 
	this["forwardToDefaultHandler"](oLsEnd);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlsend"] = 0; };

/** @override */
UCF_Listbox_Popup["prototype"]["onlsenter"] = function(oLsEnter) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlsenter"]++; }; 
	this["forwardToDefaultHandler"](oLsEnter);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onlsenter"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_Listbox_Popup["prototype"]["forwardToDefaultHandler"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["forwardToDefaultHandler"]++; }; 
	if (this["oEventDefaultHandler"]) {
		this["oEventDefaultHandler"]['on' + oBrowserEvent["sGetName"]()](oBrowserEvent);
	}

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["forwardToDefaultHandler"] = 0; };

// ===== internal handlers ====================================================

/**
 * @see UCF_ComboBox#handleLsItemNavigationKeys
 *
 * @protected
 */
UCF_Listbox_Popup["prototype"]["handleFirstItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleFirstItem"]++; }; 
	/** @type {_AnyItem} */
	var oItem = this["oGetSelectedItem"]();

	this["_selectItem"](
		(this["bIsActionItem"](oItem) && oItem !== this["oGetFirstActionItem"]())
		? this["oGetActionItemsManager"]()["oFindItemByIndex"](0)
		: this["oGetFirstWriteableItem"](),
		UCF_Listbox_Popup["SELECTTYPE"]["FirstItem"]
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleFirstItem"] = 0; };

/**
 * @see UCF_ComboBox#handleLsPageKeys
 *
 * @protected
 */
UCF_Listbox_Popup["prototype"]["handlePageUp"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handlePageUp"]++; }; 
	/** @type {_AnyItem} */
	var oItem = this["oGetSelectedItem"]();
	/** @type {boolean} */
	var bIsActionItem = this["bIsActionItem"](oItem);

	this["_selectItem"](
		(bIsActionItem && oItem !== this["oGetFirstActionItem"]())
		// [PAGE_UP] should page one page up, but action items are not scrollable
		// => paging one page up always moves to the first action item
		? this["oGetActionItemsManager"]()["oFindItemByIndex"](0)
		: this["oGetRelativeItem"](
			// selection should jump from last item on viewport to first item on
			// the same viewport => 1 less than #visible
			-(this["iCurrentlyVisibleItems"] - 1),
			bIsActionItem ? this["oGetLastWriteableItem"]() : oItem
		),
		UCF_Listbox_Popup["SELECTTYPE"]["PageUp"]
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handlePageUp"] = 0; };

/**
 * @see UCF_ComboBox#handleLsUpDownKeys
 *
 * @protected
 * @param {_AnyItem} oItem the current item
 */
UCF_Listbox_Popup["prototype"]["handlePreviousItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handlePreviousItem"]++; }; 
	/** @type {_AnyItem} */
	var oSelectedItem = this["oGetSelectedItem"]();
	/** @type {number} */
	var iOffset = (oItem || oSelectedItem) ? -1 : 0;
	/** @type {UCF_Listbox_ActionItems} */
	var oAIM = this["oGetActionItemsManager"]();
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	if (oSelectedItem && !oItem) {
		oItem = oSelectedItem;
	}

	this["_selectItem"](
		this["bIsActionItem"](oItem)
		? (oItem === this["oGetFirstActionItem"]()
			? this["oGetLastWriteableItem"]()
			: oAIM["oFindItemByIndex"](oAIM["iGetItemIndex"](oItem) - 1))
		: this["bOpened"]
			? this["oGetRelativeItem"](iOffset, oItem)
			: oIM["oFindItemByIndexOffsetAndStates"](oItem, iOffset, [], UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"]),
		UCF_Listbox_Popup["SELECTTYPE"]["PreviousItem"]
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handlePreviousItem"] = 0; };

/**
 * @see UCF_ComboBox#handleLsUpDownKeys
 *
 * @protected
 * @param {_AnyItem} oItem the current item
 */
UCF_Listbox_Popup["prototype"]["handleNextItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleNextItem"]++; }; 
	/** @type {_AnyItem} */
	var oSelectedItem = this["oGetSelectedItem"]();
	/** @type {number} */
	var iOffset = (oItem || oSelectedItem) ? 1 : 0;
	/** @type {UCF_Listbox_ActionItems} */
	var oAIM = this["oGetActionItemsManager"]();
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	if (oSelectedItem && !oItem) {
		oItem = oSelectedItem;
	}

	this["handleForwardSelection"](
		oItem,
		(this["bIsActionItem"](oItem)
			? oAIM["oFindItemByIndex"](oAIM["iGetItemIndex"](oItem) + 1)
			: (this["oGetItemsManager"]()["bEqual"](oItem, this["oGetLastWriteableItem"]())
				? this["oGetFirstActionItem"]()
				: this["bOpened"]
				? this["oGetRelativeItem"](iOffset, oItem): oIM["oFindItemByIndexOffsetAndStates"](oItem, iOffset, [], UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"])
			)
			// no item to select from and no item to select => try with first actionitem
		) || this["oGetFirstActionItem"](),
		UCF_Listbox_Popup["SELECTTYPE"]["NextItem"]
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleNextItem"] = 0; };

/**
 * @private
 * @param {_AnyItem} oFromItem the selected item
 * before the operation
 * @param {_AnyItem} oToItem the selected item
 * after the operation
 * @param {UCF_Listbox_Popup_SelectType} sEventName the name of the event
 */
UCF_Listbox_Popup["prototype"]["handleForwardSelection"] = function(oFromItem, oToItem, sEventName) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleForwardSelection"]++; }; 
	/** @type {boolean} */
	var bFireSelect;

	if (this["bShouldShowOverlay"]) {
		// don't fire select when overlay is open
		bFireSelect = !this["bOpened"];
	}
	this["_selectItem"](oToItem, sEventName, bFireSelect);
	// if moving from normal item to action item: fire select with empty item to
	// clear combobox
	if (!this["bIsActionItem"](oFromItem) && this["bIsActionItem"](oToItem)) {
		this["fireDeselect"](sEventName);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleForwardSelection"] = 0; };

/**
 * @see UCF_ComboBox#handleLsPageKeys
 *
 * @protected
 */
UCF_Listbox_Popup["prototype"]["handlePageDown"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handlePageDown"]++; }; 
	/** @type {_AnyItem} */
	var oItem = this["oGetSelectedItem"]();
	/** @type {UCF_Listbox_ActionItems} */
	var oAIM = this["oGetActionItemsManager"]();

	this["handleForwardSelection"](
		oItem,
		(
			this["bIsActionItem"](oItem) ||
			this["oGetItemsManager"]()["bEqual"](oItem, this["oGetLastWriteableItem"]())
		)
		// [PAGE_DOWN] should move by one page, but action items are not
		// scrollable => moving by one page always jumps straigt to the bottom
		? oAIM["oFindItemByIndex"](oAIM["iGetItemCount"]() - 1)
		// selection should jump from first item in viewport to last item in the
		// same viewport => 1 less than #visible
		: this["oGetRelativeItem"](this["iCurrentlyVisibleItems"] - 1, oItem),
		UCF_Listbox_Popup["SELECTTYPE"]["PageDown"]
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handlePageDown"] = 0; };

/**
 * @see UCF_ComboBox#handleLsItemNavigationKeys
 *
 * @protected
 */
UCF_Listbox_Popup["prototype"]["handleLastItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleLastItem"]++; }; 
	/** @type {UCF_Listbox_Item|UCF_Listbox_ActionItem} */
	var oItem = this["oGetSelectedItem"]();
	/** @type {UCF_Listbox_ActionItems} */
	var oAIM = this["oGetActionItemsManager"]();

	this["handleForwardSelection"](
		oItem,
		(
			this["bIsActionItem"](oItem) ||
			this["oGetItemsManager"]()["bEqual"](oItem, this["oGetLastWriteableItem"]())
		)
		? oAIM["oFindItemByIndex"](oAIM["iGetItemCount"]() - 1)
		: this["oGetLastWriteableItem"](),
		UCF_Listbox_Popup["SELECTTYPE"]["LastItem"]
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["handleLastItem"] = 0; };

// ===== internal events ======================================================

/**
 * @see UCF_ComboBox#onBeforeOpenFieldHelp
 *
 * @protected
 * @param {UCF_Control} oControl the default handler to set
 */
UCF_Listbox_Popup["prototype"]["setEventDefaultHandler"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["setEventDefaultHandler"]++; }; 
	this["oEventDefaultHandler"] = oControl;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["setEventDefaultHandler"] = 0; };

// ----- select ---------------------------------------------------------------

/**
 * @private
 * @param {_AnyItem} oItem the selected item
 * @param {UCF_Listbox_Popup_SelectType} sEventName the event that triggered
 * the select (see UCF_Listbox_Popup.SELECTTYPE enum)
 * @param {boolean} bFireSelect `true` to fire select to listeners
 * @param {boolean} bDelayed `true` to fire delayed after
 * UCF_Listbox_Popup.TOUCH_HANDLING_DELAY
 */
UCF_Listbox_Popup["prototype"]["fireSelect"] = function(oItem, sEventName, bFireSelect, bDelayed) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireSelect"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM;

	if (oItem && !this["bIsActionItem"](oItem)) {
		oIM = this["oGetItemsManager"]();

		if (bDelayed) {
			UCF_JsUtil["delayedCall"](
				UCF_Listbox_Popup["TOUCH_HANDLING_DELAY"],
				this,
				'fireEvent', [
					this["E_EVENTS"]["Select"],
					{
						"sKey": oIM["sGetItemKey"](oItem),
						"sValue": oIM["sGetItemValue"](oItem),
						"bFireSelect": bFireSelect,
						"sEventName": sEventName,
						"sIconSrc": oIM["sGetItemIconSrc"](oItem)
					}
				]
			);
		} else {
			this["fireEvent"](this["E_EVENTS"]["Select"], {
				"sKey": oIM["sGetItemKey"](oItem),
				"sValue": oIM["sGetItemValue"](oItem),
				"bFireSelect": bFireSelect,
				"sEventName": sEventName,
				"sIconSrc": oIM["sGetItemIconSrc"](oItem)
			});
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireSelect"] = 0; };

/**
 * @private
 * @param {UCF_Lisbtox_Popup.SELECT_EVENT} sEventName the event that triggered
 * the select (see UCF_Listbox_Popup.SELECTTYPE enum)
 */
UCF_Listbox_Popup["prototype"]["fireDeselect"] = function(sEventName) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireDeselect"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Select"], {
		"sKey": '',
		"sValue": '',
		"bFireSelect": false,
		"sEventName": sEventName,
		"sIconSrc": ''
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireDeselect"] = 0; };

// ----- close ----------------------------------------------------------------

/** @private */
UCF_Listbox_Popup["prototype"]["fireClose"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireClose"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Close"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireClose"] = 0; };

// ----- activate -------------------------------------------------------------

/** @private */
UCF_Listbox_Popup["prototype"]["fireActivate"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireActivate"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Activate"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireActivate"] = 0; };

// ----- actionactivate -------------------------------------------------------

/**
 * @private
 * @param {Object} oPayload the event payload
 */
UCF_Listbox_Popup["prototype"]["fireActionActivate"] = function(oPayload) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireActionActivate"]++; }; 
	if (!UCF_StringUtil["bEndsWith"](oPayload["sId"], '-canceloverlay')) {
		this["fireEvent"](this["E_EVENTS"]["ActionActivate"], oPayload);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireActionActivate"] = 0; };

// ----- deleteitem -----------------------------------------------------------

/**
 * @private
 * @param {Object} oPayload the event payload
 */
UCF_Listbox_Popup["prototype"]["fireDeleteItem"] = function(oPayload) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireDeleteItem"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["DeleteItem"], oPayload);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireDeleteItem"] = 0; };

// ----- focuschange ----------------------------------------------------------
/**
 * @private
 * @param {Object} oPayload the event payload
 */
UCF_Listbox_Popup["prototype"]["fireFocusChange"] = function(oPayload) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireFocusChange"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["FocusChange"], oPayload);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireFocusChange"] = 0; };

// ===== internal api =========================================================

/**
 * @see UCF_ComboBox#bIsPerceivedChild
 * @see UCF_ComboBox#handleMousedownAnyEvent
 *
 * @protected
 * @param {HTMLElement} oDomRef the dom ref
 * @return {UCF_Control}
 */
UCF_Listbox_Popup["prototype"]["oGetControlByDomRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetControlByDomRef"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {UCF_Listbox_Item} */
	var oItem;

	if (oDomRef) {
		oItem = oIM["oFindItemByDomRef"](oDomRef);

		return (oItem && oIM["oToItem"](oItem))
			|| this["oLS"]["oControlFactory"]["oGetEnclosingControlByDomRef"](oDomRef);
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetControlByDomRef"] = 0; };

/**
 * @see UCF_ComboBox#handleLsUpDownKeys
 * @see UCF_ComboBox#prepareFireListAccess
 *
 * @protected
 * @return {boolean}
 */
UCF_Listbox_Popup["prototype"]["bIsAvailable"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["bIsAvailable"]++; }; 
	return this["bAvailable"];
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["bIsAvailable"] = 0; };

/**
 * @see UCF_ComboBox#onBeforeOpenFieldHelp
 *
 * @protected
 * @param {boolean} bReadonly the readonly value to set
 */
UCF_Listbox_Popup["prototype"]["setReadonly"] = function(bReadonly) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["setReadonly"]++; }; 
	/** @type {boolean} */
	var bShouldRerender = bReadonly !== this["bReadonly"];

	this["bReadonly"] = bReadonly;
	this["setClientProperty"]("Readonly", bReadonly, true); // eslint-disable-line quotes

	if (bReadonly) {
		this["removeDelegate"](this["oActiveInteractionDelegate"]);
		delete this["oActiveInteractionDelegate"];
	} else if (!this["oActiveInteractionDelegate"]) {
		this["oActiveInteractionDelegate"] =
			new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_ActiveInteractionDelegate"))(this);
		this["addDelegate"](this["oActiveInteractionDelegate"]);
	}

	if (bShouldRerender) {
		this["rerenderReadonly"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["setReadonly"] = 0; };

/** @private */
UCF_Listbox_Popup["prototype"]["rerenderReadonly"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["rerenderReadonly"]++; }; 
	if (this["bReadonly"]) {
		UCF_DomUtil["addClass"](this["oRootRef"], 'lsListbox--readonly');
	} else {
		UCF_DomUtil["removeClass"](this["oRootRef"], 'lsListbox--readonly');
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["rerenderReadonly"] = 0; };

// ===== listbox interaction ==================================================

/**
 * @see UCF_ComboBox#onlsescape
 * @see UCF_Combobox#onBeforeOpenFieldHelp
 * @see UCF_ComboBox#onAfterCloseFieldHelp
 *
 * @protected
 */
UCF_Listbox_Popup["prototype"]["clearSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["clearSelection"]++; }; 
	this["oGetItemsManager"]()["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["clearSelection"] = 0; };

/**
 * @see UCF_ComboBox#onAfterPaste
 * @see UCF_Combobox#onAfterLsLeft
 * @see UCF_ComboBox#onAfterLsRight
 *
 * @protected
 */
UCF_Listbox_Popup["prototype"]["clearFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["clearFocus"]++; }; 
	/** @type {UCF_Listbox_ActionItems} */
	var oAIM = this["oGetActionItemsManager"]();
	/** @type {UCF_Listbox_ActionItem} */
	var oSelectedActionItem = oAIM["oGetSelectedItem"]();

	this["oGetItemsManager"]()["clearState"](UCF_Listbox_Items["STATE"]["Focus"]);
	if (oSelectedActionItem) {
		oSelectedActionItem["deselect"]();
		oAIM["selectItem"](null);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["clearFocus"] = 0; };

/**
 * @see UCF_ComboBox#importValue
 *
 * @protected
 * @return {Array.<UCF_Listbox_Item>}
 */
UCF_Listbox_Popup["prototype"]["aGetItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["aGetItems"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	return UCF_JsUtil["map"](
		UCF_JsUtil["values"](oIM["oGetItems"]()),
		function(oItem) { return oIM["oToItem"](oItem); }
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["aGetItems"] = 0; };

/**
 * @see UCF_ComboBox#onAfterLsAccessibility
 *
 * @protected
 * @return {number} the number of items (not including action items) of the
 * listbox
 */
UCF_Listbox_Popup["prototype"]["iGetItemCount"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetItemCount"]++; }; 
	return this["oGetItemsManager"]()["iGetItemCount"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetItemCount"] = 0; };

// ===== item interaction =====================================================

/**
 * @see UCF_ComboBox#handleDeleteItem
 * @see UCF_ComboBox#onkeypress
 * @see UCF_ComboBox#onkeyup
 * @see UCF_ComboBox#onListBoxSelect
 * @see UCF_ComboBox#onBeforeOpenFieldHelp
 *
 * @protected
 * @param {string} sKey the key of the item to select
 */
UCF_Listbox_Popup["prototype"]["selectItem"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["selectItem"]++; }; 
	this["_selectItem"](this["oGetItemsManager"]()["oFindItemByKey"](sKey));
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["selectItem"] = 0; };

/**
 * @see UCF_ComboBox#onListBoxDeleteItem
 *
 * @protected
 * @param {_MaybeItem} oItem the item to delete
 */
UCF_Listbox_Popup["prototype"]["deleteItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["deleteItem"]++; }; 
	this["oGetItemsManager"]()["deleteItem"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["deleteItem"] = 0; };

/**
 * @private
 * @param {UCF_Event<{oItem:_MaybeItem}>} oEvent
 */
UCF_Listbox_Popup["prototype"]["onWillItemsManagerDeleteItemAnimated"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onWillItemsManagerDeleteItemAnimated"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {UCF_Listbox_Item|UCF_Listbox_ActionItem} */
	var oSelectedItem = this["oGetSelectedItem"]();
	/** @type {_MaybeItem} */
	var oItem = oEvent["oGetParam"]('oItem');

	// has to be before fireWillDeleteItem, otherwise cached aVisibleItems
	// in Listbox_Suggest gets invalidated too early
	this["addItemDeleteAnimationStyles"]();
	this["fireWillDeleteItem"](oItem);

	if (
		!this["bIsActionItem"](oSelectedItem) &&
		oIM["bEqual"](oItem, oSelectedItem)
	) {
		oIM["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
	}
	if (oIM["bEqual"](oItem, this["oGetFirstWriteableItem"]())) {
		this["oCache"]["invalidate"]('firstWriteableItem');
	}
	if (oIM["bEqual"](oItem, this["oGetLastWriteableItem"]())) {
		this["oCache"]["invalidate"]('oLastWriteableItem');
	}
	if (oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["History"])) {
		this["oCache"]["invalidate"]('aHistoryItems');
		this["oCache"]["invalidate"]('bHistoryVisible');
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onWillItemsManagerDeleteItemAnimated"] = 0; };

/**
 * @private
 * @param {UCF_Event<{oItem:_MaybeItem}>} oEvent
 */
UCF_Listbox_Popup["prototype"]["onDidItemsManagerDeleteItemAnimated"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onDidItemsManagerDeleteItemAnimated"]++; }; 
	this["removeItemDeleteAnimationStyles"]();
	this["resetSeparator"]();
	this["applyHeight"]();
	this["setPosition"]();

	this["fireDidDeleteItem"](oEvent["oGetParam"]('oItem'));
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["onDidItemsManagerDeleteItemAnimated"] = 0; };

/** @private */
UCF_Listbox_Popup["prototype"]["addItemDeleteAnimationStyles"] = UCF_ClassLoader["oGetClass"]('UCF_Listbox_Items')["iGetItemDeleteAnimationDurationMs"]() > 0
	? function() {
		/** @type {number} */
		var iVisibleLines = this["iGetVisibleLines"]();
		/** @type {number} */
		var iHeightBefore = this["iGetMaxVisibleItems"]();
		/** @type {number} */
		var iHeightAfter;
		/** @type {number} */
		var iTopBefore;
		/** @type {number} */
		var iTopAfter;
		/** @type {boolean} */
		var bTopAttached;

		if (iHeightBefore === iVisibleLines) {
			bTopAttached = this["bIsTopAttached"]();
			iHeightAfter = Math["max"](0, iHeightBefore - 1);
			iTopBefore = parseInt(this["oRootRef"]["style"]["top"]);
			iTopAfter = iTopBefore + UCF_Listbox_Items["iGetItemHeight"]();

			UCF_DomUtil["setStyleElementContent"](
				UCF_Listbox_Popup["sGetCollapseHeightKeyframes"](iHeightBefore, iHeightAfter) +
				(bTopAttached ? UCF_Listbox_Popup["sGetCollapseTopKeyframes"](iTopBefore, iTopAfter) : '')
			);
			UCF_DomUtil["addClass"](this["oRootRef"], 'lsListbox--deleting');
		}
	}
	: function() {};

/**
 * @private
 * @static
 * @param {number} iHeightBefore
 * @param {number} iHeightAfter
 * @return {string}
 */
UCF_Listbox_Popup["sGetCollapseHeightKeyframes"] = function(iHeightBefore, iHeightAfter) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["sGetCollapseHeightKeyframes"]++; }; 
	/* beautify preserve:start */
	return '@keyframes sapUrListbox_Deleted_CollapseItems{' +
		'0%{' +
			'height:' + iHeightBefore + 'em;' +
			'max-height:' + iHeightBefore + 'em' +
		'}' +
		'100%{' +
			'height:' + iHeightAfter + 'em;' +
			'max-height:' + iHeightAfter + 'em' +
		'}' +
	'}';
	/* beautify preserve:end */
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["sGetCollapseHeightKeyframes"] = 0; };

/**
 * @private
 * @static
 * @param {number} iTopBefore
 * @param {number} iTopAfter
 * @return {string}
 */
UCF_Listbox_Popup["sGetCollapseTopKeyframes"] = function(iTopBefore, iTopAfter) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["sGetCollapseTopKeyframes"]++; }; 
	/* beautify preserve:start */
	return '@keyframes sapUrListbox_Deleted_CollapseTop{' +
		'0%{' +
			'top:' + iTopBefore + 'px' +
		'}' +
		'100%{' +
			'top:' + iTopAfter + 'px' +
		'}' +
	'}';
	/* beautify preserve:end */
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["sGetCollapseTopKeyframes"] = 0; };

/** @private */
UCF_Listbox_Popup["prototype"]["removeItemDeleteAnimationStyles"] = UCF_ClassLoader["oGetClass"]('UCF_Listbox_Items')["iGetItemDeleteAnimationDurationMs"]() > 0
	? function() {
		UCF_DomUtil["removeClass"](this["oRootRef"], 'lsListbox--deleting');
		UCF_DomUtil["setStyleElementContent"]('');
	}
	: function() {};

/**
 * @private
 * @param {_MaybeItem} oItem
 */
UCF_Listbox_Popup["prototype"]["fireWillDeleteItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireWillDeleteItem"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["WillDeleteItem"], { "oItem": oItem });
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireWillDeleteItem"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem
 */
UCF_Listbox_Popup["prototype"]["fireDidDeleteItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireDidDeleteItem"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["DidDeleteItem"], { "oItem": oItem });
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireDidDeleteItem"] = 0; };

/** @private */
UCF_Listbox_Popup["prototype"]["resetSeparator"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["resetSeparator"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {_MaybeItem[]} */
	var aHistoryItems;
	/** @type {_MaybeItem} */
	var oSeparatorItem;

	oIM["clearState"](UCF_Listbox_Items["STATE"]["Separator"]);

	if (this["bIsHistoryVisible"]()) {
		aHistoryItems = this["aGetHistoryItems"]();
		oSeparatorItem = oIM["oFindItemByIndexOffsetAndStates"](
			aHistoryItems[aHistoryItems["length"] - 1],
			1, [], [UCF_Listbox_Items["STATE"]["Hidden"]], true
		);

		if (oSeparatorItem) {
			oIM["addState"](
				oSeparatorItem,
				UCF_Listbox_Items["STATE"]["Separator"]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["resetSeparator"] = 0; };

/** @private */
UCF_Listbox_Popup["prototype"]["resetAria"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["resetAria"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {UCF_Listbox_ActionItems} */
	var oAIM = this["oGetActionItemsManager"]();
	/** @type {Array.<_MaybeItem>} */
	var aItems = oIM["aFindItemsByStates"](
		[],
		UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"]
	);
	var aActionItems = oAIM["aGetItems"]();
	/** @type {number} */
	var iSetsize = aItems["length"] + aActionItems["length"];
	var iPosinset = 1;
	var aOwnsIds = [];

	UCF_JsUtil["forEach"](oIM["aFindItemsByStates"]([], []), function(oItem) {
		var bWriteable = UCF_JsUtil["every"](UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"], function(eState) {
			return !UCF_Listbox_Items["bHasItemState"](oItem, eState);
		});

		if (bWriteable) {
			aOwnsIds["push"](UCF_Listbox_Items["sGetItemId"](oItem));
		}

		UCF_Listbox_Items["setItemAriaHidden"](oItem, !bWriteable);
		UCF_Listbox_Items["setItemAriaSetsize"](oItem, bWriteable && iSetsize);
		UCF_Listbox_Items["setItemAriaPosinset"](oItem, bWriteable && iPosinset++);
	});
	UCF_JsUtil["forEach"](aActionItems, function(oItem) {
		aOwnsIds["push"](oItem["sId"]);
		oItem["setAriaSetsize"](iSetsize);
		oItem["setAriaPosinset"](iPosinset++);
	});
	UCF_AriaStateHelper["setOwns"](this["oDomRef"], aOwnsIds["join"](' '));

	// remove "-ariaempty" reference in aria-labelledby
	UCF_AriaStateHelper["setLabelledBy"](this["oDomRef"], '');
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["resetAria"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_Listbox_Popup["prototype"]["bIsHistoryVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["bIsHistoryVisible"]++; }; 
	var self = this;

	return this["oCache"]["get"]('bHistoryVisible', function() {
		return self["aGetHistoryItems"]()["length"] > 0;
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["bIsHistoryVisible"] = 0; };

/**
 * @private
 * @return {_MaybeItem[]}
 */
UCF_Listbox_Popup["prototype"]["aGetHistoryItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["aGetHistoryItems"]++; }; 
	/** @type {UCF_Listbox_Popup} */
	var self = this;

	return this["oCache"]["get"]('aHistoryItems', function() {
		return self["oGetItemsManager"]()["aFindItemsByStates"](
			[UCF_Listbox_Items["STATE"]["History"]],
			[UCF_Listbox_Items["STATE"]["Hidden"]]
		);
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["aGetHistoryItems"] = 0; };

// ===== item access ==========================================================

/**
 * @see UCF_ComboBox#handleLsUpDownKeys
 * @see UCF_ComboBox#onkeypress
 *
 * @protected
 * @param {string} sKey the item key
 * @return {UCF_Listbox_Item}
 */
UCF_Listbox_Popup["prototype"]["oGetItem"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	return oIM["oToItem"](oIM["oFindItemByKey"](sKey));
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetItem"] = 0; };

/**
 * @see UCF_ComboBox#handleDeleteKeydown
 * @see UCF_ComboBox#onAfterLsEnter
 * @see UCF_ComboBox#onListBoxDeleteItem
 *
 * @protected
 * @return {UCF_Listbox_Item|UCF_Listbox_ActionItem}
 */
UCF_Listbox_Popup["prototype"]["oGetSelectedItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetSelectedItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {Array.<_MaybeItem>} */
	var aItems = oIM["aFindItemsByState"](UCF_Listbox_Items["STATE"]["Selected"]);

	return aItems && aItems["length"] > 0
		? oIM["oToItem"](aItems[0])
		: this["oGetActionItemsManager"]()["oGetSelectedItem"]();
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetSelectedItem"] = 0; };

/**
 * @protected
 * @return {UCF_Listbox_Item|UCF_Listbox_ActionItem}
 */
UCF_Listbox_Popup["prototype"]["oGetFocusedItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetFocusedItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {Array.<_MaybeItem>} */
	var aItems = oIM["aFindItemsByState"](UCF_Listbox_Items["STATE"]["Focus"]);

	return aItems && aItems["length"] > 0
		? oIM["oToItem"](aItems[0])
		: "";
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetFocusedItem"] = 0; };

/**
 * @see UCF_ComboBox#onkeypress
 * @see UCF_ComboBox#onkeyup
 *
 * @protected
 * @param {string} sSearch the search string
 * @param {UCF_Listbox_Item} oStartItem the item to start the search from
 * @return {UCF_Listbox_Item}
 */
UCF_Listbox_Popup["prototype"]["oFindItem"] = function(sSearch, oStartItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oFindItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {number} */
	var iIndex = (oStartItem
		// don't include oStartItem in the first search
		? oIM["iGetItemIndex"](oStartItem) + 1
		: 0);
	/** @type {Array.<_MaybeItem>} */
	var aItems = oIM["aFindItemsByIndexRange"](iIndex);
	/** @type {_MaybeItem} */
	var oItem;

	/**
	 * @param {UCF_Listbox_Item} o the item to match
	 * @return {boolean}
	 */
	function bMatches(o) { return oIM["bMatches"](o, sSearch); }

	oItem = UCF_JsUtil["find"](aItems, bMatches);

	if (oItem) {
		return oIM["oToItem"](oItem);
	} else if (oStartItem) {
		oItem = UCF_JsUtil["find"](
			oIM["aFindItemsByIndexRange"](0, iIndex),
			bMatches
		);

		return oItem && oIM["oToItem"](oItem);
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oFindItem"] = 0; };

// ===== item convenience methods =============================================

/**
 * @see UCF_ComboBox#onAfterLsAccessibility
 *
 * @protected
 * @param {string} sKey the key of the item
 * @return {number} 1-based just like UCF_ItemListBox_ie6.iGetItemIndex
 */
UCF_Listbox_Popup["prototype"]["iGetItemIndex"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetItemIndex"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemByKey"](sKey);

	return oItem && oIM["iGetItemIndex"](oItem) + 1;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetItemIndex"] = 0; };

/**
 * @see UCF_ComboBox#onBeforeHideRequiredIndicator
 * @see UCF_ComboBox#handleDeleteKeydown
 * @see UCF_ComboBox#onAfterLsEnter
 * @see UCF_ComboBox#onlsescape
 * @see UCF_ComboBox#onkeypress
 * @see UCF_ComboBox#onkeyup
 *
 * @protected
 * @param {string} sKey the key of the item
 * @return {string}
 */
UCF_Listbox_Popup["prototype"]["sGetItemValue"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["sGetItemValue"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemByKey"](sKey);

	return oItem && oIM["sGetItemValue"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["sGetItemValue"] = 0; };

/**
 * @see UCF_ComboBox#onAfterLsAccessibility
 *
 * @protected
 * @param {string} sKey the key of the item
 * @return {string}
 */
UCF_Listbox_Popup["prototype"]["sGetItemDescription"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["sGetItemDescription"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemByKey"](sKey);

	return oIM["sGetItemDescription"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["sGetItemDescription"] = 0; };

// ===== selected item convenience methods ====================================

/**
 * @see UCF_ComboBox#handleFieldHelpPressKeydown
 * @see UCF_ComboBox#onAfterLsEnter
 *
 * @protected
 * @return {string}
 */
UCF_Listbox_Popup["prototype"]["sGetSelectedItemKey"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["sGetSelectedItemKey"]++; }; 
	/** @type {_AnyItem} */
	var oItem = this["oGetSelectedItem"]();

	this["fireActionItem"](oItem);

	return (oItem && !this["bIsActionItem"](oItem))
		? this["oGetItemsManager"]()["sGetItemKey"](oItem)
		: (oItem && oItem["sKey"]);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["sGetSelectedItemKey"] = 0; };

// ===== helpers ==============================================================

/**
 * internal method to select both items and actionitems
 * @private
 * @param {_AnyItem} oItem the item to select
 * @param {string} sEventName the event that triggered the select
 * @param {boolean} [bFireSelect=false] parameter passed in the Listbox:Select
 * @param {boolean} [bDelayed=false] `true` to fire Listbox:Select after
 * TOUCH_HANDLING_DELAY
 */
UCF_Listbox_Popup["prototype"]["_selectItem"] = function(oItem, sEventName, bFireSelect, bDelayed) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["_selectItem"]++; }; 
	if (this["bIsActionItem"](oItem)) {
		this["selectActionItem"](oItem);
		// ARIA for action items
		if (this["oOpenerRef"] && (window["UCF_System"]["bIsAria"] || window["UCF_System"]["bIs508"])) {
			//UCF_AriaStateHelper.setActivedescendant(UCF_DomUtil.$(this.oOpenerRef.id.split('-r')[0]), UCF_Listbox_Items.sGetItemId(oItem));
			UCF_AriaStateHelper["setActivedescendant"](UCF_DomUtil["$"](this["oOpenerRef"]["id"]["split"]('-r')[0]), oItem["sId"]);
		}
	} else if (this["oGetItemsManager"]()["bIsWriteable"](oItem)) {
		this["selectWriteableItem"](oItem, sEventName, bFireSelect, bDelayed);
	} else if (this["bOpened"] && this["oGetItemsManager"]()["bIsFocusable"](oItem)) {
		this["focusItem"](oItem, sEventName, bFireSelect, bDelayed);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["_selectItem"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem the item
 * @param {string} sEventName the event that triggered the select
 * @param {boolean} [bFireSelect=false] parameter passed in the Listbox:Select
 * @param {boolean} [bDelayed=false] `true` to fire Listbox:Select after
 * TOUCH_HANDLING_DELAY
 */
UCF_Listbox_Popup["prototype"]["selectWriteableItem"] = function(oItem, sEventName, bFireSelect, bDelayed) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["selectWriteableItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	this["oGetActionItemsManager"]()["selectItem"](null);

	oIM["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
	oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
	oIM["clearState"](UCF_Listbox_Items["STATE"]["Focus"]);
	oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Focus"]);
	oIM["clearState"](UCF_Listbox_Items["STATE"]["LastInteractedWith"]);
	oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["LastInteractedWith"]);

	if (this["oOpenerRef"] && (window["UCF_System"]["bIsAria"] || window["UCF_System"]["bIs508"])) {
		UCF_AriaStateHelper["setActivedescendant"](UCF_DomUtil["$"](this["oOpenerRef"]["id"]["split"]('-r')[0]), UCF_Listbox_Items["sGetItemId"](oItem));
	}

	oIM["scrollIntoView"](oItem);

	this["fireFocusChange"](oIM["bIsWriteable"](oItem)
		? { "oNewItem": oIM["oToItem"](oItem) }
		: {});

	if (sEventName && sEventName !== UCF_Listbox_Popup["SELECTTYPE"]["Mouseover"]) {
		this["fireSelect"](oItem, sEventName, bFireSelect, bDelayed);
	};
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["selectWriteableItem"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem the item
 * @param {string} sEventName the event that triggered the select
 * @param {boolean} [bFireSelect=false] parameter passed in the Listbox:Select
 * @param {boolean} [bDelayed=false] `true` to fire Listbox:Select after
 * TOUCH_HANDLING_DELAY
 */
UCF_Listbox_Popup["prototype"]["focusItem"] = function(oItem, sEventName, bFireSelect, bDelayed) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["focusItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	oIM["clearState"](UCF_Listbox_Items["STATE"]["Focus"]);
	oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Focus"]);
	oIM["clearState"](UCF_Listbox_Items["STATE"]["LastInteractedWith"]);
	oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["LastInteractedWith"]);

	if (this["oOpenerRef"] && (window["UCF_System"]["bIsAria"] || window["UCF_System"]["bIs508"])) {
		UCF_AriaStateHelper["setActivedescendant"](UCF_DomUtil["$"](this["oOpenerRef"]["id"]["split"]('-r')[0]), UCF_Listbox_Items["sGetItemId"](oItem));
	}

	oIM["scrollIntoView"](oItem);

	this["fireFocusChange"](oIM["bIsFocusable"](oItem)
		? { "oNewItem": oIM["oToItem"](oItem) }
		: {});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["focusItem"] = 0; };

/**
 * @private
 * @param {UCF_Listbox_ActionItem} oItem the action item
 */
UCF_Listbox_Popup["prototype"]["selectActionItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["selectActionItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	oIM["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
	oIM["clearState"](UCF_Listbox_Items["STATE"]["Focus"]);
	oIM["clearState"](UCF_Listbox_Items["STATE"]["LastInteractedWith"]);

	this["oGetActionItemsManager"]()["selectItem"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["selectActionItem"] = 0; };

/**
 * @private
 * @param {number} iOffset the offset relative to the selected item
 * @param {_MaybeItem} oItem the item to start the search from
 * @return {_MaybeItem}
 */
UCF_Listbox_Popup["prototype"]["oGetRelativeItem"] = function(iOffset, oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetRelativeItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {Array.<_MaybeItem>} */
	var aItems;
	/** @type {boolean} */
	var bForceSelection = false;
	/** @type {_MaybeItem} */
	var oTarget;

	if (!oItem) {
		aItems = oIM["aFindItemsByStates"](
			[],
			UCF_Listbox_Items["IGNORED_FOCUSABLE_STATES"]
		);
		if (aItems && aItems["length"] > 0) {
			oItem = aItems[0];
			bForceSelection = true;
		}
	}

	oTarget = oIM["oFindItemByIndexOffsetAndStates"](
		oItem,
		iOffset,
		[],
		UCF_Listbox_Items["IGNORED_FOCUSABLE_STATES"]
	);

	return oTarget && (bForceSelection || oTarget !== oItem)
		? oTarget
		: null;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetRelativeItem"] = 0; };

/**
 * @private
 * @return {_MaybeItem}
 */
UCF_Listbox_Popup["prototype"]["oGetLastWriteableItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetLastWriteableItem"]++; }; 
	/** @type {UCF_Listbox_Popup} */
	var self = this;

	return this["oCache"]["get"]('oLastWriteableItem', function() {
		/** @type {Array.<_MaybeItem>} */
		var aItems = self["oGetItemsManager"]()["aFindItemsByStates"](
			[], UCF_Listbox_Items["IGNORED_FOCUSABLE_STATES"]
		);

		return aItems && aItems["length"] > 0 && aItems[aItems["length"] - 1];
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetLastWriteableItem"] = 0; };

/**
 * @private
 * @return {_MaybeItem}
 */
UCF_Listbox_Popup["prototype"]["oGetFirstWriteableItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetFirstWriteableItem"]++; }; 
	/** @type {UCF_Listbox_Popup} */
	var self = this;

	return this["oCache"]["get"]('firstWriteableItem', function() {
		/** @type {Array.<_MaybeItem>} */
		var aItems = self["oGetItemsManager"]()["aFindItemsByStates"](
			[], UCF_Listbox_Items["IGNORED_FOCUSABLE_STATES"]
		);

		return aItems && aItems["length"] > 0 && aItems[0];
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetFirstWriteableItem"] = 0; };

/**
 * @private
 * @return {UCF_Listbox_ActionItem}
 */
UCF_Listbox_Popup["prototype"]["oGetFirstActionItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetFirstActionItem"]++; }; 
	/** @type {UCF_Listbox_Popup} */
	var self = this;

	return this["oCache"]["get"]('firstActionItem', function() {
		/** @type {Array.<UCF_Listbox_ActionItem>} */
		var aItems = self["oGetActionItemsManager"]()["aGetItems"]();

		return aItems && aItems["length"] > 0 && aItems[0];
	});
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["oGetFirstActionItem"] = 0; };

/**
 * @private
 * @param {UCF_Control} oControl the control to check
 * @return {boolean}
 */
UCF_Listbox_Popup["prototype"]["bIsActionItem"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["bIsActionItem"]++; }; 
	return UCF_JsUtil["bInstanceOf"](oControl, 'UCF_Listbox_ActionItem');
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["bIsActionItem"] = 0; };

/**
 * fires UCF_Listbox_Popup:ActionActivate and UCF_Listbox_Popup:Close if oItem
 * is an action item
 * @param {UCF_Listbox_ActionItem} oItem the action item
 */
UCF_Listbox_Popup["prototype"]["fireActionItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireActionItem"]++; }; 
	if (this["bIsActionItem"](oItem)) {
		this["fireActionActivate"]({ "sId": oItem["sId"] });
		this["fireClose"]();
		this["removeOverlay"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["fireActionItem"] = 0; };

/**
 * @param {boolean} bValue `true` if phone overlay should be displayed
 * otherwise `false`
 */
UCF_Listbox_Popup["prototype"]["setShouldDisplayOverlay"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["setShouldDisplayOverlay"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'setShouldDisplayOverlay ' + bValue, "Listbox_Popup.js(2012): setShouldDisplayOverlay"); };
	this["bShouldShowOverlay"] = bValue;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["setShouldDisplayOverlay"] = 0; };

/**
 * @see {@link UCF_SuggestBox#open}
 * @protected
 * @return {boolean}
 */
UCF_Listbox_Popup["prototype"]["bShowNoResults"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["bShowNoResults"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["bShowNoResults"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Listbox_Popup["prototype"]["iGetOptimalNumberOfItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetOptimalNumberOfItems"]++; }; 
	if (this["oListboxOverlayDelegate"]) {
		return this["oListboxOverlayDelegate"]["iGetOptimalNumberOfItems"]();
	}

	if (this["bShouldShowOverlay"]) {
		this["addOverlay"]();
		if (this["oListboxOverlayDelegate"]) {
			return this["oListboxOverlayDelegate"]["iGetOptimalNumberOfItems"]();
		} else {
			return 10;
		}
	} else {
		return 10;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Popup["_"]["iGetOptimalNumberOfItems"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_PopupMultiSelect"] = function() {/* global _assert, _trace, DEBUG, INFO, WARNING, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Listbox_PopupMultiSelectInteraction */
/// <reference path="./delegates/Listbox_PopupMultiSelectInteraction.js"/>
/* global UCF_Listbox_Popup */
/// <reference path="./Listbox_Popup.js"/>
/* global UCF_ItemListBox */
/// <reference path="./base/ItemListBox.js"/>
/* global UCF_Listbox */
/// <reference path="./Listbox.js"/>
/* global UCF_Listbox_Items */
/// <reference path="./Listbox_Items.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>

/**
 * @ct LIB_M
 * @class UCF_Listbox_PopupMultiSelect
 * @extends UCF_ItemListBox
 * @param {HTMLDivElement} oDomRef the DOM element
 * @param {UCF_LS} oLS the LightSpeed instance
 */
function UCF_Listbox_PopupMultiSelect(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["UCF_Listbox_PopupMultiSelect"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox_Popup["apply"](this, [oDomRef, oLS]);
		// UCF_Listbox.apply(this, [oDomRef, oLS]);
		this["oInteraction"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_PopupMultiSelectInteraction"))(this);
		this["addDelegate"](this["oInteraction"]);
	}
};window["UCF_Listbox_PopupMultiSelect"] = UCF_Listbox_PopupMultiSelect; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_PopupMultiSelect"); UCF_Listbox_PopupMultiSelect["_"] = {UCF_Listbox_PopupMultiSelect: 0}; }; ;
UCF_Listbox_PopupMultiSelect["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_Popup"))(); UCF_Listbox_PopupMultiSelect.prototype["sClassName"] = "UCF_Listbox_PopupMultiSelect";

/**
 * Destructor
 * @private
 */
UCF_Listbox_PopupMultiSelect["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["destroy"]++; }; 
	if (this["oInteraction"]) {
		this["oInteraction"]["destroy"]();
		this["oInteraction"] = null;
	}
	UCF_Listbox_Popup.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["destroy"] = 0; };

/**
 * @protected
 * @return {HTMLSpanElement}
 */
UCF_Listbox_PopupMultiSelect["prototype"]["oGetCheckboxRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["oGetCheckboxRef"]++; }; 
	return document["getElementById"](this["sId"] + '-checkbox');
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["oGetCheckboxRef"] = 0; };

// #region onStateChange ------------------------------------------------------
/**
 * @private
 * @param {UCF_Event} oStateChange the StateChange
 */
UCF_Listbox_PopupMultiSelect["prototype"]["onStateChange"] = function(oStateChange) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onStateChange"]++; }; 
	switch (oStateChange["oGetParam"]('iState')) {
		case UCF_Listbox_Items["STATE"]["Selected"]:
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'fireSelect for ' + this["sId"] + ' -> ' + this["getValues"](), "Listbox_PopupMultiSelect.js(67): onStateChange"); };
			this["fireEvent"](this["E_EVENTS"]["Select"], {
				"sId": this["sId"],
				"sKeys": this["getValues"]()
			});
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onStateChange"] = 0; };
// #endregion
// #region getValues ----------------------------------------------------------
/**
 * @public
 * @return {string[]}
 */
UCF_Listbox_PopupMultiSelect["prototype"]["getValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["getValues"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();

	return UCF_JsUtil["map"](
		oIM["aFindItemsByState"](UCF_Listbox_Items["STATE"]["Selected"]),
		function(oItem) { return oIM["sGetItemKey"](oItem); }
	);
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["getValues"] = 0; };
// #endregion
// #region blur ---------------------------------------------------------------
/**
 * @private
 * @param { UCF_Event } oBrowserEvent the event object
 */
UCF_Listbox_PopupMultiSelect["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onlsblur"]++; }; 
	if (this["bOpened"] &&
		oBrowserEvent["oDomEvent"] && oBrowserEvent["oDomEvent"]["relatedTarget"] &&
		oBrowserEvent["oDomEvent"]["relatedTarget"]["id"] !== this["sId"] + '-scrl') {
		this["close"]();
	}
	UCF_Listbox_Popup.prototype["onlsblur"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onlsblur"] = 0; };
// #endregion
// #region onclick ------------------------------------------------------------
/**
 * @override
 * @param {UCF_Event} oClick the event object
 */
UCF_Listbox_PopupMultiSelect["prototype"]["onclick"] = function(oClick) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onclick"]++; }; 
	/** @type {HTMLElement} */
	var oSource;

	oSource = oClick["oGetSource"]();

	if (oSource && !UCF_StringUtil["bEndsWith"](oSource["id"], "-checkbox")) {
		this["close"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onclick"] = 0; };
// #endregion
// #region onlsescape ---------------------------------------------------------
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_Listbox_PopupMultiSelect["prototype"]["onlsescape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onlsescape"]++; }; 
	if (this["bOpened"]) {
		this["close"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onlsescape"] = 0; };
// #endregion
// #region onlstabnext --------------------------------------------------------
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_Listbox_PopupMultiSelect["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onlstabnext"]++; }; 
	this["handleLsTab"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onlstabnext"] = 0; };
// #endregion
// #region onlstabprevious ----------------------------------------------------
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_Listbox_PopupMultiSelect["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onlstabprevious"]++; }; 
	this["handleLsTab"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["onlstabprevious"] = 0; };
// #endregion
// #region handleLsTab ----------------------------------------------------
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_Listbox_PopupMultiSelect["prototype"]["handleLsTab"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["handleLsTab"]++; }; 
	if (this["bOpened"]) {
		this["close"]();
		if (this["oOpenerRef"]) {
			UCF_DomUtil["moveFocusDomElement"](this["oOpenerRef"], true);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["handleLsTab"] = 0; };
// #endregion
// #region handleAltDownKeydown -----------------------------------------------
/**
 * @override
 */
UCF_Listbox_PopupMultiSelect["prototype"]["handleAltDownKeydown"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["handleAltDownKeydown"]++; }; 
	/** @type {_AnyItem} */
	var oItem = this["oGetFirstSelectedItem"]();
	/** @type {HTMLDivElement} */
	var oScrollRef = this["oGetItemsManager"]()["oGetScrollRef"]();

	if (!oItem) {
		oItem = this["oGetFirstWriteableItem"]();
	}

	if (!oItem) return ;
	this["focusItem"](oItem);

	if (!UCF_JsUtil["bInstanceOf"](oItem, "UCF_Listbox_Item")) {
		oItem = this["oGetControlByDomRef"](oItem);
	}
	UCF_DomUtil["moveFocusDomElement"](oItem, true);

	if (oScrollRef) {
		oScrollRef["focus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["handleAltDownKeydown"] = 0; };
// #endregion
// #region oGetFirstSelectedItem ----------------------------------------------
/**
 * @override
 */
UCF_Listbox_PopupMultiSelect["prototype"]["oGetFirstSelectedItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["oGetFirstSelectedItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {Array.<_MaybeItem>} */
	var aItems = oIM["aFindItemsByState"](UCF_Listbox_Items["STATE"]["Selected"]);

	aItems["sort"](function(a,b){
		return oIM["oToItem"](a)["iGetIndex"]() - oIM["oToItem"](b)["iGetIndex"]();
	});

	return aItems && aItems["length"] > 0
		? oIM["oToItem"](aItems[0])
		: null;
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["oGetFirstSelectedItem"] = 0; };
// #endregion

// #region handleAltUpKeydown -------------------------------------------------
/**
 * @override
 */
UCF_Listbox_PopupMultiSelect["prototype"]["handleAltUpKeydown"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["handleAltUpKeydown"]++; }; 
	/** @type {_AnyItem} */
	var oPreviousItem;
	var oPreviousItemRef;
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oGetItemsManager"]();
	/** @type {_AnyItem} */
	var oItem = this["oGetSelectedItem"]();

	if (!oItem) {
		oItem = this["oGetFirstWriteableItem"]();
	}

	if (!oItem) return;

	oPreviousItemRef = this["oGetRelativeItem"](-1, oItem);
	oPreviousItem = oIM["oToItem"](oPreviousItemRef);
	oIM["clearState"](UCF_Listbox_Items["STATE"]["Focus"]);
	oIM["addState"](oPreviousItem, UCF_Listbox_Items["STATE"]["Focus"]);
	UCF_DomUtil["moveFocusDomElement"](oPreviousItem, true);
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["handleAltUpKeydown"] = 0; };
// #endregion
// #region close --------------------------------------------------------------
/** @override */
UCF_Listbox_PopupMultiSelect["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["close"]++; }; 
	this["clearFocus"]();
	UCF_Listbox_Popup.prototype["close"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelect["_"]["close"] = 0; };


UCF_Listbox_PopupMultiSelect.prototype["aPublicMethods"] = ["getValues"].concat(UCF_Listbox_PopupMultiSelect.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Listbox_PopupMultiSelectInteraction"] = function() {/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Listbox_Items */
/// <reference path="../Listbox_Items.js"/>
/* global UCF_Listbox_Interaction */
/// <reference path="./Listbox_Interaction.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>

/**
 * @class UCF_Listbox_PopupMultiSelectInteraction
 * @extends UCF_Listbox_Interaction
 * @param {UCF_Listbox_MultiSelect} oControl the listbox
 * @param {UCF_Listbox_Items} [oItems] the items
 */
function UCF_Listbox_PopupMultiSelectInteraction(oControl, oItems) {if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["UCF_Listbox_PopupMultiSelectInteraction"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox_Interaction["apply"](this, arguments);

		/** @type {string} */
		this["sAccessibilityCt"] = 'ILBM';

		/** @type {boolean} */
		this["bTouchstartSelected"] = false;

		/** @type {boolean} */
		this["bAllItemsSelected"] = false;
	}
};window["UCF_Listbox_PopupMultiSelectInteraction"] = UCF_Listbox_PopupMultiSelectInteraction; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_PopupMultiSelectInteraction"); UCF_Listbox_PopupMultiSelectInteraction["_"] = {UCF_Listbox_PopupMultiSelectInteraction: 0}; }; ;
UCF_Listbox_PopupMultiSelectInteraction["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_Interaction"))(); UCF_Listbox_PopupMultiSelectInteraction.prototype["sClassName"] = "UCF_Listbox_PopupMultiSelectInteraction";

// ===== keydown ==============================================================

/** @override */
// eslint-disable-next-line complexity
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["onkeydown"] = function(oKeydown) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["onkeydown"]++; }; 
	var bHandled = false;

	/* beautify preserve:start */
	// [DOWN]
if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"])) {
	this["focusItem"](this["oGetItemRelativeToFocused"](1));
	bHandled = true;
} else
	// [UP]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"])) {
		this["focusItem"](this["oGetItemRelativeToFocused"](-1));
		bHandled = true;
	} else
	// [PAGE_UP]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_UP"])) {
		this["focusItem"](this["oGetItemRelativeToFocused"](
			-UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [PAGE_DOWN]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_DOWN"])) {
		this["focusItem"](this["oGetItemRelativeToFocused"](
			UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [CTRL][DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"], 'C')
	) {
		this["focusItem"](this["oGetItemRelativeToFocused"](1));
		bHandled = true;
	} else
	// [SPACE]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"])) {
		if (this["bHasState"](this["oGetFocusedItem"](), UCF_Listbox_Items["STATE"]["Selected"])) {
			this["deselectItem"](this["oGetFocusedItem"]());
		} else {
			this["selectItem"](this["oGetFocusedItem"]());
		}
		bHandled = true;
	} else
	// [ENTER]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ENTER"]) && this["oControl"]["bOpened"]) {
		if (this["bHasState"](this["oGetFocusedItem"](), UCF_Listbox_Items["STATE"]["Selected"])) {
			this["deselectItem"](this["oGetFocusedItem"]());
		}
		else {
			this["selectItem"](this["oGetFocusedItem"]());
		}
		this["oControl"]["close"]();
		bHandled = true;
	} else
	// [CTRL][UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"], 'C')
	) {
		this["focusItem"](this["oGetItemRelativeToFocused"](-1));
		bHandled = true;
	} else
	// [CTRL][PAGE_DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_DOWN"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetItemRelativeToFocused"](
			UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [CTRL][PAGE_UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_UP"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetItemRelativeToFocused"](
			-UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [CTRL][HOME]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["HOME"], 'C')) {
		this["focusItem"](this["oGetFirstWriteableItem"]());
		bHandled = true;
	} else
	// [CTRL][END]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["END"], 'C')) {
		this["focusItem"](this["oGetLastWriteableItem"]());
		bHandled = true;
	} else
	// [CTRL][SPACE] and [CTRL][ENTER]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"], 'C') ||
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ENTER"], 'C')
	) {
		this["extendSelectionWithItem"](this["oGetFocusedItem"]());
		bHandled = true;
	} else
	// [SHIFT][DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](1));
		bHandled = true;
	} else
	// [SHIFT][UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](-1));
		bHandled = true;
	} else
	// [SHIFT][PAGE_DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_DOWN"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](
			UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [SHIFT][PAGE_UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["PAGE_UP"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetItemRelativeToFocused"](
			-UCF_Listbox_Interaction["LARGE_STEP"]
		));
		bHandled = true;
	} else
	// [SHIFT][HOME]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["HOME"], 'S')) {
		this["extendSelectionWithRange"](this["oGetFirstWriteableItem"]());
		bHandled = true;
	} else
	// [SHIFT][END]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["END"], 'S')) {
		this["extendSelectionWithRange"](this["oGetLastWriteableItem"]());
		bHandled = true;
	} else
	// [SHIFT][SPACE] and [SHIFT][ENTER]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"], 'S') ||
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ENTER"], 'S')
	) {
		this["extendSelectionWithRange"](this["oGetFocusedItem"]());
		bHandled = true;
	} else
	// [HOME]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["HOME"])
	) {
		this["focusItem"](this["oGetFirstWriteableItem"]());
		bHandled = true;
	} else
	// [END]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["END"])
	) {
		this["focusItem"](this["oGetLastWriteableItem"]());
		bHandled = true;
	} else
	// [F4]
	if (UCF_KeyboardHelper["bIsEventForKey"](oKeydown,	UCF_KeyCodes["F4"])
		&& !oKeydown["bRepeat"]() && !oKeydown["bCtrl"]() && !oKeydown["bShift"]()
		&& this["oControl"]["bOpened"]) {
			this["oControl"]["close"]();
			bHandled = true;
	} else
	// [ALT][DOWN]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_DOWN"], 'A')
		&& this["oControl"]["bOpened"]
	) {
		this["oControl"]["close"]();
		bHandled = true;
	} else
	// [ALT][UP]
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ARROW_UP"], 'A')
		&& this["oControl"]["bOpened"]
	) {
		this["oControl"]["close"]();
		bHandled = true;
	} else
		// [CTRL][A]
		if (
			UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["A"], 'C')
		) {
			if (this["bAllItemsSelected"]) {
				this["deselectAllItems"]();
			} else {
				this["selectAllItems"]();
			}
			bHandled = true;
	}	else {
		UCF_Listbox_Interaction.prototype["onkeydown"]["call"](this, oKeydown);
	}
	/* beautify preserve:end */

	if (bHandled) {
		oKeydown["cancel"]();
		oKeydown["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["onkeydown"] = 0; };

// ===== mousedown ============================================================

/**
 * @private
 * @param {UCF_BrowserEvent} oMousedown the mousedown
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["onmousedown"] = function(oMousedown) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["onmousedown"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemByDomRef"](oMousedown["oGetSource"]());

	if (oIM["bIsWriteable"](oItem)) {
		if (oMousedown && oMousedown["bIsTouchInteraction"]()) {
			// if touch handle is drag source don't toggle selection here
			// as it is handled in onlstouchstart
			if (!this["bOnDragHandle"](oMousedown)) {
				this["extendSelectionWithItem"](oItem);
			}
		} else if (oMousedown["bCtrl"]()) {
			this["extendSelectionWithItem"](oItem);
		} else if (oMousedown["bShift"]()) {
			this["extendSelectionWithRange"](oItem);
		} else if (oIM["aFindItemsByState"](UCF_Listbox_Items["STATE"]["Selected"])["length"] === 0) {
			// select only if no drag & drop is performed
			// this.selectItem(oItem);
		} else {
			this["interactWithItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["onmousedown"] = 0; };

// ===== click ================================================================
/**
 * @private
 * @param {UCF_BrowserEvent} oClick the click
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["onclick"] = function(oClick) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["onclick"]++; }; 
	if (oClick && !oClick["bIsTouchInteraction"]()
		&& !oClick["bCtrl"]()
		&& !oClick["bShift"]()) {
		var oItem = this["oControl"]["oGetItemsManager"]()["oFindItemByDomRef"](oClick["oGetSource"]());
		if (this["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])) {
			this["deselectItem"](oItem);
		} else {
			this["selectItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["onclick"] = 0; };

// ===== onlstouchstart =======================================================
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the touchstart
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["onlstouchstart"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {Item} */
	var oItem = oIM["oFindItemByDomRef"](oBrowserEvent["oGetSource"]());

	this["bTouchstartSelected"] = false;

	// if touch handle is source select item
	if (this["bOnDragHandle"](oBrowserEvent)) {
		if (oIM["bIsWriteable"](oItem) &&
			!oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])) {
			this["bTouchstartSelected"] = true;
			this["extendSelectionWithItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["onlstouchstart"] = 0; };

// ===== onlstouchend =========================================================
/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the onlstouchend
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["onlstouchend"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {Item} */
	var oItem = oIM["oFindItemByDomRef"](oBrowserEvent["oGetSource"]());

	// if touch handle is source select item
	if (this["bOnDragHandle"](oBrowserEvent)) {
		if (oIM["bIsWriteable"](oItem) &&
			oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]) &&
			!this["bTouchstartSelected"]) {
			this["extendSelectionWithItem"](oItem);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["onlstouchend"] = 0; };

// ===== helpers ==============================================================

/**
 * @private
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["extendSelectionWithItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["extendSelectionWithItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	if (!this["bReadonly"] && oIM["bIsWriteable"](oItem)) {
		if (oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])) {
			oIM["removeState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
		} else {
			oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
		}
		this["focusItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["extendSelectionWithItem"] = 0; };

/**
 * @private
 * @param {_MaybeItem} oItem
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["extendSelectionWithRange"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["extendSelectionWithRange"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {Array.<Array.<_RangeItem>>} */
	var aSelectedRanges = UCF_JsUtil["reduce"](
		oIM["aFindItemsByStates"](
			[UCF_Listbox_Items["STATE"]["Selected"]],
			UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"]
		),
		/**
		 * @param {Array.<Array.<_RangeItem>>} aRanges the ranges
		 * @param {UCF_Listbox_Item} oSelectedItem the item
		 * @return {Array.<Array.<_RangeItem>>}
		 */
		function(aRanges, oSelectedItem) {
			/** @type {number} */
			var iRangesLength = aRanges["length"];
			/** @type {Array.<_RangeItem>} */
			var aLastRange;
			/** @type {number} */
			var iLastRangeLength;

			if (iRangesLength === 0) {
				aRanges["push"]([oSelectedItem]);
			} else {
				aLastRange = aRanges[iRangesLength - 1];
				iLastRangeLength = aLastRange["length"];

				if (
					oIM["iGetItemIndex"](aLastRange[iLastRangeLength - 1]) ===
					oIM["iGetItemIndex"](oSelectedItem) - 1
				) {
					aLastRange["push"](oSelectedItem);
				} else {
					aRanges["push"]([oSelectedItem]);
				}
			}

			return aRanges;
		},
		[]
	);
	/** @type {Array.<UCF_Listbox_Item>} */
	var aLastInteractedRange = UCF_JsUtil["find"](
		aSelectedRanges,
		/**
		 * @param {Array.<UCF_Listbox_Item>} aRange the range
		 * @return {boolean}
		 */
		function(aRange) {
			return UCF_JsUtil["some"](
				aRange,
				/**
				 * @param {UCF_Listbox_Item} o the item
				 * @return {boolean}
				 */
				function(o) {
					return oIM["bHasState"](o, UCF_Listbox_Items["STATE"]["LastInteractedWith"]);
				}
			);
		}
	) || (aSelectedRanges["length"] > 0 && aSelectedRanges[0]);
	/** @type {number} */
	var iCurrentIndex;
	/** @type {number} */
	var iMinIndex;
	/** @type {UCF_Listbox_Item} */
	var oFocusedItem = this["oGetFocusedItem"]();
	/** @type {boolean} */
	var bSelect = this["bHasState"](oFocusedItem, UCF_Listbox_Items["STATE"]["Selected"])
		? true : false;

	if (
		UCF_JsUtil["bIsArray"](aLastInteractedRange) &&
		aLastInteractedRange["length"] > 0 && bSelect
	) {
		iCurrentIndex = oIM["iGetItemIndex"](oItem);
		iMinIndex = oIM["iGetItemIndex"](aLastInteractedRange[0]);

		// oIM.clearState(UCF_Listbox_Items.STATE.Selected);
		UCF_JsUtil["forEach"](
			iCurrentIndex < iMinIndex
			? oIM["aFindItemsByIndexRange"](
				iCurrentIndex,
				oIM["iGetItemIndex"](aLastInteractedRange[aLastInteractedRange["length"] - 1])
			)
			: oIM["aFindItemsByIndexRange"](
				iMinIndex,
				iCurrentIndex
			),
			function(o) {
				if (!oIM["bHasState"](o, UCF_Listbox_Items["STATE"]["Disabled"])) {
					oIM["addState"](o, UCF_Listbox_Items["STATE"]["Selected"]);
				}
			}
		);
	} else {
		oIM["removeState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
	}
	this["focusItem"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["extendSelectionWithRange"] = 0; };

// ===== api ==================================================================

/**
 * @protected
 * @param {string} sId the id of the item to select
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["selectItemById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["selectItemById"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemById"](sId);

	if (
		!this["bReadonly"] &&
		oIM["bIsWriteable"](oItem) &&
		!oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])
	) {
		this["extendSelectionWithItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["selectItemById"] = 0; };

/**
 * @protected
 * @param {string} sId the id of the item to deselect
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["deselectItemById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["deselectItemById"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {_MaybeItem} */
	var oItem = oIM["oFindItemById"](sId);

	if (
		!this["bReadonly"] &&
		oIM["bIsWriteable"](oItem) &&
		oIM["bHasState"](oItem, UCF_Listbox_Items["STATE"]["Selected"])
	) {
		this["extendSelectionWithItem"](oItem);
	}
	this["bAllItemsSelected"] = false;
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["deselectItemById"] = 0; };

/**
 * @protected
 * @param {Array.<string>} aKeys the list of keys of items to select
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["selectItemsByKeys"] = function(aKeys) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["selectItemsByKeys"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM;
	/** @type {UCF_Listbox_PopupMultiSelectInteraction} */
	var self;

	if (aKeys && aKeys["length"] > 0) {
		oIM = this["oControl"]["oGetItemsManager"]();
		self = this;

		oIM["clearState"](UCF_Listbox_Items["STATE"]["Selected"]);
		UCF_JsUtil["forEach"](aKeys, function(sKey) {
			self["extendSelectionWithItem"](oIM["oFindItemByKey"](sKey));
		});
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["selectItemsByKeys"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["selectItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["selectItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	if (!this["bReadonly"] && oIM["bIsWriteable"](oItem)) {
		//	oIM.clearState(UCF_Listbox_Items.STATE.Selected);
		oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
	}
	this["focusItem"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["selectItem"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the item
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["deselectItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["deselectItem"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	if (!this["bReadonly"] && oIM["bIsWriteable"](oItem)) {
		//	oIM.clearState(UCF_Listbox_Items.STATE.Selected);
		oIM["removeState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
	}
	this["bAllItemsSelected"] = false;
	this["focusItem"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["deselectItem"] = 0; };

/**
 * @protected
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["selectAllItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["selectAllItems"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();

	UCF_JsUtil["forEach"](
		UCF_JsUtil["values"](oIM["oGetItems"]()),
		function(oItem) {
			if (oIM["bIsItemEnabled"](oItem)) {
				oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
			}
		}
	);
	this["bAllItemsSelected"] = true;
	this["focusItem"](this["oGetFirstWriteableItem"]());
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["selectAllItems"] = 0; };

/**
 * @protected
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["deselectAllItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["deselectAllItems"]++; }; 
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"]["oGetItemsManager"]();
	/** @type {UCF_Listbox_Item} */
	var oItem = this["oGetFirstWriteableItem"]();

	UCF_JsUtil["forEach"](
		UCF_JsUtil["values"](oIM["oGetItems"]()),
		function(oItem) {
			if (oIM["bIsItemEnabled"](oItem)) {
				oIM["removeState"](oItem, UCF_Listbox_Items["STATE"]["Selected"]);
			}
		}
	);
	this["bAllItemsSelected"] = false;
	if (oItem["id"]) {
		// UCF_DomUtil.moveFocusDomElement(oItem, true);
		UCF_DomUtil["focusDomElement"](oItem);
		this["focusItem"](oItem);
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["deselectAllItems"] = 0; };

/**
 * @protected
 * @param {_MaybeItem} oItem the element or item
 * @param {UCF_Listbox_Items.STATE} iState the state to check
 * @return {boolean}
 */
UCF_Listbox_PopupMultiSelectInteraction["prototype"]["bHasState"] = function(oItem, iState) {;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["bHasState"]++; }; 
	var oIM = this["oControl"]["oGetItemsManager"]();
	return oIM["bHasState"](oItem, iState);
};;if (__UCF_COVERAGE__) { UCF_Listbox_PopupMultiSelectInteraction["_"]["bHasState"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_SingleSelect"] = function() {/* global UCF_Listbox_Interaction */
/// <reference path="./delegates/Listbox_Interaction.js"/>
/* global UCF_Listbox */
/// <reference path="./Listbox.js"/>

/**
 * @ct LIB_S
 * @class UCF_Listbox_SingleSelect
 * @extends UCF_Control
 * @param {HTMLDivElement} oDomRef the DOM element
 * @param {UCF_LS} oLS the LightSpeed instance
 */
function UCF_Listbox_SingleSelect(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Listbox_SingleSelect["_"]["UCF_Listbox_SingleSelect"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Listbox["apply"](this, [oDomRef, oLS]);

		this["oInteraction"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox_Interaction"))(this);
		this["addDelegate"](this["oInteraction"]);
	}
};window["UCF_Listbox_SingleSelect"] = UCF_Listbox_SingleSelect; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_SingleSelect"); UCF_Listbox_SingleSelect["_"] = {UCF_Listbox_SingleSelect: 0}; }; ;
UCF_Listbox_SingleSelect["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Listbox"))(); UCF_Listbox_SingleSelect.prototype["sClassName"] = "UCF_Listbox_SingleSelect";

/**
 * Destructor
 * @private
 */
UCF_Listbox_SingleSelect["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_SingleSelect["_"]["destroy"]++; }; 
	if (this["oInteraction"]) {
		this["oInteraction"]["destroy"]();
		this["oInteraction"] = null;
	}
	UCF_Listbox.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_SingleSelect["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_Suggest"] = function() {/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Listbox_Items */
/// <reference path="./Listbox_Item.js"/>
/* global UCF_Listbox_Popup */
/// <reference path="./Listbox_Popup.js"/>
/* global UCF_Listbox_JsonPopup */
/// <reference path="./Listbox_JsonPopup.js"/>

/**
 * @abstract
 * @depends UCF_Listbox_JsonPopup
 */
function UCF_Listbox_Suggest() {if (__UCF_COVERAGE__) { UCF_Listbox_Suggest["_"]["UCF_Listbox_Suggest"]++; }; 

};window["UCF_Listbox_Suggest"] = UCF_Listbox_Suggest; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_Suggest"); UCF_Listbox_Suggest["_"] = {UCF_Listbox_Suggest: 0}; }; ;

/**
 * @protected
 * @param {UCF_Listbox_Popup} self
 */
UCF_Listbox_Suggest["extend"] = function(self) {;if (__UCF_COVERAGE__) { UCF_Listbox_Suggest["_"]["extend"]++; };  // eslint-disable-line consistent-this
	// make sure UCF_JsonPopup is loaded
	UCF_ClassLoader["oGetClass"]('UCF_Listbox_JsonPopup');

	/** @type {string} */
	self["sClientFilter"] = '';

	self["attachEvent"](self["E_EVENTS"]["WillDeleteItem"], self, 'onWillDeleteItem');
	self["attachEvent"](self["E_EVENTS"]["DidDeleteItem"], self, 'onDidDeleteItem');

	// ===== internal api =======================================================

	/**
	 * @see UCF_ComboBox#handleDeleteKeydown
	 *
	 * @protected
	 * @param {_MaybeItem} oItem the item to delete
	 */
	self["handleDeleteItem"] = function(oItem) {
		if (!oItem) {
			oItem = this["oGetSelectedItem"]();
		}
		if (!this["bIsActionItem"](oItem)) {
			this["handleNextItem"](oItem);
			this["deleteItem"](oItem);
		}
	};

	/**
	 * @protected
	 * @return {number}
	 */
	self["iGetSuggestedItems"] = function() {
		/** @type {Array.<_MaybeItem>} */
		var aItems = this["aGetVisibleItems"]();

		return aItems && aItems["length"];
	};

	/**
	 * @protected
	 * @param {string} sFilter the filter
	 * @param {boolean} bPrefixSearch `true` to match prefixes
	 * @param {boolean} bValue1OrValue2 `true` to match both values
	 * @return {UCF_Listbox_Item}
	 */
	self["filterList"] = function(sFilter, bPrefixSearch, bValue1OrValue2) {
		/** @type {UCF_Listbox_Items} */
		var oIM = this["oGetItemsManager"]();
		/** @type {UCF_Listbox_Suggest} */
		var self; // eslint-disable-line no-shadow
		/** @type {Array.<_MaybeItem>} */
		var aItems;

		if (this["sClientFilter"] !== sFilter) {
			this["sClientFilter"] = sFilter;
			self = this;

			UCF_JsUtil["forEach"](
				oIM["aFindItemsByStates"]([], [
					UCF_Listbox_Items["STATE"]["TableHeader"],
					UCF_Listbox_Items["STATE"]["Headline"]
				]), // == all items
				function(oItem) {
					if (self["bIsMatch"](oItem, sFilter, bPrefixSearch, bValue1OrValue2)) {
						oIM["removeState"](oItem, UCF_Listbox_Items["STATE"]["Hidden"]);
					} else {
						oIM["addState"](oItem, UCF_Listbox_Items["STATE"]["Hidden"]);
					}
				}
			);

			this["oCache"]["invalidate"]('aHistoryItems');
			this["oCache"]["invalidate"]('bHistoryVisible');
			this["oCache"]["invalidate"]('aVisibleItems');
			this["oCache"]["invalidate"]('iVisibleItemsWidthPx');
			this["oCache"]["invalidate"]('oLastWriteableItem');

			this["resetSeparator"]();

			if (window["UCF_System"]["bIsAria"]) {
				this["resetAria"]();
			}

			if (this["bOpened"]) {
				this["applyHeight"]();
				this["setPosition"]();
			}
		}

		aItems = this["aGetVisibleItems"]();

		return aItems && aItems["length"] > 0 && oIM["oToItem"](aItems[0]);
	};
	/**
	 * @private
	 * @param {_MaybeItem} oItem the item
	 * @param {string} sFilter the filter to match against the values of oItem
	 * @param {boolean} [bPrefixSearch=false] `true` to match only if `sFilter` is
	 * a prefix
	 * @param {boolean} [bValue1OrValue2=false] `true` to match if `oItem.sValue1`
	 * or `oItem.sValue2` match `sFilter`
	 * @return {boolean}
	 */
	self["bIsMatch"] = function(oItem, sFilter, bPrefixSearch, bValue1OrValue2) {
		/** @type {UCF_Listbox_Items} */
		var oIM = this["oGetItemsManager"]();
		/**
		 * @param {string} sValue the value
		 * @return {boolean}
		 */
		var fMatches = bPrefixSearch
			? function(sValue) {
				return UCF_StringUtil["bStartsWith"](sValue, sFilter, true);
			}
			: function(sValue) {
				return (sFilter === '') // bContains returns false for '' search
					|| UCF_StringUtil["bContains"](sValue, sFilter, true);
			};
		/** @type {string} */
		var sValue1;
		/** @type {string} */
		var sValue2;

		if (oItem) {
			sValue1 = oIM["sGetItemValue1"](oItem);
			sValue2 = oIM["sGetItemValue2"](oItem);

			// SuggestBoxListBox#bIsMatch matches 2nd value only if it is not '', i.e.
			// assumes match if it is ''
			return (bValue1OrValue2 && sValue2)
				? (fMatches(sValue1) || fMatches(sValue2))
				: fMatches(sValue1);
		} else {
			return false;
		}
	};

	/**
	 * @private
	 * @return {Array.<_MaybeItem>}
	 */
	self["aGetVisibleItems"] = function() {
		/** @type {UCF_Listbox_Suggest} */
		var self = this; // eslint-disable-line no-shadow

		return this["oCache"]["get"]('aVisibleItems', function() {
			return self["oGetItemsManager"]()["aFindItemsByStates"](
				[],
				[
					UCF_Listbox_Items["STATE"]["Hidden"],
					UCF_Listbox_Items["STATE"]["Headline"],
					UCF_Listbox_Items["STATE"]["TableHeader"],
					UCF_Listbox_Items["STATE"]["Deleted"]
				]
			);
		});
	};

	/** @override */
	self["onWillDeleteItem"] = function() {
		this["oCache"]["invalidate"]('aVisibleItems');
		this["oCache"]["invalidate"]('iVisibleItemsWidthPx');
	};

	self["onDidDeleteItem"] = function() {
		if (this["iGetSuggestedItems"]() === 0) {
			// can't use fireSelect() because there is no item to select
			this["fireEvent"](this["E_EVENTS"]["Select"], {
				"sKey": '',
				"sValue": '',
				"bFireSelect": false,
				"sEventName": 'leave',
				"sIconSrc": ''
			});
		}
	};

	if (!('hideNoResults' in self)) {
		/** @protected */
		self["hideNoResults"] = function() {
			// nothing to do, "no results" only shown for Listbox_JsonSuggest
		};
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_Suggest["_"]["extend"] = 0; };

};
sap["ls"]["preload"]["UCF_Listbox_TruncationDelegate"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>

/**
 * @class
 * @extends UCF_Object
 * @param {UCF_Listbox} oControl
 */
function UCF_Listbox_TruncationDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_Listbox_TruncationDelegate["_"]["UCF_Listbox_TruncationDelegate"]++; }; 
	if (arguments["length"] > 0) {
		/** @type {UCF_Listbox} */
		this["oControl"] = oControl;
	}
};window["UCF_Listbox_TruncationDelegate"] = UCF_Listbox_TruncationDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Listbox_TruncationDelegate"); UCF_Listbox_TruncationDelegate["_"] = {UCF_Listbox_TruncationDelegate: 0}; }; ;
UCF_Listbox_TruncationDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Listbox_TruncationDelegate.prototype["sClassName"] = "UCF_Listbox_TruncationDelegate";

/** @override */
UCF_Listbox_TruncationDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Listbox_TruncationDelegate["_"]["destroy"]++; }; 
	this["oControl"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Listbox_TruncationDelegate["_"]["destroy"] = 0; };

/** @param {UCF_BrowserEvent} oMouseover */
UCF_Listbox_TruncationDelegate["prototype"]["onmouseover"] = function(oMouseover) {;if (__UCF_COVERAGE__) { UCF_Listbox_TruncationDelegate["_"]["onmouseover"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oMouseover["oGetSource"]();
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oControl"] && this["oControl"]["oGetItemsManager"]();
	/** @type {boolean} */
	var bIsIconValue = UCF_DomUtil["bHasClass"](
		UCF_DomUtil["oGetParentElement"](oSource),
		'lsListbox__values--icon'
	);
	/** @type {boolean} */
	var bIsHistoryValue = UCF_DomUtil["bHasClass"](
		oSource,
		'lsListbox__value--history'
	);
	/** @type {boolean} */
	var bIsGroupTitleValue = UCF_DomUtil["bHasClass"](
		oSource,
		'lsListbox__value--group'
	);
	/** @type {boolean} */
	var bIsHeadlineValue = UCF_DomUtil["bHasClass"](
		oSource,
		'lsListbox__value--headline'
	);
	/** @type {string} */
	var sIconToolTip = bIsIconValue ? oIM["sGetItemIconToolTip"](oSource) : '';
	/** @type {string} */
	var sItemTooltip = oIM["sGetItemTooltip"](oSource);
	/** @type {string} */
	var sTooltip = this["oControl"]["sTooltip"];

	if (bIsGroupTitleValue) {
		oSource["textContent"] = UCF_DomUtil["dataset"](oSource)["itemgrouptitle"];
	}
	if (bIsHeadlineValue || bIsHistoryValue) {
		oSource["textContent"] = UCF_DomUtil["dataset"](oSource)["itemvalue1"] ||
			UCF_DomUtil["dataset"](oSource)["itemvalue2"];
	}

	if (oSource["scrollWidth"] > oSource["offsetWidth"]) {
		oSource["setAttribute"]('title', UCF_JsUtil["filter"](
			[sIconToolTip, sItemTooltip, sTooltip, UCF_DomUtil["sGetInnerText"](oSource)],
			function(x) { return x; }
		)["join"](' - '));
	} else {
		oSource["setAttribute"]('title', UCF_JsUtil["filter"](
			[sIconToolTip, sItemTooltip, sTooltip],
			function(x) { return x; }
		)["join"](' - '));
	}

	if (bIsGroupTitleValue || bIsHistoryValue || bIsHeadlineValue) {
		oSource["textContent"] = '';
	}
};;if (__UCF_COVERAGE__) { UCF_Listbox_TruncationDelegate["_"]["onmouseover"] = 0; };

};
sap["ls"]["preload"]["UCF_LoadingAnimation"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_LoadingAnimation(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["UCF_LoadingAnimation"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "LoadingAnimation.js(29): UCF_LoadingAnimation"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "LoadingAnimation.js(30): UCF_LoadingAnimation"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "LoadingAnimation.js(31): UCF_LoadingAnimation"); };

	UCF_LayeredControl["apply"](this, [oDomRef, oLS]);

	this["attachLSEvent"](this["oLS"]["E_EVENTS"]["ControlVisibilityChange"], "onFooterToolbarVisibilityChange");

	this["iAlignment"] = UCF_LayeredControl["ALIGNMENT"]["BROWSERCENTER"];
	this["sTimer"] = null;
	this["sType"] = !UCF_DomUtil["$"]("ur-loading-footer") ? this["TYPE"]["INDICATOR"] : this["TYPE"]["DIALOG"];
};window["UCF_LoadingAnimation"] = UCF_LoadingAnimation; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LoadingAnimation"); UCF_LoadingAnimation["_"] = {UCF_LoadingAnimation: 0}; }; ;
UCF_LoadingAnimation["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_LoadingAnimation.prototype["sClassName"] = "UCF_LoadingAnimation";

UCF_LoadingAnimation["prototype"]["TYPE"] = {
	"INDICATOR": "INDICATOR",
	"DIALOG": "DIALOG"
};

/**
 * Triggers the loading animation with given delay in ms
 * @public
 */
UCF_LoadingAnimation["prototype"]["trigger"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["trigger"]++; }; 

	if (this["sTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimer"]);
	}
	this["sTimer"] = UCF_JsUtil["delayedCall"](this["iDelay"], this, "show");

};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["trigger"] = 0; };

/**
 * Shows the loading animation immediately
 * @public
 */
UCF_LoadingAnimation["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["show"]++; }; 

	if (this["sTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimer"]);
	}
	this["open"]();
	this["fireShow"]();
	if (window["UCF_System"]["bIs508"]) {
		//lsaccessibility handler won't be accessed because focusin event triggering lsaccessibility will be canceled in Browserwindow during LS lock state
		//therefore manually set the title attribute

		if (!this["oDomRef"]["getAttribute"]("title") && !this["oDomRef"]["title"]) {
			UCF_DomUtil["setTooltip"](this["oDomRef"], this["oLS"]["sGetText"]("SAPUR_LOADINGANIM"));
		}
		UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
		if (this["oLS"]["oBrowserWindow"]["bIsFocussed"]()) UCF_DomUtil["moveFocusDomElement"](this["oDomRef"]);
		//BCP 278200 / 2016: In a scenario with two browser windows communication with EPCM eventing the moveFocus can cause that the application in the background becomes visible once 508 is enabled and the loading animation appears.
	}
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setRole"](this["oDomRef"], 'alert');
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["show"] = 0; };

/**
 * Cancels the loading animation, hides if already shown and
 * stops the timeout if canceled before
 * @public
 */
UCF_LoadingAnimation["prototype"]["cancel"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["cancel"]++; }; 

	UCF_JsUtil["clearDelayedCall"](this["sTimer"]);
	this["sTimer"] = null;
	if (window["UCF_System"]["bIs508"]) {
		UCF_DomUtil["resetTabIndex"](this["oDomRef"]);
	}
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setRole"](this["oDomRef"]);
	}
	this["close"]();
	this["fireHide"]();
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["cancel"] = 0; };

/**
 * Sets the text of the loading animation
 *
 * @public
 * @param {string} sText the new text of the textview
 */
UCF_LoadingAnimation["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["setText"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sText) === "string", "typeof(sText) === \"string\"", "LoadingAnimation.js(115): setText"); };

	var sClassName = "";
	var bShowFooterToolbar = false;
	var oFooterRef = UCF_DomUtil["$"]("ur-loading-footer");
	var bFullPageLockStateEnabled = this["oLS"]["oGetRenderManager"]()["getRenderer"]('FeatureFlags')["renderIsEnabled"]({
		"Feature": 'oneux.fullpagelockstate'
	}, this["oLS"]["oGetRenderManager"]());

	if (oFooterRef) {
		var oUCFFooterToolbar = this["oGetControlByDomRef"](UCF_DomUtil["oGetFirstChild"](oFooterRef), false);
		if (oUCFFooterToolbar) bShowFooterToolbar = oUCFFooterToolbar["sVisibility"] === "VISIBLE";
	}
	var oTextDiv = UCF_DomUtil["$"]("loadinganimationtext");
	if (!sText && !oTextDiv) return;

	if (!sText) {
		this["oDomRef"]["childNodes"][1]["removeChild"](oTextDiv);
		this["sText"] = sText;
		this["setClientProperty"]("Text", sText, true);
		if (bFullPageLockStateEnabled) {
			if (this["sType"] === this["TYPE"]["INDICATOR"]) {
				sClassName = "urLoadA lsLoadABlockLayer";
			} else {
				sClassName = "urLoadA lsLoadABlockLayer lsLoadADialogBoxPad";
				if (bShowFooterToolbar) sClassName += " lsLoadADialogBox lsLoadABox sapContrast";
			}
		} else {
			if (this["sType"] === this["TYPE"]["INDICATOR"]) {
				sClassName = "urLoadA";
			} else {
				sClassName = "urLoadA lsLoadADialogBoxPad";
				if (bShowFooterToolbar) sClassName += " lsLoadADialogBox lsLoadABox_WOBL sapContrast";
			}
		}
		UCF_DomUtil["setClass"](UCF_DomUtil["$"]("ur-loading-box"), sClassName);
		return;
	}
	if (!oTextDiv) {
		oTextDiv = document["createElement"]("DIV");
		oTextDiv["setAttribute"]("id", "loadinganimationtext");
		UCF_DomUtil["setClass"](oTextDiv, "urLoadATxt lsLoadATxtPadding");
		if (this["sType"] === this["TYPE"]["INDICATOR"]) {
			UCF_DomUtil["$"]("ur-loading-box")["appendChild"](oTextDiv);
		} else {
			UCF_DomUtil["$"]("ur-loading-box")["insertBefore"](oTextDiv, UCF_DomUtil["$"]("ur-loading-footer"));
		}
	}
	if (bFullPageLockStateEnabled) {
		if (this["sType"] === this["TYPE"]["INDICATOR"]) {
			sClassName = "urLoadA lsLoadABlockLayer lsLoadABox sapContrast";
		} else {
			sClassName = "urLoadA lsLoadABlockLayer lsLoadADialogBoxPad lsLoadABox sapContrast";
			if (bShowFooterToolbar) sClassName += " lsLoadADialogBox";
		}
	} else {
		if (this["sType"] === this["TYPE"]["INDICATOR"]) {
			sClassName = "urLoadA lsLoadABox_WOBL sapContrast";
		} else {
			sClassName = "urLoadA lsLoadADialogBoxPad lsLoadABox_WOBL sapContrast";
			if (bShowFooterToolbar) sClassName += " lsLoadADialogBox";
		}
	}
	UCF_DomUtil["setClass"](UCF_DomUtil["$"]("ur-loading-box"), sClassName);
	UCF_DomUtil["setInnerText"](oTextDiv, sText);

	this["sText"] = sText;
	this["setClientProperty"]("Text", sText, true);

};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["setText"] = 0; };

/**
 * Returns the value of the loading animation
 *
 * @return text of the loading animation
 * @type string
 *
 * @public
 */
UCF_LoadingAnimation["prototype"]["getText"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["getText"]++; }; 
	return this["sText"];
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["getText"] = 0; };

/**
 * Shows the aggregated FooterToolbar
 *
 * @public
 */
UCF_LoadingAnimation["prototype"]["showFooterToolbar"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["showFooterToolbar"]++; }; 

	var bFullPageLockStateEnabled = this["oLS"]["oGetRenderManager"]()["getRenderer"]('FeatureFlags')["renderIsEnabled"]({
		"Feature": 'oneux.fullpagelockstate'
	}, this["oLS"]["oGetRenderManager"]());

	var oFooterRef = UCF_DomUtil["$"]("ur-loading-footer");
	if (oFooterRef) {
		var oBoxRef = UCF_DomUtil["$"]("ur-loading-box");
		if (!UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadADialogBox")) UCF_DomUtil["addClass"](oBoxRef, "lsLoadADialogBox");
		if (bFullPageLockStateEnabled) {
			if (!UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadABox")) UCF_DomUtil["addClass"](oBoxRef, "lsLoadABox");
		} else {
			if (!UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadABox_WOBL")) UCF_DomUtil["addClass"](oBoxRef, "lsLoadABox_WOBL");
		}
		if (!UCF_DomUtil["bHasClass"](oBoxRef, "sapContrast")) UCF_DomUtil["addClass"](oBoxRef, "sapContrast");

		oFooterRef["style"]["visibility"] = "visible";
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["showFooterToolbar"] = 0; };

/**
 * Hides the aggregated FooterToolbar
 *
 * @public
 */
UCF_LoadingAnimation["prototype"]["hideFooterToolbar"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["hideFooterToolbar"]++; }; 

	var bFullPageLockStateEnabled = this["oLS"]["oGetRenderManager"]()["getRenderer"]('FeatureFlags')["renderIsEnabled"]({
		"Feature": 'oneux.fullpagelockstate'
	}, this["oLS"]["oGetRenderManager"]());

	var oFooterRef = UCF_DomUtil["$"]("ur-loading-footer");
	if (oFooterRef) {
		var oBoxRef = UCF_DomUtil["$"]("ur-loading-box");
		if (UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadADialogBox")) UCF_DomUtil["removeClass"](oBoxRef, "lsLoadADialogBox");
		if (bFullPageLockStateEnabled) {
			if (!this["sText"] && UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadABox")) UCF_DomUtil["removeClass"](oBoxRef, "lsLoadABox");
		} else {
			if (!this["sText"] && UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadABox_WOBL")) UCF_DomUtil["removeClass"](oBoxRef, "lsLoadABox_WOBL");
		}
		if (!this["sText"] && UCF_DomUtil["bHasClass"](oBoxRef, "sapContrast")) UCF_DomUtil["removeClass"](oBoxRef, "sapContrast");

		oFooterRef["style"]["visibility"] = "hidden";
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["hideFooterToolbar"] = 0; };

/**
 * Cancels the loading animation timeout
 * @private
 */
UCF_LoadingAnimation["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["destroy"]++; }; 

	this["cancel"](); //close explicitly the loading animation as there are case in which the loadingAnimation remains visible

	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["ControlVisibilityChange"]);

	this["iAlignment"] = 0;
	this["sTimer"] = null;
	this["sType"] = "";
	this["sText"] = "";

	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["destroy"] = 0; };

UCF_LoadingAnimation["prototype"]["onlsfocus"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onlsfocus"]++; }; 
	if (oBrowserEvent["oGetSource"]()["getAttribute"]("tp") === "START") {
		if (!this["focusLastChildControl"]() && oBrowserEvent["oFromElement"]) {
			UCF_DomUtil["focusDomElement"](oBrowserEvent["oFromElement"]);
		}
	}
	if (oBrowserEvent["oGetSource"]()["getAttribute"]("tp") === "END") {
		if (!this["focusFirstChildControl"]() && oBrowserEvent["oFromElement"]) {
			UCF_DomUtil["focusDomElement"](oBrowserEvent["oFromElement"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onlsfocus"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 * @private
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LoadingAnimation["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LoadingAnimation.js(291): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	oAccessibilityHelper["setText"](this["oLS"]["sGetText"]("SAPUR_LOADINGANIM"));

};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onlsaccessibility"] = 0; };

UCF_LoadingAnimation["prototype"]["onFooterToolbarVisibilityChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onFooterToolbarVisibilityChange"]++; }; 
	var oFooterRef = UCF_DomUtil["$"]("ur-loading-footer");
	if (!oFooterRef) return;
	var oUCFFooterToolbar = this["oGetControlByDomRef"](UCF_DomUtil["oGetFirstChild"](oFooterRef), false);
	if (!oUCFFooterToolbar) return;
	if (oEvent["mParameters"]["sId"] !== oUCFFooterToolbar["sId"]) return;

	switch (oEvent["mParameters"]["sVisibility"]) {
		case "VISIBLE":
			this["showFooterToolbar"]();
			break;
		case "BLANK":
			this["hideFooterToolbar"]();
			break;
		case "NONE":
			this["hideFooterToolbar"]();
			break;
		case "ON_DEMAND":
			break;
		default:
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onFooterToolbarVisibilityChange"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_LoadingAnimation["prototype"]["aAttributeNames"] = ["sText","iDelay","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_LoadingAnimation["prototype"]["aEventNames"] = ["Show","Hide"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_LoadingAnimation["prototype"]["aMethodNames"] = ["trigger","show","cancel","setText","getText","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_LoadingAnimation["prototype"]["sText"] = '';

/**
 * @private
 * @type {number}
 */
UCF_LoadingAnimation["prototype"]["iDelay"] = 2000;

/**
 * @private
 * @type {string}
 */
UCF_LoadingAnimation["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_LoadingAnimation["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["iDelay"] = 2000;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Delay", 2000, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * 
 * @fires LoadingAnimation::Show
 */
UCF_LoadingAnimation["prototype"]["fireShow"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["fireShow"]++; }; 
	/** @type {{}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 0, "arguments.length == 0", "LoadingAnimation.js(387): fireShow"); };
	
	mParams = {
		
	};
	
	this["fireSemanticEvent"]("LoadingAnimation", "Show", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["fireShow"] = 0; };

/**
 * @protected
 * 
 * @fires LoadingAnimation::Hide
 */
UCF_LoadingAnimation["prototype"]["fireHide"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["fireHide"]++; }; 
	/** @type {{}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 0, "arguments.length == 0", "LoadingAnimation.js(405): fireHide"); };
	
	mParams = {
		
	};
	
	this["fireSemanticEvent"]("LoadingAnimation", "Hide", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["fireHide"] = 0; };

UCF_LoadingAnimation.prototype["aPublicMethods"] = ["trigger","show","cancel","setText","getText","showFooterToolbar","hideFooterToolbar"].concat(UCF_LoadingAnimation.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_LoadingPlaceHolder"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_LoadingPlaceHolder(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["UCF_LoadingPlaceHolder"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "LoadingPlaceHolder.js(20): UCF_LoadingPlaceHolder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "LoadingPlaceHolder.js(21): UCF_LoadingPlaceHolder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "LoadingPlaceHolder.js(22): UCF_LoadingPlaceHolder"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oLS"]["attachAfterEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"], this, 'onAfterControlsInitialized');
};window["UCF_LoadingPlaceHolder"] = UCF_LoadingPlaceHolder; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LoadingPlaceHolder"); UCF_LoadingPlaceHolder["_"] = {UCF_LoadingPlaceHolder: 0}; }; ;

UCF_LoadingPlaceHolder["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_LoadingPlaceHolder.prototype["sClassName"] = "UCF_LoadingPlaceHolder";


UCF_LoadingPlaceHolder["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["initialize"]++; }; 
};;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["initialize"] = 0; };

/**
 * Fires the Load event after the initializeIDs-Phase of startup/update
 */
UCF_LoadingPlaceHolder["prototype"]["onAfterControlsInitialized"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["onAfterControlsInitialized"]++; }; 
	// Additional delay to make sure ClientInspector.Notify events are contained in the event queue,
	// because it also is triggered by After-ControlsInitialized.
	UCF_JsUtil["delayedCall"](0, this, "fireLoad", [this["sId"]]);
	// Immediately detach: WDA might do an update with only script-calls and NOT remove the LoadingPlaceholder,
	// The initializeIDs array would be empty, but LS will still send the event!
	this["oLS"]["detachAfterEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"], this, 'onAfterControlsInitialized');
};;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["onAfterControlsInitialized"] = 0; };

UCF_LoadingPlaceHolder["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["destroy"]++; }; 
	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	this["oLS"]["detachAfterEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"], this, 'onAfterControlsInitialized');
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_LoadingPlaceHolder["prototype"]["aAttributeNames"] = ["sId","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_LoadingPlaceHolder["prototype"]["aEventNames"] = ["Load"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_LoadingPlaceHolder["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_LoadingPlaceHolder["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_LoadingPlaceHolder["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_LoadingPlaceHolder["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The Id of the control
 * @fires LoadingPlaceHolder::Load
 */
UCF_LoadingPlaceHolder["prototype"]["fireLoad"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["fireLoad"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "LoadingPlaceHolder.js(108): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "LoadingPlaceHolder.js(109): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "LoadingPlaceHolder.js(110): fireLoad"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("LoadingPlaceHolder", "Load", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["fireLoad"] = 0; };

};
sap["ls"]["preload"]["UCF_MapType"] = function() {/* global UCF_SimpleType */
/// <reference path="../SimpleType.js"/>

/**
 * Constructor for a String type.
 *
 * This class represents string simple types.
 *
 * @extends UCF_SimpleType
 * 
 * @version 1.7.0-SNAPSHOT
 *
 * @public
 * @class
 * @constructor
 * @param {Object} oConfiguration
 */
function UCF_MapType(oConfiguration) {if (__UCF_COVERAGE__) { UCF_MapType["_"]["UCF_MapType"]++; }; 
	/** @type {string} */
	var n;

	UCF_SimpleType["apply"](this, arguments);
	this["mMapConfiguration"] = oConfiguration;
	this["mMapConfigurationReverse"] = {};
	for (n in this["mMapConfiguration"]) {
		this["mMapConfigurationReverse"][this["mMapConfiguration"][n]] = n;
	}
	this["sName"] = 'Map';
};window["UCF_MapType"] = UCF_MapType; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MapType"); UCF_MapType["_"] = {UCF_MapType: 0}; }; ;
UCF_MapType["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SimpleType"))(); UCF_MapType.prototype["sClassName"] = "UCF_MapType";

/** @override */
UCF_MapType["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MapType["_"]["destroy"]++; }; 
	this["mMapConfiguration"] = null;

	UCF_SimpleType.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MapType["_"]["destroy"] = 0; };

/**
 * @param {string} sValue
 * @return {any}
 */
UCF_MapType["prototype"]["formatValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_MapType["_"]["formatValue"]++; }; 
	return this["mMapConfiguration"][sValue];
};;if (__UCF_COVERAGE__) { UCF_MapType["_"]["formatValue"] = 0; };

/**
 * @param {Object} oValue
 * @return {any}
 */
UCF_MapType["prototype"]["parseValue"] = function(oValue) {;if (__UCF_COVERAGE__) { UCF_MapType["_"]["parseValue"]++; }; 
	return this["mMapConfigurationReverse"][oValue];
};;if (__UCF_COVERAGE__) { UCF_MapType["_"]["parseValue"] = 0; };

/**
 * @param {string} sValue
 * @return {boolean}
 */
UCF_MapType["prototype"]["validateValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_MapType["_"]["validateValue"]++; }; 
	// eslint-disable-next-line eqeqeq
	return this["mMapConfigurationReverse"][sValue] != '';
};;if (__UCF_COVERAGE__) { UCF_MapType["_"]["validateValue"] = 0; };

/**
 * Factory for a new inherited class with a special given configuration
 *
 * @protected
 * @static
 * @param {string} sName
 * @param {Object} oConfiguration
 * @return {function(new: UCF_MapType)}
 */
UCF_MapType["createNewType"] = function(sName, oConfiguration) {;if (__UCF_COVERAGE__) { UCF_MapType["_"]["createNewType"]++; }; 
	var oDefaultConfiguration = oConfiguration;
	var oClass = function(oConfiguration) { // intentional?
		if (!oConfiguration) {
			oConfiguration = oDefaultConfiguration;
		}
		UCF_MapType["apply"](this, [oConfiguration]);
		this["sName"] = sName;

	};

	oClass["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_MapType"))();
	window[sName] = oClass;

	return oClass;
};;if (__UCF_COVERAGE__) { UCF_MapType["_"]["createNewType"] = 0; };

UCF_MapType.prototype["aPublicMethods"] = ["UCF_MapType"].concat(UCF_MapType.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_MatrixLayout"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_SimpleLayoutDragDelegate */
/// <reference path="./delegates/SimpleLayoutDragDelegate.js"/>
/* global UCF_SimpleLayoutDropDelegate */
/// <reference path="./delegates/SimpleLayoutDropDelegate.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MatrixLayout(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["UCF_MatrixLayout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "MatrixLayout.js(30): UCF_MatrixLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef !== null, "oDomRef !== null", "MatrixLayout.js(31): UCF_MatrixLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "MatrixLayout.js(32): UCF_MatrixLayout"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	if (this["mEvents"]["Resize"]) {
		this["attachBrowserEvent"]("resize", this["oDomRef"]);
	}
};window["UCF_MatrixLayout"] = UCF_MatrixLayout; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MatrixLayout"); UCF_MatrixLayout["_"] = {UCF_MatrixLayout: 0}; }; ;

UCF_MatrixLayout["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_MatrixLayout.prototype["sClassName"] = "UCF_MatrixLayout";

UCF_MatrixLayout["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["initialize"]++; }; 
	if (window["UCF_System"]["sDevice"] === "standards" && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && this["sHeight"]) {
		UCF_DomUtil["initHtmlTableCorrection"](this["oDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["initialize"] = 0; };

/**
 * @return {string}
 */
UCF_MatrixLayout["prototype"]["sGetDragSourceInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["sGetDragSourceInfo"]++; }; 

	return this["sDragSourceInfo"];
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["sGetDragSourceInfo"] = 0; };

/**
 * implements method from UCF_Control
 */
UCF_MatrixLayout["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["createDragDelegate"]++; }; 

	if (!this["sDragSourceInfo"])
		return;

	if (this["oDragDelegate"])
		return;

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_SimpleLayoutDragDelegate"))(this["oLS"], this, this["sDropDecoratorType"]);
	this["addDelegate"](this["oDragDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["createDragDelegate"] = 0; };

/**
 * implements method from UCF_Control
 */
UCF_MatrixLayout["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["createDropDelegate"]++; }; 

	if (!this["sDropTargetInfo"])
		return;

	if (this["oDropDelegate"])
		return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_SimpleLayoutDropDelegate"))(this["oLS"], this, this["sDropDecoratorType"]);
	this["addDelegate"](this["oDropDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["createDropDelegate"] = 0; };

/**
 * Destructor
 */
UCF_MatrixLayout["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["destroy"]++; }; 
	if (this["mEvents"]["Resize"]) {
		this["detachBrowserEvent"]("resize", this["oDomRef"]);
	}
	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}
	this["iHeight"] = 0;
	this["iWidth"] = 0;
	this["sWidth"] = null;
	this["sHeight"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["destroy"] = 0; };

/**
 * Handles the onresize event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MatrixLayout["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["onresize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MatrixLayout.js(117): onresize"); };

	var iWidth = this["oDomRef"]["offsetWidth"];
	var iHeight = this["oDomRef"]["offsetHeight"];

	var iWidthDelta = iWidth - this["iWidth"];
	var iHeightDelta = iHeight - this["iHeight"];

	if (iWidthDelta !== 0 || iHeightDelta !== 0) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Resize MatrixLayout " + this["sId"] + " Width:" + iWidthDelta + " Height:" + iHeightDelta, "MatrixLayout.js(126): onresize"); };
		this["iWidth"] = iWidth;
		this["iHeight"] = iHeight;
		this["fireResize"](this["sId"], iWidth, iHeight);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No Resize fired on MatrixLayout " + this["sId"] + " Width:" + iWidth + " Height:" + iHeight, "MatrixLayout.js(131): onresize"); };
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["onresize"] = 0; };

UCF_MatrixLayout["prototype"]["setWidth"] = function(sWidth) {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["setWidth"]++; }; 
	if (window["UCF_System"]["sDevice"] === 'standards') {
		this["setDimension"](sWidth, this["sHeight"]);
		this["sWidth"] = sWidth;
		this["setClientProperty"]("Width", this["sWidth"], true);
	} else
		this["oDomRef"]["style"]["width"] = sWidth /*+ "px"*/ ;
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["setWidth"] = 0; };

UCF_MatrixLayout["prototype"]["setHeight"] = function(sHeight) {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["setHeight"]++; }; 
	if (window["UCF_System"]["sDevice"] === 'standards') {
		this["setDimension"](this["sWidth"], sHeight);
		this["sHeight"] = sHeight;
		this["setClientProperty"]("Height", this["sHeight"], true);
	} else
		this["oDomRef"]["style"]["height"] = sHeight /*+ "px"*/ ;
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["setHeight"] = 0; };

/**
 * @see UCF_DTExtension
 * @param { UCF_HTMLElement } oDTElement the lsaccessibility
 * @return { UCF_DTExtesion } the control specific DTExtension and instance of the base class UCF_DTExtesion
 * @private
 */
UCF_MatrixLayout["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["oGetDTExtension"]++; }; 
	return UCF_Control.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]("UCF_LayoutEditorExtension"));
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["oGetDTExtension"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MatrixLayout["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MatrixLayout.js(172): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MatrixLayout["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MatrixLayout.js(184): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["onlsskipback"] = 0; };

/**
 * In non SingleCell case, when there is a Width/Height given via API,
 * those values are set for the Root (-r)
 * and the DomRef has width/Height:100% (lsControl--fulwidth/height)
 *
 * Sets the width and height for the MatrixLayout
 *
 * @param {string} sWidth
 * @param {string} sHeight
 * @private
 */
UCF_MatrixLayout["prototype"]["setDimension"] = function(sWidth, sHeight) {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["setDimension"]++; }; 

	var bSingleCell = this["oDomRef"]["getAttribute"] && this["oDomRef"]["getAttribute"]('ur-singlecell') === 'true';
	if (this["sWidth"] !== sWidth) {
		if (bSingleCell)
			this["oDomRef"]["style"]["width"] = sWidth /*+ "px"*/ ;
		else
			this["oRootRef"]["style"]["width"] = sWidth /*+ "px"*/ ;

		if ((sWidth !== '' && !bSingleCell) || (sWidth === '100%' && bSingleCell)) {
			if (sWidth === '100%' && !bSingleCell && !UCF_DomUtil["bHasClass"](this["oRootRef"], 'lsControl--fullwidth'))
				UCF_DomUtil["addClass"](this["oRootRef"], 'lsControl--fullwidth');

			if (!UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsControl--fullwidth'))
				UCF_DomUtil["addClass"](this["oDomRef"], 'lsControl--fullwidth');
		} else if (sWidth === '') {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsControl--fullwidth');
			UCF_DomUtil["removeClass"](this["oRootRef"], 'lsControl--fullwidth');
		}
	}

	if (this["sHeight"] !== sHeight) {
		if (bSingleCell)
			this["oDomRef"]["style"]["height"] = sHeight /*+ "px"*/ ;
		else
			this["oRootRef"]["style"]["height"] = sHeight /*+ "px"*/ ;

		if ((sHeight !== '' && !bSingleCell) || (sHeight === '100%' && bSingleCell)) {
			if (sHeight === '100%' && !bSingleCell && !UCF_DomUtil["bHasClass"](this["oRootRef"], 'lsControl--fullheight'))
				UCF_DomUtil["addClass"](this["oRootRef"], 'lsControl--fullheight');
			if (!UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsControl--fullheight'))
				UCF_DomUtil["addClass"](this["oDomRef"], 'lsControl--fullheight');
		} else if (sHeight === '') {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsControl--fullheight');
			UCF_DomUtil["removeClass"](this["oRootRef"], 'lsControl--fullheight');
		}
	}

};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["setDimension"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_MatrixLayout["prototype"]["aAttributeNames"] = ["sId","sMarginLeft","sWidth","sHeight","sVisibility","sDragSourceInfo","sDropTargetInfo","sDropDecoratorType","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_MatrixLayout["prototype"]["aEventNames"] = ["Resize","Drag","Drop"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_MatrixLayout["prototype"]["aMethodNames"] = ["setWidth","setHeight","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_MatrixLayout["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MatrixLayout["prototype"]["sMarginLeft"] = '0px';

/**
 * @private
 * @type {string}
 */
UCF_MatrixLayout["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MatrixLayout["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_MatrixLayout["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_MatrixLayout["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MatrixLayout["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LayoutDropDecorator}
 */
UCF_MatrixLayout["prototype"]["sDropDecoratorType"] = "BOX";

/**
 * @private
 * @type {string}
 */
UCF_MatrixLayout["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MatrixLayout["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_MatrixLayout["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sMarginLeft"] = '0px';
	this["sWidth"] = '';
	this["sHeight"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sDragSourceInfo"] = '';
	this["sDropTargetInfo"] = '';
	this["sDropDecoratorType"] = "BOX";
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("MarginLeft", '0px', true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("DropDecoratorType", "BOX", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iWidth new width of the MatrixLyout
 * @param {number} iHeight new height of the MatrixLyout
 * @fires MatrixLayout::Resize
 */
UCF_MatrixLayout["prototype"]["fireResize"] = function(sId, iWidth, iHeight) {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["fireResize"]++; }; 
	/** @type {{Id: string, Width: number, Height: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "MatrixLayout.js(361): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MatrixLayout.js(362): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MatrixLayout.js(363): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iWidth != null, "iWidth != null", "MatrixLayout.js(364): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iWidth) == "number", "typeof(iWidth) == \"number\"", "MatrixLayout.js(365): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iHeight != null, "iHeight != null", "MatrixLayout.js(366): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iHeight) == "number", "typeof(iHeight) == \"number\"", "MatrixLayout.js(367): fireResize"); };
	mParams = {
		"Id": sId,
		"Width": iWidth,
		"Height": iHeight
	};
	
	
	
	this["fireSemanticEvent"]("MatrixLayout", "Resize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["fireResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires MatrixLayout::Drag
 */
UCF_MatrixLayout["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "MatrixLayout.js(390): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MatrixLayout.js(391): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MatrixLayout.js(392): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "MatrixLayout.js(393): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "MatrixLayout.js(394): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "MatrixLayout.js(395): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "MatrixLayout.js(396): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("MatrixLayout", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sCell The Id of the matrixlayoutcell where the drop occured
 * @param {number} iOffset The Offset relative to the matrixlayoutcell where the drop occured (signum)
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the Tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires MatrixLayout::Drop
 */
UCF_MatrixLayout["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, sCell, iOffset, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, Cell: string, Offset: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 12, "arguments.length == 12", "MatrixLayout.js(430): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MatrixLayout.js(431): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MatrixLayout.js(432): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "MatrixLayout.js(433): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "MatrixLayout.js(434): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "MatrixLayout.js(435): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "MatrixLayout.js(436): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCell != null, "sCell != null", "MatrixLayout.js(437): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCell) == "string", "typeof(sCell) == \"string\"", "MatrixLayout.js(438): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOffset != null, "iOffset != null", "MatrixLayout.js(439): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOffset) == "number", "typeof(iOffset) == \"number\"", "MatrixLayout.js(440): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "MatrixLayout.js(441): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "MatrixLayout.js(442): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "MatrixLayout.js(443): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "MatrixLayout.js(444): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "MatrixLayout.js(445): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "MatrixLayout.js(446): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "MatrixLayout.js(447): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "MatrixLayout.js(448): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "MatrixLayout.js(449): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "MatrixLayout.js(450): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "MatrixLayout.js(451): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "MatrixLayout.js(452): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "MatrixLayout.js(453): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "MatrixLayout.js(454): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"Cell": sCell,
		"Offset": iOffset,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	if (sCell) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sCell);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "Cell");
			}
		}
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("MatrixLayout", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_MatrixLayout["_"]["fireDrop"] = 0; };

};
sap["ls"]["preload"]["UCF_MatrixLayoutCell"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MatrixLayoutCell(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MatrixLayoutCell["_"]["UCF_MatrixLayoutCell"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "MatrixLayoutCell.js(17): UCF_MatrixLayoutCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "MatrixLayoutCell.js(18): UCF_MatrixLayoutCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "MatrixLayoutCell.js(19): UCF_MatrixLayoutCell"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_MatrixLayoutCell"] = UCF_MatrixLayoutCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MatrixLayoutCell"); UCF_MatrixLayoutCell["_"] = {UCF_MatrixLayoutCell: 0}; }; ;

UCF_MatrixLayoutCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_MatrixLayoutCell.prototype["sClassName"] = "UCF_MatrixLayoutCell";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_MatrixLayoutCell["prototype"]["aAttributeNames"] = ["sDragData","sCustomData","sCustomStyle","sLayoutCellPosition"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_MatrixLayoutCell["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_MatrixLayoutCell["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_MatrixLayoutCell["prototype"]["sDragData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MatrixLayoutCell["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MatrixLayoutCell["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LayoutCellPosition}
 */
UCF_MatrixLayoutCell["prototype"]["sLayoutCellPosition"] = "DEFAULT";

//#JSCOVER_EXCL_START
/** @protected */
UCF_MatrixLayoutCell["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutCell["_"]["setDefaultValues"]++; }; 
	this["sDragData"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sLayoutCellPosition"] = "DEFAULT";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("DragData", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("LayoutCellPosition", "DEFAULT", true);
	}
};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutCell["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_MatrixLayoutDTDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_EventProvider */
/// <reference path="../../../core/EventProvider.js"/>

/**
 * @class
 * @param {UCF_Control} oDTElement
 * @param {HTMLElement} oDomRef
 * @param {UCF_Control} oControl
 */
function UCF_MatrixLayoutDTDelegate(oDTElement, oDomRef, oControl) {if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["UCF_MatrixLayoutDTDelegate"]++; }; 
	UCF_EventProvider["apply"](this);
	this["oDomRef"] = oDomRef;
	this["oDTElement"] = oDTElement;
	this["oDTContainer"] = oDTElement["oDTContainer"];
	this["oLayout"] = oControl;
	this["iHoverTimer"] = null;
	this["mIndicators"] = {};
	this["createIndicators"]();
	this["oDTContainer"]["attachEvent"](this["oDTContainer"]["E_EVENTS"]["DragStart"], this, "handleContainerDragStart");
	this["oDTContainer"]["attachEvent"](this["oDTContainer"]["E_EVENTS"]["DragStop"], this, "handleContainerDragStop");
	this["oDTElement"]["attachEvent"](this["oDTElement"]["E_EVENTS"]["Select"], this, "handleElementSelect");
	this["oDTElement"]["attachEvent"](this["oDTElement"]["E_EVENTS"]["Deselect"], this, "handleElementDeselect");

};window["UCF_MatrixLayoutDTDelegate"] = UCF_MatrixLayoutDTDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MatrixLayoutDTDelegate"); UCF_MatrixLayoutDTDelegate["_"] = {UCF_MatrixLayoutDTDelegate: 0}; }; ;
UCF_MatrixLayoutDTDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_MatrixLayoutDTDelegate.prototype["sClassName"] = "UCF_MatrixLayoutDTDelegate";

UCF_MatrixLayoutDTDelegate["prototype"]["handleElementSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["handleElementSelect"]++; }; 
	this["oDomRef"]["style"]["display"] = "block";
	this["displayContentDTElements"](false);
};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["handleElementSelect"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["handleElementDeselect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["handleElementDeselect"]++; }; 
	this["oDomRef"]["style"]["display"] = "none";
	this["displayContentDTElements"](true);
};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["handleElementDeselect"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["handleContainerDragStart"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["handleContainerDragStart"]++; }; 
	this["oDomRef"]["style"]["display"] = "block";
};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["handleContainerDragStart"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["handleContainerDragStop"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["handleContainerDragStop"]++; }; 
	this["oDomRef"]["style"]["display"] = "none";
};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["handleContainerDragStop"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["onlsdragover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["onlsdragover"]++; }; 
	this["displayContentDTElements"](false);
	this["oDTElement"]["oDomRef"]["style"]["zIndex"] = this["oDTElement"]["iZIndex"];
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource && oSource["getAttribute"]("lsindex")) {
		oSource["style"]["opacity"] = "1";
	}

};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["onlsdragover"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["onlsdragleave"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["onlsdragleave"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	this["oDTElement"]["oDomRef"]["style"]["zIndex"] = this["oDTElement"]["iZIndex"];
	if (UCF_DomUtil["bContains"](this["oDomRef"], oSource)) {
		this["displayContentDTElements"](true);
	}
	if (oSource && oSource["getAttribute"]("lsindex")) {
		oSource["style"]["opacity"] = "0.1";
	}
};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["onlsdragleave"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["onlsdrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["onlsdrop"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	this["displayContentDTElements"](true);
	if (oSource && oSource["getAttribute"]("lsindex")) {
		oSource["style"]["opacity"] = "0.1";
	}
};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["onlsdrop"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["getRowIndicator"] = function(oRow) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["getRowIndicator"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["getRowIndicator"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["getCellIndicator"] = function(oCell) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["getCellIndicator"]++; }; 
	var o = document["createElement"]("DIV");
	o["style"]["position"] = "absolute";
	o["style"]["left"] = oCell["offsetLeft"] + "px";
	o["style"]["top"] = oCell["offsetTop"] + "px";
	o["style"]["width"] = oCell["offsetWidth"] + "px";
	o["style"]["height"] = oCell["offsetHeight"] + "px";
	o["style"]["backgroundColor"] = "red";
	o["style"]["opacity"] = "0.1";
	o["setAttribute"]("lsindex", oCell["cellIndex"] + "-" + oCell["parentNode"]["rowIndex"]);
	this["oDomRef"]["appendChild"](o);
};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["getCellIndicator"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["createIndicators"] = function() {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["createIndicators"]++; }; 
	var oDomRef = this["oLayout"]["oDomRef"];
	for (var iRow = 0; iRow < oDomRef["rows"]["length"]; iRow++) {
		for (var iCol = 0; iCol < oDomRef["rows"][iRow]["cells"]["length"]; iCol++) {
			this["mIndicators"][iCol + "-" + iRow] = {
				"oDomRef": this["getCellIndicator"](oDomRef["rows"][iRow]["cells"][iCol]),
				"iRow": iRow,
				"iCol": iCol
			};
		}
		this["mIndicators"][iRow] = {
			"oDomRef": this["getRowIndicator"](oDomRef["rows"][iRow]),
			"iRow": iRow
		};
	}
};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["createIndicators"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["_displayContentDTElements"] = function(bShow) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["_displayContentDTElements"]++; }; 
	this["bContentDTElementsShown"] = bShow;
	var aControls = this["oLayout"]["aGetContainedControls"]();
	if (aControls) {
		for (var i = 0; i < aControls["length"]; i++) {
			var oDTElement = this["oDTContainer"]["getDTElement"](aControls[i]["sId"]);
			if (oDTElement) {
				//oDTElement.oDomRef.style.display = bShow ? "block" : "none";
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["_displayContentDTElements"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["displayContentDTElements"] = function(bShow) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["displayContentDTElements"]++; }; 
	if (this["bContentDTElementsShown"] === bShow) return;
	if (this["iContentDTElementsShowTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["iContentDTElementsShowTimer"]);
	}
	this["iContentDTElementsShowTimer"] = UCF_JsUtil["delayedCall"](120, this, "_displayContentDTElements", [bShow]);

};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["displayContentDTElements"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["expandColumn"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["expandColumn"]++; }; };;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["expandColumn"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["expandRow"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["expandRow"]++; }; };;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["expandRow"] = 0; };

UCF_MatrixLayoutDTDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["destroy"]++; }; 
	this["iContentDTElementsShowTimer"] = null;
	this["oDomRef"] = null;
	this["oDTElement"] = null;
	this["oLayout"] = null;
	this["oDTContainer"] = null;
	this["bContentDTElementsShown"] = null;
	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MatrixLayoutDTDelegate["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_MeltingGroup"] = function() {/* global _assert, _trace, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MeltingGroup(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["UCF_MeltingGroup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "MeltingGroup.js(33): UCF_MeltingGroup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "MeltingGroup.js(34): UCF_MeltingGroup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "MeltingGroup.js(35): UCF_MeltingGroup"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	/** @type {UCF_Cache} */
	this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
	this["iCurrentIndex"] = -1;
	this["iNoOfControls"] = -1;
	this["bIsNavigationMode"] = false;

};window["UCF_MeltingGroup"] = UCF_MeltingGroup; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MeltingGroup"); UCF_MeltingGroup["_"] = {UCF_MeltingGroup: 0}; }; ;

UCF_MeltingGroup["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_MeltingGroup.prototype["sClassName"] = "UCF_MeltingGroup";

UCF_MeltingGroup["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["destroy"]++; }; 
	this["oCache"]["destroy"]();
	this["oCache"] = null;
	this["iCurrentIndex"] = null;
	this["iNoOfControls"] = null;
	this["bIsNavigationMode"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["destroy"] = 0; };

/**
 * Focusses the control
 */
UCF_MeltingGroup["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["focus"]++; }; 
	var oDomRef = this["oFocusDomRef"];
	if (this["bUsedInSapTable"]) {

		UCF_DomUtil["focusDomElement"](oDomRef);
		return;
	}

	if (!window["UCF_System"]["bIs508"]) { //label is normally connected to MG - in the non 508 mode redirect the focus to the first element within the group
		var oControl = this["oGetFirstFocusableChild"]();
		if (oControl && oControl["oFocusDomRef"]) oDomRef = oControl["oFocusDomRef"];
	}

	if (oDomRef) {
		if (!UCF_DomUtil["bHasTabIndex"](oDomRef)) {
			UCF_DomUtil["setTabIndex"](oDomRef, 0);
			oDomRef["bResetTabIndex"] = true;
		}

		UCF_DomUtil["focusDomElement"](oDomRef);
	}
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["focus"] = 0; };

/**
 * Returns the DOM element that should be focussed if the controls focus method
 * is called. Please do overide if the DOM element is other than the oRootRef
 * or the oDomRef.
 *
 * @return {HTMLElement} the DOM element that should be focussed if the
 * controls focus method is called.
 */
UCF_MeltingGroup["prototype"]["oGetForcedFocusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetForcedFocusDomRef"]++; }; 
	if (this["bUsedInSapTable"]) {
		return this["oGetFirstDomRef"]();
	} else
		return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetForcedFocusDomRef"] = 0; };

UCF_MeltingGroup["prototype"]["oGetFirstDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetFirstDomRef"]++; }; 
	var oControls = this["oGetControlsList"]();

	var oFirstDomRef, oControl;
	if (oControls["length"] === 0)
		return this["oDomRef"];
	else if (oControls["length"] === 1) {
		oControl = oControls[0];
		oFirstDomRef = oControl["oGetForcedFocusDomRef"]() || oControl["oDomRef"];
		return oFirstDomRef;
	} else
		return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetFirstDomRef"] = 0; };

UCF_MeltingGroup["prototype"]["oGetFirstCellDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetFirstCellDomRef"]++; }; 
	var oFirstDomRef;
	if (this["iGetNoOfControls"]() > 1) {
		oFirstDomRef = this["oGetDomRefFromPosition"](0);
	} else {
		oFirstDomRef = this["oGetFirstDomRef"]();
	}
	return oFirstDomRef;
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetFirstCellDomRef"] = 0; };

UCF_MeltingGroup["prototype"]["oGetControlsList"] = function() {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetControlsList"]++; }; 
	/** @type {UCF_MeltingGroup} */
	var self = this;

	return this["oCache"]["get"]('oControls', function() {
		if (self["oDomRef"]["tagName"] === 'TABLE') {
			return UCF_JsUtil["reduce"](
				UCF_JsUtil["arrayFrom"](UCF_DomUtil["childNodes"](UCF_DomUtil["oGetFirstElement"](UCF_DomUtil["oGetFirstElement"](self["oDomRef"])), 'TD')),
				function(oControls, oChildnode) {
					var oContent = UCF_DomUtil["oGetFirstChildCTElement"](oChildnode);
					if (oContent) {
						var oControl = self["oLS"]["oControlFactory"]["oGetControlByDomRef"](oContent, true);
						if (oControl)
							oControls["push"](oControl);
					}
					return oControls;
				}, []
			);
		} else if (self["oDomRef"]["tagName"] === 'SPAN' && UCF_DomUtil["bHasClass"](self["oDomRef"], 'lsMeltingGroup--singlecell')) {
			var oControls = [];
			var oChildDomRef = UCF_DomUtil["oGetFirstElement"](self["oDomRef"]);
			var oContent = UCF_DomUtil["oGetFirstChildCTElement"](self["oDomRef"]) || UCF_DomUtil["oGetFirstElement"](oChildDomRef);
			if (oContent) {
				var oControl = self["oLS"]["oControlFactory"]["oGetControlByDomRef"](oContent, true);
				if (oControl)
					oControls["push"](oControl);
			}
			return oControls;
		} else return [];

	});

};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetControlsList"] = 0; };

/**
 * @see UCF_Control
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_MeltingGroup["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsblur"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "MeltingGroup.js(161): onlsblur"); };

	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource["bResetTabIndex"]) {
		UCF_DomUtil["resetTabIndex"](oSource);
		oSource["bResetTabIndex"] = false;
	}

};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsblur"] = 0; };

/**
 * @see UCF_Control
 * @return {integer}
 */
UCF_MeltingGroup["prototype"]["iGetOptimalWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["iGetOptimalWidth"]++; }; 
	var iWidth = 0,
		aDomRefCells = this["oRootRef"] ? this["oRootRef"]["rows"][0]["cells"] : null;

	if (this["oRootRef"] && aDomRefCells && aDomRefCells["length"]) {
		for (var i = 0; i < aDomRefCells["length"]; i++) {
			var oDomRefCell = aDomRefCells[i];

			if (oDomRefCell["getAttribute"]("lsContentCell")) {
				var iPaddingLeft = parseInt(UCF_DomUtil["sGetCurrentStyle"](oDomRefCell, "paddingLeft"), 10),
					iPaddingRight = parseInt(UCF_DomUtil["sGetCurrentStyle"](oDomRefCell, "paddingRight"), 10),
					oChildControl = this["oGetFirstChildRecursive"](oDomRefCell);

				iWidth += iPaddingLeft + iPaddingRight;
				if (oChildControl) iWidth += oChildControl["iGetOptimalWidth"]();

			} else {
				iWidth += oDomRefCell["offsetWidth"];
			}
		}
	}

	return Math["max"](iWidth, 20);
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["iGetOptimalWidth"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MeltingGroup["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsskipforward"]++; }; 
	if (window["UCF_System"]["bIs508"]) this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MeltingGroup["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsskipback"]++; }; 
	if (window["UCF_System"]["bIs508"]) this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsskipback"] = 0; };

/**
 *  retrives the focus DomRef for the given control
 * @param {UCF_Control} oControl the current control
 * @return {HTMLDivElement} - the focused DomRef
 * @private
 */
UCF_MeltingGroup["prototype"]["oGetFocusDomRefForControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetFocusDomRefForControl"]++; }; 
	if (oControl)
		return oControl["oGetForcedFocusDomRef"]() || oControl["oDomRef"];
	return null;
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetFocusDomRefForControl"] = 0; };

/**
 * returns the number of Control from iPosition
 * @return {int} no of Controls
 * @private
 */
UCF_MeltingGroup["prototype"]["iGetNoOfControls"] = function() {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["iGetNoOfControls"]++; }; 
	if (this["iNoOfControls"] === -1) {
		this["iNoOfControls"] = this["oGetControlsList"]()["length"];
	}
	return this["iNoOfControls"];
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["iGetNoOfControls"] = 0; };

/**
 *  retrives the Control from iPosition
 * @param { int } iPosition the current control
 * @return {UCF_Control} - the control
 * @private
 */
UCF_MeltingGroup["prototype"]["oGetDomRefFromPosition"] = function(iPosition) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetDomRefFromPosition"]++; }; 
	var oControls = this["oGetControlsList"]();
	if (oControls && (0 < iPosition < oControls["length"])) {
		return this["oGetFocusDomRefForControl"](oControls[iPosition]);
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["oGetDomRefFromPosition"] = 0; };

/**
 * [HOME] Key
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_PanelStack
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_MeltingGroup["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlshome"]++; }; 
	// only in Navigation mode
	if (!this["bIsNavigationMode"]) return;

	var oFirstDomRef;
	if (this["iGetNoOfControls"]() > 1) {
		oFirstDomRef = this["oGetDomRefFromPosition"](0);
		this["iCurrentIndex"] = 0;
		if (oFirstDomRef) {
			UCF_DomUtil["moveFocusDomElement"](oFirstDomRef, true);
			if (window["UCF_System"]["bIsAria"]) {
				this["oDomRef"]["ariaActivedescendant"] = oFirstDomRef["id"];
				UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], oFirstDomRef["id"]);
			}
		}

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlshome"] = 0; };

/**
 * [END]
 * Hanldes the lsend event
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_MeltingGroup["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsend"]++; }; 
	// only in Navigation mode
	if (!this["bIsNavigationMode"]) return;
	var oLastDomRef;

	if (this["iGetNoOfControls"]() > 1) {
		oLastDomRef = this["oGetDomRefFromPosition"](this["iGetNoOfControls"]() - 1);
		this["iCurrentIndex"] = this["iGetNoOfControls"]() - 1;
		if (oLastDomRef) {
			UCF_DomUtil["moveFocusDomElement"](oLastDomRef, true);
			if (window["UCF_System"]["bIsAria"]) {
				this["oDomRef"]["ariaActivedescendant"] = oLastDomRef["id"];
				UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], oLastDomRef["id"]);
			}
		}

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsend"] = 0; };

/**
 *  [RIGHT]
 * @param { UCF_BrowserEvent } oBrowserEvent the lsnext
 * @private
 */
UCF_MeltingGroup["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsright"]++; }; 
	// only in Navigation mode
	if (!this["bIsNavigationMode"]) return;

	if (this["iGetNoOfControls"]() < 2) return;
	var oSourceDomRef = oBrowserEvent["oGetSource"](),
		oNextDomRef;
	if (oSourceDomRef === this["oDomRef"]) {
		this["iCurrentIndex"] = 0;
	} else this["iCurrentIndex"]++;

	if (this["iCurrentIndex"] >= this["iGetNoOfControls"]())
		this["iCurrentIndex"] = 0;

	oNextDomRef = this["oGetDomRefFromPosition"](this["iCurrentIndex"]);
	if (oNextDomRef) {
		UCF_DomUtil["moveFocusDomElement"](oNextDomRef, true);
		if (window["UCF_System"]["bIsAria"]) {
			this["oDomRef"]["ariaActivedescendant"] = oNextDomRef["id"];
			UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], oNextDomRef["id"]);
		}
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsright"] = 0; };

/**
 * [LEFT] Key
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_MeltingGroup["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsleft"]++; }; 
	// only in Navigation mode
	if (!this["bIsNavigationMode"]) return;

	if (this["iGetNoOfControls"]() < 2) return; // do nothing
	var oSourceDomRef = oBrowserEvent["oGetSource"](),
		oPreviousDomRef;
	if (oSourceDomRef === this["oDomRef"]) {
		this["iCurrentIndex"] = this["iGetNoOfControls"]() - 1;
	} else this["iCurrentIndex"]--;

	if (this["iCurrentIndex"] < 0) {
		this["iCurrentIndex"] = this["iGetNoOfControls"]() - 1;
	}

	oPreviousDomRef = this["oGetDomRefFromPosition"](this["iCurrentIndex"]);
	if (oPreviousDomRef) {
		UCF_DomUtil["moveFocusDomElement"](oPreviousDomRef, true);
		if (window["UCF_System"]["bIsAria"]) {
			this["oDomRef"]["ariaActivedescendant"] = oPreviousDomRef["id"];
			UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], oPreviousDomRef["id"]);
		}
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsleft"] = 0; };

/**
 * handles the onlsdown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MeltingGroup["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsdown"]++; }; 
	// only in Navigation mode
	if (!this["bIsNavigationMode"]) return;
	this["bIsNavigationMode"] = !this["bIsNavigationMode"];
	this["iCurrentIndex"] = -1;
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsdown"] = 0; };

/**
 * handles the onlsup event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MeltingGroup["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsup"]++; }; 
	// only in Navigation mode
	if (!this["bIsNavigationMode"]) return;
	this["bIsNavigationMode"] = !this["bIsNavigationMode"];
	this["iCurrentIndex"] = -1;
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsup"] = 0; };

UCF_MeltingGroup["prototype"]["SELECTION_STATE"] = {
	"NONE": null,
	"NOT_SELECTED": 0,
	"PRIMARY_SELECTED": 1,
	"SELECTED": 2,
	"NOT_SELECTABLE": 4
};

/**
 * Sets the selection state of a melting group cell
 *
 * @param {string} sCellId The ID of a cell belonging to the melting group
 * @param {string} sSelectionState NONE, NOT_SELECTABLE, NOT_SELECTED, SELECTED, PRIMARY_SELECTED
 * @public
 */
UCF_MeltingGroup["prototype"]["setCellSelectionState"] = function(sCellId, sSelectionState) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["setCellSelectionState"]++; }; 
	var oDomRefCell = UCF_DomUtil["$"](sCellId) || this["oDomRef"];

	if (!(sSelectionState in this["SELECTION_STATE"])) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Cell State \"" + sSelectionState + "\" is not valid. Use \"NONE, NOT_SELECTABLE, NOT_SELECTED, SELECTED, PRIMARY_SELECTED\" instead. No selection triggered.", "MeltingGroup.js(426): setCellSelectionState"); };
	} else if (oDomRefCell) {
		var iOldSelectionState = parseInt(oDomRefCell["getAttribute"]("sst")),
			iNewSelectionState = this["SELECTION_STATE"][sSelectionState];

		if (iOldSelectionState === this["SELECTION_STATE"]["SELECTED"] || iOldSelectionState === this["SELECTION_STATE"]["PRIMARY_SELECTED"]) {
			UCF_DomUtil["removeClass"](oDomRefCell, "urST4Sel2");
		}

		if (iNewSelectionState === this["SELECTION_STATE"]["SELECTED"] || iNewSelectionState === this["SELECTION_STATE"]["PRIMARY_SELECTED"]) {
			UCF_DomUtil["addClass"](oDomRefCell, "urST4Sel2");
		}

		oDomRefCell["setAttribute"]("sst", iNewSelectionState);

	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Cell with ID=\"" + sCellId + "\" does not exist. No selection triggered.", "MeltingGroup.js(442): setCellSelectionState"); };
	}

};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["setCellSelectionState"] = 0; };

/**
 * Gets the cells value as string for cells containing a single control with text or value
 *
 * @param {string} sCellId The ID of a cell belonging to the melting group
 * @return {string}
 * @public
 */
UCF_MeltingGroup["prototype"]["getCellDisplayValue"] = function (sCellId) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["getCellDisplayValue"]++; }; 
	var oDomRefCell = UCF_DomUtil["$"](sCellId) || this["oDomRef"];
	return UCF_DomUtil["sGetVisibleTextContent"](oDomRefCell);
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["getCellDisplayValue"] = 0; };

/**
 * Check if the current Key combination is [ALT] + [F7]
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */

UCF_MeltingGroup["prototype"]["bIsNavigationModeKey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["bIsNavigationModeKey"]++; }; 
	//keyboard navigation will be only for MeltingGroup on Saptable
	if (!this["bUsedInSapTable"]) return false;
	// more than one cells
	if (this["iGetNoOfControls"]() <= 1) return false;

	var iKeyCode = oBrowserEvent["iKeyCode"]();

	if (iKeyCode === UCF_KeyCodes["F7"] && UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent)) {
		//&& UCF_KeyboardHelper.bHasOnlyCtrlAsModifier(oBrowserEvent)) {
		oBrowserEvent["oDomEvent"]["preventDefault"]();
		// is the correct key
		return true;
	}

	return false;

};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["bIsNavigationModeKey"] = 0; };

UCF_MeltingGroup["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MeltingGroup.js(486): onkeydown"); };
	var oFocusDomRef;
	if (this["bIsNavigationModeKey"](oBrowserEvent)) {
		this["bIsNavigationMode"] = !this["bIsNavigationMode"];
		if (this["bIsNavigationMode"]) {
			oFocusDomRef = this["oGetFirstCellDomRef"]();
			this["iCurrentIndex"] = 0;
		} else {
			oFocusDomRef = this["oDomRef"];
		}
		if (oFocusDomRef)
			UCF_DomUtil["focusDomElement"](oFocusDomRef);

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onkeydown"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MeltingGroup["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MeltingGroup.js(514): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSource"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oBrowserEvent["oGetSourceControl"]() === this) {
		if (oSource["getAttribute"]("tp") === "END") {
			oAccessibilityHelper["setControlType"]("G_END");
		} else {
			oAccessibilityHelper["addTooltip"](this["sTooltip"]);

			//Apply label and accDescription
			oAccessibilityHelper["applyLabelingInfo"](this, this["sAccessibilityDescription"]);

			oAccessibilityHelper["setControlType"]("MG");
			oAccessibilityHelper["applyContainerEntryBehaviour"]();
		}
	} else {
		var oLegendDomRef = UCF_DomUtil["$"](this["sId"] + '-legend');

		for (var oDomRef = oSource; oDomRef && oDomRef !== this["oDomRef"]; oDomRef = oDomRef["parentNode"]) {

			if (oDomRef["getAttribute"]) {

				// Legend handling for cells
				if (oLegendDomRef && oDomRef["getAttribute"]("lsSemanticColor")) {
					oAccessibilityHelper["setLegendJSDomRef"](oLegendDomRef);
					oAccessibilityHelper["addSemantic"](oDomRef["getAttribute"]("lsSemanticColor"));
				}

				// Selection handling
				if (oDomRef["getAttribute"]("sst")) {
					var iSelectionState = parseInt(oDomRef["getAttribute"]("sst"));
					if (iSelectionState === this["SELECTION_STATE"]["SELECTED"] || iSelectionState === this["SELECTION_STATE"]["PRIMARY_SELECTED"]) {
						oAccessibilityHelper["setSelected"](true);
					}
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["onlsaccessibility"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_MeltingGroup["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;
	/** @type {Node} */
	var oNode;
	/** @type {string} */
	var sDescribedBy;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);

			sDescribedBy = '';
			oNode = UCF_DomUtil["oGetFirstChildByAttribute"](
				this["oDomRef"],
				'lscontentcell',
				'true'
			);
			if (oNode) { // eslint-disable-line max-depth
				sDescribedBy = oNode["id"];
			}

			oNode = UCF_DomUtil["oGetLastChildByAttribute"](
				this["oDomRef"],
				'lscontentcell',
				'true'
			);
			// eslint-disable-next-line max-depth
			if (oNode && oNode["id"] !== sDescribedBy) {
				sDescribedBy = sDescribedBy + ' ' + oNode["id"];
			}

			this["oDomRef"]["setAttribute"]('aria-describedby', sDescribedBy);
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
			this["oDomRef"]["setAttribute"]('role', 'gridcell');
		}
	}
	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["bPrepareAria"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_MeltingGroup["prototype"]["aAttributeNames"] = ["sVisibility","bUsedInSapTable","sAccessibilityDescription","sTooltip","sCustomData","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_MeltingGroup["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_MeltingGroup["prototype"]["aMethodNames"] = ["setCellSelectionState","getCellDisplayValue","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_MeltingGroup["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_MeltingGroup["prototype"]["bUsedInSapTable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_MeltingGroup["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MeltingGroup["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MeltingGroup["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MeltingGroup["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_MeltingGroup["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["bUsedInSapTable"] = false;
	this["sAccessibilityDescription"] = '';
	this["sTooltip"] = '';
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("UsedInSapTable", false, true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_MeltingGroup["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_MeltingGroup.prototype["aPublicMethods"] = ["setCellSelectionState","getCellDisplayValue"].concat(UCF_MeltingGroup.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_MenuBar"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MenuBar(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["UCF_MenuBar"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "MenuBar.js(37): UCF_MenuBar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "MenuBar.js(38): UCF_MenuBar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "MenuBar.js(39): UCF_MenuBar"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]);
	this["createItems"]();
	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Focus"], this, 'handleNext');
	//this.oItemNavigation.setFocusedIndex(this.oItemNavigation.iFocusedIndex);
	//this.oItemNavigation.oItemContainer = this.oDomRef;
	//UCF_DomUtil.resetTabIndex(this.oDomRef);
	this["bHadBeenFocused"] = false;
	this["iLastFocusableItem"] = -1;
	this["sPreviousHoveredId"] = null;
	this["oPreviousItem"] = null;
	this["sMenuBarId"] = null;
	this["bMenuOpenWithRightLeftArrow"] = false;
};window["UCF_MenuBar"] = UCF_MenuBar; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MenuBar"); UCF_MenuBar["_"] = {UCF_MenuBar: 0}; }; ;
UCF_MenuBar["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_MenuBar.prototype["sClassName"] = "UCF_MenuBar";

UCF_MenuBar["prototype"]["eStyles"] = {
	"ITEM_HOVERABLE": "lsMenuBar--item-hoverable",
	"ITEM_HOVER_IE": "lsMenuBar--item-hover",
	"ITEM_MENU_FOCUSABLE": "lsMenuBar--item-focusable",
	"ITEM_MENU_OPEN": "lsMenuBar--menu-opened",
	"ITEM_MENU_HOVERED": "lsMenuBar--menu-hovered"
};

/**
 * In case when the MenuBar has a fixed width in px and the Item width is bigger,
 * it should adjust the width to the item width. Initialize can't be removed.
 */
UCF_MenuBar["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["initialize"]++; }; 
	if (this["oDomRef"]["scrollWidth"] > this["oDomRef"]["clientWidth"]) {
		this["oDomRef"]["style"]["width"] = this["oDomRef"]["scrollWidth"] + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["initialize"] = 0; };

/**
 * Handles the onclick event of the browser. Opens the associated menu.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MenuBar["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MenuBar.js(85): onclick"); };

	var oItem = oBrowserEvent["oGetSourceControl"]();

	if (!__UCF_IE6__) {
		this["toggleHover"](oItem, !oBrowserEvent["bIsTouchInteraction"]());
		this["toggleFocusableCss"](oItem, !oBrowserEvent["bIsTouchInteraction"]());
	}
	if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"]();
		if (!__UCF_IE6__) {
			this["toggleMenuOpenCss"](oItem, false);
		}

	} else {
		this["openMenu"](oItem, false);
		if (!__UCF_IE6__) {
			this["toggleMenuOpenCss"](oItem, true);
		}
	}
	// Note: this.bMenuOpenWithRightLeftArrow is at this place false,
	// It is a flag only to handle navigation with an arrow keys
	// to decide if the next menu after a disable item should be open or not
	this["bMenuOpenWithRightLeftArrow"] = false;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "this.bMenuOpenWithRightLeftArrow: " + this["bMenuOpenWithRightLeftArrow"], "MenuBar.js(110): onclick"); };
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onclick"] = 0; };

/**
 * Handles the keyboard events that open the associated menu.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MenuBar["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onlsshow"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MenuBar.js(121): onlsshow"); };

	var oItem = oBrowserEvent["oGetSourceControl"]();

	if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"]();
	} else {
		this["openMenu"](oItem, true);
	}
	if (!__UCF_IE6__) {
		this["toggleMenuOpenHoveredCss"](oItem, null, true);
	}
	this["sPreviousHoveredId"] = oItem["sId"];

	// Note: this.bMenuOpenWithRightLeftArrow is at this place false,
	// It is a flag only to handle navigation with an arrow keys
	// to decide if the next menu after a disable item should be open or not
	this["bMenuOpenWithRightLeftArrow"] = false;

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onlsshow"] = 0; };

/**
 * Handles the onmouseover event of the browser.
 * The item receives a hover effect. <br>
 * If a pop up has already been opened, hovering over items opens their pop up.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MenuBar["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onmouseover"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MenuBar.js(154): onmouseover"); };

	var oSource = oBrowserEvent["oGetSourceControl"]();

	if (!oSource["bEnabled"]) return;

	this["reopenMenu"](oSource);
	if (__UCF_IE6__) {
		this["toggleHoverIEQuirks"](oSource, true);
	} else {
		this["toggleHover"](oSource, oBrowserEvent["bIsMouseHover"]());
	}

};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onmouseover"] = 0; };

/**
 * remove hover effect on menubar item
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MenuBar["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MenuBar.js(176): onmouseout"); };

	var oSource = oBrowserEvent["oGetSourceControl"]();
	if (oSource["bEnabled"]) {
		if (__UCF_IE6__) {
			this["toggleHoverIEQuirks"](oSource, false);
		} else {
			this["toggleHover"](oSource, true);
			this["toggleFocusableCss"](oSource, true);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onmouseout"] = 0; };

if (__UCF_IE6__) {
	/**
	 * remove hover effect on menubar item
	 *
	 * @param {UCF_Control} oSource the browser event object that occurred
	 * @param {boolean} bIsHoverActive - if should add or remove the hover css class
	 * @private
	 */
	UCF_MenuBar["prototype"]["toggleHoverIEQuirks"] = function(oSource, bIsHoverActive) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["toggleHoverIEQuirks"]++; }; 
		if (
			oSource &&
			UCF_JsUtil["bInstanceOf"](oSource, 'UCF_MenuBarItem') &&
			oSource["bEnabled"]
		) {
			if (bIsHoverActive) {
				if (!UCF_DomUtil["bHasClass"](oSource["oDomRef"], this["eStyles"]["ITEM_HOVER_IE"])) {
					UCF_DomUtil["addClass"](oSource["oDomRef"], this["eStyles"]["ITEM_HOVER_IE"]);
				}
			} else {
				UCF_DomUtil["removeClass"](oSource["oDomRef"], this["eStyles"]["ITEM_HOVER_IE"]);
			}
		}
	};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["toggleHoverIEQuirks"] = 0; };
}

if (!__UCF_IE6__) {
	/**
	 * remove hover effect on menubar item
	 *
	 * @param {UCF_Control} oSource the browser event object that occurred
	 * @param {boolean} bIsHoverActive - if if should add or remove the hover css class
	 * @private
	 */
	UCF_MenuBar["prototype"]["toggleHover"] = function(oSource, bIsHoverActive) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["toggleHover"]++; }; 
		if (
			!__UCF_IE6__ &&
			oSource &&
			UCF_JsUtil["bInstanceOf"](oSource, 'UCF_MenuBarItem') &&
			oSource["bEnabled"]
		) {
			this["sPreviousHoveredId"] = oSource["sId"];
			if (bIsHoverActive) {
				if (!UCF_DomUtil["bHasClass"](oSource["oDomRef"], this["eStyles"]["ITEM_HOVERABLE"])) {
					UCF_DomUtil["addClass"](oSource["oDomRef"], this["eStyles"]["ITEM_HOVERABLE"]);
				}
			} else {
				UCF_DomUtil["removeClass"](oSource["oDomRef"], this["eStyles"]["ITEM_HOVERABLE"]);
			}
		}
	};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["toggleHover"] = 0; };
}

if (!__UCF_IE6__) {
	/**
	 * remove hover effect on menubar item
	 *
	 * @param {UCF_Control} oSource the browser event object that occurred
	 * @param {boolean} bIsOpened - if if should add or remove the hover css class
	 * @private
	 */
	UCF_MenuBar["prototype"]["toggleMenuOpenCss"] = function(oSource, bIsOpened) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["toggleMenuOpenCss"]++; }; 
		if (
			oSource &&
			UCF_JsUtil["bInstanceOf"](oSource, 'UCF_MenuBarItem') &&
			oSource["bEnabled"]
		) {
			if (bIsOpened) {
				if (!UCF_DomUtil["bHasClass"](oSource["oDomRef"], this["eStyles"]["ITEM_MENU_OPEN"])) {
					UCF_DomUtil["addClass"](oSource["oDomRef"], this["eStyles"]["ITEM_MENU_OPEN"]);
				}
			} else {
				UCF_DomUtil["removeClass"](oSource["oDomRef"], this["eStyles"]["ITEM_MENU_OPEN"]);
			}
		}
	};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["toggleMenuOpenCss"] = 0; };
}

if (!__UCF_IE6__) {
	/**
	 * remove/add focus effect on menubar item
	 *
	 * @param {UCF_Control} oSource the browser event object that occurred
	 * @param {boolean} bIsFocusable - if if should add or remove the hover css class
	 * @private
	 */
	UCF_MenuBar["prototype"]["toggleFocusableCss"] = function(oSource, bIsFocusable) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["toggleFocusableCss"]++; }; 
		if (oSource &&
			UCF_JsUtil["bInstanceOf"](oSource, 'UCF_MenuBarItem') &&
			oSource["bEnabled"]
		) {

			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "====================== toggleFocusableCss - bIsFocusable " + bIsFocusable, "MenuBar.js(280): toggleFocusableCss"); };

			if (bIsFocusable) {
				if (!UCF_DomUtil["bHasClass"](oSource["oDomRef"], this["eStyles"]["ITEM_MENU_FOCUSABLE"])) {
					UCF_DomUtil["addClass"](oSource["oDomRef"], this["eStyles"]["ITEM_MENU_FOCUSABLE"]);
				}
			} else {
				UCF_DomUtil["removeClass"](oSource["oDomRef"], this["eStyles"]["ITEM_MENU_FOCUSABLE"]);
			}
		}
	};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["toggleFocusableCss"] = 0; };
}

if (!__UCF_IE6__) {
	/**
	 * remove hover effect on menubar item
	 *
	 * @param {UCF_Control} oSource the browser event object that occurred
	 * @param { string } sItemId -	the item id
	 * @param {boolean} bIsOpened - if it should add or remove the hover css class
	 * @private
	 */
	UCF_MenuBar["prototype"]["toggleMenuOpenHoveredCss"] = function(oSource, sItemId, bIsOpened) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["toggleMenuOpenHoveredCss"]++; }; 
		/** @type {UCF_MenuBarItem} */
		var oCurrentSource;

		if (oSource || sItemId) {
			oCurrentSource = oSource || this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);

			if (
				oCurrentSource &&
				UCF_JsUtil["bInstanceOf"](oCurrentSource, 'UCF_MenuBarItem') &&
				oCurrentSource["bEnabled"]
			) {
				if (bIsOpened) {
					if (!UCF_DomUtil["bHasClass"](oCurrentSource["oDomRef"], this["eStyles"]["ITEM_MENU_HOVERED"])) {
						UCF_DomUtil["addClass"](oCurrentSource["oDomRef"], this["eStyles"]["ITEM_MENU_HOVERED"]);
					}
				} else {
					UCF_DomUtil["removeClass"](oCurrentSource["oDomRef"], this["eStyles"]["ITEM_MENU_HOVERED"]);
				}
			}
		}
	};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["toggleMenuOpenHoveredCss"] = 0; };
}

/**
 * @private
 * @return {boolean} `true` if the Menu can be reopen, otherwise `false`
 */

UCF_MenuBar["prototype"]["bCanReopen"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["bCanReopen"]++; }; 

	return this["oPopupMenu"] && this["oPopupMenu"]["bOpened"] &&
		oItem["oDomRef"] !== this["oPreviousItem"] &&
		this["oPopupMenu"]["sOpenerId"] === this["sPreviousHoveredId"];

};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["bCanReopen"] = 0; };

/**
 * Open menu when hovering over next item.
 *
 * @param {UCF_MenuBarItem} oItem
 * @private
 */
UCF_MenuBar["prototype"]["reopenMenu"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["reopenMenu"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oItem) === "object", "typeof(oItem) === \"object\"", "MenuBar.js(347): reopenMenu"); };

	if (this["bCanReopen"](oItem)) {

		if (UCF_UserAgent["bIsFirefox"](3) && this["oPopupMenu"]["oAnim"]) {
			this["oPopupMenu"]["oAnim"]["callbackRemove"]();
		}

		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["NextMenu"], this);
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["PreviousMenu"], this);
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this);
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, "onMenuSelect");

		this["oPopupMenu"]["bAutoRefocus"] = false;
		this["oPopupMenu"]["close"]();
		if (!__UCF_IE6__) {
			this["toggleMenuOpenHoveredCss"](null, this["sPreviousHoveredId"], false);
			this["toggleMenuOpenCss"](this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]], false);
			if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
				UCF_AriaStateHelper["setExpanded"](this["oPreviousItem"], false);
			}
		}
		this["oPopupMenu"]["setOpenerRef"](oItem["oDomRef"]);
		this["oPopupMenu"]["setOpenerId"](oItem["sId"]);
		for (var i = 0; i < this["oItemNavigation"]["aItems"]["length"]; i++) {
			if (this["oItemNavigation"]["aItems"][i] === oItem) {
				var iCurrentFocusedIndex = i;
				this["oItemNavigation"]["setFocusedIndex"](iCurrentFocusedIndex);
			}
		}

		this["openMenu"](oItem, false);
		if (!__UCF_IE6__) {
			this["toggleMenuOpenHoveredCss"](oItem, null, true);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["reopenMenu"] = 0; };

/**
 * open menu at menu bar item
 *
 * @param { UCF_MenuBarItem } oItem
 * @param { boolean } bWithKeyboard - true if the PopupMenu is opening with keyboard
 * @public
 */
UCF_MenuBar["prototype"]["openMenu"] = function(oItem, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["openMenu"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oItem) === "object", "typeof(oItem) === \"object\"", "MenuBar.js(394): openMenu"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oItem.bEnabled = ' + oItem["bEnabled"], "MenuBar.js(395): openMenu"); };

	//if (!oItem.bEnabled || oItem.sPopupMenuId === "") return;
	if (oItem["bEnabled"] && oItem["sPopupMenuId"] !== "") {

		this["oPopupMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](oItem["sPopupMenuId"], true);
		this["oPopupMenu"]["setOpenerRef"](oItem["oDomRef"]);
		this["oPopupMenu"]["setOpenerId"](oItem["sId"]);
		this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);
		this["iOldFocusedIndex"] = this["oItemNavigation"]["iFocusedIndex"];
		//this.oItemNavigation.bIgnoreFocus = true;
		this["oPopupMenu"]["bAutoRefocus"] = true;
		this["oPreviousItem"] = oItem["oDomRef"];
		// Need to update it to keep the current information
		this["sPreviousHoveredId"] = oItem["sId"];
		//this.sMenuBarId = this.sId;
		this["oPopupMenu"]["open"](bWithKeyboard);
		if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
			UCF_AriaStateHelper["setExpanded"](this["oPreviousItem"], true);
		}
		this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["NextMenu"], this, "onNextMenu");
		this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["PreviousMenu"], this, "onPreviousMenu");
		this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, "onMenuSelect");
		this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");

		this["fireMenuAccess"](this["sId"], oItem["sId"], oItem["sPopupMenuId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["openMenu"] = 0; };

/**
 * Handle menu select event
 *
 * @param {UCF_Event} oEvent the event object that occurred
 * @private
 */
UCF_MenuBar["prototype"]["onMenuSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onMenuSelect"]++; }; 
	this["oPopupMenu"]["bAutoRefocus"] = true;
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onMenuSelect"] = 0; };

/**
 * handles the menu close event
 *
 * @private
 * @param {UCF_BrowserEvent} oEvent
 */
UCF_MenuBar["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onMenuClose"]++; }; 
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, 'onMenuClose');
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["NextMenu"], this, "onNextMenu");
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["PreviousMenu"], this, 'onPreviousMenu');
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, 'onMenuSelect');

	var iFocusIndex = this["oItemNavigation"]["iFocusedIndex"];
	var sCurrentHoveredId = this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]]["sId"];
	// Workaround for doing visible the focus; first move the focus on an other item
	// and the refocus on the correct one
	if (__UCF_IE6__ && window["UCF_System"]["bIs508"]) {
		this["oItemNavigation"]["focusItemByIndex"](iFocusIndex - 1);
	}
	this["oItemNavigation"]["focusItemByIndex"](iFocusIndex);
	if (!__UCF_IE6__) {
		this["toggleMenuOpenCss"](this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]], false);
		if (sCurrentHoveredId === this["sPreviousHoveredId"]) {
			this["toggleMenuOpenHoveredCss"](null, this["sPreviousHoveredId"], false);
		} else {
			this["toggleMenuOpenHoveredCss"](null, sCurrentHoveredId, false);
		}

		if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
			UCF_AriaStateHelper["setExpanded"](this["oPreviousItem"], false);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onMenuClose"] = 0; };

/**
 * @private
 * @param { UCF_Event } oEvent
 */
UCF_MenuBar["prototype"]["handleNext"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["handleNext"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "MenuBar.js(473): handleNext"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "this.bMenuOpenWithRightLeftArrow before: " + this["bMenuOpenWithRightLeftArrow"], "MenuBar.js(475): handleNext"); };

	var oItem = oEvent["oGetParam"]("oItem");

	if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_MenuBarItem")) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "oItem.iIndex: " + oItem["iIndex"], "MenuBar.js(480): handleNext"); };

		if (this["bMenuOpenWithRightLeftArrow"] && oItem["bEnabled"]) {

			if (oItem["oDomRef"] === this["oPreviousItem"] &&
				this["oPopupMenu"]["sOpenerId"] === this["sPreviousHoveredId"]) {
				if (!__UCF_IE6__) {
					this["toggleMenuOpenHoveredCss"](oItem, null, true);
				}
				this["sPreviousHoveredId"] = oItem["sId"];
				// For cases like:
				// Navigation with arrow keys using feature to open the next menu
				// if the menu before was open and the current menu will be closed with
				// [ESCAPE], [ENTER], [SPACE].
				this["bMenuOpenWithRightLeftArrow"] = false;
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "this.bMenuOpenWithRightLeftArrow after: " + this["bMenuOpenWithRightLeftArrow"], "MenuBar.js(495): handleNext"); };
				return;
			}
			if (this["oPopupMenu"] && !this["oPopupMenu"]["bOpened"]) {
				this["openMenu"](oItem, true);
				if (!__UCF_IE6__) {
					this["toggleMenuOpenHoveredCss"](oItem, null, true);
				}
			}
			this["sPreviousHoveredId"] = oItem["sId"];
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "this.bMenuOpenWithRightLeftArrow after: " + this["bMenuOpenWithRightLeftArrow"], "MenuBar.js(506): handleNext"); };
	}
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["handleNext"] = 0; };

/**
 * handles the NextMenu event of the PopupMenu
 * @private
 * @param { UCF_BrowserEvent } oEvent
 */
UCF_MenuBar["prototype"]["onNextMenu"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onNextMenu"]++; }; 

	if (this["iOldFocusedIndex"] < this["oItemNavigation"]["aItems"]["length"] - 1) {

		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["NextMenu"], this, "onNextMenu");
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["PreviousMenu"], this, 'onPreviousMenu');
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, 'onMenuClose');
		this["oPopupMenu"]["bAutoRefocus"] = false;
		this["oPopupMenu"]["close"](false);
		this["bMenuOpenWithRightLeftArrow"] = false;

		if (!__UCF_IE6__) {
			this["toggleMenuOpenCss"](this["oItemNavigation"]["aItems"][this["iOldFocusedIndex"]], false);
			this["toggleMenuOpenHoveredCss"](this["oItemNavigation"]["aItems"][this["iOldFocusedIndex"]], null, false);
			if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
				UCF_AriaStateHelper["setExpanded"](this["oItemNavigation"]["aItems"][this["iOldFocusedIndex"]]["oDomRef"], false);
			}
		}
		this["oItemNavigation"]["setFocusedIndex"](this["iOldFocusedIndex"] + 1);
		if (this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]]["bEnabled"]) {
			this["openMenu"](this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]], true);
			this["bMenuOpenWithRightLeftArrow"] = true;
		} else {
			this["oItemNavigation"]["focusItemByIndex"](this["oItemNavigation"]["iFocusedIndex"]);
			// Need this flag to be true at this place
			// for the first enabled item after a disabled item or desabled items.
			this["bMenuOpenWithRightLeftArrow"] = true;
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "this.bMenuOpenWithRightLeftArrow: " + this["bMenuOpenWithRightLeftArrow"], "MenuBar.js(543): onNextMenu"); };
		if (!__UCF_IE6__) {
			this["toggleMenuOpenHoveredCss"](this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]], null, true);
		}
		this["sPreviousHoveredId"] = this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]]["sId"];
		this["oPreviousItem"] = this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]]["oDomRef"];

	}
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onNextMenu"] = 0; };

/**
 * handles the PreviousMenu event of the PopupMenu
 * @private
 * @param { UCF_BrowserEvent } oEvent
 */
UCF_MenuBar["prototype"]["onPreviousMenu"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onPreviousMenu"]++; }; 

	if (this["oItemNavigation"]["aItems"]["length"] === 1) return;

	if (this["iOldFocusedIndex"] > 0) {
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["PreviousMenu"], this, 'onPreviousMenu');
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["NextMenu"], this, 'onNextMenu');
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, 'onMenuClose');
		this["oPopupMenu"]["bAutoRefocus"] = false;
		this["oPopupMenu"]["close"](false);
		this["bMenuOpenWithRightLeftArrow"] = false;

		if (!__UCF_IE6__) {
			this["toggleMenuOpenCss"](this["oItemNavigation"]["aItems"][this["iOldFocusedIndex"]], false);
			this["toggleMenuOpenHoveredCss"](this["oItemNavigation"]["aItems"][this["iOldFocusedIndex"]], null, false);
			if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
				UCF_AriaStateHelper["setExpanded"](this["oItemNavigation"]["aItems"][this["iOldFocusedIndex"]]["oDomRef"], false);
			}
		}

		this["oItemNavigation"]["setFocusedIndex"](this["iOldFocusedIndex"] - 1);
		if (this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]]["bEnabled"]) {
			this["openMenu"](this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]], true);
			this["bMenuOpenWithRightLeftArrow"] = true;
		} else {
			this["oItemNavigation"]["focusItemByIndex"](this["oItemNavigation"]["iFocusedIndex"]);
			// Need this flag to be true at this place
			// for the first enabled item after a disabled item or disabled items.
			this["bMenuOpenWithRightLeftArrow"] = true;
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "this.bMenuOpenWithRightLeftArrow: " + this["bMenuOpenWithRightLeftArrow"], "MenuBar.js(588): onPreviousMenu"); };
		if (!__UCF_IE6__) {
			this["toggleMenuOpenHoveredCss"](this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]], null, true);
		}
		this["sPreviousHoveredId"] = this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]]["sId"];
		this["oPreviousItem"] = this["oItemNavigation"]["aItems"][this["oItemNavigation"]["iFocusedIndex"]]["oDomRef"];
	}

};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onPreviousMenu"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * [ALT] + [UP] - toggle the menu
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MenuBar["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MenuBar.js(607): onkeydown"); };

	var iKeyCode = oBrowserEvent["iKeyCode"]();
	/** @type {boolean} */
	var bAltOnly = oBrowserEvent["bAlt"]() && !oBrowserEvent["bShift"]() && !oBrowserEvent["bCtrl"]();

	if (iKeyCode === UCF_KeyCodes["ARROW_UP"] && bAltOnly) {
		this["onlsshow"](oBrowserEvent);
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Toggle menu [alt] + [up]/[down] => this.bMenuOpenWithRightLeftArrow: " + this["bMenuOpenWithRightLeftArrow"], "MenuBar.js(615): onkeydown"); };

	}

};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onkeydown"] = 0; };

/**
 * Handles[ENTER] and [SPACE]
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MenuBar["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MenuBar.js(627): onlsselect"); };
	this["onlsshow"](oBrowserEvent);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Toggle menu [space]/[select] => this.bMenuOpenWithRightLeftArrow: " + this["bMenuOpenWithRightLeftArrow"], "MenuBar.js(629): onlsselect"); };
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onlsselect"] = 0; };

/**
 * handles the onlsfocus event
 * @private
 */

/*
UCF_MenuBar.prototype.onlsfocus = function(oBrowserEvent) {
 	if (!UCF_System.bIs508) {
 		oBrowserEvent.cancelBubble();
 		return;
 	}

	if (!this.bHadBeenFocused ) {
		this.oItemNavigation.bIgnoreFocus = true;
		this.bHadBeenFocused = true;
		if (this.iLastFocusableItem != -1) {
			UCF_DomUtil.setTabIndex(this.aItems[this.iLastFocusableItem].oDomRef,0);
		}
	}
	else {
		this.oItemNavigation.bIgnoreFocus = false;
		this.bHadBeenFocused = false;
	}

	oBrowserEvent.cancelBubble();


};
*/
/**
 * handles the onlsfocus event
 * @private
 */

/*
UCF_MenuBar.prototype.onlsblur = function(oBrowserEvent) {
	if (!UCF_System.bIs508) {
 		return;
 	}

	this.bHadBeenFocused = false;
	 _assert(oBrowserEvent instanceof UCF_BrowserEvent);

	var oSource = oBrowserEvent.oGetSourceControl();
	if (UCF_JsUtil.bInstanceOf(oSource, "UCF_MenuBarItem")) {
		for ( var i = 0; i < this.aItems.length; i++ ) {
			if (UCF_DomUtil.bHasTabIndex(this.aItems[i].oDomRef)) {
				UCF_DomUtil.resetTabIndex(this.aItems[i].oDomRef);
				this.iLastFocusableItem = i;
				break;
			}

		}
	}
};
*/

/**
 * Creates two arrays with items. One for the item navigation and a second for the scrolling mechanism.
 *
 * @private
 */
UCF_MenuBar["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["createItems"]++; }; 
	var aDomItems = this["oDomRef"]["childNodes"];
	this["aItems"] = [];
	var index = 0;
	for (var i = 0; i < aDomItems["length"]; i++) {

		var oControlItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[i], true);

		if (oControlItem == null) continue;

		oControlItem["iIndex"] = index;
		this["aItems"]["push"](oControlItem);
		index++;
		if (oControlItem["bEnabled"] || window["UCF_System"]["bIs508"] || window["UCF_System"]["bIsAria"])
			this["oItemNavigation"]["addItem"](oControlItem, oControlItem["iIndex"] === 0);
	}
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["createItems"] = 0; };

/**
 * Applies the ACC helper object to the correct dom reference
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MenuBar["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MenuBar.js(719): onlsaccessibility"); };

	var oSourceCtrl = oBrowserEvent["oGetSourceControl"](),
		oEndSource = UCF_DomUtil["$"](this["sId"] + "-end"),
		oSource = oBrowserEvent["oGetSource"]();

	if (!UCF_JsUtil["bInstanceOf"](oSourceCtrl, "UCF_MenuBarItem") && !UCF_JsUtil["bInstanceOf"](oSourceCtrl, "UCF_MenuBar")) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	if (UCF_JsUtil["bInstanceOf"](oSourceCtrl, "UCF_MenuBarItem")) {
		oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](oSourceCtrl["oDomRef"]));
		oAccessibilityHelper["setEnabled"](oSourceCtrl["bEnabled"]);
		oAccessibilityHelper["setTooltip"](oSourceCtrl["sTooltip"]);
		oAccessibilityHelper["setItemCount"](this["aItems"]["length"]);
		oAccessibilityHelper["setItemIndex"](oSourceCtrl["iIndex"] + 1);
		oAccessibilityHelper["setControlType"]("MNB_I");
		oAccessibilityHelper["addEnabledTutor"]("MNB_I_TUT", oSourceCtrl["bEnabled"]);
	} else if (UCF_JsUtil["bInstanceOf"](oSourceCtrl, "UCF_MenuBar")) {
		if (oSource === oEndSource) {
			oAccessibilityHelper["setControlType"]("MNB_END");
		} else {
			oAccessibilityHelper["setControlType"]("MNB");
			oAccessibilityHelper["applyContainerEntryBehaviour"]();
			oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onlsaccessibility"] = 0; };
/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MenuBar["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MenuBar["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["onlsskipback"] = 0; };

UCF_MenuBar["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["destroy"]++; }; 

	if (this["oItemNavigation"]) {
		this["oItemNavigation"]["destroy"]();
		this["oItemNavigation"] = null;
	}

	this["oPopupMenu"] = null;
	this["iLastFocusableItem"] = null;
	this["iOldFocusedIndex"] = null;
	this["sPreviousHoveredId"] = null;
	this["oPreviousItem"] = null;
	this["sMenuBarId"] = null;
	this["bMenuOpenWithRightLeftArrow"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_MenuBar["prototype"]["aAttributeNames"] = ["sTooltip","sVisibility","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_MenuBar["prototype"]["aEventNames"] = ["MenuAccess"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_MenuBar["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_MenuBar["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_MenuBar["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_MenuBar["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MenuBar["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_MenuBar["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the menu bar control, to which the clicked item belongs.
 * @param {string} sItemId Identifier of the clicked menu bar item, to which the pop up menu is associated.
 * @param {string} sPopupMenuId Identifier of the popupmenu associated to the item.
 * @fires MenuBar::MenuAccess
 */
UCF_MenuBar["prototype"]["fireMenuAccess"] = function(sId, sItemId, sPopupMenuId) {;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string, ItemId: string, PopupMenuId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "MenuBar.js(862): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MenuBar.js(863): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MenuBar.js(864): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "MenuBar.js(865): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "MenuBar.js(866): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPopupMenuId != null, "sPopupMenuId != null", "MenuBar.js(867): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPopupMenuId) == "string", "typeof(sPopupMenuId) == \"string\"", "MenuBar.js(868): fireMenuAccess"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"PopupMenuId": sPopupMenuId
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	if (sPopupMenuId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sPopupMenuId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "PopupMenuId");
			}
		}
	this["fireSemanticEvent"]("MenuBar", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MenuBar["_"]["fireMenuAccess"] = 0; };

UCF_MenuBar.prototype["aPublicMethods"] = ["openMenu"].concat(UCF_MenuBar.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_MenuBarItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MenuBarItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MenuBarItem["_"]["UCF_MenuBarItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "MenuBarItem.js(17): UCF_MenuBarItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "MenuBarItem.js(18): UCF_MenuBarItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "MenuBarItem.js(19): UCF_MenuBarItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_MenuBarItem"] = UCF_MenuBarItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MenuBarItem"); UCF_MenuBarItem["_"] = {UCF_MenuBarItem: 0}; }; ;

UCF_MenuBarItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_MenuBarItem.prototype["sClassName"] = "UCF_MenuBarItem";

UCF_MenuBarItem["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MenuBarItem["_"]["onlsfocus"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MenuBarItem["_"]["onlsfocus"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_MenuBarItem["prototype"]["aAttributeNames"] = ["bEnabled","sTooltip","sPopupMenuId","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_MenuBarItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_MenuBarItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {boolean}
 */
UCF_MenuBarItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_MenuBarItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MenuBarItem["prototype"]["sPopupMenuId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MenuBarItem["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MenuBarItem["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_MenuBarItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_MenuBarItem["_"]["setDefaultValues"]++; }; 
	this["bEnabled"] = true;
	this["sTooltip"] = '';
	this["sPopupMenuId"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("PopupMenuId", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_MenuBarItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Message"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * Message
 *
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Message(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Message["_"]["UCF_Message"]++; }; 
	if (arguments["length"] == 0) {
		return;
	}
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) == "object", "typeof (oDomRef) == \"object\"", "Message.js(31): UCF_Message"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Message.js(32): UCF_Message"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Message.js(33): UCF_Message"); };
	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["defineEvents"](['ShowDetail', 'HideDetail']);

	this["attachEvent"](this["E_EVENTS"]["ShowDetail"], this["oGetParent"](), "onShowDetail");
	this["attachEvent"](this["E_EVENTS"]["HideDetail"], this["oGetParent"](), "onHideDetail");

	this["bDetailOpen"] = false;
	this["sFilterType"] = "ALL";

	/** Ensure text selection is possible @private */
	this["allowTextSelection"]();

};window["UCF_Message"] = UCF_Message; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Message"); UCF_Message["_"] = {UCF_Message: 0}; }; ;

UCF_Message["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Message.prototype["sClassName"] = "UCF_Message";

/**
 * Handles the onlsenter event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Message["prototype"]["onlsenter"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsenter"]++; }; 
	var bHandled = false;
	bHandled = this["openDetail"]();
	if (bHandled) return;
	this["handleClick"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsenter"] = 0; };

/**
 * Handles the onlsentermodfier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Message["prototype"]["onlsentermodifier"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsentermodifier"]++; }; 
	if (!oBrowserEvent["bAlt"]()) return;
	this["handleClick"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsentermodifier"] = 0; };

UCF_Message["prototype"]["onlsselectmodifier"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsselectmodifier"]++; }; 
	//close message detail at shift enter
	if (this["oGetParent"]()["sMessageMode"] == "SINGLE") return;

	if (oBrowserEvent["bShift"]() && this["bDetailOpen"]) {
		this["closeDetail"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsselectmodifier"] = 0; };

UCF_Message["prototype"]["onclick"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onclick"]++; }; 
	this["handleClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onclick"] = 0; };

UCF_Message["prototype"]["handleClick"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["handleClick"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource["getAttribute"]("id") == this["sId"] + "-detail") {
		this["openDetail"]();
	} else if (this["bEnabled"] && !this["bDetailOpen"] && !this["bIsUserTextSelection"]()) {
		this["fireSelect"](this["sId"]);
		this["focusConnectedControl"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["handleClick"] = 0; };

UCF_Message["prototype"]["collectFocusInfo"] = function (oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "Message.js(105): collectFocusInfo"); };
	oFocusInfo["setApplyControl"](this);
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["collectFocusInfo"] = 0; };

UCF_Message["prototype"]["applyFocusInfo"] = function (oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "Message.js(110): applyFocusInfo"); };
	this["oDomRef"]["focus"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["applyFocusInfo"] = 0; };

/**
 * @private
 * @return {boolean} bHandled
 */
UCF_Message["prototype"]["openDetail"] = function () {;if (__UCF_COVERAGE__) { UCF_Message["_"]["openDetail"]++; }; 
	var bHandled = false;
	var bHasContentAggregation = this["oDomRef"]["getAttribute"]("bHasContentAggregation");
	if (bHasContentAggregation) {
		this["showDetail"]();
		this["fireEvent"](this["E_EVENTS"]["ShowDetail"], { "sMessageId": this["sId"] });
		bHandled = true;
	} else if (this["bHasContent"]) {
		this["fireContentAccess"](this["sId"]);
		bHandled = true;
	}
	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["openDetail"] = 0; };

UCF_Message["prototype"]["showDetail"] = function () {;if (__UCF_COVERAGE__) { UCF_Message["_"]["showDetail"]++; }; 
	this["bDetailOpen"] = true;

	UCF_DomUtil["removeClass"](this["oDomRef"], "lsMSGBorder");
	UCF_DomUtil["removeClass"](this["oDomRef"], "lsMSGCursor");
	if (this["bEnabled"]) UCF_DomUtil["removeClass"](this["oDomRef"], "lsMSGEnbl");
	var oIconDiv = UCF_DomUtil["$"](this["sId"] + "-icon");
	var oTextDiv = UCF_DomUtil["$"](this["sId"] + "-text");
	var oDetailDiv = UCF_DomUtil["$"](this["sId"] + "-detail");
	var oDetailContentTable = UCF_DomUtil["$"](this["sId"] + "-detailContent");

	oIconDiv["style"]["display"] = "none";
	oTextDiv["style"]["display"] = "none";
	oDetailDiv["style"]["visibility"] = "hidden";
	oDetailContentTable["style"]["display"] = "block";

	// ARIA
	if (window["UCF_System"]["bIsAria"]) {
		this["oDomRef"]["setAttribute"]("aria-expanded", "true");
	}
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["showDetail"] = 0; };

UCF_Message["prototype"]["closeDetail"] = function () {;if (__UCF_COVERAGE__) { UCF_Message["_"]["closeDetail"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["HideDetail"]);
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["closeDetail"] = 0; };

UCF_Message["prototype"]["hideDetail"] = function () {;if (__UCF_COVERAGE__) { UCF_Message["_"]["hideDetail"]++; }; 
	this["bDetailOpen"] = false;

	UCF_DomUtil["addClass"](this["oDomRef"], "lsMSGBorder");
	UCF_DomUtil["addClass"](this["oDomRef"], "lsMSGCursor");
	if (this["bEnabled"]) UCF_DomUtil["addClass"](this["oDomRef"], "lsMSGEnbl");
	var oIconDiv = UCF_DomUtil["$"](this["sId"] + "-icon");
	var oTextDiv = UCF_DomUtil["$"](this["sId"] + "-text");
	var oDetailDiv = UCF_DomUtil["$"](this["sId"] + "-detail");
	var oDetailContentTable = UCF_DomUtil["$"](this["sId"] + "-detailContent");

	oIconDiv["style"]["display"] = "inline-block";
	oTextDiv["style"]["display"] = "inline-block";
	oDetailDiv["style"]["visibility"] = "visible";
	oDetailContentTable["style"]["display"] = "none";

	// Safari at MacOs does not correctly paint the float
	// trigger repainting
	if (UCF_UserAgent["bIsMacOs"]() && UCF_UserAgent["bIsSafari"]()) {
		oDetailDiv["style"]["display"] = "none";
		// eslint-disable-next-line no-unused-expressions
		oDetailDiv["offsetHeight"];
		oDetailDiv["style"]["display"] = "inline-block";
	}

	// ARIA
	if (window["UCF_System"]["bIsAria"]) {
		this["oDomRef"]["setAttribute"]("aria-expanded", "false");
	}

	UCF_DomUtil["focusDomElement"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["hideDetail"] = 0; };

UCF_Message["prototype"]["onFilterAll"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onFilterAll"]++; }; 
	// this.oDomRef.style.display = "block";
	this["oDomRef"]["style"]["removeProperty"]("display");
	this["sFilterType"] = "ALL";
	if (this["oDomRef"]["getAttribute"]("iMsgIndex") == 0) {
		UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
	} else {
		UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
	}
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onFilterAll"] = 0; };

UCF_Message["prototype"]["onFilterError"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onFilterError"]++; }; 
	if (this["sType"] == "ERROR") {
		// this.oDomRef.style.display = "block";
		this["oDomRef"]["style"]["removeProperty"]("display");
		if (this["oDomRef"]["getAttribute"]("iErrorMsgIndex") == 0) {
			UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
		} else {
			UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
		}
	} else {
		this["oDomRef"]["style"]["display"] = "none";
		UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
	}
	this["sFilterType"] = "ERROR";
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onFilterError"] = 0; };

UCF_Message["prototype"]["onFilterWarning"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onFilterWarning"]++; }; 
	if (this["sType"] == "WARNING") {
		// this.oDomRef.style.display = "block";
		this["oDomRef"]["style"]["removeProperty"]("display");
		if (this["oDomRef"]["getAttribute"]("iWarningMsgIndex") == 0) {
			UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
		} else {
			UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
		}
	} else {
		this["oDomRef"]["style"]["display"] = "none";
		UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
	}
	this["sFilterType"] = "WARNING";
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onFilterWarning"] = 0; };

UCF_Message["prototype"]["onFilterInfo"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onFilterInfo"]++; }; 
	if (this["sType"] == "INFO") {
		// this.oDomRef.style.display = "block";
		this["oDomRef"]["style"]["removeProperty"]("display");
		if (this["oDomRef"]["getAttribute"]("iInfoMsgIndex") == 0) {
			UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
		} else {
			UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
		}
	} else {
		this["oDomRef"]["style"]["display"] = "none";
		UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
	}
	this["sFilterType"] = "INFO";
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onFilterInfo"] = 0; };

UCF_Message["prototype"]["onFilterSuccess"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onFilterSuccess"]++; }; 
	if (this["sType"] == "OK") {
		// this.oDomRef.style.display = "block";
		this["oDomRef"]["style"]["removeProperty"]("display");
		if (this["oDomRef"]["getAttribute"]("iSuccessMsgIndex") == 0) {
			UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
		} else {
			UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
		}
	} else {
		this["oDomRef"]["style"]["display"] = "none";
		UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
	}
	this["sFilterType"] = "OK";
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onFilterSuccess"] = 0; };

/**
 * Handles the expand event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Message["prototype"]["onlsexpand"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsexpand"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Message.js(273): onlsexpand"); };

	if (this["bDetailOpen"]) return;

	this["openDetail"]();
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsexpand"] = 0; };

/**
 * Handles the collapse event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Message["prototype"]["onlscollapse"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlscollapse"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Message.js(289): onlscollapse"); };

	if (this["oGetParent"]()["sMessageMode"] == "SINGLE") return;

	this["closeDetail"]();
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlscollapse"] = 0; };

/**
 * Handles the mouseover event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_Message["prototype"]["onmouseover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Message.js(305): onmouseover"); };

	if (window["UCF_System"]["bIs508"]) return;
	this["enrichTooltip"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onmouseover"] = 0; };

UCF_Message["prototype"]["enrichTooltip"] = function () {;if (__UCF_COVERAGE__) { UCF_Message["_"]["enrichTooltip"]++; }; 

	var oTextDiv = UCF_DomUtil["$"](this["sId"] + "-text");
	var sSeparator = (this["sTooltip"] != "") ? " - " : "";

	if (oTextDiv && oTextDiv["scrollWidth"] > oTextDiv["offsetWidth"]) {
		UCF_DomUtil["setTooltip"](this["oDomRef"], this["sText"] + sSeparator + this["sTooltip"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["enrichTooltip"] = 0; };

UCF_Message["prototype"]["iGetMessageIndex"] = function () {;if (__UCF_COVERAGE__) { UCF_Message["_"]["iGetMessageIndex"]++; }; 
	var iCurrentIndex = 0;
	var aMessageDivs = this["oGetParent"]()["oCenterContainerDiv"]["childNodes"];
	for (var n = 0; n < aMessageDivs["length"]; n++) {
		if (aMessageDivs[n]["style"]["display"] != "none") iCurrentIndex++;
		if (this["oDomRef"] == aMessageDivs[n]) return iCurrentIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["iGetMessageIndex"] = 0; };

UCF_Message["prototype"]["onlsaccessibility"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Message.js(331): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	var bSingleMessageMode = this["oGetParent"]()["sMessageMode"] == "SINGLE";
	var iMessageCount = 0;

	if (oSource["getAttribute"]("id") == this["sId"]) {
		oAccessibilityHelper["setControlType"]("MSG");
		oAccessibilityHelper["setText"](this["sText"]);
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		switch (this["sType"]) {
			case "ERROR":
				oAccessibilityHelper["setError"](true);
				break;
			case "WARNING":
				oAccessibilityHelper["setWarning"](true);
				break;
			case "INFO":
				oAccessibilityHelper["setInformation"](true);
				break;
			case "OK":
				oAccessibilityHelper["setSuccess"](true);
				break;
			default:
				break;
		}
		if (this["bEnabled"]) oAccessibilityHelper["addTutor"]("LN_TUT");
		oAccessibilityHelper["setEnabled"](this["bEnabled"]);

		if (this["bHasContent"] && !bSingleMessageMode) {
			if (this["bDetailOpen"]) {
				oAccessibilityHelper["addTutor"]("SAPUR_ST_COL_TUT");
			} else {
				oAccessibilityHelper["addTutor"]("SAPUR_ST_EXP_TUT");
			}
		}

		switch (this["sFilterType"]) {
			case "ALL":
				iMessageCount = this["oGetParent"]()["oCenterDiv"]["getAttribute"]("iMsgCount");
				oAccessibilityHelper["setItemCount"](iMessageCount);
				oAccessibilityHelper["setItemIndex"](this["iGetMessageIndex"]());
				if (!bSingleMessageMode && iMessageCount > 1) {
					oAccessibilityHelper["addTutor"]("MSG_NAV");
				}
				oAccessibilityHelper["setFiltered"](false);
				break;
			case "ERROR":
				iMessageCount = this["oGetParent"]()["oCenterDiv"]["getAttribute"]("iErrorMsgCount");
				oAccessibilityHelper["setItemCount"](iMessageCount);
				oAccessibilityHelper["setItemIndex"](this["iGetMessageIndex"]());
				if (!bSingleMessageMode && iMessageCount > 1) {
					oAccessibilityHelper["addTutor"]("MSG_NAV");
				}
				oAccessibilityHelper["setFiltered"](true);
				break;
			case "WARNING":
				iMessageCount = this["oGetParent"]()["oCenterDiv"]["getAttribute"]("iWarningMsgCount");
				oAccessibilityHelper["setItemCount"](iMessageCount);
				oAccessibilityHelper["setItemIndex"](this["iGetMessageIndex"]());
				if (!bSingleMessageMode && iMessageCount > 1) {
					oAccessibilityHelper["addTutor"]("MSG_NAV");
				}
				oAccessibilityHelper["setFiltered"](true);
				break;
			case "INFO":
				iMessageCount = this["oGetParent"]()["oCenterDiv"]["getAttribute"]("iInfoMsgCount");
				oAccessibilityHelper["setItemCount"](iMessageCount);
				oAccessibilityHelper["setItemIndex"](this["iGetMessageIndex"]());
				if (!bSingleMessageMode && iMessageCount > 1) {
					oAccessibilityHelper["addTutor"]("MSG_NAV");
				}
				oAccessibilityHelper["setFiltered"](true);
				break;
			case "OK":
				iMessageCount = this["oGetParent"]()["oCenterDiv"]["getAttribute"]("iSuccessMsgCount");
				oAccessibilityHelper["setItemCount"](iMessageCount);
				oAccessibilityHelper["setItemIndex"](this["iGetMessageIndex"]());
				if (!bSingleMessageMode && iMessageCount > 1) {
					oAccessibilityHelper["addTutor"]("MSG_NAV");
				}
				oAccessibilityHelper["setFiltered"](true);
				break;
			default:
				break;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsaccessibility"] = 0; };

/**
 * TabNext
 * @private
 */
UCF_Message["prototype"]["onlstabnext"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlstabnext"]++; }; 
	//in pinned state forward tab out of message area
	var bIsPinned = this["oGetParent"]()["bIsPinned"];
	if (bIsPinned) return;

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource == this["oDomRef"]) {
		var oFirstFocusableDomRef = UCF_DomUtil["oGetFirstFocusableDomRef"](this["oDomRef"]);
		if (oFirstFocusableDomRef) {
			UCF_DomUtil["focusDomElement"](oFirstFocusableDomRef);
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			return;
		} else {
			var oCenterHeader = UCF_DomUtil["oGetPreviousSibling"](this["oDomRef"]["parentNode"]);
			UCF_DomUtil["focusDomElement"](UCF_DomUtil["oGetFirstFocusableDomRef"](oCenterHeader));
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	} else {
		var oLastFocusableDomRef = UCF_DomUtil["oGetLastFocusableDomRef"](this["oDomRef"]);
		if (oLastFocusableDomRef && oLastFocusableDomRef == oSource) {
			oCenterHeader = UCF_DomUtil["oGetPreviousSibling"](this["oDomRef"]["parentNode"]);
			UCF_DomUtil["focusDomElement"](UCF_DomUtil["oGetFirstFocusableDomRef"](oCenterHeader));
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlstabnext"] = 0; };

/**
 * TabPrevious
 * @private
 */
UCF_Message["prototype"]["onlstabprevious"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlstabprevious"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource == this["oDomRef"]) {
		var oLastFocusableDomRef = UCF_DomUtil["oGetLastFocusableDomRef"](this["oDomRef"]);
		if (oLastFocusableDomRef) {
			UCF_DomUtil["focusDomElement"](oLastFocusableDomRef);
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			return;
		} else {
			var oCenterHeader = UCF_DomUtil["oGetPreviousSibling"](this["oDomRef"]["parentNode"]);
			UCF_DomUtil["focusDomElement"](UCF_DomUtil["oGetLastFocusableDomRef"](oCenterHeader));
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	} else {
		var oFirstFocusableDomRef = UCF_DomUtil["oGetFirstFocusableDomRef"](this["oDomRef"]);
		if (oFirstFocusableDomRef && oFirstFocusableDomRef == oSource) {
			oCenterHeader = UCF_DomUtil["oGetPreviousSibling"](this["oDomRef"]["parentNode"]);
			UCF_DomUtil["focusDomElement"](UCF_DomUtil["oGetLastFocusableDomRef"](oCenterHeader));
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlstabprevious"] = 0; };

/**
 * Arrow up
 * @private
 */
UCF_Message["prototype"]["onlsup"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsup"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var oPreviousMessageDiv = UCF_DomUtil["oGetPreviousSibling"](oSource);
	//navigate messages
	while (oPreviousMessageDiv) {
		if (oPreviousMessageDiv["style"]["display"] != "none") {
			UCF_DomUtil["setTabIndex"](oSource, -1);
			UCF_DomUtil["setTabIndex"](oPreviousMessageDiv, 0);
			UCF_DomUtil["focusDomElement"](oPreviousMessageDiv);
			break;
		}
		oPreviousMessageDiv = UCF_DomUtil["oGetPreviousSibling"](oPreviousMessageDiv);
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsup"] = 0; };

/**
 * Arrow left
 * @private
 */
UCF_Message["prototype"]["onlsprevious"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsprevious"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var oPreviousMessageDiv = UCF_DomUtil["oGetPreviousSibling"](oSource);
	//navigate messages
	while (oPreviousMessageDiv) {
		if (oPreviousMessageDiv["style"]["display"] != "none") {
			UCF_DomUtil["setTabIndex"](oSource, -1);
			UCF_DomUtil["setTabIndex"](oPreviousMessageDiv, 0);
			UCF_DomUtil["focusDomElement"](oPreviousMessageDiv);
			break;
		}
		oPreviousMessageDiv = UCF_DomUtil["oGetPreviousSibling"](oPreviousMessageDiv);
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsprevious"] = 0; };

/**
 * Arrow down
 * @private
 */
UCF_Message["prototype"]["onlsdown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsdown"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var oNextMessageDiv = UCF_DomUtil["oGetNextSibling"](oSource);
	//navigate messages
	while (oNextMessageDiv) {
		if (oNextMessageDiv["style"]["display"] != "none") {
			UCF_DomUtil["setTabIndex"](oSource, -1);
			UCF_DomUtil["setTabIndex"](oNextMessageDiv, 0);
			UCF_DomUtil["focusDomElement"](oNextMessageDiv);
			break;
		}
		oNextMessageDiv = UCF_DomUtil["oGetNextSibling"](oNextMessageDiv);
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsdown"] = 0; };

/**
 * Arrow right
 * @private
 */
UCF_Message["prototype"]["onlsnext"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsnext"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var oNextMessageDiv = UCF_DomUtil["oGetNextSibling"](oSource);
	//navigate messages
	while (oNextMessageDiv) {
		if (oNextMessageDiv["style"]["display"] != "none") {
			UCF_DomUtil["setTabIndex"](oSource, -1);
			UCF_DomUtil["setTabIndex"](oNextMessageDiv, 0);
			UCF_DomUtil["focusDomElement"](oNextMessageDiv);
			break;
		}
		oNextMessageDiv = UCF_DomUtil["oGetNextSibling"](oNextMessageDiv);
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsnext"] = 0; };

/**
 * Home
 * @private
 */
UCF_Message["prototype"]["onlshome"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlshome"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var oFirstMessageDiv = UCF_DomUtil["oGetFirstChild"](oSource["parentNode"]);
	//navigate messages
	while (oFirstMessageDiv) {
		if (oFirstMessageDiv["style"]["display"] != "none") {
			UCF_DomUtil["setTabIndex"](oSource, -1);
			UCF_DomUtil["setTabIndex"](oFirstMessageDiv, 0);
			UCF_DomUtil["focusDomElement"](oFirstMessageDiv);
			break;
		}
		oFirstMessageDiv = UCF_DomUtil["oGetNextSibling"](oFirstMessageDiv);
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlshome"] = 0; };

/**
 * End
 * @private
 */
UCF_Message["prototype"]["onlsend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsend"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var oLastMessageDiv = UCF_DomUtil["oGetLastChild"](oSource["parentNode"]);
	//navigate messages
	while (oLastMessageDiv) {
		if (oLastMessageDiv["style"]["display"] != "none") {
			UCF_DomUtil["setTabIndex"](oSource, -1);
			UCF_DomUtil["setTabIndex"](oLastMessageDiv, 0);
			UCF_DomUtil["focusDomElement"](oLastMessageDiv);
			break;
		}
		oLastMessageDiv = UCF_DomUtil["oGetPreviousSibling"](oLastMessageDiv);
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlsend"] = 0; };

/**
 * Home
 * @private
 */
UCF_Message["prototype"]["onlspageup"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlspageup"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var oPreviousMessageDiv = UCF_DomUtil["oGetPreviousSibling"](oSource);
	var oCurrentMessageDiv = null;
	var iVisibleMessageCount = this["oGetParent"]()["iVisibleMessageCount"];
	var iMessageCounter = 1;
	//navigate messages
	while (oPreviousMessageDiv && iMessageCounter <= iVisibleMessageCount) {
		if (oPreviousMessageDiv["style"]["display"] != "none") {
			oCurrentMessageDiv = oPreviousMessageDiv;
			iMessageCounter++;
		}
		oPreviousMessageDiv = UCF_DomUtil["oGetPreviousSibling"](oPreviousMessageDiv);
	}
	if (oCurrentMessageDiv) {
		UCF_DomUtil["setTabIndex"](oSource, -1);
		UCF_DomUtil["setTabIndex"](oCurrentMessageDiv, 0);
		UCF_DomUtil["focusDomElement"](oCurrentMessageDiv);
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlspageup"] = 0; };

/**
 * End
 * @private
 */
UCF_Message["prototype"]["onlspagedown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlspagedown"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var oNextMessageDiv = UCF_DomUtil["oGetNextSibling"](oSource);
	var oCurrentMessageDiv = null;
	var iVisibleMessageCount = this["oGetParent"]()["iVisibleMessageCount"];
	var iMessageCounter = 1;
	//navigate messages
	while (oNextMessageDiv && iMessageCounter <= iVisibleMessageCount) {
		if (oNextMessageDiv["style"]["display"] != "none") {
			oCurrentMessageDiv = oNextMessageDiv;
			iMessageCounter++;
		}
		oNextMessageDiv = UCF_DomUtil["oGetNextSibling"](oNextMessageDiv);
	}
	if (oCurrentMessageDiv) {
		UCF_DomUtil["setTabIndex"](oSource, -1);
		UCF_DomUtil["setTabIndex"](oCurrentMessageDiv, 0);
		UCF_DomUtil["focusDomElement"](oCurrentMessageDiv);
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["onlspagedown"] = 0; };

/**
 * Sets the focus to the connected control that corresponds to the message
 * If the connected control cannot receive the focus this function is ignored.
 */
UCF_Message["prototype"]["focusConnectedControl"] = function () {;if (__UCF_COVERAGE__) { UCF_Message["_"]["focusConnectedControl"]++; }; 
	if (!this["sConnectedControlId"]) return;
	var oTargetControl = this["oGetControlById"](this["sConnectedControlId"]);
	if (!oTargetControl) return;
	if (oTargetControl["bIsFocusable"]()) {
		oTargetControl["focus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["focusConnectedControl"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Message["prototype"]["aAttributeNames"] = ["sType","sText","sTooltip","bEnabled","bHasContent","sConnectedControlId","bWrapping"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Message["prototype"]["aEventNames"] = ["Select","ContentAccess"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Message["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.MessageType}
 */
UCF_Message["prototype"]["sType"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_Message["prototype"]["sText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Message["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Message["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_Message["prototype"]["bHasContent"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Message["prototype"]["sConnectedControlId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Message["prototype"]["bWrapping"] = false;

//#JSCOVER_EXCL_START
/** @protected */
UCF_Message["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Message["_"]["setDefaultValues"]++; }; 
	this["sType"] = "NONE";
	this["sText"] = '';
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["bHasContent"] = false;
	this["sConnectedControlId"] = '';
	this["bWrapping"] = false;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Type", "NONE", true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("HasContent", false, true);
		this["setClientProperty"]("ConnectedControlId", '', true);
		this["setClientProperty"]("Wrapping", false, true);
	}
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the Message control.
 * @fires Message::Select
 */
UCF_Message["prototype"]["fireSelect"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["fireSelect"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Message.js(774): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Message.js(775): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Message.js(776): fireSelect"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Message", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Message control.
 * @fires Message::ContentAccess
 */
UCF_Message["prototype"]["fireContentAccess"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Message["_"]["fireContentAccess"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Message.js(793): fireContentAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Message.js(794): fireContentAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Message.js(795): fireContentAccess"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Message", "ContentAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Message["_"]["fireContentAccess"] = 0; };

};
sap["ls"]["preload"]["UCF_MessageArea"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>

/**
 * MessageArea
 *
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MessageArea(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["UCF_MessageArea"]++; }; 
	if (arguments["length"] === 0) {
		return;
	}
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "MessageArea.js(31): UCF_MessageArea"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "MessageArea.js(32): UCF_MessageArea"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "MessageArea.js(33): UCF_MessageArea"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["defineEvents"]([
		'FilterAll',
		'FilterError',
		'FilterWarning',
		'FilterInfo',
		'FilterSuccess'
	]);

	this["oNotifierDiv"] = UCF_DomUtil["$"](this["sId"] + "-notifier");
	this["oCenterDiv"] = UCF_DomUtil["$"](this["sId"] + "-center");
	this["oCenterHeaderDiv"] = UCF_DomUtil["$"](this["sId"] + "-centerHeader");
	this["oCenterContainerDiv"] = UCF_DomUtil["$"](this["sId"] + "-centerContainer");

	this["iMsgCount"] = parseInt(this["oCenterDiv"]["getAttribute"]("iMsgCount"));
	this["iErrorMsgCount"] = parseInt(this["oCenterDiv"]["getAttribute"]("iErrorMsgCount"));
	this["iWarningMsgCount"] = parseInt(this["oCenterDiv"]["getAttribute"]("iWarningMsgCount"));
	this["iInfoMsgCount"] = parseInt(this["oCenterDiv"]["getAttribute"]("iInfoMsgCount"));
	this["iSuccessMsgCount"] = parseInt(this["oCenterDiv"]["getAttribute"]("iSuccessMsgCount"));

	this["oFilterButtonsDiv"] = UCF_DomUtil["$"](this["sId"] + "-filterButtons");
	this["oFilterAllDiv"] = UCF_DomUtil["$"](this["sId"] + "-filterAll");
	this["oFilterErrorDiv"] = UCF_DomUtil["$"](this["sId"] + "-filterError");
	this["oFilterWarningDiv"] = UCF_DomUtil["$"](this["sId"] + "-filterWarning");
	this["oFilterInfoDiv"] = UCF_DomUtil["$"](this["sId"] + "-filterInfo");
	this["oFilterSuccessDiv"] = UCF_DomUtil["$"](this["sId"] + "-filterSuccess");

	this["oTogglePinDiv"] = UCF_DomUtil["$"](this["sId"] + "-togglePin");
	this["oCollapseDiv"] = UCF_DomUtil["$"](this["sId"] + "-collapse");
	this["oBackDiv"] = UCF_DomUtil["$"](this["sId"] + "-back");

	//	Reset top/left position at server - use  9999 instead of -1 because css size check
	//  Reset logic at server not available -> reset in renderer and UCF constructor
	if (this["sTop"] === "9999px" && this["sLeft"] === "9999px") {
		this["sTop"] = "";
		this["setClientProperty"]("Top", this["sTop"], true);
		this["sLeft"] = "";
		this["setClientProperty"]("Left", this["sLeft"], true);
	}
	this["iTop"] = 0;
	if (this["sTop"]) {
		this["iTop"] = parseInt(this["sTop"]);
	}
	this["iLeft"] = 0;
	if (this["sLeft"]) {
		this["iLeft"] = parseInt(this["sLeft"]);
	}
	this["iHeight"] = 0;
	this["iWidth"] = parseInt(this["sWidth"]);
	this["iMessageHeight"] = 0;

	this["sCurrentFilter"] = "all";
	this["bDetailOpen"] = false;
	this["bRepositioned"] = this["sTop"] !== "" || this["sLeft"] !== "";
	this["iDetailHeight"] = 0;

	this["bToggleFocusActive"] = false;

	this["oBlindLayer"] = null;
	this["sPopOverPositionMode"] = "fixed";
	this["bMsgWrapping"] = false;
};window["UCF_MessageArea"] = UCF_MessageArea; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MessageArea"); UCF_MessageArea["_"] = {UCF_MessageArea: 0}; }; ;

UCF_MessageArea["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_MessageArea.prototype["sClassName"] = "UCF_MessageArea";

/******************************************************
 ** CONSTANTS
 *******************************************************/

UCF_MessageArea["prototype"]["RESIZE_BAR_HEIGHT"] = 6;
UCF_MessageArea["prototype"]["MIN_WIDTH"] = 400;

UCF_MessageArea["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["destroy"]++; }; 
	// Detach the page windowResize event
	var oPage = this["oLS"]["oGetPageInternal"]();
	if (oPage) {
		oPage["detachEvent"](oPage["E_EVENTS"]["WindowResize"], this, 'onWindowResize');
	}

	if (this["oBlindLayer"]) {
		this["releaseBlindLayer"]();
		this["oBlindLayer"] = null;
	}

	this["iMsgCount"] = 0;
	this["iErrorMsgCount"] = 0;
	this["iWarningMsgCount"] = 0;
	this["iInfoMsgCount"] = 0;
	this["iSuccessMsgCount"] = 0;
	this["iTop"] = 0;
	this["iLeft"] = 0;
	this["iHeight"] = 0;
	this["iWidth"] = 0;
	this["iMessageHeight"] = 0;
	this["iDetailHeight"] = 0;
	this["iCenterHeaderHeight"] = 0;
	this["iPageXStart"] = 0;
	this["iPageYStart"] = 0;

	this["oNotifierDiv"] = null;
	this["oCenterDiv"] = null;
	this["oCenterHeaderDiv"] = null;
	this["oCenterContainerDiv"] = null;
	this["oFilterAllDiv"] = null;
	this["oFilterErrorDiv"] = null;
	this["oFilterWarningDiv"] = null;
	this["oFilterInfoDiv"] = null;
	this["oFilterSuccessDiv"] = null;
	this["oTogglePinDiv"] = null;
	this["oCollapseDiv"] = null;
	this["oBackDiv"] = null;
	this["oMessage"] = null;
	this["oFilterButtonsDiv"] = null;

	this["bInitialized"] = false;
	this["bToggleFocusActive"] = false;
	this["bRepositioned"] = false;
	this["bMsgWrapping"] = false;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["destroy"] = 0; };

UCF_MessageArea["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["initialize"]++; }; 

	//initialize when opened or pinned but msgCount=0
	if ((this["bIsOpened"] || this["bIsPinned"]) && this["iMsgCount"] === 0 && !this["bInitialized"]) {
		this["initInternal"]();
		return;
	}

	var bStick = false;
	//trigger expand when bIsOpened is set
	if ((this["bIsOpened"] || this["bIsPinned"]) && !this["sContentAccessId"]) {
		bStick = !this["sTop"] && !this["sLeft"] && !this["bIsPinned"];
		if (!this["bIsPinned"]) this["oNotifierDiv"]["style"]["display"] = 'block';
		this["expand"](false, bStick);
	}

	//show detail (expand + showDetail)
	if ((this["bIsOpened"] || this["bIsPinned"]) && this["sContentAccessId"]) {
		bStick = !this["sTop"] && !this["sLeft"];
		this["expand"](false, bStick);
		var oMessage = this["oLS"]["oControlFactory"]["oGetControlById"](this["sContentAccessId"]);
		oMessage["showDetail"]();
		this["showDetail"](this["sContentAccessId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["initialize"] = 0; };

/* eslint-disable complexity */
UCF_MessageArea["prototype"]["initInternal"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["initInternal"]++; }; 
	var oPageHeader;
	var sPageHeaderId;
	var oHeaderMsgContainerDiv;
	var oHeaderMsgNotifierTD;

	this["bInitialized"] = true;

	//initialize Messages
	if (this["iMsgCount"] > 0) {
		var aMessageDivs = this["oCenterContainerDiv"]["childNodes"];
		var oMessage = null;
		var iMsgIndex = 0;
		var iErrorMsgIndex = 0;
		var iWarningMsgIndex = 0;
		var iInfoMsgIndex = 0;
		var iSuccessMsgIndex = 0;
		for (var n = 0; n < aMessageDivs["length"] - 1; n++) {
			oMessage = this["oGetControlByDomRef"](aMessageDivs[n], true);
			if (oMessage && oMessage["bWrapping"]) this["bMsgWrapping"] = true;
			aMessageDivs[n]["setAttribute"]("iMsgIndex", iMsgIndex);
			iMsgIndex++;
			switch (oMessage["sType"]) {
				case "ERROR":
					aMessageDivs[n]["setAttribute"]("iErrorMsgIndex", iErrorMsgIndex);
					iErrorMsgIndex++;
					break;
				case "WARNING":
					aMessageDivs[n]["setAttribute"]("iWarningMsgIndex", iWarningMsgIndex);
					iWarningMsgIndex++;
					break;
				case "INFO":
					aMessageDivs[n]["setAttribute"]("iInfoMsgIndex", iInfoMsgIndex);
					iInfoMsgIndex++;
					break;
				case "OK":
					aMessageDivs[n]["setAttribute"]("iSuccessMsgIndex", iSuccessMsgIndex);
					iSuccessMsgIndex++;
					break;
				default:
					break;
			}

			this["attachEvent"](this["E_EVENTS"]["FilterAll"], oMessage, "onFilterAll");
			this["attachEvent"](this["E_EVENTS"]["FilterError"], oMessage, "onFilterError");
			this["attachEvent"](this["E_EVENTS"]["FilterWarning"], oMessage, "onFilterWarning");
			this["attachEvent"](this["E_EVENTS"]["FilterInfo"], oMessage, "onFilterInfo");
			this["attachEvent"](this["E_EVENTS"]["FilterSuccess"], oMessage, "onFilterSuccess");
		}

		switch (this["sFilterType"]) {
			case "ERROR":
				this["filterError"]();
				break;
			case "WARNING":
				this["filterWarning"]();
				break;
			case "INFO":
				this["filterInfo"]();
				break;
			case "SUCCESS":
				this["filterSuccess"]();
				break;
			default:
				break;
		}
	}

	//get rendered message height as well as centerHeader height
	this["iMessageHeight"] = this["oCenterContainerDiv"]["lastChild"]["offsetHeight"];
	this["iCenterHeaderHeight"] = this["oCenterHeaderDiv"]["offsetHeight"];
	//hide template message
	var oTemplateMsg = UCF_DomUtil["$"](this["sId"] + "-messageTemplate");
	if (oTemplateMsg) oTemplateMsg["style"]["display"] = "none";
	//determine popOver height
	if (this["bIsOpened"] && this["sHeight"]) {
		this["iHeight"] = parseInt(this["sHeight"]);
	} else {
		this["iHeight"] = (Math["min"](this["iMsgCount"], this["iVisibleMessageCount"]) * this["iMessageHeight"]) + this["iCenterHeaderHeight"];
	}
	//set popOver maxHeight
	if (!this["bMsgWrapping"]) {
		if (this["bAdjustHeight"] || !this["bIsPinned"] || (this["iMsgCount"] > this["iVisibleMessageCount"])) {
			this["oCenterDiv"]["style"]["maxHeight"] = ((this["iMsgCount"] * this["iMessageHeight"]) + this["iCenterHeaderHeight"]) + "px";
			this["oCenterContainerDiv"]["style"]["maxHeight"] = (this["iMsgCount"] * this["iMessageHeight"]) + "px";
		} else {
			this["oCenterDiv"]["style"]["maxHeight"] = ((this["iVisibleMessageCount"] * this["iMessageHeight"]) + this["iCenterHeaderHeight"]) + "px";
			this["oCenterContainerDiv"]["style"]["maxHeight"] = (this["iVisibleMessageCount"] * this["iMessageHeight"]) + "px";
		}
	}
	//set popOver height
	this["oCenterContainerDiv"]["style"]["height"] = (Math["min"](this["iMsgCount"], this["iVisibleMessageCount"]) * this["iMessageHeight"]) + "px";
	//adjust popOver height for pinned state
	if (this["bIsPinned"]) {
		//		in pinned state add resizeBarHeight -- this.sHeight is always the height of the unpinned state
		if (this["sHeight"]) {
			this["iHeight"] += this["RESIZE_BAR_HEIGHT"];
			this["oCenterDiv"]["style"]["height"] = this["iHeight"] + "px";
		} else {
			this["iHeight"] = ((Math["min"](this["iMsgCount"], this["iVisibleMessageCount"]) * this["iMessageHeight"]) + this["iCenterHeaderHeight"]) + this["RESIZE_BAR_HEIGHT"];
			this["oCenterDiv"]["style"]["height"] = ((Math["min"](this["iMsgCount"], this["iVisibleMessageCount"]) * this["iMessageHeight"]) + this["iCenterHeaderHeight"]) + this["RESIZE_BAR_HEIGHT"] + "px";
		}
		this["oCenterDiv"]["style"]["minHeight"] = this["iCenterHeaderHeight"] + this["RESIZE_BAR_HEIGHT"] + "px";
		if (!this["bMsgWrapping"]) this["oCenterDiv"]["style"]["maxHeight"] = parseInt(this["oCenterDiv"]["style"]["maxHeight"]) + this["RESIZE_BAR_HEIGHT"] + "px";
	}
	//set filter DIV styles
	if (this["iErrorMsgCount"] === 0) {
		this["oFilterErrorDiv"]["style"]["display"] = "none";
	} else if (this["iWarningMsgCount"] === 0 && this["iSuccessMsgCount"] === 0 && this["iInfoMsgCount"] === 0) {
		UCF_DomUtil["addClass"](this["oFilterErrorDiv"], "lsMAFilterIconLast");
	}
	if (this["iWarningMsgCount"] === 0) {
		this["oFilterWarningDiv"]["style"]["display"] = "none";
	} else if (this["iSuccessMsgCount"] === 0 && this["iInfoMsgCount"] === 0) {
		UCF_DomUtil["addClass"](this["oFilterWarningDiv"], "lsMAFilterIconLast");
	}
	if (this["iSuccessMsgCount"] === 0) {
		this["oFilterSuccessDiv"]["style"]["display"] = "none";
	} else if (this["iInfoMsgCount"] === 0) {
		UCF_DomUtil["addClass"](this["oFilterSuccessDiv"], "lsMAFilterIconLast");
	}
	if (this["iInfoMsgCount"] === 0) {
		this["oFilterInfoDiv"]["style"]["display"] = "none";
	} else {
		UCF_DomUtil["addClass"](this["oFilterInfoDiv"], "lsMAFilterIconLast");
	}

	//initialize pinned state
	if (this["bIsPinned"]) {
		//dock to PageHeader container if embedded in PageHeader and pinned
		oPageHeader = UCF_DomUtil["oGetParentByAttribute"](this["oDomRef"]["parentNode"], "ct", "PHM");
		if (oPageHeader) {
			sPageHeaderId = oPageHeader["getAttribute"]("id");
			oHeaderMsgContainerDiv = UCF_DomUtil["$"](sPageHeaderId + "-msgContainer");
			oHeaderMsgNotifierTD = UCF_DomUtil["$"](sPageHeaderId + "-msgNotifier");
			if (oHeaderMsgContainerDiv && oHeaderMsgNotifierTD && !UCF_DomUtil["oGetFirstChild"](oHeaderMsgContainerDiv) && UCF_DomUtil["oGetFirstChild"](oHeaderMsgNotifierTD)) {
				UCF_DomUtil["addClass"](oHeaderMsgContainerDiv, "lsPageHeader--messagearea");
				oHeaderMsgContainerDiv["appendChild"](UCF_DomUtil["oGetFirstChild"](oHeaderMsgNotifierTD));
				this["applyCenterContainerScrollbarClass"]();
			}
		}
		// Chrome53++ does not correctly absolute position the resize bar
		// trigger repainting
		if (UCF_UserAgent["bIsChromium"](53)) {
			this["oCenterContainerDiv"]["style"]["display"] = "none";
			// eslint-disable-next-line no-unused-expressions
			this["oCenterContainerDiv"]["offsetHeight"];
			this["oCenterContainerDiv"]["style"]["display"] = "block";
		}

		this["bIsOpened"] = true;
		this["setClientProperty"]("IsOpened", this["bIsOpened"], true);
		this["setNavigation"]();
	}
	//revert pinned state
	if (!this["bIsPinned"]) {
		//undock from PageHeader container if embedded in PageHeader and not pinned
		oPageHeader = UCF_DomUtil["oGetParentByAttribute"](this["oDomRef"]["parentNode"], "ct", "PHM");
		if (oPageHeader) {
			sPageHeaderId = oPageHeader["getAttribute"]("id");
			oHeaderMsgContainerDiv = UCF_DomUtil["$"](sPageHeaderId + "-msgContainer");
			oHeaderMsgNotifierTD = UCF_DomUtil["$"](sPageHeaderId + "-msgNotifier");
			if (oHeaderMsgContainerDiv && oHeaderMsgNotifierTD && UCF_DomUtil["oGetFirstChild"](oHeaderMsgContainerDiv) && !UCF_DomUtil["oGetFirstChild"](oHeaderMsgNotifierTD)) {
				UCF_DomUtil["removeClass"](oHeaderMsgContainerDiv, "lsPageHeader--messagearea");
				oHeaderMsgNotifierTD["appendChild"](UCF_DomUtil["oGetFirstChild"](oHeaderMsgContainerDiv));
			}
		}
	}

	//trigger expand when bIsOpened is set
	//var bStick = false;
	//if (!this.sContentAccessId && this.bIsOpened) {
	//	bStick = !this.sTop && !this.sLeft && !this.bIsPinned;
	//	if (!this.bIsPinned) this.oNotifierDiv.style.display = 'block';
	//	this.expand(false, bStick);
	//}
	// switch to position absolute if notifier is not in visible area of screen
	if (!this["bIsPinned"]) {
		var oNotifierRect = this["oGetObjectRect"](this["oNotifierDiv"]);
		var iCLientWidth = UCF_DomUtil["iClientWidth"]();
		var iCLientHeight = UCF_DomUtil["iClientHeight"]();
		if (oNotifierRect["top"] > iCLientHeight || oNotifierRect["left"] > iCLientWidth) {
			this["oCenterDiv"]["style"]["position"] = "absolute";
			this["sPopOverPositionMode"] = "absolute";
		}
	}
	// Attach the page windowResize event
	var oPage = this["oLS"]["oGetPageInternal"]();
	if (oPage) {
		oPage["attachEvent"](oPage["E_EVENTS"]["WindowResize"], this, 'onWindowResize');
	}
	//show detail (expand + showDetail)
	//if (!this.bIsOpened || !this.sContentAccessId) return;
	//bStick = !this.sTop && !this.sLeft;
	//this.expand(false, bStick);
	//var oMessage = this.oLS.oControlFactory.oGetControlById(this.sContentAccessId);
	//oMessage.showDetail();
	//this.showDetail(this.sContentAccessId);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["initInternal"] = 0; };
/* eslint-enable complexity */

UCF_MessageArea["prototype"]["setNavigation"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["setNavigation"]++; }; 

	var lv_tabIndex = 0;
	var aButtonDivs = this["oCenterHeaderDiv"]["childNodes"];
	var oAllFilterButtonsChilds, oFilterButton;
	for (var i = 0; i < aButtonDivs["length"]; i++) {
		if (aButtonDivs[i]["getAttribute"]("id") === this["sId"] + "-rightIcons") {
			for (var k = 0; k < aButtonDivs[i]["childNodes"]["length"]; k++) {
				UCF_DomUtil["setTabIndex"](aButtonDivs[i]["childNodes"][k], lv_tabIndex);
			}
		} else if (aButtonDivs[i]["getAttribute"]("id") === this["sId"] + "-filterButtons") {
			oAllFilterButtonsChilds = aButtonDivs[i]["childNodes"];
			for (var j = 0; j < oAllFilterButtonsChilds["length"]; j++) {
				oFilterButton = oAllFilterButtonsChilds[j];
				switch (oFilterButton["getAttribute"]("id")) {
					case this["sId"] + "-filterAll":
						if (this["sFilterType"] === "ALL") {
							UCF_DomUtil["setTabIndex"](oFilterButton, lv_tabIndex);
							if (window["UCF_System"]["bIsAria"]) {
								oFilterButton["setAttribute"]("aria-checked", true);
							}
						}
						break;
					case this["sId"] + "-filterError":
						if (this["sFilterType"] === "ERROR") {
							UCF_DomUtil["setTabIndex"](oFilterButton, lv_tabIndex);
							if (window["UCF_System"]["bIsAria"]) {
								oFilterButton["setAttribute"]("aria-checked", true);
							}
						}
						break;
					case this["sId"] + "-filterWarning":
						if (this["sFilterType"] === "WARNING") {
							UCF_DomUtil["setTabIndex"](oFilterButton, lv_tabIndex);
							if (window["UCF_System"]["bIsAria"]) {
								oFilterButton["setAttribute"]("aria-checked", true);
							}
						}
						break;
					case this["sId"] + "-filterInfo":
						if (this["sFilterType"] === "INFO") {
							UCF_DomUtil["setTabIndex"](oFilterButton, lv_tabIndex);
							if (window["UCF_System"]["bIsAria"]) {
								oFilterButton["setAttribute"]("aria-checked", true);
							}
						}
						break;
					case this["sId"] + "-filterSuccess":
						if (this["sFilterType"] === "SUCCESS") {
							UCF_DomUtil["setTabIndex"](oFilterButton, lv_tabIndex);
							if (window["UCF_System"]["bIsAria"]) {
								oFilterButton["setAttribute"]("aria-checked", true);
							}
						}
						break;
					default:
						break;
				}
			}
		}
	}

	if (this["iMsgCount"] === 0) return;

	var aMessageDivs = this["oCenterContainerDiv"]["childNodes"];
	for (j = 0; j < aMessageDivs["length"]; j++) {
		if (this["oFilterButtonsDiv"] === aMessageDivs) {
			oAllFilterButtonsChilds = this["oFilterButtonsDiv"]["childNodes"];
			for (i = 0; i < oAllFilterButtonsChilds["length"]; i++) {
				UCF_DomUtil["setTabIndex"](oAllFilterButtonsChilds[i], -1);
			}
		} else
			UCF_DomUtil["setTabIndex"](aMessageDivs[j], -1);

	}

	var oFirstMessageDiv = this["oCenterContainerDiv"]["firstChild"];
	if (this["oFilterButtonsDiv"] === oFirstMessageDiv) {
		oFirstMessageDiv = this["oFilterButtonsDiv"]["firstChild"];
	}
	UCF_DomUtil["setTabIndex"](oFirstMessageDiv, lv_tabIndex);

};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["setNavigation"] = 0; };

UCF_MessageArea["prototype"]["resetNavigation"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetNavigation"]++; }; 

	var lv_tabIndex = -1;
	var aButtonDivs = this["oCenterHeaderDiv"]["childNodes"];
	for (var i = 0; i < aButtonDivs["length"]; i++) {
		if (aButtonDivs[i]["getAttribute"]("id") === this["sId"] + "-rightIcons") {
			for (var k = 0; k < aButtonDivs[i]["childNodes"]["length"]; k++) {
				UCF_DomUtil["setTabIndex"](aButtonDivs[i]["childNodes"][k], lv_tabIndex);
			}
		} else if (aButtonDivs[i]["getAttribute"]("id")["indexOf"]("filter") !== -1) {
			UCF_DomUtil["setTabIndex"](aButtonDivs[i], lv_tabIndex);
			if (window["UCF_System"]["bIsAria"]) {
				aButtonDivs[i]["setAttribute"]("aria-checked", false);
			}
		}
	}

	if (this["iMsgCount"] === 0) return;

	var aMessageDivs = this["oCenterContainerDiv"]["childNodes"];
	for (var j = 0; j < aMessageDivs["length"]; j++) {
		UCF_DomUtil["setTabIndex"](aMessageDivs[j], -1);
	}

};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetNavigation"] = 0; };

UCF_MessageArea["prototype"]["oGetFocusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["oGetFocusDomRef"]++; }; 
	//in ACC mode and pinned state center has tabindex
	var oCenterDiv = UCF_DomUtil["$"](this["sId"] + "-center"),
		oNotifierDiv = UCF_DomUtil["$"](this["sId"] + "-notifier"),
		oFilterAllDiv = UCF_DomUtil["$"](this["sId"] + "-filterAll");

	if (oCenterDiv && UCF_DomUtil["bHasTabIndex"](oCenterDiv)) {
		return oCenterDiv;
	} else {
		//otherwise take the notifier
		if (oNotifierDiv && UCF_DomUtil["bHasTabIndex"](oNotifierDiv)) {
			return oNotifierDiv;
		}
		//or the first filter button (in pinned state non ACC mode)
		else {
			if (oFilterAllDiv && UCF_DomUtil["bHasTabIndex"](oFilterAllDiv)) {
				return oFilterAllDiv;
			}
		}
	}
	return UCF_Control.prototype["oGetFocusDomRef"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["oGetFocusDomRef"] = 0; };

/**
 * Handles the layout change event
 */
UCF_MessageArea["prototype"]["onWindowResize"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onWindowResize"]++; }; 

	// switch to position absolute if notifier is not in visible area of screen
	if (!this["bIsPinned"]) {
		var oNotifierRect = this["oGetObjectRect"](this["oNotifierDiv"]);
		var iCLientWidth = UCF_DomUtil["iClientWidth"]();
		var iCLientHeight = UCF_DomUtil["iClientHeight"]();
		if (oNotifierRect["top"] > iCLientHeight || oNotifierRect["left"] > iCLientWidth) {
			this["oCenterDiv"]["style"]["position"] = "absolute";
			this["sPopOverPositionMode"] = "absolute";
		} else {
			this["oCenterDiv"]["style"]["position"] = "fixed";
			this["sPopOverPositionMode"] = "fixed";
		}
	}

	if (!this["bIsOpened"] || this["bIsPinned"] || this["iMsgCount"] === 0) return;
	this["stick"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onWindowResize"] = 0; };

/**
 * Handles the onlsdragstart event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageArea["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsdragstart"]++; }; 

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];
	var sDragType = "";

	this["sDragType"] = "";

	this["oCenterDiv"]["style"]["transition"] = "all 0s";

	this["iPageXStart"] = oBrowserEvent["iPageX"]();
	this["iPageYStart"] = oBrowserEvent["iPageY"]();

	if (this["bDetailOpen"]) {
		this["iDetailHeight"] = this["oCenterDiv"]["offsetHeight"];
	}

	var oSource = oBrowserEvent["oGetSource"]();
	switch (oSource["getAttribute"]("id")) {
		case this["sId"] + "-resizeHandleN":
			this["sDragType"] = "resizeN";
			sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
			break;
		case this["sId"] + "-resizeHandleNNW":
			if (window["UCF_System"]["bIsRTL"]) {
				this["sDragType"] = "resizeNNE";
			} else {
				this["sDragType"] = "resizeNNW";
			}
			sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
			break;
		case this["sId"] + "-resizeHandleNNE":
			if (window["UCF_System"]["bIsRTL"]) {
				this["sDragType"] = "resizeNNW";
			} else {
				this["sDragType"] = "resizeNNE";
			}
			sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
			break;
		case this["sId"] + "-resizeHandleE":
			if (window["UCF_System"]["bIsRTL"]) {
				this["sDragType"] = "resizeW";
			} else {
				this["sDragType"] = "resizeE";
			}
			sDragType = UCF_DragSession["DRAG_TYPE"]["H_RESIZE"];
			break;
		case this["sId"] + "-resizeHandleENE":
			if (window["UCF_System"]["bIsRTL"]) {
				this["sDragType"] = "resizeNNW";
			} else {
				this["sDragType"] = "resizeNNE";
			}
			sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
			break;
		case this["sId"] + "-resizeHandleESE":
			if (window["UCF_System"]["bIsRTL"]) {
				this["sDragType"] = "resizeWSW";
			} else {
				this["sDragType"] = "resizeESE";
			}
			sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
			break;
		case this["sId"] + "-resizeHandleS":
			this["sDragType"] = "resizeS";
			sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
			break;
		case this["sId"] + "-resizeHandleSSW":
			if (window["UCF_System"]["bIsRTL"]) {
				this["sDragType"] = "resizeSSE";
			} else {
				this["sDragType"] = "resizeSSW";
			}
			sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
			break;
		case this["sId"] + "-resizeHandleSSE":
			if (window["UCF_System"]["bIsRTL"]) {
				this["sDragType"] = "resizeSSW";
			} else {
				this["sDragType"] = "resizeSSE";
			}
			sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
			break;
		case this["sId"] + "-resizeHandleW":
			if (window["UCF_System"]["bIsRTL"]) {
				this["sDragType"] = "resizeE";
			} else {
				this["sDragType"] = "resizeW";
			}
			sDragType = UCF_DragSession["DRAG_TYPE"]["H_RESIZE"];
			break;
		case this["sId"] + "-resizeHandleWNW":
			if (window["UCF_System"]["bIsRTL"]) {
				this["sDragType"] = "resizeNNE";
			} else {
				this["sDragType"] = "resizeNNW";
			}
			sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
			break;
		case this["sId"] + "-resizeHandleWSW":
			if (window["UCF_System"]["bIsRTL"]) {
				this["sDragType"] = "resizeESE";
			} else {
				this["sDragType"] = "resizeWSW";
			}
			sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
			break;
		case this["sId"] + "-centerHeader":
			this["sDragType"] = "reposition";
			sDragType = UCF_DragSession["DRAG_TYPE"]["NONE"];
			this["bRepositioned"] = true;
			break;
		default:
			//sap_belize needs addtional DIV in order to implement grip font-icon
			var oSourceParent = oSource["parentNode"];
			if (oSourceParent && oSourceParent["getAttribute"]("id") === this["sId"] + "-resizeHandleS") {
				this["sDragType"] = "resizeS";
				sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
			}
			//TouchDevice Grip visualization
			if (oBrowserEvent["bIsTouchInteraction"]() === 'TOUCH') {
				var oResizeHandleSDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleS");
				if (UCF_DomUtil["bContains"](oResizeHandleSDiv, oSource)) {
					this["sDragType"] = "resizeS";
					sDragType = UCF_DragSession["DRAG_TYPE"]["V_RESIZE"];
				}
			}
			break;
	}

	if (oDragAndDropManager != null && this["sDragType"]) {
		oDragAndDropManager["startDragSession"](this["sId"], null, sDragType, null, null, null);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsdragstart"] = 0; };

/** Updates the visualisation of the active sash after mouse move
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageArea["prototype"]["onlsdrag"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsdrag"]++; }; 

	var iDeltaX = oBrowserEvent["iPageX"]() - this["iPageXStart"];
	var iDeltaY = oBrowserEvent["iPageY"]() - this["iPageYStart"];
	var bHandled = true;

	switch (this["sDragType"]) {
		case "resizeN":
			this["handleDragN"](iDeltaY);
			break;
		case "resizeNNW":
			this["handleDragN"](iDeltaY);
			this["handleDragW"](iDeltaX);
			break;
		case "resizeNNE":
			this["handleDragN"](iDeltaY);
			this["handleDragE"](iDeltaX);
			break;
		case "resizeE":
			this["handleDragE"](iDeltaX);
			break;
		case "resizeENE":
			this["handleDragN"](iDeltaY);
			this["handleDragE"](iDeltaX);
			break;
		case "resizeESE":
			this["handleDragS"](iDeltaY);
			this["handleDragE"](iDeltaX);
			break;
		case "resizeS":
			this["handleDragS"](iDeltaY);
			break;
		case "resizeSSW":
			this["handleDragS"](iDeltaY);
			this["handleDragW"](iDeltaX);
			break;
		case "resizeSSE":
			this["handleDragS"](iDeltaY);
			this["handleDragE"](iDeltaX);
			break;
		case "resizeW":
			this["handleDragW"](iDeltaX);
			break;
		case "resizeWNW":
			this["handleDragN"](iDeltaY);
			this["handleDragW"](iDeltaX);
			break;
		case "resizeWSW":
			this["handleDragS"](iDeltaY);
			this["handleDragW"](iDeltaX);
			break;
		case "reposition":
			if (this["bIsPinned"]) return;
			this["oCenterDiv"]["style"]["top"] = Math["max"](0, this["iTop"] + iDeltaY) + "px";
			this["oCenterDiv"]["style"]["left"] = Math["max"](0, this["iLeft"] + iDeltaX) + "px";
			this["updateBlindLayer"](this["iLeft"] + iDeltaX, this["iTop"] + iDeltaY);
			break;
		default:
			bHandled = false;
			break;
	}

	if (bHandled) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsdrag"] = 0; };

UCF_MessageArea["prototype"]["handleDragN"] = function(iDeltaY) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragN"]++; }; 

	if (this["bDetailOpen"]) {
		if ((this["iDetailHeight"] - iDeltaY) >= parseInt(this["oCenterDiv"]["style"]["minHeight"])) {
			this["oCenterDiv"]["style"]["top"] = (this["iTop"] + iDeltaY) + "px";
			this["oCenterDiv"]["style"]["height"] = (this["iDetailHeight"] - iDeltaY) + "px";
			this["oCenterContainerDiv"]["style"]["height"] = (this["iDetailHeight"] - iDeltaY - this["iCenterHeaderHeight"]) + "px";
		}
	} else {
		if (!this["bMsgWrapping"]) iDeltaY = Math["max"](iDeltaY, this["iHeight"] - parseInt(this["oCenterDiv"]["style"]["maxHeight"]));
		if ((this["iHeight"] - iDeltaY) >= parseInt(this["oCenterDiv"]["style"]["minHeight"])) {
			this["oCenterDiv"]["style"]["top"] = (this["iTop"] + iDeltaY) + "px";
			this["oCenterDiv"]["style"]["height"] = (this["iHeight"] - iDeltaY) + "px";
			this["oCenterContainerDiv"]["style"]["height"] = (this["iHeight"] - iDeltaY - this["iCenterHeaderHeight"]) + "px";
		}
	}
	if (this["bIsPinned"]) return;
	this["updateBlindLayer"](null, null, this["oCenterDiv"]["offsetWidth"], this["oCenterDiv"]["offsetHeight"]);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragN"] = 0; };

UCF_MessageArea["prototype"]["handleDragE"] = function(iDeltaX) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragE"]++; }; 

	this["oCenterDiv"]["style"]["width"] = (this["iWidth"] + iDeltaX) + "px";
	if (this["bIsPinned"]) return;
	this["updateBlindLayer"](null, null, this["oCenterDiv"]["offsetWidth"], this["oCenterDiv"]["offsetHeight"]);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragE"] = 0; };

UCF_MessageArea["prototype"]["handleDragS"] = function(iDeltaY) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragS"]++; }; 

	if (this["bDetailOpen"]) {
		this["oCenterDiv"]["style"]["height"] = (this["iDetailHeight"] + iDeltaY) + "px";
		this["oCenterContainerDiv"]["style"]["height"] = (this["iDetailHeight"] + iDeltaY - this["iCenterHeaderHeight"]) + "px";
	} else {
		this["oCenterDiv"]["style"]["height"] = (this["iHeight"] + iDeltaY) + "px";
		if (this["bIsPinned"]) {
			this["oCenterContainerDiv"]["style"]["height"] = (this["iHeight"] + iDeltaY - this["iCenterHeaderHeight"] - this["RESIZE_BAR_HEIGHT"]) + "px";
		} else {
			this["oCenterContainerDiv"]["style"]["height"] = (this["iHeight"] + iDeltaY - this["iCenterHeaderHeight"]) + "px";
		}
	}
	if (this["bIsPinned"]) {
		this["applyCenterContainerScrollbarClass"]();
		return;
	}
	this["updateBlindLayer"](null, null, this["oCenterDiv"]["offsetWidth"], this["oCenterDiv"]["offsetHeight"]);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragS"] = 0; };

UCF_MessageArea["prototype"]["handleDragW"] = function(iDeltaX) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragW"]++; }; 

	if ((this["iWidth"] - iDeltaX) >= this["MIN_WIDTH"]) {
		this["oCenterDiv"]["style"]["left"] = (this["iLeft"] + iDeltaX) + "px";
		this["oCenterDiv"]["style"]["width"] = (this["iWidth"] - iDeltaX) + "px";
	}
	if (this["bIsPinned"]) return;
	this["updateBlindLayer"](null, null, this["oCenterDiv"]["offsetWidth"], this["oCenterDiv"]["offsetHeight"]);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragW"] = 0; };

UCF_MessageArea["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsdragend"]++; }; 

	var iDeltaX = oBrowserEvent["iPageX"]() - this["iPageXStart"];
	var iDeltaY = oBrowserEvent["iPageY"]() - this["iPageYStart"];
	var bHandled = true;

	switch (this["sDragType"]) {
		case "resizeN":
			this["handleDragEndN"](iDeltaY);
			break;
		case "resizeNNW":
			this["handleDragEndN"](iDeltaY);
			this["handleDragEndW"](iDeltaX);
			break;
		case "resizeNNE":
			this["handleDragEndN"](iDeltaY);
			this["handleDragEndE"](iDeltaX);
			break;
		case "resizeE":
			this["handleDragEndE"](iDeltaX);
			break;
		case "resizeENE":
			this["handleDragEndN"](iDeltaY);
			this["handleDragEndE"](iDeltaX);
			break;
		case "resizeESE":
			this["handleDragEndS"](iDeltaY);
			this["handleDragEndE"](iDeltaX);
			break;
		case "resizeS":
			this["handleDragEndS"](iDeltaY);
			break;
		case "resizeSSW":
			this["handleDragEndS"](iDeltaY);
			this["handleDragEndW"](iDeltaX);
			break;
		case "resizeSSE":
			this["handleDragEndS"](iDeltaY);
			this["handleDragEndE"](iDeltaX);
			break;
		case "resizeW":
			this["handleDragEndW"](iDeltaX);
			break;
		case "resizeWNW":
			this["handleDragEndN"](iDeltaY);
			this["handleDragEndW"](iDeltaX);
			break;
		case "resizeWSW":
			this["handleDragEndS"](iDeltaY);
			this["handleDragEndW"](iDeltaX);
			break;
		case "reposition":
			if (this["bIsPinned"]) return;
			this["iTop"] += iDeltaY;
			this["iTop"] = Math["max"](0, this["iTop"]);
			this["oCenterDiv"]["style"]["top"] = this["iTop"] + "px";
			if (this["getClientControl"]()) {
				this["getClientControl"]()["setTop"](this["iTop"] + "px", true);
			}
			this["iLeft"] += iDeltaX;
			this["iLeft"] = Math["max"](0, this["iLeft"]);
			this["oCenterDiv"]["style"]["left"] = this["iLeft"] + "px";
			if (this["getClientControl"]()) {
				this["getClientControl"]()["setLeft"](this["iLeft"] + "px", true);
			}
			this["fireReposition"](this["sId"], this["iTop"], this["iLeft"]);
			this["updateBlindLayer"]();
			break;
		default:
			bHandled = false;
			break;
	}

	if (this["sDragType"]["indexOf"]("resize") !== -1) {
		var iHeight = this["iHeight"];
		if (this["bIsPinned"]) {
			iHeight = this["iHeight"] - this["RESIZE_BAR_HEIGHT"];
			this["applyCenterContainerScrollbarClass"]();
		}
		//fire always the height in unpinned state
		this["fireResize"](this["sId"], this["iWidth"], iHeight);
	}

	this["handleMouseUp"](oBrowserEvent);

	if (bHandled) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsdragend"] = 0; };

UCF_MessageArea["prototype"]["handleDragEndN"] = function(iDeltaY) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragEndN"]++; }; 

	if (this["bDetailOpen"]) {
		iDeltaY = Math["min"](iDeltaY, this["iDetailHeight"] - this["iCenterHeaderHeight"]);
		this["iTop"] += iDeltaY;
		this["iDetailHeight"] -= iDeltaY;
		this["oCenterDiv"]["style"]["height"] = this["iDetailHeight"] + "px";
		this["oCenterContainerDiv"]["style"]["height"] = (this["iDetailHeight"] - this["iCenterHeaderHeight"]) + "px";
	} else {
		iDeltaY = Math["min"](iDeltaY, this["iHeight"] - this["iCenterHeaderHeight"]);
		if (!this["bMsgWrapping"]) iDeltaY = Math["max"](iDeltaY, this["iHeight"] - parseInt(this["oCenterDiv"]["style"]["maxHeight"]));
		this["iTop"] += iDeltaY;
		this["iHeight"] -= iDeltaY;
		this["oCenterDiv"]["style"]["height"] = this["iHeight"] + "px";
		this["oCenterContainerDiv"]["style"]["height"] = (this["iHeight"] - this["iCenterHeaderHeight"]) + "px";
	}
	if (this["bIsPinned"]) return;
	this["updateBlindLayer"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragEndN"] = 0; };

UCF_MessageArea["prototype"]["handleDragEndE"] = function(iDeltaX) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragEndE"]++; }; 

	this["iWidth"] += iDeltaX;
	this["iWidth"] = Math["max"](this["iWidth"], this["MIN_WIDTH"]);
	this["oCenterDiv"]["style"]["width"] = this["iWidth"] + "px";
	if (this["bIsPinned"]) return;
	this["updateBlindLayer"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragEndE"] = 0; };

UCF_MessageArea["prototype"]["handleDragEndS"] = function(iDeltaY) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragEndS"]++; }; 

	if (this["bDetailOpen"]) {
		this["oCenterDiv"]["style"]["height"] = (this["iDetailHeight"] + iDeltaY) + "px";
		this["oCenterContainerDiv"]["style"]["height"] = (this["iDetailHeight"] + iDeltaY - this["iCenterHeaderHeight"]) + "px";
	} else {
		this["iHeight"] += iDeltaY;
		if (!this["bMsgWrapping"]) this["iHeight"] = Math["min"](this["iHeight"], parseInt(this["oCenterDiv"]["style"]["maxHeight"]));
		this["iHeight"] = Math["max"](this["iHeight"], this["iCenterHeaderHeight"]);
		this["oCenterDiv"]["style"]["height"] = this["iHeight"] + "px";
		if (this["bIsPinned"]) {
			this["oCenterContainerDiv"]["style"]["height"] = (this["iHeight"] - this["iCenterHeaderHeight"] - this["RESIZE_BAR_HEIGHT"]) + "px";
		} else {
			this["oCenterContainerDiv"]["style"]["height"] = (this["iHeight"] - this["iCenterHeaderHeight"]) + "px";
		}
	}
	if (this["bIsPinned"]) return;
	this["updateBlindLayer"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragEndS"] = 0; };

UCF_MessageArea["prototype"]["handleDragEndW"] = function(iDeltaX) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragEndW"]++; }; 

	iDeltaX = Math["min"](iDeltaX, this["iWidth"] - this["MIN_WIDTH"]);
	this["iLeft"] += iDeltaX;
	this["iWidth"] -= iDeltaX;
	this["oCenterDiv"]["style"]["left"] = this["iLeft"] + "px";
	this["oCenterDiv"]["style"]["width"] = this["iWidth"] + "px";
	if (this["bIsPinned"]) return;
	this["updateBlindLayer"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleDragEndW"] = 0; };

UCF_MessageArea["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlstouchstart"]++; }; 
	this["onmousedown"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlstouchstart"] = 0; };

UCF_MessageArea["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onmousedown"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	//Notifier Down
	if (UCF_DomUtil["bContains"](this["oNotifierDiv"], oSource)) {
		if (UCF_DomUtil["bHasClass"](this["oNotifierDiv"], "lsMANotifier")) {
			UCF_DomUtil["replaceClass"](this["oNotifierDiv"], "lsMANotifier", "lsMANotifierD");
		}
		if (UCF_DomUtil["bHasClass"](this["oNotifierDiv"], "lsMANotifierSingle")) {
			UCF_DomUtil["replaceClass"](this["oNotifierDiv"], "lsMANotifierSingle", "lsMANotifierSingleD");
		}
	}
	//Close button Down
	if (UCF_DomUtil["bContains"](this["oCollapseDiv"], oSource)) {
		UCF_DomUtil["replaceClass"](this["oCollapseDiv"], "lsMACollapseIcon", "lsMACollapseIconD");
	}
	//ResizeHandleSGrip Down
	var oResizeHandleSDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleS");
	if (UCF_DomUtil["bContains"](oResizeHandleSDiv, oSource)) {
		UCF_DomUtil["addClass"](oResizeHandleSDiv, "lsMAResizeHandleActivated");
		var oTouchHandle = UCF_DomUtil["$"](this["sId"] + "-resizeHandleS-TOUCH");
		if (oTouchHandle) UCF_DomUtil["addClass"](oTouchHandle, "lsSpTableVisTouchHandleActivated");
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onmousedown"] = 0; };

UCF_MessageArea["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlstouchend"]++; }; 
	this["onmouseup"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlstouchend"] = 0; };

UCF_MessageArea["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onmouseup"]++; }; 
	this["handleMouseUp"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onmouseup"] = 0; };

UCF_MessageArea["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onmouseout"]++; }; 
	this["handleMouseUp"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onmouseout"] = 0; };

UCF_MessageArea["prototype"]["handleMouseUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleMouseUp"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	//Notifier Up
	if (UCF_DomUtil["bContains"](this["oNotifierDiv"], oSource)) {

		if (UCF_DomUtil["bHasClass"](this["oNotifierDiv"], "lsMANotifierD")) {
			UCF_DomUtil["replaceClass"](this["oNotifierDiv"], "lsMANotifierD", "lsMANotifier");
		}
		if (UCF_DomUtil["bHasClass"](this["oNotifierDiv"], "lsMANotifierSingleD")) {
			UCF_DomUtil["replaceClass"](this["oNotifierDiv"], "lsMANotifierSingleD", "lsMANotifierSingle");
		}
	}
	//Close button Up
	if (UCF_DomUtil["bContains"](this["oCollapseDiv"], oSource)) {
		UCF_DomUtil["replaceClass"](this["oCollapseDiv"], "lsMACollapseIconD", "lsMACollapseIcon");
	}
	//ResizeHandleSGrip Up
	var oResizeHandleSDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleS");
	if (UCF_DomUtil["bContains"](oResizeHandleSDiv, oSource)) {
		UCF_DomUtil["removeClass"](oResizeHandleSDiv, "lsMAResizeHandleActivated");
		var oTouchHandle = UCF_DomUtil["$"](this["sId"] + "-resizeHandleS-TOUCH");
		if (oTouchHandle) UCF_DomUtil["removeClass"](oTouchHandle, "lsSpTableVisTouchHandleActivated");
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleMouseUp"] = 0; };

UCF_MessageArea["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onclick"]++; }; 
	this["handleClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onclick"] = 0; };

UCF_MessageArea["prototype"]["handleClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleClick"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var oMessage = null;
	switch (oSource["getAttribute"]("id")) {
		case this["sId"] + "-togglePin":
			this["togglePin"](oBrowserEvent);
			break;
		case this["sId"] + "-collapse":
			this["handleClose"](oBrowserEvent);
			if (this["bIsPinned"]) {
				this["togglePin"](oBrowserEvent);
			}
			break;
		case this["sId"] + "-notifier":
			if (this["sMessageMode"] === "SINGLE" && this["sContentAccessId"]) {
				this["expand"](true, true);
				oMessage = this["oLS"]["oControlFactory"]["oGetControlById"](this["sContentAccessId"]);
				oMessage["showDetail"]();
				this["showDetail"](this["sContentAccessId"]);
			} else {
				this["expand"](true, true);
			}
			break;
		case this["sId"] + "-back":
			this["back"]();
			break;
		default:
			break;
	}

	if (UCF_DomUtil["bContains"](this["oFilterAllDiv"], oSource)) {
		this["filterAll"]();
	}

	if (UCF_DomUtil["bContains"](this["oFilterErrorDiv"], oSource)) {
		this["filterError"]();
	}

	if (UCF_DomUtil["bContains"](this["oFilterWarningDiv"], oSource)) {
		this["filterWarning"]();
	}

	if (UCF_DomUtil["bContains"](this["oFilterInfoDiv"], oSource)) {
		this["filterInfo"]();
	}

	if (UCF_DomUtil["bContains"](this["oFilterSuccessDiv"], oSource)) {
		this["filterSuccess"]();
	}

	if (UCF_DomUtil["bContains"](this["oNotifierDiv"], oSource)) {
		if (this["sMessageMode"] === "SINGLE" && this["sContentAccessId"]) {
			this["expand"](true, true);
			oMessage = this["oLS"]["oControlFactory"]["oGetControlById"](this["sContentAccessId"]);
			oMessage["showDetail"]();
			this["showDetail"](this["sContentAccessId"]);
		} else {
			this["expand"](true, true);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleClick"] = 0; };

/**
 * Handles the onlsselect event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageArea["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsselect"]++; }; 
	this["handleClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsselect"] = 0; };

UCF_MessageArea["prototype"]["onlsselectmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsselectmodifier"]++; }; 

	//close message detail at shift enter
	if (this["oMessage"] && this["sMessageMode"] === "MULTI") {
		this["back"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsselectmodifier"] = 0; };

UCF_MessageArea["prototype"]["resetFilter"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilter"]++; }; 
	switch (this["sCurrentFilter"]) {
		case "all":
			this["resetFilterAll"]();
			break;
		case "error":
			this["resetFilterError"]();
			break;
		case "warning":
			this["resetFilterWarning"]();
			break;
		case "info":
			this["resetFilterInfo"]();
			break;
		case "success":
			this["resetFilterSuccess"]();
			break;
		default:
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilter"] = 0; };

// eslint-disable-next-line consistent-return
UCF_MessageArea["prototype"]["iGetCurrentMessageCount"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["iGetCurrentMessageCount"]++; }; 
	switch (this["sCurrentFilter"]) {
		case "all":
			return this["iMsgCount"];
		case "error":
			return this["iErrorMsgCount"];
		case "warning":
			return this["iWarningMsgCount"];
		case "info":
			return this["iInfoMsgCount"];
		case "success":
			return this["iSuccessMsgCount"];
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["iGetCurrentMessageCount"] = 0; };

UCF_MessageArea["prototype"]["adjustCenterHeight"] = function(iMsgCount) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["adjustCenterHeight"]++; }; 
	if (this["bMsgWrapping"]) return;
	var iMaxHeight = this["iCenterHeaderHeight"] + (iMsgCount * this["iMessageHeight"]);
	if (this["bIsPinned"]) iMaxHeight += this["RESIZE_BAR_HEIGHT"];
	var iHeight = Math["min"](this["iHeight"], iMaxHeight);
	if (this["bAdjustHeight"] || !this["bIsPinned"]) {
		this["oCenterDiv"]["style"]["maxHeight"] = iMaxHeight + "px";
		this["oCenterDiv"]["style"]["height"] = iHeight + "px";
	}
	this["oCenterContainerDiv"]["style"]["height"] = (iHeight - this["iCenterHeaderHeight"]) + "px";
	this["oCenterContainerDiv"]["style"]["maxHeight"] = (iMsgCount * this["iMessageHeight"]) + "px";
	this["updateBlindLayer"](null, null, null, iHeight);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["adjustCenterHeight"] = 0; };

UCF_MessageArea["prototype"]["filterAll"] = function(bForce) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["filterAll"]++; }; 
	if (!bForce && this["sCurrentFilter"] === "all") return;
	this["resetFilter"]();
	UCF_DomUtil["replaceClass"](this["oFilterAllDiv"], "lsMAFilterAllButton", "lsMAFilterButtonDown");
	this["sCurrentFilter"] = "all";
	UCF_DomUtil["setTabIndex"](this["oFilterAllDiv"], 0);
	if (window["UCF_System"]["bIsAria"]) {
		this["oFilterAllDiv"]["setAttribute"]("aria-checked", true);
	}
	this["fireEvent"](this["E_EVENTS"]["FilterAll"]);

	this["adjustCenterHeight"](this["iMsgCount"]);

	this["fireFilter"](this["sId"], "ALL");
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["filterAll"] = 0; };

UCF_MessageArea["prototype"]["resetFilterAll"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilterAll"]++; }; 
	UCF_DomUtil["replaceClass"](this["oFilterAllDiv"], "lsMAFilterButtonDown", "lsMAFilterAllButton");
	UCF_DomUtil["setTabIndex"](this["oFilterAllDiv"], -1);
	if (window["UCF_System"]["bIsAria"]) {
		this["oFilterAllDiv"]["setAttribute"]("aria-checked", false);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilterAll"] = 0; };

UCF_MessageArea["prototype"]["filterError"] = function(bForce) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["filterError"]++; }; 
	if (!bForce && this["sCurrentFilter"] === "error") return;
	this["resetFilter"]();
	UCF_DomUtil["replaceClass"](this["oFilterErrorDiv"], "lsMAFilterButton", "lsMAFilterButtonDown");
	UCF_DomUtil["removeClass"](this["oFilterErrorDiv"]["firstChild"], "lsMAFilterCounterColor");
	this["sCurrentFilter"] = "error";
	UCF_DomUtil["setTabIndex"](this["oFilterErrorDiv"], 0);
	if (window["UCF_System"]["bIsAria"]) {
		this["oFilterErrorDiv"]["setAttribute"]("aria-checked", true);
	}
	this["fireEvent"](this["E_EVENTS"]["FilterError"]);

	this["adjustCenterHeight"](this["iErrorMsgCount"]);

	this["fireFilter"](this["sId"], "ERROR");
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["filterError"] = 0; };

UCF_MessageArea["prototype"]["resetFilterError"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilterError"]++; }; 
	UCF_DomUtil["replaceClass"](this["oFilterErrorDiv"], "lsMAFilterButtonDown", "lsMAFilterButton");
	UCF_DomUtil["addClass"](this["oFilterErrorDiv"]["firstChild"], "lsMAFilterCounterColor");
	UCF_DomUtil["setTabIndex"](this["oFilterErrorDiv"], -1);
	if (window["UCF_System"]["bIsAria"]) {
		this["oFilterErrorDiv"]["setAttribute"]("aria-checked", false);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilterError"] = 0; };

UCF_MessageArea["prototype"]["filterWarning"] = function(bForce) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["filterWarning"]++; }; 
	if (!bForce && this["sCurrentFilter"] === "warning") return;
	this["resetFilter"]();
	UCF_DomUtil["replaceClass"](this["oFilterWarningDiv"], "lsMAFilterButton", "lsMAFilterButtonDown");
	UCF_DomUtil["removeClass"](this["oFilterWarningDiv"]["firstChild"], "lsMAFilterCounterColor");
	this["sCurrentFilter"] = "warning";
	UCF_DomUtil["setTabIndex"](this["oFilterWarningDiv"], 0);
	if (window["UCF_System"]["bIsAria"]) {
		this["oFilterWarningDiv"]["setAttribute"]("aria-checked", true);
	}
	this["fireEvent"](this["E_EVENTS"]["FilterWarning"]);

	this["adjustCenterHeight"](this["iWarningMsgCount"]);

	this["fireFilter"](this["sId"], "WARNING");
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["filterWarning"] = 0; };

UCF_MessageArea["prototype"]["resetFilterWarning"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilterWarning"]++; }; 
	UCF_DomUtil["replaceClass"](this["oFilterWarningDiv"], "lsMAFilterButtonDown", "lsMAFilterButton");
	UCF_DomUtil["addClass"](this["oFilterWarningDiv"]["firstChild"], "lsMAFilterCounterColor");
	UCF_DomUtil["setTabIndex"](this["oFilterWarningDiv"], -1);
	if (window["UCF_System"]["bIsAria"]) {
		this["oFilterWarningDiv"]["setAttribute"]("aria-checked", false);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilterWarning"] = 0; };

UCF_MessageArea["prototype"]["filterInfo"] = function(bForce) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["filterInfo"]++; }; 
	if (!bForce && this["sCurrentFilter"] === "info") return;
	this["resetFilter"]();
	UCF_DomUtil["replaceClass"](this["oFilterInfoDiv"], "lsMAFilterButton", "lsMAFilterButtonDown");
	UCF_DomUtil["removeClass"](this["oFilterInfoDiv"]["firstChild"], "lsMAFilterCounterColor");
	this["sCurrentFilter"] = "info";
	UCF_DomUtil["setTabIndex"](this["oFilterInfoDiv"], 0);
	if (window["UCF_System"]["bIsAria"]) {
		this["oFilterInfoDiv"]["setAttribute"]("aria-checked", true);
	}
	this["fireEvent"](this["E_EVENTS"]["FilterInfo"]);

	this["adjustCenterHeight"](this["iInfoMsgCount"]);

	this["fireFilter"](this["sId"], "INFO");
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["filterInfo"] = 0; };

UCF_MessageArea["prototype"]["resetFilterInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilterInfo"]++; }; 
	UCF_DomUtil["replaceClass"](this["oFilterInfoDiv"], "lsMAFilterButtonDown", "lsMAFilterButton");
	UCF_DomUtil["addClass"](this["oFilterInfoDiv"]["firstChild"], "lsMAFilterCounterColor");
	UCF_DomUtil["setTabIndex"](this["oFilterInfoDiv"], -1);
	if (window["UCF_System"]["bIsAria"]) {
		this["oFilterInfoDiv"]["setAttribute"]("aria-checked", false);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilterInfo"] = 0; };

UCF_MessageArea["prototype"]["filterSuccess"] = function(bForce) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["filterSuccess"]++; }; 
	if (!bForce && this["sCurrentFilter"] === "success") return;
	this["resetFilter"]();
	UCF_DomUtil["replaceClass"](this["oFilterSuccessDiv"], "lsMAFilterButton", "lsMAFilterButtonDown");
	UCF_DomUtil["removeClass"](this["oFilterSuccessDiv"]["firstChild"], "lsMAFilterCounterColor");
	this["sCurrentFilter"] = "success";
	UCF_DomUtil["setTabIndex"](this["oFilterSuccessDiv"], 0);
	if (window["UCF_System"]["bIsAria"]) {
		this["oFilterSuccessDiv"]["setAttribute"]("aria-checked", true);
	}
	this["fireEvent"](this["E_EVENTS"]["FilterSuccess"]);

	this["adjustCenterHeight"](this["iSuccessMsgCount"]);

	this["fireFilter"](this["sId"], "SUCCESS");
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["filterSuccess"] = 0; };

UCF_MessageArea["prototype"]["resetFilterSuccess"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilterSuccess"]++; }; 
	UCF_DomUtil["replaceClass"](this["oFilterSuccessDiv"], "lsMAFilterButtonDown", "lsMAFilterButton");
	UCF_DomUtil["addClass"](this["oFilterSuccessDiv"]["firstChild"], "lsMAFilterCounterColor");
	UCF_DomUtil["setTabIndex"](this["oFilterSuccessDiv"], -1);
	if (window["UCF_System"]["bIsAria"]) {
		this["oFilterSuccessDiv"]["setAttribute"]("aria-checked", false);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetFilterSuccess"] = 0; };

UCF_MessageArea["prototype"]["reapplyFilter"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["reapplyFilter"]++; }; 
	switch (this["sCurrentFilter"]) {
		case "all":
			this["filterAll"](true);
			break;
		case "error":
			this["filterError"](true);
			break;
		case "warning":
			this["filterWarning"](true);
			break;
		case "info":
			this["filterInfo"](true);
			break;
		case "success":
			this["filterSuccess"](true);
			break;
		default:
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["reapplyFilter"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event for touch check
 */
UCF_MessageArea["prototype"]["togglePin"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["togglePin"]++; }; 
	if (this["bIsPinned"]) {
		this["unpin"](oBrowserEvent);
	} else {
		this["pin"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["togglePin"] = 0; };

UCF_MessageArea["prototype"]["resetCenter"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetCenter"]++; }; 

	this["oCenterDiv"]["style"]["transition"] = "all 0s";

	if (!this["bMsgWrapping"]) {
		if (this["bAdjustHeight"] || !this["bIsPinned"] || (this["iMsgCount"] > this["iVisibleMessageCount"])) {
			this["oCenterDiv"]["style"]["maxHeight"] = ((this["iMsgCount"] * this["iMessageHeight"]) + this["iCenterHeaderHeight"]) + "px";
		} else {
			this["oCenterDiv"]["style"]["maxHeight"] = ((this["iVisibleMessageCount"] * this["iMessageHeight"]) + this["iCenterHeaderHeight"]) + "px";
		}
		this["oCenterContainerDiv"]["style"]["maxHeight"] = (this["iMsgCount"] * this["iMessageHeight"]) + "px";
		if (this["bIsPinned"]) {
			//		in pinned state add resizeBarHeight
			this["oCenterDiv"]["style"]["maxHeight"] = parseInt(this["oCenterDiv"]["style"]["maxHeight"]) + this["RESIZE_BAR_HEIGHT"] + "px";
		}
	}

	this["oBackDiv"]["style"]["display"] = "none";
	this["oFilterAllDiv"]["style"]["display"] = "inline-block";
	if (this["iErrorMsgCount"] === 0) {
		this["oFilterErrorDiv"]["style"]["display"] = "none";
	} else {
		this["oFilterErrorDiv"]["style"]["display"] = "inline-block";
	}
	if (this["iWarningMsgCount"] === 0) {
		this["oFilterWarningDiv"]["style"]["display"] = "none";
	} else {
		this["oFilterWarningDiv"]["style"]["display"] = "inline-block";
	}
	if (this["iInfoMsgCount"] === 0) {
		this["oFilterInfoDiv"]["style"]["display"] = "none";
	} else {
		this["oFilterInfoDiv"]["style"]["display"] = "inline-block";
	}
	if (this["iSuccessMsgCount"] === 0) {
		this["oFilterSuccessDiv"]["style"]["display"] = "none";
	} else {
		this["oFilterSuccessDiv"]["style"]["display"] = "inline-block";
	}

	if (this["bIsPinned"] && this["bAllowUnpin"] || !this["bIsPinned"] && this["bAllowPin"]) {
		this["oTogglePinDiv"]["style"]["display"] = "inline-block";
	} else {
		this["oTogglePinDiv"]["style"]["display"] = "none";
	}

	if (this["bDetailOpen"] && this["oMessage"]) {
		this["oMessage"]["hideDetail"]();
		this["bDetailOpen"] = false;
	}

	this["reapplyFilter"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["resetCenter"] = 0; };

UCF_MessageArea["prototype"]["collapse"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["collapse"]++; }; 

	this["releaseBlindLayer"]();

	//collapse in pinned state leads to rerendering at server side -> do nothing at client
	if (this["bIsPinned"] && this["bHasPinSubmitListener"]()) {
		this["fireCollapse"](this["sId"]);
		return;
	}

	this["oCenterDiv"]["style"]["minHeight"] = "";
	if (this["bDetailOpen"]) {
		this["oCenterDiv"]["style"]["transition"] = "height 500ms";
	} else {
		this["oCenterDiv"]["style"]["transition"] = "all 500ms";
	}

	this["oCenterDiv"]["style"]["height"] = "0px";
	this["oCenterDiv"]["style"]["opacity"] = "0";
	this["oCenterDiv"]["style"]["visibility"] = "hidden";
	this["oNotifierDiv"]["style"]["display"] = "block";

	var oNotifierRect = this["oGetObjectRect"](this["oNotifierDiv"]);
	var iCLientWidth = UCF_DomUtil["iClientWidth"]();
	var iCLientHeight = UCF_DomUtil["iClientHeight"]();

	if (oNotifierRect["left"] < iCLientWidth / 2) {
		this["iLeft"] = oNotifierRect["left"];
	} else {
		this["iLeft"] = oNotifierRect["left"] + oNotifierRect["width"] - this["iWidth"];
	}
	if (oNotifierRect["top"] < iCLientHeight / 2) {
		this["iTop"] = oNotifierRect["top"] + oNotifierRect["height"];
	} else {
		this["iTop"] = oNotifierRect["top"] - this["iHeight"];
	}
	this["oCenterDiv"]["style"]["top"] = this["iTop"] + "px";
	this["oCenterDiv"]["style"]["left"] = this["iLeft"] + "px";

	this["fireCollapse"](this["sId"]);
	this["bIsOpened"] = false;
	this["setClientProperty"]("IsOpened", this["bIsOpened"], true);

	if (this["bDetailOpen"] && this["oMessage"]) {
		this["back"]();
		this["oCenterDiv"]["style"]["height"] = "0px";
		this["releaseBlindLayer"]();
	}

	this["resetNavigation"]();

	//focus notifier
	UCF_DomUtil["focusDomElement"](this["oNotifierDiv"]);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["collapse"] = 0; };

UCF_MessageArea["prototype"]["expand"] = function(bAnimate, bStick) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["expand"]++; }; 

	if (this["iMsgCount"] === 0) return;

	if (!this["bInitialized"]) {
		this["initInternal"]();
	}

	this["oCenterDiv"]["style"]["minHeight"] = this["iCenterHeaderHeight"] + "px";
	if (bAnimate) {
		this["oCenterDiv"]["style"]["transition"] = "opacity 500ms, height 500ms";
	} else {
		this["oCenterDiv"]["style"]["transition"] = "all 0s";
	}
	if (this["bIsPinned"]) {
		this["oCenterDiv"]["style"]["width"] = "100%";
	} else {
		this["oCenterDiv"]["style"]["width"] = this["iWidth"] + "px";
	}
	this["oCenterDiv"]["style"]["visibility"] = "visible";
	this["oCenterDiv"]["style"]["opacity"] = "1";

	if (this["bDetailOpen"]) {
		this["oCenterDiv"]["style"]["height"] = "auto";
		this["oCenterContainerDiv"]["style"]["height"] = "auto";
		this["iDetailHeight"] = this["oCenterDiv"]["offsetHeight"];
	} else {
		this["oCenterDiv"]["style"]["height"] = this["iHeight"] + "px";
		if (this["bIsPinned"]) {
			this["oCenterContainerDiv"]["style"]["height"] = (this["iHeight"] - this["iCenterHeaderHeight"] - this["RESIZE_BAR_HEIGHT"]) + "px";
		} else {
			this["oCenterContainerDiv"]["style"]["height"] = (this["iHeight"] - this["iCenterHeaderHeight"]) + "px";
		}
	}

	if (bStick) {
		this["stick"]();
	}

	this["fireExpand"](this["sId"]);
	this["bIsOpened"] = true;
	this["setClientProperty"]("IsOpened", this["bIsOpened"], true);

	this["setNavigation"]();
	//focus first message
	UCF_DomUtil["focusDomElement"](UCF_DomUtil["oGetFirstFocusableDomRef"](this["oCenterContainerDiv"]));

	if (!this["bIsPinned"]) {
		this["updateBlindLayer"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["expand"] = 0; };

UCF_MessageArea["prototype"]["stick"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["stick"]++; }; 

	if (!this["bIsValid"]() || !this["bInitialized"]) return;

	var oNotifierRect = this["oGetObjectRect"](this["oNotifierDiv"]);
	var oResizeHandleNNEDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleNNE");
	var oResizeHandleSSWDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleSSW");
	var oCenterHeaderDiv = UCF_DomUtil["$"](this["sId"] + "-centerHeader");
	var iCLientWidth = UCF_DomUtil["iClientWidth"]();
	var iCLientHeight = UCF_DomUtil["iClientHeight"]();

	if (oNotifierRect["left"] < iCLientWidth / 2) {
		this["iLeft"] = oNotifierRect["left"];
	} else {
		this["iLeft"] = oNotifierRect["left"] + oNotifierRect["width"] - this["iWidth"];
	}
	if (oNotifierRect["top"] < iCLientHeight / 2) {
		this["iTop"] = oNotifierRect["top"] + oNotifierRect["height"];
	} else {
		if (this["bDetailOpen"]) {
			this["iTop"] = oNotifierRect["top"] - this["iDetailHeight"];
		} else {
			this["iTop"] = oNotifierRect["top"] - this["iHeight"];
		}
	}

	// add resize icon at top right/bottom left corner depending on relative position to notifier (diagional)
	if (window["UCF_System"]["bIsRTL"]) {
		if ((oNotifierRect["left"] >= iCLientWidth / 2) && (oNotifierRect["top"] >= iCLientHeight / 2)) {
			if (oResizeHandleNNEDiv && !UCF_DomUtil["bHasClass"](oResizeHandleNNEDiv, "lsMAResizeIconNNERTL")) {
				UCF_DomUtil["addClass"](oResizeHandleNNEDiv, "lsMAResizeIconNNERTL");
			}
			if (oCenterHeaderDiv && !UCF_DomUtil["bHasClass"](oCenterHeaderDiv, "lsMACenterHeaderPaddingRI")) {
				UCF_DomUtil["addClass"](oCenterHeaderDiv, "lsMACenterHeaderPaddingRI");
			}
		}
		if ((oNotifierRect["left"] < iCLientWidth / 2) && (oNotifierRect["top"] < iCLientHeight / 2)) {
			if (oResizeHandleNNEDiv && !UCF_DomUtil["bHasClass"](oResizeHandleSSWDiv, "lsMAResizeIconSSWRTL")) {
				UCF_DomUtil["addClass"](oResizeHandleSSWDiv, "lsMAResizeIconSSWRTL");
			}
		}
	}
	else {
		if ((oNotifierRect["left"] < iCLientWidth / 2) && (oNotifierRect["top"] >= iCLientHeight / 2)) {
			if (oResizeHandleNNEDiv && !UCF_DomUtil["bHasClass"](oResizeHandleNNEDiv, "lsMAResizeIconNNE")) {
				UCF_DomUtil["addClass"](oResizeHandleNNEDiv, "lsMAResizeIconNNE");
			}
			if (oCenterHeaderDiv && !UCF_DomUtil["bHasClass"](oCenterHeaderDiv, "lsMACenterHeaderPaddingRI")) {
				UCF_DomUtil["addClass"](oCenterHeaderDiv, "lsMACenterHeaderPaddingRI");
			}
		}
		if ((oNotifierRect["left"] >= iCLientWidth / 2) && (oNotifierRect["top"] < iCLientHeight / 2)) {
			if (oResizeHandleNNEDiv && !UCF_DomUtil["bHasClass"](oResizeHandleSSWDiv, "lsMAResizeIconSSW")) {
				UCF_DomUtil["addClass"](oResizeHandleSSWDiv, "lsMAResizeIconSSW");
			}
		}
	}

	if (this["bIsOpened"]) {
		this["oCenterDiv"]["style"]["transition"] = "all 500ms";
	} else {
		this["oCenterDiv"]["style"]["transition"] = "opacity 500ms, height 500ms";
	}

	this["oCenterDiv"]["style"]["top"] = this["iTop"] + "px";
	this["oCenterDiv"]["style"]["left"] = this["iLeft"] + "px";

	this["bRepositioned"] = false;

	//	Reset top/left position at server - use  9999 instead of -1 because css size check
	this["fireReposition"](this["sId"], 9999, 9999);
	this["updateBlindLayer"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["stick"] = 0; };

UCF_MessageArea["prototype"]["back"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["back"]++; }; 

	this["resetCenter"]();

	//Position fixed in unpinned state -> reset this.iHeight and this.iTop
	if (!this["bIsPinned"]) {
		var oNotifierRect = this["oGetObjectRect"](this["oNotifierDiv"]);
		var iCLientHeight = UCF_DomUtil["iClientHeight"]();
		if ((oNotifierRect["top"] >= iCLientHeight / 2) && !this["bRepositioned"]) {
			if (this["bMsgWrapping"]) this["iTop"] = oNotifierRect["top"] - this["iHeight"];
			else this["iTop"] = oNotifierRect["top"] - this["oCenterDiv"]["offsetHeight"];
			this["oCenterDiv"]["style"]["top"] = this["iTop"] + "px";
		}
	}
	this["oCenterDiv"]["style"]["height"] = this["iHeight"] + "px";
	if (this["bIsPinned"]) {
		this["oCenterContainerDiv"]["style"]["height"] = (this["iHeight"] - this["iCenterHeaderHeight"] - this["RESIZE_BAR_HEIGHT"]) + "px";
	} else {
		this["oCenterContainerDiv"]["style"]["height"] = (this["iHeight"] - this["iCenterHeaderHeight"]) + "px";
	}

	// Chrome53++ does not correctly absolute position the resize bar
	// trigger repainting
	if (UCF_UserAgent["bIsChromium"](53) && this["bIsPinned"]) {
		this["oCenterContainerDiv"]["style"]["display"] = "none";
		// eslint-disable-next-line no-unused-expressions
		this["oCenterContainerDiv"]["offsetHeight"];
		this["oCenterContainerDiv"]["style"]["display"] = "block";
	}

	//	UCF_DomUtil.focusDomElement(this.oCenterDiv);
	if (this["oMessage"]) {
		UCF_DomUtil["focusDomElement"](this["oMessage"]["oDomRef"]);
		this["oMessage"]["oDomRef"]["scrollIntoView"](false);
		this["refocus"](this["oMessage"]["oDomRef"]);
		this["oMessage"] = null;
	}
	this["updateBlindLayer"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["back"] = 0; };

/**
 * Set Pinned
 *
 * @param { UCF_BrowserEvent } oBrowserEvent the event for touch check
 * @private
 */
UCF_MessageArea["prototype"]["pin"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["pin"]++; }; 

	this["firePin"](this["sId"]);
	this["fireReposition"](this["sId"], this["iTop"], this["iLeft"]);
	this["releaseBlindLayer"]();
	if (this["oDomRef"])
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsMessageArea--ispinned');

	if (this["bHasPinSubmitListener"]()) return;

	var oResizeHandleNDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleN");
	var oResizeHandleSDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleS");
	var oResizeHandleEDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleE");
	var oResizeHandleSSEDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleSSE");
	var oResizeHandleSSWDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleSSW");
	var oResizeHandleWDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleW");
	var oResizeHandleSTouchPinDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleS-TOUCHPIN");
	var oResizeHandleSTouchNotPinDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleS-TOUCHNOTPIN");

	oResizeHandleNDiv["style"]["display"] = "none";
	oResizeHandleEDiv["style"]["display"] = "none";
	oResizeHandleSSEDiv["style"]["display"] = "none";
	oResizeHandleSSWDiv["style"]["display"] = "none";
	oResizeHandleWDiv["style"]["display"] = "none";
	if (oResizeHandleSTouchPinDiv) oResizeHandleSTouchPinDiv["style"]["display"] = "block";
	if (oResizeHandleSTouchNotPinDiv) oResizeHandleSTouchNotPinDiv["style"]["display"] = "none";
	if (oBrowserEvent["bIsTouchInteraction"]()) this["oCenterDiv"]["style"]["overflow"] = "visible";

	UCF_DomUtil["addClass"](oResizeHandleSDiv, "urSpTHs");

	if (window["UCF_System"]["bIs508"]) {
		UCF_DomUtil["setTabIndex"](this["oCenterDiv"], 0);
	}
	UCF_DomUtil["setTabIndex"](this["oNotifierDiv"], -1);

	this["oCenterDiv"]["style"]["position"] = "relative";
	this["oCenterDiv"]["style"]["boxShadow"] = "0px 0px 0px 0px transparent";
	this["oNotifierDiv"]["style"]["display"] = "none";

	UCF_DomUtil["replaceClass"](this["oTogglePinDiv"], "lsMAPinIcon", "lsMAUnPinIcon");
	this["oTogglePinDiv"]["setAttribute"]("title", this["oLS"]["sGetText"]("SAPUR_MA_UNPIN_TT"));
	this["oTogglePinDiv"]["setAttribute"]("aria-label", this["oLS"]["sGetText"]("SAPUR_MA_UNPIN_TT"));
	if (this["bAllowUnpin"]) {
		this["oTogglePinDiv"]["style"]["display"] = "'inline-block'";
		this["oCollapseDiv"]["style"]["display"] = "";
	} else {
		this["oTogglePinDiv"]["style"]["display"] = "none";
		this["oCollapseDiv"]["style"]["display"] = "none";
	}

	var iCurrentMsgCount = this["iGetCurrentMessageCount"]();
	//	in pinned state add resizeBarHeight
	if (!this["bAdjustHeight"] && (iCurrentMsgCount < this["iVisibleMessageCount"])) {
		if (!this["bMsgWrapping"]) this["oCenterDiv"]["style"]["maxHeight"] = ((this["iVisibleMessageCount"] * this["iMessageHeight"]) + this["iCenterHeaderHeight"] + this["RESIZE_BAR_HEIGHT"]) + "px";
		this["oCenterDiv"]["style"]["height"] = ((this["iVisibleMessageCount"] * this["iMessageHeight"]) + this["iCenterHeaderHeight"] + this["RESIZE_BAR_HEIGHT"]) + "px";
		this["oCenterDiv"]["style"]["minHeight"] = this["iCenterHeaderHeight"] + this["RESIZE_BAR_HEIGHT"] + "px";
		this["oCenterContainerDiv"]["style"]["height"] = (this["iVisibleMessageCount"] * this["iMessageHeight"]) + "px";
		if (!this["bMsgWrapping"]) this["oCenterContainerDiv"]["style"]["maxHeight"] = (iCurrentMsgCount * this["iMessageHeight"]) + "px";
	} else {
		if (!this["bMsgWrapping"]) this["oCenterDiv"]["style"]["maxHeight"] = (parseInt(this["oCenterDiv"]["style"]["maxHeight"]) + this["RESIZE_BAR_HEIGHT"]) + "px";
		this["oCenterDiv"]["style"]["height"] = (parseInt(this["oCenterDiv"]["style"]["height"]) + this["RESIZE_BAR_HEIGHT"]) + "px";
		this["oCenterDiv"]["style"]["minHeight"] = parseInt(this["oCenterDiv"]["style"]["minHeight"]) + this["RESIZE_BAR_HEIGHT"] + "px";
	}
	this["iHeight"] += this["RESIZE_BAR_HEIGHT"];

	this["oCenterDiv"]["style"]["transition"] = "all 0s";
	this["oCenterDiv"]["style"]["width"] = "100%";
	this["oCenterDiv"]["style"]["right"] = "";
	this["oCenterDiv"]["style"]["left"] = "";
	this["oCenterDiv"]["style"]["top"] = "";
	this["oCenterDiv"]["style"]["bottom"] = "";
	this["oNotifierDiv"]["style"]["right"] = "";
	this["oNotifierDiv"]["style"]["left"] = "";
	this["oNotifierDiv"]["style"]["top"] = "";
	this["oNotifierDiv"]["style"]["bottom"] = "";

	this["bIsPinned"] = true;
	this["setClientProperty"]("IsPinned", this["bIsPinned"], true);
	if (this["getClientControl"]()) {
		this["getClientControl"]()["setIsPinned"](this["bIsPinned"], true);
	}

	var oPageHeader = UCF_DomUtil["oGetParentByAttribute"](this["oDomRef"]["parentNode"], "ct", "PHM");
	if (!oPageHeader) {
		UCF_DomUtil["focusDomElement"](this["oTogglePinDiv"]);
		this["refocus"](this["oTogglePinDiv"]);
		return;
	}
	var sPageHeaderId = oPageHeader["getAttribute"]("id");
	var oHeaderMsgContainerDiv = UCF_DomUtil["$"](sPageHeaderId + "-msgContainer");
	var oHeaderMsgNotifierTD = UCF_DomUtil["$"](sPageHeaderId + "-msgNotifier");
	if (oHeaderMsgContainerDiv && oHeaderMsgNotifierTD) {
		UCF_DomUtil["addClass"](oHeaderMsgContainerDiv, "lsPageHeader--messagearea");
		oHeaderMsgContainerDiv["appendChild"](UCF_DomUtil["oGetFirstChild"](oHeaderMsgNotifierTD));
		this["applyCenterContainerScrollbarClass"]();
	}
	UCF_DomUtil["focusDomElement"](this["oTogglePinDiv"]);
	this["refocus"](this["oTogglePinDiv"]);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["pin"] = 0; };

/**
 * Reset Pinned *
 * @param { UCF_BrowserEvent } oBrowserEvent the event for touch check
 *
 * @private
 */
UCF_MessageArea["prototype"]["unpin"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["unpin"]++; }; 

	var oPageHeader, sPageHeaderId, oHeaderMsgNotifierTD, oHeaderMsgContainerDiv;
	this["fireUnpin"](this["sId"]);
	if (this["oDomRef"])
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsMessageArea--ispinned');

	/* if the Unpin Event has ClientAction: summit,
			the MessageArea will be rendered again, but not the PageHeader;
			that's why the classes has to be removed */
	oPageHeader = UCF_DomUtil["oGetParentByAttribute"](this["oDomRef"]["parentNode"], "ct", "PHM");
	if (oPageHeader) {
		sPageHeaderId = oPageHeader["getAttribute"]("id");
		oHeaderMsgNotifierTD = UCF_DomUtil["$"](sPageHeaderId + "-msgNotifier");
		oHeaderMsgContainerDiv = UCF_DomUtil["$"](sPageHeaderId + "-msgContainer");
		if (oHeaderMsgContainerDiv && oHeaderMsgNotifierTD) {
			UCF_DomUtil["removeClass"](oHeaderMsgContainerDiv, "lsPageHeader--messagearea");
		}
	}

	if (this["bHasUnpinSubmitListener"]()) return;

	var oResizeHandleNDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleN");
	var oResizeHandleSDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleS");
	var oResizeHandleEDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleE");
	var oResizeHandleSSEDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleSSE");
	var oResizeHandleSSWDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleSSW");
	var oResizeHandleWDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleW");
	var oResizeHandleSTouchPinDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleS-TOUCHPIN");
	var oResizeHandleSTouchNotPinDiv = UCF_DomUtil["$"](this["sId"] + "-resizeHandleS-TOUCHNOTPIN");
	UCF_DomUtil["removeClass"](oResizeHandleSDiv, "urSpTHs");

	oResizeHandleNDiv["style"]["display"] = "block";
	oResizeHandleEDiv["style"]["display"] = "block";
	oResizeHandleSSEDiv["style"]["display"] = "block";
	oResizeHandleSSWDiv["style"]["display"] = "block";
	oResizeHandleWDiv["style"]["display"] = "block";
	if (oResizeHandleSTouchPinDiv) oResizeHandleSTouchPinDiv["style"]["display"] = "none";
	if (oResizeHandleSTouchNotPinDiv) oResizeHandleSTouchNotPinDiv["style"]["display"] = "block";
	if (oBrowserEvent["bIsTouchInteraction"]()) this["oCenterDiv"]["style"]["overflow"] = "hidden";

	if (window["UCF_System"]["bIs508"]) {
		UCF_DomUtil["setTabIndex"](this["oCenterDiv"], -1);
	}
	UCF_DomUtil["setTabIndex"](this["oNotifierDiv"], 0);

	this["oCenterDiv"]["style"]["boxShadow"] = "";
	this["oNotifierDiv"]["style"]["display"] = "block";

	// switch to position absolute if notifier is not in visible area of screen
	var oNotifierRect = this["oGetObjectRect"](this["oNotifierDiv"]);
	var iCLientWidth = UCF_DomUtil["iClientWidth"]();
	var iCLientHeight = UCF_DomUtil["iClientHeight"]();
	if (oNotifierRect["top"] > iCLientHeight || oNotifierRect["left"] > iCLientWidth) {
		this["oCenterDiv"]["style"]["position"] = "absolute";
		this["sPopOverPositionMode"] = "absolute";
	} else {
		this["oCenterDiv"]["style"]["position"] = "fixed";
		this["sPopOverPositionMode"] = "fixed";
	}

	UCF_DomUtil["replaceClass"](this["oTogglePinDiv"], "lsMAUnPinIcon", "lsMAPinIcon");
	this["oTogglePinDiv"]["setAttribute"]("title", this["oLS"]["sGetText"]("SAPUR_MA_PIN_TT"));
	this["oTogglePinDiv"]["setAttribute"]("aria-label", this["oLS"]["sGetText"]("SAPUR_MA_PIN_TT"));
	if (this["bAllowPin"]) {
		this["oTogglePinDiv"]["style"]["display"] = "'inline-block'";
	} else {
		this["oTogglePinDiv"]["style"]["display"] = "none";
	}
	this["oCollapseDiv"]["style"]["display"] = "";

	//	in unpinned state substract resizeBarHeight
	var iCurrentMsgCount = this["iGetCurrentMessageCount"]();
	if (!this["bMsgWrapping"]) {
		if (!this["bAdjustHeight"] && (iCurrentMsgCount < this["iVisibleMessageCount"])) {
			this["oCenterDiv"]["style"]["maxHeight"] = ((iCurrentMsgCount * this["iMessageHeight"]) + this["iCenterHeaderHeight"]) + "px";
		} else {
			this["oCenterDiv"]["style"]["maxHeight"] = (parseInt(this["oCenterDiv"]["style"]["maxHeight"]) - this["RESIZE_BAR_HEIGHT"]) + "px";
		}
	}
	this["oCenterDiv"]["style"]["height"] = (parseInt(this["oCenterDiv"]["style"]["height"]) - this["RESIZE_BAR_HEIGHT"]) + "px";
	this["oCenterDiv"]["style"]["minHeight"] = parseInt(this["oCenterDiv"]["style"]["minHeight"]) - this["RESIZE_BAR_HEIGHT"] + "px";

	this["iHeight"] -= this["RESIZE_BAR_HEIGHT"];

	this["oCenterDiv"]["style"]["transition"] = "all 0s";
	this["oCenterDiv"]["style"]["width"] = this["iWidth"] + "px";

	if (this["iTop"] === 0 && this["sTop"]) {
		this["iTop"] = parseInt(this["sTop"]);
	}
	this["oCenterDiv"]["style"]["top"] = this["iTop"] + "px";
	this["oNotifierDiv"]["style"]["top"] = this["iTop"] + "px";

	if (this["iLeft"] === 0 && this["sLeft"]) {
		this["iLeft"] = parseInt(this["sLeft"]);
	}
	this["oCenterDiv"]["style"]["left"] = this["iLeft"] + "px";
	this["oNotifierDiv"]["style"]["left"] = this["iLeft"] + "px";

	this["bIsPinned"] = false;
	this["setClientProperty"]("IsPinned", this["bIsPinned"], true);
	if (this["getClientControl"]()) {
		this["getClientControl"]()["setIsPinned"](this["bIsPinned"], true);
	}

	UCF_DomUtil["focusDomElement"](this["oTogglePinDiv"]);

	if (!oPageHeader) {
		UCF_DomUtil["focusDomElement"](this["oTogglePinDiv"]);
		this["refocus"](this["oTogglePinDiv"]);
		return;
	}
	sPageHeaderId = oPageHeader["getAttribute"]("id");
	oHeaderMsgNotifierTD = UCF_DomUtil["$"](sPageHeaderId + "-msgNotifier");
	oHeaderMsgContainerDiv = UCF_DomUtil["$"](sPageHeaderId + "-msgContainer");
	if (oHeaderMsgContainerDiv && oHeaderMsgNotifierTD) {
		UCF_DomUtil["removeClass"](oHeaderMsgContainerDiv, "lsPageHeader--messagearea");
		oHeaderMsgNotifierTD["appendChild"](UCF_DomUtil["oGetFirstChild"](oHeaderMsgContainerDiv));
	}
	UCF_DomUtil["focusDomElement"](this["oTogglePinDiv"]);
	this["refocus"](this["oTogglePinDiv"]);

	if (this["bIsOpened"]) {
		this["updateBlindLayer"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["unpin"] = 0; };

UCF_MessageArea["prototype"]["onShowDetail"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onShowDetail"]++; }; 
	var sMessageId = oEvent["oGetParam"]("sMessageId");
	this["showDetail"](sMessageId);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onShowDetail"] = 0; };

UCF_MessageArea["prototype"]["onHideDetail"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onHideDetail"]++; }; 
	this["back"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onHideDetail"] = 0; };

UCF_MessageArea["prototype"]["showDetail"] = function(sMessageId) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["showDetail"]++; }; 

	this["oMessage"] = this["oLS"]["oControlFactory"]["oGetControlById"](sMessageId);

	this["oCenterDiv"]["style"]["transition"] = "all 0s";

	this["oCenterDiv"]["style"]["height"] = "auto";
	this["oCenterDiv"]["style"]["maxHeight"] = "none";
	this["oCenterContainerDiv"]["style"]["height"] = "auto";

	this["oBackDiv"]["style"]["display"] = "inline-block";
	this["oFilterAllDiv"]["style"]["display"] = "none";
	this["oFilterErrorDiv"]["style"]["display"] = "none";
	this["oFilterWarningDiv"]["style"]["display"] = "none";
	this["oFilterInfoDiv"]["style"]["display"] = "none";
	this["oFilterSuccessDiv"]["style"]["display"] = "none";
	this["oTogglePinDiv"]["style"]["display"] = "none";
	if (this["sMessageMode"] === "SINGLE") {
		this["oBackDiv"]["style"]["visibility"] = "hidden";
	}

	var aMessageDivs = this["oCenterContainerDiv"]["childNodes"];
	for (var n = 0; n < aMessageDivs["length"]; n++) {
		if (aMessageDivs[n]["getAttribute"]("id") !== sMessageId) {
			aMessageDivs[n]["style"]["display"] = "none";
		}
	}

	//Position fixed in unpinned state -> take care that height does not exceed clientHeight
	if (!this["bIsPinned"]) {
		var oCenterHeaderRect = this["oGetObjectRect"](this["oCenterHeaderDiv"]);
		var oNotifierRect = this["oGetObjectRect"](this["oNotifierDiv"]);
		var iCLientHeight = UCF_DomUtil["iClientHeight"]();
		if (!this["bMsgWrapping"]) this["oCenterContainerDiv"]["style"]["maxHeight"] = iCLientHeight - (oCenterHeaderRect["top"] + oCenterHeaderRect["height"]) + "px";
		if ((oNotifierRect["top"] >= iCLientHeight / 2) && !this["bRepositioned"]) {
			this["oCenterContainerDiv"]["style"]["maxHeight"] = "none";
			this["iDetailHeight"] = this["oCenterDiv"]["offsetHeight"];
			this["iTop"] = oNotifierRect["top"] - this["oCenterDiv"]["offsetHeight"];
			this["oCenterDiv"]["style"]["top"] = this["iTop"] + "px";
			if (this["iTop"] < 0) {
				if (!this["bMsgWrapping"]) this["oCenterContainerDiv"]["style"]["maxHeight"] = (oNotifierRect["top"] - oCenterHeaderRect["height"]) + "px";
				this["iDetailHeight"] = this["oCenterDiv"]["offsetHeight"];
				this["iTop"] = 0;
				this["oCenterDiv"]["style"]["top"] = this["iTop"] + "px";
			}
		}
	} else {
		this["oCenterContainerDiv"]["style"]["maxHeight"] = "none";
		// Chrome53++ does not correctly absolute position the resize bar
		// trigger repainting
		if (UCF_UserAgent["bIsChromium"](53)) {
			this["oCenterContainerDiv"]["style"]["display"] = "none";
			// eslint-disable-next-line no-unused-expressions
			this["oCenterContainerDiv"]["offsetHeight"];
			this["oCenterContainerDiv"]["style"]["display"] = "block";
		}
	}

	this["bDetailOpen"] = true;
	//focus back button
	UCF_DomUtil["focusDomElement"](this["oBackDiv"]);
	this["updateBlindLayer"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["showDetail"] = 0; };

/**
 * Handles the expand event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageArea["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsexpand"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageArea.js(1928): onlsexpand"); };

	if (this["bIsOpened"]) return;
	if (this["sMessageMode"] === "SINGLE" && this["sContentAccessId"]) {
		this["expand"](true, true);
		var oMessage = this["oLS"]["oControlFactory"]["oGetControlById"](this["sContentAccessId"]);
		oMessage["showDetail"]();
		this["showDetail"](this["sContentAccessId"]);
	} else if (!this["oMessage"]) {
		this["expand"](true, true);
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsexpand"] = 0; };

/**
 * Handles the collapse event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageArea["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlscollapse"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageArea.js(1950): onlscollapse"); };

	if (!this["bIsOpened"]) return;
	if (this["oMessage"] && this["sMessageMode"] === "MULTI") {
		this["back"]();
	} else if (!this["bIsPinned"]) {
		this["handleClose"](oBrowserEvent);
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlscollapse"] = 0; };

UCF_MessageArea["prototype"]["onlsescape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsescape"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageArea.js(1963): onlsescape"); };

	if (!this["bIsOpened"]) return;
	if (this["oMessage"] && this["sMessageMode"] === "MULTI") {
		this["back"]();
	} else if (!this["bIsPinned"]) {
		this["handleClose"](oBrowserEvent);
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsescape"] = 0; };

UCF_MessageArea["prototype"]["handleClose"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleClose"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageArea.js(1976): handleClose"); };

	this["collapse"]();
	this["refocus"](this["oNotifierDiv"]);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["handleClose"] = 0; };

UCF_MessageArea["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageArea.js(1985): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource["getAttribute"]("tp") === "MA_END") {
		oAccessibilityHelper["setControlType"]("MA_END");
	} else if (oSource["getAttribute"]("id") === this["sId"] + "-notifier") {
		oAccessibilityHelper["setControlType"]("MA", [this["iMsgCount"]]);
		if (this["iMsgCount"] > 0) {
			oAccessibilityHelper["applyContainerEntryBehaviour"](true, true, !this["bIsOpened"]);
		}
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	} else if (oSource["getAttribute"]("id") === this["sId"] + "-center") {
		oAccessibilityHelper["setControlType"]("MA", [this["iMsgCount"]]);
		oAccessibilityHelper["applyContainerEntryBehaviour"](false);
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		if (this["bToggleFocusActive"]) {
			oAccessibilityHelper["addTutor"]("MA_TOGGLE_FOCUS");
		}
	} else if (UCF_DomUtil["bContains"](this["oFilterAllDiv"], oSource)) {
		oAccessibilityHelper["addTutor"]("MA_FILTER_ALL");
		oAccessibilityHelper["addTutor"]("LN_TUT");
		oAccessibilityHelper["addTutor"]("MA_FILTER_NAV");
	} else if (UCF_DomUtil["bContains"](this["oFilterErrorDiv"], oSource)) {
		oAccessibilityHelper["addTutor"]("MA_FILTER_ERROR", [this["iErrorMsgCount"]]);
		oAccessibilityHelper["addTutor"]("LN_TUT");
		oAccessibilityHelper["addTutor"]("MA_FILTER_NAV");
	} else if (UCF_DomUtil["bContains"](this["oFilterWarningDiv"], oSource)) {
		oAccessibilityHelper["addTutor"]("MA_FILTER_WARNING", [this["iWarningMsgCount"]]);
		oAccessibilityHelper["addTutor"]("LN_TUT");
		oAccessibilityHelper["addTutor"]("MA_FILTER_NAV");
	} else if (UCF_DomUtil["bContains"](this["oFilterInfoDiv"], oSource)) {
		oAccessibilityHelper["addTutor"]("MA_FILTER_INFO", [this["iInfoMsgCount"]]);
		oAccessibilityHelper["addTutor"]("LN_TUT");
		oAccessibilityHelper["addTutor"]("MA_FILTER_NAV");
	} else if (UCF_DomUtil["bContains"](this["oFilterSuccessDiv"], oSource)) {
		oAccessibilityHelper["addTutor"]("MA_FILTER_SUCCESS", [this["iSuccessMsgCount"]]);
		oAccessibilityHelper["addTutor"]("LN_TUT");
		oAccessibilityHelper["addTutor"]("MA_FILTER_NAV");
	} else if (UCF_DomUtil["bContains"](this["oTogglePinDiv"], oSource)) {
		if (this["bIsPinned"]) {
			oAccessibilityHelper["addTutor"]("MA_UNPIN");
		} else {
			oAccessibilityHelper["addTutor"]("MA_PIN");
		}
		oAccessibilityHelper["addTutor"]("LN_TUT");
	} else if (UCF_DomUtil["bContains"](this["oCollapseDiv"], oSource)) {
		oAccessibilityHelper["addTutor"]("MA_COLLAPSE");
		oAccessibilityHelper["addTutor"]("LN_TUT");
	} else if (UCF_DomUtil["bContains"](this["oBackDiv"], oSource)) {
		oAccessibilityHelper["addTutor"]("MSG_COLLAPSE");
		oAccessibilityHelper["addTutor"]("LN_TUT");
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsaccessibility"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageArea["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsskipforward"] = 0; };

/**
 * Handles the space event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageArea["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsspace"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageArea.js(2060): onlsspace"); };

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsspace"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageArea["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsskipback"] = 0; };

/**
 * Provide internal stuff for QUnit test recording and playback
 * @return {Object} the test data
 */
UCF_MessageArea["prototype"]["oGetTestData"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["oGetTestData"]++; }; 
	var o = UCF_Control.prototype["oGetTestData"]["apply"](this, arguments);
	o["internals"]["Notifier:CSSDisplay"] = UCF_DomUtil["sGetCurrentStyle"](this["oNotifierDiv"], "display");
	o["internals"]["Center:Height"] = this["oCenterDiv"]["clientHeight"];
	o["internals"]["Center:iMsgCount"] = this["iMsgCount"];
	o["internals"]["CenterContainer:NumberOfChildNodes"] = this["oCenterContainerDiv"]["childNodes"]["length"];
	return o;
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["oGetTestData"] = 0; };
/**
 * Notifies Message Area, that focus toggle feature is active (to add tutor text)
 *
 * @param {boolean} bActive  Focus toggle is active/inactive
 * @public
 */
UCF_MessageArea["prototype"]["notifyMessageFocusToggleActive"] = function(bActive) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["notifyMessageFocusToggleActive"]++; }; 
	this["bToggleFocusActive"] = bActive;
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["notifyMessageFocusToggleActive"] = 0; };

/**
 * Arrow up
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event
 */
UCF_MessageArea["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsup"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	//navigate filter buttons
	if (oSource["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
		var oPreviousFilterButtonDiv = UCF_DomUtil["oGetPreviousSibling"](oSource);
		while (oPreviousFilterButtonDiv && oPreviousFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
			if (oPreviousFilterButtonDiv["style"]["display"] !== "none") {
				UCF_DomUtil["setTabIndex"](oSource, -1);
				UCF_DomUtil["setTabIndex"](oPreviousFilterButtonDiv, 0);
				UCF_DomUtil["focusDomElement"](oPreviousFilterButtonDiv);
				break;
			}
			oPreviousFilterButtonDiv = UCF_DomUtil["oGetPreviousSibling"](oPreviousFilterButtonDiv);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsup"] = 0; };

/**
 * Arrow left
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event
 */
UCF_MessageArea["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsprevious"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	//navigate filter buttons
	if (oSource["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
		var oPreviousFilterButtonDiv = UCF_DomUtil["oGetPreviousSibling"](oSource);
		while (oPreviousFilterButtonDiv && oPreviousFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
			if (oPreviousFilterButtonDiv["style"]["display"] !== "none") {
				UCF_DomUtil["setTabIndex"](oSource, -1);
				UCF_DomUtil["setTabIndex"](oPreviousFilterButtonDiv, 0);
				UCF_DomUtil["focusDomElement"](oPreviousFilterButtonDiv);
				break;
			}
			oPreviousFilterButtonDiv = UCF_DomUtil["oGetPreviousSibling"](oPreviousFilterButtonDiv);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsprevious"] = 0; };

/**
 * Arrow down
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event
 */
UCF_MessageArea["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsdown"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	//navigate filter buttons
	if (oSource["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
		var oNextFilterButtonDiv = UCF_DomUtil["oGetNextSibling"](oSource);
		while (oNextFilterButtonDiv && oNextFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
			if (oNextFilterButtonDiv["style"]["display"] !== "none") {
				UCF_DomUtil["setTabIndex"](oSource, -1);
				UCF_DomUtil["setTabIndex"](oNextFilterButtonDiv, 0);
				UCF_DomUtil["focusDomElement"](oNextFilterButtonDiv);
				break;
			}
			oNextFilterButtonDiv = UCF_DomUtil["oGetNextSibling"](oNextFilterButtonDiv);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsdown"] = 0; };

/**
 * Arrow right
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event
 */
UCF_MessageArea["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsnext"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	//navigate filter buttons
	if (oSource["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
		var oNextFilterButtonDiv = UCF_DomUtil["oGetNextSibling"](oSource);
		while (oNextFilterButtonDiv && oNextFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
			if (oNextFilterButtonDiv["style"]["display"] !== "none") {
				UCF_DomUtil["setTabIndex"](oSource, -1);
				UCF_DomUtil["setTabIndex"](oNextFilterButtonDiv, 0);
				UCF_DomUtil["focusDomElement"](oNextFilterButtonDiv);
				break;
			}
			oNextFilterButtonDiv = UCF_DomUtil["oGetNextSibling"](oNextFilterButtonDiv);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsnext"] = 0; };

/**
 * Home
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event
 */
UCF_MessageArea["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlshome"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	//navigate filter buttons
	if (oSource["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
		var oFirstFilterButtonDiv = UCF_DomUtil["oGetFirstChild"](oSource["parentNode"]);
		if (oFirstFilterButtonDiv && oFirstFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-back") !== -1) {
			oFirstFilterButtonDiv = UCF_DomUtil["oGetNextSibling"](oFirstFilterButtonDiv);
		}
		while (oFirstFilterButtonDiv && oFirstFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
			if (oFirstFilterButtonDiv["style"]["display"] !== "none") {
				UCF_DomUtil["setTabIndex"](oSource, -1);
				UCF_DomUtil["setTabIndex"](oFirstFilterButtonDiv, 0);
				UCF_DomUtil["focusDomElement"](oFirstFilterButtonDiv);
				break;
			}
			oFirstFilterButtonDiv = UCF_DomUtil["oGetNextSibling"](oFirstFilterButtonDiv);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlshome"] = 0; };

/**
 * End
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event
 */
UCF_MessageArea["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsend"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	//navigate filter buttons
	if (oSource["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
		var oLastFilterButtonDiv = UCF_DomUtil["oGetLastChild"](oSource["parentNode"]);
		if (oLastFilterButtonDiv && oLastFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-rightIcons") !== -1) {
			oLastFilterButtonDiv = UCF_DomUtil["oGetPreviousSibling"](oLastFilterButtonDiv);
		}
		while (oLastFilterButtonDiv && oLastFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
			if (oLastFilterButtonDiv["style"]["display"] !== "none") {
				UCF_DomUtil["setTabIndex"](oSource, -1);
				UCF_DomUtil["setTabIndex"](oLastFilterButtonDiv, 0);
				UCF_DomUtil["focusDomElement"](oLastFilterButtonDiv);
				break;
			}
			oLastFilterButtonDiv = UCF_DomUtil["oGetPreviousSibling"](oLastFilterButtonDiv);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlsend"] = 0; };

/**
 * Home
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event
 */
UCF_MessageArea["prototype"]["onlspageup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlspageup"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	//navigate filter buttons
	if (oSource["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
		var oFirstFilterButtonDiv = UCF_DomUtil["oGetFirstChild"](oSource["parentNode"]);
		if (oFirstFilterButtonDiv && oFirstFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-back") !== -1) {
			oFirstFilterButtonDiv = UCF_DomUtil["oGetNextSibling"](oFirstFilterButtonDiv);
		}
		while (oFirstFilterButtonDiv && oFirstFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
			if (oFirstFilterButtonDiv["style"]["display"] !== "none") {
				UCF_DomUtil["setTabIndex"](oSource, -1);
				UCF_DomUtil["setTabIndex"](oFirstFilterButtonDiv, 0);
				UCF_DomUtil["focusDomElement"](oFirstFilterButtonDiv);
				break;
			}
			oFirstFilterButtonDiv = UCF_DomUtil["oGetNextSibling"](oFirstFilterButtonDiv);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlspageup"] = 0; };

/**
 * End
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event
 */
UCF_MessageArea["prototype"]["onlspagedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlspagedown"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	//navigate filter buttons
	if (oSource["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
		var oLastFilterButtonDiv = UCF_DomUtil["oGetLastChild"](oSource["parentNode"]);
		if (oLastFilterButtonDiv && oLastFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-rightIcons") !== -1) {
			oLastFilterButtonDiv = UCF_DomUtil["oGetPreviousSibling"](oLastFilterButtonDiv);
		}
		while (oLastFilterButtonDiv && oLastFilterButtonDiv["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1) {
			if (oLastFilterButtonDiv["style"]["display"] !== "none") {
				UCF_DomUtil["setTabIndex"](oSource, -1);
				UCF_DomUtil["setTabIndex"](oLastFilterButtonDiv, 0);
				UCF_DomUtil["focusDomElement"](oLastFilterButtonDiv);
				break;
			}
			oLastFilterButtonDiv = UCF_DomUtil["oGetPreviousSibling"](oLastFilterButtonDiv);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlspagedown"] = 0; };

/**
 * TabPrevious
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event
 */
UCF_MessageArea["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlstabprevious"]++; }; 
	//in pinned state backward tab out of message area
	if (this["bIsPinned"]) return;
	if (oBrowserEvent["oGetSource"]()["getAttribute"]("id")["indexOf"](this["sId"] + "-filter") !== -1 || oBrowserEvent["oGetSource"]()["getAttribute"]("id") === this["sId"] + "-back"
		|| this["sMessageMode"] === "SINGLE" && oBrowserEvent["oGetSource"]()["getAttribute"]("id") === this["sId"] + "-collapse") {
		UCF_DomUtil["focusDomElement"](UCF_DomUtil["oGetFirstFocusableDomRef"](this["oCenterContainerDiv"]));
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["onlstabprevious"] = 0; };

/**
 * @private
 * @return {boolean} `true` if first Pin listener has `ClientAction=submit`
 */
UCF_MessageArea["prototype"]["bHasPinSubmitListener"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["bHasPinSubmitListener"]++; }; 
	return this["mEvents"]["Pin"]
		&& this["mEvents"]["Pin"][0]
		&& this["mEvents"]["Pin"][0]["ClientAction"] === 'submit';
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["bHasPinSubmitListener"] = 0; };

/**
 *  add or remove the scrollbar class for Container
 * @private
 */
UCF_MessageArea["prototype"]["applyCenterContainerScrollbarClass"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["applyCenterContainerScrollbarClass"]++; }; 
	if (!this["oCenterContainerDiv"]) return;

	if (this["oCenterContainerDiv"]["scrollHeight"] > this["oCenterContainerDiv"]["offsetHeight"]) {
		if (!UCF_DomUtil["bHasClass"](this["oCenterContainerDiv"], 'lsMACenterContainerPaddingScrollbar'))
			UCF_DomUtil["addClass"](this["oCenterContainerDiv"], 'lsMACenterContainerPaddingScrollbar');
	} else if (UCF_DomUtil["bHasClass"](this["oCenterContainerDiv"], 'lsMACenterContainerPaddingScrollbar')) {
		UCF_DomUtil["removeClass"](this["oCenterContainerDiv"], 'lsMACenterContainerPaddingScrollbar');
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["applyCenterContainerScrollbarClass"] = 0; };

/**
 * @private
 * @return {boolean} `true` if first Pin listener has `ClientAction=submit`
 */
UCF_MessageArea["prototype"]["bHasUnpinSubmitListener"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["bHasUnpinSubmitListener"]++; }; 
	return this["mEvents"]["Unpin"]
		&& this["mEvents"]["Unpin"][0]
		&& this["mEvents"]["Unpin"][0]["ClientAction"] === 'submit';
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["bHasUnpinSubmitListener"] = 0; };

UCF_MessageArea["prototype"]["updateBlindLayer"] = function(iLeft, iTop, iWidth, iHeight) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["updateBlindLayer"]++; }; 
	if (!this["oBlindLayer"]) {
		this["oBlindLayer"] = this["oLS"]["oGetBlindLayer"]();
	}

	UCF_DomUtil["setStyle"](this["oBlindLayer"]["oDomRef"], {
		"left": iLeft ? iLeft + 'px' : this["iLeft"] + 'px',
		"top": iTop ? iTop + 'px' : this["iTop"] + 'px',
		"width": iWidth ? iWidth + 'px' : this["iWidth"] + 'px',
		"height": iHeight ? iHeight + 'px' : this["bDetailOpen"] ? this["oCenterDiv"]["offsetHeight"] + 'px' : this["iHeight"] + "px",
		// height: iHeight ? iHeight + 'px' : this.oCenterDiv.offsetHeight + 'px',
		"position": this["sPopOverPositionMode"]
	});
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["updateBlindLayer"] = 0; };

UCF_MessageArea["prototype"]["releaseBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["releaseBlindLayer"]++; }; 

	if (this["oBlindLayer"]) {
		UCF_DomUtil["setStyle"](this["oBlindLayer"]["oDomRef"], {
			"position": "absolute"
		});
		this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
		this["oBlindLayer"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["releaseBlindLayer"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_MessageArea["prototype"]["aAttributeNames"] = ["sWidth","bIsPinned","iVisibleMessageCount","sTooltip","sVisibility","bAdjustHeight","sContentAccessId","bAllowUnpin","bIsOpened","sHeight","sTop","sLeft","sFilterType","bAllowPin","sMessageMode"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_MessageArea["prototype"]["aEventNames"] = ["Pin","Unpin","Expand","Collapse","Resize","Reposition","Filter"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_MessageArea["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_MessageArea["prototype"]["sWidth"] = '400px';

/**
 * @private
 * @type {boolean}
 */
UCF_MessageArea["prototype"]["bIsPinned"] = false;

/**
 * @private
 * @type {number}
 */
UCF_MessageArea["prototype"]["iVisibleMessageCount"] = 1;

/**
 * @private
 * @type {string}
 */
UCF_MessageArea["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_MessageArea["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_MessageArea["prototype"]["bAdjustHeight"] = true;

/**
 * @private
 * @type {string}
 */
UCF_MessageArea["prototype"]["sContentAccessId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_MessageArea["prototype"]["bAllowUnpin"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_MessageArea["prototype"]["bIsOpened"] = false;

/**
 * @private
 * @type {string}
 */
UCF_MessageArea["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageArea["prototype"]["sTop"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageArea["prototype"]["sLeft"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.MessageFilterType}
 */
UCF_MessageArea["prototype"]["sFilterType"] = "ALL";

/**
 * @private
 * @type {boolean}
 */
UCF_MessageArea["prototype"]["bAllowPin"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.MessageMode}
 */
UCF_MessageArea["prototype"]["sMessageMode"] = "MULTI";

//#JSCOVER_EXCL_START
/** @protected */
UCF_MessageArea["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["setDefaultValues"]++; }; 
	this["sWidth"] = '400px';
	this["bIsPinned"] = false;
	this["iVisibleMessageCount"] = 1;
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["bAdjustHeight"] = true;
	this["sContentAccessId"] = '';
	this["bAllowUnpin"] = true;
	this["bIsOpened"] = false;
	this["sHeight"] = '';
	this["sTop"] = '';
	this["sLeft"] = '';
	this["sFilterType"] = "ALL";
	this["bAllowPin"] = true;
	this["sMessageMode"] = "MULTI";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Width", '400px', true);
		this["setClientProperty"]("IsPinned", false, true);
		this["setClientProperty"]("VisibleMessageCount", 1, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("AdjustHeight", true, true);
		this["setClientProperty"]("ContentAccessId", '', true);
		this["setClientProperty"]("AllowUnpin", true, true);
		this["setClientProperty"]("IsOpened", false, true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("Top", '', true);
		this["setClientProperty"]("Left", '', true);
		this["setClientProperty"]("FilterType", "ALL", true);
		this["setClientProperty"]("AllowPin", true, true);
		this["setClientProperty"]("MessageMode", "MULTI", true);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the MessageArea control.
 * @fires MessageArea::Pin
 */
UCF_MessageArea["prototype"]["firePin"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["firePin"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "MessageArea.js(2540): firePin"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageArea.js(2541): firePin"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageArea.js(2542): firePin"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("MessageArea", "Pin", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["firePin"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the MessageArea control.
 * @fires MessageArea::Unpin
 */
UCF_MessageArea["prototype"]["fireUnpin"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireUnpin"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "MessageArea.js(2559): fireUnpin"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageArea.js(2560): fireUnpin"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageArea.js(2561): fireUnpin"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("MessageArea", "Unpin", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireUnpin"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the MessageArea control.
 * @fires MessageArea::Expand
 */
UCF_MessageArea["prototype"]["fireExpand"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireExpand"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "MessageArea.js(2578): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageArea.js(2579): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageArea.js(2580): fireExpand"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("MessageArea", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireExpand"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the MessageArea control.
 * @fires MessageArea::Collapse
 */
UCF_MessageArea["prototype"]["fireCollapse"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "MessageArea.js(2597): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageArea.js(2598): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageArea.js(2599): fireCollapse"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("MessageArea", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the MessageArea control.
 * @param {number} iWidth Width of the MessageArea control.
 * @param {number} iHeight Height of the MessageArea control.
 * @fires MessageArea::Resize
 */
UCF_MessageArea["prototype"]["fireResize"] = function(sId, iWidth, iHeight) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireResize"]++; }; 
	/** @type {{Id: string, Width: number, Height: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "MessageArea.js(2618): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageArea.js(2619): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageArea.js(2620): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iWidth != null, "iWidth != null", "MessageArea.js(2621): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iWidth) == "number", "typeof(iWidth) == \"number\"", "MessageArea.js(2622): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iHeight != null, "iHeight != null", "MessageArea.js(2623): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iHeight) == "number", "typeof(iHeight) == \"number\"", "MessageArea.js(2624): fireResize"); };
	mParams = {
		"Id": sId,
		"Width": iWidth,
		"Height": iHeight
	};
	
	
	
	this["fireSemanticEvent"]("MessageArea", "Resize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the MessageArea control.
 * @param {number} iTop Top position of the MessageArea control.
 * @param {number} iLeft Left position of the MessageArea control.
 * @fires MessageArea::Reposition
 */
UCF_MessageArea["prototype"]["fireReposition"] = function(sId, iTop, iLeft) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireReposition"]++; }; 
	/** @type {{Id: string, Top: number, Left: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "MessageArea.js(2647): fireReposition"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageArea.js(2648): fireReposition"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageArea.js(2649): fireReposition"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iTop != null, "iTop != null", "MessageArea.js(2650): fireReposition"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iTop) == "number", "typeof(iTop) == \"number\"", "MessageArea.js(2651): fireReposition"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iLeft != null, "iLeft != null", "MessageArea.js(2652): fireReposition"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iLeft) == "number", "typeof(iLeft) == \"number\"", "MessageArea.js(2653): fireReposition"); };
	mParams = {
		"Id": sId,
		"Top": iTop,
		"Left": iLeft
	};
	
	
	
	this["fireSemanticEvent"]("MessageArea", "Reposition", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireReposition"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the MessageArea control.
 * @param {UCF_ClientInterfaces.E.MessageFilterType} sType Type of the message filter.
 * @fires MessageArea::Filter
 */
UCF_MessageArea["prototype"]["fireFilter"] = function(sId, sType) {;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireFilter"]++; }; 
	/** @type {{Id: string, Type: UCF_ClientInterfaces.E.MessageFilterType}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "MessageArea.js(2675): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageArea.js(2676): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageArea.js(2677): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sType != null, "sType != null", "MessageArea.js(2678): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sType) == "string", "typeof(sType) == \"string\"", "MessageArea.js(2679): fireFilter"); };
	mParams = {
		"Id": sId,
		"Type": sType
	};
	
	
	this["fireSemanticEvent"]("MessageArea", "Filter", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageArea["_"]["fireFilter"] = 0; };

UCF_MessageArea.prototype["aPublicMethods"] = ["notifyMessageFocusToggleActive"].concat(UCF_MessageArea.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_MessageBar"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_Page */
/// <reference path="../core/Page.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * A clickable TextView
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MessageBar(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["UCF_MessageBar"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "MessageBar.js(32): UCF_MessageBar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "MessageBar.js(33): UCF_MessageBar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "MessageBar.js(34): UCF_MessageBar"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	this["oHelpLink"] = UCF_DomUtil["$"](this["sId"] + "-help");
	this["allowTextSelection"]();
	this["sClassImagePrefix"] = "urMsgBarImg";
	this["sClassIconPrefix"] = "lsMsgBarIcon";
	this["sClassImageStdPrefix"] = "lsMessageBar__image--";
	this["sClassIconStdPrefix"] = "lsMessageBar__icon--";
	this["sClassTypePrefix"] = "lsMessageBar--type";
	this["bToggleFocusActive"] = false;
};window["UCF_MessageBar"] = UCF_MessageBar; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MessageBar"); UCF_MessageBar["_"] = {UCF_MessageBar: 0}; }; ;
UCF_MessageBar["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_MessageBar.prototype["sClassName"] = "UCF_MessageBar";

/**
 * Initializes the MessageBar
 */
UCF_MessageBar["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["initialize"]++; }; 

	//empty, just to find the message bar for a certain input field
	if (this["sBindingPath"]) {
		this["initBindings"]();
	}

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["initialize"] = 0; };

/**
 * Initializes messages that are bound to controls
 */
UCF_MessageBar["prototype"]["initBindings"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["initBindings"]++; }; 
	var sModelId = this["sBindingPath"]["substring"](0, this["sBindingPath"]["indexOf"](">")),
		oPage = this["oLS"]["oGetPageInternal"](),
		oModel = null;
	if (oPage)
		oModel = oPage["getModel"](sModelId);
	if (oModel) {
		var aControls = oModel["getBoundControls"](this["sBindingPath"]);
		for (var i = 0; i < aControls["length"]; i++) {
			var oControl = aControls[i];
			if (oControl["getUCFInstance"] && oControl["getUCFInstance"]()) {
				var oUCFInstance = oControl["getUCFInstance"]();
				if (oUCFInstance) {
					var oText = UCF_DomUtil["$"](this["sId"] + '-txt');
					UCF_JsUtil["delayedCall"](10, oUCFInstance, "createDataTip", [this["sType"], UCF_DomUtil["sGetInnerText"](oText)]);
				}
			}
		}
	} else {
		if (oPage)
			oPage["attachEvent"](oPage["E_EVENTS"]["ModelAvailable"], this, "initBindings");
	}
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["initBindings"] = 0; };
/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(94): onclick"); };

	var oSource = oBrowserEvent["oGetSource"]();

	if (!this["mEvents"]["Click"]) {
		if ((this["bHasHelpLink"]) && (oSource === this["oHelpLink"])) {
			this["fireActivateHelp"](this["sId"]);
			oBrowserEvent["cancelBubble"]();
		} else {
			this["focusConnectedControl"]();
			oBrowserEvent["cancelBubble"]();
		}
	} else {
		if (this["mEvents"]["ActivateHelp"] && this["bHasHelpLink"] && (oSource === this["oHelpLink"])) {
			this["fireActivateHelp"](this["sId"]);
			oBrowserEvent["cancelBubble"]();
		} else {
			this["fireClick"](this["sId"]);
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onclick"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(124): ondblclick"); };

	if (!this["mEvents"]["DoubleClick"]) return;

	this["fireDoubleClick"](this["sId"]);
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["ondblclick"] = 0; };
/**
 * Handles selection by keyboard
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsspace"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(139): onlsspace"); };

	this["handleClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsspace"] = 0; };

/**
 * Handles the click on the menu with keyboard or mouse
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["handleClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["handleClick"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();

	if (this["bHasHelpLink"] && (oSource === this["oHelpLink"])) {
		this["fireActivateHelp"](this["sId"]);
	} else {
		this["focusConnectedControl"]();
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["handleClick"] = 0; };

/**
 * Handles the onlsselect event of lightspeed
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsenter"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(172): onlsenter"); };

	this["handleClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsenter"] = 0; };

/**
 * Sets the focus to the connected control that corresponds to the message
 * If the connected control cannot receive the focus this function is ignored.
 * @return {boolean} true if the connected control received the focus.
 */
UCF_MessageBar["prototype"]["focusConnectedControl"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["focusConnectedControl"]++; }; 
	if (!this["sConnectedControlId"]) return false;
	var oTargetControl = this["oGetControlById"](this["sConnectedControlId"]);
	if (!oTargetControl) return false;
	// ARIA: put message in aria-describedby of the target control
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setDescribedby"](oTargetControl["oDomRef"], this["sId"]);
	}
	if (oTargetControl["bIsFocusable"]) {
		oTargetControl["focus"](this["sFocusData"]);
		return true;
	}
	return false;

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["focusConnectedControl"] = 0; };

/**
 * Highlights the message bar for a short time
 * This effect can be used to highlight the message bar if the corresponding input element got the focus.
 * The effect can only be seen if animations are allowed with UCF_System.bUseAnimation.
 *
 * @private
 */
UCF_MessageBar["prototype"]["highlight"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["highlight"]++; }; 
	//TODO
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["highlight"] = 0; };

/**
 * Set the type of the MessageBar
 *
 * @param {string} sType
 * @public
 */
UCF_MessageBar["prototype"]["setType"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setType"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sType) === "string", "typeof(sType) === \"string\"", "MessageBar.js(217): setType"); };
	this["setInvalidated"](false);
	var oImg = UCF_DomUtil["$"](this["sId"] + '-img'),
		oIcon = UCF_DomUtil["$"](this["sId"] + '-icon'),
		sTop = this["oDomRef"]["className"]["indexOf"]("Top") > -1 ? "Top" : "",
		sBottom = this["oDomRef"]["className"]["indexOf"]("Btm") > -1 ? "Btm" : "";
	var sOldSuffix = this["sGetTypeSuffix"](this["sType"]),
		sNewSuffix = this["sGetTypeSuffix"](sType),
		sOldImgClassName = this["sClassImagePrefix"] + sOldSuffix,
		sNewImgClassName = this["sClassImagePrefix"] + sNewSuffix,
		sOldIconClassName = this["sClassIconPrefix"] + sOldSuffix,
		sNewIconClassName = this["sClassIconPrefix"] + sNewSuffix,
		sOldImgStdClassName = this["sClassImageStdPrefix"] + sOldSuffix,
		sNewImgStdClassName = this["sClassImageStdPrefix"] + sNewSuffix,
		sOldIconStdClassName = this["sClassIconStdPrefix"] + sOldSuffix,
		sNewIconStdClassName = this["sClassIconStdPrefix"] + sNewSuffix,
		sOldTypeClass = this["sClassTypePrefix"] + sOldSuffix,
		sNewTypeClass = this["sClassTypePrefix"] + sNewSuffix;

	if (this["sRulerDisplay"] === "NONE") {
		UCF_DomUtil["replaceClass"](this["oDomRef"], "urMsgBar" + sOldSuffix, "urMsgBar" + sNewSuffix);
	} else {
		if (this["sType"] !== "ERROR" && sType === "ERROR") {
			UCF_DomUtil["replaceClass"](this["oDomRef"], "urMsgBarStd" + sTop + sBottom, "urMsgBarErr" + sTop + sBottom);
		} else if (this["sType"] === "ERROR" && sType !== "ERROR") {
			UCF_DomUtil["replaceClass"](this["oDomRef"], "urMsgBarErr" + sTop + sBottom, "urMsgBarStd" + sTop + sBottom);
		}
	}

	UCF_DomUtil["replaceClass"](this["oDomRef"], sOldTypeClass, sNewTypeClass);

	this["sType"] = sType;
	if (oImg != null && sOldImgClassName !== sNewImgClassName) {
		UCF_DomUtil["replaceClass"](oImg, sOldImgClassName, sNewImgClassName);

	}
	if (oIcon != null && sOldIconClassName !== sNewIconClassName) {
		UCF_DomUtil["replaceClass"](oIcon, sOldIconClassName, sNewIconClassName);
		if (window["UCF_System"]["sDevice"] === "standards") {
			UCF_DomUtil["replaceClass"](oIcon, sOldIconStdClassName, sNewIconStdClassName);
			UCF_DomUtil["replaceClass"](oIcon, sOldImgStdClassName, sNewImgStdClassName);
		}
	}
	this["setClientProperty"]("Type", this["sType"], true);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setType"] = 0; };

/**
 * @private
 * @param {string} sType
 * @return {string}
 */
UCF_MessageBar["prototype"]["sGetTypeSuffix"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["sGetTypeSuffix"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'MessageBarTypeSuffixFragment',
		'MessageBar', { "Type": sType }
	);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["sGetTypeSuffix"] = 0; };

/**
 * Set the text of the MessageBar
 *
 * @param {string} sText
 * @public
 */
UCF_MessageBar["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setText"]++; }; 
	var oText = UCF_DomUtil["$"](this["sId"] + '-txt');
	this["setInvalidated"](false);
	UCF_DomUtil["setInnerText"](oText, sText);
	this["sText"] = sText;
	this["setClientProperty"]("Text", this["sText"], true);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setText"] = 0; };
/**
 * Sets or removes the message bar invalidated state
 * Use this state in case the corresponding field was changed but not yet confirmed to be corrected
 * @param {boolean} bInvalidated The invalidated state
 */
UCF_MessageBar["prototype"]["setInvalidated"] = function(bInvalidated) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setInvalidated"]++; }; 

	if (window["UCF_System"]["sDevice"] === "standards") return;

	var oText = UCF_DomUtil["$"](this["sId"] + '-txt'),
		oImg = UCF_DomUtil["$"](this["sId"] + '-img');
	if (bInvalidated) {
		oText["style"]["color"] = "#999";
		this["oDomRef"]["style"]["borderColor"] = "#999";
		if (oImg)
			UCF_DomUtil["setOpacityStyle"](oImg, 30);
	} else {
		this["oDomRef"]["style"]["borderColor"] = "";
		oText["style"]["color"] = "";
		oText["style"]["textDecoration"] = "";
		if (oImg)
			UCF_DomUtil["setOpacityStyle"](oImg, 100);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setInvalidated"] = 0; };

/**
 * Handles the mouseover event on the label
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(320): onmouseover"); };

	if (window["UCF_System"]["bIs508"] || this["bWrapping"] || !this["bTextOverflow"]) return;
	// the text will not be added to the Title when Wrapping=true and the
	// Label is into container which has Overflow
	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oMessageBarText = UCF_DomUtil["$"](this["sId"] + "-txt");

	if (oSource !== oMessageBarText) return;

	var oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + "-txt");
	if (oDomRefOvfl) {
		UCF_DomUtil["checkTooltip"](this["oDomRef"], this["sTooltip"], oDomRefOvfl);
	}

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onmouseover"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageBar["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MessageBar.js(346): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oHelpLink = UCF_DomUtil["$"](this["sId"] + "-help");

	if (oSource === oHelpLink) {
		oAccessibilityHelper["setControlType"]("LN");
		if (this["sHelpLinkText"] !== '')
			oAccessibilityHelper["setText"](this["sHelpLinkText"]);
		else
			oAccessibilityHelper["addTutor"]("HELP");
		oAccessibilityHelper["addTutor"]("LN_TUT");
		if (this["bToggleFocusActive"]) {
			oAccessibilityHelper["addTutor"]("MA_TOGGLE_FOCUS");
		}
	} else {
		if (this["sType"] === "ERROR")
			oAccessibilityHelper["addTutor"]("ERROR");
		else if (this["sType"] === "OK")
			oAccessibilityHelper["addTutor"]("SUCCESS");
		else if (this["sType"] === "STOP")
			oAccessibilityHelper["addTutor"]("STOP");
		else if (this["sType"] === "WARNING")
			oAccessibilityHelper["addTutor"]("WARNING");
		else if (this["sType"] === "LOADING")
			oAccessibilityHelper["addTutor"]("LOADING");
		else if (this["sType"] === "INFO")
			oAccessibilityHelper["addTutor"]("INFO");
		else if (this["sType"] === "NOTIFICATION")
			oAccessibilityHelper["addTutor"]("NOTIFICATION");
		else if (this["sType"] === "ALERT")
			oAccessibilityHelper["addTutor"]("ALERT");
		else if (this["sType"] === "TASK")
			oAccessibilityHelper["addTutor"]("TASK");
		oAccessibilityHelper["setText"](this["sText"]);
		if (this["sText"] !== this["sTooltip"])
			oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	}

};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["onlsaccessibility"] = 0; };
/**
 * Notifies Message Area, that focus toggle feature is active (to add tutor text)
 *
 * @param {boolean} bActive  Focus toggle is active/inactive
 * @public
 */
UCF_MessageBar["prototype"]["notifyMessageFocusToggleActive"] = function(bActive) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["notifyMessageFocusToggleActive"]++; }; 
	this["bToggleFocusActive"] = bActive;
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["notifyMessageFocusToggleActive"] = 0; };

/**
 * See UCF_Control.aGetTouchContextMenuEntries()
 * @private
 * @return {Array<{sType: ('TOOLTIP'|'TEXT'|'DATATIP'|'DOUBLECLICK'|'QUICKVIEW'), sText: string, fTrigger: function(): void}>}
 */
UCF_MessageBar["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	if (this["bTextOverflow"]) {
		var oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-txt');
		if (oTextDomRef && UCF_DomUtil["bHasTextEllipsis"](this["oDomRef"], oTextDomRef)) {
			aResult["push"]({
				"sType": 'TEXT',
				"sText": UCF_DomUtil["removeColon"](UCF_DomUtil["sGetInnerText"](oTextDomRef))
			});
		}
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["aGetTouchContextMenuEntries"] = 0; };

UCF_MessageBar["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["destroy"]++; }; 

	this["oHelpLink"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sText"] = null;
	this["bToggleFocusActive"] = false;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sType"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_MessageBar["prototype"]["aAttributeNames"] = ["sText","sType","sRulerDisplay","sVisibility","sConnectedControlId","sTooltip","bHasHelpLink","sHelpLinkText","sFocusData","sCustomStyle","sBindingPath","sCustomData","bWrapping","bTextOverflow"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_MessageBar["prototype"]["aEventNames"] = ["DoubleClick","Click","ActivateHelp"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_MessageBar["prototype"]["aMethodNames"] = ["setText","setType","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sText"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.MessageType}
 */
UCF_MessageBar["prototype"]["sType"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.MessageBarRulerDisplay}
 */
UCF_MessageBar["prototype"]["sRulerDisplay"] = "BOTTOM";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_MessageBar["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sConnectedControlId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_MessageBar["prototype"]["bHasHelpLink"] = false;

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sHelpLinkText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sFocusData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sBindingPath"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageBar["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_MessageBar["prototype"]["bWrapping"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_MessageBar["prototype"]["bTextOverflow"] = false;

//#JSCOVER_EXCL_START
/** @protected */
UCF_MessageBar["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["sType"] = "NONE";
	this["sRulerDisplay"] = "BOTTOM";
	this["sVisibility"] = "VISIBLE";
	this["sConnectedControlId"] = '';
	this["sTooltip"] = '';
	this["bHasHelpLink"] = false;
	this["sHelpLinkText"] = '';
	this["sFocusData"] = '';
	this["sCustomStyle"] = '';
	this["sBindingPath"] = '';
	this["sCustomData"] = '';
	this["bWrapping"] = true;
	this["bTextOverflow"] = false;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Type", "NONE", true);
		this["setClientProperty"]("RulerDisplay", "BOTTOM", true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ConnectedControlId", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("HasHelpLink", false, true);
		this["setClientProperty"]("HelpLinkText", '', true);
		this["setClientProperty"]("FocusData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("BindingPath", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("Wrapping", true, true);
		this["setClientProperty"]("TextOverflow", false, true);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the Button control.
 * @fires MessageBar::DoubleClick
 */
UCF_MessageBar["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "MessageBar.js(581): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageBar.js(582): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageBar.js(583): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("MessageBar", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Button control.
 * @fires MessageBar::Click
 */
UCF_MessageBar["prototype"]["fireClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "MessageBar.js(600): fireClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageBar.js(601): fireClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageBar.js(602): fireClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("MessageBar", "Click", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires MessageBar::ActivateHelp
 */
UCF_MessageBar["prototype"]["fireActivateHelp"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireActivateHelp"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "MessageBar.js(619): fireActivateHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessageBar.js(620): fireActivateHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessageBar.js(621): fireActivateHelp"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("MessageBar", "ActivateHelp", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessageBar["_"]["fireActivateHelp"] = 0; };

UCF_MessageBar.prototype["aPublicMethods"] = ["setType","setText","notifyMessageFocusToggleActive"].concat(UCF_MessageBar.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_MessageToast"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>

/**
 * 
 * @version
 *
 * @class
 * @extends UCF_LayeredControl
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MessageToast(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["UCF_MessageToast"]++; }; 
	if (arguments["length"] === 0) {
		return;
	}
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "MessageToast.js(43): UCF_MessageToast"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "MessageToast.js(44): UCF_MessageToast"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "MessageToast.js(45): UCF_MessageToast"); };
	UCF_LayeredControl["apply"](this, [oDomRef, oLS]);
	this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["POSITION"]);
	UCF_MessageToast["oLastMessage"] = {
		"OpenerId": this["sOpenerId"],
		"Text": this["sText"],
		"Duration": this["iDuration"]
	};
	UCF_MessageToast["oGUI"] = this["oRootRef"] = this["oGetDomRef"](); // must be set for alignment of layered control
	UCF_MessageToast["oGUI"]["style"]["display"]='none';
};window["UCF_MessageToast"] = UCF_MessageToast; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MessageToast"); UCF_MessageToast["_"] = {UCF_MessageToast: 0}; }; ;

UCF_MessageToast["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_MessageToast.prototype["sClassName"] = "UCF_MessageToast";

UCF_MessageToast["bIsOpened"] = false; // MessageToast is opened (precondition for shown)
UCF_MessageToast["bIsClosing"] = false; // MessageToast is closing
UCF_MessageToast["bIsShown"] = false; // MessageToast is shown
UCF_MessageToast["iLeft"] = 0; // x position of MessageToast
UCF_MessageToast["iTop"] = 0; // y position of MessageToast
UCF_MessageToast["oGUI"] = null; // MessageToast GUI

/**
 * Remove emove tooltip from DOM in UCF_Control.initializeMessageToast()
 * @private
 * @return {boolean}
 */
UCF_MessageToast["prototype"]["bKeepTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["bKeepTooltip"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["bKeepTooltip"] = 0; };

/**
 * Destructor of MessageToast
 * @private
 */
UCF_MessageToast["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["destroy"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "MessageToast destroyed !!!! ", "MessageToast.js(80): destroy"); };
	this["close"]();
	this["sTimerIdShow"] = null;
	this["sTimerIdClose"] = null;

	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["destroy"] = 0; };

/**
 * Constructor of MessageToast
 * @private
 * @return {Object} domRef
 */
UCF_MessageToast["prototype"]["oGetDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["oGetDomRef"]++; }; 
	var sPageId = this["oLS"]["oGetPageInternal"]()["sId"],
		sId = sPageId + "-mtsingleton",
		oDomRef = UCF_DomUtil["$"](sId);

	if (oDomRef != null) return oDomRef;
	var oTemp = document["createElement"]("div");
	// eslint-disable-next-line no-unsanitized/property
	var sInnerHTMLNew = this["getHTMLContent"]();
	//UCF_DomUtil.setInnerHtml(oTemp, sInnerHTML);
	UCF_DomUtil["setInnerHtml"](oTemp, sInnerHTMLNew);
	UCF_DomUtil["setStyle"](UCF_DomUtil["$"](sId), { 'zIndex': UCF_LS["E_LAYERS"]["POPUPMENUS"] });

	var oFragment = document["createDocumentFragment"]();
	oFragment["appendChild"](oTemp["firstChild"]);

	var sStaticId = sPageId + "-static",
		oStaticDomRef = UCF_DomUtil["$"](sStaticId);

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oStaticDomRef != null, "oStaticDomRef != null", "MessageToast.js(112): oGetDomRef"); };

	oStaticDomRef["appendChild"](oFragment);
	oDomRef = UCF_DomUtil["$"](sId);
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPageId + "-mtsingleton" === sId, "sPageId + \"-mtsingleton\" === sId", "MessageToast.js(116): oGetDomRef"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "MessageToast.js(117): oGetDomRef"); };

	return oDomRef;
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["oGetDomRef"] = 0; };

/**
 * Remove MessageToast from DOM
 */
UCF_MessageToast["prototype"]["remove"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["remove"]++; }; 
	UCF_DomUtil["removeFromDom"](this["oRootRef"]);
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["remove"] = 0; };

/**
 * Retrieve the HTML content of MessageToast
 * @return {string} - the HTML
 */
UCF_MessageToast["prototype"]["getHTMLContent"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["getHTMLContent"]++; }; 

	var sContentHTML, oContentHTML;
	var sPageId = this["oLS"]["oGetPageInternal"]()["sId"],
		sId = sPageId + "-mtsingleton";
	oContentHTML = this["renderContent"](sId);
	sContentHTML = '';
	if (oContentHTML)
		sContentHTML = oContentHTML["outerHTML"];
	return sContentHTML;
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["getHTMLContent"] = 0; };

/**
 * Shows the MessageToast at given position for the mouseover event of the browser
 *
 */
UCF_MessageToast["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["show"]++; }; 
	var oContentHTML;
	var sPageId = this["oLS"]["oGetPageInternal"]()["sId"],
		sId = sPageId + "-mtsingleton";

	oContentHTML = this["renderContent"](sId);
	if (oContentHTML)
		UCF_DomUtil["setInnerHtml"](this["oRootRef"], oContentHTML["innerHTML"]);

	// make visible --> required for this.checkRootRef()
	UCF_DomUtil["setStyle"](this["oRootRef"], {
		"visibility": 'inherit',
		"display": 'block',
		"overflow": 'visible',
		"opacity": 0
	});

	var oRectMessageToast = this["oGetObjectRect"](this["oRootRef"]);
	var oRectPage;
	if (this["sOpenerId"] !== ''){
		this["oOpenerRef"] = document["getElementById"](this["sOpenerId"]);
		oRectPage = this["oOpenerRef"]["getBoundingClientRect"]();
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iTopPosition"] = ((2*oRectPage["height"]/3 + oRectPage["top"])  - oRectMessageToast["height"] / 2);
		if (oRectMessageToast["height"] > 100)
			this["setTop"](oRectPage["top"] + oRectPage["height"] - oRectMessageToast["height"]);
		else
			this["setTop"](oRectPage["top"] + oRectPage["height"] - 3*oRectMessageToast["height"]/2);
		this["setLeft"]((oRectPage["width"]) / 2 + oRectPage["left"] - oRectMessageToast["width"] / 2);
	}
	else {
		this["oOpenerRef"] = this["oLS"]["oGetPageInternal"]()["oDomRef"];
		oRectPage = UCF_DomUtil["oGetParentScrollContainer"](this["oOpenerRef"])["getBoundingClientRect"]();
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iTopPosition"] = (oRectPage["height"] - oRectPage["top"]) / 1.2 - oRectMessageToast["height"] / 2;
		if (oRectMessageToast["height"] > 100)
			this["setTop"](oRectPage["height"] - oRectPage["top"] - oRectMessageToast["height"]);
		else
			this["setTop"](oRectPage["height"] - oRectPage["top"] - 3*oRectMessageToast["height"]/2);
		this["setLeft"]((oRectPage["width"]) / 2 - oRectPage["left"] - oRectMessageToast["width"] / 2);
	}

	// eslint-disable-next-line @ur/no-memory-leaks
	//UCF_DomUtil.oGetParentScrollContainer(this.oOpenerRef).getBoundingClientRect().height
	// this.iTopPosition = oRectPage.top + oRectPage.height / 1.2 - oRectMessageToast.height / 2;

	if (this["fadeInInterval"]) UCF_JsUtil["clearIntervalCall"](this["fadeInInterval"]);
	if (this["fadeOutInterval"]) UCF_JsUtil["clearIntervalCall"](this["fadeOutInterval"]);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["fadeOutInterval"] = null;

	// eslint-disable-next-line @ur/no-memory-leaks
	this["fadeInInterval"] = UCF_JsUtil["intervalCall"](15, this, 'fadeIn');

	// update control within DOM
	this["checkRootRef"]();

	// open layered control and implicit set position
	this["openBase"]();

	UCF_DomUtil["attachEvent"](this["oRootRef"], "mouseover", UCF_MessageToast["onmouseover"]);
	UCF_DomUtil["attachEvent"](this["oRootRef"], "mouseout", UCF_MessageToast["onmouseout"]);

	// set auto close of this MessageToast after a given time
	var bWithoutCloseTimeout = false;
	if (!this["iDuration"] || this["iDuration"] === 0)
		this["iDuration"] = 5000; // five seconds
	if (this["getClientControl"]())
		this["setClientProperty"]("Duration", this["iDuration"], true);
	if (this["iDuration"] > 0 && !bWithoutCloseTimeout) {
		this["prepareClose"](this["iDuration"]);
	}

	// set state to opened and shown
	this["notifyLayerVisible"]();
	UCF_MessageToast["bIsShown"] = true;
	UCF_MessageToast["bIsOpened"] = true;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "MessageToast shown!!!! ", "MessageToast.js(226): show"); };
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["show"] = 0; };


UCF_MessageToast["prototype"]["fadeIn"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["fadeIn"]++; }; 
	if (!this["oRootRef"]){
		UCF_JsUtil["clearIntervalCall"](this["fadeInInterval"]);
		this["fadeInInterval"] = null;
		return;
	}
	var iTop = this["oRootRef"]["offsetTop"];
	if (this["oRootRef"]["style"]["opacity"] !== 1)
		this["oRootRef"]["style"]["opacity"] = this["oRootRef"]["style"]["opacity"] + 0.2;
	iTop -= 5;
	if (iTop <= this["iTopPosition"]){
		this["oRootRef"]["style"]["opacity"] = 1;
		UCF_JsUtil["clearIntervalCall"](this["fadeInInterval"]);
		this["fadeInInterval"] = null;
		return;
	}
	//this.setTop(iTop);
	this["oRootRef"]["style"]["top"]=iTop+'px';
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["fadeIn"] = 0; };

/**
 * Opens the MessageToast control
 *
 * @param {int} iLeft left position where the MessageToast should open
 * @param {int} iTop top position where the MessageToast should open
 */
UCF_MessageToast["prototype"]["open"] = function(iLeft, iTop) {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["open"]++; }; 
	if (UCF_MessageToast["bIsOpened"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "MessageToast already opened for a control.", "MessageToast.js(258): open"); };
		return; // exit if another MessageToast is opened
	}

	if (!this["sText"] || this["sText"]["length"] <= 0) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "MessageToast has no text! ", "MessageToast.js(263): open"); };
		return; // exit if no text is available for MessageToast
	}

	UCF_MessageToast["bIsOpened"] = true;
	UCF_MessageToast["bMouseOver"] = false;
	this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "close");
	this["sTimerIdShow"] = UCF_JsUtil["delayedCall"](1000, this, "show");
	UCF_MessageToast["iLeft"] = iLeft;
	UCF_MessageToast["iTop"] = iTop;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "MessageToast opened !!!!", "MessageToast.js(273): open"); };
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["open"] = 0; };

/**
 * Closes the MessageToast after a given time. If user interacts in this time
 * the MessageToast will be shown furthermore
 * @param {int} timeout
 */
UCF_MessageToast["prototype"]["prepareClose"] = function(timeout) {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["prepareClose"]++; }; 
	UCF_MessageToast["bIsClosing"] = true;
	this["sTimerIdClose"] = UCF_JsUtil["delayedCall"](timeout, this, "startFadeOut");
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["prepareClose"] = 0; };

UCF_MessageToast["prototype"]["startFadeOut"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["startFadeOut"]++; }; 
		// eslint-disable-next-line @ur/no-memory-leaks
		this["fadeOutOpacity"] = 1;
		// eslint-disable-next-line @ur/no-memory-leaks
		this["fadeOutInterval"] = UCF_JsUtil["intervalCall"](10, this, 'fadeOut');
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["startFadeOut"] = 0; };

UCF_MessageToast["prototype"]["fadeOut"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["fadeOut"]++; }; 
	if (UCF_MessageToast["bMouseOver"])
		return;
	if (!this["oRootRef"]) {
		UCF_JsUtil["clearIntervalCall"](this["fadeOutInterval"]);
		this["fadeOutInterval"] = null;
		return;
	}
	this["fadeOutOpacity"] = this["fadeOutOpacity"] - 0.01;
	this["oRootRef"]["style"]["opacity"] = this["fadeOutOpacity"]; // + '%';
	if (this["fadeOutOpacity"] < 0.01) {
		UCF_JsUtil["clearIntervalCall"](this["fadeOutInterval"]);
		this["fadeOutInterval"] = null;
		this["close"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["fadeOut"] = 0; };

/**
 * Closes the MessageToast
 */
UCF_MessageToast["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["close"]++; }; 
	// check if a MessageToast is available for closing
	if (!UCF_MessageToast["bIsOpened"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "MessageToast is opened!!!", "MessageToast.js(316): close"); };
		return;
	}
	UCF_MessageToast["bMouseOver"] = false;
	// this stops delayed calls for closing and showing of MessageToast
	UCF_JsUtil["clearDelayedCall"](this["sTimerIdClose"]); //clear timer of method 'close'
	UCF_JsUtil["clearDelayedCall"](this["sTimerIdShow"]); //clear timer of method 'show'

	if (this["fadeInInterval"]) UCF_JsUtil["clearIntervalCall"](this["fadeInInterval"]);
	if (this["fadeOutInterval"]) UCF_JsUtil["clearIntervalCall"](this["fadeOutInterval"]);

	UCF_DomUtil["detachEvent"](this["oRootRef"], "mouseover", UCF_MessageToast["onmouseover"]);
	UCF_DomUtil["detachEvent"](this["oRootRef"], "mouseout", UCF_MessageToast["onmouseout"]);

	// hide this MessageToast
//	if (UCF_MessageToast.bIsShown) {
		var oStyle = UCF_MessageToast["oGUI"]["style"];
		oStyle["left"] = "-70000";
		oStyle["visibility"] = "hidden";
//	}

	// detach closing for this MessageToast when page is closed
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "close");

	// hide Layered Control
	this["closeBase"]();

	// reset global variables to initial state
	UCF_MessageToast["bIsShown"] = false;
	UCF_MessageToast["bIsOpened"] = false;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "MessageToast closed !!!! ", "MessageToast.js(346): close"); };
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["close"] = 0; };

/**
 * Handles the mouseover event
 * @param {Object} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MessageToast["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["onmouseover"]++; }; 
	UCF_MessageToast["bMouseOver"] = true;
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["onmouseover"] = 0; };
/**
 * Handles the mouseout event
 * @private
 * @param {Object} oBrowserEvent the browser event object that occurred
 */
UCF_MessageToast["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["onmouseout"]++; }; 
	UCF_MessageToast["bMouseOver"] = false;
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["onmouseout"] = 0; };
/**
 * @private
 * @param {string} sId the id of the control
 * @return {HTMLElement} oRenderManager the render manager
 */
UCF_MessageToast["prototype"]["renderContent"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["renderContent"]++; }; 
	/** @type {UCF_RenderManager} */
	var oRenderManager;
	/** @type {HTMLElement} */
	var oContentHTML;

	oRenderManager = this["oLS"]["oGetRenderManager"]();
	oRenderManager["write"](this["oLS"]["oGetRenderManager"]()["callFragment"](
		'MessageToastContentFragment',
		'MessageToast', {
			"Id": sId,
			"Text": this["sText"]
		}
	));

	oContentHTML = oRenderManager["oGetElementFromHtml"]();
	oRenderManager["clearBuffer"]();
	return oContentHTML;

};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["renderContent"] = 0; };

/**
 * Sets the Text for the MessageToast control.
 * @public
 * @param {string} sText
 */
UCF_MessageToast["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["setText"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sText) === "string", "typeof(sText) === \"string\"", "MessageToast.js(397): setText"); };
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sText"] = sText;
	if (this["getClientControl"]())
		this["setClientProperty"]("Text", this["sText"], true);
	else
		UCF_DomUtil["setInnerHtml"](this["oRootRef"], sText);
	this["remove"]();
	UCF_MessageToast["oGUI"] = this["oRootRef"] = this["oGetDomRef"]();

};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["setText"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_MessageToast["prototype"]["aAttributeNames"] = ["sText","sOpenerId","iDuration"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_MessageToast["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_MessageToast["prototype"]["aMethodNames"] = ["setText","show","close","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_MessageToast["prototype"]["sText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessageToast["prototype"]["sOpenerId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_MessageToast["prototype"]["iDuration"] = 5000;

//#JSCOVER_EXCL_START
/** @protected */
UCF_MessageToast["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["sOpenerId"] = '';
	this["iDuration"] = 5000;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("OpenerId", '', true);
		this["setClientProperty"]("Duration", 5000, true);
	}
};;if (__UCF_COVERAGE__) { UCF_MessageToast["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_MessageToast.prototype["aPublicMethods"] = ["setText"].concat(UCF_MessageToast.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_MessagingTrigger"] = function() {/* global _assert, _trace, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MessagingTrigger(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["UCF_MessagingTrigger"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "MessagingTrigger.js(19): UCF_MessagingTrigger"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "MessagingTrigger.js(20): UCF_MessagingTrigger"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "MessagingTrigger.js(21): UCF_MessagingTrigger"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["sSubscribedTo"] = null;
	this["oServiceProvider"] = null;
	this["bKeepAlive"] = true;
};window["UCF_MessagingTrigger"] = UCF_MessagingTrigger; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MessagingTrigger"); UCF_MessagingTrigger["_"] = {UCF_MessagingTrigger: 0}; }; ;

UCF_MessagingTrigger["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_MessagingTrigger.prototype["sClassName"] = "UCF_MessagingTrigger";

UCF_MessagingTrigger["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["initialize"]++; }; 
	if ((!this["bEnabled"] && this["sSubscribedTo"]) || (this["sSubscribedTo"] && this["sSubscribedTo"] != this["sMessageName"]))
		this["disconnect"](this["sSubscribedTo"]);

	if (this["bEnabled"] && this["sMessageName"] && this["sSubscribedTo"] != this["sMessageName"])
		this["connect"](this["sMessageName"]);
};;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["initialize"] = 0; };

UCF_MessagingTrigger["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["destroy"]++; }; 
	this["disconnect"](this["sMessageName"]);
	this["oServiceProvider"] = null;
	this["sSubscribedTo"] = null;
	this["bKeepAlive"] = false;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["destroy"] = 0; };

UCF_MessagingTrigger["prototype"]["connect"] = function(sMessageName) {;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["connect"]++; }; 
	if (!this["sSubscribedTo"] && this["bEnabled"]) {
		this["oServiceProvider"] = this["oLS"]["oControlFactory"]["oGetControlById"](this["sServiceProviderId"]);

		if (this["oServiceProvider"]) {
			this["oServiceProvider"]["subscribeMessage"](sMessageName, this["sId"]);
			this["oServiceProvider"]["attachEvent"](this["oServiceProvider"]["E_EVENTS"]["InternalReceive"], this, "onReceive");
			this["sSubscribedTo"] = sMessageName;
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Did not find service provider \"" + this["sServiceProviderId"] + "\". Connection failed", "MessagingTrigger.js(57): connect"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["connect"] = 0; };

UCF_MessagingTrigger["prototype"]["disconnect"] = function(sMessageName) {;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["disconnect"]++; }; 
	if (this["sSubscribedTo"]) {
		this["oServiceProvider"] = this["oLS"]["oControlFactory"]["oGetControlById"](this["sServiceProviderId"]);

		if (this["oServiceProvider"]) {
			this["oServiceProvider"]["unsubscribeMessage"](sMessageName, this["sId"]);
			this["oServiceProvider"]["detachEvent"](this["oServiceProvider"]["E_EVENTS"]["InternalReceive"], this);
			this["sSubscribedTo"] = null;
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Did not find service provider \"" + this["sServiceProviderId"] + "\". Connection failed", "MessagingTrigger.js(71): disconnect"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["disconnect"] = 0; };

UCF_MessagingTrigger["prototype"]["onReceive"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["onReceive"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "MessagingTrigger.js(77): onReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "MessagingTrigger.js(78): onReceive"); };

	this["fireReceive"](this["sId"], this["sMessageName"], oEvent["oGetParam"]("sData"));
};;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["onReceive"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_MessagingTrigger["prototype"]["aAttributeNames"] = ["sServiceProviderId","sMessageName","bEnabled","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_MessagingTrigger["prototype"]["aEventNames"] = ["Receive"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_MessagingTrigger["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_MessagingTrigger["prototype"]["sServiceProviderId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MessagingTrigger["prototype"]["sMessageName"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_MessagingTrigger["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_MessagingTrigger["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_MessagingTrigger["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["setDefaultValues"]++; }; 
	this["sServiceProviderId"] = '';
	this["sMessageName"] = '';
	this["bEnabled"] = true;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("ServiceProviderId", '', true);
		this["setClientProperty"]("MessageName", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sName Name of the message
 * @param {string} sData Message payload
 * @fires MessagingTrigger::Receive
 */
UCF_MessagingTrigger["prototype"]["fireReceive"] = function(sId, sName, sData) {;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["fireReceive"]++; }; 
	/** @type {{Id: string, Name: string, Data: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "MessagingTrigger.js(156): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MessagingTrigger.js(157): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MessagingTrigger.js(158): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != null, "sName != null", "MessagingTrigger.js(159): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) == "string", "typeof(sName) == \"string\"", "MessagingTrigger.js(160): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "MessagingTrigger.js(161): fireReceive"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "MessagingTrigger.js(162): fireReceive"); };
	mParams = {
		"Id": sId,
		"Name": sName,
		"Data": sData
	};
	
	
	
	this["fireSemanticEvent"]("MessagingTrigger", "Receive", mParams, true, false, false);
};;if (__UCF_COVERAGE__) { UCF_MessagingTrigger["_"]["fireReceive"] = 0; };

};
sap["ls"]["preload"]["UCF_Model"] = function() {/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_EventProvider */
/// <reference path="../../core/EventProvider.js"/>
/* global UCF_BindingContext */
/// <reference path="BindingContext.js" />

/**
 * @typedef {Object} UCF_Model_BindingModes
 * @property {boolean} OneWay
 * @property {boolean} TwoWay
 * @property {boolean} OneTime
 */

/**
 * The Data Binding API.
 *
 * The default binding mode for model implementations (if not implemented
 * otherwise) is two way and the supported binding modes by the model are one
 * way, two way and one time. The default binding mode can be changed by the
 * application for each model instance. A model implementation should specify
 * its supported binding modes and set the default binding mode accordingly
 * (e.g. if the model supports only one way binding the default binding mode
 * should also be set to one way).
 *
 * @namespace
 * @name sap.ui.model
 * @public
 */

/**
 * Constructor for a new Model.
 *
 *
 * This is an abstract base class for model objects.
 * @class
 * @extends sap.ui.base.Object
 *
 * 
 * @version 1.7.0-SNAPSHOT
 *
 * @constructor
 * @public
 */
function UCF_Model() {if (__UCF_COVERAGE__) { UCF_Model["_"]["UCF_Model"]++; }; 
	UCF_EventProvider["apply"](this, arguments);

	this["defineEvents"]([
		/**
		 * Depending on the model implementation a ParseError should be fired if a
		 * parse error occurred. Contains the parameters:
		 * errorCode, url, reason, srcText, line, linepos, filepos
		 */
		'ParseError',
		/**
		 * Depending on the model implementation a RequestFailed should be fired if
		 * a request to a backend failed. Contains the parameters:
		 * message, statusCode, statusText and responseText
		 */
		'RequestFailed',
		/**
		 * Depending on the model implementation a RequestSent should be fired when
		 * a request to a backend is sent. Contains Parameters: url, type, async,
		 * info
		 */
		'RequestSend',
		/**
		 * Depending on the model implementation a RequestCompleted should be fired
		 * when a request to a backend is completed regardless if the request
		 * failed or succeeded. Contains Parameters:
		 * url, type, async, info
		 */
		'RequestCompleted'
	]);

	UCF_ClassLoader["oGetClass"]('UCF_BindingContext');

	this["oData"] = {};
	this["aBindings"] = [];
	/** @type {Object<string,UCF_BindingContext>} */
	this["mContexts"] = {};
	/** @type {number} */
	this["iSizeLimit"] = 1000000;
	/** @type {string} */
	this["sDefaultBindingMode"] = 'TwoWay';
	/** @type {UCF_Model_BindingModes} */
	this["mSupportedBindingModes"] = {"OneWay": true, "TwoWay": true, "OneTime": true};
	/** @type {boolean} */
	this["bLegacySyntax"] = false;
	/** @type {boolean} */
	this["bLocked"] = false;
};window["UCF_Model"] = UCF_Model; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Model"); UCF_Model["_"] = {UCF_Model: 0}; }; ;
UCF_Model["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_Model.prototype["sClassName"] = "UCF_Model";

/** @override */
UCF_Model["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Model["_"]["destroy"]++; }; 
	this["iSizeLimit"] = null;
	this["sDefaultBindingMode"] = null;
	this["bLegacySyntax"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["destroy"] = 0; };

/**
 * The 'requestFailed' event is fired, when data retrieval from a backend
 * failed.
 *
 * @public
 * @event
 * @name UCF_Model#requestFailed
 * @param {sap.ui.base.Event} oControlEvent
 * @param {sap.ui.base.EventProvider} oControlEvent.getSource
 * @param {Object} oControlEvent.getParameters
 * @param {string} oControlEvent.getParameters.message A text that describes
 * the failure.
 * @param {string} oControlEvent.getParameters.statusCode HTTP status code
 * returned by the request (if available)
 * @param {string} oControlEvent.getParameters.statusText The status as a text,
 * details not specified, intended only for diagnosis output
 * @param {string} oControlEvent.getParameters.responseText Response that has
 * been received for the request ,as a text string
 */

/**
 * Attach event-handler <code>fnFunction</code> to the 'requestFailed' event of
 * this <code>UCF_Model</code>.<br/>
 *
 * @public
 * @param {Object} oListener Object on which to call the given function. If
 * empty, this Model is used.
 * @param {function} fnFunction The function to call, when the event occurs.
 * This function will be called on the oListener-instance (if present) or in a
 * 'static way'.
 * @return {UCF_Model} <code>this</code> to allow method chaining
 */
UCF_Model["prototype"]["attachRequestFailed"] = function(oListener, fnFunction) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["attachRequestFailed"]++; }; 
	this["attachEvent"](this["E_EVENTS"]["RequestFailed"], oListener, fnFunction);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["attachRequestFailed"] = 0; };

/**
 * Detach event-handler <code>fnFunction</code> from the 'requestFailed' event
 * of this <code>UCF_Model</code>.<br/>
 *
 * The passed function and listener object must match the ones previously used
 * for event registration.
 *
 * @public
 * @param {Object} oListener Object on which to call the given function. If
 * empty, this Model is used.
 * @param {function} fnFunction The function to call, when the event occurs.
 * This function will be called on the oListener-instance (if present) or in a
 * 'static way'.
 * @return {UCF_Model} <code>this</code> to allow method chaining
 */
UCF_Model["prototype"]["detachRequestFailed"] = function(oListener, fnFunction) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["detachRequestFailed"]++; }; 
	this["detachEvent"](this["E_EVENTS"]["RequestFailed"], oListener, fnFunction);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["detachRequestFailed"] = 0; };

/**
 * Fire event requestFailed to attached listeners.
 *
 * Expects following event parameters:
 * <ul>
 * <li>'message' of type <code>string</code> A text that describes the
 * failure.</li>
 * <li>'statusCode' of type <code>string</code> HTTP status code returned by
 * the request (if available)</li>
 * <li>'statusText' of type <code>string</code> The status as a text, details
 * not specified, intended only for diagnosis output</li>
 * <li>'responseText' of type <code>string</code> Response that has been
 * received for the request ,as a text string</li>
 * </ul>
 *
 * @protected
 * @param {Map} [mArguments] the arguments to pass along with the event.
 * @return {UCF_Model} <code>this</code> to allow method chaining
 */
UCF_Model["prototype"]["fireRequestFailed"] = function(mArguments) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["fireRequestFailed"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["RequestFailed"], mArguments);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["fireRequestFailed"] = 0; };

/**
 * The 'parseError' event is fired when parsing of a model document (e.g. XML
 * response) fails.
 *
 * @public
 * @name UCF_Model#parseError
 * @event
 * @param {sap.ui.base.Event} oControlEvent
 * @param {sap.ui.base.EventProvider} oControlEvent.getSource
 * @param {Object} oControlEvent.getParameters
 * @param {int} oControlEvent.getParameters.errorCode
 * @param {string} oControlEvent.getParameters.url
 * @param {string} oControlEvent.getParameters.reason
 * @param {string} oControlEvent.getParameters.srcText
 * @param {int} oControlEvent.getParameters.line
 * @param {int} oControlEvent.getParameters.linepos
 * @param {int} oControlEvent.getParameters.filepos
 */

/**
 * Attach event-handler <code>fnFunction</code> to the 'parseError' event of
 * this <code>UCF_Model</code>.<br/>
 *
 * @public
 * @param {Object} [oListener] Object on which to call the given function. If
 * empty, the global context (window) is used.
 * @param {function} fnFunction The function to call, when the event occurs.
 * This function will be called on the oListener-instance (if present) or in a
 * 'static way'.
 * @return {UCF_Model} <code>this</code> to allow method chaining
 */
UCF_Model["prototype"]["attachParseError"] = function(oListener, fnFunction) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["attachParseError"]++; }; 
	this["attachEvent"](this["E_EVENTS"]["ParseError"], oListener, fnFunction);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["attachParseError"] = 0; };

/**
 * Detach event-handler <code>fnFunction</code> from the 'parseError' event of
 * this <code>UCF_Model</code>.<br/>
 *
 * The passed function and listener object must match the ones previously used
 * for event registration.
 *
 * @public
 * @param {function} fnFunction The function to call, when the event occurs.
 * @param {Object} [oListener] Object on which to call the given function. If
 * empty, the global context (window) is used.
 * @return {UCF_Model} <code>this</code> to allow method chaining
 */
UCF_Model["prototype"]["detachParseError"] = function(fnFunction, oListener) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["detachParseError"]++; }; 
	this["detachEvent"](this["E_EVENTS"]["ParseError"], fnFunction, oListener);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["detachParseError"] = 0; };

/**
 * Fire event parseError to attached listeners.
 *
 * Expects following event parameters:
 * <ul>
 * <li>'errorCode' of type <code>int</code> </li>
 * <li>'url' of type <code>string</code> </li>
 * <li>'reason' of type <code>string</code> </li>
 * <li>'srcText' of type <code>string</code> </li>
 * <li>'line' of type <code>int</code> </li>
 * <li>'linepos' of type <code>int</code> </li>
 * <li>'filepos' of type <code>int</code> </li>
 * </ul>
 *
 * @protected
 * @param {Object} [mArguments] the arguments to pass along with the event.
 * @return {UCF_Model} <code>this</code> to allow method chaining
 */
UCF_Model["prototype"]["fireParseError"] = function(mArguments) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["fireParseError"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["ParseError"], mArguments);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["fireParseError"] = 0; };

/**
 * Attach event-handler <code>fnFunction</code> to the 'requestSent' event of
 * this <code>UCF_Model</code>.<br/>
 *
 * @public
 * @param {Object} [oData] The object, that should be passed along with the
 * event-object when firing the event.
 * @param {function} fnFunction The function to call, when the event occurs.
 * This function will be called on the oListener-instance (if present) or in a
 * 'static way'.
 * @param {Object} [oListener] Object on which to call the given function. If
 * empty, the global context (window) is used.
 * @return {UCF_Model} <code>this</code> to allow method chaining
 */
UCF_Model["prototype"]["attachRequestSent"] = function(oData, fnFunction, oListener) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["attachRequestSent"]++; }; 
	this["attachEvent"](this["E_EVENTS"]["RequestSent"], oData, fnFunction, oListener);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["attachRequestSent"] = 0; };

/**
 * Detach event-handler <code>fnFunction</code> from the 'requestSent' event of
 * this <code>UCF_Model</code>.<br/>
 *
 * The passed function and listener object must match the ones previously used
 * for event registration.
 *
 * @public
 * @param {function} fnFunction The function to call, when the event occurs.
 * @param {Object} oListener Object on which the given function had to be
 * called.
 * @return {UCF_Model} <code>this</code> to allow method chaining
 */
UCF_Model["prototype"]["detachRequestSent"] = function(fnFunction, oListener) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["detachRequestSent"]++; }; 
	this["detachEvent"](this["E_EVENTS"]["RequestSent"], fnFunction, oListener);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["detachRequestSent"] = 0; };

/**
 * Fire event requestSent to attached listeners.
 *
 * Expects following event parameters:
 * <ul>
 * <li>'url' of type <code>string</code> The url which is sent to the
 * backend.</li>
 * <li>'type' of type <code>string</code> The type of the request (if
 * available)</li>
 * <li>'async' of type <code>boolean</code> If the request is synchronous or
 * asynchronous (if available)</li>
 * <li>'info' of type <code>string</code> additional information for the
 * request (if available)</li>
 * </ul>
 *
 * @protected
 * @param {Object} [mArguments] the arguments to pass along with the event.
 * @return {UCF_Model} <code>this</code> to allow method chaining
 */
UCF_Model["prototype"]["fireRequestSent"] = function(mArguments) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["fireRequestSent"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["RequestSent"], mArguments);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["fireRequestSent"] = 0; };

/**
 * Attach event-handler <code>fnFunction</code> to the 'requestCompleted' event
 * of this <code>UCF_Model</code>.<br/>
 *
 * @param {Object} [oData] The object, that should be passed along with the
 * event-object when firing the event.
 * @param {function} fnFunction The function to call, when the event occurs.
 * This function will be called on the oListener-instance (if present) or in a
 * 'static way'.
 * @param {Object} [oListener] Object on which to call the given function. If
 * empty, the global context (window) is used.
 *
 * @return {UCF_Model} <code>this</code> to allow method chaining
 * @public
 */
UCF_Model["prototype"]["attachRequestCompleted"] = function(oData, fnFunction, oListener) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["attachRequestCompleted"]++; }; 
	this["attachEvent"](this["E_EVENTS"]["RequestCompleted"], oData, fnFunction, oListener);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["attachRequestCompleted"] = 0; };

/**
 * Detach event-handler <code>fnFunction</code> from the 'requestCompleted'
 * event of this <code>UCF_Model</code>.<br/>
 *
 * The passed function and listener object must match the ones previously used
 * for event registration.
 *
 * @public
 * @param {function} fnFunction The function to call, when the event occurs.
 * @param {Object} oListener Object on which the given function had to be
 * called.
 * @return {UCF_Model} <code>this</code> to allow method chaining
 */
UCF_Model["prototype"]["detachRequestCompleted"] = function(fnFunction, oListener) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["detachRequestCompleted"]++; }; 
	this["detachEvent"](this["E_EVENTS"]["RequestCompleted"], fnFunction, oListener);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["detachRequestCompleted"] = 0; };

/**
 * Fire event requestCompleted to attached listeners.
 *
 * Expects following event parameters:
 * <ul>
 * <li>'url' of type <code>string</code> The url which was sent to the
 * backend.</li>
 * <li>'type' of type <code>string</code> The type of the request (if
 * available)</li>
 * <li>'async' of type <code>boolean</code> If the request was synchronous or
 * asynchronous (if available)</li>
 * <li>'info' of type <code>string</code> additional information for the
 * request (if available)</li>
 * </ul>
 *
 * @protected
 * @param {Object} [mArguments] the arguments to pass along with the event.
 * @return {UCF_Model} <code>this</code> to allow method chaining
 */
UCF_Model["prototype"]["fireRequestCompleted"] = function(mArguments) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["fireRequestCompleted"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["RequestCompleted"], mArguments);

	return this;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["fireRequestCompleted"] = 0; };

// the 'abstract methods' to be implemented by child classes

/**
 * Implement in inheriting classes
 *
 * @public
 * @abstract
 * @function
 * @name UCF_Model.prototype.bindProperty
 * @param {string} sPath the path pointing to the property that should be bound
 * @param {Object} [oContext] the context object for this databinding
 * @param {Object} [mParameters] additional model specific parameters
 * @return {UCF_PropertyBinding}
 */

/**
 * Implement in inheriting classes
 *
 * @public
 * @abstract
 * @function
 * @name UCF_Model.prototype.bindList
 * @param {string} sPath the path pointing to the list/array that should be
 * bound
 * @param {Object} [oContext] the context object for this databinding
 * @param {UCF_Sorter} [oSorter] initial sort order
 * @param {Array} [aFilters] predefined filter/s contained in an array
 * @param {Object} [mParameters] additional model specific parameters
 * @return {UCF_ListBinding}
 */

/**
 * Implement in inheriting classes
 *
 * @public
 * @abstract
 * @function
 * @name UCF_Model.prototype.bindGrid
 * @param {string} sPath the path pointing to the grid data that uses x-y as
 * key in an associative array that should be bound
 * @param {Object} [oContext] the context object for this databinding
 * @param {UCF_Sorter} [oSorter] initial sort order
 * @param {Array} [aFilters] predefined filter/s contained in an array
 * @param {Object} [mParameters] additional model specific parameters
 * @return {UCF_ListBinding}
 */

/**
 * Implement in inheriting classes
 *
 * @public
 * @abstract
 * @function
 * @name UCF_Model.prototype.bindTree
 * @param {string} sPath the path pointing to the tree/array that should be
 * bound
 * @param {Object} [oContext] the context object for this databinding
 * @param {Array} [aFilters] predefined filter/s contained in an array
 * @param {Object} [mParameters] additional model specific parameters
 * @return {UCF_TreeBinding}
 */

/**
 * Implement in inheriting classes
 *
 * @public
 * @abstract
 * @function
 * @name UCF_Model.prototype.createBindingContext
 * @param {string} sPath the path to create the new context from
 * @param {Object} [oContext] the context which should be used to create the
 * new binding context
 * @param {Object} [mParameters] the parameters used to create the new binding
 * context
 * @param {function} fnCallBack the function which should be called after the
 * binding context has been created
 */

/**
 * Implement in inheriting classes
 *
 * @public
 * @abstract
 * @function
 * @name UCF_Model.prototype.destroyBindingContext
 * @param {Object} oContext to destroy
 */

/**
 * Implement in inheriting classes
 *
 * @public
 * @abstract
 * @function
 * @name UCF_Model.prototype.getProperty
 * @param {string} sPath the path to where to read the attribute value
 * @param {Object} [oContext] the context with which the path should be
 * resolved
 */

/**
 * Gets a binding context. If context already exists, return it from the map,
 * otherwise create one using the context constructor.
 *
 * @param {string} sPath the path
 * @return {UCF_BindingContext}
 */
UCF_Model["prototype"]["getContext"] = function(sPath) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["getContext"]++; }; 
	/** @type {UCF_BindingContext} */
	var oContext = this["mContexts"][sPath];

	if (!oContext) {
		oContext = new (UCF_ClassLoader["oGetClass"]("UCF_BindingContext"))(this, sPath);
		this["mContexts"][sPath] = oContext;
	}

	return oContext;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["getContext"] = 0; };

/**
 * Resolve the path relative to the given context
 * @param {string} sPath the path
 * @param {Object} oContext the context
 * @return {string}
 */
UCF_Model["prototype"]["resolve"] = function(sPath, oContext) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["resolve"]++; }; 
	/** @type {boolean} */
	var bIsRelative = !UCF_StringUtil["bStartsWith"](sPath, '/');
	/** @type {string} */
	var sResolvedPath = sPath;
	/** @type {string} */
	var sContextPath;

	if (bIsRelative) {
		if (oContext) {
			sContextPath = oContext["getPath"]();
			sResolvedPath = sContextPath +
				(UCF_StringUtil["bEndsWith"](sContextPath, '/') ? '' : '/') +
				sPath;
		} else {
			sResolvedPath = this["isLegacySyntax"]() ? '/' + sPath : '';
		}
	}
	if (UCF_StringUtil["bEndsWith"](sResolvedPath, '/')) {
		sResolvedPath = sResolvedPath["substr"](0, sResolvedPath["length"] - 1);
	}

	return sResolvedPath;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["resolve"] = 0; };

/**
 * Add a binding to this model
 *
 * @param {UCF_Binding} oBinding the binding to be added
 */
UCF_Model["prototype"]["addBinding"] = function(oBinding) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["addBinding"]++; }; 
	this["aBindings"]["push"](oBinding);
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["addBinding"] = 0; };

/**
 * Remove a binding from the model
 *
 * @param {UCF_Binding} oBinding the binding to be removed
 */
UCF_Model["prototype"]["removeBinding"] = function(oBinding) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["removeBinding"]++; }; 
	/** @type {number} */
	var i;

	for (i = 0; i < this["aBindings"]["length"]; i++) {
		if (this["aBindings"][i] === oBinding) {
			this["aBindings"]["splice"](i, 1);
			break;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["removeBinding"] = 0; };

/**
 * Get the default binding mode for the model
 *
 * @public
 * @return {UCF_Binding_Mode} default binding mode of the model
 */
UCF_Model["prototype"]["getDefaultBindingMode"] = function() {;if (__UCF_COVERAGE__) { UCF_Model["_"]["getDefaultBindingMode"]++; }; 
	return this["sDefaultBindingMode"];
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["getDefaultBindingMode"] = 0; };

/**
 * Set the default binding mode for the model. If the default binding mode
 * should be changed, this method should be called directly after model
 * instance creation and before any binding creation. Otherwise it is not
 * guaranteed that the existing bindings will be updated with the new binding
 * mode.
 *
 * @public
 * @param {UCF_Binding_Mode} sMode the default binding mode to set for the
 * model
 */
UCF_Model["prototype"]["setDefaultBindingMode"] = function(sMode) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["setDefaultBindingMode"]++; }; 
	if (this["isBindingModeSupported"](sMode)) {
		this["sDefaultBindingMode"] = sMode;
	} else {
		throw new Error('Binding mode ' + sMode + ' is not supported by this model.');
	}
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["setDefaultBindingMode"] = 0; };

/**
 * Check if the specified binding mode is supported by the model.
 *
 * @param {UCF_Binding_Mode} sMode the binding mode to check
 * @return {boolean}
 *
 * @public
 */
UCF_Model["prototype"]["isBindingModeSupported"] = function(sMode) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["isBindingModeSupported"]++; }; 
	return (sMode in this["mSupportedBindingModes"]);
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["isBindingModeSupported"] = 0; };

/**
 * Enables legacy path syntax handling
 *
 * This defines, whether relative bindings, which do not have a defined
 * binding context, should be compatible to earlier releases which means
 * they are resolved relative to the root element or handled strict and
 * stay unresolved until a binding context is set
 *
 * @param {boolean} bLegacySyntax the path syntax to use
 *
 * @public
 */
UCF_Model["prototype"]["setLegacySyntax"] = function(bLegacySyntax) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["setLegacySyntax"]++; }; 
	this["bLegacySyntax"] = bLegacySyntax;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["setLegacySyntax"] = 0; };

/**
 * Returns whether legacy path syntax is used
 *
 * @return {boolean}
 *
 * @public
 */
UCF_Model["prototype"]["isLegacySyntax"] = function() {;if (__UCF_COVERAGE__) { UCF_Model["_"]["isLegacySyntax"]++; }; 
	return this["bLegacySyntax"];
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["isLegacySyntax"] = 0; };

/**
 * Set the maximum number of entries which are used for for list bindings.
 * @param {int} iSizeLimit size limit
 * @public
 */
UCF_Model["prototype"]["setSizeLimit"] = function(iSizeLimit) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["setSizeLimit"]++; }; 
	this["iSizeLimit"] = iSizeLimit;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["setSizeLimit"] = 0; };

/**
 * Returns the controls that are currently bound to the given path.
 * @param {string} sPath
 * @param {boolean} bIncludeParentPath
 * @param {string} sClassName
 * @return {UCF_ClientElement[]}
 */
UCF_Model["prototype"]["getBoundControls"] = function(sPath, bIncludeParentPath, sClassName) {;if (__UCF_COVERAGE__) { UCF_Model["_"]["getBoundControls"]++; }; 
	/** @type {UCF_ClientElement[]} */
	var aControls = [];
	/** @type {number} */
	var i;
	/** @type {UCF_Binding} */
	var oBinding;
	/** @type {string} */
	var sBindingPath;
	/** @type {boolean} */
	var bRelevant;
	/** @type {UCF_ClientElement} */
	var oListener;

	if (sPath["indexOf"]('>') > -1) {
		sPath = sPath["substring"](sPath["indexOf"]('>') + 1);
	}
	for (i = 0; i < this["aBindings"]["length"]; i++) {
		oBinding = this["aBindings"][i];
		sBindingPath = oBinding["getAbsolutePath"]();
		bRelevant = false;

		if (bIncludeParentPath) {
			if (sBindingPath["indexOf"](sPath) === 0) {
				bRelevant = true;
			}
		} else if (sPath === sBindingPath) {
			bRelevant = true;
		}

		if (bRelevant) {
			oListener = oBinding["oListener"];

			if (UCF_JsUtil["bInstanceOf"](oListener, 'UCF_ClientElement')) {
				oListener = oListener["getUCFInstance"]();
				if (oListener && ((sClassName && oListener["sClassName"] === sClassName) || !sClassName)) {
					aControls["push"](oListener);
				}
			}
		}
	}

	return aControls;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["getBoundControls"] = 0; };

/**
 * Sets a locked lag to the model
 */
UCF_Model["prototype"]["lock"] = function() {;if (__UCF_COVERAGE__) { UCF_Model["_"]["lock"]++; }; 
	this["bLocked"] = true;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["lock"] = 0; };

/**
 * Resets the locked flag of the model
 */
UCF_Model["prototype"]["unlock"] = function() {;if (__UCF_COVERAGE__) { UCF_Model["_"]["unlock"]++; }; 
	this["bLocked"] = false;
};;if (__UCF_COVERAGE__) { UCF_Model["_"]["unlock"] = 0; };

UCF_Model.prototype["aPublicMethods"] = ["UCF_Model","attachRequestFailed","detachRequestFailed","attachParseError","detachParseError","attachRequestSent","detachRequestSent","attachRequestCompleted","detachRequestCompleted","getDefaultBindingMode","setDefaultBindingMode","isBindingModeSupported","setLegacySyntax","isLegacySyntax","setSizeLimit"].concat(UCF_Model.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ModelControl"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_JSONModel */
/// <reference path="../model/json/JSONModel.js"/>

/**
 * A Model control that sends requests to the server and initalizes a UCF_JSONModel internally
 *
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 * @param {string} sId
 */
function UCF_ModelControl(oDomRef, oLS, sId) {if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["UCF_ModelControl"]++; }; 
	/** @type {any} */
	var oData;

	if (arguments["length"] > 0) {
		UCF_Control["apply"](this, [oDomRef, oLS, sId]);

		this["oModel"] = new (UCF_ClassLoader["oGetClass"]("UCF_JSONModel"))({});
		oDomRef = this["oDomRef"];
		if (!oDomRef) {
			oDomRef = document["createElement"]("xmp");
			oDomRef["setAttribute"]("id", sId);
			this["sInitialData"] = "{}";
			this["oDomRef"] = oDomRef;
		} else {
			this["sInitialData"] = UCF_DomUtil["sGetInnerText"](oDomRef);
			oDomRef["text"] = ""; //clean the html to avoid large content of elements
		}

		this["oPage"] = this["oLS"]["oGetPageInternal"]();
		if (this["oPage"])
			this["oPage"]["oGetStaticAreaRef"]()["appendChild"](this["oDomRef"]);
		this["oModel"]["setUCFInstance"](this);
		if (this["oPage"])
			this["oPage"]["registerModel"](this["sId"], this["oModel"], this["bIsDefaultModel"]);
		if (this["sId"]) {
			if (this["sIsDefault"]) {
				this["sDefaultModelId"] = this["sId"];
			}
			oData = UCF_JsUtil["oJsonParse"](this["sInitialData"]);

			if (oData) {
				this["setData"](oData);
			}
		}
	}
};window["UCF_ModelControl"] = UCF_ModelControl; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ModelControl"); UCF_ModelControl["_"] = {UCF_ModelControl: 0}; }; ;
UCF_ModelControl["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ModelControl.prototype["sClassName"] = "UCF_ModelControl";

/**
 * Callback for setting the delay for events to the server if they are configured as delayed
 */
UCF_ModelControl["getEventDelay"] = function () {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["getEventDelay"]++; }; 
	return 1;
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["getEventDelay"] = 0; };

/**
 * Initializes the model, meaning registering it to the page
 */
UCF_ModelControl["prototype"]["initialize"] = function () {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["initialize"]++; }; 
	this["oLS"]["oControlFactory"]["updateControlTreeBindings"](this["sId"], false);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["initialize"] = 0; };

/**
 * Updates the bindings for the controls
 * @public
 */
UCF_ModelControl["prototype"]["updateBindings"] = function () {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["updateBindings"]++; }; 
	this["oLS"]["oControlFactory"]["updateControlTreeBindings"](this["sId"], false);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["updateBindings"] = 0; };
/**
 * Sets new data of the model
 * @param {JSONObject} oData the new Data
 * @param {boolean} bMerge defines whether the new data should be merged into the existing data
 */
UCF_ModelControl["prototype"]["setData"] = function (oData, bMerge) {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["setData"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oData) === "object", "typeof (oData) === \"object\"", "ModelControl.js(89): setData"); };
	this["oModel"]["setData"](oData, bMerge);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["setData"] = 0; };

/**
 * Sets new data of for a given paththe model
 * @param {String} sPath the path where the new data should be applied
 * @param {JSONObject} oData the new Data
 * @param {boolean} bMerge defines whether the new data should be merged into the existing data
 */
UCF_ModelControl["prototype"]["setPathData"] = function (sPath, oData, bMerge) {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["setPathData"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (sPath) === "string", "typeof (sPath) === \"string\"", "ModelControl.js(100): setPathData"); };
	this["oModel"]["setPathData"](sPath, oData, bMerge);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["setPathData"] = 0; };

/**
 * Destroys the control and also unregisters the UCF_JSONModel from the page and destroys it.
 */
UCF_ModelControl["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["destroy"]++; }; 
	if (!this["oLS"]["bIsDestroyed"]) {
		this["oPage"]["unregisterModel"](this["sId"]);
		this["oModel"]["setData"]({});
		this["updateBindings"](null, false);
	}
	this["oPage"]["oGetStaticAreaRef"]()["removeChild"](this["oDomRef"]);
	this["oModel"]["destroy"]();
	this["oModel"] = null;
	this["oPage"] = null;
	this["sInitialData"] = "";
	this["sDefaultModelId"] = "";

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["destroy"] = 0; };

/**
 * Locks the model to avoid updates to be applied
 * @public
 */
UCF_ModelControl["prototype"]["lock"] = function () {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["lock"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Locking Model for data change: " + this["sId"], "ModelControl.js(128): lock"); };
	this["oModel"]["lock"]();
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["lock"] = 0; };

/**
 * Unlocks the model and applies the updates
 * @public
 */
UCF_ModelControl["prototype"]["unlock"] = function () {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["unlock"]++; }; 
	this["oModel"]["unlock"]();
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["unlock"] = 0; };

/**
 * Returns the client controls that are bound  to a specific path
 * @param {string} sPath the path where the control is bound to
 *
 * @public
 */
UCF_ModelControl["prototype"]["getBoundControls"] = function (sPath, sClassName) {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["getBoundControls"]++; }; 
	return this["oModel"]["getBoundControls"](sPath, true, sClassName);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["getBoundControls"] = 0; };

/**
 * @protected
 * @param {string} sId Id of the ModelControl
 * @param {string} sPath Path of the GridData
 * @param {string} sOperation GET,DELETE,UPDATE
 * @param {number} iStartX Start X Position
 * @param {number} iStartY Start Y Position
 * @param {number} iEndX End X Position
 * @param {number} iEndY End Y Position
 * @fires ModelControl::UpdateGrid
 */
UCF_ModelControl["prototype"]["_fireGetGrid"] = function (sId, sPath, iStartX, iStartY, iEndX, iEndY) {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["_fireGetGrid"]++; }; 
	/** @type {{Id: string, Path: string, Operation: string, StartX: number, StartY: number, EndX: number, EndY: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] === 6, "arguments.length === 6", "ModelControl.js(165): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ModelControl.js(166): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sId === 'string', "typeof sId === 'string'", "ModelControl.js(167): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPath != null, "sPath != null", "ModelControl.js(168): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sPath === 'string', "typeof sPath === 'string'", "ModelControl.js(169): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iStartX != null, "iStartX != null", "ModelControl.js(170): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iStartX === 'number', "typeof iStartX === 'number'", "ModelControl.js(171): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iStartY != null, "iStartY != null", "ModelControl.js(172): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iStartY === 'number', "typeof iStartY === 'number'", "ModelControl.js(173): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iEndX != null, "iEndX != null", "ModelControl.js(174): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iEndX === 'number', "typeof iEndX === 'number'", "ModelControl.js(175): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iEndY != null, "iEndY != null", "ModelControl.js(176): _fireGetGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iEndY === 'number', "typeof iEndY === 'number'", "ModelControl.js(177): _fireGetGrid"); };

	mParams = {
		"Id": sId,
		"Path": sPath,
		"Operation": "GET",
		"StartX": iStartX,
		"StartY": iStartY,
		"EndX": iEndX,
		"EndY": iEndY
	};

	//fire UpdateGrid with bMarkDirty = false
	this["fireSemanticEvent"]("ModelControl", "UpdateGrid", mParams, true, false, false);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["_fireGetGrid"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ModelControl["prototype"]["aAttributeNames"] = ["bIsDefaultModel","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ModelControl["prototype"]["aEventNames"] = ["DataChange","UpdateGrid","UpdateList","UpdateSelection","UpdateGridSelection"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ModelControl["prototype"]["aMethodNames"] = ["updateBindings","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {boolean}
 */
UCF_ModelControl["prototype"]["bIsDefaultModel"] = false;

/**
 * @private
 * @type {string}
 */
UCF_ModelControl["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ModelControl["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["setDefaultValues"]++; }; 
	this["bIsDefaultModel"] = false;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("IsDefaultModel", false, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Id of the ModelControl
 * @param {string} sPath The path to the node in the model that changed.
 * @param {string} sValue The string representation if the new value
 * @fires ModelControl::DataChange
 */
UCF_ModelControl["prototype"]["fireDataChange"] = function(sId, sPath, sValue) {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["fireDataChange"]++; }; 
	/** @type {{Id: string, Path: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "ModelControl.js(250): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ModelControl.js(251): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ModelControl.js(252): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPath != null, "sPath != null", "ModelControl.js(253): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPath) == "string", "typeof(sPath) == \"string\"", "ModelControl.js(254): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "ModelControl.js(255): fireDataChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "ModelControl.js(256): fireDataChange"); };
	mParams = {
		"Id": sId,
		"Path": sPath,
		"Value": sValue
	};
	
	
	
	this["fireSemanticEvent"]("ModelControl", "DataChange", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["fireDataChange"] = 0; };

/**
 * @protected
 * @param {string} sId Id of the ModelControl
 * @param {string} sPath Path of the GridData
 * @param {string} sOperation GET,DELETE,UPDATE
 * @param {number} iStartX Start X Position
 * @param {number} iStartY Start Y Position
 * @param {number} iEndX End X Position
 * @param {number} iEndY End Y Position
 * @fires ModelControl::UpdateGrid
 */
UCF_ModelControl["prototype"]["fireUpdateGrid"] = function(sId, sPath, sOperation, iStartX, iStartY, iEndX, iEndY) {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["fireUpdateGrid"]++; }; 
	/** @type {{Id: string, Path: string, Operation: string, StartX: number, StartY: number, EndX: number, EndY: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "ModelControl.js(283): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ModelControl.js(284): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ModelControl.js(285): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPath != null, "sPath != null", "ModelControl.js(286): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPath) == "string", "typeof(sPath) == \"string\"", "ModelControl.js(287): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sOperation != null, "sOperation != null", "ModelControl.js(288): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sOperation) == "string", "typeof(sOperation) == \"string\"", "ModelControl.js(289): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iStartX != null, "iStartX != null", "ModelControl.js(290): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iStartX) == "number", "typeof(iStartX) == \"number\"", "ModelControl.js(291): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iStartY != null, "iStartY != null", "ModelControl.js(292): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iStartY) == "number", "typeof(iStartY) == \"number\"", "ModelControl.js(293): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iEndX != null, "iEndX != null", "ModelControl.js(294): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iEndX) == "number", "typeof(iEndX) == \"number\"", "ModelControl.js(295): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iEndY != null, "iEndY != null", "ModelControl.js(296): fireUpdateGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iEndY) == "number", "typeof(iEndY) == \"number\"", "ModelControl.js(297): fireUpdateGrid"); };
	mParams = {
		"Id": sId,
		"Path": sPath,
		"Operation": sOperation,
		"StartX": iStartX,
		"StartY": iStartY,
		"EndX": iEndX,
		"EndY": iEndY
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("ModelControl", "UpdateGrid", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["fireUpdateGrid"] = 0; };

/**
 * @protected
 * @param {string} sId Id of the ModelControl
 * @param {string} sPath Path of the ListData
 * @param {string} sOperation GET,DELETE,UPDATE
 * @param {number} iStart Start  Position
 * @param {number} iLength Length
 * @fires ModelControl::UpdateList
 */
UCF_ModelControl["prototype"]["fireUpdateList"] = function(sId, sPath, sOperation, iStart, iLength) {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["fireUpdateList"]++; }; 
	/** @type {{Id: string, Path: string, Operation: string, Start: number, Length: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "ModelControl.js(330): fireUpdateList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ModelControl.js(331): fireUpdateList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ModelControl.js(332): fireUpdateList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPath != null, "sPath != null", "ModelControl.js(333): fireUpdateList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPath) == "string", "typeof(sPath) == \"string\"", "ModelControl.js(334): fireUpdateList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sOperation != null, "sOperation != null", "ModelControl.js(335): fireUpdateList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sOperation) == "string", "typeof(sOperation) == \"string\"", "ModelControl.js(336): fireUpdateList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iStart != null, "iStart != null", "ModelControl.js(337): fireUpdateList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iStart) == "number", "typeof(iStart) == \"number\"", "ModelControl.js(338): fireUpdateList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iLength != null, "iLength != null", "ModelControl.js(339): fireUpdateList"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iLength) == "number", "typeof(iLength) == \"number\"", "ModelControl.js(340): fireUpdateList"); };
	mParams = {
		"Id": sId,
		"Path": sPath,
		"Operation": sOperation,
		"Start": iStart,
		"Length": iLength
	};
	
	
	
	
	
	this["fireSemanticEvent"]("ModelControl", "UpdateList", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["fireUpdateList"] = 0; };

/**
 * @protected
 * @param {string} sId Id of the ModelControl
 * @param {string} sPath Path of the Selection
 * @param {number} iState The state of the selection where 0 = not selected, 1= Primary selected,2= Secondary selected
 * @fires ModelControl::UpdateSelection
 */
UCF_ModelControl["prototype"]["fireUpdateSelection"] = function(sId, sPath, iState) {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["fireUpdateSelection"]++; }; 
	/** @type {{Id: string, Path: string, State: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "ModelControl.js(367): fireUpdateSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ModelControl.js(368): fireUpdateSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ModelControl.js(369): fireUpdateSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPath != null, "sPath != null", "ModelControl.js(370): fireUpdateSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPath) == "string", "typeof(sPath) == \"string\"", "ModelControl.js(371): fireUpdateSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iState != null, "iState != null", "ModelControl.js(372): fireUpdateSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iState) == "number", "typeof(iState) == \"number\"", "ModelControl.js(373): fireUpdateSelection"); };
	mParams = {
		"Id": sId,
		"Path": sPath,
		"State": iState
	};
	
	
	
	this["fireSemanticEvent"]("ModelControl", "UpdateSelection", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["fireUpdateSelection"] = 0; };

/**
 * @protected
 * @param {string} sId Id of the ModelControl
 * @param {string} sPath Path of the GridData
 * @param {string} sStartX Start X Position
 * @param {string} sStartY Start Y Position
 * @param {string} sEndX End X Position
 * @param {string} sEndY End Y Position
 * @param {number} iState The state of the selection where 0 = not selected, 1= Primary selected,2= Secondary selected
 * @fires ModelControl::UpdateGridSelection
 */
UCF_ModelControl["prototype"]["fireUpdateGridSelection"] = function(sId, sPath, sStartX, sStartY, sEndX, sEndY, iState) {;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["fireUpdateGridSelection"]++; }; 
	/** @type {{Id: string, Path: string, StartX: string, StartY: string, EndX: string, EndY: string, State: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "ModelControl.js(400): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ModelControl.js(401): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ModelControl.js(402): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPath != null, "sPath != null", "ModelControl.js(403): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPath) == "string", "typeof(sPath) == \"string\"", "ModelControl.js(404): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sStartX != null, "sStartX != null", "ModelControl.js(405): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sStartX) == "string", "typeof(sStartX) == \"string\"", "ModelControl.js(406): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sStartY != null, "sStartY != null", "ModelControl.js(407): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sStartY) == "string", "typeof(sStartY) == \"string\"", "ModelControl.js(408): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sEndX != null, "sEndX != null", "ModelControl.js(409): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sEndX) == "string", "typeof(sEndX) == \"string\"", "ModelControl.js(410): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sEndY != null, "sEndY != null", "ModelControl.js(411): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sEndY) == "string", "typeof(sEndY) == \"string\"", "ModelControl.js(412): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iState != null, "iState != null", "ModelControl.js(413): fireUpdateGridSelection"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iState) == "number", "typeof(iState) == \"number\"", "ModelControl.js(414): fireUpdateGridSelection"); };
	mParams = {
		"Id": sId,
		"Path": sPath,
		"StartX": sStartX,
		"StartY": sStartY,
		"EndX": sEndX,
		"EndY": sEndY,
		"State": iState
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("ModelControl", "UpdateGridSelection", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_ModelControl["_"]["fireUpdateGridSelection"] = 0; };

UCF_ModelControl.prototype["aPublicMethods"] = ["updateBindings","lock","unlock","getBoundControls"].concat(UCF_ModelControl.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_MultiCarousel"] = function() {/* global _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Carousel */
/// <reference path="./Carousel.js"/>

/**
 * @class
 * @extends UCF_Carousel
 * @param {HTMLDivElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MultiCarousel(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["UCF_MultiCarousel"]++; }; 

	if (arguments["length"] > 0) {
		UCF_Carousel["apply"](this, [oDomRef, oLS]);
	}

	if (arguments["length"] > 0) {
		/** @type {UCF_MultiCarousel} */
		var self = this;
		/** @param {Event} oDomEvent */
		this["onNativeScroll"] = function(oDomEvent) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oDomEvent.scrollLeft: ' + oDomEvent["target"]["scrollLeft"] + ' oDomEvent.scrollTop: ' + oDomEvent["target"]["scrollTop"], "MultiCarousel.js(33): onNativeScroll"); };
			if (typeof self["iFocusedIndex"] === 'number') {
				self["scrollTo"](self["iFocusedIndex"], true);
				self["iFocusedIndex"] = null;
			}
			self["showAllItems"]();
			self["updateFirstVisible"]();

		};
		UCF_DomUtil["attachEvent"](this["oGetScrollRef"](), 'scroll', this["onNativeScroll"]);

		this["iFirstVisibleInTheList"] = 0;
	}

};window["UCF_MultiCarousel"] = UCF_MultiCarousel; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MultiCarousel"); UCF_MultiCarousel["_"] = {UCF_MultiCarousel: 0}; }; ;
UCF_MultiCarousel["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Carousel"))(); UCF_MultiCarousel.prototype["sClassName"] = "UCF_MultiCarousel";

/** @override */
UCF_MultiCarousel["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["destroy"]++; }; 
	this["iFocusedIndex"] = null;
	this["iFirstVisible"] = null;
	this["onNativeScroll"] = null;
	this["iFirstVisibleInTheList"] = null;

	UCF_Carousel.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["destroy"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["oGetInitialDomRefStyle"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["oGetInitialDomRefStyle"]++; }; 
	/** @type {Object} */
	var oStyle = {};
	/** @type {number} */
	var iScrollbarWidth = UCF_DomUtil["iGetScrollbarWidth"]();
	/** @type {number} */
	var iButtonsSize = this["iGetButtonsSize"]();
	/** @type {number} */
	var iFullButtonHeight = this["iGetFullButtonHeight"]();

	switch (this["sAlignment"]) {
		case 'HORIZONTAL':
			if (this["sWidth"] === '') {
				oStyle["width"] = this["iGetLargestItemWidth"]() + iButtonsSize + this["iGetPaddingLeft"]() + this["iGetPaddingRight"]() + 'px';
			}
			if (this["sHeight"] === '') {
				oStyle["height"] = Math["max"](iFullButtonHeight, this["iGetLargestItemHeight"]()) + this["iGetPaddingTop"]() + this["iGetPaddingBottom"]() + iScrollbarWidth + 'px';
			}
			if (this["sWidth"] !== '') {
				oStyle["width"] = this["iGetScrollRefClientWidth"]() + iButtonsSize + 'px';
			}
			break;
		case 'VERTICAL':
			if (this["sWidth"] === '') {
				oStyle["width"] = this["iGetLargestItemWidth"]() + iScrollbarWidth + this["iGetPaddingLeft"]() + this["iGetPaddingRight"]() + 'px';
			}
			if (this["sHeight"] === '') {
				oStyle["height"] = this["iGetLargestItemHeight"]() + iButtonsSize + this["iGetPaddingTop"]() + this["iGetPaddingBottom"]() + 'px';
			}
			if (this["sHeight"] !== '') {
				oStyle["height"] = this["iGetScrollRefClientHeight"]() + iButtonsSize + 'px';
			}
			break;
	}

	return oStyle;
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["oGetInitialDomRefStyle"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["onBeforeInitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onBeforeInitialize"]++; }; 
	// Checks if there is a Scrollbar -> then align the navigationButtons new
	if ((this["iGetScrollRefScrollWidth"]() > this["iGetScrollRefClientWidth"]() ||
			this["iGetScrollRefScrollHeight"]() > this["iGetScrollRefClientHeight"]())) {
		this["alignNavigationButtons"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onBeforeInitialize"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["onAfterInitializeWithScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterInitializeWithScrollPosition"]++; }; 
	this["updateNavigation"]();
	this["updatePagination"]();
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterInitializeWithScrollPosition"] = 0; };

/** @override
 * @param { Array } aItems
 * @param { number } iIndex
 * @param { boolean } [bImmediate]
 * @param { boolean } [bHomeOrEnd]
 */
UCF_MultiCarousel["prototype"]["_scrollTo"] = function(aItems, iIndex, bImmediate, bHomeOrEnd) {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["_scrollTo"]++; }; 
	/** @type {number} */
	var iScrollPx = 0;
	/** @type {UCF_MultiCarousel} */
	var self = this;

	// _trace(INFO, 'iIndex = ' + iIndex);
	// _trace(INFO, '->showAllItems()');
	this["showAllItems"]();

	if (window["UCF_System"]["bIsRTL"] && self["sAlignment"] === 'HORIZONTAL') {
		if (UCF_UserAgent["bIsIE"]()) {
			iScrollPx = self["iGetOffsetRight"](iIndex);
		} else if (UCF_UserAgent["bIsFirefox"]() || UCF_UserAgent["bIsWebKit"]()) {
			iScrollPx = self["iGetOffsetRight"](iIndex) * -1;
		} else {
			iScrollPx = self["iGetScrollRefScrollWidth"]() - self["iGetScrollRefClientWidth"]() - self["iGetOffsetRight"](iIndex);
		}
	} else {
		iScrollPx = self["aGetItemOffsets"]()[iIndex];
	}

	// This part checks that the Scrolldifference isn't bigger than the clientWidth/clientHight
	if (self["sAlignment"] === 'HORIZONTAL' && self["bIsItemSizeExceeded"](self["iFirstVisible"], iIndex, bImmediate) && !bImmediate && !bHomeOrEnd) {
		if ((iScrollPx - self["oGetScrollRef"]()["scrollLeft"]) > self["iGetScrollRefClientWidth"]()) {
			iScrollPx = self["oGetScrollRef"]()["scrollLeft"] + self["iGetScrollRefClientWidth"]();
		} else if ((iScrollPx - self["oGetScrollRef"]()["scrollLeft"]) < self["iGetScrollRefClientWidth"]() * -1) {
			iScrollPx = self["oGetScrollRef"]()["scrollLeft"] - self["iGetScrollRefClientWidth"]();
		}
	} else if (self["sAlignment"] === 'VERTICAL' && self["bIsItemSizeExceeded"](self["iFirstVisible"], iIndex, bImmediate) && !bImmediate && !bHomeOrEnd) {
		// eslint-disable-next-line no-lonely-if
		if ((iScrollPx - self["oGetScrollRef"]()["scrollTop"]) > self["iGetScrollRefClientHeight"]()) {
			iScrollPx = self["oGetScrollRef"]()["scrollTop"] + self["iGetScrollRefClientHeight"]();
		} else if ((iScrollPx - self["oGetScrollRef"]()["scrollTop"]) < self["iGetScrollRefClientHeight"]() * -1) {
			iScrollPx = self["oGetScrollRef"]()["scrollTop"] - self["iGetScrollRefClientHeight"]();
		}
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'iScrollPx = ' + iScrollPx, "MultiCarousel.js(158): _scrollTo"); };

	this["animateScroll"]({
		"iEndPx": iScrollPx,
		"bImmediate": bImmediate,
		"fDone": function() {
			// _trace(INFO, '(fDone) iFirstVisible = ' + iIndex);
			self["iFirstVisible"] = iIndex;
			self["setClientProperty"]('FirstVisible', self["iFirstVisible"], true);
			self["updateNavigation"]();
			// _trace(INFO, '(fDone) ->updateFirstVisible()');
			self["updateFirstVisible"]();
			// _trace(INFO, '(fDone) ->hideItemsBeforeFirstVisible()');
			self["hideItemsBeforeFirstVisible"]();
			if (window["UCF_System"]["bIsAria"]) { self["updateAriaAttributes"](); };
			if (!bImmediate) { UCF_DomUtil["focusDomElement"](UCF_DomUtil["$"](self["sId"] + '__item-' + self["iFirstVisible"])); };
		}
	});
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["_scrollTo"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["hideItemsBeforeFirstVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["hideItemsBeforeFirstVisible"]++; }; 
	/** @type {number} */
	var index = 0;
	/** @type {UCF_Carousel_ItemInfo[]} */
	var items = this["aGetItems"]();

	// _trace(INFO, 'iFirstVisible == ' + this.iFirstVisible);

	for (index; index < this["iFirstVisibleInTheList"]; index++) {
		UCF_DomUtil["setStyle"](items[index]["oDomRef"], { "visibility": 'hidden' });
	};
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["hideItemsBeforeFirstVisible"] = 0; };

/**@private */
UCF_MultiCarousel["prototype"]["updateFirstVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["updateFirstVisible"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {number} */
	var iCounter = 0;

	UCF_JsUtil["forEach"](this["aGetItems"](), function(item, index) {
		switch (self["sAlignment"]) {
			case 'HORIZONTAL':
				if (UCF_DomUtil["bIsRTL"]) {
					if (self["iGetOffsetRight"](index) + item["iOffsetWidth"] <= self["iGetScrollRefScrollWidth"]() - self["iGetScrollRefClientWidth"]() - UCF_DomUtil["iGetScrollLeft"](self["oGetScrollRef"]())) {
						iCounter++;
					}
				} else {
					// eslint-disable-next-line no-lonely-if
					if (item["iOffsetLeft"] + item["iOffsetWidth"] <= UCF_DomUtil["iGetScrollLeft"](self["oGetScrollRef"]())) {
						iCounter++;
					}
				}
				break;
			case 'VERTICAL':
				if (item["iOffsetTop"] + item["iOffsetHeight"] <= self["oGetScrollRef"]()["scrollTop"]) {
					iCounter++;
					break;
				}
		}
	});
	// _trace(INFO, 'iFirstVisible = ' + iCounter);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iFirstVisibleInTheList"] = iCounter;
	if (window["UCF_System"]["bIsAria"]) { this["updateAriaAttributes"](); };
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["updateFirstVisible"] = 0; };

/**
 * @param {number} iFirstVisible
 * @param {number} iFutureIndex
 * @param {boolean} bImmediate
 * @return {boolean}
 */
UCF_MultiCarousel["prototype"]["bIsItemSizeExceeded"] = function(iFirstVisible, iFutureIndex, bImmediate) {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["bIsItemSizeExceeded"]++; }; 
	/** @type {UCF_MultiCarousel} */
	var self = this;
	/** @type {number} */
	var iStartIndex = iFirstVisible <= iFutureIndex ? iFirstVisible : iFutureIndex;
	/** @type {number} */
	var iEndIndex = this["iFirstVisible"] <= iFutureIndex ? iFutureIndex : iFirstVisible;
	/** @type {number} */
	var iIndex = iStartIndex;
	/** @type {boolean} */
	var bSizeExceeded = false;

	if (!bImmediate) {
		for (iIndex; iIndex <= iEndIndex; iIndex++) {
			if (self["sAlignment"] === 'HORIZONTAL') {
				if (self["aGetItems"]()[iIndex]["iOffsetWidth"] >= self["iGetScrollRefClientWidth"]()) {
					bSizeExceeded = true;
				};
			} else {
				if (self["aGetItems"]()[iIndex]["iOffsetHeight"] >= self["iGetScrollRefClientHeight"]()) {
					bSizeExceeded = true;
				};
			}
		}
	};

	return bSizeExceeded;
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["bIsItemSizeExceeded"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_MultiCarousel["prototype"]["onAfterKeyboardNavigation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterKeyboardNavigation"]++; }; 
	UCF_DomUtil["focusDomElement"](UCF_DomUtil["$"](this["sId"] + '__item-' + this["iFirstVisible"]));
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterKeyboardNavigation"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["onAfterScroll"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterScroll"]++; }; 
	// _trace(INFO, '->updateFirstVisible()');
	this["updateFirstVisible"]();
	// _trace(INFO, '->hideItemsBeforeFirstVisible()');
	this["hideItemsBeforeFirstVisible"]();
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterScroll"] = 0; };

UCF_MultiCarousel["prototype"]["onAfterLsFocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterLsFocus"]++; }; 
	/** @type {HTMLElement} */
	var oSrc = oBrowserEvent["oGetSource"]();

	/*if (!UCF_DomUtil.bIsVisible(oSrc, true)) {
		oSrc = UCF_DomUtil.$(this.sId + '__item-' + this.iFirstVisible);
		UCF_DomUtil.focusDomElement(oSrc);
	}*/

	/**
	 * IE and Firefox scroll the focused control into view, but not the containing
	 * item. For item #0, this does not scroll the item to the very left, the
	 * prev button is never disabled.
	 * => we store the index of the focused item, and in the next native scroll,
	 * we scroll to this item instead
	 * @see {@link UCF_MultiCarousel#onNativeScroll}
	 * @type {number}
	 */
	this["iFocusedIndex"] = UCF_JsUtil["reduce"](this["aGetItems"](), function(iFocusedIndex, oItem, iIndex) {
		if (typeof iFocusedIndex === 'number') {
			return iFocusedIndex;
		} else if (UCF_DomUtil["bContains"](oItem["oDomRef"], oSrc)) {
			return iIndex;
		} else {
			return null;
		}
	}, null);
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterLsFocus"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_MultiCarousel["prototype"]["onAfterCarouselFocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterCarouselFocus"]++; }; 
	/** @type {HTMLElement}*/
	var oSrc = oBrowserEvent["oGetSource"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '----------------->focus() (oSrc == ' + oSrc["nodeName"] + '#' + oSrc["id"] + ')', "MultiCarousel.js(313): onAfterCarouselFocus"); };

	if (oSrc === this["oDomRef"] || !UCF_DomUtil["bContains"](this["oGetActiveItem"](), oSrc)) {
		UCF_DomUtil["focusDomElement"](this["oGetActiveItem"]());
	} else
		this["onAfterLsFocus"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterCarouselFocus"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["onAfterLsBlur"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterLsBlur"]++; }; 
	// _trace(INFO, '->showAllItems()');
	this["showAllItems"]();
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterLsBlur"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_MultiCarousel["prototype"]["onAfterClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterClick"]++; }; 
	/**@type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/**@type {int} */
	var iIndex;

	/**@type {string} */
	var sPrefix = this["sId"] + '__item-';
	/**@type {string} */
	var sSourceId = oSource["id"];

	if (UCF_StringUtil["bStartsWith"](sSourceId, sPrefix)) {
		iIndex = parseInt(sSourceId["substring"](sPrefix["length"]));
		this["scrollTo"](iIndex);

	} else if (UCF_StringUtil["bStartsWith"](oSource["id"], this["sId"])) {
		UCF_DomUtil["focusDomElement"](this["oGetActiveItem"]());
	}

};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterClick"] = 0; };
/**
 * @override
 * @param { UCF_BrowserEvent } oBrowserEvent
 * */
UCF_MultiCarousel["prototype"]["onAfterPointerUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterPointerUp"]++; }; 
	// _trace(INFO, '->hideItemsBeforeFirstVisible() (delayed)');
	UCF_JsUtil["delayedCall"](
		UCF_Carousel["ANIMATION_DURATION_MS"],
		this,
		'hideItemsBeforeFirstVisible'
	);
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterPointerUp"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["_updateNavigation"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["_updateNavigation"]++; }; 
	/** @type {HTMLDivElement} */
	var oScrollRef = this["oGetScrollRef"]();

	if (this["oPrevButton"]) {
		switch (this["sAlignment"]) {
			case 'HORIZONTAL':
				this["enablePrevButton"](
					window["UCF_System"]["bIsRTL"]
					? UCF_DomUtil["iGetScrollLeft"](oScrollRef) < this["iGetScrollRefScrollWidth"]() - this["iGetScrollRefClientWidth"]()
					: UCF_DomUtil["iGetScrollLeft"](oScrollRef) > 0
				);
				break;
			case 'VERTICAL':
				this["enablePrevButton"](oScrollRef["scrollTop"] > 0);
				break;
		}
	}
	if (this["oNextButton"]) {
		switch (this["sAlignment"]) {
			case 'HORIZONTAL':
				this["enableNextButton"](
					window["UCF_System"]["bIsRTL"]
					? UCF_DomUtil["iGetScrollLeft"](oScrollRef) > 0
					: UCF_DomUtil["iGetScrollLeft"](oScrollRef) < this["iGetScrollRefScrollWidth"]() - this["iGetScrollRefClientWidth"]()
				);
				break;
			case 'VERTICAL':
				this["enableNextButton"](oScrollRef["scrollTop"] < this["iGetScrollRefScrollHeight"]() - this["iGetScrollRefClientHeight"]());
				break;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["_updateNavigation"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["iGetPrevIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["iGetPrevIndex"]++; }; 
	var self = this;
	/** @type {number} */
	var iItemForPrevPressMultiple = self["iFirstVisible"] - 1;

	return iItemForPrevPressMultiple < 0 ? 0 : iItemForPrevPressMultiple;

};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["iGetPrevIndex"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["iGetPrevPageIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["iGetPrevPageIndex"]++; }; 
	var self = this;
	/** @type {number} */
	var iItemForPrevPressMultiple = self["iFirstVisible"] - self["iGetFullVisibleItemsCount"](self["iFirstVisibleInTheList"]);

	return iItemForPrevPressMultiple === self["iFirstVisible"]
		? self["iFirstVisible"] - 1
		: iItemForPrevPressMultiple;
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["iGetPrevPageIndex"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["iGetNextIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["iGetNextIndex"]++; }; 
	var self = this;
	/** @type {number} */
	var iLastVisibleItemPosition = self["iFirstVisible"] + 1;

	return iLastVisibleItemPosition < (self["aGetItems"]()["length"] - 1)
		? iLastVisibleItemPosition
		: self["aGetItems"]()["length"] - 1;
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["iGetNextIndex"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["iGetNextPageIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["iGetNextPageIndex"]++; }; 
	var self = this;
	/** @type {number} */
	var iLastVisibleItemPosition = self["iFirstVisible"] + self["iGetFullVisibleItemsCount"](self["iFirstVisibleInTheList"]);

	return iLastVisibleItemPosition > self["iFirstVisible"]
		? iLastVisibleItemPosition
		: self["iFirstVisible"] + 1;
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["iGetNextPageIndex"] = 0; };

/**
 * @override
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_MultiCarousel["prototype"]["onAfterTabPrevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterTabPrevious"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '------------------>onAfterTabPrevious (oSrc == ' + oSource["id"] + '#' + oSource["id"] + ')', "MultiCarousel.js(449): onAfterTabPrevious"); };

	if (oSource === this["oGetActiveItem"]()) {
		var focussed = this["focusPreviousControl"](); //try to focus previous sibling and their children
		if (focussed) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		} else {
			//No focusable control after the tab strip then leave it up to ls object to find the next element
			this["oLS"]["focusEnd"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterTabPrevious"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_MultiCarousel["prototype"]["onAfterTabNext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterTabNext"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '------------------>onAfterTabNext (oSrc == ' + oSource["id"] + '#' + oSource["id"] + ')', "MultiCarousel.js(469): onAfterTabNext"); };
	if (oSource !== this["oGetActiveItem"]()) {
		var focussed = this["focusNextControl"](); //try to focus next sibling and their children
		if (focussed) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		} else {
			//No focusable control after the tab strip then leave it up to ls object to find the next element
			this["oLS"]["focusEnd"]();
		}
	}

};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterTabNext"] = 0; };

/**
 * @override
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_MultiCarousel["prototype"]["onAfterMousewheel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterMousewheel"]++; }; 
	/** @type {number} */
	// var iScrollDistance = oBrowserEvent.oDomEvent.wheelDelta / 120 * 150;
	var iScrollDistance = oBrowserEvent["iWheelDelta"]() * 40;

	/** @type {number} */
	var iScrollLeft = this["oGetScrollRef"]()["scrollLeft"];

	if (this["sAlignment"] === 'HORIZONTAL') {
		if (window["UCF_System"]["bIsRTL"]) {
			this["oGetScrollRef"]()["scrollLeft"] += iScrollDistance;
		} else {
			this["oGetScrollRef"]()["scrollLeft"] -= iScrollDistance;
		}
	};

	if (iScrollLeft + this["iGetScrollRefClientWidth"]() === this["iGetScrollRefScrollWidth"]() || iScrollLeft === 0) {

	} else {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onAfterMousewheel"] = 0; };

/** @override */
UCF_MultiCarousel["prototype"]["onBeforeDestroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onBeforeDestroy"]++; }; 
	UCF_DomUtil["detachEvent"](this["oGetScrollRef"](), 'scroll', this["onNativeScroll"]);
};;if (__UCF_COVERAGE__) { UCF_MultiCarousel["_"]["onBeforeDestroy"] = 0; };

};
sap["ls"]["preload"]["UCF_MultiComboBox"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_ImageUtil */
/// <reference path="../core/ImageUtil.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_RenderManager */
/// <reference path="../core/RenderManager.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>
/* global UCF_ButtonDragDelegate */
/// <reference path="./delegates/ButtonDragDelegate.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>
/* global UCF_Listbox_Items */
/// <reference path="./Listbox_Items.js"/>
/* global UCF_MultiComboBoxNavigationDelegate */
/// <reference path="./delegates/MultiComboBoxNavigationDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_MultiComboBox(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["UCF_MultiComboBox"]++; }; 
	/** @type {UCF_Listbox_PopupMultiSelect} */
	var oListbox;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "MultiComboBox.js(58): UCF_MultiComboBox"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "MultiComboBox.js(59): UCF_MultiComboBox"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "MultiComboBox.js(60): UCF_MultiComboBox"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oTokeinzerDomRef"] = UCF_DomUtil["$"](this["sId"] + '-tokenizerscroll');

	this["oFieldHelp"] = null;
	if (this["sItemListBoxId"]) {
		oListbox = this["oLS"]["oControlFactory"]["oGetControlById"](this["sItemListBoxId"]);
		if (oListbox) {
			this["oFieldHelp"] = oListbox;
			this["oFieldHelp"]["attachEvent"](
				this["oFieldHelp"]["E_EVENTS"]["Select"],
				this,
				'onListBoxSelect'
			);
		}
	}

	// ..... Delegates ..........................................................
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_MultiComboBoxNavigationDelegate"))(this);
	this["addDelegate"](this["oNavigation"], true);

	this["bIsResizable"] = UCF_StringUtil["bContains"](this["sWidth"], '%');

	if (this["oLS"] && this["bIsResizable"]) {
		this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, 'onLayoutChange');
	}

	this["aItems"] = [];
};window["UCF_MultiComboBox"] = UCF_MultiComboBox; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MultiComboBox"); UCF_MultiComboBox["_"] = {UCF_MultiComboBox: 0}; }; ;

UCF_MultiComboBox["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_MultiComboBox.prototype["sClassName"] = "UCF_MultiComboBox";

UCF_MultiComboBox["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["initialize"]++; }; 
	this["renderTokens"]();
	if (this["oNavigation"]) {
		this["oNavigation"]["setToInitialMode"]();
	}
	if (this["bIsResizable"])
		this["attachBrowserEvent"]('resize', this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["initialize"] = 0; };

/**
 * Perfom destroy
 */
UCF_MultiComboBox["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["destroy"]++; }; 

	if (this["oFieldHelp"]) {
		this["oFieldHelp"]["detachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Select"],
			this,
			'onListBoxSelect'
		);
	}

	this["oNavigation"] = null;
	this["oTokeinzerDomRef"] = null;
	this["oFieldHelp"] = null;

	this["aItems"] = null;
	if (this["bIsResizable"])
		this["detachBrowserEvent"]("resize", this["oDomRef"]);
	this["bIsResizable"] = null;

	if (this["oLS"] && this["bIsResizable"]) {
		this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
	}
	this["sTimeOutId"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["destroy"] = 0; };

/**
 * @protected
 */
UCF_MultiComboBox["prototype"]["renderTokens"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["renderTokens"]++; }; 
	/** @type {Object} */
	var oRenderManager = this["oLS"]["oGetRenderManager"]();
	/** @type {Object} */
	var oToken;
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oFieldHelp"]["oGetItemsManager"]();
	/** @type {Array.<Array.<_RangeItem>>} */
	var aListBoxItems = oIM["aFindItemsByStates"](
			[UCF_Listbox_Items["STATE"]["Selected"]],
		UCF_Listbox_Items["IGNORED_WRITEABLE_STATES"]
	);
	/** @type {UCF_Listbox_Item} */
	var oItemRef;
	// reset the list
	this["aItems"] = [];

	// remove all children
	this["oTokeinzerDomRef"]["innerHTML"] = "";

	for (var i = 0; i < aListBoxItems["length"]; i++) {
		oItemRef = aListBoxItems[i];
		oRenderManager["write"](this["oLS"]["oGetRenderManager"]()["callFragment"](
			'MultiComboBoxTokenFragment',
			'MultiComboBox', {
				"Id": this["sId"],
				"ItemListBoxItemId": UCF_Listbox_Items["sGetItemId"](oItemRef),
				"Value": oIM["sGetItemValue1"](oItemRef) || oIM["sGetItemValue2"](oItemRef),
				"AriaPosinset": i,
				"AriaSetsize": aListBoxItems["length"]
			}
		));

		oToken = oRenderManager["oGetElementFromHtml"]();
		this["aItems"]["push"](oToken);
		UCF_DomUtil["append"](this["oTokeinzerDomRef"], oToken);
		oRenderManager["clearBuffer"]();
	}
	if (this["oNavigation"])
		this["oNavigation"]["updateAriaOwns"]();
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["renderTokens"] = 0; };

/**
 * @protected
 * @return {HTMLSpanElement}
 */
UCF_MultiComboBox["prototype"]["oGetHelpButtonRef"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["oGetHelpButtonRef"]++; }; 
	return document["getElementById"](this["sId"] + '-button');
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["oGetHelpButtonRef"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @return {boolean} if the SourceDomRef of oBrowserEvent is contained in the combobox
 */
UCF_MultiComboBox["prototype"]["bContainsDeleteButtonRef"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["bContainsDeleteButtonRef"]++; }; 
	var oSourceDomRef = oBrowserEvent["oGetSource"]();

	if (this["oTokeinzerDomRef"]["contains"](oSourceDomRef)) {
		return true;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["bContainsDeleteButtonRef"] = 0; };

/**
 * @protected
 * @return {boolean} if the listbox is open
 */
UCF_MultiComboBox["prototype"]["bIsListOpened"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["bIsListOpened"]++; }; 
	return this["oFieldHelp"] && this["oFieldHelp"]["bOpened"];
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["bIsListOpened"] = 0; };

/**
 * Handles the onkeydown event of the browser
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBox["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBox.js(215): onkeydown"); };

	if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["ARROW_DOWN"],
			'A'
		) && !oBrowserEvent["bRepeat"]() && !oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]()
		&& !this["bIsListOpened"]()) {
		this["handleAltDownKeydown"](oBrowserEvent);
	} else if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["ARROW_UP"],
			'A'
		) && !oBrowserEvent["bRepeat"]() && !oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]()
		&& !this["bIsListOpened"]()) {
		this["handleAltUpKeydown"](oBrowserEvent);
	} else if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["ARROW_DOWN"]
		) && !oBrowserEvent["bRepeat"]() && !oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]()
		&& this["bIsListOpened"]()) {
		this["handleAltDownKeydown"](oBrowserEvent);
	} else if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["F4"]
		) && !oBrowserEvent["bRepeat"]() && !oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]()
		&& !this["bIsListOpened"]()) {
		this["handleAltDownKeydown"](oBrowserEvent);
		oBrowserEvent["oDomEvent"]["preventDefault"]();

	} else if (UCF_KeyboardHelper["bIsEventForKey"](
			oBrowserEvent,
			UCF_KeyCodes["BACKSPACE"]
		) && !oBrowserEvent["bRepeat"]() && !this["bIsListOpened"]()) {
		this["handleBackspaceKeydown"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onkeydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the [ALT][DOWN] keydown
 */
UCF_MultiComboBox["prototype"]["handleAltDownKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleAltDownKeydown"]++; }; 
	if (this["oFieldHelp"]) {
		this["oFieldHelp"]["setOpenerRef"](this["oDomRef"]);
		this["oFieldHelp"]["open"]();
		this["attachFieldHelpEvents"](oBrowserEvent);
		this["oFieldHelp"]["handleAltDownKeydown"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleAltDownKeydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the [ALT][UP] keydown
 */
UCF_MultiComboBox["prototype"]["handleAltUpKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleAltUpKeydown"]++; }; 
	if (this["oFieldHelp"]) {
		this["oFieldHelp"]["setOpenerRef"](this["oDomRef"]);
		this["oFieldHelp"]["open"]();
		this["attachFieldHelpEvents"](oBrowserEvent);
		this["oFieldHelp"]["handleAltUpKeydown"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleAltUpKeydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the [BACKSPACE] keydown
 */
UCF_MultiComboBox["prototype"]["handleBackspaceKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleBackspaceKeydown"]++; }; 
	if (this["oNavigation"]["oControl"]["aItems"]["length"] > 0) {
		this["oNavigation"]["focusTokenAndNavigate"](this["oNavigation"]["oControl"]["aItems"]["length"] - 1);
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleBackspaceKeydown"] = 0; };

/**
 * Handles the onclick event of the browser
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_MultiComboBox["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBox.js(295): onclick"); };

	// check if it is a combo box click, do not handles list box clicks
	if (
		oBrowserEvent["oGetSourceControl"]() === this
	) {
		if (oBrowserEvent["oSource"] === this["oGetHelpButtonRef"]()) {
			this["handleHelpButtonPress"](oBrowserEvent);
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onclick"] = 0; };

/**
 * @private
 * @param { UCF_Event } oBrowserEvent the event object
 */
UCF_MultiComboBox["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onlsblur"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBox.js(313): onlsblur"); };

	if (this["bIsListOpened"]() &&
		oBrowserEvent["oDomEvent"] && oBrowserEvent["oDomEvent"]["relatedTarget"] !== this["oFieldHelp"]["oOpenerRef"] &&
		oBrowserEvent["oDomEvent"]["relatedTarget"] && oBrowserEvent["oDomEvent"]["relatedTarget"]["id"] !== this["oFieldHelp"]["sId"] + '-scrl' &&
		oBrowserEvent["oDomEvent"] && oBrowserEvent["oDomEvent"]["relatedTarget"]["getAttribute"]('ct') !== 'LIB_I') {
		this["detachFieldHelpEvents"]();
		this["oFieldHelp"]["close"]();
		if (this["oNavigation"])
			this["oNavigation"]["setToInitialMode"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onlsblur"] = 0; };

/**
 * Handles a click on the field help button.
 *
 * @private
 * @param {UCF_Event} oBrowserEvent the event object
 */
UCF_MultiComboBox["prototype"]["handleHelpButtonPress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleHelpButtonPress"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBox.js(333): handleHelpButtonPress"); };

	if (this["oFieldHelp"] && !this["bIsListOpened"]()) {
		this["oFieldHelp"]["clearFocus"]();
		this["oFieldHelp"]["setOpenerRef"](this["oDomRef"]);
		this["oFieldHelp"]["open"]();
		this["attachFieldHelpEvents"](oBrowserEvent);
	} else {
		this["oFieldHelp"]["close"]();
		this["detachFieldHelpEvents"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleHelpButtonPress"] = 0; };

/**
 * Handles a click on the delete button of the token.
 *
 * @private
 * @param {UCF_Event} oBrowserEvent the event object
 */
UCF_MultiComboBox["prototype"]["handleDeletePress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleDeletePress"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBox.js(353): handleDeletePress"); };

	var oTokenDomRef = this["oNavigation"]["oGetTokenFromEvent"](oBrowserEvent);
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oFieldHelp"]["oGetItemsManager"]();
	var sItemId = oTokenDomRef["dataset"]["itemlistboxid"];
	var oItemRef = oIM["oFindItemById"](sItemId);

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBox.js(361): handleDeletePress"); };

	if (oItemRef && this["oFieldHelp"]) {
		oIM["removeState"](oItemRef, UCF_Listbox_Items["STATE"]["Selected"]);
		if (!this["bIsListOpened"]()) {
			this["renderTokens"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleDeletePress"] = 0; };

/**
 * Deletes / deselect a list of tokens
 *
 * @private
 * @param {Array} aTokenList the event object
 */
UCF_MultiComboBox["prototype"]["handleDeleteTokens"] = function(aTokenList) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleDeleteTokens"]++; }; 

	if (!aTokenList) return;
	if (aTokenList && aTokenList["length"] === 0) return;
	if (!this["oFieldHelp"]) return;

	/** {HTMLElement} */
	var oTokenDomRef;
	/** @type {UCF_Listbox_Items} */
	var oIM = this["oFieldHelp"]["oGetItemsManager"]();
	/** {string} */
	var sItemId;
	/** {HTMLElement} */
	var oItemRef;
	for (var i = 0; i < aTokenList["length"]; i++) {
		oTokenDomRef = aTokenList[i];
		sItemId = oTokenDomRef["dataset"]["itemlistboxid"];
		oItemRef = oIM["oFindItemById"](sItemId);
		if (oItemRef)
			oIM["removeState"](oItemRef, UCF_Listbox_Items["STATE"]["Selected"]);
	}

	if (!this["bIsListOpened"]()) {
		this["renderTokens"]();
	}

};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["handleDeleteTokens"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_MultiComboBox["prototype"]["bAreFieldHelpEventsAttached"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["bAreFieldHelpEventsAttached"]++; }; 
	// we assume all events are attached if one is attached
	return this["oFieldHelp"] && this["oFieldHelp"]["E_EVENTS"]
		&& this["oFieldHelp"]["bIsListener"](this["oFieldHelp"]["E_EVENTS"]["Close"], this, 'onFieldHelpClose');
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["bAreFieldHelpEventsAttached"] = 0; };

/**
 * Attaches events when the Listbox is opened
 *
 * @private
 * @param {UCF_Event} oBrowserEvent the event object
 */
UCF_MultiComboBox["prototype"]["attachFieldHelpEvents"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["attachFieldHelpEvents"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBox.js(422): attachFieldHelpEvents"); };

	this["fireEvent"](this["E_EVENTS"]["Open"], { "type": oBrowserEvent["sName"] });

	if (this["oFieldHelp"] && !this["bAreFieldHelpEventsAttached"]()) {
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Close"],
			this,
			'onFieldHelpClose'
		);
		this["oFieldHelp"]["attachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Activate"],
			this,
			'onActivate'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["attachFieldHelpEvents"] = 0; };

/**
 * Detaches events when the Listbox is closed
 *
 * @private
 */
UCF_MultiComboBox["prototype"]["detachFieldHelpEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["detachFieldHelpEvents"]++; }; 
	if (this["oFieldHelp"] && this["bAreFieldHelpEventsAttached"]()) {
		this["oFieldHelp"]["detachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Close"],
			this,
			'onFieldHelpClose'
		);
		this["oFieldHelp"]["detachEvent"](
			this["oFieldHelp"]["E_EVENTS"]["Activate"],
			this,
			'onActivate'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["detachFieldHelpEvents"] = 0; };

/**
 * Event handler for selection in the Listbox
 *
 * @private
 * @param {UCF_Event} oEvent the event object
 */
UCF_MultiComboBox["prototype"]["onListBoxSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onListBoxSelect"]++; }; 
	/** @type {string} */
	var sListboxId = oEvent["oGetParam"]('sId');
	/** @type {Array} */
	var aKeys = oEvent["oGetParam"]('sKeys');
	this["fireSelect"](this["sId"], aKeys);

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'sListboxId = ' + sListboxId + ' aKeys = ' + aKeys, "MultiComboBox.js(473): onListBoxSelect"); };

	if (sListboxId !== '' && this["oFieldHelp"]["bOpened"]) {
		this["renderTokens"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onListBoxSelect"] = 0; };

/**
 * Event handler for closing the Listbox
 *
 * @private
 */
UCF_MultiComboBox["prototype"]["onFieldHelpClose"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onFieldHelpClose"]++; }; 
	this["detachFieldHelpEvents"]();
	if (this["oFieldHelp"] && document["activeElement"] &&
		this["oFieldHelp"]["oDomRef"]["contains"](document["activeElement"])) {
		this["focus"]();
	} else {
		if (this["oNavigation"])
			this["oNavigation"]["setToInitialMode"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onFieldHelpClose"] = 0; };

/**
 * Event handler for activating the Listbox
 *
 * @private
 * @param {UCF_Event} oBrowserEvent the event object
 */
UCF_MultiComboBox["prototype"]["onActivate"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onActivate"]++; }; 
	if (this["oFieldHelp"] && !this["bIsListOpened"]()) {
		this["attachFieldHelpEvents"](oBrowserEvent);
		this["oFieldHelp"]["open"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onActivate"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_MultiComboBox["prototype"]["onlsescape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onlsescape"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBox.js(514): onlsescape"); };

	if (this["oFieldHelp"] && this["bIsListOpened"]()) {
		this["oFieldHelp"]["close"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onlsescape"] = 0; };

/**
 * After resizing the toolbar some items may become visible.
 * For these items the delegateOpenMenu property must be changed.
 * Otherwise they cannot be opened programmatically, if relying
 * on "bIsHidden".
 * @private
 */

UCF_MultiComboBox["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onresize"]++; }; 
	if (typeof(this["sTimeOutId"]) !== 'undefined') {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
	}
	this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResize');
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onresize"] = 0; };

/**
 *  Recalculate the current visible tokens after resize
 *  @private
 */
UCF_MultiComboBox["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onAfterResize"]++; }; 
	if (this["oNavigation"]) {
		this["oNavigation"]["onAfterResize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onAfterResize"] = 0; };

/**
 *  Recalculate the current visible tokens after resize
 *  @private
 */
UCF_MultiComboBox["prototype"]["onLayoutChange"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onLayoutChange"]++; }; 
	if (this["oNavigation"]) {
		this["oNavigation"]["onAfterResize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["onLayoutChange"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_MultiComboBox["prototype"]["aAttributeNames"] = ["sId","sAccessKey","sCustomData","sCustomStyle","bEnabled","sInputState","sItemListBoxId","bReadOnly","bRequired","sTextDesign","sTooltip","sVisibility","sWidth","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_MultiComboBox["prototype"]["aEventNames"] = ["Select"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_MultiComboBox["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_MultiComboBox["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MultiComboBox["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MultiComboBox["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MultiComboBox["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_MultiComboBox["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputState}
 */
UCF_MultiComboBox["prototype"]["sInputState"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_MultiComboBox["prototype"]["sItemListBoxId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_MultiComboBox["prototype"]["bReadOnly"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_MultiComboBox["prototype"]["bRequired"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputDesign}
 */
UCF_MultiComboBox["prototype"]["sTextDesign"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_MultiComboBox["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_MultiComboBox["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_MultiComboBox["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_MultiComboBox["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_MultiComboBox["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sAccessKey"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["bEnabled"] = true;
	this["sInputState"] = "NONE";
	this["sItemListBoxId"] = '';
	this["bReadOnly"] = false;
	this["bRequired"] = false;
	this["sTextDesign"] = "STANDARD";
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sWidth"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("InputState", "NONE", true);
		this["setClientProperty"]("ItemListBoxId", '', true);
		this["setClientProperty"]("ReadOnly", false, true);
		this["setClientProperty"]("Required", false, true);
		this["setClientProperty"]("TextDesign", "STANDARD", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {Array<any>} sKeys Array of the selected keys
 * @fires MultiComboBox::Select
 */
UCF_MultiComboBox["prototype"]["fireSelect"] = function(sId, sKeys) {;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, Keys: Array<any>}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "MultiComboBox.js(708): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "MultiComboBox.js(709): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "MultiComboBox.js(710): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sKeys != null, "sKeys != null", "MultiComboBox.js(711): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sKeys) == "object", "typeof(sKeys) == \"object\"", "MultiComboBox.js(712): fireSelect"); };
	mParams = {
		"Id": sId,
		"Keys": sKeys
	};
	
	
	this["fireSemanticEvent"]("MultiComboBox", "Select", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBox["_"]["fireSelect"] = 0; };

};
sap["ls"]["preload"]["UCF_MultiComboBoxNavigationDelegate"] = function() {/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_FieldNavigationDelegate */
/// <reference path="./FieldNavigationDelegate.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global _trace, INFO, _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../../core/util/AriaStateHelper.js"/>
/* global UCF_ClipboardUtil */
/// <reference path="../../../core/util/ClipboardUtil.js"/>
/**
 * @class UCF_MultiComboBoxNavigationDelegate
 * @extends UCF_Object
 * @param {UCF_MultiComboBox} oControl the MultiComboBox
 */
function UCF_MultiComboBoxNavigationDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["UCF_MultiComboBoxNavigationDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		this["oControl"] = oControl;
		this["oLS"] = oControl["oLS"];
		this["oIndicatorDomRef"] = null;
		this["oTokenizerDomRef"] = UCF_DomUtil["$"](this["oControl"]["sId"] + '-tokenizerscroll');
		this["oTokenizerParentDomRef"] = UCF_DomUtil["$"](this["oControl"]["sId"] + '-tokenizer');
		this["eCurrentNavigationStates"] = this["eStates"]["DISPLAY_MORE"];
		this["iCurrentIndex"] = -1;
		this["iPreviousItem"] = -1;

		/** @type {boolean} */
		this["bAllTokensSelected"] = false;
	}
};window["UCF_MultiComboBoxNavigationDelegate"] = UCF_MultiComboBoxNavigationDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_MultiComboBoxNavigationDelegate"); UCF_MultiComboBoxNavigationDelegate["_"] = {UCF_MultiComboBoxNavigationDelegate: 0}; }; ;
UCF_MultiComboBoxNavigationDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_MultiComboBoxNavigationDelegate.prototype["sClassName"] = "UCF_MultiComboBoxNavigationDelegate";

/**
 * A list of the different states of the navigation between the tokes in MultiComboxBox
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["eStates"] = {
	"DISPLAY_ONLY": 'DISPLAY_ONLY', // the list is opened and the itesm are right hAligned
	"DISPLAY_MORE": 'DISPLAY_MORE', // initial staus, when no focus is set on the item
	"NAVIGATE": 'NAVIGATE' // When the focus is on the MultiComboBox and no List is opened
};

UCF_MultiComboBoxNavigationDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["destroy"]++; }; 
	this["oControl"] = null;
	this["oIndicatorDomRef"] = null;
	this["oTokenizerDomRef"] = null;
	this["iCurrentIndex"] = null;
	this["iPreviousItem"] = null;
	this["eCurrentNavigationStates"] = null;
	this["oTokenizerParentDomRef"] = null;
	if (this["sTimeOutId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		this["sTimeOutId"] = null;
	}
	this["oLS"] = null;
	this["bAllTokensSelected"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["destroy"] = 0; };
/**
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["setToInitialMode"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["setToInitialMode"]++; }; 
	this["updateTokenizerAccordingToState"](this["eStates"]["DISPLAY_MORE"]);
	this["updateAriaOwns"]();
	this["iCurrentIndex"] = -1;
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["setToInitialMode"] = 0; };

/**
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onAfterResize"]++; }; 
	this["updateTokenizerAccordingToState"](this["eStates"]["NAVIGATE"]);
	this["setToRightHAlinment"]();
	this["setToInitialMode"]();
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onAfterResize"] = 0; };

/**
 * Handles the onkeydown event of the browser
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(102): onlsfocus"); };
	if (!this["oControl"]["bEnabled"]) return;

	var oSource = oBrowserEvent["oGetSource"]();
	if (this["oControl"]["oDomRef"] === oSource) {
		if (this["eCurrentNavigationStates"] === this["eStates"]["DISPLAY_MORE"]) {
			this["updateTokenizerAccordingToState"](this["eStates"]["DISPLAY_ONLY"]);
			this["iCurrentIndex"] = -1;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsfocus"] = 0; };

/**
 * Handles the [SPACE] on a Token
 * It toggle the select state of the Token
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsspace"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(121): onlsspace"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (this["bIsToken"](oSource)) {
		if (this["bIsSelectedToken"](oSource))
			this["deselectToken"](oSource);
		else
			this["selectToken"](oSource);
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsspace"] = 0; };

/**
 * Handles the onkeydown event of the browser
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsblur"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(137): onlsblur"); };
	if (typeof(this["sTimeOutId"]) !== 'undefined') {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
	}
	this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterBlur');

};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsblur"] = 0; };

/** @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onAfterBlur"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onAfterBlur"]++; }; 
	var oActiveElement = UCF_DomUtil["oGetActiveElement"]();
	if (this["oControl"]["bIsListOpened"]()) return;
	if (oActiveElement === document["body"] || (oActiveElement["id"] && !UCF_StringUtil["bStartsWith"](oActiveElement["id"], this["oControl"]["sId"])))
		this["updateTokenizerAccordingToState"](this["eStates"]["DISPLAY_MORE"]);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onAfterBlur"] = 0; };

/**
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["updateTokenizerWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["updateTokenizerWidth"]++; }; 
	this["oTokenizerDomRef"]["style"]["width"] = this["oTokenizerDomRef"]["offsetWidth"] + 'px';
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["updateTokenizerWidth"] = 0; };

/**
 * Test if the current token is hidden
 * @param {HTMLElement} oTokenDomRef
 * @return {boolean} - true if there are hidden items
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["bIsHiddenToken"] = function(oTokenDomRef) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bIsHiddenToken"]++; }; 
	if (window["UCF_System"]["bIsRTL"]) {
		return oTokenDomRef["offsetLeft"] > this["oTokenizerParentDomRef"]["offsetLeft"] + this["oTokenizerParentDomRef"]["offsetWidth"] ||
			oTokenDomRef["offsetLeft"] + oTokenDomRef["offsetWidth"] > this["oTokenizerParentDomRef"]["offsetLeft"] + this["oTokenizerParentDomRef"]["offsetWidth"];
	} else
		return oTokenDomRef["offsetLeft"] < 0 || (oTokenDomRef["offsetLeft"] - oTokenDomRef["offsetWidth"]) < 0 || oTokenDomRef["offsetLeft"] < this["oTokenizerParentDomRef"]["offsetLeft"];
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bIsHiddenToken"] = 0; };

/**
 *
 * @return {boolean} - true if theere are hidden items
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["bHasHiddenTokens"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bHasHiddenTokens"]++; }; 
	var aCurrentItems = this["oControl"]["aItems"];
	if (!aCurrentItems || (aCurrentItems && aCurrentItems["length"] === 0)) return false;
	if (window["UCF_System"]["bIsRTL"])
		return this["oTokenizerDomRef"]["scrollWidth"] > this["oTokenizerParentDomRef"]["offsetWidth"];
	else
		return aCurrentItems[0]["offsetLeft"] < 0 || aCurrentItems[0]["offsetLeft"] < this["oTokenizerDomRef"]["offsetLeft"] || this["oTokenizerParentDomRef"]["offsetWidth"] < this["oTokenizerDomRef"]["offsetWidth"];
	//this.bIsHiddenToken(aCurrentItems[0]);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bHasHiddenTokens"] = 0; };

/**
 * @param { int } iNoOfMore
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["setIndicatorValue"] = function(iNoOfMore) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["setIndicatorValue"]++; }; 
	if (this["oIndicatorDomRef"])
		this["oIndicatorDomRef"]["textContent"] = this["oLS"]["sGetText"]('SAPUR_TOKENIZER_MORE', [iNoOfMore]);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["setIndicatorValue"] = 0; };

/**
 * @param { int } iNoOfMore
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["createIndicatorValue"] = function(iNoOfMore) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["createIndicatorValue"]++; }; 

	if (this["oIndicatorDomRef"]) return;

	/** @type {Object} */
	var oRenderManager = this["oLS"]["oGetRenderManager"]();
	oRenderManager["write"](this["oLS"]["oGetRenderManager"]()["callFragment"](
		'MultiComboBoxIndicatorFragment',
		'MultiComboBox', {
			"Id": this["oControl"]["sId"],
			"NoOfItems": iNoOfMore
		}
	));

	this["oIndicatorDomRef"] = oRenderManager["oGetElementFromHtml"]();
	UCF_DomUtil["append"](this["oTokenizerDomRef"], this["oIndicatorDomRef"]);
	oRenderManager["clearBuffer"]();
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["createIndicatorValue"] = 0; };

/**
 * removes the indicator HTMLElement
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["removeIndicatorValue"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["removeIndicatorValue"]++; }; 

	if (this["oIndicatorDomRef"]) {
		UCF_DomUtil["removeFromDom"](this["oIndicatorDomRef"]);
		this["oIndicatorDomRef"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["removeIndicatorValue"] = 0; };

/**
 *
 * @return {boolean} - true if theere are hidden items
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["oGetHiddenTokens"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["oGetHiddenTokens"]++; }; 
	var aCurrentItems = this["oControl"]["aItems"];
	var self = this;

	return UCF_JsUtil["filter"](aCurrentItems, function(oRef) {
		return self["bIsHiddenToken"](oRef);
	});
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["oGetHiddenTokens"] = 0; };

/**
 * @param {NagivationState} eState
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["updateTokenizerAccordingToState"] = function(eState) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["updateTokenizerAccordingToState"]++; }; 
	/** {Array} */
	var aCurrentItems;
	/** Array */
	var aHiddenItems;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Navigation State  -------> ' + eState, "MultiComboBoxNavigationDelegate.js(258): updateTokenizerAccordingToState"); };

	aCurrentItems = this["oControl"]["aItems"];
	this["setTokenizerNavigationState"](eState);
	switch (eState) {
		case this["eStates"]["DISPLAY_MORE"]:
			if (this["bHasHiddenTokens"]()) {
				this["createIndicatorValue"](aCurrentItems["length"]);
				aHiddenItems = this["oGetHiddenTokens"]();
				this["setIndicatorValue"](aHiddenItems["length"]);
				this["deselectAllTokens"]();
				this["hideList"](aHiddenItems);
				this["resetHAlinment"]();
			}
			break;
		case this["eStates"]["DISPLAY_ONLY"]:
			this["removeIndicatorValue"]();
			this["resetHAlinment"]();
			this["setToRightHAlinment"]();
			this["showList"](aCurrentItems);
			this["deselectAllTokens"]();
			break;
		case this["eStates"]["NAVIGATE"]:
			this["removeIndicatorValue"]();
			this["resetHAlinment"]();
			this["showList"](aCurrentItems);
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["updateTokenizerAccordingToState"] = 0; };

/**
 * @param {eStates} eState
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["setTokenizerNavigationState"] = function(eState) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["setTokenizerNavigationState"]++; }; 
	this["eCurrentNavigationStates"] = eState;
	if (eState === this["eStates"]["NAVIGATE"])
		this["resetHAlinment"]();
	else {
		this["setToRightHAlinment"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["setTokenizerNavigationState"] = 0; };

/**
 * Set the float:right to the Tokenizer scrollcontainer
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["setToRightHAlinment"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["setToRightHAlinment"]++; }; 
	if (!UCF_DomUtil["bHasClass"](this["oTokenizerDomRef"], 'lsMultiComboBox--scrollcontainer-hAlign'))
		UCF_DomUtil["addClass"](this["oTokenizerDomRef"], 'lsMultiComboBox--scrollcontainer-hAlign');
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["setToRightHAlinment"] = 0; };

/**
 * reset the float:right to the Tokenizer scrollcontainer
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["resetHAlinment"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["resetHAlinment"]++; }; 
	UCF_DomUtil["removeClass"](this["oTokenizerDomRef"], 'lsMultiComboBox--scrollcontainer-hAlign');
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["resetHAlinment"] = 0; };

/**
 * @param { HTMLElement } oToken
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["showToken"] = function(oToken) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["showToken"]++; }; 
	UCF_DomUtil["removeClass"](oToken, 'lsMultiComboBox__token--invisible');
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["showToken"] = 0; };

/**
 * @param {HTMLElement} oToken
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["hideToken"] = function(oToken) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["hideToken"]++; }; 
	UCF_DomUtil["addClass"](oToken, 'lsMultiComboBox__token--invisible');
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["hideToken"] = 0; };

/**
 * @param {HTMLElement} oToken
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["selectToken"] = function(oToken) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["selectToken"]++; }; 
	UCF_DomUtil["addClass"](oToken, 'lsMultiComboBox__token--selected');
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["selectToken"] = 0; };

/**
 * @param {HTMLElement} oToken
 * @return {boolean} - true if the token is selected
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["bIsSelectedToken"] = function(oToken) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bIsSelectedToken"]++; }; 
	return UCF_DomUtil["bHasClass"](oToken, 'lsMultiComboBox__token--selected');
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bIsSelectedToken"] = 0; };

/**
 * @param {HTMLElement} oToken
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["deselectToken"] = function(oToken) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["deselectToken"]++; }; 
	UCF_DomUtil["removeClass"](oToken, 'lsMultiComboBox__token--selected');
	this["bAllTokensSelected"] = false;
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["deselectToken"] = 0; };

/**
 * Deselects all the Tokens
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["deselectAllTokens"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["deselectAllTokens"]++; }; 
	for (var i = 0; i < this["oControl"]["aItems"]["length"]; i++) {
		this["deselectToken"](this["oControl"]["aItems"][i]);
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["deselectAllTokens"] = 0; };

/**
 * Selects all the Tokens
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["selectAllTokens"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["selectAllTokens"]++; }; 
	for (var i = 0; i < this["oControl"]["aItems"]["length"]; i++) {
		if (!this["bIsSelectedToken"](this["oControl"]["aItems"][i]))
			this["selectToken"](this["oControl"]["aItems"][i]);
	}
	this["bAllTokensSelected"] = true;
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["selectAllTokens"] = 0; };

/**
 *
 * @return {Array} - The list of the selected tokens
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["oGetSelectedTokens"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["oGetSelectedTokens"]++; }; 
	var aCurrentItems = this["oControl"]["aItems"];
	var self = this;

	return UCF_JsUtil["filter"](aCurrentItems, function(oRef) {
		return self["bIsSelectedToken"](oRef);
	});
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["oGetSelectedTokens"] = 0; };

/**
 * @param {Array} aList
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["showList"] = function(aList) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["showList"]++; }; 
	for (var i = 0; i < aList["length"]; i++)
		this["showToken"](aList[i]);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["showList"] = 0; };

/**
 * @param {Array} aList
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["hideList"] = function(aList) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["hideList"]++; }; 
	for (var i = 0; i < aList["length"]; i++)
		this["hideToken"](aList[i]);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["hideList"] = 0; };

/**
 * @param {HTMLElement} oTokenDomRef
 * @return {int} - the current position on the list
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["iGetPosition"] = function(oTokenDomRef) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["iGetPosition"]++; }; 
	/** {int} */
	var iPosition;
	var aList = this["oControl"]["aItems"];
	for (var i = 0; i < aList["length"]; i++) {
		iPosition = i;
		if (oTokenDomRef === aList[i])
			break;
	}
	return iPosition;
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["iGetPosition"] = 0; };

UCF_MultiComboBoxNavigationDelegate["prototype"]["focusToken"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["focusToken"]++; }; 
	/** {HTMLElement} */
	var oPreviousToken;
	/** {HTMLElement} */
	var oCurrentDomRef;
	if (this["iPreviousItem"] >= 0 && this["iPreviousItem"] < this["oControl"]["aItems"]["length"]) {
		oPreviousToken = this["oControl"]["aItems"][this["iPreviousItem"]];
		UCF_DomUtil["resetTabIndex"](oPreviousToken);
	}
	if (iIndex >= this["oControl"]["aItems"]["length"])
		iIndex = this["oControl"]["aItems"]["length"] - 1;
	if (iIndex < 0)
		iIndex = 0;
	this["iPreviousItem"] = iIndex;

	oCurrentDomRef = this["oControl"]["aItems"][iIndex];
	UCF_DomUtil["setTabIndex"](oCurrentDomRef, 0);
	UCF_DomUtil["focusDomElement"](oCurrentDomRef);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["focusToken"] = 0; };

/**
 * @param {number} iIndex
 * @protected
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["selectTokenByIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["selectTokenByIndex"]++; }; 
	/** {HTMLElement} */
	var oTokenDomRef;

	oTokenDomRef = this["oControl"]["aItems"][iIndex];
	UCF_DomUtil["addClass"](oTokenDomRef, 'lsMultiComboBox__token--selected');
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["selectTokenByIndex"] = 0; };

UCF_MultiComboBoxNavigationDelegate["prototype"]["focusTokenAndNavigate"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["focusTokenAndNavigate"]++; }; 
	/** {HTMLElement} */
	var oPreviousToken;
	/** {HTMLElement} */
	var oCurrentDomRef;

	if (this["oControl"] && this["oControl"]["oFieldHelp"] && this["oControl"]["oFieldHelp"]["bOpened"]) return;

	if (this["iPreviousItem"] >= 0 && this["iPreviousItem"] < this["oControl"]["aItems"]["length"]) {
		oPreviousToken = this["oControl"]["aItems"][this["iPreviousItem"]];
		UCF_DomUtil["resetTabIndex"](oPreviousToken);
	}
	this["iPreviousItem"] = iIndex;

	oCurrentDomRef = this["oControl"]["aItems"][iIndex];
	this["resetHAlinment"]();
	this["showList"](this["oControl"]["aItems"]);
	UCF_DomUtil["setTabIndex"](oCurrentDomRef, 0);
	UCF_DomUtil["focusDomElement"](oCurrentDomRef);
	this["updateAriaActivedescendant"](oCurrentDomRef);

};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["focusTokenAndNavigate"] = 0; };

/**
 * Handles the onclick event of the browser
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(492): onclick"); };
	/** {HTMLElement} */
	var oSource;
	/** {HTMLElement} */
	var oToken;

	oSource = oBrowserEvent["oGetSource"]();
	if (this["bIsTokenDeleteButton"](oSource)) {
		this["deleteToken"](oBrowserEvent, false);
	} else if (this["bIsToken"](oSource)) {
		oToken = this["oGetTokenFromEvent"](oBrowserEvent);
		if (oBrowserEvent["bShift"]()) {
			this["rangeSelect"](oToken);
		} else {
			this["iCurrentIndex"] = this["iGetPosition"](oSource);
			this["focusToken"](this["iCurrentIndex"]);
			this["selectToken"](oToken);
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["cancel"]();
		}
	} else if (this["bIsMenuButton"](oSource)) {
		this["updateTokenizerAccordingToState"](this["eStates"]["DISPLAY_ONLY"]);
		this["iCurrentIndex"] = -1;
	} else if (oSource && UCF_StringUtil["bStartsWith"](oSource["id"], this["oControl"]["sId"])
		&& !this["bIsMenuButton"](oSource)) {
		this["updateTokenizerAccordingToState"](this["eStates"]["DISPLAY_ONLY"]);
		this["iCurrentIndex"] = -1;
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onclick"] = 0; };

/**
 * Check if the source is a token
 * @param {HTMLElement} oDomRef
 * @return {boolean} - true if the HTMLElement is a token
 * @private
 */

UCF_MultiComboBoxNavigationDelegate["prototype"]["bIsToken"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bIsToken"]++; }; 
	/** {boolean} */
	var bIsToken = false;
	if (oDomRef
		&& oDomRef["id"]
		&& UCF_StringUtil["bStartsWith"](oDomRef["id"], this["oControl"]["sId"] + '_token')
		&& !UCF_StringUtil["bEndsWith"](oDomRef["id"], '-delete')) {
		bIsToken = true;
	}
	return bIsToken;
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bIsToken"] = 0; };

/**
 * Check if the source is a token
 * @param {HTMLElement} oDomRef
 * @return {boolean} - true if the HTMLElement is a token
 * @private
 */

UCF_MultiComboBoxNavigationDelegate["prototype"]["bIsMenuButton"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bIsMenuButton"]++; }; 
	return oDomRef
		&& oDomRef["id"]
		&& oDomRef["id"] === this["oControl"]["sId"] + '-button';
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bIsMenuButton"] = 0; };

/**
 * Check if the source is the delete button of the token
 * @param {HTMLElement} oDomRef
 * @return {boolean} - true if the HTMLElement is a token
 * @private
 */

UCF_MultiComboBoxNavigationDelegate["prototype"]["bIsTokenDeleteButton"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bIsTokenDeleteButton"]++; }; 
	/** {boolean} */
	var bIsDeleteButton = false;
	if (oDomRef
		&& oDomRef["id"]
		&& UCF_StringUtil["bStartsWith"](oDomRef["id"], this["oControl"]["sId"] + '_token')
		&& UCF_StringUtil["bEndsWith"](oDomRef["id"], '-delete')) {
		bIsDeleteButton = true;
	}
	return bIsDeleteButton;
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["bIsTokenDeleteButton"] = 0; };

/**
 * Handles the onkeydown event of the browser
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(581): onkeydown"); };

	/** {HTMLElement} */
	//var oSource;
	// click on the tokem should focus it
	//oSource = oBrowserEvent.oGetSource();
	if (UCF_KeyboardHelper["bHasKeyWithoutModifiers"](oBrowserEvent, UCF_KeyCodes["DELETE"])) {
		this["deleteAllSelectedTokens"](oBrowserEvent);
	} else
		// [CTRL][A]
		if (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["A"], 'C')) {
			if (this["bAllTokensSelected"]) {
				this["deselectAllTokens"]();
			} else {
				this["selectAllTokens"]();
			}
		} else
			// [BACKSPACE]
			if (
				UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["BACKSPACE"])
			) {
				this["deleteToken"](oBrowserEvent, true);
			} else
				// [CTRL][C]
				if (
					UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["C"], 'C')
				) {
					this["copyToClipboard"](oBrowserEvent);
				}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onkeydown"] = 0; };

/**
 * Handles the onkeydown event of the browser
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @param {boolean} bWithKeyboard - using the Keyboard
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["deleteToken"] = function(oBrowserEvent, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["deleteToken"]++; }; 
	/** {HTMLElement} */
	var oToken;
	/** {int} */
	var iTokenIndex;
	oToken = this["oGetTokenFromEvent"](oBrowserEvent);
	if (oToken) {
		iTokenIndex = parseInt(oToken["dataset"]["index"]);
		this["oControl"]["handleDeletePress"](oBrowserEvent);
		if (bWithKeyboard) {
			this["focusToken"](iTokenIndex);
		}
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["deleteToken"] = 0; };

/**
 * @private
 * @param {HTMLElement} oToken
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["rangeSelect"] = function(oToken) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["rangeSelect"]++; }; 
	/** {int} */
	var iLastSelectedTokenIndex;
	var oFirstSelectedToken = this["oGetSelectedTokens"]()[0];
	var iFirstSelectedTokenIndex = oFirstSelectedToken ? oFirstSelectedToken["dataset"]["index"] : null;

	if (!iFirstSelectedTokenIndex) return;

	if (oToken) {
		iLastSelectedTokenIndex = parseInt(oToken["dataset"]["index"]);
		for (var i = 0; i <= iLastSelectedTokenIndex; i++) {
			this["selectTokenByIndex"](i);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["rangeSelect"] = 0; };

/**
 * Handles the [DELETE] with Keyboard for all seleted token
 * It sets the focus on the last token ( for the moment)
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["deleteAllSelectedTokens"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["deleteAllSelectedTokens"]++; }; 
	/** {HTMLElement} */
	var oToken;
	/** {int} */
	var iTokenIndex;
	this["oControl"]["handleDeleteTokens"](this["oGetSelectedTokens"]());

	if (this["oControl"]["aItems"]["length"] > 0) {
		oToken = this["oControl"]["aItems"][this["oControl"]["aItems"]["length"] - 1];
		if (oToken) {
			iTokenIndex = parseInt(oToken["dataset"]["index"]);
			this["focusToken"](iTokenIndex);
		}
	} else
		UCF_DomUtil["focusDomElement"](this["oControl"]["oDomRef"]);

};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["deleteAllSelectedTokens"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["copyToClipboard"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["copyToClipboard"]++; }; 
	/** @type {string} */
	var sText = '';
	/** @type {number} */
	var i;

	if (window["UCF_System"]["sDevice"] !== 'standards') return;

	for (i = 0; i < this["oControl"]["aItems"]["length"]; i++) {
		sText += this["oControl"]["aItems"][i]["querySelectorAll"]("[id$='-text']")[0]["outerText"] + '\n';
	}

	UCF_ClipboardUtil["copyTextToClipboard"](sText, this["oLS"]);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["copyToClipboard"] = 0; };

/**
 * Retreives the token with the index from the list
 * @param {int} iIndex
 * @return {HTMLElement}
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["oGetTokenFromList"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["oGetTokenFromList"]++; }; 
	return (iIndex >= 0 && iIndex < this["oControl"]["aItems"]["length"]) ? this["oControl"]["aItems"][iIndex] : null;
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["oGetTokenFromList"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @return {HTMLElement} the token from
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["oGetTokenFromEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["oGetTokenFromEvent"]++; }; 
	/** {HTMLElement} */
	var oSource;
	/** {string} */
	var sId;
	/** {string} */
	var sTokenId;
	// click on the tokem should focus it
	oSource = oBrowserEvent["oGetSource"]();
	if (this["bIsTokenDeleteButton"](oSource)) {
		sId = oSource["id"];
		sTokenId = sId["replace"](/-delete/g, '');
		return UCF_DomUtil["$"](sTokenId);
	} else if (this["bIsToken"](oSource)) {
		return oSource;
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["oGetTokenFromEvent"] = 0; };

/**
 * [LEFT] / [UP]
 * Handles the navigation behaviour while pressing[LEFT] / [UP] key
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsprevious"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(737): onlsprevious"); };
	if (this["iCurrentIndex"] === -1)
		this["iCurrentIndex"] = this["oControl"]["aItems"]["length"];
	this["iCurrentIndex"]--;
	if (this["iCurrentIndex"] < 0)
		this["iCurrentIndex"] = 0;

	this["focusTokenAndNavigate"](this["iCurrentIndex"]);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsprevious"] = 0; };

/**
 * [LEFT] / [UP] with modifier
 * Handles the navigation behaviour while pressing[LEFT] / [UP] key and a modifier
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onlspreviousmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlspreviousmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(754): onlspreviousmodifier"); };
	/** {HTMLElement} */
	var oToken;
	var iKeyCode = oBrowserEvent["iKeyCode"]();

	// SHIFT LEFT -> extend selection
	// SHIFT UP -> do nothing
	// CTRL UP, CTRL LEFT -> move focus, do not select

	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent) && iKeyCode === UCF_KeyCodes["ARROW_LEFT"]) {
		this["onlsprevious"](oBrowserEvent);
		oToken = this["oGetTokenFromList"](this["iCurrentIndex"]);
		this["selectToken"](oToken);
	} else if (UCF_KeyboardHelper["bHasOnlyCtrlAsModifier"](oBrowserEvent)) {
		this["onlsprevious"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlspreviousmodifier"] = 0; };

/**
 * [RIGHT] / [DOWN]
 * Handles the navigation behaviour while pressing [RIGHT] / [DOWN] key
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsnext"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(779): onlsnext"); };
	if (this["iCurrentIndex"] === -1)
		this["iCurrentIndex"] = this["oControl"]["aItems"]["length"] - 2;
	this["iCurrentIndex"]++;
	if (this["iCurrentIndex"] >= this["oControl"]["aItems"]["length"])
		this["iCurrentIndex"] = this["oControl"]["aItems"]["length"] - 1;

	this["focusTokenAndNavigate"](this["iCurrentIndex"]);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsnext"] = 0; };

/**
 * [RIGHT] / [DOWN] with Modifier
 * Handles the navigation behaviour while pressing [RIGHT] / [DOWN] key and a modifier
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onlsnextmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsnextmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(796): onlsnextmodifier"); };
	/** {HTMLElement} */
	var oToken;
	var iKeyCode = oBrowserEvent["iKeyCode"]();

	// SHIFT RIGHT -> extend selection
	// SHIFT DOWN -> do nothing
	// CTRL DOWN, CTRL RIGHT -> move focus, do not select

	if (UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent) && iKeyCode === UCF_KeyCodes["ARROW_RIGHT"]) {
		this["onlsnext"](oBrowserEvent);
		oToken = this["oGetTokenFromList"](this["iCurrentIndex"]);
		this["selectToken"](oToken);
	} else if (UCF_KeyboardHelper["bHasOnlyCtrlAsModifier"](oBrowserEvent)) {
		this["onlsnext"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsnextmodifier"] = 0; };

/**
 * [HOME]
 * Handles the navigation behaviour while pressing [HOME] key
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlshome"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(821): onlshome"); };
	this["iCurrentIndex"] = 0;
	this["focusTokenAndNavigate"](this["iCurrentIndex"]);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlshome"] = 0; };

/**
 * [CTRL][HOME]
 * Handles the navigation behaviour while pressing [HOME] key and a modifier
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onlshomemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlshomemodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(833): onlshomemodifier"); };
	this["onlshome"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlshomemodifier"] = 0; };

/**
 * [END]
 * Handles the navigation behaviour while pressing [END] key
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(844): onlsend"); };
	this["iCurrentIndex"] = this["oControl"]["aItems"]["length"] - 1;
	this["focusTokenAndNavigate"](this["iCurrentIndex"]);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsend"] = 0; };

/**
 * [CTRL][END]
 * Handles the navigation behaviour while pressing [END] key and a modifier
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["onlsendmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsendmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "MultiComboBoxNavigationDelegate.js(856): onlsendmodifier"); };
	this["onlsend"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["onlsendmodifier"] = 0; };
/**
 *
 * Update the aria-activedescendant for the MultiComboBox with role=listbox
 * @param {HTMLElement} oDomRef the browser event object that occurred
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["updateAriaActivedescendant"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["updateAriaActivedescendant"]++; }; 
	/** {HTMLElement} */
	var oCurrentItem;
	if (oDomRef) {
		UCF_AriaStateHelper["setActivedescendant"](this["oControl"]["oDomRef"], oDomRef["id"]);
	} else {
		oCurrentItem = this["oGetTokenFromList"](this["iCurrentIndex"]);
		if (oCurrentItem)
			UCF_AriaStateHelper["setActivedescendant"](this["oControl"]["oDomRef"], oCurrentItem["id"]);
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["updateAriaActivedescendant"] = 0; };

/**
 * Update the aria-posinset, aria-setsize for each item from the list
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["updateAriaAttributeForItems"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["updateAriaAttributeForItems"]++; }; 
	/** {HTMLElement} */
	var oCurrentItem;

	for (var i = 0; i < this["oControl"]["aItems"]["length"]; i++) {
		oCurrentItem = this["oControl"]["aItems"][i];
		UCF_AriaStateHelper["setPosinset"](oCurrentItem, i + 1);
		UCF_AriaStateHelper["setSetsize"](oCurrentItem, this["oControl"]["aItems"]["length"]);
	}
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["updateAriaAttributeForItems"] = 0; };

/**
 * Update the aria-posinset, aria-setsize for each item from the list
 * @private
 */
UCF_MultiComboBoxNavigationDelegate["prototype"]["updateAriaOwns"] = function() {;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["updateAriaOwns"]++; }; 
	/** {HTMLElement} */
	var oCurrentItem;
	var sAriaOwns;

	sAriaOwns = '';

	for (var i = 0; i < this["oControl"]["aItems"]["length"]; i++) {
		oCurrentItem = this["oControl"]["aItems"][i];
		sAriaOwns += oCurrentItem["id"] + ' ';
	}
	UCF_AriaStateHelper["setOwns"](this["oControl"]["oDomRef"], sAriaOwns);
};;if (__UCF_COVERAGE__) { UCF_MultiComboBoxNavigationDelegate["_"]["updateAriaOwns"] = 0; };

};
sap["ls"]["preload"]["UCF_NavigationList"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_Expander */
/// <reference path="../anim/Expander.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_NavigationList(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["UCF_NavigationList"]++; }; 

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oScrollDomRef"] = UCF_DomUtil["$"](this["sId"] + '-scrl');

	this["oPersonalizeDomRef"] = UCF_DomUtil["$"](this["sId"] + '-pers');
	if (this["bExpandable"]) {
		this["oExpandIcon"] = UCF_DomUtil["$"](this["sId"] + "-exp");
		this["oExpander"] = new (UCF_ClassLoader["oGetClass"]("UCF_Expander"))(this["oScrollDomRef"]);
		this["oFocusDomRef"] = this["oExpandIcon"];
	}

	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]);
	//this.bHasSelectedItem = false;
	this["createItems"]();
	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Select"], this, "onItemSelect");
	this["oItemNavigation"]["setFocusedIndex"](this["oItemNavigation"]["iFocusedIndex"]);

	//this.oItemNavigation.bIgnoreFocus = true;
};window["UCF_NavigationList"] = UCF_NavigationList; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_NavigationList"); UCF_NavigationList["_"] = {UCF_NavigationList: 0}; }; ;
UCF_NavigationList["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_NavigationList.prototype["sClassName"] = "UCF_NavigationList";

UCF_NavigationList["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsfocus"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsfocus"] = 0; };

/**
 * Decides whether the item navigation sets the focus
 */

/*
UCF_NavigationList.prototype.onkeydown = function(oBrowserEvent) {

	if (oBrowserEvent.bAlt() || oBrowserEvent.bCtrl()) return;

	var bTab = (oBrowserEvent.iKeyCode() === UCF_KeyCodes.TAB),
		bShift = oBrowserEvent.bShift(),
		sControlType = this.oGetSourceType(oBrowserEvent.oGetSourceControl()),
		oSource = oBrowserEvent.oGetSource(),
		bEnd = (oSource.getAttribute("id") && oSource.getAttribute("id").indexOf("-end") > -1);

	if ((bTab && !bShift && !bEnd) || (bTab && bShift && sControlType !== "NAVIGATIONLIST"))
		this.oItemNavigation.bIgnoreFocus = true;

	else if ((bTab && bShift && bEnd) || (bTab && !bShift && sControlType === "NAVIGATIONLIST"))
		this.oItemNavigation.bIgnoreFocus = false;
};
*/

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_NavigationList["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "NavigationList.js(92): onclick"); };

	var oSource = oBrowserEvent["oGetSource"](),
		oSourceControl = oBrowserEvent["oGetSourceControl"]();

	if (oSource["getAttribute"]("id") && oSource["getAttribute"]("id")["indexOf"]("-exp") > -1) {
		this["toggle"]();
	} else if (this["oPersonalizeDomRef"] !== null && oSource === this["oPersonalizeDomRef"]) {
		this["firePersonalize"](this["sId"]);
	} else if (UCF_JsUtil["bInstanceOf"](oSourceControl, "UCF_NavigationListItem") && oSourceControl["sPopupMenuId"] !== '' && oSourceControl["bEnabled"]) {
		this["fireMenuAccess"](this["sId"], oSourceControl["sId"], oSourceControl["sPopupMenuId"]);
		this["openMenu"](oSourceControl);
	}
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onclick"] = 0; };

UCF_NavigationList["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["oncontextmenu"]++; }; 
	var oSourceControl = oBrowserEvent["oGetSourceControl"]();

	if (UCF_JsUtil["bInstanceOf"](oSourceControl, "UCF_NavigationListItem") && oSourceControl["sPopupMenuId"] !== "") {
		this["fireMenuAccess"](this["sId"], oSourceControl["sId"], oSourceControl["sPopupMenuId"]);
		this["openMenu"](oSourceControl);
	}
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["oncontextmenu"] = 0; };

/**
 * Opens an associated menu, F4 key
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_NavigationList["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsshow"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "NavigationList.js(124): onlsshow"); };

	var oItem = oBrowserEvent["oGetSourceControl"](),
		sSourceType = this["oGetSourceType"](oItem);

	if (sSourceType !== "NAVIGATIONLISTITEM" || oItem["sPopupMenuId"] === "") return;

	this["fireMenuAccess"](this["sId"], oItem["sId"], oItem["sPopupMenuId"]);
	this["openMenu"](oItem);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsshow"] = 0; };

/**
 * Handles the keydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_NavigationList["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsexpand"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "NavigationList.js(143): onlsexpand"); };

	if (this["getCollapseStatus"](oBrowserEvent)) {
		this["toggle"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsexpand"] = 0; };

/**
 * Handles the right arrow on the HeaderArea/ Panel
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_NavigationList["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsright"]++; }; 
	this["onlsexpand"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsright"] = 0; };

/**
 * Handles the keydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_NavigationList["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlscollapse"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "NavigationList.js(169): onlscollapse"); };

	if (this["getCollapseStatus"](oBrowserEvent)) {
		this["toggle"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}

};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlscollapse"] = 0; };

/**
 * Handles the left arrow on the HeaderArea/ Panel
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_NavigationList["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsleft"]++; }; 
	this["onlscollapse"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsleft"] = 0; };

/**
 * Looks whether the focus is on the outer element
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @return {boolean} - true if it's collapsed
 * @private
 */
UCF_NavigationList["prototype"]["getCollapseStatus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["getCollapseStatus"]++; }; 

	var oSourceControl = oBrowserEvent["oGetSourceControl"](),
		oSource = oBrowserEvent["oGetSource"](),
		sSourceId = oSource["getAttribute"]("id"),
		sSourceType = this["oGetSourceType"](oSourceControl),
		bKeyboardEvent = oBrowserEvent["oDomEvent"]["type"] === "keydown",
		iKey = oBrowserEvent["iKeyCode"]();

	if (sSourceType === null || !this["bExpandable"] || sSourceId["indexOf"]("-pers") > -1 ||
		sSourceType === "NAVIGATIONLISTITEM" || sSourceType === "NAVIGATIONLISTGROUP" ||
		(bKeyboardEvent && this["bExpanded"] && iKey === UCF_KeyCodes["NUMPAD_PLUS"]) ||
		(bKeyboardEvent && this["bExpanded"] && iKey === UCF_KeyCodes["ARROW_RIGHT"]) ||
		(bKeyboardEvent && !this["bExpanded"] && iKey === UCF_KeyCodes["NUMPAD_MINUS"]) ||
		(bKeyboardEvent && !this["bExpanded"] && iKey === UCF_KeyCodes["ARROW_LEFT"])) return false;

	return true;
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["getCollapseStatus"] = 0; };

/**
 * Handles opening and closing of content area
 */
UCF_NavigationList["prototype"]["toggle"] = function() {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["toggle"]++; }; 

	if (this["bExpanded"]) {
		UCF_DomUtil["replaceClass"](this["oExpandIcon"], "urFRAExpOp", "urFRAExpClo");
		this["oScrollDomRef"]["style"]["display"] = "none";
		this["fireCollapse"](this["sId"]);
		this["oExpandIcon"]["title"] = this["oLS"]["sGetText"]('SAPUR_BTNTYP_EXPANDEND');
		if (window["UCF_System"]["bIsAria"])
			UCF_AriaStateHelper["setOrRemoveAttribute"](this["oExpandIcon"], 'aria-label', this["oLS"]["sGetText"]('SAPUR_BTNTYP_EXPANDEND'));
	} else {
		UCF_DomUtil["replaceClass"](this["oExpandIcon"], "urFRAExpClo", "urFRAExpOp");
		this["oScrollDomRef"]["style"]["display"] = "block";
		this["fireExpand"](this["sId"]);
		this["oExpandIcon"]["title"] = this["oLS"]["sGetText"]('SAPUR_BTNTYP_COLLAPSEBEGIN');
		if (window["UCF_System"]["bIsAria"])
			UCF_AriaStateHelper["setOrRemoveAttribute"](this["oExpandIcon"], 'aria-label', this["oLS"]["sGetText"]('SAPUR_BTNTYP_COLLAPSEBEGIN'));
	}
	this["bExpanded"] = !this["bExpanded"];
	this["setClientProperty"]("Expanded", this["bExpanded"], true);

	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setExpanded"](this["oExpandIcon"], this["bExpanded"]);
	}
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["toggle"] = 0; };

/**
 * Fires the selection event of the item
 * @param {Event} oEvent - event thta occurs while selection
 *
 */
UCF_NavigationList["prototype"]["onItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onItemSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "NavigationList.js(249): onItemSelect"); };

	var oItem = oEvent["oGetParam"]("oItem"),
		sSourceType = this["oGetSourceType"](oItem);

	if (sSourceType === "NAVIGATIONLISTITEM" && !oItem["bSelected"] && oItem["bEnabled"] && oItem["sPopupMenuId"] === "")
		this["fireSelect"](this["sId"], oItem["sId"]);
	else if (sSourceType === "NAVIGATIONLISTGROUP" && oItem["bIsClickable"])
		this["fireSelect"](this["sId"], oItem["sId"]);
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onItemSelect"] = 0; };

/**
 * Opens a popup menu, if the item knows the id of its associated menu.
 * @param { Event } oItem - event thta occurs while selection
 * @param {boolean} bWidthKeyboard - true if the menu is open using the keyboard
 */
UCF_NavigationList["prototype"]["openMenu"] = function(oItem, bWidthKeyboard) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["openMenu"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oItem) === "object", "typeof(oItem) === \"object\"", "NavigationList.js(267): openMenu"); };

	if (!oItem["bEnabled"] || oItem["sPopupMenuId"] === "") return;
	this["oPopupMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](oItem["sPopupMenuId"], true);
	this["oPopupMenu"]["setOpenerRef"](oItem["oDomRef"]);
	this["oPopupMenu"]["setOpenerId"](oItem["sId"]);
	this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
	this["iOldFocusedIndex"] = this["oItemNavigation"]["iFocusedIndex"];
	this["oPopupMenu"]["open"](bWidthKeyboard);
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["openMenu"] = 0; };

/**
 * handles the Close event of the PopupMenu
 * @param { Event } oEvent - event which occurs when the menu is closed
 */
UCF_NavigationList["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onMenuClose"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "NavigationList.js(284): onMenuClose"); };
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this);
	this["oItemNavigation"]["focusItemByIndex"](this["iOldFocusedIndex"]);
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onMenuClose"] = 0; };

/**
 * Passes all items that are neccessary for the navigation to the navigation framework
 */

UCF_NavigationList["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["createItems"]++; }; 

	var aDomItems = this["oScrollDomRef"]["getElementsByTagName"]("DIV");

	for (var i = 0; i < aDomItems["length"]; i++) {

		var oControlItem = (aDomItems[i]["getAttribute"]("ct")) ? this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[i], true) :
			this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[i]["parentNode"]["parentNode"], true),
			sSourceType = this["oGetSourceType"](oControlItem);

		if (oControlItem === null || sSourceType === null) continue;

		if (sSourceType === "NAVIGATIONLISTGROUP") {
			oControlItem["bEnabled"] = true;
			oControlItem["bSelected"] = false;
		}

		if (oControlItem["bEnabled"] || window["UCF_System"]["bIs508"] || window["UCF_System"]["bIsAria"]) {
			this["oItemNavigation"]["addItem"](oControlItem, oControlItem["bSelected"]);
		}

		oControlItem["iIndex"] = this["oItemNavigation"]["aItems"]["length"];
	}
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["createItems"] = 0; };

/**
 * Finds the control type of a navigation list object and returns it.
 * @param { UCF_Control } oObject - the control object or a {HTMLElement}
 * @return {string} - the control type
 */
UCF_NavigationList["prototype"]["oGetSourceType"] = function(oObject) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["oGetSourceType"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oObject) === "object", "typeof(oObject) === \"object\"", "NavigationList.js(324): oGetSourceType"); };

	if (UCF_JsUtil["bInstanceOf"](oObject, "UCF_NavigationListItem"))
		return "NAVIGATIONLISTITEM";
	else if (UCF_JsUtil["bInstanceOf"](oObject, "UCF_NavigationListGroup"))
		return "NAVIGATIONLISTGROUP";
	else if (UCF_JsUtil["bInstanceOf"](oObject, "UCF_NavigationList"))
		return "NAVIGATIONLIST";
	else if ((oObject["id"] && oObject["id"]["indexOf"]("-pers") > -1)
		|| (oObject["sId"] && oObject["sId"]["indexOf"]("-pers") > -1))
		return "PERSONALIZE";
	else if ((oObject["id"] && oObject["id"]["indexOf"]("-end") > -1)
		|| (oObject["sId"] && oObject["sId"]["indexOf"]("-end") > -1))
		return "END";

	return null;
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["oGetSourceType"] = 0; };

/**
 * Gets the direct children as string.
 *
 * @see UCF_Control.sGetAccChildren
 * @return {string} - the accessibility description for navigationList child
 *
 */
UCF_NavigationList["prototype"]["sGetAccChildren"] = function() {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["sGetAccChildren"]++; }; 
	return this["oLS"]["sGetText"]("SAPUR_ACC_NL_CHILDREN");
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["sGetAccChildren"] = 0; };

/**
 * Calls the right setter for acc text according to the focused control type
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_NavigationList["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "NavigationList.js(360): onlsaccessibility"); };

	var oControl = oBrowserEvent["oGetSourceControl"](),
		oSource = oBrowserEvent["oGetSource"](),
		sSourceType = (oSource["id"]["indexOf"]("-") === -1) ? this["oGetSourceType"](oControl) : this["oGetSourceType"](oSource);

	if (sSourceType === null) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	switch (sSourceType) {
		case "NAVIGATIONLIST":
			this["setAccTextForList"](oAccessibilityHelper);
			break;
		case "NAVIGATIONLISTGROUP":
			this["setAccTextForGroup"](oAccessibilityHelper, oControl);
			break;
		case "NAVIGATIONLISTITEM":
			this["setAccTextForItem"](oAccessibilityHelper, oControl);
			break;
		case "PERSONALIZE":
			this["setAccTextForPersonalize"](oAccessibilityHelper);
			break;
		case "END":
			this["setAccTextForEnd"](oAccessibilityHelper);
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsaccessibility"] = 0; };

/**
 * Set screen reader text for navigation list - root control
 * @param {UCF_BrowserEvent} oAccessibilityHelper
 * @private
 */
UCF_NavigationList["prototype"]["setAccTextForList"] = function(oAccessibilityHelper) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setAccTextForList"]++; }; 

	oAccessibilityHelper["setText"](this["sTitle"]);
	oAccessibilityHelper["setControlType"]("NL");
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);

	oAccessibilityHelper["applyContainerEntryBehaviour"](this["bExpandable"], true, !this["bExpanded"]);
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setAccTextForList"] = 0; };

/**
 * Set screen reader text for navigation list group
 * @param { UCF_BrowserEvent } oAccessibilityHelper
 * @param {UCF_Control} oControl
 */
UCF_NavigationList["prototype"]["setAccTextForGroup"] = function(oAccessibilityHelper, oControl) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setAccTextForGroup"]++; }; 

	oAccessibilityHelper["setText"](oControl["sTitle"]);
	oAccessibilityHelper["setControlType"]("NL_G");
	oAccessibilityHelper["setItemCount"](this["oItemNavigation"]["aItems"]["length"]);
	oAccessibilityHelper["setItemIndex"](oControl["iIndex"]);
	oAccessibilityHelper["addTutor"]("NL_G_TUT");
	if (oControl["bIsClickable"])
		oAccessibilityHelper["addTutor"]("SELECT_TUT");
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setAccTextForGroup"] = 0; };

/**
 * Set screen reader text for navigation list item
 * @param { UCF_BrowserEvent } oAccessibilityHelper
 * @param { UCF_Control } oControl
 * @private
 */
UCF_NavigationList["prototype"]["setAccTextForItem"] = function(oAccessibilityHelper, oControl) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setAccTextForItem"]++; }; 

	oAccessibilityHelper["setText"](oControl["sText"]);
	oAccessibilityHelper["setControlType"]("NL_I");
	oAccessibilityHelper["setItemCount"](this["oItemNavigation"]["aItems"]["length"]);
	oAccessibilityHelper["setItemIndex"](oControl["iIndex"]);
	oAccessibilityHelper["setSelected"](oControl["bSelected"]);
	oAccessibilityHelper["setEnabled"](oControl["bEnabled"]);

	if (oControl["bEnabled"] && oControl["sPopupMenuId"] !== "") {
		oAccessibilityHelper["addTutor"]("NL_I_POP_TUT");
	} else if (oControl["bEnabled"] && oControl["sPopupMenuId"] === "") {
		oAccessibilityHelper["addTutor"]("NL_I_TUT");
	}
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setAccTextForItem"] = 0; };

/**
 * Set screen reader text for personalize
 * @param { UCF_BrowserEvent } oAccessibilityHelper
 * @private
 */
UCF_NavigationList["prototype"]["setAccTextForPersonalize"] = function(oAccessibilityHelper) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setAccTextForPersonalize"]++; }; 

	oAccessibilityHelper["setControlType"]("PERS");
	oAccessibilityHelper["addTutor"]("LN_TUT");
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setAccTextForPersonalize"] = 0; };

/**
 * Set screen reader text for end point
 * @param { UCF_BrowserEvent } oAccessibilityHelper
 * @private
 */
UCF_NavigationList["prototype"]["setAccTextForEnd"] = function(oAccessibilityHelper) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setAccTextForEnd"]++; }; 

	oAccessibilityHelper["setControlType"]("NL_END");
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setAccTextForEnd"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_NavigationList["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_NavigationList["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsskipback"] = 0; };

/**
 * Handles the space event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_NavigationList["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsspace"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();

	if (this["oPersonalizeDomRef"] !== null && oSource === this["oPersonalizeDomRef"]) {
		this["firePersonalize"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	} else {
		this["onlsexpand"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsspace"] = 0; };

/**
 * Handles the enter event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_NavigationList["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsenter"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();

	if (this["oPersonalizeDomRef"] !== null && oSource === this["oPersonalizeDomRef"]) {
		this["firePersonalize"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	} else {
		this["onlsexpand"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["onlsenter"] = 0; };

UCF_NavigationList["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["destroy"]++; }; 

	if (this["oExpander"]) {
		this["oExpander"]["destroy"]();
		this["oExpander"] = null;
	}
	if (this["oItemNavigation"]) {
		this["oItemNavigation"]["destroy"]();
		this["oItemNavigation"] = null;
	}
	this["oScrollDomRef"] = null;
	this["oExpandIcon"] = null;
	this["oPopupMenu"] = null;
	this["bExpanded"] = false;
	this["iOldFocusedIndex"] = 0;
	this["oPersonalizeDomRef"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_NavigationList["prototype"]["aAttributeNames"] = ["sTitle","bExpandable","bExpanded","iContentHeight","sTooltip","iHeadingLevel","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_NavigationList["prototype"]["aEventNames"] = ["Select","Expand","Collapse","MenuAccess","Personalize"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_NavigationList["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_NavigationList["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_NavigationList["prototype"]["bExpandable"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_NavigationList["prototype"]["bExpanded"] = true;

/**
 * @private
 * @type {number}
 */
UCF_NavigationList["prototype"]["iContentHeight"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_NavigationList["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {number}
 */
UCF_NavigationList["prototype"]["iHeadingLevel"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_NavigationList["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_NavigationList["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setDefaultValues"]++; }; 
	this["sTitle"] = '';
	this["bExpandable"] = false;
	this["bExpanded"] = true;
	this["iContentHeight"] = 0;
	this["sTooltip"] = '';
	this["iHeadingLevel"] = 0;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("Expandable", false, true);
		this["setClientProperty"]("Expanded", true, true);
		this["setClientProperty"]("ContentHeight", 0, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {string} sItemId Identifier of the selected item.
 * @fires NavigationList::Select
 */
UCF_NavigationList["prototype"]["fireSelect"] = function(sId, sItemId) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, ItemId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "NavigationList.js(636): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "NavigationList.js(637): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "NavigationList.js(638): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "NavigationList.js(639): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "NavigationList.js(640): fireSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId
	};
	
	
	this["fireSemanticEvent"]("NavigationList", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires NavigationList::Expand
 */
UCF_NavigationList["prototype"]["fireExpand"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["fireExpand"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "NavigationList.js(659): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "NavigationList.js(660): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "NavigationList.js(661): fireExpand"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("NavigationList", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["fireExpand"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires NavigationList::Collapse
 */
UCF_NavigationList["prototype"]["fireCollapse"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "NavigationList.js(678): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "NavigationList.js(679): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "NavigationList.js(680): fireCollapse"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("NavigationList", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["fireCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {string} sItemId Identifier of the the item to which the popupmenu is associated.
 * @param {string} sPopupMenuId Identifier of the popupmenu associated to the item.
 * @fires NavigationList::MenuAccess
 */
UCF_NavigationList["prototype"]["fireMenuAccess"] = function(sId, sItemId, sPopupMenuId) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string, ItemId: string, PopupMenuId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "NavigationList.js(701): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "NavigationList.js(702): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "NavigationList.js(703): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "NavigationList.js(704): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "NavigationList.js(705): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPopupMenuId != null, "sPopupMenuId != null", "NavigationList.js(706): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPopupMenuId) == "string", "typeof(sPopupMenuId) == \"string\"", "NavigationList.js(707): fireMenuAccess"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"PopupMenuId": sPopupMenuId
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	if (sPopupMenuId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sPopupMenuId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "PopupMenuId");
			}
		}
	this["fireSemanticEvent"]("NavigationList", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["fireMenuAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires NavigationList::Personalize
 */
UCF_NavigationList["prototype"]["firePersonalize"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["firePersonalize"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "NavigationList.js(738): firePersonalize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "NavigationList.js(739): firePersonalize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "NavigationList.js(740): firePersonalize"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("NavigationList", "Personalize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_NavigationList["_"]["firePersonalize"] = 0; };

};
sap["ls"]["preload"]["UCF_NavigationListGroup"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_NavigationListGroup(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_NavigationListGroup["_"]["UCF_NavigationListGroup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "NavigationListGroup.js(17): UCF_NavigationListGroup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "NavigationListGroup.js(18): UCF_NavigationListGroup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "NavigationListGroup.js(19): UCF_NavigationListGroup"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_NavigationListGroup"] = UCF_NavigationListGroup; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_NavigationListGroup"); UCF_NavigationListGroup["_"] = {UCF_NavigationListGroup: 0}; }; ;
UCF_NavigationListGroup["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_NavigationListGroup.prototype["sClassName"] = "UCF_NavigationListGroup";

UCF_NavigationListGroup["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationListGroup["_"]["onlsfocus"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_NavigationListGroup["_"]["onlsfocus"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_NavigationListGroup["prototype"]["aAttributeNames"] = ["sTitle","bIsClickable","sTooltip","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_NavigationListGroup["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_NavigationListGroup["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_NavigationListGroup["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_NavigationListGroup["prototype"]["bIsClickable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_NavigationListGroup["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_NavigationListGroup["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_NavigationListGroup["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_NavigationListGroup["_"]["setDefaultValues"]++; }; 
	this["sTitle"] = '';
	this["bIsClickable"] = false;
	this["sTooltip"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("IsClickable", false, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_NavigationListGroup["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_NavigationListItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_NavigationListItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_NavigationListItem["_"]["UCF_NavigationListItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "NavigationListItem.js(19): UCF_NavigationListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "NavigationListItem.js(20): UCF_NavigationListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "NavigationListItem.js(21): UCF_NavigationListItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	//DONE: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	//	this.oFocusDomRef = this.oDomRef.firstChild.firstChild;
	this["oFocusDomRef"] = UCF_DomUtil["firstChild"](this["oDomRef"]);
};window["UCF_NavigationListItem"] = UCF_NavigationListItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_NavigationListItem"); UCF_NavigationListItem["_"] = {UCF_NavigationListItem: 0}; }; ;

UCF_NavigationListItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_NavigationListItem.prototype["sClassName"] = "UCF_NavigationListItem";

UCF_NavigationListItem["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_NavigationListItem["_"]["onlsfocus"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_NavigationListItem["_"]["onlsfocus"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_NavigationListItem["prototype"]["aAttributeNames"] = ["sText","bEnabled","bSelected","sPopupMenuId","sContextMenuId","sTooltip","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_NavigationListItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_NavigationListItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_NavigationListItem["prototype"]["sText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_NavigationListItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_NavigationListItem["prototype"]["bSelected"] = false;

/**
 * @private
 * @type {string}
 */
UCF_NavigationListItem["prototype"]["sPopupMenuId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_NavigationListItem["prototype"]["sContextMenuId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_NavigationListItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_NavigationListItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_NavigationListItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_NavigationListItem["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["bEnabled"] = true;
	this["bSelected"] = false;
	this["sPopupMenuId"] = '';
	this["sContextMenuId"] = '';
	this["sTooltip"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Selected", false, true);
		this["setClientProperty"]("PopupMenuId", '', true);
		this["setClientProperty"]("ContextMenuId", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_NavigationListItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_NestingAnalyzer"] = function() {/* global _measure, START, STOP */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>

/**
 * DOM Analyzer for more detailed information about the current page.
 * Especially nesting depth, nesting of tables
 *
 * Numbers:
 * Max Nesting: The maximal  nesting level that appears in the document
 * Avg Nesting: The average nesting level
 * Max Table Nesting: Somehow clear what that means (more that 24 the browser
 * stops rendering)
 * Max Critical Nesting: Nesting of tags that have a height and width
 * specified. (More than 40 the browser stops rendering)
 *
 * 
 * @class UCF_NestingAnalyzer
 * @extends UCF_Object
 */
function UCF_NestingAnalyzer() {if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["UCF_NestingAnalyzer"]++; }; 
	UCF_Object["apply"](this);

	/** @type {number} */
	this["iCount"] = 0;
	/** @type {number} */
	this["iElementCount"] = 0;
	/** @type {number} */
	this["iTextCount"] = 0;
	/** @type {Object.<string,number>} */
	this["mTagCount"] = {};
	/** @type {Array.<number>} */
	this["aLevelCount"] = [];

	/** @type {number} */
	this["iNesting"] = 0;
	/** @type {number} */
	this["iMaxNesting"] = 0;
	/** @type {number} */
	this["iParentCount"] = 0;
	/** @type {string} */
	this["sStartingCt"] = '';
	/** @type {number} */
	this["iNestingSum"] = 0;
	/** @type {number} */
	this["fAvgNesting"] = 0;

	/** @type {number} */
	this["iTableNesting"] = 0;
	/** @type {number} */
	this["iMaxTableNesting"] = 0;

	/** @type {number} */
	this["iCritNesting"] = 0;
	/** @type {number} */
	this["iMaxCritNesting"] = 0;
	/** @type {Array.<string>} */
	this["aCritNesting"] = [];
};window["UCF_NestingAnalyzer"] = UCF_NestingAnalyzer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_NestingAnalyzer"); UCF_NestingAnalyzer["_"] = {UCF_NestingAnalyzer: 0}; }; ;
UCF_NestingAnalyzer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_NestingAnalyzer.prototype["sClassName"] = "UCF_NestingAnalyzer";

/** @constant {number} */
UCF_NestingAnalyzer["ELEMENT_NODE"] = 1;
/** @constant {number} */
UCF_NestingAnalyzer["TEXT_NODE"] = 3;
/** @constant {number} */
UCF_NestingAnalyzer["COMMENT_NODE"] = 8;

/** @constant {number} */
UCF_NestingAnalyzer["MAX_DEPTH_WARNING"] = 60;
/** @constant {number} */
UCF_NestingAnalyzer["AVG_DEPTH_WARNING"] = 40;
/** @constant {number} */
UCF_NestingAnalyzer["TBL_DEPTH_WARNING"] = 10;
/** @constant {number} */
UCF_NestingAnalyzer["TBL_DEPTH_ERROR"] = 25;
/** @constant {number} */
UCF_NestingAnalyzer["CRIT_DEPTH_WARNING"] = 20;
/** @constant {number} */
UCF_NestingAnalyzer["CRIT_DEPTH_ERROR"] = 40;

/** @constant {number} */
UCF_NestingAnalyzer["REPORT_COLS"] = 70;

/** @override */
UCF_NestingAnalyzer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["destroy"]++; }; 
	this["reset"]();

	this["iParentCount"] = null;
	this["sStartingCt"] = null;
	this["sMaxCritNesting"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["destroy"] = 0; };

/**
 * Trigger DOM Analyzer
 * @public
 */
UCF_NestingAnalyzer["prototype"]["trigger"] = function() {;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["trigger"]++; }; 
	/** @type {HTMLElement} */
	var oRootRef = UCF_DomUtil["querySelector"]('[ct="PAGE"]')
		|| document["documentElement"];

	this["reset"]();

	if (__UCF_MEASURE__) { UCF_Tracer.measure(START, 'NestingAnalyzer#analyze()'); };
	this["analyze"](oRootRef);
	if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, 'NestingAnalyzer#analyze()'); };
	// eslint-disable-next-line no-magic-numbers
	this["fAvgNesting"] = Math["floor"](10 * this["iNestingSum"] / this["iElementCount"]) / 10;

	alert(this["createReport"](oRootRef));
	alert(this["createLevelReport"](oRootRef));
};;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["trigger"] = 0; };

/**
 * Traverse DOM and collect
 *
 * @private
 * @param {DOMElement} node
 */
UCF_NestingAnalyzer["prototype"]["analyze"] = function(node) {;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["analyze"]++; }; 
	/** @type {boolean} */
	var bIsTable;
	/** @type {boolean} */
	var bIsCritical;
	/** @type {string} */
	var sTagName;
	/** @type {string} */
	var sCt;
	/** @type {string} */
	var sId;
	/** @type {number} */
	var i;
	/** @type {CSSStyleDeclaration} */
	var oComputedStyle;

	this["iCount"]++;
	if (this["iNesting"] > this["iMaxNesting"]) {
		this["iMaxNesting"] = this["iNesting"];
	}
	if (this["iTableNesting"] > this["iMaxTableNesting"]) {
		this["iMaxTableNesting"] = this["iTableNesting"];
	}
	if (this["iCritNesting"] > this["iMaxCritNesting"]) {
		this["iMaxCritNesting"] = this["iCritNesting"];
		this["sMaxCritNesting"] = this["aCritNesting"]["join"]('\n');
	}

	switch (node["nodeType"]) {
		case UCF_NestingAnalyzer["ELEMENT_NODE"]:
			sTagName = node["tagName"];
			sId = node["getAttribute"]('id');
			sCt = node["getAttribute"]('ct');
			bIsTable = sTagName === 'TABLE';
			oComputedStyle = UCF_DomUtil["oGetComputedStyle"](node);
			bIsCritical = oComputedStyle["height"] !== 'auto' ||
				oComputedStyle["width"] !== 'auto';

			this["iElementCount"]++;
			this["iNestingSum"] += this["iNesting"];

			if (!this["mTagCount"][sTagName]) {
				this["mTagCount"][sTagName] = 0;
			}
			this["mTagCount"][sTagName]++;

			if (!this["aLevelCount"][this["iNesting"]]) {
				this["aLevelCount"][this["iNesting"]] = 0;
			}
			this["aLevelCount"][this["iNesting"]]++;

			this["iNesting"]++;
			if (bIsTable) {
				this["iTableNesting"]++;
			}
			if (bIsCritical) {
				this["iCritNesting"]++;
				this["aCritNesting"]["push"](
					sTagName + (sCt ? (', ' + sCt + ' \'' + sId + '\'') : '')
				);
			}

			for (i = 0; i < node["childNodes"]["length"]; i++) {
				this["analyze"](node["childNodes"][i]);
			}

			this["iNesting"]--;
			if (bIsTable) {
				this["iTableNesting"]--;
			}
			if (bIsCritical) {
				this["iCritNesting"]--;
				this["aCritNesting"]["pop"]();
			}

			break;
		case UCF_NestingAnalyzer["TEXT_NODE"]:
			this["iTextCount"]++;
			break;
		case UCF_NestingAnalyzer["COMMENT_NODE"]:
			break;
	}

	this["iParentCount"] = this["iGetParentCount"](UCF_DomUtil["querySelector"]('[ct="PAGE"]') || document["documentElement"]);
	this["sStartingCt"] = UCF_DomUtil["querySelector"]('[ct="PAGE"]')["getAttribute"]('ct');

};;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["analyze"] = 0; };

/** @private */
UCF_NestingAnalyzer["prototype"]["reset"] = function() {;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["reset"]++; }; 
	this["iCount"] = 0;
	this["iElementCount"] = 0;
	this["iTextCount"] = 0;
	this["mTagCount"] = {};

	this["iNesting"] = 0;
	this["iMaxNesting"] = 0;
	this["iNestingSum"] = 0;
	this["fAvgNesting"] = 0;

	this["iTableNesting"] = 0;
	this["iMaxTableNesting"] = 0;

	this["iCritNesting"] = 0;
	this["iMaxCritNesting"] = 0;
	this["aCritNesting"] = [];
};;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["reset"] = 0; };

/**
 * @private
 * @param {HTMLElement} [oRootRef] the root element the analyse was made for
 * @return {string}
 */
UCF_NestingAnalyzer["prototype"]["createReport"] = function(oRootRef) {;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["createReport"]++; }; 
	/** @type {number} */
	var iParentCount = 0;
	/** @type {string} */
	var sOffsetDescription = '';
	/** @type {string} */
	var sMaxDepthWarning = UCF_NestingAnalyzer["MAX_DEPTH_WARNING"];
	/** @type {string} */
	var sAvgDepthWarning = UCF_NestingAnalyzer["AVG_DEPTH_WARNING"];
	/** @type {string} */
	var sTblDepthWarning = UCF_NestingAnalyzer["TBL_DEPTH_WARNING"];
	/** @type {string} */
	var sTblDepthError = UCF_NestingAnalyzer["TBL_DEPTH_ERROR"];
	/** @type {string} */
	var sCritDepthWarning = UCF_NestingAnalyzer["CRIT_DEPTH_WARNING"];
	/** @type {string} */
	var sCritDepthError = UCF_NestingAnalyzer["CRIT_DEPTH_ERROR"];

	if (oRootRef && oRootRef !== document["documentElement"]) {
		iParentCount = this["iGetParentCount"](oRootRef);
		sOffsetDescription = '(starting from ' + oRootRef["getAttribute"]('ct') +
			' on nesting level ' + iParentCount + ')\n';
		sMaxDepthWarning = '' + iParentCount + '+' +
			(UCF_NestingAnalyzer["MAX_DEPTH_WARNING"] - iParentCount);
		sAvgDepthWarning = '' + iParentCount + '+' +
			(UCF_NestingAnalyzer["AVG_DEPTH_WARNING"] - iParentCount);
		sTblDepthWarning = '' + iParentCount + '+' +
			(UCF_NestingAnalyzer["TBL_DEPTH_WARNING"] - iParentCount);
		sTblDepthError = '' + iParentCount + '+' +
			(UCF_NestingAnalyzer["TBL_DEPTH_ERROR"] - iParentCount);
		sCritDepthWarning = '' + iParentCount + '+' +
			(UCF_NestingAnalyzer["CRIT_DEPTH_WARNING"] - iParentCount);
		sCritDepthError = '' + iParentCount + '+' +
			(UCF_NestingAnalyzer["CRIT_DEPTH_ERROR"] - iParentCount);
	}

	return 'Nesting depth of elements in the HTML DOM\n' +
		sOffsetDescription + '\n' +

		'Maximum Nesting Depth: ' + this["iMaxNesting"] + '\n' +
		'(should not exceed ' + sMaxDepthWarning + ')\n\n' +

		'Average Nesting Depth: ' + this["fAvgNesting"] + '\n' +
		'(should not exceed ' + sAvgDepthWarning + ')\n\n' +

		'Maximum Table Nesting Depth: ' + this["iMaxTableNesting"] + '\n' +
		'(should not exceed ' + sTblDepthWarning + ', ' +
		'must not exceed ' + sTblDepthError + ')\n\n' +

		'Maximum Critical Nesting Depth: ' + this["iMaxCritNesting"] + '\n' +
		'(should not exceed ' + sCritDepthWarning + ', ' +
		'must not exceed ' + sCritDepthError + ')\n\n' +

		'Maximum Critical Nesting Elements:\n\n' + this["sMaxCritNesting"] + '\n\n';
};;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["createReport"] = 0; };

/**
 * @private
 * @param {HTMLElement} oRef the element to get the count for
 * @param {number} [iCount=0] already counted parent elements (for recursion)
 * @return {number}
 */
UCF_NestingAnalyzer["prototype"]["iGetParentCount"] = function(oRef, iCount) {;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["iGetParentCount"]++; }; 
	if (typeof iCount !== 'number') {
		iCount = 0;
	}

	return oRef === document["documentElement"]
		? iCount
		: this["iGetParentCount"](UCF_DomUtil["oGetParentElement"](oRef), iCount + 1);
};;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["iGetParentCount"] = 0; };

/**
 * @private
 * @param {HTMLElement} [oRootRef] the root element
 * @return {string}
 */
UCF_NestingAnalyzer["prototype"]["createLevelReport"] = function(oRootRef) {;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["createLevelReport"]++; }; 
	/** @type {number} */
	var iParentCount = oRootRef && oRootRef !== document["documentElement"]
		? this["iGetParentCount"](oRootRef)
		: 0;
	/** @type {number} */
	var iMaxCount = 0;
	/** @type {number} */
	var iElementCount;
	/** @type {number} */
	var iNormalizedCount;
	/** @type {number} */
	var iEffectiveLineNumber;
	/** @type {number} */
	var i;
	/** @type {number} */
	var j;
	/** @type {number} */
	var jj;
	/** @type {string} */
	var sReport = 'Distribution of elements at the different nesting levels\n' +
		(iParentCount > 0 ? ('(starting at level ' + iParentCount + ')') : '') +
		'\n';

	for (i = 0; i < this["aLevelCount"]["length"]; i++) {
		iElementCount = this["aLevelCount"][i];
		if (iElementCount > iMaxCount) {
			iMaxCount = iElementCount;
		}
	}

	for (j = 0; j < this["aLevelCount"]["length"]; j++) {
		iEffectiveLineNumber = iParentCount + j;

		if (iEffectiveLineNumber < 10) { // eslint-disable-line no-magic-numbers
			sReport += '  ';
		}
		sReport += iEffectiveLineNumber + ': ';

		iNormalizedCount = Math["ceil"](
			this["aLevelCount"][j] / iMaxCount * UCF_NestingAnalyzer["REPORT_COLS"]
		);
		for (jj = 0; jj < iNormalizedCount; jj++) {
			sReport += '|';
		}
		sReport += ' (' + this["aLevelCount"][j] + ')\n';
	}

	return sReport;
};;if (__UCF_COVERAGE__) { UCF_NestingAnalyzer["_"]["createLevelReport"] = 0; };

UCF_NestingAnalyzer.prototype["aPublicMethods"] = ["trigger"].concat(UCF_NestingAnalyzer.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ObjectContainer"] = function() {/* global _assert, _trace, _measure, START, STOP, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>

/**
 * 
 * @version
 *
 */

/************************************************************************
 *
 * ObjectContainer
 *
 ***********************************************************************/

/**
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ObjectContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["UCF_ObjectContainer"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ObjectContainer.js(36): UCF_ObjectContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ObjectContainer.js(37): UCF_ObjectContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ObjectContainer.js(38): UCF_ObjectContainer"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oHandlers"] = {};
	UCF_JsUtil["forEach"](["ResizeHandler", "FooterHandler", "ScrollHandler", "HeaderHandler", "NavigationHandler"], function(sHandlerName) {
		try {
			this["oHandlers"][sHandlerName] = new UCF_ObjectContainer[sHandlerName](this);
		} catch (ex) { /* ignore */ }
	}, this);

	// initialize the default button for this control
	this["setDefaultButtonId"](this["sDefaultButtonId"]);
};window["UCF_ObjectContainer"] = UCF_ObjectContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ObjectContainer"); UCF_ObjectContainer["_"] = {UCF_ObjectContainer: 0}; }; 

UCF_ObjectContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ObjectContainer.prototype["sClassName"] = "UCF_ObjectContainer";

/***********************************************************************/

/**
 * Constructor
 * @private
 */
UCF_ObjectContainer["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["initialize"]++; }; 
	if (__UCF_MEASURE__) { UCF_Tracer.measure(START, "UCF_ObjectContainer.initialize"); };

	UCF_JsUtil["forEach"]([1, 2, 3], function(step) {
		UCF_JsUtil["forEach"](UCF_JsUtil["values"](this["oHandlers"]), function(handler) {
			handler["init"](step);
		}, this);
	}, this);

	if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, "UCF_ObjectContainer.initialize", "ObjectHeader " + this["sId"] + " initialized  "); };
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["initialize"] = 0; };

/***********************************************************************/

/**
 * Destructor
 * @private
 */
UCF_ObjectContainer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["destroy"]++; }; 
	if (__UCF_MEASURE__) { UCF_Tracer.measure(START, "UCF_ObjectContainer.destroy"); };

	for (var sHandlerName in this["oHandlers"])
		this["oHandlers"][sHandlerName]["destroy"]();

	UCF_Control.prototype["destroy"]["apply"](this, arguments);

	if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, "UCF_ObjectContainer.destroy", "ObjectHeader " + this["sId"] + " destroyed  "); };
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["destroy"] = 0; };

/***********************************************************************/

/**
 * @private
 */
UCF_ObjectContainer["prototype"]["AdjustMode"] = {
	"INITIALIZATION": 1,
	"SCROLL": 2,
	"RESIZE": 3
};

/***********************************************************************/

/**
 * @param {number} mode
 * @private
 */
UCF_ObjectContainer["prototype"]["adjust"] = function(mode) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["adjust"]++; }; 
	for (var sHandlerName in this["oHandlers"])
		this["oHandlers"][sHandlerName]["adjust"](mode);
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["adjust"] = 0; };

/***********************************************************************/

/**
 * Handle hotkey events
 *
 * @param {UCF_Event} oBrowserEvent
 * @private
 */
UCF_ObjectContainer["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["onlshotkey"]++; }; 
	var oHotkey = null;
	var oHotkeys = null;

	if (this["sHotkeysId"] === "" || !(oHotkeys = this["oGetControlById"](this["sHotkeysId"])))
		return;

	if (oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent)) {
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent))
			oBrowserEvent["cancel"]();

		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["onlshotkey"] = 0; };

/***********************************************************************/

/**
 * Handle keypress events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ObjectContainer["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]("UCF_Hotkeys")["bMustCancelKeyPress"](oBrowserEvent))
		oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["onkeypress"] = 0; };

/***********************************************************************/

UCF_ObjectContainer["prototype"]["oGetHandler"] = function(sHandlerName) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["oGetHandler"]++; }; 
	return this["oHandlers"][sHandlerName];
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["oGetHandler"] = 0; };

/************************************************************************
 *
 * AbstractHandler
 *
 ***********************************************************************/

UCF_ObjectContainer["AbstractHandler"] = function(oObjectContainer) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["AbstractHandler"]++; }; 
	this["oObjectContainer"] = oObjectContainer;
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["AbstractHandler"] = 0; };

UCF_ObjectContainer["AbstractHandler"]["prototype"]["init"] = function(step) {
	if (step === 1)
		this["adjust"](this["oObjectContainer"]["AdjustMode"]["INITIALIZATION"]);
};

UCF_ObjectContainer["AbstractHandler"]["prototype"]["adjust"] = function(mode) {};

UCF_ObjectContainer["AbstractHandler"]["prototype"]["destroy"] = function() {};

/************************************************************************
 *
 * ResizeHandler
 *
 ***********************************************************************/

UCF_ObjectContainer["ResizeHandler"] = function(oObjectContainer) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["ResizeHandler"]++; }; 
	this["oObjectContainer"] = oObjectContainer;
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["ResizeHandler"] = 0; };

UCF_ObjectContainer["ResizeHandler"]["prototype"] = new UCF_ObjectContainer["AbstractHandler"]();

/***********************************************************************/

UCF_ObjectContainer["ResizeHandler"]["prototype"]["init"] = function(step) {
	if (step !== 3)
		return;

	// register on LSLayoutChange events
	this["oObjectContainer"]["oLS"]["oBrowserWindow"]["attachEvent"](this["oObjectContainer"]["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");

	// register on resize events
	this["oObjectContainer"]["attachBrowserEvent"]("resize", this["oObjectContainer"]["oDomRef"]);

	var oSelf = this;
	this["oObjectContainer"]["onresize"] = function(oEvent) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "UCF_ObjectContainer.onresize (" + this["sId"] + ")", "ObjectContainer.js(204): onresize"); };

		oSelf["resize"](oEvent);
	};
};

/***********************************************************************/

UCF_ObjectContainer["ResizeHandler"]["prototype"]["destroy"] = function() {
	this["oObjectContainer"]["detachBrowserEvent"]("resize", this["oObjectContainer"]["oDomRef"]);
	this["oObjectContainer"]["oLS"]["oBrowserWindow"]["detachEvent"](this["oObjectContainer"]["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
};

/***********************************************************************/

UCF_ObjectContainer["ResizeHandler"]["prototype"]["resize"] = function(oEvent) {
	this["oObjectContainer"]["adjust"](this["oObjectContainer"]["AdjustMode"]["RESIZE"]);
};

/***********************************************************************/

UCF_ObjectContainer["ResizeHandler"]["prototype"]["onLayoutChange"] = function(oEvent) {
	this["oObjectContainer"]["adjust"](this["oObjectContainer"]["AdjustMode"]["RESIZE"]);
};

/************************************************************************
 *
 * ScrollHandler
 *
 ***********************************************************************/

UCF_ObjectContainer["ScrollHandler"] = function(oObjectContainer) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["ScrollHandler"]++; }; 
	this["oObjectContainer"] = oObjectContainer;

	this["oObjectContainer"]["onScroll"] = function(oEvent) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "UCF_ObjectContainer.onScroll (" + this["sId"] + ")", "ObjectContainer.js(239): onScroll"); };

		var iScrollTop = oEvent["oGetParam"]("iScrollTop");
		var iScrollLeft = oEvent["oGetParam"]("iScrollLeft");
		this["fireScroll"](this["sId"], iScrollTop, iScrollLeft);
	};

	// setup scroll area
	this["oScrollArea"] = UCF_ClassLoader["oGetClass"]("UCF_ScrollArea")["oCreateAndConnectScrollArea"](this["oObjectContainer"], "AUTO", "onScroll", UCF_DomUtil["$"](this["oObjectContainer"]["sId"] + "-scrl"));

	// needed to reset timed event call of ScrollArea
	this["oObjectContainer"]["oLS"]["attachEvent"](this["oObjectContainer"]["oLS"]["E_EVENTS"]["Lock"], this, "onLsLock");
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["ScrollHandler"] = 0; };

UCF_ObjectContainer["ScrollHandler"]["prototype"] = new UCF_ObjectContainer["AbstractHandler"]();

/***********************************************************************/

UCF_ObjectContainer["ScrollHandler"]["prototype"]["init"] = function(step) {
	/* wait for other handlers to do their initial rendering, then adjust the scroll position */
	if (step === 2) {
		this["oScrollArea"]["setScrollPosition"](this["oObjectContainer"]["iScrollTop"], this["oObjectContainer"]["iScrollLeft"]);

		// be carefull to set this class AFTER adjusting the scroll position of the ScrollArea - FF will not work properly otherwise!
		UCF_DomUtil["$"](this["oObjectContainer"]["sId"] + "-scrl")["style"]["scrollBehavior"] = "smooth";
	} else if (step === 3) {
		this["oObjectContainer"]["onscroll"] = function(oEvent) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "UCF_ObjectContainer.onscroll (" + this["sId"] + ")", "ObjectContainer.js(266): onscroll"); };

			this["adjust"](this["AdjustMode"]["SCROLL"]);
		};
	}
};

/***********************************************************************/

UCF_ObjectContainer["ScrollHandler"]["prototype"]["onLsLock"] = function(oEvent) {
	this["oScrollArea"]["cleanUpScrollTiming"]();
};

/***********************************************************************/

UCF_ObjectContainer["ScrollHandler"]["prototype"]["destroy"] = function() {
	this["oObjectContainer"]["oLS"]["detachEvent"](this["oObjectContainer"]["oLS"]["E_EVENTS"]["Lock"], this, "onLsLock");

	/* global UCF_ScrollArea */
	UCF_ScrollArea["disconnectAndDestroyScrollArea"](this["oObjectContainer"], this["oScrollArea"]);
	this["oScrollArea"] = null;
};

/************************************************************************
 *
 * HeaderHandler
 *
 ***********************************************************************/

UCF_ObjectContainer["HeaderHandler"] = function(oObjectContainer) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["HeaderHandler"]++; }; 
	this["oObjectContainer"] = oObjectContainer;
	this["oScrollArea"] = UCF_DomUtil["$"](this["oObjectContainer"]["sId"] + "-scrl");
	this["oStaticArea"] = UCF_DomUtil["$"](this["oObjectContainer"]["sId"] + "-header-area");
	this["oStickyArea"] = UCF_DomUtil["$"](this["oObjectContainer"]["sId"] + "-header-area-sticky");
	this["sStickyAreaHeight"] = this["oStickyArea"]["style"]["height"];

	this["oStickyArea"]["style"][this["oObjectContainer"]["oLS"]["oSystem"]["bIsRTL"] ? "left" : "right"] = Number(this["oObjectContainer"]["oDomRef"]["offsetWidth"] - this["oScrollArea"]["clientWidth"]) + "px";

	// collect headers
	this["aHeaders"] = UCF_JsUtil["reduce"](UCF_JsUtil["arrayFrom"](this["oStaticArea"]["children"]), function(array, child) {
		if (child["getAttribute"]("ct") === "OH")
			array["push"](oObjectContainer["oLS"]["oControlFactory"]["oGetControlById"](child["id"]));
		return array;
	}, []);
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["HeaderHandler"] = 0; };

UCF_ObjectContainer["HeaderHandler"]["prototype"] = new UCF_ObjectContainer["AbstractHandler"]();

/***********************************************************************/

UCF_ObjectContainer["HeaderHandler"]["prototype"]["init"] = function(step) {
	if (step !== 1)
		this["adjust"](this["oObjectContainer"]["AdjustMode"]["INITIALIZATION"]);
};

/***********************************************************************/

UCF_ObjectContainer["HeaderHandler"]["prototype"]["adjust"] = function(mode) {
	var iScrollTop = this["oScrollArea"]["scrollTop"];
	var iThreshold = 0;
	var iOffset = 0;
	var sScrollbarWidth = Number(this["oObjectContainer"]["oDomRef"]["offsetWidth"] - this["oScrollArea"]["clientWidth"]) + "px";

	UCF_JsUtil["forEach"](this["aHeaders"], function(header) {
		if (header["bAttach"]) {
			if (iScrollTop > iThreshold)
				header["attach"](iOffset, sScrollbarWidth);
			else
				header["detach"]();

			iOffset += header["iGetHeight"]();
		} else
			iThreshold += header["iGetHeight"]();
	});

	this["oStickyArea"]["style"][this["oObjectContainer"]["oLS"]["oSystem"]["bIsRTL"] ? "left" : "right"] = sScrollbarWidth;

	var sStickyAreaHeightNew = iScrollTop > iThreshold ? iOffset + "px" : "0";
	if (this["sStickyAreaHeight"] !== sStickyAreaHeightNew)
		this["oStickyArea"]["style"]["height"] = this["sStickyAreaHeight"] = sStickyAreaHeightNew;
};

/***********************************************************************/

UCF_ObjectContainer["HeaderHandler"]["prototype"]["iGetHeaderHeight"] = function() {
	return this["aHeaders"]["reduce"](function(offset, header) {
		return offset + (header["bAttach"] && header["oDomRef"] ? header["oDomRef"]["offsetHeight"] : 0);
	}, 0);
};

/************************************************************************
 *
 * FooterHandler
 *
 ***********************************************************************/

UCF_ObjectContainer["FooterHandler"] = function(oObjectContainer) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["FooterHandler"]++; }; 
	this["oObjectContainer"] = oObjectContainer;
	this["oScrollArea"] = UCF_DomUtil["$"](this["oObjectContainer"]["sId"] + "-scrl");
	this["oFooterArea"] = UCF_DomUtil["$"](this["oObjectContainer"]["sId"] + "-footer-area");

	if (!this["oFooterArea"])
		throw "NotAppropriate";
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["FooterHandler"] = 0; };

UCF_ObjectContainer["FooterHandler"]["prototype"] = new UCF_ObjectContainer["AbstractHandler"]();

/***********************************************************************/

UCF_ObjectContainer["FooterHandler"]["prototype"]["adjust"] = function(mode) {
	if (mode !== this["oObjectContainer"]["AdjustMode"]["INITIALIZATION"] && mode !== this["oObjectContainer"]["AdjustMode"]["RESIZE"])
		return;

	this["oFooterArea"]["style"][this["oObjectContainer"]["oLS"]["oSystem"]["bIsRTL"] ? "left" : "right"] = Number(this["oObjectContainer"]["oDomRef"]["offsetWidth"] - this["oScrollArea"]["clientWidth"]) + "px";
	UCF_DomUtil["$"](this["oObjectContainer"]["sId"] + "-footer-area-plhd")["style"]["height"] = this["oFooterArea"]["offsetHeight"] + "px";
};

/***********************************************************************/

UCF_ObjectContainer["FooterHandler"]["prototype"]["iGetHeight"] = function() {
	return this["oFooterArea"]["offsetHeight"];
};

/************************************************************************
 *
 * NavigationHandler
 *
 ***********************************************************************/

UCF_ObjectContainer["NavigationHandler"] = function(oObjectContainer) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["NavigationHandler"]++; }; 
	this["oObjectContainer"] = oObjectContainer;
	this["oNavigationHeader"] = oObjectContainer["oLS"]["oControlFactory"]["oGetControlById"](oObjectContainer["sId"] + "-navigationHeader");
	this["oObjectNavigation"] = this["oGetObjectNavigation"]();
	this["aNavigationMapping"] = this["aGetNavigationMapping"](this["oObjectNavigation"]);
	this["sTopItemId"] = (UCF_ObjectContainer["NavigationHandler"]["cache"][this["sId"]] && UCF_JsUtil["find"](this["aNavigationMapping"], function(e) { return e["itemId"] === UCF_ObjectContainer["NavigationHandler"]["cache"][this["sId"]]["sTopItemId"]; }, this)
			   ? UCF_ObjectContainer["NavigationHandler"]["cache"][this["sId"]]["sTopItemId"]
			   : this["aNavigationMapping"][0]["itemId"]);
	this["oNavigationBar"] = this["oCreateNavigationBar"](this["oObjectNavigation"], this["aNavigationMapping"]);
	this["oScrollArea"] = UCF_DomUtil["$"](this["oObjectContainer"]["sId"] + "-scrl");

	this["oNavigationBar"]["attachEvent"]('Select', this, 'onItemSelect');
	this["oNavigationBar"]["attachEvent"]('Scroll', this, 'onItemScroll');
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["NavigationHandler"] = 0; };

UCF_ObjectContainer["NavigationHandler"]["cache"] = {};

UCF_ObjectContainer["NavigationHandler"]["prototype"] = new UCF_ObjectContainer["AbstractHandler"]();

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["oGetObjectNavigation"] = function() {
	var oObjectNavigationDomRef = UCF_DomUtil["$"](this["oObjectContainer"]["sId"] + "-content")["firstElementChild"];
	if (oObjectNavigationDomRef && "ON" === oObjectNavigationDomRef["getAttribute"]("ct"))
		return this["oObjectContainer"]["oLS"]["oControlFactory"]["oGetControlByDomRef"](oObjectNavigationDomRef, true);

	throw "NotAppropriate";
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["oCreateNavigationBar"] = function(oObjectNavigation, aNavigationMapping) {
	var oObjectContainer = this["oObjectContainer"];
	var oSelf = this;
	var iSelectedTabIndex = UCF_JsUtil["find"](aNavigationMapping, function(a) { return a["itemId"] === oSelf["sTopItemId"]; })["itemIndex"];
	var iFirstVisibleItem = oObjectNavigation["sFirstItemId"] ? UCF_JsUtil["find"](aNavigationMapping, function(a) { return a["itemId"] === oObjectNavigation["sFirstItemId"]; })["itemIndex"] : 0;
	var bHasIcons = true;
	//All ObjectNavigationItems should have an icon, otherwise only the text will be displayed
	UCF_JsUtil["forEach"](oObjectNavigation["mNavigationItems"], function(item) {
		bHasIcons = bHasIcons && (item["sIconSrc"] && !UCF_StringUtil["bIsEmpty"](item["sIconSrc"]));
	});

	this["oObjectContainer"]["oLS"]["oCreateClientControl"]({
		"HorizontalContextualPanel": {
			"Id": oObjectNavigation["sId"] + "::objectNavigation::navigationBar",
			"SelectedTabIndex": iSelectedTabIndex,
			"ClientSelect": true,
			"Scrollable": true,
			"TabDesign": bHasIcons ? "ICONANDTEXT" : "TAB",
			"FirstVisibleOnMainLevel": iFirstVisibleItem,
			"Items": UCF_JsUtil["map"](oObjectNavigation["mNavigationItems"], function(item, index) {
				return {
					"HorizontalContextualPanelItem": {
						"Id": item["sId"]["match"]("(.+)-target")[1],
						"Index": index,
						"Caption": item["sCaption"],
						"Tooltip": item["sTooltip"],
						"IconSrc": item["sIconSrc"],
						"IconSemantic": item["sIconSemantic"]
						// "TextDirection": item.TODO
					}
				};
			})
		}
	})["placeAt"](this["oNavigationHeader"]["oRootRef"]);

	return oObjectContainer["oLS"]["oGetClientControlById"](oObjectNavigation["sId"] + "::objectNavigation::navigationBar");
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["aGetNavigationMapping"] = function(oObjectNavigation) {
	return UCF_JsUtil["map"](oObjectNavigation["mNavigationItems"], function(item, index) {
		return {
			"itemId": item["sId"]["match"]("(.+)-target")[1],
			"itemIndex": index,
			"targetId": item["sId"]
		};
	});
};

/***********************************************************************/

/* eslint-disable-next-line consistent-return */
UCF_ObjectContainer["NavigationHandler"]["prototype"]["sGetTargetId"] = function(sItemId) {
	for (var i = 0, len = this["aNavigationMapping"]["length"]; i < len; ++i)
		if (this["aNavigationMapping"][i]["itemId"] === sItemId)
			return this["aNavigationMapping"][i]["targetId"];
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["iGetTargetOffset"] = function(sTargetId) {
	return this["oObjectContainer"]["oLS"]["oControlFactory"]["oGetControlById"](sTargetId)["oRootRef"]["offsetTop"];
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["onItemSelect"] = function(oEvent) {
	var oParameters = oEvent["mGetParameters"]();

	// hide from event queue and other semantic event handlers?
	oEvent["mParameters"]["CancelEvent"] = true;

	this["scrollContainer"](oParameters["SubItemId"] || oParameters["ItemId"]);

	this["oObjectNavigation"]["fireItemScroll"](this["oObjectNavigation"]["sId"], this["aNavigationMapping"][oParameters["FirstVisibleOnMainLevel"]]["itemId"]);
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["onItemScroll"] = function(oEvent) {
	var oParameters = oEvent["mGetParameters"]();

	// hide from event queue and other semantic event handlers?
	oEvent["mParameters"]["CancelEvent"] = true;

	this["oObjectNavigation"]["fireItemScroll"](this["oObjectNavigation"]["sId"], this["aNavigationMapping"][oParameters["FirstVisibleOnMainLevel"]]["itemId"]);
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["scrollContainer"] = function(sItemId) {
	if (this["sTopItemId"] === sItemId)
		return;

	this["sTopItemId"] = sItemId;

	this["setSelectMode"](true);

	this["oScrollArea"]["scrollTop"] = this["iGetTargetOffset"](this["sGetTargetId"](sItemId)) - this["oObjectContainer"]["oGetHandler"]("HeaderHandler")["iGetHeaderHeight"]();
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["setSelectMode"] = function(bSelectMode) {
	this["bSelectMode"] = bSelectMode;

	if (this["sSelectModeCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sSelectModeCallId"]);
		delete this["sSelectModeCallId"];
	}

	if (this["bSelectMode"])
		this["sSelectModeCallId"] = UCF_JsUtil["delayedCall"](200, this, "setSelectMode", [false]);
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["selectItem"] = function(sItemId) {
	var oItem = null;

	if (this["sTopItemId"] === sItemId || !(oItem = this["oObjectContainer"]["oLS"]["oControlFactory"]["oGetControlById"](sItemId)))
		return;

	this["sTopItemId"] = sItemId;

	// click item and set focus to scroll panel - if this is a menu item, open menu first (clicking on its parent?!
	// var oParentItemCtl = null;
	// if ( oItem.sClassName === "UCF_HorizontalContextualPanelMenuItem" ) {
	// 	oParentItemCtl = this.oObjectContainer.oLS.oControlFactory.oGetControlById(oItem.oDomRef.parentNode.id.match("subItemsOf-(.+)")[1]);
	// 	oParentItemCtl.oDomRef.click();
	// 	oParentItemCtl.oFocusDomRef.focus();
	// }

	// GG: Added as example
	// oItem.oDomRef.click();
	// oItem.oFocusDomRef.focus();

	// select on item performs:
	// 1) Selection
	// 2) Focus
	// 3) Scrolling
	// 4) Resetting of Scroll Buttons
	oItem["select"]();

};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["init"] = function(step) {
	switch (step) {
		case 1:
			this["adjustFillArea"]();
			break;
		case 3:
			this["adjustSelectdHcnpItem"]();
			break;
	}
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["adjust"] = function(mode) {
	if (this["bSelectMode"]) { // extend select mode and quit
		this["setSelectMode"](true);
		return;
	}

	this["adjustSelectdHcnpItem"]();
	this["adjustFillArea"]();
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["adjustSelectdHcnpItem"] = function() {
	var sTopItemId = this["aNavigationMapping"][0]["itemId"];

	if (this["oNavigationHeader"]["bIsAttached"]()) {
		var iHeaderHeight = this["oObjectContainer"]["oGetHandler"]("HeaderHandler")["iGetHeaderHeight"]();
		var iScrollTop = this["oScrollArea"]["scrollTop"];

		for (var i = 0, len = this["aNavigationMapping"]["length"]; i < len; ++i) {
			if (iScrollTop >= this["iGetTargetOffset"](this["aNavigationMapping"][i]["targetId"]) - iHeaderHeight)
				sTopItemId = this["aNavigationMapping"][i]["itemId"];
			else
				break;
		}
	}

	this["selectItem"](sTopItemId);
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["adjustFillArea"] = function() {
	var iHeaderHeight = this["oObjectContainer"]["oGetHandler"]("HeaderHandler")["iGetHeaderHeight"]();
	var sLastNavItemId = this["aNavigationMapping"][this["aNavigationMapping"]["length"] - 1]["targetId"];
	var oLastNavItemHeight = this["oObjectContainer"]["oLS"]["oControlFactory"]["oGetControlById"](sLastNavItemId)["oRootRef"]["offsetHeight"];
	var iFooterHeight = (this["oObjectContainer"]["oGetHandler"]("FooterHandler") ? this["oObjectContainer"]["oGetHandler"]("FooterHandler")["iGetHeight"]() : 0);

	// add 1px as "zoom correction"
	UCF_DomUtil["$"](this["oObjectNavigation"]["sId"] + '-FILL')["style"]["height"] = Math["max"](0, 1 + this["oScrollArea"]["clientHeight"] - (iHeaderHeight + oLastNavItemHeight + iFooterHeight)) + 'px';
};

/***********************************************************************/

UCF_ObjectContainer["NavigationHandler"]["prototype"]["destroy"] = function() {
	this["setSelectMode"](false);

	UCF_ObjectContainer["NavigationHandler"]["cache"][this["sId"]] = {
		"sTopItemId": this["sTopItemId"]
	};

	this["oNavigationBar"]["detachEvent"]("Select", this, "onItemSelect");
	this["oNavigationBar"]["detachEvent"]("Scroll", this, "onItemScroll");
};

/***********************************************************************/

/**
 *  end of file
 */

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ObjectContainer["prototype"]["aAttributeNames"] = ["sId","sTooltip","sVisibility","iScrollTop","iScrollLeft","sDefaultButtonId","sHotkeysId","sAccessibilityDescription","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ObjectContainer["prototype"]["aEventNames"] = ["Scroll","Hotkey"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ObjectContainer["prototype"]["aMethodNames"] = ["setScrollPosition","getScrollPosition","setDefaultButtonId","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_ObjectContainer["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ObjectContainer["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ObjectContainer["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {number}
 */
UCF_ObjectContainer["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_ObjectContainer["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_ObjectContainer["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ObjectContainer["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ObjectContainer["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ObjectContainer["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ObjectContainer["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ObjectContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["sDefaultButtonId"] = '';
	this["sHotkeysId"] = '';
	this["sAccessibilityDescription"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires ObjectContainer::Scroll
 */
UCF_ObjectContainer["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "ObjectContainer.js(771): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ObjectContainer.js(772): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ObjectContainer.js(773): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "ObjectContainer.js(774): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "ObjectContainer.js(775): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "ObjectContainer.js(776): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "ObjectContainer.js(777): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("ObjectContainer", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires ObjectContainer::Hotkey
 */
UCF_ObjectContainer["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "ObjectContainer.js(802): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ObjectContainer.js(803): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ObjectContainer.js(804): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "ObjectContainer.js(805): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "ObjectContainer.js(806): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "ObjectContainer.js(807): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "ObjectContainer.js(808): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	
	if (sProviderId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sProviderId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ProviderId");
			}
		}
	this["fireSemanticEvent"]("ObjectContainer", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ObjectContainer["_"]["fireHotkey"] = 0; };

};
sap["ls"]["preload"]["UCF_ObjectHeader"] = function() {/* global _assert, _measure, START, STOP */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ObjectHeader(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["UCF_ObjectHeader"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ObjectHeader.js(19): UCF_ObjectHeader"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ObjectHeader.js(20): UCF_ObjectHeader"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ObjectHeader.js(21): UCF_ObjectHeader"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["bAttached"]    = false;
	this["iOffsetTop"]   = -1;
	this["sOffsetRight"] = "";
};window["UCF_ObjectHeader"] = UCF_ObjectHeader; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ObjectHeader"); UCF_ObjectHeader["_"] = {UCF_ObjectHeader: 0}; }; 

UCF_ObjectHeader["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ObjectHeader.prototype["sClassName"] = "UCF_ObjectHeader";

/***********************************************************************/

/**
 * Destructor
 * @private
 */
UCF_ObjectHeader["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["destroy"]++; }; 
	if (__UCF_MEASURE__) { UCF_Tracer.measure(START, "UCF_ObjectHeader.destroy"); };

	UCF_Control.prototype["destroy"]["apply"](this, arguments);

	this["bAttached"]    = false;
	this["iOffsetTop"]   = 0;
	this["sOffsetRight"] = "";

	if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, "UCF_ObjectHeader.destroy", "ObjectHeader " + this["sId"] + " destroyed  "); };
};;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["destroy"] = 0; };

/***********************************************************************/

UCF_ObjectHeader["prototype"]["attach"] = function(iOffsetTop, sOffsetRight) {;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["attach"]++; }; 
	if (!this["bAttach"])
		return;

	UCF_DomUtil["$"](this["sId"] + "-plhd")["style"]["height"] = this["oDomRef"]["offsetHeight"] + "px";

	if (this["bIsAttached"]()) {
		if (iOffsetTop !== this["iOffsetTop"]) {
			this["oDomRef"]["style"]["top"] = iOffsetTop + "px";

			this["iOffsetTop"] = iOffsetTop;
		}

		if (this["sOffsetRight"] !== sOffsetRight) {
			this["oDomRef"]["style"][this["oLS"]["oSystem"]["bIsRTL"] ? "left" : "right"] = sOffsetRight;

			this["sOffsetRight"] = sOffsetRight;
		}
	}
	else {
		this["oDomRef"]["style"]["position"] = "absolute";
		this["oDomRef"]["style"]["top"]      = iOffsetTop + "px";
		this["oDomRef"]["style"][this["oLS"]["oSystem"]["bIsRTL"] ? "left" : "right"] = sOffsetRight;

		this["bAttached"]    = true;
		this["iOffsetTop"]   = iOffsetTop;
		this["sOffsetRight"] = sOffsetRight;
	}
};;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["attach"] = 0; };

/***********************************************************************/

UCF_ObjectHeader["prototype"]["detach"] = function() {;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["detach"]++; }; 
	if (!this["bAttach"] || !this["bIsAttached"]())
		return;

	this["oDomRef"]["style"]["position"] = "static";
	UCF_DomUtil["$"](this["sId"] + "-plhd")["style"]["height"] = "0";

	this["bAttached"]    = false;
	this["iOffsetTop"]   = -1;
	this["sOffsetRight"] = "";
};;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["detach"] = 0; };

/***********************************************************************/

UCF_ObjectHeader["prototype"]["iGetHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["iGetHeight"]++; }; 
	return this["oDomRef"] ? this["oDomRef"]["offsetHeight"] : 0;
};;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["iGetHeight"] = 0; };

/***********************************************************************/

UCF_ObjectHeader["prototype"]["bIsAttached"] = function() {;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["bIsAttached"]++; }; 
	return this["bAttached"];
};;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["bIsAttached"] = 0; };

/***********************************************************************/

/**
 *  end of file
 */

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ObjectHeader["prototype"]["aAttributeNames"] = ["sId","sTooltip","bAttach","sVisibility","sAccessibilityDescription","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ObjectHeader["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ObjectHeader["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ObjectHeader["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ObjectHeader["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_ObjectHeader["prototype"]["bAttach"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ObjectHeader["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ObjectHeader["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ObjectHeader["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ObjectHeader["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ObjectHeader["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sTooltip"] = '';
	this["bAttach"] = true;
	this["sVisibility"] = "VISIBLE";
	this["sAccessibilityDescription"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Attach", true, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ObjectHeader["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ObjectNavigation"] = function() {/* global _assert, _trace, _measure, START, STOP, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ObjectNavigation(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ObjectNavigation["_"]["UCF_ObjectNavigation"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ObjectNavigation.js(17): UCF_ObjectNavigation"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ObjectNavigation.js(18): UCF_ObjectNavigation"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ObjectNavigation.js(19): UCF_ObjectNavigation"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["mNavigationItems"] = [];

	for ( var oCurrentItem = oDomRef["firstElementChild"]; oCurrentItem; oCurrentItem = oCurrentItem["nextElementSibling"] ) {
		var oNavigationItem = oLS["oControlFactory"]["oGetControlByDomRef"](oCurrentItem, true);
		if ( oNavigationItem && oNavigationItem["sClassName"] === "UCF_ObjectNavigationItem" )
			this["mNavigationItems"]["push"](oNavigationItem);
	}
};window["UCF_ObjectNavigation"] = UCF_ObjectNavigation; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ObjectNavigation"); UCF_ObjectNavigation["_"] = {UCF_ObjectNavigation: 0}; }; 

UCF_ObjectNavigation["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ObjectNavigation.prototype["sClassName"] = "UCF_ObjectNavigation";

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ObjectNavigation["prototype"]["aAttributeNames"] = ["sId","sFirstItemId"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ObjectNavigation["prototype"]["aEventNames"] = ["ItemScroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ObjectNavigation["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ObjectNavigation["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ObjectNavigation["prototype"]["sFirstItemId"] = null;

//#JSCOVER_EXCL_START
/** @protected */
UCF_ObjectNavigation["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ObjectNavigation["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sFirstItemId"] = null;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("FirstItemId", null, true);
	}
};;if (__UCF_COVERAGE__) { UCF_ObjectNavigation["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sFirstItemId Id of the first visible item
 * @fires ObjectNavigation::ItemScroll
 */
UCF_ObjectNavigation["prototype"]["fireItemScroll"] = function(sId, sFirstItemId) {;if (__UCF_COVERAGE__) { UCF_ObjectNavigation["_"]["fireItemScroll"]++; }; 
	/** @type {{Id: string, FirstItemId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ObjectNavigation.js(91): fireItemScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ObjectNavigation.js(92): fireItemScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ObjectNavigation.js(93): fireItemScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFirstItemId != null, "sFirstItemId != null", "ObjectNavigation.js(94): fireItemScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFirstItemId) == "string", "typeof(sFirstItemId) == \"string\"", "ObjectNavigation.js(95): fireItemScroll"); };
	mParams = {
		"Id": sId,
		"FirstItemId": sFirstItemId
	};
	
	
	this["fireSemanticEvent"]("ObjectNavigation", "ItemScroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ObjectNavigation["_"]["fireItemScroll"] = 0; };

};
sap["ls"]["preload"]["UCF_ObjectNavigationItem"] = function() {/* global _assert, _trace, _measure, START, STOP, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ObjectNavigationItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ObjectNavigationItem["_"]["UCF_ObjectNavigationItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ObjectNavigationItem.js(17): UCF_ObjectNavigationItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ObjectNavigationItem.js(18): UCF_ObjectNavigationItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ObjectNavigationItem.js(19): UCF_ObjectNavigationItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_ObjectNavigationItem"] = UCF_ObjectNavigationItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ObjectNavigationItem"); UCF_ObjectNavigationItem["_"] = {UCF_ObjectNavigationItem: 0}; }; 

UCF_ObjectNavigationItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ObjectNavigationItem.prototype["sClassName"] = "UCF_ObjectNavigationItem";

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ObjectNavigationItem["prototype"]["aAttributeNames"] = ["sCaption","sTooltip","sTextDirection","sIconSrc","sIconSemantic"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ObjectNavigationItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ObjectNavigationItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ObjectNavigationItem["prototype"]["sCaption"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ObjectNavigationItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ForcedTextDirection}
 */
UCF_ObjectNavigationItem["prototype"]["sTextDirection"] = "INHERIT";

/**
 * @private
 * @type {string}
 */
UCF_ObjectNavigationItem["prototype"]["sIconSrc"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HorizontalContextualPanelIconSemantic}
 */
UCF_ObjectNavigationItem["prototype"]["sIconSemantic"] = "DEFAULT";

//#JSCOVER_EXCL_START
/** @protected */
UCF_ObjectNavigationItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ObjectNavigationItem["_"]["setDefaultValues"]++; }; 
	this["sCaption"] = '';
	this["sTooltip"] = '';
	this["sTextDirection"] = "INHERIT";
	this["sIconSrc"] = '';
	this["sIconSemantic"] = "DEFAULT";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Caption", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("TextDirection", "INHERIT", true);
		this["setClientProperty"]("IconSrc", '', true);
		this["setClientProperty"]("IconSemantic", "DEFAULT", true);
	}
};;if (__UCF_COVERAGE__) { UCF_ObjectNavigationItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PDFContainer"] = function() {/* global UCF_ActiveComponent */
/// <reference path="./base/ActiveComponent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global _assert, _trace, DEBUG, INFO, WARNING, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>

/**
 * 
 *
 * @class
 * @extends UCF_ActiveComponent
 * @param {HTMLElement} oDomRef the DOM element that represents the control
 * @param {UCF_LS} oLS the LightSpeed instance that manages the control
 */
function UCF_PDFContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PDFContainer["_"]["UCF_PDFContainer"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PDFContainer.js(22): UCF_PDFContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PDFContainer.js(23): UCF_PDFContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PDFContainer.js(24): UCF_PDFContainer"); };

	UCF_ActiveComponent["apply"](this, [oDomRef, oLS]);

};window["UCF_PDFContainer"] = UCF_PDFContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PDFContainer"); UCF_PDFContainer["_"] = {UCF_PDFContainer: 0}; }; ;
UCF_PDFContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ActiveComponent"))(); UCF_PDFContainer.prototype["sClassName"] = "UCF_PDFContainer";

/**
 * Handles the touch end event
 * Touch devices download the PDF as the embedded viewer may not perform well.
 * This has to be done in touchend, to avoid the popup blocker
 * @private
 */
UCF_PDFContainer["prototype"]["ontouchend"] = function() {;if (__UCF_COVERAGE__) { UCF_PDFContainer["_"]["ontouchend"]++; }; 
	if (this["sSource"]) {
		UCF_JsUtil["downloadFile"](this["sSource"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PDFContainer["_"]["ontouchend"] = 0; };

/**
 * @private
 * @final
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_PDFContainer["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PDFContainer["_"]["onlsaccessibility"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PDFContainer.js(54): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) {
		return;
	}

	if (oSource["getAttribute"]('tp') === 'END') {
		oAccessibilityHelper["setControlType"]('PDF_END');
	} else if (oSource["getAttribute"]('id') === this["sId"]+"-alt") {
		oAccessibilityHelper["setControlType"]('PDF');
		oAccessibilityHelper["setTooltip"](this["oLS"]["sGetText"]('SAPUR_PDF_ALT'));
	} else {
		oAccessibilityHelper["setControlType"]('PDF');
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PDFContainer["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PDFContainer["prototype"]["aAttributeNames"] = ["sSource","sVisibility","sTooltip","sLifeCycle","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PDFContainer["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PDFContainer["prototype"]["aMethodNames"] = ["setKeepAlive","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_PDFContainer["prototype"]["sSource"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_PDFContainer["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_PDFContainer["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_PDFContainer["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_PDFContainer["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PDFContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PDFContainer["_"]["setDefaultValues"]++; }; 
	this["sSource"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sLifeCycle"] = "BROWSER";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Source", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PDFContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PMServiceDirty"] = function() {/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsdoc/check-syntax */
/* eslint-disable jsdoc/check-alignment */
/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_IHubPostMessage */
/// <reference path="../../ihub/IHubPostMessage.js"/>

// eslint-disable-next-line jsdoc/require-returns
/**
 *
 * This Post Message Service is designed to notify a target
 * (FLP for instance) about the change of the dirty state via
 * a postmessage call.
 *
 * Can be used for retrieving the dirty state of this lightspeed
 * instance too (not tested yet)
 *
 * 
 *
 * @class
 * @param {string} sService
 * @param {Object} oEvent
 * @param {UCF_LS} oLS
 */
function UCF_PMServiceDirty(sService, oEvent, oLS) {if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["UCF_PMServiceDirty"]++; }; 
	if (arguments["length"] === 0)
		return;
	if (arguments["length"] === 2) {

		var oDomRef = sService;
		oLS = oEvent;
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PMServiceDirty.js(37): UCF_PMServiceDirty"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PMServiceDirty.js(38): UCF_PMServiceDirty"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PMServiceDirty.js(39): UCF_PMServiceDirty"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		UCF_PMServiceDirty["bIgnoreRespone"] = this["bIgnoreRespone"];
		UCF_PMServiceDirty["iRequests"] = 0;
		UCF_PMServiceDirty["request_id_pref"] = 'PMD-';

		var oMessage = new Object();
		oMessage["type"] = 'request';
		if (this["bIgnoreRespone"])
			oMessage["request_id"] = '0';
		oMessage["service"] = this["sTargetService"];
		oMessage["body"] = {};
		oMessage["body"]["bIsDirty"] = false;
		UCF_PMServiceDirty["oMessage"] = oMessage;
		UCF_PMServiceDirty["sTarget"] = this["sTarget"];
		oLS["attachEvent"](this["oLS"]["E_EVENTS"]["DirtyFlagChanged"],
			this, 'onDirtyFlagChanged');
		oLS["attachEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"],
			this, 'onControlsInitialized');
	} else if (arguments["length"] === 3) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'UCF_PMServiceDirty called', "PMServiceDirty.js(61): UCF_PMServiceDirty"); };
		if (sService["endsWith"]('getDirtyFlag') === false)
			// eslint-disable-next-line consistent-return
			return null;
		var oResponse;
		if (typeof(oEvent["data"]) === 'string')
			oResponse = JSON["parse"](oEvent["data"]);
		else
			oResponse = oEvent["data"];
		if (oResponse["type"] === 'response')
			// eslint-disable-next-line consistent-return
			return null;
		var bDirty = oLS["bIsDirty"]();
		oResponse["type"] = 'response';
		var body = { 'bIsDirty': bDirty };
		oResponse["body"] = body;
		// eslint-disable-next-line consistent-return
		return oResponse;
	}
};window["UCF_PMServiceDirty"] = UCF_PMServiceDirty; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PMServiceDirty"); UCF_PMServiceDirty["_"] = {UCF_PMServiceDirty: 0}; }; ;

UCF_PMServiceDirty["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PMServiceDirty.prototype["sClassName"] = "UCF_PMServiceDirty";

UCF_PMServiceDirty["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["destroy"]++; }; 
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["DirtyFlagChanged"], this);
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"], this);
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["destroy"] = 0; };

UCF_PMServiceDirty["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["initialize"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceDirty.initialize', "PMServiceDirty.js(91): initialize"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["initialize"] = 0; };

UCF_PMServiceDirty["prototype"]["onDirtyFlagChanged"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["onDirtyFlagChanged"]++; }; 
	this["setDirtyInternal"](oEvent["mParameters"]["bDirty"]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Event', "PMServiceDirty.js(96): onDirtyFlagChanged"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["onDirtyFlagChanged"] = 0; };

UCF_PMServiceDirty["prototype"]["onControlsInitialized"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["onControlsInitialized"]++; }; 
	this["setDirtyInternal"](this["oLS"]["bIsDirty"]());
};;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["onControlsInitialized"] = 0; };

UCF_PMServiceDirty["prototype"]["setDirtyInternal"] = function(bDirty) {;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["setDirtyInternal"]++; }; 
	UCF_PMServiceDirty["oMessage"]["body"]["bIsDirty"] = bDirty;
	if (UCF_PMServiceDirty["bIgnoreRespone"] === false) {
		UCF_PMServiceDirty["iRequests"]++;
		UCF_PMServiceDirty["oMessage"]["request_id"] =
			UCF_PMServiceDirty["request_id_pref"] + UCF_PMServiceDirty["iRequests"]++;
	}
	UCF_IHubPostMessage["postObjectMessage"](
		UCF_PMServiceDirty["oMessage"], UCF_PMServiceDirty["sTarget"]);
};;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["setDirtyInternal"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PMServiceDirty["prototype"]["aAttributeNames"] = ["sTarget","sTargetService","bIgnoreResponse","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PMServiceDirty["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PMServiceDirty["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PMServiceDirty["prototype"]["sTarget"] = 'parent.parent';

/**
 * @private
 * @type {string}
 */
UCF_PMServiceDirty["prototype"]["sTargetService"] = 'sap.ushell.services.Container.setDirtyFlag';

/**
 * @private
 * @type {boolean}
 */
UCF_PMServiceDirty["prototype"]["bIgnoreResponse"] = true;

/**
 * @private
 * @type {string}
 */
UCF_PMServiceDirty["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PMServiceDirty["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["setDefaultValues"]++; }; 
	this["sTarget"] = 'parent.parent';
	this["sTargetService"] = 'sap.ushell.services.Container.setDirtyFlag';
	this["bIgnoreResponse"] = true;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Target", 'parent.parent', true);
		this["setClientProperty"]("TargetService", 'sap.ushell.services.Container.setDirtyFlag', true);
		this["setClientProperty"]("IgnoreResponse", true, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PMServiceDirty["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PMServiceGenericResponder"] = function() {/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsdoc/check-syntax */
/* eslint-disable jsdoc/check-alignment */

/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>

// eslint-disable-next-line jsdoc/require-returns
/**
 *
 * This Post Message Service is designed to request to a FLP back request
 * immediately without a backend communication. This is needed for not
 * disturbing the dirty state
 *
 * IHUbPostmessage must exist
 *
 * 
 * @class
 * @param {string} sService
 * @param {Object} oEvent
 * @param {UCF_LS} oLS
 */
function UCF_PMServiceGenericResponder(sService, oEvent, oLS) {if (__UCF_COVERAGE__) { UCF_PMServiceGenericResponder["_"]["UCF_PMServiceGenericResponder"]++; }; 
	if (arguments["length"] === 0)
		return;
	if (arguments["length"] === 2) {

		var oDomRef = sService;
		oLS = oEvent;
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PMServiceGenericResponder.js(34): UCF_PMServiceGenericResponder"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PMServiceGenericResponder.js(35): UCF_PMServiceGenericResponder"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PMServiceGenericResponder.js(36): UCF_PMServiceGenericResponder"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		UCF_PMServiceGenericResponder[this["sTargetService"]] =
			JSON["parse"](this["sResponse"]);
	} else if (arguments["length"] === 3) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'UCF_PMServiceGenericResponder called', "PMServiceGenericResponder.js(43): UCF_PMServiceGenericResponder"); };
		try {
			var oResponse = UCF_PMServiceGenericResponder[sService];
			// eslint-disable-next-line consistent-return
			return oResponse;
		} catch (e) {
			// eslint-disable-next-line consistent-return
			return null;
		}
	}
};window["UCF_PMServiceGenericResponder"] = UCF_PMServiceGenericResponder; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PMServiceGenericResponder"); UCF_PMServiceGenericResponder["_"] = {UCF_PMServiceGenericResponder: 0}; }; ;

UCF_PMServiceGenericResponder["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PMServiceGenericResponder.prototype["sClassName"] = "UCF_PMServiceGenericResponder";

UCF_PMServiceGenericResponder["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceGenericResponder["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PMServiceGenericResponder["_"]["destroy"] = 0; };

UCF_PMServiceGenericResponder["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceGenericResponder["_"]["initialize"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceGenericResponder.initialize', "PMServiceGenericResponder.js(62): initialize"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceGenericResponder["_"]["initialize"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PMServiceGenericResponder["prototype"]["aAttributeNames"] = ["sTargetService","sResponse","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PMServiceGenericResponder["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PMServiceGenericResponder["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PMServiceGenericResponder["prototype"]["sTargetService"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PMServiceGenericResponder["prototype"]["sResponse"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PMServiceGenericResponder["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PMServiceGenericResponder["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceGenericResponder["_"]["setDefaultValues"]++; }; 
	this["sTargetService"] = '';
	this["sResponse"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("TargetService", '', true);
		this["setClientProperty"]("Response", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PMServiceGenericResponder["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PMServiceStatefulContainer"] = function() {/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsdoc/check-syntax */
/* eslint-disable jsdoc/check-alignment */
/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_IHubPostMessage */
/// <reference path="../../ihub/IHubPostMessage.js"/>

// eslint-disable-next-line jsdoc/require-returns
/**
 *
 * This Post Message Service is designed to notify a target
 * (FLP for instance) about the change of control positions
 * through via a postmessage call.
 *
 *
 * 
 *
 * @class
 * @param {string} sService
 * @param {Object} oEvent
 * @param {UCF_LS} oLS
 * @return {Any}
 */
function UCF_PMServiceStatefulContainer(sService, oEvent, oLS) {if (__UCF_COVERAGE__) { UCF_PMServiceStatefulContainer["_"]["UCF_PMServiceStatefulContainer"]++; }; 
	if (arguments["length"] === 0)
		return;
	if (arguments["length"] === 2) {
		var oDomRef = sService;
		oLS = oEvent;
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PMServiceStatefulContainer.js(41): UCF_PMServiceStatefulContainer"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PMServiceStatefulContainer.js(42): UCF_PMServiceStatefulContainer"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PMServiceStatefulContainer.js(43): UCF_PMServiceStatefulContainer"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		// Apply defaults to statics
		UCF_PMServiceStatefulContainer["sServiceName"] = this["sServiceName"];
		UCF_PMServiceStatefulContainer["sServiceType"] = this["sServiceType"];
		UCF_PMServiceStatefulContainer["sTechnology"] = this["sTechnology"];
		UCF_PMServiceStatefulContainer["sTarget"] = this["sTarget"];
		UCF_PMServiceStatefulContainer["sReceive"] = this["sReceive"];
		UCF_PMServiceStatefulContainer["oLS"] = oLS;
		UCF_PMServiceStatefulContainer["oInstance"] = this;
		var oConf = UCF_JsUtil["oJsonParse"](oDomRef["getAttribute"]("data-config"));
		if (oConf["ServiceName"])
			UCF_PMServiceStatefulContainer["sServiceName"] = oConf["ServiceName"];
		if (oConf["Technologie"])
			UCF_PMServiceStatefulContainer["sTechnology"] = oConf["Technologie"];
		if (oConf["Target"])
			UCF_PMServiceStatefulContainer["sTarget"] = oConf["Target"];
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "UCF_PMServiceStatefulContainer c'tor called", "PMServiceStatefulContainer.js(62): UCF_PMServiceStatefulContainer"); };
	} else if (arguments["length"] === 3) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'UCF_PMServiceStatefulContainer called', "PMServiceStatefulContainer.js(64): UCF_PMServiceStatefulContainer"); };

		var oRequest;
		if (typeof(oEvent["data"]) === 'string')
			oRequest = JSON["parse"](oEvent["data"]);
		else
			oRequest = oEvent["data"];
		if (oRequest["type"] === 'response')
			// eslint-disable-next-line consistent-return
			return true;
		if (UCF_StringUtil["bContains"](sService, '.destroy') === true) {
			UCF_PMServiceStatefulContainer["oLS"]["sleep"]();
			// call the destroy handler configured
			if ((UCF_PMServiceStatefulContainer["sReceive"]) !== '')
				window[UCF_PMServiceStatefulContainer["sReceive"]](oRequest);
			oRequest["status"] = 'success';
		}
		else if (UCF_StringUtil["bContains"](sService, '.create') === true) {
			UCF_PMServiceStatefulContainer["oLS"]["sleep"](false);
			// call the create handler configured
			if ((UCF_PMServiceStatefulContainer["sReceive"]) !== '')
				window[UCF_PMServiceStatefulContainer["sReceive"]] (oRequest);
			oRequest["status"] = 'success';
		}
		else {
			oRequest["status"] = 'failed';
		}
		oRequest["type"] = 'response';
		oRequest["status"] = 'success';
		// eslint-disable-next-line consistent-return
		return oRequest;
	}
};window["UCF_PMServiceStatefulContainer"] = UCF_PMServiceStatefulContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PMServiceStatefulContainer"); UCF_PMServiceStatefulContainer["_"] = {UCF_PMServiceStatefulContainer: 0}; }; ;

UCF_PMServiceStatefulContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PMServiceStatefulContainer.prototype["sClassName"] = "UCF_PMServiceStatefulContainer";

UCF_PMServiceStatefulContainer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceStatefulContainer["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PMServiceStatefulContainer["_"]["destroy"] = 0; };

UCF_PMServiceStatefulContainer["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceStatefulContainer["_"]["initialize"]++; }; 
	var sServiceName = this["sServiceName"] + ".setup";
	UCF_JsUtil["postMessage"]({
		"type": "request",
		"service": sServiceName,
		"request_id": "stateful-init",
		"body": {
			"isStateful": true,
			"session": {
				"bLogoutSupport": true
			}
		}
	}, this["sTarget"]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceStatefulContainer.initialize', "PMServiceStatefulContainer.js(117): initialize"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceStatefulContainer["_"]["initialize"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PMServiceStatefulContainer["prototype"]["aAttributeNames"] = ["sTarget","sServiceName","sReceive","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PMServiceStatefulContainer["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PMServiceStatefulContainer["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PMServiceStatefulContainer["prototype"]["sTarget"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PMServiceStatefulContainer["prototype"]["sServiceName"] = 'sap.ushell.services.appLifeCycle';

/**
 * @private
 * @type {string}
 */
UCF_PMServiceStatefulContainer["prototype"]["sReceive"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PMServiceStatefulContainer["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PMServiceStatefulContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceStatefulContainer["_"]["setDefaultValues"]++; }; 
	this["sTarget"] = '';
	this["sServiceName"] = 'sap.ushell.services.appLifeCycle';
	this["sReceive"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Target", '', true);
		this["setClientProperty"]("ServiceName", 'sap.ushell.services.appLifeCycle', true);
		this["setClientProperty"]("Receive", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PMServiceStatefulContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PMServiceThemeChange"] = function() {/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsdoc/check-syntax */
/* eslint-disable jsdoc/check-alignment */
/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>

// eslint-disable-next-line jsdoc/require-returns
/**
 *
 * Theme change request will be handled by this service
 *
 * 
 *
 * @class
 * @param {string} sService
 * @param {UCF_Event} oEvent
 * @param {UCF_LS} oLS
 */

function UCF_PMServiceThemeChange(sService, oEvent, oLS) {if (__UCF_COVERAGE__) { UCF_PMServiceThemeChange["_"]["UCF_PMServiceThemeChange"]++; }; 
	if (arguments["length"] === 0)
		return;
	if (arguments["length"] === 2) {

		var oDomRef = sService;
		oLS = oEvent;
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PMServiceThemeChange.js(39): UCF_PMServiceThemeChange"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PMServiceThemeChange.js(40): UCF_PMServiceThemeChange"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PMServiceThemeChange.js(41): UCF_PMServiceThemeChange"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);
		this["oLS"] = oLS;
		UCF_PMServiceThemeChange["oInstance"] = this;
		UCF_PMServiceThemeChange["oLS"] = oLS;
	} else if (arguments["length"] === 3) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'UCF_PMServiceThemeChange called', "PMServiceThemeChange.js(48): UCF_PMServiceThemeChange"); };

		if (oLS)
			UCF_PMServiceThemeChange["oLS"] = oLS;
		var oMessage;
		if (typeof(oEvent["data"]) === 'string')
			oMessage = JSON["parse"](oEvent["data"]);
		else
			oMessage = oEvent["data"];

		var aThemeId = oMessage["body"]["currentThemeId"]["split"]('@');
		if (aThemeId["length"] > 1) {
			if (UCF_ResourceUtil["bIsSapThemeID"](aThemeId[0]) === true) {
				aThemeId[1] = window["UCF_System"]["sThemeFallbackRepositoryURL"];
			}
			UCF_PMServiceThemeChange["oLS"]["setSystemParameters"]({
				"ThemeRepositoryURL": aThemeId[1],
				"ThemeID": aThemeId[0]
			});
		} else {
			if (UCF_ResourceUtil["bIsSapThemeID"](aThemeId[0]) === true)
				UCF_PMServiceThemeChange["oLS"]["setSystemParameters"]({
					"ThemeRepositoryURL": window["UCF_System"]["sThemeFallbackRepositoryURL"],
					"ThemeID": aThemeId[0]
				});
			else
				UCF_PMServiceThemeChange["oLS"]["setSystemParameters"]({
					"ThemeID": aThemeId[0]
				});
		}

		var oResponse;
		if (typeof(oEvent["data"]) === 'string')
			oResponse = JSON["parse"](oEvent["data"]);
		else
			oResponse = oEvent["data"];
		if (oResponse["type"] === 'response')
			// eslint-disable-next-line consistent-return
			return null;
		oResponse["type"] = 'response';
		oResponse["status"] = 'success';
		// eslint-disable-next-line consistent-return
		return oResponse;
	}
};window["UCF_PMServiceThemeChange"] = UCF_PMServiceThemeChange; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PMServiceThemeChange"); UCF_PMServiceThemeChange["_"] = {UCF_PMServiceThemeChange: 0}; }; ;

UCF_PMServiceThemeChange["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PMServiceThemeChange.prototype["sClassName"] = "UCF_PMServiceThemeChange";

UCF_PMServiceThemeChange["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceThemeChange["_"]["destroy"]++; }; 
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["DirtyFlagChanged"], this);
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"], this);
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PMServiceThemeChange["_"]["destroy"] = 0; };

UCF_PMServiceThemeChange["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceThemeChange["_"]["initialize"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceThemeChange.initialize', "PMServiceThemeChange.js(103): initialize"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceThemeChange["_"]["initialize"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PMServiceThemeChange["prototype"]["aAttributeNames"] = [];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PMServiceThemeChange["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PMServiceThemeChange["prototype"]["aMethodNames"] = [];


//#JSCOVER_EXCL_START
/** @protected */
UCF_PMServiceThemeChange["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceThemeChange["_"]["setDefaultValues"]++; }; 
	

	if (this["getClientControl"]() && !this["bKeepAlive"]) ;
};;if (__UCF_COVERAGE__) { UCF_PMServiceThemeChange["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PMServiceTimeout"] = function() {/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsdoc/check-syntax */
/* eslint-disable jsdoc/check-alignment */
/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>

/*
 *
 * This Post Message Service is used to obtain the time a user has
 * been inactive.
 *
 * It uses any event for determining that time
 *
 * IHUbPostmessage must exist
 *
 */

// eslint-disable-next-line jsdoc/require-returns
/**
 * 
 *
 * @class
 * @param {string} sService
 * @param {Object} oEvent
 * @param {UCF_LS} oLS
 */
function UCF_PMServiceTimeout(sService, oEvent, oLS) {if (__UCF_COVERAGE__) { UCF_PMServiceTimeout["_"]["UCF_PMServiceTimeout"]++; }; 
	var oDate;

	if (arguments["length"] === 0)
		return;
	if (arguments["length"] === 2) {

		var oDomRef = sService;
		oLS = oEvent;
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PMServiceTimeout.js(40): UCF_PMServiceTimeout"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PMServiceTimeout.js(41): UCF_PMServiceTimeout"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PMServiceTimeout.js(42): UCF_PMServiceTimeout"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		var oWindow = this["oLS"]["oBrowserWindow"];
		oWindow["attachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');

		oDate = new Date();
		this["iLastActionTime"] = oDate["getTime"]();
		UCF_PMServiceTimeout["oInstance"] = this;
	} else if (arguments["length"] === 3) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'UCF_PMServiceTimeout called', "PMServiceTimeout.js(53): UCF_PMServiceTimeout"); };
		var oResponse;
		if (typeof(oEvent["data"]) === 'string')
			oResponse = JSON["parse"](oEvent["data"]);
		else
			oResponse = oEvent["data"];
		if (oResponse["type"] === 'response')
			// eslint-disable-next-line consistent-return
			return null;
		oDate = new Date();
		var x = (oDate["getTime"]() -
			UCF_PMServiceTimeout["oInstance"]["iLastActionTime"]) / 1000;
		if (x < oResponse["body"]["x"])
			oResponse["body"]["isUserActive"] = true;
		else
			oResponse["body"]["isUserActive"] = false;
		oResponse["body"]["x"] = x;
		oResponse["type"] = 'response';
		oResponse["status"] = 'success';
		// eslint-disable-next-line consistent-return
		return oResponse;
	}
};window["UCF_PMServiceTimeout"] = UCF_PMServiceTimeout; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PMServiceTimeout"); UCF_PMServiceTimeout["_"] = {UCF_PMServiceTimeout: 0}; }; ;

UCF_PMServiceTimeout["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PMServiceTimeout.prototype["sClassName"] = "UCF_PMServiceTimeout";

UCF_PMServiceTimeout["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceTimeout["_"]["destroy"]++; }; 
	this["oLS"]["oBrowserWindow"]["detachEvent"](
		this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"], this);
	this["iLastActionTime"] = null;;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PMServiceTimeout["_"]["destroy"] = 0; };

UCF_PMServiceTimeout["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceTimeout["_"]["initialize"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceTimeout.initialize', "PMServiceTimeout.js(88): initialize"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceTimeout["_"]["initialize"] = 0; };

UCF_PMServiceTimeout["prototype"]["onAfterResponse"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PMServiceTimeout["_"]["onAfterResponse"]++; }; 
	var oDate = new Date();
	this["iLastActionTime"] = oDate["getTime"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Event', "PMServiceTimeout.js(94): onAfterResponse"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceTimeout["_"]["onAfterResponse"] = 0; };

UCF_PMServiceTimeout["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PMServiceTimeout["_"]["onAnyEvent"]++; }; 
	var oDate = new Date();
	this["iLastActionTime"] = oDate["getTime"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Event', "PMServiceTimeout.js(100): onAnyEvent"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceTimeout["_"]["onAnyEvent"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PMServiceTimeout["prototype"]["aAttributeNames"] = ["sTarget","sTargetService","bIgnoreResponse","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PMServiceTimeout["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PMServiceTimeout["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PMServiceTimeout["prototype"]["sTarget"] = 'parent.parent';

/**
 * @private
 * @type {string}
 */
UCF_PMServiceTimeout["prototype"]["sTargetService"] = 'sap.ushell.services.Container.setDirtyFlag';

/**
 * @private
 * @type {boolean}
 */
UCF_PMServiceTimeout["prototype"]["bIgnoreResponse"] = true;

/**
 * @private
 * @type {string}
 */
UCF_PMServiceTimeout["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PMServiceTimeout["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceTimeout["_"]["setDefaultValues"]++; }; 
	this["sTarget"] = 'parent.parent';
	this["sTargetService"] = 'sap.ushell.services.Container.setDirtyFlag';
	this["bIgnoreResponse"] = true;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Target", 'parent.parent', true);
		this["setClientProperty"]("TargetService", 'sap.ushell.services.Container.setDirtyFlag', true);
		this["setClientProperty"]("IgnoreResponse", true, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PMServiceTimeout["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PMServiceUShellSessionHandler"] = function() {/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsdoc/check-alignment */
/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_IHubPostMessage */
/// <reference path="../../ihub/IHubPostMessage.js"/>

/**
 *
 *
 *
 * @class
 * @param {string} sService
 * @param {Object} oEvent
 * @param {UCF_LS} oLS
 * @return {Object}
 */
// eslint-disable-next-line jsdoc/check-syntax
function UCF_PMServiceUShellSessionHandler(sService, oEvent, oLS) {if (__UCF_COVERAGE__) { UCF_PMServiceUShellSessionHandler["_"]["UCF_PMServiceUShellSessionHandler"]++; }; 
	if (arguments["length"] === 0)
		return;
	if (arguments["length"] === 2) {

		var oDomRef = sService;
		oLS = oEvent;
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PMServiceUShellSessionHandler.js(38): UCF_PMServiceUShellSessionHandler"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PMServiceUShellSessionHandler.js(39): UCF_PMServiceUShellSessionHandler"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PMServiceUShellSessionHandler.js(40): UCF_PMServiceUShellSessionHandler"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);
		this["oLS"] = oLS;
		UCF_PMServiceUShellSessionHandler["oInstance"] = this;
		UCF_PMServiceUShellSessionHandler["oLS"] = oLS;

	} else if (arguments["length"] === 3) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'UCF_PMServiceUShellSessionHandler called', "PMServiceUShellSessionHandler.js(48): UCF_PMServiceUShellSessionHandler"); };

		if (oLS)
			UCF_PMServiceUShellSessionHandler["oLS"] = oLS;
		try {
			var oResponse;
			if (typeof(oEvent["data"]) === 'string')
				oResponse = JSON["parse"](oEvent["data"]);
			else
				oResponse = oEvent["data"];
			if (oResponse["type"] === 'response')
				// eslint-disable-next-line consistent-return
				return true; // return immediately
			oResponse["type"] = 'response';
			oResponse["status"] = 'success';
			// eslint-disable-next-line consistent-return
			return oResponse;
		} catch (e) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'UCF_PMServiceUShellSessionHandler exception', "PMServiceUShellSessionHandler.js(66): UCF_PMServiceUShellSessionHandler"); };
		}
	}
};window["UCF_PMServiceUShellSessionHandler"] = UCF_PMServiceUShellSessionHandler; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PMServiceUShellSessionHandler"); UCF_PMServiceUShellSessionHandler["_"] = {UCF_PMServiceUShellSessionHandler: 0}; }; ;

UCF_PMServiceUShellSessionHandler["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PMServiceUShellSessionHandler.prototype["sClassName"] = "UCF_PMServiceUShellSessionHandler";

UCF_PMServiceUShellSessionHandler["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceUShellSessionHandler["_"]["destroy"]++; }; 
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"], this);
	this["iLastActionTime"] = null;
	this["iLastNotication"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PMServiceUShellSessionHandler["_"]["destroy"] = 0; };

UCF_PMServiceUShellSessionHandler["prototype"]["onAnyEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceUShellSessionHandler["_"]["onAnyEvent"]++; }; 
	var oDate = new Date();
	this["iLastActionTime"] = oDate["getTime"]();
	if (this["iLastActionTime"] - this["iLastNotication"] > 1000) {
		this["iLastNotication"] = this["iLastActionTime"];
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceUShellSessionHandler: Send activity notification.', "PMServiceUShellSessionHandler.js(86): onAnyEvent"); };
		UCF_JsUtil["postMessage"](this["sRequest"], this["sTarget"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PMServiceUShellSessionHandler["_"]["onAnyEvent"] = 0; };

UCF_PMServiceUShellSessionHandler["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceUShellSessionHandler["_"]["initialize"]++; }; 
	this["bInitialized"] = true;
	if (this["bNotifyUserActive"]) {
		this["iRequestId"] = 1;
		this["iLastNotication"] = 0;
		this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
		this["sRequest"] = '{"type": "request","service": "sap.ushell.sessionHandler.notifyUserActive","body": {}}';
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceUShellSessionHandler.initialize', "PMServiceUShellSessionHandler.js(100): initialize"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceUShellSessionHandler["_"]["initialize"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PMServiceUShellSessionHandler["prototype"]["aAttributeNames"] = ["sTarget","bNotifyUserActive","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PMServiceUShellSessionHandler["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PMServiceUShellSessionHandler["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PMServiceUShellSessionHandler["prototype"]["sTarget"] = 'parent.parent';

/**
 * @private
 * @type {boolean}
 */
UCF_PMServiceUShellSessionHandler["prototype"]["bNotifyUserActive"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PMServiceUShellSessionHandler["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PMServiceUShellSessionHandler["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceUShellSessionHandler["_"]["setDefaultValues"]++; }; 
	this["sTarget"] = 'parent.parent';
	this["bNotifyUserActive"] = false;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Target", 'parent.parent', true);
		this["setClientProperty"]("NotifyUserActive", false, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PMServiceUShellSessionHandler["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PMServiceWebAssistant"] = function() {/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsdoc/check-syntax */
/* eslint-disable jsdoc/check-alignment */
/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_IHubPostMessage */
/// <reference path="../../ihub/IHubPostMessage.js"/>

// eslint-disable-next-line jsdoc/require-returns
/**
 *
 * This Post Message Service is designed to notify a target
 * (FLP for instance) about the change of control positions
 * through via a postmessage call.
 *
 *
 * 
 *
 * @class
 * @param {string} sService
 * @param {Object} oEvent
 * @param {UCF_LS} oLS
 * @return {Any}
 */
function UCF_PMServiceWebAssistant(sService, oEvent, oLS) {if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["UCF_PMServiceWebAssistant"]++; }; 
	if (arguments["length"] === 0)
		return;
	if (arguments["length"] === 2) {
		var oDomRef = sService;
		oLS = oEvent;
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PMServiceWebAssistant.js(41): UCF_PMServiceWebAssistant"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PMServiceWebAssistant.js(42): UCF_PMServiceWebAssistant"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PMServiceWebAssistant.js(43): UCF_PMServiceWebAssistant"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		if (UCF_PMServiceWebAssistant["bHandlerAttached"] == null)
			UCF_PMServiceWebAssistant["bHandlerAttached"] = false;
		// Apply defaults to statics
		UCF_PMServiceWebAssistant["sServiceName"] = this["sServiceName"];
		UCF_PMServiceWebAssistant["sServiceType"] = this["sServiceType"];
		UCF_PMServiceWebAssistant["sTechnology"] = this["sTechnology"];
		UCF_PMServiceWebAssistant["oLS"] = oLS;
		UCF_PMServiceWebAssistant["oInstance"] = this;
		UCF_PMServiceWebAssistant["nLayeredControls"] = 0;
		var oConf = UCF_JsUtil["oJsonParse"](oDomRef["getAttribute"]("data-config"));
		if (oConf["ServiceName"])
			UCF_PMServiceWebAssistant["sServiceName"] = oConf["ServiceName"];
		if (oConf["ServiceType"])
			UCF_PMServiceWebAssistant["sServiceType"] = oConf["ServiceType"];
		if (oConf["Technologie"])
			UCF_PMServiceWebAssistant["sTechnology"] = oConf["Technologie"];
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "UCF_PMServiceWebAssistant c'tor called", "PMServiceWebAssistant.js(63): UCF_PMServiceWebAssistant"); };
	} else if (arguments["length"] === 3) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'UCF_PMServiceWebAssistant called', "PMServiceWebAssistant.js(65): UCF_PMServiceWebAssistant"); };
		var oPM;
		if (!UCF_PMServiceWebAssistant["iRequestId"])
			UCF_PMServiceWebAssistant["iRequestId"] = 0;
		if (UCF_PMServiceWebAssistant["bHandlerAttached"] == null)
			UCF_PMServiceWebAssistant["bHandlerAttached"] = false;
		if (!UCF_PMServiceWebAssistant["sTechnology"])
			UCF_PMServiceWebAssistant["sTechnology"] = 'OTHER';
		UCF_PMServiceWebAssistant["sQueryString"] = "[data-hint*=',\"" + UCF_PMServiceWebAssistant["sServiceType"] +
			"\":'], [data-hint^='{\"" + UCF_PMServiceWebAssistant["sServiceType"] + "\":']";
		UCF_PMServiceWebAssistant["sQueryStringV2"] = "[data-hint*=',\"SapCompanion\":'], [data-hint^='{\"SapCompanion\":']";

		var oRequest;
		if (typeof(oEvent["data"]) === 'string')
			oRequest = JSON["parse"](oEvent["data"]);
		else
			oRequest = oEvent["data"];
		if (oRequest["type"] === 'response')
			// eslint-disable-next-line consistent-return
			return true;
		if (UCF_StringUtil["bContains"](sService, 'top') === true) {
			if (UCF_PMServiceWebAssistant["bHandlerAttached"]) {
				//				UCF_DomUtil.detachEvent(document, "scroll", UCF_PMServiceWebAssistant.onscroll);
				if (document["removeEventListener"]) {
					UCF_PMServiceWebAssistant["oLS"]["oPage"]["oDomRef"]["removeEventListener"]("scroll", UCF_PMServiceWebAssistant["onscroll"], true);
					UCF_DomUtil["detachEvent"](document, "scroll", UCF_PMServiceWebAssistant["onscroll"]);
				} else
					document["detachEvent"]("onscroll", UCF_PMServiceWebAssistant["onscroll"]);
				oPM = UCF_PMServiceWebAssistant["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]();
				oPM["detachEvent"](oPM["E_EVENTS"]["PopupOpen"], UCF_PMServiceWebAssistant["oInstance"]);
				oPM["detachEvent"](oPM["E_EVENTS"]["PopupClose"], UCF_PMServiceWebAssistant["oInstance"]);
				UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["detachEvent"](
					UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayersVisible"],
					UCF_PMServiceWebAssistant["oInstance"]);
				UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["detachEvent"](
					UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayeredControlOpen"],
					UCF_PMServiceWebAssistant["oInstance"]);
				UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["detachEvent"](
					UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayeredControlClose"],
					UCF_PMServiceWebAssistant["oInstance"]);
				UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["detachEvent"](
					UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"],
					UCF_PMServiceWebAssistant["oInstance"]);
				UCF_PMServiceWebAssistant["oLS"]["detachEvent"](
					UCF_PMServiceWebAssistant["oLS"]["E_EVENTS"]["ControlCreate"],
					UCF_PMServiceWebAssistant["oInstance"]);
				UCF_PMServiceWebAssistant["oInstance"]["detachHandlers"]();
				UCF_PMServiceWebAssistant["bHandlerAttached"] = false;
			}
			UCF_PMServiceWebAssistant["bActive"] = false;
			UCF_IHubPostMessage["submit"](oRequest);

			if (oRequest["request_id"]) {
				oRequest["type"] = 'response';
				oRequest["status"] = 'success';
				// eslint-disable-next-line consistent-return
				return oRequest;
			}
			// eslint-disable-next-line consistent-return
			else return true;
		}
		if (UCF_StringUtil["bContains"](sService, 'tart') === true) {
			// eslint-disable-next-line consistent-return
			if (UCF_PMServiceWebAssistant["bHandlerAttached"] === false) {
				//			UCF_DomUtil.attachEvent(document, "scroll", UCF_PMServiceWebAssistant.onscroll);

				if (document["addEventListener"]) {
					UCF_PMServiceWebAssistant["oLS"]["oPage"]["oDomRef"]["addEventListener"]("scroll", UCF_PMServiceWebAssistant["onscroll"], true);
					UCF_DomUtil["attachEvent"](document, "scroll", UCF_PMServiceWebAssistant["onscroll"]);
				} else
					document["attachEvent"]("onscroll", UCF_PMServiceWebAssistant["onscroll"]);
				oPM = UCF_PMServiceWebAssistant["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]();
				oPM["attachEvent"](oPM["E_EVENTS"]["PopupOpen"], UCF_PMServiceWebAssistant["oInstance"], 'onPopupOpenClose');
				oPM["attachEvent"](oPM["E_EVENTS"]["PopupClose"], UCF_PMServiceWebAssistant["oInstance"], 'onPopupOpenClose');
				UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["attachEvent"](
					UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayeredControlOpen"],
					UCF_PMServiceWebAssistant["oInstance"], 'onLayeredControlOpen');
				UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["attachEvent"](
					UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayersVisible"],
					UCF_PMServiceWebAssistant["oInstance"], 'onLayerVisible');
				UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["attachEvent"](
					UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayeredControlClose"],
					UCF_PMServiceWebAssistant["oInstance"], 'onLayeredControlClose');
				UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["attachEvent"](
					UCF_PMServiceWebAssistant["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"],
					UCF_PMServiceWebAssistant["oInstance"],
					'onLayOutChange');
				UCF_PMServiceWebAssistant["oLS"]["attachEvent"](
					UCF_PMServiceWebAssistant["oLS"]["E_EVENTS"]["ControlCreate"],
					UCF_PMServiceWebAssistant["oInstance"],
					'onControlCreate');
				/*				UCF_PMServiceWebAssistant.oLS.attachEvent(
									UCF_PMServiceWebAssistant.oLS.E_EVENTS.ControlDestroy,
									UCF_PMServiceWebAssistant.oInstance,
									'onControlDestroy'); */
				UCF_PMServiceWebAssistant["oInstance"]["attachHandlers"]();
				UCF_PMServiceWebAssistant["bHandlerAttached"] = true;
			}
			UCF_PMServiceWebAssistant["bActive"] = true;
			UCF_PMServiceWebAssistant["sendElementsArray"]();
			UCF_PMServiceWebAssistant["oTarget"] = oEvent["source"];
			UCF_IHubPostMessage["submit"](oRequest);
			if (oRequest["request_id"]) {
				oRequest["type"] = 'response';
				oRequest["status"] = 'success';
				// eslint-disable-next-line consistent-return
				return oRequest;
			}
			// eslint-disable-next-line consistent-return
			else return true;
		}
		// eslint-disable-next-line consistent-return
		return true;
	}
};window["UCF_PMServiceWebAssistant"] = UCF_PMServiceWebAssistant; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PMServiceWebAssistant"); UCF_PMServiceWebAssistant["_"] = {UCF_PMServiceWebAssistant: 0}; }; ;

UCF_PMServiceWebAssistant["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PMServiceWebAssistant.prototype["sClassName"] = "UCF_PMServiceWebAssistant";

UCF_PMServiceWebAssistant["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["destroy"] = 0; };

UCF_PMServiceWebAssistant["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["initialize"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceWebAssistant.initialize', "PMServiceWebAssistant.js(188): initialize"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["initialize"] = 0; };

/**
 *
 * Attach Hierarchicalview and Scrollbar handlers when needed
 *
 */

UCF_PMServiceWebAssistant["prototype"]["attachHandlers"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["attachHandlers"]++; }; 
	var self = this;
	var oNodes = document["querySelectorAll"]('[ct="HV"]');
	UCF_JsUtil["forEach"](oNodes, self["attachHierarchicalViewHandler"]);
	oNodes = document["querySelectorAll"]('[ct="SCB"]');
	UCF_JsUtil["forEach"](oNodes, self["attachScrollHandler"]);
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["attachHandlers"] = 0; };

/**
 *
 * Attach Hierarchicalview Scrollbar handlers when needed
 *
 */

UCF_PMServiceWebAssistant["prototype"]["attachHierarchicalViewHandler"] = function(oNode) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["attachHierarchicalViewHandler"]++; }; 
	var oControl = UCF_PMServiceWebAssistant["oLS"]["oControlFactory"]["oGetControlById"](oNode["id"]);
	oControl["attachSemanticEvent"](
		'SegmentChange',
		UCF_PMServiceWebAssistant["oInstance"],
		'onHierarchicalViewChange');
	return;
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["attachHierarchicalViewHandler"] = 0; };

UCF_PMServiceWebAssistant["prototype"]["attachScrollHandler"] = function(oNode) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["attachScrollHandler"]++; }; 
	var oControl = UCF_PMServiceWebAssistant["oLS"]["oControlFactory"]["oGetControlById"](oNode["id"]);
	oControl["attachEvent"](oControl["E_EVENTS"]["Scroll"], UCF_PMServiceWebAssistant["oInstance"], "onScrollbarChange");
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["attachScrollHandler"] = 0; };

/**
 *
 * Detach Hierarchicalview handlers when needed
 *
 */

UCF_PMServiceWebAssistant["prototype"]["detachHandlers"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["detachHandlers"]++; }; 
	var self = this;
	var oNodes = document["querySelectorAll"]('[ct="HV"]');
	UCF_JsUtil["forEach"](oNodes, self["detachHierarchicalViewHandler"]);
	oNodes = document["querySelectorAll"]('[ct="SCB"]');
	UCF_JsUtil["forEach"](oNodes, self["detachScrollHandler"]);
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["detachHandlers"] = 0; };

UCF_PMServiceWebAssistant["prototype"]["detachHierarchicalViewHandler"] = function(oNode) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["detachHierarchicalViewHandler"]++; }; 
	var oControl = UCF_PMServiceWebAssistant["oLS"]["oControlFactory"]["oGetControlById"](oNode["id"]);
	oControl["detachSemanticEvent"](
		'SegmentChange',
		UCF_PMServiceWebAssistant["oInstance"],
		'onHierarchicalViewChange');
	return;
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["detachHierarchicalViewHandler"] = 0; };

UCF_PMServiceWebAssistant["prototype"]["detachScrollHandler"] = function(oNode) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["detachScrollHandler"]++; }; 
	var oControl = UCF_PMServiceWebAssistant["oLS"]["oControlFactory"]["oGetControlById"](oNode["id"]);
	oControl["detachEvent"](oControl["E_EVENTS"]["Scroll"], UCF_PMServiceWebAssistant["oInstance"], "onScrollbarChange");
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["detachScrollHandler"] = 0; };

/**
 *
 * Handler for layoutchange events
 *
 * @param {Object} param
 *
 */
UCF_PMServiceWebAssistant["prototype"]["onLayOutChange"] = function(param) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onLayOutChange"]++; }; 
	try {
		// Semantical events of hierarchical views created by CSR must be monitored
		if (param["mParameters"]["sSourceClassName"] === "UCF_RenderManager" &&
			UCF_PMServiceWebAssistant["oLS"]["oControlFactory"]["oGetControlById"](param["mParameters"]["oCustomData"]["sRenderedControlId"])["sClassName"]
			=== "UCF_HierarchicalView")
			UCF_PMServiceWebAssistant["oLS"]["oControlFactory"]["oGetControlById"](param["mParameters"]["oCustomData"]["sRenderedControlId"])["attachSemanticEvent"](
				'SegmentChange',
				UCF_PMServiceWebAssistant["oInstance"],
				'onHierarchicalViewChange');

	} catch (e) {}

	if (UCF_PMServiceWebAssistant["nLayeredControls"] !== 0 || UCF_PMServiceWebAssistant["requestAnimationFrameId"])
		return;
	UCF_PMServiceWebAssistant["requestAnimationFrameId"] =
		UCF_JsUtil["requestAnimationFrame"](UCF_PMServiceWebAssistant["sendElementsArray"]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceWebAssistant.onLayOutChange', "PMServiceWebAssistant.js(277): onLayOutChange"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onLayOutChange"] = 0; };

UCF_PMServiceWebAssistant["prototype"]["onLayerVisible"] = function(params) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onLayerVisible"]++; }; 
	//document.getElementById("ls-datepickerslider").getBoundingClientRect()
	if (UCF_PMServiceWebAssistant["sLayeredControlOpening"]) {
		UCF_PMServiceWebAssistant["oLayeredControlRect"] =
			document["getElementById"](UCF_PMServiceWebAssistant["sLayeredControlOpening"]);
		if (UCF_PMServiceWebAssistant["oLayeredControlRect"])
			UCF_PMServiceWebAssistant["oLayeredControlRect"] =
			document["getElementById"](UCF_PMServiceWebAssistant["sLayeredControlOpening"])["getBoundingClientRect"]();
	}
	UCF_PMServiceWebAssistant["sLayeredControlOpening"] = null;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceWebAssistant.onLayerVisible', "PMServiceWebAssistant.js(290): onLayerVisible"); };
	if (UCF_PMServiceWebAssistant["requestAnimationFrameId"])
		return;
	UCF_PMServiceWebAssistant["requestAnimationFrameId"] =
		UCF_JsUtil["requestAnimationFrame"](UCF_PMServiceWebAssistant["sendElementsArray"]);
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onLayerVisible"] = 0; };
/**
 *
 * Handler for the LayeredControlOpen event
 *
 * @param {Object} params
 *
 */
UCF_PMServiceWebAssistant["prototype"]["onLayeredControlOpen"] = function(params) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onLayeredControlOpen"]++; }; 
	if (params["mParameters"]["sSourceClassName"] === "UCF_LoadingAnimation") return;
	UCF_PMServiceWebAssistant["nLayeredControls"]++;
	UCF_PMServiceWebAssistant["sLayeredControlOpening"] = params["mParameters"]["sSourceControlId"];
	return;
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onLayeredControlOpen"] = 0; };

/**
 *
 * Handler for the LayeredControlClose event
 *
 * @param {Object} params
 *
 */
UCF_PMServiceWebAssistant["prototype"]["onLayeredControlClose"] = function(params) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onLayeredControlClose"]++; }; 
	if (params["mParameters"]["sSourceClassName"] === "UCF_LoadingAnimation") return;
	UCF_PMServiceWebAssistant["sLayeredControlOpening"] = null;
	UCF_PMServiceWebAssistant["oLayeredControlRect"] = null;
	if (UCF_PMServiceWebAssistant["nLayeredControls"] !== 0) UCF_PMServiceWebAssistant["nLayeredControls"]--;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceWebAssistant.onLayeredControlClose count:' +
		UCF_PMServiceWebAssistant["nLayeredControls"], "PMServiceWebAssistant.js(322): onLayeredControlClose"); };
	if (UCF_PMServiceWebAssistant["nLayeredControls"] === 0 && !UCF_PMServiceWebAssistant["requestAnimationFrameId"])
		UCF_PMServiceWebAssistant["requestAnimationFrameId"] =
		UCF_JsUtil["requestAnimationFrame"](UCF_PMServiceWebAssistant["sendElementsArray"]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceWebAssistant.onLayeredControlClose', "PMServiceWebAssistant.js(327): onLayeredControlClose"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onLayeredControlClose"] = 0; };

/**
 *
 * Handler for the scroll event
 *
 * @param {Object} oEvent
 *
 */
UCF_PMServiceWebAssistant["onscroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onscroll"]++; }; 
	if (UCF_PMServiceWebAssistant["nLayeredControls"] === 0 &&
		(!UCF_PMServiceWebAssistant["requestAnimationFrameId"] || UCF_PMServiceWebAssistant["requestAnimationFrameId"] === 0))
		UCF_PMServiceWebAssistant["requestAnimationFrameId"] = UCF_JsUtil["requestAnimationFrame"](UCF_PMServiceWebAssistant["sendElementsArray"]);
	else
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceWebAssistant.sendElementsArray - not registered', "PMServiceWebAssistant.js(342): onscroll"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onscroll"] = 0; };

/**
 *
 * Handler for changes in Hierarchicalviews
 *
 */

UCF_PMServiceWebAssistant["prototype"]["onHierarchicalViewChange"] = function(oNode) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onHierarchicalViewChange"]++; }; 
	if (UCF_PMServiceWebAssistant["requestAnimationFrameId"])
		return;
	UCF_PMServiceWebAssistant["requestAnimationFrameId"] =
		UCF_JsUtil["requestAnimationFrame"](UCF_PMServiceWebAssistant["sendElementsArray"]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceWebAssistant.onHierarchicalViewChange', "PMServiceWebAssistant.js(356): onHierarchicalViewChange"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onHierarchicalViewChange"] = 0; };

UCF_PMServiceWebAssistant["prototype"]["onScrollbarChange"] = function(oNode) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onScrollbarChange"]++; }; 
	if (UCF_PMServiceWebAssistant["requestAnimationFrameId"])
		return;
	UCF_PMServiceWebAssistant["requestAnimationFrameId"] =
		UCF_JsUtil["requestAnimationFrame"](UCF_PMServiceWebAssistant["sendElementsArray"]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceWebAssistant.onScrollbarChange', "PMServiceWebAssistant.js(364): onScrollbarChange"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onScrollbarChange"] = 0; };

UCF_PMServiceWebAssistant["prototype"]["onControlDestroy"] = function(oParameter) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onControlDestroy"]++; }; 
	/*		if (oParameter.mParameters.sClassName === 'UCF_Scrollbar')
				this.detachScrollHandler(document.getElementById(oParameter.mParameters.Id)); */
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onControlDestroy"] = 0; };

UCF_PMServiceWebAssistant["prototype"]["onControlCreate"] = function(oParameter) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onControlCreate"]++; }; 
	if (oParameter["mParameters"]["ClassName"] === 'UCF_Scrollbar')
		this["attachScrollHandler"](document["getElementById"](oParameter["mParameters"]["Id"]));
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onControlCreate"] = 0; };

/**
 *
 * Constructs the array containing the coordinates of visible
 * elements related to UCF_PMServiceWebAssistant.sQueryString
 * Send that array to the assistant system using postmessage
 *
 */
UCF_PMServiceWebAssistant["sendElementsArray"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["sendElementsArray"]++; }; 
	if (UCF_PMServiceWebAssistant["requestAnimationFrameId"]) {
		UCF_JsUtil["cancelAnimationFrame"](UCF_PMServiceWebAssistant["requestAnimationFrameId"]);
		UCF_PMServiceWebAssistant["requestAnimationFrameId"] = 0;
	}
	UCF_PMServiceWebAssistant["oArrayToSend"] = new Array();
	UCF_PMServiceWebAssistant["oControlsToIgnore"] = new Array();
	UCF_PMServiceWebAssistant["oTableHeaderCells"] = new Array();
	// var oNodes = document.querySelectorAll("[data-hint*=',\"Webassistant\":' i], [data-hint^='{\"Webassistant\":' i]");
	UCF_PMServiceWebAssistant["bUseVersion2"] = false;
	var oNodes = document["querySelectorAll"](UCF_PMServiceWebAssistant["sQueryString"]);
	if (oNodes && oNodes["length"] === 0) {
		oNodes = document["querySelectorAll"](UCF_PMServiceWebAssistant["sQueryStringV2"]);
		UCF_PMServiceWebAssistant["bUseVersion2"] = true;
	}

	UCF_PMServiceWebAssistant["oPageRect"] = UCF_PMServiceWebAssistant["oLS"]["oPage"]["oDomRef"]["getBoundingClientRect"]();
	UCF_JsUtil["forEach"](oNodes, UCF_PMServiceWebAssistant["assembleArray"]);

	UCF_JsUtil["forEach"](UCF_PMServiceWebAssistant["oControlsToIgnore"], UCF_PMServiceWebAssistant["shrinkArrayToSend"]);

	var oObject = new Object();
	oObject["request_id"] = '-1'; // not intereted about responses
	oObject["type"] = 'request';
	oObject["body"] = new Object();
	if (UCF_PMServiceWebAssistant["bUseVersion2"]) {
		oObject["body"]["hotspots"] = UCF_PMServiceWebAssistant["oArrayToSend"];
		oObject["service"] = "sap.companion.services.UpdateHotspots";
	} else {
		oObject["body"]["technology"] = UCF_PMServiceWebAssistant["sTechnology"];
		oObject["body"]["elements"] = UCF_PMServiceWebAssistant["oArrayToSend"];
		oObject["service"] = "sap.webassistant.services.updateHotspots";
	}
	UCF_IHubPostMessage["postObjectMessage"](
		oObject, UCF_PMServiceWebAssistant["oTarget"]);
	UCF_PMServiceWebAssistant["oArrayToSend"] = [];
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_PMServiceWebAssistant.sendElementsArray', "PMServiceWebAssistant.js(420): sendElementsArray"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["sendElementsArray"] = 0; };

UCF_PMServiceWebAssistant["addHeaderCellToArrayToSend"] = function(oEntry, index) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["addHeaderCellToArrayToSend"]++; }; 
	UCF_PMServiceWebAssistant["oArrayToSend"]["push"](oEntry);
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["addHeaderCellToArrayToSend"] = 0; };

/**
 *
 * Removes oEntry from the array to be send
 * used for Controls contained in a hierarchical view already
 *
 * @param {Object} oEntry
 * @param {integer} index // not used just to satisfy the forEach interface
 *
 */
UCF_PMServiceWebAssistant["shrinkArrayToSend"] = function(oEntry, index) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["shrinkArrayToSend"]++; }; 
	for (var position = 0; position < UCF_PMServiceWebAssistant["oArrayToSend"]["length"]; position++)
		if (UCF_PMServiceWebAssistant["oArrayToSend"][position]["ctrlId"] === oEntry)
			break;
	if (position < UCF_PMServiceWebAssistant["oArrayToSend"]["length"])
		UCF_PMServiceWebAssistant["oArrayToSend"]["splice"](position, 1);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Entry to remove: ' + oEntry, "PMServiceWebAssistant.js(442): shrinkArrayToSend"); };
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["shrinkArrayToSend"] = 0; };

/**
 *
 * Calculates whether oNode might be a candidate for the assistant system
 * and pushes it to send array, controls to be gnored (already part of
 * a hierarchical view) are pushed to a second array
 *
 * @param {Object} oNode
 * @param {integer} index // not used just to satisfy the forEach interface
 *
 */
UCF_PMServiceWebAssistant["assembleArray"] = function(oNode, index) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["assembleArray"]++; }; 
	var oDomRect;
	var bIsTableheaderCell = false;
	var oControl = UCF_PMServiceWebAssistant["oLS"]["oControlFactory"]["oGetControlById"](oNode["id"]);
	if (!oControl) {
		try {
			if (oNode["getAttribute"]("subct") && oNode["getAttribute"]("subct") === 'HC') {
				bIsTableheaderCell = true;
				oControl = UCF_PMServiceWebAssistant["oLS"]["oControlFactory"]["oGetControlById"](oNode["parentNode"]["parentNode"]["id"]["split"]('-content')[0]);
			} else {
				oControl = UCF_PMServiceWebAssistant["oLS"]["oControlFactory"]["oGetControlById"](oNode["id"]["split"]('-')[1]);
				if (oControl) { // Hierarchicalview
					UCF_PMServiceWebAssistant["oControlsToIgnore"]["push"](oNode["id"]["split"]('-')[1]);
					var oSegmentNode = UCF_DomUtil["oGetParentByTagName"](oNode, 'DIV');
					// = document.getElementById(oNode.id.split(' - ')[0] + ' - itemssegment - ')
					if (oSegmentNode && oSegmentNode["getAttribute"]('class')["indexOf"]('lsHierarchicalview__itemssegment--active') === -1)
						return;
				}
			}
		} catch (e) {}
	}
	if (!oControl || UCF_PMServiceWebAssistant["oLS"]["oGetPopupManagerInternal"]()["bControlIsBlocked"](oControl))
		return;
	var oObject;
	if (UCF_PMServiceWebAssistant["bUseVersion2"]) {
		try {
			var oDataHint = JSON["parse"](oNode["getAttribute"]('data-hint'));
			oObject = JSON["parse"](JSON["stringify"](oDataHint["SapCompanion"]));
			/*oObject.hotspotId = oDataHint.SAPCompanion.hotspotId;
			if (oObject.hotspotId === '')
				return;
			if (oDataHint.SAPCompanion.backendHelpCDSQuery)
				oObject.backendHelpCDSQuery = oDataHint.SAPCompanion.backendHelpCDSQuery;
			if (oDataHint.SAPCompanion.backendHelpKey)
				oObject.backendHelpKey = oDataHint.SAPCompanion.backendHelpKey; */
		} catch (e) {
			return;
		}
	} else {
		try {
			oObject = new Object();
			oObject["id"] = JSON["parse"](oNode["getAttribute"]('data-hint'))[UCF_PMServiceWebAssistant["sServiceType"]]["id"];
		} catch (e) {
			return;
		}
		if (oObject["id"] === '')
			return;
	}
	oObject["position"] = new Object();
	if (bIsTableheaderCell)
		oDomRect = oNode["getBoundingClientRect"]();
	else
		oDomRect = oControl["oGetClientRectForHelp"]();
	oObject["ctrlId"] = oNode["id"];
	if (oDomRect["width"] === 0 || oDomRect["height"] === 0 || oDomRect["left"] < 0 || oDomRect["top"] < 0)
		return;
	var sLabel = UCF_PMServiceWebAssistant["sGetLabelFor"](oControl["sId"]);
	if (sLabel)
		oObject["labelText"] = sLabel;
	var oTable = oControl["oSaptableParent"]();
	if (oTable)
		oDomRect = UCF_PMServiceWebAssistant["oDomRectForTableCell"](oTable, oObject, oControl, oDomRect);
	if (!oDomRect)
		return;
	oObject["position"]["x"] = oDomRect["left"];
	oObject["position"]["y"] = oDomRect["top"];
	oObject["position"]["width"] = oDomRect["width"];
	oObject["position"]["height"] = oDomRect["height"];
	var oScrollContainer = oControl["oGetParentScrollAreaDomRef"]();
	while (oScrollContainer) {
		var oScrollRect = oScrollContainer["getBoundingClientRect"]();
		if (oScrollRect["y"] > oObject["position"]["y"] || oScrollRect["x"] > oObject["position"]["x"] ||
			oScrollRect["y"] + oScrollRect["height"] < oObject["position"]["y"] + oObject["position"]["height"] ||
			oScrollRect["x"] + oScrollRect["width"] < oObject["position"]["x"] + oObject["position"]["width"]) {
			if (oTable == null)
				return;
			var oTableRect = oTable["oDomRef"]["getBoundingClientRect"]();
			oObject["position"]["y"] = oScrollRect["y"];
			if (oTableRect["y"] + oTableRect["height"] < oObject["position"]["y"] + oObject["position"]["height"] || oTableRect["y"] > oObject["position"]["y"])
				return;
		}
		oScrollContainer = UCF_DomUtil["oGetParentByAttribute"](
			oScrollContainer && oScrollContainer["parentNode"],
			'lsscrl',
			'true'
		);
	}
	if (oObject["position"]["x"] + oObject["position"]["width"] / 2 >= UCF_PMServiceWebAssistant["oPageRect"]["x"] &&
		oObject["position"]["y"] + oObject["position"]["height"] / 2 >= UCF_PMServiceWebAssistant["oPageRect"]["y"] &&
		oObject["position"]["x"] + oObject["position"]["width"] / 2 <= UCF_PMServiceWebAssistant["oPageRect"]["width"] &&
		oObject["position"]["y"] + oObject["position"]["height"] / 2 <= UCF_PMServiceWebAssistant["oPageRect"]["height"]) {
		if (UCF_PMServiceWebAssistant["oLayeredControlRect"]) {
			if ((oObject["position"]["x"] + oObject["position"]["width"] / 2 <= UCF_PMServiceWebAssistant["oLayeredControlRect"]["x"] ||
					oObject["position"]["x"] + oObject["position"]["width"] / 2 >= UCF_PMServiceWebAssistant["oLayeredControlRect"]["x"] + UCF_PMServiceWebAssistant["oLayeredControlRect"]["width"]) &&
				(oObject["position"]["y"] + oObject["position"]["height"] / 2 <= UCF_PMServiceWebAssistant["oLayeredControlRect"]["y"] ||
					oObject["position"]["y"] + oObject["position"]["height"] / 2 >= UCF_PMServiceWebAssistant["oLayeredControlRect"]["y"] + UCF_PMServiceWebAssistant["oLayeredControlRect"]["height"])) {
				UCF_PMServiceWebAssistant["oArrayToSend"]["push"](oObject);
			}
		} else
			UCF_PMServiceWebAssistant["oArrayToSend"]["push"](oObject);
	}
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["assembleArray"] = 0; };

/**
 *
 * Calculates the rectangle used for table cells
 *
 * @param {Object} oTable
 * @param {Object} oObject
 * @param {Object} oControl
 * @param { Object } oDomRect
 * @return {Object}
 *
 */

UCF_PMServiceWebAssistant["oDomRectForTableCell"] = function(oTable, oObject, oControl, oDomRect) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["oDomRectForTableCell"]++; }; 
	var sHelpName = '';
	if (oObject["id"]) {
		if (oObject["id"]["dtel"])
			sHelpName = oObject["id"]["dtel"];
		else if (oObject["id"]["backendHelpKey"] && oObject["id"]["backendHelpKey"]["dtel"])
			sHelpName = oObject["id"]["backendHelpKey"]["dtel"];
		else if (oObject["id"]["ClassName"])
			sHelpName = oObject["id"]["name"];
	}
	try {
		// Search for Header Cell
		var oParent = oControl["oDomRef"]["parentNode"];
		while (oParent && oParent["getAttribute"]("ctv") !== "C" && oParent["getAttribute"]("subct") !== "STC") {
			oParent = oParent["parentNode"];
		}
		var oSTCHeader;
		if (oParent["getAttribute"]('cc') != null)
			oSTCHeader = oTable["aCellInfoMatrix"][0][parseInt(oParent["getAttribute"]('cc'))]["oDomRefCell"];
		else
			oSTCHeader = oTable["oGetHeaderCellInfoByDomRef"](oParent)["oDomRefCell"];
		if (!UCF_PMServiceWebAssistant["bHeaderCellToProcess"](oSTCHeader, oTable, oControl, oParent, sHelpName))
			return null;
		if (!(UCF_PMServiceWebAssistant["oTableHeaderCells"][oSTCHeader["id"]] &&
				UCF_PMServiceWebAssistant["oTableHeaderCells"][oSTCHeader["id"]][sHelpName])) {
			if (UCF_PMServiceWebAssistant["oTableHeaderCells"][oSTCHeader["id"]]) {
				console["log"]("First Cell Variant found: " + oSTCHeader["id"]);
			} else
				oDomRect = oSTCHeader["getBoundingClientRect"]();
			oObject["sHeaderCellId"] = oSTCHeader["id"];
			if (!UCF_PMServiceWebAssistant["oTableHeaderCells"][oSTCHeader["id"]])
				UCF_PMServiceWebAssistant["oTableHeaderCells"][oSTCHeader["id"]] = new Array();
			UCF_PMServiceWebAssistant["oTableHeaderCells"][oSTCHeader["id"]][sHelpName] = oControl["sId"];
		}
	} catch (e) {
		console["log"]("HeaderCell not found");
	}
	return oDomRect;
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["oDomRectForTableCell"] = 0; };

/**
 *
 * Chech whether headercell has to be processed
 *
 * @param { Object } oSTCHeader
 * @param { Object } oTable
 * @param { Object } oControl
 * @param { Object } oParent
 * @param { string } sHelpName
 * @return { boolean }
 *
 */

UCF_PMServiceWebAssistant["bHeaderCellToProcess"] = function(oSTCHeader, oTable, oControl, oParent, sHelpName) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["bHeaderCellToProcess"]++; }; 
	if ((UCF_PMServiceWebAssistant["oTableHeaderCells"][oSTCHeader["id"]] &&
			(UCF_PMServiceWebAssistant["oTableHeaderCells"][oSTCHeader["id"]][sHelpName]) ||
			oTable["eGetCellType"](oTable["oGetCellInfoByDomRef"](oControl["oDomRef"])) === 'HC' ||
			oTable["bIsHorizontalScrolledIntoView"](oTable["oGetCellInfoByDomRef"](oParent)) === false))
		return false;
	return true;
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["bHeaderCellToProcess"] = 0; };

/**
 *
 * Handler for the popup open/close event event
 *
 * @param {Object} oEvent
 *
 */
UCF_PMServiceWebAssistant["prototype"]["onPopupOpenClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onPopupOpenClose"]++; }; 
	if (!UCF_PMServiceWebAssistant["requestAnimationFrameId"] || UCF_PMServiceWebAssistant["requestAnimationFrameId"] === 0)
		UCF_PMServiceWebAssistant["requestAnimationFrameId"] = UCF_JsUtil["requestAnimationFrame"](UCF_PMServiceWebAssistant["sendElementsArray"]);
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["onPopupOpenClose"] = 0; };

/**
 * Retrieve the Labeltext
 *
 * @param {string} sId
 * @return {string}
 *
 */
UCF_PMServiceWebAssistant["sGetLabelFor"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["sGetLabelFor"]++; }; 
	var oLabel;
	try {
		oLabel =
			oLabel = document["querySelectorAll"]('label[for="' + sId + '"]');
		if (!oLabel || !oLabel[0])
			oLabel = document["querySelectorAll"]('label[f="' + sId + '"]');
		if (!oLabel || !oLabel[0])
			return null;
		return oLabel[0]["textContent"];
	} catch (e) {}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["sGetLabelFor"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PMServiceWebAssistant["prototype"]["aAttributeNames"] = ["sTechnology","sServiceType","sServiceName","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PMServiceWebAssistant["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PMServiceWebAssistant["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PMServiceWebAssistant["prototype"]["sTechnology"] = 'OTHER';

/**
 * @private
 * @type {string}
 */
UCF_PMServiceWebAssistant["prototype"]["sServiceType"] = 'WebAssistant';

/**
 * @private
 * @type {string}
 */
UCF_PMServiceWebAssistant["prototype"]["sServiceName"] = 'sap.webassistant.services.updateHotspots';

/**
 * @private
 * @type {string}
 */
UCF_PMServiceWebAssistant["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PMServiceWebAssistant["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["setDefaultValues"]++; }; 
	this["sTechnology"] = 'OTHER';
	this["sServiceType"] = 'WebAssistant';
	this["sServiceName"] = 'sap.webassistant.services.updateHotspots';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Technology", 'OTHER', true);
		this["setClientProperty"]("ServiceType", 'WebAssistant', true);
		this["setClientProperty"]("ServiceName", 'sap.webassistant.services.updateHotspots', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PMServiceWebAssistant["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PageHeader"] = function() {/* global _assert, _trace, INFO, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_PageHeaderTitle */
/// <reference path="./PageHeaderTitle.js"/>

/**
 * A PageHeader control that can contain PageHeaderItems
 * @class
 * 
 *
 * @param {HMTLElement} oDomRef The ROM reference
 * @param {UCF_LS} oLS The LS instance
 */
function UCF_PageHeader(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["UCF_PageHeader"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PageHeader.js(29): UCF_PageHeader"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PageHeader.js(30): UCF_PageHeader"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PageHeader.js(31): UCF_PageHeader"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["allowTextSelection"]();

};window["UCF_PageHeader"] = UCF_PageHeader; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PageHeader"); UCF_PageHeader["_"] = {UCF_PageHeader: 0}; }; ;
UCF_PageHeader["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PageHeader.prototype["sClassName"] = "UCF_PageHeader";

UCF_PageHeader["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["initialize"]++; }; 
	this["oRetrieveAndSetLogoIcon"]();
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["initialize"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 * @return { UCF_HTMLElement }
 */
UCF_PageHeader["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetInplaceEditDomRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + "-title");
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetInplaceEditDomRef"] = 0; };

/**
 *  Sets the text typed in InplaceEdit field
 * @return {string} - the text for inplaceedit
 * @see UCF_Control.sGetInplaceEditText
 */
UCF_PageHeader["prototype"]["sGetInplaceEditText"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["sGetInplaceEditText"]++; }; 
	return this["getClientProperty"]("Title") || this["sTitle"];
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["sGetInplaceEditText"] = 0; };

/**
 * Sets the text typed in InplaceEdit field
 * @param {string} sTitle - the text typed
 * @see UCF_Control.setInplaceEditDomRef
 */
UCF_PageHeader["prototype"]["setInplaceEditText"] = function(sTitle) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["setInplaceEditText"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sTitle"] = sTitle;
	this["setClientProperty"]("Title", sTitle);
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["setInplaceEditText"] = 0; };
/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageHeader["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsskipforward"]++; }; 
	/** @type {HTMLDivElement[]} */
	var aPageHeaderItemRefs = UCF_JsUtil["arrayFrom"](
		UCF_DomUtil["querySelectorAll"](
			'[id="' + this["sId"] + '"] [sub-ct="PAHI"]'
		)
	);
	/** @type {HTMLElement} */
	var oFocusDomRef = UCF_DomUtil["oGetActiveElement"]();
	/** @type {HTMLElement} */
	var oActivePageHeaderItemRef = UCF_DomUtil["oGetSubCTElement"](oFocusDomRef);
	/** @type {HTMLElement} */
	var oResult;

	// if active item is in page header title
	// move focus to the first tabbable element in the first page header item
	if (!oActivePageHeaderItemRef && aPageHeaderItemRefs && aPageHeaderItemRefs["length"] > 0) {
		oResult = UCF_DomUtil["oGetTabbableElementForward"](aPageHeaderItemRefs[0], true);
	}

	if (oResult && UCF_DomUtil["bDomElementFocused"](oResult)) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	} else {
		this["handleSkipForward"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageHeader["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsskipback"] = 0; };

/**
 * handles the mouse over event:
 * - initializes fields laizy
 * - applies hover effect, when title has menu associated
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageHeader["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onmouseover"]++; }; 

	if (window["UCF_System"]["bIs508"]) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oDomRefTitle = UCF_DomUtil["$"](this["sId"] + '-title');

	if (oSource !== oDomRefTitle) return;

	UCF_DomUtil["checkTooltip"](oDomRefTitle, this["sTooltip"], oDomRefTitle);
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onmouseover"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageHeader["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PageHeader.js(142): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSource"]();

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	if (oSource["getAttribute"]("tp") === "END") {
		oAccessibilityHelper["setControlType"]("PH_END");
	} else {
		oAccessibilityHelper["setText"](this["sTitle"]);
		oAccessibilityHelper["setControlType"]("PHM");
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsaccessibility"] = 0; };

/**
 * @see UCF_DTExtension
 * @param {UCF_HTMLElement} oDTElement the lsaccessibility
 * @return {UCF_DTExtesion} the control specific DTExtension and instance of the base class UCF_DTExtesion
 * @private
 */
UCF_PageHeader["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetDTExtension"]++; }; 
	return UCF_Control.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]("UCF_PageHeaderDTExtension"));
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetDTExtension"] = 0; };

/**
 * Returns a ControlInfo object for the given dom ref if the dom ref is a sub
 * control. The control info should contain the lsdata that has client access.
 * To be overwritten by the control that likes to return a control info based
 * on a dom ref contained in the control
 *
 * @private
 * @param {HTMLElement} oDomRef the element
 * @return {UCF_ControlInfo} The ControlInfo of a contained sub element within
 * this control.
 */
UCF_PageHeader["prototype"]["oGetContainedControlInfo"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetContainedControlInfo"]++; }; 
	var oTitleId = this["oDomRef"]["getAttribute"]("title_id");
	if (!oTitleId) return null;

	var oTitle = UCF_DomUtil["$"](oTitleId);
	if (oTitle === oDomRef && oDomRef["getAttribute"]("subct") === "PHT") {
		return new (UCF_ClassLoader["oGetClass"]("UCF_PageHeaderTitle"))(oTitle, this);
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetContainedControlInfo"] = 0; };

UCF_PageHeader["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["destroy"] = 0; };

/**
 * Makes the browser selection visible
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the selectstart
 */
UCF_PageHeader["prototype"]["onselectstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onselectstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PageHeader.js(203): onselectstart"); };
	// for touch, cancel text selection
	if (oBrowserEvent["bIsTouchInteraction"]()) {
		oBrowserEvent["oDomEvent"]["returnValue"] = false;
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}

	UCF_Control.prototype["onselectstart"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onselectstart"] = 0; };

UCF_PageHeader["prototype"]["oRetrieveAndSetLogoIcon"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oRetrieveAndSetLogoIcon"]++; }; 
	var sLogoIconUrl = this["sGetLogoIconUrl"]();
	if (!sLogoIconUrl) return;
	if (sLogoIconUrl === 'none') return;

	var oCustomLogo = UCF_DomUtil["$"](this["sId"] + '-logocustom');
	if (oCustomLogo)
		oCustomLogo["src"] = sLogoIconUrl;
	var oStandardLogo = UCF_DomUtil["$"](this["sId"] + '-logostandard');
	var oLogo = UCF_DomUtil["$"](this["sId"] + '-logo');
	UCF_DomUtil["addClass"](oStandardLogo, 'lsLogo--hidestandard');
	UCF_DomUtil["addClass"](oLogo, 'lsLogo--customlogo');
	UCF_DomUtil["removeClass"](oCustomLogo, 'lsElement--invisible');
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oRetrieveAndSetLogoIcon"] = 0; };

UCF_PageHeader["prototype"]["sGetLogoIconUrl"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["sGetLogoIconUrl"]++; }; 
	/** @type {HTMLElement} */
	var oElement;
	/** @type {string} */
	var sBackgroundImage;

	oElement = document["createElement"]('div');
	oElement["className"] = 'lsPageHeader__metadata';
	UCF_DomUtil["setStyle"](oElement, {
		"position": 'absolute',
		"top": '-10000px',
		"display": 'block',
		"height": 0,
		"width": 0
	});
	UCF_DomUtil["prepend"](document["body"], oElement);

	try {
		sBackgroundImage = decodeURIComponent(
			UCF_DomUtil["sGetCurrentStyle"](oElement, 'backgroundImage')
		);

		if (typeof oElementOrClassName === 'string') {
			UCF_DomUtil["removeFromDom"](oElement);
		}

		if (sBackgroundImage && sBackgroundImage !== 'none') {
			return sBackgroundImage["substring"](5, sBackgroundImage["length"] - 2);
		} else {
			return null;
		}
	} catch (e) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Error getting metadata from background-image of "' + oElement["className"] + '" (got: "' + sBackgroundImage + '"): ' + e["message"], "PageHeader.js(262): sGetLogoIconUrl"); };
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["sGetLogoIconUrl"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PageHeader["prototype"]["aAttributeNames"] = ["sVisibility","sTitle","sTooltip","bShowTitle","sCustomStyle","sCustomData","iHeadingLevel"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PageHeader["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PageHeader["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_PageHeader["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_PageHeader["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PageHeader["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PageHeader["prototype"]["bShowTitle"] = true;

/**
 * @private
 * @type {string}
 */
UCF_PageHeader["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PageHeader["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {number}
 */
UCF_PageHeader["prototype"]["iHeadingLevel"] = 0;

//#JSCOVER_EXCL_START
/** @protected */
UCF_PageHeader["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTitle"] = '';
	this["sTooltip"] = '';
	this["bShowTitle"] = true;
	this["sCustomStyle"] = '';
	this["sCustomData"] = '';
	this["iHeadingLevel"] = 0;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("ShowTitle", true, true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PageHeaderDTExtension"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DTExtension */
/// <reference path="./DTExtension.js"/>

/**
 * Designtime extension for PageHeader
 * 
 * @class
 * @extends UCF_DTExtension
 *
 * @param {UCF_LS} oLS LS instance
 * @param {UCF_Control} oControl Control instance
 * @param {UCF_DTElement} oDTElement DTElement instance
 */
function UCF_PageHeaderDTExtension(oLS, oControl, oDTElement) {if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["UCF_PageHeaderDTExtension"]++; }; 
	if (arguments["length"] === 0) return;
	UCF_DTExtension["apply"](this, arguments);
};window["UCF_PageHeaderDTExtension"] = UCF_PageHeaderDTExtension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PageHeaderDTExtension"); UCF_PageHeaderDTExtension["_"] = {UCF_PageHeaderDTExtension: 0}; }; ;

UCF_PageHeaderDTExtension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTExtension"))(); UCF_PageHeaderDTExtension.prototype["sClassName"] = "UCF_PageHeaderDTExtension";

/**
 * @param { string } sElementId
 * For WebGUI Personas with Belize theme the title TD is a sub-control but whole title area should be used for the DTElement
 */
UCF_PageHeaderDTExtension["prototype"]["oGetDomRefForRect"] = function(sElementId) {;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["oGetDomRefForRect"]++; }; 
	if (this["oDTElement"]["oDTContainer"]["bIsPersonasEnabled"]() && UCF_DomUtil["$"](sElementId)["getAttribute"]("subct") === "PHT") {
		return UCF_DomUtil["oGetFirstChild"](this["oControl"]["oDomRef"]);
	} else {
		return UCF_DTExtension.prototype["oGetDomRefForRect"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["oGetDomRefForRect"] = 0; };

/**
 * Tell the LS framework that this extension is also a delegate
 */
UCF_PageHeaderDTExtension["prototype"]["bIsDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["bIsDelegate"]++; }; 
	// Acivate delegate only for personas!
	return this["oDTElement"]["oDTContainer"]["bIsPersonasEnabled"]();
};;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["bIsDelegate"] = 0; };

UCF_PageHeaderDTExtension["prototype"]["onlsdragover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["onlsdragover"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, this["sToolbarId"], "PageHeaderDTExtension.js(46): onlsdragover"); };

	// Note:
	// This extension handles some events like a DnD delegate but does NOT inherit from Drag/DropDelegate base classes
	// which contain DnD framework coding necessary e.g. for proper Tag matching => We have to copy some code from the DropDelegate here...
	if (this["oGetDropTargetInfoId"]()) {
		var sDropTags = this["sGetDropTags"](oBrowserEvent),
			sValidMimeTypes = this["sGetValidMimeTypes"](oBrowserEvent),
			oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
			bEventBubbling = this["bGetEventBubbling"](oBrowserEvent);
		if (!oDragAndDropManager["bGetDropAllowed"](sDropTags, sValidMimeTypes)) {
			if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
			return;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["onlsdragover"] = 0; };

UCF_PageHeaderDTExtension["prototype"]["onlsdrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["onlsdrop"]++; }; 
	if (!oBrowserEvent["oDragAndDropManager"]["oDragSession"]) return;

	var oDraggedDTElement = this["oLS"]["oGetControlById"](oBrowserEvent["oDragAndDropManager"]["oDragSession"]["sDragSourceId"]);
	if (!oDraggedDTElement) return;

	this["oDTElement"]["oDTContainer"]["fireDrop"](
		this["oDTElement"]["oDTContainer"]["sId"],
		oDraggedDTElement["sGetId"](),
		this["oDTElement"]["sId"],
		"",
		"",
		"",
		"",
		"",
		0,
		oBrowserEvent["oDragAndDropManager"]["oDragSession"]["oGetDropPosition"]()["left"], //iPosX
		oBrowserEvent["oDragAndDropManager"]["oDragSession"]["oGetDropPosition"]()["top"], //iPosY
		0,
		-1,
		-1,
		-1,
		-1
	);

	oBrowserEvent["bHandled"] = true;
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["onlsdrop"] = 0; };

// This is a copy of DropDelegate code, because we do not inherit from it

UCF_PageHeaderDTExtension["prototype"]["sGetDropTags"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["sGetDropTags"]++; }; 

	var oDropTargetControl = this["oDTElement"],
		sDropTargetInfoId = this["oGetDropTargetInfoId"](oBrowserEvent);
	if (!sDropTargetInfoId)
		return "";

	var oDropTargetInfoControl = oDropTargetControl["oGetControlById"](sDropTargetInfoId);
	if (!oDropTargetInfoControl)
		return "";

	var sDropTags = oDropTargetInfoControl["sGetTags"]();
	if (!sDropTags)
		return "";

	return sDropTags;
};;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["sGetDropTags"] = 0; };

UCF_PageHeaderDTExtension["prototype"]["sGetValidMimeTypes"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["sGetValidMimeTypes"]++; }; 
	var oDropTargetControl = this["oDTElement"],
		sDropTargetInfoId = this["oGetDropTargetInfoId"](oBrowserEvent);
	if (!sDropTargetInfoId) {
		return "";
	}
	var oDropTargetInfoControl = oDropTargetControl["oGetControlById"](sDropTargetInfoId);
	if (!oDropTargetInfoControl) {
		return "";
	}
	var sValidMimeTypes = oDropTargetInfoControl["sGetValidMimeTypes"]();
	if (!sValidMimeTypes) {
		return "";
	}
	return sValidMimeTypes;
};;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["sGetValidMimeTypes"] = 0; };

UCF_PageHeaderDTExtension["prototype"]["oGetDropTargetInfoId"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["oGetDropTargetInfoId"]++; }; 
	return this["oDTElement"]["sDropTargetInfo"] || this["oDTElement"]["sDropTargetInfoTop"];
};;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["oGetDropTargetInfoId"] = 0; };

UCF_PageHeaderDTExtension["prototype"]["bGetEventBubbling"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["bGetEventBubbling"]++; }; 
	if (!this["oDropTargetControl"]) this["oDropTargetControl"] = this["oDTElement"];
	if (this["oDropTargetControl"]) {
		if (!this["oDropTargetInfoControl"]) {
			if (this["oGetDropTargetInfoId"](oBrowserEvent)) {
				this["oDropTargetInfoControl"] = this["oDropTargetControl"]["oGetControlById"](this["oGetDropTargetInfoId"](oBrowserEvent));
				if (this["oDropTargetInfoControl"]) return this["oDropTargetInfoControl"]["bGetEventBubbling"]();
				else return true;
			} else return true;
		} else return this["oDropTargetInfoControl"]["bGetEventBubbling"]();
	} else return true;
};;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["bGetEventBubbling"] = 0; };

UCF_PageHeaderDTExtension["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["destroy"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "D E S T R O Y: " + this["sToolbarId"], "PageHeaderDTExtension.js(148): destroy"); };

	this["oDropTargetControl"] = null;
	this["oDropTargetInfoControl"] = null;
	UCF_DTExtension.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PageHeaderDTExtension["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_PageHeaderTitle"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Interface */
/// <reference path="../../core/Interface.js"/>
/* global UCF_ControlInfo */
/// <reference path="../core/ControlInfo.js"/>
/* global UCF_PageHeader */
/// <reference path="./PageHeader.js"/>

/**
 * Sub-control for PageHeader title area.
 * @param {HTMLElement} oDomRef DOM reference
 * @param {UCF_PageHeader} oPageHeader The control reference
 * @class
 */
function UCF_PageHeaderTitle(oDomRef, oPageHeader) {if (__UCF_COVERAGE__) { UCF_PageHeaderTitle["_"]["UCF_PageHeaderTitle"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PageHeaderTitle.js(19): UCF_PageHeaderTitle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PageHeaderTitle.js(20): UCF_PageHeaderTitle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oPageHeader instanceof UCF_PageHeader, "oPageHeader instanceof UCF_PageHeader", "PageHeaderTitle.js(21): UCF_PageHeaderTitle"); };

	UCF_ControlInfo["apply"](this, [oDomRef, oPageHeader["oLS"]]);

	// eslint-disable-next-line @ur/no-memory-leaks
	this["oPageHeader"] = oPageHeader;
};window["UCF_PageHeaderTitle"] = UCF_PageHeaderTitle; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PageHeaderTitle"); UCF_PageHeaderTitle["_"] = {UCF_PageHeaderTitle: 0}; }; ;
UCF_PageHeaderTitle["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ControlInfo"))(); UCF_PageHeaderTitle.prototype["sClassName"] = "UCF_PageHeaderTitle";

/**
 * Returns an interface for this sub-control and includes the UCF_ControlInfo public methods.
 * @private
 * @param {string[]} aMethodNames
 * @return {UCF_Interface} The interface.
 */
UCF_PageHeaderTitle["prototype"]["oGetInterface"] = function(aMethodNames) {;if (__UCF_COVERAGE__) { UCF_PageHeaderTitle["_"]["oGetInterface"]++; }; 
	var aUseMethodNames = aMethodNames || this["aPublicMethods"] || [];

	aUseMethodNames = aUseMethodNames["concat"](UCF_ControlInfo["prototype"]["aPublicMethods"]);

	return new (UCF_ClassLoader["oGetClass"]("UCF_Interface"))(this, aUseMethodNames);
};;if (__UCF_COVERAGE__) { UCF_PageHeaderTitle["_"]["oGetInterface"] = 0; };

UCF_PageHeaderTitle["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeaderTitle["_"]["destroy"]++; }; 

	UCF_ControlInfo.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PageHeaderTitle["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PageHeaderTitle["prototype"]["aAttributeNames"] = ["sTitle","sTooltip","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PageHeaderTitle["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PageHeaderTitle["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PageHeaderTitle["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PageHeaderTitle["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PageHeaderTitle["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PageHeaderTitle["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeaderTitle["_"]["setDefaultValues"]++; }; 
	this["sTitle"] = '';
	this["sTooltip"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeaderTitle["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PageLayout"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>

/**
 * 
 * @version 1.0.0.0
 *
 * @class
 * @extends UCF_Control
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PageLayout(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["UCF_PageLayout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PageLayout.js(26): UCF_PageLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PageLayout.js(27): UCF_PageLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PageLayout.js(28): UCF_PageLayout"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_PageLayout"] = UCF_PageLayout; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PageLayout"); UCF_PageLayout["_"] = {UCF_PageLayout: 0}; }; ;
UCF_PageLayout["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PageLayout.prototype["sClassName"] = "UCF_PageLayout";

/**
 * Handle hotkey events
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_PageLayout["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["onlshotkey"]++; }; 
	if (this["sHotkeysId"] === '') return;

	var oHotkeys = this["oGetControlById"](this["sHotkeysId"]);
	if (oHotkeys == null) return;

	var oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["onlshotkey"] = 0; };

UCF_PageLayout["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]("UCF_Hotkeys")["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["onkeypress"] = 0; };

/** Accessiblity
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_PageLayout["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PageLayout.js(73): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setControlType"]('PL');
	oAccessibilityHelper["applyContainerEntryBehaviour"]();
};;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["onlsaccessibility"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageLayout["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PageLayout.js(90): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageLayout["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PageLayout.js(102): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
  oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["onlsskipback"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PageLayout["prototype"]["aAttributeNames"] = ["sHotkeysId","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PageLayout["prototype"]["aEventNames"] = ["Hotkey"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PageLayout["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PageLayout["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PageLayout["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PageLayout["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PageLayout["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["setDefaultValues"]++; }; 
	this["sHotkeysId"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires PageLayout::Hotkey
 */
UCF_PageLayout["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PageLayout.js(174): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PageLayout.js(175): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PageLayout.js(176): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "PageLayout.js(177): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "PageLayout.js(178): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "PageLayout.js(179): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "PageLayout.js(180): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	
	if (sProviderId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sProviderId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ProviderId");
			}
		}
	this["fireSemanticEvent"]("PageLayout", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PageLayout["_"]["fireHotkey"] = 0; };

};
sap["ls"]["preload"]["UCF_PageLayoutPanel"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PageLayoutPanel(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PageLayoutPanel["_"]["UCF_PageLayoutPanel"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PageLayoutPanel.js(17): UCF_PageLayoutPanel"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PageLayoutPanel.js(18): UCF_PageLayoutPanel"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PageLayoutPanel.js(19): UCF_PageLayoutPanel"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_PageLayoutPanel"] = UCF_PageLayoutPanel; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PageLayoutPanel"); UCF_PageLayoutPanel["_"] = {UCF_PageLayoutPanel: 0}; }; ;
UCF_PageLayoutPanel["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PageLayoutPanel.prototype["sClassName"] = "UCF_PageLayoutPanel";

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageLayoutPanel["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageLayoutPanel["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PageLayoutPanel["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageLayoutPanel["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageLayoutPanel["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PageLayoutPanel["_"]["onlsskipback"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PageLayoutPanel["prototype"]["aAttributeNames"] = ["sCustomData","sAccessibilityDescription"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PageLayoutPanel["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PageLayoutPanel["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PageLayoutPanel["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PageLayoutPanel["prototype"]["sAccessibilityDescription"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PageLayoutPanel["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PageLayoutPanel["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';
	this["sAccessibilityDescription"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PageLayoutPanel["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Pager"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ScrollBase */
/// <reference path="./base/ScrollBase.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Pager(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Pager["_"]["UCF_Pager"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Pager.js(31): UCF_Pager"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Pager.js(32): UCF_Pager"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Pager.js(33): UCF_Pager"); };

	UCF_ScrollBase["apply"](this, [oDomRef, oLS]);

	this["iPageOffset"] = 0;
	if (this["iItemsPerPage"] > 1) this["iPageOffset"] = parseInt(((this["iFirstVisibleItem"] + this["iItemsPerPage"]) % this["iItemsPerPage"]) - 1);
	this["iLastVisibleItem"] = this["iFirstVisibleItem"] + this["iItemsPerPage"];
	//if (this.iLastVisibleItem > this.iItemCount) this.iLastVisibleItem = this.iItemCount;
	this["iSelectedStartPage"] = parseInt(((this["iFirstVisibleItem"] - 1) / this["iItemsPerPage"]) + 1);
	this["iSelectedEndPage"] = parseInt(((this["iLastVisibleItem"] - 1) / this["iItemsPerPage"]) + 1);

	this["iSelectedPage"] = parseInt(((this["iFirstVisibleItem"] - 1) / this["iItemsPerPage"]) + 1);

	this["calculateClientSide"]();

	this["iOldStartIndex"] = this["iStartIndex"];
	this["iOldEndIndex"] = this["iEndIndex"];
	this["iOldMaximumIndex"] = this["iMaximumIndex"];
	this["iOldVisiblePagePickerCount"] = this["iVisiblePagePickerCount"];
	this["iOldItemsPerPage"] = this["iItemsPerPage"];
	// eslint-disable-next-line @ur/no-memory-leaks
	this["mNotificationMode"] = this["NOTIFICATION"]["AUTO"];

	this["oDomRef"] = oDomRef;

	this["initTouchSupport"]();

};window["UCF_Pager"] = UCF_Pager; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Pager"); UCF_Pager["_"] = {UCF_Pager: 0}; }; ;

UCF_Pager["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollBase"))(); UCF_Pager.prototype["sClassName"] = "UCF_Pager";

/**
 * Destructor
 *
 * @private
 */
UCF_Pager["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["destroy"]++; }; 

	UCF_JsUtil["resetMassNotificationFilter"](this);
	this["mNotificationMode"] = this["NOTIFICATION"]["AUTO"];

	this["iPageOffset"] = null;
	this["iLastVisibleItem"] = null;
	this["iSelectedStartPage"] = null;
	this["iSelectedEndPage"] = null;
	this["iSelectedPage"] = null;

	this["iOldStartIndex"] = null;
	this["iOldEndIndex"] = null;
	this["iOldMaximumIndex"] = null;
	this["iOldVisiblePagePickerCount"] = null;
	this["iOldItemsPerPage"] = null;
	this["iOldSelectedPage"] = null;

	this["iStartIndex"] = null;
	this["iEndIndex"] = null;
	this["iMaximumIndex"] = null;

	this["iVisiblePagePickerCount"] = null;
	this["iFirstVisibleItemLastPage"] = null;

	UCF_ScrollBase.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["destroy"] = 0; };

/**
 * Calculates parameter at client side
 *
 * @private
 */
UCF_Pager["prototype"]["calculateClientSide"] = function() {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["calculateClientSide"]++; }; 

	//return if this.iItemsPerPage == 0 or this.iItemCount == 0
	if (this["iItemsPerPage"] === 0 || this["iItemCount"] === 0) return;

	this["iStartIndex"] = 0;
	this["iEndIndex"] = 0;
	this["iMaximumIndex"] = 0;
	this["iVisiblePagePickerCount"] = 0;

	this["iMaximumIndex"] = parseInt(this["iItemCount"] / this["iItemsPerPage"]);
	if ((this["iItemCount"] % this["iItemsPerPage"]) > 0) {
		this["iMaximumIndex"]++;
	}

	this["iStartIndex"] = this["iSelectedPage"] - parseInt(this["iPagePickerCount"] / 2);
	if (this["iStartIndex"] < 1) {
		this["iStartIndex"] = 1;
	}

	this["iEndIndex"] = this["iStartIndex"] + this["iPagePickerCount"] - 1;
	if (this["iEndIndex"] > this["iMaximumIndex"]) {
		this["iEndIndex"] = this["iMaximumIndex"];
		this["iStartIndex"] = this["iEndIndex"] - this["iPagePickerCount"] + 1;
	}

	if (this["iStartIndex"] < 1) {
		this["iStartIndex"] = 1;
	}

	if (this["iEndIndex"] > this["iMaximumIndex"]) {
		this["iEndIndex"] = this["iMaximumIndex"];
	}

	this["iVisiblePagePickerCount"] = this["iEndIndex"] - this["iStartIndex"] + 1;

	if (this["iMaximumIndex"] < 2) {
		this["bVisible"] = false;
	} else {
		this["bVisible"] = true;
	}

	this["iFirstVisibleItemLastPage"] = ((this["iMaximumIndex"] - 1) * this["iItemsPerPage"]) + 1;

};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["calculateClientSide"] = 0; };

/**
 * Renders the control at client side
 *
 * @private
 */
UCF_Pager["prototype"]["renderClientSide"] = function() {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["renderClientSide"]++; }; 

	var oLoopDomRef = null,
		oLoopChildDomRef = null,
		iLoopIndex = this["iStartIndex"];

	if (this["iItemsPerPage"] === 0 || this["iItemCount"] === 0) {
		UCF_DomUtil["setVisibility"](this["oDomRef"], "NONE");
		return;
	} else {
		UCF_DomUtil["setVisibility"](this["oDomRef"], "VISIBLE");
	}

	oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-Begin");
	if (this["iMaximumIndex"] > this["iPagePickerCount"]) {
		UCF_DomUtil["setVisibility"](oLoopDomRef, "VISIBLE");
	} else {
		UCF_DomUtil["setVisibility"](oLoopDomRef, "NONE");
	}

	oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-End");
	if (this["iMaximumIndex"] > this["iPagePickerCount"]) {
		UCF_DomUtil["setVisibility"](oLoopDomRef, "VISIBLE");
		// Modify MaximumIndex
		if (this["iOldMaximumIndex"] !== this["MaximumIndex"]) {
			oLoopChildDomRef = UCF_DomUtil["oGetFirstChild"](oLoopDomRef);
			UCF_DomUtil["setInnerText"](oLoopChildDomRef, String(this["iMaximumIndex"]));
		}
	} else {
		UCF_DomUtil["setVisibility"](oLoopDomRef, "NONE");
	}

	if (this["iOldVisiblePagePickerCount"] > this["iVisiblePagePickerCount"]) {
		for (var i = this["iVisiblePagePickerCount"] + 1; i <= this["iOldVisiblePagePickerCount"]; i++) {
			oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-" + i);
			UCF_DomUtil["setVisibility"](oLoopDomRef, "NONE");
		}
	} else {
		for (var j = this["iOldVisiblePagePickerCount"] + 1; j <= this["iVisiblePagePickerCount"]; j++) {
			oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-" + j);
			UCF_DomUtil["setVisibility"](oLoopDomRef, "VISIBLE");
		}
	}

	if (this["iVisiblePagePickerCount"] < 2 || this["iItemsPerPage"] === 0) {
		oLoopDomRef = UCF_DomUtil["$"](this["sId"]);
		UCF_DomUtil["setVisibility"](oLoopDomRef, "NONE");
	} else {
		oLoopDomRef = UCF_DomUtil["$"](this["sId"]);
		UCF_DomUtil["setVisibility"](oLoopDomRef, "VISIBLE");
	}

	for (var k = 1; k <= this["iPagePickerCount"]; k++) {
		oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-" + k);
		oLoopChildDomRef = UCF_DomUtil["oGetFirstChild"](oLoopDomRef);
		UCF_DomUtil["setInnerText"](oLoopChildDomRef, String(iLoopIndex));
		//ARIA1.1
		if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
			oLoopDomRef["setAttribute"]('aria-label', String(iLoopIndex));
		}

		//first of all enable all links
		UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnkDsbl", "urPGRLnk");
		UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnkDsblBrd", "urPGRLnkReport");
		UCF_DomUtil["setTabIndex"](oLoopDomRef, 0);
		UCF_DomUtil["replaceClass"](oLoopChildDomRef, "urPGRLnkDsblBg", "urPGRLnkBg");
		if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
			UCF_AriaStateHelper["setOrRemoveAttribute"](oLoopDomRef, 'aria-current');
		}

		//then disable according to current state
		if (iLoopIndex === this["iSelectedPage"]) {
			if (this["iPageOffset"] === 0) {
				UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnk", "urPGRLnkDsbl");
				UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnkReport", "urPGRLnkDsblBrd");
				if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
					UCF_AriaStateHelper["setCurrent"](oLoopDomRef, true);
				}
				if (window["UCF_System"]["bIs508"] || window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
					UCF_DomUtil["setTabIndex"](oLoopDomRef, 0);
				} else {
					UCF_DomUtil["setTabIndex"](oLoopDomRef, -1);
				}
				UCF_DomUtil["replaceClass"](oLoopChildDomRef, "urPGRLnkBg", "urPGRLnkDsblBg");
			}
		}

		if (iLoopIndex === 1 && (this["iFirstVisibleItem"] === 1)) {
			UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnk", "urPGRLnkDsbl");
			UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnkReport", "urPGRLnkDsblBrd");
			//if (!UCF_System.bIs508) UCF_DomUtil.setTabIndex(oLoopDomRef, -1);
			if (window["UCF_System"]["bIs508"] || window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
				UCF_DomUtil["setTabIndex"](oLoopDomRef, 0);
			} else {
				UCF_DomUtil["setTabIndex"](oLoopDomRef, -1);
			}
			UCF_DomUtil["replaceClass"](oLoopChildDomRef, "urPGRLnkBg", "urPGRLnkDsblBg");
		}

		if ((iLoopIndex === this["iMaximumIndex"]) && (this["iLastVisibleItem"] >= this["iItemCount"]) && (this["iFirstVisibleItem"] <= this["iFirstVisibleItemLastPage"])) {
			UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnk", "urPGRLnkDsbl");
			UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnkReport", "urPGRLnkDsblBrd");
			if (window["UCF_System"]["bIs508"] || window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
				UCF_DomUtil["setTabIndex"](oLoopDomRef, 0);
			} else {
				UCF_DomUtil["setTabIndex"](oLoopDomRef, -1);
			}
			//if (!UCF_System.bIs508) UCF_DomUtil.setTabIndex(oLoopDomRef, -1);
			UCF_DomUtil["replaceClass"](oLoopChildDomRef, "urPGRLnkBg", "urPGRLnkDsblBg");
		}

		iLoopIndex++;
	}

	//first of all enable all links
	oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-Begin");
	oLoopChildDomRef = UCF_DomUtil["oGetFirstChild"](oLoopDomRef);
	UCF_DomUtil["setClass"](oLoopDomRef, "urPGR urPGRLnk urPGRLnkReport");
	UCF_DomUtil["setTabIndex"](oLoopDomRef, 0);
	UCF_DomUtil["replaceClass"](oLoopChildDomRef, "urPGRLnkDsblBg", "urPGRLnkBg");
	if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
		UCF_AriaStateHelper["setOrRemoveAttribute"](oLoopDomRef, 'aria-hidden');
	}

	oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-btn-PrevPage");
	UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRPrevPageDsbl", "urPGRPrevPage");
	UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnkDsbl", "urPGRLnkReport");
	UCF_DomUtil["setTabIndex"](oLoopDomRef, 0);
	if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
		UCF_AriaStateHelper["setDisabled"](oLoopDomRef, false);
	}

	oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-End");
	oLoopChildDomRef = UCF_DomUtil["oGetFirstChild"](oLoopDomRef);
	UCF_DomUtil["setClass"](oLoopDomRef, "urPGR urPGRLnk urPGRLnkReport");
	UCF_DomUtil["setTabIndex"](oLoopDomRef, 0);
	UCF_DomUtil["replaceClass"](oLoopChildDomRef, "urPGRLnkDsblBg", "urPGRLnkBg");
	if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
		UCF_AriaStateHelper["setOrRemoveAttribute"](oLoopDomRef, 'aria-hidden');
	}

	oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-btn-NxtPage");
	UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRNxtPageDsbl", "urPGRNxtPage");
	UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnkDsbl", "urPGRLnkReport");
	UCF_DomUtil["setTabIndex"](oLoopDomRef, 0);
	if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
		UCF_AriaStateHelper["setDisabled"](oLoopDomRef, false);
	}

	//then disable according to current state
	//if (this.iSelectedPage == 1 || this.iFirstVisibleItem == 1) {
	if (this["iFirstVisibleItem"] === 1) {
		oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-Begin");
		oLoopChildDomRef = UCF_DomUtil["oGetFirstChild"](oLoopDomRef);
		UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnk", "urPGRLnkDsbl");
		UCF_DomUtil["removeClass"](oLoopDomRef, "urPGRLnkReport");
		if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
			UCF_AriaStateHelper["setOrRemoveAttribute"](oLoopDomRef, 'aria-hidden', true);
		}
		if (!window["UCF_System"]["bIs508"]) UCF_DomUtil["setTabIndex"](oLoopDomRef, -1);

		oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-btn-PrevPage");
		UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRPrevPage", "urPGRPrevPageDsbl");
		UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnkReport", "urPGRLnkDsbl");
		if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
			UCF_AriaStateHelper["setDisabled"](oLoopDomRef, true);
		}
		if (!window["UCF_System"]["bIs508"]) UCF_DomUtil["setTabIndex"](oLoopDomRef, -1);
	}

	//if (this.iSelectedPage == this.iMaximumIndex || this.iLastVisibleItem >= this.iItemCount) {
	if (this["iLastVisibleItem"] >= this["iItemCount"]) {
		oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-End");
		oLoopChildDomRef = UCF_DomUtil["oGetFirstChild"](oLoopDomRef);
		UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnk", "urPGRLnkDsbl");
		UCF_DomUtil["removeClass"](oLoopDomRef, "urPGRLnkReport");
		if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
			UCF_AriaStateHelper["setOrRemoveAttribute"](oLoopDomRef, 'aria-hidden', true);
		}
		if (!window["UCF_System"]["bIs508"]) UCF_DomUtil["setTabIndex"](oLoopDomRef, -1);

		oLoopDomRef = UCF_DomUtil["$"](this["sId"] + "-btn-NxtPage");
		UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRNxtPage", "urPGRNxtPageDsbl");
		UCF_DomUtil["replaceClass"](oLoopDomRef, "urPGRLnkReport", "urPGRLnkDsbl");
		if (window["UCF_System"]["sAccessibility"] === "ARIA1.1") {
			UCF_AriaStateHelper["setDisabled"](oLoopDomRef, true);
		}
		if (!window["UCF_System"]["bIs508"]) UCF_DomUtil["setTabIndex"](oLoopDomRef, -1);
	}

	this["iOldStartIndex"] = this["iStartIndex"];
	this["iOldEndIndex"] = this["iEndIndex"];
	this["iOldMaximumIndex"] = this["iMaximumIndex"];
	this["iOldVisiblePagePickerCount"] = this["iVisiblePagePickerCount"];
	this["iOldItemsPerPage"] = this["iItemsPerPage"];

};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["renderClientSide"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Pager["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Pager.js(358): onclick"); };

	// don't handle onclick on control instance
	if (oBrowserEvent["oSource"]["className"] === "urPGR") return;
	this["handlePageSelect"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onclick"] = 0; };
/**
 * Handles the onlsselect event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Pager["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Pager.js(374): onlsselect"); };

	this["handlePageSelect"](oBrowserEvent, this["ACCESS_TYPE"]["KEYBOARD"]);
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlsselect"] = 0; };

/**
 * Handles the onlsmousewheel event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_Pager["prototype"]["onlsmousewheel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlsmousewheel"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Pager.js(388): onlsmousewheel"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oBrowserEvent) === "object", "typeof(oBrowserEvent) === \"object\"", "Pager.js(389): onlsmousewheel"); };

	if (!this["bVisible"]) return;
	this["handlePageSelect"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE_WHEEL"]);
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlsmousewheel"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object

 * @private
 */
UCF_Pager["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlstouchstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Pager.js(405): onlstouchstart"); };

	if (!this["bVisible"]) return;
	if (UCF_DomUtil["bContains"](this["oDomRef"], oBrowserEvent["oGetSource"]())) return;

	this["handlePageSelect"](oBrowserEvent, this["ACCESS_TYPE"]["TOUCH_START"]);
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlstouchstart"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_Pager["prototype"]["onlstouchmove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlstouchmove"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Pager.js(420): onlstouchmove"); };

	if (!this["bVisible"]) return;
	if (UCF_DomUtil["bContains"](this["oDomRef"], oBrowserEvent["oGetSource"]())) return;

	this["handlePageSelect"](oBrowserEvent, this["ACCESS_TYPE"]["TOUCH_MOVE"]);
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlstouchmove"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_Pager["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlstouchend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Pager.js(435): onlstouchend"); };

	if (!this["bVisible"]) return;
	if (UCF_DomUtil["bContains"](this["oDomRef"], oBrowserEvent["oGetSource"]())) return;

	this["handlePageSelect"](oBrowserEvent, this["ACCESS_TYPE"]["TOUCH_END"]);
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlstouchend"] = 0; };

/**
 * Handles the actions if a new page has been selected
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @param {int} eAccessType the AccessType specified in ScrollBase.js
 * @param {Object} oAccessInfo
 * @private
 */
UCF_Pager["prototype"]["handlePageSelect"] = function(oBrowserEvent, eAccessType, oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["handlePageSelect"]++; }; 
	var bNotify = true;
	var iLastSelectedPage;

	this["iOldSelectedPage"] = this["iSelectedPage"];

	if (eAccessType === this["ACCESS_TYPE"]["EXTERNAL"]) {
		this["handleExternalEvent"](oAccessInfo);
	} else if (eAccessType === this["ACCESS_TYPE"]["MOUSE"] || eAccessType === this["ACCESS_TYPE"]["KEYBOARD"]) {
		this["selectPageByDomRef"](oBrowserEvent["oGetSource"]());
		this["iPageOffset"] = 0;
	} else if (eAccessType === this["ACCESS_TYPE"]["MOUSE_WHEEL"]) {
		iLastSelectedPage = this["iSelectedPage"];
		if (oBrowserEvent["iWheelDelta"]() < 0) {
			if (this["iPageOffset"] === 0) {
				if (this["iSelectedPage"] < this["iMaximumIndex"]) this["iSelectedPage"]++;
			} else {
				if (this["iLastVisibleItem"] < this["iItemCount"]) {
					this["iSelectedPage"] = this["iSelectedEndPage"];
					this["iOldSelectedPage"] = this["iSelectedPage"] - 1;
				}
			}
		} else {
			if (this["iPageOffset"] === 0) {
				if (this["iSelectedPage"] > 1) this["iSelectedPage"]--;
			} else {
				if (this["iFirstVisibleItem"] > 1) {
					this["iSelectedPage"] = this["iSelectedStartPage"];
					this["iOldSelectedPage"] = this["iSelectedPage"] + 1;
				}
			}
		}
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iFirstVisibleItem"] = ((this["iSelectedPage"] - 1) * this["iItemsPerPage"]) + 1;
		this["setClientProperty"]("FirstVisibleItem", this["iFirstVisibleItem"], true);
		this["iLastVisibleItem"] = this["iFirstVisibleItem"] - 1 + this["iItemsPerPage"];

		this["iPageOffset"] = 0;

		//cancel browserEvent if handled to avoid parallel scolling
		if (iLastSelectedPage !== this["iSelectedPage"]) {
			oBrowserEvent["cancel"]();
		}
	} else if (eAccessType === this["ACCESS_TYPE"]["TOUCH_START"] || eAccessType === this["ACCESS_TYPE"]["TOUCH_MOVE"] || eAccessType === this["ACCESS_TYPE"]["TOUCH_END"]) {
		iLastSelectedPage = this["iSelectedPage"];

		this["selectPageBySwipe"](oBrowserEvent, eAccessType);

		this["iPageOffset"] = 0;

		//cancel browserEvent if handled to avoid parallel scolling
		if (iLastSelectedPage !== this["iSelectedPage"]) {
			oBrowserEvent["cancel"]();
		}
	}
	//update client side
	this["calculateClientSide"]();
	this["renderClientSide"]();

	// fire semantic Event
	this["fireSelect"](this["sId"], this["iSelectedPage"]);
	// fire internal Event
	this["iFirstVisibleItem"] = parseInt(((this["iSelectedPage"] - 1) * this["iItemsPerPage"]) + 1);
	this["setClientProperty"]("FirstVisibleItem", this["iFirstVisibleItem"], true);
	var eAccessSource = "PAGER";
	if (!oAccessInfo) {
		oAccessInfo = this["oCreateAccessInfoByInternal"](this["iOldSelectedPage"], this["iSelectedPage"]);
	}
	if (eAccessType === this["ACCESS_TYPE"]["MOUSE_WHEEL"]) {
		UCF_JsUtil["feedMassNotificationFilter"](700, this, this, "fireInternalScrollEvent", [this["iFirstVisibleItem"], oAccessInfo["eAction"], eAccessSource, oAccessInfo["eAccessType"], oAccessInfo["mModifier"]]);
	}

	if (this["mNotificationMode"] === this["NOTIFICATION"]["ALWAYS_WHEN_CHANGED"] || this["mNotificationMode"] === this["NOTIFICATION"]["ALWAYS"]) bNotify = true;
	else if (this["mNotificationMode"] === this["NOTIFICATION"]["NEVER"]) bNotify = false;

	if (bNotify) this["fireInternalScrollEvent"](this["iFirstVisibleItem"], oAccessInfo["eAction"], eAccessSource, oAccessInfo["eAccessType"], oAccessInfo["mModifier"]);

	if (eAccessType !== this["ACCESS_TYPE"]["EXTERNAL"]) oBrowserEvent["cancelBubble"]();

	// refocus to update acc information
	if (eAccessType !== this["ACCESS_TYPE"]["EXTERNAL"]) UCF_DomUtil["refocusDomElement"](oBrowserEvent["oGetSource"]());
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["handlePageSelect"] = 0; };

/**
 * Selects the current page by DomRef
 *
 * @param {element} oDomRef
 * @private
 */
UCF_Pager["prototype"]["selectPageByDomRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["selectPageByDomRef"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Pager.js(542): selectPageByDomRef"); };

	var sClassName = oDomRef["className"],
		sDomRefId = oDomRef["getAttribute"]("id"),
		bEnabled = !UCF_StringUtil["bContains"](sClassName, "Dsbl", false);

	if (bEnabled) {
		if (UCF_StringUtil["bContains"](sDomRefId, "PrevPage", false)) {
			if (this["iPageOffset"] === 0) this["iSelectedPage"]--;
			else {
				this["iSelectedPage"] = this["iSelectedEndPage"] - 1;
			}
		} else if (UCF_StringUtil["bContains"](sDomRefId, "NxtPage", false)) {
			if (this["iPageOffset"] === 0) this["iSelectedPage"]++;
			else {
				this["iSelectedPage"] = this["iSelectedStartPage"] + 1;
			}
		} else if (UCF_StringUtil["bContains"](sDomRefId, "-BG", false)) {
			this["iSelectedPage"] = parseInt(oDomRef["innerHTML"], 10);
		} else {
			this["iSelectedPage"] = parseInt(UCF_DomUtil["oGetFirstChild"](oDomRef)["innerHTML"], 10);
		}

		this["iFirstVisibleItem"] = ((this["iSelectedPage"] - 1) * this["iItemsPerPage"]) + 1;
		this["setClientProperty"]("FirstVisibleItem", this["iFirstVisibleItem"], true);
		this["iLastVisibleItem"] = this["iFirstVisibleItem"] - 1 + this["iItemsPerPage"];
	}
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["selectPageByDomRef"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Pager["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Pager.js(580): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		sClassName = oSource["className"],
		sDomRefId = oSource["getAttribute"]("id"),
		bEnabled = !UCF_StringUtil["bContains"](sClassName, "Dsbl", false),
		sControlType = null,
		iToPage = -1;

	if (UCF_StringUtil["bContains"](sDomRefId, "PrevPage", false)) {
		sControlType = "PGRI_P";
		iToPage = this["iSelectedPage"] - 1;
	} else if (UCF_StringUtil["bContains"](sDomRefId, "NxtPage", false)) {
		sControlType = "PGRI_N";
		iToPage = this["iSelectedPage"] + 1;
	} else if (UCF_StringUtil["bContains"](sDomRefId, "-BG", false)) {
		sControlType = "PGRI";
		iToPage = parseInt(oSource["innerHTML"], 10);
	} else {
		sControlType = "PGRI";
		iToPage = parseInt(UCF_DomUtil["oGetFirstChild"](oSource)["innerHTML"], 10);
	}

	oAccessibilityHelper["setControlType"](sControlType);

	oAccessibilityHelper["setValue"](oAccessibilityHelper["sGetText"]("PGR_PAGENR", [iToPage]));

	//oAccessibilityHelper.setCustomStatusText("PGR_PAGENR", [iToPage]);
	if (bEnabled) {
		oAccessibilityHelper["addTutor"]("PGR_TUT");
	} else {
		oAccessibilityHelper["setSelected"](true);

	}
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["onlsaccessibility"] = 0; };

/**
 * Create access info external
 *
 * @param {ACTION} eAction
 * @param {int} mModifier
 * @param {int} iPosition
 * @return {Array}
 */
UCF_Pager["prototype"]["oCreateAccessInfoByExternal"] = function(eAction, mModifier, iPosition) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["oCreateAccessInfoByExternal"]++; }; 
	return {
		"oBrowserEvent": null,
		"eAccessType": this["ACCESS_TYPE"]["EXTERNAL"],
		"sAccessFragmentType": null,
		"oAccessFragmentDomRef": null,
		"eAction": eAction,
		"bHandled": false,
		"mModifier": (mModifier ? mModifier : UCF_JsUtil["MODIFIER"]["NONE"]),
		"iPosition": (iPosition ? iPosition : 0)
	};
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["oCreateAccessInfoByExternal"] = 0; };

/**
 * Create access info internal
 *
 * @param {int} iOldSelectedPage
 * @param {int} iSelectedPage
 * @return {Array}
 */
UCF_Pager["prototype"]["oCreateAccessInfoByInternal"] = function(iOldSelectedPage, iSelectedPage) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["oCreateAccessInfoByInternal"]++; }; 
	var eAction;
	if (iSelectedPage === 1) {
		eAction = this["ACTION"]["BEGIN"];
	} else if (iSelectedPage = this["iMaximumIndex"]) {
		eAction = this["ACTION"]["END"];
	} else if (iSelectedPage < iOldSelectedPage) {
		eAction = this["ACTION"]["PREVIOUS_PAGE"];
	} else if (iSelectedPage > iOldSelectedPage) {
		eAction = this["ACTION"]["NEXT_PAGE"];
	}
	return {
		"oBrowserEvent": null,
		"eAccessType": this["ACCESS_TYPE"]["EXTERNAL"],
		"sAccessFragmentType": null,
		"oAccessFragmentDomRef": null,
		"eAction": eAction,
		"bHandled": false
	};
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["oCreateAccessInfoByInternal"] = 0; };

/******************************************************
 ** METHODS WHICH CAN BE CALLED FROM EXTERNAL
 *******************************************************/

/**
 * Scroll to previous item
 *
 * @param {int} mModifier
 */
UCF_Pager["prototype"]["scrollToPrevious"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToPrevious"]++; }; 
	this["handlePageSelect"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION"]["PREVIOUS"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToPrevious"] = 0; };

/**
 * Scroll to next item
 *
 * @param {int} mModifier
 */
UCF_Pager["prototype"]["scrollToNext"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToNext"]++; }; 
	this["handlePageSelect"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION"]["NEXT"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToNext"] = 0; };

/**
 * Scroll to previous page
 *
 * @param {int} mModifier
 */
UCF_Pager["prototype"]["scrollToPreviousPage"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToPreviousPage"]++; }; 
	this["handlePageSelect"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION"]["PREVIOUS_PAGE"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToPreviousPage"] = 0; };

/**
 * Scroll to next page
 *
 * @param {int} mModifier
 */
UCF_Pager["prototype"]["scrollToNextPage"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToNextPage"]++; }; 
	this["handlePageSelect"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION"]["NEXT_PAGE"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToNextPage"] = 0; };

/**
 * Scroll to begin
 *
 * @param {int} mModifier
 */
UCF_Pager["prototype"]["scrollToBegin"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToBegin"]++; }; 
	this["handlePageSelect"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION"]["BEGIN"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToBegin"] = 0; };

/**
 * Scroll to end
 *
 * @param {int} mModifier
 */
UCF_Pager["prototype"]["scrollToEnd"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToEnd"]++; }; 
	this["handlePageSelect"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION"]["END"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToEnd"] = 0; };

/**
 * Scroll to a specific position
 *
 * @param {int} iPosition
 * @param {int} mModifier
 */
UCF_Pager["prototype"]["scrollToPosition"] = function(iPosition, mModifier) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToPosition"]++; }; 
	this["handlePageSelect"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION"]["DIRECT"], mModifier, iPosition));
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["scrollToPosition"] = 0; };

/**
 * Returns true if the end position has been reached
 * @return {boolean}
 */
UCF_Pager["prototype"]["bEndPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["bEndPosition"]++; }; 
	return this["bVisible"] && this["iSelectedPage"] === this["iMaximumIndex"];
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["bEndPosition"] = 0; };

/**
 * Returns true if the start position has been reached
 * @return {boolean}
 */
UCF_Pager["prototype"]["bStartPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["bStartPosition"]++; }; 
	return this["bVisible"] && this["iSelectedPage"] === 1;
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["bStartPosition"] = 0; };

/**
 * Sets the visible ItemCount
 * @param { int } iVisibleItemCount
 */
UCF_Pager["prototype"]["setVisibleItemCount"] = function(iVisibleItemCount) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["setVisibleItemCount"]++; }; 
	// eslint-disable-next-line @ur/no-missing-setClientProperty, @ur/no-memory-leaks
	this["iItemsPerPage"] = iVisibleItemCount;
	this["setClientProperty"]("ItemsPerPage", this["iItemsPerPage"], true);
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["setVisibleItemCount"] = 0; };

/**
 * Gets the first visible item index
 * @return {int}
 */
UCF_Pager["prototype"]["iGetFirstVisibleItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["iGetFirstVisibleItem"]++; }; 
	return this["iFirstVisibleItem"];
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["iGetFirstVisibleItem"] = 0; };

/**
 * Sets the first visible Item
 *
 * @param { int } iFirstVisibleItem
 * @param { boolean } bSkipUpdateUI
 */
UCF_Pager["prototype"]["setFirstVisibleItem"] = function(iFirstVisibleItem, bSkipUpdateUI) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["setFirstVisibleItem"]++; }; 
	this["iFirstVisibleItem"] = iFirstVisibleItem;
	this["setClientProperty"]("FirstVisibleItem", this["iFirstVisibleItem"], true);
	this["iLastVisibleItem"] = this["iFirstVisibleItem"] - 1 + this["iItemsPerPage"];
	this["scrollToPosition"](iFirstVisibleItem, UCF_JsUtil["MODIFIER"]["NONE"]);
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["setFirstVisibleItem"] = 0; };

UCF_Pager["prototype"]["setItemCount"] = function(iItemCount) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["setItemCount"]++; }; 
	// eslint-disable-next-line @ur/no-missing-setClientProperty, @ur/no-memory-leaks
	this["iItemCount"] = iItemCount;
	this["setClientProperty"]("ItemCount", this["iItemCount"], true);
	//update client side
	this["calculateClientSide"]();
	this["renderClientSide"]();
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["setItemCount"] = 0; };

/**
 * Handles the external event
 *
 * @param {Object} oAccessInfo
 */
UCF_Pager["prototype"]["handleExternalEvent"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["handleExternalEvent"]++; }; 

	if (!this["bVisible"]) oAccessInfo["eAccessType"] = this["ACCESS_TYPE"]["NONE"];

	if (oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["EXTERNAL"]) {
		if (oAccessInfo["eAction"] === this["ACTION"]["PREVIOUS"]) {
			if (this["iSelectedPage"] > 1) this["iSelectedPage"]--;
			this["iFirstVisibleItem"] = ((this["iSelectedPage"] - 1) * this["iItemsPerPage"]) + 1;
			this["iLastVisibleItem"] = this["iFirstVisibleItem"] - 1 + this["iItemsPerPage"];
		} else if (oAccessInfo["eAction"] === this["ACTION"]["NEXT"]) {
			if (this["iSelectedPage"] < this["iMaximumIndex"]) this["iSelectedPage"]++;
			this["iFirstVisibleItem"] = ((this["iSelectedPage"] - 1) * this["iItemsPerPage"]) + 1;
			this["iLastVisibleItem"] = this["iFirstVisibleItem"] - 1 + this["iItemsPerPage"];
		} else if (oAccessInfo["eAction"] === this["ACTION"]["BEGIN"]) {
			this["iSelectedPage"] = 1;
			this["iFirstVisibleItem"] = ((this["iSelectedPage"] - 1) * this["iItemsPerPage"]) + 1;
			this["iLastVisibleItem"] = this["iFirstVisibleItem"] - 1 + this["iItemsPerPage"];
		} else if (oAccessInfo["eAction"] === this["ACTION"]["END"]) {
			this["iSelectedPage"] = this["iMaximumIndex"];
			this["iFirstVisibleItem"] = ((this["iSelectedPage"] - 1) * this["iItemsPerPage"]) + 1;
			this["iLastVisibleItem"] = this["iFirstVisibleItem"] - 1 + this["iItemsPerPage"];
		} else if (oAccessInfo["eAction"] === this["ACTION"]["NEXT_PAGE"]) {
			if (this["iSelectedPage"] < this["iMaximumIndex"]) this["iSelectedPage"]++;
			this["iFirstVisibleItem"] = ((this["iSelectedPage"] - 1) * this["iItemsPerPage"]) + 1;
			this["iLastVisibleItem"] = this["iFirstVisibleItem"] - 1 + this["iItemsPerPage"];
		} else if (oAccessInfo["eAction"] === this["ACTION"]["PREVIOUS_PAGE"]) {
			if (this["iSelectedPage"] > 1) this["iSelectedPage"]--;
			this["iFirstVisibleItem"] = ((this["iSelectedPage"] - 1) * this["iItemsPerPage"]) + 1;
			this["iLastVisibleItem"] = this["iFirstVisibleItem"] - 1 + this["iItemsPerPage"];
		} else if (oAccessInfo["eAction"] === this["ACTION"]["DIRECT"]) {
			if (this["iFirstVisibleItem"] || this["iLastVisibleItem"]) {

				this["iMaximumIndex"] = parseInt(this["iItemCount"] / this["iItemsPerPage"]);
				if ((this["iItemCount"] % this["iItemsPerPage"]) > 0) {
					this["iMaximumIndex"]++;
				}
				if (this["iItemsPerPage"] > 1) this["iPageOffset"] = parseInt(((this["iFirstVisibleItem"] + this["iItemsPerPage"]) % this["iItemsPerPage"]) - 1);
				else this["iPageOffset"] = 0;

				if (this["iItemsPerPage"] !== this["iOldItemsPerPage"] && this["iFirstVisibleItem"] !== 0 && (this["iPageOffset"] !== 0)) {
					//this.iPageOffset = parseInt(this.iItemsPerPage - (this.iFirstVisibleItem % this.iItemsPerPage));
					this["iSelectedStartPage"] = parseInt(((this["iFirstVisibleItem"] - 1) / this["iItemsPerPage"]) + 1);
					this["iSelectedEndPage"] = parseInt(((this["iLastVisibleItem"] - 1) / this["iItemsPerPage"]) + 1);
				} else {
					if (this["iFirstVisibleItem"] === 0 || ((this["iFirstVisibleItem"] % this["iItemsPerPage"]) === 0)) {
						this["iSelectedStartPage"] = 0;
						this["iSelectedEndPage"] = 0;
					}
				}
				if (this["iLastVisibleItem"] >= this["iItemCount"]) {
					this["iSelectedPage"] = this["iMaximumIndex"];
				} else {
					//this.iSelectedPage = parseInt(Math.ceil((this.iFirstVisibleItem + this.iPageOffset) / this.iItemsPerPage) + 1);
					this["iSelectedPage"] = parseInt(((this["iFirstVisibleItem"] - 1) / this["iItemsPerPage"]) + 1);
				}
			}
		}
		this["setClientProperty"]('FirstVisibleItem', this["iFirstVisibleItem"], true);
	}
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["handleExternalEvent"] = 0; };

/**
 * Touch support
 */

/**
 * Initializes touch support
 * @private
 */
UCF_Pager["prototype"]["initTouchSupport"] = function() {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["initTouchSupport"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oTouchInfo"] = null;
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["initTouchSupport"] = 0; };

/**
 * Clean up of touch support refrences
 * @private
 */
UCF_Pager["prototype"]["cleanUpTouchSupport"] = function() {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["cleanUpTouchSupport"]++; }; 
	var oTouchInfo = this["oTouchInfo"];

	if (oTouchInfo) {
		if (oTouchInfo["sDelayedCallTouch"]) UCF_JsUtil["clearDelayedCall"](oTouchInfo["sDelayedCallTouch"]);
		this["oTouchInfo"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["cleanUpTouchSupport"] = 0; };

/**
 * Handles the touch events isolated in its own handle method
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @param {ACCESS_TYPE} eAccessType
 * @private
 */
UCF_Pager["prototype"]["selectPageBySwipe"] = function(oBrowserEvent, eAccessType) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["selectPageBySwipe"]++; }; 

	if (eAccessType === this["ACCESS_TYPE"]["TOUCH_START"]) {
		var iTimeStart = new Date()["getTime"]();
		var iPxPosStart = oBrowserEvent["iPageY"]();

		this["stopTouchMomentum"]();

		this["fVelocityFactor"] = 0.8;
		this["fDurationFactor"] = 200;
		this["fMoveThreshold"] = 50;

		this["oTouchInfo"] = {
			"iPxPosStart": iPxPosStart,
			"iTimeStart": iTimeStart,
			"iPxPosLast": iPxPosStart,
			"iTimeLast": iTimeStart,
			"bDirectionPositiveLast": true,
			"fVelocity": 0.0
		};

	} else if (eAccessType === this["ACCESS_TYPE"]["TOUCH_MOVE"]) {
		if (this["oTouchInfo"]) {
			var iPxPos = oBrowserEvent["iPageY"]();
			var iTime = new Date()["getTime"]();
			var iTimeDelta = Math["min"](10, Math["abs"](iTime - this["oTouchInfo"]["iTimeLast"]));
			var fVelocity = iTimeDelta ? Math["abs"](this["oTouchInfo"]["iPxPosLast"] - iPxPos) / iTimeDelta : 0;
			var bThresholdExceeded = false;
			var bHandled = true;

			this["oTouchInfo"]["fVelocity"] = this["fVelocityFactor"] * fVelocity + 0.2 * this["oTouchInfo"]["fVelocity"];
			this["oTouchInfo"]["bDirectionPositiveLast"] = iPxPos < this["oTouchInfo"]["iPxPosLast"];
			bThresholdExceeded = Math["abs"](this["oTouchInfo"]["iPxPosLast"] - iPxPos) > this["fMoveThreshold"];

			if (bThresholdExceeded) {
				if (this["oTouchInfo"]["bDirectionPositiveLast"]) {
					if (this["iPageOffset"] === 0) {
						if (this["iSelectedPage"] < this["iMaximumIndex"]) this["iSelectedPage"]++;
					} else {
						if (this["iLastVisibleItem"] < this["iItemCount"]) {
							this["iSelectedPage"] = this["iSelectedEndPage"];
							this["iOldSelectedPage"] = this["iSelectedPage"] - 1;
						}
					}
				} else {
					if (this["iPageOffset"] === 0) {
						if (this["iSelectedPage"] > 1) this["iSelectedPage"]--;
					} else {
						if (this["iFirstVisibleItem"] > 1) {
							this["iSelectedPage"] = this["iSelectedStartPage"];
							this["iOldSelectedPage"] = this["iSelectedPage"] + 1;
						}
					}
				}
				this["oTouchInfo"]["iPxPosLast"] = iPxPos;
				this["oTouchInfo"]["iTimeLast"] = iTime;

				this["iFirstVisibleItem"] = ((this["iSelectedPage"] - 1) * this["iItemsPerPage"]) + 1;
				this["setClientProperty"]("FirstVisibleItem", this["iFirstVisibleItem"], true);
				this["iLastVisibleItem"] = this["iFirstVisibleItem"] - 1 + this["iItemsPerPage"];

				if (this["bStartPosition"]() && !this["oTouchInfo"]["bDirectionPositiveLast"]) {
					//top reached - do not cancel to let parent controls/elements scroll
					bHandled = false;
				}
				if (this["bEndPosition"]() && this["oTouchInfo"]["bDirectionPositiveLast"]) {
					//bottom reached - do not cancel to let parent controls/elements scroll
					bHandled = false;
				}

				if (bHandled) {
					oBrowserEvent["cancel"]();
					oBrowserEvent["cancelBubble"]();
					oBrowserEvent["oDomEvent"]["returnValue"] = false;
					oBrowserEvent["bHandled"] = true;
				}
			}
		}
	} else if (eAccessType === this["ACCESS_TYPE"]["TOUCH_END"]) {
		if (this["oTouchInfo"] && this["oTouchInfo"]["fVelocity"] > 1.0) {
			this["startTouchMomentum"](oBrowserEvent);
		} else {
			this["cleanUpTouchSupport"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["selectPageBySwipe"] = 0; };

/**
 * When the user touches ,drags the scoll content and releases the touch screen there can be a momentum simulated
 * which let's scolling continuing a slowly eases it out
 * This is the method which starts the momentum simulation.
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Pager["prototype"]["startTouchMomentum"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["startTouchMomentum"]++; }; 
	var oTouchMomentumInfo = null;
	var iDuration = this["fDurationFactor"] * this["oTouchInfo"]["fVelocity"];
	var iScrollDistance = (this["oTouchInfo"]["bDirectionPositiveLast"] ? 0.8 : -0.8) * this["oTouchInfo"]["fVelocity"] * this["oTouchInfo"]["fVelocity"];

	oTouchMomentumInfo = {
		"iTimeStart": this["oTouchInfo"]["iTimeLast"],
		"iDuration": iDuration,
		"iScrollDistance": iScrollDistance,
		"iScrollStart": this["oTouchInfo"]["iScrollPosStart"],
		"oTouchInfo": this["oTouchInfo"],
		"oBrowserEvent": oBrowserEvent
	};

	this["oTouchInfo"]["sDelayedCallTouch"] = UCF_JsUtil["delayedCall"](100, this, "applyTouchMomentum", [oTouchMomentumInfo]);
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["startTouchMomentum"] = 0; };

/**
 * Applies the scoll position calculated by the momentum
 * @param { Object } oTouchMomentumInfo
 * @private
 */
UCF_Pager["prototype"]["applyTouchMomentum"] = function(oTouchMomentumInfo) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["applyTouchMomentum"]++; }; 
	var iTime = new Date()["getTime"]() - oTouchMomentumInfo["iTimeStart"];

	if (iTime < oTouchMomentumInfo["iDuration"]) {

		if (this["oTouchInfo"]["bDirectionPositiveLast"]) {
			if (this["iPageOffset"] === 0) {
				if (this["iSelectedPage"] < this["iMaximumIndex"]) this["iSelectedPage"]++;
			} else {
				if (this["iLastVisibleItem"] < this["iItemCount"]) {
					this["iSelectedPage"] = this["iSelectedEndPage"];
					this["iOldSelectedPage"] = this["iSelectedPage"] - 1;
				}
			}
		} else {
			if (this["iPageOffset"] === 0) {
				if (this["iSelectedPage"] > 1) this["iSelectedPage"]--;
			} else {
				if (this["iFirstVisibleItem"] > 1) {
					this["iSelectedPage"] = this["iSelectedStartPage"];
					this["iOldSelectedPage"] = this["iSelectedPage"] + 1;
				}
			}
		}

		this["iFirstVisibleItem"] = ((this["iSelectedPage"] - 1) * this["iItemsPerPage"]) + 1;
		this["setClientProperty"]("FirstVisibleItem", this["iFirstVisibleItem"], true);
		this["iLastVisibleItem"] = this["iFirstVisibleItem"] - 1 + this["iItemsPerPage"];

		//update client side
		this["calculateClientSide"]();
		this["renderClientSide"]();

		// fire semantic Event
		this["fireSelect"](this["sId"], this["iSelectedPage"]);
		// fire internal Event
		var eAccessSource = "PAGER";
		var oAccessInfo = this["oCreateAccessInfoByInternal"](this["iOldSelectedPage"], this["iSelectedPage"]);
		var bNotify = false;

		if (this["mNotificationMode"] === this["NOTIFICATION"]["ALWAYS_WHEN_CHANGED"] || this["mNotificationMode"] === this["NOTIFICATION"]["ALWAYS"]) bNotify = true;
		else if (this["mNotificationMode"] === this["NOTIFICATION"]["NEVER"]) bNotify = false;

		if (bNotify) this["fireInternalScrollEvent"](this["iFirstVisibleItem"], oAccessInfo["eAction"], eAccessSource, oAccessInfo["eAccessType"], oAccessInfo["mModifier"]);

		oTouchMomentumInfo["oTouchInfo"]["sDelayedCallTouch"] = UCF_JsUtil["delayedCall"](100, this, "applyTouchMomentum", [oTouchMomentumInfo]);
		return;

	}
	this["stopTouchMomentum"]();
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["applyTouchMomentum"] = 0; };

/**
 * Stops the momentum
 * @private
 */
UCF_Pager["prototype"]["stopTouchMomentum"] = function() {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["stopTouchMomentum"]++; }; 
	if (this["oTouchInfo"]) {
		this["cleanUpTouchSupport"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["stopTouchMomentum"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Pager["prototype"]["aAttributeNames"] = ["sId","iFirstVisibleItem","iItemCount","iItemsPerPage","iPagePickerCount","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Pager["prototype"]["aEventNames"] = ["Select"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Pager["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_Pager["prototype"]["sId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_Pager["prototype"]["iFirstVisibleItem"] = 1;

/**
 * @private
 * @type {number}
 */
UCF_Pager["prototype"]["iItemCount"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_Pager["prototype"]["iItemsPerPage"] = 10;

/**
 * @private
 * @type {number}
 */
UCF_Pager["prototype"]["iPagePickerCount"] = 5;

/**
 * @private
 * @type {string}
 */
UCF_Pager["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Pager["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["iFirstVisibleItem"] = 1;
	this["iItemCount"] = 0;
	this["iItemsPerPage"] = 10;
	this["iPagePickerCount"] = 5;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("FirstVisibleItem", 1, true);
		this["setClientProperty"]("ItemCount", 0, true);
		this["setClientProperty"]("ItemsPerPage", 10, true);
		this["setClientProperty"]("PagePickerCount", 5, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iSelectedPage Index of selected page
 * @fires Pager::Select
 */
UCF_Pager["prototype"]["fireSelect"] = function(sId, iSelectedPage) {;if (__UCF_COVERAGE__) { UCF_Pager["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, SelectedPage: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Pager.js(1157): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Pager.js(1158): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Pager.js(1159): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iSelectedPage != null, "iSelectedPage != null", "Pager.js(1160): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iSelectedPage) == "number", "typeof(iSelectedPage) == \"number\"", "Pager.js(1161): fireSelect"); };
	mParams = {
		"Id": sId,
		"SelectedPage": iSelectedPage
	};
	
	
	this["fireSemanticEvent"]("Pager", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Pager["_"]["fireSelect"] = 0; };

};
sap["ls"]["preload"]["UCF_Paginator"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/**
 * 
 * @version
 *
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Paginator(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Paginator["_"]["UCF_Paginator"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Paginator.js(33): UCF_Paginator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Paginator.js(34): UCF_Paginator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Paginator.js(35): UCF_Paginator"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	this["oText"] = UCF_DomUtil["$"](this["sId"] + 'ft2');
	if (this["oText"])
		this["allowTextSelection"](this["oText"]);
	this["oMenu"] = UCF_DomUtil["$"](this["sId"] + '-menu');

	UCF_Control["apply"](this, [oDomRef, oLS]);
	/** @type {UCF_Cache} */
	this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
	this["iSelectionStart"] = 0;
	this["oInputField"] = UCF_DomUtil["$"](this["sId"] + '-inp');
	if (this["oInputField"]) {
		this["attachBrowserEvent"]("change", this["oInputField"]);
		this["iSelectionStart"] = this["oInputField"]["value"]["length"];
	}
	this["bEditMode"] = false;
	this["bKeepEditMode"] = false;
	this["iSelectionEnd"] = this["iSelectionStart"];
	this["bSelected"] = false;
};window["UCF_Paginator"] = UCF_Paginator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Paginator"); UCF_Paginator["_"] = {UCF_Paginator: 0}; }; ;

UCF_Paginator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Paginator.prototype["sClassName"] = "UCF_Paginator";

/**
 * Destructor
 */
UCF_Paginator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["destroy"]++; }; 
	if (this["oInputField"]) {
		this["detachBrowserEvent"]("change", this["oInputField"]);
		this["oInputField"] = null;
	}

	this["sStyles"] = "";
	this["oOptionMenu"] = null;
	this["oMenu"] = null;
	if (this["oCache"]) {
		this["oCache"]["destroy"]();
		this["oCache"] = null;
	}
	this["bEditMode"] = null;
	this["bKeepEditMode"] = null;
	this["iSelectionEnd"] = null;
	this["iSelectionStart"] = null;
	this["oText"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["destroy"] = 0; };

/**
 * Sets focus specific styles on the control
 */

UCF_Paginator["prototype"]["onactivate"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onactivate"]++; }; 

	if (this["bReadonly"] && !window["UCF_System"]["bIs508"]) return;

	var sFocusStyle = "lsEdFieldFocus",
		oSource = oBrowserEvent["oGetSource"](),
		sId = oSource["getAttribute"]("id");

	if (sId && sId["indexOf"]("-inp") < 0) return;

	this["sStyles"] = oSource["className"];

	if (this["bReadonly"] || !this["bEnabled"]) {
		sFocusStyle += "Dsbl";
	}

	UCF_DomUtil["addClass"](oSource, sFocusStyle);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onactivate"] = 0; };

/**
 * Removes the focus styles
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_Paginator["prototype"]["ondeactivate"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["ondeactivate"]++; }; 

	var oSource = oBrowserEvent["oGetSource"](),
		sId = oSource["getAttribute"]("id");

	if ((sId && sId["indexOf"]("-inp") < 0) || !this["sStyles"]) return;

	oSource["className"] = this["sStyles"];

};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["ondeactivate"] = 0; };

/**
 * Handle change event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Paginator["prototype"]["onchange"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onchange"]++; }; 
	this["fireFieldChange"](this["sId"], this["oInputField"]["value"]);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onchange"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Paginator["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Paginator.js(140): onclick"); };

	var oSource = oBrowserEvent["oGetSource"]();
	//toggle the menu if clicked on the icon
	if (this["oMenu"] && this["oMenu"] === oSource) {
		this["toggleMenu"]();
	} else if (this["bHasAttribute"](oSource, 'data-paginator-type')) {
		this["fireEvents"](oSource);
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onclick"] = 0; };

/** @override */
UCF_Paginator["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsfocus"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oInputField"] && !this["bReadonly"]) {
		if (oBrowserEvent["bIsTouchInteraction"]()) {
			this["editMode"]();
		} else if (!this["bEditMode"]) {
			this["navigationMode"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsfocus"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsupmodifier
 */
UCF_Paginator["prototype"]["onlsupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsupmodifier"]++; }; 

	if (UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent))
		this["toggleMenu"]();
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsupmodifier"] = 0; };
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdownmodifier
 */
UCF_Paginator["prototype"]["onlsdownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsdownmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent))
		this["toggleMenu"]();
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsdownmodifier"] = 0; };

/**
 * Handles the [ENTER] event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Paginator["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Paginator.js(190): onlsenter"); };

	var oSource = oBrowserEvent["oGetSource"]();

	//toggle the menu if clicked on the icon
	if (this["oMenu"] && this["oMenu"] === oSource) {
		this["toggleMenu"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (this["bHasAttribute"](oSource, 'data-paginator-type')) {
		this["fireEvents"](oSource);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (oSource === this["oInputField"]) {
		this["fireFieldChange"](this["sId"], this["oInputField"]["value"]);
	}

};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsenter"] = 0; };

/**
 * Handles the [SPACE] event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Paginator["prototype"]["onlsspaceup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsspaceup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Paginator.js(216): onlsspaceup"); };

	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}

	var oSource = oBrowserEvent["oGetSource"]();
	//toggle the menu if clicked on the icon
	if (this["oMenu"] && this["oMenu"] === oSource) {
		this["toggleMenu"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (this["bHasAttribute"](oSource, "data-paginator-type")) {
		this["fireEvents"](oSource);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsspaceup"] = 0; };
/**
 * Handles the events according with the button type
 *
 * @param {HTMLElement} oSource the browser event object that occurred
 * @param { string } sAttribute
 *
 * @return {boolean}
 * @private
 */
UCF_Paginator["prototype"]["bHasAttribute"] = function(oSource, sAttribute) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["bHasAttribute"]++; }; 
	var bHasAttribute = oSource["hasAttribute"] && oSource["hasAttribute"](sAttribute);
	if (__UCF_IE6__) {
		bHasAttribute = UCF_DomUtil["sGetAttribute"](oSource, sAttribute) && UCF_DomUtil["sGetAttribute"](oSource, sAttribute) !== '';
	}
	return bHasAttribute;
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["bHasAttribute"] = 0; };
/**
 * Handles the events according with the button type
 *
 * @param {HTMLElement} oSource the browser event object that occurred
 * @private
 */
UCF_Paginator["prototype"]["fireEvents"] = function(oSource) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireEvents"]++; }; 

	var sConId = oSource["getAttribute"]("ConnectedControlId");
	if (UCF_DomUtil["sGetAttribute"](oSource, "data-paginator-type") === "buttontype-Begin") {
		this["firePageTop"](this["sId"], sConId);
	}
	if (UCF_DomUtil["sGetAttribute"](oSource, "data-paginator-type") === "buttontype-PrevPage") {
		this["firePagePrevious"](this["sId"], sConId);
	}
	if (UCF_DomUtil["sGetAttribute"](oSource, "data-paginator-type") === "buttontype-PrevItem") {
		this["fireItemPrevious"](this["sId"], sConId);
	}
	if (UCF_DomUtil["sGetAttribute"](oSource, "data-paginator-type") === "buttontype-NxtItem") {
		this["fireItemNext"](this["sId"], sConId);
	}
	if (UCF_DomUtil["sGetAttribute"](oSource, "data-paginator-type") === "buttontype-NxtPage") {
		this["firePageNext"](this["sId"], sConId);
	}
	if (UCF_DomUtil["sGetAttribute"](oSource, "data-paginator-type") === "buttontype-End") {
		this["firePageEnd"](this["sId"], sConId);
	}
	if (UCF_DomUtil["sGetAttribute"](oSource, "data-paginator-type") === "buttontype-AA") {
		this["fireNextYear"](this["sId"], sConId);
	}
	if (UCF_DomUtil["sGetAttribute"](oSource, "data-paginator-type") === "buttontype-RA") {
		this["firePreviousYear"](this["sId"], sConId);
	}

};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireEvents"] = 0; };

/**
 * Toggle menu
 */
UCF_Paginator["prototype"]["toggleMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["toggleMenu"]++; }; 

	if (!this["oMenu"]) return;
	var sOpId = this["oMenu"]["getAttribute"]("OptionMenuId");

	if (!this["oOptionMenu"]) {
		this["oOptionMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](sOpId, true);

		if (!this["oOptionMenu"]) return;

		this["oOptionMenu"]["setOpenerRef"](this["oMenu"]);
		this["oOptionMenu"]["setOpenerId"](this["sId"]);
		this["oOptionMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
		this["oOptionMenu"]["setOffsetTop"](-1);
		this["oOptionMenu"]["setOffsetLeft"](-1);
		this["oOptionMenu"]["attachEvent"](this["oOptionMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
	}
	if (this["bOptionMenuIsOpened"]) {
		this["oOptionMenu"]["close"]();
	} else {
		this["oOptionMenu"]["open"]();
	}

};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["toggleMenu"] = 0; };

/**
 * Handles the onMenuClose event
 *
 * @param {UCF_Event} oEvent
 */
UCF_Paginator["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onMenuClose"]++; }; 

	if (!this["oMenu"]) return;
	this["bOptionMenuIsOpened"] = false;
	this["oMenu"]["focus"]();

};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onMenuClose"] = 0; };

/**
 * Set enabled
 */
UCF_Paginator["prototype"]["setEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["setEnabled"]++; }; 
	if (this["bEnabled"]) return;
	this["oDomRef"]["className"] = this["oDomRef"]["className"] + "Dsbl";
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["setEnabled"] = 0; };

/**
 * Set disabled
 */
UCF_Paginator["prototype"]["setDisabled"] = function() {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["setDisabled"]++; }; 
	if (this["bEnabled"]) return;
	this["oDomRef"]["className"] = this["oDomRef"]["className"]["replace"]("Dsbl", "");
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["setDisabled"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Paginator["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Paginator.js(352): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource["className"]["indexOf"]("Input") > -1) {
		oAccessibilityHelper["setControlType"]("I");
		if (this["bReadonly"]) {
			oAccessibilityHelper["addTutor"]("READONLY");
		} else {
			oAccessibilityHelper["addTutor"]("PG_INPUT");
		}
		if (this["sPageIndicatorText"] !== "") {
			oAccessibilityHelper["addTooltip"](this["sPageIndicatorText"] + " " + this["iVisibleIndex"] + " of " + this["iMaximumIndex"]);
		} else {
			oAccessibilityHelper["addTooltip"](this["sNavigationText"] + " " + this["iVisibleIndex"] + " of " + this["iMaximumIndex"]);
		}
	} else if ((this["bHasFreetext"]) && (oSource["className"]["indexOf"]("Txt") > -1))
		oAccessibilityHelper["setTooltip"](this["sFreetext"]);
	else {
		oAccessibilityHelper["setControlType"]("B");
		if (oSource["className"]["indexOf"]("Begin") > -1) oAccessibilityHelper["addTutor"]("PG_IBEGIN");
		if (oSource["className"]["indexOf"]("PrevPage") > -1) oAccessibilityHelper["addTutor"]("PG_PPREV");
		if ((this["sNavigationType"] !== "CALENDAR") && (oSource["className"]["indexOf"]("PrevItem") > -1)) oAccessibilityHelper["addTutor"]("PG_IPREV");
		if ((this["sNavigationType"] === "CALENDAR") && (oSource["className"]["indexOf"]("PrevItem") > -1)) oAccessibilityHelper["addTutor"]("DN_PREV");
		if ((this["sNavigationType"] !== "CALENDAR") && (oSource["className"]["indexOf"]("NxtItem") > -1)) oAccessibilityHelper["addTutor"]("PG_INEXT");
		if ((this["sNavigationType"] === "CALENDAR") && (oSource["className"]["indexOf"]("NxtItem") > -1)) oAccessibilityHelper["addTutor"]("DN_NEXT");
		if (oSource["className"]["indexOf"]("NxtPage") > -1) oAccessibilityHelper["addTutor"]("PG_PNEXT");
		if (oSource["className"]["indexOf"]("End") > -1) oAccessibilityHelper["addTutor"]("PG_IEND");
		if ((this["sNavigationType"] !== "CALENDAR") && (oSource["className"]["indexOf"]("AA") > -1)) oAccessibilityHelper["addTutor"]("PG_AA");
		if ((this["sNavigationType"] === "CALENDAR") && (oSource["className"]["indexOf"]("AA") > -1)) oAccessibilityHelper["addTutor"]("DN_YNEXT");
		if ((this["sNavigationType"] !== "CALENDAR") && (oSource["className"]["indexOf"]("RA") > -1)) oAccessibilityHelper["addTutor"]("PG_RA");
		if ((this["sNavigationType"] === "CALENDAR") && (oSource["className"]["indexOf"]("RA") > -1)) oAccessibilityHelper["addTutor"]("DN_YPREV");
		if (oSource["className"]["indexOf"]("MenuIco") > -1) oAccessibilityHelper["addTutor"]("PG_MNU");
		if (oSource["className"]["indexOf"]("Dsbl") > -1) oAccessibilityHelper["addTutor"]("DISABLED");
		else {
			oAccessibilityHelper["addTutor"]("B_TUT");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsaccessibility"] = 0; };

/**
 * Passes all items that are neccessary for the navigation to the navigation framework
 * @return {UCF_Button[]}
 */
UCF_Paginator["prototype"]["oGetButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["oGetButtons"]++; }; 

	/** @type {UCF_Paginator} */
	var self = this;

	return this["oCache"]["get"]('oButtons', function() {
		return UCF_DomUtil["querySelectorAll"]('button,input', self["oDomRef"]);
	});
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["oGetButtons"] = 0; };

/**
 * Passes all items that are neccessary for the navigation to the navigation framework
 * @param {DOMElement} oDomRef
 * @return {int}
 */
UCF_Paginator["prototype"]["iGetPosition"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["iGetPosition"]++; }; 

	var oButtons = this["oGetButtons"]();
	var iCurrentPosition = 0;

	for (var i = 0; i < oButtons["length"]; i++) {
		iCurrentPosition = i;
		if (oButtons[i] === oDomRef)
			break;
	}

	return iCurrentPosition;
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["iGetPosition"] = 0; };

/**
 *  [RIGHT]
 * @param { UCF_BrowserEvent } oBrowserEvent the lsnext
 * @private
 */
UCF_Paginator["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsright"]++; }; 

	var oSourceDomRef = oBrowserEvent["oGetSource"](),
		oNextDomRef,
		aButtons = this["oGetButtons"]();

	if (oSourceDomRef === this["oInputField"] && !this["bReadonly"] && this["bEditMode"]) {

	} else {
		var iCurrentIndex = this["iGetPosition"](oSourceDomRef);
		var iNextIndex = iCurrentIndex < (aButtons["length"] - 1) ? iCurrentIndex + 1 : iCurrentIndex;
		oNextDomRef = aButtons[iNextIndex];
		if (oNextDomRef) {
			UCF_DomUtil["moveFocusDomElement"](oNextDomRef, true);
		}
		this["bEditMode"] = false;

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsright"] = 0; };

/**
 *  [DOWN]
 * @param { UCF_BrowserEvent } oBrowserEvent the lsnext
 * @private
 */
UCF_Paginator["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsdown"]++; }; 
	this["onlsright"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsdown"] = 0; };

/**
 *  [LEFT]
 * @param { UCF_BrowserEvent } oBrowserEvent the lsleft
 * @private
 */
UCF_Paginator["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsleft"]++; }; 

	var oSource = oBrowserEvent["oGetSource"](),
		oPreviousDomRef,
		aButtons = this["oGetButtons"]();
	if (oSource === this["oInputField"] && !this["bReadonly"] && this["bEditMode"]) {

	} else {
		var iCurrentIndex = this["iGetPosition"](oSource);
		var iNextIndex = iCurrentIndex === 0 ? 0 : iCurrentIndex - 1;
		oPreviousDomRef = aButtons[iNextIndex];
		if (oPreviousDomRef) {
			UCF_DomUtil["moveFocusDomElement"](oPreviousDomRef, true);
		}

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsleft"] = 0; };

/**
 *  [UP]
 * @param { UCF_BrowserEvent } oBrowserEvent the lsup
 * @private
 */
UCF_Paginator["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsup"]++; }; 
	this["onlsleft"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsup"] = 0; };

/**
 *  [HOME]
 * @param { UCF_BrowserEvent } oBrowserEvent the lshome
 * @private
 */
UCF_Paginator["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlshome"]++; }; 

	var oSource = oBrowserEvent["oGetSource"](),
		oPreviousDomRef,
		aButtons = this["oGetButtons"]();
	if (oSource === this["oInputField"] && !this["bReadonly"] && this["bEditMode"]) {

	} else {
		oPreviousDomRef = aButtons[0];
		if (oPreviousDomRef) {
			UCF_DomUtil["moveFocusDomElement"](oPreviousDomRef, true);
		}

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlshome"] = 0; };

/**
 *  [END]
 * @param { UCF_BrowserEvent } oBrowserEvent the lsend
 * @private
 */
UCF_Paginator["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsend"]++; }; 

	var oSource = oBrowserEvent["oGetSource"](),
		oPreviousDomRef,
		aButtons = this["oGetButtons"]();
	if (oSource === this["oInputField"] && !this["bReadonly"] && this["bEditMode"]) {

	} else {
		oPreviousDomRef = aButtons[aButtons["length"] - 1];
		if (oPreviousDomRef) {
			UCF_DomUtil["moveFocusDomElement"](oPreviousDomRef, true);
		}

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsend"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Paginator["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Paginator["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlsskipback"] = 0; };

/** @override */
UCF_Paginator["prototype"]["onlshotkey"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlshotkey"]++; }; 
	if (UCF_KeyboardHelper["bIsEventForKey"](oHotkey, UCF_KeyCodes["F2"])) {
		this["handleF2"](oHotkey);
	}
	if (UCF_KeyboardHelper["bIsEventForKey"](oHotkey, UCF_KeyCodes["A"], 'C')) {
		this["handleCtrlA"](oHotkey);
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onlshotkey"] = 0; };

/** @protected */
UCF_Paginator["prototype"]["navigationMode"] = function() {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["navigationMode"]++; }; 
	this["bEditMode"] = false;

	if (!this["bReadonly"]) {
		this["selectText"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["navigationMode"] = 0; };

/** @protected */
UCF_Paginator["prototype"]["editMode"] = function() {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["editMode"]++; }; 
	if (!this["bReadonly"]) {
		this["bEditMode"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["editMode"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oHotkey the hotkey
 */
UCF_Paginator["prototype"]["handleF2"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["handleF2"]++; }; 
	if (this["bReadonly"]) return;
	if (this["bEditMode"]) {
		// save selection start and end
		this["iSelectionStart"] = UCF_DomUtil["iGetSelectionStart"](this["oInputField"]);
		this["iSelectionEnd"] = UCF_DomUtil["iGetSelectionEnd"](this["oInputField"]);
		this["navigationMode"]();
	} else {
		this["editMode"]();
		UCF_DomUtil["setSelection"](
			this["oInputField"],
			this["iSelectionStart"],
			this["iSelectionEnd"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["handleF2"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oHotkey the hotkey
 */
UCF_Paginator["prototype"]["handleCtrlA"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["handleCtrlA"]++; }; 
	if (
		// Limitation: Not in IE: Focus gets lost!
		!UCF_UserAgent["bIsIE"]() &&
		// AND read only or disabled
		!this["bReadonly"]
	) {
		// select the text and cancel the event.
		// otherwise: Let the event bubble, and the table raises a RowSelect event
		this["selectText"]();
		oHotkey["cancelBubble"]();
		oHotkey["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["handleCtrlA"] = 0; };

/** @override */
// eslint-disable-next-line complexity
UCF_Paginator["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onkeydown"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oInputField"] && !this["bReadonly"]) {
		if (this["bEditMode"] && (
				UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["DELETE"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["ESCAPE"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["INSERT"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["SPACE"])
			)) {
			oBrowserEvent["cancelBubble"]();
		} else if (this["bIsImplicitEditModeSwitch"](oBrowserEvent)) {
			this["editMode"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onkeydown"] = 0; };

/** @override
 * On MouseDown set the bEditMode: true
 */
UCF_Paginator["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onmousedown"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oInputField"] && !this["bReadonly"]) {
		this["editMode"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["onmousedown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @return {boolean}
 */
UCF_Paginator["prototype"]["bIsImplicitEditModeSwitch"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["bIsImplicitEditModeSwitch"]++; }; 
	/** @type {number} */
	var iKeyCode = oBrowserEvent["iKeyCode"]();

	return UCF_KeyboardHelper["bIsEditKey"](iKeyCode)
		&& iKeyCode !== UCF_KeyCodes["ENTER"]
		&& (!oBrowserEvent["bCtrl"]() || oBrowserEvent["bAlt"]())
		&& !UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["SPACE"])
		&& oBrowserEvent["oGetSource"]() === this["oInputField"];
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["bIsImplicitEditModeSwitch"] = 0; };

/** @private
 *  Selects the text of the Input
 */
UCF_Paginator["prototype"]["selectText"] = function() {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["selectText"]++; }; 
	/** @type {Document} */
	var document = window["document"];
	/** @type {Selection} */
	var selection;
	/** @type {Range} */
	var range;

	if (this["oInputField"]["select"]) {
		this["oInputField"]["select"]();
	} else if (window["getSelection"] && document["createRange"]) {
		// Chrome, Firefox, IE11
		selection = window["getSelection"]();
		range = document["createRange"]();
		range["selectNodeContents"](this["oInputField"]);
		selection["removeAllRanges"]();
		selection["addRange"](range);
	} else if (document["body"]["createTextRange"]) {
		// IE11
		range = document["body"]["createTextRange"]();
		range["moveToElementText"](this["oInputField"]);
		range["select"]();
	}
	this["bSelected"] = true;
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["selectText"] = 0; };

/** @private */
UCF_Paginator["prototype"]["deselectText"] = function() {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["deselectText"]++; }; 
	if (this["oInputField"]["select"]) {
		this["oInputField"]["selectionStart"] = 0;
		this["oInputField"]["selectionEnd"] = 0;
	} else {
		UCF_DomUtil["removeSelection"]();
	}
	this["bSelected"] = false;
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["deselectText"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Paginator["prototype"]["aAttributeNames"] = ["iVisibleIndex","iMaximumIndex","sPageIndicatorText","bHasFreetext","sFreetext","sNavigationType","sNavigationText","bReadonly","sVisibility","sTooltipCalendarDoubleNext","sTooltipCalendarDoublePrev","sTooltipCalendarNext","sTooltipCalendarPrev","sCustomData","sAccessibilityDescription"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Paginator["prototype"]["aEventNames"] = ["PageTop","PageEnd","PreviousYear","PageNext","NextYear","PagePrevious","ItemNext","ItemPrevious","FieldChange","MenuOpen"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Paginator["prototype"]["aMethodNames"] = ["openMenu","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {number}
 */
UCF_Paginator["prototype"]["iVisibleIndex"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_Paginator["prototype"]["iMaximumIndex"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_Paginator["prototype"]["sPageIndicatorText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Paginator["prototype"]["bHasFreetext"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Paginator["prototype"]["sFreetext"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.PaginatorNavigationType}
 */
UCF_Paginator["prototype"]["sNavigationType"] = "ITEM";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.PaginatorNavigationText}
 */
UCF_Paginator["prototype"]["sNavigationText"] = "PAGE";

/**
 * @private
 * @type {boolean}
 */
UCF_Paginator["prototype"]["bReadonly"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Paginator["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_Paginator["prototype"]["sTooltipCalendarDoubleNext"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Paginator["prototype"]["sTooltipCalendarDoublePrev"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Paginator["prototype"]["sTooltipCalendarNext"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Paginator["prototype"]["sTooltipCalendarPrev"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Paginator["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Paginator["prototype"]["sAccessibilityDescription"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Paginator["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["setDefaultValues"]++; }; 
	this["iVisibleIndex"] = -1;
	this["iMaximumIndex"] = 0;
	this["sPageIndicatorText"] = '';
	this["bHasFreetext"] = false;
	this["sFreetext"] = '';
	this["sNavigationType"] = "ITEM";
	this["sNavigationText"] = "PAGE";
	this["bReadonly"] = false;
	this["sVisibility"] = "VISIBLE";
	this["sTooltipCalendarDoubleNext"] = '';
	this["sTooltipCalendarDoublePrev"] = '';
	this["sTooltipCalendarNext"] = '';
	this["sTooltipCalendarPrev"] = '';
	this["sCustomData"] = '';
	this["sAccessibilityDescription"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("VisibleIndex", -1, true);
		this["setClientProperty"]("MaximumIndex", 0, true);
		this["setClientProperty"]("PageIndicatorText", '', true);
		this["setClientProperty"]("HasFreetext", false, true);
		this["setClientProperty"]("Freetext", '', true);
		this["setClientProperty"]("NavigationType", "ITEM", true);
		this["setClientProperty"]("NavigationText", "PAGE", true);
		this["setClientProperty"]("Readonly", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("TooltipCalendarDoubleNext", '', true);
		this["setClientProperty"]("TooltipCalendarDoublePrev", '', true);
		this["setClientProperty"]("TooltipCalendarNext", '', true);
		this["setClientProperty"]("TooltipCalendarPrev", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sConnectedControlId Identifier of the connected control
 * @fires Paginator::PageTop
 */
UCF_Paginator["prototype"]["firePageTop"] = function(sId, sConnectedControlId) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["firePageTop"]++; }; 
	/** @type {{Id: string, ConnectedControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Paginator.js(882): firePageTop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Paginator.js(883): firePageTop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Paginator.js(884): firePageTop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectedControlId != null, "sConnectedControlId != null", "Paginator.js(885): firePageTop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectedControlId) == "string", "typeof(sConnectedControlId) == \"string\"", "Paginator.js(886): firePageTop"); };
	mParams = {
		"Id": sId,
		"ConnectedControlId": sConnectedControlId
	};
	
	if (sConnectedControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sConnectedControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ConnectedControlId");
			}
		}
	this["fireSemanticEvent"]("Paginator", "PageTop", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["firePageTop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sConnectedControlId Identifier of the connected control
 * @fires Paginator::PageEnd
 */
UCF_Paginator["prototype"]["firePageEnd"] = function(sId, sConnectedControlId) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["firePageEnd"]++; }; 
	/** @type {{Id: string, ConnectedControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Paginator.js(913): firePageEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Paginator.js(914): firePageEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Paginator.js(915): firePageEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectedControlId != null, "sConnectedControlId != null", "Paginator.js(916): firePageEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectedControlId) == "string", "typeof(sConnectedControlId) == \"string\"", "Paginator.js(917): firePageEnd"); };
	mParams = {
		"Id": sId,
		"ConnectedControlId": sConnectedControlId
	};
	
	if (sConnectedControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sConnectedControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ConnectedControlId");
			}
		}
	this["fireSemanticEvent"]("Paginator", "PageEnd", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["firePageEnd"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sConnectedControlId Identifier of the connected control
 * @fires Paginator::PreviousYear
 */
UCF_Paginator["prototype"]["firePreviousYear"] = function(sId, sConnectedControlId) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["firePreviousYear"]++; }; 
	/** @type {{Id: string, ConnectedControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Paginator.js(944): firePreviousYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Paginator.js(945): firePreviousYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Paginator.js(946): firePreviousYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectedControlId != null, "sConnectedControlId != null", "Paginator.js(947): firePreviousYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectedControlId) == "string", "typeof(sConnectedControlId) == \"string\"", "Paginator.js(948): firePreviousYear"); };
	mParams = {
		"Id": sId,
		"ConnectedControlId": sConnectedControlId
	};
	
	if (sConnectedControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sConnectedControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ConnectedControlId");
			}
		}
	this["fireSemanticEvent"]("Paginator", "PreviousYear", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["firePreviousYear"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sConnectedControlId Identifier of the connected control
 * @fires Paginator::PageNext
 */
UCF_Paginator["prototype"]["firePageNext"] = function(sId, sConnectedControlId) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["firePageNext"]++; }; 
	/** @type {{Id: string, ConnectedControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Paginator.js(975): firePageNext"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Paginator.js(976): firePageNext"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Paginator.js(977): firePageNext"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectedControlId != null, "sConnectedControlId != null", "Paginator.js(978): firePageNext"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectedControlId) == "string", "typeof(sConnectedControlId) == \"string\"", "Paginator.js(979): firePageNext"); };
	mParams = {
		"Id": sId,
		"ConnectedControlId": sConnectedControlId
	};
	
	if (sConnectedControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sConnectedControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ConnectedControlId");
			}
		}
	this["fireSemanticEvent"]("Paginator", "PageNext", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["firePageNext"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sConnectedControlId Identifier of the connected control
 * @fires Paginator::NextYear
 */
UCF_Paginator["prototype"]["fireNextYear"] = function(sId, sConnectedControlId) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireNextYear"]++; }; 
	/** @type {{Id: string, ConnectedControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Paginator.js(1006): fireNextYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Paginator.js(1007): fireNextYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Paginator.js(1008): fireNextYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectedControlId != null, "sConnectedControlId != null", "Paginator.js(1009): fireNextYear"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectedControlId) == "string", "typeof(sConnectedControlId) == \"string\"", "Paginator.js(1010): fireNextYear"); };
	mParams = {
		"Id": sId,
		"ConnectedControlId": sConnectedControlId
	};
	
	if (sConnectedControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sConnectedControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ConnectedControlId");
			}
		}
	this["fireSemanticEvent"]("Paginator", "NextYear", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireNextYear"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sConnectedControlId Identifier of the connected control
 * @fires Paginator::PagePrevious
 */
UCF_Paginator["prototype"]["firePagePrevious"] = function(sId, sConnectedControlId) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["firePagePrevious"]++; }; 
	/** @type {{Id: string, ConnectedControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Paginator.js(1037): firePagePrevious"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Paginator.js(1038): firePagePrevious"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Paginator.js(1039): firePagePrevious"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectedControlId != null, "sConnectedControlId != null", "Paginator.js(1040): firePagePrevious"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectedControlId) == "string", "typeof(sConnectedControlId) == \"string\"", "Paginator.js(1041): firePagePrevious"); };
	mParams = {
		"Id": sId,
		"ConnectedControlId": sConnectedControlId
	};
	
	if (sConnectedControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sConnectedControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ConnectedControlId");
			}
		}
	this["fireSemanticEvent"]("Paginator", "PagePrevious", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["firePagePrevious"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sConnectedControlId Identifier of the connected control
 * @fires Paginator::ItemNext
 */
UCF_Paginator["prototype"]["fireItemNext"] = function(sId, sConnectedControlId) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireItemNext"]++; }; 
	/** @type {{Id: string, ConnectedControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Paginator.js(1068): fireItemNext"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Paginator.js(1069): fireItemNext"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Paginator.js(1070): fireItemNext"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectedControlId != null, "sConnectedControlId != null", "Paginator.js(1071): fireItemNext"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectedControlId) == "string", "typeof(sConnectedControlId) == \"string\"", "Paginator.js(1072): fireItemNext"); };
	mParams = {
		"Id": sId,
		"ConnectedControlId": sConnectedControlId
	};
	
	if (sConnectedControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sConnectedControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ConnectedControlId");
			}
		}
	this["fireSemanticEvent"]("Paginator", "ItemNext", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireItemNext"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sConnectedControlId Identifier of the connected control
 * @fires Paginator::ItemPrevious
 */
UCF_Paginator["prototype"]["fireItemPrevious"] = function(sId, sConnectedControlId) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireItemPrevious"]++; }; 
	/** @type {{Id: string, ConnectedControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Paginator.js(1099): fireItemPrevious"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Paginator.js(1100): fireItemPrevious"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Paginator.js(1101): fireItemPrevious"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectedControlId != null, "sConnectedControlId != null", "Paginator.js(1102): fireItemPrevious"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectedControlId) == "string", "typeof(sConnectedControlId) == \"string\"", "Paginator.js(1103): fireItemPrevious"); };
	mParams = {
		"Id": sId,
		"ConnectedControlId": sConnectedControlId
	};
	
	if (sConnectedControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sConnectedControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ConnectedControlId");
			}
		}
	this["fireSemanticEvent"]("Paginator", "ItemPrevious", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireItemPrevious"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue Identifier of the control
 * @fires Paginator::FieldChange
 */
UCF_Paginator["prototype"]["fireFieldChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireFieldChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Paginator.js(1128): fireFieldChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Paginator.js(1129): fireFieldChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Paginator.js(1130): fireFieldChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "Paginator.js(1131): fireFieldChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Paginator.js(1132): fireFieldChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("Paginator", "FieldChange", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireFieldChange"] = 0; };

/**
 * @protected
 * @param {string} sId 
 * @param {string} sOptionMenuId 
 * @param {string} sConnectedControlId 
 * @fires Paginator::MenuOpen
 */
UCF_Paginator["prototype"]["fireMenuOpen"] = function(sId, sOptionMenuId, sConnectedControlId) {;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireMenuOpen"]++; }; 
	/** @type {{Id: string, OptionMenuId: string, ConnectedControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Paginator.js(1155): fireMenuOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Paginator.js(1156): fireMenuOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Paginator.js(1157): fireMenuOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sOptionMenuId != null, "sOptionMenuId != null", "Paginator.js(1158): fireMenuOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sOptionMenuId) == "string", "typeof(sOptionMenuId) == \"string\"", "Paginator.js(1159): fireMenuOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectedControlId != null, "sConnectedControlId != null", "Paginator.js(1160): fireMenuOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectedControlId) == "string", "typeof(sConnectedControlId) == \"string\"", "Paginator.js(1161): fireMenuOpen"); };
	mParams = {
		"Id": sId,
		"OptionMenuId": sOptionMenuId,
		"ConnectedControlId": sConnectedControlId
	};
	
	if (sOptionMenuId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sOptionMenuId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "OptionMenuId");
			}
		}
	if (sConnectedControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sConnectedControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ConnectedControlId");
			}
		}
	this["fireSemanticEvent"]("Paginator", "MenuOpen", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Paginator["_"]["fireMenuOpen"] = 0; };

};
sap["ls"]["preload"]["UCF_Panel"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_PanelBase */
/// <reference path="./base/PanelBase.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>
/* global UCF_PanelDragDelegate */
/// <reference path="./delegates/PanelDragDelegate.js"/>
/* global UCF_PanelDropDelegate */
/// <reference path="./delegates/PanelDropDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Panel(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Panel["_"]["UCF_Panel"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "Panel.js(35): UCF_Panel"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef !== null, "oDomRef !== null", "Panel.js(36): UCF_Panel"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Panel.js(37): UCF_Panel"); };

	UCF_PanelBase["apply"](this, [oDomRef, oLS]);

	//  create scroll area helper
	// scroll area only exists when a height is provided
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oScrollArea"] = (this["sScrollingMode"] !== 'NONE')
		? UCF_ClassLoader["oGetClass"]('UCF_ScrollArea')["oCreateAndConnectScrollArea"](this, this["sScrollingMode"], 'onScroll')
		: null;

	this["oFocusDomRef"] = this["bIsCollapsible"] ? UCF_DomUtil["$"](this["sId"] + '-title') : null;
	// initialize the default button for this control
	this["setDefaultButtonId"](this["sDefaultButtonId"]);
};window["UCF_Panel"] = UCF_Panel; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Panel"); UCF_Panel["_"] = {UCF_Panel: 0}; }; ;

UCF_Panel["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PanelBase"))(); UCF_Panel.prototype["sClassName"] = "UCF_Panel";

UCF_Panel["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["initialize"]++; }; 

	// initialize drag handle
	if (this["bIsDragHandle"]) {
		var oHandleDomRef = UCF_DomUtil["$"](this["sId"] + '-draghandle');

		if (oHandleDomRef)
			this["initializeHandle"](oHandleDomRef);
	}
	// create inplace edit objects and fields
	if (this["bHasEditableTitle"]) {
		var oInplaceEditDelegate = this["oInplaceEditDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEditDelegate"))(this["oLS"]);

		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this, 'onInplaceEditStart');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this, 'onInplaceEditFinished');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this, 'onInplaceEditClosed');
		this["addDelegate"](oInplaceEditDelegate);
	}

	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) {
		this["oScrollArea"] = (this["oGetParent"]()["sScrollingMode"] !== 'NONE') //scroll area only exists when a height is provided
			? UCF_ClassLoader["oGetClass"]('UCF_ScrollArea')["oCreateAndConnectScrollArea"](this, this["sScrollingMode"], 'onScroll')
			: null;

		if (this["oScrollArea"]) {
			this["oGetParent"]()["addDelegate"](this["oScrollArea"]);
			this["oScrollArea"]["setScrollPosition"](this["oGetParent"]()["iScrollTop"], this["oGetParent"]()["iScrollLeft"]);
		}
	} else {
		if (this["oScrollArea"]) {
			this["oScrollArea"]["setScrollPosition"](this["iScrollTop"], this["iScrollLeft"]);
		}
	}

	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;

	if ((window["UCF_System"]["sDevice"] === 'standards'
			&& (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()))
		|| (this["sWidth"] === '100%' || this["sHeight"] === '100%')) {
		this["attachBrowserEvent"]('resize', this["oDomRef"]);
	}
	this["correctPanelHeight"]();
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iDomRefHeight"] = this["oDomRef"]["offsetHeight"];
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iDomRefWidth"] = this["oDomRef"]["offsetWidth"];

};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["initialize"] = 0; };

UCF_Panel["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["onresize"]++; }; 

	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;

	if (this["sHeaderDesign"] !== 'UNDERLINE'
		&& !(window["UCF_System"]["sDevice"] === 'standards'
			&& (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()))
		&& !(this["sWidth"] === '100%' || this["sHeight"] === '100%')) return;

	if (this["sTimeOutId"] !== null) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
	}
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResize');
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["onresize"] = 0; };

UCF_Panel["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["onAfterResize"]++; }; 
	var oHeaderToolbar = this["oGetHeaderToolbar"]();

	if (oHeaderToolbar !== null) {
		var oIndicator = UCF_DomUtil["$"](oHeaderToolbar["sId"] + '-menuindicator');

		if (oIndicator === null)
			return;

		if (!oHeaderToolbar["bIsWrapping"]()) {
			oIndicator["style"]["backgroundPosition"] = 'right -1000';
		} else {
			oIndicator["style"]["backgroundPosition"] = 'right center';
		}
	}

	if ((!this["bCollapsed"] && this["oDomRef"]
			&& this["iDomRefHeight"] !== this["oDomRef"]["offsetHeight"])
		|| (this["oDomRef"] && this["iDomRefWidth"] !== this["oDomRef"]["offsetWidth"])) {
		// Notify framework, that layout has changed toggling the Panel
		//_trace(INFO, '================= Panel - id - ' + this.sId + ' - After Resize - ');
		this["notifyLayoutChange"]();
		this["correctPanelHeight"]();
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iDomRefHeight"] = this["oDomRef"]["offsetHeight"];
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iDomRefWidth"] = this["oDomRef"]["offsetWidth"];

	}
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["onAfterResize"] = 0; };

/************************************************************
 * ########### Scroll Area Section #######################
 *****************************************************************/

UCF_Panel["prototype"]["createScrollHelper"] = function() {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["createScrollHelper"]++; }; 

	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;

	var oScrollDomRef = UCF_DomUtil["$"](this["sId"] + '-scrl');

	this["oScrollArea"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(oScrollDomRef);
	this["attachBrowserEvent"]('scroll', oScrollDomRef);
	this["oScrollArea"]["attachEvent"](this["oScrollArea"]["E_EVENTS"]["Scroll"], this, 'onScroll');
	this["addDelegate"](this["oScrollArea"]);
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["createScrollHelper"] = 0; };

/**
 * Handle the area scroll event
 *
 * @param {UCF_Event} oEvent
 */
UCF_Panel["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["onScroll"]++; }; 
	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;

	var iScrollTop = oEvent["oGetParam"]('iScrollTop'),
		iScrollLeft = oEvent["oGetParam"]('iScrollLeft'),
		oScrollContainer = UCF_DomUtil["$"](this["sId"] + '-scrl');

	if (oScrollContainer["offsetHeight"] !== oScrollContainer["scrollHeight"]
		|| oScrollContainer["offsetWidth"] !== oScrollContainer["scrollWidth"]) {
		this["fireScroll"](this["sId"], iScrollTop, iScrollLeft);
	}
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["onScroll"] = 0; };

UCF_Panel["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["destroy"]++; }; 
	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}

	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}

	if (this["oInplaceEditDelegate"]) {
		this["oInplaceEditDelegate"]["destroy"]();
		this["oInplaceEditDelegate"] = null;
	}

	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;

	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}

	if (this["sHeaderDesign"] === 'UNDERLINE' || (window["UCF_System"]["sDevice"] === 'standards'
			&& (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()))
		|| (this["sWidth"] === '100%' || this["sHeight"] === '100%')) {
		this["detachBrowserEvent"]('resize', this["oDomRef"]);
	}
	UCF_PanelBase.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["destroy"] = 0; };

/*****************************************************
 * ########## Drag and Drop Section ##################
 **************************************************** * */

/**
 * implements method from UCF_Control
 */
UCF_Panel["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["createDragDelegate"]++; }; 

	if (!this["sDragSourceInfo"])
		return;

	if (this["oDragDelegate"])
		return;

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_PanelDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["createDragDelegate"] = 0; };

/**
 * implements method from UCF_Control
 */
UCF_Panel["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["createDropDelegate"]++; }; 

	if (!this["sDropTargetInfo"])
		return;

	if (this["oDropDelegate"])
		return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_PanelDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["createDropDelegate"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 * @public
 */
UCF_Panel["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["setDefaultButtonId"]++; }; 
	UCF_PanelBase.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["setDefaultButtonId"] = 0; };

/**
 * Sets the visibility state of the Panel control.
 * @param { string } sVisibility
 * @public
 */
UCF_Panel["prototype"]["setVisibility"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["setVisibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sVisibility) === 'string', "typeof(sVisibility) === 'string'", "Panel.js(271): setVisibility"); };

	UCF_DomUtil["setVisibility"](this["oDomRef"], sVisibility);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sVisibility"] = sVisibility;
	this["setClientProperty"]("Visibility", this["sVisibility"], true);
	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) {
		// update parent
		var oPanelStack = this["oGetParent"]();

		if (oPanelStack) {
			oPanelStack["iWidth"] = 0;
			oPanelStack["onAfterResize"]();
			//oPanelStack.createPopupMenuItems();
			if (oPanelStack["sSelectedPanelId"] === this["sId"]) {
				// the selected Panel
				var oPanelContent = UCF_DomUtil["$"](this["sId"] + '-cntwhl');

				if (oPanelContent) {
					UCF_DomUtil["setVisibility"](oPanelContent, sVisibility);
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["setVisibility"] = 0; };

/**
 * @private - overwrites the Control.removeForcedFocus
 * Resets the tabindex that was set in addForcedFocus method and detaches the
 * blur handler, but not when the Panel is in PanelStack and it's selected
 * @param {element} oDomRef the dom reference where the tabindex was set
 */
UCF_Panel["prototype"]["removeForcedFocus"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["removeForcedFocus"]++; }; 
	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) {
		var oPanelStack = this["oGetParent"]();

		if (oPanelStack["sSelectedPanelId"] !== this["sId"]) {
			UCF_PanelBase.prototype["removeForcedFocus"]["apply"](this, arguments);
		}
	} else
		UCF_PanelBase.prototype["removeForcedFocus"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["removeForcedFocus"] = 0; };

/** Returns the visibility of the Panel control.
 * For the parameter values see enumeration 'Visibility'.
 * @public
 * @return {string} Returns the Visibility
 */

UCF_Panel["prototype"]["getVisibility"] = function() {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["getVisibility"]++; }; 
	return this["sVisibility"];
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["getVisibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Panel["prototype"]["aAttributeNames"] = ["sVisibility","sTooltip","sWidth","sHeight","sDefaultButtonId","sHotkeysId","sDragSourceInfo","sDropTargetInfo","sTitle","bHasEditableTitle","sAccessibilityDescription","sImageSrc","bIsCollapsible","bClientCollapse","bCollapsed","sCollapseIconPosition","bEnabled","sHeaderDesign","bIsDragHandle","iHeadingLevel","sAccessKey","sScrollingMode","iScrollTop","iScrollLeft","bTitleOverflow","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Panel["prototype"]["aEventNames"] = ["Collapse","Expand","Change","Scroll","Hotkey","MenuAccess","Drop"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Panel["prototype"]["aMethodNames"] = ["setDefaultButtonId","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Panel["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Panel["prototype"]["bHasEditableTitle"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sImageSrc"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Panel["prototype"]["bIsCollapsible"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_Panel["prototype"]["bClientCollapse"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_Panel["prototype"]["bCollapsed"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CollapseIconPosition}
 */
UCF_Panel["prototype"]["sCollapseIconPosition"] = "START";

/**
 * @private
 * @type {boolean}
 */
UCF_Panel["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HeaderDesign}
 */
UCF_Panel["prototype"]["sHeaderDesign"] = "STANDARD";

/**
 * @private
 * @type {boolean}
 */
UCF_Panel["prototype"]["bIsDragHandle"] = false;

/**
 * @private
 * @type {number}
 */
UCF_Panel["prototype"]["iHeadingLevel"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ScrollingMode}
 */
UCF_Panel["prototype"]["sScrollingMode"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_Panel["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_Panel["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_Panel["prototype"]["bTitleOverflow"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Panel["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Panel["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sWidth"] = '';
	this["sHeight"] = '';
	this["sDefaultButtonId"] = '';
	this["sHotkeysId"] = '';
	this["sDragSourceInfo"] = '';
	this["sDropTargetInfo"] = '';
	this["sTitle"] = '';
	this["bHasEditableTitle"] = false;
	this["sAccessibilityDescription"] = '';
	this["sImageSrc"] = '';
	this["bIsCollapsible"] = true;
	this["bClientCollapse"] = true;
	this["bCollapsed"] = false;
	this["sCollapseIconPosition"] = "START";
	this["bEnabled"] = true;
	this["sHeaderDesign"] = "STANDARD";
	this["bIsDragHandle"] = false;
	this["iHeadingLevel"] = 0;
	this["sAccessKey"] = '';
	this["sScrollingMode"] = "NONE";
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["bTitleOverflow"] = false;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("HasEditableTitle", false, true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("ImageSrc", '', true);
		this["setClientProperty"]("IsCollapsible", true, true);
		this["setClientProperty"]("ClientCollapse", true, true);
		this["setClientProperty"]("Collapsed", false, true);
		this["setClientProperty"]("CollapseIconPosition", "START", true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("HeaderDesign", "STANDARD", true);
		this["setClientProperty"]("IsDragHandle", false, true);
		this["setClientProperty"]("HeadingLevel", 0, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("ScrollingMode", "NONE", true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("TitleOverflow", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The id of the HeaderArea.
 * @fires Panel::Collapse
 */
UCF_Panel["prototype"]["fireCollapse"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Panel.js(579): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Panel.js(580): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Panel.js(581): fireCollapse"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Panel", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the HeaderArea.
 * @fires Panel::Expand
 */
UCF_Panel["prototype"]["fireExpand"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireExpand"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Panel.js(598): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Panel.js(599): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Panel.js(600): fireExpand"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Panel", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireExpand"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the Accordion.
 * @param {string} sValue The new tile.
 * @fires Panel::Change
 */
UCF_Panel["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Panel.js(618): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Panel.js(619): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Panel.js(620): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "Panel.js(621): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Panel.js(622): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("Panel", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires Panel::Scroll
 */
UCF_Panel["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Panel.js(643): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Panel.js(644): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Panel.js(645): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "Panel.js(646): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "Panel.js(647): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "Panel.js(648): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "Panel.js(649): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("Panel", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires Panel::Hotkey
 */
UCF_Panel["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Panel.js(674): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Panel.js(675): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Panel.js(676): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "Panel.js(677): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "Panel.js(678): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "Panel.js(679): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "Panel.js(680): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	
	if (sProviderId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sProviderId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ProviderId");
			}
		}
	this["fireSemanticEvent"]("Panel", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireHotkey"] = 0; };

/**
 * @protected
 * @param {string} sId DEPRECATED
 * @param {string} sPopupMenuId DEPRECATED
 * @param {boolean} bWithKeyboard DEPRECATED
 * @fires Panel::MenuAccess
 * @deprecated
 */
UCF_Panel["prototype"]["fireMenuAccess"] = function(sId, sPopupMenuId, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string, PopupMenuId: string, WithKeyboard: boolean}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Panel.js(711): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Panel.js(712): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Panel.js(713): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPopupMenuId != null, "sPopupMenuId != null", "Panel.js(714): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPopupMenuId) == "string", "typeof(sPopupMenuId) == \"string\"", "Panel.js(715): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bWithKeyboard != null, "bWithKeyboard != null", "Panel.js(716): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bWithKeyboard) == "boolean", "typeof(bWithKeyboard) == \"boolean\"", "Panel.js(717): fireMenuAccess"); };
	mParams = {
		"Id": sId,
		"PopupMenuId": sPopupMenuId,
		"WithKeyboard": bWithKeyboard
	};
	
	if (sPopupMenuId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sPopupMenuId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "PopupMenuId");
			}
		}
	
	this["fireSemanticEvent"]("Panel", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireMenuAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSourceId Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires Panel::Drop
 */
UCF_Panel["prototype"]["fireDrop"] = function(sId, sDragSourceId, sDropTargetInfo, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSourceId: string, DropTargetInfo: string, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 10, "arguments.length == 10", "Panel.js(752): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Panel.js(753): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Panel.js(754): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceId != null, "sDragSourceId != null", "Panel.js(755): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceId) == "string", "typeof(sDragSourceId) == \"string\"", "Panel.js(756): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "Panel.js(757): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "Panel.js(758): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "Panel.js(759): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "Panel.js(760): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "Panel.js(761): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "Panel.js(762): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "Panel.js(763): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "Panel.js(764): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "Panel.js(765): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "Panel.js(766): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "Panel.js(767): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "Panel.js(768): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "Panel.js(769): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "Panel.js(770): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "Panel.js(771): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "Panel.js(772): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSourceId": sDragSourceId,
		"DropTargetInfo": sDropTargetInfo,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("Panel", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Panel["_"]["fireDrop"] = 0; };

UCF_Panel.prototype["aPublicMethods"] = ["setDefaultButtonId","setVisibility"].concat(UCF_Panel.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PanelBase"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../../core/util/XSSEncoder.js"/>
/* global UCF_Animation */
/// <reference path="../../anim/Animation.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_UrBase */
/// <reference path="./UrBase.js"/>

/**
 * @class
 * Helper Class for all controls that use the BaseFragment of the HeaderArea Control
 * and for the Header Area Control itself
 * @param { HTMLElement } oDomRef
 * @param { UCF_LS } oLS
 * 
 *
 * @version
 */
function UCF_PanelBase(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["UCF_PanelBase"]++; }; 

	// necessary for inheritance
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PanelBase.js(45): UCF_PanelBase"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PanelBase.js(46): UCF_PanelBase"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PanelBase.js(47): UCF_PanelBase"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	//create animation objects and fields
	var iTimeout = (UCF_UserAgent["bIsIE"]()) ? 300 : 500;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oExpandAnimation"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))();
	this["oExpandAnimation"]["setTime"](iTimeout);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oCollapseAnimation"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))();
	this["oCollapseAnimation"]["setTime"](iTimeout);
	this["iAnimsFinished"] = 0;
	this["maxHeight"] = 0;
	this["maxWidth"] = 0;
	this["minWidth"] = 0;
	this["bLocked"] = false;
	this["sEmbedingType"] = 'NONE';
	//is only true for IE Standards mode when by the first rendering
	//bIsCollapsed=true
	this["bNeedsHeightCalculation"] = false;
	this["iHeaderHeight"] = -1;
	this["iToolbarHeight"] = -1;
	this["iSeparatorHeight"] = -1;
	// for resize
	this["iDomRefHeight"] = -1;
	this["iDomRefWidth"] = -1;
	this["bDynamicHeaderFunctions"] = false;
	this["sTitleSuffiex"] = '';
	this["oToggleEndButton"] = this["attachToggleEndButtonEvents"]();
	this["bIsStandardsMode"] = window["UCF_System"]["sDevice"] === 'standards';
	this["oTitle"] = UCF_DomUtil["$"](this["sId"] + '-title');
	if (this["oTitle"])
		this["allowTextSelection"](this["oTitle"]);
};window["UCF_PanelBase"] = UCF_PanelBase; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PanelBase"); UCF_PanelBase["_"] = {UCF_PanelBase: 0}; }; ;

UCF_PanelBase["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PanelBase.prototype["sClassName"] = "UCF_PanelBase";

UCF_PanelBase["prototype"]["eEmbeddingType"] = {
	"PANEL_STACK": 'PST',
	"NONE": 'NONE'
};

UCF_PanelBase["prototype"]["setEmbeddingType"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["setEmbeddingType"]++; }; 
	this["sEmbedingType"] = sType;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["setEmbeddingType"] = 0; };

UCF_PanelBase["prototype"]["sGetEmbeddingType"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["sGetEmbeddingType"]++; }; 
	return this["sEmbedingType"];
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["sGetEmbeddingType"] = 0; };

/*******************************************
 *######## Generic Listeners Section #######
 *******************************************/

/**
 * handles the mouse over event:
 * - initializes fields laizy
 * - applies hover effect, when title has menu associated
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onmouseover"]++; }; 

	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;

	//initialize Toolbar as DragHandle if bIsDaragHandle is on
	if (this["bIsDragHandle"] && this["oGetHeaderToolbar"]() != null) {
		var oHeaderToolbar = this["oGetHeaderToolbar"]();
		oHeaderToolbar["bIsDragHandle"] = true;
		oHeaderToolbar["initializeHandle"](oHeaderToolbar["oDomRef"]);
	}

	if (window["UCF_System"]["bIs508"]) return;
	var oSource = oBrowserEvent["oGetSource"](),
		oDomRefContent = UCF_DomUtil["$"](this["sId"] + '-caCnt');

	if (oSource === oDomRefContent) return;

	var oDomRefTitle = UCF_DomUtil["$"](this["sId"] + '-titlearea') || UCF_DomUtil["$"](this["sId"] + '-titletext'),
		oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + '-titletext');

	UCF_DomUtil["checkTooltip"](oDomRefTitle, this["sTooltip"], oDomRefOvfl);
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onmouseover"] = 0; };

/**
 * @private
 * @return {Array}
 */
UCF_PanelBase["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	var oDomRefTitle = UCF_DomUtil["$"](this["sId"] + '-titlearea'),
		oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + '-titletext');

	if (oDomRefTitle && oDomRefOvfl &&
		UCF_DomUtil["bHasTextEllipsis"](oDomRefTitle, oDomRefOvfl)) {
		aResult["push"]({
			"sType": 'TEXT',
			"sText": UCF_DomUtil["sGetInnerText"](oDomRefOvfl)
		});
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["aGetTouchContextMenuEntries"] = 0; };

/**
 * Handles the on click event:
 * - toggling header and content, if content is available
 * - opens and closes title menu
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onclick"]++; }; 

	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;

	if (!this["bEnabled"]) return;

	var oSource = oBrowserEvent["oGetSource"]();
	var oSourceControl = oBrowserEvent["oSourceControl"];

	//toggle header and content
	if (this["bIsCollapsible"]) {

		if (this["bClientCollapse"] && this["bIsClickableArea"](oSource)) {
			this["togglePanel"]();
			// Notify framework, that layout has changed toggling the Panel
			//The notify is done in toggleContent()
			//this.notifyLayoutChange();
		}
	}

	if (oSourceControl === this) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onclick"] = 0; };

/**
 *
 * @private
 * @return {UCF_Control}
 */
UCF_PanelBase["prototype"]["attachToggleEndButtonEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["attachToggleEndButtonEvents"]++; }; 
	/** @type {UCF_PanelBase} */
	var self = this;
	var oToggleEndDomRef = UCF_DomUtil["$"](this["sId"] + '-tglend');
	if (oToggleEndDomRef) {
		var oButton = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oToggleEndDomRef, true);
		if (oButton) {
			oButton["attachSemanticEvent"]('Press', self, 'togglePanel');
			return oButton;
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["attachToggleEndButtonEvents"] = 0; };

/**
 * Set the focus on Title Area
 * @private
 *
 */
UCF_PanelBase["prototype"]["setFocusOnHeader"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["setFocusOnHeader"]++; }; 
	var oTitle;
	if (!this["bIsCollapsible"]) return;

	if (this["sEmbedingType"] === 'NONE') {
		// should expand only when the active element is the Toggle Icon
		oTitle = UCF_DomUtil["oGetActiveElement"]();
		this["refocus"](oTitle);

	} else {
		// In PanelStack
		oTitle = UCF_DomUtil["$"](this["sId"] + '-title');
		UCF_DomUtil["focusDomElement"](oTitle);
	}

};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["setFocusOnHeader"] = 0; };

/** @private */
UCF_PanelBase["prototype"]["togglePanel"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["togglePanel"]++; }; 

	this["toggleHeader"]();

	if (this["oGetContentArea"]() != null) {
		this["toggleContent"]();
	}

	if (this["bCollapsed"]) {
		this["setClientProperty"]('Collapsed', this["bCollapsed"], true);
		this["fireExpand"](this["sId"]);
	} else {
		this["setClientProperty"]('Collapsed', this["bCollapsed"], true);
		this["fireCollapse"](this["sId"]);
	}
	this["bCollapsed"] = !this["bCollapsed"];
	this["setFocusOnHeader"]();
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["togglePanel"] = 0; };

/**
 * Handles the enter event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsenter"]++; }; 
	this["onlsspace"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsenter"] = 0; };

/**
 * Handles the space event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsspace"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PanelBase.js(263): onlsspace"); };
	this["onclick"](oBrowserEvent);
	// The event should be canceled only when the space is press on the Toggle area
	var oSource = oBrowserEvent["oGetSource"]();
	if (this["bIsClickableArea"](oSource)) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsspace"] = 0; };

/**
 * Handles the onlsfocus event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PanelBase.js(280): onlsfocus"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oDomRef"]) {
		if (this["bIsCollapsible"])
			this["setFocusOnHeader"]();
		else {
			// set the focus to the first element from Content
			var oNextContainer = UCF_DomUtil["$"](this["sId"] + '-tbar') || this["oGetContentArea"]();
			if (oNextContainer)
				UCF_DomUtil["focusDomElement"](UCF_DomUtil["oGetFirstFocusableDomRef"](oNextContainer));
		}
	}

};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsfocus"] = 0; };

/*****************************************
 * ######## Start of Toggle Section ######
 ****************************************/

/**
 * Toggles the header area
 * @private
 */
UCF_PanelBase["prototype"]["toggleHeader"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["toggleHeader"]++; }; 
	if (this["bIsStandardsMode"]) {
		this["toggleHeaderStyleStandardsMode"]();
	} else {
		this["toggleHeaderStyle"]();
		this["adjustHeaderFunctionWidth"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["toggleHeader"] = 0; };
/**
 * Adjusts width of header functions (also called by PanelStack.js)
 * @private
 */
UCF_PanelBase["prototype"]["adjustHeaderFunctionWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["adjustHeaderFunctionWidth"]++; }; 

	var iLength = 0,
		oHdrFnctCell,
		oHdrFnctSpan,
		iBtnFnctWidth,
		iToggleFnctWidth,
		iWidth;

	//invalidate header functions, if there are header functions with Visibility.ON_DEMAND
	if (this["bHasDynamicHeaderFunctions"]()) {
		this["invalidateHeaderFunctions"]();
	}
	//adjust width of header functions cell
	if (this["oGetHeaderFunctions"]()) iLength = this["oGetHeaderFunctions"]()["length"];
	if (this["bHasDynamicHeaderFunctions"]()) {

		oHdrFnctCell = UCF_DomUtil["$"](this["sId"] + '-functions');
		oHdrFnctSpan = UCF_DomUtil["$"](this["sId"] + '-functionsInner');
		iBtnFnctWidth = (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsEdgeHtml"]) ? 27 : 25;
		iToggleFnctWidth = (UCF_DomUtil["$"](this["sId"] + '-tglend')) ? 17 : 0;
		iWidth = iToggleFnctWidth + (iLength * iBtnFnctWidth);
		if (oHdrFnctCell) oHdrFnctCell["style"]["width"] = iWidth + 'px';
		if (oHdrFnctSpan) oHdrFnctSpan["style"]["width"] = iWidth + 'px';

	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["adjustHeaderFunctionWidth"] = 0; };

/**
 * Set the press state of thge toggle
 * @param {boolean} bDown - down flag
 * @private
 */
UCF_PanelBase["prototype"]["pressToogleButton"] = function(bDown) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["pressToogleButton"]++; }; 
	var oToggleButton = UCF_DomUtil["$"](this["sId"] + '-tgl');
	if (oToggleButton) {
		if (bDown)
			UCF_DomUtil["addClass"](oToggleButton, 'lsHeaderArea--toggle-pressed');
		else
			UCF_DomUtil["removeClass"](oToggleButton, 'lsHeaderArea--toggle-pressed');
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["pressToogleButton"] = 0; };

UCF_PanelBase["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PanelBase.js(359): onkeydown"); };

	/** @type {int} */
	var iKeyCode = oBrowserEvent["iKeyCode"]();
	if (iKeyCode !== UCF_KeyCodes["SPACE"] && iKeyCode !== UCF_KeyCodes["ENTER"]) return;
	// The event should be canceled only when the space is press on the Toggle area
	var oSource = oBrowserEvent["oGetSource"](),
		oToggleButton = UCF_DomUtil["$"](this["sId"] + '-tgl');
	if (oSource === oToggleButton) {
		this["pressToogleButton"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onkeydown"] = 0; };

UCF_PanelBase["prototype"]["onkeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onkeyup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PanelBase.js(373): onkeyup"); };
	/** @type {int} */
	var iKeyCode = oBrowserEvent["iKeyCode"]();
	if (iKeyCode !== UCF_KeyCodes["SPACE"] && iKeyCode !== UCF_KeyCodes["ENTER"]) return;
	// The event should be canceled only when the space is press on the Toggle area
	var oSource = oBrowserEvent["oGetSource"](),
		oToggleButton = UCF_DomUtil["$"](this["sId"] + '-tgl');
	if (oSource === oToggleButton) {
		this["pressToogleButton"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onkeyup"] = 0; };

/**
 * Toggles the header area by changing the style
 * @private
 */
UCF_PanelBase["prototype"]["toggleHeaderStyleStandardsMode"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["toggleHeaderStyleStandardsMode"]++; }; 

	var oToggleButton = UCF_DomUtil["$"](this["sId"] + '-tgl'),
		oTitle = UCF_DomUtil["$"](this["sId"] + '-title'),
		oHeaderContent = UCF_DomUtil["$"](this["sId"] + '-titlecontent'),
		oEmdeddedContent = UCF_DomUtil["$"](this["sId"] + '-embedded') || this["oDomRef"];

	if (this["bCollapsed"]) {

		// add class to toggle visibility on demand for header functions
		UCF_DomUtil["addClass"](oHeaderContent, 'lsHeaderArea--content-expanded');
		UCF_DomUtil["removeClass"](oHeaderContent, 'lsHeaderArea--content-collapsed');

		// add class to toggle visibility on demand for header functions
		UCF_DomUtil["addClass"](oEmdeddedContent, 'lsHeaderArea--expanded');
		UCF_DomUtil["removeClass"](oEmdeddedContent, 'lsHeaderArea--collapsed');
		// collapse icon at the beginning
		if (this["sCollapseIconPosition"] !== 'END' && oToggleButton) {
			UCF_DomUtil["replaceClass"](oToggleButton, 'lsHeaderArea--toggle-collapsed', 'lsHeaderArea--toggle-expanded');
		}
		// set aria-expanded true
		if (window["UCF_System"]["bIsAria"] && oTitle) {
			// panel: the expanded state is set at the toggle area / html a tag
			if (this["sCollapseIconPosition"] !== 'END')
				UCF_AriaStateHelper["setExpanded"](oTitle, true);

		}
	} else {

		UCF_DomUtil["addClass"](oHeaderContent, 'lsHeaderArea--content-collapsed');
		UCF_DomUtil["removeClass"](oHeaderContent, 'lsHeaderArea--content-expanded');

		UCF_DomUtil["addClass"](oEmdeddedContent, 'lsHeaderArea--collapsed');
		UCF_DomUtil["removeClass"](oEmdeddedContent, 'lsHeaderArea--expanded');

		// collapse icon at the beginning
		if (this["sCollapseIconPosition"] !== 'END' && oToggleButton) {
			UCF_DomUtil["replaceClass"](oToggleButton, 'lsHeaderArea--toggle-expanded', 'lsHeaderArea--toggle-collapsed');

		}

		// set aria-expanded false
		if (window["UCF_System"]["bIsAria"] && oTitle) {
			// panel: the collapsed state is set at the toggle area / html a tag
			if (this["sCollapseIconPosition"] !== 'END')
				UCF_AriaStateHelper["setExpanded"](oTitle, false);

		}
	}

	this["toggleEndButton"]();
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["toggleHeaderStyleStandardsMode"] = 0; };

/**
 * Toggles the header area by changing the style
 * @private
 */
UCF_PanelBase["prototype"]["toggleHeaderStyle"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["toggleHeaderStyle"]++; }; 

	var oTglBtnIcon = UCF_DomUtil["$"](this["sId"] + '-tgl'),
		oHdrArInnerTable = UCF_DomUtil["$"](this["sId"] + '-HdrArInner');

	if (this["sHeaderDesign"] === 'STANDARD') {
		// the left and right corner
		var oLeft = UCF_DomUtil["$"](this["sId"] + '-title'),
			oRight = UCF_DomUtil["$"](this["sId"] + '-right');

		if (this["bCollapsed"]) {
			UCF_DomUtil["replaceClass"](oLeft, 'lsHdArLeft2Col', 'lsHdArLeft2Exp');
			if (oRight)
				UCF_DomUtil["replaceClass"](oRight, 'lsHdArRight2Col', 'lsHdArRight2Exp');
		} else {
			UCF_DomUtil["replaceClass"](oLeft, 'lsHdArLeft2Exp', 'lsHdArLeft2Col');
			if (oRight)
				UCF_DomUtil["replaceClass"](oRight, 'lsHdArRight2Exp', 'lsHdArRight2Col');
		}
	}

	if (this["bCollapsed"]) {

		// add class to toggle visibility on demand for header functions
		UCF_DomUtil["addClass"](oHdrArInnerTable, 'lsHeaderArea__state--expanded');
		UCF_DomUtil["removeClass"](oHdrArInnerTable, 'lsHeaderArea__state--collapsed');
		// collapse icon at the beginning
		if (this["sCollapseIconPosition"] !== 'END' && oTglBtnIcon) {
			UCF_DomUtil["replaceClass"](oTglBtnIcon, 'lsHdArTglIconColl', 'lsHdArTglIconExp');
			UCF_DomUtil["replaceClass"](oTglBtnIcon, 'lsHdArCol2', 'lsHdArExp2');
		}

		// set aria-expanded true
		if (window["UCF_System"]["bIsAria"] && oTglBtnIcon) {
			// panel: the expanded state is set at the toggle area / html a tag
			UCF_AriaStateHelper["setExpanded"](oTglBtnIcon, true);
		}
	} else {

		// remove class to toggle visibility on demand for header functions
		UCF_DomUtil["addClass"](oHdrArInnerTable, 'lsHeaderArea__state--collapsed');
		UCF_DomUtil["removeClass"](oHdrArInnerTable, 'lsHeaderArea__state--expanded');
		// collapse icon at the beginning
		if (this["sCollapseIconPosition"] !== 'END' && oTglBtnIcon) {
			UCF_DomUtil["replaceClass"](oTglBtnIcon, 'lsHdArExp2', 'lsHdArCol2');
			UCF_DomUtil["replaceClass"](oTglBtnIcon, 'lsHdArTglIconExp', 'lsHdArTglIconColl');

		}
		// set aria-expanded false
		if (window["UCF_System"]["bIsAria"] && oTglBtnIcon) {
			// panel: the collapsed state is set at the toggle area / html a tag
			UCF_AriaStateHelper["setExpanded"](oTglBtnIcon, false);
		}
	}
	this["toggleEndButton"]();
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["toggleHeaderStyle"] = 0; };

/**
 * Toggles the header area by changing the style
 * @private
 */
UCF_PanelBase["prototype"]["toggleEndButton"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["toggleEndButton"]++; }; 

	var oTglBtnImageEnd = UCF_DomUtil["$"](this["sId"] + '-tglend-img');

	if (this["bCollapsed"]) {
		// the collapse icon at the end
		if (this["oToggleEndButton"] != null) {
			UCF_DomUtil["replaceClass"](oTglBtnImageEnd, 'urBtnTypeMaximize', 'urBtnTypeMinimize');
			UCF_DomUtil["replaceClass"](this["oToggleEndButton"]["oDomRef"], 'urBtnTypeMaximize', 'urBtnTypeMinimize');
			this["oToggleEndButton"]["setTooltip"](this["oLS"]["sGetText"]('SAPUR_BTNTYP_MINIMIZE'));
		}

	} else {

		// the collapse icon at the beginning
		if (this["oToggleEndButton"] != null) {
			UCF_DomUtil["replaceClass"](oTglBtnImageEnd, 'urBtnTypeMinimize', 'urBtnTypeMaximize');
			UCF_DomUtil["replaceClass"](this["oToggleEndButton"]["oDomRef"], 'urBtnTypeMinimize', 'urBtnTypeMaximize');
			this["oToggleEndButton"]["setTooltip"](this["oLS"]["sGetText"]('SAPUR_BTNTYP_MAXIMIZE'));
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["toggleEndButton"] = 0; };

/**
 * Toggles the content area depending on whether there is one.
 * @private
 */
UCF_PanelBase["prototype"]["toggleContent"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["toggleContent"]++; }; 

	var oContent = this["oGetContentArea"](),
		oTbar = UCF_DomUtil["$"](this["sId"] + '-tbar');

	if (oContent != null) {
		if (window["UCF_System"]["bUseAnimation"]) {
			var sUnits = (this["sHeight"] !== '' && this["sHeight"]["indexOf"]('%') > -1) ? '%' : 'px';
			var oHeader = UCF_DomUtil["$"](this["sId"] + '-right') || UCF_DomUtil["$"](this["sId"] + '-embedded');
			var minHeight = 0,
				maxHeight = 0;

			if (this["maxHeight"] === 0) {
				if (this["sHeight"] !== '') {
					this["maxHeight"] = parseInt(this["sHeight"]);
				} else {
					this["maxHeight"] = this["oDomRef"]["offsetHeight"];
				}
			}

			if (this["bCollapsed"]) {
				//expand
				if (oTbar != null) {
					oTbar["style"]["overflow"] = 'hidden';
				}
				if (oHeader) {
					oHeader["style"]["overflow"] = 'hidden';
					minHeight = sUnits === '%' ? 15 : oHeader["offsetHeight"];
				}
				if (oTbar != null) {
					oTbar["style"]["display"] = (this["bCollapsed"]) ? '' : 'none';
					if (this["bCollapsed"])
						UCF_DomUtil["removeClass"](oTbar, 'lsControl--invisible');
				}
				this["oDomRef"]["style"]["overflow"] = '';
				this["oDomRef"]["style"]["height"] = this["sHeight"];
				this["oExpandAnimation"]["setDomRef"](this["oDomRef"]);
				this["oExpandAnimation"]["callbackStep"](this, 'notifyExpandFinished');
				this["oExpandAnimation"]["callbackFinish"](this, 'notifyExpandFinishedStd');
				//this.oExpandAnimation.addInitialStyleValue('display', '');
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '================= Panel - id - ' + this["sId"] + ' - expand - units - ' + sUnits + ' - height   - ' + minHeight + ' - to - ' + this["maxHeight"], "PanelBase.js(574): toggleContent"); };
				this["oExpandAnimation"]["addStyleChange"](
					/*sName:*/
					'height',
					/*sPrefix:*/
					'',
					/*sSuffix:*/
					sUnits,
					/*iStartValue:*/
					minHeight,
					/*iEndValue:*/
					this["maxHeight"],
					/*fnTransition:*/
					this["oExpandAnimation"]["M_TRANSITIONS"]["Linear"]
				);

				this["oExpandAnimation"]["play"]();
			} else {
				//collapse
				minHeight = oHeader["offsetHeight"];
				maxHeight = this["oDomRef"]["offsetHeight"];
				//collapse
				if (oTbar != null) {
					oTbar["style"]["display"] = (this["bCollapsed"]) ? '' : 'none';
					if (this["bCollapsed"])
						UCF_DomUtil["removeClass"](oTbar, 'lsControl--invisible');
					oTbar["style"]["overflow"] = 'hidden';
				}
				if (oHeader) {
					oHeader["style"]["overflow"] = 'hidden';
				}
				this["oDomRef"]["style"]["overflow"] = 'hidden';
				this["oCollapseAnimation"]["setDomRef"](this["oDomRef"]);
				this["oCollapseAnimation"]["callbackFinish"](this, 'notifyCollapseFinished');
				//this.oCollapseAnimation.addFinalStyleValue('display', 'none');
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '================= Panel - id - ' + this["sId"] + ' - collapse  height   - ' + maxHeight + ' - to - ' + minHeight, "PanelBase.js(609): toggleContent"); };
				this["oCollapseAnimation"]["addStyleChange"](
					/*sName:*/
					'height',
					/*sPrefix:*/
					'',
					/*sSuffix:*/
					'px',
					/*iStartValue:*/
					maxHeight,
					/*iEndValue:*/
					minHeight,
					/*fnTransition:*/
					this["oCollapseAnimation"]["M_TRANSITIONS"]["Linear"]
				);

				this["oCollapseAnimation"]["play"]();

			}
		} else {
			if (oTbar != null) {
				oTbar["style"]["display"] = (this["bCollapsed"]) ? '' : 'none';
				if (this["bCollapsed"])
					UCF_DomUtil["removeClass"](oTbar, 'lsControl--invisible');
			}
			if (this["bCollapsed"]) {
				oContent["style"]["display"] = '';
				UCF_DomUtil["removeClass"](oContent, 'lsControl--invisible');
				this["oDomRef"]["style"]["height"] = this["sHeight"] /*+ 'px'*/ ;
			} else {
				oContent["style"]["display"] = 'none';
			}

			this["notifyLayoutChange"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["toggleContent"] = 0; };

UCF_PanelBase["prototype"]["notifyExpandFinished"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["notifyExpandFinished"]++; }; 

	if (!this["bIsValid"]()) return;

	var oContent = this["oGetContentArea"](),
		oTbar = UCF_DomUtil["$"](this["sId"] + '-tbar');

	if (oContent != null) {
		oContent["style"]["display"] = '';
		UCF_DomUtil["removeClass"](oContent, 'lsControl--invisible');
	}
	if (oTbar != null) {
		oTbar["style"]["display"] = '';
		UCF_DomUtil["removeClass"](oTbar, 'lsControl--invisible');
	}
	// The notify is done in notifyExpandFinishedStd()
	// this.notifyLayoutChange();
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["notifyExpandFinished"] = 0; };

UCF_PanelBase["prototype"]["notifyExpandFinishedStd"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["notifyExpandFinishedStd"]++; }; 

	if (!this["bIsValid"]()) return;

	if (this["bNeedsHeightCalculation"]) {
		this["correctPanelHeight"]();
	}

	this["notifyLayoutChange"]();
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["notifyExpandFinishedStd"] = 0; };

UCF_PanelBase["prototype"]["notifyCollapseFinished"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["notifyCollapseFinished"]++; }; 

	if (!this["bIsValid"]()) return;

	var oContent = this["oGetContentArea"](),
		oTbar = UCF_DomUtil["$"](this["sId"] + '-tbar');

	if (oContent != null) {
		oContent["style"]["display"] = 'none';
	}
	if (oTbar != null) {
		oTbar["style"]["display"] = 'none';
	}
	var oHeader = UCF_DomUtil["$"](this["sId"] + '-right') || UCF_DomUtil["$"](this["sId"] + '-embedded');

	if (oHeader) {
		this["oDomRef"]["style"]["height"] = oHeader["offsetHeight"];
	}
	this["oDomRef"]["style"]["overflow"] = '';

	this["notifyLayoutChange"]();
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["notifyCollapseFinished"] = 0; };

/**
 * Handles the expand event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @param {boolean} bSetIsCollapsed
 * @private
 */
UCF_PanelBase["prototype"]["triggerExpandCollapseHeader"] = function(oBrowserEvent, bSetIsCollapsed) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["triggerExpandCollapseHeader"]++; }; 
	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;
	var oSourceControl = oBrowserEvent["oGetSourceControl"]();
	if (oSourceControl !== this) return;

	if (!this["bEnabled"] || !this["bIsCollapsible"] || !this["bClientCollapse"]) return;
	if (bSetIsCollapsed === this["bCollapsed"]) return;

	this["togglePanel"]();

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["triggerExpandCollapseHeader"] = 0; };

/**
 * Handles the expand event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsexpand"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PanelBase.js(729): onlsexpand"); };

	this["triggerExpandCollapseHeader"](oBrowserEvent, false);

};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsexpand"] = 0; };

/**
 * Handles the right arrow on the HeaderArea/ Panel
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsright"]++; }; 
	this["triggerExpandCollapseHeader"](oBrowserEvent, false);
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsright"] = 0; };

/**
 * Handles the collapse event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlscollapse"]++; }; 
	this["triggerExpandCollapseHeader"](oBrowserEvent, true);
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlscollapse"] = 0; };

/**
 * Handles the left arrow on the HeaderArea/ Panel
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsleft"]++; }; 
	this["triggerExpandCollapseHeader"](oBrowserEvent, true);
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsleft"] = 0; };

/********************************************
 * ######## Inplace Edit Section ######
 ********************************************/

/**
 * Start InplaceEdit in delayed double click
 * @param {Object} oParams
 * @private
 */
UCF_PanelBase["prototype"]["onInplaceEditStart"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onInplaceEditStart"]++; }; 

	//if (this.sGetEmbeddingType() != this.eEmbeddingType.NONE) return;

	var oBrowserEvent = oParams["mParameters"]["oBrowserEvent"],
		oSource = oBrowserEvent["oGetSource"](),
		oTitle = UCF_DomUtil["$"](this["sId"] + '-title'),
		oTitleText = UCF_DomUtil["$"](this["sId"] + '-titletext'),
		oEditDomRef = oTitleText || oTitle;

	var oBoundaries = UCF_DomUtil["oGetObjectRect"](oEditDomRef);

	if (!(oSource === oTitle)) return;

	oBoundaries["top"] += 1;

	this["oInplaceEditDelegate"]["setInplaceEditData"](
		oEditDomRef,
		oBoundaries,
		this["sTitle"]
	);

	var sTitle = UCF_DomUtil["sGetInnerText"](oEditDomRef);
	this["sTitle"] = sTitle;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onInplaceEditStart"] = 0; };

/**
 * Finish Inplace Edit on blur
 * @param { Object } oParams
 * @private
 */
UCF_PanelBase["prototype"]["onInplaceEditFinished"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onInplaceEditFinished"]++; }; 

	//	if (this.sGetEmbeddingType() != this.eEmbeddingType.NONE) return;

	var sText = UCF_XSSEncoder["encodeHTML"](oParams["oGetParam"]('sText'));

	if (sText === this["sTitle"]) return;

	var oTitle = UCF_DomUtil["$"](this["sId"] + '-titletext'),
		oFocusTitle = UCF_DomUtil["$"](this["sId"] + '-title'),
		oHeading = UCF_DomUtil["$"](this["sId"] + '-heading');

	if (!oTitle)
		oTitle = oFocusTitle;
	var sImageDomRefStr = null,
		bHasImage = this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"] && this["sImageSrc"] !== '';

	if (bHasImage) {
		sImageDomRefStr = oTitle["innerHTML"];
		sImageDomRefStr = sImageDomRefStr["replace"](UCF_StringUtil["sTrim"](this["sTitle"]), '');
	}
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oTitle, (bHasImage ? sImageDomRefStr : '') + new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(undefined, this["oLS"])["sAccessKeyTextFragment"](sText, this["sAccessKey"], this["bEnabled"]));
	if (oHeading) {
		oHeading["textContent"] = sText;
	}
	this["sTitle"] = sText;
	this["setClientProperty"]('Title', this["sTitle"], true);
	if (window["UCF_System"]["bIsAria"] && oFocusTitle && oFocusTitle["hasAttribute"]('aria-label')) {
		oFocusTitle["setAttribute"]('aria-label', sText + ' ' + this["oLS"]["sGetText"]('SAPUR_ACR_EDIT_TITLE') + ' ' + this["oLS"]["sGetText"]('SAPUR_ACR_LOCK_TITLE'));
	}
	if (window["UCF_System"]["bIsAria"] && UCF_DomUtil["$"](this["sId"] + '-arialabel')) {
		// change -arialabel text
		UCF_DomUtil["$"](this["sId"] + '-arialabel')["textContent"] = sText + ' ' + (this["sAccessibilityDescription"] && this["sAccessibilityDescription"] !== '' && this["sAccessibilityDescription"] !== sText ? this["sAccessibilityDescription"] + ' ' : '') + this["oLS"]["sGetText"]('SAPUR_ACR_EDIT_TITLE') + ' ' + this["oLS"]["sGetText"]('SAPUR_ACR_LOCK_TITLE');
	}
	if (!this["bIsStandalone"]()) {
		oFocusTitle["setAttribute"]('data-sap-ls-panel-title', sText);
	}

	var oPanelStack = this["oGetParent"]();

	if (UCF_JsUtil["bInstanceOf"](oPanelStack, "UCF_PanelStack") && oPanelStack["sSelectedPanelId"] !== this["sId"]) {
		var oAriaHeading = UCF_DomUtil["$"](oPanelStack["sId"] + '-heading');
		if (oAriaHeading)
			UCF_DomUtil["setInnerHtml"](oAriaHeading, UCF_XSSEncoder["encodeHTML"](sText));
	}

	this["fireChange"](this["sId"], sText);
	UCF_DomUtil["focusDomElement"](oFocusTitle);

};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onInplaceEditFinished"] = 0; };

UCF_PanelBase["prototype"]["onInplaceEditClosed"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onInplaceEditClosed"]++; }; 
	var oTitle = UCF_DomUtil["$"](this["sId"] + '-title');
	UCF_DomUtil["focusDomElement"](oTitle);
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onInplaceEditClosed"] = 0; };

/**
 * client-side wrapper for the renderUrBase_IconFragment
 *
 * @private
 * @param {string} sText
 * @return {string}
 */
UCF_PanelBase["prototype"]["sPanelTitleWithAceesKey"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["sPanelTitleWithAceesKey"]++; }; 
	return this["sAccessKey"] === ''
		? sText
		: this["oLS"]["oGetRenderManager"]()["callFragment"](
			'UrBaseAccessKeyTextFragment',
			'UrBase', { "Text": sText, "AccessKey": this["sAccessKey"], "EnabledAccessKey": this["bEnabled"] }
		);
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["sPanelTitleWithAceesKey"] = 0; };

/********************************************
 * ######## Hotkey Section ######
 ********************************************/
/**
 * Handle hotkey events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlshotkey"]++; }; 

	if (!this["sHotkeysId"] || this["sHotkeysId"] === '') return;

	//if ( this.sGetEmbeddingType() !== this.eEmbeddingType.NONE) return;

	var oHotkeys = this["oGetControlById"](this["sHotkeysId"]),
		oHotkey = null;

	if (oHotkeys == null) return;

	oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlshotkey"] = 0; };

/************************************************************
 * ########### ACC and keyboard Section #######################
 *****************************************************************/

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsskipforward"]++; }; 
	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;

	var oSource = oBrowserEvent["oGetSource"]();

	// ### skip to single panel elements ###//
	if (this["sGetContainer"](oSource) != null && this["sGetContainer"](oSource) !== 'CONTENT') {
		this["skipForwardToElement"](oSource, oBrowserEvent);
	} else {
		// ### skip to next control ###//
		this["handleSkipForward"](oBrowserEvent);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsskipback"]++; }; 

	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;

	var oSource = oBrowserEvent["oGetSource"]();

	// ### skip to single panel elements ###//
	if (this["sGetContainer"](oSource) != null && !this["bIsLastSkipableBackwards"](oSource) && this["sGetContainer"](oSource) !== 'TITLE') {
		this["skipBackToElement"](oSource, oBrowserEvent);
	} else {
		// ### skip to next control ###//
		this["handleSkipBack"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsskipback"] = 0; };

/**
 * Returns the last focusable element within the header to which skipping backwards is possible
 * @private
 */

UCF_PanelBase["prototype"]["bIsLastSkipableBackwards"] = function(oSource) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["bIsLastSkipableBackwards"]++; }; 

	if (this["oGetHeaderToolbar"]()) {
		var oHeaderToolbar = this["oGetHeaderToolbar"]();

		return oSource === UCF_DomUtil["$"](oHeaderToolbar["sId"] + '-hiddenOpener') ||
			oHeaderToolbar["oDomRef"]["contains"](oSource);
	}

	if (this["oGetHeaderFunctions"]() != null) {
		var oHeaderFunction = this["oGetHeaderFunctions"]();

		return oHeaderFunction["contains"](oSource);
	}

	if (this["oGetContentToolbar"]() != null) {
		var oContentToolbar = this["oGetContentToolbar"]();

		return oSource === UCF_DomUtil["$"](oContentToolbar["sId"] + '-hiddenOpener') ||
			this["oContentToolbar"]["oDomRef"]["contains"](oSource);
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["bIsLastSkipableBackwards"] = 0; };

/**
 * Returns the last focusable element within the header to which skipping forward is possible
 * @private
 */

UCF_PanelBase["prototype"]["bIsLastSkipableForward"] = function(oSource) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["bIsLastSkipableForward"]++; }; 

	if (this["oGetContentToolbar"]() != null) {
		var oContentToolbar = this["oGetContentToolbar"]();

		return oSource === oContentToolbar["oDomRef"] ||
			oContentToolbar["oDomRef"]["contains"](oSource);

	}
	if (this["oGetHeaderFunctions"]() != null) {
		var oHeaderFunction = this["oGetHeaderFunctions"]();

		return oHeaderFunction["contains"](oSource);
	}

	if (this["oGetHeaderToolbar"]()) {
		var oHeaderToolbar = this["oGetHeaderToolbar"]();

		return oSource === oHeaderToolbar()["oDomRef"] ||
			oHeaderToolbar()["oDomRef"]["contains"](oSource);
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["bIsLastSkipableForward"] = 0; };

/**
 * Finds out the HTML element of the header where the focus is currently
 * @private
 */

UCF_PanelBase["prototype"]["sGetContainer"] = function(oSource) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["sGetContainer"]++; }; 
	if (oSource == null || oSource["id"] == null) {
		return null;
	}
	// focus is on title
	var sId = oSource["id"];

	if (sId["indexOf"]('-titletext') > -1) {
		return 'TITLE';
	}

	// focus is on header toolbar or on one of its element
	if (this["oGetHeaderToolbar"]() != null) {
		var oHeaderToolbar = this["oGetHeaderToolbar"]();

		if (sId["indexOf"]('-hdtbar') > -1 || oHeaderToolbar["oDomRef"]["contains"](oSource)) {
			return 'HDTBAR';
		}
	}

	// focus is on content toolbar or on one of its elements
	if (this["oGetContentToolbar"]() != null) {
		var oContentToolbar = this["oGetContentToolbar"]();
		if (sId["indexOf"]('-tbar') > -1 || oContentToolbar["oDomRef"]["contains"](oSource)) {
			return 'CNTTBAR';
		}
	}

	// focus in on one of the header functions
	if (this["oGetHeaderFunctions"]() != null) {
		var oHeaderFunctions = UCF_DomUtil["$"](this["sId"] + '-functions');

		if (oHeaderFunctions["contains"](oSource)) {
			return 'FUNCTIONS';
		}
	}

	if (this["oGetContentArea"]() != null) {
		var oContent = UCF_DomUtil["$"](this["sId"] + '-cnt');

		if (oContent["contains"](oSource)) {
			return 'CONTENT';
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["sGetContainer"] = 0; };

/**
 * Skips to the next header element depending on the current focus position
 * @private
 */

UCF_PanelBase["prototype"]["skipForwardToElement"] = function(oSource, oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["skipForwardToElement"]++; }; 

	var oHeaderToolbar = this["oGetHeaderToolbar"](),
		oContentToolbar = this["oGetContentToolbar"](),
		oHeaderFunctions = this["oGetHeaderFunctions"](),
		bFocusSet = false;

	//focus is on the title

	if (this["sGetContainer"](oSource) === 'TITLE') {
		//skip to header toolbar
		if (oHeaderToolbar != null) {
			if (window["UCF_System"]["bIs508"]) {
				this["focusElement"](oHeaderToolbar["oDomRef"], oBrowserEvent);
			} else {
				this["focusElement"](oHeaderToolbar["aItems"][0]["oDomRef"], oBrowserEvent);
			}
			bFocusSet = true;
		} else if (oHeaderFunctions != null) {
			// skip to header functions
			this["focusElement"](oHeaderFunctions[0], oBrowserEvent);
			bFocusSet = true;
		} else if (oContentToolbar != null) {
			// skip to content toolbar
			if (window["UCF_System"]["bIs508"]) {
				this["focusElement"](oContentToolbar["oDomRef"], oBrowserEvent);
			} else {
				this["focusElement"](oContentToolbar["aItems"][0]["oDomRef"], oBrowserEvent);
			}
			bFocusSet = true;
		}
	} else if (this["sGetContainer"](oSource) === 'HDTBAR') {
		// focus is on header toolbar
		if (oHeaderFunctions != null) {
			this["focusElement"](oHeaderFunctions[0], oBrowserEvent);
			bFocusSet = true;
		} else if (oContentToolbar != null) {
			if (window["UCF_System"]["bIs508"]) {
				this["focusElement"](oContentToolbar["oDomRef"], oBrowserEvent);
			} else {
				this["focusElement"](oContentToolbar["aItems"][0]["oDomRef"], oBrowserEvent);
			}
			bFocusSet = true;
		}
	}
	//focus is on one of the header functions
	else if (this["sGetContainer"](oSource) === 'FUNCTIONS') {
		if (oContentToolbar) {
			if (window["UCF_System"]["bIs508"]) {
				this["focusElement"](oContentToolbar["oDomRef"], oBrowserEvent);
			} else {
				this["focusElement"](oContentToolbar["aItems"][0]["oDomRef"], oBrowserEvent);
			}
			bFocusSet = true;
		}
	}
	//CSN 655987 Toolbar - fix F6 when the Toolbar is nested in Panel
	if (!bFocusSet) {
		this["handleSkipForward"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["skipForwardToElement"] = 0; };

/**
 * Skips to the previous header element depending on the current focus position
 * @private
 */

UCF_PanelBase["prototype"]["skipBackToElement"] = function(oSource, oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["skipBackToElement"]++; }; 

	var oHeaderToolbar = this["oGetHeaderToolbar"](),
		oContentToolbar = this["oGetContentToolbar"](),
		oHeaderFunctions = this["oGetHeaderFunctions"](),
		bFocusSet = false,
		oMenuTrigger;

	//focus is within content
	if (this["sGetContainer"](oSource) === 'CONTENT') {
		if (oContentToolbar) {
			if (oContentToolbar["bIsWrapping"]()) {
				oMenuTrigger = UCF_DomUtil["$"](oContentToolbar["sId"] + '-hiddenOpener');
				this["focusElement"](oMenuTrigger, oBrowserEvent);
			} else {
				this["focusElement"](oContentToolbar["aItems"][oContentToolbar["aItems"]["length"] - 1]["oDomRef"], oBrowserEvent);
			}
			bFocusSet = true;
		} else if (oHeaderFunctions != null) {
			this["focusElement"](oHeaderFunctions[oHeaderFunctions["length"] - 1]["oDomRef"], oBrowserEvent);
			bFocusSet = true;
		} else if (oHeaderToolbar) {

			if (oHeaderToolbar["bIsWrapping"]()) {
				oMenuTrigger = UCF_DomUtil["$"](oHeaderToolbar["sId"] + '-hiddenOpener');
				this["focusElement"](oMenuTrigger, oBrowserEvent);
			} else {
				this["focusElement"](oHeaderToolbar["aItems"][oHeaderToolbar["aItems"]["length"] - 1]["oDomRef"], oBrowserEvent);
			}
			bFocusSet = true;
		}
	}
	//focus is on content toolbar
	else if (this["sGetContainer"](oSource) === 'CNTTBAR') {
		if (oHeaderFunctions) {
			this["focusElement"](oHeaderFunctions[oHeaderFunctions["length"] - 1]["oDomRef"], oBrowserEvent);
			bFocusSet = true;
		} else if (oHeaderToolbar) {
			if (oHeaderToolbar["bIsWrapping"]()) {
				oMenuTrigger = UCF_DomUtil["$"](oHeaderToolbar["sId"] + '-hiddenOpener');
				this["focusElement"](oMenuTrigger, oBrowserEvent);
			} else {
				this["focusElement"](oHeaderToolbar["aItems"][oHeaderToolbar["aItems"]["length"] - 1]["oDomRef"], oBrowserEvent);
			}
			bFocusSet = true;
		}
	}
	//focus is on one of the header functions
	else if (this["sGetContainer"](oSource) === 'FUNCTIONS') {
		if (oHeaderToolbar) {
			if (oHeaderToolbar["bIsWrapping"]()) {
				oMenuTrigger = UCF_DomUtil["$"](oHeaderToolbar["sId"] + '-hiddenOpener');
				this["focusElement"](oMenuTrigger, oBrowserEvent);
			} else {
				this["focusElement"](oHeaderToolbar["aItems"][oHeaderToolbar["aItems"]["length"] - 1]["oDomRef"], oBrowserEvent);
			}
			bFocusSet = true;
		}
	}
	//CSN 655987 Toolbar - fix F6 when the Toolbar is nested in Panel
	if (!bFocusSet) {
		this["handleSkipBack"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["skipBackToElement"] = 0; };

/**
 * Set the focus to the given header element and cancel the event
 * @param { UCF_Panel } oElement
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["focusElement"] = function(oElement, oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["focusElement"]++; }; 
	UCF_DomUtil["focusDomElement"](oElement);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["focusElement"] = 0; };

/**
 * Handles the acc event and sets the correct tootip text
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelBase["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsaccessibility"]++; }; 

	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PanelBase.js(1228): onlsaccessibility"); };

	var oSourceControl = oBrowserEvent["oGetSourceControl"](),
		oSource = oBrowserEvent["oGetSource"]();

	if (oSourceControl !== this || (oSource["id"]["indexOf"]('-end') > -1 && oSource["getAttribute"]('tp') && oSource["getAttribute"]('tp') !== 'cntar')) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource !== null && oSource["id"] && oSource["id"] === this["sId"] + '-end') {

		oAccessibilityHelper["setControlType"]('G_END');

		return;
	}

	oAccessibilityHelper["setText"](this["sTitle"]);
	oAccessibilityHelper["setControlType"]('G');
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);

	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);

	oAccessibilityHelper["applyContainerEntryBehaviour"](this["bIsCollapsible"] && this["bClientCollapse"], this["bEnabled"], this["bCollapsed"]);
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["onlsaccessibility"] = 0; };

/**
 * Destroy all created objects
 * @private
 */
UCF_PanelBase["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["destroy"]++; }; 

	if (this["oCollapseAnimation"]) this["oCollapseAnimation"] = null;
	if (this["oExpandAnimation"]) this["oExpandAnimation"] = null;

	if (this["sGetEmbeddingType"]() !== this["eEmbeddingType"]["NONE"]) return;

	var oInplaceEditDelegate = this["oInplaceEditDelegate"];

	if (oInplaceEditDelegate) {
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this);
		this["oInplaceEditDelegate"] = null;
	}
	this["oToggleEndButton"] = null;
	this["oHeaderToolbar"] = null;
	this["aHeaderFunctions"] = null;
	this["oContentToolbar"] = null;
	this["oContentArea"] = null;
	this["sTitle"] = null;
	this["bCollapsed"] = null;
	this["maxHeight"] = null;
	this["sEmbedingType"] = null;
	this["iHeaderHeight"] = null;
	this["iSeparatorHeight"] = null;
	this["iToolbarHeight"] = null;
	this["iDomRefHeight"] = null;
	this["iDomRefWidth"] = null;
	this["oExpandAnimation"] = null;
	this["oCollapseAnimation"] = null;
	this["bIsStandardsMode"] = null;
	this["oTitle"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["destroy"] = 0; };

/*************************************
 *#######All neccessary Getters#######
 * Get single objects when needed in order
 * to avoid initialization of nested controls
 *************************************/

/**
 * Returns the header toolbar as control.
 * @return {UCF_HeaderToolbar}
 * @private
 */
UCF_PanelBase["prototype"]["oGetHeaderToolbar"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["oGetHeaderToolbar"]++; }; 

	if (this["oHeaderToolbar"] != null && UCF_JsUtil["bInstanceOf"](this["oHeaderToolbar"], 'UCF_Toolbar')) {
		return this["oHeaderToolbar"];
	}

	var oHeaderToolbar = UCF_DomUtil["$"](this["sId"] + '-hdtbar');
	if (oHeaderToolbar != null) {
		oHeaderToolbar = UCF_DomUtil["firstChild"](oHeaderToolbar);
		if (oHeaderToolbar) {
			this["oHeaderToolbar"] = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oHeaderToolbar, true);
			return this["oHeaderToolbar"];
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["oGetHeaderToolbar"] = 0; };

/**
 * Returns all visible items in the header functions area.
 * @return {Array}
 * @private
 */
UCF_PanelBase["prototype"]["oGetHeaderFunctions"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["oGetHeaderFunctions"]++; }; 

	if (this["aHeaderFunctions"] != null) return this["aHeaderFunctions"];

	var oHeader = UCF_DomUtil["$"](this["sId"] + '-functions'),
		oHeaderFunctions = UCF_DomUtil["firstChild"](oHeader, 'SPAN'),
		aHeaderFunctionsTmp = [];

	if (oHeaderFunctions != null) {
		var aHeaderFunctions = UCF_DomUtil["childNodes"](oHeaderFunctions, 'A');
		for (var i = 0; i < aHeaderFunctions["length"]; i++) {
			if (UCF_DomUtil["bHasClass"](aHeaderFunctions[i], 'urBtnVisibilityOnDemand')) {
				this["bDynamicHeaderFunctions"] = true;
				if (UCF_DomUtil["sGetCurrentStyle"](aHeaderFunctions[i], 'display') !== 'none') {
					aHeaderFunctionsTmp["push"](aHeaderFunctions[i]);
				}
			} else {
				aHeaderFunctionsTmp["push"](aHeaderFunctions[i]);
			}
		}
		if (aHeaderFunctionsTmp["length"] > 0) this["aHeaderFunctions"] = aHeaderFunctionsTmp;
		return this["aHeaderFunctions"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["oGetHeaderFunctions"] = 0; };

/**
 * Returns true if header area has header functions with Visibility.ON_DEMAND.
 * @return {bool}
 * @private
 */
UCF_PanelBase["prototype"]["bHasDynamicHeaderFunctions"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["bHasDynamicHeaderFunctions"]++; }; 

	return this["bDynamicHeaderFunctions"];
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["bHasDynamicHeaderFunctions"] = 0; };

/**
 * Returns true if the Panel is standalone.
 * @return {bool}
 * @private
 */
UCF_PanelBase["prototype"]["bIsStandalone"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["bIsStandalone"]++; }; 
	return this["sGetEmbeddingType"]() === this["eEmbeddingType"]["NONE"];
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["bIsStandalone"] = 0; };

/**
 * Returns true if the source it's a clickable area
 * @param {HTMLElement} oSourceDomRef - the
 * @return {bool}
 * @private
 */
UCF_PanelBase["prototype"]["bIsClickableArea"] = function(oSourceDomRef) {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["bIsClickableArea"]++; }; 
	if (!oSourceDomRef) return false;
	var bIsClickableIEQuriks = false,
		bIsClickableStandards = false;
	var
		oTitle = UCF_DomUtil["$"](this["sId"] + '-title'),
		oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-titletext'),
		oToggleEndButton = UCF_DomUtil["$"](this["sId"] + '-tglend'),
		oToggleButton = UCF_DomUtil["$"](this["sId"] + '-tgl');

	if (__UCF_IE6__) {
		bIsClickableIEQuriks = ((oSourceDomRef === oTitle || oSourceDomRef === oTextDomRef || oSourceDomRef === oToggleButton) && this["sCollapseIconPosition"] !== 'END') ||
			(oSourceDomRef === oToggleEndButton && this["sCollapseIconPosition"] === 'END');
	} else {
		bIsClickableStandards = ((oSourceDomRef === oTitle || oSourceDomRef === oTextDomRef) && this["sCollapseIconPosition"] !== 'END') ||
			(oSourceDomRef === oToggleEndButton && this["sCollapseIconPosition"] === 'END');
	}
	return bIsClickableIEQuriks || bIsClickableStandards;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["bIsClickableArea"] = 0; };

/**
 * Invalidates header functions array
 * This is necessary after toggling if header area has header functions with Visibility.ON_DEMAND.
 * @private
 */
UCF_PanelBase["prototype"]["invalidateHeaderFunctions"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["invalidateHeaderFunctions"]++; }; 

	this["aHeaderFunctions"] = null;

};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["invalidateHeaderFunctions"] = 0; };
/**
 * Returns the toolbar whithin the content area if there is one
 * @return {UCF_Toolbar}
 * @private
 */
UCF_PanelBase["prototype"]["oGetContentToolbar"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["oGetContentToolbar"]++; }; 

	if (this["oContentToolbar"] != null) return this["oContentToolbar"];

	var oContentToolbar = UCF_DomUtil["$"](this["sId"] + '-tbar');
	if (oContentToolbar != null) {
		oContentToolbar = UCF_DomUtil["firstChild"](UCF_DomUtil["firstChild"](oContentToolbar));
		this["oContentToolbar"] = this["oLS"]["oControlFactory"]["oCreateControlByDomRef"](oContentToolbar);
		return this["oContentToolbar"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["oGetContentToolbar"] = 0; };

/**
 * Returns the content area
 * @return {UCF_ContentArea}
 * @private
 */
UCF_PanelBase["prototype"]["oGetContentArea"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["oGetContentArea"]++; }; 

	if (this["oContentArea"] != null) return this["oContentArea"];

	var oContentArea = UCF_DomUtil["$"](this["sId"] + '-cnt');
	if (oContentArea != null) {
		this["oContentArea"] = oContentArea;
		return this["oContentArea"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["oGetContentArea"] = 0; };

/**
 * recalculate the height of the given oDomRef element
 * only for IE & Standards
 * @private
 */
UCF_PanelBase["prototype"]["correctPanelHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["correctPanelHeight"]++; }; 
	if (!UCF_DomUtil["bCheckStandardsCorrection"]())
		return;

	var oHeaderPanel = UCF_DomUtil["$"](this["sId"] + '-right') || UCF_DomUtil["$"](this["sId"] + '-embedded');
	if (oHeaderPanel == null || typeof(oHeaderPanel) === 'undefined') return;

	if (this["bCollapsed"]) {
		this["bNeedsHeightCalculation"] = true;
		return;
	}

	var sPanelHeight = this["sHeight"];
	//	_trace(INFO, '================= Panel - id - ' + this.sId + ' - Offset  height   - ' + this.oDomRef.offsetHeight );
	if (this["iHeaderHeight"] === -1) {
		this["iHeaderHeight"] = oHeaderPanel["offsetHeight"];
	}
	var iFixHeight = this["iHeaderHeight"],
		oPanelCnt = UCF_DomUtil["$"](this["sId"] + '-caCnt'),
		iDomRefHeight = this["oDomRef"]["offsetHeight"];

	if (iDomRefHeight < 2 * iFixHeight) {
		//_trace(INFO, 'oTbarContent -iFixHeight height ' + iFixHeight);
		//something is wrong, no calculation will be done
		oPanelCnt["style"]["height"] = '94%';
	} else {
		try {
			if (this["iToolbarHeight"] === -1) {
				var oTbarContent = UCF_DomUtil["$"](this["sId"] + '-tbar');
				if (oTbarContent) {
					this["iToolbarHeight"] = oTbarContent["offsetHeight"];
				} else {
					this["iToolbarHeight"] = 0;
				}
			}
			iFixHeight += this["iToolbarHeight"];

		} catch (e) {}
		iFixHeight += 0; // the line between tabs & content
		if (sPanelHeight && sPanelHeight["indexOf"]('px') > -1) {
			var iTabstripHeight = parseInt(sPanelHeight);
			oPanelCnt["style"]["height"] = (iTabstripHeight - iFixHeight) + 'px';
			//_trace(INFO, '===== panelId - ' + this.sId + ' - OffsetHeight - ' + iDomRefHeight + 'px - FixedHeight - ' +  iFixHeight + 'px - ContentHeight - ' +  oPanelCnt.style.height );
		} else {
			oPanelCnt["style"]["height"] = Math["floor"](100 - (iFixHeight * 100 / iDomRefHeight)) + '%';
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '===== panelId - ' + this["sId"] + ' - OffsetHeight - ' + iDomRefHeight + 'px - FixedHeight - ' + iFixHeight + 'px - ContentHeight - ' + oPanelCnt["style"]["height"], "PanelBase.js(1498): correctPanelHeight"); };
		}
	}

	this["iDomRefHeight"] = this["oDomRef"]["offsetHeight"];

	this["bNeedsHeightCalculation"] = false;

};;if (__UCF_COVERAGE__) { UCF_PanelBase["_"]["correctPanelHeight"] = 0; };

};
sap["ls"]["preload"]["UCF_PanelDragDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_PanelDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_PanelDragDelegate["_"]["UCF_PanelDragDelegate"]++; }; 

	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);

};window["UCF_PanelDragDelegate"] = UCF_PanelDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PanelDragDelegate"); UCF_PanelDragDelegate["_"] = {UCF_PanelDragDelegate: 0}; }; ;
UCF_PanelDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_PanelDragDelegate.prototype["sClassName"] = "UCF_PanelDragDelegate";

UCF_PanelDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelDragDelegate["_"]["oGetGhost"]++; }; 

	var oPanel = this["oDragSourceControl"],
		sIdSuffix = oPanel["sGetEmbeddingType"]() === oPanel["eEmbeddingType"]["NONE"] ? "-draghandle" : "";

	oPanel = UCF_DomUtil["$"](this["oDragSourceControl"]["sId"] + sIdSuffix);
	var oGhostFragment = oPanel["cloneNode"](true);

	// oGhostFragment.style.width = oPanel.offsetWidth;
	oGhostFragment["style"]["fontSize"] = "0.7em";
	oGhostFragment["style"]["paddingRight"] = "1px";
	var selection = UCF_StringUtil["bContains"](oGhostFragment["className"], "Sel", true);
	oGhostFragment["className"] = selection ? "lsPnstLastSel" : "lsPnstLast";

	var firstChildSpan = UCF_DomUtil["firstChild"](oGhostFragment, "SPAN");
	if (firstChildSpan) {
		if (selection) {
			firstChildSpan["className"] = "lsPnstFirstSel";
			firstChildSpan["height"] = "2.5em";
			firstChildSpan["marginLeft"] = "30px";
		} else {
			firstChildSpan["className"] = "lsPnstFirst";
		}
	}

	// oGhostFragment.style.backgroundImage = "!important";
	// debugger;
	var oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oGhostFragment);
	oGhost["setOffset"](4, 4);
	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_PanelDragDelegate["_"]["oGetGhost"] = 0; };

UCF_PanelDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelDragDelegate["_"]["bIsDragPossible"]++; }; 

	// George, I changed this to be only draggable from the panel header
	var oPanelHeader = UCF_DomUtil["$"](this["oDragSourceControl"]["sId"] + "-draghandle");
	if (UCF_DomUtil["bContains"](oPanelHeader, oBrowserEvent["oGetSource"]()) ||
		this["oDragSourceControl"]["sGetEmbeddingType"]() === this["oDragSourceControl"]["eEmbeddingType"]["PANEL_STACK"]) {
		return true;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_PanelDragDelegate["_"]["bIsDragPossible"] = 0; };

};
sap["ls"]["preload"]["UCF_PanelDropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_BoxDecorator */
/// <reference path="./BoxDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_Panel} oPanel
 * @param {UCF_LS} oLS
 */
function UCF_PanelDropDecorator(oPanel, oLS) {if (__UCF_COVERAGE__) { UCF_PanelDropDecorator["_"]["UCF_PanelDropDecorator"]++; }; 

	UCF_BoxDecorator["apply"](this, [oPanel]);
	this["oLS"] = oLS;
};window["UCF_PanelDropDecorator"] = UCF_PanelDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PanelDropDecorator"); UCF_PanelDropDecorator["_"] = {UCF_PanelDropDecorator: 0}; }; ;

/**
 *
 */
UCF_PanelDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_BoxDecorator"))(); UCF_PanelDropDecorator.prototype["sClassName"] = "UCF_PanelDropDecorator";

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PanelDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelDropDecorator["_"]["update"]++; }; 

	this["sTargetPanel"] = -1;

	var oPanelDomRef = UCF_DomUtil["$"](this["oControl"]["sId"] + "-draghandle"),
		oPanelRect = UCF_DomUtil["oGetObjectRect"](oPanelDomRef);
	// iMouseX = oBrowserEvent.iClientX(),
	// iMouseY = oBrowserEvent.iClientY();

	this["setBounds"](oPanelRect["left"], oPanelRect["top"], oPanelRect["height"], oPanelRect["width"]);
	this["show"]();
};;if (__UCF_COVERAGE__) { UCF_PanelDropDecorator["_"]["update"] = 0; };

/**
 * destructor
 */
UCF_PanelDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelDropDecorator["_"]["destroy"]++; }; 

	this["oLS"] = null;
	this["sTargetPanel"] = null;
	UCF_BoxDecorator.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PanelDropDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_PanelDropDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_PanelDropDecorator */
/// <reference path="../decorators/PanelDropDecorator.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_PanelDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_PanelDropDelegate["_"]["UCF_PanelDropDelegate"]++; }; 

	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);
	this["oLS"] = oLS;

};window["UCF_PanelDropDelegate"] = UCF_PanelDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PanelDropDelegate"); UCF_PanelDropDelegate["_"] = {UCF_PanelDropDelegate: 0}; }; ;
UCF_PanelDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_PanelDropDelegate.prototype["sClassName"] = "UCF_PanelDropDelegate";

/**
 * @override
 */
UCF_PanelDropDelegate["prototype"]["oCreateDropDecorator"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelDropDelegate["_"]["oCreateDropDecorator"]++; }; 

	return new (UCF_ClassLoader["oGetClass"]("UCF_PanelDropDecorator"))(this["oDropTargetControl"], this["oLS"]);

};;if (__UCF_COVERAGE__) { UCF_PanelDropDelegate["_"]["oCreateDropDecorator"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {Object}
 */
UCF_PanelDropDelegate["prototype"]["oGetDropLocation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelDropDelegate["_"]["oGetDropLocation"]++; }; 

	if (!this["oDropDecorator"])
		return null;

	return this["oDropDecorator"]["oGetDropLocation"]();

};;if (__UCF_COVERAGE__) { UCF_PanelDropDelegate["_"]["oGetDropLocation"] = 0; };

/**
 * @param {Object} oDragSession
 * @return {function(string, string): void}
 */
UCF_PanelDropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_PanelDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function(sDragData, sMimeType) {

		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);
	};

};;if (__UCF_COVERAGE__) { UCF_PanelDropDelegate["_"]["fGetDropCallBack"] = 0; };

UCF_PanelDropDelegate["prototype"]["onlsdraghover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelDropDelegate["_"]["onlsdraghover"]++; }; 

	var oPanelDomRef = UCF_DomUtil["$"](this["oDropTargetControl"]["sId"] + "-draghandle"),
		oViewPort = UCF_DomUtil["oGetObjectRect"](oPanelDomRef),
		iMouseY = oBrowserEvent["iClientY"]();

	if (iMouseY < oViewPort["top"] || iMouseY > oViewPort["top"] + oViewPort["height"])
		return;

	if (this["oDropDecorator"])
		this["oDropDecorator"]["update"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_PanelDropDelegate["_"]["onlsdraghover"] = 0; };

UCF_PanelDropDelegate["prototype"]["bIsDropPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelDropDelegate["_"]["bIsDropPossible"]++; }; 

	var oDropTargetArea = UCF_DomUtil["$"](this["oDropTargetControl"]["sId"] + "-titlecontent"),
		oSource = oBrowserEvent["oGetSource"]();

	if (UCF_DomUtil["bContains"](oDropTargetArea, oSource)) {
		return UCF_DropDelegate.prototype["bIsDropPossible"]["call"](this, oBrowserEvent);
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_PanelDropDelegate["_"]["bIsDropPossible"] = 0; };

};
sap["ls"]["preload"]["UCF_PanelStack"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_Animation */
/// <reference path="../anim/Animation.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ClientPopupMenuHelper */
/// <reference path="../helper/ClientPopupMenuHelper.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>
/* global UCF_PanelStackDragDelegate */
/// <reference path="./delegates/PanelStackDragDelegate.js"/>
/* global UCF_PanelStackDropDelegate */
/// <reference path="./delegates/PanelStackDropDelegate.js"/>
/* global UCF_Panel */
/// <reference path="./Panel.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>

/**
 * A PanelStack is a collection of panels displayed in various modes, i.e.
 * as tab items, menu items etc.
 * @class
 * 
 * @param {HTMLElement} oDomRef the DOM element that represents the control
 * @param {UCF_LS} oLS the LightSpeed instance that manages the control
 */
function UCF_PanelStack(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["UCF_PanelStack"]++; }; 
	var iTimeout;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PanelStack.js(55): UCF_PanelStack"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PanelStack.js(56): UCF_PanelStack"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PanelStack.js(57): UCF_PanelStack"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]);

	if (this["sStackDesign"] === 'TAB') {
		this["oViewPort"] = UCF_DomUtil["$"](this["sId"] + '-itms');
		//this.oNextBtn = UCF_DomUtil.$(this.sId + '-next');
		//this.oPrevBtn = UCF_DomUtil.$(this.sId + '-prev');
		this["oMenuButton"] = UCF_DomUtil["$"](this["sId"] + '-menuOpener');
		this["oMorePanel"] = null;
		this["iWidth"] = this["oViewPort"]["offsetWidth"];
	} else if (this["sStackDesign"] === 'MENU') {
		this["oTitle"] = UCF_DomUtil["$"](this["sId"] + '-title');
		// for ARIA implementation, this is the focusable element
		this["oTitleArea"] = UCF_DomUtil["$"](this["sId"] + '-titlearea');
		this["oTitleIcon"] = UCF_DomUtil["$"](this["sId"] + '-titleIcon');
		this["sTitle"] = UCF_DomUtil["sGetInnerText"](this["oTitle"]);
	}
	this["oAriaHeading"] = UCF_DomUtil["$"](this["sId"] + '-heading');
	this["oMenuOpener"] = this["sStackDesign"] === 'TAB' ? this["oMenuButton"] : this["oTitleArea"];
	this["oSelArrowDomRef"] = null;
	this["bSelArrowHidden"] = null;
	this["bAnimation"] = false;
	this["iSelArrowOffsetTop"] = -1;
	this["oSelArrowAnimation"] = null;
	if (this["sStackDesign"] === 'TAB' && window["UCF_System"]["bUseAnimation"]) {
		this["oSelArrowDomRef"] = UCF_DomUtil["$"](this["sId"] + '-selArrow');
		this["bSelArrowHidden"] = this["oSelArrowDomRef"]
			? UCF_DomUtil["sGetCurrentStyle"](this["oSelArrowDomRef"], 'display')
			: null;
		if (this["oSelArrowDomRef"] != null && this["bSelArrowHidden"] != null && this["bSelArrowHidden"] === 'block') {
			this["bAnimation"] = true;
		}
		if (this["bAnimation"]) {
			//create animation objects and fields
			iTimeout = 500;
			this["oSelArrowAnimation"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))();
			this["oSelArrowAnimation"]["setTime"](iTimeout);
			this["oSelArrowAnimation"]["setDomRef"](this["oSelArrowDomRef"]);
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Checked value for this.bSelArrowHidden ' + this["bSelArrowHidden"] + ' - animation - ' + this["bAnimation"], "PanelStack.js(100): UCF_PanelStack"); };
	}

	this["oToggleButton"] = UCF_DomUtil["$"](this["sId"] + '-tgl');

	this["scrollAreaItems"] = null;
	//this.iFocused = 0;
	this["iSelected"] = 0;
	this["createPanels"]();

	this["iFocused"] = this["iGetSelectedIndex"](this["sSelectedPanelId"]);
	this["bSuppressResize"] = false;
	this["oScrollArea"] = null;

	//create animation objects and fields
	iTimeout = UCF_UserAgent["bIsIE"]() ? 300 : 500;
	this["oExpand"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))();
	this["oExpand"]["setTime"](iTimeout);
	this["oCollapse"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))();
	this["oCollapse"]["setTime"](iTimeout);
	//this.oItemNavigation.attachEvent(this.oItemNavigation.E_EVENTS.Select,this,'onItemSelect');
	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Activate"], this, 'onPanelActivate');
	this["oItemNavigation"]["setNavigateInLoop"](false);
	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
	if (this["aItems"]["length"] > 0) {
		this["oItemContainer"] = UCF_DomUtil["$"](this["sId"] + '-itms');
	}

	// for animation arrow

	this["bToggleIconHidden"] = null;
	this["bToggleAnimation"] = false;
	this["oToggleIconAnimation"] = null;
	if (window["UCF_System"]["bUseAnimation"] && this["oToggleButton"] != null) {
		this["bToggleIconHidden"] = UCF_DomUtil["sGetCurrentStyle"](this["oToggleButton"], 'display');
		if (this["bToggleIconHidden"] != null && this["bToggleIconHidden"] === 'inline-block') {
			this["bToggleAnimation"] = true;
		}
		if (this["bToggleAnimation"]) {
			//create animation objects and fields
			iTimeout = UCF_UserAgent["bIsIE"]() ? 500 : 500;
			this["oToggleIconAnimation"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))();
			this["oToggleIconAnimation"]["setTime"](iTimeout);
			this["oToggleIconAnimation"]["setDomRef"](this["oToggleButton"]);
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Checked value for this.bToggleIconHidden ' + this["bToggleIconHidden"] + ' - animation - ' + this["bToggleAnimation"], "PanelStack.js(145): UCF_PanelStack"); };
	}

	this["oFocusDomRef"] = this["oToggleButton"] ? this["oToggleButton"] : UCF_DomUtil["$"](this["sSelectedPanelId"] + '-title');

};window["UCF_PanelStack"] = UCF_PanelStack; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PanelStack"); UCF_PanelStack["_"] = {UCF_PanelStack: 0}; }; ;

UCF_PanelStack["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PanelStack.prototype["sClassName"] = "UCF_PanelStack";

/**#######################################################################
 * ######################## Generic Events Section ######################
 * #######################################################################
 */

/**
 * Initializes the panel stack when TAB design is on.
 * During initialization it scrolls the selected item into
 * the view port and registers to the resize / scroll event.
 */
UCF_PanelStack["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["initialize"]++; }; 

	//adjust scroll position
	if (this["sScrollingMode"] !== 'NONE') {
		this["createScrollHelper"]();
		if (this["oScrollArea"] != null) {
			this["oScrollArea"]["setScrollPosition"](this["iScrollTop"], this["iScrollLeft"]);
			this["setScrollPosition"]();
		}
	}
	//initialize tabitems
	if (this["sStackDesign"] !== 'TAB' || this["aItems"]["length"] === 0) return;
	this["callInitialize"]();
	var oSelected = UCF_DomUtil["$"](this["sSelectedPanelId"]);

	if (oSelected != null && this["bIsHidden"](oSelected)) {
		this["scrollIntoViewPort"](oSelected);
	}

	if (this["bOverflowOn"]()) {
		this["showPager"]();
		//this.setPreviousBtn();
		//this.setNextBtn();
		this["setMoreIndicator"]();
	}

	if (!this["bCollapsed"] && window["UCF_System"]["sDevice"] === 'standards' && UCF_UserAgent["bIsIE"]()) {
		UCF_DomUtil["initHtmlTableCorrection"](this["oDomRef"], true);
	}
	if (this["bCollapsed"]) {
		this["setContentNoneDisplay"](true);
	}
	this["checkAngleSelection"](this["sSelectedPanelId"]);
	this["attachBrowserEvent"]('resize', this["oViewPort"]);

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["initialize"] = 0; };

/**
 * Calls the initialize() methode for all its Panels
 *
 * @private
 */
UCF_PanelStack["prototype"]["callInitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["callInitialize"]++; }; 

	var aItems = this["aItems"];
	for (var i = aItems["length"] - 1; i >= 0; i--) {
		this["aItems"][i]["initialize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["callInitialize"] = 0; };

/**
 * Sets the left/top scroll positions of an items' content.
 * Needs the selected item to do so.
 * @private
 */
UCF_PanelStack["prototype"]["setScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setScrollPosition"]++; }; 
	if (this["iSelected"]) {
		var oSelected = this["aItems"][this["iSelected"]];
		if (oSelected && oSelected["iScrollTop"] < 1 && oSelected["iScrollLeft"] < 1) return;
		if (this["oScrollArea"] != null) {
			this["oScrollArea"]["oDomRef"] = UCF_DomUtil["$"](oSelected["sId"] + '-scrl');
			this["oScrollArea"]["setScrollPosition"](oSelected["iScrollTop"], oSelected["iScrollLeft"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setScrollPosition"] = 0; };

UCF_PanelStack["prototype"]["createScrollHelper"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["createScrollHelper"]++; }; 
	if (this["scrollAreaItems"]) {
		var oSelectedSA = this["scrollAreaItems"][this["iSelected"]];
		if (oSelectedSA) {
			this["oScrollArea"] = oSelectedSA;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["createScrollHelper"] = 0; };

/**
 * In collapse mode, the Tab - PanelStack should have display = none
 * for the tr of the Content, otherwise the IE will render an extra
 * pixel below
 * @param {boolean} bDisplayNone
 */
UCF_PanelStack["prototype"]["setContentNoneDisplay"] = function(bDisplayNone) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setContentNoneDisplay"]++; }; 

	if (this["sStackDesign"] !== 'TAB') return;
	if (window["UCF_System"]["sDevice"] === 'standards' || !UCF_UserAgent["bIsIE"]()) return;
	var oLastBody = UCF_DomUtil["lastChild"](this["oDomRef"], 'TBODY');
	if (oLastBody) {
		var oLastTr = UCF_DomUtil["lastChild"](oLastBody, 'TR');
		if (oLastTr) {
			oLastTr["style"]["display"] = bDisplayNone ? 'none' : '';
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setContentNoneDisplay"] = 0; };

/**
 * Handles the space event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelStack["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsspace"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PanelStack.js(265): onlsspace"); };
	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource && oSource === this["oToggleButton"]) {
		this["onclick"](oBrowserEvent);
		if (this["bCollapsed"]) {
			this["refocus"](this["oToggleButton"]);
		}
	}

	/* ### open the menu with space if neccessary ### */
	this["openMenu"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsspace"] = 0; };

/**
 * Handles the enter event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelStack["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsenter"]++; }; 
	this["onlsspace"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsenter"] = 0; };

/**
 * Calls all handlers that listen to the click event
 * - Toggling of collapsed / expanded state.
 * - Selecting a panel.
 * - Paging
 * - Applying correct styles to pager btns.
 * - More indicator
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PanelStack["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onclick"]++; }; 
	/* ### expand / collapse triggered by click ### */
	if (this["bCanToggle"](oBrowserEvent)) {

		if (this["bCollapsed"]) {
			this["fireExpand"](this["sId"]);

			if (this["bClientCollapse"]) {
				this["expandHeader"]();
				this["expandContent"]();

				if (this["sStackDesign"] === 'TAB') {
					this["selectPanelItem"](this["sSelectedPanelId"]);
					var oSelected = this["aItems"][this["iSelected"]]["oDomRef"];
					if (this["bIsHidden"](oSelected)) {
						this["scrollIntoViewPort"](oSelected);
					}
				}

				this["bCollapsed"] = !this["bCollapsed"];
				this["setClientProperty"]("Collapsed", this["bCollapsed"], true);
			}
		} else {
			this["fireCollapse"](this["sId"]);

			if (this["bClientCollapse"]) {
				this["collapseHeader"]();
				this["collapseContent"]();

				if (this["sStackDesign"] === 'TAB') {
					this["deselectPanelItem"](true);
				}

				this["bCollapsed"] = !this["bCollapsed"];
				this["setClientProperty"]("Collapsed", this["bCollapsed"], true);
			}
		}
		// Notify framework, that layout has changed after toggling the PanelStack
		this["notifyLayoutChange"]();

		// calculate width of header functions cell for visible on demand header functions
		var oPanel = this["oLS"]["oControlFactory"]["oGetControlById"](this["sSelectedPanelId"]);
		if (oPanel) oPanel["adjustHeaderFunctionWidth"]();
		oBrowserEvent["cancel"]();
	}

	/* ### select new panel after click on panel item: ###*/
	var oControl = oBrowserEvent["oGetSourceControl"]();
	if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_Panel')) {
		this["selectByPanel"](oBrowserEvent);
	}

	/* ### open the menu if neccessary ### */
	this["openMenu"](oBrowserEvent);

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onclick"] = 0; };

/**
 * Handle ItemSelect event
 *
 * @param {UCF_Event} oEvent the event object that occurred
 * @private
 */
UCF_PanelStack["prototype"]["onItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onItemSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "PanelStack.js(365): onItemSelect"); };

	var oItem = oEvent["oGetParam"]('oItem'),
		oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');
	//oSourceElement = oBrowserEvent.oGetSource();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_Panel, "oItem instanceof UCF_Panel", "PanelStack.js(371): onItemSelect"); };
	oBrowserEvent["cancelBubble"]();
	this["selectByPanelId"](oItem["id"]);

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onItemSelect"] = 0; };

/**
 * Handle the area scroll event
 *
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_PanelStack["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onScroll"]++; }; 
	if (this["iSelected"] < 0) return;

	var iScrollTop = oEvent["oGetParam"]('iScrollTop'),
		iScrollLeft = oEvent["oGetParam"]('iScrollLeft'),
		oSelected = this["aItems"][this["iSelected"]],
		oScrollContainer = UCF_DomUtil["$"](oSelected["sId"] + '-scrl');

	if (oScrollContainer["offsetHeight"] !== oScrollContainer["scrollHeight"] || oScrollContainer["offsetWidth"] !== oScrollContainer["scrollWidth"]) {
		this["fireScroll"](this["sId"], iScrollTop, iScrollLeft);
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onScroll"] = 0; };

UCF_PanelStack["prototype"]["onLayoutChange"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onLayoutChange"]++; }; 
	if (this["sTimeOutId"] != null) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
	}
	this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResize');
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onLayoutChange"] = 0; };

/**
 * Listens to resize. Waits till resize is finished
 * and calls onAfterResize
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PanelStack["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onresize"]++; }; 
	if (this["sTimeOutId"] != null) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
	}

	this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResize');
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onresize"] = 0; };

/**
 * Adjusts all elements necessary for tab scrolling when
 * resize is finished
 */
UCF_PanelStack["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onAfterResize"]++; }; 

	if (this["sStackDesign"] === 'MENU' ||
		this["bDestroyed"]) return;

	if (!this["oViewPort"]) {
		this["oViewPort"] = UCF_DomUtil["$"](this["sId"] + '-itms');
	}

	var iWidth = this["oViewPort"]["offsetWidth"];
	if (iWidth === this["iWidth"]) return;

	var oSelected = UCF_DomUtil["$"](this["sSelectedPanelId"]);
	// while resizing, the popupMenu will be closing
	if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
		UCF_DomUtil["removeClass"](this["oMenuOpener"], 'lsPanelStack--menu-open');
		this["oPopupMenu"]["close"]();
	}

	if (this["bIsHidden"](oSelected) && !this["bSuppressResize"] && oSelected != null) {
		this["scrollIntoViewPort"](oSelected);
	}

	if (this["bAnimation"] && this["bCollapsed"] === false && oSelected != null) {
		var oPanelTabTitle = UCF_DomUtil["$"](oSelected["id"] + '-title');
		if (oPanelTabTitle) {
			//check if the selected panel is visible
			if (oSelected["style"]["display"] === 'none') {
				this["oSelArrowDomRef"]["style"]["left"] = '-100px';
			} else {
				var leftPosition = oSelected["offsetLeft"] + oPanelTabTitle["clientWidth"] / 2 - 3;
				this["oSelArrowDomRef"]["style"]["left"] = Math["round"](leftPosition) + 'px';
				oPanelTabTitle["style"]["backgroundImage"] = 'none';
			}
			//_trace(INFO, ' test createPanels()' + this.bSelArrowHidden + ' - animation - ' + this.bAnimation);
		}
	}
	if (this["bOverflowOn"]()) {
		this["showPager"]();
	} else {
		this["hidePager"]();
	}

	this["removeMoreIndicator"]();
	this["setMoreIndicator"]();
	//this.setPreviousBtn();
	//this.setNextBtn();
	this["bSuppressResize"] = false;

	this["iWidth"] = this["oViewPort"]["offsetWidth"];
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onAfterResize"] = 0; };

/**##################################################################
 * ####################### Selection Section #########################
 * ##################################################################
 */

/**
	//1) change the design of the items
	//2) change the content
	//3) update the pager menu accordingly
	//4) toggle the whole control, if neccessary and possibleselectByPanelId
	//5) update all fields accordingly
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PanelStack["prototype"]["selectByPanel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectByPanel"]++; }; 
	var oPanelCtrl = oBrowserEvent["oGetSourceControl"]();
	if (oPanelCtrl && oPanelCtrl["bEnabled"] === false) {
		return;
	}
	var oSelectedPanel = this["oGetSeletedPanel"](oBrowserEvent);

	if (oSelectedPanel == null) return;
	this["selectByPanelId"](oSelectedPanel["id"]);

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectByPanel"] = 0; };

UCF_PanelStack["prototype"]["getLeftPosition"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["getLeftPosition"]++; }; 
	var oPanelDomRef = this["oGetPanelById"](sSelectedId);
	if (oPanelDomRef) {
		var oPanelTabTitle = UCF_DomUtil["$"](oPanelDomRef["sId"] + '-title');
		if (oPanelTabTitle) {
			//@ToDo move it into a proper place
			oPanelTabTitle["style"]["backgroundImage"] = 'none';
			//this.oSelArrowDomRef.style.marginBottom = oPanelDomRef.oDomRef.offsetTop > 0 ? -oPanelDomRef.oDomRef.offsetTop + 'px': '0px';
			this["oSelArrowDomRef"]["style"]["top"] = (this["iSelArrowOffsetTop"] + oPanelDomRef["oDomRef"]["offsetTop"]) + 'px';
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '======== this.oViewPort.scrollTop: ' + this["oViewPort"]["scrollTop"] + ' - oPanelDomRef.oDomRef.offsetTop:' + oPanelDomRef["oDomRef"]["offsetTop"], "PanelStack.js(507): getLeftPosition"); };
			return Math["round"](oPanelDomRef["oDomRef"]["offsetLeft"] + oPanelTabTitle["clientWidth"] / 2 - 3);
		}
	}
	return -100;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["getLeftPosition"] = 0; };

UCF_PanelStack["prototype"]["applyAnimation"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["applyAnimation"]++; }; 
	if (this["bAnimation"]) {
		//this.oSelArrowAnimation.callbackStep(this,'notifyExpandFinished');
		//this.oExpand.addInitialStyleValue('display', '');
		var currentLeft = this["oSelArrowDomRef"]["style"]["left"],
			nextLeft = this["getLeftPosition"](sSelectedId);
		if (currentLeft && currentLeft["indexOf"]('px') !== -1)
			currentLeft = parseInt(currentLeft);
		this["oSelArrowAnimation"]["addStyleChange"](
			/*sName:*/
			'left',
			/*sPrefix:*/
			'',
			/*sSuffix:*/
			'px',
			/*iStartValue:*/
			currentLeft,
			/*iEndValue:*/
			nextLeft,
			/*fnTransition:*/
			this["oSelArrowAnimation"]["M_TRANSITIONS"]["Linear"]
		);

		this["oSelArrowAnimation"]["play"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["applyAnimation"] = 0; };

UCF_PanelStack["prototype"]["selectByPanelId"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectByPanelId"]++; }; 
	// fire the select event independetly of client selection
	var oNewSelTitle = UCF_DomUtil["$"](sSelectedId + '-title'),
		oOldSelTitle = UCF_DomUtil["$"](this["sSelectedPanelId"] + '-title');
	var panelCtrl = this["oGetControlById"](sSelectedId, false);
	if (sSelectedId !== this["sSelectedPanelId"]) {
		this["fireSelect"](this["sId"], sSelectedId);
		// SAP ME send Collapse/Expand Panel events
		panelCtrl = this["oGetControlById"](sSelectedId, false);
		if (panelCtrl != null && UCF_JsUtil["bInstanceOf"](panelCtrl, 'UCF_Panel')) {
			panelCtrl["fireCollapse"](this["sSelectedPanelId"]);
			panelCtrl["fireExpand"](sSelectedId);
		}
	}

	// ARIA: change aria-selected attribute
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setSelected"](oNewSelTitle, true);
		UCF_AriaStateHelper["setSelected"](oOldSelTitle, false);
		if (this["oToggleButton"] && sSelectedId)
			UCF_AriaStateHelper["setLabelledBy"](this["oToggleButton"], sSelectedId);
		if (this["oAriaHeading"])
			UCF_DomUtil["setInnerHtml"](this["oAriaHeading"], UCF_XSSEncoder["encodeHTML"](panelCtrl["sTitle"]));

	}

	// select the appropriate panel and menu item if client select is on
	if (sSelectedId !== this["sSelectedPanelId"] && this["bClientSelect"]) {
		this["removePanelCollapseHeader"](this["sSelectedPanelId"]);
		this["deselectHeaderFunctions"]();
		if (!this["bCollapsed"]) {
			this["deselectPanelItem"](false);
		}
		this["selectPanelItem"](sSelectedId);
		this["selectHeaderFunctions"](sSelectedId);
		this["updateMenu"](sSelectedId);
	}

	if (sSelectedId !== this["sSelectedPanelId"] && !this["bCollapsed"] && this["bClientSelect"]) {
		this["selectPanelContent"](sSelectedId);
		this["applyAnimation"](sSelectedId);
	}

	if (this["bCollapsed"]) {
		this["onAfterSelection"](sSelectedId, false);
	}

	this["sSelectedPanelId"] = sSelectedId;
	this["setClientProperty"]("SelectedPanelId", this["sSelectedPanelId"], true);

	this["iSelected"] = this["iGetSelectedIndex"](sSelectedId);
	this["setFocus"](oOldSelTitle, oNewSelTitle);

	this["iFocused"] = this["iSelected"];

	//this.oItemNavigation.setFocusedIndex(this.iFocused);
	//CSN 1443958 2013 -- change the style for the first visible panel
	this["removeMoreIndicator"]();
	this["setMoreIndicator"]();
	// Notify framework, that layout has changed after toggling the PanelStack
	this["notifyLayoutChange"]();

	//UCF_DomUtil.detachEvent(oNewSelTitle,'blur',this._forwardBlur);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectByPanelId"] = 0; };

/**
 * If the pager menu was used a panel item is selcted
 * If the control menu is used, only the content is changed
 *
 * @param {UCF_Event} oEvent the internal event
 */
UCF_PanelStack["prototype"]["onSelectByMenu"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onSelectByMenu"]++; }; 

	var sMenuItemId = oEvent["oGetParam"]('sItemId');

	if (!sMenuItemId) return;

	var sSelectedId = sMenuItemId["split"]('-')[0];
	this["selectByMenuId"](sSelectedId);

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onSelectByMenu"] = 0; };

/**
 * If the pager menu was used a panel item is selcted
 * If the control menu is used, only the content is changed
 * @param {string} sSelectedId
 */
UCF_PanelStack["prototype"]["selectByMenuId"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectByMenuId"]++; }; 

	var aItems = this["oItemNavigation"]["aItems"];
	var iSelectedIndex = function(sId) {

		return UCF_JsUtil["filter"](aItems, function(oItem) {
			return oItem["sId"] === sId;
		});
	};

	//fire select event independent of clientselect
	if (this["sSelectedPanelId"] !== sSelectedId) {
		this["fireSelect"](this["sId"], sSelectedId);
	}

	//Return if selecting is turned off
	if (!this["bClientSelect"]) return;

	if (this["sStackDesign"] === 'TAB' && this["sSelectedPanelId"] !== sSelectedId) {
		var oSelected = UCF_DomUtil["$"](sSelectedId);

		this["removePanelCollapseHeader"](this["sSelectedPanelId"]);
		if (!this["bCollapsed"]) {
			this["deselectPanelItem"](false);
			this["deselectHeaderFunctions"]();
		}
		this["selectPanelItem"](sSelectedId);
		this["selectHeaderFunctions"](sSelectedId);
		this["updateMenu"](sSelectedId);
		var aSelectedItems = iSelectedIndex(sSelectedId);
		this["oItemNavigation"]["iFocusedIndex"] = aSelectedItems && aSelectedItems["length"] > 0 ? aSelectedItems[0]["iIndex"] : 0;

		if (!this["bCollapsed"]) {
			this["selectPanelContent"](sSelectedId);

		}
		this["applyAnimation"](sSelectedId);
		if (this["bIsHidden"](oSelected)) {
			this["scrollIntoViewPort"](oSelected);
		}
		this["applyAnimation"](sSelectedId);

		var oSelTitle = UCF_DomUtil["$"](sSelectedId + '-title'),
			oDeSelTitle = UCF_DomUtil["$"](this["sSelectedPanelId"] + '-title');

		this["setFocus"](oDeSelTitle, oSelTitle);

		// ARIA: change aria-selected attribute
		if (window["UCF_System"]["bIsAria"]) {
			UCF_AriaStateHelper["setSelected"](oSelTitle, true);
			UCF_AriaStateHelper["setSelected"](oDeSelTitle, false);
		}
	}
	var oSelectedPanel = this["oGetPanelById"](sSelectedId);
	if (this["sStackDesign"] === 'MENU' && this["sSelectedPanelId"] !== sSelectedId) {
		this["updateTitle"](oSelectedPanel);
	}

	if (this["sStackDesign"] === 'TAB' || this["sStackDesign"] === 'MENU') {

		if (!this["bCollapsed"] && this["bClientSelect"]) {
			this["selectPanelContent"](sSelectedId);
		} else if (this["bCollapsed"]) {
			this["onAfterSelection"](sSelectedId, true);
		}
	}

	this["deselectHeaderFunctions"]();
	this["selectHeaderFunctions"](sSelectedId);

	this["updateMenu"](sSelectedId);

	this["sSelectedPanelId"] = sSelectedId;
	this["setClientProperty"]("SelectedPanelId", this["sSelectedPanelId"], true);

	this["iSelected"] = oSelectedPanel["iIndex"];
	//CSN 1443958 2013 -- change the style for the first visible panel
	if (this["sStackDesign"] === 'TAB') {
		this["removeMoreIndicator"]();
		this["setMoreIndicator"]();
	}

	// Notify framework, that layout has changed after toggling the PanelStack
	this["notifyLayoutChange"]();

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectByMenuId"] = 0; };

/**
 * select by keyboard
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PanelStack["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsselect"]++; }; 

	if (typeof(this["sStackDesign"]) === 'undefined' || this["sStackDesign"] !== 'TAB') return;
	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource && this["oItemContainer"] && UCF_DomUtil["bContains"](this["oItemContainer"], oSource)) {
		this["selectByPanel"](oBrowserEvent);
		var oSelTitle = UCF_DomUtil["$"](this["sSelectedPanelId"] + '-title');
		this["refocus"](oSelTitle);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsselect"] = 0; };

/**
 * Returns the clicked Tab item or null
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {HTMLElement}
 */
UCF_PanelStack["prototype"]["oGetSeletedPanel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetSeletedPanel"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource == null) return null;

	var oPanelDomRef = (oSource["getAttribute"]('tp') && oSource["getAttribute"]('tp') === 'P') ?
		oSource : this["oGetPanel"](oSource);

	return oPanelDomRef;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetSeletedPanel"] = 0; };

/**
 * Check the style for the next Panel, after the selected Panel
 * @param {string} sSelectedId
 */
UCF_PanelStack["prototype"]["checkAngleSelection"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["checkAngleSelection"]++; }; 

	if (this["bCollapsed"]) return;

	var oPanelDomRef = UCF_DomUtil["$"](sSelectedId);

	if (oPanelDomRef == null) return;

	if (oPanelDomRef !== this["aItems"][this["aItems"]["length"] - 1]["oDomRef"]) {
		var oNext = UCF_DomUtil["nextSibling"](oPanelDomRef, 'DIV');
		var oNextAngle = UCF_DomUtil["$"](oNext["id"] + '-angle');

		if (oNextAngle && oNextAngle["className"]["indexOf"]('EndSel') === -1) {
			oNextAngle["className"] = oNextAngle["className"] + 'EndSel';
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["checkAngleSelection"] = 0; };

/**
 * Sets the clicked item to selected
 * @param {string} sSelectedId
 */
UCF_PanelStack["prototype"]["selectPanelItem"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectPanelItem"]++; }; 

	var oPanelDomRef = UCF_DomUtil["$"](sSelectedId),
		oAngle = UCF_DomUtil["$"](sSelectedId + '-angle'),
		oTitle = UCF_DomUtil["$"](sSelectedId + '-title');

	if (oPanelDomRef == null) return;

	UCF_DomUtil["removeClass"](oPanelDomRef, 'lsPanelStack--panel-hoverable');
	if (__UCF_IE6__) {
		if (oPanelDomRef["className"]["indexOf"]('Sel') === -1)
			oPanelDomRef["className"] = oPanelDomRef["className"] + 'Sel';
		oTitle["className"] = oTitle["className"]["replace"]('Hover', '');

		if (oTitle["className"]["indexOf"]('Sel') === -1)
			oTitle["className"] = oTitle["className"] + 'Sel';
	}
	UCF_DomUtil["addClass"](oPanelDomRef, 'lsPanelStack--panel-selected');

	UCF_DomUtil["removeClass"](oTitle, 'lsPnstLabelSelCollapse');

	oAngle["className"] = oAngle["className"]["replace"]('EndHover', '');
	oAngle["className"] = oAngle["className"]["replace"]('Hover', '');
	if (oAngle) {
		if (oAngle["className"]["indexOf"]('End') > -1) {
			oAngle["className"] = oAngle["className"]["replace"]('End', '');
		} else {
			oAngle["className"] = oAngle["className"] + 'Sel';
		}
	}

	if (oPanelDomRef !== this["aItems"][this["aItems"]["length"] - 1]["oDomRef"]) {
		var oNext = UCF_DomUtil["nextSibling"](oPanelDomRef, 'DIV');
		var oNextAngle = UCF_DomUtil["$"](oNext["id"] + '-angle');
		if (oNextAngle) {
			oNextAngle["className"] = oNextAngle["className"]["replace"]('EndHover', '');
			oNextAngle["className"] = oNextAngle["className"]["replace"]('Hover', '');
			if (oNextAngle["className"]["indexOf"]('FirstMore') > -1) {
				oNextAngle["className"] = oNextAngle["className"]["replace"]('FirstMore', 'Start');
			}

			oNextAngle["className"] = oNextAngle["className"] + 'EndSel';
		}
	}

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectPanelItem"] = 0; };

UCF_PanelStack["prototype"]["removePanelCollapseHeader"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["removePanelCollapseHeader"]++; }; 

	var oTitle = UCF_DomUtil["$"](sSelectedId + '-title');

	if (oTitle == null) return;
	UCF_DomUtil["removeClass"](oTitle, 'lsPnstLabelSelCollapse');
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["removePanelCollapseHeader"] = 0; };
/**
 * deselects the previously selected item.
 * @param {boolean} bSelectedCollapse
 */
UCF_PanelStack["prototype"]["deselectPanelItem"] = function(bSelectedCollapse) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["deselectPanelItem"]++; }; 
	var oSelected = UCF_DomUtil["$"](this["sSelectedPanelId"]);
	if (oSelected == null) return;
	var oAngle = oSelected["childNodes"][0],
		oTitle = oSelected["childNodes"][1];
	if (__UCF_IE6__) {
		oSelected["className"] = oSelected["className"]["replace"]('Sel', '');
		oTitle["className"] = oTitle["className"]["replace"]('Sel', '');
	}

	UCF_DomUtil["removeClass"](oSelected, 'lsPanelStack--panel-selected');
	UCF_DomUtil["addClass"](oSelected, 'lsPanelStack--panel-hoverable');

	oAngle["className"] = oAngle["className"]["replace"]('Sel', '');

	if (bSelectedCollapse) {
		UCF_DomUtil["addClass"](oTitle, 'lsPnstLabelSelCollapse');
	}

	if (oSelected !== this["aItems"][this["aItems"]["length"] - 1]["oDomRef"]) {
		var oNext = UCF_DomUtil["nextSibling"](oSelected, 'DIV'),
			oNextAngle = UCF_DomUtil["$"](oNext["id"] + '-angle');

		oNextAngle["className"] = oNextAngle["className"]["replace"]('EndSel', '');
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["deselectPanelItem"] = 0; };

/**
 * Selects and deselects the content
 * @param {string} sSelectedId
 */
UCF_PanelStack["prototype"]["selectPanelContent"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectPanelContent"]++; }; 

	var oSelected = UCF_DomUtil["$"](this["sSelectedPanelId"] + '-cntwhl'),
		oNewWholeContainer = UCF_DomUtil["$"](sSelectedId + '-cntwhl');

	if (oSelected != null)
		UCF_DomUtil["addClass"](oSelected, 'lsPanelStack--panel-collapsed');

	if (oNewWholeContainer != null)
		UCF_DomUtil["removeClass"](oNewWholeContainer, 'lsPanelStack--panel-collapsed');

	if (this["sScrollingMode"] !== 'NONE' && this["scrollAreaItems"] != null) {
		this["oScrollArea"] = this["scrollAreaItems"][this["iSelected"]];
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectPanelContent"] = 0; };

UCF_PanelStack["prototype"]["selectHeaderFunctions"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectHeaderFunctions"]++; }; 
	var oFunction = UCF_DomUtil["$"](sSelectedId + '-functions');

	if (oFunction && !UCF_DomUtil["bHasClass"](oFunction, 'lsPanelStack--panel-noheaderfunction')) {
		UCF_DomUtil["removeClass"](oFunction, 'lsElement--invisible');
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectHeaderFunctions"] = 0; };

UCF_PanelStack["prototype"]["deselectHeaderFunctions"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["deselectHeaderFunctions"]++; }; 
	var oFunction = UCF_DomUtil["$"](this["sSelectedPanelId"] + '-functions');

	if (oFunction && !UCF_DomUtil["bHasClass"](oFunction, 'lsPanelStack--panel-noheaderfunction')) {
		UCF_DomUtil["addClass"](oFunction, 'lsElement--invisible');
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["deselectHeaderFunctions"] = 0; };

/**
 * Update the pager menu or the panel menu accordingly
 * @param {string} sSelectedId
 */
UCF_PanelStack["prototype"]["updateMenu"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["updateMenu"]++; }; 
	if (!this["oPopupMenu"]) return;

	var oOldMenuItem = this["oLS"]["oControlFactory"]["oGetControlById"](this["sSelectedPanelId"] + '-menuItem'),
		oMenuItem = this["oLS"]["oControlFactory"]["oGetControlById"](sSelectedId + '-menuItem');

	oMenuItem["setChecked"](true);
	if (oOldMenuItem) {
		oOldMenuItem["setChecked"](false);
	}
	this["oSelectedMenuItem"] = oMenuItem;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["updateMenu"] = 0; };

/**
 * returns the index of the selected panel
 * @param {string} sSelectedId
 * @return {integer}
 */
// eslint-disable-next-line consistent-return
UCF_PanelStack["prototype"]["iGetSelectedIndex"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["iGetSelectedIndex"]++; }; 
	if (this["oSelectedMenuItem"] != null) {
		return this["oSelectedMenuItem"]["iIndex"];
	}

	for (var i = 0; i < this["aItems"]["length"]; i++) {
		if (sSelectedId === this["aItems"][i]["sId"]) {
			return i;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["iGetSelectedIndex"] = 0; };

/**
 * returns the panel with the given ID
 * @param {string} sId
 * @return {integer}
 */
UCF_PanelStack["prototype"]["oGetPanelById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetPanelById"]++; }; 
	for (var i = 0; i < this["aItems"]["length"]; i++) {
		if (sId === this["aItems"][i]["sId"]) {
			return this["aItems"][i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetPanelById"] = 0; };

/**
 * returns the panel with the given index
 * @param {integer} iIndex
 * @return {UCF_Panel}
 */
UCF_PanelStack["prototype"]["oGetPanelByIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetPanelByIndex"]++; }; 
	if (iIndex < this["aItems"]["length"]) {
		return this["aItems"][iIndex];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetPanelByIndex"] = 0; };

/**
 * Performs adjustments after an item has been selected
 *  - expands the control if neccessary
 *  - set selected design if neccessary
 *  - scrolls selected into view
 *
 * @param {string} sSelectedId
 * @param {boolean} bFirePanelEvents
 */
UCF_PanelStack["prototype"]["onAfterSelection"] = function(sSelectedId, bFirePanelEvents) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onAfterSelection"]++; }; 

	if (sSelectedId === this["sSelectedPanelId"]) {
		this["fireExpand"](this["sId"]);
	} else {
		if (bFirePanelEvents) {
			// SAP ME send Collapse/Expand Panel events
			var panelCtrl = this["oGetControlById"](sSelectedId, false);
			if (panelCtrl != null && UCF_JsUtil["bInstanceOf"](panelCtrl, 'UCF_Panel')) {
				panelCtrl["fireCollapse"](this["sSelectedPanelId"]);
				panelCtrl["fireExpand"](sSelectedId);
			}
		}
		if (this["bCollapsed"]) {
			this["fireExpand"](this["sId"]);
		}
	}

	if (this["bClientCollapse"]) {
		this["expandHeader"]();
		this["expandContent"](sSelectedId);
		this["bCollapsed"] = false;
		this["setClientProperty"]("Collapsed", this["bCollapsed"], true);

	}

	if (this["bClientSelect"]) {

		if (sSelectedId === this["sSelectedPanelId"]) {
			this["selectPanelItem"](sSelectedId);
		}

		this["selectPanelContent"](sSelectedId);
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onAfterSelection"] = 0; };

/**
 * Returns the panel element if the source is its title or angle
 *
 * @param {HTMLElement} oDomRef
 * @return {HTMLElement} oPanelDomRef
 */
UCF_PanelStack["prototype"]["oGetPanel"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetPanel"]++; }; 
	var oPanelDomRef = UCF_DomUtil["oGetParentByAttribute"](oDomRef, 'ct', 'P');
	return oPanelDomRef;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetPanel"] = 0; };

/**
 * Adjust the title to the current selected menu item.
 * Only used if StaDesign is 'MENU'
 *
 * @param {UCF_Panel} oSelectedPanel
 */
UCF_PanelStack["prototype"]["updateTitle"] = function(oSelectedPanel) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["updateTitle"]++; }; 
	var sTitle = oSelectedPanel["sTitle"],
		sTooltip = oSelectedPanel["sTooltip"],
		oImageRef, sImageSrc,
		oRendererManager;

	if (sTooltip != null) {
		this["oTitle"]["setAttribute"]('title', sTooltip);
		this["oTitle"]["setAttribute"]('oldtitle', sTooltip);
	}
	if (this["oAriaHeading"])
		UCF_DomUtil["setInnerHtml"](this["oAriaHeading"], UCF_XSSEncoder["encodeHTML"](sTitle));

	if (oSelectedPanel["sAccessKey"] !== '') {
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](this["oTitle"], new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(undefined, this["oLS"])["sAccessKeyTextFragment"](
			oSelectedPanel["sTitle"],
			oSelectedPanel["sAccessKey"],
			oSelectedPanel["bEnabled"]
		));
	} else {
		UCF_DomUtil["setInnerText"](this["oTitle"], sTitle);
	}
	oRendererManager = this["oLS"]["oGetRenderManager"]();
	oImageRef = UCF_DomUtil["$"](this["sId"] + '-img');
	sImageSrc = oSelectedPanel["sImageSrc"] !== '' ? oSelectedPanel["sImageSrc"] : window["UCF_System"]["sSpaceGif"];

	if (oImageRef) {
		this["oPanelImage"](sImageSrc, oRendererManager, 'lsPnstImgAlign');
		// eslint-disable-next-line no-unsanitized/property
		oImageRef["outerHTML"] = oRendererManager["getHTMLString"]();
		oRendererManager["clearBuffer"]();
	}

	this["sTitle"] = sTitle;

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["updateTitle"] = 0; };

/**
 * @private
 * @param {string} sIconSrc the icon src
 * @param {UCF_RenderManager} oRenderManager the render manager
 * @param {string} sClassName the classname
 */
UCF_PanelStack["prototype"]["oPanelImage"] = function(sIconSrc, oRenderManager, sClassName) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oPanelImage"]++; }; 
	oRenderManager["write"](new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(undefined, this["oLS"])["sIconFragment"]({
		"Id": this["sId"] + '-img',
		"Src": sIconSrc,
		"SrcOnError": '',
		"Width": '',
		"Height": '',
		"Tooltip": '',
		"AlternativeText": '',
		"CssClass": sClassName,
		"CssStyle": ''
	}));
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oPanelImage"] = 0; };

/**
 * Finds out if a particular panel succeeds the selected item.
 * Necessary to know in order to apply the correct style when styles are switched.
 *
 * @param {HTMLElement} oPanelDomRef
 * @return {boolean}
 */
UCF_PanelStack["prototype"]["bDocksToSelected"] = function(oPanelDomRef) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["bDocksToSelected"]++; }; 

	if (oPanelDomRef && oPanelDomRef["className"]["indexOf"]('First') > -1) return false;

	var oPreviousPanel = UCF_DomUtil["previousSibling"](oPanelDomRef, 'DIV');

	if (oPreviousPanel["id"] === this["sSelectedPanelId"]) return true;

	return false;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["bDocksToSelected"] = 0; };

/**##########################################################################
 * ######################## Paging Section #################################
 * #########################################################################
 */

/**
 * Pages to the next hidden panels
 */
UCF_PanelStack["prototype"]["pageToNext"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["pageToNext"]++; }; 
	//if (this.oNextBtn.className.indexOf('Dsbl') > -1) return;
	this["oViewPort"]["scrollTop"] += this["aItems"][this["iSelected"]]["oDomRef"]["offsetHeight"];
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["pageToNext"] = 0; };

/**
 * Pages to the previous hidden panels
 */
UCF_PanelStack["prototype"]["pageToPrevious"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["pageToPrevious"]++; }; 
	//if (this.oPrevBtn.className.indexOf('Dsbl') > -1) return;
	this["oViewPort"]["scrollTop"] -= this["aItems"][this["iSelected"]]["oDomRef"]["offsetHeight"];
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["pageToPrevious"] = 0; };

/**
 * scrolls a particular item into the view port
 * @param {HTMLElement} oPanelDomRef
 */
UCF_PanelStack["prototype"]["scrollIntoViewPort"] = function(oPanelDomRef) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["scrollIntoViewPort"]++; }; 

	this["oViewPort"]["scrollTop"] = oPanelDomRef["offsetTop"];
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '============================= this.oViewPort.scrollTop: ' + this["oViewPort"]["scrollTop"], "PanelStack.js(1126): scrollIntoViewPort"); };
	//this.bSuppressResize = true;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["scrollIntoViewPort"] = 0; };

/**
 * Turns the pager visible
 */
UCF_PanelStack["prototype"]["showPager"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["showPager"]++; }; 
	UCF_DomUtil["removeClass"](this["oMenuButton"], 'lsPanelStack--pager-hidden');
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["showPager"] = 0; };

/**
 * Turns the pager invisible
 */
UCF_PanelStack["prototype"]["hidePager"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["hidePager"]++; }; 
	UCF_DomUtil["addClass"](this["oMenuButton"], 'lsPanelStack--pager-hidden');
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["hidePager"] = 0; };

/**
 * Sets the more indicator at the beginning of the panels
 */
UCF_PanelStack["prototype"]["setMoreIndicator"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setMoreIndicator"]++; }; 
	var oPanel = this["oGetFirstVisible"]();

	if (oPanel == null) return;
	if (oPanel["iIndex"] === 0) return;

	var oAngle = UCF_DomUtil["$"](oPanel["sId"] + '-angle');

	if (oPanel["sId"] === this["sSelectedPanelId"] && !this["bCollapsed"]) {
		oAngle["className"] = 'lsPnstFirstMoreSel';
	} else {
		oAngle["className"] = 'lsPnstFirstMore';
	}

	this["oMorePanel"] = oPanel;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setMoreIndicator"] = 0; };

/**
 * Removes the more indicator from the beginning of the panels
 */
UCF_PanelStack["prototype"]["removeMoreIndicator"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["removeMoreIndicator"]++; }; 

	if (this["oMorePanel"] == null) return;

	var oPanel = this["oMorePanel"],
		oAngle = UCF_DomUtil["$"](oPanel["sId"] + '-angle'),
		sSel = this["bCollapsed"] ? '' : 'Sel';

	if (oPanel["sId"] === this["sSelectedPanelId"]) {

		if (oPanel["iIndex"] === 0) {
			oAngle["className"] = 'lsPnstFirst' + sSel;
		} else {
			oAngle["className"] = 'lsPnstStart' + sSel;
		}
	} else {
		if (oPanel["iIndex"] === 0) {
			oAngle["className"] = 'lsPnstFirst';
		} else {
			if (this["bDocksToSelected"](oPanel["oDomRef"]) && !this["bCollapsed"]) {
				oAngle["className"] = 'lsPnstStartEndSel';
			} else {
				oAngle["className"] = 'lsPnstStart';
			}
		}
	}

	this["oMorePanel"] = null;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["removeMoreIndicator"] = 0; };

/**
 * Returns the first visible panel
 * @return {UCF_Panel}
 */
UCF_PanelStack["prototype"]["oGetFirstVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetFirstVisible"]++; }; 
	var aItems = this["aItems"];

	for (var i = 0; i < aItems["length"]; i++) {
		var oPanel = this["aItems"][i];
		if (!this["bIsHidden"](oPanel["oDomRef"]))
			return oPanel;
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetFirstVisible"] = 0; };

/**
 * Returns the last visible panel.
 * @return {UCF_Panel}
 */
UCF_PanelStack["prototype"]["oGetLastVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetLastVisible"]++; }; 
	var aItems = this["aItems"];

	for (var i = aItems["length"] - 1; i >= 0; i--) {
		var oPanel = this["aItems"][i];
		if (!this["bIsHidden"](oPanel["oDomRef"]))
			return oPanel;
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["oGetLastVisible"] = 0; };

/**
 * Returns the first visible panel index
 * @return {integer}
 */
UCF_PanelStack["prototype"]["iGetFirstVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["iGetFirstVisible"]++; }; 
	var aItems = this["aItems"];

	for (var i = 0; i < aItems["length"]; i++) {
		var oPanel = this["aItems"][i];
		if (!this["bIsHidden"](oPanel["oDomRef"]))
			return this["aItems"][i]["iIndex"];
	}
	return 0;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["iGetFirstVisible"] = 0; };

/**
 * Returns the last visible panel index.
 * @return {integer}
 */
UCF_PanelStack["prototype"]["iGetLastVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["iGetLastVisible"]++; }; 
	var aItems = this["aItems"];

	for (var i = aItems["length"] - 1; i >= 0; i--) {
		var oPanel = this["aItems"][i];
		if (!this["bIsHidden"](oPanel["oDomRef"]))
			return this["aItems"][i]["iIndex"];
	}
	return 0;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["iGetLastVisible"] = 0; };

/**
 * Finds out if a paricular panel is in the view port.
 * @param {HTMLElement} oPanelDomRef
 * @return {integer}
 */
UCF_PanelStack["prototype"]["bIsHidden"] = function(oPanelDomRef) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["bIsHidden"]++; }; 
	if (oPanelDomRef == null) return false;
	return oPanelDomRef["offsetTop"] > this["oViewPort"]["scrollTop"] + this["oViewPort"]["offsetHeight"] / 2
		|| oPanelDomRef["offsetTop"] < this["oViewPort"]["scrollTop"] - this["oViewPort"]["offsetHeight"] / 2;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["bIsHidden"] = 0; };

/**
 * Finds out if the view port scrolls
 * @return {boolean}
 */
UCF_PanelStack["prototype"]["bOverflowOn"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["bOverflowOn"]++; }; 
	return this["oViewPort"]["scrollHeight"] > this["oViewPort"]["offsetHeight"] + 5;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["bOverflowOn"] = 0; };

/**###################################################################
 * ############## Toggle Section ##################################
 * ##################################################################
 */

/**
 * Checks if toggling the content is possible
 * @param {UCF_BrowserEvent} oBrowserEvent the lstabnext
 * @return {boolean}
 */
UCF_PanelStack["prototype"]["bCanToggle"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["bCanToggle"]++; }; 

	if (this["sCollapseMode"] === 'NONE') return false;

	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource === this["oToggleButton"]) return true;

	return false;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["bCanToggle"] = 0; };

/**
 * Changes the status of the collapse icon in the header to expanded.
 */
UCF_PanelStack["prototype"]["toggleHeaderImage"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["toggleHeaderImage"]++; }; 
	if (this["bToggleAnimation"] && this["oToggleIconAnimation"]) {
		var sTransform = 'rotate';

		if (this["bCollapsed"]) {
			//this.oToggleIconAnimation.callbackFinish(this,'toggleHeaderStyle');
			//this.oToggleIconAnimation.addInitialTransformValue(sTransform, [-90]);
			this["oToggleIconAnimation"]["addTransformChange"](
				/*sTransformation:*/
				sTransform,
				/*aStartValues:*/
				[-90],
				/*aEndValues:*/
				[0],
				/*fnTransition:*/
				this["oToggleIconAnimation"]["M_TRANSITIONS"]["Linear"]
			);
			//this.oToggleIconAnimation.addFinalTransformValue(sTransform, [0]);
		} else {
			//this.oToggleIconAnimation.callbackFinish(this,'toggleHeaderStyle');
			//this.oToggleIconAnimation.addInitialTransformValue(sTransform, [0]);
			this["oToggleIconAnimation"]["addTransformChange"](
				/*sTransformation:*/
				sTransform,
				/*aStartValues:*/
				[0],
				/*aEndValues:*/
				[-90],
				/*fnTransition:*/
				this["oToggleIconAnimation"]["M_TRANSITIONS"]["Linear"]
			);
			//this.oToggleIconAnimation.addFinalTransformValue(sTransform, [-90]);

		}
		this["oToggleIconAnimation"]["play"]();

	}

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["toggleHeaderImage"] = 0; };

/**
 * Changes the status of the collapse icon in the header to expanded.
 */
UCF_PanelStack["prototype"]["expandHeader"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["expandHeader"]++; }; 

	// the CollapseMode can be 'NONE'
	if (this["oToggleButton"] != null) {
		//UCF_DomUtil.replaceClass(this.oToggleButton, 'lsPnstHdCol', 'lsPnstHdExp');
		UCF_DomUtil["replaceClass"](this["oToggleButton"], 'lsPnstTglIconCol', 'lsPnstTglIconExp');
		this["oToggleButton"]["title"] = this["oLS"]["sGetText"]('SAPUR_P_COLLAPSE');
	}

	var oLeft = UCF_DomUtil["$"](this["sId"] + '-left'),
		oRight = UCF_DomUtil["$"](this["sId"] + '-right');

	UCF_DomUtil["replaceClass"](oLeft, 'lsPnstHdLeftCol', 'lsPnstHdLeft');
	UCF_DomUtil["replaceClass"](oRight, 'lsPnstHdRightCol', 'lsPnstHdRight');

	var oPnstCenter1 = UCF_DomUtil["$"](this["sId"] + '-center1'),
		oPnstCenter2 = UCF_DomUtil["$"](this["sId"] + '-center2');
	if (oPnstCenter1 != null) {
		UCF_DomUtil["removeClass"](oPnstCenter1, 'lsPnstHdCenterCollapse');
	}
	if (oPnstCenter2 != null) {
		UCF_DomUtil["removeClass"](oPnstCenter2, 'lsPnstHdCenterCollapse');
	}

	// set aria-expanded true
	if (window["UCF_System"]["bIsAria"] && this["oToggleButton"]) {
		// panelstack: the expanded state is set at the icon / html span tag
		UCF_AriaStateHelper["setExpanded"](this["oToggleButton"], true);
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["expandHeader"] = 0; };

/**
 * Changes the status of the expanded icon in the header to collapsed.
 */
UCF_PanelStack["prototype"]["collapseHeader"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["collapseHeader"]++; }; 

	// the CollapseMode can be 'NONE'
	if (this["oToggleButton"] != null) {
		//	UCF_DomUtil.replaceClass(this.oToggleButton, 'lsPnstHdExp', 'lsPnstHdCol');
		UCF_DomUtil["replaceClass"](this["oToggleButton"], 'lsPnstTglIconExp', 'lsPnstTglIconCol');
		this["oToggleButton"]["title"] = this["oLS"]["sGetText"]('SAPUR_P_EXPAND');
	}

	var oLeft = UCF_DomUtil["$"](this["sId"] + '-left'),
		oRight = UCF_DomUtil["$"](this["sId"] + '-right');

	UCF_DomUtil["replaceClass"](oLeft, 'lsPnstHdLeft', 'lsPnstHdLeftCol');
	UCF_DomUtil["replaceClass"](oRight, 'lsPnstHdRight', 'lsPnstHdRightCol');

	var oPnstCenter1 = UCF_DomUtil["$"](this["sId"] + '-center1'),
		oPnstCenter2 = UCF_DomUtil["$"](this["sId"] + '-center2');
	if (oPnstCenter1 != null) {
		UCF_DomUtil["addClass"](oPnstCenter1, 'lsPnstHdCenterCollapse');
	}
	if (oPnstCenter2 != null) {
		UCF_DomUtil["addClass"](oPnstCenter2, 'lsPnstHdCenterCollapse');
	}

	// set aria-expanded false
	if (window["UCF_System"]["bIsAria"] && this["oToggleButton"]) {
		// panelstack: the collapsed state is set at the icon / html span tag
		UCF_AriaStateHelper["setExpanded"](this["oToggleButton"], false);
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["collapseHeader"] = 0; };

/**
 * Expands the content area. The exapnd collapse
 * status of the content differs from the unselected status. Both methods have to be
 * use separately.
 * @param {string} sSelectedId
 */
UCF_PanelStack["prototype"]["expandContent"] = function(sSelectedId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["expandContent"]++; }; 

	var sValisSelectedID = (sSelectedId ? sSelectedId : this["sSelectedPanelId"]);
	var oWholeContainer = UCF_DomUtil["$"](sValisSelectedID + '-cntwhl');

	this["oDomRef"]["style"]["height"] = this["sHeight"];

	if (oWholeContainer == null) return;

	UCF_DomUtil["removeClass"](oWholeContainer, 'lsPanelStack--panel-collapsed');
	this["setContentNoneDisplay"](false);

	this["setScrollPosition"]();
	if (window["UCF_System"]["sDevice"] === 'standards' && UCF_UserAgent["bIsIE"]()) {
		UCF_DomUtil["initHtmlTableCorrection"](this["oDomRef"], true);
	}
	this["applyAnimation"](sValisSelectedID);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["expandContent"] = 0; };

/**
 * Collapses the content area. The exapnd collapse
 * status of the content differs from the unselected status. Both methods have to be
 * use separately.
 */
UCF_PanelStack["prototype"]["collapseContent"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["collapseContent"]++; }; 

	var oWholeContainer = UCF_DomUtil["$"](this["sSelectedPanelId"] + '-cntwhl');

	var oHeader = UCF_DomUtil["$"](this["sId"] + '-center2');
	var minHeight = oHeader["offsetHeight"];
	this["oDomRef"]["style"]["height"] = parseInt(minHeight) + 'px';

	UCF_DomUtil["addClass"](oWholeContainer, 'lsPanelStack--panel-collapsed');

	this["setContentNoneDisplay"](true);
	if (this["bAnimation"] && this["oSelArrowDomRef"]) {
		this["oSelArrowDomRef"]["style"]["left"] = '-100px';
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["collapseContent"] = 0; };

/**
 * Expand by keyboard
 * @param {UCF_BrowserEvent} oBrowserEvent the lstabnext
 */
UCF_PanelStack["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsexpand"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PanelStack.js(1459): onlsexpand"); };

	var oSource = oBrowserEvent["oGetSourceControl"]();

	if (!UCF_JsUtil["bInstanceOf"](oSource, 'UCF_PanelStack') &&
		!UCF_JsUtil["bInstanceOf"](oSource, 'UCF_Panel'))
		return;
	// should expand only when the active element is the Toggle Icon
	if (UCF_DomUtil["oGetActiveElement"]() !== this["oToggleButton"]) return;

	if (!this["bCollapsed"]) {
		oBrowserEvent["cancelBubble"]();
		return;
	}

	this["fireExpand"](this["sId"]);

	if (!this["bClientCollapse"]) return;

	this["expandHeader"](oBrowserEvent);
	this["expandContent"]();

	this["bCollapsed"] = !this["bCollapsed"];
	this["setClientProperty"]("Collapsed", this["bCollapsed"], true);
	if (this["sStackDesign"] === 'TAB') {
		this["selectPanelItem"](this["sSelectedPanelId"]);

		var oSelected = this["aItems"][this["iSelected"]]["oDomRef"];
		if (this["bIsHidden"](oSelected)) {
			this["scrollIntoViewPort"](oSelected);
			this["removeMoreIndicator"]();
			this["setMoreIndicator"]();
		}

		var oFocusedTitle = UCF_DomUtil["$"](this["aItems"][this["iFocused"]]["sId"] + '-title'),
			oSelectedTitle = UCF_DomUtil["$"](this["sSelectedPanelId"] + '-title');
		if (oFocusedTitle !== oSelectedTitle) {
			this["setFocus"](oFocusedTitle, oSelectedTitle);

			this["iFocused"] = this["aItems"][this["iSelected"]]["iIndex"];
		} else {
			this["refocus"](oSelectedTitle);
		}
		this["bSuppressResize"] = true;
	} else if (this["sStackDesign"] === 'MENU') {
		var oTitle = UCF_DomUtil["$"](this["sId"] + '-title');
		this["refocus"](oTitle);
	}
	oBrowserEvent["cancelBubble"]();
	this["setScrollPosition"]();
	// Notify framework, that layout has changed after toggling the PanelStack
	this["notifyLayoutChange"]();
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsexpand"] = 0; };

/**
 * Handles the right arrow on the PanelStack
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelStack["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsright"]++; }; 
	this["onlsexpand"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsright"] = 0; };

/********************************************
 * ######## Hotkey Section ######
 ********************************************/
/**
 * Handle hotkey events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelStack["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlshotkey"]++; }; 
	var oSelectedPanel = this["oGetPanelById"](this["sSelectedPanelId"]);
	if (oSelectedPanel && UCF_JsUtil["bInstanceOf"](oSelectedPanel, 'UCF_Panel'))
		oSelectedPanel["onlshotkey"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlshotkey"] = 0; };

/**
 * Collapse by keyboard
 * @param {UCF_BrowserEvent} oBrowserEvent the lstabnext
 */
UCF_PanelStack["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlscollapse"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PanelStack.js(1543): onlscollapse"); };

	var oSource = oBrowserEvent["oGetSourceControl"]();

	if (!UCF_JsUtil["bInstanceOf"](oSource, 'UCF_PanelStack') &&
		!UCF_JsUtil["bInstanceOf"](oSource, 'UCF_Panel'))
		return;
	// should collapse only when the active element is the Toggle Icon
	if (UCF_DomUtil["oGetActiveElement"]() !== this["oToggleButton"]) return;
	if (this["bCollapsed"]) {
		oBrowserEvent["cancelBubble"]();
		return;
	}

	this["fireCollapse"](this["sId"]);

	if (!this["bClientCollapse"]) return;

	this["collapseHeader"](oBrowserEvent);
	this["collapseContent"]();

	this["bCollapsed"] = !this["bCollapsed"];
	this["setClientProperty"]("Collapsed", this["bCollapsed"], true);
	if (this["sStackDesign"] === 'TAB') {
		this["deselectPanelItem"](true);

		this["scrollIntoViewPort"](this["aItems"][this["iFocused"]]["oDomRef"]);
		this["removeMoreIndicator"]();
		this["setMoreIndicator"]();
		//this.setNextBtn();
		//this.setPreviousBtn();
		// while Collpase, the focus moves on the ToggleIcon
		this["refocus"](this["oToggleButton"]);

	} else if (this["sStackDesign"] === 'MENU') {
		this["refocus"](this["oToggleButton"]);
	}
	oBrowserEvent["cancelBubble"]();
	// Notify framework, that layout has changed after toggling the PanelStack
	this["notifyLayoutChange"]();
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlscollapse"] = 0; };

/*
 * Handles the left arrow on the PanelStack
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelStack["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsleft"]++; }; 
	this["onlscollapse"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsleft"] = 0; };

UCF_PanelStack["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsskipforward"] = 0; };

UCF_PanelStack["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsskipback"] = 0; };

/**
 * Selects the next tab by ctrl + page up
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelStack["prototype"]["onlspageupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlspageupmodifier"]++; }; 

	var oSource = oBrowserEvent["oGetSourceControl"]();

	//select next item by using page up
	if (oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]() && !oBrowserEvent["bAlt"]()) {
		var oItem = this["nextSelectable"]();

		if (oItem != null) {
			this["selectByPaging"](oSource, oItem);
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlspageupmodifier"] = 0; };

/**
 * Selects the prevouis tab by ctrl + page down
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelStack["prototype"]["onlspagedownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlspagedownmodifier"]++; }; 

	var oSource = oBrowserEvent["oGetSourceControl"]();

	//select previous item by using page down
	if (oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]() && !oBrowserEvent["bAlt"]()) {
		var oItem = this["previousSelectable"]();
		if (oItem != null) {
			this["selectByPaging"](oSource, oItem);
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlspagedownmodifier"] = 0; };

/**
 * Handles the onlsfocus event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PanelStack["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PanelStack.js(1651): onlsfocus"); };
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oDomRef"]) {
		if (this["sCollapseMode"] !== 'NONE') {
			UCF_DomUtil["focusDomElement"](this["oToggleButton"]);
		} else {
			this["oLS"]["focusElement"](this["sSelectedPanelId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsfocus"] = 0; };

/**
 * Selects the next tab by page up / down
 *
 * @private
 * @param {UCF_Panel} oSource
 * @param {UCF_Panel} oItem
 */
UCF_PanelStack["prototype"]["selectByPaging"] = function(oSource, oItem) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectByPaging"]++; }; 
	if (oSource["sId"] !== oItem["sId"]) {
		if (this["sStackDesign"] === 'MENU') {
			this["selectByMenuId"](oItem["sId"]);
		} else {
			this["selectByPanelId"](oItem["sId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectByPaging"] = 0; };

/**
 * Finds the next selectable tab. Returns null, if there is none
 *
 * @private
 * @return {UCF_Panel}
 */
UCF_PanelStack["prototype"]["nextSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["nextSelectable"]++; }; 

	if (this["iSelected"] + 1 >= this["aItems"]["length"]) return;

	var i = this["iSelected"] + 1,
		aItems = this["aItems"],
		oItem = null;

	while (i < aItems["length"]) {

		if (aItems[i]["bEnabled"]) {
			oItem = aItems[i];
			break;
		}
		i++;
	}
	// eslint-disable-next-line consistent-return
	return oItem;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["nextSelectable"] = 0; };

/**
 * Finds the previous selectable tab. Returns null, if there is none
 *
 * @private
 * @return {UCF_Panel}
 */
UCF_PanelStack["prototype"]["previousSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["previousSelectable"]++; }; 

	if (this["iSelected"] < 0) return;

	var i = this["iSelected"] - 1,
		aItems = this["aItems"],
		oItem = null;

	while (i >= 0) {

		if (aItems[i]["bEnabled"]) {
			oItem = aItems[i];
			break;
		}
		i--;
	}
	// eslint-disable-next-line consistent-return
	return oItem;
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["previousSelectable"] = 0; };

/**########################################################
 * ################### Popup Menu Section ##################
 * #########################################################
 */

/**
 * Creates an array with panels
 */
UCF_PanelStack["prototype"]["createPanels"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["createPanels"]++; }; 
	var aItemRef = UCF_DomUtil["$"](this["sId"] + '-itms')["childNodes"];
	this["aItems"] = [];

	if (this["bAnimation"]) {
		// the set realtive position fot the overflow
		var aItemRefItms = UCF_DomUtil["$"](this["sId"] + '-itms');
		aItemRefItms["style"]["position"] = 'relative';
	}
	var fillSCItems = (this["sScrollingMode"] !== 'NONE');
	if (fillSCItems) {
		this["scrollAreaItems"] = [];
	}
	for (var i = 0; i < aItemRef["length"]; i++) {
		var oPanel = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aItemRef[i], true);
		if (oPanel != null) {
			oPanel["setEmbeddingType"](oPanel["eEmbeddingType"]["PANEL_STACK"]);
			oPanel["oFocusDomRef"] = UCF_DomUtil["$"](oPanel["sId"] + '-title');
			oPanel["iIndex"] = i;
			oPanel["bIsDragHandle"] = false;
			this["aItems"]["push"](oPanel);
			if (oPanel["bEnabled"] || window["UCF_System"]["bIs508"] || window["UCF_System"]["bIsAria"]) {
				this["oItemNavigation"]["addItem"](oPanel, oPanel["iIndex"] === this["iSelected"]);
			}
			if (fillSCItems) {
				var oScrollDomRef = UCF_DomUtil["$"](oPanel["sId"] + '-scrl');
				if (oScrollDomRef) {
					var oScrollArea = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(oScrollDomRef);
					this["addDelegate"](oScrollArea);
					this["attachBrowserEvent"]('scroll', oScrollDomRef);
					oScrollArea["attachEvent"](oScrollArea["E_EVENTS"]["Scroll"], this, 'onScroll');
					this["scrollAreaItems"]["push"](oScrollArea);
				}
			}
			if (this["sSelectedPanelId"] === oPanel["sId"]) {

				this["iSelected"] = i;

				this["iFocused"] = i;

				if (this["bAnimation"] & this["bCollapsed"] === false) {
					var oPanelTabTitle = UCF_DomUtil["$"](oPanel["sId"] + '-title');
					if (oPanelTabTitle) {
						var leftPosition = aItemRef[i]["offsetLeft"] + oPanelTabTitle["clientWidth"] / 2 - 3;
						this["oSelArrowDomRef"]["style"]["left"] = Math["round"](leftPosition) + 'px';
						oPanelTabTitle["style"]["backgroundImage"] = 'none';
						if (this["iSelArrowOffsetTop"] === -1) {

							this["iSelArrowOffsetTop"] = this["oSelArrowDomRef"]["offsetTop"];
						}
						//_trace(INFO, ' test createPanels()' + this.bSelArrowHidden + ' - animation - ' + this.bAnimation);
					}
				}
			}

		}
	}
	if (this["bCollapsed"]) {
		var oHeader = UCF_DomUtil["$"](this["sId"] + '-center2');
		var minHeight = oHeader["offsetHeight"];
		this["oDomRef"]["style"]["height"] = parseInt(minHeight) + 'px';
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["createPanels"] = 0; };

/**
 * Open menu by keyboard
 * @param {UCF_BrowserEvent} oBrowserEvent the lstabnext
 */
UCF_PanelStack["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsshow"]++; }; 
	this["openMenu"](oBrowserEvent);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsshow"] = 0; };

/**
 * Opens the item menu
 * @param {UCF_BrowserEvent} oBrowserEvent the lstabnext
 */
UCF_PanelStack["prototype"]["openMenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["openMenu"]++; }; 

	var oSource = oBrowserEvent["oGetSource"](),
		oTglTitleArea = UCF_DomUtil["$"](this["sId"] + '-titlearea');

	if (oSource === this["oMenuButton"] || (this["sStackDesign"] === 'MENU'
			&& (oSource === this["oTitle"] || oSource === this["oTitleIcon"] || oSource === oTglTitleArea))) {

		if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
			UCF_DomUtil["removeClass"](this["oMenuOpener"], 'lsPanelStack--menu-open');
			this["oPopupMenu"]["close"]();
		} else {
			this["handlePopupMenuOpen"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["openMenu"] = 0; };

/**
 * Update items, render menu and open it.
 */
UCF_PanelStack["prototype"]["handlePopupMenuOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["handlePopupMenuOpen"]++; }; 
	var aNewItems = [];
	for (var i = 0; i < this["aItems"]["length"]; i++) {
		var oItem = this["aItems"][i];
		if (oItem["sVisibility"] === 'VISIBLE') {
			aNewItems["push"]({
				"PopupMenuItem": {
					"Id": oItem["sId"] + '-menuItem',
					"Text": oItem["sTitle"],
					"CanCheck": true,
					"Checked": oItem["sId"] === this["sSelectedPanelId"],
					"Enabled": oItem["bEnabled"],
					"HasIcon": !UCF_StringUtil["bIsEmpty"](oItem["sImageSrc"]),
					"EnabledIconSrc": oItem["sImageSrc"],
					"Tooltip": oItem["sTooltip"]
				}
			});
		}
	}
	var oMenuHelper = new (UCF_ClassLoader["oGetClass"]("UCF_ClientPopupMenuHelper"))(this["oLS"]);
	this["oPopupMenu"] = oMenuHelper["oRenderMenu"](
		this["sId"] + '-itmMenu',
		null, // DOM location: Must use default, which is Page assoc area
		aNewItems
	);
	var sOpenerId = this["sStackDesign"] === 'TAB' ? this["sId"] + '-menuOpener' : this["sId"] + '-title';
	var oOpenerRef = this["sStackDesign"] === 'TAB' ? this["oMenuButton"] : this["oTitle"];

	UCF_DomUtil["addClass"](this["oMenuOpener"], 'lsPanelStack--menu-open');
	this["oPopupMenu"]["setOpenerRef"](oOpenerRef);
	this["oPopupMenu"]["setOpenerId"](sOpenerId);
	this["oPopupMenu"]["setAlignment"](this["sStackDesign"] === 'TAB' ? UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"] : UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"]);
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, 'onMenuClose');
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, 'onSelectByMenu');
	this["oPopupMenu"]["bAutoRefocus"] = false;
	this["oPopupMenu"]["bContentChanged"] = false; // do not call the delayed call, otherwise items are not present when trying to access them first
	this["oPopupMenu"]["open"]();
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["handlePopupMenuOpen"] = 0; };

/**
 * Handles the close event of the item menu.
 * Sets the focus on the selected item.
 */
UCF_PanelStack["prototype"]["onMenuClose"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onMenuClose"]++; }; 

	var oFocus = (this["sStackDesign"] === 'TAB' && this["aItems"][this["iSelected"]]) ?
		this["aItems"][this["iSelected"]]["oDomRef"] :
		this["oTitleArea"];

	UCF_DomUtil["removeClass"](this["oMenuOpener"], 'lsPanelStack--menu-open');
	UCF_DomUtil["focusDomElement"](oFocus);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onMenuClose"] = 0; };

/**
 * Detaches from:
 * - the resize event
 *
 */
UCF_PanelStack["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["destroy"]++; }; 

	if (this["oScrollArea"]) {
		this["destroyScrollAreas"]();
		// this.oScrollArea is the selected scroll area of this.scrollAreaItems
		// whichi has already been destroyed in #destroyScrollAreas()
		this["oScrollArea"] = null;
	}
	var bDetach = this["sStackDesign"] === 'TAB' && this["aItems"]["length"] !== 0 && (this["oDomRef"]["style"]["visibility"] === 'visible' || this["oDomRef"]["style"]["visibility"] === '');

	if (bDetach) {
		this["detachBrowserEvent"]('resize', this["oViewPort"]);
	}

	if (this["oToggleIconAnimation"]) {
		this["oToggleIconAnimation"]["destroy"]();
		this["oToggleIconAnimation"] = null;
	}

	if (this["oExpand"]) {
		this["oExpand"]["destroy"]();
		this["oExpand"] = null;
	}

	if (this["oCollapse"]) {
		this["oCollapse"]["destroy"]();
		this["oCollapse"] = null;
	}

	if (this["oItemNavigation"]) {
		this["oItemNavigation"]["destroy"]();
		this["oItemNavigation"] = null;
	}

	if (this["oSelArrowAnimation"]) {
		this["oSelArrowAnimation"]["destroy"]();
		this["oSelArrowAnimation"] = null;
	}

	if (this["oPopupMenu"]) {
		UCF_ClientPopupMenuHelper["handleDestroy"](this["oPopupMenu"]);
		this["oPopupMenu"] = null;
	}
	this["oSelectedMenuItem"] = null;
	this["oMorePanel"] = null;
	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}
	this["oItemNavigation"] = null;
	this["oViewPort"] = null;
	this["oMenuButton"] = null;
	this["oTitle"] = null;
	this["oTitleArea"] = null;
	this["oTitleIcon"] = null;
	this["oMenuOpener"] = null;
	this["oSelArrowDomRef"] = null;
	this["sTitle"] = null;
	this["oToggleButton"] = null;
	this["oItemContainer"] = null;
	this["iWidth"] = 0;
	this["bSelArrowHidden"] = false;
	this["iSelArrowOffsetTop"] = 0;
	this["iSelected"] = 0;
	this["iFocused"] = 0;
	this["bToggleIconHidden"] = false;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["bCollapsed"] = false;
	this["sTimeOutId"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sSelectedPanelId"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sVisibility"] = null;
	this["oAriaHeading"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["destroy"] = 0; };

UCF_PanelStack["prototype"]["destroyScrollAreas"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["destroyScrollAreas"]++; }; 

	if (this["scrollAreaItems"]) {
		for (var i = 0; i < this["scrollAreaItems"]["length"]; i++) {
			var oScrollArea = this["scrollAreaItems"][i];
			UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, oScrollArea);
		}
		this["scrollAreaItems"] = null;
	}

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["destroyScrollAreas"] = 0; };

/**###############################################################################
 * #################### Drag and Drop section ####################################
 * ###############################################################################
 */

/**
 * implements method from UCF_Control
 */
UCF_PanelStack["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["createDragDelegate"]++; }; 

	if (!this["sDragSourceInfo"])
		return;

	if (this["oDragDelegate"])
		return;

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_PanelStackDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["createDragDelegate"] = 0; };

/**
 * implements method from UCF_Control
 */
UCF_PanelStack["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["createDropDelegate"]++; }; 

	if (!this["sDropTargetInfo"])
		return;

	if (this["oDropDelegate"])
		return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_PanelStackDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["createDropDelegate"] = 0; };

UCF_PanelStack["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsnext"]++; }; 

	var oSourceControl = oBrowserEvent["oSourceControl"],
		iLastVisible;
	if (this["sStackDesign"] === 'MENU') return;
	// if the active element is ToggleIcon, than just out
	if (UCF_DomUtil["oGetActiveElement"]() === this["oToggleButton"]) return;

	iLastVisible = this["iGetLastVisible"]();
	if (oSourceControl["iIndex"] === iLastVisible && iLastVisible < this["aItems"]["length"] - 1) {
		this["scrollIntoViewPort"](this["aItems"][iLastVisible + 1]["oDomRef"]);
		this["removeMoreIndicator"]();
		this["setMoreIndicator"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsnext"] = 0; };

UCF_PanelStack["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsprevious"]++; }; 
	var oSourceControl = oBrowserEvent["oSourceControl"],
		iFirstVisible;
	if (this["sStackDesign"] === 'MENU') return;

	// if the active element is ToggleIcon, than just out
	if (UCF_DomUtil["oGetActiveElement"]() === this["oToggleButton"]) return;

	iFirstVisible = this["iGetFirstVisible"]();
	if ((oSourceControl["iIndex"] === iFirstVisible && iFirstVisible > 0)) {

		this["scrollIntoViewPort"](this["aItems"][iFirstVisible - 1]["oDomRef"]);
		this["removeMoreIndicator"]();
		this["setMoreIndicator"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsprevious"] = 0; };

UCF_PanelStack["prototype"]["onPanelActivate"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onPanelActivate"]++; }; 
	var oPanel = oEvent["mParameters"]["oItem"];

	if (this["bIsHidden"](oPanel["oDomRef"])) {
		this["scrollIntoViewPort"](oPanel["oDomRef"]);
		this["removeMoreIndicator"]();
		this["setMoreIndicator"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onPanelActivate"] = 0; };

/**
 * Adjust the tabindex attribute and set focus accordingly
 * @param {HTMLElement} oOldSelTitle
 * @param {HTMLElement} oNewSelTitle
 */
UCF_PanelStack["prototype"]["setFocus"] = function(oOldSelTitle, oNewSelTitle) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setFocus"]++; }; 

	if (oOldSelTitle != null)
		UCF_DomUtil["setTabIndex"](oOldSelTitle, -1);

	UCF_DomUtil["setTabIndex"](oNewSelTitle, 0);
	UCF_DomUtil["focusDomElement"](oNewSelTitle);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setFocus"] = 0; };

/**
 * Resets the focus to the selected item
 *
 * @param {integer} iDeSelTitle index of the deselcted title
 * @param {integer} iSelTitle index of the selected title
 */
UCF_PanelStack["prototype"]["setFocusIds"] = function(iDeSelTitle, iSelTitle) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setFocusIds"]++; }; 

	if (iDeSelTitle === -1 || iSelTitle === -1) return;

	var oDeSelTitle = (iDeSelTitle !== -1) ? this["aItems"][iDeSelTitle]["oFocusDomRef"] : null,
		oSelTitle = (iSelTitle !== -1) ? this["aItems"][iSelTitle]["oFocusDomRef"] : null;
	if (oDeSelTitle) {
		UCF_DomUtil["setTabIndex"](oDeSelTitle, -1);
	}
	if (oSelTitle) {
		UCF_DomUtil["setTabIndex"](oSelTitle, 0);
	}

	this["iFocused"] = this["iSelected"];

};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setFocusIds"] = 0; };

/**
 * #################################################################
 * ################### ACC Section #################################
 * #################################################################
 * @param {oBrowserEvent} oBrowserEvent
 */
UCF_PanelStack["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsaccessibility"]++; }; 
	var oSource = oBrowserEvent["oGetSourceControl"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oEventSource = oBrowserEvent["oGetSource"]();

	if (!window["UCF_System"]["bIs508"]) return;

	if (!UCF_JsUtil["bInstanceOf"](oSource, 'UCF_PanelStack') &&
		!UCF_JsUtil["bInstanceOf"](oSource, 'UCF_Panel'))
		return;

	var bApplyContainerBehaviour = true;
	if (this["sStackDesign"] === 'TAB') {
		if (oEventSource === this["oMenuButton"]) {
			oAccessibilityHelper["addTutor"]('MENU_TUT');
			bApplyContainerBehaviour = false;
		} else if (oEventSource === this["oToggleButton"]) {
			// nothing
			oAccessibilityHelper["setControlType"]('TS');
			//oAccessibilityHelper.applyContainerEntryBehaviour();
		} else if (oBrowserEvent["oGetSource"]()["id"]["indexOf"]('-end') > -1 && oSource === this) {
			// nothing
		} else {

			oAccessibilityHelper["setControlType"]('TS');
			oAccessibilityHelper["setEnabled"](oSource["bEnabled"]);
			oAccessibilityHelper["setItemCount"](this["aItems"]["length"]);
			oAccessibilityHelper["setItemIndex"](oSource["iIndex"] + 1);
			oAccessibilityHelper["setText"](oSource["sTitle"]);
			oAccessibilityHelper["setAccessKey"](oSource["sAccessKey"]);

			if (!UCF_StringUtil["bIsEmpty"](oSource["sTooltip"])) {
				oAccessibilityHelper["setTooltip"](oSource["sTooltip"]);
			}

			if (oSource["sId"] !== this["sSelectedPanelId"] && oSource["bEnabled"]) {
				oAccessibilityHelper["addTutor"]('SELECT_TUT');
			}
			oAccessibilityHelper["setSelected"](oSource["sId"] === this["sSelectedPanelId"]);
			oAccessibilityHelper["addTutor"]('LRNAV_TUT');
		}
	} else if (this["sStackDesign"] === 'MENU') {
		if (!(oBrowserEvent["oGetSource"]()["id"]["indexOf"]('-end') > -1 && oSource === this)) {
			if (this["oTitleArea"] === oEventSource) {
				oAccessibilityHelper["setText"](this["sTitle"]);
				oAccessibilityHelper["setAccessKey"](oSource["sAccessKey"]);
				oAccessibilityHelper["addTutor"]('MENU_TUT');
			}

			if (!UCF_StringUtil["bIsEmpty"](this["sTooltip"])) {
				oAccessibilityHelper["setTooltip"](oSource["sTooltip"]);
			}
		}

	}

	if (oBrowserEvent["oGetSource"]()["id"]["indexOf"]('-end') > -1 && oSource === this) {
		oAccessibilityHelper["setControlType"]('TS_END');
	} else {
		if (bApplyContainerBehaviour) {
			oAccessibilityHelper["applyContainerEntryBehaviour"](true, (this["sCollapseMode"] !== 'NONE'), this["bCollapsed"]);

			if (!UCF_StringUtil["bIsEmpty"](this["sAccessibilityDescription"])) {
				oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);
			}
		}

	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["onlsaccessibility"] = 0; };

/**
 * Sets the visibility state of the PanelStack control.
 * @param {string} sVisibility
 * @public
 */
UCF_PanelStack["prototype"]["setVisibility"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setVisibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sVisibility) === 'string', "typeof(sVisibility) === 'string'", "PanelStack.js(2188): setVisibility"); };

	UCF_DomUtil["setVisibility"](this["oDomRef"], sVisibility);

	this["sVisibility"] = sVisibility;
	this["setClientProperty"]("Visibility", this["sVisibility"], true);
	this["iWidth"] = 0;
	this["onAfterResize"]();
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setVisibility"] = 0; };

/**
 * Select the Panel with the given Id for the PanelStack.
 * @param {string} sPanelId - identifier of the Panel that is to be selected.
 * @public
 */
UCF_PanelStack["prototype"]["selectPanel"] = function(sPanelId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectPanel"]++; }; 
	this["selectByPanelId"](sPanelId);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["selectPanel"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PanelStack["prototype"]["aAttributeNames"] = ["sVisibility","sWidth","sHeight","sCollapseMode","bClientCollapse","bCollapsed","sStackDesign","bClientSelect","sSelectedPanelId","sDragSourceInfo","sDropTargetInfo","sAccessibilityDescription","sScrollingMode","iScrollTop","iScrollLeft","sCustomData","sCustomStyle","iHeadingLevel"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PanelStack["prototype"]["aEventNames"] = ["Collapse","Expand","Change","Hotkey","Scroll","Select","Drag","Drop","MenuAccess"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PanelStack["prototype"]["aMethodNames"] = ["selectPanel","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_PanelStack["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_PanelStack["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PanelStack["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CollapseMode}
 */
UCF_PanelStack["prototype"]["sCollapseMode"] = "TO_HORIZONTAL_LINE";

/**
 * @private
 * @type {boolean}
 */
UCF_PanelStack["prototype"]["bClientCollapse"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_PanelStack["prototype"]["bCollapsed"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.StackDesign}
 */
UCF_PanelStack["prototype"]["sStackDesign"] = "TAB";

/**
 * @private
 * @type {boolean}
 */
UCF_PanelStack["prototype"]["bClientSelect"] = true;

/**
 * @private
 * @type {string}
 */
UCF_PanelStack["prototype"]["sSelectedPanelId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PanelStack["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PanelStack["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PanelStack["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ScrollingMode}
 */
UCF_PanelStack["prototype"]["sScrollingMode"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_PanelStack["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_PanelStack["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_PanelStack["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PanelStack["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {number}
 */
UCF_PanelStack["prototype"]["iHeadingLevel"] = 0;

//#JSCOVER_EXCL_START
/** @protected */
UCF_PanelStack["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sWidth"] = '';
	this["sHeight"] = '';
	this["sCollapseMode"] = "TO_HORIZONTAL_LINE";
	this["bClientCollapse"] = true;
	this["bCollapsed"] = false;
	this["sStackDesign"] = "TAB";
	this["bClientSelect"] = true;
	this["sSelectedPanelId"] = '';
	this["sDragSourceInfo"] = '';
	this["sDropTargetInfo"] = '';
	this["sAccessibilityDescription"] = '';
	this["sScrollingMode"] = "NONE";
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["iHeadingLevel"] = 0;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("CollapseMode", "TO_HORIZONTAL_LINE", true);
		this["setClientProperty"]("ClientCollapse", true, true);
		this["setClientProperty"]("Collapsed", false, true);
		this["setClientProperty"]("StackDesign", "TAB", true);
		this["setClientProperty"]("ClientSelect", true, true);
		this["setClientProperty"]("SelectedPanelId", '', true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("ScrollingMode", "NONE", true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The id of the Panelstack.
 * @fires PanelStack::Collapse
 */
UCF_PanelStack["prototype"]["fireCollapse"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "PanelStack.js(2390): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PanelStack.js(2391): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PanelStack.js(2392): fireCollapse"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("PanelStack", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the Panelstack
 * @fires PanelStack::Expand
 */
UCF_PanelStack["prototype"]["fireExpand"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireExpand"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "PanelStack.js(2409): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PanelStack.js(2410): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PanelStack.js(2411): fireExpand"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("PanelStack", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireExpand"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the Panelstack.
 * @param {string} sPanelId The id of the Panel which title was changed.
 * @param {string} sValue The new tile.
 * @fires PanelStack::Change
 */
UCF_PanelStack["prototype"]["fireChange"] = function(sId, sPanelId, sValue) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireChange"]++; }; 
	/** @type {{Id: string, PanelId: string, Value: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PanelStack.js(2432): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PanelStack.js(2433): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PanelStack.js(2434): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPanelId != null, "sPanelId != null", "PanelStack.js(2435): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPanelId) == "string", "typeof(sPanelId) == \"string\"", "PanelStack.js(2436): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "PanelStack.js(2437): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "PanelStack.js(2438): fireChange"); };
	mParams = {
		"Id": sId,
		"PanelId": sPanelId,
		"Value": sValue
	};
	
	if (sPanelId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sPanelId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "PanelId");
			}
		}
	
	this["fireSemanticEvent"]("PanelStack", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires PanelStack::Hotkey
 */
UCF_PanelStack["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PanelStack.js(2468): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PanelStack.js(2469): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PanelStack.js(2470): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "PanelStack.js(2471): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "PanelStack.js(2472): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "PanelStack.js(2473): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "PanelStack.js(2474): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	
	if (sProviderId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sProviderId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ProviderId");
			}
		}
	this["fireSemanticEvent"]("PanelStack", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireHotkey"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Panelstack.
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires PanelStack::Scroll
 */
UCF_PanelStack["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PanelStack.js(2502): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PanelStack.js(2503): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PanelStack.js(2504): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "PanelStack.js(2505): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "PanelStack.js(2506): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "PanelStack.js(2507): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "PanelStack.js(2508): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("PanelStack", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Panelstack.
 * @param {string} sPanelId Identifier of the selected Panel.
 * @fires PanelStack::Select
 */
UCF_PanelStack["prototype"]["fireSelect"] = function(sId, sPanelId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, PanelId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "PanelStack.js(2532): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PanelStack.js(2533): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PanelStack.js(2534): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPanelId != null, "sPanelId != null", "PanelStack.js(2535): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPanelId) == "string", "typeof(sPanelId) == \"string\"", "PanelStack.js(2536): fireSelect"); };
	mParams = {
		"Id": sId,
		"PanelId": sPanelId
	};
	
	if (sPanelId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sPanelId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "PanelId");
			}
		}
	this["fireSemanticEvent"]("PanelStack", "Select", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires PanelStack::Drag
 */
UCF_PanelStack["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PanelStack.js(2562): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PanelStack.js(2563): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PanelStack.js(2564): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "PanelStack.js(2565): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "PanelStack.js(2566): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "PanelStack.js(2567): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "PanelStack.js(2568): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("PanelStack", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sPanelId The Index of the TabstripItem where the drop occured
 * @param {number} iOffset The Offset relative to the TabStripItem where the drop occured (signum)
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires PanelStack::Drop
 */
UCF_PanelStack["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, sPanelId, iOffset, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, PanelId: string, Offset: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 12, "arguments.length == 12", "PanelStack.js(2600): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PanelStack.js(2601): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PanelStack.js(2602): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "PanelStack.js(2603): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "PanelStack.js(2604): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "PanelStack.js(2605): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "PanelStack.js(2606): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPanelId != null, "sPanelId != null", "PanelStack.js(2607): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPanelId) == "string", "typeof(sPanelId) == \"string\"", "PanelStack.js(2608): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOffset != null, "iOffset != null", "PanelStack.js(2609): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOffset) == "number", "typeof(iOffset) == \"number\"", "PanelStack.js(2610): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "PanelStack.js(2611): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "PanelStack.js(2612): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "PanelStack.js(2613): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "PanelStack.js(2614): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "PanelStack.js(2615): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "PanelStack.js(2616): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "PanelStack.js(2617): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "PanelStack.js(2618): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "PanelStack.js(2619): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "PanelStack.js(2620): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "PanelStack.js(2621): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "PanelStack.js(2622): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "PanelStack.js(2623): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "PanelStack.js(2624): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"PanelId": sPanelId,
		"Offset": iOffset,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("PanelStack", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the PopupTrigger control
 * @param {string} sPopupMenuId Identifier of the popupmenu associated to the item.
 * @param {boolean} bWithKeyboard Determines whether the menu is opened by a keyboard action or by a mouse action.
 * @fires PanelStack::MenuAccess
 */
UCF_PanelStack["prototype"]["fireMenuAccess"] = function(sId, sPopupMenuId, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string, PopupMenuId: string, WithKeyboard: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PanelStack.js(2665): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PanelStack.js(2666): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PanelStack.js(2667): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPopupMenuId != null, "sPopupMenuId != null", "PanelStack.js(2668): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPopupMenuId) == "string", "typeof(sPopupMenuId) == \"string\"", "PanelStack.js(2669): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bWithKeyboard != null, "bWithKeyboard != null", "PanelStack.js(2670): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bWithKeyboard) == "boolean", "typeof(bWithKeyboard) == \"boolean\"", "PanelStack.js(2671): fireMenuAccess"); };
	mParams = {
		"Id": sId,
		"PopupMenuId": sPopupMenuId,
		"WithKeyboard": bWithKeyboard
	};
	
	
	
	this["fireSemanticEvent"]("PanelStack", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PanelStack["_"]["fireMenuAccess"] = 0; };

UCF_PanelStack.prototype["aPublicMethods"] = ["setVisibility","selectPanel"].concat(UCF_PanelStack.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PanelStackDragDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_PanelStackDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_PanelStackDragDelegate["_"]["UCF_PanelStackDragDelegate"]++; }; 

	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);

};window["UCF_PanelStackDragDelegate"] = UCF_PanelStackDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PanelStackDragDelegate"); UCF_PanelStackDragDelegate["_"] = {UCF_PanelStackDragDelegate: 0}; }; ;
UCF_PanelStackDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_PanelStackDragDelegate.prototype["sClassName"] = "UCF_PanelStackDragDelegate";

UCF_PanelStackDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStackDragDelegate["_"]["oGetGhost"]++; }; 

	var oSource = oBrowserEvent["oGetSource"](),
		oPanel = UCF_DomUtil["$"](oSource["id"]["split"]('-')[0]),
		oGhostFragment = oPanel["cloneNode"](true);

	// oGhostFragment.style.width = oPanel.offsetWidth + 'px';

	oGhostFragment["style"]["fontSize"] = '0.7em';
	oGhostFragment["style"]["paddingRight"] = '1px';
	var selection = UCF_StringUtil["bContains"](oGhostFragment["className"], 'Sel', true);

	oGhostFragment["className"] = selection ? 'lsPnstLastSel' : 'lsPnstLast';

	var firstChildSpan = UCF_DomUtil["firstChild"](oGhostFragment, 'SPAN');

	if (firstChildSpan) {
		if (selection) {
			firstChildSpan["className"] = 'lsPnstFirstSel';
			firstChildSpan["height"] = '2.5em';
			firstChildSpan["marginLeft"] = '30px';
		} else {
			firstChildSpan["className"] = 'lsPnstFirst';
		}
	}
	var oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oGhostFragment);
	oGhost["setOffset"](4, 4);
	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_PanelStackDragDelegate["_"]["oGetGhost"] = 0; };

UCF_PanelStackDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStackDragDelegate["_"]["bIsDragPossible"]++; }; 

	// George, I changed this to be only draggable from the panel header
	var oPanelHeader = UCF_DomUtil["$"](this["oDragSourceControl"]["sId"] + '-itms');

	if (UCF_DomUtil["bContains"](oPanelHeader, oBrowserEvent["oGetSource"]())) {
		return true;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_PanelStackDragDelegate["_"]["bIsDragPossible"] = 0; };

};
sap["ls"]["preload"]["UCF_PanelStackDropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_BoxDecorator */
/// <reference path="./BoxDecorator.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_PanelStack} oPanelStack
 * @param {UCF_LS} oLS
 */
function UCF_PanelStackDropDecorator(oPanelStack, oLS) {if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["UCF_PanelStackDropDecorator"]++; }; 

	this["oLineDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(oPanelStack, false);
	//this.oLineDecorator.apply(this, [oPanelStack, false]);
	//create box decorator
	this["oBoxDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_BoxDecorator"))(oPanelStack);
	// this.oBoxDecorator.setContainer(oControl.oRootRef); //probably need for ff2?
	this["oBoxDecorator"]["bDashed"] = false;
	this["oControl"] = oPanelStack;
	this["oLS"] = oLS;
	this["bInitialized"] = false;
};window["UCF_PanelStackDropDecorator"] = UCF_PanelStackDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PanelStackDropDecorator"); UCF_PanelStackDropDecorator["_"] = {UCF_PanelStackDropDecorator: 0}; }; ;

/**
 *
 */
UCF_PanelStackDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_PanelStackDropDecorator.prototype["sClassName"] = "UCF_PanelStackDropDecorator";

/**
 * destructor
 */
UCF_PanelStackDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["destroy"]++; }; 
	this["oControl"] = null;
	this["oLineDecorator"]["destroy"]();
	this["oBoxDecorator"]["destroy"]();
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["destroy"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PanelStackDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["update"]++; }; 
	this["oLineDecorator"]["hide"]();
	this["oBoxDecorator"]["hide"]();
	this["sTargetPanelId"] = -1;

	var oPanelDomRef = UCF_DomUtil["$"](this["oControl"]["sId"] + "-itms"),
		oViewPortRect = UCF_DomUtil["oGetObjectRect"](oPanelDomRef),
		oRowDomRef = UCF_DomUtil["$"](this["oControl"]["sId"] + "-selArrow"),
		iHeight = 0;
	var aDomItems, i, iLeftBoxDecorator, iWidthBoxDecorator;
	if (this["bMouseOutsideItems"](oPanelDomRef, oBrowserEvent)) {
		this["hide"]();
		return;
	}
	var oSource = oBrowserEvent["oGetSource"]();
	if (oPanelDomRef === oSource) {
		//BoxDecorator
		// find last visible Panel
		// find the Bounds for the BoxDecorator
		//debugger;
		aDomItems = oPanelDomRef["childNodes"];
		i = 0;
		var oLastVisiblePanel = null,
			bFirstVisibleFlag = false;
		// bIsVisible = false;

		while (i < aDomItems["length"]) {
			var bVisible = this["bIsPanelVisible"](aDomItems[i], oPanelDomRef) && aDomItems[i] !== oRowDomRef;
			if (bVisible) {
				oLastVisiblePanel = aDomItems[i];
				if (bFirstVisibleFlag === false) {
					bFirstVisibleFlag = true;
				}
			}
			if (!bVisible && bFirstVisibleFlag)
				break;
			i++;
		}
		if (oLastVisiblePanel != null) {
			this["sTargetPanelId"] = oLastVisiblePanel["getAttribute"]("id");
			this["iPosition"] = 1;
			var oLastVisiblePanelRect = UCF_DomUtil["oGetObjectRect"](oLastVisiblePanel);
			iLeftBoxDecorator = oLastVisiblePanelRect["left"] + oLastVisiblePanelRect["width"] + 4;
			iWidthBoxDecorator = oViewPortRect["left"] + oViewPortRect["width"] - iLeftBoxDecorator - 2;
			if (iWidthBoxDecorator < 0) {
				iWidthBoxDecorator = 0;
			}
			this["oBoxDecorator"]["setBounds"](iLeftBoxDecorator, oViewPortRect["top"], oViewPortRect["height"] - 2, iWidthBoxDecorator);
			this["oBoxDecorator"]["show"]();
		}
	} else {
		// LineDecorator
		aDomItems = oPanelDomRef["childNodes"];
		i = 0;
		var iMouseX = oBrowserEvent["iClientX"](),
			iPosition, iLeft;
		iLeftBoxDecorator = -1;
		// sTargetBoxPanelId = -1,

		while (this["sTargetPanelId"] === -1 && i < aDomItems["length"]) {

			if (!UCF_DomUtil["bContains"](aDomItems[i], oSource)) {
				i++;
				continue;
			}

			var oPanelRect = UCF_DomUtil["oGetObjectRect"](aDomItems[i]),
				iThreshold = oPanelRect["left"] + (window["UCF_System"]["bIsRTL"] ? 8 : 0) + oPanelRect["width"] / 2;

			iHeight = oPanelRect["height"];

			this["sTargetPanelId"] = aDomItems[i]["getAttribute"]("id");

			if (iMouseX < iThreshold) {
				iPosition = -1;
				iLeft = oPanelRect["left"];
				iLeftBoxDecorator = iThreshold;
				iWidthBoxDecorator = oViewPortRect["width"] - iThreshold - 3;
				// sTargetBoxPanelId = this.sTargetPanelId;
				if (!window["UCF_System"]["bIsRTL"]) {
					iLeft -= parseInt(UCF_DomUtil["sGetCurrentStyle"](aDomItems[i], "marginLeft"));
				}
			} else {
				iPosition = 1;
				iLeft = oPanelRect["left"] + oPanelRect["width"];
				if (window["UCF_System"]["bIsRTL"]) {
					iLeft += parseInt(UCF_DomUtil["sGetCurrentStyle"](aDomItems[i], "marginRight"));
				}
			}

			break;
		}
		if (this["sTargetPanelId"] === -1) {
			this["hide"]();
			return;
		} else {
			this["iPosition"] = iPosition;
			this["oLineDecorator"]["show"]();
			this["oLineDecorator"]["setBounds"](iLeft, oViewPortRect["top"], iHeight);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["update"] = 0; };

UCF_PanelStackDropDecorator["prototype"]["bMouseOutsideItems"] = function(oViewPortRect, oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["bMouseOutsideItems"]++; }; 

	var iMouseX = oBrowserEvent["iClientX"](),
		iMouseY = oBrowserEvent["iClientY"]();

	return (iMouseX < oViewPortRect["left"] ||
		iMouseX > oViewPortRect["left"] + oViewPortRect["width"] ||
		iMouseY < oViewPortRect["top"] ||
		iMouseY > oViewPortRect["top"] + oViewPortRect["height"]);
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["bMouseOutsideItems"] = 0; };

/**
 *
 */
UCF_PanelStackDropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["oGetDropLocation"]++; }; 

	if (this["sTargetPanelId"] === -1)
		return null;

	return { "sId": this["sTargetPanelId"], "iOffset": this["iPosition"] };
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["oGetDropLocation"] = 0; };

/**
 * creates dom
 *
 */
UCF_PanelStackDropDecorator["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["init"]++; }; 

	if (this["bInitialized"]) return;

	this["oLineDecorator"]["init"]();
	this["oBoxDecorator"]["init"]();
	this["bInitialized"] = true;
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["init"] = 0; };

/**
 * removes elements from DOM
 */
UCF_PanelStackDropDecorator["prototype"]["cleanUp"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["cleanUp"]++; }; 

	// this.oLineDecorator.cleanUp();
	// this.oBoxDecorator.cleanUp();
	this["oLineDecorator"]["hide"]();
	this["oBoxDecorator"]["hide"]();
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["cleanUp"] = 0; };

/**
 * needed to determine the hovered element
 */
UCF_PanelStackDropDecorator["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["hide"]++; }; 

	this["oLineWasVisible"] = this["oLineDecorator"]["bIsVisible"]();
	if (this["oLineWasVisible"]) {
		this["oLineDecorator"]["hide"]();
	}

	this["oBoxWasVisible"] = this["oBoxDecorator"]["bIsVisible"]();
	if (this["oBoxWasVisible"]) {
		this["oBoxDecorator"]["hide"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["hide"] = 0; };
UCF_PanelStackDropDecorator["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["show"]++; }; 

	if (this["oLineWasVisible"]) {
		this["oLineDecorator"]["show"]();
	}

	if (this["oBoxWasVisible"]) {
		this["oBoxDecorator"]["show"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["show"] = 0; };

UCF_PanelStackDropDecorator["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["bIsVisible"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["bIsVisible"] = 0; };

UCF_PanelStackDropDecorator["prototype"]["bIsPanelVisible"] = function(oPanelDomRef, oViewPort) {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["bIsPanelVisible"]++; }; 
	if (oPanelDomRef == null) return false;
	if (oPanelDomRef == null) return false;
	return oPanelDomRef["offsetTop"] < oViewPort["scrollTop"] + oViewPort["offsetHeight"] / 2;
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["bIsPanelVisible"] = 0; };

/**
 * destructor
 */
UCF_PanelStackDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["destroy"]++; }; 

	this["oLineDecorator"] = null;
	this["oBoxDecorator"] = null;
	this["sTargetPanelId"] = null;
	this["iPosition"] = null;
	this["oLineWasVisible"] = null;
	this["oBoxWasVisible"] = null;
	this["oLS"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_PanelStackDropDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_PanelStackDropDecorator */
/// <reference path="../decorators/PanelStackDropDecorator.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_PanelStackDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_PanelStackDropDelegate["_"]["UCF_PanelStackDropDelegate"]++; }; 

	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);
	this["oLS"] = oLS;
};window["UCF_PanelStackDropDelegate"] = UCF_PanelStackDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PanelStackDropDelegate"); UCF_PanelStackDropDelegate["_"] = {UCF_PanelStackDropDelegate: 0}; }; ;
UCF_PanelStackDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_PanelStackDropDelegate.prototype["sClassName"] = "UCF_PanelStackDropDelegate";

/**
 * @override
 */
UCF_PanelStackDropDelegate["prototype"]["oCreateDropDecorator"] = function() {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDelegate["_"]["oCreateDropDecorator"]++; }; 

	return new (UCF_ClassLoader["oGetClass"]("UCF_PanelStackDropDecorator"))(this["oDropTargetControl"], this["oLS"]);

};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDelegate["_"]["oCreateDropDecorator"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {Object}
 */
UCF_PanelStackDropDelegate["prototype"]["oGetDropLocation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDelegate["_"]["oGetDropLocation"]++; }; 

	if (!this["oDropDecorator"])
		return null;

	return this["oDropDecorator"]["oGetDropLocation"]();
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDelegate["_"]["oGetDropLocation"] = 0; };

/**
 * @param {UCF_DragSession} oDragSession
 * @return {function(string,string):void}
 */
UCF_PanelStackDropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		oLocation = this["oGetDropLocation"](),
		sPanelId = (oLocation != null) ? oLocation["sId"] : "",
		iOffset = (oLocation != null) ? oLocation["iOffset"] : 0,
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function(sDragData, sMimeType) {

		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			sPanelId,
			iOffset,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);
	};

};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDelegate["_"]["fGetDropCallBack"] = 0; };

// UCF_PanelStackDropDelegate.prototype.onlsdragover = function(oBrowserEvent) {
//	this.onlsdragenter(oBrowserEvent);
// };

UCF_PanelStackDropDelegate["prototype"]["onlsdraghover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDelegate["_"]["onlsdraghover"]++; }; 

	var oPanelDomRef = UCF_DomUtil["$"](this["oDropTargetControl"]["sId"] + "-itms"),
		oViewPort = UCF_DomUtil["oGetObjectRect"](oPanelDomRef),
		iMouseX = oBrowserEvent["iClientX"](),
		iMouseY = oBrowserEvent["iClientY"](),
		oPanelStack = this["oDropTargetControl"];

	if (iMouseY < oViewPort["top"] || iMouseY > oViewPort["top"] + oViewPort["height"])
		return;

	if (oPanelStack["bOverflowOn"]) {

		if (iMouseX < oViewPort["left"] + 20) {
			oPanelStack["pageToPrevious"]();
		} else if (iMouseX > oViewPort["left"] + oViewPort["width"] - 20) {
			oPanelStack["pageToNext"]();
		}
		// oPanelStack.setPreviousBtn();
		oPanelStack["setNextBtn"]();
		oPanelStack["removeMoreIndicator"]();
		oPanelStack["setMoreIndicator"]();
	}

	if (this["oDropDecorator"])
		this["oDropDecorator"]["update"](oBrowserEvent);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["bHandled"] = true;
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDelegate["_"]["onlsdraghover"] = 0; };

UCF_PanelStackDropDelegate["prototype"]["bIsDropPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PanelStackDropDelegate["_"]["bIsDropPossible"]++; }; 

	var oPanelDomRef = UCF_DomUtil["$"](this["oDropTargetControl"]["sId"] + "-itms"),
		oSource = oBrowserEvent["oGetSource"]();
	// The dropArea	will be constrained just to the Panels ( only where the decorator is shwon)
	//CSN 424560 2012
	//if ( oPanelDomRef == oSource)  return false;

	if (UCF_DomUtil["bContains"](oPanelDomRef, oSource)) {
		return UCF_DropDelegate.prototype["bIsDropPossible"]["call"](this, oBrowserEvent);
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_PanelStackDropDelegate["_"]["bIsDropPossible"] = 0; };

};
sap["ls"]["preload"]["UCF_PasswordFieldDelegate"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_Event */
/// <reference path="../../../core/Event.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>

/**
 * @class UCF_PasswordFieldDelegate
 * @extends UCF_Object
 * @param {UCF_InputField} oControl the field
 */
function UCF_PasswordFieldDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["UCF_PasswordFieldDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		/** @type {UCF_InputField} */
		this["oControl"] = oControl;
		/** @type {HTMLInputElement} */
		this["oDomRef"] = this["oControl"]["oDomRef"];
		/**
		 * @type {string} value from server. it is not allowed to edit the
		 * default value, you can only enter a new value
		 */
		this["sDefaultValue"] = this["oControl"]["sValue"];
	}
};window["UCF_PasswordFieldDelegate"] = UCF_PasswordFieldDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PasswordFieldDelegate"); UCF_PasswordFieldDelegate["_"] = {UCF_PasswordFieldDelegate: 0}; }; ;
UCF_PasswordFieldDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_PasswordFieldDelegate.prototype["sClassName"] = "UCF_PasswordFieldDelegate";

/** @override */
UCF_PasswordFieldDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["destroy"]++; }; 
	this["oControl"] = null;
	this["oDomRef"] = null;
	this["sDefaultValue"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["destroy"] = 0; };

/**
 * @private
 * @param {number} iKeyCode the key code
 * @return {boolean}
 */
UCF_PasswordFieldDelegate["bIsNavigationKey"] = function(iKeyCode) {;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["bIsNavigationKey"]++; }; 
	return iKeyCode === UCF_KeyCodes["ARROW_UP"]
		|| iKeyCode === UCF_KeyCodes["ARROW_DOWN"]
		|| iKeyCode === UCF_KeyCodes["ARROW_LEFT"]
		|| iKeyCode === UCF_KeyCodes["ARROW_RIGHT"]
		|| iKeyCode === UCF_KeyCodes["HOME"]
		|| iKeyCode === UCF_KeyCodes["END"];
};;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["bIsNavigationKey"] = 0; };

/** @override */
UCF_PasswordFieldDelegate["prototype"]["onkeydown"] = function(oKeyDownEvent) {;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["onkeydown"]++; }; 
	/** @type {number} */
	var iKey = oKeyDownEvent["iKeyCode"]();

	if (
		this["sDefaultValue"] &&
		this["oControl"]["sGetCurrentValue"]() === this["sDefaultValue"] &&
		UCF_PasswordFieldDelegate["bIsNavigationKey"](iKey)
	) {
		oKeyDownEvent["oDomEvent"]["returnValue"] = false;
		oKeyDownEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["onkeydown"] = 0; };

/** @override */
UCF_PasswordFieldDelegate["prototype"]["onAnyEvent"] = function(oAnyEvent) {;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["onAnyEvent"]++; }; 
	var oBrowserEvent = oAnyEvent["oGetParam"]('oBrowserEvent');
	var sName = oBrowserEvent["sGetName"]();
	var oBrowserWindow;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAnyEvent instanceof UCF_Event, "oAnyEvent instanceof UCF_Event", "PasswordFieldDelegate.js(77): onAnyEvent"); };

	if (sName === 'mouseup' || sName === 'select') {
		oBrowserWindow = this["oControl"]["oLS"]["oBrowserWindow"];
		oBrowserWindow["detachEvent"](
			oBrowserWindow["E_EVENTS"]["AnyEvent"],
			this, 'onAnyEvent'
		);
		// Browsers set the caret in the mouseup event
		// and remove the selection thereby.
		// But we want to
		// - select the content of passwordfields to indicate the user that the
		//   only operation is to overwrite the password
		// and
		// - prevent the browser to set the caret, so we cancel the event
		this["oControl"]["select"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["onAnyEvent"] = 0; };

/** @override */
UCF_PasswordFieldDelegate["prototype"]["onmousedown"] = function() {;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["onmousedown"]++; }; 
	var oBrowserWindow = this["oControl"]["oLS"]["oBrowserWindow"];

	oBrowserWindow["attachEvent"](
		oBrowserWindow["E_EVENTS"]["AnyEvent"],
		this, 'onAnyEvent'
	);
};;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["onmousedown"] = 0; };

/** @override */
UCF_PasswordFieldDelegate["prototype"]["onlsaccessibility"] = function(oLsAccessibilityEvent) {;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["onlsaccessibility"]++; }; 
	/** @type {string} */
	var sValue = this["oControl"]["sGetValue"]();

	if (sValue === '') {
		oLsAccessibilityEvent["oAccessibilityHelper"]["setEmpty"](true);
	} else {
		oLsAccessibilityEvent["oAccessibilityHelper"]["setText"](
			UCF_StringUtil["repeat"]('*', sValue["length"])
		);
	}
};;if (__UCF_COVERAGE__) { UCF_PasswordFieldDelegate["_"]["onlsaccessibility"] = 0; };

};
sap["ls"]["preload"]["UCF_PatternContainerIconButton"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PatternContainerIconButton(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["UCF_PatternContainerIconButton"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "PatternContainerIconButton.js(21): UCF_PatternContainerIconButton"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PatternContainerIconButton.js(22): UCF_PatternContainerIconButton"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PatternContainerIconButton.js(23): UCF_PatternContainerIconButton"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_PatternContainerIconButton"] = UCF_PatternContainerIconButton; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PatternContainerIconButton"); UCF_PatternContainerIconButton["_"] = {UCF_PatternContainerIconButton: 0}; }; ;
UCF_PatternContainerIconButton["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PatternContainerIconButton.prototype["sClassName"] = "UCF_PatternContainerIconButton";

/**
 * Handles the onclick event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerIconButton["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerIconButton.js(38): onclick"); };

	this["click"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["onclick"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerIconButton["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["onkeydown"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerIconButton.js(52): onkeydown"); };
	if (oBrowserEvent["iKeyCode"]() == UCF_KeyCodes["SPACE"]) {
		this["click"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["onkeydown"] = 0; };

/**
 * Fires the click event
 *
 * @private
 */
UCF_PatternContainerIconButton["prototype"]["click"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["click"]++; }; 

	if (!this["bEnabled"]) return;

	this["firePress"](this["sId"]);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["click"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerIconButton["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerIconButton.js(80): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	if (this["sFunctionStatus"] == "LARGE") {
		oAccessibilityHelper["setControlType"]("PCI_E");
		oAccessibilityHelper["addEnabledTutor"]("PCI_E_TUT", this["bEnabled"]);
	} else if (this["sFunctionStatus"] == "MEDIUM") {
		oAccessibilityHelper["setControlType"]("PCI_M");
		oAccessibilityHelper["addEnabledTutor"]("PCI_M_TUT", this["bEnabled"]);
	} else if (this["sFunctionStatus"] == "SMALL") {
		oAccessibilityHelper["setControlType"]("PCI_C");
		oAccessibilityHelper["addEnabledTutor"]("PCI_C_TUT", this["bEnabled"]);
	}
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PatternContainerIconButton["prototype"]["aAttributeNames"] = ["bEnabled","sFunctionStatus","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerIconButton["prototype"]["aEventNames"] = ["Press"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerIconButton["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerIconButton["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.IconButtonFunctionStatus}
 */
UCF_PatternContainerIconButton["prototype"]["sFunctionStatus"] = "LARGE";

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerIconButton["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PatternContainerIconButton["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["setDefaultValues"]++; }; 
	this["bEnabled"] = true;
	this["sFunctionStatus"] = "LARGE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("FunctionStatus", "LARGE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires PatternContainerIconButton::Press
 * @deprecated
 */
UCF_PatternContainerIconButton["prototype"]["firePress"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["firePress"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "PatternContainerIconButton.js(161): firePress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PatternContainerIconButton.js(162): firePress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PatternContainerIconButton.js(163): firePress"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("PatternContainerIconButton", "Press", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerIconButton["_"]["firePress"] = 0; };

};
sap["ls"]["preload"]["UCF_PatternContainerSequence"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PatternContainerSequence(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["UCF_PatternContainerSequence"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PatternContainerSequence.js(30): UCF_PatternContainerSequence"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PatternContainerSequence.js(31): UCF_PatternContainerSequence"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PatternContainerSequence.js(32): UCF_PatternContainerSequence"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_PatternContainerSequence"] = UCF_PatternContainerSequence; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PatternContainerSequence"); UCF_PatternContainerSequence["_"] = {UCF_PatternContainerSequence: 0}; }; ;
UCF_PatternContainerSequence["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PatternContainerSequence.prototype["sClassName"] = "UCF_PatternContainerSequence";

/**
 * Initialize the PatternContainerSequence
 */
UCF_PatternContainerSequence["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["initialize"]++; }; 

	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]);
	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Select"], this, "onItemSelect");
	this["createItems"]();

	this["bScrollingNeeded"] = this["aItems"]["length"] > this["iMaxVisibleItems"];
	this["iPageSize"] = Math["floor"](this["aItems"]["length"] / this["iMaxVisibleItems"]);
	this["iFirstVisibleItemIndex"] = Math["floor"](this["iSelectedIndex"] / this["iMaxVisibleItems"]) * this["iMaxVisibleItems"];

	this["updateScrollButtons"]();

	this["oItemNavigation"]["setFocusedIndex"](this["oItemNavigation"]["iFocusedIndex"]);
	UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
	if (this["aItems"]["length"] > 0) {

		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
		this["oItemNavigation"]["oItemContainer"] = this["oDomRef"]["firstChild"]["firstChild"];
	}

};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["initialize"] = 0; };

/**
 * Updated the enabled and disabled status of the scrolling buttons depending on the visiblity of the tabs
 */
UCF_PatternContainerSequence["prototype"]["updateScrollButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["updateScrollButtons"]++; }; 

	if (!this["bScrollable"]) return;
	var oPagingRef = UCF_DomUtil["$"](this["sId"] + "-pag");
	if (this["bScrollingNeeded"]) {
		UCF_DomUtil["removeClass"](oPagingRef, 'lsControl--hidden');
		oPagingRef["style"]["visibility"] = "visible";
	} else {
		oPagingRef["style"]["visibility"] = "hidden";
		return;
	}

	var aButtons = oPagingRef["childNodes"];

	if (this["iFirstVisibleItemIndex"] > 0) {
		aButtons[0]["className"] = "lsPGBtnIcon urPGBtn urPGHBegin";
		aButtons[1]["className"] = "lsPGBtnIcon urPGBtn urPGHPrevPage";
	} else {
		aButtons[0]["className"] = "lsPGBtnIcon urPGBtn urPGHBeginDsbl";
		aButtons[1]["className"] = "lsPGBtnIcon urPGBtn urPGHPrevPageDsbl";
	}

	if (this["iFirstVisibleItemIndex"] + this["iMaxVisibleItems"] < this["aItems"]["length"]) {
		aButtons[2]["className"] = "lsPGBtnIcon urPGBtn urPGHNxtPage";
		aButtons[3]["className"] = "lsPGBtnIcon urPGBtn urPGHEnd";
	} else {
		aButtons[2]["className"] = "lsPGBtnIcon urPGBtn urPGHNxtPageDsbl";
		aButtons[3]["className"] = "lsPGBtnIcon urPGBtn urPGHEndDsbl";
	}
	this["oItemNavigation"]["aItems"] = [];
	this["createItems"]();
	this["oItemNavigation"]["setFocusedIndex"](this["oItemNavigation"]["iFocusedIndex"]);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["updateScrollButtons"] = 0; };
/**
 * Creates PatternContainerSequenceItems

 */
UCF_PatternContainerSequence["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["createItems"]++; }; 
	this["aItems"] = [];
	var aItems = this["aItems"],
		iItemsLength = this["oDomRef"]["getAttribute"]("ic"),
		aItemIds = this["oDomRef"]["getAttribute"]("itemids")["split"](",");
	for (var iItemCount = 0; iItemCount < iItemsLength; iItemCount++) {
		var oDomItem = UCF_DomUtil["$"](aItemIds[iItemCount]),
			oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oDomItem, true);
		if (!oItem) continue;
		oItem["iIndex"] = iItemCount;
		oItem["bSelected"] = oItem["iIndex"] === this["iSelectedIndex"];
		aItems["push"](oItem);
		if (oItem["bGetVisible"]() && oItem["bEnabled"]) {
			this["oItemNavigation"]["addItem"](oItem, oItem["bSelected"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["createItems"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerSequence["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerSequence.js(131): onclick"); };
	var oSource = oBrowserEvent["oGetSource"]();
	var sSourceId = oSource["getAttribute"]("id");
	//toggle the tray if clicked on the icon
	if (sSourceId === this["sId"] + "-menu") {
		this["toggleMenu"]();
		return;
	} else if (sSourceId["indexOf"](this["sId"] + "-tit") > -1) {
		this["fireTitleSelect"](this["sId"]);
		return;
	} else if (sSourceId === this["sId"] + "-itemmenu") {
		this["toggleItemMenu"](oSource);
		return;
	} else if (sSourceId === this["sId"] + "-begin-btn-0") {
		this["firstPage"]();
		return;
	} else if (sSourceId === this["sId"] + "-end-btn-3") {
		this["lastPage"]();
		return;
	} else if (sSourceId === this["sId"] + "-prev-btn-1") {
		this["previousPage"]();
		return;
	} else if (sSourceId === this["sId"] + "-next-btn-2") {
		this["nextPage"]();
		return;
	}

};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onclick"] = 0; };

/**
 * Handle ItemSelect event
 *
 * @param {UCF_Event} oEvent
 */

UCF_PatternContainerSequence["prototype"]["onItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onItemSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "PatternContainerSequence.js(167): onItemSelect"); };
	var oItem = oEvent["oGetParam"]("oItem");
	if (oItem["bEnabled"] && oItem["iIndex"] !== this["iSelectedIndex"]) {
		this["fireItemSelect"](this["sId"], oItem["sId"]);
	}

};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onItemSelect"] = 0; };

/**
 * Opens the pattern containers option menu
 */
UCF_PatternContainerSequence["prototype"]["toggleMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["toggleMenu"]++; }; 

	if (!this["sOptionMenuId"]) return;

	var oMenuButtonRef = UCF_DomUtil["$"](this["sId"] + "-menu"); //the menu buttons dom ref

	if (!oMenuButtonRef) return;
	if (!this["oOptionMenu"]) {

		this["fireMenuAccess"](this["sId"]);

		this["oOptionMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](this["sOptionMenuId"], true);

		if (!this["oOptionMenu"]) return;

		this["oOptionMenu"]["setOpenerRef"](oMenuButtonRef);
		this["oOptionMenu"]["setOpenerId"](this["sId"]);
		this["oOptionMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
		this["oOptionMenu"]["setOffsetTop"](-1);
		this["oOptionMenu"]["setOffsetLeft"](-1);
		this["oOptionMenu"]["attachEvent"](this["oOptionMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
	}
	if (this["bOptionMenuIsOpened"]) {
		this["oOptionMenu"]["close"]();
	} else {
		this["oOptionMenu"]["open"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["toggleMenu"] = 0; };

UCF_PatternContainerSequence["prototype"]["toggleItemMenu"] = function(oSource) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["toggleItemMenu"]++; }; 
	if (!this["oItemMenu"]) {
		//create the popupmenu
		var sMenuId = oSource["getAttribute"]("menuid");
		if (!sMenuId) return;
		this["oItemMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](sMenuId);
		this["oItemMenu"]["setOpenerRef"](oSource);
		this["oItemMenu"]["setOpenerId"](this["sId"]);
		this["oItemMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
	}

	this["oItemMenu"]["attachEvent"](this["oItemMenu"]["E_EVENTS"]["Select"], this, "onMenuItemSelect");
	this["oItemMenu"]["attachEvent"](this["oItemMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
	this["oItemMenu"]["bFirstVisibleItemIndex"] = 0;

	if (this["oItemMenu"]["bOpened"]) {
		this["oItemMenu"]["close"]();
	} else {

		this["oItemMenu"]["open"]();

		var oMenuItems = this["oItemMenu"]["aItems"];
		for (var i = 0; i < oMenuItems["length"]; i++) {
			if (oMenuItems[i]["bChecked"] && i !== this["iCurrentIndex"]) oMenuItems[i]["setChecked"](false);
		}
		this["oItemMenu"]["aItems"][this["iSelectedIndex"]]["setChecked"](true);
		this["bMenuOpened"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["toggleItemMenu"] = 0; };

/**
 * Handle MenuItemSelect event
 *
 * @param {UCF_Event} oEvent
 */
UCF_PatternContainerSequence["prototype"]["onMenuItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onMenuItemSelect"]++; }; 
	var sItemId = oEvent["oGetParam"]("sItemId");
	if (sItemId) {
		//find the index of the item in the menu
		var aMenuItems = this["oItemMenu"]["aItems"];

		for (var i = 0; i < aMenuItems["length"]; i++) {
			var oItem = aMenuItems[i];
			if (oItem["sId"] === sItemId && i !== this["iSelectedIndex"]) {
				this["fireItemSelect"](this["sId"], this["aItems"][i]["sId"]);
				return;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onMenuItemSelect"] = 0; };

/**
 * Handles the onMenuClose event
 *
 * @param {UCF_Event} oEvent
 */
UCF_PatternContainerSequence["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onMenuClose"]++; }; 
	var oMenuButton = UCF_DomUtil["$"](this["sId"] + '-menu');
	UCF_DomUtil["focusDomElement"](oMenuButton);
	this["oItemMenu"]["detachEvent"](this["oItemMenu"]["E_EVENTS"]["Close"], this);
	this["oItemMenu"]["detachEvent"](this["oItemMenu"]["E_EVENTS"]["Select"], this, "onMenuItemSelect");
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onMenuClose"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerSequence["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerSequence["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onlsskipback"] = 0; };

/**
 * Scrolls the tabs to the next page
 */
UCF_PatternContainerSequence["prototype"]["nextPage"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["nextPage"]++; }; 
	this["iFirstVisibleItemIndex"] = this["iFirstVisibleItemIndex"] + this["iMaxVisibleItems"];
	if (this["iFirstVisibleItemIndex"] > this["aItems"]["length"] - this["iMaxVisibleItems"]) {
		this["iFirstVisibleItemIndex"] = this["aItems"]["length"] - this["iMaxVisibleItems"];
	}
	this["applyItemVisibility"]();
	this["updateScrollButtons"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["nextPage"] = 0; };

/**
 * Scrolls the tabs to the previous page
 */
UCF_PatternContainerSequence["prototype"]["previousPage"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["previousPage"]++; }; 
	this["iFirstVisibleItemIndex"] = this["iFirstVisibleItemIndex"] - this["iMaxVisibleItems"];
	if (this["iFirstVisibleItemIndex"] < 0) {
		this["iFirstVisibleItemIndex"] = 0;
	}
	this["applyItemVisibility"]();
	this["updateScrollButtons"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["previousPage"] = 0; };

/**
 * Scrolls to the first page
 */
UCF_PatternContainerSequence["prototype"]["firstPage"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["firstPage"]++; }; 
	this["iFirstVisibleItemIndex"] = 0;
	this["applyItemVisibility"]();
	this["updateScrollButtons"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["firstPage"] = 0; };
/**
 * Scrolls to the last page
 */
UCF_PatternContainerSequence["prototype"]["lastPage"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["lastPage"]++; }; 
	this["iFirstVisibleItemIndex"] = this["aItems"]["length"] - this["iMaxVisibleItems"];
	this["applyItemVisibility"]();
	this["updateScrollButtons"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["lastPage"] = 0; };

/**
 * Applies the visiblity of items
 *
 * @private
 */
UCF_PatternContainerSequence["prototype"]["applyItemVisibility"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["applyItemVisibility"]++; }; 
	var oPreviousCell = UCF_DomUtil["$"](this["sId"] + "-p"),
		oNextCell = UCF_DomUtil["$"](this["sId"] + "-n"),
		oConnectorPrevious = UCF_DomUtil["$"](this["sId"] + "-p-c"),
		oConnectorNext = UCF_DomUtil["$"](this["sId"] + "-n-c");
	if (this["iFirstVisibleItemIndex"] > 0) {
		oPreviousCell["style"]["display"] = "";

		if (oConnectorPrevious) {
			oConnectorPrevious["style"]["display"] = "";
		}
		if (this["aItems"][this["iFirstVisibleItemIndex"]]["bSelected"]) {
			oPreviousCell["className"] = "urPcSeqFirstAngOnPrevOn";
		} else {
			oPreviousCell["className"] = "urPcSeqFirstAngOffPrevOn";
		}
	} else {
		oPreviousCell["style"]["display"] = "none";
		if (oConnectorPrevious) {
			oConnectorPrevious["style"]["display"] = "none";
		}
	}
	if (this["iFirstVisibleItemIndex"] + this["iMaxVisibleItems"] < this["aItems"]["length"]) {
		oNextCell["style"]["display"] = "";
		if (oConnectorNext) {
			oConnectorNext["style"]["display"] = "";
		}
		if (this["aItems"][this["iFirstVisibleItemIndex"] + this["iMaxVisibleItems"] - 1]["bSelected"]) {
			oNextCell["className"] = "urPcSeqLastOnNextOn";
		} else {
			oNextCell["className"] = "urPcSeqLastOffNextOn";
		}
	} else {
		oNextCell["style"]["display"] = "none";
		if (oConnectorNext) {
			oConnectorNext["style"]["display"] = "none";
		}
	}

	for (var iItemCount = 0; iItemCount < this["aItems"]["length"]; iItemCount++) {
		var bIsVisible = iItemCount >= this["iFirstVisibleItemIndex"]
			&& iItemCount < this["iFirstVisibleItemIndex"] + this["iMaxVisibleItems"];
		this["aItems"][iItemCount]["bFirstVisibleItem"] = (this["iFirstVisibleItemIndex"] === iItemCount);
		if (iItemCount > 0) this["aItems"][iItemCount]["bPreviousSelected"] = this["aItems"][iItemCount - 1]["bSelected"];
		this["aItems"][iItemCount]["bLastVisibleItem"] = (this["iFirstVisibleItemIndex"] + this["iMaxVisibleItems"] - 1 === iItemCount);
		this["aItems"][iItemCount]["bLastItem"] = (iItemCount === this["aItems"]["length"] - 1);
		this["aItems"][iItemCount]["setVisible"](bIsVisible);
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["applyItemVisibility"] = 0; };
/**
 * Handles the lstabnext event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerSequence["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onlstabnext"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerSequence.js(396): onlstabnext"); };
	var oSource = oBrowserEvent["oGetSource"](),
		oSelectedTabId = this["aItems"][this["iSelectedIndex"]]["oDomRef"]["id"],
		oFocusedId = oSelectedTabId + '-txt';
	//
	if (oSource["id"] === oFocusedId) {
		var oContentTab = UCF_DomUtil["$"](oSelectedTabId + '-cnt');
		if (oContentTab) {
			var nextFocus = UCF_DomUtil["oGetFirstFocusableDomRef"](oContentTab, false);
			if (nextFocus)
				UCF_DomUtil["focusDomElement"](nextFocus);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else {
		//if the tab is into a not selected Sequence it should go further to the menu
		this["oItemNavigation"]["bIgnoreFocus"] = true;
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onlstabnext"] = 0; };

UCF_PatternContainerSequence["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerSequence.js(419): onlsfocus"); };

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onlsfocus"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerSequence["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerSequence.js(432): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSource = oBrowserEvent["oGetSource"](),
		oSourceControl = oBrowserEvent["oGetSourceControl"]();
	oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);

	if (oSource === this["oDomRef"]) {
		oAccessibilityHelper["setControlType"]("PCSEQ");
		oAccessibilityHelper["addTutor"]("SKIP");
	} else if (oSource["id"] === this["sId"] + "-menu") {
		oAccessibilityHelper["setControlType"]("PCTIT_MNU");
		oAccessibilityHelper["addTutor"]("PCTIT_MNU_TUT");
	} else if (oSource["getAttribute"]("tp") === "END") {
		oAccessibilityHelper["setControlType"]("PCSEQ_END");
	} else if (UCF_JsUtil["bInstanceOf"](oSourceControl, "UCF_PatternContainerSequenceItem")) {
		oAccessibilityHelper["setControlType"]("PCSEQ");
		oAccessibilityHelper["setItemIndex"](oSourceControl["iIndex"] + 1);
		oAccessibilityHelper["setItemCount"](this["aItems"]["length"]);
		oAccessibilityHelper["setText"](oSourceControl["sTitle"]);
		oAccessibilityHelper["setEnabled"](oSourceControl["bEnabled"]);

		if (oSourceControl["iIndex"] === this["iSelectedIndex"]) {
			oAccessibilityHelper["setSelected"](true);
			oAccessibilityHelper["addTutor"]("ENTERTAB");
		} else {
			oAccessibilityHelper["addEnabledTutor"]("SELECT_TUT", oSourceControl["bEnabled"]);
		}

		oAccessibilityHelper["addTutor"]("LRNAV_TUT");
		oAccessibilityHelper["addTutor"]("SKIP");
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 */
UCF_PatternContainerSequence["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["destroy"]++; }; 

	this["bScrollingNeeded"] = null;
	this["iPageSize"] = null;
	this["iFirstVisibleItemIndex"] = null;
	this["oOptionMenu"] = null;
	this["oItemMenu"] = null;

	if (this["oItemNavigation"]) {
		this["oItemNavigation"]["destroy"]();
		this["oItemNavigation"] = null;
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PatternContainerSequence["prototype"]["aAttributeNames"] = ["bTitleSelected","bHasOptionMenu","sOptionMenuId","bCollapsed","iMaxVisibleItems","iSelectedIndex","bScrollable","sAccessibilityDescription","sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerSequence["prototype"]["aEventNames"] = ["MenuAccess","ItemSelect","TitleSelect","Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerSequence["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerSequence["prototype"]["bTitleSelected"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerSequence["prototype"]["bHasOptionMenu"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerSequence["prototype"]["sOptionMenuId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerSequence["prototype"]["bCollapsed"] = false;

/**
 * @private
 * @type {number}
 */
UCF_PatternContainerSequence["prototype"]["iMaxVisibleItems"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_PatternContainerSequence["prototype"]["iSelectedIndex"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerSequence["prototype"]["bScrollable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerSequence["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_PatternContainerSequence["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerSequence["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PatternContainerSequence["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["setDefaultValues"]++; }; 
	this["bTitleSelected"] = false;
	this["bHasOptionMenu"] = false;
	this["sOptionMenuId"] = '';
	this["bCollapsed"] = false;
	this["iMaxVisibleItems"] = 0;
	this["iSelectedIndex"] = 0;
	this["bScrollable"] = false;
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("TitleSelected", false, true);
		this["setClientProperty"]("HasOptionMenu", false, true);
		this["setClientProperty"]("OptionMenuId", '', true);
		this["setClientProperty"]("Collapsed", false, true);
		this["setClientProperty"]("MaxVisibleItems", 0, true);
		this["setClientProperty"]("SelectedIndex", 0, true);
		this["setClientProperty"]("Scrollable", false, true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires PatternContainerSequence::MenuAccess
 * @deprecated
 */
UCF_PatternContainerSequence["prototype"]["fireMenuAccess"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "PatternContainerSequence.js(606): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PatternContainerSequence.js(607): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PatternContainerSequence.js(608): fireMenuAccess"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("PatternContainerSequence", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["fireMenuAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sItemId Id of the newly selected item
 * @fires PatternContainerSequence::ItemSelect
 * @deprecated
 */
UCF_PatternContainerSequence["prototype"]["fireItemSelect"] = function(sId, sItemId) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["fireItemSelect"]++; }; 
	/** @type {{Id: string, ItemId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "PatternContainerSequence.js(629): fireItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PatternContainerSequence.js(630): fireItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PatternContainerSequence.js(631): fireItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "PatternContainerSequence.js(632): fireItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "PatternContainerSequence.js(633): fireItemSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	this["fireSemanticEvent"]("PatternContainerSequence", "ItemSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["fireItemSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires PatternContainerSequence::TitleSelect
 * @deprecated
 */
UCF_PatternContainerSequence["prototype"]["fireTitleSelect"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["fireTitleSelect"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "PatternContainerSequence.js(658): fireTitleSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PatternContainerSequence.js(659): fireTitleSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PatternContainerSequence.js(660): fireTitleSelect"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("PatternContainerSequence", "TitleSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["fireTitleSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sFirstVisibleItemId Id of the first visible item after the user scrolled
 * @fires PatternContainerSequence::Scroll
 * @deprecated
 */
UCF_PatternContainerSequence["prototype"]["fireScroll"] = function(sId, sFirstVisibleItemId) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, FirstVisibleItemId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "PatternContainerSequence.js(681): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PatternContainerSequence.js(682): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PatternContainerSequence.js(683): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFirstVisibleItemId != null, "sFirstVisibleItemId != null", "PatternContainerSequence.js(684): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFirstVisibleItemId) == "string", "typeof(sFirstVisibleItemId) == \"string\"", "PatternContainerSequence.js(685): fireScroll"); };
	mParams = {
		"Id": sId,
		"FirstVisibleItemId": sFirstVisibleItemId
	};
	
	if (sFirstVisibleItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sFirstVisibleItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "FirstVisibleItemId");
			}
		}
	this["fireSemanticEvent"]("PatternContainerSequence", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequence["_"]["fireScroll"] = 0; };

};
sap["ls"]["preload"]["UCF_PatternContainerSequenceItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * A pattern container tab.
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PatternContainerSequenceItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PatternContainerSequenceItem["_"]["UCF_PatternContainerSequenceItem"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PatternContainerSequenceItem.js(22): UCF_PatternContainerSequenceItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PatternContainerSequenceItem.js(23): UCF_PatternContainerSequenceItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PatternContainerSequenceItem.js(24): UCF_PatternContainerSequenceItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	this["oFocusDomRef"] = this["oDomRef"]["firstChild"];

};window["UCF_PatternContainerSequenceItem"] = UCF_PatternContainerSequenceItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PatternContainerSequenceItem"); UCF_PatternContainerSequenceItem["_"] = {UCF_PatternContainerSequenceItem: 0}; }; ;
UCF_PatternContainerSequenceItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PatternContainerSequenceItem.prototype["sClassName"] = "UCF_PatternContainerSequenceItem";

UCF_PatternContainerSequenceItem["prototype"]["bGetVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequenceItem["_"]["bGetVisible"]++; }; 
	return this["oDomRef"]["style"]["display"] !== "none";
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequenceItem["_"]["bGetVisible"] = 0; };

/**
 * Sets the items visiblity
 * @param {boolean} bVisible
 */
UCF_PatternContainerSequenceItem["prototype"]["setVisible"] = function(bVisible) {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequenceItem["_"]["setVisible"]++; }; 
	var oContentConnector = UCF_DomUtil["$"](this["sId"] + "-c"),
		oContentConnectorA = UCF_DomUtil["$"](this["sId"] + "-ca"),
		oContentConnectorN = UCF_DomUtil["$"](this["sId"] + "-cn"),
		oDomRef = this["oDomRef"],
		oDomRefA = UCF_DomUtil["$"](this["sId"] + "-a"),
		oDomRefN = UCF_DomUtil["$"](this["sId"] + "-n");
	if (bVisible) {
		oDomRef["style"]["display"] = "";
		UCF_DomUtil["removeClass"](oDomRef, 'lsControl--invisible');
		oDomRefN["style"]["display"] = "";
		UCF_DomUtil["removeClass"](oDomRefN, 'lsControl--invisible');
		if (oContentConnector) {
			oContentConnector["style"]["display"] = "";
			UCF_DomUtil["removeClass"](oContentConnector, 'lsControl--invisible');
		}
		if (oContentConnectorN) {
			oContentConnectorN["style"]["display"] = "";
			UCF_DomUtil["removeClass"](oContentConnectorN, 'lsControl--invisible');
		}

		if (this["bFirstVisibleItem"]) {
			oDomRefA["style"]["display"] = "none";
			if (oContentConnectorA) oContentConnectorA["style"]["display"] = "none";
		} else {
			oDomRefA["style"]["display"] = "";
			UCF_DomUtil["removeClass"](oDomRefA, 'lsControl--invisible');
			if (oContentConnectorA) {
				oContentConnectorA["style"]["display"] = "";
				UCF_DomUtil["removeClass"](oContentConnectorA, 'lsControl--invisible');
			}
		}
	} else {
		if (oContentConnector) {
			oContentConnector["style"]["display"] = "none";
			oContentConnectorN["style"]["display"] = "none";
			oContentConnectorA["style"]["display"] = "none";
		}
		oDomRef["style"]["display"] = "none";
		oDomRefA["style"]["display"] = "none";
		oDomRefN["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequenceItem["_"]["setVisible"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PatternContainerSequenceItem["prototype"]["aAttributeNames"] = ["sTitle","bRequired","sStatus","sTooltipStepNumber","sTooltipTitle","sTooltipStatus","bEnabled","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerSequenceItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerSequenceItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerSequenceItem["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerSequenceItem["prototype"]["bRequired"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.PatternContainerSequenceStatus}
 */
UCF_PatternContainerSequenceItem["prototype"]["sStatus"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerSequenceItem["prototype"]["sTooltipStepNumber"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerSequenceItem["prototype"]["sTooltipTitle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerSequenceItem["prototype"]["sTooltipStatus"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerSequenceItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerSequenceItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PatternContainerSequenceItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerSequenceItem["_"]["setDefaultValues"]++; }; 
	this["sTitle"] = '';
	this["bRequired"] = false;
	this["sStatus"] = "NONE";
	this["sTooltipStepNumber"] = '';
	this["sTooltipTitle"] = '';
	this["sTooltipStatus"] = '';
	this["bEnabled"] = true;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("Required", false, true);
		this["setClientProperty"]("Status", "NONE", true);
		this["setClientProperty"]("TooltipStepNumber", '', true);
		this["setClientProperty"]("TooltipTitle", '', true);
		this["setClientProperty"]("TooltipStatus", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerSequenceItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PatternContainerTab"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>

/**
 * A pattern container tab.
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PatternContainerTab(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["UCF_PatternContainerTab"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PatternContainerTab.js(37): UCF_PatternContainerTab"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PatternContainerTab.js(38): UCF_PatternContainerTab"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PatternContainerTab.js(39): UCF_PatternContainerTab"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_PatternContainerTab"] = UCF_PatternContainerTab; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PatternContainerTab"); UCF_PatternContainerTab["_"] = {UCF_PatternContainerTab: 0}; }; ;
UCF_PatternContainerTab["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PatternContainerTab.prototype["sClassName"] = "UCF_PatternContainerTab";

/**
 * Initializes the PatternContainerTab
 */
UCF_PatternContainerTab["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["initialize"]++; }; 

	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]);
	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Select"], this, "onItemSelect");

	this["createItems"]();
	this["bScrollingNeeded"] = this["aItems"]["length"] > this["iMaxVisibleItems"];
	this["iPageSize"] = Math["floor"](this["aItems"]["length"] / this["iMaxVisibleItems"]);
	this["iFirstVisibleItemIndex"] = Math["floor"](this["iSelectedIndex"] / this["iMaxVisibleItems"]) * this["iMaxVisibleItems"];

	this["updateScrollButtons"]();

	this["oItemNavigation"]["setFocusedIndex"](this["oItemNavigation"]["iFocusedIndex"]);
	UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
	if (this["aItems"]["length"] > 0) {

		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
		this["oItemNavigation"]["oItemContainer"] = this["oDomRef"]["firstChild"]["firstChild"];
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["initialize"] = 0; };

/**
 * Updated the enabled and disabled status of the scrolling buttons depending on the visiblity of the tabs
 */
UCF_PatternContainerTab["prototype"]["updateScrollButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["updateScrollButtons"]++; }; 
	if (!this["bScrollable"]) return;

	var oPagingRef = UCF_DomUtil["$"](this["sId"] + "-pag");

	if (this["bScrollingNeeded"]) {
		UCF_DomUtil["removeClass"](oPagingRef, 'lsControl--hidden');
		oPagingRef["style"]["visibility"] = "visible";
	} else {
		oPagingRef["style"]["visibility"] = "hidden";
		return;
	}

	var aButtons = oPagingRef["childNodes"];

	if (this["iFirstVisibleItemIndex"] > 0) {
		aButtons[0]["className"] = "lsTbsPageStart";
		aButtons[1]["className"] = "lsTbsPagePrev";
	} else {
		aButtons[0]["className"] = "lsTbsPageStartDsbl";
		aButtons[1]["className"] = "lsTbsPagePrevDsbl";
	}

	if (this["iFirstVisibleItemIndex"] + this["iMaxVisibleItems"] < this["aItems"]["length"]) {
		aButtons[2]["className"] = "lsTbsPageNext";
		aButtons[3]["className"] = "lsTbsPageEnd";
	} else {
		aButtons[2]["className"] = "lsTbsPageNextDsbl";
		aButtons[3]["className"] = "lsTbsPageEndDsbl";
	}
	this["oItemNavigation"]["aItems"] = [];
	this["createItems"]();
	this["oItemNavigation"]["setFocusedIndex"](this["oItemNavigation"]["iFocusedIndex"]);

};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["updateScrollButtons"] = 0; };
/**
 * Creates PatternContainerTabItems

 */
UCF_PatternContainerTab["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["createItems"]++; }; 

	this["aItems"] = [];
	var aItems = this["aItems"],
		iItemsLength = this["oDomRef"]["getAttribute"]("ic"),
		aItemIds = this["oDomRef"]["getAttribute"]("itemids")["split"](",");
	for (var iItemCount = 0; iItemCount < iItemsLength; iItemCount++) {
		var oDomItem = UCF_DomUtil["$"](aItemIds[iItemCount]),
			oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oDomItem, true);
		oItem["iIndex"] = iItemCount;
		oItem["bSelected"] = oItem["iIndex"] === this["iSelectedIndex"];
		aItems["push"](oItem);
		if ((oItem["bGetVisible"]() && oItem["bEnabled"]) || window["UCF_System"]["bIs508"]) {
			this["oItemNavigation"]["addItem"](oItem, oItem["bSelected"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["createItems"] = 0; };

/**
 * Handle hotkey events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PatternContainerTab["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onlshotkey"]++; }; 

	var oSelectedItem = this["aItems"][this["iSelectedIndex"]];

	if (oSelectedItem["sHotkeysId"] === '') return;

	var oHotkeys = this["oGetControlById"](oSelectedItem["sHotkeysId"]),
		oHotkey = null;
	if (oHotkeys == null) return;

	oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onlshotkey"] = 0; };

UCF_PatternContainerTab["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]("UCF_Hotkeys")["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onkeypress"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerTab["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerTab.js(173): onclick"); };
	var oSource = oBrowserEvent["oGetSource"]();
	var sSourceId = oSource["getAttribute"]("id");
	//toggle the tray if clicked on the icon
	if (sSourceId === this["sId"] + "-menu") {
		this["toggleMenu"]();
		return;
	} else if (sSourceId === this["sId"] + "-itemmenu") {
		this["toggleItemMenu"](oSource);
		return;
	} else if (sSourceId === this["sId"] + "-start") {
		this["firstPage"]();
		return;
	} else if (sSourceId === this["sId"] + "-end") {
		this["lastPage"]();
		return;
	} else if (sSourceId === this["sId"] + "-prev") {
		this["previousPage"]();
		return;
	} else if (sSourceId === this["sId"] + "-next") {
		this["nextPage"]();
		return;
	}

};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onclick"] = 0; };

/**
 * Handle ItemSelect event
 *
 * @param {UCF_Event} oEvent
 */

UCF_PatternContainerTab["prototype"]["onItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onItemSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "PatternContainerTab.js(206): onItemSelect"); };
	var oItem = oEvent["oGetParam"]("oItem");
	if (oItem["bEnabled"] && oItem["iIndex"] !== this["iSelectedIndex"]) {
		this["fireTabSelect"](this["sId"], oItem["sId"]);
	}

};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onItemSelect"] = 0; };

/**
 * Opens the pattern containers option menu
 */
UCF_PatternContainerTab["prototype"]["toggleMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["toggleMenu"]++; }; 

	if (!this["sOptionMenuId"]) return;

	var oMenuButtonRef = UCF_DomUtil["$"](this["sId"] + "-menu"); //the menu buttons dom ref

	if (!oMenuButtonRef) return;
	if (!this["oOptionMenu"]) {

		this["fireMenuAccess"](this["sId"]);

		this["oOptionMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](this["sOptionMenuId"], true);

		if (!this["oOptionMenu"]) return;

		this["oOptionMenu"]["setOpenerRef"](oMenuButtonRef);
		this["oOptionMenu"]["setOpenerId"](this["sId"]);
		this["oOptionMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
		this["oOptionMenu"]["setOffsetTop"](-1);
		this["oOptionMenu"]["setOffsetLeft"](-1);
		this["oOptionMenu"]["attachEvent"](this["oOptionMenu"]["E_EVENTS"]["Close"], this, "onOptionClose");
	}
	if (this["bOptionMenuIsOpened"]) {
		this["oOptionMenu"]["close"]();
	} else {
		this["oOptionMenu"]["open"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["toggleMenu"] = 0; };

UCF_PatternContainerTab["prototype"]["toggleItemMenu"] = function(oSource) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["toggleItemMenu"]++; }; 

	if (!this["oItemMenu"]) {

		//create the popupmenu
		var sMenuId = oSource["getAttribute"]("menuid");
		if (!sMenuId) return;
		this["oItemMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](sMenuId);
		this["oItemMenu"]["setOpenerRef"](oSource);
		this["oItemMenu"]["setOpenerId"](this["sId"]);
		this["oItemMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
	}

	this["oItemMenu"]["attachEvent"](this["oItemMenu"]["E_EVENTS"]["Select"], this, "onMenuItemSelect");
	this["oItemMenu"]["attachEvent"](this["oItemMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
	this["oItemMenu"]["bFirstVisibleItemIndex"] = 0;

	if (this["oItemMenu"]["bOpened"]) {
		this["oItemMenu"]["close"]();
	} else {

		this["oItemMenu"]["open"]();

		var oMenuItems = this["oItemMenu"]["aItems"];
		for (var i = 0; i < oMenuItems["length"]; i++) {
			if (oMenuItems[i]["bChecked"] && i !== this["iCurrentIndex"]) oMenuItems[i]["setChecked"](false);
		}
		this["oItemMenu"]["aItems"][this["iSelectedIndex"]]["setChecked"](true);
		this["bMenuOpened"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["toggleItemMenu"] = 0; };

/**
 * Handle MenuItemSelect event
 *
 * @param {UCF_Event} oEvent
 */
UCF_PatternContainerTab["prototype"]["onMenuItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onMenuItemSelect"]++; }; 

	var sItemId = oEvent["oGetParam"]("sItemId");
	if (sItemId) {
		//find the index of the item in the menu
		var aMenuItems = this["oItemMenu"]["aItems"];

		for (var i = 0; i < aMenuItems["length"]; i++) {
			var oItem = aMenuItems[i];
			if (oItem["sId"] === sItemId && i !== this["iSelectedIndex"]) {
				this["fireTabSelect"](this["sId"], this["aItems"][i]["sId"]);
				return;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onMenuItemSelect"] = 0; };

/**
 * Handles the onMenuClose event
 *
 * @param {UCF_Event} oEvent
 */
UCF_PatternContainerTab["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onMenuClose"]++; }; 

	var oMenuButton = UCF_DomUtil["$"](this["sId"] + '-menu');
	UCF_DomUtil["focusDomElement"](oMenuButton);
	this["oItemMenu"]["detachEvent"](this["oItemMenu"]["E_EVENTS"]["Close"], this);
	this["oItemMenu"]["detachEvent"](this["oItemMenu"]["E_EVENTS"]["Select"], this, "onMenuItemSelect");
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onMenuClose"] = 0; };

UCF_PatternContainerTab["prototype"]["onOptionClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onOptionClose"]++; }; 

	var oMenuButton = UCF_DomUtil["$"](this["sId"] + '-menu');
	UCF_DomUtil["focusDomElement"](oMenuButton);
	this["oOptionMenu"]["detachEvent"](this["oOptionMenu"]["E_EVENTS"]["Close"], this);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onOptionClose"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerTab["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onlsskipforward"] = 0; };

/**
 * Handles the lstabnext event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerTab["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onlstabnext"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerTab.js(340): onlstabnext"); };
	var oSource = oBrowserEvent["oGetSource"](),
		oSelectedTabId = this["aItems"][this["iSelectedIndex"]]["oDomRef"]["id"],
		oFocusedId = oSelectedTabId + '-focus';

	if (oSource["id"] === oFocusedId) {
		var oContentTab = UCF_DomUtil["$"](oSelectedTabId + '-cnt');
		if (oContentTab) {
			var nextFocus = UCF_DomUtil["oGetFirstFocusableDomRef"](oContentTab, false);
			if (nextFocus)
				UCF_DomUtil["focusDomElement"](nextFocus);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else {
		//if the tab is into a not selected Sequence it should go further to the menu
		this["oItemNavigation"]["bIgnoreFocus"] = true;
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onlstabnext"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerTab["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onlsskipback"] = 0; };

/**
 * Scrolls the tabs to the next page
 */
UCF_PatternContainerTab["prototype"]["nextPage"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["nextPage"]++; }; 
	this["iFirstVisibleItemIndex"] = this["iFirstVisibleItemIndex"] + this["iMaxVisibleItems"];
	if (this["iFirstVisibleItemIndex"] > this["aItems"]["length"] - this["iMaxVisibleItems"]) {
		this["iFirstVisibleItemIndex"] = this["aItems"]["length"] - this["iMaxVisibleItems"];
	}
	this["applyItemVisibility"]();
	this["updateScrollButtons"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["nextPage"] = 0; };

/**
 * Scrolls the tabs to the previous page
 */
UCF_PatternContainerTab["prototype"]["previousPage"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["previousPage"]++; }; 
	this["iFirstVisibleItemIndex"] = this["iFirstVisibleItemIndex"] - this["iMaxVisibleItems"];
	if (this["iFirstVisibleItemIndex"] < 0) {
		this["iFirstVisibleItemIndex"] = 0;
	}
	this["applyItemVisibility"]();
	this["updateScrollButtons"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["previousPage"] = 0; };

/**
 * Scrolls to the first page
 */
UCF_PatternContainerTab["prototype"]["firstPage"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["firstPage"]++; }; 
	this["iFirstVisibleItemIndex"] = 0;
	this["applyItemVisibility"]();
	this["updateScrollButtons"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["firstPage"] = 0; };
/**
 * Scrolls to the last page
 */
UCF_PatternContainerTab["prototype"]["lastPage"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["lastPage"]++; }; 
	this["iFirstVisibleItemIndex"] = this["aItems"]["length"] - this["iMaxVisibleItems"];
	this["applyItemVisibility"]();
	this["updateScrollButtons"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["lastPage"] = 0; };

/**
 * Applies the visiblity of items
 *
 * @private
 */
UCF_PatternContainerTab["prototype"]["applyItemVisibility"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["applyItemVisibility"]++; }; 
	for (var iItemCount = 0; iItemCount < this["aItems"]["length"]; iItemCount++) {
		var bIsVisible = iItemCount >= this["iFirstVisibleItemIndex"]
			&& iItemCount < this["iFirstVisibleItemIndex"] + this["iMaxVisibleItems"];
		this["aItems"][iItemCount]["bFirstVisibleItem"] = (this["iFirstVisibleItemIndex"] === iItemCount);
		if (iItemCount > 0) this["aItems"][iItemCount]["bPreviousSelected"] = this["aItems"][iItemCount - 1]["bSelected"];
		this["aItems"][iItemCount]["bLastVisibleItem"] = (this["iFirstVisibleItemIndex"] + this["iMaxVisibleItems"] - 1 === iItemCount);
		this["aItems"][iItemCount]["bLastItem"] = (iItemCount === this["aItems"]["length"] - 1);
		this["aItems"][iItemCount]["setVisible"](bIsVisible);
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["applyItemVisibility"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerTab["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerTab.js(439): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSource = oBrowserEvent["oGetSource"](),
		oSourceControl = oBrowserEvent["oGetSourceControl"]();

	if (oSource === this["oDomRef"]) {
		oAccessibilityHelper["setControlType"]("PCTAB");
		oAccessibilityHelper["addTutor"]("SKIP");
	} else if (oSource["id"] === this["sId"] + "-menu") {
		oAccessibilityHelper["setControlType"]("PCTIT_MNU");
		oAccessibilityHelper["addTutor"]("PCTIT_MNU_TUT");
	} else if (oSource["getAttribute"]("tp") === "END") {
		oAccessibilityHelper["setControlType"]("PCTAB_END");
	} else if (UCF_JsUtil["bInstanceOf"](oSourceControl, "UCF_PatternContainerTabItem")) {
		oAccessibilityHelper["setControlType"]("PCTAB");
		oAccessibilityHelper["setItemIndex"](oSourceControl["iItemIndex"] + 1);
		oAccessibilityHelper["setItemCount"](this["aItems"]["length"]);
		oAccessibilityHelper["setText"](oSourceControl["sTitle"]);
		oAccessibilityHelper["setEnabled"](oSourceControl["bEnabled"]);

		if (oSourceControl["iItemIndex"] === this["iSelectedIndex"]) {
			oAccessibilityHelper["setSelected"](true);
			oAccessibilityHelper["addTutor"]("ENTERTAB");
		} else {
			oAccessibilityHelper["addEnabledTutor"]("TS_ITM_NSEL_TUT", oSourceControl["bEnabled"]);
		}
		oAccessibilityHelper["addTutor"]("LRNAV_TUT");
		oAccessibilityHelper["addTutor"]("SKIP");
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 */
UCF_PatternContainerTab["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["destroy"]++; }; 

	this["bScrollingNeeded"] = null;
	this["iPageSize"] = null;
	this["iFirstVisibleItemIndex"] = null;
	this["oOptionMenu"] = null;
	this["oItemMenu"] = null;

	if (this["oItemNavigation"]) {
		this["oItemNavigation"]["destroy"]();
		this["oItemNavigation"] = null;
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PatternContainerTab["prototype"]["aAttributeNames"] = ["bHasOptionMenu","sOptionMenuId","bCollapsed","iMaxVisibleItems","iSelectedIndex","bScrollable","bHasContentConnector","sVisibility","sTooltip","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerTab["prototype"]["aEventNames"] = ["MenuAccess","TabSelect","Scroll","Hotkey"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerTab["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerTab["prototype"]["bHasOptionMenu"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerTab["prototype"]["sOptionMenuId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerTab["prototype"]["bCollapsed"] = false;

/**
 * @private
 * @type {number}
 */
UCF_PatternContainerTab["prototype"]["iMaxVisibleItems"] = 7;

/**
 * @private
 * @type {number}
 */
UCF_PatternContainerTab["prototype"]["iSelectedIndex"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerTab["prototype"]["bScrollable"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerTab["prototype"]["bHasContentConnector"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_PatternContainerTab["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerTab["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerTab["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PatternContainerTab["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["setDefaultValues"]++; }; 
	this["bHasOptionMenu"] = false;
	this["sOptionMenuId"] = '';
	this["bCollapsed"] = false;
	this["iMaxVisibleItems"] = 7;
	this["iSelectedIndex"] = 0;
	this["bScrollable"] = false;
	this["bHasContentConnector"] = false;
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("HasOptionMenu", false, true);
		this["setClientProperty"]("OptionMenuId", '', true);
		this["setClientProperty"]("Collapsed", false, true);
		this["setClientProperty"]("MaxVisibleItems", 7, true);
		this["setClientProperty"]("SelectedIndex", 0, true);
		this["setClientProperty"]("Scrollable", false, true);
		this["setClientProperty"]("HasContentConnector", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires PatternContainerTab::MenuAccess
 * @deprecated
 */
UCF_PatternContainerTab["prototype"]["fireMenuAccess"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "PatternContainerTab.js(611): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PatternContainerTab.js(612): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PatternContainerTab.js(613): fireMenuAccess"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("PatternContainerTab", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["fireMenuAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sItemId Id of the newly selected item
 * @fires PatternContainerTab::TabSelect
 * @deprecated
 */
UCF_PatternContainerTab["prototype"]["fireTabSelect"] = function(sId, sItemId) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["fireTabSelect"]++; }; 
	/** @type {{Id: string, ItemId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "PatternContainerTab.js(634): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PatternContainerTab.js(635): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PatternContainerTab.js(636): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "PatternContainerTab.js(637): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "PatternContainerTab.js(638): fireTabSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	this["fireSemanticEvent"]("PatternContainerTab", "TabSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["fireTabSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sFirstVisibleItemId Id of the first visible item after the user scrolled
 * @fires PatternContainerTab::Scroll
 * @deprecated
 */
UCF_PatternContainerTab["prototype"]["fireScroll"] = function(sId, sFirstVisibleItemId) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, FirstVisibleItemId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "PatternContainerTab.js(666): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PatternContainerTab.js(667): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PatternContainerTab.js(668): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFirstVisibleItemId != null, "sFirstVisibleItemId != null", "PatternContainerTab.js(669): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFirstVisibleItemId) == "string", "typeof(sFirstVisibleItemId) == \"string\"", "PatternContainerTab.js(670): fireScroll"); };
	mParams = {
		"Id": sId,
		"FirstVisibleItemId": sFirstVisibleItemId
	};
	
	if (sFirstVisibleItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sFirstVisibleItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "FirstVisibleItemId");
			}
		}
	this["fireSemanticEvent"]("PatternContainerTab", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sItemId ItemId of the tab item which is currently selected and hotkey is fired
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires PatternContainerTab::Hotkey
 * @deprecated
 */
UCF_PatternContainerTab["prototype"]["fireHotkey"] = function(sId, sItemId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, ItemId: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "PatternContainerTab.js(700): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PatternContainerTab.js(701): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PatternContainerTab.js(702): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "PatternContainerTab.js(703): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "PatternContainerTab.js(704): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "PatternContainerTab.js(705): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "PatternContainerTab.js(706): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "PatternContainerTab.js(707): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "PatternContainerTab.js(708): fireHotkey"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	if (sProviderId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sProviderId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ProviderId");
			}
		}
	this["fireSemanticEvent"]("PatternContainerTab", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTab["_"]["fireHotkey"] = 0; };

};
sap["ls"]["preload"]["UCF_PatternContainerTabItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * A pattern container tab.
 *
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PatternContainerTabItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PatternContainerTabItem["_"]["UCF_PatternContainerTabItem"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PatternContainerTabItem.js(22): UCF_PatternContainerTabItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PatternContainerTabItem.js(23): UCF_PatternContainerTabItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PatternContainerTabItem.js(24): UCF_PatternContainerTabItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	this["oFocusDomRef"] = this["oDomRef"]["firstChild"];
	this["sTitle"] = UCF_DomUtil["sGetInnerText"](oDomRef);

};window["UCF_PatternContainerTabItem"] = UCF_PatternContainerTabItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PatternContainerTabItem"); UCF_PatternContainerTabItem["_"] = {UCF_PatternContainerTabItem: 0}; }; ;
UCF_PatternContainerTabItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PatternContainerTabItem.prototype["sClassName"] = "UCF_PatternContainerTabItem";

UCF_PatternContainerTabItem["prototype"]["bGetVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTabItem["_"]["bGetVisible"]++; }; 
	return this["oDomRef"]["style"]["display"] !== "none";
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTabItem["_"]["bGetVisible"] = 0; };

/**
 * Sets the items visiblity
 * @param {boolean} bVisible
 */
UCF_PatternContainerTabItem["prototype"]["setVisible"] = function(bVisible) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTabItem["_"]["setVisible"]++; }; 
	var oContentConnector = UCF_DomUtil["$"](this["sId"] + "-c");
	var oLastAngle;

	if (bVisible) {
		this["oDomRef"]["style"]["display"] = "";
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsControl--invisible');
		//TODO replace by UCF_DomUtil.oGetPreviousSibling
		this["oDomRef"]["previousSibling"]["style"]["display"] = "";
		UCF_DomUtil["removeClass"](this["oDomRef"]["previousSibling"], 'lsControl--invisible');
		if (this["bFirstVisibleItem"]) {
			this["oDomRef"]["previousSibling"]["style"]["display"] = "none";
			if (oContentConnector) {
				oContentConnector["previousSibling"]["style"]["display"] = "none";
			}
			var sPrev = this["iIndex"] === 0 ? "PrevOff" : "PrevOn",

				//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
				oFirstAngle = this["oDomRef"]["parentNode"]["firstChild"];
			if (this["bSelected"]) {
				oFirstAngle["className"] = "urPcTbsFirstAngOn" + sPrev;
			} else {
				oFirstAngle["className"] = "urPcTbsFirstAngOff" + sPrev;
			}
		} else {
			if (oContentConnector) {
				oContentConnector["previousSibling"]["style"]["display"] = "";
				UCF_DomUtil["removeClass"](oContentConnector["previousSibling"], 'lsControl--invisible');
			}
			this["oDomRef"]["previousSibling"]["style"]["display"] = "";
			UCF_DomUtil["removeClass"](this["oDomRef"]["previousSibling"], 'lsControl--invisible');
		}

		if (this["bLastItem"]) {
			//TODO: replace by UCF_DomUtil.lastChild(this.oDomRef) to avoid problems with text node
			oLastAngle = this["oDomRef"]["parentNode"]["lastChild"]["previousSibling"];
			if (this["bSelected"]) {
				oLastAngle["className"] = "urPcTbsLastOnNextOff";
			} else {
				oLastAngle["className"] = "urPcTbsLastOffNextOff";
			}
		} else if (this["bLastVisibleItem"]) {
			//TODO: replace by UCF_DomUtil.lastChild(this.oDomRef) to avoid problems with text node
			oLastAngle = this["oDomRef"]["parentNode"]["lastChild"]["previousSibling"];
			if (this["bSelected"]) {
				oLastAngle["className"] = "urPcTbsLastOnNextOn";
			} else {
				oLastAngle["className"] = "urPcTbsLastOffNextOn";
			}
		} else {
			if (this["bSelected"]) {
				this["oDomRef"]["previousSibling"]["className"] = "urPcTbsAngOffOn";
			} else if (this["bPreviousSelected"]) {
				this["oDomRef"]["previousSibling"]["className"] = "urPcTbsAngOnOff";
			} else {
				this["oDomRef"]["previousSibling"]["className"] = "urPcTbsAngOffOff";
			}
		}
		if (oContentConnector) {
			oContentConnector["style"]["display"] = "";
			UCF_DomUtil["removeClass"](oContentConnector, 'lsControl--invisible');
			if (this["bSelected"]) {
				oContentConnector["className"] = "urPcConOn";
			} else {
				oContentConnector["className"] = "urPcConOff";
			}
		}
	} else {
		if (oContentConnector) {
			oContentConnector["style"]["display"] = "none";
			oContentConnector["previousSibling"]["style"]["display"] = "none";
		}
		this["oDomRef"]["style"]["display"] = "none";
		this["oDomRef"]["previousSibling"]["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTabItem["_"]["setVisible"] = 0; };

/**
 * Destructor
 */
UCF_PatternContainerTabItem["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTabItem["_"]["destroy"]++; }; 

	this["sTitle"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTabItem["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PatternContainerTabItem["prototype"]["aAttributeNames"] = ["iItemIndex","bEnabled","sHotkeysId","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerTabItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerTabItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_PatternContainerTabItem["prototype"]["iItemIndex"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerTabItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerTabItem["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerTabItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PatternContainerTabItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTabItem["_"]["setDefaultValues"]++; }; 
	this["iItemIndex"] = 0;
	this["bEnabled"] = true;
	this["sHotkeysId"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("ItemIndex", 0, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTabItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PatternContainerTitle"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>

/**
 * A pattern container title.
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PatternContainerTitle(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["UCF_PatternContainerTitle"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "PatternContainerTitle.js(32): UCF_PatternContainerTitle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PatternContainerTitle.js(33): UCF_PatternContainerTitle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PatternContainerTitle.js(34): UCF_PatternContainerTitle"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_PatternContainerTitle"] = UCF_PatternContainerTitle; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PatternContainerTitle"); UCF_PatternContainerTitle["_"] = {UCF_PatternContainerTitle: 0}; }; ;
UCF_PatternContainerTitle["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PatternContainerTitle.prototype["sClassName"] = "UCF_PatternContainerTitle";

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerTitle["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerTitle.js(49): onclick"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var sSourceId = oSource["getAttribute"]("id");
	//toggle the tray if clicked on the icon
	if (sSourceId == this["sId"] + "-menu") {
		this["toggleMenu"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onclick"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerTitle["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onkeydown"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerTitle.js(67): onkeydown"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var sSourceId = oSource["getAttribute"]("id");
	//toggle the tray if clicked on the icon
	if (sSourceId == this["sId"] + "-menu" && oBrowserEvent["iKeyCode"]() == UCF_KeyCodes["SPACE"]) {
		this["toggleMenu"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onkeydown"] = 0; };

/**
 * Handle hotkey events
 *
 * @param {UCF_Event} oEvent
 */
UCF_PatternContainerTitle["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onlshotkey"]++; }; 

	if (this["sHotkeysId"] == '') return;

	var oHotkeys = this["oGetControlById"](this["sHotkeysId"]),
		oHotkey = null;
	if (oHotkeys == null) return;

	oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onlshotkey"] = 0; };

UCF_PatternContainerTitle["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]("UCF_Hotkeys")["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onkeypress"] = 0; };

/**
 * Opens the pattern containers option menu
 */
UCF_PatternContainerTitle["prototype"]["toggleMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["toggleMenu"]++; }; 

	if (!this["sOptionMenuId"]) return;

	var oMenuButtonRef = UCF_DomUtil["$"](this["sId"] + "-menu"); //the menu buttons dom ref

	if (!oMenuButtonRef) return;
	if (!this["oOptionMenu"]) {

		this["fireMenuAccess"](this["sId"]);

		this["oOptionMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](this["sOptionMenuId"], true);

		if (!this["oOptionMenu"]) return;

		this["oOptionMenu"]["setOpenerRef"](oMenuButtonRef);
		this["oOptionMenu"]["setOpenerId"](this["sId"]);
		this["oOptionMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
		this["oOptionMenu"]["setOffsetTop"](-1);
		this["oOptionMenu"]["setOffsetLeft"](-1);
		this["oOptionMenu"]["attachEvent"](this["oOptionMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
	}
	if (this["bOptionMenuIsOpened"]) {
		this["oOptionMenu"]["close"]();
	} else {
		this["oOptionMenu"]["open"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["toggleMenu"] = 0; };

/**
 * Handles the onMenuClose event
 *
 * @param {UCF_Event} oEvent
 */
UCF_PatternContainerTitle["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onMenuClose"]++; }; 

	this["bOptionMenuIsOpened"] = false;
	var oMenuButtonRef = UCF_DomUtil["$"](this["sId"] + "-menu"); //the menu buttons dom ref
	oMenuButtonRef["focus"]();

};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onMenuClose"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerTitle["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerTitle["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onlsskipback"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PatternContainerTitle["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PatternContainerTitle.js(189): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSource = oBrowserEvent["oGetSource"](),
		oSourceControl = oBrowserEvent["oGetSourceControl"]();

	if (oSourceControl != this) return;

	if (oSource == this["oDomRef"]) {
		oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
		oAccessibilityHelper["setText"](this["sTitle"]);
		oAccessibilityHelper["setControlType"]("PCTIT");
		oAccessibilityHelper["addTutor"]("SKIP");
	} else if (oSource["id"] == this["sId"] + "-menu") {
		oAccessibilityHelper["setControlType"]("PCTIT_MNU");
		oAccessibilityHelper["addTutor"]("PCTIT_MNU_TUT");
	} else if (oSource["getAttribute"]("tp") == "END") {
		oAccessibilityHelper["setControlType"]("PCTIT_END");
		oAccessibilityHelper["setText"](this["sTitle"]);

	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 */
UCF_PatternContainerTitle["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["destroy"]++; }; 

	this["oOptionMenu"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PatternContainerTitle["prototype"]["aAttributeNames"] = ["sTitle","bHasOptionMenu","sOptionMenuId","bCollapsed","sVisibility","sTooltip","sHotkeysId","sAccessKey","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerTitle["prototype"]["aEventNames"] = ["MenuAccess","Hotkey"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PatternContainerTitle["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerTitle["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerTitle["prototype"]["bHasOptionMenu"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerTitle["prototype"]["sOptionMenuId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PatternContainerTitle["prototype"]["bCollapsed"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_PatternContainerTitle["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerTitle["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerTitle["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerTitle["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PatternContainerTitle["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PatternContainerTitle["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["setDefaultValues"]++; }; 
	this["sTitle"] = '';
	this["bHasOptionMenu"] = false;
	this["sOptionMenuId"] = '';
	this["bCollapsed"] = false;
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sHotkeysId"] = '';
	this["sAccessKey"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("HasOptionMenu", false, true);
		this["setClientProperty"]("OptionMenuId", '', true);
		this["setClientProperty"]("Collapsed", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires PatternContainerTitle::MenuAccess
 * @deprecated
 */
UCF_PatternContainerTitle["prototype"]["fireMenuAccess"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "PatternContainerTitle.js(335): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PatternContainerTitle.js(336): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PatternContainerTitle.js(337): fireMenuAccess"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("PatternContainerTitle", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["fireMenuAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires PatternContainerTitle::Hotkey
 * @deprecated
 */
UCF_PatternContainerTitle["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PatternContainerTitle.js(359): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PatternContainerTitle.js(360): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PatternContainerTitle.js(361): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "PatternContainerTitle.js(362): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "PatternContainerTitle.js(363): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "PatternContainerTitle.js(364): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "PatternContainerTitle.js(365): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	
	if (sProviderId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sProviderId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ProviderId");
			}
		}
	this["fireSemanticEvent"]("PatternContainerTitle", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PatternContainerTitle["_"]["fireHotkey"] = 0; };

};
sap["ls"]["preload"]["UCF_PersonasFacade"] = function() {/* global _assert, _trace, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global sap, jQuery */

/**
 * PersonasFacade
 *
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef The DOM reference
 * @param {UCF_LS} oLS The LS instance
 */
function UCF_PersonasFacade(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["UCF_PersonasFacade"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === "object", "typeof oDomRef === \"object\"", "PersonasFacade.js(21): UCF_PersonasFacade"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PersonasFacade.js(22): UCF_PersonasFacade"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PersonasFacade.js(23): UCF_PersonasFacade"); };
	if (window["sap"] && window["sap"]["personas"] && window["sap"]["personas"]["core"] && window["sap"]["personas"]["core"]["Facade"]) {
		return;
	}
	if (oDomRef) {
		if (oLS["oGetPageInternal"]())
			oLS["oGetPageInternal"]()["oGetStaticAreaRef"]()["appendChild"](oDomRef);
	}
	UCF_Control["apply"](this, [oDomRef, oLS]);
	this["bKeepAlive"] = true;
	this["oFacade"] = null;
	this["bInitialized"] = false;
	this["bAllLoaded"] = false;
	this["bScriptingActive"] = false;
	this["aScriptQueue"] = [];
	this["bExtensionActive"] = false;
	window["jQuery"] = null;
	this["oConfiguration"] = null;

};window["UCF_PersonasFacade"] = UCF_PersonasFacade; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PersonasFacade"); UCF_PersonasFacade["_"] = {UCF_PersonasFacade: 0}; }; ;
UCF_PersonasFacade["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PersonasFacade.prototype["sClassName"] = "UCF_PersonasFacade";

UCF_PersonasFacade["prototype"]["doKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["doKeepAlive"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["doKeepAlive"] = 0; };
/**
 * Initializes the PersonasFacade
 * @private
 */
UCF_PersonasFacade["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["initialize"]++; }; 
	if (this["bInitialized"]) {
		return;
	}
	this["bInitialized"] = true;

	// It is not feasible for a control to try to control the locking of LS during some async. action, because LS and the WDA framework will control the locking.
	// It is unknown why this was done or what it is needed for.
	// This caused problems with TimeTrigger, which handles the unlock event.
	//this.oLS.lock();

	if (this["oLS"]["oGetPageInternal"]())
		this["oLS"]["oGetPageInternal"]()["addScript"](this["sPersonasSourceRoot"] + this["sPersonasSourceDir"] + 'script/sap/personas/Client.js?' + Date["now"](), undefined, undefined, this, "_initClient");
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["initialize"] = 0; };

/**
 * Calls a method in the facade implementation.
 * @param {string} sName The name of the method to call
 * @param {array|string} sParameters The parameters to pass to the method.
 * @returns {any} The result of the called method or null
 * @public
 */
UCF_PersonasFacade["prototype"]["callMethod"] = function(sName, sParameters) {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["callMethod"]++; }; 
	var aParameters = sParameters;

	if (!this["oFacade"] || typeof this["oFacade"][sName] !== "function") {
		if (!this["bExtensionActive"]) {
			this["aScriptQueue"]["push"]({ "name": sName, "parameters": sParameters });
		}
		return;
	}

	if (typeof aParameters === "string") {
		aParameters = UCF_JsUtil["oJsonParse"](aParameters);
	}

	return this["oFacade"][sName]["apply"](this["oFacade"], aParameters);
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["callMethod"] = 0; };

/**
 * Fire RequestData event to backend
 */
UCF_PersonasFacade["prototype"]["_fireRequestData"] = function(sCommand, sParameters) {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["_fireRequestData"]++; }; 
	this["fireRequestData"](this["sId"], sCommand, sParameters);
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["_fireRequestData"] = 0; };

/**
 * Init the Personas client after it was loaded
 */
UCF_PersonasFacade["prototype"]["_initClient"] = function() {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["_initClient"]++; }; 
	// sap.personas.Client must be available now
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof window["sap"]["personas"]["Client"] === "function", "typeof window.sap.personas.Client === \"function\"", "PersonasFacade.js(103): _initClient"); };

	var oPage = this["oLS"]["oGetPageInternal"]();

	//this.oLS.unlock();
	this["bAllLoaded"] = true;

	// Boost performance a little bit, could be removed as Personas loads UI5 as well
	if (oPage)
		oPage["addScript"](this["sUi5SourceRoot"]);

	// Build configuration
	if (this["sConfigJson"]) {
		try {
			this["oConfiguration"] = UCF_JsUtil["oJsonParse"](this["sConfigJson"]);
		} catch (e) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Error while parsing Personas configuration JSON: " + e["message"], "PersonasFacade.js(119): _initClient"); };
		}
	}
	// Configuration done via JSON has priority, others are done for backward compatibility
	this["oConfiguration"] = this["oConfiguration"] || {};
	this["oConfiguration"]["serviceRoot"] = this["oConfiguration"]["serviceRoot"] || this["sPersonasSourceRoot"];
	this["oConfiguration"]["sourceDir"] = this["oConfiguration"]["sourceDir"] || this["sPersonasSourceDir"];
	this["oConfiguration"]["sourceUI5"] = this["oConfiguration"]["sourceUI5"] || this["sUi5SourceRoot"];

	// Create the Personas client
	var oPersonas = new sap["personas"]["Client"](this["oConfiguration"]);

	// Add Personas DOM nodes to isolated area to avoid lightspeed event handling
	if (oPersonas && typeof oPersonas["root"] === "object") {
		this["oLS"]["addIsolatedArea"](oPersonas["root"]);
		this["oLS"]["addIsolatedArea"](oPersonas["dialogRoot"]);
	}

	// Register the ExtensionFactory that will load framework specific classes afterwards
	oPage["addScript"](this["sPersonasSourceRoot"] + this["sPersonasSourceDir"] + 'script/' + this["sPackageUrl"] + 'ExtensionFactory.js?' + Date["now"](), undefined, undefined, this, '_registerExtension', [oPersonas]);
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["_initClient"] = 0; };

UCF_PersonasFacade["prototype"]["_registerExtension"] = function(oPersonas) {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["_registerExtension"]++; }; 
	var aPackageParts = this["sPackageName"]["split"]("."),
		oPackage = null,
		oExtensionFactory = null;

	// Check if the framework package is loaded.
	if (aPackageParts) {
		oPackage = window;
		for (var i = 0, iMax = aPackageParts["length"]; i < iMax; i++) {
			oPackage = oPackage[aPackageParts[i]];
			if (!oPackage) {
				// Not fully loaded. Come back here after a while
				UCF_JsUtil["delayedCall"](50, this, "_registerExtension", [oPersonas]);
				return;
			}
		}
	}

	// Create the extension factory and register it
	oExtensionFactory = new oPackage["ExtensionFactory"](oPersonas, this);
	oPersonas["registerExtensionFactory"](oExtensionFactory["switchMode"]["bind"](oExtensionFactory));

	// Show the "P"
	var bHidden = this["oConfiguration"]["hidden"] || false;
	oPersonas["show"](null, !bHidden);
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["_registerExtension"] = 0; };

UCF_PersonasFacade["prototype"]["setCommunicationHandler"] = function(oCommunicationHandler) {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["setCommunicationHandler"]++; }; 
	this["oFacade"] = oCommunicationHandler;
	this["bExtensionActive"] = true;

	// process all potentially delayed calls
	for (var i = 0, iMaxQueue = this["aScriptQueue"]["length"]; i < iMaxQueue; i++) {
		this["callMethod"](this["aScriptQueue"][i]["name"], this["aScriptQueue"][i]["parameters"]);
	}
	this["aScriptQueue"] = [];
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["setCommunicationHandler"] = 0; };

/**
 * Returns the path to Personas root
 * @return {string} path to Personas source root
 * @public
 */
UCF_PersonasFacade["prototype"]["getPersonasRootPath"] = function() {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["getPersonasRootPath"]++; }; 
	return this["sPersonasSourceRoot"];
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["getPersonasRootPath"] = 0; };

/**
 * Sets Facade into Script Mode
 * @param {boolean} Scripting Mode active
 * @protected
 */
UCF_PersonasFacade["prototype"]["setScriptingActive"] = function(bActive) {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["setScriptingActive"]++; }; 
	this["bScriptingActive"] = bActive;
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["setScriptingActive"] = 0; };

/**
 * Loads an object by a given name
 * @param {string} sObject, the object name, e.g. sap.personas.fw.SomeObject
 * @param {object} oCallbackObject, the object on which a callback function should be called
 * @param {string} sCallbackName, the name of the function which should be called on oCallbackObject
 */
UCF_PersonasFacade["prototype"]["loadObject"] = function(sObject) {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["loadObject"]++; }; 
	// Make sure require() is available
	if (__UCF_ASSERT__) { UCF_Tracer.assert(jQuery && jQuery["sap"] && jQuery["sap"]["require"] && typeof jQuery["sap"]["require"] === "function", "jQuery && jQuery.sap && jQuery.sap.require && typeof jQuery.sap.require === \"function\"", "PersonasFacade.js(205): loadObject"); };

	if (!sObject) {
		return;
	}

	jQuery["sap"]["registerModulePath"]("sap.personas", sap["personas"]["M_PATH"]["sources"] + 'sap/personas');
	jQuery["sap"]["registerModulePath"]("sap.personas.thirdparty", sap["personas"]["M_PATH"]["thirdparty"]);
	jQuery["sap"]["require"](sObject);

};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["loadObject"] = 0; };

/**
 * Destructor
 */
UCF_PersonasFacade["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["destroy"]++; }; 
	this["oFacade"] = null;
	this["bScriptingActive"] = null;
	this["oConfiguration"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PersonasFacade["prototype"]["aAttributeNames"] = ["sPersonasSourceRoot","sPackageName","sPackageUrl","bThemeSupport","sCustomData","sUi5SourceRoot","sPersonasSourceDir","sConfigJson"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PersonasFacade["prototype"]["aEventNames"] = ["RequestData"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PersonasFacade["prototype"]["aMethodNames"] = ["callMethod","getPersonasRootPath","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_PersonasFacade["prototype"]["sPersonasSourceRoot"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PersonasFacade["prototype"]["sPackageName"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PersonasFacade["prototype"]["sPackageUrl"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PersonasFacade["prototype"]["bThemeSupport"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PersonasFacade["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PersonasFacade["prototype"]["sUi5SourceRoot"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PersonasFacade["prototype"]["sPersonasSourceDir"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PersonasFacade["prototype"]["sConfigJson"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PersonasFacade["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["setDefaultValues"]++; }; 
	this["sPersonasSourceRoot"] = '';
	this["sPackageName"] = '';
	this["sPackageUrl"] = '';
	this["bThemeSupport"] = false;
	this["sCustomData"] = '';
	this["sUi5SourceRoot"] = '';
	this["sPersonasSourceDir"] = '';
	this["sConfigJson"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("PersonasSourceRoot", '', true);
		this["setClientProperty"]("PackageName", '', true);
		this["setClientProperty"]("PackageUrl", '', true);
		this["setClientProperty"]("ThemeSupport", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("Ui5SourceRoot", '', true);
		this["setClientProperty"]("PersonasSourceDir", '', true);
		this["setClientProperty"]("ConfigJson", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {string} sCommand Identifier of the personas command.
 * @param {string} sEventParameters Implemtation based on the Facade settings. in WD/UR Serialized JS Array with name value entries.
 * @fires PersonasFacade::RequestData
 */
UCF_PersonasFacade["prototype"]["fireRequestData"] = function(sId, sCommand, sEventParameters) {;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["fireRequestData"]++; }; 
	/** @type {{Id: string, Command: string, EventParameters: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PersonasFacade.js(332): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PersonasFacade.js(333): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PersonasFacade.js(334): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCommand != null, "sCommand != null", "PersonasFacade.js(335): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCommand) == "string", "typeof(sCommand) == \"string\"", "PersonasFacade.js(336): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sEventParameters != null, "sEventParameters != null", "PersonasFacade.js(337): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sEventParameters) == "string", "typeof(sEventParameters) == \"string\"", "PersonasFacade.js(338): fireRequestData"); };
	mParams = {
		"Id": sId,
		"Command": sCommand,
		"EventParameters": sEventParameters
	};
	
	
	
	this["fireSemanticEvent"]("PersonasFacade", "RequestData", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PersonasFacade["_"]["fireRequestData"] = 0; };

UCF_PersonasFacade.prototype["aPublicMethods"] = ["callMethod","getPersonasRootPath"].concat(UCF_PersonasFacade.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PhaseIndicator"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_PhaseIndicatorItem */
/// <reference path="./PhaseIndicatorItem.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PhaseIndicator(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["UCF_PhaseIndicator"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PhaseIndicator.js(36): UCF_PhaseIndicator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PhaseIndicator.js(37): UCF_PhaseIndicator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PhaseIndicator.js(38): UCF_PhaseIndicator"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["iFirstVisibleItem"] = parseInt(this["sFirstVisibleItem"]);
	this["oScrollDomRef"] = UCF_DomUtil["$"](this["sId"] + '-scrl');
	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	//this.oItemNavigation.bIgnoreFocus = true;
	this["addDelegate"](this["oItemNavigation"]);

	this["createItems"]();
	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Select"], this, "onItemSelect");
	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Activate"], this, 'onItemFocus'); // hack for the first focus
	this["oItemNavigation"]["setFocusedIndex"](this["oItemNavigation"]["iFocusedIndex"]);
	this["oItemNavigation"]["setNavigateInLoop"](false);
	//this.oItemNavigation.bIgnoreFocus = true;

	UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);

	this["attachBrowserEvent"]("resize", this["oDomRef"]);
	this["attachBrowserEvent"]("scroll", this["oScrollDomRef"]);
};window["UCF_PhaseIndicator"] = UCF_PhaseIndicator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PhaseIndicator"); UCF_PhaseIndicator["_"] = {UCF_PhaseIndicator: 0}; }; ;

UCF_PhaseIndicator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PhaseIndicator.prototype["sClassName"] = "UCF_PhaseIndicator";

/**
 * Initializes the PhaseIndicator.
 *
 * @private
 */
UCF_PhaseIndicator["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["initialize"]++; }; 

	if (this["iFirstVisibleItem"] > 0 && this["iFirstVisibleItem"] < this["aItems"]["length"]) {
		this["oScrollDomRef"]["scrollTop"] = this["aItems"][this["iFirstVisibleItem"]]["oDomRef"]["offsetTop"];
	}

	this["setPreviousButton"]();
	this["setNextButton"]();
	this["setMoreIndicator"]();

};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["initialize"] = 0; };

/**
 * Handles the resize event of the window.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PhaseIndicator["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onresize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PhaseIndicator.js(87): onresize"); };

	if (this["sTimeOutId"] != null) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
	}

	this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, "onAfterResize");
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onresize"] = 0; };

/**
 * @private
 */
UCF_PhaseIndicator["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onAfterResize"]++; }; 

	if (this["iControlWidth"] != null && this["iControlWidth"] === this["oDomRef"]["offsetWidth"]) return;

	if (this["oSelected"] != null) {
		this["oScrollDomRef"]["scrollTop"] = this["oSelected"]["oDomRef"]["offsetTop"];
	} else if (this["iFirstVisibleItem"] < this["aItems"]["length"]) {
		this["oScrollDomRef"]["scrollTop"] = this["aItems"][this["iFirstVisibleItem"]]["oDomRef"]["offsetTop"];
	}

	this["setPreviousButton"]();
	this["setNextButton"]();
	this["setMoreIndicator"]();

	this["iControlWidth"] = this["oDomRef"]["offsetWidth"];
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onAfterResize"] = 0; };

/**
 * Resets the status of the buttons and the more indicator, if scrolling was caused
 * by item navigation
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PhaseIndicator["prototype"]["onscroll"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onscroll"]++; }; 

	var oSource = UCF_DomUtil["oGetActiveElement"](),
		oItem = UCF_DomUtil["oGetCTElement"](oSource);

	if (oItem && oItem["getAttribute"]("ct") === "PHII") {
		this["setNextButton"]();
		this["setPreviousButton"]();
		this["setMoreIndicator"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onscroll"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PhaseIndicator["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PhaseIndicator.js(143): onclick"); };

	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource["getAttribute"]("id") == null) return;

	var sSourceId = oSource["getAttribute"]("id");

	if (sSourceId["indexOf"]("next") > -1) {
		this["nextPage"]();
	} else if (sSourceId["indexOf"]("prev") > -1) {
		this["previousPage"]();
	}

	this["setPreviousButton"]();
	this["setNextButton"]();
	this["setMoreIndicator"]();
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onclick"] = 0; };

/**
 * Triggers scrolling to previous page.
 * @private
 */
UCF_PhaseIndicator["prototype"]["previousPage"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["previousPage"]++; }; 
	var oBtn = UCF_DomUtil["$"](this["sId"] + "-prev");
	if (oBtn["className"]["indexOf"]("Dsbl") > -1) return;
	// the oScrollDomRef.offsetHeight should be the same with the Height of the phaseIndicatorItem
	// if there is any scrolling issue, please check the css styles
	//_trace(DEBUG, "==========PREVIOUS scrollTop =" + this.oScrollDomRef.scrollTop + "===>>> offsetHeight=" + this.oScrollDomRef.offsetHeight);
	this["oScrollDomRef"]["scrollTop"] -= this["oScrollDomRef"]["offsetHeight"];
	if (this["getFirstVisible"]()) {
		this["fireScroll"](this["sId"], this["getFirstVisible"]()["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["previousPage"] = 0; };

/**
 * Triggers scrolling to next page
 * @private
 */
UCF_PhaseIndicator["prototype"]["nextPage"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["nextPage"]++; }; 
	var oBtn = UCF_DomUtil["$"](this["sId"] + "-next");
	if (oBtn["className"]["indexOf"]("Dsbl") > -1) return;

	// the oScrollDomRef.offsetHeight should be the same with the Height of the phaseIndicatorItem
	// if there is any scrolling issue, please check the css styles
	//_trace(DEBUG, "==========NEXT scrollTop =" + this.oScrollDomRef.scrollTop + "===>>> offsetHeight=" + this.oScrollDomRef.offsetHeight);
	this["oScrollDomRef"]["scrollTop"] += this["oScrollDomRef"]["offsetHeight"];
	if (this["getFirstVisible"]()) {
		this["fireScroll"](this["sId"], this["getFirstVisible"]()["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["nextPage"] = 0; };

/**
 * Sets the MoreIndicator icon on the left, if there are more items
 * before the first visible
 * @private
 */
UCF_PhaseIndicator["prototype"]["setMoreIndicator"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["setMoreIndicator"]++; }; 

	var oIcon = UCF_DomUtil["$"](this["sId"] + "-start");
	if (this["oScrollDomRef"]["scrollTop"] > 0) oIcon["className"] = "lsPhInicoMB2";
	else oIcon["className"] = "lsPhInicoStrart2";
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["setMoreIndicator"] = 0; };

/**
 * Finds the first visible item
 *
 * @return the first visible item
 * @type UCF_PhaseIndicatorItem
 * @private
 */
UCF_PhaseIndicator["prototype"]["getFirstVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["getFirstVisible"]++; }; 
	for (var i = 0; i < this["aItems"]["length"]; i++) {
		//calculate with one pixel offset when oDomRef.offsetTop is called; may occur in all FF versions and in Safari under Mac
		//alert("gfv: " + this.oScrollDomRef.scrollTop + " == " + this.aItems[i].oDomRef.offsetTop);
		var iST = this["oScrollDomRef"]["scrollTop"];
		var iOT = this["aItems"][i]["oDomRef"]["offsetTop"];
		if (iST === iOT || iST + 1 === iOT || iST - 1 === iOT) return this["aItems"][i];
	}
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["getFirstVisible"] = 0; };

/**
 * Finds the last visible item
 *
 * @return the last visible item
 * @type UCF_PhaseIndicatorItem
 * @private
 */
UCF_PhaseIndicator["prototype"]["getLastVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["getLastVisible"]++; }; 
	for (var i = this["aItems"]["length"] - 1; i >= 0; i--) {
		//calculate with one pixel offset when oDomRef.offsetTop is called; may occur in all FF versions and in Safari under Mac
		//alert("glv: " + this.oScrollDomRef.scrollTop + " == " + this.aItems[i].oDomRef.offsetTop);
		var iST = this["oScrollDomRef"]["scrollTop"];
		var iOT = this["aItems"][i]["oDomRef"]["offsetTop"];
		if (iST === iOT || iST + 1 === iOT || iST - 1 === iOT) return this["aItems"][i];
	}
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["getLastVisible"] = 0; };

/**
 * Sets the correct styles on the previous Button
 * @private
 */
UCF_PhaseIndicator["prototype"]["setPreviousButton"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["setPreviousButton"]++; }; 
	//debugger;
	var oBtn = UCF_DomUtil["$"](this["sId"] + "-prev");
	if (this["oScrollDomRef"]["scrollTop"] > 0) {
		UCF_DomUtil["replaceClass"](oBtn, "urBtnStdDsbl", "urBtnStd");
		UCF_DomUtil["replaceClass"](oBtn, "urPGHPrevItemDsbl", "urPGHPrevItem");
		UCF_DomUtil["replaceClass"](oBtn, "urPGBtnDsbl", "urPGBtn");
		UCF_DomUtil["removeClass"](oBtn, 'lsPhaseIndicator--disabled');
	} else {
		UCF_DomUtil["replaceClass"](oBtn, "urBtnStd", "urBtnStdDsbl");
		UCF_DomUtil["replaceClass"](oBtn, "urPGHPrevItem", "urPGHPrevItemDsbl");
		UCF_DomUtil["replaceClass"](oBtn, "urPGBtn", "urPGBtnDsbl");
		UCF_DomUtil["addClass"](oBtn, 'lsPhaseIndicator--disabled');
	}

};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["setPreviousButton"] = 0; };

/**
 * Sets the correct styles on the next Button
 * @private
 */
UCF_PhaseIndicator["prototype"]["setNextButton"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["setNextButton"]++; }; 
	var bScroll = this["oScrollDomRef"]["scrollHeight"] > this["oScrollDomRef"]["scrollTop"] + this["oScrollDomRef"]["offsetHeight"] + 1;
	var oBtn = UCF_DomUtil["$"](this["sId"] + "-next");
	if (bScroll) {
		UCF_DomUtil["replaceClass"](oBtn, "urBtnStdDsbl", "urBtnStd");
		UCF_DomUtil["replaceClass"](oBtn, "urPGHNxtItemDsbl", "urPGHNxtItem");
		UCF_DomUtil["replaceClass"](oBtn, "urPGBtnDsbl", "urPGBtn");
		UCF_DomUtil["removeClass"](oBtn, 'lsPhaseIndicator--disabled');
	} else {
		UCF_DomUtil["replaceClass"](oBtn, "urBtnStd", "urBtnStdDsbl");
		UCF_DomUtil["replaceClass"](oBtn, "urPGHNxtItem", "urPGHNxtItemDsbl");
		UCF_DomUtil["replaceClass"](oBtn, "urPGBtn", "urPGBtnDsbl");
		UCF_DomUtil["addClass"](oBtn, 'lsPhaseIndicator--disabled');
	}
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["setNextButton"] = 0; };

/**
 * fires the select event
 *
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_PhaseIndicator["prototype"]["onItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onItemSelect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "PhaseIndicator.js(290): onItemSelect"); };

	var oItem = oEvent["oGetParam"]("oItem");

	if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_PhaseIndicatorItem") && !oItem["bSelected"] && oItem["bEnabled"])
		this["fireSelect"](this["sId"], oItem["sId"]);
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onItemSelect"] = 0; };

/**
 * Set the focus
 * @param {UCF_Event} oEvent the event that occurred
 * @private
 */
UCF_PhaseIndicator["prototype"]["onItemFocus"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onItemFocus"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "PhaseIndicator.js(305): onItemFocus"); };

	var oItem = oEvent["oGetParam"]('oItem');

	if (!oItem) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_PhaseIndicatorItem, "oItem instanceof UCF_PhaseIndicatorItem", "PhaseIndicator.js(311): onItemFocus"); };

	oItem["focus"]();
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onItemFocus"] = 0; };

/**
 * handles the item navigation
 * @private
 */
UCF_PhaseIndicator["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["createItems"]++; }; 

	var aDomItems = this["oScrollDomRef"]["childNodes"];
	this["aItems"] = new Array();
	this["oSelected"] = null;

	for (var iItemCount = 0; iItemCount < aDomItems["length"]; iItemCount++) {
		var oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[iItemCount], true);
		oItem["iIndex"] = iItemCount;

		if (oItem["bSelected"]) this["oSelected"] = oItem;

		if (oItem["bEnabled"] || window["UCF_System"]["bIs508"] || window["UCF_System"]["bIsAria"]) { //window.UCF_System.bIs508 deleted
			this["oItemNavigation"]["addItem"](oItem, oItem["bSelected"]);
		}
		this["aItems"]["push"](oItem);

		if (window["UCF_System"]["bIsAria"] && oItem["oFocusDomRef"]) {
			UCF_AriaStateHelper["setPosinset"](oItem["oFocusDomRef"], iItemCount + 1);
			UCF_AriaStateHelper["setSetsize"](oItem["oFocusDomRef"], aDomItems["length"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["createItems"] = 0; };

/**
 * Sets the correct acc text
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PhaseIndicator["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PhaseIndicator.js(351): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSourceControl"]();

	if (!UCF_JsUtil["bInstanceOf"](oSource, "UCF_PhaseIndicatorItem")) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](oSource["oDomRef"]));
	oAccessibilityHelper["setTooltip"](oSource["sTooltip"]);
	oAccessibilityHelper["setItemCount"](this["oItemNavigation"]["aItems"]["length"]);
	oAccessibilityHelper["setItemIndex"](oSource["iIndex"] + 1);

	if (!UCF_StringUtil["bIsEmpty"](this["sAccessibilityDescription"])) {
		oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);
	}

	oAccessibilityHelper["setControlType"]("PHI");
	oAccessibilityHelper["setEnabled"](oSource["bEnabled"]);
	oAccessibilityHelper["setSelected"](oSource["bSelected"]);
	oAccessibilityHelper["addTutor"]("LRNAV_TUT");
	oAccessibilityHelper["addEnabledTutor"]("SELECT_TUT", oSource["bEnabled"] && !oSource["bSelected"]);
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_PhaseIndicator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["destroy"]++; }; 
	this["detachBrowserEvent"]("resize", this["oDomRef"]);
	this["detachBrowserEvent"]("scroll", this["oDomRef"]);
	this["iFirstVisibleItem"] = null;
	this["oScrollDomRef"] = null;

	this["sTimeOutId"] = null;
	this["iControlWidth"] = null;
	this["aItems"] = null;
	this["oSelected"] = null;
	if (this["oItemNavigation"]) {
		this["oItemNavigation"]["destroy"]();
		this["oItemNavigation"] = null;
	}

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PhaseIndicator["prototype"]["aAttributeNames"] = ["sFirstVisibleItem","sAccessibilityDescription","sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PhaseIndicator["prototype"]["aEventNames"] = ["Select","Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PhaseIndicator["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PhaseIndicator["prototype"]["sFirstVisibleItem"] = '0';

/**
 * @private
 * @type {string}
 */
UCF_PhaseIndicator["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_PhaseIndicator["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_PhaseIndicator["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PhaseIndicator["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["setDefaultValues"]++; }; 
	this["sFirstVisibleItem"] = '0';
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("FirstVisibleItem", '0', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier the PhaseIndicator.
 * @param {string} sItemId Identifier the selected PhaseIndicator item.
 * @fires PhaseIndicator::Select
 */
UCF_PhaseIndicator["prototype"]["fireSelect"] = function(sId, sItemId) {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, ItemId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "PhaseIndicator.js(469): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PhaseIndicator.js(470): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PhaseIndicator.js(471): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "PhaseIndicator.js(472): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "PhaseIndicator.js(473): fireSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId
	};
	
	
	this["fireSemanticEvent"]("PhaseIndicator", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier the PhaseIndicator control (Root object).
 * @param {string} sFirstVisibleItemId Identifier of the first visible PhaseIndicator item. 
 * @fires PhaseIndicator::Scroll
 */
UCF_PhaseIndicator["prototype"]["fireScroll"] = function(sId, sFirstVisibleItemId) {;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, FirstVisibleItemId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "PhaseIndicator.js(493): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PhaseIndicator.js(494): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PhaseIndicator.js(495): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFirstVisibleItemId != null, "sFirstVisibleItemId != null", "PhaseIndicator.js(496): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFirstVisibleItemId) == "string", "typeof(sFirstVisibleItemId) == \"string\"", "PhaseIndicator.js(497): fireScroll"); };
	mParams = {
		"Id": sId,
		"FirstVisibleItemId": sFirstVisibleItemId
	};
	
	
	this["fireSemanticEvent"]("PhaseIndicator", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicator["_"]["fireScroll"] = 0; };

};
sap["ls"]["preload"]["UCF_PhaseIndicatorItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PhaseIndicatorItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PhaseIndicatorItem["_"]["UCF_PhaseIndicatorItem"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "PhaseIndicatorItem.js(18): UCF_PhaseIndicatorItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PhaseIndicatorItem.js(19): UCF_PhaseIndicatorItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PhaseIndicatorItem.js(20): UCF_PhaseIndicatorItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	this["oFocusDomRef"] = this["oDomRef"]["firstChild"];
};window["UCF_PhaseIndicatorItem"] = UCF_PhaseIndicatorItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PhaseIndicatorItem"); UCF_PhaseIndicatorItem["_"] = {UCF_PhaseIndicatorItem: 0}; }; ;
UCF_PhaseIndicatorItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PhaseIndicatorItem.prototype["sClassName"] = "UCF_PhaseIndicatorItem";

UCF_PhaseIndicatorItem["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PhaseIndicatorItem["_"]["onlsfocus"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicatorItem["_"]["onlsfocus"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PhaseIndicatorItem["prototype"]["aAttributeNames"] = ["sTooltip","sTitle","bEnabled","bSelected","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PhaseIndicatorItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PhaseIndicatorItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PhaseIndicatorItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PhaseIndicatorItem["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PhaseIndicatorItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_PhaseIndicatorItem["prototype"]["bSelected"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PhaseIndicatorItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PhaseIndicatorItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PhaseIndicatorItem["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sTitle"] = '';
	this["bEnabled"] = true;
	this["bSelected"] = false;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Selected", false, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PhaseIndicatorItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_PickerSlider"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * A Slider to provide a list of items on the client
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 * @param {string} sId
 * @depends UCF_PickerSlider
 */
function UCF_PickerSlider(oDomRef, oLS, sId) {if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["UCF_PickerSlider"]++; }; 

	UCF_Control["apply"](this, arguments);

	this["defineEvents"](['Change', 'Drag']);

	//initialize the control
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bCyclic"] = false;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iVisibleItems"] = 3;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bComplete"] = true;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iSelectedItem"] = 0;
};window["UCF_PickerSlider"] = UCF_PickerSlider; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PickerSlider"); UCF_PickerSlider["_"] = {UCF_PickerSlider: 0}; }; ;
UCF_PickerSlider["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PickerSlider.prototype["sClassName"] = "UCF_PickerSlider";

UCF_PickerSlider["SCROLL_ANIMATION_DURATION"] = 200;

/**
 * setProperties
 * set the properties by the contents of a JSON
 * @param {Object} oProperties
 *
 */
UCF_PickerSlider["prototype"]["setProperties"] = function(oProperties) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["setProperties"]++; }; 
	if (oProperties["bCyclic"] !== undefined)
		this["bCyclic"] = oProperties["bCyclic"];
	if (oProperties["iVisibleItems"])
		this["iVisibleItems"] = parseInt(oProperties["iVisibleItems"] / 2);
	else
		this["iVisibleItems"] = 0;
	if (oProperties["iSelectedItem"])
		this["iSelectedItem"] = oProperties["iSelectedItem"]; // + this.iVisibleItems;
	if (oProperties["bComplete"] !== undefined)
		this["bComplete"] = oProperties["bComplete"];
	if (oProperties["sTitle"])
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sTitle"] = oProperties["sTitle"];
	else
		this["sTitle"] = '';
	if (oProperties["sLabel"])
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sLabel"] = oProperties["sLabel"];
	else
		this["sLabel"] = '';
	if (oProperties["sParentId"])
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sParentId"] = oProperties["sParentId"];
	if (oProperties["sId"])
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sId"] = oProperties["sId"];
	if (oProperties["oParent"])
		this["oParent"] = oProperties["oParent"];
	if (oProperties["aListItems"])
		this["setListItems"](oProperties["aListItems"]);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["setProperties"] = 0; };

/** setListItems aItems [{ "key": string, "value": string} }
 *
 * @param {Array} aItems
 *
 */
UCF_PickerSlider["prototype"]["setListItems"] = function(aItems) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["setListItems"]++; }; 
	var i;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sLongest"] = this["sTitle"];
	this["aListItems"] = [];
	for (i = 0; i < aItems["length"]; i++)
		if (this["sLongest"]["length"] < aItems[i]["value"]["length"])
			this["sLongest"] = aItems[i]["value"];
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iListItems"] = aItems["length"];
	this["aListItems"] = aItems;
	if (this["iVisibleItems"] > 0 && this["bCyclic"])
		this["aListItems"] = this["aListItems"]["concat"](aItems, aItems);
	var oElement = document["getElementById"](this["sId"] + '-content');
	if (oElement)
		// eslint-disable-next-line no-unsanitized/property
		oElement["innerHTML"] = this["sGetListItemsHTML"]();
	oElement = document["getElementById"](this["sId"]);
	if (oElement)
		oElement["setAttribute"]('data-widest-item', this["sLongest"]);
	if (this["oScroller"])
		this["setScrollTop"]();
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["setListItems"] = 0; };

/**
 * renderSeparator
 */
UCF_PickerSlider["prototype"]["renderSeparator"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["renderSeparator"]++; }; 
	var oParent = document["getElementById"](this["sParentId"]);
	var element = document["createElement"]('DIV');
	element["id"] = this["sId"];
	element["setAttribute"]('ct', "PickerSlider");
	element["setAttribute"]('class', "lsPickerSliderColumn lsPickerSliderSeparator");
	oParent["appendChild"](element);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["renderSeparator"] = 0; };

/**
 * render
 */
UCF_PickerSlider["prototype"]["render"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["render"]++; }; 
	if (!this["aListItems"]) {
		this["renderSeparator"]();
		return;
	}
	var oParent = document["getElementById"](this["sParentId"]);
	var element = document["createElement"]('DIV');
	element["id"] = this["sId"];
	element["setAttribute"]('tabindex', "0");
	element["setAttribute"]('ti', "0");
	element["setAttribute"]('ct', "PickerSlider");
	element["setAttribute"]('class', "lsPickerSliderColumn");
	element["setAttribute"]('data-widest-item', this["sLongest"]);

	if (this["sLabel"] && this["sLabel"] !== '')
		element["setAttribute"]('aria-label', this["sLabel"]);
	else
		element["setAttribute"]('aria-label', this["sTitle"]);
	element["setAttribute"]('aria-describedby', this["sId"] + '-valDescription');

	oParent["appendChild"](element);
	var sInnerHTML = '';

	sInnerHTML += '<div id="' + this["sId"] + '-label" class="lsPickerSliderLabel" aria-expanded="true">' + this["sTitle"] + '</div>';
	sInnerHTML += '<div id="' + this["sId"] + '-valDescription" class="lsControl--invisible" aria-hidden="false" aria-live="assertive">' +
		this["aListItems"][this["iSelectedItem"]]["value"] +
		'</div>';
	sInnerHTML += '<div class="lsPickerSliderArrows" >';
	sInnerHTML += '<span id="' + this["sId"] + '-button-up"  ' +
		'class="lsDateNavigator--button lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconHv urCalArrPrev lsMirrorRtl"></span>';

	sInnerHTML += '</div>';
	sInnerHTML += '<div class="lsPickerSlider" unselectable="on">';
	if (this["bCyclic"] === false) {
		if (this["iVisibleItems"] === 2)
			sInnerHTML += '<ul class="lsPickerSliderNonCyclicListSmall" id="' + this["sId"] + '-content" unselectable="on">';
		else
			sInnerHTML += '<ul class="lsPickerSliderNonCyclicList" id="' + this["sId"] + '-content" unselectable="on">';
	} else
		sInnerHTML += '<ul  id="' + this["sId"] + '-content" unselectable="on">';
		/*style="position:relative;margin:0" */
	sInnerHTML += this["sGetListItemsHTML"]();
	sInnerHTML += '</ul>';
	sInnerHTML += '</div>';
	sInnerHTML += '<div class="lsPickerSliderArrows" >';

	sInnerHTML += '<span id="' + this["sId"] + '-button-down" ' +
		'class="lsDateNavigator--button ' +
		'lsCalArrowBtn lsCalArrBtnIcon lsCalArrBtnIconHv urCalArrPrev lsMirrorRtl"></span>';
	sInnerHTML += '</div>';

	// eslint-disable-next-line no-unsanitized/property
	element["innerHTML"] = sInnerHTML;

	document["getElementById"](this["sId"] + '-button-up')["style"]["position"] = "relative";
	document["getElementById"](this["sId"] + '-button-up')["style"]["transform"] = "rotate(90deg)";
	document["getElementById"](this["sId"] + '-button-down')["style"]["position"] = "relative";
	document["getElementById"](this["sId"] + '-button-down')["style"]["transform"] = "rotate(-90deg)";
	if (this["bCyclic"] === true) {
		document["getElementById"](this["sId"] + '-content')["style"]["position"] = "relative";
		document["getElementById"](this["sId"] + '-content')["style"]["margin"] = "0";
	}

	this["oDomRef"] = element;
	this["oList"] = document["getElementById"](this["sId"] + '-content');
	this["oScroller"] = this["oList"]["parentNode"];
	this["connectToDom"](element);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["render"] = 0; };

/** sGetSelection
 *
 * @return {Object}
 *
 */
UCF_PickerSlider["prototype"]["sGetSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["sGetSelection"]++; }; 
	return ({ "value": this["oList"]["children"][this["iSelectedItem"]]["innerText"], "key": this["oList"]["children"][this["iSelectedItem"]]["getAttribute"]('data-key') });
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["sGetSelection"] = 0; };

/**
 * ondragstart
 * @param {UCF_BrowserEvent} oEvent
 */
UCF_PickerSlider["prototype"]["ondragstart"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["ondragstart"]++; }; 

	//start collecting touch coordinates
	if (!this["_dragSession"]) {
		this["_dragSession"] = {};
		this["_dragSession"]["positions"] = [];
	}
	//check this !!!
	//	this._dragSession.pageY = iPageY;
	this["_dragSession"]["startTop"] = this["oScroller"]["scrollTop"];
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["ondragstart"] = 0; };

/** onTouchStart
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @returns {void}
 */
UCF_PickerSlider["prototype"]["onTouchStart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onTouchStart"]++; }; 
	this["attachBrowserEvent"]('mousemove', this["oDomRef"]);
	this["attachBrowserEvent"]('touchmove', this["oDomRef"]);
	var oEvent = oBrowserEvent["oDomEvent"];
	var iPageY = oEvent["touches"] && oEvent["touches"]["length"] ? oEvent["touches"][0]["pageY"] : oEvent["pageY"];
	this["_bIsDrag"] = false;

	if (!this["bGetExpanded"]())
		return;

	this["_startDrag"](iPageY);

	oEvent["preventDefault"]();
	this["_mousedown"] = true;
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onTouchStart"] = 0; };

/** onTouchMove
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {void}
 */
UCF_PickerSlider["prototype"]["onTouchMove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onTouchMove"]++; }; 
	if (oBrowserEvent["oDomEvent"]["buttons"] === 0)
		this["onTouchEnd"](oBrowserEvent);
	var oEvent = oBrowserEvent["oDomEvent"];

	var iPageY = oEvent["touches"] && oEvent["touches"]["length"] ? oEvent["touches"][0]["pageY"] : oEvent["pageY"];

	if (!this["_mousedown"] || !this["bGetExpanded"]())
		return;

	//galaxy s5 android 5.0 fires touchmove every time - so see if it's far enough to call it a drag
	if (!this["_bIsDrag"] && this["_dragSession"] && this["_dragSession"]["positions"]["length"]) {
		//there is a touch at least 5px away vertically from the initial touch
		var bFarEnough = this["_dragSession"]["positions"]["some"](function(pos) {
			return Math["abs"](pos["pageY"] - iPageY) > 5;
		});

		if (bFarEnough) {
			this["_bIsDrag"] = true;
		}
	}

	this["_doDrag"](iPageY, oEvent["timeStamp"]);

	this["_mousedown"] = true;
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onTouchMove"] = 0; };

/**
 * Default onTouchEnd handler.
 * @param {UCF_BrowserEvent} oBrowserEvent  Event object
 */
UCF_PickerSlider["prototype"]["onTouchEnd"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onTouchEnd"]++; }; 
	var oEvent = oBrowserEvent["oDomEvent"];

	var iPageY = oEvent["changedTouches"] && oEvent["changedTouches"]["length"] ? oEvent["changedTouches"][0]["pageY"] : oEvent["pageY"];

	if (this["_bIsDrag"] === false) {
		this["handleTap"](oBrowserEvent);
		this["_dragSession"] = null;
	} else {
		this["_bIsDrag"] = true;
		if (!this["bGetExpanded"]()) {
			this["_dragSession"] = null;
			return;
		}
		this["_endDrag"](iPageY, oEvent["timeStamp"]);
		this["_mousedown"] = false;
		this["snap"]();
	}
	this["detachBrowserEvent"]('touchmove', this["oDomRef"]);
	this["detachBrowserEvent"]('mousemove', this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onTouchEnd"] = 0; };

/**
 * Starts scroll session.
 *
 * @param {number} iPageY The starting y-coordinate of the target
 * @private
 */
UCF_PickerSlider["prototype"]["_startDrag"] = function(iPageY) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["_startDrag"]++; }; 
	//start collecting touch coordinates
	if (!this["_dragSession"]) {
		this["_dragSession"] = {};
		this["_dragSession"]["positions"] = [];
	}

	this["_dragSession"]["pageY"] = iPageY;
	this["_dragSession"]["startTop"] = this["oScroller"]["scrollTop"]; //this._getSliderContainerDomRef().scrollTop();
	this["fireEvent"](this["E_EVENTS"]["Drag"], { "sId": this["sId"], "bValue": true });
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["_startDrag"] = 0; };

/**
 * Performs vertical scroll.
 *
 * @param {number} iPageY The current y-coordinate of the target to scroll to
 * @param {Date} dTimeStamp Timestamp of the event
 * @private
 */
UCF_PickerSlider["prototype"]["_doDrag"] = function(iPageY, dTimeStamp) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["_doDrag"]++; }; 
	if (this["_dragSession"]) {
		//calculate the distance between the start of the drag and the current touch
		this["_dragSession"]["offsetY"] = iPageY - this["_dragSession"]["pageY"];

		this["_dragSession"]["positions"]["push"]({ "pageY": iPageY, "timeStamp": dTimeStamp });
		//to calculate speed we only need the last touch positions
		if (this["_dragSession"]["positions"]["length"] > 20) {
			this["_dragSession"]["positions"]["splice"](0, 10);
		}

		if (this["_bIsDrag"]) {
			//while dragging update the list position inside its container
			// this._getSliderContainerDomRef().scrollTop(this._dragSession.startTop - this._dragSession.offsetY);
			this["oScroller"]["scrollTop"] = this["_dragSession"]["startTop"] - this["_dragSession"]["offsetY"];

			if (this["oScroller"]["scrollTop"] <= 0)
				this["oScroller"]["scrollTop"] = 0;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["_doDrag"] = 0; };

/**
 * Finishes scroll session.
 *
 * @param {number} iPageY The last y-coordinate of the target to scroll to
 * @param {Date} dTimeStamp Timestamp of the event
 * @private
 */
UCF_PickerSlider["prototype"]["_endDrag"] = function(iPageY, dTimeStamp) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["_endDrag"]++; }; 
	if (this["_dragSession"]) {
		var iOffsetTime, iOffsetY;
		//get only the offset calculated including the touches in the last 100ms
		for (var i = this["_dragSession"]["positions"]["length"] - 1; i >= 0; i--) {
			iOffsetTime = dTimeStamp - this["_dragSession"]["positions"][i]["timeStamp"];
			iOffsetY = iPageY - this["_dragSession"]["positions"][i]["pageY"];
			if (iOffsetTime > 100) {
				break;
			}
		}

		var fSpeed = (iOffsetY / iOffsetTime); // px/ms

		if (this["_animating"]) {
			clearInterval(this["_intervalId"]);
			// eslint-disable-next-line @ur/no-memory-leaks
			this["_intervalId"] = null;
			this["_animating"] = null;
		}

		this["_dragSession"] = null;
		this["_animateScroll"](fSpeed);
		this["fireEvent"](this["E_EVENTS"]["Drag"], { "sId": this["sId"], "bValue": false });
	}
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["_endDrag"] = 0; };

/**
 * Animate scroll session.
 *
 * @param {number} iSpeed
 * @private
 */
UCF_PickerSlider["prototype"]["_animateScroll"] = function(iSpeed) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["_animateScroll"]++; }; 
	var $Container = this["oScroller"],
		iPreviousScrollTop = $Container["scrollTop"], // $Container.scrollTop(),
		frameFrequencyMs = 25, //milliseconds - 40 frames per second; 1000ms / 40frames === 25
		//increase the distance that the slider can be dragged before reaching one end of the list
		//because we do not do updates of list offset while dragging,
		//we have to keep that distance long at least while animating
		bCycle = this["bCyclic"],
		fDecelerationCoefficient = 0.9,
		fStopSpeed = 0.05,
		that = this;

	this["_intervalId"] = setInterval(function() {
		that["_animating"] = true;
		//calculate the new scroll offset by subtracting the distance
		iPreviousScrollTop = iPreviousScrollTop - iSpeed * frameFrequencyMs;
		if (bCycle) {
			//iPreviousScrollTop = that.oScroller.scrollTop; //that._getUpdatedCycleScrollTop($ContainerHeight, $ContentHeight, iPreviousScrollTop, iDragMargin, iContentRepeat);
		} else {
			if (iPreviousScrollTop > that["_maxScrollTop"]) {
				iPreviousScrollTop = that["_maxScrollTop"];
				iSpeed = 0;
			}

			if (iPreviousScrollTop < that["_minScrollTop"]) {
				iPreviousScrollTop = that["_minScrollTop"];
				iSpeed = 0;
			}
		}
		$Container["scrollTop"] = iPreviousScrollTop;

		iSpeed *= fDecelerationCoefficient;
		if (Math["abs"](iSpeed) < fStopSpeed) { // px/milliseconds
			var iItemHeight = 32;

			clearInterval(that["_intervalId"]);
			that["_intervalId"] = null;
			that["_animating"] = null;
			that["iSelectedItem"] = Math["round"]((iPreviousScrollTop) / iItemHeight);

			that["_animatingSnap"] = true;
			that["snap"]();
			that["selectionChange"]();
		}
	}, frameFrequencyMs);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["_animateScroll"] = 0; };

/**
 * Stops the scrolling animation.
 *
 * @private
 */
UCF_PickerSlider["prototype"]["_stopAnimation"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["_stopAnimation"]++; }; 
	if (this["_animating"]) {
		clearInterval(this["_intervalId"]);
		this["_intervalId"] = null;
		this["_animating"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["_stopAnimation"] = 0; };

/**
 * Returns the Expansion state
 * @return {boolean}
 */
UCF_PickerSlider["prototype"]["bGetExpanded"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["bGetExpanded"]++; }; 
	return (this["bExpanded"]);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["bGetExpanded"] = 0; };

/**
 * Set to expanded
 * @param {boolean} bExpanded
 */
UCF_PickerSlider["prototype"]["setExpanded"] = function(bExpanded) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["setExpanded"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bExpanded"] = bExpanded;
	if (!this["oDomRef"]) // separator
		return;
	if (bExpanded)
		this["oDomRef"]["className"] = 'lsPickerSliderColumn lsPickerSliderExpanded';
	else
		this["oDomRef"]["className"] = 'lsPickerSliderColumn';
	this["setScrollTop"]();
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["setExpanded"] = 0; };

/**
 * Handle the Tap Event
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {void}
 */
UCF_PickerSlider["prototype"]["handleTap"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["handleTap"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PickerSlider.js(472): handleTap"); };
	if (!this["oScroller"])
		return;
	if (!this["bExpanded"]) {
		this["setExpanded"](true);
		this["oParent"]["setExpanded"](this);
	} else {
		var index;
		var sIndex = oBrowserEvent["oSource"]["getAttribute"]('index');
		if (sIndex)
			index = parseInt(sIndex);
		else if (oBrowserEvent["oSource"]["id"] && oBrowserEvent["oSource"]["id"]["indexOf"]('button-up') !== -1)
			index = this["iSelectedItem"] - 1;
		else if (oBrowserEvent["oSource"]["id"] && oBrowserEvent["oSource"]["id"]["indexOf"]('button-down') !== -1)
			index = this["iSelectedItem"] + 1;
		else { // Selectionframe
			UCF_DomUtil["cancelEvent"](oBrowserEvent["oDomEvent"]);
			return;
		}
		if (index >= 0 && index < this["aListItems"]["length"]) {
			this["oList"]["children"][this["iSelectedItem"]]["className"] = 'lsPickerSliderItem';
			this["iSelectedItem"] = index;
			this["setScrollTop"]();
			this["oList"]["children"][this["iSelectedItem"]]["className"] = 'lsPickerSliderItem lsPickerSliderItemSelected';
		}
		this["selectionChange"]();
	}
	UCF_DomUtil["cancelEvent"](oBrowserEvent["oDomEvent"]);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["handleTap"] = 0; };

UCF_PickerSlider["prototype"]["onmousemove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onmousemove"]++; }; 
	this["onTouchMove"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onmousemove"] = 0; };

UCF_PickerSlider["prototype"]["ontouchmove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["ontouchmove"]++; }; 
	this["onTouchMove"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["ontouchmove"] = 0; };

UCF_PickerSlider["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onmousedown"]++; }; 
	this["onTouchStart"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onmousedown"] = 0; };

UCF_PickerSlider["prototype"]["ontouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["ontouchstart"]++; }; 
	this["onTouchStart"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["ontouchstart"] = 0; };

UCF_PickerSlider["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onmouseup"]++; }; 
	this["onTouchEnd"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onmouseup"] = 0; };

UCF_PickerSlider["prototype"]["ontouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["ontouchend"]++; }; 
	this["onTouchEnd"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["ontouchend"] = 0; };

UCF_PickerSlider["prototype"]["onlsmousewheel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlsmousewheel"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PickerSlider.js(527): onlsmousewheel"); };

	// eslint-disable-next-line no-magic-numbers
	this["oList"]["children"][this["iSelectedItem"]]["className"] = 'lsPickerSliderItem';
	this["iSelectedItem"] -= parseInt(oBrowserEvent["iWheelDelta"]() / 3);
	if (this["bCyclic"]) {
		if (this["iSelectedItem"] < this["iListItems"])
			this["iSelectedItem"] += this["iListItems"];
		else if (this["iSelectedItem"] > 2 * this["iListItems"])
			this["iSelectedItem"] -= this["iListItems"];
	} else if (!this["bComplete"]) {
		if (this["iSelectedItem"] < this["iVisibleItems"])
			this["iSelectedItem"] = this["aListItems"]["length"] - this["iVisibleItems"] - 1;
		else if (this["iSelectedItem"] > this["aListItems"]["length"] - this["iVisibleItems"])
			this["iSelectedItem"] = this["iVisibleItems"] + 1;
	} else {
		if (this["iSelectedItem"] < 0)
			this["iSelectedItem"] = 0;
		else if (this["iSelectedItem"] > this["aListItems"]["length"] - 1)
			this["iSelectedItem"] = this["aListItems"]["length"] - 1;
	}
	this["setScrollTop"]();
	this["oList"]["children"][this["iSelectedItem"]]["className"] = 'lsPickerSliderItem lsPickerSliderItemSelected';
	this["selectionChange"]();

	UCF_DomUtil["cancelEvent"](oBrowserEvent["oDomEvent"]);

};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlsmousewheel"] = 0; };

UCF_PickerSlider["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PickerSlider.js(557): onlsfocus"); };
	if (!this["bExpanded"]) {
		this["setExpanded"](true);
		this["oParent"]["setExpanded"](this);
	}
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlsfocus"] = 0; };

UCF_PickerSlider["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlsblur"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PickerSlider.js(565): onlsblur"); };
	if (this["bExpanded"]) {
		this["setExpanded"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlsblur"] = 0; };

UCF_PickerSlider["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlsup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PickerSlider.js(572): onlsup"); };
	this["iSelectedItem"]--;
	if (this["iSelectedItem"] < 0)
		this["iSelectedItem"] = 0;
	this["setScrollTop"]();
	this["oList"]["children"][this["iSelectedItem"]]["className"] = 'lsPickerSliderItem lsPickerSliderItemSelected';
	this["selectionChange"]();
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlsup"] = 0; };

UCF_PickerSlider["prototype"]["onlspageup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlspageup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PickerSlider.js(584): onlspageup"); };
	if (!this["bCyclic"])
		return;
	this["iSelectedItem"] -= 10;
	if (this["iSelectedItem"] < 0)
		this["iSelectedItem"] += this["iListItems"];
	this["setScrollTop"]();
	this["oList"]["children"][this["iSelectedItem"]]["className"] = 'lsPickerSliderItem lsPickerSliderItemSelected';
	this["selectionChange"]();
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlspageup"] = 0; };

UCF_PickerSlider["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlsdown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PickerSlider.js(598): onlsdown"); };
	var iMax;
	this["iSelectedItem"]++;
	if (this["bCyclic"])
		iMax = 3 * this["iListItems"];
	else
		iMax = this["iListItems"];
	if (this["iSelectedItem"] >= iMax)
		this["iSelectedItem"] -= this["iListItems"];
	this["setScrollTop"]();
	this["oList"]["children"][this["iSelectedItem"]]["className"] = 'lsPickerSliderItem lsPickerSliderItemSelected';
	this["selectionChange"]();
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlsdown"] = 0; };

UCF_PickerSlider["prototype"]["onlspagedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlspagedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PickerSlider.js(615): onlspagedown"); };
	if (!this["bCyclic"])
		return;
	var iMax = 3 * this["iListItems"];
	this["iSelectedItem"] += 10;
	if (this["iSelectedItem"] >= iMax)
		this["iSelectedItem"] = iMax - 1;
	this["setScrollTop"]();
	this["oList"]["children"][this["iSelectedItem"]]["className"] = 'lsPickerSliderItem lsPickerSliderItemSelected';
	this["selectionChange"]();
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["onlspagedown"] = 0; };

UCF_PickerSlider["prototype"]["selectionChange"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["selectionChange"]++; }; 
	var sOptions = '';
	// eslint-disable-next-line no-unsanitized/property
	document["getElementById"](this["sId"] + '-valDescription')["innerHTML"] = this["sGetSelection"]()["value"];
	if (this["bCyclic"] === false && this["bComplete"] === false) {
		if (this["iSelectedItem"] <= this["iVisibleItems"])
			sOptions = ' { "InsertBefore": "' + this["oList"]["children"][0]["getAttribute"]('data-key') + '"}';
		else if (this["iSelectedItem"] >= this["aListItems"]["length"] - this["iVisibleItems"])
			sOptions = ' { "AppendAfter": "' + this["oList"]["children"][this["aListItems"]["length"] - 1]["getAttribute"]('data-key') + '"}';
	}
	this["fireEvent"](this["E_EVENTS"]["Change"], { "sId": this["sId"], "sValue": this["sGetSelection"]()["value"], "sKey": this["sGetSelection"]()["key"], "sOptions": sOptions });
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["selectionChange"] = 0; };

UCF_PickerSlider["prototype"]["initAfterRendering"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["initAfterRendering"]++; }; 
	this["setScrollTop"]();
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["initAfterRendering"] = 0; };

UCF_PickerSlider["prototype"]["setSelectedItem"] = function(iSelectedItem) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["setSelectedItem"]++; }; 
	this["iSelectedItem"] = iSelectedItem;
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["setSelectedItem"] = 0; };

UCF_PickerSlider["prototype"]["iGetItemHeightInPixel"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["iGetItemHeightInPixel"]++; }; 
	return document["getElementById"](this["sId"] + '-li0')["offsetHeight"];
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["iGetItemHeightInPixel"] = 0; };

UCF_PickerSlider["prototype"]["snap"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["snap"]++; }; 
	if (!this["iItemHeight"])
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iItemHeight"] = this["iGetItemHeightInPixel"]();
	this["iSelectedItem"] = parseInt(this["oScroller"]["scrollTop"] / this["iItemHeight"] + .5);
	if (this["bCyclic"])
		this["iSelectedItem"] += this["iVisibleItems"];
	this["setScrollTop"]();
	this["selectionChange"]();
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["snap"] = 0; };

UCF_PickerSlider["prototype"]["setScrollTop"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["setScrollTop"]++; }; 
	if (!this["oScroller"])
		return;
	if (!this["iItemHeight"])
		this["iItemHeight"] = this["iGetItemHeightInPixel"]();
	if (!this["bExpanded"]) {
		if (this["bCyclic"])
			this["oScroller"]["scrollTop"] = this["iItemHeight"] * this["iSelectedItem"];
		else
			this["oScroller"]["scrollTop"] = this["iItemHeight"] * (this["iSelectedItem"] + this["iVisibleItems"]);
	} else if (this["bCyclic"]) {
		if (this["iSelectedItem"] < this["iListItems"])
			this["iSelectedItem"] += this["iListItems"];
		else if (this["iSelectedItem"] > 2 * (this["iListItems"] + 1))
			this["iSelectedItem"] -= this["iListItems"];
		this["oScroller"]["scrollTop"] = this["iItemHeight"] * (this["iSelectedItem"] - this["iVisibleItems"]);
	} else
		this["oScroller"]["scrollTop"] = this["iItemHeight"] * (this["iSelectedItem"]);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["setScrollTop"] = 0; };

/**
 * insertBefore
 * insert list items at the begin
 * @param {Array} aValues
 */
UCF_PickerSlider["prototype"]["insertBefore"] = function(aValues) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["insertBefore"]++; }; 
	var oElement = document["getElementById"](this["sId"] + '-content');
	this["aListItems"] = aValues["concat"](this["aListItems"]);
	// eslint-disable-next-line no-unsanitized/property
	oElement["innerHTML"] = this["sGetListItemsHTML"]();
	this["iSelectedItem"] += aValues["length"];
	this["setScrollTop"]();
	for (var i = 0; i < aValues["length"]; i++) {
		if (aValues[i]["value"]["length"] > this["sLongest"]["length"])
			this["sLongest"] = aValues[i]["value"];
	}
	oElement = document["getElementById"](this["sId"]);
	if (oElement)
		oElement["setAttribute"]('data-widest-item', this["sLongest"]);
	this["iListItems"] = this["aListItems"]["length"];
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["insertBefore"] = 0; };

/**
 * appendAfter
 * append list items to the end
 * @param {Array} aValues
 */
UCF_PickerSlider["prototype"]["appendAfter"] = function(aValues) {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["appendAfter"]++; }; 
	var oElement = document["getElementById"](this["sId"] + '-content');
	this["aListItems"] = this["aListItems"]["concat"](aValues);
	// eslint-disable-next-line no-unsanitized/property
	oElement["innerHTML"] = this["sGetListItemsHTML"]();
	this["setScrollTop"]();
	for (var i = 0; i < aValues["length"]; i++) {
		if (aValues[i]["value"]["length"] > this["sLongest"]["length"])
			this["sLongest"]["length"] = aValues[i]["value"];
	}
	oElement = document["getElementById"](this["sId"]);
	if (oElement)
		oElement["setAttribute"]('data-widest-item', this["sLongest"]);
	this["iListItems"] = this["aListItems"]["length"];
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["appendAfter"] = 0; };

/**
 * sGetListItemsHTML
 * create the HTML used for the <li> elements
 * @return {string}
 */
UCF_PickerSlider["prototype"]["sGetListItemsHTML"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["sGetListItemsHTML"]++; }; 
	var sInnerHTML = "";
	sInnerHTML += '<li id="' + this["sId"] + '-li0" class="lsPickerSliderItem" index="0" data-key="' +
		this["aListItems"][0]["key"] + '" role="listitem" unselectable="on">' + this["aListItems"][0]["value"] + '</li>';
	for (var i = 1; i < this["aListItems"]["length"]; i++)
		sInnerHTML += '<li class="lsPickerSliderItem" index="' + i +
		'" data-key="' + this["aListItems"][i]["key"] + '" role="listitem" unselectable="on">' +
		this["aListItems"][i]["value"] + '</li>';
	return sInnerHTML;
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["sGetListItemsHTML"] = 0; };

/**
 * Detach Events and clear all objects references calls
 * @private
 */
UCF_PickerSlider["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["destroy"]++; }; 
	this["oParent"] = null;
	this["aListItems"] = null;
	this["oList"] = null;
	this["oScroller"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PickerSlider["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_PlaceHolder"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_FocusInfo */
/// <reference path="../../core/FocusInfo.js"/>

/**
 * Helper Class for all controls that need to survive roundtrips
 *
 * Following rules have to be taken care of for the rendering:
 * - Root container/content ids either "id-r"/"id" OR "id"/"id-o"
 * - A XMP as first child which contains HTML of the real control
 *
 * 
 *
 * @class
 * @param {UCF_LS} oLS
 * @param {HTMLElement} oDomRef
 */
function UCF_PlaceHolder(oLS, oDomRef) {if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["UCF_PlaceHolder"]++; }; 

	if (arguments["length"] === 0) return;

	UCF_Control["apply"](this, [oLS, oDomRef]);

	this["oPopupWindow"] = null;

	// Flag to control extra IE6-only specific handling. Destroying of DOM
	// has to be skipped otherwise iframe onunload is not fired.  see int CSN: 601001 2010
	this["bSkipDomDestroy"] = false;

	// lifecycle flags
	this["bKeepAlive"] = (this["sLifeCycle"] !== "BROWSER");
	this["bVisible"] = true;

	if (this["bKeepAlive"]) {

		if (this["oRootRef"]) {
			this["attachBrowserEvent"]("resize", this["oRootRef"]);
		}

		this["oContentRef"] = UCF_DomUtil["$"](this["sId"] + "-ph");
		this["oXMPRef"] = UCF_DomUtil["$"](this["sId"] + "-obj");
		this["sContent"] = this["oRootRef"]["firstChild"]["innerHTML"];

		var sScrollAreaId = this["oXMPRef"]["getAttribute"]("cid");
		this["oScrollAreaRef"] = sScrollAreaId ? UCF_DomUtil["$"](sScrollAreaId) : null;

		this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "update");
		var oPM = this["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]();
		if (oPM) {
			oPM["attachEvent"](oPM["E_EVENTS"]["PopupOpen"], this, 'update');
		}

		// For accessibility and TrackSwitches
		this["attachBrowserEvent"]("focusin", this["oContentRef"]);

		// attach extra handler for IE-6-only handling iframe onuload  - int. CSN 601001 2010
		if (UCF_UserAgent["bIsIE"](6, true)) {
			this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["BeforeDestroy"], this, "onLSBeforeDestroy");
		}
	}

};window["UCF_PlaceHolder"] = UCF_PlaceHolder; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PlaceHolder"); UCF_PlaceHolder["_"] = {UCF_PlaceHolder: 0}; }; ;
UCF_PlaceHolder["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PlaceHolder.prototype["sClassName"] = "UCF_PlaceHolder";

/**
 * Destructor
 */
UCF_PlaceHolder["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["destroy"]++; }; 

	if (UCF_UserAgent["bIsIE"](6, true)) {
		this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["BeforeDestroy"], this);
	}

	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this);
	var oPM = this["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]();
	if (oPM) {
		oPM["detachEvent"](oPM["E_EVENTS"]["PopupOpen"], this, 'update');
	}

	if (this["oRootRef"]) {
		this["detachBrowserEvent"]("resize", this["oRootRef"]);
	}
	// DIV-popup support -  see update()
	if (this["oPopupWindow"]) {
		this["oPopupWindow"]["detachEvent"](this["oPopupWindow"]["E_EVENTS"]["Move"], this);
		this["oPopupWindow"]["detachEvent"](this["oPopupWindow"]["E_EVENTS"]["Resize"], this);
		this["oPopupWindow"]["detachEvent"](this["oPopupWindow"]["E_EVENTS"]["MoveAndResize"], this);
	}

	// detach extra handler for IE-6-only handling iframe onuload  - int. CSN 601001 2010
	if (UCF_UserAgent["bIsIE"](6, true)) {
		this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["BeforeDestroy"], this, "onLSBeforeDestroy");
	}

	if (this["oContentRef"]) {
		this["detachBrowserEvent"]("focusin", this["oContentRef"]);
		var oParentRef = this["oContentRef"]["parentNode"];
		if (oParentRef) {

			if (!this["bSkipDomDestroy"]) {
				oParentRef["removeChild"](this["oContentRef"]);
			}
			this["oContentRef"] = null;
		}
	}

	this["oXMPRef"] = null;
	this["sContent"] = null;
	this["oScrollAreaRef"] = null;
	this["oPopupWindow"] = null;
	this["oRootRectBackup"] = null;
	this["bKeepAlive"] = false;

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["destroy"] = 0; };

/**
 *  When LS is being destoyed and extra handling for IE-6 gets activated
 * @param {UCF_Event} oEvent
 */
UCF_PlaceHolder["prototype"]["onLSBeforeDestroy"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["onLSBeforeDestroy"]++; }; 
	this["bSkipDomDestroy"] = true;
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["onLSBeforeDestroy"] = 0; };

/**
 * When initializes update the position of the content div
 */
UCF_PlaceHolder["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["initialize"]++; }; 

	if (this["oContentRef"]) {
		this["update"]();

		// Workaround FireFox update issue. See external OSS 0120050409 0000016081 2015
		// DOM is not painted and calucalted but the Placeholder position initialization has been triggred before the right
		// dimensions have been established. This leads sometimes to a wrong caluclated position.
		// Oms delayed did not succeed. "MozAfterPaint" event has to be activated by browser preferences which is also no option.
		// Desperate trial:
		if (UCF_UserAgent["bIsFirefox"]()) {
			UCF_JsUtil["delayedCall"](500, this, "update"); //Ignition 1
			UCF_JsUtil["delayedCall"](1000, this, "update"); //Ignition 2
			UCF_JsUtil["delayedCall"](2000, this, "update"); //Ignition 3
			UCF_JsUtil["delayedCall"](4000, this, "update"); //Ignition 4
		}
	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["initialize"] = 0; };

/**
 * Determine the root reference of the Placeholder control
 *
 * @return {HTMLElement} the root reference of the Placeholder control
 */
UCF_PlaceHolder["prototype"]["oGetRootRef"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["oGetRootRef"]++; }; 
	var oObjectRef = UCF_DomUtil["$"](this["sId"] + "-o");
	return oObjectRef ? UCF_DomUtil["$"](this["sId"]) : UCF_DomUtil["$"](this["sId"] + "-r");
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["oGetRootRef"] = 0; };

/**
 * Determine the object reference of the Placeholder control
 * @return {HTMLElement}
 */
UCF_PlaceHolder["prototype"]["oGetObjectRef"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["oGetObjectRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + "-o") || UCF_DomUtil["$"](this["sId"]);
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["oGetObjectRef"] = 0; };

/**
 * Reconnects the control to its DOM representation, used for keepalive controls
 */
UCF_PlaceHolder["prototype"]["reconnectToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["reconnectToDom"]++; }; 

	if (this["oContentRef"]) {

		if (this["oRootRef"]) {
			this["detachBrowserEvent"]("resize", this["oRootRef"]);
		}

		var oDomRef = UCF_DomUtil["$"](this["sId"]),
			oRootRef = this["oGetRootRef"]();

		if (oRootRef) {
			this["setDefaultValues"]();
			this["connectToDom"](oDomRef);
			this["attachBrowserEvent"]("resize", this["oRootRef"]);
		} else {
			this["hidePlaceholder"]();
			this["oRootRef"] = null;
		}

	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["reconnectToDom"] = 0; };

/**
 * @see UCF_Control
 * @param {UCF_FocusInfo} oFocusInfo
 */
UCF_PlaceHolder["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "PlaceHolder.js(209): collectFocusInfo"); };

	oFocusInfo["setApplyControl"](this);
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["collectFocusInfo"] = 0; };

/**
 * @see UCF_Control
 * @param { UCF_FocusInfo } oFocusInfo
 */
UCF_PlaceHolder["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "PlaceHolder.js(219): applyFocusInfo"); };
	// if the Placeholder control has already the focus in keepAlive mode then avoid setting an additional focus because the browser
	// scrolls the control completely into view port. The page "jitters". Placeholder controls are usually quite big controls. Therefore
	// the effect is dominant.

	if (!this["bKeepAlive"] || UCF_DomUtil["oGetActiveElement"]() !== this["oFocusDomRef"]) {
		this["focus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["applyFocusInfo"] = 0; };

/**
 * Returns whether the control should be kept alive.
 * In case of keep alive, check whether content has changed
 *
 * @return {boolean}
 */
UCF_PlaceHolder["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["bDoKeepAlive"]++; }; 

	// In case of scrollcontainers the content div may get lost
	var oContentRef = UCF_DomUtil["$"](this["sId"] + "-ph");

	if (this["bKeepAlive"] && oContentRef) {
		var oNewRootRef = this["oGetRootRef"]();
		if (oNewRootRef) {
			// if there is a new control with same id compare the content
			var sNewContent = oNewRootRef["firstChild"]["innerHTML"];
			return (this["sContent"] === sNewContent);
		} else {
			// if no new control is sent, only keep alive if set to MANUAL
			return (this["sLifeCycle"] === "MANUAL");
		}
	}
	return false;

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["bDoKeepAlive"] = 0; };

/**
 * When resized update the position
 */
UCF_PlaceHolder["prototype"]["onresize"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["onresize"]++; }; 

	if (this["oContentRef"]) {
		this["update"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["onresize"] = 0; };

/**
 * Checks if the control has a valid DOM reference.
 * For PlaceHolder the relevant element to check is the root
 * reference, as the control itself is never removed
 *
 * @return {boolean} Whether the control has a valid DOM reference
 */
UCF_PlaceHolder["prototype"]["bIsValid"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["bIsValid"]++; }; 

	if (this["oContentRef"]) {
		if (!UCF_DomUtil["bIsInActiveDom"](this["oDomRef"])) return false;
		var oRootRef = this["oGetRootRef"]();
		return (oRootRef != null && oRootRef === this["oRootRef"]);
	} else {
		return UCF_Control.prototype["bIsValid"]["apply"](this, arguments);
	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["bIsValid"] = 0; };

/**
 * Calculate position of the root element and place the content on top of it
 * @param {UCF_Event} [oEvent] The internal event, if called as event handler
 */
UCF_PlaceHolder["prototype"]["update"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["update"]++; }; 

	if (!this["oRootRef"] || UCF_DomUtil["sGetCurrentStyle"](this["oRootRef"], 'visibility') === 'hidden') {
		this["hidePlaceholder"]();
		this["bVisible"] = false;
		return;
	} else {
		this["bVisible"] = true;
	}

	var oRootRect = UCF_DomUtil["oGetObjectRect"](this["oRootRef"], this["oScrollAreaRef"]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "top:" + oRootRect["top"] + "; left:" + oRootRect["left"] + "; height:" + oRootRect["height"] + "; width:" + oRootRect["width"], "PlaceHolder.js(300): update"); };

	// if running in a scrollcontainer, where a padding is defined, the padding has to be substracted
	// from the top and left position, as relative positioning is used inside the scrollcontainer
	if (this["oScrollAreaRef"] && this["oScrollAreaRef"]["currentStyle"]) {
		var iPaddingTop = parseInt(this["oScrollAreaRef"]["currentStyle"]["paddingTop"]) || 0,
			iPaddingLeft = parseInt(this["oScrollAreaRef"]["currentStyle"]["paddingLeft"]) || 0;
		oRootRect["top"] -= iPaddingTop;
		oRootRect["left"] -= iPaddingLeft;
	}

	if (!UCF_UserAgent["bIsFirefox"]() && (oRootRect["height"] === 0 || (oRootRect["top"] + oRootRect["height"]) < 0)) {
		this["hidePlaceholder"]();
		return;
	}

	// Support modal DIV-popups in WDA: Workaround for z-index. We support only a single Popup with PH inside.
	// The following code is not possible during createContent() because it is called in ControlFactory before the constructor(!)
	if (this["oPopupWindow"] === null && UCF_DomUtil["bContains"](this["oLS"]["oGetStaticAreaRef"](), this["oContentRef"])) {
		var oPW = this["oGetParentPopupWindow"](this["oXMPRef"]);
		// Note: bIsModalDivPopup() returns null if Popup is not yet initialized (e.g. during purge by an update the PH maybe purged before the Popup)
		// Note: z-index is not calculated although PW is initialized and PopupManager.register() was called because of the WDA-ID-order workaaround(!)
		//       => do NOT store this.oPopupWindow yet, update will be called again on PopupManager.OpenPopup event
		if (oPW && oPW["bIsModalDivPopup"]() === true && !isNaN(oPW["iGetZIndex"]())) {
			this["oPopupWindow"] = oPW;
			oPW["attachEvent"](oPW["E_EVENTS"]["Move"], this, "update");
			oPW["attachEvent"](oPW["E_EVENTS"]["Resize"], this, "update");
			oPW["attachEvent"](oPW["E_EVENTS"]["MoveAndResize"], this, "update"); // fired by maximize/restore
			this["oRootRectBackup"] = oRootRect;
		}
	}

	// Support for modal DIV-popups:
	// Adapt size of root container when PopupWindow is resized
	if (this["oPopupWindow"]) {
		// For IFrame, rely on the internal "resize" event notification
		// instead of events and calculations from the Popup...
		// see: UCF_IFrame.onresize() which calls _super() !!
		if (this["sClassName"] !== 'UCF_Iframe') {
			var oParam = oEvent ? oEvent["mGetParameters"]() : null;
			var bInitial = oEvent && oEvent["oGetParam"] ? oEvent["oGetParam"]("sSourceClassName") === "UCF_PageUpdater" : false;
			// Internal Resize-event from Popup has this parameter
			var oCntSize = oParam ? oParam["ContentInnerSize"] : null;
			// PopupOpen event from PopupManager: Ask popup directly about inner content size
			if (!oCntSize) oCntSize = this["oPopupWindow"]["oPWDimensions"] ? this["oPopupWindow"]["oPWDimensions"]["oGetContentInnerSize"]() : this["oPopupWindow"]["oGetContentInnerSize"]();
			if (oCntSize) {
				if (this["oRootRef"]["style"]["width"]["indexOf"]('%') === -1) {
					if (this["sClassName"] === 'UCF_PDFContainer' ||
						bInitial || oCntSize["width"] < this["oRootRectBackup"]["width"]) {
						oRootRect["width"] = oCntSize["width"];
					} else {
						oRootRect["width"] = this["oRootRectBackup"]["width"];
					}
					this["oRootRef"]["style"]["width"] = oRootRect["width"] + "px";
				}
				if (this["oRootRef"]["style"]["height"]["indexOf"]('%') === -1) {
					if (this["sClassName"] === 'UCF_PDFContainer' || bInitial || oCntSize["height"] < this["oRootRectBackup"]["height"]) {
						oRootRect["height"] = oCntSize["height"];
					} else {
						oRootRect["height"] = this["oRootRectBackup"]["height"];
					}
					this["oRootRef"]["style"]["height"] = oRootRect["height"] + "px";
				}
			}
		}
		this["oContentRef"]["style"]["zIndex"] = this["oPopupWindow"]["iGetZIndex"]() + 10;
	}

	for (var i in oRootRect) {
		this["oContentRef"]["style"][i] = oRootRect[i] + "px";
		// Works without this for IFrame (?)
		// if (this.oPopupWindow && this.sClassName === 'UCF_Iframe') {
		// 	this.oRootRef.style[i] = oRootRect[i] + "px";
		// }
	}

	// IE does not size iframe smaller than 150px, if height is set to 100%
	if ((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && this["oDomRef"]["tagName"] === "IFRAME") {
		this["oDomRef"]["style"]["height"] = oRootRect["height"] + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["update"] = 0; };


/**
 * Hide the content control by positioning it at top -10000px
 */
UCF_PlaceHolder["prototype"]["hidePlaceholder"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["hidePlaceholder"]++; }; 
	if (this["oContentRef"]) {
		this["oContentRef"]["style"]["top"] = "-10000px";
	}
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["hidePlaceholder"] = 0; };

/**
 * Hides the content control
 */
UCF_PlaceHolder["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["hide"]++; }; 
	if (this["oContentRef"]) {
		this["oContentRef"]["style"]["top"] = "-10000px";
	}
	UCF_Control.prototype["hide"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["hide"] = 0; };

/**
 * Shows the  control
 */
UCF_PlaceHolder["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["show"]++; }; 
	UCF_Control.prototype["show"]["apply"](this, arguments);
	if (this["oContentRef"]) {
		this["update"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["show"] = 0; };

/**
 * Set flag to keep the control alive, even if it is not visible on the screen
 *
 * @param {boolean} bKeepAlive
 * @public
 */
UCF_PlaceHolder["prototype"]["setKeepAlive"] = function(bKeepAlive) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["setKeepAlive"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["sLifeCycle"] === "MANUAL", "this.sLifeCycle === \"MANUAL\"", "PlaceHolder.js(420): setKeepAlive"); };

	if (this["sLifeCycle"] === "MANUAL") {
		this["bKeepAlive"] = bKeepAlive;
		if (!bKeepAlive) {
			UCF_JsUtil["delayedCall"](0, this["oLS"]["oControlFactory"], "purgeControl", [this]);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["setKeepAlive"] = 0; };

/**
 * Create the placeholder content.
 * This method is called by the ControlFactory.
 *
 * @param {string} sId
 * @param {element} oXMPRef
 * @param {element} oStaticAreaRef
 *
 */
UCF_PlaceHolder["createContent"] = function(sId, oXMPRef, oStaticAreaRef) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["createContent"]++; }; 
	var oScrollRef = null,
		oContentRef = document["createElement"]("div");

	oContentRef["setAttribute"]("id", sId + "-ph");
	oContentRef["style"]["overflow"] = "hidden";

	{
		// Loop up the DOM and look for a LS scroll container (-scrl)
		var oDomRef = oXMPRef,
			sScrollId;

		while (oDomRef && oDomRef !== document) {
			sScrollId = oDomRef["getAttribute"]("id");
			// important to check overflow because -scrl is used
			// by several controls for overflow=visible (default) -> see also int. 525773 2010
			if (sScrollId && sScrollId["indexOf"]("-scrl") > 0 && UCF_DomUtil["sGetCurrentStyle"](oDomRef, "overflow") !== "visible") {
				oScrollRef = oDomRef;
				break;
			}
			oDomRef = oDomRef["parentNode"];
		}
	}

	if (oScrollRef) {
		sScrollId = oScrollRef["getAttribute"]("id");
		if (!sScrollId) {
			sScrollId = sId + "-" + UCF_JsUtil["iGetTimeStamp"]();
			oScrollRef["setAttribute"]("id", sScrollId);
		}
		oXMPRef["setAttribute"]("cid", sScrollId);
	}

	UCF_DomUtil["oAddLayeredElement"](oContentRef, oStaticAreaRef, oScrollRef, true);

	// Temporary HACK BEGIN :: APPLET & Placeholder PZ:----
	var sMarkup = oXMPRef["innerHTML"];
	var iCt = sMarkup["indexOf"]('ct=\"AP\"');
	var iLsevents = sMarkup["indexOf"]("lsevents=");

	if (iCt >= 0 && iLsevents < 0) {
		// add missing attributes ti & lsevents
		sMarkup = sMarkup["substring"](0, iCt + 7)
			+ " ti=\"0\" lsevents={} "
			+ sMarkup["substring"](iCt + 7);
	}
	// sMarkup is extracted from contents coming from the server response
	UCF_DomUtil["setInnerHtml"](oContentRef, sMarkup);
	// UCF_DomUtil.setInnerHtml(oContentRef, oXMPRef.innerHTML);
	// Temporary HACK END :: APPLET & Placeholder PZ:----
};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["createContent"] = 0; };

/**
 * Sets the visibility for a control
 * @param {string} sVisibility The visibility of the control "BLANK", "NONE","VISIBLE"
 * @public
 */
UCF_PlaceHolder["prototype"]["setVisibility"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["setVisibility"]++; }; 
	UCF_Control.prototype["setVisibility"]["apply"](this, arguments);
	if (this["oContentRef"]) {
		UCF_DomUtil["setVisibility"](this["oContentRef"], sVisibility);
		this["update"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PlaceHolder["_"]["setVisibility"] = 0; };


UCF_PlaceHolder.prototype["aPublicMethods"] = ["setKeepAlive","setVisibility"].concat(UCF_PlaceHolder.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PopIn"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PopIn(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PopIn["_"]["UCF_PopIn"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PopIn.js(23): UCF_PopIn"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PopIn.js(24): UCF_PopIn"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PopIn.js(25): UCF_PopIn"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	if (window["UCF_System"]["bIs508"]) {
		this["oFocusDomRef"] = this["oDomRef"];
	} else {
		var oDomRefCloseButton = UCF_DomUtil["$"](this["sId"] + "-" + this["SUFFIX"]["CLOSE_BUTTON"]);
		if (oDomRefCloseButton) this["oFocusDomRef"] = oDomRefCloseButton;
	}
};window["UCF_PopIn"] = UCF_PopIn; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopIn"); UCF_PopIn["_"] = {UCF_PopIn: 0}; }; ;
UCF_PopIn["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PopIn.prototype["sClassName"] = "UCF_PopIn";

UCF_PopIn["prototype"]["SUFFIX"] = {
	"CLOSE_BUTTON": "close",
	"TITLE": "title",
	"END": "end"
};

/**
 * Handles the onclick event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_PopIn["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopIn.js(51): onclick"); };
	this["close"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["onclick"] = 0; };

/**
 * Handles the keydown event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_PopIn["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopIn.js(62): onlsselect"); };
	this["close"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["onlsselect"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PopIn["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PopIn["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["onlsskipback"] = 0; };

/**
 * Fires the close event
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PopIn["prototype"]["close"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["close"]++; }; 
	if (this["bHasCloseIcon"]) {
		var sId = oBrowserEvent["oGetSource"]()["getAttribute"]("id");

		if (sId && sId["indexOf"]("-cl") > -1) {
			this["fireClose"](this["sId"]);
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["close"] = 0; };

/**
 * Apply ACC helper object
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_PopIn["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopIn.js(109): onlsaccessibility"); };
	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSource = oBrowserEvent["oGetSource"]();

	if (oSource["id"]["indexOf"]("-" + this["SUFFIX"]["END"]) > -1) {
		oAccessibilityHelper["setControlType"]("PI_END");
	} else if (oSource["id"]["indexOf"]("-" + this["SUFFIX"]["CLOSE_BUTTON"]) > -1) {
		oAccessibilityHelper["setControlType"]("PI_CLB");
		oAccessibilityHelper["addTutor"]("B_TUT");
	} else {
		oAccessibilityHelper["setControlType"]("PI");

		if (this["sTitleAreaDesign"] === "ERROR") {
			oAccessibilityHelper["setError"](true);
		} else if (this["sTitleAreaDesign"] === "CRITICAL") {
			oAccessibilityHelper["setWarning"](true);
		}

		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		var sTitleRef = UCF_DomUtil["$"](this["sId"] + "-" + this["SUFFIX"]["TITLE"]);
		if (sTitleRef) oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](sTitleRef));
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
		oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PopIn["prototype"]["aAttributeNames"] = ["sTitleAreaDesign","bHasCloseIcon","sAccessibilityDescription","sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PopIn["prototype"]["aEventNames"] = ["Close"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PopIn["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.PopInTitleAreaDesign}
 */
UCF_PopIn["prototype"]["sTitleAreaDesign"] = "TEXT";

/**
 * @private
 * @type {boolean}
 */
UCF_PopIn["prototype"]["bHasCloseIcon"] = true;

/**
 * @private
 * @type {string}
 */
UCF_PopIn["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_PopIn["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_PopIn["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PopIn["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["setDefaultValues"]++; }; 
	this["sTitleAreaDesign"] = "TEXT";
	this["bHasCloseIcon"] = true;
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("TitleAreaDesign", "TEXT", true);
		this["setClientProperty"]("HasCloseIcon", true, true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires PopIn::Close
 */
UCF_PopIn["prototype"]["fireClose"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["fireClose"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "PopIn.js(216): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopIn.js(217): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopIn.js(218): fireClose"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("PopIn", "Close", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopIn["_"]["fireClose"] = 0; };

};
sap["ls"]["preload"]["UCF_PopoverContainer"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PopoverContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["UCF_PopoverContainer"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PopoverContainer.js(25): UCF_PopoverContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PopoverContainer.js(26): UCF_PopoverContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PopoverContainer.js(27): UCF_PopoverContainer"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	//initialize the default button for this control
	this["setDefaultButtonId"](this["sDefaultButtonId"]);

};window["UCF_PopoverContainer"] = UCF_PopoverContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopoverContainer"); UCF_PopoverContainer["_"] = {UCF_PopoverContainer: 0}; }; ;
UCF_PopoverContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PopoverContainer.prototype["sClassName"] = "UCF_PopoverContainer";

/**
 * @private
 */
UCF_PopoverContainer["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["initialize"]++; }; };;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["initialize"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_PopoverContainer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["destroy"] = 0; };

/**
 * Handle hotkey events
 *
 * @param {UCF_Event} oBrowserEvent
 * @private
 */
UCF_PopoverContainer["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["onlshotkey"]++; }; 

	if (this["sHotkeysId"] === '') return;

	var oHotkeys = this["oGetControlById"](this["sHotkeysId"]),
		oHotkey = null;
	if (oHotkeys == null) return;

	oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["onlshotkey"] = 0; };

/**
 * Handle keypress events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PopoverContainer["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]("UCF_Hotkeys")["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["onkeypress"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 * @public
 */
UCF_PopoverContainer["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["setDefaultButtonId"]++; }; 
	UCF_Control.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["setDefaultButtonId"] = 0; };

/**
 * Handle mouseover events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PopoverContainer["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["onmouseover"]++; }; 

	// Tooltip for hidden overflow
	// the check will be done also in 509, because the title is not in tabChain
	var oTitleDomRef = UCF_DomUtil["$"](this["sId"] + '-header-title');
	if (!oTitleDomRef || oBrowserEvent["oGetSource"]() !== oTitleDomRef) return;
	UCF_DomUtil["checkTooltip"](oTitleDomRef, '', oTitleDomRef);
};;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["onmouseover"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PopoverContainer["prototype"]["aAttributeNames"] = ["sCustomData","sDefaultButtonId","sHotkeysId","sTooltip"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PopoverContainer["prototype"]["aEventNames"] = ["Hotkey"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PopoverContainer["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_PopoverContainer["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PopoverContainer["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PopoverContainer["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PopoverContainer["prototype"]["sTooltip"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PopoverContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';
	this["sDefaultButtonId"] = '';
	this["sHotkeysId"] = '';
	this["sTooltip"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("Tooltip", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires PopoverContainer::Hotkey
 */
UCF_PopoverContainer["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PopoverContainer.js(191): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopoverContainer.js(192): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopoverContainer.js(193): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "PopoverContainer.js(194): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "PopoverContainer.js(195): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "PopoverContainer.js(196): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "PopoverContainer.js(197): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	
	if (sProviderId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sProviderId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ProviderId");
			}
		}
	this["fireSemanticEvent"]("PopoverContainer", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopoverContainer["_"]["fireHotkey"] = 0; };

UCF_PopoverContainer.prototype["aPublicMethods"] = ["setDefaultButtonId"].concat(UCF_PopoverContainer.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PopupBase"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_ScrollArea */
/// <reference path="../controls/base/ScrollArea.js"/>
/* global UCF_Hotkeys */
/// <reference path="../controls/Hotkeys.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_PopupWindow */
/// <reference path="../controls/PopupWindow.js"/>

/**
 * A base class for popup controls:
 * 1. handles conversation with the PopupManager and lifecycle.
 * 2. manages a BlindLayer - only if active content is found on the page.
 * 3. fires BrowserWindow's "LayerHidden" and "LayerVisible" events (needed by Placeholder controls).
 * 4. handles hotkeys (if "HotKeysId" parameter defined in interface).
 * 5. sets the default button ID if a parameter "DefaultButtonId" is defined.
 * 6. Implements client-side close() method
 * 7. contains a UCF_ScrollArea to manage drag-scrolling and restoring of the scroll-position after a page update
 * 8. Sets this.bKeepAlive = true
 *
 * Rules for derived controls:
 * - control interface should have a parameter "Mode" of type Mode. Otherwise the default is "MODAL"
 * - renderer must use <code>position:absolute</code> or <code>position:static</code> on this.oDomRef element and it should be initially invisible.
 * - the methods {@link UCF_PopupBase#show} and {@link UCF_PopupBase#hide} must be implemented and must contain coding to make the popup visible/invisible and position it.
 * - control implementation must call <code>this.updatePosition()</code> or <code>this.updateSize()</code> when popup is moved or resized.
 * - There should be no need to overwrite the <code>initialize()</code> or <code>close()</code> methods. If this is done, <code>_super()</code> must be called.
 * - control should overwrite oGetScrollAreaRoot()
 * Optional:
 * - It may be required to handle LayoutChange events
 * - Control interface may define a "Close" event
 *
 * Implementation examples: 1. SidePopup 2. PopupWindow_standards
 *
 * Usage notes:
 *
 * A popup MUST be placed inside the associated area of the Page.
 * <pre>
 * 	var oPopup = oLS.oCreateClientControl('MyPopup', sId, ...);
 *	oPopup.setContent(...);
 *	oPopup.placeAt(oLS.oGetAssociatedAreaRef());
 * </pre>
 *
 * A popup instance is closed by:
 * - calling its UCF interface method <code>close()</code>.
 * - calling <code>UCF_PopupManager.closePopup(sId)</code> or <code>UCF_PopupManager.closeAllPopups()</code>.
 * - By a page update that removes the control from the DOM.
 *
 * Calling one of the close-functions does not remove the control from the DOM.
 * If the control is client-side-rendered it can be removed from the DOM by calling <code>UCF_ClientControl.destroy()</code> and <code>UCF_PopupWindow.destroy()</code>.
 *
 * @class
 * @extends UCF_PopupWindow
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS LS instance
 */
function UCF_PopupBase(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["UCF_PopupBase"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PopupBase.js(68): UCF_PopupBase"); };

		UCF_PopupWindow["apply"](this, [oDomRef, oLS]);

		/** @type {UCF_PopupManager} */
		this["oPopupManager"] = oLS["oGetMainLS"]()["oGetPopupManagerInternal"]();

		this["oBlindLayer"] = null;
		this["bIsDivPopup"] = true;
		this["bKeepAlive"] = true; // See UCF_Control.bKeepAlive()

		/** @type {HTMLElement} */
		this["oContainer"] = this["oDomRef"];

		if (this["sMode"] === undefined) {
			this["sMode"] = 'MODAL'; // eslint-disable-line @ur/no-missing-setClientProperty
		}

		var oSAR = this["oGetScrollAreaRoot"]();
		/** @type {UCF_SCrollArea} */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["oScrollArea"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(oSAR);
		this["oScrollArea"]["enableDragScrolling"](true);
		this["oScrollArea"]["attachEvent"](this["oScrollArea"]["E_EVENTS"]["Scroll"], this, "onAreaScroll");
		this["addDelegate"](this["oScrollArea"]);

		/** @type {Object} */
		this["oContentScrollPosition"] = null;

		this["bInitialized"] = false;
		this["bClosed"] = false;
		this["sWaitForCloseAnimationTimerId"] = null;

		///** @type {MutationObserver} */
		//this.oMutationObserver = null;

		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (this["fireClose"]) === 'function', "typeof (this.fireClose) === 'function'", "PopupBase.js(104): UCF_PopupBase"); };
	}
};window["UCF_PopupBase"] = UCF_PopupBase; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopupBase"); UCF_PopupBase["_"] = {UCF_PopupBase: 0}; }; ;
UCF_PopupBase["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PopupWindow"))(); UCF_PopupBase.prototype["sClassName"] = "UCF_PopupBase";

/**
 * Returns false
 * @return {boolean}
 * @public
 */
UCF_PopupBase["prototype"]["bIsIFramePopup"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["bIsIFramePopup"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["bIsIFramePopup"] = 0; };


/**
 * Stores scroll position to restore it after a page update - in initialize().
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_PopupBase["prototype"]["onAreaScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["onAreaScroll"]++; }; 
	this["oContentScrollPosition"] = {
		"iScrollLeft": oEvent["oGetParam"]("iScrollLeft"),
		"iScrollTop": oEvent["oGetParam"]("iScrollTop")
	};
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["onAreaScroll"] = 0; };

/**
 * @private
 */
UCF_PopupBase["prototype"]["restoreScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["restoreScrollPosition"]++; }; 
	if (this["oContentScrollPosition"]) {
		this["oDomRef"]["scrollLeft"] = this["oContentScrollPosition"]["iScrollLeft"];
		this["oDomRef"]["scrollTop"] = this["oContentScrollPosition"]["iScrollTop"];
	}
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["restoreScrollPosition"] = 0; };

/**
 * Returns the root DOM element for the UCF_ScrollArea
 * @return {HTMLElement}
 * @overwrite
 */
UCF_PopupBase["prototype"]["oGetScrollAreaRoot"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["oGetScrollAreaRoot"]++; }; 
	return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["oGetScrollAreaRoot"] = 0; };

UCF_PopupBase["prototype"]["reconnectToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["reconnectToDom"]++; }; 
	this["oGetScrollAreaRoot"]()["setAttribute"]('lsscrl', 'true');
	UCF_PopupWindow.prototype["reconnectToDom"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["reconnectToDom"] = 0; };

/**
 * Hotkey-support: Capture kedyboard-events in so they are not
 * dispatched to the BODY-element of the Page.
 * @private
 */
UCF_PopupBase["prototype"]["captureHotkeys"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["captureHotkeys"]++; }; 
	if (this["sMode"] === 'MODAL') {
		UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
		this["oDomRef"]["style"]["outline"] = 'none';
	}
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["captureHotkeys"] = 0; };

/**
 * Implements UCF_Control initialize function.
 * @private
 */
UCF_PopupBase["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["initialize"]++; }; 
	if (!this["bInitialized"]) {
		if (this["sDefaultButtonId"]) {
			this["setDefaultButtonId"](this["sDefaultButtonId"]);
		}
		this["captureHotkeys"]();
		this["oPopupManager"]["addPopup"](window, this["sId"], this["sMode"], this["oDomRef"], null, true);
		this["oPopupManager"]["register"](this);
		this["updateBlindLayer"]();
		this["show"]();
		this["updateBlindLayer"]();
		this["oLS"]["oBrowserWindow"]["notifyLayerVisible"]();

		this["bInitialized"] = true;
	}
	else {
		// Update scroll-area helper
		var oSAR = this["oGetScrollAreaRoot"]();
		this["detachBrowserEvent"]("scroll", this["oScrollArea"]["oDomRef"]);
		this["oScrollArea"]["oDomRef"] = oSAR;
		this["attachBrowserEvent"]("scroll", oSAR);

		this["captureHotkeys"]();
		this["oPopupManager"]["updatePopup"](this);
		this["oPopupManager"]["updateZIndices"](this);
		this["updateBlindLayer"]();
		this["update"]();
		this["updateBlindLayer"]();
		this["oLS"]["oBrowserWindow"]["notifyLayerVisible"]();
		this["restoreScrollPosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["initialize"] = 0; };

/**
 * Close this popup. It is not removed from the DOM. It has to be removed afterwards by re-rendering:
 * a) apply a page update that deletes it in the DOM b) client-side-rendering, e.g. calling {@link UCF_ClientElement#destroy}
 * @public
 */
UCF_PopupBase["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["close"]++; }; 
	/** @type {UCF_PopupBase} */
	var _this = this;
	var bAnimationEnd = false;

	var onClose = function() {
		if (_this["bIsDestroyed"]) return;
		if (_this["bClosed"]) return;

		_this["oPopupManager"]["unregister"](_this["sId"]);
		_this["oLS"]["oBrowserWindow"]["notifyLayerHidden"]();
		if (_this["oBlindLayer"]) _this["oLS"]["releaseBlindLayer"](_this["oBlindLayer"]);

		_this["bClosed"] = true;
	};

	var handleCloseAnimation = function() {
		bAnimationEnd = true;
		UCF_DomUtil["detachEvent"](_this["oDomRef"], 'animationend', handleCloseAnimation);
		if (typeof (_this["fOnAnimationEnd"]) === 'function') _this["fOnAnimationEnd"]();
		onClose();
	};

	UCF_DomUtil["attachEvent"](this["oDomRef"], 'animationend', handleCloseAnimation);
	this["fOnAnimationEnd"] = this["hide"]();

	this["sWaitForCloseAnimationTimerId"] = setTimeout(function() {
		if (!bAnimationEnd) {
			onClose();
		}
		clearTimeout(_this["sWaitForCloseAnimationTimerId"]);
	}, 250);

	// if (!__UCF_IE6__) {
	// 	this.oMutationObserver = new MutationObserver(function(/** @type {MutationRecords} */ oRecords, /** @type {MutationObserver} */ o) {
	// 		for (var j = 0; j < oRecords.length; j++) {
	// 			var oRecord = oRecords[j];
	// 			if (oRecord.removedNodes) {
	// 				for (var i = 0; i < oRecord.removedNodes.length; i++) {
	// 					if (oRecord.removedNodes[i].id === _this.oDomRef.id) {
	// 						onClose();
	// 						o.disconnect();
	// 					}
	// 				}
	// 			}
	// 		}
	// 	});
	// 	this.oMutationObserver.observe(UCF_DomUtil.oGetParentElement(this.oDomRef), { childList: true });
	// }
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["close"] = 0; };

/**
 * Implementation must show and position the popup.
 * @abstract
 */
UCF_PopupBase["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["show"]++; };  };;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["show"] = 0; };

/**
 * Implementation must hide the popup (but not remove it from the DOM)
 * @return {function|null} Optional callback for 'animationend' if an CSS animation on this.oDomRef is started by the implementation.
 * @abstract
 */
UCF_PopupBase["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["hide"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["hide"] = 0; };

/**
 * Implementation must do what needs to be done when the popup was re-rendered/changed by a page-update
 * - see initialize() implementation.
 * @abstract
 */
UCF_PopupBase["prototype"]["update"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["update"]++; };  };;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["update"] = 0; };

/**
 * This method must be called by the implementation whenever the popup position has changed.
 */
UCF_PopupBase["prototype"]["updatePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["updatePosition"]++; }; 
	this["updateBlindLayer"]();
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["updatePosition"] = 0; };

/**
 * This method must be called by the implementation whenever the popup size has changed.
 */
UCF_PopupBase["prototype"]["updateSize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["updateSize"]++; }; 
	this["updateBlindLayer"]();
	this["notifyLayoutChangeFrom"]();
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["updateSize"] = 0; };

// TODO: notifyContentUpdate() - Find out where (webgui?) and why this is used
/**
 * Implementation is optional. Called by UCF_PopupManager public function notifyContentUpdate()
 * @abstract
 */
UCF_PopupBase["prototype"]["updateDimensions"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["updateDimensions"]++; };  };;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["updateDimensions"] = 0; };

UCF_PopupBase["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["destroy"]++; }; 
	if (this["oLS"] == null || this["bIsDestroyed"]) return;

	// Unregister if close() was not called
	// to make sure the block layer is removed (in PopupManager.updateZIndices()).
	if (!this["oLS"]["bIsDestroyed"]) {
		this["oPopupManager"]["unregister"](this["sId"]);
	}

	// In WDA close() may not be called for DIV-popups before destroy
	// We need to fire this internal event for ACF components to "unfreeze"
	this["oLS"]["oBrowserWindow"]["notifyLayerHidden"]();

	if (this["oBlindLayer"]) {
		// In WebGUI it may happen that a DIV-popup gets server-side rendered,
		// initialized and then re-rendered with client-side-rendering
		// (before it gets visible and without calling close)
		this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
		this["oBlindLayer"] = null;
	}

	this["oContentScrollPosition"] = null;
	this["oPopupManager"] = null;
	this["oContainer"] = null;
	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}

	this["fOnAnimationEnd"] = null;
	if (this["sWaitForCloseAnimationTimerId"]) {
		clearTimeout(this["sWaitForCloseAnimationTimerId"]);
		this["sWaitForCloseAnimationTimerId"] = null;
	}
	// if (this.oMutationObserver) {
	// 	try {
	// 		this.oMutationObserver.disconnect();
	// 	}
	// 	catch (e) {
	// 		// ignore
	// 	}
	// 	this.oMutationObserver = null;
	// }
	UCF_PopupWindow.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["destroy"] = 0; };

/**
 * Handle blind-layer for popups when active components are used.
 * Must be called when the popup is moved or resized.
 * @private
 */
UCF_PopupBase["prototype"]["updateBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["updateBlindLayer"]++; }; 
	if (!UCF_DomUtil["bContainsActiveComponent"]()) return;
	this["oBlindLayer"] = this["oBlindLayer"] || this["oLS"]["oGetBlindLayer"]();
	UCF_DomUtil["setStyle"](this["oBlindLayer"]["oDomRef"], {
		"left": this["oDomRef"]["style"]["left"],
		"top": this["oDomRef"]["style"]["top"],
		"width": this["oDomRef"]["offsetWidth"] + 'px',
		"height": this["oDomRef"]["offsetHeight"] + 'px'
	});
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["updateBlindLayer"] = 0; };

/**
 * Returns true when a BlindLayer is used because active components have been found on the page
 * @return {boolean}
 */
UCF_PopupBase["prototype"]["bHasBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["bHasBlindLayer"]++; }; 
	return this["oBlindLayer"] !== null;
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["bHasBlindLayer"] = 0; };

UCF_PopupBase["prototype"]["setZIndex"] = function(iZIndex) {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["setZIndex"]++; }; 
	if (this["oDomRef"]) {
		if (this["oDomRef"]["style"]["zIndex"] !== iZIndex) this["oDomRef"]["style"]["zIndex"] = iZIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["setZIndex"] = 0; };

UCF_PopupBase["prototype"]["iGetZIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["iGetZIndex"]++; }; 
	if (this["oDomRef"]) {
		//return parseInt(this.oDomRef.style.zIndex);
		return parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'zIndex'));
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["iGetZIndex"] = 0; };

/**
 * Sets the default button ID for the control.
 *
 * @param {string} sDefaultButtonId ID of the button that is executed if the user hits the enter key
 * @public
 */
UCF_PopupBase["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["setDefaultButtonId"]++; }; 
	UCF_PopupWindow.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["setDefaultButtonId"] = 0; };

/**
 * Handle hotkey events if derived control has parameter "HotkeysId" and it is used.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PopupBase["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["onlshotkey"]++; }; 
	if (this["sHotkeysId"] === '') {
		if (this["bIsDivPopup"] && this["sMode"] === 'MODAL') {
			oBrowserEvent["cancelBubble"]();
		}
		return;
	}
	var oHotkeys = this["oGetControlById"](this["sHotkeysId"]);
	if (oHotkeys == null) return;

	var oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		// Cancel and prevent default behaviour in browser
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent) || UCF_UserAgent["bIsChromium"]() && oBrowserEvent["oDomEvent"]["type"] === "keydown" && oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["ESC"]) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			var sControlId = oBrowserEvent["oGetSourceControl"]()["sGetId"](oBrowserEvent["oGetSource"]());
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"], sControlId);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupBase["_"]["onlshotkey"] = 0; };



UCF_PopupBase.prototype["aPublicMethods"] = ["bIsIFramePopup","close","setDefaultButtonId"].concat(UCF_PopupBase.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PopupMenu"] = function() {/* global _assert, _trace, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Interface */
/// <reference path="../../core/Interface.js"/>
/* global UCF_Animation */
/// <reference path="../anim/Animation.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_PopupMenuDragDelegate */
/// <reference path="./delegates/PopupMenuDragDelegate.js"/>
/* global UCF_PopupMenuDropDelegate */
/// <reference path="./delegates/PopupMenuDropDelegate.js"/>
/* global UCF_PopupMenuItem */
/// <reference path="./PopupMenuItem.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>

/**
 * PopupMenu control implementation
 * @class UCF_PopupMenu
 * @extends UCF_LayeredControl
 * @see UCF_PopupMenuItem
 * @param {HTMLElement} oDomRef the dom element
 * @param {UCF_LS} oLS the LS instance
 */
function UCF_PopupMenu(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["UCF_PopupMenu"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PopupMenu.js(49): UCF_PopupMenu"); };

	UCF_LayeredControl["apply"](this, [oDomRef, oLS]);

	this["defineEvents"]([
		'Close',
		'Select',
		'NextMenu',
		'PreviousMenu',
		'TabNext',
		'TabPrevious',
		'MenuAccess'
	]);

	/** @type {UCF_PopupMenuItem} */
	this["oSelectedItem"] = null; // eslint-disable-line @ur/no-memory-leaks
	this["bIsSubMenu"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["sUserData"] = ''; // eslint-disable-line @ur/no-memory-leaks
	this["bContentChanged"] = true; // eslint-disable-line @ur/no-memory-leaks
	// Automatic removal of the menu
	this["bRemoveOnClose"] = false; // eslint-disable-line @ur/no-memory-leaks

	// Focus handling
	this["bAutoRefocus"] = true; // eslint-disable-line @ur/no-memory-leaks
	//this.bAutoRefocusKeyup = false; // eslint-disable-line @ur/no-memory-leaks
	this["bApplyAutoRefocusKeyup"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["bFirstMouseUp"] = true; // eslint-disable-line @ur/no-memory-leaks
	this["sLastFocusedId"] = null; // eslint-disable-line @ur/no-memory-leaks

	// create item objects dynamically on the client
	this["oDomScrollUp"] = UCF_DomUtil["$"](this["sId"] + '-scrlup');
	this["oDomScrollUp"]["style"]["boxSizing"] = 'border-box';
	this["oDomScrollUp"]["style"]["MozBoxSizing"] = 'border-box';

	this["oDomScrollDown"] = UCF_DomUtil["$"](this["sId"] + '-scrldwn');
	this["oDomScrollDown"]["style"]["boxSizing"] = 'border-box';
	this["oDomScrollDown"]["style"]["MozBoxSizing"] = 'border-box';

	this["oDomContent"] = UCF_DomUtil["$"](this["sId"] + '-cnt');
	this["oDomContent"]["style"]["boxSizing"] = 'border-box';

	this["oRootRef"]["style"]["overflow"] = 'visible';

	this["oDomTable"] = this["oDomContent"]["getElementsByTagName"]('TABLE')[0];
	this["oDomTable"]["parentNode"]["parentNode"]["parentNode"]["overflow"] = 'visible';
	try {
		this["oDomTable"]["style"]["outline"] = '0px'; // reset the outline as it is
	} catch (ex) {}

	// Array containing the all menu items.
	this["aItems"] = [];
	this["aVisibleItems"] = [];

	this["bIgnoreDefaultButton"] = true; // eslint-disable-line @ur/no-memory-leaks
	this["bOverArrow"] = false; // eslint-disable-line @ur/no-memory-leaks

	// TODO: remove -  All fields necessary for handling menu in toolbar
	this["bUsedByToolbar"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["iFirstVisibleItemIdx"] = 0; // eslint-disable-line @ur/no-memory-leaks
	// eslint-disable-next-line quotes
	this["setClientProperty"]("FirstVisibleItemIdx", this["iFirstVisibleItemIdx"], true);
	this["iStoredFirstVisible"] = this["iFirstVisibleItemIdx"]; // eslint-disable-line @ur/no-memory-leaks
	this["bEnhancePopupWindows"] = true;
	this["attachBrowserEvent"]('scroll', this["oDomContent"]);
	this["oRootRef"]["setAttribute"]('pmnu', 'X');
	this["bHidden"] = true; // eslint-disable-line @ur/no-memory-leaks
	/** @type {UCF_Control} */
	this["oTouchContextMenuOpenerControl"] = null;
	/** @type {number} */
	this["iTouchMenuItemCount"] = 0; // eslint-disable-line @ur/no-memory-leaks
	/** @type {boolean} */
	this["bHasHeader"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["oOpenAtPosition"] = null;

	this["setSafetyDistance"](UCF_LayeredControl["MIN_BORDER_DISTANCE"]);

	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["OrientationChange"], this, "onOrientationChange");
};window["UCF_PopupMenu"] = UCF_PopupMenu; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopupMenu"); UCF_PopupMenu["_"] = {UCF_PopupMenu: 0}; }; ;
UCF_PopupMenu["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_PopupMenu.prototype["sClassName"] = "UCF_PopupMenu";

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenu["_bFiori"] = undefined;

/**
 * Returns whether the used theme is a Fiori theme or not
 * @private
 * @static
 * @return {boolean} Fiori?
 */
UCF_PopupMenu["bIsFiori"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bIsFiori"]++; }; 
	/** @type {{Tags: Array<string>}} */
	var oCssMetaData;

	if (typeof UCF_PopupMenu["_bFiori"] === 'undefined') {
		oCssMetaData = UCF_ResourceUtil["oExtractCssMetaData"]();

		UCF_PopupMenu["_bFiori"] = oCssMetaData
			&& oCssMetaData["Tags"]
			&& UCF_JsUtil["some"](
				oCssMetaData["Tags"],
				function(sTag) { return sTag === 'Fiori_2' || sTag === 'Fiori_3'; }
			);
	}

	return UCF_PopupMenu["_bFiori"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bIsFiori"] = 0; };

/** @type {number} in ms */
UCF_PopupMenu["ANIMATION_DURATION"] = 300;
/** @type {number} in px */
UCF_PopupMenu["SMALL_SEPARATOR_THRESHOLD"] = 2;
/** @type {number} (in px) the indent a submenu overlaps the main menu */
UCF_PopupMenu["SUBMENU_INDENT"] = 2;

/**
 * Orientation changed on iOS / Touch device
 * @private
 */
UCF_PopupMenu["prototype"]["onOrientationChange"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onOrientationChange"]++; }; 
	if (this["bIsTCM"]()) {
		this["closeAll"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onOrientationChange"] = 0; };

/**
 * Returns true if this is a touch-contextmenu
 * @return {boolean}
 * @private
 */
UCF_PopupMenu["prototype"]["bIsTCM"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bIsTCM"]++; }; 
	return this["bIsContextMenu"] && UCF_DomUtil["bHasClass"](document["body"], 'lsPage--touch');
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bIsTCM"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_PopupMenu["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["destroy"]++; }; 
	if (this["bIsDestroyed"]) return;

	/** @type {UCF_BrowserWindow} */
	var oWindow;

	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	this["bAvoidImmediateClose"] = false;
	oWindow = this["oLS"]["oBrowserWindow"];
	oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
	oWindow["detachEvent"](oWindow["E_EVENTS"]["OrientationChange"], this);

	if (this["oAnim"] && this["oAnim"]["bRunning"]) {
		this["oAnim"]["finish"]();
	}

	this["detachBrowserEvent"]('scroll', this["oDomContent"]);
	this["detachBrowserEvent"]('mousemove', this["oDomRef"]);
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["BeforeHotkey"], this, 'closeAll');
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this);

	// Control Refs
	this["oAnim"] = null; // eslint-disable-line @ur/no-memory-leaks
	this["oParentMenu"] = null;
	this["oDragDelegate"] = null; // eslint-disable-line @ur/no-memory-leaks
	this["oDropDelegate"] = null; // eslint-disable-line @ur/no-memory-leaks
	this["oSelectedItem"] = null;
	this["oSelectDownOnElement"] = null;
	this["oTouchContextMenuOpenerControl"] = null;

	// DomRefs
	this["oDomScrollUp"] = null;
	this["oDomScrollDown"] = null;
	this["oDomContent"] = null;
	this["oDomTable"] = null;
	this["oOpenerRefForLayering"] = null;

	// Arrays
	this["aItems"] = null;
	this["aVisibleItems"] = null;

	this["oInterval"] = null;
	this["onkeyup"] = null;
	this["onmouseup"] = null;

	// This is mucho importante because there might be no close() !
	var oSubstituteOpenerElement = document["getElementById"](this["sId"] + '-lsPopupMenuElement');
	if (oSubstituteOpenerElement) {
		try {
			UCF_DomUtil["removeFromDom"](oSubstituteOpenerElement);
		} catch (err) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Oops, unable to remove opener', "PopupMenu.js(240): destroy"); };
		}
	}

	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["destroy"] = 0; };

/**
 * Applies the height to the menu depending on the available
 * MaxVisible items or body height
 * @private
 */
UCF_PopupMenu["prototype"]["applyHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["applyHeight"]++; }; 
	/** @type {number} */
	var iItemHeight = this["iGetItemHeight"]();;
	/** @type {number} */
	var iNeededHeight = iItemHeight;
	/** @type {Array.<UCF_PopupMenuItem>} */
	var aVisibleItems = this["aGetVisibleItems"]();
	/** @type {number} */
	var iTotalItems = aVisibleItems["length"];
	/** @type {boolean} */
	var bSmallSeparator = null;
	/** @type {number} */
	var iSeparatorHeight = null;
	/** @type {number} */
	var iHeightOfSeparators = 0;
	/** @type {number} */
	var i;
	/** @type {number} */
	var iContentHeight;
	/** @type {number} */
	var iTotalHeight = 0;

	// var ADD_HEIGHT_FOR_BORDER_RADIUS = this.bIsTCM() ? 8 : 0;
	var ADD_HEIGHT_FOR_BORDER_RADIUS = 0;
	/** @type {boolean} */
	var bIsTriggeredByTouch = UCF_DomUtil["bHasClass"](document["body"], 'lsPage--touch');
	/**
	 * Note: In Belize sep. has height 1px or 2px in HCB
	 * @param {UCF_PopupMenuItem} oItem the item
	 * @return {number} the height of the previous sibling of the given item
	 */
	function iGetSepHeight(oItem) {
		return UCF_DomUtil["oGetPreviousSibling"](oItem["oDomRef"])["clientHeight"];
	};

	//If the page has lsPage--touch class, the last action was touch
	// Enable swipe-scrolling on touch device - Safari on iOS or Chrome on Android
	if (bIsTriggeredByTouch) {
		this["oDomContent"]["style"]["overflowY"] = 'auto';
		this["oDomContent"]["style"]["overflowX"] = 'hidden';
		this["oDomContent"]["style"]["overflow"]["webkitOverflowScrolling"] = 'touch';
	}
	// Calculate height of all seperator items...
	for (i = 0; i < aVisibleItems["length"]; i++) {
		if (aVisibleItems[i]["bHasSeparator"]) {
			// detect height only once, for the first separator item that is found
			if (bSmallSeparator == null) {
				iSeparatorHeight = iGetSepHeight(aVisibleItems[i]);
				bSmallSeparator = iSeparatorHeight <=
					UCF_PopupMenu["SMALL_SEPARATOR_THRESHOLD"];
			}
			if (bSmallSeparator) {
				iHeightOfSeparators += iSeparatorHeight;
			} else {
				iTotalItems++; // separator items have same height as normal items
			}
		}
	}

	// The height of the special tooltip header DIV for touch-contextmenu
	var iHeaderHeight = 0;
	if (this["bHasHeader"] && this["bIsTCM"]() && !this["bIsSubMenu"]) {
		iHeaderHeight += UCF_DomUtil["$"](this["sId"] + '-header-tooltip')["offsetHeight"];
		iHeaderHeight += UCF_DomUtil["$"](this["sId"] + '-header-text')["offsetHeight"];
		iHeaderHeight += UCF_DomUtil["$"](this["sId"] + '-header-datatip')["offsetHeight"];
	}

	iNeededHeight = Math["max"](
		iTotalItems * iNeededHeight + iHeightOfSeparators + iHeaderHeight,
		iNeededHeight
	);
	iNeededHeight += ADD_HEIGHT_FOR_BORDER_RADIUS;

	// Calculate height and available space based on position and size of "opener" control
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();

	var iMaxAvailableHeight = Math["max"](oViewportObjectRect["bottom"], oViewportObjectRect["top"]) - this["iGetPointerHeight"]();
	if (iMaxAvailableHeight < iNeededHeight) { // there's not enough space for the whole context menu
		// bring it to a multiple of item height
		iContentHeight = Math["floor"]((iMaxAvailableHeight - iHeaderHeight) / iItemHeight) * iItemHeight;
		//	if (UCF_System.sInteractionType === 'TOUCH') {
		if (bIsTriggeredByTouch) {
			// touch case: trim height to show half last visible item to indicate more values to the user
			iContentHeight -= iItemHeight / 2;
			iTotalHeight = iContentHeight + iHeaderHeight + ADD_HEIGHT_FOR_BORDER_RADIUS;
		} else {
			// desktop case: Show scroll indicators
			iTotalHeight = iContentHeight;
			iContentHeight -= iItemHeight * 2; // display scroll-items
		}
	} else { // there's enough space to display the complete menu
		iContentHeight = this["oDomContent"]["firstChild"]["offsetHeight"];
		if (iContentHeight <= iNeededHeight ||
			iContentHeight >= iNeededHeight + iItemHeight
		) {
			iTotalHeight = iNeededHeight;
		}
	}

	this["oRootRef"]["style"]["height"] = iTotalHeight + 'px';
	this["oDomContent"]["style"]["height"] = iContentHeight + 'px';

	// calculate the height of the PopupMenu
	this["_iHeight"] = iTotalHeight + (this["bIsTopOrBottom"]() ? this["iGetPointerHeight"]() : 0);

	if (this["bContentChanged"]) {
		this["aGetVisibleItems"]();
	}
	this["setScrollButtons"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["applyHeight"] = 0; };

/**
 * Returns the maximum height of all items. As a side-effect also sets this
 * maximum height on all items (TR).
 * @return {number} the maximum height of all items in px.
 */
UCF_PopupMenu["prototype"]["iGetItemHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetItemHeight"]++; }; 
	/** @type {NodeList.<HTMLTableRowElement>} */
	var aTR = this["oDomRef"]["getElementsByTagName"]('TR');
	/** @type {number} */
	var iHighest = 1;
	/** @type {number} */
	var iLength = aTR["length"];
	/** @type {number} */
	var i;
	/** @type {HTMLImageElement} */
	var oImg;

	// TODO: Remove or find explanation??
	for (i = 0; i < iLength; i++) {
		oImg = aTR[i]["getElementsByTagName"]('IMG')[0];
		if (oImg) {
			oImg["style"]["height"] = '16px';
			oImg["style"]["width"] = '16px';
		}
	}

	for (i = 0; i < iLength; i++) {
		iHighest = Math["max"](iHighest, aTR[i]["offsetHeight"]);
	}

	// TODO: Can we remove this magic-number magic?
	if (iHighest < 17) {
		iHighest = 17;
	}

	// TODO: Can we remove this side-effect? applyHeight function ALSO enforces
	// same height for all items?
	for (i = 0; i < iLength; i++) {
		aTR[i]["style"]["height"] = iHighest + 'px';
	}

	return iHighest;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetItemHeight"] = 0; };

/**
 * Sets the name of the event that opened the menu
 * Used if the menu was opened for a drop operation to close it again
 * @private
 * @param {string} sEventName The name of the event that opened the menu
 */
UCF_PopupMenu["prototype"]["setOpenEventName"] = function(sEventName) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setOpenEventName"]++; }; 
	this["sOpenEventName"] = sEventName; // eslint-disable-line @ur/no-memory-leaks
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setOpenEventName"] = 0; };

/**
 * Gets the name of the event that opened the menu
 * Used if the menu was opened for a drop operation to close it again
 * @private
 * @return {string}
 */
UCF_PopupMenu["prototype"]["sGetOpenEventName"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["sGetOpenEventName"]++; }; 
	return this["sOpenEventName"] ? this["sOpenEventName"] : '';
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["sGetOpenEventName"] = 0; };

/**
 * Determines whether the mouse is over a a scroll button of the menu.
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the event
 * @return {boolean}
 */
UCF_PopupMenu["prototype"]["bOverArrows"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bOverArrows"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef = oBrowserEvent["oGetSource"]();

	return UCF_DomUtil["bContains"](this["oDomScrollUp"], oDomRef)
		|| UCF_DomUtil["bContains"](this["oDomScrollDown"], oDomRef);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bOverArrows"] = 0; };

/**
 * Handles the mouse wheel event
 *
 * @private
 */
UCF_PopupMenu["prototype"]["onscroll"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onscroll"]++; }; 
	if (UCF_DomUtil["bHasClass"](document["body"], 'lsPage--mouse')) {
		this["setScrollButtons"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onscroll"] = 0; };

/**
 * Handles the mouse wheel event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @return {boolean}
 */
UCF_PopupMenu["prototype"]["onlsmousewheel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsmousewheel"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "PopupMenu.js(461): onlsmousewheel"); };

	if (oBrowserEvent["iWheelDelta"]() > 0) {
		this["scrollUp"]();
	} else {
		this["scrollDown"]();
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

	return true;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsmousewheel"] = 0; };

/**
 * Update style of scroll buttons
 * @private
 */
UCF_PopupMenu["prototype"]["setScrollButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setScrollButtons"]++; }; 
	/** @type {UCF_PopupMenu} */
	var self = this;
	/** @type {HTMLElement} */
	var oCnt = this["oDomContent"];
	/** @type {number} */
	var iScrollTop = oCnt["scrollTop"];
	/** @type {HTMLElement} */
	var oUp = this["oDomScrollUp"];
	/** @type {boolean} */
	var bAtBottom = iScrollTop + oCnt["offsetHeight"] >= oCnt["scrollHeight"];
	/** @type {HTMLElement} */
	var oDown = this["oDomScrollDown"];

	/** @return {boolean} */
	function bScrollingNeeded() {
		return ((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsFirefox"]())
				&& window["UCF_System"]["bIsRTL"])
			// IE and FF reports totally wrong scrollHeight in RTL
			? self["oDomContent"]["firstChild"]["offsetHeight"] >
			self["oDomContent"]["offsetHeight"] + 3
			: self["oDomContent"]["scrollHeight"] >
			self["oDomContent"]["offsetHeight"] + 3;
	};

	if (bScrollingNeeded() && UCF_DomUtil["bHasClass"](document["body"], 'lsPage--mouse')) {
		UCF_DomUtil["removeClass"](oUp, 'lsElement--invisible');
		UCF_DomUtil["removeClass"](oUp, 'urMnuScrUp urMnuScrUpDsbl');
		UCF_DomUtil["addClass"](oUp, iScrollTop === 0 ? 'urMnuScrUpDsbl' : 'urMnuScrUp');
		UCF_DomUtil["removeClass"](oDown, 'lsElement--invisible');
		UCF_DomUtil["removeClass"](oDown, 'urMnuScrDwn urMnuScrDwnDsbl');
		UCF_DomUtil["addClass"](oDown, bAtBottom ? 'urMnuScrDwnDsbl' : 'urMnuScrDwn');
	} else {
		oCnt["scrollTop"] = 0; // scroll to top
		UCF_DomUtil["addClass"](oUp, 'lsElement--invisible');
		UCF_DomUtil["addClass"](oDown, 'lsElement--invisible');
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setScrollButtons"] = 0; };

/**
 * Tries to get the last HTML element which was involved in the eventing which
 * lead to open the popup menu
 * @private
 * @return {HTMLElement}
 */
UCF_PopupMenu["prototype"]["oGetLastInvolvedOpenerElement"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetLastInvolvedOpenerElement"]++; }; 
	// TODO Find a better way to do this
	/** @type {HTMLElement} */
	var oLastInvolved = this["oLS"]["oBrowserWindow"]["oCurrentDomRef"];

	// If a full update was processed 'oBrowserWindow.oCurrentDomRef' is
	// invalidated and we need to find the new reference
	if (oLastInvolved &&
		!UCF_DomUtil["bIsInActiveDom"](oLastInvolved) &&
		oLastInvolved["getAttribute"] &&
		oLastInvolved["getAttribute"]('id')
	) {
		oLastInvolved = UCF_DomUtil["$"](oLastInvolved["getAttribute"]('id'));
	}

	return oLastInvolved;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetLastInvolvedOpenerElement"] = 0; };

/**
 * Hides the tooltip of the dom node
 * @private
 * @param {HTMLElement} [oDomRef=this.oGetLastInvolvedOpenerElement()] the element
 */
UCF_PopupMenu["prototype"]["hideTooltip"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["hideTooltip"]++; }; 
	this["removeTooltips"](oDomRef || this["oGetLastInvolvedOpenerElement"]());
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["hideTooltip"] = 0; };

/**
 * Shows the tooltip of the dom node
 * @private
 */
UCF_PopupMenu["prototype"]["showTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["showTooltip"]++; }; 
	this["resetTooltips"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["showTooltip"] = 0; };

/**
 * Opens the popup menu at a specified control
 * @param {string} sControlId the id of the control to open the PopupMenu at
 * @param {boolean} bWithKeyboard true to indicate that the PopupMenu was opened by a keyboard interaction
 * @param {UCF_LayeredControl.ALIGNMENT} [iAlignment=UCF_LayeredControl.ALIGNMENT.BOTTOMLEFT]
 * 	Optional value for positioning relative to the control
 * @public
 */
UCF_PopupMenu["prototype"]["openAtControl"] = function(sControlId, bWithKeyboard, iAlignment) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["openAtControl"]++; }; 
	this["connectToDom"](this["oDomRef"]);
	this["hide"]();
	if (sControlId) {
		this["setOpenerId"](sControlId);
		this["setOpenerRef"](UCF_DomUtil["$"](sControlId));
	}
	if (typeof iAlignment === 'number') {
		this["setAlignment"](iAlignment);
	} else {
		// Default, also for new Design=POPOVER
		this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);
	}
	if (this["bIsTCM"]()) {
		if (sControlId === this["sId"] + '-lsPopupMenuElement') {
			// Page remembers the last opener ID when firing ContextMenu events
			sControlId = this["oLS"]["oGetPageInternal"]()["sGetContextMenuOpenerId"]();
		}
		this["prepareTouchContextMenu"](
			this["oGetControlById"](sControlId) || this["oGetSubControl"](sControlId)
		);
	}
	this["open"](bWithKeyboard);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["openAtControl"] = 0; };

/**
 * Opens the popup menu at the given absolute position.
 * @param {number} iLeft left position where the popup menu should open
 * @param {number} iTop top position where the popup menu should open
 * @param {string} [sOpenerId] Optional control ID of the opener e.g. control on which the right-click occured for a context-menu.
 * @public
 */
UCF_PopupMenu["prototype"]["openAtPosition"] = function(iLeft, iTop, sOpenerId) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["openAtPosition"]++; }; 
	/** @type {UCF_LS_VisualViewport} */
	var oVisualViewport = this["oGetVisualViewport"]();
	var iWidth = this["iGetMinPointerEdgeOffset"]() ? this["iGetMinPointerEdgeOffset"]() : 1;

	iTop = Math["max"](0, iTop - oVisualViewport["pageTop"]); // transform to viewport coordinates
	iTop = Math["min"](oVisualViewport["height"] - 1, iTop); // and move into viewport, if necessary
	iLeft = Math["max"](0, iLeft - oVisualViewport["pageLeft"]); // transform to viewport coordinates
	iLeft = Math["min"](oVisualViewport["width"] - iWidth, iLeft); // and move into viewport, if necessary

	// create a dummy opener-control
	var oSubstituteOpenerElement = document["createElement"]('div');
	oSubstituteOpenerElement["id"] = this["sId"] + '-lsPopupMenuElement';
	oSubstituteOpenerElement["style"]["position"] = 'absolute';
	oSubstituteOpenerElement["style"]["top"] = (iTop + oVisualViewport["pageTop"]) + 'px';
	oSubstituteOpenerElement["style"]["left"] = (iLeft + oVisualViewport["pageLeft"]) + 'px';
	oSubstituteOpenerElement["style"]["width"] = iWidth + 'px';
	oSubstituteOpenerElement["style"]["height"] = '1px';
	oSubstituteOpenerElement["style"]["background"] = 'transparent';
	document["body"]["appendChild"](oSubstituteOpenerElement);

	// Important: this.oOpenerRefForLayering is used in LayeredControl.oFindParentLayer() which is called
	// during opening!
	var oOpenerControl = sOpenerId ?
		this["oGetControlById"](sOpenerId) || this["oGetSubControl"](sOpenerId) :
		null;
	if (oOpenerControl) {
		// Note: Do no use oOpenerRef/Id which is also used for positioning
		this["oOpenerRefForLayering"] = oOpenerControl["oDomRef"];
	}

	this["openAtControl"](
		oSubstituteOpenerElement["id"],
		this["oLS"]["oGetPageInternal"]()["bGetContextMenuEventByKeyBoard"](),
		this["bIsTCM"]() ? UCF_LayeredControl["ALIGNMENT"]["BOTTOMCENTER"] : null
	);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["openAtPosition"] = 0; };

/**
 * Returns whether the popupmenu is a possible droptarget or not
 * @private
 * @return {boolean}
 */
UCF_PopupMenu["prototype"]["bIsDropTarget"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bIsDropTarget"]++; }; 
	return this["mEvents"]["Drop"] != null;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bIsDropTarget"] = 0; };

/**
 * Returns whether the popupmenu is opened or not
 * @private
 * @return {boolean}
 */
UCF_PopupMenu["prototype"]["bIsOpened"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bIsOpened"]++; }; 
	return this["bOpened"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bIsOpened"] = 0; };

// /**
//  * Returns whether the popupmenu is opened or not
//  * @private
//  * @return {boolean}
//  */
// UCF_PopupMenu.prototype.bHasParentAutoRefocusKeyup = function() {
// 	if (this.bIsSubMenu) {
// 		return this.oParentMenu.bHasParentAutoRefocusKeyup();
// 	}
// 	return this.bAutoRefocusKeyup;
// };

/**
 * Returns whether the popupmenu is opened or not
 * @private
 */
UCF_PopupMenu["prototype"]["applyParentAutoRefocusKeyup"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["applyParentAutoRefocusKeyup"]++; }; 
	if (this["bIsSubMenu"]) {
		this["oParentMenu"]["applyParentAutoRefocusKeyup"]();
	} else
		this["bApplyAutoRefocusKeyup"] = true;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["applyParentAutoRefocusKeyup"] = 0; };

/**
 * Opens the popup menu
 * @private
 * @param {boolean} [bWithKeyboard] `true` to indicate that the open was
 * triggered by a keyboard interaction
 */
UCF_PopupMenu["prototype"]["open"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["open"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {string} */
	var sOpenerId;
	/** @type {HTMLElement} */
	var oRootRef;
	/** @type {number} */
	var iZIndex;
	/** @type {HTMLElement} */
	var oElement;

	if (this["bOpened"]) return;

	this["reset"]();

	if (bWithKeyboard === undefined) {
		bWithKeyboard = false;
	}
	this["hide"]();

	oDomRef = this["oDomRef"];
	if (this["mEvents"]["BeforeOpen"]) {
		this["bContentChanged"] = true;
		sOpenerId = this["oOpenerItem"]
			? this["oOpenerItem"]["sId"]
			: (this["sOpenerId"] || '');
		this["fireBeforeOpen"](
			this["sId"], sOpenerId,
			!!bWithKeyboard,
			this["iAlignment"]
		);
	} else if (this["oDomTable"]["getElementsByTagName"]('TR')["length"] > 0) {
		this["doNotProcessScrollEvents"](200);

		this["hideTooltip"]();
		this["applyHeight"]();
		this["oDomScrollUp"]["style"]["width"] = '100%';

		if (window["UCF_System"]["bIsAria"]) {
			UCF_AriaStateHelper["setLabelledBy"](oDomRef, this["oGetOpenerRef"]()["id"]);
		}

		// if autorefocus is enabled ask for currently focused id
		if (this["bAutoRefocus"]) {
			this["sLastFocusedId"] = this["oLS"]["sGetFocusedElementId"]();
		}

		this["checkRootRef"]();

		oRootRef = this["oRootRef"] || this["oDomRef"];

		//UCF_DomUtil.removeClass(oRootRef, 'lsMnu-root-initstyles');

		UCF_DomUtil["setStyle"](oRootRef, { "width": '1px', "visibility": 'visible', "overflow": 'visible', "display": 'inline' });

		if (this["bIsSubMenu"]) {
			iZIndex = parseInt(this["oParentMenu"]["oRootRef"]["style"]["zIndex"]);
			if (isNaN(iZIndex)) {
				iZIndex = UCF_LS["E_LAYERS"]["POPUPMENUS"];
			}
			oRootRef["style"]["zIndex"] = iZIndex + 1;
		}

		if (this["bIsTCM"]() && !this["bIsSubMenu"]) {
			this["enableUserSelectionForTcmHeader"](false);
			var oCMData = this["oLS"]["oGetPageInternal"]()["oGetContextMenuEventData"]();
			if (oCMData && oCMData["bOpenedByExtraLongTab"]) {
				// Workaround for Safari:
				// Suppress text-selection and enable it again on touchend of an 'extralongtab' to prevent Safari
				// from immediately selecting the text under the user's finger
				var oPage = this["oLS"]["oGetPageInternal"](),
					_this = this;
				oPage["attachEventOnce"](oPage["E_EVENTS"]["ContextMenuLongTouchEnd"], function() {

					UCF_JsUtil["delayedCall"](200, _this, 'enableUserSelectionForTcmHeader', [true]);
				});
			} else {
				UCF_JsUtil["delayedCall"](300, this, 'enableUserSelectionForTcmHeader', [true]);
			}
		}

		if (this["oAnim"] && this["oAnim"]["bRunning"]) {
			// Note: If a close animation is in progress, hide() callback must be
			// called to reset width !
			// this.oAnim.callbackRemove();
			this["oAnim"]["finish"]();
		}

		// Add drop shadow class
		oElement = this["oRootRef"];
		UCF_DomUtil["addClass"](oElement, UCF_LayeredControl["BOX_SHADOW_CLASS"]);
		if (!this["bIsSubMenu"]) {
			this["handlePopupWindowLayerOpen"]();
		}

		this["handleParentLayersOnOpen"]();

		oRootRef["style"]["overflow"] = 'visible';
		if (this["bIsSubMenu"]) {
			oRootRef["style"]["height"] = UCF_DomUtil["$"](this["sId"] + '-container')["offsetHeight"] + 'px';
			this["removeOverflow"]();
		} else {
			// Don't use animation for fiori
			if (!UCF_PopupMenu["bIsFiori"]()) {
				// Animation is running durung height calculation!
				// So, call iGetHeight once to cache the correct height
				this["iGetHeight"]();

				this["oAnim"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(
					oRootRef,
					UCF_PopupMenu["ANIMATION_DURATION"]
				);
				this["oAnim"]["addStyleChange"](
					'height',
					'',
					'px',
					1,
					UCF_DomUtil["$"](this["sId"] + '-container')["offsetHeight"],
					this["oAnim"]["M_TRANSITIONS"]["EaseIn"]
				);
				this["oAnim"]["callbackFinish"](this, 'removeOverflow');
				this["oAnim"]["play"]();
			} else {
				this["removeOverflow"]();
			}
		}

		this["setOpened"](true);

		this["attachBrowserEvent"]('mousemove', this["oDomRef"]);
		if (!this["bIsSubMenu"]) {
			this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["BeforeHotkey"], this, 'closeAll');
		}
		UCF_DomUtil["setTabIndex"](UCF_DomUtil["oGetFirstElement"](this["oRootRef"]), 0);
		UCF_DomUtil["oGetFirstElement"](this["oRootRef"])["hideFocus"] = true;

		// call this delayed for the tooltip problem:
		// tooltip on opener did not disappear
		this["sOpen2Call"] = UCF_JsUtil["delayedCall"]( // eslint-disable-line @ur/no-memory-leaks
			1,
			this,
			'open2',
			[bWithKeyboard]
		);
		this["bHidden"] = false;
		// avoid that the menu us immediately closed if a resize or scroll
		// happens within the next 200ms
		this["bAvoidImmediateClose"] = true;
	}
	this["notifyLayeredControlOpen"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["open"] = 0; };

UCF_PopupMenu["prototype"]["resetImmediateClose"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["resetImmediateClose"]++; }; 
	this["bAvoidImmediateClose"] = false;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["resetImmediateClose"] = 0; };

/**
 * @private
 * @param {boolean} [bWithKeyboard] `true` to indicate that the open was
 * triggered by a keyboard interaction
 */
UCF_PopupMenu["prototype"]["open2"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["open2"]++; }; 
	/** @type {Array.<UCF_PopupMenuItem>} */
	var aItems;
	/** @type {HTMLElement} */
	var oDom;
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow;

	// Call before setPosition(), otherwise this.oRootRef.scrollWidth=1 after the
	// first close() call and the PopupMenu may appear in a different position
	// depending on the UCF_LayeredControl.ALIGNMENT and the available space.
	this["resetMenuWidth"]();

	// must be called delayed for the tooltip to disappear
	this["setPosition"]();

	// delay this: else browser scrolls to the top...
	// focus will not work if LS is still locked
	if (this["oLS"]["bIsLocked"]) {
		this["oLS"]["attachEvent"](
			this["oLS"]["E_EVENTS"]["Unlock"],
			this,
			'onUnlock',
			[bWithKeyboard]
		);
	} else {
		this["onUnlock"](bWithKeyboard);
	}

	// Focus the first item (that is not disabled)
	// 4/2022: Int. incident 2270069629 - Focus the first item also with mouse interaction if ARIA (not 508)
	aItems = this["aGetVisibleItems"]();
	if (!window["UCF_System"]["bIs508"] && aItems["length"] > 0) {
		this["oSelectedItem"] = null;
		var oFocussedItem = this["focusNextItem"]();
		if (oFocussedItem) {
			oDom = oFocussedItem["oDomRef"];
			UCF_AriaStateHelper["setRole"](oDom, 'menuitem');
			UCF_AriaStateHelper["setPosinset"](oDom, oFocussedItem["iIndex"] + 1);
			UCF_AriaStateHelper["setSetsize"](oDom, aItems["length"]);
			UCF_AriaStateHelper["setLabel"](oDom, oFocussedItem["sText"]);
			if (oFocussedItem["bGetHasSubMenu"]()) {
				UCF_AriaStateHelper["setOwns"](oDom, oFocussedItem["sSubMenuId"]);
				UCF_AriaStateHelper["setHasPopup"](oDom, true);
			}
		}
	}

	// refocus in accessibility mode to get the screen reader
	// to reading out the first menu item
	if (window["UCF_System"]["bIs508"]) {
		this["refocus"](this["oDom"]);
	}

	// must be called delayed to not close prematurely on imagemaps
	oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["attachEvent"](
		oBrowserWindow["E_EVENTS"]["AnyEvent"],
		this,
		'onAnyEvent'
	);

	this["notifyLayerVisible"]();

};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["open2"] = 0; };

/** @private */
UCF_PopupMenu["prototype"]["removeOverflow"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["removeOverflow"]++; }; 
	/** @type {HTMLElement} */
	var oRootRef = this["oRootRef"] || this["oDomRef"];
	oRootRef["style"]["overflow"] = 'visible';
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["removeOverflow"] = 0; };

UCF_PopupMenu["prototype"]["enableUserSelectionForTcmHeader"] = function(bSwitch) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["enableUserSelectionForTcmHeader"]++; }; 
	if (!this["bIsTCM"]()) return;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'enableUserSelectionForTcmHeader: ' + bSwitch, "PopupMenu.js(921): enableUserSelectionForTcmHeader"); };
	var sValue = bSwitch ? 'text' : 'none';
	var _this = this;
	UCF_JsUtil["forEach"]([
		'-header-tooltip',
		'-header-text',
		'-header-datatip'
	], function(s) {
		UCF_DomUtil["$"](_this["sId"] + s)["style"]["userSelect"] = sValue;
		UCF_DomUtil["$"](_this["sId"] + s)["style"]["webkitUserSelect"] = sValue;
	});
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["enableUserSelectionForTcmHeader"] = 0; };

/**
 * Cancels the popup menu
 *
 * @private
 * @param {boolean} bForceClose menu must be closed, even if it is not a submenu
 */
UCF_PopupMenu["prototype"]["cancel"] = function(bForceClose) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["cancel"]++; }; 
	/** @type {UCF_PopupMenuItem} */
	var oSelectedItem = this["oSelectedItem"];

	if (oSelectedItem &&
		oSelectedItem["oSubMenu"] &&
		oSelectedItem["oSubMenu"]["bOpened"]
	) {
		oSelectedItem["closeSubMenu"]();
	} else if (this["bIsSubMenu"] || bForceClose) {
		this["close"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["cancel"] = 0; };

/**
 * Close all menus
 * @param { boolean } bByKeyboardEvent `false` to focus the first element in the
 * @private
 */
UCF_PopupMenu["prototype"]["closeAll"] = function(bByKeyboardEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["closeAll"]++; }; 
	/** @type {UCF_PopupMenu} */
	var oMenu;

	if (!this["bIsSubMenu"]) {
		this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["BeforeHotkey"], this, 'closeAll');
	}

	oMenu = this; // eslint-disable-line consistent-this
	while (oMenu) {
		oMenu["close"](bByKeyboardEvent);
		oMenu = oMenu["oParentMenu"];
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["closeAll"] = 0; };

/**
 * Handler for the unlock event of lightspeed
 * If the menu is opened and LS is still locked it will not get
 * the right accessibility texts attached.
 *
 * @private
 * @param {boolean} [bWithKeyboard] `false` to focus the first element in the
 * PopupMenu
 */
UCF_PopupMenu["prototype"]["onUnlock"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onUnlock"]++; }; 
	if (bWithKeyboard === false) {
		UCF_DomUtil["focusDomElement"](UCF_DomUtil["oGetFirstElement"](this["oRootRef"]));
	}
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this);
	UCF_JsUtil["delayedCall"](200, this, 'resetImmediateClose');
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onUnlock"] = 0; };

/**
 * set the focus back to the opener after roundtrip
 * @private
 * @param {UCF_FocusInfo} oFocusInfo the focus info
 */
UCF_PopupMenu["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "PopupMenu.js(997): collectFocusInfo"); };

	if (this["bAutoRefocus"] && this["sOpenerId"]) {
		oFocusInfo["setFocussedId"](this["sOpenerId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["collectFocusInfo"] = 0; };

/**
 * @private
 * @param {number} iResetTime the timeout duration
 */
UCF_PopupMenu["prototype"]["doNotProcessScrollEvents"] = function(iResetTime) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["doNotProcessScrollEvents"]++; }; 
	this["bDoNotProcessScrollEvents"] = true;
	UCF_JsUtil["delayedCall"](iResetTime, this, 'resetDoNotProcessScrollEvents');
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["doNotProcessScrollEvents"] = 0; };

/** @private */
UCF_PopupMenu["prototype"]["resetDoNotProcessScrollEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["resetDoNotProcessScrollEvents"]++; }; 
	this["bDoNotProcessScrollEvents"] = false;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["resetDoNotProcessScrollEvents"] = 0; };

/**
 * Closes the popup menu
 *
 * @private
 * @param { boolean } bByKeyboardEvent determines
 * whether popup was closed by mouse or keyboard. In mouse- case don 't refocus the last focussed element
 */
UCF_PopupMenu["prototype"]["close"] = function(bByKeyboardEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["close"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oWindow;
	/** @type {UCF_PopupMenuItem} */
	var oSelectedItem;
	/** @type {HTMLElement} */
	var oRootRef;

	UCF_JsUtil["clearDelayedCall"](this["sOpen2Call"]);

	var oSubstituteOpenerElement = document["getElementById"](this["sId"] + '-lsPopupMenuElement');
	if (oSubstituteOpenerElement) {
		try {
			UCF_DomUtil["removeFromDom"](oSubstituteOpenerElement);
		} catch (err) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Oops, unable to remove opener', "PopupMenu.js(1040): close"); };
		}
	}

	if (UCF_DomUtil["$"](this["sId"] + '-up')) {
		UCF_DomUtil["$"](this["sId"] + '-up')["style"]["visibility"] = 'hidden';
	}
	if (UCF_DomUtil["$"](this["sId"] + '-down')) {
		UCF_DomUtil["$"](this["sId"] + '-down')["style"]["visibility"] = 'hidden';
	}

	if (this["bOpened"]) {
		this["oOpenAtPosition"] = null;
		this["doNotProcessScrollEvents"](200);
		UCF_DomUtil["setTabIndex"](UCF_DomUtil["oGetFirstElement"](this["oRootRef"]), -1);
		oWindow = this["oLS"]["oBrowserWindow"];
		oSelectedItem = this["oSelectedItem"];
		this["setOpened"](false);
		this["showTooltip"]();

		// detach events
		oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
		this["detachBrowserEvent"]('mousemove', this["oDomRef"]);

		// clean up the selected item and close the submenues
		if (oSelectedItem) {
			this["oSelectedItem"]["handleMenuCloseForSelectedItem"]();
			this["oSelectedItem"] = null; // reset the selected item
		}

		oRootRef = this["oRootRef"] || this["oDomRef"];

		// add overflow for animation
		oRootRef["style"]["overflow"] = 'hidden';
		// oRootRef.style.width = '1px';

		if (this["oAnim"] && this["oAnim"]["bRunning"]) {
			this["oAnim"]["finish"]();
		}

		if (this["bIsSubMenu"]) {
			this["hide"]();
		} else if (!UCF_PopupMenu["bIsFiori"]()) {
			this["oAnim"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(oRootRef, UCF_PopupMenu["ANIMATION_DURATION"]);
			this["oAnim"]["addStyleChange"](
				'height',
				'',
				'px',
				oRootRef["scrollHeight"],
				1,
				this["oAnim"]["M_TRANSITIONS"]["EaseOut"]
			);
			this["oAnim"]["callbackFinish"](this, 'hide');
			this["oAnim"]["play"]();
		} else {
			oRootRef["style"]["height"] = '1px';
			this["hide"]();
		}

		// if autorefocus is enabled set focused to last element. Don't refocus
		// last element if user clicks with mouse. calls 'moveFocus' -> in case of
		// roundtrip opener control is focussed to late so focusinfo is still the
		// popupmenu item therefore #collectFocusInfo() necessary
		// if (this.bIsSubMenu)  {
		// 	this.focusParentMenu();
		// }
		// if (this.bHasParentAutoRefocusKeyup()) {
		// 	var _this = this;
		// 	// WCAG 2.1 pointer cancellation
		// 	// If a Menu button uses keyup to open the menu it would open the menu again
		// 	// when an menu item is selected an the menu is closed because the focus
		// 	// is moved to the button before the user releases the key...
		// 	this.onkeyup = function(oBrowserEvent) {
		// 		if (UCF_KeyboardHelper.bIsEventForKey(oBrowserEvent, UCF_KeyCodes.SPACE) ||
		// 			UCF_KeyboardHelper.bIsEventForKey(oBrowserEvent, UCF_KeyCodes.ENTER) ||
		// 			UCF_KeyboardHelper.bIsEventForKey(oBrowserEvent, UCF_KeyCodes.ESCAPE)) {
		// 			this.bApplyAutoRefocusKeyup = false;
		// 			_trace(INFO, '=================== onkeyup  --------------------  ID --- : ' + _this.sId + ' ------------------ key ' + oBrowserEvent.iKeyCode());
		// 			_this.autoRefocus();
		// 		}
		// 		oBrowserEvent.cancel();
		// 		oBrowserEvent.cancelBubble();

		// 		_this.onkeyup = null;
		// 	};

		// 	this.onmouseup = function(oBrowserEvent) {
		// 		_trace(INFO, '=================== onmouseup  --------------------  ID --- : ' + _this.sId);
		// 		if (!_this.bIsSubMenu || this.bApplyAutoRefocusKeyup) {
		// 			_this.autoRefocus();

		// 			this.bApplyAutoRefocusKeyup = false;
		// 			oBrowserEvent.cancel();
		// 			oBrowserEvent.cancelBubble();
		// 		} else
		// 			_this.applyParentAutoRefocusKeyup();
		// 		_this.onmouseup = null;
		// 	};

		// 	if (!this.bIsSubMenu && this.bFirstMouseUp) {
		// 		this.autoRefocus();
		// 		_trace(INFO, '=================== bFirstMouseUp  --------------------  ID --- : ' + this.sId);
		// 		this.bFirstMouseUp = false;
		// 	}

		// 	if (!this.bIsSubMenu && this.bApplyAutoRefocusKeyup) {
		// 		this.autoRefocus();
		// 		_trace(INFO, '=================== bApplyAutoRefocusKeyup  --------------------  ID --- : ' + this.sId);
		// 		this.bApplyAutoRefocusKeyup = false;
		// 	}
		// } else
		if (!this["bIsSubMenu"] && this["bAutoRefocus"]) {
			this["autoRefocus"]();
		}

		if (this["oTouchContextMenuOpenerControl"]) {
			this["oTouchContextMenuOpenerControl"] = null;
			this["removeTouchContextMenuItems"](); // Remove all extra items and header
		}

		// internal
		this["fireEvent"](this["E_EVENTS"]["Close"], {});
		// semantic
		this["fireClose"](this["sId"]);

		// if menu is marked to be removed on close call this
		// delayed to avoid order problems in the JS
		if (this["bRemoveOnClose"]) {
			UCF_JsUtil["delayedCall"](0, this, 'removeMenu');
		}
	}
	this["notifyLayeredControlClose"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["close"] = 0; };

UCF_PopupMenu["prototype"]["autoRefocus"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["autoRefocus"]++; }; 
	/** @type {UCF_FocusInfo} */
	var oFocusInfo;
	/** @type {HTMLElement} */
	var oDomRef;

	// Note: don't use framework method because it uses a delayed call...
	// this.oLS.focusElement(this.sLastFocusedId);
	oFocusInfo = new (UCF_ClassLoader["oGetClass"]("UCF_FocusInfo"))(this["oLS"]);
	oFocusInfo["deserialize"](this["sLastFocusedId"]);
	oDomRef = UCF_DomUtil["$"](oFocusInfo["sFocussedId"]);

	// if there is an opener ref (set via open at control) this needs to be
	// considered here.
	if (!oDomRef && this["oOpenerRef"]) {
		oDomRef = this["oOpenerRef"];
	}
	if (oDomRef) {
		try {
			oDomRef["focus"]();
		} catch (e) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'oDomRef with id=' + this["sLastFocusedId"] + ' could not be focussed', "PopupMenu.js(1195): autoRefocus"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["autoRefocus"] = 0; };

/**
 * Remove menu
 * @private
 */
UCF_PopupMenu["prototype"]["removeMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["removeMenu"]++; }; 
	/** @type {Array.<UCF_PopupMenuItem>} */
	var aItems = this["aGetItems"]();
	/** @type {number} */
	var i;
	/** @type {UCF_PopupMenuItem} */
	var oItem;
	/** @type {UCF_PopupMenu} */
	var oSubMenu;

	for (i = 0; i < aItems["length"]; i++) {
		oItem = aItems[i];
		oSubMenu = this["oLS"]["oControlFactory"]["oGetControlById"](
			oItem["sSubMenuId"],
			true
		);

		if (oItem["bHasSubMenu"] && oSubMenu != null) {
			UCF_JsUtil["delayedCall"](0, oSubMenu, 'removeMenu');
		}
	}

	UCF_DomUtil["removeFromDom"](this["oRootRef"]);
	UCF_DomUtil["removeFromDom"](this["oPlaceHolderRef"]);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["removeMenu"] = 0; };

/**
 * Hides the menu
 * @private
 */
UCF_PopupMenu["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["hide"]++; }; 
	/** @type {HTMLElement} */
	var oRootRef;

	if (!this["bHidden"]) {
		UCF_JsUtil["clearDelayedCall"](this["sOpen2Call"]);
		oRootRef = this["oRootRef"] || this["oDomRef"];
		if (this["oAnim"]) {
			this["oAnim"]["callbackRemove"]();
		}

		UCF_DomUtil["setStyle"](oRootRef, {
			"top": '-100000px',
			"left": ''
		});
		//UCF_DomUtil.addClass(oRootRef, 'lsMnu-root-initstyles');

		this["setMenuWidth"](1);
		this["notifyLayerHidden"]();
		this["bHidden"] = true;
		if (!this["bIsSubMenu"]) {
			this["handlePopupWindowLayerClose"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["hide"] = 0; };

/**
 * Returns the item with a specific index or null if an item with the index
 * does not exist
 *
 * @private
 * @param {number} iIndex the index of the item to be returned
 * @return {UCF_PopupMenuItem}
 */
UCF_PopupMenu["prototype"]["oGetItem"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetItem"]++; }; 
	/** @type {Array.<UCF_PopupMenuItem>} */
	var aItems = this["aGetItems"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iIndex === 'number', "typeof iIndex === 'number'", "PopupMenu.js(1272): oGetItem"); };

	return aItems[iIndex] || null;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetItem"] = 0; };

/**
 * Returns the first visible item.
 * @private
 * @return {UCF_PopupMenuItem}
 */
UCF_PopupMenu["prototype"]["oGetFirstVisibleItem"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetFirstVisibleItem"]++; }; 
	return this["aGetVisibleItems"]()[0];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetFirstVisibleItem"] = 0; };

/**
 * Returns the first visible item.
 * @private
 * @return {UCF_PopupMenuItem}
 */
UCF_PopupMenu["prototype"]["oGetFirstEnabledItem"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetFirstEnabledItem"]++; }; 
	var iFirst = this["iSkipDisabledItems"](0, true);
	if (iFirst === -1)
		iFirst = 0;
	return this["aGetVisibleItems"]()[iFirst];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetFirstEnabledItem"] = 0; };

/**
 * Sets the selected item of the popup menu
 *
 * @private
 * @param {UCF_PopupMenuItem} oItem item that is selected or null
 * @param {boolean} bAutoToggle `true` to enable auto toggling - used only during hovering of items, never for keyboard-access
 */
UCF_PopupMenu["prototype"]["setSelectedItem"] = function(oItem, bAutoToggle) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setSelectedItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_PopupMenuItem || oItem == null, "oItem instanceof UCF_PopupMenuItem || oItem == null", "PopupMenu.js(1306): setSelectedItem"); };
	//console.log('++++++ setSelectedItem 0');
	// strange case in toolbar it sometimes happens that the selected item is
	// already destroyed
	if (this["oSelectedItem"] && this["oSelectedItem"]["bIsDestroyed"]) {
		this["oSelectedItem"] = null;
	}

	// check if the event source is the same item and return, this avoids the
	// flickering
	if (this["oSelectedItem"] !== oItem) {
		//console.log('++++++ setSelectedItem 1');
		// set the currently selected item to false
		if (this["oSelectedItem"]) {
			this["oSelectedItem"]["setSelected"](false);
			if (bAutoToggle) {
				this["oSelectedItem"]["closeSubMenu"]();
			}
		}
		// store the new selected item in the popupmenu object
		this["oSelectedItem"] = oItem;

		// set the new selected item to true
		if (this["oSelectedItem"]) {
			//console.log('++++++ setSelectedItem 2');
			this["oSelectedItem"]["focus"]();
			this["oSelectedItem"]["setSelected"](true);
			if (bAutoToggle) {
				//console.log('++++++ setSelectedItem 3');
				this["oSelectedItem"]["openSubMenu"]();
			}
		}
	} else {
		// The item may have been hovered before and got selected, but the open-timer (250ms)
		// was not reached. Now it is already selected and gets hovered again
		if (!(oItem["oSubMenu"] && oItem["oSubMenu"]["bIsOpened"]()) && bAutoToggle) {
			//console.log('++++++ setSelectedItem 4');
			this["oSelectedItem"]["openSubMenu"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setSelectedItem"] = 0; };

/**
 * Sets whether the menu is a submenu or not
 *
 * @private
 * @param {boolean} bIsSubMenu
 */
UCF_PopupMenu["prototype"]["setIsSubMenu"] = function(bIsSubMenu) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setIsSubMenu"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof bIsSubMenu === 'boolean', "typeof bIsSubMenu === 'boolean'", "PopupMenu.js(1355): setIsSubMenu"); };
	this["bIsSubMenu"] = bIsSubMenu;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setIsSubMenu"] = 0; };

/**
 * Sets the focus to the next item.
 * Used for keyboard navigation. Will skip disabled items.
 * @private
 * @return {Object} The focussed item (or null if all items are disabled)
 */
UCF_PopupMenu["prototype"]["focusNextItem"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusNextItem"]++; }; 
	/** @type {number} */
	var iNext;
	/** @type {number} */
	var iSelectedIndex;
	/** @type {number} */
	var iItemTopBeforeFocus;
	/** @type {number} */
	var iScrollTopBeforeFocus;
	/** @type {UCF_PopupMenuItem} */
	var oNextItem;

	if (this["oSelectedItem"]) {
		iSelectedIndex = this["oSelectedItem"]["iIndex"];
		this["oSelectedItem"]["closeSubMenu"]();
		this["oSelectedItem"]["setSelected"](false);
		this["oSelectedItem"] = null;
		iNext = this["iGetNextVisibleItemIndex"](iSelectedIndex);
	} else {
		// -1 means: Get the first visible item... (!)
		iNext = this["iGetNextVisibleItemIndex"](-1);
	}

	// Skip disabled items
	// iNext = this.iSkipDisabledItems(iNext, true);
	// if (iNext === -1) return null; // Only disabled items!

	iItemTopBeforeFocus = this["iGetItemTopPosition"](iNext);
	iScrollTopBeforeFocus = this["iGetContentScrollTop"]();
	oNextItem = this["oGetItem"](iNext);

	this["setSelectedItem"](oNextItem, false);
	this["scrollItemIntoView"](iNext, iItemTopBeforeFocus, iScrollTopBeforeFocus);
	return oNextItem;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusNextItem"] = 0; };

/**
 * Used in focusNextItem/focusPReviousItem: Search for the next item that is enabled.
 * @param {number} iNext The index of the item to start with
 * @param {boolean} bDirection Search in forward or backward direction for the next item that is not disabled
 * @return {number} The index of the next item to use or -1 if there are only disabled items
 */
UCF_PopupMenu["prototype"]["iSkipDisabledItems"] = function(iNext, bDirection) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iSkipDisabledItems"]++; }; 
	// Note: It is now really time to refactor the
	// aGetItems-aGetVisibleItems-oGetItem-iGetNextVisibleItemIndex-focusNextItem-focusFirstItem-MESS !!
	var iStart = iNext;
	var iCount = 0;
	var bNoEnabledItems = false;
	while (!this["oGetItem"](iNext)["bIsEnabled"]()
		&& iCount++ < this["aVisibleItems"]["length"]
	) {
		iNext = bDirection ? this["iGetNextVisibleItemIndex"](iNext) : this["iGetPreviousVisibleItemIndex"](iNext);
		if (iNext === iStart) {
			bNoEnabledItems = true;
			break;
		}
	}
	return bNoEnabledItems ? -1 : iNext;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iSkipDisabledItems"] = 0; };

/**
 * Find the index of the next visible item starting with the given item-index.
 * The next item of the last is the first.
 * @private
 * @param {number} iSelectedIndex the selected index
 * @param {Array.<UCF_PopupMenuItem>} aVisibleItems the visible items
 * @return {number}
 */
UCF_PopupMenu["prototype"]["iGetNextVisibleItemIndex"] = function(iSelectedIndex, aVisibleItems) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetNextVisibleItemIndex"]++; }; 
	/** @type {Array.<UCF_PopupMenuItem>} */
	var aItems = aVisibleItems || this["aGetItems"]();

	iSelectedIndex++;
	if (iSelectedIndex > aItems["length"] - 1) {
		// This means: Get the first visible item... (!)
		iSelectedIndex = this["iGetNextVisibleItemIndex"](-1);
	}

	return aItems[iSelectedIndex]["bGetIsVisible"]()
		? iSelectedIndex
		: this["iGetNextVisibleItemIndex"](iSelectedIndex, aItems);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetNextVisibleItemIndex"] = 0; };

/**
 * Find the index of the previous visible item starting with the given
 * item-index. The previous item of the first is the last.
 * @private
 * @param {number} iSelectedIndex the selected index
 * @param {Array.<UCF_PopupMenuItem>} aVisibleItems the visible items
 * @return {number}
 */
UCF_PopupMenu["prototype"]["iGetPreviousVisibleItemIndex"] = function(iSelectedIndex, aVisibleItems) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetPreviousVisibleItemIndex"]++; }; 
	/** @type {Array.<UCF_PopupMenuItem>} */
	var aItems = aVisibleItems || this["aGetItems"]();

	iSelectedIndex--;
	if (iSelectedIndex < 0) {
		// This means: Get the last visible item... (!)
		iSelectedIndex = this["iGetPreviousVisibleItemIndex"](aItems["length"]);
	}

	return aItems[iSelectedIndex]["bGetIsVisible"]()
		? iSelectedIndex
		: this["iGetPreviousVisibleItemIndex"](iSelectedIndex, aItems);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetPreviousVisibleItemIndex"] = 0; };

/**
 * Sets the focus to the first item
 * Used for keyboard navigation.
 * @private
 */
UCF_PopupMenu["prototype"]["focusFirstItem"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusFirstItem"]++; }; 
	/** @type {number} */
	var iSelectedIndex = this["iGetNextVisibleItemIndex"](-1);
	/** @type {number} */
	var iItemTopBeforeFocus = this["iGetItemTopPosition"](iSelectedIndex);
	/** @type {number} */
	var iScrollTopBeforeFocus = this["iGetContentScrollTop"]();
	/** @type {UCF_PopupMenuItem} */
	var oItem = this["oGetItem"](iSelectedIndex);

	this["setSelectedItem"](oItem, false);
	this["scrollItemIntoView"](
		iSelectedIndex,
		iItemTopBeforeFocus,
		iScrollTopBeforeFocus
	);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusFirstItem"] = 0; };

/**
 * Sets the focus to the last item
 * Used for keyboard navigation.
 * @private
 */
UCF_PopupMenu["prototype"]["focusLastItem"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusLastItem"]++; }; 
	/** @type {number} */
	var iSelectedIndex = this["iGetPreviousVisibleItemIndex"](this["aItems"]["length"]);
	/** @type {number} */
	var iItemTopBeforeFocus = this["iGetItemTopPosition"](iSelectedIndex);
	/** @type {number} */
	var iScrollTopBeforeFocus = this["iGetContentScrollTop"]();
	/** @type {UCF_PopupMenuItem} */
	var oItem = this["oGetItem"](iSelectedIndex);

	this["setSelectedItem"](oItem, false);
	this["scrollItemIntoView"](
		iSelectedIndex,
		iItemTopBeforeFocus,
		iScrollTopBeforeFocus
	);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusLastItem"] = 0; };

/**
 * Sets the focus to the previous item.
 * Used for keyboard navigation. Disabled items are skipped.
 * @private
 */
UCF_PopupMenu["prototype"]["focusPreviousItem"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusPreviousItem"]++; }; 
	/** @type {number} */
	var iPrevious = 0;
	/** @type {number} */
	var iItemTopBeforeFocus;
	/** @type {number} */
	var iScrollTopBeforeFocus;
	/** @type {UCF_PopupMenuItem} */
	var oPrevItem;

	if (this["oSelectedItem"]) {
		iPrevious = this["oSelectedItem"]["iIndex"];
		this["oSelectedItem"]["closeSubMenu"]();
		this["oSelectedItem"]["setSelected"](false);
		this["oSelectedItem"] = null;
	}

	iPrevious = this["iGetPreviousVisibleItemIndex"](iPrevious);

	// Skip disabled items
	// iPrevious = this.iSkipDisabledItems(iPrevious, false);
	// if (iPrevious === -1) return; // Only disabled items!

	iItemTopBeforeFocus = this["iGetItemTopPosition"](iPrevious);
	iScrollTopBeforeFocus = this["iGetContentScrollTop"]();
	oPrevItem = this["oGetItem"](iPrevious);
	this["setSelectedItem"](oPrevItem, false);
	this["scrollItemIntoView"](
		iPrevious,
		iItemTopBeforeFocus,
		iScrollTopBeforeFocus
	);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusPreviousItem"] = 0; };

/** @override */
UCF_PopupMenu["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focus"]++; }; 
	/** @type {number} */
	var iScrollTop = this["oDomContent"]["scrollTop"];

	UCF_LayeredControl.prototype["focus"]["apply"](this, arguments);
	if (iScrollTop !== this["oDomContent"]["scrollTop"]) {
		this["oDomContent"]["scrollTop"] = iScrollTop;
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focus"] = 0; };

/**
 * @private
 * @return {HTMLElement}
 */
UCF_PopupMenu["prototype"]["oGetFocusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetFocusDomRef"]++; }; 
	return UCF_DomUtil["oGetFirstElement"](this["oRootRef"]);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetFocusDomRef"] = 0; };

/**
 * @private
 * @param {number} iItemIndex the item index
 * @return {number}
 */
UCF_PopupMenu["prototype"]["iGetItemTopPosition"] = function(iItemIndex) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetItemTopPosition"]++; }; 
	/** @type {UCF_PopupMenuItem} */
	var oItem = this["oGetItemByIndex"](iItemIndex);

	return oItem["oRootRef"]["offsetTop"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetItemTopPosition"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_PopupMenu["prototype"]["iGetContentScrollTop"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetContentScrollTop"]++; }; 
	return this["oDomContent"]["scrollTop"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetContentScrollTop"] = 0; };

/**
 * ScrollItem into view
 * @private
 * @param {number} iItemIndex the index of the item to scroll into view
 * @param {number} iItemTopBeforeFocus the top offset of the item before
 * focussing
 * @param {number} iST the scrolltop
 */
UCF_PopupMenu["prototype"]["scrollItemIntoView"] = function(iItemIndex, iItemTopBeforeFocus, iST) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["scrollItemIntoView"]++; }; 
	/** @type {number} */
	var iTop = iItemTopBeforeFocus === undefined
		? this["oGetItemByIndex"](iItemIndex)["oRootRef"]["offsetTop"]
		: iItemTopBeforeFocus;
	/** @type {number} */
	var iScrollTop = iST === undefined
		? this["oDomContent"]["scrollTop"]
		: iST;

	/** @type {number} */
	var iItemHeight = this["iGetItemHeight"]();

	if (iTop > this["oDomContent"]["offsetHeight"] + iScrollTop - iItemHeight) {
		while (iTop > this["oDomContent"]["offsetHeight"] + iScrollTop - iItemHeight) {
			this["oDomContent"]["scrollTop"] = iScrollTop = iScrollTop + iItemHeight;
		}
	} else if (iTop === 0) {
		this["oDomContent"]["scrollTop"] = 0;
	} else if (iTop < iScrollTop) {
		this["oDomContent"]["scrollTop"] = iScrollTop - iItemHeight;
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["scrollItemIntoView"] = 0; };

/**
 * Focuses the selected item in the parent menu.
 * Used during keyboard navigation with arrow left.
 * @private
 */
UCF_PopupMenu["prototype"]["focusParentMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusParentMenu"]++; }; 
	if (this["bIsSubMenu"]) {
		this["oParentMenu"]["oSelectedItem"]["focus"]();
	} else {
		this["fireEvent"](this["E_EVENTS"]["PreviousMenu"], {});
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusParentMenu"] = 0; };

/**
 * @param { boolean } bWithKeyboard
 * Selects the first entry in the submenu.
 * Used during keyboard navigation with arrow right.
 * @private
 */
UCF_PopupMenu["prototype"]["focusSubMenu"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusSubMenu"]++; }; 
	if (this["oSelectedItem"]) {
		this["oSelectedItem"]["openSubMenu"](true);
		if (this["oSelectedItem"] != null && !this["oSelectedItem"]["oSubMenu"]) {
			this["fireEvent"](this["E_EVENTS"]["NextMenu"], {});
		} else {
			this["oSelectedItem"]["oSubMenu"]["setSelectedItem"](
				// bWithKeyboard ?
				// this.oSelectedItem.oSubMenu.oGetFirstEnabledItem() : this.oSelectedItem.oSubMenu.oGetFirstVisibleItem(),
				this["oSelectedItem"]["oSubMenu"]["oGetFirstVisibleItem"](),
				false
			);
		}
	} else {
		this["fireEvent"](this["E_EVENTS"]["NextMenu"], {});
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["focusSubMenu"] = 0; };

/**
 * Handles the key down event on the menu for keyboard navigation
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private

UCF_PopupMenu.prototype.onkeyup = function(oBrowserEvent) {

	if (this.bHasParentAutoRefocusKeyup()) {
		if (!this.bIsSubMenu) {
			if (UCF_KeyboardHelper.bIsEventForKey(oBrowserEvent, UCF_KeyCodes.SPACE) ||
				UCF_KeyboardHelper.bIsEventForKey(oBrowserEvent, UCF_KeyCodes.ENTER)) {
				this.autoRefocus();
			}
			oBrowserEvent.cancel();
			oBrowserEvent.cancelBubble();
		} else
			this.oParentMenu.onkeyup(oBrowserEvent);
	} else {
		oBrowserEvent.cancel();
		oBrowserEvent.cancelBubble();
	}
};
 */
/**
 * Handles the key down event on the menu for keyboard navigation
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_PopupMenu["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onkeydown"]++; }; 
	/** @type {number} */
	var iKeyCode;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenu.js(1698): onkeydown"); };

	iKeyCode = oBrowserEvent["iKeyCode"]();
	//_trace(INFO, '>>> PopupMenu keydown: ' + iKeyCode);
	if (oBrowserEvent["bCtrl"]() || oBrowserEvent["bAlt"]()) {
		if (iKeyCode === UCF_KeyCodes["ARROW_UP"] ||
			iKeyCode === UCF_KeyCodes["ARROW_DOWN"]
		) {
			this["close"](true);
		} else {

			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '>>> PopupMenu cancelling keydown: ' + iKeyCode, "PopupMenu.js(1709): onkeydown"); };
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();

		}
	} else if ( /*iKeyCode === UCF_KeyCodes.ESCAPE	||*/
		iKeyCode === UCF_KeyCodes["F4"]
	) {
		this["close"](true);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (iKeyCode === UCF_KeyCodes["TAB"]) {
		this["closeAll"](true);
		// just cancel the event and do not cancel bubbling
		// and the browser will focus the next or prev control
		this["cancel"](true);
	} else if ((iKeyCode === UCF_KeyCodes["ARROW_LEFT"] && !window["UCF_System"]["bIsRTL"])
		|| (iKeyCode === UCF_KeyCodes["ARROW_RIGHT"] && window["UCF_System"]["bIsRTL"])
	) {
		this["cancel"](false);
		this["focusParentMenu"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (iKeyCode === UCF_KeyCodes["ARROW_DOWN"]) {
		this["focusNextItem"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (iKeyCode === UCF_KeyCodes["ARROW_UP"]) {
		this["focusPreviousItem"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if ((iKeyCode === UCF_KeyCodes["ARROW_RIGHT"] && !window["UCF_System"]["bIsRTL"])
		|| (iKeyCode === UCF_KeyCodes["ARROW_LEFT"] && window["UCF_System"]["bIsRTL"])
	) {
		this["focusSubMenu"](true);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (iKeyCode === UCF_KeyCodes["HOME"]) {
		this["focusFirstItem"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (iKeyCode === UCF_KeyCodes["END"]) {
		this["focusLastItem"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '>>> PopupMenu cancelling keydown: ' + iKeyCode, "PopupMenu.js(1755): onkeydown"); };
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onkeydown"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_PopupMenu["prototype"]["onlsescape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsescape"]++; }; 
	//this.focusParentMenu();
	if (this["bIsSubMenu"] && this["oParentMenu"] && this["oParentMenu"]["oSelectedItem"]) {
		this["oParentMenu"]["oSelectedItem"]["focus"]();
	}
	this["close"](true);
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsescape"] = 0; };

/**
 * Handles the mouse move event on the menu
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_PopupMenu["prototype"]["onmousemove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onmousemove"]++; }; 
	// special behavior for items without submenu:
	// moving out of an item the selection is taken away
	// if a submenu was opened the selection is kept.
	/** @type {HTMLElement} */
	var oSourceRoot = oBrowserEvent["oGetSourceRoot"]();

	if (this["oSelectedItem"] &&
		oSourceRoot !== this["oSelectedItem"]["oDomRef"] &&
		!this["oSelectedItem"]["bStaySelected"]()
	) {
		this["setSelectedItem"](null);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onmousemove"] = 0; };

/**
 * Handles the mouseover event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_PopupMenu["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onmouseover"]++; }; 
	/** @type {HTMLElement} */
	var oCnt = this["oDomContent"];
	/** @type {number} */
	var iScrollTop = oCnt["scrollTop"];
	/** @type {boolean} */
	var bAtTop = oCnt["scrollTop"] === 0;
	/** @type {boolean} */
	var bAtBottom = iScrollTop + oCnt["offsetHeight"] >= oCnt["scrollHeight"];

	if (UCF_DomUtil["bContains"](this["oDomScrollUp"], oBrowserEvent["oGetSource"]()) &&
		!bAtTop
	) {
		this["oInterval"] = UCF_JsUtil["intervalCall"](100, this, 'scrollUp');
		if (this["oDomScrollUp"]["className"]["indexOf"]('Dsbl') === -1) {
			UCF_DomUtil["addClass"](this["oDomScrollUp"], 'urMnuScrHvr');
		}
	} else if (
		UCF_DomUtil["bContains"](this["oDomScrollDown"], oBrowserEvent["oGetSource"]()) &&
		!bAtBottom
	) {
		this["oInterval"] = UCF_JsUtil["intervalCall"](100, this, 'scrollDown');
		if (this["oDomScrollDown"]["className"]["indexOf"]('Dsbl') === -1) {
			UCF_DomUtil["addClass"](this["oDomScrollDown"], 'urMnuScrHvr');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onmouseover"] = 0; };

/**
 * Handles the touchstart event
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_PopupMenu["prototype"]["ontouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["ontouchstart"]++; }; 
	/** @type {HTMLElement} */
	var oCnt = this["oDomContent"];
	/** @type {number} */
	var iScrollTop = oCnt["scrollTop"];
	/** @type {boolean} */
	var bAtTop = oCnt["scrollTop"] === 0;
	/** @type {boolean} */
	var bAtBottom = iScrollTop + oCnt["offsetHeight"] >= oCnt["scrollHeight"];

	if (UCF_DomUtil["bContains"](this["oDomScrollUp"], oBrowserEvent["oGetSource"]()) &&
		!bAtTop
	) {
		if (this["oDomScrollUp"]["className"]["indexOf"]('Dsbl') === -1) {
			UCF_DomUtil["addClass"](this["oDomScrollUp"], 'urMnuScrHvr');
		}
		this["scrollUp"]();
		oBrowserEvent["cancel"]();
	} else if (
		UCF_DomUtil["bContains"](this["oDomScrollDown"], oBrowserEvent["oGetSource"]()) &&
		!bAtBottom
	) {
		if (this["oDomScrollDown"]["className"]["indexOf"]('Dsbl') === -1) {
			UCF_DomUtil["addClass"](this["oDomScrollDown"], 'urMnuScrHvr');
		}
		this["scrollDown"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["ontouchstart"] = 0; };

/**
 * Handles the touchend event
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_PopupMenu["prototype"]["ontouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["ontouchend"]++; }; 
	this["onmouseout"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["ontouchend"] = 0; };

/**
 * Handles the mouseout event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_PopupMenu["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onmouseout"]++; }; 
	if (UCF_DomUtil["bContains"](this["oDomScrollUp"], oBrowserEvent["oGetSource"]())) {
		UCF_DomUtil["removeClass"](this["oDomScrollUp"], 'urMnuScrHvr');
	} else if (
		UCF_DomUtil["bContains"](this["oDomScrollDown"], oBrowserEvent["oGetSource"]())
	) {
		UCF_DomUtil["removeClass"](this["oDomScrollDown"], 'urMnuScrHvr');
	}
	if (this["oInterval"]) {
		UCF_JsUtil["clearIntervalCall"](this["oInterval"]);
		this["oInterval"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onmouseout"] = 0; };

/**
 * Catches all events occurring on the window
 * handles mouse down and mousemove
 *
 * @param {UCF_Event} oEvent the Event object of Lightspeed
 * @private
 */
UCF_PopupMenu["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onAnyEvent"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');
	/** @type {HTMLElement} */
	var oSourceRoot = oBrowserEvent["oGetSourceRoot"]();
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {string} */
	var sName = oBrowserEvent["sGetName"]();
	// Only need to handle 'scroll' event for FF:
	// Other browsers will close menu on 'mousedown' on scrollbar or 'mousewheel' events
	/** @type {boolean} */
	var bHandleScrollEvent = UCF_UserAgent["bIsFirefox"]() || this["bIsTCM"]();

	if (UCF_DomUtil["bContains"](UCF_DomUtil["$"](this["sId"] + '-header-tooltip'), oSource) ||
			UCF_DomUtil["bContains"](UCF_DomUtil["$"](this["sId"] + '-header-text'), oSource) ||
			UCF_DomUtil["bContains"](UCF_DomUtil["$"](this["sId"] + '-header-datatip'), oSource) ||
			this["bOverArrows"](oBrowserEvent)) {
		return;
	}

	if (sName === 'mousedown' || sName === 'touchstart') {
		if (!oSourceRoot ||
			oSourceRoot === document ||
			(oSourceRoot["getAttribute"]('ct') !== 'POMNI' &&
				// 2009/07/02 changed oSourceRoot to oSource after discussion with
				// Martin
				!UCF_DomUtil["bContains"](this["oOpenerRef"], oSource) &&
				this["oOpenerRef"] !== oSource
			) ||
			(oSourceRoot["getAttribute"]('ct') !== 'POMNI' &&
				oBrowserEvent["eGetMouseButtonState"]() ===
				oBrowserEvent["MOUSE_BUTTON_STATE"]["Right"])
		) {
			this["close"](true);
		}
	} else if (sName === 'lsfocuslost') {
		this["bAutoRefocus"] = false;
		this["closeAll"]();
	} else if (sName === 'mouseover') {
		if (this["oSelectedItem"] &&
			oSourceRoot !== this["oSelectedItem"]["oDomRef"] &&
			!this["oSelectedItem"]["bStaySelected"]()) {
			this["setSelectedItem"](null);
		}
	}
	/*else if (sName === 'lsdragstart') {
		oDragSourceDomRef = oBrowserEvent.oGetSource();
		if (!UCF_DomUtil.bContains(this.oDomRef, oDragSourceDomRef)) {
			this.closeAll();
		}
	}*/
	else if (
		!this["bAvoidImmediateClose"] &&
		(sName === 'mousewheel' || (sName === 'scroll' && bHandleScrollEvent))
	) {
		// 2/2/2016 - Still the menu annoyingly is closing itself, in the case
		// where the body has a vertical scrollbar:
		// - When a sub-menu is opened and it would calculate the height a few
		//   pixels to big => scroll event
		// - When a sub-menu is closed and calls focusParentMenu() => scroll
		//   event
		// With this flag scroll events are not processed during sub-menu
		// open/close
		if (this["bDoNotProcessScrollEvents"]) {
			return;
		}

		// CSN: 0731492 2014 scroll with mousewheel outside popupmenu
		if (oSource &&
			!UCF_DomUtil["oGetParentByAttribute"](oSource, 'pmnu', 'X')
		) {
			this["closeAll"]();
		}
	} else if (!this["bAvoidImmediateClose"] && sName === 'resize') {
		// Workaround: On some screens in ITS the IE misbehaves and fires wrong
		// resize events (e.g. during DOM read access).  This may even happen
		// when hovering over an open menu and it would close itself !
		if (this["sOpen2Call"]) {
			UCF_JsUtil["clearDelayedCall"](this["sOpen2Call"]);
		}
		if (this["iX"]) {
			this["setLeft"](this["iX"]);
		}
		this["sOpen2Call"] = UCF_JsUtil["delayedCall"](10, this, 'open2');
	}
	/*else if (this.bIsTCM() && sName === 'touchmove') {
		var oSrc = oBrowserEvent.oGetSource();
		if (oSrc && !UCF_DomUtil.bContains(this.oDomRef, oSrc)) {
			this.closeAll();
		}
	}*/

};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onAnyEvent"] = 0; };

/**
 * Remove special items from DOM and internal this.aItems array.
 * Also remove tooltip header.
 */
UCF_PopupMenu["prototype"]["removeTouchContextMenuItems"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["removeTouchContextMenuItems"]++; }; 
	this["iTouchMenuItemCount"] = 0;
	this["aItems"] = UCF_JsUtil["filter"](
		this["aItems"],
		/**
		 * @param {UCF_PopupMenuItem} oItem
		 * @return {boolean}
		 */
		function(oItem) {
			if (oItem["bIsTouchContextMenuItem"]) {
				UCF_DomUtil["removeFromDom"](oItem["oDomRef"]);
				oItem["destroy"]();
				return false;
			} else {
				return true;
			}
		}
	);
	if (this["bHasHeader"]) {
		UCF_DomUtil["addClass"](UCF_DomUtil["$"](this["sId"] + '-header-tooltip'), 'lsElement--invisible');
		UCF_DomUtil["addClass"](UCF_DomUtil["$"](this["sId"] + '-header-text'), 'lsElement--invisible');
		UCF_DomUtil["addClass"](UCF_DomUtil["$"](this["sId"] + '-header-datatip'), 'lsElement--invisible');
		this["bHasHeader"] = false;
		//UCF_DomUtil.$(this.sId + '-cnt').removeAttribute('hasheader');
		UCF_DomUtil["removeClass"](UCF_DomUtil["$"](this["sId"] + '-cnt'), '.lsMnu--contextmenu-hasheader');
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["removeTouchContextMenuItems"] = 0; };

/**
 * Use the special DIV above the items to display the given tooltip text
 * @param {string} sText
 * @param {string} sType
 * @private
 */
UCF_PopupMenu["prototype"]["addTouchContextMenuHeader"] = function(sText, sType) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["addTouchContextMenuHeader"]++; }; 
	var oTTHeader = UCF_DomUtil["$"](this["sId"] + '-header-' + sType["toLowerCase"]());
	UCF_DomUtil["removeClass"](oTTHeader, 'lsElement--invisible');
	//oTTHeader.style.webkitUserSelect = 'text';
	UCF_DomUtil["setInnerText"](oTTHeader, sText);
	this["bHasHeader"] = true;
	//UCF_DomUtil.$(this.sId + '-cnt').setAttribute('hasheader', 'true');
	UCF_DomUtil["addClass"](UCF_DomUtil["$"](this["sId"] + '-cnt'), '.lsMnu--contextmenu-hasheader');
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["addTouchContextMenuHeader"] = 0; };

/**
 * Add a menu item at first position with client-side rendering.
 * @param {Object} oTouchContextMenuEntry
 */
UCF_PopupMenu["prototype"]["addTouchContextMenuItemTop"] = function(oTouchContextMenuEntry) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["addTouchContextMenuItemTop"]++; }; 

	this["CTXMNU_ITEM_DEFAULT_PROPS"] = this["CTXMNU_ITEM_DEFAULT_PROPS"] || (function() { // eslint-disable-line @ur/no-memory-leaks
		var oResult = {};
		var oCI = UCF_ClassLoader["oGetClass"]("UCF_ClientInterfaces");
		UCF_JsUtil["forEach"](UCF_JsUtil["keys"](oCI["I"]["PopupMenuItem"]["properties"]), function(k) {
			oResult[k] = oCI["I"]["PopupMenuItem"]["properties"][k]["defaultValue"];
		});
		return oResult;
	})();

	var ID_PREFIX = this["sId"] + '_tcm_item_';
	var ITEM_ID = ID_PREFIX + this["iTouchMenuItemCount"]++;

	// Overwrite generic texts with the values provided via API parameters
	if (this["sCmDoubleClickText"] && oTouchContextMenuEntry["sType"] === 'DOUBLECLICK') {
		oTouchContextMenuEntry["sText"] = this["sCmDoubleClickText"];
	} else if (this["sCmQuickViewText"] && oTouchContextMenuEntry["sType"] === 'QUICKVIEW') {
		oTouchContextMenuEntry["sText"] = this["sCmQuickViewText"];
	}

	// Inject HTML
	/** @type {HTMLTableBodyElement} */
	var oTableBody = this["oDomTable"]["getElementsByTagName"]('TBODY')[0];
	UCF_DomUtil["setStyle"](this["oDomTable"]["parentNode"]["parentNode"]["parentNode"], {
		"overflow": 'visible'
	});
	var oTmpTable = document["createElement"]('TABLE');
	var oTmpBody = document["createElement"]('TBODY');
	oTmpTable["appendChild"](oTmpBody);
	UCF_DomUtil["setInnerHtml"](oTmpBody, this["oLS"]["oGetRenderManager"]()["callFragment"](
		'PopupMenuItemFragment',
		'PopupMenu', {
			"Item": UCF_JsUtil["extend"](this["CTXMNU_ITEM_DEFAULT_PROPS"], {
				"Id": ITEM_ID,
				"Text": oTouchContextMenuEntry["sText"]
			})
		}
	));
	oTableBody["insertBefore"](oTmpBody["firstChild"], oTableBody["firstChild"]);

	// Update internal objects/data
	/** @type {UCF_PopupMenuItem} */
	var oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oTableBody["firstChild"], true);
	oItem["oMenu"] = this;
	oItem["iIndex"] = 0;
	// Attach flag and data to the PopupMenuItem instance
	oItem["bIsTouchContextMenuItem"] = true;
	oItem["oTouchContextMenuEntry"] = oTouchContextMenuEntry;
	// Add to internal list of items
	UCF_JsUtil["forEach"](this["aItems"], function (oItem) { oItem["iIndex"]++; });
	this["aItems"] = [oItem]["concat"](this["aItems"]);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["addTouchContextMenuItemTop"] = 0; };

UCF_PopupMenu["prototype"]["prepareTouchContextMenu"] = function(oOpenerControl) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["prepareTouchContextMenu"]++; }; 
	this["oTouchContextMenuOpenerControl"] = oOpenerControl;

	if (this["oTouchContextMenuOpenerControl"]) {
		// Fill this.aItems, which would otherwise happen later in applyHeight() during open() ....
		this["aGetVisibleItems"]();

		// Ask opener control for list of extra items
		var aTouchContextMenuEntries = this["oTouchContextMenuOpenerControl"]["aGetTouchContextMenuEntries"](
			this["oLS"]["oGetPageInternal"]()["oGetContextMenuEventData"]()
		);
		// Add to top of menu in the same order as contained in the array(!)
		// and handle special header text entries
		for (var i = aTouchContextMenuEntries["length"] - 1; i >= 0; i--) {
			if (aTouchContextMenuEntries[i]["sType"] === 'TOOLTIP' ||
					aTouchContextMenuEntries[i]["sType"] === 'TEXT' ||
					aTouchContextMenuEntries[i]["sType"] === 'DATATIP') {
				this["addTouchContextMenuHeader"](aTouchContextMenuEntries[i]["sText"], aTouchContextMenuEntries[i]["sType"]);
			} else {
				this["addTouchContextMenuItemTop"](aTouchContextMenuEntries[i]);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["prepareTouchContextMenu"] = 0; };

/**
 * Handle onlslongtap event.
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupMenu["prototype"]["onlslongtap"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlslongtap"]++; }; 
	// No touch-contextmenu on the touch-contextmenu...
	if (this["bIsTCM"]()) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlslongtap"] = 0; };

/**
 * Handle onlslongtapend event.
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupMenu["prototype"]["onlslongtapend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlslongtapend"]++; }; 
	// No touch-contextmenu on the touch-contextmenu...
	if (this["bIsTCM"]()) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlslongtapend"] = 0; };

/**
 * Handle onlsextralongtap event.
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupMenu["prototype"]["onlsextralongtap"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsextralongtap"]++; }; 
	// No touch-contextmenu on the touch-contextmenu...
	if (this["bIsTCM"]()) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsextralongtap"] = 0; };

/**
 * Handle onlsextralongtapend event.
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupMenu["prototype"]["onlsextralongtapend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsextralongtapend"]++; }; 
	// No touch-contextmenu on the touch-contextmenu...
	if (this["bIsTCM"]()) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsextralongtapend"] = 0; };

/**
 * Retrieves an UCF_PopupMenuItem from the items collection by a given id#
 *
 * @private
 * @param {string} sId id of the menu item
 * @return {UCF_PopupMenuItem}
 */
UCF_PopupMenu["prototype"]["oGetItemById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetItemById"]++; }; 
	/** @type {Array.<UCF_PopupMenuItem>} */
	var aItems = this["aGetItems"]();
	/** @type {number} */
	var i;

	for (i = 0; i < aItems["length"]; i++) {
		if (aItems[i] && aItems[i]["sId"] === sId) {
			return aItems[i];
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetItemById"] = 0; };

/**
 * Scrolls the menu one item up
 * @private
 */
UCF_PopupMenu["prototype"]["scrollUp"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["scrollUp"]++; }; 
	// TODO: remove
	/** @type {UCF_PopupMenuItem} */
	var oSelectedItem = this["oSelectedItem"];

	if (oSelectedItem &&
		oSelectedItem["oSubMenu"] &&
		oSelectedItem["oSubMenu"]["bOpened"]
	) {
		oSelectedItem["closeSubMenu"]();
	}

	this["oDomContent"]["scrollTop"] =
		this["oDomContent"]["scrollTop"] -
		this["iGetItemHeight"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["scrollUp"] = 0; };

/**
 * Scrolls the menu one item down
 * @private
 */
UCF_PopupMenu["prototype"]["scrollDown"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["scrollDown"]++; }; 
	/** @type {UCF_PopupMenuItem} */
	var oSelectedItem = this["oSelectedItem"];

	if (oSelectedItem &&
		oSelectedItem["oSubMenu"] &&
		oSelectedItem["oSubMenu"]["bOpened"]
	) {
		oSelectedItem["closeSubMenu"]();
	}

	this["oDomContent"]["scrollTop"] =
		this["oDomContent"]["scrollTop"] +
		this["iGetItemHeight"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["scrollDown"] = 0; };

/**
 * Sets the control id of the control that opened the PopupMenu
 *
 * @param {string} sId
 * @private
 */
UCF_PopupMenu["prototype"]["setOpenerId"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setOpenerId"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sId === 'string', "typeof sId === 'string'", "PopupMenu.js(2245): setOpenerId"); };
	this["sOpenerId"] = sId; // eslint-disable-line @ur/no-memory-leaks
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setOpenerId"] = 0; };

/**
 * Overwrite base-class method to return the opener in case of sub-menus.
 * @override
 */
UCF_PopupMenu["prototype"]["oGetOpenerRef"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetOpenerRef"]++; }; 
	/** @type {UCF_PopupMenuItem} */
	var oPMItem = this["oGetControlByDomRef"](this["oOpenerRef"], false);

	return (oPMItem && UCF_JsUtil["bInstanceOf"](oPMItem, 'UCF_PopupMenuItem'))
		? oPMItem["oMenu"]["oGetOpenerRef"]()
		: this["oOpenerRef"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetOpenerRef"] = 0; };

/**
 * Sets the userdata of the control that opened the PopupMenu
 *
 * @private
 * @param {string} sUserData the user data to set
 */
UCF_PopupMenu["prototype"]["setUserData"] = function(sUserData) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setUserData"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sUserData === 'string', "typeof sUserData === 'string'", "PopupMenu.js(2269): setUserData"); };
	this["sUserData"] = sUserData;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setUserData"] = 0; };

/**
 * Selects an item and fires the corresponding internal and semantic events.
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browserevent
 */
UCF_PopupMenu["prototype"]["selectItem"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["selectItem"]++; }; 
	/** @type {boolean} */
	var bRadioItemChecked;
	/** @type {string} */
	var sItemId;
	/** @type {boolean} */
	var bChecked;
	/** @type {string} */
	var sUserData;
	/** @type {string} */
	var sOpenerId;

	if (this["oSelectedItem"]) {

		// Handling for selection of Touch-ContextMenu items
		if (this["oSelectedItem"]["bIsTouchContextMenuItem"]) {
			if (this["oTouchContextMenuOpenerControl"] && this["oSelectedItem"]["oTouchContextMenuEntry"]["fTrigger"]) {
				var fTrigger = this["oSelectedItem"]["oTouchContextMenuEntry"]["fTrigger"];
				this["closeAll"]();
				// generic action of extra items, e.g. fire DoubleClick or open a QuickView
				fTrigger();
			}
			return;
		}

		bRadioItemChecked = this["oSelectedItem"]["bCanCheck"] &&
			this["oSelectedItem"]["bChecked"] &&
			this["oSelectedItem"]["sGroupId"] !== '';

		if (this["oSelectedItem"]["bEnabled"] &&
			!bRadioItemChecked && (
				!this["oSelectedItem"]["bHasSubMenu"] || (
					this["oSelectedItem"]["bHasSubMenu"] &&
					this["oSelectedItem"]["bHasSubMenuSection"]
				)
			)
		) {
			sItemId = this["oSelectedItem"]["sId"];
			bChecked = this["oSelectedItem"]["bChecked"];
			sUserData = this["sUserData"];

			// select may already closes the popup so that this.oSelectedItem will be
			// destroyed after the following statement
			this["fireEvent"](
				this["E_EVENTS"]["Select"], { "sItemId": this["oSelectedItem"]["sId"], "oBrowserEvent": oBrowserEvent }
			);

			sOpenerId = this["sOpenerId"] || '';
			// TODO:
			// The OpenedId parameter should be EMPTY if there is actually no opener:
			// This is a very old bug, that now needs another workaround because of the dummy-opener
			// see openAtPosition() -> openAtControl() -> setOpenerId()
			if (sOpenerId["indexOf"]('-lsPopupMenuElement') === 0) {
				sOpenerId = sOpenerId["replace"]('-lsPopupMenuElement', '');
			}

			this["closeAll"](oBrowserEvent["bIsKeyboardTriggered"]());

			this["fireSelect"](this["sId"], sItemId, sOpenerId, bChecked, sUserData);
		} else if (this["oSelectedItem"]["bEnabled"] && bRadioItemChecked) {
			this["closeAll"](oBrowserEvent["bIsKeyboardTriggered"]());
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["selectItem"] = 0; };

/**
 * Handles the click event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_PopupMenu["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenu.js(2350): onclick"); };

	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}

	if (this["bOverArrows"](oBrowserEvent)) {
		if (UCF_DomUtil["bHasClass"](
				oBrowserEvent["oDomEvent"]["srcElement"],
				'urMnuScrUp')) {
			this["scrollUp"]();
		} else if (UCF_DomUtil["bHasClass"](
				oBrowserEvent["oDomEvent"]["srcElement"],
				'urMnuScrDwn'
			)) {
			this["scrollDown"]();
		}
	} else if (UCF_DomUtil["bContains"](UCF_DomUtil["$"](this["sId"] + '-header-tooltip'), oBrowserEvent["oGetSource"]()) ||
		UCF_DomUtil["bContains"](UCF_DomUtil["$"](this["sId"] + '-header-text'), oBrowserEvent["oGetSource"]()) ||
		UCF_DomUtil["bContains"](UCF_DomUtil["$"](this["sId"] + '-header-datatip'), oBrowserEvent["oGetSource"]())) {
		// Do nothing: Maybe user is trying tabhold gesture to select the tooltip text
		return;
	} else {
		this["selectItem"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onclick"] = 0; };

/**
 * Handles the context menu event on the popupmenu
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_PopupMenu["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oncontextmenu"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenu.js(2384): oncontextmenu"); };

	this["selectItem"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oncontextmenu"] = 0; };

/**
 * Handles the lsselect event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_PopupMenu["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsselect"]++; }; 
	// Case with Button-Menu opened with ENTER and looong keypress
	// The repeated keydown would already "hit" the menu item
	if (oBrowserEvent["bRepeat"]()) {
		return;
	}
	this["oSelectDownOnElement"] = oBrowserEvent["oGetSource"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsselect"] = 0; };

/**
 * Handles the lsselectup event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_PopupMenu["prototype"]["onlsselectup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsselectup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenu.js(2413): onlsselectup"); };

	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}

	// Case with Button-Menu opened with ENTER (down)
	// onlsselectup will fire on the PopupMenu item that was already selected and focussed during open()
	// => Process the selectup ONLY if there also was a select on the same item.
	if (this["oSelectDownOnElement"] !== oBrowserEvent["oGetSource"]()) {
		return;
	}
	this["oSelectDownOnElement"] = null;

	if (this["oSelectedItem"] && this["oSelectedItem"]["bEnabled"] && this["oSelectedItem"]["bHasSubMenu"]) {
		this["focusSubMenu"](true);
	} else {
		this["selectItem"](oBrowserEvent);
	}

	// The onlsselect is originally triggered by a 'keydown'
	// This has to be canceled because this event selects an menu item and
	// probably sets the focus back to the 'sLastFocusedId'. The follow up events
	// like 'keyup', 'keypress' and when buttons or links are involved even a
	// 'click' are fired on the 'lastFocussed' control, which is improper.
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsselectup"] = 0; };

/**
 * This is a heuristic effort to detect if the menu lost the focus because of
 * an access-key. Fortunately, in IE the focusout event has infos about the
 * alt-key and the next element that will get the focus. Access-keys are not
 * supported on other browser. If we do not close this menu, the focus could
 * move to e.g. another menu-button and if the menu is opened via keyboard we
 * would end up with two popup menus open at the same time.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the lsblur
 */
UCF_PopupMenu["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsblur"]++; }; 
	/** @type {HTMLElement} */
	var oToElement;
	/** @type {UCF_Control} */
	var oToControl;

	if ((UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) &&
		oBrowserEvent["oDomEvent"]["altKey"] &&
		oBrowserEvent["oDomEvent"]["altLeft"]
	) {
		oToElement = oBrowserEvent["oDomEvent"]["toElement"];
		if (oToElement) {
			oToControl = this["oLS"]["oGetControlById"](oToElement["id"]);
			if (oToControl &&
				!UCF_JsUtil["bInstanceOf"](oToControl, 'UCF_PopupMenu')
			) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Closing popupmenu because of access-key', "PopupMenu.js(2468): onlsblur"); };
				this["close"](true);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsblur"] = 0; };

/**
 * Sets RemoveOnClose flag to determine whether the menu can be removed
 * from the dom when it has been closed
 *
 * @private
 * @param {boolean} bRemoveOnClose
 */
UCF_PopupMenu["prototype"]["setRemoveOnClose"] = function(bRemoveOnClose) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setRemoveOnClose"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof bRemoveOnClose === 'boolean', "typeof bRemoveOnClose === 'boolean'", "PopupMenu.js(2483): setRemoveOnClose"); };
	this["bRemoveOnClose"] = bRemoveOnClose;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setRemoveOnClose"] = 0; };

/**
 * Sets AutoRefocus flag to be able to set the focus to the last element
 * which had the focus before the menu was opened.
 * This can be used by frameworks, who are not able to use the
 * internal Close event
 *
 * @param {boolean} bAutoRefocus
 * @private
 */
UCF_PopupMenu["prototype"]["setAutoRefocus"] = function(bAutoRefocus) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setAutoRefocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof bAutoRefocus === 'boolean', "typeof bAutoRefocus === 'boolean'", "PopupMenu.js(2497): setAutoRefocus"); };
	this["bAutoRefocus"] = bAutoRefocus;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setAutoRefocus"] = 0; };

// /**
//  * Do the refocusing on keyup event if the closing of the menu was triggered by
//  * a keyboard event (ESC or ENTER/SPACE when a sub-menu is selected).
//  * Feature for "WCAG 2.1 pointer cancellation".
//  *
//  * @param {boolean} bAutoRefocusKeyup
//  * @private
//  */
// UCF_PopupMenu.prototype.setAutoRefocusOnKeyup = function(bAutoRefocusKeyup) {
// 	_assert(typeof bAutoRefocusKeyup === 'boolean');
// 	this.setAutoRefocus(bAutoRefocusKeyup);
// 	this.bAutoRefocusKeyup = bAutoRefocusKeyup;
// };

/**
 * Handles also PopupMenuItems (which get focussed when selected/hovered)
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_PopupMenu["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper;
	/** @type {number} */
	var iCount;
	/** @type {Array.<UCF_PopupMenuItem>} */
	var aItems;
	/** @type {number} */
	var x;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenu.js(2530): onlsaccessibility"); };

	oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (this["oSelectedItem"]) {
		oAccessibilityHelper["setText"](
			this["oSelectedItem"]["sModifiedText"] || this["oSelectedItem"]["sText"]
		);
		oAccessibilityHelper["setHotkey"](this["oSelectedItem"]["sHotkey"]);
		oAccessibilityHelper["setEnabled"](this["oSelectedItem"]["bEnabled"]);
		oAccessibilityHelper["setControlType"]('POMN_I');

		// find the selected item
		iCount = 0;
		aItems = this["aGetVisibleItems"]();
		for (x = 0; x < aItems["length"]; x++) {
			if (aItems[x]["bIsItemVisible"]) {
				if (aItems[x] === this["oSelectedItem"]) {
					oAccessibilityHelper["setItemIndex"](iCount + 1);
				}
				iCount++;
			}
		}
		oAccessibilityHelper["setItemCount"](iCount);

		if (this["oSelectedItem"]) {
			oAccessibilityHelper["addSemantic"](this["oSelectedItem"]["sSemanticColor"]);
		}

		if (this["oSelectedItem"]["bCanCheck"]) {
			oAccessibilityHelper["setSelected"](this["oSelectedItem"]["bChecked"]);
			if (this["oSelectedItem"]["bChecked"]) {
				if (!this["oSelectedItem"]["sGroupId"]) {
					oAccessibilityHelper["addEnabledTutor"](
						'POMN_I_SEL_TUT',
						this["oSelectedItem"]["bEnabled"]
					);
				}
			} else {
				oAccessibilityHelper["addEnabledTutor"](
					'POMN_I_NSEL_TUT',
					this["oSelectedItem"]["bEnabled"]
				);
			}
		} else if (this["oSelectedItem"]["bHasSubMenu"]) {
			oAccessibilityHelper["setControlType"]('POMN_ISMNU');

			if (this["oSelectedItem"]["bHasSubMenuSection"]) {
				oAccessibilityHelper["addEnabledTutor"](
					'POMN_ISMNUSCT_TUT',
					this["oSelectedItem"]["bEnabled"]
				);
			} else {
				oAccessibilityHelper["addEnabledTutor"](
					'POMN_ISMNU_TUT',
					this["oSelectedItem"]["bEnabled"]
				);
			}
		} else {
			oAccessibilityHelper["addEnabledTutor"](
				'POMN_I_NSEL_TUT',
				this["oSelectedItem"]["bEnabled"]
			);
		}

		oBrowserEvent["cancelBubble"]();
	} else {
		oAccessibilityHelper["addTutor"]('UDNAV_TUT');
		oAccessibilityHelper["setControlType"](
			'POMN',
			[this["aGetVisibleItems"]()["length"]]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onlsaccessibility"] = 0; };

/**
 * Removes the item
 * @public
 * @param {UCF_PopupMenuItem|UCF_Interface} oItem item that will be removed
 */
UCF_PopupMenu["prototype"]["removeItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["removeItem"]++; }; 
	/** @type {Array.<UCF_PopupMenuItem>} */
	var aItems;
	/** @type {number} */
	var i;
	/** @type {UCF_PopupMenuItem} */
	var oMenuItem;

	this["bContentChanged"] = true;
	aItems = this["aGetItems"]();

	for (i = 0; i < aItems["length"]; i++) {
		oMenuItem = aItems[i];
		var bFound = oMenuItem === oItem;
		if (!bFound && oItem instanceof UCF_Interface) {
			bFound = oMenuItem === this["oLS"]["oControlFactory"]["oGetControlById"](oItem["sGetId"]());
		}
		if (bFound) {
			oMenuItem["remove"]();
		}
	}
	this["aItems"] = this["aGetItems"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["removeItem"] = 0; };

/**
 * Removes all items from the menu.
 * @public
 */
UCF_PopupMenu["prototype"]["removeItems"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["removeItems"]++; }; 
	this["bContentChanged"] = true;
	UCF_JsUtil["forEach"](this["aGetItems"](), function(oItem) { oItem["remove"](); });
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["removeItems"] = 0; };

/**
 * Append an menu Item at the end of the menu
 *
 * @public
 * @param {string} sId the id of the item
 * @param {string} sText the text of the item
 * @param {boolean} bHasSeparator `true` if the item has a separator
 * @param {boolean} bCanCheck `true` if the item can be checked
 * @param {boolean} bChecked `true` if the item is checked
 * @param {boolean} bEnabled `true` if the item is enabled
 * @param {string} sSubMenuId the id of the associated submenu
 * @param {boolean} bHasSubMenu `true` if the item has a submenu
 * @param {string} sShortcutText the shortcut text of the item
 * @param {boolean} bHasElipsis `true` if the item has ellipsis truncation
 * @param {string} sGroupId the id of the group the item is in
 * @param {boolean} bHasIcon `true` if the item has an icon
 * @param {string} sEnabledIconSrc the enabled icon src of the item
 * @param {string} sDisabledIconSrc the disabled icon src of the item
 * @param {boolean} bHasSubMenuSection `true` if the item has a submenu section
 * @param {string} sHotkey the hotkey of the item
 * @param {string} sTooltip the tooltip of the item
 * @param {string} sItemCount the item count
 */
UCF_PopupMenu["prototype"]["addItem"] = function(sId, sText, bHasSeparator, bCanCheck, bChecked, bEnabled, sSubMenuId, bHasSubMenu, sShortcutText, bHasElipsis, sGroupId, bHasIcon, sEnabledIconSrc, sDisabledIconSrc, bHasSubMenuSection, sHotkey, sTooltip, sItemCount) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["addItem"]++; }; 
	/** @type {HTMLTableRowElement} */
	var oItemDomRef;
	/** @type {HTMLTableBodyElement} */
	var oTableBody;
	/** @type {UCF_PopupMenuItem} */
	var oItem;

	this["bContentChanged"] = true;

	oItemDomRef = document["createElement"]('TR');
	oItemDomRef["setAttribute"]('ct', 'POMNI');
	oItemDomRef["setAttribute"]('id', sId);

	oTableBody = this["oDomTable"]["getElementsByTagName"]('TBODY')[0];
	UCF_DomUtil["setStyle"](this["oDomTable"]["parentNode"]["parentNode"]["parentNode"], {
		"overflow": 'visible'
	});
	oTableBody["appendChild"](oItemDomRef);

	oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oItemDomRef, true);
	oItem["oMenu"] = this;
	oItem["iIndex"] = this["aItems"]["length"];
	oItem["sId"] = sId;
	oItem["sText"] = sText;
	oItem["bCanCheck"] = bCanCheck;
	oItem["bChecked"] = bChecked;
	oItem["bEnabled"] = bEnabled;
	oItem["sSubMenuId"] = sSubMenuId;
	oItem["bHasSubMenu"] = bHasSubMenu;
	oItem["bHasSeparator"] = bHasSeparator;
	oItem["sShortcutText"] = sShortcutText;
	oItem["bHasElipsis"] = bHasElipsis;
	oItem["sGroupId"] = sGroupId;
	oItem["bHasIcon"] = bHasIcon;
	oItem["sEnabledIconSrc"] = sEnabledIconSrc;
	oItem["sDisabledIconSrc"] = sDisabledIconSrc;
	oItem["bHasSubMenuSection"] = bHasSubMenuSection;
	oItem["sHotkey"] = sHotkey;
	oItem["sTooltip"] = sTooltip;
	oItem["sItemCount"] = sItemCount;

	// !!!
	// Constructor of PopupMenuItem is executed during oGetControlByDomRef() but
	// the attributes are set afterwards. We have to copy/paste all code from the
	// constructor here that uses these attributes. So, currently, until someone
	// makes a change to the constructor:
	// !!!
	if (oItem["bHasSubMenu"]) {
		oItem["sSubMenuClass"] = ' lsMnuSubMenu';
	}

	oItem["append"](oTableBody);
	this["aItems"]["push"](oItem);

	// need item height which is style-dependent since corbu
	this["readItemHeight"](oItemDomRef);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["addItem"] = 0; };

/** @type {string} */
UCF_PopupMenu["sThemeHeight"] = null;

/**
 * @private
 * @param {HTMLElement} oDom the item
 */
UCF_PopupMenu["prototype"]["readItemHeight"] = function(oDom) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["readItemHeight"]++; }; 
	/** @type {number} */
	var OLD_DEFAULT;

	if (this["iItemHeight"] === undefined) {
		OLD_DEFAULT = 18; // Old default value for ALL themes (before corbu)
		UCF_PopupMenu["sThemeHeight"] = UCF_PopupMenu["sThemeHeight"]
			|| UCF_DomUtil["sGetCurrentStyle"](oDom, 'height');

		// 'auto': IE (quirks) value if no height is set in theme/css
		if (UCF_PopupMenu["sThemeHeight"] === 'auto') {
			this["iItemHeight"] = OLD_DEFAULT; // eslint-disable-line @ur/no-memory-leaks
		} else {
			this["iItemHeight"] = parseInt(UCF_PopupMenu["sThemeHeight"]);
			// FF in standards mode reports 15 if no height is set in css
			if (this["iItemHeight"] < OLD_DEFAULT) {
				this["iItemHeight"] = OLD_DEFAULT;
			}
			// Note: FF in quirks mode reports 20 if no height is set ... no
			// workaround available.
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["readItemHeight"] = 0; };

/**
 * implements method from UCF_Control
 * @private
 */
UCF_PopupMenu["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["createDragDelegate"]++; }; 
	if (this["sDragSourceInfo"] && !this["oDragDelegate"]) {
		this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_PopupMenuDragDelegate"))(this["oLS"], this);
		this["addDelegate"](this["oDragDelegate"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["createDragDelegate"] = 0; };

/**
 * implements method from UCF_Control
 * @private
 */
UCF_PopupMenu["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["createDropDelegate"]++; }; 
	if (this["sDropTargetInfo"] && !this["oDropDelegate"]) {
		this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_PopupMenuDropDelegate"))(this["oLS"], this);
		this["addDelegate"](this["oDropDelegate"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["createDropDelegate"] = 0; };

/**
 * Sets the width of the whole menu.
 * Necessary in connection with the show/hideMenuItem methods.
 * After Items have been hidden, the content may shrink and thus need a new
 * width. The width has to be taken from the content. Use the content's
 * scrollWidth property to receive the correct width.
 * @private
 * @param {number} iWidth the new width
 */
UCF_PopupMenu["prototype"]["setMenuWidth"] = function(iWidth) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setMenuWidth"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iWidth === 'number', "typeof iWidth === 'number'", "PopupMenu.js(2788): setMenuWidth"); };

	if (iWidth != null && this["oRootRef"]["style"] && UCF_DomUtil["$"](this["sId"] + '-container')) {
		this["oRootRef"]["style"]["width"] = iWidth + 'px';
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setMenuWidth"] = 0; };

/**
 * Sets the width of the whole menu based on the scroll. Used by Toolbar and
 * constructor.
 * @private
 */
UCF_PopupMenu["prototype"]["resetMenuWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["resetMenuWidth"]++; }; 
	var w = this["oDomContent"]["scrollWidth"];
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetVisualViewport"]();
	w = Math["min"](w, oViewportObjectRect["width"]);
	this["oDomContent"]["style"]["width"] = w + 'px';
	if (this["bHasHeader"]) {
		this["oDomContent"]["style"]["width"] = Math["max"](
			this["oDomContent"]["scrollWidth"],
			UCF_DomUtil["$"](this["sId"] + '-header-tooltip')["offsetWidth"],
			UCF_DomUtil["$"](this["sId"] + '-header-text')["offsetWidth"],
			UCF_DomUtil["$"](this["sId"] + '-header-datatip')["offsetWidth"]
		);
	}
	this["setMenuWidth"](this["oDomContent"]["parentNode"]["scrollWidth"]);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["resetMenuWidth"] = 0; };

/**
 * Returns the number of items.
 * @public
 * @return {number} The number of items.
 */
UCF_PopupMenu["prototype"]["iGetItemCount"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetItemCount"]++; }; 
	return UCF_JsUtil["filter"](
		UCF_JsUtil["arrayFrom"](this["oDomContent"]["getElementsByTagName"]('TR')),
		function(oTR) { return oTR["getAttribute"]('ct'); }
	)["length"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetItemCount"] = 0; };

/**
 * Returns the PopupMenuItem at index iIndex.
 * @public
 * @param {number} iIndex Index of the desired item.
 * @return {UCF_PopupMenuItem} The PopupMenuItem at index iIndex.
 */
UCF_PopupMenu["prototype"]["oGetItemByIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetItemByIndex"]++; }; 
	/** @type {Array.<UCF_PopupMenuItem>} */
	var aItems = this["aGetItems"]();

	return iIndex >= 0 && iIndex < aItems["length"]
		? aItems[iIndex]
		: null;
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["oGetItemByIndex"] = 0; };

/**
 * Calculates this.aItems and this.aVisibleItems, then returns this.aVisibleItems
 * @private
 * @return {Array.<UCF_PopupMenuItem>}
 */
UCF_PopupMenu["prototype"]["aGetVisibleItems"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["aGetVisibleItems"]++; }; 
	/** @type {NodeList.<HTMLTableRowElement>} */
	var aDomItems = this["oDomContent"]["getElementsByTagName"]('TR');
	/** @type {boolean} */
	var bColumnsRendered = false;
	/** @type {number} */
	var iControlCount = 0;
	/** @type {number} */
	var iItemCount;
	/** @type {HTMLTableRowElement} */
	var oItemDomRef;
	/** @type {UCF_PopupMenuItem} */
	var oItem;

	this["aVisibleItems"] = [];
	this["aItems"] = [];

	for (iItemCount = 0; iItemCount < aDomItems["length"]; iItemCount++) {
		oItemDomRef = aDomItems[iItemCount];
		if (!bColumnsRendered &&
			oItemDomRef &&
			oItemDomRef["childNodes"]["length"] === 5 &&
			oItemDomRef["style"]["display"] !== 'none'
		) {
			bColumnsRendered = true;
		}
		if (oItemDomRef["getAttribute"]('ct')) {
			oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oItemDomRef, true);
			if (oItem) {
				if (!oItem["oMenu"]) {
					oItem["oMenu"] = this;
				}
				oItem["iIndex"] = iControlCount;
				if (oItem["bGetIsVisible"]() /* oItem.bIsVisible()*/ ) {
					this["aVisibleItems"]["push"](oItem);
				}
				this["aItems"]["push"](oItem);
				iControlCount++;
			}
		}
	}

	// For Touch-contextmenu: Mark all normal items that are followed by a "separator" item
	if (this["bIsTCM"]()) {
		for (var i = 0; i < this["aItems"]["length"] - 1; i++) {
			/** @type {UCF_PopupMenuItem} */
			var o = this["aItems"][i];
			if (this["aItems"][i + 1]["bHasSeparator"]) {
				UCF_DomUtil["addClass"](o["oDomRef"], 'lsMnu--contextmenu-nextitemisseparator');
			} else {
				UCF_DomUtil["removeClass"](o["oDomRef"], 'lsMnu--contextmenu-nextitemisseparator');
			}
		}
	}
	return this["aVisibleItems"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["aGetVisibleItems"] = 0; };

/**
 * Returns an array of PopupMenuItem controls.
 * @public
 * @return {Array.<UCF_PopupMenuItem>}
 */
UCF_PopupMenu["prototype"]["aGetItems"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["aGetItems"]++; }; 
	this["aGetVisibleItems"]();

	return this["aItems"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["aGetItems"] = 0; };

/**
 * IsContextMenu=true: Defines the text displayed for the generic item that triggers a DoubleClick event on the opener control
 * @param {string} sText The new text
 * @public
 */
UCF_PopupMenu["prototype"]["setCmDoubleClickText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setCmDoubleClickText"]++; }; 
	this["sCmDoubleClickText"] = sText; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("CmDoubleClickText", this["sCmDoubleClickText"], true);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setCmDoubleClickText"] = 0; };

/**
 * IsContextMenu=true: Defines the text displayed for the generic item that triggers opening of a QuickView on the opener control
 * @param {string} sText The new text
 * @public
 */
UCF_PopupMenu["prototype"]["setCmQuickViewText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setCmQuickViewText"]++; }; 
	this["sCmQuickViewText"] = sText; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("CmQuickViewText", this["sCmQuickViewText"], true);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setCmQuickViewText"] = 0; };

UCF_PopupMenu["prototype"]["onBeforeSetPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onBeforeSetPosition"]++; }; 
	if (this["bIsRightAttached"]() || this["bIsLeftAttached"]()) {
		if (UCF_PopupMenu["bIsFiori"]()) {
			this["iOffsetLeft"] = UCF_DomUtil["iRem2px"](parseFloat(this["themeValue"]('subMenuIndentX'), 10)); // eslint-disable-line @ur/no-memory-leaks
			this["iOffsetTop"] = -1 * UCF_DomUtil["iRem2px"](parseFloat(this["themeValue"]('subMenuIndentY'), 10)); // eslint-disable-line @ur/no-memory-leaks
		} else {
			this["iOffsetLeft"] = 2;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["onBeforeSetPosition"] = 0; };

UCF_PopupMenu["prototype"]["themeValue"] = function(sProperty) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["themeValue"]++; }; 
	/** @type {_StyleProperty} */
	var sMetaData;
	/** @type {Object} */
	var oMetaData;

	if (!UCF_PopupMenu["mThemeValueCache"]) {
		try {
			sMetaData = decodeURIComponent(UCF_DomUtil["sGetCurrentStyle"](
				UCF_DomUtil["$"](this["sId"] + '-container'),
				'background-image'
			));

			sMetaData = sMetaData["slice"](sMetaData["indexOf"]('{'), sMetaData["lastIndexOf"]('}') + 1);
			oMetaData = UCF_JsUtil["oJsonParse"](sMetaData);
			UCF_PopupMenu["mThemeValueCache"] = oMetaData;
		} catch (e) {
			console["error"](e["message"]);
		}
	}

	return UCF_PopupMenu["mThemeValueCache"][sProperty];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["themeValue"] = 0; };

/**
 * Returns whether the pointer for the menu shall be displayed:
 * For popup menus, it shall be displayed for the contextmenu only
 * @return {boolean}
 */
UCF_PopupMenu["prototype"]["bShowPointer"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bShowPointer"]++; }; 
	return this["bIsContextMenu"] &&
		!this["bIsSubMenu"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["bShowPointer"] = 0; };

/**
 * Returns the width of the menu
 * @return {number}
 */
UCF_PopupMenu["prototype"]["iGetWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetWidth"]++; }; 
	if (this["_iWidth"] === null || this["_iWidth"] === undefined) {
		this["_iWidth"] = this["oRootRef"]["offsetWidth"]; // eslint-disable-line @ur/no-memory-leaks
	}

	return this["_iWidth"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetWidth"] = 0; };

/**
 * Returns the height of the menu
 * @return {number}
 */
UCF_PopupMenu["prototype"]["iGetHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetHeight"]++; }; 
	if (this["_iHeight"] === null || this["_iHeight"] === undefined) {
		this["_iHeight"] = this["oRootRef"]["offsetHeight"]; // eslint-disable-line @ur/no-memory-leaks
		if (this["_iHeight"] === 0) {
			// Workaround for strange issue with browser zoom 150% in Chrome
			this["_iHeight"] = this["oRootRef"]["scrollHeight"];
		}
		if (this["bIsTopOrBottom"]()) {
			this["_iHeight"] += this["iGetPointerHeight"]();
		}
	}
	return this["_iHeight"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["iGetHeight"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PopupMenu["prototype"]["aAttributeNames"] = ["iFirstVisibleItemIdx","iMaxVisibleItems","sDragSourceInfo","sDropTargetInfo","bKeepSpaceForIcon","sCustomStyle","sCustomData","bIsContextMenu","sCmDoubleClickText","sCmQuickViewText"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PopupMenu["prototype"]["aEventNames"] = ["Select","Drag","BeforeOpen","Drop","Close"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PopupMenu["prototype"]["aMethodNames"] = ["openAtPosition","openAtControl","setRemoveOnClose","setAutoRefocus","setAutoRefocusOnKeyup","addItem","removeItems","iGetItemCount","oGetItemByIndex","aGetItems","removeItem","setCmDoubleClickText","setCmQuickViewText","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {number}
 */
UCF_PopupMenu["prototype"]["iFirstVisibleItemIdx"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_PopupMenu["prototype"]["iMaxVisibleItems"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_PopupMenu["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PopupMenu["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenu["prototype"]["bKeepSpaceForIcon"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PopupMenu["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PopupMenu["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenu["prototype"]["bIsContextMenu"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PopupMenu["prototype"]["sCmDoubleClickText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PopupMenu["prototype"]["sCmQuickViewText"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PopupMenu["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setDefaultValues"]++; }; 
	this["iFirstVisibleItemIdx"] = 0;
	this["iMaxVisibleItems"] = 0;
	this["sDragSourceInfo"] = '';
	this["sDropTargetInfo"] = '';
	this["bKeepSpaceForIcon"] = false;
	this["sCustomStyle"] = '';
	this["sCustomData"] = '';
	this["bIsContextMenu"] = false;
	this["sCmDoubleClickText"] = '';
	this["sCmQuickViewText"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("FirstVisibleItemIdx", 0, true);
		this["setClientProperty"]("MaxVisibleItems", 0, true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("KeepSpaceForIcon", false, true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("IsContextMenu", false, true);
		this["setClientProperty"]("CmDoubleClickText", '', true);
		this["setClientProperty"]("CmQuickViewText", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Id of the PopupMenu
 * @param {string} sItemId Identifier of the PopupMenuItem
 * @param {string} sConnectedControlId Identifier of the control that triggered the popupmenu, empty string if none
 * @param {boolean} bChecked Returns whether the item is checked or not.
 * @param {string} sUserData Returns the UserData that was set at the opener of the PopupMenu
 * @fires PopupMenu::Select
 */
UCF_PopupMenu["prototype"]["fireSelect"] = function(sId, sItemId, sConnectedControlId, bChecked, sUserData) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, ItemId: string, ConnectedControlId: string, Checked: boolean, UserData: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "PopupMenu.js(3137): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupMenu.js(3138): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupMenu.js(3139): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "PopupMenu.js(3140): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "PopupMenu.js(3141): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sConnectedControlId != null, "sConnectedControlId != null", "PopupMenu.js(3142): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sConnectedControlId) == "string", "typeof(sConnectedControlId) == \"string\"", "PopupMenu.js(3143): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bChecked != null, "bChecked != null", "PopupMenu.js(3144): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bChecked) == "boolean", "typeof(bChecked) == \"boolean\"", "PopupMenu.js(3145): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sUserData != null, "sUserData != null", "PopupMenu.js(3146): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sUserData) == "string", "typeof(sUserData) == \"string\"", "PopupMenu.js(3147): fireSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"ConnectedControlId": sConnectedControlId,
		"Checked": bChecked,
		"UserData": sUserData
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	
	
	this["fireSemanticEvent"]("PopupMenu", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires PopupMenu::Drag
 */
UCF_PopupMenu["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PopupMenu.js(3179): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupMenu.js(3180): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupMenu.js(3181): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "PopupMenu.js(3182): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "PopupMenu.js(3183): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "PopupMenu.js(3184): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "PopupMenu.js(3185): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("PopupMenu", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Id of the PopupMenu.
 * @param {string} sControlId Identifier of the control that triggered the popupmenu, empty string if none.
 * @param {boolean} bWithKeyboard Indicates whether the BeforeOpen event was triggered with the keyboard. This is necessary for the client to select the first item of the menu.
 * @param {number} iAlignment To be passed into the openAtControl method to tell the new instance where to align itself relative to the control with sControl is.
 * @fires PopupMenu::BeforeOpen
 */
UCF_PopupMenu["prototype"]["fireBeforeOpen"] = function(sId, sControlId, bWithKeyboard, iAlignment) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["fireBeforeOpen"]++; }; 
	/** @type {{Id: string, ControlId: string, WithKeyboard: boolean, Alignment: number}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "PopupMenu.js(3211): fireBeforeOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupMenu.js(3212): fireBeforeOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupMenu.js(3213): fireBeforeOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sControlId != null, "sControlId != null", "PopupMenu.js(3214): fireBeforeOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sControlId) == "string", "typeof(sControlId) == \"string\"", "PopupMenu.js(3215): fireBeforeOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bWithKeyboard != null, "bWithKeyboard != null", "PopupMenu.js(3216): fireBeforeOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bWithKeyboard) == "boolean", "typeof(bWithKeyboard) == \"boolean\"", "PopupMenu.js(3217): fireBeforeOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iAlignment != null, "iAlignment != null", "PopupMenu.js(3218): fireBeforeOpen"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iAlignment) == "number", "typeof(iAlignment) == \"number\"", "PopupMenu.js(3219): fireBeforeOpen"); };
	mParams = {
		"Id": sId,
		"ControlId": sControlId,
		"WithKeyboard": bWithKeyboard,
		"Alignment": iAlignment
	};
	
	if (sControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ControlId");
			}
		}
	
	
	this["fireSemanticEvent"]("PopupMenu", "BeforeOpen", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["fireBeforeOpen"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sItemId The id of the PopupMenuItem where the drop occured
 * @param {number} iOffset The Offset relative to the ItemListItem where the drop occured (signum)
 * @param {string} sData Arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires PopupMenu::Drop
 */
UCF_PopupMenu["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, sItemId, iOffset, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, ItemId: string, Offset: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 12, "arguments.length == 12", "PopupMenu.js(3258): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupMenu.js(3259): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupMenu.js(3260): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "PopupMenu.js(3261): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "PopupMenu.js(3262): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "PopupMenu.js(3263): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "PopupMenu.js(3264): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "PopupMenu.js(3265): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "PopupMenu.js(3266): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOffset != null, "iOffset != null", "PopupMenu.js(3267): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOffset) == "number", "typeof(iOffset) == \"number\"", "PopupMenu.js(3268): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "PopupMenu.js(3269): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "PopupMenu.js(3270): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "PopupMenu.js(3271): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "PopupMenu.js(3272): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "PopupMenu.js(3273): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "PopupMenu.js(3274): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "PopupMenu.js(3275): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "PopupMenu.js(3276): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "PopupMenu.js(3277): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "PopupMenu.js(3278): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "PopupMenu.js(3279): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "PopupMenu.js(3280): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "PopupMenu.js(3281): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "PopupMenu.js(3282): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"ItemId": sItemId,
		"Offset": iOffset,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("PopupMenu", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Id of the PopupMenu.
 * @fires PopupMenu::Close
 */
UCF_PopupMenu["prototype"]["fireClose"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["fireClose"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "PopupMenu.js(3321): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupMenu.js(3322): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupMenu.js(3323): fireClose"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("PopupMenu", "Close", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupMenu["_"]["fireClose"] = 0; };

UCF_PopupMenu.prototype["aPublicMethods"] = ["openAtControl","openAtPosition","removeItem","removeItems","addItem","iGetItemCount","oGetItemByIndex","aGetItems","setCmDoubleClickText","setCmQuickViewText"].concat(UCF_PopupMenu.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PopupMenuDragDelegate"] = function() {/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>

/**
 * Delegate for the drag of menu items
 *
 * 
 * @version
 * @see UCF_PopupMenu
 *
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Conrol} oDragSourceControl the control that initiated the drag
 */
function UCF_PopupMenuDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_PopupMenuDragDelegate["_"]["UCF_PopupMenuDragDelegate"]++; }; 

	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);

};window["UCF_PopupMenuDragDelegate"] = UCF_PopupMenuDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopupMenuDragDelegate"); UCF_PopupMenuDragDelegate["_"] = {UCF_PopupMenuDragDelegate: 0}; }; ;
UCF_PopupMenuDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_PopupMenuDragDelegate.prototype["sClassName"] = "UCF_PopupMenuDragDelegate";

/**
 * Create a ghost for a menu item
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {UCF_HTMLGhost}
 */
UCF_PopupMenuDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuDragDelegate["_"]["oGetGhost"]++; }; 

	var oGhostDomRef = this["oDragSourceControl"]["oSelectedItem"]["oDomRef"],
		oGhostClone = oGhostDomRef["cloneNode"](true);

	for (var i = 0; i < oGhostClone["childNodes"]["length"]; i++) {
		oGhostClone["childNodes"][i]["style"]["width"] = oGhostDomRef["childNodes"][i]["offsetWidth"] + "px";
	}
	var oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oGhostClone);
	oGhost["setOffset"](12, 12);
	oGhostClone["style"]["width"] = this["oDragSourceControl"]["oDomRef"]["style"]["width"];
	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_PopupMenuDragDelegate["_"]["oGetGhost"] = 0; };

/*
 * Handles the drag end event and closes the menu
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupMenuDragDelegate["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuDragDelegate["_"]["onlsdragend"]++; }; 
	this["oDragSourceControl"]["close"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenuDragDelegate["_"]["onlsdragend"] = 0; };

/*
 * Returns whether a drag is currently possible on the menu item or not
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupMenuDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuDragDelegate["_"]["bIsDragPossible"]++; }; 
	if (this["oDragSourceControl"]["oSelectedItem"] &&
		this["oDragSourceControl"]["oSelectedItem"]["bEnabled"]) {
		return oBrowserEvent["oGetSource"]() !== this["oDragSourceControl"]["oDomRef"];
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_PopupMenuDragDelegate["_"]["bIsDragPossible"] = 0; };

};
sap["ls"]["preload"]["UCF_PopupMenuDropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/** @class
 * Handles the visualization for inserting a draged objects into the menu
 *
 * 
 *
 * @version
 * @see UCF_PopupMenu
 * @param {UCF_PopupMenu} oPopupMenu
 * @param {UCF_LS} oLS
 */
function UCF_PopupMenuDropDecorator(oPopupMenu, oLS) {if (__UCF_COVERAGE__) { UCF_PopupMenuDropDecorator["_"]["UCF_PopupMenuDropDecorator"]++; }; 
	UCF_LineDecorator["apply"](this, [oPopupMenu, true]);
};window["UCF_PopupMenuDropDecorator"] = UCF_PopupMenuDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopupMenuDropDecorator"); UCF_PopupMenuDropDecorator["_"] = {UCF_PopupMenuDropDecorator: 0}; }; ;
UCF_PopupMenuDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(); UCF_PopupMenuDropDecorator.prototype["sClassName"] = "UCF_PopupMenuDropDecorator";

/**
 * Initializes the decorator with a certain z-index
 */
UCF_PopupMenuDropDecorator["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDecorator["_"]["init"]++; }; 
	UCF_LineDecorator.prototype["init"]["apply"](this, arguments);

	this["setZIndex"](UCF_LS["E_LAYERS"]["POPUPMENUS"] + 100);

};;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDecorator["_"]["init"] = 0; };

/**
 * Updates the decorator becaus the mouse position changed during the drag.
 * This is constantly fired during a drag.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupMenuDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDecorator["_"]["update"]++; }; 

	var
		// iMouseX = oBrowserEvent.iPageX(),
		iMouseY = oBrowserEvent["iPageY"]();

	var oViewPort = UCF_DomUtil["oGetObjectRect"](this["oControl"]["oDomRef"]);

	var iItemHeight = 0,
		aItems = this["oControl"]["aItems"],
		//	iItemCount = aItems.length,
		//	oFirstItem = aItems[0].oDomRef,
		// iIndex = -1,
		iOffsetY = iMouseY - 1,
		iTop = oViewPort["top"];

	if (this["oControl"]["oDomHead"]["style"]["display"] !== "none") {
		this["bScrolling"] = true;
		iTop += this["oControl"]["oDomHead"]["offsetHeight"];
	}
	for (var i = 0; i < aItems["length"]; i++) {
		iItemHeight = aItems[i]["oDomRef"]["offsetHeight"];
		if (iOffsetY < iTop + Math["floor"](iItemHeight / 2)) {
			this["iOffset"] = -1; // eslint-disable-line @ur/no-memory-leaks
			break;
		}
		iTop += iItemHeight;
		this["sItemId"] = aItems[i]["sId"]; // eslint-disable-line @ur/no-memory-leaks
		this["iOffset"] = 1;
		// iIndex = i;
		if (aItems[i]["bHasSeparator"]) {
			iTop += aItems[i]["oDomRef"]["previousSibling"]["offsetHeight"];
		}
	}
	var iWidth = this["oControl"]["oDomRef"]["clientWidth"];
	var iLeft = oViewPort["left"];

	this["setBounds"](iLeft, iTop, iWidth);

};;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDecorator["_"]["update"] = 0; };

/**
 * Returns the drop location on which menu item the drop appeared
 * @type Object
 * @return Object containing sItemId or the menu item and the iOffset on the item.
 */

UCF_PopupMenuDropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDecorator["_"]["oGetDropLocation"]++; }; 
	return { "sItemId": this["sItemId"], "iOffset": this["iOffset"] };

};;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDecorator["_"]["oGetDropLocation"] = 0; };

/**
 * Destructor
 */
UCF_PopupMenuDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDecorator["_"]["destroy"]++; }; 

	UCF_LineDecorator.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_PopupMenuDropDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_PopupMenuDropDecorator */
/// <reference path="../decorators/PopupMenuDropDecorator.js"/>

/**
 * Delegate for the drop of menu items
 *
 * 
 * @version
 * @see UCF_PopupMenu
 *
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl the menu that handles the drop
 */
function UCF_PopupMenuDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["UCF_PopupMenuDropDelegate"]++; }; 

	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);

};window["UCF_PopupMenuDropDelegate"] = UCF_PopupMenuDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopupMenuDropDelegate"); UCF_PopupMenuDropDelegate["_"] = {UCF_PopupMenuDropDelegate: 0}; }; ;
UCF_PopupMenuDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_PopupMenuDropDelegate.prototype["sClassName"] = "UCF_PopupMenuDropDelegate";

/**
 * Creates a drop decorator to visualize where dragged object will be dropped
 * @see {UCF_PopupMenuDropDecorator}
 * @override
 */
UCF_PopupMenuDropDelegate["prototype"]["oCreateDropDecorator"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["oCreateDropDecorator"]++; }; 

	return new (UCF_ClassLoader["oGetClass"]("UCF_PopupMenuDropDecorator"))(this["oDropTargetControl"], this["oLS"]);

};;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["oCreateDropDecorator"] = 0; };
/**
 * Handles the drag hover event for scrolling the menu
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupMenuDropDelegate["prototype"]["onlsdraghover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["onlsdraghover"]++; }; 
	var oPopupMenu = this["oDropTargetControl"];
	if (oPopupMenu["oDomHead"]["style"]["display"] === "none") return;
	var oSourceRef = oBrowserEvent["oGetSource"]();
	if (UCF_DomUtil["bContains"](oPopupMenu["oDomHead"], oSourceRef)) {
		oPopupMenu["scrollUp"]();
	} else if (UCF_DomUtil["bContains"](oPopupMenu["oDomFoot"], oSourceRef)) {
		oPopupMenu["scrollDown"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["onlsdraghover"] = 0; };

/**
 * Returns the drop location on which menu item the drop appeared
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {Object} containing sItemId or the menu item and the iOffset on the item.
 */
UCF_PopupMenuDropDelegate["prototype"]["oGetDropLocation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["oGetDropLocation"]++; }; 
	return this["oDropDecorator"]["oGetDropLocation"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["oGetDropLocation"] = 0; };

/**
 * Handles the drag leave event for the PopupMenu and closed the menu
 * if it was opened during a drag session
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupMenuDropDelegate["prototype"]["onlsdragleave"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["onlsdragleave"]++; }; 
	UCF_DropDelegate.prototype["onlsdragleave"]["apply"](this, arguments);
	var oPopupMenu = this["oDropTargetControl"],
		oSource = oBrowserEvent["oGetSource"]();

	if (UCF_DomUtil["bContains"](oPopupMenu["oDomRef"], oSource)) return;
	if (oPopupMenu["sGetOpenEventName"]() === "lsdraghover") {
		oPopupMenu["close"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["onlsdragleave"] = 0; };
/**
 * overide supermethod
 * additionally close the popup menu
 */

UCF_PopupMenuDropDelegate["prototype"]["onlsdrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["onlsdrop"]++; }; 

	UCF_DropDelegate.prototype["onlsdrop"]["call"](this, oBrowserEvent);

	var oPopupMenu = this["oDropTargetControl"];
	if (oPopupMenu["bIsOpened"]())
		oPopupMenu["close"]();

};;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["onlsdrop"] = 0; };

/**
 * Callback function that is executed after the drop to mach the frav
 * @param {Object} the dragsession
 */

UCF_PopupMenuDropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["fGetDropCallBack"]++; }; 
	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		oLocation = this["oGetDropLocation"](),
		sItemId = oLocation["sItemId"],
		iOffset = oLocation["iOffset"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function(sDragData, sMimeType) {
		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			sItemId,
			iOffset,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);

	};

};;if (__UCF_COVERAGE__) { UCF_PopupMenuDropDelegate["_"]["fGetDropCallBack"] = 0; };

};
sap["ls"]["preload"]["UCF_PopupMenuItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>

/**
 * PopupMenuItem control implementation
 *
 * @class
 * @see UCF_PopupMenu
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PopupMenuItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["UCF_PopupMenuItem"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "PopupMenuItem.js(43): UCF_PopupMenuItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PopupMenuItem.js(44): UCF_PopupMenuItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PopupMenuItem.js(45): UCF_PopupMenuItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	// properties
	this["oMenu"] = null;
	this["bStaySelectedForSubMenuItems"] = false;
	this["iIndex"] = -1; // eslint-disable-line @ur/no-memory-leaks
	//	this.bIsHovering = false;
	this["bIsItemVisible"] = true; // eslint-disable-line @ur/no-memory-leaks
	this["bIsSeperatorVisible"] = true; // eslint-disable-line @ur/no-memory-leaks
	this["sSubMenuClass"] = "";
	if (this["bHasSubMenu"]) {
		this["sSubMenuClass"] = " lsMnuSubMenu";
	}
	this["bIsTouchContextMenuItem"] = false;
	this["oTouchContextMenuEntry"] = null;
	this["OPEN_DELAY"] = 250;
};window["UCF_PopupMenuItem"] = UCF_PopupMenuItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopupMenuItem"); UCF_PopupMenuItem["_"] = {UCF_PopupMenuItem: 0}; }; ;
UCF_PopupMenuItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PopupMenuItem.prototype["sClassName"] = "UCF_PopupMenuItem";

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_PopupMenuItem["prototype"]["onmousemove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onmousemove"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenuItem.js(71): onmousemove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oMenu"] != null, "this.oMenu != null", "PopupMenuItem.js(72): onmousemove"); };
	this["oMenu"]["setSelectedItem"](this, true); //select the item
	this["bIsHovering"] = true;
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onmousemove"] = 0; };

/**
 * Need for dynamically build items that fire MenuAccess events, for example in the toolbar.
 * Releases the item to fire fire MenuAccess again with the next mousemove.
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_PopupMenuItem["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenuItem.js(84): onmouseout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oMenu"] != null, "this.oMenu != null", "PopupMenuItem.js(85): onmouseout"); };
	if (!this["oMenu"]) return;
	this["bIsHovering"] = false;
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onmouseout"] = 0; };

/**
 * Workaround for IE11 only, because :active CSS selector does not work.
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_PopupMenuItem["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenuItem.js(96): onmousedown"); };
	// Note: Only for belize
	if (UCF_UserAgent["bIsIE"]()) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'urMnuRowPressed');
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onmousedown"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_PopupMenuItem["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onmouseup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenuItem.js(108): onmouseup"); };
	if (UCF_UserAgent["bIsIE"]()) {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'urMnuRowPressed');
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onmouseup"] = 0; };

/**
 * Handle "Pressed" state (belize) because on touch device there is no mouseover (urMnuRowOn is not set)
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_PopupMenuItem["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onlstouchstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenuItem.js(120): onlstouchstart"); };
	var bIsSpecialTouchContextMenuTooltipItem =
		this["oTouchContextMenuEntry"] && this["oTouchContextMenuEntry"]["sType"] === 'TOOLTIP';
	if (!bIsSpecialTouchContextMenuTooltipItem && this["bEnabled"]) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'urMnuRowPressed');
		if (oBrowserEvent["oDomEvent"]["touches"]["length"] === 1) {
			this["oTouchStart"] = {
				"iX": oBrowserEvent["oDomEvent"]["touches"][0]["clientX"],
				"iY": oBrowserEvent["oDomEvent"]["touches"][0]["clientY"]
			};
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onlstouchstart"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_PopupMenuItem["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onlstouchend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenuItem.js(139): onlstouchend"); };
	var bIsSpecialTouchContextMenuTooltipItem =
		this["oTouchContextMenuEntry"] && this["oTouchContextMenuEntry"]["sType"] === 'TOOLTIP';
	if (!bIsSpecialTouchContextMenuTooltipItem && this["bEnabled"]) {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'urMnuRowPressed');
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onlstouchend"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_PopupMenuItem["prototype"]["onlstouchmove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onlstouchmove"]++; }; 
	var bIsSpecialTouchContextMenuTooltipItem =
		this["oTouchContextMenuEntry"] && this["oTouchContextMenuEntry"]["sType"] === 'TOOLTIP';
	// When user starts to swipe (scroll) in any direction, remove the pressed state...
	if (!bIsSpecialTouchContextMenuTooltipItem && this["bEnabled"] && oBrowserEvent["oDomEvent"]["touches"]["length"] === 1) {
		var iMoveDistanceX = oBrowserEvent["oDomEvent"]["touches"][0]["clientX"] - this["oTouchStart"]["iX"];
		var iMoveDistanceY = oBrowserEvent["oDomEvent"]["touches"][0]["clientY"] - this["oTouchStart"]["iY"];
		var TH = 10;
		if (Math["abs"](iMoveDistanceX) > TH || Math["abs"](iMoveDistanceY) > TH) {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'urMnuRowPressed');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onlstouchmove"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_PopupMenuItem["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupMenuItem.js(172): onclick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oMenu"] != null, "this.oMenu != null", "PopupMenuItem.js(173): onclick"); };
	this["oMenu"]["setSelectedItem"](this, true);
	this["oMenu"]["onclick"](oBrowserEvent); //select the item
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onclick"] = 0; };

/**
 * Selects the item visually. returns true if the bSelected differed from prevous value
 *
 * @param {boolean} bSelected selection state
 * @return {boolean}
 */
UCF_PopupMenuItem["prototype"]["setSelected"] = function(bSelected) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setSelected"]++; }; 
	//console.trace('********* setSelected: ' + bSelected);
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bSelected) == "boolean", "typeof(bSelected) == \"boolean\"", "PopupMenuItem.js(186): setSelected"); };

	if (this["bSelected"] == bSelected) return false; //exit if the selected state is set again to the same value

	//DomRef maybe already destroyed e.g in toolbar so that DOM operations should be ignored to avoid JS errors
	if (this["oDomRef"]) {

		if (bSelected) {
			if (this["bEnabled"]) {
				this["oDomRef"]["className"] = "urMnuRowOn"; //paint with new classes
			} else {
				this["oDomRef"]["className"] = "urMnuRowDsblOn"; //paint with new classes
			}

			//checkbox column
			UCF_DomUtil["removeClass"](this["oDomRef"]["getElementsByTagName"]("TD")[0], "urMnuColumnColor");
			//icon column
			UCF_DomUtil["removeClass"](this["oDomRef"]["getElementsByTagName"]("TD")[1], "urMnuIconColumnColor");

			//
			// Handle ARIA
			//
			if (window["UCF_System"]["bIsAria"]) {
				//var oMenuRef = UCF_DomUtil.oGetFirstElement(this.oMenu.oRootRef);
				//if (oMenuRef) {
				var oDomElement = this["oDomRef"];
				if (this["bCanCheck"]) {
					if (this["sGroupId"] !== "") {
						UCF_AriaStateHelper["setRole"](oDomElement, "menuitemradio");
					} else {
						UCF_AriaStateHelper["setRole"](oDomElement, "menuitemcheckbox");
					}
					UCF_AriaStateHelper["setChecked"](oDomElement, this["bChecked"]);
				} else {
					UCF_AriaStateHelper["setRole"](oDomElement, "menuitem");
				}
				// Note: Disabled items are skipped with KB-navigation
				UCF_AriaStateHelper["setDisabled"](oDomElement, !this["bEnabled"]);
				UCF_AriaStateHelper["setPosinset"](oDomElement, this["iGetVisibleItemIndex"]());
				if (this["oMenu"]) {
					UCF_AriaStateHelper["setSetsize"](oDomElement, this["oMenu"]["aGetVisibleItems"]()["length"]);
				} else if (this["sItemCount"]) {
					UCF_AriaStateHelper["setSetsize"](oDomElement, this["sItemCount"]);
				}
				var sLabelText = "";
				if (this["sText"]) {
					sLabelText = this["sText"];
				} else {
					sLabelText = this["sModifiedText"];
				}
				if (this["sHotkey"] !== "NONE") {
					sLabelText = sLabelText + ' ' + UCF_KeyboardHelper["sGetHotkeyText"](this["oLS"], this["sHotkey"]);
				}
				if (this["sShortcutText"] !== "") {
					sLabelText = sLabelText + " " + this["sShortcutText"];
				}
				if (sLabelText) {
					UCF_AriaStateHelper["setLabel"](oDomElement, sLabelText);
				} else {
					UCF_AriaStateHelper["setLabel"](oDomElement, this["oLS"]["sGetText"]('SAPUR_EMPTY'));
				}
				if (this["bGetHasSubMenu"]()) {
					UCF_AriaStateHelper["setOwns"](oDomElement, this["sSubMenuId"]);
					UCF_AriaStateHelper["setHasPopup"](oDomElement, true);
				} else {
					UCF_AriaStateHelper["setOwns"](oDomElement, "");
					UCF_AriaStateHelper["setHasPopup"](oDomElement, false);
				}
				//}
			}
		} else {
			if (this["bEnabled"]) {
				this["oDomRef"]["className"] = "urMnuRow"; //paint with new class
			} else {
				this["oDomRef"]["className"] = "urMnuRowDsbl"; //paint with new classes
			}

			//checkbox column
			UCF_DomUtil["addClass"](this["oDomRef"]["getElementsByTagName"]("TD")[0], "urMnuColumnColor");
			//icon column
			UCF_DomUtil["addClass"](this["oDomRef"]["getElementsByTagName"]("TD")[1], "urMnuIconColumnColor");
		}
	}
	this["bSelected"] = bSelected; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("Selected", this["bSelected"], true);
	if (this["oGetParent"]()["sCustomStyle"]) {
		this["oDomRef"]["className"] += this["sSubMenuClass"] + " lsMnuItemHeight " + this["oGetParent"]()["sCustomStyle"];
	} else {
		this["oDomRef"]["className"] += " lsMnuItemHeight" + this["sSubMenuClass"];
	}

	return true;
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setSelected"] = 0; };

/**
 * Opens a submenu of the item. returns whether the submnu was opened or not
 * @param {boolean} bKeyboard Signals the desired focus behaviour. True: The focus is set on the first item (like during keyboard-navigation), false: The whole sub-menu gets the focus.
 * @return {boolean} whether the submenu was opened
 * @public
 */
UCF_PopupMenuItem["prototype"]["openSubMenu"] = function(bKeyboard) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["openSubMenu"]++; }; 

	if (!this["bEnabled"] || !this["bHasSubMenu"]) return false;

	//needed when method gets called externally
	this["bSelected"] = true;
	this["setClientProperty"]("Selected", this["bSelected"], true);
	this["oMenu"]["oSelectedItem"] = this;
	var _this = this;
	var bTouchMode = window["UCF_System"]["sInteractionType"] === 'TOUCH';

	//If there is no submenu on the client, fire a event and exit
	if (this["bHasSubMenu"] && (!this["sSubMenuId"] || this["oGetControlById"](this["sSubMenuId"]) == null)) {
		if (bKeyboard || bTouchMode) {
			this["oMenu"]["fireEvent"](this["oMenu"]["E_EVENTS"]["MenuAccess"], { "sMenuId": this["sId"], "bEnabled": this["bEnabled"] });
		} else {
			UCF_JsUtil["delayedCall"](this["OPEN_DELAY"], {
				"delayedMenuAccess": function() {
					if (_this["bIsHovering"]) {
						if (!_this["oMenu"]["bIsDestroyed"]) {
							_this["oMenu"]["fireEvent"](_this["oMenu"]["E_EVENTS"]["MenuAccess"], { "sMenuId": _this["sId"], "bEnabled": _this["bEnabled"] });
						}
					}
				}
			}, 'delayedMenuAccess');
		}
		return true;
	}

	var oSubMenu = this["oLS"]["oControlFactory"]["oGetControlById"](this["sSubMenuId"], true);
	oSubMenu["setOpenerRef"](this["oDomRef"]); //connect the item with the submenu
	this["bStaySelectedForSubMenuItems"] = true; //the item should stay selected even if mouse is moved out
	oSubMenu["setOpenerId"](this["oMenu"]["sOpenerId"]);
	oSubMenu["setUserData"](this["oMenu"]["sUserData"]);
	oSubMenu["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["MENUITEM"]);
	oSubMenu["setOffsetTop"](2);
	oSubMenu["setIsSubMenu"](true);
	oSubMenu["oParentMenu"] = this["oMenu"];
	oSubMenu["oOpenerItem"] = this;

	this["oSubMenu"] = oSubMenu;
	this["oMenu"]["oSubMenu"] = oSubMenu;
	oSubMenu["attachEvent"](this["oSubMenu"]["E_EVENTS"]["Close"], this, "onSubMenuClose");
	oSubMenu["attachEvent"](this["oSubMenu"]["E_EVENTS"]["NextMenu"], this, "onNextMenu");

	this["oMenu"]["doNotProcessScrollEvents"](200);
	if (bKeyboard || bTouchMode) {
		oSubMenu["open"](bKeyboard);
	} else {
		UCF_JsUtil["delayedCall"](this["OPEN_DELAY"], {
			"delayedOpen": function() {
				if (_this["bIsHovering"]) {
					if (!oSubMenu["bIsDestroyed"]) {
						oSubMenu["open"](bKeyboard);
					}
				}
			}
		}, 'delayedOpen');
	}

	return true; //return true if opened
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["openSubMenu"] = 0; };

/**
 * Called by PopupMenu.onmousemove()
 * @return {boolean}
 */
UCF_PopupMenuItem["prototype"]["bStaySelected"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bStaySelected"]++; }; 
	return this["bStaySelectedForSubMenuItems"] && this["oSubMenu"] && this["oSubMenu"]["bIsOpened"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bStaySelected"] = 0; };

/**
 * Called my PopupMenu.close() for the selected item.
 */
UCF_PopupMenuItem["prototype"]["handleMenuCloseForSelectedItem"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["handleMenuCloseForSelectedItem"]++; }; 
	this["bStaySelectedForSubMenuItems"] = false;
	this["setSelected"](false);
	this["closeSubMenu"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["handleMenuCloseForSelectedItem"] = 0; };

/**
 * open submenu when user drags
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupMenuItem["prototype"]["onlsdraghover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onlsdraghover"]++; }; 
	this["openSubMenu"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onlsdraghover"] = 0; };

/**
 * Closes a submenu of the item, returns whether the submenu was closed
 *
 * @return {boolean} whether the submenu was closed
 * @public
 */
UCF_PopupMenuItem["prototype"]["closeSubMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["closeSubMenu"]++; }; 

	if (!this["oSubMenu"]) return false; //exit asap if no submenu

	this["oSubMenu"]["detachEvent"](this["oSubMenu"]["E_EVENTS"]["Close"], this);
	this["oMenu"]["doNotProcessScrollEvents"](200);
	this["oSubMenu"]["close"]();
	return true; //return true if closed
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["closeSubMenu"] = 0; };

/**
 * Handler that is called, when a SubMenu is closed
 *
 * @param {UCF_Event} oEvent
 */
UCF_PopupMenuItem["prototype"]["onSubMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onSubMenuClose"]++; }; 

	this["oSubMenu"]["detachEvent"](this["oSubMenu"]["E_EVENTS"]["Close"], this);
	//UCF_DomUtil.focusDomElement(UCF_DomUtil.oGetFirstElement(this.oMenu.oRootRef));
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onSubMenuClose"] = 0; };

/**
 * Handler that is called, when a SubMenu is closed
 *
 * @param {UCF_Event} oEvent
 */
UCF_PopupMenuItem["prototype"]["onNextMenu"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onNextMenu"]++; }; 

	this["oSubMenu"]["detachEvent"](this["oSubMenu"]["E_EVENTS"]["NextMenu"], this);
	this["oMenu"]["fireEvent"](this["oMenu"]["E_EVENTS"]["NextMenu"], {});

};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["onNextMenu"] = 0; };

UCF_PopupMenuItem["prototype"]["bGetCanCheck"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bGetCanCheck"]++; }; 
	return this["bCanCheck"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bGetCanCheck"] = 0; };

UCF_PopupMenuItem["prototype"]["setCanCheck"] = function(bCanCheck) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setCanCheck"]++; }; 

	this["bCanCheck"] = bCanCheck; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("CanCheck", this["bCanCheck"], true);
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setCanCheck"] = 0; };

UCF_PopupMenuItem["prototype"]["bGetIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bGetIsVisible"]++; }; 
	return this["bIsItemVisible"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bGetIsVisible"] = 0; };

UCF_PopupMenuItem["prototype"]["setVisible"] = function(bVisible) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setVisible"]++; }; 

	this["oDomRef"]["style"]["display"] = bVisible ? "" : "none";
	this["bIsItemVisible"] = bVisible;

};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setVisible"] = 0; };

UCF_PopupMenuItem["prototype"]["setSeperatorVisible"] = function(bVisible) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setSeperatorVisible"]++; }; 

	//TODO replace by UCF_DomUtil.oGetPreviousSibling
	if (this["bHasSeparator"] && this["oDomRef"]["previousSibling"]) {
		this["oDomRef"]["previousSibling"]["style"]["display"] = bVisible ? "" : "none";
	}

	this["bIsSeperatorVisible"] = bVisible;

};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setSeperatorVisible"] = 0; };

UCF_PopupMenuItem["prototype"]["bGetIsSeperatorVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bGetIsSeperatorVisible"]++; }; 

	return this["bHasSeparator"] && this["bIsSeperatorVisible"];

};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bGetIsSeperatorVisible"] = 0; };

UCF_PopupMenuItem["prototype"]["bIsEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bIsEnabled"]++; }; 
	return this["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bIsEnabled"] = 0; };

UCF_PopupMenuItem["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setEnabled"]++; }; 

	this["bEnabled"] = bEnabled; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("Enabled", this["bEnabled"], true);
	if (bEnabled) {
		this["oDomRef"]["className"] = "urMnuRowOff lsMnuItemHeight" + this["sSubMenuClass"];
	} else {
		this["oDomRef"]["className"] = "urMnuRowDsbl lsMnuItemHeight";
	}

};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setEnabled"] = 0; };

UCF_PopupMenuItem["prototype"]["bIsChecked"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bIsChecked"]++; }; 
	return this["bChecked"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bIsChecked"] = 0; };

/**
 * Set style for checked items
 *
 * @param {boolean} bChecked
 */
UCF_PopupMenuItem["prototype"]["setChecked"] = function(bChecked) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setChecked"]++; }; 
	this["bCanCheck"] = true;
	this["setClientProperty"]("CanCheck", this["bCanCheck"], true);
	this["bChecked"] = bChecked; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("Checked", this["bChecked"], true);
	var oCheckDomRef = UCF_DomUtil["firstChild"](this["oDomRef"]);
	if (oCheckDomRef) {
		if (this["sGroupId"]) {
			if (bChecked) {
				// adding the class: Workaround because urMnuChk exists only via rendering when CanCheck=true
				// But setCanCheck() is offered in the API and the implementation does NOT set this class. See also code at the beginning of this function, which sets the bCanCheck = true.
				// Existing code in WebGUI relies on this unfortunate implementation...
				if (UCF_DomUtil["bHasClass"](oCheckDomRef, "urMnuChkRbg")) {
					UCF_DomUtil["replaceClass"](oCheckDomRef, "urMnuChkRbg", "urMnuChkRbgOn");
				} else {
					UCF_DomUtil["addClass"](oCheckDomRef, "urMnuChkRbgOn");
				}
			} else {
				UCF_DomUtil["replaceClass"](oCheckDomRef, "urMnuChkRbgOn", "urMnuChkRbg");
			}
		} else {
			if (bChecked) {
				if (UCF_DomUtil["bHasClass"](oCheckDomRef, "urMnuChk")) {
					UCF_DomUtil["replaceClass"](oCheckDomRef, "urMnuChk", "urMnuChkOn");
				} else {
					UCF_DomUtil["addClass"](oCheckDomRef, "urMnuChkOn");
				}
			} else {
				UCF_DomUtil["replaceClass"](oCheckDomRef, "urMnuChkOn", "urMnuChk");
			}
		}
		if (window["UCF_System"]["bIsAria"]) {
			if (bChecked) {
				UCF_AriaStateHelper["setSelected"](oCheckDomRef, true);
			} else {
				UCF_AriaStateHelper["setSelected"](oCheckDomRef, false);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setChecked"] = 0; };

UCF_PopupMenuItem["prototype"]["sGetGroupId"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["sGetGroupId"]++; }; 
	return this["sGroupId"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["sGetGroupId"] = 0; };

UCF_PopupMenuItem["prototype"]["setGroupId"] = function(sGroupId) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setGroupId"]++; }; 

	this["sGroupId"] = sGroupId; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("GroupId", this["sGroupId"], true);

};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setGroupId"] = 0; };

UCF_PopupMenuItem["prototype"]["sGetId"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["sGetId"]++; }; 
	return this["sId"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["sGetId"] = 0; };

UCF_PopupMenuItem["prototype"]["sGetSubMenuId"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["sGetSubMenuId"]++; }; 
	return this["sSubMenuId"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["sGetSubMenuId"] = 0; };

/**
 * @public
 * @param {string} sSubMenuId
 */
UCF_PopupMenuItem["prototype"]["setSubMenuId"] = function(sSubMenuId) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setSubMenuId"]++; }; 

	this["sSubMenuId"] = sSubMenuId; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("SubMenuId", this["sSubMenuId"], true);

};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setSubMenuId"] = 0; };

UCF_PopupMenuItem["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setText"]++; }; 

	var oTextCell = UCF_DomUtil["oGetFirstChild"](this["oDomRef"]["getElementsByTagName"]("TD")[2]);

	UCF_DomUtil["setInnerText"](oTextCell, sText);
	this["sModifiedText"] = sText; // eslint-disable-line @ur/no-memory-leaks
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setText"] = 0; };

UCF_PopupMenuItem["prototype"]["bGetHasSubMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bGetHasSubMenu"]++; }; 
	return this["bHasSubMenu"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["bGetHasSubMenu"] = 0; };

/**
 * Sets the sSemanticColor
 * @param {string} sSemanticColor
 */
UCF_PopupMenuItem["prototype"]["setSemanticColor"] = function(sSemanticColor) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setSemanticColor"]++; }; 
	this["sSemanticColor"] = sSemanticColor; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("SemanticColor", this["sSemanticColor"], true);

	var oTDs = this["oDomRef"]["getElementsByTagName"]("TD"),
		oTDImg = oTDs["length"] > 1 ? oTDs[1] : null,
		oImgRef = oTDImg != null ? this["oDomRef"]["getElementsByTagName"]("IMG")[0] : null;
	if (!oImgRef) return;

	new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(); //load urbase
	oImgRef["className"] = UCF_UrBase["getSemanticColor"](this["sSemanticColor"]);
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setSemanticColor"] = 0; };

/**
 * @return the sSemanticColor
 * @type string
 */
UCF_PopupMenuItem["prototype"]["getSemanticColor"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["getSemanticColor"]++; }; 
	return this["sSemanticColor"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["getSemanticColor"] = 0; };

/**
 * Sets the sImage
 * @public
 * @param {string} sImage
 */
UCF_PopupMenuItem["prototype"]["setEnabledIconSrc"] = function(sImage) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setEnabledIconSrc"]++; }; 
	this["sEnabledIconSrc"] = sImage; // eslint-disable-line @ur/no-memory-leaks
	this["setClientProperty"]("EnabledIconSrc", this["sEnabledIconSrc"], true);
	var oTDs = this["oDomRef"]["getElementsByTagName"]("TD"),
		oTDImg = oTDs["length"] > 1 ? oTDs[1] : null,
		oImgRef = oTDImg != null ? this["oDomRef"]["getElementsByTagName"]("IMG")[0] : null;
	if (!oImgRef) return;

	oImgRef["src"] = sImage;
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setEnabledIconSrc"] = 0; };

/**
 * @return {string} Returns the UpIconSrc
 * @public
 */
UCF_PopupMenuItem["prototype"]["getEnabledIconSrc"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["getEnabledIconSrc"]++; }; 
	return this["sEnabledIconSrc"];
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["getEnabledIconSrc"] = 0; };

/**
 * Removes the item from the dom and destroys the instance
 */
UCF_PopupMenuItem["prototype"]["remove"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["remove"]++; }; 

	if (this["oDomRef"]) {
		//TODO replace by UCF_DomUtil.oGetPreviousSibling
		if (this["bHasSeparator"] && this["oDomRef"]["previousSibling"]) {
			this["oDomRef"]["parentNode"]["removeChild"](this["oDomRef"]["previousSibling"]);
		}
		this["oDomRef"]["parentNode"]["removeChild"](this["oDomRef"]);
	}
	this["destroy"]();
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["remove"] = 0; };

/**
 * Insertes the rendering of the PopupMenuItem to as last child of a given oDOmRef
 * @param {HTMLElement} oDomRef
 */
UCF_PopupMenuItem["prototype"]["append"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["append"]++; }; 
	var oRow = this["oDomRef"],
		oCheckCell = document["createElement"]("TD"),
		oIconCell = document["createElement"]("TD"),
		oTextCell = document["createElement"]("TD"),
		oTextSpan = document["createElement"]("SPAN"),
		oShortCutCell = document["createElement"]("TD"),
		oSubMenuCellSpan = document["createElement"]("SPAN"),
		oSubMenuCell = document["createElement"]("TD");

	if (this["bEnabled"]) {
		oRow["className"] = "lsMnuItem urMnuRowOff";
	} else {
		oRow["className"] = "lsMnuItem urMnuRowDsbl";
	}
	oRow["setAttribute"]("ct", "POMNI");
	oRow["setAttribute"]("id", this["sId"]);

	if (!UCF_StringUtil["bIsEmpty"](this["sTooltip"])) {
		oRow["setAttribute"]("title", this["sTooltip"]);
	}

	//Checked Cell
	if (this["bCanCheck"]) {
		if (this["sGroupId"] != '') UCF_DomUtil["addClass"](oCheckCell, this["bChecked"] ? "urMnuChkRbgOn" : "urMnuChkRbg");
		else UCF_DomUtil["addClass"](oCheckCell, this["bChecked"] ? "urMnuChkOn" : "urMnuChk");
	}
	var oSpan1 = document["createElement"]("SPAN");
	oCheckCell["appendChild"](oSpan1);
	oSpan1["className"] = "lsMnuNbsp";
	if (this["bCanCheck"]) oSpan1["innerHTML"] = "&nbsp;&nbsp;&nbsp;";
	else if (this["bHasIcon"]) oSpan1["innerHTML"] = "&nbsp;";

	UCF_DomUtil["addClass"](oCheckCell, "urMnuColumn");
	UCF_DomUtil["addClass"](oCheckCell, "urMnuColumnColor");

	//Icon Cell
	UCF_DomUtil["addClass"](oIconCell, "urMnuIconColumnColor");
	UCF_DomUtil["addClass"](oIconCell, "lsMenuItemIcon");
	if (this["bHasIcon"]) {
		if (window["UCF_System"]["bIsRTL"]) oIconCell["style"]["paddingLeft"] = "3px";
		else oIconCell["style"]["paddingRight"] = "3px";
		//the ToolbarButtons give the class name of the ButtonType
		var oRendererManager = this["oLS"]["oGetRenderManager"]();
		if (this["bEnabled"]) {
			/* eslint-disable no-unsanitized/property */
			if (UCF_StringUtil["bStartsWith"](this["sEnabledIconSrc"], "lsControl--fontIcon")) {
				oIconCell["innerHTML"] = "<span id=\"" + this["sId"] + "-img\" class=\"" + this["sEnabledIconSrc"]["substring"](19) + "\">";
			} else {
				this["oPopupImage"](this["sEnabledIconSrc"], oRendererManager);
				oIconCell["innerHTML"] = oRendererManager["getHTMLString"]();
			}
		} else {
			if (UCF_StringUtil["bStartsWith"](this["sDisabledIconSrc"], "lsControl--fontIcon")) {
				oIconCell["innerHTML"] = "<span id=\"" + this["sId"] + "-img\" class=\"" + this["sDisabledIconSrc"]["substring"](19) + "\">";
			} else {
				this["oPopupImage"](this["sDisabledIconSrc"], oRendererManager);
				oIconCell["innerHTML"] = oRendererManager["getHTMLString"]();
			}
		}
		oRendererManager["clearBuffer"]();
		/* eslint-enable no-unsanitized/property */

		//if (this.bEnabled) oIconCell.innerHTML="<img border=\"0\" src=\"" + (UCF_StringUtil.bStartsWith(this.sEnabledIconSrc,"ClassName:")? UCF_ResourceUtil.sGetSpacerImageUrl()+ "\"  class=\"" + this.sEnabledIconSrc.substring(10) : this.sEnabledIconSrc )+ "\" alt=\"\">";
		//else oIconCell.innerHTML="<img border=\"0\" src=\""+ (UCF_StringUtil.bStartsWith(this.sDisabledIconSrc,"ClassName:")? UCF_ResourceUtil.sGetSpacerImageUrl()+ "\"  class=\"" + this.sDisabledIconSrc.substring(10) : this.sDisabledIconSrc )+ "\" alt=\"\">";
	} else {
		UCF_DomUtil["addClass"](oIconCell, "lsMnuNoIcon");
		var oPopupMenu = this["oGetParent"]();
		if (oPopupMenu && oPopupMenu["bKeepSpaceForIcon"]) {
			oIconCell["innerHTML"] = "<img border=\"0\" src=\"" + UCF_ResourceUtil["sGetSpacerImageUrl"]() + "\"  class=\"seqMnuSpaceIcon\" alt=\"\">"; // eslint-disable-line no-unsanitized/property
		} else {
			var oSpan2 = document["createElement"]("SPAN");
			oIconCell["appendChild"](oSpan2);
			oSpan2["className"] = "lsMnuNbsp";
			oSpan2["innerHTML"] = "&nbsp;";
		}
	}

	//Text Cell
	oTextCell["className"] = "urMnuTxt";
	oTextSpan["style"]["whiteSpace"] = "nowrap";
	if (this["sTextDirection"] === "LTR" && window["UCF_System"]["bIsRTL"]) oTextSpan["dir"] = "ltr";
	if (this["sTextDirection"] === "RTL" && !window["UCF_System"]["bIsRTL"]) oTextSpan["dir"] = "rtl";
	if (this["bHasEllipsis"]) {
		oTextSpan["innerHTML"] = UCF_XSSEncoder["encodeHTML"](this["sText"])["replace"](/ /g, "&nbsp;") + "&#8230"; // eslint-disable-line no-unsanitized/property
	} else {
		oTextSpan["innerHTML"] = UCF_XSSEncoder["encodeHTML"](this["sText"])["replace"](/ /g, "&nbsp;"); // eslint-disable-line no-unsanitized/property
	}

	//Shortcut Cell
	oShortCutCell["className"] = "urMnuTxt lsMnuHK";
	oShortCutCell["style"]["whiteSpace"] = "nowrap";
	if (this["sShortcutText"] !== undefined && this["sShortcutText"] != null && !UCF_StringUtil["bIsEmpty"](this["sShortcutText"])) {
		oShortCutCell["innerHTML"] = "&nbsp;" + UCF_XSSEncoder["encodeHTML"](this["sShortcutText"])["replace"](/ /g, "&nbsp;"); // eslint-disable-line no-unsanitized/property
	} else {
		oShortCutCell["innerHTML"] = "&nbsp;&nbsp;&nbsp;" + UCF_KeyboardHelper["sGetHotkeyText"](this["oLS"], this["sHotkey"]); // eslint-disable-line no-unsanitized/property
	}

	//SubMenu Cell
	if (this["bHasSubMenu"]) {

		if (this["bHasSubMenuSection"])
			oSubMenuCellSpan["className"] = "urMnuSubOnChc";
		else
			oSubMenuCellSpan["className"] = "urMnuSubOn lsMirrorRtl";

		oSubMenuCellSpan["innerHTML"] = "&nbsp;&nbsp;&nbsp;";
	} else {
		oSubMenuCellSpan["className"] = "urMnuSubOff lsMirrorRtl";
		oSubMenuCellSpan["innerHTML"] = "&nbsp;";
	}

	//append the cells to the row
	oSubMenuCell["appendChild"](oSubMenuCellSpan);
	oRow["appendChild"](oCheckCell);
	oRow["appendChild"](oIconCell);
	oRow["appendChild"](oTextCell);
	oRow["appendChild"](oShortCutCell);
	oRow["appendChild"](oSubMenuCell);
	oTextCell["appendChild"](oTextSpan);

	//handle the separator row
	if (this["bHasSeparator"]) {
		var oSeparatorRow = document["createElement"]("TR"),
			oSeparatorCell = document["createElement"]("TD");
		oSeparatorRow["className"] = "urMnuRowOff lsMnuItemIsSeparator";
		oSeparatorCell["colSpan"] = "5";
		oSeparatorCell["className"] = "urMnuDvdr";
		oSeparatorCell["innerHTML"] = "<div>&nbsp</div>";
		oSeparatorRow["appendChild"](oSeparatorCell);

		//append the separator
		oDomRef["insertBefore"](oSeparatorRow, oRow);
	}

	oRow["className"] += " lsMnuItemHeight" + this["sSubMenuClass"];

	//append the row
	this["connectToDom"](oRow);
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["append"] = 0; };

/**
 * @private
 * @param {string} sIconSrc the icon src
 * @param {UCF_RenderManager} oRenderManager the render manager
 * @return {string} the popup image
 */
UCF_PopupMenuItem["prototype"]["oPopupImage"] = function(sIconSrc, oRenderManager) {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["oPopupImage"]++; }; 
	oRenderManager["write"](new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(undefined, this["oLS"])["sIconFragment"]({
		"Id": this["sId"] + '-img',
		"Src": sIconSrc,
		"SrcOnError": '',
		"Width": '',
		"Height": '',
		"Tooltip": '',
		"AlternativeText": '',
		"CssClass": '',
		"CssStyle": ''
	}));
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["oPopupImage"] = 0; };

/**
 * returns the item index of an item for all visible items
 * @private
 */
UCF_PopupMenuItem["prototype"]["iGetVisibleItemIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["iGetVisibleItemIndex"]++; }; 
	var aVisibleItems = this["oMenu"]["aGetVisibleItems"]();
	for (var iItemCount = 0; iItemCount < aVisibleItems["length"]; iItemCount++) {
		if (aVisibleItems[iItemCount]["sId"] == this["sId"]) {
			return iItemCount + 1;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["iGetVisibleItemIndex"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_PopupMenuItem["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["destroy"]++; }; 

	if (this["oSubMenu"]) {
		this["oSubMenu"]["detachEvent"](this["oSubMenu"]["E_EVENTS"]["Close"], this);
	}

	this["oTouchStart"] = null;
	this["oSubMenu"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PopupMenuItem["prototype"]["aAttributeNames"] = ["sGroupId","sText","bChecked","bCanCheck","bHasSeparator","bEnabled","bHasSubMenu","sSubMenuId","bHasIcon","sEnabledIconSrc","sDisabledIconSrc","sTextDirection","bHasEllipsis","sShortcutText","bSelected","sHotkey","bHasSubMenuSection","sSemanticColor","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PopupMenuItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PopupMenuItem["prototype"]["aMethodNames"] = ["sGetId","bIsChecked","setChecked","bGetCanCheck","setCanCheck","bIsEnabled","setEnabled","bGetIsVisible","setVisible","bGetIsSeperatorVisible","setSeperatorVisible","sGetGroupId","setGroupId","sGetSubMenuId","setSubMenuId","bGetHasSubMenu","setText","openSubMenu","setSemanticColor","getSemanticColor","setEnabledIconSrc","getEnabledIconSrc","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_PopupMenuItem["prototype"]["sGroupId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PopupMenuItem["prototype"]["sText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenuItem["prototype"]["bChecked"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenuItem["prototype"]["bCanCheck"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenuItem["prototype"]["bHasSeparator"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenuItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenuItem["prototype"]["bHasSubMenu"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PopupMenuItem["prototype"]["sSubMenuId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenuItem["prototype"]["bHasIcon"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PopupMenuItem["prototype"]["sEnabledIconSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PopupMenuItem["prototype"]["sDisabledIconSrc"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ForcedTextDirection}
 */
UCF_PopupMenuItem["prototype"]["sTextDirection"] = "INHERIT";

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenuItem["prototype"]["bHasEllipsis"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PopupMenuItem["prototype"]["sShortcutText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenuItem["prototype"]["bSelected"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HotkeyValue}
 */
UCF_PopupMenuItem["prototype"]["sHotkey"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_PopupMenuItem["prototype"]["bHasSubMenuSection"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_PopupMenuItem["prototype"]["sSemanticColor"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_PopupMenuItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PopupMenuItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setDefaultValues"]++; }; 
	this["sGroupId"] = '';
	this["sText"] = '';
	this["bChecked"] = false;
	this["bCanCheck"] = false;
	this["bHasSeparator"] = false;
	this["bEnabled"] = true;
	this["bHasSubMenu"] = false;
	this["sSubMenuId"] = '';
	this["bHasIcon"] = false;
	this["sEnabledIconSrc"] = '';
	this["sDisabledIconSrc"] = '';
	this["sTextDirection"] = "INHERIT";
	this["bHasEllipsis"] = false;
	this["sShortcutText"] = '';
	this["bSelected"] = false;
	this["sHotkey"] = "NONE";
	this["bHasSubMenuSection"] = false;
	this["sSemanticColor"] = "NONE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("GroupId", '', true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Checked", false, true);
		this["setClientProperty"]("CanCheck", false, true);
		this["setClientProperty"]("HasSeparator", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("HasSubMenu", false, true);
		this["setClientProperty"]("SubMenuId", '', true);
		this["setClientProperty"]("HasIcon", false, true);
		this["setClientProperty"]("EnabledIconSrc", '', true);
		this["setClientProperty"]("DisabledIconSrc", '', true);
		this["setClientProperty"]("TextDirection", "INHERIT", true);
		this["setClientProperty"]("HasEllipsis", false, true);
		this["setClientProperty"]("ShortcutText", '', true);
		this["setClientProperty"]("Selected", false, true);
		this["setClientProperty"]("Hotkey", "NONE", true);
		this["setClientProperty"]("HasSubMenuSection", false, true);
		this["setClientProperty"]("SemanticColor", "NONE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupMenuItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_PopupMenuItem.prototype["aPublicMethods"] = ["openSubMenu","closeSubMenu","setSubMenuId","setEnabledIconSrc","getEnabledIconSrc"].concat(UCF_PopupMenuItem.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PopupTrigger"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_PopupTrigger(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["UCF_PopupTrigger"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PopupTrigger.js(28): UCF_PopupTrigger"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PopupTrigger.js(29): UCF_PopupTrigger"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PopupTrigger.js(30): UCF_PopupTrigger"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_PopupTrigger"] = UCF_PopupTrigger; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopupTrigger"); UCF_PopupTrigger["_"] = {UCF_PopupTrigger: 0}; }; ;
UCF_PopupTrigger["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PopupTrigger.prototype["sClassName"] = "UCF_PopupTrigger";

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupTrigger["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupTrigger.js(42): onclick"); };
	var oBtn, oHidden, oSource, bIsButton, oIndicator;

	if (!this["bHasPopupMenu"] || !this["bEnabled"]) return;

	if (window["UCF_System"]["sDevice"] === "standards") {
		oIndicator = UCF_DomUtil["$"](this["sId"] + "-btn");
		if (this["sTriggerIndicator"] === "BUTTON") {
			oSource = oBrowserEvent["oSource"];
			if (oSource !== oIndicator) return;
		}
		this["openMenu"](false);
		this["fireMenuAccess"](this["sId"], this["sPopupMenuId"], false);
		oBrowserEvent["cancelBubble"]();

	} else {
		oBtn = UCF_DomUtil["$"](this["sId"] + "-btn");
		oHidden = UCF_DomUtil["$"](this["sId"] + "-hidden");
		oSource = oBrowserEvent["oGetSource"]();
		bIsButton = this["sTriggerIndicator"] === "BUTTON";

		if (!bIsButton || (bIsButton && oSource === oHidden) || (bIsButton && oSource === oBtn)) {

			this["openMenu"](false);
			this["fireMenuAccess"](this["sId"], this["sPopupMenuId"], false);
			oBrowserEvent["cancelBubble"]();
		}
	}

};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onclick"] = 0; };

UCF_PopupTrigger["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupTrigger.js(74): onmousedown"); };
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onmousedown"] = 0; };

/**
 * check keycodes and open menu
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupTrigger["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onlsshow"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupTrigger.js(85): onlsshow"); };
	// fired on F4

	if (!this["bHasPopupMenu"] || !this["bEnabled"]) return;

	this["openMenu"](true);
	this["updateAria"](true);
	this["fireMenuAccess"](this["sId"], this["sPopupMenuId"], true);

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onlsshow"] = 0; };

/**
 *
 * @param {bool} bState
 * @private
 */
UCF_PopupTrigger["prototype"]["updateAria"] = function(bState) {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["updateAria"]++; }; 
	UCF_AriaStateHelper["setExpanded"](this["oDomRef"], bState);
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["updateAria"] = 0; };

/**
 * Handles the onlsselect event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PopupTrigger["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupTrigger.js(114): onlsselect"); };
	// fired on space

	if (!this["bHasPopupMenu"] || !this["bEnabled"]) return;
	this["openMenu"](true);
	this["fireMenuAccess"](this["sId"], this["sPopupMenuId"], true);

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onlsselect"] = 0; };

/**
 * show hovereffekt on popuptrigger and its content
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupTrigger["prototype"]["onmouseover"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onmouseover"]++; }; 

	if (!this["bEnabled"] || this["oDomRef"] == null) return;

	if (window["UCF_System"]["sDevice"] === "standards") {

		var oIndicator = UCF_DomUtil["$"](this["sId"] + "-btn");

		UCF_DomUtil["addClass"](this["oDomRef"], "urPopUpTrHover");

		if (this["sTriggerIndicator"] !== "BUTTON") {
			UCF_DomUtil["addClass"](oIndicator, "urPopUpTrgInActHover");
		}
	} else {

		if (this["sTriggerIndicator"] === "BUTTON" || !this["bEnabled"] || this["oDomRef"] == null) return;

		var oBtn = UCF_DomUtil["$"](this["sId"] + "-btn"),
			oHidden = UCF_DomUtil["$"](this["sId"] + "-hidden");

		UCF_DomUtil["addClass"](this["oDomRef"], "urPopUpTrHover");
		if (oBtn != null) {
			UCF_DomUtil["addClass"](oBtn, "urPopUpTrgInActHover");
		}
		if (oHidden != null && this["bTextOverflow"]) {
			UCF_DomUtil["addClass"](oHidden, "urPopUpTrgInActHover");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onmouseover"] = 0; };

/**
 * remove hovereffekt on popuptrigger and its content
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupTrigger["prototype"]["onmouseout"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onmouseout"]++; }; 

	if (!this["bEnabled"] || this["oDomRef"] == null) return;

	if (window["UCF_System"]["sDevice"] === "standards") {

		var oIndicator = UCF_DomUtil["$"](this["sId"] + "-btn");

		UCF_DomUtil["removeClass"](this["oDomRef"], "urPopUpTrHover");

		if (this["sTriggerIndicator"] !== "BUTTON") {
			UCF_DomUtil["removeClass"](oIndicator, "urPopUpTrgInActHover");
		}
	} else {
		if (this["sTriggerIndicator"] === "BUTTON" || !this["bEnabled"] || this["oDomRef"] == null) return;

		var oBtn = UCF_DomUtil["$"](this["sId"] + "-btn"),
			oHidden = UCF_DomUtil["$"](this["sId"] + "-hidden");;

		UCF_DomUtil["removeClass"](this["oDomRef"], "urPopUpTrHover");
		if (oBtn != null) {
			UCF_DomUtil["removeClass"](oBtn, "urPopUpTrgInActHover");
		}

		if (this["bTextOverflow"] && oHidden != null) {
			UCF_DomUtil["removeClass"](oHidden, "urPopUpTrgInActHover");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onmouseout"] = 0; };

/**
 * Handles the draghover event and opens the corresponding menu
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupTrigger["prototype"]["onlsdraghover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onlsdraghover"]++; }; 

	//return cause draghover fires in intervalls

	this["openMenu"](false);

	if (!this["oPopupMenu"]["bIsOpened"]())
		this["fireMenuAccess"](this["sId"], this["sPopupMenuId"], true);

	oBrowserEvent["cancelBubble"]();
	if (this["oPopupMenu"]["bIsDropTarget"]()) {
		this["oPopupMenu"]["setOpenEventName"](oBrowserEvent["sGetName"]());
	}
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onlsdraghover"] = 0; };

/**
 * additionally close the popup menu
 * (needed when drop occurs on popup trigger)
 * @param {BrowserEvent} oBrowserEvent
 */
UCF_PopupTrigger["prototype"]["onlsdrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onlsdrop"]++; }; 

	var oPopupMenu = this["oPopupMenu"];

	if (!oPopupMenu)
		return;

	if (oPopupMenu["bIsOpened"]())
		oPopupMenu["close"]();

};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onlsdrop"] = 0; };

/**
 * open meu for popup trigger
 * @param {boolean} bWithKeyboard
 * @param {string} sPopupMenuId
 */
UCF_PopupTrigger["prototype"]["openMenu"] = function(bWithKeyboard, sPopupMenuId) {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["openMenu"]++; }; 

	var sMenuId, oOpenerRef, oHidden;

	sMenuId = (sPopupMenuId == null) ? this["sPopupMenuId"] : sPopupMenuId;

	if (sMenuId == null || UCF_StringUtil["bIsEmpty"](sMenuId)) return;

	var oButton = UCF_DomUtil["$"](this["sId"] + "-btn");

	if (window["UCF_System"]["sDevice"] === "standards") {

		oOpenerRef = oButton;

	} else {

		oOpenerRef = this["oDomRef"];

		if (this["bTextOverflow"]) {
			oHidden = UCF_DomUtil["$"](this["sId"] + "-hidden");
			oOpenerRef = (oHidden["offsetTop"] < 0) ? oButton : oHidden;
		}
	}
	this["oPopupMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](sMenuId, true);
	this["oPopupMenu"]["setOpenerRef"](oOpenerRef);
	this["oPopupMenu"]["setAutoRefocus"](false);
	this["oPopupMenu"]["setOpenerId"](this["sId"]);
	this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
	this["oPopupMenu"]["setUserData"](this["sUserData"]);
	this["oPopupMenu"]["open"](bWithKeyboard);
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["openMenu"] = 0; };

/**
 * handles the menu close events
 */
UCF_PopupTrigger["prototype"]["onMenuClose"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onMenuClose"]++; }; 

	var oOpenerRef = document["getElementById"](this["oPopupMenu"]["sOpenerId"]);
	if (oOpenerRef == null) oOpenerRef = this["oDomRef"];
	this["updateAria"](false);
	UCF_DomUtil["focusDomElement"](oOpenerRef);
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this);
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onMenuClose"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_PopupTrigger["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["destroy"]++; }; 
	if (this["oPopupMenu"]) {
		this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this);
		this["oPopupMenu"] = null;
	}
	if (this["oDomRefOvfl"] != null) {
		this["detachBrowserEvent"]("resize", this["oDomRefOvfl"]);
		this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this);
	}
	this["oParentDomRef"] = null;
	this["oDomRefOvfl"] = null;
	this["oButtonDomRef"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["destroy"] = 0; };

/**
 * for external use only. opens the popup trigger
 *
 * @param {string} sPopupMenuId
 * @param {boolean} bWithKeyboard
 */
UCF_PopupTrigger["prototype"]["openOnRequest"] = function(sPopupMenuId, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["openOnRequest"]++; }; 

	//this.sPopupMenuId = sPopupMenuId;
	//this.setClientProperty("PopupMenuId",this.sPopupMenuId,true);
	this["openMenu"](bWithKeyboard, sPopupMenuId);
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["openOnRequest"] = 0; };

/**
 * Apply ACC helper object
 * @param {BrowserEvent} oBrowserEvent
 */
UCF_PopupTrigger["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupTrigger.js(319): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (this["sTooltip"] !== "") {
		oAccessibilityHelper["addTooltip"](this["sTooltip"]);
	}

	if (this["bEnabled"]) {
		oAccessibilityHelper["addTutor"]("MENU_TUT");
	} else {
		oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	}

	//D039230 - avoid the method when the source is the Content of the PopupTrigger
	if (oBrowserEvent["oGetSourceControl"]() === this) {
		//Apply label and accDescription
		oAccessibilityHelper["applyLabelingInfo"](this);
		oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](this["oDomRef"]));

	} else {
		oAccessibilityHelper["applyLabelingInfo"](oBrowserEvent["oGetSourceControl"]());
		oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](this["oDomRef"]));
	}
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PopupTrigger["prototype"]["aAttributeNames"] = ["sTooltip","bHasPopupMenu","sPopupMenuId","sTriggerIndicator","sUserData","sVisibility","bTextOverflow","bEnabled","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PopupTrigger["prototype"]["aEventNames"] = ["MenuAccess"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PopupTrigger["prototype"]["aMethodNames"] = ["openOnRequest","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_PopupTrigger["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PopupTrigger["prototype"]["bHasPopupMenu"] = true;

/**
 * @private
 * @type {string}
 */
UCF_PopupTrigger["prototype"]["sPopupMenuId"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.PopUpTriggerIndicator}
 */
UCF_PopupTrigger["prototype"]["sTriggerIndicator"] = "PERMANENT";

/**
 * @private
 * @type {string}
 */
UCF_PopupTrigger["prototype"]["sUserData"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_PopupTrigger["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_PopupTrigger["prototype"]["bTextOverflow"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_PopupTrigger["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_PopupTrigger["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PopupTrigger["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["bHasPopupMenu"] = true;
	this["sPopupMenuId"] = '';
	this["sTriggerIndicator"] = "PERMANENT";
	this["sUserData"] = '';
	this["sVisibility"] = "VISIBLE";
	this["bTextOverflow"] = false;
	this["bEnabled"] = true;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("HasPopupMenu", true, true);
		this["setClientProperty"]("PopupMenuId", '', true);
		this["setClientProperty"]("TriggerIndicator", "PERMANENT", true);
		this["setClientProperty"]("UserData", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("TextOverflow", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the PopupTrigger control
 * @param {string} sPopupMenuId Identifier of the popupmenu associated to the item.
 * @param {boolean} bWithKeyboard Determines whether the menu is opened by a keyboard action or by a mouse action.
 * @fires PopupTrigger::MenuAccess
 */
UCF_PopupTrigger["prototype"]["fireMenuAccess"] = function(sId, sPopupMenuId, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string, PopupMenuId: string, WithKeyboard: boolean}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PopupTrigger.js(460): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupTrigger.js(461): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupTrigger.js(462): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPopupMenuId != null, "sPopupMenuId != null", "PopupTrigger.js(463): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPopupMenuId) == "string", "typeof(sPopupMenuId) == \"string\"", "PopupTrigger.js(464): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bWithKeyboard != null, "bWithKeyboard != null", "PopupTrigger.js(465): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bWithKeyboard) == "boolean", "typeof(bWithKeyboard) == \"boolean\"", "PopupTrigger.js(466): fireMenuAccess"); };
	mParams = {
		"Id": sId,
		"PopupMenuId": sPopupMenuId,
		"WithKeyboard": bWithKeyboard
	};
	
	if (sPopupMenuId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sPopupMenuId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "PopupMenuId");
			}
		}
	
	this["fireSemanticEvent"]("PopupTrigger", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupTrigger["_"]["fireMenuAccess"] = 0; };

};
sap["ls"]["preload"]["UCF_PopupWindow"] = function() {/* global _assert, _trace, DEBUG, INFO */
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_BrowserWindow */
/// <reference path="../browser/BrowserWindow.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../../ls/core/ResourceUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * @typedef {Object} UCF_PopupWindow_Metadata
 * @property {boolean} bMaxSizeMargin
 * @property {number} [iMaxSizeMarginX] when bMaxSizeMargin=true
 * @property {number} [iMaxSizeMarginY] when bMaxSizeMargin=true
 */

/**
 * The PopupWindow control base class
 * @class
 * @param {HMTLElement} oDomRef The DOM reference
 * @param {UCF_LS} oLS The LS instance
 * @extends UCF_Control
 */
function UCF_PopupWindow(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["UCF_PopupWindow"]++; }; 

	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PopupWindow.js(32): UCF_PopupWindow"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PopupWindow.js(33): UCF_PopupWindow"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PopupWindow.js(34): UCF_PopupWindow"); };
		UCF_Control["apply"](this, [oDomRef, oLS]);
	}

};window["UCF_PopupWindow"] = UCF_PopupWindow; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopupWindow"); UCF_PopupWindow["_"] = {UCF_PopupWindow: 0}; }; ;

UCF_PopupWindow["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PopupWindow.prototype["sClassName"] = "UCF_PopupWindow";


/**
 * Returns whether an IFrame-PopupWindow is currently enhanced for field help visibility or not
 * @return {boolean}
 * @public
 */
UCF_PopupWindow["prototype"]["bIsEnhanced"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["bIsEnhanced"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["bIsEnhanced"] = 0; };

/**
 * Called by PageUpdater. Prepares the PopupWindow for an content update that changes the dimension and therefore
 * needs to set the x and y position again. Implementation is optional.
 * @overwrite
 */
UCF_PopupWindow["prototype"]["beforeUpdate"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["beforeUpdate"]++; }; 
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["beforeUpdate"] = 0; };

/**
 * Sets the default button ID for the control.
 *
 * @param {string} sDefaultButtonId ID of the button that is executed if the user hits the enter key
 */
UCF_PopupWindow["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["setDefaultButtonId"]++; }; 
	UCF_Control.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["setDefaultButtonId"] = 0; };

/**
 * @private
 * @static
 * @type {UCF_PopupWindow_Metadata}
 */
UCF_PopupWindow["oMetadata"] = null;

/**
 * @static
 * @return {UCF_PopupWindow_Metadata}
 */
UCF_PopupWindow["oGetMetadata"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["oGetMetadata"]++; }; 
	if (UCF_PopupWindow["oMetadata"] === null) {
		UCF_PopupWindow["oMetadata"] = UCF_ResourceUtil["oGetMetadataFromTheme"]('lsPopupWindow__metadata');
	}

	return UCF_PopupWindow["oMetadata"];
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["oGetMetadata"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PopupWindow["prototype"]["aAttributeNames"] = ["bIsResizable","bHasCloseButton","sX","sY","sWidth","sHeight","bWindowSize","sDefaultButtonId","sHotkeysId","bOverrideMinimumSize","bIsMaximized","bHasHelpButton","sMode","sCustomData","sCustomStyle","bNoContentScrolling","bContextMenuEvent","sDesign","iHeadingLevel"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PopupWindow["prototype"]["aEventNames"] = ["Close","Help","Hotkey","Resize","Move","Maximize","Restore","PopupContextMenu"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PopupWindow["prototype"]["aMethodNames"] = ["setDefaultButtonId","setTitleText","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {boolean}
 */
UCF_PopupWindow["prototype"]["bIsResizable"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_PopupWindow["prototype"]["bHasCloseButton"] = true;

/**
 * @private
 * @type {string}
 */
UCF_PopupWindow["prototype"]["sX"] = '-1';

/**
 * @private
 * @type {string}
 */
UCF_PopupWindow["prototype"]["sY"] = '-1';

/**
 * @private
 * @type {string}
 */
UCF_PopupWindow["prototype"]["sWidth"] = '-1';

/**
 * @private
 * @type {string}
 */
UCF_PopupWindow["prototype"]["sHeight"] = '-1';

/**
 * @private
 * @type {boolean}
 */
UCF_PopupWindow["prototype"]["bWindowSize"] = false;

/**
 * @private
 * @type {string}
 */
UCF_PopupWindow["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PopupWindow["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PopupWindow["prototype"]["bOverrideMinimumSize"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_PopupWindow["prototype"]["bIsMaximized"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_PopupWindow["prototype"]["bHasHelpButton"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Mode}
 */
UCF_PopupWindow["prototype"]["sMode"] = "MODAL";

/**
 * @private
 * @type {string}
 */
UCF_PopupWindow["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PopupWindow["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PopupWindow["prototype"]["bNoContentScrolling"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_PopupWindow["prototype"]["bContextMenuEvent"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.QuickViewDesign}
 */
UCF_PopupWindow["prototype"]["sDesign"] = "STANDARD";

/**
 * @private
 * @type {number}
 */
UCF_PopupWindow["prototype"]["iHeadingLevel"] = 0;

//#JSCOVER_EXCL_START
/** @protected */
UCF_PopupWindow["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["setDefaultValues"]++; }; 
	this["bIsResizable"] = true;
	this["bHasCloseButton"] = true;
	this["sX"] = '-1';
	this["sY"] = '-1';
	this["sWidth"] = '-1';
	this["sHeight"] = '-1';
	this["bWindowSize"] = false;
	this["sDefaultButtonId"] = '';
	this["sHotkeysId"] = '';
	this["bOverrideMinimumSize"] = false;
	this["bIsMaximized"] = false;
	this["bHasHelpButton"] = false;
	this["sMode"] = "MODAL";
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["bNoContentScrolling"] = false;
	this["bContextMenuEvent"] = false;
	this["sDesign"] = "STANDARD";
	this["iHeadingLevel"] = 0;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("IsResizable", true, true);
		this["setClientProperty"]("HasCloseButton", true, true);
		this["setClientProperty"]("X", '-1', true);
		this["setClientProperty"]("Y", '-1', true);
		this["setClientProperty"]("Width", '-1', true);
		this["setClientProperty"]("Height", '-1', true);
		this["setClientProperty"]("WindowSize", false, true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("OverrideMinimumSize", false, true);
		this["setClientProperty"]("IsMaximized", false, true);
		this["setClientProperty"]("HasHelpButton", false, true);
		this["setClientProperty"]("Mode", "MODAL", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("NoContentScrolling", false, true);
		this["setClientProperty"]("ContextMenuEvent", false, true);
		this["setClientProperty"]("Design", "STANDARD", true);
		this["setClientProperty"]("HeadingLevel", 0, true);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires PopupWindow::Close
 */
UCF_PopupWindow["prototype"]["fireClose"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireClose"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "PopupWindow.js(279): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupWindow.js(280): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupWindow.js(281): fireClose"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("PopupWindow", "Close", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireClose"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires PopupWindow::Help
 */
UCF_PopupWindow["prototype"]["fireHelp"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireHelp"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "PopupWindow.js(298): fireHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupWindow.js(299): fireHelp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupWindow.js(300): fireHelp"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("PopupWindow", "Help", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireHelp"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @param {string} sControlId The Id of the control where the event occured
 * @fires PopupWindow::Hotkey
 */
UCF_PopupWindow["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId, sControlId) {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string, ControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "PopupWindow.js(322): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupWindow.js(323): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupWindow.js(324): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "PopupWindow.js(325): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "PopupWindow.js(326): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "PopupWindow.js(327): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "PopupWindow.js(328): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sControlId != null, "sControlId != null", "PopupWindow.js(329): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sControlId) == "string", "typeof(sControlId) == \"string\"", "PopupWindow.js(330): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId,
		"ControlId": sControlId
	};
	
	
	if (sProviderId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sProviderId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ProviderId");
			}
		}
	if (sControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ControlId");
			}
		}
	this["fireSemanticEvent"]("PopupWindow", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireHotkey"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iWidth Width of the control in Pixels
 * @param {number} iHeight Height of the control in Pixels
 * @param {number} iContentWidth Width of the content in Pixels
 * @param {number} iContentHeight Height of the content in Pixels
 * @param {number} iX horizontal position of the control in Pixels
 * @param {number} iY vertical position of the control in Pixels
 * @fires PopupWindow::Resize
 */
UCF_PopupWindow["prototype"]["fireResize"] = function(sId, iWidth, iHeight, iContentWidth, iContentHeight, iX, iY) {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireResize"]++; }; 
	/** @type {{Id: string, Width: number, Height: number, ContentWidth: number, ContentHeight: number, X: number, Y: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "PopupWindow.js(369): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupWindow.js(370): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupWindow.js(371): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iWidth != null, "iWidth != null", "PopupWindow.js(372): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iWidth) == "number", "typeof(iWidth) == \"number\"", "PopupWindow.js(373): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iHeight != null, "iHeight != null", "PopupWindow.js(374): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iHeight) == "number", "typeof(iHeight) == \"number\"", "PopupWindow.js(375): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iContentWidth != null, "iContentWidth != null", "PopupWindow.js(376): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iContentWidth) == "number", "typeof(iContentWidth) == \"number\"", "PopupWindow.js(377): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iContentHeight != null, "iContentHeight != null", "PopupWindow.js(378): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iContentHeight) == "number", "typeof(iContentHeight) == \"number\"", "PopupWindow.js(379): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iX != null, "iX != null", "PopupWindow.js(380): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iX) == "number", "typeof(iX) == \"number\"", "PopupWindow.js(381): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iY != null, "iY != null", "PopupWindow.js(382): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iY) == "number", "typeof(iY) == \"number\"", "PopupWindow.js(383): fireResize"); };
	mParams = {
		"Id": sId,
		"Width": iWidth,
		"Height": iHeight,
		"ContentWidth": iContentWidth,
		"ContentHeight": iContentHeight,
		"X": iX,
		"Y": iY
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("PopupWindow", "Resize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iX horizontal position of the control in Pixels
 * @param {number} iY vertical position of the control in Pixels
 * @fires PopupWindow::Move
 */
UCF_PopupWindow["prototype"]["fireMove"] = function(sId, iX, iY) {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireMove"]++; }; 
	/** @type {{Id: string, X: number, Y: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PopupWindow.js(414): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupWindow.js(415): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupWindow.js(416): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iX != null, "iX != null", "PopupWindow.js(417): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iX) == "number", "typeof(iX) == \"number\"", "PopupWindow.js(418): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iY != null, "iY != null", "PopupWindow.js(419): fireMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iY) == "number", "typeof(iY) == \"number\"", "PopupWindow.js(420): fireMove"); };
	mParams = {
		"Id": sId,
		"X": iX,
		"Y": iY
	};
	
	
	
	this["fireSemanticEvent"]("PopupWindow", "Move", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireMove"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iContentWidth Width of the content in Pixels
 * @param {number} iContentHeight Height of the content in Pixels
 * @fires PopupWindow::Maximize
 */
UCF_PopupWindow["prototype"]["fireMaximize"] = function(sId, iContentWidth, iContentHeight) {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireMaximize"]++; }; 
	/** @type {{Id: string, ContentWidth: number, ContentHeight: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PopupWindow.js(443): fireMaximize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupWindow.js(444): fireMaximize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupWindow.js(445): fireMaximize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iContentWidth != null, "iContentWidth != null", "PopupWindow.js(446): fireMaximize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iContentWidth) == "number", "typeof(iContentWidth) == \"number\"", "PopupWindow.js(447): fireMaximize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iContentHeight != null, "iContentHeight != null", "PopupWindow.js(448): fireMaximize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iContentHeight) == "number", "typeof(iContentHeight) == \"number\"", "PopupWindow.js(449): fireMaximize"); };
	mParams = {
		"Id": sId,
		"ContentWidth": iContentWidth,
		"ContentHeight": iContentHeight
	};
	
	
	
	this["fireSemanticEvent"]("PopupWindow", "Maximize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireMaximize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iContentWidth Width of the content in Pixels
 * @param {number} iContentHeight Height of the content in Pixels
 * @fires PopupWindow::Restore
 */
UCF_PopupWindow["prototype"]["fireRestore"] = function(sId, iContentWidth, iContentHeight) {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireRestore"]++; }; 
	/** @type {{Id: string, ContentWidth: number, ContentHeight: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "PopupWindow.js(472): fireRestore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupWindow.js(473): fireRestore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupWindow.js(474): fireRestore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iContentWidth != null, "iContentWidth != null", "PopupWindow.js(475): fireRestore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iContentWidth) == "number", "typeof(iContentWidth) == \"number\"", "PopupWindow.js(476): fireRestore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iContentHeight != null, "iContentHeight != null", "PopupWindow.js(477): fireRestore"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iContentHeight) == "number", "typeof(iContentHeight) == \"number\"", "PopupWindow.js(478): fireRestore"); };
	mParams = {
		"Id": sId,
		"ContentWidth": iContentWidth,
		"ContentHeight": iContentHeight
	};
	
	
	
	this["fireSemanticEvent"]("PopupWindow", "Restore", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["fireRestore"] = 0; };

/**
 * @protected
 * @param {string} sId The Id of the PopupWindow control
 * @param {string} sControlId The Id of the control where the event occured
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {boolean} bShift Indicates whether the shift key was pressed when the event occured.
 * @param {boolean} bCtrl Indicates whether the control key was pressed when the event occured.
 * @param {boolean} bAlt Indicates whether the alt key was pressed when the event occured.
 * @fires PopupWindow::PopupContextMenu
 */
UCF_PopupWindow["prototype"]["firePopupContextMenu"] = function(sId, sControlId, iPosX, iPosY, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["firePopupContextMenu"]++; }; 
	/** @type {{Id: string, ControlId: string, PosX: number, PosY: number, Shift: boolean, Ctrl: boolean, Alt: boolean}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "PopupWindow.js(507): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "PopupWindow.js(508): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "PopupWindow.js(509): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sControlId != null, "sControlId != null", "PopupWindow.js(510): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sControlId) == "string", "typeof(sControlId) == \"string\"", "PopupWindow.js(511): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "PopupWindow.js(512): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "PopupWindow.js(513): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "PopupWindow.js(514): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "PopupWindow.js(515): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "PopupWindow.js(516): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "PopupWindow.js(517): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "PopupWindow.js(518): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "PopupWindow.js(519): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "PopupWindow.js(520): firePopupContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "PopupWindow.js(521): firePopupContextMenu"); };
	mParams = {
		"Id": sId,
		"ControlId": sControlId,
		"PosX": iPosX,
		"PosY": iPosY,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt
	};
	
	if (sControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ControlId");
			}
		}
	
	
	
	
	
	this["fireSemanticEvent"]("PopupWindow", "PopupContextMenu", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow["_"]["firePopupContextMenu"] = 0; };

UCF_PopupWindow.prototype["aPublicMethods"] = ["bIsEnhanced"].concat(UCF_PopupWindow.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PopupWindowDimensions"] = function() {/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_PopupWindow_ie6 */
/// <reference path="./PopupWindow_ie6.js" />

/**
 * Helper for
 * - size measurements (measureXXX)
 * - reading current/computed style values or DOM values like height, width, padding, border, etc. (readXXX)
 * - other calculations for size- and position-related operations
 * @class
 * @param {UCF_PopupWindow_ie6} oPW PopupWindow instance
 */
function UCF_PopupWindowDimensions(oPW) {if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["UCF_PopupWindowDimensions"]++; }; 
	this["oPW"] = oPW; // eslint-disable-line @ur/no-memory-leaks
	this["bContentPaddingCell"] = true;
};window["UCF_PopupWindowDimensions"] = UCF_PopupWindowDimensions; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopupWindowDimensions"); UCF_PopupWindowDimensions["_"] = {UCF_PopupWindowDimensions: 0}; }; ;
UCF_PopupWindowDimensions["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_PopupWindowDimensions.prototype["sClassName"] = "UCF_PopupWindowDimensions";

/** @override */
UCF_PopupWindowDimensions["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["destroy"]++; }; 
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["destroy"] = 0; };

/**
 * Reads content padding applied to Table-TD in older styles and to table in Belize
 * @return {number}
 */
UCF_PopupWindowDimensions["prototype"]["readContentPadding"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readContentPadding"]++; }; 
	var oResult = {};
	var _this = this;
	var getPadding = function(s) {
		var bIsIEQuirksMode = UCF_UserAgent["bIsIE"]() && !UCF_UserAgent["bIsStandardsMode"]();
		var T = bIsIEQuirksMode ? "paddingTop" : "padding-top";
		var L = bIsIEQuirksMode ? "paddingLeft" : "padding-left";
		var B = bIsIEQuirksMode ? "paddingBottom" : "padding-bottom";
		var R = bIsIEQuirksMode ? "paddingRight" : "padding-right";
		return {
			"vertical": parseInt(UCF_DomUtil["sGetCurrentStyle"](UCF_DomUtil["$"](_this["oPW"]["sId"] + s), T)) + parseInt(UCF_DomUtil["sGetCurrentStyle"](UCF_DomUtil["$"](_this["oPW"]["sId"] + s), B)),
			"horizontal": parseInt(UCF_DomUtil["sGetCurrentStyle"](UCF_DomUtil["$"](_this["oPW"]["sId"] + s), L)) + parseInt(UCF_DomUtil["sGetCurrentStyle"](UCF_DomUtil["$"](_this["oPW"]["sId"] + s), R))
		};
	};
	oResult = getPadding("-cntTD");
	if (oResult["vertical"] === 0 && oResult["horizontal"] === 0) {
		// Belize
		oResult = getPadding("-cnttbl");
		this["bContentPaddingCell"] = false;
	}
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readContentPadding"] = 0; };

/**
 * Belize: content padding is applied on the table. Older themes: padding is applied on the cell (true)
 * @return {boolean}
 */
UCF_PopupWindowDimensions["prototype"]["bHasContentPaddingCell"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["bHasContentPaddingCell"]++; }; 
	return this["bContentPaddingCell"];
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["bHasContentPaddingCell"] = 0; };

/**
 * Reads inner+outer border size from current style.
 * @return {number}
 */
UCF_PopupWindowDimensions["prototype"]["readBorderSize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readBorderSize"]++; }; 
	// Value can be cached at class-level because it only depends on theme and NOT on any parameters or custom-styles
	// Of course this is only effective in DIV-popups
	if (UCF_PopupWindowDimensions["iBorderSize"] === undefined) {
		var sBorderWidth = UCF_DomUtil["sGetCurrentStyle"](this["oPW"]["oDomRef"], "borderWidth");
		if (!sBorderWidth) {
			sBorderWidth = UCF_DomUtil["sGetCurrentStyle"](this["oPW"]["oDomRef"], "borderTopWidth");
		}
		UCF_PopupWindowDimensions["iBorderSize"] = parseInt(sBorderWidth);
		if (isNaN(UCF_PopupWindowDimensions["iBorderSize"])) UCF_PopupWindowDimensions["iBorderSize"] = 1;
		// add inner border:
		// - fixed inner border width (urPWInnerBorder: 1px) - in Belice this could be 0!
		// - IE-Quirks/Corbu: Instead of outer border 10px => outer border 1px and inner 9px margin
		sBorderWidth = UCF_DomUtil["sGetCurrentStyle"](UCF_DomUtil["$"](this["oPW"]["sId"] + "-ib"), "borderWidth");
		if (!sBorderWidth) {
			sBorderWidth = UCF_DomUtil["sGetCurrentStyle"](UCF_DomUtil["$"](this["oPW"]["sId"] + "-ib"), "borderTopWidth");
		}
		var iInnerBorder = parseInt(sBorderWidth);
		if (!isNaN(iInnerBorder)) UCF_PopupWindowDimensions["iBorderSize"] += iInnerBorder;
		var iMargin = parseInt(UCF_DomUtil["sGetCurrentStyle"](UCF_DomUtil["firstChild"](this["oPW"]["oDomRef"]), "margin"));
		if (!isNaN(iMargin)) UCF_PopupWindowDimensions["iBorderSize"] += iMargin;

		//_trace(INFO, "*** iBorderSize=" + UCF_PopupWindowDimensions.iBorderSize);
	}

	return UCF_PopupWindowDimensions["iBorderSize"];
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readBorderSize"] = 0; };

/**
 * Returns true if the current theme has a big border - ONLY corbu theme.
 * @return {boolean}
 */
UCF_PopupWindowDimensions["prototype"]["bHasBigBorder"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["bHasBigBorder"]++; }; 
	return (this["readBorderSize"]() > 2);
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["bHasBigBorder"] = 0; };

UCF_PopupWindowDimensions["prototype"]["measureTitleHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["measureTitleHeight"]++; }; 
	return UCF_DomUtil["$"](this["oPW"]["sId"] + "-ttl")["offsetHeight"] + UCF_DomUtil["$"](this["oPW"]["sId"] + '-spr')["offsetHeight"];
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["measureTitleHeight"] = 0; };

/**
 * @param {number} iWidth
 * @return {number} height of the messagearea when having applied a certain width
 */
UCF_PopupWindowDimensions["prototype"]["measureMessageAreaHeightByWidth"] = function(iWidth) {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["measureMessageAreaHeightByWidth"]++; }; 
	var messageBar = UCF_DomUtil["$"](this["oPW"]["sId"] + "-mb");

	if (!messageBar) return 0;

	var messageAreaHeight = 0;

	//apply values
	messageBar["style"]["overflow"] = "visible";
	messageBar["style"]["width"] = iWidth + "px";

	//measure
	messageAreaHeight = messageBar["scrollHeight"];

	//restore orginal values
	messageBar["style"]["width"] = "100%";
	messageBar["style"]["overflow"] = "hidden";

	return messageAreaHeight;
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["measureMessageAreaHeightByWidth"] = 0; };

/**
 * @return {number}  the width needed for the buttons in the title
 */
UCF_PopupWindowDimensions["prototype"]["readButtonWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readButtonWidth"]++; }; 
	var iWidth = null;
	var oTestButton = UCF_DomUtil["$"](this["oPW"]["sId"] + "-close") || UCF_DomUtil["$"](this["oPW"]["sId"] + "-minmax");
	if (oTestButton) {
		iWidth = oTestButton["offsetWidth"];
		var sComputedPaddingRight = UCF_DomUtil["sGetCurrentStyle"](oTestButton["parentNode"], window["UCF_System"]["bIsRTL"] ? 'paddingLeft' : 'paddingRight');
		if (sComputedPaddingRight) {
			iWidth += parseInt(sComputedPaddingRight);
		}
	}
	if (iWidth == null) {
		// Old hard-coded default value for all styles (before CORBU)
		// Note: This is actually an obvious bug, because image size is style-dependent !
		iWidth = 20;
	}
	var iResultWidth = 7;
	if (!(UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
		iResultWidth += 8; // eslint-disable-line no-magic-numbers
	}
	if (this["oPW"]["bIsResizable"]) iResultWidth += iWidth; //UCF_PopupWindowDimensions.iSingleButtonWidth;

	if (this["oPW"]["bHasCloseButton"]) iResultWidth += iWidth; //UCF_PopupWindowDimensions.iSingleButtonWidth;

	if (this["oPW"]["bHasHelpButton"]) iResultWidth += iWidth; //UCF_PopupWindowDimensions.iSingleButtonWidth;

	return iResultWidth + this["readBorderSize"]();
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readButtonWidth"] = 0; };

/**
 * Try to estimate a minimum size - mainly the required wdith for the footer buttons (with no FooterToolbar!).
 */
UCF_PopupWindowDimensions["prototype"]["estimateMinSize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["estimateMinSize"]++; }; 
	var bHasFooterToolbar = UCF_DomUtil["$"](this["oPW"]["sId"] + "-tbcontainer") !== null;
	var iWidth = 0;
	if (bHasFooterToolbar) {
		iWidth = UCF_PopupWindow_ie6["MINIMAL_WIDTH"];
	} else {
		var OLD_THEMES_WAVE_SIZE = 56;
		// Old button-row has no overflow mechanism
		var oButtonContainer = UCF_DomUtil["$"](this["oPW"]["sId"] + "-btns");
		if (oButtonContainer) {
			iWidth = UCF_UserAgent["bIsIOS"]() && UCF_UserAgent["bIsSafari"]() ? UCF_DomUtil["oGetFirstChild"](oButtonContainer)["scrollWidth"] : oButtonContainer["scrollWidth"];
			if (UCF_DomUtil["sGetCurrentStyle"](oButtonContainer["previousSibling"], "display") !== "none") {
				iWidth += OLD_THEMES_WAVE_SIZE;
			}
			iWidth += oButtonContainer["nextSibling"]["clientWidth"];
		} else {
			iWidth = UCF_PopupWindow_ie6["MINIMAL_WIDTH"];
		}
	}
	return {
		"width": iWidth + 2 * this["readBorderSize"](), // eslint-disable-line no-magic-numbers
		"height": UCF_PopupWindow_ie6["MINIMAL_HEIGHT"] + this["measureMessageAreaHeightByWidth"](iWidth)
	};
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["estimateMinSize"] = 0; };

/**
 * @return height of the footer (varies if buttons are there or not)
 */
UCF_PopupWindowDimensions["prototype"]["readFooterbarHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readFooterbarHeight"]++; }; 
	return UCF_DomUtil["oGetFirstChild"](UCF_DomUtil["$"](this["oPW"]["sId"] + "-ftr"))["clientHeight"];
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readFooterbarHeight"] = 0; };

/**
 * Get the size of a rectangle in pixels with the given measures (em,ex,%, pt, etc)
 *
 * @param {string} sWidth
 * @param {string} sHeight
 * @return translates sizes with em, ex or % in absolute pixel values
 */
UCF_PopupWindowDimensions["prototype"]["measurePixelSize"] = function(sWidth, sHeight) {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["measurePixelSize"]++; }; 
	if (sWidth == "") {
		sWidth = 0;
	} else {
		sWidth = UCF_StringUtil["sTrim"](sWidth);
	}
	if (sHeight == "") {
		sHeight = 0;
	} else {
		sHeight = UCF_StringUtil["sTrim"](sHeight);
	}

	var dummy = document["createElement"]("div");
	this["oPW"]["oLS"]["oGetAssociatedAreaRef"]()["appendChild"](dummy);

	var style = dummy["style"];
	style["position"] = "absolute";
	style["left"] = "0px";
	style["top"] = "-5000px";

	var pixelWidth, pixelHeight;
	if (typeof(sWidth) === "string" && sWidth["indexOf"]("%") > 0) {
		pixelWidth = this["oPW"]["oGetInnerWindowSize"](this["oPW"]["oHostWindow"])["width"] * parseInt(sWidth) / 100; // eslint-disable-line no-magic-numbers
	} else {
		if (!isNaN(sWidth)) sWidth += "px";
		dummy["style"]["width"] = sWidth;
		pixelWidth = dummy["scrollWidth"];
	}

	if (typeof(sHeight) === "string" && sHeight["indexOf"]("%") > 0) {
		pixelHeight = this["oPW"]["oGetInnerWindowSize"](this["oPW"]["oHostWindow"])["height"] * parseInt(sHeight) / 100; // eslint-disable-line no-magic-numbers
	} else {
		// Total craziness: measure using width value, because IE does not calculate height correctly (?!)
		if (!isNaN(sHeight)) sHeight += "px";
		dummy["style"]["width"] = sHeight;
		pixelHeight = dummy["scrollWidth"];
	}

	this["oPW"]["oLS"]["oGetAssociatedAreaRef"]()["removeChild"](dummy);
	return {
		"width": parseInt(pixelWidth),
		"height": parseInt(pixelHeight)
	};

};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["measurePixelSize"] = 0; };

/**
 * Read current dimensions of the container DIV or IFrame. In case of DIV the size includes the borders (corbu theme).
 */
UCF_PopupWindowDimensions["prototype"]["readCurrentFrame"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readCurrentFrame"]++; }; 
	if (this["oPW"]["bIsDivPopup"]) {
		return {
			"x": this["oPW"]["oContainer"]["offsetLeft"],
			"y": this["oPW"]["oContainer"]["offsetTop"],
			"width": this["oPW"]["oContainer"]["offsetWidth"],
			"height": this["oPW"]["oContainer"]["offsetHeight"]
		};
	} else {
		var oStyle = this["oPW"]["oContainer"]["style"];
		return {
			"x": parseInt(oStyle["left"]),
			"y": parseInt(oStyle["top"]),
			"width": parseInt(oStyle["width"]),
			"height": parseInt(oStyle["height"])
		};
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readCurrentFrame"] = 0; };

UCF_PopupWindowDimensions["prototype"]["getInnerTableHeightInIE"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["getInnerTableHeightInIE"]++; }; 
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		return parseInt(UCF_DomUtil["sGetCurrentStyle"](UCF_DomUtil["$"](this["oPW"]["sId"] + "-cntTD"), "height"));
	}
	return undefined;
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["getInnerTableHeightInIE"] = 0; };

UCF_PopupWindowDimensions["prototype"]["readContentSizeForEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readContentSizeForEvent"]++; }; 
	var oContentRect = UCF_DomUtil["oGetObjectRect"](UCF_DomUtil["$"](this["oPW"]["sId"] + "-cnt"));
	return { "width": oContentRect["width"] - this["oPW"]["iContentTableCellHorizontalPadding"], "height": oContentRect["height"] - this["oPW"]["iContentTableCellVerticalPadding"] };
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["readContentSizeForEvent"] = 0; };

/**
 * Calculates the allowed x/y location based on the given position and size of the popup and the available space on the main page, so that
 * the popup is completely visible and no scrollbars are caused in the page.
 * This is used during move and by PopupWindow.relocate()
 * @param {Object} oFrame (x,y,width,height) The actual current frame or a calculated one
 * @return {Object|null} (x,y) An allowed position (could be unchanged x,y values from the input if it is an allowed position)
 */
UCF_PopupWindowDimensions["prototype"]["getPositionConstraint"] = function(oFrame) {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["getPositionConstraint"]++; }; 
	var oHW = this["oPW"]["oHostWindow"];
	// This is only relevant for DIV- or IFrame-popups in "standalone" mode (no portal)
	// Note 1: Take into account special-case in WebGUI where a client-side rendered DIV-popup may have a IFrame-Popup as host, although we do
	// not have a working concept of IFrame- and DIV-popups to coexist, it is "tolerated"...
	// Note 2: Use == to compare for IE11 Quirks Mode because === would be true for reference for same window...?!
	if (oHW != this["oPW"]["oLS"]["oGetMainLS"]()["oWindow"] && (oHW["name"] && oHW["name"]["indexOf"]("URLSPW-") !== 0 || !oHW["name"])) return null; // eslint-disable-line eqeqeq

	var oResult = { "x": oFrame["x"], "y": oFrame["y"] };
	var oInnerSize = this["oPW"]["oGetInnerWindowSize"](oHW);
	var oScrollOffset;
	if (this["oPW"]["oLS"]["oGetPageInternal"]()["bInsideShellIFrameOnIOS"]()) {
		oScrollOffset = this["oPW"]["oLS"]["oGetPageScrollOffset"]();
	} else {
		// IFrame-Popups: In any shell, the "host-window" is NOT the window of the UR Page!
		oScrollOffset = UCF_DomUtil["oGetScrollOffset"](oHW);
	}

	// Make sure to not cause scrollbars in any case/browser
	var SAFETY_DISTANCE = {
		"x": 2,
		"y": UCF_UserAgent["bIsMSEdge"]() || UCF_UserAgent["bIsFirefox"]() ? 5 : 3 // eslint-disable-line no-magic-numbers
	};

	var iMaxX;
	var iSB;
	if (window["UCF_System"]["bIsRTL"]) {
		iMaxX = oInnerSize["width"] - oFrame["width"];
		oResult["x"] = Math["min"](oResult["x"], iMaxX);
		oResult["x"] = Math["max"](oResult["x"], 0);
	} else {
		var bHasScrollbarX = Math["max"](oHW["document"]["body"]["scrollWidth"], oHW["document"]["documentElement"]["scrollWidth"]) > Math["max"](oHW["document"]["body"]["clientWidth"], oHW["document"]["documentElement"]["clientWidth"]);
		iSB = bHasScrollbarX ? UCF_DomUtil["iGetScrollbarWidth"]() : 0;
		iMaxX = oScrollOffset["x"] + oInnerSize["width"] - oFrame["width"] - iSB - SAFETY_DISTANCE["x"];
		oResult["x"] = Math["min"](oResult["x"], iMaxX);
		oResult["x"] = Math["max"](oResult["x"], 0);
		if (UCF_UserAgent["bIsIOS"]() && oScrollOffset["x"] > 0) {
			oResult["x"] = oScrollOffset["x"];
		}
	}

	var bHasScrollbarY = Math["max"](oHW["document"]["body"]["scrollHeight"], oHW["document"]["documentElement"]["scrollHeight"]) > Math["max"](oHW["document"]["body"]["clientHeight"], oHW["document"]["documentElement"]["clientHeight"]);
	iSB = bHasScrollbarY ? UCF_DomUtil["iGetScrollbarWidth"]() : 0;
	var iMaxY = oScrollOffset["y"] + oInnerSize["height"] - oFrame["height"] - iSB - SAFETY_DISTANCE["y"];
	oResult["y"] = Math["min"](oResult["y"], iMaxY);
	oResult["y"] = Math["max"](oResult["y"], 0);

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["getPositionConstraint"] = 0; };

/**
 * Calculates the value for the ContentSize parameter of the semantic Resize event.
 * @return {Object} width, height
 */
UCF_PopupWindowDimensions["prototype"]["oGetContentSizeForEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["oGetContentSizeForEvent"]++; }; 
	var oContentRect = UCF_DomUtil["oGetObjectRect"](UCF_DomUtil["$"](this["oPW"]["sId"] + "-cnt"));
	return { "width": oContentRect["width"] - this["oPW"]["iContentTableCellHorizontalPadding"], "height": oContentRect["height"] - this["oPW"]["iContentTableCellVerticalPadding"] };
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["oGetContentSizeForEvent"] = 0; };

/**
 * Returns the inner size (without padding, scrollbars, etc.) of the PopupWindow content area. Used for the internal Resize event.
 * @return {Object} width, height
 */
UCF_PopupWindowDimensions["prototype"]["oGetContentInnerSize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["oGetContentInnerSize"]++; }; 
	this["oPW"]["iScrollbarWidth"] = this["oPW"]["iScrollbarWidth"] || UCF_DomUtil["iGetScrollbarWidth"]();
	var oCnt = UCF_DomUtil["$"](this["oPW"]["sId"] + "-cnt");
	var iScrollbarH = 0,
		iScrollbarV = 0;
	if (oCnt["scrollWidth"] - oCnt["offsetWidth"] > 0) {
		iScrollbarH = this["oPW"]["iScrollbarWidth"];
	}
	if (oCnt["scrollHeight"] - oCnt["offsetHeight"] > 0) {
		iScrollbarV = this["oPW"]["iScrollbarWidth"];
	}
	return {
		"width": parseInt(oCnt["style"]["width"]) - this["oPW"]["iContentTableCellHorizontalPadding"] - iScrollbarH,
		"height": parseInt(oCnt["style"]["height"]) - this["oPW"]["iContentTableCellVerticalPadding"] - iScrollbarV
	};
};;if (__UCF_COVERAGE__) { UCF_PopupWindowDimensions["_"]["oGetContentInnerSize"] = 0; };

};
sap["ls"]["preload"]["UCF_PopupWindow_ie6"] = function() {/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../../ls/core/ResourceUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Animation */
/// <reference path="../anim/Animation.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_BrowserWindow */
/// <reference path="../browser/BrowserWindow.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_PopupManager */
/// <reference path="../helper/PopupManager.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>
/* global UCF_PopupWindowDimensions */
/// <reference path="./PopupWindowDimensions.js"/>
/* global UCF_PopupWindow */
/// <reference path="./PopupWindow.js"/>

/**
 * The PopupWindow control
 * @class
 * @param {HMTLElement} oDomRef The DOM reference
 * @param {UCF_LS} oLS The LS instance
 * @extends UCF_Control
 */
function UCF_PopupWindow_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["UCF_PopupWindow_ie6"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PopupWindow_ie6.js(47): UCF_PopupWindow_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PopupWindow_ie6.js(48): UCF_PopupWindow_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PopupWindow_ie6.js(49): UCF_PopupWindow_ie6"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["defineEvents"]([
		'Move',
		'Resize',
		'MoveAndResize' // Maximize/Restore
	]);

	this["sDragMode"] = null;
	this["resizeListenerForPopup"] = null;

	/** @type {UCF_PopupManager} */
	this["oPopupManager"] = oLS["oGetPopupManagerInternal"]();

	this["animationRectangle"] = null;
	this["bIsInitialized"] = false;
	this["bIsDivPopup"] = null; // eslint-disable-line @ur/no-memory-leaks
	// Keep UCF instance alive during update/purge - actually the property is not needed because we also overwrite bDoKeepAlive()
	this["bKeepAlive"] = true;
	this["bUserHasResized"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["bUserHasMoved"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["bUserHasMaximized"] = false; // eslint-disable-line @ur/no-memory-leaks

	this["bUseGhostForResize"] = true;

	this["bIgnoreLayoutChange"] = false;

	//set to true if popupwindow is destroyed to cancel animation
	this["bStopAnimation"] = false;

	//after resize, set back focus to previously focussed element
	this["sFocussedElementId"] = null;

	//frame of the popup in restored mode
	this["oFrameWhenRestored"] = null;

	this["oFrame"] = {};

	//initialize the default button for this control
	this["setDefaultButtonId"](this["sDefaultButtonId"]);

	this["oFocusDomRef"] = UCF_DomUtil["$"](this["sId"] + "-ttl");

	// /** @type {UCF_ScrollArea} */
	// this.oScrollArea = null;
	// var oSC = UCF_DomUtil.$(this.sId + "-cnt");
	// if (this.bNoContentScrolling && oSC.firstChild) {
	// 	// API parameter: Framework (WebGUI) wants to switch off scrolling PW content
	// 	// and use own scrolling on RasterLayout instead
	// 	oSC = oSC.firstChild;
	// }
	// this.oScrollArea = UCF_ClassLoader.oGetClass('UCF_ScrollArea').oCreateAndConnectScrollArea(
	// 	this,
	// 	'AUTO',
	// 	'onAreaScroll',
	// 	oSC
	// );

	/** @type {UCF_ScrollArea} */
	this["oScrollArea"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(UCF_DomUtil["$"](this["sId"] + "-cnt")); // eslint-disable-line @ur/no-memory-leaks
	this["oScrollArea"]["enableDragScrolling"](true);
	this["oScrollArea"]["attachEvent"](this["oScrollArea"]["E_EVENTS"]["Scroll"], this, "onAreaScroll");
	this["addDelegate"](this["oScrollArea"]);
	this["attachBrowserEvent"]("scroll", UCF_DomUtil["$"](this["sId"] + "-cnt"));

	this["oDomRef"]["style"]["top"] = "0px";

	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
	//this.oLS.oBrowserWindow.attachEvent(this.oLS.oBrowserWindow.E_EVENTS.ZoomChange, this, "onZoomChange");
	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["OrientationChange"], this, "onOrientationChange");

	this["bShouldSetInitialBounds"] = false;
	this["bOpenerHasActiveComponents"] = null; // eslint-disable-line @ur/no-memory-leaks
	this["bCancelCtrlF4KeyPress"] = false;

	this["oEnhancedOldSettings"] = null;
	this["oOpenLayeredControlCount"] = 0;
	this["iEnhancedValue"] = 30; // Room for box-shadow when IFrame is enlarged - see openLayeredControl()

	/** @type {UCF_PopupWindowDimensions} */
	this["oPWDimensions"] = new (UCF_ClassLoader["oGetClass"]("UCF_PopupWindowDimensions"))(this);

	this["bIgnoreScrollEvent"] = false;
	this["bIsInitializedAfterUpdate"] = false;

	this["oBlindLayer"] = null; // Used for DIV-popups in IE

	// "Max size margin" in % according to spec (not for phones)
	this["bMaxSizeMargin"] = false;
	var oMeta = UCF_PopupWindow["oGetMetadata"]();
	if (oMeta && oMeta["bMaxSizeMargin"] === true) {
		this["bMaxSizeMargin"] = true;
		this["iMaxSizeMarginX"] = oMeta["iMaxSizeMarginX"]; // eslint-disable-line @ur/no-memory-leaks
		this["iMaxSizeMarginY"] = oMeta["iMaxSizeMarginY"]; // eslint-disable-line @ur/no-memory-leaks
	}

	this["oLS"]["attachBeforeEvent"](this["oLS"]["E_EVENTS"]["BeforeControlsInitialized"], this, 'onBeforeControlsInitialized');
	this["oLS"]["attachAfterEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"], this, 'onControlsInitialized');
	this["bPageUpdateInitializePhase"] = false;
};window["UCF_PopupWindow_ie6"] = UCF_PopupWindow_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopupWindow_ie6"); UCF_PopupWindow_ie6["_"] = {UCF_PopupWindow_ie6: 0}; }; ;
UCF_PopupWindow_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PopupWindow"))(); UCF_PopupWindow_ie6.prototype["sClassName"] = "UCF_PopupWindow_ie6";

UCF_PopupWindow_ie6["MINIMAL_WIDTH"] = 270;
UCF_PopupWindow_ie6["MINIMAL_HEIGHT"] = 180;

/**
 * @private
 * @return {boolean}
 */
UCF_PopupWindow_ie6["prototype"]["bMaxSizeMarginEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bMaxSizeMarginEnabled"]++; }; 
	return this["bMaxSizeMargin"] && this["bIsDivPopup"] &&
		!UCF_UserAgent["bMatchesResponsiveBreakpoint"](UCF_UserAgent["RESPONSIVE_BREAKPOINT"]["S"], this["oLS"]);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bMaxSizeMarginEnabled"] = 0; };

UCF_PopupWindow_ie6["prototype"]["onAreaScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onAreaScroll"]++; }; 
	//See note 2138152
	if (this["bIgnoreScrollEvent"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Ignore Scroll Event, see note 2138152", "PopupWindow_ie6.js(168): onAreaScroll"); };

		return;
	}

	this["oContentScrollPosition"] = {
		"iScrollLeft": oEvent["oGetParam"]("iScrollLeft"),
		"iScrollTop": oEvent["oGetParam"]("iScrollTop")
	};
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onAreaScroll"] = 0; };

/**
 * Return the PopupManager of this popup window
 * @return {UCF_PopupManager}
 */
UCF_PopupWindow_ie6["prototype"]["getPopupManager"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["getPopupManager"]++; }; 
	return this["oPopupManager"];
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["getPopupManager"] = 0; };

/**
 * Initialize the popup window
 */
UCF_PopupWindow_ie6["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["initialize"]++; }; 
	var oDimensions = null;
	var bDoMaximize = false;
	var oDomRefContent;
	var oStyle;
	var oAnimation;
	var oOpenerLS;
	var _this = this;

	/**
	 * Capture kedyboard-events (hotkeys) in modal DIV-popups so they are not
	 * dispatched to the BODY-element of the Page
	 */
	var captureKeysInModalDivPopups = function() {
		if (_this["sMode"] === 'MODAL') {
			UCF_DomUtil["setTabIndex"](_this["oDomRef"], 0);
			_this["oDomRef"]["style"]["outline"] = 'none';
		}
	};

	UCF_DomUtil["$"](this["sId"] + "-cnt")["setAttribute"]("lsscrl", "true");

	// initialize the default button for this control
	this["setDefaultButtonId"](this["sDefaultButtonId"]);

	this["bWindowContainsActiveComponent"] = this["bHasActiveComponent"](); // eslint-disable-line @ur/no-memory-leaks
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "bWindowContainsActiveComponent=" + this["bWindowContainsActiveComponent"], "PopupWindow_ie6.js(216): initialize"); };

	// D039230 - fix CSN 35743 2010 - force focusDomRef on the title
	this["oFocusDomRef"] = UCF_DomUtil["$"](this["sId"] + "-ttl");

	var p = this["oPWDimensions"]["readContentPadding"]();
	this["iContentTableCellVerticalPadding"] = p["vertical"]; // eslint-disable-line @ur/no-memory-leaks
	this["iContentTableCellHorizontalPadding"] = p["horizontal"]; // eslint-disable-line @ur/no-memory-leaks

	if (this["bIsInitialized"]) {
		this["bIsInitializedAfterUpdate"] = true;

		oDomRefContent = UCF_DomUtil["$"](this["sId"] + "-cnt");
		oStyle = this["oDomRef"]["style"];
		oStyle["top"] = "0px";

		this["detachBrowserEvent"]("scroll", this["oScrollArea"]["oDomRef"]);
		this["oScrollArea"]["oDomRef"] = oDomRefContent;
		this["attachBrowserEvent"]("scroll", oDomRefContent);

		if (this["bIsDivPopup"]) {
			this["oContainer"] = this["oDomRef"];
			oStyle["position"] = "absolute";
			oDimensions = this["oFrame"];
			captureKeysInModalDivPopups();
			this["oPopupManager"]["updatePopup"](this);
			this["oPopupManager"]["updateZIndices"](this);
		} else {
			// This is a temp. hack (6.3.2019)
			// Ticket: https://support.wdf.sap.corp/sap/support/message/002075129500000671192019
			// We have to find out how this did actually work before DIV-popups were introduced!
			//
			// IFrame-popups in WDA: Only during the 2. initialize, when the content was updated,
			// the popup must becomes visible... see below
			if (window["application"] !== undefined) {
				this["oContainer"]["style"]["visibility"] = 'visible';
			}
		}

		this["bUserHasMaximized"] = this["bUserHasMaximized"] || this["bIsMaximized"];
		bDoMaximize = this["bUserHasMaximized"];
		if (this["bShouldSetInitialBounds"]) {
			oDimensions = this["oInitialBounds"]();
			this["bShouldSetInitialBounds"] = false;
		}
	} else {
		this["bIsInitialized"] = true;
		this["oContainer"] = this["oLS"]["oGetPopupIFrame"](this["sId"]);

		if (!this["oContainer"]) {
			//no iframe found -> container is most likely a div...
			this["oContainer"] = this["oDomRef"];
			//and is hosted in the very same window
			this["oHostWindow"] = window;
		} else {
			this["oHostWindow"] = this["oPopupManager"]["oGetHostWindow"]();
		}

		this["bIsDivPopup"] = this["oContainer"] === this["oDomRef"];

		if (!this["bIsDivPopup"]) {
			// Temp. hack for WDA IFrame-popups - see comment above
			if (window["application"] !== undefined) {
				this["oContainer"]["style"]["visibility"] = 'hidden';
			}

			// Reverse operation of IE11-quirksmode workaround in close() because IFrames are reused!
			if (UCF_UserAgent["bIsTrident"](7) && !UCF_UserAgent["bIsStandardsMode"]() && this["oContainer"]["style"]["visibility"] === "hidden") {
				this["oContainer"]["style"]["visibility"] = "visible";
			}
			if (!UCF_UserAgent["bIsFirefox"]()) {
				document["body"]["style"]["backgroundColor"] = "transparent";
			}

			if (!this["bWindowContainsActiveComponent"]) {
				document["body"]["style"]["overflow"] = "hidden";
				// only effect in FF
				// in IE only when frame has not been attached to DOM
				this["oContainer"]["setAttribute"]("scrolling", "no");
			}
		} else {
			oStyle = this["oDomRef"]["style"];
			oStyle["position"] = "absolute";
			oStyle["display"] = "block";
			oStyle["width"] = "50px"; // make it smaller so that the width of the messagearea will be calculated correctly
			captureKeysInModalDivPopups();
			this["getPopupManager"]()["addPopup"](window, this["sId"], this["sMode"], this["oContainer"], null, this["bIsDivPopup"]);
		}

		this["getPopupManager"]()["register"](this);

		//get pixel sizes if values are em,ex or %
		oDimensions = this["oInitialBounds"]();

		if (window["UCF_System"]["bUseAnimation"] && UCF_UserAgent["bIsIE"]()) {
			UCF_DomUtil["setOpacityStyle"](this["oContainer"], 60);
		}

		// Initially maximized via API parameter
		if (this["bIsMaximized"]) {
			this["oFrameWhenRestored"] = oDimensions;
			bDoMaximize = true;
		}
		if (window["UCF_System"]["bUseAnimation"] && UCF_UserAgent["bIsIE"]()) {
			oAnimation = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(this["oContainer"], 100);
			oAnimation["addOpacityChange"](60, 100, oAnimation["M_TRANSITIONS"]["EaseIn"]);
			oAnimation["addFinalOpacityValue"](100);
			oAnimation["play"]();
		}

		//in WDA Initialize is called twice, therefore this workaround is in place for locking the openerLS
		if (!this["bOpenerLSLocked"]) {
			oOpenerLS = this["getPopupManager"]()["oGetOpenerLSByPopupIdInternal"](this["sId"]);
			if (oOpenerLS && oOpenerLS["oBrowserWindow"]) {
				oOpenerLS["oBrowserWindow"]["notifyLayerVisible"]();
				this["bOpenerLSLocked"] = true;
			}
		}
	}

	this["initOuterBorderStyles"]();

	var o = UCF_DomUtil["$"](this["sId"] + "-tbcontainer");
	if (o) {
		o = UCF_DomUtil["oGetFirstChild"](o);
		if (o) {
			// the Toolbar has a root container
			o = UCF_DomUtil["oGetFirstChild"](o);
			if (o) {
				if (UCF_DomUtil["sGetCurrentStyle"](o, 'display') === 'none') {
					// Needed for correct positioning of resize-handle touch-overlay:
					// The empty and "invisible" toolbar (extra-special case for WebGUI)
					// must have no height
					var f = UCF_DomUtil["$"](this["sId"] + '-ftr');
					if (f) f["style"]["height"] = '0px';
					var r = UCF_DomUtil["$"](this["sId"] + '-rszovl');
					if (r) r["style"]["top"] = '-1rem';
				}
			}
		}
	}

	if (UCF_UserAgent["bIsGecko"]() && this["bOpenerContainsActiveComponent"]()) {
		// fix for CSN 0000559625 2011 - Rounded borders don't work with Active components and
		// no background color set.
		this["oDomRef"]["backgroundColor"] = "#FFFFFF";
		UCF_DomUtil["$"](this["sId"] + "-ib")["style"]["MozBorderRadius"] = "0";
	}

	this["bIgnoreLayoutChange"] = true;

	if (bDoMaximize) {
		this["doMaximize"](true);
	} else {
		this["updateDimensions"](oDimensions, true);
		if (this["bNoContentScrolling"]) {
			// API parameter: Framework (WebGUI) wants to switch off scrolling in content
			UCF_DomUtil["$"](this["sId"] + "-cnt")["style"]["overflow"] = "hidden";
		}
	}

	this["bIgnoreLayoutChange"] = false;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["initialize"] = 0; };

/**
 * Overwrite for special handling of client-side-rendering with DIV popups and bKeepAlive=true
 * when the new control has the same ID but is of a different type (although this should only
 * happen in QUnit tests...)
 * @return {boolean}
 */
UCF_PopupWindow_ie6["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bDoKeepAlive"]++; }; 
	if (!this["bIsDivPopup"]) return true;
	var oNewDomRef = UCF_DomUtil["$"](this["sId"]);
	return oNewDomRef && (oNewDomRef["getAttribute"]('ct') === 'PW' || oNewDomRef["getAttribute"]('ct') === 'PW_standards');
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bDoKeepAlive"] = 0; };

/**
 * Special treatment (change attributes of rendering) for styles with an visible outer border (e.g. CORBU...)
 */
UCF_PopupWindow_ie6["prototype"]["initOuterBorderStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["initOuterBorderStyles"]++; }; 
	//var time = new Date().getTime();

	if (this["oPWDimensions"]["bHasBigBorder"]()) {
		// Test if class already set because of IFrame-caching
		this["sShadowClass"] = "lsPWDropShadow";
		if (this["oContainer"]["className"]["indexOf"](this["sShadowClass"]) === -1) {
			UCF_DomUtil["addClass"](this["oContainer"], this["sShadowClass"]);
		}

		UCF_JsUtil["delayedCall"](0, this, "missingDropShadowHack", []);
		/** @type {HTMLElement} */
		var oButtonDomRef;
		if (UCF_UserAgent["bIsIE"]()) {
			// top instead of bottom alignment for button images
			oButtonDomRef = UCF_DomUtil["$"](this["sId"] + "-help");
			if (oButtonDomRef) oButtonDomRef["parentNode"]["vAlign"] = "top";
			oButtonDomRef = UCF_DomUtil["$"](this["sId"] + "-minmax");
			if (oButtonDomRef) oButtonDomRef["parentNode"]["vAlign"] = "top";
			oButtonDomRef = UCF_DomUtil["$"](this["sId"] + "-close");
			if (oButtonDomRef) oButtonDomRef["parentNode"]["vAlign"] = "top";

			if (this["bWindowSize"] && window["UCF_System"]["sDevice"] === "standards") {
				this["oDomRef"]["style"]["backgroundColor"] = UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], "borderColor");
			}
		} else {
			oButtonDomRef = UCF_DomUtil["$"](this["sId"] + "-help");
			if (oButtonDomRef) oButtonDomRef["parentNode"]["style"]["verticalAlign"] = "top";
			oButtonDomRef = UCF_DomUtil["$"](this["sId"] + "-minmax");
			if (oButtonDomRef) oButtonDomRef["parentNode"]["style"]["verticalAlign"] = "top";
			oButtonDomRef = UCF_DomUtil["$"](this["sId"] + "-close");
			if (oButtonDomRef) oButtonDomRef["parentNode"]["style"]["verticalAlign"] = "top";
		}

		// Hide resize handle - resizing is enabled on the whole outer border !
		var rsz = UCF_DomUtil["$"](this["sId"] + "-rsz");
		if (rsz) {
			rsz["style"]["width"] = "0px";
			rsz["style"]["height"] = "0px";
			rsz["style"]["cursor"] = "";
		}
		var ttltxt = UCF_DomUtil["$"](this["sId"] + "-ttltxt");
		if (ttltxt) {
			ttltxt["style"]["cursor"] = "move";
		}
	} else {
		// This is used for blue_crystal, belize ...
		this["sShadowClass"] = "lsPWShadowStd";
		if (this["oContainer"]["className"]["indexOf"](this["sShadowClass"]) === -1) {
			UCF_DomUtil["addClass"](this["oContainer"], this["sShadowClass"]);
		}
		UCF_JsUtil["delayedCall"](0, this, "missingDropShadowHack", []);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["initOuterBorderStyles"] = 0; };

/**
 * 1. Workaround for ITS and Portal: The boxshadow (or 1px border in quirks) has to be set on the the IFrame.
 * The level where the IFrame gets inserted in the DOM (UCF_DomUtil.oGetTopWindow()) the ITS or Portal has no LS stylesheet
 * => Get the boxshadow value of the style class from the IFrame's document and copy it to the IFrame element...
 *
 * 2. Workaround for Belize theme and border-radius: Also apply border-radius from PopupWindow to the IFrame (e.g. Belize theme)
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["missingDropShadowHack"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["missingDropShadowHack"]++; }; 
	if (this["bIsEnhanced"]()) return;

	if (window["UCF_System"]["sDevice"] === "standards") {

		var oTmp = document["createElement"]("DIV");
		oTmp["style"]["width"] = oTmp["style"]["height"] = "0px";
		oTmp["className"] = this["oContainer"]["className"];
		this["oLS"]["oGetAssociatedAreaRef"]()["appendChild"](oTmp);
		var sBorderRadius = UCF_DomUtil["sGetCurrentStyle"](oTmp, "border-radius");
		if (!(sBorderRadius && sBorderRadius !== "0" && sBorderRadius !== "0px")) {
			sBorderRadius = UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], "border-top-left-radius");
		}
		var sBoxShadow = UCF_DomUtil["sGetCurrentStyle"](oTmp, "boxShadow");
		this["oLS"]["oGetAssociatedAreaRef"]()["removeChild"](oTmp);
		if (sBorderRadius && sBorderRadius !== "0" && sBorderRadius !== "0px") {
			this["oContainer"]["style"]["borderRadius"] = sBorderRadius;
		}

		if (window["UCF_System"]["sDevice"] === "standards" || (window["UCF_System"]["sDevice"] !== "standards" && (UCF_UserAgent["bIsWebKit"]() || UCF_UserAgent["bIsFirefox"]()))) {
			var sCurrentBS = UCF_DomUtil["sGetCurrentStyle"](this["oContainer"], "boxShadow");
			if (sCurrentBS === undefined || sCurrentBS == null || sCurrentBS === "" || sCurrentBS === "none") {
				this["oContainer"]["style"]["boxShadow"] = sBoxShadow;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["missingDropShadowHack"] = 0; };

/**
 * Called by PageUpdater. Prepares the PopupWindow for an update that changes the dimension and therefore
 * needs to set the x and y position again.
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["beforeUpdate"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["beforeUpdate"]++; }; 
	this["bShouldSetInitialBounds"] = true;
	this["bIsInitializedAfterUpdate"] = false;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["beforeUpdate"] = 0; };

/**
 * @private
 * @param {boolean} bLayoutChange
 * @return {Object} width, height
 */
UCF_PopupWindow_ie6["prototype"]["oInitialBounds"] = function(bLayoutChange) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oInitialBounds"]++; }; 
	var bOptimalWidth = (this["sWidth"] == "-1" || this["sWidth"] == "-1px");
	var bOptimalHeight = (this["sHeight"] == "-1" || this["sHeight"] == "-1px");
	var optimalSize = null;
	var bounds = this["oPWDimensions"]["measurePixelSize"](bOptimalWidth ? 0 : this["sWidth"], bOptimalHeight ? 0 : this["sHeight"]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Result of measurePixelSize: w=" + bounds["width"] + ", h=" + bounds["height"], "PopupWindow_ie6.js(506): oInitialBounds"); };

	if (this["bWindowSize"] === false) {
		//guarantee at least optimal size
		optimalSize = this["oGetOptimalSize"](bounds["width"], bounds["height"], bLayoutChange);
		bounds["width"] = Math["max"](bounds["width"], optimalSize["width"]);
		bounds["height"] = Math["max"](bounds["height"], optimalSize["height"]);
	} else {
		// New behaviour when WindowSize=true, for JSF:
		// width and height specify size of window directly, use "optimal size"
		// calculation ONLY if specified by -1 flag.
		if (bOptimalWidth || bOptimalHeight) {
			optimalSize = this["oGetOptimalSize"](bounds["width"], bounds["height"], bLayoutChange);
		}
		if (bOptimalWidth) {
			bounds["width"] = Math["max"](bounds["width"], optimalSize["width"]);
		}
		if (bOptimalHeight) {
			bounds["height"] = Math["max"](bounds["height"], optimalSize["height"]);
		}
	}

	this["oIBounds"] = bounds;
	return bounds;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oInitialBounds"] = 0; };

UCF_PopupWindow_ie6["prototype"]["onBeforeControlsInitialized"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onBeforeControlsInitialized"]++; }; 
	this["bPageUpdateInitializePhase"] = true;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onBeforeControlsInitialized"] = 0; };

UCF_PopupWindow_ie6["prototype"]["onControlsInitialized"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onControlsInitialized"]++; }; 
	this["bPageUpdateInitializePhase"] = false;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onControlsInitialized"] = 0; };

/**
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onLayoutChange"]++; }; 
	if (this["bIsDivPopup"]) {
		if (oEvent["oGetParam"]("sSourceClassName") === "UCF_PopupWindow_ie6") {
			// Ignore my own LC (maximize/restore)
			return;
		} else if (oEvent["oGetParam"]("sSourceClassName") === "UCF_PageUpdater" && oEvent["oGetParam"]("oCustomData")) {
			// Only process once for the last update in a response document with many updates (WebGUI)
			// TODO: The LS.UpdateDocumentComplete event could also be used for this when fixed
			if (oEvent["oGetParam"]("oCustomData")["iIndex"] === oEvent["oGetParam"]("oCustomData")["iCount"] - 1) {
				this["updateDimensions"](null, false, true);
			}
		} else if (oEvent["oGetParam"]("sSourceClassName") === "UCF_RenderManager" && oEvent["oGetParam"]("oCustomData")) {
			// Client-side-rendering (WebGUI):
			// Ignore LC at the end of re-initialize in render manager, because updateDimensions was already called during initialize()
			// Ignore LC after CS rendering for controls that did not change the layout because they are not visible yet (layered controls)
			var sId = oEvent["oGetParam"]('oCustomData')["sRenderedControlId"];
			if (sId !== this["sId"] && UCF_DomUtil["bIsVisible"](UCF_DomUtil["$"](sId + '-r') || UCF_DomUtil["$"](sId))) {
				this["updateDimensions"](null, false, true);
			}
		} else if (oEvent["oGetParam"]("sSourceClassName") === "UCF_TileLayout" && this["bPageUpdateInitializePhase"]) {
			return;
		} else {
			// Ignore LayoutChange caused by window-resize caused by zoom on iPad
			if (!(UCF_UserAgent["bIsIOS"]() && oEvent["oGetParam"]("bIsWindowResize") === true)) this["updateDimensions"](null, false, true);
		}

		return;
	}
	// else: IFrame-Popup ...

	// Do not process LC triggered by other controls during initialize-phase
	// There is one LC event at the end of the update and initialize process - see UCF_PageUpdater.processAfterDomUpdate()
	// Exception: Process the LC that is triggered from client-side-rendering, which happens in the same stack as initialization triggered by "new UCF_LS()" (WebGUI CSR content added to IFrame-Popups)
	if (!this["bIsInitializedAfterUpdate"] && oEvent["oGetParam"]("sSourceClassName") !== "UCF_RenderManager") return;

	if (this["bIgnoreLayoutChange"]) {
		//release the lock after UI has resized
		if (this["sLayoutChangeTimeout"]) UCF_JsUtil["clearDelayedCall"](this["sLayoutChangeTimeout"]);
		this["sLayoutChangeTimeout"] = UCF_JsUtil["delayedCall"](1, this, "doNotIgnoreLayoutChanges", []);

	} else {
		//lock the mechanism for no further processing of resize (endless loop)
		this["bIgnoreLayoutChange"] = true;
		this["updateDimensions"](null, false, true);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onLayoutChange"] = 0; };

/**
 * Orientation changed on iOS / Touch device
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["onOrientationChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onOrientationChange"]++; }; 
	if (this["bIsDivPopup"]) {
		UCF_JsUtil["delayedCall"](100, this, 'updateDimensions', [null, false, false]);
		//this.updateDimensions(null, false, false);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onOrientationChange"] = 0; };

UCF_PopupWindow_ie6["prototype"]["doNotIgnoreLayoutChanges"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["doNotIgnoreLayoutChanges"]++; }; 

	this["bIgnoreLayoutChange"] = false;

};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["doNotIgnoreLayoutChanges"] = 0; };

UCF_PopupWindow_ie6["prototype"]["restoreScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["restoreScrollPosition"]++; }; 

	//restore scroll position of content area
	if (!this["oContentScrollPosition"]) return;

	var oContentAreaDiv = UCF_DomUtil["$"](this["sId"] + "-cnt");
	oContentAreaDiv["scrollLeft"] = this["oContentScrollPosition"]["iScrollLeft"];
	oContentAreaDiv["scrollTop"] = this["oContentScrollPosition"]["iScrollTop"];

};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["restoreScrollPosition"] = 0; };

/**
 * Returns whether the PopupWindow is a DIV- or IFrame-Popup.
 * @return {boolean}
 * @public
 */
UCF_PopupWindow_ie6["prototype"]["bIsIFramePopup"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bIsIFramePopup"]++; }; 
	return !this["bIsDivPopup"];
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bIsIFramePopup"] = 0; };

/**
 * Returns whether the PopupWindow is currently enhanced for field help visibility or not
 * @return {boolean}
 * @public
 */
UCF_PopupWindow_ie6["prototype"]["bIsEnhanced"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bIsEnhanced"]++; }; 
	return this["oEnhancedOldSettings"] != null;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bIsEnhanced"] = 0; };

/**
 * Returns true if the PopupWindow can enlarge the IFrame to have more space available for LayeredControls.
 * @param {UCF_LS} [oMainLS] Optional reference to the main LS instance
 * @return {boolean} whether the PopupWindow can enlarge the IFrame or not
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["bEnlargeIFrameForLayeredControlsEnabled"] = function(oMainLS) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bEnlargeIFrameForLayeredControlsEnabled"]++; }; 
	if (this["bIsDivPopup"]) return false;
	var oTheMainLS = oMainLS || this["oLS"]["oGetMainLS"]();
	// Not supported for Quirks mode and active content on main page
	// allowTransparency is required in Quirks but it caused PW to be rendered behind Active Components
	if (!UCF_UserAgent["bIsStandardsMode"]()) {
		if (oTheMainLS && UCF_DomUtil["bContainsActiveComponent"](oTheMainLS["oWindow"]["document"])) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Do not extend the IFrame: Detected Quirks Mode and active content on the main page", "PopupWindow_ie6.js(651): bEnlargeIFrameForLayeredControlsEnabled"); };
			return false;
		}
		var iframes = oTheMainLS["oWindow"]["document"]["getElementsByTagName"]("iframe");
		if (iframes["length"] > 0) {
			// Look for IFrame controls (no NOT take into account PopupWindow- or back-navigation IFrames, etc.)
			for (var f in iframes) {
				if (f["getAttribute"] && f["getAttribute"]("ct")) {
					if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Do not extend the IFrame: Detected Quirks Mode and IFrame control on the main page", "PopupWindow_ie6.js(659): bEnlargeIFrameForLayeredControlsEnabled"); };
					return false;
				}
			}
		}
	}
	return true;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bEnlargeIFrameForLayeredControlsEnabled"] = 0; };

/**
 * Do the IFrame-extension for a LayeredControls that opened in the popup and might exceed the size of the popup.
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["openLayeredControl"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["openLayeredControl"]++; }; 
	// do nothing for div popup
	if (this["bIsDivPopup"]) {
		return;
	}
	this["oOpenLayeredControlCount"]++;
	if (this["oEnhancedOldSettings"]) {
		return;
	}
	var oMainLS = this["oLS"]["oGetMainLS"]();

	if (!this["bEnlargeIFrameForLayeredControlsEnabled"](oMainLS)) return;

	// Offset-parent for calculation of new size and position
	var oOffsetParent;
	if (oMainLS && window["sap"] && window["sap"]["its"]) {
		// Hack for WebGUI (standalone or Portal): the top body where we insert our IFrame has height=0
		// The Main-LS is in an extra IFrame (id="ITSFRAME1") which we must use to get the available height
		oOffsetParent = oMainLS["oWindow"]["document"]["body"];
	} else {
		// WDA standalone or in Portal/NWBC
		oOffsetParent = this["oLS"]["oWindow"]["frameElement"]["offsetParent"];
	}

	var bApplyWidth = Math["abs"](oOffsetParent["offsetWidth"] - this["oLS"]["oWindow"]["frameElement"]["offsetWidth"]) >= this["iEnhancedValue"];
	var bApplyHeight = Math["abs"](oOffsetParent["offsetHeight"] - this["oLS"]["oWindow"]["frameElement"]["offsetHeight"]) >= this["iEnhancedValue"];

	// Do not enlarge the IFrame if there is no room left
	if (!bApplyWidth && !bApplyHeight) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Do not extend the IFrame: Not sufficient space in both directions in parent window", "PopupWindow_ie6.js(701): openLayeredControl"); };
		return;
	}

	// remove all resize and move cursors
	UCF_DomUtil["$"](this["sId"] + "-rsz")["style"]["cursor"] = "default";
	// Store the current values of height, width and user variables for restore operation in closeLayeredControl()
	this["oEnhancedOldSettings"] = {};
	this["oEnhancedOldSettings"]["bUserHasResized"] = this["bUserHasResized"];
	this["oEnhancedOldSettings"]["bUserHasMoved"] = this["bUserHasMoved"];
	this["oEnhancedOldSettings"]["iWidth"] = Math["max"](this["oDomRef"]["parentNode"]["clientWidth"], this["oGetInnerWindowSize"]()["width"]);
	this["oEnhancedOldSettings"]["iHeight"] = Math["max"](this["oDomRef"]["parentNode"]["clientHeight"], this["oGetInnerWindowSize"]()["height"]);
	this["oEnhancedOldSettings"]["bAppliedWidth"] = bApplyWidth;
	this["oEnhancedOldSettings"]["bAppliedHeight"] = bApplyHeight;

	// avoid any wither resize to cause growing of the window.
	this["bUserHasResized"] = true;
	this["bUserHasMoved"] = true;
	// background color and image need to be transparent.
	document["body"]["style"]["backgroundColor"] = "transparent";
	if (!UCF_UserAgent["bIsStandardsMode"]()) {
		this["oLS"]["oWindow"]["frameElement"]["allowTransparency"] = "true"; //transparent for quirks
	}
	document["body"]["style"]["backgroundImage"] = "none";
	this["oDomRef"]["style"]["left"] = this["oDomRef"]["offsetLeft"] + "px";

	if (bApplyWidth) {
		// Change position
		if (UCF_UserAgent["bIsMSEdge"]()) {
			// offset values are 2px less than the style.top value
			this["iFrameElementBeforeLeft"] = parseInt(this["oLS"]["oWindow"]["frameElement"]["style"]["left"]); // eslint-disable-line @ur/no-memory-leaks
			this["oLS"]["oWindow"]["frameElement"]["style"]["left"] = (this["iFrameElementBeforeLeft"] - this["iEnhancedValue"]) + "px"; // eslint-disable-line @ur/no-memory-leaks
		} else {
			this["oLS"]["oWindow"]["frameElement"]["style"]["left"] = (this["oLS"]["oWindow"]["frameElement"]["offsetLeft"] - this["iEnhancedValue"]) + "px";
		}
		var iWidth = Math["max"](this["oLS"]["oWindow"]["frameElement"]["offsetWidth"] + this["iEnhancedValue"], oOffsetParent["offsetWidth"] - this["oLS"]["oWindow"]["frameElement"]["offsetLeft"]);
		if (UCF_UserAgent["bIsIE"]() && !UCF_UserAgent["bIsStandardsMode"]()) {
			// for quirks use the client height.
			iWidth = Math["max"](this["oLS"]["oWindow"]["frameElement"]["offsetWidth"] + this["iEnhancedValue"], oOffsetParent["clientWidth"] - this["oLS"]["oWindow"]["frameElement"]["offsetLeft"]);
		}
		// Apply size
		if (UCF_UserAgent["bIsMSEdge"]()) {
			iWidth -= 5;
		}
		this["oLS"]["oWindow"]["frameElement"]["style"]["width"] = (iWidth) + "px";
		// Make room for the drop-shadow which is applied to the inner DIV
		this["oDomRef"]["style"]["marginLeft"] = this["oDomRef"]["style"]["marginRight"] = this["iEnhancedValue"] + "px";
	}
	if (bApplyHeight) {
		if (UCF_UserAgent["bIsMSEdge"]()) {
			this["iFrameElementBeforeTop"] = parseInt(this["oLS"]["oWindow"]["frameElement"]["style"]["top"]); // eslint-disable-line @ur/no-memory-leaks
			this["oLS"]["oWindow"]["frameElement"]["style"]["top"] = (this["iFrameElementBeforeTop"] - this["iEnhancedValue"]) + "px";
		} else {
			this["oLS"]["oWindow"]["frameElement"]["style"]["top"] = (this["oLS"]["oWindow"]["frameElement"]["offsetTop"] - this["iEnhancedValue"]) + "px";
		}
		var iHeight = Math["max"](this["oLS"]["oWindow"]["frameElement"]["offsetHeight"] + this["iEnhancedValue"], oOffsetParent["offsetHeight"] - this["oLS"]["oWindow"]["frameElement"]["offsetTop"]);
		if (UCF_UserAgent["bIsIE"]() && !UCF_UserAgent["bIsStandardsMode"]()) {
			iHeight = Math["max"](this["oLS"]["oWindow"]["frameElement"]["offsetHeight"] + this["iEnhancedValue"], oOffsetParent["clientHeight"] - this["oLS"]["oWindow"]["frameElement"]["offsetTop"]);
		}
		if (UCF_UserAgent["bIsMSEdge"]()) {
			iHeight -= 5;
		}
		this["oLS"]["oWindow"]["frameElement"]["style"]["height"] = (iHeight) + "px";
		this["oDomRef"]["style"]["marginTop"] = this["oDomRef"]["style"]["marginBottom"] = this["iEnhancedValue"] + "px";
	}

	// Remove the drop shadow from the IFrame, apply the drop shadow to the inner DIV
	this["oLS"]["oWindow"]["frameElement"]["style"]["boxShadow"] = "none";
	UCF_DomUtil["addClass"](this["oDomRef"], this["sShadowClass"]);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["openLayeredControl"] = 0; };

/**
 * Remove the IFrame-extension for a LayeredControls
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["closeLayeredControl"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["closeLayeredControl"]++; }; 
	if (this["bIsDivPopup"]) {
		return;
	}
	if (!this["oEnhancedOldSettings"]) {
		return;
	}
	this["oOpenLayeredControlCount"]--;
	if (this["oOpenLayeredControlCount"] > 0) {
		return;
	}

	//Reset all values set in openLayeredControl
	UCF_DomUtil["$"](this["sId"] + "-rsz")["style"]["cursor"] = ""; //cursor from css class again
	var oOldSettings = this["oEnhancedOldSettings"];
	this["oEnhancedOldSettings"] = null;

	this["oLS"]["oWindow"]["frameElement"]["style"]["boxShadow"] = "";
	this["oDomRef"]["style"]["margin"] = "0px";
	//document.body.style.backgroundColor = "";
	document["body"]["style"]["backgroundImage"] = "";
	UCF_DomUtil["removeClass"](this["oDomRef"], this["sShadowClass"]);
	if (oOldSettings) {
		this["bUserHasResized"] = oOldSettings["bUserHasResized"];
		this["bUserHasMoved"] = oOldSettings["bUserHasMoved"];
		if (oOldSettings["bAppliedWidth"]) {
			this["oLS"]["oWindow"]["frameElement"]["style"]["width"] = (oOldSettings["iWidth"]) + "px";
		}
		if (oOldSettings["bAppliedHeight"]) {
			this["oLS"]["oWindow"]["frameElement"]["style"]["height"] = (oOldSettings["iHeight"]) + "px";
		}
		this["setSize"](oOldSettings["iWidth"], oOldSettings["iHeight"]);
	}
	if (UCF_UserAgent["bIsMSEdge"]()) {
		if (oOldSettings["bAppliedHeight"]) this["oLS"]["oWindow"]["frameElement"]["style"]["top"] = this["iFrameElementBeforeTop"] + "px";
		if (oOldSettings["bAppliedWidth"]) this["oLS"]["oWindow"]["frameElement"]["style"]["left"] = this["iFrameElementBeforeLeft"] + "px";
	} else {
		if (oOldSettings["bAppliedHeight"]) this["oLS"]["oWindow"]["frameElement"]["style"]["top"] = (this["oLS"]["oWindow"]["frameElement"]["offsetTop"] + this["iEnhancedValue"]) + "px";
		if (oOldSettings["bAppliedWidth"]) this["oLS"]["oWindow"]["frameElement"]["style"]["left"] = (this["oLS"]["oWindow"]["frameElement"]["offsetLeft"] + this["iEnhancedValue"]) + "px";
	}
	this["missingDropShadowHack"]();

	var oRSZ = UCF_DomUtil["$"](this["sId"] + "-rsz");
	if (UCF_UserAgent["bIsIE"]() && UCF_DomUtil["sGetCurrentStyle"](oRSZ, "position") === "absolute") {
		// Workaround: Force IE to (re-)calculate the correct position of resize-handle
		UCF_DomUtil["$"](this["sId"] + "-rsz")["style"]["display"] = "none";
		UCF_JsUtil["delayedCall"](500, this, "resizeHandlePositionWorkaroundForIE");
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["closeLayeredControl"] = 0; };

/**
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["resizeHandlePositionWorkaroundForIE"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["resizeHandlePositionWorkaroundForIE"]++; }; 
	UCF_DomUtil["$"](this["sId"] + "-rsz")["style"]["display"] = "";
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["resizeHandlePositionWorkaroundForIE"] = 0; };

UCF_PopupWindow_ie6["prototype"]["reconnectToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["reconnectToDom"]++; }; 
	if (this["bIsEnhanced"]()) {
		this["closeLayeredControl"]();
	}

	UCF_DomUtil["$"](this["sId"] + "-cnt")["setAttribute"]("lsscrl", "true");
	UCF_PopupWindow.prototype["reconnectToDom"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["reconnectToDom"] = 0; };

/**
 * Apply new size after roundtrip or layoutchange.
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["updateDimensions"] = function(oBounds, bInit, bLayoutChange) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["updateDimensions"]++; }; 
	var bKeepSizeWorkaround = false;

	if (bInit === false && this["oEnhancedOldSettings"]) return;

	if (!oBounds) {
		oBounds = this["oInitialBounds"](bLayoutChange);

		// Workaround: A layered element might cause the PW to grow with each LayoutChange (roundtrip/resize) if:
		// 1. present as child of the content DIV as a result of oGetParentScrollAreaDomRef() + addLayeredElement()
		// 2. Does NOT use IFrame-extension mechanism (openLayeredControl())
		// 3. does its own recalculation in its own LayoutChange handler AND is in a 100%-scenario
		// Actual case: Tokenizer with "overlay" (IE11)
		// New case 7/2020: ComboBox flying F4-help-button (chrome)
		if (bLayoutChange) {
			var THRESHOLD = 28;
			var bHasLayeredElement = UCF_DomUtil["oGetFirstChild"](UCF_DomUtil["$"](this["sId"] + "-cnt")) !== UCF_DomUtil["$"](this["sId"] + "-cnttbl");
			bKeepSizeWorkaround = bHasLayeredElement && Math["abs"](this["oFrame"]["width"] - oBounds["width"]) <= THRESHOLD && Math["abs"](this["oFrame"]["height"] - oBounds["height"]) <= THRESHOLD;
		}
	}

	if (this["bUserHasResized"] || this["bUserHasMaximized"] || this["bIsMaximized"]) {
		oBounds["width"] = this["oFrame"]["width"];
		oBounds["height"] = this["oFrame"]["height"];
	}

	if (!(bKeepSizeWorkaround && bLayoutChange)) {
		this["setSize"](oBounds["width"], oBounds["height"]);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "bKeepSizeWorkaround=true - setSize() is not called!", "PopupWindow_ie6.js(875): updateDimensions"); };
	}

	// Position of popup:
	// If the user has resized also lock the position, otherwise the PW will "jump" when the content gets updated or onLayoutChange
	if (this["bUserHasMoved"] || this["bUserHasResized"]) {
		oBounds["x"] = this["oFrame"]["x"];
		oBounds["y"] = this["oFrame"]["y"];
	} else {
		var innerSize = this["oGetInnerWindowSize"](this["oHostWindow"]);

		var oScrollOffset;
		if (this["oLS"]["oGetPageInternal"]()["bInsideShellIFrameOnIOS"]()) {
			oScrollOffset = this["oLS"]["oGetPageScrollOffset"]();
		} else {
			// IFrame-Popups: In any shell, the "host-window" is NOT the window of the UR Page!
			oScrollOffset = UCF_DomUtil["oGetScrollOffset"](this["oHostWindow"]);
		}

		if (UCF_UserAgent["bIsSafari"]() && UCF_UserAgent["bIsIOS"]()) {
			// Workaround:
			// updateDimensions is called by LayoutChange that is triggered at the end of client-side rendering
			// of popup content: E.g. when opening a SuggestBox when the keyboard is open. The PW would re-calculate
			// the position based on the scrollOffset, which is not a "real" scrolling but the forced native scrolling
			// of the whole screen content by Safari to center the focussed element. The popup would be positioned
			// behind the keyboard.
			// => Ignore scrollOffset if Safari has reduced the innerHeight because of a virtual keyboard
			if (oScrollOffset["y"] > 0 && window["innerHeight"] < window["document"]["documentElement"]["clientHeight"]) {
				oScrollOffset = 0;
			}
		}

		oBounds["x"] = (this["sX"] === "" || this["sX"] === "-1" ? Math["max"](0, (oScrollOffset["x"] + innerSize["width"] / 2 - this["oFrame"]["width"] / 2)) : parseInt(this["sX"]));
		oBounds["y"] = (this["sY"] === "" || this["sY"] === "-1" ? Math["max"](0, (oScrollOffset["y"] + innerSize["height"] / 2 - this["oFrame"]["height"] / 2)) : parseInt(this["sY"]));

		// Max-size-margin
		if (this["bMaxSizeMarginEnabled"]()) {
			var dy = innerSize["height"] / 100 * this["iMaxSizeMarginY"] / 2;
			var dx = innerSize["width"] / 100 * this["iMaxSizeMarginX"] / 2;
			if (oBounds["y"] < dy) {
				oBounds["y"] = dy;
			}
			if (oBounds["x"] < dx) {
				oBounds["x"] = dx;
			}
		}
	}
	this["setPosition"](oBounds["x"], oBounds["y"]);

	/*See note 2138152:
	 * The read access to this.oHostWindow.window.document.body.clientWidth
	 * (this happens in method relocate)
	 * sometimes causes scroll events. This is critical at this point in time, as
	 * 'setSize' resets the the scroll position (scrollTop, scrollLeft) to zero.
	 * Hence, we get zero in 'onAreaScroll' and in 'restoreScrollPosition' the popup window
	 * scrolls to the top.   */
	if (UCF_UserAgent["bIsIE"]() && this["oContentScrollPosition"] && (this["oContentScrollPosition"]["iScrollTop"] > 0 || this["oContentScrollPosition"]["iScrollLeft"] > 0)) {
		this["bIgnoreScrollEvent"] = true;
	}
	this["relocate"]();
	this["restoreScrollPosition"]();
	this["bIgnoreScrollEvent"] = false;
	if (bLayoutChange === false) this["notifyLayoutChangeFrom"]();
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["updateDimensions"] = 0; };

/**
 * Handle blind-layer for DIV popups in IE11.
 */
UCF_PopupWindow_ie6["prototype"]["updateBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["updateBlindLayer"]++; }; 
	if (!this["bIsDivPopup"] || !UCF_UserAgent["bIsIE"]()) return;
	this["oBlindLayer"] = this["oBlindLayer"] || this["oLS"]["oGetBlindLayer"]();
	UCF_DomUtil["setStyle"](this["oBlindLayer"]["oDomRef"], {
		"left": this["oContainer"]["style"]["left"],
		"top": this["oContainer"]["style"]["top"],
		"width": this["oContainer"]["offsetWidth"] + "px",
		"height": this["oContainer"]["offsetHeight"] + "px"
	});
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["updateBlindLayer"] = 0; };

/**
 * Set the size of the popup window
 * @param {string} iWidth
 * @param {string} iHeight
 * @param  {Object} originalFrame
 */
UCF_PopupWindow_ie6["prototype"]["setSize"] = function(iWidth, iHeight, originalFrame) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setSize"]++; };  // eslint-disable-line complexity
	//constrain to minsize depending on number of buttons
	var minSize = this["oPWDimensions"]["estimateMinSize"]();
	iWidth = Math["max"](iWidth, minSize["width"]);
	iHeight = Math["max"](iHeight, minSize["height"]);

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Set IFrame size: w=" + iWidth + ", h=" + iHeight, "PopupWindow_ie6.js(966): setSize"); };
	this["oFrame"]["width"] = iWidth;
	this["oFrame"]["height"] = iHeight;

	var oOuterDiv = this["oDomRef"],
		oInnerDiv = UCF_DomUtil["$"](this["sId"] + "-ib"),
		oSeparatorDiv = UCF_DomUtil["$"](this["sId"] + "-spr"),
		oContentDiv = UCF_DomUtil["$"](this["sId"] + "-cnt"),
		oContentTable = UCF_DomUtil["$"](this["sId"] + "-cnttbl"),
		oContentTableCell = UCF_DomUtil["$"](this["sId"] + "-cntTD"),
		oTitleDiv = UCF_DomUtil["$"](this["sId"] + "-ttl"),
		oTitleTextDiv = UCF_DomUtil["$"](this["sId"] + "-ttltxt"),
		oFooterDiv = UCF_DomUtil["$"](this["sId"] + "-ftr");

	// Safari on iPad: Do not set any IFrame dimensions because they are sometimes/often ignored, but
	// the browser adjusts the IFrame to the content size automatically (!!!)
	//if (!(UCF_UserAgent.bIsIOS() && UCF_UserAgent.bIsWebKit())) {
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Set oContainer size: w=" + iWidth + ", h=" + iHeight, "PopupWindow_ie6.js(983): setSize"); };
	this["oContainer"]["style"]["width"] = iWidth + "px";
	this["oContainer"]["style"]["height"] = iHeight + "px";
	//}

	UCF_UserAgent["setResponsiveBreakpointScope"](this["oContainer"], iWidth);

	//
	// Width
	//

	if (this["bWindowContainsActiveComponent"] && (document["body"]["scrollHeight"] > this["iClientHeight"]())) iWidth -= 17;
	var bBigBorder = this["oPWDimensions"]["bHasBigBorder"]();
	var contentWidth;
	var spaceForButtons = this["oPWDimensions"]["readButtonWidth"](); // Width of ALL buttons!
	if (UCF_UserAgent["bIsWebKit"]() && this["bWindowSize"]) {
		contentWidth = iWidth;
	} else {
		contentWidth = iWidth - 2 * this["oPWDimensions"]["readBorderSize"]();
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Set oContentDiv width: " + contentWidth, "PopupWindow_ie6.js(1004): setSize"); };
	oContentDiv["style"]["width"] = contentWidth + "px";

	// if (UCF_UserAgent.bIsIE()  && this.iContentTableCellHorizontalPadding > 0) {
	//     oContentTable.style.width = (contentWidth - this.iContentTableCellHorizontalPadding) + "px";
	// }

	oFooterDiv["style"]["width"] = contentWidth + "px";
	oSeparatorDiv["style"]["width"] = contentWidth + "px";

	var ttlWidth = contentWidth;
	if (this["bWindowSize"] && (UCF_UserAgent["bIsFirefox"]() || UCF_UserAgent["bIsSafari"]() || (UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] === "standards"))) {
		ttlWidth = ttlWidth + 2 * this["oPWDimensions"]["readBorderSize"]();
	}
	oTitleDiv["style"]["width"] = ttlWidth + "px";

	var sTitleCssPos = UCF_DomUtil["sGetCurrentStyle"](oTitleTextDiv, 'position');
	if (sTitleCssPos === 'absolute') {
		// Themes which require the title text to be centered in relation to the whole popup width:
		// The -ttltxt DIV needs to be centered via positioning (CSS: text-align=left instead of center)
		oTitleTextDiv["style"]["left"] = spaceForButtons + "px";
		oTitleTextDiv["style"]["width"] = (contentWidth - 2 * spaceForButtons) + "px";
	} else {
		var iTxtWidth = contentWidth - spaceForButtons;
		var iLeftPadding = parseInt(UCF_DomUtil["sGetCurrentStyle"](oTitleTextDiv, window["UCF_System"]["bIsRTL"] ? 'padding-right' : 'padding-left'));
		if (!isNaN(iLeftPadding)) iTxtWidth -= iLeftPadding;
		if (window["UCF_System"]["sDevice"] === "standards" && UCF_UserAgent["bIsIE"]() && !bBigBorder) {
			oTitleTextDiv["style"]["width"] = (iTxtWidth - 5) + "px";
		} else if (UCF_UserAgent["bIsWebKit"]() && this["bWindowSize"]) {
			oTitleTextDiv["style"]["width"] = (iTxtWidth + 2 * this["oPWDimensions"]["readBorderSize"]()) + "px";
		} else {
			// "Nobody knows the trouble I've seen, nobody knows my sorrow"
			// avoid unneeded ellipsis in IE11:
			if (UCF_UserAgent["bIsIE"]()) iTxtWidth += 1;

			oTitleTextDiv["style"]["width"] = iTxtWidth + "px";
		}
	}

	var footerbarHeight = this["iFooterbarHeight"] || this["oPWDimensions"]["readFooterbarHeight"](),
		messageAreaHeight = this["oPWDimensions"]["measureMessageAreaHeightByWidth"](contentWidth),
		messageBar = UCF_DomUtil["$"](this["sId"] + "-mb");

	if (messageBar) messageBar["style"]["width"] = contentWidth + "px";

	//
	// Height
	//

	var contentHeight = iHeight
		- this["oPWDimensions"]["measureTitleHeight"]()
		- 2 * this["oPWDimensions"]["readBorderSize"]()
		- messageAreaHeight
		- footerbarHeight;

	if (UCF_UserAgent["bIsWebKit"]() && this["bWindowSize"]) {
		contentHeight += 2 * this["oPWDimensions"]["readBorderSize"]();
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Set oContentDiv height: " + contentHeight, "PopupWindow_ie6.js(1063): setSize"); };
	oContentDiv["style"]["height"] = contentHeight + "px";

	// Avoid useless vertical scrollbar if there is an, horizonal scrollbar
	// if (this.oIBounds.width > contentWidth - this.iContentTableCellHorizontalPadding) {
	//     contentHeight -= 5;
	// }
	var contentHeightMinusPadding = contentHeight;
	// Adjustment to avoid vertical scrollbars if HasContentPadding is true
	if (this["iContentTableCellVerticalPadding"] > 0) {
		contentHeightMinusPadding = Math["max"](0, contentHeight - this["iContentTableCellVerticalPadding"]);
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Set oContentTable,oContentTableCell height (minus padding): " + contentHeight + " (" + contentHeightMinusPadding + ")", "PopupWindow_ie6.js(1076): setSize"); };
	if (this["oPWDimensions"]["bHasContentPaddingCell"]()) {
		oContentTable["style"]["height"] = contentHeight + "px";
	} else {
		oContentTable["style"]["height"] = contentHeightMinusPadding + "px";
	}
	oContentTableCell["style"]["height"] = contentHeightMinusPadding + "px";

	if (this["bWindowSize"] == false) {
		var w = iWidth; // - 2 * this["oPWDimensions"]["readBorderSize"]();
		var h = iHeight; // - 2 * this["oPWDimensions"]["readBorderSize"]();
		var bs = this["oPWDimensions"]["readBorderSize"]();
		if (bs > 1) {
			w -= 2 * bs;
			h -= 2 * bs;
		}

		// Special correction for corbu in FF,SF,standards because of drop-shadow
		if ((!UCF_UserAgent["bIsIE"]() || window["UCF_System"]["sDevice"] == "standards") && bBigBorder) {
			w += 2;
			h += 2;
		}

		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Set oOuterDiv,oInnerDiv size: w=" + w + ", h=" + h, "PopupWindow_ie6.js(1099): setSize"); };
		oOuterDiv["style"]["width"] = w + "px";
		oOuterDiv["style"]["height"] = h + "px";
		oInnerDiv["style"]["width"] = w + "px";
		oInnerDiv["style"]["height"] = h + "px";

		if (this["bWindowContainsActiveComponent"] && originalFrame) {
			// See internal 2170188439
			// oContentDiv.style.height = originalFrame.height + "px";
		}
	} else {
		if ((UCF_UserAgent["bIsFirefox"]() || UCF_UserAgent["bIsSafari"]()) && bBigBorder) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "FF, SF: Set oInnerDiv size: w=" + iWidth + ", h=" + iHeight, "PopupWindow_ie6.js(1111): setSize"); };
			oInnerDiv["style"]["width"] = iWidth + "px";
			oInnerDiv["style"]["height"] = iHeight + "px";
		}
	}

	//
	// Special corrections in standards mode
	//

	if (window["UCF_System"]["sDevice"] === "standards") {
		/** @type {HTMLElement} */
		//	var oButton;
		if (UCF_UserAgent["bIsIE"]()) {
			oTitleTextDiv["style"]["lineHeight"] = "18px";
			/*	if (bBigBorder) {
					oButton = UCF_DomUtil.$(this.sId + "-close");
					if (oButton) oButton.firstChild.style.marginTop = "-3px";
					oButton = UCF_DomUtil.$(this.sId + "-minmax");
					if (oButton) oButton.firstChild.style.marginTop = "-3px";
					oButton = UCF_DomUtil.$(this.sId + "-help");
					if (oButton) oButton.firstChild.style.marginTop = "-3px";
				}*/
		} else {
			// FF, SF, Chrome
			if (bBigBorder) {
				oTitleTextDiv["style"]["lineHeight"] = "18px";
				/*		oButton = UCF_DomUtil.$(this.sId + "-close");
						if (oButton) oButton.firstChild.style.marginTop = "-2px";
						oButton = UCF_DomUtil.$(this.sId + "-minmax");
						if (oButton) oButton.firstChild.style.marginTop = "-2px";
						oButton = UCF_DomUtil.$(this.sId + "-help");
						if (oButton) oButton.firstChild.style.marginTop = "-2px";*/
			} else {
				if (!UCF_UserAgent["bIsFirefox"]()) {
					oTitleTextDiv["style"]["lineHeight"] = "16px";
				}
				/*	oButton = UCF_DomUtil.$(this.sId + "-close");
					if (oButton) oButton.firstChild.style.paddingTop = "3px";
					oButton = UCF_DomUtil.$(this.sId + "-minmax");
					if (oButton) oButton.firstChild.style.paddingTop = "3px";
					oButton = UCF_DomUtil.$(this.sId + "-help");
					if (oButton) oButton.firstChild.style.paddingTop = "3px";*/
			}
		}
	}
	this["updateBlindLayer"]();

	// Handle tooltip when title has elipsis
	// first check if it's a InfoType or a normal title
	var oTitleText = UCF_DomUtil["$"](this["sId"] + '-ttltxt-infotype') || UCF_DomUtil["$"](this["sId"] + '-ttltxt');
	UCF_DomUtil["checkTooltip"](oTitleText["parentNode"], '', oTitleText);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setSize"] = 0; };

/**
 * Set the position of the popup window
 *
 * @param {int} left
 * @param {int} top
 */
UCF_PopupWindow_ie6["prototype"]["setPosition"] = function(left, top) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setPosition"]++; }; 
	left = Math["max"](left, -this["oContainer"]["offsetWidth"] + 50);
	top = Math["max"](top, 0);

	this["oFrame"]["x"] = left;
	this["oFrame"]["y"] = top;

	this["oContainer"]["style"]["left"] = left + "px";
	this["oContainer"]["style"]["top"] = top + "px";

	this["updateBlindLayer"]();
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setPosition"] = 0; };

/**
 * Handle the dblclick event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_ie6["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["ondblclick"]++; }; 
	var srcElement, optimalSize;

	if (this["bIsEnhanced"]()) {
		// Do nothing if a Layered Control has currently enhanced the popup. User needs to mouse down again.
		return;
	}

	srcElement = oBrowserEvent["oGetSource"]();
	if (srcElement["id"] === this["sId"] + "-ttltxt") {
		// "secret" functionality
		if (oBrowserEvent["bCtrl"]() && !this["bUserHasMaximized"]) {
			optimalSize = this["oGetOptimalSize"](0, 0, false);
			this["setSize"](optimalSize["width"], optimalSize["height"]);
		} else {
			if (this["bIsResizable"]) {
				this["toggleMinMax"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["ondblclick"] = 0; };

// /**
//  * Handle the lsdoubletab event
//  * @param {UCF_BrowserEvent} oBrowserEvent The browser event for the second 'touchend'
//  */
// UCF_PopupWindow.prototype.onlsdoubletab = function(oBrowserEvent) {
// 	// Note: Touch only supported for DIV-popups!
// 	if (this.bIsResizable && oBrowserEvent.oGetSource().id === this.sId + "-ttltxt") {
// 		this.toggleMinMax();
// 		// It is sufficient to cancel the last touchend to prevent the default double-tab-zoom-in/out of the browser
// 		oBrowserEvent.cancel();
// 	}
// };

/**
 * Find optimal size of the popup window
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["oGetOptimalSize"] = function(iWidthHint, iHeightHint, bLayoutChange) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oGetOptimalSize"]++; }; 
	var oContentDiv = UCF_DomUtil["$"](this["sId"] + "-cnt"),
		oContentTD = UCF_DomUtil["$"](this["sId"] + "-cntTD"),
		originalWidth = oContentDiv["style"]["width"],
		originalHeight = oContentDiv["style"]["height"];
	this["iFooterbarHeight"] = this["oPWDimensions"]["readFooterbarHeight"](); // eslint-disable-line @ur/no-memory-leaks
	var iSampleWidth = UCF_PopupWindow_ie6["MINIMAL_WIDTH"] - 2 * this["oPWDimensions"]["readBorderSize"](),
		iSampleHeight = UCF_PopupWindow_ie6["MINIMAL_HEIGHT"] - (this["oPWDimensions"]["measureTitleHeight"]() + this["iFooterbarHeight"] + 2 * this["oPWDimensions"]["readBorderSize"]()),
		oContentTable = UCF_DomUtil["$"](this["sId"] + "-cnttbl"),
		messageBar = UCF_DomUtil["$"](this["sId"] + "-mb");

	// use a small value to calculate size
	// don't make it any smaller to avoid strange browser dependent calculation errors
	if (this["bOverrideMinimumSize"]) {
		iSampleWidth = 50;
		iSampleHeight = 50;
	}

	// if a hint is given, use it to calculate optimalsize
	// regard iWidthHint/iHeightHint as a calculation hint
	if (iWidthHint) {
		iSampleWidth = Math["max"](iSampleWidth, iWidthHint);
	}

	if (iHeightHint) {
		iSampleHeight = Math["max"](iSampleHeight, iHeightHint);
	}

	/* Note 2238166: In certain cases the size of the popup is
	 * enhanced (in method initialize) and made smaller again (in method onLayoutChange).
	 * This effect occurs, if the popup content adjusts its dimensions dynamically to the surrounding
	 * container (100% height and/or width). In these cases, size calculations in methods oGetOptimalSize and setSize
	 * are problematic, especially if there is a vertical (horizontal) scroll bar and the algorithm tries to
	 * prevent a horizontal (vertical) scroll bar by enhancing the width (height) of the iFrame and its content:
	 * In 'initialize' the iFrame is enhanced (to prevent scrollbars). In 'onLayoutChange' the dynamic content adjusts its
	 * dimensions to the available space (which is 17px less than before, because of the vertical (horizontal) scroll bar.
	 * => Check for scrollbars and enhance iSampleWidth (iSampleHeight).
	 */

	// https://support.wdf.sap.corp/sap/support/message/2180373138:
	// This workaround cause PopupMenu in PanelStack inside Popup to get closed:
	// Open menu of PanelStack -> Client-side rendering of PopupMenu -> LayoutChange -> PopupWindow size now gets smaller because of the +17 before
	//  -> PanelStack onresize -> PanelStack closes Menu in onAfterResize()
	// This is the official ending of all the size workarounds: There are too many LayoutChange events (see workarounds in onLayoutChange!!)
	// and too many possible controls in the content that make another workaround fail.

	// if (oContentDiv.clientHeight && oContentDiv.scrollHeight && oContentDiv.scrollHeight > oContentDiv.clientHeight) {
	// 	iSampleWidth = iSampleWidth + 17;
	// }
	// if (oContentDiv.clientWidth && oContentDiv.scrollWidth && oContentDiv.scrollWidth > oContentDiv.clientWidth) {
	// 	iSampleHeight = iSampleHeight + 17;
	// }

	// onLayoutChange: Constraint the "sample" hight to the max available height of the host window, that was detected during the last relocate()
	// Growing the shrinking the height during our "measurement" can cause scroll position to get lost inside the content in such scenarios
	if (bLayoutChange === true && iSampleHeight > this["iHostWindowHeightConstraint"]) {
		iSampleHeight = this["iHostWindowHeightConstraint"];
	}

	// Clear previously set values
	oContentTable["style"]["height"] = "";
	var sOldHeight = "";
	if (UCF_UserAgent["bIsChromium"]() || UCF_UserAgent["bIsFirefox"]() || UCF_UserAgent["bIsSafari"]()) {
		sOldHeight = oContentTD["style"]["height"];
		oContentTD["style"]["height"] = "";
	}
	if (UCF_UserAgent["bIsIE"]()) {
		oContentTable["style"]["width"] = "";
		oContentTD["style"]["height"] = "100%";
	}

	// Apply the sample size to the content-DIV
	oContentDiv["style"]["width"] = iSampleWidth + "px";
	oContentDiv["style"]["height"] = iSampleHeight + "px";
	if (this["bNoContentScrolling"]) {
		// Temporarily set to auto for the following "measurement"
		oContentDiv["style"]["overflow"] = "auto";
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "iSampleWidth=" + iSampleWidth + ", iSampleHeight=" + iSampleHeight, "PopupWindow_ie6.js(1306): oGetOptimalSize"); };

	// This is THE "measurement" of the content size
	var sw = oContentDiv["scrollWidth"];
	var sh = oContentDiv["scrollHeight"];

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "sw=" + sw + ", sh=" + sh, "PopupWindow_ie6.js(1312): oGetOptimalSize"); };

	// Restore old value which may be overwritten later in setSize() BUT
	// in updateDmensions() there is a workaround in place that can
	// cause that setSize() is NOT called, but a height value might be critical for the content with 100%
	if (UCF_UserAgent["bIsChromium"]() || UCF_UserAgent["bIsFirefox"]() || UCF_UserAgent["bIsSafari"]()) {
		oContentTD["style"]["height"] = sOldHeight;
	}

	// Workaround: Height correction if many (>2) images are contained in an page update:
	// It seems that img tags inserted via innerHTML are loaded by the browsers much slower (or sequencially instead of parallel).
	// The "alt" text is displyed before an image is loaded which is larger than the actual image.
	// During init. the height calculation is to early and we do NOT know when all images are loaded! If the height is
	// set on -cntTD with a higher value the browser will not decrease the oContentDiv.scrollHeight later when images are loaded.
	// There is a mass-notify layoutchange event with 1 sec. delay in Image.js: The height will be corrected here based on the real
	// height of the content, but there is a visible glitch due to the 1 sec. delay ... ("es fluppt")
	if (this["sHeight"] == "-1" && this["oLS"]["bAlternativeKeyboardHandling"] == false) {
		var oFC = UCF_DomUtil["oGetFirstChild"](oContentTD);
		if (oFC) {
			var iRealHeight = oFC["scrollHeight"] + this["iContentTableCellVerticalPadding"];
			if (iRealHeight < sh) {
				sh = iRealHeight;
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "iRealHeight=" + iRealHeight, "PopupWindow_ie6.js(1334): oGetOptimalSize"); };
			}
		}
	}

	var optimalWidth = sw + 2 * this["oPWDimensions"]["readBorderSize"](),
		messageAreaHeight = this["oPWDimensions"]["measureMessageAreaHeightByWidth"](sw),
		optimalHeight = sh + this["oPWDimensions"]["measureTitleHeight"]() + messageAreaHeight + this["iFooterbarHeight"] + 2 * this["oPWDimensions"]["readBorderSize"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "optimalWidth=" + optimalWidth + ", optimalHeight=" + optimalHeight, "PopupWindow_ie6.js(1342): oGetOptimalSize"); };

	if (UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]()) {
		if (this["bWindowContainsActiveComponent"]) {
			var oOptSize = UCF_DomUtil["oScrollSize"]();
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "FF, SF a.c..: oOptSize=" + oOptSize["width"] + "," + oOptSize["height"], "PopupWindow_ie6.js(1347): oGetOptimalSize"); };
			optimalHeight = oOptSize["height"] - (this["oPWDimensions"]["measureTitleHeight"]() + messageAreaHeight + this["iFooterbarHeight"] + 2 * this["oPWDimensions"]["readBorderSize"]() + 1);
			optimalWidth = oOptSize["width"] - 2 * this["oPWDimensions"]["readBorderSize"]() + 6;
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "After FF, SF a.c. corr.: optimalWidth=" + optimalWidth + ", optimalHeight=" + optimalHeight, "PopupWindow_ie6.js(1350): oGetOptimalSize"); };
		}
	}

	if (this["bNoContentScrolling"]) {
		oContentDiv["style"]["overflow"] = "hidden";
	} else {
		// Add-magic-numbers-to-prevent-scrollbars-section:

		// Another workaround: Avoid growing on LC event, when there is control in the content that has a
		// resize handler and adjusts its size to 100% height...
		var bDoNotAddMagicNumberToHeight = bLayoutChange && optimalHeight <= parseInt(originalHeight);

		if (UCF_UserAgent["bIsFirefox"]()) {
			optimalWidth += 17;
			if (!bDoNotAddMagicNumberToHeight) optimalHeight += 4;
		} else if (UCF_UserAgent["bIsChromium"]() || UCF_UserAgent["bIsSafari"]()) {
			if (!bDoNotAddMagicNumberToHeight) optimalHeight += 17;
			optimalWidth += 25;
		} else if (UCF_UserAgent["bIsIE"]()) {
			optimalWidth += 10;
			if (!bDoNotAddMagicNumberToHeight) optimalHeight += 10;
			if (UCF_UserAgent["bIsTrident"](7) && window["UCF_System"]["sDevice"] !== "standards") {
				optimalHeight += 4;
			}
		}
	}

	//done measuring: restore original size
	oContentDiv["style"]["width"] = originalWidth;
	oContentDiv["style"]["height"] = originalHeight;

	if (!this["bOverrideMinimumSize"]) {
		// constrain to a minsize for datepicker
		optimalWidth = Math["max"](optimalWidth, UCF_PopupWindow_ie6["MINIMAL_WIDTH"]);
		optimalHeight = Math["max"](optimalHeight, UCF_PopupWindow_ie6["MINIMAL_HEIGHT"]);

		var iButtonWidth = this["oPWDimensions"]["readButtonWidth"](),
			oTitleTextRef = UCF_DomUtil["$"](this["sId"] + "-ttltxt"),
			sTitleWidth = oTitleTextRef["style"]["width"];

		//compress otherwise it grows
		oTitleTextRef["style"]["width"] = "20px";

		if (UCF_DomUtil["sGetCurrentStyle"](oTitleTextRef, 'position') === 'absolute') {
			// New themes (belize, fiori3)
			iButtonWidth = 2 * iButtonWidth;
		}
		var oInfoTypeTitleText = UCF_DomUtil["$"](this["sId"] + '-ttltxt-infotype');
		if (oInfoTypeTitleText) {
			optimalWidth = Math["max"](optimalWidth,
				oInfoTypeTitleText["scrollWidth"] +
				oTitleTextRef["scrollWidth"] +
				iButtonWidth +
				2 * this["oPWDimensions"]["readBorderSize"]()
			) + 1;
		} else {
			optimalWidth = Math["max"](optimalWidth, oTitleTextRef["scrollWidth"] + iButtonWidth + 2 * this["oPWDimensions"]["readBorderSize"]()) + 1;
		}

		//restore old size
		oTitleTextRef["style"]["width"] = sTitleWidth;
	}

	//consider messagebar width
	if (messageBar) {
		var messageBarOriginalWidth = messageBar["style"]["width"];
		messageBar["style"]["width"] = optimalWidth;
		var swMessageBar = messageBar["scrollWidth"];
		optimalWidth = Math["max"](optimalWidth, swMessageBar);
		messageBar["style"]["width"] = messageBarOriginalWidth;
	}

	//consider width of the iframe scrollbar
	if (this["bWindowContainsActiveComponent"]) {
		optimalWidth += 17;
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RESULT: optimalWidth=" + optimalWidth + ", optimalHeight=" + optimalHeight, "PopupWindow_ie6.js(1428): oGetOptimalSize"); };
	return {
		"width": optimalWidth,
		"height": optimalHeight
	};
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oGetOptimalSize"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_ie6["prototype"]["ontouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["ontouchstart"]++; }; 
	this["onclick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["ontouchstart"] = 0; };

/**
 * Handle click event
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_ie6["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onclick"]++; }; 

	var srcElement = oBrowserEvent["oGetSource"](),
		sAction = srcElement["getAttribute"]("action");

	//cancel the browser event to prevent firing of events like onunload
	if (sAction === "minmax") {
		if (this["bIsEnhanced"]()) {
			//Do nothing if a Layered Control has currently enhanced the popup. User needs to mouse down again.
			return;
		}
		this["toggleMinMax"]();
		oBrowserEvent["cancel"]();

	} else if (sAction === "close") {

		this["fireClose"](this["sId"]);
		// IFrame-popup: BrowserEvent is "destroyed" ... cancel() cannot be called anymore
		if (this["bIsDivPopup"]) {
			oBrowserEvent["cancel"]();
		}
	} else if (sAction === "help") {
		if (this["bIsEnhanced"]()) {
			//Do nothing if a Layered Control has currently enhanced the popup. User needs to mouse down again.
			return;
		}
		this["fireHelp"](this["sId"]);
		oBrowserEvent["cancel"]();

	}

};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onclick"] = 0; };

/**
 * @see #onmousedown
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupWindow_ie6["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlstouchstart"]++; }; 
	this["onmousedown"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlstouchstart"] = 0; };

/**
 * @see #onmousedown
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupWindow_ie6["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlstouchend"]++; }; 
	this["onmouseup"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlstouchend"] = 0; };

/**
 * @see #onmousedown
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupWindow_ie6["prototype"]["onlstouchmove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlstouchmove"]++; }; 
	this["handleMouseMove"](oBrowserEvent["oDomEvent"]);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlstouchmove"] = 0; };

/**
 *	drag and move capabilities
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_ie6["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onmousedown"]++; }; 
	if (UCF_UserAgent["bIsSafari"]() && oBrowserEvent["eGetMouseButtonState"]() !== oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"]) {
		// Trying to open a context-menu on the PopupWindow title causes confusion on Safari
		return;
	}
	if (this["bIsEnhanced"]()) {
		//Do nothing if a Layered Control has currently enhanced the popup. User needs to mouse down again.
		return;
	}
	this["oPopupManager"]["updateZIndices"](this);

	var oSrcElement = oBrowserEvent["oGetSource"]();
	this["sDragMode"] = oSrcElement["getAttribute"]("drag");

	if (this["sDragMode"] === null && oSrcElement === this["oDomRef"] && this["bIsResizable"]) {
		// For newer styles with visible outer border: complete border is used for resizing (no resize handle image)
		this["sDragMode"] = "resize";
	} else if (this["sDragMode"] === "resize") {
		// Used in calculateResize(): tradeshow-style resizing with a handle-icon in the south-east corner
		this["sBorderHoverArea"] = window["UCF_System"]["bIsRTL"] ? "sw" : "se";
	}

	if (!this["bUserHasMaximized"]) this["oFrameBeforeDragging"] = this["oPWDimensions"]["readCurrentFrame"]();

	if (this["sDragMode"] === null || this["sDragMode"] === "false") return;

	//store focussed element to refocus it after mouseup
	if (this["sDragMode"] === "resize") {
		this["sFocussedElementId"] = this["oLS"]["sGetFocusedElementId"]();
	}
	// calculate event X,Y coordinates
	this["startDragX"] = oBrowserEvent["iScreenX"]();
	this["startDragY"] = oBrowserEvent["iScreenY"]();
	//_trace(INFO, ">>> TOUCH: startdrag " + this.startDragX + ", " + this.startDragY);

	var that = this;
	this["handleMouseMoveCall"] = function(event) { // eslint-disable-line @ur/no-memory-leaks
		that["handleMouseMove"](event);
	};

	// attach mouse move handler
	UCF_DomUtil["attachEvent"](window["document"], "mousemove", this["handleMouseMoveCall"]);
	if (!this["bIsDivPopup"]) {
		UCF_DomUtil["attachEvent"](window["parent"]["document"], "mousemove", this["handleMouseMoveCall"], true);

		// Opener LS runs in IFrame and no blocklayer - e.g. ITS ...
		if (UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]()) {
			var oOpenerLS = this["getPopupManager"]()["oGetOpenerLSByPopupIdInternal"](this["sId"]);
			// Don't attach twice to the same window
			if (oOpenerLS["oGetWindow"]() !== window["parent"]) UCF_DomUtil["attachEvent"](oOpenerLS["oGetWindow"]()["document"], "mousemove", this["handleMouseMoveCall"]);
		}
	}

	//attach mouseup listener
	if (this["bUseGhostForResize"]) {
		this["handleMouseUp"] = function(event) {
			that["onmouseup"](event);
		};
		UCF_DomUtil["attachEvent"](window["document"], "mouseup", this["handleMouseUp"]);
		UCF_DomUtil["attachEvent"](this["oCreateGhostRectangle"](), "mouseup", this["handleMouseUp"]);
		if (!this["bIsDivPopup"]) UCF_DomUtil["attachEvent"](window["parent"]["document"], "mouseup", this["handleMouseUp"], true);

	}

	//needed when popup contains PDF (does not work... check)
	if (oSrcElement["setCapture"]) {
		oSrcElement["setCapture"]();
		this["oCaptureDomRef"] = oSrcElement;
	}

	//prevent selection of popups title text (currently only effect in FF)
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onmousedown"] = 0; };

/**
 * @param {DOMEvent} oNativeBrowserEvent
 */
UCF_PopupWindow_ie6["prototype"]["handleMouseMove"] = function(oNativeBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["handleMouseMove"]++; }; 
	if (!this["sDragMode"]) return;

	oNativeBrowserEvent = oNativeBrowserEvent || window["event"];

	if (this["sDragMode"] === "resize" && !this["bUserHasMaximized"]) {
		var iSX = oNativeBrowserEvent["screenX"];
		var iSY = oNativeBrowserEvent["screenY"];
		if (iSX === undefined && oNativeBrowserEvent["touches"][0]) {
			iSX = oNativeBrowserEvent["touches"][0]["screenX"];
			iSY = oNativeBrowserEvent["touches"][0]["screenY"];
		}
		var oNewFrame = this["calculateResize"](
			this["oFrameBeforeDragging"],
			this["startDragX"], this["startDragY"],
			iSX, iSY,
			this["sBorderHoverArea"]);

		if (this["bUseGhostForResize"]) {
			var oStyle = this["oCreateGhostRectangle"]()["style"];
			oStyle["left"] = oNewFrame["x"] + "px";
			oStyle["top"] = oNewFrame["y"] + "px";
			oStyle["width"] = oNewFrame["width"] + "px";
			oStyle["height"] = oNewFrame["height"] + "px";
		} else {
			this["setSize"](oNewFrame["width"], oNewFrame["height"]);
			this["setPosition"](oNewFrame["x"], oNewFrame["y"]);
			this["notifyLayoutChange"]();
		}

		this["bUserHasResized"] = true;
	} else if (this["sDragMode"] === "move") {

		var iWidth = this["oFrameBeforeDragging"]["width"],
			iHeight = this["oFrameBeforeDragging"]["height"],
			iLeft, iTop;

		//debugger;
		if (UCF_BrowserEvent["bTouchInteraction"] /*UCF_System.sInteractionType === 'TOUCH'*/ /*oNativeBrowserEvent.pointerType === 'touch'*/ ) {
			iLeft = this["oFrameBeforeDragging"]["x"] + oNativeBrowserEvent["touches"][0]["screenX"] - this["startDragX"];
			iTop = this["oFrameBeforeDragging"]["y"] + oNativeBrowserEvent["touches"][0]["screenY"] - this["startDragY"];
			//_trace(INFO, ">>> TOUCH: move sx sy: " + oNativeBrowserEvent.touches[0].screenX + ", " + oNativeBrowserEvent.touches[0].screenY);
			//_trace(INFO, ">>> TOUCH: iLeft = " + iLeft + ", iTop=" + iTop);
		} else {
			iLeft = this["oFrameBeforeDragging"]["x"] + oNativeBrowserEvent["screenX"] - this["startDragX"];
			iTop = this["oFrameBeforeDragging"]["y"] + oNativeBrowserEvent["screenY"] - this["startDragY"];
		}

		if (this["bUseGhostForResize"]) {
			// Constrain movement to page area - do not cause scrollbars
			var oAllowedPosition = this["oPWDimensions"]["getPositionConstraint"]({ "x": iLeft, "y": iTop, "width": iWidth, "height": iHeight });
			if (oAllowedPosition !== null && (oAllowedPosition["x"] !== iLeft || oAllowedPosition["y"] !== iTop)) {
				iLeft = oAllowedPosition["x"];
				iTop = oAllowedPosition["y"];
			}
			var body = this["oHostWindow"]["document"]["body"];

			this["bSnappedToMaximize"] = false;

			//unsnap from top
			if (this["bUserHasMaximized"] && this["bIsResizable"]) {
				this["oFrameWhenRestored"] = this["oFrameBeforeDragging"];
				this["doRestore"]();
				this["bUserHasMaximized"] = false;
				this["bThresholdOverridden"] = false;

				this["oFrameBeforeDragging"]["x"] = (oNativeBrowserEvent["pageX"] ? oNativeBrowserEvent["pageX"] : oNativeBrowserEvent["clientX"]) - (this["oFrameBeforeDragging"]["width"] / 2);
				this["oFrameBeforeDragging"]["y"] = 0;
				if (UCF_BrowserEvent["bTouchInteraction"] /*UCF_System.sInteractionType === 'TOUCH'*/ ) {
					iLeft = this["oFrameBeforeDragging"]["x"] + oNativeBrowserEvent["touches"][0]["screenX"] - this["startDragX"];
				} else {
					iLeft = this["oFrameBeforeDragging"]["x"] + oNativeBrowserEvent["screenX"] - this["startDragX"];
				}
			}

			//snap to top
			if (iTop > body["scrollTop"] && this["bIsResizable"]) this["bThresholdOverridden"] = true;

			if (iTop < body["scrollTop"] + 3 && this["bThresholdOverridden"]) {
				iLeft = body["scrollLeft"];
				iTop = body["scrollTop"];
				this["bSnappedToMaximize"] = true;
				if (UCF_UserAgent["bIsAndroid"]()) {
					var oVP = this["oGetInnerWindowSize"](this["oHostWindow"]);
					iWidth = oVP["width"];
					iHeight = oVP["height"];
				} else {
					iWidth = this["iClientWidth"](this["oHostWindow"]);
					iHeight = this["iClientHeight"](this["oHostWindow"]);
				}
			}

			oStyle = this["oGhostRectangle"]["style"];
			oStyle["left"] = iLeft + "px";
			oStyle["top"] = iTop + "px";
			oStyle["width"] = iWidth + "px";
			oStyle["height"] = iHeight + "px";

		} else {
			this["setPosition"](iLeft, iTop);
		}

		this["bUserHasMoved"] = true;
	}
	oNativeBrowserEvent["cancelBubble"] = true;
	if (UCF_BrowserEvent["bTouchInteraction"]) {
		UCF_DomUtil["cancelEvent"](oNativeBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["handleMouseMove"] = 0; };

/**
 * Calculate new dimensions and position of popup.
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["calculateResize"] = function(oBefore, iStartX, iStartY, iScreenX, iScreenY, sArea) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["calculateResize"]++; }; 
	var mResult = { "x": oBefore["x"], "y": oBefore["y"] };
	var iDeltaX = 0,
		iDeltaY = 0;
	var iWidth = oBefore["width"],
		iHeight = oBefore["height"];

	if (sArea == "n" || sArea == "s") {
		iDeltaY = iScreenY - iStartY;
	} else if (sArea == "w" || sArea == "e") {
		iDeltaX = iScreenX - iStartX;
	} else {
		iDeltaY = iScreenY - iStartY;
		iDeltaX = iScreenX - iStartX;
	}

	if (sArea["indexOf"]("n") != -1) {
		iHeight = oBefore["height"] - iDeltaY;
	} else {
		iHeight = oBefore["height"] + iDeltaY;
	}

	if (sArea["indexOf"]("w") != -1) {
		iWidth = oBefore["width"] - iDeltaX;
	} else {
		iWidth = oBefore["width"] + iDeltaX;
	}

	var mMinSize = this["oPWDimensions"]["estimateMinSize"]();
	mResult["width"] = Math["max"](iWidth, mMinSize["width"]);
	mResult["height"] = Math["max"](iHeight, mMinSize["height"]);

	// Also changed the position ?
	if (sArea["indexOf"]("n") != -1 || sArea["indexOf"]("w") != -1) {
		if (sArea != "ne") {
			if (iWidth > mMinSize["width"]) {
				mResult["x"] = oBefore["x"] + iDeltaX;
			} else {
				mResult["x"] = (oBefore["width"] - mMinSize["width"]) + oBefore["x"];
			}
		}
		if (sArea != "sw") {
			if (iHeight > mMinSize["height"]) {
				mResult["y"] = oBefore["y"] + iDeltaY;
			} else {
				mResult["y"] = (oBefore["height"] - mMinSize["height"]) + oBefore["y"];
			}
		}
	}

	return mResult;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["calculateResize"] = 0; };

/**
 * Update cursor/pointer based on coordinates.
 * Note: Uses this.iBorderSize and this.mContainerRect calculated in onmouseover()
 */
UCF_PopupWindow_ie6["prototype"]["handleBorderMouseMove"] = function(oNativeBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["handleBorderMouseMove"]++; }; 
	if (this["bIsEnhanced"]()) {
		return; //Dont set a custor if a layered control is open.
	}
	if (this["oDomRef"] == null) return;

	// resize or move in progress, do not update cursor
	if (this["sDragMode"] != null) return;

	var iX = oNativeBrowserEvent["clientX"];
	var iY = oNativeBrowserEvent["clientY"];

	var iXBase = 0;
	var iYBase = 0;
	var s = null;

	if (this["bIsDivPopup"]) {
		iXBase = this["mContainerRect"]["x"];
		iYBase = this["mContainerRect"]["y"];
	}

	if (iY < iYBase + this["iBorderSize"]) {
		if (iX < iXBase + this["iBorderSize"]) {
			s = "nw";
		} else if (iX > iXBase + this["mContainerRect"]["width"] - this["iBorderSize"]) {
			s = "ne";
		} else {
			s = "n";
		}
	} else if (iY > iYBase + this["mContainerRect"]["height"] - this["iBorderSize"]) {
		if (iX < iXBase + this["iBorderSize"]) {
			s = "sw";
		} else if (iX > iXBase + this["mContainerRect"]["width"] - this["iBorderSize"]) {
			s = "se";
		} else {
			s = "s";
		}
	} else {
		if (iX < iXBase + this["iBorderSize"]) {
			s = "w";
		} else {
			s = "e";
		}
	}

	if (window["UCF_System"]["bIsRTL"]) {
		if (s["indexOf"]("w") > -1) {
			s["replace"]("w", "e");
		} else if (s["indexOf"]("e") > -1) {
			s["replace"]("e", "w");
		}
	}

	this["oDomRef"]["style"]["cursor"] = s + "-resize";
	this["sBorderHoverArea"] = s;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["handleBorderMouseMove"] = 0; };

/**
 * Handle mouseup event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onmouseup"]++; }; 
	if (this["bIsEnhanced"]()) {
		return; //LayeredControl is open therefore do not react until closed
	}
	if (this["oCaptureDomRef"]) this["oCaptureDomRef"]["releaseCapture"]();

	if (this["sDragMode"] == null) return;

	this["getPopupManager"]()["popupMoved"]();

	//set back focus to previously focussed element (only set when resizing)
	if (this["sFocussedElementId"]) {
		this["oLS"]["focusElement"](this["sFocussedElementId"]);
		this["sFocussedElementId"] = null;
	}

	//detach event listeners
	if (this["handleMouseMoveCall"]) {
		UCF_DomUtil["detachEvent"](window["document"], "mousemove", this["handleMouseMoveCall"]);
		if (!this["bIsDivPopup"]) {
			UCF_DomUtil["detachEvent"](window["parent"]["document"], "mousemove", this["handleMouseMoveCall"]);
			//why? see above when attaching
			if (UCF_UserAgent["bIsGecko"]()) {
				var oOpenerLS = this["getPopupManager"]()["oGetOpenerLSByPopupIdInternal"](this["sId"]);
				//don't attach twice to the same window
				if (oOpenerLS["oGetWindow"]() != window["parent"]) UCF_DomUtil["detachEvent"](oOpenerLS["oGetWindow"]()["document"], "mousemove", this["handleMouseMoveCall"]);
			}
		}
		this["handleMouseMoveCall"] = null;
	}
	if (this["handleBorderMouseMoveCall"]) {
		if (this["handleBorderMouseMoveCall"]) {
			UCF_DomUtil["detachEvent"](window["document"], "mousemove", this["handleBorderMouseMoveCall"]);
			if (!this["bIsDivPopup"]) {
				UCF_DomUtil["detachEvent"](window["parent"]["document"], "mousemove", this["handleBorderMouseMoveCall"]);
			}
			this["handleBorderMouseMoveCall"] = null; // eslint-disable-line @ur/no-memory-leaks
		}
	}

	//adapt popup to ghost size
	if (this["bUseGhostForResize"]) {

		//detach listeners which were attached for the ghost
		if (this["handleMouseUp"]) {
			UCF_DomUtil["detachEvent"](window["document"], "mouseup", this["handleMouseUp"]);
			UCF_DomUtil["detachEvent"](this["oGhostRectangle"], "mouseup", this["handleMouseUp"]);
			if (!this["bIsDivPopup"]) UCF_DomUtil["detachEvent"](window["parent"]["document"], "mouseup", this["handleMouseUp"]);
			this["handleMouseUp"] = null;
		}

		if (this["oGhostRectangle"]) {

			var style = this["oGhostRectangle"]["style"],
				oGhostFrame = {
					"x": parseInt(style["left"]),
					"y": parseInt(style["top"]),
					"width": parseInt(style["width"]),
					"height": parseInt(style["height"])
				};

			if (UCF_UserAgent["bIsFirefox"]()) {
				style["width"] -= 2 * this["oPWDimensions"]["readBorderSize"]();
				style["height"] -= 2 * this["oPWDimensions"]["readBorderSize"]();
			}

			if (!isNaN(oGhostFrame["x"])) {
				if (this["sDragMode"] === "resize") {
					this["setSize"](oGhostFrame["width"], oGhostFrame["height"]);
					if (this["oFrameBeforeDragging"]["x"] !== oGhostFrame["x"] || this["oFrameBeforeDragging"]["y"] !== oGhostFrame["y"]) {
						this["setPosition"](oGhostFrame["x"], oGhostFrame["y"]);
					}
				} else {
					//ghost snapped to full screen
					if (this["bSnappedToMaximize"]) {
						this["oFrameWhenRestored"] = this["oFrameBeforeDragging"] = this["oPWDimensions"]["readCurrentFrame"]();
						this["doMaximize"]();
					} else {
						this["setPosition"](oGhostFrame["x"], oGhostFrame["y"]);
					}

					//workaround to avoid scrollbar color irritation in embedded scroll containers (IE)
					//scrollbars would be rendered in standard grey after moving the popup
					//                    if (UCF_UserAgent.bIsIE()) {
					//                        this.setSize(oGhostFrame.width + 1, oGhostFrame.height + 1);
					//                        this.setSize(oGhostFrame.width, oGhostFrame.height);
					//                    }
				}

			}

			UCF_DomUtil["removeFromDom"](this["oGhostRectangle"]);
			this["oGhostRectangle"] = null; // eslint-disable-line @ur/no-memory-leaks
		}

	}

	// fire semantic resize / move event
	var oFrame = this["oPWDimensions"]["readCurrentFrame"]();

	if (this["sDragMode"] === "resize" && (this["oFrameBeforeDragging"]["width"] !== oFrame["width"] || this["oFrameBeforeDragging"]["height"] !== oFrame["height"])) {
		this["fireEvent"](this["E_EVENTS"]["Resize"], {
			"ContentInnerSize": this["oPWDimensions"]["oGetContentInnerSize"]()
		});
		var oCS = this["oPWDimensions"]["oGetContentSizeForEvent"]();
		this["fireResize"](
			this["sId"],
			oFrame["width"],
			oFrame["height"],
			oCS["width"],
			oCS["height"],
			oFrame["x"],
			oFrame["y"]
		);
		if (this["bIsDivPopup"]) {
			// For DIV popups send a LC because there is no browser resize event from the window
			// as for IFrame-popups.
			//this.oLS.oBrowserWindow.notifyLayoutChangeFrom();
			this["notifyLayoutChangeFrom"]();
		}
	}

	if (this["sDragMode"] === "move" && (this["oFrameBeforeDragging"]["x"] !== oFrame["x"] || this["oFrameBeforeDragging"]["y"] !== oFrame["y"])) {
		this["fireEvent"](this["E_EVENTS"]["Move"]);
		this["fireMove"](this["sId"], oFrame["x"], oFrame["y"]);
	}

	this["sDragMode"] = null;

};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onmouseup"] = 0; };

/**
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["iClientWidth"] = function(oWindow) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["iClientWidth"]++; }; 
	oWindow = oWindow || window;
	return Math["max"](0,
		oWindow["innerWidth"] ||
		oWindow["document"]["body"]["clientWidth"]
	);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["iClientWidth"] = 0; };

/**
 * @private
 * This also consideres the innerHeight of the window which is needed for IFrame-popups.
 * The "HostWindow" of IFrame-popups may have no clientHeight.
 */
UCF_PopupWindow_ie6["prototype"]["iClientHeight"] = function(oWindow) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["iClientHeight"]++; }; 
	oWindow = oWindow || window;

	return Math["max"](0,
		oWindow["innerHeight"] ||
		oWindow["document"]["body"]["clientHeight"]
	);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["iClientHeight"] = 0; };

/**
 * @private
 * @return {Object} height,width
 * @param {Window} oHostWindow
 */
UCF_PopupWindow_ie6["prototype"]["oGetInnerWindowSize"] = function(oHostWindow) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oGetInnerWindowSize"]++; }; 
	oHostWindow = oHostWindow || window;

	//
	// TODO: Use UCF_DomUtil.oGetVisualViewport()
	//

	if (UCF_UserAgent["bIsAndroid"]()) {
		var oVP = oHostWindow["visualViewport"];
		return {
			'height': Math["floor"](oVP["height"]),
			'width': Math["floor"](oVP["width"])
		};
	}

	var r = {
		'height': Math["max"](0,
			oHostWindow["innerHeight"] ||
			oHostWindow["document"]["documentElement"]["clientHeight"] ||
			oHostWindow["document"]["body"]["clientHeight"]
		),
		'width': Math["max"](0,
			oHostWindow["innerWidth"] ||
			oHostWindow["document"]["documentElement"]["clientWidth"] ||
			oHostWindow["document"]["body"]["clientWidth"]
		)
	};

	//_trace(INFO, "ViewPort: oGetVisualViewport: height=" + x.height + ", width=" + x.width);
	return r;

};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oGetInnerWindowSize"] = 0; };

/**
 * Relocate sets the popup at a position where its content will be completely visible
 */
UCF_PopupWindow_ie6["prototype"]["relocate"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["relocate"]++; }; 
	this["iHostWindowHeightConstraint"] = undefined; // eslint-disable-line @ur/no-memory-leaks
	var oInnerSize = this["oGetInnerWindowSize"](this["oHostWindow"]);

	this["oFrame"] = this["oPWDimensions"]["readCurrentFrame"]();
	var oOriginalFrame = this["oPWDimensions"]["readCurrentFrame"]();

	// constrain to browser window size
	var oNewSize = {
		"width": Math["min"](this["oFrame"]["width"], oInnerSize["width"]),
		"height": Math["min"](this["oFrame"]["height"], oInnerSize["height"])
	};

	// Max-size-margin
	if (this["bMaxSizeMarginEnabled"]()) {
		oNewSize["height"] = Math["min"](
			this["oFrame"]["height"],
			oInnerSize["height"] - oInnerSize["height"] / 100 * this["iMaxSizeMarginY"]
		);
		oNewSize["width"] = Math["min"](
			this["oFrame"]["width"],
			oInnerSize["width"] - oInnerSize["width"] / 100 * this["iMaxSizeMarginX"]
		);
	}

	if (oNewSize["width"] !== oOriginalFrame["width"] || oNewSize["height"] !== oOriginalFrame["height"]) {
		this["setSize"](oNewSize["width"], oNewSize["height"], oOriginalFrame);
		// Remember height constraint cause by small host window
		this["iHostWindowHeightConstraint"] = oNewSize["height"];
	}

	// constrain position inside the main page
	this["oFrame"]["width"] = oNewSize["width"];
	this["oFrame"]["height"] = oNewSize["height"];
	var oAllowedPosition = this["oPWDimensions"]["getPositionConstraint"](this["oFrame"]);
	if (oAllowedPosition !== null && (oAllowedPosition["x"] !== oOriginalFrame["x"] || oAllowedPosition["y"] !== oOriginalFrame["y"])) {
		this["setPosition"](oAllowedPosition["x"], oAllowedPosition["y"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["relocate"] = 0; };

/**
 * Handle keydown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_ie6["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]("UCF_Hotkeys")["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}

	var iKey = oBrowserEvent["iKeyCode"](),
		bCtrl = oBrowserEvent["bCtrl"](),
		bShift = oBrowserEvent["bShift"](),
		bAlt = oBrowserEvent["bAlt"]();

	if (bCtrl || bShift || bAlt) return;

	switch (iKey) {

		case UCF_KeyCodes["ESCAPE"]:

			if (!this["bHasCloseButton"]) break;

			if (UCF_UserAgent["bIsGecko"]()) {
				// Delay is a workaround: Otherwise FF will abort the UCF request when ESC is pressed
				// and UCF_RequestUtil will render the error message popup (connection broken)
				UCF_JsUtil["delayedCall"](10, this, "fireClose", [this["sId"]]);
			} else {
				this["fireClose"](this["sId"]);
			}
			break;

		case UCF_KeyCodes["SPACE"]:
			this["onclick"](oBrowserEvent);
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onkeypress"] = 0; };

/**
 * Handle browsers that do not (no longer) fire keypress for ESC...
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupWindow_ie6["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onkeydown"]++; }; 
	if (!(UCF_UserAgent["bIsChromium"]() || UCF_UserAgent["bIsFirefox"]())) return;

	// Do not fire Close event if a ESC-hotkey is defined and was already handled
	if (oBrowserEvent["bIsDomEventCanceled"]()) return;

	var iKey = oBrowserEvent["iKeyCode"](),
		bCtrl = oBrowserEvent["bCtrl"](),
		bShift = oBrowserEvent["bShift"](),
		bAlt = oBrowserEvent["bAlt"]();

	if (bCtrl || bShift || bAlt) return;
	if (iKey === UCF_KeyCodes["ESCAPE"]) {
		this["fireClose"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onkeydown"] = 0; };

/**
 * Set window title
 *
 * @param {string} sText
 */
UCF_PopupWindow_ie6["prototype"]["setTitle"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setTitle"]++; }; 

	var oTitleTextRef = UCF_DomUtil["$"](this["sId"] + "-ttltxt");
	UCF_DomUtil["setInnerText"](oTitleTextRef, sText);

};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setTitle"] = 0; };

UCF_PopupWindow_ie6["prototype"]["setZIndex"] = function(iZIndex) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setZIndex"]++; }; 
	if (this["oContainer"]) {
		//prevents scrollbar irritations of embedded scroll containers
		if (this["oContainer"]["style"]["zIndex"] != iZIndex) this["oContainer"]["style"]["zIndex"] = iZIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setZIndex"] = 0; };

UCF_PopupWindow_ie6["prototype"]["iGetZIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["iGetZIndex"]++; }; 
	if (this["oContainer"]) {
		return parseInt(this["oContainer"]["style"]["zIndex"]);
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["iGetZIndex"] = 0; };

/**
 * Returns true if the instance is a DIV-popup and has Mode=MODAL. Returns null when instance is not yet initialized.
 * @return {boolean|null}
 */
UCF_PopupWindow_ie6["prototype"]["bIsModalDivPopup"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bIsModalDivPopup"]++; }; 
	if (this["bIsDivPopup"] == null) return null;
	return this["bIsDivPopup"] && this["sMode"] === "MODAL";
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bIsModalDivPopup"] = 0; };

/**
 * close the popup window
 */
UCF_PopupWindow_ie6["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["close"]++; }; 
	// If this.oLS is null this means this PW and this.oLS are alreaddy destroyed and we are not able to navigate
	// to the main LS (in the next line) which called close during its destruction ... funny, isn't it ?
	if (this["oLS"] == null) return;

	var oRootManager = this["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"](),
		oContainer = this["oContainer"],
		oContentRef = UCF_DomUtil["$"](this["sId"] + "-cnt");

	if (!this["bIsDivPopup"]) {
		//Fix for CSN 767556 2009
		//Popup was opened initially and closed with enter in inputfield
		//so we have to remove the focus from the inputfield
		//else the main window does not react on clicks initially
		//
		//Actually I thought this was solved by not removing the iframes
		//but this obviously only affected the missing cursor problem in inputs
		//but not the missing click-event which is the case here
		UCF_DomUtil["focusDomElement"](document["body"]);

		//lock to prevent nervous keypressing
		this["oLS"]["oBrowserWindow"]["lock"](UCF_BrowserWindow["LOCKTYPES"]["POPUP"]);
	}
	if (oContentRef) {
		this["detachBrowserEvent"]("resize", UCF_DomUtil["oGetFirstChild"](oContentRef));
		this["detachBrowserEvent"]("scroll", oContentRef);
	}

	if (this["resizeListenerForPopup"]) {
		UCF_DomUtil["detachEvent"](this["oHostWindow"], "resize", this["resizeListenerForPopup"]);
		//UCF_DomUtil.detachEvent(this.oHostWindow, "scroll", this.resizeListenerForPopup);
		this["resizeListenerForPopup"] = null;
	}

	if (!oContainer) return;

	// Must read the frame size before setting display:none
	var srcRect = this["oPWDimensions"]["readCurrentFrame"]();
	var oOpenerLS = this["getPopupManager"]()["oGetOpenerLSByPopupIdInternal"](this["sId"], true);

	// Make it disapear
	if (UCF_UserAgent["bIsTrident"](7) && !UCF_UserAgent["bIsStandardsMode"]()) {
		/* See Note 2165642:
		 * In certain scenarios IE11 (Quirks Mode) crashes when closing a popup.
		 * The error occurs, if the application is embedded in an IE8 Standards Mode main window
		 * (NWBC scenario) and if there is an opener window.
		 * It turned out, that setting 'visibility:hidden' instead of 'display:none' prevents the crash
		 * from happening. (Remarks: Disabling Iframe caching does NOT prevent the crash from happening).
		 */
		oContainer["style"]["visibility"] = "hidden";
	} else {
		oContainer["style"]["display"] = "none";
	}
	oContainer["style"]["top"] = -10000;

	oRootManager["unregister"](this["sId"]);

	if (oOpenerLS && oOpenerLS["oBrowserWindow"]) {
		if (this["bOpenerLSLocked"]) {
			oOpenerLS["oBrowserWindow"]["notifyLayerHidden"]();
			this["bOpenerLSLocked"] = false;
		}

		//fix for the exotic case that a this PW gets closed and an external popup window will be opened
		//then the browserwindow no longer has the focus and therefore do NOT focus the main window
		//to retain the focus on the external window
		if (this["oLS"]["oBrowserWindow"]["bFocussed"]) UCF_JsUtil["delayedCall"](0, UCF_PopupManager, "delayedFocusOpenerLS", [oOpenerLS]);
	}

	if (!this["bIsDivPopup"]) {
		this["oLS"]["destroy"]();
		oRootManager["releaseIFrame"](oContainer);
	} else {
		if (this["oBlindLayer"]) this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
		this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this);
		//this.oLS.oBrowserWindow.detachEvent(this.oLS.oBrowserWindow.E_EVENTS.ZoomChange, this);
		this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["OrientationChange"], this);
		if (this["oScrollArea"] && this["oScrollArea"]["E_EVENTS"]) {
			this["oScrollArea"]["detachEvent"](this["oScrollArea"]["E_EVENTS"]["Scroll"], this);
		}
	}

	if (window["UCF_System"]["bUseAnimation"]) {
		var trgtRect = {
			"x": srcRect["x"] + srcRect["width"] / 2,
			"y": srcRect["y"] + srcRect["height"] / 2,
			"width": 2,
			"height": 2
		};
		oRootManager["showResizeAnimation"](srcRect, trgtRect);
	}

	this["bIsInitialized"] = false;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["close"] = 0; };

/**
 * Toggle between restored and maximized
 */
UCF_PopupWindow_ie6["prototype"]["toggleMinMax"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["toggleMinMax"]++; }; 
	if (this["bUserHasMaximized"]) {
		this["restore"]();
	} else {
		this["maximize"]();
	}

};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["toggleMinMax"] = 0; };

/**
 * restore
 */
UCF_PopupWindow_ie6["prototype"]["restore"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["restore"]++; }; 

	if (!window["UCF_System"]["bUseAnimation"]) {
		this["doRestore"]();
		return;
	}

	var srcRect = this["oPWDimensions"]["readCurrentFrame"](),
		trgtRect = this["oFrameWhenRestored"],
		that = this,
		callBack = function() {
			that["doRestore"]();
		};
	this["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]()["showResizeAnimation"](srcRect, trgtRect, callBack);

};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["restore"] = 0; };

/**
 * Restore
 */
UCF_PopupWindow_ie6["prototype"]["doRestore"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["doRestore"]++; }; 

	UCF_DomUtil["detachEvent"](this["oHostWindow"], "resize", this["resizeListenerForPopup"]);
	UCF_DomUtil["detachEvent"](this["oHostWindow"], "scroll", this["resizeListenerForPopup"]);
	this["resizeListenerForPopup"] = null;

	UCF_DomUtil["$"](this["sId"] + "-minmax")["className"] = "urPWMaximize urPWMaximizeIcon urPWBtnIcon urPWButton";

	if (this["bIsResizable"]) {
		var classes = "urPWResize";

		if (window["UCF_System"]["bIsRTL"]) classes += " urPWResizeNE";
		else classes += " urPWResizeNW";

		UCF_DomUtil["$"](this["sId"] + "-rsz")["className"] = classes;
	}

	this["setPosition"](this["oFrameWhenRestored"]["x"], this["oFrameWhenRestored"]["y"]);
	this["setSize"](this["oFrameWhenRestored"]["width"], this["oFrameWhenRestored"]["height"]);

	this["bUserHasMaximized"] = false;

	var oMinMaxDomRef = UCF_DomUtil["$"](this["sId"] + "-minmax");
	if (oMinMaxDomRef) {
		oMinMaxDomRef["setAttribute"]("title", this["oLS"]["sGetText"]("SAPUR_MAXIMIZE"));
		UCF_AriaStateHelper["setLabel"](oMinMaxDomRef, this["oLS"]["sGetText"]("SAPUR_MAXIMIZE"));
		oMinMaxDomRef["focus"]();
	}

	this["fireEvent"](this["E_EVENTS"]["MoveAndResize"], {
		"ContentInnerSize": this["oPWDimensions"]["oGetContentInnerSize"]()
	});
	if (this["bIsDivPopup"]) {
		// For DIV popups send a LC because there is no browser resize event from the window
		// as for IFrame-popups.
		//this.oLS.oBrowserWindow.notifyLayoutChangeFrom();
		this["notifyLayoutChangeFrom"]();
	}
	var oCS = this["oPWDimensions"]["oGetContentSizeForEvent"]();
	this["fireRestore"](this["sId"], oCS["width"], oCS["height"]);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["doRestore"] = 0; };

/**
 * Maximize
 */
UCF_PopupWindow_ie6["prototype"]["maximize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["maximize"]++; }; 

	//store orginal position
	this["oFrameWhenRestored"] = this["oPWDimensions"]["readCurrentFrame"]();

	if (!window["UCF_System"]["bUseAnimation"]) {
		this["doMaximize"]();
		return;
	}

	var srcRect = this["oPWDimensions"]["readCurrentFrame"](),
		body = this["oHostWindow"]["document"]["body"],
		trgtRect = {
			"x": body["scrollLeft"],
			"y": body["scrollTop"],
			"width": this["iClientWidth"](this["oHostWindow"]),
			"height": this["iClientHeight"](this["oHostWindow"])
		},
		_this = this,
		callBack = function() {
			_this["doMaximize"]();
		};

	var oVP = this["oGetInnerWindowSize"](this["oHostWindow"]);

	if (UCF_UserAgent["bIsAndroid"]()) {
		trgtRect["width"] = oVP["width"];
		trgtRect["height"] = oVP["height"];
	}

	// Max-size-margin
	if (this["bMaxSizeMarginEnabled"]()) {
		var dx = oVP["width"] / 100 * this["iMaxSizeMarginX"] / 2;
		var dy = oVP["height"] / 100 * this["iMaxSizeMarginY"] / 2;
		trgtRect["height"] -= 2 * dy;
		trgtRect["y"] += dy;
		trgtRect["width"] -= 2 * dx;
		trgtRect["x"] += dx;
	}
	this["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]()["showResizeAnimation"](srcRect, trgtRect, callBack);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["maximize"] = 0; };

/**
 * Maximize
 */
UCF_PopupWindow_ie6["prototype"]["doMaximize"] = function(bNoEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["doMaximize"]++; }; 
	this["stretchToMax"]();
	if (this["bIsResizable"]) {
		UCF_DomUtil["$"](this["sId"] + "-minmax")["className"] = "urPWRestore urPWRestoreIcon urPWBtnIcon urPWButton";
		UCF_DomUtil["$"](this["sId"] + "-rsz")["className"] = "urPWNoResize";
	}

	var oMinMaxDomRef = UCF_DomUtil["$"](this["sId"] + "-minmax");
	if (oMinMaxDomRef) {
		oMinMaxDomRef["setAttribute"]("title", this["oLS"]["sGetText"]("SAPUR_BTNTYP_RESTORE"));
		UCF_AriaStateHelper["setLabel"](oMinMaxDomRef, this["oLS"]["sGetText"]("SAPUR_BTNTYP_RESTORE"));
		oMinMaxDomRef["focus"]();
	}

	// Called during initialize (PW is re-rendered via "Maximize" event in WebGUI)
	if (bNoEvent === true) return;

	var that = this;
	this["resizeListenerForPopup"] = function() {
		// For some unknown reason it is still called after destroy altough it is detached there...
		if (!that["bIsDestroyed"]) that["stretchToMax"]();
	};

	UCF_DomUtil["attachEvent"](this["oHostWindow"], "resize", this["resizeListenerForPopup"]);
	//UCF_DomUtil.attachEvent(this.oHostWindow, "scroll", this.resizeListenerForPopup);

	this["bUserHasMaximized"] = true;

	var oCS = this["oPWDimensions"]["oGetContentSizeForEvent"]();
	this["fireEvent"](this["E_EVENTS"]["MoveAndResize"], {
		"ContentInnerSize": this["oPWDimensions"]["oGetContentInnerSize"]()
	});
	if (this["bIsDivPopup"]) {
		// For DIV popups send a LC because there is no browser resize event from the window
		// as for IFrame-popups.
		//this.oLS.oBrowserWindow.notifyLayoutChangeFrom();
		this["notifyLayoutChangeFrom"]();
	}
	this["fireMaximize"](this["sId"], oCS["width"], oCS["height"]);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["doMaximize"] = 0; };

/**
 * Expand to maximal size depending on the parent window
 */
UCF_PopupWindow_ie6["prototype"]["stretchToMax"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["stretchToMax"]++; }; 
	var oBody = this["oHostWindow"]["document"]["body"],
		iWidth, iHeight,
		iTop = oBody["scrollTop"],
		iLeft = oBody["scrollLeft"];

	var oSO = this["oLS"]["oGetPageScrollOffset"]();
	iTop = Math["max"](iTop, oSO["y"]);
	iLeft = Math["max"](iLeft, oSO["x"]);

	var oVP = this["oGetInnerWindowSize"](this["oHostWindow"]);
	if (UCF_UserAgent["bIsAndroid"]()) {

		iWidth = oVP["width"];
		iHeight = oVP["height"];
	} else {
		iWidth = this["iClientWidth"](this["oHostWindow"]);
		iHeight = this["iClientHeight"](this["oHostWindow"]);
	}

	if (this["oPWDimensions"]["bHasBigBorder"]()) {
		iWidth -= 2; //2 * this.oPWDimensions.readBorderSize();
		iHeight -= 2; //2 * this.oPWDimensions.readBorderSize();
	}

	if (this["bMaxSizeMarginEnabled"]()) {
		var dx = oVP["width"] / 100 * this["iMaxSizeMarginX"] / 2;
		var dy = oVP["height"] / 100 * this["iMaxSizeMarginY"] / 2;
		iHeight -= 2 * dy;
		iTop += dy;
		iWidth -= 2 * dx;
		iLeft += dx;
	}

	this["setPosition"](iLeft, iTop);
	this["setSize"](iWidth, iHeight);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["stretchToMax"] = 0; };

/**
 * Handle lsfocus event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_ie6["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlsfocus"]++; }; 

	var sId = oBrowserEvent["oGetSource"]()["id"];

	switch (sId) {
		case this["sId"] + "-fhet":
			if (!window["UCF_System"]["bIsAria"]) {
				this["focus"]();
			} else {
				// Note: title area buttons (maximize,close,help) are not control instances.
				// UCF_DomUtil.oGetTabbableElementForward() does also not work
				// for them because it will "find" the -fhte element
				var oFirstTitleButton = UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== 'standards' ?
					UCF_DomUtil["querySelector"]('a[tabindex = "0"]') :
					UCF_DomUtil["$"](this["sId"] + '-ttl')["querySelector"]('button[tabindex = "0"]'); //table[id = "' + this.sId + '-ttl"]

				if (oFirstTitleButton) {
					UCF_DomUtil["focusDomElement"](oFirstTitleButton);
				} else {
					this["focusFirstChildControl"]();
				}
			}
			break;

		case this["sId"] + "-fhte":
			//focus the last button or the last element
			this["focusLastChildControl"]();
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlsfocus"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_ie6["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onmouseover"]++; }; 
	if (oBrowserEvent["oGetSource"]() == this["oDomRef"] && this["bIsResizable"]) {
		var that = this;
		this["handleBorderMouseMoveCall"] = function(event) {
			that["handleBorderMouseMove"](event);
		};
		UCF_DomUtil["attachEvent"](window["document"], "mousemove", this["handleBorderMouseMoveCall"]);
		if (!this["bIsDivPopup"]) {
			UCF_DomUtil["attachEvent"](window["parent"]["document"], "mousemove", this["handleBorderMouseMoveCall"], true);
		}

		this["iBorderSize"] = this["oPWDimensions"]["readBorderSize"](); // eslint-disable-line @ur/no-memory-leaks
		this["mContainerRect"] = this["oPWDimensions"]["readCurrentFrame"]();
	}
	this["onmouseoverout"](oBrowserEvent, true);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onmouseover"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_ie6["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onmouseout"]++; }; 
	if (oBrowserEvent["oGetSource"]() == this["oDomRef"]) {
		if (this["handleBorderMouseMoveCall"]) {
			UCF_DomUtil["detachEvent"](window["document"], "mousemove", this["handleBorderMouseMoveCall"]);
			if (!this["bIsDivPopup"]) {
				UCF_DomUtil["detachEvent"](window["parent"]["document"], "mousemove", this["handleBorderMouseMoveCall"]);
			}
			this["handleBorderMouseMoveCall"] = null;
		}

		this["oDomRef"]["style"]["cursor"] = "default";
	}
	this["onmouseoverout"](oBrowserEvent, false);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onmouseout"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @param {boolean} bOver
 */
UCF_PopupWindow_ie6["prototype"]["onmouseoverout"] = function(oBrowserEvent, bOver) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onmouseoverout"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();

	// hover effect for buttons
	// can't remember why this is not realized with :hover style
	if (UCF_DomUtil["bContains"](UCF_DomUtil["$"](this["sId"] + "-close"), oSource)) UCF_DomUtil["$"](this["sId"] + "-close")["className"] = bOver ? "urPWCloseHover urPWCloseIcon urPWBtnIcon urPWBtnIconHover urPWButton" : "urPWClose urPWCloseIcon urPWBtnIcon urPWButton";
	else if (UCF_DomUtil["bContains"](UCF_DomUtil["$"](this["sId"] + "-minmax"), oSource)) UCF_DomUtil["$"](this["sId"] + "-minmax")["className"] = bOver ? (this["bUserHasMaximized"] ? "urPWRestoreHover urPWRestoreIcon urPWBtnIcon urPWBtnIconHover urPWButton" : "urPWMaximizeHover urPWMaximizeIcon urPWBtnIcon urPWBtnIconHover urPWButton") : (this["bUserHasMaximized"] ? "urPWRestore urPWRestoreIcon urPWBtnIcon urPWButton" : "urPWMaximize urPWMaximizeIcon urPWBtnIcon urPWButton");
	else if (UCF_DomUtil["bContains"](UCF_DomUtil["$"](this["sId"] + "-help"), oSource)) {
		if (bOver) {
			UCF_DomUtil["$"](this["sId"] + "-help")["className"] = "urPWHelpHover urPWHelpIcon urPWBtnIcon urPWBtnIconHover urPWButton";
			// TODO: This is a workaround - replace this mess with :hover in CSS
			this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "onUnlock");
		} else {
			UCF_DomUtil["$"](this["sId"] + "-help")["className"] = "urPWHelp urPWHelpIcon urPWBtnIcon urPWButton";
			this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "onUnlock");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onmouseoverout"] = 0; };

UCF_PopupWindow_ie6["prototype"]["onUnlock"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onUnlock"]++; }; 
	if (this["bIsDestroyed"]) return;

	var oHelpButton = UCF_DomUtil["$"](this["sId"] + "-help");
	if (oHelpButton) {
		oHelpButton["className"] = "urPWHelp urPWHelpIcon urPWBtnIcon urPWButton";
	}
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "onUnlock");
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onUnlock"] = 0; };

/**
 * Focus
 */
UCF_PopupWindow_ie6["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["focus"]++; }; 
	// int. ticket https://support.wdf.sap.corp/sap/support/message/2280087233
	// Title does no longer have a tabindex in ARIA
	if (window["UCF_System"]["bIsAria"]) {
		// Called directly by LS.focusElement() -> FocusInfo.apply() when the
		// framework focusses the popup because the application has not set a focus inside the content.
		// => Search and focus first button in footer or close button
		// => Search has to skip "hidden" and disabled (tabindex="-1") buttons

		/** @type {Array} */
		var aNodes = UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== 'standards' ?
			UCF_JsUtil["arrayFrom"](UCF_DomUtil["querySelectorAll"]('*[tabindex = "0"]')) :
			UCF_JsUtil["arrayFrom"](UCF_DomUtil["$"](this["sId"] + '-ftr')["querySelectorAll"]('*[tabindex = "0"]'));

		/** @type {Array} */
		var aFooterButtons =
			UCF_JsUtil["filter"](
				aNodes,
				function(e) {
					// offsetParent is null when the element or a parent has display:none
					return UCF_DomUtil["sGetCurrentStyle"](e, 'visibility') !== 'hidden' &&
						e["offsetParent"] !== null && e["offsetParent"] !== undefined;
				}
			);
		if (aFooterButtons && aFooterButtons["length"] > 0
			/*&&
			UCF_DomUtil.bContains(UCF_DomUtil.$(this.sId + "-ftr"), aFooterButtons[0])*/
		) {
			UCF_JsUtil["delayedCall"](0, UCF_DomUtil, "focusDomElement", [aFooterButtons[0]]);
		} else {
			if (UCF_DomUtil["$"](this["sId"] + "-close")) {
				UCF_JsUtil["delayedCall"](0, UCF_DomUtil, "focusDomElement", [UCF_DomUtil["$"](this["sId"] + "-close")]);
			}
		}
	} else {
		try {
			UCF_JsUtil["delayedCall"](0, UCF_DomUtil, "focusDomElement", [UCF_DomUtil["$"](this["sId"] + "-ttltxt")]);
		} catch (e) {
			//do nothing
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["focus"] = 0; };

//-------Animation stuff -----------------------------------------------------------
UCF_PopupWindow_ie6["prototype"]["oCreateGhostRectangle"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oCreateGhostRectangle"]++; }; 

	if (this["oGhostRectangle"]) return this["oGhostRectangle"];

	var oDocument = this["oHostWindow"]["document"];

	this["oGhostRectangle"] = oDocument["createElement"]("div");

	var style = this["oGhostRectangle"]["style"];
	style["border"] = "1px dotted black";
	style["position"] = "absolute";
	style["zIndex"] = 99999;
	style["top"] = "-9999px";

	oDocument["body"]["appendChild"](this["oGhostRectangle"]);

	var innerDiv = oDocument["createElement"]("div");
	style = innerDiv["style"];
	style["backgroundColor"] = "#FFFFFF";
	style["width"] = "100%";
	style["height"] = "100%";

	UCF_DomUtil["setOpacityStyle"](innerDiv, 60);

	this["oGhostRectangle"]["appendChild"](innerDiv);

	if (UCF_UserAgent["bIsIE"]()) {
		//prevent selection of the popup title during drag and drop
		this["oGhostRectangle"]["onselectstart"] = function() {
			return false;
		};
	}
	return this["oGhostRectangle"];
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oCreateGhostRectangle"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupWindow_ie6.js(2656): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() != this) return;

	var srcElement = oBrowserEvent["oGetSource"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setEnabled"](this["bEnabled"]);

	if (srcElement["getAttribute"]("action") === "close") {
		oAccessibilityHelper["setTooltip"](this["oLS"]["sGetText"]("SAPUR_POPUP_CLOSE"));
		oAccessibilityHelper["setControlType"]("PW");
		oAccessibilityHelper["addEnabledTutor"]("B_TUT", this["bEnabled"]);
	} else if (srcElement["getAttribute"]("action") === "help") {
		oAccessibilityHelper["setTooltip"](this["oLS"]["sGetText"]("SAPUR_POPUP_HELP"));
		oAccessibilityHelper["setControlType"]("PW");
		oAccessibilityHelper["addEnabledTutor"]("B_TUT", this["bEnabled"]);
	} else if (srcElement["getAttribute"]("action") === "minmax" && (srcElement["tagName"] === "A" || srcElement["tagName"] === "BUTTON")) {
		var sTooltip = this["oLS"]["sGetText"](this["bUserHasMaximized"] ? "SAPUR_POPUP_RESTORE" : "SAPUR_POPUP_MAXIMIZE");

		oAccessibilityHelper["setTooltip"](sTooltip);
		oAccessibilityHelper["setControlType"]("PW");
		oAccessibilityHelper["addEnabledTutor"]("B_TUT", this["bEnabled"]);
	} else if (srcElement["id"] === this["sId"] + "-ttltxt") {
		oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](srcElement));
		oAccessibilityHelper["setControlType"]("PW");
	} else if (srcElement["getAttribute"]("acc_text")) {
		oAccessibilityHelper["setText"](this["oLS"]["sGetText"](srcElement["getAttribute"]("acc_text")));
		oAccessibilityHelper["setControlType"]("PW");
	}

};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlsaccessibility"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_ie6["prototype"]["onlshomemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlshomemodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PopupWindow_ie6.js(2693): onlshomemodifier"); };

	//control home focusses the title
	if (oBrowserEvent["bCtrl"]() && !oBrowserEvent["bAlt"]() && !oBrowserEvent["bShift"]()) this["focus"]();

};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlshomemodifier"] = 0; };

/**
 * Handle hotkey events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlshotkey"]++; }; 
	if (this["sHotkeysId"] === '') {
		if (this["bIsDivPopup"] && this["sMode"] === 'MODAL') {
			oBrowserEvent["cancelBubble"]();
		}
		return;
	}
	var oHotkeys = this["oGetControlById"](this["sHotkeysId"]);
	if (oHotkeys == null) return;

	var oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		// Cancel and prevent default behaviour in browser
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent) || UCF_UserAgent["bIsChromium"]() && oBrowserEvent["oDomEvent"]["type"] === "keydown" && oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["ESC"]) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			var sControlId = oBrowserEvent["oGetSourceControl"]()["sGetId"](oBrowserEvent["oGetSource"]());
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"], sControlId);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["onlshotkey"] = 0; };

UCF_PopupWindow_ie6["prototype"]["bHasActiveComponent"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bHasActiveComponent"]++; }; 

	var aXMPs = this["oDomRef"]["getElementsByTagName"]("xmp");

	for (var x = 0; x < aXMPs["length"]; x++) {
		if (!aXMPs[x]["innerHTML"]) continue;
		var sText = aXMPs[x]["innerHTML"]["toLowerCase"]();

		if (sText["indexOf"]("<object") != -1) return true;

	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bHasActiveComponent"] = 0; };

/**
 *
 * Check if Host window contains active elements
 *
 */
UCF_PopupWindow_ie6["prototype"]["bOpenerContainsActiveComponent"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bOpenerContainsActiveComponent"]++; }; 
	if (this["bOpenerHasActiveComponents"] === null) {
		var oOpenerWindow = this["oPopupManager"]["oGetOpenerWindow"](this["oContainer"]["contentWindow"]);
		if (oOpenerWindow) {
			// check if active components exist
			this["bOpenerHasActiveComponents"] = UCF_DomUtil["bContainsActiveComponent"](oOpenerWindow["document"]);
		} else {
			this["bOpenerHasActiveComponents"] = false;
		}
	}
	return this["bOpenerHasActiveComponents"];
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["bOpenerContainsActiveComponent"] = 0; };

/**
 * Destructor
 */
UCF_PopupWindow_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["destroy"]++; }; 
	if (this["oLS"] == null || this["bIsDestroyed"]) return;

	// DIV-popups can be just removed via page update without calling close()
	if (this["bIsDivPopup"]) {
		// The close-animation is also done in close()
		// TODO: When a  clientside-rendered popup is changed (setTitle) it is invalidated and re-rendered
		//       and this code would show a close-animation: Currently it is not possible to distinguish this case
		//       from a destroy when popup is really closed(!)

		// if (UCF_System.bUseAnimation && this.bIsInitialized) {
		// 	// If close() was not called do the close-animation
		// 	var trgtRect = {
		// 		x: this.oFrame.x + this.oFrame.width / 2,
		// 		y: this.oFrame.y + this.oFrame.height / 2,
		// 		width: 2,
		// 		height: 2
		// 	};
		// 	var oRootManager = this.oLS.oGetMainLS().oGetPopupManagerInternal();
		// 	if (oRootManager) oRootManager.showResizeAnimation(this.oFrame, trgtRect);
		// }
		if (this["resizeListenerForPopup"]) {
			UCF_DomUtil["detachEvent"](this["oHostWindow"], "resize", this["resizeListenerForPopup"]);
			//UCF_DomUtil.detachEvent(this.oHostWindow, "scroll", this.resizeListenerForPopup);
			this["resizeListenerForPopup"] = null;
		}
		if (!this["oLS"]["bIsDestroyed"]) {
			// Unregister to make sure the block layer is removed (in PopupManager.updateZIndices()).
			this["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]()["unregister"](this["sId"]);
			// In WDA close() may not be called for DIV-popups before destroy
			// We need to fire this internal event for ACF component to "unfreeze"
			this["oLS"]["oBrowserWindow"]["notifyLayerHidden"]();
		}
	}

	// On mobile platforms the emulated mouseup is not fired when the popup is closed,
	// so the event needs to be detached in destroy at least
	if (this["handleMouseUp"]) {
		UCF_DomUtil["detachEvent"](window["document"], "mouseup", this["handleMouseUp"]);
		UCF_DomUtil["detachEvent"](this["oGhostRectangle"], "mouseup", this["handleMouseUp"]);
		if (!this["bIsDivPopup"]) UCF_DomUtil["detachEvent"](window["parent"]["document"], "mouseup", this["handleMouseUp"]);
		this["handleMouseUp"] = null;
	}

	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this);
	//this.oLS.oBrowserWindow.detachEvent(this.oLS.oBrowserWindow.E_EVENTS.ZoomChange, this);
	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["OrientationChange"], this);
	this["oLS"]["detachBeforeEvent"](this["oLS"]["E_EVENTS"]["BeforeControlsInitialized"], this, 'onBeforeControlsInitialized');
	this["oLS"]["detachAfterEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"], this, 'onControlsInitialized');

	if (!this["bIsDivPopup"]) {
		//animation can run to an end if popups is not in a iframe
		UCF_DomUtil["removeFromDom"](this["oGhostRectangle"]);
	}

	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}

	this["oPopupManager"] = null;
	this["oContainer"] = null;
	this["oFocusDomRef"] = null;
	this["oFrame"] = null;
	this["sDragMode"] = null;
	this["sFocussedElementId"] = null;
	this["oFrameWhenRestored"] = null;
	if (this["oPWDimensions"]) {
		this["oPWDimensions"]["destroy"]();
		this["oPWDimensions"] = null;
	}
	this["oContentScrollPosition"] = null;
	this["oHostWindow"] = null;
	this["oIBounds"] = null;
	this["sLayoutChangeTimeout"] = null;
	this["sBorderHoverArea"] = null;
	this["startDragX"] = null;
	this["startDragY"] = null;
	this["oFrameBeforeDragging"] = null;
	this["oCaptureDomRef"] = null;
	this["mContainerRect"] = null;

	if (this["oBlindLayer"]) {
		// In WebGUI it may happen that a DIV-popup gets server-side rendered, initialized and then re-rendered with client-side-rendering
		// (before it gets visible and without calling close)
		this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
		this["oBlindLayer"] = null;
	}

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	UCF_PopupWindow.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["destroy"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 * @public
 */
UCF_PopupWindow_ie6["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setDefaultButtonId"]++; }; 
	UCF_PopupWindow.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setDefaultButtonId"] = 0; };

/**
 * Changes the title text. The PopupWindow size is recalculated.
 *
 * @param {string} sText string The new text
 * @public
 */
UCF_PopupWindow_ie6["prototype"]["setTitleText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setTitleText"]++; }; 
	this["setTitle"](sText);
	this["updateDimensions"](null, false, false);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["setTitleText"] = 0; };

/**
 * Event handler
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oncontextmenu"]++; }; 
	if (this["bIsDivPopup"] && this["sMode"] === "MODAL" && this["bContextMenuEvent"]) {
		this["firePopupContextMenu"](
			this["sId"],
			oBrowserEvent["oGetSourceControl"]()["sGetId"](),
			oBrowserEvent["iPageX"](),
			oBrowserEvent["iPageY"](),
			oBrowserEvent["bShift"](),
			oBrowserEvent["bCtrl"](),
			oBrowserEvent["bAlt"]()
		);
		// No context event on Page (or other "parent" popups), which are blocked by BlockLayer
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oncontextmenu"] = 0; };

/**
 * Provide internal stuff for QUnit test recording and playback
 * @private
 */
UCF_PopupWindow_ie6["prototype"]["oGetTestData"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oGetTestData"]++; }; 
	var o = UCF_PopupWindow.prototype["oGetTestData"]["apply"](this, arguments);

	var oContentDiv = UCF_DomUtil["$"](this["sId"] + "-cnt");

	o["internals"]["ContentDiv:offsetHeight"] = oContentDiv["offsetHeight"];
	o["internals"]["ContentDiv:offsetWidth"] = oContentDiv["offsetWidth"];
	o["internals"]["ContentDiv:scrollHeight"] = oContentDiv["scrollHeight"];
	o["internals"]["ContentDiv:scrollWidth"] = oContentDiv["scrollWidth"];
	o["internals"]["HasScrollbars"] = oContentDiv["scrollWidth"] - oContentDiv["offsetWidth"] > 0 || oContentDiv["scrollHeight"] - oContentDiv["offsetHeight"] > 0;

	if (!this["oTestData"]) this["oTestData"] = {};

	o["internals"]["PREVIOUS-VALUE:IFrame:style-width"] = this["oTestData"]["sIFrameStyleWidth"] || "";
	o["internals"]["PREVIOUS-VALUE:IFrame:style-height"] = this["oTestData"]["sIFrameStyleHeight"] || "";
	this["oTestData"]["sIFrameStyleWidth"] = o["internals"]["IFrame:style-width"] = this["oContainer"]["style"]["width"];
	this["oTestData"]["sIFrameStyleHeight"] = o["internals"]["IFrame:style-height"] = this["oContainer"]["style"]["height"];

	return o;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oGetTestData"] = 0; };

/**
 * Returns the footer ToolBar control or null.
 * @return {UCF_Toolbar|null}
 */
UCF_PopupWindow_ie6["prototype"]["oGetFooterToolbar"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oGetFooterToolbar"]++; }; 
	var o = UCF_DomUtil["$"](this["sId"] + "-tbcontainer");
	if (o) {
		o = UCF_DomUtil["oGetFirstChild"](o);
		if (o) {
			// the Toolbar has a root container
			o = UCF_DomUtil["oGetFirstChild"](o);
			if (o) {
				return this["oGetControlByDomRef"](o);
			}
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oGetFooterToolbar"] = 0; };

/**
 * called by UCF_InputFieldHelpButton#oFindPositionContainer
 * @return {HTMLDivElement}
 */
UCF_PopupWindow_ie6["prototype"]["oGetContentRef"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oGetContentRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + '-cnt');
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["oGetContentRef"] = 0; };

/**
 * @private
 * @return {Array}
 */
UCF_PopupWindow_ie6["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_PopupWindow.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	var oTitleText = UCF_DomUtil["$"](this["sId"] + '-ttltxt');

	if (oTitleText && UCF_DomUtil["bHasTextEllipsis"](oTitleText["parentNode"], oTitleText)) {
		aResult["push"]({
			"sType": 'TEXT',
			"sText": UCF_DomUtil["sGetInnerText"](oTitleText)
		});
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_ie6["_"]["aGetTouchContextMenuEntries"] = 0; };

UCF_PopupWindow_ie6.prototype["aPublicMethods"] = ["bIsIFramePopup","bIsEnhanced","setDefaultButtonId","setTitleText"].concat(UCF_PopupWindow_ie6.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PopupWindow_standards"] = function() {/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_PopupBase */
/// <reference path="../helper/PopupBase.js"/>

/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../../ls/core/ResourceUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Animation */
/// <reference path="../anim/Animation.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_BrowserWindow */
/// <reference path="../browser/BrowserWindow.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_PopupManager */
/// <reference path="../helper/PopupManager.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>
/* global UCF_PopupWindowDimensions */
/// <reference path="./PopupWindowDimensions.js"/>
/* global UCF_PopupWindow */
/// <reference path="./PopupWindow.js"/>

/**
 * The new PopupWindow control.
 * @class
 * @param {HMTLElement} oDomRef The DOM reference
 * @param {UCF_LS} oLS The LS instance
 * @extends UCF_PopupBase
 */
function UCF_PopupWindow_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["UCF_PopupWindow_standards"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PopupWindow_standards.js(52): UCF_PopupWindow_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PopupWindow_standards.js(53): UCF_PopupWindow_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PopupWindow_standards.js(54): UCF_PopupWindow_standards"); };

	UCF_PopupBase["apply"](this, [oDomRef, oLS]);

	// These internal events are mucho importante for UCF_Placeholder.update()
	this["defineEvents"]([
		'Move',
		'Resize',
		'MoveAndResize' // Maximize/Restore
	]);

	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");

	this["setDefaultButtonId"](this["sDefaultButtonId"]);

	this["bUserHasMaximized"] = false;
	this["bUserHasResized"] = false;
	this["bUserHasMoved"] = false;
	this["oUserSize"] = { "w": null, "h": null };
	this["oUserPosition"] = { "x": null, "y": null };
	this["sDragMode"] = null;
	this["handleMouseMove"] = null;
	this["bSetContentSectionHeightPx"] = false;

	//this.bCenterUsingMargins = UCF_UserAgent.bIsChrome();
};window["UCF_PopupWindow_standards"] = UCF_PopupWindow_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PopupWindow_standards"); UCF_PopupWindow_standards["_"] = {UCF_PopupWindow_standards: 0}; }; ;
UCF_PopupWindow_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PopupBase"))(); UCF_PopupWindow_standards.prototype["sClassName"] = "UCF_PopupWindow_standards";

UCF_PopupWindow_standards["MINIMAL_WIDTH"] = 270;
UCF_PopupWindow_standards["MINIMAL_HEIGHT"] = 180;

/**
 * @public
 */
UCF_PopupWindow_standards["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["close"]++; }; 
	UCF_PopupBase.prototype["close"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["close"] = 0; };

UCF_PopupWindow_standards["prototype"]["oGetScrollAreaRoot"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetScrollAreaRoot"]++; }; 
	// Note: This is called during constructor by UCF_PopupBase, so initializing
	// at the end of the constructor above is too late...
	return UCF_DomUtil["$"](this["sId"] + '-contentsection');
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetScrollAreaRoot"] = 0; };

/**
 * @private
 */
UCF_PopupWindow_standards["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["init"]++; }; 
	if (this["bNoContentScrolling"]) {
		// API parameter: Framework WebGUI wants to switch off scrolling in content
		// TODO: Is this still used?
		UCF_DomUtil["$"](this["sId"] + '-contentsection')["style"]["overflow"] = 'hidden';
	}
	this["oDomRef"]["style"]["display"] = '';
	this["applyAPIPositionAndSize"]();
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["init"] = 0; };

/**
 * @private
 */
UCF_PopupWindow_standards["prototype"]["update"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["update"]++; }; 
	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this);
	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, 'onLayoutChange');

	this["oDomRef"]["style"]["opacity"] = '1'; // Update: no open animation!
	this["init"]();
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["update"] = 0; };

/**
 * @private
 */
UCF_PopupWindow_standards["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["show"]++; }; 
	this["init"]();
	if (window["UCF_System"]["bUseAnimation"]) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsPWNew--animation-open');
	} else {
		this["oDomRef"]["style"]["opacity"] = '1';
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["show"] = 0; };

/**
 * @private
 * @return {function}
 */
UCF_PopupWindow_standards["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["hide"]++; }; 
	// Note: close animation will not play when popup
	// is just removed from the DOM with an page update (WDA)
	if (window["UCF_System"]["bUseAnimation"]) {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsPWNew--animation-open');
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsPWNew--animation-close');
	}
	var _this = this;
	return function() {
		_this["oDomRef"]["style"]["display"] = 'none';
	};
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["hide"] = 0; };

/**
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_PopupWindow_standards["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onLayoutChange"]++; }; 
	if (oEvent["oGetParam"]("sSourceClassName") !== "UCF_PopupWindow_standards") {
		this["handleFooterToolbarWidth"]();
	}
	// When the browser window is resized or after a PageUpdate of the content
	// re-calculate the negative margins...
	// if (this.bCenterUsingMargins /*&& oEvent.oGetParam('bIsWindowResize') === true*/) {
	// 	var oStyle = this.oDomRef.style;
	// 	var sML = UCF_DomUtil.sGetCurrentStyle(this.oDomRef, 'marginLeft');
	// 	if (sML !== '' && sML !== '0' && sML !== '0px') {
	// 		oStyle.marginLeft = -(Math.round(this.oDomRef.scrollWidth / 2)) + 'px';
	// 	}
	// 	var sMT = UCF_DomUtil.sGetCurrentStyle(this.oDomRef, 'marginTop');
	// 	if (sMT !== '' !== sMT !== '0' && sMT !== '0px') {
	// 		oStyle.marginTop = -(Math.round(this.oDomRef.scrollHeight / 2)) + 'px';
	// 	}
	// }
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onLayoutChange"] = 0; };

/**
 * Handle click event
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_standards["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onclick"]++; }; 
	var srcElement = oBrowserEvent["oGetSource"](),
		sAction = srcElement["getAttribute"]("action");

	if (sAction === "minmax") {
		if (this["bIsResizable"]) {
			this["toggleMaximize"]();
			oBrowserEvent["cancel"]();
		}
	} else if (sAction === "close") {
		this["fireClose"](this["sId"]);
		oBrowserEvent["cancel"]();
	} else if (sAction === "help") {
		this["fireHelp"](this["sId"]);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onclick"] = 0; };

/**
 * Handle the dblclick event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_standards["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["ondblclick"]++; }; 
	var oSrcElement = oBrowserEvent["oGetSource"]();
	if (oSrcElement["id"] === this["sId"] + '-header-title' || oSrcElement["id"] === this["sId"] + '-header-title-txt') {
		if (this["bIsResizable"]) {
			this["toggleMaximize"]();
		}
	}
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["ondblclick"] = 0; };

/**
 * @param {number} iLeft
 * @param {number} iTop
 */
UCF_PopupWindow_standards["prototype"]["setFixedPosition"] = function(iLeft, iTop) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["setFixedPosition"]++; }; 
	this["oDomRef"]["style"]["left"] = iLeft + 'px';
	this["oDomRef"]["style"]["top"] = iTop + 'px';
	// if (this.bCenterUsingMargins) {
	// 	this.oDomRef.style.marginLeft = '0px';
	// 	this.oDomRef.style.marginTop = '0px';
	// }
	// else {
	this["oDomRef"]["style"]["transform"] = '';
	//}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["setFixedPosition"] = 0; };

/**
 * API: X, Y, Width, Height, WindowSize -> CSS properties
 *
 * Notes:
 *
 * Chromium rendering engine has problems with height and width when only min/max-width/height values
 * are used and the content contains "metric decoupling" trick, e.g. ScrollContainer. The content of the SC
 * would have no height and disapear.
 * The workaround to make Chrome behave properly:
 * - height:0 or height=offsetHeight/scrollHeight on the contentsection element
 * - Usage of "min-content" values for width/height
 *
 * Chrome has a bug with transform:translate. It will render blurry fonts, if the
 * transformation results in decimal numbers in the matrix (sub-pixels).
 * Possible workarounds:
 * 1. round the values and re-apply the matrix.
 * https://stackoverflow.com/questions/27385126/chrome-font-appears-blurry
 * This workaround does not always give the same clear rendering as without transform:translate.
 * 2. The only "clear" solution is to convert the values to (negative) margins. But this means that
 * we have to recalculate them onresize etc. (Flag: this.bCenterUsingMargins)
 *
 * The initial goal was set, to have as many position and size features coded in CSS directly
 * instead if calculating px values in Javascript. Unfortunately due to the Chrome workarounds
 * mentioned above things got a little bumpy. Also, the CSS min- and max-width/height attributes caused
 * a calculation workaround when the API Width/Height parameters are set AND the content is
 * larger than the available screen space (min overrules max value in CSS).
 * Conclusion: It may be easier to understand and more maintainable to have a clever size/position
 * calculation done in Javascript - considering that we still have to support something like in
 * oCalculatePositionConstraint() anyway!
 *
 * @private
 * @param {boolean} bRestore
 */
UCF_PopupWindow_standards["prototype"]["applyAPIPositionAndSize"] = function(bRestore) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["applyAPIPositionAndSize"]++; }; 

	var _this = this;

	var oGetCssMaxSize = function() {
		var oDiv = document["createElement"]('DIV');
		oDiv["style"]["position"] = 'absolute';
		oDiv["style"]["top"] = '-5000px';
		UCF_DomUtil["addClass"](oDiv, 'lsPWNewMaxWidthAutoX');
		UCF_DomUtil["addClass"](oDiv, 'lsPWNewMaxWidthAutoY');
		document["body"]["appendChild"](oDiv);
		var oResult = {
			"width": parseInt(UCF_DomUtil["sGetCurrentStyle"](oDiv, 'max-width')),
			"height": parseInt(UCF_DomUtil["sGetCurrentStyle"](oDiv, 'max-height'))
		};
		document["body"]["removeChild"](oDiv);
		if (UCF_DomUtil["bHasClass"](_this["oDomRef"], 'lsPWNewMaxWidthPosX')) {
			oResult["width"] -= parseInt(_this["sX"]);
		}
		if (UCF_DomUtil["bHasClass"](_this["oDomRef"], 'lsPWNewMaxWidthPosY')) {
			oResult["height"] -= parseInt(_this["sY"]);
		}
		return oResult;
	};

	this["oRootRef"]["style"]["zIndex"] = UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'z-index');

	var TRANSFORM_CENTERED_Y = 'translateY(-50%)';
	var TRANSFORM_CENTERED_X = 'translateX(-50%)';
	var TRANSFORM_CENTERED_XY = TRANSFORM_CENTERED_X + ' ' + TRANSFORM_CENTERED_Y;

	this["iFallbackSize"] = this["iFallbackSize"] || UCF_DomUtil["iConvertAnySizeToPixel"]('50%', '1rem');

	var oScrollOffset = this["oLS"]["oGetPageScrollOffset"]();

	var centerY = function(oStyle) {
		oStyle["top"] = 'calc(50vh + ' + oScrollOffset["y"] + 'px)';
		// if (_this.bCenterUsingMargins) {
		// 	var iSH = _this.oDomRef.scrollHeight;
		// 	if (iSH === 0) {
		// 		// E.g. placeholder xmp is the only content (contained in 100% container/layout)
		// 		iSH = parseInt(_this.sHeight);
		// 		if (isNaN(iSH) || iSH === 0) {
		// 			iSH = _this.iFallbackSize;
		// 		}
		// 	}
		// 	oStyle.marginTop = -(Math.round(iSH / 2)) + 'px';
		// }
		// else {
		oStyle["transform"] = TRANSFORM_CENTERED_Y;
		//}
	};

	var centerX = function(oStyle) {
		oStyle["left"] = 'calc(50vw + ' + oScrollOffset["x"] + 'px)';
		// if (_this.bCenterUsingMargins) {
		// 	var iSW = _this.oDomRef.scrollWidth;
		// 	if (iSW === 0) {
		// 		// E.g. placeholder xmp is the only content (contained in 100% container/layout)
		// 		iSW = parseInt(_this.sWidth);
		// 		if (isNaN(iSW) || iSW === 0) {
		// 			iSW = _this.iFallbackSize;
		// 		}
		// 	}
		// 	oStyle.marginLeft = -(Math.round(iSW / 2)) + 'px';
		// }
		// else {
		oStyle["transform"] = TRANSFORM_CENTERED_X;

		//}
	};

	var centerXY = function(oStyle) {
		centerX(oStyle);
		centerY(oStyle);
		//if (!_this.bCenterUsingMargins) {
		oStyle["transform"] = TRANSFORM_CENTERED_XY;
		//}
	};

	var oContentSection = UCF_DomUtil["$"](this["sId"] + '-contentsection');
	var oStyle = this["oDomRef"]["style"];
	if (bRestore) {
		oContentSection["style"]["height"] = '0';
	}
	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsPWNewMaximized');

	//
	// Apply size
	//
	if (!this["bUserHasResized"]) {
		// Hard-coded default minimal size
		// this was also featured by the old implementation and kind-of makes sense
		oStyle["minWidth"] = UCF_PopupWindow_standards["MINIMAL_WIDTH"] + 'px';
		oStyle["minHeight"] = UCF_PopupWindow_standards["MINIMAL_HEIGHT"] + 'px';

		var oCssMaxSize = oGetCssMaxSize();

		if (this["sWidth"] === '-1') {
			oStyle["width"] = 'min-content';
		} else {
			if (this["bWindowSize"]) {
				oStyle["width"] = this["sWidth"] + (!isNaN(this["sWidth"]) ? 'px' : '');
			} else {
				// Width/Height API parameters have semantic of "minimal size"
				oStyle["width"] = 'min-content';
				this["iWidth"] = this["iWidth"] ||
					UCF_DomUtil["iConvertAnySizeToPixel"](
						UCF_JsUtil["bContainsOnlyDigits"](this["sWidth"]) ? this["sWidth"] + 'px' : this["sWidth"], '1rem'
					);
				if (!isNaN(this["iWidth"])) {
					// Avoid that CSS min will always override max value. Max values are
					// needed for handling max-size (classes lsPWNewMaxWidthAutoX/Y)
					if (this["iWidth"] < oCssMaxSize["width"]) {
						oStyle["minWidth"] = this["iWidth"] + 'px';
					} else {
						// If a Width parameter is used we need to set some value
						// for min-width otherwise the size may not work with position:absolute
						// in the content (e.g. RasterLayout) because the width:min-content does NOT account for it.
						oStyle["minWidth"] = oCssMaxSize["width"] + 'px';
					}
				}
			}
		}
		if (this["sHeight"] === '-1') {
			oStyle["height"] = 'min-content';
		} else {
			if (this["bWindowSize"]) {
				oStyle["height"] = this["sHeight"] + (!isNaN(this["sHeight"]) ? 'px' : '');
			} else {
				// Width/Height API parameters have semantic of "minimal size"
				oStyle["height"] = 'min-content';
				this["iHeight"] = this["iHeight"] ||
					UCF_DomUtil["iConvertAnySizeToPixel"](
						UCF_JsUtil["bContainsOnlyDigits"](this["sHeight"]) ? this["sHeight"] + 'px' : this["sHeight"], '1rem'
					);
				if (!isNaN(this["iHeight"])) {
					var h = this["iHeight"] +
						UCF_DomUtil["$"](this["sId"] + '-footer')["offsetHeight"] +
						UCF_DomUtil["$"](this["sId"] + '-header')["offsetHeight"];
					// Avoid that CSS min will always override max value.
					if (h < oCssMaxSize["height"]) {
						oStyle["minHeight"] = h + 'px';
					} else {
						oStyle["minHeight"] = oCssMaxSize["height"] + 'px';
					}
				}
			}
		}
	} else {
		oStyle["width"] = this["oUserSize"]["w"] + 'px';
		oStyle["height"] = this["oUserSize"]["h"] + 'px';
	}

	//
	// Apply position
	//
	if (!this["bUserHasMoved"]) {
		if (!this["bUserHasResized"]) {
			// if (this.bCenterUsingMargins) {
			// 	this.oDomRef.style.marginLeft = '0px';
			// 	this.oDomRef.style.marginTop = '0px';
			// }
			// else {
			this["oDomRef"]["style"]["transform"] = '';
			//}

			UCF_DomUtil["addClass"](this["oDomRef"], 'lsPWNewMaxWidthAutoX');
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsPWNewMaxWidthAutoY');
			if (this["bUserHasMaximized"] || this["bIsMaximized"]) {
				oStyle["minWidth"] = '';
				oStyle["minHeight"] = '';
				UCF_DomUtil["addClass"](this["oDomRef"], 'lsPWNewMaximized');
			}

			if (this["sX"] === '-1') {
				if (this["sY"] === '-1') {
					centerXY(oStyle);
				} else {
					centerX(oStyle);
				}
			} else {
				oStyle["left"] = this["sX"] + (!isNaN(this["sX"]) ? 'px' : '');
			}
			if (this["sY"] === '-1') {
				if (this["sX"] === '-1') {
					centerXY(oStyle);
				} else {
					centerY(oStyle);
				}
			} else {
				oStyle["top"] = this["sY"] + (!isNaN(this["sY"]) ? 'px' : '');
			}
		} else {
			this["setFixedPosition"](this["oUserPosition"]["x"], this["oUserPosition"]["y"]);
		}
	} else {
		this["setFixedPosition"](this["oUserPosition"]["x"], this["oUserPosition"]["y"]);

		// User has previously moved the popup: It is no longer centered
		// Apply a max-width and max-height so that it will
		// completely visible even after an update with bigger content.
		// Use same CSS that is used with X/Y API parameter
		//
		// TODO: This does not work in the one case when API Width/Height
		// 			 parameters are used and the resulting minHeight/Width is bigger...
		//			 The old-school "position constraint" calculation might be used to
		// 			 fix it: oCalculatePositionConstraint()
		//
		this["oDomRef"]["style"]["setProperty"]('--ur-data-pw-posx', (this["oUserPosition"]["x"] - oScrollOffset["y"]) + 'px');
		this["oDomRef"]["style"]["setProperty"]('--ur-data-pw-posy', (this["oUserPosition"]["y"] - oScrollOffset["y"]) + 'px');
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsPWNewMaxWidthAutoX');
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsPWNewMaxWidthAutoY');
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsPWNewMaxWidthPosX');
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsPWNewMaxWidthPosY');
	}

	//
	// Apply "maximized" state
	//
	if (this["bUserHasMaximized"] || this["bIsMaximized"]) {
		oStyle["minWidth"] = '';
		oStyle["minHeight"] = '';
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsPWNewMaximized');

		if (this["bUserHasResized"]) {
			oStyle["width"] = '';
			oStyle["height"] = '';
			centerXY(oStyle);
		} else if (this["bUserHasMoved"]) {
			centerXY(oStyle);
		} else {
			// Position X,Y via API parameter -> overwrite values
			if (this["sX"] !== '-1') {
				centerX(oStyle);
			}
			if (this["sY"] !== '-1') {
				centerY(oStyle);
			}
			if (this["sX"] !== '-1' && this["sY"] !== '-1') {
				centerXY(oStyle);
			}
		}

	}

	//
	// Special handling: footer, responsive paddings, Chrome workarounds
	//
	this["handleFooterToolbarWidth"]();
	UCF_UserAgent["setResponsiveBreakpointScope"](this["oDomRef"], this["oDomRef"]["clientWidth"]);

	// This may look like a mistake: But this is currently the workaround to make the height work in Chrome in all cases.
	// offsetHeight is the value we are looking for but it is available only after setting scrollHeight as height
	oContentSection["style"]["height"] = oContentSection["scrollHeight"] + 'px';
	oContentSection["style"]["height"] = oContentSection["offsetHeight"] + 'px';
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["applyAPIPositionAndSize"] = 0; };

/**
 * Toggle maximized state
 */
UCF_PopupWindow_standards["prototype"]["toggleMaximize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["toggleMaximize"]++; }; 
	this["bUserHasMaximized"] = !this["bUserHasMaximized"];
	this["applyAPIPositionAndSize"](this["bUserHasMaximized"] === false);
	this["updateSize"]();

	// Toggle the icon
	UCF_DomUtil["$"](this["sId"] + "-minmax")["className"] =
		(this["bUserHasMaximized"] ? 'urPWRestoreIcon' : 'urPWMaximizeIcon')
		+ ' urPWBtnIcon urPWButton lsPWNewButton';

	var oContentSection = UCF_DomUtil["$"](this["sId"] + '-contentsection');
	this["fireEvent"](this["E_EVENTS"]["MoveAndResize"], {
		"ContentInnerSize": this["oGetContentInnerSize"]()
	});
	if (this["bUserHasMaximized"]) {
		// TODO: Paddings? see PopupWindow_ie6 implementation ...
		this["fireMaximize"](this["sId"], oContentSection["clientWidth"], oContentSection["clientHeight"]);
	} else {
		this["fireRestore"](this["sId"], oContentSection["clientWidth"], oContentSection["clientHeight"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["toggleMaximize"] = 0; };

/**
 * Special call for UCF_Placeholder
 * @return {Object} width,height
 */
UCF_PopupWindow_standards["prototype"]["oGetContentInnerSize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetContentInnerSize"]++; }; 
	var oContentSection = UCF_DomUtil["$"](this["sId"] + '-contentsection');
	return {
		"width": UCF_DomUtil["oGetFirstChild"](oContentSection)["clientWidth"],
		"height": UCF_DomUtil["oGetFirstChild"](oContentSection)["clientHeight"]
	};
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetContentInnerSize"] = 0; };

/**
 * handle move (header) and resize (handle)
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_standards["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onmousedown"]++; }; 
	// Support for none-modal popups - which is only used in Test-cases
	this["oPopupManager"]["updateZIndices"](this);

	this["bMoveHandlerStarted"] = false;

	var oSrcElement = oBrowserEvent["oGetSource"]();

	this["sDragMode"] = oSrcElement["getAttribute"]("drag");
	if (this["sDragMode"] === null || this["sDragMode"] === "false") return;

	var iStartX = oBrowserEvent["iScreenX"]();
	var iStartY = oBrowserEvent["iScreenY"]();

	/** @type {UCF_PopupWindow_standards} */
	var _this = this;

	/** @type {DOMRect} */
	var oStartPosAndSize = {
		"width": this["oDomRef"]["clientWidth"],
		"height": this["oDomRef"]["clientHeight"]
	};

	// Initial position cases:
	// 1. Already moved to fixed position
	// 2. default = center (left,top = 50%,50% and translate -50%,-50%)
	// 3. It has a given position via API parameters X/Y
	if (this["bUserHasMoved"]) {
		oStartPosAndSize["left"] = this["oDomRef"]["offsetLeft"];
		oStartPosAndSize["top"] = this["oDomRef"]["offsetTop"];
	} else if (this["sX"] === '-1' && this["sY"] === '-1' && !this["bUserHasResized"]) {
		oStartPosAndSize["left"] = this["oDomRef"]["offsetLeft"] - ( /*this.bCenterUsingMargins === true ? 0 : */ oStartPosAndSize["width"] / 2);
		oStartPosAndSize["top"] = this["oDomRef"]["offsetTop"] - ( /*this.bCenterUsingMargins === true ? 0 : */ oStartPosAndSize["height"] / 2);
	} else {
		// sX or sY is NOT "-1"
		oStartPosAndSize["left"] = this["oDomRef"]["offsetLeft"];
		oStartPosAndSize["top"] = this["oDomRef"]["offsetTop"];
	}

	// TODO:
	// Better support (tolerate) Placeholder in content (IFrame/HTMLIsland, PDFs):
	// Try to attach also to mousemove in shadow DOM if possible
	// 1. Search for PH control: ph="true" attribute
	// 2. Navigate to id="ID-ph"
	// 3. From there search for child <object> or <IFrame>
	// 4. Try to attach mousemove on oObject.contentDocument.body (in Chrome this also seems to work for PDFs)

	if (this["sDragMode"] === 'resize') {
		/**************************************
		 * 							resize
		 **************************************/
		this["sFocussedElementId"] = this["oLS"]["sGetFocusedElementId"]();

		var iMinWidthFromFooter = null;
		var oFooterToolbarContainer = UCF_DomUtil["$"](this["sId"] + '-tbcontainer');
		if (!oFooterToolbarContainer) {
			var oFooter = UCF_DomUtil["$"](_this["sId"] + '-footer');
			oFooter["style"]["width"] = 'fit-content';
			iMinWidthFromFooter = oFooter["clientWidth"];
			oFooter["style"]["width"] = 'auto';
		}

		// If previously moved, delete the maxWidth/Height during resize
		// It is re-applied whe applyAPIPositionAndSize() is called again
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsPWNewMaxWidthPosX');
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsPWNewMaxWidthPosY');

		var oScrollOffset = this["oLS"]["oGetPageScrollOffset"]();

		/**
		 * @param {MouseEvent} oNativeMouseMove
		 */
		this["handleMouseMove"] = function(oNativeMouseMove) {
			_this["bMoveHandlerStarted"] = true;

			if (oFooterToolbarContainer) {
				// Reset fixed width from workaround in handleFooterToolbarWidth()
				oFooterToolbarContainer["style"]["width"] = 'auto';
			}

			var oMousePos = _this["oGetEventMousePos"](oNativeMouseMove);

			var iDeltaX = oMousePos["x"] - iStartX;
			var iDeltaY = oMousePos["y"] - iStartY;
			var iNewWidth = window["UCF_System"]["bIsRTL"] ? oStartPosAndSize["width"] - iDeltaX : oStartPosAndSize["width"] + iDeltaX;
			var iNewHeight = oStartPosAndSize["height"] + iDeltaY;

			// Enforce min size
			iNewWidth = Math["max"](iNewWidth, UCF_PopupWindow_standards["MINIMAL_WIDTH"]);
			iNewHeight = Math["max"](iNewHeight, UCF_PopupWindow_standards["MINIMAL_HEIGHT"]);

			// Enforce max size
			var iAvailableHeight = document["documentElement"]["clientHeight"] || document["body"]["clientHeight"] || window["innerHeight"];
			var iAvailableWidth = document["documentElement"]["clientWidth"] || document["body"]["clientWidth"] || window["innerWidth"];
			var SAFETY_DISTANCE = 25;
			iAvailableHeight -= SAFETY_DISTANCE;
			iAvailableWidth -= SAFETY_DISTANCE;
			iNewHeight = Math["min"](iNewHeight, iAvailableHeight - oStartPosAndSize["top"] + oScrollOffset["y"]);
			iNewWidth = Math["min"](iNewWidth, iAvailableWidth - oStartPosAndSize["left"] + oScrollOffset["x"]);

			// Old-school buttons in footer (no footer-toolbar) must not be cut off
			// Footer has "min-width:min-content" - enforce for overall min-width when resizing
			if (iMinWidthFromFooter !== null) {
				iNewWidth = Math["max"](iNewWidth, iMinWidthFromFooter);
			}

			_this["oDomRef"]["style"]["width"] = iNewWidth + 'px';
			_this["oDomRef"]["style"]["height"] = iNewHeight + 'px';

			// Overwrite in case it is used (when API Width/Height parameters are set)
			// We must to be able to make popup smaller than "min-size" set by API parameters.
			var oContentSection = UCF_DomUtil["$"](_this["sId"] + '-contentsection');
			oContentSection["style"]["minWidth"] = oContentSection["style"]["minHeight"] = '';

			// Be able to resize maximized popup
			if (UCF_DomUtil["bHasClass"](_this["oDomRef"], 'lsPWNewMaximized')) {
				UCF_DomUtil["removeClass"](_this["oDomRef"], 'lsPWNewMaximized');
			}

			_this["oUserSize"] = { "w": iNewWidth, "h": iNewHeight };
			_this["oUserPosition"] = {
				"x": window["UCF_System"]["bIsRTL"] ? oStartPosAndSize["left"] - (iNewWidth - oStartPosAndSize["width"]) : oStartPosAndSize["left"],
				"y": oStartPosAndSize["top"]
			};

			// Check mouse button state - handles mouseup outside LS window
			if (oNativeMouseMove["buttons"] === 0) {
				_this["endResize"]();
				return;
			};

			// Position is fixed (usually default is "center") as soon as user has dragged the resize handle
			_this["setFixedPosition"](_this["oUserPosition"]["x"], _this["oUserPosition"]["y"]);

			// Show title text as tooltip when title has ellipsis
			var oTitleText = UCF_DomUtil["$"](_this["sId"] + '-header-title-txt');
			UCF_DomUtil["checkTooltip"](oTitleText["parentNode"], '', oTitleText);

			_this["bUserHasResized"] = true;
			_this["endNativeMoveHandler"](oNativeMouseMove);

			_this["fireEvent"](_this["E_EVENTS"]["Resize"], {
				"ContentInnerSize": _this["oGetContentInnerSize"]()
			});
			_this["notifyLayoutChangeFrom"](); // Notify controls inside content
		};

		UCF_DomUtil["attachEvent"](window["document"], "mousemove", this["handleMouseMove"]);
	} else if (this["sDragMode"] === 'move') {
		/**************************************
		 * 							 move
		 **************************************/

		/**
		 * @param {MouseEvent} oNativeMouseMove
		 */
		this["handleMouseMove"] = function(oNativeMouseMove) {
			var oMousePos = _this["oGetEventMousePos"](oNativeMouseMove);
			_this["bMoveHandlerStarted"] = true;

			var iNewX = oStartPosAndSize["left"] + oMousePos["x"] - iStartX;
			var iNewY = oStartPosAndSize["top"] + oMousePos["y"] - iStartY;

			var oAllowedPos = _this["oCalculatePositionConstraint"]({
				"x": iNewX,
				"y": iNewY,
				"width": oStartPosAndSize["width"],
				"height": oStartPosAndSize["height"]
			});
			iNewX = oAllowedPos["x"];
			iNewY = oAllowedPos["y"];

			_this["oUserPosition"] = { "x": iNewX, "y": iNewY };

			// Check mouse button state - handles mouseup outside LS window
			if (oNativeMouseMove["buttons"] === 0) {
				_this["endMove"]();
				return;
			};

			_this["bUserHasMoved"] = true;
			_this["setFixedPosition"](iNewX, iNewY);

			_this["endNativeMoveHandler"](oNativeMouseMove);
			_this["fireEvent"](_this["E_EVENTS"]["Move"]);
		};
		UCF_DomUtil["attachEvent"](window["document"], "mousemove", this["handleMouseMove"]);
	}

	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onmousedown"] = 0; };

UCF_PopupWindow_standards["prototype"]["endResize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["endResize"]++; }; 
	// restore focus
	if (this["sFocussedElementId"]) {
		this["oLS"]["focusElement"](this["sFocussedElementId"]);
		this["sFocussedElementId"] = null;
	}

	this["sDragMode"] = null;
	UCF_DomUtil["detachEvent"](window["document"], "mousemove", this["handleMouseMove"]);
	this["handleMouseMove"] = null;

	if (this["bMoveHandlerStarted"]) {
		this["handleFooterToolbarWidth"]();

		this["notifyLayoutChangeFrom"](); // Notify controls inside content

		var oContentSection = UCF_DomUtil["$"](this["sId"] + '-contentsection');
		this["fireEvent"](this["E_EVENTS"]["Resize"], {
			"ContentInnerSize": this["oGetContentInnerSize"]()
		});
		this["fireResize"](
			this["sId"],
			this["oUserSize"]["w"],
			this["oUserSize"]["h"],
			oContentSection["clientWidth"],
			oContentSection["clientHeight"],
			this["oUserPosition"]["x"],
			this["oUserPosition"]["y"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["endResize"] = 0; };

UCF_PopupWindow_standards["prototype"]["endMove"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["endMove"]++; }; 
	this["sDragMode"] = null;
	UCF_DomUtil["detachEvent"](window["document"], "mousemove", this["handleMouseMove"]);
	this["handleMouseMove"] = null;
	if (this["bMoveHandlerStarted"]) {
		this["fireEvent"](this["E_EVENTS"]["Move"]);
		this["fireMove"](
			this["sId"],
			this["oUserPosition"]["x"],
			this["oUserPosition"]["y"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["endMove"] = 0; };

/**
 * @private
 */
UCF_PopupWindow_standards["prototype"]["handleFooterToolbarWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["handleFooterToolbarWidth"]++; }; 
	// Footer: In case of footer-toolbar it should NOT push the width
	// TODO: Is there a CSS solution for this?
	var oFooterToolbarContainer = UCF_DomUtil["$"](this["sId"] + '-tbcontainer');
	if (oFooterToolbarContainer) {
		oFooterToolbarContainer["style"]["display"] = 'none';
		oFooterToolbarContainer["style"]["width"] = this["oDomRef"]["clientWidth"] + 'px';
		oFooterToolbarContainer["style"]["display"] = 'block';
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["handleFooterToolbarWidth"] = 0; };

/**
 * handle mouseup for move and resize
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_standards["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onmouseup"]++; }; 
	if (this["sDragMode"] === 'resize') {
		this["endResize"]();
		this["updateSize"]();
	} else if (this["sDragMode"] === 'move') {
		this["endMove"]();
		this["updatePosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onmouseup"] = 0; };

/**
 * @private
 * @return {Object} height,width
 */
UCF_PopupWindow_standards["prototype"]["oGetInnerWindowSize"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetInnerWindowSize"]++; }; 
	//
	// This is copied from the old implementation
	// still the same TODO: Use UCF_DomUtil.oGetVisualViewport() ?
	//

	if (UCF_UserAgent["bIsAndroid"]()) {
		var oVP = window["visualViewport"];
		return {
			'height': Math["floor"](oVP["height"]),
			'width': Math["floor"](oVP["width"])
		};
	}

	var r = {
		'height': Math["max"](0,
			window["innerHeight"] ||
			window["document"]["documentElement"]["clientHeight"] ||
			window["document"]["body"]["clientHeight"]
		),
		'width': Math["max"](0,
			window["innerWidth"] ||
			window["document"]["documentElement"]["clientWidth"] ||
			window["document"]["body"]["clientWidth"]
		)
	};

	return r;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetInnerWindowSize"] = 0; };

/**
 * Calculates the allowed x/y location based on the given position and size of the popup and the available space on the main page, so that
 * the popup is completely visible and no scrollbars are caused in the page.
 * @param {Object} oFrame (x,y,width,height) The actual current frame or a calculated one
 * @return {Object|null} (x,y) An allowed position (could be unchanged x,y values from the input if it is an allowed position)
 */
UCF_PopupWindow_standards["prototype"]["oCalculatePositionConstraint"] = function(oFrame) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oCalculatePositionConstraint"]++; }; 
	var oResult = { "x": oFrame["x"], "y": oFrame["y"] };
	var oInnerSize = this["oGetInnerWindowSize"]();
	var oScrollOffset;
	if (this["oLS"]["oGetPageInternal"]()["bInsideShellIFrameOnIOS"]()) {
		oScrollOffset = this["oLS"]["oGetPageScrollOffset"]();
	} else {
		oScrollOffset = UCF_DomUtil["oGetScrollOffset"](window);
	}
	console["log"](">>> oInnerSize=" + JSON["stringify"](oInnerSize));

	// Make sure to not cause scrollbars in any case/browser
	var SAFETY_DISTANCE = {
		"x": 25, //2,
		"y": 25 //UCF_UserAgent.bIsFirefox() ? 5 : 3 // eslint-disable-line no-magic-numbers
	};

	var iMaxX;
	var iSB;
	if (window["UCF_System"]["bIsRTL"]) {
		iMaxX = oInnerSize["width"] - oFrame["width"];
		oResult["x"] = Math["min"](oResult["x"], iMaxX);
		oResult["x"] = Math["max"](oResult["x"], 0);
	} else {
		var bHasScrollbarY =
			Math["max"](window["document"]["body"]["scrollHeight"], window["document"]["documentElement"]["scrollHeight"]) >
			Math["max"](window["document"]["body"]["clientHeight"], window["document"]["documentElement"]["clientHeight"]);
		iSB = bHasScrollbarY ? UCF_DomUtil["iGetScrollbarWidth"]() : 0;
		iMaxX = oScrollOffset["x"] + oInnerSize["width"] - oFrame["width"] - iSB - SAFETY_DISTANCE["x"];
		oResult["x"] = Math["min"](oResult["x"], iMaxX);
		oResult["x"] = Math["max"](oResult["x"], 0);
		if (UCF_UserAgent["bIsIOS"]() && oScrollOffset["x"] > 0) {
			oResult["x"] = oScrollOffset["x"];
		}
	}

	var bHasScrollbarX =
		Math["max"](window["document"]["body"]["scrollWidth"], window["document"]["documentElement"]["scrollWidth"]) >
		Math["max"](window["document"]["body"]["clientWidth"], window["document"]["documentElement"]["clientWidth"]);
	iSB = bHasScrollbarX ? (iSB !== undefined ? iSB : UCF_DomUtil["iGetScrollbarWidth"]()) : 0;
	var iMaxY = oScrollOffset["y"] + oInnerSize["height"] - oFrame["height"] - iSB - SAFETY_DISTANCE["y"];
	oResult["y"] = Math["min"](oResult["y"], iMaxY);
	oResult["y"] = Math["max"](oResult["y"], 0);
	console["log"](">>> oResult=" + JSON["stringify"](oResult));
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oCalculatePositionConstraint"] = 0; };

/**
 * Destructor
 */
UCF_PopupWindow_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["destroy"]++; }; 
	if (this["oLS"] == null || this["bIsDestroyed"]) return;
	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this);
	this["handleMouseMove"] = null;
	this["sDragMode"] = null;
	this["sFocussedElementId"] = null;
	this["oUserPosition"] = null;
	this["oUserSize"] = null;
	this["bUserHasMaximized"] = null;
	//this.bCenterUsingMargins = null;
	this["iFallbackSize"] = null;
	this["iWidth"] = null;
	this["iHeight"] = null;
	UCF_PopupBase.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["destroy"] = 0; };

/**
 * Handle keydown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_standards["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]("UCF_Hotkeys")["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}

	var iKey = oBrowserEvent["iKeyCode"](),
		bCtrl = oBrowserEvent["bCtrl"](),
		bShift = oBrowserEvent["bShift"](),
		bAlt = oBrowserEvent["bAlt"]();

	if (bCtrl || bShift || bAlt) return;

	switch (iKey) {

		case UCF_KeyCodes["ESCAPE"]:

			if (!this["bHasCloseButton"]) break;

			if (UCF_UserAgent["bIsGecko"]()) {
				// Delay is a workaround: Otherwise FF will abort the UCF request when ESC is pressed
				// and UCF_RequestUtil will render the error message popup (connection broken)
				UCF_JsUtil["delayedCall"](10, this, "fireClose", [this["sId"]]);
			} else {
				this["fireClose"](this["sId"]);
			}
			break;

		case UCF_KeyCodes["SPACE"]:
			this["onclick"](oBrowserEvent);
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onkeypress"] = 0; };

/**
 * Handle browsers that do not (no longer) fire keypress for ESC...
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupWindow_standards["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onkeydown"]++; }; 
	if (!(UCF_UserAgent["bIsChromium"]() || UCF_UserAgent["bIsMSEdge"]() || UCF_UserAgent["bIsFirefox"]())) return;

	// Do not fire Close event if a ESC-hotkey is defined and was already handled
	if (oBrowserEvent["bIsDomEventCanceled"]()) return;

	var iKey = oBrowserEvent["iKeyCode"](),
		bCtrl = oBrowserEvent["bCtrl"](),
		bShift = oBrowserEvent["bShift"](),
		bAlt = oBrowserEvent["bAlt"]();

	if (bCtrl || bShift || bAlt) return;
	if (iKey === UCF_KeyCodes["ESCAPE"]) {
		this["fireClose"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onkeydown"] = 0; };

/**
 * Overwrite for special handling of client-side-rendering with DIV popups and bKeepAlive=true
 * when the new control has the same ID but is of a different type (although this should only
 * happen in QUnit tests...)
 * @return {Object}
 */
UCF_PopupWindow_standards["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["bDoKeepAlive"]++; }; 
	var oNewDomRef = UCF_DomUtil["$"](this["sId"]);
	return oNewDomRef && oNewDomRef["getAttribute"]('ct') === 'PW_standards';
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["bDoKeepAlive"] = 0; };

/**
 * Focus handling
 * @private
 */
UCF_PopupWindow_standards["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["focus"]++; }; 
	// Called directly by LS.focusElement() -> FocusInfo.apply() when the
	// framework focusses the popup because the application has not set a focus inside the content.
	// => Search and focus first button in footer or close button
	// => Search has to skip "hidden" and disabled (tabindex="-1") buttons

	/** @type {Array} */
	var aFooterButtons = UCF_JsUtil["filter"](
		Array["from"](UCF_DomUtil["$"](this["sId"] + '-footer')["querySelectorAll"]('*[tabindex = "0"]')),
		function(e) {
			// offsetParent is null when the element or a parent has display:none
			return UCF_DomUtil["sGetCurrentStyle"](e, 'visibility') !== 'hidden' &&
				e["offsetParent"] !== null && e["offsetParent"] !== undefined;
		}
	);
	if (aFooterButtons && aFooterButtons["length"] > 0 &&
		aFooterButtons[0]["id"] !== this["sId"] + '-lasttabindex') {
		UCF_JsUtil["delayedCall"](0, UCF_DomUtil, "focusDomElement", [aFooterButtons[0]]);
	} else {
		if (UCF_DomUtil["$"](this["sId"] + "-close")) {
			UCF_JsUtil["delayedCall"](0, UCF_DomUtil, "focusDomElement", [UCF_DomUtil["$"](this["sId"] + "-close")]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["focus"] = 0; };

/**
 * Handle lsfocus event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_standards["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onlsfocus"]++; }; 
	var sId = oBrowserEvent["oGetSource"]()["id"];
	if (sId === this["sId"] + '-lasttabindex') {
		var oFirstTitleButton = this["oDomRef"]["querySelector"]('.lsPWNewHeaderDivRight button[tabindex = "0"]');
		if (oFirstTitleButton) {
			UCF_DomUtil["focusDomElement"](oFirstTitleButton);
		} else {
			this["focusFirstChildControl"]();
		}
	} else if (sId === this["sId"] + '-firsttabindex') {
		// focus the last button or the last element of the content
		// when using shift-TAB on the title
		this["focusLastChildControl"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onlsfocus"] = 0; };

/**
 * Event handler
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_PopupWindow_standards["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oncontextmenu"]++; }; 
	if (this["sMode"] === "MODAL" && this["bContextMenuEvent"]) {
		this["firePopupContextMenu"](
			this["sId"],
			oBrowserEvent["oGetSourceControl"]()["sGetId"](),
			oBrowserEvent["iPageX"](),
			oBrowserEvent["iPageY"](),
			oBrowserEvent["bShift"](),
			oBrowserEvent["bCtrl"](),
			oBrowserEvent["bAlt"]()
		);
		// No context event on Page (or other "parent" popups), which are blocked by BlockLayer
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oncontextmenu"] = 0; };

/**
 * Returns the footer ToolBar control or null.
 * Note: This is only needed for workaround for then tab-chain (see Toolbar_standards.js)
 * @return {UCF_Toolbar|null}
 */
UCF_PopupWindow_standards["prototype"]["oGetFooterToolbar"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetFooterToolbar"]++; }; 
	var o = UCF_DomUtil["$"](this["sId"] + "-tbcontainer");
	if (o) {
		o = UCF_DomUtil["oGetFirstChild"](o);
		if (o) {
			// the Toolbar has a root container
			o = UCF_DomUtil["oGetFirstChild"](o);
			if (o) {
				return this["oGetControlByDomRef"](o);
			}
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetFooterToolbar"] = 0; };

/**
 * called by UCF_InputFieldHelpButton#oFindPositionContainer
 * @return {HTMLDivElement}
 */
UCF_PopupWindow_standards["prototype"]["oGetContentRef"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetContentRef"]++; }; 
	return this["oGetScrollAreaRoot"]();
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetContentRef"] = 0; };

/** ---------------- Touch support ---------------- */

/**
 * Orientation changed on iOS / Touch device
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_PopupWindow_standards["prototype"]["onOrientationChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onOrientationChange"]++; }; 
	this["handleFooterToolbarWidth"]();
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onOrientationChange"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_PopupWindow_standards["prototype"]["ontouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["ontouchstart"]++; }; 
	this["onclick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["ontouchstart"] = 0; };

/**
 * @see #onmousedown
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupWindow_standards["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onlstouchstart"]++; }; 
	this["onmousedown"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onlstouchstart"] = 0; };

/**
 * @see #onmousedown
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupWindow_standards["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onlstouchend"]++; }; 
	this["onmouseup"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onlstouchend"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_PopupWindow_standards["prototype"]["onlstouchmove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onlstouchmove"]++; }; 
	if (this["handleMouseMove"] !== null) {
		this["handleMouseMove"](oBrowserEvent["oDomEvent"]);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["onlstouchmove"] = 0; };

UCF_PopupWindow_standards["prototype"]["oGetEventMousePos"] = function(oNativeBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetEventMousePos"]++; }; 
	//oNativeBrowserEvent = oNativeBrowserEvent|| window.event;

	// TODO: Better use UCF_BrowserEvent.bTouchInteraction ??
	var iSX = oNativeBrowserEvent["screenX"];
	var iSY = oNativeBrowserEvent["screenY"];
	if (iSX === undefined && oNativeBrowserEvent["touches"][0]) {
		iSX = oNativeBrowserEvent["touches"][0]["screenX"];
		iSY = oNativeBrowserEvent["touches"][0]["screenY"];
	}

	return {
		"x": iSX,
		"y": iSY
	};
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["oGetEventMousePos"] = 0; };

UCF_PopupWindow_standards["prototype"]["endNativeMoveHandler"] = function(oNativeBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["endNativeMoveHandler"]++; }; 
	if (UCF_BrowserEvent["bTouchInteraction"]) {
		UCF_DomUtil["cancelEvent"](oNativeBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["endNativeMoveHandler"] = 0; };

/**
 * @private
 * @return {Array}
 */
UCF_PopupWindow_standards["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_PopupBase.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	var oTitleText = UCF_DomUtil["$"](this["sId"] + '--header-title-txt');

	if (oTitleText && UCF_DomUtil["bHasTextEllipsis"](oTitleText["parentNode"], oTitleText)) {
		aResult["push"]({
			"sType": 'TEXT',
			"sText": UCF_DomUtil["sGetInnerText"](oTitleText)
		});
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["aGetTouchContextMenuEntries"] = 0; };

/**
 * Returns true if the instance is a DIV-popup and has Mode=MODAL. Returns null when instance is not yet initialized.
 * Note: Called by UCF_Placeholder
 * @return {boolean|null}
 */
UCF_PopupWindow_standards["prototype"]["bIsModalDivPopup"] = function() {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["bIsModalDivPopup"]++; }; 
	if (this["bIsDivPopup"] == null || this["bIsDivPopup"] === undefined) return null;
	return this["bIsDivPopup"] && this["sMode"] === "MODAL";
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["bIsModalDivPopup"] = 0; };

/** ------------------- Interface API ---------------- */

/**
 * Changes the title text.
 *
 * @param {string} sText string The new text
 * @public
 */
UCF_PopupWindow_standards["prototype"]["setTitleText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["setTitleText"]++; }; 
	var oTitleTextRef = UCF_DomUtil["$"](this["sId"] + '-header-title-txt');
	UCF_DomUtil["setInnerText"](oTitleTextRef, sText);
	this["notifyLayoutChangeFrom"](); // Popup width may change
};;if (__UCF_COVERAGE__) { UCF_PopupWindow_standards["_"]["setTitleText"] = 0; };

UCF_PopupWindow_standards.prototype["aPublicMethods"] = ["close","setTitleText"].concat(UCF_PopupWindow_standards.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PostMessageTreatments"] = function() {/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsdoc/check-alignment */
/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 *
 * Post Message Treatmentss holds a list of PM Services with their
 * required Clientactions
 *
 *
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
// eslint-disable-next-line jsdoc/check-syntax
function UCF_PostMessageTreatments(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PostMessageTreatments["_"]["UCF_PostMessageTreatments"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "PostMessageTreatments.js(33): UCF_PostMessageTreatments"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef !== null, "oDomRef !== null", "PostMessageTreatments.js(34): UCF_PostMessageTreatments"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PostMessageTreatments.js(35): UCF_PostMessageTreatments"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	if (!UCF_UserAgent["bIsStandardsMode"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'PostMessageHubs are supported in standards mode only', "PostMessageTreatments.js(40): UCF_PostMessageTreatments"); };
		// eslint-disable-next-line no-unsanitized/property
		this["oRootRef"]["innerHTML"] =
			oLS["sGetText"]('SAPUR_HTML5_CONTROL_ERROR', [
				'<a target=\'_blank\' href=\'https://service.sap.com/sap/support/notes/1970689\'>Note 1970689</a>',
				'Postmessage'
			]);

		return;
	}
	if (!UCF_PostMessageTreatments["mServices"])
		UCF_PostMessageTreatments["mServices"] = {};
	try {
		if (oDomRef["innerHTML"]["substring"](12, oDomRef["innerHTML"]["length"] - 6) === '{}');
		//			this.mServices = {};
		else {
			var newValues = UCF_JsUtil["oJsonParse"](
				oDomRef["innerHTML"]["substring"](12, oDomRef["innerHTML"]["length"] - 6)["replace"](/\\/g, ''));
			var aKeys = UCF_JsUtil["keys"](newValues);
			for (var iIndex = 0; iIndex < aKeys["length"]; iIndex++)
				UCF_PostMessageTreatments["mServices"][aKeys[iIndex]] = newValues[aKeys[iIndex]];
		}
	} catch (e) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'PostMessageServices: Service Treatment List cannot be parsed', "PostMessageTreatments.js(63): UCF_PostMessageTreatments"); };
	}
	this["oLS"] = oLS;
};window["UCF_PostMessageTreatments"] = UCF_PostMessageTreatments; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PostMessageTreatments"); UCF_PostMessageTreatments["_"] = {UCF_PostMessageTreatments: 0}; }; ;

UCF_PostMessageTreatments["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PostMessageTreatments.prototype["sClassName"] = "UCF_PostMessageTreatments";

UCF_PostMessageTreatments["addPostMessageService"] = function(sService, setClientAction) {;if (__UCF_COVERAGE__) { UCF_PostMessageTreatments["_"]["addPostMessageService"]++; }; 
	if (!UCF_PostMessageTreatments["mServices"])
		UCF_PostMessageTreatments["mServices"] = {};
	UCF_PostMessageTreatments["mServices"][sService] = setClientAction;
};;if (__UCF_COVERAGE__) { UCF_PostMessageTreatments["_"]["addPostMessageService"] = 0; };

UCF_PostMessageTreatments["removePostMessageService"] = function(sService) {;if (__UCF_COVERAGE__) { UCF_PostMessageTreatments["_"]["removePostMessageService"]++; }; 
	if (UCF_PostMessageTreatments["mServices"])
		UCF_PostMessageTreatments["mServices"][sService] = null;
};;if (__UCF_COVERAGE__) { UCF_PostMessageTreatments["_"]["removePostMessageService"] = 0; };

UCF_PostMessageTreatments["getClientAction"] = function(sServiceName) {;if (__UCF_COVERAGE__) { UCF_PostMessageTreatments["_"]["getClientAction"]++; }; 
	var u;
	for (u in UCF_PostMessageTreatments["mServices"])
		if (sServiceName["startsWith"](u))
			return UCF_PostMessageTreatments["mServices"][u];
		return null;
};;if (__UCF_COVERAGE__) { UCF_PostMessageTreatments["_"]["getClientAction"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PostMessageTreatments["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PostMessageTreatments["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PostMessageTreatments["prototype"]["aMethodNames"] = ["addPostMessageTreatment","removePostMessageTreatment","getClientAction","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_PostMessageTreatments["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_PostMessageTreatments["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PostMessageTreatments["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_PostMessageTreatments["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ProgressIndicator"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_RenderManager */
/// <reference path="../core/RenderManager.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ProgressIndicator(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["UCF_ProgressIndicator"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ProgressIndicator.js(31): UCF_ProgressIndicator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ProgressIndicator.js(32): UCF_ProgressIndicator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ProgressIndicator.js(33): UCF_ProgressIndicator"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	if (this["getClientControl"]()) {
		if (this["sDisplayValue"] === null) {
			this["sDisplayValue"] = this["getClientControl"]()["getDisplayValue"]();
			this["setClientProperty"]("DisplayValue", this["sDisplayValue"], true);
		}
		if (this["bShowValue"] === null) {
			this["bShowValue"] = this["getClientControl"]()["getShowValue"]();
			this["setClientProperty"]("ShowValue", this["bShowValue"], true);
		}
		if (this["iPercentValue"] === null) {
			this["iPercentValue"] = this["getClientControl"]()["getPercentValue"]();
			this["setClientProperty"]("PercentValue", this["iPercentValue"], true);
		}
	}
};window["UCF_ProgressIndicator"] = UCF_ProgressIndicator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ProgressIndicator"); UCF_ProgressIndicator["_"] = {UCF_ProgressIndicator: 0}; }; ;

UCF_ProgressIndicator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ProgressIndicator.prototype["sClassName"] = "UCF_ProgressIndicator";

UCF_ProgressIndicator["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["initialize"]++; }; 
	// The workaround for safari removed, because is never used.
	// The clientHeight of ProgressIndicator in the themes older as sap_corbu is
	// never smaller as 15.
	/*	this.WebsocketId = "IHUB_WEBSOCKETPCP";
		if (window.JSON != undefined && this.WebsocketId != '') {
			var oIHubWebSocket = this.oLS.oControlFactory.oGetControlByDomRef(
				UCF_DomUtil.$(this.WebsocketId), true );
			if (oIHubWebSocket)
				oIHubWebSocket.attachSemanticEvent('ReceivePcpEventSeverity0', this, 'onWebsocketReceive');
		}
	*/
};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["initialize"] = 0; };

/** @override */
UCF_ProgressIndicator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["destroy"]++; }; 
	this["sDisplayValue"] = null;
	this["bShowValue"] = null;
	this["iPercentValue"] = null;
	this["sBarColor"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["destroy"] = 0; };

/**
 * returns a Class to style an unfilled progress bar without progress value
 * @private
 * @param {string} sBarColor
 * @return { string }
 */
UCF_ProgressIndicator["prototype"]["getBarStateClass"] = function(sBarColor) {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["getBarStateClass"]++; }; 
	switch (sBarColor) {
		case "POSITIVE":
			return "lsProgressIndicator--positive";
		case "CRITICAL":
			return "lsProgressIndicator--critical";
		case "NEGATIVE":
			return "lsProgressIndicator--negative";
	}
	return "lsProgressIndicator--neutral";
};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["getBarStateClass"] = 0; };

/**
 * returns a Class to style a BarColor
 * @param {string} sBarColor
 * @return { string }
 */
UCF_ProgressIndicator["prototype"]["getBarClass"] = function(sBarColor) {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["getBarClass"]++; }; 
	switch (sBarColor) {
		case "POSITIVE":
			return "urPrInValuePositiv";
		case "CRITICAL":
			return "urPrInValueCritical";
		case "NEGATIVE":
			return "urPrInValueNegativ";
	}
	return "urPrInNeutral";
};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["getBarClass"] = 0; };

/**
 * set a BarColor
 * @param { string } sBarColor for a ProgressIndicator
 * @public
 */
UCF_ProgressIndicator["prototype"]["setBarColor"] = function(sBarColor) {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["setBarColor"]++; }; 
	/** @type {HTMLImageElement|SVGElement|HTMLSpanElement} */
	var aImg = this["oDomRef"]["getElementsByTagName"]("IMG"),
		sOldBarClass = this["getBarClass"](this["sBarColor"]),
		sNewBarColor = this["getBarClass"](sBarColor),
		sOldBarStateClass = this["getBarStateClass"](this["sBarColor"]),
		sNewBarStateClass = this["getBarStateClass"](sBarColor);

	UCF_DomUtil["replaceClass"](this["oDomRef"], sOldBarStateClass, sNewBarStateClass);

	for (var i = 0; i < aImg["length"]; i++) {
		UCF_DomUtil["replaceClass"](aImg[i], sOldBarClass, sNewBarColor);

	}

	this["sBarColor"] = sBarColor;
	this["setClientProperty"]("BarColor", this["sBarColor"], true);
};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["setBarColor"] = 0; };

UCF_ProgressIndicator["prototype"]["updateImageStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["updateImageStyles"]++; }; 
	/** @type {HTMLImageElement|SVGElement|HTMLSpanElement} */
	var aImg = this["oDomRef"]["getElementsByTagName"]("IMG");

	if (this["iPercentValue"] < 100 && this["iPercentValue"] > 0) {

		if (UCF_DomUtil["bHasClass"](this["oDomRef"], "lsProgressIndicator--value-min")) {
			UCF_DomUtil["removeClass"](this["oDomRef"], "lsProgressIndicator--value-min");
			UCF_DomUtil["removeClass"](aImg[1], "lsProgressIndicator__item--secondvalue-min");
		}

		if (UCF_DomUtil["bHasClass"](this["oDomRef"], "lsProgressIndicator--value-max")) {
			UCF_DomUtil["removeClass"](this["oDomRef"], "lsProgressIndicator--value-max");
			UCF_DomUtil["removeClass"](aImg[1], "lsProgressIndicator__item--secondvalue-max");
		}

		UCF_DomUtil["replaceClass"](aImg[0], "lsProgressIndicator__item--first", "lsProgressIndicator__item--firstOuter");

		if (UCF_DomUtil["bHasClass"](aImg[1], "lsProgressIndicator__item--secondOuterLeft")) {
			UCF_DomUtil["replaceClass"](aImg[1], "lsProgressIndicator__item--secondOuterLeft", "lsProgressIndicator__item--secondOuterRight");
			UCF_DomUtil["removeClass"](aImg[2], "lsProgressIndicator__item--third");
		} else {
			UCF_DomUtil["replaceClass"](aImg[1], "lsProgressIndicator__item--second", "lsProgressIndicator__item--secondOuterRight");
		}
	}

	if (this["iPercentValue"] > 100) {
		UCF_DomUtil["replaceClass"](aImg[1], "lsProgressIndicator__item--second", "lsProgressIndicator__item--secondOuterLeft");
		UCF_DomUtil["replaceClass"](aImg[1], "lsProgressIndicator__item--secondOuterRight", "lsProgressIndicator__item--secondOuterLeft");
		UCF_DomUtil["replaceClass"](aImg[0], "lsProgressIndicator__item--firstOuter", "lsProgressIndicator__item--first");
		UCF_DomUtil["addClass"](aImg[2], "lsProgressIndicator__item--third");
	}

	if (this["iPercentValue"] === 0 || this["iPercentValue"] === 100) {
		UCF_DomUtil["replaceClass"](aImg[0], "lsProgressIndicator__item--firstOuter", "lsProgressIndicator__item--first");
		UCF_DomUtil["replaceClass"](aImg[1], "lsProgressIndicator__item--secondOuterLeft", "lsProgressIndicator__item--second");
		UCF_DomUtil["replaceClass"](aImg[1], "lsProgressIndicator__item--secondOuterRight", "lsProgressIndicator__item--second");
		if (UCF_DomUtil["bHasClass"](aImg[2], "lsProgressIndicator__item--third")) {
			UCF_DomUtil["removeClass"](aImg[2], "lsProgressIndicator__item--third");
		}

		if (this["iPercentValue"] === 100) {
			if (this["oDomRef"]) {
				if (UCF_DomUtil["bHasClass"](this["oDomRef"], "lsProgressIndicator--value-min")) {
					UCF_DomUtil["replaceClass"](this["oDomRef"], "lsProgressIndicator--value-min", "lsProgressIndicator--value-max");
				} else {
					UCF_DomUtil["addClass"](this["oDomRef"], "lsProgressIndicator--value-max");
				}
			}
			if (UCF_DomUtil["bHasClass"](aImg[1], "lsProgressIndicator__item--secondvalue-min")) {
				UCF_DomUtil["replaceClass"](aImg[1], "lsProgressIndicator__item--secondvalue-min", "lsProgressIndicator__item--secondvalue-max");
			} else {
				UCF_DomUtil["addClass"](aImg[1], "lsProgressIndicator__item--secondvalue-max");
			}
		}

		if (this["iPercentValue"] === 0) {
			if (this["oDomRef"]) {
				if (UCF_DomUtil["bHasClass"](this["oDomRef"], "lsProgressIndicator--value-max")) {
					UCF_DomUtil["replaceClass"](this["oDomRef"], "lsProgressIndicator--value-max", "lsProgressIndicator--value-min");
				} else {
					UCF_DomUtil["addClass"](this["oDomRef"], "lsProgressIndicator--value-min");
				}
			}
			if (UCF_DomUtil["bHasClass"](aImg[1], "lsProgressIndicator__item--secondvalue-max")) {
				UCF_DomUtil["replaceClass"](aImg[1], "lsProgressIndicator__item--secondvalue-max", "lsProgressIndicator__item--secondvalue-min");
			} else {
				UCF_DomUtil["addClass"](aImg[1], "lsProgressIndicator__item--secondvalue-min");
			}
		}
	}

};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["updateImageStyles"] = 0; };

/** @private */
UCF_ProgressIndicator["prototype"]["updateTextStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["updateTextStyles"]++; }; 
	/** @type {HTMLImageElement|SVGElement|HTMLSpanElement} */
	var aImg = this["oDomRef"]["getElementsByTagName"]("IMG");
	/** @type {HTMLDivElement} */
	var aDiv = this["oDomRef"]["getElementsByTagName"]("DIV");

	if (aDiv && aDiv[0]) {
		UCF_DomUtil["removeClass"](aDiv[0], "lsPITxtLAlign");
		UCF_DomUtil["removeClass"](aDiv[0], "lsPITxtRAlign");
		if (this["iPercentValue"] === 0) {
			if (window["UCF_System"]["bIsRTL"]) {
				UCF_DomUtil["setStyle"](aDiv[0], {
					"width": aImg[1]["style"]["width"],
					"right": aImg[2]["style"]["width"]
				});
			} else {
				UCF_DomUtil["setStyle"](aDiv[0], {
					"width": aImg[1]["style"]["width"],
					"left": aImg[2]["style"]["width"]
				});
			}
		} else if (this["iPercentValue"] > 50 && this["iPercentValue"] < 101) {
			UCF_DomUtil["addClass"](aDiv[0], "lsPITxtLAlign");
			if (window["UCF_System"]["bIsRTL"]) {
				UCF_DomUtil["setStyle"](aDiv[0], {
					"width": this["iPercentValue"] + '%',
					"right": aImg[2]["style"]["width"]
				});
			} else {
				UCF_DomUtil["setStyle"](aDiv[0], {
					"width": this["iPercentValue"] + '%',
					"left": aImg[2]["style"]["width"]
				});
			}
		} else if (this["iPercentValue"] > 0 && this["iPercentValue"] < 51) {
			UCF_DomUtil["addClass"](aDiv[0], "lsPITxtRAlign");
			if (window["UCF_System"]["bIsRTL"]) {
				UCF_DomUtil["setStyle"](aDiv[0], {
					"width": (100 - this["iPercentValue"]) + '%',
					"right": this["iPercentValue"] + '%'
				});
			} else {
				UCF_DomUtil["setStyle"](aDiv[0], {
					"width": (100 - this["iPercentValue"]) + '%',
					"left": this["iPercentValue"] + '%'
				});
			}
		} else if (this["iPercentValue"] > 100) {
			UCF_DomUtil["addClass"](aDiv[0], "lsPITxtLAlign");
			var iSecondImgWidth = parseInt(aImg[1]["style"]["width"]);
			var iThirdImgWidth = parseInt(aImg[2]["style"]["width"]);

			if (iSecondImgWidth >= iThirdImgWidth) {
				if (window["UCF_System"]["bIsRTL"]) {
					UCF_DomUtil["setStyle"](aDiv[0], {
						"width": aImg[1]["style"]["width"],
						"right": aImg[0]["style"]["width"]
					});
				} else {
					UCF_DomUtil["setStyle"](aDiv[0], {
						"width": aImg[1]["style"]["width"],
						"left": aImg[0]["style"]["width"]
					});
				}
			} else {
				if (window["UCF_System"]["bIsRTL"]) {
					UCF_DomUtil["setStyle"](aDiv[0], {
						"width": aImg[2]["style"]["width"],
						"right": aImg[1]["style"]["width"]
					});
				} else {
					UCF_DomUtil["setStyle"](aDiv[0], {
						"width": aImg[2]["style"]["width"],
						"left": aImg[1]["style"]["width"]
					});
				}
			}

		}

	}

};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["updateTextStyles"] = 0; };

/** @private */
UCF_ProgressIndicator["prototype"]["updateTitle"] = function() {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["updateTitle"]++; }; 
	/** @type {string} */
	var sTitle = this["iPercentValue"] + '%';

	if (this["sDisplayValue"] && this["sDisplayValue"] !== sTitle) {
		sTitle += ' - ' + this["sDisplayValue"];
	}
	if (
		this["sTooltip"] &&
		this["sTooltip"] !== this["iPercentValue"] + '%' &&
		this["sTooltip"] !== this["sDisplayValue"]
	) {
		sTitle += ' - ' + this["sTooltip"];
	}

	this["oDomRef"]["title"] = sTitle;

	if (window["UCF_System"]["bIsAria"]) {
		this["oDomRef"]["setAttribute"]('aria-valuetext', this["sDisplayValue"]);
		this["oDomRef"]["setAttribute"]('aria-valuenow', this["iPercentValue"]);
	}

};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["updateTitle"] = 0; };

/**
 * Set the PercentValue
 * @param { int } iPercentValue for a ProgressIndicator
 * @public
 */
UCF_ProgressIndicator["prototype"]["setPercentValue"] = function(iPercentValue) {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["setPercentValue"]++; }; 
	/** @type {HTMLImageElement|SVGElement|HTMLSpanElement} */
	var aImg = this["oDomRef"]["getElementsByTagName"]("IMG");

	if (iPercentValue < 100) {
		aImg[0]["style"]["width"] = iPercentValue + "%";
		aImg[1]["style"]["width"] = (100 - iPercentValue) + "%";
		if (aImg[1]["className"]["indexOf"](this["getBarClass"]()) > -1) {
			UCF_DomUtil["removeClass"](aImg[1], this["getBarClass"](this["sBarColor"]));
		}
		aImg[2]["style"]["width"] = "0%";
	} else if (iPercentValue >= 100) {
		aImg[0]["style"]["width"] = "0%";
		aImg[1]["style"]["width"] = Math["round"](10000 / iPercentValue) + "%";
		if (aImg[1]["className"]["indexOf"](this["getBarClass"]()) === -1) {
			UCF_DomUtil["addClass"](aImg[1], this["getBarClass"](this["sBarColor"]));
		}
		aImg[2]["style"]["width"] = 100 - Math["round"](10000 / iPercentValue) + "%";
	}

	this["iPercentValue"] = iPercentValue;
	this["setClientProperty"]("PercentValue", this["iPercentValue"], true);
	this["updateImageStyles"]();
	this["updateTextStyles"]();
	this["updateTitle"]();

};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["setPercentValue"] = 0; };

/**
 * Set the ShowValue
 * @param { boolean } bShowValue for a ProgressIndicator
 * @public
 */
UCF_ProgressIndicator["prototype"]["setShowValue"] = function(bShowValue) {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["setShowValue"]++; }; 
	/** @type {HTMLDivElement} */
	var aDiv = this["oDomRef"]["getElementsByTagName"]("DIV");

	if (bShowValue) {
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](aDiv[0], UCF_XSSEncoder["encodeHTML"](this["sDisplayValue"]));
	} else {
		UCF_DomUtil["setInnerHtml"](aDiv[0], "&nbsp;");
	}
	this["bShowValue"] = bShowValue;
	this["setClientProperty"]("ShowValue", this["bShowValue"], true);
};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["setShowValue"] = 0; };

/**
 * Set the DisplayValue
 * @param { string } sDisplayValue for a ProgressIndicator
 * @public
 */
UCF_ProgressIndicator["prototype"]["setDisplayValue"] = function(sDisplayValue) {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["setDisplayValue"]++; }; 
	this["sDisplayValue"] = sDisplayValue;
	this["setClientProperty"]("DisplayValue", this["sDisplayValue"], true);
	/** @type {HTMLDivElement} */
	var aDiv = this["oDomRef"]["getElementsByTagName"]("DIV");

	if (this["bShowValue"]) {
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](aDiv[0], UCF_XSSEncoder["encodeHTML"](this["sDisplayValue"]));
	} else {
		UCF_DomUtil["setInnerHtml"](aDiv[0], "&nbsp;");
	}
	this["updateTitle"]();
};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["setDisplayValue"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ProgressIndicator["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ProgressIndicator.js(401): onlsaccessibility"); };
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSourceControl"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	//Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this);
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

	oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](oSource["oDomRef"]));
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["setControlType"]("PRI");

	switch (this["sBarColor"]) {
		case "POSITIVE":
			oAccessibilityHelper["addSemantic"]("POSITIVE");
			break;
		case "CRITICAL":
			oAccessibilityHelper["addSemantic"]("CRITICALVALUE");
			break;
		case "NEGATIVE":
			oAccessibilityHelper["addSemantic"]("NEGATIVE");
			break;
	}

};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["onlsaccessibility"] = 0; };

UCF_ProgressIndicator["prototype"]["updateValues"] = function(oUpdate) {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["updateValues"]++; }; 
	if (!oUpdate) return;

	try {
		if (typeof oUpdate === 'string') {
			oUpdate = UCF_JsUtil["oJsonParse"](oUpdate);
		}
	} catch (ex) {}

	if (oUpdate["TEXT"])
		this["setDisplayValue"](oUpdate["TEXT"]);
	if (oUpdate["PERCENTAGE"] || oUpdate["PERCENTAGE"] === 0)
		this["setPercentValue"](oUpdate["PERCENTAGE"]);
	if (oUpdate["BARCOLOR"])
		this["setBarColor"](oUpdate["BARCOLOR"]);

};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["updateValues"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ProgressIndicator["prototype"]["aAttributeNames"] = ["sWidth","iPercentValue","sDisplayValue","bShowValue","sBarColor","sTooltip","sVisibility","sWebsocketId","sCustomData","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ProgressIndicator["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ProgressIndicator["prototype"]["aMethodNames"] = ["updateValues","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_ProgressIndicator["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {number}
 */
UCF_ProgressIndicator["prototype"]["iPercentValue"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_ProgressIndicator["prototype"]["sDisplayValue"] = '0';

/**
 * @private
 * @type {boolean}
 */
UCF_ProgressIndicator["prototype"]["bShowValue"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ProgressIndicatorBarColor}
 */
UCF_ProgressIndicator["prototype"]["sBarColor"] = "NEUTRAL";

/**
 * @private
 * @type {string}
 */
UCF_ProgressIndicator["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ProgressIndicator["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ProgressIndicator["prototype"]["sWebsocketId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ProgressIndicator["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ProgressIndicator["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ProgressIndicator["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["setDefaultValues"]++; }; 
	this["sWidth"] = '';
	this["iPercentValue"] = 0;
	this["sDisplayValue"] = '0';
	this["bShowValue"] = true;
	this["sBarColor"] = "NEUTRAL";
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sWebsocketId"] = '';
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("PercentValue", 0, true);
		this["setClientProperty"]("DisplayValue", '0', true);
		this["setClientProperty"]("ShowValue", true, true);
		this["setClientProperty"]("BarColor", "NEUTRAL", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("WebsocketId", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ProgressIndicator["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_ProgressIndicator.prototype["aPublicMethods"] = ["setBarColor","setPercentValue","setShowValue","setDisplayValue"].concat(UCF_ProgressIndicator.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_PropertyBinding"] = function() {/* global UCF_Binding */
/// <reference path="./Binding.js"/>

/**
 * Constructor for PropertyBinding
 *
 *
 * The PropertyBinding is used to access single data values in the data model.
 *
 * @public
 * @class
 * @param {UCF_Model} oModel
 * @param {string} sPath
 * @param {Object} oContext
 * @param {Map} mParameters
 */
function UCF_PropertyBinding(oModel, sPath, oContext, mParameters) {if (__UCF_COVERAGE__) { UCF_PropertyBinding["_"]["UCF_PropertyBinding"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Binding["apply"](this, arguments);
	}
};window["UCF_PropertyBinding"] = UCF_PropertyBinding; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PropertyBinding"); UCF_PropertyBinding["_"] = {UCF_PropertyBinding: 0}; }; ;
UCF_PropertyBinding["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Binding"))(); UCF_PropertyBinding.prototype["sClassName"] = "UCF_PropertyBinding";

// the 'abstract methods' to be implemented by child classes
/**
 * @public
 * @function
 * @name UCF_PropertyBinding.prototype.getValue
 * @return {Object} the current value of the bound target
 */

/**
 * Sets the value for this binding. A model implementation should check if the
 * current default binding mode permits setting the binding value and if so set
 * the new value also in the model.
 *
 * @public
 * @function
 * @name UCF_PropertyBinding.prototype.setValue
 * @param {Object} oValue the value to set for this binding
 */
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PropertyBinding["prototype"]["aAttributeNames"] = [];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PropertyBinding["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PropertyBinding["prototype"]["aMethodNames"] = [];


//#JSCOVER_EXCL_START
/** @protected */
UCF_PropertyBinding["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PropertyBinding["_"]["setDefaultValues"]++; }; 
	

	if (this["getClientControl"]() && !this["bKeepAlive"]) ;
};;if (__UCF_COVERAGE__) { UCF_PropertyBinding["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_PropertyBinding.prototype["aPublicMethods"] = ["UCF_PropertyBinding"].concat(UCF_PropertyBinding.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_QuickView"] = function() {/* global _assert, _trace, DEBUG, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * QuickView control implementation
 *
 * @class
 * @extends UCF_LayeredControl
 * 
 * @param {HTMLElement} oDomRef The DOM reference
 * @param {UCF_LS} oLS The LS instance
 */
function UCF_QuickView(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_QuickView["_"]["UCF_QuickView"]++; }; 
	if (arguments["length"] === 0) {
		return;
	}
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "QuickView.js(39): handleMouseMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "QuickView.js(40): handleMouseMove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "QuickView.js(41): handleMouseMove"); };

	UCF_LayeredControl["apply"](this, [oDomRef, oLS]);

	if (this["sBehavior"] === "DEFAULT") {
		this["bKeepAlive"] = true;
	}

	this["bQuickViewOrOpenerHovered"] = false;
	this["bQuickViewHovered"] = false;
	this["bChildLayerHovered"] = false;
	this["bEnhancePopupWindows"] = true;

	// If mouse is currently inside opener control and QuickView frame including
	// frame of currently opened child layers (e.g. PopuMenu)
	this["bHoverInside"] = false; // eslint-disable-line @ur/no-memory-leaks

	// Tell base class that QuickView may contain other "child" layered controls
	this["bIsParent"] = true;

	if (this["sBehavior"] === "POPOVER") {
		if (this["sPopOverAlignment"] === 'TOP_LEFT_CONTAINER') {
			this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["TOPLEFT_CONTAINER"]);
		} else {
			this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);
		}
	} else {
		this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"]);
	}
	if (window["UCF_System"]["sInteractionType"] === 'TOUCH') {
		this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMCENTER"]);
	}
	this["setMoveIntoViewPortXY"](true, true);

	// Take into account possible box-shadows and/or scrollbars for the "move into view port" algorith.
	this["setSafetyDistance"](UCF_LayeredControl["MIN_BORDER_DISTANCE"]);

	this["iEventTS"] = null; // eslint-disable-line @ur/no-memory-leaks
	this["bContentReady"] = false; // QV content was delivered and contentReady() called.
	this["bCloseFired"] = true; // Remember state of Content-Access/Close event pairs when open/closed via mouse (NOT used for hotkey)

	this["bOpenedByKeyboard"] = false; // eslint-disable-line @ur/no-memory-leaks
	this["bMoveFocus"] = false;
	this["bAvoidImmediateClose"] = false;
	this["iStoreZIndex"] = null;
	this["sMyPopupId"] = null;

	// "Parse" the hotkey parameter...
	this["oHotkey"] = {};
	this["oHotkey"]["bCtrl"] = (this["sOpenHotkey"]["indexOf"]("CTRL") > -1);
	this["oHotkey"]["bShift"] = (this["sOpenHotkey"]["indexOf"]("SHIFT") > -1);
	this["oHotkey"]["bAlt"] = false; // Not supported for Hotkeys in LS
	var sTemp = this["sOpenHotkey"]["split"]("_");
	this["oHotkey"]["iKeyCode"] = UCF_KeyCodes[sTemp[sTemp["length"] - 1]];
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "OpenHotkey code=" + this["oHotkey"]["iKeyCode"], "QuickView.js(95): handleMouseMove"); };

	/** @type {UCF_LayerHelper} */
	this["oLayerHelper"] = null;
	if (this["sBehavior"] === "DEFAULT") {
		oLS["attachEvent"](oLS["E_EVENTS"]["Lock"], this, "onLock");
	} else if (this["sBehavior"] === "POPOVER") {
		this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
		this["oLayerHelper"] = UCF_ClassLoader["oGetClass"]("UCF_LayerHelper")["create"](this);
	}

	if (this["sBehavior"] !== "POPOVER") {
		/** @type {UCF_PopupManager} */
		var oPM = this["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]();
		oPM["attachEvent"](oPM["E_EVENTS"]["PopupOpen"], this, 'handlePopupOpenClose');
		oPM["attachEvent"](oPM["E_EVENTS"]["PopupClose"], this, 'handlePopupOpenClose');
		oPM["attachEvent"](oPM["E_EVENTS"]["WindowOpen"], this, 'handlePopupOpenClose');
		oPM["attachEvent"](oPM["E_EVENTS"]["WindowClose"], this, 'handlePopupOpenClose');

		this["sCloseTimerId"] = null;
		var _this = this;
		this["handleMouseMove"] = function(oDomEvent) {
			// Use same logic as onmouseout() and notifyChildLayerMouseOut() for
			// mousemoves outside the QV and opener. This handles very special cases
			// (slow backend, opening external windows) where the QV ends up opened with
			// the mouse-pointer outside of the opener and QV.
			if (_this["bOpened"]) {
				var oSource = oDomEvent["srcElement"] || oDomEvent["target"] || oDomEvent["currentTarget"];
				_this["bChildLayerHovered"] = _this["bIsNestedLayer"](oSource);
				if (!_this["sCloseTimerId"] &&
					!UCF_DomUtil["bContains"](_this["oRootRef"], oSource) &&
					!UCF_DomUtil["bContains"](_this["oOpenerRef"], oSource)) {
					_this["bQuickViewOrOpenerHovered"] = false;
					_this["updateHoverState"]();
				}
			}
		};
		UCF_DomUtil["attachEvent"](window["document"], 'mousemove', this["handleMouseMove"]);
	}
};window["UCF_QuickView"] = UCF_QuickView; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_QuickView"); UCF_QuickView["_"] = {UCF_QuickView: 0}; }; ;
UCF_QuickView["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_QuickView.prototype["sClassName"] = "UCF_QuickView";

/**
 * Note: PRELOAD value must be higher than CLOSE !
 * Because WDA backend depends on always receiving close events. If QV1 is open and you quickly hover
 * to QV2, then QV2 would send an ContentAccess event before QV1 close timer is up.
 * @private
 */
UCF_QuickView["TIMEOUTS"] = {
	"CLOSE": 300,
	"OPEN": 700,
	"PRELOAD": 400,
	"AVOID_IMMEDIATE_CLOSE": 200
};

/**
 * @private
 */
UCF_QuickView["prototype"]["handlePopupOpenClose"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["handlePopupOpenClose"]++; }; 
	this["closeAndFireClose"]();
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["handlePopupOpenClose"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["handleRichTooltipInit"] = function(oOpenerDomRef) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["handleRichTooltipInit"]++; }; 
	if (this["sBehavior"] !== 'POPOVER' && window["UCF_System"]["bIsAria"]) {
		var sHotkey = this["sOpenHotkey"]["replace"](/_/g, "+");
		UCF_AriaStateHelper["addLabel"](oOpenerDomRef, this["oLS"]["sGetText"]("SAPUR_QV_TUT", [sHotkey]));
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["handleRichTooltipInit"] = 0; };

/**
 * Do not remove tooltip from DOM in UCF_Control.initializeRichTooltip()
 * @return {boolean} Keep tooltip or not
 * @private
 */
UCF_QuickView["prototype"]["bKeepTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["bKeepTooltip"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["bKeepTooltip"] = 0; };

UCF_QuickView["prototype"]["onLock"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onLock"]++; }; 
	// If a very fast user manages to trigger a roundtrip before the 300ms close-timeout is over we must also close a QV
	if (this["sBehavior"] !== 'POPOVER' && this["bOpened"] && this["sCloseTimerId"]) {
		this["closeAndFireClose"]();
	}
	UCF_JsUtil["clearDelayedCall"](this["sPreloadTimerId"]);
	UCF_JsUtil["clearDelayedCall"](this["sOpenTimerId"]);
	UCF_JsUtil["clearDelayedCall"](this["sCloseTimerId"]);
	this["sCloseTimerId"] = this["sOpenTimerId"] = this["sPreloadTimerId"] = null; // eslint-disable-line @ur/no-memory-leaks
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onLock"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["initialize"]++; }; 
	if (this["sPopOverOpenAtControl"]) {
		this["oParentPopup"] = this["oGetParentPopupWindow"](UCF_DomUtil["$"](this["sPopOverOpenAtControl"]));
		if (this["oParentPopup"]) {
			// Delay is needed also because PW z-indices might be calculated at the end of the
			// control-initialize loop during an update. The UCF_LayerHelper needs the final PW z-index value.
			UCF_JsUtil["delayedCall"](0, this, "openAtControl", [this["sPopOverOpenAtControl"], true]);
		} else {
			this["openAtControl"](this["sPopOverOpenAtControl"], this["bPopOverFocusContent"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["initialize"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["bIsInitial"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["bIsInitial"]++; }; 
	return (this["oDomRef"]["tagName"] === "XMP");
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["bIsInitial"] = 0; };

/**
 * Opens the QuickView, assuming that the content was rendered initially or already loaded.
 * @param {boolean} bKeyboard true: Focus the first element with tab-index >= 0 inside content, which should usually be the title (if Is508=true).
 * @public
 */
UCF_QuickView["prototype"]["show"] = function(bKeyboard) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["show"]++; }; 
	if (typeof(bKeyboard) === "boolean") {
		this["bOpenedByKeyboard"] = bKeyboard;
	}
	if (this["sBehavior"] === "DEFAULT" && this["bIsInitial"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "QuickView content not available.", "QuickView.js(220): show"); };
		return;
	}
	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	this["openBase"](); // Note: setPosition() is called!
	this["setParentLayerOpened"](true);

	// Focus the first element with tabindex >= 0 inside content
	// (Note: this.focusFirstChildControl() Does not work because it finds the TrackSwitch
	// control which is contained before any "real" content)
	if (this["bOpenedByKeyboard"]) {
		var oFC = UCF_DomUtil["firstChild"](UCF_DomUtil["$"](this["sId"] + "-cntbox"));
		if (oFC) {
			var oFocusMe = UCF_DomUtil["oGetTabbableElementForward"](oFC, false);
			if (oFocusMe) {
				var _this = this;
				UCF_JsUtil["delayedCall"](0, {
					"h": function() {
						_this["bMoveFocus"] = true; // Suppress onlsblur handling
						UCF_DomUtil["focusDomElement"](oFocusMe);
					}
				}, 'h');
			}
		}
	}

	// Need same workaround as PopupMenu
	this["bAvoidImmediateClose"] = true;
	UCF_JsUtil["delayedCall"](UCF_QuickView["TIMEOUTS"]["AVOID_IMMEDIATE_CLOSE"], this, "resetImmediateClose");

	this["bCloseFiredForAnyEvent"] = false;
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["show"] = 0; };

UCF_QuickView["prototype"]["resetImmediateClose"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["resetImmediateClose"]++; }; 
	this["bAvoidImmediateClose"] = false;
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["resetImmediateClose"] = 0; };

UCF_QuickView["prototype"]["bIEQuirks"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["bIEQuirks"]++; }; 
	return (window["UCF_System"]["sDevice"] !== "standards" && UCF_UserAgent["bIsIE"]());
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["bIEQuirks"] = 0; };

/**
 * Report that the content was delivered via control update, triggered by an ContentAccesss event
 * (Only for parameter Preload=true).
 * The QV will be shown when the open-timeout is reached. If the time is already up it will be shown immediately.
 *
 * @public
 */
UCF_QuickView["prototype"]["contentReady"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["contentReady"]++; }; 
	if (this["sBehavior"] === "POPOVER") return;

	//console.log(">>> cr: locked=" + this.oLS.bLocked());

	// see fOpenByTouchContextMenu()
	if (this["bOpenByTouchContextMenu"]) {
		this["show"]();
		return;
	}

	if (this["iEventTS"] == null) return;

	var iNow = new Date()["getTime"]();
	var iTime = iNow - this["iEventTS"];

	if (iTime >= UCF_QuickView["TIMEOUTS"]["OPEN"]) {
		this["show"]();
	} else {
		// Trigger show() with remaining time
		// Note: open-timer can still be stopped if the user hovers outside the opener control or interacts with the opener.
		this["bContentReady"] = true;
		this["sOpenTimerId"] = UCF_JsUtil["delayedCall"](UCF_QuickView["TIMEOUTS"]["OPEN"] - iTime, this, "onOpenTimeOut");
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["contentReady"] = 0; };

/**
 * Overwrite function in LayeredConteol to add drop shadow.
 * @private
 */
UCF_QuickView["prototype"]["addClassesOnOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["addClassesOnOpen"]++; }; 
	var oContentDiv = UCF_DomUtil["$"](this["sId"] + "-cnt");
	if (oContentDiv) {
		if (!UCF_DomUtil["bHasClass"](oContentDiv, UCF_LayeredControl["BOX_SHADOW_CLASS"])) {
			UCF_DomUtil["addClass"](oContentDiv, UCF_LayeredControl["BOX_SHADOW_CLASS"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["addClassesOnOpen"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_QuickView["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["destroy"]++; }; 
	if (this["oLS"] == null) return;
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this);
	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"], this);
	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	this["sCloseTimerId"] = null;
	this["sOpenTimerId"] = null;
	this["sPreloadTimerId"] = null;
	if (this["sBehavior"] === "POPOVER") {
		this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this);
		this["oLayerHelper"]["destroy"]();
		this["oLayerHelper"] = null;
	}
	else {
		if (this["oLS"]["oGetMainLS"]()) {
			/** @type {UCF_PopupManager} */
			var oPM = this["oLS"]["oGetMainLS"]()["oGetPopupManagerInternal"]();
			oPM["detachEvent"](oPM["E_EVENTS"]["PopupOpen"], this);
			oPM["detachEvent"](oPM["E_EVENTS"]["PopupClose"], this);
			oPM["detachEvent"](oPM["E_EVENTS"]["WindowOpen"], this);
			oPM["detachEvent"](oPM["E_EVENTS"]["WindowClose"], this);
		}
	}
	this["oParentPopup"] = null;
	if (this["sBehavior"] !== "POPOVER") {
		UCF_DomUtil["detachEvent"](window["document"], "mousemove", this["handleMouseMove"]);
		this["handleMouseMove"] = null;
	}
	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["destroy"] = 0; };

/**
 * Sets the control id of the control that opened the QuickView
 *
 * @param {string} sId
 */
UCF_QuickView["prototype"]["setOpenerId"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["setOpenerId"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) === "string", "typeof(sId) === \"string\"", "QuickView.js(349): setOpenerId"); };
	this["sOpenerId"] = sId; // eslint-disable-line @ur/no-memory-leaks
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["setOpenerId"] = 0; };

/**
 * May happen when click on opener triggers a page update while QV is open.
 * It will be closed because it is removed (and replaced by initial QV with XMP tag) in the DOM by the page update.
 * In this case close() or destroy() are NOT called, because this.bKeepAlive = true
 * @private
 */
UCF_QuickView["prototype"]["reconnectToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["reconnectToDom"]++; }; 
	UCF_LayeredControl.prototype["reconnectToDom"]["apply"](this, arguments);

	if (this["sBehavior"] === "POPOVER") return;

	// QV is closed but replacement is not initial but has content
	// AND it is re-opened immediately be show() in update-script-call
	// => The opener-DOM-reference will be invalid. We have to assume that the ID is the same !
	var oOpenerRef = UCF_DomUtil["$"](this["sOpenerId"]);
	if (oOpenerRef) this["setOpenerRef"](oOpenerRef);

	UCF_JsUtil["clearDelayedCall"](this["sPreloadTimerId"]);
	UCF_JsUtil["clearDelayedCall"](this["sOpenTimerId"]);
	UCF_JsUtil["clearDelayedCall"](this["sCloseTimerId"]);
	this["sCloseTimerId"] = this["sOpenTimerId"] = this["sPreloadTimerId"] = null;
	this["setOpened"](false); // Note: Also releases blind-layer !!
	this["bQuickViewOrOpenerHovered"] = false;
	this["bQuickViewHovered"] = false;
	this["bChildLayerHovered"] = false;
	this["bHoverInside"] = false;
	this["bContentReady"] = false;
	this["setParentLayerOpened"](false);
	this["oChildLayer"] = null;
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["reconnectToDom"] = 0; };

/**
 * Handles the hotkey event.
 * Note: QuickView is also a delegate for the opener control !
 * @private
 */
UCF_QuickView["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onlshotkey"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "QuickView.js(390): onlshotkey"); };

	// ESC pressed on opener OR inside QuickView
	var iKeyCode = oBrowserEvent["iKeyCode"]();
	if (iKeyCode === UCF_KeyCodes["ESCAPE"]) {
		if (this["sBehavior"] === "POPOVER") {
			if (this["bPopOverCloseEvent"]) {
				try {
					if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "activeElement: " + document["activeElement"]["id"], "QuickView.js(398): onlshotkey"); };
				} catch (e) {}
				this["fireClose"](this["sId"], true);
			}
		} else {
			this["closeAndFireClose"](false);
		}
	} else if (iKeyCode === this["oHotkey"]["iKeyCode"] &&
		oBrowserEvent["bCtrl"]() === this["oHotkey"]["bCtrl"] &&
		oBrowserEvent["bShift"]() === this["oHotkey"]["bShift"] &&
		oBrowserEvent["bAlt"]() === this["oHotkey"]["bAlt"]) {

		// Hot-key is pressed on opener control => show or send event
		if (UCF_DomUtil["bContains"](this["oOpenerRef"], oBrowserEvent["oGetSource"]())) {
			if (this["bOpened"]) {
				this["closeAndFireClose"](false, true);
			} else {
				// Note: Framework must call show(true) in page update
				this["fireKeyboardContentAccess"](this["sId"]);

				// TODO:It is no longer possible to open server-side rendered QuickViews via Hot-key,
				// which is currently NOT used by WDA - WDA always uses ContentAccess event.
				//
				// if (this.bIsInitial() || this.bAlwaysSendKCAEvent) {
				// 	this.fireKeyboardContentAccess(this.sId);
				// }
				// else {
				// 	this.show(true);
				// }
			}
		} else {
			// Hot-key used inside QuickView => close
			this["closeAndFireClose"](false);
		}
	}

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onlshotkey"] = 0; };

/**
 * Return true if the given DOM element is inside a nested LayeredControl of this QuickView/Popover (e.g. a PopupMenu or ComboBoxListBox)
 * @param {HTMLElement} oSourceDomRef
 * @return {boolean}
 */
UCF_QuickView["prototype"]["bIsNestedLayer"] = function(oSourceDomRef) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["bIsNestedLayer"]++; }; 
	return this["bIsParentLayer"]() && this["oChildLayer"] && this["oChildLayer"]["oRootRef"] && UCF_DomUtil["bContains"](this["oChildLayer"]["oRootRef"], oSourceDomRef);
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["bIsNestedLayer"] = 0; };

/**
 * Handles all events
 * @private
 * @param {UCF_Event} oEvent the event object
 */
UCF_QuickView["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onAnyEvent"]++; }; 
	var oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent");
	var oSourceRoot = oBrowserEvent["oGetSourceRoot"]();
	var oSource = oBrowserEvent["oGetSource"]();
	var sName = oBrowserEvent["sGetName"]();

	if (this["sBehavior"] === "POPOVER") {
		if (this["bPopOverCloseEvent"]) {
			var bHandleScrollEvent = UCF_UserAgent["bIsFirefox"]();
			// Do not close when behind blocklayer of a (DIV) popup
			var bIsBehindBlockLayer = this["oLayerHelper"] && this["oLayerHelper"]["bIsBehindBlockLayer"]();
			//var bTouch = UCF_System.sInteractionType === 'TOUCH';
			//if (!bTouch && sName === "click" || bTouch && sName === "touchstart") {
			if (sName === "mousedown" || sName === "touchstart") {
				if (!oSourceRoot || oSourceRoot === document) {
					this["fireClose"](this["sId"], false);
				} else if (!UCF_DomUtil["bContains"](this["oDomRef"], oSource)) {
					// close when clicking outside PopOver, but not when interacting with the opener
					// Do not close if the user interacts with currently opened "child" LayeredControl	(e.g. selecting a ListBox item)
					// Do not close if there is a modal DIV-popup (in an IFrame-popup no events will be dispatched to the main page!) AND this Popover is NOT inside the top-most popup
					var bSourceIsNestedLayer = this["bIsNestedLayer"](oSource);
					if (!(bSourceIsNestedLayer || bIsBehindBlockLayer) && !this["bCloseFiredForAnyEvent"]) {
						this["bCloseFiredForAnyEvent"] = true;
						this["fireClose"](this["sId"], false);
					}
				}
			} else if (!this["bAvoidImmediateClose"] && (sName === "mousewheel" || sName === "scroll" && bHandleScrollEvent)) {
				if (!UCF_DomUtil["bContains"](this["oDomRef"], oSource)) {
					// Do not close if the user interacts with currently opened "child" LayeredControl	(e.g. scrolling inside a ListBox)
					bSourceIsNestedLayer = this["bIsNestedLayer"](oSource);
					// Hack: Do not close for certain known scroll events that are caused
					//  		 during mouseover of other controls
					if (!(bSourceIsNestedLayer || bIsBehindBlockLayer) && !this["bCloseFiredForAnyEvent"]) {
						this["bCloseFiredForAnyEvent"] = true;
						this["fireClose"](this["sId"], false);
					}
				}
			}
		}
	} else {
		if (sName === "lsfocuslost") {
			// Close if current browser window looses focus
			this["closeAndFireClose"](false);
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		} else if (this["bCloseOnTyping"] === true && (sName === "keypress" || sName === "keydown")) {
			if (!UCF_DomUtil["bContains"](this["oOpenerRef"], oSource) && !UCF_DomUtil["bContains"](this["oDomRef"], oSource)) {
				// Close if any key is pressed outside the QV and its opener
				this["closeAndFireClose"](false);
			}
		} else if (sName === 'touchstart') {
			if (!UCF_DomUtil["bContains"](this["oDomRef"], oSource) && !this["bIsNestedLayer"](oSource)) {
				this["closeAndFireClose"](false);
			}
		}
		else if (sName === 'lsescape') {
			// Must close with ESC without having the focus: WDAUIUR1-2427
			var iKeyCode = oBrowserEvent["iKeyCode"]();
			if (iKeyCode === UCF_KeyCodes["ESCAPE"]) {
				this["closeAndFireClose"](false);
				oBrowserEvent["cancel"]();
			}
		}
		else if ((sName === "mousewheel" || sName === "scroll" || sName === 'DOMMouseScroll') && !this["bQuickViewHovered"]) {
			// Send Close when scroll event is caught outside QV (but also on the opener)
			// Example: Opener is a SapTable cell -> use mousewheel on the cell -> Close
			this["closeAndFireClose"](false);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onAnyEvent"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["onlsdrag"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onlsdrag"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "QuickView.js(527): onlsdrag"); };

	if (this["sBehavior"] === "POPOVER") return;

	if (this["bOpened"]) {
		this["closeAndFireClose"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onlsdrag"] = 0; };

/**
 * Note: QuickView is also a delegate for the opener control !
 * @private
 */
UCF_QuickView["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onlsblur"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "QuickView.js(541): onlsblur"); };

	if (this["sBehavior"] === "POPOVER") return;

	if (this["bOpened"] && this["bOpenedByKeyboard"] && UCF_DomUtil["bContains"](this["oOpenerRef"], oBrowserEvent["oGetSource"]())) {
		if (this["bMoveFocus"]) {
			// blur was caused by moving focus inside QV in show()
			this["bMoveFocus"] = false;
			return;
		}
		this["closeAndFireClose"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onlsblur"] = 0; };

/**
 * Note: QuickView is also a delegate for the opener control !
 * @private
 */
UCF_QuickView["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "QuickView.js(560): onmouseover"); };

	// Ignore emulated mouseover events in mobile-Chrome and do not open QuickView,
	// because we want to utilize our touch-contextmenu like on iPad
	if (this["sBehavior"] === "POPOVER" ||
		oBrowserEvent["bIsTouchInteraction"]() && !UCF_UserAgent["bIsSafari"]()) return;

	// Special case for scroll/mousewheel event handling in onAnyEvent()
	if (UCF_DomUtil["bContains"](this["oRootRef"], oBrowserEvent["oGetSource"]())) {
		if (!(this["bContentReady"] && this["sOpenTimerId"] && !this["bOpened"])) {
			this["bQuickViewHovered"] = true;
		}
	}

	if (UCF_DomUtil["bContains"](this["oRootRef"], oBrowserEvent["oGetSource"]()) ||
		UCF_DomUtil["bContains"](this["oOpenerRef"], oBrowserEvent["oGetSource"]())) {
		if (this["bContentReady"] && this["sOpenTimerId"] && !this["bOpened"]) {
			return;
		}
		this["bQuickViewOrOpenerHovered"] = true;
		this["updateHoverState"]();
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onmouseover"] = 0; };

/**
 * Note: QuickView is also a delegate for the opener control !
 * @private
 */
UCF_QuickView["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "QuickView.js(589): onmouseout"); };

	if (this["sBehavior"] === "POPOVER" || UCF_UserAgent["bIsAndroid"]()) return;

	if (!UCF_DomUtil["bContains"](this["oRootRef"], oBrowserEvent["oGetSource"]())) {
		this["bQuickViewHovered"] = false;
	}

	if (UCF_DomUtil["bContains"](this["oRootRef"], oBrowserEvent["oGetSource"]()) ||
		UCF_DomUtil["bContains"](this["oOpenerRef"], oBrowserEvent["oGetSource"]())) {
		this["bQuickViewOrOpenerHovered"] = false;
		this["updateHoverState"]();
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onmouseout"] = 0; };

/**
 * Note: QuickView is also a delegate for the opener control !
 * @private
 */
UCF_QuickView["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "QuickView.js(609): onmousedown"); };

	if (this["sBehavior"] === "POPOVER") return;

	// If left or right mouse button is used on opener (e.g. click on link to navigate)
	// 1. Cancel preload- and open-timer
	// 2. Close immediately if open
	if (UCF_DomUtil["bContains"](this["oOpenerRef"], oBrowserEvent["oGetSource"]())) {
		UCF_JsUtil["clearDelayedCall"](this["sOpenTimerId"]);
		UCF_JsUtil["clearDelayedCall"](this["sPreloadTimerId"]);
		this["sOpenTimerId"] = this["sPreloadTimerId"] = null;
		if (this["bContentReady"]) {
			this["fireClose"](this["sId"], false);
			this["bContentReady"] = false;
			this["bCloseFired"] = true;
		} else if (this["bOpened"]) {
			this["closeAndFireClose"](false);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onmousedown"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["notifyChildLayerMouseOver"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["notifyChildLayerMouseOver"]++; }; 
	if (this["sBehavior"] === "POPOVER") return;

	this["bChildLayerHovered"] = true;
	this["updateHoverState"]();
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["notifyChildLayerMouseOver"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["notifyChildLayerMouseOut"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["notifyChildLayerMouseOut"]++; }; 
	if (this["sBehavior"] === "POPOVER") return;

	this["bChildLayerHovered"] = false;
	this["updateHoverState"]();
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["notifyChildLayerMouseOut"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["updateHoverState"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["updateHoverState"]++; }; 
	this["bHoverInside"] = this["bQuickViewOrOpenerHovered"] || this["bChildLayerHovered"];

	if (!this["bHoverInside"]) {
		UCF_JsUtil["clearDelayedCall"](this["sPreloadTimerId"]);
		UCF_JsUtil["clearDelayedCall"](this["sOpenTimerId"]);
		this["sOpenTimerId"] = this["sPreloadTimerId"] = null;
		// Note: WDA also needs a Close event when the user "cancels" the opening (moves the mouse away)
		// after content was delivered but the open timeout value is not reached.
		if (this["bOpened"] || this["bContentReady"]) {
			this["sCloseTimerId"] = UCF_JsUtil["delayedCall"](UCF_QuickView["TIMEOUTS"]["CLOSE"], this, "onCloseTimeOut");
		}
	} else {
		UCF_JsUtil["clearDelayedCall"](this["sCloseTimerId"]);
		this["sCloseTimerId"] = null;
		if (!this["bOpened"]) {
			if (this["bPreload"]) {
				this["sPreloadTimerId"] = UCF_JsUtil["delayedCall"](UCF_QuickView["TIMEOUTS"]["PRELOAD"], this, "onContentAccessEventTimeOut");
			} else {
				this["sOpenTimerId"] = UCF_JsUtil["delayedCall"](UCF_QuickView["TIMEOUTS"]["OPEN"], this, "onOpenTimeOut");
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["updateHoverState"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["onContentAccessEventTimeOut"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onContentAccessEventTimeOut"]++; }; 
	if (this["bIsDestroyed"]) return;
	if (!UCF_DomUtil["$"](this["sId"])) return; // Strange things can happen in QuickView-Land

	this["iEventTS"] = new Date()["getTime"]();
	if (!this["bCloseFired"]) {
		// As a last fallback insert close event in queue before sending ContentAccess because
		// WDA will dump if ContentAccess/Close event pairs are not correct !!
		this["fireClose"](this["sId"], false);
	}
	this["fireContentAccess"](this["sId"]);
	// Note: Now expecting a contentReady() call in page update...
	this["bCloseFired"] = false;
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onContentAccessEventTimeOut"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["onOpenTimeOut"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onOpenTimeOut"]++; }; 
	// Assuming that the content is rendered initially OR already loaded.
	this["bContentReady"] = false;
	this["show"]();
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onOpenTimeOut"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["onCloseTimeOut"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onCloseTimeOut"]++; }; 
	this["closeAndFireClose"](false);
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onCloseTimeOut"] = 0; };

/**
 * Close QuickView/Popover if it is currently opened.
 * @public
 */
UCF_QuickView["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["close"]++; }; 
	if (this["sBehavior"] === "DEFAULT" && this["bIsInitial"]()) {
		return;
	}
	if (UCF_DomUtil["$"](this["sId"]) == null) {
		return;
	}

	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	if (this["oChildLayer"]) {
		this["oChildLayer"]["close"]();
	}

	this["bContentReady"] = false;
	this["setParentLayerOpened"](false);

	UCF_LayeredControl.prototype["close"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["close"] = 0; };

/**
 * Calls this.close() and handles focus and 'Close' event.
 * @private
 * @param {boolean} bNoResetFocus If QV was opened via keyboard do NOT set the focus back on the opener (when called by onlsblur()).
 * @param {boolean} [bKeyboard] Closed via hotkey
 */
UCF_QuickView["prototype"]["closeAndFireClose"] = function(bNoResetFocus, bKeyboard) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["closeAndFireClose"]++; }; 
	// Do not proceed (do NOT send Close event) if in wrong state
	if (this["sBehavior"] === "DEFAULT" && !(this["bOpened"] || this["bContentReady"])) {
		return;
	}
	this["close"]();
	if (this["bOpenedByKeyboard"] && !bNoResetFocus) {
		// Reset the focus to the opener
		this["bOpenedByKeyboard"] = false;
		UCF_DomUtil["focusDomElement"](this["oOpenerRef"]);
	}
	// Note: The bCloseFired flag is only relevant for ContentAccess event
	// which is only used for mouse/hover NOT for hotkey
	if (this["sBehavior"] === "DEFAULT" && this["bPreload"] && this["bCloseFired"] && bKeyboard !== true) {
		// Do NOT fire close twice until the flag is cleared - in onContentAccessTimeout()
		// Example: A navigation is triggered inside a QV which opens a new Tab.
		//  Then the mouse is moved outside the QV immediately after the click.
		//  The navigation request takes some time (>300ms), so that the close-timer is triggered.
		//  This close event is then added to the event-queue but it is never sent to WDA (!)
		//  When the user returns from the new Tab the mouse events outside the QV trigger the
		//  close, but we must not add another event to the queue.
		//  It is the only possible way to fix this here, because there are "missing" mouse
		//  events because of the navigation, to handle the hover-state properly.
		return;
	}
	if (this["sBehavior"] === "DEFAULT" && this["bPreload"] || this["sBehavior"] === "POPOVER") {

		console["trace"](">>>>> fireClose: " + this["sId"] + " destroyed=" + this["bIsDestroyed"] + " locked=" + this["oLS"]["bLocked"]() + " " + this["sOpenTimerId"] + " " + this["sCloseTimerId"]);

		this["fireClose"](this["sId"], false);
		if (this["sBehavior"] === "DEFAULT" && bKeyboard !== true) {
			this["bCloseFired"] = true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["closeAndFireClose"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["remove"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["remove"]++; }; 
	// Called by UCF_Control.removeRichTooltip();
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["remove"] = 0; };

/**
 * Adds parameters to identify the control by the template id and the binding path.
 * For a QuickView the information is not in the control itself but in the bound OpenerRef
 */
UCF_QuickView["prototype"]["enrichSemanticEventParamsWithBindingContext"] = function(mParams, sName, oClientControl) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["enrichSemanticEventParamsWithBindingContext"]++; }; 
	if (this["oOpenerRef"]) {
		var oSourceControl = this["oGetControlByDomRef"](this["oOpenerRef"], false);
		if (oSourceControl) {
			oClientControl = oSourceControl["getClientControl"]();
			if (oClientControl) {
				UCF_Control["prototype"]["enrichSemanticEventParamsWithBindingContext"]["apply"](this, [mParams, sName, oClientControl]);
				return;
			}
		}
	}
	UCF_LayeredControl.prototype["enrichSemanticEventParamsWithBindingContext"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["enrichSemanticEventParamsWithBindingContext"] = 0; };

/**
 * Opens the Popover (Behavior=POPOVER) at a the specified control.
 * @param {string} sControlId The control to use for positioning
 * @param {boolean} bWithKeyboard Flag to indicate that the user interaction was done with the keyboard (focus handling)
 * @param {UCF_LayeredControl.ALIGNMENT} iAlignment Behavior=POPOVER: Set alignment using enumeration UCF_LayeredControl.ALIGNMENT
 * Note: This will overwrite the API parameter 'PopOverAlignment' when it is also set.
 * @public
 */
UCF_QuickView["prototype"]["openAtControl"] = function(sControlId, bWithKeyboard, iAlignment) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["openAtControl"]++; }; 
	if (this["sBehavior"] === "DEFAULT") return;

	if (!sControlId) return;

	this["setOpenerId"](sControlId);
	this["setOpenerRef"](UCF_DomUtil["$"](sControlId));
	if (typeof(iAlignment) === 'number') {
		this["setAlignment"](iAlignment);
	}
	this["show"](bWithKeyboard);
	this["oLayerHelper"]["handleOpen"]();
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["openAtControl"] = 0; };

/**
 * @private
 */
UCF_QuickView["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onLayoutChange"]++; }; 
	// WebGUI uses client-side rendering and calls ClientElement.destroy()
	// => The DOM is gone...
	if (!this["bIsValid"]()) return;
	this["setPosition"]();
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onLayoutChange"] = 0; };

/**
 * Because the QuickView is a control that is also a UCF_Delegate, we have to implement this
 * function (instead of UCF_Control.aGetTouchContextMenuEntries()).
 * @private
 * @param {Array<Object>} aEntries
 */
UCF_QuickView["prototype"]["aChangeTouchContextMenuEntries"] = function(aEntries) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["aChangeTouchContextMenuEntries"]++; }; 
	var _this = this;
	aEntries["push"]({
		"sType": 'QUICKVIEW',
		"sText": this["oLS"]["sGetText"]('SAPUR_POMN_CX_QUICKVIEW') || 'Open quick-view',
		"fTrigger": function() {
			if (_this["bPreload"]) {
				// We can remember this special opening "mode" until contentReady()
				// is called by WDA, because QV has keepAlive=true
				_this["bOpenByTouchContextMenu"] = true;
				_this["fireContentAccess"](_this["sId"]);
				this["bCloseFired"] = false;
			} else {
				_this["show"]();
			}
		}
	});
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["aChangeTouchContextMenuEntries"] = 0; };

UCF_QuickView["prototype"]["onBeforeSetPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onBeforeSetPosition"]++; }; 
	if (this["bIsRightAttached"]()) {
		// double pointer height, because iLeft is not including the pointer
		// (i.e. iLeft points to the left edge of the quickview)
		this["iOffsetLeft"] = 2 * this["iGetPointerHeight"](); // eslint-disable-line @ur/no-memory-leaks
	} else if (this["bIsLeftAttached"]()) {
		this["iOffsetLeft"] = this["iGetPointerHeight"]();
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onBeforeSetPosition"] = 0; };

UCF_QuickView["prototype"]["onAfterPointerCalculation"] = function(oPointer) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onAfterPointerCalculation"]++; }; 
	var oCntDomRef;
	var oContentDomRef;

	if (UCF_UserAgent["bIsIECompatibilityMode"]()) {
		return;
	}

	if (this["_iCntPaddingTop"] === undefined) {
		oCntDomRef = UCF_DomUtil["$"](this["sId"] + "-cnt");
		this["_iCntPaddingTop"] = parseInt(UCF_DomUtil["oGetComputedStyle"](oCntDomRef)["paddingTop"], 10); // eslint-disable-line @ur/no-memory-leaks
		this["_iCntPaddingBottom"] = parseInt(UCF_DomUtil["oGetComputedStyle"](oCntDomRef)["paddingBottom"], 10); // eslint-disable-line @ur/no-memory-leaks
	}
	if (this["bIsTopAttached"]() && this["_iCntPaddingTop"] <= 0) {
		oContentDomRef = UCF_DomUtil["oGetFirstChildByAttribute"](UCF_DomUtil["$"](this["sId"] + "-cntbox"), "ct", "POPOVERCONTAINER");
		if (oContentDomRef && UCF_DomUtil["$"](oContentDomRef["id"] + "-footer")) {
			UCF_DomUtil["removeClass"](oPointer, 'lsQuickView--header');
			UCF_DomUtil["addClass"](oPointer, 'sapContrast lsQuickView--footer');
		}
	} else if (this["bIsBottomAttached"]() && this["_iCntPaddingBottom"] <= 0) {
		oContentDomRef = UCF_DomUtil["oGetFirstChildByAttribute"](UCF_DomUtil["$"](this["sId"] + "-cntbox"), "ct", "POPOVERCONTAINER");
		if (oContentDomRef && UCF_DomUtil["$"](oContentDomRef["id"] + "-header")) {
			UCF_DomUtil["removeClass"](oPointer, 'sapContrast lsQuickView--footer');
			UCF_DomUtil["addClass"](oPointer, 'lsQuickView--header');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["onAfterPointerCalculation"] = 0; };

/**
 * Calculates and returns the top of the Quickview
 * @return {number}
 */
UCF_QuickView["prototype"]["iGetTop"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["iGetTop"]++; }; 
	/** @type {_ObjectRect} */
	var oViewportObjectRect;
	/** @type {number} iHeight  the height of the layered control */
	var iHeight;
	/** @type {number} iTop  the top position of the layered control */
	var iTop;

	if (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["RIGHT"]) {
		iHeight = this["iGetHeight"]();
		oViewportObjectRect = this["oGetViewportObjectRect"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'right, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "QuickView.js(913): iGetTop"); };
		iTop = Math["max"](0, oViewportObjectRect["top"] - 20);
		if (this["bMoveY"]) {
			iTop = Math["min"](iTop, this["oGetVisualViewport"]()["height"] - iHeight);
		}
	} else {
		iTop = UCF_LayeredControl.prototype["iGetTop"]["apply"](this, arguments);
	}
	return iTop;
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["iGetTop"] = 0; };

/**
 * Returns whether the pointer for the quickview shall be displayed:
 * For quickviews and popovers, it shall be displayed always
 * @return {boolean}
 */
UCF_QuickView["prototype"]["bShowPointer"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["bShowPointer"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["bShowPointer"] = 0; };

/**
 * Returns the width of the Quickview
 * @return {number}
 */
UCF_QuickView["prototype"]["iGetWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["iGetWidth"]++; }; 
	if (this["_iWidth"] === null || this["_iWidth"] === undefined) {
		this["_iWidth"] = this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["RIGHT"] // eslint-disable-line @ur/no-memory-leaks
			? this["oRootRef"]["scrollWidth"] + this["iGetPointerHeight"]()
			: this["oRootRef"]["scrollWidth"];
	}

	return this["_iWidth"];
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["iGetWidth"] = 0; };

/**
 * Returns the height of the Quickview
 * @return {number}
 */
UCF_QuickView["prototype"]["iGetHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["iGetHeight"]++; }; 
	if (this["_iHeight"] === null || this["_iHeight"] === undefined) {
		this["_iHeight"] = this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["RIGHT"] // eslint-disable-line @ur/no-memory-leaks
			? this["oRootRef"]["offsetHeight"]
			: this["oRootRef"]["offsetHeight"] + this["iGetPointerHeight"]();
	}

	return this["_iHeight"];
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["iGetHeight"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_QuickView["prototype"]["aAttributeNames"] = ["bPreload","sOpenHotkey","bAlwaysSendKCAEvent","sCustomData","bCloseOnTyping","sBehavior","bPopOverCloseEvent","sPopOverOpenAtControl","sDesign","bPopOverFocusContent","sPopOverAlignment"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_QuickView["prototype"]["aEventNames"] = ["ContentAccess","KeyboardContentAccess","Close"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_QuickView["prototype"]["aMethodNames"] = ["show","contentReady","openAtControl","close","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {boolean}
 */
UCF_QuickView["prototype"]["bPreload"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HotkeyValue}
 */
UCF_QuickView["prototype"]["sOpenHotkey"] = "CTRL_SHIFT_I";

/**
 * @private
 * @type {boolean}
 */
UCF_QuickView["prototype"]["bAlwaysSendKCAEvent"] = false;

/**
 * @private
 * @type {string}
 */
UCF_QuickView["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_QuickView["prototype"]["bCloseOnTyping"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.QuickViewBehavior}
 */
UCF_QuickView["prototype"]["sBehavior"] = "DEFAULT";

/**
 * @private
 * @type {boolean}
 */
UCF_QuickView["prototype"]["bPopOverCloseEvent"] = false;

/**
 * @private
 * @type {string}
 */
UCF_QuickView["prototype"]["sPopOverOpenAtControl"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.QuickViewDesign}
 */
UCF_QuickView["prototype"]["sDesign"] = "STANDARD";

/**
 * @private
 * @type {boolean}
 */
UCF_QuickView["prototype"]["bPopOverFocusContent"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.PopOverAlignment}
 */
UCF_QuickView["prototype"]["sPopOverAlignment"] = "DEFAULT";

//#JSCOVER_EXCL_START
/** @protected */
UCF_QuickView["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["setDefaultValues"]++; }; 
	this["bPreload"] = false;
	this["sOpenHotkey"] = "CTRL_SHIFT_I";
	this["bAlwaysSendKCAEvent"] = false;
	this["sCustomData"] = '';
	this["bCloseOnTyping"] = false;
	this["sBehavior"] = "DEFAULT";
	this["bPopOverCloseEvent"] = false;
	this["sPopOverOpenAtControl"] = '';
	this["sDesign"] = "STANDARD";
	this["bPopOverFocusContent"] = true;
	this["sPopOverAlignment"] = "DEFAULT";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Preload", false, true);
		this["setClientProperty"]("OpenHotkey", "CTRL_SHIFT_I", true);
		this["setClientProperty"]("AlwaysSendKCAEvent", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CloseOnTyping", false, true);
		this["setClientProperty"]("Behavior", "DEFAULT", true);
		this["setClientProperty"]("PopOverCloseEvent", false, true);
		this["setClientProperty"]("PopOverOpenAtControl", '', true);
		this["setClientProperty"]("Design", "STANDARD", true);
		this["setClientProperty"]("PopOverFocusContent", true, true);
		this["setClientProperty"]("PopOverAlignment", "DEFAULT", true);
	}
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires QuickView::ContentAccess
 */
UCF_QuickView["prototype"]["fireContentAccess"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["fireContentAccess"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "QuickView.js(1089): fireContentAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "QuickView.js(1090): fireContentAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "QuickView.js(1091): fireContentAccess"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("QuickView", "ContentAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["fireContentAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires QuickView::KeyboardContentAccess
 */
UCF_QuickView["prototype"]["fireKeyboardContentAccess"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["fireKeyboardContentAccess"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "QuickView.js(1108): fireKeyboardContentAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "QuickView.js(1109): fireKeyboardContentAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "QuickView.js(1110): fireKeyboardContentAccess"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("QuickView", "KeyboardContentAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["fireKeyboardContentAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {boolean} bByKeyboard Close was triggered by a keyboard event - only used in PopOver-mode!
 * @fires QuickView::Close
 */
UCF_QuickView["prototype"]["fireClose"] = function(sId, bByKeyboard) {;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["fireClose"]++; }; 
	/** @type {{Id: string, ByKeyboard: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "QuickView.js(1128): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "QuickView.js(1129): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "QuickView.js(1130): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bByKeyboard != null, "bByKeyboard != null", "QuickView.js(1131): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bByKeyboard) == "boolean", "typeof(bByKeyboard) == \"boolean\"", "QuickView.js(1132): fireClose"); };
	mParams = {
		"Id": sId,
		"ByKeyboard": bByKeyboard
	};
	
	
	this["fireSemanticEvent"]("QuickView", "Close", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_QuickView["_"]["fireClose"] = 0; };

UCF_QuickView.prototype["aPublicMethods"] = ["show","contentReady","close","openAtControl"].concat(UCF_QuickView.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_RadioButton"] = function() {/* global UCF_Tracer, _assert, _trace, INFO, DEBUG, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {LightSpeed} oLS
 */
function UCF_RadioButton(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["UCF_RadioButton"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "RadioButton.js(20): UCF_RadioButton"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RadioButton.js(21): UCF_RadioButton"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "RadioButton.js(22): UCF_RadioButton"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	// -- flag to enable arrow key navigation etc., you can only toggle the
	// -- navigation mode in a table
	this["bUseOwnNavigation"] = !this["bUsedInSapTable"];

	this["eFilterBy"] = this["fFilterBy"](this["sName"]);

	// -- when the name is changed, the RadioButton with
	// -- the same name will be checked every time
	this["bIsNameChanged"] = false;
	this["oFocusDomRef"] = oDomRef;
};window["UCF_RadioButton"] = UCF_RadioButton; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RadioButton"); UCF_RadioButton["_"] = {UCF_RadioButton: 0}; }; ;

UCF_RadioButton["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_RadioButton.prototype["sClassName"] = "UCF_RadioButton";

/**
 * ############################################################################
 *
 * SECTION RESPONSIBLE FOR FOCUS NAVIGATION
 *
 * ############################################################################
 */

/**
 * Static variable
 *
 * Stores the radio button group as global object that is accessible to all radio
 * buttons Background: radio buttons are not always grouped by means of the
 * radio button group control. To find out which radio buttons belongs together
 * we need to collect them from the DOM. All radio buttons that have the same
 * name attribute belong to the same group.
 *
 * @private
 */
UCF_RadioButton["oRadioGroup"] = {
	"bGroupInitialized": false,
	"bIsIndefiniteGroup": false,
	"sSAP_TableEditMode": 'F2_MODE_OFF',
	"Skipping": 'NONE',
	"sExitType": 'NONE',
	"sAccessType": 'NONE'
};

/**
 * Helper to update certain fields of oRadioGroup
 *
 * @private
 * @param {Object} oData
 */
UCF_RadioButton["prototype"]["storeRadioInGroupField"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["storeRadioInGroupField"]++; }; 
	/** @type {boolean} */
	var oRadioGroup;
	/** @type {string} */
	var sField;
	/** @type {Object} */
	var oRadio;

	if (
		UCF_RadioButton &&
		UCF_RadioButton["oRadioGroup"] &&
		oData &&
		oData["sField"]
	) {

		oRadioGroup = UCF_RadioButton["oRadioGroup"];
		sField = oData["sField"];
		oRadio = oData["oRadio"];

		oRadioGroup[sField]["oRadio"] = oRadio;

		if (oData["iIndex"]) {
			oRadioGroup[sField]["iIndex"] = oData["iIndex"];
		}

	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'oRadioGroup not found or no data / field available', "RadioButton.js(99): storeRadioInGroupField"); };
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["storeRadioInGroupField"] = 0; };

/**
 *
 * @private
 * @param {string} sField
 * @return {UCF_RadioButton}
 */
UCF_RadioButton["prototype"]["getValueOfGroupField"] = function(sField) {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["getValueOfGroupField"]++; }; 
	/** @type {Object} */
	var oRadioGroup;

	// -- check if a group is there
	if (
		UCF_RadioButton &&
		UCF_RadioButton["oRadioGroup"] &&
		sField
	) {

		oRadioGroup = UCF_RadioButton["oRadioGroup"];
		// -- return the radio stored in field
		return oRadioGroup[sField];
		// -- trace the error
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'oRadioGroup not found or no field name available', "RadioButton.js(125): getValueOfGroupField"); };
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["getValueOfGroupField"] = 0; };

/**
 * Returns the Rectangle used for Help
 *
 * @private
 * @return {DomRect}
 */

UCF_RadioButton["prototype"]["oGetClientRectForHelp"] = function(){;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["oGetClientRectForHelp"]++; }; 
	var oDomRect = this["oDomRef"]["getBoundingClientRect"]();
	if (window["UCF_System"]["bIsRTL"]){
		if (this["sArrangement"] === 'RADIOBUTTONLAST'){
			oDomRect["right"] = oDomRect["left"] + oDomRect["height"];
			oDomRect["width"] = oDomRect["height"];
		} else {
			oDomRect["x"] = oDomRect["right"] - oDomRect["height"];
			oDomRect["width"] = oDomRect["height"];
		}
	}
	else{
		if (this["sArrangement"] === 'RADIOBUTTONLAST') {
			oDomRect["x"] = oDomRect["right"] - oDomRect["height"];
			oDomRect["width"] = oDomRect["height"];
		} else {
			oDomRect["right"] = oDomRect["left"] + oDomRect["height"];
			oDomRect["width"] = oDomRect["height"];
		}
	}
	return oDomRect;
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["oGetClientRectForHelp"] = 0; };

/**
 * Helper to update certain fields of oRadioGroup
 *
 * @private
 * @param {Object} oData
 */
UCF_RadioButton["prototype"]["setValueInGroupField"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["setValueInGroupField"]++; }; 
	/** @type {Object} */
	var oRadioGroup;

	// -- check if a group is there
	if (
		UCF_RadioButton &&
		UCF_RadioButton["oRadioGroup"] &&
		oData
	) {

		if (!oData["sField"] || !oData["sValue"]) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No field name or value found in oData.', "RadioButton.js(178): setValueInGroupField"); };
			return;
		}

		oRadioGroup = UCF_RadioButton["oRadioGroup"];

		// if (!oRadioGroup[oData.sField]){
		// 	_trace(ERROR, 'No such field in oData.');
		// 	return null;
		// }
		oRadioGroup[oData["sField"]] = oData["sValue"];

		// -- trace the error
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'oRadioGroup not found or no data available', "RadioButton.js(192): setValueInGroupField"); };
		return;
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["setValueInGroupField"] = 0; };

/**
 * The skeleton of an object that is initially used to store and pass all data
 * relevant for selection and navigation
 *
 * @private
 * @return {Object}
 */
UCF_RadioButton["prototype"]["oFilteredRadiosSkeleton"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["oFilteredRadiosSkeleton"]++; }; 
	return {
		// -- important for navigation
		// -- store here a radio of interactionType DISAPLED or READONLY
		// -- that needs to be unselected if a radio is selected
		'oUnSelectableAndSelected': {
			"oRadio": null
		},
		// -- stores the selected radio and its index
		'oSelected': {
			"oRadio": null,
			"iIndex": null
		},
		// -- stores the radio that currently has the focus
		// -- if it is of the interactionType DISABLED it actually cannot receive the focus
		// -- then the index is -1
		'oRadioWithFocus': {
			"oRadio": null,
			"iIndex": null
		}, // -- stores an object that maps the ids of the indeces of the radios
		'mIdMap': {},
		// -- all radios relevant for navigation
		'aRadios': [],
		// -- a radio accessed by click, touch and alike interactions. Anything that
		// -- is not focus, such as accesskeys, tab etc.
		// -- important to find out, if this radio still belongs to the same group
		'oRadioNotAccessedByFocus': {
			"oRadio": null
		}
	};
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["oFilteredRadiosSkeleton"] = 0; };

/**
 * All possible values relevant for filtering out radios that belong to one group
 * NAME: the name determines all radios that belong to one group NO_NAME: if the
 * radios were collected from a radio group control we assume that all of them
 * belong together, even those that do not have a name. Necessary for Personas
 * scenarios.
 *
 * @param {string} sName
 * @return {Object}
 * @private
 */
UCF_RadioButton["prototype"]["fFilterBy"] = function(sName) {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["fFilterBy"]++; }; 
	return {
		"NAME": sName,
		"NO_NAME_ASSIGNED": ''
	};
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["fFilterBy"] = 0; };

// /**
//  * ############################################################################
//  *
//  * SECTION WITH PUBLIC APIS
//  *
//  * ############################################################################
//  */

/**
 * Returns the key of the RadioButton,
 *
 * @return {string} The value of the RadioButton
 * @public
 */
UCF_RadioButton["prototype"]["getName"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["getName"]++; }; 
	return this["sName"];
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["getName"] = 0; };

/**
 * Set the key of the RadioButton
 *
 * @param {string} sName the new key
 * @public
 */
UCF_RadioButton["prototype"]["setName"] = function(sName) {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["setName"]++; }; 
	this["sName"] = sName;
	this["setClientProperty"]("Name", this["sName"], true);
	// if (bValueChanged) {
	// 	this.aRadioButtons = new Array();
	// 	this.bIsNameChanged = true;
	// 	this.oDomRef.name = this.sName;
	// 	this.checkSelection(true);
	// 	this.applyStateToDom();
	// }
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["setName"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_RadioButton["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["destroy"]++; }; 
	this["sName"] = null;
	this["bUseOwnNavigation"] = null;
	this["eFilterBy"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_RadioButton["prototype"]["aAttributeNames"] = ["sName","bChecked","bEnabled","bReadonly","sText","sTooltip","bInvalid","sVisibility","bShowHelp","sInputState","bUsedInSapTable","sAccessKey","sArrangement","sAssociatedEditContext","sCustomData","sCustomStyle","bTextOverflow","sHeight","bIsTextLabel","sAccessibilityDescription","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_RadioButton["prototype"]["aEventNames"] = ["Change","DoubleClick","Enter"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_RadioButton["prototype"]["aMethodNames"] = ["setValue","getValue","setName","getName","setEnabled","getEnabled","setValueState","getValueState","setEditable","getEditable","createDataTip","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_RadioButton["prototype"]["sName"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_RadioButton["prototype"]["bChecked"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_RadioButton["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_RadioButton["prototype"]["bReadonly"] = false;

/**
 * @private
 * @type {string}
 */
UCF_RadioButton["prototype"]["sText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RadioButton["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_RadioButton["prototype"]["bInvalid"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_RadioButton["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_RadioButton["prototype"]["bShowHelp"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputState}
 */
UCF_RadioButton["prototype"]["sInputState"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_RadioButton["prototype"]["bUsedInSapTable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_RadioButton["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.RadioButtonArrangement}
 */
UCF_RadioButton["prototype"]["sArrangement"] = "RADIOBUTTONFIRST";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.EditContext}
 */
UCF_RadioButton["prototype"]["sAssociatedEditContext"] = "PARENTEDITABLE";

/**
 * @private
 * @type {string}
 */
UCF_RadioButton["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RadioButton["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_RadioButton["prototype"]["bTextOverflow"] = false;

/**
 * @private
 * @type {string}
 */
UCF_RadioButton["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_RadioButton["prototype"]["bIsTextLabel"] = false;

/**
 * @private
 * @type {string}
 */
UCF_RadioButton["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RadioButton["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_RadioButton["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["setDefaultValues"]++; }; 
	this["sName"] = '';
	this["bChecked"] = false;
	this["bEnabled"] = true;
	this["bReadonly"] = false;
	this["sText"] = '';
	this["sTooltip"] = '';
	this["bInvalid"] = false;
	this["sVisibility"] = "VISIBLE";
	this["bShowHelp"] = false;
	this["sInputState"] = "NONE";
	this["bUsedInSapTable"] = false;
	this["sAccessKey"] = '';
	this["sArrangement"] = "RADIOBUTTONFIRST";
	this["sAssociatedEditContext"] = "PARENTEDITABLE";
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["bTextOverflow"] = false;
	this["sHeight"] = '';
	this["bIsTextLabel"] = false;
	this["sAccessibilityDescription"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Name", '', true);
		this["setClientProperty"]("Checked", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Readonly", false, true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Invalid", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ShowHelp", false, true);
		this["setClientProperty"]("InputState", "NONE", true);
		this["setClientProperty"]("UsedInSapTable", false, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("Arrangement", "RADIOBUTTONFIRST", true);
		this["setClientProperty"]("AssociatedEditContext", "PARENTEDITABLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("TextOverflow", false, true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("IsTextLabel", false, true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {boolean} bChecked Returns the current checked status of the radio button
 * @fires RadioButton::Change
 */
UCF_RadioButton["prototype"]["fireChange"] = function(sId, bChecked) {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Checked: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "RadioButton.js(509): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "RadioButton.js(510): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "RadioButton.js(511): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bChecked != null, "bChecked != null", "RadioButton.js(512): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bChecked) == "boolean", "typeof(bChecked) == \"boolean\"", "RadioButton.js(513): fireChange"); };
	mParams = {
		"Id": sId,
		"Checked": bChecked
	};
	
	
	this["fireSemanticEvent"]("RadioButton", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires RadioButton::DoubleClick
 */
UCF_RadioButton["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "RadioButton.js(532): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "RadioButton.js(533): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "RadioButton.js(534): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("RadioButton", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires RadioButton::Enter
 */
UCF_RadioButton["prototype"]["fireEnter"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["fireEnter"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "RadioButton.js(551): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "RadioButton.js(552): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "RadioButton.js(553): fireEnter"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("RadioButton", "Enter", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_RadioButton["_"]["fireEnter"] = 0; };

UCF_RadioButton.prototype["aPublicMethods"] = ["getName","setName"].concat(UCF_RadioButton.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_RadioButtonGroup"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * RadioButtonGroup
 * 
 *
 * @class
 * @extends UCF_Control
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_RadioButtonGroup(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["UCF_RadioButtonGroup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "RadioButtonGroup.js(26): UCF_RadioButtonGroup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RadioButtonGroup.js(27): UCF_RadioButtonGroup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "RadioButtonGroup.js(28): UCF_RadioButtonGroup"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	// all radio buttons of the group
	this["aRadioButtons"] = new Array();
};window["UCF_RadioButtonGroup"] = UCF_RadioButtonGroup; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RadioButtonGroup"); UCF_RadioButtonGroup["_"] = {UCF_RadioButtonGroup: 0}; }; ;
UCF_RadioButtonGroup["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_RadioButtonGroup.prototype["sClassName"] = "UCF_RadioButtonGroup";

/**
 * destructor
 * @private
 */
UCF_RadioButtonGroup["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["destroy"]++; }; 
	this["aRadioButtons"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["destroy"] = 0; };

/**
 * Get all radio buttons of the radio button group.
 *
 * @return {Array} array of radio button in the group
 */
UCF_RadioButtonGroup["prototype"]["aGetGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["aGetGroup"]++; }; 
	if (this["aRadioButtons"]["length"] > 0)
		return this["aRadioButtons"];

	var aRadioButtonsRef = this["oDomRef"]["getElementsByTagName"]("SPAN"),
		j = 0;
	for (var i = 0; i < aRadioButtonsRef["length"]; i++) {
		if (aRadioButtonsRef[i]["getAttribute"]("ct") === "R_standards"
			|| aRadioButtonsRef[i]["getAttribute"]("ct") === "R_ie6") {
			this["aRadioButtons"][j] = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aRadioButtonsRef[i], true);
			j++;
		}
	}
	return this["aRadioButtons"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["aGetGroup"] = 0; };


/**
 * Cancel the browser event to avoid VC cursor returning to
 * start of page
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonGroup["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["onlsselect"]++; }; 
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["onlsselect"] = 0; };

/**
 * Focusses the control
 */
UCF_RadioButtonGroup["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["focus"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Focus " + this["sClassName"] + " \"" + this["sId"] + "\"", "RadioButtonGroup.js(84): focus"); };

	/** @type {Array} */
	var aRadios;
	/** @type {integer} */
	var i;
	/** @type {HTML_Element} */
	var oNavHelper;

	if (window["UCF_System"]["bIs508"]) {
		UCF_DomUtil["focusDomElement"](this["oFocusDomRef"]);
	} else {
		aRadios = this["aGetGroup"]();
		for (i = 0; i < aRadios["length"]; i++) {
				if (aRadios[i]["bEnabled"]) {
					oNavHelper = UCF_DomUtil["$"](aRadios[i]["sId"] + '-NAV_HELPER');
					UCF_DomUtil["focusDomElement"](oNavHelper);
					break;
				}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["focus"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonGroup["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["onlsskipforward"]++; }; 
	var aGroup = this["aGetGroup"]();
	if (aGroup["length"] > 0) {
		aGroup[0]["handleSkipForward"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonGroup["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["onlsskipback"]++; }; 
	var aGroup = this["aGetGroup"]();
	if (aGroup["length"] > 0) {
		aGroup[0]["handleSkipBack"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["onlsskipback"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonGroup["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonGroup.js(141): onlsaccessibility"); };

	var i;

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	var oSource = oBrowserEvent["oGetSource"]();

	// radiobutton group
	if (oSource === this["oDomRef"]) {
		// control type with item count
		var aCheckBoxes = oSource["getElementsByTagName"]("TD");
		var iItemCount = aCheckBoxes["length"];
		oAccessibilityHelper["setControlType"]("RG", new Array(iItemCount["toString"]()));

		//set disabled / readOnly if all items of the group are disabled / readOnly
		var radioButton = this["aGetGroup"](),
			setEnabled = true,
			setReadOnly = false,
			iDisabled = 0,
			iReadonly = 0;

		for (i = 0; i < radioButton["length"]; i++) {
			if (radioButton[i]["bEnabled"] === false) {
				iDisabled++;
			}
		}

		if (iDisabled === radioButton["length"]) {
			setEnabled = false;
		}

		for (i = 0; i < radioButton["length"]; i++) {
			if (radioButton[i]["bReadonly"] === true) {
				iReadonly++;
			}
		}

		if (iReadonly === radioButton["length"]) {
			setReadOnly = true;
		}

		oAccessibilityHelper["setEnabled"](setEnabled);
		oAccessibilityHelper["setReadonly"](setReadOnly);

		//Apply label and accDescription
		oAccessibilityHelper["applyLabelingInfo"](this, this["sAccessibilityDescription"]);

		// tutor text
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
	}
	// end point of checkbox group
	else {
		oAccessibilityHelper["setControlType"]("RG_END");
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_RadioButtonGroup["prototype"]["aAttributeNames"] = ["sAccessibilityDescription","sVisibility","sCustomData","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_RadioButtonGroup["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_RadioButtonGroup["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_RadioButtonGroup["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_RadioButtonGroup["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_RadioButtonGroup["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RadioButtonGroup["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_RadioButtonGroup["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["setDefaultValues"]++; }; 
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonGroup["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_RadioButtonKeyboard_ie6"] = function() {/* global _assert, _trace, INFO, DEBUG, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_RadioButton */
/// <reference path="./RadioButton.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>

/**
 * @class
 * @extends UCF_RadioButton
 * @param {HTMLElement} oDomRef
 * @param {LightSpeed} oLS
 */
function UCF_RadioButtonKeyboard_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["UCF_RadioButtonKeyboard_ie6"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "RadioButtonKeyboard_ie6.js(32): UCF_RadioButtonKeyboard_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RadioButtonKeyboard_ie6.js(33): UCF_RadioButtonKeyboard_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "RadioButtonKeyboard_ie6.js(34): UCF_RadioButtonKeyboard_ie6"); };

	UCF_RadioButton["apply"](this, [oDomRef, oLS]);
};window["UCF_RadioButtonKeyboard_ie6"] = UCF_RadioButtonKeyboard_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RadioButtonKeyboard_ie6"); UCF_RadioButtonKeyboard_ie6["_"] = {UCF_RadioButtonKeyboard_ie6: 0}; }; ;

UCF_RadioButtonKeyboard_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_RadioButton"))(); UCF_RadioButtonKeyboard_ie6.prototype["sClassName"] = "UCF_RadioButtonKeyboard_ie6";

/**
 * ############################################################################
 *
 * SECTION RESPONSIBLE FOR FOCUS NAVIGATION
 *
 * ############################################################################
 */

/**
 * Enumeration
 *
 * Determines the access point of the group. Every radio button has an
 * additional empty SPAN that serves as navigation helper. The helper SPAN has
 * the tab index in a yet undetermined group. The SPAN is identified as
 * NAV_HELPER. With root we identify the root element of the focusDomRef
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["eAccessPoint"] = {
	"ROOT": 'ROOT',
	"NAV_HELPER": 'NAV_HELPER',
	"RADIO": 'RADIO',
	"IMAGE": 'IMAGE',
	"UNKNOWN": 'UNKNOWN'
};

/**
 * @param {HTMLElement} oDomRef
 * @return {string} the access point.
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["sGetAccessPoint"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetAccessPoint"]++; }; 
	/** @type {string} determines the element focused upon first access*/
	var sAccessPoint;

	sAccessPoint = oDomRef["getAttribute"]('accessPoint');
	switch (sAccessPoint) {
		case this["eAccessPoint"]["NAV_HELPER"]:
			return this["eAccessPoint"]["NAV_HELPER"];
		case this["eAccessPoint"]["ROOT"]:
			return this["eAccessPoint"]["ROOT"];
		case this["eAccessPoint"]["RADIO"]:
			return this["eAccessPoint"]["RADIO"];
		case this["eAccessPoint"]["IMAGE"]:
			return this["eAccessPoint"]["IMAGE"];
		default:
			return this["eAccessPoint"]["UNKNOWN"];
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetAccessPoint"] = 0; };

/**
 * Enumeration
 *
 * Lists the different statuses of a radio button that take influence on its focus navigation
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["eSelectionStatus"] = {
	"SELECTABLE": 'SELECTABLE', // this property excludes all the following an provides the information that a radio button with this status can be selected
	"UNSELECTABLE_AND_SELECTED": 'UNSELECTABLE_AND_SELECTED',
	"UNSELECTABLE": 'UNSELECTABLE',
	"SELECTED": 'SELECTED'
};
/**
 *
 * @param {UCF_RadioButton} oRadio
 * @return {string} determines whether a radio can be selected depending on the combinations of its different states.
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["sGetSelectionStatus"] = function(oRadio) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetSelectionStatus"]++; }; 
	if (oRadio["bChecked"] && oRadio["bReadonly"])
		return this["eSelectionStatus"]["UNSELECTABLE_AND_SELECTED"];

	if (oRadio["bChecked"] && !oRadio["bEnabled"])
		return this["eSelectionStatus"]["UNSELECTABLE_AND_SELECTED"];

	if (!oRadio["bEnabled"] && !oRadio["bChecked"])
		return this["eSelectionStatus"]["UNSELECTABLE"];

	if (oRadio["bReadonly"] && !oRadio["bChecked"])
		return this["eSelectionStatus"]["UNSELECTABLE"];

	if (oRadio["sAssociatedEditContext"] === 'PARENTREADONLY')
		return this["eSelectionStatus"]["UNSELECTABLE"];

	if (oRadio["bEnabled"] && !oRadio["bReadonly"] && oRadio["bChecked"])
		return this["eSelectionStatus"]["SELECTED"];

	return this["eSelectionStatus"]["SELECTABLE"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetSelectionStatus"] = 0; };

/**
 * Enumeration
 *
 * Lists the different statuses of a radio button that take influence on its focus navigation
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["eNavigationStatus"] = {
	"ACCESSIBLE": 'ACCESSIBLE', // this property excludes all the following an provides the information that a radio button with this status can be selected
	"INACCESSIBLE": 'INACCESSIBLE' // selection not possible
};

/**
 *
 * Determines as to how focus navigation is to happen depending on the different modes for the non sighted and sighted user
 * @param {UCF_radioButton} oRadio
 * @return {string}
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["sGetNavigationStatus"] = function(oRadio) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetNavigationStatus"]++; }; 

	//Sighted user if ARIA and 508 are off
	if (!window["UCF_System"]["bIs508"] && !window["UCF_System"]["bIsAria"]) {
		if (oRadio["bReadonly"] || !oRadio["bEnabled"])
			return this["eNavigationStatus"]["INACCESSIBLE"];
		if (oRadio["sAssociatedEditContext"] === 'PARENTREADONLY')
			return this["eNavigationStatus"]["INACCESSIBLE"];
		return this["eNavigationStatus"]["ACCESSIBLE"];
	}

	//Non-sighted user if ARIA is on and 508 is off
	if (window["UCF_System"]["bIsAria"]) {
		if (!oRadio["bEnabled"])
			return this["eNavigationStatus"]["INACCESSIBLE"];
		return this["eNavigationStatus"]["ACCESSIBLE"];
	}

	//non sighted user in 508 mode
	if (window["UCF_System"]["bIs508"])
		return this["eNavigationStatus"]["ACCESSIBLE"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetNavigationStatus"] = 0; };

/**
 * Enumeration
 * Lists the different sematics that a blur event can have
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["eExitType"] = {
	"RADIO_FOCUS_LOST": 'RADIO_FOCUS_LOST', // Focus moved from the current radio button group to another element ===> destroy this group
	"FOCUS_MOVED": 'FOCUS_MOVED', // Focus was programmaticaly moved from one radio button to some other 	===> do not handle this
	"SELECTION": 'SELECTION', // Focus assigned to this element through mouse selection 	===> perform all necessary steps to select this radio button and deselect the previous if there is one
	"NAVIGATION": 'NAVIGATION', // Focus moved by navigational means 										===> ignore this
	"EXIT": 'EXIT', // The group has been exited 														===> destroy this group
	"NONE": 'NONE' // default
};
/**
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {string} how the user left the radio button they were working with
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["sGetExitType"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetExitType"]++; }; 
	/** @type {Object} contains all elements and infos about the radios of a group */
	var oRadioGroup;
	/** @type {boolean} */
	var bGroupInitialized;

	oRadioGroup = UCF_RadioButton["oRadioGroup"];
	bGroupInitialized = UCF_RadioButton["oRadioGroup"]["bGroupInitialized"];

	if (!oRadioGroup || bGroupInitialized === false) {
		return this["eExitType"]["NONE"];
	}
	if (oRadioGroup["sExitType"] === this["eExitType"]["NAVIGATION"])
		return this["eExitType"]["NAVIGATION"];
	if (oBrowserEvent["sName"]["indexOf"]('tab') > -1) {
		return this["eExitType"]["EXIT"];
	}
	if (this["bRadioFocusLost"]()) {
		return this["eExitType"]["RADIO_FOCUS_LOST"];
	}
	return oRadioGroup["sExitType"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetExitType"] = 0; };

/**
 * The focus has been lost if the active element of the DOM does not have a
 * name-property or its value is not equal to the value of the current group
 *
 * @return {boolean} that determines whether the current radio group has lost the focus focus
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["bRadioFocusLost"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bRadioFocusLost"]++; }; 
	var oUnknownElement = UCF_DomUtil["oGetActiveElement"]();
	if (oUnknownElement && oUnknownElement["id"]) {
		var sUnknonwId = oUnknownElement["id"];
	} else {
		return true;
	}
	if (sUnknonwId === 'ur-accfocus') {
		return false;
	}
	if (this["bInAccessibleRadioFocused"]()) return false;
	var mIdMap = UCF_RadioButton["oRadioGroup"]["mIdMap"];
	try {
		var oEntry = mIdMap[sUnknonwId["split"]('-')[0]];
		if (oEntry && typeof(oEntry) === 'object') {
			return false;
		} else {
			return true;
		}
	} catch (exception) {
		return true;
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bRadioFocusLost"] = 0; };

/**
 * Determines whether a radio with a status that makes it as inaccessible has been focused.
 * This mainly happens after the radio was clicked
 * @return {boolean}
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["bInAccessibleRadioFocused"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bInAccessibleRadioFocused"]++; }; 
	var oUnknownElement = UCF_DomUtil["oGetActiveElement"](),
		oInAccessibleRadio = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"]["oFocusDomRef"],
		bHasInAccesibleRadio = (UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"]["iIndex"] === -1);
	return (bHasInAccesibleRadio && oUnknownElement === oInAccessibleRadio);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bInAccessibleRadioFocused"] = 0; };

/**
 * Enumeration
 *
 * Lists the different sematics that a focus event can have
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["eAccessType"] = {
	"NAVIGATION": 'NAVIGATION', // focus moved by navigation means 	===> ignore this case
	"ACCESSIBLE_ACCESSED": 'ACCESSIBLE_ACCESSED', // focus assigned through selection  ===> perform all selection steps necessary
	"INACCESSIBLE_ACCESSED": 'INACCESSIBLE_ACCESSED', // User clicked on an unselectable radio. Focus is now on an item that is not part of the navigation if 508 is off. ===> Find according previous or next item in radio array.
	"FIRST_ACCESS": 'FIRST_ACCESS', // first focusing of a radio button that might belong to a group 	===> create the global radio button group object
	"FOCUS_MOVED": 'FOCUS_MOVED', // focus moved programaticaly from one radio button to some other 	===> ignore this case
	"NONE": 'NONE' // default no particular reaction necessary
};
/**
 *
 * @return {string} the sematic of a radio button's receiving focus
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["sGetAccessType"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetAccessType"]++; }; 

	var oRadioGroup = UCF_RadioButton["oRadioGroup"],
		sName = UCF_RadioButton["oRadioGroup"]["sName"],
		bGroupInitialized = UCF_RadioButton["oRadioGroup"]["bGroupInitialized"];

	if (bGroupInitialized === false || oRadioGroup === null)
		return this["eAccessType"]["FIRST_ACCESS"];

	if (bGroupInitialized === true && sName !== this["sName"])
		return this["eAccessType"]["FIRST_ACCESS"];

	if (bGroupInitialized && oRadioGroup
		&& oRadioGroup["sAccessType"] !== this["eAccessType"]["NONE"])
		return oRadioGroup["sAccessType"];

	return this["eAccessType"]["NONE"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetAccessType"] = 0; };

/**
 * Returns whether the first access of a radio group was successful.
 * Returns a negative result if the group consits of inaccessible radios only.
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["eAccessResult"] = {
	"GROUP_ACCESSED": 'GROUP_ACCESSED',
	"GROUP_NOT_ACCESSIBLE": 'GROUP_NOT_ACCESSIBLE'
};

/**
 * Determines whether a radio group could be created
 * @param {object} oFilteredRadios
 * @return {string}
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["sGetAccessResult"] = function(oFilteredRadios) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetAccessResult"]++; }; 
	if (oFilteredRadios["iInAccessibleRadios"] === oFilteredRadios["aRadios"]["length"]) {
		return this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"];
	}
	return this["eAccessResult"]["GROUP_ACCESSED"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sGetAccessResult"] = 0; };

/**
 * All possible values relevant for filtering out radios that belong to one group
 * NAME: the name determines all radios that belong to one group NO_NAME: if the
 * radios were collected from a radio group control we assume that all of them
 * belong together, even those that do not have a name. Necessary for Personas
 * scenarios.
 *
 * @param {string} sName
 * @return {object}
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["fFilterBy"] = function(sName) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["fFilterBy"]++; }; 
	return {
		"NAME": sName,
		"NO_NAME_ASSIGNED": ''
	};
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["fFilterBy"] = 0; };

/**
 * Starts the initialisation of the global object that stores the radio button
 * group
 * @return {string}
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onFirstGroupAccess"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onFirstGroupAccess"]++; }; 
	/** @type {array} */
	var oFilteredRadiosData = this["oCollectRadios"]();

	if (this["sGetAccessResult"](oFilteredRadiosData) === this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"])
		return this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"];

	if (window["UCF_System"]["bIs508"] && window["UCF_System"]["sDevice"] === 'standards') //&& this.bFeatureFlagOn)
		this["Delegate_508"]["addItems"](oFilteredRadiosData["aRadios"]);

	this["oCREATE__RadioGroup"](oFilteredRadiosData);
	this["removeNavHelper"]();

	return this["eAccessResult"]["GROUP_ACCESSED"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onFirstGroupAccess"] = 0; };

/**
 * Assemble all relevant functions and start the process
 * @return {object}
 * @private
 *
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["oCollectRadios"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oCollectRadios"]++; }; 
	return this["oFilterRadios"](
		this["oCollectRadiosFromDocument"](
			this["oCollectRadiosFromGroup"]()
		)
	);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oCollectRadios"] = 0; };

/**
 * returns all radios from the document that have the same name
 *
 * @private
 * @return {object}
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["oCollectRadiosFromGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oCollectRadiosFromGroup"]++; }; 
	/** @type {UCF_RadioButtonGroup} */
	var oRadioButtonGroup = this["oGetParent"]();
	/** @type {array} contains elements that presumably belong to a radio group*/
	var aCollectedRadios;

	if (oRadioButtonGroup && oRadioButtonGroup["sClassName"] === 'UCF_RadioButtonGroup') {

		if (window["UCF_System"]["sSubmitMethod"] === 'FORM') {
			aCollectedRadios = document["getElementsByName"](this["eFilterBy"]["NAME"]);
		} else {
			if (window["UCF_System"]["sDevice"] === 'standards') {
				aCollectedRadios = oRadioButtonGroup["oDomRef"]["getElementsByTagName"]('SPAN');
			} else {
				aCollectedRadios = document["getElementsByName"](this["eFilterBy"]["NAME"]);
			}
		}
	}
	return aCollectedRadios;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oCollectRadiosFromGroup"] = 0; };

/**
 * returns all radios from the document that have the same name
 *
 * @private
 * @param {array} aCollectedRadios
 * @return {array}
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["oCollectRadiosFromDocument"] = function(aCollectedRadios) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oCollectRadiosFromDocument"]++; }; 

	if (!aCollectedRadios) {

		if (window["UCF_System"]["sSubmitMethod"] === 'FORM') {
			aCollectedRadios = document["getElementsByName"](this["eFilterBy"]["NAME"]); //scheint nicht in domutil/jsutil zu sein
		} else {
			if (window["UCF_System"]["sDevice"] === 'standards') {
				aCollectedRadios = document["querySelectorAll"]('[ct=\"R_standards\"]');
			} else {
				aCollectedRadios = document["getElementsByName"](this["eFilterBy"]["NAME"]);
			}
		}
	}

	return aCollectedRadios;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oCollectRadiosFromDocument"] = 0; };

/**
 * @param {array} aCollectedRadios
 * @return {object} an object that stores:
 * 	1) an array with the collected radio buttons
 * 	2) Info about focused, selected, unavailable though selected, etc
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["oFilterRadios"] = function(aCollectedRadios) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oFilterRadios"]++; }; 
	var oFilteredRadios = this["oFilteredRadiosSkeleton"]();

	for (var i = 0; i < aCollectedRadios["length"]; i++) {

		var oFilteredRadioInfo = { 'iIndex': null, 'iNext': null };

		//check whether the objects collected from DOM are
		// radio buttons indeed
		if (aCollectedRadios[i]["getAttribute"]('ct') !== 'R_ie6' &&
			aCollectedRadios[i]["getAttribute"]('ct') !== 'R_standards')
			continue;

		var oRadio = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](
			aCollectedRadios[i], true);

		// make sure that the blindly collected radio buttons have the same name
		// and thus belong to the same group
		if (oRadio["sName"] !== this["eFilterBy"]["NAME"])
			continue;

		// -- distrubute the radios to their respective fields
		// start with that radio that is unselectable but still selected
		if (this["sGetSelectionStatus"](oRadio) === this["eSelectionStatus"]["UNSELECTABLE_AND_SELECTED"]) {
			oFilteredRadios["oUnSelectableAndSelected"]["oRadio"] = oRadio;
		}

		// in the if state ment create the group of radio buttons that will be used
		// for navigation purposes. Find those that can receive a focus dependant
		// on the current context, i.e. ARIA etc.
		if (this["bCanReceiveNavFocus"](oRadio)) {
			oFilteredRadios["aRadios"]["push"](oRadio);
			oFilteredRadioInfo["iIndex"] = oFilteredRadios["aRadios"]["length"] - 1;
			oFilteredRadios["mIdMap"][oRadio["sId"]] = oFilteredRadioInfo;
		} else {
			oFilteredRadioInfo["iNext"] = oFilteredRadios["aRadios"]["length"];
			oFilteredRadioInfo["iIndex"] = -1;
			oFilteredRadios["mIdMap"][oRadio["sId"]] = oFilteredRadioInfo;
		}

		if (this["sGetSelectionStatus"](oRadio) === this["eSelectionStatus"]["SELECTED"]) {
			oFilteredRadios["oSelected"]["oRadio"] = oRadio;
			oFilteredRadios["oSelected"]["iIndex"] = oFilteredRadios["aRadios"]["length"] - 1;
		}

		if (this === oRadio) {
			var iIndexOfThis = -1;
			if (this["bCanReceiveNavFocus"](this)) {
				iIndexOfThis = oFilteredRadios["aRadios"]["length"] - 1;
			}
		}

	}

	if (oFilteredRadios["oSelected"]["oRadio"] === null || window["UCF_System"]["bIs508"] === true) {
		oFilteredRadios["oRadioWithFocus"]["oRadio"] = this;
		oFilteredRadios["oRadioWithFocus"]["iIndex"] = iIndexOfThis;
	} else if (oFilteredRadios["oSelected"]["oRadio"] != null) {
		oFilteredRadios["oRadioWithFocus"]["oRadio"] = oFilteredRadios["oSelected"]["oRadio"];
		oFilteredRadios["oRadioWithFocus"]["iIndex"] = oFilteredRadios["oSelected"]["iIndex"];
	}

	return oFilteredRadios;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oFilterRadios"] = 0; };

/**
 * Creates all necessary field of the global radio button objects and assigns
 * values to them
 * @param {object} oFilteredRadiosData
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["oCREATE__RadioGroup"] = function(oFilteredRadiosData) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oCREATE__RadioGroup"]++; }; 
	UCF_RadioButton["oRadioGroup"] = oFilteredRadiosData;
	UCF_RadioButton["oRadioGroup"]["sAccessType"] = this["eAccessType"]["NONE"];
	UCF_RadioButton["oRadioGroup"]["bGroupInitialized"] = true;
	UCF_RadioButton["oRadioGroup"]["sName"] = this["sName"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oCREATE__RadioGroup"] = 0; };

/**
 * @return {boolean} that determines whether a radio button can be focused
 * @param {UCF_RadioButton} oRadio
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["bCanReceiveNavFocus"] = function(oRadio) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bCanReceiveNavFocus"]++; }; 
	var sStatus = this["sGetNavigationStatus"](oRadio);
	return sStatus === this["eNavigationStatus"]["ACCESSIBLE"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bCanReceiveNavFocus"] = 0; };

/**
 * Each radio button of the global object UCF_RadioButton.oRadioGroup is mapped
 * to its index in the array UCF_RadioButton.aRadios through its Id.
 *
 * This function expects that radio button's id of which the index is to be
 * determined
 * @param {UCF_RadioButton} oRadio
 * @return {integer}
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["iGetRadioIndex"] = function(oRadio) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["iGetRadioIndex"]++; }; 
	var oEntry = UCF_RadioButton["oRadioGroup"]["mIdMap"][oRadio["sId"]];
	return oEntry ? oEntry["iIndex"] : undefined;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["iGetRadioIndex"] = 0; };

/**
 * Removes the tabIndex of the nav-helper SPAN within the radio button
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["removeNavHelper"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["removeNavHelper"]++; }; 

	if (this["bUseTabNavigation"]() === true || this["bUseOwnNavigation"] === false) return;

	var mIdMap = UCF_RadioButton["oRadioGroup"]["mIdMap"];

	for (var sId in mIdMap) {
		var oNavHelper = UCF_DomUtil["$"](sId + '-' + this["eAccessPoint"]["NAV_HELPER"]);
		UCF_DomUtil["setTabIndex"](oNavHelper, -1);
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["removeNavHelper"] = 0; };

/**
 * As long as there is a selected radio only the nav-helper of the selected radio receives a tab index
 * For loose radio groups all nav-helpers receive a tab index. We need to make sure that from a focused element
 * that is no a radio button the focus moves to a radio if that proceeds or succeeds the radio.
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["assignNavHelper"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["assignNavHelper"]++; }; 

	if (this["bUseTabNavigation"]() || !this["bUseOwnNavigation"]) return;

	var oSelected = UCF_RadioButton["oRadioGroup"]["oSelected"]["oRadio"],
		oNavHelper;

	if (oSelected) {
		oNavHelper = UCF_DomUtil["$"](oSelected["sId"] + '-' + this["eAccessPoint"]["NAV_HELPER"]);
		UCF_DomUtil["setTabIndex"](oNavHelper, 0);
	} else {

		var mIdMap = UCF_RadioButton["oRadioGroup"]["mIdMap"];

		for (var sId in mIdMap) {
			oNavHelper = UCF_DomUtil["$"](sId + '-' + this["eAccessPoint"]["NAV_HELPER"]);
			UCF_DomUtil["setTabIndex"](oNavHelper, 0);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["assignNavHelper"] = 0; };

/**
 * handles the blur event that has the sematic EXIT
 * 1) Removes the tabIndex from the currently focused radio button
 * 2) Assigns a tabIndex to all nav-helpers
 * 3) Triggers this destruction of the radio group object
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onRadioGroupExit"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onRadioGroupExit"]++; }; 
	if (this["bUseTabNavigation"]() === false && this["bUsedInSapTable"] === false) {
		var oFocusedRadio = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"]["oFocusDomRef"];
		UCF_DomUtil["setTabIndex"](oFocusedRadio, -1);
		this["assignNavHelper"]();
	}
	this["destroyRadioGroup"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onRadioGroupExit"] = 0; };

/**
 * Sets the radio group back to its initial state
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["destroyRadioGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["destroyRadioGroup"]++; }; 
	UCF_RadioButton["oRadioGroup"] = null;
	UCF_RadioButton["oRadioGroup"] = {};
	UCF_RadioButton["oRadioGroup"]["bGroupInitialized"] = false;
	this["bIsExternalTabSequence"] = null;;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["destroyRadioGroup"] = 0; };

UCF_RadioButtonKeyboard_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["destroy"]++; }; 
	if (UCF_RadioButton["oRadioGroup"]["bGroupInitialized"]) {
		this["onRadioGroupExit"]();
	}
	UCF_RadioButton.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["destroy"] = 0; };

/**
 * The access of a radio group can result in three different ways to continue
 *
 * @private
 *
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["eHandleGroupAccessBy"] = {
	"CONTINUING": 'CONTINUING', // the static object can be created, continue the creation process
	"STOPPING": 'STOPPING', // the static object must not be created for diffenret reasons such as it already there, it cannot be created at all etc.
	"EXITING": 'EXITING' // the static object needs to be destroyed before contueing because it does not belong to the accessed group
};

/**
 * All combinations and circumstances that might be or occur
 * during a group access
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {string}
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["controlGroupAccess"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["controlGroupAccess"]++; }; 
	var oAccessPoint = oBrowserEvent["oSource"];
	var sAccessPoint = this["sGetAccessPoint"](oAccessPoint);
	var bInitialized = UCF_RadioButton["oRadioGroup"]["bGroupInitialized"];
	var sAccessType = this["sGetAccessType"]();

	if (sAccessType === this["eAccessType"]["FIRST_ACCESS"] && bInitialized)
		return this["eHandleGroupAccessBy"]["EXITING"];

	if (sAccessType !== this["eAccessType"]["FIRST_ACCESS"] && bInitialized)
		return this["eHandleGroupAccessBy"]["STOPPING"];

	if (sAccessType === this["eAccessType"]["FIRST_ACCESS"] && !bInitialized)
		return this["eHandleGroupAccessBy"]["CONTINUING"];

	switch (sAccessPoint) {
		case this["eAccessPoint"]["ROOT"]:
			return this["eHandleGroupAccessBy"]["STOPPING"];
		case this["eAccessPoint"]["RADIO"]:
			return this["eHandleGroupAccessBy"]["CONTINUING"];
		case this["eAccessPoint"]["NAV_HELPER"]:
			return this["eHandleGroupAccessBy"]["CONTINUING"];
	}

	// Focus triggered by navigation or programatically
	if (sAccessType === this["eAccessType"]["NAVIGATION"] ||
		sAccessType === this["eAccessType"]["FOCUS_MOVED"])
		return this["eHandleGroupAccessBy"]["STOPPING"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["controlGroupAccess"] = 0; };

/**
 * Special handling for personas
 *
 * @private
 * @param {boolean} bFormBackNavigation
 * @param {boolean} bIsExternalTabSequence
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["focus"] = function(bFormBackNavigation, bIsExternalTabSequence) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["focus"]++; }; 
	if (this["bIsVisible"]()) {
		this["bIsExternalTabSequence"] = bIsExternalTabSequence;
		this["removeOwnTabSequence"](bIsExternalTabSequence);
	}
	UCF_RadioButton.prototype["focus"]["call"](this, bFormBackNavigation, bIsExternalTabSequence);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["focus"] = 0; };

/**
 * Special handling for personas
 *
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["bIsFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bIsFocusable"]++; }; 
	if (window["UCF_System"]["bIs508"] || (this["bEnabled"] && !this["bReadonly"]))
		return (this["oFocusDomRef"] && UCF_DomUtil["bHasTabIndex"](this["oFocusDomRef"]));
	else
		return false;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bIsFocusable"] = 0; };

/**
 * Special handling for personas
 *
 * @private
 * @param {boolean} bIsExternalTabSequence
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["removeOwnTabSequence"] = function(bIsExternalTabSequence) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["removeOwnTabSequence"]++; }; 
	var oFilteredRadiosData = this["oCollectRadios"]();
	this["oCREATE__RadioGroup"](oFilteredRadiosData);
	var oNavHelperWithFocus = UCF_DomUtil["$"](oFilteredRadiosData["oRadioWithFocus"]["oRadio"]["sId"] + '-NAV_HELPER');
	UCF_DomUtil["setTabIndex"](oNavHelperWithFocus, -1);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["removeOwnTabSequence"] = 0; };
/**
 * Handles the onlsfocus event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsfocus"]++; }; 

	// -- An indefinite group is a group that could not be created.
	if (this["sName"] === this["eFilterBy"]["NO_NAME_ASSIGNED"]) {
		UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"] = true;
		return;
	}

	// -- access-key handling, force select...
	if (oBrowserEvent["bAlt"]()) {
		this["handleSelection"]();
	}

	// -- someone has defined a tabsequence of their own.
	if (this["bIsExternalTabSequence"]) {
		this["removeOwnTabSequence"]();
		return;
	}

	// -- special handling for sap table
	if (this["bUsedInSapTable"] === true) {
		this["sapTableHandling"]();
		return;
	}

	// --
	if (this["controlGroupAccess"](oBrowserEvent) !==
		this["eHandleGroupAccessBy"]["CONTINUING"]) return;

	// --Create all fields and object necessary for navigation
	var sAccessResult = this["onFirstGroupAccess"]();

	// -- Group cannot be accessed most likely because there is no enabled radio
	if (sAccessResult === this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"]) return;

	if (!window["UCF_System"]["bIs508"] && this["bUseOwnNavigation"]) {
		var oFirstRadioToFocus = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"]["oFocusDomRef"];

		UCF_RadioButton["oRadioGroup"]["sExitType"] = this["eExitType"]["FOCUS_MOVED"];
		UCF_RadioButton["oRadioGroup"]["sAccessType"] = this["eAccessType"]["FOCUS_MOVED"];
		UCF_DomUtil["setTabIndex"](oFirstRadioToFocus, 0);

		var oAccessPoint = oBrowserEvent["oSource"];
		var sAccessPoint = this["sGetAccessPoint"](oAccessPoint);

		//var oSelected	 = UCF_RadioButton.oRadioGroup.oSelected.oRadio;
		if (sAccessPoint === this["eAccessPoint"]["NAV_HELPER"]) { //||
			// (sAccessPoint === this.eAccessPoint.ROOT && oSelected && oAccessPoint.id !== oSelected.sId)) {
			UCF_DomUtil["focusDomElement"](oFirstRadioToFocus);
		}
	}

	// -- update ARIA if necessary
	if (window["UCF_System"]["bIsAria"] && window["UCF_System"]["sDevice"] === 'standards') { // && this.bFeatureFlagOn) {
		this["oRadioButtonBase"]["updateAriaInfo"](this);
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsfocus"] = 0; };

/**
 * @private
 * @param {UCF_FocusInfo_Object} oFocusInfo
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "RadioButtonKeyboard_ie6.js(780): collectFocusInfo"); };
	var oRadio;
	try {
		oRadio = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"];
	} catch (e) {
		oRadio = null;
	}
	if (!UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"] && oRadio) {
		oFocusInfo["setApplyControl"](oRadio);
	} else {
		oFocusInfo["setFocussedId"](oFocusInfo["sFocussedId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["collectFocusInfo"] = 0; };

/**
 * @private
 * @param {UCF_FocusInfo_Object} oFocusInfo
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "RadioButtonKeyboard_ie6.js(799): applyFocusInfo"); };
	UCF_DomUtil["$"](this["sId"] + '-NAV_HELPER')["focus"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["applyFocusInfo"] = 0; };

/**
 * Special handling for the SAP Table
 * In the SAP Table the radio button group must not navigate nor assign a focus of its own
 * Focus handling and navigation is passed on to the SAP Table.
 * Any interference might lead to recursive focus assignments which in return cause
 * the browser to crash.
 * To avoid this we rather handle radio groups in SAP Tables with special
 * methods
 *
 * @private
 *
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["sapTableHandling"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sapTableHandling"]++; };  //check F2
	// Create all fields and objects necessary for navigation
	//var sAccessResult = this.onFirstGroupAccess();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["sapTableHandling"] = 0; };

/**
 * Handles the onlsblur event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsblur"]++; }; 

	//_trace(ERROR, 'Blur Fired by: ' + this.sText + ' with id: ' + oBrowserEvent.oSource.id);

	// Focus was moved programatically from the nav helper to the DomRef
	if (this["sGetAccessPoint"](oBrowserEvent["oSource"]) === this["eAccessPoint"]["NAV_HELPER"])
		return;
	// handle the sematic of the blur event
	if (UCF_RadioButton["oRadioGroup"]["bGroupInitialized"]) {
		var sExitType = this["sGetExitType"](oBrowserEvent);
		if (sExitType === this["eExitType"]["EXIT"] ||
			sExitType === this["eExitType"]["RADIO_FOCUS_LOST"]) { //check for lost focus
			this["onRadioGroupExit"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsblur"] = 0; };

/**
 * See UCF_ClientRadioButton.setChecked()
 * @private
 * @param {boolean} bSelect
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["handleClientSideSelection"] = function(bSelect) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["handleClientSideSelection"]++; }; 

	var sAccessResult = this["onFirstGroupAccess"]();

	// Group cannot be accessed most likely because there is no enabled radio
	if (sAccessResult === this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"])
		return;
	if (bSelect) {
		this["assignSelection"]();
	} else {
		this["removeSelection"]();
	}
	if (!this["bUseTabNavigation"]() && this["bUseOwnNavigation"])
		this["focusRadio"](this);

	var sAccessType = (this["bUnFocusableFocused"]()) ?
		this["eAccessType"]["INACCESSIBLE_ACCESSED"] :
		this["eAccessType"]["ACCESSIBLE_ACCESSED"];

	this["updateRadioGroup"](
		/* Selected:   */
		this["oUpdateSelectedRadioData"](this),
		/* Focused: 	 */
		this,
		/* AccessType: */
		sAccessType,
		/* ExitType: 	 */
		this["eExitType"]["SELECTION"]
	);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["handleClientSideSelection"] = 0; };

/**
 * Handles the onclick event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(886): onclick"); };

	// if (oBrowserEvent.sName === 'click' && UCF_System.sInteractionType === 'TOUCH') return;

	// An indefinite group is a group that could not be created.
	if (this["sName"] === this["eFilterBy"]["NO_NAME_ASSIGNED"]) {
		this["assignSelection"]();
		this["fireChange"](this["sId"], this["bChecked"]);
		return;
	}

	//after clickling into nav bar of browser old group is still active while new was not created
	if (this["controlGroupAccess"](oBrowserEvent) === this["eHandleGroupAccessBy"]["EXITING"])
		this["onRadioGroupExit"]();

	// handle the semantic of the click event
	if (this["controlGroupAccess"](oBrowserEvent) === this["eHandleGroupAccessBy"]["CONTINUING"]) {
		var sAccessResult = this["onFirstGroupAccess"]();
	}

	// Group cannot be accessed most likely because there is no enabled radio
	if (sAccessResult === this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"]) return;

	//if (!this.bUseTabNavigation() && this.bUseOwnNavigation)
	if (this["bUseOwnNavigation"])
		this["focusRadio"](this);

	this["handleSelection"](oBrowserEvent);

	var sAccessType = (this["bUnFocusableFocused"]()) ?
		this["eAccessType"]["INACCESSIBLE_ACCESSED"] :
		this["eAccessType"]["ACCESSIBLE_ACCESSED"];

	this["updateRadioGroup"](
		/* Selected: */
		this["oUpdateSelectedRadioData"](this),
		/* Focused: 	 */
		this,
		/* AccessType: */
		sAccessType,
		/* ExitType: 	 */
		this["eExitType"]["SELECTION"]
	);

	if (oBrowserEvent)
		oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onclick"] = 0; };
/**
 * Responsible for the value that updates the field oSelected of the
 * stative variable oRadioGroup. If the previous routines could select the
 * according radio button it will return it. If not it will return null
 *
 * @private
 * @param {UCF_RadioButton} oRadioToSelect
 * @return {UCF_RadioButton}
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["oUpdateSelectedRadioData"] = function(oRadioToSelect) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oUpdateSelectedRadioData"]++; }; 
	var sStatus = this["sGetSelectionStatus"](oRadioToSelect);
	if (sStatus === this["eSelectionStatus"]["SELECTED"])
		return oRadioToSelect;
	return null;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oUpdateSelectedRadioData"] = 0; };

/**
 * Updates those fields of the global radio group object whose values have been
 * modified through navigation or selection
 *
 * @private
 * @param {UCF_RadioButton} oSelected
 * @param {UCF_RadioButton} oFocused
 * @param {string} sAccessType
 * @param {string} sExitType
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["updateRadioGroup"] = function(oSelected, oFocused, sAccessType, sExitType) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["updateRadioGroup"]++; }; 
	var iRadioIndex;
	if (oSelected) {
		iRadioIndex = this["iGetRadioIndex"](oSelected);
		UCF_RadioButton["oRadioGroup"]["oSelected"]["oRadio"] = oSelected;
		UCF_RadioButton["oRadioGroup"]["oSelected"]["iIndex"] = iRadioIndex;
	}
	if (oFocused) {
		iRadioIndex = this["iGetRadioIndex"](oFocused);
		UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"] = oFocused;
		UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["iIndex"] = iRadioIndex;
	}
	if (sAccessType)
		UCF_RadioButton["oRadioGroup"]["sAccessType"] = sAccessType;
	if (sExitType)
		UCF_RadioButton["oRadioGroup"]["sExitType"] = sExitType;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["updateRadioGroup"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(984): ondblclick"); };
	if (this["mEvents"]["DoubleClick"]) {
		this["fireDoubleClick"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["ondblclick"] = 0; };

/**
 * Handles the onkeydown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(998): onkeydown"); };
	var iKey = oBrowserEvent["iKeyCode"]();
	// toggle navigation mode for radio buttons in tables, the whole radio button
	// group is toggled
	if (iKey === UCF_KeyCodes["F2"] && this["bUsedInSapTable"]) {
		this["bUseOwnNavigation"] = !this["bUseOwnNavigation"];
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onkeydown"] = 0; };

/**
 * Handles the onmousedown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1015): onmousedown"); };
	if (!this["bEnabled"] || this["bReadonly"]) return;
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onmousedown"] = 0; };

/**
 * Handles the onlsright event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsright"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1027): onlsright"); };
	// check if navigation mode is on
	if (!this["bUseOwnNavigation"] || UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]) return;
	this["updateRadioGroup"](null, null, this["eAccessType"]["NAVIGATION"], this["eAccessType"]["NAVIGATION"]);
	var oNext = this["oGetNext"]();
	if (oNext) {

		oNext["focusRadio"]();
		oNext["handleSelection"]();

		this["updateRadioGroup"](
			/* Selected:  */
			this["oUpdateSelectedRadioData"](oNext),
			/* Focused:   */
			oNext,
			/* AccessType:*/
			null,
			/* ExitType:  */
			null
		);
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsright"] = 0; };

/**
 * Handles the onlsrightmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsrightmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsrightmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1059): onlsrightmodifier"); };

	// check if navigation mode is on
	if (!this["bUseOwnNavigation"] ||
			UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"] ||
			!UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) return;

	this["updateRadioGroup"](null, null, this["eAccessType"]["NAVIGATION"], this["eAccessType"]["NAVIGATION"]);

	// handle only shift
	if (oBrowserEvent["bAlt"]()) return;

	var oNext = this["oGetNext"]();
	if (oNext) {
		oNext["focusRadio"]();
		this["updateRadioGroup"](
			/* Selected:   */
			null,
			/* Focused:    */
			oNext,
			/* AccessType: */
			null,
			/* ExitType:   */
			null
		);
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsrightmodifier"] = 0; };
/**
 * Handles the onlsdown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsdown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1095): onlsdown"); };
	if (!this["bUseOwnNavigation"] || UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]) return;
	this["onlsright"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsdown"] = 0; };
/**
 * Handles the onlsdownmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsdownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsdownmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1106): onlsdownmodifier"); };
	if (!this["bUseOwnNavigation"] ||
		UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"] ||
		!UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) return;
	this["onlsrightmodifier"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsdownmodifier"] = 0; };
/**
 * Handles the onlsleft event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsleft"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1119): onlsleft"); };

	if (!this["bUseOwnNavigation"] || UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]) return;

	// check if navigation mode is on
	if (!this["bUseOwnNavigation"]) return;

	this["updateRadioGroup"](null, null, this["eAccessType"]["NAVIGATION"], this["eAccessType"]["NAVIGATION"]);
	var oPrevious = this["oGetPrevious"](oBrowserEvent);
	if (oPrevious) {
		oPrevious["focusRadio"]();
		oPrevious["handleSelection"]();

		this["updateRadioGroup"](
			/* Selected:   */
			this["oUpdateSelectedRadioData"](oPrevious),
			/* Focused:    */
			oPrevious,
			/* AccessType: */
			null,
			/* ExitType:   */
			null
		);
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsleft"] = 0; };

/**
 * Handles the onlsleftmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsleftmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsleftmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1154): onlsleftmodifier"); };

	if (!this["bUseOwnNavigation"] ||
		UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"] ||
		!UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) return;

	// check if navigation mode is on
	if (!this["bUseOwnNavigation"]) return;

	// handle only shift
	if (oBrowserEvent["bAlt"]()) return;

	this["updateRadioGroup"](null, null, this["eAccessType"]["NAVIGATION"], this["eAccessType"]["NAVIGATION"]);

	var oPrevious = this["oGetPrevious"](oBrowserEvent);
	if (oPrevious) {
		oPrevious["focusRadio"]();

		this["updateRadioGroup"](
			/* Selected:   */
			null,
			/* Focused:    */
			oPrevious,
			/* AccessType: */
			null,
			/* ExitType:   */
			null
		);
	}
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsleftmodifier"] = 0; };

/**
 * Handles the onlsup event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1194): onlsup"); };
	if (!this["bUseOwnNavigation"] || UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]) return;
	this["onlsleft"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsup"] = 0; };

/**
 * Handles the onlsupmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsupmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1206): onlsupmodifier"); };
	if (!this["bUseOwnNavigation"] ||
			UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"] ||
			!UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) return;
	this["onlsleftmodifier"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsupmodifier"] = 0; };

/**
 * Handles the onlshome event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlshome"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1220): onlshome"); };
	// check if navigation mode is on
	if (!this["bUseOwnNavigation"] ||
		 UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"] ||
		 UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent) === false) return;
	var oFirst = this["oGetFirstInGroup"]();
	if (oFirst) {
		this["updateRadioGroup"](null, null, this["eAccessType"]["NAVIGATION"], this["eAccessType"]["NAVIGATION"]);
		oFirst["focusRadio"]();
		oFirst["handleSelection"]();

		this["updateRadioGroup"](
			/* Selected:   */
			this["oUpdateSelectedRadioData"](oFirst),
			/* Focused:    */
			oFirst,
			/* AccessType: */
			null,
			/* ExitType:   */
			null
		);
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlshome"] = 0; };

UCF_RadioButtonKeyboard_ie6["prototype"]["oGetFirstInGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oGetFirstInGroup"]++; }; 
	var aRadios = UCF_RadioButton["oRadioGroup"]["aRadios"];
	return aRadios[0];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oGetFirstInGroup"] = 0; };

UCF_RadioButtonKeyboard_ie6["prototype"]["oGetLastInGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oGetLastInGroup"]++; }; 
	var aRadios = UCF_RadioButton["oRadioGroup"]["aRadios"];
	return aRadios[aRadios["length"] - 1];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oGetLastInGroup"] = 0; };

/**
 * Handles the onlshomemodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlshomemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlshomemodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1262): onlshomemodifier"); };

	if (!this["bUseOwnNavigation"] ||
			UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"] ||
			!UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) return;

	var oFirst = this["oGetFirstInGroup"]();

	if (oFirst) {
		this["updateRadioGroup"](null, null, this["eAccessType"]["NAVIGATION"], this["eAccessType"]["NAVIGATION"]);
		oFirst["focusRadio"]();

		this["updateRadioGroup"](
			/* Selected:   */
			null,
			/* Focused:    */
			oFirst,
			/* AccessType: */
			null,
			/* ExitType:   */
			null
		);
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlshomemodifier"] = 0; };

/**
 * Handles the onlsend event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1295): onlsend"); };

	if (!this["bUseOwnNavigation"] || UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]) return;
	// check if navigation mode is on
	if (!this["bUseOwnNavigation"]) return;

	this["updateRadioGroup"](null, null, this["eAccessType"]["NAVIGATION"], this["eAccessType"]["NAVIGATION"]);

	var oLast = this["oGetLastInGroup"]();

	if (oLast) {
		oLast["focusRadio"]();
		oLast["handleSelection"]();

		this["updateRadioGroup"](
			/* Selected:   */
			this["oUpdateSelectedRadioData"](oLast),
			/* Focused:    */
			oLast,
			/* AccessType: */
			null,
			/* ExitType:   */
			null
		);
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsend"] = 0; };

/**
 * Handles the onlsendmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlsendmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsendmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1330): onlsendmodifier"); };
	if (!this["bUseOwnNavigation"] ||
			UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"] ||
			!UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) return;

	var oLast = this["oGetLastInGroup"]();
	if (oLast) {
		this["updateRadioGroup"](null, null, this["eAccessType"]["NAVIGATION"], this["eAccessType"]["NAVIGATION"]);
		oLast["focusRadio"]();

		this["updateRadioGroup"](
			/* Selected    */
			null,
			/* Focused     */
			oLast,
			/* AccessType: */
			null,
			/* ExitType:   */
			null
		);
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlsendmodifier"] = 0; };

/**
 * Handles the onlstabnext event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlstabnext"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1361): onlstabnext"); };

	if (!this["bUseOwnNavigation"] || UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]) return;
	// check if navigation mode is on
	if (!this["bUseOwnNavigation"]) return;
	if (window["UCF_System"]["bIs508"]) {

		this["updateRadioGroup"](
			/* Selected   */
			null,
			/* Focused    */
			this["oGetNext"](),
			/* AccessType:*/
			this["eAccessType"]["NAVIGATION"],
			/* ExitType:  */
			this["eExitType"]["NAVIGATION"]
		);
	}
	UCF_RadioButton["oRadioGroup"]["sExitType"] = this["eExitType"]["EXIT"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlstabnext"] = 0; };

/**
 * Handles the onlstabprevious event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlstabprevious"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_ie6.js(1389): onlstabprevious"); };

	if (!this["bUseOwnNavigation"] || UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]) return;
	// check if navigation mode is on
	if (!this["bUseOwnNavigation"]) return;

	if (window["UCF_System"]["bIs508"]) {
		this["updateRadioGroup"](
			/* Selected:   */
			null,
			/* Focused:    */
			this["oGetPrevious"](),
			/* AccessType: */
			this["eAccessType"]["NAVIGATION"],
			/* ExitType:   */
			this["eExitType"]["NAVIGATION"]
		);
	}
	UCF_RadioButton["oRadioGroup"]["sExitType"] = this["eExitType"]["EXIT"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["onlstabprevious"] = 0; };

/**
 * Finds out whether the group has a radio that is both disabled/readonly and slected
 *
 * @private
 * @return {boolean}
 *
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["bhandleUnSelectableAndSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bhandleUnSelectableAndSelected"]++; }; 
	if (!UCF_RadioButton["oRadioGroup"]["bGroupInitialized"])
		return false;
	return UCF_RadioButton["oRadioGroup"]["oUnSelectableAndSelected"]["oRadio"] != null;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bhandleUnSelectableAndSelected"] = 0; };

/**
 * Performs all actions necessary during focusing a radio
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["focusRadio"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["focusRadio"]++; }; 
	var oDomRefToFocus = this["oFocusDomRef"],
		oDomRefToUnFocus = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"]["oFocusDomRef"];
	if (!this["bUseTabNavigation"]()) {
		UCF_DomUtil["resetTabIndex"](oDomRefToUnFocus);
		UCF_DomUtil["setTabIndex"](oDomRefToFocus, 0);
	}
	//	UCF_DomUtil.focusDomElement(oDomRefToFocus);
	UCF_DomUtil["refocusDomElement"](oDomRefToFocus);

	if (window["UCF_System"]["bIsAria"] && window["UCF_System"]["sDevice"] === 'standards') { //&& this.bFeatureFlagOn) {
		this["oRadioButtonBase"]["updateAriaInfo"](this);
	}

};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["focusRadio"] = 0; };

/**
 * Get the next radio button in the group. If the radio button is already the
 * last one, the radio button itself is returned.
 *
 * @return {UCF_RadioButton} next radio button in the group
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["oGetNext"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oGetNext"]++; }; 

	if (!this["bCanNavigate"]) return;

	var aRadios = UCF_RadioButton["oRadioGroup"]["aRadios"],
		iNextRadio;

	if (this["bUnFocusableFocused"]()) {
		iNextRadio = this["iGetNextToUnFocusable"]();
		return aRadios[iNextRadio];
	}

	var iAllRadios = aRadios["length"] - 1,
		iFocusedRadio = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["iIndex"];
	iNextRadio = (iFocusedRadio >= iAllRadios) ? 0 : (iFocusedRadio + 1);

	return aRadios[iNextRadio];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oGetNext"] = 0; };

/**
 * Determines whether the radio focused is actually unfocusable due to its status
 * @private
 * @return {boolean}
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["bUnFocusableFocused"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bUnFocusableFocused"]++; }; 
	return UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["iIndex"] === -1;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bUnFocusableFocused"] = 0; };

/**
 * Returns the index of the radio that would be next to the unfocusable in the tab chain.
 *
 * @private
 * @return {integer}
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["iGetNextToUnFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["iGetNextToUnFocusable"]++; }; 
	var sId = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"]["sId"],
		iNext = UCF_RadioButton["oRadioGroup"]["mIdMap"][sId]["iNext"];
	if (iNext >= UCF_RadioButton["oRadioGroup"]["aRadios"]["length"] - 1) {
		return 0;
	}
	return iNext;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["iGetNextToUnFocusable"] = 0; };

/**
 * Returns the index of the radio that would be prior to the unfocusable in the tab chain.
 *
 * @private
 * @return {integer}
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["iGetPreviousToUnFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["iGetPreviousToUnFocusable"]++; }; 
	var sId = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"]["sId"],
		iPrevious = UCF_RadioButton["oRadioGroup"]["mIdMap"][sId]["iNext"] - 1;
	if (iPrevious < 0) {
		return UCF_RadioButton["oRadioGroup"]["aRadios"]["length"] - 1;
	}
	return iPrevious;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["iGetPreviousToUnFocusable"] = 0; };

/**
 * Get the previous radio button in the radio button group. If the radio button
 * is already the first one, the radio button itself is returned.
 * @return {UCF_RadioButton}
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["oGetPrevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oGetPrevious"]++; }; 

	if (!this["bCanNavigate"]) return;

	var aRadios = UCF_RadioButton["oRadioGroup"]["aRadios"],
		iPreviousRadio;

	if (this["bUnFocusableFocused"]()) {
		iPreviousRadio = this["iGetPreviousToUnFocusable"]();
		return aRadios[iPreviousRadio];
	}

	var iAllRadios = aRadios["length"] - 1,
		iFocusedRadio = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["iIndex"];
	iPreviousRadio = (iFocusedRadio <= 0) ? iAllRadios : (iFocusedRadio - 1);
	return aRadios[iPreviousRadio];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["oGetPrevious"] = 0; };

/**
 * Determines whether or not focus navigation is possible / necessary
 *
 * @private
 * @return {boolean}
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["bCanNavigate"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bCanNavigate"]++; }; 
	var oRadioGroup = UCF_RadioButton["oRadioGroup"];
	if (oRadioGroup["bGroupInitialized"] === false) return false;
	if (oRadioGroup["bGroupInitialized"] === true && oRadioGroup["aRadios"]["length"] < 2) return false;
	return true;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bCanNavigate"] = 0; };

/**
 * Defines whether all RadioButtons including not selected RadioButton can be
 * reached by tab. true: It is possible to tab through all RadioButtons by Tab
 * false: Only the selected RadioButton has a tab stop all others are not in the
 * TabChain. Tab jumps out of the RadioButtonGroup
 *
 * @return {boolean} Tab Navigation Mode The value of the RadioButton
 * @private
 */
UCF_RadioButtonKeyboard_ie6["prototype"]["bUseTabNavigation"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bUseTabNavigation"]++; }; 
	return window["UCF_System"]["bIs508"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_ie6["_"]["bUseTabNavigation"] = 0; };

};
sap["ls"]["preload"]["UCF_RadioButtonKeyboard_standards"] = function() {/* global UCF_Tracer, _assert, _trace, INFO, DEBUG, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_RadioButton */
/// <reference path="./RadioButton.js"/>
/* global UCF_Selector_508_Delegate */
/// <reference path="./delegates/Selector_508_Delegate.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>

/**
 *
 * @param {HTMLElement} oDomRef
 * @param {LightSpeed} oLS
 */
function UCF_RadioButtonKeyboard_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["UCF_RadioButtonKeyboard_standards"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "RadioButtonKeyboard_standards.js(35): UCF_RadioButtonKeyboard_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RadioButtonKeyboard_standards.js(36): UCF_RadioButtonKeyboard_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "RadioButtonKeyboard_standards.js(37): UCF_RadioButtonKeyboard_standards"); };

	UCF_RadioButton["apply"](this, [oDomRef, oLS]);

	this["sGrouping"] = 'NONE';

	if (window["UCF_System"]["bIs508"]) {
		this["Delegate_508"] = new (UCF_ClassLoader["oGetClass"]("UCF_Selector_508_Delegate"))(this);
		this["addDelegate"](this["Delegate_508"]);
	}

};window["UCF_RadioButtonKeyboard_standards"] = UCF_RadioButtonKeyboard_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RadioButtonKeyboard_standards"); UCF_RadioButtonKeyboard_standards["_"] = {UCF_RadioButtonKeyboard_standards: 0}; }; ;

UCF_RadioButtonKeyboard_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_RadioButton"))(); UCF_RadioButtonKeyboard_standards.prototype["sClassName"] = "UCF_RadioButtonKeyboard_standards";

/**
 * ############################################################################
 *
 * SECTION RESPONSIBLE FOR FOCUS NAVIGATION
 *
 * ############################################################################
 */

/**
 * Enumeration
 *
 * Determines the access point of the group. Every radio button has an
 * additional empty SPAN that serves as navigation helper. The helper SPAN has
 * the tab index in a yet undetermined group. The SPAN is identified as
 * NAV_HELPER. With root we identify the root element of the focusDomRef
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["eAccessPoint"] = {
	"ROOT": 'ROOT',
	"NAV_HELPER": 'NAV_HELPER',
	"RADIO": 'RADIO',
	"IMAGE": 'IMAGE',
	"UNKNOWN": 'UNKNOWN'
};

/**
 * @param {HTMLElement} oDomRef
 * @return {string} the access point.
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["sGetAccessPoint"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetAccessPoint"]++; }; 
	/** @type {string} determines the element focused upon first access*/
	var sAccessPoint;

	sAccessPoint = oDomRef["getAttribute"]('accessPoint');
	switch (sAccessPoint) {
		case this["eAccessPoint"]["NAV_HELPER"]:
			return this["eAccessPoint"]["NAV_HELPER"];
		case this["eAccessPoint"]["ROOT"]:
			return this["eAccessPoint"]["ROOT"];
		case this["eAccessPoint"]["RADIO"]:
			return this["eAccessPoint"]["RADIO"];
		case this["eAccessPoint"]["IMAGE"]:
			return this["eAccessPoint"]["IMAGE"];
		default:
			return this["eAccessPoint"]["UNKNOWN"];
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetAccessPoint"] = 0; };

/** @typedef {'SELECTABLE'|'UNSELECTABLE_AND_SELECTED'|'UNSELECTABLE'|'SELECTED'} UCF_RadioButtonKeyboard_standards_SelectionStatus */
/**
 * Enumeration
 *
 * Lists the different statuses of a radio button that take influence on its focus navigation
 *
 * @private
 * @enum {UCF_RadioButtonKeyboard_standards_SelectionStatus}
 */
UCF_RadioButtonKeyboard_standards["prototype"]["eSelectionStatus"] = {
	"SELECTABLE": 'SELECTABLE', // this property excludes all the following an provides the information that a radio button with this status can be selected
	"UNSELECTABLE_AND_SELECTED": 'UNSELECTABLE_AND_SELECTED',
	"UNSELECTABLE": 'UNSELECTABLE',
	"SELECTED": 'SELECTED'
};
/**
 *
 * @param {UCF_RadioButton} oRadio
 * @return {string} determines whether a radio can be selected depending on the combinations of its different states.
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["sGetSelectionStatus"] = function(oRadio) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetSelectionStatus"]++; }; 
	if (oRadio["bChecked"] && oRadio["bReadonly"])
		return this["eSelectionStatus"]["UNSELECTABLE_AND_SELECTED"];

	if (oRadio["bChecked"] && !oRadio["bEnabled"])
		return this["eSelectionStatus"]["UNSELECTABLE_AND_SELECTED"];

	if (!oRadio["bEnabled"] && !oRadio["bChecked"])
		return this["eSelectionStatus"]["UNSELECTABLE"];

	if (oRadio["bReadonly"] && !oRadio["bChecked"])
		return this["eSelectionStatus"]["UNSELECTABLE"];

	if (oRadio["sAssociatedEditContext"] === 'PARENTREADONLY')
		return this["eSelectionStatus"]["UNSELECTABLE"];

	if (oRadio["bEnabled"] && !oRadio["bReadonly"] && oRadio["bChecked"])
		return this["eSelectionStatus"]["SELECTED"];

	return this["eSelectionStatus"]["SELECTABLE"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetSelectionStatus"] = 0; };

/**
 * Enumeration
 *
 * Lists the different statuses of a radio button that take influence on its focus navigation
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["eNavigationStatus"] = {
	"ACCESSIBLE": 'ACCESSIBLE', // this property excludes all the following an provides the information that a radio button with this status can be selected
	"INACCESSIBLE": 'INACCESSIBLE' // selection not possible
};

/**
 * Enumeration
 *
 * Lists of controls that can be in chanrge of focus navigation
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["eNavigationControledBy"] = {
	"RADIO_BUTTON_ARROWS": 'RADIO_BUTTON_ARROWS',
	"RADIO_BUTTON_TABS": 'RADIO_BUTTON_TABS',
	"RADIO_BUTTON_TABS_IN_SAP_TABLE": 'RADIO_BUTTON_TABS_IN_SAP_TABLE',
	"RADIO_BUTTON_ARROWS_IN_SAP_TABLE": 'RADIO_BUTTON_ARROWS_IN_SAP_TABLE',
	"SAP_TABLE": 'SAP_TABLE'
};

/**
 * Enumeration
 *
 * All edit modes a radio can assume in the SAP_Table that can
 * take infuence on its navigation
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["eSAP_TableEditMode"] = {
	"F2_MODE_ON": 'F2_MODE_ON',
	"F2_MODE_OFF": 'F2_MODE_OFF'
};

/**
 * @private
 * @return {enum-value}
 */
// eslint-disable-next-line consistent-return
UCF_RadioButtonKeyboard_standards["prototype"]["whoControlsNavigation"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["whoControlsNavigation"]++; }; 

	var sSAP_TableEditMode = UCF_RadioButton["oRadioGroup"]["sSAP_TableEditMode"];

	// -- a standard radio group in ARIA and for the sighted user
	if (!this["bUsedInSapTable"] && !window["UCF_System"]["bIs508"])
		return this["eNavigationControledBy"]["RADIO_BUTTON_ARROWS"];

	// -- a standard radio group in 508
	if (window["UCF_System"]["bIs508"] && !this["bUsedInSapTable"])
		return this["eNavigationControledBy"]["RADIO_BUTTON_TABS"];

	// -- control belongs to the SAP table
	if (this["bUsedInSapTable"] && UCF_RadioButton["oRadioGroup"]["bGroupInitialized"] === false)
		return this["eNavigationControledBy"]["SAP_TABLE"];

	// -- control belongs to the SAP table
	if (this["bUsedInSapTable"] && sSAP_TableEditMode === this["eSAP_TableEditMode"]["F2_MODE_OFF"])
		return this["eNavigationControledBy"]["SAP_TABLE"];

	// a standard radio group in ARIA and the sighted user when F2 was pressed
	if (this["bUsedInSapTable"] && sSAP_TableEditMode === this["eSAP_TableEditMode"]["F2_MODE_ON"] && !window["UCF_System"]["bIs508"])
		return this["eNavigationControledBy"]["RADIO_BUTTON_ARROWS_IN_SAP_TABLE"];

	// -- a standard radio group in 508 within the SAP table when F2 edit mode is off
	if (window["UCF_System"]["bIs508"] && this["bUsedInSapTable"] && sSAP_TableEditMode === this["eSAP_TableEditMode"]["F2_MODE_OFF"])
		return this["eNavigationControledBy"]["SAP_TABLE"];

	// -- a standard radio group in 508 within the SAP table when F2 edit mode is on
	if (window["UCF_System"]["bIs508"] && this["bUsedInSapTable"] && sSAP_TableEditMode === this["eSAP_TableEditMode"]["F2_MODE_ON"])
		return this["eNavigationControledBy"]["RADIO_BUTTON_TABS_IN_SAP_TABLE"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["whoControlsNavigation"] = 0; };

/**
 *
 * Determines as to how focus navigation is to happen depending on the different modes for the non sighted and sighted user
 * @param {UCF_radioButton} oRadio
 * @return {string}
 * @private
 */
// eslint-disable-next-line consistent-return
UCF_RadioButtonKeyboard_standards["prototype"]["sGetNavigationStatus"] = function(oRadio) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetNavigationStatus"]++; }; 

	//Sighted user if ARIA and 508 are off
	//Non-sighted user if ARIA is on and 508 is off
	if ((window["UCF_System"]["bIsAria"] || window["UCF_System"]["sAccessibility"] === 'NONE')
		&& window["UCF_System"]["bIs508"] === false) {
		if (!oRadio["bEnabled"])
			return this["eNavigationStatus"]["INACCESSIBLE"];
		return this["eNavigationStatus"]["ACCESSIBLE"];
	}

	//non sighted user in 508 mode
	if (window["UCF_System"]["sAccessibility"] === 'CLASSIC'
		|| window["UCF_System"]["bIs508"])
		return this["eNavigationStatus"]["ACCESSIBLE"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetNavigationStatus"] = 0; };

/**
 * Enumeration
 * Lists the different sematics that a blur event can have
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["eExitType"] = {
	"REFOCUS": 'REFOCUS', // refocusDomRef triggers a programmatic blur that sets the focus on the body and gets the radio to fire a focus_lost
	"RADIO_FOCUS_LOST": 'RADIO_FOCUS_LOST', // Focus moved from the current radio button group to another element ===> destroy this group
	"FOCUS_MOVED": 'FOCUS_MOVED', // Focus was programmaticaly moved from one radio button to some other 	===> do not handle this
	"SELECTION": 'SELECTION', // Focus assigned to this element through mouse selection 	===> perform all necessary steps to select this radio button and deselect the previous if there is one
	"NAVIGATION": 'NAVIGATION', // Focus moved by navigational means 										===> ignore this
	"EXIT": 'EXIT', // The group has been exited 	==> destroy this group
	"SKIPPING": 'SKIPPING', // F6 Skipping ==> Destroy this group
	"NONE": 'NONE' // default
};

/**
 *
 * @return {boolean} true: radio is in current group
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["bAccessedRadioBelongsToGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bAccessedRadioBelongsToGroup"]++; }; 
	/** @type {Object} a radio accessed by click, touch etc. but not through focus */
	var oData;
	/** @type {Object} */
	var mRadioMap;

	mRadioMap = this["getValueOfGroupField"]('mIdMap');
	oData = this["getValueOfGroupField"]('oRadioNotAccessedByFocus');

	if (!mRadioMap || !oData || !oData["oRadio"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No map or radio found', "RadioButtonKeyboard_standards.js(281): bAccessedRadioBelongsToGroup"); };
		return null;
	} else {
		return (oData["oRadio"]["sId"] in mRadioMap);
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bAccessedRadioBelongsToGroup"] = 0; };

/**
 *
 * @return {boolean} true: id is in current group
 * @return {boolean} determines that the id of an unknown object belongs to
 * the current group
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["bAccessedIdBelongsToGroup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bAccessedIdBelongsToGroup"]++; }; 
	/** @type {string} */
	var sTargetId;
	/** @type {Object} */
	var mIdMap;

	try {
		sTargetId = oBrowserEvent["oDomEvent"]["relatedTarget"]["getAttribute"]('id');

		if (sTargetId &&
			UCF_StringUtil["bIsEmpty"](sTargetId) === false) {

			mIdMap = this["getValueOfGroupField"]('mIdMap');
			return (sTargetId in mIdMap);
		}
	} catch (oEx) {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bAccessedIdBelongsToGroup"] = 0; };

/**
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {string} how the user left the radio button they were working with
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["sGetExitType"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetExitType"]++; }; 

	// -- ignore this case. group is not there
	if (this["getValueOfGroupField"]('bGroupInitialized') === false) {
		return this["eExitType"]["NONE"];
	}

	// -- exit group with skipping
	if (this["getValueOfGroupField"]('sExitType') === this["eExitType"]["SKIPPING"]) {
		return this["eExitType"]["EXIT"];
	}

	// -- check if radio accessed by click, touch or VC is in curent group
	if (this["getValueOfGroupField"]('sExitType') === this["eExitType"]["SELECTION"]) {
		if (this["bAccessedRadioBelongsToGroup"]() === true) {
			return this["eExitType"]["NONE"];
		} else if (this["bAccessedRadioBelongsToGroup"]() === false) {
			return this["eExitType"]["EXIT"];
		}
	}

	// -- check if an element with an id was accessed and if the id is in the
	// -- current id map
	if (this["getValueOfGroupField"]('sExitType') === this["eExitType"]["NAVIGATION"]) {
		if (this["bAccessedIdBelongsToGroup"](oBrowserEvent) === true) {
			return this["eExitType"]["NONE"];
		} else if (this["bAccessedIdBelongsToGroup"](oBrowserEvent) === false) {
			return this["eExitType"]["EXIT"];
		}
	}

	// -- tab was pressed. handle this as exit
	// -- to do: what about tabnavigation
	if (oBrowserEvent &&
		oBrowserEvent["sName"] &&
		oBrowserEvent["sName"]["indexOf"]('tab') > -1) {
		return this["eExitType"]["EXIT"];
	}

	// -- do not handle focus when element was refocused
	if (this["getValueOfGroupField"]('sExitType') === this["eExitType"]["REFOCUS"]) {
		return this["eExitType"]["REFOCUS"];
	}

	// -- determine if focus has been lost
	if (this["bRadioFocusLost"](oBrowserEvent)) {
		return this["eExitType"]["RADIO_FOCUS_LOST"];
	}

	return this["getValueOfGroupField"]('sExitType');
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetExitType"] = 0; };

/**
 * The focus has been lost if the active element of the DOM does not have a
 * name-property or its value is not equal to the value of the current group
 *
 * @return {boolean} that determines whether the current radio group has lost the focus focus
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["bRadioFocusLost"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bRadioFocusLost"]++; }; 
	/** @type {HTML_element} */
	var oUnknownElement = UCF_DomUtil["oGetActiveElement"]();
	/** @type {string} */
	var sUnknonwId;
	/** @type {Object} */
	var mIdMap;
	/** @type {Object} */
	var oEntry;

	if (oUnknownElement && oUnknownElement["id"]) {
		sUnknonwId = oUnknownElement["id"];
	} else {
		return true;
	}
	if (sUnknonwId === 'ur-accfocus') {
		return false;
	}
	if (this["bInAccessibleRadioFocused"]()) return false;
	mIdMap = UCF_RadioButton["oRadioGroup"]["mIdMap"];
	try {
		oEntry = mIdMap[sUnknonwId["split"]('-')[0]];
		if (oEntry && typeof(oEntry) === 'object') {
			return false;
		} else {
			return true;
		}
	} catch (exception) {
		return true;
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bRadioFocusLost"] = 0; };

/**
 * Determines whether a radio with a status that makes it as inaccessible has been focused.
 * This mainly happens after the radio was clicked
 * @return {boolean}
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["bInAccessibleRadioFocused"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bInAccessibleRadioFocused"]++; }; 
	/** @type {HTML_element} */
	var oUnknownElement;
	/** @type {UCF_RadioButton} */
	var oInAccessibleRadio;
	/** @type {Object} */
	var oRadioWithFocus;

	oRadioWithFocus = this["getValueOfGroupField"]('oRadioWithFocus'); //UCF_RadioButton.oRadioGroup.oRadioWithFocus;

	if (!oRadioWithFocus || oRadioWithFocus["iIndex"] > -1) {
		return false;
	}

	oUnknownElement = UCF_DomUtil["oGetActiveElement"]();
	oInAccessibleRadio = oRadioWithFocus["oRadio"]["oFocusDomRef"];

	return (oUnknownElement === oInAccessibleRadio);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bInAccessibleRadioFocused"] = 0; };

/** @typedef {'NAVIGATION'|'ACCESSIBLE_ACCESSED'|'INACCESSIBLE_ACCESSED'|'FIRST_ACCESS'|'FOCUS_MOVED'|'NONE'} UCF_RadioButtonKeyboard_standards_AccessType */
/**
 * Enumeration
 *
 * Lists the different sematics that a focus event can have
 * @private
 * @enum {UCF_RadioButtonKeyboard_standards_AccessType}
 */
UCF_RadioButtonKeyboard_standards["prototype"]["eAccessType"] = {
	//-- focus moved by navigation
	//-- => important for focus listener. Handler must ignore this case:
	"NAVIGATION": 'NAVIGATION',

	//-- focus assigned through selection
	// -- => perform all necessary selection steps:
	"ACCESSIBLE_ACCESSED": 'ACCESSIBLE_ACCESSED',

	//-- The means used (Mouse, Touch, AT) accesed an unselectable radio.
	//-- Focus is now on an item that is not part of the navigation if 508 is off.
	//-- => Find according previous or next item in radio array:
	"INACCESSIBLE_ACCESSED": 'INACCESSIBLE_ACCESSED',

	//-- Determines the very first access and is predefined in the field sAccessType.
	//-- => Collect radios, create radio group etc.
	"FIRST_ACCESS": 'FIRST_ACCESS',

	//-- First focusing of a radio that belongs to a group
	//-- Typically focus is moved from nav-helper to root, which refocuses either
	//-- the same radio or a different one in the group
	//-- => important for focus listener. Handler must ignore this case
	"FOCUS_MOVED": 'FOCUS_MOVED',

	//-- Any other means but focus navigation (i.e. touch, AT, mouse etc) accessed a radio.
	//-- Typically to select it. Radio will be refocused programatically.
	//-- => important for focus listener. Handler must ignore this case
	"SELECTION": 'SELECTION', // To select through key or mouse focus needs to be set programatically but no refocus required.

	//-- An access of an unimportant kind ocurred
	//-- => Do not handle this case
	"NONE": 'NONE',

	//-- Something went wrong.
	//-- => Trace the error in the console
	"UNDEFINED": 'UNDEFINED'
};
/**
 *
 * @return {string} the sematic of a radio button's receiving focus
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["sGetAccessType"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetAccessType"]++; }; 
	/** @type {Object} */
	var oRadioGroup = UCF_RadioButton["oRadioGroup"];
	/** @type {string} */
	var sName = this["getValueOfGroupField"]('sName'); //UCF_RadioButton.oRadioGroup.sName;
	/** @type {boolean} */
	var bGroupInitialized = this["getValueOfGroupField"]('bGroupInitialized'); //UCF_RadioButton.oRadioGroup.bGroupInitialized;
	/** @type {string} */
	var sAccessType;

	if (bGroupInitialized === false || oRadioGroup === null) {
		sAccessType = this["eAccessType"]["FIRST_ACCESS"];
	} else if (bGroupInitialized === true && sName !== this["sName"]) {
		sAccessType = this["eAccessType"]["FIRST_ACCESS"];
	} else if (bGroupInitialized && oRadioGroup
		&& oRadioGroup["sAccessType"] !== this["eAccessType"]["NONE"]) {
		sAccessType = oRadioGroup["sAccessType"];
	} else {
		sAccessType = this["eAccessType"]["NONE"];
	}
	return sAccessType;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetAccessType"] = 0; };

/** @typedef {'GROUP_ACCESSED'|'GROUP_NOT_ACCESSIBLE'} UCF_RadioButtonKeyboard_standards_AccessResult */
/**
 * Returns whether the first access of a radio group was successful.
 * Returns a negative result if the group consits of inaccessible radios only.
 *
 * @private
 * @enum {UCF_RadioButtonKeyboard_standards_AccessResult}
 */
UCF_RadioButtonKeyboard_standards["prototype"]["eAccessResult"] = {
	"GROUP_ACCESSED": 'GROUP_ACCESSED',
	"GROUP_NOT_ACCESSIBLE": 'GROUP_NOT_ACCESSIBLE'
};

/**
 * Determines whether a radio group could be created
 * @param {Object} oFilteredRadios
 * @return {string}
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["sGetAccessResult"] = function(oFilteredRadios) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetAccessResult"]++; }; 
	if (oFilteredRadios["aRadios"]["length"] === 0) {
		return this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"];
	}
	return this["eAccessResult"]["GROUP_ACCESSED"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sGetAccessResult"] = 0; };

/**
 * All possible values relevant for filtering out radios that belong to one group
 * NAME: the name determines all radios that belong to one group NO_NAME: if the
 * radios were collected from a radio group control we assume that all of them
 * belong together, even those that do not have a name. Necessary for Personas
 * scenarios.
 *
 * @param {string} sName
 * @return {Object}
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["fFilterBy"] = function(sName) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["fFilterBy"]++; }; 
	return {
		"NAME": sName,
		"NO_NAME_ASSIGNED": ''
	};
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["fFilterBy"] = 0; };

/**
 * Starts the initialisation of the global object that stores the radio button
 * group
 * @return {string}
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onFirstGroupAccess"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onFirstGroupAccess"]++; }; 
	/** @type {Array} */
	var oFilteredRadiosData = this["oCollectRadios"]();

	if (this["sGetAccessResult"](oFilteredRadiosData) === this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"])
		return this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"];

	if (window["UCF_System"]["bIs508"])
		this["Delegate_508"]["addItems"](oFilteredRadiosData["aRadios"]);

	this["oCREATE__RadioGroup"](oFilteredRadiosData);
	this["removeNavHelper"]();

	return this["eAccessResult"]["GROUP_ACCESSED"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onFirstGroupAccess"] = 0; };

/**
 * Assemble all relevant functions and start the process
 * @return {Object}
 * @private
 *
 */
UCF_RadioButtonKeyboard_standards["prototype"]["oCollectRadios"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oCollectRadios"]++; }; 
	return this["oFilterRadios"](
		this["oCollectRadiosFromDocument"](
			this["oCollectRadiosFromGroup"]()
		)
	);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oCollectRadios"] = 0; };

/**
 * returns all radios from the document that have the same name
 *
 * @private
 * @return {Object}
 */
UCF_RadioButtonKeyboard_standards["prototype"]["oCollectRadiosFromGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oCollectRadiosFromGroup"]++; }; 
	/** @type {UCF_RadioButtonGroup} */
	var oRadioButtonGroup = this["oGetParent"]();
	/** @type {Array} contains elements that presumably belong to a radio group*/
	var aCollectedRadios;

	if (oRadioButtonGroup && oRadioButtonGroup["sClassName"] === 'UCF_RadioButtonGroup') {

		if (window["UCF_System"]["sSubmitMethod"] === 'FORM') {
			aCollectedRadios = document["getElementsByName"](this["eFilterBy"]["NAME"]);
		} else {
			aCollectedRadios = oRadioButtonGroup["oDomRef"]["getElementsByTagName"]('SPAN');
		}
	}
	return aCollectedRadios;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oCollectRadiosFromGroup"] = 0; };

/**
 * returns all radios from the document that have the same name
 *
 * @private
 * @param {Array} aCollectedRadios
 * @return {Array}
 */
UCF_RadioButtonKeyboard_standards["prototype"]["oCollectRadiosFromDocument"] = function(aCollectedRadios) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oCollectRadiosFromDocument"]++; }; 

	if (!aCollectedRadios) {

		if (window["UCF_System"]["sSubmitMethod"] === 'FORM') {
			aCollectedRadios = document["getElementsByName"](this["eFilterBy"]["NAME"]); //scheint nicht in domutil/jsutil zu sein
		} else {
			aCollectedRadios = document["querySelectorAll"]('[ct=\"R_standards\"]');
		}
	}

	return aCollectedRadios;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oCollectRadiosFromDocument"] = 0; };

/**
 * @param {Array} aCollectedRadios
 * @return {Object} an object that stores:
 * 	1) an array with the collected radio buttons
 * 	2) Info about focused, selected, unavailable though selected, etc
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["oFilterRadios"] = function(aCollectedRadios) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oFilterRadios"]++; }; 

	/** @type {Object} */
	var oFilteredRadios = this["oFilteredRadiosSkeleton"]();
	/** @type {Object} */
	var oFilteredRadioInfo;
	/** @type {UCF_RadioButton} */
	var oRadio;
	/** @type {integer} */
	var iIndexOfThis;

	for (var i = 0; i < aCollectedRadios["length"]; i++) {

		oFilteredRadioInfo = { 'iIndex': null, 'iNext': null };

		//check whether the objects collected from DOM are
		// radio buttons indeed
		if (aCollectedRadios[i]["getAttribute"]('ct') !== 'R_standards')
			continue;

		oRadio = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](
			aCollectedRadios[i], true);

		// make sure that the blindly collected radio buttons have the same name
		// and thus belong to the same group
		if (oRadio["sName"] !== this["eFilterBy"]["NAME"])
			continue;

		// -- distrubute the radios to their respective fields
		// start with that radio that is unselectable but still selected
		if (this["sGetSelectionStatus"](oRadio) === this["eSelectionStatus"]["UNSELECTABLE_AND_SELECTED"]) {
			oFilteredRadios["oUnSelectableAndSelected"]["oRadio"] = oRadio;
		}

		// in the if state ment create the group of radio buttons that will be used
		// for navigation purposes. Find those that can receive a focus dependant
		// on the current context, i.e. ARIA etc.
		if (this["bCanReceiveNavFocus"](oRadio)) {
			oFilteredRadios["aRadios"]["push"](oRadio);
			oFilteredRadioInfo["iIndex"] = oFilteredRadios["aRadios"]["length"] - 1;
			oFilteredRadios["mIdMap"][oRadio["sId"]] = oFilteredRadioInfo;
		} else {
			oFilteredRadioInfo["iNext"] = oFilteredRadios["aRadios"]["length"];
			oFilteredRadioInfo["iIndex"] = -1;
			oFilteredRadios["mIdMap"][oRadio["sId"]] = oFilteredRadioInfo;
		}

		if (this["sGetSelectionStatus"](oRadio) === this["eSelectionStatus"]["SELECTED"]) {
			oFilteredRadios["oSelected"]["oRadio"] = oRadio;
			oFilteredRadios["oSelected"]["iIndex"] = oFilteredRadios["aRadios"]["length"] - 1;
		}

		if (this === oRadio) {
			iIndexOfThis = -1;
			if (this["bCanReceiveNavFocus"](this)) {
				iIndexOfThis = oFilteredRadios["aRadios"]["length"] - 1;
			}
		}
	}

	if ((oFilteredRadios["oSelected"]["oRadio"] === null
			&& oFilteredRadios["oUnSelectableAndSelected"]["oRadio"] === null)
		|| window["UCF_System"]["bIs508"] === true
		|| this["bUsedInSapTable"]) {
		oFilteredRadios["oRadioWithFocus"]["oRadio"] = this;
		oFilteredRadios["oRadioWithFocus"]["iIndex"] = iIndexOfThis;

	} else if (oFilteredRadios["oSelected"]["oRadio"] != null
		&& this["bUsedInSapTable"] === false) {
		oFilteredRadios["oRadioWithFocus"]["oRadio"] = oFilteredRadios["oSelected"]["oRadio"];
		oFilteredRadios["oRadioWithFocus"]["iIndex"] = oFilteredRadios["oSelected"]["iIndex"];

	} else if (oFilteredRadios["oUnSelectableAndSelected"]["oRadio"] != null
		&& this["bUsedInSapTable"] === false) {
		oRadio = oFilteredRadios["oUnSelectableAndSelected"]["oRadio"];
		oFilteredRadios["oRadioWithFocus"]["oRadio"] = oFilteredRadios["oUnSelectableAndSelected"]["oRadio"];
		oFilteredRadios["oRadioWithFocus"]["iIndex"] = (oFilteredRadios["mIdMap"][oRadio["sId"]] !== null) ? oFilteredRadios["mIdMap"][oRadio["sId"]]["iIndex"] : -1;

	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Could not determine first radio to focus', "RadioButtonKeyboard_standards.js(723): oFilterRadios"); };
	}

	return oFilteredRadios;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oFilterRadios"] = 0; };

/**
 * Creates all necessary field of the global radio button objects and assigns
 * values to them
 * @param {Object} oFilteredRadiosData
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["oCREATE__RadioGroup"] = function(oFilteredRadiosData) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oCREATE__RadioGroup"]++; }; 
	UCF_RadioButton["oRadioGroup"] = oFilteredRadiosData;
	UCF_RadioButton["oRadioGroup"]["sAccessType"] = this["eAccessType"]["NONE"];
	UCF_RadioButton["oRadioGroup"]["bGroupInitialized"] = true;
	UCF_RadioButton["oRadioGroup"]["sName"] = this["sName"];
	UCF_RadioButton["oRadioGroup"]["sSAP_TableEditMode"] = this["eSAP_TableEditMode"]["F2_MODE_OFF"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oCREATE__RadioGroup"] = 0; };

/**
 * @return {boolean} that determines whether a radio button can be focused
 * @param {UCF_RadioButton} oRadio
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["bCanReceiveNavFocus"] = function(oRadio) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bCanReceiveNavFocus"]++; }; 
	var sStatus = this["sGetNavigationStatus"](oRadio);
	return sStatus === this["eNavigationStatus"]["ACCESSIBLE"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bCanReceiveNavFocus"] = 0; };

/**
 * Each radio button of the global object UCF_RadioButton.oRadioGroup is mapped
 * to its index in the array UCF_RadioButton.aRadios through its Id.
 *
 * This function expects that radio button's id of which the index is to be
 * determined
 * @param {UCF_RadioButton} oRadio
 * @return {integer} index of the radio
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["iGetRadioIndex"] = function(oRadio) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["iGetRadioIndex"]++; }; 
	/** @type {Object} */
	var oEntry = UCF_RadioButton["oRadioGroup"]["mIdMap"][oRadio["sId"]];
	return oEntry ? oEntry["iIndex"] : undefined;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["iGetRadioIndex"] = 0; };

/**
 * Removes the tabIndex of the nav-helper SPAN within the radio button
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["removeNavHelper"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["removeNavHelper"]++; }; 

	/** @type {HTML_element} used in ARIA*/
	var oNavHelper;
	/** @type {Object} a ist with all radio ids*/
	var mIdMap;
	/** @type {string} */
	var sId;

	if (this["whoControlsNavigation"]() === this["eNavigationControledBy"]["RADIO_BUTTON_ARROWS"]) {
		mIdMap = this["getValueOfGroupField"]('mIdMap'); //UCF_RadioButton.oRadioGroup.mIdMap;

		for (sId in mIdMap) {
			oNavHelper = UCF_DomUtil["$"](sId + '-' + this["eAccessPoint"]["NAV_HELPER"]);
			UCF_DomUtil["setTabIndex"](oNavHelper, -1);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["removeNavHelper"] = 0; };

/**
 * As long as there is a selected radio only the nav-helper of the selected radio receives a tab index
 * For loose radio groups all nav-helpers receive a tab index. We need to make sure that from a focused element
 * that is no a radio button the focus moves to a radio if that proceeds or succeeds the radio.
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["assignNavHelper"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["assignNavHelper"]++; }; 

	/** @type {UCF_RadioButton}  */
	var oSelected;
	/** @type {HTML_element} used in ARIA*/
	var oNavHelper;
	/** @type {Object} a ist with all radio ids*/
	var mIdMap;
	/** @type {string} */
	var sId;

	mIdMap = this["getValueOfGroupField"]('mIdMap'); //UCF_RadioButton.oRadioGroup.mIdMap;

	if (this["whoControlsNavigation"]() === this["eNavigationControledBy"]["RADIO_BUTTON_ARROWS"]) {

		oSelected = this["getValueOfGroupField"]('oSelected'); //UCF_RadioButton.oRadioGroup.oSelected.oRadio;

		if (oSelected && oSelected["oRadio"]) {
			oSelected = oSelected["oRadio"];
			oNavHelper = UCF_DomUtil["$"](oSelected["sId"] + '-' + this["eAccessPoint"]["NAV_HELPER"]);
			UCF_DomUtil["setTabIndex"](oNavHelper, 0);
		} else {

			mIdMap = UCF_RadioButton["oRadioGroup"]["mIdMap"];

			for (sId in mIdMap) {
				oNavHelper = UCF_DomUtil["$"](sId + '-' + this["eAccessPoint"]["NAV_HELPER"]);
				UCF_DomUtil["setTabIndex"](oNavHelper, 0);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["assignNavHelper"] = 0; };

/**
 * Assign the tabInxdex to the root SPAN. This is necessary
 * in the SAP Table
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["assignTabIndexToRoot"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["assignTabIndexToRoot"]++; }; 
	/** @type {Array} all radios that can receive a tab-index*/
	var aRadios;

	aRadios = UCF_RadioButton["oRadioGroup"]["aRadios"];
	if (this["whoControlsNavigation"]() === this["eNavigationControledBy"]["RADIO_BUTTON_ARROWS_IN_SAP_TABLE"]) {
		UCF_JsUtil["forEach"](aRadios, function(oRadio) {
			UCF_DomUtil["setTabIndex"](oRadio["oDomRef"], 0);
		});
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["assignTabIndexToRoot"] = 0; };

/**
 * Assign the tabInxdex to the root SPAN. This is necessary
 * in the SAP Table
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["removeTabIndexFromRoot"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["removeTabIndexFromRoot"]++; }; 
	/**  @type {UCF_RadioButton} */
	var oRadioWithFocus;
	/**  @type {Object} */
	var mIdMap;
	/**  @type {UCF_RadioButton} */
	var oRadio;
	/** @type {string} */
	var sId;

	if (this["whoControlsNavigation"]() === this["eNavigationControledBy"]["RADIO_BUTTON_ARROWS_IN_SAP_TABLE"]) {

		mIdMap = UCF_RadioButton["oRadioGroup"]["mIdMap"];
		oRadioWithFocus = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"];

		for (sId in mIdMap) {
			oRadio = UCF_DomUtil["$"](sId);
			if (oRadio["id"] !== oRadioWithFocus["sId"])
				UCF_DomUtil["setTabIndex"](oRadio, -1);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["removeTabIndexFromRoot"] = 0; };

/**
 * handles the blur event that has the sematic EXIT
 * 1) Removes the tabIndex from the currently focused radio button
 * 2) Assigns a tabIndex to all nav-helpers
 * 3) Triggers this destruction of the radio group object
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onRadioGroupExit"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onRadioGroupExit"]++; }; 

	/** @type {enum-value} see eNavigationControledBy*/
	var sNavigationControledBy = this["whoControlsNavigation"]();
	/** @type {UCF_RadioButton} */
	var oFocusedRadio;
	/** @type {enum} */
	var _ = this["eNavigationControledBy"];

	if (this["getValueOfGroupField"]('sExitType') === this["eExitType"]["SKIPPING"]) {
		this["setValueInGroupField"]({ "sField": 'sExitType', "sValue": 'NONE' });
	} else if (sNavigationControledBy === _["RADIO_BUTTON_ARROWS"]) {
		oFocusedRadio = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"]["oFocusDomRef"];
		UCF_DomUtil["setTabIndex"](oFocusedRadio, -1);
		this["assignNavHelper"]();
	} else if (sNavigationControledBy === _["RADIO_BUTTON_ARROWS_IN_SAP_TABLE"]) {
		this["assignTabIndexToRoot"]();
		this["markAsGrouped"](false);
	} else if (sNavigationControledBy === _["RADIO_BUTTON_TABS_IN_SAP_TABLE"]) {
		this["markAsGrouped"](false);
	}
	this["destroyRadioGroup"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onRadioGroupExit"] = 0; };

/**
 * Sets the radio group back to its initial state
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["destroyRadioGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["destroyRadioGroup"]++; }; 
	UCF_RadioButton["oRadioGroup"] = null;
	UCF_RadioButton["oRadioGroup"] = {
		"bGroupInitialized": false,
		"bIsIndefiniteGroup": false,
		"sSAP_TableEditMode": 'F2_MODE_OFF'
	};
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["destroyRadioGroup"] = 0; };

UCF_RadioButtonKeyboard_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["destroy"]++; }; 
	if (this["Delegate_508"]) {
		this["Delegate_508"]["destroy"]();
		this["Delegate_508"] = null;
	}

	if (this["bIsExternalTabSequence"]) {
		this["bIsExternalTabSequence"] = null;
	}

	if (UCF_RadioButton["oRadioGroup"]["bGroupInitialized"]) {
		this["onRadioGroupExit"]();
	}
	UCF_RadioButton.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["destroy"] = 0; };

/**
 * The access of a radio group can result in three different ways to continue
 *
 * @private
 *
 */
UCF_RadioButtonKeyboard_standards["prototype"]["eHandleGroupAccessBy"] = {
	"CONTINUING": 'CONTINUING', // the static object can be created, continue the creation process
	"STOPPING": 'STOPPING', // the static object must not be created for diffenret reasons such as it already there, it cannot be created at all etc.
	"EXITING": 'EXITING' // the static object needs to be destroyed before contueing because it does not belong to the accessed group
};

/**
 * All combinations and circumstances that might be or occur
 * during a group access
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {string}
 */
// eslint-disable-next-line consistent-return
UCF_RadioButtonKeyboard_standards["prototype"]["controlGroupAccess"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["controlGroupAccess"]++; }; 
	/** @type {HTML_Element} determines the first focused element of a group */
	var oAccessPoint = oBrowserEvent["oSource"];
	/** @type {string} */
	var sAccessPoint = this["sGetAccessPoint"](oAccessPoint);
	/** @type {boolean} */
	var bInitialized = UCF_RadioButton["oRadioGroup"]["bGroupInitialized"];
	/** @type {enum-value} */
	var sAccessType = this["sGetAccessType"]();

	if (sAccessType === this["eAccessType"]["FIRST_ACCESS"] && bInitialized)
		return this["eHandleGroupAccessBy"]["EXITING"];

	if (sAccessType !== this["eAccessType"]["FIRST_ACCESS"] && bInitialized)
		return this["eHandleGroupAccessBy"]["STOPPING"];

	if (sAccessType === this["eAccessType"]["FIRST_ACCESS"] && !bInitialized)
		return this["eHandleGroupAccessBy"]["CONTINUING"];

	if (sAccessType === this["eAccessType"]["ACCESSIBLE_ACCESSED"] && bInitialized)
		return this["eHandleGroupAccessBy"]["STOPPING"];

	if (sAccessType === this["eAccessType"]["INACCESSIBLE_ACCESSED"] && bInitialized)
		return this["eHandleGroupAccessBy"]["STOPPING"];

	switch (sAccessPoint) {
		case this["eAccessPoint"]["ROOT"]:
			return this["eHandleGroupAccessBy"]["STOPPING"];
		case this["eAccessPoint"]["RADIO"]:
			return this["eHandleGroupAccessBy"]["CONTINUING"];
		case this["eAccessPoint"]["NAV_HELPER"]:
			return this["eHandleGroupAccessBy"]["CONTINUING"];
	}

	// Focus triggered by navigation or programatically
	if (sAccessType === this["eAccessType"]["NAVIGATION"] ||
		sAccessType === this["eAccessType"]["FOCUS_MOVED"])
		return this["eHandleGroupAccessBy"]["STOPPING"];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["controlGroupAccess"] = 0; };

/**
 * Special handling for personas
 *
 * @private
 * @param {boolean} bFormBackNavigation
 * @param {boolean} bIsExternalTabSequence
 */

UCF_RadioButtonKeyboard_standards["prototype"]["focus"] = function(bFormBackNavigation, bIsExternalTabSequence) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["focus"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()', "RadioButtonKeyboard_standards.js(1011): focus"); };
	/** @type {HTML_element}*/
	var oRadioWithFocusNavHelper;
	/** @type {Array} */
	var oFilteredRadiosData;

	if (bIsExternalTabSequence) {
		if (this["bIsVisible"]()) {
			this["bIsExternalTabSequence"] = bIsExternalTabSequence;
			this["removeOwnTabSequence"]();
		}
		UCF_RadioButton.prototype["focus"]["call"](this, bFormBackNavigation, bIsExternalTabSequence);
	} else if (this["bUsedInSapTable"]) {
		UCF_RadioButton.prototype["focus"]["call"](this, bFormBackNavigation, bIsExternalTabSequence);
	} else {
		if (this["bIsVisible"]()) {
			oFilteredRadiosData = this["oCollectRadios"]();
			oRadioWithFocusNavHelper = UCF_DomUtil["$"](oFilteredRadiosData["oRadioWithFocus"]["oRadio"]["sId"] + '-NAV_HELPER');
			if (oRadioWithFocusNavHelper) {
				UCF_DomUtil["focusDomElement"](oRadioWithFocusNavHelper);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["focus"] = 0; };

/**
 * Special handling for personas and also a check for Navigation for not personas
 * CSN: 2280147907 the selected RadioButton from RadioButtonGroup is not in the TAB chain
 * Reason: Some controls use focusNextControl() to navigate
 * Check in focusNextControl() if a Control is focusable by call of a bIsFocusable()
 * bIsFocusable() check if this.oFocusDomRef != null &&
 * UCF_DomUtil.bIsVisible(this.oFocusDomRef, true);
 * The local implementation check not if it can be focused,
 * but if it has TabIndex=0 and overwrites
 * bIsFocusable() from Control.js
 * @see bCanReceiveNavFocus
 * @return {boolean}
 * @private
 */

UCF_RadioButtonKeyboard_standards["prototype"]["bIsFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bIsFocusable"]++; }; 

	if (window["UCF_System"]["bIsAria"] && (this["bEnabled"] || this["bReadonly"])) {
		return UCF_RadioButton.prototype["bIsFocusable"]["apply"](this, arguments);
	} else
	if (window["UCF_System"]["bIs508"] || (this["bEnabled"] && !this["bReadonly"])) {
		return (this["oFocusDomRef"] && UCF_DomUtil["bHasTabIndex"](this["oFocusDomRef"]));
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bIsFocusable"] = 0; };

/**
 * Special handling for personas
 *
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["removeOwnTabSequence"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["removeOwnTabSequence"]++; }; 
	var oFilteredRadiosData = this["oCollectRadios"]();
	this["oCREATE__RadioGroup"](oFilteredRadiosData);
	var oNavHelperWithFocus = UCF_DomUtil["$"](oFilteredRadiosData["oRadioWithFocus"]["oRadio"]["sId"] + '-NAV_HELPER');
	UCF_DomUtil["setTabIndex"](oNavHelperWithFocus, -1);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["removeOwnTabSequence"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
	this["setValueInGroupField"]({ "sField": 'sExitType', "sValue": 'SKIPPING' });
	this["onRadioGroupExit"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
	this["setValueInGroupField"]({ "sField": 'sExitType', "sValue": 'SKIPPING' });
	this["onRadioGroupExit"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsskipback"] = 0; };

/**
 * Handles the onlsfocus event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsfocus"]++; }; 

	//if (!this.bIsFocusable()) return;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'GroupAccess: ' + this["controlGroupAccess"](oBrowserEvent), "RadioButtonKeyboard_standards.js(1113): onlsfocus"); };

	if (UCF_RadioButton["oRadioGroup"]["aRadios"])
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'First Radio: ' + UCF_RadioButton["oRadioGroup"]["aRadios"][0]["id"], "RadioButtonKeyboard_standards.js(1116): onlsfocus"); };

	// -- An indefinite group is a group that could not be created.
	if (this["sName"] === this["eFilterBy"]["NO_NAME_ASSIGNED"]) {
		UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"] = true;
		return;
	}

	// -- access-key handling, force select...
	if (oBrowserEvent["bAlt"]()) {
		this["handleSelection"]();
	}

	// -- someone has defined a tabsequence of their own.
	if (this["bIsExternalTabSequence"]) {
		this["removeOwnTabSequence"]();
		return;
	}

	// --
	if (this["controlGroupAccess"](oBrowserEvent) !==
		this["eHandleGroupAccessBy"]["CONTINUING"]) return;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'AccessType: ' + UCF_RadioButton["oRadioGroup"]["sAccessType"], "RadioButtonKeyboard_standards.js(1139): onlsfocus"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'tabindex: ' + this["oDomRef"]["getAttribute"]('tabindex'), "RadioButtonKeyboard_standards.js(1140): onlsfocus"); };

	// -- Create all fields and object necessary for navigation
	var sAccessResult = this["onFirstGroupAccess"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "sAccessResult: " + sAccessResult, "RadioButtonKeyboard_standards.js(1144): onlsfocus"); };

	// -- Group cannot be accessed most likely because there is no enabled radio
	if (sAccessResult === this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"]) return;

	// -- special handling for sap table
	// Note: the content of sapTableHandling() is empty,
	// the call of this.removeTabIndexFromRoot() is comment out and not used.
	if (!this["bUsedInSapTable"]) {
		this["focusFirstFocusable"](oBrowserEvent);
	}

	// -- update ARIA if necessary
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oRadioButtonBase"]["updateAriaInfo"](this);

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsfocus"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_RadioButtonKeyboard_standards["prototype"]["focusFirstFocusable"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["focusFirstFocusable"]++; }; 

	/** @type {HTML_object} the html element that first received the focus*/
	var oAccessPoint;
	/** @type {string} value of eAccessPoint*/
	var sAccessPoint;
	/** @type {UCF_RadioButton}*/
	var oFirstRadioToFocus;

	if (this["whoControlsNavigation"]() === this["eNavigationControledBy"]["RADIO_BUTTON_ARROWS"]) {

		oFirstRadioToFocus = this["getValueOfGroupField"]('oRadioWithFocus')["oRadio"];

		if (oFirstRadioToFocus) {
			oFirstRadioToFocus = oFirstRadioToFocus["oFocusDomRef"];
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'oFirstRadioToFocus is null', "RadioButtonKeyboard_standards.js(1183): focusFirstFocusable"); };
			return;
		}

		this["setValueInGroupField"]({ "sField": 'sExitType', "sValue": 'FOCUS_MOVED' });
		this["setValueInGroupField"]({ "sField": 'sAccessType', "sValue": 'FOCUS_MOVED' });
		UCF_DomUtil["setTabIndex"](oFirstRadioToFocus, 0);

		oAccessPoint = oBrowserEvent["oSource"];

		sAccessPoint = this["sGetAccessPoint"](oAccessPoint);

		if (sAccessPoint === this["eAccessPoint"]["NAV_HELPER"]) {
			UCF_DomUtil["focusDomElement"](oFirstRadioToFocus);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["focusFirstFocusable"] = 0; };

/**
 * @private
 * @param {UCF_FocusInfo_Object} oFocusInfo
 */
UCF_RadioButtonKeyboard_standards["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "RadioButtonKeyboard_standards.js(1206): collectFocusInfo"); };
	/** @type {UCF_RadioButton}*/
	var oRadio;
	try {
		oRadio = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"];
	} catch (e) {
		oRadio = null;
	}
	if (!UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"] && oRadio) {
		oFocusInfo["setApplyControl"](oRadio);
	} else {
		oFocusInfo["setFocussedId"](oFocusInfo["sFocussedId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["collectFocusInfo"] = 0; };

/**
 * @private
 * @param {UCF_FocusInfo_Object} oFocusInfo
 */
UCF_RadioButtonKeyboard_standards["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "RadioButtonKeyboard_standards.js(1226): applyFocusInfo"); };
	/** @type {HTML_Element}*/
	var oDomRef = UCF_DomUtil["$"](this["sId"] + '-NAV_HELPER');

	if (window["UCF_System"]["sAccessibility"] === 'CLASSIC'
		|| window["UCF_System"]["sAccessibility"] === 'NONE')
		oDomRef = UCF_DomUtil["$"](this["sId"]);

	UCF_DomUtil["focusDomElement"](oDomRef);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["applyFocusInfo"] = 0; };

/**
 * Special handling for the SAP Table
 * In the SAP Table the radio button group must not navigate nor assign a focus of its own
 * Focus handling and navigation is passed on to the SAP Table.
 * Any interference might lead to recursive focus assignments which in return cause
 * the browser to crash.
 * To avoid this we rather handle radio groups in SAP Tables with special
 * methods
 *
 * @private
 *
 */
UCF_RadioButtonKeyboard_standards["prototype"]["sapTableHandling"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sapTableHandling"]++; }; 
	// this.removeTabIndexFromRoot();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["sapTableHandling"] = 0; };

/**
 * Handles the onlsblur event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsblur"]++; }; 
	/** @type {enum-value}*/
	var sExitType;

	// Focus was moved programatically from the nav helper to the DomRef
	if (this["sGetAccessPoint"](oBrowserEvent["oSource"]) === this["eAccessPoint"]["NAV_HELPER"]
		|| this["getValueOfGroupField"]('bGroupInitialized') === false)
		return;

	// handle the internal sematic of the blur event
	sExitType = this["sGetExitType"](oBrowserEvent);

	if (sExitType === this["eExitType"]["EXIT"] ||
		sExitType === this["eExitType"]["RADIO_FOCUS_LOST"]) {
		this["onRadioGroupExit"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsblur"] = 0; };

/**
 * See UCF_ClientRadioButton.setChecked()
 * @private
 * @param {boolean} bSelect
 */
UCF_RadioButtonKeyboard_standards["prototype"]["handleClientSideSelection"] = function(bSelect) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["handleClientSideSelection"]++; }; 

	/** @type {enum-value}  see eAccessResult*/
	var sAccessResult;
	/** @type {enum-value}  see eAccessType*/
	var sAccessType;

	sAccessResult = this["onFirstGroupAccess"]();

	// Group cannot be accessed most likely because there is no enabled radio
	if (sAccessResult === this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"]) return;

	if (bSelect) {
		this["assignSelection"]();
	} else {
		this["removeSelection"]();
	}

	if (this["whoControlsNavigation"]() === this["eNavigationControledBy"]["RADIO_BUTTON_ARROWS"]) {
		this["focusRadio"]();
	}

	// -- the access-type depends on whether a focusable elements was clicked
	// -- if not it might have side effects as an un-focusable element is not
	// -- if the navagation array (aRadios) of the static variable
	sAccessType = (this["bUnFocusableFocused"]()) ?
		this["eAccessType"]["INACCESSIBLE_ACCESSED"] :
		this["eAccessType"]["ACCESSIBLE_ACCESSED"];

	this["updateRadioGroup"](
		/* Selected:   */
		this["oUpdateSelectedRadioData"](this),
		/* Focused: 	 */
		this,
		/* AccessType: */
		sAccessType,
		/* ExitType: 	 */
		this["eExitType"]["SELECTION"]
	);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["handleClientSideSelection"] = 0; };

/**
 * The on click event does not always mean selection
 * Sometimes it only asigns a focus
 * Soetimes it must avoid assigning a focus
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1332): onclick"); };

	//if (!this.bIsFocusable()) return;

	/** @type {enum-value} see eAccessType*/
	var sAccessType;
	/** @type {enum-value} see eAccessResult*/
	var sAccessResult;
	/** @type {enum-value} see eNavigationControledBy*/
	var sNavigationControledBy = this["whoControlsNavigation"]();
	// _trace(WARNING, 'tabindex on click: ' + this.oDomRef.getAttribute('tabindex'));
	// -- an indefinite group is a group that could not be created.
	if (this["sName"] === this["eFilterBy"]["NO_NAME_ASSIGNED"]) {
		this["assignSelection"]();
		this["fireChange"](this["sId"], this["bChecked"]);
		return;
	}
	// _trace(WARNING, 'control group access: ' + this.controlGroupAccess(oBrowserEvent));
	// -- after clickling into nav bar of browser old group is still active while new was not created
	if (this["controlGroupAccess"](oBrowserEvent) === this["eHandleGroupAccessBy"]["EXITING"])
		this["onRadioGroupExit"]();

	// -- handle the semantic of the click event
	if (this["controlGroupAccess"](oBrowserEvent) === this["eHandleGroupAccessBy"]["CONTINUING"]) {
		sAccessResult = this["onFirstGroupAccess"]();
	}

	// -- Group cannot be accessed most likely because there is no enabled radio
	if (sAccessResult === this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"]) return;

	// -- store the accessed radio
	this["storeRadioInGroupField"]({ "sField": 'oRadioNotAccessedByFocus', "oRadio": this });

	// -- the programmatic assignment of the focus on click has to be done carefully
	// -- it might have side effects such as an endless focus loop
	if (sNavigationControledBy === this["eNavigationControledBy"]["RADIO_BUTTON_ARROWS"]) {
		this["focusRadio"]();
	}

	// -- process the selection
	this["handleSelection"](oBrowserEvent);

	// -- the access-type depends on whether a focusable elements was clicked
	// -- if not it might have side effects as an un-focusable element is not
	// -- if the navagation array (aRadios) of the static variable
	sAccessType = (this["bUnFocusableFocused"]()) ?
		this["eAccessType"]["INACCESSIBLE_ACCESSED"] :
		this["eAccessType"]["ACCESSIBLE_ACCESSED"];

	// -- update all navigation and selection data
	this["updateRadioGroup"](
		/* Selected: */
		this["oUpdateSelectedRadioData"](this),
		/* Focused: 	 */
		this,
		/* AccessType: */
		sAccessType,
		/* ExitType: 	 */
		this["eExitType"]["SELECTION"]
	);

	if (oBrowserEvent)
		oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onclick"] = 0; };

/**
 * Responsible for the value that updates the field oSelected of the
 * stative variable oRadioGroup. If the previous routines could select the
 * according radio button it will return it. If not it will return null
 *
 * @private
 * @param {UCF_RadioButton} oRadioToSelect
 * @return {UCF_RadioButton}
 */
UCF_RadioButtonKeyboard_standards["prototype"]["oUpdateSelectedRadioData"] = function(oRadioToSelect) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oUpdateSelectedRadioData"]++; }; 
	/** @type {enum-value} */
	var sStatus;

	if (!oRadioToSelect) return null;

	sStatus = this["sGetSelectionStatus"](oRadioToSelect);
	if (sStatus === this["eSelectionStatus"]["SELECTED"])
		return oRadioToSelect;
	return null;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oUpdateSelectedRadioData"] = 0; };

/**
 * Updates those fields of the global radio group object whose values have been
 * modified through navigation or selection
 *
 * @private
 * @param {UCF_RadioButton} oSelected
 * @param {UCF_RadioButton} oFocused
 * @param {string} sAccessType
 * @param {string} sExitType
 */
UCF_RadioButtonKeyboard_standards["prototype"]["updateRadioGroup"] = function(oSelected, oFocused, sAccessType, sExitType) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["updateRadioGroup"]++; }; 
	/** @type {integer} */
	var iRadioIndex;

	if (oSelected) {
		iRadioIndex = this["iGetRadioIndex"](oSelected);
		UCF_RadioButton["oRadioGroup"]["oSelected"]["oRadio"] = oSelected;
		UCF_RadioButton["oRadioGroup"]["oSelected"]["iIndex"] = iRadioIndex;
	}
	if (oFocused) {
		iRadioIndex = this["iGetRadioIndex"](oFocused);
		UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"] = oFocused;
		UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["iIndex"] = iRadioIndex;
	}
	if (sAccessType)
		UCF_RadioButton["oRadioGroup"]["sAccessType"] = sAccessType;
	if (sExitType)
		UCF_RadioButton["oRadioGroup"]["sExitType"] = sExitType;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["updateRadioGroup"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1455): ondblclick"); };
	if (this["mEvents"]["DoubleClick"]) {
		this["fireDoubleClick"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["ondblclick"] = 0; };

/**
 * Handles the onkeydown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1469): onkeydown"); };

	/** @type {integer} */
	var iKey = oBrowserEvent["iKeyCode"]();
	/** @type {enum-value} see eNavigationControledBy*/
	var sWhoControlsNavigation;
	/** @type {enum-value} see eSAP_TableEditMode*/
	var sSAP_TableEditMode;
	/** @type {enum} */
	var _;

	_ = this["eNavigationControledBy"];
	sSAP_TableEditMode = UCF_RadioButton["oRadioGroup"]["sSAP_TableEditMode"];
	sWhoControlsNavigation = this["whoControlsNavigation"]();

	// -- toggle navigation mode for radio buttons in sap table
	if (iKey === UCF_KeyCodes["F2"] && this["bUsedInSapTable"]) {

		// -- with F2_MODE_ON the radio groups own navigation is turned on
		if (sWhoControlsNavigation === _["SAP_TABLE"]
			&& sSAP_TableEditMode === this["eSAP_TableEditMode"]["F2_MODE_OFF"]) {

			this["onRadioGroupExit"]();
			this["onFirstGroupAccess"]();
			this["markAsGrouped"](true);

			// -- update the group about the edit mode
			UCF_RadioButton["oRadioGroup"]["sSAP_TableEditMode"] = this["eSAP_TableEditMode"]["F2_MODE_ON"];
			this["removeTabIndexFromRoot"]();

		} else if ((
				sWhoControlsNavigation === _["RADIO_BUTTON_ARROWS_IN_SAP_TABLE"]
				|| sWhoControlsNavigation === _["RADIO_BUTTON_TABS_IN_SAP_TABLE"])
			&& sSAP_TableEditMode === this["eSAP_TableEditMode"]["F2_MODE_ON"]
		) {

			// -- with F2_MODE_OFF navigation is passed back to the SAP table
			UCF_RadioButton["oRadioGroup"]["sSAP_TableEditMode"] = this["eSAP_TableEditMode"]["F2_MODE_OFF"];

			this["markAsGrouped"](false);
			this["assignTabIndexToRoot"]();
			this["onRadioGroupExit"]();
		}

		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onkeydown"] = 0; };

/**
 * Handles the onmousedown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1525): onmousedown"); };
	if (!this["bEnabled"] || this["bReadonly"]) return;
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onmousedown"] = 0; };

/**
 * Central handler for all keyboard events that trigger focus shift and
 * have the sematics of 'GroupNavigation'
 *
 * @param { Object } oData the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["doGroupNavigation"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["doGroupNavigation"]++; }; 
	/** @type {enum-value} check eNavigationControledBy */
	var sNavigationControledBy = this["whoControlsNavigation"]();
	/** @type {enumeation} check eNavigationControledBy */
	var _ = this["eNavigationControledBy"];

	this["updateRadioGroup"](null, null, this["eAccessType"]["NAVIGATION"], this["eExitType"]["NAVIGATION"]);

	// -- I could't find a radio to navigate to
	if (!oData["oNavigateTo"]) return;

	// -- if the radio arrows control the navigation trigger selection
	if (
		sNavigationControledBy === _["RADIO_BUTTON_ARROWS"] ||
		sNavigationControledBy === _["RADIO_BUTTON_ARROWS_IN_SAP_TABLE"] ||
		sNavigationControledBy === _["RADIO_BUTTON_TABS"] ||
		sNavigationControledBy === _["RADIO_BUTTON_TABS_IN_SAP_TABLE"]) {

		oData["oNavigateTo"]["focusRadio"]();

		if (oData["oSelected"])
			oData["oSelected"]["handleSelection"]();

		this["updateRadioGroup"](
			/* Selected:  */
			this["oUpdateSelectedRadioData"](oData["oSelected"]),
			/* Focused:   */
			oData["oNavigateTo"],
			/* AccessType:*/
			this["eAccessType"]["NAVIGATION"],
			/* ExitType:  */
			this["eExitType"]["NAVIGATION"]
		);

		oData["oEvent"]["cancelBubble"]();
		oData["oEvent"]["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["doGroupNavigation"] = 0; };

/**
 * Determines whether or not a particular type of focus change is to be handled as
 * group navigation
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @return {boolean}
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["bIsGroupNavigation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bIsGroupNavigation"]++; }; 
	/** @type {enum-value} check eNavigationControledBy */
	var sNavigationControledBy = this["whoControlsNavigation"]();
	/** @type {enumeation} check eNavigationControledBy */
	var _ = this["eNavigationControledBy"];

	if (!UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]
		&& sNavigationControledBy !== _["SAP_TABLE"]
		&& !oBrowserEvent["bAlt"]()) {
		return true;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bIsGroupNavigation"] = 0; };

/**
 * Handles the onlsright event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsright"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1606): onlsright"); };
	/** @type {UCF_RadioButton} */
	var oNext;

	if (this["bIsGroupNavigation"](oBrowserEvent)) {
		oNext = this["oGetNext"]();
		this["doGroupNavigation"]({ 'oNavigateTo': oNext, 'oSelected': oNext, 'oEvent': oBrowserEvent });
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsright"] = 0; };

/**
 * Handles the onlsrightmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsrightmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsrightmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1623): onlsrightmodifier"); };
	/** @type {UCF_RadioButton} */
	var oNext;

	if (this["bIsGroupNavigation"](oBrowserEvent) &&
		UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) {
		oNext = this["oGetNext"]();
		this["doGroupNavigation"]({ 'oNavigateTo': oNext, 'oSelected': null, 'oEvent': oBrowserEvent });
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsrightmodifier"] = 0; };
/**
 * Handles the onlsdown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsdown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1640): onlsdown"); };
	this["onlsright"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsdown"] = 0; };
/**
 * Handles the onlsdownmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsdownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsdownmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1650): onlsdownmodifier"); };
	this["onlsrightmodifier"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsdownmodifier"] = 0; };

/**
 * Handles the onlsleft event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsleft"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1661): onlsleft"); };

	/** @type {UCF_RadioButton} */
	var oPrevious;

	if (this["bIsGroupNavigation"](oBrowserEvent)) {
		oPrevious = this["oGetPrevious"](oBrowserEvent);
		this["doGroupNavigation"]({ 'oNavigateTo': oPrevious, 'oSelected': oPrevious, 'oEvent': oBrowserEvent });
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsleft"] = 0; };

/**
 * Handles the onlsleftmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsleftmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsleftmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1679): onlsleftmodifier"); };

	/** @type {UCF_RadioButton} */
	var oPrevious;

	if (this["bIsGroupNavigation"](oBrowserEvent) &&
		UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) {
		oPrevious = this["oGetPrevious"](oBrowserEvent);
		this["doGroupNavigation"]({ 'oNavigateTo': oPrevious, 'oSelected': null, 'oEvent': oBrowserEvent });
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsleftmodifier"] = 0; };

/**
 * Handles the onlsup event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1698): onlsup"); };
	this["onlsleft"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsup"] = 0; };

/**
 * Handles the onlsupmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsupmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1709): onlsupmodifier"); };
	this["onlsleftmodifier"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsupmodifier"] = 0; };

/**
 * Handles the onlshome event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlshome"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1720): onlshome"); };
	/** @type {UCF_RadioButton} */
	var oFirst;

	if (this["bIsGroupNavigation"](oBrowserEvent)) {
		oFirst = this["oGetFirstInGroup"]();
		this["doGroupNavigation"]({ 'oNavigateTo': oFirst, 'oSelected': oFirst, 'oEvent': oBrowserEvent });
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlshome"] = 0; };

/**
 * Handles the onlshomemodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlshomemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlshomemodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1737): onlshomemodifier"); };

	/** @type {UCF_RadioButton} */
	var oFirst;

	if (this["bIsGroupNavigation"](oBrowserEvent) &&
		UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) {
		oFirst = this["oGetFirstInGroup"]();
		this["doGroupNavigation"]({ 'oNavigateTo': oFirst, 'oSelected': null, 'oEvent': oBrowserEvent });
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlshomemodifier"] = 0; };

/**
 * Handles the onlsend event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1756): onlsend"); };

	/** @type {UCF_RadioButton} */
	var oLast;

	if (this["bIsGroupNavigation"](oBrowserEvent)) {
		oLast = this["oGetLastInGroup"]();
		this["doGroupNavigation"]({ 'oNavigateTo': oLast, 'oSelected': oLast, 'oEvent': oBrowserEvent });
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsend"] = 0; };

/**
 * Handles the onlsendmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlsendmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsendmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1774): onlsendmodifier"); };

	/** @type {UCF_RadioButton} */
	var oLast;

	if (this["bIsGroupNavigation"](oBrowserEvent) &&
		UCF_KeyboardHelper["bHasOnlyShiftAsModifier"](oBrowserEvent)) {
		oLast = this["oGetLastInGroup"]();
		this["doGroupNavigation"]({ 'oNavigateTo': oLast, 'oSelected': null, 'oEvent': oBrowserEvent });
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlsendmodifier"] = 0; };

/**
 * Handles the onlstabnext event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlstabnext"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1793): onlstabnext"); };

	/** @type {enum-value} */
	var sNavigationControledBy = this["whoControlsNavigation"]();
	/** @type {enum-value} */
	var oFocusedRadio;
	/** @type {enum} */
	var _;
	/** @type {UCF_RadioButton} */
	var oLast;

	// -- there is no group. I can't navigate
	if (UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]) return;

	oLast = this["oGetLastInGroup"]();
	_ = this["eNavigationControledBy"];

	// -- depending on the superior control TAB receives a different semantic
	oFocusedRadio = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"];

	switch (sNavigationControledBy) {
		case _["RADIO_BUTTON_ARROWS_IN_SAP_TABLE"]:
			this["markAsGrouped"](false);
			UCF_RadioButton["oRadioGroup"]["sExitType"] = this["eExitType"]["EXIT"];
			break;

		case _["RADIO_BUTTON_TABS_IN_SAP_TABLE"]:
			if (oFocusedRadio["sId"] !== oLast["sId"]) {

				this["updateRadioGroup"](
					/* Selected    */
					null,
					/* Focused     */
					this["oGetNext"](),
					/* AccessType: */
					this["eExitType"]["NAVIGATION"],
					/* ExitType:   */
					this["eExitType"]["NAVIGATION"]
				);

			} else if (oFocusedRadio["sId"] === oLast["sId"]) {
				this["markAsGrouped"](false);
				UCF_RadioButton["oRadioGroup"]["sExitType"] = this["eExitType"]["EXIT"];
			}
			break;

		default:
			UCF_RadioButton["oRadioGroup"]["sExitType"] = this["eExitType"]["EXIT"];
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlstabnext"] = 0; };

/**
 * Handles the onlstabprevious event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlstabprevious"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButtonKeyboard_standards.js(1851): onlstabprevious"); };

	/** @type {enum-value} */
	var sNavigationControledBy = this["whoControlsNavigation"]();
	/** @type {enum-value} */
	var oFocusedRadio = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"];
	/** @type {enum} */
	var _;
	/** @type {UCF_RadioButton} */
	var oFirst;

	// -- there is no group. I can't navigate
	if (UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]) return;

	oFirst = this["oGetFirstInGroup"]();
	_ = this["eNavigationControledBy"];

	switch (sNavigationControledBy) {
		case _["RADIO_BUTTON_ARROWS_IN_SAP_TABLE"]:
			this["markAsGrouped"](false);
			UCF_RadioButton["oRadioGroup"]["sExitType"] = this["eExitType"]["EXIT"];
			break;

		case _["RADIO_BUTTON_TABS_IN_SAP_TABLE"]:

			if (oFocusedRadio["sId"] !== oFirst["sId"]) {
				this["updateRadioGroup"](
					/* Selected    */
					null,
					/* Focused     */
					this["oGetPrevious"](),
					/* AccessType: */
					this["eExitType"]["NAVIGATION"],
					/* ExitType:   */
					this["eExitType"]["NAVIGATION"]
				);
			} else if (oFocusedRadio["sId"] === oFirst["sId"]) {
				this["markAsGrouped"](false);
				UCF_RadioButton["oRadioGroup"]["sExitType"] = this["eExitType"]["EXIT"];
			}
			break;

		default:
			UCF_RadioButton["oRadioGroup"]["sExitType"] = this["eExitType"]["EXIT"];
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["onlstabprevious"] = 0; };

/**
 * Finds the first focusable radio of a group
 *
 * @private
 * @return {UCF_RadioButton}
 *
 */
UCF_RadioButtonKeyboard_standards["prototype"]["oGetFirstInGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oGetFirstInGroup"]++; }; 
	var aRadios = UCF_RadioButton["oRadioGroup"]["aRadios"];
	return aRadios[0];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oGetFirstInGroup"] = 0; };

/**
 * Finds the last focusable radio of a group
 *
 * @private
 * @return {UCF_RadioButton}
 *
 */
UCF_RadioButtonKeyboard_standards["prototype"]["oGetLastInGroup"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oGetLastInGroup"]++; }; 
	var aRadios = UCF_RadioButton["oRadioGroup"]["aRadios"];
	return aRadios[aRadios["length"] - 1];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oGetLastInGroup"] = 0; };

/**
 * Finds out whether the group has a radio that is both disabled/readonly and slected
 *
 * @private
 * @return {boolean}
 *
 */
UCF_RadioButtonKeyboard_standards["prototype"]["bhandleUnSelectableAndSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bhandleUnSelectableAndSelected"]++; }; 
	if (!UCF_RadioButton["oRadioGroup"]["bGroupInitialized"])
		return false;
	return UCF_RadioButton["oRadioGroup"]["oUnSelectableAndSelected"]["oRadio"] != null;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bhandleUnSelectableAndSelected"] = 0; };

/**
 * Performs all actions necessary during focusing a radio
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["focusRadio"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["focusRadio"]++; }; 
	/** @type {HTML_element} */
	var oDomRefToFocus;
	/** @type {HTML_element} */
	var oDomRefToUnFocus;
	/** @type {enum-value} */
	var sNavigationControledBy;
	/** @type {enum-value} */
	var sAccessType = UCF_RadioButton["oRadioGroup"]["sAccessType"];

	oDomRefToFocus = this["oFocusDomRef"];
	oDomRefToUnFocus = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"]["oFocusDomRef"];
	sNavigationControledBy = this["whoControlsNavigation"]();

	if (sNavigationControledBy === this["eNavigationControledBy"]["RADIO_BUTTON_ARROWS"]
		|| sNavigationControledBy === this["eNavigationControledBy"]["RADIO_BUTTON_ARROWS_IN_SAP_TABLE"]) {
		UCF_DomUtil["resetTabIndex"](oDomRefToUnFocus);
		UCF_DomUtil["setTabIndex"](oDomRefToFocus, 0);
	}

	// UCF_DomUtil.focusDomElement(oDomRefToFocus);
	// Only SELECTION and FOCUS_MOVED and NAVIGATION
	if (sAccessType === this["eAccessType"]["SELECTION"]) {
		UCF_DomUtil["refocusDomElement"](oDomRefToFocus);
	} else {
		UCF_DomUtil["focusDomElement"](oDomRefToFocus);
	}

	// _trace(INFO, UCF_RadioButton.oRadioGroup.sExitType);
	// _trace(INFO, UCF_RadioButton.oRadioGroup.sSAP_TableEditMode);
	if (window["UCF_System"]["bIsAria"] && window["UCF_System"]["bIs508"] === false) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["oRadioButtonBase"]["updateAriaInfo"](this);
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["focusRadio"] = 0; };

/**
 * Get the next radio button in the group. If the radio button is already the
 * last one, the radio button itself is returned.
 *
 * @return {UCF_RadioButton} next radio button in the group
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["oGetNext"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oGetNext"]++; }; 
	/** @type {Array} all radios that belong to a group */
	var aRadios;
	/** @type {integer} index of radio succeeding the currently focused */
	var iNextRadio;
	/** @type {integer} amount of radios */
	var iAllRadios;
	/** @type {integer} index of radio currently focused */
	var iFocusedRadio;

	if (!this["bCanNavigate"]()) return null;

	aRadios = UCF_RadioButton["oRadioGroup"]["aRadios"];

	// -- the access-type depends on whether a focusable elements was clicked
	// -- if not it might have side effects as an un-focusable element is not
	// -- if the navagation array (aRadios) of the static variable
	if (this["bUnFocusableFocused"]()) {
		iNextRadio = this["iGetNextToUnFocusable"]();
		return aRadios[iNextRadio];
	}

	// -- calulation that finds the index of the next focusable
	iAllRadios = aRadios["length"] - 1;
	iFocusedRadio = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["iIndex"];
	iNextRadio = (iFocusedRadio >= iAllRadios) ? 0 : (iFocusedRadio + 1);

	return aRadios[iNextRadio];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oGetNext"] = 0; };

/**
 * Determines whether the radio focused is actually unfocusable due to its status
 * @private
 * @return {boolean}
 */
UCF_RadioButtonKeyboard_standards["prototype"]["bUnFocusableFocused"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bUnFocusableFocused"]++; }; 
	return UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["iIndex"] === -1;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bUnFocusableFocused"] = 0; };

/**
 * Returns the index of the radio that succeedes the unfocusable in the tab chain.
 *
 * @private
 * @return {integer}
 */
UCF_RadioButtonKeyboard_standards["prototype"]["iGetNextToUnFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["iGetNextToUnFocusable"]++; }; 
	var sId = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"]["sId"],
		iNext = UCF_RadioButton["oRadioGroup"]["mIdMap"][sId]["iNext"];
	if (iNext >= UCF_RadioButton["oRadioGroup"]["aRadios"]["length"] - 1) {
		return 0;
	}
	return iNext;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["iGetNextToUnFocusable"] = 0; };

/**
 * Returns the index of the radio that preceeds the unfocusable in the tab chain.
 *
 * @private
 * @return {integer}
 */
UCF_RadioButtonKeyboard_standards["prototype"]["iGetPreviousToUnFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["iGetPreviousToUnFocusable"]++; }; 
	var sId = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["oRadio"]["sId"],
		iPrevious = UCF_RadioButton["oRadioGroup"]["mIdMap"][sId]["iNext"] - 1;
	if (iPrevious < 0) {
		return UCF_RadioButton["oRadioGroup"]["aRadios"]["length"] - 1;
	}
	return iPrevious;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["iGetPreviousToUnFocusable"] = 0; };

/**
 * Get the previous radio button in the radio button group. If the radio button
 * is already the first one, the radio button itself is returned.
 * @return {UCF_RadioButton}
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_RadioButtonKeyboard_standards["prototype"]["oGetPrevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oGetPrevious"]++; }; 

	if (!this["bCanNavigate"]()) return null;

	var aRadios = UCF_RadioButton["oRadioGroup"]["aRadios"],
		iPreviousRadio;

	// -- the access-type depends on whether a focusable elements was clicked
	// -- if not it might have side effects as an un-focusable element is not
	// -- if the navagation array (aRadios) of the static variable
	if (this["bUnFocusableFocused"]()) {
		iPreviousRadio = this["iGetPreviousToUnFocusable"]();
		return aRadios[iPreviousRadio];
	}

	var iAllRadios = aRadios["length"] - 1,
		iFocusedRadio = UCF_RadioButton["oRadioGroup"]["oRadioWithFocus"]["iIndex"];
	iPreviousRadio = (iFocusedRadio <= 0) ? iAllRadios : (iFocusedRadio - 1);
	return aRadios[iPreviousRadio];
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["oGetPrevious"] = 0; };

/**
 * Determines whether or not focus navigation is possible / necessary
 *
 * @private
 * @return {boolean}
 */
UCF_RadioButtonKeyboard_standards["prototype"]["bCanNavigate"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bCanNavigate"]++; }; 
	/** @type {Object} contains all information about the radio group */
	var oRadioGroup = UCF_RadioButton["oRadioGroup"];
	/** @type {UCF_RadioButton} */
	var iIndexOfFocused = oRadioGroup["oRadioWithFocus"]["iIndex"];

	if (oRadioGroup["bGroupInitialized"] === false) return false;

	if (oRadioGroup["bGroupInitialized"] === true
		&& oRadioGroup["aRadios"]["length"] < 2
		&& iIndexOfFocused > -1) return false;

	return true;
};;if (__UCF_COVERAGE__) { UCF_RadioButtonKeyboard_standards["_"]["bCanNavigate"] = 0; };

};
sap["ls"]["preload"]["UCF_RadioButton_ie6"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_CheckBoxDelegate_ie6 */
/// <reference path="./delegates/CheckBoxDelegate_ie6.js"/>
/* global UCF_RadioButton */
/// <reference path="./RadioButton.js"/>
/* global UCF_RadioButtonKeyboard_ie6 */
/// <reference path="./RadioButtonKeyboard_ie6.js"/>

/**
 * @class
 * @extends UCF_RadioButtonKeyboard_ie6
 * @param {HTMLElement} oDomRef oLS
 * @param {UCF_LS} oLS
 */
function UCF_RadioButton_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["UCF_RadioButton_ie6"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "RadioButton_ie6.js(29): UCF_RadioButton_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RadioButton_ie6.js(30): UCF_RadioButton_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "RadioButton_ie6.js(31): UCF_RadioButton_ie6"); };

	UCF_RadioButtonKeyboard_ie6["apply"](this, [oDomRef, oLS]);
	this["oFocusDomRef"] = UCF_DomUtil["$"](this["sId"] + "-lbl");
	this["oRadioButtonBase"] = new (UCF_ClassLoader["oGetClass"]("UCF_CheckBoxDelegate_ie6"))(this);
	this["addDelegate"](this["oRadioButtonBase"]);

	this["bIsMouseOver"] = false;
	// when the name is changed, the RadioButton with
	// the same name will be checked every time
};window["UCF_RadioButton_ie6"] = UCF_RadioButton_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RadioButton_ie6"); UCF_RadioButton_ie6["_"] = {UCF_RadioButton_ie6: 0}; }; ;

UCF_RadioButton_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_RadioButtonKeyboard_ie6"))(); UCF_RadioButton_ie6.prototype["sClassName"] = "UCF_RadioButton_ie6";

/**
 *
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButton_ie6["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButton_ie6.js(53): onmouseover"); };
	this["bIsMouseOver"] = true;
	this["applyHoverState"]();
	this["oRadioButtonBase"]["applyTooltip"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["onmouseover"] = 0; };

/**
 * @private
 */
UCF_RadioButton_ie6["prototype"]["applyHoverState"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["applyHoverState"]++; }; 
	var oImg, sClasses, i;
	if (!this["bEnabled"] || this["bReadonly"])
		return;
	if (this["bIsMouseOver"]) {
		oImg = UCF_DomUtil["$"](this["sId"] + '-img');
		if (!oImg)
			return;
		sClasses = UCF_DomUtil["sGetClass"](oImg);
		var aClassNames = sClasses["split"](' ');
		for (i = 0; i < aClassNames["length"]; i++)
			if (aClassNames[i]["indexOf"]('Hover') !== -1)
				aClassNames["splice"](i, 1);
		sClasses = aClassNames["join"](' ');
		var sState = this["oRadioButtonBase"]["getValueState"]();
		if ('NONE' === sState) {
			if (this["bChecked"])
				sClasses += ' urRImgOnHover';
			else
				sClasses += ' urRImgOffHover';
		} else if ('ERROR' === sState) {
			if (this["bChecked"])
				sClasses += ' urRImgOnInvHover';
			else
				sClasses += ' urRImgOffInvHover';
		} else if ('WARNING' === sState) {
			if (this["bChecked"])
				sClasses += ' urRImgOnWarnHover';
			else
				sClasses += ' urRImgOffWarnHover';
		}
		UCF_DomUtil["setClass"](oImg, sClasses);
	} else {
		oImg = UCF_DomUtil["$"](this["sId"] + '-img');
		if (!oImg)
			return;
		sClasses = UCF_DomUtil["sGetClass"](oImg);
		if (sClasses["indexOf"]('Hover') === -1)
			return;
		var aClasses = sClasses["split"](' ');
		var sClassName = aClasses[0];
		for (i = 1; i < aClasses["length"] - 1; i++)
			sClassName = sClassName + ' ' + aClasses[i];
		UCF_DomUtil["setClass"](oImg, sClassName);
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["applyHoverState"] = 0; };

/**
 * Handles the onmouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButton_ie6["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButton_ie6.js(116): onmouseout"); };
	this["bIsMouseOver"] = false;
	this["applyHoverState"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["onmouseout"] = 0; };

/**
 * Handles the onlsselect event, i.e. SPACE
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButton_ie6["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButton_ie6.js(128): onlsselect"); };

	if (oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["ENTER"]) return;

	if (!this["bUseOwnNavigation"] || UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]) return;

	// An indefinite group is a group that could not be created.
	if (this["sName"] === this["eFilterBy"]["NO_NAME_ASSIGNED"]) {
		this["assignSelection"]();
		this["fireChange"](this["sId"], this["bChecked"]);
		return;
	}
	this["handleSelection"]();
	this["updateRadioGroup"](
		/* Selected:   */
		this["oUpdateSelectedRadioData"](this),
		/* Focused:    */
		null,
		/* AccessType: */
		this["eAccessType"]["ACCESSIBLE_ACCESSED"],
		/* ExitType:   */
		this["eExitType"]["SELECTION"]);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["onlsselect"] = 0; };

/**
 * Selects radio button, de-selects all other radio buttons in the group. Sets
 * focus to the selected radio button.
 * Sequence: First navigation then selection
 * @private
 */
UCF_RadioButton_ie6["prototype"]["handleSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["handleSelection"]++; }; 
	var sSelectionStatus = this["sGetSelectionStatus"](this);
	if (sSelectionStatus === this["eSelectionStatus"]["UNSELECTABLE_AND_SELECTED"] ||
		sSelectionStatus === this["eSelectionStatus"]["UNSELECTABLE"] ||
		sSelectionStatus === this["eSelectionStatus"]["SELECTED"])
		return;
	if (this["oDataTip"] && this["oDataTip"]["sExplanationText"])
		this["oDataTip"]["close"]();
	this["assignSelection"]();
	if (this["bhandleUnSelectableAndSelected"]() === true) {
		this["handleUnSelectableAndSelected"]();
	} else {
		this["removeSelection"]();
	}
	this["fireChange"](this["sId"], this["bChecked"]);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["handleSelection"] = 0; };

/**
 * Assigns all styles and values necessary for the selected state of the radio
 * @private
 */
UCF_RadioButton_ie6["prototype"]["assignSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["assignSelection"]++; }; 
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setChecked"](UCF_DomUtil["$"](this["sId"] + '-lbl'), true);
		UCF_AriaStateHelper["setChecked"](this["oDomRef"], true);
		if (this["oParentControl"])
			UCF_AriaStateHelper["setActivedescendant"](
				this["oParentControl"]["oDomRef"], this["sId"] + '-lbl');
	}
	var oImgRef = UCF_DomUtil["$"](this["sId"] + '-img');
	oImgRef["className"] = oImgRef["className"]["replace"]('Off', 'On');
	this["bChecked"] = true;
	this["oDomRef"]["checked"] = true;
	this["setClientProperty"]("Checked", this["bChecked"], true);
	this["applyHoverState"]();
	this["applySelection"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["assignSelection"] = 0; };

/**
 * Deselects the inaccessible and selected radio.
 * Removes it from the global group object so as to make sure
 *
 * @private
 *
 */
UCF_RadioButton_ie6["prototype"]["handleUnSelectableAndSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["handleUnSelectableAndSelected"]++; }; 
	//This case applies to ARIA. Here we can still navigate to readonly radios
	//If this happens a radio with the selection status UNSELECTABLE_AND_SELECTED
	//must not be unselected
	if (this["sGetSelectionStatus"](this) === this["eSelectionStatus"]["UNSELECTABLE"]) return;
	var oRadio = UCF_RadioButton["oRadioGroup"]["oUnSelectableAndSelected"]["oRadio"],
		oImgRef = UCF_DomUtil["$"](oRadio["sId"] + '-img'),
		oCheckbox = UCF_DomUtil["$"](oRadio["sId"] + '-imgSymb');
	UCF_DomUtil["removeClass"](oCheckbox, 'lsRBImgSel');
	oImgRef["className"] = oImgRef["className"]["replace"]('On', 'Off');
	oRadio["bChecked"] = false;
	oRadio["oDomRef"]["checked"] = false;
	oRadio["setClientProperty"]("Checked", oRadio["bChecked"], true);
	UCF_RadioButton["oRadioGroup"]["oUnSelectableAndSelected"]["oRadio"] = null;
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["handleUnSelectableAndSelected"] = 0; };

/**
 * Assigns all styles and values necessary for the deselected state of the radio
 *
 * @private
 *
 */
UCF_RadioButton_ie6["prototype"]["removeSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["removeSelection"]++; }; 
	var oRadio = UCF_RadioButton["oRadioGroup"]["oUnSelectableAndSelected"]["oRadio"];
	oRadio = (oRadio) ? oRadio : UCF_RadioButton["oRadioGroup"]["oSelected"]["oRadio"];

	if (oRadio === null) return;

	var oImgRef = UCF_DomUtil["$"](oRadio["sId"] + '-img');
	oImgRef["className"] = oImgRef["className"]["replace"]('On', 'Off');
	oRadio["bChecked"] = false;
	oRadio["oDomRef"]["checked"] = false;
	oRadio["setClientProperty"]("Checked", oRadio["bChecked"], true);
	oRadio["applyHoverState"]();
	oRadio["applySelection"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["removeSelection"] = 0; };

UCF_RadioButton_ie6["prototype"]["applySelection"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["applySelection"]++; }; 
	this["oRadioButtonBase"]["applySelection"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["applySelection"] = 0; };

UCF_RadioButton_ie6["prototype"]["applyStateToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["applyStateToDom"]++; }; 
	this["oRadioButtonBase"]["applyStateToDom"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["applyStateToDom"] = 0; };

/**
 * Returns the key of the RadioButton,
 * @return {string} The value of the RadioButton
 * @public
 */
UCF_RadioButton_ie6["prototype"]["getName"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["getName"]++; }; 
	return this["sName"];
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["getName"] = 0; };

/**
 * Set the key of the RadioButton
 * @param {string} sName the new key
 * @public
 */
UCF_RadioButton_ie6["prototype"]["setName"] = function(sName) {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setName"]++; }; 
	var bValueChanged = (this["sName"] !== sName);
	this["sName"] = sName;
	this["setClientProperty"]("Name", this["sName"], true);
	if (bValueChanged) {
		this["aRadioButtons"] = new Array();
		this["bIsNameChanged"] = true;
		this["oDomRef"]["name"] = this["sName"];
		this["checkSelection"](true);
		this["applyStateToDom"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setName"] = 0; };

/**
 * Set the value of the CheckBox, true=selected; false=deselected
 *
 * @param {boolean} bValue the new value
 * @public
 */
UCF_RadioButton_ie6["prototype"]["setValue"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setValue"]++; }; 
	var bValueChanged = (this["bChecked"] !== bValue);
	this["bChecked"] = bValue;
	this["setClientProperty"]("Value", this["bChecked"], true);
	this["setClientProperty"]("Checked", this["bChecked"], true);
	if (bValueChanged) {
		this["aRadioButtons"] = new Array();
		this["checkSelection"](true);
		this["applyStateToDom"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setValue"] = 0; };

/**
 * Adds the data tip id to the DOM in aria-describedby attribute
 * @private
 */
UCF_RadioButton_ie6["prototype"]["applyAriaDataTipInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["applyAriaDataTipInfo"]++; }; 
	if (window["UCF_System"]["bIsAria"]) {
		var id = this["sId"] + '-lbl';
		if (this["oDomRef"]["id"]) {
			UCF_AriaStateHelper["addDescribedby"](UCF_DomUtil["$"](id), this["oDomRef"]["id"] + '-dtip');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["applyAriaDataTipInfo"] = 0; };

UCF_RadioButton_ie6["prototype"]["setValue"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setValue"]++; }; 
	this["oRadioButtonBase"]["setValue"](bValue);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setValue"] = 0; };

UCF_RadioButton_ie6["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["getValue"]++; }; 
	return this["oRadioButtonBase"]["getValue"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["getValue"] = 0; };

UCF_RadioButton_ie6["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["getEnabled"]++; }; 
	return this["oRadioButtonBase"]["getEnabled"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["getEnabled"] = 0; };

UCF_RadioButton_ie6["prototype"]["setEnabled"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setEnabled"]++; }; 
	return this["oRadioButtonBase"]["setEnabled"](bValue);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setEnabled"] = 0; };

UCF_RadioButton_ie6["prototype"]["getEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["getEditable"]++; }; 
	return this["oRadioButtonBase"]["getEditable"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["getEditable"] = 0; };

UCF_RadioButton_ie6["prototype"]["setEditable"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setEditable"]++; }; 
	this["oRadioButtonBase"]["setEditable"](bValue);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setEditable"] = 0; };

UCF_RadioButton_ie6["prototype"]["getValueState"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["getValueState"]++; }; 
	return this["oRadioButtonBase"]["getValueState"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["getValueState"] = 0; };

UCF_RadioButton_ie6["prototype"]["setValueState"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setValueState"]++; }; 
	this["oRadioButtonBase"]["setValueState"](sValue);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["setValueState"] = 0; };

/**
 * only to avoid JS errors as used by standards class and called by parent
 */
UCF_RadioButton_ie6["prototype"]["markAsGrouped"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["markAsGrouped"]++; }; };;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["markAsGrouped"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element
 * within the control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButton_ie6["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButton_ie6.js(352): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this || this["sName"] === this["eFilterBy"]["NO_NAME_ASSIGNED"])
		return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setControlType"]("R");

	// set item count and item index
	var idx = this["iGetRadioIndex"](this) + 1;
	oAccessibilityHelper["setItemCount"](UCF_RadioButton["oRadioGroup"]["aRadios"]["length"]);
	oAccessibilityHelper["setItemIndex"](idx);

	// tutor text
	if (this["bUseOwnNavigation"]) {
		if (!this["bEnabled"] || this["bReadonly"])
			oAccessibilityHelper["addTutor"]("R_DSBL_TUT");
		else if (this["bChecked"])
			oAccessibilityHelper["addTutor"]("R_SEL_TUT");
		else
			oAccessibilityHelper["addTutor"]("R_TUT");
	} else {
		if (this["bEnabled"] && !this["bReadonly"] && !this["bChecked"])
			oAccessibilityHelper["addTutor"]("SELECT_TUT");
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_RadioButton_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["destroy"]++; }; 
	this["oRadioButtonBase"]["destroy"]();
	this["oRadioButtonBase"] = null;
	this["sName"] = null;
	this["bChecked"] = null;
	this["aRadioButtons"] = null;
	UCF_RadioButtonKeyboard_ie6.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_ie6["_"]["destroy"] = 0; };

UCF_RadioButton_ie6.prototype["aPublicMethods"] = ["getName","setName","setValue"].concat(UCF_RadioButton_ie6.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_RadioButton_standards"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_SelectorDelegate */
/// <reference path="./delegates/SelectorDelegate.js"/>
/* global UCF_RadioButton */
/// <reference path="./RadioButton.js"/>
/* global UCF_RadioButtonKeyboard_standards */
/// <reference path="./RadioButtonKeyboard_standards.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>

/**
 * @class
 * @extends UCF_RadioButtonKeyboard_standards
 * @param {HTML_Element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_RadioButton_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["UCF_RadioButton_standards"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "RadioButton_standards.js(27): UCF_RadioButton_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RadioButton_standards.js(28): UCF_RadioButton_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "RadioButton_standards.js(29): UCF_RadioButton_standards"); };

	if (arguments["length"] > 0) {
		UCF_RadioButtonKeyboard_standards["apply"](this, [oDomRef, oLS]);
		// eslint-disable-next-line @ur/no-memory-leaks
		this["oFocusDomRef"] = oDomRef;
		this["oRadioButtonBase"] = new (UCF_ClassLoader["oGetClass"]("UCF_SelectorDelegate"))(this);
		this["addDelegate"](this["oRadioButtonBase"]);
	}
};window["UCF_RadioButton_standards"] = UCF_RadioButton_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RadioButton_standards"); UCF_RadioButton_standards["_"] = {UCF_RadioButton_standards: 0}; }; ;
UCF_RadioButton_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_RadioButtonKeyboard_standards"))(); UCF_RadioButton_standards.prototype["sClassName"] = "UCF_RadioButton_standards";

/**
 * ############################################################################
 *
 * SECTION RESPONSIBLE FOR SELECTION
 *
 * ############################################################################
 */

/**
 * See UCF_ClientRadioButton.setChecked()
 * @private
 * @param {boolean} bSelect
 */
UCF_RadioButton_standards["prototype"]["handleClientSideSelection"] = function(bSelect) {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["handleClientSideSelection"]++; }; 
	/** @type {UCF_RadioButtonKeyboard_standards_AccessResult} */
	var sAccessResult = this["onFirstGroupAccess"]();
	/** @type {UCF_RadioButtonKeyboard_standards_AccessType} */
	var sAccessType;
	/** @type {Delegate} */
	var oRadioButtonBase = this["oRadioButtonBase"];
	/** @type {Object} */
	var Style_Factory = oRadioButtonBase["styleFactory"]["bind"](oRadioButtonBase);
	/** @type {method} */
	var toggleMethods = oRadioButtonBase["toggleMethods"];
	/** @type {method} */
	var eSelectionState = oRadioButtonBase["eSelectionState"];

	// -- Group cannot be accessed most likely because there is no enabled radio
	if (sAccessResult === this["eAccessResult"]["GROUP_NOT_ACCESSIBLE"]) return;

	if (bSelect) {
		this["assignSelection"]();
	} else {
		Style_Factory(toggleMethods["switchSelectionState"]["bind"](oRadioButtonBase),
			this, eSelectionState["UNSELECTED"]);

		oRadioButtonBase["updateAriaInfo"](this);
		this["bChecked"] = false;
		this["oDomRef"]["checked"] = false;
		this["setClientProperty"]("Checked", this["bChecked"], true);
	}

	this["focusRadio"](this);

	sAccessType = (this["bUnFocusableFocused"]()) ?
		this["eAccessType"]["INACCESSIBLE_ACCESSED"] :
		this["eAccessType"]["ACCESSIBLE_ACCESSED"];

	this["updateRadioGroup"](
		/* Selected:   */
		this["oUpdateSelectedRadioData"](this),
		/* Focused: 	 */
		this,
		/* AccessType: */
		sAccessType,
		/* ExitType: 	 */
		this["eExitType"]["SELECTION"]);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["handleClientSideSelection"] = 0; };

/**
 * Handles the onlsselect event.SPACE and ENTER and SHIFT
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButton_standards["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButton_standards.js(107): onlsselect"); };

	// -- ENTER has a diffenrent sematic with ITS. Must not trigger selection
	if (oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["ENTER"]) return;

	// -- No selection when shift was pressed simulataneously
	if (oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["SHIFT"]) return;

	// -- Arrow keys not used and there is no radio group.
	if (UCF_RadioButton["oRadioGroup"]["bIsIndefiniteGroup"]) return;

	// -- An indefinite group is a group that could not be created.
	if (this["sName"] === this["eFilterBy"]["NO_NAME_ASSIGNED"]) {
		this["assignSelection"]();
		this["fireChange"](this["sId"], this["bChecked"]);

		return;
	}

	this["updateRadioGroup"](
		/* Selected:   */
		this["oUpdateSelectedRadioData"](this),
		/* Focused:    */
		null,
		/* AccessType: */
		this["eAccessType"]["ACCESSIBLE_ACCESSED"],
		/* ExitType:   */
		this["eExitType"]["REFOCUS"]
	);

	this["storeRadioInGroupField"]({ "sField": 'oRadioNotAccessedByFocus', "oRadio": null });

	this["focusRadio"](this);
	this["handleSelection"](oBrowserEvent);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["onlsselect"] = 0; };

/**
 * Selects radio button, de-selects all other radio buttons in the group. Sets
 * focus to the selected radio button.
 * Sequence: First navigation then selection
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_RadioButton_standards["prototype"]["handleSelection"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["handleSelection"]++; }; 
	/** @type {UCF_RadioButtonKeyboard_standards_SelectionStatus} */
	var sSelectionStatus = this["sGetSelectionStatus"](this);

	// -- check whether radio can be selected
	if (sSelectionStatus === this["eSelectionStatus"]["UNSELECTABLE_AND_SELECTED"] ||
		sSelectionStatus === this["eSelectionStatus"]["UNSELECTABLE"] ||
		sSelectionStatus === this["eSelectionStatus"]["SELECTED"])
		return;

	// -- close the data tip upon selection
	if (this["oDataTip"] && this["oDataTip"]["sExplanationText"]) {
		this["oDataTip"]["close"]();
	}

	// -- swap the styles
	this["assignSelection"]();

	// -- determine if there is a selected non-selcatbal to be handled
	if (this["bhandleUnSelectableAndSelected"]() === true) {
		this["handleUnSelectableAndSelected"]();
	} else {
		this["removeSelection"]();
	}

	// -- update stored radio group properties
	// -- and refocus where necessary

	if (window["UCF_System"]["bIs508"]) {
		this["updateRadioGroup"](
			/* Selected:*/
			this["oUpdateSelectedRadioData"](this),
			/* Focused: */
			this,
			/* AccessType: */
			this["eAccessType"]["FOCUS_MOVED"],
			/* ExitType:*/
			this["eExitType"]["FOCUS_MOVED"]);
		UCF_DomUtil["refocusDomElement"](this["oFocusDomRef"]);

	} else if (window["UCF_System"]["bIsAria"]) {
		this["updateRadioGroup"](
			/* Selected:*/
			this["oUpdateSelectedRadioData"](this),
			/* Focused: */
			this,
			/* AccessType: */
			this["eAccessType"]["FOCUS_MOVED"],
			/* ExitType:*/
			this["eExitType"]["FOCUS_MOVED"]);

		this["oRadioButtonBase"]["updateAriaInfo"](this);

	} else {
		this["updateRadioGroup"](
			/* Selected:*/
			this["oUpdateSelectedRadioData"](this),
			/* Focused: */
			this,
			/* AccessType: */
			this["eAccessType"]["ACCESSIBLE_ACCESSED"],
			/* ExitType:*/
			this["eExitType"]["SELECTION"]);
	}
	this["fireChange"](this["sId"], this["bChecked"]);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["handleSelection"] = 0; };

UCF_RadioButton_standards["prototype"]["markAsGrouped"] = function(bGroup) {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["markAsGrouped"]++; }; 

	/** @type {UCF_SelectorDelegate} */
	var oRadioButtonBase = this["oRadioButtonBase"];
	/** @type {Object} */
	var Style_Factory = oRadioButtonBase["styleFactory"]["bind"](oRadioButtonBase);
	/** @type {Object} */
	var toggleMethods = oRadioButtonBase["toggleMethods"];
	/** @type {UCF_SelectorDelegate_Grouping} */
	var eGrouping = oRadioButtonBase["eGrouping"];
	/** @type {string} */
	var sId;
	/** @type {Object} */
	var mIds = UCF_RadioButton["oRadioGroup"]["mIdMap"];
	/** @type {UCF_RadioButton} */
	var oRadio;
	/** @type {boolean} */
	var sGrouping = (bGroup) ? eGrouping["GROUPED"] : eGrouping["NONE"];

	for (sId in mIds) {
		oRadio = this["oLS"]["oControlFactory"]["oGetControlById"](sId, true);

		if (bGroup) {
			Style_Factory(toggleMethods["switchToGrouped"]["bind"](oRadioButtonBase),
				oRadio, sGrouping);
		} else {
			Style_Factory(toggleMethods["switchToUngrouped"]["bind"](oRadioButtonBase),
				oRadio, sGrouping);
		}

		oRadio["sGrouping"] = sGrouping;
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["markAsGrouped"] = 0; };

/**
 * Assigns all styles and values necessary for the selected state of the radio
 * @private
 */
UCF_RadioButton_standards["prototype"]["assignSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["assignSelection"]++; }; 
	/** @type {UCF_SelectorDelegate} */
	var oRadioButtonBase = this["oRadioButtonBase"];
	/** @type {Object} */
	var Style_Factory = oRadioButtonBase["styleFactory"]["bind"](oRadioButtonBase);
	/** @type {Object} */
	var toggleMethods = oRadioButtonBase["toggleMethods"];
	/** @type {UCF_RadioButtonKeyboard_standards_SelectionStatus} */
	var eSelectionState = oRadioButtonBase["eSelectionState"];

	// -- swap classes
	Style_Factory(toggleMethods["switchSelectionState"]["bind"](oRadioButtonBase),
		this, eSelectionState["SELECTED"]);

	// -- swap control properties
	this["bChecked"] = true;
	this["oDomRef"]["checked"] = true;
	this["setClientProperty"]("Checked", this["bChecked"], true);

	// -- swap ARIA properties
	oRadioButtonBase["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["assignSelection"] = 0; };

/**
 * Assigns all styles and values necessary for the deselected state of the radio
 *
 * @private
 *
 */
UCF_RadioButton_standards["prototype"]["removeSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["removeSelection"]++; }; 

	/** @type {UCF_RadioButton} */
	var oRadio = UCF_RadioButton["oRadioGroup"]["oUnSelectableAndSelected"]["oRadio"];
	/** @type {UCF_SelectorDelegate} */
	var oRadioButtonBase = this["oRadioButtonBase"];
	/** @type {Object} */
	var Style_Factory = oRadioButtonBase["styleFactory"]["bind"](oRadioButtonBase);
	/** @type {Object} */
	var toggleMethods = oRadioButtonBase["toggleMethods"];
	/** @type {UCF_SelectorDelegate_SelectionState} */
	var eSelectionState = oRadioButtonBase["eSelectionState"];

	oRadio = (oRadio) ? oRadio : UCF_RadioButton["oRadioGroup"]["oSelected"]["oRadio"];

	if (oRadio === null) return;

	Style_Factory(toggleMethods["switchSelectionState"]["bind"](oRadioButtonBase),
		oRadio, eSelectionState["UNSELECTED"]);

	oRadio["bChecked"] = false;
	oRadio["oDomRef"]["checked"] = false;
	oRadio["setClientProperty"]("Checked", oRadio["bChecked"], true);
	oRadioButtonBase["updateAriaInfo"](oRadio);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["removeSelection"] = 0; };

/**
 * Finds out whether the group has a radio that is both disabled/readonly and slected
 *
 * @private
 * @return {boolean}
 *
 */
UCF_RadioButton_standards["prototype"]["bhandleUnSelectableAndSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["bhandleUnSelectableAndSelected"]++; }; 
	return UCF_RadioButton["oRadioGroup"]["oUnSelectableAndSelected"]["oRadio"] != null;
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["bhandleUnSelectableAndSelected"] = 0; };

/**
 * Deselects the inaccessible and selected radio.
 * Removes it from the global group object so as to make sure
 *
 * @private
 */
UCF_RadioButton_standards["prototype"]["handleUnSelectableAndSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["handleUnSelectableAndSelected"]++; }; 
	//This case applies to ARIA. Here we can still navigate to readonly radios
	//If this happens a radio with the selection status UNSELECTABLE_AND_SELECTED
	//must not be unselected

	/** @type {UCF_RadioButton} */
	var oRadio;

	if (this["sGetSelectionStatus"](this) === this["eSelectionStatus"]["UNSELECTABLE"]) return;

	oRadio = UCF_RadioButton["oRadioGroup"]["oUnSelectableAndSelected"]["oRadio"];

	if (!oRadio) return;

	var oRadioButtonBase = this["oRadioButtonBase"];
	var Style_Factory = oRadioButtonBase["styleFactory"]["bind"](oRadioButtonBase);
	var toggleMethods = oRadioButtonBase["toggleMethods"];
	var eSelectionState = oRadioButtonBase["eSelectionState"];

	Style_Factory(toggleMethods["switchSelectionState"]["bind"](oRadioButtonBase),
		oRadio, eSelectionState["UNSELECTED"]);

	oRadio["bChecked"] = false;
	oRadio["oDomRef"]["checked"] = false;
	oRadio["setClientProperty"]("Checked", oRadio["bChecked"], true);
	UCF_RadioButton["oRadioGroup"]["oUnSelectableAndSelected"]["oRadio"] = null;
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["handleUnSelectableAndSelected"] = 0; };

/**
 * ############################################################################
 *
 * SECTION WITH ALL STYLES NECESSARY FOR STYLE SWITCH
 *
 * ############################################################################
 */

UCF_RadioButton_standards["prototype"]["eStyles"] = {
	'GROUPED_SELECTED_ENABLED': 'lsRadioButton--grouped lsRadioButton--checked',
	'GROUPED_UNSELECTED_ENABLED': 'lsRadioButton--grouped lsRadioButton--unchecked',
	'GROUPED_SELECTED_READONLY': 'lsRadioButton--grouped lsRadioButton--checked--readOnly',
	'GROUPED_UNSELECTED_READONLY': 'lsRadioButton--grouped lsRadioButton--unchecked--readOnly',
	'GROUPED_SELECTED_DISABLED': 'lsRadioButton--grouped lsRadioButton--checked--disabled',
	'GROUPED_UNSELECTED_DISABLED': 'lsRadioButton--grouped lsRadioButton--unchecked--disabled',

	'SELECTED_ENABLED': 'lsRadioButton--checked',
	'UNSELECTED_ENABLED': 'lsRadioButton--unchecked',
	'SELECTED_READONLY': 'lsRadioButton--checked--readOnly',
	'UNSELECTED_READONLY': 'lsRadioButton--unchecked--readOnly',
	'SELECTED_ERROR_ENABLED': 'lsRadioButton--checked--error',
	'UNSELECTED_ERROR_ENABLED': 'lsRadioButton--unchecked--error',
	'SELECTED_WARNING_ENABLED': 'lsRadioButton--checked--warning',
	'UNSELECTED_WARNING_ENABLED': 'lsRadioButton--unchecked--warning',
	'SELECTED_PARENT_READONLY': 'lsRadioButton--checked--parentReadOnly',
	'UNSELECTED_PARENT_READONLY': 'lsRadioButton--unchecked--parentReadOnly',
	'SELECTED_ERROR_READONLY': 'lsRadioButton--checked--error--readOnly',
	'UNSELECTED_ERROR_READONLY': 'lsRadioButton--unchecked--error--readOnly',
	'SELECTED_WARNING_READONLY': 'lsRadioButton--checked--warning--readOnly',
	'UNSELECTED_WARNING_READONLY': 'lsRadioButton--unchecked--warning--readOnly',
	'SELECTED_DISABLED': 'lsRadioButton--checked--disabled',
	'UNSELECTED_DISABLED': 'lsRadioButton--unchecked--disabled'
};

/**
 * ############################################################################
 *
 * SECTION WITH PUBLIC APIS
 *
 * ############################################################################
 */

/**
 * Set the value of the CheckBox, true=selected; false=deselected
 *
 * @param {boolean} bValue the new value
 * @public
 */
UCF_RadioButton_standards["prototype"]["setValue"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["setValue"]++; }; 

	if (this["bChecked"] === bValue) return;
	this["handleClientSideSelection"](bValue);
	this["oRadioButtonBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["setValue"] = 0; };

/**
 * Returns the value of the CheckBox, true=checked; false=not checked
 * @return {boolean} The value of the CheckBox,
 * true=checked; false=not checked
 * @public
 */
UCF_RadioButton_standards["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["getValue"]++; }; 
	return this["oRadioButtonBase"]["getValue"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["getValue"] = 0; };
/**
 * Get enabled
 * @return {boolean} the enabled state
 * @public
 */
UCF_RadioButton_standards["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["getEnabled"]++; }; 
	return this["oRadioButtonBase"]["getEnabled"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["getEnabled"] = 0; };
/**
 * Set enabled
 * @param {boolean} bEnabled the new enabled value
 * @public
 */
UCF_RadioButton_standards["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["setEnabled"]++; }; 
	this["oRadioButtonBase"]["setEnabled"](bEnabled);
	this["oRadioButtonBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["setEnabled"] = 0; };
/**
 * Get the editable state of the checkbox
 * @return {boolean} the editable state
 * @public
 */
UCF_RadioButton_standards["prototype"]["getEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["getEditable"]++; }; 
	return this["oRadioButtonBase"]["getEditable"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["getEditable"] = 0; };
/**
 * Set the editable state of the checkbox
 *
 * @param {boolean} bValue the new editable value
 * @public
 */
UCF_RadioButton_standards["prototype"]["setEditable"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["setEditable"]++; }; 
	this["oRadioButtonBase"]["setEditable"](bValue);
	this["oRadioButtonBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["setEditable"] = 0; };
/**
 * Gets the value state of this checkbox
 * @return {string} the required state
 * @public
 */
UCF_RadioButton_standards["prototype"]["getValueState"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["getValueState"]++; }; 
	return this["oRadioButtonBase"]["getValueState"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["getValueState"] = 0; };
/**
 * Sets the input state of the checkbox
 * @param {string} sValue state
 * @public
 */
UCF_RadioButton_standards["prototype"]["setValueState"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["setValueState"]++; }; 
	this["oRadioButtonBase"]["setValueState"](sValue);
	this["oRadioButtonBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["setValueState"] = 0; };

/**
 * ############################################################################
 *
 * SECTION RESPONSIBLE FOR TOUCH
 *
 * ############################################################################
 */
/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
// UCF_RadioButton_standards.prototype.onlstouchend = function(oBrowserEvent) {
// 	_assert(oBrowserEvent instanceof UCF_BrowserEvent);
// 	this.onclick(oBrowserEvent);
// };

/**
 * ############################################################################
 *
 * SECTION WITH MISC METHODS
 *
 * ############################################################################
 */

/**
 *
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RadioButton_standards["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RadioButton_standards.js(509): onmouseover"); };
	this["oRadioButtonBase"]["applyTooltip"]();
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["onmouseover"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_RadioButton_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["destroy"]++; }; 
	UCF_RadioButtonKeyboard_standards.prototype["destroy"]["apply"](this, arguments);
	// this is still used in parent UCF_RadioButtonKeyboard_standards
	// on destroy

	if (this["oRadioButtonBase"]) {
		this["oRadioButtonBase"]["destroy"]();
		this["oRadioButtonBase"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_RadioButton_standards["_"]["destroy"] = 0; };

UCF_RadioButton_standards.prototype["aPublicMethods"] = ["setValue","getValue","getEnabled","setEnabled","getEditable","setEditable","getValueState","setValueState"].concat(UCF_RadioButton_standards.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_RasterLayout"] = function() {/* global _assert, _trace, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * RasterLayout
 *
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_RasterLayout(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["UCF_RasterLayout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "RasterLayout.js(25): UCF_RasterLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RasterLayout.js(26): UCF_RasterLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "RasterLayout.js(27): UCF_RasterLayout"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["iScrollWidth"] = 0;
	this["iScrollHeight"] = 0;
	// avoid sending scrolling after initialize
	this["bIgnoreScrollEvent"] = false;
};window["UCF_RasterLayout"] = UCF_RasterLayout; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RasterLayout"); UCF_RasterLayout["_"] = {UCF_RasterLayout: 0}; }; ;
UCF_RasterLayout["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_RasterLayout.prototype["sClassName"] = "UCF_RasterLayout";

/**
 * @type {number} ms from the last scroll event to fire the RasterLayout:Scroll */
UCF_RasterLayout["SCROLL_FRAME"] = 200;

UCF_RasterLayout["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["destroy"]++; }; 
	if (this["oGridDotContainer"] && this["oGridDotContainer"]["parentNode"]) {
		this["oGridDotContainer"]["parentNode"]["removeChild"](this["oGridDotContainer"]);
		this["oGridDotContainer"] = null;
	}
	if (this["sScrollDelayedCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sScrollDelayedCallId"]);
	}
	this["bIgnoreScrollEvent"] = null;
	this["iRasterHeight"] = null;
	this["iRasterWidth"] = null;
	this["sScrollDelayedCallId"] = null;
	this["iScrollHeight"] = null;
	this["iScrollTop"] = null;
	this["iScrollLeft"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["destroy"] = 0; };

/**
 * Intialize in case scroll positions have to be applied
 */
UCF_RasterLayout["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["initialize"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(this["iScrollTop"]) === 'number', "typeof(this.iScrollTop) === 'number'", "RasterLayout.js(66): initialize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(this["iScrollLeft"]) === 'number', "typeof(this.iScrollLeft) === 'number'", "RasterLayout.js(67): initialize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["iScrollTop"] >= -1, "this.iScrollTop >= -1", "RasterLayout.js(68): initialize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["iScrollLeft"] >= -1, "this.iScrollLeft >= -1", "RasterLayout.js(69): initialize"); };

	//	_trace(INFO, '================= RasterLayout - id - ' + this.sId + ' - ScrollingMode. ' + this.sScrollingMode + ' ========= ');
	var iCurrentScrollLeft = this["iScrollLeft"],
		iCurrentScrollTop = this["iScrollTop"],
		iScrollLeft = 0,
		iScrollTop = 0,
		bApplyScrollTop = false,
		bApplyScrollLeft = false;

	// Get scroll height and scroll width to make sure that it has
	// been calculated properly by Internet Explorer
	if (iCurrentScrollTop === -1) iCurrentScrollTop = this["oDomRef"]["scrollHeight"];
	if (iCurrentScrollLeft === -1) iCurrentScrollLeft = this["oDomRef"]["scrollWidth"];

	if (window["UCF_System"]["bIsRTL"]) {
		var iScrollWidth = this["oDomRef"]["scrollWidth"];

		iCurrentScrollLeft = iScrollWidth - this["oDomRef"]["clientWidth"] - iCurrentScrollLeft;
	}

	// ScrollTop should be set only when
	// ScrollingMode: AUTO, BOTH, VERTICAL && VERTICAL_AUTO
	// and iCurrentScrollTop != 0
	bApplyScrollTop = iCurrentScrollTop !== 0 &&
		(this["sScrollingMode"] === 'AUTO' || this["sScrollingMode"] === 'BOTH'
			|| this["sScrollingMode"] === 'VERTICAL'
			|| this["sScrollingMode"] === 'VERTICAL_AUTO');

	// ScrollLeft should be set only when
	// ScrollingMode: AUTO, BOTH, HORIZONTAL && HORIZONTAL_AUTO
	bApplyScrollLeft = iCurrentScrollLeft > 0 &&
		(this["sScrollingMode"] === 'AUTO' || this["sScrollingMode"] === 'BOTH'
			|| this["sScrollingMode"] === 'HORIZONTAL'
			|| this["sScrollingMode"] === 'HORIZONTAL_AUTO');

	// first read the values
	if (bApplyScrollTop) {
		iScrollTop = this["oDomRef"]["scrollTop"];
	}

	if (bApplyScrollLeft) {
		iScrollLeft = this["oDomRef"]["scrollLeft"];
	}

	// second set the values
	if (bApplyScrollTop && iCurrentScrollTop !== iScrollTop) {
		this["oDomRef"]["scrollTop"] = iCurrentScrollTop;
		this["setIgnoreScrollEvent"](true);
	}

	if (bApplyScrollLeft && iCurrentScrollLeft !== iScrollLeft) {
		this["oDomRef"]["scrollLeft"] = iCurrentScrollLeft;
		this["setIgnoreScrollEvent"](true);
	}

	// In case LS is locked scroll events will not be dispatched
	// so clear scroll ignore flag after timeout
	UCF_JsUtil["delayedCall"](200, this, "setIgnoreScrollEvent", [false]);
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["initialize"] = 0; };

/**
 * Returns the RasterLayoutItems ordered by DOM position (childNodes). Returns an empty object if there are no items.
 * @return {Object.<string, UCF_Control>} A result entry has the control ID as key and the control instance as value.
 */
UCF_RasterLayout["prototype"]["oGetItems"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["oGetItems"]++; }; 
	var aChildren = this["oDomRef"]["childNodes"];

	if (!aChildren) return {};

	var oResult = {};

	for (var i = 0; i < aChildren["length"]; i++) {
		var oChild = aChildren[i];

		if (oChild["getAttribute"]('ct') === 'RLI') {
			var oControl = this["oGetControlByDomRef"](oChild, true);

			if (oControl) {
				oResult[oControl["sGetId"]()] = oControl;
			}
		}
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["oGetItems"] = 0; };

/**
 * Returns the size of the RL calculated by the browser, when no width/height is set via API parameters FixedWidthFixedHeight.
 * @return {Object} Properties "width" and "height" - can be null.
 */
UCF_RasterLayout["prototype"]["getInnerSize"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["getInnerSize"]++; }; 
	if (this["oGetParentPopupWindow"]()) {
		return { "width": null, "height": null };
	}

	var aChildNodes = this["oDomRef"]["childNodes"];
	var oSize = {
		"width": this["oDomRef"]["parentNode"]["offsetWidth"],
		"height": this["oDomRef"]["parentNode"]["offsetHeight"]
	};
	var oParentControl = this["oGetParent"]();

	if (oParentControl && oParentControl["sClassName"] === 'UCF_ScrollContainer'
		&& oParentControl["sScrollingMode"] !== 'NONE') {
		oSize["width"] -= 20;
		oSize["height"] -= 20;
	}
	for (var i = 0; i < aChildNodes["length"]; i++) {
		var oDomRef = aChildNodes[i];

		if (oDomRef && oDomRef["getAttribute"]('ct') === 'RLI') {
			oSize["height"] = Math["max"](oSize["height"], oDomRef["offsetTop"] + oDomRef["offsetHeight"]);
			oSize["width"] = Math["max"](oSize["width"], oDomRef["offsetLeft"] + oDomRef["offsetWidth"]);
		}
	}
	if (oParentControl && oParentControl["sClassName"] === 'UCF_ScrollContainer'
		&& oParentControl["sScrollingMode"] !== 'NONE') {
		if (oSize["height"] < oParentControl["oDomRef"]["offsetHeight"]) {
			oSize["height"] = null;
		}
		if (oSize["width"] < oParentControl["oDomRef"]["offsetWidth"]) {
			oSize["width"] = null;
		}
	}

	return oSize;
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["getInnerSize"] = 0; };

/**
 * Connects a Designtime element to the control
 * @param {UCF_DTElement} oDTElement The design time element to connect
 */
UCF_RasterLayout["prototype"]["connectDesignTimeElement"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["connectDesignTimeElement"]++; }; 
	UCF_Control.prototype["connectDesignTimeElement"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["connectDesignTimeElement"] = 0; };

/**
 * Disconnects a Designtime element to the control
 */
UCF_RasterLayout["prototype"]["disconnectDesignTimeElement"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["disconnectDesignTimeElement"]++; }; 
	UCF_Control.prototype["disconnectDesignTimeElement"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["disconnectDesignTimeElement"] = 0; };

/**
 * Renders the designtime-grid for the raster layout.
 * @public
 */
UCF_RasterLayout["prototype"]["showGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["showGrid"]++; }; 

	// Check standards
	if (__UCF_IE6__) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Showing a grid is only supported in Standards Mode', "RasterLayout.js(221): showGrid"); };

		return;
	}
	if (this["oGridDotContainer"]) {
		this["oGridDotContainer"]["style"]["display"] = 'block';

		return;
	}

	var oMeasure = document["createElement"]('DIV');

	this["oGridDotContainer"] = document["createElement"]('DIV');
	this["oGridDotContainer"]["id"] = this["sId"] + '-grid';

	// get the pixel width for the raster
	oMeasure["style"]["height"] = this["fRasterHeight"] + this["sRasterHeightUnit"];
	oMeasure["style"]["width"] = this["fRasterWidth"] + this["sRasterWidthUnit"];
	oMeasure["style"]["overflow"] = 'hidden';
	oMeasure["style"]["position"] = 'absolute';
	oMeasure["style"]["boxSizing"] = 'border-box';
	this["oRootRef"]["appendChild"](oMeasure);

	var iPixelX = oMeasure["offsetWidth"],
		iPixelY = oMeasure["offsetHeight"];

	if (iPixelY < 10) {
		iPixelY = (10 / iPixelY) * iPixelY;
	}
	if (iPixelY > iPixelX) {
		iPixelX = iPixelY - iPixelY % iPixelX;
	}

	var oCanvas = document["createElement"]('canvas'),
		oContext = oCanvas["getContext"]('2d');

	oCanvas["height"] = iPixelY;
	oCanvas["width"] = iPixelX;
	oContext["fillStyle"] = '#999';
	oContext["fillRect"](0, 0, 1, 1);
	oContext["createImageData"](iPixelX, iPixelY);
	this["oGridDotContainer"]["style"]["background"] = "url('" + oCanvas["toDataURL"]("image/png") + "')";
	this["oGridDotContainer"]["style"]["height"] = '100%';
	this["oGridDotContainer"]["style"]["width"] = '100%';
	this["oGridDotContainer"]["style"]["position"] = 'absolute';
	this["oRootRef"]["insertBefore"](this["oGridDotContainer"], this["oRootRef"]["firstChild"]);
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["showGrid"] = 0; };

/**
 * Hides the designtime grid
 * @public
 */
UCF_RasterLayout["prototype"]["hideGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["hideGrid"]++; }; 
	if (this["oGridDotContainer"]) {
		this["oGridDotContainer"]["style"]["display"] = 'none';
	}
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["hideGrid"] = 0; };

/**
 * Returns the calculated values for the raster grid in px.
 * @return {Object}
 */
UCF_RasterLayout["prototype"]["oGetRasterSizePx"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["oGetRasterSizePx"]++; }; 
	// if (this.iRasterWidth === undefined) {
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '>>> this.fRasterWidth:' + this["fRasterWidth"] + ', this.sRasterWidthUnit:' + this["sRasterWidthUnit"] + ', this.fRasterHeight:' + this["fRasterHeight"] + ', this.sRasterHeightUnit:' + this["sRasterHeightUnit"], "RasterLayout.js(285): oGetRasterSizePx"); };

	var oMeasure = document["createElement"]('DIV');

	oMeasure["style"]["height"] = this["fRasterHeight"] + this["sRasterHeightUnit"];
	oMeasure["style"]["width"] = this["fRasterWidth"] + this["sRasterWidthUnit"];
	oMeasure["style"]["overflow"] = 'hidden';
	oMeasure["style"]["position"] = 'absolute';
	oMeasure["style"]["boxSizing"] = 'border-box';
	this["oRootRef"]["appendChild"](oMeasure);
	this["iRasterWidth"] = oMeasure["offsetWidth"];
	this["iRasterHeight"] = oMeasure["offsetHeight"];
	this["oRootRef"]["removeChild"](oMeasure);
	// }

	return { "width": this["iRasterWidth"], "height": this["iRasterHeight"] };
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["oGetRasterSizePx"] = 0; };

/**
 * Set ignore scroll flag to avoid scroll events to be thrown
 * by setting the scroll position programmatically
 * @param { boolean } bIgnoreScrollEvent
 */
UCF_RasterLayout["prototype"]["setIgnoreScrollEvent"] = function(bIgnoreScrollEvent) {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["setIgnoreScrollEvent"]++; }; 

	this["bIgnoreScrollEvent"] = bIgnoreScrollEvent;

};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["setIgnoreScrollEvent"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oScroll the scroll
 */
UCF_RasterLayout["prototype"]["onscroll"] = function(oScroll) {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["onscroll"]++; }; 

	oScroll["cancelBubble"]();

	if (this["bIgnoreScrollEvent"]) {

		return;
	}

	if (this["sScrollDelayedCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sScrollDelayedCallId"]);
	}
	this["sScrollDelayedCallId"] = UCF_JsUtil["delayedCall"](
		UCF_RasterLayout["SCROLL_FRAME"],
		this,
		'fireScrollSync'
	);
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["onscroll"] = 0; };

/** @private */
UCF_RasterLayout["prototype"]["fireScrollSync"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["fireScrollSync"]++; }; 
	this["fireScroll"](this["sId"], this["oDomRef"]["scrollTop"], this["oDomRef"]["scrollLeft"]);
	delete this["sScrollDelayedCallId"];
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["fireScrollSync"] = 0; };

/**
 * @public
 * @return {number}
 */
UCF_RasterLayout["prototype"]["getAvailableWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["getAvailableWidth"]++; }; 
	/** @type {CSSStyleDeclaration} */
	var oComputedStyle = UCF_DomUtil["oGetComputedStyle"](this["oDomRef"]);

	return this["oDomRef"]["offsetWidth"] -
		(parseInt(oComputedStyle["paddingLeft"], 10) || 0) -
		(parseInt(oComputedStyle["paddingRight"], 10) || 0);
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["getAvailableWidth"] = 0; };

/**
 * @public
 * @return {number}
 */
UCF_RasterLayout["prototype"]["getAvailableHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["getAvailableHeight"]++; }; 
	/** @type {CSSStyleDeclaration} */
	var oComputedStyle = UCF_DomUtil["oGetComputedStyle"](this["oDomRef"]);

	return this["oDomRef"]["offsetHeight"] -
		(parseInt(oComputedStyle["paddingTop"], 10) || 0) -
		(parseInt(oComputedStyle["paddingBottom"], 10) || 0);
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["getAvailableHeight"] = 0; };
/**
 * Set scroll position
 *
 * @public
 *
 * @param {int} iScrollTop
 * @param {int} iScrollLeft
 */
UCF_RasterLayout["prototype"]["setScrollPosition"] = function(iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["setScrollPosition"]++; }; 

	this["iScrollTop"] = iScrollTop;
	this["iScrollLeft"] = iScrollLeft;
	this["setClientProperty"]("ScrollTop", this["iScrollTop"], true);
	this["setClientProperty"]("ScrollLeft", this["iScrollLeft"], true);
	// hier etwas Schöneres, aber im Moment würde das tun
	this["initialize"]();

};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["setScrollPosition"] = 0; };

/**
 * Returns the scroll position of the ScrollArea
 *
 * @return {Object}
 * @public
 */
UCF_RasterLayout["prototype"]["getScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["getScrollPosition"]++; }; 
	if (this["oDomRef"]) {
		return {
			"top": this["oDomRef"]["scrollTop"],
			"left": this["oDomRef"]["scrollLeft"]
		};
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["getScrollPosition"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RasterLayout["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["onlsskipforward"]++; }; 
	/** @type {HTMLElement} */
	var oResult;
	/** @type {boolean} */
	var bSearching = false;
	/** @type {HTMLElement} */
	var oAE = UCF_DomUtil["oGetActiveElement"]();

	UCF_JsUtil["forEach"](UCF_JsUtil["values"](this["oGetItems"]()), function(oItem) {
		var oChild;
		if (!oResult) {
			if (bSearching) {
				oChild = oItem["oGetFirstChildControl"]();
				if (oChild && oChild["onlsskipforward"]) {
					oResult = UCF_DomUtil["oGetTabbableElementForward"](oChild["oRootRef"], true);
				}
			} else if (UCF_DomUtil["bContains"](oItem["oRootRef"], oAE)) {
				bSearching = true;
			}
		}
	});

	if (oResult && UCF_DomUtil["bDomElementFocused"](oResult)) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RasterLayout["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["onlsskipback"]++; }; 
	/** @type {HTMLElement} */
	var oResult;
	/** @type {boolean} */
	var bSearching = false;
	/** @type {HTMLElement} */
	var oAE = UCF_DomUtil["oGetActiveElement"]();

	UCF_JsUtil["forEach"](UCF_JsUtil["values"](this["oGetItems"]())["reverse"](), function(oItem) {
		var oChild;
		if (!oResult) {
			if (bSearching) {
				oChild = oItem["oGetLastChildControl"]();
				if (oChild && oChild["onlsskipback"]) {
					oResult = UCF_DomUtil["oGetTabbableElementBackward"](oChild["oRootRef"], true);
				}
			} else if (UCF_DomUtil["bContains"](oItem["oRootRef"], oAE)) {
				bSearching = true;
			}
		}
	});

	if (oResult && UCF_DomUtil["bDomElementFocused"](oResult)) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["onlsskipback"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_RasterLayout["prototype"]["aAttributeNames"] = ["fRasterHeight","sRasterHeightUnit","fRasterWidth","sRasterWidthUnit","sCustomData","sVisibility","sScrollingMode","iScrollTop","iScrollLeft","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_RasterLayout["prototype"]["aEventNames"] = ["Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_RasterLayout["prototype"]["aMethodNames"] = ["showGrid","hideGrid","getAvailableWidth","getAvailableHeight","setScrollPosition","getScrollPosition","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {number}
 */
UCF_RasterLayout["prototype"]["fRasterHeight"] = 1;

/**
 * @private
 * @type {string}
 */
UCF_RasterLayout["prototype"]["sRasterHeightUnit"] = 'px';

/**
 * @private
 * @type {number}
 */
UCF_RasterLayout["prototype"]["fRasterWidth"] = 1;

/**
 * @private
 * @type {string}
 */
UCF_RasterLayout["prototype"]["sRasterWidthUnit"] = 'px';

/**
 * @private
 * @type {string}
 */
UCF_RasterLayout["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_RasterLayout["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ScrollingMode}
 */
UCF_RasterLayout["prototype"]["sScrollingMode"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_RasterLayout["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_RasterLayout["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_RasterLayout["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_RasterLayout["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["setDefaultValues"]++; }; 
	this["fRasterHeight"] = 1;
	this["sRasterHeightUnit"] = 'px';
	this["fRasterWidth"] = 1;
	this["sRasterWidthUnit"] = 'px';
	this["sCustomData"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sScrollingMode"] = "NONE";
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("RasterHeight", 1, true);
		this["setClientProperty"]("RasterHeightUnit", 'px', true);
		this["setClientProperty"]("RasterWidth", 1, true);
		this["setClientProperty"]("RasterWidthUnit", 'px', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ScrollingMode", "NONE", true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires RasterLayout::Scroll
 */
UCF_RasterLayout["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "RasterLayout.js(592): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "RasterLayout.js(593): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "RasterLayout.js(594): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "RasterLayout.js(595): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "RasterLayout.js(596): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "RasterLayout.js(597): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "RasterLayout.js(598): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("RasterLayout", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_RasterLayout["_"]["fireScroll"] = 0; };

UCF_RasterLayout.prototype["aPublicMethods"] = ["showGrid","hideGrid","getAvailableWidth","getAvailableHeight","setScrollPosition","getScrollPosition"].concat(UCF_RasterLayout.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_RasterLayoutItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_AccessibilityHelper */
/// <reference path="../helper/AccessibilityHelper.js"/>

/**
 * RasterLayoutItem
 *
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_RasterLayoutItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RasterLayoutItem["_"]["UCF_RasterLayoutItem"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "RasterLayoutItem.js(24): UCF_RasterLayoutItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RasterLayoutItem.js(25): UCF_RasterLayoutItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "RasterLayoutItem.js(26): UCF_RasterLayoutItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	this["oAccessibilityHelper"] = null;
	//this.oLS.oBrowserWindow.attachEvent(this.oLS.oBrowserWindow.E_EVENTS.LayoutChange, this, "onLayoutChange");
	//this.sRenderWidth = null;
	//this.sRenderHeight = null;
	if (this["bHitZone"]) {
		var aContent = this["aGetContainedControls"]();
		if (aContent["length"] > 0) {
			this["oContent"] = aContent[0];
			this["addDelegate"](this["oContent"]);
		}
	}

};window["UCF_RasterLayoutItem"] = UCF_RasterLayoutItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RasterLayoutItem"); UCF_RasterLayoutItem["_"] = {UCF_RasterLayoutItem: 0}; }; ;
UCF_RasterLayoutItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_RasterLayoutItem.prototype["sClassName"] = "UCF_RasterLayoutItem";

UCF_RasterLayoutItem["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayoutItem["_"]["destroy"]++; }; 
	//this.oLS.oBrowserWindow.detachEvent(this.oLS.oBrowserWindow.E_EVENTS.LayoutChange, this, "onLayoutChange");
	if (this["oContent"]) {
		this["removeDelegate"](this["oContent"]);
	}
	this["oContent"] = null;
	if (this["oAccessibilityHelper"]) {
		this["oAccessibilityHelper"]["destroy"]();
		this["oAccessibilityHelper"] = null;
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RasterLayoutItem["_"]["destroy"] = 0; };

UCF_RasterLayoutItem["prototype"]["oGetParent"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayoutItem["_"]["oGetParent"]++; }; 
	if (this["oRootRef"] && this["oRootRef"]["parentNode"] && this["oRootRef"]["parentNode"]["id"]["indexOf"]("-r") > -1) {
		return this["oGetControlById"](this["oRootRef"]["parentNode"]["id"]["substring"](0, this["oRootRef"]["parentNode"]["id"]["indexOf"]("-")));
	}
	return UCF_Control.prototype["oGetParent"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RasterLayoutItem["_"]["oGetParent"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RasterLayoutItem["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RasterLayoutItem["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RasterLayoutItem.js(72): onlsaccessibility"); };

	if (this["sSemanticColor"] === "NONE") return;
	var oEventAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	this["oAccessibilityHelper"] = new (UCF_ClassLoader["oGetClass"]("UCF_AccessibilityHelper"))(this["oLS"]);

	var parentGrid = UCF_DomUtil["oGetParentByTagName"](this["oDomRef"], "TABLE");
	if (parentGrid) {
		var oLegendDomRef = UCF_DomUtil["$"](parentGrid["id"] + "-legend");
		if (oLegendDomRef) this["oAccessibilityHelper"]["setLegendJSDomRef"](oLegendDomRef);
	}
	this["oAccessibilityHelper"]["addSemantic"](this["sSemanticColor"]);

	oEventAccessibilityHelper["addContainerHelper"](this["oAccessibilityHelper"]);

};;if (__UCF_COVERAGE__) { UCF_RasterLayoutItem["_"]["onlsaccessibility"] = 0; };

/*
UCF_RasterLayoutItem.prototype.onLayoutChange = function(oEvent) {
	if (!oEvent) return;

	var sId = null;
	if (oEvent.mGetParameters()) sId = oEvent.mGetParameters().sControlId;
	if (sId) {
		var oContent = this.oGetFirstChildControl();
		if (oContent && sId == oContent.sGetId()) {
			var w = oEvent.mGetParameters().width;
			var h = oEvent.mGetParameters().height;
			var bFixedSize = false;
			if (w) {
				this.sRenderWidth = this.oDomRef.style.width;
				this.oDomRef.style.width = w;
				bFixedSize = true;
			}
			if (h) {
				this.sRenderHeight = this.oDomRef.style.height;
				this.oDomRef.style.height = h;
				bFixedSize = true;
			}
			//console.log(">>> w=" + w + ", h=" + h + ", this.sRenderWidth=" + this.sRenderWidth);

			if (!bFixedSize && this.sRenderWidth && this.sRenderHeight) {
				this.oDomRef.style.width = this.sRenderWidth;
				this.oDomRef.style.height = this.sRenderHeight;
			}
		}
	}
};
*/
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_RasterLayoutItem["prototype"]["aAttributeNames"] = ["iTop","iLeft","iWidth","iHeight","sSemanticColor","sCustomData","iZIndex","bHitZone","sCssTop","sCssLeft","sCssBottom","sCssRight","sCssWidth","sCssHeight","sCssMinWidth","sCssMinHeight","sCssMaxWidth","sCssMaxHeight","sCustomStyle","sVisibility"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_RasterLayoutItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_RasterLayoutItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_RasterLayoutItem["prototype"]["iTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_RasterLayoutItem["prototype"]["iLeft"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_RasterLayoutItem["prototype"]["iWidth"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_RasterLayoutItem["prototype"]["iHeight"] = 0;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_RasterLayoutItem["prototype"]["sSemanticColor"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {number}
 */
UCF_RasterLayoutItem["prototype"]["iZIndex"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_RasterLayoutItem["prototype"]["bHitZone"] = false;

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCssTop"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCssLeft"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCssBottom"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCssRight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCssWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCssHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCssMinWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCssMinHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCssMaxWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCssMaxHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RasterLayoutItem["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_RasterLayoutItem["prototype"]["sVisibility"] = "VISIBLE";

//#JSCOVER_EXCL_START
/** @protected */
UCF_RasterLayoutItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_RasterLayoutItem["_"]["setDefaultValues"]++; }; 
	this["iTop"] = 0;
	this["iLeft"] = 0;
	this["iWidth"] = 0;
	this["iHeight"] = 0;
	this["sSemanticColor"] = "NONE";
	this["sCustomData"] = '';
	this["iZIndex"] = 0;
	this["bHitZone"] = false;
	this["sCssTop"] = '';
	this["sCssLeft"] = '';
	this["sCssBottom"] = '';
	this["sCssRight"] = '';
	this["sCssWidth"] = '';
	this["sCssHeight"] = '';
	this["sCssMinWidth"] = '';
	this["sCssMinHeight"] = '';
	this["sCssMaxWidth"] = '';
	this["sCssMaxHeight"] = '';
	this["sCustomStyle"] = '';
	this["sVisibility"] = "VISIBLE";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Top", 0, true);
		this["setClientProperty"]("Left", 0, true);
		this["setClientProperty"]("Width", 0, true);
		this["setClientProperty"]("Height", 0, true);
		this["setClientProperty"]("SemanticColor", "NONE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("ZIndex", 0, true);
		this["setClientProperty"]("HitZone", false, true);
		this["setClientProperty"]("CssTop", '', true);
		this["setClientProperty"]("CssLeft", '', true);
		this["setClientProperty"]("CssBottom", '', true);
		this["setClientProperty"]("CssRight", '', true);
		this["setClientProperty"]("CssWidth", '', true);
		this["setClientProperty"]("CssHeight", '', true);
		this["setClientProperty"]("CssMinWidth", '', true);
		this["setClientProperty"]("CssMinHeight", '', true);
		this["setClientProperty"]("CssMaxWidth", '', true);
		this["setClientProperty"]("CssMaxHeight", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
	}
};;if (__UCF_COVERAGE__) { UCF_RasterLayoutItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_RatingIndicator"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * Rating Indicator
 *
 * If the server sets the iItemCount property the new behavior is activated
 * The new behavior is:
 *
 * If the RatingIndicator is not read only items han be hovered with the mouse
 * After the user clicked the item the iRatingIndex is set and a Rate event is
 * raises. As long as the server does not resend the RatingIndicator the new
 * value will stay. There is not possibility to get back the old rated value
 * that was displayed initially. As long as the user did not click the old
 * value is restored. For keyboard the user needs to focus the control. Rating
 * is done with arrow keys and a blur of the Rating indicator. As long as the
 * user did not blur the RatingIndicator with he can use escape key to restore
 * the old value. Once a Rate event was sent only the server can send a new
 * RatingIndicator with new average values.
 *
 * 
 *
 * @class UCF_RatingIndicator
 * @extends UCF_Control
 * @param {HTMLDivElement} oDomRef the dom element representing the RatingIndicator
 * @param {UCF_LS} oLS the LightSpeed instance managing the RatingIndicator
 */
function UCF_RatingIndicator(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["UCF_RatingIndicator"]++; }; 
	if (arguments["length"] < 2) { // eslint-disable-line no-magic-numbers
		return; // needed for inheritance
	}

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "RatingIndicator.js(51): UCF_RatingIndicator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oLS, 'UCF_LS'), "UCF_JsUtil.bInstanceOf(oLS, 'UCF_LS')", "RatingIndicator.js(52): UCF_RatingIndicator"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	/** @type {number} */
	this["iHoveredIndex"] = 0;
	/** @type {number} */
	this["iRatedIndex"] = 0;
	/** @type {number} */
	this["iOldRatedIndex"] = 0;
	/** @type {boolean} */
	this["bLastAccessedWithKeyboard"] = false;
	/** @type {boolean} */
	this["bAccBlur"] = false;

	/** @type {boolean} */
	this["bUsedInTable"] = UCF_JsUtil["bInstanceOf"](this["oGetParent"](), 'UCF_SapTable') || UCF_JsUtil["bInstanceOf"](this["oGetParent"](), 'UCF_SapTableCS');
	/** @type {boolean} */
	this["bTableNavigation"] = this["bUsedInTable"];

	/** @type {boolean} abstracts 'only in new render mode' */
	this["bIsInteractiveRenderMode"] = this["iItemCount"] > 0;

	/**
	 * For ARIA, the RatingIndicator either announces "average rating x of y"
	 * or "current rating x of y". However, once "current rating ..." is announced,
	 * one can never go back to "average rating ..." (just via roundtrip). It
	 * is therefore cumbersome to announce "current rating" on every hover,
	 * so we announce it only the first time and from then on only "x of y".
	 *
	 * @see [WDAUIUR1-936 Aria: Implementation for RatingIndicator](http://sapjira/browse/WDAUIUR1-936)
	 * @see #applyAriaInformation
	 * @type {number} iAriaMode
	 */
	this["iAriaMode"] = UCF_RatingIndicator["E_ARIA_MODE"]["AVERAGE"];
};window["UCF_RatingIndicator"] = UCF_RatingIndicator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RatingIndicator"); UCF_RatingIndicator["_"] = {UCF_RatingIndicator: 0}; }; ;
UCF_RatingIndicator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_RatingIndicator.prototype["sClassName"] = "UCF_RatingIndicator";

/** @type {Object.<string, number>} */
UCF_RatingIndicator["E_ARIA_MODE"] = {
	"AVERAGE": 0,
	"CURRENT": 1,
	"CURRENT_ANNOUNCE": 2
};

/** @type {Object.<string, number>} */
UCF_RatingIndicator["E_SELECTION"] = {
	"FIRST": 0,
	"PREVIOUS": 1,
	"EXACT": 2,
	"NEXT": 3,
	"NEXT_WRAPPING": 4,
	"LAST": 5
};

/** @private */
UCF_RatingIndicator["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["initialize"]++; }; 
	// Workaround-of-the-year-candidate: In IE-Quirks AND inside PopupWindow stars are misplaced until you trigger IE to re-render
	if (window["UCF_System"]["sDevice"] !== 'standards' && UCF_UserAgent["bIsIE"]()) {
		this["oDomRef"]["style"]["backgroundColor"] = 'transparent';
		this["oDomRef"]["style"]["backgroundColor"] = '';
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["initialize"] = 0; };

/** @override */
UCF_RatingIndicator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["destroy"]++; }; 
	this["iHoveredIndex"] = null;
	this["iRatedIndex"] = null;
	this["iOldRatedIndex"] = null;
	this["bUsedInTable"] = null;
	this["bTableNavigation"] = null;
	this["bIsInteractiveRenderMode"] = null;
	this["iAriaMode"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["destroy"] = 0; };

/**
 * Returns the item dom ref by event
 *
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @return {HTMLSpanElement} the item referenced in the browser event
 */
UCF_RatingIndicator["prototype"]["getItemDomRef"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["getItemDomRef"]++; }; 
	/** @type {UCF_RatingIndicatorItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RatingIndicator.js(141): getItemDomRef"); };

	if (this["bIsInteractiveRenderMode"]) {
		oItem = oBrowserEvent["oGetSource"]();
		while (oItem !== this["oDomRef"]) {
			if (oItem["id"]) {
				return oItem;
			}
			oItem = oItem["parentNode"];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["getItemDomRef"] = 0; };

/**
 * Returns the item index of the given item or -1 if no ItemDomRef was given
 *
 *
 * @private
 * @param {HTMLSpanElement} oItemDomRef the span representing the item
 * @return {number} the index of the span
 */
UCF_RatingIndicator["prototype"]["getItemIndex"] = function(oItemDomRef) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["getItemIndex"]++; }; 
	if (oItemDomRef["id"] && oItemDomRef["id"]["indexOf"](this["sId"] + '-item-') === 0) {
		return parseInt(oItemDomRef["id"]["replace"](this["sId"] + '-item-', ''));
	}
	return -1;
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["getItemIndex"] = 0; };

/**
 * Hovers an item with the given dom ref and all previous siblings. If no item is given
 * the initial case is restored.
 *
 *
 * @private
 * @param {HTMLSpanElement} [oItemDomRef] if given this item and all previous siblings are hovered otherwise the hover state is removed.
 */
UCF_RatingIndicator["prototype"]["hoverItem"] = function(oItemDomRef) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["hoverItem"]++; }; 
	/** @type {string} */
	var sImg = this["sHoverItemIconSrc"];
	/** @type {boolean} */
	var bNotFound = oItemDomRef != null;
	/** @type {boolean} */
	var bHasIconSrc = this["sHoverItemIconSrc"] !== '';
	/** @type {number} */
	var i;
	/** @type {HTMLElement} */
	var oNode;
	/** @type {HTMLElement} */
	var oLast;

	for (i = 0; i < this["oDomRef"]["childNodes"]["length"]; i++) {
		oNode = this["oDomRef"]["childNodes"][i];

		if (oNode["nodeType"] === 1) {
			oLast = oNode["lastChild"];
			if (!oLast["getAttribute"]('oldWidth')) {
				oLast["setAttribute"]('oldWidth', oLast["style"]["width"]);
			}
			if (bHasIconSrc && !oLast["firstChild"]["getAttribute"]('originalSrc')) {
				oLast["firstChild"]["setAttribute"]('originalSrc', oLast["firstChild"]["src"]);
			}
			if (!oItemDomRef) {
				if (this["iRatedIndex"] > 0) {
					if (i <= this["iRatedIndex"] - 1) {
						if (sImg) {
							oLast["firstChild"]["src"] = sImg;
						} else {
							UCF_DomUtil["addClass"](oLast["firstChild"], 'lsRI2ItemImgHover');
						}
						oLast["style"]["width"] = '100%';
					} else {
						oLast["style"]["width"] = '0%';
					}
				} else if (oLast["getAttribute"]('oldWidth')) {
					oLast["style"]["width"] = oLast["getAttribute"]('oldWidth');
					if (bHasIconSrc) {
						oLast["firstChild"]["src"] = oLast["firstChild"]["getAttribute"]('originalSrc');
					} else {
						UCF_DomUtil["removeClass"](oLast["firstChild"], 'lsRI2ItemImgHover');
					}
				}
				continue;
			}
			if (bNotFound) {
				oLast["style"]["width"] = '100%';
				if (bHasIconSrc) {
					oLast["firstChild"]["src"] = sImg;
				} else {
					UCF_DomUtil["addClass"](oLast["firstChild"], 'lsRI2ItemImgHover');
				}
			} else {
				oLast["style"]["width"] = '0%';
				if (bHasIconSrc) {
					oLast["firstChild"]["src"] = oLast["firstChild"]["getAttribute"]('originalSrc');
				} else {
					UCF_DomUtil["removeClass"](oLast["firstChild"], 'lsRI2ItemImgHover');
				}
			}
		}
		if (oNode === oItemDomRef) {
			this["iHoveredIndex"] = this["getItemIndex"](oItemDomRef);
			bNotFound = false;
			if (this["iAriaMode"] === UCF_RatingIndicator["E_ARIA_MODE"]["AVERAGE"]) {
				this["iAriaMode"] = UCF_RatingIndicator["E_ARIA_MODE"]["CURRENT_ANNOUNCE"];
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["hoverItem"] = 0; };

/** @private */
UCF_RatingIndicator["prototype"]["applyAriaInformation"] = function() {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["applyAriaInformation"]++; }; 
	var sValueText;
	var fIndex;

	switch (this["iAriaMode"]) {
		case UCF_RatingIndicator["E_ARIA_MODE"]["AVERAGE"]:
			fIndex = this["fValue"];
			sValueText = 'SAPUR_RI_VAL_AVERAGE';
			break;
		case UCF_RatingIndicator["E_ARIA_MODE"]["CURRENT"]:
			fIndex = this["iHoveredIndex"];
			sValueText = 'SAPUR_RI_VAL';
			break;
		case UCF_RatingIndicator["E_ARIA_MODE"]["CURRENT_ANNOUNCE"]:
			fIndex = this["iHoveredIndex"];
			sValueText = 'SAPUR_RI_VAL_CURRENT';
			break;
	}

	// JAWS seems to not read aria-valuenow etc if an element with those attributes
	// has the focus while JAWS is starting. One has to fully exit + restart JAWS
	// (and wait patiently until it is restarted before interacting again).

	// JAWS will not read aria-valuenow etc if in "Basics" > "Tutor Messages"
	// it is configured to "Turn off Menu and Control help"
	this["oDomRef"]["setAttribute"]('aria-valuenow', this["iHoveredIndex"]);
	this["oDomRef"]["setAttribute"]('aria-valuetext', this["oLS"]["sGetText"](sValueText, [fIndex, this["iItemCount"]]));
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["applyAriaInformation"] = 0; };

/**
 * Handles the mouseover event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_RatingIndicator["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "RatingIndicator.js(288): onmouseover"); };

	/** @type {HTMLSpanElement} */
	var oItem;

	if (this["bIsInteractiveRenderMode"] && !this["bReadonly"] && this["bEnabled"]) {
		oItem = this["getItemDomRef"](oBrowserEvent);
		if (oItem) {
			this["hoverItem"](oItem);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onmouseover"] = 0; };

/**
 * Handles the onmouseout event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 *
 * @private
 */
UCF_RatingIndicator["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "RatingIndicator.js(311): onmouseout"); };

	if (this["bIsInteractiveRenderMode"] && !this["bReadonly"] && this["bEnabled"]) {
		this["hoverItem"]();
		if (this["iRatedIndex"] === 0) {
			this["iHoveredIndex"] = 0;
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onmouseout"] = 0; };

/**
 * @see UCF_RatingIndicator.E_SELECTION
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the selection event
 * @param {number} iSelectiontype the selection type
 * @param {number} [iHoveredIndex] the hovered index, only evaluated if iSelectionType is EXACT
 */
UCF_RatingIndicator["prototype"]["handleItemHover"] = function(oBrowserEvent, iSelectiontype, iHoveredIndex) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["handleItemHover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "RatingIndicator.js(331): handleItemHover"); };

	/** @type {HTMLSpanElement} */
	var oItem;

	if (this["bIsInteractiveRenderMode"] && !this["bReadonly"] && this["bEnabled"] && !this["bTableNavigation"] && !oBrowserEvent["bCtrl"]() && !oBrowserEvent["bAlt"]() && !oBrowserEvent["bShift"]()) {
		oItem = this["oGetItemFromHover"](iSelectiontype, iHoveredIndex);
		if (oItem) {
			this["hoverItem"](oItem);
			this["applyAriaInformation"]();
			if (this["iAriaMode"] === UCF_RatingIndicator["E_ARIA_MODE"]["CURRENT_ANNOUNCE"]) {
				this["iAriaMode"] = UCF_RatingIndicator["E_ARIA_MODE"]["CURRENT"];
			}
		}
		this["iRatedIndex"] = this["iHoveredIndex"];
		if (this["oLS"]["oSystem"]["bIs508"]) {
			this["bAccBlur"] = true;
			this["refocus"](this["oDomRef"]);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["handleItemHover"] = 0; };

/**
 * @see UCF_RatingIndicator.E_SELECTION
 * @private
 * @param {number} iSelectiontype the selection type
 * @param {number} [iHoveredIndex] the hovered index, only evaluated if iSelectionType is EXACT
 * @return {HTMLSpanElement} the item
 */
UCF_RatingIndicator["prototype"]["oGetItemFromHover"] = function(iSelectiontype, iHoveredIndex) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["oGetItemFromHover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["contains"](UCF_JsUtil["values"](UCF_RatingIndicator["E_SELECTION"]), iSelectiontype), "UCF_JsUtil.contains(UCF_JsUtil.values(UCF_RatingIndicator.E_SELECTION), iSelectiontype)", "RatingIndicator.js(363): oGetItemFromHover"); };

	switch (iSelectiontype) {
		case UCF_RatingIndicator["E_SELECTION"]["FIRST"]:
			return UCF_DomUtil["$"](this["sId"] + '-item-1');
		case UCF_RatingIndicator["E_SELECTION"]["PREVIOUS"]:
			return UCF_DomUtil["$"](this["sId"] + '-item-' + Math["max"]((this["iHoveredIndex"] - 1), 1));
		case UCF_RatingIndicator["E_SELECTION"]["EXACT"]:
			if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iHoveredIndex === 'number', "typeof iHoveredIndex === 'number'", "RatingIndicator.js(371): oGetItemFromHover"); };
			if (__UCF_ASSERT__) { UCF_Tracer.assert(0 <= iHoveredIndex && iHoveredIndex <= this["iItemCount"], "0 <= iHoveredIndex && iHoveredIndex <= this.iItemCount", "RatingIndicator.js(372): oGetItemFromHover"); };
			return UCF_DomUtil["$"](this["sId"] + '-item-' + iHoveredIndex);
		case UCF_RatingIndicator["E_SELECTION"]["NEXT"]:
			return UCF_DomUtil["$"](this["sId"] + '-item-' + Math["min"]((this["iHoveredIndex"] + 1), this["iItemCount"]));
		case UCF_RatingIndicator["E_SELECTION"]["NEXT_WRAPPING"]:
			return UCF_DomUtil["$"](this["sId"] + '-item-' + ((this["iHoveredIndex"] === this["iItemCount"]) ? '1' : (this["iHoveredIndex"] + 1)));
		case UCF_RatingIndicator["E_SELECTION"]["LAST"]:
			return UCF_DomUtil["$"](this["sId"] + '-item-' + this["iItemCount"]);
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["oGetItemFromHover"] = 0; };

/**
 * Handles the onlsleft event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_RatingIndicator["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsleft"]++; }; 
	this["handleItemHover"](oBrowserEvent, this["oLS"]["oSystem"]["bIsRTL"] ? UCF_RatingIndicator["E_SELECTION"]["NEXT"] : UCF_RatingIndicator["E_SELECTION"]["PREVIOUS"]);
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsleft"] = 0; };

/**
 * Handles the onlsright event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_RatingIndicator["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsright"]++; }; 
	this["handleItemHover"](oBrowserEvent, this["oLS"]["oSystem"]["bIsRTL"] ? UCF_RatingIndicator["E_SELECTION"]["PREVIOUS"] : UCF_RatingIndicator["E_SELECTION"]["NEXT"]);
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsright"] = 0; };

/**
 * Handles the onlsup event
 * Only in none table case
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_RatingIndicator["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsup"]++; }; 
	if (!this["bUsedInTable"]) {
		this["handleItemHover"](oBrowserEvent, UCF_RatingIndicator["E_SELECTION"]["NEXT"]);
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsup"] = 0; };

/**
 * Handles the onlsdown event
 * Only in none table case
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_RatingIndicator["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsdown"]++; }; 
	if (!this["bUsedInTable"]) {
		this["handleItemHover"](oBrowserEvent, UCF_RatingIndicator["E_SELECTION"]["PREVIOUS"]);
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsdown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshome
 */
UCF_RatingIndicator["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlshome"]++; }; 
	this["handleItemHover"](oBrowserEvent, UCF_RatingIndicator["E_SELECTION"]["FIRST"]);
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlshome"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsend
 */
UCF_RatingIndicator["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsend"]++; }; 
	this["handleItemHover"](oBrowserEvent, UCF_RatingIndicator["E_SELECTION"]["LAST"]);
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsend"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsspace
 */
UCF_RatingIndicator["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsspace"]++; }; 
	this["handleItemHover"](oBrowserEvent, UCF_RatingIndicator["E_SELECTION"]["NEXT_WRAPPING"]);
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsspace"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsenter
 */
UCF_RatingIndicator["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsenter"]++; }; 
	this["handleItemHover"](oBrowserEvent, UCF_RatingIndicator["E_SELECTION"]["NEXT_WRAPPING"]);
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsenter"] = 0; };

/**
 * Handles the lsescape that resets the rating
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_RatingIndicator["prototype"]["onlsescape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsescape"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "RatingIndicator.js(470): onlsescape"); };

	if (this["bIsInteractiveRenderMode"] && !this["bReadonly"] && this["bEnabled"]) {
		this["iRatedIndex"] = this["iOldRatedIndex"];
		this["iHoveredIndex"] = this["iOldRatedIndex"];
		this["hoverItem"]();
		if (this["oLS"]["oSystem"]["bIs508"]) {
			this["bAccBlur"] = true;
			this["refocus"](this["oDomRef"]);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsescape"] = 0; };

/**
 * Handles the onblur that resets the rating if nothing was rated by the user
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_RatingIndicator["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsblur"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "RatingIndicator.js(492): onlsblur"); };

	if (this["bIsInteractiveRenderMode"] && !this["bReadonly"] && this["bEnabled"]) {
		this["hoverItem"]();
		if (this["iRatedIndex"] > 0 && this["iRatedIndex"] !== this["iOldRatedIndex"]) {
			if (!this["bAccBlur"]) { // event was raised by refocus for acc. Avoid firing to server
				this["fireRate"](this["sId"], this["iRatedIndex"]);
			}
		}
		if (this["iRatedIndex"] === 0) {
			this["iHoveredIndex"] = 0;
		}
		if (!this["bAccBlur"]) { // event was raised by refocus for acc. Avoid firing to server
			if (!this["bUsedInTable"]) {
				oBrowserEvent["cancel"]();
				oBrowserEvent["cancelBubble"]();
			} else {
				this["bTableNavigation"] = this["bUsedInTable"];
			}
		}
	}

	if (this["iAriaMode"] === UCF_RatingIndicator["E_ARIA_MODE"]["CURRENT"]) {
		this["iAriaMode"] = UCF_RatingIndicator["E_ARIA_MODE"]["CURRENT_ANNOUNCE"];
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsblur"] = 0; };

/**
 * Handles the onfocus that resets the rating if nothing was rated by the user
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_RatingIndicator["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "RatingIndicator.js(526): onlsfocus"); };

	if (this["bIsInteractiveRenderMode"] && !this["bReadonly"] && this["bEnabled"]) {
		if (this["bAccBlur"]) {
			this["bAccBlur"] = false;
		} else {
			if (this["iRatedIndex"] > 0) {
				if (this["iRatedIndex"] !== this["iOldRatedIndex"]) {
					this["iOldRatedIndex"] = this["iRatedIndex"];
				}
				this["iHoveredIndex"] = this["iRatedIndex"];
			}
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsfocus"] = 0; };

/**
 * Handles the click event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_RatingIndicator["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "RatingIndicator.js(551): onclick"); };

	/** @type {HTMLSpanElement} */
	var oItem;

	if (this["bIsInteractiveRenderMode"] && !this["bReadonly"] && this["bEnabled"]) {
		if (this["bUsedInTable"]) {
			this["bTableNavigation"] = false;
		}

		oItem = this["getItemDomRef"](oBrowserEvent);
		if (oItem) {
			this["iHoveredIndex"] = this["getItemIndex"](oItem);
			this["iRatedIndex"] = this["iHoveredIndex"];
			this["hoverItem"]();
			this["fireRate"](this["sId"], this["iRatedIndex"]);
			this["iOldRatedIndex"] = this["iRatedIndex"];
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onclick"] = 0; };

/**
 * Handles the onkeydown event to switch table navigation mode
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_RatingIndicator["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "RatingIndicator.js(581): onkeydown"); };

	/** @type {number} */
	var iKey;

	if (this["bIsInteractiveRenderMode"] && !this["bReadonly"] && this["bEnabled"]) {
		iKey = oBrowserEvent["iKeyCode"]();

		// checks for [CTRL]/[ALT]/[SHIFT] are done in #handleItemHover
		// => no need to double-check them here

		if (iKey === UCF_KeyCodes["F2"] && this["bUsedInTable"]) {
			this["bTableNavigation"] = !this["bTableNavigation"]; // toggle table navigation
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		} else if (UCF_KeyboardHelper["bIsPlusKey"](iKey)) {
			this["bTableNavigation"] = false;
			this["handleItemHover"](oBrowserEvent, UCF_RatingIndicator["E_SELECTION"]["NEXT"]);
		} else if (UCF_KeyboardHelper["bIsMinusKey"](iKey)) {
			this["bTableNavigation"] = false;
			this["handleItemHover"](oBrowserEvent, UCF_RatingIndicator["E_SELECTION"]["PREVIOUS"]);
		} else if (iKey >= UCF_KeyCodes["_1"] && iKey <= UCF_KeyCodes["_9"]) { // no "0" rating possible
			this["handleItemHover"](oBrowserEvent, UCF_RatingIndicator["E_SELECTION"]["EXACT"], Math["max"](1, Math["min"](iKey - UCF_KeyCodes["_0"], this["iItemCount"])));
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onkeydown"] = 0; };

/**
 * Apply ACC helper object
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_RatingIndicator["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RatingIndicator.js(615): onlsaccessibility"); };

	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

	if (this["bIsInteractiveRenderMode"]) {
		if (!this["bReadonly"] && this["bEnabled"]) {
			oAccessibilityHelper["addTutor"]('RI_TUT');
		}
		oAccessibilityHelper["setControlType"]('RI', ['' + this["iItemCount"], '' + this["fValue"]]);
		if (this["iRatedIndex"] > 0 && !this["bReadonly"] && this["bEnabled"]) {
			oAccessibilityHelper["setExplanationText"](oAccessibilityHelper["sGetText"]('RI_SEL', [this["iHoveredIndex"]]));
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_RatingIndicator["prototype"]["aAttributeNames"] = ["iItemCount","fValue","sDisplayMode","bReadonly","sHoverItemIconSrc","sTooltip","sVisibility","sCustomData","sLabelledBy","sCustomStyle","bEnabled"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_RatingIndicator["prototype"]["aEventNames"] = ["Rate"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_RatingIndicator["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_RatingIndicator["prototype"]["iItemCount"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_RatingIndicator["prototype"]["fValue"] = 0;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ValueDisplayMode}
 */
UCF_RatingIndicator["prototype"]["sDisplayMode"] = "CONTINUOUS";

/**
 * @private
 * @type {boolean}
 */
UCF_RatingIndicator["prototype"]["bReadonly"] = false;

/**
 * @private
 * @type {string}
 */
UCF_RatingIndicator["prototype"]["sHoverItemIconSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RatingIndicator["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_RatingIndicator["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_RatingIndicator["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RatingIndicator["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RatingIndicator["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_RatingIndicator["prototype"]["bEnabled"] = true;

//#JSCOVER_EXCL_START
/** @protected */
UCF_RatingIndicator["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["setDefaultValues"]++; }; 
	this["iItemCount"] = 0;
	this["fValue"] = 0;
	this["sDisplayMode"] = "CONTINUOUS";
	this["bReadonly"] = false;
	this["sHoverItemIconSrc"] = '';
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';
	this["sCustomStyle"] = '';
	this["bEnabled"] = true;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("ItemCount", 0, true);
		this["setClientProperty"]("Value", 0, true);
		this["setClientProperty"]("DisplayMode", "CONTINUOUS", true);
		this["setClientProperty"]("Readonly", false, true);
		this["setClientProperty"]("HoverItemIconSrc", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("Enabled", true, true);
	}
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iItemNumber Number of the clicked item
 * @fires RatingIndicator::Rate
 */
UCF_RatingIndicator["prototype"]["fireRate"] = function(sId, iItemNumber) {;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["fireRate"]++; }; 
	/** @type {{Id: string, ItemNumber: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "RatingIndicator.js(762): fireRate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "RatingIndicator.js(763): fireRate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "RatingIndicator.js(764): fireRate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iItemNumber != null, "iItemNumber != null", "RatingIndicator.js(765): fireRate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iItemNumber) == "number", "typeof(iItemNumber) == \"number\"", "RatingIndicator.js(766): fireRate"); };
	mParams = {
		"Id": sId,
		"ItemNumber": iItemNumber
	};
	
	
	this["fireSemanticEvent"]("RatingIndicator", "Rate", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_RatingIndicator["_"]["fireRate"] = 0; };

};
sap["ls"]["preload"]["UCF_RectangleManager"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_EventProvider */
/// <reference path="../../../core/EventProvider.js"/>

/**
 * 
 * @class
 * @extends UCF_EventProvider
 */
function UCF_RectangleManager() {if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["UCF_RectangleManager"]++; }; 
	UCF_EventProvider["apply"](this);

	this["defineEvents"](['Matching']);

	this["aRectangles"] = [];
};window["UCF_RectangleManager"] = UCF_RectangleManager; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RectangleManager"); UCF_RectangleManager["_"] = {UCF_RectangleManager: 0}; }; ;
UCF_RectangleManager["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_RectangleManager.prototype["sClassName"] = "UCF_RectangleManager";

UCF_RectangleManager["debug"] = false;
UCF_RectangleManager["counter"] = 0;

UCF_RectangleManager["prototype"]["addRectangle"] = function(oRect, oCustomData) {;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["addRectangle"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, oRect["iLeft"] + ":" + oRect["iTop"] + ", " + (oRect["iLeft"] + oRect["iWidth"]) + ":" + (oRect["iTop"] + oRect["iHeight"]), "RectangleManager.js(24): addRectangle"); };
	if (UCF_RectangleManager["debug"]) {
		var oDebugItem = document["createElement"]("DIV");
		oDebugItem["setAttribute"]("id", "_debug_" + (UCF_RectangleManager["counter"]));
		oDebugItem["style"]["backgroundColor"] = "green";
		oDebugItem["style"]["opacity"] = "0.1";
		oDebugItem["style"]["width"] = oRect["iWidth"] + "px";
		oDebugItem["style"]["height"] = oRect["iHeight"] + "px";
		oDebugItem["style"]["top"] = oRect["iTop"] + "px";
		oDebugItem["style"]["left"] = oRect["iLeft"] + "px";
		oDebugItem["style"]["position"] = "absolute";
		document["body"]["appendChild"](oDebugItem);
	}
	if (!("iLeft" in oRect)) {
		oRect["iLeft"] = oRect["left"];
	}
	if (!("iWidth" in oRect)) {
		oRect["iWidth"] = oRect["width"];
	}
	if (!("iTop" in oRect)) {
		oRect["iTop"] = oRect["top"];
	}
	if (!("iHeight" in oRect)) {
		oRect["iHeight"] = oRect["height"];
	}
	oRect["iBottom"] = oRect["iTop"] + oRect["iHeight"];
	oRect["iRight"] = oRect["iLeft"] + oRect["iWidth"];
	this["aRectangles"]["push"]({ "oRectangle": oRect, "oCustomData": oCustomData, "iAdminId": UCF_RectangleManager["counter"]++ });
};;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["addRectangle"] = 0; };

UCF_RectangleManager["prototype"]["getClosestTop"] = function(iValue, oRect, iThreshold, sRulerType, oIgnoreElement, iDistance) {;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getClosestTop"]++; }; 
	var oTarget = null;
	iDistance = iDistance || 100000;
	iDistance = iDistance + (2 * oRect["width"]);
	for (var i = 0; i < this["aRectangles"]["length"]; i++) {
		var oMyRect = this["aRectangles"][i]["oRectangle"];
		if (this["aRectangles"][i]["oCustomData"] && this["aRectangles"][i]["oCustomData"]["ruler"]["sType"] == sRulerType && this["aRectangles"][i]["oCustomData"]["element"] != oIgnoreElement) {
			if (iValue >= oMyRect["iTop"] - iThreshold && iValue <= oMyRect["iTop"] + iThreshold) {
				var iMyDistance = Math["min"](
					iDistance,
					Math["abs"](oRect["left"] - oMyRect["iLeft"] + oMyRect["iWidth"]),
					Math["abs"](oRect["left"] + oRect["width"] - oMyRect["iLeft"] + oMyRect["iWidth"]),
					Math["abs"](oRect["left"] + oRect["width"] - oMyRect["iLeft"]),
					Math["abs"](oRect["left"] - oMyRect["iLeft"])
				);
				if (iMyDistance < iDistance) {
					iDistance = iMyDistance;
					oTarget = this["aRectangles"][i];
				}
			}
		}
	}
	return oTarget;
};;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getClosestTop"] = 0; };

UCF_RectangleManager["prototype"]["getClosestBottom"] = function(iValue, oRect, iThreshold, sRulerType, oIgnoreElement, iDistance) {;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getClosestBottom"]++; }; 
	var oTarget = null;
	iDistance = iDistance || 100000;
	iDistance = iDistance + (2 * oRect["width"]);

	for (var i = 0; i < this["aRectangles"]["length"]; i++) {
		var oMyRect = this["aRectangles"][i]["oRectangle"];
		if (this["aRectangles"][i]["oCustomData"] && this["aRectangles"][i]["oCustomData"]["ruler"]["sType"] == sRulerType && this["aRectangles"][i]["oCustomData"]["element"] != oIgnoreElement) {
			if (iValue >= oMyRect["iTop"] + oMyRect["iHeight"] - iThreshold && iValue <= oMyRect["iTop"] + oMyRect["iHeight"] + iThreshold) {
				var iMyDistance = Math["min"](
					iDistance,
					Math["abs"](oRect["left"] - oMyRect["iLeft"] + oMyRect["iWidth"]),
					Math["abs"](oRect["left"] + oRect["width"] - oMyRect["iLeft"] + oMyRect["iWidth"]),
					Math["abs"](oRect["left"] + oRect["width"] - oMyRect["iLeft"]),
					Math["abs"](oRect["left"] - oMyRect["iLeft"])
				);
				if (iMyDistance < iDistance) {
					iDistance = iMyDistance;
					oTarget = this["aRectangles"][i];
				}
			}
		}
	}
	return oTarget;
};;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getClosestBottom"] = 0; };

UCF_RectangleManager["prototype"]["getClosestLeft"] = function(iValue, oRect, iThreshold, sRulerType, oIgnoreElement, iDistance) {;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getClosestLeft"]++; }; 
	var oTarget = null;
	iDistance = iDistance || 100000;
	iDistance = iDistance + (2 * oRect["height"]);

	for (var i = 0; i < this["aRectangles"]["length"]; i++) {
		var oMyRect = this["aRectangles"][i]["oRectangle"];
		if (this["aRectangles"][i]["oCustomData"] && this["aRectangles"][i]["oCustomData"]["ruler"]["sType"] == sRulerType && this["aRectangles"][i]["oCustomData"]["element"] != oIgnoreElement) {
			if (iValue >= oMyRect["iLeft"] - iThreshold && iValue <= oMyRect["iLeft"] + iThreshold) {
				var iMyDistance = Math["min"](
					iDistance,
					Math["abs"](oRect["top"] - oMyRect["iTop"] + oMyRect["iHeight"]),
					Math["abs"](oRect["top"] + oRect["height"] - oMyRect["iTop"] + oMyRect["iHeight"]),
					Math["abs"](oRect["top"] + oRect["height"] - oMyRect["iTop"]),
					Math["abs"](oRect["top"] - oMyRect["iTop"])
				);
				if (iMyDistance < iDistance) {
					iDistance = iMyDistance;
					oTarget = this["aRectangles"][i];
				}
			}
		}
	}
	return oTarget;
};;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getClosestLeft"] = 0; };

UCF_RectangleManager["prototype"]["getClosestRight"] = function(iValue, oRect, iThreshold, sRulerType, oIgnoreElement, iDistance) {;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getClosestRight"]++; }; 
	var oTarget = null;
	iDistance = iDistance || 100000;
	iDistance = iDistance + (2 * oRect["height"]);

	for (var i = 0; i < this["aRectangles"]["length"]; i++) {
		var oMyRect = this["aRectangles"][i]["oRectangle"];
		if (this["aRectangles"][i]["oCustomData"] && this["aRectangles"][i]["oCustomData"]["ruler"]["sType"] == sRulerType && this["aRectangles"][i]["oCustomData"]["element"] != oIgnoreElement) {
			if (iValue >= oMyRect["iLeft"] + oMyRect["iWidth"] - iThreshold && iValue <= oMyRect["iLeft"] + oMyRect["iWidth"] + iThreshold) {
				var iMyDistance = Math["min"](
					iDistance,
					Math["abs"](oRect["top"] - oMyRect["iTop"] + oMyRect["iHeight"]),
					Math["abs"](oRect["top"] + oRect["height"] - oMyRect["iTop"] + oMyRect["iHeight"]),
					Math["abs"](oRect["top"] + oRect["height"] - oMyRect["iTop"]),
					Math["abs"](oRect["top"] - oMyRect["iTop"])
				);
				if (iMyDistance < iDistance) {
					iDistance = iMyDistance;
					oTarget = this["aRectangles"][i];
				}
			}
		}
	}
	return oTarget;
};;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getClosestRight"] = 0; };

UCF_RectangleManager["prototype"]["getClosestRects"] = function(iX, iY, iThreshold, oIgnoreCustomData) {;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getClosestRects"]++; }; 
	var mTargetLines = {};
	var iDistance;

	for (var i = 0; i < this["aRectangles"]["length"]; i++) {
		var oRect = this["aRectangles"][i];
		if (oIgnoreCustomData && oRect["oCustomData"] != oIgnoreCustomData) {
			if (iY >= this["aRectangles"][i]["oRectangle"]["iBottom"] - iThreshold && iY <= this["aRectangles"][i]["oRectangle"]["iBottom"] + iThreshold) {
				iDistance = 100000;
				if (mTargetLines["bottom"]) {
					iDistance = Math["abs"](iX - mTargetLines["bottom"]["left"]);
				}
				if (iDistance > Math["abs"](iX - oRect["oRectangle"]["iLeft"])) {
					mTargetLines["bottom"] = { "y": oRect["oRectangle"]["iBottom"], "left": oRect["oRectangle"]["iLeft"], "oCustomData": oRect["oCustomData"] };
				}
			}
			if (iX >= oRect["oRectangle"]["iLeft"] - iThreshold && iX <= oRect["oRectangle"]["iLeft"] + iThreshold) {
				iDistance = 100000;
				if (mTargetLines["left"]) {
					iDistance = Math["abs"](iY - mTargetLines["left"]["top"]);
				}
				if (iDistance > Math["abs"](iY - oRect["oRectangle"]["iTop"])) {
					mTargetLines["left"] = { "x": oRect["oRectangle"]["iLeft"], "top": oRect["oRectangle"]["iTop"], "oCustomData": oRect["oCustomData"] };
				}
			}
			if (iX >= oRect["oRectangle"]["iRight"] - iThreshold && iX <= oRect["oRectangle"]["iRight"] + iThreshold) {
				iDistance = 100000;
				if (mTargetLines["right"]) {
					iDistance = Math["abs"](iY - mTargetLines["right"]["top"]);
				}
				if (iDistance > Math["abs"](iY - oRect["oRectangle"]["iTop"])) {
					mTargetLines["right"] = { "x": oRect["oRectangle"]["iRight"], "top": oRect["oRectangle"]["iTop"], "oCustomData": oRect["oCustomData"] };
				}
			}
		}
	};
	if (!mTargetLines["top"] && !mTargetLines["right"] && !mTargetLines["bottom"] && !mTargetLines["left"]) {
		return null;
	}
	return mTargetLines;
};;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getClosestRects"] = 0; };

UCF_RectangleManager["prototype"]["removeRectangle"] = function(oRect) {;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["removeRectangle"]++; }; 
	for (var i = 0; i < this["aRectangles"]["length"]; i++) {
		if (this["aRectangles"][i]["oRectangle"] == oRect) {
			this["aRectangles"]["splice"](i, 1);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["removeRectangle"] = 0; };

UCF_RectangleManager["prototype"]["getRectangles"] = function(iX, iY) {;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getRectangles"]++; }; 
	var aTargetRectangles = [];
	var i;
	var oRect;

	for (i = 0; i < this["aRectangles"]["length"]; i++) {
		oRect = this["aRectangles"][i];
		if (iX >= oRect["oRectangle"]["iLeft"] &&
			iX <= oRect["oRectangle"]["iLeft"] + oRect["oRectangle"]["iWidth"] &&
			iY >= oRect["oRectangle"]["iTop"] &&
			iY <= oRect["oRectangle"]["iTop"] + oRect["oRectangle"]["iHeight"]) {
			aTargetRectangles["push"]({ "oRectangle": oRect["oRectangle"], "oCustomData": oRect["oCustomData"] });
		};
	};
	if (!aTargetRectangles["length"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Point: (" + iX + "," + iY + "): No match.", "RectangleManager.js(222): getRectangles"); };
	}
	for (i = 0; i < aTargetRectangles["length"]; i++) {
		oRect = aTargetRectangles[i]["oRectangle"];
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Point: (" + iX + "," + iY + ") matches [X=" + oRect["iLeft"] + "-" + (oRect["iLeft"] + oRect["iWidth"]) + ", Left=" + oRect["iTop"] + "-" + (oRect["iTop"] + oRect["iHeight"]) + "]", "RectangleManager.js(226): getRectangles"); };
	};
	if (aTargetRectangles["length"] > 0) {
		this["fireEvent"](this["E_EVENTS"]["Matching"], { "aRects": aTargetRectangles });
	}
	return aTargetRectangles;
};;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["getRectangles"] = 0; };

UCF_RectangleManager["prototype"]["redraw"] = function() {;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["redraw"]++; }; 

	if (!UCF_RectangleManager["debug"]) { return; }
	for (var i = 0; i < this["aRectangles"]["length"]; i++) {
		document["getElementById"]("_debug_" + this["aRectangles"][i]["iAdminId"])["style"]["width"] = this["aRectangles"][i]["oRectangle"]["iWidth"] + "px";
		document["getElementById"]("_debug_" + this["aRectangles"][i]["iAdminId"])["style"]["height"] = this["aRectangles"][i]["oRectangle"]["iHeight"] + "px";
		document["getElementById"]("_debug_" + this["aRectangles"][i]["iAdminId"])["style"]["top"] = this["aRectangles"][i]["oRectangle"]["iTop"] + "px";
		document["getElementById"]("_debug_" + this["aRectangles"][i]["iAdminId"])["style"]["left"] = this["aRectangles"][i]["oRectangle"]["iLeft"] + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["redraw"] = 0; };

UCF_RectangleManager["prototype"]["removeAll"] = function() {;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["removeAll"]++; }; 
	if (UCF_RectangleManager["debug"]) {
		for (var i = 0; i < this["aRectangles"]["length"]; i++) {
			document["body"]["removeChild"](document["getElementById"]("_debug_" + this["aRectangles"][i]["iAdminId"]));
		}
	}
	this["aRectangles"] = [];
};;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["removeAll"] = 0; };

UCF_RectangleManager["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["destroy"]++; }; 
	this["removeAll"]();

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RectangleManager["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_ReferenceGhost"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Ghost */
/// <reference path="./Ghost.js"/>

/**
 * a simple ghost which does not create a copy / clone
 *
 * @class
 * 
 *
 * @param {UCF_LS} oLS
 * @param {HTMLElement} oGhostRef the ghost ref
 */
function UCF_ReferenceGhost(oLS, oGhostRef) {if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["UCF_ReferenceGhost"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oGhostRef) == "object", "typeof (oGhostRef) == \"object\"", "ReferenceGhost.js(22): UCF_ReferenceGhost"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oGhostRef != null, "oGhostRef != null", "ReferenceGhost.js(23): UCF_ReferenceGhost"); };

	this["oLS"] = oLS;

	UCF_Ghost["apply"](this, [oGhostRef]);

};window["UCF_ReferenceGhost"] = UCF_ReferenceGhost; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ReferenceGhost"); UCF_ReferenceGhost["_"] = {UCF_ReferenceGhost: 0}; }; ;

UCF_ReferenceGhost["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Ghost"))(); UCF_ReferenceGhost.prototype["sClassName"] = "UCF_ReferenceGhost";

UCF_ReferenceGhost["prototype"]["create"] = function (oRootContainerDomRef) {;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["create"]++; }; 
	var x;
	var len;

	this["oDomRef"] = document["createElement"]("DIV");
	this["oDomRef"]["style"]["position"] = "absolute";
	this["oDomRef"]["style"]["overflow"] = "hidden";
	this["oDomRef"]["style"]["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"];
	var table = document["createElement"]("table"),
		tBody = document["createElement"]("tBody");
	this["oDomRef"]["appendChild"](table);
	table["appendChild"](tBody);

	var oRect = UCF_DomUtil["oGetObjectRect"](this["oGhostRef"]);

	this["oDomRef"]["style"]["width"] = oRect["width"] + "px";
	this["oDomRef"]["style"]["height"] = oRect["height"] + "px";
	//remove the reference from the dom temporarily
	//needed for firefox to prevent display errors

	var oParentRef = this["oGhostRef"]["parentNode"],
		oChildNodes = oParentRef["childNodes"];

	this["iIndex"] = -1;
	this["oParentRef"] = oParentRef;
	for (x = 0, len = oChildNodes["length"]; x < len; x++) {
		if (oChildNodes[x] == this["oGhostRef"]) {
			this["iIndex"] = x;
			break;
		}
	}

	UCF_DomUtil["removeFromDom"](this["oGhostRef"]);
	tBody["appendChild"](this["oGhostRef"]);
	oRootContainerDomRef["appendChild"](this["oDomRef"]);

	table["style"]["width"] = oRect["width"] + "px";
	table["style"]["height"] = oRect["height"] + "px";

	this["iOriginalWidth"] = this["oDomRef"]["offsetWidth"];
	this["iOriginalHeight"] = this["oDomRef"]["offsetHeight"];
	var oStyle = this["oDomRef"]["style"];
	oStyle["position"] = "absolute";

	oStyle["top"] = "-1000px";
	oStyle["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"];

	if (this["bApplyAlphaFilter"]) {
		var aCellRefs = this["oDomRef"]["cells"];
		for (x = 0; x < aCellRefs["length"]; x++) {
			UCF_DomUtil["setOpacityStyle"](aCellRefs[x], 60);
		}
	}

	//search the ghost for placeholder controls
	var aPotentialPlaceHolders = this["oLS"]["oControlFactory"]["oGetCurrentControlsByClassName"]("UCF_PlaceHolder", true);
	this["aPlaceHolders"] = [];

	for (x = 0; x < aPotentialPlaceHolders["length"]; x++) {

		var aPlaceHolderDomRef = aPotentialPlaceHolders[x]["oContentRef"];

		if (!aPlaceHolderDomRef)
			continue;

		if (!UCF_DomUtil["bContains"](this["oDomRef"], aPotentialPlaceHolders[x]["oRootRef"]))
			continue;

		var oPlaceHolderRect = UCF_DomUtil["oGetObjectRect"](aPlaceHolderDomRef);

		this["aPlaceHolders"][this["aPlaceHolders"]["length"]] = {
			"oDomRef": aPlaceHolderDomRef,
			"oOffset": {
				"iLeft": oPlaceHolderRect["left"] - oRect["left"],
				"iTop": oPlaceHolderRect["top"] - oRect["top"]
			},
			"iZIndex": aPlaceHolderDomRef["style"]["zIndex"],
			"sId": aPotentialPlaceHolders[x]["sId"]
		};
		aPlaceHolderDomRef["style"]["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"] + 20;
	}

	UCF_Ghost.prototype["create"]["call"](this, oRootContainerDomRef);

	//create the ghost extension for dropEffect visualization
	var oExtensionDomRef = document["createElement"]("SPAN"),
		oExtensionIconDomRef = document["createElement"]("SPAN"),
		oExtensionTextDomRef = document["createElement"]("SPAN"),
		oExtensionStyle = oExtensionDomRef["style"];

	UCF_DomUtil["setClass"](oExtensionDomRef, "lsDDGhostExtension urTxtColor");
	UCF_DomUtil["setClass"](oExtensionIconDomRef, "lsDDGhostExtensionIcon");
	if (window["UCF_System"]["bIsRTL"]) {
		UCF_DomUtil["addClass"](oExtensionIconDomRef, "lsDDGhostExtensionIconRTL");
		UCF_DomUtil["addClass"](oExtensionIconDomRef, "lsMirrorRtl");
	}

	oExtensionStyle["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"] + 10;
	if (!(this["bOverflow"] === true)) {
		oExtensionStyle["overflow"] = "hidden";
	} else {
		oExtensionStyle["overflow"] = "visible";
	}
	oExtensionStyle["top"] = "-10000px";
	oExtensionStyle["visibility"] = "hidden";
	oExtensionStyle["display"] = "none";

	oExtensionDomRef["appendChild"](oExtensionIconDomRef);
	oExtensionDomRef["appendChild"](oExtensionTextDomRef);
	oRootContainerDomRef["appendChild"](oExtensionDomRef);
	this["oExtensionDomRef"] = oExtensionDomRef;
};;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["create"] = 0; };

UCF_ReferenceGhost["prototype"]["update"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["update"]++; }; 

	UCF_Ghost.prototype["update"]["call"](this, oBrowserEvent);

	//update the position of all placeholders
	for (var x = 0; x < this["aPlaceHolders"]["length"]; x++) {
		var sId = this["aPlaceHolders"][x]["sId"],
			oPlaceHolder = this["oLS"]["oControlFactory"]["oGetControlById"](sId);

		if (oPlaceHolder) {
			oPlaceHolder["update"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["update"] = 0; };
/**
 *
 *
 */
UCF_ReferenceGhost["prototype"]["show"] = function () {;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["show"]++; }; 

	if (this["aPlaceHolders"]) {
		for (var x = 0; x < this["aPlaceHolders"]["length"]; x++) {
			this["aPlaceHolders"][x]["oDomRef"]["style"]["display"] = "";
		}
	}

	UCF_Ghost.prototype["show"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["show"] = 0; };

/**
 *
 */
UCF_ReferenceGhost["prototype"]["hide"] = function () {;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["hide"]++; }; 

	if (this["aPlaceHolders"]) {
		for (var x = 0; x < this["aPlaceHolders"]["length"]; x++) {
			this["aPlaceHolders"][x]["oDomRef"]["style"]["display"] = "none";
		}
	}
	UCF_Ghost.prototype["hide"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["hide"] = 0; };
UCF_ReferenceGhost["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["destroy"]++; }; 

	UCF_DomUtil["removeFromDom"](this["oShimRef"]);
	UCF_DomUtil["removeFromDom"](this["oIFrameRef"]);

	this["oShimRef"] = null;
	this["oIFrameRef"] = null;

	this["doDestroy"]();

	UCF_Ghost.prototype["destroy"]["apply"](this, arguments);

	this["oLS"] = null;
	this["oExtensionDomRef"] = null;
	this["iIndex"] = 0;
	this["iOriginalWidth"] = 0;
	this["iOriginalHeight"] = 0;
};;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["destroy"] = 0; };

UCF_ReferenceGhost["prototype"]["doDestroy"] = function () {;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["doDestroy"]++; }; 
	var x;

	if (!this["oGhostRef"] || !this["oDomRef"]) return;

	UCF_DomUtil["removeFromDom"](this["oGhostRef"]);
	UCF_DomUtil["removeFromDom"](this["oDomRef"]);

	if (this["iIndex"] < this["oParentRef"]["childNodes"]["length"]) {
		this["oParentRef"]["insertBefore"](this["oGhostRef"], this["oParentRef"]["childNodes"][this["iIndex"]]);
	} else {
		this["oParentRef"]["appendChild"](this["oGhostRef"]);
	}

	if (this["bApplyAlphaFilter"]) {
		var aCellRefs = this["oDomRef"]["cells"];
		for (x = 0; x < aCellRefs["length"]; x++) {
			UCF_DomUtil["setOpacityStyle"](aCellRefs[x], 100);
		}
	}

	//update the position of all placeholders
	for (x = 0; x < this["aPlaceHolders"]["length"]; x++) {
		var oStyle = this["aPlaceHolders"][x]["oDomRef"]["style"],
			oOffset = this["aPlaceHolders"][x]["oOffset"];

		oStyle["left"] = this["oDomRef"]["offsetLeft"] + oOffset["iLeft"] + "px";
		oStyle["top"] = this["oDomRef"]["offsetTop"] + oOffset["iTop"] + "px";
		oStyle["zIndex"] = this["aPlaceHolders"][x]["iZIndex"];
	}

	this["oGhostRef"] = null;
	this["oParentRef"] = null;
	this["aPlaceHolders"] = null;
};;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["doDestroy"] = 0; };

UCF_ReferenceGhost["prototype"]["removeFromDom"] = function () {;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["removeFromDom"]++; }; 
	UCF_DomUtil["removeFromDom"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_ReferenceGhost["_"]["removeFromDom"] = 0; };

};
sap["ls"]["preload"]["UCF_RegistrationMap"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>

/**
 * Helper for registration of Name/Object pairs in a map
 *
 * 
 * @version
 * @class
 */
function UCF_RegistrationMap() {if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["UCF_RegistrationMap"]++; }; 
	this["mRegistrationMap"] = {};
};window["UCF_RegistrationMap"] = UCF_RegistrationMap; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RegistrationMap"); UCF_RegistrationMap["_"] = {UCF_RegistrationMap: 0}; }; ;
UCF_RegistrationMap["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_RegistrationMap.prototype["sClassName"] = "UCF_RegistrationMap";

UCF_RegistrationMap["prototype"]["cleanUpRegistration"] = function() {;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["cleanUpRegistration"]++; }; 
	this["mRegistrationMap"] = null;
};;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["cleanUpRegistration"] = 0; };

UCF_RegistrationMap["prototype"]["unregisterAll"] = function() {;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["unregisterAll"]++; }; 
	this["mRegistrationMap"] = {};
};;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["unregisterAll"] = 0; };

UCF_RegistrationMap["prototype"]["register"] = function(sRegName, oRegObject) {;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["register"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRegName != null, "sRegName != null", "RegistrationMap.js(27): register"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRegName) === "string", "typeof(sRegName) === \"string\"", "RegistrationMap.js(28): register"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oRegObject != null, "oRegObject != null", "RegistrationMap.js(29): register"); };

	if (this["bIsRegistered"](sRegName, oRegObject)) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "[" + sRegName + ", " + (oRegObject["toString"] ? oRegObject["toString"]() : "object") + "] is already registered.", "RegistrationMap.js(32): register"); };
		return;
	}

	if (!this["mRegistrationMap"][sRegName]) {
		this["mRegistrationMap"][sRegName] = [oRegObject];
	} else {
		this["mRegistrationMap"][sRegName]["push"](oRegObject);
	}
};;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["register"] = 0; };

UCF_RegistrationMap["prototype"]["unregister"] = function(sRegName, oRegObject) {;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["unregister"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRegName != null, "sRegName != null", "RegistrationMap.js(44): unregister"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRegName) === "string", "typeof(sRegName) === \"string\"", "RegistrationMap.js(45): unregister"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oRegObject != null, "oRegObject != null", "RegistrationMap.js(46): unregister"); };

	if (!this["bIsRegistered"](sRegName, oRegObject)) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "[" + sRegName + ", " + (oRegObject["toString"] ? oRegObject["toString"]() : "object") + "] is not registered.", "RegistrationMap.js(49): unregister"); };
		return;
	}

	if (this["mRegistrationMap"][sRegName]) {
		var aObjects = this["mRegistrationMap"][sRegName];

		if (aObjects["length"] === 1 && aObjects[0] == oRegObject) {
			delete this["mRegistrationMap"][sRegName];
		} else {
			var aNewObjects = [];

			for (var i = 0; i < aObjects["length"]; i++) {
				if (aObjects[i] != oRegObject) aNewObjects["push"](aObjects[i]);
			}

			this["mRegistrationMap"][sRegName] = aNewObjects;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["unregister"] = 0; };

UCF_RegistrationMap["prototype"]["bIsRegistered"] = function(sRegName, oRegObject) {;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["bIsRegistered"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRegName != null, "sRegName != null", "RegistrationMap.js(71): bIsRegistered"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRegName) === "string", "typeof(sRegName) === \"string\"", "RegistrationMap.js(72): bIsRegistered"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oRegObject != null, "oRegObject != null", "RegistrationMap.js(73): bIsRegistered"); };

	if (this["mRegistrationMap"][sRegName]) {
		var aObjects = this["mRegistrationMap"][sRegName];

		for (var i = 0; i < aObjects["length"]; i++) {
			if (aObjects[i] == oRegObject) return true;
		}
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["bIsRegistered"] = 0; };

UCF_RegistrationMap["prototype"]["aGetRegistrationEntries"] = function(sRegName) {;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["aGetRegistrationEntries"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRegName != null, "sRegName != null", "RegistrationMap.js(87): aGetRegistrationEntries"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRegName) === "string", "typeof(sRegName) === \"string\"", "RegistrationMap.js(88): aGetRegistrationEntries"); };

	return this["mRegistrationMap"][sRegName];
};;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["aGetRegistrationEntries"] = 0; };

UCF_RegistrationMap["prototype"]["toString"] = function() {;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["toString"]++; }; 
	if (this["mRegistrationMap"]) {
		var sResult = "",
			aObjects = null;

		for (var sRegName in this["mRegistrationMap"]) {
			aObjects = this["mRegistrationMap"][sRegName];
			sResult += sRegName + " = [" + aObjects["toString"]() + "];";
		}

		if (sResult != "") return sResult;
	}

	return "Empty";
};;if (__UCF_COVERAGE__) { UCF_RegistrationMap["_"]["toString"] = 0; };

};
sap["ls"]["preload"]["UCF_ResizeEventHelper"] = function() {/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>

/**
 * @typedef {Object} ResizeObserver
 * @property {function(HTMLElement|SVGElement): void} observe
 * @property {function(HTMLElement|SVGElement): void} unobserve
 */
/**
 * @typedef {Object} ResizeObserverEntry
 * @property {HTMLElement|SVGElement} target
 * @property {ResizeObserverSize[]} borderBoxSize
 * @property {ResizeObserverSize[]} contentBoxSize
 * @property {ResizeObserverSize[]} devicePixelContentBoxSize
 * @property {DOMRect} contentRect
 */
/**
 * @typedef {Object} ResizeObserverSize
 * @property {number} blockSize
 * @property {number} inlineSize
 */
/** @typedef {{oDomRef: HTMLElement, iWidth: number, iHeight: number}} ResizeElement */

/**
 * @param {function(Event): void} fHandler the event handler function
 */
function UCF_ResizeEventHelper(fHandler) {if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["UCF_ResizeEventHelper"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof fHandler === 'function', "typeof fHandler === 'function'", "ResizeEventHelper.js(38): UCF_ResizeEventHelper"); };

	/** @type {function(Event): void} */
	this["fHandler"] = fHandler;
	/** @type {Array.<ResizeElement>} */
	this["aResizeElementsIntervalCheck"] = [];
	/** @type {string} */
	this["sInterval"] = null;
	/** @type {boolean} */
	this["bActive"] = true;
	/** @type {boolean} */
	this["bSkipped"] = false;
	/** @type {Object<string,{width:number,height:number}>} */
	this["oLastKnownSizes"] = {};
	/** @type {UCF_Cache} */
	this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

};window["UCF_ResizeEventHelper"] = UCF_ResizeEventHelper; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ResizeEventHelper"); UCF_ResizeEventHelper["_"] = {UCF_ResizeEventHelper: 0}; }; ;
UCF_ResizeEventHelper["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_ResizeEventHelper.prototype["sClassName"] = "UCF_ResizeEventHelper";

/** @override */
UCF_ResizeEventHelper["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["destroy"]++; }; 
	this["fHandler"] = null;
	this["sInterval"] = null;
	this["oLastKnownSizes"] = null;
	if (this["oCache"]) {
		this["oCache"]["destroy"]();
		this["oCache"] = null;
	}

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["destroy"] = 0; };

/** @param {HTMLElement} oDomRef the DOM reference */
UCF_ResizeEventHelper["prototype"]["attachEvent"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["attachEvent"]++; }; 
	if (oDomRef) {
		if (UCF_UserAgent["bIsIE"]()) {
			this["attachEventIntervalCheck"](oDomRef);
		} else {
			if (!oDomRef["offsetParent"]) {
				this["oLastKnownSizes"][UCF_DomUtil["sSerializeDomRef"](oDomRef)] = {
					"width": -1,
					"height": -1
				};
			}
			this["oGetResizeObserver"]()["observe"](oDomRef);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["attachEvent"] = 0; };

/**
 * Allows a control that has attached a DomRef to reset the current
 * width/height values (and 'skip' one check-interval) so it will not receive a
 * resize event that is cause by its own changes to its own DOM.
 * @param {HTMLElement} oDomRef the DOM reference
 * @param {UCF_Control} oControl the control instance doing the call
 */
UCF_ResizeEventHelper["prototype"]["reset"] = function(oDomRef, oControl) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["reset"]++; }; 
	if (this["detachEvent"](oDomRef)) {
		UCF_JsUtil["delayedCall"](
			this["I_INTERVAL"],
			this,
			'reAttach',
			[oDomRef, oControl]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["reset"] = 0; };

/**
 * @private
 * @param {HTMLElement} oDomRef the DOM reference
 * @param {UCF_Control} oControl the control instance doing the call
 */
UCF_ResizeEventHelper["prototype"]["reAttach"] = function(oDomRef, oControl) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["reAttach"]++; }; 
	if (!oControl["bIsDestroyed"]) {
		this["attachEvent"](oDomRef);
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["reAttach"] = 0; };

/**
 * Detach resize event
 *
 * @param {HTMLElement} oDomRef the DOM reference
 * @return {boolean|undefined} Whether the DOM reference was found and removed
 * from the internal registry (if resize event 'emulation' is used).
 */
UCF_ResizeEventHelper["prototype"]["detachEvent"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["detachEvent"]++; }; 
	if (oDomRef) {
		if (UCF_UserAgent["bIsIE"]()) {
			return this["detachEventIntervalCheck"](oDomRef);
		} else if (this["oCache"]["has"]('oResizeObserver')) {
			this["oGetResizeObserver"]()["unobserve"](oDomRef);
			delete this["oLastKnownSizes"][UCF_DomUtil["sSerializeDomRef"](oDomRef)];
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["detachEvent"] = 0; };

/**
 * @private
 * @param {ResizeElement} oResizeElement the stored information for the dom ref
 * @param {HTMLElement} oDomRef the current dom ref
 * @return {boolean} `true` if the dimensions of oDomRef did change, otherwise
 * `false`
 */
UCF_ResizeEventHelper["prototype"]["bIsResized"] = function(oResizeElement, oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["bIsResized"]++; }; 
	return oResizeElement["iWidth"] !== oDomRef["offsetWidth"]
		|| oResizeElement["iHeight"] !== oDomRef["offsetHeight"];
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["bIsResized"] = 0; };

/**
 * Create pseudo DOM event
 *
 * @param {element} oDomRef the dom reference
 * @return {Event} a pseudo DomEvent
 */
UCF_ResizeEventHelper["prototype"]["oCreatePseudoEvent"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["oCreatePseudoEvent"]++; }; 
	return {
		"type": 'resize',
		"target": oDomRef,
		"currentTarget": oDomRef,
		"bubbles": true,
		"cancelable": true,
		"isTrusted": true
	};
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["oCreatePseudoEvent"] = 0; };

// #region interval checking method ===========================================

/**
 * The interval which is used for checking the width/height of all attached
 * elements
 * @type {number}
 */
UCF_ResizeEventHelper["prototype"]["I_INTERVAL"] = 200;

/**
 * adds oDomRef to the list of DOM elements that get their resize events via
 * event emulation (i.e. interval checks)
 * @private
 * @param {HTMLElement} oDomRef the DOM reference
 */
UCF_ResizeEventHelper["prototype"]["attachEventIntervalCheck"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["attachEventIntervalCheck"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef, "oDomRef", "ResizeEventHelper.js(182): attachEventIntervalCheck"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'attaching resize for oDomRef.id = ' + oDomRef["id"], "ResizeEventHelper.js(183): attachEventIntervalCheck"); };

	// Add element to the list
	this["aResizeElementsIntervalCheck"]["push"]({
		"oDomRef": oDomRef,
		"iWidth": oDomRef["offsetWidth"],
		"iHeight": oDomRef["offsetHeight"]
	});

	// If interval is not already running, start it
	if (!this["sInterval"]) {
		this["sInterval"] = UCF_JsUtil["intervalCall"](
			this["I_INTERVAL"],
			this,
			'checkSizes'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["attachEventIntervalCheck"] = 0; };

/**
 * @param {HTMLElement} oDomRef the DOM reference
 * @return {boolean} `true` if the DOM reference has been removed successfully,
 * otherwise `false`
 */
UCF_ResizeEventHelper["prototype"]["detachEventIntervalCheck"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["detachEventIntervalCheck"]++; }; 
	/** @type {boolean} */
	var bRemoved = false;
	/** @type {ResizeElement} */
	var oResizeElement;
	/** @type {number} */
	var i = 0;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef, "oDomRef", "ResizeEventHelper.js(215): detachEventIntervalCheck"); };

	// find entry in the array
	for (; i < this["aResizeElementsIntervalCheck"]["length"]; i++) {
		oResizeElement = this["aResizeElementsIntervalCheck"][i];

		if (oResizeElement["oDomRef"] === oDomRef) {
			this["aResizeElementsIntervalCheck"]["splice"](i, 1);
			bRemoved = true;
			break;
		}
	}

	// if list is empty now, stop interval
	if (this["aResizeElementsIntervalCheck"]["length"] === 0) {
		UCF_JsUtil["clearIntervalCall"](this["sInterval"]);
		this["sInterval"] = null;
	}

	return bRemoved;
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["detachEventIntervalCheck"] = 0; };

/**
 * Check sizes of resize elements
 */
UCF_ResizeEventHelper["prototype"]["checkSizes"] = function() {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["checkSizes"]++; }; 
	/** @type {ResizeElement} */
	var oResizeElement;
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {number} */
	var i = 0;

	for (; i < this["aResizeElementsIntervalCheck"]["length"]; i++) {
		oResizeElement = this["aResizeElementsIntervalCheck"][i];
		oDomRef = oResizeElement["oDomRef"];

		if (this["bIsResized"](oResizeElement, oDomRef)) {
			oResizeElement["iWidth"] = oDomRef["offsetWidth"];
			oResizeElement["iHeight"] = oDomRef["offsetHeight"];

			if (this["bActive"]) {
				this["fHandler"](this["oCreatePseudoEvent"](oDomRef));
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["checkSizes"] = 0; };

/**
 * Skip resize event emulation
 * @private
 */
UCF_ResizeEventHelper["prototype"]["skipResizeEventEmulation"] = function() {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["skipResizeEventEmulation"]++; }; 
	if (this["sInterval"]) {
		UCF_JsUtil["clearIntervalCall"](this["sInterval"]);
		this["sInterval"] = null;
		this["bSkipped"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["skipResizeEventEmulation"] = 0; };

/**
 * Continue resize event emulation
 * @private
 */
UCF_ResizeEventHelper["prototype"]["continueResizeEventEmulation"] = function() {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["continueResizeEventEmulation"]++; }; 
	if (!this["sInterval"] && this["bSkipped"]) {
		this["sInterval"] = UCF_JsUtil["intervalCall"](
			this["I_INTERVAL"],
			this,
			'checkSizes'
		);
		this["bSkipped"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["continueResizeEventEmulation"] = 0; };
// #endregion
// #region resize observer ====================================================

/** @return {ResizeObserver} */
UCF_ResizeEventHelper["prototype"]["oGetResizeObserver"] = function() {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["oGetResizeObserver"]++; }; 
	/** @type {UCF_ResizeEventHelper} */
	var self = this;

	return this["oCache"]["get"]('oResizeObserver', function() {
		return new window["ResizeObserver"](function( /** @type {ResizeObserverEntry[]} */ aEntries) {
			UCF_JsUtil["forEach"](aEntries, function(oEntry) {
				/** @type {string} */
				var sTargetId = UCF_DomUtil["sSerializeDomRef"](oEntry["target"]);
				/** @type {DOMRect} */
				var oContentRect = oEntry["contentRect"];

				if (sTargetId in self["oLastKnownSizes"]) {
					if (
						self["oLastKnownSizes"][sTargetId]["width"] !== oContentRect["width"] ||
						self["oLastKnownSizes"][sTargetId]["height"] !== oContentRect["height"]
					) {
						self["oLastKnownSizes"][sTargetId] = {
							"width": oContentRect["width"],
							"height": oContentRect["height"]
						};
						self["fHandler"](self["oCreatePseudoEvent"](oEntry["target"]));
					}
				} else {
					self["oLastKnownSizes"][sTargetId] = {
						"width": oContentRect["width"],
						"height": oContentRect["height"]
					};
				}
			});
		});
	});
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["oGetResizeObserver"] = 0; };

// #endregion

};
sap["ls"]["preload"]["UCF_RichTextEdit"] = function() {/* global _assert, _trace, _measure, DEBUG, INFO, WARNING, ERROR, START, STOP */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_RichTextEdit(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["UCF_RichTextEdit"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "RichTextEdit.js(36): forwardEditorEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef, "oDomRef", "RichTextEdit.js(37): forwardEditorEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oLS, 'UCF_LS'), "UCF_JsUtil.bInstanceOf(oLS, 'UCF_LS')", "RichTextEdit.js(38): forwardEditorEvent"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oFrameRef"] = UCF_DomUtil["$"](this["sId"] + '-frm');

	if (this["sHtmlText"] === '') {
		if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
			this["sHtmlText"] = '<p></p>';
		} else {
			this["sHtmlText"] = '<p> </p>';
		}
		this["setClientProperty"]("HtmlText", this["sHtmlText"], true);
	}

	/**
	 * whether the editor frame content document has been loaded and initalized
	 * @type {boolean}
	 */
	this["bInitialized"] = false;

	/**
	 * whether blur should be ignored, because it has been caused by clicking on a toolbar button
	 * @type {boolean}
	 */
	this["bIgnoreBlur"] = false;

	/** @type {boolean} */
	this["bDragging"] = false;

	/**
	 * The format state on the current cursor position/selection
	 */
	this["mState"] = {};

	/**
	 * Toolbar buttons, one for each format
	 * @see #oFormats
	 */
	this["mButtons"] = null;

	/**
	 * Clientside Rendering representations of #mButtons
	 * @see #mButtons
	 */
	this["mClientButtons"] = null;

	/**
	 * Toolbar (right) buttons, one for each action
	 * @see #oEditorActions
	 */
	this["mActionButtons"] = null;

	/**
	 * Clientside Rendering representations of #mActionButtons
	 */
	this["mActionClientButtons"] = null;

	this["forbiddenCtrlKeys"] = null;
	this["hotkeysUsedByRTE"] = null;

	/**
	 * The last change of the HTML
	 * @type {string}
	 */
	this["sLastHtml"] = this["sHtmlText"]; // eslint-disable-line @ur/no-memory-leaks

	/**
	 * the current HTML text
	 * @type {string}
	 */
	this["sCurrentHtml"] = this["sHtmlText"]; // eslint-disable-line @ur/no-memory-leaks

	/**
	 * The default button handling should be ignored
	 * @type {boolean}
	 */
	this["bIgnoreDefaultButton"] = true;

	/** @type {int} */
	this["iSerializeCounter"] = 0;

	// if surrounding context is readonly the richtextedit is also readonly
	if (this["sAssociatedEditContext"] === 'PARENTREADONLY') {
		this["bReadonly"] = true;
		this["setClientProperty"]("Readonly", this["bReadonly"], true);
	}

	/**
	 * The focus dom refs for forward and back navigation
	 */
	this["oFocusDomRef"] = this["oDomRef"];
	this["oLastFocusDomRef"] = this["oFrameRef"];

	/**
	 * Store whether the focus was requested before the control was initialized In this case wait for the iframe to load and then set the focus again CSN: 1428860 2012
	 */
	this["bRequestInitialFocus"] = false;

	this["sScrollTimerId"] = null; // eslint-disable-line @ur/no-memory-leaks

	// the dirty state changes after controls was edited
	this["bIsDirty"] = false;

	// send the last change even if there was a time trigger
	this["attachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"], 'onPendingRequest');

	this["forwardEditorEvent"] = function() { // eslint-disable-line @ur/no-memory-leaks
		// empty function for IE8 also for read only mode to avoid asserts.
	};
};window["UCF_RichTextEdit"] = UCF_RichTextEdit; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RichTextEdit"); UCF_RichTextEdit["_"] = {UCF_RichTextEdit: 0}; }; ;

UCF_RichTextEdit["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_RichTextEdit.prototype["sClassName"] = "UCF_RichTextEdit";

/**
 * @private
 * @static
 * @param {string} sStylesheet
 * @return {string}
 */
UCF_RichTextEdit["fBoilerplate"] = function(sStylesheet) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["fBoilerplate"]++; }; 
	var sHTML = '';
	if (!__UCF_IE6__) {
		sHTML = '<!doctype html>';
	}
	sHTML = '<html><head><link rel="stylesheet" type="text/css" href="' + sStylesheet +
		'"/></head><body supportedthemes="sap_corbu" class="lsRichTextEdit--fail-body">'
		+ (UCF_UserAgent["bIsIOS"]() && UCF_UserAgent["bIsSafari"]()
			// This decoupling is needed so that iOS-Safari renders the given height of the IFrame instead of using the height of the content
			? '<div class="lsRichTextEdit--fail-ios-container"><div class="lsRichTextEdit--fail-ios-content" id="editable"></div></div>'
			: '')
		+ '</body></html>';

	return sHTML;

};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["fBoilerplate"] = 0; };

/**
 * List of actions that can be performed to alter the RichTextEdit
 * (not the content -- this is done with {{#oFormats}}).
 * @type {{<string>: {
 * 		sIdPart: string,
 * 		sCommand: string,
 * 		sCssClass: string,
 * 		sTooltipKey: string,
 * 		fEnabledWhen: () => boolean
 * }}}
 */
UCF_RichTextEdit["prototype"]["oEditorActions"] = {
	"paragraphSpacing": {
		"sIdPart": 'paragraphSpacing',
		"sCommand": 'toggleParagraphSpacing',
		"sCssClass": 'lsRichtextedit__button--paragraphSpacing',
		"fEnabledWhen": function(self) { return self["sParagraphSpacing"] === 'LINE'; },
		"sTooltipKey": 'RTE_PARAGRAPH_SPACING'
	}
};

/**
 * List of formats that can be used in the RichTextEdit.
 * @type {{<string>: {
 * 		sIdPart: string,
 * 		sCommand: string,
 * 		sCtrlKey?: string,
 * 		sCssClass: string,
 * 		bProp: boolean,
 * 		sTooltipKey: string,
 * 		mUnsupported?: {<string>: boolean},
 * 		sEnableValue?: string,
 * 		sDisableValue?: string,
 * 		sCheckValue?: string
 * }}}
 */
UCF_RichTextEdit["prototype"]["oFormats"] = {
	"bold": {
		"sIdPart": 'bld',
		"sCommand": 'bold',
		"sCtrlKey": 'b',
		"sCssClass": 'urRTEIcoBold',
		"bProp": 'bHasBold',
		"sTooltipKey": 'RTE_BOLD'
	},
	"italic": {
		"sIdPart": 'itl',
		"sCommand": 'italic',
		"sCtrlKey": 'i',
		"sCssClass": 'urRTEIcoItalics',
		"bProp": 'bHasItalics',
		"sTooltipKey": 'RTE_ITALIC'
	},
	"underline": {
		"sIdPart": 'und',
		"sCommand": 'underline',
		"sCtrlKey": 'u',
		"sCssClass": 'urRTEIcoUnderline',
		"bProp": 'bHasUnderline',
		"sTooltipKey": 'RTE_UNDERLINE'
	},
	"indent": {
		"sIdPart": 'idnt',
		"sCommand": 'indent',
		"mUnsupported": {
			"ff1": true
		},
		"sCssClass": 'urRTEIcoIndent',
		"bProp": 'bHasIndent',
		"sTooltipKey": 'RTE_INDENT'
	},
	"outdent": {
		"sIdPart": 'odnt',
		"sCommand": 'outdent',
		"mUnsupported": {
			"ff1": true
		},
		"sCssClass": 'urRTEIcoOutdent',
		"bProp": 'bHasOutdent',
		"sTooltipKey": 'RTE_OUTDENT'
	},
	"ordered": {
		"sIdPart": 'olist',
		"sCommand": 'insertorderedlist',
		"sCssClass": 'urRTEIcoNumList',
		"bProp": 'bHasOrderedList',
		"sTooltipKey": 'RTE_OLIST'
	},
	"unordered": {
		"sIdPart": 'unolist',
		"sCommand": 'insertunorderedlist',
		"sCssClass": 'urRTEIcoBulList',
		"bProp": 'bHasUnorderedList',
		"sTooltipKey": 'RTE_ULIST'
	},
	"header1": {
		"sIdPart": 'head1',
		"sCommand": 'formatblock',
		"sEnableValue": '<h1>',
		"sDisableValue": '<p>',
		"sCheckValue": '1',
		"sCssClass": 'urRTEIcoH1',
		"bProp": 'bHasHeadings',
		"sTooltipKey": 'RTE_H1'
	},
	"header2": {
		"sIdPart": 'head2',
		"sCommand": 'formatblock',
		"sEnableValue": '<h2>',
		"sDisableValue": '<p>',
		"sCheckValue": '2',
		"sCssClass": 'urRTEIcoH2',
		"bProp": 'bHasHeadings',
		"sTooltipKey": 'RTE_H2'
	},
	"header3": {
		"sIdPart": 'head3',
		"sCommand": 'formatblock',
		"sEnableValue": '<h3>',
		"sDisableValue": '<p>',
		"sCheckValue": '3',
		"sCssClass": 'urRTEIcoH3',
		"bProp": 'bHasHeadings',
		"sTooltipKey": 'RTE_H3'
	},

	"leftAlign": {
		"sIdPart": 'lAlign',
		"sCommand": 'justifyleft',
		"sDisableValue": '<p>',
		"sCssClass": 'urRTEIcoAlignLeft',
		"bProp": 'bHasTextAlignment',
		"sTooltipKey": 'RTE_JLEFT'
	},
	"centerAlign": {
		"sIdPart": 'cAlign',
		"sCommand": 'justifycenter',
		"sDisableValue": '<p>',
		"sCssClass": 'urRTEIcoAlignCenter',
		"bProp": 'bHasTextAlignment',
		"sTooltipKey": 'RTE_JCENTER'

	},
	"rightAlign": {
		"sIdPart": 'rAlign',
		"sCommand": 'justifyright',
		"sDisableValue": '<p>',
		"sCssClass": 'urRTEIcoAlignRight',
		"bProp": 'bHasTextAlignment',
		"sTooltipKey": 'RTE_JRIGHT'
	}
};

/**
 * Destructor
 */
UCF_RichTextEdit["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["destroy"]++; }; 
	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	this["destroyButtons"]();
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		try {
			if (this["oFrameRef"]["contentWindow"]) {
				UCF_DomUtil["detachEvent"](this["oFrameRef"]["contentWindow"], 'resize', this["handleFrameResize"]);
			}
		} catch (ex) {
			// ignored
		}
		this["handleFrameResize"] = null;
	}
	this["detachIFrameEvents"]();
	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);

	/*
	 * This fix is supposed to correct the issues which were corrected in methods
	 * 'EnableEditMode()' and 'detachIframeEvents()' previously. As these corrections
	 * caused unwanted side effects (see CSN 427929 2014 and 483791 2013), they were
	 * removed.
	 * The problem (see internal CSN 79495 2009): After destroying the RTE, the iFrame
	 * is not correctly unloaded. If the RTE is recreated after a roundtrip, it is not
	 * possible to set the cursor. Setting the Iframe src unloads the contentWindow.
	 * Unfortunately, we have to add the iFrame to the active DOM again.
	 */
	if (this["oFrameRef"] && UCF_UserAgent["bIsIE"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Try to force unload of iFrame for MSIE<IE9, see note 2028819', "RichTextEdit.js(358): destroy"); };
		try {
			document["body"]["appendChild"](this["oFrameRef"]);
			this["oFrameRef"]["src"] = 'javascript:""';
			document["body"]["removeChild"](this["oFrameRef"]);
		} catch (oException) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Could not force unload of iFrame for MSIE<IE9 => Potential problem with setting cursor in RTE', "RichTextEdit.js(364): destroy"); };
		}
	}
	this["oFrameRef"] = null;
	this["detachBrowserEvent"]('resize', this["oRootRef"]);
	if (this["oLS"]) {
		this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, 'adjustSize');
	}
	this["oLastFocusDomRef"] = null;
	this["oPendingRequest"] = null;
	this["oFirstFocusDomRef"] = null;
	this["oClientToolbar"] = null;
	this["sParagraphSpacing"] = null;
	this["sHeight"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["destroy"] = 0; };

UCF_RichTextEdit["prototype"]["focus"] = function(bFromBackNavigation) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["focus"]++; }; 
	if (!this["bInitialized"]) {
		this["bRequestInitialFocus"] = true;
	} else {
		UCF_Control.prototype["focus"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["focus"] = 0; };

/**
 * No change event during typing. If time trigger fires submit rich text will not fire change.
 */
UCF_RichTextEdit["prototype"]["onPendingRequest"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onPendingRequest"]++; }; 

	this["oPendingRequest"] = oEvent["oGetParam"]('oPendingRequest');

	this["oPendingRequest"]["suspend"](this["sId"]);
	if (!this["bInitialized"]) {
		return;
	}
	this["resumePendingRequest"]();
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onPendingRequest"] = 0; };

/**
 * Resumes a waiting pending request
 */
UCF_RichTextEdit["prototype"]["resumePendingRequest"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["resumePendingRequest"]++; }; 
	this["fireChangeIfNeeded"]();
	this["oPendingRequest"]["resume"](this["sId"]);
	this["oPendingRequest"] = null;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["resumePendingRequest"] = 0; };

/**
 * Initialize
 */
UCF_RichTextEdit["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["initialize"]++; }; 
	var oPage = this["oLS"]["oGetPageInternal"]();
	var sThemeUrl = null;

	this["bIsRTL"] = window["UCF_System"]["bIsRTL"] ? true : false; // eslint-disable-line @ur/no-memory-leaks
	if (this["sTextDirection"] !== "INHERIT") {
		this["bIsRTL"] = this["sTextDirection"] === "RTL" ? true : false;
	}

	if (oPage)
		sThemeUrl = oPage["sGetThemeUrl"]();
	if (!this["oFrameRef"]["loaded"] || !this["oFrameRef"]["src"]) {
		var sBoilerPlate = UCF_RichTextEdit["fBoilerplate"](sThemeUrl),
			sSrc = UCF_DomUtil["sGetIframeJSSource"](sBoilerPlate);

		this["attachBrowserEvent"]('load', this["oFrameRef"]);
		try {
			this["oFrameRef"]["src"] = sSrc;
		} catch (ex) {
			// ignored
		}
		return;
	}

	var oWin, oDoc;

	try {
		oWin = this["oFrameRef"]["contentWindow"];
		oDoc = oWin["document"];
		if (this["bLoadViaFile"]) {
			oDoc["getElementsByTagName"]('LINK')[0]["setAttribute"]('href', sThemeUrl);
		}
	} catch (ex) {
		if (!this["bLoadViaFile"]) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Initialization failed. Try again with file.', "RichTextEdit.js(450): handleFrameResize"); };
			this["oFrameRef"]["loaded"] = false;
			this["attachBrowserEvent"]('load', this["oFrameRef"]);
			try {
				this["oFrameRef"]["src"] = window["UCF_System"]["sResourceRoot"] + '/js/html/richtext.html';
			} catch (ex) {
				// ignored
			}
			this["bLoadViaFile"] = true;
			return;
		}
		//display a warning
		var oSpan = document["createElement"]('span');
		UCF_DomUtil["setInnerHtml"](oSpan, 'Due to system security restrictions this editor is currently disabled.');
		oSpan["className"] = 'lsRichTextEdit--text lsRichTextEdit--fail urTxtStd urMsgBarImgWarning';
		if (__UCF_DEBUG__) {
			oSpan["setAttribute"]('title', 'Possible reason is a wrong HTTP header that prevents RichTextEditor to work correctly. Prevent setting header x-frame-options: sameorigin');
		}

		this["oFrameRef"]["parentNode"]["appendChild"](oSpan);
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Initialization failed. Possible reason is a wrong HTTP header that prevents RichTextEditor to work correctly. Prevent setting header x-frame-options: sameorigin', "RichTextEdit.js(470): handleFrameResize"); };
		return;
	}

	this["applyParagraphSpacing"]();
	this["createButtons"]();

	oDoc["body"]["setAttribute"]('id', this["sId"]);
	oDoc["body"]["setAttribute"]('subct', "RTE_IF"); //used for BrowserEvent.oGetSourceRoot to identify the IFrame of a RTE. As result the oDomRoot of the RTE instead of IFrame is used for event processing

	oDoc["body"]["setAttribute"]('acf', 'editor');
	if (!this["oLS"]["oSystem"]["bIs508"] && this["sTooltip"] !== '') {
		oDoc["body"]["setAttribute"]('title', this["sTooltip"]);
	}

	oDoc["body"]["dir"] = this["bIsRTL"] ? 'rtl' : 'ltr';

	var sClassName = 'lsRichTextEdit--body urFTxtV';

	if (!this["bEnabled"]) {
		sClassName += ' urRteDsbl';
	} else if (this["sAssociatedEditContext"] === 'PARENTREADONLY' || this["bReadonly"]) {
		sClassName += ' urRteRo';
	} else {
		sClassName += ' urRte';
	}

	// sap_belize focus in ie needs to know the user agent in css. Generic
	// html[data-sap-ls-system-useragent^="..."] does not work across the
	// iframe => need to give the info to the body
	if (UCF_UserAgent["bIsIE"]()) {
		sClassName += ' lsRichtextedit--ie';
	} else if (UCF_UserAgent["bIsMSEdge"]()) {
		sClassName += ' lsRichtextedit--edge';
	} else if (UCF_UserAgent["bIsGecko"]()) {
		sClassName += ' lsRichtextedit--gecko';
	} else {
		sClassName += ' lsRichtextedit--webkit';
	}

	oDoc["body"]["className"] = sClassName;

	UCF_LS["applySupportedThemes"](oDoc["body"]);

	this["setHtml"](this["sHtmlText"]);

	this["adjustSize"]();
	this["attachBrowserEvent"]('resize', this["oRootRef"]);
	if (this["oLS"]) {
		this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, 'adjustSize');
	}
	var self = this;
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		this["handleFrameResize"] = function() {
			self["_handleFrameResize"]();
		};
		UCF_DomUtil["attachEvent"](oWin, 'resize', this["handleFrameResize"]);
	}
	if (!this["bEnabled"] || this["bReadonly"]) {
		this["bInitialized"] = true;
		if (this["bRequestInitialFocus"]) {
			this["focus"]();
			this["bRequestInitialFocus"] = false;
		}
		if (this["oPendingRequest"]) {
			this["resumePendingRequest"]();
		}

		return;
	}

	this["enableEditMode"](oDoc);

	this["sLastHtml"] = this["sGetHtml"]();

	this["forwardEditorEvent"] = function(e) {
		self["cleanUpStyles"]();
		switch (e["type"]) {
			case 'keyup':
			case 'keydown':
				self["onEditorKeyDown"](e);
				break;
			case 'keypress':

				self["onEditorKeyDown"](e);
				break;
			case 'click':
			case 'select':
			case 'touchstart':
				if (e["type"] === 'touchstart') {
					UCF_JsUtil["delayedCall"](100, self, 'onEditorAction');
				} else {
					self["onEditorAction"]();
				}
				break;
			case 'cut':
				self["onEditorCut"]();
				break;
			case 'paste':
				self["onEditorPaste"]();
				break;
			case 'focus':
				self["onEditorFocus"]();
				break;
			case 'blur':
				self["onEditorBlur"]();
				break;
			case 'scroll':
				self["onEditorScroll"]();
				break;
			case 'dragstart':
				self["onEditorDragStart"]();
				break;
			case 'drop':
				self["onEditorDrop"]();
				break;
		}
	};

	this["attachIFrameEvents"]();

	UCF_JsUtil["delayedCall"](0, this, 'applyScrollPosition');

	this["bInitialized"] = true;
	if (this["bRequestInitialFocus"]) {
		this["focus"]();
		this["bRequestInitialFocus"] = false;
	}
	if (this["oPendingRequest"]) {
		this["resumePendingRequest"]();
	}
	this["oFirstFocusDomRef"] = this["oGetFirstButtonDomRef"]() || this["oFrameRef"];

	//this.createBtnNav();
	//this.iFocusIndex = 0;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["initialize"] = 0; };

/*
UCF_RichTextEdit.prototype.createBtnNav = function() {

	var oBtnCont = UCF_DomUtil.$(this.sId + "-tbarcontainer");
	var aButtons = oBtnCont.getElementsByTagName("A");
	this.aButtons = [];

	for (var i = 0; i < aButtons.length; i++) {
		this.aButtons.push(aButtons[i]);
		if (i === 0) continue;
		UCF_DomUtil.setTabIndex(aButtons[i], -1);
	}
};


UCF_RichTextEdit.prototype.onkeydown = function (oBrowserEvent) {
debugger;

	switch (oBrowserEvent._iKeyCode) {
		case UCF_KeyCodes.ARROW_LEFT:
		case UCF_KeyCodes.ARROW_UP:

			this.navToPreviousButton(oBrowserEvent);
			break;

		case UCF_KeyCodes.ARROW_RIGHT:
		case UCF_KeyCodes.ARROW_DOWN:

			this.navToNextButton(oBrowserEvent);
	}
};

UCF_RichTextEdit.prototype.navToPreviousButton = function (oBrowserEvent) {

	var oButton = oBrowserEvent.oSource;
	var iIndex  = this.iFocusIndex - 1;

	if (iIndex < 0) return;

	UCF_DomUtil.setTabIndex(oButton, -1);
	UCF_DomUtil.setTabIndex(this.aButtons[iIndex], 0);
	UCF_DomUtil.focusDomElement(this.aButtons[iIndex]);

	this.iFocusIndex = iIndex;
};

UCF_RichTextEdit.prototype.navToNextButton = function (oBrowserEvent) {
	var oButton = oBrowserEvent.oSource;
	var iIndex  = this.iFocusIndex + 1;

	if (iIndex > this.aButtons.length - 1) return;

	UCF_DomUtil.setTabIndex(oButton, -1);
	UCF_DomUtil.setTabIndex(this.aButtons[iIndex], 0);
	UCF_DomUtil.focusDomElement(this.aButtons[iIndex]);

	this.iFocusIndex = iIndex;
};
*/

UCF_RichTextEdit["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onresize"]++; }; 
	this["adjustSize"]();
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onresize"] = 0; };

/**
 * traps calling {{#adjustSizeInternal}} in a 500ms resetting delay
 * (i.e. calls {{#adjustSizeInternal}} only if it isn't called for 500ms)
 * @see UCF_RichTextEdit.prototype.adjustSizeInternal
 */
UCF_RichTextEdit["prototype"]["adjustSize"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["adjustSize"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()', "RichTextEdit.js(677): adjustSize"); };
	// CSN (1570846944)[https://support.wdf.sap.corp/sap/support/message/1570846944]:
	// adjustSize is attached to LayoutChange and onresize and therefore called
	// multiple times => trap it in a resetting delay to only execute it once
	if (this["sAdjustSizeDelayedCallId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sAdjustSizeDelayedCallId"]);
	}
	// TODO 500ms delay is chosen ~randomly
	this["sAdjustSizeDelayedCallId"] = UCF_JsUtil["delayedCall"](500, this, 'adjustSizeInternal'); // eslint-disable-line @ur/no-memory-leaks
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["adjustSize"] = 0; };

/**
 * adjusts the size of the RTE based on the {{this.sHeight}}
 * (roughly emulates {{this.oFrameRef.style.height = `calc(100% - ${getComputedStyle(this.oToolbarRef).height})`}})
 * @private
 */
UCF_RichTextEdit["prototype"]["adjustSizeInternal"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["adjustSizeInternal"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()', "RichTextEdit.js(694): adjustSizeInternal"); };
	this["sAdjustSizeDelayedCallId"] = undefined;

	if (!this["sHeight"]) {
		this["sHeight"] = '130px';
	}

	// Workaround: Some code in ClientToolbar.js during initialize that renders a More button
	// will cause the Toolbar to get re-rendered and this instance that we created during initialize of the RTE
	// is left in destroyed-state => get the new instance
	if (this["oClientToolbar"] && this["oClientToolbar"]["bIsDestroyed"]) {
		this["oClientToolbar"] = this["oLS"]["oGetClientControlById"](this["oClientToolbar"]["getId"]());
	}

	var sUnit = this["sHeight"]["replace"](/[0-9]|\./gi, ''),
		iBorderWidth = parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'borderBottomWidth')) || 0,
		iToolbarHeight = this["oClientToolbar"] ? this["oClientToolbar"]["getRootRef"]()["offsetHeight"] : 0,
		oFrameCell = UCF_DomUtil["$"](this["sId"] + '-tdfrm')
		//, iMinHeight = iToolbarHeight + 60
		,
		iHeight;

	if (this["sHeight"] && !sUnit) {
		this["sHeight"] = this["sHeight"] + 'px';
	}
	this["setClientProperty"]("Height", this["sHeight"], false);

	this["oRootRef"]["style"]["position"] = 'relative';
	this["oDomRef"]["style"]["position"] = 'absolute';
	this["oFrameRef"]["style"]["position"] = 'absolute';
	iHeight = this["oRootRef"]["offsetHeight"]; // ?
	this["oRootRef"]["style"]["height"] = this["sHeight"];
	iHeight = this["oRootRef"]["offsetHeight"];

	// if (iHeight < iMinHeight) {
	// 	iHeight = iMinHeight;
	// }
	this["oDomRef"]["style"]["boxSizing"] = 'border-box';
	this["oFrameRef"]["style"]["width"] = '1px';

	iToolbarHeight = iToolbarHeight + iBorderWidth;

	this["oDomRef"]["style"]["height"] = iHeight + 'px';
	this["oFrameRef"]["style"]["height"] = Math["max"](iHeight - iToolbarHeight - (2 * iBorderWidth), 10) + 'px';
	oFrameCell["style"]["height"] = Math["max"](iHeight - iToolbarHeight - (2 * iBorderWidth)) + 'px';

	this["oRootRef"]["style"]["position"] = 'static';
	this["oDomRef"]["style"]["position"] = 'static';
	this["oFrameRef"]["style"]["position"] = 'static';

	this["oFrameRef"]["style"]["width"] = '100%';
	try {
		var oWin = this["oFrameRef"]["contentWindow"],
			oDoc = oWin["document"];
		//set height of content body to allow clicks in empty area
		oDoc["body"]["style"]["height"] = (iHeight - 22 - iToolbarHeight - (2 * iBorderWidth)) + 'px';
	} catch (ignored) {
		// ignored
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["adjustSizeInternal"] = 0; };

/**
 * attach events for iframe
 */
UCF_RichTextEdit["prototype"]["attachIFrameEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["attachIFrameEvents"]++; }; 
	var oWin = this["oFrameRef"]["contentWindow"],
		oDoc = oWin["document"];

	UCF_DomUtil["attachEvent"](oWin, 'scroll', this["forwardEditorEvent"]);

	// IE uses lsfocus and lsblur and does not need to attach focus/blur
	if (UCF_UserAgent["bIsGecko"]()) {
		UCF_DomUtil["attachEvent"](oDoc, 'focus', this["forwardEditorEvent"]);
		UCF_DomUtil["attachEvent"](oDoc, 'blur', this["forwardEditorEvent"]);
	} else if (UCF_UserAgent["bIsWebKit"]() || UCF_UserAgent["bIsEdgeHtml"]()) {
		UCF_DomUtil["attachEvent"](oWin, 'focus', this["forwardEditorEvent"]);
		UCF_DomUtil["attachEvent"](oWin, 'blur', this["forwardEditorEvent"]);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["attachIFrameEvents"] = 0; };

/**
 * detach events for iframe
 */
UCF_RichTextEdit["prototype"]["detachIFrameEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["detachIFrameEvents"]++; }; 
	// Workaround for IE bug, where the contentWindow cannot be accessed before document
	this["oFrameRef"]["document"]; // eslint-disable-line no-unused-expressions

	var oWin = this["oFrameRef"]["contentWindow"],
		oDoc;

	if (!oWin)
		return;
	if (!this["forwardEditorEvent"])
		return;
	try {
		oDoc = oWin["document"];
	} catch (ex) {

		return;
	}

	// CSN:0772807 2011 and CSN:483791 2013: Fix was replaced (see 'destroy()')

	UCF_DomUtil["detachEvent"](oWin, 'scroll', this["forwardEditorEvent"]);

	UCF_JsUtil["clearDelayedCall"](this["sScrollTimerId"]);
	// IE6 uses lsfocus and lsblur and does not need to detach focus/blur
	if (UCF_UserAgent["bIsGecko"]()) {
		UCF_DomUtil["detachEvent"](oDoc, 'focus', this["forwardEditorEvent"]);
		UCF_DomUtil["detachEvent"](oDoc, 'blur', this["forwardEditorEvent"]);
	} else if (UCF_UserAgent["bIsWebKit"]()) {
		UCF_DomUtil["detachEvent"](oWin, 'focus', this["forwardEditorEvent"]);
		UCF_DomUtil["detachEvent"](oWin, 'blur', this["forwardEditorEvent"]);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["detachIFrameEvents"] = 0; };

UCF_RichTextEdit["prototype"]["_handleFrameResize"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["_handleFrameResize"]++; }; 
	// force redraw
	if (this["oFrameRef"]) {
		this["oFrameRef"]["contentWindow"]["document"]["body"]["className"] = this["oFrameRef"]["contentWindow"]["document"]["body"]["className"];
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["_handleFrameResize"] = 0; };

/**
 * attach events for iframe
 */
UCF_RichTextEdit["prototype"]["attachEditorEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["attachEditorEvents"]++; }; 
	var oWin = this["oFrameRef"]["contentWindow"],
		oDoc = oWin["document"],
		oSource = oDoc["body"];

	if (UCF_UserAgent["bIsIOS"]() && UCF_UserAgent["bIsSafari"]()) oSource = oDoc["body"]["firstChild"]["firstChild"];

	UCF_DomUtil["attachEvent"](oDoc, 'select', this["forwardEditorEvent"]);

	UCF_DomUtil["attachEvent"](oSource, 'keyup', this["forwardEditorEvent"]);
	UCF_DomUtil["attachEvent"](oSource, 'keydown', this["forwardEditorEvent"]);
	UCF_DomUtil["attachEvent"](oSource, 'keypress', this["forwardEditorEvent"]);
	UCF_DomUtil["attachEvent"](oSource, 'click', this["forwardEditorEvent"]);
	UCF_DomUtil["attachEvent"](oSource, 'dragstart', this["forwardEditorEvent"]);
	UCF_DomUtil["attachEvent"](oSource, 'drop', this["forwardEditorEvent"]);
	UCF_DomUtil["attachEvent"](oSource, 'cut', this["forwardEditorEvent"]);
	UCF_DomUtil["attachEvent"](oSource, 'paste', this["forwardEditorEvent"]);
	if (UCF_UserAgent["bIsIOS"]() && UCF_UserAgent["bIsSafari"]()) {
		UCF_DomUtil["attachEvent"](oSource, 'touchstart', this["forwardEditorEvent"]);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["attachEditorEvents"] = 0; };
/**
 * detach events for iframe
 */
UCF_RichTextEdit["prototype"]["detachEditorEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["detachEditorEvents"]++; }; 
	var oWin = this["oFrameRef"]["contentWindow"],
		oDoc = oWin["document"],
		oSource = oDoc["body"];

	if (UCF_UserAgent["bIsIOS"]() && UCF_UserAgent["bIsSafari"]()) oSource = oDoc["body"]["firstChild"]["firstChild"];

	UCF_DomUtil["detachEvent"](oDoc, 'select', this["forwardEditorEvent"]);

	UCF_DomUtil["detachEvent"](oSource, 'keyup', this["forwardEditorEvent"]);
	UCF_DomUtil["detachEvent"](oSource, 'keydown', this["forwardEditorEvent"]);
	UCF_DomUtil["detachEvent"](oSource, 'keypress', this["forwardEditorEvent"]);
	UCF_DomUtil["detachEvent"](oSource, 'click', this["forwardEditorEvent"]);
	UCF_DomUtil["detachEvent"](oSource, 'dragstart', this["forwardEditorEvent"]);
	UCF_DomUtil["detachEvent"](oSource, 'drop', this["forwardEditorEvent"]);
	UCF_DomUtil["detachEvent"](oSource, 'cut', this["forwardEditorEvent"]);
	UCF_DomUtil["detachEvent"](oSource, 'paste', this["forwardEditorEvent"]);
	if (UCF_UserAgent["bIsIOS"]() && UCF_UserAgent["bIsSafari"]()) {
		UCF_DomUtil["detachEvent"](oSource, 'touchstart', this["forwardEditorEvent"]);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["detachEditorEvents"] = 0; };

/**
 * Returns whether the value was edited by the user
 *
 * @private
 */
UCF_RichTextEdit["prototype"]["bValueEdited"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["bValueEdited"]++; }; 
	var sLastValue = this["sGetHtmlOfString"](this["normalizeHtml"](this["sLastHtml"])),
		sCurrentValue = this["normalizeHtml"](this["sGetHtml"]()),
		bEdited = sCurrentValue !== sLastValue;

	if (bEdited) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, sCurrentValue + ' !== ' + sLastValue, "RichTextEdit.js(877): bValueEdited"); };
	}
	return bEdited;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["bValueEdited"] = 0; };

/**
 * Handler for events that are fired during a field is edited.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTextEdit["prototype"]["handleEditEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["handleEditEvents"]++; }; 
	if (this["bValueEdited"]() && !this["bIsDirty"]) {
		this["bIsDirty"] = true;
		this["markDirty"](true);
		this["setPendingChange"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["handleEditEvents"] = 0; };

/**
 * Handles the onload event for the editor iframe
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTextEdit["prototype"]["onload"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onload"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RichTextEdit.js(903): onload"); };

	this["oFrameRef"]["loaded"] = true;
	this["detachBrowserEvent"]('load', this["oFrameRef"]);
	this["initialize"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onload"] = 0; };

/**
 * Handles the onmousdown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTextEdit["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onmousedown"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onmousedown"] = 0; };

/**
 * Handles the ls focus event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTextEdit["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onlsfocus"]++; }; 
	oBrowserEvent["cancelBubble"]();
	if (!this["bInitialized"])
		return;

	var oSource = oBrowserEvent["oGetSource"]();
	// D039230 CSN 3433037 2011 . setFocus always in the Iframe
	// tabchain, always starts with the toolbar buttons
	if (oSource === this["oFrameRef"] || oSource === this["oDomRef"]) {
		this["onEditorFocus"]();
		this["oFrameRef"]["contentWindow"]["focus"]();
		if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
			if (!this["oFrameRef"]["contentWindow"]["document"]["getSelection"]) {
				this["oFrameRef"]["contentWindow"]["document"]["selection"]["createRange"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onlsfocus"] = 0; };

/**
 * Handles the lsblur event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTextEdit["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onlsblur"]++; }; 
	oBrowserEvent["cancelBubble"]();

	if (oBrowserEvent["oGetSource"]() === this["oFrameRef"]) {
		this["onEditorBlur"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onlsblur"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTextEdit["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RichTextEdit.js(967): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oBrowserEvent["oGetSourceControl"]() !== this) {
		oAccessibilityHelper["setParentControlType"]('RTE');
		return;
	}
	oAccessibilityHelper["setControlType"]('RTE');

	// Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this);
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

	// status
	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setReadonly"](this["bReadonly"]);

	oAccessibilityHelper["setTooltip"](this["sTooltip"]);

	// Special handling for the iframe
	// set the title of the iframes document because this is read out via IAcc interface
	if (this["oFrameRef"] && this["oFrameRef"]["contentWindow"] && this["oFrameRef"]["contentWindow"]["document"]) {
		this["oFrameRef"]["contentWindow"]["document"]["title"] = this["oLS"]["sGetText"]('SAPUR_RTE');
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onlsaccessibility"] = 0; };

/**
 * Handles the MouseDown event of the embedded toolbar buttons
 *
 * @param {UCF_Event} oEvent the browser event object that occurred
 * @private
 */
UCF_RichTextEdit["prototype"]["onButtonMouseDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onButtonMouseDown"]++; }; 
	if (!this["bInitialized"]) {
		return;
	}
	this["bIgnoreBlur"] = true;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onButtonMouseDown"] = 0; };

/**
 * Handles the Press events of the embedded toolbar buttons
 *
 * @param {UCF_Event} oEvent the browser event object that occurred
 * @private
 */
UCF_RichTextEdit["prototype"]["onButtonPress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onButtonPress"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "RichTextEdit.js(1015): onButtonPress"); };
	if (!this["bInitialized"])
		return;
	if (this["bReadonly"] === true) return;

	var sId = oEvent["oGetParam"]('sId');
	var bIsToolbarButton = /.*_tbar_(.*)(-r)?/["test"](sId);

	if (!bIsToolbarButton)
		return;

	var sAction = RegExp["$1"];
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'RTE - sId - ' + sId + '; sAction - ' + sAction, "RichTextEdit.js(1027): onButtonPress"); };
	for (var i in this["oFormats"]) {
		if (this["oFormats"][i]["sIdPart"] === sAction) {
			this["applyFormat"](i);
			break;
		}
	}

	this["oFrameRef"]["contentWindow"]["focus"]();
	this["queryFormatState"]();
	this["updateButtons"]();

};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onButtonPress"] = 0; };

/** Cleans the HTML from not allowed tags in case of paste, cut, drop */
UCF_RichTextEdit["prototype"]["cleanHTML"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["cleanHTML"]++; }; 
	var oRange;
	var oCaret;

	if (this["oFrameRef"]["contentWindow"]["document"]["getSelection"]) {
		oRange = this["oFrameRef"]["contentWindow"]["document"]["getSelection"]()["getRangeAt"](0);
		var newTextNode = this["oFrameRef"]["contentWindow"]["document"]["createElement"]('span');
		newTextNode["appendChild"](this["oFrameRef"]["contentWindow"]["document"]["createTextNode"]('|'));
		newTextNode["setAttribute"]('id', 'ls_caret');
		oRange["insertNode"](newTextNode);
	} else if (this["oFrameRef"]["contentWindow"]["document"]["selection"]) {
		oRange = this["oFrameRef"]["contentWindow"]["document"]["selection"]["createRange"]();
		oRange["pasteHTML"]('<span id="ls_caret">|</span>');
	}
	this["setHtml"](this["sGetHtml"]());
	if (this["oFrameRef"]["contentWindow"]["document"]["getSelection"]) {
		this["oFrameRef"]["contentWindow"]["document"]["getSelection"]()["removeAllRanges"]();
		oCaret = this["oFrameRef"]["contentWindow"]["document"]["getElementById"]('ls_caret');
		oRange = document["createRange"]();
		oRange["setStartBefore"](oCaret);
		oCaret["parentNode"]["removeChild"](oCaret);
		this["oFrameRef"]["contentWindow"]["document"]["getSelection"]()["addRange"](oRange);
	} else if (this["oFrameRef"]["contentWindow"]["document"]["selection"]) {
		oRange = this["oFrameRef"]["contentWindow"]["document"]["selection"]["createRange"]();
		oCaret = this["oFrameRef"]["contentWindow"]["document"]["getElementById"]('ls_caret');
		oRange["moveToElementText"](oCaret);
		oRange["move"]('character', 1);
		oCaret["parentNode"]["removeChild"](oCaret);
		oRange["select"]();
	}
	this["fireChangeIfNeeded"]();
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["cleanHTML"] = 0; };

/** Handler for paste event */
UCF_RichTextEdit["prototype"]["onEditorPaste"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorPaste"]++; }; 
	this["onEditorAction"]();
	UCF_JsUtil["delayedCall"](0, this, 'cleanHTML');
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorPaste"] = 0; };

/** Handler for cut event */
UCF_RichTextEdit["prototype"]["onEditorCut"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorCut"]++; }; 
	this["onEditorAction"]();
	UCF_JsUtil["delayedCall"](0, this, 'cleanHTML');
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorCut"] = 0; };

/** Handler for all actions inside the editor window */
UCF_RichTextEdit["prototype"]["onEditorAction"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorAction"]++; }; 
	this["queryFormatState"]();
	this["updateButtons"]();
	this["handleEditEvents"]();
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorAction"] = 0; };

UCF_RichTextEdit["prototype"]["onEditorKeyDown"] = function(e) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorKeyDown"]++; }; 
	if (e) {
		var iKeyCode = e["keyCode"],
			bCtrlKey = UCF_UserAgent["bIsMacOs"]() ? e["metaKey"] : e["ctrlKey"],
			bAltKey = e["altKey"],
			bShiftKey = e["shiftKey"];

		// avoid tab in chrome and safari
		if (!bCtrlKey && !bAltKey && iKeyCode === 9 && UCF_UserAgent["bIsWebKit"]() && e["type"] === 'keydown') {

			var oFocusControl = null;

			if (e["shiftKey"]) {
				oFocusControl = this["oGetPreviousFocusableControlRecursive"](this["oFrameRef"]);
				if (oFocusControl === this) { // no buttons
					oFocusControl = this["oGetPreviousFocusableControlRecursive"](this["oRootRef"]);
				}
			} else {
				oFocusControl = this["oGetNextFocusableControlRecursive"](this["oFrameRef"]);
			}
			if (oFocusControl) {
				oFocusControl["moveFocus"](false, e["shiftKey"]);
			}

			if (e["preventDefault"]) {
				e["preventDefault"]();
				e["cancelBubble"] = true;
			}
			return;
		}
		if (iKeyCode === 0) {
			return;
		}

		if (bCtrlKey && !bShiftKey && !bAltKey) {
			var sKeyCode = String["fromCharCode"](iKeyCode)["toLowerCase"]();
			var allowed = this["bCtrlKeyAllowed"](sKeyCode);
			// _trace(INFO, 'keyCode pressed ' + iKeyCode + ' - ' + sKeyCode + ' - ' + allowed);
			if (!allowed) {
				// FF
				if (e["preventDefault"]) {
					e["preventDefault"]();
				}
				// MSIE
				else {
					e["returnValue"] = false;
					// Fix som stuborn events, like F5 and ctrl-f
					e["keyCode"] = 0;
				}
			}
		}

		//hotkey handling - only for allow Hotkeys - don't fireLSHotkey for RTE specific hotkeys
		if (e["type"] === "keydown"
			&& UCF_KeyboardHelper["bIsValidHotkey"](iKeyCode, bCtrlKey, bAltKey, bShiftKey)
			&& this["bHotkeyAllowed"](iKeyCode, bCtrlKey, bShiftKey, bAltKey)) {
			this["fireHotkeyEvent"](e);
		}
	}

	this["queryFormatState"]();
	this["updateButtons"]();
	this["handleEditEvents"]();
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorKeyDown"] = 0; };

UCF_RichTextEdit["prototype"]["fireHotkeyEvent"] = function(e) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["fireHotkeyEvent"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Hotkey event fired: " + e["keyCode"], "RichTextEdit.js(1160): fireHotkeyEvent"); };

	var oNewBrowserEvent = this["oLS"]["oBrowserWindow"]["oBrowserEventPool"]["oBorrowObject"](e);

	oNewBrowserEvent["oSourceControl"] = this;
	this["oLS"]["oBrowserWindow"]["fireLSEvent"](this["oLS"]["oBrowserWindow"]["E_LS_EVENTS"]["hotkey"], oNewBrowserEvent);

	this["oLS"]["oBrowserWindow"]["oBrowserEventPool"]["returnObject"](oNewBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["fireHotkeyEvent"] = 0; };

UCF_RichTextEdit["prototype"]["bCtrlKeyAllowed"] = function(sKeyCode) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["bCtrlKeyAllowed"]++; }; 
	if (this["forbiddenCtrlKeys"]) {
		for (var i = 0; i < this["forbiddenCtrlKeys"]["length"]; i++) {
			if (sKeyCode === this["forbiddenCtrlKeys"][i]) {
				return false;
			}
		}
	}
	return true;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["bCtrlKeyAllowed"] = 0; };

/** check if keyCode is a valid hotkey (-> fire LSHotekey event)   */
UCF_RichTextEdit["prototype"]["bHotkeyAllowed"] = function(iKeyCode, bCtrlKey, bShiftKey, bAltKey) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["bHotkeyAllowed"]++; }; 

	var sKeyCode = String["fromCharCode"](iKeyCode)["toLowerCase"]();

	if (this["hotkeysUsedByRTE"]) {
		for (var i = 0; i < this["hotkeysUsedByRTE"]["length"]; i++) {
			if (sKeyCode === this["hotkeysUsedByRTE"][i]) {
				// no hotkey - used by RTE internally
				return false;
			}
		}
	}

	if (bCtrlKey && !bShiftKey && !bAltKey
		&& (iKeyCode === UCF_KeyCodes["C"]
			|| iKeyCode === UCF_KeyCodes["X"]
			|| iKeyCode === UCF_KeyCodes["V"]
			|| iKeyCode === UCF_KeyCodes["Z"]
			|| iKeyCode === UCF_KeyCodes["Y"]
			|| iKeyCode === UCF_KeyCodes["A"]
			|| iKeyCode === UCF_KeyCodes["DELETE"]
			|| iKeyCode === UCF_KeyCodes["INSERT"])) {
		// no hotkey - used by RTE internally
		return false;
	}

	if (iKeyCode === UCF_KeyCodes["ENTER"]) {
		return false;
	}
	return true;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["bHotkeyAllowed"] = 0; };

/** Handler for scrolling inside the editor window */
UCF_RichTextEdit["prototype"]["onEditorScroll"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorScroll"]++; }; 
	if (this["sScrollTimerId"] == null) {
		this["handleFireScroll"]();
	} else {
		UCF_JsUtil["clearDelayedCall"](this["sScrollTimerId"]);
	}
	this["sScrollTimerId"] = UCF_JsUtil["delayedCall"](100, this, 'handleFireScroll');
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorScroll"] = 0; };

/** Handler for dragging inside the editor window */
UCF_RichTextEdit["prototype"]["onEditorDragStart"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorDragStart"]++; }; 
	this["bDragging"] = true;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorDragStart"] = 0; };

/** Handler for dropping inside the editor window */
UCF_RichTextEdit["prototype"]["onEditorDrop"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorDrop"]++; }; 
	this["handleEditEvents"]();
	this["bDragging"] = false;
	UCF_JsUtil["delayedCall"](0, this, 'cleanHTML');
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorDrop"] = 0; };

/**
 * Handler for focus of the editor window (FF does not fire lsfocus for iframes)
 */
UCF_RichTextEdit["prototype"]["onEditorFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorFocus"]++; }; 
	if (!this["bInitialized"])
		return;
	if (!this["bIgnoreBlur"])
		this["attachEditorEvents"]();
	this["bIgnoreBlur"] = false;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorFocus"] = 0; };

/**
 * Handler for blur of the editor window (FF does not fire lsblur for iframes)
 */
UCF_RichTextEdit["prototype"]["onEditorBlur"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorBlur"]++; }; 
	if (!this["bInitialized"])
		return;

	if (UCF_UserAgent["bIsIOS"]() && UCF_UserAgent["bIsSafari"]()) {
		// "ignoreblur" Handling does not work on touch devices:
		// The blur is fired before the click/mousedown and even if we try to handle a touchstart on the Buttons,
		// there are sometimes two blur/focus in a row...
		var _this = this;
		UCF_JsUtil["delayedCall"](50, {
			"f": function() {
				var oAE = UCF_DomUtil["oGetActiveElement"]();
				if (oAE && !UCF_DomUtil["bContains"](_this["oRootRef"], oAE)) {
					_this["fireChangeIfNeeded"]();
				}
			}
		}, 'f');
		return;
	} else if (this["bIgnoreBlur"]) {
		return;
	}

	if (this["bDragging"]) {
		this["bDragging"] = false;
		UCF_JsUtil["delayedCall"](0, this, 'onEditorBlur');
		return;
	}

	this["detachEditorEvents"]();
	this["fireChangeIfNeeded"]();
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["onEditorBlur"] = 0; };

/**
 * Check if HTML has changed, if this is the case fire change
 */
UCF_RichTextEdit["prototype"]["fireChangeIfNeeded"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["fireChangeIfNeeded"]++; }; 
	var sHtml = this["sGetHtml"]();

	if (this["bValueEdited"]()) {
		this["sLastHtml"] = sHtml;
		this["sCurrentHtml"] = sHtml;
		this["fireChange"](this["sId"], this["normalizeHtml"](sHtml));
		this["setPendingChange"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["fireChangeIfNeeded"] = 0; };

/**
 * Fire scroll event with delay to avoid to get a semantic event for each browser scroll event
 */
UCF_RichTextEdit["prototype"]["handleFireScroll"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["handleFireScroll"]++; }; 
	if (this["sScrollTimerId"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' - ' + this["sScrollTimerId"], "RichTextEdit.js(1301): handleFireScroll"); };
		UCF_JsUtil["clearDelayedCall"](this["sScrollTimerId"]);
		this["sScrollTimerId"] = null;
	}
	if (!this["bPreventScroll"]) {
		var oBody = this["oFrameRef"]["contentWindow"]["document"]["body"],
			iScrollTop = oBody["scrollTop"],
			iScrollLeft = oBody["scrollLeft"];
		if (this["bIsRTL"]) {
			iScrollLeft = oBody["scrollWidth"] - oBody["clientWidth"] - oBody["scrollLeft"];
		}
		this["fireScroll"](this["sId"], Math["round"](iScrollTop), Math["round"](iScrollLeft));
	}
	this["bPreventScroll"] = false;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["handleFireScroll"] = 0; };

/**
 * Apply the scroll position of the editor. This needs to be called with delay, because the height of the editor has to be calculated first by the browser
 */
UCF_RichTextEdit["prototype"]["applyScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["applyScrollPosition"]++; }; 
	var oBody = this["oFrameRef"]["contentWindow"]["document"]["body"],
		iScrollTop, iScrollLeft;

	this["bPreventScroll"] = true;
	iScrollTop = this["iScrollTop"];
	iScrollLeft = this["iScrollLeft"];

	if (iScrollTop === -1) {
		iScrollTop = oBody["scrollHeight"];
	}
	if (iScrollLeft === -1) {
		iScrollLeft = oBody["scrollWidth"];
	}
	if (this["bIsRTL"]) {
		iScrollLeft = oBody["scrollWidth"] - oBody["clientWidth"] - this["iScrollLeft"];
	}
	oBody["scrollTop"] = iScrollTop;
	oBody["scrollLeft"] = iScrollLeft;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["applyScrollPosition"] = 0; };

/**
 * Query the current formatting state from the HTML
 */
UCF_RichTextEdit["prototype"]["queryFormatState"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["queryFormatState"]++; }; 
	var oDocument = this["oFrameRef"]["contentWindow"]["document"],
		oFormat = null,
		key;

	this["mState"] = {};

	for (key in this["oFormats"]) {
		oFormat = this["oFormats"][key];

		if (oFormat["mUnsupported"] && oFormat["mUnsupported"][window["UCF_System"]["sDevice"]]) {
			continue;
		}

		// if a value is defined, check the value, otherwise just the state
		if (oFormat["sCheckValue"]) {
			this["mState"][key] = UCF_JsUtil["contains"](oDocument["queryCommandValue"](oFormat["sCommand"])["toString"](), oFormat["sCheckValue"]);
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'i - ' + key + '; this.mState[i] - ' + this["mState"][key], "RichTextEdit.js(1361): queryFormatState"); };
		} else {
			this["mState"][key] = oDocument["queryCommandState"](oFormat["sCommand"]);
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'i - ' + key + '; this.mState[i] - ' + this["mState"][key], "RichTextEdit.js(1364): queryFormatState"); };
		}
	}
	if (oDocument["selection"]) {
		if (this["mState"]["header1"] || this["mState"]["header2"] || this["mState"]["header3"]) {
			this["mState"]["bold"] = false;
		} else {
			var iHeaderPos = oDocument["selection"]["createRange"]()["htmlText"]["indexOf"]('<H');
			if (iHeaderPos <= 3 && iHeaderPos > -1) {
				this["mState"]["bold"] = false;
				var sHTag = oDocument["selection"]["createRange"]()["htmlText"]["substring"](iHeaderPos + 1, iHeaderPos + 3);
				this["mState"]["header1"] = sHTag === 'H1';
				this["mState"]["header2"] = sHTag === 'H2';
				this["mState"]["header3"] = sHTag === 'H3';
			}
		}
	} else {
		// Avoid showing 'bold' state for headers
		if (this["mState"]["header1"] || this["mState"]["header2"] || this["mState"]["header3"]) {
			this["mState"]["bold"] = false;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["queryFormatState"] = 0; };

UCF_RichTextEdit["prototype"]["createToolbar"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["createToolbar"]++; }; 
	var oToolbarContainer = UCF_DomUtil["$"](this["sId"] + '-tbarcontainer');
	/** @type {UCF_Label} */
	var oLabel;
	/** @type {string} */
	var sACCText = '';

	this["oClientToolbar"] = this["oLS"]["oCreateClientControl"]('Toolbar', this["sId"] + '_tbar');
	this["oClientToolbar"]["setDesign"](this["sToolbarDesign"]);
	this["oClientToolbar"]["setHasBorder"](false);
	this["oClientToolbar"]["setItemOverflow"](true);

	if (this["sLabelledBy"]) {
		oLabel = UCF_DomUtil["$"](this["sLabelledBy"]);
		if (oLabel) {
			sACCText = oLabel["textContent"] + ' ' + oLabel["title"];
		}
	}
	if (sACCText) {
		this["oClientToolbar"]["setAccessibilityDescription"](this["oLS"]["sGetText"]('SAPUR_RTE') + ' ' + sACCText);
	} else {
		this["oClientToolbar"]["setAccessibilityDescription"](this["oLS"]["sGetText"]('SAPUR_RTE'));
	}

	this["setToolbarItems"]();
	this["setToolbarRightItems"]();

	this["oClientToolbar"]["attachEvent"](this["oClientToolbar"]["E_EVENTS"]["AfterRendering"], this, 'attachButtonEvents');
	this["oClientToolbar"]["placeAt"](oToolbarContainer);

};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["createToolbar"] = 0; };

/** @private */
UCF_RichTextEdit["prototype"]["setToolbarItems"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["setToolbarItems"]++; }; 
	for (var n in this["oFormats"]) {
		if (!this["mClientButtons"]) {
			this["mClientButtons"] = {};
		}
		if (this[this["oFormats"][n]["bProp"]]) {
			this["mClientButtons"][n] = this["oCreateButton"](this["oFormats"][n]);
			this["mClientButtons"][n]["setEnabled"](this["bEnabled"]);
			this["oClientToolbar"]["addItem"](this["mClientButtons"][n]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["setToolbarItems"] = 0; };

/** @private */
UCF_RichTextEdit["prototype"]["setToolbarRightItems"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["setToolbarRightItems"]++; }; 
	for (var n in this["oEditorActions"]) {
		if (!this["mActionClientButtons"]) {
			this["mActionClientButtons"] = {};
		}

		this["mActionClientButtons"][n] = this["oCreateButton"](this["oEditorActions"][n]);
		this["oClientToolbar"]["addRightItem"](this["mActionClientButtons"][n]);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["setToolbarRightItems"] = 0; };

/**
 * creates a toolbar button (using clientside rendering)
 * for a given format
 *
 * @param {{<string>: {
 * 		sIdPart: string,
 * 		sCommand: string,
 * 		sCtrlKey?: string,
 * 		sCssClass: string,
 * 		bProp: boolean,
 * 		sTooltipKey: string,
 * 		mUnsupported?: {<string>: boolean},
 * 		sEnableValue?: string,
 * 		sDisableValue?: string,
 * 		sCheckValue?: string
 * }}} oFormat the functionality that should be represented by the button
 * @return {UCF_ClientControl}
 * @see #oFormat
 */
UCF_RichTextEdit["prototype"]["oCreateButton"] = function(oFormat) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["oCreateButton"]++; }; 
	var oButton = this["oLS"]["oCreateClientControl"]('ToolbarButton', this["sId"] + '_tbar_' + oFormat["sIdPart"]);

	oButton["setDisabledIconSrc"]('lsControl--fontIcon urRTEIcoDim ' + oFormat["sCssClass"]);
	oButton["setUpIconSrc"]('lsControl--fontIcon urRTEIcoDim ' + oFormat["sCssClass"]);
	oButton["setDownIconSrc"]('lsControl--fontIcon urRTEIcoDim ' + oFormat["sCssClass"]);
	oButton["setInteractionBehaviour"]('TOGGLE');
	oButton["setHAlign"]('CENTER');
	oButton["setEnabled"](this["bEnabled"] && !this["bReadonly"]);
	oButton["setHasIcon"](true);
	oButton["setType"]('RTE');
	oButton["setTooltip"](this["oLS"]["sGetText"]('SAPUR_' + oFormat["sTooltipKey"]));
	oButton["onAfterRendering"] = function() {
		UCF_DomUtil["$"](oButton["getId"]() + '-img')["style"]["display"] = 'inline-block';
	};

	return oButton;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["oCreateButton"] = 0; };

/** @private */
UCF_RichTextEdit["prototype"]["toggleParagraphSpacing"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["toggleParagraphSpacing"]++; }; 
	this["sParagraphSpacing"] = (this["sParagraphSpacing"] === 'NONE')
		? 'LINE'
		: 'NONE';
	this["setClientProperty"]('ParagraphSpacing', this["sParagraphSpacing"], true);
	this["applyParagraphSpacing"]();

	this["oFrameRef"]["contentWindow"]["focus"]();
	// asynchronous call to break free from UCF_Button#onmousedown
	// (#updateButtons rerenders the button and after that this.oDomRef is
	// undefined in the UCF_Button#onmousedown() call that triggers #toggleParagraphSpacing)
	UCF_JsUtil["delayedCall"](0, this, 'updateButtons');
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["toggleParagraphSpacing"] = 0; };

/**
 * depending on {{#sParagraphSpacing}} either adds or removes {{p{margin:0}}} from iframe
 * @private
 */
UCF_RichTextEdit["prototype"]["applyParagraphSpacing"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["applyParagraphSpacing"]++; }; 
	UCF_DomUtil["setStyleElementContent"](
		this["sParagraphSpacing"] === 'NONE'
		? 'p,blockquote {margin-bottom:0px!important;margin-top:0px!important;}'
		: '',
		this["oFrameRef"]["contentWindow"]["document"]
	);
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["applyParagraphSpacing"] = 0; };

UCF_RichTextEdit["prototype"]["attachButtonEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["attachButtonEvents"]++; }; 
	var i, oFormat, oButton;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()', "RichTextEdit.js(1515): attachButtonEvents"); };

	this["mButtons"] = {};
	for (i in this["oFormats"]) {
		oFormat = this["oFormats"][i];
		if (this["mClientButtons"][i]) {
			oButton = this["mClientButtons"][i]["getUCFInstance"](true);
			oButton["attachEvent"](oButton["E_EVENTS"]["Press"], this, 'onButtonPress');
			oButton["attachEvent"](oButton["E_EVENTS"]["MouseDown"], this, 'onButtonMouseDown');
			this["mButtons"][i] = oButton;
		}
	}

	this["mActionButtons"] = {};
	for (i in this["oEditorActions"]) {
		oFormat = this["oEditorActions"][i];
		if (this["mActionClientButtons"][i]) {
			oButton = this["mActionClientButtons"][i]["getUCFInstance"](true);
			oButton["attachEvent"](oButton["E_EVENTS"]["Press"], this, oFormat["sCommand"]);
			oButton["attachEvent"](oButton["E_EVENTS"]["MouseDown"], this, oFormat["sCommand"]);
			this["mActionButtons"][i] = oButton;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["attachButtonEvents"] = 0; };

/** Get toolbar buttons */
UCF_RichTextEdit["prototype"]["createButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["createButtons"]++; }; 
	var oFormat, sCtrlKeyValue, n;

	if (this["bHasToolBar"]) {
		if (!this["oClientToolbar"]) {
			this["createToolbar"]();
		}
		this["forbiddenCtrlKeys"] = [];
		this["hotkeysUsedByRTE"] = [];
		for (n in this["oFormats"]) {
			oFormat = this["oFormats"][n];
			sCtrlKeyValue = oFormat["sCtrlKey"];
			if (sCtrlKeyValue) {
				if (!this[oFormat["bProp"]]) {
					if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'key forbidden ' + sCtrlKeyValue, "RichTextEdit.js(1555): createButtons"); };
					this["forbiddenCtrlKeys"]["push"](sCtrlKeyValue);
				} else {
					//do not fire hotkey event for toolbar buttons
					this["hotkeysUsedByRTE"]["push"](sCtrlKeyValue);
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["createButtons"] = 0; };

/** Detach from button events */
UCF_RichTextEdit["prototype"]["destroyButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["destroyButtons"]++; }; 
	var i, oButton;

	for (i in this["mActionButtons"]) {
		oButton = this["mActionButtons"][i];
		oButton["detachEvent"](oButton["E_EVENTS"]["Press"], this);
		oButton["detachEvent"](oButton["E_EVENTS"]["MouseDown"], this);
	}

	for (i in this["mButtons"]) {
		oButton = this["mButtons"][i];
		oButton["detachEvent"](oButton["E_EVENTS"]["Press"], this);
		oButton["detachEvent"](oButton["E_EVENTS"]["MouseDown"], this);
	}

	if (this["oClientToolbar"]) {
		this["oClientToolbar"]["destroy"]();
	}

	this["mButtons"] = {};
	this["mActionButtons"] = {};
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["destroyButtons"] = 0; };

/** Update the buttons according to the current state */
UCF_RichTextEdit["prototype"]["updateButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["updateButtons"]++; }; 
	var n, oFormat;

	for (n in this["mActionButtons"]) {
		oFormat = this["oEditorActions"][n];

		if (oFormat["fEnabledWhen"](this) !== this["mActionClientButtons"][n]["getDown"]()) {
			this["updateButton"](n, this["mActionClientButtons"], this["mActionButtons"], { "Press": oFormat["sCommand"], "MouseDown": oFormat["sCommand"] }, oFormat["fEnabledWhen"](this));
		}
	}

	for (n in this["mButtons"]) {
		if (this["mState"][n] !== this["mClientButtons"][n]["getDown"]()) {
			this["updateButton"](n, this["mClientButtons"], this["mButtons"], { "Press": 'onButtonPress', "MouseDown": 'onButtonMouseDown' }, this["mState"][n]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["updateButtons"] = 0; };

/**
 * Updates a single Toolbar Button by
 * 1. detaching all events from it
 * 2. setting the down state according to {{bIsButtonDown}}
 * 3. re-initializing the button reference
 * 4. re-attaching all events in {{mEventHandlersForButton}}
 *
 * @param {string} sButtonId the id of the button in {{mClientButtons}} and {{mButtons}}
 * @param {<string>: UCF_ClientControl} mClientButtons mapping of button ids to client control instances
 * @param {<string>: UCF_Control} mButtons mapping of button ids to ucf control instances; it should hold
 * that for all i in mButtons, mButtons[i].getClientControl().sId === mClientButtons[i].sId
 * (they might get re-initialized during the process, so mButtons[i].getClientControl() === mClientButtons[i]
 * might not be true)
 * @param {<string>: string} mEventhandlersForButton a mapping of button events (see UCF_Button#M_EVENTS) to
 * function names of UCF_RichTextEdit (e.g. {{{Press: 'onButtonPress'}}})
 * @param {boolean} bIsButtonDown {{true}} if the button will be set to the down state, otherwise {{false}}
 */
UCF_RichTextEdit["prototype"]["updateButton"] = function(sButtonId, mClientButtons, mButtons, mEventhandlersForButton, bIsButtonDown) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["updateButton"]++; }; 
	var oButton = mButtons[sButtonId],
		n;

	if (oButton) {
		for (n in mEventhandlersForButton) {
			oButton["detachEvent"](oButton["E_EVENTS"][n], this, mEventhandlersForButton[n]);
		}
	}

	mClientButtons[sButtonId]["setDown"](bIsButtonDown);
	mButtons[sButtonId] = mClientButtons[sButtonId]["getUCFInstance"](true);

	oButton = mButtons[sButtonId];

	if (oButton) {
		for (n in mEventhandlersForButton) {
			oButton["attachEvent"](oButton["E_EVENTS"][n], this, mEventhandlersForButton[n]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["updateButton"] = 0; };

/**
 * Returns the visible first button dom reference
 *
 * @return {Element} the visible first button dom reference
 */
UCF_RichTextEdit["prototype"]["oGetFirstButtonDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["oGetFirstButtonDomRef"]++; }; 
	var oButton = this["oGetFirstFocusableChild"]();
	if (UCF_JsUtil["bInstanceOf"](oButton, 'UCF_Button')) {
		return oButton["oGetFocusDomRef"]();
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["oGetFirstButtonDomRef"] = 0; };

/**
 * Apply format
 *
 * @param {string} sCommand
 * @param {string} sValue
 */
UCF_RichTextEdit["prototype"]["applyFormat"] = function(sName) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["applyFormat"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) === 'string', "typeof(sName) === 'string'", "RichTextEdit.js(1668): applyFormat"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(this["oFormats"][sName]) === 'object', "typeof(this.oFormats[sName]) === 'object'", "RichTextEdit.js(1669): applyFormat"); };

	var oFormat = this["oFormats"][sName],
		sCommand = oFormat["sCommand"],
		sValue = this["mState"][sName] ? oFormat["sDisableValue"] : oFormat["sEnableValue"],
		oEditorWindow = this["oFrameRef"]["contentWindow"];

	if (!UCF_UserAgent["bIsChromium"]())
		oEditorWindow["focus"]();

	if (UCF_UserAgent["bIsWebKit"]() && sName["indexOf"]('header') > -1 && (this["mState"]['unordered'] || this["mState"]['ordered'])) {
		return;
	}
	oEditorWindow["document"]["execCommand"](sCommand, false, sValue);
	// erase fontsize
	if (sName["indexOf"]('ordered') > -1 || sName["indexOf"]('indent') > -1 || sName["indexOf"]('outdent') > -1) {
		// remove tag styles
		this["cleanUpStyles"]();
	}

	if (UCF_UserAgent["bIsChromium"]())
		oEditorWindow["document"]["body"]["focus"]();
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["applyFormat"] = 0; };

UCF_RichTextEdit["prototype"]["cleanUpStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["cleanUpStyles"]++; }; 
	var self = this;

	if (UCF_UserAgent["bIsWebKit"]()) {
		UCF_JsUtil["forEach"](['span', 'b', 'i', 'u'], function(sTag) {
			UCF_JsUtil["forEach"]([]["slice"]["call"](self["oFrameRef"]["contentWindow"]["document"]["body"]["getElementsByTagName"](sTag)), function(oElement) {
				oElement["removeAttribute"]('style');
			});
		});
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["cleanUpStyles"] = 0; };

/**
 * Sets the HTML in Iframe
 *
 * @param {string} sHtml
 */
UCF_RichTextEdit["prototype"]["setHtml"] = function(sHtml) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["setHtml"]++; }; 
	var oEditorWindow = this["oFrameRef"]["contentWindow"],
		oRootNode = UCF_UserAgent["bIsIOS"]() && UCF_UserAgent["bIsSafari"]() ? oEditorWindow["document"]["body"]["firstChild"]["firstChild"] : oEditorWindow["document"]["body"],
		sNormalizedHtml = this["normalizeHtml"](sHtml);

	if (sHtml !== sNormalizedHtml || oRootNode["innerHTML"] !== sNormalizedHtml) {
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](oRootNode, sNormalizedHtml);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["setHtml"] = 0; };

/**
 * Returns the normalized HTML
 */
UCF_RichTextEdit["prototype"]["normalizeHtml"] = function(sHtml) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["normalizeHtml"]++; }; 
	if (UCF_UserAgent["bIsGecko"]()) {
		sHtml = sHtml["replace"](/<(\/?)strong>/g, '<$1b>');
		sHtml = sHtml["replace"](/<(\/?)em>/g, '<$1i>');
	}
	// Paragraph at the end  erase
	if (sHtml["substring"](sHtml["length"] - 8) === '<p> </p>') {
		sHtml = sHtml["substring"](0, sHtml["length"] - 8);
	}
	// This should not happen, <br></br> is not valid HTML
	sHtml = sHtml["replace"](/<br><\/br>/g, '<br/>');
	// The last <br/> in gecko is not necessary
	if (UCF_UserAgent["bIsGecko"]() && sHtml["substring"](sHtml["length"] - 5) === '<br/>') {
		sHtml = sHtml["substring"](0, sHtml["length"] - 5);
	}
	return sHtml;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["normalizeHtml"] = 0; };

/**
 * Applies some reformatting In IE, ENTER set as
 * <p>
 * </p>; replace it with <br/>
 *
 * @type string
 */
UCF_RichTextEdit["prototype"]["sProcessHtml"] = function(sHtml) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["sProcessHtml"]++; }; 
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		if (sHtml !== '<p></p>') {
			sHtml = sHtml["replace"](/<p><\/p>/g, '<p><br/><\/p>');
			sHtml = sHtml["replace"](/<p><strong><\/strong><\/p>/g, '<p><br/><\/p>');
			sHtml = sHtml["replace"](/<p><em><\/em><\/p>/g, '<p><br/><\/p>');
			sHtml = sHtml["replace"](/<p><strong><em><\/em><\/strong><\/p>/g, '<p><br/><\/p>');
		} else {
			sHtml = "";
		}
	}
	return sHtml;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["sProcessHtml"] = 0; };

UCF_RichTextEdit["prototype"]["sGetHtmlOfString"] = function(sHtmlString) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["sGetHtmlOfString"]++; }; 
	var oNode = document["createElement"]('body');
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oNode, sHtmlString);
	return this["sGetHtmlOfNode"](oNode);
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["sGetHtmlOfString"] = 0; };

UCF_RichTextEdit["prototype"]["sGetHtmlOfNode"] = function(oNode) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["sGetHtmlOfNode"]++; }; 
	var aBuffer = [],
		sHtml;

	this["iSerializeCounter"]++;

	if (__UCF_MEASURE__) { UCF_Tracer.measure(START, 'richtextserialize', 'Serializing HTML DOM'); };
	this["serializeXHTML"](aBuffer, oNode);
	sHtml = aBuffer["join"]("");
	if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, 'richtextserialize', 'Serialized in'); };

	// For debugging problems with the resulting XML uncomment this block
	// var oDom = UCF_JsUtil.oParseXMLDocument('<div>' + sHtml + '</div>');
	// if (oDom.parseError && oDom.parseError.errorCode !== 0) debugger;
	// else if (oDom.documentElement.nodeName === 'parsererror') debugger;
	sHtml = this["sProcessHtml"](sHtml);
	return sHtml;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["sGetHtmlOfNode"] = 0; };
/**
 * Reads the HTML from the Iframe and applies some reformatting
 *
 * @type string
 */
UCF_RichTextEdit["prototype"]["sGetHtml"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["sGetHtml"]++; }; 
	var sHtml = this["sGetHtmlOfNode"](UCF_UserAgent["bIsIOS"]() && UCF_UserAgent["bIsSafari"]() ? this["oFrameRef"]["contentWindow"]["document"]["body"]["firstChild"]["firstChild"] : this["oFrameRef"]["contentWindow"]["document"]["body"]);
	this["sCurrentHtml"] = sHtml;
	return sHtml;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["sGetHtml"] = 0; };

/**
 * Map of allowed tags and attributes
 */
UCF_RichTextEdit["prototype"]["oValidTags"] = {
	"abbr": { "empty": false },
	"acronym": { "empty": false },
	"address": { "empty": false },
	"blockquote": { "empty": false },
	"br": { "empty": true },
	"cite": { "empty": false },
	"code": { "empty": false },
	"dfn": { "empty": false },
	"div": { "empty": false, "attrs": ['align'] },
	"em": { "empty": false },
	"h1": { "empty": false },
	"h2": { "empty": false },
	"h3": { "empty": false },
	"h4": { "empty": false },
	"kbd": { "empty": false },
	"p": { "empty": false, "attrs": ['align'] },
	"pre": { "empty": false },
	"q": { "empty": false },
	"samp": { "empty": false },
	"span": { "empty": false, "attrs": ['id'] },
	"strong": { "empty": false },
	'var': { "empty": false },
	"dt": { "empty": false },
	"dd": { "empty": false },
	"ol": { "empty": false },
	"ul": { "empty": false },
	"li": { "empty": false },
	"a": { "empty": false, "attrs": ['href'] },
	"img": { "empty": true, "attrs": ['src'] },
	"u": { "mapped": 'u' },
	"b": { "mapped": 'strong' },
	"i": { "mapped": 'em' }
};

/**
 * Map of unallowed tags which content is omitted
 */
UCF_RichTextEdit["prototype"]["oOmitContentTags"] = {
	"script": true,
	"noscript": true,
	"style": true,
	"select": true,
	"button": true,
	"link": true,
	"iframe": true,
	"object": true
};

/**
 * XML escapes a given string sText
 * @param {string} sText The text to escaped
 * @return {string} The escaped string
 * @private
 */
UCF_RichTextEdit["prototype"]["sXmlEscape"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["sXmlEscape"]++; }; 
	sText = sText["replace"](/\&/g, "&amp;");
	sText = sText["replace"](/\</g, "&lt;");
	sText = sText["replace"](/\"/g, "&quot;");
	return sText;
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["sXmlEscape"] = 0; };

/**
 * Serializes the given DOM node to XHTML subset used by Web Dynpro FormattedText into the given buffer array.
 *
 * 1 ELEMENT_NODE
 * 2 ATTRIBUTE_NODE
 * 3 TEXT_NODE
 * 4 CDATA_SECTION_NODE
 * 5 ENTITY_REFERENCE_NODE
 * 6 ENTITY_NODE
 * 7 PROCESSING_INSTRUCTION_NODE
 * 8 COMMENT_NODE
 * 9 DOCUMENT_NODE
 * 10 DOCUMENT_TYPE_NODE
 * 11 DOCUMENT_FRAGMENT_NODE
 * 12 NOTATION_NODE
 *
 * @param {Array.<string>} aBuffer
 * @param {Element} oNode
 */
UCF_RichTextEdit["prototype"]["serializeXHTML"] = function(aBuffer, oNode) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["serializeXHTML"]++; }; 
	var i;

	switch (oNode["nodeType"]) {
		case 1: // ELEMENT_NODE
			var sTagName = oNode["tagName"]["toLowerCase"](),
				oTagInfo = this["oValidTags"][sTagName];
			if (oTagInfo) {

				// DOM tree can be self referencing in IE (!!!),
				// so mark nodes as visited and break if needed
				if (oNode["cnt"] === this["iSerializeCounter"]) {
					if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Recursive DOM reference ' + sTagName, "RichTextEdit.js(1895): serializeXHTML"); };
					break;
				}
				oNode["cnt"] = this["iSerializeCounter"];

				if (oTagInfo["mapped"]) {
					sTagName = oTagInfo["mapped"];
					oTagInfo = this["oValidTags"][sTagName];
				}

				aBuffer["push"]('<');
				aBuffer["push"](sTagName);
				if (oTagInfo["attrs"]) {
					var aAttributes = oTagInfo["attrs"],
						sName, sValue;
					for (i = 0; i < aAttributes["length"]; i++) {
						sName = aAttributes[i];
						sValue = oNode["getAttribute"](sName);
						if (sValue) {
							aBuffer["push"](' ');
							aBuffer["push"](sName);
							aBuffer["push"]('="');
							aBuffer["push"](this["sXmlEscape"](sValue));
							aBuffer["push"]('"');
						}
					}
				}
				if (oTagInfo["empty"]) {
					aBuffer["push"]('/>');
				} else {
					aBuffer["push"]('>');
				}
			}

			if (!this["oOmitContentTags"][sTagName]) {
				var childNodes = oNode["childNodes"];
				if (childNodes) {
					for (i = 0; i < childNodes["length"]; i++) {
						this["serializeXHTML"](aBuffer, childNodes[i]);
					}
				}
			}

			if (oTagInfo && !oTagInfo["empty"]) {
				aBuffer["push"]('</' + sTagName + '>');
			}
			break;
		case 3: // TEXT_NODE
			aBuffer["push"](this["sXmlEscape"](oNode["nodeValue"]));
			break;
		default: // ANYTHING ELSE
			// omit
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["serializeXHTML"] = 0; };

/**
 * Switch on "contentEditable" or "designMode" attributes.
 */
UCF_RichTextEdit["prototype"]["enableEditMode"] = function(oDoc) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["enableEditMode"]++; }; 
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {

		// int. CSN 079495 2009: Fix was replaced (see 'destroy()')

		// Disable first to avoid misleading focus on editor on IE
		oDoc["body"]["disabled"] = true;
		oDoc["body"]["contentEditable"] = true;
		try {
			oDoc["body"]["disabled"] = false;
			oDoc["body"]["removeAttribute"]('disabled');
		} catch (ex) {
			// ignored
		}

	} else if (UCF_UserAgent["bIsIOS"]() && UCF_UserAgent["bIsSafari"]()) {
		oDoc["body"]["firstChild"]["firstChild"]["contentEditable"] = true;
	} else {
		oDoc["designMode"] = 'On';
		// IMPORTANT... To make Mozilla editor use HTML Tags instead of CSS style attributes !!!
		oDoc["execCommand"]('useCSS', false, true);
		// the above is deprecated and styleWithCSS was introduced
		// oDoc.execCommand('styleWithCSS',true,true);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["enableEditMode"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_RichTextEdit["prototype"]["aAttributeNames"] = ["sHtmlText","bEnabled","bReadonly","sHeight","bHasToolBar","bHasBold","bHasItalics","bHasUnderline","bHasHeadings","bHasIndent","bHasOutdent","bHasOrderedList","bHasUnorderedList","iScrollTop","iScrollLeft","sTooltip","bHasBorder","sToolbarDesign","sAssociatedEditContext","sCustomData","sParagraphSpacing","sLabelledBy","sTextDirection"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_RichTextEdit["prototype"]["aEventNames"] = ["Change","Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_RichTextEdit["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_RichTextEdit["prototype"]["sHtmlText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bReadonly"] = false;

/**
 * @private
 * @type {string}
 */
UCF_RichTextEdit["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bHasToolBar"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bHasBold"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bHasItalics"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bHasUnderline"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bHasHeadings"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bHasIndent"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bHasOutdent"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bHasOrderedList"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bHasUnorderedList"] = false;

/**
 * @private
 * @type {number}
 */
UCF_RichTextEdit["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_RichTextEdit["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_RichTextEdit["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_RichTextEdit["prototype"]["bHasBorder"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ToolbarDesign}
 */
UCF_RichTextEdit["prototype"]["sToolbarDesign"] = "STANDARD";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.EditContext}
 */
UCF_RichTextEdit["prototype"]["sAssociatedEditContext"] = "PARENTEDITABLE";

/**
 * @private
 * @type {string}
 */
UCF_RichTextEdit["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.RichTextEditParagraphSpacing}
 */
UCF_RichTextEdit["prototype"]["sParagraphSpacing"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_RichTextEdit["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ForcedTextDirection}
 */
UCF_RichTextEdit["prototype"]["sTextDirection"] = "INHERIT";

//#JSCOVER_EXCL_START
/** @protected */
UCF_RichTextEdit["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["setDefaultValues"]++; }; 
	this["sHtmlText"] = '';
	this["bEnabled"] = true;
	this["bReadonly"] = false;
	this["sHeight"] = '';
	this["bHasToolBar"] = true;
	this["bHasBold"] = false;
	this["bHasItalics"] = false;
	this["bHasUnderline"] = false;
	this["bHasHeadings"] = false;
	this["bHasIndent"] = false;
	this["bHasOutdent"] = false;
	this["bHasOrderedList"] = false;
	this["bHasUnorderedList"] = false;
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["sTooltip"] = '';
	this["bHasBorder"] = false;
	this["sToolbarDesign"] = "STANDARD";
	this["sAssociatedEditContext"] = "PARENTEDITABLE";
	this["sCustomData"] = '';
	this["sParagraphSpacing"] = "NONE";
	this["sLabelledBy"] = '';
	this["sTextDirection"] = "INHERIT";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("HtmlText", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Readonly", false, true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("HasToolBar", true, true);
		this["setClientProperty"]("HasBold", false, true);
		this["setClientProperty"]("HasItalics", false, true);
		this["setClientProperty"]("HasUnderline", false, true);
		this["setClientProperty"]("HasHeadings", false, true);
		this["setClientProperty"]("HasIndent", false, true);
		this["setClientProperty"]("HasOutdent", false, true);
		this["setClientProperty"]("HasOrderedList", false, true);
		this["setClientProperty"]("HasUnorderedList", false, true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("HasBorder", false, true);
		this["setClientProperty"]("ToolbarDesign", "STANDARD", true);
		this["setClientProperty"]("AssociatedEditContext", "PARENTEDITABLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("ParagraphSpacing", "NONE", true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("TextDirection", "INHERIT", true);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue The changed HTML text
 * @fires RichTextEdit::Change
 */
UCF_RichTextEdit["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "RichTextEdit.js(2203): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "RichTextEdit.js(2204): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "RichTextEdit.js(2205): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "RichTextEdit.js(2206): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "RichTextEdit.js(2207): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("RichTextEdit", "Change", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires RichTextEdit::Scroll
 */
UCF_RichTextEdit["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "RichTextEdit.js(2228): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "RichTextEdit.js(2229): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "RichTextEdit.js(2230): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "RichTextEdit.js(2231): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "RichTextEdit.js(2232): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "RichTextEdit.js(2233): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "RichTextEdit.js(2234): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("RichTextEdit", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_RichTextEdit["_"]["fireScroll"] = 0; };

};
sap["ls"]["preload"]["UCF_RichTooltip"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>

/**
 * 
 * @version
 *
 * @class
 * @extends UCF_LayeredControl
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_RichTooltip(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["UCF_RichTooltip"]++; }; 
	if (arguments["length"] === 0) {
		return;
	}
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "RichTooltip.js(43): UCF_RichTooltip"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RichTooltip.js(44): UCF_RichTooltip"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "RichTooltip.js(45): UCF_RichTooltip"); };
	UCF_LayeredControl["apply"](this, [oDomRef, oLS]);
	this["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["POSITION"]);
	UCF_RichTooltip["oGUI"] = this["oRootRef"] = this["oGetDomRef"](); // must be set for alignment of layered control
};window["UCF_RichTooltip"] = UCF_RichTooltip; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RichTooltip"); UCF_RichTooltip["_"] = {UCF_RichTooltip: 0}; }; ;
UCF_RichTooltip["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_RichTooltip.prototype["sClassName"] = "UCF_RichTooltip";

UCF_RichTooltip["bIsOpened"] = false; // RichTooltip is opened (precondition for shown)
UCF_RichTooltip["bIsClosing"] = false; // RichTooltip is closing
UCF_RichTooltip["bIsShown"] = false; // RichTooltip is shown
UCF_RichTooltip["iLeftTmp"] = null; // old x position of RichTooltip
UCF_RichTooltip["iTopTmp"] = null; // old y position of RichTooltip
UCF_RichTooltip["iLeft"] = 0; // x position of RichTooltip
UCF_RichTooltip["iTop"] = 0; // y position of RichTooltip
UCF_RichTooltip["oGUI"] = null; // RichTooltip GUI
UCF_RichTooltip["sOpenerId"] = ""; // id of the control which opened the RichTooltip

/**
 * Remove emove tooltip from DOM in UCF_Control.initializeRichTooltip()
 * @private
 * @return {boolean}
 */
UCF_RichTooltip["prototype"]["bKeepTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["bKeepTooltip"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["bKeepTooltip"] = 0; };

/**
 * Destructor of RichTooltip
 * @private
 */
UCF_RichTooltip["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["destroy"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RichTooltip destroyed for control: " + this["sOpenerId"], "RichTooltip.js(76): destroy"); };
	this["close"]();
	this["sOpenerId"] = null;
	this["sTimerIdShow"] = null;
	this["sTimerIdClose"] = null;

	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["destroy"] = 0; };

/**
 * Destructor of RichTooltip
 * @private
 * @return {Object} domRef
 */
UCF_RichTooltip["prototype"]["oGetDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["oGetDomRef"]++; }; 
	var sPageId = this["oLS"]["oGetPageInternal"]()["sId"],
		sId = sPageId + "-rttsingleton",
		oDomRef = UCF_DomUtil["$"](sId);
	if (oDomRef != null) return oDomRef;
	var oTemp = document["createElement"]("div");
	// eslint-disable-next-line no-unsanitized/property
	var sInnerHTMLNew = this["getHTMLContent"]();
	//UCF_DomUtil.setInnerHtml(oTemp, sInnerHTML);
	UCF_DomUtil["setInnerHtml"](oTemp, sInnerHTMLNew);
	UCF_DomUtil["setStyle"](UCF_DomUtil["$"](sId), { 'zIndex': UCF_LS["E_LAYERS"]["POPUPMENUS"] });

	var aNodes = oTemp["childNodes"],

		iLen = aNodes["length"],
		oFragment = document["createDocumentFragment"]();

	for (var i = iLen; i--;) {
		oFragment["appendChild"](aNodes[i]);
	}

	var sStaticId = sPageId + "-static",
		oStaticDomRef = UCF_DomUtil["$"](sStaticId);

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oStaticDomRef != null, "oStaticDomRef != null", "RichTooltip.js(114): oGetDomRef"); };
	oStaticDomRef["appendChild"](oFragment);
	oDomRef = UCF_DomUtil["$"](sId);

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPageId + "-rttsingleton" === sId, "sPageId + \"-rttsingleton\" === sId", "RichTooltip.js(118): oGetDomRef"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RichTooltip.js(119): oGetDomRef"); };

	return oDomRef;
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["oGetDomRef"] = 0; };

/**
 * Remove RichTooltip from DOM
 */
UCF_RichTooltip["prototype"]["remove"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["remove"]++; }; 
	UCF_DomUtil["removeFromDom"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["remove"] = 0; };

/**
 * Retrive the HTML content of RichTooltip
 * @return {string} - the HTML
 */
UCF_RichTooltip["prototype"]["getHTMLContent"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["getHTMLContent"]++; }; 

	var sContentHTML, oContentHTML;
	var sPageId = this["oLS"]["oGetPageInternal"]()["sId"],
		sId = sPageId + "-rttsingleton";
	oContentHTML = this["renderContent"](sId);
	sContentHTML = '';
	if (oContentHTML)
		sContentHTML = oContentHTML["outerHTML"];
	return sContentHTML;
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["getHTMLContent"] = 0; };

/**
 * Sets the control id of the control that opened the RichTooltip
 *
 * @param {string} sId
 */
UCF_RichTooltip["prototype"]["setOpenerId"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["setOpenerId"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) === "string", "typeof(sId) === \"string\"", "RichTooltip.js(153): setOpenerId"); };
	this["sOpenerId"] = sId;
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["setOpenerId"] = 0; };

/**
 * Set CSS property float of an element
 * @param {HTMLElement} oElem
 * @param {string} sValue
 */
UCF_RichTooltip["prototype"]["setFloat"] = function(oElem, sValue) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["setFloat"]++; }; 
	if (typeof oElem["style"]["cssFloat"] !== "undefined") { // Safari, Firefox
		oElem["style"]["cssFloat"] = sValue;
	} else { // IE <= 8
		oElem["style"]["styleFloat"] = sValue;
	}
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["setFloat"] = 0; };

/**
 * Shows the RichTooltip at given position for the mouseover event of the browser
 *
 */
UCF_RichTooltip["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["show"]++; }; 
	var oContentHTML;
	var sPageId = this["oLS"]["oGetPageInternal"]()["sId"],
		sId = sPageId + "-rttsingleton";

	oContentHTML = this["renderContent"](sId);
	if (oContentHTML)
		UCF_DomUtil["setInnerHtml"](this["oRootRef"], oContentHTML["innerHTML"]);

	// make visible --> required for this.checkRootRef()
	UCF_DomUtil["setStyle"](this["oRootRef"], {
		"visibility": 'inherit',
		"display": 'block',
		"overflow": 'visible'
	});

	// set iLeft of RichTooltip to mouse cursor x
	this["setLeft"](UCF_RichTooltip["iLeft"]);
	// set iTop to RichTooltip to opener control y + height
	this["oOpenerRef"] = UCF_DomUtil["$"](this["sOpenerId"]);
	var oRect = this["oGetObjectRect"](this["oOpenerRef"]);
	this["setTop"](oRect["top"] + oRect["height"]);

	// update control within DOM
	this["checkRootRef"]();

	// set max width to 320 px
	if (UCF_RichTooltip["oGUI"]["offsetWidth"] > 320) {
		UCF_RichTooltip["oGUI"]["style"]["width"] = "320px";
	}

	// open layered control and implicit set position
	this["openBase"]();

	// save iLeft, iTop for mousemove check
	UCF_RichTooltip["iLeftTmp"] = UCF_RichTooltip["iLeft"];
	UCF_RichTooltip["iTopTmp"] = UCF_RichTooltip["iTop"];

	// set auto close of this RichTooltip after a given time
	var bWithoutCloseTimeout = false;
	this["iAutoHideTimeout"] = 10;
	if (this["iAutoHideTimeout"] > 0 && !bWithoutCloseTimeout) {
		this["prepareClose"](this["iAutoHideTimeout"] * 1000);
	}

	// set state to opened and shown
	this["notifyLayerVisible"]();
	UCF_RichTooltip["bIsShown"] = true;
	UCF_RichTooltip["bIsOpened"] = true;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RichTooltip shown for control: " + this["sOpenerId"], "RichTooltip.js(223): show"); };
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["show"] = 0; };

/**
 * Opens the RichTooltip control
 *
 * @param {int} iLeft left position where the RichTooltip should open
 * @param {int} iTop top position where the RichTooltip should open
 */
UCF_RichTooltip["prototype"]["open"] = function(iLeft, iTop) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["open"]++; }; 
	if (UCF_RichTooltip["bIsOpened"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RichTooltip already opened for a control.", "RichTooltip.js(234): open"); };
		return; // exit if another RichTooltip is opened
	}

	if (!this["sText"] || this["sText"]["length"] <= 0) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RichTooltip has no text! Control: " + this["sOpenerId"], "RichTooltip.js(239): open"); };
		return; // exit if no text is available for RichTooltip
	}

	UCF_RichTooltip["bIsOpened"] = true;
	UCF_RichTooltip["sOpenerId"] = this["sOpenerId"];
	this["attachBrowserEvent"]("mousemove", this["oOpenerRef"]);
	this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "close");
	this["sTimerIdShow"] = UCF_JsUtil["delayedCall"](1000, this, "show");
	UCF_RichTooltip["iLeft"] = iLeft;
	UCF_RichTooltip["iTop"] = iTop;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RichTooltip opened for control: " + this["sOpenerId"], "RichTooltip.js(250): open"); };
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["open"] = 0; };

/**
 * Closes the RichTooltip after a given time. If user interacts in this time
 * the RichTooltip will be shown furthermore
 * @param {int} timeout
 */
UCF_RichTooltip["prototype"]["prepareClose"] = function(timeout) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["prepareClose"]++; }; 
	UCF_RichTooltip["bIsClosing"] = true;
	this["sTimerIdClose"] = UCF_JsUtil["delayedCall"](timeout, this, "close");
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["prepareClose"] = 0; };

/**
 * Closes the RichTooltip
 */
UCF_RichTooltip["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["close"]++; }; 
	// check if a RichTooltip is available for closing
	if (!UCF_RichTooltip["bIsOpened"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RichTooltip is opened for another control: " + this["sOpenerId"] + ". Closing impossible", "RichTooltip.js(269): close"); };
		return;
	}

	/** check if controls wants to close this RichTooltip is the same like the opening one
	 * during tests in some cases the events came in total lack of order and this a check prevents
	 * an unwanted closing.
	 */
	if (UCF_RichTooltip["sOpenerId"] !== this["sOpenerId"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RichTooltip is opened for control: " + UCF_RichTooltip["sOpenerId"] + ". Control: " + this["sOpenerId"] + " tries to close RTT! --> Canceled!", "RichTooltip.js(278): close"); };
		return;
	}

	// this stops delayed calls for closing and showing of RichTooltip
	UCF_JsUtil["clearDelayedCall"](this["sTimerIdClose"]); //clear timer of method 'close'
	UCF_JsUtil["clearDelayedCall"](this["sTimerIdShow"]); //clear timer of method 'show'

	// detach mousemove event
	this["detachBrowserEvent"]("mousemove", this["oOpenerRef"]);

	// hide this RichTooltip
	if (UCF_RichTooltip["bIsShown"]) {
		var oStyle = UCF_RichTooltip["oGUI"]["style"];
		oStyle["left"] = "-70000";
		oStyle["visibility"] = "hidden";
	}

	// detach closing for this RichTooltip when page is closed
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "close");

	// hide Layered Control
	this["closeBase"]();

	// reset global variables to initial state
	UCF_RichTooltip["iLeftTmp"] = null;
	UCF_RichTooltip["iTopTmp"] = null;
	UCF_RichTooltip["bIsShown"] = false;
	UCF_RichTooltip["bIsOpened"] = false;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RichTooltip closed for control: " + this["sOpenerId"], "RichTooltip.js(307): close"); };
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["close"] = 0; };

/**
 * Handles the mouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTooltip["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onmouseover"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RichTooltip onmouseover event catched for control: " + this["sId"], "RichTooltip.js(317): onmouseover"); };

	this["open"](oBrowserEvent["iPageX"](), oBrowserEvent["iPageY"]());
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onmouseover"] = 0; };

/**
 * Handles the mouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTooltip["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onmouseout"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RichTooltip mouseout for control: " + this["sOpenerId"], "RichTooltip.js(329): onmouseout"); };
	this["close"]();
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onmouseout"] = 0; };

/**
 * Handles the mousemove event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTooltip["prototype"]["onmousemove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onmousemove"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RichTooltip.js(340): onmousemove"); };
	var mouseX = oBrowserEvent["iPageX"]();
	var mouseY = oBrowserEvent["iPageY"]();

	/** get mouse pointer x/y and set them as iLeft/iTop of RichTooltip
	 *  until RichTooltip is shown. Result: RichTooltip will have last position though
	 * delayed call of function 'show'
	 */
	if (!UCF_RichTooltip["bIsShown"]) {
		UCF_RichTooltip["iLeftTmp"] = UCF_RichTooltip["iLeft"] = mouseX;
		UCF_RichTooltip["iTopTmp"] = UCF_RichTooltip["iTop"] = mouseY;
	}

	// close RichTooltip when mouse has moved more than 30 pixels in one direction
	if (UCF_RichTooltip["iLeftTmp"] != null && UCF_RichTooltip["iTopTmp"] != null) {
		if ((Math["max"](mouseX, UCF_RichTooltip["iLeftTmp"]) - Math["min"](mouseX, UCF_RichTooltip["iLeftTmp"])) > 30 ||
			(Math["max"](mouseY, UCF_RichTooltip["iTopTmp"]) - Math["min"](mouseY, UCF_RichTooltip["iTopTmp"])) > 30) {
			this["close"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onmousemove"] = 0; };

/**
 * Handles the hotkey event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTooltip["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onlshotkey"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RichTooltip.js(370): onlshotkey"); };

	var iKeyCode = oBrowserEvent["iKeyCode"]();
	if (iKeyCode === UCF_KeyCodes["I"] && oBrowserEvent["bCtrl"]() && !oBrowserEvent["bAlt"]() && oBrowserEvent["bShift"]()) {
		if (this["bOpened"]) {
			this["close"]();
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["cancel"]();
		} else {
			this["open"](true);
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onlshotkey"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTooltip["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RichTooltip.js(395): onlsaccessibility"); };

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, this["sText"], "RichTooltip.js(398): onlsaccessibility"); };

	var sText = "";

	if (this["sTitle"] !== "" && this["sText"] !== "") {
		sText = this["sTitle"] + " - " + this["sText"];
	} else {
		sText = this["sTitle"] + this["sText"];
	}

	oAccessibilityHelper["setRichTooltip"](sText);

	// ARIA
	if (window["UCF_System"]["bIsAria"]) {
		var id = this["sId"]["split"]("-tt")[0];
		if (!id) return;
		var oButtonRef = UCF_DomUtil["$"](id);
		if (!oButtonRef) return;
		var sLabel = oButtonRef["getAttribute"]("aria-label");
		if (this["sText"]) {
			if (sLabel) {
				UCF_AriaStateHelper["setLabel"](oButtonRef, sLabel + ' ' + this["sText"]);
			} else {
				UCF_AriaStateHelper["setLabel"](oButtonRef, this["sText"]);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onlsaccessibility"] = 0; };

/**
 * Handles the onlsescape event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RichTooltip["prototype"]["onlsescape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onlsescape"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RichTooltip.js(435): onlsescape"); };

	if (this["bOpened"]) {
		this["close"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["onlsescape"] = 0; };

/**
 * @private
 * @param {string} sId the id of the control
 * @param {string} sIconSrc the icon src
 * @param {UCF_RenderManager} oRenderManager the render manager
 */
UCF_RichTooltip["prototype"]["renderImage"] = function(sId, sIconSrc, oRenderManager) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["renderImage"]++; }; 
	oRenderManager["write"](new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(undefined, this["oLS"])["sIconFragment"]({
		"Id": sId + '-img',
		"Src": sIconSrc,
		"SrcOnError": '',
		"Width": '',
		"Height": '',
		"Tooltip": '',
		"AlternativeText": '',
		"CssClass": '',
		"CssStyle": ''
	}));
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["renderImage"] = 0; };

/**
 * @private
 * @param {string} sId the id of the control
 * @return {HTMLElement} oRenderManager the render manager
 */
UCF_RichTooltip["prototype"]["renderContent"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["renderContent"]++; }; 
	/** @type {UCF_RenderManager} */
	var oRenderManager;
	/** @type {HTMLElement} */
	var oContentHTML;

	oRenderManager = this["oLS"]["oGetRenderManager"]();
	oRenderManager["write"](this["oLS"]["oGetRenderManager"]()["callFragment"](
		'RichTooltipContentFragment',
		'RichTooltip', {
			"Id": sId,
			"Title": this["sTitle"],
			"ImageSrc": this["sImageSrc"],
			"Text": this["sText"]
		}
	));

	oContentHTML = oRenderManager["oGetElementFromHtml"]();
	oRenderManager["clearBuffer"]();
	return oContentHTML;

};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["renderContent"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_RichTooltip["prototype"]["aAttributeNames"] = ["sTitle","sImageSrc","sText","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_RichTooltip["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_RichTooltip["prototype"]["aMethodNames"] = ["show","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_RichTooltip["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RichTooltip["prototype"]["sImageSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RichTooltip["prototype"]["sText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RichTooltip["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_RichTooltip["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["setDefaultValues"]++; }; 
	this["sTitle"] = '';
	this["sImageSrc"] = '';
	this["sText"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("ImageSrc", '', true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_RichTooltip["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_RoadMap"] = function() {/* global _assert, _trace, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_RoadMapItem */
/// <reference path="./RoadMapItem.js"/>

/**
 * RoadMap control
 * @class
 * @param {HTMLElement} oDomRef DOM reference
 * @param {UCF_LS} oLS LS instance
 */
function UCF_RoadMap(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["UCF_RoadMap"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "RoadMap.js(40): UCF_RoadMap"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RoadMap.js(41): UCF_RoadMap"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "RoadMap.js(42): UCF_RoadMap"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	this["oScrollDomRef"] = UCF_DomUtil["$"](this["sId"] + '-scrl');
	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]);
	this["createItems"]();
	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Select"], this, "onItemSelect");

	this["oItemNavigation"]["setFocusedIndex"](this["oItemNavigation"]["iFocusedIndex"]);
	this["oItemNavigation"]["setNavigateInLoop"](false);

	//UCF_DomUtil.setTabIndex(this.oDomRef, -1);
};window["UCF_RoadMap"] = UCF_RoadMap; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RoadMap"); UCF_RoadMap["_"] = {UCF_RoadMap: 0}; }; ;
UCF_RoadMap["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_RoadMap.prototype["sClassName"] = "UCF_RoadMap";

/**
 * Initialize the RoadMap control
 */
UCF_RoadMap["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["initialize"]++; }; 
	// WORKAROUND: Standards mode correction of wrong values in classes with Scroll=false
	// Same classes (e.g. lsRMDefault) are used in Scroll=true on different elements!
	if (!this["bScroll"] && window["UCF_System"]["sDevice"] === "standards") {
		var aDomItems = this["oScrollDomRef"]["childNodes"];
		for (var i = 0; i < aDomItems["length"]; i++) {
			aDomItems[i]["style"]["cssFloat"] = "none";
			aDomItems[i]["style"]["display"] = "table-cell";
			aDomItems[i]["style"]["verticalAlign"] = "baseline";
		}
	}

	if (this["bScroll"]) {
		if (this["aItems"]["length"] === 0) return;
		if (this["iFirstVisibleItemIdx"] > this["aItems"]["length"] - 1) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Parameter iFirstVisibleItemIdx has an invalid value: must be less or equal than total number of items - 1.", "RoadMap.js(76): initialize"); };
			this["iFirstVisibleItemIdx"] = this["aItems"]["length"] - 1; // eslint-disable-line @ur/no-memory-leaks
			this["setClientProperty"]("FirstVisibleItemIdx", this["iFirstVisibleItemIdx"], true);
		}
		if (this["iFirstVisibleItemIdx"] > 0) {
			this["oScrollDomRef"]["scrollTop"] = this["aItems"][this["iFirstVisibleItemIdx"]]["oDomRef"]["offsetTop"];

		} else if (this["iFirstVisibleItemIdx"] < 0) {
			if (this["oSelected"] != null) {
				if (UCF_UserAgent["bIsFirefox"]()) {
					if (this["oSelected"]["oDomRef"]["offsetTop"] < 3) {
						this["oScrollDomRef"]["scrollTop"] = 0;
					} else {
						this["oScrollDomRef"]["scrollTop"] = this["oSelected"]["oDomRef"]["offsetTop"];
					}
				} else {
					this["oScrollDomRef"]["scrollTop"] = this["oSelected"]["oDomRef"]["offsetTop"];
				}
				this["iFirstVisibleItemIdx"] = this["getFirstVisible"]()["iIndex"];
				this["setClientProperty"]("FirstVisibleItemIdx", this["iFirstVisibleItemIdx"], true);
			}
		}

		this["iControlWidth"] = this["oDomRef"]["offsetWidth"]; // eslint-disable-line @ur/no-memory-leaks

		this["setMoreIndicator"]();
		this["setMinWidth"]();

		this["attachBrowserEvent"]("resize", this["oScrollDomRef"]);
		this["attachBrowserEvent"]("scroll", this["oScrollDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["initialize"] = 0; };

UCF_RoadMap["prototype"]["setMinWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["setMinWidth"]++; }; 
	var oMinWidth = UCF_DomUtil["$"](this["sId"] + "-minwidth");
	oMinWidth["style"]["width"] = this["aItems"][0]["oDomRef"]["offsetWidth"];
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["setMinWidth"] = 0; };

/**
 * Handles the resize event of the browser window
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RoadMap["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onresize"]++; }; 

	if (typeof(this["sTimeOutId"]) !== "undefined") {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
	}
	this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, "onAfterResize"); // eslint-disable-line @ur/no-memory-leaks
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onresize"] = 0; };

/**
 * @private
 */
UCF_RoadMap["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onAfterResize"]++; }; 

	if (this["iControlWidth"] != null && this["iControlWidth"] === this["oDomRef"]["offsetWidth"]) return;

	this["scrollSelectedIntoView"]();
	this["setMoreIndicator"]();
	this["iControlWidth"] = this["oDomRef"]["offsetWidth"];
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onAfterResize"] = 0; };

UCF_RoadMap["prototype"]["scrollSelectedIntoView"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["scrollSelectedIntoView"]++; }; 
	if (this["oSelected"] === null) return;
	this["oScrollDomRef"]["scrollTop"] = this["oSelected"]["oDomRef"]["offsetTop"];
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["scrollSelectedIntoView"] = 0; };

//UCF_RoadMap.prototype.onlsfocus = function(oBrowserEvent) {
//	var oSource = oBrowserEvent.oGetSource();
//
//	if (oSource === this.oDomRef) {
//
//		if (this.oSelected != null) {
//			// delayedCall is workaround for screenreader problem with focus
//			UCF_JsUtil.delayedCall(1, UCF_DomUtil, "focusDomElement", [this.oSelected.oDomRef]);
//			oBrowserEvent.cancel();
//			oBrowserEvent.cancelBubble();
//		}
//		else if (this.aItems && this.aItems.length > 0){
//			UCF_JsUtil.delayedCall(1, UCF_DomUtil, "focusDomElement", [this.aItems[0]]);
//			oBrowserEvent.cancel();
//			oBrowserEvent.cancelBubble();
//		}
//	}
//};

/**
 * Resets the status of the buttons and the more indicator, if scrolling was caused
 * by item navigation
 * @param {BrowserEvent} oBrowserEvent
 */
UCF_RoadMap["prototype"]["onscroll"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onscroll"]++; }; 

	var oSource = UCF_DomUtil["oGetActiveElement"]();
	if (oSource === null) return;

	var oItem = UCF_DomUtil["oGetCTElement"](oSource);

	if (oSource["id"]["indexOf"]("-ma") < 0 && oItem && oItem["getAttribute"]("ct") === "RMI") {
		this["setMoreIndicator"]();
		this["fireScroll"](this["sId"], this["aItems"][this["iFirstVisibleItemIndex"]]["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onscroll"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RoadMap["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RoadMap.js(190): onclick"); };

	var oSource = oBrowserEvent["oGetSource"]();
	var sSourceId = oSource["id"];

	this["resetNaviHoverIcons"](oSource);

	if (this["bScroll"]) {

		if (sSourceId && sSourceId["indexOf"]("-start") > -1)
			this["previousPage"]();
		else if (sSourceId && sSourceId["indexOf"]("-ma") > -1) {
			this["nextPage"]();
		}
	} else {

		if (this["sStartingPoint"] === "MORE" && sSourceId && sSourceId["indexOf"]("-start") > -1)
			this["firePagePrevious"](this["sId"]);
		else if (this["sEndPoint"] === "MORE" && sSourceId && sSourceId["indexOf"]("-end") > -1)
			this["firePageNext"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onclick"] = 0; };

UCF_RoadMap["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onmouseover"]++; }; 
	// Hover-images for "MoreBefore" and "MoreAfter" icons
	var oSourceDom = oBrowserEvent["oGetSource"]();
	var oLV = this["getLastVisible"]();
	if (oSourceDom["id"] === this["sId"] + "-start" && oSourceDom["className"] !== "lsRMicoStrart") {
		if (UCF_DomUtil["bHasClass"](oSourceDom, "lsRMicoMBsub")) {
			UCF_DomUtil["replaceClass"](oSourceDom, "lsRMicoMBsub", "lsRMicoMBsubHover");
		} else if (UCF_DomUtil["bHasClass"](oSourceDom, "lsRMicoMB")) {
			UCF_DomUtil["replaceClass"](oSourceDom, "lsRMicoMB", "lsRMicoMBHover");
		}
	} else if (oLV && oSourceDom["id"] === this["aItems"][oLV["iIndex"]]["sId"] + "-ma") {
		if (UCF_DomUtil["bHasClass"](oSourceDom, "lsRMicoMA2")) {
			UCF_DomUtil["replaceClass"](oSourceDom, "lsRMicoMA2", "lsRMicoMA2Hover");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onmouseover"] = 0; };

UCF_RoadMap["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onmouseout"]++; }; 
	this["resetNaviHoverIcons"](oBrowserEvent["oGetSource"]());
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onmouseout"] = 0; };

/**
 * Reset hover icons on mouseout or click.
 * @param {Object} o
 */
UCF_RoadMap["prototype"]["resetNaviHoverIcons"] = function(o) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["resetNaviHoverIcons"]++; }; 
	var oLV = this["getLastVisible"]();
	if (o["id"] === this["sId"] + "-start") {
		if (UCF_DomUtil["bHasClass"](o, "lsRMicoMBsubHover")) {
			UCF_DomUtil["replaceClass"](o, "lsRMicoMBsubHover", "lsRMicoMBsub");
		} else if (UCF_DomUtil["bHasClass"](o, "lsRMicoMBHover")) {
			UCF_DomUtil["replaceClass"](o, "lsRMicoMBHover", "lsRMicoMB");
		}
	} else if (oLV && o["id"] === this["aItems"][oLV["iIndex"]]["sId"] + "-ma") {
		if (UCF_DomUtil["bHasClass"](o, "lsRMicoMA2Hover")) {
			UCF_DomUtil["replaceClass"](o, "lsRMicoMA2Hover", "lsRMicoMA2");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["resetNaviHoverIcons"] = 0; };

/**
 * Scrolls to previous page and fires scroll events with first and last visible items index
 */
UCF_RoadMap["prototype"]["previousPage"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["previousPage"]++; }; 
	var oBtn = UCF_DomUtil["$"](this["sId"] + "-start");
	if (UCF_DomUtil["bHasClass"](oBtn, "lsRMicoStrart")) return;

	this["oScrollDomRef"]["scrollTop"] -= this["oScrollDomRef"]["offsetHeight"];
	this["setMoreIndicator"]();
	this["fireScroll"](this["sId"], this["aItems"][this["iFirstVisibleItemIndex"]]["sId"]);

};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["previousPage"] = 0; };

/**
 * Scrolls to next page and fires scroll events with first and last visible items id
 */
UCF_RoadMap["prototype"]["nextPage"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["nextPage"]++; }; 

	this["oScrollDomRef"]["scrollTop"] += this["oScrollDomRef"]["offsetHeight"];
	this["setMoreIndicator"]();
	this["fireScroll"](this["sId"], this["aItems"][this["iFirstVisibleItemIndex"]]["sId"]);

};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["nextPage"] = 0; };

/**
 * Sets the left and right more indicators
 */
UCF_RoadMap["prototype"]["setMoreIndicator"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["setMoreIndicator"]++; }; 

	var iFirst = this["iFirstVisibleItemIdx"];

	var oFirst = (iFirst === -1 || Math["abs"](this["aItems"][iFirst]["oDomRef"]["offsetTop"] - this["oScrollDomRef"]["scrollTop"]) > 5) ?
		this["getFirstVisible"]() : this["aItems"][this["iFirstVisibleItemIdx"]];

	var oMoreStart = UCF_DomUtil["$"](this["sId"] + "-start");

	this["iFirstVisibleItemIndex"] = oFirst["iIndex"]; // eslint-disable-line @ur/no-memory-leaks
	if (oFirst && !UCF_UserAgent["bIsFirefox"]()) {
		//_trace(INFO, "RoadMap - " + this.iFirstVisibleItemIndex + "-  first Visible Item  offset- " + oFirst.oDomRef.offsetTop);
		this["oScrollDomRef"]["scrollTop"] = oFirst["oDomRef"]["offsetTop"];
	}
	if (this["oScrollDomRef"]["scrollTop"] > 0) {

		if (oFirst["sStepType"] === "SUBSTEP" || oFirst["sStepType"] === "ROUNDTRIPEND")
			oMoreStart["className"] = "lsRMicoMBsub";
		else
			oMoreStart["className"] = "lsRMicoMB";

	} else {
		oMoreStart["className"] = "lsRMicoStrart lsRMStartIconScrollingOn";
	}

	var oMoreAfter;
	if (this["oLast"] != null && this["oLast"]["iIndex"] < this["aItems"]["length"] - 1) {
		oMoreAfter = UCF_DomUtil["$"](this["oLast"]["sId"] + "-ma");
		UCF_DomUtil["removeClass"](oMoreAfter, "lsRMicoMA2");
	}

	var oLast = this["getLastVisible"]();
	// _trace(INFO, "RoadMap - " + this.sId + "-  last Visible Item - " + oLast.iIndex);
	if (oLast) {
		if (oLast["iIndex"] < this["aItems"]["length"] - 1) {
			oMoreAfter = UCF_DomUtil["$"](oLast["sId"] + "-ma");
			UCF_DomUtil["addClass"](oMoreAfter, "lsRMicoMA2");
		}
		this["oLast"] = oLast;
	}
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["setMoreIndicator"] = 0; };

/**
 * Gets the first visible items
 *
 * @type {UCF_RoadMapItem}
 */
UCF_RoadMap["prototype"]["getFirstVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["getFirstVisible"]++; }; 
	for (var i = 0; i < this["aItems"]["length"]; i++) {
		// for iPad & FF, the ScrollTop differ 1-2 px than the offsetTop
		if (Math["abs"](this["oScrollDomRef"]["scrollTop"] - this["aItems"][i]["oDomRef"]["offsetTop"]) < 5) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "RoadMap - " + this["sId"] + "-  first Visible Item index - " + this["aItems"][i]["iIndex"], "RoadMap.js(331): getFirstVisible"); };
			//this.oScrollDomRef.scrollTop = this.aItems[i].oDomRef.offsetTop;
			return this["aItems"][i];
		}
	}

	return undefined;
	//return this.aItems[0];
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["getFirstVisible"] = 0; };

UCF_RoadMap["prototype"]["bIsLegacy"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["bIsLegacy"]++; }; 
	return UCF_ResourceUtil["oGetMetadataFromTheme"]('lsRoadmap__metadata')["bIsLegacy"];
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["bIsLegacy"] = 0; };

/**
 * Gets the last visible items
 *
 * @type {UCF_RoadMapItem}
 */
UCF_RoadMap["prototype"]["getLastVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["getLastVisible"]++; }; 
	var self = this;
	var width = 0;
	var backArrowWidth;
	var forwardArrowWidth;

	// Empty - no items
	var oFirstVisible = self["getFirstVisible"]();
	if (!oFirstVisible) return undefined;

	for (var i = oFirstVisible["iIndex"]; i < self["aItems"]["length"]; i++) {
		if (self["bIsLegacy"]()) {
			backArrowWidth = 15;
			forwardArrowWidth = 15;
		} else {
			backArrowWidth = oFirstVisible["iIndex"] > 0 ? 24 : 0;
			forwardArrowWidth = i === self["aItems"]["length"] - 1 ? 0 : 26;
		}

		width = width + self["aItems"][i]["oDomRef"]["firstChild"]["scrollWidth"];

		if (width + backArrowWidth + forwardArrowWidth > self["oDomRef"]["offsetWidth"]) {
			return i < self["aItems"]["length"] ? self["aItems"][i - 1] : self["aItems"][i];
		} else if (width + backArrowWidth + forwardArrowWidth === self["oDomRef"]["offsetWidth"]) {
			return self["bIsLegacy"]() && self["aItems"]["length"] > 1 ? self["aItems"][i - 1] : self["aItems"][i];
		} else if (i === self["aItems"]["length"] - 1) {
			return self["aItems"][i];
		}
	}
	return undefined;
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["getLastVisible"] = 0; };

/**
 * Sets the design of a selected RoadMap step
 *
 * @param {UCF_RoadMapItem} oNewStep
 *
 * @private
 */
UCF_RoadMap["prototype"]["setSelectedDesign"] = function(oNewStep) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["setSelectedDesign"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oNewStep instanceof UCF_RoadMapItem, "oNewStep instanceof UCF_RoadMapItem", "RoadMap.js(391): setSelectedDesign"); };

	if (oNewStep === null || oNewStep["sStepDesign"] !== "DEFAULT" || !this["bClientSelect"] || oNewStep["bIsInteractive"] === false) return;

	//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	var aNewStep = (this["bScroll"]) ? oNewStep["oDomRef"]["firstChild"]["childNodes"] : oNewStep["oDomRef"]["childNodes"];

	// The RoadMapItem customstyle class may contain the string "Hover"...
	// remove it before the manipulation of the className string
	var sTmpClassName = aNewStep[0]["className"];
	if (oNewStep["sCustomStyle"]) {
		sTmpClassName = sTmpClassName["split"](oNewStep["sCustomStyle"])[1];
	}
	if (sTmpClassName["indexOf"]("Hover") > -1) {
		sTmpClassName = sTmpClassName["split"]("Hover")[0];
	}
	aNewStep[0]["className"] = oNewStep["sCustomStyle"] ? oNewStep["sCustomStyle"] + sTmpClassName : sTmpClassName;

	sTmpClassName = aNewStep[1]["className"];
	if (oNewStep["sCustomStyle"]) {
		sTmpClassName = sTmpClassName["split"](oNewStep["sCustomStyle"])[1];
	}
	if (sTmpClassName["indexOf"]("Hover") > -1) {
		sTmpClassName = sTmpClassName["split"]("Hover")[0];
	}
	aNewStep[1]["className"] = oNewStep["sCustomStyle"] ? oNewStep["sCustomStyle"] + sTmpClassName : sTmpClassName;

	aNewStep[0]["className"] = aNewStep[0]["className"] + "Sel";
	aNewStep[1]["className"] = aNewStep[1]["className"] + "Sel";

	var oRoundTripImg;
	if (oNewStep["sStepType"]["indexOf"]("ROUNDTRIP") > -1) {
		oRoundTripImg = UCF_DomUtil["$"](oNewStep["sId"] + "-rtImg");
		if (oRoundTripImg["className"]["indexOf"]("Sel") === -1) {
			oRoundTripImg["className"] = oRoundTripImg["className"] + "Sel";
		}
	}

	if (this["oSelected"] != null) {

		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
		var aOldStep = (this["bScroll"]) ? this["oSelected"]["oDomRef"]["firstChild"]["childNodes"] : this["oSelected"]["oDomRef"]["childNodes"];
		// The RoadMapItem customstyle class may contain the string "Set"...
		// remove it before the manipulation of the className string
		sTmpClassName = aOldStep[0]["className"];
		if (aOldStep["sCustomStyle"]) {
			sTmpClassName = sTmpClassName["split"](oNewStep["sCustomStyle"])[1];
		}
		sTmpClassName = sTmpClassName["split"]("Sel")[0];
		aOldStep[0]["className"] = aOldStep["sCustomStyle"] ? aOldStep["sCustomStyle"] + sTmpClassName : sTmpClassName;

		sTmpClassName = aOldStep[1]["className"];
		if (aOldStep["sCustomStyle"]) {
			sTmpClassName = sTmpClassName["split"](oNewStep["sCustomStyle"])[1];
		}
		sTmpClassName = sTmpClassName["split"]("Sel")[0];
		aOldStep[1]["className"] = aOldStep["sCustomStyle"] ? aOldStep["sCustomStyle"] + sTmpClassName : sTmpClassName;

		if (this["oSelected"]["sStepType"]["indexOf"]("ROUNDTRIP") > -1) {
			oRoundTripImg = UCF_DomUtil["$"](this["oSelected"]["sId"] + "-rtImg");
			if (oRoundTripImg["className"]["indexOf"]("Sel") > -1) {
				oRoundTripImg["className"] = oRoundTripImg["className"]["split"]("Sel")[0];
			}
		}

		this["oSelected"]["sStepDesign"] = "DEFAULT";
	}

	this["oSelected"] = oNewStep;
	oNewStep["sStepDesign"] = "SELECTED";

	// Do we realy need this ?
	// if (this.bScroll) this.setMoreIndicator();
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["setSelectedDesign"] = 0; };

/**
 * Sets the hover design classes
 *
 * @param {UCF_RoadMapItem} oHoverStep
 * @param {boolean} bOverOut
 *
 * @private
 */
UCF_RoadMap["prototype"]["setHoveredDesign"] = function(oHoverStep, bOverOut) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["setHoveredDesign"]++; }; 
	if (bOverOut) {
		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
		var oStep = (oHoverStep["oGetParent"]()["bScroll"]) ? oHoverStep["oDomRef"]["firstChild"]["childNodes"][1] : oHoverStep["oDomRef"]["childNodes"][1],
			oStepImg = (oHoverStep["oGetParent"]()["bScroll"]) ? oHoverStep["oDomRef"]["firstChild"]["childNodes"][0] : oHoverStep["oDomRef"]["childNodes"][0];

		if (oHoverStep["sStepDesign"] === "SELECTED" || oHoverStep["sStepDesign"] === "DISABLED" ||
			oHoverStep["bIsInteractive"] === false) return;

		oHoverStep["sStylesImg"] = oStepImg["className"];
		oHoverStep["oHoverImg"] = oStepImg;
		oHoverStep["sStyles"] = oStep["className"];
		oHoverStep["oHover"] = oStep;
		oHoverStep["oHover"]["className"] = oHoverStep["oHover"]["className"] + "Hover";
		oHoverStep["oHoverImg"]["className"] = oHoverStep["oHoverImg"]["className"] + "Hover";

		// These are the small arrow ions: Use the "selection" state icons also for the hover effect.
		// Notes: This was added for the new Corba theme. All other themes have the same icons for selected and unselected !
		oHoverStep["oRtImg"] = UCF_DomUtil["$"](oHoverStep["sId"] + "-rtImg");
		if (oHoverStep["oRtImg"]) {
			if (oHoverStep["oRtImg"]["className"]["indexOf"]("Sel") === -1) {
				oHoverStep["sStylesRtImg"] = oHoverStep["oRtImg"]["className"];
				oHoverStep["oRtImg"]["className"] = oHoverStep["oRtImg"]["className"] + "Sel";
			} else {
				oHoverStep["oRtImg"] = null;
			}
		}
	} else {
		if (oHoverStep["oHover"] === null || oHoverStep["oHover"] === undefined || oHoverStep["sStyles"] === "" || oHoverStep["sStepDesign"] === "SELECTED" ||
			oHoverStep["sStepDesign"] === "DISABLED" || oHoverStep["bIsInteractive"] === false) return;

		oHoverStep["oHover"]["className"] = oHoverStep["sStyles"];
		if (oHoverStep["oHoverImg"] != null) {
			oHoverStep["oHoverImg"]["className"] = oHoverStep["sStylesImg"];
		}
		if (oHoverStep["oRtImg"] != null) {
			oHoverStep["oRtImg"]["className"] = oHoverStep["sStylesRtImg"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["setHoveredDesign"] = 0; };

/**
 * The select event triggered by an item.
 *
 * @param {UCF_Event} oEvent
 */
UCF_RoadMap["prototype"]["onItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onItemSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "RoadMap.js(521): onItemSelect"); };

	var oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent"),
		sSourceId = oBrowserEvent["oGetSource"]()["getAttribute"]("id");

	if (sSourceId && sSourceId["indexOf"]("-ma") > -1) return;

	var oItem = oEvent["oGetParam"]("oItem");

	if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_RoadMapItem")) {

		if (oItem["sStepDesign"] === "DEFAULT") {
			if (window["UCF_System"]["bIsAria"]) {
				if (this["oSelected"]) {
					//UCF_AriaStateHelper.setSelected(this.oSelected.oDomRef, false);
					UCF_AriaStateHelper["setOrRemoveAttribute"](this["oSelected"]["oDomRef"], 'aria-current'); // Remove
				}
				//UCF_AriaStateHelper.setSelected(oItem.oDomRef, true);
				UCF_AriaStateHelper["setCurrent"](oItem["oDomRef"], 'step');
			}
			this["fireSelect"](this["sId"], oItem["sId"]);
			this["setSelectedDesign"](oItem);
		} else if (oItem["sStepDesign"] === "DISABLED") {
			// TODO: We should re-set the focus to the first/last item that is enabled, shoudn't we?
			// if (oBrowserEvent.iKeyCode() === UCF_KeyCodes.HOME) {
			// }
			// else if (oBrowserEvent.iKeyCode() === UCF_KeyCodes.END) {
			// }
		}

		if (window["UCF_System"]["bIs508"] && oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["SPACE"]) {
			UCF_DomUtil["refocusDomElement"](oItem["oDomRef"]);
		}
	}
	//otherwise oSource is Roadmap when item navigation tries to check whether
	//an item was clicked
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onItemSelect"] = 0; };

/**
 * Creates two arrays with items. One for the item navigation and a second for the scrolling mechanism.
 */
UCF_RoadMap["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["createItems"]++; }; 
	/** @type {Array} */
	var aDomItems = UCF_DomUtil["childNodes"](this["oScrollDomRef"]);
	this["oSelected"] = null;
	this["aItems"] = new Array();

	if (aDomItems["length"] === 0) return;

	if (UCF_StringUtil["bEndsWith"](aDomItems[0]["id"], '-start')) {
		aDomItems["splice"](0, 1);
	}
	if (UCF_StringUtil["bEndsWith"](aDomItems[aDomItems["length"] - 1]["id"], '-end')) {
		aDomItems["splice"](aDomItems["length"] - 1, 1);
	}

	for (var i = 0; i < aDomItems["length"]; i++) {
		var oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[i], true);

		if (oItem === null) continue;

		if (oItem["sStepDesign"] === "SELECTED")
			this["oSelected"] = oItem;

		oItem["iIndex"] = this["aItems"]["length"];
		this["aItems"]["push"](oItem);
		oItem["oRM"] = this;
		oItem["bEnabled"] = oItem["sStepDesign"] !== "DISABLED";
		if (oItem["sStepDesign"] !== "DISABLED" || window["UCF_System"]["bIs508"] || window["UCF_System"]["bIsAria"]) {
			this["oItemNavigation"]["addItem"](oItem, (oItem["sStepDesign"] === "SELECTED"));
		}

		if (window["UCF_System"]["bIsAria"]) {
			var oDom = aDomItems[i];
			//UCF_AriaStateHelper.setSelected(oDom, oItem.sStepDesign === "SELECTED");
			if (oItem["sStepDesign"] === "SELECTED") UCF_AriaStateHelper["setCurrent"](oDom, 'step');
			UCF_AriaStateHelper["setPosinset"](oDom, i + 1);
			UCF_AriaStateHelper["setSetsize"](oDom, aDomItems["length"]);
			if (oItem["sStepType"] === "SUBSTEP") {
				oDom["setAttribute"]("aria-level", "2");
			} else {
				oDom["setAttribute"]("aria-level", "1");
			}
		}

		// Use of special classes and special calculations used only in Belize (Item height > 50)
		// According to API docu, the StepName should only contain a single char, but ...
		// in reality longer texts are used and the StepName can even be longer than the StepDescription (Title).
		// => Render circle-shaped steps only for 1-character step names. Others will have a rectangle with border-radius.
		if (window["UCF_System"]["sDevice"] === "standards" &&
			aDomItems[i]["clientHeight"] > 50 && UCF_StringUtil["sTrim"](oItem["sStepName"])["length"] > 2) {
			var MIN_LINE_LENGTH = 5;
			var LINE_DIST = 10; // The line ends 10px before the step-box/circle
			UCF_DomUtil["addClass"](oItem["oDomRef"], "lsRMLongStepName");
			var oHiddenText = UCF_DomUtil["$"](oItem["sId"] + "-stn"); // Hidden DIV that pushes the width, if the RoadMapItem.StepName is longer than 1 character
			UCF_DomUtil["addClass"](oHiddenText, "lsRMLongStepNameHidden"); // In Belize styles the "display:none" is removed

			var fNoRuleAccessWorkaround = function() {
				// Only minimal width of the line regardless of text length...
				UCF_DomUtil["addClass"](oItem["oDomRef"], "lsRMLongStepNameWorkaround");
			};

			var oStyleSheet = UCF_ResourceUtil["oGetLightspeedCssStylesheet"]();
			try {
				oStyleSheet["rules"]; // eslint-disable-line no-unused-expressions
			} catch (e) {
				// !!!
				// Not (no longer?) allowed in Chrome to acces stylesheet.rules in case of
				// WDA in FLP with different origins of window.document and stylesheet
				// !!!
				oStyleSheet = null;
			}

			if (oStyleSheet) {
				// Unfortunately we have to calculate the item width and the length of the lines in Belize
				// because there is no "string length" expression available in renderer and no selectors available in CSS...
				var iStepNameWidth = UCF_DomUtil["$"](oItem["sId"] + "-box")["offsetWidth"]; // Text width including padding
				var iPadding = parseInt(UCF_DomUtil["sGetCurrentStyle"](oHiddenText["parentNode"], "padding-left")) + parseInt(UCF_DomUtil["sGetCurrentStyle"](oHiddenText["parentNode"], "padding-right"));
				var iDescriptionWidth = oHiddenText["parentNode"]["offsetWidth"] - iPadding; // Description text width without padding
				var iTextWidth = Math["floor"](Math["max"](iStepNameWidth, iDescriptionWidth));
				var iWidth = iTextWidth + 2 * ( /*MIN_LINE_LENGTH +*/ LINE_DIST);
				var iLineLength = Math["max"](Math["floor"]((iWidth - iStepNameWidth - 2 * LINE_DIST) / 2) + iPadding / 2, MIN_LINE_LENGTH);

				// Apply width and line-length to the DOM / styles
				// Unfortunately the length is the property of a pseudo :before / :after => must add rules to the stylesheet object
				oHiddenText["parentNode"]["style"]["minWidth"] = iWidth + "px";
				var aAllRules = UCF_JsUtil["map"](["lsRMTitle", "lsRMTitleHover", "lsRMTitleSel", "lsRMTitleDsbl"], function(s) {
					return ".lsRMLongStepName[id='" + oItem["sId"] + "'] ." + s; // .replace(/\./g, "\\.")
				});
				UCF_JsUtil["forEach"](["before", "after"], function(p) {
					try {
						oStyleSheet["insertRule"](UCF_JsUtil["map"](aAllRules, function(s) {
							return s + ":" + p;
						})["join"](",") + " { width: " + iLineLength + "px }", 0);
					} catch (e) {
						// CSS ID-selector does not work if LSX or WDA "stable IDs" contain dots
						// (escaping with \. is not working, maybe because of less compiler(?))
						fNoRuleAccessWorkaround();
					}
				});
			} else {
				// Workaround (No access to stylesheet.rules): Use fixed minimal lines
				fNoRuleAccessWorkaround();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["createItems"] = 0; };

/**
 * Sets the correct ACC text
 * @param {BrowserEvent} oBrowserEvent
 */
UCF_RoadMap["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "RoadMap.js(676): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSourceControl"]();

	if (!UCF_JsUtil["bInstanceOf"](oSource, "UCF_RoadMapItem")) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		sCt = "RM_STN";

	var sText = oSource["sStepDescription"];
	oAccessibilityHelper["setText"](sText);

	switch (oSource["sStepType"]) {
		case "ROUNDTRIPCLOSED":
			sCt = "RM_RTCLO";
			break;
		case "ROUNDTRIPSTART":
			sCt = "RM_RTSTR";
			break;
		case "ROUNDTRIPEND":
			sCt = "RM_RTEND";
			break;
		case "SUBSTEP":
			sCt = "RM_SUB";
			break;
	}

	oAccessibilityHelper["setParentControlType"]("RM");
	oAccessibilityHelper["setParentTooltip"](this["sTooltip"]);
	oAccessibilityHelper["setParentText"](this["sAccessibilityDescription"]);
	oAccessibilityHelper["setControlType"](sCt);
	oAccessibilityHelper["setItemCount"](this["oItemNavigation"]["aItems"]["length"]);
	oAccessibilityHelper["setItemIndex"](oSource["iIndex"] + 1);
	oAccessibilityHelper["setEnabled"](oSource["sStepDesign"] !== "DISABLED");
	//oAccessibilityHelper.setSelected(oSource.sStepDesign === "SELECTED");
	if (oSource["sStepDesign"] === "SELECTED") UCF_AriaStateHelper["setCurrent"](oSource["oDomRef"], 'step');
	oAccessibilityHelper["setReadonly"](!oSource["bIsInteractive"]);
	oAccessibilityHelper["addTooltip"](oSource["sTooltip"]);
	oAccessibilityHelper["addTutor"]("LRNAV_TUT");

	if (oSource["bIsInteractive"])
		oAccessibilityHelper["addEnabledTutor"]("SELECT_TUT", oSource["sStepDesign"] === "DEFAULT");

};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 */
UCF_RoadMap["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["destroy"]++; }; 
	if (this["bScroll"]) {
		this["detachBrowserEvent"]("resize", this["oScrollDomRef"]);
		this["detachBrowserEvent"]("scroll", this["oScrollDomRef"]);
	}
	this["oItemNavigation"]["detachEvent"](this["oItemNavigation"]["E_EVENTS"]["Select"], this);
	if (this["oItemNavigation"]) {
		this["oItemNavigation"]["destroy"]();
		this["oItemNavigation"] = null;
	}
	this["oScrollDomRef"] = null;
	this["aItems"] = null;
	this["oSelected"] = null;
	this["oLast"] = null;
	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_RoadMap["prototype"]["aAttributeNames"] = ["sAccessibilityDescription","sStartingPoint","sEndPoint","sVisibility","bScroll","iFirstVisibleItemIdx","sTooltip","bClientSelect","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_RoadMap["prototype"]["aEventNames"] = ["Select","Scroll","PagePrevious","PageNext"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_RoadMap["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_RoadMap["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.RoadMapEdgesDesign}
 */
UCF_RoadMap["prototype"]["sStartingPoint"] = "DEFAULT";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.RoadMapEdgesDesign}
 */
UCF_RoadMap["prototype"]["sEndPoint"] = "DEFAULT";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_RoadMap["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_RoadMap["prototype"]["bScroll"] = true;

/**
 * @private
 * @type {number}
 */
UCF_RoadMap["prototype"]["iFirstVisibleItemIdx"] = -1;

/**
 * @private
 * @type {string}
 */
UCF_RoadMap["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_RoadMap["prototype"]["bClientSelect"] = true;

/**
 * @private
 * @type {string}
 */
UCF_RoadMap["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_RoadMap["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["setDefaultValues"]++; }; 
	this["sAccessibilityDescription"] = '';
	this["sStartingPoint"] = "DEFAULT";
	this["sEndPoint"] = "DEFAULT";
	this["sVisibility"] = "VISIBLE";
	this["bScroll"] = true;
	this["iFirstVisibleItemIdx"] = -1;
	this["sTooltip"] = '';
	this["bClientSelect"] = true;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("StartingPoint", "DEFAULT", true);
		this["setClientProperty"]("EndPoint", "DEFAULT", true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Scroll", true, true);
		this["setClientProperty"]("FirstVisibleItemIdx", -1, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("ClientSelect", true, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier the RoadMap control (Root object).
 * @param {string} sItemId Identifier of a RoadMap item (step). 
 * @fires RoadMap::Select
 */
UCF_RoadMap["prototype"]["fireSelect"] = function(sId, sItemId) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, ItemId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "RoadMap.js(856): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "RoadMap.js(857): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "RoadMap.js(858): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "RoadMap.js(859): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "RoadMap.js(860): fireSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	this["fireSemanticEvent"]("RoadMap", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier the PhaseIndicator control (Root object).
 * @param {string} sFirstVisibleItemId Identifier of the first visible PhaseIndicator item. 
 * @fires RoadMap::Scroll
 */
UCF_RoadMap["prototype"]["fireScroll"] = function(sId, sFirstVisibleItemId) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, FirstVisibleItemId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "RoadMap.js(887): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "RoadMap.js(888): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "RoadMap.js(889): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFirstVisibleItemId != null, "sFirstVisibleItemId != null", "RoadMap.js(890): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFirstVisibleItemId) == "string", "typeof(sFirstVisibleItemId) == \"string\"", "RoadMap.js(891): fireScroll"); };
	mParams = {
		"Id": sId,
		"FirstVisibleItemId": sFirstVisibleItemId
	};
	
	if (sFirstVisibleItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sFirstVisibleItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "FirstVisibleItemId");
			}
		}
	this["fireSemanticEvent"]("RoadMap", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier the PhaseIndicator control (Root object).
 * @fires RoadMap::PagePrevious
 */
UCF_RoadMap["prototype"]["firePagePrevious"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["firePagePrevious"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "RoadMap.js(915): firePagePrevious"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "RoadMap.js(916): firePagePrevious"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "RoadMap.js(917): firePagePrevious"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("RoadMap", "PagePrevious", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["firePagePrevious"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier the PhaseIndicator control (Root object).
 * @fires RoadMap::PageNext
 */
UCF_RoadMap["prototype"]["firePageNext"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["firePageNext"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "RoadMap.js(934): firePageNext"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "RoadMap.js(935): firePageNext"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "RoadMap.js(936): firePageNext"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("RoadMap", "PageNext", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_RoadMap["_"]["firePageNext"] = 0; };

};
sap["ls"]["preload"]["UCF_RoadMapItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * RoadMapItem
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef DOM reference
 * @param {UCF_LS} oLS LS instance
 */
function UCF_RoadMapItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["UCF_RoadMapItem"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "RoadMapItem.js(19): UCF_RoadMapItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "RoadMapItem.js(20): UCF_RoadMapItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "RoadMapItem.js(21): UCF_RoadMapItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_RoadMapItem"] = UCF_RoadMapItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_RoadMapItem"); UCF_RoadMapItem["_"] = {UCF_RoadMapItem: 0}; }; ;

UCF_RoadMapItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_RoadMapItem.prototype["sClassName"] = "UCF_RoadMapItem";

/**
 * Handles the onmouseover event of the browser.
 * Creates a hover effect with the title of the step.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RoadMapItem["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["onmouseover"]++; }; 
	var sSourceId = oBrowserEvent["oGetSource"]()["id"];
	if (sSourceId["indexOf"]("-ma") > -1) return;

	if (this["oRM"]) this["oRM"]["setHoveredDesign"](this, true);
};;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["onmouseover"] = 0; };

/**
 * Handles the onmouseout event of the browser.
 * Takes away the hover effect from the title of the step.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_RoadMapItem["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["onmouseout"]++; }; 
	if (this["oRM"]) this["oRM"]["setHoveredDesign"](this, false);
};;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["onmouseout"] = 0; };

UCF_RoadMapItem["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["onlsfocus"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["onlsfocus"] = 0; };

/**
 * Overwrite UCF_Control method: Returns false if item is not visible because of overflow (width too small for all items),
 * fallback to super otherwise.
 * @private
 */
UCF_RoadMapItem["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["bIsVisible"]++; }; 
	if (this["oDomRef"]["offsetTop"] > 0) {
		return false;
	} else {
		return UCF_Control.prototype["bIsVisible"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["bIsVisible"] = 0; };

UCF_RoadMapItem["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["focus"]++; }; 
	UCF_DomUtil["focusDomElement"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["focus"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_RoadMapItem["prototype"]["aAttributeNames"] = ["sTooltip","sStepDesign","sStepType","sStepName","sStepDescription","bIsInteractive","bDynamicStep","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_RoadMapItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_RoadMapItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_RoadMapItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.RoadMapStepDesign}
 */
UCF_RoadMapItem["prototype"]["sStepDesign"] = "DEFAULT";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.RoadMapStepType}
 */
UCF_RoadMapItem["prototype"]["sStepType"] = "STANDARDSTEP";

/**
 * @private
 * @type {string}
 */
UCF_RoadMapItem["prototype"]["sStepName"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RoadMapItem["prototype"]["sStepDescription"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_RoadMapItem["prototype"]["bIsInteractive"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_RoadMapItem["prototype"]["bDynamicStep"] = false;

/**
 * @private
 * @type {string}
 */
UCF_RoadMapItem["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_RoadMapItem["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_RoadMapItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sStepDesign"] = "DEFAULT";
	this["sStepType"] = "STANDARDSTEP";
	this["sStepName"] = '';
	this["sStepDescription"] = '';
	this["bIsInteractive"] = false;
	this["bDynamicStep"] = false;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("StepDesign", "DEFAULT", true);
		this["setClientProperty"]("StepType", "STANDARDSTEP", true);
		this["setClientProperty"]("StepName", '', true);
		this["setClientProperty"]("StepDescription", '', true);
		this["setClientProperty"]("IsInteractive", false, true);
		this["setClientProperty"]("DynamicStep", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_RoadMapItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Ruler"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../../core/Object.js"/>
/* global UCF_LS */
/// <reference path="../../../core/LS.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {string} sType
 * @param {Object} oCustomData
 * @param {Object} oOwner
 */
function UCF_Ruler(oDomRef, sType, oCustomData, oOwner) {if (__UCF_COVERAGE__) { UCF_Ruler["_"]["UCF_Ruler"]++; }; 
	UCF_Object["apply"](this);
	this["oDomRef"] = oDomRef;
	this["sType"] = sType;
	this["oCustomData"] = oCustomData;
	this["oOwner"] = oOwner;
	this["iBaseLine"] = 0;
};window["UCF_Ruler"] = UCF_Ruler; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Ruler"); UCF_Ruler["_"] = {UCF_Ruler: 0}; }; ;
UCF_Ruler["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Ruler.prototype["sClassName"] = "UCF_Ruler";

UCF_Ruler["mElements"] = {};

UCF_Ruler["TYPES"] = {
	"TOP": "TOP",
	"BOTTOM": "BOTTOM",
	"LEFT": "LEFT",
	"RIGHT": "RIGHT",
	"BASELINE": "BASELINE"
};

UCF_Ruler["prototype"]["setGhost"] = function(oGhost) {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["setGhost"]++; }; 
	this["oGhost"] = oGhost;
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["setGhost"] = 0; };

UCF_Ruler["prototype"]["setBaseLine"] = function(iBaseLine) {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["setBaseLine"]++; }; 
	this["iBaseLine"] = iBaseLine;
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["setBaseLine"] = 0; };

UCF_Ruler["prototype"]["getElement"] = function() {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["getElement"]++; }; 
	if (!UCF_Ruler["mElements"][this["sType"]]) {
		var oRuler = document["createElement"]("DIV");
		oRuler["style"]["opacity"] = "0.9";
		oRuler["style"]["position"] = "absolute";
		oRuler["style"]["display"] = "block";
		oRuler["style"]["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"] + 200;
		if (this["sType"] === UCF_Ruler["TYPES"]["LEFT"] || this["sType"] === UCF_Ruler["TYPES"]["RIGHT"]) {
			oRuler["style"]["bottom"] = "-4px";
			oRuler["style"]["width"] = "1px";
			oRuler["style"]["top"] = "-4px";
			if (this["sType"] === UCF_Ruler["TYPES"]["LEFT"]) {
				oRuler["style"]["borderLeft"] = "1px solid rgb(192, 220, 255)";
				oRuler["style"]["left"] = "0px";
				UCF_DomUtil["setInnerHtml"](oRuler, "<div class=\"urRulerDistanceV\"><span></span></div>");
			}
			if (this["sType"] === UCF_Ruler["TYPES"]["RIGHT"]) {
				oRuler["style"]["borderRight"] = "1px solid rgb(192, 220, 255)";
				oRuler["style"]["right"] = "0px";
				UCF_DomUtil["setInnerHtml"](oRuler, "<div class=\"urRulerDistanceV\"><span></span></div>");
			}
		} else {
			oRuler["style"]["right"] = "-4px";
			oRuler["style"]["height"] = "1px";
			oRuler["style"]["left"] = "-4px";
			if (this["sType"] === UCF_Ruler["TYPES"]["TOP"]) {
				oRuler["style"]["borderTop"] = "1px solid rgb(192, 220, 255)";
				oRuler["style"]["top"] = "0px";
				UCF_DomUtil["setInnerHtml"](oRuler, "<div class=\"urRulerDistanceH\"><span></span></div>");
				UCF_DomUtil["setStyle"](oRuler["firstChild"], { "marginTop": '4px' });
			}
			if (this["sType"] === UCF_Ruler["TYPES"]["BASELINE"]) {
				oRuler["style"]["borderTop"] = "1px dotted rgb(192, 220, 255)";
				oRuler["style"]["top"] = "16px";
				oRuler["style"]["right"] = "4px";
				oRuler["style"]["left"] = "4px";
				UCF_DomUtil["setInnerHtml"](oRuler, "<div class=\"urRulerDistanceH\"><span></span></div>");
				UCF_DomUtil["setStyle"](oRuler["firstChild"], { "marginTop": '-11px' });
			}
			if (this["sType"] === UCF_Ruler["TYPES"]["BOTTOM"]) {
				oRuler["style"]["borderBottom"] = "1px solid rgb(192, 220, 255)";
				oRuler["style"]["bottom"] = "0px";
				UCF_DomUtil["setInnerHtml"](oRuler, "<div class=\"urRulerDistanceH\"><span></span></div>");
				UCF_DomUtil["setStyle"](oRuler["firstChild"], { "marginTop": '4px' });
			}
		}

		UCF_Ruler["mElements"][this["sType"]] = oRuler;
	}
	return UCF_Ruler["mElements"][this["sType"]];
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["getElement"] = 0; };

UCF_Ruler["prototype"]["snap"] = function(bSnap) {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["snap"]++; }; 
	if (!bSnap) {
		this["getElement"]()["style"]["borderColor"] = "rgb(192, 220, 255)";
	} else {
		this["getElement"]()["style"]["borderColor"] = "rgb(206, 0, 208)";
	}
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["snap"] = 0; };

UCF_Ruler["prototype"]["show"] = function(oTargetRect, oGhostRect, oElementRect) {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["show"]++; }; 
	var oElement = this["getElement"]();
	if (this["sType"] === "TOP" || this["sType"] === "BOTTOM") {
		oElement["style"]["left"] = "-4px";
		oElement["style"]["right"] = "-4px";
		if (oTargetRect["left"] < oGhostRect["left"]) {
			oElement["style"]["left"] = (oTargetRect["left"] - oGhostRect["left"]) + "px";
			oElement["firstChild"]["style"]["left"] = oElementRect["width"] + "px";
			oElement["firstChild"]["style"]["right"] = (oGhostRect["width"] + 4) + "px";
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oElement["firstChild"]["firstChild"], (oGhostRect["left"] - oTargetRect["left"] - oElementRect["width"]) + "px");
			if (this["sType"] === "BOTTOM") {
				oElement["firstChild"]["style"]["marginTop"] = 11 + "px";
			} else {
				oElement["firstChild"]["style"]["marginTop"] = -11 + "px";

			}
		} else if (oTargetRect["left"] > oGhostRect["left"] + oGhostRect["width"]) {
			oElement["style"]["right"] = (oGhostRect["left"] + oGhostRect["width"] - oTargetRect["left"] - oElementRect["width"]) + "px";
			oElement["firstChild"]["style"]["left"] = (oGhostRect["width"] + 4) + "px";
			oElement["firstChild"]["style"]["right"] = oElementRect["width"] + "px";
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oElement["firstChild"]["firstChild"], (oTargetRect["left"] - oGhostRect["left"] - oGhostRect["width"]) + "px");
		}
	} else if (this["sType"] === "LEFT" || this["sType"] === "RIGHT") {
		oElement["style"]["top"] = "-4px";
		oElement["style"]["bottom"] = "-4px";
		if (oTargetRect["top"] < oGhostRect["top"]) {
			oElement["style"]["top"] = (oTargetRect["top"] - oGhostRect["top"]) + "px";
			oElement["firstChild"]["style"]["top"] = oElementRect["height"] + "px";
			oElement["firstChild"]["style"]["bottom"] = (oGhostRect["height"] + 4) + "px";
			oElement["firstChild"]["style"]["lineHeight"] = Math["floor"]((oElement["firstChild"]["offsetHeight"] - 11)) + "px";
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oElement["firstChild"]["firstChild"], (oGhostRect["top"] - oTargetRect["top"] - oElementRect["height"]) + "px");
		} else if (oTargetRect["top"] > oGhostRect["top"] + oGhostRect["height"]) {
			oElement["style"]["bottom"] = (oGhostRect["top"] + oGhostRect["height"] - oTargetRect["top"] - oElementRect["height"]) + "px";
			oElement["firstChild"]["style"]["top"] = (oGhostRect["height"] + 4) + "px";
			oElement["firstChild"]["style"]["bottom"] = oElementRect["height"] + "px";
			oElement["firstChild"]["style"]["lineHeight"] = Math["floor"]((oElement["firstChild"]["offsetHeight"] - 11)) + "px";
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oElement["firstChild"]["firstChild"], (oTargetRect["top"] - oGhostRect["top"] - oGhostRect["height"]) + "px");
		}
	} else if (this["sType"] === "BASELINE") {
		oElement["style"]["left"] = "4px";
		oElement["style"]["right"] = "4px";
		oElement["style"]["top"] = (Math["floor"](oGhostRect["height"] / 2) + 3) + "px";
		if (oTargetRect["left"] < oGhostRect["left"]) {
			oElement["style"]["left"] = (oTargetRect["left"] - oGhostRect["left"]) + "px";
			oElement["style"]["left"] = (oTargetRect["left"] - oGhostRect["left"]) + "px";
			oElement["firstChild"]["style"]["left"] = oElementRect["width"] + "px";
			oElement["firstChild"]["style"]["right"] = (oGhostRect["width"] + 4) + "px";
			oElement["firstChild"]["style"]["marginTop"] = (Math["floor"](oGhostRect["height"] / 2) + 3 - 11) + "px";
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oElement["firstChild"]["firstChild"], (oGhostRect["left"] - oTargetRect["left"] - oElementRect["width"]) + "px");
		} else if (oTargetRect["left"] > oGhostRect["left"] + oGhostRect["width"]) {
			oElement["style"]["right"] = (oGhostRect["left"] + oGhostRect["width"] - oTargetRect["left"] - oElementRect["width"]) + "px";
			oElement["style"]["right"] = (oGhostRect["left"] + oGhostRect["width"] - oTargetRect["left"] - oElementRect["width"]) + "px";
			oElement["firstChild"]["style"]["left"] = (oGhostRect["width"] + 4) + "px";
			oElement["firstChild"]["style"]["right"] = oElementRect["width"] + "px";
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oElement["firstChild"]["firstChild"], (oTargetRect["left"] - oGhostRect["left"] - oGhostRect["width"]) + "px");
		}

	}
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["show"] = 0; };

UCF_Ruler["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["hide"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["hide"] = 0; };

UCF_Ruler["prototype"]["showDistance"] = function() {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["showDistance"]++; }; 
	var oElement = this["getElement"]();
	if (oElement["firstChild"]["innerHTML"]["indexOf"]("-") === -1) {
		oElement["firstChild"]["style"]["display"] = "block";
	} else {
		oElement["firstChild"]["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["showDistance"] = 0; };

UCF_Ruler["prototype"]["hideDistance"] = function() {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["hideDistance"]++; }; 
	var oElement = this["getElement"]();
	oElement["firstChild"]["style"]["display"] = "none";
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["hideDistance"] = 0; };

UCF_Ruler["prototype"]["minimize"] = function() {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["minimize"]++; }; 
	var oElement = this["getElement"]();
	if (this["sType"] === UCF_Ruler["TYPES"]["LEFT"] || this["sType"] === UCF_Ruler["TYPES"]["RIGHT"]) {
		oElement["style"]["bottom"] = "-4px";
		oElement["style"]["top"] = "-4px";
	} else if (this["sType"] === "BASELINE") {
		oElement["style"]["right"] = "4px";
		oElement["style"]["left"] = "4px";
	} else {
		oElement["style"]["right"] = "-4px";
		oElement["style"]["left"] = "-4px";
	}
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["minimize"] = 0; };

UCF_Ruler["prototype"]["getMatchingRect"] = function(oRectManager, oRect, oSender, bSnap) {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["getMatchingRect"]++; }; 
	var oTarget = null,
		iThreshold = bSnap ? 4 : 2;
	if (this["sType"] === "BASELINE") {
		oTarget = oRectManager["getClosestTop"](oRect["top"] + this["iBaseLine"], oRect, iThreshold, this["sType"], oSender, 200);
	}
	if (this["sType"] === "TOP") {
		oTarget = oRectManager["getClosestTop"](oRect["top"], oRect, iThreshold, this["sType"], oSender, 400);
	}
	if (this["sType"] === "LEFT") {
		oTarget = oRectManager["getClosestLeft"](oRect["left"], oRect, iThreshold, this["sType"], oSender, 300);
	}
	if (this["sType"] === "BOTTOM") {
		oTarget = oRectManager["getClosestBottom"](oRect["top"] + oRect["height"], oRect, iThreshold, this["sType"], oSender, 400);
	}
	if (this["sType"] === "RIGHT") {
		oTarget = oRectManager["getClosestRight"](oRect["left"] + oRect["width"], oRect, iThreshold, this["sType"], oSender, 200);
	}
	if (oTarget && oTarget["oCustomData"] && oTarget["oCustomData"]["ruler"] && oTarget["oCustomData"]["ruler"]["sType"] === this["sType"]) {
		return oTarget;
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["getMatchingRect"] = 0; };

UCF_Ruler["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["destroy"]++; }; 
	this["hide"]();
	this["oDomRef"] = null;
	this["oCustomData"] = null;
	this["oOwner"] = null;
	this["sType"] = null;
	this["iBaseLine"] = null;
	this["oGhost"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["destroy"] = 0; };

UCF_Ruler["prototype"]["getRect"] = function() {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["getRect"]++; }; 
	if (!this["oDomRef"]) {
		return null;
	}
	var oRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);
	if (this["sType"] === UCF_Ruler["TYPES"]["LEFT"] || this["sType"] === UCF_Ruler["TYPES"]["RIGHT"]) {
		if (this["sType"] === UCF_Ruler["TYPES"]["RIGHT"]) {
			oRect["left"] = oRect["left"] + oRect["width"];
		}
	} else if (this["sType"] === UCF_Ruler["TYPES"]["TOP"] || this["sType"] === UCF_Ruler["TYPES"]["BOTTOM"]) {
		if (this["sType"] === UCF_Ruler["TYPES"]["BOTTOM"]) {
			oRect["top"] = oRect["top"] + oRect["height"];
		}
	} else {
		oRect["top"] = oRect["top"] + this["iBaseLine"];
	}
	oRect["width"] = 1;
	oRect["height"] = 1;
	return oRect;
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["getRect"] = 0; };

UCF_Ruler["_getTextBaseline"] = function(oDomRef, oStartDomRef) {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["_getTextBaseline"]++; }; 
	//this is experimental
	if (!oStartDomRef) oStartDomRef = oDomRef;
	if (oDomRef) {
		if (oDomRef["firstChild"] && (oDomRef["firstChild"]["nodeType"] === "3" || oDomRef["firstChild"]["tagName"] === "INPUT" || oDomRef["firstChild"]["tagName"] === "SELECT" || oDomRef["firstChild"]["tagName"] === "TEXTAREA")) {
			var oImg = document["createElement"]("img");
			oImg["style"]["height"] = "1px";
			oImg["style"]["width"] = "1px";
			oImg["style"]["verticalAlign"] = "text-bottom";
			oDomRef["insertBefore"](oImg, oDomRef["firstChild"]);
			var iTop = oImg["offsetTop"];
			var o = oImg;
			while (o["offsetParent"] !== oStartDomRef) {
				o = o["offsetParent"];
				iTop += o["offsetTop"] - 2;
			}
			oDomRef["removeChild"](oImg);
			return iTop;
		} else if (oDomRef["firstChild"]) {
			for (var i = 0; i < oDomRef["childNodes"]["length"]; i++) {
				var iResult = UCF_Ruler["_getTextBaseline"](oDomRef["childNodes"][i], oStartDomRef);
				if (iResult != null) {
					return iResult;
				}
			}
		}
	}
	return null;

};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["_getTextBaseline"] = 0; };
UCF_Ruler["getTextBaseline"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["getTextBaseline"]++; }; 
	return UCF_Ruler["_getTextBaseline"](oDomRef);
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["getTextBaseline"] = 0; };

UCF_Ruler["getTextLeft"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["getTextLeft"]++; }; 
	if (oDomRef) {
		if (oDomRef["firstChild"] && oDomRef["firstChild"]["nodeType"] === "3") {
			var oImg = document["createElement"]("img");
			oImg["style"]["height"] = "0px";
			oImg["style"]["width"] = "0px";
			oDomRef["insertBefore"](oImg, oDomRef["firstChild"]);
			return oImg["offsetLeft"];
			// oDomRef.removeChild(oImg);
		} else if (oDomRef["firstChild"]) {
			for (var i = 0; i < oDomRef["childNodes"]["length"]; i++) {
				var iResult = UCF_Ruler["getTextLeft"](oDomRef["childNodes"][i]);
				if (iResult != null) {
					return iResult + oDomRef["childNodes"][i]["offsetLeft"];
				}
			}
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Ruler["_"]["getTextLeft"] = 0; };

};
sap["ls"]["preload"]["UCF_SapTable"] = function() {// #region imports ############################################################
/* global _assert, _trace, DEBUG, WARNING, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_ClipboardUtil */
/// <reference path="../../core/util/ClipboardUtil.js"/>
/* global UCF_ColorUtil */
/// <reference path="../../core/util/ColorUtil.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_SapTableAccessibilityHelper */
/// <reference path="./base/SapTableAccessibilityHelper.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_SapTableDragDelegate */
/// <reference path="./delegates/SapTableDragDelegate.js"/>
/* global UCF_SapTableDragDropDelegate */
/// <reference path="./delegates/SapTableDragDropDelegate.js"/>
/* global UCF_SapTableDropDelegate */
/// <reference path="./delegates/SapTableDropDelegate.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>
/* global UCF_SapTableCell */
/// <reference path="./SapTableCell.js"/>
/* global UCF_SapTableHeaderCell */
/// <reference path="./SapTableHeaderCell.js"/>
/* global UCF_SapTableHierarchicalCell */
/// <reference path="./SapTableHierarchicalCell.js"/>
/* global UCF_SapTableMatrixCell */
/// <reference path="./SapTableMatrixCell.js"/>
/* global UCF_SapTableSelectionCell */
/// <reference path="./SapTableSelectionCell.js"/>
// #endregion
// #region typedefs ###########################################################
// #region UCF_SapTable_Metadata ==============================================
/**
 * @typedef {Object} UCF_SapTable_Metadata
 * @property {string} sCopyToClipboardAnimationDurationMs
 */
// #endregion
// #region UCF_SapTable_DataCell ==============================================
/** @typedef {UCF_SapTableCell|UCF_SapTableHierarchicalCell|UCF_SapTableMatrixCell} UCF_SapTable_DataCell */
// #endregion
// #region UCF_SapTable_Bitmask ===============================================
/** @typedef {number} UCF_SapTable_Modifiermask */
// #endregion
// #region UCF_SapTable_Modifier ==============================================
/** @typedef {"SHIFT"} UCF_SapTable_ShiftModifier */
/** @typedef {"CTRL"} UCF_SapTable_CtrlModifier */
/** @typedef {"ALT"} UCF_SapTable_AltModifier */
/** @typedef {UCF_SapTable_ShiftModifier|UCF_SapTable_CtrlModifier|UCF_SapTable_AltModifier} UCF_SapTable_Modifier */
/**
 * @typedef {Object} UCF_SapTable_ModifierEnum
 * @property {UCF_SapTable_ShiftModifier} SHIFT
 * @property {UCF_SapTable_CtrlModifier} CTRL
 * @property {UCF_SapTable_AltModifier} ALT
 */
// #endregion
// #region UCF_SapTable_Subcontrol ============================================
/** @typedef {false} UCF_SapTable_NoneSubcontrol */
/** @typedef {"ST"} UCF_SapTable_TableSubcontrol */
/** @typedef {"HC"} UCF_SapTable_HeaderCellSubcontrol */
/** @typedef {"STC"} UCF_SapTable_StandardCellSubcontrol */
/** @typedef {"HIC"} UCF_SapTable_HierarchyCellSubcontrol */
/** @typedef {"MC"} UCF_SapTable_MatrixCellSubcontrol */
/** @typedef {"SC"} UCF_SapTable_SelectionCellSubcontrol */
/** @typedef {"PC"} UCF_SapTable_PopinCellSubcontrol */
/** @typedef {UCF_SapTable_NoneSubcontrol|UCF_SapTable_TableSubcontrol|UCF_SapTable_HeaderCellSubcontrol|UCF_SapTable_StandardCellSubcontrol|UCF_SapTable_HierarchyCellSubcontrol|UCF_SapTable_MatrixCellSubcontrol|UCF_SapTable_SelectionCellSubcontrol|UCF_SapTable_PopinCellSubcontrol} UCF_SapTable_Subcontrol */
/**
 * @typedef {Object} UCF_SapTable_SubcontrolEnum
 * @property {UCF_SapTable_NoneSubcontrol} NONE
 * @property {UCF_SapTable_TableSubcontrol} TABLE
 * @property {UCF_SapTable_HeaderCellSubcontrol} HEADER_CELL
 * @property {UCF_SapTable_StandardCellSubcontrol} STANDARD_CELL
 * @property {UCF_SapTable_HierarchyCellSubcontrol} HIERARCHY_CELL
 * @property {UCF_SapTable_MatrixCellSubcontrol} MATRIX_CELL
 * @property {UCF_SapTable_SelectionCellSubcontrol} SELECTION_CELL
 * @property {UCF_SapTable_PopinCellSubcontrol} POPIN_CELL
 */
// #endregion
// #region UCF_SapTable_CellType ==============================================
/** @typedef {"SapTableCell"} UCF_SapTable_StandardCellCellType */
/** @typedef {"SapTableHierarchicalCell"} UCF_SapTable_HierarchicalCellCellType */
/** @typedef {"SapTableMatrixCell"} UCF_SapTable_MatrixCellCellType */
/** @typedef {"SapTableSelectionCell"} UCF_SapTable_SelectionCellCellType */
/** @typedef {"SapTableCell"} UCF_SapTable_CellCellType */
/** @typedef {"SapTableHeaderCell"} UCF_SapTable_HeaderCellCellType */
/** @typedef {UCF_SapTable_StandardCellCellType|UCF_SapTable_HierarchicalCellCellType|UCF_SapTable_MatrixCellCellType|UCF_SapTable_SelectionCellCellType|UCF_SapTable_CellCellType|UCF_SapTable_HeaderCellCellType} UCF_SapTable_CellType */
/**
 * @typedef {Object} UCF_SapTable_CellTypeEnum
 * @property {UCF_SapTable_StandardCellCellType} STC
 * @property {UCF_SapTable_HierarchicalCellCellType} HIC
 * @property {UCF_SapTable_MatrixCellCellType} MC
 * @property {UCF_SapTable_SelectionCellCellType} SC
 * @property {UCF_SapTable_CellCellType} PC
 * @property {UCF_SapTable_HeaderCellCellType} HC
 */
// #endregion
// #region UCF_SapTable_ColumnReorder =========================================
/** @typedef {"NONE"} UCF_SapTable_NoneColumnReorder */
/** @typedef {"AFTER"} UCF_SapTable_AfterColumnReorder */
/** @typedef {"BEFORE"} UCF_SapTable_BeforeColumnReorder */
/** @typedef {UCF_SapTable_NoneColumnReorder|UCF_SapTable_AfterColumnReorder|UCF_SapTable_BeforeColumnReorder} UCF_SapTable_ColumnReorder */
/**
 * @typedef {Object} UCF_SapTable_ColumnReorderEnum
 * @property {UCF_SapTable_NoneColumnReorder} NONE
 * @property {UCF_SapTable_AfterColumnReorder} AFTER
 * @property {UCF_SapTable_BeforeColumnReorder} BEFORE
 */
// #endregion
// #region UCF_SapTable_EventMapAccessType ====================================
/** @typedef {"INVALID"} UCF_SapTable_InvalidEventMapAccessType */
/** @typedef {"STANDARD"} UCF_SapTable_StandardEventMapAccessType */
/** @typedef {"RANGE"} UCF_SapTable_RangeEventMapAccessType */
/** @typedef {"TOGGLE"} UCF_SapTable_ToggleEventMapAccessType */
/** @typedef {"SELECT_ALL"} UCF_SapTable_SelectAllEventMapAccessType */
/** @typedef {"DESELECT_ALL"} UCF_SapTable_DeselectAllEventMapAccessType */
/** @typedef {UCF_SapTable_InvalidEventMapAccessType|UCF_SapTable_StandardEventMapAccessType|UCF_SapTable_RangeEventMapAccessType|UCF_SapTable_ToggleEventMapAccessType|UCF_SapTable_SelectAllEventMapAccessType|UCF_SapTable_DeselectAllEventMapAccessType} UCF_SapTable_EventMapAccessType */
/**
 * @typedef {Object} UCF_SapTable_EventMapAccessTypeEnum
 * @property {UCF_SapTable_InvalidEventMapAccessType} INVALID
 * @property {UCF_SapTable_StandardEventMapAccessType} STANDARD
 * @property {UCF_SapTable_RangeEventMapAccessType} RANGE
 * @property {UCF_SapTable_ToggleEventMapAccessType} TOGGLE
 * @property {UCF_SapTable_SelectAllEventMapAccessType} SELECT_ALL
 * @property {UCF_SapTable_DeselectAllEventMapAccessType} DESELECT_ALL
 */
// #endregion
// #region UCF_SapTable_Action ================================================
/** @typedef {""} UCF_SapTable_NoneAction */
/** @typedef {"CSEL"} UCF_SapTable_CellSelectAction */
/** @typedef {"HCICO"} UCF_SapTable_HeaderIconAction */
/** @typedef {"HCSORT"} UCF_SapTable_HeaderSortAction */
/** @typedef {"HICEXP"} UCF_SapTable_HierarchyExpandAction */
/** @typedef {"HICCOL"} UCF_SapTable_HierarchyCollapseAction */
/** @typedef {"HICALT"} UCF_SapTable_HierarchyAlternativeAction */
/** @typedef {"SELMNUOPN"} UCF_SapTable_SelectionMenuOpenAction */
/** @typedef {"HCACTMNUOPN"} UCF_SapTable_HeaderActionMenuOpenAction */
/** @typedef {"FLTR"} UCF_SapTable_FilterAction */
/** @typedef {"FLTR_ENTER"} UCF_SapTable_FilterEnterAction */
/** @typedef {"CRESIZE"} UCF_SapTable_ColResizeAction */
/** @typedef {"CDRAG"} UCF_SapTable_ColDragAction */
/** @typedef {"TVRESIZE"} UCF_SapTable_TableVResizeAction */
/** @typedef {"TABLE_END"} UCF_SapTable_TableEndAction */
/** @typedef {"CONFIG"} UCF_SapTable_ConfigAction */
/** @typedef {"NO_DATA_NOTIFICATION"} UCF_SapTable_NoDataNotificationAction */
/** @typedef {"SELCOLTOGGLE"} UCF_SapTable_SelectionColumnToggleAction */
/** @typedef {"BLOCKSEL"} UCF_SapTable_BlockSelectAction */
/** @typedef {UCF_SapTable_NoneAction|UCF_SapTable_CellSelectAction|UCF_SapTable_HeaderIconAction|UCF_SapTable_HeaderSortAction|UCF_SapTable_HierarchyExpandAction|UCF_SapTable_HierarchyCollapseAction|UCF_SapTable_HierarchyAlternativeAction|UCF_SapTable_SelectionMenuOpenAction|UCF_SapTable_HeaderActionMenuOpenAction|UCF_SapTable_FilterAction|UCF_SapTable_FilterEnterAction|UCF_SapTable_ColResizeAction|UCF_SapTable_ColDragAction|UCF_SapTable_TableVResizeAction|UCF_SapTable_TableEndAction|UCF_SapTable_ConfigAction|UCF_SapTable_NoDataNotificationAction|UCF_SapTable_SelectionColumnToggleAction|UCF_SapTable_BlockSelectAction} UCF_SapTable_Action */
/**
 * @typedef {Object} UCF_SapTable_ActionEnum
 * @property {UCF_SapTable_NoneAction} NONE
 * @property {UCF_SapTable_CellSelectAction} CELL_SELECT
 * @property {UCF_SapTable_HeaderIconAction} HEADER_ICON
 * @property {UCF_SapTable_HeaderSortAction} HEADER_SORT
 * @property {UCF_SapTable_HierarchyExpandAction} HIERARCHY_EXPAND
 * @property {UCF_SapTable_HierarchyCollapseAction} HIERARCHY_COLLAPSE
 * @property {UCF_SapTable_HierarchyAlternativeAction} HIERARCHY_ALTERNATIVE
 * @property {UCF_SapTable_SelectionMenuOpenAction} SELECTION_MENU_OPEN
 * @property {UCF_SapTable_HeaderActionMenuOpenAction} HEADER_ACTION_MENU_OPEN
 * @property {UCF_SapTable_FilterAction} FILTER
 * @property {UCF_SapTable_FilterEnterAction} FILTER_ENTER
 * @property {UCF_SapTable_ColResizeAction} COL_RESIZE
 * @property {UCF_SapTable_ColDragAction} COL_DRAG
 * @property {UCF_SapTable_TableVResizeAction} TABLE_V_RESIZE
 * @property {UCF_SapTable_TableEndAction} TABLE_END
 * @property {UCF_SapTable_ConfigAction} CONFIG
 * @property {UCF_SapTable_NoDataNotificationAction} NO_DATA_NOTIFICATION
 * @property {UCF_SapTable_SelectionColumnToggleAction} SELECTION_COLUMN_TOGGLE
 * @property {UCF_SapTable_BlockSelectAction} BLOCK_SELECT
 */
// #endregion
// #region UCF_SapTable_AccessType ============================================
/** @typedef {0} UCF_SapTable_NoneAccessType */
/** @typedef {1} UCF_SapTable_MouseAccessType */
/** @typedef {2} UCF_SapTable_KeyboardSelectAccessType */
/** @typedef {3} UCF_SapTable_KeyboardExpandAccessType */
/** @typedef {4} UCF_SapTable_KeyboardCollapseAccessType */
/** @typedef {5} UCF_SapTable_DragStartAccessType */
/** @typedef {6} UCF_SapTable_DragAccessType */
/** @typedef {7} UCF_SapTable_DragEndAccessType */
/** @typedef {8} UCF_SapTable_DragOverAccessType */
/** @typedef {9} UCF_SapTable_DropAccessType */
/** @typedef {10} UCF_SapTable_DragEnterAccessType */
/** @typedef {11} UCF_SapTable_DragLeaveAccessType */
/** @typedef {12} UCF_SapTable_S508AccessType */
/** @typedef {13} UCF_SapTable_HotkeyAccessType */
/** @typedef {14} UCF_SapTable_KeyboardEnterAccessType */
/** @typedef {15} UCF_SapTable_KeyboardNavigateAccessType */
/** @typedef {16} UCF_SapTable_KeyboardTabAccessType */
/** @typedef {UCF_SapTable_NoneAccessType|UCF_SapTable_MouseAccessType|UCF_SapTable_KeyboardSelectAccessType|UCF_SapTable_KeyboardExpandAccessType|UCF_SapTable_KeyboardCollapseAccessType|UCF_SapTable_DragStartAccessType|UCF_SapTable_DragAccessType|UCF_SapTable_DragEndAccessType|UCF_SapTable_DragOverAccessType|UCF_SapTable_DropAccessType|UCF_SapTable_DragEnterAccessType|UCF_SapTable_DragLeaveAccessType|UCF_SapTable_S508AccessType|UCF_SapTable_HotkeyAccessType|UCF_SapTable_KeyboardEnterAccessType|UCF_SapTable_KeyboardNavigateAccessType|UCF_SapTable_KeyboardTabAccessType} UCF_SapTable_AccessType */
/**
 * @typedef {Object} UCF_SapTable_AccessTypeEnum
 * @property {UCF_SapTable_NoneAccessType} NONE
 * @property {UCF_SapTable_MouseAccessType} MOUSE
 * @property {UCF_SapTable_KeyboardSelectAccessType} KEYBOARD_SELECT
 * @property {UCF_SapTable_KeyboardExpandAccessType} KEYBOARD_EXPAND
 * @property {UCF_SapTable_KeyboardCollapseAccessType} KEYBOARD_COLLAPSE
 * @property {UCF_SapTable_DragStartAccessType} DRAG_START
 * @property {UCF_SapTable_DragAccessType} DRAG
 * @property {UCF_SapTable_DragEndAccessType} DRAG_END
 * @property {UCF_SapTable_DragOverAccessType} DRAG_OVER
 * @property {UCF_SapTable_DropAccessType} DROP
 * @property {UCF_SapTable_DragEnterAccessType} DRAG_ENTER
 * @property {UCF_SapTable_DragLeaveAccessType} DRAG_LEAVE
 * @property {UCF_SapTable_S508AccessType} S_508
 * @property {UCF_SapTable_HotkeyAccessType} HOTKEY
 * @property {UCF_SapTable_KeyboardEnterAccessType} KEYBOARD_ENTER
 * @property {UCF_SapTable_KeyboardNavigateAccessType} KEYBOARD_NAVIGATE
 * @property {UCF_SapTable_KeyboardTabAccessType} KEYBOARD_TAB
 */
// #endregion
// #region UCF_SapTable_Suffix ================================================
/** @typedef {""} UCF_SapTable_NoneSuffix */
/** @typedef {"scrollV"} UCF_SapTable_ScrollVSuffix */
/** @typedef {"scrollH"} UCF_SapTable_ScrollHSuffix */
/** @typedef {"contentTBody"} UCF_SapTable_ContentTBodySuffix */
/** @typedef {"content"} UCF_SapTable_ContentAreaSuffix */
/** @typedef {"toolbar"} UCF_SapTable_ToolbarCellSuffix */
/** @typedef {"footer"} UCF_SapTable_FooterCellSuffix */
/** @typedef {"legendContainer"} UCF_SapTable_LegendContainerSuffix */
/** @typedef {"CRESIZE"} UCF_SapTable_ResizeHandleSuffix */
/** @typedef {"CONTENT"} UCF_SapTable_HCContentSuffix */
/** @typedef {UCF_SapTable_NoneSuffix|UCF_SapTable_ScrollVSuffix|UCF_SapTable_ScrollHSuffix|UCF_SapTable_ContentTBodySuffix|UCF_SapTable_ContentAreaSuffix|UCF_SapTable_ToolbarCellSuffix|UCF_SapTable_FooterCellSuffix|UCF_SapTable_LegendContainerSuffix|UCF_SapTable_ResizeHandleSuffix|UCF_SapTable_HCContentSuffix} UCF_SapTable_Suffix */
/**
 * @typedef {Object} UCF_SapTable_SuffixEnum
 * @property {UCF_SapTable_NoneSuffix} NONE
 * @property {UCF_SapTable_ScrollVSuffix} SCROLL_V
 * @property {UCF_SapTable_ScrollHSuffix} SCROLL_H
 * @property {UCF_SapTable_ContentTBodySuffix} CONTENT_TBODY
 * @property {UCF_SapTable_ContentAreaSuffix} CONTENT_AREA
 * @property {UCF_SapTable_ToolbarCellSuffix} TOOLBAR_CELL
 * @property {UCF_SapTable_FooterCellSuffix} FOOTER_CELL
 * @property {UCF_SapTable_LegendContainerSuffix} LEGEND_CONTAINER
 * @property {UCF_SapTable_ResizeHandleSuffix} RESIZE_HANDLE
 * @property {UCF_SapTable_HCContentSuffix} HC_CONTENT
 */
// #endregion
// #region UCF_SapTable_HoverEffect ===========================================
/** @typedef {""} UCF_SapTable_NoneHoverEffect */
/** @typedef {"hoverDivider"} UCF_SapTable_DivierHoverEffect */
/** @typedef {"hoverActMenu"} UCF_SapTable_ActionMenuHoverEffect */
/** @typedef {"hoverHdrBg"} UCF_SapTable_HeaderBGHoverEffect */
/** @typedef {"hoverTable"} UCF_SapTable_TableHoverEffect */
/** @typedef {"hoverResizeHandle"} UCF_SapTable_ResizeHandleHoverEffect */
/** @typedef {UCF_SapTable_NoneHoverEffect|UCF_SapTable_DivierHoverEffect|UCF_SapTable_ActionMenuHoverEffect|UCF_SapTable_HeaderBGHoverEffect|UCF_SapTable_TableHoverEffect|UCF_SapTable_ResizeHandleHoverEffect} UCF_SapTable_HoverEffect */
/**
 * @typedef {Object} UCF_SapTable_HoverEffectEnum
 * @property {UCF_SapTable_NoneHoverEffect} NONE
 * @property {UCF_SapTable_DivierHoverEffect} DIVIDER
 * @property {UCF_SapTable_ActionMenuHoverEffect} ACTION_MENU
 * @property {UCF_SapTable_HeaderBGHoverEffect} HEADER_BG
 * @property {UCF_SapTable_TableHoverEffect} TABLE
 * @property {UCF_SapTable_ResizeHandleHoverEffect} RESIZE_HANDLE
 */
// #endregion
// #region UCF_SapTable_Navigation ============================================
/** @typedef {0} UCF_SapTable_NoneNavigation */
/** @typedef {1} UCF_SapTable_LeftNavigation */
/** @typedef {2} UCF_SapTable_RightNavigation */
/** @typedef {3} UCF_SapTable_HomeNavigation */
/** @typedef {4} UCF_SapTable_EndNavigation */
/** @typedef {5} UCF_SapTable_UpNavigation */
/** @typedef {6} UCF_SapTable_DownNavigation */
/** @typedef {7} UCF_SapTable_TopNavigation */
/** @typedef {8} UCF_SapTable_BottomNavigation */
/** @typedef {9} UCF_SapTable_PageUpNavigation */
/** @typedef {10} UCF_SapTable_PageDownNavigation */
/** @typedef {11} UCF_SapTable_NextColumnPageNavigation */
/** @typedef {12} UCF_SapTable_PreviousColumnPageNavigation */
/** @typedef {UCF_SapTable_NoneNavigation|UCF_SapTable_LeftNavigation|UCF_SapTable_RightNavigation|UCF_SapTable_HomeNavigation|UCF_SapTable_EndNavigation|UCF_SapTable_UpNavigation|UCF_SapTable_DownNavigation|UCF_SapTable_TopNavigation|UCF_SapTable_BottomNavigation|UCF_SapTable_PageUpNavigation|UCF_SapTable_PageDownNavigation|UCF_SapTable_NextColumnPageNavigation|UCF_SapTable_PreviousColumnPageNavigation} UCF_SapTable_Navigation */
/**
 * @typedef {Object} UCF_SapTable_NavigationEnum
 * @property {UCF_SapTable_NoneNavigation} NONE
 * @property {UCF_SapTable_LeftNavigation} LEFT
 * @property {UCF_SapTable_RightNavigation} RIGHT
 * @property {UCF_SapTable_HomeNavigation} HOME
 * @property {UCF_SapTable_EndNavigation} END
 * @property {UCF_SapTable_UpNavigation} UP
 * @property {UCF_SapTable_DownNavigation} DOWN
 * @property {UCF_SapTable_TopNavigation} TOP
 * @property {UCF_SapTable_BottomNavigation} BOTTOM
 * @property {UCF_SapTable_PageUpNavigation} PAGE_UP
 * @property {UCF_SapTable_PageDownNavigation} PAGE_DOWN
 * @property {UCF_SapTable_NextColumnPageNavigation} NEXT_COLUMN_PAGE
 * @property {UCF_SapTable_PreviousColumnPageNavigation} PREVIOUS_COLUMN_PAGE
 */
// #endregion
// #region UCF_SapTable_FocusBehavior =========================================
/** @typedef {0} UCF_SapTable_NoneFocusBehavior */
/** @typedef {1} UCF_SapTable_CellFocusBehavior */
/** @typedef {2} UCF_SapTable_FilterFocusBehavior */
/** @typedef {3} UCF_SapTable_SelectionMenuFocusBehavior */
/** @typedef {4} UCF_SapTable_HeaderSortFocusBehavior */
/** @typedef {5} UCF_SapTable_HeaderIconFocusBehavior */
/** @typedef {UCF_SapTable_NoneFocusBehavior|UCF_SapTable_CellFocusBehavior|UCF_SapTable_FilterFocusBehavior|UCF_SapTable_SelectionMenuFocusBehavior|UCF_SapTable_HeaderSortFocusBehavior|UCF_SapTable_HeaderIconFocusBehavior} UCF_SapTable_FocusBehavior */
/**
 * @typedef {Object} UCF_SapTable_FocusBehaviorEnum
 * @property {UCF_SapTable_NoneFocusBehavior} NONE
 * @property {UCF_SapTable_CellFocusBehavior} CELL
 * @property {UCF_SapTable_FilterFocusBehavior} FILTER
 * @property {UCF_SapTable_SelectionMenuFocusBehavior} SELECTION_MENU
 * @property {UCF_SapTable_HeaderSortFocusBehavior} HEADER_SORT
 * @property {UCF_SapTable_HeaderIconFocusBehavior} HEADER_ICON
 */
// #endregion
// #region UCF_SapTable_FocusAppearance =======================================
/** @typedef {0} UCF_SapTable_NeverFocusAppearance */
/** @typedef {1} UCF_SapTable_AlwaysFocusAppearance */
/** @typedef {2} UCF_SapTable_InputFocusAppearance */
/** @typedef {UCF_SapTable_NeverFocusAppearance|UCF_SapTable_AlwaysFocusAppearance|UCF_SapTable_InputFocusAppearance} UCF_SapTable_FocusAppearance */
/**
 * @typedef {Object} UCF_SapTable_FocusAppearanceEnum
 * @property {UCF_SapTable_NeverFocusAppearance} NEVER
 * @property {UCF_SapTable_AlwaysFocusAppearance} ALWAYS
 * @property {UCF_SapTable_InputFocusAppearance} INPUT
 */
// #endregion
// #region UCF_SapTable_RowType ===============================================
/** @typedef {0} UCF_SapTable_UnspecifiedRowType */
/** @typedef {1} UCF_SapTable_StandardRowType */
/** @typedef {2} UCF_SapTable_HeaderRowType */
/** @typedef {3} UCF_SapTable_FilterRowType */
/** @typedef {4} UCF_SapTable_TopFixedRowType */
/** @typedef {5} UCF_SapTable_BottomFixedRowType */
/** @typedef {6} UCF_SapTable_PivotRowType */
/** @typedef {UCF_SapTable_UnspecifiedRowType|UCF_SapTable_StandardRowType|UCF_SapTable_HeaderRowType|UCF_SapTable_FilterRowType|UCF_SapTable_TopFixedRowType|UCF_SapTable_BottomFixedRowType|UCF_SapTable_PivotRowType} UCF_SapTable_RowType */
/**
 * @typedef {Object} UCF_SapTable_RowTypeEnum
 * @property {UCF_SapTable_UnspecifiedRowType} UNSPECIFIED
 * @property {UCF_SapTable_StandardRowType} STANDARD
 * @property {UCF_SapTable_HeaderRowType} HEADER
 * @property {UCF_SapTable_FilterRowType} FILTER
 * @property {UCF_SapTable_TopFixedRowType} TOP_FIXED
 * @property {UCF_SapTable_BottomFixedRowType} BOTTOM_FIXED
 * @property {UCF_SapTable_PivotRowType} PIVOT
 */
// #endregion
// #region UCF_SapTable_ScrollUpdateMode ======================================
/** @typedef {"CLIENT"} UCF_SapTable_ClientScrollUpdateMode */
/** @typedef {"SERVER"} UCF_SapTable_ServerScrollUpdateMode */
/** @typedef {UCF_SapTable_ClientScrollUpdateMode|UCF_SapTable_ServerScrollUpdateMode} UCF_SapTable_ScrollUpdateMode */
/**
 * @typedef {Object} UCF_SapTable_ScrollUpdateModeEnum
 * @property {UCF_SapTable_ClientScrollUpdateMode} CLIENT
 * @property {UCF_SapTable_ServerScrollUpdateMode} SERVER
 */
// #endregion
// #region UCF_SapTable_Color =================================================
/** @typedef {"colorStdHover"} UCF_SapTable_HoverColor */
/** @typedef {"colorDDHover"} UCF_SapTable_HoverDDColor */
/** @typedef {UCF_SapTable_HoverColor|UCF_SapTable_HoverDDColor} UCF_SapTable_Color */
/**
 * @typedef {Object} UCF_SapTable_ColorEnum
 * @property {UCF_SapTable_HoverColor} HOVER
 * @property {UCF_SapTable_HoverDDColor} HOVER_DD
 */
// #endregion
// #region UCF_SapTable_Rgb ===================================================
/**
 * @typedef {Object} UCF_SapTable_Rgb
 * @property {number} r
 * @property {number} g
 * @property {number} b
 */
// #endregion
// #region UCF_SapTable_SearchDirection =======================================
/** @typedef {0} UCF_SapTable_NoneSearchDirection */
/** @typedef {1} UCF_SapTable_AscendingSearchDirection */
/** @typedef {2} UCF_SapTable_DescendingSearchDirection */
/** @typedef {3} UCF_SapTable_LastSearchDirection */
/** @typedef {4} UCF_SapTable_FirstSearchDirection */
/** @typedef {UCF_SapTable_NoneSearchDirection|UCF_SapTable_AscendingSearchDirection|UCF_SapTable_DescendingSearchDirection|UCF_SapTable_LastSearchDirection|UCF_SapTable_FirstSearchDirection} UCF_SapTable_SearchDirection */
/**
 * @typedef {Object} UCF_SapTable_SearchDirectionEnum
 * @property {UCF_SapTable_NoneSearchDirection} NONE
 * @property {UCF_SapTable_AscendingSearchDirection} ASCENDING
 * @property {UCF_SapTable_DescendingSearchDirection} DESCENDING
 * @property {UCF_SapTable_LastSearchDirection} LAST
 * @property {UCF_SapTable_FirstSearchDirection} FIRST
 */
// #endregion
// #region UCF_SapTable_ClientSelectionMode ===================================
/** @typedef {0} UCF_SapTable_NoneClientSelectionMode */
/** @typedef {1} UCF_SapTable_WebDynproClientSelectionMode */
/** @typedef {UCF_SapTable_NoneClientSelectionMode|UCF_SapTable_WebDynproClientSelectionMode} UCF_SapTable_ClientSelectionMode */
/**
 * @typedef {Object} UCF_SapTable_ClientSelectionModeEnum
 * @property {UCF_SapTable_NoneClientSelectionMode} NONE
 * @property {UCF_SapTable_WebDynproClientSelectionMode} WEB_DYNPRO
 */
// #endregion
// #region UCF_SapTable_SelectionLayer ========================================
/** @typedef {0} UCF_SapTable_NoneSelectionLayer */
/** @typedef {1} UCF_SapTable_RowSelectionLayer */
/** @typedef {2} UCF_SapTable_ColumnSelectionLayer */
/** @typedef {4} UCF_SapTable_RowPrimarySelectionLayer */
/** @typedef {8} UCF_SapTable_RowDisabledSelectionLayer */
/** @typedef {16} UCF_SapTable_ColumnDisabledSelectionLayer */
/** @typedef {32} UCF_SapTable_CellSelectionLayer */
/** @typedef {255} UCF_SapTable_AllSelectionLayer */
/** @typedef {UCF_SapTable_NoneSelectionLayer|UCF_SapTable_RowSelectionLayer|UCF_SapTable_ColumnSelectionLayer|UCF_SapTable_RowPrimarySelectionLayer|UCF_SapTable_RowDisabledSelectionLayer|UCF_SapTable_ColumnDisabledSelectionLayer|UCF_SapTable_CellSelectionLayer|UCF_SapTable_AllSelectionLayer} UCF_SapTable_SelectionLayer */
/**
 * @typedef {Object} UCF_SapTable_SelectionLayerEnum
 * @property {UCF_SapTable_NoneSelectionLayer} NONE
 * @property {UCF_SapTable_RowSelectionLayer} ROW
 * @property {UCF_SapTable_ColumnSelectionLayer} COLUMN
 * @property {UCF_SapTable_RowPrimarySelectionLayer} ROW_PRIMARY
 * @property {UCF_SapTable_RowDisabledSelectionLayer} ROW_DISABLED
 * @property {UCF_SapTable_ColumnDisabledSelectionLayer} COLUMN_DISABLED
 * @property {UCF_SapTable_CellSelectionLayer} CELL
 * @property {UCF_SapTable_AllSelectionLayer} ALL
 */
// #endregion
// #region UCF_SapTable_CellUsageType =========================================
/** @typedef {0} UCF_SapTable_NoneCellUsageType */
/** @typedef {1} UCF_SapTable_StandardCellUsageType */
/** @typedef {2} UCF_SapTable_TextCellUsageType */
/** @typedef {3} UCF_SapTable_EditCellUsageType */
/** @typedef {4} UCF_SapTable_EmptyrowCellUsageType */
/** @typedef {5} UCF_SapTable_EmptycellCellUsageType */
/** @typedef {6} UCF_SapTable_FormatCellUsageType */
/** @typedef {7} UCF_SapTable_RowcreatorCellUsageType */
/** @typedef {8} UCF_SapTable_InfoCellUsageType */
/** @typedef {UCF_SapTable_NoneCellUsageType|UCF_SapTable_StandardCellUsageType|UCF_SapTable_TextCellUsageType|UCF_SapTable_EditCellUsageType|UCF_SapTable_EmptyrowCellUsageType|UCF_SapTable_EmptycellCellUsageType|UCF_SapTable_FormatCellUsageType|UCF_SapTable_RowcreatorCellUsageType|UCF_SapTable_InfoCellUsageType} UCF_SapTable_CellUsageType */
/**
 * @typedef {Object} UCF_SapTable_CellUsageTypeEnum
 * @property {UCF_SapTable_NoneCellUsageType} NONE
 * @property {UCF_SapTable_StandardCellUsageType} STANDARD
 * @property {UCF_SapTable_TextCellUsageType} TEXT
 * @property {UCF_SapTable_EditCellUsageType} EDIT
 * @property {UCF_SapTable_EmptyrowCellUsageType} EMPTYROW
 * @property {UCF_SapTable_EmptycellCellUsageType} EMPTYCELL
 * @property {UCF_SapTable_FormatCellUsageType} FORMAT
 * @property {UCF_SapTable_RowcreatorCellUsageType} ROWCREATOR
 * @property {UCF_SapTable_InfoCellUsageType} INFO
 */
// #endregion
// #region UCF_SapTable_CellInfoDomRefCell ====================================
/**
 * @typedef {HTMLElement} UCF_SapTable_CellInfoDomRefCell
 * @property {number} lsMatrixRowIndex
 * @property {number} lsMatrixColIndex
 */
// #endregion
// #region UCF_SapTable_CellInfo ==============================================
/**
 * @typedef {Object} UCF_SapTable_CellInfo
 * @property {UCF_SapTable_Subcontrol} eCellType
 * @property {number} iRowIndex
 * @property {number} iRowSpan
 * @property {number} iColIndex
 * @property {number} iColSpan
 * @property {UCF_SapTable_SelectionLayer} iSelectionState
 * @property {UCF_SapTable_CellInfoDomRefCell} oDomRefCell
 * @property {HTMLTableRowElement} oDomRefRow
 */
// #endregion
// #region UCF_SapTable_CellInfoMatrixHeadData ================================
/**
 * @typedef {Object} UCF_SapTable_CellInfoMatrixHeadData
 * @property {number} iFocussedCellRowIndex
 * @property {number} iFocussedCellColIndex
 */
// #endregion
// #region UCF_SapTable_SelectionInfo =========================================
/**
 * @typedef {Object} UCF_SapTable_SelectionInfo
 * @property {boolean} bSelectAll
 * @property {UCF_SapTable_SelectionRange[]} mSelectedRows
 * @property {boolean} bInitialized
 * @property {number} iSelectableRowCount
 * @property {number} iSelectedRows
 * @property {Object<number, true>} oDisabledRows
 */
// #endregion
// #region UCF_SapTable_SelectionRange ========================================
/**
 * @typedef {Object} UCF_SapTable_SelectionRange
 * @property {number} iStart
 * @property {number} iEnd
 */
// #endregion
// #region UCF_SapTable_AccessInfo ============================================
/**
 * @typedef {Object} UCF_SapTable_AccessInfo
 * @property {UCF_BrowserEvent} oBrowserEvent
 * @property {UCF_SapTable_AccessType} eAccessType
 * @property {UCF_SapTable} oTable
 * @property {HTMLElement} oTableDomRef
 * @property {string} sSubControlId
 * @property {HTMLElement} oSubControlDomRef
 * @property {UCF_SapTable_Subcontrol} eSubControlType
 * @property {string} sAccessFragmentType
 * @property {HTMLElement} oAccessFragmentDomRef
 * @property {UCF_SapTable_Action} eAction
 * @property {boolean} bHandled
 * @property {boolean} bForceCancelEvent
 * @property {UCF_SapTable_CellInfo} oCellInfo
 */
// #endregion
// #region UCF_SapTable_BlockSelectionReferencePoint ==========================
/**
 * @typedef {Object} UCF_SapTable_BlockSelectionReferencePoint
 * @property {number} RefCol
 * @property {number} RefRow
 */
// #endregion
// #region UCF_SapTable_BlockSelection ========================================
/** @typedef {{}} UCF_SapTable_DeselectedBlockSelection */
/**
 * @typedef {Object} UCF_SapTable_SelectedBlockSelection
 * @property {number} TopLeftCol
 * @property {number} TopLeftRow
 * @property {number} BottomRightCol
 * @property {number} BottomRightRow
 */
/** @typedef {UCF_SapTable_DeselectedBlockSelection|UCF_SapTable_SelectedBlockSelection} UCF_SapTable_BlockSelection */
// #endregion
// #region UCF_SapTable_DelayedUpdateInfo =====================================
/**
 * @typedef {Object} UCF_SapTable_DelayedUpdateInfo
 * @property {number} iRangeStart
 * @property {number} iNextRangeStart
 */
// #endregion
// #region UCF_SapTable_SkippingStructureVertical =============================
/**
 * @typedef {Object} UCF_SapTable_SkippingStructureVertical
 * @property {number[]} aAreaPositions
 * @property {number} iScrollableStart The cell matrix index from which can be
 * scrolled on client side
 * @property {number} iScrollableEnd The cell matrix index to which can be
 * scrolled on client side
 */
// #endregion
// #region UCF_SapTable_CellPosition ==========================================
/**
 * @typedef {Object} UCF_SapTable_CellPosition
 * @property {number} iRowIndex
 * @property {number} iColIndex
 */
// #endregion
// #region UCF_SapTable_ClippingInfo ==========================================
/**
 * @typedef {Object} UCF_SapTable_ClippingInfo
 * @property {UCF_SapTable_CellInfo} oReferenceCell
 * @property {number} iCellClippingLeft
 * @property {number} iCellClippingRight
 * @property {number} iCellOffsetLeft
 * @property {number} iCellWidth
 * @property {number} iSegmentOffsetLeft
 * @property {number} iSegmentWidth
 * @property {number} iClippingAreaWidth
 */
// #endregion
// #region UCF_SapTable_BlockSelectionMode ====================================
/** @typedef {"NEUTRAL"} UCF_SapTable_NeutralBlockSelectionMode */
/** @typedef {"INITIALIZE"} UCF_SapTable_InitializeBlockSelectionMode */
/** @typedef {"TRANSFORM"} UCF_SapTable_TransformBlockSelectionMode */
/** @typedef {UCF_SapTable_NeutralBlockSelectionMode|UCF_SapTable_InitializeBlockSelectionMode|UCF_SapTable_TransformBlockSelectionMode} UCF_SapTable_BlockSelectionMode */
/**
 * @typedef {Object} UCF_SapTable_BlockSelectionModeEnum
 * @property {UCF_SapTable_NeutralBlockSelectionMode} NEUTRAL
 * @property {UCF_SapTable_InitializeBlockSelectionMode} INITIALIZE
 * @property {UCF_SapTable_TransformBlockSelectionMode} TRANSFORM
 */
// #endregion
// #endregion
/**
 * The mighty SAP Table
 *
 * 
 * @depends UCF_SapTableHeaderCell
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SapTable(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SapTable["_"]["UCF_SapTable"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "SapTable.js(614): UCF_SapTable"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTable.js(615): UCF_SapTable"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SapTable.js(616): UCF_SapTable"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["defineEvents"](['ClientRowSelect']);

		/** @type {UCF_ScrollBase} */
		this["oScrollV"] = null;
		/** @type {UCF_ScrollBase} */
		this["oScrollH"] = null;
		/** @type {boolean} */
		this["bScrollingByKeyboardLocked"] = false;
		/** @type {boolean} */
		this["bKeyboardHandlingInProcess"] = false;
		/** @type {UCF_SapTable_CellInfo[][]} */
		this["aCellInfoMatrix"] = null;
		/** @type {UCF_SapTable_CellInfoMatrixHeadData} */
		this["mCellInfoMatrixHeadData"] = null;
		/** @type {TODO} */
		this["oSelectionMenu"] = null;

		this["initCellInfoMatrix"]();
		this["initScrollbars"]();
		this["initClientSelectionHandling"]();
		this["initHoverEffects"](); //Needs initClientSelectionHandling processed before
		this["initContentListening"](); //Needs initClientSelectionHandling processed before

		/** @type {UCF_SapTable_FocusBehavior} */
		this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["NONE"];
		/** @type {UCF_SapTable_FocusAppearanceEnum} */
		this["eFocusAppearance"] = this["FOCUS_APPEARANCE"]["NEVER"];

		/** @type {UCF_SapTableAccessibilityHelper} */
		this["oAccHelper"] = null;

		/** @type {boolean} */
		this["bZeroBasedScrolling"] = false; // also set by SapTableCS
		/** @type {number} */
		this["iContentRowOffset"] = -1; // also set by SapTableCS
		/** @type {number} */
		this["iRowHeight"] = 21; //Default row height

		this["oDragDropDelegate"] = null;

		this["mAppIndexMap"] = null;

		//initialize the default button for this control
		this["setDefaultButtonId"](this["sDefaultButtonId"]);

		if (this["oScrollH"] && this["bCanClientScroll"](true)) {
			this["oScrollH"]["setNotifactionMode"](
				this["oScrollH"]["NOTIFICATION"]["ALWAYS_WHEN_CHANGED"]
			);
			this["oScrollH"]["attachEvent"](
				this["oScrollH"]["E_EVENTS"]["ClientUpdateResize"],
				this,
				'onHScrollClientUpdateResize'
			);
		}

		/** @type {boolean} */
		this["bScrollByPage"] = false;

		/** @type {boolean} */
		this["bHCTouchLayer"] = false;
		/** @type {boolean} */ // eslint-disable-next-line @ur/no-memory-leaks
		this["bHCTouchLayerActivated"] = false;

		this["iLastAppliedDragHoverStyle"] = -1;

		/** @type {UCF_SapTable_SelectionInfo} */
		this["oSelectionInfo"] = this["oSelectionInfo"] = {
			"bSelectAll": false,
			"mSelectedRows": [],
			"bInitialized": false,
			"iSelectableRowCount": 0,
			"iSelectedRows": 0,
			"oDisabledRows": {},
			"bBlockSelectAll": false,
			"bColumnSelectAll": false
		};

		/** @type {boolean} */
		this["bDoubleClickGateOpened"] = false;
		/** @type {HTMLElement} */
		this["oDoubleClickedDomRef"] = null;
		/** @type {string} */
		this["sDoubleClickTimeout"] = null;

		/** @type {boolean} */
		this["bMouseAccessInside"] = false;

		/** @type {string} */
		this["sCellSelectSubControlId"] = '';

		/** @type {boolean} */ // eslint-disable-next-line @ur/no-memory-leaks
		this["bNativeHorizontalScrollMode"] = UCF_UserAgent["bIsIE"]()
			&& window["UCF_System"]["sDevice"] === 'standards'
			&& !window["UCF_System"]["bIsRTL"]
			&& this["bNativeHScrollingEnabled"]();

		/** @type {UCF_SapTable_SkippingStructureVertical} */
		this["mSkippingStructureVertical"] = null;

		//set draggable attribute at TR level
		this["setDraggableRows"]();

		/** @type {UCF_SapTable_BlockSelection} */
		this["oBlockSelection"] = null;
		/** @type {UCF_SapTable_BlockSelection} */
		this["oBlockSelectionPrevious"] = null;
		/** @type {UCF_SapTable_BlockSelectionReferencePoint} */
		this["oBSRefPoint"] = null;
		this["oBSFocus"] = null;
		this["aBlockSelectionCells"] = [];
		this["aTransformBlockSelectionCells"] = [];
		this["aNeutralBlockSelectionCells"] = [];
		this["bBlockSelectionInitialized"] = false;
		this["sReducedBlockSelection"] = '';
		/** @type {boolean} */
		this["bCopyToClipboardEnabled"] = false;

		/** @type {UCF_PopupMenu} */
		this["oHeaderActionMenu"] = null;

		/** @type {Object<string, UCF_DataTip>} */
		this["mDataTips"] = null;

		/** @type {string} */
		this["sRemoveVisualizeCopyToClipboardDelayedCallId"] = null;

		/** @type {boolean} */
		this["bTriggerShiftHomeRowSelection"] = false;
		/** @type {boolean} */
		this["bTriggerShiftHomeColumnSelection"] = false;

		this["sRowDragSelectAccess"] = '';
		this["bRowDragSelectActive"] = false;
		this["bRowDragSelectStart"] = false;
		this["mRowDragSelectExceptionMap"] = null;

		this["sFocusInfo"] = '';
		this["bMouseDown"] = false;
		this["bCancelSelection"] = false;
		// threshold of rowCount for blockSelection handling
		this["iRowCountThreshold"] = 500;
		this["bFocusChanged"] = false;
		this["oSelectStartEditor"] = null;
	}
};window["UCF_SapTable"] = UCF_SapTable; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTable"); UCF_SapTable["_"] = {UCF_SapTable: 0}; }; ;

UCF_SapTable["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_SapTable.prototype["sClassName"] = "UCF_SapTable";

/******************************************************
 ** DESTRUCTOR
 *******************************************************/
/**
 * Destructor
 * @private
 */
UCF_SapTable["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["destroy"]++; }; 
	this["eFocusAppearance"] = 0;
	this["eFocusBehavior"] = 0;

	if (
		this["oScrollH"] &&
		this["sHorizontalScrollUpdateMode"] === this["SCROLL_UPDATE_MODE"]["CLIENT"]
	) {
		this["oScrollH"]["detachEvent"](
			this["oScrollH"]["E_EVENTS"]["ClientUpdateResize"],
			this,
			'onHScrollClientUpdateResize'
		);
	}

	this["cleanUpColorProcessing"]();
	this["cleanUpHeaderActionMenu"]();
	this["cleanUpSelectionMenu"]();
	this["cleanUpScrollbars"]();
	this["cleanUpHoverEffects"]();

	this["cleanUpCellInfoMatrix"]();

	//this.cleanUpDragDrop();
	if (this["oAccHelper"]) {
		this["oAccHelper"]["destroy"]();
		this["oAccHelper"] = null;
	}

	this["cleanUpClientSelectionHandling"]();

	//needed for autoscroll
	if (this["oDragDropDelegate"]) {
		this["oDragDropDelegate"]["cleanUpDragDrop"]();
	}

	this["mAppIndexMap"] = null;

	this["cleanUpContentListening"]();
	this["cleanUpNavigateSkipping"]();

	this["cleanUpScrollbarHeightAdoption"]();

	if (this["bColumnTitleAdoption"]) {
		this["detachBrowserEvent"]('resize', this["oDomRef"]);
	}

	this["oSelectionInfo"] = null;

	this["bDoubleClickGateOpened"] = false;
	this["oDoubleClickedDomRef"] = null;
	this["sDoubleClickTimeout"] = null;
	this["sRemoveVisualizeCopyToClipboardDelayedCallId"] = null;
	this["bTriggerShiftHomeRowSelection"] = false;
	this["bTriggerShiftHomeColumnSelection"] = false;
	this["bMouseAccessInside"] = false;

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	this["iContentRowOffset"] = 0;
	if (this["oDragDropDelegate"]) {
		this["oDragDropDelegate"]["destroy"]();
		this["oDragDropDelegate"] = null;
	}
	this["iLastAppliedDragHoverStyle"] = 0;
	this["sCellSelectSubControlId"] = '';
	this["oBlockSelection"] = null;
	this["oBlockSelectionPrevious"] = null;
	this["oBSRefPoint"] = null;
	this["sBlockSelection"] = '';
	this["sReducedBlockSelection"] = '';
	this["bCopyToClipboardEnabled"] = false;
	this["oDelayedDoubleClickedDomRef"] = null;
	this["iStartPageX"] = 0;
	this["iStartPageY"] = 0;
	this["iRowSelectionReferenceIndex"] = 0;
	this["iRowSelectionRangeEndIndex"] = 0;
	this["iLastStandardSelectionRowIndex"] = 0;
	this["sLastHeaderActionMenu"] = null;
	this["iLastEnteredRow"] = 0;
	this["bInitializeHorizontalScrollbar"] = false;
	this["HCTouchLayerMenu"] = null;
	this["HCTouchLayerResize"] = null;
	this["unmarkTouchLayerRedirect"] = null;
	this["sDataTipTimeOutId"] = '';
	this["iMatrixContentRowCount"] = 0;
	this["iMatrixRowCount"] = 0;
	this["iRowCount"] = 0;
	this["sDropTargetInfo"] = '';
	this["sDragSourceInfo"] = '';
	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}
	this["iHorizontalScrollPosition"] = 0;
	this["aBlockSelectionCells"] = null;
	this["aTransformBlockSelectionCells"] = null;
	this["aNeutralBlockSelectionCells"] = null;
	this["bBlockSelectionInitialized"] = false;
	this["sRowDragSelectAccess"] = '';
	this["bRowDragSelectActive"] = false;
	this["bRowDragSelectStart"] = false;
	this["mRowDragSelectExceptionMap"] = null;
	this["sFocusInfo"] = '';
	this["bMouseDown"] = false;
	this["bCancelSelection"] = false;
	this["bFocusChanged"] = false;
	this["oSelectStartEditor"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["destroy"] = 0; };

/**
 * Initialize when appears on screen
 * @private
 */
UCF_SapTable["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initialize"]++; }; 
	// !!!! This method is overwritten by SapTableCS
	var row = 0;
	var col = 0;
	var oCellInfo = null;

	if (this["bInitializeHorizontalScrollbar"]) {
		this["updateHorizontalScrollDimensions"]();
	}

	this["initScrollbarHeightAdoption"]();

	if (this["sBlockSelection"] && (this["bBlockSelectionActive"]())) {
		this["reduceBSProperties"]();
		this["oBlockSelection"] = UCF_JsUtil["oJsonParse"](this["sReducedBlockSelection"]);

		// add to neutral block selection cells once
		this["aNeutralBlockSelectionCells"] = [];
		for (col = this["oBlockSelection"]["TopLeftCol"]; col <= this["oBlockSelection"]["BottomRightCol"]; col++) {
			for (row = this["oBlockSelection"]["TopLeftRow"]; row <= this["oBlockSelection"]["BottomRightRow"]; row++) {
				oCellInfo = this["oGetCellInfo"](row, col);
				if (oCellInfo) this["aNeutralBlockSelectionCells"]["push"](oCellInfo);
			}
		}

		this["applyBlockSelection"](this["BLOCKSELECTION_MODE"]["INITIALIZE"], true);
		this["oSelectionInfo"]["bBlockSelectAll"] = this["bSelectionInfoBlockSelectAll"]();
		UCF_DomUtil["addClass"](this["oRootRef"], 'lsSapTable--bs-exist');
	}

	if (this["bColumnTitleAdoption"]) {
		this["attachBrowserEvent"]('resize', this["oDomRef"]);
		this["adjustHeaderCellCaptions"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initialize"] = 0; };

/******************************************************
 ** CONSTANTS
 *******************************************************/
/** @type {number} */
UCF_SapTable["prototype"]["MIN_COL_WIDTH"] = 25; // eslint-disable-line no-magic-numbers
/** @type {number} */
UCF_SapTable["prototype"]["APPDEFINED_ROW_DEFAULT_INDEX"] = -2147483648;

/**
 * Keyboard modifier
 * @type {UCF_SapTable_ModifierEnum}
 */
UCF_SapTable["prototype"]["MODIFIER_NAME"] = {
	"SHIFT": 'SHIFT',
	"CTRL": 'CTRL',
	"ALT": 'ALT'
};

/**
 * Subcontrol types
 * @type {UCF_SapTable_SubcontrolEnum}
 */
UCF_SapTable["prototype"]["SUBCONTROL"] = {
	"NONE": false,
	"TABLE": 'ST',
	"HEADER_CELL": 'HC',
	"STANDARD_CELL": 'STC',
	"HIERARCHY_CELL": 'HIC',
	"MATRIX_CELL": 'MC',
	"SELECTION_CELL": 'SC',
	"POPIN_CELL": 'PC'
};

/**
 * Table cell types
 * @type {UCF_SapTable_CellTypeEnum}
 */
UCF_SapTable["prototype"]["EVENT_PARAM_MAP_CELL_TYPE"] = {
	"STC": 'SapTableCell',
	"HIC": 'SapTableHierarchicalCell',
	"MC": 'SapTableMatrixCell',
	"SC": 'SapTableSelectionCell',
	"PC": 'SapTableCell',
	"HC": 'SapTableHeaderCell'
};

/**
 * ColumnReorder event params
 * @type {UCF_SapTable_ColumnReorderEnum}
 */
UCF_SapTable["prototype"]["EVENT_PARAM_MAP_INSERT_MODE"] = {
	"NONE": 'NONE',
	"AFTER": 'AFTER',
	"BEFORE": 'BEFORE'
};

/**
 * Access type event params
 * @type {UCF_SapTable_EventMapAccessTypeEnum}
 */
UCF_SapTable["prototype"]["EVENT_PARAM_MAP_ACCESS_TYPE"] = {
	"INVALID": 'INVALID',
	"STANDARD": 'STANDARD',
	"RANGE": 'RANGE',
	"TOGGLE": 'TOGGLE',
	"SELECT_ALL": 'SELECT_ALL',
	"DESELECT_ALL": 'DESELECT_ALL',
	"SET": 'SET',
	"ADD": 'ADD',
	"REMOVE": 'REMOVE',
	"UPDATE": 'UPDATE'
};

/**
 * Trigger action event params
 * @type {UCF_SapTable_EventMapTriggerActionEnum}
 */
UCF_SapTable["prototype"]["EVENT_PARAM_MAP_TRIGGER_ACTION"] = {
	"MOUSE": 'MOUSE',
	"ENTER": 'ENTER',
	"SPACE": 'SPACE',
	"FOCUS": 'FOCUS'
};

/**
 * Actions
 * @type {UCF_SapTable_ActionEnum}
 */
UCF_SapTable["prototype"]["ACTION"] = {
	"NONE": '',
	"CELL_SELECT": 'CSEL',
	"HEADER_ICON": 'HCICO',
	"HEADER_SORT": 'HCSORT',
	"HIERARCHY_EXPAND": 'HICEXP',
	"HIERARCHY_COLLAPSE": 'HICCOL',
	"HIERARCHY_ALTERNATIVE": 'HICALT',
	"SELECTION_MENU_OPEN": 'SELMNUOPN',
	"HEADER_ACTION_MENU_OPEN": 'HCACTMNUOPN',
	"FILTER": 'FLTR',
	"FILTER_ENTER": 'FLTR_ENTER',
	"COL_RESIZE": 'CRESIZE',
	"COL_DRAG": 'CDRAG',
	"TABLE_V_RESIZE": 'TVRESIZE',
	"TABLE_END": 'TABLE_END',
	"CONFIG": 'CONFIG',
	"NO_DATA_NOTIFICATION": 'NO_DATA_NOTIFICATION',
	"SELECTION_COLUMN_TOGGLE": 'SELCOLTOGGLE',
	"BLOCK_SELECT": 'BLOCKSEL'
};

/**
 * Access types
 * @typedef {UCF_SapTable_AccessTypeEnum}
 */
UCF_SapTable["prototype"]["ACCESS_TYPE"] = {
	"NONE": 0,
	"MOUSE": 1,
	"KEYBOARD_SELECT": 2,
	"KEYBOARD_EXPAND": 3,
	"KEYBOARD_COLLAPSE": 4,
	"DRAG_START": 5,
	"DRAG": 6,
	"DRAG_END": 7,
	"DRAG_OVER": 8,
	"DROP": 9,
	"DRAG_ENTER": 10,
	"DRAG_LEAVE": 11,
	"S_508": 12,
	"HOTKEY": 13,
	"KEYBOARD_ENTER": 14,
	"KEYBOARD_NAVIGATE": 15,
	"KEYBOARD_TAB": 16,
	"KEYBOARD_ESCAPE": 17
};

/**
 * Suffix
 * @typedef {UCF_SapTable_SuffixEnum}
 */
UCF_SapTable["prototype"]["SUFFIX"] = {
	"NONE": '',
	"SCROLL_V": 'scrollV',
	"SCROLL_H": 'scrollH',
	"CONTENT_TBODY": 'contentTBody',
	"CONTENT_AREA": 'content',
	"TOOLBAR_CELL": 'toolbar',
	"FOOTER_CELL": 'footer',
	"LEGEND_CONTAINER": 'legendContainer',
	"RESIZE_HANDLE": 'CRESIZE',
	"HC_CONTENT": 'CONTENT'
};

/**
 * Hover Effects
 * @type {UCF_SapTable_HoverEffectEnum}
 */
UCF_SapTable["prototype"]["HOVER_EFFECT"] = {
	"NONE": '',
	"DIVIDER": 'hoverDivider',
	"ACTION_MENU": 'hoverActMenu',
	"HEADER_BG": 'hoverHdrBg',
	"TABLE": 'hoverTable',
	"RESIZE_HANDLE": 'hoverResizeHandle'
};

/**
 * Navigation types
 * @type {UCF_SapTable_NavigationEnum}
 */
UCF_SapTable["prototype"]["NAVIGATION"] = {
	"NONE": 0,
	"LEFT": 1,
	"RIGHT": 2,
	"HOME": 3,
	"END": 4,
	"UP": 5,
	"DOWN": 6,
	"TOP": 7,
	"BOTTOM": 8,
	"PAGE_UP": 9,
	"PAGE_DOWN": 10,
	"NEXT_COLUMN_PAGE": 11,
	"PREVIOUS_COLUMN_PAGE": 12,
	"TOP_BEGIN": 13,
	"BOTTOM_END": 14
};

/** @type {UCF_SapTable_FocusBehaviorEnum} */
UCF_SapTable["prototype"]["FOCUS_BEHAVIOR"] = {
	"NONE": 0,
	"CELL": 1,
	"FILTER": 2,
	"SELECTION_MENU": 3,
	"HEADER_SORT": 4,
	"HEADER_ICON": 5
};

/** @type {UCF_SapTable_FocusAppearanceEnum} */
UCF_SapTable["prototype"]["FOCUS_APPEARANCE"] = {
	"NEVER": 0,
	"ALWAYS": 1,
	"INPUT": 2
};

/** @type {UCF_SapTable_RowTypeEnum} */
UCF_SapTable["prototype"]["ROW_TYPE"] = {
	"UNSPECIFIED": 0,
	"STANDARD": 1,
	"HEADER": 2,
	"FILTER": 3,
	"TOP_FIXED": 4,
	"BOTTOM_FIXED": 5,
	"PIVOT": 6
};

/** @type {UCF_SapTable_ScrollUpdateModeEnum} */
UCF_SapTable["prototype"]["SCROLL_UPDATE_MODE"] = {
	"CLIENT": 'CLIENT',
	"SERVER": 'SERVER'
};

/** @type {UCF_SapTable_BlockSelectionModeEnum} */
UCF_SapTable["prototype"]["BLOCKSELECTION_MODE"] = {
	"NEUTRAL": 'NEUTRAL',
	"INITIALIZE": 'INITIALIZE',
	"TRANSFORM": 'TRANSFORM'
};

/******************************************************
 ** METHODS of the control interface
 *******************************************************/

/**
 * Returns the content theme scope (e.g. lsCondensed)
 *
 * @public
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetContentThemeScope"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetContentThemeScope"]++; }; 
	return this["sContentThemeScope"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetContentThemeScope"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @public
 * @param {string} sDefaultButtonId string Id of the button that is executed if
 * the user presses enter
 */
UCF_SapTable["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDefaultButtonId"]++; }; 
	UCF_Control.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDefaultButtonId"] = 0; };

/**
 * Puts a HTML content in the browser clipboard
 *
 * @public
 * @param {string} sHtmlContent
 */
UCF_SapTable["prototype"]["setClipboardHtml"] = function(sHtmlContent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setClipboardHtml"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sHtmlContent === 'string', "typeof sHtmlContent === 'string'", "SapTable.js(1192): setClipboardHtml"); };
	UCF_ClipboardUtil["setHtmlToClipboard"](sHtmlContent);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setClipboardHtml"] = 0; };

/**
 * Sets/resets the primary row selection state
 *
 * @public
 * @param {string} sCellId The ID of a cell belonging to the row
 * @param {boolean} bSet `true`=select, `false`=deselect
 */
UCF_SapTable["prototype"]["setPrimaryRowSelection"] = function(sCellId, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setPrimaryRowSelection"]++; }; 
	/** @type {number} */
	var iRowIndex;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(1207): setPrimaryRowSelection"); };

	iRowIndex = this["iGetInternalRowIndexByCellId"](sCellId);

	this["setPrimarySelectionByIndex"](iRowIndex, bSet);

	if (iRowIndex === this["mCellInfoMatrixHeadData"]["iFocussedCellRowIndex"]) {
		this["updateScreenreaderAnnoucement"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setPrimaryRowSelection"] = 0; };

/**
 * Sets/resets the row selection state
 *
 * @public
 * @param {string} sCellId The ID of a cell belonging to the row
 * @param {boolean} bSet `true`=select, `false`=deselect
 */
UCF_SapTable["prototype"]["setRowSelection"] = function(sCellId, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowSelection"]++; }; 
	/** @type {number} */
	var iRowIndex;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(1229): setRowSelection"); };

	iRowIndex = this["iGetInternalRowIndexByCellId"](sCellId);

	this["updateSelectionInfo"](iRowIndex, 1, bSet);

	this["setSecondarySelectionByIndex"](iRowIndex, bSet);

	if (iRowIndex === this["mCellInfoMatrixHeadData"]["iFocussedCellRowIndex"]) {
		this["updateScreenreaderAnnoucement"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowSelection"] = 0; };

/**
 * Resets the all rows row selection state
 *
 * @public
 */
UCF_SapTable["prototype"]["clearRowSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["clearRowSelection"]++; }; 
	this["updateSelectionInfo"](0, this["iGetCellInfoMatrixLastRowIndex"]() + 1, false);

	this["processRowSelectionMassUpdate"](
		0,
		this["iGetCellInfoMatrixLastRowIndex"]() + 1,
		false,
		(this["SELECTION_LAYER"]["ROW"] | this["SELECTION_LAYER"]["ROW_PRIMARY"])
	);

	this["updateScreenreaderAnnoucement"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["clearRowSelection"] = 0; };

/**
 * Sets/resets the column selection state
 *
 * @public
 * @param {string} sCellId The ID of a cell belonging to the column
 * @param {boolean} bSet `true`=select, `false`=deselect
 */
UCF_SapTable["prototype"]["setColumnSelection"] = function(sCellId, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setColumnSelection"]++; }; 
	/** @type {number} */
	var iColIndex;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(1271): setColumnSelection"); };

	iColIndex = this["iGetInternalColIndexByCellId"](sCellId);

	if (!(
			this["eGetColSelectionState"](iColIndex) &
			this["SELECTION_LAYER"]["COLUMN_DISABLED"]
		)) {
		this["setColumnSelectionByIndex"](iColIndex, bSet);

		if (iColIndex === this["mCellInfoMatrixHeadData"]["iFocussedCellColIndex"]) {
			this["updateScreenreaderAnnoucement"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setColumnSelection"] = 0; };

/**
 * @public
 * @param {string} sBlockSelection The BlockSelection JSON
 */
UCF_SapTable["prototype"]["setBlockSelection"] = function(sBlockSelection) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setBlockSelection"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sBlockSelection === 'string', "typeof sBlockSelection === 'string'", "SapTable.js(1292): setBlockSelection"); };

	var row = 0;
	var col = 0;
	var oCellInfo = null;
	var oBlockSelection = {};

	this["sBlockSelection"] = sBlockSelection;
	this["setClientProperty"]('BlockSelection', this["sBlockSelection"], true);
	this["reduceBSProperties"]();

	if (this["sBlockSelection"] && this["bBlockSelectionActive"]()) {
		// add to neutral block selection cells once
		oBlockSelection = UCF_JsUtil["oJsonParse"](this["sReducedBlockSelection"]);
		this["aNeutralBlockSelectionCells"] = [];
		for (col = oBlockSelection["TopLeftCol"]; col <= oBlockSelection["BottomRightCol"]; col++) {
			for (row = oBlockSelection["TopLeftRow"]; row <= oBlockSelection["BottomRightRow"]; row++) {
				oCellInfo = this["oGetCellInfo"](row, col);
				if (oCellInfo) this["aNeutralBlockSelectionCells"]["push"](oCellInfo);
			}
		}

		this["setBlockSelectionInternal"](
			oBlockSelection,
			this["BLOCKSELECTION_MODE"]["INITIALIZE"],
			true,
			false
		);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setBlockSelection"] = 0; };

/**
 * Refocus to recalculate announcement after mapi call to update screenreader
 * announcement
 *
 * @private
 */
UCF_SapTable["prototype"]["updateScreenreaderAnnoucement"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateScreenreaderAnnoucement"]++; }; 
	/** @type {HTMLElement} */
	var oActiveElement;

	// Refocus to recalculate announcement after mapi call
	if (window["UCF_System"]["bIs508"]) {
		oActiveElement = UCF_DomUtil["oGetActiveElement"]();

		if (oActiveElement) {
			UCF_DomUtil["refocusDomElement"](oActiveElement);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateScreenreaderAnnoucement"] = 0; };

/**
 * @public
 * @param {string} sCellId sCellId The ID of a cell belonging to the row
 * @return {boolean} the primary row selection state (`true`=selected,
 * `false`=deselected)
 */
UCF_SapTable["prototype"]["getPrimaryRowSelection"] = function(sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getPrimaryRowSelection"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(1350): getPrimaryRowSelection"); };

	return !!(this["eGetRowSelectionState"](
		this["iGetInternalRowIndexByCellId"](sCellId)
	) & this["SELECTION_LAYER"]["ROW_PRIMARY"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getPrimaryRowSelection"] = 0; };

/**
 * @public
 * @param {string} sCellId sCellId The ID of a cell belonging to the row
 * @return {boolean} the row secondary selection state (`true`=selected,
 * `false`=deselected)
 */
UCF_SapTable["prototype"]["getRowSelection"] = function(sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getRowSelection"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(1364): getRowSelection"); };

	return !!(this["eGetRowSelectionState"](
		this["iGetInternalRowIndexByCellId"](sCellId)
	) & this["SELECTION_LAYER"]["ROW"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getRowSelection"] = 0; };

/**
 * @public
 * @param {string} sCellId The ID of a cell belonging to the column
 * @return {boolean} the column selection state (`true`=selected,
 * `false`=deselected)
 */
UCF_SapTable["prototype"]["getColumnSelection"] = function(sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getColumnSelection"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefCell;
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(1383): getColumnSelection"); };

	oDomRefCell = UCF_DomUtil["$"](sCellId);
	oCellInfo = (oDomRefCell) ? this["oGetCellInfoByDomRef"](oDomRefCell) : null;

	if (oCellInfo) {
		return !!(this["eGetColSelectionState"](oCellInfo["iColIndex"]) & this["SELECTION_LAYER"]["COLUMN"]);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Cell with ID="' + sCellId + '" does not exist. No selection triggered.', "SapTable.js(1391): getColumnSelection"); };
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getColumnSelection"] = 0; };

/**
 * @public
 * @param {number} iRowIndex
 * @param {number} iColIndex
 * @return {string} the serialized focus information string which can be used
 * to focus a specific cell in the table. The serialized string must not be
 * modified by the framework.
 */
UCF_SapTable["prototype"]["getFocusInfoByIndex"] = function(iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getFocusInfoByIndex"]++; }; 
	/** @type {number} */
	var iMaxInternalRowIndex = this["iGetCellInfoMatrixLastRowIndex"]();
	/** @type {UCF_SapTable_CellInfo} */
	var oCellToFocus = null;
	/** @type {string} */
	var sResult = '';
	/** @type {number} */
	var iInternalRowIndex;
	/** @type {number} */
	var iMaxInternalColIndex;
	/** @type {number} */
	var iInternalColIndex;
	/** @type {UCF_FocusInfo} */
	var oFocusInfo;

	for (iInternalRowIndex = 0; iInternalRowIndex <= iMaxInternalRowIndex; iInternalRowIndex++) {
		if (this["iGetApiRowIndex"](this["oGetCellInfo"](iInternalRowIndex, 0)) === iRowIndex) {
			iMaxInternalColIndex = this["iGetCellInfoMatrixLastColIndex"]();

			for (iInternalColIndex = 0; iInternalColIndex <= iMaxInternalColIndex; iInternalColIndex++) {
				if (this["iGetApiColIndex"](this["oGetCellInfo"](iInternalRowIndex, iInternalColIndex)) === iColIndex) {
					oCellToFocus = this["oGetCellInfo"](iInternalRowIndex, iInternalColIndex);
					break;
				}
			}
			break;
		}
	}

	if (oCellToFocus) {
		oFocusInfo = new (UCF_ClassLoader["oGetClass"]("UCF_FocusInfo"))(this["oLS"]);
		oFocusInfo["init"](null);

		oFocusInfo["setApplyControl"](this);
		oFocusInfo["addParam"]('iRowIndex', oCellToFocus["iRowIndex"]);
		oFocusInfo["addParam"]('iColIndex', oCellToFocus["iColIndex"]);

		sResult = oFocusInfo["sSerialize"]();
		oFocusInfo["cleanUp"]();
	}

	return sResult;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getFocusInfoByIndex"] = 0; };

/**
 * Returns all primary and secondary selected rows existing on client side.
 *
 * @return {number[]} Array of int with the indices of the selected rows
 * @private
 */
UCF_SapTable["prototype"]["getSelectedRows"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getSelectedRows"]++; }; 
	/** @type {UCF_SapTable_CellInfo[]} */
	var aCellInfos = this["aGetSelectedRows"]();
	/** @type {number[]} */
	var aRowIndices = [];
	/** @type {number} */
	var i;

	for (i = 0; i < aCellInfos["length"]; i++) {
		aRowIndices[aRowIndices["length"]] = this["iGetApiRowIndex"](aCellInfos[i]);
	}

	if (typeof aCellInfos["iPrimary"] === 'number') {
		aRowIndices["iPrimary"] = this["iGetApiRowIndex"](aCellInfos[aCellInfos["iPrimary"]]);
	}

	return aRowIndices;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getSelectedRows"] = 0; };

/******************************************************
 ** EVENT HANDLER RAISED BY LS FRAMEWORK
 *******************************************************/

/**
 * Event handler
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oncontextmenu"]++; }; 
	/** @type {UCF_SapTable_AccessInfo} */
	var oAccessInfo;
	var oCellInfo = null;
	var bSelected = false;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(1492): oncontextmenu"); };
	if (this["bCancelHandlerProcessing"](oBrowserEvent)) {
		return undefined;
	}

	oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);

	if (this["bBlockSelectionActive"]() && oAccessInfo && oAccessInfo["oCellInfo"]) {
		oCellInfo = oAccessInfo["oCellInfo"];
		bSelected = ((this["eGetCellSelectionState"](oCellInfo["iRowIndex"], oCellInfo["iColIndex"]) & this["SELECTION_LAYER"]["CELL"]) ||
		(this["eGetColSelectionState"](oCellInfo["iColIndex"]) & this["SELECTION_LAYER"]["COLUMN"]) ||
		(this["eGetRowSelectionState"](oCellInfo["iRowIndex"]) & this["SELECTION_LAYER"]["ROW"]))  ? true : false;

		if (this["bIsNavigateableTableCell"](oAccessInfo["eSubControlType"]) && (!oAccessInfo["oAccessFragmentDomRef"] ||!UCF_DomUtil["bHasTabIndex"](oAccessInfo["oAccessFragmentDomRef"]))) {
			this["setCellMatrixFocusByCellInfo"](
				oAccessInfo["oCellInfo"],
				oBrowserEvent["oGetSource"]()
			);
		}

		if (oAccessInfo["eSubControlType"] === this["SUBCONTROL"]["HEADER_CELL"]) {
			if ((this["bIsCellSelect"](
					oAccessInfo,
					UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT_XOR_CTRL"]
				) || oAccessInfo["eAction"] === this["ACTION"]["COL_RESIZE"]) && !bSelected) {
				this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
				this["internalFireHeaderCellSelect"](oAccessInfo);
			}
		} else if (oAccessInfo["eSubControlType"] === this["SUBCONTROL"]["STANDARD_CELL"]) {
			if (this["bIsCellSelect"](
					oAccessInfo,
					UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT_XOR_CTRL"]
				) && !bSelected) {
				this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
				this["internalFireCellSelect"](oAccessInfo);
			}
		} else if (oAccessInfo["eSubControlType"] === this["SUBCONTROL"]["SELECTION_CELL"]) {
			if (this["bIsCellSelect"](
					oAccessInfo,
					UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT_XOR_CTRL"]
				) && !bSelected) {
				this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
				this["internalFireSelectionCellSelect"](oAccessInfo);

			}
		}
	}

	if (
		this["mEvents"]["CellContextMenu"] &&
		oAccessInfo &&
		oAccessInfo["oCellInfo"] &&
		this["bCanFireContextMenuEvent"](oAccessInfo)
	) {
		this["doFireCellContextMenu"](oAccessInfo, oBrowserEvent);

		this["cancelBubbleEventInternal"](oBrowserEvent);
		this["cancelEventInternal"](oBrowserEvent);

		return false;
	}

	return undefined;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oncontextmenu"] = 0; };

/**
 * Event handler
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onresize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(1564): onresize"); };
	this["handleScrollbarHeightAdoption"](oBrowserEvent);
	if (this["bColumnTitleAdoption"]) {
		this["adjustHeaderCellCaptions"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onresize"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(1577): onclick"); };

	if (this["bBlockSelectionActive"]() && this["bCancelSelection"]) {
		this["bMouseDown"] = false;
		this["bCancelSelection"] = false;
		return undefined;
	}

	if (this["bCancelHandlerProcessing"](oBrowserEvent)) { return undefined; }

	if (!this["bIsQuickRowSelect"](oBrowserEvent)) {
		if (oBrowserEvent["oGetSource"]()["bQuickSelect"]) {
			// This is necessary due to a client method can set the state by
			// mousedown. The mouseup/click will again deselect
			oBrowserEvent["oGetSource"]()["bQuickSelect"] = false;
		} else {
			return this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);
		}
	}

	return undefined;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onclick"] = 0; };

/** "open" double click gate */
UCF_SapTable["prototype"]["openDoubleClickGate"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["openDoubleClickGate"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Open double click gate', "SapTable.js(1602): openDoubleClickGate"); };
	this["bDoubleClickGateOpened"] = true;
	// eslint-disable-next-line no-magic-numbers
	this["sDoubleClickTimeout"] = UCF_JsUtil["delayedCall"](
		300,
		this,
		'closeDoubleClickGate',
		[]
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["openDoubleClickGate"] = 0; };

/** "close" double click gate */
UCF_SapTable["prototype"]["closeDoubleClickGate"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["closeDoubleClickGate"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Close double click gate', "SapTable.js(1615): closeDoubleClickGate"); };
	this["bDoubleClickGateOpened"] = false;
	this["sDoubleClickTimeout"] = null;
	this["oDelayedDoubleClickedDomRef"] = null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["closeDoubleClickGate"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onmousedown"]++; }; 
	/** @type {string} */
	var sSrcElementId;
	/** @type {boolean} */
	var bDoubleClick;
	/** @type {UCF_SapTable_AccessInfo} */
	var oAccessInfo;
	/** @type {HTMLElement} */
	var oResizeHandle;
	/** @type {string} */
	var sDomRefSourceTagName;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(1638): onselectstart"); };

	this["bMouseDown"] = true;
	this["bCancelSelection"] = false;
	this["bFocusChanged"] = false;
	// mark mouse access inside SapTable from mousedown to next focus in order to identify
	// within lsfocus handler wether the focus event at SapTable root DomRef
	// has been triggered by a non focusable Dom Element within the SapTable
	this["bMouseAccessInside"] = true;

	// HeaderCell TouchLayer
	sSrcElementId = oBrowserEvent["oGetSource"]()["getAttribute"]('id');

	this["bHCTouchLayerActivated"] = sSrcElementId
		&& sSrcElementId["indexOf"]('HCTouchLayer') !== -1;

	if (this["bCancelHandlerProcessing"](oBrowserEvent)) { return undefined; }

	if (oBrowserEvent["eGetMouseButtonState"]() !==
		oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"]) { return undefined; }

	// Check for double click. This is needed in IE Standards Mode. Deleting the
	// selection on the first click of a double click makes it impossible to
	// select a cell content via double click. In Quirks Mode this issue does not
	// occur, because there is only one click even cycle for a double click. In
	// other browsers, removing the selection in onmousedown is no harm.
	if (this["bDoubleClickGateOpened"]) {
		if (oBrowserEvent["oGetSource"]() === this["oDelayedDoubleClickedDomRef"]) {
			bDoubleClick = true;
		} else {
			this["closeDoubleClickGate"]();
			this["oDelayedDoubleClickedDomRef"] = oBrowserEvent["oGetSource"]();
			this["openDoubleClickGate"]();
		}
	} else {
		this["oDelayedDoubleClickedDomRef"] = oBrowserEvent["oGetSource"]();
		this["openDoubleClickGate"]();
	}

	// Sometimes IE does not clear selection text when mouse is pressed.
	// Therefore we call it explicitly. See I-1786179 2010. When by capturing is
	// turned on the selection is handled by the cell editor. In this case don't
	// "steal" the selection. See I-3320841 2010
	if (
		!this["bCapturedEventProcessing"] ||
		!this["bHasValidTextSelection"](oBrowserEvent)
	) {
		if (bDoubleClick) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Do not remove text selection on double click', "SapTable.js(1686): onselectstart"); };
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Remove text selection', "SapTable.js(1688): onselectstart"); };
			UCF_DomUtil["removeSelection"](document);
		}
	}

	// temporarily deactivate native selectstart to avoid confusing text
	// selection when performing cell range select in MSIE deactivate only if
	// CellSelect RANGE is being processed to stillsupport text selection
	// within cell Editors
	if (oBrowserEvent["bShift"]() && window["UCF_System"]["sUserAgentName"] === 'MSIE') {
		oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);

		if (
			this["sCellSelectSubControlId"] &&
			this["sCellSelectSubControlId"] !== oAccessInfo["sSubControlId"]
		) {
			document["onselectstart"] = function() { return false; };
			setTimeout(function() {
				document["onselectstart"] = null;
			}, 0);
		}
	}

	// This is needed for the drag drop to Excel feature
	if (oBrowserEvent["oGetSource"]()["getAttribute"]('cdd')) {
		this["bAllowTextSelection"] = true;
		oBrowserEvent["oGetSource"]()["createTextRange"]()["select"]();

		this["cancelBubbleEventInternal"](oBrowserEvent);
	} else {
		this["bAllowTextSelection"] = false;

		// Ingos code for row drag drop
		if (this["sGetDragSourceInfo"]() != '') { // eslint-disable-line eqeqeq
			oBrowserEvent["oGetSourceControl"]()["bAllowTextSelection"] = false;
		}
	}

	oResizeHandle = UCF_DomUtil["oGetParentByAttribute"](
		oBrowserEvent["oGetSource"](),
		'acf',
		this["ACTION"]["TABLE_V_RESIZE"]
	);
	if (oResizeHandle) {
		this["updateCssClass"](oResizeHandle, 'lsTableResizeHandleActivated', true);
	}

	if (this["bIsQuickRowSelect"](oBrowserEvent) && !bDoubleClick) {
		// This is necessary due to a client method can set the state by mousedown.
		// The mouseup/click will again deselect
		oBrowserEvent["oGetSource"]()["bQuickSelect"] = true;

		return this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);
	} else {
		if (oBrowserEvent["oGetSource"]()["bQuickSelect"]) {
			oBrowserEvent["oGetSource"]()["bQuickSelect"] = false;
		}

		// Avoid text selection in FireFox when Row D&D is enabled
		// This can only be done while mousdown
		if (UCF_UserAgent["bIsGecko"]() && this["sGetRowRootDragSourceInfo"]()) {
			sDomRefSourceTagName = oBrowserEvent["oGetSource"]()["tagName"];

			if (
				sDomRefSourceTagName !== 'INPUT' &&
				sDomRefSourceTagName !== 'TEXTAREA'
			) {
				oBrowserEvent["oGetSource"]()["style"]["MozUserSelect"] = 'none';
			}
		}
	}

	return undefined;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onmousedown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsdragend"]++; }; 
	/** @type {HTMLElement} */
	var oResizeHandle;
	/** @type {HTMLElement} */
	var oTouchHandle;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(1773): onlsdragend"); };

	oResizeHandle = UCF_DomUtil["$"](this["sId"] + '-' + this["ACTION"]["TABLE_V_RESIZE"]);

	if (oResizeHandle) {
		this["updateCssClass"](oResizeHandle, 'lsTableResizeHandleActivated', false);
		oTouchHandle = UCF_DomUtil["$"](this["sId"] + '-' + this["ACTION"]["TABLE_V_RESIZE"] + '-TOUCH');

		if (oTouchHandle) {
			UCF_DomUtil["removeClass"](oTouchHandle, 'lsSpTableVisTouchHandleActivated');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsdragend"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onmouseup"]++; }; 
	this["onlsdragend"](oBrowserEvent);
	this["bMouseDown"] = false;
	this["bFocusChanged"] = false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onmouseup"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsselectmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsselectmodifier"]++; }; 
	/** @type {boolean} */
	var bResult;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(1806): onlsselectmodifier"); };

	if (
		!this["bSkipSelectProcessing"](oBrowserEvent) &&
		!this["bCancelHandlerProcessing"](oBrowserEvent)
	) {
		bResult = this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["KEYBOARD_SELECT"]);

		return oBrowserEvent["bHandled"]
			? bResult
			: this["bIsValidTableHotkey"](oBrowserEvent)
			? this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["HOTKEY"])
			: bResult;
	} else {
		return undefined;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsselectmodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(1830): onlsselect"); };

	return (
			!this["bSkipSelectProcessing"](oBrowserEvent) &&
			!this["bCancelHandlerProcessing"](oBrowserEvent)
		)
		? this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["KEYBOARD_SELECT"])
		: undefined;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsselect"] = 0; };

/**
 * Skips the select event if table is configured like that
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bSkipSelectProcessing"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSkipSelectProcessing"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(1848): bSkipSelectProcessing"); };

	return this["bSkipSelectionByEnter"] && oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["ENTER"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSkipSelectProcessing"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsenter"]++; }; 
	/** @type {boolean} */
	var bResult;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(1862): onlsenter"); };

	if (this["bCancelHandlerProcessing"](oBrowserEvent)) {
		return undefined;
	} else {
		bResult = this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["KEYBOARD_ENTER"]);

		return oBrowserEvent["bHandled"]
			? bResult
			: UCF_Control.prototype["onlsenter"]["call"](this, oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsenter"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(1880): onkeydown"); };

	if (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["C"], 'C')) {
		this["fireCopyToClipboardRequestInternal"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onkeydown"] = 0; };

/** @private */
UCF_SapTable["prototype"]["fireCopyToClipboardRequestInternal"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCopyToClipboardRequestInternal"]++; }; 
	if (this["bCopyToClipboardEnabled"]) {
		this["visualizeCopyToClipboard"]();
		this["fireCopyToClipboardRequest"](this["sId"], UCF_DomUtil["sGetCurrentSelectionText"]());
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCopyToClipboardRequestInternal"] = 0; };

/** @private
 * @param {boolean} bEnabled
 */
UCF_SapTable["prototype"]["setCopyToClipboardEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCopyToClipboardEnabled"]++; }; 
	this["bCopyToClipboardEnabled"] = bEnabled;

	if (bEnabled) {
		UCF_DomUtil["removeClass"](this["oRootRef"], 'lsSapTable--bs-disabled');
	} else {
		UCF_DomUtil["addClass"](this["oRootRef"], 'lsSapTable--bs-disabled');
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCopyToClipboardEnabled"] = 0; };

/**
 * @private
 * @static
 * @return {UCF_SapTable_Metadata}
 */
UCF_SapTable["oGetMetadata"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetMetadata"]++; }; 
	if (!UCF_SapTable["oMetadata"]) {
		UCF_SapTable["oMetadata"] = UCF_ResourceUtil["oGetMetadataFromTheme"]('urSTMetadata');
	}

	return UCF_JsUtil["extend"]({
		"sCopyToClipboardAnimationDurationMs": '0ms'
	}, UCF_SapTable["oMetadata"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetMetadata"] = 0; };

/** @public */
UCF_SapTable["prototype"]["visualizeCopyToClipboard"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["visualizeCopyToClipboard"]++; }; 
	/** @type {number} */
	var iCopyToClipboardAnimationDurationMs;

	if (this["oLS"]["oSystem"]["bUseAnimation"]) {
		iCopyToClipboardAnimationDurationMs = parseInt(UCF_SapTable["oGetMetadata"]()["sCopyToClipboardAnimationDurationMs"]);

		if (iCopyToClipboardAnimationDurationMs > 0) {
			UCF_DomUtil["addClass"](this["oRootRef"], 'urSTDidCopy');
			this["sRemoveVisualizeCopyToClipboardDelayedCallId"] = UCF_JsUtil["delayedCall"](
				iCopyToClipboardAnimationDurationMs,
				this,
				'didVisualizeCopyToClipboard'
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["visualizeCopyToClipboard"] = 0; };

/** @private */
UCF_SapTable["prototype"]["didVisualizeCopyToClipboard"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["didVisualizeCopyToClipboard"]++; }; 
	UCF_DomUtil["removeClass"](this["oRootRef"], 'urSTDidCopy');
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["didVisualizeCopyToClipboard"] = 0; };

/**
 * Grant that following keydown events are canceled for bubbling when they are
 * handled already by ohter ls Events
 */

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsspace"]++; }; 
	/** @type {string} */
	var sDomRefSourceTagName;

	this["bCancelHandlerProcessing"](oBrowserEvent);

	// Workaround: Avoid browser window scrolling on spacebar press
	if (oBrowserEvent["oDomEvent"]["bSapTableKeyHandled"]) {
		sDomRefSourceTagName = oBrowserEvent["oGetSource"]()["tagName"];

		if (
			sDomRefSourceTagName !== 'INPUT' &&
			sDomRefSourceTagName !== 'TEXTAREA'
		) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Cancel SPACE event in SapTable to avoid document paging', "SapTable.js(1971): onlsspace"); };
			this["blockEventInternal"](oBrowserEvent);

			return false;
		}
	}

	return undefined;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsspace"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean}
 */
UCF_SapTable["prototype"]["onlsspacemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsspacemodifier"]++; }; 
	return this["onlsspace"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsspacemodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onlsentermodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsentermodifier"]++; }; 
	this["bCancelHandlerProcessing"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsentermodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsexpand"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2004): onlsexpand"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["KEYBOARD_EXPAND"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsexpand"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsexpandmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsexpandmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2017): onlsexpandmodifier"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["KEYBOARD_EXPAND"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsexpandmodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlscollapse"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2030): onlscollapse"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["KEYBOARD_COLLAPSE"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlscollapse"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlscollapsemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlscollapsemodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2043): onlscollapsemodifier"); };

	return (oBrowserEvent["bShift"]() || this["bCancelHandlerProcessing"](oBrowserEvent))
		? undefined
		: this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["KEYBOARD_COLLAPSE"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlscollapsemodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsmousewheel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsmousewheel"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2056): onlsmousewheel"); };

	var iDeltaX = oBrowserEvent["oDomEvent"]["deltaX"] || 0;
	var iDeltaY = oBrowserEvent["oDomEvent"]["deltaY"] || 0;

	if (this["bCancelHandlerProcessing"](oBrowserEvent))
		return;

	if (Math["abs"](iDeltaX) >= Math["abs"](iDeltaY) && iDeltaX && this["oScrollH"])
		return this["oScrollH"]["onlsmousewheel"](oBrowserEvent);

	if (this["oScrollV"])
		return this["oScrollV"]["onlsmousewheel"](oBrowserEvent);

	return true;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsmousewheel"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onmouseover"]++; }; 
	if (!this["bCancelHandlerProcessing"](oBrowserEvent)) {
		if (!UCF_SapTable["bCursorRulesApplied"]) {
			UCF_DomUtil["applyIECssCursorRule"](
				'.urSTbvIconSortCursor' + (__UCF_IE6__ ? '_' + window["UCF_System"]["sDevice"] + '_' : '')
			);
			UCF_SapTable["bCursorRulesApplied"] = true;
		}

		this["checkHoverEffectsIn"](oBrowserEvent);
		this["checkHeaderCellTooltip"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onmouseover"] = 0; };


/**
 * Checks the tooltip for the Header Cells. The check is not done for multi
 * caption cells. The Caption gets pointer-events:none when is rendered in
 * HeaderCell, so the tooltip is read from HeaderCell DomRef. On mouseover the
 * HeaderCell, checks if the Caption text contains or not ellipsis and then the
 * text will be added or not to the tooltip.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["checkHeaderCellTooltip"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHeaderCellTooltip"]++; }; 
	/** @type {HTMLElement} */
	var oSource;
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {HTMLElement} */
	var oCellDomRef;
	/** @type {string} */
	var sTooltipAPI;
	/** @type {HTMLElement} */
	var oCaptionDomRef;
	/** @type {string} */
	var sCaptionTooltip;
	/** @type {UCF_Control} */
	var oSourceControl;
	/** @type {UCF_Caption} */
	var oCaption;
	/** @type {string} */
	var sText = null;
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(2121): checkHeaderCellTooltip"); };

	oSource = oBrowserEvent["oGetSource"]();
	oCellInfo = this["oGetCellInfoByDomRef"](oSource);

	if (oCellInfo) {
		if (this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["HEADER_CELL"]) {
			oCellDomRef = oCellInfo["oDomRefCell"];

			// the check is not for multicaption HeaderCell
			if (
				!oCellDomRef ||
				!oCellDomRef["hasAttribute"] ||
				!oCellDomRef["hasAttribute"]('multicaption')
			) {
				sTooltipAPI = (oCellDomRef && oCellDomRef["getAttribute"])
					? oCellDomRef["getAttribute"]('t')
					: '';
				oCaptionDomRef = UCF_DomUtil["oGetFirstChildByAttribute"](
					oSource,
					'ct',
					'CP'
				);
				if (oCaptionDomRef) {
					oCaption = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oCaptionDomRef, true);
					if (oCaption)
						sText = oCaption["sText"];
				}

				if (!oCaptionDomRef) {
					oCaptionDomRef = UCF_DomUtil["$"](oCellDomRef["id"] + '-CONTENT');
				}

				if (oCaptionDomRef) { // eslint-disable-line max-depth

					UCF_DomUtil["checkTooltip"](oCaptionDomRef, sTooltipAPI, null, sText);

					sCaptionTooltip = oCaptionDomRef["title"];
					oSourceControl = oBrowserEvent["oGetSourceControl"]();

					// eslint-disable-next-line max-depth
					if (oSourceControl instanceof UCF_ClassLoader["oGetClass"](
							'UCF_SapTableCS'
						)) {
						// The SapTableCSHeaderCell has no Tooltip via API, the Caption
						// Tooltip is rendered
						UCF_DomUtil["setTooltip"](oCellDomRef, sCaptionTooltip);
					} else if (oSourceControl instanceof UCF_SapTable) {
						// The SapTableHeaderCell has Tooltip via API, the Caption Text
						// and Tooltip should be considered
						UCF_DomUtil["setTooltip"](oCellDomRef, sCaptionTooltip);
					}
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHeaderCellTooltip"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(2184): onmouseout"); };

	if (!this["bCancelHandlerProcessing"](oBrowserEvent)) {
		this["checkHoverEffectsOut"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onmouseout"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstouchstart"]++; }; 
	/** @type {HTMLElement} */
	var oResizeHandle;
	/** @type {HTMLElement} */
	var oTouchHandle;
	/** @type {string} */
	var sSrcElementId;
	/** @type {boolean} */
	var bResult;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(2206): onlstouchstart"); };

	oResizeHandle = UCF_DomUtil["$"](this["sId"] + '-' + this["ACTION"]["TABLE_V_RESIZE"]);
	if (
		oResizeHandle &&
		UCF_DomUtil["bContains"](oResizeHandle, oBrowserEvent["oSource"])
	) {
		this["updateCssClass"](oResizeHandle, 'lsTableResizeHandleActivated', true);
		oTouchHandle = UCF_DomUtil["$"](
			this["sId"] + '-' + this["ACTION"]["TABLE_V_RESIZE"] + '-TOUCH'
		);

		if (oTouchHandle) {
			UCF_DomUtil["addClass"](oTouchHandle, 'lsSpTableVisTouchHandleActivated');
		}

		return undefined;
	}

	// touchStart at HCTouchLayer
	sSrcElementId = oBrowserEvent["oGetSource"]()["getAttribute"]('id');
	if (sSrcElementId && sSrcElementId["indexOf"]('HCTouchLayer') !== -1) {
		return undefined;
	}

	// touchStart at BlockSelectionHandle
	if (sSrcElementId && sSrcElementId["indexOf"]('BSHandle') !== -1) {
		return undefined;
	}

	this["bTouchForSelect"] = true;

	if (this["bCancelHandlerProcessing"](oBrowserEvent)) {
		return undefined;
	} else {
		if (
			this["sHorizontalScrollUpdateMode"] === this["SCROLL_UPDATE_MODE"]["SERVER"] &&
			this["oScrollV"] &&
			this["oScrollH"]
		) {
			// in case of server side scrolling in both directions it is neccessary
			// to determine main swipe direction in order to fire the scroll event
			// the user was intended to trigger otherwise the not intended scroll
			// event may block the intended one
			this["iStartPageX"] = oBrowserEvent["iPageX"]();
			this["iStartPageY"] = oBrowserEvent["iPageY"]();
		}

		bResult = true;
		UCF_DomUtil["addClass"](this["oDomRef"], 'urST4TableHovered');
		if (this["oScrollV"]) {
			bResult = this["oScrollV"]["onlstouchstart"](oBrowserEvent) && bResult;
		}
		if (this["oScrollH"]) {
			bResult = this["oScrollH"]["onlstouchstart"](oBrowserEvent) && bResult;
		}

		return bResult;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstouchstart"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlstouchmove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstouchmove"]++; }; 
	/** @type {HTMLElement} */
	var oResizeHandle;
	/** @type {string} */
	var sSrcElementId;
	/** @type {boolean} */
	var bResult;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(2280): onlstouchmove"); };

	oResizeHandle = UCF_DomUtil["$"](this["sId"] + '-' + this["ACTION"]["TABLE_V_RESIZE"]);

	if (
		oResizeHandle &&
		UCF_DomUtil["bContains"](oResizeHandle, oBrowserEvent["oSource"])
	) {
		return undefined;
	}

	// touchMove at HCTouchLayer
	sSrcElementId = oBrowserEvent["oGetSource"]()["getAttribute"]('id');
	if (sSrcElementId && sSrcElementId["indexOf"]('HCTouchLayer') !== -1) {
		return undefined;
	}

	// touchMove at BlockSelectionHandle
	if (sSrcElementId && sSrcElementId["indexOf"]('BSHandle') !== -1) {
		return undefined;
	}

	this["bTouchForSelect"] = false;

	if (this["bCancelHandlerProcessing"](oBrowserEvent)) {
		return undefined;
	} else {
		bResult = true;
		if (this["oScrollV"]) {
			bResult = this["oScrollV"]["onlstouchmove"](oBrowserEvent) && bResult;
		}
		if (this["oScrollH"]) {
			bResult = this["oScrollH"]["onlstouchmove"](oBrowserEvent) && bResult;
		}

		return bResult;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstouchmove"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstouchend"]++; }; 
	/** @type {HTMLElement} */
	var oResizeHandle;
	/** @type {string} */
	var sSrcElementId;
	/** @type {boolean} */
	var bResult;
	/** @type {'H'|'V'} */
	var sMainSwipeDirection;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(2334): onlstouchend"); };

	oResizeHandle = UCF_DomUtil["$"](this["sId"] + '-' + this["ACTION"]["TABLE_V_RESIZE"]);

	if (
		oResizeHandle &&
		UCF_DomUtil["bContains"](oResizeHandle, oBrowserEvent["oSource"])
	) {
		return undefined;
	}

	// touchEnd at HCTouchLayer
	sSrcElementId = oBrowserEvent["oGetSource"]()["getAttribute"]('id');
	if (sSrcElementId && sSrcElementId["indexOf"]('HCTouchLayer') !== -1) {
		return undefined;
	}

	// touchEnd at BlockSelectionHandle
	if (sSrcElementId && sSrcElementId["indexOf"]('BSHandle') !== -1) {
		return undefined;
	}

	if (this["bCancelHandlerProcessing"](oBrowserEvent)) {
		return undefined;
	} else if (this["bTouchForSelect"]) {
		// This let the emulated click events un-canceled. A selection is possible
		// This happens only when no scolling by touchmove has been triggred

		if (this["oScrollV"]) {
			this["oScrollV"]["stopInteraction"]();
		}
		if (this["oScrollH"]) {
			this["oScrollH"]["stopInteraction"]();
		}

		this["bTouchForSelect"] = false;
	} else {
		bResult = true;
		UCF_DomUtil["removeClass"](this["oDomRef"], 'urST4TableHovered');

		if (
			this["sHorizontalScrollUpdateMode"] === this["SCROLL_UPDATE_MODE"]["SERVER"] &&
			this["oScrollV"] &&
			this["oScrollH"]
		) {
			// in case of server side scrolling in both directions it is neccessary
			// to determine main swipe direction in order to fire the scroll event
			// the user was intended to trigger otherwise the not intended scroll
			// event may block the intended one
			sMainSwipeDirection = (
				Math["abs"](this["iStartPageX"] - oBrowserEvent["iPageX"]()) >=
				Math["abs"](this["iStartPageY"] - oBrowserEvent["iPageY"]())
			) ? 'H' : 'V';

			if (this["oScrollV"] && sMainSwipeDirection === 'V') {
				bResult = this["oScrollV"]["onlstouchend"](oBrowserEvent) && bResult;
			}
			if (this["oScrollH"] && sMainSwipeDirection === 'H') {
				bResult = this["oScrollH"]["onlstouchend"](oBrowserEvent) && bResult;
			}
		} else {
			if (this["oScrollV"]) {
				bResult = this["oScrollV"]["onlstouchend"](oBrowserEvent) && bResult;
			}
			if (this["oScrollH"]) {
				bResult = this["oScrollH"]["onlstouchend"](oBrowserEvent) && bResult;
			}
		}

		return bResult;
	}

	return true;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstouchend"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlshotkey"]++; }; 
	/** @type {UCF_Hotkeys} */
	var oHotkeys;
	/** @type {UCF_Hotkey} */
	var oHotkey;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(2420): onlshotkey"); };

	if (this["bCancelHandlerProcessing"](oBrowserEvent)) {
		return undefined;
	}

	if (this["bIsValidTableHotkey"](oBrowserEvent)) {
		return this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["HOTKEY"]);
	}

	if (this["sHotkeysId"] == '') { // eslint-disable-line eqeqeq
		return undefined;
	}

	oHotkeys = this["oGetControlById"](this["sHotkeysId"]);
	if (oHotkeys == null) {
		return undefined;
	}

	oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
			this["cancelEventInternal"](oBrowserEvent);
		}
		this["cancelBubbleEventInternal"](oBrowserEvent);

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
	}

	return undefined;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlshotkey"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]('UCF_Hotkeys')["bMustCancelKeyPress"](
			oBrowserEvent
		)) {
		this["cancelEventInternal"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onkeypress"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsskipforward"]++; }; 
	// -> no special handling for skipping navigation within sapTable itself anylonger via method this.bNavigateSkipping()
	// -> instead just standard container skipping -> see note 3068553
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(2476): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsskipforward"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsskipback"]++; }; 
	// -> no special handling for skipping navigation within sapTable itself anylonger via method this.bNavigateSkipping()
	// -> instead just standard container skipping -> see note 3068553
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(2489): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsskipback"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2500): onlsup"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["UP"], false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsup"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onlsupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsupmodifier"]++; }; 
	if (this["bBlockSelectionActive"]() && oBrowserEvent["bCtrl"]()) {
		return this["bCancelHandlerProcessing"](oBrowserEvent)
			? undefined
			: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["TOP"], false);
	}
	else if (this["bRowSelectionByNavigation"] || (this["bBlockSelectionActive"]())) {
		this["onlsup"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsupmodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsdown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2528): onlsdown"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["DOWN"], false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsdown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onlsdownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsdownmodifier"]++; }; 
	if (this["bBlockSelectionActive"]() && oBrowserEvent["bCtrl"]()) {
		return this["bCancelHandlerProcessing"](oBrowserEvent)
			? undefined
			: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["BOTTOM"], false);
	}
	else if (this["bRowSelectionByNavigation"] || this["bBlockSelectionActive"]()) {
		this["onlsdown"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsdownmodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsleft"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2556): onlsleft"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](
			oBrowserEvent,
			window["UCF_System"]["bIsRTL"] ? this["NAVIGATION"]["RIGHT"] : this["NAVIGATION"]["LEFT"],
			true
		);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsleft"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onlsleftmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsleftmodifier"]++; }; 
	var oCellInfo = this["oGetCellInfoByBrowserEvent"](oBrowserEvent);
	var oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["NONE"]);
	if (oCellInfo && oCellInfo["eCellType"] === this["SUBCONTROL"]["HEADER_CELL"] && oBrowserEvent["bCtrl"]()) {
		if (this["moveColumnLeft"](oCellInfo, oAccessInfo)) return;
	}
	if (this["bBlockSelectionActive"]() && oBrowserEvent["bCtrl"]()) {
		return this["bCancelHandlerProcessing"](oBrowserEvent)
			? undefined
			: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["HOME"], true);
	}
	else if (oCellInfo && oCellInfo["eCellType"] === this["SUBCONTROL"]["HEADER_CELL"] && oCellInfo["oDomRefCell"]["getAttribute"]("resizable") !== null && oBrowserEvent["bShift"]) {
		this["decreaseColumnWidth"](oCellInfo, oAccessInfo);
	}
	else if (this["bBlockSelectionActive"]()) {
		this["onlsleft"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsleftmodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsright"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2596): onlsright"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](
			oBrowserEvent,
			window["UCF_System"]["bIsRTL"] ? this["NAVIGATION"]["LEFT"] : this["NAVIGATION"]["RIGHT"],
			true
		);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsright"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onlsrightmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsrightmodifier"]++; }; 
	var oCellInfo = this["oGetCellInfoByBrowserEvent"](oBrowserEvent);
	var oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["NONE"]);
	if (oCellInfo && oCellInfo["eCellType"] === this["SUBCONTROL"]["HEADER_CELL"] && oBrowserEvent["bCtrl"]()) {
		if (this["moveColumnRight"](oCellInfo, oAccessInfo)) return;
	}
	if (this["bBlockSelectionActive"]() && oBrowserEvent["bCtrl"]()) {
		return this["bCancelHandlerProcessing"](oBrowserEvent)
			? undefined
			: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["END"], true);
	}
	else if (oCellInfo && oCellInfo["eCellType"] === this["SUBCONTROL"]["HEADER_CELL"] && oCellInfo["oDomRefCell"]["getAttribute"]("resizable") !== null && oBrowserEvent["bShift"]) {
		this["increaseColumnWidth"](oCellInfo, oAccessInfo);
	}
	else if (this["bBlockSelectionActive"]()) {
		this["onlsright"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsrightmodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlspageup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlspageup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2636): onlspageup"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](
			oBrowserEvent,
			this["NAVIGATION"]["PAGE_UP"],
			false
		);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlspageup"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlspagedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlspagedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2653): onlspagedown"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](
			oBrowserEvent,
			this["NAVIGATION"]["PAGE_DOWN"],
			false
		);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlspagedown"] = 0; };

/**
 * @return {boolean} false to skip event processing
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTable["prototype"]["onlspageupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlspageupmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2670): onlspageupmodifier"); };

	if (this["bBlockSelectionActive"]() && oBrowserEvent["bShift"]()) {
		return this["bCancelHandlerProcessing"](oBrowserEvent)
			? undefined
			: this["handleKeyboardNavigation"](
				oBrowserEvent,
				this["NAVIGATION"]["PAGE_UP"],
				false
			);
	}
	else {
		return this["bCancelHandlerProcessing"](oBrowserEvent)
			? undefined
			: this["handleKeyboardNavigation"](
				oBrowserEvent,
				this["NAVIGATION"]["PREVIOUS_COLUMN_PAGE"],
				true
			);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlspageupmodifier"] = 0; };

/**
 * @return {boolean} false to skip event processing
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTable["prototype"]["onlspagedownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlspagedownmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2698): onlspagedownmodifier"); };

	if (this["bBlockSelectionActive"]() && oBrowserEvent["bShift"]()) {
		return this["bCancelHandlerProcessing"](oBrowserEvent)
			? undefined
			: this["handleKeyboardNavigation"](
				oBrowserEvent,
				this["NAVIGATION"]["PAGE_DOWN"],
				false
			);
	}
	else {
		return this["bCancelHandlerProcessing"](oBrowserEvent)
			? undefined
			: this["handleKeyboardNavigation"](
				oBrowserEvent,
				this["NAVIGATION"]["NEXT_COLUMN_PAGE"],
				true
			);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlspagedownmodifier"] = 0; };

/**
 * @return {boolean} false to skip event processing
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTable["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlshome"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2726): onlshome"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["HOME"], true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlshome"] = 0; };

/**
 * @return {boolean} false to skip event processing
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTable["prototype"]["onlshomemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlshomemodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2739): onlshomemodifier"); };

	if (this["bBlockSelectionActive"]() && oBrowserEvent["bCtrl"]()) {
		return this["bCancelHandlerProcessing"](oBrowserEvent)
			? undefined
			: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["TOP_BEGIN"]);
	}
	else if (oBrowserEvent["bCtrl"]() || oBrowserEvent["bAlt"]()) return;
	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["HOME"], true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlshomemodifier"] = 0; };

/**
 * @return {boolean} false to skip event processing
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTable["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2758): onlsend"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["END"], true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsend"] = 0; };

/**
 * @return {boolean} false to skip event processing
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTable["prototype"]["onlsendmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsendmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2771): onlsendmodifier"); };

	if (this["bBlockSelectionActive"]() && oBrowserEvent["bCtrl"]()) {
		return this["bCancelHandlerProcessing"](oBrowserEvent)
			? undefined
			: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["BOTTOM_END"]);
	}
	else if (oBrowserEvent["bCtrl"]() || oBrowserEvent["bAlt"]()) return;
	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["END"], true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsendmodifier"] = 0; };

/**
 * @return {boolean} false to skip event processing
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTable["prototype"]["onlstop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstop"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2790): onlstop"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["TOP"], false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstop"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean} false to skip event processing
 */
UCF_SapTable["prototype"]["onlsbottom"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsbottom"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2803): onlsbottom"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["handleKeyboardNavigation"](
			oBrowserEvent,
			this["NAVIGATION"]["BOTTOM"],
			false
		);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsbottom"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onlsescape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsescape"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oTriggerCellInfo;
	/** @type {UCF_SapTable_AccessInfo} */
	var oAccessInfo = {};
	var oBlockSelection = {};
	var bRowSelectionMode = this["sCellSelectionMapping"] === 'ROW' || (this["sRowSelectionFollowFocus"] !== 'NONE');
	var eRowSelectionState = '';
	var bRowSelected = false;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2828): onlsescape"); };

	if (this["bMouseDown"]) {
		this["bCancelSelection"] = true;
	}
	oTriggerCellInfo = this["oGetCellInfoByBrowserEvent"](oBrowserEvent);
	if (this["bBlockSelectionActive"]() && this["oBlockSelection"] && (UCF_JsUtil["keys"](this["oBlockSelection"])["length"] > 0) &&
		oTriggerCellInfo &&
		oTriggerCellInfo["iRowIndex"] <= this["oBlockSelection"]["BottomRightRow"] && oTriggerCellInfo["iRowIndex"] >= this["oBlockSelection"]["TopLeftRow"] &&
		oTriggerCellInfo["iColIndex"] <= this["oBlockSelection"]["BottomRightCol"] && oTriggerCellInfo["iColIndex"] >= this["oBlockSelection"]["TopLeftCol"]) {

		oAccessInfo["oTable"] = this;
		oAccessInfo["oCellInfo"] = oTriggerCellInfo;
		oAccessInfo["eAccessType"] = this["ACCESS_TYPE"]["KEYBOARD_ESCAPE"];

		eRowSelectionState = this["eGetRowSelectionState"](oTriggerCellInfo["iRowIndex"]);
		bRowSelected = eRowSelectionState & this["SELECTION_LAYER"]["ROW"] ||	eRowSelectionState & this["SELECTION_LAYER"]["ROW_PRIMARY"];

		if (bRowSelectionMode && bRowSelected) {
			if (this["oBlockSelection"]["TopLeftRow"] !== this["oBlockSelection"]["BottomRightRow"]) {
				oBlockSelection = {
					"TopLeftCol": oTriggerCellInfo["iColIndex"],
					"TopLeftRow": oTriggerCellInfo["iRowIndex"],
					"BottomRightCol": oTriggerCellInfo["iColIndex"],
					"BottomRightRow": oTriggerCellInfo["iRowIndex"]
				};
				this["setBlockSelectionInternal"](oBlockSelection, this["BLOCKSELECTION_MODE"]["NEUTRAL"], true, true);
				this["adjustRowToBlockSelection"](oAccessInfo, oBlockSelection);
				this["adjustColumnToBlockSelection"](oAccessInfo, oBlockSelection);
				this["fireBlockSelect"](this["sId"],
					UCF_JsUtil["sJsonStringify"](this["oEnrichBSProperties"](oBlockSelection)),
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["UPDATE"]
				);
				this["internalFireRowSelectDirect"](
					oAccessInfo["oCellInfo"],
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"],
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"],
					this
				);
				oBrowserEvent["cancel"]();
				oBrowserEvent["cancelBubble"]();
			}
		}
		else {
			if (this["oBlockSelection"]["TopLeftRow"] !== this["oBlockSelection"]["BottomRightRow"] || this["oBlockSelection"]["TopLeftCol"] !== this["oBlockSelection"]["BottomRightCol"]) {
				if (this["bCellSupportsBlockSelection"](oAccessInfo["oCellInfo"])) {
					this["internalFireBlockSelect"](oAccessInfo);
					oBrowserEvent["cancel"]();
					oBrowserEvent["cancelBubble"]();
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsescape"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_SapTable["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(2889): onlsfocus"); };

	// focus at SapTable(CS) itself but not triggered from any embedded element such as for example the expand/collapse icon
	if (oBrowserEvent["oGetSource"]() === this["oDomRef"] && !this["bMouseAccessInside"]) {
		// validation correction, because in this case the focus shouldn'd be on a
		//cell
		this["resetCellMatrixFocus"]();
		// !508: find either start or last focussed cell and focus it or its content
		if (!window["UCF_System"]["bIs508"]) {
			this["handleFocusEntryStart"]();
		}
	}
	else if (oBrowserEvent["oGetSource"]()["getAttribute"]("tp") === "START_INSIDE") {
			// !508: back navigation from inside -> focus previous control
		if (!window["UCF_System"]["bIs508"]) {
			if (oBrowserEvent["oFromElement"] === this["oDomRef"]) {
				// SapTable(CS) does not seem to contain any cells -> focus next control
				if (!this["focusNextControl"]()) {
					this["oLS"]["focusEnd"]();
				}
			}
			else this["focusTabbableElementBackward"]();
		}
	}
			// !508: back navigation from inside -> focus previous control
	else if (oBrowserEvent["oGetSource"]()["getAttribute"]("tp") === "END") {
		// ARIA: find either end or last focussed cell and focus it or its content
		if (!window["UCF_System"]["bIs508"]) {
			this["handleFocusEntryEnd"]();
		}
	}
	else if (oBrowserEvent["oGetSource"]()["getAttribute"]("tp") === "END_INSIDE") {
			// !508: forward navigation from inside -> focus next control
		if (!window["UCF_System"]["bIs508"]) {
			if (oBrowserEvent["oFromElement"] && oBrowserEvent["oFromElement"]["getAttribute"]("tp") === "END") {
				// SapTable(CS) does not seem to contain any cells -> focus previous control
				if (!this["focusPreviousControl"]()) {
					document["body"]["focus"]();
				}
			}
			else this["focusTabbableElementForward"]();
		}
	}
	this["bMouseAccessInside"] = false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsfocus"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_SapTable["prototype"]["onlscontainerfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlscontainerfocus"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(2944): onlscontainerfocus"); };

	if (!this["bCancelHandlerProcessing"](oBrowserEvent)) {
		UCF_Control.prototype["onlscontainerfocus"]["call"](this, oBrowserEvent);

		// Maybe this was already processed by a nested SapTable (which is
		// offically not supported).  Avoid SapTable double processing
		// lsContainerFocus is not allowed to be canceled, therefore using
		// BrowserEvent.oData
		if (!oBrowserEvent["oGetData"]()["bProcessedBySapTableContainerFocus"]) {
			oBrowserEvent["oGetData"]()["bProcessedBySapTableContainerFocus"] = true;

			oCellInfo = this["oGetCellInfoByBrowserEvent"](oBrowserEvent);

			if (oCellInfo) {
				if (this["bIsCellFocussed"](oCellInfo)) {
					this["markCellAsFocussed"](oCellInfo);
				} else if (
					this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["NONE"])["eAction"] !==
					this["ACTION"]["COL_RESIZE"]
				) {
					this["setCellMatrixFocusByCellInfo"](oCellInfo);
				}
			}

			this["setElementActive"](this["oDomRef"], true);
		}
	}
	this["setCopyToClipboardEnabled"](true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlscontainerfocus"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_SapTable["prototype"]["onlscontainerblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlscontainerblur"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(2981): onlscontainerblur"); };

	if (!this["bCancelHandlerProcessing"](oBrowserEvent)) {
		// _super(oBrowserEvent);

		this["setElementActive"](this["oDomRef"], false);
	}
		this["setCopyToClipboardEnabled"](false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlscontainerblur"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_SapTable["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstabnext"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(2997): onlstabnext"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["bProcessTabHandling"](oBrowserEvent, true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstabnext"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_SapTable["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstabprevious"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(3010): onlstabprevious"); };

	return this["bCancelHandlerProcessing"](oBrowserEvent)
		? undefined
		: this["bProcessTabHandling"](oBrowserEvent, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlstabprevious"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element
 * within the control gets the focus.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(3025): onlsaccessibility"); };

	if (!this["bCancelHandlerProcessing"](oBrowserEvent)) {
		if (!this["oAccHelper"]) {
			this["oAccHelper"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableAccessibilityHelper"))(this);
		}

		this["oAccHelper"]["onlsaccessibility"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsaccessibility"] = 0; };

/**
 * @see UCF_Control.sGetAccChildren
 * @private
 * @return {string} the direct children as string.
 */
UCF_SapTable["prototype"]["sGetAccChildren"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetAccChildren"]++; }; 
	return this["oLS"]["sGetText"]('SAPUR_ACC_TABLE_CHILDREN');
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetAccChildren"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["ondragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["ondragstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(3050): ondragstart"); };

	if (!this["bCancelHandlerProcessing"](oBrowserEvent)) {
		// This is needed for the drag drop to Excel feature
		if (oBrowserEvent["oGetSource"]()["getAttribute"]('cdd')) {
			this["fireClipboardSelectionDataGet"](this["sId"]);
			this["cancelBubbleEventInternal"](oBrowserEvent);
		}

		// create dragDelegate ... also done in control.js ondragstart method
		this["createDragDelegate"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["ondragstart"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onlsselectstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsselectstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(3069): onlsselectstart"); };

	// create dragDelegate
	this["createDragDelegate"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsselectstart"] = 0; };

/**
 * Checks if the browser event has to be processed
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bCancelHandlerProcessing"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCancelHandlerProcessing"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(3083): bCancelHandlerProcessing"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(3084): bCancelHandlerProcessing"); };

	if (oBrowserEvent["oDomEvent"]["bSapTableKeyHandled"]) {
		this["cancelBubbleEventInternal"](oBrowserEvent);

		return true;
	} else if (oBrowserEvent["oGetData"]()["bProcessedBySapTableCancel"]) {
		// Maybe this was already processed by a nested SapTable (which is
		// offically not supported). Avoid SapTable double processing. Some events
		// are not allowed to be canceled, therefore using BrowserEvent.oData

		// Cell content listening concept
		// See documentation in the are "Cell content listening"
		if (oBrowserEvent["oGetData"]()["bProcessedBySapTableCancelBubbleEvent"]) {
			this["cancelBubbleEventInternal"](oBrowserEvent);
		}

		if (oBrowserEvent["oGetData"]()["bProcessedBySapTableCancelEvent"]) {
			this["cancelEventInternal"](oBrowserEvent);
		}

		return true;
	} else {
		oBrowserEvent["oGetData"]()["bProcessedBySapTableCancel"] = true;

		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCancelHandlerProcessing"] = 0; };

/******************************************************
 ** EVENT HANDLER RAISED BY EVENT LISTENING
 *******************************************************/

/**
 * @private
 * @param {UCF_Event} oEvent the event object
 */
UCF_SapTable["prototype"]["onScrollH"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onScrollH"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "SapTable.js(3122): onScrollH"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "SapTable.js(3123): onScrollH"); };

	this["notifyCellDataUpdate"]();

	if (this["sHorizontalScrollUpdateMode"] === this["SCROLL_UPDATE_MODE"]["CLIENT"]) {
		this["setHorizontalScrollPosition"](oEvent["oGetParam"]('iFirstVisibleItem') - 1);
	}

	this["fireHorizontalScroll"](
		this["sId"],
		oEvent["oGetParam"]('iFirstVisibleItem') + (this["bZeroBasedScrolling"] || this["sHorizontalScrollUpdateMode"] === this["SCROLL_UPDATE_MODE"]["CLIENT"] ? -1 : 0),
		oEvent["oGetParam"]('eAction'),
		oEvent["oGetParam"]('eAccessSource'),
		oEvent["oGetParam"]('bShift'),
		oEvent["oGetParam"]('bCtrl'),
		oEvent["oGetParam"]('bAlt')
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onScrollH"] = 0; };

/**
 * @private
 * @param {UCF_Event} oEvent the event object
 */
UCF_SapTable["prototype"]["onScrollV"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onScrollV"]++; }; 
	// !!!! This method is overwritten by SapTableCS

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "SapTable.js(3149): onScrollV"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "SapTable.js(3150): onScrollV"); };

	this["fireVerticalScrollInternal"](oEvent);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onScrollV"] = 0; };

/**
 * @private
 * @param {UCF_Event} oEvent the event object
 */
UCF_SapTable["prototype"]["onCellEditorEditMode"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onCellEditorEditMode"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "SapTable.js(3161): onCellEditorEditMode"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "SapTable.js(3162): onCellEditorEditMode"); };

	this["setCopyToClipboardEnabled"](false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onCellEditorEditMode"] = 0; };

/**
 * @private
 * @param {UCF_Event} oEvent the event object
 */
UCF_SapTable["prototype"]["onCellEditorNavigationMode"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onCellEditorNavigationMode"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "SapTable.js(3173): onCellEditorNavigationMode"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "SapTable.js(3174): onCellEditorNavigationMode"); };

	this["setCopyToClipboardEnabled"](true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onCellEditorNavigationMode"] = 0; };

/**
 * Internal method to fire the semantic vertical scroll event
 *
 * @private
 * @param {UCF_Event} oScrollEvent
 */
UCF_SapTable["prototype"]["fireVerticalScrollInternal"] = function(oScrollEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireVerticalScrollInternal"]++; }; 
	/** @type {number} */
	var iFirstVisibleItem = oScrollEvent
		? (oScrollEvent["oGetParam"]('iFirstVisibleItem') + (this["bZeroBasedScrolling"] ? -1 : 0))
		: this["iVisibleFirstRow"];
	/** @type {UCF_SapTable_Action} */
	var eAction = oScrollEvent
		? oScrollEvent["oGetParam"]('eAction')
		: this["oScrollV"]["ACTION"]["DIRECT"];
	/** @type {UCF_ScrollBase_AccessSource} */
	var eAccessSource = oScrollEvent
		? oScrollEvent["oGetParam"]('eAccessSource')
		: this["oScrollV"]["ACCESS_SOURCE"]["EXTERNAL"];
	/** @type {boolean} */
	var bShift = oScrollEvent ? oScrollEvent["oGetParam"]('bShift') : false;
	/** @type {boolean} */
	var bCtrl = oScrollEvent ? oScrollEvent["oGetParam"]('bCtrl') : false;
	/** @type {boolean} */
	var bAlt = oScrollEvent ? oScrollEvent["oGetParam"]('bAlt') : false;
	/** @type {UCF_SapTable_CellInfo} */
	var oFocussedCell = this["oGetFocussedCell"]();
	/** @type {number} */
	var sCellId = this["sGetCellId"](oFocussedCell);
	/** @type {boolean} */
	var bBoundaryScroll = (
		eAction === this["oScrollV"]["ACTION"]["END"] ||
		eAction === this["oScrollV"]["ACTION"]["BEGIN"]
	);

	this["notifyCellDataUpdate"]();

	this["fireVerticalScroll"](this["sId"],
		iFirstVisibleItem,
		eAction,
		sCellId,
		eAccessSource,
		// Keyboard access
		this["bKeyboardHandlingInProcess"] && (
			// not in selection column when toggling mode enabled
			!this["bRowSelectionCellToggleMode"] ||
			!this["bIsCellOfSelectionColumn"](oFocussedCell)
		) && (
			this["bRowSelectionFollowFocusKeyboard"]
			&& (
				this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["NONE"], bShift, bCtrl, bAlt)
				|| bBoundaryScroll
			)
			|| !this["bRowSelectionFollowFocusKeyboard"]
			&& (
				this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["CTRL"], bShift, bCtrl, bAlt)
				&& !bBoundaryScroll
			)
		),
		bShift, bCtrl, bAlt
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireVerticalScrollInternal"] = 0; };

/**
 * Forces an update of data potentiaonal changed data before e.g. sending an
 * event to server
 *
 * @private
 */
UCF_SapTable["prototype"]["notifyCellDataUpdate"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["notifyCellDataUpdate"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef = UCF_DomUtil["oGetActiveElement"]();
	/** @type {UCF_Control} */
	var oControl = oDomRef
		? this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oDomRef, true)
		: null;

	// Check if the framework has to be updated due to changed data
	// UCF_EditFieldBase implements onBeforeCellDataUpdate
	if (oControl && UCF_JsUtil["bIsFunction"](oControl["onBeforeCellDataUpdate"])) {
		oControl["onBeforeCellDataUpdate"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["notifyCellDataUpdate"] = 0; };

/******************************************************
 ** GENERAL
 *******************************************************/

/**
 * Util function to check if the id of a given dom refrence contains a specific
 * string
 *
 * @private
 * @param {HTMLElement} oDomRef
 * @param {string} sString
 * @return {boolean} true if the string is contained
 */
UCF_SapTable["prototype"]["bIdContains"] = function(oDomRef, sString) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIdContains"]++; }; 
	return (oDomRef && oDomRef["getAttribute"]('id'))
		? oDomRef["getAttribute"]('id')["indexOf"](sString) !== -1
		: false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIdContains"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_SapTable["prototype"]["sGetId"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetId"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (oDomRef) {
		oCellInfo = this["oGetCellInfoByDomRef"](oDomRef);

		if (
			oCellInfo &&
			this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["HEADER_CELL"] &&
			this["sGetCellId"](oCellInfo)
		) {
			return this["sGetCellId"](oCellInfo);
		}
	}

	return UCF_Control.prototype["sGetId"]["call"](this, oDomRef);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetId"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @return {UCF_SapTable_Action} alternative action of a hierarchical cell
 * (important for summary cells -> see renderer)
 */
UCF_SapTable["prototype"]["sGetAlternativeAction"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetAlternativeAction"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(3313): sGetAlternativeAction"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(3314): sGetAlternativeAction"); };

	return (
			oAccessInfo["oSubControlDomRef"] &&
			oAccessInfo["oSubControlDomRef"]["getAttribute"]('altAction')
		)
		? oAccessInfo["oSubControlDomRef"]["getAttribute"]('altAction')
		: null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetAlternativeAction"] = 0; };

/**
 * Creates and gets access info of a given user interaction
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {UCF_SapTable_AccessType} eAccessType
 * @return {UCF_SapTable_AccessInfo} The access info object
 */
UCF_SapTable["prototype"]["oGetAccessInfo"] = function(oBrowserEvent, eAccessType) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetAccessInfo"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {UCF_SapTable_Subcontrol} */
	var eSubControlType;
	/** @type {string} */
	var sContentControlType;
	/** @type {UCF_SapTable_Action} */
	var eAction;
	/** @type {string} */
	var sAccessFragmentType;
	/** @type {HTMLElement} */
	var oAccessFragmentDomRef;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(3346): oGetAccessInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oBrowserEvent === 'object', "typeof oBrowserEvent === 'object'", "SapTable.js(3347): oGetAccessInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof eAccessType === 'number', "typeof eAccessType === 'number'", "SapTable.js(3348): oGetAccessInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(eAccessType >= 0, "eAccessType >= 0", "SapTable.js(3349): oGetAccessInfo"); };

	oDomRef = oBrowserEvent["oGetSource"]();
	eSubControlType = this["SUBCONTROL"]["NONE"];
	sContentControlType = null;
	eAction = this["ACTION"]["NONE"];
	sAccessFragmentType = '';
	oAccessFragmentDomRef = null;

	while (oDomRef && oDomRef["tagName"] !== 'BODY') {
		if (oDomRef["getAttribute"]('subct')) {
			eSubControlType = oDomRef["getAttribute"]('subct');
		} else if (!sContentControlType && oDomRef["getAttribute"]('ct')) {
			sContentControlType = oDomRef["getAttribute"]('ct');
		}

		if (!sAccessFragmentType && oDomRef["getAttribute"]('acf')) {
			sAccessFragmentType = oDomRef["getAttribute"]('acf');
			oAccessFragmentDomRef = oDomRef;
			eAction = sAccessFragmentType;
		}

		if (oDomRef === this["oDomRef"]) {
			eSubControlType = this["SUBCONTROL"]["TABLE"];
		}

		if (eSubControlType) {
			return {
				"oBrowserEvent": oBrowserEvent,
				"eAccessType": eAccessType,
				"oTable": this,
				"oTableDomRef": this["oDomRef"],
				"sSubControlId": oDomRef["getAttribute"]('id')
					? oDomRef["getAttribute"]('id')
					: '',
				"oSubControlDomRef": oDomRef,
				"eSubControlType": eSubControlType,
				"sContentControlType": sContentControlType,
				"sAccessFragmentType": sAccessFragmentType,
				"oAccessFragmentDomRef": oAccessFragmentDomRef,
				"eAction": eAction,
				"bHandled": false,
				"bForceCancelEvent": false,
				"oCellInfo": this["oGetCellInfoByDomRef"](oDomRef)
			};
		}
		oDomRef = oDomRef["parentNode"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetAccessInfo"] = 0; };

/**
 * Handle browser event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {UCF_SapTable_AccessType} eAccessType
 * @return {boolean} false to skip event handling
 */
UCF_SapTable["prototype"]["handleEvent"] = function(oBrowserEvent, eAccessType) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleEvent"]++; }; 
	/** @type {UCF_SapTable_AccessInfo} */
	var oAccessInfo;
	var oCellInfo;
	var oBlockSelection;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(3415): handleEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oBrowserEvent === 'object', "typeof oBrowserEvent === 'object'", "SapTable.js(3416): handleEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof eAccessType === 'number', "typeof eAccessType === 'number'", "SapTable.js(3417): handleEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(eAccessType >= 0, "eAccessType >= 0", "SapTable.js(3418): handleEvent"); };

	if (!this["bInitBeforeHandling"]()) {
		return false;
	}

	oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, eAccessType);

	if (oAccessInfo) {
		// Some fragments like Sorticon, SelectionMenuIcon are buttons which raise
		// also an onclick when activated by SPACE bar. Therefore cancel key access
		// by SPACE bar
		if (
			oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_SELECT"] &&
			oAccessInfo["oAccessFragmentDomRef"] && (
				oAccessInfo["oAccessFragmentDomRef"]["tagName"] === 'BUTTON' ||
				oAccessInfo["oAccessFragmentDomRef"]["tagName"] === 'A'
			)
		) {
			if (
				oAccessInfo["oAccessFragmentDomRef"]["getAttribute"]('bCancleClickBySpace')
			) {
				// When the button fragment is prepared for that behaviour do not skip
				// processing the event itself but cancel all upcoming keyboard events
				oAccessInfo["bForceCancelEvent"] = true;
			} else {
				return false;
			}
		}

		//Select rows of block at Shift Space
		if (this["bBlockSelectionActive"]() && this["oBlockSelection"] && UCF_JsUtil["keys"](this["oBlockSelection"])["length"] > 0 &&
				oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_SELECT"] &&
				oAccessInfo["eSubControlType"] !== this["SUBCONTROL"]["HEADER_CELL"] &&
				oAccessInfo["eSubControlType"] !== this["SUBCONTROL"]["SELECTION_CELL"] &&
				this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["SHIFT"], oBrowserEvent["bShift"](), oBrowserEvent["bCtrl"](), oBrowserEvent["bAlt"]())) {
			oCellInfo = this["oGetCellInfo"](this["oBlockSelection"]["TopLeftRow"], this["oBlockSelection"]["TopLeftCol"]);
			oBlockSelection = this["oBlockSelection"];
			this["internalFireRowSelectDirect"](
				oCellInfo,
				this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"],
				this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"],
				this
			);
			if (oBlockSelection["TopLeftRow"] < oBlockSelection["BottomRightRow"]) {
				oCellInfo = this["oGetCellInfo"](oBlockSelection["BottomRightRow"], oBlockSelection["BottomRightCol"]);
				this["internalFireRowSelectDirect"](
					oCellInfo,
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"],
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"],
					this
				);
			}
			oAccessInfo["bHandled"] = true;
			return this["bSetEventReturnState"](
				oBrowserEvent,
				oAccessInfo["bHandled"],
				false
			);
		}

		//Select columns of block at Ctrl Space (SapTableCS only so far)
		if (UCF_JsUtil["bInstanceOf"](this, 'UCF_SapTableCS')) {
			if (this["bBlockSelectionActive"]() && this["oBlockSelection"] && UCF_JsUtil["keys"](this["oBlockSelection"])["length"] > 0 &&
					oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_SELECT"] &&
					oAccessInfo["eSubControlType"] !== this["SUBCONTROL"]["HEADER_CELL"] &&
					oAccessInfo["eSubControlType"] !== this["SUBCONTROL"]["SELECTION_CELL"] &&
					this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["CTRL"], oBrowserEvent["bShift"](), oBrowserEvent["bCtrl"](), oBrowserEvent["bAlt"]())) {
				oCellInfo = this["oGetCellInfo"](this["oBlockSelection"]["TopLeftRow"], this["oBlockSelection"]["TopLeftCol"]);
				oBlockSelection = this["oBlockSelection"];
				this["internalFireColumnSelectDirect"](
					oCellInfo,
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"],
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"],
					this
				);
				if (oBlockSelection["TopLeftCol"] < oBlockSelection["BottomRightCol"]) {
					oCellInfo = this["oGetCellInfo"](oBlockSelection["BottomRightRow"], oBlockSelection["BottomRightCol"]);
					this["internalFireColumnSelectDirect"](
						oCellInfo,
						this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"],
						this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"],
						this
					);
				}
				oAccessInfo["bHandled"] = true;
				return this["bSetEventReturnState"](
					oBrowserEvent,
					oAccessInfo["bHandled"],
					false
				);
			}
		}

		if (
			eAccessType === this["ACCESS_TYPE"]["MOUSE"] &&
			this["bIsNavigateableTableCell"](oAccessInfo["eSubControlType"]) && (
				!oAccessInfo["oAccessFragmentDomRef"] ||
				!UCF_DomUtil["bHasTabIndex"](oAccessInfo["oAccessFragmentDomRef"])
			) &&
			oAccessInfo["eAction"] !== this["ACTION"]["COL_RESIZE"] &&
			oAccessInfo["eAction"] !== this["ACTION"]["TABLE_V_RESIZE"]
		) {
			this["setCellMatrixFocusByCellInfo"](
				oAccessInfo["oCellInfo"],
				oBrowserEvent["oGetSource"]()
			);
			oAccessInfo["bHandled"] = true;
		}

		if (oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["HOTKEY"]) {
			this["handleTableHotkey"](oAccessInfo);
		} else if (oAccessInfo["eSubControlType"] === this["SUBCONTROL"]["HEADER_CELL"]) {
			this["handleHeaderCellEvent"](oAccessInfo);
		} else if (oAccessInfo["eSubControlType"] === this["SUBCONTROL"]["STANDARD_CELL"]) {
			this["handleStandardCellEvent"](oAccessInfo);
		} else if (oAccessInfo["eSubControlType"] === this["SUBCONTROL"]["HIERARCHY_CELL"]) {
			this["handleHierarchyCellEvent"](oAccessInfo);
		} else if (oAccessInfo["eSubControlType"] === this["SUBCONTROL"]["MATRIX_CELL"]) {
			if (
				oAccessInfo["sAccessFragmentType"] !== 'BLOCKSEL' &&
				this["bBlockSelectionActive"]()
			) {
				this["internalFireBlockSelect"](oAccessInfo);
			}
		} else if (oAccessInfo["eSubControlType"] === this["SUBCONTROL"]["SELECTION_CELL"]) {
			this["handleSelectionCellEvent"](oAccessInfo);
		} else if (oAccessInfo["eSubControlType"] === this["SUBCONTROL"]["POPIN_CELL"]) {
			this["handlePopinCellEvent"](oAccessInfo);
		}

		if (
			!oAccessInfo["bHandled"] &&
			oAccessInfo["eSubControlType"] === this["SUBCONTROL"]["TABLE"]
		) {
			this["handleTableEvent"](oAccessInfo);
		}

		return this["bSetEventReturnState"](
			oBrowserEvent,
			oAccessInfo["bHandled"],
			oAccessInfo["bForceCancelEvent"]
		);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'oAccessInfo must not be "null"', "SapTable.js(3562): handleEvent"); };

		return this["bSetEventReturnState"](oBrowserEvent, false, false);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleEvent"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @param {UCF_JsUtil_Modifier} iModifierCheck
 * @param {boolean} [bNoDoubleClickAllowed]
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bIsCellSelect"] = function(oAccessInfo, iModifierCheck, bNoDoubleClickAllowed) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsCellSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(3576): bIsCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(3577): bIsCellSelect"); };

	return oAccessInfo["oCellInfo"]
		&& oAccessInfo["eAction"] === this["ACTION"]["CELL_SELECT"]
		&& this["bIsSelectAccess"](oAccessInfo, iModifierCheck);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsCellSelect"] = 0; };

/**
 * Sets the reference index for range seletion to a row given by a cell
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["setRowSelectionReferenceIndex"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowSelectionReferenceIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(3591): setRowSelectionReferenceIndex"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oCellInfo === 'object', "typeof oCellInfo === 'object'", "SapTable.js(3592): setRowSelectionReferenceIndex"); };

	this["iRowSelectionReferenceIndex"] = this["bCanDataRequest"]()
		// For LoadOnDemand the reference index needs to be the internal row index
		? this["iGetContentRowIndex"](oCellInfo)
		: this["iGetApiRowIndex"](oCellInfo);
	this["setClientProperty"](
		'RowSelectionReferenceIndex',
		this["iRowSelectionReferenceIndex"],
		true
	);
	this["resetRowSelectionRangeEndIndex"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowSelectionReferenceIndex"] = 0; };

/**
 * Resets the reference index for range seletion
 * @private
 */
UCF_SapTable["prototype"]["resetRowSelectionReferenceIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["resetRowSelectionReferenceIndex"]++; }; 
	this["iRowSelectionReferenceIndex"] = this["APPDEFINED_ROW_DEFAULT_INDEX"];
	this["setClientProperty"](
		'RowSelectionReferenceIndex',
		this["iRowSelectionReferenceIndex"],
		true
	);
	this["resetRowSelectionRangeEndIndex"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["resetRowSelectionReferenceIndex"] = 0; };

/**
 * @private
 * @return {number} the reference index for range seletion
 */
UCF_SapTable["prototype"]["iGetSelectionReferenceCellMatrixRowIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSelectionReferenceCellMatrixRowIndex"]++; }; 
	return this["bHasSetRowSelectionReferenceIndex"]()
		? this["bCanDataRequest"]()
		// For LoadOnDemand the reference index needs to be the internal index
		? this["iRowSelectionReferenceIndex"] + this["iGetContentRowOffset"]()
		: this["iConvertAppDefinedToCellMatrixIndex"](this["iRowSelectionReferenceIndex"])
		: -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSelectionReferenceCellMatrixRowIndex"] = 0; };

/**
 * Checks if a selection range reference index has been set
 *
 * @private
 * @return {boolean} `true` if an index has been set
 */
UCF_SapTable["prototype"]["bHasSetRowSelectionReferenceIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasSetRowSelectionReferenceIndex"]++; }; 
	return this["iRowSelectionReferenceIndex"] !== this["APPDEFINED_ROW_DEFAULT_INDEX"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasSetRowSelectionReferenceIndex"] = 0; };

/**
 * Sets the range end index for range selection to a row given by a cell
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["setRowSelectionRangeEndIndex"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowSelectionRangeEndIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(3650): setRowSelectionRangeEndIndex"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oCellInfo === 'object', "typeof oCellInfo === 'object'", "SapTable.js(3651): setRowSelectionRangeEndIndex"); };

	this["iRowSelectionRangeEndIndex"] = this["bCanDataRequest"]()
		// For LoadOnDemand the reference index needs to be the internal row index
		? this["iGetContentRowIndex"](oCellInfo)
		: this["iGetApiRowIndex"](oCellInfo);
	this["setClientProperty"](
		'RowSelectionRangeEndIndex',
		this["iRowSelectionRangeEndIndex"],
		true
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowSelectionRangeEndIndex"] = 0; };

/**
 * Resets the range end index for range selection
 * @private
 */
UCF_SapTable["prototype"]["resetRowSelectionRangeEndIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["resetRowSelectionRangeEndIndex"]++; }; 
	this["iRowSelectionRangeEndIndex"] = this["APPDEFINED_ROW_DEFAULT_INDEX"];
	this["setClientProperty"](
		'RowSelectionRangeEndIndex',
		this["iRowSelectionRangeEndIndex"],
		true
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["resetRowSelectionRangeEndIndex"] = 0; };

/**
 * @private
 * @return {number} the range end index for row range seletion
 */
UCF_SapTable["prototype"]["iGetSelectionRangeEndCellMatrixRowIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSelectionRangeEndCellMatrixRowIndex"]++; }; 
	return this["bHasSetRowSelectionRangeEndIndex"]()
		? this["bCanDataRequest"]()
		// For LoadOnDemand the reference index needs to be the internal index
		? this["iRowSelectionRangeEndIndex"] + this["iGetContentRowOffset"]()
		: this["iConvertAppDefinedToCellMatrixIndex"](this["iRowSelectionRangeEndIndex"])
		: -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSelectionRangeEndCellMatrixRowIndex"] = 0; };

/**
 * Checks if a range end index for range selection has been set
 *
 * @private
 * @return {boolean} `true` if an index has been set
 */
UCF_SapTable["prototype"]["bHasSetRowSelectionRangeEndIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasSetRowSelectionRangeEndIndex"]++; }; 
	return this["iRowSelectionRangeEndIndex"] !== this["APPDEFINED_ROW_DEFAULT_INDEX"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasSetRowSelectionRangeEndIndex"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 */
UCF_SapTable["prototype"]["internalFireBlockSelect"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireBlockSelect"]++; }; 
	/** @type {number} */
	var iTopLeftCol;
	/** @type {number} */
	var iTopLeftRow;
	/** @type {number} */
	var iBottomRightCol;
	/** @type {number} */
	var iBottomRightRow;
	/** @type {UCF_SapTable_BlockSelection} */
	var oBlockSelection = {};
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {number} */
	var col;
	/** @type {number} */
	var row;
	// /** @type {string} */
	// var sSelectAccess;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(3724): internalFireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(3725): internalFireBlockSelect"); };

	if (oAccessInfo["eAccessType"] === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]) {
		oBlockSelection = {};
	}
	else if (oAccessInfo["eAccessType"] === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"]) {
		iTopLeftRow = this["bHasHeaderRow"]() ? this["iGetHeaderRowCount"]() : 0;
		iBottomRightRow = this["iGetCellInfoMatrixLastRowIndex"]();
		iTopLeftCol = this["bHasLeadingSelectionColumn"]() ? 1 : 0;
		iBottomRightCol = this["iGetCellInfoMatrixLastColIndex"]();
		oBlockSelection = {
			"TopLeftCol": iTopLeftCol,
			"TopLeftRow": iTopLeftRow,
			"BottomRightCol": iBottomRightCol,
			"BottomRightRow": iBottomRightRow
		};
	}
	else {
		iTopLeftCol = oAccessInfo["oCellInfo"]["iColIndex"];
		iTopLeftRow = oAccessInfo["oCellInfo"]["iRowIndex"];

		if (
			oAccessInfo["oBrowserEvent"] &&
			oAccessInfo["oBrowserEvent"]["_bShift"] &&
			this["oBSRefPoint"]
		) {
			iTopLeftCol = oAccessInfo["oCellInfo"]["iColIndex"];
			iTopLeftRow = oAccessInfo["oCellInfo"]["iRowIndex"];
			iBottomRightCol = oAccessInfo["oCellInfo"]["iColIndex"];
			iBottomRightRow = oAccessInfo["oCellInfo"]["iRowIndex"];

			oBlockSelection["TopLeftCol"] = Math["min"](
				this["oBSRefPoint"]["RefCol"],
				iTopLeftCol
			);
			oBlockSelection["TopLeftRow"] = Math["min"](
				this["oBSRefPoint"]["RefRow"],
				iTopLeftRow
			);
			oBlockSelection["BottomRightCol"] = Math["max"](
				this["oBSRefPoint"]["RefCol"],
				iBottomRightCol
			);
			oBlockSelection["BottomRightRow"] = Math["max"](
				this["oBSRefPoint"]["RefRow"],
				iBottomRightRow
			);

			//scan block range to check wether merged cell do enhance
			for (col = oBlockSelection["TopLeftCol"]; col <= oBlockSelection["BottomRightCol"]; col++) {
				for (row = oBlockSelection["TopLeftRow"]; row <= oBlockSelection["BottomRightRow"]; row++) {
					oCellInfo = this["oGetCellInfo"](row, col);

					oBlockSelection["TopLeftCol"] = Math["min"](
						oBlockSelection["TopLeftCol"],
						oCellInfo["iColIndex"]
					);
					oBlockSelection["TopLeftRow"] = Math["min"](
						oBlockSelection["TopLeftRow"],
						oCellInfo["iRowIndex"]
					);
					oBlockSelection["BottomRightCol"] = Math["max"](
						oBlockSelection["BottomRightCol"],
						oCellInfo["iColIndex"] + oCellInfo["iColSpan"] - 1
					);
					oBlockSelection["BottomRightRow"] = Math["max"](
						oBlockSelection["BottomRightRow"],
						oCellInfo["iRowIndex"] + oCellInfo["iRowSpan"] - 1
					);
				}
			}
		} else {
			this["oBSRefPoint"] = {
				"RefCol": iTopLeftCol,
				"RefRow": iTopLeftRow
			};

			oBlockSelection = {
				"TopLeftCol": iTopLeftCol,
				"TopLeftRow": iTopLeftRow,
				"BottomRightCol": oAccessInfo["oCellInfo"]["iColIndex"],
				"BottomRightRow": oAccessInfo["oCellInfo"]["iRowIndex"]
			};
		}
	}

	this["setBlockSelectionInternal"](
		oBlockSelection,
		(oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_ESCAPE"]) ? this["BLOCKSELECTION_MODE"]["NEUTRAL"] :
		(oAccessInfo["oBrowserEvent"] && (oAccessInfo["oBrowserEvent"]["_bCtrl"] || oAccessInfo["oBrowserEvent"]["_bShift"]) && (UCF_JsUtil["keys"](oBlockSelection)["length"] > 0) &&
		(oAccessInfo["eAccessType"] !== this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]) &&
		(oAccessInfo["eAccessType"] !== this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"]))
		? oAccessInfo["oBrowserEvent"]["_bShift"] ? this["BLOCKSELECTION_MODE"]["NEUTRAL"] : this["BLOCKSELECTION_MODE"]["TRANSFORM"]
		: this["BLOCKSELECTION_MODE"]["INITIALIZE"],
		true,
		true
	);

	this["adjustRowToBlockSelection"](oAccessInfo, oBlockSelection);
	this["adjustColumnToBlockSelection"](oAccessInfo, oBlockSelection);

	// if (oAccessInfo.eAccessType === this.EVENT_PARAM_MAP_ACCESS_TYPE.DESELECT_ALL ||
	// 	oAccessInfo.eAccessType === this.EVENT_PARAM_MAP_ACCESS_TYPE.SELECT_ALL) {
	// 	sSelectAccess = oAccessInfo.eAccessType;
	// }
	// else {
	// 	sSelectAccess = (oAccessInfo.oBrowserEvent && oAccessInfo.oBrowserEvent._bCtrl && (UCF_JsUtil.keys(oBlockSelection).length > 0))
	// 	? this.EVENT_PARAM_MAP_ACCESS_TYPE.TOGGLE
	// 	: this.EVENT_PARAM_MAP_ACCESS_TYPE.STANDARD;
	// }

	this["fireBlockSelect"](oAccessInfo["oTable"]["sId"],
		UCF_JsUtil["sJsonStringify"](this["oEnrichBSProperties"](oBlockSelection)),
		// sSelectAccess
		(oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_ESCAPE"]) ? this["EVENT_PARAM_MAP_ACCESS_TYPE"]["UPDATE"] :
		(oAccessInfo["oBrowserEvent"] && (oAccessInfo["oBrowserEvent"]["_bCtrl"] || oAccessInfo["oBrowserEvent"]["_bShift"]) && (UCF_JsUtil["keys"](oBlockSelection)["length"] > 0) && oAccessInfo["eAccessType"] !== this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"])
			? this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]
			: this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]
	);

	oAccessInfo["bHandled"] = this["bHasEventListeners"]('RowSelect') ||
		this["bHasEventListeners"]('ClientRowSelect') ||
		this["bHasEventListeners"]('BlockSelect');

};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireBlockSelect"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @param {UCF_SapTable_BlockSelection} oBlockSelection
 * @param {boolean} bSet true=select; false=deselect
 */
UCF_SapTable["prototype"]["adjustRowToBlockSelection"] = function (oAccessInfo, oBlockSelection, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["adjustRowToBlockSelection"]++; }; 

	if (!this["bBlockSelectionActive"]()) return;

	var iRangeStart = -1;
	var iRangeSize = -1;
	var eRowSelectionState = '';
	var bRowSelected = false;
	var aCellsToReselect = [];
	var mExceptionMap = {};
	var oCellInfo = null;
	var row = 0;
	var col = 0;
	var iFirstColIndex = this["bHasLeadingSelectionColumn"]() ? 1 : 0;
	var iLastColIndex = this["iGetCellInfoMatrixLastColIndex"]();

	if (bSet) {
		iRangeStart = oBlockSelection["TopLeftRow"] ;
		iRangeSize = oBlockSelection["BottomRightRow"] - oBlockSelection["TopLeftRow"] + 1;
		this["updateSelectionInfo"](iRangeStart, iRangeSize, true, mExceptionMap);
		this["processRowSelectionMassUpdate"](
			iRangeStart,
			iRangeSize,
			true,
			this["SELECTION_LAYER"]["ROW"] | this["SELECTION_LAYER"]["ROW_PRIMARY"],
			mExceptionMap
		);
		return;
	}

// we currently just reset the row selection state at client side without firing the clientRowSelection
// event ... either framework or application needs to manage resetting the rowSelection state when a corresponding
// blockSelection gets changed ... handing at client side and consequently firing the clientRowSelection event for
// that case would work only for blocks entirely available at client side.
// clientSide logic could look like that:

	// var aCellInfos = this.aGetSelectedRows();
	// for() loop over aCellInfos
	// if (this.bIsValidCellInfo(oCellInfo)) {
	// 	this.doFireClientRowSelect(oTable.sId,
	// 		this.iGetApiRowIndex(oCellInfo),
	// 		this.sGetRowUserData(oCellInfo),
	// 		this.sGetCellUserData(oCellInfo),
	// 		sSelectAccess, ->toggle
	// 		this.sGetCellId(oCellInfo)
	// 	);
	// }

	if (oAccessInfo["eAccessType"] !== this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"] && oAccessInfo["oBrowserEvent"] && oAccessInfo["oBrowserEvent"]["_bCtrl"]) return;

	// resize at handles
	if (oAccessInfo["oBrowserEvent"] && oAccessInfo["oBrowserEvent"]["sName"] === 'lsdragstart' &&	oAccessInfo["oBrowserEvent"]["oDragAndDropManager"] &&	oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"] &&
			(oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["oDragDropDelegate"]["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"] ||
			oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["oDragDropDelegate"]["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BL"] ||
			oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["oDragDropDelegate"]["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TR"] ||
			oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["oDragDropDelegate"]["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"] )) {

		// only blocks over the entire rows are resulting out of a rowSelection -> take only those rows into account
		if (oBlockSelection["TopLeftCol"] !== iFirstColIndex || oBlockSelection["BottomRightCol"] !== iLastColIndex) return;

		iRangeStart = oBlockSelection["TopLeftRow"];
		iRangeSize = oBlockSelection["BottomRightRow"] - oBlockSelection["TopLeftRow"] + 1;

		// convert row selection into neutral block selection cell once when removing the row selection
		this["aNeutralBlockSelectionCells"] = [];
		for (col = this["oBlockSelection"]["TopLeftCol"]; col <= this["oBlockSelection"]["BottomRightCol"]; col++) {
			for (row = this["oBlockSelection"]["TopLeftRow"]; row <= this["oBlockSelection"]["BottomRightRow"]; row++) {
				oCellInfo = this["oGetCellInfo"](row, col);
				this["aNeutralBlockSelectionCells"]["push"](oCellInfo);
			}
		}
	}
	else {
		if (oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_ESCAPE"] || (oAccessInfo["oBrowserEvent"] && oAccessInfo["oBrowserEvent"]["_bShift"])) {
			if (this["oBlockSelectionPrevious"] && UCF_JsUtil["keys"](this["oBlockSelectionPrevious"])["length"] > 0) {
				// only blocks over the entire rows are resulting out of a rowSelection -> take only those rows into account
				if (this["oBlockSelectionPrevious"]["TopLeftCol"] !== iFirstColIndex || this["oBlockSelectionPrevious"]["BottomRightCol"] !== iLastColIndex) return;
				iRangeStart = this["oBlockSelectionPrevious"]["TopLeftRow"];
				iRangeSize = this["oBlockSelectionPrevious"]["BottomRightRow"] - this["oBlockSelectionPrevious"]["TopLeftRow"] + 1;
			}
		}
		else {
			iRangeStart = 0;
			iRangeSize = this["iGetCellInfoMatrixLastRowIndex"]() + 1;
		}

		// reset cell selection for row selected cells and add to tranform block selection cells
		for (row = this["oBlockSelection"]["TopLeftRow"]; row <= this["oBlockSelection"]["BottomRightRow"]; row++) {
			eRowSelectionState = this["eGetRowSelectionState"](row);
			bRowSelected = eRowSelectionState & this["SELECTION_LAYER"]["ROW"] ||	eRowSelectionState & this["SELECTION_LAYER"]["ROW_PRIMARY"];
			if (!bRowSelected) continue;
			for (col = this["oBlockSelection"]["TopLeftCol"]; col <= this["oBlockSelection"]["BottomRightCol"]; col++) {
				oCellInfo = this["oGetCellInfo"](row, col);
				this["aTransformBlockSelectionCells"]["push"](oCellInfo);
				aCellsToReselect["push"](oCellInfo);
			}
		}
		this["setCellSelectionStates"](
			aCellsToReselect,
			true,
			this["SELECTION_LAYER"]["CELL"]
		);
	}

	if (this["oSelectionInfo"]["bSelectAll"]) {
		// all rows selected
		mExceptionMap = null;
	}

	this["updateSelectionInfo"](iRangeStart, iRangeSize, false, mExceptionMap);
	this["processRowSelectionMassUpdate"](
		iRangeStart,
		iRangeSize,
		false,
		this["SELECTION_LAYER"]["ROW"] | this["SELECTION_LAYER"]["ROW_PRIMARY"],
		mExceptionMap
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["adjustRowToBlockSelection"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @param {UCF_SapTable_BlockSelection} oBlockSelection
 * @param {boolean} bSet true=select; false=deselect
 */
UCF_SapTable["prototype"]["adjustColumnToBlockSelection"] = function (oAccessInfo, oBlockSelection, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["adjustColumnToBlockSelection"]++; }; 

	if (!this["bBlockSelectionActive"]() || !UCF_JsUtil["bInstanceOf"](this, 'UCF_SapTableCS')) return;

	var iRangeStart = -1;
	var iRangeSize = -1;
	var eColumnSelectionState = '';
	var bColumnSelected = false;
	var aCellsToReselect = [];
	var oCellInfo = null;
	var row = 0;
	var col = 0;

	var iFirstRowIndex = this["bHasHeaderRow"]() ? 1 : 0;
	var iLastRowIndex = this["iGetCellInfoMatrixLastRowIndex"]();

	if (oAccessInfo["eAccessType"] !== this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"] && oAccessInfo["oBrowserEvent"] && oAccessInfo["oBrowserEvent"]["_bCtrl"]) return;

	// resize at handles
	if (oAccessInfo["oBrowserEvent"] && oAccessInfo["oBrowserEvent"]["sName"] === 'lsdragstart' &&	oAccessInfo["oBrowserEvent"]["oDragAndDropManager"] &&	oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"] &&
			(oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["oDragDropDelegate"]["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"] ||
			oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["oDragDropDelegate"]["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BL"] ||
			oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["oDragDropDelegate"]["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TR"] ||
			oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["oDragDropDelegate"]["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"] )) {

		// only blocks over the entire cols are resulting out of a colSelection -> take only those cols into account
		if (oBlockSelection["TopLeftRow"] !== iFirstRowIndex || oBlockSelection["BottomRightRow"] !== iLastRowIndex) return;

		iRangeStart = oBlockSelection["TopLeftCol"] ;
		iRangeSize = oBlockSelection["BottomRightCol"] - oBlockSelection["TopLeftCol"] + 1;
	}
	else {
		if (oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_ESCAPE"] || (oAccessInfo["oBrowserEvent"] && oAccessInfo["oBrowserEvent"]["_bShift"])) {
			if (this["oBlockSelectionPrevious"] && UCF_JsUtil["keys"](this["oBlockSelectionPrevious"])["length"] > 0) {
			// only blocks over the entire cols are resulting out of a colSelection -> take only those cols into account
			if (this["oBlockSelectionPrevious"]["TopLeftRow"] !== iFirstRowIndex || this["oBlockSelectionPrevious"]["BottomRightRow"] !== iLastRowIndex) return;
				iRangeStart = this["oBlockSelectionPrevious"]["TopLeftCol"] ;
				iRangeSize = this["oBlockSelectionPrevious"]["BottomRightCol"] - this["oBlockSelectionPrevious"]["TopLeftCol"] + 1;
			}
		}
		else {
			iRangeStart = this["bHasLeadingSelectionColumn"]() ? 1 : 0;
			iRangeSize = this["iGetCellInfoMatrixLastColIndex"]() + 1;
		}

		// reset cell selection for column selected cells and add to tranform block selection cells
		for (col = this["oBlockSelection"]["TopLeftCol"]; col <= this["oBlockSelection"]["BottomRightCol"]; col++) {
			eColumnSelectionState = this["eGetColSelectionState"](col);
			bColumnSelected = eColumnSelectionState & this["SELECTION_LAYER"]["COLUMN"];
			if (!bColumnSelected) continue;
			for (row = this["oBlockSelection"]["TopLeftRow"]; row <= this["oBlockSelection"]["BottomRightRow"]; row++) {
				oCellInfo = this["oGetCellInfo"](row, col);
				this["aTransformBlockSelectionCells"]["push"](oCellInfo);
				aCellsToReselect["push"](oCellInfo);
			}
		}
		this["setCellSelectionStates"](
			aCellsToReselect,
			true,
			this["SELECTION_LAYER"]["CELL"]
		);
	}

	for (var iCurIndex = iRangeStart; iCurIndex < (iRangeStart + iRangeSize); ++iCurIndex) {
		this["setColumnSelectionByIndex"](iCurIndex, false);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["adjustColumnToBlockSelection"] = 0; };

/**
 * @param {number} iRangeStart The range start to select
 * @param {number} iRangeSize The range size
 * @param {boolean} [bSet] Is this a set or unset operation?
 * @param {UCF_SapTable_EventMapAccessType} sSelectAccess
 * @private
 */
UCF_SapTable["prototype"]["internalFireRowBlockSelect"] = function (iRangeStart, iRangeSize, bSet, sSelectAccess) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireRowBlockSelect"]++; }; 

	var oBlockSelection = null;
	var oCurrentCellInfo = this["oGetFocussedCell"]();
	var iTopLeftCol = this["bHasLeadingSelectionColumn"]() ? 1 : 0;
	var iBottomRightCol = this["aCollectCellsForRowSelection"](iRangeStart)["length"]-1;
	var iBSRefPointColIndex = -1;

	// do not take header rows into account
	if (iRangeStart === 0 && this["bHasHeaderRow"]()) {
		iRangeStart = 1;
		iRangeSize--;
	}

	if (bSet) {
		if (iRangeSize <= 0) {
			oBlockSelection = {};
			this["oBSRefPoint"] = null;
		}
		else {
			oBlockSelection = {
				"TopLeftCol": iTopLeftCol,
				"TopLeftRow": iRangeStart,
				"BottomRightCol": iBottomRightCol,
				"BottomRightRow": iRangeStart+iRangeSize-1
			};
			// set RefIndex for non range selections but not at bTriggerShiftHomeRowSelection
			if (oCurrentCellInfo && iRangeSize === 1 && !this["bTriggerShiftHomeRowSelection"]) {
				iBSRefPointColIndex = oCurrentCellInfo["iColIndex"];
				// do not take selection column into account for RefPoint
				if (this["eGetCellType"](oCurrentCellInfo) === this["SUBCONTROL"]["SELECTION_CELL"]) {
					iBSRefPointColIndex++;
				}
				this["oBSRefPoint"] = {
					"RefCol": iBSRefPointColIndex,
					"RefRow": oCurrentCellInfo["iRowIndex"]
				};
			}
		}
	}
	else {
		if (this["oBlockSelection"] && iTopLeftCol === this["oBlockSelection"]["TopLeftCol"] && iBottomRightCol === this["oBlockSelection"]["BottomRightCol"]) {
			// range exactly matches block -> erase block
			if (iRangeStart === this["oBlockSelection"]["TopLeftRow"] && (iRangeStart + iRangeSize - 1) === this["oBlockSelection"]["BottomRightRow"]) {
				oBlockSelection = {};
			}
			// divide block -> erase block
			else if (iRangeStart > this["oBlockSelection"]["TopLeftRow"] && iRangeStart < this["oBlockSelection"]["BottomRightRow"]) {
				oBlockSelection = {};
			}
			//reduce block top
			else if (iRangeStart === this["oBlockSelection"]["TopLeftRow"] && (iRangeStart + iRangeSize) < this["oBlockSelection"]["BottomRightRow"]) {
				oBlockSelection = {
					"TopLeftCol": iTopLeftCol,
					"TopLeftRow": iRangeStart+iRangeSize,
					"BottomRightCol": iBottomRightCol,
					"BottomRightRow": this["oBlockSelection"]["BottomRightRow"]
				};
			}
			//reduce block bottom
			else if (iRangeStart > this["oBlockSelection"]["TopLeftRow"] && (iRangeStart + iRangeSize - 1) === this["oBlockSelection"]["BottomRightRow"]) {
				oBlockSelection = {
					"TopLeftCol": iTopLeftCol,
					"TopLeftRow": this["oBlockSelection"]["TopLeftRow"],
					"BottomRightCol": iBottomRightCol,
					"BottomRightRow": iRangeStart - 1
				};
			}
		}
	}

	if (!oBlockSelection) return;

	this["setBlockSelectionInternal"](
		oBlockSelection,
		(sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"])
			? this["BLOCKSELECTION_MODE"]["TRANSFORM"]
			: this["BLOCKSELECTION_MODE"]["INITIALIZE"],
			false,
			true
	);

	this["fireBlockSelect"](this["sId"],
		UCF_JsUtil["sJsonStringify"](this["oEnrichBSProperties"](oBlockSelection)),
		sSelectAccess
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireRowBlockSelect"] = 0; };

/**
 * @param {number} iRangeStart The range start to select
 * @param {number} iRangeSize The range size
 * @param {boolean} [bSet] Is this a set or unset operation?
 * @param {UCF_SapTable_EventMapAccessType} sSelectAccess
 * @private
 */
UCF_SapTable["prototype"]["internalFireColumnBlockSelect"] = function (iRangeStart, iRangeSize, bSet, sSelectAccess) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireColumnBlockSelect"]++; }; 

	var oBlockSelection = null;
	var oCurrentCellInfo = this["oGetFocussedCell"]();
	var iTopLeftRow = this["bHasHeaderRow"]() ? 1 : 0;
	var iBottomRightRow = this["iGetRowCount"]()-1;
	var iBSRefPointRowIndex = -1;

	if (UCF_JsUtil["bInstanceOf"](this, 'UCF_SapTableCS')) {
		iBottomRightRow = this["iMatrixHeaderRowCount"] + this["iMatrixTopFixedRowCount"] + this["iMatrixContentRowCount"] + this["iMatrixBottomFixedRowCount"] - 1;
	}

	// do not take selection columns into account
	if (iRangeStart === 0 && this["bHasLeadingSelectionColumn"]()) {
		iRangeStart = 1;
		iRangeSize--;
	}

	if (bSet) {
		oBlockSelection = {
			"TopLeftCol": iRangeStart,
			"TopLeftRow": iTopLeftRow,
			"BottomRightCol": iRangeStart+iRangeSize-1,
			"BottomRightRow": iBottomRightRow
		};
		// set RefIndex for non range selections but not at bTriggerShiftHomeColumnSelection
		if (oCurrentCellInfo && iRangeSize === 1 && !this["bTriggerShiftHomeColumnSelection"]) {
			iBSRefPointRowIndex = oCurrentCellInfo["iRowIndex"];
			// do not take header row into account for RefPoint
			if (this["eGetCellType"](oCurrentCellInfo) === this["SUBCONTROL"]["HEADER_CELL"]) {
				iBSRefPointRowIndex++;
			}
			this["oBSRefPoint"] = {
				"RefCol": oCurrentCellInfo["iColIndex"],
				"RefRow": iBSRefPointRowIndex
			};
		}
	}
	else {
		if (this["oBlockSelection"] && iTopLeftRow === this["oBlockSelection"]["TopLeftRow"] && iBottomRightRow === this["oBlockSelection"]["BottomRightRow"]) {
			// range exactly matches block -> erase block
			if (iRangeStart === this["oBlockSelection"]["TopLeftCol"] && (iRangeStart + iRangeSize - 1) === this["oBlockSelection"]["BottomRightCol"]) {
				oBlockSelection = {};
			}
			// divide block -> erase block
			else if (iRangeStart > this["oBlockSelection"]["TopLeftCol"] && iRangeStart < this["oBlockSelection"]["BottomRightCol"]) {
				oBlockSelection = {};
			}
			//reduce block left
			else if (iRangeStart === this["oBlockSelection"]["TopLeftCol"] && (iRangeStart + iRangeSize) < this["oBlockSelection"]["BottomRightCol"]) {
				oBlockSelection = {
					"TopLeftCol": iRangeStart+iRangeSize,
					"TopLeftRow": iTopLeftRow,
					"BottomRightCol": this["oBlockSelection"]["BottomRightCol"],
					"BottomRightRow": iBottomRightRow
				};
			}
			//reduce block right
			else if (iRangeStart > this["oBlockSelection"]["TopLeftCol"] && (iRangeStart + iRangeSize - 1) === this["oBlockSelection"]["BottomRightCol"]) {
				oBlockSelection = {
					"TopLeftCol": this["oBlockSelection"]["TopLeftCol"],
					"TopLeftRow": iTopLeftRow,
					"BottomRightCol": iRangeStart - 1,
					"BottomRightRow": iBottomRightRow
				};
			}
		}
	}

	if (!oBlockSelection) return;

	this["setBlockSelectionInternal"](
		oBlockSelection,
		(sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"])
			? this["BLOCKSELECTION_MODE"]["TRANSFORM"]
			: this["BLOCKSELECTION_MODE"]["INITIALIZE"],
			false,
			true
	);

	this["fireBlockSelect"](this["sId"],
		UCF_JsUtil["sJsonStringify"](this["oEnrichBSProperties"](oBlockSelection)),
		sSelectAccess
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireColumnBlockSelect"] = 0; };

/**
 * @param {number} iRangeStart The range start to select
 * @param {number} iRangeSize The range size
 * @param {boolean} [bSet] Is this a set or unset operation?
 * @param {UCF_SapTable_EventMapAccessType} sSelectAccess
 * @private
 */
UCF_SapTable["prototype"]["applyRowBlockSelect"] = function (iRangeStart, iRangeSize, bSet, sSelectAccess) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyRowBlockSelect"]++; }; 

	var oBlockSelection = null;
	var iTopLeftCol = this["bHasLeadingSelectionColumn"]() ? 1 : 0;
	var iBottomRightCol = this["aCollectCellsForRowSelection"](iRangeStart)["length"]-1;

	// do not take header rows into account
	if (iRangeStart === 0 && this["bHasHeaderRow"]()) {
		iRangeStart = 1;
		iRangeSize--;
	}

	if (bSet) {
		oBlockSelection = {
			"TopLeftCol": iTopLeftCol,
			"TopLeftRow": iRangeStart,
			"BottomRightCol": iBottomRightCol,
			"BottomRightRow": iRangeStart+iRangeSize-1
		};
	}
	else {
		if (iTopLeftCol === this["oBlockSelection"]["TopLeftCol"] && iBottomRightCol === this["oBlockSelection"]["BottomRightCol"]) {
			// divide block -> erase block
			if (iRangeStart >= this["oBlockSelection"]["TopLeftRow"] && iRangeStart <= this["oBlockSelection"]["BottomRightRow"]) {
				oBlockSelection = {};
			}
			//reduce block
			if (iRangeStart === this["oBlockSelection"]["TopLeftRow"]) {
				oBlockSelection = {
					"TopLeftCol": iTopLeftCol,
					"TopLeftRow": iRangeStart+iRangeSize,
					"BottomRightCol": iBottomRightCol,
					"BottomRightRow": this["oBlockSelection"]["BottomRightRow"]
				};
			}
		}
	}

	this["setBlockSelectionInternal"](
		oBlockSelection,
		(bSet && sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"])
			? this["bRowDragSelectStart"] ? this["BLOCKSELECTION_MODE"]["TRANSFORM"] : this["BLOCKSELECTION_MODE"]["NEUTRAL"]
			: this["BLOCKSELECTION_MODE"]["INITIALIZE"],
			true,
			true
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyRowBlockSelect"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 */
UCF_SapTable["prototype"]["internalFireCellSelect"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireCellSelect"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oReferenceCell;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(4301): internalFireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(4302): internalFireCellSelect"); };

	oReferenceCell = null;

	if (this["sCellSelectionMapping"] === 'ROW') {
		oReferenceCell = this["oGetRowReferenceCell"](oAccessInfo["oCellInfo"]["iRowIndex"]);
		if (oReferenceCell) {
			if (!(
					this["eGetRowSelectionState"](oAccessInfo["oCellInfo"]["iRowIndex"]) &
					this["SELECTION_LAYER"]["ROW_DISABLED"]
				)) {
				this["internalFireRowSelect"](oAccessInfo);

				return;
			}
		}
	} else if (this["sCellSelectionMapping"] === 'COLUMN') {
		oReferenceCell = this["oGetColReferenceCell"](oAccessInfo["oCellInfo"]["iColIndex"]);
		if (oReferenceCell) {
			if (!(
					this["eGetColSelectionState"](oAccessInfo["oCellInfo"]["iColIndex"]) &
					this["SELECTION_LAYER"]["COLUMN_DISABLED"]
				)) {
				this["internalFireHeaderCellSelect"](
					oAccessInfo,
					this["sGetCellId"](oReferenceCell)
				);

				return;
			}
		}
	}

	this["sCellSelectSubControlId"] = this["sGetEventSelectAccessType"](oAccessInfo) === 'RANGE'
		? ''
		: oAccessInfo["sSubControlId"];

	this["fireCellSelect"](oAccessInfo["oTable"]["sId"],
		oAccessInfo["sSubControlId"],
		this["sGetEventCellType"](oAccessInfo),
		this["iGetApiRowIndex"](oAccessInfo["oCellInfo"]),
		this["iGetApiColIndex"](oAccessInfo["oCellInfo"]),
		this["sGetRowUserData"](oAccessInfo["oCellInfo"]),
		this["sGetCellUserData"](oAccessInfo["oCellInfo"]),
		this["sGetEventSelectAccessType"](oAccessInfo)
	);

	oAccessInfo["bHandled"] = this["bHasEventListeners"]('CellSelect');

	if (
		oAccessInfo["sAccessFragmentType"] !== 'BLOCKSEL' &&
		this["bBlockSelectionActive"]()
	) {
		this["internalFireBlockSelect"](oAccessInfo);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireCellSelect"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 */
UCF_SapTable["prototype"]["internalFireSelectionCellSelect"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireSelectionCellSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(4364): internalFireSelectionCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(4365): internalFireSelectionCellSelect"); };

	this["internalFireRowSelect"](oAccessInfo);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireSelectionCellSelect"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @param {string} sHeaderCellId
 */
UCF_SapTable["prototype"]["internalFireHeaderCellSelect"] = function(oAccessInfo, sHeaderCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireHeaderCellSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(4376): internalFireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(4377): internalFireHeaderCellSelect"); };

	this["fireHeaderCellSelect"](
		oAccessInfo["oTable"]["sId"],
		sHeaderCellId ? sHeaderCellId : oAccessInfo["sSubControlId"],
		this["sGetEventSelectAccessType"](oAccessInfo),
		this["sGetCellUserData"](oAccessInfo["oCellInfo"])
	);

	oAccessInfo["bHandled"] = this["bHasEventListeners"]('HeaderCellSelect');

	if (
		oAccessInfo["sAccessFragmentType"] !== 'BLOCKSEL' &&
		this["bBlockSelectionActive"]() &&
		oAccessInfo["oCellInfo"] &&
		this["bCellSupportsBlockSelection"](oAccessInfo["oCellInfo"])
	) {
		this["internalFireBlockSelect"](oAccessInfo);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireHeaderCellSelect"] = 0; };

/**
 * @param {Object} oAccessInfo
 * @private
 */
UCF_SapTable["prototype"]["internalFireRowSelect"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireRowSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(4403): internalFireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(4404): internalFireRowSelect"); };

	var sSelectAccessType;
	if (oAccessInfo["oBrowserEvent"] && oAccessInfo["oBrowserEvent"]["sName"] &&
		(oAccessInfo["oBrowserEvent"]["sName"] === 'lsselect' || oAccessInfo["oBrowserEvent"]["sName"] === 'lsselectmodifier')) {
		if (oAccessInfo["oBrowserEvent"]["iKeyCode"]() === UCF_KeyCodes["SPACE"]) {
			sSelectAccessType = this["ACCESS_TYPE"]["KEYBOARD_SELECT"];
		}
		if (oAccessInfo["oBrowserEvent"]["iKeyCode"]() === UCF_KeyCodes["ENTER"]) {
			sSelectAccessType = this["ACCESS_TYPE"]["KEYBOARD_ENTER"];
		}
	}

	this["internalFireRowSelectDirect"](
		oAccessInfo["oCellInfo"],
		oAccessInfo["eAccessType"],
		this["sGetEventSelectAccessType"](oAccessInfo),
		oAccessInfo["oTable"],
		sSelectAccessType
	);

	if (window["UCF_System"]["bIsAria"] && this["bIsValidCellInfo"](oAccessInfo["oCellInfo"])) {
		if ((oAccessInfo["oCellInfo"]["iSelectionState"] & (
				this["SELECTION_LAYER"]["COLUMN"] |
				this["SELECTION_LAYER"]["CELL"] |
				this["SELECTION_LAYER"]["ROW"] |
				this["SELECTION_LAYER"]["ROW_PRIMARY"]
			)) > 0) {
			oAccessInfo["oCellInfo"]["oDomRefRow"]["setAttribute"]('aria-selected', 'true');
		} else {
			oAccessInfo["oCellInfo"]["oDomRefRow"]["setAttribute"]('aria-selected', 'false');
		}
	}

	oAccessInfo["bHandled"] = this["bHasEventListeners"]('RowSelect') ||
		this["bHasEventListeners"]('ClientRowSelect');
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireRowSelect"] = 0; };

/* eslint-disable complexity */
/**
 * Handles a request to select a row and triggers the corresponding mass
 * selection processses and triggers a potentinal event
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {UCF_SapTable_EventMapAccessType} eAccessType
 * @param {UCF_SapTable_EventMapAccessType} sSelectAccess
 * @param {UCF_SapTable} oTable
 * @param {UCF_SapTable_EventMapAccessType} sSelectAccessType
 */
UCF_SapTable["prototype"]["internalFireRowSelectDirect"] = function(oCellInfo, eAccessType, sSelectAccess, oTable, sSelectAccessType) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireRowSelectDirect"]++; }; 
	/** @type {UCF_SapTable_SelectionLayer} */
	var eSelectionState;
	/** @type {Object<number,boolean>} */
	var mExceptionMap;
	/** @type {boolean} */
	var bHasPrimarySelection;
	/** @type {boolean} */
	var bHasMandatoryPrimarySelection;
	/** @type {boolean} */
	var bIsMulti;
	/** @type {boolean} */
	var bHasPrimarySelectionChanged;
	/** @type {boolean} */
	var bIsPrimarySelectionSet;
	/** @type {number} */
	var iRowIndex;
	/** @type {number} */
	var iMaxRange;
	/** @type {number} */
	var iMaxStart;
	/** @type {number} */
	var iConvertedRefIndex;
	/** @type {number} */
	var iConvertedEndIndex;
	/** @type {number} */
	var iRangeStart;
	/** @type {number} */
	var iRangeSize;
	/** @type {number} */
	var iRangeRefStart;
	/** @type {number} */
	var iRangeRefSize;
	/** @type {number} */
	var i;
	/** @type {number} */
	var bSelected;
	/** @type {HTMLElement} */
	var oActiveElement;
	/** @type {UCF_Control}  */
	var oControl;
	/** @type {number} */
	var iStart;
	/** @type {string} */
	var sTriggerAction;

	if (this["sRowSelectionMode"] === 'NONE') {
		return;
	}

	eSelectionState = null;
	mExceptionMap = null;

	if (eAccessType === this["ACCESS_TYPE"]["KEYBOARD_TAB"]  ||  eAccessType === this["ACCESS_TYPE"]["KEYBOARD_NAVIGATE"]) {
		sTriggerAction = this["EVENT_PARAM_MAP_TRIGGER_ACTION"]["FOCUS"];
	}
	else {
		if (sSelectAccessType === this["ACCESS_TYPE"]["KEYBOARD_SELECT"]) {
			sTriggerAction = this["EVENT_PARAM_MAP_TRIGGER_ACTION"]["SPACE"];
		}
		else if (sSelectAccessType === this["ACCESS_TYPE"]["KEYBOARD_ENTER"]) {
			sTriggerAction = this["EVENT_PARAM_MAP_TRIGGER_ACTION"]["ENTER"];
		}
		else sTriggerAction = this["EVENT_PARAM_MAP_TRIGGER_ACTION"]["MOUSE"];
	}

	if (
		this["sRowSelectionMode"] !== 'SERVER' && (
			this["sRowSelectionClientBehaviour"] === 'SMART' ||
			this["sRowSelectionClientBehaviour"] === 'WEB' ||
			this["sRowSelectionClientBehaviour"] === 'WEB_SMART'
		)
	) {
		// Client side selection activated
		bHasPrimarySelection = this["sRowSelectionMode"]["indexOf"]('PRIMARY') !== -1;
		bHasMandatoryPrimarySelection = bHasPrimarySelection &&
			this["sRowSelectionMode"]["indexOf"]('MANDATORY') !== -1;
		bIsMulti = this["sRowSelectionMode"]["indexOf"]('MULTI') !== -1;
		bHasPrimarySelectionChanged = false;
		// Check if the referenceIndex is also the primary selected row or just a
		// range selection index
		bIsPrimarySelectionSet = this["bHasSetRowSelectionReferenceIndex"]() && (
			this["eGetRowSelectionState"](this["iGetSelectionReferenceCellMatrixRowIndex"]()) &
			this["SELECTION_LAYER"]["ROW_PRIMARY"]
		);
		iRowIndex = oCellInfo
			? oCellInfo["iRowIndex"]
			: this["APPDEFINED_ROW_DEFAULT_INDEX"];
		iMaxRange = this["iGetCellInfoMatrixLastRowIndex"]() + 1;
		iMaxStart = 0;

		if (
			eAccessType === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"] ||
			eAccessType === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]
		) {
			//AccessType correction for deselect and select all
			sSelectAccess = eAccessType;
		}

		if (!bIsMulti) {
			// Cleanup for access type which makes no sense for single selection
			if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"]) {
				sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
			} else if (
				sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"] ||
				sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]
			) {
				return;
			}
		}

		if (this["sRowSelectionClientBehaviour"] === 'WEB') {
			// No Primary for WEB supported
			bHasPrimarySelection = false;
			bHasMandatoryPrimarySelection = false;
			bIsPrimarySelectionSet = false;
			bHasPrimarySelectionChanged = false;

			// For "WEB" mode the standard acesss type is toggle
			if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]) {
				sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"];
			}
		} else if (
			this["bRowSelectionCellToggleMode"] &&
			this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["SELECTION_CELL"]
		) {
			if (eAccessType === this["ACCESS_TYPE"]["KEYBOARD_NAVIGATE"]) {
				if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]) {
					return;
				} else if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]) {
					sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
				}
			} else if (eAccessType === this["ACCESS_TYPE"]["KEYBOARD_TAB"]) {
				sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
			} else if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]) {
				sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"];
			}
		}

		if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"]) {
			this["updateSelectionInfo"](iMaxStart, this["iGetRowCount"]() + 1, true);
			// in case of active Block Selection really select all ... not only all starting with current focus row
			iStart = this["bBlockSelectionActive"]() ? iMaxStart : oCellInfo["iRowIndex"];
			this["processRowSelectionMassUpdate"](
				iStart,
				iMaxRange,
				true,
				this["SELECTION_LAYER"]["ROW"]
			);

			if (!bHasPrimarySelection) {
				this["resetRowSelectionReferenceIndex"]();
			}
		} else if (
			sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]
		) {
			if (bHasMandatoryPrimarySelection) {
				this["updateSelectionInfo"](iMaxStart, iMaxRange, false);
				this["processRowSelectionMassUpdate"](
					iMaxStart,
					iMaxRange,
					false,
					this["SELECTION_LAYER"]["ROW"]
				);
			} else {
				bHasPrimarySelectionChanged = bHasPrimarySelection &&
					bIsPrimarySelectionSet;

				this["updateSelectionInfo"](iMaxStart, iMaxRange, false);
				this["processRowSelectionMassUpdate"](
					iMaxStart,
					iMaxRange,
					false,
					this["SELECTION_LAYER"]["ROW"] | this["SELECTION_LAYER"]["ROW_PRIMARY"]
				);
				this["resetRowSelectionReferenceIndex"]();
			}
			if (this["bBlockSelectionActive"]()) {
				this["internalFireBlockSelect"]({"oTable": this, "eAccessType": this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]});
			}
		} else if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]) {
			eSelectionState = this["eGetRowSelectionState"](iRowIndex);
			mExceptionMap = {};

			if (eSelectionState & this["SELECTION_LAYER"]["ROW_DISABLED"]) {
				return;
			}

			bHasPrimarySelectionChanged = bHasPrimarySelection &&
				!(eSelectionState & this["SELECTION_LAYER"]["ROW_PRIMARY"]);

			mExceptionMap[iRowIndex] = true;

			if (this["iLastStandardSelectionRowIndex"] > -1) {
				// optimized selection clear
				this["updateSelectionInfo"](
					this["iLastStandardSelectionRowIndex"],
					1,
					false,
					mExceptionMap
				);
				this["processRowSelectionMassUpdate"](
					this["iLastStandardSelectionRowIndex"],
					1,
					false,
					this["SELECTION_LAYER"]["ROW"] | this["SELECTION_LAYER"]["ROW_PRIMARY"],
					mExceptionMap
				);
			} else {
				this["updateSelectionInfo"](iMaxStart, iMaxRange, false, mExceptionMap);
				this["processRowSelectionMassUpdate"](
					iMaxStart,
					iMaxRange,
					false,
					this["SELECTION_LAYER"]["ROW"] | this["SELECTION_LAYER"]["ROW_PRIMARY"],
					mExceptionMap
				);
			}

			this["setSecondarySelectionByIndex"](iRowIndex, true, sSelectAccess);
			if (bHasPrimarySelection) {
				this["setPrimarySelectionByIndex"](iRowIndex, true);
			}
			this["updateSelectionInfo"](iRowIndex, 1, true);

			this["setRowSelectionReferenceIndex"](oCellInfo);

			this["iLastStandardSelectionRowIndex"] = iRowIndex;

		} else if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"]) {
			eSelectionState = this["eGetRowSelectionState"](iRowIndex);
			iConvertedRefIndex = this["bHasSetRowSelectionReferenceIndex"]()
				? this["iGetSelectionReferenceCellMatrixRowIndex"]()
				: 0;
			iRangeStart = 0;
			iRangeSize = 0;
			mExceptionMap = {};

			if (eSelectionState & this["SELECTION_LAYER"]["ROW_DISABLED"]) {
				return;
			}

			if (typeof iConvertedRefIndex === 'undefined') {
				iConvertedRefIndex = 0;
			}

			iRangeSize = Math["abs"](iRowIndex - iConvertedRefIndex) + 1;
			iRangeStart = Math["min"](iConvertedRefIndex, iRowIndex);

			for (i = iRangeStart; i < iRangeStart + iRangeSize; i++) {
				mExceptionMap[i] = true;
			}

			// for WEB and WEB_SMART, do not cleanup previous selections
			// // do not cleanup if last select access was toggle (ctrl modifier)
			// if (this.sRowSelectionClientBehaviour === 'SMART' && this.iLastRowSelectAccess !== this.EVENT_PARAM_MAP_ACCESS_TYPE.TOGGLE) {
			if (this["sRowSelectionClientBehaviour"] === 'SMART') {
				if (this["bBlockSelectionActive"]()) {  //SMART_MULTI_RANGE - allow multiple ranges
					iConvertedEndIndex = this["bHasSetRowSelectionRangeEndIndex"]()
						? this["iGetSelectionRangeEndCellMatrixRowIndex"]()
						: 0;
					iRangeRefSize = this["bHasSetRowSelectionRangeEndIndex"]() ? (Math["abs"](iConvertedRefIndex - iConvertedEndIndex) + 1) : 1;
					iRangeRefStart = this["bHasSetRowSelectionRangeEndIndex"]() ? (Math["min"](iConvertedRefIndex, iConvertedEndIndex)) : iConvertedRefIndex;
					this["updateSelectionInfo"](iRangeRefStart, iRangeRefSize, false, mExceptionMap);
					this["processRowSelectionMassUpdate"](
						iRangeRefStart,
						iRangeRefSize,
						false,
						this["SELECTION_LAYER"]["ROW"],
						mExceptionMap
					);
				}
				else {
					this["updateSelectionInfo"](iMaxStart, iMaxRange, false, mExceptionMap);
					this["processRowSelectionMassUpdate"](
						iMaxStart,
						iMaxRange,
						false,
						this["SELECTION_LAYER"]["ROW"],
						mExceptionMap
					);
				}
			}
			this["updateSelectionInfo"](iRangeStart, iRangeSize, true);
			this["processRowSelectionMassUpdate"](
				iRangeStart,
				iRangeSize,
				true,
				this["SELECTION_LAYER"]["ROW"]
			);

			this["setRowSelectionRangeEndIndex"](oCellInfo);

			// When no Primary is set in Primary selection mode the selection range
			// action leads to PrimaryChange
			if (bHasPrimarySelection && !this["bHasSetRowSelectionReferenceIndex"]()) {
				bHasPrimarySelectionChanged = true;
			}
		} else if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]) {
			eSelectionState = this["eGetRowSelectionState"](iRowIndex);
			bSelected = eSelectionState & this["SELECTION_LAYER"]["ROW"] ||
				eSelectionState & this["SELECTION_LAYER"]["ROW_PRIMARY"];

			if (eSelectionState & this["SELECTION_LAYER"]["ROW_DISABLED"]) {
				return;
			}
			if (
				bHasMandatoryPrimarySelection &&
				eSelectionState & this["SELECTION_LAYER"]["ROW_PRIMARY"]
			) {
				return;
			}

			bHasPrimarySelectionChanged = bHasPrimarySelection &&
				(eSelectionState & this["SELECTION_LAYER"]["ROW_PRIMARY"]);

			if (bSelected) {
				if (
					bHasPrimarySelection &&
					eSelectionState & this["SELECTION_LAYER"]["ROW_PRIMARY"]
				) {
					this["setPrimarySelectionByIndex"](iRowIndex, false);
					this["resetRowSelectionReferenceIndex"]();
				} else if (!bHasPrimarySelection) {
					this["setRowSelectionReferenceIndex"](oCellInfo);
				}
				this["setSecondarySelectionByIndex"](iRowIndex, false, sSelectAccess);
				this["updateSelectionInfo"](iRowIndex, 1, false);
			} else {
				if (!bIsMulti) {
					this["updateSelectionInfo"](iMaxStart, iMaxRange, false);
					this["processRowSelectionMassUpdate"](
						iMaxStart,
						iMaxRange,
						false,
						this["SELECTION_LAYER"]["ROW"] | this["SELECTION_LAYER"]["ROW_PRIMARY"]
					);
				}

				if (bHasPrimarySelection) {
					if (!bIsPrimarySelectionSet || !bIsMulti) {
						this["setPrimarySelectionByIndex"](iRowIndex, true);
						bHasPrimarySelectionChanged = true;
						this["setRowSelectionReferenceIndex"](oCellInfo);
					}

					this["setSecondarySelectionByIndex"](iRowIndex, true, sSelectAccess);
				} else {
					this["setSecondarySelectionByIndex"](iRowIndex, true, sSelectAccess);
					this["setRowSelectionReferenceIndex"](oCellInfo);
				}
				this["updateSelectionInfo"](iRowIndex, 1, true);
			}
		}

		// iLastStandardSelectionRowIndex is an optimization for client row
		// selection
		if (sSelectAccess !== this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]) {
			this["iLastStandardSelectionRowIndex"] = -1;
		}

		if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"]) {
			this["doFireClientRowSelect"](
				oTable["sId"],
				-1,
				'',
				'',
				this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"],
				'',
				''
			);
		} else if (
			sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]
		) {
			this["doFireClientRowSelect"](
				oTable["sId"],
				-1,
				'',
				'',
				this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"],
				'',
				''
			);
		} else if (this["bIsValidCellInfo"](oCellInfo)) {
			this["doFireClientRowSelect"](oTable["sId"],
				this["iGetApiRowIndex"](oCellInfo),
				this["sGetRowUserData"](oCellInfo),
				this["sGetCellUserData"](oCellInfo),
				sSelectAccess,
				this["sGetCellId"](oCellInfo),
				sTriggerAction
			);
		}

		// Refocus to recalculate announcement after mapi call
		if (window["UCF_System"]["bIs508"]) {
			oActiveElement = UCF_DomUtil["oGetActiveElement"]();

			if (oActiveElement) {

				// Refocus deletes selection text. This has to be avoided in capture
				// mode
				if (
					this["bCapturedEventProcessing"] &&
					oActiveElement &&
					oActiveElement["tagName"] === 'INPUT' &&
					UCF_DomUtil["sGetSelectionText"](oActiveElement)
				) {
					//SKIP refocus
				} else {
					oControl = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](
						oActiveElement,
						true
					);

					// CSN 141430 2016: space is ignored in InputField and ComboBox
					if (
						oControl &&
						UCF_JsUtil["bInstanceOf"](oControl, 'UCF_EditFieldBase')
					) {
						oControl["refocus"]();
					} else {
						UCF_DomUtil["refocusDomElement"](oActiveElement);
					}
				}
			}
		}

		if (bHasPrimarySelectionChanged) {
			this["fireClientPrimaryRowChange"](oTable["sId"]);
		}
	} else if (eAccessType === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"]) {
		this["fireRowSelect"](
			oTable["sId"],
			-1,
			'',
			'',
			this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"],
			'',
			''
		);
	} else if (eAccessType === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]) {
		this["fireRowSelect"](
			oTable["sId"],
			-1,
			'',
			'',
			this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"],
			'',
			''
		);
	} else {
		this["fireRowSelect"](
			oTable["sId"],
			this["iGetApiRowIndex"](oCellInfo),
			this["sGetRowUserData"](oCellInfo),
			this["sGetCellUserData"](oCellInfo),
			sSelectAccess,
			this["sGetCellId"](oCellInfo),
			sTriggerAction
		);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["internalFireRowSelectDirect"] = 0; };
/* eslint-enable complexity */

/**
 * Handles a row range select and triggers the corresponding mass
 * selection processses at UI side
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["handleRowRangeSelectUI"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleRowRangeSelectUI"]++; }; 
	/** @type {UCF_SapTable_SelectionLayer} */
	var eSelectionState;
	/** @type {number} */
	var iRowIndex;
	/** @type {number} */
	var iMaxRange;
	/** @type {number} */
	var iMaxStart;
	/** @type {number} */
	var iConvertedRefIndex;
	/** @type {number} */
	var iConvertedEndIndex;
	/** @type {number} */
	var iRangeStart;
	/** @type {number} */
	var iRangeSize;
	/** @type {number} */
	var iRangeRefStart;
	/** @type {number} */
	var iRangeRefSize;

	if (this["sRowSelectionMode"] === 'NONE' || this["sRowSelectionMode"] === 'SERVER' ||
			this["sRowSelectionMode"] === 'SINGLE' || this["sRowSelectionMode"] === 'SINGLE_PRIMARY' || this["sRowSelectionMode"] === 'SINGLE_PRIMARY_MANDATORY' ||
			(this["sRowSelectionClientBehaviour"] !== 'SMART' &&
			this["sRowSelectionClientBehaviour"] !== 'WEB' &&
			this["sRowSelectionClientBehaviour"] !== 'WEB_SMART' &&
			this["sRowSelectionClientBehaviour"] !== 'SERVER_WEB_SMART')) {
		return;
	}

	// Client side selection activated
	eSelectionState = null;

	iRowIndex = oCellInfo
		? oCellInfo["iRowIndex"]
		: this["APPDEFINED_ROW_DEFAULT_INDEX"];
	iMaxRange = this["iGetCellInfoMatrixLastRowIndex"]() + 1;
	iMaxStart = 0;


	eSelectionState = this["eGetRowSelectionState"](iRowIndex);
	iConvertedRefIndex = this["bHasSetRowSelectionReferenceIndex"]()
		? this["iGetSelectionReferenceCellMatrixRowIndex"]()
		: 0;
	iRangeStart = 0;
	iRangeSize = 0;

	if (eSelectionState & this["SELECTION_LAYER"]["ROW_DISABLED"]) {
		return;
	}

	if (typeof iConvertedRefIndex === 'undefined') {
		iConvertedRefIndex = 0;
	}

	iRangeSize = Math["abs"](iRowIndex - iConvertedRefIndex) + 1;
	iRangeStart = Math["min"](iConvertedRefIndex, iRowIndex);

	// for (i = iRangeStart; i < iRangeStart + iRangeSize; i++) {
	// 	mExceptionMap[i] = true;
	// }
	// aSelectedRows = this.getSelectedRows();
	// for (i = 0; i < aSelectedRows.length - 1; i++) {
	// 	mExceptionMap[aSelectedRows[i]] = true;
	// }

	// for WEB and WEB_SMART, do not cleanup previous selections
	// do not cleanup if last select access was toggle (ctrl modifier)
	// if (this.sRowSelectionClientBehaviour === 'SMART' && this.iLastRowSelectAccess !== this.EVENT_PARAM_MAP_ACCESS_TYPE.TOGGLE) {
	// 	this.updateSelectionInfo(iMaxStart, iMaxRange, false, mExceptionMap);
	// 	this.processRowSelectionMassUpdate(
	// 		iMaxStart,
	// 		iMaxRange,
	// 		false,
	// 		this.SELECTION_LAYER.ROW,
	// 		mExceptionMap
	// 	);
	// }

	iConvertedEndIndex = this["bHasSetRowSelectionRangeEndIndex"]()
		? this["iGetSelectionRangeEndCellMatrixRowIndex"]()
		: 0;
	iRangeRefSize = this["bHasSetRowSelectionRangeEndIndex"]() ? (Math["abs"](iConvertedRefIndex - iConvertedEndIndex) + 1) : 1;
	iRangeRefStart = this["bHasSetRowSelectionRangeEndIndex"]() ? (Math["min"](iConvertedRefIndex, iConvertedEndIndex)) : iConvertedRefIndex;

	if (this["bRowDragSelectActive"]) {
		this["updateSelectionInfo"](iRangeRefStart, iRangeRefSize, false, this["mRowDragSelectExceptionMap"]);
		this["processRowSelectionMassUpdate"](
			iRangeRefStart,
			iRangeRefSize,
			false,
			this["SELECTION_LAYER"]["ROW"],
			this["mRowDragSelectExceptionMap"]
		);
	}
	else {
		// for WEB and WEB_SMART, do not cleanup previous selections
		// // do not cleanup if last select access was toggle (ctrl modifier)
		// if (this.sRowSelectionClientBehaviour === 'SMART' && this.iLastRowSelectAccess !== this.EVENT_PARAM_MAP_ACCESS_TYPE.TOGGLE) {
		if (this["sRowSelectionClientBehaviour"] === 'SMART' || this["sRowSelectionClientBehaviour"] === 'WEB_SMART' || this["sRowSelectionClientBehaviour"] === 'SERVER_WEB_SMART') {
			if (this["bBlockSelectionActive"]()) {  //SMART_MULTI_RANGE - allow multiple ranges
				if (this["sRowDragSelectAccess"] === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]) {
					this["updateSelectionInfo"](iMaxStart, iMaxRange, false, this["mRowDragSelectExceptionMap"]);
					this["processRowSelectionMassUpdate"](
						iMaxStart,
						iMaxRange,
						false,
						this["SELECTION_LAYER"]["ROW"],
						this["mRowDragSelectExceptionMap"]
					);
				}
				if (this["sRowDragSelectAccess"] === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]) {
					this["updateSelectionInfo"](iRangeRefStart, iRangeRefSize, false, this["mRowDragSelectExceptionMap"]);
					this["processRowSelectionMassUpdate"](
						iRangeRefStart,
						iRangeRefSize,
						false,
						this["SELECTION_LAYER"]["ROW"],
						this["mRowDragSelectExceptionMap"]
					);
				}
			}
			else {
				this["updateSelectionInfo"](iMaxStart, iMaxRange, false, this["mRowDragSelectExceptionMap"]);
				this["processRowSelectionMassUpdate"](
					iMaxStart,
					iMaxRange,
					false,
					this["SELECTION_LAYER"]["ROW"],
					this["mRowDragSelectExceptionMap"]
				);
			}
		}
	}

	this["updateSelectionInfo"](iRangeStart, iRangeSize, true, this["mRowDragSelectExceptionMap"]);
	this["processRowSelectionMassUpdate"](
		iRangeStart,
		iRangeSize,
		true,
		this["SELECTION_LAYER"]["ROW"],
		this["mRowDragSelectExceptionMap"]
	);

	this["setRowSelectionRangeEndIndex"](oCellInfo);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleRowRangeSelectUI"] = 0; };

/**
 * Handles a row range select and triggers the corresponding mass
 * selection processses at UI side
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["handleRowRangeSelectEvent"] = function(oCellInfo, sSelectAccess) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleRowRangeSelectEvent"]++; }; 

	if (this["sRowSelectionMode"] === 'NONE' || this["sRowSelectionMode"] === 'SERVER' ||
			(this["sRowSelectionClientBehaviour"] !== 'SMART' &&
			this["sRowSelectionClientBehaviour"] !== 'WEB' &&
			this["sRowSelectionClientBehaviour"] !== 'WEB_SMART' &&
			this["sRowSelectionClientBehaviour"] !== 'SERVER_WEB_SMART')) {
		return;
	}

	if (this["sRowSelectionClientBehaviour"] === 'SERVER_WEB_SMART') {
		this["iLastStandardSelectionRowIndex"] = -1;

		if (this["bIsValidCellInfo"](oCellInfo)) {
			this["fireRowSelect"](this["sId"],
				this["iGetApiRowIndex"](oCellInfo),
				this["sGetRowUserData"](oCellInfo),
				this["sGetCellUserData"](oCellInfo),
				sSelectAccess,
				this["sGetCellId"](oCellInfo),
				this["EVENT_PARAM_MAP_TRIGGER_ACTION"]["MOUSE"]
			);
		}
	}
	else {
		this["iLastStandardSelectionRowIndex"] = -1;

		if (this["bIsValidCellInfo"](oCellInfo)) {
			this["doFireClientRowSelect"](this["sId"],
				this["iGetApiRowIndex"](oCellInfo),
				this["sGetRowUserData"](oCellInfo),
				this["sGetCellUserData"](oCellInfo),
				sSelectAccess,
				this["sGetCellId"](oCellInfo),
				this["EVENT_PARAM_MAP_TRIGGER_ACTION"]["MOUSE"]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleRowRangeSelectEvent"] = 0; };

/**
 * Sets the RowRange Select range
 *
 * @private
 */
UCF_SapTable["prototype"]["setRowDragSelectActive"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowDragSelectActive"]++; }; 
	this["bRowDragSelectStart"] = false;
	this["bRowDragSelectActive"] = true;

	var aSelectedRows = this["getSelectedRows"]();
	this["mRowDragSelectExceptionMap"] = {};
	for (var i = 0; i <= aSelectedRows["length"] - 1; i++) {
		this["mRowDragSelectExceptionMap"][aSelectedRows[i]] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowDragSelectActive"] = 0; };

/**
 * Resets the bRowDragSelectActive flag
 * @private
 */
UCF_SapTable["prototype"]["resetRowDragSelectActive"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["resetRowDragSelectActive"]++; }; 
	this["bRowDragSelectActive"] = false;
	this["bRowDragSelectStart"] = false;
	this["mRowDragSelectExceptionMap"] = {};
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["resetRowDragSelectActive"] = 0; };

/**
 * Sets the RowRange Select range start
 *
 * @private
 */
UCF_SapTable["prototype"]["setRowDragSelectStart"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowDragSelectStart"]++; }; 
	this["bRowDragSelectStart"] = true;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowDragSelectStart"] = 0; };



/**
 * Handles the selection of multiple rows in an optimized way
 *
 * @param {number} iRangeStart The range start to select
 * @param {number} iRangeSize The range size
 * @param {boolean} bSet Is this a set or unset operation?
 * @param {UCF_SapTable_Modifiermask} mOperationMap The bit mask to set or unset
 * @param {Object} mExceptionList A map filled with row indices to be ignored while handling
 * @param {boolean} [bForceDirectUpdate] Prevents a delayed segmentation of the operation
 * @param {number} [iOriginalTimeRowSelection] A timestamp identifiing the selection process
 * @private
 */
UCF_SapTable["prototype"]["processRowSelectionMassUpdate"] = function(iRangeStart, iRangeSize, bSet, mOperationMap, mExceptionList, bForceDirectUpdate, iOriginalTimeRowSelection) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["processRowSelectionMassUpdate"]++; }; 
	/** @type {UCF_SapTable_CellInfo[]} */
	var aResultCellInfos = [];
	/** @type {UCF_SapTable_CellInfo} */
	var oRefCellInfo = null;
	/** @type {UCF_SapTable_SelectionLayer} */
	var eCurrRowSelectionState = this["SELECTION_LAYER"]["NONE"];
	/** @type {UCF_SapTable_DelayedUpdateInfo[]} */
	var aDelayedUpdate = [];
	/** @type {boolean} */
	var bStartedDelayedUpdate = false;
	/** @type {UCF_SapTable_DelayedUpdateInfo} */
	var oCurrentDelayedUpdateInfo = null;
	/** @type {UCF_SapTable_Modifiermask} */
	var mNormalizationMap = (this["SELECTION_LAYER"]["ROW"] | this["SELECTION_LAYER"]["ROW_PRIMARY"]);
	/** @type {UCF_SapTable_Modifiermask} */
	var mNormalizedOperationMap = mOperationMap & mNormalizationMap;
	/** @type {number} */
	var iContentRowOffset = this["iGetContentRowOffset"]();
	/** @type {number} */
	var iTimeRowSelection = iOriginalTimeRowSelection ? iOriginalTimeRowSelection : UCF_JsUtil["iGetTimeStamp"]();
	/** @type {number} */
	var iRowIndex;
	/** @type {number} */
	var i;
	/** @type {boolean} */
	var bRangeIncludesDisabledRow = false;

	for (iRowIndex = (this["bHasDomRow"](iRangeStart)) ? iRangeStart : this["iSearchAvailableDomRow"](iRangeStart); iRowIndex < iRangeStart + iRangeSize; iRowIndex = this["iSearchAvailableDomRow"](iRowIndex + 1)) {
		if (
			bForceDirectUpdate ||
			this["bIsVerticalScrolledIntoViewByIndex"](iRowIndex - iContentRowOffset)
		) {
			if (bStartedDelayedUpdate) {
				bStartedDelayedUpdate = false;
				oCurrentDelayedUpdateInfo["iNextRangeStart"] = iRowIndex;
				oCurrentDelayedUpdateInfo = null;
			}

			if (!(mExceptionList && mExceptionList[iRowIndex])) {
				eCurrRowSelectionState = this["eGetRowSelectionState"](iRowIndex);

				if (!(eCurrRowSelectionState & this["SELECTION_LAYER"]["ROW_DISABLED"]) && (
						(bSet && eCurrRowSelectionState !== mNormalizedOperationMap) ||
						(
							!bSet &&
							(~eCurrRowSelectionState & mNormalizationMap) !==
							mNormalizedOperationMap
						)
					)) {
					aResultCellInfos = this["aCollectCellsForRowSelection"](
						iRowIndex,
						aResultCellInfos,
						iTimeRowSelection
					);
					if (window["UCF_System"]["bIsAria"]) {
						oRefCellInfo = this["oGetCellInfo"](iRowIndex, 0);
						if (oRefCellInfo) {
							if (bSet) {
								oRefCellInfo["oDomRefRow"]["setAttribute"]('aria-selected', 'true');
							} else {
								oRefCellInfo["oDomRefRow"]["setAttribute"]('aria-selected', 'false');
							}
						}
					}
				}

				if (
					bSet &&
					(eCurrRowSelectionState & this["SELECTION_LAYER"]["ROW_DISABLED"])
				) {
					if (this["aCellInfoMatrix"] &&
							this["aCellInfoMatrix"][iRowIndex] &&
							this["aCellInfoMatrix"][iRowIndex][0] &&
							this["aCellInfoMatrix"][iRowIndex][0]["eCellType"] !==
							this["SUBCONTROL"]["HEADER_CELL"]) {
						bRangeIncludesDisabledRow = true;
					}
					this["updateSelectionInfo"](
						iRowIndex,
						1,
						false,
						[],
						(this["aCellInfoMatrix"] &&
							this["aCellInfoMatrix"][iRowIndex] &&
							this["aCellInfoMatrix"][iRowIndex][0] &&
							this["aCellInfoMatrix"][iRowIndex][0]["eCellType"] !==
							this["SUBCONTROL"]["HEADER_CELL"])
						? [iRowIndex]
						: []
					);
				}
			}
		} else if (!bStartedDelayedUpdate) {
			bStartedDelayedUpdate = true;
			oCurrentDelayedUpdateInfo = { "iRangeStart": iRowIndex };
			aDelayedUpdate[aDelayedUpdate["length"]] = oCurrentDelayedUpdateInfo;
		}
	}

	if (bStartedDelayedUpdate) {
		bStartedDelayedUpdate = false;
		oCurrentDelayedUpdateInfo["iNextRangeStart"] = iRowIndex;
		oCurrentDelayedUpdateInfo = null;
	}

	// The visible rows are applied directly
	if (aResultCellInfos["length"] > 0) {
		this["setCellSelectionStates"](aResultCellInfos, bSet, mOperationMap);
	}

	// Apply hidden rows delayed -> user interaction feedback performance
	for (i = 0; i < aDelayedUpdate["length"]; i++) {
		UCF_JsUtil["delayedCall"](
			100 * (i + 1), // eslint-disable-line no-magic-numbers
			this,
			'processRowSelectionMassUpdate',
			[
				aDelayedUpdate[i]["iRangeStart"],
				aDelayedUpdate[i]["iNextRangeStart"] - aDelayedUpdate[i]["iRangeStart"],
				bSet,
				mOperationMap,
				mExceptionList,
				true,
				iTimeRowSelection
			]
		);
	}
	// do not handle blockSelection at delayed rowSelection
	if (!bForceDirectUpdate && bSet) {
		if (this["bBlockSelectionActive"]()) {
			if (this["bRowDragSelectStart"] || this["bRowDragSelectActive"]) {
				this["applyRowBlockSelect"](iRangeStart, iRangeSize, bSet, this["sRowDragSelectAccess"]);
			}
			else {
				if (bRangeIncludesDisabledRow) {
					this["internalFireRowBlockSelect"](iRangeStart, 0, bSet, this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]);
				}
				else {
					this["internalFireRowBlockSelect"](iRangeStart, iRangeSize, bSet, this["sRowDragSelectAccess"] ? this["sRowDragSelectAccess"] : this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]);
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["processRowSelectionMassUpdate"] = 0; };

/**
 * This method is called by all processors which de/select rows on client side
 * and want to update the cell state and the UI. It collects all cells of a
 * given row and append it to a cell collector pool in the case that the
 * selection state is not up to date.
 *
 * Have a look in the "processRowSelectionMassUpdate" method. In this method
 * the selection state update is processed delayed to increase interaction
 * perfromance. Within such a delayed processing it could happen that a state
 * of row which is already up to date is invalidated by a old delayed process
 * task. Using this method a timestamp comparison resolves such a conflict.
 *
 * @private
 * @param {number} iRowIndex
 * @param {UCF_SapTable_CellInfo[]} [aCellCollector]
 * @param {number} [iTimeRowSelection]
 * @return {UCF_SapTable_CellInfo[]} An Array of the resulting cell infos
 */
UCF_SapTable["prototype"]["aCollectCellsForRowSelection"] = function(iRowIndex, aCellCollector, iTimeRowSelection) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aCollectCellsForRowSelection"]++; }; 
	/** @type {UCF_SapTable_CellInfo[]} */
	var aCellInfosOfRow;
	/** @type {UCF_SapTable_CellInfo} */
	var oRowReferenceCell;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iRowIndex === 'number', "typeof iRowIndex === 'number'", "SapTable.js(5340): aCollectCellsForRowSelection"); };

	aCellInfosOfRow = this["aGetCellInfosOfRow"](iRowIndex);

	if (aCellInfosOfRow && aCellInfosOfRow["length"] > 0) {
		oRowReferenceCell = aCellInfosOfRow[0];

		if (!iTimeRowSelection) {
			iTimeRowSelection = UCF_JsUtil["iGetTimeStamp"]();
		}

		// Timed management of mass update which comes delayed
		if (
			!oRowReferenceCell["iTimeRowSelection"] ||
			oRowReferenceCell["iTimeRowSelection"] <= iTimeRowSelection
		) {
			oRowReferenceCell["iTimeRowSelection"] = iTimeRowSelection;

			return aCellCollector
				? aCellCollector["concat"](aCellInfosOfRow)
				: aCellInfosOfRow;
		}
	}

	return aCellCollector ? aCellCollector : [];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aCollectCellsForRowSelection"] = 0; };

/**
 * Searches for the next row which has a DOM representation
 *
 * @private
 * @param {number} iStartSearchRowIndex Begin search from this MartixRowIndex
 * @param {boolean} bDescending optional Search in descending order
 * @return {number} the next available MatrixRowIndex
 */
UCF_SapTable["prototype"]["iSearchAvailableDomRow"] = function(iStartSearchRowIndex, bDescending) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iSearchAvailableDomRow"]++; }; 
	return iStartSearchRowIndex;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iSearchAvailableDomRow"] = 0; };

/**
 * Checks if the given row index has a DOM representation
 *
 * @private
 * @param {number} iRowIndex
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bHasDomRow"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasDomRow"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasDomRow"] = 0; };

/**
 * Checks if the given event handles a quick row select which should be
 * triggred by mousedown
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bIsQuickRowSelect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsQuickRowSelect"]++; }; 
	/** @type {UCF_SapTable_AccessInfo} */
	var oAccessInfo;
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {boolean} */
	var bContinueQuickSelect;
	/** @type {UCF_SapTable_CellType} */
	var eCellType;
	/** @type {UCF_Control} */
	var oSourceControl;
	/** @type {UCF_SapTable_SelectionLayer} */
	var eRowSelectionState;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(5412): bIsQuickRowSelect"); };

	if (this["bBlockSelectionActive"]()) {
		// change to correct behaviour with activated blockSelection
		// (select via mouse has to be cancelable before releasing the mouse button)
		// -> trigger at mouseup instead of mousedown
		return false;
	}

	oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);

	if (
		this["bCapturedEventProcessing"] ||
		!oAccessInfo ||
		oAccessInfo["eAction"] !== this["ACTION"]["CELL_SELECT"] ||
		!oAccessInfo["oCellInfo"]
	) {
		return false;
	}

	oCellInfo = oAccessInfo["oCellInfo"];
	bContinueQuickSelect = false;
	eCellType = this["eGetCellType"](oCellInfo);

	// Reduce to valid cells
	if (this["bIsDataTableCell"](eCellType)) {
		bContinueQuickSelect = true;
	} else if (eCellType === this["SUBCONTROL"]["SELECTION_CELL"]) {
		bContinueQuickSelect = true;
	}

	//Check Drag&Drop
	if (bContinueQuickSelect) {
		oSourceControl = oBrowserEvent["oGetSourceControl"]();

		if (
			UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_Caption') &&
			oSourceControl["sDragSourceInfo"]
		) {
			bContinueQuickSelect = false;
		}
	}

	if (bContinueQuickSelect) {
		if (this["bCheckModifierMask"](
				UCF_JsUtil["MODIFIER"]["NONE"],
				oBrowserEvent["bShift"](),
				oBrowserEvent["bCtrl"](),
				oBrowserEvent["bAlt"]()
			)) {
			eRowSelectionState = this["eGetRowSelectionState"](oCellInfo["iRowIndex"]);

			if (
				!(eRowSelectionState & this["SELECTION_LAYER"]["ROW"]) &&
				!(eRowSelectionState & this["SELECTION_LAYER"]["ROW_PRIMARY"])
			) {
				return true;
			}
		} else if (this["bCheckModifierMask"](
				UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT"],
				oBrowserEvent["bShift"](),
				oBrowserEvent["bCtrl"](),
				oBrowserEvent["bAlt"]()
			)) {
			return true;
		}
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsQuickRowSelect"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @param {UCF_JsUtil_Modifier} iModifierMask
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bIsSelectAccess"] = function(oAccessInfo, iModifierMask) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsSelectAccess"]++; }; 
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(5493): bIsSelectAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(5494): bIsSelectAccess"); };

	oControl = this["oLS"]["oControlFactory"]["oGetEnclosingControlByDomRef"](
		UCF_DomUtil["oGetActiveElement"](),
		true
	);

	if (
		(!this["bRowSelectionFollowFocusKeyboard"] &&
		!this["bRowSelectionFollowFocusMouse"]) ||
		// check of userTextSelection for character based textSelection in cellEditor in any case
		(oAccessInfo["oBrowserEvent"] && this["bPermitTextSelection"](oAccessInfo["oBrowserEvent"]))
	) {
		if (
			oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["MOUSE"] &&
			!oAccessInfo["oBrowserEvent"]["bShift"]() &&
			!oAccessInfo["oBrowserEvent"]["bCtrl"]() &&
			!oAccessInfo["oBrowserEvent"]["bAlt"]() &&
			oControl &&
			oControl["bIsUserTextSelection"]() &&
			// do not skip for a dblclick
			oAccessInfo["oBrowserEvent"]["sGetName"]() !== 'dblclick' &&
			// do not skip for right mouse click
			oAccessInfo["oBrowserEvent"]["sGetName"]() !== 'contextmenu'
		) {
			// It is no select when a cell was touched by text selection

			return false;
		}
	}

	return this["bCheckModifierMask"](
		iModifierMask,
		oAccessInfo["oBrowserEvent"]["bShift"](),
		oAccessInfo["oBrowserEvent"]["bCtrl"](),
		oAccessInfo["oBrowserEvent"]["bAlt"]()
	) && (
		oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["MOUSE"] ||
		oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_SELECT"]
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsSelectAccess"] = 0; };

/**
 * Tries to check if the there is selected text within the table
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bHasValidTextSelection"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasValidTextSelection"]++; }; 
	/** @type {string} */
	var sSelectedText;
	/** @type {HTMLElement} */
	var oActiveElement;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(5549): bHasValidTextSelection"); };

	sSelectedText = UCF_DomUtil["sGetSelectionText"](document["body"]);

	if (sSelectedText) {
		oActiveElement = UCF_DomUtil["oGetActiveElement"]();

		return oActiveElement &&
			UCF_DomUtil["bContains"](this["oDomRef"], oActiveElement);
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasValidTextSelection"] = 0; };

/**
 * @private
 * @param {UCF_JsUtil_Modifier} iModifierMask
 * @param {boolean} bShift
 * @param {boolean} bCtrl
 * @param {boolean} bAlt
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bCheckModifierMask"] = function(iModifierMask, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCheckModifierMask"]++; }; 
	/** @type {UCF_JsUtil_Modifier} */
	var iModifierMaskToCheck = UCF_JsUtil["MODIFIER"]["NONE"];

	if (iModifierMask >= UCF_JsUtil["MODIFIER"]["ALL"]) {
		// mask OR operation
		return (iModifierMask === UCF_JsUtil["MODIFIER"]["ALL"]) ||
			// NONE is allowed for every mask
			(!bShift && !bCtrl && !bAlt) || (
				iModifierMask === UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT"] &&
				bShift &&
				!bCtrl &&
				!bAlt
			) || (
				iModifierMask === UCF_JsUtil["MODIFIER"]["NONE_OR_CTRL"] &&
				!bShift &&
				bCtrl &&
				!bAlt
			) || (
				iModifierMask === UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT_XOR_CTRL"] &&
				!bShift &&
				!bAlt
			) || (
				iModifierMask === UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT_XOR_CTRL"] &&
				!bCtrl &&
				!bAlt
			);
	} else {
		// mask AND operation
		if (bShift) {
			iModifierMaskToCheck |= 1;
		}
		if (bCtrl) {
			// eslint-disable-next-line no-magic-numbers
			iModifierMaskToCheck |= 2;
		}
		if (bAlt) {
			// eslint-disable-next-line no-magic-numbers
			iModifierMaskToCheck |= 4;
		}

		return iModifierMask === iModifierMaskToCheck;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCheckModifierMask"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetEventCellType"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetEventCellType"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(5622): sGetEventCellType"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(5623): sGetEventCellType"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo["oCellInfo"] != null, "oAccessInfo.oCellInfo != null", "SapTable.js(5624): sGetEventCellType"); };

	return this["EVENT_PARAM_MAP_CELL_TYPE"][oAccessInfo["eSubControlType"]];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetEventCellType"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetEventSelectAccessType"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetEventSelectAccessType"]++; }; 
	/** @type {boolean} */
	var bShift;
	/** @type {boolean} */
	var bCtrl;
	/** @type {boolean} */
	var bAlt;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(5642): sGetEventSelectAccessType"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(5643): sGetEventSelectAccessType"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo["oCellInfo"] != null, "oAccessInfo.oCellInfo != null", "SapTable.js(5644): sGetEventSelectAccessType"); };

	bShift = oAccessInfo["oBrowserEvent"]["bShift"]();
	bCtrl = oAccessInfo["oBrowserEvent"]["bCtrl"]();
	bAlt = oAccessInfo["oBrowserEvent"]["bAlt"]();

	return this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["NONE"], bShift, bCtrl, bAlt)
		? this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]
		: this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["SHIFT"], bShift, bCtrl, bAlt)
		? this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"]
		: this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["CTRL"], bShift, bCtrl, bAlt)
		? this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]
		: this["EVENT_PARAM_MAP_ACCESS_TYPE"]["INVALID"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetEventSelectAccessType"] = 0; };

/******************************************************
 ** HANDLING OF SPECIFIC CELLTYPES
 *******************************************************/

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 */
UCF_SapTable["prototype"]["handleSelectionCellEvent"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleSelectionCellEvent"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(5668): handleSelectionCellEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(5669): handleSelectionCellEvent"); };

	if (this["bIsCellSelect"](
			oAccessInfo,
			UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT_XOR_CTRL"]
		)) {
		this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
		if (this["bIsRowCreatorCell"](oAccessInfo["oCellInfo"])) {
			this["fireRowCreate"](this["sId"], -1, this["iGetRowCount"]());
			oAccessInfo["bHandled"] = true;
		} else {
			this["internalFireSelectionCellSelect"](oAccessInfo);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleSelectionCellEvent"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 */
UCF_SapTable["prototype"]["handleHeaderCellEvent"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleHeaderCellEvent"]++; }; 
	/** @type {string} */
	var sPopupMenuId;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(5693): handleHeaderCellEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(5694): handleHeaderCellEvent"); };

	if (oAccessInfo["oBrowserEvent"]["bIsTouchInteraction"]() && 	oAccessInfo["oCellInfo"]["oDomRefCell"]["getAttribute"]('touchResize')) {

		sPopupMenuId = oAccessInfo["oCellInfo"]["oDomRefCell"]["getAttribute"]('actMenuId');
		if (!this["oHeaderActionMenu"]) {
			this["oHeaderActionMenu"] = sPopupMenuId
				? this["oGetControlById"](sPopupMenuId, true)
				: null;
		}

		if (this["oHeaderActionMenu"]) {
			this["oHeaderActionMenu"]["close"]();
			this["sLastHeaderActionMenu"] = null;
		}

		if (oAccessInfo["eAction"] !== 'HCSORT' && oAccessInfo["eAction"] !== 'HCICO') {
			// direct action SORT and ICO -> do not render touch layer
			if (!this["bHCTouchLayer"]) {
				this["createHCTouchLayer"](oAccessInfo);

				// do not perform any other actions in parallel
				return;
			}
		}
	}

	if (this["bIsCellSelect"](
			oAccessInfo,
			UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT_XOR_CTRL"]
		)) {
		this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
		this["internalFireHeaderCellSelect"](oAccessInfo);
	}

	if (this["bIsSelectAccess"](oAccessInfo, UCF_JsUtil["MODIFIER"]["NONE_OR_CTRL"])) {
		if (oAccessInfo["eAction"] === this["ACTION"]["HEADER_SORT"]) {
			this["eFocusBehavior"] = this["bIdContains"](
					oAccessInfo["oAccessFragmentDomRef"],
					this["ACTION"]["HEADER_SORT"]
				)
				? this["FOCUS_BEHAVIOR"]["HEADER_SORT"]
				: this["FOCUS_BEHAVIOR"]["CELL"];
			this["fireColSort"](
				oAccessInfo["oTable"]["sId"],
				oAccessInfo["sSubControlId"],
				this["sGetEventSelectAccessType"](oAccessInfo)
			);
			oAccessInfo["bHandled"] = true;
		} else if (oAccessInfo["eAction"] === this["ACTION"]["SELECTION_MENU_OPEN"]) {
			this["openSelectionMenu"](
				oAccessInfo["oAccessFragmentDomRef"]["getAttribute"]('selMenuId'),
				oAccessInfo["oAccessFragmentDomRef"],
				oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_SELECT"]
			);
			oAccessInfo["bHandled"] = true;
		} else if (oAccessInfo["eAction"] === this["ACTION"]["HEADER_ACTION_MENU_OPEN"]) {
			this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
			if (!this["bOpenHeaderActionMenuInternal"](
					oAccessInfo["oCellInfo"],
					true,
					oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_SELECT"]
				)) {
				this["fireHeaderActionMenuAccess"](
					oAccessInfo["oTable"]["sId"],
					this["sGetCellId"](oAccessInfo["oCellInfo"]),
					oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_SELECT"],
					this["sGetCellUserData"](oAccessInfo["oCellInfo"])
				);
			}
			oAccessInfo["bHandled"] = true;
		} else if (oAccessInfo["eAction"] === this["ACTION"]["COL_RESIZE"]) {
			if (oAccessInfo["oBrowserEvent"]["sGetName"]() === 'dblclick') {
				this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
				this["optimizeColumnWidth"](oAccessInfo);
				oAccessInfo["bHandled"] = true;
			}
		} else if (oAccessInfo["eAction"] === this["ACTION"]["HEADER_ICON"]) {
			this["eFocusBehavior"] = this["bIdContains"](
					oAccessInfo["oAccessFragmentDomRef"],
					this["ACTION"]["HEADER_SORT"]
				)
				? this["FOCUS_BEHAVIOR"]["HEADER_ICON"]
				: this["FOCUS_BEHAVIOR"]["CELL"];

			this["fireCellIconSelect"](
				oAccessInfo["oTable"]["sId"],
				this["iGetApiRowIndex"](oAccessInfo["oCellInfo"]),
				this["sGetRowUserData"](oAccessInfo["oCellInfo"]),
				this["sGetCellUserData"](oAccessInfo["oCellInfo"]),
				oAccessInfo["sSubControlId"]
			);

			oAccessInfo["bHandled"] = true;
		} else if (oAccessInfo["eAction"] === this["ACTION"]["SELECTION_COLUMN_TOGGLE"]) {
			// column selection so far only available in sapTableCS and columnSelectionClientBehaviour SMART
			this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
			if ((this["sSelectionMassAction"] === 'BOTH' || this["sSelectionMassAction"] === 'COLUMN') && UCF_JsUtil["bInstanceOf"](this, 'UCF_SapTableCS') &&
				this["sColumnSelectionMode"] === 'MULTI' && this["sColumnSelectionClientBehaviour"] === 'SMART') {
				if (this["sSelectionMassAction"] === 'BOTH') {
					oAccessInfo["eAccessType"] = (this["oSelectionInfo"]["bSelectAll"] && this["oSelectionInfo"]["bColumnSelectAll"])
						? this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]
						: this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"];
					this["internalFireRowSelect"](oAccessInfo);
					this["internalFireColumnSelect"](oAccessInfo);
				}
				if (this["sSelectionMassAction"] === 'COLUMN') {
					oAccessInfo["eAccessType"] = this["oSelectionInfo"]["bColumnSelectAll"]
						? this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]
						: this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"];
					this["internalFireColumnSelect"](oAccessInfo);
				}
			}
			else {
				oAccessInfo["eAccessType"] = this["oSelectionInfo"]["bSelectAll"]
					? this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]
					: this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"];
				this["internalFireRowSelect"](oAccessInfo);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleHeaderCellEvent"] = 0; };

/**
 * Analyzes the optimal column with an resizes the column to that
 *
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 */
UCF_SapTable["prototype"]["optimizeColumnWidth"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["optimizeColumnWidth"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(5824): optimizeColumnWidth"); };
	// !!!! This method is overwritten by SapTableCS
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["optimizeColumnWidth"] = 0; };

/**
 * Decreases the column width step by step
 *
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @private
 */
UCF_SapTable["prototype"]["decreaseColumnWidth"] = function(oCellInfo, oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["decreaseColumnWidth"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(5835): decreaseColumnWidth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(5836): decreaseColumnWidth"); };

	var iEm = 16;
	var iResultWidth = Math["max"](this["MIN_COL_WIDTH"], (oCellInfo["oDomRefCell"]["offsetWidth"] - iEm));

	this["createDragDropDelegate"]();

	this["oDragDropDelegate"]["simulateDragDropColumnResize"](oAccessInfo, iResultWidth, false);

	if (this["bColumnTitleAdoption"]) {
		this["adjustHeaderCellCaptions"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["decreaseColumnWidth"] = 0; };

/**
 * Increases the column width step by step
 *
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @private
 */
UCF_SapTable["prototype"]["increaseColumnWidth"] = function(oCellInfo, oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["increaseColumnWidth"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(5857): increaseColumnWidth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(5858): increaseColumnWidth"); };

	var iEm = 16;
	var iResultWidth = Math["max"](this["MIN_COL_WIDTH"], (oCellInfo["oDomRefCell"]["offsetWidth"] + iEm));

	this["createDragDropDelegate"]();

	this["oDragDropDelegate"]["simulateDragDropColumnResize"](oAccessInfo, iResultWidth, false);

	if (this["bColumnTitleAdoption"]) {
		this["adjustHeaderCellCaptions"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["increaseColumnWidth"] = 0; };

/**
 * Moves the column one position left
 *
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @private
 */
UCF_SapTable["prototype"]["moveColumnLeft"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["moveColumnLeft"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(5880): moveColumnLeft"); };

	var oTargetCellInfo = null;

	if (oCellInfo["iColIndex"] > 0) oTargetCellInfo = this["oGetCellInfo"](oCellInfo["iRowIndex"], oCellInfo["iColIndex"] - 1);
	if (!oTargetCellInfo) return false;

	this["createDragDropDelegate"]();
	return this["oDragDropDelegate"]["simulateDragDropColumnReorder"](oCellInfo, oTargetCellInfo, -1);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["moveColumnLeft"] = 0; };

/**
 * Moves the column one position right
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @private
 */
UCF_SapTable["prototype"]["moveColumnRight"] = function(oCellInfo, oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["moveColumnRight"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(5898): moveColumnRight"); };

	var oTargetCellInfo = null;

	if (oCellInfo["iColIndex"] < this["iGetCellInfoMatrixLastColIndex"]()) oTargetCellInfo = this["oGetCellInfo"](oCellInfo["iRowIndex"], oCellInfo["iColIndex"] + 1);
	if (!oTargetCellInfo) return false;

	this["createDragDropDelegate"]();
	return this["oDragDropDelegate"]["simulateDragDropColumnReorder"](oCellInfo, oTargetCellInfo, 1);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["moveColumnRight"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 */
UCF_SapTable["prototype"]["handleStandardCellEvent"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleStandardCellEvent"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(5914): handleStandardCellEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(5915): handleStandardCellEvent"); };

	if (this["bIsCellSelect"](
			oAccessInfo,
			UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT_XOR_CTRL"]
		)) {
		this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];

		if (this["bIsRowCreatorCell"](oAccessInfo["oCellInfo"])) {
			this["fireRowCreate"](
				this["sId"],
				this["iGetApiColIndex"](oAccessInfo["oCellInfo"]),
				this["iGetRowCount"]()
			);
			oAccessInfo["bHandled"] = true;
		} else {
			this["internalFireCellSelect"](oAccessInfo);
		}
	} else if ((
			oAccessInfo["eAction"] === this["ACTION"]["FILTER"] &&
			this["bIsSelectAccess"](oAccessInfo, UCF_JsUtil["MODIFIER"]["NONE"])
		) || (
			oAccessInfo["eAction"] === this["ACTION"]["FILTER_ENTER"] &&
			oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_ENTER"]
		)) {
		this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["FILTER"];
		this["fireFilter"](oAccessInfo["oTable"]["sId"], oAccessInfo["sSubControlId"]);
		oAccessInfo["bHandled"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleStandardCellEvent"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 */
UCF_SapTable["prototype"]["handleHierarchyCellEvent"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleHierarchyCellEvent"]++; }; 
	/** @type {UCF_SapTable_Action} */
	var eAction;
	/** @type {UCF_SapTable_Action} */
	var sAltAction;
	/** @type {boolean} */
	var bValidOperation;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(5958): handleHierarchyCellEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(5959): handleHierarchyCellEvent"); };

	if (this["bIsCellSelect"](
			oAccessInfo,
			UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT_XOR_CTRL"]
		)) {
		this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
		this["internalFireCellSelect"](oAccessInfo);
	} else {
		eAction = this["ACTION"]["NONE"];

		if (this["bIsSelectAccess"](oAccessInfo, UCF_JsUtil["MODIFIER"]["NONE"])) {
			eAction = oAccessInfo["eAction"];
		}

		if (
			oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_COLLAPSE"] ||
			oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_EXPAND"] ||
			oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_SELECT"]
		) {
			// Keyboard handling of Collapse, Expand on any modifier
			sAltAction = this["sGetAlternativeAction"](oAccessInfo);
			bValidOperation = (
				oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_EXPAND"] &&
				sAltAction === this["ACTION"]["HIERARCHY_EXPAND"]
			) || (
				oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_COLLAPSE"] &&
				sAltAction === this["ACTION"]["HIERARCHY_COLLAPSE"]
			) || (
				oAccessInfo["eAccessType"] === this["ACCESS_TYPE"]["KEYBOARD_SELECT"] &&
				sAltAction === this["ACTION"]["HIERARCHY_ALTERNATIVE"]
			);

			if (bValidOperation && sAltAction) {
				eAction = sAltAction;
			}
		}

		if (eAction === this["ACTION"]["HIERARCHY_ALTERNATIVE"]) {
			this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
			this["fireCellIconSelect"](oAccessInfo["oTable"]["sId"],
				this["iGetApiRowIndex"](oAccessInfo["oCellInfo"]),
				this["sGetRowUserData"](oAccessInfo["oCellInfo"]),
				this["sGetCellUserData"](oAccessInfo["oCellInfo"]),
				oAccessInfo["sSubControlId"]
			);
			oAccessInfo["bHandled"] = true;
		} else if (eAction === this["ACTION"]["HIERARCHY_EXPAND"]) {
			this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
			this["fireCellExpand"](
				oAccessInfo["oTable"]["sId"],
				this["iGetApiRowIndex"](oAccessInfo["oCellInfo"]),
				this["sGetRowUserData"](oAccessInfo["oCellInfo"]),
				this["sGetCellUserData"](oAccessInfo["oCellInfo"]),
				oAccessInfo["sSubControlId"]
			);
			oAccessInfo["bHandled"] = true;
		} else if (eAction === this["ACTION"]["HIERARCHY_COLLAPSE"]) {
			this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
			this["fireCellCollapse"](oAccessInfo["oTable"]["sId"],
				this["iGetApiRowIndex"](oAccessInfo["oCellInfo"]),
				this["sGetRowUserData"](oAccessInfo["oCellInfo"]),
				this["sGetCellUserData"](oAccessInfo["oCellInfo"]),
				oAccessInfo["sSubControlId"]
			);
			oAccessInfo["bHandled"] = true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleHierarchyCellEvent"] = 0; };

/**
 * Handle events which are directly processed by the table and by it's cells
 *
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 */
UCF_SapTable["prototype"]["handleTableEvent"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleTableEvent"]++; }; 
	// !!!! This method is overwritten by SapTableCS

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(6038): handleTableEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(6039): handleTableEvent"); };
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleTableEvent"] = 0; };

/**
 * Sets all necessary attributes to set thew correct event return state
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {boolean} bHandled
 * @param {boolean} bForceCancelEvent
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bSetEventReturnState"] = function(oBrowserEvent, bHandled, bForceCancelEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSetEventReturnState"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(6052): bSetEventReturnState"); };

	if (bHandled) {
		// Mark keyboardevent taint to cancel all following keyboard events in the
		// table. see also "bCancelHandlerProcessing"
		if (oBrowserEvent["bIsKeyboardTriggered"]()) {
			oBrowserEvent["oDomEvent"]["bSapTableKeyHandled"] = true;
		}

		if (
			oBrowserEvent["iKeyCode"]() !== 0 &&
			oBrowserEvent["iKeyCode"]() !== UCF_KeyCodes["SPACE"]
		) {
			this["cancelEventInternal"](oBrowserEvent);
		}
		this["cancelBubbleEventInternal"](oBrowserEvent);
		oBrowserEvent["bHandled"] = true;
	}

	if (bForceCancelEvent) {
		oBrowserEvent["cancel"]();
	}

	return oBrowserEvent["oDomEvent"]["returnValue"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSetEventReturnState"] = 0; };

/**
 * Cancels the passed browser event for bubbling. The method checks for capture
 * mode and handles the cancelation only for non captured events.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SapTable["prototype"]["cancelBubbleEventInternal"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cancelBubbleEventInternal"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(6086): cancelBubbleEventInternal"); };

	if (this["bCapturedEventProcessing"]) {
		oBrowserEvent["oGetData"]()["bProcessedBySapTableCancelBubbleEvent"] = true;
	} else {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cancelBubbleEventInternal"] = 0; };

/**
 * Cancels the passed browser event. The method checks for capture mode and
 * handles the cancelation only for non captured events.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SapTable["prototype"]["cancelEventInternal"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cancelEventInternal"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(6103): cancelEventInternal"); };

	if (this["bCapturedEventProcessing"]) {
		oBrowserEvent["oGetData"]()["bProcessedBySapTableCancelEvent"] = true;
	} else {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cancelEventInternal"] = 0; };

/**
 * Blocks the browser event for further processing
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SapTable["prototype"]["blockEventInternal"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["blockEventInternal"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(6119): blockEventInternal"); };

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["bHandled"] = true;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["blockEventInternal"] = 0; };

/******************************************************
 ** TAB ACTION
 *******************************************************/

/* eslint-disable complexity */
/**
 * This method handles the whole tab processing. It searches for the current
 * focus, searches for the next focusable element and focuses it. It prepares
 * the scrollstate according to the element to focus.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {boolean} bForward Forwartd or backward tabbing?
 * @return {boolean} `false` when event has been canceled
 */
UCF_SapTable["prototype"]["bProcessTabHandling"] = function(oBrowserEvent, bForward) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bProcessTabHandling"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oTabActionCellInfoFrom;
	/** @type {UCF_SapTable_CellInfo} */
	var oTabActionCellInfoTo;
	/** @type {UCF_SapTable_CellInfo} */
	var oTabActionCellInfoLast;
	/** @type {UCF_SapTable_CellInfo} */
	var oNextTabableCellInfo;
	/** @type {HTMLElement} */
	var oResultDomRef;
	/** @type {HTMLElement} */
	var oSNextSiblingDomRef;
	/** @type {HTMLElement} */
	var oPreviousSiblingDomRef;
	/** @type {HTMLElement} */
	var oSNextTabableDomRef;
	/** @type {boolean} */
	var bResult;
	/** @type {boolean} */
	var bChangeRowByTab;
	/** @type {HTMLElement} */
	var oSource;
	/** @type {number} */
	var iRowIndex;
	/** @type {number} */
	var iColIndex;
	/** @type {number} */
	var iLastRowIndex;
	/** @type {number} */
	var iLastColIndex;
	/** @type {number} */
	var iDifference;
	/** @type {boolean} */
	var bInherit;
	/** @type {boolean} */
	var bLastRowAction;
	/** @type {UCF_Control} */
	var oControl;
	/** @type {UCF_SapTable_CellType} */
	var eCellType;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(6183): bProcessTabHandling"); };

	if (this["bScrollingByKeyboardLocked"]) {
		this["blockEventInternal"](oBrowserEvent);

		return false;
	}

	this["bKeyboardHandlingInProcess"] = true;

	oTabActionCellInfoFrom = this["oGetCellInfoByBrowserEvent"](oBrowserEvent);
	oTabActionCellInfoTo = null;
	oTabActionCellInfoLast = null;
	oResultDomRef = null;
	oSNextSiblingDomRef = null;
	oSNextTabableDomRef = null;
	oPreviousSiblingDomRef = null;
	bResult = true;
	bChangeRowByTab = false;
	oSource = oBrowserEvent["oGetSource"]();

	// When current focus position found in cell matrix search for next cell to
	// focus
	if (oTabActionCellInfoFrom) {
		iRowIndex = oTabActionCellInfoFrom["iRowIndex"];
		iColIndex = oTabActionCellInfoFrom["iColIndex"];
		iLastRowIndex = this["iGetCellInfoMatrixLastRowIndex"]();
		iLastColIndex = this["iGetCellInfoMatrixLastColIndex"]();
		oTabActionCellInfoTo = oTabActionCellInfoFrom;
		eCellType = this["eGetCellType"](oTabActionCellInfoFrom);

		if ((
				bForward &&
				UCF_DomUtil["oGetLastFocusableDomRef"](
					oTabActionCellInfoFrom["oDomRefCell"]
				) === oSource) || (
				!bForward &&
				(UCF_DomUtil["oGetFirstFocusableDomRef"](
					oTabActionCellInfoFrom["oDomRefCell"]
				) === oSource || (window["UCF_System"]["bIsAria"] && eCellType === this["SUBCONTROL"]["HIERARCHY_CELL"]))	//ARIA - hierarchical cell -> dispatch to content
			)) {
			while (oResultDomRef == null || !UCF_DomUtil["bIsVisible"](
					oResultDomRef,
					true,
					oTabActionCellInfoTo["oDomRefCell"]
				)) {
				iColIndex = bForward ? iColIndex + 1 : iColIndex - 1;

				if (bForward) {
					if (iColIndex > iLastColIndex) {
						iColIndex = 0;
						bChangeRowByTab = true;
						iRowIndex++;

						if (iRowIndex > iLastRowIndex) {
							oTabActionCellInfoLast = oTabActionCellInfoTo;
							oTabActionCellInfoTo = null;
							break;
						}
					}
				} else if (iColIndex < 0) {
					iColIndex = iLastColIndex;
					bChangeRowByTab = true;
					iRowIndex--;
					if (iRowIndex < 0) {
						oTabActionCellInfoTo = null;
						break;
					}
				}

				oTabActionCellInfoTo = this["oGetCellInfo"](iRowIndex, iColIndex);

				// When coordinates are not the cell origin (rowspan or colspan) ignore
				// the cell to avoid tab cycle
				if (
					oTabActionCellInfoTo["iRowIndex"] !== iRowIndex ||
					oTabActionCellInfoTo["iColIndex"] !== iColIndex
				) {
					continue;
				}

				if (this["bIsValidCellInfo"](oTabActionCellInfoTo)) {
					oResultDomRef = bForward
						? UCF_DomUtil["oGetFirstFocusableDomRef"](
							oTabActionCellInfoTo["oDomRefCell"],
							true
						)
						: UCF_DomUtil["oGetLastFocusableDomRef"](
							oTabActionCellInfoTo["oDomRefCell"],
							true
						);
				} else {
					oResultDomRef = null;
					break;
				}
			}

			// Get target cell by DOM reference
			if (oResultDomRef) {
				oTabActionCellInfoTo = this["oGetCellInfoByDomRef"](oResultDomRef);
				bResult = false;
			}
		}
	}

	// Hook to redirect target?
	oTabActionCellInfoTo = this["oRedirectProcessTabHandling"](
		oBrowserEvent,
		bForward,
		oTabActionCellInfoFrom,
		oTabActionCellInfoTo
	);

	if (oTabActionCellInfoTo) {
		// Scroll to result cell?
		if (!this["bIsVerticalScrolledIntoView"](oTabActionCellInfoTo)) {
			// Only content cells could not be scolled into view! So
			// oTabActionCellInfoTo must be a content cell

			if (this["oScrollV"]) { // Has vertical scrollbar?
				if (this["bIsContentRowIndex"](oTabActionCellInfoFrom["iRowIndex"])) {
					// When tabbed from content to content
					iDifference = oTabActionCellInfoTo["iRowIndex"] -
						oTabActionCellInfoFrom["iRowIndex"];

					if (Math["abs"](iDifference) === 1) {
						// When next row has to be scrolled inot view use the specific
						// scrollbar API for that
						if (bForward) {
							this["oScrollV"]["scrollToNext"](UCF_JsUtil["MODIFIER"]["NONE"]);
						} else {
							this["oScrollV"]["scrollToPrevious"](UCF_JsUtil["MODIFIER"]["NONE"]);
						}
					} else {
						this["oScrollV"]["scrollToPosition"](
							this["oScrollV"]["iGetFirstVisibleItem"]() + iDifference,
							UCF_JsUtil["MODIFIER"]["NONE"]
						);
					}
				} else if (bForward) {
					// When tabbing from outside the content into the content
					this["oScrollV"]["scrollToBegin"](UCF_JsUtil["MODIFIER"]["NONE"]);
				} else {
					this["oScrollV"]["scrollToEnd"](UCF_JsUtil["MODIFIER"]["NONE"]);
				}
			}
		}

		if (!this["bIsHorizontalScrolledIntoView"](oTabActionCellInfoTo)) {
			this["scrollHorizontalIntoView"](oTabActionCellInfoTo);
		}

		// Load Data?
		if (
			this["bCanDataRequest"]() &&
			!this["bIsValidCellInfo"](oTabActionCellInfoTo)
		) {
			// Cell is not yet loaded
			this["setCellMatrixFocusHeadData"](
				oTabActionCellInfoTo["iRowIndex"],
				oTabActionCellInfoTo["iColIndex"]
			);
			this["bCheckDataRequest"](true);
			bResult = false;
		}
	} else {
		if (oTabActionCellInfoLast && oTabActionCellInfoLast["oDomRefCell"] && oTabActionCellInfoFrom && oTabActionCellInfoFrom["oDomRefCell"]) {
			//get next/previous tabbable element
			oSNextSiblingDomRef = UCF_DomUtil["oGetNextSibling"](oTabActionCellInfoFrom["oDomRefCell"], true);
			if (oSNextSiblingDomRef) {
				oSNextTabableDomRef = UCF_DomUtil["oGetTabbableElementForward"](oSNextSiblingDomRef, true);
				if (oSNextTabableDomRef) {
					oNextTabableCellInfo = this["oGetCellInfoByDomRef"](oSNextTabableDomRef);
					if (oNextTabableCellInfo && oNextTabableCellInfo["iRowIndex"] < oTabActionCellInfoFrom["iRowIndex"]) {
						oSNextSiblingDomRef = UCF_DomUtil["oGetNextSibling"](oTabActionCellInfoLast["oDomRefCell"], true);
						if (oSNextSiblingDomRef) {
							oResultDomRef = UCF_DomUtil["oGetTabbableElementForward"](oSNextSiblingDomRef, true);
							bResult = false;
						}
						else {
							//No Focusing, no event aborting
							oResultDomRef = null;
							bResult = true;
						}
					}
					else {
						//No Focusing, no event aborting
						oResultDomRef = null;
						bResult = true;
					}
				}
				else {
					//No Focusing, no event aborting
					oResultDomRef = null;
					bResult = true;
				}
			}
			else {
				//No Focusing, no event aborting
				oResultDomRef = null;
				bResult = true;
			}
		}
		else if (window["UCF_System"]["bIsAria"] && !bForward && oTabActionCellInfoFrom && oTabActionCellInfoFrom["oDomRefCell"] && this["eGetCellType"](oTabActionCellInfoFrom) === this["SUBCONTROL"]["HIERARCHY_CELL"]) {
			//get previous tabbable element in order to jump over hierarchical cell state icon -> see dispatch to content
			oPreviousSiblingDomRef = UCF_DomUtil["oGetPreviousSibling"](oTabActionCellInfoFrom["oDomRefCell"], true);
			if (oPreviousSiblingDomRef) {
				oResultDomRef = UCF_DomUtil["oGetTabbableElementBackward"](oPreviousSiblingDomRef, true);
			}
			else {
				//No Focusing, no event aborting
				oResultDomRef = null;
				bResult = true;
			}
		}
		else {
			//No Focusing, no event aborting
			oResultDomRef = null;
			bResult = true;
		}
	}

	if (oTabActionCellInfoFrom) {
		// Follow Focus?
		if (
			oTabActionCellInfoTo &&
			this["bRowSelectionFollowFocusKeyboard"] &&
			oTabActionCellInfoTo["iRowIndex"] !== oTabActionCellInfoFrom["iRowIndex"]
		) {
			this["notifyCellDataUpdate"]();
			this["internalFireRowSelectDirect"](
				oTabActionCellInfoTo,
				this["ACCESS_TYPE"]["KEYBOARD_TAB"],
				this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"],
				this
			);
		}

		// RowCreate ?
		if (bChangeRowByTab && !window["UCF_System"]["bIs508"] && bForward) {
			bInherit = (
				oTabActionCellInfoTo &&
				this["bIsRowCreatorCell"](oTabActionCellInfoTo) &&
				oTabActionCellInfoTo["iRowIndex"] - oTabActionCellInfoFrom["iRowIndex"] === 1
			);
			bLastRowAction = (
				this["sRowCreationTrigger"] === 'LAST_ROW_ACTION' &&
				this["iGetContentRowIndex"](oTabActionCellInfoFrom) ===
				this["iGetRowCount"]() - 1
			);

			if (bInherit || bLastRowAction) {
				oResultDomRef = null;
				oTabActionCellInfoTo = null;
				this["notifyCellDataUpdate"]();
				this["fireRowCreate"](this["sId"], -1, this["iGetRowCount"]());
			}
		}
	}

	if (oResultDomRef) {
		this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];
		oControl = this["oLS"]["oGetControlByDomRef"](oResultDomRef);

		// No control found in cell
		if (oControl === this) {
			oControl = null;
		}

		if (
			oControl &&
			oResultDomRef === oControl["oFocusDomRef"] &&
			oControl["bIsFocusable"]()
		) {
			oControl["focus"]();
		} else {
			UCF_DomUtil["focusDomElement"](oResultDomRef);
		}
	}

	if (oTabActionCellInfoTo) {
		this["setCellMatrixFocusHeadData"](
			oTabActionCellInfoTo["iRowIndex"],
			oTabActionCellInfoTo["iColIndex"]
		);
		if (this["bBlockSelectionActive"]()) {
			this["handleKeyboardNavigationBS"](true);
		}
	}

	if (!bResult) {
		this["blockEventInternal"](oBrowserEvent);
	}

	this["bKeyboardHandlingInProcess"] = false;

	return bResult;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bProcessTabHandling"] = 0; };
/* eslint-enable complexity */

/**
 * This is a called hook in the tabprocessing to redirect the found cell to a
 * different position. This method is overwritten by SapTableCS.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {boolean} bForward Forwartd or backward tabbing?
 * @param {UCF_SapTable_CellInfo} oTabActionCellInfoFrom CellInfo with the
 * current focus
 * @param {UCF_SapTable_CellInfo} oTabActionCellInfoTo The found CellInfo to be
 * used for focussing
 * @return {UCF_SapTable_CellInfo} the cell info which should be focussed
 * instead
 */
UCF_SapTable["prototype"]["oRedirectProcessTabHandling"] = function(oBrowserEvent, bForward, oTabActionCellInfoFrom, oTabActionCellInfoTo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oRedirectProcessTabHandling"]++; }; 
	// Do not change the result for SapTable
	return oTabActionCellInfoTo;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oRedirectProcessTabHandling"] = 0; };

/**
 * @private
 */
UCF_SapTable["prototype"]["handleFocusEntryStart"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleFocusEntryStart"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oStartCellInfo;
	/** @type {UCF_FocusInfo} */
	var oFocusInfo;
	/** @type {UCF_Control} */
	var oChildControl;
	/** @type {UCF_Control} */
	var _oChildControl;
	/** @type {UCF_Control} */
	var oNextFocusableControl;
	/** @type {HTMLElement} */
	var	oThead;

	oStartCellInfo = null;
	oFocusInfo = null;
	oChildControl = null;
	_oChildControl = null;
	oNextFocusableControl = null;
	oThead = null;

	// at reaccess focus last focussed cell content
	if (this["sFocusInfo"]) {
		oFocusInfo = new (UCF_ClassLoader["oGetClass"]("UCF_FocusInfo"))(this["oLS"]);
		oFocusInfo["deserialize"](this["sFocusInfo"]);
		oFocusInfo["apply"]();
		oFocusInfo["cleanUp"]();
	}
	// at initial access focus either focusable content in the header (if available) or the first cell
	else {
		oThead = UCF_DomUtil["$"](this["sId"] + "-thead");
		if (oThead) {
			oChildControl = this["oGetFirstChildControl"]();
			while (oChildControl && UCF_DomUtil["bContains"](oThead, oChildControl["oDomRef"])) {
				if (oChildControl["bIsFocusable"]()) {
					oNextFocusableControl = oChildControl;
					break;
				}
				else {
					_oChildControl = oChildControl["oGetFirstChildControl"]();
					if (!_oChildControl) {
						oChildControl = oChildControl["oGetNextControl"]();
					}
					else {
						oChildControl = _oChildControl;
					}
				}
			}
		}

		// if there is focusable content in the header then focus it
		if (oThead && oNextFocusableControl && oNextFocusableControl["oDomRef"] && UCF_DomUtil["bContains"](oThead, oNextFocusableControl["oDomRef"])) {
			oNextFocusableControl["focus"]();
		}
		// otherwise try to focus first cell
		else {
			oStartCellInfo = this["oGetCellInfo"](0, 0);
			if (oStartCellInfo) this["setCellMatrixFocusByCellInfo"](oStartCellInfo);
			// if there is no cell find next tabable element
			else this["focusTabbableElementForward"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleFocusEntryStart"] = 0; };

/**
 * @private
 */
UCF_SapTable["prototype"]["handleFocusEntryEnd"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleFocusEntryEnd"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oEndCellInfo;
	/** @type {UCF_FocusInfo} */
	var oFocusInfo;
	/** @type {UCF_Control} */
	var oChildControl;
	/** @type {UCF_Control} */
	var _oChildControl;
	/** @type {UCF_Control} */
	var oPreviousFocusableControl;
	/** @type {HTMLElement} */
	var	oTfoot;

	oEndCellInfo = null;
	oFocusInfo = null;
	oChildControl = null;
	_oChildControl = null;
	oPreviousFocusableControl = null;
	oTfoot = null;

	// at reaccess focus last focussed cell content
	if (this["sFocusInfo"]) {
		oFocusInfo = new (UCF_ClassLoader["oGetClass"]("UCF_FocusInfo"))(this["oLS"]);
		oFocusInfo["deserialize"](this["sFocusInfo"]);
		oFocusInfo["apply"]();
		oFocusInfo["cleanUp"]();
	}
	// at initial access focus either focusable content in the footer (if available) or the last cell
	else {
		oTfoot = UCF_DomUtil["$"](this["sId"] + "-tfoot");
		if (oTfoot) {
			oChildControl = this["oGetLastChildControl"]();
			while (oChildControl && UCF_DomUtil["bContains"](oTfoot, oChildControl["oDomRef"])) {
				if (oChildControl["bIsFocusable"]()) {
					oPreviousFocusableControl = oChildControl;
					break;
				}
				else {
					_oChildControl = oChildControl["oGetLastChildControl"]();
					if (!_oChildControl) {
						oChildControl = oChildControl["oGetPreviousControl"]();
					}
					else {
						oChildControl = _oChildControl;
					}
				}
			}
		}

		// if there is focusable content in the footer then focus it
		if (oTfoot && oPreviousFocusableControl && oPreviousFocusableControl["oDomRef"] && UCF_DomUtil["bContains"](oTfoot, oPreviousFocusableControl["oDomRef"])) {
			oPreviousFocusableControl["focus"]();
		}
		// otherwise try to focus last cell
		else {
			oEndCellInfo = this["oGetCellInfo"](this["iGetCellInfoMatrixLastRowIndex"](), this["iGetCellInfoMatrixLastColIndex"]());
			if (oEndCellInfo) this["setCellMatrixFocusByCellInfo"](oEndCellInfo);
			// if there is no cell find previous tabable element
			else this["focusTabbableElementBackward"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleFocusEntryEnd"] = 0; };

/**
 * @private
 */
UCF_SapTable["prototype"]["focusTabbableElementForward"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["focusTabbableElementForward"]++; }; 
	/** @type {HTMLElement} */
	var oNextSiblingDomRef;
	/** @type {HTMLElement} */
	var oNextTabableDomRef;

	oNextSiblingDomRef = null;
	oNextTabableDomRef = null;

	// focus next tabable element
	oNextSiblingDomRef = UCF_DomUtil["oGetNextSibling"](this["oDomRef"], true);
	if (oNextSiblingDomRef) {
		oNextTabableDomRef = UCF_DomUtil["oGetTabbableElementForward"](oNextSiblingDomRef, true);
		if (oNextTabableDomRef) UCF_DomUtil["focusDomElement"](oNextTabableDomRef);
		else this["oLS"]["focusEnd"]();
	}
	else this["oLS"]["focusEnd"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["focusTabbableElementForward"] = 0; };

/**
 * @private
 */
UCF_SapTable["prototype"]["focusTabbableElementBackward"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["focusTabbableElementBackward"]++; }; 
	/** @type {HTMLElement} */
	var oPreviousSiblingDomRef;
	/** @type {HTMLElement} */
	var oPreviousTabableDomRef;

	oPreviousSiblingDomRef = null;
	oPreviousTabableDomRef = null;

	// focus previous tabable element
	oPreviousSiblingDomRef = UCF_DomUtil["oGetPreviousSibling"](this["oDomRef"], true);
	if (oPreviousSiblingDomRef) {
		oPreviousTabableDomRef = UCF_DomUtil["oGetTabbableElementBackward"](oPreviousSiblingDomRef, true);
		if (oPreviousTabableDomRef) UCF_DomUtil["focusDomElement"](oPreviousTabableDomRef);
		else document["body"]["focus"]();
	}
	else document["body"]["focus"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["focusTabbableElementBackward"] = 0; };

/**
 * Checks if the given cell is a row creator cell (AppendRow feature)
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {boolean} `true` if it is a RowCreator cell
 */
UCF_SapTable["prototype"]["bIsRowCreatorCell"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsRowCreatorCell"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(6688): bIsRowCreatorCell"); };

	return this["sRowCreationTrigger"] === 'INHERIT' &&
		this["mGetCellUsageType"](oCellInfo) === this["CELL_USAGE_TYPE"]["ROWCREATOR"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsRowCreatorCell"] = 0; };

/******************************************************
 * COLOR processing
 * The table provides some color features to handle e.g.
 * the hovering color calculation etc.
 * Some operations uses caching
 *******************************************************/

/** @type {UCF_SapTable_ColorEnum} */
UCF_SapTable["prototype"]["COLOR"] = {
	"HOVER": 'colorStdHover',
	"HOVER_DD": 'colorDDHover'
};

/**
 * Clean up the cached information accumulated by color operations
 * @private
 */
UCF_SapTable["prototype"]["cleanUpColorProcessing"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpColorProcessing"]++; }; 
	this["oColorCache"] = null;
	this["oMainBgColor"] = null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpColorProcessing"] = 0; };

/**
 * There are different theme dependend colors which have to be applied like the
 * hover color or a D&D color. The value of these colors are send to the client
 * by an HTML element which have the according CSS class applied. This method
 * simply searches for this color and caches the result
 *
 * @private
 * @param {UCF_SapTable_Color} eColor the color type (e.g. this.COLOR.HOVER)
 * @return {UCF_SapTable_Rgb} A color object containing RGB
 */
UCF_SapTable["prototype"]["oGetColor"] = function(eColor) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetColor"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefExtractor;

	if (!this["oColorCache"]) {
		this["oColorCache"] = {};
	}

	if (!this["oColorCache"][eColor]) {
		oDomRefExtractor = UCF_DomUtil["$"](this["sId"] + '-' + eColor);
		this["oColorCache"][eColor] = oDomRefExtractor
			? this["oGetBgColor"](oDomRefExtractor)
			: -1;
	}

	return this["oColorCache"][eColor] === -1 ? eColor : this["oColorCache"][eColor];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetColor"] = 0; };

/* eslint-disable no-magic-numbers */
/**
 * @private
 * @param {HTMLElement} oDomRef
 * @return {UCF_SapTable_Rgb} the background color of a given HTML element,
 * converted to an RGB set
 */
UCF_SapTable["prototype"]["oGetBgColor"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetBgColor"]++; }; 
	/** @type {string} */
	var sColor = UCF_DomUtil["sGetCurrentStyle"](oDomRef, 'backgroundColor');
	/** @type {number} */
	var iColor;
	/** @type {number} */
	var iIndexOfFirstColon;
	/** @type {number} */
	var iIndexOfSecondColon;

	// TODO trim and cleanup the incoming bg string

	if (sColor) {
		if (sColor["indexOf"]('rgb(') === 0) {
			iIndexOfFirstColon = sColor["indexOf"](',', 0);
			iIndexOfSecondColon = sColor["indexOf"](',', iIndexOfFirstColon + 1);

			return {
				"r": parseInt(sColor["substr"](4, iIndexOfFirstColon - 4), 10),
				"g": parseInt(sColor["substr"](
					iIndexOfFirstColon + 2,
					iIndexOfSecondColon - iIndexOfFirstColon - 2
				), 10),
				"b": parseInt(sColor["substr"](iIndexOfSecondColon + 2, 3), 10)
			};
		} else if (sColor["charCodeAt"](0) === 35) {
			if (sColor["length"] === 7) {
				iColor = parseInt(sColor["substr"](1, 6), 16);

				return {
					"r": (iColor & 0xff0000) >> 16,
					"g": (iColor & 0x00ff00) >> 8,
					"b": (iColor & 0x0000ff)
				};
			} else if (sColor["length"] === 4) {
				iColor = parseInt(sColor["substr"](1, 3), 16);

				return {
					"r": ((iColor & 0xf00) >> 8) | ((iColor & 0xf00) >> 4),
					"g": ((iColor & 0x0f0) >> 4) | (iColor & 0x0f0),
					"b": (iColor & 0x00f) | ((iColor & 0x00f) << 4)
				};
			}
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetBgColor"] = 0; };
/* eslint-enable no-magic-numbers */

/**
 * Returns the background color whole table background. If it is trabsparent it
 * check all parent elements
 *
 * @private
 * @return {UCF_SapTable_Rgb} the background color whole table background
 */
UCF_SapTable["prototype"]["oGetMainBgColor"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetMainBgColor"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {UCF_SapTable_Rgb} */
	var oCurrColor;

	if (!this["oMainBgColor"]) {
		// Search for content root to determine color
		oDomRef = UCF_DomUtil["$"](this["sId"] + '-' + this["SUFFIX"]["CONTENT_TBODY"]) ||
			UCF_DomUtil["$"](this["sId"] + '-' + this["SUFFIX"]["CONTENT_AREA"]);

		// Search for first parent which contains a defined BG color
		while (oDomRef && oDomRef["tagName"] !== 'BODY') {
			oCurrColor = this["oGetBgColor"](oDomRef);
			if (oCurrColor) {
				this["oMainBgColor"] = oCurrColor;

				return this["oMainBgColor"];
			}
			oDomRef = oDomRef["parentNode"];
		}

		// No MainColor found -> default = white
		this["oMainBgColor"] = { "r": 255, "g": 255, "b": 255 };
	}

	return this["oMainBgColor"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetMainBgColor"] = 0; };

/* eslint-disable no-magic-numbers */
/**
 * Converts a given RGB color to a HEX string
 *
 * @private
 * @param {UCF_SapTable_Rgb} oColor
 * @return {string} a hex string
 */
UCF_SapTable["prototype"]["sColorToHexString"] = function(oColor) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sColorToHexString"]++; }; 
	/** @type {string} */
	var sResult = ((oColor["r"] << 16) | (oColor["g"] << 8) | (oColor["b"]))["toString"](16);

	return sResult["length"] < 6
		? '000000'["substr"](0, 6 - sResult["length"]) + sResult
		: sResult;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sColorToHexString"] = 0; };

/**
 * Extracts the luminance from a given color
 *
 * @private
 * @param {UCF_SapTable_Rgb} oColor
 * @return {number} a value between 0.0 an 1.0. The higher value the brighter
 * the color
 */
UCF_SapTable["prototype"]["iGetColorLuminance"] = function(oColor) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetColorLuminance"]++; }; 
	return 0.2126 * oColor["r"] +
		0.7152 * oColor["g"] +
		0.0722 * oColor["b"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetColorLuminance"] = 0; };
/* eslint-enable no-magic-numbers */

/******************************************************
 ** ROW HOVERING
 *
 * When hovering over a row the row should be slightly
 * highligheted. The following code sections are handling
 * this feature
 *
 *******************************************************/

/**
 * Is RowHovering activated at all?
 *
 * @private
 * @return {boolean} `true` if row hovering is activated
 */
UCF_SapTable["prototype"]["bIsRowHoveringEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsRowHoveringEnabled"]++; }; 
	return this["sCellSelectionMapping"] === 'ROW';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsRowHoveringEnabled"] = 0; };

/**
 * This method is called when the row hovering could be visualized. It checks
 * if a row hovering colorization takes place and triggers the right methods to
 * colorize a row or decolorize a row
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SapTable["prototype"]["checkRowHoveringIn"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkRowHoveringIn"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {boolean} */
	var bAccepted;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(6902): checkRowHoveringIn"); };

	if (this["bIsRowHoveringEnabled"]()) {
		oCellInfo = this["oGetCellInfoByBrowserEvent"](oBrowserEvent);
		bAccepted = oCellInfo && oCellInfo["iRowSpan"] === 1;

		// bAccepted == true when a valid row has been found

		if (bAccepted && this["iLastEnteredRow"] !== oCellInfo["iRowIndex"]) {
			if (this["iLastEnteredRow"] !== -1) {
				this["doRowHoveringLeaving"](this["iLastEnteredRow"]);
			}
			this["doRowHoveringEntering"](oCellInfo["iRowIndex"]);

			this["iLastEnteredRow"] = oCellInfo["iRowIndex"];
		} else if (!bAccepted && this["iLastEnteredRow"] !== -1) {
			// When no valid row has been found decolorize the last colorized row
			// This could happen when mouse e.g. leaves the whole table
			this["doRowHoveringLeaving"](this["iLastEnteredRow"]);
			this["iLastEnteredRow"] = -1;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkRowHoveringIn"] = 0; };

/**
 * Do the processing for when the mouse leaves the table
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SapTable["prototype"]["checkRowHoveringOut"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkRowHoveringOut"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(6933): checkRowHoveringOut"); };

	if (
		this["bIsRowHoveringEnabled"]() &&
		this["iLastEnteredRow"] !== -1 &&
		!UCF_DomUtil["bContains"](
			this["oDomRef"],
			oBrowserEvent["oDomEvent"]["toElement"] ||
			oBrowserEvent["oDomEvent"]["relatedTarget"]
		)
	) {
		this["cleanUpRowHovering"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkRowHoveringOut"] = 0; };

/**
 * Initializes the RowHovering feature
 *
 * @private
 */
UCF_SapTable["prototype"]["initRowHovering"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initRowHovering"]++; }; 
	this["iLastEnteredRow"] = -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initRowHovering"] = 0; };

/**
 * Cleans up the RowHovering feature
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpRowHovering"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpRowHovering"]++; }; 
	if (this["iLastEnteredRow"] !== -1) {
		this["doRowHoveringLeaving"](this["iLastEnteredRow"]);
		this["iLastEnteredRow"] = -1;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpRowHovering"] = 0; };

/**
 * Do the processing for when the mouse is entering a row iven by a row index
 *
 * @private
 * @param {number} iRowIndex
 */
UCF_SapTable["prototype"]["doRowHoveringEntering"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringEntering"]++; }; 
	this["doRowHoveringCssSetting"](iRowIndex, true);
	this["doRowHoveringColorizeRow"](iRowIndex, true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringEntering"] = 0; };

/**
 * Do the processing for when the mouse is leaving a row given by a row index
 *
 * @private
 * @param {number} iRowIndex
 */
UCF_SapTable["prototype"]["doRowHoveringLeaving"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringLeaving"]++; }; 
	this["doRowHoveringCssSetting"](iRowIndex, false);
	this["doRowHoveringColorizeRow"](iRowIndex, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringLeaving"] = 0; };

/**
 * Refreshes the current state of hovering
 *
 * @private
 * @param {UCF_SapTable_CellInfo[]} aCellInfos An array of cell infos to be
 * refreshed or updated
 */
UCF_SapTable["prototype"]["doRowHoveringEffectUpdate"] = function(aCellInfos) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringEffectUpdate"]++; }; 
	/** @type {number} */
	var i;

	if (this["bIsRowHoveringEnabled"]()) {
		for (i = 0; i < aCellInfos["length"]; i++) {
			if (aCellInfos[i]["oDomRefCell"]["sRowColorized"]) {
				this["doRowHoveringColorizeCell"](aCellInfos[i], false);
				this["doRowHoveringColorizeCell"](aCellInfos[i], true);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringEffectUpdate"] = 0; };

/**
 * Prepares the HTML row for hovering
 *
 * @private
 * @param {number} iRowIndex
 * @param {boolean} bHovered
 */
UCF_SapTable["prototype"]["doRowHoveringCssSetting"] = function(iRowIndex, bHovered) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringCssSetting"]++; }; 
	/** @type {HTMLElement[]} */
	var aDomRefRows = this["aGetDomRefsOfRows"](iRowIndex);
	/** @type {number} */
	var i;

	for (i = 0; i < aDomRefRows["length"]; i++) {
		if (bHovered) {
			UCF_DomUtil["addClass"](aDomRefRows[i], 'urST4RowHovered');
		} else {
			UCF_DomUtil["removeClass"](aDomRefRows[i], 'urST4RowHovered');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringCssSetting"] = 0; };

/* eslint-disable no-magic-numbers */
/**
 * Colorize or decolorize a whole cell given by cell info
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {boolean} bSet "true" to colorize or "false" to decolorize
 */
UCF_SapTable["prototype"]["doRowHoveringColorizeCell"] = function(oCellInfo, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringColorizeCell"]++; }; 
	/** @type {UCF_SapTable_Rgb} */
	var oHoverColor;
	/** @type {UCF_SapTable_Rgb} */
	var oCurrentColor;
	/** @type {UCF_SapTable_Rgb} */
	var oResultColor;
	/** @type {UCF_SapTable_Rgb} */
	var oExcludeColor;
	/** @type {UCF_SapTable_Rgb[]} */
	var aExcludeColors;
	/** @type {boolean} */
	var bCalculateColor;
	/** @type {string} */
	var sCssText;
	/** @type {number} */
	var fMaxPercentage;
	/** @type {number} */
	var i;
	/** @type {number} */
	var fR;
	/** @type {number} */
	var fG;
	/** @type {number} */
	var fB;
	/** @type {string} */
	var sResultColor;
	/** @type {string} */
	var sContrastColor;
	/** @type {number} */
	var iFrom;
	/** @type {number} */
	var iTo;

	if (!this["aCellInfoMatrix"]) {
		return;
	}

	if (oCellInfo["iRowSpan"] === 1 && (
			this["bIsDataTableCell"](this["eGetCellType"](oCellInfo)) ||
			this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["SELECTION_CELL"]
		)) {
		if (bSet) {
			oHoverColor = this["oGetColor"](this["COLOR"]["HOVER"]);
			oCurrentColor = this["oGetBgColor"](oCellInfo["oDomRefCell"]);
			oResultColor = { "r": 0, "g": 0, "b": 0 };
			oExcludeColor = null;
			aExcludeColors = [{ "r": 122, "g": 81, "b": 0 }, { "r": 236, "g": 139, "b": 70 }];
			bCalculateColor = true;
			sCssText = null;
			fMaxPercentage = 1.0;

			if (!oHoverColor) {
				return; // Theme does not support row hovering
			}

			for (i = 0; i < aExcludeColors["length"]; i++) {
				oExcludeColor = aExcludeColors[i];
				if (
					oHoverColor["r"] === oExcludeColor["r"] &&
					oHoverColor["g"] === oExcludeColor["g"] &&
					oHoverColor["b"] === oExcludeColor["b"]
				) {
					bCalculateColor = false;
				}
			}

			if (!oCurrentColor) {
				oCurrentColor = this["oGetMainBgColor"]();
			}

			if (bCalculateColor) {
				if (this["iGetColorLuminance"](oCurrentColor) > 145) {
					// Subtractive mode
					if (
						oCurrentColor["r"] < (255 - oHoverColor["r"]) ||
						oCurrentColor["g"] < (255 - oHoverColor["g"]) ||
						oCurrentColor["b"] < (255 - oHoverColor["b"])
					) {
						// Color correction when one color part would overflow
						// Check the maximum percentage of the difference color which can
						// be used to substract without producing an overflow
						fMaxPercentage = Math["min"](
							oCurrentColor["r"] / (255 - oHoverColor["r"]),
							oCurrentColor["g"] / (255 - oHoverColor["g"]),
							oCurrentColor["b"] / (255 - oHoverColor["b"])
						);
					}

					oResultColor["r"] = Math["floor"](
						oCurrentColor["r"] - ((255 - oHoverColor["r"]) * fMaxPercentage)
					);
					oResultColor["g"] = Math["floor"](
						oCurrentColor["g"] - ((255 - oHoverColor["g"]) * fMaxPercentage)
					);
					oResultColor["b"] = Math["floor"](
						oCurrentColor["b"] - ((255 - oHoverColor["b"]) * fMaxPercentage)
					);
				} else {
					// Correction of color because the colors ars usually used for
					// subtractive
					fR = oHoverColor["r"] * 0.25;
					fG = oHoverColor["g"] * 0.25;
					fB = oHoverColor["b"] * 0.25;

					// Additive mode
					if (
						(oCurrentColor["r"] + fR) > 255 ||
						(oCurrentColor["g"] + fG) > 255 ||
						(oCurrentColor["b"] + fB) > 255
					) {
						// Color correction when one color part would overflow. Check the
						// maximum percentage of the difference color which can be used to
						// add without producing an overflow
						fMaxPercentage = Math["min"](
							255 / (oCurrentColor["r"] + fR),
							255 / (oCurrentColor["g"] + fG),
							255 / (oCurrentColor["b"] + fB)
						);
					}

					oResultColor["r"] = Math["floor"]((oCurrentColor["r"] + fR) * fMaxPercentage);
					oResultColor["g"] = Math["floor"]((oCurrentColor["g"] + fG) * fMaxPercentage);
					oResultColor["b"] = Math["floor"]((oCurrentColor["b"] + fB) * fMaxPercentage);
				}
			} else {
				oResultColor = oHoverColor;
			}

			sResultColor = this["sColorToHexString"](oResultColor);
			sContrastColor = UCF_ColorUtil["sContrast"]('#' + sResultColor);
			sCssText = 'BACKGROUND-COLOR: #' + sResultColor + '!important; ' +
				'COLOR: ' + sContrastColor + '!important; ' +
				'FILL: ' + sContrastColor + '!important;';

			oCellInfo["oDomRefCell"]["style"]["cssText"] += ';' + sCssText;

			// Find the formated BG color text for later replacement when removing
			// the color. Important: IE does not necessarily add the string at the
			// end. It rearranges the cssText when applying it.
			sCssText = oCellInfo["oDomRefCell"]["style"]["cssText"];

			iFrom = sCssText["indexOf"]('BACKGROUND-COLOR');
			if (iFrom === -1) {
				iFrom = sCssText["indexOf"]('background-color');
			}
			if (iFrom !== -1) {
				iTo = sCssText["indexOf"](';', iFrom);
				if (iTo === -1) {
					iTo = sCssText["length"];
				}
				oCellInfo["oDomRefCell"]["sRowBGColorized"] = sCssText["substring"](iFrom, iTo);
			}

			iFrom = sCssText["indexOf"](' COLOR');
			if (iFrom === -1) {
				iFrom = sCssText["indexOf"](' color');
			}
			if (iFrom !== -1) {
				iTo = sCssText["indexOf"](';', iFrom);
				if (iTo === -1) {
					iTo = sCssText["length"];
				}
				oCellInfo["oDomRefCell"]["sRowColorized"] = sCssText["substring"](iFrom, iTo);
			}

			iFrom = sCssText["indexOf"]('FILL');
			if (iFrom === -1) {
				iFrom = sCssText["indexOf"]('fill');
			}
			if (iFrom !== -1) {
				iTo = sCssText["indexOf"](';', iFrom);
				if (iTo === -1) {
					iTo = sCssText["length"];
				}
				oCellInfo["oDomRefCell"]["sRowFillColorized"] = sCssText["substring"](
					iFrom,
					iTo
				);
			}
		} else if (
			oCellInfo["oDomRefCell"]["sRowColorized"] ||
			oCellInfo["oDomRefCell"]["sRowBGColorized"] ||
			oCellInfo["oDomRefCell"]["sRowFillColorized"]
		) {
			if (oCellInfo["oDomRefCell"]["sRowColorized"]) {
				oCellInfo["oDomRefCell"]["style"]["cssText"] = oCellInfo["oDomRefCell"]["style"]
					["cssText"]["replace"](oCellInfo["oDomRefCell"]["sRowColorized"], '');
			}
			if (oCellInfo["oDomRefCell"]["sRowBGColorized"]) {
				oCellInfo["oDomRefCell"]["style"]["cssText"] = oCellInfo["oDomRefCell"]["style"]
					["cssText"]["replace"](oCellInfo["oDomRefCell"]["sRowBGColorized"], '');
			}
			if (oCellInfo["oDomRefCell"]["sRowFillColorized"]) {
				oCellInfo["oDomRefCell"]["style"]["cssText"] = oCellInfo["oDomRefCell"]["style"]
					["cssText"]["replace"](oCellInfo["oDomRefCell"]["sRowFillColorized"], '');
			}
			oCellInfo["oDomRefCell"]["sRowColorized"] = null;
			oCellInfo["oDomRefCell"]["sRowBGColorized"] = null;
			oCellInfo["oDomRefCell"]["sRowFillColorized"] = null;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringColorizeCell"] = 0; };
/* eslint-enable no-magic-numbers */

/**
 * Colorize or decolorize a whole row given by an index
 *
 * @private
 * @param {number} iRowIndex
 * @param {boolean} bSet "true" to colorize or "false" to decolorize
 */
UCF_SapTable["prototype"]["doRowHoveringColorizeRow"] = function(iRowIndex, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringColorizeRow"]++; }; 
	/** @type {UCF_SapTable_CellInfo[]} */
	var aCellInfos;
	/** @type {number} */
	var i;

	if (this["aCellInfoMatrix"] && !(
			this["eGetRowSelectionState"](iRowIndex) & this["SELECTION_LAYER"]["ROW_DISABLED"]
		)) {
		aCellInfos = this["aGetCellInfosOfRow"](iRowIndex);

		for (i = 0; i < aCellInfos["length"]; i++) {
			this["doRowHoveringColorizeCell"](aCellInfos[i], bSet);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doRowHoveringColorizeRow"] = 0; };

/******************************************************
 ** HOVER EFFECTS
 * This section contains the code which is handling
 * all hover effects of the table e.g. RowHovering, ActionMenu or
 * the Divider in between sort button and header cell text
 *
 ******************************************************/

/**
 * Initializes all hover effects
 *
 * @private
 */
UCF_SapTable["prototype"]["initHoverEffects"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initHoverEffects"]++; }; 
	this["initRowHovering"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initHoverEffects"] = 0; };

/**
 * Checks hovering in
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["checkHoverEffectsIn"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHoverEffectsIn"]++; }; 
	/** @type {HTMLElement} */
	var oSource;
	/** @type {number} */
	var iIteration;
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(7302): checkHoverEffectsIn"); };
	this["checkDataTipOpen"](oBrowserEvent);
	this["checkRowHoveringIn"](oBrowserEvent);
	this["initSelectionInfo"]();

	oSource = oBrowserEvent["oGetSource"]();
	iIteration = 4; // eslint-disable-line no-magic-numbers

	if (oSource["getAttribute"]('checkCellDim')) {
		// Correction painting when server cannot calculate
		oCellInfo = this["oGetCellInfoByDomRef"](oSource);

		if (oCellInfo) {
			if (this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["HEADER_CELL"]) {
				this["checkHeaderCellDimensions"](oCellInfo);
			}
		}
	}

	// Check the affected DOM for attached hover effects
	while (oSource && iIteration !== 0) {
		if (oSource["getAttribute"]('hasHoverEffect')) {
			this["checkHoverEffectIn"](oSource, this["HOVER_EFFECT"]["DIVIDER"]);
			this["checkHoverEffectIn"](oSource, this["HOVER_EFFECT"]["ACTION_MENU"]);
			this["checkHoverEffectIn"](oSource, this["HOVER_EFFECT"]["HEADER_BG"], oSource);
			this["checkHoverEffectIn"](
				oSource,
				this["HOVER_EFFECT"]["RESIZE_HANDLE"],
				oSource
			);
			break;
		}

		oSource = oSource["offsetParent"];
		iIteration--;
	}

	this["checkHoverEffectIn"](this["oDomRef"], this["HOVER_EFFECT"]["TABLE"], this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHoverEffectsIn"] = 0; };

/**
 * Checks hovering out
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTable["prototype"]["checkHoverEffectsOut"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHoverEffectsOut"]++; }; 
	/** @type {HTMLElement} */
	var oTarget;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(7352): checkHoverEffectsOut"); };
	this["checkDataTipClose"](oBrowserEvent);
	this["checkRowHoveringOut"](oBrowserEvent);

	oTarget = oBrowserEvent["oDomEvent"]["toElement"] ||
		oBrowserEvent["oDomEvent"]["relatedTarget"];

	this["checkHoverEffectOut"](oTarget, this["HOVER_EFFECT"]["DIVIDER"]);
	this["checkHoverEffectOut"](oTarget, this["HOVER_EFFECT"]["ACTION_MENU"]);
	this["checkHoverEffectOut"](oTarget, this["HOVER_EFFECT"]["HEADER_BG"]);
	this["checkHoverEffectOut"](oTarget, this["HOVER_EFFECT"]["TABLE"]);
	this["checkHoverEffectOut"](oTarget, this["HOVER_EFFECT"]["RESIZE_HANDLE"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHoverEffectsOut"] = 0; };

/**
 * Clean up the hover effects
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpHoverEffects"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpHoverEffects"]++; }; 
	this["cleanUpDataTips"]();
	this["cleanUpRowHovering"]();

	this["cleanUpHoverEffect"](this["HOVER_EFFECT"]["DIVIDER"]);
	this["cleanUpHoverEffect"](this["HOVER_EFFECT"]["ACTION_MENU"]);
	this["cleanUpHoverEffect"](this["HOVER_EFFECT"]["HEADER_BG"]);
	this["cleanUpHoverEffect"](this["HOVER_EFFECT"]["TABLE"]);
	this["cleanUpHoverEffect"](this["HOVER_EFFECT"]["RESIZE_HANDLE"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpHoverEffects"] = 0; };

/**
 * Checks if a specific hover effect is currently applied
 *
 * @private
 * @param {UCF_SapTable_HoverEffect} sEffectName the effect name provided in
 * the enum this.HOVER_EFFECT
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bIsHoverEffectActive"] = function(sEffectName) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsHoverEffectActive"]++; }; 
	return !!this['oDomRefHoverLastApplied_' + sEffectName];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsHoverEffectActive"] = 0; };

/**
 * Checks if a specific hover effect is relevant for the given dom ref
 *
 * @private
 * @param {HTMLElement} oSource
 * @param {UCF_SapTable_HoverEffect} sEffectName the effect name provided in
 * the enum this.HOVER_EFFECT
 * @return {boolean} true if the passed hover effect applies
 */
UCF_SapTable["prototype"]["bHasHoverEffect"] = function(oSource, sEffectName) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasHoverEffect"]++; }; 
	return !!oSource["getAttribute"](sEffectName);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasHoverEffect"] = 0; };

/**
 * Checks if a specific hover effect is relevant for the given source dom ref
 * and applies the effect to a given target
 *
 * @private
 * @param {HTMLElement} oSource
 * @param {UCF_SapTable_HoverEffect} sEffectName the effect name provided in
 * the enum this.HOVER_EFFECT
 * @param {HTMLElement} oTarget
 */
UCF_SapTable["prototype"]["checkHoverEffectIn"] = function(oSource, sEffectName, oTarget) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHoverEffectIn"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef;

	if (this["bHasHoverEffect"](oSource, sEffectName)) {
		oDomRef = oTarget || UCF_DomUtil["$"](oSource["id"] + '-' + sEffectName);

		if (oDomRef !== this['oDomRefHoverLastApplied_' + sEffectName]) {
			if (this['oDomRefHoverContainerLastApplied_' + sEffectName] !== oSource) {
				this["cleanUpHoverEffect"](sEffectName);
			}

			UCF_DomUtil["addClass"](
				oDomRef,
				oDomRef["getAttribute"](sEffectName + '_class')
			);
			this['oDomRefHoverLastApplied_' + sEffectName] = oDomRef;
			this['oDomRefHoverContainerLastApplied_' + sEffectName] = oSource;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHoverEffectIn"] = 0; };

/**
 * Cleans up a formerly applied hover effect for a hover out
 *
 * @private
 * @param {HTMLElement} oTarget
 * @param {UCF_SapTable_HoverEffect} sEffectName the effect name provided in
 * the enum this.HOVER_EFFECT
 */
UCF_SapTable["prototype"]["checkHoverEffectOut"] = function(oTarget, sEffectName) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHoverEffectOut"]++; }; 
	if (this["bIsHoverEffectActive"](sEffectName)) {
		if (!UCF_DomUtil["bContains"](
				this['oDomRefHoverContainerLastApplied_' + sEffectName],
				oTarget
			)) {
			this["cleanUpHoverEffect"](sEffectName);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHoverEffectOut"] = 0; };

/**
 * Cleans up a formerly applied hover effect
 *
 * @private
 * @param {UCF_SapTable_HoverEffect} sEffectName the effect name provided in
 * the enum this.HOVER_EFFECT
 * @param {HTMLElement} oCheckSource
 */
UCF_SapTable["prototype"]["cleanUpHoverEffect"] = function(sEffectName, oCheckSource) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpHoverEffect"]++; }; 
	if (this["bIsHoverEffectActive"](sEffectName)) {
		if (oCheckSource == null) {
			UCF_DomUtil["removeClass"](
				this['oDomRefHoverLastApplied_' + sEffectName],
				this['oDomRefHoverLastApplied_' + sEffectName]["getAttribute"](
					sEffectName + '_class'
				)
			);
			this['oDomRefHoverLastApplied_' + sEffectName] = null;
			this['oDomRefHoverContainerLastApplied_' + sEffectName] = null;
		} else {
			// Removes the hover effect when no other hover effect in this table is
			// applied, e.g. when hover effect was set by keyboard and the table has
			// been left
			UCF_JsUtil["delayedCall"](
				50, // eslint-disable-line no-magic-numbers
				this,
				'checkCleanUpHoverEffect',
				[sEffectName, oCheckSource]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpHoverEffect"] = 0; };

/**
 * Check if there is a hover effect to clean up and calls then the clean up
 * method
 *
 * @private
 * @param {UCF_SapTable_HoverEffect} sEffectName the effect name provided in
 * the enum this.HOVER_EFFECT
 * @param {HTMLElement} oCheckSource
 */
UCF_SapTable["prototype"]["checkCleanUpHoverEffect"] = function(sEffectName, oCheckSource) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkCleanUpHoverEffect"]++; }; 
	if (
		this["bIsHoverEffectActive"](sEffectName) &&
		this['oDomRefHoverContainerLastApplied_' + sEffectName] === oCheckSource
	) {
		this["cleanUpHoverEffect"](sEffectName);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkCleanUpHoverEffect"] = 0; };

/******************************************************
 ** HEADER ACTION MENU
 *******************************************************/

/**
 * Opens the action menu of the header cell. Returns "false" when the "open"
 * was not successful.
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo The cell info of the header cell
 * @param {boolean} bToggle Toggles the menu when it is already open
 * @param {boolean} bWithKeyboard The flag which determines if the menu access
 * was tiggred by keyboard
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bOpenHeaderActionMenuInternal"] = function(oCellInfo, bToggle, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bOpenHeaderActionMenuInternal"]++; }; 
	/** @type {string} */
	var sPopupMenuId;
	/** @type {string} */
	var sHeaderId;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(7530): bOpenHeaderActionMenuInternal"); };

	sPopupMenuId = oCellInfo["oDomRefCell"]["getAttribute"]('actMenuId');
	sHeaderId = this["sGetCellId"](oCellInfo);

	this["oHeaderActionMenu"] = sPopupMenuId
		? this["oGetControlById"](sPopupMenuId, true)
		: null;

	if (this["oHeaderActionMenu"]) {
		this["oHeaderActionMenu"]["setAutoRefocus"](false);

		if (
			this["sLastHeaderActionMenu"] === sHeaderId &&
			this["oHeaderActionMenu"]["bOpened"]
		) {
			if (bToggle) {
				this["oHeaderActionMenu"]["close"]();
				this["sLastHeaderActionMenu"] = null;
			}
		} else {
			this["oHeaderActionMenu"]["setOpenerRef"](oCellInfo["oDomRefCell"]);
			this["oHeaderActionMenu"]["setOpenerId"](sHeaderId);

			this["oHeaderActionMenu"]["attachEvent"](
				this["oHeaderActionMenu"]["E_EVENTS"]["Close"],
				this,
				'onHeaderActionMenuClose'
			);

			this["oHeaderActionMenu"]["open"](bWithKeyboard);
			this["sLastHeaderActionMenu"] = sHeaderId;
		}

		return true;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bOpenHeaderActionMenuInternal"] = 0; };

/**
 * Opens the action menu of the header cell given by a header cell id
 *
 * @public
 * @param {string} sCellId The id of the header cell
 * @param {boolean} bWithKeyboard The flag which determines if the menu access
 * was tiggred by keyboard
 */
UCF_SapTable["prototype"]["openHeaderActionMenu"] = function(sCellId, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["openHeaderActionMenu"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTable.js(7582): openHeaderActionMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(7583): openHeaderActionMenu"); };

	oCellInfo = this["oGetCellInfoByDomRef"](UCF_DomUtil["$"](sCellId));

	if (oCellInfo && oCellInfo["oDomRefCell"]["getAttribute"]('actMenuId')) {
		this["bOpenHeaderActionMenuInternal"](oCellInfo, false, bWithKeyboard);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["openHeaderActionMenu"] = 0; };

/**
 * The handler which closes a opened Action window
 *
 * @private
 * @param {UCF_Event} oEvent
 */
UCF_SapTable["prototype"]["onHeaderActionMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onHeaderActionMenuClose"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "SapTable.js(7602): onHeaderActionMenuClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "SapTable.js(7603): onHeaderActionMenuClose"); };

	oCellInfo = this["oGetCellInfoByDomRef"](
		UCF_DomUtil["$"](this["sLastHeaderActionMenu"])
	);

	if (oCellInfo) {
		this["setCellMatrixFocusByCellInfo"](oCellInfo);
	}

	this["cleanUpHeaderActionMenu"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onHeaderActionMenuClose"] = 0; };

/**
 * Cleans up the action menu handling
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpHeaderActionMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpHeaderActionMenu"]++; }; 
	if (this["oHeaderActionMenu"]) {
		this["oHeaderActionMenu"]["detachEvent"](
			this["oHeaderActionMenu"]["E_EVENTS"]["Close"],
			this
		);
		this["oHeaderActionMenu"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpHeaderActionMenu"] = 0; };

/******************************************************
 ** SELECTION MENU
 *******************************************************/

/**
 * Open selection menu
 *
 * @private
 * @param {string} sSelectionMenuId
 * @param {HTMLElement} oDomRefMenuIcon
 * @param {boolean} bWithKeyboard
 */
UCF_SapTable["prototype"]["openSelectionMenu"] = function(sSelectionMenuId, oDomRefMenuIcon, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["openSelectionMenu"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSelectionMenuId != null, "sSelectionMenuId != null", "SapTable.js(7644): openSelectionMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sSelectionMenuId === 'string', "typeof sSelectionMenuId === 'string'", "SapTable.js(7645): openSelectionMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefMenuIcon != null, "oDomRefMenuIcon != null", "SapTable.js(7646): openSelectionMenu"); };

	if (!this["oSelectionMenu"]) {
		this["oSelectionMenu"] = this["oGetControlById"](sSelectionMenuId);

		this["oSelectionMenu"]["setOpenerRef"](oDomRefMenuIcon);
		this["oSelectionMenu"]["setOpenerId"](this["sId"]);
		this["oSelectionMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);

		this["oSelectionMenu"]["attachEvent"](
			this["oSelectionMenu"]["E_EVENTS"]["Select"],
			this,
			'onSelectionMenuItemSelect'
		);
		this["oSelectionMenu"]["attachEvent"](
			this["oSelectionMenu"]["E_EVENTS"]["Close"],
			this,
			'onSelectionMenuClose'
		);

		this["oSelectionMenu"]["open"](bWithKeyboard);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["openSelectionMenu"] = 0; };

/**
 * Clean up selection menu
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpSelectionMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpSelectionMenu"]++; }; 
	if (this["oSelectionMenu"]) {
		this["oSelectionMenu"]["detachEvent"](this["oSelectionMenu"]["E_EVENTS"]["Select"], this);
		this["oSelectionMenu"]["detachEvent"](this["oSelectionMenu"]["E_EVENTS"]["Close"], this);
		this["oSelectionMenu"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpSelectionMenu"] = 0; };

/**
 * Handle event
 *
 * @private
 * @param {UCF_Event} oEvent
 */
UCF_SapTable["prototype"]["onSelectionMenuItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onSelectionMenuItemSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "SapTable.js(7690): onSelectionMenuItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "SapTable.js(7691): onSelectionMenuItemSelect"); };

	this["focusSelectionMenuOpener"]();
	this["fireSelectionMenuItemSelect"](this["sId"], oEvent["oGetParam"]('sItemId'));
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onSelectionMenuItemSelect"] = 0; };

/**
 * Handle event
 *
 * @private
 * @param {UCF_Event} oEvent
 */
UCF_SapTable["prototype"]["onSelectionMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onSelectionMenuClose"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "SapTable.js(7704): onSelectionMenuClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "SapTable.js(7705): onSelectionMenuClose"); };

	this["focusSelectionMenuOpener"]();
	this["cleanUpSelectionMenu"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onSelectionMenuClose"] = 0; };

/**
 * Focuses the trigger button for the selection menu
 *
 * @private
 */
UCF_SapTable["prototype"]["focusSelectionMenuOpener"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["focusSelectionMenuOpener"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo = this["oGetSelectionMenuCell"]();

	if (oCellInfo) {
		this["setCellMatrixFocusByCellInfo"](oCellInfo);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["focusSelectionMenuOpener"] = 0; };

/******************************************************
 ** SCROLLBARS
 *******************************************************/

/**
 * Initialize scroll bars
 *
 * @private
 */
UCF_SapTable["prototype"]["initScrollbars"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initScrollbars"]++; }; 
	// !!!! This method is overwritten by SapTableCS

	this["oScrollV"] = this["oGetControlById"](this["sId"] + '-' + this["SUFFIX"]["SCROLL_V"]);
	this["oScrollH"] = this["oGetControlById"](this["sId"] + '-' + this["SUFFIX"]["SCROLL_H"]);

	if (this["oScrollV"]) {
		this["oScrollV"]["attachEvent"](
			this["oScrollV"]["E_EVENTS"]["Scroll"],
			this,
			'onScrollV'
		);
	}

	if (this["oScrollH"]) {
		this["oScrollH"]["attachEvent"](
			this["oScrollH"]["E_EVENTS"]["Scroll"],
			this,
			'onScrollH'
		);
	}

	this["bInitializeHorizontalScrollbar"] = this["oScrollH"] &&
		this["sHorizontalScrollUpdateMode"] === this["SCROLL_UPDATE_MODE"]["CLIENT"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initScrollbars"] = 0; };

/**
 * Clean up scrollbars
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpScrollbars"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpScrollbars"]++; }; 
	if (this["oScrollV"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollV"]);
		this["oScrollV"] = null;
	}
	if (this["oScrollH"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollH"]);
		this["oScrollH"] = null;
	}

	this["bScrollingByKeyboardLocked"] = false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpScrollbars"] = 0; };

/******************************************************
 ** CELL MATRIX CALCULATION
 *******************************************************/

/**
 * Initialize cell info matrix
 *
 * @private
 */
UCF_SapTable["prototype"]["initCellInfoMatrix"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initCellInfoMatrix"]++; }; 
	// !!!! This method is overwritten by SapTableCS
	/** @type {HTMLCollectionOf<HTMLTableRowElement>|[]} */
	var aDomRefRows = this["aGetContentTableRows"]();
	/** @type {number} */
	var iRowIndex;

	this["initCellInfoMatrixHeadData"]();

	for (iRowIndex = 0; iRowIndex < aDomRefRows["length"]; iRowIndex++) {
		this["addCellInfoMatrixRow"](
			this["aGetContentTableRowCells"](aDomRefRows[iRowIndex]),
			iRowIndex
		);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initCellInfoMatrix"] = 0; };

/**
 * Initialize cell info matrix head data
 *
 * @private
 */
UCF_SapTable["prototype"]["initCellInfoMatrixHeadData"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initCellInfoMatrixHeadData"]++; }; 
	this["mCellInfoMatrixHeadData"] = {
		"iFocussedCellRowIndex": -1,
		"iFocussedCellColIndex": -1
	};
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initCellInfoMatrixHeadData"] = 0; };

/**
 * Adds the cell infos for a dom row
 *
 * @private
 * @param {HTMLCollectionOf<HTMLTableDataCellElement|HTMLTableHeaderCellElement>} aDomRefCells
 * @param {number} iRowIndex
 */
UCF_SapTable["prototype"]["addCellInfoMatrixRow"] = function(aDomRefCells, iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["addCellInfoMatrixRow"]++; }; 
	/** @type {number} */
	var iColIndex;
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (aDomRefCells) {
		for (iColIndex = 0; iColIndex < aDomRefCells["length"]; iColIndex++) {
			oCellInfo = this["oCreateCellInfo"](aDomRefCells[iColIndex]);

			this["appendCellInfo"](iRowIndex, oCellInfo);

			if (this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["HEADER_CELL"]) {
				this["checkAndPrepareDataTip"](oCellInfo);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["addCellInfoMatrixRow"] = 0; };

/**
 * Clean up cell info matrix
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpCellInfoMatrix"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpCellInfoMatrix"]++; }; 
	this["aCellInfoMatrix"] = null;
	this["mCellInfoMatrixHeadData"] = null;
	this["mDataTips"] = {};
	this["cleanUpUnmarkHandler"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpCellInfoMatrix"] = 0; };

/**
 * Before a cell and its cell info is accessed this method is called to give
 * the tabel the chance to update a or complete cell specific HTML or data
 *
 * @private
 * @param {number} iRowIndex
 * @param {number} iColIndex
 */
UCF_SapTable["prototype"]["prepareCellMatrixAccess"] = function(iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["prepareCellMatrixAccess"]++; }; 
	// !!!! This method is overwritten by SapTableCS
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["prepareCellMatrixAccess"] = 0; };

/**
 * Get cell info
 *
 * @private
 * @param {number} iRowIndex
 * @param {number} iColIndex
 * @return {UCF_SapTable_CellInfo}
 */
UCF_SapTable["prototype"]["oGetCellInfo"] = function(iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetCellInfo"]++; }; 
	if (this["bIsValidCellInfoMatrixPosition"](iRowIndex, iColIndex)) {
		this["prepareCellMatrixAccess"](iRowIndex, iColIndex);

		return this["aCellInfoMatrix"][iRowIndex][iColIndex];
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetCellInfo"] = 0; };

/**
 * Returns the public cell interface of a cell with the given col and row index
 *
 * @public
 * @param {number} iRowIndex
 * @param {number} iColIndex
 * @return {UCF_SapTableBaseCell}
 */
UCF_SapTable["prototype"]["getCell"] = function(iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getCell"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex);

	return this["oGetCellControlInfo"](oCellInfo);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getCell"] = 0; };

/**
 * Returns the public cell interface of a cell for the given dom ref
 *
 * @public
 * @param {HTMLElement} oDomRef
 * @return {UCF_SapTableBaseCell}
 */
UCF_SapTable["prototype"]["getCellByDomRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getCellByDomRef"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo = this["oGetCellInfoByDomRef"](oDomRef);

	return oCellInfo
		? this["getCell"](oCellInfo["iRowIndex"], oCellInfo["iColIndex"])
		: null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getCellByDomRef"] = 0; };

/**
 * Returns the sub control for the given dom ref
 *
 * @private
 * @param {HTMLElement} oDomRef
 * @return {UCF_SapTableBaseCell}
 */
UCF_SapTable["prototype"]["oGetSubControlByDomRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSubControlByDomRef"]++; }; 
	/** @type {UCF_SapTableBaseCell} */
	var oSubControl = this["getCellByDomRef"](oDomRef);

	return oSubControl || null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSubControlByDomRef"] = 0; };

/**
 * Returns the public cell interface of a cell with the given col and row index
 * if it is a data cell
 *
 * @private
 * @param {number} iRowIndex
 * @param {number} iColIndex
 * @return {UCF_SapTable_DataCell}
 * of type UCF_SapTableCell, UCF_SapTableHierarchicalCell,
 * UCF_SapTableMatrixCell
 */
UCF_SapTable["prototype"]["oGetDataCell"] = function(iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetDataCell"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex);

	return this["bIsDataTableCell"](oCellInfo["eCellType"])
		? this["oGetCellControlInfo"](oCellInfo)
		: null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetDataCell"] = 0; };

/**
 * Returns the next cell info
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {UCF_SapTable_CellInfo}
 */
UCF_SapTable["prototype"]["oGetNextCellInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetNextCellInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(7957): oGetNextCellInfo"); };

	return (
			oCellInfo["iColIndex"] + oCellInfo["iColSpan"] <=
			this["iGetCellInfoMatrixLastColIndex"]()
		)
		? this["oGetCellInfo"](
			oCellInfo["iRowIndex"],
			oCellInfo["iColIndex"] + oCellInfo["iColSpan"]
		)
		: (oCellInfo["iRowIndex"] + 1 <= this["iGetCellInfoMatrixLastRowIndex"]())
		? this["oGetCellInfo"](oCellInfo["iRowIndex"] + 1, 0)
		: null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetNextCellInfo"] = 0; };

/**
 * Returns the next cell info
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {UCF_SapTable_CellInfo}
 */
UCF_SapTable["prototype"]["oGetPreviousCellInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetPreviousCellInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(7980): oGetPreviousCellInfo"); };

	return (oCellInfo["iColIndex"] > 0)
		? this["oGetCellInfo"](oCellInfo["iRowIndex"], oCellInfo["iColIndex"] - 1)
		: (oCellInfo["iRowIndex"] > 0)
		? this["oGetCellInfo"](
			oCellInfo["iRowIndex"] - 1,
			this["iGetCellInfoMatrixLastColIndex"]()
		)
		: null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetPreviousCellInfo"] = 0; };

/**
 * True if the cell info exits and is connected to the dom
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bIsValidCellInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsValidCellInfo"]++; }; 
	return !!(oCellInfo && oCellInfo["oDomRefCell"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsValidCellInfo"] = 0; };

/**
 * @private
 * @param {number} iRowIndex
 * @param {number} iColIndex
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bIsValidCellInfoMatrixPosition"] = function(iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsValidCellInfoMatrixPosition"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!isNaN(iRowIndex), "!isNaN(iRowIndex)", "SapTable.js(8010): bIsValidCellInfoMatrixPosition"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!isNaN(iColIndex), "!isNaN(iColIndex)", "SapTable.js(8011): bIsValidCellInfoMatrixPosition"); };

	return this["aCellInfoMatrix"] &&
		this["aCellInfoMatrix"][iRowIndex] &&
		this["aCellInfoMatrix"][iRowIndex][iColIndex];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsValidCellInfoMatrixPosition"] = 0; };

/**
 * Returns an array of all CellInfos in a column
 *
 * @private
 * @param {number} iColIndex The internal matrix column index
 * @return {UCF_SapTable_CellInfo[]} The array of the resulting CellInfos
 */
UCF_SapTable["prototype"]["aGetCellInfosOfColumn"] = function(iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetCellInfosOfColumn"]++; }; 
	/** @type {UCF_SapTable_CellInfo[]} */
	var aCellInfos;
	/** @type {number} */
	var iRowIndex;
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrCellInfo;
	/** @type {number} */
	var iRowLength;
	/** @type {number} */
	var iRowStartIndex;
	/** @type {number} */
	var iRowEndIndex;
	/** @type {number} */
	var i;
	/** @type {boolean} */
	var bHeaderIncluded = false;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iColIndex === 'number', "typeof iColIndex === 'number'", "SapTable.js(8043): aGetCellInfosOfColumn"); };

	if (this["iGetCellInfoMatrixLastColIndex"]() < iColIndex) {
		return [];
	} else {
		aCellInfos = [];
		if (this["bCanDataRequest"]() && this["oDataRequestInfo"] && this["oDataRequestInfo"]["aRowsLoadedRanges"]) {
			for (i = 0; i < this["oDataRequestInfo"]["aRowsLoadedRanges"]["length"]; i++) {
				iRowStartIndex = this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] === 0 ? 0 : this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] + this["iGetContentRowOffset"]();
				if (iRowStartIndex === 0) bHeaderIncluded = true;
				iRowEndIndex = this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] + this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentLength"];
				for (iRowIndex = iRowStartIndex; iRowIndex <= iRowEndIndex; iRowIndex++) {
					oCurrCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex);
					if (this["bIsValidCellInfo"](oCurrCellInfo)) aCellInfos[aCellInfos["length"]] = oCurrCellInfo;
				}
			}
			// alway add header row
			if (this["bHasHeaderRow"]() && !bHeaderIncluded) {
				oCurrCellInfo = this["oGetCellInfo"](0, iColIndex);
				if (this["bIsValidCellInfo"](oCurrCellInfo)) aCellInfos[aCellInfos["length"]] = oCurrCellInfo;
			}
		}
		else {
			iRowIndex = 0;
			oCurrCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex);
			iRowLength = this["iGetCellInfoMatrixLastRowIndex"]() + 1;
			while (iRowIndex < iRowLength) {
				if (this["bIsValidCellInfo"](oCurrCellInfo)) {
					aCellInfos[aCellInfos["length"]] = oCurrCellInfo;
					iRowIndex += oCurrCellInfo["iRowSpan"];
				} else {
					iRowIndex++;
				}
				oCurrCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex);
			}
		}

		return aCellInfos;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetCellInfosOfColumn"] = 0; };

/**
 * Returns an array of all CellInfos in a row
 *
 * @private
 * @param {number} iRowIndex The internal matrix row index
 * @return {UCF_SapTable_CellInfo[]} The array of the resulting CellInfos
 */
UCF_SapTable["prototype"]["aGetCellInfosOfRow"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetCellInfosOfRow"]++; }; 
	/** @type {UCF_SapTable_CellInfo[]} */
	var aCellInfos;
	/** @type {number} */
	var iColIndex;
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iRowIndex === 'number', "typeof iRowIndex === 'number'", "SapTable.js(8099): aGetCellInfosOfRow"); };

	if (this["iGetCellInfoMatrixLastRowIndex"]() < iRowIndex) {
		return [];
	} else {
		aCellInfos = [];
		iColIndex = 0;
		oCurrCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex);

		while (oCurrCellInfo != null) {
			aCellInfos[aCellInfos["length"]] = oCurrCellInfo;
			iColIndex += oCurrCellInfo["iColSpan"];
			oCurrCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex);
		}

		return aCellInfos;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetCellInfosOfRow"] = 0; };

/**
 * Returns an array of all TR tags usde in the given row
 *
 * @private
 * @param {number} iRowIndex The internal matrix row index
 * @return {HTMLTableRowElement[]} The array
 */
UCF_SapTable["prototype"]["aGetDomRefsOfRows"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetDomRefsOfRows"]++; }; 
	/** @type {HTMLTableRowElement[]} */
	var aRowDomRefsOfRow;
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iRowIndex === 'number', "typeof iRowIndex === 'number'", "SapTable.js(8131): aGetDomRefsOfRows"); };

	if (this["iGetCellInfoMatrixLastRowIndex"]() < iRowIndex) {
		return [];
	} else {
		aRowDomRefsOfRow = [];
		oCurrCellInfo = this["oGetCellInfo"](iRowIndex, 0);

		if (oCurrCellInfo) {
			aRowDomRefsOfRow["push"](oCurrCellInfo["oDomRefRow"]);
		}

		return aRowDomRefsOfRow;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetDomRefsOfRows"] = 0; };

/**
 * Returns the last possible matric row index
 *
 * @private
 * @return {number}
 */
UCF_SapTable["prototype"]["iGetCellInfoMatrixLastRowIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetCellInfoMatrixLastRowIndex"]++; }; 
	return this["aCellInfoMatrix"] ? this["aCellInfoMatrix"]["length"] - 1 : -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetCellInfoMatrixLastRowIndex"] = 0; };

/**
 * Returns the last possible matric column index
 *
 * @private
 * @return {number}
 */
UCF_SapTable["prototype"]["iGetCellInfoMatrixLastColIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetCellInfoMatrixLastColIndex"]++; }; 
	return this["aCellInfoMatrix"] ? this["aCellInfoMatrix"][0]["length"] - 1 : -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetCellInfoMatrixLastColIndex"] = 0; };

/**
 * Get cell info by DOM reference
 *
 * @private
 * @param {HTMLElement} oDomRefCell
 * @return {UCF_SapTable_CellInfo}
 */
UCF_SapTable["prototype"]["oGetCellInfoByDomRef"] = function(oDomRefCell) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetCellInfoByDomRef"]++; }; 
	/** @type {HTMLTableDataCellElement} */
	var oCurrDomRefCell;
	/** @type {string} */
	var sLsDomRedirectParent;
	/** @type {HTMLElement} */
	var oLsDomRedirectParent;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefCell != null, "oDomRefCell != null", "SapTable.js(8182): oGetCellInfoByDomRef"); };

	oCurrDomRefCell = oDomRefCell;

	while (
		oCurrDomRefCell &&
		oCurrDomRefCell["tagName"] !== 'BODY' &&
		oCurrDomRefCell !== this["oDomRef"]
	) {
		if (this["bHasCellInfoByDomRef"](oCurrDomRefCell)) {
			return this["oGetCellInfo"](
				oCurrDomRefCell["lsMatrixRowIndex"],
				oCurrDomRefCell["lsMatrixColIndex"]
			);
		}

		sLsDomRedirectParent = oCurrDomRefCell["getAttribute"]
			? oCurrDomRefCell["getAttribute"]('lsDomRedirectParent')
			: null;
		oLsDomRedirectParent = sLsDomRedirectParent
			? UCF_DomUtil["$"](sLsDomRedirectParent)
			: null;
		oCurrDomRefCell = oLsDomRedirectParent || oCurrDomRefCell["parentNode"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetCellInfoByDomRef"] = 0; };

/**
 * Has cell info
 *
 * @private
 * @param {HTMLElement} oDomRefCell
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bHasCellInfoByDomRef"] = function(oDomRefCell) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasCellInfoByDomRef"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefCell != null, "oDomRefCell != null", "SapTable.js(8218): bHasCellInfoByDomRef"); };

	this["synchronizeCellRenderRepresentation"](oDomRefCell);

	return !isNaN(oDomRefCell["lsMatrixRowIndex"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasCellInfoByDomRef"] = 0; };

/**
 * Normalizes the access to matrix info given by the DOM
 *
 * @param {HTMLElement} oDomRefCell
 * @private
 */
UCF_SapTable["prototype"]["synchronizeCellRenderRepresentation"] = function(oDomRefCell) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["synchronizeCellRenderRepresentation"]++; }; 
	if (
		oDomRefCell &&
		typeof oDomRefCell["lsMatrixRowIndex"] !== 'number' &&
		oDomRefCell["getAttribute"] &&
		oDomRefCell["getAttribute"]('lsMatrixRowIndex') != null
	) {
		oDomRefCell["lsMatrixRowIndex"] = parseInt(
			oDomRefCell["getAttribute"]('lsMatrixRowIndex')
		);
		oDomRefCell["lsMatrixColIndex"] = parseInt(
			oDomRefCell["getAttribute"]('lsMatrixColIndex')
		);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["synchronizeCellRenderRepresentation"] = 0; };

/**
 * Create cell info or applies a passed void cell info object
 *
 * @private
 * @param {HTMLElement} [oDomRefCell]
 * @param {UCF_SapTable_CellInfo} [oCellInfo]
 * @return {UCF_SapTable_CellInfo}
 */
UCF_SapTable["prototype"]["oCreateCellInfo"] = function(oDomRefCell, oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oCreateCellInfo"]++; }; 
	if (!oCellInfo) {
		// Initial state
		oCellInfo = {
			"oDomRefCell": null,
			"oDomRefRow": null,
			"eCellType": this["SUBCONTROL"]["NONE"],
			"iRowSpan": 1,
			"iColSpan": 1,
			"iRowIndex": -1,
			"iColIndex": -1,
			"iSelectionState": this["SELECTION_LAYER"]["NONE"]
		};
	}

	if (oDomRefCell) {
		oCellInfo["oDomRefCell"] = oDomRefCell;
		oCellInfo["oDomRefRow"] = oDomRefCell["parentNode"];

		if (oDomRefCell["getAttribute"]('lsRowSpan')) {
			oCellInfo["iRowSpan"] = parseInt(oDomRefCell["getAttribute"]('lsRowSpan'), 10);
		}
		if (oDomRefCell["getAttribute"]('lsColSpan')) {
			oCellInfo["iColSpan"] = parseInt(oDomRefCell["getAttribute"]('lsColSpan'), 10);
		}
		oCellInfo["eCellType"] = oDomRefCell["getAttribute"]('subct');
	}

	return oCellInfo;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oCreateCellInfo"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {string} user data for row
 */
UCF_SapTable["prototype"]["sGetRowUserData"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowUserData"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(8292): sGetRowUserData"); };

	return (oCellInfo["oDomRefRow"] && oCellInfo["oDomRefRow"]["getAttribute"]('uDat'))
		? oCellInfo["oDomRefRow"]["getAttribute"]('uDat')
		: '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowUserData"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {string} user data for a cell
 */
UCF_SapTable["prototype"]["sGetCellUserData"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetCellUserData"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(8305): sGetCellUserData"); };

	return (oCellInfo["oDomRefCell"] && oCellInfo["oDomRefCell"]["getAttribute"]('uDat'))
		? oCellInfo["oDomRefCell"]["getAttribute"]('uDat')
		: '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetCellUserData"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {string} the ID of the cell or "" when cell does not exits or cell
 * has no ID
 */
UCF_SapTable["prototype"]["sGetCellId"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetCellId"]++; }; 
	return (
			this["bIsValidCellInfo"](oCellInfo) &&
			oCellInfo["oDomRefCell"]["getAttribute"]('id')
		)
		? oCellInfo["oDomRefCell"]["getAttribute"]('id')
		: '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetCellId"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {UCF_SapTable_CellType} the type of a given cell
 */
UCF_SapTable["prototype"]["eGetCellType"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["eGetCellType"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(8333): eGetCellType"); };

	return oCellInfo["eCellType"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["eGetCellType"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {UCF_Control} the first child control within a cell content
 */
UCF_SapTable["prototype"]["oGetFirstCellControl"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetFirstCellControl"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefContentContainer = this["oDomRefGetCellContentContainer"](oCellInfo);
	/** @type {HTMLElement} */
	var oDomRef = oDomRefContentContainer
		? UCF_DomUtil["oGetFirstChildByAttribute"](oDomRefContentContainer, 'ct')
		: null;

	return oDomRef
		? this["oLS"]["oGetControlByDomRef"](oDomRef)
		: null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetFirstCellControl"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {UCF_Control} the last child control within a cell content.
 */
UCF_SapTable["prototype"]["oGetLastCellControl"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetLastCellControl"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefContentContainer = this["oDomRefGetCellContentContainer"](oCellInfo);
	/** @type {HTMLElement} */
	var oDomRef = oDomRefContentContainer
		? UCF_DomUtil["oGetLastChildByAttribute"](oDomRefContentContainer, 'ct')
		: null;

	return oDomRef
		? this["oLS"]["oGetControlByDomRef"](oDomRef)
		: null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetLastCellControl"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {HTMLElement} the root DOM reference of the cell content
 */
UCF_SapTable["prototype"]["oDomRefGetCellContent"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oDomRefGetCellContent"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefContentContainer = this["oDomRefGetCellContentContainer"](oCellInfo);

	return (oDomRefContentContainer)
		? UCF_DomUtil["oGetFirstElement"](oDomRefContentContainer)
		: null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oDomRefGetCellContent"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {HTMLElement} the reference of container which conatins the cell content
 */
UCF_SapTable["prototype"]["oDomRefGetCellContentContainer"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oDomRefGetCellContentContainer"]++; }; 
	/** @type {UCF_SapTable_CellType} */
	var eCellType = this["eGetCellType"](oCellInfo);
	/** @type {UCF_SapTable_CellInfoDomRefCell} */
	var oDomRefContentContainer;
	/** @type {HTMLTableElement} */
	var oFirstElement;
	/** @type {HTMLCollectionOf<HTMLTableDataCellElement|HTMLTableHeaderCellElement>} */
	var aDomRefCells;
	/** @type {number} */
	var i;

	if (
		eCellType === this["SUBCONTROL"]["STANDARD_CELL"] ||
		eCellType === this["SUBCONTROL"]["HIERARCHY_CELL"]
	) {
		oDomRefContentContainer = oCellInfo["oDomRefCell"];

		if (eCellType === this["SUBCONTROL"]["HIERARCHY_CELL"]) {
			oFirstElement = UCF_DomUtil["oGetFirstElement"](oCellInfo["oDomRefCell"]);
			aDomRefCells = oFirstElement["rows"][0]["cells"];

			for (i = 0; i < aDomRefCells["length"]; i++) {
				if (aDomRefCells[i]["style"]["width"] === '100%') {
					oDomRefContentContainer = aDomRefCells[i];
					break;
				}
			}
		}

		if (oDomRefContentContainer) {
			return oDomRefContentContainer;
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oDomRefGetCellContentContainer"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {number} hierarchy level of a cell. 0 means root level
 */
UCF_SapTable["prototype"]["iGetCellHierarchyLevel"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetCellHierarchyLevel"]++; }; 
	return (
			oCellInfo &&
			this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["HIERARCHY_CELL"]
		)
		? Math["max"](0, parseInt(oCellInfo["oDomRefCell"]["getAttribute"]('lv'), 10))
		: 0;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetCellHierarchyLevel"] = 0; };

/**
 * Checks the given cell for CellType HeaderCell
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oHeaderCellInfo
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bIsColumnHeader"] = function(oHeaderCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsColumnHeader"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oHeaderCellInfo != null, "oHeaderCellInfo != null", "SapTable.js(8453): bIsColumnHeader"); };

	// Standard header type
	return oHeaderCellInfo["oDomRefCell"]["getAttribute"]('headerType') === 'S';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsColumnHeader"] = 0; };

/**
 * Checks the dimensions of a header cell and tries to correct them if necessary.
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oHeaderCellInfo
 */
UCF_SapTable["prototype"]["checkHeaderCellDimensions"] = function(oHeaderCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHeaderCellDimensions"]++; }; 
	// Corection of resizeHandle position: When icons fragments(sort, filter
	// etc.) are used the resize handle could be missplaced when column is too
	// small and inner content table pushes over the cells dimensions

	/** @type {HTMLElement} */
	var oDomRefContentTable = UCF_DomUtil["oGetFirstElement"](
		oHeaderCellInfo["oDomRefCell"]
	);
	/** @type {HTMLElement} */
	var oDomRefResizerHandle = UCF_DomUtil["$"](
		this["sGetCellId"](oHeaderCellInfo) + '-' + this["SUFFIX"]["RESIZE_HANDLE"]
	);
	/** @type {number} */
	var iTruncationDiff;
	/** @type {number} */
	var iHandleOffset;
	/** @type {HTMLElement} */
	var oInnerHandle;

	if (oDomRefContentTable && oDomRefResizerHandle) {
		iTruncationDiff = (
			oDomRefContentTable["offsetWidth"] +
			// eslint-disable-next-line no-magic-numbers
			oDomRefContentTable["offsetLeft"] * 2
		) - oHeaderCellInfo["oDomRefCell"]["offsetWidth"];
		iHandleOffset = 0;

		if (iTruncationDiff > 0) {
			iHandleOffset = iTruncationDiff;
		}

		if (oDomRefResizerHandle["iHandleOffset"] !== iHandleOffset) {
			oInnerHandle = UCF_DomUtil["oGetFirstElement"](oDomRefResizerHandle);

			UCF_DomUtil["setStyle"](
				oInnerHandle,
				window["UCF_System"]["bIsRTL"] ? 'left' : 'right',
				// eslint-disable-next-line no-magic-numbers
				(iHandleOffset - Math["round"](oInnerHandle["offsetWidth"] / 2)) + 'px'
			);

			oDomRefResizerHandle["iHandleOffset"] = iHandleOffset;
		}

	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkHeaderCellDimensions"] = 0; };

/**
 * @private
 * @param {HTMLElement} oDomRefCell
 * @return {UCF_SapTable_CellInfo} the corresponding HeaderCell for the give
 * html cell
 */
UCF_SapTable["prototype"]["oGetHeaderCellInfoByDomRef"] = function(oDomRefCell) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetHeaderCellInfoByDomRef"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefCell != null, "oDomRefCell != null", "SapTable.js(8523): oGetHeaderCellInfoByDomRef"); };

	oCellInfo = this["oGetCellInfoByDomRef"](oDomRefCell);

	return oCellInfo ? this["oGetHeaderCellInfoByCellInfo"](oCellInfo) : null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetHeaderCellInfoByDomRef"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {UCF_SapTable_CellInfo} the corresponding HeaderCell for the given
 * cell
 */
UCF_SapTable["prototype"]["oGetHeaderCellInfoByCellInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetHeaderCellInfoByCellInfo"]++; }; 
	/** @type {number} */
	var iColIndex;

	if (oCellInfo == null) {
		return null;
	}

	iColIndex = oCellInfo["iColIndex"];

	while (
		oCellInfo != null &&
		this["eGetCellType"](oCellInfo) !== this["SUBCONTROL"]["HEADER_CELL"]
	) {
		oCellInfo = this["oGetCellInfo"](oCellInfo["iRowIndex"] - 1, iColIndex);
	}

	return oCellInfo;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetHeaderCellInfoByCellInfo"] = 0; };

/**
 * @private
 * @param {HTMLElement} oDomRefCell
 * @return {UCF_SapTable_CellInfo} the corresponding SelectionCell for the
 * given html cell
 */
UCF_SapTable["prototype"]["oGetSelectionCellInfoByDomRef"] = function(oDomRefCell) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSelectionCellInfoByDomRef"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCell;
	/** @type {UCF_SapTable_CellInfo} */
	var oSelectionCell;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefCell != null, "oDomRefCell != null", "SapTable.js(8568): oGetSelectionCellInfoByDomRef"); };

	oCell = this["oGetCellInfoByDomRef"](oDomRefCell);

	if (oCell) {
		oSelectionCell = this["oGetCellInfo"](oCell["iRowIndex"], 0);

		if (
			oSelectionCell &&
			this["eGetCellType"](oSelectionCell) === this["SUBCONTROL"]["SELECTION_CELL"]
		) {
			return oSelectionCell;
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSelectionCellInfoByDomRef"] = 0; };

/**
 * @private
 * @return {UCF_SapTable_CellInfo} the CellInfo of the header cell which has a
 * nested selection menu
 */
UCF_SapTable["prototype"]["oGetSelectionMenuCell"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSelectionMenuCell"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrCellInfo = this["oGetCellInfo"](0, 0);

	while (oCurrCellInfo != null) {
		if (oCurrCellInfo["oDomRefCell"]["getAttribute"]('hasSelMenu')) {
			return oCurrCellInfo;
		}

		oCurrCellInfo = this["oGetCellInfo"](
			oCurrCellInfo["iRowIndex"] + oCurrCellInfo["iRowSpan"],
			0
		);
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSelectionMenuCell"] = 0; };

/**
 * Add cell info
 *
 * @private
 * @param {number} iRowIndex
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["appendCellInfo"] = function(iRowIndex, oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["appendCellInfo"]++; }; 
	/** @type {number} */
	var iRow;
	/** @type {number} */
	var iCol;

	if (!this["aCellInfoMatrix"]) {
		this["aCellInfoMatrix"] = [];
	}
	if (!this["aCellInfoMatrix"][iRowIndex]) {
		this["aCellInfoMatrix"][iRowIndex] = [];
	}

	oCellInfo["iRowIndex"] = iRowIndex;
	oCellInfo["iColIndex"] = this["iGetNextAvailableSlotIndex"](
		this["aCellInfoMatrix"][iRowIndex]
	);
	oCellInfo["oDomRefCell"]["lsMatrixRowIndex"] = oCellInfo["iRowIndex"];
	oCellInfo["oDomRefCell"]["lsMatrixColIndex"] = oCellInfo["iColIndex"];

	for (iRow = oCellInfo["iRowIndex"]; iRow < oCellInfo["iRowIndex"] + oCellInfo["iRowSpan"]; iRow++) {
		if (!this["aCellInfoMatrix"][iRow]) {
			this["aCellInfoMatrix"][iRow] = [];
		}

		for (iCol = oCellInfo["iColIndex"]; iCol < oCellInfo["iColIndex"] + oCellInfo["iColSpan"]; iCol++) {
			this["aCellInfoMatrix"][iRow][iCol] = oCellInfo;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["appendCellInfo"] = 0; };

/**
 * @private
 * @param {any[] & {iLastFoundSlotIndex?: number}} aArray
 * @return {number} the next available slot index in matrix
 */
UCF_SapTable["prototype"]["iGetNextAvailableSlotIndex"] = function(aArray) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetNextAvailableSlotIndex"]++; }; 
	/** @type {number} */
	var iLastFoundSlotIndex = 0;
	/** @type {number} */
	var i;

	if (aArray["iLastFoundSlotIndex"]) {
		iLastFoundSlotIndex = aArray["iLastFoundSlotIndex"];
	}

	for (i = iLastFoundSlotIndex; i < aArray["length"]; i++) {
		if (!aArray[i]) {
			break;
		}
	}

	aArray["iLastFoundSlotIndex"] = i;

	return i;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetNextAvailableSlotIndex"] = 0; };

/**
 * Get content table rows
 *
 * @private
 * @return {HTMLCollectionOf<HTMLTableRowElement>|[]}
 */
UCF_SapTable["prototype"]["aGetContentTableRows"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetContentTableRows"]++; }; 
	/** @type {HTMLTableElement} */
	var oDomRef = UCF_DomUtil["$"](this["sId"] + '-' + this["SUFFIX"]["CONTENT_TBODY"]);

	return oDomRef == null ? [] : oDomRef["rows"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetContentTableRows"] = 0; };

/**
 * Get content table row cells
 *
 * @private
 * @param {HTMLTableRowElement} oDomRefRow
 * @return {HTMLCollectionOf<HTMLTableDataCellElement|HTMLTableHeaderCellElement>}
 */
UCF_SapTable["prototype"]["aGetContentTableRowCells"] = function(oDomRefRow) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetContentTableRowCells"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefRow != null, "oDomRefRow != null", "SapTable.js(8694): aGetContentTableRowCells"); };

	return oDomRefRow["cells"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetContentTableRowCells"] = 0; };

/**
 * Get first child by tag name
 *
 * @private
 * @param {HTMLElement} oDomRefParent
 * @param {string} sTagName
 * @return {HTMLElement}
 */
UCF_SapTable["prototype"]["oDomRefGetFirstChildByTagName"] = function(oDomRefParent, sTagName) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oDomRefGetFirstChildByTagName"]++; }; 
	/** @type {number} */
	var i;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefParent != null, "oDomRefParent != null", "SapTable.js(8711): oDomRefGetFirstChildByTagName"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTagName != null, "sTagName != null", "SapTable.js(8712): oDomRefGetFirstChildByTagName"); };

	for (i = 0; i < oDomRefParent["childNodes"]["length"]; i++) {
		if (oDomRefParent["childNodes"][i]["tagName"] === sTagName["toUpperCase"]()) {
			return oDomRefParent["childNodes"][i];
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oDomRefGetFirstChildByTagName"] = 0; };

/**
 * ROW/COL INDEX CONVERSION
 * There is an internal row and column index of the cell matrix. This is an
 * internal index which is never propagated to external. When the application
 * is receiving a RowIndex it is the row index defined on the API of the row.
 * So this index is application defined. It is set by the application and again
 * received by the application. The only usage on our side was to announce the
 * set index in 508 mode. This index was very flexible. The application can set
 * it randomly in arbitrary order and it was even allowed to set the same row
 * index for different rows (this can be useful for Popins). The only index
 * which was defined by a contract of the application and LS was the
 * FirstVisibleRow. In the SapTable this index is not zero based and starts
 * with "1".
 *
 * With introduction of client side selection we needed on the client side a
 * reference index which is defining the start point of a range selection. This
 * has to be set by the application. Due to the application does not know
 * anything about our internal row indices it can define that by a app defined
 * index and our internal coding is searching for the corresponding internal
 * index to apply the selection.
 *
 * With introduction of the SapTableCS we tried to keep these approaches but we
 * switched the FirstVisibleRowIndex to a zero based index to make it more
 * conform with other frameworks. We realized that the searching of the
 * internal index by an application defined index takes often too long but we
 * take that performance disadvantage in the selection operations because we
 * know that a SapTableCS does usually not contain more than 100 rows.
 *
 * With the introduction of the paging in the SapTableCS the RowCount of a
 * Table can be up to 1000 and when there is a reference index for the client
 * selection sent by the application it could happen that this row is even not
 * loaded yet. We realized that the approach of an application defined index is
 * getting more and more problematic. Due to the application/framework has to
 * set the offsetIndex of fragments it has already to deal with a kind of
 * scroll index which cannot be set arbitrarily anymore. It has to be a
 * sequence from 0 to n. Same indices for the different rows are not allowed.
 * We decided to switch the behavior or handling of the row indices when the
 * application/framework uses fragments. From this point on the selection
 * reverence has to be given by an zero-based index of the scrollable rows.
 * When the SapTableCSRow.Index is set by the framework it is propagated in API
 * all relevant channels (e.g. the events). If it is not set the RowIndex is
 * not -1 anymore but the index of the scrollable rows. With that the
 * application/framework does not need to set SapTableCSRow.Index to get a
 * working client side selection etc.
 *
 * In summary there is a
 * a) An internal cell matrix index of a cell info which is internal and never
 *    be propagated to the application
 * b) An application defined index which is set by the application in the API
 *    and propagated whenever it is set.
 * c) A content row index which is the index of the scrollable rows. This works
 *    together with the firstVisibleRow index, the fragment's offset index
 */

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {number} the application defined row index
 */
UCF_SapTable["prototype"]["iGetAppDefinedRowIndex"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetAppDefinedRowIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(8783): iGetAppDefinedRowIndex"); };

	return (oCellInfo["oDomRefRow"] && oCellInfo["oDomRefRow"]["getAttribute"]('rr'))
		? parseInt(oCellInfo["oDomRefRow"]["getAttribute"]('rr'), 10)
		: -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetAppDefinedRowIndex"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {number} the application defined column index
 */
UCF_SapTable["prototype"]["iGetAppDefinedColIndex"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetAppDefinedColIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(8796): iGetAppDefinedColIndex"); };

	return (oCellInfo["oDomRefCell"] && oCellInfo["oDomRefCell"]["getAttribute"]('cc'))
		? parseInt(oCellInfo["oDomRefCell"]["getAttribute"]('cc'), 10)
		: -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetAppDefinedColIndex"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {number} the index which is relevant for the api to the framework
 * using LS
 */
UCF_SapTable["prototype"]["iGetApiRowIndex"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetApiRowIndex"]++; }; 
	/** @type {number} */
	var iResultIndex;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(8813): iGetApiRowIndex"); };

	iResultIndex = this["iGetAppDefinedRowIndex"](oCellInfo);

	return (iResultIndex === -1 && this["bCanDataRequest"]())
		//If LoadOnDemand and no app index is set use the content index as fallback
		? this["iGetContentRowIndex"](oCellInfo)
		: iResultIndex;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetApiRowIndex"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {number} the index which is relevant for the api to the framework
 * using LS
 */
UCF_SapTable["prototype"]["iGetApiColIndex"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetApiColIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(8830): iGetApiColIndex"); };

	return this["iGetAppDefinedColIndex"](oCellInfo);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetApiColIndex"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {number} the content row index of a given cell. If the cell does not
 * belong to scrollable rows it returns -1.
 */
UCF_SapTable["prototype"]["iGetContentRowIndex"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetContentRowIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(8842): iGetContentRowIndex"); };

	if (this["bIsContentRowIndex"](oCellInfo["iRowIndex"])) {
		return oCellInfo["iRowIndex"]
			- this["iGetContentRowOffset"]()
			+ (this["bCanClientScroll"](false) ? 0 : this["iVisibleFirstRow"])
			- (this["bZeroBasedScrolling"] ? 0 : 1);
	}

	return -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetContentRowIndex"] = 0; };

/**
 * @private
 * @param {number} iMatrixRowIndex
 * @return {boolean} `true` if the given MatrixRowIndex is in the content area
 */
UCF_SapTable["prototype"]["bIsContentRowIndex"] = function(iMatrixRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsContentRowIndex"]++; }; 
	/** @type {number} */
	var iContentRowOffset = this["iGetContentRowOffset"]();

	return (
		iMatrixRowIndex >= iContentRowOffset &&
		iMatrixRowIndex < iContentRowOffset + this["iRowCount"]
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsContentRowIndex"] = 0; };

/**
 * Converts a given application defined row index in an internal cell matrix index
 *
 * @private
 * @param {number} iAppDefinedIndex
 * @return {number}
 */
UCF_SapTable["prototype"]["iConvertAppDefinedToCellMatrixIndex"] = function(iAppDefinedIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iConvertAppDefinedToCellMatrixIndex"]++; }; 
	/** @type {number} */
	var iContentRowOffset;
	/** @type {number} */
	var iLastRowIndex;
	/** @type {number} */
	var iStep;
	/** @type {number} */
	var iStartAt;
	/** @type {boolean} */
	var bOverflow;
	/** @type {number} */
	var iCurrInternalIndex;
	/** @type {number} */
	var iCurAppIndex;
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrCellInfo;

	if (!this["mAppIndexMap"]) {
		this["mAppIndexMap"] = {};
	}

	if (this["mAppIndexMap"][iAppDefinedIndex]) {
		return this["mAppIndexMap"][iAppDefinedIndex];
	} else {
		iContentRowOffset = this["iGetContentRowOffset"]();
		iLastRowIndex = this["iGetCellInfoMatrixLastRowIndex"]();
		iStep = 1;
		iStartAt = iAppDefinedIndex + iContentRowOffset;
		bOverflow = false;
		iCurrInternalIndex = iStartAt;
		iCurAppIndex = 0;
		oCurrCellInfo = null;

		while (true) {
			oCurrCellInfo = this["oGetCellInfo"](iCurrInternalIndex, 0);

			if (this["bIsValidCellInfo"](oCurrCellInfo)) {
				iCurAppIndex = this["iGetApiRowIndex"](oCurrCellInfo);

				if (!(iCurAppIndex in this["mAppIndexMap"])) {
					this["mAppIndexMap"][iCurAppIndex] = iCurrInternalIndex;
				}

				// Found
				if (iCurAppIndex === iAppDefinedIndex) {
					return iCurrInternalIndex;
				}

				// turn search direction. Only once possible
				if (iStep > 0 && iCurAppIndex > iAppDefinedIndex) {
					iStep = -1;
				}

				iCurrInternalIndex += iStep;

			} else {
				iCurrInternalIndex = this["iSearchAvailableDomRow"](
					iCurrInternalIndex + iStep,
					iStep < 0
				);
			}

			// Full loop Back again at the inital position
			if (iCurrInternalIndex === iStartAt) {
				return 0;
			}

			// Loop
			if (iCurrInternalIndex < 0 || iCurrInternalIndex > iLastRowIndex) {
				// second loop -> stop
				if (bOverflow) {
					return 0;
				}

				bOverflow = true;

				if (iCurrInternalIndex < 0) {
					iCurrInternalIndex = iLastRowIndex;
				} else if (iCurrInternalIndex > iLastRowIndex) {
					iCurrInternalIndex = 0;
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iConvertAppDefinedToCellMatrixIndex"] = 0; };

/******************************************************
 ** KEYBOARD NAVIGATION
 *******************************************************/

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_SapTable["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["collectFocusInfo"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {UCF_SapTable_CellType} */
	var eCellType;
	/** @type {boolean} */
	var bContinue;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "SapTable.js(8980): collectFocusInfo"); };

	if (
		this["eFocusBehavior"] === this["FOCUS_BEHAVIOR"]["CELL"] ||
		this["eFocusBehavior"] === this["FOCUS_BEHAVIOR"]["FILTER"] ||
		this["eFocusBehavior"] === this["FOCUS_BEHAVIOR"]["HEADER_SORT"] ||
		this["eFocusBehavior"] === this["FOCUS_BEHAVIOR"]["HEADER_ICON"]
	) {
		oCellInfo = this["oGetCellInfoByDomRef"](oFocusInfo["oGetOrgFocussedElement"]());

		if (oCellInfo) {
			eCellType = this["eGetCellType"](oCellInfo);
			bContinue = false;

			//DoubleCheck
			if (this["eFocusBehavior"] === this["FOCUS_BEHAVIOR"]["CELL"]) {
				bContinue = eCellType === this["SUBCONTROL"]["SELECTION_CELL"] ||
					eCellType === this["SUBCONTROL"]["HEADER_CELL"] ||
					this["bIsDataTableCell"](eCellType);
			} else if (this["eFocusBehavior"] === this["FOCUS_BEHAVIOR"]["FILTER"]) {
				bContinue = eCellType === this["SUBCONTROL"]["STANDARD_CELL"];
			} else if (
				this["eFocusBehavior"] === this["FOCUS_BEHAVIOR"]["HEADER_SORT"] ||
				this["eFocusBehavior"] === this["FOCUS_BEHAVIOR"]["HEADER_ICON"]
			) {
				bContinue = eCellType === this["SUBCONTROL"]["HEADER_CELL"];
			}

			if (!bContinue) { //Cleanup when wrong setting
				this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["NONE"];

				return;
			}

			oFocusInfo["setApplyControl"](this);
			oFocusInfo["addParam"]('iRowIndex', oCellInfo["iRowIndex"]);
			oFocusInfo["addParam"]('iColIndex', oCellInfo["iColIndex"]);

			if (this["eFocusBehavior"] === this["FOCUS_BEHAVIOR"]["HEADER_SORT"]) {
				oFocusInfo["addParam"](
					'sFragmentId',
					this["sGetCellId"](oCellInfo) + '-' + this["ACTION"]["HEADER_SORT"]
				);
			} else if (this["eFocusBehavior"] === this["FOCUS_BEHAVIOR"]["HEADER_ICON"]) {
				oFocusInfo["addParam"](
					'sFragmentId',
					this["sGetCellId"](oCellInfo) + '-' + this["ACTION"]["HEADER_ICON"]
				);
			}
			this["sFocusInfo"] = oFocusInfo["sSerialize"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["collectFocusInfo"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @param {UCF_FocusInfo} oFocusInfo
 */
UCF_SapTable["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyFocusInfo"]++; }; 
	/** @type {number} */
	var iRowIndex;
	/** @type {number} */
	var iColIndex;
	/** @type {string} */
	var sFragmentId;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "SapTable.js(9047): applyFocusInfo"); };

	iRowIndex = oFocusInfo["oGetParam"]('iRowIndex');
	iColIndex = oFocusInfo["oGetParam"]('iColIndex');
	sFragmentId = oFocusInfo["oGetParam"]('sFragmentId');

	if (sFragmentId) {
		UCF_DomUtil["focusDomElement"](UCF_DomUtil["$"](sFragmentId));
	} else if (iRowIndex >= 0 && iColIndex >= 0) {
		this["setCellMatrixFocus"](iRowIndex, iColIndex);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyFocusInfo"] = 0; };

/**
 * Removes the focus. This could be necessary for operations which are only
 * mouse related (DragDrop, ColumnResize, Scrolling by mouse). Using this
 * method in such cases help to avoid refocus problems like jumping screens
 * after a roundtrip
 *
 * @private
 */
UCF_SapTable["prototype"]["looseFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["looseFocus"]++; }; 
	/** @type {HTMLElement} */
	var oActiveElement = UCF_DomUtil["oGetActiveElement"]();

	if (
		oActiveElement &&
		oActiveElement["blur"] &&
		oActiveElement !== document &&
		oActiveElement !== document["body"]
	) {
		oActiveElement["blur"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["looseFocus"] = 0; };

/**
 * Set cell matrix focus
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {HTMLElement} [oDomRefActive] a proposal for the current active DOM
 * element
 */
UCF_SapTable["prototype"]["setCellMatrixFocusByCellInfo"] = function(oCellInfo, oDomRefActive) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCellMatrixFocusByCellInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(9091): setCellMatrixFocusByCellInfo"); };

	this["setCellMatrixFocus"](oCellInfo["iRowIndex"], oCellInfo["iColIndex"], oDomRefActive);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCellMatrixFocusByCellInfo"] = 0; };

/**
 * Set cell matrix focus
 *
 * @private
 * @param {number} iRowIndex
 * @param {number} iColIndex
 * @param {HTMLElement} [oDomRefActive] a proposal for the current active DOM
 * element
 */
UCF_SapTable["prototype"]["setCellMatrixFocus"] = function(iRowIndex, iColIndex, oDomRefActive) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCellMatrixFocus"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {UCF_SapTable_CellInfo} */
	var oLastFocussedCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex >= 0, "iRowIndex >= 0", "SapTable.js(9111): setCellMatrixFocus"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex >= 0, "iColIndex >= 0", "SapTable.js(9112): setCellMatrixFocus"); };

	if (this["bIsValidCellInfoMatrixPosition"](iRowIndex, iColIndex)) {
		oCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex);
		oLastFocussedCellInfo = this["oGetFocussedCell"]();
		if (oCellInfo !== oLastFocussedCellInfo) this["bFocusChanged"] = true;

		if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(9119): setCellMatrixFocus"); };

		// RowGrouping cell redirects focus to group head cell
		if (this["bGetIsInvisibleRowGroupingCell"](oCellInfo)) {
			oCellInfo = this["oSearchFocusableCell"](
				oCellInfo,
				this["SEARCH_DIRECTION"]["DESCENDING"],
				false
			);
		}

		// Ignore Focus on valid cellinfo with fi
		if (
			!this["bIsValidCellInfo"](oCellInfo) ||
			!oCellInfo["oDomRefCell"]["getAttribute"]('fi')
		) {
			this["setCellMatrixFocusHeadData"](iRowIndex, iColIndex);

			this["processCellIsFocussed"](oCellInfo);

			this["markCellAsFocussed"](oCellInfo, oLastFocussedCellInfo, oDomRefActive);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCellMatrixFocus"] = 0; };

/**
 * Sets the cell matrix focus positon to the matrix head data
 *
 * @private
 * @param {number} iRowIndex
 * @param {number} iColIndex
 */
UCF_SapTable["prototype"]["setCellMatrixFocusHeadData"] = function(iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCellMatrixFocusHeadData"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex >= 0, "iRowIndex >= 0", "SapTable.js(9152): setCellMatrixFocusHeadData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex >= 0, "iColIndex >= 0", "SapTable.js(9153): setCellMatrixFocusHeadData"); };

	if (this["bIsValidCellInfoMatrixPosition"](iRowIndex, iColIndex) && (
			this["mCellInfoMatrixHeadData"]["iFocussedCellRowIndex"] !== iRowIndex ||
			this["mCellInfoMatrixHeadData"]["iFocussedCellColIndex"] !== iColIndex
		)) {
		this["mCellInfoMatrixHeadData"]["iFocussedCellRowIndex"] = iRowIndex;
		this["mCellInfoMatrixHeadData"]["iFocussedCellColIndex"] = iColIndex;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCellMatrixFocusHeadData"] = 0; };

/**
 * Hook when cell is focussed
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["processCellIsFocussed"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["processCellIsFocussed"]++; }; 
	// !!!! This method is overwritten by SapTableCS

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(9173): processCellIsFocussed"); };

	if (!this["bIsHorizontalScrolledIntoView"](oCellInfo)) {
		this["scrollHorizontalIntoView"](oCellInfo);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["processCellIsFocussed"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {boolean} `true` if the given Cell is currently focussed
 */
UCF_SapTable["prototype"]["bIsCellFocussed"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsCellFocussed"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(9186): bIsCellFocussed"); };

	return this["oGetFocussedCell"]() === oCellInfo;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsCellFocussed"] = 0; };

/**
 * @private
 * @return {UCF_SapTable_CellInfo} the cell info of the currently focussed cell
 */
UCF_SapTable["prototype"]["oGetFocussedCell"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetFocussedCell"]++; }; 
	return this["oGetCellInfo"](
		this["mCellInfoMatrixHeadData"]["iFocussedCellRowIndex"],
		this["mCellInfoMatrixHeadData"]["iFocussedCellColIndex"]
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetFocussedCell"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {boolean} `true` if the table has a selection column and the cell
 * belongs to that column
 */
UCF_SapTable["prototype"]["bIsCellOfSelectionColumn"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsCellOfSelectionColumn"]++; }; 
	return oCellInfo &&
		this["bHasLeadingSelectionColumn"]() &&
		oCellInfo["iColIndex"] === 0 && (
			this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["SELECTION_CELL"] || (
				this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["HEADER_CELL"] &&
				!this["bIsColumnHeader"](oCellInfo)
			)
		);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsCellOfSelectionColumn"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {boolean} `true` if the Cell supports BlockSelection
 */
UCF_SapTable["prototype"]["bCellSupportsBlockSelection"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCellSupportsBlockSelection"]++; }; 
	return !oCellInfo || (
			this["eGetCellType"](oCellInfo) !== this["SUBCONTROL"]["SELECTION_CELL"] &&
			this["eGetCellType"](oCellInfo) !== this["SUBCONTROL"]["HEADER_CELL"]
		);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCellSupportsBlockSelection"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean} `true` if the CellEditor supports TextSelection before triggering BlockSelection
 */
UCF_SapTable["prototype"]["bPermitTextSelection"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bPermitTextSelection"]++; }; 
	//permit for EditFields in ReadOnly mode as well as for Caption, TextView so far
	//permit within currently focussed cell within existing BlockSelection
	var oControl = oBrowserEvent["oSourceControl"];
	var oCellInfo = this["oGetCellInfoByBrowserEvent"](oBrowserEvent);
	return oControl && (
		(oControl["bIsFakeField"] !== undefined &&
		!oControl["bIsWriteable"]()) ||
		oControl["sClassName"] === 'UCF_Caption' ||
		oControl["sClassName"] === 'UCF_TextView'
		) &&
		oCellInfo &&
		this["oBlockSelection"] && UCF_JsUtil["keys"](this["oBlockSelection"])["length"] > 0 &&
		oCellInfo["iRowIndex"] >= this["oBlockSelection"]["TopLeftRow"] && oCellInfo["iRowIndex"] <= this["oBlockSelection"]["BottomRightRow"] &&
		oCellInfo["iColIndex"] >= this["oBlockSelection"]["TopLeftCol"] && oCellInfo["iColIndex"] <= this["oBlockSelection"]["BottomRightCol"] &&
		!this["bFocusChanged"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bPermitTextSelection"] = 0; };

/**
 * Colorizes a table cell with the given style
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {string} sStyle
 */
UCF_SapTable["prototype"]["colorizeCell"] = function(oCellInfo, sStyle) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["colorizeCell"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(9262): colorizeCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sStyle != null, "sStyle != null", "SapTable.js(9263): colorizeCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sStyle === 'string', "typeof sStyle === 'string'", "SapTable.js(9264): colorizeCell"); };

	if (this["bIsValidCellInfo"](oCellInfo)) {
		oCellInfo["oDomRefCell"]["sColorized"] = sStyle;

		if (!UCF_SapTable["oBgColorCache"]) {
			UCF_SapTable["oBgColorCache"] = {};
		}

		UCF_DomUtil["setBackgroundColor"](
			oCellInfo["oDomRefCell"],
			sStyle,
			UCF_SapTable["oBgColorCache"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["colorizeCell"] = 0; };

/**
 * Decolorizes a table cell which was formely colorized
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["decolorizeCell"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["decolorizeCell"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(9288): decolorizeCell"); };

	if (this["bIsValidCellInfo"](oCellInfo) && oCellInfo["oDomRefCell"]["sColorized"]) {
		UCF_DomUtil["resetBackgroundColor"](
			oCellInfo["oDomRefCell"],
			oCellInfo["oDomRefCell"]["sColorized"],
			UCF_SapTable["oBgColorCache"]
		);

		oCellInfo["oDomRefCell"]["sColorized"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["decolorizeCell"] = 0; };

/**
 * Reset cell matrix focus
 *
 * @private
 */
UCF_SapTable["prototype"]["resetCellMatrixFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["resetCellMatrixFocus"]++; }; 
	this["mCellInfoMatrixHeadData"]["iFocussedCellRowIndex"] = -1;
	this["mCellInfoMatrixHeadData"]["iFocussedCellColIndex"] = -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["resetCellMatrixFocus"] = 0; };

/**
 * Search Direction
 * @private
 * @type {UCF_SapTable_SearchDirectionEnum}
 */
UCF_SapTable["prototype"]["SEARCH_DIRECTION"] = {
	"NONE": 0,
	"ASCENDING": 1,
	"DESCENDING": 2,
	"LAST": 3,
	"FIRST": 4,
	"TOP_BEGIN": 5,
	"BOTTOM_END": 6
};

/**
 * Searches for a focusable cell out from a refrence cell
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfoReference
 * @param {UCF_SapTable_SearchDirection} eSearchDirection
 * @param {boolean} bHorizontal
 * @return {UCF_SapTable_CellInfo} The found cell or the ReferenceCell when nothing found
 */
UCF_SapTable["prototype"]["oSearchFocusableCell"] = function(oCellInfoReference, eSearchDirection, bHorizontal) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oSearchFocusableCell"]++; }; 
	/** @type {number} */
	var iCurrRowIndex;
	/** @type {number} */
	var iCurrColIndex;
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrCellInfo;
	/** @type {UCF_SapTable_CellInfo} */
	var oRecursionResult;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfoReference != null, "oCellInfoReference != null", "SapTable.js(9345): oSearchFocusableCell"); };

	iCurrRowIndex = oCellInfoReference["iRowIndex"];
	iCurrColIndex = oCellInfoReference["iColIndex"];
	oCurrCellInfo = null;

	if (eSearchDirection === this["SEARCH_DIRECTION"]["TOP_BEGIN"]) {
		iCurrRowIndex = this["bHasHeaderRow"]() ? iCurrRowIndex <= 1 ? 0 : 1 : 0;
		iCurrColIndex = this["bHasLeadingSelectionColumn"]() ? iCurrColIndex <= 1 ? 0 : 1 : 0;
	}
	else if (eSearchDirection === this["SEARCH_DIRECTION"]["BOTTOM_END"]) {
		iCurrRowIndex = this["iGetCellInfoMatrixLastRowIndex"]();
		iCurrColIndex = this["iGetCellInfoMatrixLastColIndex"]();
	}
	else if (bHorizontal) {
		if (eSearchDirection === this["SEARCH_DIRECTION"]["LAST"]) {
			iCurrColIndex = this["iGetCellInfoMatrixLastColIndex"]();
		} else if (eSearchDirection === this["SEARCH_DIRECTION"]["FIRST"]) {
			iCurrColIndex = this["bHasLeadingSelectionColumn"]() ? iCurrColIndex <= 1 ? 0 : 1 : 0;
		} else if (eSearchDirection === this["SEARCH_DIRECTION"]["ASCENDING"]) {
			iCurrColIndex = iCurrColIndex + oCellInfoReference["iColSpan"];
		} else if (eSearchDirection === this["SEARCH_DIRECTION"]["DESCENDING"]) {
			iCurrColIndex = iCurrColIndex - 1;
		}
	} else if (eSearchDirection === this["SEARCH_DIRECTION"]["LAST"]) {
		iCurrRowIndex = this["iGetCellInfoMatrixLastRowIndex"]();
	} else if (eSearchDirection === this["SEARCH_DIRECTION"]["FIRST"]) {
		iCurrRowIndex = this["bHasHeaderRow"]() ? iCurrRowIndex <= 1 ? 0 : 1 : 0;
	} else if (eSearchDirection === this["SEARCH_DIRECTION"]["ASCENDING"]) {
		iCurrRowIndex = iCurrRowIndex + oCellInfoReference["iRowSpan"];
	} else if (eSearchDirection === this["SEARCH_DIRECTION"]["DESCENDING"]) {
		iCurrRowIndex = iCurrRowIndex - 1;
	}

	oCurrCellInfo = this["oGetCellInfo"](iCurrRowIndex, iCurrColIndex);

	if (oCurrCellInfo == null) {
		return oCellInfoReference;
	}

	// Grouping with redudant (= invisible) grouping cells
	if (this["bGetIsInvisibleRowGroupingCell"](oCurrCellInfo)) {
		oCurrCellInfo = bHorizontal
			? this["oSearchFocusableCell"](
				oCurrCellInfo,
				this["SEARCH_DIRECTION"]["DESCENDING"],
				false
			)
			: this["oSearchFocusableCell"](
				oCurrCellInfo,
				eSearchDirection === this["SEARCH_DIRECTION"]["ASCENDING"]
				? this["SEARCH_DIRECTION"]["ASCENDING"]
				: this["SEARCH_DIRECTION"]["DESCENDING"],
				false
			);
	}

	// Ignore focus is set?
	if (
		this["bIsValidCellInfo"](oCurrCellInfo) &&
		oCurrCellInfo["oDomRefCell"]["getAttribute"]('fi')
	) {
		oRecursionResult = eSearchDirection === this["SEARCH_DIRECTION"]["LAST"]
			? this["oSearchFocusableCell"](
				oCurrCellInfo,
				this["SEARCH_DIRECTION"]["DESCENDING"],
				bHorizontal
			)
			: eSearchDirection === this["SEARCH_DIRECTION"]["FIRST"]
			? this["oSearchFocusableCell"](
				oCurrCellInfo,
				this["SEARCH_DIRECTION"]["ASCENDING"],
				bHorizontal
			)
			: this["oSearchFocusableCell"](
				oCurrCellInfo,
				eSearchDirection,
				bHorizontal
			);

		oCurrCellInfo = oRecursionResult["oDomRefCell"]["getAttribute"]('fi')
			? oCellInfoReference
			: oRecursionResult;
	}

	return oCurrCellInfo;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oSearchFocusableCell"] = 0; };

/**
 * attaches the unmark handler
 *
 * @private
 * @param {HTMLElement} oDomRef
 */
UCF_SapTable["prototype"]["attachUnmarkHandler"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["attachUnmarkHandler"]++; }; 
	/** @type {UCF_SapTable} */
	var self = this;
	/** @type {HTMLElement} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTable.js(9445): unmarkCellAsFocussedRedirect"); };

	if (!this["unmarkCellAsFocussedRedirect"]) {
		this["unmarkCellAsFocussedRedirect"] = function(oDomEvent) {
			if (self["bHCTouchLayer"] && self["bHCTouchLayerActivated"]) {
				return;
			}
			self["unmarkCellAsFocussed"](oDomEvent["srcElement"] || oDomEvent["target"]);
			self["detachUnmarkHandler"](oDomEvent["srcElement"] || oDomEvent["target"]);
		};
	}

	if (this["oDomRefAttachedToUnmarkHandler"]) {
		if (this["oDomRefAttachedToUnmarkHandler"] === oDomRef) {
			return;
		} else {
			// for the case focusout/blur does not get raised at all or gets raised
			// at an invalid dom element (high performance inputField) call
			// unmarkCellAsFocussed for the old focussed cell when another cell gets
			// focussed won't work when navigating out of the table and entering the
			// table again by keyboard
			if (this["oDomRefAttachedToUnmarkHandler"]["getAttribute"]('id')) {
				oControl = this["oLS"]["oControlFactory"]["oGetControlById"](
					this["oDomRefAttachedToUnmarkHandler"]["getAttribute"]('id')
				);

				if (
					oControl &&
					oControl["oDomRef"] &&
					!oControl["oDomRef"]["bUnmarkedAsFocussed"]
				) {
					this["unmarkCellAsFocussed"](oControl["oDomRef"]);
				}
			}
			this["detachUnmarkHandler"](this["oDomRefAttachedToUnmarkHandler"]);
		}
	}

	this["oDomRefAttachedToUnmarkHandler"] = oDomRef;

	UCF_DomUtil["attachEvent"](
		oDomRef,
		UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]() ? 'focusout' : 'blur',
		this["unmarkCellAsFocussedRedirect"]
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["attachUnmarkHandler"] = 0; };

/**
 * detaches the unmark handler
 *
 * @private
 * @param {HTMLElement} oDomRef
 */
UCF_SapTable["prototype"]["detachUnmarkHandler"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["detachUnmarkHandler"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTable.js(9499): detachUnmarkHandler"); };

	UCF_DomUtil["detachEvent"](
		oDomRef,
		UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]() ? 'focusout' : 'blur',
		this["unmarkCellAsFocussedRedirect"]
	);

	this["oDomRefAttachedToUnmarkHandler"] = null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["detachUnmarkHandler"] = 0; };

/**
 * clean up of the unmark handler mechanism
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpUnmarkHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpUnmarkHandler"]++; }; 
	if (this["oDomRefAttachedToUnmarkHandler"]) {
		this["detachUnmarkHandler"](this["oDomRefAttachedToUnmarkHandler"]);
	}

	this["unmarkCellAsFocussedRedirect"] = null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpUnmarkHandler"] = 0; };

/* eslint-disable complexity */
/**
 * Mark cell as focussed
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {UCF_SapTable_CellInfo} [oLastFocussedCellInfo]
 * @param {HTMLElement} [oDomRefActive] a proposal for the current active DOM
 * element
 */
UCF_SapTable["prototype"]["markCellAsFocussed"] = function(oCellInfo, oLastFocussedCellInfo, oDomRefActive) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["markCellAsFocussed"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef = null;
	/** @type {HTMLElement} */
	var oActiveElement = oDomRefActive || UCF_DomUtil["oGetActiveElement"]();
	/** @type {HTMLElement} */
	var curDomRef;
	/** @type {UCF_SapTable_CellType} */
	var eCellType;
	/** @type {UCF_Control} */
	var oControl;
	/** @type {UCF_Control} */
	var oFirstEmbeddedControl;
	/** @type {HTMLDivElement} */
	var oResizeHandleTopLeft = UCF_DomUtil["$"](this["sId"] + '-BSHandleTL');
	/** @type {HTMLDivElement} */
	var oResizeHandleBottomRight = UCF_DomUtil["$"](this["sId"] + '-BSHandleBR');
	/** @type {HTMLDivElement} */
	var oResizeHandleTopRight = UCF_DomUtil["$"](this["sId"] + '-BSHandleTR');
	/** @type {HTMLDivElement} */
	var oResizeHandleBottomLeft = UCF_DomUtil["$"](this["sId"] + '-BSHandleBL');

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(9555): markCellAsFocussed"); };

	if (!this["bIsValidCellInfo"](oCellInfo)) {
		if (oLastFocussedCellInfo) {
			this["decolorizeCell"](oLastFocussedCellInfo);
			this["cleanUpHoverEffect"](this["HOVER_EFFECT"]["ACTION_MENU"]);
			this["cleanUpHoverEffect"](this["HOVER_EFFECT"]["HEADER_BG"]);

			if (
				oActiveElement &&
				UCF_DomUtil["bContains"](oLastFocussedCellInfo["oDomRefCell"], oActiveElement)
			) {
				oActiveElement["blur"]();
			}
		}
	} else if (!oCellInfo["oDomRefCell"]["getAttribute"]('fi')) {
		// Focus ignore

		// IF active element is already a valid content of the cell keep focus and
		//    do not reset the focus
		// ELSE take the first tabable element
		//
		// Because of special DOM structure of CheckBox, RadioButton,
		// TristateCheckBox in addition to an already reported IE11 bug
		// (inline-block Elements can become active elements although they do not
		// have a tabIndex) for the mentioned controls used as cellEditors focus
		// visualization may fail (focus visualization within the circle) and there
		// may be one addtional unnecessary tab stop
		//
		// since CheckBox, RadioButton, TristateCheckBox should be redesigned in
		// near future we decided not to implement a workaround so far

		if (
			// Cell itself is not valid
			oCellInfo["oDomRefCell"] !== oActiveElement &&
			// the content container is not valid
			this["oDomRefGetCellContentContainer"](oCellInfo) !== oActiveElement &&
			// BS handles are not valid
			oResizeHandleTopLeft !== oActiveElement &&
			oResizeHandleBottomRight !== oActiveElement &&
			oResizeHandleTopRight !== oActiveElement &&
			oResizeHandleBottomLeft !== oActiveElement &&
			UCF_DomUtil["bContains"](oCellInfo["oDomRefCell"], oActiveElement)
		) {
			oDomRef = oActiveElement;

			/**
			 * WebKit-based user agents are picky when calling focus() on a dom
			 * element with tabindex="-1": the focus rectangle is missing, and Safari
			 * sometimes even mis-aligns. Hence, we climb up the dom to find the
			 * first focusalbe ancestor.
			 */
			if (
				UCF_UserAgent["bIsWebKit"]() &&
				oCellInfo["eCellType"] === this["SUBCONTROL"]["SELECTION_CELL"]
			) {
				for (curDomRef = oDomRef; oCellInfo["oDomRefCell"] !== curDomRef; curDomRef = curDomRef["parentNode"]) {
					if (UCF_DomUtil["bHasTabIndex"](curDomRef)) {
						oDomRef = curDomRef;
						break;
					}
				}
			}
		} else {
			// cell embedds MeltingGroup -> MeltingGroup determines DomRef to be focussed
			oFirstEmbeddedControl = this["oGetFirstCellControl"](oCellInfo);
			if (oFirstEmbeddedControl && UCF_JsUtil["bInstanceOf"](oFirstEmbeddedControl, 'UCF_MeltingGroup')) {
				oDomRef = oFirstEmbeddedControl["oGetForcedFocusDomRef"]();
			}
			else {
				oDomRef = UCF_DomUtil["oGetFirstFocusableDomRef"](oCellInfo["oDomRefCell"]);
			}
		}

		//ARIA - hierarchical cell -> dispatch to content
		if (oDomRef) {
			eCellType = this["eGetCellType"](oCellInfo);
			if (window["UCF_System"]["bIsAria"] && eCellType === this["SUBCONTROL"]["HIERARCHY_CELL"] &&
				(UCF_DomUtil["oGetParentByAttribute"](oDomRef, 'acf', this["ACTION"]["HIERARCHY_EXPAND"]) ||
				UCF_DomUtil["oGetParentByAttribute"](oDomRef, 'acf', this["ACTION"]["HIERARCHY_COLLAPSE"]) ||
				UCF_DomUtil["oGetParentByAttribute"](oDomRef, 'acf', this["ACTION"]["HIERARCHY_ALTERNATIVE"]))) {
				oDomRef = null;
			}
		}

		// if no content, check for valid content
		if (!oDomRef) {
			oDomRef = this["oGetFocusDomRefFromCellInfo"](oCellInfo);
		}

		//ARIA - cellType=INFO -> dispatch to content
		if (window["UCF_System"]["bIsAria"] && oDomRef && UCF_DomUtil["bHasClass"](oDomRef, 'lsSTInfoIcon') && oCellInfo["oDomRefCell"]) {
			oDomRef = UCF_DomUtil["oGetLastChild"](oCellInfo["oDomRefCell"]);
		}

		// If there is still no content then "emergency" skip. This shouldn't be
		// the case
		if (oDomRef) {
			if (
				oCellInfo["oDomRefRow"] &&
				!this["bIsElementActive"](oCellInfo["oDomRefRow"])
			) {
				this["setElementActive"](
					this["aGetDomRefsOfRows"](oCellInfo["iRowIndex"]),
					true
				);
			}

			if (!this["bIsElementActive"](oCellInfo["oDomRefCell"])) {
				eCellType = this["eGetCellType"](oCellInfo);

				this["setElementActive"](oCellInfo["oDomRefCell"], true);

				if (!UCF_DomUtil["bHasTabIndex"](oDomRef)) {
					UCF_DomUtil["setTabIndex"](oDomRef, 0);
					oDomRef["bResetTabIndex"] = true;
				}

				if (oLastFocussedCellInfo) {
					this["decolorizeCell"](oLastFocussedCellInfo);
					this["cleanUpHoverEffect"](this["HOVER_EFFECT"]["ACTION_MENU"]);
					this["cleanUpHoverEffect"](this["HOVER_EFFECT"]["HEADER_BG"]);
				}

				if (eCellType === this["SUBCONTROL"]["HEADER_CELL"]) {
					if (this["bHasHoverEffect"](
							oCellInfo["oDomRefCell"],
							this["HOVER_EFFECT"]["ACTION_MENU"]
						)) {
						this["checkHoverEffectIn"](
							oCellInfo["oDomRefCell"],
							this["HOVER_EFFECT"]["ACTION_MENU"]
						);
					}

					if (this["bHasHoverEffect"](
							oCellInfo["oDomRefCell"],
							this["HOVER_EFFECT"]["HEADER_BG"]
						)) {
						this["checkHoverEffectIn"](
							oCellInfo["oDomRefCell"],
							this["HOVER_EFFECT"]["HEADER_BG"],
							oCellInfo["oDomRefCell"]
						);
					}

				}

				oControl = this["oLS"]["oGetControlByDomRef"](oDomRef);

				// No control found in cell
				if (oControl === this) {
					oControl = null;
				}

				if (
					this["bIsDataTableCell"](eCellType) &&
					eCellType !== this["SUBCONTROL"]["MATRIX_CELL"] &&
					this["eFocusAppearance"] !== this["FOCUS_APPEARANCE"]["NEVER"] && (
						this["eFocusAppearance"] === this["FOCUS_APPEARANCE"]["ALWAYS"] || (
							// Cannot check by instanceof due to classes are maybe not loaded
							// yet. Colorize only InputField and ComboBox
							this["eFocusAppearance"] === this["FOCUS_APPEARANCE"]["INPUT"] &&
							oControl &&
							oControl["oGetParent"]() === this &&
							UCF_JsUtil["bInstanceOf"](oControl, 'UCF_EditFieldBase')
						)
					)
				) {
					this["colorizeCell"](oCellInfo, 'urSTFoc');
				}

				if (oControl && (
						// If a fragment in the found control is focussed (e.g. Popin) do
						// notfocus control
						!oDomRef ||
						oDomRef !== oActiveElement ||
						oDomRef === oControl["oFocusDomRef"]
					) && oControl["bIsFocusable"]()) {
					this["oLS"]["focusElement"](oControl["sId"]);
					oDomRef = UCF_DomUtil["oGetActiveElement"]() || oDomRef;
				} else if (UCF_DomUtil["oGetActiveElement"]() !== oDomRef) {
					UCF_DomUtil["focusDomElement"](oDomRef);
				}

				if (
					UCF_DomUtil["oGetActiveElement"]() === oDomRef &&
					eCellType === this["SUBCONTROL"]["HEADER_CELL"] && (
						!this["oGetSelectionColumnToggle"]() ||
						UCF_DomUtil["oGetParentByTagName"](
							this["oGetSelectionColumnToggle"](),
							'TH'
						) !== oCellInfo["oDomRefCell"]
					)
				) {
					this["updateCssClass"](
						oCellInfo["oDomRefCell"],
						'ls-sthcfocus-simulate',
						true
					);
				}

				oDomRef["bUnmarkedAsFocussed"] = false;
				this["attachUnmarkHandler"](oDomRef);
			}
		} else {
			// Ignore focus for this cell
			oCellInfo["oDomRefCell"]["setAttribute"]('fi', true);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["markCellAsFocussed"] = 0; };
/* eslint-enable complexity */

/**
 * gets the DomRef from the CellInfo
 *
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {HTMLElement} the focused Dom element or null
 */
UCF_SapTable["prototype"]["oGetFocusDomRefFromCellInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetFocusDomRefFromCellInfo"]++; }; 
	/** @type {UCF_Control} */
	var oControl;
	/** @type {HTMLElement} */
	var oDomRef;

	// First gets the oDomRef from the CellInfo
	oDomRef = this["oDomRefGetCellContent"](oCellInfo);

	// Check the oForcedFocusDomRef
	if (oDomRef) {
		oControl = this["oLS"]["oGetControlByDomRef"](oDomRef);

		// gets the Control forcedFocusDomRef or the oDomRef if the first is null
		if (oControl) {
			oDomRef = oControl["oGetForcedFocusDomRef"]() || oDomRef;
		}
	}

	// If no valid content found -> Fallback to first element
	if (!oDomRef) {
		oDomRef = UCF_DomUtil["oGetFirstElement"](oCellInfo["oDomRefCell"]);
	}

	return oDomRef;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetFocusDomRefFromCellInfo"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 */
UCF_SapTable["prototype"]["createHCTouchLayer"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["createHCTouchLayer"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {UCF_SapTable} */
	var self;

	if (!this["bHCTouchLayer"]) {
		oCellInfo = oAccessInfo["oCellInfo"];
		oCellInfo["oDomRefCell"]["firstChild"]["style"]["position"] = 'relative';

		if (oCellInfo["oDomRefCell"]["getAttribute"]('touchMenu')) {
			this["HCTouchLayerMenu"] = document["createElement"]('DIV');
			this["HCTouchLayerMenu"]["setAttribute"]('id', 'HCTouchLayerMenu');
			this["HCTouchLayerMenu"]["setAttribute"]('acf', 'HCACTMNUOPN');
			this["HCTouchLayerMenu"]["setAttribute"]('tabindex', '1');

			if (!oCellInfo["oDomRefCell"]["getAttribute"]('touchResize')) {
				this["HCTouchLayerMenu"]["style"]["width"] = '100%';
			}

			UCF_DomUtil["setClass"](this["HCTouchLayerMenu"], 'lsSTHCTouchLayerMenu');

			oCellInfo["oDomRefCell"]["firstChild"]["appendChild"](this["HCTouchLayerMenu"]);
		}

		if (oCellInfo["oDomRefCell"]["getAttribute"]('touchResize')) {
			this["HCTouchLayerResize"] = document["createElement"]('DIV');
			this["HCTouchLayerResize"]["setAttribute"]('id', 'HCTouchLayerResize');
			this["HCTouchLayerResize"]["setAttribute"]('acf', 'CRESIZE');
			this["HCTouchLayerResize"]["setAttribute"]('tabindex', '1');

			if (!oCellInfo["oDomRefCell"]["getAttribute"]('touchMenu')) {
				this["HCTouchLayerResize"]["style"]["width"] = '100%';
			}

			UCF_DomUtil["setClass"](this["HCTouchLayerResize"], 'lsSTHCTouchLayerResize');
			oCellInfo["oDomRefCell"]["firstChild"]["appendChild"](this["HCTouchLayerResize"]);
		}

		this["bHCTouchLayer"] = true;
		self = this;

		if (!this["unmarkTouchLayerRedirect"]) {
			this["unmarkTouchLayerRedirect"] = function(oDomEvent) {
				self["unmarkCellAsFocussed"](oDomEvent["srcElement"] || oDomEvent["target"]);
				self["detachUnmarkTouchHandler"](
					oDomEvent["srcElement"] || oDomEvent["target"]
				);
			};
		}

		if (oCellInfo["oDomRefCell"]["getAttribute"]('touchMenu')) {
			UCF_DomUtil["attachEvent"](
				this["HCTouchLayerMenu"],
				'blur',
				this["unmarkTouchLayerRedirect"]
			);
		}

		if (oCellInfo["oDomRefCell"]["getAttribute"]('touchResize')) {
			UCF_DomUtil["attachEvent"](
				this["HCTouchLayerResize"],
				'blur',
				this["unmarkTouchLayerRedirect"]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["createHCTouchLayer"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["removeHCTouchLayer"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["removeHCTouchLayer"]++; }; 
	if (this["bHCTouchLayer"]) {
		oCellInfo["oDomRefCell"]["firstChild"]["style"]["position"] = 'initial';

		if (oCellInfo["oDomRefCell"]["getAttribute"]('touchMenu')) {
			oCellInfo["oDomRefCell"]["firstChild"]["removeChild"](this["HCTouchLayerMenu"]);
		}
		if (oCellInfo["oDomRefCell"]["getAttribute"]('touchResize')) {
			oCellInfo["oDomRefCell"]["firstChild"]["removeChild"](this["HCTouchLayerResize"]);
		}

		this["bHCTouchLayer"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["removeHCTouchLayer"] = 0; };

/**
 * @private
 * @param {HTMLElement} oDomRef
 */
UCF_SapTable["prototype"]["detachUnmarkTouchHandler"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["detachUnmarkTouchHandler"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTable.js(9900): detachUnmarkTouchHandler"); };

	UCF_DomUtil["detachEvent"](
		oDomRef,
		UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]() ? 'focusout' : 'blur',
		this["unmarkTouchLayerRedirect"]
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["detachUnmarkTouchHandler"] = 0; };

/**
 * Unmark cell as focussed
 *
 * @private
 * @param {HTMLElement} oDomRef
 */
UCF_SapTable["prototype"]["unmarkCellAsFocussed"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["unmarkCellAsFocussed"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTable.js(9919): unmarkCellAsFocussed"); };

	oCellInfo = this["oGetCellInfoByDomRef"](oDomRef);

	// the browser may have lost the focus and a TextInputHelp on TextEdit is
	// open => oCellInfo might be null.
	if (oCellInfo) {
		oDomRef["bUnmarkedAsFocussed"] = true;

		if (oCellInfo["oDomRefRow"] && this["bIsElementActive"](oCellInfo["oDomRefRow"])) {
			this["setElementActive"](
				this["aGetDomRefsOfRows"](oCellInfo["iRowIndex"]),
				false
			);
		}

		if (this["bIsElementActive"](oCellInfo["oDomRefCell"])) {
			if (oDomRef["bResetTabIndex"]) {
				UCF_DomUtil["resetTabIndex"](oDomRef);
				oDomRef["bResetTabIndex"] = false;
			}

			this["setElementActive"](oCellInfo["oDomRefCell"], false);

			this["decolorizeCell"](oCellInfo);
			this["cleanUpHoverEffect"](
				this["HOVER_EFFECT"]["ACTION_MENU"],
				oCellInfo["oDomRefCell"]
			);
			this["cleanUpHoverEffect"](
				this["HOVER_EFFECT"]["HEADER_BG"],
				oCellInfo["oDomRefCell"]
			);

			this["updateCssClass"](
				oCellInfo["oDomRefCell"],
				'ls-sthcfocus-simulate',
				false
			);

			if (this["bHCTouchLayer"]) this["removeHCTouchLayer"](oCellInfo);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["unmarkCellAsFocussed"] = 0; };

/**
 * Sets an HTML DOM Elemnt activation state
 *
 * @private
 * @param {HTMLElement} oDomRef
 * @param {boolean} bActive
 */
UCF_SapTable["prototype"]["setElementActive"] = function(oDomRef, bActive) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setElementActive"]++; }; 
	/** @type {number} */
	var i;
	/** @type {string} */
	var sClassName;

	if (oDomRef instanceof Array) {
		for (i = 0; i < oDomRef["length"]; i++) {
			this["setElementActive"](oDomRef[i], bActive);
		}
	} else if (oDomRef["bMarkedAsActive"] !== bActive) {
		sClassName = oDomRef === this["oDomRef"]
			? 'urST4TableActive'
			: oDomRef["tagName"] === 'TR'
			? 'urST4RowActive'
			: 'urST4CellActive';

		if (bActive) {
			UCF_DomUtil["addClass"](oDomRef, sClassName);
		} else {
			UCF_DomUtil["removeClass"](oDomRef, sClassName);
		}

		oDomRef["bMarkedAsActive"] = bActive;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setElementActive"] = 0; };

/**
 * @private
 * @param {HTMLElement} oDomRef
 * @return {boolean} HTML DOM Element activation state
 */
UCF_SapTable["prototype"]["bIsElementActive"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsElementActive"]++; }; 
	return oDomRef && oDomRef["bMarkedAsActive"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsElementActive"] = 0; };

/**
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {boolean} `true` if the passsed cellInfo is a cell which is grouped
 * and by redundancy not visible
 */
UCF_SapTable["prototype"]["bGetIsInvisibleRowGroupingCell"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bGetIsInvisibleRowGroupingCell"]++; }; 
	return this["bIsValidCellInfo"](oCellInfo) &&
		oCellInfo["oDomRefCell"]["getAttribute"]('grm') === '3' &&
		(oCellInfo["iRowIndex"] - this["iGetContentRowOffset"]()) !== this["iVisibleFirstRow"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bGetIsInvisibleRowGroupingCell"] = 0; };

/**
 * Updates the css class which is indicating the first visible row of the table
 *
 * @private
 * @param {number} iAfter
 * @param {number} iBefore
 */
UCF_SapTable["prototype"]["updateCssClassFirstVisible"] = function(iAfter, iBefore) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateCssClassFirstVisible"]++; }; 
	/** @type {string} */
	var sClassName;
	/** @type {number} */
	var iContentRowOffset;

	if (iAfter !== iBefore) {
		sClassName = 'urST4RowFirstVisible';
		iContentRowOffset = this["iGetContentRowOffset"]();

		if (iAfter >= 0) {
			this["updateCssClass"](
				this["aGetDomRefsOfRows"](iContentRowOffset + iAfter),
				sClassName,
				true
			);
		}
		if (iBefore >= 0) {
			this["updateCssClass"](
				this["aGetDomRefsOfRows"](iContentRowOffset + iBefore),
				sClassName,
				false
			);
		}

	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateCssClassFirstVisible"] = 0; };

/**
 * Sets the css class which is indicating the first visible row of the table
 *
 * @private
 * @param {number} iRowIndex
 */
UCF_SapTable["prototype"]["setCssClassFirstVisible"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCssClassFirstVisible"]++; }; 
	/** @type {HTMLTableRowElement} */
	var oDomRef = this["aGetDomRefsOfRows"](this["iGetContentRowOffset"]() + iRowIndex);

	if (oDomRef) {
		this["updateCssClass"](oDomRef, 'urST4RowFirstVisible', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCssClassFirstVisible"] = 0; };

/**
 * Updates an HTML DOM Element class
 *
 * @private
 * @param {HTMLElement} oDomRef
 * @param {string} sClassName
 * @param {boolean} bSet
 */
UCF_SapTable["prototype"]["updateCssClass"] = function(oDomRef, sClassName, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateCssClass"]++; }; 
	/** @type {number} */
	var i;
	/** @type {string} */
	var sMarkerAttribute;
	/** @type {string} */
	var sMarkerValue;

	if (oDomRef instanceof Array) {
		for (i = 0; i < oDomRef["length"]; i++) {
			this["updateCssClass"](oDomRef[i], sClassName, bSet);
		}
	} else {
		sMarkerAttribute = 'bSet' + sClassName;
		sMarkerValue = oDomRef["getAttribute"](sMarkerAttribute);

		if ((sMarkerValue !== null && sMarkerValue !== '') !== bSet) {
			// attribute can be "X", "" or null

			if (bSet) {
				UCF_DomUtil["addClass"](oDomRef, sClassName);
			} else {
				UCF_DomUtil["removeClass"](oDomRef, sClassName);
			}

			oDomRef["setAttribute"](sMarkerAttribute, bSet ? 'X' : '');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateCssClass"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {UCF_SapTable_CellInfo} cell info by BrowserEvent
 */
UCF_SapTable["prototype"]["oGetCellInfoByBrowserEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetCellInfoByBrowserEvent"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(10116): oGetCellInfoByBrowserEvent"); };

	oDomRef = oBrowserEvent["oGetSource"]();

	// browser drag drop ... get row information also for TR nodes
	if (oBrowserEvent["oDomEvent"]["type"] === 'dragstart') {
		oDomRef = UCF_DomUtil["oGetFirstChild"](oDomRef);
	}

	return this["oGetCellInfoByDomRef"](oDomRef);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetCellInfoByBrowserEvent"] = 0; };

/**
 * Checks if a context menu event has to be raised
 *
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bCanFireContextMenuEvent"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCanFireContextMenuEvent"]++; }; 
	// !!!! This method is overwritten by SapTableCS

	/** @type {UCF_SapTable_CellType} */
	var eCellType;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(10141): bCanFireContextMenuEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(10142): bCanFireContextMenuEvent"); };

	eCellType = this["eGetCellType"](oAccessInfo["oCellInfo"]);

	return eCellType === this["SUBCONTROL"]["SELECTION_CELL"] || (
		this["bIsDataTableCell"](eCellType) &&
		!oAccessInfo["sContentControlType"] // no cell content control is involved
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCanFireContextMenuEvent"] = 0; };

/* eslint-disable complexity */
/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {UCF_SapTable_Navigation} eOperation
 * @param {boolean} bHorizontal
 * @return {boolean} false to skip event handling
 */
UCF_SapTable["prototype"]["handleKeyboardNavigation"] = function(oBrowserEvent, eOperation, bHorizontal) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleKeyboardNavigation"]++; }; 
	/** @type {UCF_JsUtil_Modifier} */
	var mModifier;
	/** @type {boolean} */
	var bHandled;
	/** @type {boolean} */
	var bStandardNavigation;
	/** @type {boolean} */
	var bStartBS;
	/** @type {boolean} */
	var bContinue;
	/** @type {boolean} */
	var bCtrl;
	/** @type {boolean} */
	var bAlt;
	/** @type {boolean} */
	var bShift;
	/** @type {boolean} */
	var bMacCtrl;
	/** @type {number} */
	var iCurrentRowIndex;
	/** @type {number} */
	var iCurrentColIndex;
	/** @type {UCF_SapTable_CellInfo} */
	var oTriggerCellInfo;
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrentCellInfo;
	/** @type {boolean} */
	var bHandleSelection;
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {number} */
	var _rowIndex;
	/** @type {number} */
	var iScrollUIPosBefore;
	/** @type {string} */
	var sSelectAccess;
	/** @type {UCF_SapTable_CellType} */
	var eCellType;
	/** @type {UCF_SapTable_SelectionLayer} */
	var eRowSelectionState;
	/** @type {UCF_SapTable_CellInfo} */
	var oRangeCellInfo;
	/** @type {boolean} */
	var bHandleColumnSelection;

	if (!this["bInitBeforeHandling"]()) {
		return false;
	}

	mModifier = UCF_JsUtil["MODIFIER"]["NONE"];
	bHandled = false;
	bStandardNavigation = true;
	bStartBS = false;
	bCtrl = oBrowserEvent["bCtrl"]();
	bAlt = oBrowserEvent["bAlt"]();
	bShift = oBrowserEvent["bShift"]();
	bMacCtrl = UCF_UserAgent["bIsMacOs"]() && oBrowserEvent["oDomEvent"]["ctrlKey"];

	// Standard Navigation: Process modifier exceptions. Exceptions are e.g. CTRL
	// for TOP and BOTTOM and ALT for PREVIOUS_COLUMN_PAGE and NEXT_COLUMN_PAGE
	if (this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["NONE"], bShift, bCtrl, bAlt)) {
			bStartBS = true;
	} else {
		bContinue = false;

		if (
			this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["CTRL"], bShift, bCtrl, bAlt)
		) {
			mModifier = UCF_JsUtil["MODIFIER"]["CTRL"];
			bStartBS = true;
			if (
				eOperation === this["NAVIGATION"]["TOP"] ||
				eOperation === this["NAVIGATION"]["BOTTOM"] ||
				eOperation === this["NAVIGATION"]["DOWN"] ||
				eOperation === this["NAVIGATION"]["UP"] ||
				eOperation === this["NAVIGATION"]["HOME"] ||
				eOperation === this["NAVIGATION"]["END"] ||
				eOperation === this["NAVIGATION"]["TOP_BEGIN"] ||
				eOperation === this["NAVIGATION"]["BOTTOM_END"]

			) {
				bContinue = true;
			}
		} else if (
			this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["SHIFT"], bShift, bCtrl, bAlt)
		) {
			mModifier = UCF_JsUtil["MODIFIER"]["SHIFT"];

			if (
				eOperation === this["NAVIGATION"]["DOWN"] ||
				eOperation === this["NAVIGATION"]["UP"] ||
				eOperation === this["NAVIGATION"]["RIGHT"] ||
				eOperation === this["NAVIGATION"]["LEFT"] ||
				eOperation === this["NAVIGATION"]["HOME"] ||
				eOperation === this["NAVIGATION"]["END"] ||
				eOperation === this["NAVIGATION"]["PAGE_UP"] ||
				eOperation === this["NAVIGATION"]["PAGE_DOWN"]
			) {
				bContinue = true;
			}
		} else if (
			this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["ALT"], bShift, bCtrl || bMacCtrl, bAlt)
		) {
			mModifier = UCF_JsUtil["MODIFIER"]["ALT"];

			if (
				eOperation === this["NAVIGATION"]["PREVIOUS_COLUMN_PAGE"] ||
				eOperation === this["NAVIGATION"]["NEXT_COLUMN_PAGE"]
			) {
				bContinue = true;
			}
		} else if (this["bCheckModifierMask"](
				UCF_JsUtil["MODIFIER"]["ALT"] | UCF_JsUtil["MODIFIER"]["CTRL"],
				bShift,
				(UCF_UserAgent["bIsMacOs"]() ? bMacCtrl : bCtrl),
				bAlt
		)) {
			// Skipping navigation
			mModifier = UCF_JsUtil["MODIFIER"]["ALT"] | UCF_JsUtil["MODIFIER"]["CTRL"];

			if (
				eOperation === this["NAVIGATION"]["DOWN"] ||
				eOperation === this["NAVIGATION"]["UP"]
			) {
				// -> no special handling for skipping navigation within sapTable itself anylonger via method this.bNavigateSkipping()
				// -> instead just standard container skipping -> see note 3068553
				bStandardNavigation = false;
				bContinue = false;
			}
		} else if (this["bCheckModifierMask"](
				UCF_JsUtil["MODIFIER"]["ALT"] | UCF_JsUtil["MODIFIER"]["SHIFT"],
				bShift,
				bCtrl,
				bAlt
			)) {
			// Skipping navigation
			mModifier = UCF_JsUtil["MODIFIER"]["ALT"] | UCF_JsUtil["MODIFIER"]["SHIFT"];
			//ALT as BlockSelection Modifier
			bContinue = true;
			bHandleSelection = false;
			bStartBS = false;
		} else if (this["bCheckModifierMask"](
				UCF_JsUtil["MODIFIER"]["CTRL"] | UCF_JsUtil["MODIFIER"]["SHIFT"],
				bShift,
				bCtrl,
				bAlt
			)) {
			// TOP/BOTTOM BockSelection
			mModifier = UCF_JsUtil["MODIFIER"]["CTRL"] | UCF_JsUtil["MODIFIER"]["SHIFT"];
			if (
				eOperation === this["NAVIGATION"]["TOP"] ||
				eOperation === this["NAVIGATION"]["BOTTOM"] ||
				eOperation === this["NAVIGATION"]["HOME"] ||
				eOperation === this["NAVIGATION"]["END"] ||
				eOperation === this["NAVIGATION"]["TOP_BEGIN"] ||
				eOperation === this["NAVIGATION"]["BOTTOM_END"]
			) {
				bContinue = true;
			}
		}

		if (!bContinue) { return false; }
	}

	iCurrentRowIndex = -1;
	iCurrentColIndex = -1;
	oTriggerCellInfo = this["oGetCellInfoByBrowserEvent"](oBrowserEvent);
	oCurrentCellInfo = this["oGetFocussedCell"]();
	bHandleSelection = false;
	oCellInfo = null;
	oRangeCellInfo = null;

	this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["CELL"];

	if (oTriggerCellInfo && oCurrentCellInfo !== oTriggerCellInfo) {
		this["setCellMatrixFocusHeadData"](
			oTriggerCellInfo["iRowIndex"],
			oTriggerCellInfo["iColIndex"]
		);
		oCurrentCellInfo = oTriggerCellInfo;
	}

	// If table root is focussed enter the matrix by arrow keys. This is
	// important when in the table is no tab entry point
	if (
		!oTriggerCellInfo &&
		oBrowserEvent["oGetSource"]() === this["oFocusDomRef"] && (
			eOperation === this["NAVIGATION"]["DOWN"] ||
			eOperation === this["NAVIGATION"]["RIGHT"] ||
			eOperation === this["NAVIGATION"]["UP"] ||
			eOperation === this["NAVIGATION"]["LEFT"]
		)
	) {
		bStandardNavigation = false;
		bHandleSelection = false;
		oCurrentCellInfo = this["oGetCellInfo"](
			this["iGetContentRowOffset"]() +
			(this["bCanClientScroll"](false) ? this["iVisibleFirstRow"] : 0),
			0
		);

		if (oCurrentCellInfo) {
			this["setCellMatrixFocusByCellInfo"](oCurrentCellInfo);

			if (eOperation === this["NAVIGATION"]["RIGHT"]) {
				// as long as setting the focus did not succeed, loop the table for
				// first possible cell
				while (
					oCurrentCellInfo &&
					-1 === this["mCellInfoMatrixHeadData"]["iFocussedCellRowIndex"]
				) {
					_rowIndex = oCurrentCellInfo["iRowIndex"];
					oCurrentCellInfo = this["oGetCellInfo"](
						oCurrentCellInfo["iRowIndex"],
						oCurrentCellInfo["iColIndex"] + 1
					) || this["oGetCellInfo"](_rowIndex + 1, 0);

					if (oCurrentCellInfo) {
						this["setCellMatrixFocusByCellInfo"](oCurrentCellInfo);
					}
				}
			}
		}
	}

	if (oCurrentCellInfo) {
		this["bKeyboardHandlingInProcess"] = true;

		iCurrentRowIndex = this["mCellInfoMatrixHeadData"]["iFocussedCellRowIndex"];
		iCurrentColIndex = this["mCellInfoMatrixHeadData"]["iFocussedCellColIndex"];

		if (bStandardNavigation) {
			iScrollUIPosBefore = this["oScrollV"]
				? this["oScrollV"]["iGetFirstVisibleItem"]()
				: -1;

			this["navigateToCell"](
				eOperation,
				iCurrentRowIndex,
				iCurrentColIndex,
				bHorizontal,
				mModifier
			);

			// Is there a selection handling needed in principle -> only when
			// vertical and keyboard navigation selection is enabled

			// trigger column selection handling for bTriggerShiftHomeColumnSelection -> shift home context
			// column selection so far only available in sapTableCS and columnSelectionClientBehaviour SMART
			bHandleColumnSelection = this["bTriggerShiftHomeColumnSelection"] && UCF_JsUtil["bInstanceOf"](this, 'UCF_SapTableCS') &&
				this["sColumnSelectionMode"] === 'MULTI' && this["sColumnSelectionClientBehaviour"] === 'SMART';
			// force selection handling for bTriggerShiftHomeRowSelection -> shift home context
			bHandleSelection = (this["bRowSelectionByNavigation"] && !bHorizontal && !bHandleColumnSelection) || this["bTriggerShiftHomeRowSelection"];

			if (bHandleSelection && !this["bTriggerShiftHomeRowSelection"]) { // Skip handle selection for specuial cases
				// client knows the row to select
				bHandleSelection = this["bCanClientScroll"](bHorizontal)
					// supress when cursor pos did not change
					? (
						this["mCellInfoMatrixHeadData"]["iFocussedCellRowIndex"] !==
						iCurrentRowIndex
					)
					// Supress selection event when the row to select is not known by
					// client
					: (
						!this["oScrollV"] ||
						iScrollUIPosBefore === this["oScrollV"]["iGetFirstVisibleItem"]()
					);
			}
		} else if ((
				eOperation === this["NAVIGATION"]["DOWN"] ||
				eOperation === this["NAVIGATION"]["UP"]
			) && mModifier === UCF_JsUtil["MODIFIER"]["ALT"] | UCF_JsUtil["MODIFIER"]["CTRL"]) {
			this["bNavigateSkipping"](
				eOperation,
				iCurrentRowIndex,
				iCurrentColIndex,
				bHorizontal
			);
			bHandleSelection = false;
		}

		// CTRL + SHIFT + HOME
		if (this["bTriggerShiftHomeColumnSelection"] && this["bTriggerShiftHomeRowSelection"]) {
			oCellInfo = this["oGetFocussedCell"]();
			if (bHandleColumnSelection) {
				this["internalFireColumnSelectDirect"](
					oCellInfo,
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"],
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"],
					this
				);
			}
			if (bHandleSelection) {
				this["internalFireRowSelectDirect"](
					oCellInfo,
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"],
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"],
					this
				);
			}
			this["bTriggerShiftHomeRowSelection"] = false;
			this["bTriggerShiftHomeRowSelection"] = false;
		}
		// Check if row selection should be done by navigation
		else if (bHandleSelection) {
			oCellInfo = this["oGetFocussedCell"]();
			sSelectAccess = null;
			eCellType = oCellInfo
				? this["eGetCellType"](oCellInfo)
				: this["SUBCONTROL"]["NONE"];
			eRowSelectionState = oCellInfo
				? this["eGetRowSelectionState"](oCellInfo["iRowIndex"])
				: this["SELECTION_LAYER"]["ROW_DISABLED"];

			if (
				oCellInfo && (
					this["bIsDataTableCell"](eCellType) ||
					eCellType === this["SUBCONTROL"]["SELECTION_CELL"] || (
						!this["bIsValidCellInfo"](oCellInfo) &&
						this["bCanDataRequest"]() &&
						this["bIsContentRowIndex"](oCellInfo["iRowIndex"])
					)
				) &&
				!this["bIsRowCreatorCell"](oCellInfo) &&
				!(eRowSelectionState & this["SELECTION_LAYER"]["ROW_DISABLED"])
			) {
				if (mModifier === UCF_JsUtil["MODIFIER"]["NONE"]) {
					if (this["bRowSelectionFollowFocusKeyboard"]) {
						sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
					}
				} else if (mModifier === UCF_JsUtil["MODIFIER"]["CTRL"]) {
					if (
						eOperation === this["NAVIGATION"]["TOP"] ||
						eOperation === this["NAVIGATION"]["BOTTOM"] ||
						eOperation === this["NAVIGATION"]["TOP_BEGIN"] ||
						eOperation === this["NAVIGATION"]["BOTTOM_END"]
					) {
						if (this["bRowSelectionFollowFocusKeyboard"]) {
							sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
						}
					} else if (!this["bRowSelectionFollowFocusKeyboard"]) {
						// sSelectAccess = this.EVENT_PARAM_MAP_ACCESS_TYPE.STANDARD;
					}
				} else if (mModifier === UCF_JsUtil["MODIFIER"]["SHIFT"]) {
					if (this["bTriggerShiftHomeRowSelection"]) {
						sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
					}
				 	else if (this["bRowSelectionFollowFocusKeyboard"]) {
				  	sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"];
					}
				} else if (mModifier === (UCF_JsUtil["MODIFIER"]["SHIFT"] | UCF_JsUtil["MODIFIER"]["CTRL"])) {
					if (this["bTriggerShiftHomeRowSelection"]) {
						sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
					}
				} else if (mModifier === UCF_JsUtil["MODIFIER"]["ALT"]) {
					//DO NOTHING
				}
			}

			if (sSelectAccess !== null) {
				if (this["bBlockSelectionActive"]() && this["bTriggerShiftHomeRowSelection"]) {
					if (oCellInfo["iRowIndex"] !== this["oBlockSelection"]["TopLeftRow"]) {
						oRangeCellInfo = this["oGetCellInfo"](this["oBlockSelection"]["TopLeftRow"], oCellInfo["iColIndex"]);
					}
					if (oCellInfo["iRowIndex"] !== this["oBlockSelection"]["BottomRightRow"]) {
						oRangeCellInfo = this["oGetCellInfo"](this["oBlockSelection"]["BottomRightRow"], oCellInfo["iColIndex"]);
					}
				}
				this["internalFireRowSelectDirect"](
					oCellInfo,
					this["ACCESS_TYPE"]["KEYBOARD_NAVIGATE"],
					sSelectAccess,
					this
				);
				//switch blockSelection to RowSelection at SHIFT HOME Selection Column Scope
				if (this["bBlockSelectionActive"]() && this["bTriggerShiftHomeRowSelection"]) {
					if (oRangeCellInfo) {
						this["internalFireRowSelectDirect"](
							oRangeCellInfo,
							this["ACCESS_TYPE"]["KEYBOARD_NAVIGATE"],
							this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"],
							this
						);
					}
				}
			}
			this["bTriggerShiftHomeRowSelection"] = false;
		}
		else if (bHandleColumnSelection) {
			oCellInfo = this["oGetFocussedCell"]();
			if (this["bBlockSelectionActive"]()) {
				if (oCellInfo["iColIndex"] !== this["oBlockSelection"]["TopLeftCol"]) {
					oRangeCellInfo = this["oGetCellInfo"](oCellInfo["iRowIndex"] , this["oBlockSelection"]["TopLeftCol"]);
				}
				if (oCellInfo["iColIndex"] !== this["oBlockSelection"]["BottomRightCol"]) {
					oRangeCellInfo = this["oGetCellInfo"](oCellInfo["iRowIndex"], this["oBlockSelection"]["BottomRightCol"]);
				}
			}
			this["internalFireColumnSelectDirect"](
				oCellInfo,
				this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"],
				this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"],
				this
			);
			//switch blockSelection to ColumnSelection at SHIFT HOME Selection Row Scope
			if (this["bBlockSelectionActive"]()) {
				if (oRangeCellInfo) {
					this["internalFireColumnSelectDirect"](
						oRangeCellInfo,
						this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"],
						this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"],
						this
					);
				}
			}
			this["bTriggerShiftHomeColumnSelection"] = false;
		}

		if (this["bBlockSelectionActive"]() && !sSelectAccess &&
			(this["mCellInfoMatrixHeadData"]["iFocussedCellRowIndex"] !== iCurrentRowIndex ||
			this["mCellInfoMatrixHeadData"]["iFocussedCellColIndex"] !== iCurrentColIndex)) {
			this["handleKeyboardNavigationBS"](bStartBS);
		}

		bHandled = true;

		this["bKeyboardHandlingInProcess"] = false;
	}

	return this["bSetEventReturnState"](oBrowserEvent, bHandled);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleKeyboardNavigation"] = 0; };

/**
 * @private
 * @param {boolean} bStartBS
 */
UCF_SapTable["prototype"]["handleKeyboardNavigationBS"] = function(bStartBS) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleKeyboardNavigationBS"]++; }; 

	/** @type {UCF_SapTable_AccessInfo} */
	var oAccessInfo;
	/** @type {UCF_SapTable_BlockSelection} */
	var oBlockSelection;
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {number} */
	var col;
	/** @type {number} */
	var row;

	oAccessInfo = {};
	oBlockSelection = {};
	oCellInfo = null;

	oAccessInfo["oTable"] = this;
	oAccessInfo["oCellInfo"] = this["oGetFocussedCell"]();

	if (this["bCellSupportsBlockSelection"](oAccessInfo["oCellInfo"])) {
		if (bStartBS) {
			this["internalFireBlockSelect"](oAccessInfo);
		} else if (this["oBSRefPoint"]) {
			oBlockSelection["TopLeftCol"] = Math["min"](
				this["oBSRefPoint"]["RefCol"],
				oAccessInfo["oCellInfo"]["iColIndex"]
			);
			oBlockSelection["TopLeftRow"] = Math["min"](
				this["oBSRefPoint"]["RefRow"],
				oAccessInfo["oCellInfo"]["iRowIndex"]
			);
			oBlockSelection["BottomRightCol"] = Math["max"](
				this["oBSRefPoint"]["RefCol"],
				oAccessInfo["oCellInfo"]["iColIndex"]
			);
			oBlockSelection["BottomRightRow"] = Math["max"](
				this["oBSRefPoint"]["RefRow"],
				oAccessInfo["oCellInfo"]["iRowIndex"]
			);

			// scan block range to check wether merged cell do enhance
			for (col = oBlockSelection["TopLeftCol"]; col <= oBlockSelection["BottomRightCol"]; col++) {
				for (row = oBlockSelection["TopLeftRow"]; row <= oBlockSelection["BottomRightRow"]; row++) {
					oCellInfo = this["oGetCellInfo"](row, col);

					oBlockSelection["TopLeftCol"] = Math["min"](
						oBlockSelection["TopLeftCol"],
						oCellInfo["iColIndex"]
					);
					oBlockSelection["TopLeftRow"] = Math["min"](
						oBlockSelection["TopLeftRow"],
						oCellInfo["iRowIndex"]
					);
					oBlockSelection["BottomRightCol"] = Math["max"](
						oBlockSelection["BottomRightCol"],
						oCellInfo["iColIndex"] + oCellInfo["iColSpan"] - 1
					);
					oBlockSelection["BottomRightRow"] = Math["max"](
						oBlockSelection["BottomRightRow"],
						oCellInfo["iRowIndex"] + oCellInfo["iRowSpan"] - 1
					);
				}
			}

			this["setBlockSelectionInternal"](
				oBlockSelection,
				this["BLOCKSELECTION_MODE"]["NEUTRAL"],
				true,
				true
			);
			this["adjustRowToBlockSelection"](oAccessInfo, oBlockSelection);
			this["adjustColumnToBlockSelection"](oAccessInfo, oBlockSelection);
			this["fireBlockSelect"](
				this["sId"],
				UCF_JsUtil["sJsonStringify"](this["oEnrichBSProperties"](this["oBlockSelection"])),
				this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleKeyboardNavigationBS"] = 0; };

/* eslint-enable complexity */

/**
 * This method sets the focus to the first focussabe element in front or behind
 * the cells of a table
 *
 * @private
 * @param {boolean} bUp
 * @return {boolean} `true` if successful
 */
UCF_SapTable["prototype"]["bNavigateLeaveCellArea"] = function(bUp) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bNavigateLeaveCellArea"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefFocusArea = null;
	/** @type {HTMLElement} */
	var oDomRefToFocus;

	if (bUp) {
		if (!oDomRefFocusArea) {
			oDomRefFocusArea = UCF_DomUtil["$"](
				this["sId"] + '-' + this["SUFFIX"]["TOOLBAR_CELL"]
			);
		}
	} else {
		if (!oDomRefFocusArea) {
			oDomRefFocusArea = UCF_DomUtil["$"](
				this["sId"] + '-' + this["SUFFIX"]["FOOTER_CELL"]
			);
		}
		if (!oDomRefFocusArea) {
			oDomRefFocusArea = UCF_DomUtil["$"](
				this["sId"] + '-' + this["SUFFIX"]["LEGEND_CONTAINER"]
			);
		}
	}

	if (oDomRefFocusArea) {
		oDomRefToFocus = UCF_DomUtil["oGetFirstFocusableDomRef"](oDomRefFocusArea);

		if (oDomRefToFocus) {
			this["resetCellMatrixFocus"]();
			UCF_DomUtil["focusDomElement"](oDomRefToFocus);

			return true;
		}
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bNavigateLeaveCellArea"] = 0; };

/**
 * The table provides the possibility to skip table areas by hot keys. Areas
 * are the Header, Toolbar, TopFixed, Content, BottomFixed, Footer. The keys
 * are e.g. ALT+CTRL Arrow up/down
 *
 * @private
 * @param {UCF_SapTable_Navigation} eOperation Operation to execute e.g.
 * this.NAVIGATION.DOWN or this.NAVIGATION.UP
 * @param {number} iCurrentRowIndex
 * @param {number} iCurrentColIndex
 * @param {boolean} bHorizontal Only vertical allowed yet (=false)
 * @return {boolean} `true` if successful
 */
UCF_SapTable["prototype"]["bNavigateSkipping"] = function(eOperation, iCurrentRowIndex, iCurrentColIndex, bHorizontal) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bNavigateSkipping"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrentCellInfo = this["oGetCellInfo"](iCurrentRowIndex, iCurrentColIndex);
	/** @type {number[]} */
	var aAreaPositions;
	/** @type {number} */
	var iAreaIndex;

	if (bHorizontal) {
		//Not implemented yet
	} else {
		this["initSkippingStructure"](bHorizontal);

		aAreaPositions = this["mSkippingStructureVertical"]["aAreaPositions"];

		if (oCurrentCellInfo) {
			// Find area in which the cell is located
			for (iAreaIndex = 0; iAreaIndex < aAreaPositions["length"]; iAreaIndex++) {
				if (oCurrentCellInfo["iRowIndex"] < aAreaPositions[iAreaIndex]) {
					break;
				}
			}

			iAreaIndex = iAreaIndex - 1;

			if (
				(iAreaIndex === 0 && eOperation === this["NAVIGATION"]["UP"]) || (
					iAreaIndex === aAreaPositions["length"] - 1 &&
					eOperation === this["NAVIGATION"]["DOWN"]
				)
			) {
				// Leaving cell area
				return this["bNavigateLeaveCellArea"](eOperation === this["NAVIGATION"]["UP"]);
			} else {
				// Inner cell skipping
				if (eOperation === this["NAVIGATION"]["UP"]) {
					this["setCellMatrixFocus"](
						aAreaPositions[iAreaIndex] - 1,
						oCurrentCellInfo["iColIndex"]
					);
				} else if (eOperation === this["NAVIGATION"]["DOWN"]) {
					this["setCellMatrixFocus"](
						aAreaPositions[iAreaIndex + 1],
						oCurrentCellInfo["iColIndex"]
					);
				}

				return true;
			}
		} else {
			//Skipping from none cell ... not yet implemented
		}
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bNavigateSkipping"] = 0; };

/**
 * Scans the table for areas which can be skipped and summarizes the info for
 * later use
 *
 * @see {@link UCF_SapTable#bNavigateSkipping}
 *
 * @private
 * @param {boolean} bHorizontal Only vertical allowed yet (=false)
 */
UCF_SapTable["prototype"]["initSkippingStructure"] = function(bHorizontal) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initSkippingStructure"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrCellInfo;
	/** @type {UCF_SapTable_RowType} */
	var iRowType;
	/** @type {UCF_SapTable_RowType} */
	var iLastRowType;
	/** @type {number[]} */
	var aAreaPositions;

	if (bHorizontal) {
		//Not implemented yet
	} else if (!this["mSkippingStructureVertical"]) {
		// Create an array which contains the start index of each single cell
		// skipping area
		oCurrCellInfo = this["bIsValidCellInfoMatrixPosition"](0, 0)
			? this["oGetCellInfo"](0, 0)
			: null;
		iRowType = -1;
		iLastRowType = -1;
		aAreaPositions = [];

		this["mSkippingStructureVertical"] = {
			"iScrollableStart": -1,
			"iScrollableEnd": -1,
			"aAreaPositions": aAreaPositions
		};

		while (this["bIsValidCellInfo"](oCurrCellInfo)) {
			iRowType = parseInt(oCurrCellInfo["oDomRefRow"]["getAttribute"]('rt'), 10);

			if (!iRowType) {
				iRowType = this["ROW_TYPE"]["UNSPECIFIED"];
			}

			if (iRowType !== iLastRowType) {
				if (iRowType === this["ROW_TYPE"]["STANDARD"]) {
					this["mSkippingStructureVertical"]["iScrollableStart"] = oCurrCellInfo["iRowIndex"];
				}
				if (iLastRowType === this["ROW_TYPE"]["STANDARD"]) {
					this["mSkippingStructureVertical"]["iScrollableEnd"] = oCurrCellInfo["iRowIndex"] - 1;
				}
				aAreaPositions[aAreaPositions["length"]] = oCurrCellInfo["iRowIndex"];
				iLastRowType = iRowType;
			}

			oCurrCellInfo = this["oGetCellInfo"](
				oCurrCellInfo["iRowIndex"] + oCurrCellInfo["iRowSpan"],
				oCurrCellInfo["iColIndex"]
			);
		}

		if (
			this["mSkippingStructureVertical"]["iScrollableEnd"] === -1 &&
			this["mSkippingStructureVertical"]["iScrollableStart"] !== -1
		) {
			this["mSkippingStructureVertical"]["iScrollableEnd"] = this["iGetCellInfoMatrixLastRowIndex"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initSkippingStructure"] = 0; };

/**
 * Cleans up the skipping area data
 *
 * @see {@link UCF_SapTable#bNavigateSkipping}
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpNavigateSkipping"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpNavigateSkipping"]++; }; 
	this["mSkippingStructureVertical"] = null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpNavigateSkipping"] = 0; };

/**
 * Checks if the table supports client side scrolling in vertical or horizontal
 * direction
 *
 * @private
 * @param {boolean} bHorizontal Only vertical allowed yet (=false)
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bCanClientScroll"] = function(bHorizontal) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCanClientScroll"]++; }; 
	return bHorizontal &&
		this["oScrollH"] &&
		this["sHorizontalScrollUpdateMode"] === this["SCROLL_UPDATE_MODE"]["CLIENT"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCanClientScroll"] = 0; };

/* eslint-disable complexity */
/**
 * Navigates to the cell by the given operation and triggers scrolling if necessary
 *
 * @param {number} eOperation
 * @param {number} iCurrentRowIndex
 * @param {number} iCurrentColIndex
 * @param {boolean} bHorizontal
 * @param {number} mModifier
 * @private
 */
UCF_SapTable["prototype"]["navigateToCell"] = function(eOperation, iCurrentRowIndex, iCurrentColIndex, bHorizontal, mModifier) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["navigateToCell"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrentCellInfo = this["oGetCellInfo"](iCurrentRowIndex, iCurrentColIndex);
	/** @type {UCF_ScrollBase} */
	var oScrollUI = bHorizontal ? this["oScrollH"] : this["oScrollV"];
	/** @type {string} */
	var sScrollMethod = null;
	/** @type {UCF_SapTable_CellInfo} */
	var oResultCellInfo = null;
	/** @type {UCF_SapTable_CellInfo} */
	var oFirstScrollableCellInfo = null;
	/** @type {UCF_SapTable_CellInfo} */
	var oLastScrollableCellInfo = null;
	/** @type {number} */
	var iResultIndex = -1;
	/** @type {boolean} */
	var bVertical = !bHorizontal;
	/** @type {boolean} */
	var bIsClientScrolling = this["bCanClientScroll"](bHorizontal);
	/** @type {number} */
	var iContentRowOffset = this["iGetContentRowOffset"]();
	/** @type {number} */
	var iFocusRowIndex;
	/** @type {number} */
	var iFocusColIndex;
	/** @type {[HTMLDivElement?, HTMLDivElement?, HTMLDivElement?]} */
	var oContentSegments;
	/** @type {HTMLDivElement} */
	var oContentSegment;
	/** @type {number} */
	var iContentSegment;

	if (
		eOperation === this["NAVIGATION"]["LEFT"] ||
		eOperation === this["NAVIGATION"]["UP"]
	) {
		oResultCellInfo = this["oSearchFocusableCell"](
			oCurrentCellInfo,
			this["SEARCH_DIRECTION"]["DESCENDING"],
			bHorizontal
		);

		if (bIsClientScrolling) {
			if (
				bVertical &&
				oScrollUI &&
				!this["bIsVerticalScrolledIntoView"](oResultCellInfo)
			) {
				if (oCurrentCellInfo["iRowIndex"] === iContentRowOffset + this["iRowCount"]) {
					iResultIndex = iContentRowOffset +
						this["iVisibleFirstRow"] +
						this["iVisibleRowCount"] - 1;
					oResultCellInfo = this["oGetCellInfo"](iResultIndex, iCurrentColIndex);
				} else {
					sScrollMethod = this["bScrollByPage"]
						? 'scrollToPreviousPage'
						: 'scrollToPrevious';
				}
			}
		} else {
			// Skipping for serverside vertical scrolling
			if (
				bVertical &&
				oScrollUI &&
				!oScrollUI["bIsDisabled"]() &&
				!oScrollUI["bStartPosition"]()
			) {
				// Check if skipping area info is available and if server scrolling is
				// active and the start of scrolling hasn't been reached. keep position
				// and trigger scrolling
				this["initSkippingStructure"](false);
				if (this["mSkippingStructureVertical"]["iScrollableStart"] !== -1) {
					oFirstScrollableCellInfo = this["oGetCellInfo"](
						this["mSkippingStructureVertical"]["iScrollableStart"],
						iCurrentColIndex
					);
					if (
						oFirstScrollableCellInfo &&
						oCurrentCellInfo === oFirstScrollableCellInfo
					) {
						oResultCellInfo = oCurrentCellInfo;
					}
				}
			}

			if (oResultCellInfo === oCurrentCellInfo) {
				if (bVertical && this["bScrollByPage"]) {
					iResultIndex = iContentRowOffset + this["iVisibleRowCount"] - 1;
					sScrollMethod = 'scrollToPreviousPage';
				} else {
					sScrollMethod = 'scrollToPrevious';
				}
			}
		}
	} else if (
		eOperation === this["NAVIGATION"]["RIGHT"] ||
		eOperation === this["NAVIGATION"]["DOWN"]
	) {
		oResultCellInfo = this["oSearchFocusableCell"](
			oCurrentCellInfo,
			this["SEARCH_DIRECTION"]["ASCENDING"],
			bHorizontal
		);

		if (bIsClientScrolling) {
			if (bVertical && !this["bIsVerticalScrolledIntoView"](oResultCellInfo)) {
				if (
					oCurrentCellInfo["iRowIndex"] + oCurrentCellInfo["iRowSpan"] ===
					iContentRowOffset
				) {
					iResultIndex = iContentRowOffset + this["iVisibleFirstRow"];
					oResultCellInfo = this["oGetCellInfo"](iResultIndex, iCurrentColIndex);
				} else {
					sScrollMethod = this["bScrollByPage"]
						? 'scrollToNextPage'
						: 'scrollToNext';
				}
			}
		} else {
			// Skipping for serverside vertical scrolling
			if (
				bVertical &&
				oScrollUI &&
				!oScrollUI["bIsDisabled"]() &&
				!oScrollUI["bEndPosition"]()
			) {
				// Check if skipping area info is available and if server scrolling is
				// active and the end of scrolling hasn't been reached. keep position
				// and trigger scrolling
				this["initSkippingStructure"](false);
				if (this["mSkippingStructureVertical"]["iScrollableEnd"] !== -1) {
					oLastScrollableCellInfo = this["oGetCellInfo"](
						this["mSkippingStructureVertical"]["iScrollableEnd"],
						iCurrentColIndex
					);

					if (
						oLastScrollableCellInfo &&
						oCurrentCellInfo === oLastScrollableCellInfo
					) {
						oResultCellInfo = oCurrentCellInfo;
					}
				}
			}

			if (oResultCellInfo === oCurrentCellInfo) {
				if (bVertical && this["bScrollByPage"]) {
					iResultIndex = iContentRowOffset;
					sScrollMethod = 'scrollToNextPage';
				} else {
					sScrollMethod = 'scrollToNext';
				}
			}
		}
	} else if (
		eOperation === this["NAVIGATION"]["PAGE_UP"] ||
		eOperation === this["NAVIGATION"]["PREVIOUS_COLUMN_PAGE"]
	) {
		if (bIsClientScrolling) {
			if (bVertical) {
				if (this["bIsContentRowIndex"](oCurrentCellInfo["iRowIndex"])) {
					iResultIndex = Math["max"](
						iContentRowOffset,
						iCurrentRowIndex - this["iVisibleRowCount"]
					);
					oResultCellInfo = this["oGetCellInfo"](iResultIndex, iCurrentColIndex);
				} else {
					oResultCellInfo = oCurrentCellInfo;
				}

				sScrollMethod = 'scrollToPreviousPage';
			}
		} else {
			// Keep position and only trigger scrolling
			oResultCellInfo = oCurrentCellInfo;
			sScrollMethod = 'scrollToPreviousPage';
		}
	} else if (
		eOperation === this["NAVIGATION"]["PAGE_DOWN"] ||
		eOperation === this["NAVIGATION"]["NEXT_COLUMN_PAGE"]
	) {
		if (bIsClientScrolling) {
			if (bVertical) {
				if (this["bIsContentRowIndex"](oCurrentCellInfo["iRowIndex"])) {
					iResultIndex = Math["min"](
						iContentRowOffset + this["iRowCount"] - 1,
						iCurrentRowIndex + this["iVisibleRowCount"]
					);
					oResultCellInfo = this["oGetCellInfo"](iResultIndex, iCurrentColIndex);
				} else {
					oResultCellInfo = oCurrentCellInfo;
				}

				sScrollMethod = 'scrollToNextPage';
			}
		} else {
			// Keep position and only trigger scrolling
			oResultCellInfo = oCurrentCellInfo;

			sScrollMethod = 'scrollToNextPage';
		}
	} else if (
		eOperation === this["NAVIGATION"]["HOME"] ||
		eOperation === this["NAVIGATION"]["TOP"] ||
		eOperation === this["NAVIGATION"]["TOP_BEGIN"]
	) {
		oResultCellInfo = this["oSearchFocusableCell"](
			oCurrentCellInfo,
			eOperation === this["NAVIGATION"]["TOP_BEGIN"] ? this["SEARCH_DIRECTION"]["TOP_BEGIN"] : this["SEARCH_DIRECTION"]["FIRST"],
			bHorizontal
		);

		if (eOperation === this["NAVIGATION"]["TOP_BEGIN"] &&
			oResultCellInfo["eCellType"] === this["SUBCONTROL"]["HEADER_CELL"] &&
			this["bIsCellOfSelectionColumn"](oResultCellInfo) &&
			mModifier === (UCF_JsUtil["MODIFIER"]["CTRL"] | UCF_JsUtil["MODIFIER"]["SHIFT"])) {
				// SHIFT HOME at Selection column scope
		 		this["bTriggerShiftHomeRowSelection"] = true;
				// SHIFT HOME at Header row scope
				this["bTriggerShiftHomeColumnSelection"] = true;
		}
		else if (oResultCellInfo["eCellType"] === this["SUBCONTROL"]["SELECTION_CELL"] && (mModifier === UCF_JsUtil["MODIFIER"]["SHIFT"] || mModifier === (UCF_JsUtil["MODIFIER"]["CTRL"] | UCF_JsUtil["MODIFIER"]["SHIFT"]))) {
			if (this["bHasLeadingSelectionColumn"]() && oCurrentCellInfo["iColIndex"] === 1) {
				// SHIFT HOME at Selection column scope
		 		this["bTriggerShiftHomeRowSelection"] = true;
			}
		}
		else if (oResultCellInfo["eCellType"] === this["SUBCONTROL"]["HEADER_CELL"] && mModifier === (UCF_JsUtil["MODIFIER"]["CTRL"] | UCF_JsUtil["MODIFIER"]["SHIFT"])) {
			// SHIFT HOME at Header row scope
			this["bTriggerShiftHomeColumnSelection"] = true;
		}

		// //Vertical skipping
		// if (bVertical) {
		// 	this.initSkippingStructure(false);
		// 	if (oCurrentCellInfo.iRowIndex === 0) {
		// 		// If most top position has already been reached check if the focus can
		// 		// be set to none cell area like e.g. toolbar
		// 		this.bNavigateLeaveCellArea(true);

		// 		return;
		// 	} else if (this.mSkippingStructureVertical.iScrollableStart !== -1) {
		// 		// If skipping structure info is avaiable
		// 		oFirstScrollableCellInfo = this.oGetCellInfo(
		// 			this.mSkippingStructureVertical.iScrollableStart,
		// 			iCurrentColIndex
		// 		);

		// 		if (oFirstScrollableCellInfo && (
		// 				oFirstScrollableCellInfo !== oCurrentCellInfo ||
		// 				(oScrollUI && !oScrollUI.bStartPosition())
		// 			)) {
		// 			oResultCellInfo = oFirstScrollableCellInfo;
		// 		}
		// 	}
		// }

		sScrollMethod = 'scrollToBegin';
	} else if (
		eOperation === this["NAVIGATION"]["END"] ||
		eOperation === this["NAVIGATION"]["BOTTOM"] ||
		eOperation === this["NAVIGATION"]["BOTTOM_END"]
	) {
		oResultCellInfo = this["oSearchFocusableCell"](
			oCurrentCellInfo,
			eOperation === this["NAVIGATION"]["BOTTOM_END"] ? this["SEARCH_DIRECTION"]["BOTTOM_END"] : this["SEARCH_DIRECTION"]["LAST"],
			bHorizontal);

		// //Vertical skipping
		// if (bVertical) {
		// 	this.initSkippingStructure(false);
		// 	if (
		// 		oCurrentCellInfo.iRowIndex === this.iGetCellInfoMatrixLastRowIndex()
		// 	) {
		// 		// If most end position has already been reached check if the focus can
		// 		// be set to none cell area like e.g. footer
		// 		this.bNavigateLeaveCellArea(false);

		// 		return;
		// 	} else if (this.mSkippingStructureVertical.iScrollableEnd !== -1) {
		// 		// If skipping structure info is avaiable
		// 		oLastScrollableCellInfo = this.oGetCellInfo(
		// 			this.mSkippingStructureVertical.iScrollableEnd,
		// 			iCurrentColIndex
		// 		);

		// 		if (oLastScrollableCellInfo && (
		// 				oLastScrollableCellInfo !== oCurrentCellInfo ||
		// 				(oScrollUI && !oScrollUI.bEndPosition())
		// 			)) {
		// 			oResultCellInfo = oLastScrollableCellInfo;
		// 		}
		// 	}
		// }

		iResultIndex = bHorizontal
			? oResultCellInfo["iColIndex"] + oResultCellInfo["iColSpan"] - 1
			: oResultCellInfo["iRowIndex"] + oResultCellInfo["iRowSpan"] - 1;

		sScrollMethod = 'scrollToEnd';
	}

	// Separation of RowIndex and CellInfo is needed because of row and colspans
	// Fallback to ResultCell
	if (iResultIndex === -1 && oResultCellInfo) {
		iResultIndex = bHorizontal
			? oResultCellInfo["iColIndex"]
			: oResultCellInfo["iRowIndex"];
	}

	// If result found process navigation
	if (iResultIndex !== -1) {
		// navigate to topLeft/bottomRight cell is independet of row/colSpan -> 2 dim navigation
		if (eOperation === this["NAVIGATION"]["TOP_BEGIN"] || eOperation === this["NAVIGATION"]["BOTTOM_END"]) {
			iFocusRowIndex = oResultCellInfo["iRowIndex"];
			iFocusColIndex = oResultCellInfo["iColIndex"];
		}
		else {
			iFocusRowIndex = bHorizontal ? iCurrentRowIndex : iResultIndex;
			iFocusColIndex = bHorizontal ? iResultIndex : iCurrentColIndex;
		}

		// When scrolling is necessary
		if (sScrollMethod) {
			// Skip processing when scrolling is locked
			if (this["bScrollingByKeyboardLocked"]) {
				return;
			}
			if (this["bIsRowHoveringEnabled"]()) {
				this["cleanUpRowHovering"]();
			}
		}

		// When we navigate to row which is not available in follow focus mode we
		// need maybe to deselect all currently selected rows. This special
		// situation has to be clarified by the server, therefore we force a
		// complete data cleanup
		if (
			oResultCellInfo &&
			this["bRowSelectionFollowFocusKeyboard"] &&
			oResultCellInfo["iRowIndex"] !== oCurrentCellInfo["iRowIndex"] &&
			mModifier === UCF_JsUtil["MODIFIER"]["NONE"] &&
			!this["bIsValidCellInfo"](oResultCellInfo) &&
			this["bCanDataRequest"]() &&
			this["bIsContentRowIndex"](oResultCellInfo["iRowIndex"]) &&
			this["oDataRequestInfo"]
		) {
			this["oDataRequestInfo"]["bForceDataCleanup"] = true;
		}

		if (bIsClientScrolling && oScrollUI && sScrollMethod) {
			oScrollUI[sScrollMethod](mModifier);
		}

		this["setCellMatrixFocus"](iFocusRowIndex, iFocusColIndex);

		// avoid native scrollIntoView at contentSegments - sometimes happens with
		// WINDOWS ZOOM not equal 100%
		if (this["aDomRefSegmentMatrix"]) {
			oContentSegments = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]];
			oContentSegment = null;

			for (iContentSegment = 0; iContentSegment < oContentSegments["length"]; iContentSegment++) {
				oContentSegment = oContentSegments[iContentSegment];
				if (oContentSegment) {
					oContentSegment["scrollTop"] = 0;
				}
			}
		}

		if (!bIsClientScrolling && oScrollUI && sScrollMethod) {
			oScrollUI[sScrollMethod](mModifier);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["navigateToCell"] = 0; };
/* eslint-enable complexity */

/**
 * Checks if the given cell type is navigateable
 *
 * @private
 * @param {UCF_SapTable_Subcontrol} eSubControlType
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bIsNavigateableTableCell"] = function(eSubControlType) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsNavigateableTableCell"]++; }; 
	return eSubControlType === this["SUBCONTROL"]["HEADER_CELL"] ||
		eSubControlType === this["SUBCONTROL"]["STANDARD_CELL"] ||
		eSubControlType === this["SUBCONTROL"]["HIERARCHY_CELL"] ||
		eSubControlType === this["SUBCONTROL"]["MATRIX_CELL"] ||
		eSubControlType === this["SUBCONTROL"]["SELECTION_CELL"] ||
		eSubControlType === this["SUBCONTROL"]["POPIN_CELL"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsNavigateableTableCell"] = 0; };

/**
 * Checks if the given cell type is a cell which contains content
 *
 * @private
 * @param {UCF_SapTable_Subcontrol} eSubControlType
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bIsDataTableCell"] = function(eSubControlType) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsDataTableCell"]++; }; 
	return eSubControlType === this["SUBCONTROL"]["STANDARD_CELL"] ||
		eSubControlType === this["SUBCONTROL"]["HIERARCHY_CELL"] ||
		eSubControlType === this["SUBCONTROL"]["MATRIX_CELL"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsDataTableCell"] = 0; };

/**
 * Standard method to initialize the table before user event handling.
 *
 * @private
 * @return {boolean} true if continue handling
 */
UCF_SapTable["prototype"]["bInitBeforeHandling"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bInitBeforeHandling"]++; }; 
	this["eFocusBehavior"] = this["FOCUS_BEHAVIOR"]["NONE"];

	if (this["oScrollV"] && this["oScrollV"]["bIsInInteraction"]()) {
		if (this["bCanClientScroll"](false)) {
			this["oScrollV"]["stopInteraction"]();
		} else {
			this["oScrollV"]["cancelInteraction"]();
		}
	}

	return this["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bInitBeforeHandling"] = 0; };

/******************************************************
 ** TABLE HOTKEYS
 *******************************************************/

/**
 * Checks if the browser hotkey event has to be handled by the table
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent The browsers key event
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bIsValidTableHotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsValidTableHotkey"]++; }; 
	/** @type {number} */
	var iKeyCode;
	/** @type {boolean} */
	var bShift;
	/** @type {boolean} */
	var bCtrl;
	/** @type {boolean} */
	var bAlt;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(11352): bIsValidTableHotkey"); };

	iKeyCode = oBrowserEvent["iKeyCode"]();
	bShift = oBrowserEvent["bShift"]();
	bCtrl = oBrowserEvent["bCtrl"]();
	bAlt = oBrowserEvent["bAlt"]();

	if (iKeyCode === UCF_KeyCodes["A"]) {
		if (this["bRowSelectionMassOperation"]) {
			if (bShift && bCtrl && !bAlt) {
				// Deselect all [CTRL][SHIFT][A]
				return true;
			}
			if (!bShift && bCtrl && !bAlt) {
				// Select all [CTRL][A]
				return true;
			}
		}
		if (this["bBlockSelectionActive"]()) {
			if (bShift && bCtrl && !bAlt) {
				// Deselect all [CTRL][SHIFT][A]
				return true;
			}
			if (!bShift && bCtrl && !bAlt) {
				// Select all [CTRL][A]
				return true;
			}
		}
	} else if (iKeyCode === UCF_KeyCodes["SPACE"]) {
		if (!bShift && bCtrl && bAlt) {
			// Column Select [CTRL][ALT][SPACE]
			return true;
		}
	} else if (iKeyCode === UCF_KeyCodes["C"]) {
		/* Activate this feature in later release
		if (!bShift && bCtrl && !bAlt) {
			// Copy Cell content
			return true;
		}
		*/
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsValidTableHotkey"] = 0; };

/**
 * Handles the table hotkey event
 *
 * @private
 * @param {UCF_SapTable_AccessInfo} oAccessInfo
 */
UCF_SapTable["prototype"]["handleTableHotkey"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleTableHotkey"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent;
	/** @type {number} */
	var iKeyCode;
	/** @type {boolean} */
	var bShift;
	/** @type {boolean} */
	var bCtrl;
	/** @type {boolean} */
	var bAlt;
	/** @type {UCF_SapTable_CellInfo} */
	var oHeaderCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTable.js(11417): handleTableHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTable.js(11418): handleTableHotkey"); };

	oBrowserEvent = oAccessInfo["oBrowserEvent"];
	iKeyCode = oBrowserEvent["iKeyCode"]();
	bShift = oBrowserEvent["bShift"]();
	bCtrl = oBrowserEvent["bCtrl"]();
	bAlt = oBrowserEvent["bAlt"]();

	if (iKeyCode === UCF_KeyCodes["A"]) {
		if (this["bRowSelectionMassOperation"] || this["bBlockSelectionActive"]()) {
			if (bShift && bCtrl && !bAlt) {
				// Deselect all [CTRL][SHIFT][A]
				oAccessInfo["eAccessType"] = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"];
				if (this["bBlockSelectionActive"]()) {
					this["internalFireBlockSelect"](oAccessInfo);
				}
				else {
					this["internalFireRowSelect"](oAccessInfo);
				}
			}
			if (!bShift && bCtrl && !bAlt) {
				//toggle Select all [CTRL][A]
				if (this["bBlockSelectionActive"]()) {
					if (this["oSelectionInfo"]["bBlockSelectAll"]) {
						if (!this["oSelectionInfo"]["bSelectAll"]  && this["sRowSelectionMode"] === 'MULTI') {
							oAccessInfo["eAccessType"] = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"];
							this["internalFireRowSelect"](oAccessInfo);
						}
						else {
							// column selection so far only available in sapTableCS and columnSelectionClientBehaviour SMART
							if (UCF_JsUtil["bInstanceOf"](this, 'UCF_SapTableCS') && !this["oSelectionInfo"]["bColumnSelectAll"] &&
								this["sColumnSelectionMode"] === 'MULTI' && this["sColumnSelectionClientBehaviour"] === 'SMART') {
								oAccessInfo["eAccessType"] = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"];
								this["internalFireColumnSelect"](oAccessInfo);
							}
							else {
								oAccessInfo["eAccessType"] = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"];
								this["internalFireRowSelect"](oAccessInfo);
								if (UCF_JsUtil["bInstanceOf"](this, 'UCF_SapTableCS')) this["internalFireColumnSelect"](oAccessInfo);
								this["internalFireBlockSelect"](oAccessInfo);
							}
						}
					}
					else {
						oAccessInfo["eAccessType"] = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"];
						this["internalFireBlockSelect"](oAccessInfo);
					}
				}
				else {
					oAccessInfo["eAccessType"] = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"];
					this["internalFireRowSelect"](oAccessInfo);
				}
			}
		}
	} else if (iKeyCode === UCF_KeyCodes["SPACE"]) {
		if (!bShift && bCtrl && bAlt) {
			// Column Select [CTRL][ALT][SPACE]
			oHeaderCellInfo = this["oGetHeaderCellInfoByCellInfo"](oAccessInfo["oCellInfo"]);

			if (
				this["sGetCellId"](oHeaderCellInfo) &&
				!(
					this["eGetColSelectionState"](oHeaderCellInfo["iColIndex"]) &
					this["SELECTION_LAYER"]["COLUMN_DISABLED"]
				)
			) {
				this["fireHeaderCellSelect"](
					oAccessInfo["oTable"]["sId"],
					this["sGetCellId"](oHeaderCellInfo),
					this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"],
					this["sGetCellUserData"](oHeaderCellInfo)
				);
				oAccessInfo["bHandled"] = true;
			}
		}
	} else if (oAccessInfo["oCellInfo"] && iKeyCode === UCF_KeyCodes["C"]) {
		if (!bShift && bCtrl && !bAlt) {
			// Copy Cell content [CTRL][C]
			this["setClipboardHtml"]('<span>' + UCF_XSSEncoder["encodeHTML"](
				oAccessInfo["oCellInfo"]["oDomRefCell"]["innerText"]
			) + '</span>');

			this["setCellMatrixFocusByCellInfo"](oAccessInfo["oCellInfo"]);

			oAccessInfo["bHandled"] = true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleTableHotkey"] = 0; };

/******************************************************
 ** DATATIP HANDLING
 *******************************************************/

/**
 * Cleans up the data tip handling
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpDataTips"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpDataTips"]++; }; 
	if (this["mDataTips"]) {
		this["mDataTips"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpDataTips"] = 0; };

/**
 * Checks if a DataTip has to be opened
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["checkDataTipOpen"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkDataTipOpen"]++; }; 
	/** @type {HTMLElement} */
	var oSource;
	/** @type {string} */
	var sId;
	/** @type {UCF_DataTip} */
	var oDataTip;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(11536): checkDataTipOpen"); };

	if (this["mDataTips"]) {
		oSource = oBrowserEvent["oGetSource"]();

		if (oSource["sTableDataTipId"]) {
			sId = oSource["sTableDataTipId"];
			oDataTip = this["mDataTips"][sId];

			oDataTip["bShowOnActivate"] = false; // cancel the default handling

			if (this["sDataTipTimeOutId"]) {
				UCF_JsUtil["clearDelayedCall"](this["sDataTipTimeOutId"]);
			}

			this["addDelegate"](oDataTip);

			this["sDataTipTimeOutId"] = UCF_JsUtil["delayedCall"](
				400, // eslint-disable-line no-magic-numbers
				this,
				'openDataTip',
				[sId]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkDataTipOpen"] = 0; };

/**
 * Checks if a DataTip has to be closed
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["checkDataTipClose"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkDataTipClose"]++; }; 
	/** @type {HTMLElement} */
	var oSource;
	/** @type {string} */
	var sId;
	/** @type {UCF_DataTip} */
	var oDataTip;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(11577): checkDataTipClose"); };

	if (this["mDataTips"]) {
		oSource = oBrowserEvent["oGetSource"]();

		if (oSource["sTableDataTipId"]) {
			sId = oSource["sTableDataTipId"];
			oDataTip = this["mDataTips"][sId];

			if (oDataTip) {
				oDataTip["close"]();
				this["removeDelegate"](oDataTip);
			}

			if (this["sDataTipTimeOutId"]) {
				UCF_JsUtil["clearDelayedCall"](this["sDataTipTimeOutId"]);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkDataTipClose"] = 0; };

/**
 * Removes a data tip delegate identified by its ID
 *
 * @private
 * @param {string} sId the ID of the delegate
 */
UCF_SapTable["prototype"]["removeDataTipDelegateById"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["removeDataTipDelegateById"]++; }; 
	if (this["mDataTips"]) {
		this["removeDelegate"](this["mDataTips"][sId]);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["removeDataTipDelegateById"] = 0; };

/**
 * Opens a connected datatip
 *
 * @private
 * @param {string} sId
 */
UCF_SapTable["prototype"]["openDataTip"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["openDataTip"]++; }; 
	/** @type {UCF_DataTip} */
	var oDataTip;

	if (this["mDataTips"]) {
		oDataTip = this["mDataTips"][sId];

		// The alignment is set to top because to the tooltip of the header can
		// potentionally overlap the dataTip
		oDataTip["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"]);

		oDataTip["open"]();
		if (this["sDataTipTimeOutId"]) {
			UCF_JsUtil["clearDelayedCall"](this["sDataTipTimeOutId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["openDataTip"] = 0; };

/**
 * Checks if a DataTip exists for a cell and prepares it
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["checkAndPrepareDataTip"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkAndPrepareDataTip"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {string} */
	var sHeaderId;
	/** @type {UCF_DataTip} */
	var oDataTip;
	/** @type {HTMLElement} */
	var oDomRefContent;
	/** @type {HTMLElement} */
	var oDomRefFirstChild;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(11652): checkAndPrepareDataTip"); };

	oDomRef = oCellInfo["oDomRefCell"];
	sHeaderId = this["sGetCellId"](oCellInfo);
	oDataTip = sHeaderId ? this["oGetDataTipById"](sHeaderId) : null;

	if (oDataTip) {
		oDomRefContent = UCF_DomUtil["$"](sHeaderId + '-' + this["SUFFIX"]["HC_CONTENT"]);
		oDomRefFirstChild = (oDomRefContent == null)
			? null
			: UCF_DomUtil["oGetFirstElement"](oDomRefContent);

		if (oDomRefFirstChild) {
			oDomRefContent = oDomRefFirstChild;
		}

		if (oDomRefContent) {
			oDataTip["setOpenerRef"](oDomRef);

			oDomRefContent["sTableDataTipId"] = sHeaderId;

			if (!this["mDataTips"]) {
				this["mDataTips"] = {};
			}
			this["mDataTips"][sHeaderId] = oDataTip;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["checkAndPrepareDataTip"] = 0; };

/******************************************************
 ** Table selection METHOD handling
 *******************************************************/

/** @type {UCF_SapTable_ClientSelectionModeEnum} */
UCF_SapTable["prototype"]["CLIENT_SELECTION_MODE"] = {
	"NONE": 0,
	"WEB_DYNPRO": 1
};

/** @type {UCF_SapTable_SelectionLayerEnum} */
UCF_SapTable["prototype"]["SELECTION_LAYER"] = {
	"NONE": 0,
	"ROW": 1,
	"COLUMN": 2,
	"ROW_PRIMARY": 4,
	"ROW_DISABLED": 8,
	"COLUMN_DISABLED": 16,
	"CELL": 32,
	"ALL": 255
};

/**
 * Initializes the selection info
 *
 * @private
 */
UCF_SapTable["prototype"]["initSelectionInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initSelectionInfo"]++; }; 
	/** @type {string[]} */
	var mRanges = [];
	/** @type {number} */
	var i = 0;
	/** @type {number} */
	var iMinRange = 0;
	/** @type {number} */
	var iMaxRange = 0;
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {string[]} */
	var aSelectedRows;

	if (!this["oSelectionInfo"]["bInitialized"]) {
		oDomRef = this["oGetSelectionColumnToggle"]();

		if (oDomRef) {
			if (this["sRowsSelected"] && this["sRowsSelected"] !== '') {
				mRanges = this["sRowsSelected"]["split"](',');

				for (i = 0; i < mRanges["length"]; i++) {
					aSelectedRows = mRanges[i]["split"]('-');
					iMinRange = parseInt(aSelectedRows[0], 10);
					iMaxRange = parseInt(aSelectedRows[aSelectedRows["length"] - 1], 10);
					this["oSelectionInfo"]["mSelectedRows"]["push"]({
						"iStart": iMinRange,
						"iEnd": iMaxRange
					});
				}
			}

			this["oSelectionInfo"]["bSelectAll"] = this["bSelectionInfoSelectAll"]();

			// column selection so far only available in sapTableCS and columnSelectionClientBehaviour SMART
			if ((this["sSelectionMassAction"] === 'BOTH' || this["sSelectionMassAction"] === 'COLUMN') &&  UCF_JsUtil["bInstanceOf"](this, 'UCF_SapTableCS') &&
				this["sColumnSelectionMode"] === 'MULTI' && this["sColumnSelectionClientBehaviour"] === 'SMART') {
				this["oSelectionInfo"]["bColumnSelectAll"] = this["bSelectionInfoColumnSelectAll"]();
			}

			this["updateSelectionInfoUi"](oDomRef);
			this["oSelectionInfo"]["bInitialized"] = true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initSelectionInfo"] = 0; };

/**
 * Checks if a given value is inside the selection range
 *
 * @private
 * @param {UCF_SapTable_SelectionRange} oRange
 * @param {number} iValue
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bContainedInSelectionRange"] = function(oRange, iValue) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bContainedInSelectionRange"]++; }; 
	return iValue >= oRange["iStart"] && iValue <= oRange["iEnd"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bContainedInSelectionRange"] = 0; };

/**
 * Checks if a given range is the first range
 *
 * @private
 * @param {UCF_SapTable_SelectionRange} oRange
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bFirstSelectionRange"] = function(oRange) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bFirstSelectionRange"]++; }; 
	return (
		this["oSelectionInfo"]["mSelectedRows"]["length"] === 0 ||
		this["oSelectionInfo"]["mSelectedRows"][0]["iStart"] > oRange["iEnd"]
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bFirstSelectionRange"] = 0; };

/**
 * Checks if a given range is the last range
 *
 * @private
 * @param {UCF_SapTable_SelectionRange} oRange
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bLastSelectionRange"] = function(oRange) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bLastSelectionRange"]++; }; 
	return (
		this["oSelectionInfo"]["mSelectedRows"]["length"] > 0 &&
		this["oSelectionInfo"]["mSelectedRows"][
			this["oSelectionInfo"]["mSelectedRows"]["length"] - 1
		]["iEnd"] < oRange["iStart"]
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bLastSelectionRange"] = 0; };

/**
 * Checks if two ranges have intersections
 * @private
 * @param {UCF_SapTable_SelectionRange} oRange
 * @param {number} iStart
 * @param {number} iEnd
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bSelectionIntersection"] = function(oRange, iStart, iEnd) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSelectionIntersection"]++; }; 
	return (
		iEnd > oRange["iEnd"] &&
		(oRange["iEnd"] >= iStart || oRange["iEnd"] === iStart - 1)
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSelectionIntersection"] = 0; };

/**
 * Checks if a given value is between two ranges
 * @private
 * @param {UCF_SapTable_SelectionRange} oRange1
 * @param {UCF_SapTable_SelectionRange} oRange2
 * @param {number} iValue
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bBetweenSelectionRanges"] = function(oRange1, oRange2, iValue) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bBetweenSelectionRanges"]++; }; 
	return (
		oRange1["iEnd"] < iValue &&
		oRange2["iStart"] > iValue
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bBetweenSelectionRanges"] = 0; };

/**
 * Inserts a selection range
 *
 * @private
 * @param {UCF_SapTable_SelectionRange[]} mRanges
 * @param {UCF_SapTable_SelectionRange} oRange
 */
UCF_SapTable["prototype"]["insertSelectionRange"] = function(mRanges, oRange) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["insertSelectionRange"]++; }; 
	if (mRanges["length"] === 0) {
		if (oRange["iEnd"] >= oRange["iStart"]) {
			mRanges["push"](oRange);
		}
	} else if (this["bSelectionIntersection"](
			mRanges[mRanges["length"] - 1],
			oRange["iStart"],
			oRange["iEnd"]
		)) {
		// intersection: modify end of last range, do not create a new one
		mRanges[mRanges["length"] - 1]["iEnd"] = oRange["iEnd"];
	} else if (
		oRange["iEnd"] >= oRange["iStart"] &&
		!this["bContainedInSelectionRange"](
			mRanges[mRanges["length"] - 1],
			oRange["iStart"]
		) &&
		!this["bContainedInSelectionRange"](mRanges[mRanges["length"] - 1], oRange["iEnd"])
	) {
		mRanges["push"]({
			"iStart": oRange["iStart"],
			"iEnd": oRange["iEnd"]
		});
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["insertSelectionRange"] = 0; };
/**
 * Get selection ranges to update the selection info
 * @private
 * @param {number} iRangeStart
 * @param {number} iRangeSize
 * @param {Object<string, boolean>} mExceptionList
 * @return {UCF_SapTable_SelectionRange[]}
 */
UCF_SapTable["prototype"]["mGetSelectionRanges"] = function(iRangeStart, iRangeSize, mExceptionList) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["mGetSelectionRanges"]++; }; 
	/** @type {UCF_SapTable_SelectionRange[]} */
	var mRanges = [];
	/** @type {UCF_SapTable_SelectionRange} */
	var oRange = { "iStart": iRangeStart, "iEnd": iRangeStart + iRangeSize - 1 };
	/** @type {number} */
	var iLastIndex = -1;
	/** @type {number} */
	var iIndex;
	/** @type {string} */
	var sIndex;

	if (!mExceptionList || mExceptionList["length"] === 0) {
		mRanges["push"](oRange);
	} else {
		for (sIndex in mExceptionList) {
			iIndex = parseInt(sIndex, 10);
			if (iIndex >= oRange["iStart"] && iIndex <= oRange["iEnd"] && iLastIndex < 0) {
				oRange["iEnd"] = iIndex - 1;
				mRanges["push"](oRange);
			} else if (iIndex > iLastIndex + 1) {
				oRange = { "iStart": iLastIndex + 1, "iEnd": iIndex - 1 };
				mRanges["push"](oRange);
			}
			iLastIndex = iIndex;
		}
		if (iIndex < iRangeStart + iRangeSize - 1) {
			oRange = { "iStart": iIndex + 1, "iEnd": iRangeStart + iRangeSize - 1 };
			mRanges["push"](oRange);
		}
	}

	return mRanges;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["mGetSelectionRanges"] = 0; };

/**
 * Update the selection ranges
 *
 * @private
 * @param {number} iMinRange
 * @param {number} iMaxRange
 * @param {boolean} bSet
 */
UCF_SapTable["prototype"]["updateSelectionRanges"] = function(iMinRange, iMaxRange, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateSelectionRanges"]++; }; 
	/** @type {number} */
	var iStart;
	/** @type {number} */
	var iEnd;
	/** @type {UCF_SapTable_SelectionRange} */
	var oRange = {};
	/** @type {UCF_SapTable_SelectionRange[]} */
	var mRanges = [];
	/** @type {number} */
	var i;

	if (this["oSelectionInfo"]["mSelectedRows"]["length"] === 0 && bSet) {
		this["oSelectionInfo"]["mSelectedRows"]["push"]({
			"iStart": iMinRange,
			"iEnd": iMaxRange
		});
	} else {
		if (bSet) {
			if (this["bFirstSelectionRange"]({ "iStart": iMinRange, "iEnd": iMaxRange })) {
				oRange = { "iStart": iMinRange, "iEnd": iMaxRange };
				this["insertSelectionRange"](mRanges, oRange);
			}

			for (i = 0; i < this["oSelectionInfo"]["mSelectedRows"]["length"]; i++) {
				iStart = this["oSelectionInfo"]["mSelectedRows"][i]["iStart"];
				iEnd = this["oSelectionInfo"]["mSelectedRows"][i]["iEnd"];

				if (
					this["bContainedInSelectionRange"](
						this["oSelectionInfo"]["mSelectedRows"][i],
						iMinRange
					) &&
					this["bContainedInSelectionRange"](
						this["oSelectionInfo"]["mSelectedRows"][i],
						iMaxRange
					)
				) {
					oRange = { "iStart": iStart, "iEnd": iEnd };
				} else if (this["bContainedInSelectionRange"](
						this["oSelectionInfo"]["mSelectedRows"][i],
						iMinRange
					)) {
					oRange = { "iStart": iStart, "iEnd": iMaxRange };
				} else if (this["bContainedInSelectionRange"](
						this["oSelectionInfo"]["mSelectedRows"][i],
						iMaxRange
					)) {
					oRange = { "iStart": iMinRange, "iEnd": iEnd };
				} else if (
					i + 1 < this["oSelectionInfo"]["mSelectedRows"]["length"] &&
					this["bBetweenSelectionRanges"](
						this["oSelectionInfo"]["mSelectedRows"][i],
						this["oSelectionInfo"]["mSelectedRows"][i + 1],
						iMinRange
					)
				) {
					oRange = { "iStart": iStart, "iEnd": iEnd };
					this["insertSelectionRange"](mRanges, oRange);
					oRange = { "iStart": iMinRange, "iEnd": iMaxRange };
				} else if (
					this["bContainedInSelectionRange"]({ "iStart": iMinRange, "iEnd": iMaxRange }, iStart) &&
					this["bContainedInSelectionRange"]({ "iStart": iMinRange, "iEnd": iMaxRange }, iEnd)
				) {
					oRange = { "iStart": iMinRange, "iEnd": iMaxRange };
				} else {
					oRange = { "iStart": iStart, "iEnd": iEnd };
				}
				this["insertSelectionRange"](mRanges, oRange);
			}
			if (this["bLastSelectionRange"]({ "iStart": iMinRange, "iEnd": iMaxRange })) {
				oRange = { "iStart": iMinRange, "iEnd": iMaxRange };
				this["insertSelectionRange"](mRanges, oRange);
			}
		} else {
			for (i = 0; i < this["oSelectionInfo"]["mSelectedRows"]["length"]; i++) {
				iStart = this["oSelectionInfo"]["mSelectedRows"][i]["iStart"];
				iEnd = this["oSelectionInfo"]["mSelectedRows"][i]["iEnd"];
				if (
					this["bContainedInSelectionRange"](
						this["oSelectionInfo"]["mSelectedRows"][i],
						iMinRange
					) &&
					this["bContainedInSelectionRange"](
						this["oSelectionInfo"]["mSelectedRows"][i],
						iMaxRange
					)
				) {
					oRange = { "iStart": iStart, "iEnd": iMinRange - 1 };
					this["insertSelectionRange"](mRanges, oRange);
					oRange = { "iStart": iMaxRange + 1, "iEnd": iEnd };
				} else if (this["bContainedInSelectionRange"](
						this["oSelectionInfo"]["mSelectedRows"][i],
						iMinRange
					)) {
					oRange = { "iStart": iStart, "iEnd": iMinRange - 1 };
				} else if (this["bContainedInSelectionRange"](
						this["oSelectionInfo"]["mSelectedRows"][i],
						iMaxRange
					)) {
					oRange = { "iStart": iMaxRange + 1, "iEnd": iEnd };
				} else if (
					!this["bContainedInSelectionRange"]({ "iStart": iMinRange, "iEnd": iMaxRange }, iStart) &&
					!this["bContainedInSelectionRange"]({ "iStart": iMinRange, "iEnd": iMaxRange }, iEnd)
				) {
					oRange = { "iStart": iStart, "iEnd": iEnd };
				}
				this["insertSelectionRange"](mRanges, oRange);
			}
		}
		this["oSelectionInfo"]["mSelectedRows"] = mRanges;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateSelectionRanges"] = 0; };

/**
 * Get selection column toggle DomRef
 * @private
 * @return {HTMLElement}
 */
UCF_SapTable["prototype"]["oGetSelectionColumnToggle"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSelectionColumnToggle"]++; }; 
	/** @type {string} */
	var sId;
	/** @type {HTMLElement} */
	var oSelColToggle;
	/** @type {number} */
	var i;

	if (this["aCellInfoMatrix"]) {
		for (i = 0; i < this["aCellInfoMatrix"]["length"]; i++) {
			if (
				this["aCellInfoMatrix"][i] &&
				this["aCellInfoMatrix"][i][0] &&
				this["aCellInfoMatrix"][i][0]["oDomRefCell"] &&
				this["aCellInfoMatrix"][i][0]["eCellType"] === this["SUBCONTROL"]["HEADER_CELL"]
			) {
				sId = this["aCellInfoMatrix"][i][0]["oDomRefCell"]["getAttribute"]('id');
				oSelColToggle = UCF_DomUtil["$"](sId + '-SELCOLTOGGLE');

				if (oSelColToggle) {
					return oSelColToggle;
				}
			}
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSelectionColumnToggle"] = 0; };

/**
 * Update the selection info
 *
 * @private
 * @param {number} iRangeStart
 * @param {number} iRangeSize
 * @param {boolean} bSet
 * @param {Object<string, boolean>} mExceptionList
 * @param {number[]} aDisabledRows
 */
UCF_SapTable["prototype"]["updateSelectionInfo"] = function(iRangeStart, iRangeSize, bSet, mExceptionList, aDisabledRows) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateSelectionInfo"]++; }; 
	/** @type {UCF_SapTable_SelectionRange[]} */
	var mRanges = [];
	/** @type {HTMLElement} */
	var oDomRef = this["oGetSelectionColumnToggle"]();
	/** @type {number} */
	var i;

	/* TODO:
	 * map selected rows to api row index
	 */
	if (oDomRef) {
		this["initSelectionInfo"]();
		mRanges = this["mGetSelectionRanges"](
			iRangeStart,
			iRangeSize,
			mExceptionList
		);

		for (i = 0; i < mRanges["length"]; i++) {
			this["updateSelectionRanges"](mRanges[i]["iStart"], mRanges[i]["iEnd"], bSet);
		}

		if (aDisabledRows) {
			for (i = 0; i < aDisabledRows["length"]; i++) {
				this["oSelectionInfo"]["oDisabledRows"][aDisabledRows[i]] = true;
			}
		}

		this["oSelectionInfo"]["bSelectAll"] = this["bSelectionInfoSelectAll"]();

		this["updateSelectionInfoUi"](oDomRef);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateSelectionInfo"] = 0; };

/**
 * Update the column selection info
 */
UCF_SapTable["prototype"]["updateColumnSelectionInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateColumnSelectionInfo"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef = this["oGetSelectionColumnToggle"]();

	this["oSelectionInfo"]["bColumnSelectAll"] = this["bSelectionInfoColumnSelectAll"]();
	if (oDomRef) {
		this["updateSelectionInfoUi"](oDomRef);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateColumnSelectionInfo"] = 0; };

/**
 * @private
 * @return {boolean} All rows selected?
 */
UCF_SapTable["prototype"]["bSelectionInfoSelectAll"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSelectionInfoSelectAll"]++; }; 
	/** @type {number} */
	var iRows = 0;
	/** @type {UCF_SapTable_SelectionRange} */
	var oRange;
	/** @type {number[]} */
	var aDisabledRows = UCF_JsUtil["keys"](this["oSelectionInfo"]["oDisabledRows"]);
	/** @type {number} */
	var iDisabledRowsTotal = 0;
	/** @type {number} */
	var iDisabledRowsInvisible = 0;
	/** @type {number} */
	var iDisabledRowsVisible = aDisabledRows ? aDisabledRows["length"] : 0;
	/** @type {number} */
	var i;

	this["oSelectionInfo"]["iSelectableRowCount"] = this["iSelectableRowCount"] >= 0
		? this["iSelectableRowCount"]
		: this["iGetRowCount"]();

	for (i = 0; i < this["oSelectionInfo"]["mSelectedRows"]["length"]; i++) {
		oRange = this["oSelectionInfo"]["mSelectedRows"][i];
		iRows = iRows + (oRange["iEnd"] - oRange["iStart"]) + 1;
	}

	// If the table contains disabled rows, which are not in the visible content
	// rows range, correct the selected rows counter
	iDisabledRowsTotal = this["iGetRowCount"]() - this["oSelectionInfo"]["iSelectableRowCount"];
	iDisabledRowsInvisible = iDisabledRowsTotal - iDisabledRowsVisible;

	this["oSelectionInfo"]["iSelectedRows"] = iRows > this["oSelectionInfo"]["iSelectableRowCount"]
		? iRows - iDisabledRowsInvisible
		: iRows;

	return this["oSelectionInfo"]["iSelectableRowCount"] > 0 &&
		this["oSelectionInfo"]["iSelectedRows"] ===
		this["oSelectionInfo"]["iSelectableRowCount"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSelectionInfoSelectAll"] = 0; };

/**
 * @private
 * @return {boolean} All content block selected?
 */
UCF_SapTable["prototype"]["bSelectionInfoBlockSelectAll"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSelectionInfoBlockSelectAll"]++; }; 
	/** @type {number} */
	var iTopLeftRow;
	/** @type {number} */
	var iBottomRightRow;
	/** @type {number} */
	var iTopLeftCol;
	/** @type {number} */
	var iBottomRightCol;

	iTopLeftRow = this["bHasHeaderRow"]() ? this["iGetHeaderRowCount"]() : 0;
	iBottomRightRow = this["iGetCellInfoMatrixLastRowIndex"]();
	iTopLeftCol = this["bHasLeadingSelectionColumn"]() ? 1 : 0;
	iBottomRightCol = this["iGetCellInfoMatrixLastColIndex"]();

	return (this["oBlockSelection"]["TopLeftCol"] === iTopLeftCol &&
			this["oBlockSelection"]["TopLeftRow"] === iTopLeftRow &&
			this["oBlockSelection"]["BottomRightCol"] === iBottomRightCol &&
			this["oBlockSelection"]["BottomRightRow"] === iBottomRightRow);

};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSelectionInfoBlockSelectAll"] = 0; };

/**
 * @private
 * @return {boolean} All columns selected?
 */
UCF_SapTable["prototype"]["bSelectionInfoColumnSelectAll"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSelectionInfoColumnSelectAll"]++; }; 
	/** @type {number} */
	var iFirstIndex;
	/** @type {number} */
	var iLastIndex;
	/** @type {boolean} */
	var bIsColSelected = false;
	/** @type {boolean} */
	var bAllColsSelected = true;

	iFirstIndex = this["bHasLeadingSelectionColumn"]() ? 1 : 0;
	iLastIndex = this["iGetCellInfoMatrixLastColIndex"]();

	for (var iCurIndex = iFirstIndex; iCurIndex <= iLastIndex; ++iCurIndex) {
		bIsColSelected = !!(this["eGetColSelectionState"](iCurIndex) & this["SELECTION_LAYER"]["COLUMN"]);
		bAllColsSelected = bAllColsSelected && bIsColSelected;
		if (!bAllColsSelected) break;
	}

	return bAllColsSelected;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bSelectionInfoColumnSelectAll"] = 0; };

/**
 * Update Selection Column Ui
 * @private
 * @param {HTMLElement} oDomRef
 */
UCF_SapTable["prototype"]["updateSelectionInfoUi"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateSelectionInfoUi"]++; }; 
	/** @type {string} */
	var sCssClasses = UCF_DomUtil["sGetClass"](oDomRef);
	/** @type {boolean} */
	var bSelectAll = false;
	/** @type {HTMLElement} */
	var oCellDomRef;
	/** @type {HTMLElement} */
	var oAriaTutorDomRef;
	/** @type {string} */
	var sDomRefId = '';

	// column selection so far only available in sapTableCS and columnSelectionClientBehaviour SMART
	if ((this["sSelectionMassAction"] === 'BOTH' || this["sSelectionMassAction"] === 'COLUMN') && UCF_JsUtil["bInstanceOf"](this, 'UCF_SapTableCS') &&
		this["sColumnSelectionMode"] === 'MULTI' && this["sColumnSelectionClientBehaviour"] === 'SMART') {
		if (this["sSelectionMassAction"] === 'BOTH') {
			bSelectAll = this["oSelectionInfo"]["bColumnSelectAll"] && this["oSelectionInfo"]["bSelectAll"];
		}
		if (this["sSelectionMassAction"] === 'COLUMN') {
			bSelectAll = this["oSelectionInfo"]["bColumnSelectAll"];
		}
	}
	else {
		bSelectAll = this["oSelectionInfo"]["bSelectAll"];
	}

	UCF_DomUtil["setClass"](
		oDomRef,
		bSelectAll
		? sCssClasses
		["replace"]('urSTSelColToggleUnSelIcon', 'urSTSelColToggleSelIcon')
		["replace"]('urST4LbUnselIcon', 'urST4LbSelIcon')
		: sCssClasses
		["replace"]('urSTSelColToggleSelIcon', 'urSTSelColToggleUnSelIcon')
		["replace"]('urST4LbSelIcon', 'urST4LbUnselIcon')
	);

	if (!window["UCF_System"]["bIsAria"]) {
		oDomRef["setAttribute"]('title', this["oLS"]["sGetText"]('SAPUR_ST_SELCOLTOGGLE', [
			this["oSelectionInfo"]["iSelectedRows"],
			this["oSelectionInfo"]["iSelectableRowCount"]
		]));
	}

	if (window["UCF_System"]["bIsAria"]) {
		sDomRefId = UCF_DomUtil["sGetAttribute"](oDomRef, 'id');
		// Id = CellId + '-SELCOLTOGGLE' - get CellId -> slice by 13 chars
		oAriaTutorDomRef = UCF_DomUtil["$"](sDomRefId["slice"](0, sDomRefId["length"] - 13) + '-ariatutor');
		if (oAriaTutorDomRef) UCF_DomUtil["setInnerText"](oAriaTutorDomRef, bSelectAll ? this["oLS"]["sGetText"]('SAPUR_ST_SC_SALL_TUT') : this["oLS"]["sGetText"]('SAPUR_ST_SC_NALL_TUT'));
		oCellDomRef = UCF_DomUtil["$"](sDomRefId["slice"](0, sDomRefId["length"] - 13));
		if (oCellDomRef) oCellDomRef["setAttribute"]('aria-selected', bSelectAll ? 'true' : 'false');
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateSelectionInfoUi"] = 0; };

/**
 * Initializes the selection handling on client side
 *
 * @private
 */
UCF_SapTable["prototype"]["initClientSelectionHandling"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initClientSelectionHandling"]++; }; 
	// enables the selection by navigation in principle. SHIFT UP/DOWN is enabled
	// by that
	this["bRowSelectionByNavigation"] = this["sRowSelectionClientBehaviour"] !==
		'WEB';

	this["bRowSelectionCellToggleMode"] = this["sRowSelectionClientBehaviour"] ===
		'WEB_SMART';
	this["bContentListening"] = this["sCellEventProcessing"] === 'CAPTURE' || (
		this["sRowSelectionClientBehaviour"] === 'WEB_SMART' &&
		this["sRowSelectionFollowFocus"] !== 'NONE'
	);

	this["bSkipSelectionByEnter"] = !UCF_StringUtil["bContains"](
		this["sCellSelectionKeyboardTrigger"],
		'ENTER'
	);

	this["bRowSelectionFollowFocusKeyboard"] = (
		this["sRowSelectionFollowFocus"] === 'KEYBOARD' ||
		this["sRowSelectionFollowFocus"] === 'BOTH'
	);
	this["bRowSelectionFollowFocusMouse"] = (
		this["sRowSelectionFollowFocus"] === 'MOUSE' ||
		this["sRowSelectionFollowFocus"] === 'BOTH'
	);

	// The primary is part of the multi selection. No visual difference.
	this["bRowSelectionImplicitPrimary"] = UCF_StringUtil["bContains"](
		this["sRowSelectionMode"],
		'IMPLICIT'
	);

	// Optimization for faster cleanup of selected rows
	this["iLastStandardSelectionRowIndex"] = -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initClientSelectionHandling"] = 0; };

/**
 * CleanUp for all variables and instances used by selection handling on client
 * side
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpClientSelectionHandling"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpClientSelectionHandling"]++; }; 
	this["bRowSelectionFollowFocusKeyboard"] = false;
	this["bRowSelectionFollowFocusMouse"] = false;
	this["bRowSelectionCellToggleMode"] = false;
	this["bRowSelectionByNavigation"] = false;
	this["bSkipSelectionByEnter"] = false;
	this["bRowSelectionImplicitPrimary"] = false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpClientSelectionHandling"] = 0; };

/**
 * Toggles the selection of a row on client side
 *
 * @private
 * @param {number} iRowIndex The internal cell matrix index
 */
UCF_SapTable["prototype"]["toggleSelectRowInternal"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["toggleSelectRowInternal"]++; }; 
	/** @type {UCF_SapTable_SelectionLayer} */
	var eRowSelectionState;
	/** @type {boolean} */
	var bSelectable;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iRowIndex === 'number', "typeof iRowIndex === 'number'", "SapTable.js(12339): toggleSelectRowInternal"); };

	eRowSelectionState = this["eGetRowSelectionState"](iRowIndex);
	bSelectable = !(eRowSelectionState & this["SELECTION_LAYER"]["ROW_DISABLED"]);

	if (bSelectable) {
		this["setRowCellSelectionStates"](
			iRowIndex,
			!(eRowSelectionState & this["SELECTION_LAYER"]["ROW"]),
			this["SELECTION_LAYER"]["ROW"]
		);

		if (
			(eRowSelectionState & this["SELECTION_LAYER"]["ROW"]) &&
			(eRowSelectionState & this["SELECTION_LAYER"]["ROW_PRIMARY"])
		) {
			this["setRowCellSelectionStates"](
				iRowIndex,
				false,
				this["SELECTION_LAYER"]["ROW_PRIMARY"]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["toggleSelectRowInternal"] = 0; };

/**
 * Toggles the selection of a column on client side
 *
 * @private
 * @param {number} iColIndex The internal cell matrix index
 */
UCF_SapTable["prototype"]["toggleSelectColInternal"] = function(iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["toggleSelectColInternal"]++; }; 
	/** @type {UCF_SapTable_SelectionLayer} */
	var eColSelectionState;
	/** @type {boolean} */
	var bSelectable;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iColIndex === 'number', "typeof iColIndex === 'number'", "SapTable.js(12376): toggleSelectColInternal"); };

	eColSelectionState = this["eGetColSelectionState"](iColIndex);
	bSelectable = !(eColSelectionState & this["SELECTION_LAYER"]["COLUMN_DISABLED"]);

	if (bSelectable) {
		this["setCellSelectionStates"](
			this["aGetCellInfosOfColumn"](iColIndex),
			!(eColSelectionState & this["SELECTION_LAYER"]["COLUMN"]),
			this["SELECTION_LAYER"]["COLUMN"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["toggleSelectColInternal"] = 0; };

/**
 * Sets/resets the secondary selection state
 *
 * @private
 * @param {number} iRowIndex The internal cell matrix index
 * @param {boolean} bSet true=select; false=deselect
 * @param {UCF_SapTable_EventMapAccessType} sSelectAccess
 */
UCF_SapTable["prototype"]["setSecondarySelectionByIndex"] = function(iRowIndex, bSet, sSelectAccess) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setSecondarySelectionByIndex"]++; }; 
	/** @type {UCF_SapTable_SelectionLayer} */
	var eRowSelectionState;
	/** @type {boolean} */
	var bSelectable;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iRowIndex === 'number', "typeof iRowIndex === 'number'", "SapTable.js(12404): setSecondarySelectionByIndex"); };

	if (iRowIndex >= 0) {
		eRowSelectionState = this["eGetRowSelectionState"](iRowIndex);
		bSelectable = !(eRowSelectionState & this["SELECTION_LAYER"]["ROW_DISABLED"]);

		if (bSelectable) {
			this["setRowCellSelectionStates"](
				iRowIndex,
				bSet,
				this["SELECTION_LAYER"]["ROW"]
			);
			// do not trigger blockSelection without selectAccess -- i.e. public method setRowSelection
			if (this["bBlockSelectionActive"]() && sSelectAccess) {
				this["internalFireRowBlockSelect"](iRowIndex, 1, bSet, sSelectAccess);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setSecondarySelectionByIndex"] = 0; };

/**
 * Sets/resets the primary selection state
 *
 * @private
 * @param {number} iRowIndex The internal cell matrix index
 * @param {boolean} bSet true=select; false=deselect
 */
UCF_SapTable["prototype"]["setPrimarySelectionByIndex"] = function(iRowIndex, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setPrimarySelectionByIndex"]++; }; 
	/** @type {UCF_SapTable_SelectionLayer} */
	var eRowSelectionState;
	/** @type {boolean} */
	var bSelectable;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iRowIndex === 'number', "typeof iRowIndex === 'number'", "SapTable.js(12437): setPrimarySelectionByIndex"); };

	if (iRowIndex >= 0) {
		eRowSelectionState = this["eGetRowSelectionState"](iRowIndex);
		bSelectable = !(eRowSelectionState & this["SELECTION_LAYER"]["ROW_DISABLED"]);

		if (bSelectable) {
			this["setRowCellSelectionStates"](
				iRowIndex,
				bSet,
				this["SELECTION_LAYER"]["ROW_PRIMARY"]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setPrimarySelectionByIndex"] = 0; };

/**
 * Sets/resets the column selection state
 *
 * @param {number} iColIndex The internal cell matrix index
 * @param {boolean} bSet true=select; false=deselect
 * @private
 */
UCF_SapTable["prototype"]["setColumnSelectionByIndex"] = function(iColIndex, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setColumnSelectionByIndex"]++; }; 
	/** @type {UCF_SapTable_SelectionLayer} */
	var eColSelectionState;
	/** @type {boolean} */
	var bSelectable;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iColIndex === 'number', "typeof iColIndex === 'number'", "SapTable.js(12466): setColumnSelectionByIndex"); };

	if (iColIndex >= 0) {
		eColSelectionState = this["eGetColSelectionState"](iColIndex);
		bSelectable = !(eColSelectionState & this["SELECTION_LAYER"]["COLUMN_DISABLED"]);

		if (bSelectable) {
			this["setCellSelectionStates"](
				this["aGetCellInfosOfColumn"](iColIndex),
				bSet,
				this["SELECTION_LAYER"]["COLUMN"]
			);
			// if (this.bBlockSelectionActive()) {
			// 	this.internalFireColumnBlockSelect(iColIndex, 1, bSet, this.EVENT_PARAM_MAP_ACCESS_TYPE.STANDARD);
			// }
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setColumnSelectionByIndex"] = 0; };

/**
 * Returns the internal column and row cell matrix index of a cell given by an
 * ID in a standard JS object.
 *
 * @private
 * @param {string} sCellId The Id of the cell
 * @return {UCF_SapTable_CellPosition} {iRowIndex, iColIndex} or null
 */
UCF_SapTable["prototype"]["oGetInternalPositionByCellId"] = function(sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetInternalPositionByCellId"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefCell;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(12497): oGetInternalPositionByCellId"); };

	oDomRefCell = UCF_DomUtil["$"](sCellId);

	return oDomRefCell
		? {
			"iRowIndex": oDomRefCell["lsMatrixRowIndex"],
			"iColIndex": oDomRefCell["lsMatrixColIndex"]
		}
		: null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetInternalPositionByCellId"] = 0; };

/**
 * Returns the internal column cell matrix index of a cell given by an ID.
 *
 * @private
 * @param {string} sCellId The Id of the cell
 * @return {number} The internal cell matrix index. -1 if cell does not exit
 */
UCF_SapTable["prototype"]["iGetInternalColIndexByCellId"] = function(sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetInternalColIndexByCellId"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefCell;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(12520): iGetInternalColIndexByCellId"); };

	oDomRefCell = UCF_DomUtil["$"](sCellId);
	this["synchronizeCellRenderRepresentation"](oDomRefCell);

	return oDomRefCell ? oDomRefCell["lsMatrixColIndex"] : -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetInternalColIndexByCellId"] = 0; };

/**
 * Returns the internal row cell matrix index of a cell given by an ID.
 *
 * @param {string} sCellId The Id of the cell
 *
 * @return {number} The internal cell matrix index. -1 if cell does not exit
 * @private
 */
UCF_SapTable["prototype"]["iGetInternalRowIndexByCellId"] = function(sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetInternalRowIndexByCellId"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefCell;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(12540): iGetInternalRowIndexByCellId"); };

	oDomRefCell = UCF_DomUtil["$"](sCellId);
	this["synchronizeCellRenderRepresentation"](oDomRefCell);

	return oDomRefCell ? oDomRefCell["lsMatrixRowIndex"] : -1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetInternalRowIndexByCellId"] = 0; };

/* eslint-disable max-depth */
/**
 * Adjust headerCell captions
 *
 * @private
 */
UCF_SapTable["prototype"]["adjustHeaderCellCaptions"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["adjustHeaderCellCaptions"]++; }; 
	/** @type {UCF_SapTable_CellInfo[]} */
	var aRows = this["aGetRows"]();
	/** @type {UCF_SapTable_CellInfo[]} */
	var aCellInfos = null;
	/** @type {number} */
	var iCellHeight = -1;
	/** @type {string} */
	var sCellId = '';
	/** @type {string} */
	var sCaptionId = '';
	/** @type {HTMLCollection} */
	var aContentRefs = null;
	/** @type {HTMLElement[]} */
	var aFittingContentRefs = [];
	/** @type {boolean} */
	var bBreak = false;
	/** @type {number} */
	var i;
	/** @type {number} */
	var j;
	/** @type {number} */
	var k;
	/** @type {number} */
	var l;
	/** @type {number} */
	var n;

	for (i = 0; i < aRows["length"]; i++) {
		if (bBreak) {
			break;
		}
		if (!aRows[i] || aRows[i]["eCellType"] !== this["SUBCONTROL"]["HEADER_CELL"]) {
			bBreak = true;
		}
		if (!aRows[i] || aRows[i]["eCellType"] === this["SUBCONTROL"]["HEADER_CELL"]) {
			aCellInfos = this["aGetCellInfosOfRow"](i);

			for (j = 0; j < aCellInfos["length"]; j++) {
				if (aCellInfos[j]["eCellType"] === this["SUBCONTROL"]["HEADER_CELL"]) {
					sCellId = aCellInfos[j]["oDomRefCell"]["getAttribute"]('id');

					if (UCF_DomUtil["$"](sCellId + '-CONTENT-1')) {
						aContentRefs = UCF_DomUtil["$"](
							sCellId + '-CONTENT-1'
						)["parentNode"]["children"];

						if (aContentRefs["length"] > 0) {
							aFittingContentRefs = [];
							iCellHeight = aCellInfos[j]["oDomRefCell"]["clientHeight"];

							for (k = 0; k < aContentRefs["length"]; k++) {
								UCF_DomUtil["replaceClass"](
									aContentRefs[k],
									'lsSTHCCPContentCurrent',
									'lsSTHCCPContent'
								);
								aContentRefs[k]["style"]["display"] = '';

								if (aContentRefs[k]["offsetHeight"] <= (iCellHeight + 10)) {
									aFittingContentRefs["push"](aContentRefs[k]);
								}
							}

							if (aFittingContentRefs["length"] === 0) {
								for (l = 0; l < aContentRefs["length"]; l++) {
									aFittingContentRefs["push"](aContentRefs[l]);
								}

								aFittingContentRefs["sort"](function(a, b) {
									return a["offsetHeight"] - b["offsetHeight"];
								});

								UCF_DomUtil["replaceClass"](
									aFittingContentRefs[0],
									'lsSTHCCPContent',
									'lsSTHCCPContentCurrent'
								);
								sCaptionId = aFittingContentRefs[0]["firstElementChild"]
									["getAttribute"]('id');
								aCellInfos[j]["oDomRefCell"]["setAttribute"](
									'captionId',
									sCaptionId
								);
							} else {
								aFittingContentRefs["sort"](function(a, b) {
									return a["innerText"]["length"] - b["innerText"]["length"];
								});

								UCF_DomUtil["replaceClass"](
									aFittingContentRefs[aFittingContentRefs["length"] - 1],
									'lsSTHCCPContent',
									'lsSTHCCPContentCurrent'
								);
								sCaptionId = aFittingContentRefs[
									aFittingContentRefs["length"] - 1
								]["firstElementChild"]["getAttribute"]('id');
								aCellInfos[j]["oDomRefCell"]["setAttribute"](
									'captionId',
									sCaptionId
								);
							}
							for (n = 0; n < aContentRefs["length"]; n++) {
								if (UCF_DomUtil["bHasClass"](
										aContentRefs[n],
										'lsSTHCCPContent'
									)) {
									aContentRefs[n]["style"]["display"] = 'none';
								}
							}
						}
					}
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["adjustHeaderCellCaptions"] = 0; };

UCF_SapTable["prototype"]["bBlockSelectionActive"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bBlockSelectionActive"]++; }; 
	return this["mEvents"] && this["mEvents"]["BlockSelect"];

	// return this.mEvents &&
	// 	this.mEvents.BlockSelect && (
	// 		this.sRowSelectionMode !== 'SERVER' && (
	// 		this.sRowSelectionClientBehaviour === 'SMART' ||
	// 		this.sRowSelectionClientBehaviour === 'WEB' ||
	// 		this.sRowSelectionClientBehaviour === 'WEB_SMART'
	// 	)
	// );
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bBlockSelectionActive"] = 0; };

UCF_SapTable["prototype"]["reduceBSProperties"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["reduceBSProperties"]++; }; 
	var oBlockSelectionExternal = null;
	var oBlockSelectionReduced = {};

	oBlockSelectionExternal = UCF_JsUtil["oJsonParse"](this["sBlockSelection"]);

	oBlockSelectionReduced["TopLeftCol"] = oBlockSelectionExternal["TopLeftCol"];
	oBlockSelectionReduced["TopLeftRow"] = oBlockSelectionExternal["TopLeftRow"];
	oBlockSelectionReduced["BottomRightCol"] = oBlockSelectionExternal["BottomRightCol"];
	oBlockSelectionReduced["BottomRightRow"] = oBlockSelectionExternal["BottomRightRow"];

	this["sReducedBlockSelection"] = UCF_JsUtil["sJsonStringify"](oBlockSelectionReduced);
	this["oBSRefPoint"] = {"RefCol": oBlockSelectionExternal["RefCol"], "RefRow": oBlockSelectionExternal["RefRow"]};
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["reduceBSProperties"] = 0; };

UCF_SapTable["prototype"]["oEnrichBSProperties"] = function(oBlockSelection) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oEnrichBSProperties"]++; }; 
	var oBlockSelectionEnriched = {};

	oBlockSelectionEnriched["TopLeftCol"] = oBlockSelection["TopLeftCol"];
	oBlockSelectionEnriched["TopLeftRow"] = oBlockSelection["TopLeftRow"];
	oBlockSelectionEnriched["BottomRightCol"] = oBlockSelection["BottomRightCol"];
	oBlockSelectionEnriched["BottomRightRow"] = oBlockSelection["BottomRightRow"];

	if (UCF_JsUtil["keys"](oBlockSelection)["length"] > 0) {
		if (this["oBSRefPoint"]) {
			oBlockSelectionEnriched["RefCol"] = this["oBSRefPoint"]["RefCol"];
			oBlockSelectionEnriched["RefRow"] = this["oBSRefPoint"]["RefRow"];
		}
		else {
			oBlockSelectionEnriched["RefCol"] = -1;
			oBlockSelectionEnriched["RefRow"] = -1;
		}
	}
	else {
		// empty object
		// oBlockSelectionEnriched = {};
		oBlockSelectionEnriched = oBlockSelection;
	}

	return oBlockSelectionEnriched;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oEnrichBSProperties"] = 0; };

/**
 * Initialze the block selection after server roundtrip
 * Neccessary to reset server side cell selection initially
 *
 * @private
 */
UCF_SapTable["prototype"]["initializeBlockSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initializeBlockSelection"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo = null;
	/** @type {UCF_SapTable_CellInfo[]} */
	var aSelectedCells = [];
	/** @type {boolean} */
	var bCellSelected = false;
	/** @type {number} */
	var col;
	/** @type {number} */
	var row;
	/** @type {number} */
	var iRowStartIndex;
	/** @type {number} */
	var iRowEndIndex;
	/** @type {number} */
	var i;

	if (this["bBlockSelectionInitialized"]) return;

	if (this["bCanDataRequest"]() && this["oDataRequestInfo"] && this["oDataRequestInfo"]["aRowsLoadedRanges"]) {
		for (col = 0; col <= this["iGetCellInfoMatrixLastColIndex"](); col++) {
			for (i = 0; i < this["oDataRequestInfo"]["aRowsLoadedRanges"]["length"]; i++) {
				iRowStartIndex = this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] === 0 ? 0 : this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] + this["iGetContentRowOffset"]();
				iRowEndIndex = this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] + this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentLength"];
				for (row = iRowStartIndex; row <= iRowEndIndex; row++) {
					oCellInfo = this["oGetCellInfo"](row, col);
					if (!oCellInfo) continue;

					// TODO: eGetCellSelectionState returns 16 for API selected cells of SapTable but 32 of SapTableCS
					// -> API selected cell do not get identified with the logic underneath
					bCellSelected = (this["eGetCellSelectionState"](oCellInfo["iRowIndex"], oCellInfo["iColIndex"]) & this["SELECTION_LAYER"]["CELL"]) ? true : false;
					if (bCellSelected) {
						aSelectedCells["push"](oCellInfo);
					}
				}
			}
		}
	}
	else {
		for (col = 0; col <= this["iGetCellInfoMatrixLastColIndex"](); col++) {
			for (row = 0; row <= this["iGetCellInfoMatrixLastRowIndex"](); row++) {
				oCellInfo = this["oGetCellInfo"](row, col);
				if (!oCellInfo) continue;

				// TODO: eGetCellSelectionState returns 16 for API selected cells of SapTable but 32 of SapTableCS
				// -> API selected cell do not get identified with the logic underneath
				bCellSelected = (this["eGetCellSelectionState"](oCellInfo["iRowIndex"], oCellInfo["iColIndex"]) & this["SELECTION_LAYER"]["CELL"]) ? true : false;
				if (bCellSelected) {
					aSelectedCells["push"](oCellInfo);
				}
			}
		}
	}

	if (aSelectedCells["length"] > 0) {
		this["setCellSelectionStates"](aSelectedCells,	false, this["SELECTION_LAYER"]["CELL"]);
	}
	this["bBlockSelectionInitialized"] = true;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initializeBlockSelection"] = 0; };

/**
 * Applies the block selection
 * @private
 * @param {UCF_SapTable_BlockSelectionMode} sBlockSelectionMode
 * @param {boolean} bSetCellSelection
 */
UCF_SapTable["prototype"]["applyBlockSelection"] = function(sBlockSelectionMode, bSetCellSelection) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyBlockSelection"]++; }; 
	/** @type {string} */
	var sClassName = '';
	/** @type {HTMLDivElement} */
	var oResizeHandleTopLeft = document["createElement"]('DIV');
	/** @type {HTMLDivElement} */
	var oResizeHandleBottomRight = document["createElement"]('DIV');
	/** @type {HTMLDivElement} */
	var oResizeHandleTopRight = document["createElement"]('DIV');
	/** @type {HTMLDivElement} */
	var oResizeHandleBottomLeft = document["createElement"]('DIV');
	/** @type {number} */
	var col;
	/** @type {number} */
	var row;
	/** @type {number} */
	var iRowStartIndex;
	/** @type {number} */
	var iRowEndIndex;
	/** @type {number} */
	var i;

	this["setCopyToClipboardEnabled"](true);

	oResizeHandleTopLeft["setAttribute"]('id', this["sId"] + '-BSHandleTL');
	oResizeHandleTopLeft["setAttribute"]('acf', 'BLOCKSEL');
	sClassName = 'lsSTBSHandleTL';
	UCF_DomUtil["addClass"](oResizeHandleTopLeft, sClassName);

	oResizeHandleBottomRight["setAttribute"]('id', this["sId"] + '-BSHandleBR');
	oResizeHandleBottomRight["setAttribute"]('acf', 'BLOCKSEL');
	sClassName = 'lsSTBSHandleBR';
	UCF_DomUtil["addClass"](oResizeHandleBottomRight, sClassName);

	oResizeHandleTopRight["setAttribute"]('id', this["sId"] + '-BSHandleTR');
	oResizeHandleTopRight["setAttribute"]('acf', 'BLOCKSEL');
	sClassName = 'lsSTBSHandleTR';
	UCF_DomUtil["addClass"](oResizeHandleTopRight, sClassName);

	oResizeHandleBottomLeft["setAttribute"]('id', this["sId"] + '-BSHandleBL');
	oResizeHandleBottomLeft["setAttribute"]('acf', 'BLOCKSEL');
	sClassName = 'lsSTBSHandleBL';
	UCF_DomUtil["addClass"](oResizeHandleBottomLeft, sClassName);

	// performance optimization for selectAll scenario
	if (this["bCanDataRequest"]() && this["oDataRequestInfo"] && this["oDataRequestInfo"]["aRowsLoadedRanges"] && ((this["oBlockSelection"]["BottomRightRow"] - this["oBlockSelection"]["TopLeftRow"]) > this["iRowCountThreshold"])) {
		for (i = 0; i < this["oDataRequestInfo"]["aRowsLoadedRanges"]["length"]; i++) {
			iRowStartIndex = this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] === 0 ? 0 : this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] + this["iGetContentRowOffset"]();
			iRowEndIndex = this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] + this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentLength"];
			for (row = iRowStartIndex; row <= iRowEndIndex; row++) {
				if (row >= this["oBlockSelection"]["TopLeftRow"] && row <=this["oBlockSelection"]["BottomRightRow"]) {
					for (col = this["oBlockSelection"]["TopLeftCol"]; col <= this["oBlockSelection"]["BottomRightCol"]; col++) {
							this["applyBlockSelectionCell"](row, col, sBlockSelectionMode, bSetCellSelection, oResizeHandleTopLeft, oResizeHandleBottomRight, oResizeHandleTopRight, oResizeHandleBottomLeft);
					}
				}
			}
		}
	}
	else {
		for (col = this["oBlockSelection"]["TopLeftCol"]; col <= this["oBlockSelection"]["BottomRightCol"]; col++) {
			for (row = this["oBlockSelection"]["TopLeftRow"]; row <= this["oBlockSelection"]["BottomRightRow"]; row++) {
				this["applyBlockSelectionCell"](row, col, sBlockSelectionMode, bSetCellSelection, oResizeHandleTopLeft, oResizeHandleBottomRight, oResizeHandleTopRight, oResizeHandleBottomLeft);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyBlockSelection"] = 0; };
/* eslint-enable max-depth */

/**
 * Applies the block selection at cell level
 * @private
 * @param {number} iRowIndex
 * @param {number} iColIndex
 * @param {UCF_SapTable_BlockSelectionMode} sBlockSelectionMode
 * @param {boolean} bSetCellSelection
 * @param {HTMLElement} oResizeHandleTopLeft
 * @param {HTMLElement} oResizeHandleBottomRight
 * @param {HTMLElement} oResizeHandleTopRight
 * @param {HTMLElement} oResizeHandleTopRight
 */
UCF_SapTable["prototype"]["applyBlockSelectionCell"] = function(iRowIndex, iColIndex, sBlockSelectionMode, bSetCellSelection, oResizeHandleTopLeft, oResizeHandleBottomRight, oResizeHandleTopRight, oResizeHandleBottomLeft) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyBlockSelectionCell"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo = null;
	/** @type {HTMLElement} */
	var oDomRef = null;
	/** @type {string} */
	var sClassSuffix = '';
	/** @type {string} */
	var sClassName = '';
	/** @type {boolean} */
	var bBSHandled = false;
	/** @type {number} */
	var i;
	/** @type {UCF_SapTable_CellInfo[]} */
	var aSelectedCells = [];
	/** @type {boolean} */
	var bCellSelected = false;
	/** @type {boolean} */
	var bFound = false;

	oCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex);
	if (!oCellInfo) return;
	oDomRef = oCellInfo["oDomRefCell"];

	if (oDomRef) {
		bBSHandled = oDomRef["getAttribute"]('bs') === 'X';
		sClassName = 'lsSTBS';
		sClassSuffix = '';

		if (!bBSHandled) {
			if (iRowIndex === this["oBlockSelection"]["TopLeftRow"]) {
				sClassSuffix = 'T';
			}
			if (
				(iColIndex + oCellInfo["iColSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightCol"]
			) {
				sClassSuffix += 'R';
			}
			if (
				(iRowIndex + oCellInfo["iRowSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightRow"]
			) {
				sClassSuffix += 'B';
			}
			if (iColIndex === this["oBlockSelection"]["TopLeftCol"]) {
				sClassSuffix += 'L';
			}
			sClassName += sClassSuffix;
			UCF_DomUtil["addClass"](oDomRef, sClassName);
			oDomRef["setAttribute"]('bs', 'X');
			bCellSelected = ((this["eGetCellSelectionState"](oCellInfo["iRowIndex"], oCellInfo["iColIndex"]) & this["SELECTION_LAYER"]["CELL"]) ||
			(this["eGetColSelectionState"](oCellInfo["iColIndex"]) & this["SELECTION_LAYER"]["COLUMN"]) ||
			(this["eGetRowSelectionState"](oCellInfo["iRowIndex"]) & this["SELECTION_LAYER"]["ROW"]))  ? true : false;
			if (!bCellSelected) {
				aSelectedCells["push"](oCellInfo);
				for (i = 0; i < this["aTransformBlockSelectionCells"]["length"]; i++) {
					if (this["aTransformBlockSelectionCells"][i] === oCellInfo) {
						bFound = true;
						break;
					}
				}
				if (!bFound) this["aTransformBlockSelectionCells"]["push"](oCellInfo);
				bFound = false;
				if (sBlockSelectionMode === this["BLOCKSELECTION_MODE"]["NEUTRAL"]) {
					this["aNeutralBlockSelectionCells"]["push"](oCellInfo);
				}
				if (bSetCellSelection) {
					this["setCellSelectionStates"](
						aSelectedCells,
						true,
						this["SELECTION_LAYER"]["CELL"]
					);
				}
				aSelectedCells = [];
			}
			//TL, TR, BR, BL
			if (
				iColIndex === this["oBlockSelection"]["TopLeftCol"] &&
				iRowIndex === this["oBlockSelection"]["TopLeftRow"] &&
				(iColIndex + oCellInfo["iColSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightCol"] &&
				(iRowIndex + oCellInfo["iRowSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightRow"]
			) {
				oResizeHandleTopLeft["style"]["top"] = '0px';
				oResizeHandleTopLeft["style"]["left"] = '0px';
				oResizeHandleBottomRight["style"]["bottom"] = '0px';
				oResizeHandleBottomRight["style"]["right"] = '0px';
				oDomRef["appendChild"](oResizeHandleTopLeft);
				oDomRef["appendChild"](oResizeHandleBottomRight);

				oResizeHandleTopRight["style"]["top"] = '0px';
				oResizeHandleTopRight["style"]["right"] = '0px';
				oResizeHandleBottomLeft["style"]["bottom"] = '0px';
				oResizeHandleBottomLeft["style"]["left"] = '0px';
				oDomRef["appendChild"](oResizeHandleTopRight);
				oDomRef["appendChild"](oResizeHandleBottomLeft);

				oDomRef["style"]["position"] = 'relative';
				//TL, BL
			} else if (
				iColIndex === this["oBlockSelection"]["TopLeftCol"] &&
				iRowIndex === this["oBlockSelection"]["TopLeftRow"] &&
				(iRowIndex + oCellInfo["iRowSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightRow"]
			) {
				oResizeHandleTopLeft["style"]["top"] = '0px';
				oResizeHandleTopLeft["style"]["left"] = '0px';
				oDomRef["appendChild"](oResizeHandleTopLeft);
				oDomRef["style"]["position"] = 'relative';
				oResizeHandleBottomLeft["style"]["bottom"] = '0px';
				oResizeHandleBottomLeft["style"]["left"] = '0px';
				oDomRef["appendChild"](oResizeHandleBottomLeft);
				oDomRef["style"]["position"] = 'relative';
				//TL, TR
			} else if (
				iColIndex === this["oBlockSelection"]["TopLeftCol"] &&
				iRowIndex === this["oBlockSelection"]["TopLeftRow"] &&
				(iColIndex + oCellInfo["iColSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightCol"]
			) {
				oResizeHandleTopLeft["style"]["top"] = '0px';
				oResizeHandleTopLeft["style"]["left"] = '0px';
				oDomRef["appendChild"](oResizeHandleTopLeft);
				oDomRef["style"]["position"] = 'relative';
				oResizeHandleTopRight["style"]["top"] = '0px';
				oResizeHandleTopRight["style"]["right"] = '0px';
				oDomRef["appendChild"](oResizeHandleTopRight);
				oDomRef["style"]["position"] = 'relative';
				//TR, BR
			} else if (
				(iColIndex + oCellInfo["iColSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightCol"] &&
				(iRowIndex + oCellInfo["iRowSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightRow"] &&
				iRowIndex === this["oBlockSelection"]["TopLeftRow"]
			) {
				oResizeHandleTopRight["style"]["top"] = '0px';
				oResizeHandleTopRight["style"]["right"] = '0px';
				oDomRef["appendChild"](oResizeHandleTopRight);
				oDomRef["style"]["position"] = 'relative';
				oResizeHandleBottomRight["style"]["bottom"] = '0px';
				oResizeHandleBottomRight["style"]["right"] = '0px';
				oDomRef["appendChild"](oResizeHandleBottomRight);
				oDomRef["style"]["position"] = 'relative';
				//BR, BL
			} else if (
				(iColIndex + oCellInfo["iColSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightCol"] &&
				(iRowIndex + oCellInfo["iRowSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightRow"] &&
				iColIndex === this["oBlockSelection"]["TopLeftCol"]
			) {
				oResizeHandleBottomRight["style"]["bottom"] = '0px';
				oResizeHandleBottomRight["style"]["right"] = '0px';
				oDomRef["appendChild"](oResizeHandleBottomRight);
				oDomRef["style"]["position"] = 'relative';
				oResizeHandleBottomLeft["style"]["bottom"] = '0px';
				oResizeHandleBottomLeft["style"]["left"] = '0px';
				oDomRef["appendChild"](oResizeHandleBottomLeft);
				oDomRef["style"]["position"] = 'relative';
				//TL
			} else if (
				iColIndex === this["oBlockSelection"]["TopLeftCol"] &&
				iRowIndex === this["oBlockSelection"]["TopLeftRow"]
			) {
				oResizeHandleTopLeft["style"]["top"] = '0px';
				oResizeHandleTopLeft["style"]["left"] = '0px';
				oDomRef["appendChild"](oResizeHandleTopLeft);
				oDomRef["style"]["position"] = 'relative';
				//BR
			} else if (
				(iColIndex + oCellInfo["iColSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightCol"] &&
				(iRowIndex + oCellInfo["iRowSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightRow"]
			) {
				oResizeHandleBottomRight["style"]["bottom"] = '0px';
				oResizeHandleBottomRight["style"]["right"] = '0px';
				oDomRef["appendChild"](oResizeHandleBottomRight);
				oDomRef["style"]["position"] = 'relative';
				//TR
			} else if (
				(iColIndex + oCellInfo["iColSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightCol"] &&
				iRowIndex === this["oBlockSelection"]["TopLeftRow"]
			) {
				oResizeHandleTopRight["style"]["top"] = '0px';
				oResizeHandleTopRight["style"]["right"] = '0px';
				oDomRef["appendChild"](oResizeHandleTopRight);
				oDomRef["style"]["position"] = 'relative';
				//BL
			} else if (
				iColIndex === this["oBlockSelection"]["TopLeftCol"] &&
				(iRowIndex + oCellInfo["iRowSpan"] - 1) >=
				this["oBlockSelection"]["BottomRightRow"]
			) {
				oResizeHandleBottomLeft["style"]["bottom"] = '0px';
				oResizeHandleBottomLeft["style"]["left"] = '0px';
				oDomRef["appendChild"](oResizeHandleBottomLeft);
				oDomRef["style"]["position"] = 'relative';
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyBlockSelectionCell"] = 0; };

/* eslint-disable complexity */
/**
 * @private
 * @param {UCF_SapTable_BlockSelection} oBlockSelection
 * @param {UCF_SapTable_BlockSelectionMode} sBlockSelectionMode
 * @param {boolean} bSetCellSelection
 * @param {boolean} bInitialize
 */
UCF_SapTable["prototype"]["setBlockSelectionInternal"] = function(oBlockSelection, sBlockSelectionMode, bSetCellSelection, bInitialize) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setBlockSelectionInternal"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrentCellInfo;
	/** @type {number} */
	var col;
	/** @type {number} */
	var row;
	/** @type {number} */
	var iRowStartIndex;
	/** @type {number} */
	var iRowEndIndex;
	/** @type {UCF_SapTable_CellInfo[]} */
	var aSelectedCells = [];
	/** @type {UCF_SapTable_CellInfo[]} */
	var aCellsToDeselect = [];
	/** @type {boolean} */
	var bFound = false;
	/** @type {number} */
	var i;
	/** @type {number} */
	var j;
	/** @type {HTMLElement} */
	var oDomRef;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBlockSelection != null, "oBlockSelection != null", "SapTable.js(13119): setBlockSelectionInternal"); };

	// remove text selection in non editable editors (see bPermitTextSelection()) when setting a new blockSelection
	if (this["oSelectStartEditor"] && this["oSelectStartEditor"]["oDomRef"]) {
		if (this["oSelectStartEditor"]["oDomRef"]["select"]) {
			this["oSelectStartEditor"]["oDomRef"]["selectionStart"] = 0;
			this["oSelectStartEditor"]["oDomRef"]["selectionEnd"] = 0;
		} else {
			UCF_DomUtil["removeSelection"]();
		}
	}

	if (bInitialize && sBlockSelectionMode === this["BLOCKSELECTION_MODE"]["INITIALIZE"]) {
		this["initializeBlockSelection"]();
	}

	if (
		this["oBlockSelection"] &&
		UCF_JsUtil["keys"](this["oBlockSelection"])["length"] > 0
	) {
		// performance optimization for selectAll scenario
		if (this["bCanDataRequest"]() && this["oDataRequestInfo"] && this["oDataRequestInfo"]["aRowsLoadedRanges"] && ((this["oBlockSelection"]["BottomRightRow"] - this["oBlockSelection"]["TopLeftRow"]) > this["iRowCountThreshold"])) {
			for (i = 0; i < this["oDataRequestInfo"]["aRowsLoadedRanges"]["length"]; i++) {
				iRowStartIndex = this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] === 0 ? 0 : this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] + this["iGetContentRowOffset"]();
				iRowEndIndex = this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentOffset"] + this["oDataRequestInfo"]["aRowsLoadedRanges"][i]["SegmentLength"];
				for (row = iRowStartIndex; row <= iRowEndIndex; row++) {
					if (row >= this["oBlockSelection"]["TopLeftRow"] && row <=this["oBlockSelection"]["BottomRightRow"]) {
						for (col = this["oBlockSelection"]["TopLeftCol"]; col <= this["oBlockSelection"]["BottomRightCol"]; col++) {
							oCurrentCellInfo = this["oGetCellInfo"](row, col);
							if (!oCurrentCellInfo) continue;
							oDomRef = oCurrentCellInfo["oDomRefCell"];
							if (oDomRef) this["cleanupBlockSelectionCellStyles"](oDomRef);
							aSelectedCells["push"](oCurrentCellInfo);
						}
					}
				}
			}
		}
		else {
			for (col = this["oBlockSelection"]["TopLeftCol"]; col <= this["oBlockSelection"]["BottomRightCol"]; col++) {
				for (row = this["oBlockSelection"]["TopLeftRow"]; row <= this["oBlockSelection"]["BottomRightRow"]; row++) {
					oCurrentCellInfo = this["oGetCellInfo"](row, col);
					if (!oCurrentCellInfo) continue;
					oDomRef = oCurrentCellInfo["oDomRefCell"];
					if (oDomRef) this["cleanupBlockSelectionCellStyles"](oDomRef);
					aSelectedCells["push"](oCurrentCellInfo);
				}
			}
		}
	}
	if (!this["oLS"]["oGetDragSession"]()) {
		if (
			sBlockSelectionMode !== this["BLOCKSELECTION_MODE"]["NEUTRAL"] &&
			aSelectedCells
		) {
			// this.aBlockSelectionCells = this.aBlockSelectionCells.concat(
			// 	aSelectedCells
			// );

			for (i = 0; i < aSelectedCells["length"]; i++) {
				for (j = 0; j < this["aBlockSelectionCells"]["length"]; j++) {
					if (aSelectedCells[i] === this["aBlockSelectionCells"][j]) {
						bFound = true;
						break;
					}
				}
				if (!bFound && aSelectedCells[i]["oDomRefCell"]) this["aBlockSelectionCells"]["push"](aSelectedCells[i]);
				bFound = false;
			}

		}
		if (
			sBlockSelectionMode === this["BLOCKSELECTION_MODE"]["INITIALIZE"] &&
			this["aBlockSelectionCells"]["length"] > 0
		) {
			this["setCellSelectionStates"](
				this["aBlockSelectionCells"],
				false,
				this["SELECTION_LAYER"]["CELL"]
			);
			this["aBlockSelectionCells"] = [];
		}
		if (
			sBlockSelectionMode === this["BLOCKSELECTION_MODE"]["NEUTRAL"] &&
			aSelectedCells &&
			aSelectedCells["length"] > 0
		) {
			this["setCellSelectionStates"](
				aSelectedCells,
				false,
				this["SELECTION_LAYER"]["CELL"]
			);
		}
	}
	else {
		if (
			sBlockSelectionMode !== this["BLOCKSELECTION_MODE"]["NEUTRAL"] &&
			aSelectedCells
		) {
			// this.aBlockSelectionCells = this.aBlockSelectionCells.concat(
			// 	aSelectedCells
			// );

			for (i = 0; i < aSelectedCells["length"]; i++) {
				for (j = 0; j < this["aBlockSelectionCells"]["length"]; j++) {
					if (aSelectedCells[i] === this["aBlockSelectionCells"][j]) {
						bFound = true;
						break;
					}
				}
				if (!bFound && aSelectedCells[i]["oDomRefCell"]) this["aBlockSelectionCells"]["push"](aSelectedCells[i]);
				bFound = false;
			}

		}
		if (
			sBlockSelectionMode === this["BLOCKSELECTION_MODE"]["INITIALIZE"] &&
			this["aTransformBlockSelectionCells"]["length"] > 0
		) {
			this["setCellSelectionStates"](
				this["aTransformBlockSelectionCells"],
				false,
				this["SELECTION_LAYER"]["CELL"]
			);
			this["aTransformBlockSelectionCells"] = [];
		}
		if (sBlockSelectionMode !== this["BLOCKSELECTION_MODE"]["NEUTRAL"]) {
			this["aNeutralBlockSelectionCells"] = [];
		}
		if (
			sBlockSelectionMode === this["BLOCKSELECTION_MODE"]["NEUTRAL"] &&
			aSelectedCells &&
			aSelectedCells["length"] > 0
		) {
			for (i = 0; i < aSelectedCells["length"]; i++) {
				for (j = 0; j < this["aNeutralBlockSelectionCells"]["length"]; j++) {
					if (aSelectedCells[i] === this["aNeutralBlockSelectionCells"][j]) {
						bFound = true;
						break;
					}
				}
				if (bFound) aCellsToDeselect["push"](aSelectedCells[i]);
				bFound = false;
			}

			this["setCellSelectionStates"](
				aCellsToDeselect,
				false,
				this["SELECTION_LAYER"]["CELL"]
			);
		}
	}

	// store former blockSelection
	if (this["oBlockSelection"]) {
		if (UCF_JsUtil["keys"](this["oBlockSelection"])["length"] > 0) {
			this["oBlockSelectionPrevious"] = {
				"TopLeftCol": this["oBlockSelection"]["TopLeftCol"],
				"TopLeftRow": this["oBlockSelection"]["TopLeftRow"],
				"BottomRightCol": this["oBlockSelection"]["BottomRightCol"],
				"BottomRightRow": this["oBlockSelection"]["BottomRightRow"]
			};
		} else {
			this["oBlockSelectionPrevious"] = this["oBlockSelection"];
		}
	}

	if (UCF_JsUtil["keys"](oBlockSelection)["length"] > 0) {
		this["oBlockSelection"] = {
			"TopLeftCol": oBlockSelection["TopLeftCol"],
			"TopLeftRow": oBlockSelection["TopLeftRow"],
			"BottomRightCol": oBlockSelection["BottomRightCol"],
			"BottomRightRow": oBlockSelection["BottomRightRow"]
		};
		this["applyBlockSelection"](sBlockSelectionMode, bSetCellSelection);
		UCF_DomUtil["addClass"](this["oRootRef"], 'lsSapTable--bs-exist');
	} else {
		this["oBlockSelection"] = oBlockSelection;
		UCF_DomUtil["removeClass"](this["oRootRef"], 'lsSapTable--bs-exist');
	}
	this["oSelectionInfo"]["bBlockSelectAll"] = this["bSelectionInfoBlockSelectAll"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setBlockSelectionInternal"] = 0; };
/* eslint-enable complexity */

/**
 * @private
 * @param {HTMLElement} oDomRef
 */
UCF_SapTable["prototype"]["cleanupBlockSelectionCellStyles"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanupBlockSelectionCellStyles"]++; }; 
	/** @type {HTMLDivElement} */
	var oResizeHandleTopLeft;
	/** @type {HTMLDivElement} */
	var oResizeHandleBottomRight;
	/** @type {HTMLDivElement} */
	var oResizeHandleTopRight;
	/** @type {HTMLDivElement} */
	var oResizeHandleBottomLeft;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTable.js(13317): cleanupBlockSelectionCellStyles"); };

	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBST');
	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSR');
	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSB');
	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSL');

	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSTR');
	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSTB');
	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSTL');
	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSTRB');
	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSTRL');
	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSTRBL');
	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSTBL');

	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSRB');
	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSRL');
	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSRBL');

	UCF_DomUtil["removeClass"](oDomRef, 'lsSTBSBL');

	oDomRef["setAttribute"]('bs', '');

	oResizeHandleTopLeft = UCF_DomUtil["oGetFirstChildByAttribute"](
		oDomRef,
		'id',
		this["sId"] + '-BSHandleTL'
	);
	if (oResizeHandleTopLeft) {
		oDomRef["removeChild"](oResizeHandleTopLeft);
		oDomRef["style"]["position"] = '';
	}

	oResizeHandleBottomRight = UCF_DomUtil["oGetFirstChildByAttribute"](
		oDomRef,
		'id',
		this["sId"] + '-BSHandleBR'
	);
	if (oResizeHandleBottomRight) {
		oDomRef["removeChild"](oResizeHandleBottomRight);
		oDomRef["style"]["position"] = '';
	}

	oResizeHandleTopRight = UCF_DomUtil["oGetFirstChildByAttribute"](
		oDomRef,
		'id',
		this["sId"] + '-BSHandleTR'
	);
	if (oResizeHandleTopRight) {
		oDomRef["removeChild"](oResizeHandleTopRight);
		oDomRef["style"]["position"] = '';
	}

	oResizeHandleBottomLeft = UCF_DomUtil["oGetFirstChildByAttribute"](
		oDomRef,
		'id',
		this["sId"] + '-BSHandleBL'
	);
	if (oResizeHandleBottomLeft) {
		oDomRef["removeChild"](oResizeHandleBottomLeft);
		oDomRef["style"]["position"] = '';
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanupBlockSelectionCellStyles"] = 0; };

/**
 * Sets a set of cellInfos to the given state
 *
 * @private
 * @param {UCF_SapTable_CellInfo[]} aCellInfos
 * @param {boolean} bSet true=select; false=deselect
 * @param {UCF_SapTable_Modifiermask} mOperationMap The operation map defines
 * which kinds of selection layers have to be applied or unapplied
 */
UCF_SapTable["prototype"]["setCellSelectionStates"] = function(aCellInfos, bSet, mOperationMap) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCellSelectionStates"]++; }; 
	/** @type {number} */
	var i;
	/** @type {number} */
	var j;
	/** @type {number} */
	var k;
	/** @type {UCF_InputFieldHelpButton} */
	var oInputFieldHelpButton;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(aCellInfos != null, "aCellInfos != null", "SapTable.js(13400): setCellSelectionStates"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof mOperationMap === 'number', "typeof mOperationMap === 'number'", "SapTable.js(13401): setCellSelectionStates"); };

	for (i = 0; i < aCellInfos["length"]; i++) {
		this["initializeCellSelectionState"](aCellInfos[i]);
	}

	for (j = 0; j < aCellInfos["length"]; j++) {
		this["applyCellSelectionState"](aCellInfos[j], bSet, mOperationMap);
	}

	for (k = 0; k < aCellInfos["length"]; k++) {
		this["applyCellSelectionStateUi"](aCellInfos[k]);
	}

	this["doRowHoveringEffectUpdate"](aCellInfos);

	// Align InputFieldHelpButton with connected control after applying selection
	// state styles to cell
	oInputFieldHelpButton = this["oLS"]["oControlFactory"]
		["oGetControlById"]('ls-inputfieldhelpbutton');
	if (
		oInputFieldHelpButton &&
		oInputFieldHelpButton["oConnectedControl"] &&
		oInputFieldHelpButton["oConnectedControl"]["bIsChildOf"](this)
	) {
		oInputFieldHelpButton["alignStylesWithControl"](
			oInputFieldHelpButton["oConnectedControl"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setCellSelectionStates"] = 0; };

/**
 * Sets the cell selection state of a given row to the given state
 *
 * @private
 * @param {number} iRowIndex
 * @param {boolean} bSet true=select; false=deselect
 * @param {UCF_SapTable_Modifiermask} mOperationMap The operation map defines
 * which kinds of selection layers have to be applied or unapplied
 */
UCF_SapTable["prototype"]["setRowCellSelectionStates"] = function(iRowIndex, bSet, mOperationMap) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowCellSelectionStates"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iRowIndex === 'number', "typeof iRowIndex === 'number'", "SapTable.js(13442): setRowCellSelectionStates"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof mOperationMap === 'number', "typeof mOperationMap === 'number'", "SapTable.js(13443): setRowCellSelectionStates"); };

	this["setCellSelectionStates"](
		this["aCollectCellsForRowSelection"](iRowIndex),
		bSet,
		mOperationMap
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowCellSelectionStates"] = 0; };

/**
 * Applies the given selection state to a cellInfo without updating the UI
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {boolean} bSet true=select; false=deselect
 * @param {UCF_SapTable_Modifiermask} mOperationMap The operation map defines
 * which kinds of selection layers have to be applied or unapplied
 */
UCF_SapTable["prototype"]["applyCellSelectionState"] = function(oCellInfo, bSet, mOperationMap) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyCellSelectionState"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(13462): applyCellSelectionState"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof mOperationMap === 'number', "typeof mOperationMap === 'number'", "SapTable.js(13463): applyCellSelectionState"); };

	if (
		// Cells with rowspan > 1 cannot visualize row selection
		(oCellInfo["iRowSpan"] === 1 || (
			mOperationMap !== this["SELECTION_LAYER"]["Row"] &&
			mOperationMap !== this["SELECTION_LAYER"]["ROW_PRIMARY"]
		)) &&
		// Cells with colspan > 1 cannot visualize column selection
		(oCellInfo["iColSpan"] === 1 || mOperationMap !== this["SELECTION_LAYER"]["COLUMN"])
	) {
		oCellInfo["iLastSelectionState"] = oCellInfo["iSelectionState"];
		// Used for 508 announcement -> UCF_SapTableBaseCell
		oCellInfo["bSelectionClientModified"] = true;

		if (bSet) {
			oCellInfo["iSelectionState"] |= mOperationMap;
		} else {
			oCellInfo["iSelectionState"] &= ~mOperationMap;
		}

		if (window["UCF_System"]["bIsAria"] &&	this["bIsValidCellInfo"](oCellInfo)) {
			oCellInfo["oDomRefCell"]["setAttribute"](
				'aria-selected',
				((oCellInfo["iSelectionState"] & (
					this["SELECTION_LAYER"]["COLUMN"] |
					this["SELECTION_LAYER"]["CELL"] |
					this["SELECTION_LAYER"]["ROW"] |
					this["SELECTION_LAYER"]["ROW_PRIMARY"])) > 0)
				? 'true'
				: 'false'
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyCellSelectionState"] = 0; };

/* eslint-disable complexity */
/**
 * Updates the selection state UI of a cell
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["applyCellSelectionStateUi"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyCellSelectionStateUi"]++; }; 
	/** @type {UCF_SapTable_CellType} */
	var eCellType;
	/** @type {boolean} */
	var bSelectedBefore;
	/** @type {boolean} */
	var bSelectedPrimaryBefore;
	/** @type {boolean} */
	var bSelectedAfter;
	/** @type {boolean} */
	var bSelectedPrimaryAfter;
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {string} */
	var sCssClasses;
	/** @type {boolean} */
	var bIsReadOnly;
	/** @type {string} */
	var sClassToReplace;
	/** @type {string} */
	var sClassToApply;
	/** @type {string} */
	var sCustomStyle;
	/** @type {HTMLElement} */
	var oAriaTutorDomRef;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(13532): applyCellSelectionStateUi"); };

	eCellType = this["eGetCellType"](oCellInfo);

	if (
		eCellType === this["SUBCONTROL"]["STANDARD_CELL"] ||
		eCellType === this["SUBCONTROL"]["HIERARCHY_CELL"]
	) {
		bSelectedBefore = !!(
			(oCellInfo["iLastSelectionState"] & this["SELECTION_LAYER"]["ROW"]) ||
			(oCellInfo["iLastSelectionState"] & this["SELECTION_LAYER"]["COLUMN"]) ||
			(oCellInfo["iLastSelectionState"] & this["SELECTION_LAYER"]["CELL"])
		);
		bSelectedPrimaryBefore = !!(
			oCellInfo["iLastSelectionState"] & this["SELECTION_LAYER"]["ROW_PRIMARY"]
		);
		bSelectedAfter = !!(
			(oCellInfo["iSelectionState"] & this["SELECTION_LAYER"]["ROW"]) ||
			(oCellInfo["iSelectionState"] & this["SELECTION_LAYER"]["COLUMN"]) ||
			(oCellInfo["iSelectionState"] & this["SELECTION_LAYER"]["CELL"])
		);
		bSelectedPrimaryAfter = !!(
			oCellInfo["iSelectionState"] & this["SELECTION_LAYER"]["ROW_PRIMARY"]
		);

		if (
			bSelectedBefore !== bSelectedAfter ||
			bSelectedPrimaryBefore !== bSelectedPrimaryAfter
		) {
			oDomRef = oCellInfo["oDomRefCell"];
			sCssClasses = UCF_DomUtil["sGetClass"](oDomRef);
			bIsReadOnly = sCssClasses["indexOf"]('urSTTDRo2') > -1;
			sClassToReplace = (
					bSelectedPrimaryBefore &&
					!this["bRowSelectionImplicitPrimary"]
				)
				? (bIsReadOnly ? ' urST4SelRo' : ' urST4Sel')
				: (bSelectedPrimaryBefore || bSelectedBefore)
				? (bIsReadOnly ? ' urST4Sel2Ro' : ' urST4Sel2')
				: null;
			sClassToApply = (
					bSelectedPrimaryAfter &&
					!this["bRowSelectionImplicitPrimary"]
				)
				? (bIsReadOnly ? ' urST4SelRo' : ' urST4Sel')
				: (bSelectedPrimaryAfter || bSelectedAfter)
				? (bIsReadOnly ? ' urST4Sel2Ro' : ' urST4Sel2')
				: null;
			sCssClasses = (sClassToApply && sClassToReplace)
				? sCssClasses["replace"](sClassToReplace, sClassToApply)
				: sClassToApply
				? sCssClasses + sClassToApply
				: sClassToReplace
				? sCssClasses["replace"](sClassToReplace, '')
				: sCssClasses;
			sCustomStyle = oCellInfo["oDomRefCell"]["getAttribute"]('cStyle');

			if (sCustomStyle) {
				sCssClasses = (bSelectedPrimaryAfter || bSelectedAfter)
					? sCssClasses["replace"](' ' + sCustomStyle + 'NotSel', '')
					: sCssClasses + ' ' + sCustomStyle + 'NotSel';
			}

			UCF_DomUtil["setClass"](oDomRef, sCssClasses);
		}
	} else if (eCellType === this["SUBCONTROL"]["SELECTION_CELL"]) {
		bSelectedBefore = !!(
			oCellInfo["iLastSelectionState"] & this["SELECTION_LAYER"]["ROW"]
		);
		bSelectedPrimaryBefore = !!(
			oCellInfo["iLastSelectionState"] & this["SELECTION_LAYER"]["ROW_PRIMARY"]
		);
		bSelectedAfter = !!(
			oCellInfo["iSelectionState"] & this["SELECTION_LAYER"]["ROW"]
		);
		bSelectedPrimaryAfter = !!(
			oCellInfo["iSelectionState"] & this["SELECTION_LAYER"]["ROW_PRIMARY"]
		);

		// In sap_belize, the selection cell must have the same selection
		// background color as the row
		if (
			bSelectedBefore !== bSelectedAfter ||
			bSelectedPrimaryBefore !== bSelectedPrimaryAfter
		) {
			oDomRef = oCellInfo["oDomRefCell"];
			bIsReadOnly = false;
			sClassToReplace = (
					bSelectedPrimaryBefore &&
					!this["bRowSelectionImplicitPrimary"]
				)
				? (bIsReadOnly ? ' lsSTTDScSelBgColorRo' : ' lsSTTDScSelBgColor')
				: (bSelectedPrimaryBefore || bSelectedBefore)
				? (bIsReadOnly ? ' lsSTTDScSel2BgColorRo' : ' lsSTTDScSel2BgColor')
				: null;
			sClassToApply = (
					bSelectedPrimaryAfter &&
					!this["bRowSelectionImplicitPrimary"]
				)
				? (bIsReadOnly ? ' lsSTTDScSelBgColorRo' : ' lsSTTDScSelBgColor')
				: (bSelectedPrimaryAfter || bSelectedAfter)
				? (bIsReadOnly ? ' lsSTTDScSel2BgColorRo' : ' lsSTTDScSel2BgColor')
				: null;
			sCssClasses = UCF_DomUtil["sGetClass"](oDomRef);
			sCssClasses = (sClassToApply && sClassToReplace)
				? sCssClasses["replace"](sClassToReplace, sClassToApply)
				: sClassToApply
				? sCssClasses + sClassToApply
				: sClassToReplace
				? sCssClasses["replace"](sClassToReplace, '')
				: sCssClasses;

			UCF_DomUtil["setClass"](oDomRef, sCssClasses);
		}

		if (
			bSelectedBefore !== bSelectedAfter ||
			bSelectedPrimaryBefore !== bSelectedPrimaryAfter
		) {
			oDomRef = UCF_DomUtil["oGetFirstElement"](oCellInfo["oDomRefCell"]);
			// IE correction - cf. SapTableSelectionCell.renderer
			while (oDomRef && !UCF_DomUtil["bHasClass"](oDomRef, 'urSTSCOuterDiv')) {
				oDomRef = UCF_DomUtil["oGetFirstElement"](oDomRef);
			}
			sClassToReplace = bSelectedPrimaryBefore
				? 'urSTRowSelIcon'
				: bSelectedBefore
				? 'urSTRowSelSecIcon'
				: 'urSTRowUnSelIcon';
			sCssClasses = UCF_DomUtil["sGetClass"](oDomRef);
			sCssClasses = bSelectedPrimaryAfter
				? sCssClasses["replace"](sClassToReplace, 'urSTRowSelIcon')
				: bSelectedAfter
				? sCssClasses["replace"](sClassToReplace, 'urSTRowSelSecIcon')
				: sCssClasses["replace"](sClassToReplace, 'urSTRowUnSelIcon');
			sCssClasses = (
					(bSelectedPrimaryBefore || bSelectedBefore) &&
					!bSelectedPrimaryAfter &&
					!bSelectedAfter
				)
				? sCssClasses["replace"](' urST4LbSelIcon', ' urST4LbUnselIcon')
				: (
					(bSelectedPrimaryAfter || bSelectedAfter) &&
					!bSelectedPrimaryBefore &&
					!bSelectedBefore
				)
				? sCssClasses["replace"](' urST4LbUnselIcon', ' urST4LbSelIcon')
				: sCssClasses;

			UCF_DomUtil["setClass"](oDomRef, sCssClasses);

			if (window["UCF_System"]["bIsAria"]) {
				oAriaTutorDomRef = UCF_DomUtil["$"](oCellInfo["oDomRefCell"]["getAttribute"]('id') + '-ariatutor');
				if (oAriaTutorDomRef) {
					if (bSelectedPrimaryAfter && this["sRowSelectionMode"] === 'SINGLE_PRIMARY_MANDATORY') {
						UCF_DomUtil["setInnerText"](oAriaTutorDomRef, '');
					}
					else {
						UCF_DomUtil["setInnerText"](oAriaTutorDomRef, bSelectedAfter || bSelectedPrimaryAfter ? this["oLS"]["sGetText"]('SAPUR_ST_SC_SROW_STATE_TUT') : this["oLS"]["sGetText"]('SAPUR_ST_SC_NROW_TUT'));
					}
				}
				if (oCellInfo["oDomRefCell"]) oCellInfo["oDomRefCell"]["setAttribute"]('aria-selected', bSelectedAfter || bSelectedPrimaryAfter ? 'true' : 'false');
			}
		}
	} else if (eCellType === this["SUBCONTROL"]["HEADER_CELL"]) {
		bSelectedBefore = !!(
			oCellInfo["iLastSelectionState"] & this["SELECTION_LAYER"]["COLUMN"]
		);
		bSelectedAfter = !!(
			oCellInfo["iSelectionState"] & this["SELECTION_LAYER"]["COLUMN"]
		);

		if (bSelectedBefore !== bSelectedAfter) {
			oDomRef = oCellInfo["oDomRefCell"];
			sCssClasses = UCF_DomUtil["sGetClass"](oDomRef);

			UCF_DomUtil["setClass"](oDomRef, bSelectedAfter
				? sCssClasses
				["replace"]('urST3HUnsel', 'urST3HSel')
				["replace"]('urST4LbHdrBg', 'urST4LbHdrSelBg')
				: sCssClasses
				["replace"]('urST3HSel', 'urST3HUnsel')
				["replace"]('urST4LbHdrSelBg', 'urST4LbHdrBg')
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyCellSelectionStateUi"] = 0; };
/* eslint-enable complexity */

/**
 * Returns the y matrix position index of a row which is currently visible and
 * displayed. It can be taken to calculate offsetWidth etc.
 *
 * @private
 * @param {HTMLElement} oSegment the DomRef of the segment
 * @return {number} y matrix position index of the reference row
 */
UCF_SapTable["prototype"]["iGetFirstActiveRowOfSegment"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetFirstActiveRowOfSegment"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTable.js(13730): iGetFirstActiveRowOfSegment"); };

	return this["iGetSegmentOffsetRowIndex"](oSegment);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetFirstActiveRowOfSegment"] = 0; };

/**
 * @private
 * @param {number} iRowIndex The internal row cell matrix index
 * @return {UCF_SapTable_CellInfo} the cell info in given row which covers all
 * row states
 */
UCF_SapTable["prototype"]["oGetRowReferenceCell"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetRowReferenceCell"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oReferenceCell;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iRowIndex === 'number', "typeof iRowIndex === 'number'", "SapTable.js(13745): oGetRowReferenceCell"); };

	oReferenceCell = this["oGetCellInfo"](iRowIndex, 0);

	return (
			this["bIsValidCellInfo"](oReferenceCell) && (
				this["eGetCellType"](oReferenceCell) === this["SUBCONTROL"]["SELECTION_CELL"] ||
				oReferenceCell["oDomRefRow"]["getAttribute"]('sst')
			)
		)
		? oReferenceCell
		: null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetRowReferenceCell"] = 0; };

/**
 * Returns the cell info in given column which covers all column states
 *
 * @private
 * @param {number} iColIndex The internal column cell matrix index
 * @return {UCF_SapTable_CellInfo} The CellInfo
 */
UCF_SapTable["prototype"]["oGetColReferenceCell"] = function(iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetColReferenceCell"]++; }; 
	/** @type {number} */
	var iLastRowIndex = this["iGetCellInfoMatrixLastRowIndex"]();
	/** @type {UCF_SapTable_CellInfo} */
	var oReferenceCell;
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrCell;
	/** @type {number} */
	var i;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iColIndex === 'number', "typeof iColIndex === 'number'", "SapTable.js(13776): oGetColReferenceCell"); };

	for (i = 0; i <= iLastRowIndex; i++) {
		oCurrCell = this["oGetCellInfo"](i, iColIndex);

		if (
			this["bIsValidCellInfo"](oCurrCell) &&
			this["eGetCellType"](oCurrCell) === this["SUBCONTROL"]["HEADER_CELL"]
		) {
			oReferenceCell = oCurrCell;
		} else {
			break;
		}
	}

	return oReferenceCell;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetColReferenceCell"] = 0; };

/* eslint-disable no-magic-numbers */
/**
 * Initializes the client selection state by reading the rendering data of a
 * cell
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["initializeCellSelectionState"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initializeCellSelectionState"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefCell = oCellInfo["oDomRefCell"];
	/** @type {UCF_SapTable_CellType} */
	var eCellType;
	/** @type {string} */
	var sServerSelectionState;
	/** @type {number} */
	var iServerSelectionState;
	/** @type {UCF_SapTable_SelectionLayer} */
	var iSelectionState;
	/** @type {boolean} */
	var bServerSelectionState;

	if (!oDomRefCell["bCellSelectionStateInitialized"]) {
		eCellType = this["eGetCellType"](oCellInfo);
		sServerSelectionState = null;
		iServerSelectionState = 0;
		iSelectionState = this["SELECTION_LAYER"]["NONE"];

		if (eCellType === this["SUBCONTROL"]["HEADER_CELL"]) {
			sServerSelectionState = oDomRefCell["getAttribute"]('sst');
			iServerSelectionState = sServerSelectionState
				? parseInt(sServerSelectionState, 10)
				: 0;

			// Selected=1, Selectable=2, Disabled=4,
			iSelectionState = (
					(iServerSelectionState & 2) ||
					!(iServerSelectionState & 4)
				)
				// Selectable || Enabled
				? ((iServerSelectionState & 1)
					// Selected
					? this["SELECTION_LAYER"]["COLUMN"]
					: this["SELECTION_LAYER"]["NONE"])
				: this["SELECTION_LAYER"]["COLUMN_DISABLED"];
		} else if (
			eCellType === this["SUBCONTROL"]["STANDARD_CELL"] ||
			eCellType === this["SUBCONTROL"]["HIERARCHY_CELL"]
		) {
			bServerSelectionState = !!oDomRefCell["getAttribute"]('sst');

			// Cell selection state
			if (bServerSelectionState) {
				iSelectionState |= this["SELECTION_LAYER"]["CELL"];
			}

			// Column selection state
			if (oCellInfo["iColSpan"] === 1) {
				iSelectionState |= this["eGetColSelectionState"](oCellInfo["iColIndex"]);
			}
		}

		// Row selection state
		if (oCellInfo["iRowSpan"] === 1) {
			if (oCellInfo["oDomRefRow"]["getAttribute"]('sst')) {
				// take selection state from row DOM reference
				sServerSelectionState = oCellInfo["oDomRefRow"]["getAttribute"]('sst');
			} else if (eCellType === this["SUBCONTROL"]["SELECTION_CELL"]) {
				// When no selection state is set the row selection state is NONE. The
				// row can be selected
				sServerSelectionState = oDomRefCell["getAttribute"]('sst') || '0';
			}

			// When no selection state is set the whole row does not take part on the
			// selection
			if (sServerSelectionState) {
				//PrimarySelected=1, SecondarySelected=2, Disabled=4, NotDeselectable=8
				iServerSelectionState = sServerSelectionState
					? parseInt(sServerSelectionState, 10)
					: 0;

				if (iServerSelectionState & 1) {
					iSelectionState |= this["SELECTION_LAYER"]["ROW_PRIMARY"];
				}
				if (iServerSelectionState & 2) {
					iSelectionState |= this["SELECTION_LAYER"]["ROW"];
				}
				if (iServerSelectionState & 4) {
					iSelectionState |= this["SELECTION_LAYER"]["ROW_DISABLED"];
				}
			} else if (
				oCellInfo["iRowIndex"] > 0 &&
				eCellType !== this["SUBCONTROL"]["SELECTION_CELL"]
			) {
				// No row selection info available -> check reference cell on
				// colIndex=0
				iSelectionState |= this["eGetRowSelectionState"](oCellInfo["iRowIndex"]);
			} else {
				iSelectionState |= this["SELECTION_LAYER"]["ROW_DISABLED"];
			}
		}

		oCellInfo["iSelectionState"] = iSelectionState;
		oDomRefCell["bCellSelectionStateInitialized"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initializeCellSelectionState"] = 0; };
/* eslint-enable no-magic-numbers */

/**
 * Returns all primary and secondary selected rows
 *
 * @private
 * @return {UCF_SapTable_CellInfo[] & {iPrimary: number}} Array of
 * ReferenceCellInfos of the rows (SelectionCells)
 */
UCF_SapTable["prototype"]["aGetSelectedRows"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetSelectedRows"]++; }; 
	var iMaxRowIndex = this["iGetCellInfoMatrixLastRowIndex"]();
	var eSelectionState = null;
	/** @type {UCF_SapTable_CellInfo[] & {iPrimary: number}} */
	var aCellInfos = [];
	/** @type {number} */
	var iRowIndex;

	for (iRowIndex = 0; iRowIndex <= iMaxRowIndex; iRowIndex++) {
		eSelectionState = this["eGetRowSelectionState"](iRowIndex);

		if (
			(eSelectionState & this["SELECTION_LAYER"]["ROW_PRIMARY"]) ||
			(eSelectionState & this["SELECTION_LAYER"]["ROW"])
		) {
			aCellInfos[aCellInfos["length"]] = this["oGetRowReferenceCell"](iRowIndex);

			if (eSelectionState & this["SELECTION_LAYER"]["ROW_PRIMARY"]) {
				aCellInfos["iPrimary"] = aCellInfos["length"] - 1;
			}
		}
	}

	return aCellInfos;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetSelectedRows"] = 0; };

/**
 * Returns all rows
 *
 * @private
 * @return {UCF_SapTable_CellInfo[]} Array of ReferenceCellInfos of the rows
 * (SelectionCells)
 */
UCF_SapTable["prototype"]["aGetRows"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetRows"]++; }; 
	/** @type {number} */
	var iMaxRowIndex = this["iGetCellInfoMatrixLastRowIndex"]();
	/** @type {UCF_SapTable_CellInfo[]} */
	var aCellInfos = [];
	/** @type {number} */
	var iRowIndex;

	for (iRowIndex = 0; iRowIndex <= iMaxRowIndex; iRowIndex++) {
		aCellInfos[aCellInfos["length"]] = this["oGetRowReferenceCell"](iRowIndex);
	}

	return aCellInfos;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetRows"] = 0; };

/**
 * Returns the selection state of a given row
 *
 * @private
 * @param {number} iRowIndex The internal row cell matrix index
 * @return {UCF_SapTable_SelectionLayer} The selection state
 */
UCF_SapTable["prototype"]["eGetRowSelectionState"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["eGetRowSelectionState"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oReferenceCell;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iRowIndex === 'number', "typeof iRowIndex === 'number'", "SapTable.js(13968): eGetRowSelectionState"); };

	oReferenceCell = this["oGetRowReferenceCell"](iRowIndex);

	if (this["bIsValidCellInfo"](oReferenceCell)) {
		if (!oReferenceCell["oDomRefCell"]["bCellSelectionStateInitialized"]) {
			this["initializeCellSelectionState"](oReferenceCell);
		}

		return oReferenceCell["iSelectionState"] & (
			this["SELECTION_LAYER"]["ROW"] |
			this["SELECTION_LAYER"]["ROW_PRIMARY"] |
			this["SELECTION_LAYER"]["ROW_DISABLED"]
		);
	}

	return this["SELECTION_LAYER"]["ROW_DISABLED"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["eGetRowSelectionState"] = 0; };

/**
 * Returns the selection state of a given cell
 *
 * @private
 * @param {number} iRowIndex The internal row cell matrix index
 * @param {number} iColIndex The internal column cell matrix index
 * @return {UCF_SapTable_SelectionLayer} The selection state
 */
UCF_SapTable["prototype"]["eGetCellSelectionState"] = function(iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["eGetCellSelectionState"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oReferenceCell;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iRowIndex === 'number', "typeof iRowIndex === 'number'", "SapTable.js(13999): eGetCellSelectionState"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iColIndex === 'number', "typeof iColIndex === 'number'", "SapTable.js(14000): eGetCellSelectionState"); };

	oReferenceCell = this["oGetCellInfo"](iRowIndex, iColIndex);

	if (this["bIsValidCellInfo"](oReferenceCell)) {
		if (!oReferenceCell["oDomRefCell"]["bCellSelectionStateInitialized"]) {
			this["initializeCellSelectionState"](oReferenceCell);
		}

		return oReferenceCell["iSelectionState"] & (this["SELECTION_LAYER"]["CELL"]);
	}

	return this["SELECTION_LAYER"]["NONE"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["eGetCellSelectionState"] = 0; };

/**
 * Returns the selection state of a given column
 *
 * @private
 * @param {number} iColIndex The internal column cell matrix index
 * @return {UCF_SapTable_SelectionLayer} The selection state
 */
UCF_SapTable["prototype"]["eGetColSelectionState"] = function(iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["eGetColSelectionState"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oReferenceCell;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iColIndex === 'number', "typeof iColIndex === 'number'", "SapTable.js(14026): eGetColSelectionState"); };

	oReferenceCell = this["oGetColReferenceCell"](iColIndex);

	if (this["bIsValidCellInfo"](oReferenceCell)) {
		if (!oReferenceCell["oDomRefCell"]["bCellSelectionStateInitialized"]) {
			this["initializeCellSelectionState"](oReferenceCell);
		}

		return oReferenceCell["iSelectionState"] & (
			this["SELECTION_LAYER"]["COLUMN"] |
			this["SELECTION_LAYER"]["COLUMN_DISABLED"]
		);
	}

	return this["SELECTION_LAYER"]["COLUMN_DISABLED"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["eGetColSelectionState"] = 0; };

/******************************************************
 * Scrollbar height Adoption
 *
 * IN IE9/10 standards mode the vertical scrollabr has no chance to align 100%
 * height to the outer table body therefore this has to be adapted by
 * JavaScript. It attaches the resize mechanism on the table body and transfers
 * the height to the TD surrounding the scrollbar so that the 100% height of
 * the scrollbar applies.
 *******************************************************/

/**
 * Initialization of the Adoption
 *
 * @private
 */
UCF_SapTable["prototype"]["initScrollbarHeightAdoption"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initScrollbarHeightAdoption"]++; }; 
	if (
		window["UCF_System"]["sDevice"] === 'standards' && (
			// eslint-disable-next-line no-magic-numbers
			UCF_UserAgent["bIsTrident"](5, true) ||
			// eslint-disable-next-line no-magic-numbers
			UCF_UserAgent["bIsTrident"](6, true)
		) &&
		this["oScrollV"] &&
		UCF_JsUtil["bInstanceOf"](this["oScrollV"], 'UCF_Scrollbar') &&
		!UCF_JsUtil["bInstanceOf"](this, 'UCF_SapTableCS')
	) {
		this["oScrollbarHeightReference"] = UCF_DomUtil["$"](
			this["sId"] + '-' + this["SUFFIX"]["CONTENT_TBODY"]
		);

		if (this["oScrollbarHeightReference"]) {
			this["attachBrowserEvent"]('resize', this["oScrollbarHeightReference"]);
			this["updateScrollbarHeightAdoption"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initScrollbarHeightAdoption"] = 0; };

/**
 * Cleanup of the Adoption
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpScrollbarHeightAdoption"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpScrollbarHeightAdoption"]++; }; 
	if (this["oScrollbarHeightReference"]) {
		this["detachBrowserEvent"]('resize', this["oScrollbarHeightReference"]);
		this["oScrollbarHeightReference"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpScrollbarHeightAdoption"] = 0; };

/**
 * Updates the size of the scrollbar
 *
 * @private
 */
UCF_SapTable["prototype"]["updateScrollbarHeightAdoption"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateScrollbarHeightAdoption"]++; }; 
	/** @type {HTMLElement} */
	var oTargetDomRef;
	/** @type {HTMLElement} */
	var oSourceDomRef;

	if (this["oScrollbarHeightReference"]) {
		oTargetDomRef = this["oScrollV"]["oDomRef"]["parentNode"];
		oSourceDomRef = this["oScrollbarHeightReference"];

		// don't use offsetHeight for IE 8 standards despite is right
		oTargetDomRef["style"]["height"] = (
			// eslint-disable-next-line no-magic-numbers
			document["documentMode"] === 8 && oSourceDomRef["clientHeight"]
			? oSourceDomRef["clientHeight"]
			: oSourceDomRef["offsetHeight"]
		) + 'px';
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateScrollbarHeightAdoption"] = 0; };

/**
 * Handles the resize event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SapTable["prototype"]["handleScrollbarHeightAdoption"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleScrollbarHeightAdoption"]++; }; 
	if (
		this["oScrollbarHeightReference"] &&
		oBrowserEvent["oGetSource"]() === this["oScrollbarHeightReference"]
	) {
		this["updateScrollbarHeightAdoption"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["handleScrollbarHeightAdoption"] = 0; };

/******************************************************
 * Cell content listening
 *
 * For a special row selection mode the table needs to check if in the content
 * area of a data cell events are raised. This needs to be done regardless if a
 * event is canceled or handled by the content. E.g. the special row selection
 * mode defines that a click leads to a selection of the row regradless if the
 * user clicks directly in a cell or on a content like the Button. Regardless
 * the Button cancels the bubbling of the event the table has to be notified.
 * It has even to be notified before the Button can process the click event.
 *
 * To achieve this we use the event capturing of the LS object. The table
 * registers the events listed in the array "aCellCaptureEvents". If these
 * events are received by the table it switches to
 * "bCapturedEventProcessing=true" mode and redirects the events directly in
 * the table's event handler. In this mode the table switches off the mechanism
 * which cancels or cancelBubbles the BrowserEvent.
 *
 * The "bProcessedBySapTableCancel" mechanism (stored in the BrowserEvent)
 * avoids that the event is processed twice 1) by capturing and 2) by the
 * standard bubbling afterwards. "bProcessedBySapTableCancelBubbleEvent" and
 * "bProcessedBySapTableCancelEvent" stores the cancel result of the capturing
 * process and applies this state when the event comes again to the table by
 * standard bubbling.
 *******************************************************/

UCF_SapTable["prototype"]["aCellCaptureEvents"] = ['lsselect', 'lsenter', 'click', 'mousedown'];

/**
 * Attaches/activates the event capturing
 *
 * @private
 */
UCF_SapTable["prototype"]["attachContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["attachContentListening"]++; }; 
	/** @type {number} */
	var i;

	if (this["bContentListening"]) {
		for (i = 0; i < this["aCellCaptureEvents"]["length"]; i++) {
			this["oLS"]["attachCaptureEvent"](
				this["aCellCaptureEvents"][i],
				this,
				'onContentEventCapture'
			);
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Event capturing of "' + this["sId"] + '" attached', "SapTable.js(14179): attachContentListening"); };
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["attachContentListening"] = 0; };

/**
 * detaches/deactivates the event capturing
 *
 * @private
 */
UCF_SapTable["prototype"]["detachContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["detachContentListening"]++; }; 
	/** @type {number} */
	var i;

	if (this["bContentListening"]) {
		for (i = 0; i < this["aCellCaptureEvents"]["length"]; i++) {
			this["oLS"]["detachCaptureEvent"](this["aCellCaptureEvents"][i], this);
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Event capturing of "' + this["sId"] + '" detached', "SapTable.js(14196): detachContentListening"); };
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["detachContentListening"] = 0; };

/**
 * Processes the captured events
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SapTable["prototype"]["onContentEventCapture"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onContentEventCapture"]++; }; 
	/** @type {UCF_Control} */
	var oSourceControl;
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {string} */
	var sHandlerName;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTable.js(14214): onContentEventCapture"); };

	oSourceControl = oBrowserEvent["oGetSourceControl"]();

	if (
		oSourceControl !== this &&
		!UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_TextView') &&
		!UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_Caption')
	) {
		oCellInfo = this["oGetCellInfoByBrowserEvent"](oBrowserEvent);

		if (oCellInfo && this["bIsDataTableCell"](this["eGetCellType"](oCellInfo))) {
			sHandlerName = 'on' + oBrowserEvent["sGetName"]();

			if (
				UCF_StringUtil["bStartsWith"](oBrowserEvent["sGetName"](), 'ls') &&
				(oBrowserEvent["bShift"]() || oBrowserEvent["bCtrl"]() || oBrowserEvent["bAlt"]())
			) {
				sHandlerName += 'modifier';
			}

			this["bCapturedEventProcessing"] = true;
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Processing captured event by handler "' + sHandlerName + '" in table "' + this["sId"] + '"', "SapTable.js(14236): onContentEventCapture"); };
			if (this[sHandlerName]) {
				this[sHandlerName](oBrowserEvent);
			}

			this["bCapturedEventProcessing"] = false;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onContentEventCapture"] = 0; };

/**
 * init
 *
 * @private
 */
UCF_SapTable["prototype"]["initContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initContentListening"]++; }; 
	if (this["bContentListening"]) {
		this["attachContentListening"]();
		this["bCapturedEventProcessing"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["initContentListening"] = 0; };

/**
 * Cleanup
 *
 * @private
 */
UCF_SapTable["prototype"]["cleanUpContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpContentListening"]++; }; 
	if (this["bContentListening"]) {
		this["detachContentListening"]();
		this["bContentListening"] = false;
		this["bCapturedEventProcessing"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["cleanUpContentListening"] = 0; };

/******************************************************
 ** Internal APIs
 *******************************************************/

/** @type {UCF_SapTable_CellUsageTypeEnum} */
UCF_SapTable["prototype"]["CELL_USAGE_TYPE"] = {
	"NONE": 0,
	"STANDARD": 1,
	"TEXT": 2,
	"EDIT": 3,
	"EMPTYROW": 4,
	"EMPTYCELL": 5,
	"FORMAT": 6,
	"ROWCREATOR": 7,
	"INFO": 8
};

/**
 * Returns the matrix row index of the first scrollable content cell
 *
 * @private
 * @return {number}
 */
UCF_SapTable["prototype"]["iGetContentRowOffset"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetContentRowOffset"]++; }; 
	if (this["iContentRowOffset"] === -1) {
		// The local member variable this.iContentRowOffset is not determined in
		// SapTable but in SapTableCS. Workaround->Skipping structure. This needs a
		// proper filled RowType for all rows
		this["initSkippingStructure"](false);
		this["iContentRowOffset"] = Math["max"](
			0,
			this["mSkippingStructureVertical"]["iScrollableStart"]
		);
	}

	return this["iContentRowOffset"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetContentRowOffset"] = 0; };

/**
 * Returns the row count of the table
 *
 * @return {number} row count
 * @private
 */
UCF_SapTable["prototype"]["iGetRowCount"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetRowCount"]++; }; 
	return this["iRowCount"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetRowCount"] = 0; };

/**
 * Returns the minimal visible row count for resize options
 *
 * @private
 * @return {number} minimal visible row count
 */
UCF_SapTable["prototype"]["iGetMinVisibleContentRowCount"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetMinVisibleContentRowCount"]++; }; 
	return 3;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetMinVisibleContentRowCount"] = 0; };

/**
 * Sets the row count after an HTML DOM update
 *
 * @see {@link UCF_SapTable#setContentRowCount}
 *
 * @param {number} iRowCount
 * @private
 */
UCF_SapTable["prototype"]["setRowCount"] = function(iRowCount) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowCount"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iRowCount === 'number', "typeof iRowCount === 'number'", "SapTable.js(14338): setRowCount"); };

	this["setContentRowCount"](iRowCount);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowCount"] = 0; };

/**
 * Sets the content row count after an HTML DOM update
 *
 * @see {@link UCF_SapTable#setRowCount}
 *
 * @private
 * @param {number} iContentRowCount
 */
UCF_SapTable["prototype"]["setContentRowCount"] = function(iContentRowCount) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setContentRowCount"]++; }; 
	/** @type {number} */
	var iDelta;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iContentRowCount === 'number', "typeof iContentRowCount === 'number'", "SapTable.js(14355): setContentRowCount"); };

	if (iContentRowCount !== this["iRowCount"]) {
		// !!!! This method is overwritten by SapTableCS
		if (this["bCanClientScroll"](false)) {
			iDelta = iContentRowCount - this["iRowCount"];

			this["iMatrixContentRowCount"] += iDelta;
			this["iMatrixRowCount"] += iDelta;

			this["mSkippingStructureVertical"] = null;
		}

		this["iRowCount"] = iContentRowCount;
		this["setClientProperty"]('RowCount', this["iRowCount"], true);

		// ScrollUI update
		if (this["oScrollV"]) {
			this["oScrollV"]["setItemCount"](this["iRowCount"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setContentRowCount"] = 0; };

/**
 * Returns the common row height of the content rows
 *
 * @private
 * @return {number} the row height
 */
UCF_SapTable["prototype"]["iGetRowHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetRowHeight"]++; }; 
	return this["iRowHeight"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetRowHeight"] = 0; };

/**
 * Checks the type of cell. See at enum CELL_USAGE_TYPE to get more detail
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {UCF_SapTable_CellUsageType} the row height
 */
UCF_SapTable["prototype"]["mGetCellUsageType"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["mGetCellUsageType"]++; }; 
	/** @type {string} */
	var sUsageType;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(14399): mGetCellUsageType"); };

	sUsageType = oCellInfo["oDomRefCell"]["getAttribute"]('ut');

	return sUsageType ? parseInt(sUsageType, 10) : this["CELL_USAGE_TYPE"]["NONE"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["mGetCellUsageType"] = 0; };

/**
 * Informs the caller about the data request capability of this table instance
 *
 * @return {boolean} true if data request is possible
 * @private
 */
UCF_SapTable["prototype"]["bCanDataRequest"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCanDataRequest"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCanDataRequest"] = 0; };

/**
 * Returns an 2d array matrix which contains the content references of the
 * visible cells. The content is null when there is no content or the cell does
 * not provide content. The map parameters iFocusRow and iFocusColumn are
 * identifying the cell which has currently the focus.
 *
 * Spanned cell content distributes its content refrences over each grid cell.
 *
 * @private
 * @return {HTMLElement[][] & {iFocusRow: number, iFocusColumn: number}}
 */
UCF_SapTable["prototype"]["aGetVisibleContentGrid"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetVisibleContentGrid"]++; }; 
	/** @type {HTMLElement[][] & {iFocusRow: number, iFocusColumn: number}} */
	var aResultGrid = [];
	/** @type {number} */
	var iLastRowIndex = this["iGetCellInfoMatrixLastRowIndex"]();
	/** @type {number} */
	var iLastColIndex = this["iGetCellInfoMatrixLastColIndex"]();
	/** @type {HTMLElement[]} */
	var aRow;
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {HTMLElement} */
	var oContent;
	/** @type {number} */
	var iMatrixRowIndex;
	/** @type {number} */
	var iContentRowOffset;
	/** @type {number} */
	var iMatrixColIndex;

	aResultGrid["iFocusRow"] = -1;
	aResultGrid["iFocusColumn"] = -1;

	for (iMatrixRowIndex = 0; iMatrixRowIndex <= iLastRowIndex; iMatrixRowIndex++) {
		if (
			this["bCanClientScroll"](false) &&
			this["bIsContentRowIndex"](iMatrixRowIndex)
		) {
			iContentRowOffset = this["iGetContentRowOffset"]();

			if (iMatrixRowIndex < iContentRowOffset + this["iVisibleFirstRow"]) {
				iMatrixRowIndex = iContentRowOffset + this["iVisibleFirstRow"];
			} else if (
				iMatrixRowIndex >
				iContentRowOffset + this["iVisibleFirstRow"] + this["iVisibleRowCount"] - 1
			) {
				iMatrixRowIndex = iContentRowOffset + this["iRowCount"];
			}

			if (iMatrixRowIndex > iLastRowIndex) {
				break;
			}
		}

		aRow = [];

		for (iMatrixColIndex = 0; iMatrixColIndex <= iLastColIndex; iMatrixColIndex++) {
			oCellInfo = this["oGetCellInfo"](iMatrixRowIndex, iMatrixColIndex);

			if (this["bIsValidCellInfo"](oCellInfo)) {
				if (aResultGrid["iFocusRow"] === -1 && this["bIsCellFocussed"](oCellInfo)) {
					aResultGrid["iFocusRow"] = aResultGrid["length"];
					aResultGrid["iFocusColumn"] = aRow["length"];
				}

				oContent = this["oDomRefGetCellContent"](oCellInfo);
			} else {
				oContent = null;
			}

			aRow[aRow["length"]] = oContent;
		}

		aResultGrid[aResultGrid["length"]] = aRow;
	}

	return aResultGrid;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetVisibleContentGrid"] = 0; };

/******************************************************
 ** Drag and Drop of Rows
 *******************************************************/

UCF_SapTable["prototype"]["HIERARCHY_PX_INDENTION"] = 14;

/**
 * Returns the indention in "px" which is used in a hierarchical cell to indent
 * the content
 *
 * @private
 * @param {number} iLevel
 * @return {number}
 */
UCF_SapTable["prototype"]["iGetHierarchyCellLevelIndention"] = function(iLevel) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetHierarchyCellLevelIndention"]++; }; 
	return iLevel === 0 ? 0 : (iLevel + 1) * this["HIERARCHY_PX_INDENTION"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetHierarchyCellLevelIndention"] = 0; };

/**
 * Returns the ID of the table's root drop target info.
 *
 * @private
 * @return {string}  The ID of the root drop target info
 */
UCF_SapTable["prototype"]["sGetRowRootDropTargetInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowRootDropTargetInfo"]++; }; 
	return this["sDropTargetInfo"] ? this["sDropTargetInfo"] : '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowRootDropTargetInfo"] = 0; };

/**
 * Returns the ID of the table's root drag target info.
 *
 * @private
 * @return {string}  The ID of the root drag target info
 */
UCF_SapTable["prototype"]["sGetRowRootDragSourceInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowRootDragSourceInfo"]++; }; 
	return this["sDragSourceInfo"] ? this["sDragSourceInfo"] : '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowRootDragSourceInfo"] = 0; };

/**
 * Returns the ID of the table's root drag target info.
 *
 * @see {@link UCF_SapTable#sGetRowRootDragSourceInfo}
 *
 * @private
 * @return {string}  The ID of the root drag target info
 */
UCF_SapTable["prototype"]["sGetDragSourceInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetDragSourceInfo"]++; }; 
	return this["sDragSourceInfo"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetDragSourceInfo"] = 0; };

/**
 * Sets the ID of the table's root drop target info.
 *
 * @public
 * @param {string} sRowRootDropTargetInfo the ID of the root drop target info
 */
UCF_SapTable["prototype"]["setRowRootDropTargetInfo"] = function(sRowRootDropTargetInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowRootDropTargetInfo"]++; }; 
	this["sDropTargetInfo"] = sRowRootDropTargetInfo;
	this["setClientProperty"]('DropTargetInfo', this["sDropTargetInfo"], true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowRootDropTargetInfo"] = 0; };

/**
 * Sets the ID of the table's root drag source info.
 *
 * @public
 * @param {string} sRowRootDragSourceInfo the ID of the root drag source info
 */
UCF_SapTable["prototype"]["setRowRootDragSourceInfo"] = function(sRowRootDragSourceInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowRootDragSourceInfo"]++; }; 
	this["sDragSourceInfo"] = sRowRootDragSourceInfo;
	this["setClientProperty"]('DragSourceInfo', this["sDragSourceInfo"], true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setRowRootDragSourceInfo"] = 0; };

/**
 * Returns the ID of the DropTargetInfo control assigned to the row of a given
 * cell
 *
 * @public
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetRowDropTargetInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowDropTargetInfo"]++; }; 
	return this["bIsValidCellInfo"](oCellInfo)
		? this["sGetRowDomAttribute"](
			this["oGetCellInfo"](oCellInfo["iRowIndex"], 0),
			'ddDti'
		)
		: '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowDropTargetInfo"] = 0; };

/**
 * Returns the ID of the parent DropTargetInfo control assigned to the row of a
 * given cell. This is used to handle drag and drop in a hierachy or tree table
 *
 * @public
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetRowParentDropTargetInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowParentDropTargetInfo"]++; }; 
	/** @type {string} */
	var sDropTargetInfo = this["bIsValidCellInfo"](oCellInfo)
		? this["sGetRowDomAttribute"](
			this["oGetCellInfo"](oCellInfo["iRowIndex"], 0),
			'ddPDti'
		)
		: '';

	if (!sDropTargetInfo) {
		sDropTargetInfo = this["sGetRowRootDropTargetInfo"]();
	}

	return sDropTargetInfo;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowParentDropTargetInfo"] = 0; };

/**
 * Returns the custom data assigned to the row of a given cell
 *
 * @public
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetRowDragData"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowDragData"]++; }; 
	return this["bIsValidCellInfo"](oCellInfo)
		? this["sGetRowDomAttribute"](
			this["oGetCellInfo"](oCellInfo["iRowIndex"], 0),
			'ddData'
		)
		: '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowDragData"] = 0; };

/* COLUMN */
/**
 * Returns the ID of the root column DropTargetInfo control assigned to the
 * table
 *
 * @public
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetColumnRootDropTargetInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnRootDropTargetInfo"]++; }; 
	return this["sColumnRootDropTargetInfo"] ? this["sColumnRootDropTargetInfo"] : '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnRootDropTargetInfo"] = 0; };

/**
 * Returns the ID of the root column DragSourceInfo control assigned to the
 * table
 *
 * @public
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetColumnRootDragSourceInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnRootDragSourceInfo"]++; }; 
	return this["sColumnRootDragSourceInfo"] ? this["sColumnRootDragSourceInfo"] : '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnRootDragSourceInfo"] = 0; };

/**
 * Returns the ID of the root column DropTargetInfo control to the column of a
 * given cell
 *
 * @public
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetColumnDropTargetInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnDropTargetInfo"]++; }; 
	return this["bIsValidCellInfo"](oCellInfo)
		? oCellInfo["oDomRefCell"]["getAttribute"]('ddDti')
		: '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnDropTargetInfo"] = 0; };

/**
 * Returns the ID of the parent column DropTargetInfo control assigned to the
 * column of a given cell. This is used to handle drag and drop in a hierachy
 * of columns.
 *
 * @public
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetColumnParentDropTargetInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnParentDropTargetInfo"]++; }; 
	/** @type {string} */
	var sDropTargetInfo;

	if (this["bIsValidCellInfo"](oCellInfo)) {
		sDropTargetInfo = oCellInfo["oDomRefCell"]["getAttribute"]('ddPDti');

		if (!sDropTargetInfo && !this["bIsCellOfSelectionColumn"](oCellInfo)) {
			sDropTargetInfo = this["sGetColumnRootDropTargetInfo"]();
		}

		return sDropTargetInfo;
	} else {
		return '';
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnParentDropTargetInfo"] = 0; };

/**
 * Returns the ID of the column DropSourceInfo control assigned to the column
 * of a given cell
 *
 * @public
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetColumnDragSourceInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnDragSourceInfo"]++; }; 
	/** @type {string} */
	var sDragSourceInfo;

	if (this["bIsValidCellInfo"](oCellInfo)) {
		sDragSourceInfo = oCellInfo["oDomRefCell"]["getAttribute"]('ddDsi');

		if (!sDragSourceInfo && !this["bIsCellOfSelectionColumn"](oCellInfo)) {
			sDragSourceInfo = this["sGetColumnRootDragSourceInfo"]();
		}

		return sDragSourceInfo;
	} else {
		return '';
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnDragSourceInfo"] = 0; };

/**
 * Returns the ID of the column DropTargetInfo control of a given header cell
 * This is a method is specified in the control interface to grant external
 * access
 *
 * @public
 * @param {string} sCellId
 * @return {string}
 */
UCF_SapTable["prototype"]["getColumnHeaderDropTargetInfo"] = function(sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getColumnHeaderDropTargetInfo"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(14726): getColumnHeaderDropTargetInfo"); };

	oCellInfo = this["oGetCellInfoByDomRef"](UCF_DomUtil["$"](sCellId));

	if (
		this["bIsValidCellInfo"](oCellInfo) &&
		this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["HEADER_CELL"]
	) {
		return oCellInfo["oDomRefCell"]["getAttribute"]('ddDti');
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Set DropTargetInfo of column "' + sCellId + '" failed because of invalid cell', "SapTable.js(14736): getColumnHeaderDropTargetInfo"); };

		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getColumnHeaderDropTargetInfo"] = 0; };

/**
 * Sets the ID of the column DropTargetInfo control of a given header cell
 * This is a method is specified in the control interface to grant external
 * access
 *
 * @public
 * @param {string} sCellId
 * @param {string} sDropTargetInfo
 */
UCF_SapTable["prototype"]["setColumnHeaderDropTargetInfo"] = function(sCellId, sDropTargetInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setColumnHeaderDropTargetInfo"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(14755): setColumnHeaderDropTargetInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sDropTargetInfo === 'string', "typeof sDropTargetInfo === 'string'", "SapTable.js(14756): setColumnHeaderDropTargetInfo"); };

	oCellInfo = this["oGetCellInfoByDomRef"](UCF_DomUtil["$"](sCellId));

	if (
		this["bIsValidCellInfo"](oCellInfo) &&
		this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["HEADER_CELL"]
	) {
		oCellInfo["oDomRefCell"]["setAttribute"]('ddDti', sDropTargetInfo);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Set DropTargetInfo of column "' + sCellId + '" failed because of invalid cell', "SapTable.js(14766): setColumnHeaderDropTargetInfo"); };
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setColumnHeaderDropTargetInfo"] = 0; };

/**
 * Returns the ID of the column DragSourceInfo control of a given header cell
 * This is a method is specified in the control interface to grant external access
 *
 * @public
 * @param {string} sCellId
 * @return {string}
 */
UCF_SapTable["prototype"]["getColumnHeaderDragSourceInfo"] = function(sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getColumnHeaderDragSourceInfo"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(14782): getColumnHeaderDragSourceInfo"); };

	oCellInfo = this["oGetCellInfoByDomRef"](UCF_DomUtil["$"](sCellId));

	if (
		this["bIsValidCellInfo"](oCellInfo) &&
		this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["HEADER_CELL"]
	) {
		return oCellInfo["oDomRefCell"]["getAttribute"]('ddDsi');
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Get DragSourceInfo of column "' + sCellId + '" failed because of invalid cell', "SapTable.js(14792): getColumnHeaderDragSourceInfo"); };

		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getColumnHeaderDragSourceInfo"] = 0; };

/**
 * Sets the ID of the column DragSourceInfo control of a given header cell
 * This is a method is specified in the control interface to grant external
 * access
 *
 * @public
 * @param {string} sCellId
 * @param {string} sDragSourceInfo
 */
UCF_SapTable["prototype"]["setColumnHeaderDragSourceInfo"] = function(sCellId, sDragSourceInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setColumnHeaderDragSourceInfo"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(14811): setColumnHeaderDragSourceInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sDragSourceInfo === 'string', "typeof sDragSourceInfo === 'string'", "SapTable.js(14812): setColumnHeaderDragSourceInfo"); };

	oCellInfo = this["oGetCellInfoByDomRef"](UCF_DomUtil["$"](sCellId));

	if (
		this["bIsValidCellInfo"](oCellInfo) &&
		this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["HEADER_CELL"]
	) {
		oCellInfo["oDomRefCell"]["setAttribute"]('ddDsi', sDragSourceInfo);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Set DragSourceInfo of column "' + sCellId + '" failed because of invalid cell', "SapTable.js(14822): setColumnHeaderDragSourceInfo"); };
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setColumnHeaderDragSourceInfo"] = 0; };

/**
 * TODO: is a style really slower?
 *
 * @private
 */
UCF_SapTable["prototype"]["resetDragHoverStyle"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["resetDragHoverStyle"]++; }; 
	this["setDragHoverStyle"](this["iLastAppliedDragHoverStyle"], false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["resetDragHoverStyle"] = 0; };

/**
 * Visualizes the row hovering color for a given internal rowindex
 *
 * @private
 * @param {number} iRowIndex
 */
UCF_SapTable["prototype"]["applyDragHoverStyle"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyDragHoverStyle"]++; }; 
	this["setDragHoverStyle"](iRowIndex, true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["applyDragHoverStyle"] = 0; };

/**
 * Sets or removes the row hovering color for a given internal rowindex
 *
 * @private
 * @param {number} iRowIndex
 * @param {boolean} bSet true if the visualization has to be set
 */
UCF_SapTable["prototype"]["setDragHoverStyle"] = function(iRowIndex, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDragHoverStyle"]++; }; 
	/** @type {UCF_SapTable_CellInfo[]} */
	var aCellInfos;
	/** @type {UCF_SapTable_CellInfo} */
	var oCurrentCellInfo;
	/** @type {string} */
	var sOldStyle;
	/** @type {UCF_SapTable_Rgb} */
	var oHoverColor;
	/** @type {string} */
	var sCssText;
	/** @type {number} */
	var i;

	// do not apply for row drag select action
	if (this["oLS"]["oGetDragSession"]() && this["oDragDropDelegate"] && this["oLS"]["oGetDragSession"]()["sGetCustomType"]() === this["oDragDropDelegate"]["DRAG_CUSTOM_TYPE"]["ROW_DRAG_SELECT"]) return;

	if (bSet) {
		if (iRowIndex === this["iLastAppliedDragHoverStyle"] || iRowIndex < 0) {
			return;
		}
		this["iLastAppliedDragHoverStyle"] = iRowIndex;

	} else {
		if (this["iLastAppliedDragHoverStyle"] === -1) {
			return;
		}

		this["iLastAppliedDragHoverStyle"] = -1;
	}

	aCellInfos = this["aGetCellInfosOfRow"](iRowIndex);
	oCurrentCellInfo = null;
	sOldStyle = '';
	oHoverColor = this["oGetColor"](this["COLOR"]["HOVER_DD"]);
	sCssText = ';background-color:#' + (oHoverColor
		? this["sColorToHexString"](oHoverColor)
		: 'fef09e'
	) + ' !important';

	for (i = 0; i < aCellInfos["length"]; i++) {
		oCurrentCellInfo = aCellInfos[i];

		if (
			oCurrentCellInfo &&
			this["bIsDataTableCell"](this["eGetCellType"](oCurrentCellInfo))
		) {
			if (bSet && !oCurrentCellInfo["lsHovered"]) {
				if (oCurrentCellInfo["oDomRefCell"]["runtimeStyle"]) {
					oCurrentCellInfo["oDomRefCell"]["runtimeStyle"]["cssText"] += sCssText;
				} else {
					sOldStyle = oCurrentCellInfo["oDomRefCell"]["getAttribute"]('style');
					oCurrentCellInfo["oDomRefCell"]["setAttribute"]('sOldStyle', sOldStyle);
					oCurrentCellInfo["oDomRefCell"]["style"]["cssText"] += sCssText;
				}

				oCurrentCellInfo["lsHovered"] = true;
			} else if (!bSet && oCurrentCellInfo["lsHovered"]) {
				if (oCurrentCellInfo["oDomRefCell"]["runtimeStyle"]) {
					oCurrentCellInfo["oDomRefCell"]["runtimeStyle"]["cssText"] = '';
				} else {
					sOldStyle = oCurrentCellInfo["oDomRefCell"]["getAttribute"]('sOldStyle');
					oCurrentCellInfo["oDomRefCell"]["style"]["cssText"] = sOldStyle;
				}

				oCurrentCellInfo["lsHovered"] = false;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDragHoverStyle"] = 0; };

/**
 * @see {@link UCF_Control#createDragDelegate}
 * @override
 */
UCF_SapTable["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["createDragDelegate"]++; }; 
	// create lazy
	this["createDragDropDelegate"]();

	if (this["sGetDragSourceInfo"]() && !this["oDragDelegate"]) {
		this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableDragDelegate"))(this["oLS"], this);
		this["addDelegate"](this["oDragDelegate"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["createDragDelegate"] = 0; };

/**
 * @see {@link UCF_Control#createDropDelegate}
 * @override
 */
UCF_SapTable["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["createDropDelegate"]++; }; 
	// create lazy
	this["createDragDropDelegate"]();

	if (!this["oDropDelegate"]) {
		this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableDropDelegate"))(this["oLS"], this);
		this["addDelegate"](this["oDropDelegate"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["createDropDelegate"] = 0; };

/**
 * @see {@link UCF_Control#createDragDropDelegate}
 * @override
 */
UCF_SapTable["prototype"]["createDragDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["createDragDropDelegate"]++; }; 
	if (!this["oDragDropDelegate"]) {
		this["oDragDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableDragDropDelegate"))(this["oLS"], this);
		this["addDelegate"](this["oDragDropDelegate"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["createDragDropDelegate"] = 0; };

/**
 * Event handler
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_SapTable["prototype"]["onlsdragover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsdragover"]++; }; 
	if (!this["bCancelHandlerProcessing"](oBrowserEvent)) {
		this["createDropDelegate"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onlsdragover"] = 0; };

/******************************************************
 ** Horizontal client scrolling
 *******************************************************/

/**
 * Event handler
 * It is called when scrollbar is experiencing a resize of its boundaries
 *
 * @private
 * @param {UCF_Event} oEvent the event object
 */
UCF_SapTable["prototype"]["onHScrollClientUpdateResize"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onHScrollClientUpdateResize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "SapTable.js(14986): onHScrollClientUpdateResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "SapTable.js(14987): onHScrollClientUpdateResize"); };

	this["updateHorizontalScrollDimensions"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["onHScrollClientUpdateResize"] = 0; };

/**
 * Updates the horizontal scollbar with the current dimension of the scoll port
 * and its content
 *
 * @private
 */
UCF_SapTable["prototype"]["updateHorizontalScrollDimensions"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateHorizontalScrollDimensions"]++; }; 
	/** @type {HTMLElement} */
	var oContentSegment;
	/** @type {number} */
	var iScrollRange;
	/** @type {number} */
	var iScrollClipping;

	if (
		this["oScrollH"] &&
		this["sHorizontalScrollUpdateMode"] === this["SCROLL_UPDATE_MODE"]["CLIENT"]
	) {
		oContentSegment = this["oGetFirstContentScrollSegment"]();
		iScrollRange = this["iGetSegmentContentWidth"](oContentSegment) - 2;
		iScrollClipping = oContentSegment["offsetWidth"];

		this["oScrollH"]["updateDimensions"](
			iScrollRange,
			iScrollClipping,
			this["iHorizontalScrollPosition"]
		);

		if (window["UCF_System"]["bIsRTL"]) {
			this["setHorizontalScrollPosition"](this["iHorizontalScrollPosition"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateHorizontalScrollDimensions"] = 0; };

/**
 * Returns true if the given cell is currently shown in the clipping area
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {boolean} `true` if the given cell is currently shown in the
 * clipping area
 */
UCF_SapTable["prototype"]["bIsHorizontalScrolledIntoView"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsHorizontalScrolledIntoView"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(15035): bIsHorizontalScrolledIntoView"); };

	return !this["oGetHorizontalCellClippingInfo"](oCellInfo);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsHorizontalScrolledIntoView"] = 0; };

/**
 * Checks if the passed cell is truncated in clipping area in horizontal
 * direction. The returned object contains the left and right truncation or is
 * null when there is no truncation.
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {UCF_SapTable_ClippingInfo} null when not truncated
 */
UCF_SapTable["prototype"]["oGetHorizontalCellClippingInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetHorizontalCellClippingInfo"]++; }; 
	/** @type {UCF_SapTable_ClippingInfo} */
	var oClippingInfo = null;
	/** @type {HTMLElement} */
	var oSegment;
	/** @type {number} */
	var iSegmentOffset;
	/** @type {number} */
	var iSegmentOffsetLeft;
	/** @type {number} */
	var iSegmentContentWidth;
	/** @type {number} */
	var iClippingAreaWidth;
	/** @type {number} */
	var iCellOffsetLeft;
	/** @type {number} */
	var iCellWidth;
	/** @type {number} */
	var iCellClippingLeft;
	/** @type {number} */
	var iCellClippingRight;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(15071): oGetHorizontalCellClippingInfo"); };

	if (this["bCanClientScroll"](true)) {
		oSegment = this["oGetSegmentByCellInfo"](oCellInfo);

		if (this["bIsHorizontalScrollSegment"](oSegment)) {
			iSegmentOffset = this["iGetContentOffsetPos"](oSegment);
			iSegmentContentWidth = this["iGetSegmentContentWidth"](oSegment);
			iClippingAreaWidth = oSegment["offsetWidth"];
			iSegmentOffsetLeft = window["UCF_System"]["bIsRTL"]
				? iSegmentContentWidth - (iSegmentOffset + iClippingAreaWidth)
				: this["iGetContentOffsetPos"](oSegment);
			iCellOffsetLeft = 0;
			iCellWidth = 0;
			iCellClippingLeft = 0;
			iCellClippingRight = 0;

			if (!this["bIsValidCellInfo"](oCellInfo)) {
				oCellInfo = this["oGetColReferenceCell"](oCellInfo["iColIndex"]);
			}

			iCellOffsetLeft = oCellInfo["oDomRefCell"]["offsetLeft"];
			iCellWidth = oCellInfo["oDomRefCell"]["offsetWidth"];

			if (iCellOffsetLeft < iSegmentOffsetLeft) {
				iCellClippingLeft = iSegmentOffsetLeft - iCellOffsetLeft;
			}

			if (
				iCellOffsetLeft + iCellWidth > iSegmentOffsetLeft + iClippingAreaWidth
			) {
				iCellClippingRight = (iCellOffsetLeft + iCellWidth) -
					(iSegmentOffsetLeft + iClippingAreaWidth);
			}

			if (iCellClippingLeft || iCellClippingRight) {
				oClippingInfo = {
					"oReferenceCell": oCellInfo,
					"iCellClippingLeft": iCellClippingLeft,
					"iCellClippingRight": iCellClippingRight,
					"iCellOffsetLeft": iCellOffsetLeft,
					"iCellWidth": iCellWidth,
					"iSegmentOffsetLeft": iSegmentOffsetLeft,
					"iSegmentWidth": iSegmentContentWidth,
					"iClippingAreaWidth": iClippingAreaWidth
				};
			}
		}
	}

	return oClippingInfo;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetHorizontalCellClippingInfo"] = 0; };

/**
 * Scrolls the given cell into a visible position
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 */
UCF_SapTable["prototype"]["scrollHorizontalIntoView"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["scrollHorizontalIntoView"]++; }; 
	/** @type {UCF_SapTable_ClippingInfo} */
	var oClippingInfo;
	/** @type {boolean} */
	var bBeginAlign;
	/** @type {number} */
	var iCellOffsetPos;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(15138): scrollHorizontalIntoView"); };

	if (this["oScrollH"] && this["bIsInHorizontalScrollSegment"](oCellInfo)) {
		oClippingInfo = this["oGetHorizontalCellClippingInfo"](oCellInfo);

		if (oClippingInfo) {
			// Align the cell left or right to the clipping area
			// depending on RTL an which side is truncated by the clipping area
			bBeginAlign = (
				window["UCF_System"]["bIsRTL"] && oClippingInfo["iCellClippingRight"] ||
				!window["UCF_System"]["bIsRTL"] && oClippingInfo["iCellClippingLeft"]
			) || (oClippingInfo["iCellWidth"] > oClippingInfo["iClippingAreaWidth"]);
			iCellOffsetPos = window["UCF_System"]["bIsRTL"]
				? oClippingInfo["iSegmentWidth"] -
				(oClippingInfo["iCellOffsetLeft"] + oClippingInfo["iCellWidth"])
				: oClippingInfo["iCellOffsetLeft"];

			if (this["sHorizontalScrollUpdateMode"] === this["SCROLL_UPDATE_MODE"]["CLIENT"]) {
				iCellOffsetPos++;
			}

			this["oScrollH"]["scrollToPosition"](
				bBeginAlign
				? iCellOffsetPos
				: (iCellOffsetPos + oClippingInfo["iCellWidth"]) -
				oClippingInfo["iClippingAreaWidth"],
				UCF_JsUtil["MODIFIER"]["NONE"]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["scrollHorizontalIntoView"] = 0; };

/**
 * Returns the horizontal scrollPosition calculated by an offset given by the
 * server (used for Drag&Drop)
 *
 * @private
 * @param {HTMLElement} oDomRefSegment
 * @return {number} iPxPosition The position in pixel
 */
UCF_SapTable["prototype"]["iGetHorizontalScrollPosition"] = function(oDomRefSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetHorizontalScrollPosition"]++; }; 
	/** @type {HTMLElement} */
	var oHPositionElement = this["oGetSegmentHPositionElement"](oDomRefSegment);
	/** @type {number} */
	var iOffsetLeft;

	// In rare cases, oHPositionElement can be null. This can occur, if SapTable
	// is exchanged after a roundtrip and lsdragscroll is called immidiately
	// after the roundtrip (via interval call). In this case, sometimes the DOM
	// is not yet completely updated
	if (oHPositionElement) {
		iOffsetLeft = parseInt(oHPositionElement["getAttribute"]('iOffsetLeft'), 10);

		return -(parseInt((window["UCF_System"]["bIsRTL"]
			? oHPositionElement["style"]["right"]
			: oHPositionElement["style"]["left"]), 10) - iOffsetLeft);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Dom not yet updated => cannot calculate scroll position', "SapTable.js(15195): iGetHorizontalScrollPosition"); };

		return 0;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetHorizontalScrollPosition"] = 0; };

/**
 * Returns the horizontal scrollPosition of a given segment
 *
 * @private
 * @param {HTMLElement} oDomRefSegment
 * @return {number} iPxPosition The position in pixel
 */
UCF_SapTable["prototype"]["iGetContentOffsetPos"] = function(oDomRefSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetContentOffsetPos"]++; }; 
	/** @type {number} */
	var iLeft;

	if (this["bNativeHorizontalScrollMode"]) {
		iLeft = parseInt(
			this["oGetSegmentHPositionElement"](oDomRefSegment)["style"]["left"]
		);

		return iLeft === 0
			? this["oGetSegmentHPositionElement"](oDomRefSegment)["parentNode"]["scrollLeft"]
			: -iLeft;
	} else {
		return (
				UCF_UserAgent["bIsGecko"]() ||
				UCF_UserAgent["bIsWebKit"]() ||
				window["UCF_System"]["sDevice"] === 'standards'
			)
			? -parseInt(window["UCF_System"]["bIsRTL"]
				? this["oGetSegmentHPositionElement"](oDomRefSegment)["style"]["right"]
				: this["oGetSegmentHPositionElement"](oDomRefSegment)["style"]["left"], 10)
			: -this["oGetSegmentHPositionElement"](oDomRefSegment)["offsetLeft"];
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetContentOffsetPos"] = 0; };

/**
 * Sets all horizontal scrollable segments to a given position in pixel
 *
 * @private
 * @param {number} iPxPosition The position in pixel
 */
UCF_SapTable["prototype"]["setHorizontalScrollPosition"] = function(iPxPosition) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setHorizontalScrollPosition"]++; }; 
	/** @type {HTMLElement} */
	var oNoneFixedSegment;
	/** @type {HTMLElement[]} */
	var aHorizontalScrollSegments;
	/** @type {number} */
	var iPosToSet;
	/** @type {number} */
	var iSegmentRowIndex;
	/** @type {HTMLElement} */
	var oHPositionElement;
	/** @type {CSSStyleDeclaration} */
	var oStyle;
	/** @type {CSSStyleDeclaration} */
	var oCurrentStyle;
	/** @type {string} */
	var sFloat;
	/** @type {boolean} */
	var bApply;

	if (iPxPosition >= 0) {
		aHorizontalScrollSegments = this["aGetHorizontalScrollSegments"]();
		iPosToSet = 0;

		this["iHorizontalScrollPosition"] = iPxPosition;
		this["setClientProperty"](
			'HorizontalScrollPosition',
			this["iHorizontalScrollPosition"],
			true
		);

		for (iSegmentRowIndex = 0; iSegmentRowIndex < aHorizontalScrollSegments["length"]; iSegmentRowIndex++) {
			oNoneFixedSegment = aHorizontalScrollSegments[iSegmentRowIndex];
			if (oNoneFixedSegment) {
				oHPositionElement = this["oGetSegmentHPositionElement"](oNoneFixedSegment);
				iPosToSet = -(iPxPosition - parseInt(
					oHPositionElement["getAttribute"]('iOffsetLeft')
				));

				if (
					// eslint-disable-next-line no-magic-numbers
					(UCF_UserAgent["bIsFirefox"](3.6) || UCF_UserAgent["bIsWebKit"]()) &&
					oNoneFixedSegment["scrollLeft"] !== 0
				) {
					// FireFox 3.6 bug when tabbing back CSN: I-131171 2010
					// Chrome performs native scrollIntoView when focusing cell content
					// CSN 0020751295 0000368488 2016
					// Pos correction needed
					iPosToSet = window["UCF_System"]["bIsRTL"]
						? iPosToSet // TODO RTL
						: iPosToSet + oNoneFixedSegment["scrollLeft"];
				}

				if (window["UCF_System"]["bIsRTL"]) {
					if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
						// IE bug in RTL. see E-603375 2012
						// Set float to none, set right position, and set float back
						oStyle = oHPositionElement["style"];
						oCurrentStyle = oHPositionElement["currentStyle"];
						sFloat = oCurrentStyle["styleFloat"];
						bApply = sFloat !== 'none';

						if (bApply) {
							oStyle["styleFloat"] = 'none';
						}
						oStyle["right"] = iPosToSet + 'px';
						if (bApply) {
							oStyle["styleFloat"] = sFloat;
						}
					} else {
						oHPositionElement["style"]["right"] = iPosToSet + 'px';
					}
				} else if (this["bNativeHorizontalScrollMode"]) {
					if (parseInt(oHPositionElement["style"]["left"]) !== 0) {
						oHPositionElement["style"]["left"] = '0px';
					}
					oHPositionElement["parentNode"]["scrollLeft"] = -iPosToSet;
				} else {
					oHPositionElement["style"]["left"] = iPosToSet + 'px';
				}

				this["updateGapGridHPosition"](oNoneFixedSegment);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setHorizontalScrollPosition"] = 0; };

/**
 * Updates the GapGrid of a segment according to the current visble row count
 *
 * @param {HTMLElement} oSegment the segment to be updated
 * @private
 */
UCF_SapTable["prototype"]["updateGapGridHPosition"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateGapGridHPosition"]++; }; 
	// !!!! This method is overwritten by SapTableCS
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["updateGapGridHPosition"] = 0; };

/**
 * Returns true if the given cell is currently visible in the table
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {boolean} true if the given cell is currently visible in the table
 */
UCF_SapTable["prototype"]["bIsVerticalScrolledIntoView"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsVerticalScrolledIntoView"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(15344): bIsVerticalScrolledIntoView"); };

	return this["bIsVerticalScrolledIntoViewByIndex"](
		this["iGetContentRowIndex"](oCellInfo)
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsVerticalScrolledIntoView"] = 0; };

/**
 * Returns true if the row represented by the content row index is currently
 * visible in the table
 *
 * @private
 * @param {number} iContentRowIndex
 * @return {boolean} true/false
 */
UCF_SapTable["prototype"]["bIsVerticalScrolledIntoViewByIndex"] = function(iContentRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsVerticalScrolledIntoViewByIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iContentRowIndex === 'number', "typeof iContentRowIndex === 'number'", "SapTable.js(15360): bIsVerticalScrolledIntoViewByIndex"); };

	return true;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsVerticalScrolledIntoViewByIndex"] = 0; };

/******************************************************
 ** Segment methods
 *******************************************************/

/**
 * Returns the width of a column given by the internal column cell matrix index
 *
 * @private
 * @param {number} iColIndex the internal cell matrix index of the column
 * @return {number}
 */
UCF_SapTable["prototype"]["iGetColumnWidth"] = function(iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetColumnWidth"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iColIndex === 'number', "typeof iColIndex === 'number'", "SapTable.js(15380): iGetColumnWidth"); };

	// TODO should be the first cell without colspan
	oCellInfo = this["oGetCellInfo"](0, iColIndex);

	return this["bIsValidCellInfo"](oCellInfo)
		? oCellInfo["oDomRefCell"]["offsetWidth"]
		// TODO check by colgroups
		: 0;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetColumnWidth"] = 0; };

/**
 * Returns the width string of the related column COL tag.
 *
 * @private
 * @param {number} iColIndex the internal cell matrix index of the column
 * @return {string}
 */
UCF_SapTable["prototype"]["sGetColumnWidth"] = function(iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnWidth"]++; }; 
	/** @type {HTMLElement} */
	var oSegment;
	/** @type {HTMLElement} */
	var oDomRefCol;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iColIndex === 'number', "typeof iColIndex === 'number'", "SapTable.js(15404): sGetColumnWidth"); };

	oSegment = this["oGetSegmentByCellInfo"](this["oGetCellInfo"](0, iColIndex));
	oDomRefCol = this["oDomRefGetSegmentHtmlColumn"](
		oSegment,
		iColIndex - this["iGetSegmentOffsetColIndex"](oSegment)
	);

	return oDomRefCol ? oDomRefCol["style"]["width"] : '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetColumnWidth"] = 0; };

/**
 * Returns the width string of the related column COL tag.
 * This is an SapTable/CS API method
 *
 * @public
 * @param {string} sCellId The ID of a cell of the target column
 * @return {string}
 */
UCF_SapTable["prototype"]["getColumnWidth"] = function(sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getColumnWidth"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sCellId === 'string', "typeof sCellId === 'string'", "SapTable.js(15424): getColumnWidth"); };

	return this["sGetColumnWidth"](
		this["oGetCellInfoByDomRef"](UCF_DomUtil["$"](sCellId))["iColIndex"]
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getColumnWidth"] = 0; };

/**
 * Returns the HTML colum of a segment
 *
 * @private
 * @param {HTMLElement} oSegment
 * @param {number} iSegmentColIndex
 * @return {HTMLElement}
 */
UCF_SapTable["prototype"]["oDomRefGetSegmentHtmlColumn"] = function(oSegment, iSegmentColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oDomRefGetSegmentHtmlColumn"]++; }; 
	/** @type {HTMLElement} */
	var oHtmlTable = this["oGetSegmentTable"](oSegment);
	/** @type {HTMLCollectionOf<HTMLTableColElement>} */
	var aColsOfHtmlTable = null;

	if (oHtmlTable) {
		aColsOfHtmlTable = this["aGetColsOfHtmlTable"](oHtmlTable);

		return (
				!aColsOfHtmlTable || aColsOfHtmlTable["length"] < iSegmentColIndex + 1
			)
			? null
			: aColsOfHtmlTable[iSegmentColIndex];
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oDomRefGetSegmentHtmlColumn"] = 0; };

/**
 * Sets the width of a column given by the internal column cell matrix index
 *
 * @public
 * @param {number|string} iColIndex the internal cell matrix index of the
 * column (alternatively you can pass the ID of a cell of this column)
 * @param {string} sWidth
 */
UCF_SapTable["prototype"]["setColumnWidth"] = function(iColIndex, sWidth) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setColumnWidth"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {HTMLElement} */
	var oSegment;
	/** @type {number} */
	var iSegmentColIndex;

	// When the method is called by the SapTable/CS API iColIndex is the ID of a
	// cell
	if (typeof iColIndex === 'string') {
		iColIndex = this["oGetCellInfoByDomRef"](UCF_DomUtil["$"](iColIndex))["iColIndex"];
	}

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iColIndex === 'number', "typeof iColIndex === 'number'", "SapTable.js(15480): setColumnWidth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sWidth === 'string', "typeof sWidth === 'string'", "SapTable.js(15481): setColumnWidth"); };

	oCellInfo = this["oGetCellInfo"](0, iColIndex);
	oSegment = this["oGetSegmentByCellInfo"](oCellInfo);
	iSegmentColIndex = iColIndex - this["iGetSegmentOffsetColIndex"](oSegment);

	if (oSegment) {
		this["setSegmentColumnWidth"](oSegment, iSegmentColIndex, sWidth);

		if (this["sHorizontalScrollUpdateMode"] === this["SCROLL_UPDATE_MODE"]["CLIENT"]) {
			this["updateHorizontalScrollDimensions"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setColumnWidth"] = 0; };

/**
 * @private
 * @param {HTMLElement} oSegment The DomRef of the segment
 * @return {number} the internal column cell matrix index of the first cell in
 * this segment
 */
UCF_SapTable["prototype"]["iGetSegmentOffsetColIndex"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSegmentOffsetColIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTable.js(15503): iGetSegmentOffsetColIndex"); };

	return 0;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSegmentOffsetColIndex"] = 0; };

/**
 * @private
 * @param {HTMLElement} oSegment The DomRef of the segment
 * @return {number} the internal row cell matrix index of the first cell in
 * this segment
 */
UCF_SapTable["prototype"]["iGetSegmentOffsetRowIndex"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSegmentOffsetRowIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTable.js(15515): iGetSegmentOffsetRowIndex"); };

	return 0;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSegmentOffsetRowIndex"] = 0; };

/**
 * @private
 * @param {HTMLElement} oSegment The DomRef of the segment
 * @return {number} the count of columns embedded in the given segment
 */
UCF_SapTable["prototype"]["iGetSegmentColCount"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSegmentColCount"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTable.js(15526): iGetSegmentColCount"); };

	return this["iGetCellInfoMatrixLastColIndex"]() + 1;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSegmentColCount"] = 0; };

/**
 * Sets the width of a column in a segment. The index is not the interal
 * colindex but the index of the column within this segment
 *
 * @private
 * @param {HTMLElement} oSegment The DomRef of the segment
 * @param {number} iSegmentColIndex
 * @param {string} sWidth
 */
UCF_SapTable["prototype"]["setSegmentColumnWidth"] = function(oSegment, iSegmentColIndex, sWidth) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setSegmentColumnWidth"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iSegmentColIndex === 'number', "typeof iSegmentColIndex === 'number'", "SapTable.js(15541): setSegmentColumnWidth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sWidth === 'string', "typeof sWidth === 'string'", "SapTable.js(15542): setSegmentColumnWidth"); };

	if (oSegment) {
		this["setHtmlColWidth"](
			this["aGetColsOfHtmlTable"](this["oGetSegmentTable"](oSegment)),
			iSegmentColIndex,
			sWidth
		);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setSegmentColumnWidth"] = 0; };

/**
 * Returns true if the columns in the segment are arranged table based and not
 * column based of the column within this segment
 *
 * @private
 * @param {HTMLElement} oSegment The DomRef of the segment
 * @return {boolean} `true` if tablebased
 */
UCF_SapTable["prototype"]["bHasSegmentTableBasedColumnWidths"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasSegmentTableBasedColumnWidths"]++; }; 
	return !!this["oGetSegmentTable"](oSegment)["getAttribute"](
		'tableBasedColumnWidhts'
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasSegmentTableBasedColumnWidths"] = 0; };

/**
 * Returns a HTMLCollection of dom references pointing to to the COL tags
 * nested in a given html table reference
 *
 * @private
 * @param {HTMLElement} oHtmlTable
 * @return {HTMLCollectionOf<HTMLTableColElement>}
 */
UCF_SapTable["prototype"]["aGetColsOfHtmlTable"] = function(oHtmlTable) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetColsOfHtmlTable"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefColGroup;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oHtmlTable != null, "oHtmlTable != null", "SapTable.js(15579): aGetColsOfHtmlTable"); };

	oDomRefColGroup = oHtmlTable["getElementsByTagName"]('COLGROUP')[0];

	return oDomRefColGroup ? oDomRefColGroup["getElementsByTagName"]('COL') : null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetColsOfHtmlTable"] = 0; };

/**
 * Sets the width of a COL tag identified by a Array of COL tags and a given index
 * of the column within this segment
 *
 * @private
 * @param {HTMLElement[]} aDomRefCols The DomRef of the segment
 * @param {number} iColIndex
 * @param {string} sWidth
 */
UCF_SapTable["prototype"]["setHtmlColWidth"] = function(aDomRefCols, iColIndex, sWidth) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setHtmlColWidth"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(aDomRefCols != null, "aDomRefCols != null", "SapTable.js(15596): setHtmlColWidth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iColIndex === 'number', "typeof iColIndex === 'number'", "SapTable.js(15597): setHtmlColWidth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sWidth === 'string', "typeof sWidth === 'string'", "SapTable.js(15598): setHtmlColWidth"); };

	if (aDomRefCols) {
		aDomRefCols[iColIndex]["style"]["width"] = sWidth;

		if (
			UCF_UserAgent["bIsGecko"]() ||
			UCF_UserAgent["bIsWebKit"]() ||
			window["UCF_System"]["sDevice"] === 'standards'
		) { // force repaint
			this["oDomRef"]["style"]["left"] = (
				this["oDomRef"]["style"]["left"] || this["oDomRef"]["style"]["left"] === '0px'
			) ? '' : '0px';
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setHtmlColWidth"] = 0; };

/**
 * Returns the dom reference of the table which is nested in the segment div
 *
 * @private
 * @param {HTMLElement} oSegment The DomRef of the segment
 * @return {HTMLElement}
 */
UCF_SapTable["prototype"]["oGetSegmentTable"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSegmentTable"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTable.js(15623): oGetSegmentTable"); };

	return this["oDomRefGetFirstChildByTagName"](
		this["sHorizontalScrollUpdateMode"] === this["SCROLL_UPDATE_MODE"]["CLIENT"]
		? this["oGetSegmentHPositionElement"](oSegment)
		: oSegment,
		'table'
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSegmentTable"] = 0; };

/**
 * Returns the dom reference of element which manages the horizontal position
 *
 * @private
 * @param {HTMLElement} oSegment The DomRef of the segment
 * @return {HTMLElement}
 */
UCF_SapTable["prototype"]["oGetSegmentHPositionElement"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSegmentHPositionElement"]++; }; 
	/** @type {HTMLElement} */
	var oDomRefChild;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTable.js(15644): oGetSegmentHPositionElement"); };

	oDomRefChild = oSegment["firstChild"];

	while (oDomRefChild) {
		if (oDomRefChild["getAttribute"]('bIsPosElement')) {
			return oDomRefChild;
		}
		oDomRefChild = oDomRefChild["nextSibling"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSegmentHPositionElement"] = 0; };

/**
 * Returns the overall width of a segment.
 *
 * @private
 * @param {HTMLElement} oSegment The DomRef of the segment
 * @return {number}
 */
UCF_SapTable["prototype"]["iGetSegmentContentWidth"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSegmentContentWidth"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTable.js(15666): iGetSegmentContentWidth"); };

	return this["oGetSegmentTable"](oSegment)["offsetWidth"];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetSegmentContentWidth"] = 0; };

/**
 * Returns the DOM attribute of the cell's row
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {string} sAttributeName
 * @return {string} the attributes value
 */
UCF_SapTable["prototype"]["sGetRowDomAttribute"] = function(oCellInfo, sAttributeName) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowDomAttribute"]++; }; 
	return oCellInfo && sAttributeName
		? oCellInfo["oDomRefRow"]["getAttribute"](sAttributeName)
		: '';
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["sGetRowDomAttribute"] = 0; };

/**
 * Returns the reference of the clipping area of content segment
 *
 * @private
 * @return {HTMLElement} the DOM reference to the clipping area
 */
UCF_SapTable["prototype"]["oGetFirstContentScrollSegment"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetFirstContentScrollSegment"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + '-contentScrollSegment');
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetFirstContentScrollSegment"] = 0; };

/**
 * Returns the DOM reference of the segment which nests the given cell
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {HTMLElement} the segment
 */
UCF_SapTable["prototype"]["oGetSegmentByCellInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSegmentByCellInfo"]++; }; 
	// !!!! This method is overwritten by SapTableCS

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(15705): oGetSegmentByCellInfo"); };

	return this["oGetFirstContentScrollSegment"]() ||
		UCF_DomUtil["$"](this["sId"] + '-' + this["SUFFIX"]["CONTENT_AREA"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSegmentByCellInfo"] = 0; };

/**
 * Returns the DOM reference of the segment which nests the browser event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {HTMLElement} the segment
 */
UCF_SapTable["prototype"]["oGetSegmentByBrowserEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSegmentByBrowserEvent"]++; }; 
	// !!!! This method is overwritten by SapTableCS

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTable.js(15721): oGetSegmentByBrowserEvent"); };

	return this["oGetFirstContentScrollSegment"]() ||
		UCF_DomUtil["$"](this["sId"] + '-' + this["SUFFIX"]["CONTENT_AREA"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetSegmentByBrowserEvent"] = 0; };

/**
 * Returns the reference of the content segment
 *
 * @private
 * @return {HTMLElement} the DOM reference of the content segment
 */
UCF_SapTable["prototype"]["oGetContentSegment"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetContentSegment"]++; }; 
	// !!!! This method is overwritten by SapTableCS
	return UCF_DomUtil["$"](this["sId"] + '-' + this["SUFFIX"]["CONTENT_AREA"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetContentSegment"] = 0; };

/**
 * Checks if the passed segment is a horizontal scroll segment
 *
 * @private
 * @param {HTMLElement} oSegment The DomRef of the segment
 * @return {boolean} true if the passed segment is a horizontal scroll segment
 */
UCF_SapTable["prototype"]["bIsHorizontalScrollSegment"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsHorizontalScrollSegment"]++; }; 
	// !!!! This method is overwritten by SapTableCS

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTable.js(15748): bIsHorizontalScrollSegment"); };

	//Every segment is a scroll segment in the SapTable
	return true;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsHorizontalScrollSegment"] = 0; };

/**
 * Returns true if the given cell is nested in a horizontal scroll segment
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bIsInHorizontalScrollSegment"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsInHorizontalScrollSegment"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTable.js(15762): bIsInHorizontalScrollSegment"); };

	return this["bIsHorizontalScrollSegment"](
		this["oGetSegmentByCellInfo"](oCellInfo)
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bIsInHorizontalScrollSegment"] = 0; };

/**
 * @private
 * @return {HTMLElement[]} an Array of all scroll segments
 */
UCF_SapTable["prototype"]["aGetHorizontalScrollSegments"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetHorizontalScrollSegments"]++; }; 
	return [this["oGetFirstContentScrollSegment"]()];
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["aGetHorizontalScrollSegments"] = 0; };

/**
 * Cheks if the table has a leading selection column
 *
 * @private
 * @return {boolean} `true` if the table detects a leading selection column
 */
UCF_SapTable["prototype"]["bHasLeadingSelectionColumn"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasLeadingSelectionColumn"]++; }; 
	/** @type {HTMLCollectionOf<HTMLTableColElement>} */
	var aColsOfHtmlTable = this["aGetColsOfHtmlTable"](
		UCF_DomUtil["$"](this["sId"] + '-' + this["SUFFIX"]["CONTENT_TBODY"])["parentNode"]
	);

	return aColsOfHtmlTable &&
		aColsOfHtmlTable["length"] > 0 &&
		!!aColsOfHtmlTable[0]["getAttribute"]('selectionColumn');
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasLeadingSelectionColumn"] = 0; };

/**
 * Checks if the table has a header row
 *
 * @private
 * @return {boolean} `true` if the table detects a header row
 */
UCF_SapTable["prototype"]["bHasHeaderRow"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasHeaderRow"]++; }; 
	/** @type {UCF_SapTable_CellInfo} */
	var oReferenceCell = this["oGetRowReferenceCell"](0);

	return !oReferenceCell ||	(oReferenceCell && oReferenceCell["eCellType"] === this["SUBCONTROL"]["HEADER_CELL"]);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bHasHeaderRow"] = 0; };

/**
 * Returns the number of header rows
 *
 * @private
 * @return {number} number of header rows
 */
UCF_SapTable["prototype"]["iGetHeaderRowCount"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetHeaderRowCount"]++; }; 
	/** @type {number} */
	var iLastRowIndex = this["iGetCellInfoMatrixLastRowIndex"]();
	/** @type {UCF_SapTable_CellInfo} */
	var oReferenceCell;
	/** @type {number} */
	var iHeaderRowCount = 0;
	/** @type {number} */
	var i;

	for (i = 0; i <= iLastRowIndex; i++) {
		oReferenceCell = this["oGetCellInfo"](i, 0);

		if (oReferenceCell && this["bIsValidCellInfo"](oReferenceCell) && oReferenceCell["eCellType"] === this["SUBCONTROL"]["HEADER_CELL"]) {
			iHeaderRowCount++;
		}
		else break;
	}

	return iHeaderRowCount;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["iGetHeaderRowCount"] = 0; };

/**
 * Searches in a given row a sepcific cell type beginning at a passed column
 * start index and returns the refernce to the cell info if search was
 * successful. If nothing was found it retuns null.
 *
 * @private
 * @param {number} iRowIndex
 * @param {number} iStartColIndex Start search from this column start index
 * @param {UCF_SapTable_CellType} eType
 * @return {UCF_SapTable_CellInfo}
 */
UCF_SapTable["prototype"]["oGetCellInfoInRowByType"] = function(iRowIndex, iStartColIndex, eType) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetCellInfoInRowByType"]++; }; 
	var oCellInfo = this["oGetCellInfo"](iRowIndex, iStartColIndex);

	while (this["bIsValidCellInfo"](oCellInfo)) {
		if (this["eGetCellType"](oCellInfo) === eType) {
			return oCellInfo;
		}

		oCellInfo = this["oGetCellInfo"](
			iRowIndex,
			oCellInfo["iColIndex"] + oCellInfo["iColSpan"]
		);
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetCellInfoInRowByType"] = 0; };

/**
 * @see {@link UCF_Control#oGetDTExtension}
 * @override
 * @param {UCF_DTElement} oDTElement
 * @return {UCF_SapTableDTExtension}
 */
UCF_SapTable["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetDTExtension"]++; }; 
	return UCF_Control.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]('UCF_SapTableDTExtension'));
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetDTExtension"] = 0; };

/**
 * Returns the ControlInfo object for a given cell info
 *
 * @param {UCF_SapTable_CellInfo} oCellInfo The internal cell info object.
 * @return {UCF_SapTableBaseCell} The ControlInfo object for a given cell info
 */
UCF_SapTable["prototype"]["oGetCellControlInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetCellControlInfo"]++; }; 
	/** @type {UCF_SapTable_CellType} */
	var eCellType;

	if (oCellInfo && oCellInfo["oDomRefCell"]) {
		if (!oCellInfo["oCell"]) {
			eCellType = this["eGetCellType"](oCellInfo);

			oCellInfo["oCell"] = (eCellType === this["SUBCONTROL"]["HEADER_CELL"])
				? new (UCF_ClassLoader["oGetClass"]("UCF_SapTableHeaderCell"))(oCellInfo["oDomRefCell"], this)
				: (
					eCellType === this["SUBCONTROL"]["STANDARD_CELL"] ||
					eCellType === this["SUBCONTROL"]["POPIN_CELL"]
				)
				? new (UCF_ClassLoader["oGetClass"]("UCF_SapTableCell"))(oCellInfo["oDomRefCell"], this)
				: (eCellType === this["SUBCONTROL"]["HIERARCHY_CELL"])
				? new (UCF_ClassLoader["oGetClass"]("UCF_SapTableHierarchicalCell"))(oCellInfo["oDomRefCell"], this)
				: (eCellType === this["SUBCONTROL"]["MATRIX_CELL"])
				? new (UCF_ClassLoader["oGetClass"]("UCF_SapTableMatrixCell"))(oCellInfo["oDomRefCell"], this)
				: (eCellType === this["SUBCONTROL"]["SELECTION_CELL"])
				? new (UCF_ClassLoader["oGetClass"]("UCF_SapTableSelectionCell"))(oCellInfo["oDomRefCell"], this)
				: null;
		}

		if (oCellInfo["oCell"]) {
			return oCellInfo["oCell"];
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetCellControlInfo"] = 0; };

/**
 * @see {@link UCF_Control#oGetContainedControlInfo}
 *
 * @param {HTMLElement} oDomRef
 * @return {UCF_SapTableBaseCell}
 */
UCF_SapTable["prototype"]["oGetContainedControlInfo"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetContainedControlInfo"]++; }; 
	return this["oGetCellControlInfo"](this["oGetCellInfoByDomRef"](oDomRef));
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["oGetContainedControlInfo"] = 0; };

/**
 * Activates native browser dragging by setting draggable attribute
 *
 * @private
 */
UCF_SapTable["prototype"]["setDraggable"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDraggable"]++; }; 
	// overwrite and do nothing, see saptable specific setDraggableRows method
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDraggable"] = 0; };

/**
 * Activates native browser dragging by setting draggable attribute
 *
 * @private
 */
UCF_SapTable["prototype"]["setDraggableRows"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDraggableRows"]++; }; 
	this["setDraggableTr"]();
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDraggableRows"] = 0; };

/**
 * Sets draggable attribute at row level
 *
 * @private
 */
UCF_SapTable["prototype"]["setDraggableTr"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDraggableTr"]++; }; 
	/** @type {UCF_DragSourceInfo} */
	var oDragSourceInfo;
	/** @type {UCF_SapTable_CellInfo[]} */
	var aRows;
	/** @type {number} */
	var i;

	if (this["sGetRowRootDragSourceInfo"]()) {
		oDragSourceInfo = this["oLS"]["oControlFactory"]["oGetControlById"](
			this["sGetRowRootDragSourceInfo"]()
		);

		if (oDragSourceInfo && oDragSourceInfo["bBrowserDragDrop"]) {
			this["bDraggable"] = true;
			this["oDomRef"]["setAttribute"]('iDDThreshold', 10000);
			//set draggable attribute for all rows
			aRows = this["aGetRows"]();
			for (i = 0; i < aRows["length"]; i++) {
				if (aRows[i] && aRows[i]["oDomRefRow"]) {
					aRows[i]["oDomRefRow"]["setAttribute"]('draggable', true);
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDraggableTr"] = 0; };

/** @private */
UCF_SapTable["prototype"]["removeConditionalStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["removeConditionalStyles"]++; }; 
	/** @type {number} */
	var iMaxRows = this["iGetCellInfoMatrixLastRowIndex"]();
	/** @type {number} */
	var iMaxCols = this["iGetCellInfoMatrixLastColIndex"]();
	/** @type {number} */
	var iRow;
	/** @type {number} */
	var iCol;
	/** @type {UCF_SapTableBaseCell} */
	var oRowCell;

	for (iRow = 0; iRow < iMaxRows; iRow++) {
		for (iCol = 0; iCol < iMaxCols; iCol++) {
			oRowCell = this["getCell"](iRow, iCol);

			if (
				oRowCell &&
				!(oRowCell instanceof UCF_SapTableHeaderCell) &&
				!(oRowCell instanceof UCF_SapTableSelectionCell)
			) {
				oRowCell["removeAllConditionalStyles"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["removeConditionalStyles"] = 0; };

/* eslint-disable max-depth */
/**
 * @see {@link UCF_Control#getMatchingConditionalStyles}
 * @override
 * @param {Object<string, {rules: string[]}>} mControlRuleOptions
 * @param {Object<string, UCF_Control_ConditionalStyleRule>} mConditionalRules
 * @return {UCF_Control_ConditionalStyle[]}
 */
UCF_SapTable["prototype"]["getMatchingConditionalStyles"] = function(mControlRuleOptions, mConditionalRules) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getMatchingConditionalStyles"]++; }; 
	/** @type {UCF_Control_ConditionalStyleRule[]} */
	var aMatchingRules = [];
	/** @type {number} */
	var iMaxRows;
	/** @type {number} */
	var iMaxCols;
	/** @type {Object<string, UCF_SapTable_DataCell>} */
	var aCells = {};
	/** @type {UCF_Control_ConditionalStyleRule} */
	var oRule;
	/** @type {number} */
	var iRow;
	/** @type {string} */
	var n;
	/** @type {UCF_Control_ConditionalStyle[]} */
	var aMatchingStyles;
	/** @type {string} */
	var sClassPrefix;
	/** @type {string[]} */
	var aRules;
	/** @type {number} */
	var i;
	/** @type {number} */
	var iCol;
	/** @type {string} */
	var sIndex;
	/** @type {UCF_SapTable_DataCell} */
	var oCell;
	/** @type {string} */
	var value;
	/** @type {number} */
	var iColCount;
	/** @type {UCF_SapTableBaseCell} */
	var oRowCell;
	/** @type {number} */
	var j;
	/** @type {UCF_Control_ConditionalStyle} */
	var oStyle;

	this["removeConditionalStyles"]();

	iMaxRows = this["iGetCellInfoMatrixLastRowIndex"]();
	iMaxCols = this["iGetCellInfoMatrixLastColIndex"]();

	for (iRow = 0; iRow < iMaxRows; iRow++) {
		for (n in mControlRuleOptions) {
			aMatchingStyles = [];
			sClassPrefix = 'CFS' + this["sClassName"]["substring"](4);
			aRules = mControlRuleOptions[n]["rules"];

			for (i = 0; i < aRules["length"]; i++) {
				oRule = mConditionalRules[aRules[i]];
				oRule["name"] = aRules[i];

				if (mControlRuleOptions[n]["rules"]) {
					iCol = parseInt(n);

					if (iCol < iMaxCols) {
						sIndex = iRow + '-' + iCol;
						if (!aCells[sIndex]) {
							aCells[sIndex] = this["oGetDataCell"](iRow, iCol);
						}

						oCell = aCells[sIndex];
						if (oCell) {
							if (oRule) {
								if (!oRule["func"]) {
									// create a function for match on the fly
									oRule["func"] = function(sValue) {
										return UCF_JsUtil["eval"]('return ' + oRule["match"], {
											"value": sValue
										});
									};
								}
								value = oCell["getConditionValue"]();
								if (oRule["func"](value)) {
									// store the matching rule
									aMatchingRules["push"](oRule);
									if (oRule["table"] && oRule["table"]["applyOn"] === 'row') {
										for (iColCount = 0; iColCount < this["aCellInfoMatrix"][iRow]["length"]; iColCount++) {
											oRowCell = this["getCell"](iRow, iColCount);
											if (
												oRowCell &&
												!(oRowCell instanceof UCF_SapTableHeaderCell) &&
												!(oRowCell instanceof UCF_SapTableSelectionCell)
											) {
												oRowCell["addConditionalStyle"](
													sClassPrefix + oRule["name"]
												);
											}
										}
									} else {
										oCell["addConditionalStyle"](sClassPrefix + oRule["name"]);
									}
								}
							}
						}
					}
				}
			}
		}
	}

	for (j = 0; j < aMatchingRules["length"]; j++) {
		oRule = aMatchingRules[j];
		oStyle = {
			"customStyle": sClassPrefix + oRule["name"],
			"type": 'SapTableCell',
			"variables": oRule["style"]
		};
		if (!oRule["mStyles"]) {
			oRule["mStyles"] = {};
		}
		oRule["mStyles"][sClassPrefix + oRule["name"]] = oStyle;
		aMatchingStyles["push"](oStyle);
	}

	aCells = null;

	return aMatchingStyles;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["getMatchingConditionalStyles"] = 0; };
/* eslint-enable max-depth */

/**
 * client-side wrapper for FeatureFlags IsEnabled fragmentut
 *
 * @private
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bNativeHScrollingEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bNativeHScrollingEnabled"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'IsEnabled',
		'FeatureFlags', { "Feature": 'SapTableNativeHScrolling' }
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bNativeHScrollingEnabled"] = 0; };

/**
 * dispatch internal and sematic event
 *
 * @private
 */
UCF_SapTable["prototype"]["doFireClientRowSelect"] = function(sId, iRowIndex, sRowUserData, sCellUserData, sAccessType, sTriggerCellId, sTriggerAction) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doFireClientRowSelect"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["ClientRowSelect"], {
		"Id": sId,
		"RowIndex": iRowIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"AccessType": sAccessType,
		"TriggerCellId": sTriggerCellId,
		"TriggerAction": sTriggerAction
	});

	this["fireClientRowSelect"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doFireClientRowSelect"] = 0; };

/**
 * dispatch internal and sematic event
 *
 * @private
 */
UCF_SapTable["prototype"]["doFireCellContextMenu"] = function(oAccessInfo, oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doFireCellContextMenu"]++; }; 
	this["fireCellContextMenu"](
		oAccessInfo["oTable"]["sId"],
		oAccessInfo["sSubControlId"],
		this["iGetApiRowIndex"](oAccessInfo["oCellInfo"]),
		this["iGetApiColIndex"](oAccessInfo["oCellInfo"]),
		oBrowserEvent["iPageX"](),
		oBrowserEvent["iPageY"](),
		this["sGetRowUserData"](oAccessInfo["oCellInfo"]),
		this["sGetCellUserData"](oAccessInfo["oCellInfo"]),
		oBrowserEvent["bShift"](),
		oBrowserEvent["bCtrl"](),
		oBrowserEvent["bAlt"]()
	);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["doFireCellContextMenu"] = 0; };

/**
 * Returns wether a select event (row/column/cell) has been bound
 * for the current cell
 *
 * @private
 * @param {HTMLElement} oDomRef
 * @return {boolean}
 */
UCF_SapTable["prototype"]["bCurrentSelectionBound"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCurrentSelectionBound"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTable.js(16193): bCurrentSelectionBound"); };

	var oCellInfo = null;
	var eSelectionState;

	if (this["mEvents"] && this["mEvents"]["CellSelect"]) return true;
	if (this["mEvents"] && (this["mEvents"]["RowSelect"] || this["mEvents"]["ClientRowSelect"] || this["mEvents"]["ColumnSelect"] || this["mEvents"]["ClientColumnSelect"])) {
		oCellInfo = this["oGetCellInfoByDomRef"](oDomRef);
		if (this["mEvents"]["RowSelect"] || this["mEvents"]["ClientRowSelect"]) {
			eSelectionState = this["eGetRowSelectionState"](oCellInfo["iRowIndex"]);
			return !(eSelectionState & this["SELECTION_LAYER"]["ROW_DISABLED"]);
		}
		if (this["mEvents"]["ColumnSelect"] || this["mEvents"]["ClientColumnSelect"]) {
			eSelectionState = this["eGetColSelectionState"](oCellInfo["iColIndex"]);
			return !(eSelectionState & this["SELECTION_LAYER"]["COLUMN_DISABLED"]);
		}
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["bCurrentSelectionBound"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SapTable["prototype"]["aAttributeNames"] = ["sTitleText","sAccessibilityDescription","iRowCount","iColCount","iVisibleFirstRow","iVisibleRowCount","iVisibleColCount","iVisibleScrollableColCount","iFirstVisibleScrollableCol","sVisibility","sTooltip","bEnabled","sAccessKey","sHotkeysId","sDragSourceInfo","sDropTargetInfo","sColumnRootDragSourceInfo","sColumnRootDropTargetInfo","sRowSelectionMode","sRowSelectionClientBehaviour","sRowSelectionFollowFocus","iRowSelectionReferenceIndex","iRowSelectionRangeEndIndex","bRowSelectionMassOperation","sRowSelectionMassState","sRowsSelected","iSelectableRowCount","sRowCreationTrigger","sCellSelectionKeyboardTrigger","sCellSelectionMapping","sCellEventProcessing","sContentThemeScope","sDefaultButtonId","sResizeMode","sHorizontalScrollUpdateMode","iHorizontalScrollPosition","sCustomData","iHeadingLevel","sLabelledBy","sBlockSelection","bColumnTitleAdoption","sSelectionMassAction"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SapTable["prototype"]["aEventNames"] = ["RowSelect","ClientRowSelect","ClientPrimaryRowChange","Filter","CellSelect","ColSort","HeaderCellSelect","HeaderActionMenuAccess","CellExpand","CellCollapse","CellIconSelect","SelectionMenuItemSelect","CellContextMenu","VerticalScroll","HorizontalScroll","ClipboardSelectionDataGet","ColumnReorder","ColumnResize","RowCreate","Hotkey","Drag","Drop","TableResize","CopyToClipboardRequest","BlockSelect"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SapTable["prototype"]["aMethodNames"] = ["setPrimaryRowSelection","setRowSelection","clearRowSelection","setColumnSelection","getPrimaryRowSelection","getRowSelection","getColumnSelection","setClipboardHtml","openHeaderActionMenu","setDefaultButtonId","getColumnWidth","setColumnWidth","setRowRootDropTargetInfo","setRowRootDragSourceInfo","getColumnHeaderDropTargetInfo","setColumnHeaderDropTargetInfo","getColumnHeaderDragSourceInfo","setColumnHeaderDragSourceInfo","getCell","setBlockSelection","visualizeCopyToClipboard","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sTitleText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iRowCount"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iColCount"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iVisibleFirstRow"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iVisibleRowCount"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iVisibleColCount"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iVisibleScrollableColCount"] = -1;

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iFirstVisibleScrollableCol"] = -1;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_SapTable["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_SapTable["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sColumnRootDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sColumnRootDropTargetInfo"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableRowSelectionMode}
 */
UCF_SapTable["prototype"]["sRowSelectionMode"] = "SERVER";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableRowSelectionClientBehaviour}
 */
UCF_SapTable["prototype"]["sRowSelectionClientBehaviour"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableRowSelectionFollowFocus}
 */
UCF_SapTable["prototype"]["sRowSelectionFollowFocus"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iRowSelectionReferenceIndex"] = -2147483648;

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iRowSelectionRangeEndIndex"] = -2147483648;

/**
 * @private
 * @type {boolean}
 */
UCF_SapTable["prototype"]["bRowSelectionMassOperation"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableRowSelectionMassState}
 */
UCF_SapTable["prototype"]["sRowSelectionMassState"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sRowsSelected"] = '';

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iSelectableRowCount"] = -1;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableRowCreationTrigger}
 */
UCF_SapTable["prototype"]["sRowCreationTrigger"] = "INHERIT";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellSelectionKeyboardTrigger}
 */
UCF_SapTable["prototype"]["sCellSelectionKeyboardTrigger"] = "SPACEBAR_ENTER";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellSelectionMapping}
 */
UCF_SapTable["prototype"]["sCellSelectionMapping"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellEventProcessing}
 */
UCF_SapTable["prototype"]["sCellEventProcessing"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sContentThemeScope"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ResizeMode}
 */
UCF_SapTable["prototype"]["sResizeMode"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableScrollUpdateMode}
 */
UCF_SapTable["prototype"]["sHorizontalScrollUpdateMode"] = "SERVER";

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iHorizontalScrollPosition"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {number}
 */
UCF_SapTable["prototype"]["iHeadingLevel"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTable["prototype"]["sBlockSelection"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_SapTable["prototype"]["bColumnTitleAdoption"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableSelectionMassAction}
 */
UCF_SapTable["prototype"]["sSelectionMassAction"] = "ROW";

//#JSCOVER_EXCL_START
/** @protected */
UCF_SapTable["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDefaultValues"]++; }; 
	this["sTitleText"] = '';
	this["sAccessibilityDescription"] = '';
	this["iRowCount"] = -1;
	this["iColCount"] = -1;
	this["iVisibleFirstRow"] = -1;
	this["iVisibleRowCount"] = -1;
	this["iVisibleColCount"] = -1;
	this["iVisibleScrollableColCount"] = -1;
	this["iFirstVisibleScrollableCol"] = -1;
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["sAccessKey"] = '';
	this["sHotkeysId"] = '';
	this["sDragSourceInfo"] = '';
	this["sDropTargetInfo"] = '';
	this["sColumnRootDragSourceInfo"] = '';
	this["sColumnRootDropTargetInfo"] = '';
	this["sRowSelectionMode"] = "SERVER";
	this["sRowSelectionClientBehaviour"] = "NONE";
	this["sRowSelectionFollowFocus"] = "NONE";
	this["iRowSelectionReferenceIndex"] = -2147483648;
	this["iRowSelectionRangeEndIndex"] = -2147483648;
	this["bRowSelectionMassOperation"] = true;
	this["sRowSelectionMassState"] = "NONE";
	this["sRowsSelected"] = '';
	this["iSelectableRowCount"] = -1;
	this["sRowCreationTrigger"] = "INHERIT";
	this["sCellSelectionKeyboardTrigger"] = "SPACEBAR_ENTER";
	this["sCellSelectionMapping"] = "NONE";
	this["sCellEventProcessing"] = "STANDARD";
	this["sContentThemeScope"] = '';
	this["sDefaultButtonId"] = '';
	this["sResizeMode"] = "NONE";
	this["sHorizontalScrollUpdateMode"] = "SERVER";
	this["iHorizontalScrollPosition"] = 0;
	this["sCustomData"] = '';
	this["iHeadingLevel"] = 0;
	this["sLabelledBy"] = '';
	this["sBlockSelection"] = '';
	this["bColumnTitleAdoption"] = false;
	this["sSelectionMassAction"] = "ROW";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("TitleText", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("RowCount", -1, true);
		this["setClientProperty"]("ColCount", -1, true);
		this["setClientProperty"]("VisibleFirstRow", -1, true);
		this["setClientProperty"]("VisibleRowCount", -1, true);
		this["setClientProperty"]("VisibleColCount", -1, true);
		this["setClientProperty"]("VisibleScrollableColCount", -1, true);
		this["setClientProperty"]("FirstVisibleScrollableCol", -1, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("ColumnRootDragSourceInfo", '', true);
		this["setClientProperty"]("ColumnRootDropTargetInfo", '', true);
		this["setClientProperty"]("RowSelectionMode", "SERVER", true);
		this["setClientProperty"]("RowSelectionClientBehaviour", "NONE", true);
		this["setClientProperty"]("RowSelectionFollowFocus", "NONE", true);
		this["setClientProperty"]("RowSelectionReferenceIndex", -2147483648, true);
		this["setClientProperty"]("RowSelectionRangeEndIndex", -2147483648, true);
		this["setClientProperty"]("RowSelectionMassOperation", true, true);
		this["setClientProperty"]("RowSelectionMassState", "NONE", true);
		this["setClientProperty"]("RowsSelected", '', true);
		this["setClientProperty"]("SelectableRowCount", -1, true);
		this["setClientProperty"]("RowCreationTrigger", "INHERIT", true);
		this["setClientProperty"]("CellSelectionKeyboardTrigger", "SPACEBAR_ENTER", true);
		this["setClientProperty"]("CellSelectionMapping", "NONE", true);
		this["setClientProperty"]("CellEventProcessing", "STANDARD", true);
		this["setClientProperty"]("ContentThemeScope", '', true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("ResizeMode", "NONE", true);
		this["setClientProperty"]("HorizontalScrollUpdateMode", "SERVER", true);
		this["setClientProperty"]("HorizontalScrollPosition", 0, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("BlockSelection", '', true);
		this["setClientProperty"]("ColumnTitleAdoption", false, true);
		this["setClientProperty"]("SelectionMassAction", "ROW", true);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iRowIndex Row index of the selected row
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select , TOGGLE for a selection toggle, DESELECT_ALL for deselction of all rows, SELECT_ALL for selcetion of all rows
 * @param {string} sTriggerCellId The id of the cell which triggered the row select
 * @param {string} sTriggerAction The action which triggers the select event. MOUSE for mouse triggered direct selection, SPACE/ENTER for keyboard triggered direct selection, FOCUS for focus triggered implicit selection (see property RowSelectionFollowFocus)
 * @fires SapTable::RowSelect
 */
UCF_SapTable["prototype"]["fireRowSelect"] = function(sId, iRowIndex, sRowUserData, sCellUserData, sAccessType, sTriggerCellId, sTriggerAction) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireRowSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number, RowUserData: string, CellUserData: string, AccessType: string, TriggerCellId: string, TriggerAction: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "SapTable.js(16594): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16595): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(16596): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTable.js(16597): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTable.js(16598): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTable.js(16599): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTable.js(16600): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTable.js(16601): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTable.js(16602): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTable.js(16603): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTable.js(16604): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTriggerCellId != null, "sTriggerCellId != null", "SapTable.js(16605): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTriggerCellId) == "string", "typeof(sTriggerCellId) == \"string\"", "SapTable.js(16606): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTriggerAction != null, "sTriggerAction != null", "SapTable.js(16607): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTriggerAction) == "string", "typeof(sTriggerAction) == \"string\"", "SapTable.js(16608): fireRowSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"AccessType": sAccessType,
		"TriggerCellId": sTriggerCellId,
		"TriggerAction": sTriggerAction
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "RowSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireRowSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iRowIndex Row index of the selected row
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select , TOGGLE for a selection toggle, DESELECT_ALL for deselction of all rows, SELECT_ALL for selcetion of all rows
 * @param {string} sTriggerCellId The id of the cell which triggered the row select
 * @param {string} sTriggerAction The action which triggers the select event. MOUSE for mouse triggered direct selection, SPACE/ENTER for keyboard triggered direct selection, FOCUS for focus triggered implicit selection (see property RowSelectionFollowFocus)
 * @fires SapTable::ClientRowSelect
 */
UCF_SapTable["prototype"]["fireClientRowSelect"] = function(sId, iRowIndex, sRowUserData, sCellUserData, sAccessType, sTriggerCellId, sTriggerAction) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireClientRowSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number, RowUserData: string, CellUserData: string, AccessType: string, TriggerCellId: string, TriggerAction: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "SapTable.js(16643): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16644): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(16645): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTable.js(16646): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTable.js(16647): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTable.js(16648): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTable.js(16649): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTable.js(16650): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTable.js(16651): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTable.js(16652): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTable.js(16653): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTriggerCellId != null, "sTriggerCellId != null", "SapTable.js(16654): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTriggerCellId) == "string", "typeof(sTriggerCellId) == \"string\"", "SapTable.js(16655): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTriggerAction != null, "sTriggerAction != null", "SapTable.js(16656): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTriggerAction) == "string", "typeof(sTriggerAction) == \"string\"", "SapTable.js(16657): fireClientRowSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"AccessType": sAccessType,
		"TriggerCellId": sTriggerCellId,
		"TriggerAction": sTriggerAction
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "ClientRowSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireClientRowSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @fires SapTable::ClientPrimaryRowChange
 */
UCF_SapTable["prototype"]["fireClientPrimaryRowChange"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireClientPrimaryRowChange"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "SapTable.js(16686): fireClientPrimaryRowChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16687): fireClientPrimaryRowChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(16688): fireClientPrimaryRowChange"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("SapTable", "ClientPrimaryRowChange", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireClientPrimaryRowChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier cell which covers the filter icon
 * @fires SapTable::Filter
 */
UCF_SapTable["prototype"]["fireFilter"] = function(sId, sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireFilter"]++; }; 
	/** @type {{Id: string, CellId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "SapTable.js(16706): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16707): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(16708): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTable.js(16709): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTable.js(16710): fireFilter"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId
	};
	
	
	this["fireSemanticEvent"]("SapTable", "Filter", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireFilter"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the selected cell
 * @param {string} sCellType The type of the selected cell
 * @param {number} iRowIndex Row index of the selected cell
 * @param {number} iColIndex Column index of the selected cell
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select, TOGGLE for a sort toggle
 * @fires SapTable::CellSelect
 */
UCF_SapTable["prototype"]["fireCellSelect"] = function(sId, sCellId, sCellType, iRowIndex, iColIndex, sRowUserData, sCellUserData, sAccessType) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCellSelect"]++; }; 
	/** @type {{Id: string, CellId: string, CellType: string, RowIndex: number, ColIndex: number, RowUserData: string, CellUserData: string, AccessType: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 8, "arguments.length == 8", "SapTable.js(16736): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16737): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(16738): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTable.js(16739): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTable.js(16740): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellType != null, "sCellType != null", "SapTable.js(16741): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellType) == "string", "typeof(sCellType) == \"string\"", "SapTable.js(16742): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTable.js(16743): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTable.js(16744): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTable.js(16745): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTable.js(16746): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTable.js(16747): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTable.js(16748): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTable.js(16749): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTable.js(16750): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTable.js(16751): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTable.js(16752): fireCellSelect"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"CellType": sCellType,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"AccessType": sAccessType
	};
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "CellSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCellSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the selected cell
 * @param {string} sAccessType The type of access which lead to the sort event. STANDARD for the standard access, TOGGLE for a selection toggle
 * @fires SapTable::ColSort
 */
UCF_SapTable["prototype"]["fireColSort"] = function(sId, sCellId, sAccessType) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireColSort"]++; }; 
	/** @type {{Id: string, CellId: string, AccessType: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "SapTable.js(16785): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16786): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(16787): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTable.js(16788): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTable.js(16789): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTable.js(16790): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTable.js(16791): fireColSort"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"AccessType": sAccessType
	};
	
	
	
	this["fireSemanticEvent"]("SapTable", "ColSort", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireColSort"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the selected cell
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select, TOGGLE for a selection toggle
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @fires SapTable::HeaderCellSelect
 */
UCF_SapTable["prototype"]["fireHeaderCellSelect"] = function(sId, sCellId, sAccessType, sCellUserData) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireHeaderCellSelect"]++; }; 
	/** @type {{Id: string, CellId: string, AccessType: string, CellUserData: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "SapTable.js(16815): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16816): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(16817): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTable.js(16818): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTable.js(16819): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTable.js(16820): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTable.js(16821): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTable.js(16822): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTable.js(16823): fireHeaderCellSelect"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"AccessType": sAccessType,
		"CellUserData": sCellUserData
	};
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "HeaderCellSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireHeaderCellSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the header cell
 * @param {boolean} bWithKeyboard Determine if menu is opened by keyboard or mouse user interaction
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @fires SapTable::HeaderActionMenuAccess
 */
UCF_SapTable["prototype"]["fireHeaderActionMenuAccess"] = function(sId, sCellId, bWithKeyboard, sCellUserData) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireHeaderActionMenuAccess"]++; }; 
	/** @type {{Id: string, CellId: string, WithKeyboard: boolean, CellUserData: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "SapTable.js(16849): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16850): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(16851): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTable.js(16852): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTable.js(16853): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bWithKeyboard != null, "bWithKeyboard != null", "SapTable.js(16854): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bWithKeyboard) == "boolean", "typeof(bWithKeyboard) == \"boolean\"", "SapTable.js(16855): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTable.js(16856): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTable.js(16857): fireHeaderActionMenuAccess"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"WithKeyboard": bWithKeyboard,
		"CellUserData": sCellUserData
	};
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "HeaderActionMenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireHeaderActionMenuAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iRowIndex Row index of the selected cell
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sCellId Identifier of the selected cell
 * @fires SapTable::CellExpand
 */
UCF_SapTable["prototype"]["fireCellExpand"] = function(sId, iRowIndex, sRowUserData, sCellUserData, sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCellExpand"]++; }; 
	/** @type {{Id: string, RowIndex: number, RowUserData: string, CellUserData: string, CellId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "SapTable.js(16884): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16885): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(16886): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTable.js(16887): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTable.js(16888): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTable.js(16889): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTable.js(16890): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTable.js(16891): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTable.js(16892): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTable.js(16893): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTable.js(16894): fireCellExpand"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"CellId": sCellId
	};
	
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "CellExpand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCellExpand"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iRowIndex Row index of the selected cell
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sCellId Identifier of the selected cell
 * @fires SapTable::CellCollapse
 */
UCF_SapTable["prototype"]["fireCellCollapse"] = function(sId, iRowIndex, sRowUserData, sCellUserData, sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCellCollapse"]++; }; 
	/** @type {{Id: string, RowIndex: number, RowUserData: string, CellUserData: string, CellId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "SapTable.js(16923): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16924): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(16925): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTable.js(16926): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTable.js(16927): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTable.js(16928): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTable.js(16929): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTable.js(16930): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTable.js(16931): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTable.js(16932): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTable.js(16933): fireCellCollapse"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"CellId": sCellId
	};
	
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "CellCollapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCellCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iRowIndex Row index of the selected cell
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sCellId Identifier of the selected cell
 * @fires SapTable::CellIconSelect
 */
UCF_SapTable["prototype"]["fireCellIconSelect"] = function(sId, iRowIndex, sRowUserData, sCellUserData, sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCellIconSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number, RowUserData: string, CellUserData: string, CellId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "SapTable.js(16962): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16963): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(16964): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTable.js(16965): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTable.js(16966): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTable.js(16967): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTable.js(16968): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTable.js(16969): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTable.js(16970): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTable.js(16971): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTable.js(16972): fireCellIconSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"CellId": sCellId
	};
	
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "CellIconSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCellIconSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sMenuItemId Identifier of the PopupMenuItem
 * @fires SapTable::SelectionMenuItemSelect
 */
UCF_SapTable["prototype"]["fireSelectionMenuItemSelect"] = function(sId, sMenuItemId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireSelectionMenuItemSelect"]++; }; 
	/** @type {{Id: string, MenuItemId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "SapTable.js(16998): fireSelectionMenuItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(16999): fireSelectionMenuItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17000): fireSelectionMenuItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMenuItemId != null, "sMenuItemId != null", "SapTable.js(17001): fireSelectionMenuItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMenuItemId) == "string", "typeof(sMenuItemId) == \"string\"", "SapTable.js(17002): fireSelectionMenuItemSelect"); };
	mParams = {
		"Id": sId,
		"MenuItemId": sMenuItemId
	};
	
	
	this["fireSemanticEvent"]("SapTable", "SelectionMenuItemSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireSelectionMenuItemSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the affected cell
 * @param {number} iRowIndex Row index of the affected cell
 * @param {number} iColIndex Column index of the affected cell
 * @param {number} iPosX Horizontal mouse pointer position
 * @param {number} iPosY Vertical mouse pointer position
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {boolean} bShift True if the SHIFT modifier is pressed
 * @param {boolean} bCtrl True if the CTRL modifier is pressed
 * @param {boolean} bAlt True if the ALT modifier is pressed
 * @fires SapTable::CellContextMenu
 */
UCF_SapTable["prototype"]["fireCellContextMenu"] = function(sId, sCellId, iRowIndex, iColIndex, iPosX, iPosY, sRowUserData, sCellUserData, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCellContextMenu"]++; }; 
	/** @type {{Id: string, CellId: string, RowIndex: number, ColIndex: number, PosX: number, PosY: number, RowUserData: string, CellUserData: string, Shift: boolean, Ctrl: boolean, Alt: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 11, "arguments.length == 11", "SapTable.js(17031): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17032): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17033): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTable.js(17034): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTable.js(17035): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTable.js(17036): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTable.js(17037): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTable.js(17038): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTable.js(17039): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "SapTable.js(17040): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "SapTable.js(17041): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "SapTable.js(17042): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "SapTable.js(17043): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTable.js(17044): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTable.js(17045): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTable.js(17046): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTable.js(17047): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "SapTable.js(17048): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "SapTable.js(17049): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "SapTable.js(17050): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "SapTable.js(17051): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "SapTable.js(17052): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "SapTable.js(17053): fireCellContextMenu"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex,
		"PosX": iPosX,
		"PosY": iPosY,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt
	};
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "CellContextMenu", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCellContextMenu"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iFirstVisibleItemIndex The index of the item to which was scrolled to
 * @param {string} sAction The action which lead to the scroll event: NONE, PREVIOUS, NEXT, BEGIN, END, NEXT_PAGE, PREVIOUS_PAGE, DIRECT
 * @param {string} sCellId Identifier of the cell which received the focus while scrolling process
 * @param {string} sAccessType The type of access which lead to the scroll event. SCROLLBAR for a direct scrollbar access and  EXTERNAL for a method call from a none-scrollbar control like the table itself
 * @param {boolean} bSelectionFollowFocus True if the scrolling should also affect the selected row
 * @param {boolean} bShift True if the SIFT modifier is pressed
 * @param {boolean} bCtrl True if the CTRL modifier is pressed
 * @param {boolean} bAlt True if the ALT modifier is pressed
 * @fires SapTable::VerticalScroll
 */
UCF_SapTable["prototype"]["fireVerticalScroll"] = function(sId, iFirstVisibleItemIndex, sAction, sCellId, sAccessType, bSelectionFollowFocus, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireVerticalScroll"]++; }; 
	/** @type {{Id: string, FirstVisibleItemIndex: number, Action: string, CellId: string, AccessType: string, SelectionFollowFocus: boolean, Shift: boolean, Ctrl: boolean, Alt: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 9, "arguments.length == 9", "SapTable.js(17098): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17099): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17100): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleItemIndex != null, "iFirstVisibleItemIndex != null", "SapTable.js(17101): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleItemIndex) == "number", "typeof(iFirstVisibleItemIndex) == \"number\"", "SapTable.js(17102): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAction != null, "sAction != null", "SapTable.js(17103): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAction) == "string", "typeof(sAction) == \"string\"", "SapTable.js(17104): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTable.js(17105): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTable.js(17106): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTable.js(17107): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTable.js(17108): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bSelectionFollowFocus != null, "bSelectionFollowFocus != null", "SapTable.js(17109): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bSelectionFollowFocus) == "boolean", "typeof(bSelectionFollowFocus) == \"boolean\"", "SapTable.js(17110): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "SapTable.js(17111): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "SapTable.js(17112): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "SapTable.js(17113): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "SapTable.js(17114): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "SapTable.js(17115): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "SapTable.js(17116): fireVerticalScroll"); };
	mParams = {
		"Id": sId,
		"FirstVisibleItemIndex": iFirstVisibleItemIndex,
		"Action": sAction,
		"CellId": sCellId,
		"AccessType": sAccessType,
		"SelectionFollowFocus": bSelectionFollowFocus,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt
	};
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "VerticalScroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireVerticalScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iFirstVisibleItemIndex The index of the item to which was scrolled to
 * @param {string} sAction The action which lead to the scroll event: NONE, PREVIOUS, NEXT, BEGIN, END, NEXT_PAGE, PREVIOUS_PAGE, DIRECT
 * @param {string} sAccessType The type of access which lead to the scroll event. SCROLLBAR for a direct scrollbar access and  EXTERNAL for a method call from a none-scrollbar control like the table itself
 * @param {boolean} bShift True if the SIFT modifier is pressed
 * @param {boolean} bCtrl True if the CTRL modifier is pressed
 * @param {boolean} bAlt True if the ALT modifier is pressed
 * @fires SapTable::HorizontalScroll
 */
UCF_SapTable["prototype"]["fireHorizontalScroll"] = function(sId, iFirstVisibleItemIndex, sAction, sAccessType, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireHorizontalScroll"]++; }; 
	/** @type {{Id: string, FirstVisibleItemIndex: number, Action: string, AccessType: string, Shift: boolean, Ctrl: boolean, Alt: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "SapTable.js(17155): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17156): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17157): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleItemIndex != null, "iFirstVisibleItemIndex != null", "SapTable.js(17158): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleItemIndex) == "number", "typeof(iFirstVisibleItemIndex) == \"number\"", "SapTable.js(17159): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAction != null, "sAction != null", "SapTable.js(17160): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAction) == "string", "typeof(sAction) == \"string\"", "SapTable.js(17161): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTable.js(17162): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTable.js(17163): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "SapTable.js(17164): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "SapTable.js(17165): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "SapTable.js(17166): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "SapTable.js(17167): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "SapTable.js(17168): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "SapTable.js(17169): fireHorizontalScroll"); };
	mParams = {
		"Id": sId,
		"FirstVisibleItemIndex": iFirstVisibleItemIndex,
		"Action": sAction,
		"AccessType": sAccessType,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "HorizontalScroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireHorizontalScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires SapTable::ClipboardSelectionDataGet
 */
UCF_SapTable["prototype"]["fireClipboardSelectionDataGet"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireClipboardSelectionDataGet"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "SapTable.js(17198): fireClipboardSelectionDataGet"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17199): fireClipboardSelectionDataGet"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17200): fireClipboardSelectionDataGet"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("SapTable", "ClipboardSelectionDataGet", mParams, false, false, true);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireClipboardSelectionDataGet"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sMovedColId Identifier of the table column which was dragged
 * @param {string} sRefColId Identifier of the table column next to the position the MovedColumn was dropped
 * @param {string} sInsertMode Determines if the MovedColumn was dropped before or after the RefColumn. Possible values are 'AFTER' or 'BEFORE'
 * @fires SapTable::ColumnReorder
 */
UCF_SapTable["prototype"]["fireColumnReorder"] = function(sId, sMovedColId, sRefColId, sInsertMode) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireColumnReorder"]++; }; 
	/** @type {{Id: string, MovedColId: string, RefColId: string, InsertMode: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "SapTable.js(17220): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17221): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17222): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMovedColId != null, "sMovedColId != null", "SapTable.js(17223): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMovedColId) == "string", "typeof(sMovedColId) == \"string\"", "SapTable.js(17224): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRefColId != null, "sRefColId != null", "SapTable.js(17225): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRefColId) == "string", "typeof(sRefColId) == \"string\"", "SapTable.js(17226): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sInsertMode != null, "sInsertMode != null", "SapTable.js(17227): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sInsertMode) == "string", "typeof(sInsertMode) == \"string\"", "SapTable.js(17228): fireColumnReorder"); };
	mParams = {
		"Id": sId,
		"MovedColId": sMovedColId,
		"RefColId": sRefColId,
		"InsertMode": sInsertMode
	};
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "ColumnReorder", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireColumnReorder"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sColWidths All new widths of all visible columns (without selction column) in pixel separated by a semicolon and ordered by the column index
 * @fires SapTable::ColumnResize
 */
UCF_SapTable["prototype"]["fireColumnResize"] = function(sId, sColWidths) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireColumnResize"]++; }; 
	/** @type {{Id: string, ColWidths: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "SapTable.js(17252): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17253): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17254): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sColWidths != null, "sColWidths != null", "SapTable.js(17255): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sColWidths) == "string", "typeof(sColWidths) == \"string\"", "SapTable.js(17256): fireColumnResize"); };
	mParams = {
		"Id": sId,
		"ColWidths": sColWidths
	};
	
	
	this["fireSemanticEvent"]("SapTable", "ColumnResize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireColumnResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iColIndex Column index of the trigger cell
 * @param {number} iInsertAt The expected new row index of the newly created row
 * @fires SapTable::RowCreate
 */
UCF_SapTable["prototype"]["fireRowCreate"] = function(sId, iColIndex, iInsertAt) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireRowCreate"]++; }; 
	/** @type {{Id: string, ColIndex: number, InsertAt: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "SapTable.js(17277): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17278): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17279): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTable.js(17280): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTable.js(17281): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iInsertAt != null, "iInsertAt != null", "SapTable.js(17282): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iInsertAt) == "number", "typeof(iInsertAt) == \"number\"", "SapTable.js(17283): fireRowCreate"); };
	mParams = {
		"Id": sId,
		"ColIndex": iColIndex,
		"InsertAt": iInsertAt
	};
	
	
	
	this["fireSemanticEvent"]("SapTable", "RowCreate", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireRowCreate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires SapTable::Hotkey
 */
UCF_SapTable["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "SapTable.js(17306): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17307): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17308): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "SapTable.js(17309): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "SapTable.js(17310): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "SapTable.js(17311): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "SapTable.js(17312): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	
	
	this["fireSemanticEvent"]("SapTable", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireHotkey"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires SapTable::Drag
 */
UCF_SapTable["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "SapTable.js(17335): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17336): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17337): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "SapTable.js(17338): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "SapTable.js(17339): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "SapTable.js(17340): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "SapTable.js(17341): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("SapTable", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sDropTargetCellId Identifier of the dropped cell
 * @param {number} iRowIndex The row index of the table cell where the drop occurred
 * @param {number} iColIndex The col index of the table cell where the drop occurred
 * @param {string} sDirection 'HORIZONTAL', 'VERTICAL' or 'NONE'
 * @param {number} iOffset The offset relative to the target segment of the table (e.g. row ) where the drop occurred (signum). -1 means insert before, +1 means insert after and 0 means drop (no insert)
 * @param {number} iHierarchyLevel The hierarchy level of the drop cell starting with 0=root. -1 means no hierarchy available.
 * @param {string} sData Arbitrary data which has been provided by the drag event response of the using framework
 * @param {string} sMimeType Mime type of the data provided by tthe drag event response of the using framework
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires SapTable::Drop
 */
UCF_SapTable["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, sDropTargetCellId, iRowIndex, iColIndex, sDirection, iOffset, iHierarchyLevel, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, DropTargetCellId: string, RowIndex: number, ColIndex: number, Direction: string, Offset: number, HierarchyLevel: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 16, "arguments.length == 16", "SapTable.js(17377): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17378): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17379): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "SapTable.js(17380): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "SapTable.js(17381): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "SapTable.js(17382): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "SapTable.js(17383): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetCellId != null, "sDropTargetCellId != null", "SapTable.js(17384): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetCellId) == "string", "typeof(sDropTargetCellId) == \"string\"", "SapTable.js(17385): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTable.js(17386): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTable.js(17387): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTable.js(17388): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTable.js(17389): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDirection != null, "sDirection != null", "SapTable.js(17390): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDirection) == "string", "typeof(sDirection) == \"string\"", "SapTable.js(17391): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOffset != null, "iOffset != null", "SapTable.js(17392): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOffset) == "number", "typeof(iOffset) == \"number\"", "SapTable.js(17393): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iHierarchyLevel != null, "iHierarchyLevel != null", "SapTable.js(17394): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iHierarchyLevel) == "number", "typeof(iHierarchyLevel) == \"number\"", "SapTable.js(17395): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "SapTable.js(17396): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "SapTable.js(17397): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "SapTable.js(17398): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "SapTable.js(17399): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "SapTable.js(17400): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "SapTable.js(17401): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "SapTable.js(17402): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "SapTable.js(17403): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "SapTable.js(17404): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "SapTable.js(17405): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "SapTable.js(17406): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "SapTable.js(17407): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "SapTable.js(17408): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "SapTable.js(17409): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"DropTargetCellId": sDropTargetCellId,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex,
		"Direction": sDirection,
		"Offset": iOffset,
		"HierarchyLevel": iHierarchyLevel,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTable", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iVisibleRowCount 
 * @fires SapTable::TableResize
 */
UCF_SapTable["prototype"]["fireTableResize"] = function(sId, iVisibleRowCount) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireTableResize"]++; }; 
	/** @type {{Id: string, VisibleRowCount: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "SapTable.js(17457): fireTableResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17458): fireTableResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17459): fireTableResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iVisibleRowCount != null, "iVisibleRowCount != null", "SapTable.js(17460): fireTableResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iVisibleRowCount) == "number", "typeof(iVisibleRowCount) == \"number\"", "SapTable.js(17461): fireTableResize"); };
	mParams = {
		"Id": sId,
		"VisibleRowCount": iVisibleRowCount
	};
	
	
	this["fireSemanticEvent"]("SapTable", "TableResize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireTableResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCurrentSelectionText The current text selection within the window
 * @fires SapTable::CopyToClipboardRequest
 */
UCF_SapTable["prototype"]["fireCopyToClipboardRequest"] = function(sId, sCurrentSelectionText) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCopyToClipboardRequest"]++; }; 
	/** @type {{Id: string, CurrentSelectionText: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "SapTable.js(17481): fireCopyToClipboardRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17482): fireCopyToClipboardRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17483): fireCopyToClipboardRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCurrentSelectionText != null, "sCurrentSelectionText != null", "SapTable.js(17484): fireCopyToClipboardRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCurrentSelectionText) == "string", "typeof(sCurrentSelectionText) == \"string\"", "SapTable.js(17485): fireCopyToClipboardRequest"); };
	mParams = {
		"Id": sId,
		"CurrentSelectionText": sCurrentSelectionText
	};
	
	
	this["fireSemanticEvent"]("SapTable", "CopyToClipboardRequest", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireCopyToClipboardRequest"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sBlockSelection BlockSelection Range (for example: {'TopLeftCol': 1, 'TopLeftRow': 1, 'BottomRightCol': 4, 'BottomRightRow': 4, 'RefCol': 1, 'RefRow': 1})
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the setting a block (former blocks/selections get erased), TOGGLE for adding a block (former blocks/selections are kept)
 * @fires SapTable::BlockSelect
 */
UCF_SapTable["prototype"]["fireBlockSelect"] = function(sId, sBlockSelection, sAccessType) {;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireBlockSelect"]++; }; 
	/** @type {{Id: string, BlockSelection: string, AccessType: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "SapTable.js(17506): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTable.js(17507): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTable.js(17508): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sBlockSelection != null, "sBlockSelection != null", "SapTable.js(17509): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sBlockSelection) == "string", "typeof(sBlockSelection) == \"string\"", "SapTable.js(17510): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTable.js(17511): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTable.js(17512): fireBlockSelect"); };
	mParams = {
		"Id": sId,
		"BlockSelection": sBlockSelection,
		"AccessType": sAccessType
	};
	
	
	
	this["fireSemanticEvent"]("SapTable", "BlockSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTable["_"]["fireBlockSelect"] = 0; };

UCF_SapTable.prototype["aPublicMethods"] = ["sGetContentThemeScope","setDefaultButtonId","setClipboardHtml","setPrimaryRowSelection","setRowSelection","clearRowSelection","setColumnSelection","setBlockSelection","getPrimaryRowSelection","getRowSelection","getColumnSelection","getFocusInfoByIndex","visualizeCopyToClipboard","openHeaderActionMenu","getCell","getCellByDomRef","setRowRootDropTargetInfo","setRowRootDragSourceInfo","sGetRowDropTargetInfo","sGetRowParentDropTargetInfo","sGetRowDragData","sGetColumnRootDropTargetInfo","sGetColumnRootDragSourceInfo","sGetColumnDropTargetInfo","sGetColumnParentDropTargetInfo","sGetColumnDragSourceInfo","getColumnHeaderDropTargetInfo","setColumnHeaderDropTargetInfo","getColumnHeaderDragSourceInfo","setColumnHeaderDragSourceInfo","getColumnWidth","setColumnWidth"].concat(UCF_SapTable.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_SapTableAccessibilityHelper"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_SapTable */
/// <reference path="../SapTable.js"/>
/* global UCF_SapTableCell */
/// <reference path="../SapTableCell.js"/>
/* global UCF_SapTableHeaderCell */
/// <reference path="../SapTableHeaderCell.js"/>
/* global UCF_SapTableHierarchicalCell */
/// <reference path="../SapTableHierarchicalCell.js"/>
/* global UCF_SapTableMatrixCell */
/// <reference path="../SapTableMatrixCell.js"/>
/* global UCF_SapTableSelectionCell */
/// <reference path="../SapTableSelectionCell.js"/>

/**
 * Helper class for hte table control to provide accessibility.
 *
 * @class
 * 
 *
 * @version
 * @param {UCF_SapTable} oTable
 */
function UCF_SapTableAccessibilityHelper(oTable) {if (__UCF_COVERAGE__) { UCF_SapTableAccessibilityHelper["_"]["UCF_SapTableAccessibilityHelper"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oTable instanceof UCF_SapTable, "oTable instanceof UCF_SapTable", "SapTableAccessibilityHelper.js(32): UCF_SapTableAccessibilityHelper"); };

	this["oTable"] = oTable;

};window["UCF_SapTableAccessibilityHelper"] = UCF_SapTableAccessibilityHelper; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableAccessibilityHelper"); UCF_SapTableAccessibilityHelper["_"] = {UCF_SapTableAccessibilityHelper: 0}; }; ;

UCF_SapTableAccessibilityHelper["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_SapTableAccessibilityHelper.prototype["sClassName"] = "UCF_SapTableAccessibilityHelper";

/** @override */
UCF_SapTableAccessibilityHelper["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableAccessibilityHelper["_"]["destroy"]++; }; 
	this["cleanUp"]();
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTableAccessibilityHelper["_"]["destroy"] = 0; };

/**
 * Clean up
 *
 * @private
 */
UCF_SapTableAccessibilityHelper["prototype"]["cleanUp"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableAccessibilityHelper["_"]["cleanUp"]++; }; 
	this["oTable"] = null;
};;if (__UCF_COVERAGE__) { UCF_SapTableAccessibilityHelper["_"]["cleanUp"] = 0; };

/**
 * Delegated from table
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 *
 * @private
 */
UCF_SapTableAccessibilityHelper["prototype"]["onlsaccessibility"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableAccessibilityHelper["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableAccessibilityHelper.js(63): onlsaccessibility"); };

	//Avoid double processing of nested tables -> nested tables are not allowed but there should be any JS errors
	if (oBrowserEvent["oGetData"]()["bProcessedBySapTableAcessibility"]) {
		return;
	} else {
		oBrowserEvent["oGetData"]()["bProcessedBySapTableAcessibility"] = true;
	}

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSourceControl = oBrowserEvent["oGetSourceControl"](),
		oAccessInfo = this["oTable"]["oGetAccessInfo"](oBrowserEvent, this["oTable"]["ACCESS_TYPE"]["S_508"]),
		oCell = null;

	if (!oAccessInfo)
		return;

	if (oAccessInfo["eSubControlType"] == this["oTable"]["SUBCONTROL"]["HEADER_CELL"]) {
		oCell = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableHeaderCell"))(oAccessInfo["oSubControlDomRef"], this["oTable"]);
	} else if (oAccessInfo["eSubControlType"] == this["oTable"]["SUBCONTROL"]["STANDARD_CELL"] || oAccessInfo["eSubControlType"] == this["oTable"]["SUBCONTROL"]["POPIN_CELL"]) {
		oCell = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableCell"))(oAccessInfo["oSubControlDomRef"], this["oTable"]);
	} else if (oAccessInfo["eSubControlType"] == this["oTable"]["SUBCONTROL"]["HIERARCHY_CELL"]) {
		oCell = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableHierarchicalCell"))(oAccessInfo["oSubControlDomRef"], this["oTable"]);
	} else if (oAccessInfo["eSubControlType"] == this["oTable"]["SUBCONTROL"]["MATRIX_CELL"]) {
		oCell = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableMatrixCell"))(oAccessInfo["oSubControlDomRef"], this["oTable"]);
	} else if (oAccessInfo["eSubControlType"] == this["oTable"]["SUBCONTROL"]["SELECTION_CELL"]) {
		oCell = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableSelectionCell"))(oAccessInfo["oSubControlDomRef"], this["oTable"]);
	} else if (oAccessInfo["eSubControlType"] == this["oTable"]["SUBCONTROL"]["TABLE"]) {
		if (oSourceControl == this["oTable"]) {

			if (oAccessInfo["eAction"] == this["oTable"]["ACTION"]["TABLE_END"]) {
				oAccessibilityHelper["setControlType"]("ST_END");
			} else if (oAccessInfo["eAction"] == this["oTable"]["ACTION"]["CONFIG"]) {
				oAccessibilityHelper["setControlType"]("ST_CONFIG");
				oAccessibilityHelper["addTutor"]("ST_CONFIG_TUT");
			} else if (oAccessInfo["eAction"] == this["oTable"]["ACTION"]["NO_DATA_NOTIFICATION"]) {

				if (this["oTable"]["sNoDataNotification"] == "UNSPECIFIC") {
					oAccessibilityHelper["setControlType"]("ST_NO_DATA");
				} else if (this["oTable"]["sNoDataNotification"] == "NO_SEARCH_RESULTS") {
					oAccessibilityHelper["setControlType"]("ST_NO_SEARCH_RESULTS");
				} else if (this["oTable"]["sNoDataNotification"] == "FREE_TEXT") {
					oAccessibilityHelper["setText"](this["oTable"]["sNoDataNotificationText"]);
				}

			} else {
				var sLabelText = null;

				//Label
				if (this["oTable"]["sAccessibilityDescription"]) {
					sLabelText = this["oTable"]["sAccessibilityDescription"];
				} else if (this["oTable"]["sTitleText"]) {
					sLabelText = this["oTable"]["sTitleText"];
				} else {
					sLabelText = this["oTable"]["oDomRef"]["getAttribute"]("t"); //TODO remove such DOM access
				}

				oAccessibilityHelper["setLabel"](sLabelText);

				//Enabled
				oAccessibilityHelper["setEnabled"](this["oTable"]["bEnabled"]);

				//Tooltip (avoid double announcement with label)
				if (this["oTable"]["sTooltip"] && this["oTable"]["sTooltip"] != sLabelText) oAccessibilityHelper["addTooltip"](this["oTable"]["sTooltip"]);

				// Control type
				if (window["UCF_System"]["bIsAria"]) {
					var iAriaRowCount = parseInt(this["oTable"]["oDomRef"]["getAttribute"]("aria-rowcount"), 10);
					var iAriaColCount;
					if (this["oTable"]["oDomRef"]["hasAttribute"]("aria-colcount")) {
						iAriaColCount = parseInt(this["oTable"]["oDomRef"]["getAttribute"]("aria-colcount"), 10);
					}
					else {
						iAriaColCount = this["oTable"]["iColCount"] + (this["oTable"]["bHasLeadingSelectionColumn"]() ? 1 : 0);
					}
					oAccessibilityHelper["setControlType"]("ST", [iAriaColCount, iAriaRowCount]);
				}
				else {
					var iRowCount = this["oTable"]["iRowCount"],
						iColCount = this["oTable"]["iColCount"],
						iVisibleRowCount = this["oTable"]["iVisibleRowCount"],
						iVisibleColCount = this["oTable"]["iVisibleColCount"],
						iVisibleFirstRow = this["oTable"]["iVisibleFirstRow"] + (this["oTable"]["bZeroBasedScrolling"] ? 1 : 0);

					if (iRowCount == 0) {
						oAccessibilityHelper["setControlType"]("ST_EMPTY", [iColCount]);
					} else if (iVisibleRowCount > 0 && iVisibleRowCount < iRowCount) {
						if (iVisibleColCount != -1 && iVisibleColCount < iColCount) {
							oAccessibilityHelper["setControlType"]("ST_PAGE_HS", [iColCount, iVisibleRowCount, iRowCount, iVisibleFirstRow, iVisibleColCount]);
						} else {
							oAccessibilityHelper["setControlType"]("ST_PAGE", [iColCount, iVisibleRowCount, iRowCount, iVisibleFirstRow]);
						}
					} else {
						if (iVisibleColCount != -1 && iVisibleColCount < iColCount) {
							oAccessibilityHelper["setControlType"]("ST_HS", [iColCount, iRowCount, iVisibleColCount]);
						} else {
							oAccessibilityHelper["setControlType"]("ST", [iColCount, iRowCount]);
						}
					}
				}

				if (window["UCF_System"]["bIsAria"]) {
					oAccessibilityHelper["addTutor"]("ST_ENTRY_ARIA_TUT");
				} else {
					oAccessibilityHelper["applyContainerEntryBehaviour"]();
				}
			}
		}
	}

	if (oCell) {
		var oCellInfo = this["oTable"]["oGetCellInfoByBrowserEvent"](oBrowserEvent);
		oCell["setCellInfo"](oCellInfo);
		oCell["setAccessibilityInfo"](oSourceControl, oAccessInfo, oAccessibilityHelper);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableAccessibilityHelper["_"]["onlsaccessibility"] = 0; };

};
sap["ls"]["preload"]["UCF_SapTableBaseCell"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_Interface */
/// <reference path="../../../core/Interface.js"/>
/* global UCF_ControlInfo */
/// <reference path="../../core/ControlInfo.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_AccessibilityHelper */
/// <reference path="../../helper/AccessibilityHelper.js"/>
/* global UCF_SapTable */
/// <reference path="../SapTable.js"/>
/* global UCF_SapTableHeaderCell */
/// <reference path="../SapTableHeaderCell.js"/>

/**
 * Base class for SapTable cells.
 * @class
 * 
 */
function UCF_SapTableBaseCell(oDomRef, oTable) {if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["UCF_SapTableBaseCell"]++; }; 

	if (arguments["length"] == 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) == "object", "typeof (oDomRef) == \"object\"", "SapTableBaseCell.js(29): UCF_SapTableBaseCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTableBaseCell.js(30): UCF_SapTableBaseCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oTable instanceof UCF_SapTable, "oTable instanceof UCF_SapTable", "SapTableBaseCell.js(31): UCF_SapTableBaseCell"); };

	UCF_ControlInfo["apply"](this, [oDomRef, oTable["oLS"]]);

	this["oTable"] = oTable;

	this["sRowInfo"] = null;
	this["sColumnInfo"] = null;
	this["sCellTutorInfo"] = null;

	this["oCellInfo"] = null;

	var sId = oDomRef["getAttribute"]("id");
	this["sId"] = (sId) ? sId : ""; // eslint-disable-line @ur/no-missing-setClientProperty
	this["oCellInfo"] = this["oTable"]["oGetCellInfoByDomRef"](this["oDomRef"]);

	var oHeaderCellInfo = this["oTable"]["oGetHeaderCellInfoByDomRef"](this["oDomRef"]);
	if (oHeaderCellInfo && this["oTable"]["eGetCellType"](this["oCellInfo"]) != this["oTable"]["SUBCONTROL"]["HEADER_CELL"])
		this["oHeader"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableHeaderCell"))(oHeaderCellInfo["oDomRefCell"], this["oTable"]);
	else
		this["oHeader"] = null;

	this["oAccessibilityHelper"] = null;

	if (!this["oCellInfo"]["sCustomStyles"]) {
		this["oCellInfo"]["sCustomStyles"] = "";
	}
	if (!this["oCellInfo"]["sConditionalStyles"]) {
		this["oCellInfo"]["sConditionalStyles"] = "";
	}
	if (!this["oCellInfo"]["sCssClasses"]) {
		this["oCellInfo"]["sCssClasses"] = this["oDomRef"]["className"];
	}

};window["UCF_SapTableBaseCell"] = UCF_SapTableBaseCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableBaseCell"); UCF_SapTableBaseCell["_"] = {UCF_SapTableBaseCell: 0}; }; ;
UCF_SapTableBaseCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ControlInfo"))(); UCF_SapTableBaseCell.prototype["sClassName"] = "UCF_SapTableBaseCell";

UCF_SapTableBaseCell["prototype"]["SELECTION_STATE"] = {
	"NOT_SELECTED": 0,
	"PRIMARY": 1,
	"SECONDARY": 2,
	"COLUMN": 3
};

/**
 * Destructor
 * @private
 */
UCF_SapTableBaseCell["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["destroy"]++; }; 

	this["oTable"] = null;
	this["oCellInfo"] = null;
	this["oAccessInfo"] = null;

	if (this["oHeader"]) {
		this["oHeader"]["destroy"]();
		this["oHeader"] = null;
	}

	if (this["oAccessibilityHelper"]) {
		this["oAccessibilityHelper"]["destroy"]();
		this["oAccessibilityHelper"] = null;
	}

	UCF_ControlInfo.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["destroy"] = 0; };

/**
 * Calculates the acc info and calls the cell specific implementations
 *
 * @param {UCF_Control} oSourceControl the browser event object
 * @param {Object} oAccessInfo
 * @param {UCF_AccessibilityHelper} oAccessibilityHelper
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["setAccessibilityInfo"] = function (oSourceControl, oAccessInfo, oAccessibilityHelper) {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["setAccessibilityInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableBaseCell.js(108): setAccessibilityInfo"); };

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessibilityHelper instanceof UCF_AccessibilityHelper, "oAccessibilityHelper instanceof UCF_AccessibilityHelper", "SapTableBaseCell.js(110): setAccessibilityInfo"); };

	//Skip announcement for cell?
	if (this["oDomRef"]["getAttribute"]("skpCAnnounce")) {
		return;
	}

	if (oSourceControl != this["oTable"]) {

		this["oAccessibilityHelper"] = new (UCF_ClassLoader["oGetClass"]("UCF_AccessibilityHelper"))(this["oTable"]["oLS"]);
		oAccessibilityHelper["addContainerHelper"](this["oAccessibilityHelper"]);

	} else {
		// When content of a cell is no control but marked as empty
		if (oAccessInfo["oBrowserEvent"]
			&& oAccessInfo["oBrowserEvent"]["oGetSource"]()
			&& oAccessInfo["oBrowserEvent"]["oGetSource"]()["getAttribute"]("empty")
		) {

			oAccessibilityHelper["setEmpty"](true);

			this["oAccessibilityHelper"] = new (UCF_ClassLoader["oGetClass"]("UCF_AccessibilityHelper"))(this["oTable"]["oLS"]);

			oAccessibilityHelper["addContainerHelper"](this["oAccessibilityHelper"]);
		} else {
			this["oAccessibilityHelper"] = oAccessibilityHelper;
		}
	}

	this["oAccessInfo"] = oAccessInfo;

	var sRowAccDescription = this["sSpaceCleanUp"](this["sGetRowAccDescription"]()),
		sRowInfo = this["sSpaceCleanUp"](this["sGetRowInfo"]()),
		sColumnInfo = this["sSpaceCleanUp"](this["sGetColumnInfo"]()),
		sTutorInfo = this["sSpaceCleanUp"](this["sGetTutorInfo"]());

	//adjust rowIndex to native JAWS calculation
	if (window["UCF_System"]["bIsAria"]) {
		var iRowOffset = this["oTable"]["bHasHeaderRow"]() ? 1 : 0;
		sRowInfo = (parseInt(sRowInfo) + iRowOffset)["toString"]();
	}

	// Enabled
	if (!this["oTable"]["bEnabled"])
		this["oAccessibilityHelper"]["setEnabled"](false);

	// Semantic Color (includes selected)
	this["setSemanticColors"]();

	// Tutor text
	if (this["oTable"]["bEnabled"] && sTutorInfo)
		this["oAccessibilityHelper"]["addTutor"](sTutorInfo);

	if (sRowAccDescription) { // RowAccDescription overwrites row and column announcement -> UR classic compatibility
		this["oAccessibilityHelper"]["setText"](sRowAccDescription);
	} else if (sRowInfo && sColumnInfo) {
		this["oAccessibilityHelper"]["setControlType"]("ST_C", [sRowInfo, sColumnInfo]);
	} else if (sRowInfo) {
		this["oAccessibilityHelper"]["setControlType"]("ST_SC", [sRowInfo]);
	} else if (sColumnInfo) {
		this["oAccessibilityHelper"]["setText"](sColumnInfo);
	}

	// Required
	if (this["oHeader"] && this["oHeader"]["bRequired"])
		this["oAccessibilityHelper"]["setRequired"](true);

	// Addidtional CellState
	this["setCellState"]();

	this["oAccessibilityHelper"] = null;
	this["oAccessInfo"] = null;

};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["setAccessibilityInfo"] = 0; };

/**
 * Fills the acc helper with all cell state infos
 *
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["setCellState"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["setCellState"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["setCellState"] = 0; };

/**
 * Sets the cell info and adapts the cell state according to the server settings
 *
 * @param {Object} oCellInfo
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["setCellInfo"] = function (oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["setCellInfo"]++; }; 
	this["oCellInfo"] = oCellInfo;

	if (oCellInfo) {
		if (oCellInfo["bSelectionClientModified"]) {
			// if the selection state was modified by client methods, adapt selection state
			var SELECTION_LAYER = this["oTable"]["SELECTION_LAYER"];

			if (oCellInfo["iSelectionState"] & (SELECTION_LAYER["COLUMN"] | SELECTION_LAYER["CELL"] | SELECTION_LAYER["ROW"])) {
				this["bIsSecondarySelected"] = true;
			} else {
				this["bIsSecondarySelected"] = false;
			}

			if (oCellInfo["iSelectionState"] & SELECTION_LAYER["ROW_PRIMARY"]) {
				this["bIsSelected"] = true;
			} else {
				this["bIsSelected"] = false;
			}
		}
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["setCellInfo"] = 0; };

/**
 * Caluclates an returns the cells selection state listed in the SELECTION_STATE enum
 *
 * @return {number}
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["mGetSelectionState"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["mGetSelectionState"]++; }; 
	if (this["bIsSelected"])
		return this["SELECTION_STATE"]["PRIMARY"];
	else if (this["bIsSecondarySelected"])
		return this["SELECTION_STATE"]["SECONDARY"];
	else
		return this["SELECTION_STATE"]["NOT_SELECTED"];
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["mGetSelectionState"] = 0; };

/**
 * Returns the string identifing the row (e.g. the row index)
 *
 * @return {string}
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["sGetRowInfo"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetRowInfo"]++; }; 
	var iRowIndex = this["oTable"]["iGetAppDefinedRowIndex"](this["oCellInfo"]);

	if (iRowIndex == -1 && !this["oTable"]["bConvertRowSelectionReferenceIndex"]) {
		iRowIndex = this["oTable"]["iGetContentRowIndex"](this["oCellInfo"]);
		if (this["oTable"]["bZeroBasedScrolling"]) iRowIndex++;
	}

	if (!isNaN(iRowIndex) && iRowIndex >= 0) return new String(iRowIndex);
	else return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetRowInfo"] = 0; };

/**
 * Returns the additional description of the row
 *
 * @return {string}
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["sGetRowAccDescription"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetRowAccDescription"]++; }; 
	var sAccDescription = this["oCellInfo"]["oDomRefRow"]["getAttribute"]("t");
	return sAccDescription ? sAccDescription : null;
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetRowAccDescription"] = 0; };

/**
 * Returns the string identifing the column (e.g. the header text)
 *
 * @return {string}
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["sGetColumnInfo"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetColumnInfo"]++; }; 
	var sColumnInfo = "";

	if (this["sHeaderCellIds"]) {
		var aHeaders = this["sHeaderCellIds"]["split"](" "),
			oCurrDomRef = null;

		for (var i = 0; i < aHeaders["length"]; i++) {
			oCurrDomRef = UCF_DomUtil["$"](aHeaders[i]);
			if (oCurrDomRef) {
				sColumnInfo += ((i == 0) ? "" : " ") + this["sGetHeaderInfo"](new (UCF_ClassLoader["oGetClass"]("UCF_SapTableHeaderCell"))(oCurrDomRef, this["oTable"]));
			}
		}
	} else if (this["oHeader"]) {
		sColumnInfo += this["sGetHeaderInfo"](this["oHeader"]);
	} else {
		var iColumnIndex = this["oTable"]["iGetAppDefinedColIndex"](this["oCellInfo"]);
		if (!isNaN(iColumnIndex) && iColumnIndex >= 0) sColumnInfo += iColumnIndex;
	}

	return sColumnInfo;
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetColumnInfo"] = 0; };

/**
 * Returns the string identifing a header cell (e.g. its header text)
 *
 * @param {UCF_SapTableHeaderCell} oHeader refrence of a acc header cell instance
 *
 * @return {string}
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["sGetHeaderInfo"] = function (oHeader) {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetHeaderInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oHeader instanceof UCF_SapTableHeaderCell, "oHeader instanceof UCF_SapTableHeaderCell", "SapTableBaseCell.js(313): sGetHeaderInfo"); };

	if (oHeader["sAccessibilityDescription"]) {
		return oHeader["sAccessibilityDescription"];
	} else {
		// caption embedded: set caption text
		var sCaptionId = this["oDomRef"]["getAttribute"]("captionId"),
			sText = null;

		if (sCaptionId) {
			var oCaption = this["oTable"]["oLS"]["oControlFactory"]["oGetControlById"](sCaptionId);
			sText = oCaption["sGetText"]();
		} else {
			var oDomRefHeader = oHeader["oDomRef"];
			var sHeaderCaptionId = oDomRefHeader["getAttribute"]("captionId");
			if (sHeaderCaptionId) {
				var oHeaderCaption = this["oTable"]["oLS"]["oControlFactory"]["oGetControlById"](sHeaderCaptionId);
				sText = oHeaderCaption["sGetText"]();
			}
			else {
				sText = UCF_DomUtil["sGetInnerText"](oDomRefHeader);
			}

			if (sText && oHeader["bRequired"] && sText["indexOf"]("*") === 0) {
				sText = sText["substr"](1); //remove the "*" from text
			}
		}
		return sText;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetHeaderInfo"] = 0; };

/**
 * Returns the string identifing the cells type
 *
 * @return {string}
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["sGetCellTypeInfo"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetCellTypeInfo"]++; }; 
	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetCellTypeInfo"] = 0; };

/**
 * Calculates and sets the semantic color to the acc helper
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["setSemanticColors"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["setSemanticColors"]++; }; 
	var mSelectionState = this["mGetSelectionState"](),
		oLegendDomRef = UCF_DomUtil["$"](this["oTable"]["sId"] + '-legend');

	if (oLegendDomRef) this["oAccessibilityHelper"]["setLegendJSDomRef"](oLegendDomRef);

	if (mSelectionState == this["SELECTION_STATE"]["PRIMARY"]
		|| mSelectionState == this["SELECTION_STATE"]["SECONDARY"]
		|| mSelectionState == this["SELECTION_STATE"]["COLUMN"]
	) {
		this["oAccessibilityHelper"]["addSemantic"](this["oAccessibilityHelper"]["E_SEMANTIC"]["Selected"]);
	}

	if (this["sCellDesign"])
		this["oAccessibilityHelper"]["addSemantic"](this["sCellDesign"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["setSemanticColors"] = 0; };

/**
 * Returns the tutor info of the cell
 *
 * @return {string}
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["sGetTutorInfo"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetTutorInfo"]++; }; 
	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sGetTutorInfo"] = 0; };

/**
 * Util function to remove unnecessary spaces
 *
 * @param {string} sText
 * @return {string}
 *
 * @private
 */
UCF_SapTableBaseCell["prototype"]["sSpaceCleanUp"] = function (sText) {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sSpaceCleanUp"]++; }; 
	if (sText) return sText["replace"](/\s+$/, "")["replace"](/^\s+/, "");
	else return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["sSpaceCleanUp"] = 0; };

/**
 * Returns the cells value as string for all cells containing a single controls that has a text or value set.
 *
 * @return {string}
 *
 * @public
 */
UCF_SapTableBaseCell["prototype"]["getDisplayValue"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["getDisplayValue"]++; }; 
	return UCF_DomUtil["sGetVisibleTextContent"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["getDisplayValue"] = 0; };

/**
 * Returns the cells value as string for all cells containing a single controls that has a text or value set.
 *
 * @return {string}
 *
 * @public
 */
UCF_SapTableBaseCell["prototype"]["getConditionValue"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["getConditionValue"]++; }; 
	if (this["getCustomData"]("CFValue")) {
		return this["getCustomData"]("CFValue");
	} else {
		return this["getDisplayValue"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["getConditionValue"] = 0; };

/**
 * Adds a custom style class to the cell
 * @param {string} sStyleClassName The style class name to add
 * @return {string}
 *
 * @public
 */
UCF_SapTableBaseCell["prototype"]["addCustomStyle"] = function (sStyleClassName) {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["addCustomStyle"]++; }; 
	sStyleClassName += "NotSel";
	if (this["oCellInfo"]["sCustomStyles"]["indexOf"](" " + sStyleClassName + " ") == -1) {
		this["oCellInfo"]["sCustomStyles"] += " " + sStyleClassName + " ";
	}
	this["oDomRef"]["className"] = UCF_StringUtil["sTrim"](this["oCellInfo"]["sCssClasses"] + this["oCellInfo"]["sCustomStyles"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["addCustomStyle"] = 0; };

/**
 * Removes a custom style class from the cell
 * @param {string} sStyleClassName The style class name to remove
 *
 * @public
 */
UCF_SapTableBaseCell["prototype"]["removeCustomStyle"] = function (sStyleClassName) {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["removeCustomStyle"]++; }; 
	sStyleClassName += "NotSel";
	if (this["oCellInfo"]["sCustomStyles"]["indexOf"](" " + sStyleClassName + " ") > -1) {
		this["oCellInfo"]["sCustomStyles"] = this["oCellInfo"]["sCustomStyles"]["replace"](" " + sStyleClassName + " ", " ");
	}
	this["oDomRef"]["className"] = UCF_StringUtil["sTrim"](this["oCellInfo"]["sCssClasses"] + this["oCellInfo"]["sCustomStyles"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["removeCustomStyle"] = 0; };

/**
 * Removes all custom style classes from the cell that where previously added using addCustomStyle
 *
 * @public
 */
UCF_SapTableBaseCell["prototype"]["removeAllCustomStyles"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["removeAllCustomStyles"]++; }; 
	this["oCellInfo"]["sCustomStyles"] = "";
	this["oDomRef"]["className"] = this["oCellInfo"]["sCssClasses"];
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["removeAllCustomStyles"] = 0; };

/**
 * Adds a conditional style class to the cell
 * @param {string} sStyleClassName The style class name to add
 * @return {string}
 *
 * @public
 */
UCF_SapTableBaseCell["prototype"]["addConditionalStyle"] = function (sStyleClassName) {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["addConditionalStyle"]++; }; 
	sStyleClassName += "NotSel";
	if (this["oCellInfo"]["sConditionalStyles"]["indexOf"](" " + sStyleClassName + " ") == -1) {
		this["oCellInfo"]["sConditionalStyles"] += " " + sStyleClassName + " ";
	}
	this["oDomRef"]["className"] = UCF_StringUtil["sTrim"](this["oCellInfo"]["sCssClasses"] + this["oCellInfo"]["sConditionalStyles"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["addConditionalStyle"] = 0; };

/**
 * Removes a conditional style class from the cell
 * @param {string} sStyleClassName The style class name to remove
 *
 * @public
 */
UCF_SapTableBaseCell["prototype"]["removeConditionalStyle"] = function (sStyleClassName) {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["removeConditionalStyle"]++; }; 
	sStyleClassName += "NotSel";
	if (this["oCellInfo"]["sConditionalStyles"]["indexOf"](" " + sStyleClassName + " ") > -1) {
		this["oCellInfo"]["sConditionalStyles"] = this["oCellInfo"]["sConditionalStyles"]["replace"](" " + sStyleClassName + " ", " ");
	}
	this["oDomRef"]["className"] = UCF_StringUtil["sTrim"](this["oCellInfo"]["sCssClasses"] + this["oCellInfo"]["sConditionalStyles"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["removeConditionalStyle"] = 0; };

/**
 * Removes all conditional style classes from the cell that where previously added using addConditionalStyle
 *
 * @public
 */
UCF_SapTableBaseCell["prototype"]["removeAllConditionalStyles"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["removeAllConditionalStyles"]++; }; 
	this["oCellInfo"]["sConditionalStyles"] = "";
	this["oDomRef"]["className"] = this["oCellInfo"]["sCssClasses"];
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["removeAllConditionalStyles"] = 0; };

/**
 * Returns an interface for this cell and includes the UCF_ControlInfo public methods.
 * @returns {UCF_Interface} The interface.
 * @private
 */
UCF_SapTableBaseCell["prototype"]["oGetInterface"] = function (aMethodNames) {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["oGetInterface"]++; }; 
	var aUseMethodNames = aMethodNames || this["aPublicMethods"] || [];
	aUseMethodNames = aUseMethodNames["concat"](UCF_ControlInfo["prototype"]["aPublicMethods"]);
	return new (UCF_ClassLoader["oGetClass"]("UCF_Interface"))(this, aUseMethodNames);
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["oGetInterface"] = 0; };

/**
 * Returns the content aggregation of the SapTable(CS)Cell
 * @returns {UCF_Control} The content aggregation
 * @public
 */
UCF_SapTableBaseCell["prototype"]["getContent"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["getContent"]++; }; 
	return this["getContentRecursive"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["getContent"] = 0; };

/**
 * Returns the content aggregation of the SapTable(CS)Cell recursive
 * @param {oDomRef} oDomRef The domRef of the SapTable(CS)Cell
 * @returns {UCF_Control} The content aggregation
 * @private
 */
UCF_SapTableBaseCell["prototype"]["getContentRecursive"] = function (oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["getContentRecursive"]++; }; 
	var oControl;

	if (!oDomRef) return null;

	var aChildren = oDomRef["childNodes"];

	if (!aChildren) return null;

	for (var i = 0; i < aChildren["length"]; i++) {
		var oTmp = aChildren["item"](i);
		if (oTmp["nodeType"] != 1 || !UCF_DomUtil["bIsVisible"](oTmp) || oTmp["bIsCollectorContainer"])
			continue;
		if (oTmp["getAttribute"]("ct")) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oTmp, true);
			if (oControl) {
				return oControl;
			}
		}
		oControl = this["getContentRecursive"](oTmp);
		if (oControl) {
			return oControl;
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableBaseCell["_"]["getContentRecursive"] = 0; };

UCF_SapTableBaseCell.prototype["aPublicMethods"] = ["getDisplayValue","getConditionValue","addCustomStyle","removeCustomStyle","removeAllCustomStyles","addConditionalStyle","removeConditionalStyle","removeAllConditionalStyles","getContent"].concat(UCF_SapTableBaseCell.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_SapTableCS"] = function() {/* global _assert, _trace, DEBUG, INFO, WARNING, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_SapTableCSDragDelegate */
/// <reference path="./delegates/SapTableCSDragDelegate.js"/>
/* global UCF_SapTableCSDragDropDelegate */
/// <reference path="./delegates/SapTableCSDragDropDelegate.js"/>
/* global UCF_SapTableCSDropDelegate */
/// <reference path="./delegates/SapTableCSDropDelegate.js"/>
/* global UCF_SapTable */
/// <reference path="./SapTable.js"/>

/**
 * @typedef {Object} UCF_SapTableCS_RowSelect
 * @property {string} Id
 * @property {number} RowIndex
 * @property {string} RowUserData
 * @property {string} CellUserData
 * @property {UCF_SapTable_EventMapAccessType} AccessType
 * @property {string} TriggerCellId
 */
/**
 * @typedef {Object} UCF_SapTableCS_ClientRowSelect
 * @property {string} Id
 * @property {number} RowIndex
 * @property {string} RowUserData
 * @property {string} CellUserData
 * @property {UCF_SapTable_EventMapAccessType} AccessType
 * @property {string} TriggerCellId
 */
/**
 * @typedef {Object} UCF_SapTableCS_ClientPrimaryRowChange
 * @property {string} Id
 */
/**
 * @typedef {Object} UCF_SapTableCS_Filter
 * @property {string} Id
 * @property {string} CellId
 */
/**
 * @typedef {Object} UCF_SapTableCS_CellSelect
 * @property {string} Id
 * @property {string} CellId
 * @property {UCF_SapTable_CellType} CellType
 * @property {number} RowIndex
 * @property {number} ColIndex
 * @property {string} RowUserData
 * @property {string} CellUserData
 * @property {UCF_SapTable_EventMapAccessType} AccessType
 */
/**
 * @typedef {Object} UCF_SapTableCS_BlockSelect
 * @property {string} Id
 * @property {string} BlockSelection
 */
/** @typedef {[[HTMLDivElement?, HTMLDivElement?, HTMLDivElement?], [HTMLDivElement?, HTMLDivElement?, HTMLDivElement?], [HTMLDivElement?, HTMLDivElement?, HTMLDivElement?], [HTMLDivElement?, HTMLDivElement?, HTMLDivElement?]]} UCF_SapTableCS_SegmentMatrix */

/**
 * A table variant which allows clienside horizontal scrolling
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SapTableCS(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["UCF_SapTableCS"]++; }; 
	if (arguments["length"] > 0) {

		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "SapTableCS.js(86): UCF_SapTableCS"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTableCS.js(87): UCF_SapTableCS"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SapTableCS.js(88): UCF_SapTableCS"); };

		this["iMatrixLeftFixedColumnCount"] = parseInt(oDomRef["getAttribute"]("mtxlcc"), 10);
		this["iMatrixNoneFixedColumnCount"] = parseInt(oDomRef["getAttribute"]("mtxncc"), 10);
		this["iMatrixRightFixedColumnCount"] = parseInt(oDomRef["getAttribute"]("mtxrcc"), 10);

		this["iMatrixHeaderRowCount"] = parseInt(oDomRef["getAttribute"]("mtxhrc"), 10);
		this["iMatrixTopFixedRowCount"] = parseInt(oDomRef["getAttribute"]("mtxtrc"), 10);
		this["iMatrixContentRowCount"] = parseInt(oDomRef["getAttribute"]("mtxcrc"), 10);
		this["iMatrixBottomFixedRowCount"] = parseInt(oDomRef["getAttribute"]("mtxbrc"), 10);

		this["iMatrixColumnCount"] = this["iMatrixLeftFixedColumnCount"] + this["iMatrixNoneFixedColumnCount"] + this["iMatrixRightFixedColumnCount"];
		this["iMatrixRowCount"] = this["iMatrixHeaderRowCount"] + this["iMatrixTopFixedRowCount"] + this["iMatrixContentRowCount"] + this["iMatrixBottomFixedRowCount"];

		this["iContentRowCount"] = parseInt(oDomRef["getAttribute"]("crc"), 10);
		this["iVisibleContentRowCount"] = parseInt(oDomRef["getAttribute"]("vcrc"), 10);
		this["iFirstVisibleContentRowIndex"] = parseInt(oDomRef["getAttribute"]("fvcri"), 10);
		this["iContentColumnCount"] = this["iMatrixColumnCount"];
		this["eVerticalScrollUpdateMode"] = oDomRef["getAttribute"]("vsclum");
		this["sHorizontalScrollUpdateMode"] = this["SCROLL_UPDATE_MODE"]["CLIENT"];
		this["sResizeMode"] = oDomRef["getAttribute"]("rzm");

		this["bHasFragments"] = oDomRef["getAttribute"]("bHasFrgs") ? true : false;

		UCF_SapTable["apply"](this, [oDomRef, oLS]);

		var sPrefix = this["sId"];

		/** @type {UCF_SapTableCS_SegmentMatrix} */
		this["aDomRefSegmentMatrix"] = [
			[UCF_DomUtil["$"](sPrefix + "-mrss-hdr-left"), UCF_DomUtil["$"](sPrefix + "-mrss-hdr-none"), UCF_DomUtil["$"](sPrefix + "-mrss-hdr-right")],
			[UCF_DomUtil["$"](sPrefix + "-mrss-tfx-left"), UCF_DomUtil["$"](sPrefix + "-mrss-tfx-none"), UCF_DomUtil["$"](sPrefix + "-mrss-tfx-right")],
			[UCF_DomUtil["$"](sPrefix + "-mrss-cont-left"), UCF_DomUtil["$"](sPrefix + "-mrss-cont-none"), UCF_DomUtil["$"](sPrefix + "-mrss-cont-right")],
			[UCF_DomUtil["$"](sPrefix + "-mrss-bfx-left"), UCF_DomUtil["$"](sPrefix + "-mrss-bfx-none"), UCF_DomUtil["$"](sPrefix + "-mrss-bfx-right")]
		];

		this["defineEvents"](['ClientColumnSelect']);

		//INIT AFTER SUPER APPLY DO NOT MOVE CODING BELOW TO ABOVE SECTION
		//This section overwrites settings made by super class

		this["bZeroBasedScrolling"] = true;
		this["iContentRowOffset"] = parseInt(this["oDomRef"]["getAttribute"]("cros"), 10);
		this["iRowHeight"] = parseInt(oDomRef["getAttribute"]("rh"), 10);

		//Mapping to SapTable parameters
		this["iRowCount"] = this["iContentRowCount"];
		this["iVisibleRowCount"] = this["iVisibleContentRowCount"];
		this["iVisibleFirstRow"] = this["iFirstVisibleContentRowIndex"];
		//ACC parameters
		this["iColCount"] = this["iContentColumnCount"] - (this["bHasLeadingSelectionColumn"]() ? 1 : 0);
		this["iVisibleColCount"] = this["iColCount"];

		this["bInitializeHorizontalScrollbar"] = false;

		if (this["oScrollV"]) {
			if (this["bCanClientScroll"](false))
				this["oScrollV"]["setNotifactionMode"](this["oScrollV"]["NOTIFICATION"]["ALWAYS_WHEN_CHANGED"]);
			else
				this["oScrollV"]["setNotifactionMode"](this["oScrollV"]["NOTIFICATION"]["AUTO"]);
		}

		if (this["oScrollH"] && this["bCanClientScroll"](true)) {
			//In optimized pixel mode of horizontal scrollbar, resize don't need to be handled in table but by scrollbar itself
			this["oScrollH"]["detachEvent"](this["oScrollH"]["E_EVENTS"]["ClientUpdateResize"], this, "onHScrollClientUpdateResize");
		}

		if (this["bCanDataRequest"]()) {
			this["initDataRequest"]();
		}

		if (this["sVerticalPagerId"]) this["bScrollByPage"] = true;

		//set draggable attribute at TR level
		this["setDraggableRowsCS"]();

		// register for internal client select events
		this["attachEvent"](this["E_EVENTS"]["ClientRowSelect"], this, 'onClientRowSelect');
		this["attachEvent"](this["E_EVENTS"]["ClientColumnSelect"], this, 'onClientColumnSelect');
	}
};window["UCF_SapTableCS"] = UCF_SapTableCS; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableCS"); UCF_SapTableCS["_"] = {UCF_SapTableCS: 0}; }; ;
UCF_SapTableCS["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTable"))(); UCF_SapTableCS.prototype["sClassName"] = "UCF_SapTableCS";

/******************************************************
 ** DESTRUCTOR
 *******************************************************/

/**
 * Destructor
 * @private
 */
UCF_SapTableCS["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["destroy"]++; }; 

	this["aDomRefSegmentMatrix"] = null;
	this["iVisibleContentRowCount"] = 0;
	this["iFirstVisibleContentRowIndex"] = 0;
	this["eVerticalScrollUpdateMode"] = null;
	this["iContentRowOffset"] = 0;

	this["cleanUpDataRequest"]();

	if (this["sResizeMode"] == "AUTO_VERTICAL") {
		this["cleanUpAutoVResize"]();
	}

	if (this["_markCellAsFocussedWhenUnlocked"]) {
		this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this);
		delete this["_markCellAsFocussedWhenUnlocked"];
	}

	this["cleanUpHighlightTexts"]();

	this["iMatrixLeftFixedColumnCount"] = 0;
	this["iMatrixNoneFixedColumnCount"] = 0;
	this["iMatrixRightFixedColumnCount"] = 0;
	this["iMatrixHeaderRowCount"] = 0;
	this["iMatrixTopFixedRowCount"] = 0;
	this["iMatrixContentRowCount"] = 0;
	this["iMatrixBottomFixedRowCount"] = 0;
	this["iMatrixColumnCount"] = 0;
	this["iMatrixRowCount"] = 0;
	this["iContentRowCount"] = 0;
	this["iContentColumnCount"] = 0;
	this["sHorizontalScrollUpdateMode"] = "";
	this["sResizeMode"] = "";
	this["bHasFragments"] = false;
	this["iRowHeight"] = 0;
	this["iRowCount"] = 0;
	this["iVisibleRowCount"] = 0;
	this["iVisibleFirstRow"] = 0;
	this["iColCount"] = 0;
	this["iVisibleColCount"] = 0;
	this["iDataCleanUpThreshold"] = 0;
	this["sRowRootDropTargetInfo"] = "";
	this["sRowRootDragSourceInfo"] = "";
	this["_markCellAsFocussedWhenUnlocked"] = null;
	this["iColumnSelectionReferenceIndex"] = 0;
	this["iColumnSelectionRangeEndIndex"] = 0;

	// de-register for client select events
	this["detachEvent"](this["E_EVENTS"]["ClientRowSelect"], this, 'onClientRowSelect');
	this["detachEvent"](this["E_EVENTS"]["ClientColumnSelect"], this, 'onClientColumnSelect');

	UCF_SapTable.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["destroy"] = 0; };

/******************************************************
 ** CONSTANTS
 *******************************************************/

/**
 * Subcontrol types
 */
UCF_SapTableCS["prototype"]["SUBCONTROL"] = {
	"NONE": false,
	"TABLE": "STCS",
	"HEADER_CELL": "HC",
	"STANDARD_CELL": "STC",
	"HIERARCHY_CELL": "HIC",
	"MATRIX_CELL": "MC",
	"SELECTION_CELL": "SC",
	"POPIN_CELL": "PC"
};

UCF_SapTableCS["prototype"]["SEGMENT_ROW"] = {
	"HEADER": 0,
	"TOP": 1,
	"CONTENT": 2,
	"BOTTOM": 3
};

UCF_SapTableCS["prototype"]["SEGMENT_COL"] = {
	"LEFT_FIXED": 0,
	"NONE_FIXED": 1,
	"RIGHT_FIXED": 2
};

UCF_SapTableCS["prototype"]["MATRIX_INITIALIZATION"] = {
	"NONE": 0,
	"WHEN_INIT": 1,
	"ON_DEMAND": 2
};

UCF_SapTableCS["prototype"]["CONTENT_DISPLAY_MODE"] = {
	"HIDDEN_ROWS": 0,
	"HIDDEN_CELLS": 1,
	"RENDER_ALL": 2,
	"HIDDEN_ROWS_ACCUMULATE": 3
};

/******************************************************
 ** EVENT HANDLER RAISED BY EVENT LISTENING
 *******************************************************/

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_SapTableCS["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTableCS.js(291): ondblclick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oBrowserEvent) == "object", "typeof(oBrowserEvent) == \"object\"", "SapTableCS.js(292): ondblclick"); };

	// Android fires dblclick when touching 2 separate DOM element quickly after each other
	// Maybe browser bug -> switch off dblclick handling for Android touch devices
	if (UCF_UserAgent["bIsAndroid"]()) return false;

	return this["handleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["ondblclick"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initialize"]++; }; 

	var bCheckDataRequest = this["bCanDataRequest"]() && this["oDomRef"]["getAttribute"]("bCheckDataRequest");

	if (this["sResizeMode"] == "AUTO_VERTICAL") {
		this["initAutoVResize"]();
		bCheckDataRequest = false; //Not necessary anymore
	}

	if (bCheckDataRequest) UCF_JsUtil["delayedCall"](0, this, "bCheckDataRequest");

	UCF_SapTable.prototype["initialize"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initialize"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["onScrollV"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onScrollV"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent != null, "oEvent != null", "SapTableCS.js(326): onScrollV"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "SapTableCS.js(327): onScrollV"); };

	this["setFirstVisibleContentRowIndex"](oEvent["oGetParam"]("iFirstVisibleItem") + (this["bZeroBasedScrolling"] ? -1 : 0));

	if (!(this["oScrollV"] && this["oScrollV"]["bIsInInteraction"]())) {

		//Reset to standard scroll event listening -> see bCheckDataRequest
		if (this["oScrollV"]["mGetNotifactionMode"]() == this["oScrollV"]["NOTIFICATION"]["ALWAYS"]) {
			this["oScrollV"]["setNotifactionMode"](this["oScrollV"]["NOTIFICATION"]["ALWAYS_WHEN_CHANGED"]);
		}

		if (this["bCanDataRequest"]()) {
			if (!this["bCheckDataRequest"](true, oEvent)) this["fireVerticalScrollInternal"](oEvent);
		} else {
			this["fireVerticalScrollInternal"](oEvent);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onScrollV"] = 0; };

/******************************************************
 ** DataRequest handling
 *
 *
 *******************************************************/

/**
 * The threshold which is used to detemine when the HTML content and matrix should be removed from
 * the client to avaiof perfromance issues
 * @private
 */
UCF_SapTableCS["prototype"]["DATA_REQUEST_CLEAN_UP_THRESHOLD"] = 1250;

/**
 * When the load on demand mechanism detects that rows have to loaded from the sever it makes sense
 * to at least a sepecific amount rows to  avoid to much overhead of the server request
 * E.g. DATA_REQUEST_MIN_ROWS_TO_REQUEST is set to 6 and the client detects that there is 1 row to it requests to get a complete set of rows
 * the client also loads the next 5 rows additionally to avoid a requests when the user is scolling one row down
 * @private
 */
UCF_SapTableCS["prototype"]["DATA_REQUEST_MIN_ROWS_TO_REQUEST"] = 6;

/**
 * Adds information to the current state of the fragments loaded on demand.
 * The statictic conatins e.g. the amount of currently loaded rows.
 * The statistic is e.g. used to trigger a clean up of HTML when too much cells are loaded which harms the execution of JS
 * and processing of HTML updates
 *
 * @param {HTMLElement} oFragment The DOM ref of the fragement to be analyzed
 * @private
 */
UCF_SapTableCS["prototype"]["addFragmentStatistic"] = function(oFragment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["addFragmentStatistic"]++; }; 
	if (oFragment["parentNode"]["parentNode"]["parentNode"] == this["oDataRequestInfo"]["oReferenceSegment"]) {
		if (!this["bIsSpacerFragment"](oFragment)) {
			var iSegmentOffset = this["iGetFragmentOffset"](oFragment),
				iSegmentLength = this["iGetFragmentLength"](oFragment),
				oSegmentDimension = {'SegmentOffset' : iSegmentOffset, 'SegmentLength' : iSegmentLength};

			this["oDataRequestInfo"]["iRowsLoaded"] += iSegmentLength;
			this["oDataRequestInfo"]["aRowsLoadedRanges"]["push"](oSegmentDimension);

			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Table \"" + this["sId"] + "\" is adding fragment statistic:  From " + iSegmentOffset + " To " + (iSegmentOffset + iSegmentLength - 1) + " [Length = " + iSegmentLength + "]. " + (this["oDataRequestInfo"]["iRowsLoaded"] * this["iContentColumnCount"]) + " of max. " + this["iGetDataCleanUpThreshold"]() + " cells loaded.", "SapTableCS.js(388): addFragmentStatistic"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["addFragmentStatistic"] = 0; };

/**
 * Initializes the fragment statistic
 * The statictic conatins e.g. the amount of currently loaded rows
 *
 * @see addFragmentStatistic
 * @private
 */
UCF_SapTableCS["prototype"]["initFragmentStatistic"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initFragmentStatistic"]++; }; 
	this["oDataRequestInfo"]["iRowsLoaded"] = 0;
	this["oDataRequestInfo"]["aRowsLoadedRanges"] = [];

	if (this["oDataRequestInfo"]["oReferenceSegment"]) {
		var oDomRefSegmentBody = this["oGetSegmentTable"](this["oDataRequestInfo"]["oReferenceSegment"])["tBodies"][0];

		while (oDomRefSegmentBody) {
			this["addFragmentStatistic"](oDomRefSegmentBody);

			//TODO: replace by UCF_DomUtil.nextSibling
			oDomRefSegmentBody = oDomRefSegmentBody["nextSibling"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initFragmentStatistic"] = 0; };

/**
 * Sets the threshold of accummulated cells which when exceeded the data is cleaned up.
 * This is an API which provides the psooibility to influence the cleanUp from external
 * If this is not set an auto algorithm is used determine the thereshold
 *
 * @param {number} iDataCleanUpThreshold Threshold of accummulated data cells to trigger a clean up
 *
 * @see iGetDataCleanUpThreshold
 * @public
 */
UCF_SapTableCS["prototype"]["setDataCleanUpThreshold"] = function(iDataCleanUpThreshold) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setDataCleanUpThreshold"]++; }; 
	this["iDataCleanUpThreshold"] = iDataCleanUpThreshold;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setDataCleanUpThreshold"] = 0; };

/**
 * Gets the current setting for the cleanup threshold
 *
 * @return {number} the threshold
 *
 * @see setDataCleanUpThreshold
 * @public
 */
UCF_SapTableCS["prototype"]["iGetDataCleanUpThreshold"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetDataCleanUpThreshold"]++; }; 
	if (this["iDataCleanUpThreshold"]) {
		// if specified from external return that directly
		return this["iDataCleanUpThreshold"];
	} else if (this["iGetCellsPerPage"]() * 3 > this["DATA_REQUEST_CLEAN_UP_THRESHOLD"]) {
		// For tables which exceed already the threshold by one buffered request (3 pages)
		// For huge tables it could happen that the almost every paging lead to a clean up. For those tbale we extend the threshold
		return this["iGetCellsPerPage"]() * 5; // At least 5 pages should be kept before cleanup
	} else {
		// Standard
		return this["DATA_REQUEST_CLEAN_UP_THRESHOLD"];
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetDataCleanUpThreshold"] = 0; };

/**
 * Deterimes if a HTML cleanup on client side makes sense.
 *
 * @return {boolean} true when a data clean up should happen
 * @private
 */
UCF_SapTableCS["prototype"]["bIsDataCleanUpNecessary"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bIsDataCleanUpNecessary"]++; }; 
	return this["oDataRequestInfo"]["bForceDataCleanup"] || this["oDataRequestInfo"]["iRowsLoaded"] * this["iContentColumnCount"] > this["iGetDataCleanUpThreshold"]();
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bIsDataCleanUpNecessary"] = 0; };

/**
 * Returns the amount of cells a page contains
 *
 * @return {number} The amount of cells a page contains
 * @private
 */
UCF_SapTableCS["prototype"]["iGetCellsPerPage"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetCellsPerPage"]++; }; 
	return this["iContentColumnCount"] * this["iVisibleContentRowCount"];
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetCellsPerPage"] = 0; };

/**
 * Processes a HTML and cell matrix clean up. It removes the HTML from the content segments and deletes all related data
 * @private
 */
UCF_SapTableCS["prototype"]["doDataCleanUp"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["doDataCleanUp"]++; }; 
	var oContentSegment = null,
		oContentSegments = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]],
		oSegmentTable = null;

	// Replace all content segemnts by empty spacer fragments
	for (var iContentSegment = 0; iContentSegment < oContentSegments["length"]; iContentSegment++) {
		oContentSegment = oContentSegments[iContentSegment];
		oSegmentTable = oContentSegment ? this["oGetSegmentTable"](oContentSegment) : null;

		if (oSegmentTable) {
			var oNewSpacerFragment = this["oCreateSpacerFragment"](oContentSegment);

			while (oSegmentTable["childNodes"][1]) {
				//The first child is the colgroup
				oSegmentTable["removeChild"](oSegmentTable["childNodes"][1]);
			}

			oSegmentTable["appendChild"](oNewSpacerFragment);

			this["setSpacerFragmentAttributes"](oNewSpacerFragment, 0, this["iContentRowCount"]);
		}
	}

	// Clean up cell matrix ... keep HeaderCells
	this["aCellInfoMatrix"]["splice"](this["iMatrixHeaderRowCount"], (this["iMatrixRowCount"] - this["iMatrixHeaderRowCount"]));

	this["oDataRequestInfo"]["bForceDataCleanup"] = false;

	// Clean up statistic
	this["initFragmentStatistic"]();

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Table \"" + this["sId"] + "\" processsed DataCleanUp after accumulating " + this["iGetDataCleanUpThreshold"]() + " cells", "SapTableCS.js(508): doDataCleanUp"); };
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["doDataCleanUp"] = 0; };

/**
 * Initializes the whole DataRequest feature for the table
 * @private
 */
UCF_SapTableCS["prototype"]["initDataRequest"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initDataRequest"]++; }; 
	if (this["bCanDataRequest"]()) {
		this["iDataCleanUpThreshold"] = 0;

		this["oDataRequestInfo"] = {
			"oReferenceSegment": this["oGetFirstSegmentInSegmentRow"](this["SEGMENT_ROW"]["CONTENT"]),
			"iRowsLoaded": 0,
			"bHasPendingRequest": false,
			"bForceDataCleanup": false,
			"aRowsLoadedRanges": []
		};

		this["initFragmentStatistic"]();
		//check whether there is a dragremain event, for pager this is not the case.
		if (this["oScrollV"] && this["oScrollV"]["E_EVENTS"] && ("DragRemain" in this["oScrollV"]["E_EVENTS"])) this["oScrollV"]["attachEvent"](this["oScrollV"]["E_EVENTS"]["DragRemain"], this, "onScrollVDragRemain");
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initDataRequest"] = 0; };

/**
 * Cleans up the DataRequest feature for the table
 * @private
 */
UCF_SapTableCS["prototype"]["cleanUpDataRequest"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["cleanUpDataRequest"]++; }; 
	if (this["oDataRequestInfo"]) UCF_JsUtil["resetMassNotificationFilter"](this["oDataRequestInfo"]);
	this["oDataRequestInfo"] = null;
	//check whether there is a dragremain event, for pager this is not the case.
	if (this["oScrollV"] && this["oScrollV"]["E_EVENTS"] && ("DragRemain" in this["oScrollV"]["E_EVENTS"])) this["oScrollV"]["detachEvent"](this["oScrollV"]["E_EVENTS"]["DragRemain"], this);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["cleanUpDataRequest"] = 0; };

/**
 * Checks if the table can provide the load on demand feature at all
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["bCanDataRequest"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bCanDataRequest"]++; }; 
	return this["bHasFragments"] && this["bCanClientScroll"](false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bCanDataRequest"] = 0; };

/**
 * Checks if rows have to be loaded from server
 *
 * @param {boolean}  (optional) bBuffered True if also data should be requested which are outside the view port to speed up dtata display when scrolling
 * @param {boolean}  (optional) oTriggerScrollEvent The event which triggred the request
 * @param {boolean}  (optional) bSynchonizeLock Only execute when app is not locked
 *
 * @return {boolean} true if it was necessary to request fragments
 * @private
 */
UCF_SapTableCS["prototype"]["bCheckDataRequest"] = function(bBuffered, oTriggerScrollEvent, bSynchonizeLock) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bCheckDataRequest"]++; }; 
	var iRowIndex;
	var bCellAlreadyLoaded;

	// If table can LoadOnDemand, no previous request is on its way and if bSynchonizeLock is set it check if the app is locked
	if (this["bCanDataRequest"]() && !this["oDataRequestInfo"]["bHasPendingRequest"] && !(bSynchonizeLock && this["oLS"]["bIsLocked"])) {
		var iStart = 0,
			iEnd = 0,
			aRequestFragments = [],
			bIsDataCleanUpNecessary = this["bIsDataCleanUpNecessary"]();

		// If the visible table content is quite huge do not request buffer pages
		// On very huge tables it makes no sense to load the buffer pages  because it takes too long to apply the HTML
		// In this case buffering is switched of keep the application responsive
		if (bBuffered && this["iGetCellsPerPage"]() > this["DATA_REQUEST_CLEAN_UP_THRESHOLD"] / 3) {
			bBuffered = false;
		}

		iStart = Math["max"](0, this["iFirstVisibleContentRowIndex"] - (bBuffered ? this["iVisibleContentRowCount"] : 0));
		iEnd = Math["min"](this["iContentRowCount"] - 1, this["iFirstVisibleContentRowIndex"] - 1 + (bBuffered ? 2 * this["iVisibleContentRowCount"] : this["iVisibleContentRowCount"]));

		if (bIsDataCleanUpNecessary) {
			// If a clean up is necessary request the complete set a rows even if the rows are already on the client
			// The response of this requests would trigger a cleanup of the data and apply the fragment
			aRequestFragments[aRequestFragments["length"]] = { "iStart": iStart, "iEnd": iEnd };
		} else {
			var iRequestedRows = 0,
				bFragmentStarted = false;

			// Scan the area for non-loaded rows and put the information in requestFragments
			for (iRowIndex = iStart; iRowIndex <= iEnd; iRowIndex++) {
				bCellAlreadyLoaded = this["bIsValidCellInfo"](this["oGetCellInfo"](iRowIndex + this["iGetContentRowOffset"](), 0));

				if (!bCellAlreadyLoaded) {
					if (!bFragmentStarted) {
						aRequestFragments[aRequestFragments["length"]] = { "iStart": iRowIndex, "iEnd": -1 };
						bFragmentStarted = true;
					}
				}

				if (!bCellAlreadyLoaded) iRequestedRows++;

				if (bFragmentStarted && (iRowIndex == iEnd || bCellAlreadyLoaded)) {
					aRequestFragments[aRequestFragments["length"] - 1]["iEnd"] = (bCellAlreadyLoaded ? iRowIndex - 1 : iRowIndex);
					bFragmentStarted = false;
				}
			}

			//If only a few rows are requested try to extend the last or first fragment so that it is worth to start a request to the server.
			if (aRequestFragments["length"] > 0 && iRequestedRows < this["DATA_REQUEST_MIN_ROWS_TO_REQUEST"]) {
				var bForward = true;
				iRowIndex = -1;

				if (aRequestFragments[aRequestFragments["length"] - 1]["iEnd"] == iEnd) {
					iStart = iEnd + 1;
					iEnd = iStart + (this["DATA_REQUEST_MIN_ROWS_TO_REQUEST"] - iRequestedRows) - 1;
					bForward = true;
					iRowIndex = iStart;
				} else if (aRequestFragments[0]["iStart"] == iStart) {
					iStart = iStart - 1;
					iEnd = iStart - (this["DATA_REQUEST_MIN_ROWS_TO_REQUEST"] - iRequestedRows) + 1;
					bForward = false;
					iRowIndex = iStart;
				}

				if (iRowIndex != -1) {
					while (bForward && iRowIndex <= iEnd || !bForward && iRowIndex >= iEnd) {
						bCellAlreadyLoaded = this["bIsValidCellInfo"](this["oGetCellInfo"](iRowIndex + this["iGetContentRowOffset"](), 0));

						if (bCellAlreadyLoaded) break;

						iRowIndex = iRowIndex + (bForward ? 1 : -1);
					}

					if (bForward) aRequestFragments[aRequestFragments["length"] - 1]["iEnd"] = iRowIndex - 1;
					else aRequestFragments[0]["iStart"] = iRowIndex + 1;
				}
			}
		}

		// if there a rows to request continue with the server request procedure
		if (aRequestFragments["length"] > 0) {
			var sFragmentString = "";

			// Serialize the fragment information to event parameter string
			for (var i = 0; i < aRequestFragments["length"]; i++) {
				sFragmentString += aRequestFragments[i]["iStart"] + "," + aRequestFragments[i]["iEnd"] + ";";
			}

			this["oDataRequestInfo"]["bHasPendingRequest"] = true;
			this["bScrollingByKeyboardLocked"] = true;

			{ //Event processing

				if (this["oScrollV"]) {
					var iEventType = oTriggerScrollEvent ? oTriggerScrollEvent["iGetId"]() : -1,
						bIsScrollbar = UCF_JsUtil["bInstanceOf"](this["oScrollV"], "UCF_Scrollbar"),
						bIsDragRemain = bIsScrollbar && iEventType == this["oScrollV"]["E_EVENTS"]["DragRemain"];

					if (bIsDragRemain) oTriggerScrollEvent = null; //Reset trigger event -> leads to an external event in fireVerticalScrollInternal

					// It is necessary to fire a scroll event before the data request is fired to inform the framework about the current
					// scroll state
					this["fireVerticalScrollInternal"](oTriggerScrollEvent);

					// When server has been notified about a new first visible while drag and move of scrollbar handle
					// the scrollbar has to notify its position anyway even when the handle is moved back to its original position
					if (bIsDragRemain && this["oScrollV"]["mGetNotifactionMode"]() == this["oScrollV"]["NOTIFICATION"]["ALWAYS_WHEN_CHANGED"]) {
						this["oScrollV"]["setNotifactionMode"](this["oScrollV"]["NOTIFICATION"]["ALWAYS"]);
					}
				}

				if (bIsDataCleanUpNecessary) this["fireDataCleanUp"](this["sId"]);

				this["fireRequestData"](this["sId"], sFragmentString, this["iFirstVisibleContentRowIndex"], this["iVisibleContentRowCount"]);
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Table \"" + this["sId"] + "\" is requesting fragments: " + sFragmentString, "SapTableCS.js(679): bCheckDataRequest"); };

			}

			return true;
		}
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bCheckDataRequest"] = 0; };

/**
 * Event handler
 * When the user drags the scrollbar and without releasing the mouse button he stay on a position the scrollbar fires a
 * "DragRemain" event. This is used in the tabel to load the current page from server without buffering
 *
 * @param {UCF_Event} oEvent the event object
 * @private
 */
UCF_SapTableCS["prototype"]["onScrollVDragRemain"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onScrollVDragRemain"]++; }; 
	this["bCheckDataRequest"](false, oEvent);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onScrollVDragRemain"] = 0; };

/**
 * Receives a string HTML fragment to update the control partially
 *
 * @param {string} sHTML string The HTML data as a string
 * @private
 */
UCF_SapTableCS["prototype"]["updateHTML"] = function(sHTML) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["updateHTML"]++; }; 
	//serialize/synchronize update

	if (this["bIsDataCleanUpNecessary"]()) {
		this["cleanUpHighlightTexts"]();
	}

	// 2016/02/09 The delayed update leads to an unsynchronized initializedID
	// I make it again un-delayed and check if IE is now able to handle the update
	// If it works the updateHTMLDelayed can be deleted after a year
	// If it does not work I have to think about how the initializedIDs can be processed by the control update cycle

	// Decouple the update from the server response
	// This is done to synchronize the several data updates. Otherwise IE freezes from time to time.
	//UCF_JsUtil.delayedCall(0, this, "updateHTMLDelayed", [sHTML]);
	this["updateHTMLDelayed"](sHTML);

};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["updateHTML"] = 0; };

/**
 * Receives delayed a string HTML fragment to update the control partially
 * This is done to synchronize the data updates. Otherwise IE freezes from time to time.
 *
 * @param {string} sHTML string The HTML data as a string
 * @private
 */
UCF_SapTableCS["prototype"]["updateHTMLDelayed"] = function(sHTML) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["updateHTMLDelayed"]++; }; 
	var oContainer = document["createElement"]("div"),
		oTranportTable = null,
		aBodyFragments = [],
		iFirstVisibleContentRowIndex = -1,
		iContentRowCount = -1,
		iVisibleContentRowCount = -1;

	UCF_DomUtil["setInnerHtml"](oContainer, sHTML);
	oTranportTable = UCF_DomUtil["oGetFirstElement"](oContainer);

	// Update scrolling relvenat attributes from the server
	iFirstVisibleContentRowIndex = parseInt(oTranportTable["getAttribute"]("iFirstVisibleContentRowIndex"), 10);
	iContentRowCount = parseInt(oTranportTable["getAttribute"]("iContentRowCount"), 10);
	iVisibleContentRowCount = parseInt(oTranportTable["getAttribute"]("iVisibleContentRowCount"), 10);

	// Do the cleanu up of HTML and all related data when HTML is getting to "heavy" to harm perfromance
	if (this["bIsDataCleanUpNecessary"]()) {
		this["doDataCleanUp"]();
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Table \"" + this["sId"] + "\" is receiving fragments.", "SapTableCS.js(755): updateHTMLDelayed"); };

	for (var j = 0; j < oTranportTable["tBodies"]["length"]; j++) aBodyFragments["push"](oTranportTable["tBodies"][j]);

	// Safety cleanup to avoid mem leaks in IE
	for (var k = 0; k < aBodyFragments["length"]; k++) UCF_DomUtil["removeFromDom"](aBodyFragments[k]);
	UCF_DomUtil["removeFromDom"](oTranportTable);

	// Apply the the received HTML fragments to the right segments in the table
	for (var i = 0; i < aBodyFragments["length"]; i++) {
		var oBodyFragment = aBodyFragments[i],
			oSegment = null,
			sHpm = oBodyFragment["getAttribute"]("hpm");

		if (sHpm == "left") oSegment = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]][this["SEGMENT_COL"]["LEFT_FIXED"]];
		else if (sHpm == "none") oSegment = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]][this["SEGMENT_COL"]["NONE_FIXED"]];
		else if (sHpm == "right") oSegment = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]][this["SEGMENT_COL"]["RIGHT_FIXED"]];

		this["updateSegmentContent"](oSegment, oBodyFragment);

		if (!oBodyFragment["parentNode"]) { // Update was not successful
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Update of fragment was not successful: HPM=\"" + sHpm + "\", offset=" + this["iGetFragmentOffset"](oBodyFragment) + ", length=" + this["iGetFragmentLength"](oBodyFragment) + "", "SapTableCS.js(776): updateHTMLDelayed"); };
		} else {
			this["addFragmentStatistic"](oBodyFragment);
		}
	}

	// Refresh focussed cell
	{
		var oFocussedCell = this["oGetFocussedCell"]();
		if (this["bIsValidCellInfo"](oFocussedCell) && this["bIsVerticalScrolledIntoView"](oFocussedCell)) {
			this["markCellAsFocussedWhenUnlocked"](oFocussedCell, null);
		}
	}

	// Reset locking
	if (this["oDataRequestInfo"]["bHasPendingRequest"]) {
		this["oDataRequestInfo"]["bHasPendingRequest"] = false;
		this["bScrollingByKeyboardLocked"] = false;
	}

	// Set content row count. Only addititive is possible right currently (see AppendRow feature -> rarely used feature)
	if (iContentRowCount > this["iContentRowCount"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Changing ContentRowCount from " + this["iContentRowCount"] + " to " + iContentRowCount, "SapTableCS.js(798): updateHTMLDelayed"); };
		this["setContentRowCount"](iContentRowCount);
	}

	// Set available view of content rows. When auto resize -> ignore
	if (this["sResizeMode"] != "AUTO_VERTICAL" && iVisibleContentRowCount != this["iVisibleContentRowCount"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Changing VisibleContentRowCount from " + this["iVisibleContentRowCount"] + " to " + iVisibleContentRowCount, "SapTableCS.js(804): updateHTMLDelayed"); };
		this["setVisibleContentRowCount"](iVisibleContentRowCount);
	}

	// Is server is not in sync with the current scroll state
	if (iFirstVisibleContentRowIndex != this["iFirstVisibleContentRowIndex"]) {

		//Update visibility of rows which are sent by the server and do not fit to the current scroll state
		this["updateVisibleContentRows"](
			iFirstVisibleContentRowIndex,
			iVisibleContentRowCount,
			this["iFirstVisibleContentRowIndex"],
			this["iVisibleContentRowCount"]
		);

		/* Note 2355580: In some cases ("nervous" clicking on the vertical table scrollbar), the row grouping breaks, because class
		 * "urST4RowFirstVisible" is not set for the first visible row. This happens because the "nervous clicking" results in several
		 * "RequestData" events which are submitted from the waiting queue. The corresponding partial updates reach the client and remove the
		 * class "urST4RowFirstVisible" from the first visible row, which has been set previously in "onScrollV". Hence, we set class "urST4RowFirstVisible"
		 * again for the first visible row */
		var iNewFirstVisibleContentRowIndex = this["iOptimizeFirstVisibleContentRowIndex"](this["iFirstVisibleContentRowIndex"]);
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Note 2355580: Update CSS class for first visible row with index " + iNewFirstVisibleContentRowIndex + ", because it has been removed by nervous clicking on scrollbar. ", "SapTableCS.js(825): updateHTMLDelayed"); };
		this["updateCssClassFirstVisible"](iNewFirstVisibleContentRowIndex, iFirstVisibleContentRowIndex);

		this["bCheckDataRequest"](true);
	} else {
		// updateVisibleContentRows calls applyHighlightTexts. If the update is not called we have to make sure that the
		// highlight texts are updated explicitly
		this["applyHighlightTexts"](this["iFirstVisibleContentRowIndex"], this["iVisibleContentRowCount"]);
	}

	//setDraggableRowsCS
	this["setDraggableRowsCS"]();

	//reapply block selection for added cells
	if (this["oBlockSelection"] && this["bBlockSelectionActive"]()) this["setBlockSelectionInternal"](this["oBlockSelection"], this["BLOCKSELECTION_MODE"]["INITIALIZE"], true, false);

};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["updateHTMLDelayed"] = 0; };

/**
 * Handles the unlock event of UCF_LS
 * @private
 * @param {oFocussedCell} oFocussedCell the cell to be focussed
 */
UCF_SapTableCS["prototype"]["markCellAsFocussedWhenUnlocked"] = function(oFocussedCell) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["markCellAsFocussedWhenUnlocked"]++; }; 
	if (this["oLS"]["bLocked"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'BrowserWindow is currently locked - waiting for unlock', "SapTableCS.js(850): _markCellAsFocussedWhenUnlocked"); };
		if (!this["_markCellAsFocussedWhenUnlocked"]) {
			this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "_markCellAsFocussedWhenUnlocked");

			this["_markCellAsFocussedWhenUnlocked"] = function(oEvent) {
				this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this);
				delete this["_markCellAsFocussedWhenUnlocked"];
				this["markCellAsFocussed"](oFocussedCell, null);
			};
		}
	} else
		this["markCellAsFocussed"](oFocussedCell, null);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["markCellAsFocussedWhenUnlocked"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["iGetMinVisibleContentRowCount"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetMinVisibleContentRowCount"]++; }; 
	return parseInt(this["oDomRef"]["getAttribute"]("mvcrc"), 10);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetMinVisibleContentRowCount"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["setContentRowCount"] = function(iContentRowCount) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setContentRowCount"]++; }; 
	var iRowIndex;
	var oCellInfo;
	var oDomRefCell;
	var iSegment;
	var oSegments;
	var oSegment;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iContentRowCount) == "number", "typeof(iContentRowCount) == \"number\"", "SapTableCS.js(886): setContentRowCount"); };

	if (iContentRowCount == this["iContentRowCount"]) return;

	// In the SapTableCS it is a bit more complicated to set the content row count afterwards
	// When the table can loadOnDemand the spacer fragments have to be adapted additionally

	//TODO: Currently only additive rowcount change to the end is possible (see AppendRow feature -> rarely used feature)
	if (iContentRowCount > this["iContentRowCount"] && this["bCanClientScroll"](false)) {
		var iDelta = iContentRowCount - this["iContentRowCount"];

		// DOM AND MATRIX UPDATE
		{
			var iStartCellShift = this["iMatrixRowCount"];

			// Extend Matrix with empty rows at the end
			if (!this["aCellInfoMatrix"]) this["aCellInfoMatrix"] = new Array(iContentRowCount);
			for (iRowIndex = this["iMatrixRowCount"]; iRowIndex < this["iMatrixRowCount"] + iDelta; iRowIndex++) {
				if (!this["aCellInfoMatrix"][iRowIndex]) this["aCellInfoMatrix"][iRowIndex] = new Array(this["iMatrixColumnCount"]);
			}

			// BottomFixedRows have to be shifted -> Cell HTML DOM update for cell matrix position and segment attributes
			if (this["iMatrixBottomFixedRowCount"] > 0) {
				iStartCellShift = this["iMatrixRowCount"] - this["iMatrixBottomFixedRowCount"];
			}

			// CELL SHIFT UPDATE
			for (iRowIndex = this["iMatrixRowCount"] - 1, oCellInfo = null, oDomRefCell = null; iRowIndex >= iStartCellShift; iRowIndex--) {
				for (var iColIndex = 0; iColIndex < this["iMatrixColumnCount"]; iColIndex++) {
					oCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex);
					//When has valid DOM and is the origin coordinate (for colspan and rowspan if supported)
					if (this["bIsValidCellInfo"](oCellInfo) && oCellInfo["iRowIndex"] == iRowIndex && oCellInfo["iColIndex"] == iColIndex) {
						oDomRefCell = oCellInfo["oDomRefCell"];

						if (this["bHasCellInfoByDomRef"](oDomRefCell)) {
							oCellInfo["iRowIndex"] += iDelta;
							oDomRefCell["lsMatrixRowIndex"] += oCellInfo["iRowIndex"];
							oDomRefCell["setAttribute"]("lsMatrixRowIndex", oCellInfo["iRowIndex"]);
						}
					}
				}

				this["aCellInfoMatrix"][iRowIndex + iDelta] = this["aCellInfoMatrix"][iRowIndex];
				this["aCellInfoMatrix"][iRowIndex] = null;
			}

			// SEGMENT (HTML) UPDATE
			{
				//Update row count of content segments
				for (iSegment = 0, oSegments = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]], oSegment = null; iSegment < oSegments["length"]; oSegment = oSegments[++iSegment]) {
					if (oSegment) oSegment["setAttribute"]("segrc", this["iGetSegmentRowCount"](oSegment) + iDelta);
				}

				//Update offset row index of bottom fixed segments
				if (this["iMatrixBottomFixedRowCount"] > 0) {
					for (iSegment = 0, oSegments = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["BOTTOM"]], oSegment = null; iSegment < oSegments["length"]; oSegment = oSegments[++iSegment]) {
						if (oSegment) oSegment["setAttribute"]("segori", this["iGetSegmentOffsetRowIndex"](oSegment) + iDelta);
					}
				}
			}

			//TODO Update GapGrid
			//  !!!!!!!!!!!!!!!!!!!!!!
			//  !!!!!!!!!!!!!!!!!!!!!!
			//  !!!!!!!!!!!!!!!!!!!!!!

		}
	}

	this["iContentRowCount"] = iContentRowCount;
	UCF_SapTable.prototype["setContentRowCount"]["call"](this, iContentRowCount);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setContentRowCount"] = 0; };

/**
 * Gets an HTML body refrence and appends it to active DOM of the table
 *
 * @param {HTMLElement} oSegment the HTML DOM ref of the table segment
 * @param {HTMLElement} oDomRefInsertBody the HTML DOM ref of the rows and cells to be applied to the UI
 * @private
 */
UCF_SapTableCS["prototype"]["updateSegmentContent"] = function(oSegment, oDomRefInsertBody) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["updateSegmentContent"]++; }; 
	var iInsertOffset = this["iGetFragmentOffset"](oDomRefInsertBody),
		iInsertLength = this["iGetFragmentLength"](oDomRefInsertBody),
		oDomRefSegmentBody = this["oGetSegmentTable"](oSegment)["tBodies"][0];

	// AppendRow feauter
	if (iInsertOffset == this["iContentRowCount"]) {
		//Append new row
		oDomRefSegmentBody["parentNode"]["appendChild"](oDomRefInsertBody);
		return;
	}

	// Loop through all row fragments of the segment
	while (oDomRefSegmentBody) {
		var iOldSegmentOffset = this["iGetFragmentOffset"](oDomRefSegmentBody),
			iOldSegmentLength = this["iGetFragmentLength"](oDomRefSegmentBody);

		// if affected spacer fragment (currently only spacer fragments can be affected by convention, already applied row cannot be overwritten)
		if (this["bIsSpacerFragment"](oDomRefSegmentBody) && (iInsertOffset < iOldSegmentOffset + iOldSegmentLength)) {
			var iNewSegmentOffset = iOldSegmentOffset,
				iNewSegmentLength = iOldSegmentLength;

			//Cut front
			if (iInsertOffset < iOldSegmentOffset) {
				if (iInsertOffset + iInsertLength - 1 < iOldSegmentOffset) {
					//No Spacer for that fragment available
					break;
				} else {
					var iOffsetDiffrence = iOldSegmentOffset - iInsertOffset;

					for (var j = 0; j < iOffsetDiffrence; j++) {
						oDomRefInsertBody["removeChild"](UCF_DomUtil["oGetFirstElement"](oDomRefInsertBody));
					}

					iInsertOffset = iOldSegmentOffset;
					iInsertLength = iInsertLength - iOffsetDiffrence;
				}
			}

			//Cut tail
			if (iInsertOffset + iInsertLength > iOldSegmentOffset + iOldSegmentLength) {
				var iLengthDiffrence = (iInsertOffset + iInsertLength) - (iOldSegmentOffset + iOldSegmentLength);

				for (var i = 0; i < iLengthDiffrence; i++) {
					UCF_DomUtil["removeFromDom"](oDomRefInsertBody["lastChild"]);
				}

				iInsertLength = iInsertLength - iLengthDiffrence;
			}

			if (iInsertOffset == iOldSegmentOffset && iInsertLength == iOldSegmentLength) {
				//Fits directly into space
				oDomRefSegmentBody["parentNode"]["insertBefore"](oDomRefInsertBody, oDomRefSegmentBody);
				oDomRefSegmentBody["parentNode"]["removeChild"](oDomRefSegmentBody);
			} else if (iInsertOffset == iOldSegmentOffset) {
				//Adjacent to start index
				iNewSegmentOffset = iInsertOffset + iInsertLength;
				iNewSegmentLength = iOldSegmentLength - iInsertLength;

				oDomRefSegmentBody["parentNode"]["insertBefore"](oDomRefInsertBody, oDomRefSegmentBody);
			} else if (iInsertOffset + iInsertLength == iOldSegmentOffset + iOldSegmentLength) {
				//Adjacent to tail
				iNewSegmentLength = iOldSegmentLength - iInsertLength;

				oDomRefSegmentBody["parentNode"]["insertBefore"](oDomRefInsertBody, oDomRefSegmentBody["nextSibling"]);
			} else {
				//Not adjacent

				//Create new spacer fragment and insert it before the insert-fragment
				var oDomRefNewSpacerFragment = this["oCreateSpacerFragment"](oSegment),
					iSpacerOffset = iOldSegmentOffset,
					iSpacerLength = iInsertOffset - iOldSegmentOffset,
					oSegmentTable = oDomRefSegmentBody["parentNode"];

				iNewSegmentOffset = iInsertOffset + iInsertLength;
				iNewSegmentLength = iOldSegmentLength - (iNewSegmentOffset - iOldSegmentOffset);

				oSegmentTable["insertBefore"](oDomRefInsertBody, oDomRefSegmentBody);

				oSegmentTable["insertBefore"](oDomRefNewSpacerFragment, oDomRefInsertBody);

				this["setSpacerFragmentAttributes"](oDomRefNewSpacerFragment, iSpacerOffset, iSpacerLength);
			}

			if (iNewSegmentOffset != iOldSegmentOffset || iNewSegmentLength != iOldSegmentLength)
				this["setSpacerFragmentAttributes"](oDomRefSegmentBody, iNewSegmentOffset, iNewSegmentLength);

			oDomRefInsertBody["setAttribute"]("iRowIndexOffset", iInsertOffset);
			oDomRefInsertBody["setAttribute"]("iRowsFragmentLength", iInsertLength);

			break;
		}

		//TODO: replace by UCF_DomUtil.nextSibling
		oDomRefSegmentBody = oDomRefSegmentBody["nextSibling"];
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["updateSegmentContent"] = 0; };

/**
 * Checks if the passed DOM ref is a spacer row fragment
 *
 * @return {boolean} true if the passed DOM ref is a spacer row fragment
 * @private
 */
UCF_SapTableCS["prototype"]["bIsSpacerFragment"] = function(oFragment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bIsSpacerFragment"]++; }; 
	return oFragment["getAttribute"]("bIsSpacerFragment") ? true : false;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bIsSpacerFragment"] = 0; };

/**
 * Returns the offset of a fragment. The offset is the starting row index of the
 * fragment
 *
 * @return {number} the offset
 *
 * @see iGetFragmentLength
 * @private
 */
UCF_SapTableCS["prototype"]["iGetFragmentOffset"] = function(oFragment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetFragmentOffset"]++; }; 
	return parseInt(oFragment["getAttribute"]("iRowIndexOffset"), 10);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetFragmentOffset"] = 0; };

/**
 * Returns the length of a fragment. The length is the range of rows cobvered by the fragment
 *
 * @return {number} the length
 *
 * @see iGetFragmentOffset
 * @private
 */
UCF_SapTableCS["prototype"]["iGetFragmentLength"] = function(oFragment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetFragmentLength"]++; }; 
	return parseInt(oFragment["getAttribute"]("iRowsFragmentLength"), 10);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetFragmentLength"] = 0; };

/**
 * Creates an empty HTML spacer fragment on client side and returns its DOM ref.
 *
 * @param {HTMLElement} oSegment The segment where the spacer fragment is later on apllied to. This is needed to determine the right colspan of the spacer fragment.
 *
 * @return {Object} The DOM ref of the space fragment
 * @private
 */
UCF_SapTableCS["prototype"]["oCreateSpacerFragment"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oCreateSpacerFragment"]++; }; 
	var oDomRefNewSpacerBody = document["createElement"]("tbody"),
		oDomRefNewSpacerRow = document["createElement"]("tr"),
		oDomRefNewSpacerCell = document["createElement"]("td");

	UCF_DomUtil["setClass"](oDomRefNewSpacerCell, "urST5Load lsBusyIndicator");
	oDomRefNewSpacerCell["setAttribute"]("colspan", this["iGetSegmentColCount"](oSegment));

	oDomRefNewSpacerCell["appendChild"](document["createTextNode"](" "));
	oDomRefNewSpacerRow["appendChild"](oDomRefNewSpacerCell);
	oDomRefNewSpacerBody["appendChild"](oDomRefNewSpacerRow);

	return oDomRefNewSpacerBody;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oCreateSpacerFragment"] = 0; };

/**
 * Applies all spacer fragment relevant attributes to the HTML of a spacer fragment
 *
 * @param {HTMLElement} oDomRefFragment The DOM ref of the spacer fragment
 * @param {number} iOffset The offset of the rows covered of the spacer fragment
 * @param {number} iLength The range size of the rows covered of the spacer fragment
 * @private
 */
UCF_SapTableCS["prototype"]["setSpacerFragmentAttributes"] = function(oDomRefFragment, iOffset, iLength) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setSpacerFragmentAttributes"]++; }; 

	oDomRefFragment["setAttribute"]("iRowIndexOffset", iOffset);
	oDomRefFragment["setAttribute"]("iRowsFragmentLength", iLength);
	oDomRefFragment["setAttribute"]("bIsSpacerFragment", "true");

	this["setSpacerFragmentVisibilityState"](oDomRefFragment, this["iFirstVisibleContentRowIndex"], this["iVisibleContentRowCount"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setSpacerFragmentAttributes"] = 0; };

/**
 * A spacer fragments consists of a HTML tableBody and one row in it. When a spacer fragemnt is visible on the clinet side by
 * scrolling into an unloaded empty area the spacer fragment has to fill out the view (visibleContentRowCount).
 * This has to be calculated according to the visible loaded rows before and after the spacer fragment.
 * This method checks if the spacer fragment is visible at all and if it is visible i calcualtes the needed height
 *
 * @param {HTMLElement} oDomRefFragment The DOM ref of the spacer fragment
 * @param {number} iVisibleRangeStart The start index of the visible row range
 * @param {number} iVisibleRangeSize The range size of the visible row range
 * @private
 */
UCF_SapTableCS["prototype"]["setSpacerFragmentVisibilityState"] = function(oDomRefFragment, iVisibleRangeStart, iVisibleRangeSize) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setSpacerFragmentVisibilityState"]++; }; 
	var oDomRefRow = oDomRefFragment["rows"][0],
		iOffset = this["iGetFragmentOffset"](oDomRefFragment),
		iLength = this["iGetFragmentLength"](oDomRefFragment),
		iExpansion = Math["min"](iOffset + iLength, iVisibleRangeStart + iVisibleRangeSize) - Math["max"](iOffset, iVisibleRangeStart);

	// iExpansion is the number of rows the spacer fragment has to fill out
	iExpansion = Math["max"](0, iExpansion);

	if (!("iExpansion" in oDomRefRow)) oDomRefRow["iExpansion"] = -1;
	oDomRefRow["bIsSpacerFragmentRow"] = true;

	// if the spacer fragment is already correctly set to the right height do nothing
	if (iExpansion != oDomRefRow["iExpansion"]) {
		if (iExpansion <= 0) { // the spacer fragment is not visible at all
			oDomRefRow["style"]["display"] = "none";
		} else {
			oDomRefRow["style"]["display"] = (UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]() || window["UCF_System"]["sDevice"] == "standards") ? "table-row" : "";
		}

		oDomRefRow["style"]["height"] = (this["iRowHeight"] * iExpansion) + "px";
		oDomRefRow["iExpansion"] = iExpansion;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setSpacerFragmentVisibilityState"] = 0; };

/******************************************************
 ** Overwritten SapTable methods
 *******************************************************/

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["iSearchAvailableDomRow"] = function(iStartSearchRowIndex, bDescending) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iSearchAvailableDomRow"]++; }; 

	if (this["bHasFragments"] && this["bIsContentRowIndex"](iStartSearchRowIndex)) {
		var oFirstContentSegment = this["oGetFirstSegmentInSegmentRow"](this["SEGMENT_ROW"]["CONTENT"]),
			iContentRowOffset = this["iGetContentRowOffset"](),
			oFragment = (oFirstContentSegment) ? this["oGetFragmentByContentRowIndex"](oFirstContentSegment, iStartSearchRowIndex - iContentRowOffset) : null;

		if (!oFragment) return -1;

		if (this["bIsSpacerFragment"](oFragment)) {
			return iContentRowOffset + this["iGetFragmentOffset"](oFragment) + (bDescending ? -1 : this["iGetFragmentLength"](oFragment));
		}
	}

	return UCF_SapTable.prototype["iSearchAvailableDomRow"]["call"](this, iStartSearchRowIndex, bDescending);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iSearchAvailableDomRow"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["bHasDomRow"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bHasDomRow"]++; }; 
	if (this["bHasFragments"]) {
		return this["bIsValidCellInfo"](this["oGetCellInfo"](iRowIndex, 0));
	}

	return UCF_SapTable.prototype["bHasDomRow"]["call"](this, iRowIndex);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bHasDomRow"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["oDomRefGetCellContentContainer"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oDomRefGetCellContentContainer"]++; }; 
	var oDomRefContentContainer = UCF_SapTable.prototype["oDomRefGetCellContentContainer"]["call"](this, oCellInfo);

	if (oDomRefContentContainer && (!UCF_UserAgent["bIsIE"]() || window["UCF_System"]["sDevice"] == "standards")) {
		//There is a DIV nested in the content
		oDomRefContentContainer = UCF_DomUtil["oGetFirstElement"](oDomRefContentContainer);
	}

	return oDomRefContentContainer;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oDomRefGetCellContentContainer"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["handleTableEvent"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["handleTableEvent"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableCS.js(1237): handleTableEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oAccessInfo) == "object", "typeof(oAccessInfo) == \"object\"", "SapTableCS.js(1238): handleTableEvent"); };

	UCF_SapTable.prototype["handleTableEvent"]["call"](this, oAccessInfo);

	if (oAccessInfo["eAction"] == this["ACTION"]["CONFIG"] && this["bIsSelectAccess"](oAccessInfo, UCF_JsUtil["MODIFIER"]["NONE"])) {
		this["fireConfig"](oAccessInfo["oTable"]["sId"]);
		oAccessInfo["bHandled"] = true;
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["handleTableEvent"] = 0; };

/**
 * Processes for the given access the double click. It returns true if the double click is actually processed
 *
 * @param {Object} oAccessInfo
 *
 * @return {boolean} true if the double click is actually processed
 * @private
 */
UCF_SapTableCS["prototype"]["bHandleCellDoubleClick"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bHandleCellDoubleClick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableCS.js(1258): bHandleCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oAccessInfo) == "object", "typeof(oAccessInfo) == \"object\"", "SapTableCS.js(1259): bHandleCellDoubleClick"); };
	if (oAccessInfo["oBrowserEvent"]["sGetName"]() == "dblclick") {
		this["fireCellDoubleClick"](oAccessInfo["oTable"]["sId"],
			oAccessInfo["sSubControlId"],
			this["sGetEventCellType"](oAccessInfo),
			this["iGetApiRowIndex"](oAccessInfo["oCellInfo"]),
			this["iGetApiColIndex"](oAccessInfo["oCellInfo"]),
			this["sGetRowUserData"](oAccessInfo["oCellInfo"]),
			this["sGetCellUserData"](oAccessInfo["oCellInfo"]),
			this["sGetEventSelectAccessType"](oAccessInfo)
		);
		return true;
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bHandleCellDoubleClick"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["internalFireSelectionCellSelect"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["internalFireSelectionCellSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableCS.js(1282): internalFireSelectionCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oAccessInfo) == "object", "typeof(oAccessInfo) == \"object\"", "SapTableCS.js(1283): internalFireSelectionCellSelect"); };

	if (this["bHandleCellDoubleClick"](oAccessInfo)) {
		oAccessInfo["bHandled"] = true;
	} else {
		UCF_SapTable.prototype["internalFireSelectionCellSelect"]["call"](this, oAccessInfo);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["internalFireSelectionCellSelect"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["internalFireCellSelect"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["internalFireCellSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableCS.js(1298): internalFireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oAccessInfo) == "object", "typeof(oAccessInfo) == \"object\"", "SapTableCS.js(1299): internalFireCellSelect"); };

	if (this["bHandleCellDoubleClick"](oAccessInfo)) {
		oAccessInfo["bHandled"] = true;
	} else {
		UCF_SapTable.prototype["internalFireCellSelect"]["call"](this, oAccessInfo);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["internalFireCellSelect"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["internalFireHeaderCellSelect"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["internalFireHeaderCellSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableCS.js(1314): internalFireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oAccessInfo) == "object", "typeof(oAccessInfo) == \"object\"", "SapTableCS.js(1315): internalFireHeaderCellSelect"); };

	if (this["bHandleCellDoubleClick"](oAccessInfo)) {
		oAccessInfo["bHandled"] = true;
	} else if (this["sColumnSelectionMode"] !== 'NONE') {
		this["internalFireColumnSelect"](oAccessInfo);
	} else {
		this["fireHeaderCellSelect"](oAccessInfo["oTable"]["sId"],
			oAccessInfo["sSubControlId"],
			this["iGetApiColIndex"](oAccessInfo["oCellInfo"]),
			this["sGetEventSelectAccessType"](oAccessInfo),
			this["sGetCellUserData"](oAccessInfo["oCellInfo"])
		);

		oAccessInfo["bHandled"] = this["bHasEventListeners"]("HeaderCellSelect");
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["internalFireHeaderCellSelect"] = 0; };



/**
 * sets the reference range end index for range selection to a column index
 *
 * @private
 * @param {int} iIndex
 */
UCF_SapTableCS["prototype"]["setColumnSelectionRangeEndIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setColumnSelectionRangeEndIndex"]++; }; 
	this["iColumnSelectionRangeEndIndex"] = iIndex;
	this["setClientProperty"]('ColumnSelectionRangeEndIndex', iIndex, true);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setColumnSelectionRangeEndIndex"] = 0; };

/**
 * resets the reference range end index for range selection
 *
 * @private
 */
UCF_SapTableCS["prototype"]["resetColumnSelectionRangeEndIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["resetColumnSelectionRangeEndIndex"]++; }; 
	this["setColumnSelectionRangeEndIndex"](this["APPDEFINED_ROW_DEFAULT_INDEX"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["resetColumnSelectionRangeEndIndex"] = 0; };

/**
 * sets the reference index for range selection to a column index
 *
 * @private
 * @param {int} iIndex
 */
UCF_SapTableCS["prototype"]["setColumnSelectionReferenceIndex"] = function(iIndex, bLeaveRangeEndIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setColumnSelectionReferenceIndex"]++; }; 
	this["iColumnSelectionReferenceIndex"] = iIndex;
	this["setClientProperty"]('ColumnSelectionReferenceIndex', iIndex, true);

	if (!bLeaveRangeEndIndex)
		this["resetColumnSelectionRangeEndIndex"]();
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setColumnSelectionReferenceIndex"] = 0; };

/**
 * resets the reference index for range selection
 *
 * @private
 */
UCF_SapTableCS["prototype"]["resetColumnSelectionReferenceIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["resetColumnSelectionReferenceIndex"]++; }; 
	this["setColumnSelectionReferenceIndex"](this["APPDEFINED_ROW_DEFAULT_INDEX"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["resetColumnSelectionReferenceIndex"] = 0; };

/**
 * @private
 * @param {Object} oAccessInfo
 * @param {string} sHeaderCellId
 */
UCF_SapTableCS["prototype"]["internalFireColumnSelect"] = function(oAccessInfo, sHeaderCellId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["internalFireColumnSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableCS.js(1384): internalFireColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oAccessInfo === 'object', "typeof oAccessInfo === 'object'", "SapTableCS.js(1385): internalFireColumnSelect"); };

	this["internalFireColumnSelectDirect"](
		oAccessInfo["oCellInfo"],
		oAccessInfo["eAccessType"],
		this["sGetEventSelectAccessType"](oAccessInfo),
		oAccessInfo["oTable"]
	);

	// TODO: adjust acc info on column?! This is taken from UCF_SapTable.prototype.internalFireRowSelect()
	// if (window.UCF_System.sAccessibility === 'ARIA1.1' && this.bIsValidCellInfo(oAccessInfo.oCellInfo)) {
	// 	if ((oAccessInfo.oCellInfo.iSelectionState & (
	// 			this.SELECTION_LAYER.COLUMN |
	// 			this.SELECTION_LAYER.CELL |
	// 			this.SELECTION_LAYER.ROW |
	// 			this.SELECTION_LAYER.ROW_PRIMARY
	// 		)) > 0) {
	// 		oAccessInfo.oCellInfo.oDomRefRow.setAttribute('aria-selected', 'true');
	// 	} else {
	// 		oAccessInfo.oCellInfo.oDomRefRow.setAttributed('aria-selected', 'false');
	// 	}
	// }

	oAccessInfo["bHandled"] = this["bHasEventListeners"]('ColumnSelect') || this["bHasEventListeners"]('ClientColumnSelect');
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["internalFireColumnSelect"] = 0; };

/**
 * handles a request to select a column; triggers the corresponding
 * mass selection processses and a potentinal event
 *
 * cf. UCF_SapTable.prototype.internalFireRowSelectDirect
 *
 * @private
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {UCF_SapTable_EventMapAccessType} eAccessType
 * @param {UCF_SapTable_EventMapAccessType} sSelectAccess
 * @param {UCF_SapTable} oTable
 */
UCF_SapTableCS["prototype"]["internalFireColumnSelectDirect"] = function(oCellInfo, eAccessType, sSelectAccess, oTable) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["internalFireColumnSelectDirect"]++; }; 
	var iColIndex      = -123456789;
	var iCurIndex      = 0;
	var iFirstIndex    = this["bHasLeadingSelectionColumn"]() ? 1 : 0;
	var iLastIndex     = this["iGetCellInfoMatrixLastColIndex"]();
	var iMaxRangeIndex = 0;
	var iMinRangeIndex = 0;
	var iRefIndex      = Math["max"](this["iColumnSelectionReferenceIndex"], iFirstIndex);
	var iRangeEndIndex = this["iColumnSelectionRangeEndIndex"] >= 0 ? this["iColumnSelectionRangeEndIndex"] : iRefIndex;
	var bIsColSelected = false;

	// TODO: what about colSpan != 1?
	if (this["sColumnSelectionMode"] === 'NONE' || oCellInfo["iColSpan"] !== 1)
		return;

	// TODO: note that this method does not seem to be called for non-selectable columns
	// if (this.eGetColSelectionState(oAccessInfo.oCellInfo.iColIndex & this.SELECTION_LAYER.COLUMN_DISABLED))
	// 	return;

	if (this["sColumnSelectionMode"] !== 'SERVER' && this["sColumnSelectionClientBehaviour"] === 'SMART') {
		iColIndex = oCellInfo ? oCellInfo["iColIndex"] : iColIndex;

		// cleanup access type for single selection
		if (this["sColumnSelectionMode"] === 'SINGLE' && sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"])
			sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];

		// access type correction for deselect and select all
		if (eAccessType === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"] || eAccessType === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]) {
			sSelectAccess = eAccessType;
		}

		switch (sSelectAccess) {
		case this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]:
			if (this["eGetColSelectionState"](iColIndex) & this["SELECTION_LAYER"]["COLUMN_DISABLED"])
				return;

			for (iCurIndex = iFirstIndex; iCurIndex <= iLastIndex; ++iCurIndex)
				this["setColumnSelectionByIndex"](iCurIndex, iCurIndex === iColIndex);

			this["setColumnSelectionReferenceIndex"](iColIndex);
			if (this["bBlockSelectionActive"]())
				this["internalFireColumnBlockSelect"](iColIndex, 1, true, sSelectAccess);

			break;
		case this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"]:
			if (this["eGetColSelectionState"](iColIndex) & this["SELECTION_LAYER"]["COLUMN_DISABLED"])
				return;

			if (this["bBlockSelectionActive"]()) {
				iFirstIndex = Math["min"](iRefIndex, iRangeEndIndex, iColIndex);
				iLastIndex  = Math["max"](iRefIndex, iRangeEndIndex, iColIndex);

				this["setColumnSelectionRangeEndIndex"](iColIndex);
			}

			iMinRangeIndex = Math["min"](iColIndex, iRefIndex);
			iMaxRangeIndex = Math["max"](iColIndex, iRefIndex);
			for (iCurIndex = iFirstIndex; iCurIndex <= iLastIndex; ++iCurIndex)
				this["setColumnSelectionByIndex"](iCurIndex, iMinRangeIndex <= iCurIndex && iCurIndex <= iMaxRangeIndex);

			if (this["bBlockSelectionActive"]())
				this["internalFireColumnBlockSelect"](iMinRangeIndex, (iMaxRangeIndex - iMinRangeIndex + 1), true, this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]);

			break;
		case this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]:
			if (this["eGetColSelectionState"](iColIndex) & this["SELECTION_LAYER"]["COLUMN_DISABLED"])
				return;

			bIsColSelected = !!(this["eGetColSelectionState"](iColIndex) & this["SELECTION_LAYER"]["COLUMN"]);
			if (this["sColumnSelectionMode"] === 'MULTI' || bIsColSelected)
				this["setColumnSelectionByIndex"](iColIndex, !bIsColSelected);
			else
				for (iCurIndex = iFirstIndex; iCurIndex <= iLastIndex; ++iCurIndex)
					this["setColumnSelectionByIndex"](iCurIndex, iCurIndex === iColIndex);

			if (this["sColumnSelectionMode"] === 'MULTI')
				// TODO: this is as for "RowSelectionReferenceIndex" in "SMART" - reset to default if column has been de-selected?
				this["setColumnSelectionReferenceIndex"](iColIndex);

			if (this["bBlockSelectionActive"]())
				this["internalFireColumnBlockSelect"](iColIndex, 1, !bIsColSelected, sSelectAccess);

			break;
		case this["EVENT_PARAM_MAP_ACCESS_TYPE"]["SELECT_ALL"]:
			for (iCurIndex = iFirstIndex; iCurIndex <= iLastIndex; ++iCurIndex)
				this["setColumnSelectionByIndex"](iCurIndex, true);

			this["resetColumnSelectionReferenceIndex"]();
			if (this["bBlockSelectionActive"]() && this["sSelectionMassAction"] === 'COLUMN') {
				// only for this.sSelectionMassAction === 'COLUMN' because in case of this.sSelectionMassAction === 'BOTH' it's already done via ROW logic
				this["internalFireColumnBlockSelect"](iFirstIndex, (iLastIndex - iFirstIndex + 1), true, this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]);
			}
			break;
		case this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]:
			for (iCurIndex = iFirstIndex; iCurIndex <= iLastIndex; ++iCurIndex)
				this["setColumnSelectionByIndex"](iCurIndex, false);

			this["resetColumnSelectionReferenceIndex"]();
			if (this["bBlockSelectionActive"]() && this["sSelectionMassAction"] === 'COLUMN') {
				// only for this.sSelectionMassAction === 'COLUMN' because in case of this.sSelectionMassAction === 'BOTH' it's already done via ROW logic
				this["internalFireBlockSelect"]({"oTable": this, "eAccessType": this["EVENT_PARAM_MAP_ACCESS_TYPE"]["DESELECT_ALL"]});
			}
			break;
		}
		this["doFireClientColumnSelect"](
			oTable["sId"],
			this["iGetApiColIndex"](oCellInfo),
			this["sGetCellUserData"](oCellInfo),
			sSelectAccess,
			this["sGetCellId"](oCellInfo)
		);
	} else {
		this["fireColumnSelect"](
			oTable["sId"],
			this["iGetApiColIndex"](oCellInfo),
			this["sGetCellUserData"](oCellInfo),
			sSelectAccess,
			this["sGetCellId"](oCellInfo)
		);
	}
	this["updateColumnSelectionInfo"]();
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["internalFireColumnSelectDirect"] = 0; };

/**
 * dispatch internal and semantic event
 *
 * @private
 */
UCF_SapTableCS["prototype"]["doFireClientColumnSelect"] = function(sId, iColIndex, sCellUserData, sAccessType, sTriggerCellId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["doFireClientColumnSelect"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["ClientColumnSelect"], {
		"Id": sId,
		"ColIndex": iColIndex,
		"CellUserData": sCellUserData,
		"AccessType": sAccessType,
		"TriggerCellId": sTriggerCellId
	});

	this["fireClientColumnSelect"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["doFireClientColumnSelect"] = 0; };

/**
 * adjust column (and cell) selection if necessary
 * @private
 */
UCF_SapTableCS["prototype"]["onClientRowSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onClientRowSelect"]++; }; 
	var iCurColIndex   = 0;
	var iFirstColIndex = this["bHasLeadingSelectionColumn"]() ? 1 : 0;
	var iLastColIndex  = this["iGetCellInfoMatrixLastColIndex"]();

	// ignore if access type not STANDARD
	if (oEvent["mParameters"]["AccessType"] !== this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"])
		return;

	// de-select columns if client column selection turned on
	if ((this["sColumnSelectionMode"] === 'SINGLE' || this["sColumnSelectionMode"] === 'MULTI') && this["sColumnSelectionClientBehaviour"] === 'SMART')
		for (iCurColIndex = iFirstColIndex; iCurColIndex <= iLastColIndex; ++iCurColIndex)
			this["setColumnSelectionByIndex"](iCurColIndex, false);

	// for later: same for client side cell selection
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onClientRowSelect"] = 0; };

/**
 * adjust row (and cell) selection if necessary
 * @private
 */
UCF_SapTableCS["prototype"]["onClientColumnSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onClientColumnSelect"]++; }; 
	// ignore if access type not STANDARD
	if (oEvent["mParameters"]["AccessType"] !== this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"])
		return;

	// de-select rows if client row selection turned on
	if ((this["sRowSelectionMode"] === 'SINGLE' || this["sRowSelectionMode"] === 'MULTI') &&
	    (this["sRowSelectionClientBehaviour"] === 'SMART' || this["sRowSelectionClientBehaviour"] === 'WEB' || this["sRowSelectionClientBehaviour"] === 'WEB_SMART'))
		this["clearRowSelection"]();

	// for later: same for client side cell selection
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onClientColumnSelect"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["bCanFireContextMenuEvent"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bCanFireContextMenuEvent"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableCS.js(1607): bCanFireContextMenuEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oAccessInfo) == "object", "typeof(oAccessInfo) == \"object\"", "SapTableCS.js(1608): bCanFireContextMenuEvent"); };
	var eCellType = this["eGetCellType"](oAccessInfo["oCellInfo"]);

	return eCellType == this["SUBCONTROL"]["SELECTION_CELL"]
		|| ((this["bIsDataTableCell"](eCellType) || eCellType == this["SUBCONTROL"]["HEADER_CELL"])
			&& !oAccessInfo["sContentControlType"] //no cell content control is involved
		);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bCanFireContextMenuEvent"] = 0; };

/******************************************************
 * CellMatrix handling
 *
 * The SapTableCS has been implemented especially to provide the client scroll feature.
 * So a server can send hundreds of rows to the client while only a few are displayed.
 * When reading the SapTable document you find out that there is a CellMatrix structure
 * which has to be initialized while SapTable initialization time.
 * If we would do that also for the SapTableCS the initialization of the control would take
 * too long for those 1000s of cells. So we established a mechanism which can initialize
 * each cell on demand before it is accessed. So when a SapTableCS has been initialized there is
 * a CellMatrix with empty CellInfos which is filled step by step with the right cell data.
 *
 *******************************************************/

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["initCellInfoMatrix"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initCellInfoMatrix"]++; }; 
	// Only initialze the head data. The cells itself are initilaized on demand. This is possible because the
	// cells in the SapTableCS cannot be row spanned
	this["initCellInfoMatrixHeadData"]();
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initCellInfoMatrix"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["bIsValidCellInfoMatrixPosition"] = function(iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bIsValidCellInfoMatrixPosition"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!isNaN(iRowIndex), "!isNaN(iRowIndex)", "SapTableCS.js(1648): bIsValidCellInfoMatrixPosition"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!isNaN(iColIndex), "!isNaN(iColIndex)", "SapTableCS.js(1649): bIsValidCellInfoMatrixPosition"); };

	return iRowIndex >= 0 && iColIndex >= 0
		&& iRowIndex <= this["iGetCellInfoMatrixLastRowIndex"]()
		&& iColIndex <= this["iGetCellInfoMatrixLastColIndex"]();
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bIsValidCellInfoMatrixPosition"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["iGetCellInfoMatrixLastRowIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetCellInfoMatrixLastRowIndex"]++; }; 
	return this["iMatrixRowCount"] - 1;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetCellInfoMatrixLastRowIndex"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["iGetCellInfoMatrixLastColIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetCellInfoMatrixLastColIndex"]++; }; 
	return this["iMatrixColumnCount"] - 1;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetCellInfoMatrixLastColIndex"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["prepareCellMatrixAccess"] = function(iRowIndex, iColIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["prepareCellMatrixAccess"]++; }; 
	// The SapTableCS establishes the cell matrix cell by cell on demand.
	// This method is called before a cell is accessed to prepare cell relevant data.
	// The SapTableCS uses this method to update the cell matrix with the new cell info
	// of the accessed cell

	var oCellInfo = null;

	if (typeof(iRowIndex) == "string") {
		iRowIndex = parseInt(iRowIndex, 10);
		iColIndex = parseInt(iColIndex, 10);
	}

	if (!this["aCellInfoMatrix"]) this["aCellInfoMatrix"] = new Array(this["iMatrixRowCount"]);
	if (!this["aCellInfoMatrix"][iRowIndex]) this["aCellInfoMatrix"][iRowIndex] = new Array(this["iMatrixColumnCount"]);

	oCellInfo = this["aCellInfoMatrix"][iRowIndex][iColIndex];

	// If already valid -> do nothing
	if (this["bIsValidCellInfo"](oCellInfo)) return;

	{ // Start
		//Find right cell DOM ref
		var oDomRefCell = null,
			oRowSegment = null,
			oSegment = null,
			iSegmentRowIndex = iRowIndex,
			iSegmentColIndex = iColIndex,
			oSegmentRow = null;

		if (iSegmentRowIndex < this["iMatrixHeaderRowCount"]) {
			oRowSegment = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["HEADER"]];
		} else {
			iSegmentRowIndex -= this["iMatrixHeaderRowCount"];
			if (iSegmentRowIndex < this["iMatrixTopFixedRowCount"]) {
				oRowSegment = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["TOP"]];
			} else {
				iSegmentRowIndex -= this["iMatrixTopFixedRowCount"];
				if (iSegmentRowIndex < this["iMatrixContentRowCount"]) {
					oRowSegment = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]];
				} else {
					iSegmentRowIndex -= this["iMatrixContentRowCount"];
					oRowSegment = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["BOTTOM"]];
				}
			}
		}

		if (iSegmentColIndex < this["iMatrixLeftFixedColumnCount"]) {
			oSegment = oRowSegment[this["SEGMENT_COL"]["LEFT_FIXED"]];
		} else {
			iSegmentColIndex -= this["iMatrixLeftFixedColumnCount"];
			if (iSegmentColIndex < this["iMatrixNoneFixedColumnCount"]) {
				oSegment = oRowSegment[this["SEGMENT_COL"]["NONE_FIXED"]];
			} else {
				iSegmentColIndex -= this["iMatrixNoneFixedColumnCount"];
				oSegment = oRowSegment[this["SEGMENT_COL"]["RIGHT_FIXED"]];
			}
		}

		oSegmentRow = this["oGetSegmentRow"](oSegment, iSegmentRowIndex);

		if (oSegmentRow["bIsSpacerFragmentRow"]) {
			// If cell is in an segment which is not loaded yet, create an empty cell info which is then later on updated by the cell DOM ref
			oCellInfo = this["oCreateCellInfo"](null);
			oCellInfo["iRowIndex"] = iRowIndex;
			oCellInfo["iColIndex"] = iColIndex;
			this["aCellInfoMatrix"][iRowIndex][iColIndex] = oCellInfo;

		} else {

			// Search for correct cell DomRef according to their colspans
			for (var i = iSegmentColIndex; i >= 0; i--) {
				oDomRefCell = oSegmentRow["cells"][i];

				if (oDomRefCell) this["synchronizeCellRenderRepresentation"](oDomRefCell);
				else continue;

				// Found right DomRef
				if (oDomRefCell["lsMatrixColIndex"] == iColIndex) break;
			}

			// Create a valid cell info
			oCellInfo = this["oCreateCellInfo"](oDomRefCell, oCellInfo);
			oCellInfo["iRowIndex"] = iRowIndex;
			oCellInfo["iColIndex"] = iColIndex;

			// distribute the cell info over the matrix according to its colspan (row span is not possible in the SapTabeCS)
			for (var iMatrixColIndex = oCellInfo["iColIndex"]; iMatrixColIndex < oCellInfo["iColIndex"] + oCellInfo["iColSpan"]; iMatrixColIndex++) {
				this["aCellInfoMatrix"][iRowIndex][iMatrixColIndex] = oCellInfo;
			}

			// DatatTip for HeaderCells (e.g. explanation)
			if (this["eGetCellType"](oCellInfo) == this["SUBCONTROL"]["HEADER_CELL"]) {
				this["checkAndPrepareDataTip"](oCellInfo);
			}

		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["prepareCellMatrixAccess"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["initScrollbars"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initScrollbars"]++; }; 
	var sScrollVId = this["sVerticalPagerId"] ? this["sVerticalPagerId"] : this["oDomRef"]["getAttribute"]("vsbid"),
		sScrollHId = this["oDomRef"]["getAttribute"]("hsbid");

	if (sScrollVId) this["oScrollV"] = this["oGetControlById"](sScrollVId);
	if (sScrollHId) this["oScrollH"] = this["oGetControlById"](sScrollHId);

	if (this["oScrollV"]) {
		this["oScrollV"]["attachEvent"](this["oScrollV"]["E_EVENTS"]["Scroll"], this, "onScrollV");
	}

	if (this["oScrollH"]) {
		this["oScrollH"]["attachEvent"](this["oScrollH"]["E_EVENTS"]["Scroll"], this, "onScrollH");
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initScrollbars"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["bCanClientScroll"] = function(bHorizontal) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bCanClientScroll"]++; }; 
	return (bHorizontal && this["oScrollH"]) || (!bHorizontal && this["eVerticalScrollUpdateMode"] != this["SCROLL_UPDATE_MODE"]["SERVER"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bCanClientScroll"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["processCellIsFocussed"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["processCellIsFocussed"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTableCS.js(1815): processCellIsFocussed"); };
	if (!this["bIsVerticalScrolledIntoView"](oCellInfo)) this["scrollVerticalIntoView"](oCellInfo);
	UCF_SapTable.prototype["processCellIsFocussed"]["call"](this, oCellInfo);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["processCellIsFocussed"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["iGetAppDefinedColIndex"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetAppDefinedColIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTableCS.js(1826): iGetAppDefinedColIndex"); };

	var oHtmlCol = this["oGetHtmlCol"](oCellInfo);
	return oHtmlCol["getAttribute"]("iIdx") ? parseInt(oHtmlCol["getAttribute"]("iIdx"), 10) : -1;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetAppDefinedColIndex"] = 0; };

/**
 * Returns the DOM reference to the HTML COL tag belonging to the given cell's column
 *
 * @param {Object} oCellInfo
 *
 * @return {HTMLElement} DOM refrence
 * @private
 */
UCF_SapTableCS["prototype"]["oGetHtmlCol"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetHtmlCol"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTableCS.js(1841): oGetHtmlCol"); };
	var oSegment = this["oGetSegmentByCellInfo"](oCellInfo),
		iSegmentColIndex = oCellInfo["iColIndex"] - this["iGetSegmentOffsetColIndex"](oSegment),
		oSegmentTable = this["oGetSegmentTable"](oSegment),
		aCols = this["aGetColsOfHtmlTable"](oSegmentTable);

	return aCols[iSegmentColIndex];
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetHtmlCol"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["initSkippingStructure"] = function(bHorizontal) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initSkippingStructure"]++; }; 
	if (bHorizontal) {
		UCF_SapTable.prototype["initSkippingStructure"]["call"](this, bHorizontal);
	} else {

		if (this["mSkippingStructureVertical"]) return; //Already initialized

		var aAreaPositions = [];

		for (var iRowSegmentIndex = 0; iRowSegmentIndex < this["aDomRefSegmentMatrix"]["length"]; iRowSegmentIndex++) {
			var oSegment = this["oGetFirstSegmentInSegmentRow"](iRowSegmentIndex);
			if (oSegment) {
				aAreaPositions[aAreaPositions["length"]] = this["iGetSegmentOffsetRowIndex"](oSegment);
			}
		}

		this["mSkippingStructureVertical"] = {
			// The cell matrix index from which can be scrolled on client side
			"iScrollableStart": this["iContentRowOffset"],
			// The cell matrix index to which can be scrolled on client side
			"iScrollableEnd": this["iContentRowOffset"] + (this["bCanClientScroll"](false) ? this["iContentRowCount"] : this["iVisibleContentRowCount"]) - 1,
			"aAreaPositions": aAreaPositions
		};

	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initSkippingStructure"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["aGetDomRefsOfRows"] = function(iRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["aGetDomRefsOfRows"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTableCS.js(1888): aGetDomRefsOfRows"); };

	if (this["iGetCellInfoMatrixLastRowIndex"]() < iRowIndex) return [];
	else {
		var aRowDomRefsOfRow = [],
			iColIndex = 0,
			oCurrCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex),
			oDomRefRow = null;

		while (oCurrCellInfo != null) {
			if (oDomRefRow != oCurrCellInfo["oDomRefRow"]) aRowDomRefsOfRow["push"](oCurrCellInfo["oDomRefRow"]);
			oDomRefRow = oCurrCellInfo["oDomRefRow"];
			iColIndex += oCurrCellInfo["iColSpan"];
			oCurrCellInfo = this["oGetCellInfo"](iRowIndex, iColIndex);
		}

		return aRowDomRefsOfRow;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["aGetDomRefsOfRows"] = 0; };

/******************************************************
 ** METHODS of the control interface
 *******************************************************/

/**
 * Sets/resets the cell selection state
 *
 * @param {Array} aCellIds The id of the cell or an array of cell IDs
 * @param {boolean} bSet true=select; false=deselect
 * @public
 */
UCF_SapTableCS["prototype"]["setCellSelection"] = function(aCellIds, bSet) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setCellSelection"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(aCellIds != null, "aCellIds != null", "SapTableCS.js(1920): setCellSelection"); };

	var aCellInfos = [],
		oDomRefCell = null,
		oCellInfo = null;

	if (typeof(aCellIds) == "string") aCellIds = [aCellIds];

	for (var i = 0; i < aCellIds["length"]; i++) {
		oDomRefCell = UCF_DomUtil["$"](aCellIds[i]);
		oCellInfo = (oDomRefCell) ? this["oGetCellInfoByDomRef"](oDomRefCell) : null;

		if (oCellInfo) aCellInfos[aCellInfos["length"]] = oCellInfo;
	}

	if (aCellInfos["length"] > 0) {
		this["setCellSelectionStates"](aCellInfos, bSet, this["SELECTION_LAYER"]["CELL"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setCellSelection"] = 0; };

/**
 * Gets the cell selection state
 *
 * @param {string} sCellId The id of the cell
 *
 * @return {boolean} true=selected; false=deselected
 * @public
 */
UCF_SapTableCS["prototype"]["getCellSelection"] = function(sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["getCellSelection"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(1949): getCellSelection"); };
	var oDomRefCell = UCF_DomUtil["$"](sCellId),
		oCellInfo = (oDomRefCell) ? this["oGetCellInfoByDomRef"](oDomRefCell) : null;

	if (oCellInfo) {
		return (this["eGetCellSelectionState"](oCellInfo["iRowIndex"], oCellInfo["iColIndex"]) & this["SELECTION_LAYER"]["CELL"]) ? true : false;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Cell with ID=\"" + sCellId + "\" does not exist. No selection triggered.", "SapTableCS.js(1956): getCellSelection"); };
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["getCellSelection"] = 0; };

/******************************************************
 ** Segment methods
 *******************************************************/

/**
 * Returns the column type of a given segment
 *
 * @param {HTMLElement} oSegment The DomRef of the segment
 *
 * @return {number}
 * @private
 */
UCF_SapTableCS["prototype"]["eGetSegmentColType"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["eGetSegmentColType"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTableCS.js(1975): eGetSegmentColType"); };

	if (oSegment["getAttribute"]("hpm") == "none") return this["SEGMENT_COL"]["NONE_FIXED"];
	if (oSegment["getAttribute"]("hpm") == "left") return this["SEGMENT_COL"]["LEFT_FIXED"];
	if (oSegment["getAttribute"]("hpm") == "right") return this["SEGMENT_COL"]["RIGHT_FIXED"];
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["eGetSegmentColType"] = 0; };

/**
 * Returns the row type of a given segment
 *
 * @param {HTMLElement} oSegment The DomRef of the segment
 *
 * @return {number}
 * @private
 */
UCF_SapTableCS["prototype"]["eGetSegmentRowType"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["eGetSegmentRowType"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTableCS.js(1991): eGetSegmentRowType"); };

	if (oSegment["getAttribute"]("vpm") == "mrss-cont") return this["SEGMENT_ROW"]["CONTENT"];
	if (oSegment["getAttribute"]("vpm") == "mrss-hdr") return this["SEGMENT_ROW"]["HEADER"];
	if (oSegment["getAttribute"]("vpm") == "mrss-tfx") return this["SEGMENT_ROW"]["TOP"];
	if (oSegment["getAttribute"]("vpm") == "mrss-bfx") return this["SEGMENT_ROW"]["BOTTOM"];
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["eGetSegmentRowType"] = 0; };

/**
 * Returns the number of columns nested in the segment
 *
 * @param {HTMLElement} oSegment The DomRef of the segment
 *
 * @return {number}
 * @private
 */
UCF_SapTableCS["prototype"]["iGetSegmentColCount"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetSegmentColCount"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTableCS.js(2008): iGetSegmentColCount"); };
	return parseInt(oSegment["getAttribute"]("segcc"), 10);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetSegmentColCount"] = 0; };

/**
 * Returns the number of rows nested in the segment
 *
 * @param {HTMLElement} oSegment The DomRef of the segment
 *
 * @return {number}
 * @private
 */
UCF_SapTableCS["prototype"]["iGetSegmentRowCount"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetSegmentRowCount"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTableCS.js(2021): iGetSegmentRowCount"); };
	return parseInt(oSegment["getAttribute"]("segrc"), 10);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetSegmentRowCount"] = 0; };

/**
 * Returns the internal column cell matrix index of the first cell in this segment
 *
 * @param {HTMLElement} oSegment The DomRef of the segment
 *
 * @return {number}
 * @private
 */
UCF_SapTableCS["prototype"]["iGetSegmentOffsetColIndex"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetSegmentOffsetColIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTableCS.js(2034): iGetSegmentOffsetColIndex"); };
	return parseInt(oSegment["getAttribute"]("segoci"), 10);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetSegmentOffsetColIndex"] = 0; };

/**
 * Returns the internal row cell matrix index of the first cell in this segment
 *
 * @param {HTMLElement} oSegment The DomRef of the segment
 *
 * @return {number}
 * @private
 */
UCF_SapTableCS["prototype"]["iGetSegmentOffsetRowIndex"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetSegmentOffsetRowIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTableCS.js(2047): iGetSegmentOffsetRowIndex"); };
	return parseInt(oSegment["getAttribute"]("segori"), 10);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetSegmentOffsetRowIndex"] = 0; };

/**
 * Returns the dom reference of the first available segment of a segment column
 *
 * @param {number} eColSegmentType
 *
 * @return {HTMLElement}
 * @private
 */
UCF_SapTableCS["prototype"]["oGetFirstSegmentOfCol"] = function(eColSegmentType) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetFirstSegmentOfCol"]++; }; 
	for (var iRowSegmentIndex = 0; iRowSegmentIndex < this["aDomRefSegmentMatrix"]["length"]; iRowSegmentIndex++) {
		var oColSegment = this["aDomRefSegmentMatrix"][iRowSegmentIndex][eColSegmentType];
		if (oColSegment) return oColSegment;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetFirstSegmentOfCol"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["bIsHorizontalScrollSegment"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bIsHorizontalScrollSegment"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTableCS.js(2072): bIsHorizontalScrollSegment"); };

	for (var iRowSegment = 0; iRowSegment < this["aDomRefSegmentMatrix"]["length"]; iRowSegment++) {
		if (oSegment == this["aDomRefSegmentMatrix"][iRowSegment][this["SEGMENT_COL"]["NONE_FIXED"]]) {
			return true;
		}
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bIsHorizontalScrollSegment"] = 0; };

/**
 * Scrolls the given cell into a visible position
 *
 * @param {Object} oCellInfo
 * @private
 */
UCF_SapTableCS["prototype"]["scrollVerticalIntoView"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["scrollVerticalIntoView"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTableCS.js(2089): scrollVerticalIntoView"); };
	if (this["oScrollV"]) {
		this["oScrollV"]["scrollToPosition"](this["iGetContentRowIndex"](oCellInfo) + 1, UCF_JsUtil["MODIFIER"]["NONE"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["scrollVerticalIntoView"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["oGetFirstContentScrollSegment"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetFirstContentScrollSegment"]++; }; 
	return this["oGetFirstSegmentOfCol"](this["SEGMENT_COL"]["NONE_FIXED"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetFirstContentScrollSegment"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["oGetContentSegment"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetContentSegment"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + "-mrss-cont-none");
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetContentSegment"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["aGetHorizontalScrollSegments"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["aGetHorizontalScrollSegments"]++; }; 
	return this["aGetSegmentsByColType"](this["SEGMENT_COL"]["NONE_FIXED"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["aGetHorizontalScrollSegments"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["bIsVerticalScrolledIntoViewByIndex"] = function(iContentRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bIsVerticalScrolledIntoViewByIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iContentRowIndex) == "number", "typeof(iContentRowIndex) == \"number\"", "SapTableCS.js(2128): bIsVerticalScrolledIntoViewByIndex"); };

	return !this["bCanClientScroll"](false)
		// outside the scrolling range -> true
		|| iContentRowIndex < 0 || iContentRowIndex >= this["iContentRowCount"]
		// check scroll window
		|| (
			iContentRowIndex >= this["iFirstVisibleContentRowIndex"]
			&& iContentRowIndex < this["iFirstVisibleContentRowIndex"] + this["iVisibleContentRowCount"]
		);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bIsVerticalScrolledIntoViewByIndex"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["oGetSegmentByCellInfo"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetSegmentByCellInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oCellInfo != null, "oCellInfo != null", "SapTableCS.js(2146): oGetSegmentByCellInfo"); };

	if (this["bIsValidCellInfo"](oCellInfo)) {
		return UCF_DomUtil["oGetParentByTagName"](oCellInfo["oDomRefRow"], "DIV")["parentNode"];
	} else {
		var oContentSegments = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]],
			oSegment = null;

		for (var iSegmentColIndex = 0; iSegmentColIndex <= oContentSegments["length"]; iSegmentColIndex++) {
			oSegment = oContentSegments[iSegmentColIndex];

			if (oSegment && oCellInfo["iColIndex"] >= this["iGetSegmentOffsetColIndex"](oSegment) && oCellInfo["iColIndex"] < this["iGetSegmentOffsetColIndex"](oSegment) + this["iGetSegmentColCount"](oSegment))
				return oSegment;
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetSegmentByCellInfo"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["oGetSegmentByBrowserEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetSegmentByBrowserEvent"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "SapTableCS.js(2171): oGetSegmentByBrowserEvent"); };
	var oDomRef = oBrowserEvent["oGetSource"]();

	while (oDomRef && oDomRef != this["oDomRef"]) {
		if (oDomRef["getAttribute"]("hpm")) return oDomRef;
		oDomRef = oDomRef["parentNode"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetSegmentByBrowserEvent"] = 0; };

/**
 * @param {number} eColSegmentType
 *
 * @return {Array} Returns the segments
 * @private
 */
UCF_SapTableCS["prototype"]["aGetSegmentsByColType"] = function(eColSegmentType) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["aGetSegmentsByColType"]++; }; 
	var aResult = [],
		oSegment = null;

	for (var iSegmentRowIndex = 0; iSegmentRowIndex < this["aDomRefSegmentMatrix"]["length"]; iSegmentRowIndex++) {
		oSegment = this["aDomRefSegmentMatrix"][iSegmentRowIndex][eColSegmentType];
		if (oSegment) aResult[aResult["length"]] = oSegment;
	}

	return aResult;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["aGetSegmentsByColType"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["bHasLeadingSelectionColumn"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bHasLeadingSelectionColumn"]++; }; 
	var oCellInfo = this["oGetCellInfo"](0, 0),
		oHtmlCol = oCellInfo ? this["oGetHtmlCol"](oCellInfo) : null;

	return (oHtmlCol && oHtmlCol["getAttribute"]("eType") == "SELECTIONCOLUMN") ? true : false;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["bHasLeadingSelectionColumn"] = 0; };

/**
 * Extracts the HTML rows out from a given segment
 *
 * @param {HTMLElement} oDomRefSegment
 *
 * @return {Array} The rows
 * @private
 */
UCF_SapTableCS["prototype"]["aGetSegmentRows"] = function(oDomRefSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["aGetSegmentRows"]++; }; 
	return this["oGetSegmentTable"](oDomRefSegment)["rows"];
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["aGetSegmentRows"] = 0; };

/**
 * Extracts the HTML row out from a given segment
 *
 * @param {HTMLElement} oDomRefSegment
 *
 * @return {HTMLElement} The HTML row reference
 * @private
 */
UCF_SapTableCS["prototype"]["oGetSegmentRow"] = function(oDomRefSegment, iContentRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetSegmentRow"]++; }; 
	if (!oDomRefSegment || !this["oGetSegmentTable"](oDomRefSegment)) return null;

	if (!this["bHasFragments"]) {
		return this["aGetSegmentRows"](oDomRefSegment)[iContentRowIndex];
	} else {
		var oFragment = this["oGetFragmentByContentRowIndex"](oDomRefSegment, iContentRowIndex);

		if (oFragment) {
			if (this["bIsSpacerFragment"](oFragment)) {
				oFragment["rows"][0]["bIsSpacerFragmentRow"] = true;
				return oFragment["rows"][0];
			} else {
				return oFragment["rows"][iContentRowIndex - this["iGetFragmentOffset"](oFragment)];
			}
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetSegmentRow"] = 0; };

/**
 * Finds the fragment in a given segment according to the passed row index
 *
 * @param {HTMLElement} oDomRefSegment
 * @param {number} iContentRowIndex The row index
 *
 * @return {HTMLElement} The DOM ref to the fragment which contains the HTML row representation
 * @private
 */
UCF_SapTableCS["prototype"]["oGetFragmentByContentRowIndex"] = function(oDomRefSegment, iContentRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetFragmentByContentRowIndex"]++; }; 
	if (!this["bHasFragments"] || !oDomRefSegment || !this["oGetSegmentTable"](oDomRefSegment)) return null;

	var oDomRefSegmentBody = this["oGetSegmentTable"](oDomRefSegment)["tBodies"][0],
		iRowIndexOffset = 0,
		iRowsFragmentLength = 0,
		bIsSpacerFragment = false;

	while (oDomRefSegmentBody) {
		bIsSpacerFragment = this["bIsSpacerFragment"](oDomRefSegmentBody);
		iRowIndexOffset = this["iGetFragmentOffset"](oDomRefSegmentBody);
		iRowsFragmentLength = bIsSpacerFragment ?
			this["iGetFragmentLength"](oDomRefSegmentBody) :
			oDomRefSegmentBody["rows"]["length"];

		if (iContentRowIndex >= iRowIndexOffset + iRowsFragmentLength) {} else {
			return oDomRefSegmentBody;
		}
		oDomRefSegmentBody = oDomRefSegmentBody["nextSibling"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetFragmentByContentRowIndex"] = 0; };

/**
 * Sets FirstVisibleContentRowIndex
 *
 * @param {number} iFirstVisibleContentRowIndex
 * @private
 */
UCF_SapTableCS["prototype"]["setFirstVisibleContentRowIndex"] = function(iFirstVisibleContentRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setFirstVisibleContentRowIndex"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleContentRowIndex) == "number", "typeof(iFirstVisibleContentRowIndex) == \"number\"", "SapTableCS.js(2293): setFirstVisibleContentRowIndex"); };

	if (iFirstVisibleContentRowIndex != this["iFirstVisibleContentRowIndex"]) {
		if (this["bCanClientScroll"](false)) {
			// update the visibility state of the rows according to the new set scroll position
			this["updateVisibleContentRows"](
				this["iFirstVisibleContentRowIndex"],
				this["iVisibleContentRowCount"],
				iFirstVisibleContentRowIndex,
				this["iVisibleContentRowCount"]
			);
		}

		if (window["UCF_System"]["bIsAria"]) {
			var oFirstContentSegment = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]][0],
				oDomRefRow = null;

			if (oFirstContentSegment) {
				oDomRefRow = this["oGetSegmentRow"](oFirstContentSegment, this["iFirstVisibleContentRowIndex"]);
				if (oDomRefRow) {
					oDomRefRow["removeAttribute"]("aria-rowindex");
				}
				oDomRefRow = this["oGetSegmentRow"](oFirstContentSegment, iFirstVisibleContentRowIndex);
				if (oDomRefRow) {
					oDomRefRow["setAttribute"]("aria-rowindex", this["iMatrixHeaderRowCount"] + this["iMatrixTopFixedRowCount"] + iFirstVisibleContentRowIndex + 1);
				}
			}
		}

		this["updateCssClassFirstVisible"](iFirstVisibleContentRowIndex, this["iFirstVisibleContentRowIndex"]);

		this["iFirstVisibleContentRowIndex"] = iFirstVisibleContentRowIndex;
		this["iVisibleFirstRow"] = this["iFirstVisibleContentRowIndex"];

		if (this["oScrollV"]) {
			this["oScrollV"]["setFirstVisibleItem"](this["iFirstVisibleContentRowIndex"] + 1);
		}

	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setFirstVisibleContentRowIndex"] = 0; };

/**
 * Same as "setFirstVisibleContentRowIndex" but it is defined in the SapTableCS method API and is called from external
 *
 * @param {number} iFirstVisibleRowIndex
 * @see setFirstVisibleContentRowIndex
 * @public
 */
UCF_SapTableCS["prototype"]["setFirstVisibleRowIndex"] = function(iFirstVisibleRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setFirstVisibleRowIndex"]++; }; 
	this["setFirstVisibleContentRowIndex"](iFirstVisibleRowIndex);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setFirstVisibleRowIndex"] = 0; };

/**
 * The the scrollposition changes or an update comes from the server the HTML rows have to adapt their visibility state according to the
 * current view. This method displays the rows which are not already visible and hides the rows which are not in the current view
 * The BeforeRange is the row range which have been visible before the update and the AfterRange is the row range which should currently be visible
 *
 * @param {number} iBeforeRangeStart
 * @param {number} iBeforeRangeSize
 * @param {number} iAfterRangeStart
 * @param {number} iAfterRangeSize
 * @private
 */
UCF_SapTableCS["prototype"]["updateVisibleContentRows"] = function(iBeforeRangeStart, iBeforeRangeSize, iAfterRangeStart, iAfterRangeSize) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["updateVisibleContentRows"]++; }; 
	var oMergingObject = {},
		bShow = true,
		aTouchedFragments = null;
	var i;
	var j;
	var iTo;
	var bIsFirstVisible = false;

	// Apply the highlight texts dependent from the range which should be currently visible
	this["applyHighlightTexts"](iAfterRangeStart, iAfterRangeSize);

	if (this["bHasFragments"]) {
		aTouchedFragments = [];
	}

	// Check both ranges and remove intersections of both
	for (i = iAfterRangeStart, iTo = iAfterRangeStart + iAfterRangeSize; i < iTo; i++) {
		oMergingObject[i] = true;
	}

	for (j = iBeforeRangeStart, iTo = iBeforeRangeStart + iBeforeRangeSize; j < iTo; j++) {
		if (oMergingObject[j]) delete oMergingObject[j];
		else oMergingObject[j] = false;
	}

	for (var k in oMergingObject) {
		k = parseInt(k, 10);
		if (oMergingObject[k]) bShow = true;
		else bShow = false;

		if (k === iAfterRangeStart) bIsFirstVisible = true;
		else bIsFirstVisible = false;
		// Sets the row to the right HTML display mode and fills the aTouchedFragments array with the affected spacer fragments
		// when no real row refernce has been found but a spacer fragment for the passed row
		this["setRowVisibilityState"](k, bShow, aTouchedFragments, bIsFirstVisible);
	}

	// After the states have been applied check the spacer fragments to update their sizes according to their gap
	// they should fill
	if (aTouchedFragments) {
		var oTouchedFragment = null;

		for (var l = 0; l < aTouchedFragments["length"]; l++) {
			oTouchedFragment = aTouchedFragments[l];
			this["setSpacerFragmentVisibilityState"](oTouchedFragment, iAfterRangeStart, iAfterRangeSize);
			oTouchedFragment["bUpdateVisibilityState"] = false;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["updateVisibleContentRows"] = 0; };

/**
 * Sets the visibility state of content row. If no content row refernce have been found because the
 * row has not been loaded yet it fills the aTouchedFragments Array with the reference of the spacer fragment.
 * After a mass row state update these fragments can be analyzed and adapted
 *
 * @param {number} iContentRowIndex The row index of the row
 * @param {boolean} bShow if true the row becomes visible, if false the row is hidden
 * @param {Array} aTouchedFragments
 * @private
 */
UCF_SapTableCS["prototype"]["setRowVisibilityState"] = function(iContentRowIndex, bShow, aTouchedFragments, bIsFirstVisible) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setRowVisibilityState"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iContentRowIndex) == "number", "typeof(iContentRowIndex) == \"number\"", "SapTableCS.js(2418): setRowVisibilityState"); };

	var oContentSegments = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]],
		oContentSegment = null,
		oDomRefRow = null;

	for (var iContentSegment = 0; iContentSegment < oContentSegments["length"]; iContentSegment++) {
		oContentSegment = oContentSegments[iContentSegment];
		if (oContentSegment) {
			oDomRefRow = this["oGetSegmentRow"](oContentSegment, iContentRowIndex);

			if (oDomRefRow) {
				if (oDomRefRow["bIsSpacerFragmentRow"]) {
					if (!oDomRefRow["parentNode"]["bUpdateVisibilityState"] && aTouchedFragments) {
						oDomRefRow["parentNode"]["bUpdateVisibilityState"] = true;
						aTouchedFragments[aTouchedFragments["length"]] = oDomRefRow["parentNode"];
					}
				} else {
					if (bShow) {
						oDomRefRow["style"]["display"] = (UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]() || window["UCF_System"]["sDevice"] == "standards") ? "table-row" : "";
					} else {
						oDomRefRow["style"]["display"] = "none";
					}
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setRowVisibilityState"] = 0; };

/**
 * Sets the width of a column given by the internal cell matrix column index
 *
 * @param {number} iColIndex the internal cell matrix index of the column  (alternatively you can pass the ID of a cell of this column)
 * @param {number} iWidth
 * @public
 */
UCF_SapTableCS["prototype"]["setColumnWidth"] = function(iColIndex, sWidth) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setColumnWidth"]++; }; 
	var aCols;

	// When the method is called by the SapTable/CS API iColIndex is the ID of a cell
	if (typeof(iColIndex) == "string") iColIndex = this["oGetCellInfoByDomRef"](UCF_DomUtil["$"](iColIndex))["iColIndex"];

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTableCS.js(2460): setColumnWidth"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sWidth) == "string", "typeof(sWidth) == \"string\"", "SapTableCS.js(2461): setColumnWidth"); };

	var oCellInfo = this["oGetCellInfo"](0, iColIndex),
		oSegment = this["oGetSegmentByCellInfo"](oCellInfo),
		iSegmentColIndex = iColIndex - this["iGetSegmentOffsetColIndex"](oSegment),
		eSegmentColType = this["eGetSegmentColType"](oSegment);

	for (var iRowSegmentIndex = 0; iRowSegmentIndex < this["aDomRefSegmentMatrix"]["length"]; iRowSegmentIndex++) {
		var oColSegment = this["aDomRefSegmentMatrix"][iRowSegmentIndex][eSegmentColType];
		if (oColSegment) {
			this["setSegmentColumnWidth"](oColSegment, iSegmentColIndex, sWidth);
		}
	}

	if (eSegmentColType == this["SEGMENT_COL"]["LEFT_FIXED"]) {
		aCols = this["aGetColsOfHtmlTable"](this["oDomRef"]);

		this["setHtmlColWidth"](
			aCols,
			iColIndex + 1, //BodyTable has a leading offset col which has to be skipped
			sWidth);
	} else if (eSegmentColType == this["SEGMENT_COL"]["RIGHT_FIXED"]) {
		aCols = this["aGetColsOfHtmlTable"](this["oDomRef"]);

		this["setHtmlColWidth"](
			aCols,
			(aCols["length"] - 2) - (this["iGetCellInfoMatrixLastColIndex"]() - iColIndex),
			sWidth);

	}

	if (this["sHorizontalScrollUpdateMode"] == this["SCROLL_UPDATE_MODE"]["CLIENT"]) {
		this["updateHorizontalScrollDimensions"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setColumnWidth"] = 0; };

/**
 * Returns he proposed optimum width of the cell's column
 *
 * @param {Object} oCellInfo
 *
 * @return {number} the proposed optimum width of the column
 * @private
 */
UCF_SapTableCS["prototype"]["iGetBestCellWidth"] = function(oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetBestCellWidth"]++; }; 
	var iResult = 0; //Begins with a buffer width

	if (this["bIsValidCellInfo"](oCellInfo)) {
		var oDomRefContentContainer = this["oDomRefGetCellContentContainer"](oCellInfo);

		if (oDomRefContentContainer) {
			var oChildControl = this["oGetFirstCellControl"](oCellInfo),
				iPaddingLeft = parseInt(UCF_DomUtil["sGetCurrentStyle"](oDomRefContentContainer, "paddingLeft"), 10),
				iPaddingRight = parseInt(UCF_DomUtil["sGetCurrentStyle"](oDomRefContentContainer, "paddingRight"), 10);

			if (!iPaddingLeft) iPaddingLeft = 0;
			if (!iPaddingRight) iPaddingRight = 0;

			iResult = iResult
				+ (oCellInfo["oDomRefCell"]["offsetWidth"] - oDomRefContentContainer["offsetWidth"]) // own cell elements
				+ (oDomRefContentContainer["offsetWidth"] - oDomRefContentContainer["clientWidth"]) // cell border
				+ (iPaddingLeft + iPaddingRight) //Padding
				+ (oChildControl ? oChildControl["iGetOptimalWidth"]() : 20) // content control width or default
				+ 4; // a buffer to avoid pixel problems
		}
	}

	return iResult;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetBestCellWidth"] = 0; };

/**
 * Sets the optimzed column width for the column identified by its index
 *
 * @param {number} iColIndex
 * @private
 */
UCF_SapTableCS["prototype"]["optimizeColumnWidth"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["optimizeColumnWidth"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableCS.js(2538): optimizeColumnWidth"); };

	var oSourceHeaderCellInfo = oAccessInfo["oCellInfo"],
		iColIndex = oSourceHeaderCellInfo["iColIndex"],
		aCellInfos = this["aGetCellInfosOfColumn"](iColIndex),
		iResultWidth = this["MIN_COL_WIDTH"];

	for (var i = 0; i < aCellInfos["length"]; i++) {
		iResultWidth = Math["max"](iResultWidth, this["iGetBestCellWidth"](aCellInfos[i]));
	}

	this["createDragDropDelegate"]();

	this["oDragDropDelegate"]["simulateDragDropColumnResize"](oAccessInfo, iResultWidth, true);

	if (this["bColumnTitleAdoption"]) {
		this["adjustHeaderCellCaptions"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["optimizeColumnWidth"] = 0; };

/**
 * Searches in array of the row segments for the first available segment.
 * The result could be a left or right fixed or the content segment in between.
 *
 * @param {number} eSegmentRow
 *
 * @return {HTMLElement} the DOM ref of the first segemnt in the given row of segments
 * @private
 */
UCF_SapTableCS["prototype"]["oGetFirstSegmentInSegmentRow"] = function(eSegmentRow) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetFirstSegmentInSegmentRow"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(eSegmentRow) == "number", "typeof(eSegmentRow) == \"number\"", "SapTableCS.js(2568): oGetFirstSegmentInSegmentRow"); };

	var aSegmentRowSegments = this["aDomRefSegmentMatrix"][eSegmentRow];
	for (var iContentSegment = 0; iContentSegment < aSegmentRowSegments["length"]; iContentSegment++) {
		if (aSegmentRowSegments[iContentSegment]) return aSegmentRowSegments[iContentSegment];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetFirstSegmentInSegmentRow"] = 0; };

/**
 * Checks if the passed FirstVisibleContentRowIndex has to be corrected in a way the the whole
 * visible row count is used to display the content
 *
 * @private
 *
 * @param {number} iFirstVisibleContentRowIndex the visible row count
 * @private
 */
UCF_SapTableCS["prototype"]["iOptimizeFirstVisibleContentRowIndex"] = function(iFirstVisibleContentRowIndex) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iOptimizeFirstVisibleContentRowIndex"]++; }; 

	if (iFirstVisibleContentRowIndex + this["iVisibleContentRowCount"] > this["iContentRowCount"]) {
		var iNewFirstVisibleContentRowIndex = Math["max"](0, this["iContentRowCount"] - this["iVisibleContentRowCount"]);

		if (iNewFirstVisibleContentRowIndex != iFirstVisibleContentRowIndex) {
			return iNewFirstVisibleContentRowIndex;
		}
	}

	return iFirstVisibleContentRowIndex;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iOptimizeFirstVisibleContentRowIndex"] = 0; };

/**
 * Sets the visible row count. This is important for the auto vertical resize feature of the SapTable
 *
 * @param {number} iVisibleRowCount the visible row count
 * @public
 */
UCF_SapTableCS["prototype"]["setVisibleRowCount"] = function(iVisibleRowCount) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setVisibleRowCount"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iVisibleRowCount) == "number", "typeof(iVisibleRowCount) == \"number\"", "SapTableCS.js(2606): setVisibleRowCount"); };

	this["setVisibleContentRowCount"](iVisibleRowCount);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setVisibleRowCount"] = 0; };

/**
 * Sets the visible row count. This is important for the auto vertical resize feature of the SapTable
 *
 * @param {number} iVisibleContentRowCount the visible row count
 * @private
 */
UCF_SapTableCS["prototype"]["setVisibleContentRowCount"] = function(iVisibleContentRowCount) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setVisibleContentRowCount"]++; }; 
	var oContentSegment;
	var oContentSegments;
	var iContentSegment;
	var oSegmentRowContainer;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iVisibleContentRowCount) == "number", "typeof(iVisibleContentRowCount) == \"number\"", "SapTableCS.js(2623): setVisibleContentRowCount"); };

	iVisibleContentRowCount = Math["max"](this["iGetMinVisibleContentRowCount"](), iVisibleContentRowCount);

	if (!(
			iVisibleContentRowCount != this["iVisibleContentRowCount"]
			|| this["iOptimizeFirstVisibleContentRowIndex"](this["iFirstVisibleContentRowIndex"]) != this["iFirstVisibleContentRowIndex"]
		)) {
		return;
	}

	// Update the HTML according to the new visible row count

	var iOldVisibleRowCount = this["iVisibleContentRowCount"],
		iOldResultHeight = this["iRowHeight"] * iOldVisibleRowCount,
		oFirstContentSegment = this["oGetFirstSegmentInSegmentRow"](this["SEGMENT_ROW"]["CONTENT"]),
		iContainerHeightOffset = -1;

	this["iVisibleContentRowCount"] = iVisibleContentRowCount;
	this["iVisibleRowCount"] = iVisibleContentRowCount;

	this["oDomRef"]["setAttribute"]("vcrc", this["iVisibleContentRowCount"]);

	if (oFirstContentSegment) {
		oSegmentRowContainer = oFirstContentSegment["parentNode"]["parentNode"];
		var iNewFirstVisibleContentRowIndex = this["iOptimizeFirstVisibleContentRowIndex"](this["iFirstVisibleContentRowIndex"]);

		iContainerHeightOffset = oSegmentRowContainer["offsetHeight"] - iOldResultHeight;

		oSegmentRowContainer["style"]["height"] = Math["max"](0, (this["iRowHeight"] * this["iVisibleContentRowCount"] + iContainerHeightOffset)) + "px";

		// FirstVisibleContentRow correction if necessary
		if (iNewFirstVisibleContentRowIndex != this["iFirstVisibleContentRowIndex"]) {
			this["setFirstVisibleContentRowIndex"](iNewFirstVisibleContentRowIndex);
		}

		//Update content rows if necessary
		this["updateVisibleContentRows"](
			this["iFirstVisibleContentRowIndex"],
			iOldVisibleRowCount,
			iNewFirstVisibleContentRowIndex,
			this["iVisibleContentRowCount"]
		);

		//Update vertical scrollbar
		if (this["oScrollV"]) {
			var mOldNotificationMode = this["oScrollV"]["mGetNotifactionMode"]();

			this["oScrollV"]["setNotifactionMode"](this["oScrollV"]["NOTIFICATION"]["NEVER"]);

			this["oScrollV"]["setVisibleItemCount"](this["iVisibleContentRowCount"]);
			this["oScrollV"]["setFirstVisibleItem"](this["iFirstVisibleContentRowIndex"] + 1);

			this["oScrollV"]["setNotifactionMode"](mOldNotificationMode);
		}

		//Update gap lines
		if (this["sGapGrid"] == "ALL" && (this["sGridMode"] == "HORIZONTAL" || this["sGridMode"] == "BOTH")) {
			oContentSegment = null;
			oContentSegments = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]];

			for (iContentSegment = 0; iContentSegment < oContentSegments["length"]; iContentSegment++) {
				oContentSegment = oContentSegments[iContentSegment];

				if (oContentSegment) {
					var oHAppendLinesContainer = UCF_DomUtil["$"](oContentSegment["getAttribute"]("id") + "-GapGridH"),
						oVAppendLinesContainer = UCF_DomUtil["$"](oContentSegment["getAttribute"]("id") + "-GapGridV"),
						oTemplate = oHAppendLinesContainer["lastChild"],
						iAppliedLines = parseInt(oHAppendLinesContainer["getAttribute"]("iAppliedLines"), 10),
						iLineIndex = iAppliedLines,
						iEndLineIndex = this["iVisibleContentRowCount"] - 1,
						oGapGridLineClone = null;

					if (iLineIndex > iEndLineIndex) break;

					while (iLineIndex <= iEndLineIndex) {
						if (iLineIndex % 2 == 1) {
							var sTopPosition = (iLineIndex * this["iRowHeight"]) + "px";

							if (this["iContentRowCount"] < this["iVisibleContentRowCount"]
								&& iLineIndex > (this["iContentRowCount"] - 1)
							) {
								//Lines under the content
								oGapGridLineClone = oTemplate["cloneNode"](true);
								oGapGridLineClone["style"]["display"] = "block";
								oGapGridLineClone["style"]["top"] = sTopPosition;
								oVAppendLinesContainer["appendChild"](oGapGridLineClone);
							} else if (oContentSegment == oContentSegments[this["SEGMENT_COL"]["NONE_FIXED"]]
								&& !this["bHasSegmentTableBasedColumnWidths"](oContentSegment)
							) {
								//Lines right to the content
								oGapGridLineClone = oTemplate["cloneNode"](true);
								oGapGridLineClone["style"]["display"] = "block";
								oGapGridLineClone["style"]["top"] = sTopPosition;
								oHAppendLinesContainer["appendChild"](oGapGridLineClone);
							}

							iLineIndex += 2;
						} else {
							iLineIndex++;
						}
					}

					oHAppendLinesContainer["setAttribute"]("iAppliedLines", this["iVisibleContentRowCount"]);

				}
			}
		}

		// Update FF segment div height
		if (UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]() || window["UCF_System"]["sDevice"] == "standards") {
			oContentSegment = null;
			oContentSegments = this["aDomRefSegmentMatrix"][this["SEGMENT_ROW"]["CONTENT"]];

			for (iContentSegment = 0; iContentSegment < oContentSegments["length"]; iContentSegment++) {
				oContentSegment = oContentSegments[iContentSegment];
				if (oContentSegment) {
					oContentSegment["style"]["height"] = (this["iRowHeight"] * this["iVisibleContentRowCount"] + iContainerHeightOffset) + "px";
				}
			}
		}
	}

	if (window["UCF_System"]["sDevice"] == "standards") {
		if (oFirstContentSegment && this["oScrollV"] && UCF_JsUtil["bInstanceOf"](this["oScrollV"], "UCF_Scrollbar")) {
			oSegmentRowContainer = oFirstContentSegment["parentNode"]["parentNode"];
			var oLastCell = oSegmentRowContainer["lastChild"];

			oLastCell["style"]["height"] = (this["iRowHeight"] * this["iVisibleContentRowCount"] + iContainerHeightOffset) + "px";

			// 2012/02/16 Edge has a bug that 100% height content does not collapse in table.
			if (UCF_UserAgent["bIsMSEdge"]()) {
				var sAlternativeHeight = "calc(100% - 0.01px)",
					oScrollbarRootStyle = this["oScrollV"]["oRootRef"]["style"];
				if (oScrollbarRootStyle["height"] != sAlternativeHeight) {
					oScrollbarRootStyle["height"] = sAlternativeHeight;
				}
			}

		}
	}

	if (this["bCanDataRequest"]()) {
		// Onyl execute a potential request when app is not locked -> see bSynchonizeLock parameter of method bCheckDataRequest
		UCF_JsUtil["feedMassNotificationFilter"](500, this["oDataRequestInfo"], this, "bCheckDataRequest", [false, null, true]);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setVisibleContentRowCount"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["iGetFirstActiveRowOfSegment"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetFirstActiveRowOfSegment"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTableCS.js(2777): iGetFirstActiveRowOfSegment"); };

	if (this["eGetSegmentRowType"](oSegment) == this["SEGMENT_ROW"]["CONTENT"] && this["bCanClientScroll"](false)) {
		return this["iGetSegmentOffsetRowIndex"](oSegment) + this["iFirstVisibleContentRowIndex"];
	}

	return UCF_SapTable.prototype["iGetFirstActiveRowOfSegment"]["call"](this, oSegment);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetFirstActiveRowOfSegment"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["updateGapGridHPosition"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["updateGapGridHPosition"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSegment != null, "oSegment != null", "SapTableCS.js(2792): updateGapGridHPosition"); };
	var oHAppendLinesContainer = UCF_DomUtil["$"](oSegment["getAttribute"]("id") + "-GapGridH");

	if (oHAppendLinesContainer) {
		var iScrollPos = -(this["iHorizontalScrollPosition"]);
		var sScrollPos = "";

		if (
			// eslint-disable-next-line no-magic-numbers
			(UCF_UserAgent["bIsFirefox"](3.6) || UCF_UserAgent["bIsWebKit"]()) &&	oSegment["scrollLeft"] !== 0) {
			// see setHorizontalScrollPosition()
			iScrollPos = window["UCF_System"]["bIsRTL"]
				? iScrollPos // TODO RTL
				: iScrollPos + oSegment["scrollLeft"];
		}

		sScrollPos = iScrollPos + "px";

		if (window["UCF_System"]["bIsRTL"]) oHAppendLinesContainer["style"]["right"] = sScrollPos;
		else oHAppendLinesContainer["style"]["left"] = sScrollPos;
	}

	UCF_SapTable.prototype["updateGapGridHPosition"]["call"](this, oSegment);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["updateGapGridHPosition"] = 0; };

/******************************************************
 ** TAB ACTION
 *******************************************************/

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["oRedirectProcessTabHandling"] = function(oBrowserEvent, bForward, oTabActionCellInfoFrom, oTabActionCellInfoTo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oRedirectProcessTabHandling"]++; }; 

	// The SapTableCS provides for the WebGUI a config button which needs a special handling in the taborder
	if (this["bConfigurable"]) {
		var oSource = oBrowserEvent["oGetSource"]();

		if (oTabActionCellInfoFrom && oTabActionCellInfoTo) {
			//When the last header cell has been reached focus the configuration Icon
			var oRefCellInfo = bForward ? oTabActionCellInfoFrom : oTabActionCellInfoTo;

			if (this["eGetCellType"](oRefCellInfo) == this["SUBCONTROL"]["HEADER_CELL"]) {
				if (oRefCellInfo["iColIndex"] == this["iGetCellInfoMatrixLastColIndex"]()) {
					var oNextCellInfo = bForward ?
						this["oGetCellInfo"](oRefCellInfo["iRowIndex"] + oRefCellInfo["iRowSpan"], oRefCellInfo["iColIndex"]) :
						this["oGetCellInfo"](oRefCellInfo["iRowIndex"] - 1, oRefCellInfo["iColIndex"]);

					if (!oNextCellInfo || this["eGetCellType"](oNextCellInfo) != this["SUBCONTROL"]["HEADER_CELL"]) {
						//Do not focus the next cell but the next DOM element which is in this case the config icon
						return null;
					}
				}
			}
		} else {
			// Need to scroll when leaving config button?
			if (oSource["getAttribute"]("id") && UCF_StringUtil["bEndsWith"](oSource["getAttribute"]("id"), "-config") //Is the config button
				&& bForward //Only forward tab can trigger scrolling to firsdt row
				&& this["iFirstVisibleContentRowIndex"] != 0 // table is scrolled
				&& !this["oGetFirstSegmentInSegmentRow"](this["SEGMENT_ROW"]["TOP"]) // there is no top fixed row
			) {
				return this["oGetCellInfo"](this["iGetContentRowOffset"](), 0);
			}
		}
	}

	return UCF_SapTable.prototype["oRedirectProcessTabHandling"]["call"](this, oBrowserEvent, bForward, oTabActionCellInfoFrom, oTabActionCellInfoTo);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oRedirectProcessTabHandling"] = 0; };

/******************************************************
 ** Automatical vertical resize
 *
 * The SapTableCS provides a feature to  adapt its height to the surround content. This is possible because the missing rows to fill up the space
 * Are usually present at client side or can be loaded on demand.
 * So the table has not to be rendered with all its constraints only the visibility of the rows have to be updated according to the new calculated visible rows.
 *
 * The mechanism cannot fill the available space in exact pixel raster. A algorithm checks the available space and calculates how many rows fit into the gap.
 * With that information it adapts the visible content row count. If the height is reduced it hides the corresponding rows.
 *
 * For the rendering I chose the approach that a 100% height HTML DIV is rendered surrounding the whole table. It has overflow hidden.
 * This DIV is used to calculate all necessary data
 *
 *******************************************************/

/**
 * When the table is set to vertical auto resize mode it attaches to the resize event.
 * This handler retrieves the resize events and sets a mass filter
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableCS["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onresize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableCS.js(2886): onresize"); };
	if (this["sResizeMode"] == "AUTO_VERTICAL") {
		UCF_JsUtil["feedMassNotificationFilter"](500, this["oAutoVResizeInfo"], this, "checkAutoVResize");
	}
	if (this["bColumnTitleAdoption"]) {
		this["adjustHeaderCellCaptions"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onresize"] = 0; };

/**
 * Initializes the auto vertical resize feature
 * @private
 */
UCF_SapTableCS["prototype"]["initAutoVResize"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initAutoVResize"]++; }; 
	this["oAutoVResizeInfo"] = {};

	this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "onLsLock");
	this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "onLsUnlock");
	if (!this["oLS"]["bIsLocked"]) this["attachBrowserEvent"]("resize", this["oDomRef"]);
	this["checkAutoVResize"]();
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["initAutoVResize"] = 0; };

/**
 * Cleans up the auto vertical resize feature
 * @private
 */
UCF_SapTableCS["prototype"]["cleanUpAutoVResize"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["cleanUpAutoVResize"]++; }; 
	if (this["oAutoVResizeInfo"]) UCF_JsUtil["resetMassNotificationFilter"](this["oAutoVResizeInfo"]);
	this["oAutoVResizeInfo"] = null;
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "onLsLock");
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "onLsUnlock");
	this["detachBrowserEvent"]("resize", this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["cleanUpAutoVResize"] = 0; };

/**
 * Checks if a UI update is necesary and triggers the update
 * @private
 */
UCF_SapTableCS["prototype"]["checkAutoVResize"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["checkAutoVResize"]++; }; 
	var iOuterHeight = this["oDomRef"]["offsetHeight"]; // The DIV surrounding the table

	if (iOuterHeight != 0) { // Popup resizes Table to 0 -> Workaround: throw no resize event
		var iInnerHeight = UCF_DomUtil["oGetFirstElement"](UCF_DomUtil["oGetFirstElement"](this["oDomRef"]))["offsetHeight"], // the table in the DIV
			iThreshold = 4, // Is needed to avoid flickering in IE because the IE sizing algorithm is not deterministic and can variate some pixels for the same HTML
			iNewVisibleContentRowCount = this["iVisibleContentRowCount"] + Math["floor"](((iOuterHeight - iThreshold) - iInnerHeight) / this["iRowHeight"]),
			iOldVisibleContentRowCount = this["iVisibleContentRowCount"];

		if (iNewVisibleContentRowCount >= 0) {
			this["setVisibleContentRowCount"](iNewVisibleContentRowCount);

			if (this["iVisibleContentRowCount"] != iOldVisibleContentRowCount) {
				this["fireTableResize"](this["sId"], this["iVisibleContentRowCount"]);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["checkAutoVResize"] = 0; };

/**
 * Handler for LS Lock
 * @private
 */
UCF_SapTableCS["prototype"]["onLsLock"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onLsLock"]++; }; 

	//Disconnect resize propagation when LS is locked
	if (this["sResizeMode"] == "AUTO_VERTICAL") {
		this["detachBrowserEvent"]("resize", this["oDomRef"]);
		//CleanUp pending delayed resize requests when UI is locked
		UCF_JsUtil["resetMassNotificationFilter"](this["oAutoVResizeInfo"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onLsLock"] = 0; };

/**
 * Handler for LS Unlock
 * @private
 */
UCF_SapTableCS["prototype"]["onLsUnlock"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onLsUnlock"]++; }; 

	//Connect again resize propagation when LS is unlocked
	if (this["sResizeMode"] == "AUTO_VERTICAL") {
		this["attachBrowserEvent"]("resize", this["oDomRef"]);
		this["checkAutoVResize"]();
		// It could happen that in "AUTO_VERTICAL" that data requests are triggred by resize and have benn skipped because
		// the UI was locked. The table has to check on unlock if data has to be loaded
		this["bCheckDataRequest"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["onLsUnlock"] = 0; };

/******************************************************
 ** Drag and Drop
 *******************************************************/

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["sGetRowRootDropTargetInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["sGetRowRootDropTargetInfo"]++; }; 
	return this["sRowRootDropTargetInfo"] ? this["sRowRootDropTargetInfo"] : "";
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["sGetRowRootDropTargetInfo"] = 0; };

/**
 * @see UCF_SapTable
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["sGetRowRootDragSourceInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["sGetRowRootDragSourceInfo"]++; }; 
	return this["sRowRootDragSourceInfo"] ? this["sRowRootDragSourceInfo"] : "";
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["sGetRowRootDragSourceInfo"] = 0; };

/**
 * Sets the ID of the table's root drop target info.
 *
 * @param {string} sRowRootDropTargetInfo the ID of the root drop target info
 * @public
 */
UCF_SapTableCS["prototype"]["setRowRootDropTargetInfo"] = function(sRowRootDropTargetInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setRowRootDropTargetInfo"]++; }; 
	this["sRowRootDropTargetInfo"] = sRowRootDropTargetInfo;
	this["setClientProperty"]("RowRootDropTargetInfo", this["sRowRootDropTargetInfo"], true);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setRowRootDropTargetInfo"] = 0; };

/**
 * Sets the ID of the table's root drag source info.
 *
 * @param {string} sRowRootDropTargetInfo the ID of the root drag source info
 * @public
 */
UCF_SapTableCS["prototype"]["setRowRootDragSourceInfo"] = function(sRowRootDragSourceInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setRowRootDragSourceInfo"]++; }; 
	this["sRowRootDragSourceInfo"] = sRowRootDragSourceInfo;
	this["setClientProperty"]("RowRootDragSourceInfo", this["sRowRootDragSourceInfo"], true);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setRowRootDragSourceInfo"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["createDragDelegate"]++; }; 
	// if (UCF_UserAgent.bIsIOS()) return; //touch device does not support this feature yet

	//create lazy
	this["createDragDropDelegate"]();

	if (!this["sGetRowRootDragSourceInfo"]())
		return;

	if (this["oDragDelegate"])
		return;

	// eslint-disable-next-line @ur/no-memory-leaks
	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableCSDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["createDragDelegate"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["createDropDelegate"]++; }; 
	// if (UCF_UserAgent.bIsIOS()) return; //touch device does not support this feature yet

	//create lazy
	this["createDragDropDelegate"]();

	if (this["oDropDelegate"])
		return;

	// eslint-disable-next-line @ur/no-memory-leaks
	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableCSDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["createDropDelegate"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_SapTableCS["prototype"]["createDragDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["createDragDropDelegate"]++; }; 
	// if (UCF_UserAgent.bIsIOS()) return; //touch device does not support this feature yet

	if (this["oDragDropDelegate"])
		return;

	// eslint-disable-next-line @ur/no-memory-leaks
	this["oDragDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableCSDragDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDropDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["createDragDropDelegate"] = 0; };

/******************************************************
 * Highlighting of texts to visualize search matches
 *
 *******************************************************/

/**
 * Sets the information which controls have to set highlight texts. The info is fragmente by rows in an asso array
 *
 * @param {Object} mHighlightTextsToApply The map of row information
 * @param {Number} iRowIndexOffset An offset to be subtracted from the passed rows indices. Only the first call of setHighlightTexts method sets the index. Default is 0
 *
 * @public
 */
UCF_SapTableCS["prototype"]["setHighlightTexts"] = function(mHighlightTextsToApply, iRowIndexOffset) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setHighlightTexts"]++; }; 
	var bHasPendingDataRequest = this["oDataRequestInfo"] && this["oDataRequestInfo"]["bHasPendingRequest"];

	if (!this["mHighlightTextsToApply"]) {
		this["mHighlightTextsToApply"] = {};
		this["mHighlightTextsToApply"]["iLength"] = 0;
		this["mHighlightTextsToApply"]["iRowIndexOffset"] = iRowIndexOffset ? iRowIndexOffset : 0;
	}

	for (var sIndex in mHighlightTextsToApply) {
		this["mHighlightTextsToApply"][sIndex] = mHighlightTextsToApply[sIndex];
		this["mHighlightTextsToApply"]["iLength"]++;
	}

	if (!bHasPendingDataRequest) {
		this["applyHighlightTexts"](this["iFirstVisibleContentRowIndex"], this["iVisibleContentRowCount"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setHighlightTexts"] = 0; };

/**
 * Applies the info set by "setHiglightTexts""
 *
 * @param {number} iStart The row start index
 * @param {number} iLength The range size of the rows which have to be applied
 * @private
 */
UCF_SapTableCS["prototype"]["applyHighlightTexts"] = function(iStart, iLength) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["applyHighlightTexts"]++; }; 
	if (!this["mHighlightTextsToApply"] || this["mHighlightTextsToApply"]["iLength"] == 0) {
		return;
	} else {
		var iApplied = 0,
			iTimer = new Date()["getTime"]();

		iStart += this["mHighlightTextsToApply"]["iRowIndexOffset"];

		for (var i = iStart, iEnd = iStart + iLength; i < iEnd; i++) {
			var aApplyInfos = this["mHighlightTextsToApply"][i];

			if (aApplyInfos) {
				var bSuccess = true;

				for (var j = 0; j < aApplyInfos["length"]; j++) {
					var oApplyInfo = aApplyInfos[j],
						oControl = this["oGetControlById"](oApplyInfo[0]);

					if (oControl) {
						oControl["setHighlightTextByIndex"](oApplyInfo[1], oApplyInfo[2], oApplyInfo[3], oApplyInfo[4], oApplyInfo[5]);
						iApplied++;
					} else { //HTML not yet applied. Skipping whole row
						bSuccess = false;
						break;
					}
				}

				if (bSuccess) {
					delete this["mHighlightTextsToApply"][i];
					this["mHighlightTextsToApply"]["iLength"]--;
				}

			}
		}

		if (iApplied) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, iApplied + " highlight texts applied within " + ((new Date()["getTime"]()) - iTimer) + "ms", "SapTableCS.js(3150): applyHighlightTexts"); };
		}

	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["applyHighlightTexts"] = 0; };

/**
 * Cleans up the highlight text environment
 *
 * @private
 */
UCF_SapTableCS["prototype"]["cleanUpHighlightTexts"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["cleanUpHighlightTexts"]++; }; 
	this["mHighlightTextsToApply"] = null;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["cleanUpHighlightTexts"] = 0; };

/******************************************************
 ** Internal APIs
 *******************************************************/

/**
 * Returns the matrix row index of the first scrollable cell
 *
 * @return {number}
 * @private
 */
UCF_SapTableCS["prototype"]["iGetContentRowOffset"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetContentRowOffset"]++; }; 
	return this["iContentRowOffset"];
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["iGetContentRowOffset"] = 0; };

/**
 * Activates native browser dragging by setting draggable attribute
 *
 * @private
 */
UCF_SapTableCS["prototype"]["setDraggableRows"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setDraggableRows"]++; }; 
	//overwrite empty to avoid calling in SapTable constructor
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setDraggableRows"] = 0; };

/**
 * Activates native browser dragging by setting draggable attribute
 *
 * @private
 */
UCF_SapTableCS["prototype"]["setDraggableRowsCS"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setDraggableRowsCS"]++; }; 
	this["setDraggableTr"]();
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setDraggableRowsCS"] = 0; };

/**
 * Sets draggable attribute at row level
 *
 * @private
 */
UCF_SapTableCS["prototype"]["setDraggableTr"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setDraggableTr"]++; }; 
	if (this["sGetRowRootDragSourceInfo"]()) {
		var oDragSourceInfo = this["oLS"]["oControlFactory"]["oGetControlById"](this["sGetRowRootDragSourceInfo"]());
		if (oDragSourceInfo && oDragSourceInfo["bBrowserDragDrop"]) {
			this["bDraggable"] = true;
			this["oDomRef"]["setAttribute"]("iDDThreshold", 10000);
			//set draggable attribute for all rows

			var aDomRefContentSegments = this["aDomRefSegmentMatrix"][2];
			for (var i = 0; i < aDomRefContentSegments["length"]; i++) {
				var oDomRefContentSegment = aDomRefContentSegments[i];
				if (oDomRefContentSegment) {
					var sDomRefContentSegmentId = oDomRefContentSegment["getAttribute"]("id"),
						oTableRef = UCF_DomUtil["$"](sDomRefContentSegmentId + "-content"),
						aTrRefs = oTableRef["rows"];
					for (var j = 0; j < aTrRefs["length"]; j++) {
						aTrRefs[j]["setAttribute"]("draggable", true);
					}
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setDraggableTr"] = 0; };

/**
 * Provide internal stuff for QUnit test recording and playback
 * @private
 * @return {Object}
 */
UCF_SapTableCS["prototype"]["oGetTestData"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetTestData"]++; }; 
	var o = UCF_SapTable.prototype["oGetTestData"]["apply"](this, arguments);

	o["internals"]["iRowHeight"] = this["iRowHeight"];
	o["internals"]["iContentRowCount"] = this["iContentRowCount"];
	o["internals"]["iVisibleContentRowCount"] = this["iVisibleContentRowCount"];

	return o;
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["oGetTestData"] = 0; };

/**
 * See UCF_Control.aGetTouchContextMenuEntries()
 * @private
 * @param {Object<string,number>} oEventData
 * @param {UCF_ControlInfo} [oSubControl]
 * @return {Array<{sType: ('TOOLTIP'|'TEXT'|'DATATIP'|'DOUBLECLICK'|'QUICKVIEW'), sText: string, fTrigger: function(): void}>}
 */
UCF_SapTableCS["prototype"]["aGetTouchContextMenuEntries"] = function(oEventData, oSubControl) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["aGetTouchContextMenuEntries"]++; }; 
	if (!this["bHasEventListeners"]('CellDoubleClick'))
		return [];

	var aResult = UCF_SapTable.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);

	var currentDomRef = oSubControl ? oSubControl["oDomRef"] : UCF_DomUtil["oGetElementFromPoint"](oEventData["iPageX"], oEventData["iPageY"]);
	while (this["oDomRef"] !== currentDomRef) {
		var cellInfo = this["oGetCellInfoByDomRef"](currentDomRef);
		if (cellInfo) {
			var _this = this;
			aResult["push"]({
				"sType": 'DOUBLECLICK',
				"sText": this["oLS"]["sGetText"]('SAPUR_POMN_CX_DLB_CLICK') || 'Trigger double click',
				"fTrigger": function() {
					_this["fireCellDoubleClick"](
						_this["sId"],
						_this["sGetCellId"](cellInfo),
						_this["EVENT_PARAM_MAP_CELL_TYPE"][_this["eGetCellType"](cellInfo)],
						_this["iGetApiRowIndex"](cellInfo),
						_this["iGetApiColIndex"](cellInfo),
						_this["sGetRowUserData"](cellInfo),
						_this["sGetCellUserData"](cellInfo),
						_this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]
					);
				}
			});

			return aResult;
		}

		currentDomRef = currentDomRef["parentNode"];
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["aGetTouchContextMenuEntries"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SapTableCS["prototype"]["aAttributeNames"] = ["sTooltip","sGridMode","sGapGrid","sSelectionColumnAction","bConfigurable","sAccessKey","sHotkeysId","sDefaultButtonId","iHorizontalScrollPosition","sVerticalPagerId","sRowSelectionMode","sRowSelectionClientBehaviour","sRowSelectionFollowFocus","iRowSelectionReferenceIndex","iRowSelectionRangeEndIndex","bRowSelectionMassOperation","sRowSelectionMassState","sRowsSelected","iSelectableRowCount","sColumnSelectionMode","sColumnSelectionClientBehaviour","iColumnSelectionReferenceIndex","iColumnSelectionRangeEndIndex","sRowCreationTrigger","sCellSelectionKeyboardTrigger","sCellSelectionMapping","sCellEventProcessing","sContentThemeScope","sNoDataNotification","sNoDataNotificationText","sRowRootDragSourceInfo","sRowRootDropTargetInfo","sColumnRootDragSourceInfo","sColumnRootDropTargetInfo","sCustomData","sCustomStyle","sVisibility","iHeadingLevel","sLabelledBy","sBlockSelection","bColumnTitleAdoption","sSelectionMassAction"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SapTableCS["prototype"]["aEventNames"] = ["RowSelect","ClientRowSelect","ColumnSelect","ClientColumnSelect","ClientPrimaryRowChange","Filter","CellSelect","CellDoubleClick","ColSort","HeaderCellSelect","HeaderActionMenuAccess","CellExpand","CellCollapse","CellIconSelect","SelectionMenuItemSelect","CellContextMenu","VerticalScroll","HorizontalScroll","ClipboardSelectionDataGet","ColumnReorder","ColumnResize","RowCreate","Hotkey","Drag","Drop","TableResize","Config","RequestData","DataCleanUp","CopyToClipboardRequest","BlockSelect"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SapTableCS["prototype"]["aMethodNames"] = ["setRowSelection","clearRowSelection","setCellSelection","setColumnSelection","getRowSelection","getCellSelection","getColumnSelection","setVisibleRowCount","setFirstVisibleRowIndex","getFocusInfoByIndex","openHeaderActionMenu","setDefaultButtonId","getColumnWidth","setColumnWidth","setRowRootDropTargetInfo","setRowRootDragSourceInfo","getColumnHeaderDropTargetInfo","setColumnHeaderDropTargetInfo","getColumnHeaderDragSourceInfo","setColumnHeaderDragSourceInfo","setDataCleanUpThreshold","setHighlightTexts","getCell","setBlockSelection","visualizeCopyToClipboard","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableGridMode}
 */
UCF_SapTableCS["prototype"]["sGridMode"] = "BOTH";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableGapGrid}
 */
UCF_SapTableCS["prototype"]["sGapGrid"] = "ALL";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableSelectionColumnAction}
 */
UCF_SapTableCS["prototype"]["sSelectionColumnAction"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableCS["prototype"]["bConfigurable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_SapTableCS["prototype"]["iHorizontalScrollPosition"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sVerticalPagerId"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableRowSelectionMode}
 */
UCF_SapTableCS["prototype"]["sRowSelectionMode"] = "SERVER";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableRowSelectionClientBehaviour}
 */
UCF_SapTableCS["prototype"]["sRowSelectionClientBehaviour"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableRowSelectionFollowFocus}
 */
UCF_SapTableCS["prototype"]["sRowSelectionFollowFocus"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_SapTableCS["prototype"]["iRowSelectionReferenceIndex"] = -2147483648;

/**
 * @private
 * @type {number}
 */
UCF_SapTableCS["prototype"]["iRowSelectionRangeEndIndex"] = -2147483648;

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableCS["prototype"]["bRowSelectionMassOperation"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableRowSelectionMassState}
 */
UCF_SapTableCS["prototype"]["sRowSelectionMassState"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sRowsSelected"] = '';

/**
 * @private
 * @type {number}
 */
UCF_SapTableCS["prototype"]["iSelectableRowCount"] = -1;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableColumnSelectionMode}
 */
UCF_SapTableCS["prototype"]["sColumnSelectionMode"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableColumnSelectionClientBehaviour}
 */
UCF_SapTableCS["prototype"]["sColumnSelectionClientBehaviour"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_SapTableCS["prototype"]["iColumnSelectionReferenceIndex"] = -2147483648;

/**
 * @private
 * @type {number}
 */
UCF_SapTableCS["prototype"]["iColumnSelectionRangeEndIndex"] = -2147483648;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableRowCreationTrigger}
 */
UCF_SapTableCS["prototype"]["sRowCreationTrigger"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellSelectionKeyboardTrigger}
 */
UCF_SapTableCS["prototype"]["sCellSelectionKeyboardTrigger"] = "SPACEBAR_ENTER";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellSelectionMapping}
 */
UCF_SapTableCS["prototype"]["sCellSelectionMapping"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellEventProcessing}
 */
UCF_SapTableCS["prototype"]["sCellEventProcessing"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sContentThemeScope"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableNoDataNotificationMode}
 */
UCF_SapTableCS["prototype"]["sNoDataNotification"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sNoDataNotificationText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sRowRootDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sRowRootDropTargetInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sColumnRootDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sColumnRootDropTargetInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_SapTableCS["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {number}
 */
UCF_SapTableCS["prototype"]["iHeadingLevel"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCS["prototype"]["sBlockSelection"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableCS["prototype"]["bColumnTitleAdoption"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableSelectionMassAction}
 */
UCF_SapTableCS["prototype"]["sSelectionMassAction"] = "ROW";

//#JSCOVER_EXCL_START
/** @protected */
UCF_SapTableCS["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sGridMode"] = "BOTH";
	this["sGapGrid"] = "ALL";
	this["sSelectionColumnAction"] = "NONE";
	this["bConfigurable"] = false;
	this["sAccessKey"] = '';
	this["sHotkeysId"] = '';
	this["sDefaultButtonId"] = '';
	this["iHorizontalScrollPosition"] = 0;
	this["sVerticalPagerId"] = '';
	this["sRowSelectionMode"] = "SERVER";
	this["sRowSelectionClientBehaviour"] = "NONE";
	this["sRowSelectionFollowFocus"] = "NONE";
	this["iRowSelectionReferenceIndex"] = -2147483648;
	this["iRowSelectionRangeEndIndex"] = -2147483648;
	this["bRowSelectionMassOperation"] = true;
	this["sRowSelectionMassState"] = "NONE";
	this["sRowsSelected"] = '';
	this["iSelectableRowCount"] = -1;
	this["sColumnSelectionMode"] = "NONE";
	this["sColumnSelectionClientBehaviour"] = "NONE";
	this["iColumnSelectionReferenceIndex"] = -2147483648;
	this["iColumnSelectionRangeEndIndex"] = -2147483648;
	this["sRowCreationTrigger"] = "NONE";
	this["sCellSelectionKeyboardTrigger"] = "SPACEBAR_ENTER";
	this["sCellSelectionMapping"] = "NONE";
	this["sCellEventProcessing"] = "STANDARD";
	this["sContentThemeScope"] = '';
	this["sNoDataNotification"] = "NONE";
	this["sNoDataNotificationText"] = '';
	this["sRowRootDragSourceInfo"] = '';
	this["sRowRootDropTargetInfo"] = '';
	this["sColumnRootDragSourceInfo"] = '';
	this["sColumnRootDropTargetInfo"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sVisibility"] = "VISIBLE";
	this["iHeadingLevel"] = 0;
	this["sLabelledBy"] = '';
	this["sBlockSelection"] = '';
	this["bColumnTitleAdoption"] = false;
	this["sSelectionMassAction"] = "ROW";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("GridMode", "BOTH", true);
		this["setClientProperty"]("GapGrid", "ALL", true);
		this["setClientProperty"]("SelectionColumnAction", "NONE", true);
		this["setClientProperty"]("Configurable", false, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("HorizontalScrollPosition", 0, true);
		this["setClientProperty"]("VerticalPagerId", '', true);
		this["setClientProperty"]("RowSelectionMode", "SERVER", true);
		this["setClientProperty"]("RowSelectionClientBehaviour", "NONE", true);
		this["setClientProperty"]("RowSelectionFollowFocus", "NONE", true);
		this["setClientProperty"]("RowSelectionReferenceIndex", -2147483648, true);
		this["setClientProperty"]("RowSelectionRangeEndIndex", -2147483648, true);
		this["setClientProperty"]("RowSelectionMassOperation", true, true);
		this["setClientProperty"]("RowSelectionMassState", "NONE", true);
		this["setClientProperty"]("RowsSelected", '', true);
		this["setClientProperty"]("SelectableRowCount", -1, true);
		this["setClientProperty"]("ColumnSelectionMode", "NONE", true);
		this["setClientProperty"]("ColumnSelectionClientBehaviour", "NONE", true);
		this["setClientProperty"]("ColumnSelectionReferenceIndex", -2147483648, true);
		this["setClientProperty"]("ColumnSelectionRangeEndIndex", -2147483648, true);
		this["setClientProperty"]("RowCreationTrigger", "NONE", true);
		this["setClientProperty"]("CellSelectionKeyboardTrigger", "SPACEBAR_ENTER", true);
		this["setClientProperty"]("CellSelectionMapping", "NONE", true);
		this["setClientProperty"]("CellEventProcessing", "STANDARD", true);
		this["setClientProperty"]("ContentThemeScope", '', true);
		this["setClientProperty"]("NoDataNotification", "NONE", true);
		this["setClientProperty"]("NoDataNotificationText", '', true);
		this["setClientProperty"]("RowRootDragSourceInfo", '', true);
		this["setClientProperty"]("RowRootDropTargetInfo", '', true);
		this["setClientProperty"]("ColumnRootDragSourceInfo", '', true);
		this["setClientProperty"]("ColumnRootDropTargetInfo", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("HeadingLevel", 0, true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("BlockSelection", '', true);
		this["setClientProperty"]("ColumnTitleAdoption", false, true);
		this["setClientProperty"]("SelectionMassAction", "ROW", true);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iRowIndex Row index of the selected row
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select , TOGGLE for a selection toggle, DESELECT_ALL for deselction of all rows, SELECT_ALL for selcetion of all rows
 * @param {string} sTriggerCellId The id of the cell which triggered the row select
 * @param {string} sTriggerAction The action which triggers the select event. MOUSE for mouse triggered direct selection, SPACE/ENTER for keyboard triggered direct selection, FOCUS for focus triggered implicit selection (see property RowSelectionFollowFocus)
 * @fires SapTableCS::RowSelect
 */
UCF_SapTableCS["prototype"]["fireRowSelect"] = function(sId, iRowIndex, sRowUserData, sCellUserData, sAccessType, sTriggerCellId, sTriggerAction) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireRowSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number, RowUserData: string, CellUserData: string, AccessType: string, TriggerCellId: string, TriggerAction: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "SapTableCS.js(3665): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(3666): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(3667): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTableCS.js(3668): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTableCS.js(3669): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTableCS.js(3670): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTableCS.js(3671): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(3672): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(3673): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTableCS.js(3674): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTableCS.js(3675): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTriggerCellId != null, "sTriggerCellId != null", "SapTableCS.js(3676): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTriggerCellId) == "string", "typeof(sTriggerCellId) == \"string\"", "SapTableCS.js(3677): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTriggerAction != null, "sTriggerAction != null", "SapTableCS.js(3678): fireRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTriggerAction) == "string", "typeof(sTriggerAction) == \"string\"", "SapTableCS.js(3679): fireRowSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"AccessType": sAccessType,
		"TriggerCellId": sTriggerCellId,
		"TriggerAction": sTriggerAction
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "RowSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireRowSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iRowIndex Row index of the selected row
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select , TOGGLE for a selection toggle, DESELECT_ALL for deselction of all rows, SELECT_ALL for selcetion of all rows
 * @param {string} sTriggerCellId The id of the cell which triggered the row select
 * @param {string} sTriggerAction The action which triggers the select event. MOUSE for mouse triggered direct selection, SPACE/ENTER for keyboard triggered direct selection, FOCUS for focus triggered implicit selection (see property RowSelectionFollowFocus)
 * @fires SapTableCS::ClientRowSelect
 */
UCF_SapTableCS["prototype"]["fireClientRowSelect"] = function(sId, iRowIndex, sRowUserData, sCellUserData, sAccessType, sTriggerCellId, sTriggerAction) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireClientRowSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number, RowUserData: string, CellUserData: string, AccessType: string, TriggerCellId: string, TriggerAction: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "SapTableCS.js(3714): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(3715): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(3716): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTableCS.js(3717): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTableCS.js(3718): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTableCS.js(3719): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTableCS.js(3720): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(3721): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(3722): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTableCS.js(3723): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTableCS.js(3724): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTriggerCellId != null, "sTriggerCellId != null", "SapTableCS.js(3725): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTriggerCellId) == "string", "typeof(sTriggerCellId) == \"string\"", "SapTableCS.js(3726): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTriggerAction != null, "sTriggerAction != null", "SapTableCS.js(3727): fireClientRowSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTriggerAction) == "string", "typeof(sTriggerAction) == \"string\"", "SapTableCS.js(3728): fireClientRowSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"AccessType": sAccessType,
		"TriggerCellId": sTriggerCellId,
		"TriggerAction": sTriggerAction
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "ClientRowSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireClientRowSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iColIndex Column index of the selected column
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select , TOGGLE for a selection toggle
 * @param {string} sTriggerCellId The id of the cell which triggered the column select
 * @fires SapTableCS::ColumnSelect
 */
UCF_SapTableCS["prototype"]["fireColumnSelect"] = function(sId, iColIndex, sCellUserData, sAccessType, sTriggerCellId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireColumnSelect"]++; }; 
	/** @type {{Id: string, ColIndex: number, CellUserData: string, AccessType: string, TriggerCellId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "SapTableCS.js(3761): fireColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(3762): fireColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(3763): fireColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTableCS.js(3764): fireColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTableCS.js(3765): fireColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(3766): fireColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(3767): fireColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTableCS.js(3768): fireColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTableCS.js(3769): fireColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTriggerCellId != null, "sTriggerCellId != null", "SapTableCS.js(3770): fireColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTriggerCellId) == "string", "typeof(sTriggerCellId) == \"string\"", "SapTableCS.js(3771): fireColumnSelect"); };
	mParams = {
		"Id": sId,
		"ColIndex": iColIndex,
		"CellUserData": sCellUserData,
		"AccessType": sAccessType,
		"TriggerCellId": sTriggerCellId
	};
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "ColumnSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireColumnSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iColIndex Column index of the selected column
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select , TOGGLE for a selection toggle
 * @param {string} sTriggerCellId The id of the cell which triggered the column select
 * @fires SapTableCS::ClientColumnSelect
 */
UCF_SapTableCS["prototype"]["fireClientColumnSelect"] = function(sId, iColIndex, sCellUserData, sAccessType, sTriggerCellId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireClientColumnSelect"]++; }; 
	/** @type {{Id: string, ColIndex: number, CellUserData: string, AccessType: string, TriggerCellId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "SapTableCS.js(3800): fireClientColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(3801): fireClientColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(3802): fireClientColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTableCS.js(3803): fireClientColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTableCS.js(3804): fireClientColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(3805): fireClientColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(3806): fireClientColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTableCS.js(3807): fireClientColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTableCS.js(3808): fireClientColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTriggerCellId != null, "sTriggerCellId != null", "SapTableCS.js(3809): fireClientColumnSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTriggerCellId) == "string", "typeof(sTriggerCellId) == \"string\"", "SapTableCS.js(3810): fireClientColumnSelect"); };
	mParams = {
		"Id": sId,
		"ColIndex": iColIndex,
		"CellUserData": sCellUserData,
		"AccessType": sAccessType,
		"TriggerCellId": sTriggerCellId
	};
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "ClientColumnSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireClientColumnSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @fires SapTableCS::ClientPrimaryRowChange
 */
UCF_SapTableCS["prototype"]["fireClientPrimaryRowChange"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireClientPrimaryRowChange"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "SapTableCS.js(3835): fireClientPrimaryRowChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(3836): fireClientPrimaryRowChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(3837): fireClientPrimaryRowChange"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("SapTableCS", "ClientPrimaryRowChange", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireClientPrimaryRowChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier cell which covers the filter icon
 * @fires SapTableCS::Filter
 */
UCF_SapTableCS["prototype"]["fireFilter"] = function(sId, sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireFilter"]++; }; 
	/** @type {{Id: string, CellId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "SapTableCS.js(3855): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(3856): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(3857): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(3858): fireFilter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(3859): fireFilter"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId
	};
	
	
	this["fireSemanticEvent"]("SapTableCS", "Filter", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireFilter"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the selected cell
 * @param {string} sCellType The type of the selected cell
 * @param {number} iRowIndex Row index of the selected cell
 * @param {number} iColIndex Column index of the selected cell
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select, TOGGLE for a sort toggle
 * @fires SapTableCS::CellSelect
 */
UCF_SapTableCS["prototype"]["fireCellSelect"] = function(sId, sCellId, sCellType, iRowIndex, iColIndex, sRowUserData, sCellUserData, sAccessType) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellSelect"]++; }; 
	/** @type {{Id: string, CellId: string, CellType: string, RowIndex: number, ColIndex: number, RowUserData: string, CellUserData: string, AccessType: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 8, "arguments.length == 8", "SapTableCS.js(3885): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(3886): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(3887): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(3888): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(3889): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellType != null, "sCellType != null", "SapTableCS.js(3890): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellType) == "string", "typeof(sCellType) == \"string\"", "SapTableCS.js(3891): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTableCS.js(3892): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTableCS.js(3893): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTableCS.js(3894): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTableCS.js(3895): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTableCS.js(3896): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTableCS.js(3897): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(3898): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(3899): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTableCS.js(3900): fireCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTableCS.js(3901): fireCellSelect"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"CellType": sCellType,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"AccessType": sAccessType
	};
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "CellSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the selected cell
 * @param {string} sCellType The type of the selected cell
 * @param {number} iRowIndex Row index of the selected cell
 * @param {number} iColIndex Column index of the selected cell
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select, TOGGLE for a sort toggle
 * @fires SapTableCS::CellDoubleClick
 */
UCF_SapTableCS["prototype"]["fireCellDoubleClick"] = function(sId, sCellId, sCellType, iRowIndex, iColIndex, sRowUserData, sCellUserData, sAccessType) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellDoubleClick"]++; }; 
	/** @type {{Id: string, CellId: string, CellType: string, RowIndex: number, ColIndex: number, RowUserData: string, CellUserData: string, AccessType: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 8, "arguments.length == 8", "SapTableCS.js(3939): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(3940): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(3941): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(3942): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(3943): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellType != null, "sCellType != null", "SapTableCS.js(3944): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellType) == "string", "typeof(sCellType) == \"string\"", "SapTableCS.js(3945): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTableCS.js(3946): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTableCS.js(3947): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTableCS.js(3948): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTableCS.js(3949): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTableCS.js(3950): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTableCS.js(3951): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(3952): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(3953): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTableCS.js(3954): fireCellDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTableCS.js(3955): fireCellDoubleClick"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"CellType": sCellType,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"AccessType": sAccessType
	};
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "CellDoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the selected cell
 * @param {string} sAccessType The type of access which lead to the sort event. STANDARD for the standard access, TOGGLE for a selection toggle
 * @fires SapTableCS::ColSort
 */
UCF_SapTableCS["prototype"]["fireColSort"] = function(sId, sCellId, sAccessType) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireColSort"]++; }; 
	/** @type {{Id: string, CellId: string, AccessType: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "SapTableCS.js(3988): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(3989): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(3990): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(3991): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(3992): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTableCS.js(3993): fireColSort"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTableCS.js(3994): fireColSort"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"AccessType": sAccessType
	};
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "ColSort", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireColSort"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the selected cell
 * @param {number} iColIndex Column index of the selected cell
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select, TOGGLE for a selection toggle
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @fires SapTableCS::HeaderCellSelect
 */
UCF_SapTableCS["prototype"]["fireHeaderCellSelect"] = function(sId, sCellId, iColIndex, sAccessType, sCellUserData) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireHeaderCellSelect"]++; }; 
	/** @type {{Id: string, CellId: string, ColIndex: number, AccessType: string, CellUserData: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "SapTableCS.js(4019): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4020): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4021): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(4022): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(4023): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTableCS.js(4024): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTableCS.js(4025): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTableCS.js(4026): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTableCS.js(4027): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(4028): fireHeaderCellSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(4029): fireHeaderCellSelect"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"ColIndex": iColIndex,
		"AccessType": sAccessType,
		"CellUserData": sCellUserData
	};
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "HeaderCellSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireHeaderCellSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the header cell
 * @param {boolean} bWithKeyboard Determine if menu is opened by keyboard or mouse user interaction
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @fires SapTableCS::HeaderActionMenuAccess
 */
UCF_SapTableCS["prototype"]["fireHeaderActionMenuAccess"] = function(sId, sCellId, bWithKeyboard, sCellUserData) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireHeaderActionMenuAccess"]++; }; 
	/** @type {{Id: string, CellId: string, WithKeyboard: boolean, CellUserData: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "SapTableCS.js(4057): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4058): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4059): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(4060): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(4061): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bWithKeyboard != null, "bWithKeyboard != null", "SapTableCS.js(4062): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bWithKeyboard) == "boolean", "typeof(bWithKeyboard) == \"boolean\"", "SapTableCS.js(4063): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(4064): fireHeaderActionMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(4065): fireHeaderActionMenuAccess"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"WithKeyboard": bWithKeyboard,
		"CellUserData": sCellUserData
	};
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "HeaderActionMenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireHeaderActionMenuAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iRowIndex Row index of the selected cell
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sCellId Identifier of the selected cell
 * @fires SapTableCS::CellExpand
 */
UCF_SapTableCS["prototype"]["fireCellExpand"] = function(sId, iRowIndex, sRowUserData, sCellUserData, sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellExpand"]++; }; 
	/** @type {{Id: string, RowIndex: number, RowUserData: string, CellUserData: string, CellId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "SapTableCS.js(4092): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4093): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4094): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTableCS.js(4095): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTableCS.js(4096): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTableCS.js(4097): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTableCS.js(4098): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(4099): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(4100): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(4101): fireCellExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(4102): fireCellExpand"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"CellId": sCellId
	};
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "CellExpand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellExpand"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iRowIndex Row index of the selected cell
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sCellId Identifier of the selected cell
 * @fires SapTableCS::CellCollapse
 */
UCF_SapTableCS["prototype"]["fireCellCollapse"] = function(sId, iRowIndex, sRowUserData, sCellUserData, sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellCollapse"]++; }; 
	/** @type {{Id: string, RowIndex: number, RowUserData: string, CellUserData: string, CellId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "SapTableCS.js(4131): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4132): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4133): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTableCS.js(4134): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTableCS.js(4135): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTableCS.js(4136): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTableCS.js(4137): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(4138): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(4139): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(4140): fireCellCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(4141): fireCellCollapse"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"CellId": sCellId
	};
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "CellCollapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iRowIndex Row index of the selected cell
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {string} sCellId Identifier of the selected cell
 * @fires SapTableCS::CellIconSelect
 */
UCF_SapTableCS["prototype"]["fireCellIconSelect"] = function(sId, iRowIndex, sRowUserData, sCellUserData, sCellId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellIconSelect"]++; }; 
	/** @type {{Id: string, RowIndex: number, RowUserData: string, CellUserData: string, CellId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "SapTableCS.js(4170): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4171): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4172): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTableCS.js(4173): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTableCS.js(4174): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTableCS.js(4175): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTableCS.js(4176): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(4177): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(4178): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(4179): fireCellIconSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(4180): fireCellIconSelect"); };
	mParams = {
		"Id": sId,
		"RowIndex": iRowIndex,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"CellId": sCellId
	};
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "CellIconSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellIconSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sMenuItemId Identifier of the PopupMenuItem
 * @fires SapTableCS::SelectionMenuItemSelect
 */
UCF_SapTableCS["prototype"]["fireSelectionMenuItemSelect"] = function(sId, sMenuItemId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireSelectionMenuItemSelect"]++; }; 
	/** @type {{Id: string, MenuItemId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "SapTableCS.js(4206): fireSelectionMenuItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4207): fireSelectionMenuItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4208): fireSelectionMenuItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMenuItemId != null, "sMenuItemId != null", "SapTableCS.js(4209): fireSelectionMenuItemSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMenuItemId) == "string", "typeof(sMenuItemId) == \"string\"", "SapTableCS.js(4210): fireSelectionMenuItemSelect"); };
	mParams = {
		"Id": sId,
		"MenuItemId": sMenuItemId
	};
	
	
	this["fireSemanticEvent"]("SapTableCS", "SelectionMenuItemSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireSelectionMenuItemSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the affected cell
 * @param {number} iRowIndex Row index of the affected cell
 * @param {number} iColIndex Column index of the affected cell
 * @param {number} iPosX Horizontal mouse pointer position
 * @param {number} iPosY Vertical mouse pointer position
 * @param {string} sRowUserData The user data which is provided by the SapTableRow control
 * @param {string} sCellUserData The user data which is provided by the SapTable*Cell control
 * @param {boolean} bShift True if the SHIFT modifier is pressed
 * @param {boolean} bCtrl True if the CTRL modifier is pressed
 * @param {boolean} bAlt True if the ALT modifier is pressed
 * @fires SapTableCS::CellContextMenu
 */
UCF_SapTableCS["prototype"]["fireCellContextMenu"] = function(sId, sCellId, iRowIndex, iColIndex, iPosX, iPosY, sRowUserData, sCellUserData, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellContextMenu"]++; }; 
	/** @type {{Id: string, CellId: string, RowIndex: number, ColIndex: number, PosX: number, PosY: number, RowUserData: string, CellUserData: string, Shift: boolean, Ctrl: boolean, Alt: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 11, "arguments.length == 11", "SapTableCS.js(4239): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4240): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4241): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(4242): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(4243): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTableCS.js(4244): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTableCS.js(4245): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTableCS.js(4246): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTableCS.js(4247): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "SapTableCS.js(4248): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "SapTableCS.js(4249): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "SapTableCS.js(4250): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "SapTableCS.js(4251): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRowUserData != null, "sRowUserData != null", "SapTableCS.js(4252): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRowUserData) == "string", "typeof(sRowUserData) == \"string\"", "SapTableCS.js(4253): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellUserData != null, "sCellUserData != null", "SapTableCS.js(4254): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellUserData) == "string", "typeof(sCellUserData) == \"string\"", "SapTableCS.js(4255): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "SapTableCS.js(4256): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "SapTableCS.js(4257): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "SapTableCS.js(4258): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "SapTableCS.js(4259): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "SapTableCS.js(4260): fireCellContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "SapTableCS.js(4261): fireCellContextMenu"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex,
		"PosX": iPosX,
		"PosY": iPosY,
		"RowUserData": sRowUserData,
		"CellUserData": sCellUserData,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt
	};
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "CellContextMenu", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCellContextMenu"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iFirstVisibleItemIndex The index of the item to which was scrolled to
 * @param {string} sAction The action which lead to the scroll event: NONE, PREVIOUS, NEXT, BEGIN, END, NEXT_PAGE, PREVIOUS_PAGE, DIRECT
 * @param {string} sCellId Identifier of the cell which received the focus while scrolling process
 * @param {string} sAccessType The type of access which lead to the scroll event. SCROLLBAR for a direct scrollbar access and  EXTERNAL for a method call from a none-scrollbar control like the table itself
 * @param {boolean} bSelectionFollowFocus True if the scrolling should also affect the selected row
 * @param {boolean} bShift True if the SIFT modifier is pressed
 * @param {boolean} bCtrl True if the CTRL modifier is pressed
 * @param {boolean} bAlt True if the ALT modifier is pressed
 * @fires SapTableCS::VerticalScroll
 */
UCF_SapTableCS["prototype"]["fireVerticalScroll"] = function(sId, iFirstVisibleItemIndex, sAction, sCellId, sAccessType, bSelectionFollowFocus, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireVerticalScroll"]++; }; 
	/** @type {{Id: string, FirstVisibleItemIndex: number, Action: string, CellId: string, AccessType: string, SelectionFollowFocus: boolean, Shift: boolean, Ctrl: boolean, Alt: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 9, "arguments.length == 9", "SapTableCS.js(4306): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4307): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4308): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleItemIndex != null, "iFirstVisibleItemIndex != null", "SapTableCS.js(4309): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleItemIndex) == "number", "typeof(iFirstVisibleItemIndex) == \"number\"", "SapTableCS.js(4310): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAction != null, "sAction != null", "SapTableCS.js(4311): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAction) == "string", "typeof(sAction) == \"string\"", "SapTableCS.js(4312): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(4313): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(4314): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTableCS.js(4315): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTableCS.js(4316): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bSelectionFollowFocus != null, "bSelectionFollowFocus != null", "SapTableCS.js(4317): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bSelectionFollowFocus) == "boolean", "typeof(bSelectionFollowFocus) == \"boolean\"", "SapTableCS.js(4318): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "SapTableCS.js(4319): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "SapTableCS.js(4320): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "SapTableCS.js(4321): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "SapTableCS.js(4322): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "SapTableCS.js(4323): fireVerticalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "SapTableCS.js(4324): fireVerticalScroll"); };
	mParams = {
		"Id": sId,
		"FirstVisibleItemIndex": iFirstVisibleItemIndex,
		"Action": sAction,
		"CellId": sCellId,
		"AccessType": sAccessType,
		"SelectionFollowFocus": bSelectionFollowFocus,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt
	};
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "VerticalScroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireVerticalScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iFirstVisibleItemIndex The index of the item to which was scrolled to
 * @param {string} sAction The action which lead to the scroll event: NONE, PREVIOUS, NEXT, BEGIN, END, NEXT_PAGE, PREVIOUS_PAGE, DIRECT
 * @param {string} sAccessType The type of access which lead to the scroll event. SCROLLBAR for a direct scrollbar access and  EXTERNAL for a method call from a none-scrollbar control like the table itself
 * @param {boolean} bShift True if the SIFT modifier is pressed
 * @param {boolean} bCtrl True if the CTRL modifier is pressed
 * @param {boolean} bAlt True if the ALT modifier is pressed
 * @fires SapTableCS::HorizontalScroll
 */
UCF_SapTableCS["prototype"]["fireHorizontalScroll"] = function(sId, iFirstVisibleItemIndex, sAction, sAccessType, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireHorizontalScroll"]++; }; 
	/** @type {{Id: string, FirstVisibleItemIndex: number, Action: string, AccessType: string, Shift: boolean, Ctrl: boolean, Alt: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "SapTableCS.js(4363): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4364): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4365): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleItemIndex != null, "iFirstVisibleItemIndex != null", "SapTableCS.js(4366): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleItemIndex) == "number", "typeof(iFirstVisibleItemIndex) == \"number\"", "SapTableCS.js(4367): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAction != null, "sAction != null", "SapTableCS.js(4368): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAction) == "string", "typeof(sAction) == \"string\"", "SapTableCS.js(4369): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTableCS.js(4370): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTableCS.js(4371): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "SapTableCS.js(4372): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "SapTableCS.js(4373): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "SapTableCS.js(4374): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "SapTableCS.js(4375): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "SapTableCS.js(4376): fireHorizontalScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "SapTableCS.js(4377): fireHorizontalScroll"); };
	mParams = {
		"Id": sId,
		"FirstVisibleItemIndex": iFirstVisibleItemIndex,
		"Action": sAction,
		"AccessType": sAccessType,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "HorizontalScroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireHorizontalScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires SapTableCS::ClipboardSelectionDataGet
 */
UCF_SapTableCS["prototype"]["fireClipboardSelectionDataGet"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireClipboardSelectionDataGet"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "SapTableCS.js(4406): fireClipboardSelectionDataGet"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4407): fireClipboardSelectionDataGet"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4408): fireClipboardSelectionDataGet"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("SapTableCS", "ClipboardSelectionDataGet", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireClipboardSelectionDataGet"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sMovedColId Identifier of the table column which was dragged
 * @param {string} sRefColId Identifier of the table column next to the position the MovedColumn was dropped
 * @param {string} sInsertMode Determines if the MovedColumn was dropped before or after the RefColumn. Possible values are 'AFTER' or 'BEFORE'
 * @fires SapTableCS::ColumnReorder
 */
UCF_SapTableCS["prototype"]["fireColumnReorder"] = function(sId, sMovedColId, sRefColId, sInsertMode) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireColumnReorder"]++; }; 
	/** @type {{Id: string, MovedColId: string, RefColId: string, InsertMode: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "SapTableCS.js(4428): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4429): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4430): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMovedColId != null, "sMovedColId != null", "SapTableCS.js(4431): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMovedColId) == "string", "typeof(sMovedColId) == \"string\"", "SapTableCS.js(4432): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sRefColId != null, "sRefColId != null", "SapTableCS.js(4433): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sRefColId) == "string", "typeof(sRefColId) == \"string\"", "SapTableCS.js(4434): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sInsertMode != null, "sInsertMode != null", "SapTableCS.js(4435): fireColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sInsertMode) == "string", "typeof(sInsertMode) == \"string\"", "SapTableCS.js(4436): fireColumnReorder"); };
	mParams = {
		"Id": sId,
		"MovedColId": sMovedColId,
		"RefColId": sRefColId,
		"InsertMode": sInsertMode
	};
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "ColumnReorder", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireColumnReorder"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCellId Identifier of the affected cell
 * @param {string} sWidth The new width including its css unit or '' if not provided. This is only provided when the table columns withs are not table based. In this case only one width can be affected by a column resize operation
 * @param {string} sWidths All widths of all columns. This is only provided when the table has a new table based width configuration. In this case more than one column can be affected by a column resize operation
 * @fires SapTableCS::ColumnResize
 */
UCF_SapTableCS["prototype"]["fireColumnResize"] = function(sId, sCellId, sWidth, sWidths) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireColumnResize"]++; }; 
	/** @type {{Id: string, CellId: string, Width: string, Widths: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "SapTableCS.js(4462): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4463): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4464): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "SapTableCS.js(4465): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "SapTableCS.js(4466): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sWidth != null, "sWidth != null", "SapTableCS.js(4467): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sWidth) == "string", "typeof(sWidth) == \"string\"", "SapTableCS.js(4468): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sWidths != null, "sWidths != null", "SapTableCS.js(4469): fireColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sWidths) == "string", "typeof(sWidths) == \"string\"", "SapTableCS.js(4470): fireColumnResize"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"Width": sWidth,
		"Widths": sWidths
	};
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "ColumnResize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireColumnResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iColIndex Column index of the trigger cell
 * @param {number} iInsertAt The expected new row index of the newly created row
 * @fires SapTableCS::RowCreate
 */
UCF_SapTableCS["prototype"]["fireRowCreate"] = function(sId, iColIndex, iInsertAt) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireRowCreate"]++; }; 
	/** @type {{Id: string, ColIndex: number, InsertAt: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "SapTableCS.js(4495): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4496): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4497): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTableCS.js(4498): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTableCS.js(4499): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iInsertAt != null, "iInsertAt != null", "SapTableCS.js(4500): fireRowCreate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iInsertAt) == "number", "typeof(iInsertAt) == \"number\"", "SapTableCS.js(4501): fireRowCreate"); };
	mParams = {
		"Id": sId,
		"ColIndex": iColIndex,
		"InsertAt": iInsertAt
	};
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "RowCreate", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireRowCreate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires SapTableCS::Hotkey
 */
UCF_SapTableCS["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "SapTableCS.js(4524): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4525): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4526): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "SapTableCS.js(4527): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "SapTableCS.js(4528): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "SapTableCS.js(4529): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "SapTableCS.js(4530): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireHotkey"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires SapTableCS::Drag
 */
UCF_SapTableCS["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "SapTableCS.js(4553): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4554): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4555): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "SapTableCS.js(4556): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "SapTableCS.js(4557): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "SapTableCS.js(4558): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "SapTableCS.js(4559): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sDropTargetCellId Identifier of the dropped cell
 * @param {number} iRowIndex The row index of the table cell where the drop occurred
 * @param {number} iColIndex The col index of the table cell where the drop occurred
 * @param {string} sDirection 'HORIZONTAL', 'VERTICAL' or 'NONE'
 * @param {number} iOffset The offset relative to the target segment of the table (e.g. row ) where the drop occurred (signum). -1 means insert before, +1 means insert after and 0 means drop (no insert)
 * @param {number} iHierarchyLevel The hierarchy level of the drop cell starting with 0=root. -1 means no hierarchy available.
 * @param {string} sData Arbitrary data which has been provided by the drag event response of the using framework
 * @param {string} sMimeType Mime type of the data provided by tthe drag event response of the using framework
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires SapTableCS::Drop
 */
UCF_SapTableCS["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, sDropTargetCellId, iRowIndex, iColIndex, sDirection, iOffset, iHierarchyLevel, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, DropTargetCellId: string, RowIndex: number, ColIndex: number, Direction: string, Offset: number, HierarchyLevel: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 16, "arguments.length == 16", "SapTableCS.js(4595): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4596): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4597): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "SapTableCS.js(4598): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "SapTableCS.js(4599): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "SapTableCS.js(4600): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "SapTableCS.js(4601): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetCellId != null, "sDropTargetCellId != null", "SapTableCS.js(4602): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetCellId) == "string", "typeof(sDropTargetCellId) == \"string\"", "SapTableCS.js(4603): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iRowIndex != null, "iRowIndex != null", "SapTableCS.js(4604): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iRowIndex) == "number", "typeof(iRowIndex) == \"number\"", "SapTableCS.js(4605): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColIndex != null, "iColIndex != null", "SapTableCS.js(4606): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColIndex) == "number", "typeof(iColIndex) == \"number\"", "SapTableCS.js(4607): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDirection != null, "sDirection != null", "SapTableCS.js(4608): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDirection) == "string", "typeof(sDirection) == \"string\"", "SapTableCS.js(4609): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOffset != null, "iOffset != null", "SapTableCS.js(4610): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOffset) == "number", "typeof(iOffset) == \"number\"", "SapTableCS.js(4611): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iHierarchyLevel != null, "iHierarchyLevel != null", "SapTableCS.js(4612): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iHierarchyLevel) == "number", "typeof(iHierarchyLevel) == \"number\"", "SapTableCS.js(4613): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "SapTableCS.js(4614): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "SapTableCS.js(4615): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "SapTableCS.js(4616): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "SapTableCS.js(4617): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "SapTableCS.js(4618): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "SapTableCS.js(4619): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "SapTableCS.js(4620): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "SapTableCS.js(4621): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "SapTableCS.js(4622): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "SapTableCS.js(4623): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "SapTableCS.js(4624): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "SapTableCS.js(4625): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "SapTableCS.js(4626): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "SapTableCS.js(4627): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"DropTargetCellId": sDropTargetCellId,
		"RowIndex": iRowIndex,
		"ColIndex": iColIndex,
		"Direction": sDirection,
		"Offset": iOffset,
		"HierarchyLevel": iHierarchyLevel,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {number} iVisibleContentRowCount 
 * @fires SapTableCS::TableResize
 */
UCF_SapTableCS["prototype"]["fireTableResize"] = function(sId, iVisibleContentRowCount) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireTableResize"]++; }; 
	/** @type {{Id: string, VisibleContentRowCount: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "SapTableCS.js(4675): fireTableResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4676): fireTableResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4677): fireTableResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iVisibleContentRowCount != null, "iVisibleContentRowCount != null", "SapTableCS.js(4678): fireTableResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iVisibleContentRowCount) == "number", "typeof(iVisibleContentRowCount) == \"number\"", "SapTableCS.js(4679): fireTableResize"); };
	mParams = {
		"Id": sId,
		"VisibleContentRowCount": iVisibleContentRowCount
	};
	
	
	this["fireSemanticEvent"]("SapTableCS", "TableResize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireTableResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @fires SapTableCS::Config
 */
UCF_SapTableCS["prototype"]["fireConfig"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireConfig"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "SapTableCS.js(4698): fireConfig"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4699): fireConfig"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4700): fireConfig"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("SapTableCS", "Config", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireConfig"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sDataFragments A string which contains the fragments to be requested. (from1,to1;from2,to2; ...) e.g. '15,19;25,30;' 
 * @param {number} iFirstVisibleContentRowIndex 
 * @param {number} iVisibleContentRowCount 
 * @fires SapTableCS::RequestData
 */
UCF_SapTableCS["prototype"]["fireRequestData"] = function(sId, sDataFragments, iFirstVisibleContentRowIndex, iVisibleContentRowCount) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireRequestData"]++; }; 
	/** @type {{Id: string, DataFragments: string, FirstVisibleContentRowIndex: number, VisibleContentRowCount: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "SapTableCS.js(4720): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4721): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4722): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDataFragments != null, "sDataFragments != null", "SapTableCS.js(4723): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDataFragments) == "string", "typeof(sDataFragments) == \"string\"", "SapTableCS.js(4724): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleContentRowIndex != null, "iFirstVisibleContentRowIndex != null", "SapTableCS.js(4725): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleContentRowIndex) == "number", "typeof(iFirstVisibleContentRowIndex) == \"number\"", "SapTableCS.js(4726): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iVisibleContentRowCount != null, "iVisibleContentRowCount != null", "SapTableCS.js(4727): fireRequestData"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iVisibleContentRowCount) == "number", "typeof(iVisibleContentRowCount) == \"number\"", "SapTableCS.js(4728): fireRequestData"); };
	mParams = {
		"Id": sId,
		"DataFragments": sDataFragments,
		"FirstVisibleContentRowIndex": iFirstVisibleContentRowIndex,
		"VisibleContentRowCount": iVisibleContentRowCount
	};
	
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "RequestData", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireRequestData"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @fires SapTableCS::DataCleanUp
 */
UCF_SapTableCS["prototype"]["fireDataCleanUp"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireDataCleanUp"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "SapTableCS.js(4751): fireDataCleanUp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4752): fireDataCleanUp"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4753): fireDataCleanUp"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("SapTableCS", "DataCleanUp", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireDataCleanUp"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sCurrentSelectionText The current text selection within the window
 * @fires SapTableCS::CopyToClipboardRequest
 */
UCF_SapTableCS["prototype"]["fireCopyToClipboardRequest"] = function(sId, sCurrentSelectionText) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCopyToClipboardRequest"]++; }; 
	/** @type {{Id: string, CurrentSelectionText: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "SapTableCS.js(4771): fireCopyToClipboardRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4772): fireCopyToClipboardRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4773): fireCopyToClipboardRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCurrentSelectionText != null, "sCurrentSelectionText != null", "SapTableCS.js(4774): fireCopyToClipboardRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCurrentSelectionText) == "string", "typeof(sCurrentSelectionText) == \"string\"", "SapTableCS.js(4775): fireCopyToClipboardRequest"); };
	mParams = {
		"Id": sId,
		"CurrentSelectionText": sCurrentSelectionText
	};
	
	
	this["fireSemanticEvent"]("SapTableCS", "CopyToClipboardRequest", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireCopyToClipboardRequest"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of table
 * @param {string} sBlockSelection BlockSelection Range (for example: {'TopLeftCol': 1, 'TopLeftRow': 1, 'BottomRightCol': 4, 'BottomRightRow': 4, 'RefCol': 1, 'RefRow': 1})
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the setting a block (former blocks/selections get erased), TOGGLE for adding a block (former blocks/selections are kept)
 * @fires SapTableCS::BlockSelect
 */
UCF_SapTableCS["prototype"]["fireBlockSelect"] = function(sId, sBlockSelection, sAccessType) {;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireBlockSelect"]++; }; 
	/** @type {{Id: string, BlockSelection: string, AccessType: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "SapTableCS.js(4796): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SapTableCS.js(4797): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SapTableCS.js(4798): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sBlockSelection != null, "sBlockSelection != null", "SapTableCS.js(4799): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sBlockSelection) == "string", "typeof(sBlockSelection) == \"string\"", "SapTableCS.js(4800): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "SapTableCS.js(4801): fireBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "SapTableCS.js(4802): fireBlockSelect"); };
	mParams = {
		"Id": sId,
		"BlockSelection": sBlockSelection,
		"AccessType": sAccessType
	};
	
	
	
	this["fireSemanticEvent"]("SapTableCS", "BlockSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SapTableCS["_"]["fireBlockSelect"] = 0; };

UCF_SapTableCS.prototype["aPublicMethods"] = ["setDataCleanUpThreshold","iGetDataCleanUpThreshold","setCellSelection","getCellSelection","setFirstVisibleRowIndex","setColumnWidth","setVisibleRowCount","setRowRootDropTargetInfo","setRowRootDragSourceInfo","setHighlightTexts"].concat(UCF_SapTableCS.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_SapTableCSDragDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Animation */
/// <reference path="../../anim/Animation.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>
/* global UCF_SapTableDragDelegate */
/// <reference path="./SapTableDragDelegate.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_SapTableCSDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_SapTableCSDragDelegate["_"]["UCF_SapTableCSDragDelegate"]++; }; 

	UCF_SapTableDragDelegate["apply"](this, [oLS, oDragSourceControl]);

};window["UCF_SapTableCSDragDelegate"] = UCF_SapTableCSDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableCSDragDelegate"); UCF_SapTableCSDragDelegate["_"] = {UCF_SapTableCSDragDelegate: 0}; }; ;
UCF_SapTableCSDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableDragDelegate"))(); UCF_SapTableCSDragDelegate.prototype["sClassName"] = "UCF_SapTableCSDragDelegate";

/**
 * @see UCF_SapTableDragDelegate
 * @override
 * @private
 */
UCF_SapTableCSDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDelegate["_"]["oGetGhost"]++; }; 
	var oGhost = null,
		oSapTable = this["oDragSourceControl"],
		iContentRowOffset = oSapTable["iGetContentRowOffset"](),
		oBaseCellInfo = oSapTable["oGetCellInfoByBrowserEvent"](oBrowserEvent),
		aRows = [],
		iMaxDisplayedRows = 3,
		iLayerOffset = 3;

	{ // Identify the relevant rows to visualize
		var iBaseIndex = oBaseCellInfo["iRowIndex"],
			iScanStart = iContentRowOffset + oSapTable["iFirstVisibleContentRowIndex"],
			iScanEnd = Math["min"](iScanStart + oSapTable["iVisibleContentRowCount"], iContentRowOffset + oSapTable["iContentRowCount"]) - 1,
			iMaxOffset = Math["max"](iBaseIndex - iScanStart, iScanEnd - iBaseIndex),
			iRowIndex = null,
			eSelectionState = oSapTable["SELECTION_LAYER"]["NONE"];

		for (var iOffset = 0, bStop = false; !bStop && iOffset <= iMaxOffset; iOffset++) {
			for (iRowIndex = iBaseIndex - iOffset; !bStop; iRowIndex = iBaseIndex + iOffset) {
				if (oSapTable["bIsVerticalScrolledIntoViewByIndex"](iRowIndex - iContentRowOffset)) {
					eSelectionState = oSapTable["eGetRowSelectionState"](iRowIndex);

					if ((eSelectionState & oSapTable["SELECTION_LAYER"]["ROW_PRIMARY"]) || (eSelectionState & oSapTable["SELECTION_LAYER"]["ROW"])) {
						aRows[aRows["length"]] = {
							"iRowIndex": iRowIndex,
							"iOffset": iOffset,
							"bPrimary": eSelectionState & oSapTable["SELECTION_LAYER"]["ROW_PRIMARY"]
						};
					}
				}

				bStop = bStop || aRows["length"] >= iMaxDisplayedRows;
				if (iRowIndex === iBaseIndex + iOffset) break;
			}
		}
	}

	{ // DOM
		var oDomRefMain = document["createElement"]("div"),
			oRectMain = UCF_DomUtil["oGetObjectRect"](oSapTable["oDomRef"]),
			oDomRefTmp = oDomRefMain,
			oStyleTmp = oDomRefTmp["style"],
			oRectTmp = oRectMain,
			oCellInfoTmp = null,
			oRowTmp = null,
			iBaseX = oSapTable["bDraggable"] ? 0 : oBrowserEvent["iClientX"]() - oRectMain["left"],
			iBaseY = oSapTable["bDraggable"] ? 0 : oBrowserEvent["iClientY"]() - oRectMain["top"],
			iLeftBegin = -1,
			iLeftEnd = -1,
			iTopBegin = -1,
			iTopEnd = -1,
			iWidthBegin = -1,
			iWidthEnd = -1,
			iHeightBegin = -1,
			iHeightEnd = -1,
			iOpacityBegin = -1,
			iOpacityEnd = -1;

		oStyleTmp["overflow"] = "hidden";

		oStyleTmp["width"] = (oRectTmp["width"] + (iLayerOffset * iMaxDisplayedRows) + 20) + "px";
		oStyleTmp["height"] = (oRectTmp["height"] + (iLayerOffset * iMaxDisplayedRows)) + "px";

		for (var i = aRows["length"] - 1; i >= 0; i--) {
			oRowTmp = aRows[i];
			oDomRefTmp = document["createElement"]("div");
			oStyleTmp = oDomRefTmp["style"];

			oStyleTmp["position"] = "absolute";
			oStyleTmp["overflow"] = "hidden";

			//TODO create own classes for ghost
			UCF_DomUtil["setClass"](oDomRefTmp, "urBorderBox urST3TD " + (oRowTmp["bPrimary"] ? "urST4Sel " : "urST4Sel2 "));

			iLeftEnd = iBaseX + (i * iLayerOffset);
			iTopEnd = iBaseY + (i * iLayerOffset);
			iWidthEnd = 50;
			iHeightEnd = 10;
			iOpacityEnd = Math["min"](100, parseInt(100 * (((Math["min"](iMaxDisplayedRows, aRows["length"]) - 1) - i) / (Math["min"](iMaxDisplayedRows, aRows["length"]) - 1)), 10) + 20);

			if (window["UCF_System"]["bUseAnimation"] && !oSapTable["bDraggable"]) {
				//dont play animation for native browserDragDrop
				var oAnimation = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(oDomRefTmp, 1000);

				oCellInfoTmp = oSapTable["oGetCellInfo"](oRowTmp["iRowIndex"], 0);
				oRectTmp = UCF_DomUtil["oGetObjectRect"](oCellInfoTmp["oDomRefCell"], oSapTable["oDomRef"]);

				iLeftBegin = oRectTmp["left"];
				iTopBegin = oRectTmp["top"];
				iWidthBegin = Math["min"](200, oRectMain["width"]);
				iHeightBegin = Math["min"](21, oRectTmp["height"]);
				iOpacityBegin = 100;

				oStyleTmp["left"] = iLeftBegin + "px";
				oStyleTmp["top"] = iTopBegin + "px";
				oStyleTmp["width"] = iWidthBegin + "px";
				oStyleTmp["height"] = iHeightBegin + "px";

				oAnimation["addStyleChange"]("left", "", "px", iLeftBegin, iLeftEnd, oAnimation["M_TRANSITIONS"]["EaseIn"]);
				oAnimation["addStyleChange"]("top", "", "px", iTopBegin, iTopEnd, oAnimation["M_TRANSITIONS"]["EaseIn"]);
				oAnimation["addStyleChange"]("width", "", "px", iWidthBegin, iWidthEnd, oAnimation["M_TRANSITIONS"]["EaseIn"]);
				oAnimation["addStyleChange"]("height", "", "px", iHeightBegin, iHeightEnd, oAnimation["M_TRANSITIONS"]["EaseIn"]);
				oAnimation["addOpacityChange"](iOpacityBegin, iOpacityEnd, oAnimation["M_TRANSITIONS"]["EaseIn"]);
				oAnimation["play"]();
			} else {
				oStyleTmp["left"] = iLeftEnd + "px";
				oStyleTmp["top"] = iTopEnd + "px";
				oStyleTmp["width"] = iWidthEnd + "px";
				oStyleTmp["height"] = iHeightEnd + "px";
				UCF_DomUtil["setOpacityStyle"](oDomRefTmp, iOpacityEnd);
			}

			oDomRefMain["appendChild"](oDomRefTmp);
		}

		oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDomRefMain, false, true);
		oGhost["applyAlphaFilter"](false);
		oGhost["setExtensionOffset"](iLeftEnd + iWidthEnd / 2, iTopEnd + iHeightEnd / 2);
	}

	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDelegate["_"]["oGetGhost"] = 0; };

};
sap["ls"]["preload"]["UCF_SapTableCSDragDropDelegate"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_SapTableDragDropDelegate */
/// <reference path="./SapTableDragDropDelegate.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_SapTableCS} oSapTable
 */
function UCF_SapTableCSDragDropDelegate(oLS, oSapTable) {if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["UCF_SapTableCSDragDropDelegate"]++; }; 
	UCF_SapTableDragDropDelegate["apply"](this, [oLS, oSapTable]);
};window["UCF_SapTableCSDragDropDelegate"] = UCF_SapTableCSDragDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableCSDragDropDelegate"); UCF_SapTableCSDragDropDelegate["_"] = {UCF_SapTableCSDragDropDelegate: 0}; }; ;

UCF_SapTableCSDragDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableDragDropDelegate"))(); UCF_SapTableCSDragDropDelegate.prototype["sClassName"] = "UCF_SapTableCSDragDropDelegate";

/******************************************************
 ** Column resize and reorder
 *******************************************************/

/**
 * @see UCF_SapTableDragDropDelegate
 * @override
 * @private
 */
UCF_SapTableCSDragDropDelegate["prototype"]["bIsRasterPointVisible"] = function(oRasterPoint) {;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["bIsRasterPointVisible"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oRasterPoint != null, "oRasterPoint != null", "SapTableCSDragDropDelegate.js(31): bIsRasterPointVisible"); };
	var oDomRef = UCF_DomUtil["$"](oRasterPoint["sInsertRefId"]);
	if (oDomRef) {
		var oCellInfo = this["oSapTable"]["oGetCellInfoByDomRef"](oDomRef),
			oSegment = this["oSapTable"]["oGetSegmentByCellInfo"](oCellInfo),
			eSegmentColType = this["oSapTable"]["eGetSegmentColType"](oSegment);

		if (eSegmentColType === this["oSapTable"]["SEGMENT_COL"]["NONE_FIXED"]) {
			var oSegmentsVisibleRect = this["oGetColSegmentsRect"](this["oSapTable"]["aGetSegmentsByColType"](eSegmentColType)),
				oRect = this["oGetObjectRect"](oDomRef),
				iPointX = oRasterPoint["bInsertModeBefore"] ? oRect["left"] : oRect["left"] + oRect["width"];

			if (iPointX + 2 < oSegmentsVisibleRect["left"] || iPointX > (oSegmentsVisibleRect["left"] + oSegmentsVisibleRect["width"])) return false;

		}
	}

	return true;
};;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["bIsRasterPointVisible"] = 0; };

/**
 * @see UCF_SapTableDragDropDelegate
 * @override
 * @private
 */
UCF_SapTableCSDragDropDelegate["prototype"]["bDragProcessInStandardSegment"] = function(oResizeInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["bDragProcessInStandardSegment"]++; }; 
	return oResizeInfo["eSegmentColType"] === this["oSapTable"]["SEGMENT_COL"]["NONE_FIXED"];
};;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["bDragProcessInStandardSegment"] = 0; };

/**
 * @see UCF_SapTableDragDropDelegate
 * @override
 * @private
 */
UCF_SapTableCSDragDropDelegate["prototype"]["updateTableVerticalResize"] = function(oRasterPoint) {;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["updateTableVerticalResize"]++; }; 
	if (this["bUseOwnTableVerticalResizeDecoration"]()) {
		this["oSapTable"]["setVisibleContentRowCount"](oRasterPoint["iVisibleRowCount"]);
		this["oSapTable"]["notifyLayoutChange"](); // Notify the layoutChange when resized manually
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["updateTableVerticalResize"] = 0; };

/**
 * @see UCF_SapTableDragDropDelegate
 * @override
 * @private
 */
UCF_SapTableCSDragDropDelegate["prototype"]["bUseOwnTableVerticalResizeDecoration"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["bUseOwnTableVerticalResizeDecoration"]++; }; 
	return this["oSapTable"]["eVerticalScrollUpdateMode"] !== this["oSapTable"]["SCROLL_UPDATE_MODE"]["SERVER"];
};;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["bUseOwnTableVerticalResizeDecoration"] = 0; };

/**
 * @see UCF_SapTableDragDropDelegate
 * @override
 * @private
 */
UCF_SapTableCSDragDropDelegate["prototype"]["oGetFirstCellOfSegment"] = function(iRowIndex, oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["oGetFirstCellOfSegment"]++; }; 
	return this["oSapTable"]["oGetCellInfo"](iRowIndex, this["oSapTable"]["iGetSegmentOffsetColIndex"](oSegment));
};;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["oGetFirstCellOfSegment"] = 0; };

/**
 * @see UCF_SapTableDragDropDelegate
 * @override
 * @private
 */
UCF_SapTableCSDragDropDelegate["prototype"]["oGetSegmentsVisibleRect"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["oGetSegmentsVisibleRect"]++; }; 
	return this["oGetColSegmentsRect"](this["oSapTable"]["aGetSegmentsByColType"](this["oSapTable"]["eGetSegmentColType"](oSegment)));
};;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["oGetSegmentsVisibleRect"] = 0; };

/**
 * @see UCF_SapTableDragDropDelegate
 * @override
 * @private
 */
UCF_SapTableCSDragDropDelegate["prototype"]["oInitColumnResize"] = function(oAccessInfo, oSrcCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["oInitColumnResize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableCSDragDropDelegate.js(105): oInitColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSrcCellInfo != null, "oSrcCellInfo != null", "SapTableCSDragDropDelegate.js(106): oInitColumnResize"); };

	var oSegment = this["oSapTable"]["oGetSegmentByCellInfo"](oSrcCellInfo),
		eSegmentColType = this["oSapTable"]["eGetSegmentColType"](oSegment),
		oResizeInfo = null;

	if (eSegmentColType === this["oSapTable"]["SEGMENT_COL"]["NONE_FIXED"]) {
		oResizeInfo = UCF_SapTableDragDropDelegate.prototype["oInitColumnResize"]["call"](this, oAccessInfo, oSrcCellInfo);
	} else if (eSegmentColType === this["oSapTable"]["SEGMENT_COL"]["LEFT_FIXED"]) {

		var oNonFixedSegment = this["oSapTable"]["oGetFirstSegmentOfCol"](this["oSapTable"]["SEGMENT_COL"]["NONE_FIXED"]);

		oResizeInfo = this["oInitColumnResizeObject"](oAccessInfo, oSrcCellInfo);
		oResizeInfo["oDecorationBoundaries"]["left"] = oResizeInfo["oInitialSrcCellRect"]["left"] + (window["UCF_System"]["bIsRTL"] ? -this["oSapTable"]["MIN_COL_WIDTH"] : this["oSapTable"]["MIN_COL_WIDTH"]);

		if (oNonFixedSegment) {
			var iNoneFixedSegmentWidth = oNonFixedSegment["offsetWidth"];

			if (iNoneFixedSegmentWidth > this["MIN_NONE_FIXED_SEGMENT_WIDTH"]) {
				oResizeInfo["oDecorationBoundaries"]["width"] =
					(oResizeInfo["oInitialSrcCellRect"]["width"] + iNoneFixedSegmentWidth) - this["MIN_NONE_FIXED_SEGMENT_WIDTH"] - this["oSapTable"]["MIN_COL_WIDTH"];
			} else { // Only making column smaller is possible
				oResizeInfo["oDecorationBoundaries"]["width"] = oResizeInfo["oInitialSrcCellRect"]["width"] - this["oSapTable"]["MIN_COL_WIDTH"];
			}

			if (window["UCF_System"]["bIsRTL"])
				oResizeInfo["oDecorationBoundaries"]["left"] -= (oResizeInfo["oDecorationBoundaries"]["width"] - oResizeInfo["oInitialSrcCellRect"]["width"]);

			oResizeInfo["bIsValidResizeOperation"] = true;
		}

	}

	if (oResizeInfo) oResizeInfo["eSegmentColType"] = eSegmentColType;

	return oResizeInfo;
};;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["oInitColumnResize"] = 0; };

/**
 * @see UCF_SapTableDragDropDelegate
 * @override
 * @private
 */
UCF_SapTableCSDragDropDelegate["prototype"]["calculateColumnResize"] = function(oAccessInfo, oResizeInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["calculateColumnResize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableCSDragDropDelegate.js(150): calculateColumnResize"); };

	if (oResizeInfo["eSegmentColType"] === this["oSapTable"]["SEGMENT_COL"]["NONE_FIXED"]) {
		UCF_SapTableDragDropDelegate.prototype["calculateColumnResize"]["call"](this, oAccessInfo, oResizeInfo);
	} else if (oResizeInfo["eSegmentColType"] === this["oSapTable"]["SEGMENT_COL"]["LEFT_FIXED"]) {

		if (oResizeInfo["iResultWidth"] === -1) {
			var iDragPos = Math["min"](Math["max"](oResizeInfo["oDecorationBoundaries"]["left"],
					this["iGetPageX"](oAccessInfo["oBrowserEvent"])),
				oResizeInfo["oDecorationBoundaries"]["left"] + oResizeInfo["oDecorationBoundaries"]["width"]);

			if (window["UCF_System"]["bIsRTL"]) {
				oResizeInfo["iResultWidth"] = oResizeInfo["oInitialSrcCellRect"]["left"] + oResizeInfo["oInitialSrcCellRect"]["width"] - iDragPos;
			} else {
				oResizeInfo["iResultWidth"] = iDragPos - oResizeInfo["oInitialSrcCellRect"]["left"];
			}
		}

		this["applyColumnBasedWidth"](oResizeInfo);
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["calculateColumnResize"] = 0; };

/**
 * @see UCF_SapTableDragDropDelegate
 * @override
 * @private
 */
UCF_SapTableCSDragDropDelegate["prototype"]["internalFireColumnResize"] = function(oResizeInfo, bLooseFocus) {;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["internalFireColumnResize"]++; }; 

	if (bLooseFocus) this["oSapTable"]["looseFocus"]();

	this["oSapTable"]["fireColumnResize"](
		this["oSapTable"]["sId"],
		oResizeInfo["oSrcCellInfo"]["oDomRefCell"]["getAttribute"]("id"),
		(!oResizeInfo["bHasTableBasedColumnWidths"]) ? oResizeInfo["sResultWidth"] : '',
		(oResizeInfo["bHasTableBasedColumnWidths"]) ? oResizeInfo["sColWidths"] : ""
	);
};;if (__UCF_COVERAGE__) { UCF_SapTableCSDragDropDelegate["_"]["internalFireColumnResize"] = 0; };

};
sap["ls"]["preload"]["UCF_SapTableCSDropDelegate"] = function() {/* global UCF_SapTableDropDelegate */
/// <reference path="./SapTableDropDelegate.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_SapTableCSDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_SapTableCSDropDelegate["_"]["UCF_SapTableCSDropDelegate"]++; }; 
	UCF_SapTableDropDelegate["apply"](this, [oLS, oDropTargetControl]);
};window["UCF_SapTableCSDropDelegate"] = UCF_SapTableCSDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableCSDropDelegate"); UCF_SapTableCSDropDelegate["_"] = {UCF_SapTableCSDropDelegate: 0}; }; ;
UCF_SapTableCSDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableDropDelegate"))(); UCF_SapTableCSDropDelegate.prototype["sClassName"] = "UCF_SapTableCSDropDelegate";

/**
 * @see UCF_SapTableDropDelegate
 * @override
 * @private
 */
UCF_SapTableCSDropDelegate["prototype"]["bIsContentSegment"] = function(oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableCSDropDelegate["_"]["bIsContentSegment"]++; }; 
	return oSegment ? this["oDropTargetControl"]["eGetSegmentRowType"](oSegment) === this["oDropTargetControl"]["SEGMENT_ROW"]["CONTENT"] : false;
};;if (__UCF_COVERAGE__) { UCF_SapTableCSDropDelegate["_"]["bIsContentSegment"] = 0; };

};
sap["ls"]["preload"]["UCF_SapTableCell"] = function() {/* global UCF_SapTableBaseCell */
/// <reference path="./base/SapTableBaseCell.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_SapTable} oTable
 */
function UCF_SapTableCell(oDomRef, oTable) {if (__UCF_COVERAGE__) { UCF_SapTableCell["_"]["UCF_SapTableCell"]++; }; 
	UCF_SapTableBaseCell["apply"](this, arguments);

};window["UCF_SapTableCell"] = UCF_SapTableCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableCell"); UCF_SapTableCell["_"] = {UCF_SapTableCell: 0}; }; ;
UCF_SapTableCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableBaseCell"))(); UCF_SapTableCell.prototype["sClassName"] = "UCF_SapTableCell";

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableCell["prototype"]["setCellState"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCell["_"]["setCellState"]++; }; 
	if (this["sCellDesign"] == "FILTERICON") {
		this["oAccessibilityHelper"]["setControlType"]("ST_FBTN");
	} else if (this["sCellDesign"] == "FILTER") {
		var sColumnInfo = this["sSpaceCleanUp"](this["sGetColumnInfo"]());
		this["oAccessibilityHelper"]["setControlType"]("ST_F", [sColumnInfo]);

		if (this["oAccessInfo"]["oBrowserEvent"]
			&& this["oAccessInfo"]["oBrowserEvent"]["oGetSource"]()
			&& this["oAccessInfo"]["oBrowserEvent"]["oGetSource"]()["getAttribute"]("empty")
		) {
			this["oAccessibilityHelper"]["setEnabled"](false);
		}

	} else if (this["sCellType"] == "ROWCREATOR") {
		this["oAccessibilityHelper"]["setControlType"]("ST_RC", [this["sGetRowInfo"]()]);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCell["_"]["setCellState"] = 0; };

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableCell["prototype"]["sGetTutorInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCell["_"]["sGetTutorInfo"]++; }; 
	if (this["oAccessInfo"]["eAction"] == this["oTable"]["ACTION"]["FILTER"]) {
		return "ST_FBTN_TUT";
	} else if (this["sCellDesign"] == "FILTER" /*TODO && InputField is not readOnly*/ ) {
		return "ST_F_TUT";
	} else if (this["sCellType"] == "ROWCREATOR") {
		return "ST_RC_TUT";
	}
	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableCell["_"]["sGetTutorInfo"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SapTableCell["prototype"]["aAttributeNames"] = ["bIsSelected","bIsSecondarySelected","sCellType","sCellDesign","sHeaderCellIds","sRowHeaderCellIds","sCustomStyle","sCustomData","sAccessibilityDescription"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SapTableCell["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SapTableCell["prototype"]["aMethodNames"] = ["getContent","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableCell["prototype"]["bIsSelected"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableCell["prototype"]["bIsSecondarySelected"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellType}
 */
UCF_SapTableCell["prototype"]["sCellType"] = "TEXT";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_SapTableCell["prototype"]["sCellDesign"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_SapTableCell["prototype"]["sHeaderCellIds"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCell["prototype"]["sRowHeaderCellIds"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCell["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCell["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableCell["prototype"]["sAccessibilityDescription"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_SapTableCell["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableCell["_"]["setDefaultValues"]++; }; 
	this["bIsSelected"] = false;
	this["bIsSecondarySelected"] = false;
	this["sCellType"] = "TEXT";
	this["sCellDesign"] = "STANDARD";
	this["sHeaderCellIds"] = '';
	this["sRowHeaderCellIds"] = '';
	this["sCustomStyle"] = '';
	this["sCustomData"] = '';
	this["sAccessibilityDescription"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("IsSelected", false, true);
		this["setClientProperty"]("IsSecondarySelected", false, true);
		this["setClientProperty"]("CellType", "TEXT", true);
		this["setClientProperty"]("CellDesign", "STANDARD", true);
		this["setClientProperty"]("HeaderCellIds", '', true);
		this["setClientProperty"]("RowHeaderCellIds", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableCell["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_SapTableDTExtension"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DTExtension */
/// <reference path="./DTExtension.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oControl
 * @param {UCF_DTElement} oDTElement
 */
function UCF_SapTableDTExtension(oLS, oControl, oDTElement) {if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["UCF_SapTableDTExtension"]++; }; 
	if (arguments["length"] == 0) return;
	UCF_DTExtension["apply"](this, arguments);
};window["UCF_SapTableDTExtension"] = UCF_SapTableDTExtension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableDTExtension"); UCF_SapTableDTExtension["_"] = {UCF_SapTableDTExtension: 0}; }; ;

UCF_SapTableDTExtension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTExtension"))(); UCF_SapTableDTExtension.prototype["sClassName"] = "UCF_SapTableDTExtension";

UCF_SapTableDTExtension["prototype"]["bIsVisible"] = function(sElementId) {;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["bIsVisible"]++; }; 
	if (sElementId != this["oControl"]["sId"]) {
		// Table Column...

		var oPCC = this["oDTElement"]["oDTContainer"]["oPositioningLoopContext"];
		if (oPCC) {
			if (oPCC["mTableVisibilityCache"] == undefined) oPCC["mTableVisibilityCache"] = {};
			var bVisible = oPCC["mTableVisibilityCache"][this["oControl"]["sGetId"]()];
			if (bVisible == undefined) {
				oPCC["mTableVisibilityCache"][this["oControl"]["sGetId"]()] = bVisible = this["oControl"]["bIsVisible"]();
			}
			return bVisible;
		} else {
			return this["oControl"]["bIsVisible"]();
		}
	} else {
		return UCF_DTExtension.prototype["bIsVisible"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["bIsVisible"] = 0; };

/**
 * SapTable does not use UCF_ScrollArea: Check if this header cell is part of the scrollable "segment"
 */
UCF_SapTableDTExtension["prototype"]["oGetParentScrollAreaControl"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oGetParentScrollAreaControl"]++; }; 
	var oDomRef = UCF_DomUtil["$"](sId);
	if (oDomRef && oDomRef["getAttribute"] && oDomRef["getAttribute"]("subct") == "HC") {
		var oSegment = this["oGetSpecialScrollAreaDomRef"]();
		if (oSegment && UCF_DomUtil["bContains"](oSegment, oDomRef)) {
			return this["oControl"];
		}
	}
	return UCF_DTExtension.prototype["oGetParentScrollAreaControl"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oGetParentScrollAreaControl"] = 0; };

UCF_SapTableDTExtension["prototype"]["oGetDomRefForRect"] = function(sElementId, bIsScrollElement) {;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oGetDomRefForRect"]++; }; 
	if (bIsScrollElement) {
		// TODO: suffix always the same? string-constant?
		return UCF_DomUtil["$"](sElementId + "-mrss-hdr-none");
	} else {
		return UCF_DTExtension.prototype["oGetDomRefForRect"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oGetDomRefForRect"] = 0; };

UCF_SapTableDTExtension["prototype"]["oPostprocessRect"] = function(oRect, sElementId, bIsScrollElement) {;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oPostprocessRect"]++; }; 
	var oTBody;
	if (bIsScrollElement) {
		oTBody = UCF_DomUtil["$"](this["oControl"]["sId"] + "-" + this["oControl"]["SUFFIX"]["CONTENT_TBODY"]); // SapTable
		if (oTBody == null) {
			oTBody = UCF_DomUtil["$"](this["oControl"]["sId"] + "-" + this["oControl"]["SUFFIX"]["CONTENT_AREA"]); // SapTableCS
		}
		// Height of horizontal UCF_ScrollBar
		var iScrollBarHeight = this["oControl"]["oScrollH"] ? this["oControl"]["oScrollH"]["oDomRef"]["clientHeight"] : 18;
		oRect["height"] = oTBody["clientHeight"] + iScrollBarHeight;
	} else {
		var oDomRef = UCF_DomUtil["$"](sElementId);
		// Header-cell: Modify the height so that the element will cover the whole column
		if (oDomRef && oDomRef["getAttribute"] && oDomRef["getAttribute"]("subct") == "HC") {
			oTBody = UCF_DomUtil["$"](this["oControl"]["sId"] + "-" + this["oControl"]["SUFFIX"]["CONTENT_TBODY"]); // SapTable
			if (oTBody == null) {
				oTBody = UCF_DomUtil["$"](this["oControl"]["sId"] + "-" + this["oControl"]["SUFFIX"]["CONTENT_AREA"]); // SapTableCS
			}
			oRect["height"] = oTBody["clientHeight"];

			// If the cell is inside an scrollable "segment" also overwrite the position
			var oSegment = this["oGetSpecialScrollAreaDomRef"]();
			if (oSegment && UCF_DomUtil["bContains"](oSegment, oDomRef)) {
				oRect["top"] = 0;
				oRect["left"] = oDomRef["offsetLeft"];
			}
		}

	}

	return oRect;
};;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oPostprocessRect"] = 0; };

UCF_SapTableDTExtension["prototype"]["oGetScrollAreaDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oGetScrollAreaDomRef"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oGetScrollAreaDomRef"] = 0; };

UCF_SapTableDTExtension["prototype"]["oGetSpecialScrollAreaDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oGetSpecialScrollAreaDomRef"]++; }; 
	var aHorizontalScrollSegments = this["oControl"]["aGetHorizontalScrollSegments"]();
	for (var iSegmentRowIndex = 0; iSegmentRowIndex < aHorizontalScrollSegments["length"]; iSegmentRowIndex++) {
		var oNoneFixedSegment = aHorizontalScrollSegments[iSegmentRowIndex];
		if (oNoneFixedSegment) {
			return this["oControl"]["oGetSegmentHPositionElement"](oNoneFixedSegment);
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oGetSpecialScrollAreaDomRef"] = 0; };

UCF_SapTableDTExtension["prototype"]["oGetSpecialScrollAreaScrollWH"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oGetSpecialScrollAreaScrollWH"]++; }; 
	var oTBody = UCF_DomUtil["$"](this["oControl"]["sId"] + "-" + this["oControl"]["SUFFIX"]["CONTENT_TBODY"]); // SapTable
	if (oTBody == null) {
		oTBody = UCF_DomUtil["$"](this["oControl"]["sId"] + "-" + this["oControl"]["SUFFIX"]["CONTENT_AREA"]); // SapTableCS
	}

	return { "width": this["oGetSpecialScrollAreaDomRef"]()["clientWidth"], "height": oTBody["clientHeight"] };
};;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["oGetSpecialScrollAreaScrollWH"] = 0; };

UCF_SapTableDTExtension["prototype"]["getScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["getScrollPosition"]++; }; 
	return { "left": Math["abs"](parseInt(this["oGetSpecialScrollAreaDomRef"]()["style"]["left"])), "top": 0 };
};;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["getScrollPosition"] = 0; };

UCF_SapTableDTExtension["prototype"]["forwardScrollPosition"] = function(iLeft, iTop) {;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["forwardScrollPosition"]++; }; 
	this["oControl"]["setHorizontalScrollPosition"](iLeft);
};;if (__UCF_COVERAGE__) { UCF_SapTableDTExtension["_"]["forwardScrollPosition"] = 0; };

};
sap["ls"]["preload"]["UCF_SapTableDragDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_DragSession */
/// <reference path="../base/DragSession.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_SapTableDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_SapTableDragDelegate["_"]["UCF_SapTableDragDelegate"]++; }; 
	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);
};window["UCF_SapTableDragDelegate"] = UCF_SapTableDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableDragDelegate"); UCF_SapTableDragDelegate["_"] = {UCF_SapTableDragDelegate: 0}; }; ;
UCF_SapTableDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_SapTableDragDelegate.prototype["sClassName"] = "UCF_SapTableDragDelegate";

/**
 * Handler for the drag start event which initializes the drag session
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableDragDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDelegate["_"]["onlsdragstart"]++; }; 
	var oDragSourceControl = this["oGetDragSourceControl"](oBrowserEvent);

	// BlockSelection has already been performed in SapTableDragDropDelegate -> no additional row drag operation
	if (oBrowserEvent["bHandled"]) return;

	var sDragSourceInfoId = oDragSourceControl["sGetRowRootDragSourceInfo"]();
	if (!sDragSourceInfoId)
		return;

	var oDragSourceInfoControl = oDragSourceControl["oGetControlById"](sDragSourceInfoId);
	if (!oDragSourceInfoControl)
		return;

	var sTags = oDragSourceInfoControl["sGetTags"]();
	if (!sTags)
		return;

	if (!this["bIsDragPossible"](oBrowserEvent))
		return;

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		oDragSession = oDragAndDropManager["startDragSession"](oDragSourceControl["sId"], sTags, UCF_DragSession["DRAG_TYPE"]["STANDARD"], null, this["oGetGhost"](oBrowserEvent), oDragSourceInfoControl["sHint"]);

	//if Drag-Event is registered
	if (oDragSourceControl["mEvents"]["Drag"]) {
		oDragSourceControl["fireDrag"](oDragSourceControl["sId"], sDragSourceInfoId, oDragSession["sId"]);
	}

	var oCellInfo = oDragSourceControl["oGetCellInfoByBrowserEvent"](oBrowserEvent),
		sRowDragData = oCellInfo ? oDragSourceControl["sGetRowDragData"](oCellInfo) : null;

	//if DataAccess is registered
	if (oDragSourceInfoControl["mEvents"]["DataAccess"]) {

		//use mime type from drag source info
		//server can override it with a non-null value
		oDragSession["sMimeType"] = oDragSourceInfoControl["sGetMimeType"]();

		oDragSourceInfoControl["fireDataAccess"](sDragSourceInfoId, oDragSourceControl["sId"], oDragSession["sId"]);
	} else if (sRowDragData) { //for row repeater (difference to super method)
		oDragSession["setDragData"](sRowDragData, oDragSourceInfoControl["sGetMimeType"]());
	} else { //use data from drag source info control
		oDragSession["setDragData"](oDragSourceInfoControl["sGetData"](), oDragSourceInfoControl["sGetMimeType"]());
	}

	oBrowserEvent["bHandled"] = true;
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDelegate["_"]["onlsdragstart"] = 0; };

/**
 * Handler for the native drag start event which initializes the drag session
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableDragDelegate["prototype"]["ondragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDelegate["_"]["ondragstart"]++; }; 
	UCF_DragDelegate.prototype["ondragstart"]["apply"](this, arguments);
	if (!oBrowserEvent["bHandled"]) return;
	//set DragImage
	var oDragSourceControl = this["oGetDragSourceControl"](oBrowserEvent),
		oDragAndDropManager = oDragSourceControl["oLS"]["oBrowserWindow"]["oDragAndDropManager"];
	oDragAndDropManager["setDragImage"](oBrowserEvent, this["oGetGhost"](oBrowserEvent)["oGhostRef"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDelegate["_"]["ondragstart"] = 0; };

/**
 * Returns the HTML representation of the ghost for this drag & drop feature
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {HTMLElement} The root DOM ref of the ghost
 * @private
 */
UCF_SapTableDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDelegate["_"]["oGetGhost"]++; }; 

	//TODO: ghost for rowrepeater

	//create the ghost
	var oGhostTable = document["createElement"]("TABLE");
	oGhostTable["cellSpacing"] = 0;
	oGhostTable["cellPadding"] = 0;

	var oTableBody = document["createElement"]("TBODY");
	oGhostTable["appendChild"](oTableBody);

	var aSelectedRows = this["oDragSourceControl"]["aGetSelectedRows"]();
	for (var iRows = 0; iRows < aSelectedRows["length"]; iRows++) {
		var oRowClone = aSelectedRows[iRows]["oDomRefRow"]["cloneNode"](true);

		//first cell selection cell?
		var oFirstCellInfo = this["oDragSourceControl"]["oGetCellInfo"](aSelectedRows[iRows]["iRowIndex"], 0);
		if (oFirstCellInfo["eCellType"] === this["oDragSourceControl"]["SUBCONTROL"]["SELECTION_CELL"] && oFirstCellInfo["oDomRefCell"]) {
			//remove selection button
			oRowClone["removeChild"](oRowClone["getElementsByTagName"]("TD")[0]);
		}

		oTableBody["appendChild"](oRowClone);
	}

	oGhostTable["style"]["width"] = UCF_DomUtil["oGetObjectRect"](this["oDragSourceControl"]["oDomRef"])["width"] + "px";

	var oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oGhostTable);
	oGhost["setOffset"](12, 12);

	return oGhost;

};;if (__UCF_COVERAGE__) { UCF_SapTableDragDelegate["_"]["oGetGhost"] = 0; };

/**
 * Checks if a drag operation is possible
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} true if drag is possible
 * @private
 */
UCF_SapTableDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDelegate["_"]["bIsDragPossible"]++; }; 
	var oCellInfo = this["oDragSourceControl"]["oGetCellInfoByBrowserEvent"](oBrowserEvent);

	if (!oCellInfo)
		return false;

	//for row repeater
	if (oBrowserEvent["oGetSourceControl"]()["bIsDragHandle"])
		return UCF_DragDelegate.prototype["bIsDragPossible"]["call"](this, oBrowserEvent);

	//only allow drag from a selected row
	var aSelectedInfo = this["oDragSourceControl"]["aGetSelectedRows"]();

	for (var x = 0; x < aSelectedInfo["length"]; x++) {
		if (aSelectedInfo[x]["iRowIndex"] === oCellInfo["iRowIndex"]) {
			return UCF_DragDelegate.prototype["bIsDragPossible"]["call"](this, oBrowserEvent);
		}
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDelegate["_"]["bIsDragPossible"] = 0; };

/**
 * @return the id of the dragSourceInfo control
 * @type string
 *
 */
UCF_SapTableDragDelegate["prototype"]["oGetDragSourceInfoId"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDelegate["_"]["oGetDragSourceInfoId"]++; }; 

	var oDragSourceControl = this["oGetDragSourceControl"](oBrowserEvent);
	if (oDragSourceControl) {
		return oDragSourceControl["sGetRowRootDragSourceInfo"]();
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDelegate["_"]["oGetDragSourceInfoId"] = 0; };

};
sap["ls"]["preload"]["UCF_SapTableDragDropDelegate"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_DragDropDecoration */
/// <reference path="../base/DragDropDecoration.js"/>
/* global UCF_DragSession */
/// <reference path="../base/DragSession.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>
/* global UCF_FocusInfo */
/// <reference path="../../../ls/core/FocusInfo.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_SapTable} oSapTable
 */
function UCF_SapTableDragDropDelegate(oLS, oSapTable) {if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["UCF_SapTableDragDropDelegate"]++; }; 
	this["oLS"] = oLS;
	this["oSapTable"] = oSapTable;
	this["oDropDecoration"] = null;
	this["oReferenceContainer"] = null;
	this["oReferenceRect"] = null;
	this["oLastHoveredCellInfo"] = null;
};window["UCF_SapTableDragDropDelegate"] = UCF_SapTableDragDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableDragDropDelegate"); UCF_SapTableDragDropDelegate["_"] = {UCF_SapTableDragDropDelegate: 0}; }; ;
UCF_SapTableDragDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_SapTableDragDropDelegate.prototype["sClassName"] = "UCF_SapTableDragDropDelegate";

/******************************************************
 ** Column resize and reorder
 *******************************************************/

/**
 * Destructor
 */
UCF_SapTableDragDropDelegate["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["destroy"]++; }; 
	this["oLS"] = null;
	this["oSapTable"] = null;
	this["oDropDecoration"] = null;
	this["oReferenceContainer"] = null;
	this["oReferenceRect"] = null;
	this["oLastHoveredCellInfo"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["destroy"] = 0; };

// DragDrop source events

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["onlsselectstart"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsselectstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableDragDropDelegate.js(65): onlsselectstart"); };
	if (oBrowserEvent["oDragAndDropManager"] &&
		oBrowserEvent["oSourceControl"] && this["oSapTable"]["bPermitTextSelection"](oBrowserEvent)) {
			oBrowserEvent["oDragAndDropManager"]["activateSelectionMode"]();
			this["oSapTable"]["setCopyToClipboardEnabled"](false);
			this["oSapTable"]["oSelectStartEditor"] = oBrowserEvent["oSourceControl"];
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsselectstart"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["onlsdragstart"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableDragDropDelegate.js(81): onlsdragstart"); };

	this["handleDragDrop"](oBrowserEvent, this["oSapTable"]["ACCESS_TYPE"]["DRAG_START"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragstart"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["onlsdrag"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdrag"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableDragDropDelegate.js(93): onlsdrag"); };
	this["handleDragDrop"](oBrowserEvent, this["oSapTable"]["ACCESS_TYPE"]["DRAG"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdrag"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["onlsdragend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableDragDropDelegate.js(104): onlsdragend"); };
	this["handleDragDrop"](oBrowserEvent, this["oSapTable"]["ACCESS_TYPE"]["DRAG_END"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragend"] = 0; };

// DragDrop target events
/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["onlsdragover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableDragDropDelegate.js(116): onlsdragover"); };
	this["handleDragDrop"](oBrowserEvent, this["oSapTable"]["ACCESS_TYPE"]["DRAG_OVER"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragover"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["onlsdrop"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdrop"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableDragDropDelegate.js(127): onlsdrop"); };
	this["handleDragDrop"](oBrowserEvent, this["oSapTable"]["ACCESS_TYPE"]["DROP"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdrop"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["onlsdragenter"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableDragDropDelegate.js(138): onlsdragenter"); };
	this["handleDragDrop"](oBrowserEvent, this["oSapTable"]["ACCESS_TYPE"]["DRAG_ENTER"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragenter"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["onlsdragleave"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragleave"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableDragDropDelegate.js(149): onlsdragleave"); };
	this["handleDragDrop"](oBrowserEvent, this["oSapTable"]["ACCESS_TYPE"]["DRAG_LEAVE"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragleave"] = 0; };

/**
 * Event handler
 * It updates the scroll position according to the mouse possition
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["onlsdragscroll"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragscroll"]++; }; 

	if (this["oSapTable"]["bCanClientScroll"](true)) {
		var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"],
			oResizeInfo = oDragSession["oGetCustomData"]();

		if (oResizeInfo
			&& (oDragSession["eDragType"] === UCF_DragSession["DRAG_TYPE"]["STANDARD"] || oDragSession["eDragType"] === UCF_DragSession["DRAG_TYPE"]["BLOCK_SELECT"] ||
				(oDragSession["eDragType"] === UCF_DragSession["DRAG_TYPE"]["H_RESIZE"] && this["bDragProcessInStandardSegment"](oResizeInfo)))
		) {
			var oPullInfo = oResizeInfo["oPullInfo"];

			if (!oPullInfo || oPullInfo["sInfoOf"] !== this["oSapTable"]["sId"]) {
				var oScrollSegment = this["oGetScrollSegment"]();

				oPullInfo = {
					"sInfoOf": this["oSapTable"]["sId"],
					"oScrollSegment": oScrollSegment,
					"oScrollSegmentVisibleRect": this["oGetSegmentsVisibleRect"](oScrollSegment)
				};

				if (oDragSession["eDragType"] === UCF_DragSession["DRAG_TYPE"]["STANDARD"] || oDragSession["eDragType"] === UCF_DragSession["DRAG_TYPE"]["BLOCK_SELECT"]) {
					oPullInfo["iMinScrollPosition"] = 0;
					oPullInfo["iMaxScrollPosition"] = this["oSapTable"]["iGetSegmentContentWidth"](oScrollSegment) - oPullInfo["oScrollSegmentVisibleRect"]["width"];
				} else {
					oPullInfo["iMinScrollPosition"] = oResizeInfo["iMinScrollPosition"];
					oPullInfo["iMaxScrollPosition"] = oResizeInfo["iMaxScrollPosition"];
				}

				oResizeInfo["oPullInfo"] = oPullInfo;
			}

			this["updateScrollPositionByPull"](
				oBrowserEvent,
				oPullInfo["oScrollSegmentVisibleRect"],
				this["oSapTable"]["iGetHorizontalScrollPosition"](oPullInfo["oScrollSegment"]),
				oPullInfo["iMinScrollPosition"],
				oPullInfo["iMaxScrollPosition"]
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["onlsdragscroll"] = 0; };

UCF_SapTableDragDropDelegate["prototype"]["MAX_PULL"] = 100;
UCF_SapTableDragDropDelegate["prototype"]["PULL_PADDING"] = 15;
UCF_SapTableDragDropDelegate["prototype"]["MAX_SCROLL_STEP"] = 30;
UCF_SapTableDragDropDelegate["prototype"]["MIN_NONE_FIXED_SEGMENT_WIDTH"] = 100;

/**
 * Drag/drop custom type
 */

UCF_SapTableDragDropDelegate["prototype"]["DRAG_CUSTOM_TYPE"] = {
	"NONE": null,
	"COL_RESIZE": "tableColumResize",
	"COL_DRAG": "tableColumReorder",
	"ROW_DRAG": "tableRowDrag",
	"TABLE_V_RESIZE": "tableVerticalResize",
	"BLOCK_SELECT_TL": "tableBlockSelectTL",
	"BLOCK_SELECT_BR": "tableBlockSelectBR",
	"BLOCK_SELECT_TR": "tableBlockSelectTR",
	"BLOCK_SELECT_BL": "tableBlockSelectBL",
	"BLOCK_SELECT_CD_STANDARD": "tableBlockSelectClickDragStandard",
	"BLOCK_SELECT_CD_TOGGLE": "tableBlockSelectClickDragToggle",
	"ROW_DRAG_SELECT": "rowDragSelect"
};

/**
 * Clean up drag/drop
 * @private
 */

UCF_SapTableDragDropDelegate["prototype"]["cleanUpDragDrop"] = function (oDragAndDropManager) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["cleanUpDragDrop"]++; }; 
	this["cleanUpDropDropArea"](oDragAndDropManager);
	this["oReferenceContainer"] = null;
	this["oReferenceRect"] = null;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["cleanUpDragDrop"] = 0; };

/**
 * Clean up drop area
 * @private
 */

UCF_SapTableDragDropDelegate["prototype"]["cleanUpDropDropArea"] = function (oDragAndDropManager) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["cleanUpDropDropArea"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "cleanUpDrop " + this["oSapTable"]["sId"], "SapTableDragDropDelegate.js(244): cleanUpDropDropArea"); };

	if (this["oDropDecoration"]) {
		this["oDropDecoration"]["cleanUp"]();
		this["oDropDecoration"] = null;
	}
	if (oDragAndDropManager) oDragAndDropManager["cleanUpDropArea"]();
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["cleanUpDropDropArea"] = 0; };

/* eslint-disable complexity */
/**
 * Handle drag/drop operation
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {int} eAccessType
 * @private
 */

UCF_SapTableDragDropDelegate["prototype"]["handleDragDrop"] = function (oBrowserEvent, eAccessType) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleDragDrop"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableDragDropDelegate.js(263): handleDragDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (eAccessType) === "number", "typeof (eAccessType) === \"number\"", "SapTableDragDropDelegate.js(264): handleDragDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(eAccessType >= 0, "eAccessType >= 0", "SapTableDragDropDelegate.js(265): handleDragDrop"); };

	if (!this["oSapTable"]["bInitBeforeHandling"]()) return false;

	var oAccessInfo = null,
		oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		oDragSession = oDragAndDropManager["oDragSession"];

	var bRowSelectionMode = this["oSapTable"]["sCellSelectionMapping"] === 'ROW' || (this["oSapTable"]["sRowSelectionFollowFocus"] !== 'NONE');
	var bSingleRowSelectionMode =	this["oSapTable"]["sRowSelectionMode"] === 'SINGLE' ||
			this["oSapTable"]["sRowSelectionMode"] === 'SINGLE_PRIMARY' ||
			this["oSapTable"]["sRowSelectionMode"] === 'SINGLE_PRIMARY_MANDATORY';

	if (eAccessType === this["oSapTable"]["ACCESS_TYPE"]["DRAG_OVER"]) {
		if (this["oDropDecoration"])
			this["oDropDecoration"]["update"](oBrowserEvent);

		if (!oAccessInfo) oAccessInfo = this["oSapTable"]["oGetAccessInfo"](oBrowserEvent, eAccessType);
		if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"]) this["handleBlockSelect"](oAccessInfo);
		if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"]) this["handleBlockSelect"](oAccessInfo);
		if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TR"]) this["handleBlockSelect"](oAccessInfo);
		if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BL"]) this["handleBlockSelect"](oAccessInfo);
		if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_CD_STANDARD"]) this["handleBlockSelect"](oAccessInfo);
		if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_CD_TOGGLE"]) this["handleBlockSelect"](oAccessInfo);

		if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["ROW_DRAG_SELECT"]) this["handleRowDragSelect"](oAccessInfo);

	} else if (eAccessType === this["oSapTable"]["ACCESS_TYPE"]["DRAG_LEAVE"]) {
		this["cleanUpDropDropArea"](oDragAndDropManager);
	} else if (eAccessType === this["oSapTable"]["ACCESS_TYPE"]["DRAG_START"]) {
		// General Preparation

		oAccessInfo = this["oSapTable"]["oGetAccessInfo"](oBrowserEvent, eAccessType);

		if (oAccessInfo) {
			if (oAccessInfo["eAction"] === this["oSapTable"]["ACTION"]["TABLE_V_RESIZE"]) {
				this["handleTableVerticalResize"](oAccessInfo);
			} else if (oAccessInfo["eAction"] === this["oSapTable"]["ACTION"]["COL_RESIZE"]) {
				this["handleColumnResize"](oAccessInfo);
			} else if (oAccessInfo["eAction"] === this["oSapTable"]["ACTION"]["BLOCK_SELECT"]) {
				this["handleBlockSelect"](oAccessInfo);
			} else if (oAccessInfo["eSubControlType"] === this["oSapTable"]["SUBCONTROL"]["HEADER_CELL"]) {
				this["handleColumnDragAndInsert"](oAccessInfo);
				if (this["oSapTable"]["bBlockSelectionActive"]() && !oAccessInfo["bHandled"]) {
					this["handleBlockSelect"](oAccessInfo);
				}
			} else if (oAccessInfo["eSubControlType"] === this["oSapTable"]["SUBCONTROL"]["SELECTION_CELL"] || (bRowSelectionMode && !bSingleRowSelectionMode && !oBrowserEvent["bAlt"]())) {
				if (this["oSapTable"]["bBlockSelectionActive"]() && !this["bRowDragPossible"](oBrowserEvent)) {
					// in case of row drag configuration and existing row selection prioritize row drag operation
					this["handleRowDragSelect"](oAccessInfo);
				}
			} else if (this["oSapTable"]["bBlockSelectionActive"]() && !this["bRowDragPossible"](oBrowserEvent)) {
					// in case of row drag configuration and existing row selection prioritize row drag operation
				this["handleBlockSelect"](oAccessInfo);
			}
		}
	} else {
		// Process dispatching
		oDragSession = oDragAndDropManager["oDragSession"];

		if (!oAccessInfo) oAccessInfo = this["oSapTable"]["oGetAccessInfo"](oBrowserEvent, eAccessType);

		if (oAccessInfo) {
			if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["TABLE_V_RESIZE"]) {
				this["handleTableVerticalResize"](oAccessInfo);
			} else if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["COL_RESIZE"]) {
				this["handleColumnResize"](oAccessInfo);
			} else if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"]) {
				this["handleBlockSelect"](oAccessInfo);
			} else if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"]) {
				this["handleBlockSelect"](oAccessInfo);
			} else if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TR"]) {
				this["handleBlockSelect"](oAccessInfo);
			} else if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BL"]) {
				this["handleBlockSelect"](oAccessInfo);
			} else if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_CD_STANDARD"]) {
				this["handleBlockSelect"](oAccessInfo);
			} else if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_CD_TOGGLE"]) {
				this["handleBlockSelect"](oAccessInfo);
			} else if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["COL_DRAG"]) {
				var oResizeInfo = oDragSession["oGetCustomData"](),
					bInternalInsert = false;

				// Check if this should be handled as external or internal insert mode. Internal means source and target in the same table
				if (oResizeInfo["sDragSourceTableId"] === this["oSapTable"]["sId"]) {
					if (oResizeInfo["bLegacyReorderMode"]) { //In legacy mode it is an insert
						bInternalInsert = true;
					} else { // In non legacy mode it is only an insert when there is a parent info
						var oDropCellInfo = this["oSapTable"]["oGetHeaderCellInfoByDomRef"](oAccessInfo["oSubControlDomRef"]);

						if (oDropCellInfo && this["sGetHeaderParentDropFlavors"](oDropCellInfo["oDomRefCell"], oResizeInfo["bLegacyReorderMode"]))
							bInternalInsert = true;
					}
				}

				if (bInternalInsert) {
					this["handleColumnDragAndInsert"](oAccessInfo);
				} else if (!oResizeInfo["bLegacyReorderMode"]) {
					this["handleDragFromExternal"](oAccessInfo);
				}
			} else if (oDragSession["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["ROW_DRAG_SELECT"]) {
				this["handleRowDragSelect"](oAccessInfo);
			} else if (!oDragAndDropManager["bBrowserDragDrop"]) {
				this["handleDragFromExternal"](oAccessInfo);
			}

			// General cleanUp
			if (eAccessType === this["oSapTable"]["ACCESS_TYPE"]["DRAG_END"]) {
				this["cleanUpDragDrop"]();
				oAccessInfo["bHandled"] = true;
			}
		}
	}

	return this["oSapTable"]["bSetEventReturnState"](oBrowserEvent, oAccessInfo ? oAccessInfo["bHandled"] : false);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleDragDrop"] = 0; };
/* eslint-enable complexity */

/**
 * Handles the user interaction of resizing the height of the table itself
 *
 * @param {Object} oAccessInfo
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["handleTableVerticalResize"] = function (oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleTableVerticalResize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableDragDropDelegate.js(390): handleTableVerticalResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oAccessInfo) === "object", "typeof (oAccessInfo) === \"object\"", "SapTableDragDropDelegate.js(391): handleTableVerticalResize"); };

	if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_START"]) {
		// DRAG_START
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "TableResize DRAG_START in " + this["oSapTable"]["sId"], "SapTableDragDropDelegate.js(395): handleTableVerticalResize"); };
		var oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"],
			oDecorationBoundaries = null,
			oDecoration = null,
			iAvailableHeight = document["body"]["offsetHeight"] ? document["body"]["offsetHeight"] : window["innerHeight"], // if body is collapsed e.g. in standards
			iRowHeight = this["oSapTable"]["iRowHeight"],
			oTableRect = this["oGetObjectRect"](this["oSapTable"]["oDomRef"]),
			iMinVisibleRowCount = this["oSapTable"]["iGetMinVisibleContentRowCount"](),
			iMaxVisibleRowCount = this["oSapTable"]["iVisibleRowCount"] + Math["floor"](iAvailableHeight / iRowHeight),
			iSnapRange = iRowHeight / 2,
			iCurrHeight = 0,
			iOffset = -oAccessInfo["oAccessFragmentDomRef"]["offsetHeight"];

		oDecorationBoundaries = {
			"top": oTableRect["top"] + oTableRect["height"] - ((this["oSapTable"]["iVisibleRowCount"] - iMinVisibleRowCount) * iRowHeight),
			"left": oTableRect["left"],
			"width": oTableRect["width"],
			"height": iMaxVisibleRowCount * iRowHeight
		};

		oDecoration = new (UCF_ClassLoader["oGetClass"]("UCF_DragDropDecoration"))(this["oSapTable"]["oLS"], this["oSapTable"]["oDomRef"], oDecorationBoundaries);

		if (this["bUseOwnTableVerticalResizeDecoration"]()) oDecoration["setHiddenMode"](true);

		for (var i = iMinVisibleRowCount; i < iMaxVisibleRowCount; i++, iCurrHeight += iRowHeight) {
			oDecoration["addRasterPoint"](iCurrHeight + iOffset, iSnapRange, { "iVisibleRowCount": i });
		}

		var oDragSession = oDragAndDropManager["startDragSession"](this["oSapTable"]["sId"], "", UCF_DragSession["DRAG_TYPE"]["V_RESIZE"], oDecoration, null, null);

		oDragSession["setCustomType"](this["DRAG_CUSTOM_TYPE"]["TABLE_V_RESIZE"]);
		oDragSession["setCustomData"]({});

		oDecoration["init"](oDragAndDropManager["oDragSession"]);

		oAccessInfo["bHandled"] = true;

	} else if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG"]) {
		//DRAG
		oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"];
		var oRasterPoint = oDragAndDropManager["oGetDragDecoration"]() ? oDragAndDropManager["oGetDragDecoration"]()["oGetRasterPoint"]() : null;

		if (oRasterPoint) {
			this["updateTableVerticalResize"](oRasterPoint);
			oDragAndDropManager["oDragSession"]["oGetCustomData"]()["oLastAppliedRasterPoint"] = oRasterPoint;
		}
		oAccessInfo["bHandled"] = true;

	} else if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_END"]) {
		//DRAG_END
		oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"];
		var oLastAppliedRasterPoint = oDragAndDropManager["oDragSession"]["oGetCustomData"]()["oLastAppliedRasterPoint"];

		if (oLastAppliedRasterPoint) {

			this["oSapTable"]["looseFocus"]();

			this["oSapTable"]["fireTableResize"](
				this["oSapTable"]["sId"],
				oLastAppliedRasterPoint["iVisibleRowCount"]
			);
			oAccessInfo["bHandled"] = true;
		}
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleTableVerticalResize"] = 0; };

/**
 * Returns the rectangle spanned over all given segments
 *
 * @param {Array} aSegments
 *
 * @return {Object} the rectangle
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["oGetColSegmentsRect"] = function (aSegments) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetColSegmentsRect"]++; }; 
	var oRect = { "top": 0, "left": 0, "width": 0, "height": 0 },
		oFirstSegment = null,
		iMaxTop = this["iGetMaxTopOfRect"]();

	for (var iRowSegmentIndex = 0; iRowSegmentIndex < aSegments["length"]; iRowSegmentIndex++) {
		var oColSegment = aSegments[iRowSegmentIndex];

		if (!oFirstSegment) oFirstSegment = this["oGetObjectRect"](oColSegment["parentNode"]);
		oRect["height"] += oColSegment["parentNode"]["offsetHeight"];

	}

	oRect["width"] = oFirstSegment["width"];
	oRect["top"] = Math["max"](oFirstSegment["top"], iMaxTop);
	oRect["left"] = oFirstSegment["left"];
	oRect["height"] -= (iMaxTop !== -1 && oRect["top"] === iMaxTop) ? iMaxTop - oFirstSegment["top"] : 0;

	return oRect;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetColSegmentsRect"] = 0; };

/**
 * Checks if the scrollable segment needs to scroll while a drag drop operation to make the hidden elements visible
 * @private
 */

UCF_SapTableDragDropDelegate["prototype"]["updateScrollPositionByPull"] = function (oBrowserEvent, oPullRect, iScrollPos, iMinScrollPos, iMaxScrollPos) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["updateScrollPositionByPull"]++; }; 
	var iLeft = oPullRect["left"] + this["PULL_PADDING"],
		iRight = iLeft + (oPullRect["width"] - 2 * this["PULL_PADDING"]),
		iBeginPull = Math["min"](this["MAX_PULL"],
			window["UCF_System"]["bIsRTL"]
				? Math["max"](0, this["iGetPageX"](oBrowserEvent) - iRight)
				: Math["max"](0, iLeft - this["iGetPageX"](oBrowserEvent))
		),
		iEndPull = Math["min"](this["MAX_PULL"],
			window["UCF_System"]["bIsRTL"]
				? Math["max"](0, iLeft - this["iGetPageX"](oBrowserEvent))
				: Math["max"](0, this["iGetPageX"](oBrowserEvent) - iRight)
		);

	if (iBeginPull > 0 || iEndPull > 0) {
		var iResultScrollPos = 0;

		if (iBeginPull > 0) {
			if (iScrollPos < iMinScrollPos) return;
			iResultScrollPos = Math["max"](iMinScrollPos, Math["round"](iScrollPos - (this["MAX_SCROLL_STEP"] * (iBeginPull / this["MAX_PULL"]))));
		} else if (iEndPull > 0) {
			iResultScrollPos = Math["min"](iMaxScrollPos, Math["round"](iScrollPos + (this["MAX_SCROLL_STEP"] * (iEndPull / this["MAX_PULL"]))));
		}

		if (iResultScrollPos >= 0 && iScrollPos !== iResultScrollPos) {
			this["oSapTable"]["setHorizontalScrollPosition"](iResultScrollPos);
			this["oSapTable"]["updateHorizontalScrollDimensions"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["updateScrollPositionByPull"] = 0; };

/**
 * Checks while a Drag process if the given operation is done on a segment which is the standard horizontal scroll segment
 *
 * @param {Object} oResizeInfo
 *
 * @return {boolean} true if the segment is the standard scroll segment
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["bDragProcessInStandardSegment"] = function (oResizeInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bDragProcessInStandardSegment"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bDragProcessInStandardSegment"] = 0; };

UCF_SapTableDragDropDelegate["prototype"]["iGetMaxTopOfRect"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["iGetMaxTopOfRect"]++; }; 
	var oCellInfo = this["oSapTable"]["oGetCellInfo"](0, 0),
		oLastCellInfo = oCellInfo;

	while (oCellInfo != null && this["oSapTable"]["eGetCellType"](oCellInfo) === this["oSapTable"]["SUBCONTROL"]["HEADER_CELL"]) {
		oLastCellInfo = oCellInfo;
		oCellInfo = this["oSapTable"]["oGetCellInfo"](oCellInfo["iRowIndex"] + 1, 0);
	}

	if (oLastCellInfo) {
		var oRect = this["oGetObjectRect"](oLastCellInfo["oDomRefCell"]);

		return oRect["top"] + oRect["height"];
	}

	return -1;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["iGetMaxTopOfRect"] = 0; };

/**
 * A hook to adapt the visualization of the table when the user tries to de/increase the table height
 *
 * @param {Object} oRasterPoint
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["updateTableVerticalResize"] = function (oRasterPoint) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["updateTableVerticalResize"]++; }; 
	//Do nothing
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["updateTableVerticalResize"] = 0; };

/**
 * True if no standard visualization should be used
 *
 * @return {boolean} True if no standard visualization should be used
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["bUseOwnTableVerticalResizeDecoration"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bUseOwnTableVerticalResizeDecoration"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bUseOwnTableVerticalResizeDecoration"] = 0; };

/**
 * Returns the first cell of a given row and segment
 *
 * @param {number} iRowIndex
 * @param {Object} oSegment
 *
 * @return {Object} the cell info of the cell
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["oGetFirstCellOfSegment"] = function (iRowIndex, oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetFirstCellOfSegment"]++; }; 
	return this["oSapTable"]["oGetCellInfo"](iRowIndex, 0);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetFirstCellOfSegment"] = 0; };

/**
 * Collects all segments arranged above and below the given segment and returns a rectangle over all collected segments
 *
 * @param {Object} oSegment
 *
 * @return {Object} the rectangle
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["oGetSegmentsVisibleRect"] = function (oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetSegmentsVisibleRect"]++; }; 
	return this["oGetColSegmentsRect"]([oSegment]);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetSegmentsVisibleRect"] = 0; };

/**
 * Returns the segment whcih is horizontally scrollable
 *
 * @return {Object} the rectangle
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["oGetScrollSegment"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetScrollSegment"]++; }; 
	return this["oSapTable"]["oGetFirstContentScrollSegment"]();
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetScrollSegment"] = 0; };

/**
 * Checks if the dimension of a column given by a CellInfo is arranged table based or column based
 *
 * @param {Object} oCellInfo
 *
 * @return {boolean} true if table based
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["bHasTableBasedColumnWidths"] = function (oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bHasTableBasedColumnWidths"]++; }; 
	return this["oSapTable"]["bHasSegmentTableBasedColumnWidths"](this["oSapTable"]["oGetSegmentByCellInfo"](oCellInfo));
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bHasTableBasedColumnWidths"] = 0; };

/**
 * Creates the HTML DOM of a ghost representing a column
 *
 * @param {Object} oDomRefDragFragment
 *
 * @return {Object} the ghost's DOM ref
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["oCreateColumnGhost"] = function (oDomRefDragFragment) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oCreateColumnGhost"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefDragFragment != null, "oDomRefDragFragment != null", "SapTableDragDropDelegate.js(633): oCreateColumnGhost"); };

	var oDomRefGhost = oDomRefDragFragment["cloneNode"](true);
	oDomRefGhost["style"]["width"] = oDomRefDragFragment["offsetWidth"] + "px";
	oDomRefGhost["style"]["height"] = oDomRefDragFragment["offsetHeight"] + "px";

	var oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDomRefGhost);
	oGhost["setOffset"](12, 12);

	if (oDomRefDragFragment["tagName"] === "TR") {
		for (var i = 0; i < oDomRefDragFragment["cells"]["length"]; i++) {
			oDomRefGhost["cells"][i]["width"] = oDomRefDragFragment["cells"][i]["offsetWidth"];
		}
	}
	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oCreateColumnGhost"] = 0; };

/**
 * When the darg session is a drag from external this method is called by the central event handler
 * A external drag is a drag which has not been made in a SapTable (e.g. an Image is dragged over an SapTable)
 *
 * @param {Object} oAccessInfo
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["handleDragFromExternal"] = function (oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleDragFromExternal"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableDragDropDelegate.js(658): handleDragFromExternal"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oAccessInfo) === "object", "typeof (oAccessInfo) === \"object\"", "SapTableDragDropDelegate.js(659): handleDragFromExternal"); };

	var oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"],
		oDragSession = oDragAndDropManager["oDragSession"],
		sValidMimeTypes = "";

	if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_ENTER"]) {
		//DRAG_ENTER

		var oDropHeaderCellInfo = this["oSapTable"]["oGetHeaderCellInfoByDomRef"](oAccessInfo["oSubControlDomRef"]),
			oResizeInfo = oDragSession["oGetCustomData"]();

		if (!oResizeInfo) {
			oResizeInfo = {};
			oDragSession["setCustomData"](oResizeInfo);
		}

		if (oDropHeaderCellInfo) {
			var oDomRefCell = oDropHeaderCellInfo["oDomRefCell"],
				bAllowed = false,
				sDropFlavors = null;

			//Check insert before drop tags are checked
			sDropFlavors = this["sGetHeaderParentDropFlavors"](oDomRefCell, oResizeInfo["bLegacyReorderMode"]);
			sValidMimeTypes = this["sGetHeaderParentDropValidMimeTypes"](oDomRefCell);
			bAllowed = sDropFlavors ? oDragAndDropManager["bGetDropAllowed"](sDropFlavors, sValidMimeTypes) : false;

			if (bAllowed) {
				oResizeInfo["bAllowDropInsert"] = true;
			} else {
				//Check drop
				sDropFlavors = this["sGetHeaderDropFlavors"](oDomRefCell);
				sValidMimeTypes = this["sGetHeaderDropValidMimeTypes"](oDomRefCell);
				bAllowed = sDropFlavors ? oDragAndDropManager["bGetDropAllowed"](sDropFlavors, sValidMimeTypes) : false;

				if (bAllowed) oResizeInfo["bAllowDropInsert"] = false;
			}

			if (bAllowed) {
				if (oResizeInfo["bAllowDropInsert"]) { // Insert mode
					this["handleColumnDragAndInsert"](oAccessInfo);
				} else {
					oDragAndDropManager["initDropArea"](UCF_DragSession["DROP_TYPE"]["STANDARD"], sDropFlavors, null);
				}
			}
		}

	} else if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_LEAVE"]) {
		//DRAG_LEAVE
		this["cleanUpDropDropArea"](oDragAndDropManager);
	} else if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DROP"]) {
		//DROP
		this["fireDropInternal"](oAccessInfo);
		this["cleanUpDragDrop"](oDragAndDropManager);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleDragFromExternal"] = 0; };

/**
 * Fires the Drop event if valid
 *
 * @param {Object} oAccessInfo
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["fireDropInternal"] = function (oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["fireDropInternal"]++; }; 
	var oDropCellInfo = this["oSapTable"]["oGetHeaderCellInfoByDomRef"](oAccessInfo["oSubControlDomRef"]),
		oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"],
		oDragSession = oDragAndDropManager["oDragSession"],
		oResizeInfo = oDragSession["oGetCustomData"]();

	if (oResizeInfo
		&& oDropCellInfo
		&& !this["sGetDropFlavorsByDomRef"](oDropCellInfo["oDomRefCell"])
		&& oDragAndDropManager["bGetDropAllowed"](
			oResizeInfo["bAllowDropInsert"] ?
				this["sGetHeaderParentDropFlavors"](oDropCellInfo["oDomRefCell"], false) :
				this["sGetHeaderDropFlavors"](oDropCellInfo["oDomRefCell"]),
			this["sGetHeaderDropValidMimeTypes"](oDropCellInfo["oDomRefCell"])
		)
	) {
		var oDropPosition = oDragSession["oGetDropPosition"](),
			iPosX = oDropPosition["left"],
			iPosY = oDropPosition["top"],
			oRasterPoint = oDragAndDropManager["oGetDropDecoration"]() ? oDragAndDropManager["oGetDropDecoration"]()["oGetRasterPoint"]() : null,
			iOffset = (oRasterPoint) ? (oRasterPoint["bInsertModeBefore"] ? -1 : 1) : 0;
		//	sDropTargetInfo = oResizeInfo.bAllowDropInsert?
		//		this.oSapTable.sGetColumnParentDropTargetInfo(oDropCellInfo):
		//		this.oSapTable.sGetColumnDropTargetInfo(oDropCellInfo);

		this["oSapTable"]["looseFocus"]();

		this["oSapTable"]["fireDrop"](
			this["oSapTable"]["sId"],
			oResizeInfo["sDragFragmentId"] ? oResizeInfo["sDragFragmentId"] : oDragSession["sGetDragSourceId"](),
			oResizeInfo["bAllowDropInsert"] ? this["oSapTable"]["sGetColumnParentDropTargetInfo"](oDropCellInfo) : this["oSapTable"]["sGetColumnDropTargetInfo"](oDropCellInfo),

			//Table specific event parameters
			this["oSapTable"]["sGetCellId"](oDropCellInfo),
			this["oSapTable"]["iGetAppDefinedRowIndex"](oDropCellInfo),
			this["oSapTable"]["iGetAppDefinedColIndex"](oDropCellInfo),
			"HORIZONTAL",
			iOffset,
			-1,

			oDragSession["sGetDragData"]() ? oDragSession["sGetDragData"]() : "",
			oDragSession["sGetMimeType"]() ? oDragSession["sGetMimeType"]() : "",
			oDragSession["sGetDragTags"](),
			oDragSession["iGetMouseButtonState"](),
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);
		oAccessInfo["bHandled"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["fireDropInternal"] = 0; };

/**
 * Handle column reorder
 *
 * @param {Object} oAccessInfo
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["handleColumnDragAndInsert"] = function (oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleColumnDragAndInsert"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableDragDropDelegate.js(781): handleColumnDragAndInsert"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oAccessInfo) === "object", "typeof (oAccessInfo) === \"object\"", "SapTableDragDropDelegate.js(782): handleColumnDragAndInsert"); };

	var oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"];

	if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_START"]) {
		if (oAccessInfo["eSubControlType"] === this["oSapTable"]["SUBCONTROL"]["HEADER_CELL"]) {
			//DRAG_START
			var sDragFlavors = this["sGetDragFlavorsByDomRef"](oAccessInfo["oCellInfo"]["oDomRefCell"]),
				bLegacyReorderMode = false;

			if (sDragFlavors) {
				bLegacyReorderMode = true;
			} else {
				sDragFlavors = this["sGetHeaderDragFlavors"](oAccessInfo["oCellInfo"]["oDomRefCell"]);
			}

			if (sDragFlavors) {
				var oDragSession = oDragAndDropManager["startDragSession"](this["oSapTable"]["sId"], sDragFlavors, UCF_DragSession["DRAG_TYPE"]["STANDARD"], null, this["oCreateColumnGhost"](oAccessInfo["oSubControlDomRef"]), null),
					oDragSourceInfo = bLegacyReorderMode ? null : this["oGetHeaderDragSourceInfo"](oAccessInfo["oCellInfo"]);

				if (oDragSourceInfo) {
					oDragSession["setDragData"](oDragSourceInfo["sGetData"](), oDragSourceInfo["sGetMimeType"]());
				}

				oDragSession["setCustomType"](this["DRAG_CUSTOM_TYPE"]["COL_DRAG"]);
				oDragSession["setCustomData"]({
					"sDragSourceTableId": this["oSapTable"]["sId"],
					"sDragFragmentId": oAccessInfo["sSubControlId"],
					"oSegment": this["oSapTable"]["oGetSegmentByCellInfo"](oAccessInfo["oCellInfo"]),
					"bLegacyReorderMode": bLegacyReorderMode
				});
				oAccessInfo["bHandled"] = true;
			}
		}
	} else if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_ENTER"]) {
		//DRAG_ENTER
		var oDropCellInfo = this["oSapTable"]["oGetHeaderCellInfoByDomRef"](oAccessInfo["oSubControlDomRef"]),
			oDropCellInfoBefore = oDropCellInfo ? this["oSapTable"]["oGetCellInfo"](oDropCellInfo["iRowIndex"], oDropCellInfo["iColIndex"] - 1) : null,
			oDropCellInfoAfter = oDropCellInfo ? this["oSapTable"]["oGetCellInfo"](oDropCellInfo["iRowIndex"], oDropCellInfo["iColIndex"] + oDropCellInfo["iColSpan"]) : null;

		this["handleStandardColumnInsertDragEnter"](
			oDragAndDropManager,
			UCF_DomUtil["$"](this["oSapTable"]["sId"] + "-" + this["oSapTable"]["SUFFIX"]["CONTENT_AREA"]),
			oDropCellInfo ? oDropCellInfo["oDomRefCell"] : null,
			oDropCellInfoBefore ? oDropCellInfoBefore["oDomRefCell"] : null,
			oDropCellInfoAfter ? oDropCellInfoAfter["oDomRefCell"] : null,
			oAccessInfo
		);

	} else if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_LEAVE"]) {
		//DRAG_LEAVE
		this["cleanUpDropDropArea"](oDragAndDropManager);
	} else if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DROP"]) {
		//DROP
		var oResizeInfo = oDragAndDropManager["oDragSession"]["oGetCustomData"]();

		if (oResizeInfo && oResizeInfo["bLegacyReorderMode"] && this["oSapTable"]["mEvents"]["ColumnReorder"]) {
			var oRasterPoint = oDragAndDropManager["oGetDropDecoration"]() ? oDragAndDropManager["oGetDropDecoration"]()["oGetRasterPoint"]() : null;

			if (oRasterPoint) {

				this["oSapTable"]["looseFocus"]();

				this["oSapTable"]["fireColumnReorder"](
					this["oSapTable"]["sId"],
					oResizeInfo["sDragFragmentId"],
					oRasterPoint["sInsertRefId"],
					oRasterPoint["bInsertModeBefore"] ? this["oSapTable"]["EVENT_PARAM_MAP_INSERT_MODE"]["BEFORE"] : this["oSapTable"]["EVENT_PARAM_MAP_INSERT_MODE"]["AFTER"]
				);
				oAccessInfo["bHandled"] = true;
			}
		} else {
			this["fireDropInternal"](oAccessInfo);
		}

		this["cleanUpDragDrop"](oDragAndDropManager);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleColumnDragAndInsert"] = 0; };

/**
 * Handle column resize
 *
 * @param {Object} oAccessInfo
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["handleColumnResize"] = function (oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleColumnResize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableDragDropDelegate.js(868): handleColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oAccessInfo) === "object", "typeof (oAccessInfo) === \"object\"", "SapTableDragDropDelegate.js(869): handleColumnResize"); };

	// no column resize at right mouse drag - avoid conflict with column selection and context menu
	var iMouseButtonState = oAccessInfo["oBrowserEvent"]["eGetMouseButtonState"]();
	if (iMouseButtonState === oAccessInfo["oBrowserEvent"]["MOUSE_BUTTON_STATE"]["Right"]) return;

	if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_START"]) {

		//DRAG_START
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "ColumnResize DRAG_START in " + this["oSapTable"]["sId"], "SapTableDragDropDelegate.js(878): handleColumnResize"); };
		var oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"],
			oResizeInfo = null,
			oDecoration = null,
			oHeaderRect = null,
			oSegmentsVisibleRect = null,
			oDecorationBoundaries = null;

		oResizeInfo = this["oInitColumnResize"](oAccessInfo, this["oSapTable"]["oGetHeaderCellInfoByDomRef"](oAccessInfo["oSubControlDomRef"]));

		if (oResizeInfo && oResizeInfo["bIsValidResizeOperation"]) {
			if (oResizeInfo["oDecorationBoundaries"]) {
				oDecorationBoundaries = oResizeInfo["oDecorationBoundaries"];
			} else {
				//Default
				oHeaderRect = oResizeInfo["oInitialSrcCellRect"];
				oSegmentsVisibleRect = oResizeInfo["oSegmentsVisibleRect"];

				oDecorationBoundaries = {
					"top": oHeaderRect["top"] + oHeaderRect["height"],
					"left": oResizeInfo["iMinHorizontalMove"],
					"width": oResizeInfo["iMaxHorizontalMove"] - oResizeInfo["iMinHorizontalMove"],
					"height": oSegmentsVisibleRect["height"] - (oHeaderRect["top"] - oSegmentsVisibleRect["top"] + oHeaderRect["height"])
				};
			}

			oDecoration = new (UCF_ClassLoader["oGetClass"]("UCF_DragDropDecoration"))(this["oSapTable"]["oLS"], this["oSapTable"]["oDomRef"], oDecorationBoundaries);

			var oDragSession = oDragAndDropManager["startDragSession"](this["oSapTable"]["sId"], "", UCF_DragSession["DRAG_TYPE"]["H_RESIZE"], oDecoration, null, null);
			oDragSession["setCustomType"](this["DRAG_CUSTOM_TYPE"]["COL_RESIZE"]);
			oDragSession["setCustomData"](oResizeInfo);

			oDecoration["init"](oDragAndDropManager["oDragSession"]);

			oAccessInfo["bHandled"] = true;
		}
	}
	if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_END"]) {
		//DRAG_END
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "ColumnResize DRAG_END in " + this["oSapTable"]["sId"], "SapTableDragDropDelegate.js(917): handleColumnResize"); };
		oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"];
		oResizeInfo = oDragAndDropManager["oDragSession"]["oGetCustomData"]();

		oResizeInfo["iResultWidth"] = -1;

		this["calculateColumnResize"](oAccessInfo, oResizeInfo);

		if (this["oSapTable"]["bColumnTitleAdoption"]) {
			this["oSapTable"]["adjustHeaderCellCaptions"]();
		}

		this["internalFireColumnResize"](oResizeInfo);
		this["cleanUpColumnResize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleColumnResize"] = 0; };

/**
 * Handle block selection
 *
 * @param {Object} oAccessInfo
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["handleBlockSelect"] = function (oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleBlockSelect"]++; }; 
	var oBSRefPoint;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableDragDropDelegate.js(943): handleBlockSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oAccessInfo) === "object", "typeof (oAccessInfo) === \"object\"", "SapTableDragDropDelegate.js(944): handleBlockSelect"); };

	var iTopLeftCol = -1;
	var iTopLeftRow = -1;
	var iBottomRightCol = -1;
	var iBottomRightRow = -1;
	var oBlockSelection = null;
	var oCellInfo = null;
	var oFocusInfo = null;
	var sBlockSelectionMode = '';
	var sDragCustomType = '';
	var oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"];

	if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_START"]) {
		if (oDragAndDropManager) {
			oDragAndDropManager["startDragSession"](this["sId"], null, UCF_DragSession["DRAG_TYPE"]["BLOCK_SELECT"], null, null, null);
			if (oAccessInfo["oBrowserEvent"]["oSource"]["getAttribute"]("id") === this["oSapTable"]["sId"] + "-BSHandleTL") oDragAndDropManager["oDragSession"]["setCustomType"](this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"]);
			else if (oAccessInfo["oBrowserEvent"]["oSource"]["getAttribute"]("id") === this["oSapTable"]["sId"] + "-BSHandleBR") oDragAndDropManager["oDragSession"]["setCustomType"](this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"]);
			else if (oAccessInfo["oBrowserEvent"]["oSource"]["getAttribute"]("id") === this["oSapTable"]["sId"] + "-BSHandleTR") oDragAndDropManager["oDragSession"]["setCustomType"](this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TR"]);
			else if (oAccessInfo["oBrowserEvent"]["oSource"]["getAttribute"]("id") === this["oSapTable"]["sId"] + "-BSHandleBL") oDragAndDropManager["oDragSession"]["setCustomType"](this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BL"]);
			else {
				//click and drag
				oCellInfo = oAccessInfo["oCellInfo"];

				if (!oCellInfo) return;
				if (!this["oSapTable"]["bCellSupportsBlockSelection"](oCellInfo)) return;

				iTopLeftCol = oCellInfo["iColIndex"];
				iTopLeftRow = oCellInfo["iRowIndex"];
				iBottomRightCol = oCellInfo["iColIndex"];
				iBottomRightRow = oCellInfo["iRowIndex"];

				if (oAccessInfo["oBrowserEvent"]["_bCtrl"]) {
					sBlockSelectionMode = this["oSapTable"]["BLOCKSELECTION_MODE"]["TRANSFORM"];
					oDragAndDropManager["oDragSession"]["setCustomType"](this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_CD_TOGGLE"]);
				}
				else {
					sBlockSelectionMode = this["oSapTable"]["BLOCKSELECTION_MODE"]["INITIALIZE"];
					oDragAndDropManager["oDragSession"]["setCustomType"](this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_CD_STANDARD"]);
				}

				oBlockSelection = { 'TopLeftCol': iTopLeftCol, 'TopLeftRow': iTopLeftRow, 'BottomRightCol': iBottomRightCol, 'BottomRightRow': iBottomRightRow };
				this["oSapTable"]["setBlockSelectionInternal"](oBlockSelection, sBlockSelectionMode, true, true);
				this["oSapTable"]["oBSRefPoint"] = { 'RefCol': this["oSapTable"]["oBlockSelection"]["TopLeftCol"], 'RefRow': this["oSapTable"]["oBlockSelection"]["TopLeftRow"] };
			}

			oBSRefPoint = {};
			if (oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"]) {
				oBSRefPoint = { 'RefCol': this["oSapTable"]["oBlockSelection"]["TopLeftCol"], 'RefRow': this["oSapTable"]["oBlockSelection"]["TopLeftRow"] };
				this["oSapTable"]["oBSRefPoint"] = {"RefCol": this["oSapTable"]["oBlockSelection"]["TopLeftCol"], "RefRow": this["oSapTable"]["oBlockSelection"]["TopLeftRow"]};
			}
			if (oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"]) {
				oBSRefPoint = { 'RefCol': this["oSapTable"]["oBlockSelection"]["BottomRightCol"], 'RefRow': this["oSapTable"]["oBlockSelection"]["BottomRightRow"] };
				this["oSapTable"]["oBSRefPoint"] = {"RefCol": this["oSapTable"]["oBlockSelection"]["BottomRightCol"], "RefRow": this["oSapTable"]["oBlockSelection"]["BottomRightRow"]};
			}
			if (oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TR"]) {
				oBSRefPoint = { 'RefCol': this["oSapTable"]["oBlockSelection"]["TopLeftCol"], 'RefRow': this["oSapTable"]["oBlockSelection"]["BottomRightRow"] };
				this["oSapTable"]["oBSRefPoint"] = {"RefCol": this["oSapTable"]["oBlockSelection"]["TopLeftCol"], "RefRow": this["oSapTable"]["oBlockSelection"]["BottomRightRow"]};
			}
			if (oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BL"]) {
				oBSRefPoint = { 'RefCol': this["oSapTable"]["oBlockSelection"]["BottomRightCol"], 'RefRow': this["oSapTable"]["oBlockSelection"]["TopLeftRow"] };
				this["oSapTable"]["oBSRefPoint"] = {"RefCol": this["oSapTable"]["oBlockSelection"]["BottomRightCol"], "RefRow": this["oSapTable"]["oBlockSelection"]["TopLeftRow"]};
			}
			if (oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_CD_STANDARD"]) {
				oBSRefPoint = { 'RefCol': this["oSapTable"]["oBlockSelection"]["TopLeftCol"], 'RefRow': this["oSapTable"]["oBlockSelection"]["TopLeftRow"] };
			}
			if (oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["sGetCustomType"]() === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_CD_TOGGLE"]) {
				oBSRefPoint = { 'RefCol': this["oSapTable"]["oBlockSelection"]["TopLeftCol"], 'RefRow': this["oSapTable"]["oBlockSelection"]["TopLeftRow"] };
			}
			oDragAndDropManager["oDragSession"]["setCustomData"](oBSRefPoint);

			this["oSapTable"]["adjustRowToBlockSelection"](oAccessInfo, this["oSapTable"]["oBlockSelection"]);
			this["oSapTable"]["adjustColumnToBlockSelection"](oAccessInfo, this["oSapTable"]["oBlockSelection"]);
		}
	}

	if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_OVER"]) {

		oCellInfo = this["oSapTable"]["oGetCellInfoByDomRef"](oAccessInfo["oBrowserEvent"]["oSource"]);
		oBlockSelection = { 'TopLeftCol': this["oSapTable"]["oBlockSelection"]["TopLeftCol"], 'TopLeftRow': this["oSapTable"]["oBlockSelection"]["TopLeftRow"], 'BottomRightCol': this["oSapTable"]["oBlockSelection"]["BottomRightCol"], 'BottomRightRow': this["oSapTable"]["oBlockSelection"]["BottomRightRow"] };
		oBSRefPoint = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"]["oDragSession"]["oGetCustomData"]();

		if (!oCellInfo) return;
		if (!this["oSapTable"]["bCellSupportsBlockSelection"](oCellInfo)) return;

		oBlockSelection["TopLeftCol"] = Math["min"](oBSRefPoint["RefCol"], oCellInfo["iColIndex"]);
		oBlockSelection["TopLeftRow"] = Math["min"](oBSRefPoint["RefRow"], oCellInfo["iRowIndex"]);
		oBlockSelection["BottomRightCol"] = Math["max"](oBSRefPoint["RefCol"], oCellInfo["iColIndex"]);
		oBlockSelection["BottomRightRow"] = Math["max"](oBSRefPoint["RefRow"], oCellInfo["iRowIndex"]);

		//store current Cell for setting focus at dragend
		this["oSapTable"]["oBSFocus"] = null;
		this["oSapTable"]["oBSFocus"] = { 'FocusCol': oCellInfo["iColIndex"], 'FocusRow': oCellInfo["iRowIndex"] };

		//scan block range to check wether merged cell do enhance
		for (var col = oBlockSelection["TopLeftCol"]; col <= oBlockSelection["BottomRightCol"]; col++) {
			for (var row = oBlockSelection["TopLeftRow"]; row <= oBlockSelection["BottomRightRow"]; row++) {
				oCellInfo = this["oSapTable"]["oGetCellInfo"](row, col);

				oBlockSelection["TopLeftCol"] = Math["min"](oBlockSelection["TopLeftCol"], oCellInfo["iColIndex"]);
				oBlockSelection["TopLeftRow"] = Math["min"](oBlockSelection["TopLeftRow"], oCellInfo["iRowIndex"]);
				oBlockSelection["BottomRightCol"] = Math["max"](oBlockSelection["BottomRightCol"], oCellInfo["iColIndex"] + oCellInfo["iColSpan"] - 1);
				oBlockSelection["BottomRightRow"] = Math["max"](oBlockSelection["BottomRightRow"], oCellInfo["iRowIndex"] + oCellInfo["iRowSpan"] - 1);
			}
		}

		this["oSapTable"]["setBlockSelectionInternal"](oBlockSelection, this["oSapTable"]["BLOCKSELECTION_MODE"]["NEUTRAL"], true, true);
		// this.oSapTable.adjustRowToBlockSelection(oAccessInfo, oBlockSelection);
		// this.oSapTable.adjustColumnToBlockSelection(oAccessInfo, oBlockSelection);
	}

	if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_END"]) {
		if (this["oSapTable"]["oBSFocus"]) {
			oCellInfo = this["oSapTable"]["oGetCellInfo"](this["oSapTable"]["oBSFocus"]["FocusRow"], this["oSapTable"]["oBSFocus"]["FocusCol"]);
			// set dragstate to no_drag in order to unlock BrowserWindow in order to get focusChange event -> TODO
			oDragAndDropManager["setDragState"](oDragAndDropManager["E_DRAGSTATE"]["NoDrag"]);
			this["oSapTable"]["setCellMatrixFocusByCellInfo"](oCellInfo);

			this["oSapTable"]["eFocusBehavior"] = this["oSapTable"]["FOCUS_BEHAVIOR"]["CELL"];
			oFocusInfo = new (UCF_ClassLoader["oGetClass"]("UCF_FocusInfo"))(this["oLS"]);
			oFocusInfo["init"](UCF_DomUtil["oGetActiveElement"]());
			this["oSapTable"]["sFocusInfo"] = oFocusInfo["sSerialize"]();
			oFocusInfo["cleanUp"]();
		}

		this["oSapTable"]["aNeutralBlockSelectionCells"] = [];
		for (col = this["oSapTable"]["oBlockSelection"]["TopLeftCol"]; col <= this["oSapTable"]["oBlockSelection"]["BottomRightCol"]; col++) {
			for (row = this["oSapTable"]["oBlockSelection"]["TopLeftRow"]; row <= this["oSapTable"]["oBlockSelection"]["BottomRightRow"]; row++) {
				oCellInfo = this["oSapTable"]["oGetCellInfo"](row, col);
				this["oSapTable"]["aNeutralBlockSelectionCells"]["push"](oCellInfo);
			}
		}
		sDragCustomType = oDragAndDropManager["oDragSession"]["sGetCustomType"]();
		this["oSapTable"]["fireBlockSelect"](this["oSapTable"]["sId"],
			UCF_JsUtil["sJsonStringify"](this["oSapTable"]["oEnrichBSProperties"](this["oSapTable"]["oBlockSelection"])),
			sDragCustomType === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_CD_STANDARD"] ? this["oSapTable"]["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"] :
			(sDragCustomType === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BR"] || sDragCustomType === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_BL"] ||
			sDragCustomType === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TL"] || sDragCustomType === this["DRAG_CUSTOM_TYPE"]["BLOCK_SELECT_TR"]) ? this["oSapTable"]["EVENT_PARAM_MAP_ACCESS_TYPE"]["UPDATE"] : this["oSapTable"]["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]
			);
	}

	oAccessInfo["oBrowserEvent"]["cancel"]();
	oAccessInfo["oBrowserEvent"]["cancelBubble"]();
	oAccessInfo["oBrowserEvent"]["bHandled"] = true;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleBlockSelect"] = 0; };

/**
 * Handle row drag and select at selection cells
 *
 * @param {Object} oAccessInfo
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["handleRowDragSelect"] = function (oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleRowDragSelect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableDragDropDelegate.js(1098): handleRowDragSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oAccessInfo) === "object", "typeof (oAccessInfo) === \"object\"", "SapTableDragDropDelegate.js(1099): handleRowDragSelect"); };

	if (this["oSapTable"]["sRowSelectionMode"] === 'NONE' || this["oSapTable"]["sRowSelectionMode"] === 'SERVER' ||
			this["oSapTable"]["sRowSelectionMode"] === 'SINGLE' || this["oSapTable"]["sRowSelectionMode"] === 'SINGLE_PRIMARY' || this["oSapTable"]["sRowSelectionMode"] === 'SINGLE_PRIMARY_MANDATORY' ||
			(this["oSapTable"]["sRowSelectionClientBehaviour"] !== 'SMART' &&
			this["oSapTable"]["sRowSelectionClientBehaviour"] !== 'WEB' &&
			this["oSapTable"]["sRowSelectionClientBehaviour"] !== 'WEB_SMART' &&
			this["oSapTable"]["sRowSelectionClientBehaviour"] !== 'SERVER_WEB_SMART')) {
		return;
	}

	var oCellInfo = oAccessInfo["oCellInfo"];
	var oFocusCellInfo = null;
	var bToggle = oAccessInfo["oBrowserEvent"]["_bCtrl"];

	// WEB_SMART/SERVER_WEB_SMART -> at selection column always toggle
	if ((this["oSapTable"]["sRowSelectionClientBehaviour"] === 'WEB_SMART' || this["oSapTable"]["sRowSelectionClientBehaviour"] === 'SERVER_WEB_SMART')
			&& oAccessInfo["eSubControlType"] === this["oSapTable"]["SUBCONTROL"]["SELECTION_CELL"]) {
 		bToggle = true;
	}

	if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_START"]) {

		var oDragAndDropManager = oAccessInfo["oBrowserEvent"]["oDragAndDropManager"];

		if (oDragAndDropManager) {
			oDragAndDropManager["startDragSession"](this["sId"], null, UCF_DragSession["DRAG_TYPE"]["DRAG_SELECT"], null, null, null);
			oDragAndDropManager["oDragSession"]["setCustomType"](this["DRAG_CUSTOM_TYPE"]["ROW_DRAG_SELECT"]);
			this["oSapTable"]["setRowDragSelectStart"]();
			this["oSapTable"]["setRowSelectionReferenceIndex"](oCellInfo);
			this["oSapTable"]["sRowDragSelectAccess"] = bToggle ? this["oSapTable"]["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"] : this["oSapTable"]["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
			this["oSapTable"]["handleRowRangeSelectUI"](oCellInfo);
			this["oSapTable"]["setRowDragSelectActive"]();
		}
	}

	if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_OVER"]) {
		this["oSapTable"]["handleRowRangeSelectUI"](oCellInfo);
		this["oLastHoveredCellInfo"] = oCellInfo;
	}

	if (oAccessInfo["eAccessType"] === this["oSapTable"]["ACCESS_TYPE"]["DRAG_END"]) {
		this["oSapTable"]["resetRowDragSelectActive"]();
		if (this["oLastHoveredCellInfo"]) {
			this["oSapTable"]["handleRowRangeSelectUI"](this["oLastHoveredCellInfo"]);
			oFocusCellInfo = this["oSapTable"]["oGetCellInfo"](this["oLastHoveredCellInfo"]["iRowIndex"], oCellInfo["iColIndex"]);
			this["oSapTable"]["setCellMatrixFocusByCellInfo"](oFocusCellInfo);
			this["oSapTable"]["eFocusBehavior"] = this["oSapTable"]["FOCUS_BEHAVIOR"]["CELL"];
			this["oSapTable"]["handleRowRangeSelectEvent"](oCellInfo, this["oSapTable"]["sRowDragSelectAccess"]);
			this["oSapTable"]["handleRowRangeSelectEvent"](this["oLastHoveredCellInfo"], this["oSapTable"]["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"]);
			this["oSapTable"]["sRowDragSelectAccess"] = '';
		}
	}

	oAccessInfo["oBrowserEvent"]["cancel"]();
	oAccessInfo["oBrowserEvent"]["cancelBubble"]();
	oAccessInfo["oBrowserEvent"]["bHandled"] = true;

};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleRowDragSelect"] = 0; };

UCF_SapTableDragDropDelegate["prototype"]["simulateDragDropColumnResize"] = function (oAccessInfo, iPxResultWidth, bLooseFocus) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["simulateDragDropColumnResize"]++; }; 
	var oSourceHeaderCellInfo = oAccessInfo["oCellInfo"],
		oResizeInfo = this["oInitColumnResize"](oAccessInfo, oSourceHeaderCellInfo);

	oResizeInfo["iResultWidth"] = Math["min"](
		Math["max"](oResizeInfo["iMinColumnWidth"], oResizeInfo["iMaxColumnWidth"] > -1 ? oResizeInfo["iMaxColumnWidth"] : iPxResultWidth), iPxResultWidth
	);

	this["calculateColumnResize"](oAccessInfo, oResizeInfo);
	this["internalFireColumnResize"](oResizeInfo, bLooseFocus);
	this["cleanUpColumnResize"]();
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["simulateDragDropColumnResize"] = 0; };

/**
 * Fires the resize event after a user column resize action
 *
 * @param {Object} oResizeInfo
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["internalFireColumnResize"] = function (oResizeInfo, bLooseFocus) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["internalFireColumnResize"]++; }; 
	if (bLooseFocus) this["oSapTable"]["looseFocus"]();
	this["oSapTable"]["fireColumnResize"](this["oSapTable"]["sId"], oResizeInfo["sColWidths"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["internalFireColumnResize"] = 0; };

/**
 * Checks if the column is resizable
 *
 * @param {Object} oHeaderCellInfo
 *
 * @return {boolean}
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["bIsColumnResizable"] = function (oHeaderCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bIsColumnResizable"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oHeaderCellInfo != null, "oHeaderCellInfo != null", "SapTableDragDropDelegate.js(1192): bIsColumnResizable"); };
	return oHeaderCellInfo["oDomRefCell"]["getAttribute"]("resizable") != null;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bIsColumnResizable"] = 0; };

/**
 * Cleanup of the column resize operation
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["cleanUpColumnResize"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["cleanUpColumnResize"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["cleanUpColumnResize"] = 0; };

/**
 * Creates the resize object which is needed for a resize process
 *
 * @param {Object} oSrcCellInfo
 *
 * @return {Object}
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["oInitColumnResizeObject"] = function (oAccessInfo, oSrcCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oInitColumnResizeObject"]++; }; 
	var oResizeInfo = {};

	//Init the info object
	oResizeInfo["oSegment"] = this["oSapTable"]["oGetSegmentByCellInfo"](oSrcCellInfo);
	oResizeInfo["oSrcCellInfo"] = oSrcCellInfo;
	oResizeInfo["oSegmentsVisibleRect"] = this["oGetSegmentsVisibleRect"](oResizeInfo["oSegment"]);
	oResizeInfo["oInitialSrcCellRect"] = this["oGetObjectRect"](oSrcCellInfo["oDomRefCell"]);
	oResizeInfo["bIsValidResizeOperation"] = false;
	oResizeInfo["bHasTableBasedColumnWidths"] = this["bHasTableBasedColumnWidths"](oSrcCellInfo);
	oResizeInfo["iMinColumnWidth"] = this["oSapTable"]["MIN_COL_WIDTH"];

	if (oResizeInfo["bHasTableBasedColumnWidths"]) {
		oResizeInfo["aInvolvedCells"] = [];
		oResizeInfo["iAffectedCellsCount"] = 0;
		oResizeInfo["iMinHorizontalMove"] = window["UCF_System"]["bIsRTL"] ?
			oResizeInfo["oInitialSrcCellRect"]["left"] + oResizeInfo["oInitialSrcCellRect"]["width"] - this["oSapTable"]["MIN_COL_WIDTH"] :
			oResizeInfo["oInitialSrcCellRect"]["left"] + this["oSapTable"]["MIN_COL_WIDTH"];
		oResizeInfo["iMaxHorizontalMove"] = oResizeInfo["iMinHorizontalMove"];
		oResizeInfo["iMaxColumnWidth"] = oResizeInfo["iMinColumnWidth"];
		oResizeInfo["aColumnResizeInfos"] = [];
		oResizeInfo["iNextColumnsTotalWidth"] = 0;
		oResizeInfo["iSrcColumnResizeInfoIndex"] = -1;
		oResizeInfo["sColWidths"] = "";

	} else {
		oResizeInfo["iMinScrollPosition"] = -1;
		oResizeInfo["iMaxScrollPosition"] = -1;
		oResizeInfo["iResultWidth"] = -1;

		oResizeInfo["iMaxColumnWidth"] = oResizeInfo["iMaxScrollPosition"];
		//Init the decoration
		oResizeInfo["oDecorationBoundaries"] = {
			"top": oResizeInfo["oSegmentsVisibleRect"]["top"],
			"left": oResizeInfo["oSegmentsVisibleRect"]["left"],
			"width": oResizeInfo["oSegmentsVisibleRect"]["width"],
			"height": oResizeInfo["oSegmentsVisibleRect"]["height"]
		};
	}

	return oResizeInfo;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oInitColumnResizeObject"] = 0; };

/**
 * Checks if the column is resizable and returns the custom data
 *
 * @param {Object} oAccessInfo
 * @param {Object} oSrcHeaderCellInfo
 *
 * @return {Object}
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["oInitColumnResize"] = function (oAccessInfo, oSrcCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oInitColumnResize"]++; }; 
	var oCurrSegment;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableDragDropDelegate.js(1267): oInitColumnResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSrcCellInfo != null, "oSrcCellInfo != null", "SapTableDragDropDelegate.js(1268): oInitColumnResize"); };

	var oResizeInfo = this["oInitColumnResizeObject"](oAccessInfo, oSrcCellInfo);

	if (oResizeInfo["bHasTableBasedColumnWidths"]) {

		{
			var oSegmentTable = this["oSapTable"]["oGetSegmentTable"](oResizeInfo["oSegment"]),
				aDomRefCols = this["oSapTable"]["aGetColsOfHtmlTable"](oSegmentTable);

			if (aDomRefCols) {
				var iFirstColIndex = 0,
					iLastColIndex = this["oSapTable"]["iGetCellInfoMatrixLastColIndex"](),
					iRowIndex = oSrcCellInfo["iRowIndex"],
					oCurrCellInfo = null;
				oCurrSegment = null;

				for (var iCurrColIndex = iFirstColIndex; iCurrColIndex <= iLastColIndex; iCurrColIndex += oCurrCellInfo["iColSpan"]) {
					oCurrCellInfo = this["oSapTable"]["oGetCellInfo"](iRowIndex, iCurrColIndex);

					if (this["oSapTable"]["bIsColumnHeader"](oCurrCellInfo)) {
						oCurrSegment = this["oSapTable"]["oGetSegmentByCellInfo"](oCurrCellInfo);

						oCurrCellInfo["oDomRefCol"] = this["oSapTable"]["aGetColsOfHtmlTable"](
							this["oSapTable"]["oGetSegmentTable"](oCurrSegment)
						)[oCurrCellInfo["iColIndex"] - this["oSapTable"]["iGetSegmentOffsetColIndex"](oCurrSegment)];

						oResizeInfo["aInvolvedCells"][oResizeInfo["aInvolvedCells"]["length"]] = oCurrCellInfo;
					}
				}
			}
		}

		//Table based resize
		var oCurrInvolvedCell = null,
			oColumnResizeInfo = null;

		for (var i = 0; i < oResizeInfo["aInvolvedCells"]["length"]; i++) {
			oCurrInvolvedCell = oResizeInfo["aInvolvedCells"][i];

			if (oCurrInvolvedCell === oResizeInfo["oSrcCellInfo"]) {
				oResizeInfo["iSrcColumnResizeInfoIndex"] = i;
			}

			oColumnResizeInfo = {
				"oSrcHeaderCellInfo": oCurrInvolvedCell,
				"iWidthBefore": Math["max"](1, oCurrInvolvedCell["oDomRefCell"]["offsetWidth"]), //cannot deal with zero or even negative values in following calculations
				"iWidthAfter": -1,
				"sWidthUnitAfter": null,
				"fWidthAmountAfter": -1,
				"sWidthUnitBefore": null,
				"fWidthAmountBefore": -1,
				"bIsPercentageColumn": false,
				"sOrignalStyleWidth": UCF_StringUtil["sStripWhiteSpace"](oCurrInvolvedCell["oDomRefCol"]["style"]["width"]),
				"bIsAffected": oResizeInfo["iSrcColumnResizeInfoIndex"] !== -1
					&& this["bIsColumnResizable"](oCurrInvolvedCell)
					&& oResizeInfo["oSegment"] === this["oSapTable"]["oGetSegmentByCellInfo"](oCurrInvolvedCell)
			};

			if (oColumnResizeInfo["sOrignalStyleWidth"]) {
				var fWidthAmount = parseFloat(oColumnResizeInfo["sOrignalStyleWidth"]),
					sWidthAmount = new String(fWidthAmount),
					sWidthUnit = oColumnResizeInfo["sOrignalStyleWidth"]["substr"](sWidthAmount["length"]);

				sWidthUnit = sWidthUnit ? sWidthUnit["toLowerCase"]() : "px";
				if (sWidthUnit === "px" || sWidthUnit === "%") fWidthAmount = Math["floor"](fWidthAmount);

				oColumnResizeInfo["bIsPercentageColumn"] = sWidthUnit === "%";

				oColumnResizeInfo["fWidthAmountBefore"] = fWidthAmount;
				oColumnResizeInfo["sWidthUnitBefore"] = sWidthUnit;
			} else {
				//Empty columns width are interpreted as % widths by the browsers
				oColumnResizeInfo["bIsPercentageColumn"] = true;
			}

			if (oColumnResizeInfo["bIsAffected"]) { // this is a block where all affected columns can be analyzed
				if (window["UCF_System"]["bIsRTL"]) {
					oResizeInfo["iMinHorizontalMove"] += -oColumnResizeInfo["iWidthBefore"] + this["oSapTable"]["MIN_COL_WIDTH"];
				} else {
					oResizeInfo["iMaxHorizontalMove"] += oColumnResizeInfo["iWidthBefore"] - this["oSapTable"]["MIN_COL_WIDTH"];
				}

				oResizeInfo["iMaxColumnWidth"] += oColumnResizeInfo["iWidthBefore"] - this["oSapTable"]["MIN_COL_WIDTH"];

				if (oCurrInvolvedCell !== oResizeInfo["oSrcCellInfo"]) {
					oResizeInfo["bIsValidResizeOperation"] = true;
					oResizeInfo["iNextColumnsTotalWidth"] += oColumnResizeInfo["iWidthBefore"];
				}

				oResizeInfo["iAffectedCellsCount"]++;

			}

			oResizeInfo["aColumnResizeInfos"][oResizeInfo["aColumnResizeInfos"]["length"]] = oColumnResizeInfo;
		}

		//If all columns are smaller than the minimum needed space skip the resizing
		if ((oResizeInfo["iNextColumnsTotalWidth"] + oResizeInfo["aColumnResizeInfos"][oResizeInfo["iSrcColumnResizeInfoIndex"]]["iWidthBefore"])
			<
			(oResizeInfo["iAffectedCellsCount"] * this["oSapTable"]["MIN_COL_WIDTH"])
		) {
			oResizeInfo = null;
		}

	} else {
		//Column based resize

		var iScrollPos = this["oSapTable"]["iGetHorizontalScrollPosition"](oResizeInfo["oSegment"]),
			oFirstCellRect = this["oGetObjectRect"](this["oGetFirstCellOfSegment"](oResizeInfo["oSrcCellInfo"]["iRowIndex"], oResizeInfo["oSegment"])["oDomRefCell"]);

		oResizeInfo["iMaxScrollPosition"] = this["oSapTable"]["iGetSegmentContentWidth"](oResizeInfo["oSegment"]) * 2;
		oResizeInfo["iMinScrollPosition"] = window["UCF_System"]["bIsRTL"]
			? ((oFirstCellRect["left"] + oFirstCellRect["width"]) - (oResizeInfo["oInitialSrcCellRect"]["left"] + oResizeInfo["oInitialSrcCellRect"]["width"])) + this["oSapTable"]["MIN_COL_WIDTH"]
			: (oResizeInfo["oInitialSrcCellRect"]["left"] - oFirstCellRect["left"]) + this["oSapTable"]["MIN_COL_WIDTH"];

		oResizeInfo["iMaxColumnWidth"] = oResizeInfo["iMaxScrollPosition"];

		if (iScrollPos < oResizeInfo["iMinScrollPosition"]) {
			var iOffset = oResizeInfo["iMinScrollPosition"] - iScrollPos;
			if (!window["UCF_System"]["bIsRTL"]) oResizeInfo["oDecorationBoundaries"]["left"] += iOffset;
			oResizeInfo["oDecorationBoundaries"]["width"] -= iOffset;
		}

		oResizeInfo["bIsValidResizeOperation"] = true;
	}

	return oResizeInfo;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oInitColumnResize"] = 0; };

/**
 * Processes the calculation of all columns when the user finished the resize interaction
 *
 * @param {Object} oAccessInfo
 * @param {Object} oResizeInfo
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["calculateColumnResize"] = function (oAccessInfo, oResizeInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["calculateColumnResize"]++; }; 
	var i;
	var iStep;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "SapTableDragDropDelegate.js(1409): calculateColumnResize"); };

	if (oResizeInfo["bHasTableBasedColumnWidths"]) {
		var oSrcColumnResizeInfo = oResizeInfo["aColumnResizeInfos"][oResizeInfo["iSrcColumnResizeInfoIndex"]],
			oColumnResizeInfo = null,
			iOldTotalWidth = oResizeInfo["iNextColumnsTotalWidth"],
			iNewTotalWidth = -1,
			iWidthLeftOver = -1,
			iPercentNewTotalWidthInPx = 0,
			aPercentColumnInfos = [],
			mPixelCorrectionColumns = {}, // The columns which can be used for the pixel correction
			iPixelCorrectionColumns = 0;

		if (oResizeInfo["iResultWidth"] === -1) {
			var iCurrHorizontalMove = Math["min"](
				Math["max"](oResizeInfo["iMinHorizontalMove"], this["iGetPageX"](oAccessInfo["oBrowserEvent"])),
				oResizeInfo["iMaxHorizontalMove"]
			);

			oResizeInfo["iResultWidth"] = window["UCF_System"]["bIsRTL"] ?
				(oResizeInfo["oInitialSrcCellRect"]["left"] + oResizeInfo["oInitialSrcCellRect"]["width"]) - iCurrHorizontalMove :
				iCurrHorizontalMove - oResizeInfo["oInitialSrcCellRect"]["left"];
		}

		iNewTotalWidth = iOldTotalWidth - (oResizeInfo["iResultWidth"] - oSrcColumnResizeInfo["iWidthBefore"]);
		iWidthLeftOver = iNewTotalWidth;

		for (i = 0; i < oResizeInfo["aColumnResizeInfos"]["length"]; i++) {
			oColumnResizeInfo = oResizeInfo["aColumnResizeInfos"][i];

			if (oColumnResizeInfo["bIsAffected"]) {
				if (oSrcColumnResizeInfo === oColumnResizeInfo) {
					oColumnResizeInfo["iWidthAfter"] = oResizeInfo["iResultWidth"];
				} else {
					oColumnResizeInfo["iWidthAfter"] = Math["max"](this["oSapTable"]["MIN_COL_WIDTH"], Math["round"](iNewTotalWidth / iOldTotalWidth * (oColumnResizeInfo["iWidthBefore"])));
					iWidthLeftOver -= oColumnResizeInfo["iWidthAfter"];

					if (oColumnResizeInfo["iWidthAfter"] > this["oSapTable"]["MIN_COL_WIDTH"]) {
						mPixelCorrectionColumns[i] = oColumnResizeInfo;
						iPixelCorrectionColumns++;
					}
				}
			} else {
				// Determine the resulting column width immediatelly when column is not affected
				// For these columns the width must not change
				oColumnResizeInfo["iWidthAfter"] = oColumnResizeInfo["iWidthBefore"];
				oColumnResizeInfo["sWidthUnitAfter"] = oColumnResizeInfo["sWidthUnitBefore"];

				//Leading "%" columns should not be affected by pixel size but need to be recalucalted for its % value -> after-value can not be set
				if (!oColumnResizeInfo["bIsPercentageColumn"]) {
					oColumnResizeInfo["fWidthAmountAfter"] = oColumnResizeInfo["fWidthAmountBefore"];
				}
			}
		}

		iWidthLeftOver = Math["round"](iWidthLeftOver);

		//Pixel correction for leftovers
		while (iWidthLeftOver !== 0 && iPixelCorrectionColumns > 0) {
			var iWidthBeforeCorrection = -1;
			iStep = Math["max"](1, Math["floor"](Math["abs"](iWidthLeftOver) / iPixelCorrectionColumns));

			if (iWidthLeftOver < 0) iStep *= -1;

			for (var m in mPixelCorrectionColumns) {
				if (iWidthLeftOver === 0) break;
				oColumnResizeInfo = mPixelCorrectionColumns[m];
				iWidthBeforeCorrection = oColumnResizeInfo["iWidthAfter"];

				oColumnResizeInfo["iWidthAfter"] = Math["max"](this["oSapTable"]["MIN_COL_WIDTH"], oColumnResizeInfo["iWidthAfter"] + iStep);
				iWidthLeftOver += (iWidthBeforeCorrection - oColumnResizeInfo["iWidthAfter"]);

				if (oColumnResizeInfo["iWidthAfter"] <= this["oSapTable"]["MIN_COL_WIDTH"]) {
					delete mPixelCorrectionColumns[m];
					iPixelCorrectionColumns--;
				}
			}
		}

		//Last Fallback for leftOver
		if (iWidthLeftOver !== 0) oSrcColumnResizeInfo["iWidthAfter"] += iWidthLeftOver;

		//Transfer resulting pixel widths
		for (i = 0; i < oResizeInfo["aColumnResizeInfos"]["length"]; i++) {
			oColumnResizeInfo = oResizeInfo["aColumnResizeInfos"][i];

			if (oColumnResizeInfo["bIsPercentageColumn"]) {
				aPercentColumnInfos[aPercentColumnInfos["length"]] = oColumnResizeInfo;
				iPercentNewTotalWidthInPx += oColumnResizeInfo["iWidthAfter"];
			} else if (oColumnResizeInfo["fWidthAmountAfter"] === -1) { //Set resulting width only when not already determined
				var fWidthAmountAfter = oColumnResizeInfo["iWidthAfter"],
					sWidthUnitAfter = "px";

				if (oColumnResizeInfo["sWidthUnitBefore"] !== "px"
					&& oColumnResizeInfo["fWidthAmountBefore"] > 0.0
					&& oColumnResizeInfo["iWidthBefore"] > 0
				) {
					fWidthAmountAfter = (oColumnResizeInfo["fWidthAmountBefore"] / oColumnResizeInfo["iWidthBefore"]) * oColumnResizeInfo["iWidthAfter"];
					fWidthAmountAfter = Math["round"](fWidthAmountAfter * 100) / 100;
					sWidthUnitAfter = oColumnResizeInfo["sWidthUnitBefore"];
				}

				oColumnResizeInfo["fWidthAmountAfter"] = fWidthAmountAfter;
				oColumnResizeInfo["sWidthUnitAfter"] = sWidthUnitAfter;
			}
		}

		//Calc percentage widths
		iWidthLeftOver = 100;
		var iPercentNewWidthInPc = 0,
			aPercentageCorrectionColumns = [],
			oPercentColumnInfo = null;

		for (i = 0; i < aPercentColumnInfos["length"]; i++) {
			oPercentColumnInfo = aPercentColumnInfos[i];

			if (oPercentColumnInfo["fWidthAmountAfter"] === -1) { //Set resulting width only when not already determined
				iPercentNewWidthInPc = parseInt(Math["round"](100 * oPercentColumnInfo["iWidthAfter"] / iPercentNewTotalWidthInPx), 10);

				oPercentColumnInfo["fWidthAmountAfter"] = iPercentNewWidthInPc;
				oPercentColumnInfo["sWidthUnitAfter"] = "%";

				if (oPercentColumnInfo["bIsAffected"]) aPercentageCorrectionColumns["push"](oPercentColumnInfo);
			}

			iWidthLeftOver -= oPercentColumnInfo["fWidthAmountAfter"];
		}

		//Percentage correction
		//There might be leftovers because of int calculation.
		//Distribute the leftover over all corrected columns
		if (aPercentageCorrectionColumns["length"] > 0 && iWidthLeftOver !== 0) {
			var iCurrIndex = aPercentageCorrectionColumns["length"] - 1;
			iStep = (iWidthLeftOver > 0) ? 1 : -1;

			while (iWidthLeftOver !== 0) {
				aPercentageCorrectionColumns[iCurrIndex]["fWidthAmountAfter"] += iStep;
				iWidthLeftOver -= iStep;
				iCurrIndex--;
				if (iCurrIndex < 0) iCurrIndex = aPercentageCorrectionColumns["length"] - 1;
			}
		}

		// create event string
		var sColWidth = "";

		for (i = 0; i < oResizeInfo["aColumnResizeInfos"]["length"]; i++) {
			oColumnResizeInfo = oResizeInfo["aColumnResizeInfos"][i];
			sColWidth = oColumnResizeInfo["fWidthAmountAfter"] + oColumnResizeInfo["sWidthUnitAfter"];
			oResizeInfo["sColWidths"] += sColWidth + ";";

			if (oColumnResizeInfo["fWidthAmountAfter"] != oColumnResizeInfo["fWidthAmountBefore"]
				|| oColumnResizeInfo["sWidthUnitAfter"] != oColumnResizeInfo["sWidthUnitBefore"]
			) {
				this["oSapTable"]["setColumnWidth"](oColumnResizeInfo["oSrcHeaderCellInfo"]["iColIndex"], sColWidth);
			}

		}

	} else {

		if (oResizeInfo["iResultWidth"] === -1) {
			var iDragPos = Math["min"](
				Math["max"](oResizeInfo["oDecorationBoundaries"]["left"], this["iGetPageX"](oAccessInfo["oBrowserEvent"])),
				oResizeInfo["oDecorationBoundaries"]["left"] + oResizeInfo["oDecorationBoundaries"]["width"]
			),
				oSrcCellRect = this["oGetObjectRect"](oResizeInfo["oSrcCellInfo"]["oDomRefCell"]);

			oResizeInfo["iResultWidth"] = window["UCF_System"]["bIsRTL"] ?
				Math["max"](this["oSapTable"]["MIN_COL_WIDTH"], (oSrcCellRect["left"] + oSrcCellRect["width"]) - iDragPos) :
				iDragPos - oSrcCellRect["left"];
		}

		this["applyColumnBasedWidth"](oResizeInfo);
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["calculateColumnResize"] = 0; };

/**
 * Caluculates the resulting widths of a drag column resize operation for a column based width
 *
 * @param {Object} oResizeInfo
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["applyColumnBasedWidth"] = function (oResizeInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["applyColumnBasedWidth"]++; }; 
	var oCellInfo = oResizeInfo["oSrcCellInfo"],
		sOrgWidth = UCF_StringUtil["sStripWhiteSpace"](this["oSapTable"]["sGetColumnWidth"](oCellInfo["iColIndex"])),
		iWidthBefore = Math["max"](1, oCellInfo["oDomRefCell"]["offsetWidth"]),
		fWidthAmountBefore = parseFloat(sOrgWidth),
		sWidthAmountBefore = new String(fWidthAmountBefore),
		sWidthUnitBefore = sOrgWidth["substr"](sWidthAmountBefore["length"]),
		iWidthAfter = oResizeInfo["iResultWidth"],
		fWidthAmountAfter = iWidthAfter,
		sWidthUnitAfter = sWidthUnitBefore;

	if (sWidthUnitBefore != "px" && sWidthUnitBefore !== ""
		&& fWidthAmountBefore > 0.0
		&& iWidthBefore > 0
	) {
		fWidthAmountAfter = (fWidthAmountBefore / iWidthBefore) * iWidthAfter;
		fWidthAmountAfter = Math["round"](fWidthAmountAfter * 100) / 100;
	}

	oResizeInfo["sResultWidth"] = fWidthAmountAfter + sWidthUnitAfter;

	this["oSapTable"]["setColumnWidth"](oCellInfo["iColIndex"], oResizeInfo["sResultWidth"]);

	{
		var iMaxColIndex = this["oSapTable"]["iGetCellInfoMatrixLastColIndex"](),
			iColIndex = 0,
			sColWidth = null;

		oResizeInfo["sColWidths"] = "";
		if (this["oSapTable"]["bHasLeadingSelectionColumn"]()) iColIndex++;

		for (; iColIndex <= iMaxColIndex; iColIndex++) {
			sColWidth = this["oSapTable"]["sGetColumnWidth"](iColIndex);

			if (!sColWidth) sColWidth = this["oSapTable"]["iGetColumnWidth"](iColIndex) + "px";

			oResizeInfo["sColWidths"] += sColWidth + ";";
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["applyColumnBasedWidth"] = 0; };

/**
 * This is the standard column insert mode behaviour when a DragEnter is called
 *
 * @param {Object} oAccessInfo
 * @param {element} oDomRefMaster
 * @param {element} oDomRefDropCell
 * @param {element} oDomRefBeforeDropCell
 * @param {element} oDomRefAfterDropCell
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["handleStandardColumnInsertDragEnter"] = function (oDragAndDropManager, oDomRefMaster, oHeaderCellDomRef, oDomRefBeforeDropCell, oDomRefAfterDropCell, oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleStandardColumnInsertDragEnter"]++; }; 

	var oResizeInfo = oDragAndDropManager["oDragSession"]["oGetCustomData"](),
		sDropFlavors = "",
		sValidMimeTypes = "",
		oDropRasterDataBefore = null,
		oDropRasterDataAfter = null;

	if (oHeaderCellDomRef) {
		var bLegacyReorderMode = oResizeInfo ? oResizeInfo["bLegacyReorderMode"] : false,
			bAllowed = false;

		//Check insert before drop tags are checked
		sDropFlavors = this["sGetHeaderParentDropFlavors"](oHeaderCellDomRef, bLegacyReorderMode);
		sValidMimeTypes = this["sGetHeaderParentDropValidMimeTypes"](oHeaderCellDomRef);
		bAllowed = sDropFlavors ? oDragAndDropManager["bGetDropAllowed"](sDropFlavors, sValidMimeTypes) : false;

		if (bAllowed) {
			oDropRasterDataBefore = { "sInsertRefId": oHeaderCellDomRef["id"], "bInsertModeBefore": true };
			oDropRasterDataAfter = { "sInsertRefId": oHeaderCellDomRef["id"], "bInsertModeBefore": false };
		} else {
			//Check drop
			sDropFlavors = this["sGetHeaderDropFlavors"](oHeaderCellDomRef);
			sValidMimeTypes = this["sGetHeaderDropValidMimeTypes"](oHeaderCellDomRef);
			bAllowed = sDropFlavors ? oDragAndDropManager["bGetDropAllowed"](sDropFlavors, sValidMimeTypes) : false;

			if (bAllowed) {
				oDropRasterDataBefore = null;
				oDropRasterDataAfter = null;
			}
		}

		if (oDropRasterDataBefore && !this["bIsRasterPointVisible"](oDropRasterDataBefore)) oDropRasterDataBefore = null;
		if (oDropRasterDataAfter && !this["bIsRasterPointVisible"](oDropRasterDataAfter)) oDropRasterDataAfter = null;

		if (oDropRasterDataBefore || oDropRasterDataAfter) {

			if (!oAccessInfo["oCellInfo"]) return;

			var oDecoration = null,
				oDropCellRect = null,
				oMasterRect = this["oGetObjectRect"](oDomRefMaster),
				iSnapRange = 0,
				oDecorationBoundaries = null;
			//	iGap = oHeaderCellDomRef?oHeaderCellDomRef.scrollWidth:0,
			oDropCellRect = this["oGetObjectRect"](oHeaderCellDomRef ? oHeaderCellDomRef : oAccessInfo["oCellInfo"]["oDomRefRow"]["cells"][0]);
			var oDragSession = oDragAndDropManager["oDragSession"];
			oResizeInfo = oDragSession["oGetCustomData"]();

			if (!oResizeInfo) {
				oResizeInfo = {};
				oDragSession["setCustomData"](oResizeInfo);
			}

			oResizeInfo["bAllowDropInsert"] = true;

			iSnapRange = parseInt(oDropCellRect["width"] / 2, 10);

			oDecorationBoundaries = {
				"top": oDropCellRect["top"] + oDropCellRect["height"],
				"left": oDropCellRect["left"],
				"width": oDropCellRect["width"],
				"height": oMasterRect["height"] - (oDropCellRect["top"] - oMasterRect["top"] + oDropCellRect["height"])
			};

			oDecoration = new (UCF_ClassLoader["oGetClass"]("UCF_DragDropDecoration"))(this["oSapTable"]["oLS"], oDomRefMaster, oDecorationBoundaries);
			oDecoration["setArrowOffset"](oDropCellRect["height"]);
			if (oDropRasterDataBefore) oDecoration["addRasterPoint"](window["UCF_System"]["bIsRTL"] ? oDecorationBoundaries["width"] : 0, iSnapRange, oDropRasterDataBefore);
			if (oDropRasterDataAfter) oDecoration["addRasterPoint"](window["UCF_System"]["bIsRTL"] ? 0 : oDecorationBoundaries["width"], iSnapRange, oDropRasterDataAfter);

			this["oDropDecoration"] = oDecoration;
			oDragAndDropManager["initDropArea"](UCF_DragSession["DROP_TYPE"]["H_INSERT"], sDropFlavors, oDecoration);
			oDecoration["init"](oDragSession);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["handleStandardColumnInsertDragEnter"] = 0; };

/**
 * simulates ColumnReorder trigered by keyboard
 *
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {UCF_SapTable_CellInfo} oCellInfo
 * @param {bollean} bBefore
 * @return {booelan} true if column reorder has been performed
 */
UCF_SapTableDragDropDelegate["prototype"]["simulateDragDropColumnReorder"] = function (oSourceCellInfo, oTargetCellInfo, iOffset) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["simulateDragDropColumnReorder"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oSourceCellInfo != null, "oSourceCellInfo != null", "SapTableDragDropDelegate.js(1731): simulateDragDropColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oSourceCellInfo) === "object", "typeof (oSourceCellInfo) === \"object\"", "SapTableDragDropDelegate.js(1732): simulateDragDropColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oTargetCellInfo != null, "oTargetCellInfo != null", "SapTableDragDropDelegate.js(1733): simulateDragDropColumnReorder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oTargetCellInfo) === "object", "typeof (oTargetCellInfo) === \"object\"", "SapTableDragDropDelegate.js(1734): simulateDragDropColumnReorder"); };

	var sDragFlavors = this["sGetDragFlavorsByDomRef"](oSourceCellInfo["oDomRefCell"]);
	var	bLegacyReorderMode = false;
	var sDropFlavors = "";
	var bAllowDropInsert = false;
	var bAllowed = false;

	// get dragTags in following order:
	// - dragSourceFlavour at HeaderCell
	// - dragSourceInfo at HeaderCell
	// - columnRootDragSourceInfo at SapTable(CS)
	if (sDragFlavors) {
		bLegacyReorderMode = true;
	} else {
		sDragFlavors = this["sGetHeaderDragFlavors"](oSourceCellInfo["oDomRefCell"]);
	}

	// get dropTags in following order:
	// bLegacyReorderMode (dragSourceFlavour at HeaderCell) ->
	// - dragSourceFlavour at HeaderCell
	// - dragSourceInfo at HeaderCell
	// - columnRootDragSourceInfo at SapTable(CS)
	// bLegacyReorderMode===false (np dragSourceFlavour at HeaderCell) ->
	// - dragSourceInfo at HeaderCell
	// - columnRootDragSourceInfo at SapTable(CS)
	if (sDragFlavors) {
		sDropFlavors = this["sGetHeaderParentDropFlavors"](oTargetCellInfo["oDomRefCell"], bLegacyReorderMode);
		bAllowDropInsert = sDropFlavors ? this["bGetTagMatch"](sDragFlavors, sDropFlavors) : false;
		if (!bAllowDropInsert) {
			sDropFlavors = this["sGetHeaderDropFlavors"](oTargetCellInfo["oDomRefCell"]);
			bAllowed = sDropFlavors ? this["bGetTagMatch"](sDragFlavors, sDropFlavors) : false;
		}
		if (bAllowDropInsert || bAllowed) {
			if (bLegacyReorderMode && this["oSapTable"]["mEvents"]["ColumnReorder"]) {
					// this.oSapTable.looseFocus();
					this["oSapTable"]["fireColumnReorder"](
						this["oSapTable"]["sId"],
						this["oSapTable"]["sGetCellId"](oSourceCellInfo),
						this["oSapTable"]["sGetCellId"](oTargetCellInfo),
						(iOffset < 0) ? this["oSapTable"]["EVENT_PARAM_MAP_INSERT_MODE"]["BEFORE"] : this["oSapTable"]["EVENT_PARAM_MAP_INSERT_MODE"]["AFTER"]
					);
			} else {
				// this.oSapTable.looseFocus();
				this["oSapTable"]["fireDrop"](
					this["oSapTable"]["sId"],
					oSourceCellInfo["oDomRefCell"]["getAttribute"]("id"),
					bAllowDropInsert ? this["oSapTable"]["sGetColumnParentDropTargetInfo"](oTargetCellInfo) : this["oSapTable"]["sGetColumnDropTargetInfo"](oTargetCellInfo),
					this["oSapTable"]["sGetCellId"](oTargetCellInfo),
					this["oSapTable"]["iGetAppDefinedRowIndex"](oTargetCellInfo),
					this["oSapTable"]["iGetAppDefinedColIndex"](oTargetCellInfo),
					'HORIZONTAL',
					iOffset,
					-1,
					"",
					"",
					sDragFlavors,
					1,
					0,
					0,
					'NONE'
				);
			}
			return true;
		}
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["simulateDragDropColumnReorder"] = 0; };

/**
 * Checks if at least one tag of sSourceTags matches with one of sTargetTags
 *
 * @param {string} sSourceTags ' '-separated list of tags
 * @param {string} sTargetTags ' '-separated list of tags
 * @return {booelan} true if at least one tag of sSourceTags matches with one of sTargetTags
 */
UCF_SapTableDragDropDelegate["prototype"]["bGetTagMatch"] = function(sSourceTags, sTargetTags) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bGetTagMatch"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSourceTags) === "string", "typeof(sSourceTags) === \"string\"", "SapTableDragDropDelegate.js(1811): bGetTagMatch"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTargetTags) === "string", "typeof(sTargetTags) === \"string\"", "SapTableDragDropDelegate.js(1812): bGetTagMatch"); };

	var aSourceTags = sSourceTags["split"](' ');
	var aTargetTags = sTargetTags["split"](' ');
	for (var i = 0; i < aSourceTags["length"]; i++) {
		var sSourceTag = aSourceTags[i];
		for (var j = 0; j < aTargetTags["length"]; j++) {
			var sTargetTag = aTargetTags[j];
			if (this["bGetSingleTagMatch"](sSourceTag, sTargetTag)) {
				//_trace(INFO,"SourceTag :" + sSourceTag + " TargetTag : " + sTargetTag);
				return true;
			}
		}
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bGetTagMatch"] = 0; };

/**
 * determines if two strings equal match using * as wildcard
 * @param {string} sSourceTag
 * @param {string} sTargetTag
 *
 * @return {boolean} true, if strings match
 */
UCF_SapTableDragDropDelegate["prototype"]["bGetSingleTagMatch"] = function(sSourceTag, sTargetTag) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bGetSingleTagMatch"]++; }; 
	var iBase = -1;
	var iWildcard = sSourceTag["indexOf"]('*');

	if (iWildcard !== -1) {
		iBase = iWildcard;
	}

	iWildcard = sTargetTag["indexOf"]('*');

	if (iWildcard !== -1) {
		if (iBase === -1) iBase = iWildcard;
		else iBase = Math["min"](iBase, iWildcard);

	}

	if (iBase !== -1) {
		sSourceTag = sSourceTag["substr"](0, iBase);
		sTargetTag = sTargetTag["substr"](0, iBase);
	}

	return sSourceTag == sTargetTag;

};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bGetSingleTagMatch"] = 0; };

/**
 * Checks if given raster point is scrolled into view so that the user can see it
 *
 * @param {Object} oRasterPoint
 *
 * @return {boolean}
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["bIsRasterPointVisible"] = function (oRasterPoint) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bIsRasterPointVisible"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oRasterPoint != null, "oRasterPoint != null", "SapTableDragDropDelegate.js(1870): bIsRasterPointVisible"); };
	if (this["oSapTable"]["bCanClientScroll"](true)) {
		var oDomRef = UCF_DomUtil["$"](oRasterPoint["sInsertRefId"]);

		if (oDomRef) {
			var oSegmentsVisibleRect = this["oGetColSegmentsRect"](this["oSapTable"]["aGetHorizontalScrollSegments"]()),
				oRect = this["oGetObjectRect"](oDomRef),
				iPointX = (oRasterPoint["bInsertModeBefore"] && !window["UCF_System"]["bIsRTL"] || !oRasterPoint["bInsertModeBefore"] && window["UCF_System"]["bIsRTL"])
					? oRect["left"]
					: oRect["left"] + oRect["width"];

			if (iPointX + 2 < oSegmentsVisibleRect["left"] || iPointX > (oSegmentsVisibleRect["left"] + oSegmentsVisibleRect["width"])) return false;
		}
	}

	return true;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bIsRasterPointVisible"] = 0; };

/**
 * Extracts the drop flavor information from a given HTML element
 *
 * @param {HTMLElement} oDomRefCell
 *
 * @return {string} the flavor string
 *
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["sGetHeaderDropFlavors"] = function (oDomRefCell) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetHeaderDropFlavors"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefCell != null, "oDomRefCell != null", "SapTableDragDropDelegate.js(1898): sGetHeaderDropFlavors"); };

	var oCellInfo = this["oSapTable"]["oGetCellInfoByDomRef"](oDomRefCell);

	if (oCellInfo) {
		var oDropTargetInfoId = this["oSapTable"]["sGetColumnDropTargetInfo"](oCellInfo),
			oDropTargetInfo = oDropTargetInfoId ? this["oSapTable"]["oGetControlById"](oDropTargetInfoId) : null;

		return oDropTargetInfo ? oDropTargetInfo["sGetTags"]() : "";
	}

	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetHeaderDropFlavors"] = 0; };

/**
 * Extracts the validMimeTypes information from a given HTML element
 *
 * @param {HTMLElement} oDomRefCell
 *
 * @return {string} the validMimeTypes string
 *
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["sGetHeaderDropValidMimeTypes"] = function (oDomRefCell) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetHeaderDropValidMimeTypes"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefCell != null, "oDomRefCell != null", "SapTableDragDropDelegate.js(1922): sGetHeaderDropValidMimeTypes"); };

	var oCellInfo = this["oSapTable"]["oGetCellInfoByDomRef"](oDomRefCell);

	if (oCellInfo) {
		var oDropTargetInfoId = this["oSapTable"]["sGetColumnDropTargetInfo"](oCellInfo),
			oDropTargetInfo = oDropTargetInfoId ? this["oSapTable"]["oGetControlById"](oDropTargetInfoId) : null;

		return oDropTargetInfo ? oDropTargetInfo["sGetValidMimeTypes"]() : "";
	}

	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetHeaderDropValidMimeTypes"] = 0; };

/**
 * Extracts the parent header drop flavor information from a given HTML element
 *
 * @param {HTMLElement} oDomRefCell
 * @param {boolean} bLegacyReorderMode if there is a old location of the drop data retriueve it from there
 *
 * @return {string} the flavor string
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["sGetHeaderParentDropFlavors"] = function (oDomRefCell, bLegacyReorderMode) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetHeaderParentDropFlavors"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefCell != null, "oDomRefCell != null", "SapTableDragDropDelegate.js(1946): sGetHeaderParentDropFlavors"); };

	if (bLegacyReorderMode) {
		var sDropFlavors = this["sGetDropFlavorsByDomRef"](oDomRefCell);
		if (sDropFlavors) return sDropFlavors;
	} else {
		var oCellInfo = this["oSapTable"]["oGetCellInfoByDomRef"](oDomRefCell);

		if (oCellInfo) {
			var oParentDropTargetInfoId = this["oSapTable"]["sGetColumnParentDropTargetInfo"](oCellInfo),
				oDropTargetInfo = oParentDropTargetInfoId ? this["oSapTable"]["oGetControlById"](oParentDropTargetInfoId) : null;

			return oDropTargetInfo ? oDropTargetInfo["sGetTags"]() : "";
		}
	}
	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetHeaderParentDropFlavors"] = 0; };

/**
 * Extracts the parent header drop validMimeTypes information from a given HTML element
 *
 * @param {HTMLElement} oDomRefCell
 *
 * @return {string} the validMimeTypes string
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["sGetHeaderParentDropValidMimeTypes"] = function (oDomRefCell) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetHeaderParentDropValidMimeTypes"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefCell != null, "oDomRefCell != null", "SapTableDragDropDelegate.js(1973): sGetHeaderParentDropValidMimeTypes"); };

	var oCellInfo = this["oSapTable"]["oGetCellInfoByDomRef"](oDomRefCell);

	if (oCellInfo) {
		var oParentDropTargetInfoId = this["oSapTable"]["sGetColumnParentDropTargetInfo"](oCellInfo),
			oDropTargetInfo = oParentDropTargetInfoId ? this["oSapTable"]["oGetControlById"](oParentDropTargetInfoId) : null;

		return oDropTargetInfo ? oDropTargetInfo["sGetValidMimeTypes"]() : "";
	}
	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetHeaderParentDropValidMimeTypes"] = 0; };

/**
 * Extracts the drag flavor information from a given HTML element
 *
 * @param {HTMLElement} oDomRefCell
 *
 * @return {string} the flavor string
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["sGetHeaderDragFlavors"] = function (oDomRefCell) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetHeaderDragFlavors"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRefCell != null, "oDomRefCell != null", "SapTableDragDropDelegate.js(1995): sGetHeaderDragFlavors"); };

	var sDragFlavors = this["sGetDragFlavorsByDomRef"](oDomRefCell);

	if (sDragFlavors) {
		return sDragFlavors;
	} else {
		var oCellInfo = this["oSapTable"]["oGetCellInfoByDomRef"](oDomRefCell);

		if (oCellInfo) {
			var oDragSourceInfo = this["oGetHeaderDragSourceInfo"](oCellInfo);

			return oDragSourceInfo ? oDragSourceInfo["sGetTags"]() : "";
		}
	}

	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetHeaderDragFlavors"] = 0; };

/**
 * Extracts the drag info control of a specific header cell given by a cell info
 *
 * @param {Object} oCellInfo
 *
 * @return {UCF_DragSourceInfo} the drag source info control
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["oGetHeaderDragSourceInfo"] = function (oCellInfo) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetHeaderDragSourceInfo"]++; }; 
	var sDragSourceInfoId = this["oSapTable"]["sGetColumnDragSourceInfo"](oCellInfo);

	return sDragSourceInfoId ? this["oSapTable"]["oGetControlById"](sDragSourceInfoId) : null;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetHeaderDragSourceInfo"] = 0; };

/**
 * Returns the string which identifies the drag flavor
 *
 * @param {Object} oDomRef
 *
 * @return {string}
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["sGetDragFlavorsByDomRef"] = function (oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetDragFlavorsByDomRef"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTableDragDropDelegate.js(2037): sGetDragFlavorsByDomRef"); };
	var sFlavors = oDomRef["getAttribute"]("dragFlavors");
	if (sFlavors) return sFlavors;
	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetDragFlavorsByDomRef"] = 0; };

/**
 * Returns the string which identifies the drop flavor
 *
 * @param {Object} oDomRef
 *
 * @return {string}
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["sGetDropFlavorsByDomRef"] = function (oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetDropFlavorsByDomRef"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTableDragDropDelegate.js(2052): sGetDropFlavorsByDomRef"); };
	var sFlavors = oDomRef["getAttribute"]("dropFlavors");
	if (sFlavors) return sFlavors;
	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["sGetDropFlavorsByDomRef"] = 0; };

UCF_SapTableDragDropDelegate["prototype"]["oGetObjectRect"] = function (oDomRef) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetObjectRect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SapTableDragDropDelegate.js(2059): oGetObjectRect"); };
	return UCF_DomUtil["oGetObjectRect"](oDomRef, this["oGetReferenceContainer"]());
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetObjectRect"] = 0; };

UCF_SapTableDragDropDelegate["prototype"]["oGetReferenceContainer"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetReferenceContainer"]++; }; 
	if (!this["oReferenceContainer"]) {
		this["oReferenceContainer"] = UCF_DomUtil["oGetParentPositionReferenceContainer"](this["oSapTable"]["oDomRef"], true);
	}

	return this["oReferenceContainer"];
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetReferenceContainer"] = 0; };

UCF_SapTableDragDropDelegate["prototype"]["oGetReferenceRect"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetReferenceRect"]++; }; 
	if (!this["oReferenceRect"]) {
		if (this["oGetReferenceContainer"]()) {
			this["oReferenceRect"] = UCF_DomUtil["oGetObjectRect"](this["oGetReferenceContainer"]());
		} else {
			this["oReferenceRect"] = { "top": 0, "left": 0, "width": 0, "height": 0 };
		}
	}

	return this["oReferenceRect"];
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["oGetReferenceRect"] = 0; };

UCF_SapTableDragDropDelegate["prototype"]["iGetPageX"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["iGetPageX"]++; }; 
	var iPageX = oBrowserEvent["iPageX"]() + (window["UCF_System"]["bIsRTL"] ? +3 : -2);

	if (this["oGetReferenceContainer"]()) {
		if (window["UCF_System"]["bIsRTL"]) iPageX -= UCF_DomUtil["iGetVerticalScrollbarOffset"](this["oGetReferenceContainer"]());
		iPageX += UCF_DomUtil["iGetScrollLeft"](this["oGetReferenceContainer"]()) - this["oGetReferenceRect"]()["left"];
	}

	return iPageX;
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["iGetPageX"] = 0; };

/**
 * Checks if a row drag operation is possible
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} true if row drag is possible
 * @private
 */
UCF_SapTableDragDropDelegate["prototype"]["bRowDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bRowDragPossible"]++; }; 

	/** @type {string} */
	var sDragSourceInfoId = '';
	/** @type {UCF_Control} */
	var oDragSourceInfoControl = null;;
	/** @type {string} */
	var sTags = '';
	/** @type {UCF_SapTable_CellInfo} */
	var oCellInfo;
	/** @type {string} */
	var eRowSelectionState = '';

	sDragSourceInfoId = this["oSapTable"]["sGetRowRootDragSourceInfo"]();
	if (!sDragSourceInfoId)	return false;

	oDragSourceInfoControl = this["oSapTable"]["oGetControlById"](sDragSourceInfoId);
	if (!oDragSourceInfoControl) return false;

	sTags = oDragSourceInfoControl["sGetTags"]();
	if (!sTags)	return false;

	oCellInfo = this["oSapTable"]["oGetCellInfoByBrowserEvent"](oBrowserEvent);
	if (!oCellInfo)	return false;

	eRowSelectionState = this["oSapTable"]["eGetRowSelectionState"](oCellInfo["iRowIndex"]);
	return (eRowSelectionState & this["oSapTable"]["SELECTION_LAYER"]["ROW"] ||	eRowSelectionState & this["oSapTable"]["SELECTION_LAYER"]["ROW_PRIMARY"]);
};;if (__UCF_COVERAGE__) { UCF_SapTableDragDropDelegate["_"]["bRowDragPossible"] = 0; };

};
sap["ls"]["preload"]["UCF_SapTableDropDecorator"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_SapTable} oSapTable
 * @param {UCF_LS} oLS
 */
function UCF_SapTableDropDecorator(oSapTable, oLS) {if (__UCF_COVERAGE__) { UCF_SapTableDropDecorator["_"]["UCF_SapTableDropDecorator"]++; }; 
	UCF_LineDecorator["apply"](this, [oSapTable, true]);

	this["oLS"] = oLS;
	this["setGap"](0);
	//use a id for re-use of domRefs after roundtrip
	this["setId"](oSapTable["sId"] + "-linedecorator");
	this["setContainer"](oLS["oGetStaticAreaRef"]());
};window["UCF_SapTableDropDecorator"] = UCF_SapTableDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableDropDecorator"); UCF_SapTableDropDecorator["_"] = {UCF_SapTableDropDecorator: 0}; }; ;

UCF_SapTableDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(); UCF_SapTableDropDecorator.prototype["sClassName"] = "UCF_SapTableDropDecorator";

/**
 * @see UCF_LineDecorator
 * @override
 * @private
 */
UCF_SapTableDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDecorator["_"]["update"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableDropDecorator.js(34): update"); };

	var oTableContentDomRef = UCF_DomUtil["$"](this["oControl"]["sId"] + "-" + this["oControl"]["SUFFIX"]["CONTENT_AREA"]),
		oViewPort = oTableContentDomRef ? UCF_DomUtil["oGetObjectRect"](oTableContentDomRef) : null,
		iRowCount = this["oControl"]["iGetRowCount"](),
		iContentRowOffset = this["oControl"]["iGetContentRowOffset"](),
		iY = -1,
		oDropDelegate = this["oControl"]["oDropDelegate"],
		oResultCell = oDropDelegate["oPrepareAndGetDropCellInfo"](oBrowserEvent);

	this["oControl"]["resetDragHoverStyle"]();

	//empty table
	if (iRowCount === 0) {
		if (iContentRowOffset < 0) { //legacy approach
			var iFirstDataRow = 0,
				oCellInfo = null,
				oCellRect;

			do { //find first content row
				this["oControl"]["oGetCellInfo"](iFirstDataRow, 0);
				if (!oCellInfo) break;
				iFirstDataRow = oCellInfo["iRowIndex"] + oCellInfo["iRowSpan"];
			} while (this["eGetCellType"](oCellInfo) === this["SUBCONTROL"]["HEADER_CELL"]);

			if (oCellInfo) iY = UCF_DomUtil["oGetObjectRect"](oCellInfo["oDomRefCell"])["top"];
		} else {
			if (iContentRowOffset === 0) {
				if (oViewPort) iY = oViewPort["top"];
			} else {
				oCellInfo = this["oControl"]["oGetCellInfo"](iContentRowOffset - 1, 0);
				oCellRect = UCF_DomUtil["oGetObjectRect"](oCellInfo["oDomRefCell"]);

				if (oCellInfo) iY = oCellRect["top"] + oCellRect["height"];
			}
		}
	}

	if (oDropDelegate["iOffset"] === 0 && iRowCount > 0) { // DROP
		if (oResultCell) {
			this["oControl"]["applyDragHoverStyle"](oDropDelegate["iMatrixRowIndex"]);
		}
	} else {
		if (this["oControl"]["bIsValidCellInfo"](oResultCell)) { // INSERT
			{ //Gap leading NON-data cells (e.g. selection cell, row headers etc.)
				var iGap = 0,
					iRowIndex = oResultCell["iRowIndex"],
					oLeadingCellInfo = this["oControl"]["oGetCellInfo"](iRowIndex, 0);

				while (oLeadingCellInfo) {
					if ((this["oControl"]["bHasLeadingSelectionColumn"]() && oLeadingCellInfo["iColIndex"] === 0)
						|| !this["oControl"]["bIsDataTableCell"](this["oControl"]["eGetCellType"](oLeadingCellInfo))
					) {
						iGap += this["oControl"]["iGetColumnWidth"](oLeadingCellInfo["iColIndex"]);
					} else {
						if (oDropDelegate["iHierarchyLevel"] > 0) {
							iGap += this["oControl"]["iGetHierarchyCellLevelIndention"](oDropDelegate["iHierarchyLevel"]);
						}
						break;
					}
					oLeadingCellInfo = this["oControl"]["oGetCellInfo"](iRowIndex, oLeadingCellInfo["iColIndex"] + oLeadingCellInfo["iColSpan"]);
				}

				this["setGap"](iGap);
			}

			{ //calc y pos
				oCellRect = UCF_DomUtil["oGetObjectRect"](oResultCell["oDomRefCell"]);

				if (oDropDelegate["iOffset"] === 1) iY = oCellRect["top"] + oCellRect["height"];
				else iY = oCellRect["top"];
			}
		} else if (this["oControl"]["bHasLeadingSelectionColumn"]()) {
			this["setGap"](this["oControl"]["iGetColumnWidth"](0));
		}
	}

	//Show/hide decoration if position is available
	if ((oDropDelegate["iOffset"] !== 0 || iRowCount === 0) && iY !== -1 && oViewPort) {
		this["show"]();
		this["setBounds"](oViewPort["left"] - 4, iY, oViewPort["width"] + 4);
	} else {
		this["hide"]();
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableDropDecorator["_"]["update"] = 0; };

/**
 * @see UCF_LineDecorator
 * @override
 * @private
 */
UCF_SapTableDropDecorator["prototype"]["cleanUp"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableDropDecorator["_"]["cleanUp"]++; }; 
	if (this["oControl"]) this["oControl"]["resetDragHoverStyle"]();
	this["oLS"] = null;
	UCF_LineDecorator.prototype["cleanUp"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDecorator["_"]["cleanUp"] = 0; };

/** destructor */
UCF_SapTableDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableDropDecorator["_"]["destroy"]++; }; 
	this["oLS"] = null;
	UCF_LineDecorator.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_SapTableDropDelegate"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_DragSession */
/// <reference path="../base/DragSession.js"/>
/* global UCF_SapTableDropDecorator */
/// <reference path="../decorators/SapTableDropDecorator.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_SapTableDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["UCF_SapTableDropDelegate"]++; }; 
	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);
	this["iMatrixRowIndex"] = -1;
	this["iAppDefinedRowIndex"] = -1;
	this["iOffset"] = 0;
	this["iHierarchyLevel"] = -1;

	// Scroll attributes
	this["iFirstVisibleItemInitial"] = 0;
	this["sUpdateScrollPositionTimer"] = null;
	this["iDragScrollTrigger"] = 0;
	this["iDragScrollSkipCounter"] = 10;

};window["UCF_SapTableDropDelegate"] = UCF_SapTableDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableDropDelegate"); UCF_SapTableDropDelegate["_"] = {UCF_SapTableDropDelegate: 0}; }; ;

UCF_SapTableDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_SapTableDropDelegate.prototype["sClassName"] = "UCF_SapTableDropDelegate";

UCF_SapTableDropDelegate["prototype"]["I_AUTOSCROLL_THRESHOLD"] = 20;

UCF_SapTableDropDelegate["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["destroy"]++; }; 

	if (this["sUpdateScrollPositionTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["sUpdateScrollPositionTimer"]);
		this["sUpdateScrollPositionTimer"] = null;
	}
	this["iAppDefinedRowIndex"] = null;
	this["iOffset"] = null;
	this["iHierarchyLevel"] = null;
	this["iFirstVisibleItemInitial"] = null;
	this["sDropTargetInfo"] = null; // eslint-disable-line @ur/no-missing-setClientProperty
	this["iMatrixRowIndex"] = null;
	UCF_DropDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["destroy"] = 0; };

/**
 * @override
 * @see UCF_DropDelegate
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["oCreateDropDecorator"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oCreateDropDecorator"]++; }; 

	return new (UCF_ClassLoader["oGetClass"]("UCF_SapTableDropDecorator"))(this["oDropTargetControl"], this["oLS"]);

};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oCreateDropDecorator"] = 0; };

/**
 * @override
 * @see UCF_DropDelegate
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["sGetDropTags"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["sGetDropTags"]++; }; 
	var oDropTargetInfoControl = null,
		sDropTags = "";

	this["oPrepareAndGetDropCellInfo"](oBrowserEvent);

	if (!this["sDropTargetInfo"]) return "";

	oDropTargetInfoControl = this["oGetDropTargetControl"](oBrowserEvent)["oGetControlById"](this["sDropTargetInfo"]);

	if (!oDropTargetInfoControl) return "";

	sDropTags = oDropTargetInfoControl["sGetTags"]();

	if (!sDropTags) return "";

	return sDropTags;
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["sGetDropTags"] = 0; };

/**
 * @override
 * @see UCF_DropDelegate
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["bIsDropPossible"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["bIsDropPossible"]++; }; 
	var oHoveredCellInfo = this["oDropTargetControl"]["oGetCellInfoByBrowserEvent"](oBrowserEvent);

	if (!this["oDropDecorator"]) {
		//create it for the auto scroll case
		this["oDropDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableDropDecorator"))(this["oDropTargetControl"], this["oLS"]); // eslint-disable-line @ur/no-memory-leaks
	}

	this["oDropDecorator"]["update"](oBrowserEvent);

	if ((!oHoveredCellInfo || this["oDropTargetControl"]["eGetCellType"](oHoveredCellInfo) === this["oDropTargetControl"]["SUBCONTROL"]["HEADER_CELL"])
		&& !this["bIsContentSegment"](this["oDropTargetControl"]["oGetSegmentByBrowserEvent"](oBrowserEvent))
	) {
		return false;
	}

	var bSuperIsDropPossible = UCF_DropDelegate.prototype["bIsDropPossible"]["call"](this, oBrowserEvent);

	if (this["oDropTargetControl"]["iGetRowCount"]() === 0) {
		return bSuperIsDropPossible;
	}

	return this["iMatrixRowIndex"] >= 0
		&& bSuperIsDropPossible
		&& (Math["max"](0, this["iOffset"]) + this["iMatrixRowIndex"]) >= this["iGetFirstVisibleContentCellRowIndex"]();

};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["bIsDropPossible"] = 0; };

/**
 * @override
 * @see UCF_DropDelegate
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["oGetDomRefToBeFocussed"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oGetDomRefToBeFocussed"]++; }; 

	return null;

};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oGetDomRefToBeFocussed"] = 0; };

/**
 * @override
 * @see UCF_DropDelegate
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["onlsdraghover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["onlsdraghover"]++; }; 

	if (!this["bHandleEvent"](oBrowserEvent))
		return;

	var oTable = this["oDropTargetControl"];

	/* hierarchy table: expand row over triangle */
	if (oBrowserEvent["oGetSource"]()["parentNode"]["getAttribute"]("acf") === oTable["ACTION"]["HIERARCHY_EXPAND"]) {
		var oAccessInfo = oTable["oGetAccessInfo"](oBrowserEvent, oTable["ACCESS_TYPE"]["KEYBOARD_EXPAND"]);
		var eCellType = oTable["eGetCellType"](oAccessInfo["oCellInfo"]);

		if (eCellType === oTable["SUBCONTROL"]["HIERARCHY_CELL"]) {
			oTable["fireCellExpand"](
				oTable["sId"],
				oTable["iGetApiRowIndex"](oAccessInfo["oCellInfo"]),
				oTable["sGetRowUserData"](oAccessInfo["oCellInfo"]),
				oTable["sGetCellUserData"](oAccessInfo["oCellInfo"]),
				oAccessInfo["sSubControlId"]
			);

			return;
		}
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["onlsdraghover"] = 0; };

/**
 * A centralizes handler function to collect and dispatch browser events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} true if the evnet is handled by this delegate
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["bHandleEvent"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["bHandleEvent"]++; }; 

	var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"];

	if (!oDragSession)
		return false;

	if (oDragSession["eGetDragType"]() != UCF_DragSession["DRAG_TYPE"]["STANDARD"])
		return false;

	if (oDragSession["sGetCustomType"]() != "")
		return false;

	return true;
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["bHandleEvent"] = 0; };

/**
 * @override
 * @see UCF_DropDelegate
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["onlsdragenter"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["onlsdragenter"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "D&D", "SapTableDropDelegate.js(198): onlsdragenter"); };

	if (!this["bHandleEvent"](oBrowserEvent))
		return;

	var oVerticalScrollUi = this["oGetVerticalScrollUi"]();

	if (oVerticalScrollUi && !this["iFirstVisibleItemInitial"]) this["iFirstVisibleItemInitial"] = oVerticalScrollUi["iGetFirstVisibleItem"]();

	this["handleMouseMove"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["onlsdragenter"] = 0; };

/**
 * @override
 * @see UCF_DropDelegate
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["onlsdragleave"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["onlsdragleave"]++; }; 

	if (!this["bHandleEvent"](oBrowserEvent))
		return;

	UCF_DropDelegate.prototype["onlsdragleave"]["call"](this, oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["onlsdragleave"] = 0; };

/**
 * Initializes the drag  drop operation
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["handleMouseMove"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["handleMouseMove"]++; }; 
	// var oHoveredCellInfo = this.oDropTargetControl.oGetCellInfoByBrowserEvent(oBrowserEvent);

	//if control handles this event it should always cancel bubble
	//to avoid ambiguities (e.g. nested drop targets)
	//oBrowserEvent.cancelBubble();

	var sDropTags = this["sGetDropTags"](oBrowserEvent),
		sValidMimeTypes = this["sGetValidMimeTypes"](oBrowserEvent),
		oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];

	if (!oDragAndDropManager["bGetDropAllowed"](sDropTags, sValidMimeTypes) || !this["bIsDropPossible"](oBrowserEvent)) {
		if (this["oDropDecorator"]) {
			this["oDropDecorator"]["hide"]();
			oBrowserEvent["oDragAndDropManager"]["cleanUpDropArea"]();
		}
		return;
	}

	//initialize drop
	if (!this["oDropDecorator"])
		this["oDropDecorator"] = this["oCreateDropDecorator"]();

	if (this["oDropDecorator"]) {
		this["oDropDecorator"]["init"](oDragAndDropManager["oDragSession"]);
		this["oDropDecorator"]["update"](oBrowserEvent);
	}

	oDragAndDropManager["initDropArea"](
		UCF_DragSession["DROP_TYPE"]["STANDARD"],
		sDropTags,
		this["oDropDecorator"]
	);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["bHandled"] = true;

	// native browser drag drop
	oDragAndDropManager["oDragSession"]["setValidDropZone"](true);

	return true;
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["handleMouseMove"] = 0; };

/**
 * @override
 * @see UCF_DropDelegate
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["onlsdragscroll"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["onlsdragscroll"]++; }; 

	var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"];
	if (!oDragSession) return;

	if (!this["bHandleEvent"](oBrowserEvent) && oDragSession["eGetDragType"]() !== UCF_DragSession["DRAG_TYPE"]["BLOCK_SELECT"] && oDragSession["eGetDragType"]() !== UCF_DragSession["DRAG_TYPE"]["DRAG_SELECT"])
		return;

	var oVerticalScrollbar = this["oGetVerticalScrollbar"]();
	var oContentSegment = this["oDropTargetControl"]["oGetContentSegment"]();

	if (oVerticalScrollbar) {
		//mouse over scrollbar?
		var oScrollbarTrackDomRef = oVerticalScrollbar["oGetFragmentRef"](oVerticalScrollbar["FRAGMENT"]["BAR"]);

		if (oScrollbarTrackDomRef && UCF_DomUtil["bContains"](oScrollbarTrackDomRef, oBrowserEvent["oGetSource"]())) {
			//calculate position of scrollbar
			var iYOffset = oBrowserEvent["iPageY"]() - UCF_DomUtil["oGetObjectRect"](oScrollbarTrackDomRef)["top"] - 3,
				iHeight = oScrollbarTrackDomRef["offsetHeight"] - 1,
				fPercent = iYOffset / iHeight,
				iScrollPos = Math["max"](1, Math["round"](fPercent * oVerticalScrollbar["iGetMaxScrollTo"]()));

			this["setScrollPosition"](iScrollPos);
		}
		else if (oContentSegment) {
			var oContentSegmentRect = UCF_DomUtil["oGetObjectRect"](oContentSegment);
			if (oBrowserEvent["iPageY"]() > oContentSegmentRect["top"] && oBrowserEvent["iPageY"]() < (oContentSegmentRect["top"] + 10)) {
				if (this["iDragScrollTrigger"] === this["iDragScrollSkipCounter"]) {
					this["iDragScrollTrigger"] = 0;
					this["setScrollPosition"]("PREVIOUS");
				}
				this["iDragScrollTrigger"]++;
			}
			if (oBrowserEvent["iPageY"]() > (oContentSegmentRect["top"] + oContentSegmentRect["height"] - 10) && oBrowserEvent["iPageY"]() < (oContentSegmentRect["top"] + oContentSegmentRect["height"])) {
				if (this["iDragScrollTrigger"] === this["iDragScrollSkipCounter"]) {
					this["iDragScrollTrigger"] = 0;
					this["setScrollPosition"]("NEXT");
				}
				this["iDragScrollTrigger"]++;
			}
		}
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["onlsdragscroll"] = 0; };

/**
 */
UCF_SapTableDropDelegate["prototype"]["checkAutoScroll"] = function (iPageX, iPageY) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["checkAutoScroll"]++; }; 

	var oTable = this["oDropTargetControl"],
		oDomRefContent = UCF_DomUtil["$"](oTable["sId"] + "-" + oTable["SUFFIX"]["CONTENT_AREA"]),
		oRect = oDomRefContent ? UCF_DomUtil["oGetObjectRect"](oDomRefContent) : null;

	if (oRect) {
		var oFirstVisibleContentCell = oTable["oGetRowReferenceCell"](this["iGetFirstVisibleContentCellRowIndex"]());

		// check for header row offset
		if (oFirstVisibleContentCell && oFirstVisibleContentCell["oDomRefRow"]) {
			var oFirstRect = UCF_DomUtil["oGetObjectRect"](oFirstVisibleContentCell["oDomRefRow"], oDomRefContent);

			oRect["top"] += oFirstRect["top"];
			oRect["height"] -= oFirstRect["top"];

			if (iPageY < oRect["top"] + this["I_AUTOSCROLL_THRESHOLD"]) {
				this["setScrollPosition"]("PREVIOUS");
			} else if (iPageY > oRect["top"] + oRect["height"] - this["I_AUTOSCROLL_THRESHOLD"]) {
				this["setScrollPosition"]("NEXT");
			}

		}
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["checkAutoScroll"] = 0; };

/**
 * Checks for the drag over event if the scrollbar has to be activated to reach hidden rows
 *
 * @param {string} sScrollPos
 *
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["setScrollPosition"] = function (sScrollPos) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["setScrollPosition"]++; }; 

	/* scrolling with the scrollbar */
	var oVerticalScrollUi = this["oGetVerticalScrollUi"]();
	if (!oVerticalScrollUi)
		return;

	var bCanClientScroll = this["oDropTargetControl"]["bCanClientScroll"](false),
		iScrollPos = parseInt(sScrollPos);

	if (!bCanClientScroll) {
		oVerticalScrollUi["setNotifactionMode"](oVerticalScrollUi["NOTIFICATION"]["NEVER"]);
	}

	if (isNaN(iScrollPos)) {
		if (sScrollPos === "NEXT") {
			oVerticalScrollUi["scrollToNext"]();
		} else if (sScrollPos === "PREVIOUS") {
			oVerticalScrollUi["scrollToPrevious"]();
		}
	} else {
		oVerticalScrollUi["scrollToPosition"](iScrollPos, UCF_JsUtil["MODIFIER"]["NONE"]);
	}

	if (bCanClientScroll) {
		this["iFirstVisibleItemInitial"] = oVerticalScrollUi["iGetFirstVisibleItem"]();
	} else {
		oVerticalScrollUi["setNotifactionMode"](oVerticalScrollUi["NOTIFICATION"]["mOldNotificationMode"]);

		oVerticalScrollUi["showScrollTip"]();

		UCF_JsUtil["clearDelayedCall"](this["sUpdateScrollPositionTimer"]);
		this["sUpdateScrollPositionTimer"] = UCF_JsUtil["delayedCall"](350, this, "setScrollPositionDelayed");
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["setScrollPosition"] = 0; };

/**
 * @override
 * @see UCF_DropDelegate
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["setScrollPositionDelayed"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["setScrollPositionDelayed"]++; }; 

	/* scrolling with the scrollbar */
	var oVerticalScrollUi = this["oGetVerticalScrollUi"]();
	if (!oVerticalScrollUi)
		return;

	//if mouse over scrollbar track trigger roundtrip
	var mOldNotificationMode = oVerticalScrollUi["mGetNotifactionMode"]();

	oVerticalScrollUi["setNotifactionMode"](oVerticalScrollUi["NOTIFICATION"]["ALWAYS"]);
	this["iFirstVisibleItemInitial"] = oVerticalScrollUi["iGetFirstVisibleItem"]();
	oVerticalScrollUi["scrollToPosition"](this["iFirstVisibleItemInitial"], UCF_JsUtil["MODIFIER"]["NONE"]);
	oVerticalScrollUi["setNotifactionMode"](mOldNotificationMode);

	if (UCF_JsUtil["bInstanceOf"](oVerticalScrollUi, "UCF_Scrollbar")) { // Only for scrollbar instance and not Pager etc.
		oVerticalScrollUi["hideScrollTip"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["setScrollPositionDelayed"] = 0; };

/**
 * @override
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["fGetDropCallBack"] = function (oDragSession) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["fGetDropCallBack"]++; }; 
	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		iRowIndex = this["iAppDefinedRowIndex"],
		iOffset = this["iOffset"],
		iHierarchyLevel = this["iHierarchyLevel"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function (sDragData, sMimeType) {

		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,

			//Table specific event parameters
			"", //TODO Adapt DropTargetCellId
			iRowIndex,
			-1, //TODO Adapt ColIndex
			"VERTICAL", //TODO Adapt Direction (VERTICAL, HORIZONTAL, NONE)
			iOffset,
			iHierarchyLevel,

			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);
	};

};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["fGetDropCallBack"] = 0; };

/**
 * Searches for the cell info under the given hover event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {Object} the cell info of the cell under the hover event
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["oPrepareAndGetDropCellInfo"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oPrepareAndGetDropCellInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SapTableDropDelegate.js(474): oPrepareAndGetDropCellInfo"); };

	var oSapTable = this["oDropTargetControl"],
		oHoveredCellInfo = oSapTable["oGetCellInfoByBrowserEvent"](oBrowserEvent),
		iRowCount = oSapTable["iGetRowCount"](),
		iLastRowIndex = oSapTable["iGetContentRowOffset"]() + iRowCount - 1,

		oResultCell = null,
		iMatrixRowIndex = -1,
		iOffset = 0,
		sDropTargetInfo = "",
		iHierarchyLevel = -1;

	//empty table
	if (iRowCount === 0) {
		oResultCell = null;
		iOffset = 0;
		sDropTargetInfo = oSapTable["sGetRowRootDropTargetInfo"]();

	} else if (oHoveredCellInfo) {

		//mouse under the last row with content
		if (oSapTable["mGetCellUsageType"](oHoveredCellInfo) === oSapTable["CELL_USAGE_TYPE"]["EMPTYROW"]) {

			oResultCell = oSapTable["oGetRowReferenceCell"](iLastRowIndex);
			iOffset = 1;
			sDropTargetInfo = oSapTable["sGetRowParentDropTargetInfo"](oResultCell);

		} else {

			oResultCell = oHoveredCellInfo;

			if (oResultCell) {
				var oCellRect = UCF_DomUtil["oGetObjectRect"](oResultCell["oDomRefCell"]),
					iMouseY = oBrowserEvent["iPageY"](),
					fThreshold = 0.5,
					sRowDropTargetInfo = oSapTable["sGetRowDropTargetInfo"](oResultCell),
					sParentDropTargetInfo = oSapTable["sGetRowParentDropTargetInfo"](oResultCell),
					oHierarchyCellInfo = null;

				if (sParentDropTargetInfo) {
					if (sRowDropTargetInfo) fThreshold = 0.25;

					if (iMouseY < oCellRect["top"] + (oCellRect["height"] * fThreshold)) iOffset = -1; //mouse in the upper region?
					else if (iMouseY >= oCellRect["top"] + (1 - fThreshold) * oCellRect["height"]) iOffset = 1; //mouse in the lower region
					else iOffset = 0; //mouse in the middle of the row

					sDropTargetInfo = (iOffset === 0) ? sRowDropTargetInfo : sParentDropTargetInfo;

				} else if (sRowDropTargetInfo) { //no parent
					iOffset = 0;
					sDropTargetInfo = sRowDropTargetInfo;
				}

				oHierarchyCellInfo = oSapTable["oGetCellInfoInRowByType"](oResultCell["iRowIndex"], 0, oSapTable["SUBCONTROL"]["HIERARCHY_CELL"]);

				if (oHierarchyCellInfo) {
					oResultCell = oHierarchyCellInfo;

					//Between an expanded parent node and its children only an insert child operation should be possible
					if (iOffset === 1) {
						var oNextHierarchyCellInfo = oSapTable["oGetCellInfoInRowByType"](oResultCell["iRowIndex"] + oResultCell["iRowSpan"], 0, oSapTable["SUBCONTROL"]["HIERARCHY_CELL"]);

						if (oNextHierarchyCellInfo &&
							oSapTable["iGetCellHierarchyLevel"](oResultCell) < oSapTable["iGetCellHierarchyLevel"](oNextHierarchyCellInfo)
						) {
							oResultCell = oNextHierarchyCellInfo;
							iOffset = -1;
							sDropTargetInfo = oSapTable["sGetRowParentDropTargetInfo"](oNextHierarchyCellInfo);
						}
					}

					iHierarchyLevel = oSapTable["iGetCellHierarchyLevel"](oResultCell);

				}
			}

			if (oResultCell && iOffset !== 0) {
				//check if drop decorator is not between the rows of a table popin
				//check the neighboured row
				var oNextCellInfo = oSapTable["oGetRowReferenceCell"](iOffset === 1 ? oResultCell["iRowIndex"] + oResultCell["iRowSpan"] : oResultCell["iRowIndex"] - 1);

				if (oSapTable["bIsValidCellInfo"](oNextCellInfo)) {
					var iNeighbourRowIndex = oSapTable["iGetApiRowIndex"](oNextCellInfo),
						oResultRowIndex = oSapTable["iGetApiRowIndex"](oResultCell);

					if (oResultRowIndex === iNeighbourRowIndex) oResultCell = null;
				}
			}

		}
	} else {
		if (this["bIsContentSegment"](oSapTable["oGetSegmentByBrowserEvent"](oBrowserEvent))) {
			oResultCell = oSapTable["oGetRowReferenceCell"](iLastRowIndex);

			if (oSapTable["bIsValidCellInfo"](oResultCell)) {
				iOffset = 1;
				sDropTargetInfo = oSapTable["sGetRowParentDropTargetInfo"](oResultCell);
			} else {
				oResultCell = null;
			}
		}
	}

	if (oResultCell) {
		iMatrixRowIndex = oResultCell["iRowIndex"];

		//Level correction and level choice by mouse when insert after hierarchy cell is triggered
		if (iOffset === 1 && oSapTable["eGetCellType"](oResultCell) === oSapTable["SUBCONTROL"]["HIERARCHY_CELL"]) {
			var iMinLevel = -1,
				bExpanded = oResultCell["oDomRefCell"]["getAttribute"]("st") === "+";

			if (bExpanded) iHierarchyLevel++;

			// insert after last content cell in a table tree -> provide different level drops down to root level
			if (iHierarchyLevel > 0 && oSapTable["iGetContentRowIndex"](oResultCell) === oSapTable["iGetRowCount"]() - 1) {
				iMinLevel = 0;
			} else if (bExpanded) {
				iMinLevel = iHierarchyLevel - 1;
			}

			if (iMinLevel >= 0) {
				var iLeftOffset = Math["max"](0, oBrowserEvent["iClientX"]() - UCF_DomUtil["oGetObjectRect"](oResultCell["oDomRefCell"])["left"]),
					iLeftLevelOffset = 0;

				while (iHierarchyLevel > iMinLevel) {
					iLeftLevelOffset = oSapTable["iGetHierarchyCellLevelIndention"](iHierarchyLevel);
					if (iLeftOffset >= iLeftLevelOffset) break;
					iHierarchyLevel--;
				}
			}
		}

	}

	if (iMatrixRowIndex >= 0 && iOffset === 1) iMatrixRowIndex += (oResultCell["iRowSpan"] - 1);

	if (iMatrixRowIndex >= 0) {
		var oReferenceCell = oSapTable["oGetCellInfo"](iMatrixRowIndex, 0);

		this["iMatrixRowIndex"] = iMatrixRowIndex;
		this["iAppDefinedRowIndex"] = oSapTable["bIsValidCellInfo"](oReferenceCell) ? oSapTable["iGetApiRowIndex"](oReferenceCell) : -1;

	} else {
		this["iMatrixRowIndex"] = -1;
		this["iAppDefinedRowIndex"] = -1;
	}

	this["iOffset"] = iOffset;
	this["sDropTargetInfo"] = sDropTargetInfo; // eslint-disable-line @ur/no-missing-setClientProperty
	this["iHierarchyLevel"] = iHierarchyLevel;

	return oResultCell;
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oPrepareAndGetDropCellInfo"] = 0; };

/**
 * Checks if a segment is part of the content segment.
 *
 * @param {HTMLElement} oSegment
 *
 * @return {boolean} true if cit is a content segment
 * @private
 */
UCF_SapTableDropDelegate["prototype"]["bIsContentSegment"] = function (oSegment) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["bIsContentSegment"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["bIsContentSegment"] = 0; };

/**
 * @return the id of the dropTargetInfo control
 * @type string
 *
 */
UCF_SapTableDropDelegate["prototype"]["oGetDropTargetInfoId"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oGetDropTargetInfoId"]++; }; 

	var oDropTargetControl = this["oGetDropTargetControl"](oBrowserEvent);
	if (oDropTargetControl) {
		return oDropTargetControl["sGetRowRootDropTargetInfo"]();
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oGetDropTargetInfoId"] = 0; };

/**
 *
 *
 * @return the tabe scrollbar
 * @type UCF_Scrollbar
 */
UCF_SapTableDropDelegate["prototype"]["oGetVerticalScrollbar"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oGetVerticalScrollbar"]++; }; 
	var oVerticalScrollbar = this["oDropTargetControl"]["oScrollV"];

	if (oVerticalScrollbar && UCF_JsUtil["bInstanceOf"](oVerticalScrollbar, "UCF_Scrollbar"))
		return oVerticalScrollbar;

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oGetVerticalScrollbar"] = 0; };

/**
 *
 *
 * @return the tabe scroll UI
 * @type UCF_Scrollbar
 */
UCF_SapTableDropDelegate["prototype"]["oGetVerticalScrollUi"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oGetVerticalScrollUi"]++; }; 
	var oVerticalScrollUi = this["oDropTargetControl"]["oScrollV"];

	if (oVerticalScrollUi && UCF_JsUtil["bInstanceOf"](oVerticalScrollUi, "UCF_ScrollBase"))
		return oVerticalScrollUi;

	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["oGetVerticalScrollUi"] = 0; };

/**
 *  Returns the row index of the first visible cell
 *
 * @return the row index
 * @type integer
 */
UCF_SapTableDropDelegate["prototype"]["iGetFirstVisibleContentCellRowIndex"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["iGetFirstVisibleContentCellRowIndex"]++; }; 
	var oTable = this["oDropTargetControl"];

	return oTable["iGetContentRowOffset"]() + (oTable["bCanClientScroll"](false) ? oTable["iVisibleFirstRow"] : 0);

};;if (__UCF_COVERAGE__) { UCF_SapTableDropDelegate["_"]["iGetFirstVisibleContentCellRowIndex"] = 0; };

};
sap["ls"]["preload"]["UCF_SapTableHeaderCell"] = function() {/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_SapTableBaseCell */
/// <reference path="./base/SapTableBaseCell.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_SapTable} oTable
 */
function UCF_SapTableHeaderCell(oDomRef, oTable) {if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["UCF_SapTableHeaderCell"]++; }; 
	UCF_SapTableBaseCell["apply"](this, arguments);
	this["oHeader"] = this;
};window["UCF_SapTableHeaderCell"] = UCF_SapTableHeaderCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableHeaderCell"); UCF_SapTableHeaderCell["_"] = {UCF_SapTableHeaderCell: 0}; }; ;
UCF_SapTableHeaderCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableBaseCell"))(); UCF_SapTableHeaderCell.prototype["sClassName"] = "UCF_SapTableHeaderCell";

/**
 * Destructor
 * @private
 */
UCF_SapTableHeaderCell["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["destroy"]++; }; 
	UCF_SapTableBaseCell.prototype["destroy"]["apply"](this, arguments);
	this["oHeader"] = null;
};;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["destroy"] = 0; };

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableHeaderCell["prototype"]["setCellState"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["setCellState"]++; }; 

	if (this["oTable"]["mDataTips"]) {
		var oDataTip = this["oTable"]["mDataTips"][this["sId"]];

		if (oDataTip) {
			this["oTable"]["addDelegate"](oDataTip);
			UCF_JsUtil["delayedCall"](0, this["oTable"], "removeDataTipDelegateById", [this["sId"]]);
		}
	}

	// SortState = DISABLED, NONE, ASCENDING, DESCENDING
	if (this["sSortState"] === "ASCENDING") this["oAccessibilityHelper"]["setSortedAscending"](true);
	if (this["sSortState"] === "DESCENDING") this["oAccessibilityHelper"]["setSortedDescending"](true);
	//if(this.sSortState == "NONE") this.oAccessibilityHelper.setSortable(true);

	// Text
	var sText = null;

	if (this["sHeaderCellType"] !== "SELECTIONCOLUMN") {
		var sColumnInfo = this["sSpaceCleanUp"](this["sGetColumnInfo"]()),
			sCaptionId = this["oDomRef"]["getAttribute"]("captionId");

		if (sColumnInfo) {
			sText = sColumnInfo;
		} else {
			sText = this["oAccessibilityHelper"]["sGetText"]("EMPTY");
		}

		if (sCaptionId) {
			var oCaption = this["oTable"]["oLS"]["oControlFactory"]["oGetControlById"](sCaptionId);
			oCaption["applyAccSemantic"](this["oAccessibilityHelper"]);
		}
	}

	if (sText) this["oAccessibilityHelper"]["setText"](sText);

	// Tooltip
	if (this["sTooltip"] && this["sTooltip"] !== sText) // avoid double announcement
		this["oAccessibilityHelper"]["addTooltip"](this["sTooltip"]); {

		if (this["sIconTooltip"])
			this["oAccessibilityHelper"]["addTooltip"](this["sIconTooltip"]);
	}

	if (this["bFiltered"]) this["oAccessibilityHelper"]["setFiltered"](true);

	// Control Type
	if (this["oAccessInfo"]["eAction"] === this["oTable"]["ACTION"]["SELECTION_MENU_OPEN"]) {

		this["oAccessibilityHelper"]["setControlType"]("ST_SMNU");

	} else if (this["sHeaderCellType"] === "SELECTIONCOLUMN") {

		this["oAccessibilityHelper"]["setControlType"]("ST_SCOL");

	} else {

		if (this["sHeaderCellDesign"] === "LEVEL1HEADER")
			this["oAccessibilityHelper"]["setControlType"]("ST_HDR1");
		else if (this["sHeaderCellDesign"] === "LEVEL2HEADER")
			this["oAccessibilityHelper"]["setControlType"]("ST_HDR2");
		else if (this["sHeaderCellDesign"] === "LEVEL3HEADER")
			this["oAccessibilityHelper"]["setControlType"]("ST_HDR3");

	}

};;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["setCellState"] = 0; };

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableHeaderCell["prototype"]["mGetSelectionState"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["mGetSelectionState"]++; }; 
	return this["bColumnSelected"] ? this["SELECTION_STATE"]["COLUMN"] : this["SELECTION_STATE"]["NOT_SELECTED"];
};;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["mGetSelectionState"] = 0; };

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableHeaderCell["prototype"]["sGetTutorInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["sGetTutorInfo"]++; }; 
	if (this["oAccessInfo"]["eAction"] === this["oTable"]["ACTION"]["HEADER_ACTION_MENU_OPEN"]) {
		return "ST_HDR_ACT_MENU";
	} else if (this["oAccessInfo"]["eAction"] === this["oTable"]["ACTION"]["SELECTION_MENU_OPEN"]) {
		return "MENUSPACE_TUT";
	} else if (this["oAccessInfo"]["eAction"] === this["oTable"]["ACTION"]["HEADER_SORT"]) {

		if (this["sSortState"] === "DESCENDING") {
			return "ST_SRT_ASC_TUT";
		} else if (this["sSortState"] === "ASCENDING") {
			return "ST_SRT_DES_TUT";
		} else if (this["sSortState"] === "NONE") {
			return "ST_SRT_TUT";
		}

	} else if (this["bColumnSelectable"]) {
		if (this["bColumnSelected"]) {
			//TODO return this.oAccessibilityHelper.sGetText("");
		} else {
			//TODO return this.oAccessibilityHelper.sGetText("");
		}

	} else if (this["oAccessInfo"]["eAction"] === this["oTable"]["ACTION"]["HEADER_ICON"]) {
		return "ST_HDR_ICO";
	} else if (this["bIconEnabled"] && !this["bIconFirst"]) {
		return "ST_HDR_OPT_NAV";
	} else if (this["sSortState"] !== "DISABLED") {
		return "ST_HDR_SORT";
	}

	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["sGetTutorInfo"] = 0; };

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableHeaderCell["prototype"]["sGetColumnInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["sGetColumnInfo"]++; }; 
	return this["sGetHeaderInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["sGetColumnInfo"] = 0; };

/**
 * Returns the current visible HeaderCellCaption aggregation of the SapTableHeaderCell
 * @returns {UCF_Caption} The HeaderCellCaption aggregation
 * @public
 */
UCF_SapTableHeaderCell["prototype"]["getCurrentHeaderCellCaption"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["getCurrentHeaderCellCaption"]++; }; 
	var oContentCurrentRefs = null;
	var oCurrentHeaderCellCaptionRef = null;
	var oCurrentHeaderCellCaption = null;
	if (this["oTable"]["bColumnTitleAdoption"]) {
			oContentCurrentRefs = UCF_DomUtil["getElementsByClassName"]('lsSTHCCPContentCurrent', this["oDomRef"]);
			if (oContentCurrentRefs && oContentCurrentRefs[0]) oCurrentHeaderCellCaptionRef = UCF_DomUtil["oGetFirstChildCTElement"](oContentCurrentRefs[0]);
			if (oCurrentHeaderCellCaptionRef) oCurrentHeaderCellCaption = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oCurrentHeaderCellCaptionRef, true);
			if (oCurrentHeaderCellCaption && UCF_JsUtil["bInstanceOf"](oCurrentHeaderCellCaption, 'UCF_Caption')) return oCurrentHeaderCellCaption;
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["getCurrentHeaderCellCaption"] = 0; };

/**
 * Returns the current visible Title aggregation of the SapTableCSHeaderCell
 * @returns {UCF_Caption} The Title aggregation
 * @public
 */
UCF_SapTableHeaderCell["prototype"]["getCurrentTitle"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["getCurrentTitle"]++; }; 
	var oContentCurrentRefs = null;
	var oCurrentHeaderCellCaptionRef = null;
	var oCurrentHeaderCellCaption = null;
	if (this["oTable"]["bColumnTitleAdoption"]) {
			oContentCurrentRefs = UCF_DomUtil["getElementsByClassName"]('lsSTHCCPContentCurrent', this["oDomRef"]);
			if (oContentCurrentRefs && oContentCurrentRefs[0]) oCurrentHeaderCellCaptionRef = UCF_DomUtil["oGetFirstChildCTElement"](oContentCurrentRefs[0]);
			if (oCurrentHeaderCellCaptionRef) oCurrentHeaderCellCaption = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oCurrentHeaderCellCaptionRef, true);
			if (oCurrentHeaderCellCaption && UCF_JsUtil["bInstanceOf"](oCurrentHeaderCellCaption, 'UCF_Caption')) return oCurrentHeaderCellCaption;
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["getCurrentTitle"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SapTableHeaderCell["prototype"]["aAttributeNames"] = ["sSortState","sHeaderCellDesign","sHeaderCellType","sSelectionColumnAction","sSelectionMenuId","sRowSelectionMassState","bRequired","sTooltip","bColumnSelected","bColumnSelectable","bFiltered","bMarkTotals","sAccessibilityDescription","sIconTooltip","bIconFirst","bIconEnabled","sCustomStyle","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SapTableHeaderCell["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SapTableHeaderCell["prototype"]["aMethodNames"] = ["getCurrentHeaderCellCaption","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SortState}
 */
UCF_SapTableHeaderCell["prototype"]["sSortState"] = "DISABLED";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableHeaderCellDesign}
 */
UCF_SapTableHeaderCell["prototype"]["sHeaderCellDesign"] = "LEVEL1HEADER";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableHeaderCellType}
 */
UCF_SapTableHeaderCell["prototype"]["sHeaderCellType"] = "STANDARD";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableSelectionColumnAction}
 */
UCF_SapTableHeaderCell["prototype"]["sSelectionColumnAction"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_SapTableHeaderCell["prototype"]["sSelectionMenuId"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableRowSelectionMassState}
 */
UCF_SapTableHeaderCell["prototype"]["sRowSelectionMassState"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableHeaderCell["prototype"]["bRequired"] = false;

/**
 * @private
 * @type {string}
 */
UCF_SapTableHeaderCell["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableHeaderCell["prototype"]["bColumnSelected"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableHeaderCell["prototype"]["bColumnSelectable"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableHeaderCell["prototype"]["bFiltered"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableHeaderCell["prototype"]["bMarkTotals"] = false;

/**
 * @private
 * @type {string}
 */
UCF_SapTableHeaderCell["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableHeaderCell["prototype"]["sIconTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableHeaderCell["prototype"]["bIconFirst"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableHeaderCell["prototype"]["bIconEnabled"] = false;

/**
 * @private
 * @type {string}
 */
UCF_SapTableHeaderCell["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableHeaderCell["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_SapTableHeaderCell["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["setDefaultValues"]++; }; 
	this["sSortState"] = "DISABLED";
	this["sHeaderCellDesign"] = "LEVEL1HEADER";
	this["sHeaderCellType"] = "STANDARD";
	this["sSelectionColumnAction"] = "NONE";
	this["sSelectionMenuId"] = '';
	this["sRowSelectionMassState"] = "NONE";
	this["bRequired"] = false;
	this["sTooltip"] = '';
	this["bColumnSelected"] = false;
	this["bColumnSelectable"] = false;
	this["bFiltered"] = false;
	this["bMarkTotals"] = false;
	this["sAccessibilityDescription"] = '';
	this["sIconTooltip"] = '';
	this["bIconFirst"] = false;
	this["bIconEnabled"] = false;
	this["sCustomStyle"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("SortState", "DISABLED", true);
		this["setClientProperty"]("HeaderCellDesign", "LEVEL1HEADER", true);
		this["setClientProperty"]("HeaderCellType", "STANDARD", true);
		this["setClientProperty"]("SelectionColumnAction", "NONE", true);
		this["setClientProperty"]("SelectionMenuId", '', true);
		this["setClientProperty"]("RowSelectionMassState", "NONE", true);
		this["setClientProperty"]("Required", false, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("ColumnSelected", false, true);
		this["setClientProperty"]("ColumnSelectable", false, true);
		this["setClientProperty"]("Filtered", false, true);
		this["setClientProperty"]("MarkTotals", false, true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("IconTooltip", '', true);
		this["setClientProperty"]("IconFirst", false, true);
		this["setClientProperty"]("IconEnabled", false, true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableHeaderCell["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_SapTableHeaderCell.prototype["aPublicMethods"] = ["getCurrentHeaderCellCaption","getCurrentTitle"].concat(UCF_SapTableHeaderCell.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_SapTableHierarchicalCell"] = function() {/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_SapTableBaseCell */
/// <reference path="./base/SapTableBaseCell.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_SapTable} oTable
 */
function UCF_SapTableHierarchicalCell(oDomRef, oTable) {if (__UCF_COVERAGE__) { UCF_SapTableHierarchicalCell["_"]["UCF_SapTableHierarchicalCell"]++; }; 
	UCF_SapTableBaseCell["apply"](this, arguments);

	if (window["UCF_System"]["bIsAria"] && this["bInitialized"] !== true) {
		var sAriaLabel = "";
		this["bInitialized"] = true;
		if (oDomRef["getAttribute"]("subct") == 'HIC') {
			try {
				var oNode = UCF_DomUtil["oGetFirstChildByAttribute"](this["oDomRef"], "hic-aria", "true");
				if (oNode) {
					var oChildNodes = oNode["parentNode"]["getElementsByTagName"]("TD");
					if (oChildNodes) {
						var oTD = oChildNodes[oChildNodes["length"] - 1];
						oChildNodes = oTD["getElementsByTagName"]("SPAN");
						var sDec = oChildNodes[1]["id"];
						oNode["setAttribute"]("aria-describedby", sDec);
						sAriaLabel = this["oLS"]["sGetText"]("SAPUR_TBV_CELL", [this["oCellInfo"]["iRowIndex"], this["oCellInfo"]["iColIndex"]]);
						if (this["sStatus"] === "MARKTOTALS" || this["sStatus"] === "ICON") sAriaLabel += " " + this["oLS"]["sGetText"]("SAPUR_B_TUT");
						oNode["setAttribute"]("aria-label", sAriaLabel);
					}
				}
			} catch (e) { }
		}
	}
};window["UCF_SapTableHierarchicalCell"] = UCF_SapTableHierarchicalCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableHierarchicalCell"); UCF_SapTableHierarchicalCell["_"] = {UCF_SapTableHierarchicalCell: 0}; }; ;
UCF_SapTableHierarchicalCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableBaseCell"))(); UCF_SapTableHierarchicalCell.prototype["sClassName"] = "UCF_SapTableHierarchicalCell";

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableHierarchicalCell["prototype"]["setCellState"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableHierarchicalCell["_"]["setCellState"]++; }; 
	// Tooltip
	if (this["sContentTypeTooltip"])
		this["oAccessibilityHelper"]["addTooltip"](this["sContentTypeTooltip"]);

	// SapTableHierarchicalCellStatus = NONE, INDENT, EXPANDED, COLLAPSED, COLLAPSEDPLUS, EXPANDEDMINUS, EXPANDEDTOP, MARKTOTALS, LEAF, ICON
	if (this["sStatus"] == "EXPANDED"
		|| this["sStatus"] == "EXPANDEDMINUS"
		|| this["sStatus"] == "EXPANDEDTOP"
	) {
		this["oAccessibilityHelper"]["setExpanded"](true);
	}

	if (this["sStatus"] == "COLLAPSED"
		|| this["sStatus"] == "COLLAPSEDPLUS"
	) {
		this["oAccessibilityHelper"]["setCollapsed"](true);
	}

	if (this["iLevel"] === 0 && this["sCellDesign"] == "GROUP_LEVEL1") {
		if (this["oAccessInfo"]["eAction"] == this["oTable"]["ACTION"]["HIERARCHY_EXPAND"]) {
			this["oAccessibilityHelper"]["setControlType"]("ST_HDRGRPEXP");
		} else if (this["oAccessInfo"]["eAction"] == this["oTable"]["ACTION"]["HIERARCHY_COLLAPSE"]) {
			this["oAccessibilityHelper"]["setControlType"]("ST_HDRGRPCOL");
		} else {
			this["oAccessibilityHelper"]["setControlType"]("ST_HDRGRP");
		}
	} else if (this["iLevel"] === 0 && (this["sCellDesign"] == "TOTAL" || this["sCellDesign"] == "SUBTOTAL" || this["sCellDesign"] == "SUBTOTAL_LIGHT")) {
		// No level announcement for zero level summary cells
	} else {
		// Level
		if (this["sStatus"] == "MARKTOTALS") // In marktotals mode the level announcement is not zero based
			this["oAccessibilityHelper"]["setLevel"](this["iLevel"]);
		else
			this["oAccessibilityHelper"]["setLevel"](this["iLevel"] + 1);
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableHierarchicalCell["_"]["setCellState"] = 0; };

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableHierarchicalCell["prototype"]["sGetTutorInfo"] = function () {;if (__UCF_COVERAGE__) { UCF_SapTableHierarchicalCell["_"]["sGetTutorInfo"]++; }; 
	if (this["bStatusEnabled"]) {
		var sAltAction = this["oTable"]["sGetAlternativeAction"](this["oAccessInfo"]);

		if (sAltAction == this["oTable"]["ACTION"]["HIERARCHY_ALTERNATIVE"]) {
			//TODO not specified yet
		} else if (sAltAction == this["oTable"]["ACTION"]["HIERARCHY_EXPAND"]) {
			// Do not read tutortext anymore in this case -> discussed with ACC -> Internal message: 891748 2008
			//return "ST_EXP_TUT";
		} else if (sAltAction == this["oTable"]["ACTION"]["HIERARCHY_COLLAPSE"]) {
			// Do not read tutortext anymore in this case -> discussed with ACC -> Internal message: 891748 2008
			//return "ST_COL_TUT";
		}
	}
	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableHierarchicalCell["_"]["sGetTutorInfo"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SapTableHierarchicalCell["prototype"]["aAttributeNames"] = ["bIsSelected","bIsSecondarySelected","sCellDesign","sHeaderCellIds","iLevel","sStatus","bStatusEnabled","sContentTypeTooltip","sCustomStyle","sCustomData","sAccessibilityDescription"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SapTableHierarchicalCell["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SapTableHierarchicalCell["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableHierarchicalCell["prototype"]["bIsSelected"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableHierarchicalCell["prototype"]["bIsSecondarySelected"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_SapTableHierarchicalCell["prototype"]["sCellDesign"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_SapTableHierarchicalCell["prototype"]["sHeaderCellIds"] = '';

/**
 * @private
 * @type {number}
 */
UCF_SapTableHierarchicalCell["prototype"]["iLevel"] = 0;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableHierarchicalCellStatus}
 */
UCF_SapTableHierarchicalCell["prototype"]["sStatus"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableHierarchicalCell["prototype"]["bStatusEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_SapTableHierarchicalCell["prototype"]["sContentTypeTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableHierarchicalCell["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableHierarchicalCell["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableHierarchicalCell["prototype"]["sAccessibilityDescription"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_SapTableHierarchicalCell["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableHierarchicalCell["_"]["setDefaultValues"]++; }; 
	this["bIsSelected"] = false;
	this["bIsSecondarySelected"] = false;
	this["sCellDesign"] = "STANDARD";
	this["sHeaderCellIds"] = '';
	this["iLevel"] = 0;
	this["sStatus"] = "NONE";
	this["bStatusEnabled"] = true;
	this["sContentTypeTooltip"] = '';
	this["sCustomStyle"] = '';
	this["sCustomData"] = '';
	this["sAccessibilityDescription"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("IsSelected", false, true);
		this["setClientProperty"]("IsSecondarySelected", false, true);
		this["setClientProperty"]("CellDesign", "STANDARD", true);
		this["setClientProperty"]("HeaderCellIds", '', true);
		this["setClientProperty"]("Level", 0, true);
		this["setClientProperty"]("Status", "NONE", true);
		this["setClientProperty"]("StatusEnabled", true, true);
		this["setClientProperty"]("ContentTypeTooltip", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableHierarchicalCell["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_SapTableMatrixCell"] = function() {/* global UCF_SapTableBaseCell */
/// <reference path="./base/SapTableBaseCell.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_SapTable} oTable
 */
function UCF_SapTableMatrixCell(oDomRef, oTable) {if (__UCF_COVERAGE__) { UCF_SapTableMatrixCell["_"]["UCF_SapTableMatrixCell"]++; }; 
	UCF_SapTableBaseCell["apply"](this, arguments);
};window["UCF_SapTableMatrixCell"] = UCF_SapTableMatrixCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableMatrixCell"); UCF_SapTableMatrixCell["_"] = {UCF_SapTableMatrixCell: 0}; }; ;
UCF_SapTableMatrixCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableBaseCell"))(); UCF_SapTableMatrixCell.prototype["sClassName"] = "UCF_SapTableMatrixCell";

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableMatrixCell["prototype"]["setCellState"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableMatrixCell["_"]["setCellState"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_SapTableMatrixCell["_"]["setCellState"] = 0; };

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableMatrixCell["prototype"]["mGetSelectionState"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableMatrixCell["_"]["mGetSelectionState"]++; }; 
	return this["SELECTION_STATE"]["NOT_SELECTED"];
};;if (__UCF_COVERAGE__) { UCF_SapTableMatrixCell["_"]["mGetSelectionState"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SapTableMatrixCell["prototype"]["aAttributeNames"] = ["sCellBackgroundDesign","sHeaderCellIds","sRowHeaderCellIds","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SapTableMatrixCell["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SapTableMatrixCell["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_SapTableMatrixCell["prototype"]["sCellBackgroundDesign"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_SapTableMatrixCell["prototype"]["sHeaderCellIds"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableMatrixCell["prototype"]["sRowHeaderCellIds"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableMatrixCell["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_SapTableMatrixCell["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableMatrixCell["_"]["setDefaultValues"]++; }; 
	this["sCellBackgroundDesign"] = "STANDARD";
	this["sHeaderCellIds"] = '';
	this["sRowHeaderCellIds"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CellBackgroundDesign", "STANDARD", true);
		this["setClientProperty"]("HeaderCellIds", '', true);
		this["setClientProperty"]("RowHeaderCellIds", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableMatrixCell["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_SapTableSelectionCell"] = function() {/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_SapTableBaseCell */
/// <reference path="./base/SapTableBaseCell.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_SapTable} oTable
 */
function UCF_SapTableSelectionCell(oDomRef, oTable) {if (__UCF_COVERAGE__) { UCF_SapTableSelectionCell["_"]["UCF_SapTableSelectionCell"]++; }; 
	UCF_SapTableBaseCell["apply"](this, arguments);
	if (window["UCF_System"]["bIsAria"]) {
		var oNode = UCF_DomUtil["oGetFirstChildByAttribute"](this["oDomRef"], "role", "button");
		if (oNode)
			oNode["setAttribute"]("aria-label",
				this["oLS"]["sGetText"]("SAPUR_ST_SC", [this["oCellInfo"]["iRowIndex"]]));
	}

};window["UCF_SapTableSelectionCell"] = UCF_SapTableSelectionCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SapTableSelectionCell"); UCF_SapTableSelectionCell["_"] = {UCF_SapTableSelectionCell: 0}; }; ;
UCF_SapTableSelectionCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SapTableBaseCell"))(); UCF_SapTableSelectionCell.prototype["sClassName"] = "UCF_SapTableSelectionCell";

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableSelectionCell["prototype"]["setCellState"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableSelectionCell["_"]["setCellState"]++; }; 
	if (!this["bEnabled"]) this["oAccessibilityHelper"]["setEnabled"](false);

	if (this["sCellType"] == "ROWCREATOR") {
		this["oAccessibilityHelper"]["setControlType"]("ST_RC", [this["sGetRowInfo"]()]);
	} else {
		this["oAccessibilityHelper"]["setControlType"]("ST_SC", [this["sGetRowInfo"]()]);
	}

	if (this["sTooltip"] != "") {
		this["oAccessibilityHelper"]["setTooltip"](this["sTooltip"]);
	}

};;if (__UCF_COVERAGE__) { UCF_SapTableSelectionCell["_"]["setCellState"] = 0; };

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableSelectionCell["prototype"]["sGetTutorInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableSelectionCell["_"]["sGetTutorInfo"]++; }; 
	if (this["oAccessInfo"]["eAction"] == this["oTable"]["ACTION"]["CELL_SELECT"]) {
		if (this["bIsSelected"] || this["bIsSecondarySelected"]) {
			if (this["bIsDeselectable"]) {
				return "ST_SC_S_TUT";
			}
		} else {
			if (this["sCellType"] == "ROWCREATOR") {
				return "ST_RC_TUT";
			} else {
				return "ST_SC_N_TUT";
			}
		}
	}
	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableSelectionCell["_"]["sGetTutorInfo"] = 0; };

/**
 * @see UCF_SapTableBaseCell
 * @override
 * @private
 */
UCF_SapTableSelectionCell["prototype"]["sGetColumnInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableSelectionCell["_"]["sGetColumnInfo"]++; }; 
	return "";
};;if (__UCF_COVERAGE__) { UCF_SapTableSelectionCell["_"]["sGetColumnInfo"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SapTableSelectionCell["prototype"]["aAttributeNames"] = ["bIsSelected","bIsSecondarySelected","bEnabled","sCellType","sRowDescription","bIsDeselectable","sTooltip","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SapTableSelectionCell["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SapTableSelectionCell["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableSelectionCell["prototype"]["bIsSelected"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableSelectionCell["prototype"]["bIsSecondarySelected"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableSelectionCell["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellType}
 */
UCF_SapTableSelectionCell["prototype"]["sCellType"] = "TEXT";

/**
 * @private
 * @type {string}
 */
UCF_SapTableSelectionCell["prototype"]["sRowDescription"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_SapTableSelectionCell["prototype"]["bIsDeselectable"] = true;

/**
 * @private
 * @type {string}
 */
UCF_SapTableSelectionCell["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SapTableSelectionCell["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_SapTableSelectionCell["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SapTableSelectionCell["_"]["setDefaultValues"]++; }; 
	this["bIsSelected"] = false;
	this["bIsSecondarySelected"] = false;
	this["bEnabled"] = true;
	this["sCellType"] = "TEXT";
	this["sRowDescription"] = '';
	this["bIsDeselectable"] = true;
	this["sTooltip"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("IsSelected", false, true);
		this["setClientProperty"]("IsSecondarySelected", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("CellType", "TEXT", true);
		this["setClientProperty"]("RowDescription", '', true);
		this["setClientProperty"]("IsDeselectable", true, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SapTableSelectionCell["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ScrollBase"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
// #region typedefs ###########################################################
// #region UCF_ScrollBase_Notification ========================================
/** @typedef {0} UCF_ScrollBase_NeverNotification */
/** @typedef {1} UCF_ScrollBase_AutoNotification */
/** @typedef {2} UCF_ScrollBase_AlwaysNotification */
/** @typedef {3} UCF_ScrollBase_AlwaysWhenChangedNotification */
/** @typedef {UCF_ScrollBase_NeverNotification|UCF_ScrollBase_AutoNotification|UCF_ScrollBase_AlwaysNotification|UCF_ScrollBase_AlwaysWhenChangedNotification} UCF_ScrollBase_Notification */
/**
 * @typedef {Object} UCF_ScrollBase_NotificationEnum
 * @property {UCF_ScrollBase_NeverNotification} NEVER
 * @property {UCF_ScrollBase_AutoNotification} AUTO
 * @property {UCF_ScrollBase_AlwaysNotification} ALWAYS
 * @property {UCF_ScrollBase_AlwaysWhenChangedNotification} ALWAYS_WHEN_CHANGED
 */
// #endregion
// #region UCF_ScrollBase_Action ==============================================
/** @typedef {"NONE"} UCF_ScrollBase_NoneAction */
/** @typedef {"PREVIOUS"} UCF_ScrollBase_PreviousAction */
/** @typedef {"NEXT"} UCF_ScrollBase_NextAction */
/** @typedef {"BEGIN"} UCF_ScrollBase_BeginAction */
/** @typedef {"END"} UCF_ScrollBase_EndAction */
/** @typedef {"NEXT_PAGE"} UCF_ScrollBase_NextPageAction */
/** @typedef {"PREVIOUS_PAGE"} UCF_ScrollBase_PreviousPageAction */
/** @typedef {"DIRECT"} UCF_ScrollBase_DirectAction */
/** @typedef {UCF_ScrollBase_NoneAction|UCF_ScrollBase_PreviousAction|UCF_ScrollBase_NextAction|UCF_ScrollBase_BeginAction|UCF_ScrollBase_EndAction|UCF_ScrollBase_NextPageAction|UCF_ScrollBase_PreviousPageAction|UCF_ScrollBase_DirectAction} UCF_ScrollBase_Action */
/**
 * @typedef {Object} UCF_ScrollBase_ActionEnum
 * @property {UCF_ScrollBase_NoneAction} NONE
 * @property {UCF_ScrollBase_PreviousAction} PREVIOUS
 * @property {UCF_ScrollBase_NextAction} NEXT
 * @property {UCF_ScrollBase_BeginAction} BEGIN
 * @property {UCF_ScrollBase_EndAction} END
 * @property {UCF_ScrollBase_NextPageAction} NEXT_PAGE
 * @property {UCF_ScrollBase_PreviousPageAction} PREVIOUS_PAGE
 * @property {UCF_ScrollBase_DirectAction} DIRECT
 */
// #endregion
// #region UCF_ScrollBase_AccessSource ========================================
/** @typedef {"EXTERNAL"} UCF_ScrollBase_ExternalAccessSource */
/** @typedef {"SCROLLBAR"} UCF_ScrollBase_ScrollbarAccessSource */
/** @typedef {"PAGER"} UCF_ScrollBase_PagerAccessSource */
/** @typedef {UCF_ScrollBase_ExternalAccessSource|UCF_ScrollBase_ScrollbarAccessSource|UCF_ScrollBase_PagerAccessSource} UCF_ScrollBase_AccessSource */
/**
 * @typedef {Object} UCF_ScrollBase_AccessSourceEnum
 * @property {UCF_ScrollBase_ExternalAccessSource} EXTERNAL
 * @property {UCF_ScrollBase_ScrollbarAccessSource} SCROLLBAR
 * @property {UCF_ScrollBase_PagerAccessSource} PAGER
 */
// #endregion
// #region UCF_ScrollBase_AccessType ==========================================
/** @typedef {0} UCF_ScrollBase_NoneAccessType */
/** @typedef {1} UCF_ScrollBase_MouseAccessType */
/** @typedef {2} UCF_ScrollBase_KeyboardAccessType */
/** @typedef {3} UCF_ScrollBase_RepetitionAccessType */
/** @typedef {4} UCF_ScrollBase_RepetitionEndAccessType */
/** @typedef {5} UCF_ScrollBase_ExternalAccessType */
/** @typedef {6} UCF_ScrollBase_MouseWheelAccessType */
/** @typedef {7} UCF_ScrollBase_MouseWheelEndAccessType */
/** @typedef {8} UCF_ScrollBase_MouseWheelCancelAccessType */
/** @typedef {9} UCF_ScrollBase_DragStartAccessType */
/** @typedef {10} UCF_ScrollBase_DragAccessType */
/** @typedef {11} UCF_ScrollBase_DragEndAccessType */
/** @typedef {12} UCF_ScrollBase_TouchStartAccessType */
/** @typedef {13} UCF_ScrollBase_TouchMoveAccessType */
/** @typedef {14} UCF_ScrollBase_TouchEndAccessType */
/** @typedef {UCF_ScrollBase_NoneAccessType|UCF_ScrollBase_MouseAccessType|UCF_ScrollBase_KeyboardAccessType|UCF_ScrollBase_RepetitionAccessType|UCF_ScrollBase_RepetitionEndAccessType|UCF_ScrollBase_ExternalAccessType|UCF_ScrollBase_MouseWheelAccessType|UCF_ScrollBase_MouseWheelEndAccessType|UCF_ScrollBase_MouseWheelCancelAccessType|UCF_ScrollBase_DragStartAccessType|UCF_ScrollBase_DragAccessType|UCF_ScrollBase_DragEndAccessType|UCF_ScrollBase_TouchStartAccessType|UCF_ScrollBase_TouchMoveAccessType|UCF_ScrollBase_TouchEndAccessType} UCF_ScrollBase_AccessType */
/**
 * @typedef {Object} UCF_ScrollBase_AccessTypeEnum
 * @property {UCF_ScrollBase_NoneAccessType} NONE
 * @property {UCF_ScrollBase_MouseAccessType} MOUSE
 * @property {UCF_ScrollBase_KeyboardAccessType} KEYBOARD
 * @property {UCF_ScrollBase_RepetitionAccessType} REPETITION
 * @property {UCF_ScrollBase_RepetitionEndAccessType} REPETITION_END
 * @property {UCF_ScrollBase_ExternalAccessType} EXTERNAL
 * @property {UCF_ScrollBase_MouseWheelAccessType} MOUSE_WHEEL
 * @property {UCF_ScrollBase_MouseWheelEndAccessType} MOUSE_WHEEL_END
 * @property {UCF_ScrollBase_MouseWheelCancelAccessType} MOUSE_WHEEL_CANCEL
 * @property {UCF_ScrollBase_DragStartAccessType} DRAG_START
 * @property {UCF_ScrollBase_DragAccessType} DRAG
 * @property {UCF_ScrollBase_DragEndAccessType} DRAG_END
 * @property {UCF_ScrollBase_TouchStartAccessType} TOUCH_START
 * @property {UCF_ScrollBase_TouchMoveAccessType} TOUCH_MOVE
 * @property {UCF_ScrollBase_TouchEndAccessType} TOUCH_END
 */
// #endregion
// #endregion

/**
 * ScrollBase
 *
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ScrollBase(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["UCF_ScrollBase"]++; }; 

	if (arguments["length"] == 0) return;

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["defineEvents"](['Scroll']);

	// eslint-disable-next-line @ur/no-memory-leaks
	this["mNotificationMode"] = this["NOTIFICATION"]["AUTO"];
	//event info for internal events
	this["oInternalEventInfo"] = null;

};window["UCF_ScrollBase"] = UCF_ScrollBase; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ScrollBase"); UCF_ScrollBase["_"] = {UCF_ScrollBase: 0}; }; ;
UCF_ScrollBase["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ScrollBase.prototype["sClassName"] = "UCF_ScrollBase";

/**
 * Destructor
 */
UCF_ScrollBase["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["destroy"]++; }; 
	this["mNotificationMode"] = this["NOTIFICATION"]["AUTO"];
	this["oInternalEventInfo"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["destroy"] = 0; };

/******************************************************
 ** CONSTANTS
 *******************************************************/

/** @type {UCF_ScrollBase_NotificationEnum} Points in time of notification */
UCF_ScrollBase["prototype"]["NOTIFICATION"] = {
	"NEVER": 0,
	"AUTO": 1,
	"ALWAYS": 2,
	"ALWAYS_WHEN_CHANGED": 3
};

/** @type {UCF_ScrollBase_Action} */
UCF_ScrollBase["prototype"]["ACTION"] = {
	"NONE": "NONE",
	"PREVIOUS": "PREVIOUS",
	"NEXT": "NEXT",
	"BEGIN": "BEGIN",
	"END": "END",
	"NEXT_PAGE": "NEXT_PAGE",
	"PREVIOUS_PAGE": "PREVIOUS_PAGE",
	"DIRECT": "DIRECT"
};

/** @type {UCF_ScrollBase_AccessSourceEnum} Access source */
UCF_ScrollBase["prototype"]["ACCESS_SOURCE"] = {
	"EXTERNAL": "EXTERNAL",
	"SCROLLBAR": "SCROLLBAR",
	"PAGER": "PAGER"
};

/**
 * Access types
 */
UCF_ScrollBase["prototype"]["ACCESS_TYPE"] = {
	"NONE": 0,
	"MOUSE": 1,
	"KEYBOARD": 2,
	"REPETITION": 3,
	"REPETITION_END": 4,
	"EXTERNAL": 5,
	"MOUSE_WHEEL": 6,
	"MOUSE_WHEEL_END": 7,
	"MOUSE_WHEEL_CANCEL": 8,

	//Scrollbar specific
	"DRAG_START": 9,
	"DRAG": 10,
	"DRAG_END": 11,

	//TOUCH device
	"TOUCH_START": 12,
	"TOUCH_MOVE": 13,
	"TOUCH_END": 14
};

/******************************************************
 ** EVENT HANDLER
 *******************************************************/

/**
 * Event handler
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_ScrollBase["prototype"]["onlsmousewheel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["onlsmousewheel"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "ScrollBase.js(194): onlsmousewheel"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oBrowserEvent) == "object", "typeof(oBrowserEvent) == \"object\"", "ScrollBase.js(195): onlsmousewheel"); };

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["onlsmousewheel"] = 0; };

/******************************************************
 ** API
 *******************************************************/

/**
 * Scroll to previous item
 * 
 * @param {int} mModifier
 */
UCF_ScrollBase["prototype"]["scrollToPrevious"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToPrevious"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToPrevious"] = 0; };

/**
 * Scroll to next item
 * 
 * @param {int} mModifier
 */
UCF_ScrollBase["prototype"]["scrollToNext"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToNext"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToNext"] = 0; };

/**
 * Scroll to previous page
 * 
 * @param {int} mModifier
 */
UCF_ScrollBase["prototype"]["scrollToPreviousPage"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToPreviousPage"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToPreviousPage"] = 0; };

/**
 * Scroll to next page
 * 
 * @param {int} mModifier
 */
UCF_ScrollBase["prototype"]["scrollToNextPage"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToNextPage"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToNextPage"] = 0; };

/**
 * Scroll to begin
 * 
 * @param {int} mModifier
 */
UCF_ScrollBase["prototype"]["scrollToBegin"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToBegin"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToBegin"] = 0; };

/**
 * Scroll to end
 * 
 * @param {int} mModifier
 */
UCF_ScrollBase["prototype"]["scrollToEnd"] = function(mModifier) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToEnd"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToEnd"] = 0; };

/*
 * Returns true if the user is still interacting with scrollbar
 */
UCF_ScrollBase["prototype"]["bIsInInteraction"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["bIsInInteraction"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["bIsInInteraction"] = 0; };

/*
 * Cancels the current user interaction with the scrollbar
 */
UCF_ScrollBase["prototype"]["cancelInteraction"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["cancelInteraction"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["cancelInteraction"] = 0; };

/*
 * Stops the current user interaction with the scrollbar
 */
UCF_ScrollBase["prototype"]["stopInteraction"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["stopInteraction"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["stopInteraction"] = 0; };

/*
 * Returns true if the scrollbar reached the end position
 */
UCF_ScrollBase["prototype"]["bEndPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["bEndPosition"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["bEndPosition"] = 0; };

/*
 * Returns true if the scrollbar is in start position
 */
UCF_ScrollBase["prototype"]["bStartPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["bStartPosition"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["bStartPosition"] = 0; };

/**
 * Scroll to a specific position
 *
 * @param {int} iPosition
 * @param {int} mModifier
 */
UCF_ScrollBase["prototype"]["scrollToPosition"] = function(iPosition, mModifier) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToPosition"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["scrollToPosition"] = 0; };

/**
 * Sets the notification mode of the scrollbar which controls the event firing
 * NEVER, AUTO, ALWAYS
 * @param {int} mNotificationMode
 */
UCF_ScrollBase["prototype"]["setNotifactionMode"] = function(mNotificationMode) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["setNotifactionMode"]++; }; 
	this["mNotificationMode"] = mNotificationMode;
};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["setNotifactionMode"] = 0; };

/**
 * Gets the notification mode of the scrollbar which controls the event firing
 * NEVER, AUTO, ALWAYS
 */
UCF_ScrollBase["prototype"]["mGetNotifactionMode"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["mGetNotifactionMode"]++; }; 
	return this["mNotificationMode"];
};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["mGetNotifactionMode"] = 0; };

UCF_ScrollBase["prototype"]["setItemCount"] = function(iItemCount) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["setItemCount"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["setItemCount"] = 0; };

UCF_ScrollBase["prototype"]["setVisibleItemCount"] = function(iVisibleItemCount) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["setVisibleItemCount"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["setVisibleItemCount"] = 0; };

UCF_ScrollBase["prototype"]["setFirstVisibleItem"] = function(iFirstVisibleItem, bSkipUpdateUI) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["setFirstVisibleItem"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["setFirstVisibleItem"] = 0; };

UCF_ScrollBase["prototype"]["iGetFirstVisibleItem"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["iGetFirstVisibleItem"]++; }; 
	return -1;
};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["iGetFirstVisibleItem"] = 0; };

UCF_ScrollBase["prototype"]["bIsScrolledIntoView"] = function(iItemIndex) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["bIsScrolledIntoView"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["bIsScrolledIntoView"] = 0; };

UCF_ScrollBase["prototype"]["setInternalEventInfo"] = function(oInfo) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["setInternalEventInfo"]++; }; 
	this["oInternalEventInfo"] = oInfo;
};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["setInternalEventInfo"] = 0; };

UCF_ScrollBase["prototype"]["oGetInternalEventInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["oGetInternalEventInfo"]++; }; 
	return this["oInternalEventInfo"];
};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["oGetInternalEventInfo"] = 0; };

UCF_ScrollBase["prototype"]["fireInternalScrollEvent"] = function(iFirstVisibleItem, eAction, eAccessSource, eAccessType, mModifier) {;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["fireInternalScrollEvent"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Scroll"], {
		"iFirstVisibleItem": iFirstVisibleItem,
		"eAction": eAction,
		"eAccessSource": eAccessSource,
		"eAccessType": eAccessType,
		"bShift": (mModifier & UCF_JsUtil["MODIFIER"]["SHIFT"] ? true : false),
		"bCtrl": (mModifier & UCF_JsUtil["MODIFIER"]["CTRL"] ? true : false),
		"bAlt": (mModifier & UCF_JsUtil["MODIFIER"]["ALT"] ? true : false),
		"oInternalEventInfo": this["oGetInternalEventInfo"]()
	});
};;if (__UCF_COVERAGE__) { UCF_ScrollBase["_"]["fireInternalScrollEvent"] = 0; };

};
sap["ls"]["preload"]["UCF_ScrollContainer"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ScrollContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["UCF_ScrollContainer"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "ScrollContainer.js(25): UCF_ScrollContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ScrollContainer.js(26): UCF_ScrollContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ScrollContainer.js(27): UCF_ScrollContainer"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oScrollArea"] = this["sScrollingMode"] != "NONE"
		? UCF_ClassLoader["oGetClass"]("UCF_ScrollArea")["oCreateAndConnectScrollArea"](this, this["sScrollingMode"], "onScroll")
		: null;

	if (this["oScrollArea"]) { //Needed to reset timed event call of ScrollArea
		this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "onLsLock");
	}

	//initialize the default button for this control
	this["setDefaultButtonId"](this["sDefaultButtonId"]);
};window["UCF_ScrollContainer"] = UCF_ScrollContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ScrollContainer"); UCF_ScrollContainer["_"] = {UCF_ScrollContainer: 0}; }; ;

UCF_ScrollContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ScrollContainer.prototype["sClassName"] = "UCF_ScrollContainer";

/**
 * Sets the scroll position programmatically
 * The parameters iScrollLeft, iScrollTop are defined in the API of the ScrollContainer control.
 *
 * @private
 */
UCF_ScrollContainer["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["initialize"]++; }; 
	if (this["oScrollArea"]) {
		this["oScrollArea"]["setScrollPosition"](this["iScrollTop"], this["iScrollLeft"]);
	}
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["initialize"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ScrollContainer["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onlsskipforward"]++; }; 

	// See note 2059181. Skipping with F6 should only possible for
	// "TransparentContainers" which are not simple layout containers. In this
	// case the TC is announced as Group with tutor "to skip press F6". This
	// change may lead that F6 behaves differently in an application as before
	// every TC acts as skipping container. In this case the application must be
	// changed - minimal change is to set isLayoutContainer=false and to provide
	// a meaningful AccessibilityDescription. To get a good interaction design
	// with keyboard the application should change more in most cases.
	if (this["bIsLayout"]) return;

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ScrollContainer["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onlsskipback"]++; }; 

	// See note 2059181. Skipping with F6 should only possible for
	//  "TransparentContainers" which are not simple layout containers. In this
	//  case the TC is announced as Group with tutor "to skip press F6". This
	//  change may lead that F6 behaves differently in an application as before
	//  every TC acts as skipping container. In this case the application must be
	//  changed - minimal change is to set isLayoutContainer=false and to provide
	//  a meaningful AccessibilityDescription. To get a good interaction design
	//  with keyboard the application should change more in most cases
	if (this["bIsLayout"]) return;

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onlsskipback"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_ScrollContainer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["destroy"]++; }; 
	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;

		this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "onLsLock");
	}

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["destroy"] = 0; };

/**
 * Fires the scroll event
 *
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_ScrollContainer["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onScroll"]++; }; 
	var iScrollTop = oEvent["oGetParam"]("iScrollTop"),
		iScrollLeft = oEvent["oGetParam"]("iScrollLeft");
	this["fireScroll"](this["sId"], iScrollTop, iScrollLeft);
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onScroll"] = 0; };

/**
 * Is fired when LS locks UI
 *
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_ScrollContainer["prototype"]["onLsLock"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onLsLock"]++; }; 
	if (this["oScrollArea"]) {
		// When UI is locked the ScrollArea could send scroll events by its time out processing
		// this would lead enqued events and lead to server WD ABAP errors when the ScrollContainer is not again nested in the page
		// -> when locked then cleanup timing
		this["oScrollArea"]["cleanUpScrollTiming"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onLsLock"] = 0; };

/**
 * Handle hotkey events
 *
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_ScrollContainer["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onlshotkey"]++; }; 

	if (this["sHotkeysId"] == '') return;

	var oHotkeys = this["oGetControlById"](this["sHotkeysId"]),
		oHotkey = null;
	if (oHotkeys == null) return;

	oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onlshotkey"] = 0; };

/**
 * Handle keypress events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ScrollContainer["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]("UCF_Hotkeys")["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onkeypress"] = 0; };

/**
 * Set scroll position
 *
 * @public
 *
 * @param {int} iScrollTop
 * @param {int} iScrollLeft
 */
UCF_ScrollContainer["prototype"]["setScrollPosition"] = function(iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["setScrollPosition"]++; }; 

	if (this["oScrollArea"]) {
		this["oScrollArea"]["setScrollPosition"](iScrollTop, iScrollLeft);
	}
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["setScrollPosition"] = 0; };

/**
 * Returns the scroll position of the ScrollArea
 *
 * @return {Object}
 * @public
 */
UCF_ScrollContainer["prototype"]["getScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["getScrollPosition"]++; }; 
	if (this["oScrollArea"]) return this["oScrollArea"]["oGetScrollPosition"]();

	return null;
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["getScrollPosition"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ScrollContainer["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ScrollContainer.js(217): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() != this) return;
	if (this["bIsLayout"]) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSource = oBrowserEvent["oGetSource"]();

	if (oSource["getAttribute"]("Id") == this["sId"] + "-end") {
		oAccessibilityHelper["setControlType"]("G_END");
	} else {
		//Apply label and accDescription
		oAccessibilityHelper["applyLabelingInfo"](this, this["sAccessibilityDescription"]);

		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		oAccessibilityHelper["setControlType"]("G");
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["onlsaccessibility"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 * @public
 */
UCF_ScrollContainer["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["setDefaultButtonId"]++; }; 
	UCF_Control.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["setDefaultButtonId"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ScrollContainer["prototype"]["aAttributeNames"] = ["sScrollingMode","sVisibility","sAccessibilityDescription","bIsLayout","sDefaultButtonId","sTooltip","iScrollTop","iScrollLeft","sHotkeysId","sCustomData","sCustomStyle","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ScrollContainer["prototype"]["aEventNames"] = ["Scroll","Hotkey"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ScrollContainer["prototype"]["aMethodNames"] = ["setScrollPosition","getScrollPosition","setDefaultButtonId","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ScrollingMode}
 */
UCF_ScrollContainer["prototype"]["sScrollingMode"] = "AUTO";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ScrollContainer["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ScrollContainer["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_ScrollContainer["prototype"]["bIsLayout"] = true;

/**
 * @private
 * @type {string}
 */
UCF_ScrollContainer["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ScrollContainer["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {number}
 */
UCF_ScrollContainer["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_ScrollContainer["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_ScrollContainer["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ScrollContainer["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ScrollContainer["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ScrollContainer["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ScrollContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["setDefaultValues"]++; }; 
	this["sScrollingMode"] = "AUTO";
	this["sVisibility"] = "VISIBLE";
	this["sAccessibilityDescription"] = '';
	this["bIsLayout"] = true;
	this["sDefaultButtonId"] = '';
	this["sTooltip"] = '';
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["sHotkeysId"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("ScrollingMode", "AUTO", true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("IsLayout", true, true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires ScrollContainer::Scroll
 */
UCF_ScrollContainer["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "ScrollContainer.js(385): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ScrollContainer.js(386): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ScrollContainer.js(387): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "ScrollContainer.js(388): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "ScrollContainer.js(389): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "ScrollContainer.js(390): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "ScrollContainer.js(391): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("ScrollContainer", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires ScrollContainer::Hotkey
 */
UCF_ScrollContainer["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "ScrollContainer.js(416): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ScrollContainer.js(417): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ScrollContainer.js(418): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "ScrollContainer.js(419): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "ScrollContainer.js(420): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "ScrollContainer.js(421): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "ScrollContainer.js(422): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	
	if (sProviderId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sProviderId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ProviderId");
			}
		}
	this["fireSemanticEvent"]("ScrollContainer", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ScrollContainer["_"]["fireHotkey"] = 0; };

UCF_ScrollContainer.prototype["aPublicMethods"] = ["setScrollPosition","getScrollPosition","setDefaultButtonId"].concat(UCF_ScrollContainer.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Scrollbar"] = function() {/* global _assert, _trace, DEBUG, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_ScrollBase */
/// <reference path="./base/ScrollBase.js"/>

/**
 * @class
 * A  Scrollbar
 *
 * <br>
 * <b>Java Control references</b><br>
 * <a href="../javadoc/com/sap/tc/ls/api/controls/LSScrollbar.html">LSScrollbar</a>
 *
 * 
 *
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Scrollbar(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["UCF_Scrollbar"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) == "object", "typeof (oDomRef) == \"object\"", "Scrollbar.js(42): UCF_Scrollbar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Scrollbar.js(43): UCF_Scrollbar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Scrollbar.js(44): UCF_Scrollbar"); };

	UCF_Control["apply"](this, [oDomRef, oLS]); // Why not UCF_ScrollBase?

	this["defineEvents"](['Scroll', 'ClientUpdateResize', 'DragRemain']);

	this["bIsVertical"] = this["sScrollDirection"] == "VERTICAL";
	this["bOptimizedPixelDirectMode"] = false;

	this["initProperties"]();

	this["mNotificationMode"] = this["NOTIFICATION"]["AUTO"];

	this["oDomRefHandle"] = UCF_DomUtil["$"](this["sId"] + "-" + this["FRAGMENT"]["HANDLE"]);
	this["oDomRefSpacer"] = UCF_DomUtil["$"](this["sId"] + "-" + this["FRAGMENT"]["SPACER"]);
	this["oDomRefBar"] = UCF_DomUtil["$"](this["sId"] + "-" + this["FRAGMENT"]["BAR"]);

	this["iPxItemSize"] = parseInt(this["oDomRefSpacer"]["getAttribute"]("iPxItemSize"), 10);
	this["iPxItemSpanCorrection"] = parseInt(this["oDomRefSpacer"]["getAttribute"]("iPxItemSpanCorrection"), 10);

	this["iPxDragReference"] = -1;
	this["iPxDragPositionReference"] = -1;
	this["iDragFirstVisbleItemReference"] = -1;
	this["iMouseWheelFirstVisbleItemReference"] = -1;

	this["oDomRefCurrentPressedButton"] = null;

	this["iScrollRepetitionIncrement"] = 0;
	this["iScrollRepetitionProcessId"] = 0;
	this["iScrollRepetitionReferencePos"] = -1;

	this["oScrolledElement"] = null;

	this["bAttachToScrolledElement"] = false;
	this["bAttachedClientUpdateResize"] = false;

	this["eLastAccessType"] = this["ACCESS_TYPE"]["NONE"];

	this["iWheelTicksInMassProcessing"] = 0;
	this["iWheelDirection"] = 0;

	this["initTouchSupport"]();
	this["initDragRemain"]();
};window["UCF_Scrollbar"] = UCF_Scrollbar; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Scrollbar"); UCF_Scrollbar["_"] = {UCF_Scrollbar: 0}; }; ;
UCF_Scrollbar["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollBase"))(); UCF_Scrollbar.prototype["sClassName"] = "UCF_Scrollbar";

UCF_Scrollbar["prototype"]["HANDLE_MIN_SIZE"] = 8;
UCF_Scrollbar["prototype"]["HANDLE_GRIP_TRESHOLD"] = 20;

/**
 * Initialize when appears on screen
 * @private
 */
UCF_Scrollbar["prototype"]["initialize"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["initialize"]++; }; 

	if (UCF_DomUtil["bCheckStandardsCorrection"]() && this["bIsVertical"]) {
		UCF_DomUtil["initHtmlTableCorrection"](UCF_DomUtil["firstChild"](this["oDomRef"], "TABLE"));
	}

	if (this["iMinimum"] == -1 && this["iMaximum"] == -1) {
		this["paintBar"](-1);
		this["attachResize"]();
	}

	// ResizeEventHelper with new "Observer" does no longer fire when
	// PopupWindow sets its size during initialize. Plus, unluckily in WDA
	// it may happen that the Scrollbar inside a Popup is initialized
	// BEFORE the Popup... this is also the reason why this.oGetParentPopupWindow()
	// will not work/return a instance at this point in time.
	var oPopupWindowDomRef = UCF_DomUtil["oGetParentByAttribute"](this["oDomRef"] || this["oRootRef"],	'ct',	'PW')
		|| UCF_DomUtil["oGetParentByAttribute"](this["oDomRef"] || this["oRootRef"], 'ct',	'PW_standards');
	if (oPopupWindowDomRef) {
		var _this = this;
		setTimeout(function() {
			_this["onClientUpdateResize"]();
		}, 100);
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["initialize"] = 0; };

/**
 * Init
 * @private
 */
UCF_Scrollbar["prototype"]["initProperties"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["initProperties"]++; }; 
	var iScrollRange = 0,
		iScrollClipping = 0,
		iScrollPos = 0;

	if (this["iLargeChange"] == -100) {
		//Optimize Mode 100
		//LargeChange = -100 is the indicator for an optimized initial update mode.
		//When the scrollbar is in pixel mode usually the connected control takes care of calculating the range clipping etc.
		//so the connected control has to be initialized and calls updateDimensions of the scrollbar.
		//There is a contract with the ScrolledElement (connected control) when using mode 100
		//The root DOM reference of the connected control has to define attributtes which specifies needed information
		//  sScrollContentId = the id to the content of the scroll area
		//  iScrollContentDimCorrection = an integer which is used to adapt the dimension to the connected control needs
		//In mode 100 the expansion of the clipping area is the expansion of the scrollbar itself.
		//So the connected control hasn't to be initialized and only the scrollbar takes care of its visualization.

		var oDomRefScrolledElement = UCF_DomUtil["$"](this["sScrolledElementId"]),
			oDomRefScrollContent = UCF_DomUtil["$"](oDomRefScrolledElement["getAttribute"](this["bIsVertical"] ? "sVScrollContentId" : "sHScrollContentId"));
		if (!oDomRefScrollContent) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "oDomRefScrollContent not defined", "Scrollbar.js(147): initProperties"); };
			return;
		}

		var iDimensionCorrection = parseInt(oDomRefScrolledElement["getAttribute"](this["bIsVertical"] ? "iVScrollContentDimCorrection" : "iHScrollContentDimCorrection"), 10);
		iScrollRange = (this["bIsVertical"] ? oDomRefScrollContent["offsetHeight"] : oDomRefScrollContent["offsetWidth"]) + iDimensionCorrection;
		iScrollClipping = this["bIsVertical"] ? this["oDomRef"]["offsetHeight"] : this["oDomRef"]["offsetWidth"];
		iScrollPos = this["iValue"];

		this["iMinimum"] = -1;
		this["iMaximum"] = -1;
		this["setClientProperty"]("Minimum", this["iMinimum"], true);
		this["setClientProperty"]("Maximum", this["iMaximum"], true);

		this["bOptimizedPixelDirectMode"] = true;
	}

	if (this["iMinimum"] == -1 && this["iMaximum"] == -1) {
		this["bPixelDirectMode"] = true;
		this["bShowScrollTip"] = false;
		this["setClientProperty"]("ShowScrollTip", this["bShowScrollTip"], true);
	} else {
		this["bPixelDirectMode"] = false;

		iScrollRange = this["iMaximum"] + this["iLargeChange"] - 1;
		iScrollClipping = this["iLargeChange"];
		iScrollPos = this["iValue"];
	}

	this["updateProperties"](iScrollRange, iScrollClipping, iScrollPos);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["initProperties"] = 0; };

/**
 * This method receives the scrollrange, the clipping area and the scrollposition and updates according to those
 * all related parameters
 *
 * @param {number} iScrollRange
 * @param {number} iScrollClipping
 * @param {number} iScrollPos
 * @private
 */
UCF_Scrollbar["prototype"]["updateProperties"] = function (iScrollRange, iScrollClipping, iScrollPos) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["updateProperties"]++; }; 
	var iLargeChange, iSmallChange;

	if (this["bPixelDirectMode"]) {
		iLargeChange = Math["round"](iScrollClipping * 7 / 8);
		iSmallChange = Math["round"](iScrollClipping / 8);
	} else {
		iLargeChange = iScrollClipping;
		iSmallChange = 1;
	}

	this["iScrollRange"] = iScrollRange;
	this["iScrollPos"] = iScrollPos;
	this["iScrollClipping"] = iScrollClipping;
	this["iLargeChange"] = iLargeChange;
	this["iSmallChange"] = iSmallChange;
	this["setClientProperty"]("LargeChange", this["iLargeChange"], true);
	this["setClientProperty"]("SmallChange", this["iSmallChange"], true);

};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["updateProperties"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_Scrollbar["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["destroy"]++; }; 

	UCF_JsUtil["resetMassNotificationFilter"](this);
	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	this["detachResize"]();
	this["hideScrollTip"]();
	this["cleanUpDragRemain"]();
	this["cleanUpTouchSupport"]();

	this["bIsVertical"] = false;
	this["bPixelDirectMode"] = false;
	this["eLastAccessType"] = null;
	this["fDurationFactor"] = null;
	this["fVelocityFactor"] = null;
	this["iDragFirstVisbleItemReference"] = 0;
	this["iItemCount"] = 0;
	this["iLargeChange"] = 0;
	this["iMaximum"] = 0;
	this["iMinimum"] = 0;
	this["iMouseWheelFirstVisbleItemReference"] = 0;
	this["iPxDragPositionReference"] = 0;
	this["iPxDragReference"] = 0;
	this["iPxItemSize"] = 0;
	this["iPxItemSpanCorrection"] = 0;
	this["iRemainLatency"] = 0;
	this["iScrollClipping"] = 0;
	this["iScrollPos"] = 0;
	this["iScrollRange"] = 0;
	this["iScrollRepetitionIncrement"] = 0;
	this["iScrollRepetitionReferencePos"] = 0;
	this["iSmallChange"] = 0;
	this["iWheelDirection"] = 0;
	this["iWheelTicksInMassProcessing"] = 0;
	this["mNotificationMode"] = null;
	this["oDomRefBar"] = null;
	this["oDomRefCurrentPressedButton"] = null;
	this["oDomRefHandle"] = null;
	this["oDomRefSpacer"] = null;
	this["oScrolledElement"] = null;
	this["sDragRemainTimer"] = null;

	UCF_ScrollBase.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["destroy"] = 0; };

/******************************************************
 ** CONSTANTS
 *******************************************************/

/**
 * Actions code abbreviations
 */
UCF_Scrollbar["prototype"]["ACTION_TO_CODE"] = {
	"NONE": "",
	"PREVIOUS": "Prev",
	"NEXT": "Nxt",
	"BEGIN": "Bgn",
	"END": "End",
	"PREVIOUS_PAGE": "PPrev",
	"NEXT_PAGE": "PNext",
	"HANDLE_MOVE": "Hndl",
	"POSITION": "Pos"
};

/**
 * Action parameter map
 */
UCF_Scrollbar["prototype"]["CODE_TO_ACTION"] = {
	"": "NONE",
	"Prev": "PREVIOUS",
	"Nxt": "NEXT",
	"Bgn": "BEGIN",
	"End": "END",
	"PNext": "NEXT_PAGE",
	"PPrev": "PREVIOUS_PAGE",
	"Hndl": "DIRECT",
	"Pos": "DIRECT",
	"DIRECT": "DIRECT"
};

/**
 * Used suffices
 */
UCF_Scrollbar["prototype"]["FRAGMENT"] = {
	"NONE": "",
	"HANDLE": "hdl",
	"SPACER": "spc",
	"BAR": "bar",
	"SCROLLTIPS": "sct"
};

/**
 * Buttons
 */
UCF_Scrollbar["prototype"]["BUTTON_TYPE"] = {
	"PREVIOUS": "Prev",
	"NEXT": "Nxt",
	"BEGIN": "Bgn",
	"END": "End"
};

/**
 * Repition states
 */
UCF_Scrollbar["prototype"]["SCROLL_REPETITION_STATE"] = {
	"NONE": 0,
	"STARTED": 1,
	"KEYBOARD": 2,
	"DRAG_START": 3,
	"DRAG": 4,
	"DRAG_END": 5,
	"MOUSE_WHEEL": 6,
	"MOUSE_WHEEL_END": 7,
	"REPETITION": 8,
	"REPETITION_END": 9
};

UCF_Scrollbar["prototype"]["SCROLL_REPETITION_LATENCY"] = 1000;
UCF_Scrollbar["prototype"]["SCROLL_REPETITION_DELAY"] = 50;

/******************************************************
 ** EVENT HANDLE_MOVER RAISED BY LS FRAMEWORK
 *******************************************************/

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_Scrollbar["prototype"]["onmousedown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Scrollbar.js(346): onmousedown"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oBrowserEvent) == "object", "typeof (oBrowserEvent) == \"object\"", "Scrollbar.js(347): onmousedown"); };

	if (oBrowserEvent["eGetMouseButtonState"]() != oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"]) return true;

	var oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);

	if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["PREVIOUS"]) {
		this["setPressedButtonUI"](oAccessInfo);
		this["setScrollRepetition"](-this["iSmallChange"]);
	} else if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["NEXT"]) {
		this["setPressedButtonUI"](oAccessInfo);
		this["setScrollRepetition"](this["iSmallChange"]);
	} else if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["BEGIN"]) {
		this["setPressedButtonUI"](oAccessInfo);
	} else if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["END"]) {
		this["setPressedButtonUI"](oAccessInfo);
	} else if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["NEXT_PAGE"] || oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["PREVIOUS_PAGE"]) {
		var oBarRect = this["oGetObjectRect"](this["oDomRefBar"]),
			iPxRelMousePos = this["bIsVertical"] ? oBrowserEvent["iPageY"]() - oBarRect["top"] : oBrowserEvent["iPageX"]() - oBarRect["left"],
			iScrollRepetitionReferencePos = parseInt((iPxRelMousePos / this["iGetOuterSize"]()) * this["iItemCount"], 10);

		this["setScrollRepetition"](
			oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["NEXT_PAGE"] ? this["iLargeChange"] : -this["iLargeChange"],
			iScrollRepetitionReferencePos
		);
	}

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

	return true;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onmousedown"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_Scrollbar["prototype"]["onmouseup"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onmouseup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Scrollbar.js(389): onmouseup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oBrowserEvent) == "object", "typeof (oBrowserEvent) == \"object\"", "Scrollbar.js(390): onmouseup"); };

	if (this["bIsScrollRepetitionInProcess"]() && UCF_UserAgent["bIsGecko"]()) {
		//scroll repetition does only work in Gecko with mouse up 2522618 2012
		this["bHandleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["REPETITION_END"]);
	}

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

	return true;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onmouseup"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_Scrollbar["prototype"]["onclick"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Scrollbar.js(412): onclick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oBrowserEvent) == "object", "typeof (oBrowserEvent) == \"object\"", "Scrollbar.js(413): onclick"); };

	if (this["bIsScrollRepetitionInProcess"]()) {
		this["bHandleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["REPETITION_END"]);
	} else {
		this["bHandleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);
	}

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

	return true;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onclick"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_Scrollbar["prototype"]["onlsmousewheel"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsmousewheel"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Scrollbar.js(436): onlsmousewheel"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oBrowserEvent) == "object", "typeof (oBrowserEvent) == \"object\"", "Scrollbar.js(437): onlsmousewheel"); };

	if (!oBrowserEvent["bAlt"]() && !oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]()
		&& (oBrowserEvent["iWheelDelta"]() < 0 && !this["bEndPosition"]() || oBrowserEvent["iWheelDelta"]() >= 0 && !this["bStartPosition"]())
	) {
		UCF_JsUtil["feedMassNotificationFilter"](UCF_Scrollbar["iGetHandleEventFrameMs"](), this, this, "bHandleEvent", [oBrowserEvent, this["ACCESS_TYPE"]["MOUSE_WHEEL_END"]]);

		return this["bHandleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE_WHEEL"]);
	} else return true;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsmousewheel"] = 0; };

/** @type {number[]} */
UCF_Scrollbar["aLsMousewheelTimestamps"] = [];

/**
 * @private
 * @static
 * @return {number}
 */
UCF_Scrollbar["iGetHandleEventFrameMs"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetHandleEventFrameMs"]++; }; 
	/** @type {number[]} */
	var aDiffs;

	UCF_Scrollbar["aLsMousewheelTimestamps"]["push"](new Date()["getTime"]());
	UCF_Scrollbar["aLsMousewheelTimestamps"] = UCF_Scrollbar["aLsMousewheelTimestamps"]["slice"](-100);

	aDiffs = UCF_JsUtil["reduce"](UCF_Scrollbar["aLsMousewheelTimestamps"], function (aDiffs, iTimestamp, i) {
		/** @type {number} */
		var iTimestampBefore;
		/** @type {number} */
		var iDiff;

		if (i > 0) {
			iTimestampBefore = UCF_Scrollbar["aLsMousewheelTimestamps"][i - 1];
			iDiff = iTimestamp - iTimestampBefore;

			if (iDiff < 100) {
				aDiffs["push"](iDiff);
			}
		}

		return aDiffs;
	}, []);

	return Math["max"](aDiffs["length"] > 0
		? Math["ceil"](2 * UCF_JsUtil["reduce"](aDiffs, function (iSum, iDiff) { return iSum + iDiff; }, 0) / aDiffs["length"])
		: 200, 500);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetHandleEventFrameMs"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_Scrollbar["prototype"]["onlsdragstart"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdragstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Scrollbar.js(495): onlsdragstart"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oBrowserEvent) == "object", "typeof (oBrowserEvent) == \"object\"", "Scrollbar.js(496): onlsdragstart"); };
	return this["bHandleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["DRAG_START"]);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdragstart"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_Scrollbar["prototype"]["onlsdragover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdragover"]++; }; 

	var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"];
	if (oDragSession["eDragType"] == UCF_DragSession["DRAG_TYPE"]["NONE"])
		oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdragover"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @private
 */
UCF_Scrollbar["prototype"]["onlsdragenter"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdragenter"]++; }; 

	var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"];
	if (oDragSession["eDragType"] == UCF_DragSession["DRAG_TYPE"]["NONE"])
		oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdragenter"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @private
 */
UCF_Scrollbar["prototype"]["onlsdrop"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdrop"]++; }; 

	var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"];
	if (oDragSession["eDragType"] == UCF_DragSession["DRAG_TYPE"]["NONE"])
		oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdrop"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_Scrollbar["prototype"]["onlsdrag"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdrag"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Scrollbar.js(550): onlsdrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oBrowserEvent) == "object", "typeof (oBrowserEvent) == \"object\"", "Scrollbar.js(551): onlsdrag"); };
	return this["bHandleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["DRAG"]);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdrag"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_Scrollbar["prototype"]["onlsdragend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdragend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Scrollbar.js(564): onlsdragend"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oBrowserEvent) == "object", "typeof (oBrowserEvent) == \"object\"", "Scrollbar.js(565): onlsdragend"); };
	return this["bHandleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["DRAG_END"]);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlsdragend"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_Scrollbar["prototype"]["onlstouchstart"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlstouchstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Scrollbar.js(578): onlstouchstart"); };

	var oSourceControl = oBrowserEvent["oGetSourceControl"]();

	if (oSourceControl == this) {
		return this["bHandleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);
	} else {
		return this["bHandleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["TOUCH_START"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlstouchstart"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_Scrollbar["prototype"]["onlstouchmove"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlstouchmove"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Scrollbar.js(598): onlstouchmove"); };
	return this["bHandleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["TOUCH_MOVE"]);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlstouchmove"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_Scrollbar["prototype"]["onlstouchend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlstouchend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Scrollbar.js(611): onlstouchend"); };
	return this["bHandleEvent"](oBrowserEvent, this["ACCESS_TYPE"]["TOUCH_END"]);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onlstouchend"] = 0; };

/******************************************************
 ** METHODS WHICH CAN BE CALLED FROM EXTERNAL
 *******************************************************/

/**
 * Scroll to previous item
 *
 * @param {number} mModifier
 * @private
 */
UCF_Scrollbar["prototype"]["scrollToPrevious"] = function (mModifier) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToPrevious"]++; }; 
	this["bHandleEvent"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION_TO_CODE"]["PREVIOUS"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToPrevious"] = 0; };

/**
 * Scroll to next item
 *
 * @param {number} mModifier
 * @private
 */
UCF_Scrollbar["prototype"]["scrollToNext"] = function (mModifier) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToNext"]++; }; 
	this["bHandleEvent"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION_TO_CODE"]["NEXT"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToNext"] = 0; };

/**
 * Scroll to previous page
 *
 * @param {number} mModifier
 * @private
 */
UCF_Scrollbar["prototype"]["scrollToPreviousPage"] = function (mModifier) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToPreviousPage"]++; }; 
	this["bHandleEvent"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION_TO_CODE"]["PREVIOUS_PAGE"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToPreviousPage"] = 0; };

/**
 * Scroll to next page
 *
 * @param {number} mModifier
 * @private
 */
UCF_Scrollbar["prototype"]["scrollToNextPage"] = function (mModifier) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToNextPage"]++; }; 
	this["bHandleEvent"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION_TO_CODE"]["NEXT_PAGE"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToNextPage"] = 0; };

/**
 * Scroll to begin
 *
 * @param {number} mModifier
 * @private
 */
UCF_Scrollbar["prototype"]["scrollToBegin"] = function (mModifier) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToBegin"]++; }; 
	this["bHandleEvent"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION_TO_CODE"]["BEGIN"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToBegin"] = 0; };

/**
 * Scroll to end
 *
 * @param {number} mModifier
 * @private
 */
UCF_Scrollbar["prototype"]["scrollToEnd"] = function (mModifier) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToEnd"]++; }; 
	this["bHandleEvent"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION_TO_CODE"]["END"], mModifier));
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToEnd"] = 0; };

/**
 * Returns true if the scrollbar reached the end position
 *
 * @return {boolean}
 * @private
 */
UCF_Scrollbar["prototype"]["bEndPosition"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bEndPosition"]++; }; 
	return !this["bIsDisabled"]() && this["iScrollPos"] >= this["iGetMaxScrollTo"]();
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bEndPosition"] = 0; };

/**
 * Returns true if the scrollbar is in start position
 *
 * @return {boolean}
 * @private
 */
UCF_Scrollbar["prototype"]["bStartPosition"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bStartPosition"]++; }; 
	return !this["bIsDisabled"]() && this["iScrollPos"] <= 1;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bStartPosition"] = 0; };

/**
 * @see UCF_ScrollBase
 * @override
 * @private
 */
UCF_Scrollbar["prototype"]["bIsInInteraction"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsInInteraction"]++; }; 
	return this["eLastAccessType"] == this["ACCESS_TYPE"]["REPETITION"]
		|| this["eLastAccessType"] == this["ACCESS_TYPE"]["MOUSE_WHEEL"]
		|| this["eLastAccessType"] == this["ACCESS_TYPE"]["DRAG_START"]
		|| this["eLastAccessType"] == this["ACCESS_TYPE"]["DRAG"]
		|| this["eLastAccessType"] == this["ACCESS_TYPE"]["TOUCH_START"];
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsInInteraction"] = 0; };

/**
 * @see UCF_ScrollBase
 * @override
 * @private
 */
UCF_Scrollbar["prototype"]["cancelInteraction"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["cancelInteraction"]++; }; 
	if (this["bIsInInteraction"]()) {
		if (this["eLastAccessType"] == this["ACCESS_TYPE"]["MOUSE_WHEEL"]) {
			return this["bHandleEvent"](null, this["ACCESS_TYPE"]["MOUSE_WHEEL_CANCEL"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["cancelInteraction"] = 0; };

/**
 * @see UCF_ScrollBase
 * @override
 * @private
 */
UCF_Scrollbar["prototype"]["stopInteraction"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["stopInteraction"]++; }; 
	if (this["bIsInInteraction"]()) {
		if (this["eLastAccessType"] == this["ACCESS_TYPE"]["MOUSE_WHEEL"]) {
			return this["bHandleEvent"](null, this["ACCESS_TYPE"]["MOUSE_WHEEL_END"]);
		} else if (this["eLastAccessType"] == this["ACCESS_TYPE"]["REPETITION"]) {
			return this["bHandleEvent"](null, this["ACCESS_TYPE"]["REPETITION_END"]);
		} else if (this["eLastAccessType"] == this["ACCESS_TYPE"]["DRAG_START"] || this["eLastAccessType"] == this["ACCESS_TYPE"]["DRAG"]) {
			return this["bHandleEvent"](null, this["ACCESS_TYPE"]["DRAG_END"]);
		} else if (this["eLastAccessType"] == this["ACCESS_TYPE"]["TOUCH_START"] || this["eLastAccessType"] == this["ACCESS_TYPE"]["TOUCH_MOVE"]) {
			return this["bHandleEvent"](null, this["ACCESS_TYPE"]["TOUCH_END"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["stopInteraction"] = 0; };

/**
 * Scroll to a specific position
 *
 * @param {number} iPosition
 * @param {number} mModifier
 * @private
 */
UCF_Scrollbar["prototype"]["scrollToPosition"] = function (iPosition, mModifier) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToPosition"]++; }; 
	this["bHandleEvent"](null, this["ACCESS_TYPE"]["EXTERNAL"], this["oCreateAccessInfoByExternal"](this["ACTION_TO_CODE"]["POSITION"], mModifier, iPosition));
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollToPosition"] = 0; };

/**
 * @see UCF_ScrollBase
 * @override
 * @private
 */
UCF_Scrollbar["prototype"]["setItemCount"] = function (iItemCount) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setItemCount"]++; }; 
	if (iItemCount > 0 && iItemCount != this["iItemCount"]) {
		this["iItemCount"] = iItemCount;
		this["setClientProperty"]("ItemCount", this["iItemCount"], true);
		this["updateDimensions"](iItemCount, this["iScrollClipping"], this["iScrollPos"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setItemCount"] = 0; };

/**
 * @see UCF_ScrollBase
 * @override
 * @private
 */
UCF_Scrollbar["prototype"]["setVisibleItemCount"] = function (iVisibleItemCount) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setVisibleItemCount"]++; }; 
	if (iVisibleItemCount > 0 && iVisibleItemCount != this["iScrollClipping"]) {
		this["updateDimensions"](this["iItemCount"], iVisibleItemCount, this["iScrollPos"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setVisibleItemCount"] = 0; };

/**
 * @see UCF_ScrollBase
 * @override
 * @private
 */
UCF_Scrollbar["prototype"]["setFirstVisibleItem"] = function (iFirstVisibleItem, bSkipUpdateUI) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setFirstVisibleItem"]++; }; 
	if (iFirstVisibleItem > 0 && iFirstVisibleItem != this["iScrollPos"]) {
		if (bSkipUpdateUI) {
			this["iScrollPos"] = iFirstVisibleItem;
		} else {
			this["updateDimensions"](this["iItemCount"], this["iScrollClipping"], iFirstVisibleItem);

			// scrollToPosition calls this method implicit with bSkipUpdateUI=true
			this["scrollToPosition"](iFirstVisibleItem, UCF_JsUtil["MODIFIER"]["NONE"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setFirstVisibleItem"] = 0; };

/**
 * @see UCF_ScrollBase
 * @override
 * @private
 */
UCF_Scrollbar["prototype"]["bIsScrolledIntoView"] = function (iItemIndex) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsScrolledIntoView"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (iItemIndex) == "number", "typeof (iItemIndex) == \"number\"", "Scrollbar.js(803): bIsScrolledIntoView"); };

	return ( // check scroll window
		iItemIndex >= this["iScrollPos"]
		&& iItemIndex < this["iScrollPos"] + this["iScrollClipping"]
	)
		// outside the scrolling range -> true
		|| iItemIndex < 0 || iItemIndex >= this["iItemCount"];
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsScrolledIntoView"] = 0; };

/******************************************************
 ** GENERAL
 *******************************************************/

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_Scrollbar["prototype"]["sGetId"] = function (oDomRef) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["sGetId"]++; }; 
	if (this["sScrolledElementId"]) return this["sScrolledElementId"];

	return UCF_ScrollBase.prototype["sGetId"]["call"](this, oDomRef);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["sGetId"] = 0; };

/**
 * Returns the control refrence to the control which has to be scrolled and chches it
 *
 * @return {UCF_Control}
 * @private
 */
UCF_Scrollbar["prototype"]["oGetScrolledElement"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["oGetScrolledElement"]++; }; 
	if (!this["oScrolledElement"] && this["sScrolledElementId"]) {
		this["oScrolledElement"] = this["oGetControlById"](this["sScrolledElementId"]);
	}

	return this["oScrolledElement"];
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["oGetScrolledElement"] = 0; };

/**
 * Creates and returns access info of the current user interaction
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {ACCESS_TYPE} eAccessType
 *
 * @return {Object}
 * @private
 */
UCF_Scrollbar["prototype"]["oGetAccessInfo"] = function (oBrowserEvent, eAccessType) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["oGetAccessInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (eAccessType) == "number", "typeof (eAccessType) == \"number\"", "Scrollbar.js(852): oGetAccessInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(eAccessType >= 0, "eAccessType >= 0", "Scrollbar.js(853): oGetAccessInfo"); };

	var oDomRef = null,
		eAction = this["ACTION_TO_CODE"]["NONE"],
		sAccessFragmentType = "";

	if (oBrowserEvent) {
		oDomRef = oBrowserEvent["oGetSource"]();

		while (oDomRef && oDomRef["tagName"] != "BODY") {

			if (!eAction && oDomRef["getAttribute"]("acf")) {
				sAccessFragmentType = oDomRef["getAttribute"]("acf");
				eAction = sAccessFragmentType;
			}

			if (sAccessFragmentType || oDomRef == this["oDomRef"]) {
				break;
			}
			oDomRef = oDomRef["parentNode"];
		}
	}

	return {
		"oBrowserEvent": oBrowserEvent,
		"eAccessType": eAccessType,
		"sAccessFragmentType": sAccessFragmentType,
		"oAccessFragmentDomRef": oDomRef,
		"eAction": eAction,
		"mModifier": UCF_JsUtil["MODIFIER"]["NONE"],
		"bHandled": false
	};
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["oGetAccessInfo"] = 0; };

/**
 * Create access info reflection an external access and not an user interaction which can be derived from a browser event
 *
 * @param {ACTION} eAction
 * @param {number} mModifier
 * @param {number} iPosition
 *
 * @return {Object}
 *
 * @see oGetAccessInfo
 * @private
 */
UCF_Scrollbar["prototype"]["oCreateAccessInfoByExternal"] = function (eAction, mModifier, iPosition) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["oCreateAccessInfoByExternal"]++; }; 
	return {
		"oBrowserEvent": null,
		"eAccessType": this["ACCESS_TYPE"]["EXTERNAL"],
		"sAccessFragmentType": null,
		"oAccessFragmentDomRef": null,
		"eAction": eAction,
		"bHandled": false,
		"mModifier": (mModifier ? mModifier : UCF_JsUtil["MODIFIER"]["NONE"]),
		"iPosition": (iPosition ? iPosition : 0)
	};
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["oCreateAccessInfoByExternal"] = 0; };

/**
 * @param {Object} oAccessInfo
 * @return {boolean}
 * @private
 */
UCF_Scrollbar["prototype"]["bIsSelectAccess"] = function (oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsSelectAccess"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "Scrollbar.js(918): bIsSelectAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oAccessInfo) == "object", "typeof (oAccessInfo) == \"object\"", "Scrollbar.js(919): bIsSelectAccess"); };

	return oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["MOUSE"]
		|| (oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["KEYBOARD"] && oAccessInfo["oBrowserEvent"]["iKeyCode"]() == UCF_KeyCodes["SPACE"]);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsSelectAccess"] = 0; };

/**
 * Handle event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {ACCESS_TYPE} eAccessType
 * @param {Object} oAccessInfo
 *
 * @return {boolean} false to skip event processing
 * @private
 */
UCF_Scrollbar["prototype"]["bHandleEvent"] = function (oBrowserEvent, eAccessType, oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bHandleEvent"]++; }; 
	//oBrowserEvent optional
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (eAccessType) == "number", "typeof (eAccessType) == \"number\"", "Scrollbar.js(937): bHandleEvent"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(eAccessType >= 0, "eAccessType >= 0", "Scrollbar.js(938): bHandleEvent"); };
	//oAccessInfo optional

	this["detachResize"]();

	if (this["bIsDisabled"]()) eAccessType = this["ACCESS_TYPE"]["NONE"];

	this["resetButtonUI"]();
	this["resetScrollRepetition"]();

	if (oAccessInfo) oAccessInfo["eAccessType"] = eAccessType;
	else oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, eAccessType);

	if (eAccessType == this["ACCESS_TYPE"]["REPETITION_END"]) {
		this["scrollTo"](oAccessInfo, this["iScrollPos"]);
	} else if (eAccessType == this["ACCESS_TYPE"]["MOUSE_WHEEL"]) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Scrollbar.js(954): bHandleEvent"); };

		if (oBrowserEvent["iWheelDelta"]() * this["iWheelDirection"] < 0) {
			// wheel direction has changed: reset velocity
			this["iWheelTicksInMassProcessing"] = 0;
		}
		this["iWheelTicksInMassProcessing"] = Math["min"](10, ++this["iWheelTicksInMassProcessing"]);
		this["iWheelDirection"] = Math["abs"](oBrowserEvent["iWheelDelta"]()) / oBrowserEvent["iWheelDelta"](); // no Math.sign() in IE!
		var iWheelDelta = this["iWheelDirection"] * Math["floor"](1.2 * this["iWheelTicksInMassProcessing"]);
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '#mouse wheel ticks since last roundtrip: ' + this["iWheelTicksInMassProcessing"] + ' calculated wheelDelta: ' + iWheelDelta, "Scrollbar.js(963): bHandleEvent"); };
		if (this["iMouseWheelFirstVisbleItemReference"] < 0) {
			this["iMouseWheelFirstVisbleItemReference"] = this["iScrollPos"];
		}
		this["scrollTo"](oAccessInfo, this["iScrollPos"] - (this["bPixelDirectMode"] ? this["iSmallChange"] * iWheelDelta : iWheelDelta));
	} else if (eAccessType == this["ACCESS_TYPE"]["MOUSE_WHEEL_END"]) {
		this["iWheelTicksInMassProcessing"] = 0; //Reset
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'mouse_wheel_end ticks: ' + this["iWheelTicksInMassProcessing"], "Scrollbar.js(970): bHandleEvent"); };
		if (this["iMouseWheelFirstVisbleItemReference"] != -1) {
			//IMPORTANT oBrowserEvent.oDomEvent is not valid in this section
			//IMPORTANT oBrowserEvent could be also null
			if (oAccessInfo["oBrowserEvent"]) oAccessInfo["oBrowserEvent"]["oDomEvent"] = null;
			this["scrollTo"](oAccessInfo, this["iScrollPos"]);
			this["iMouseWheelFirstVisbleItemReference"] = -1;
		}
	} else if (eAccessType == this["ACCESS_TYPE"]["MOUSE_WHEEL_CANCEL"]) {
		if (this["iMouseWheelFirstVisbleItemReference"] != -1) {
			//IMPORTANT oBrowserEvent is null
			this["scrollTo"](oAccessInfo, this["iMouseWheelFirstVisbleItemReference"]);
			this["iMouseWheelFirstVisbleItemReference"] = -1;
		}
	} else if (eAccessType == this["ACCESS_TYPE"]["DRAG"] || eAccessType == this["ACCESS_TYPE"]["DRAG_END"]) {
		if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["HANDLE_MOVE"]) {
			if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Scrollbar.js(986): bHandleEvent"); };
			var iPxTotal = this["iGetOuterSize"](),
				fPxItemRange = iPxTotal / this["iScrollRange"],
				iPxDragReferenceTo = this["bIsVertical"] ? oBrowserEvent["iPageY"]() : oBrowserEvent["iPageX"](),
				iPxDragDistance = iPxDragReferenceTo - this["iPxDragReference"],
				iDragDistance = Math["round"](iPxDragDistance / fPxItemRange);

			this["scrollTo"](oAccessInfo, this["iDragFirstVisbleItemReference"] + ((window["UCF_System"]["bIsRTL"] && !this["bIsVertical"]) ? -iDragDistance : iDragDistance));

			if (eAccessType == this["ACCESS_TYPE"]["DRAG_END"]) {
				this["iPxDragReference"] = -1;
				this["iPxDragPositionReference"] = -1;
				this["iDragFirstVisbleItemReference"] = -1;
			}
		}
	} else if (eAccessType == this["ACCESS_TYPE"]["DRAG_START"]) {
		if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["HANDLE_MOVE"]) {
			if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Scrollbar.js(1003): bHandleEvent"); };
			this["iPxDragReference"] = this["bIsVertical"] ? oBrowserEvent["oDragAndDropManager"]["iDragStartY"] : oBrowserEvent["oDragAndDropManager"]["iDragStartX"];
			this["iPxDragPositionReference"] = this["bIsVertical"] ? this["oDomRefSpacer"]["offsetHeight"] : this["oDomRefSpacer"]["offsetWidth"];
			this["iDragFirstVisbleItemReference"] = this["iScrollPos"];

			oBrowserEvent["oDragAndDropManager"]["startDragSession"](this["sId"], "", UCF_DragSession["DRAG_TYPE"]["NONE"], null, null);
			oAccessInfo["bHandled"] = true;

		}
	} else if (eAccessType == this["ACCESS_TYPE"]["MOUSE"] || eAccessType == this["ACCESS_TYPE"]["KEYBOARD"] || eAccessType == this["ACCESS_TYPE"]["EXTERNAL"]) {
		if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["PREVIOUS"]) {
			this["scrollTo"](oAccessInfo, this["iScrollPos"] - this["iSmallChange"]);
		} else if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["NEXT"]) {
			this["scrollTo"](oAccessInfo, this["iScrollPos"] + this["iSmallChange"]);
		} else if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["BEGIN"]) {
			this["scrollTo"](oAccessInfo, 1);
		} else if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["END"]) {
			this["scrollTo"](oAccessInfo, this["iScrollRange"]);
		} else if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["NEXT_PAGE"]) {
			this["scrollTo"](oAccessInfo, this["iScrollPos"] + this["iLargeChange"]);
		} else if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["PREVIOUS_PAGE"]) {
			this["scrollTo"](oAccessInfo, this["iScrollPos"] - this["iLargeChange"]);
		} else if (oAccessInfo["eAction"] == this["ACTION_TO_CODE"]["POSITION"]) {
			this["scrollTo"](oAccessInfo, oAccessInfo["iPosition"]);
		}
	} else if (eAccessType == this["ACCESS_TYPE"]["TOUCH_START"] || eAccessType == this["ACCESS_TYPE"]["TOUCH_MOVE"] || eAccessType == this["ACCESS_TYPE"]["TOUCH_END"]) {
		this["handleTouchSupport"](oBrowserEvent, eAccessType, oAccessInfo);
	}

	if (oAccessInfo["bHandled"] && oBrowserEvent && oBrowserEvent["oDomEvent"]) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["oDomEvent"]["returnValue"] = false;
		oBrowserEvent["bHandled"] = true;
	}

	if (eAccessType != this["ACCESS_TYPE"]["DRAG"]) this["attachResize"]();

	return !oAccessInfo["bHandled"];
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bHandleEvent"] = 0; };

/* eslint-disable complexity */
/**
 * Scroll to item
 *
 * @param {Object} oAccessInfo
 * @param {number} iNewScrollPos
 * @private
 */
UCF_Scrollbar["prototype"]["scrollTo"] = function (oAccessInfo, iNewScrollPos) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollTo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "Scrollbar.js(1053): scrollTo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oAccessInfo) == "object", "typeof (oAccessInfo) == \"object\"", "Scrollbar.js(1054): scrollTo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (iNewScrollPos) == "number", "typeof (iNewScrollPos) == \"number\"", "Scrollbar.js(1055): scrollTo"); };

	if (this["bIsDisabled"]()) {
		this["eLastAccessType"] = this["ACCESS_TYPE"]["NONE"];
	} else {
		var bNotify = false,
			bChanged = false,
			eAction = this["CODE_TO_ACTION"][oAccessInfo["eAction"]],
			eAccessSource = (oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["EXTERNAL"]) ?
				this["ACCESS_SOURCE"]["EXTERNAL"] :
				this["ACCESS_SOURCE"]["SCROLLBAR"];

		this["eLastAccessType"] = oAccessInfo["eAccessType"];

		iNewScrollPos = Math["min"](Math["max"](1, iNewScrollPos), this["iGetMaxScrollTo"]());

		if (iNewScrollPos != this["iScrollPos"]) {
			this["setFirstVisibleItem"](iNewScrollPos, true);
			bChanged = true;
			if (oAccessInfo["eAccessType"] != this["ACCESS_TYPE"]["DRAG"] && oAccessInfo["eAccessType"] != this["ACCESS_TYPE"]["TOUCH_MOVE"]) {
				bNotify = true;
			}
		}

		this["resetDragRemain"]();
		if (iNewScrollPos == this["iScrollPos"] && oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["DRAG"]) {
			this["checkDragRemain"]();
		}

		if (oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["DRAG_END"] && this["iScrollPos"] != this["iDragFirstVisbleItemReference"]) {
			bNotify = true;
			eAction = this["ACTION"]["DIRECT"];
		} else if (oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["MOUSE_WHEEL"]) {
			bNotify = false;
			eAction = this["ACTION"]["DIRECT"];
		} else if (oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["MOUSE_WHEEL_END"] && this["iScrollPos"] != this["iMouseWheelFirstVisbleItemReference"]) {
			bNotify = true;
			eAction = this["ACTION"]["DIRECT"];
		} else if (oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["MOUSE_WHEEL_CANCEL"]) {
			bNotify = false;
			eAction = this["ACTION"]["DIRECT"];
		} else if (oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["REPETITION"]) {
			bNotify = false;
			eAction = this["ACTION"]["DIRECT"];
		} else if (oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["REPETITION_END"]) {
			bNotify = true;
			eAction = this["ACTION"]["DIRECT"];
		} else if (oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["TOUCH_MOVE"] && this["oTouchInfo"] && this["iScrollPos"] != this["oTouchInfo"]["iScrollPosStart"]) {
			bNotify = false;
			eAction = this["ACTION"]["DIRECT"];
		} else if (oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["TOUCH_END"] && this["oTouchInfo"] && this["iScrollPos"] != this["oTouchInfo"]["iScrollPosStart"]) {
			bNotify = true;
			eAction = this["ACTION"]["DIRECT"];
		}

		if (this["mNotificationMode"] == this["NOTIFICATION"]["ALWAYS_WHEN_CHANGED"]) {
			if (bChanged) bNotify = true;
		} else if (this["mNotificationMode"] == this["NOTIFICATION"]["ALWAYS"]) bNotify = true;
		else if (this["mNotificationMode"] == this["NOTIFICATION"]["NEVER"]) bNotify = false;

		if (oAccessInfo && oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["DRAG"]) {
			var iPxDragReferenceTo = this["bIsVertical"] ? oAccessInfo["oBrowserEvent"]["iPageY"]() : oAccessInfo["oBrowserEvent"]["iPageX"](),
				iPxDragDistance = (window["UCF_System"]["bIsRTL"] && !this["bIsVertical"]) ? -(iPxDragReferenceTo - this["iPxDragReference"]) : iPxDragReferenceTo - this["iPxDragReference"],
				iPxPositionDirect = this["iPxDragPositionReference"] + iPxDragDistance;

			this["paintBar"](iPxPositionDirect);
		} else {
			this["paintBar"](-1);
		}

		//Scrolltips
		if (this["bShowScrollTip"]) {
			if (oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["DRAG"]
				|| oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["MOUSE_WHEEL"]
				|| oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["REPETITION"]
				|| oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["TOUCH_MOVE"]
			) {
				this["showScrollTip"]();
			} else if (!this["bIsInInteraction"]()) {
				this["hideScrollTip"]();
			}
		} else {
			// This is done to force the browser to paint the scrollbar,
			// otherwise the handle is not painted always. It judders.
			// When a Scrolltip is involved the handle is touched anyway
			// eslint-disable-next-line no-unused-expressions
			this["oDomRefHandle"]["offsetWidth"];
		}

		// Focus blur
		// Scrollwheel and all direct scrollbar interaction need to blur focus to avoid a scroll into view after roundtrip
		if (oAccessInfo["eAccessType"] != this["ACCESS_TYPE"]["KEYBOARD"] &&
			(oAccessInfo["eAccessType"] == this["ACCESS_TYPE"]["MOUSE_WHEEL"] || eAccessSource == this["ACCESS_SOURCE"]["SCROLLBAR"])
		) {
			UCF_DomUtil["blurActiveElement"](true);
		}

		if (bNotify) {

			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Id:" + this["sId"] + ", Value:" + this["iScrollPos"] + ", Action:" + eAction + ", Access:" + eAccessSource + ", ScrolledElementId:" + this["sScrolledElementId"], "Scrollbar.js(1154): scrollTo"); };
			// create instance of ScrolledElement to grant that it can listen to the event
			var oScrolledElement = this["oGetScrolledElement"]();

			// fire
			this["fireInternalScrollEvent"](this["iScrollPos"], eAction, eAccessSource, oAccessInfo["eAccessType"], oAccessInfo["mModifier"]);

			if (!(oScrolledElement && UCF_JsUtil["bInstanceOf"](oScrolledElement, "UCF_SapTable")))
				this["fireScroll"](this["sId"],
					this["iScrollPos"],
					eAction,
					eAccessSource,
					(oAccessInfo["mModifier"] & UCF_JsUtil["MODIFIER"]["SHIFT"] ? true : false),
					(oAccessInfo["mModifier"] & UCF_JsUtil["MODIFIER"]["CTRL"] ? true : false),
					(oAccessInfo["mModifier"] & UCF_JsUtil["MODIFIER"]["ALT"] ? true : false)
				);
		}

		oAccessInfo["bHandled"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["scrollTo"] = 0; };
/* eslint-enable complexity */

/**
 * Paint scroll bar
 *
 * @param {Object} oAccessInfo (optional)
 * @private
 */
UCF_Scrollbar["prototype"]["paintBar"] = function (iPxPositionDirect) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["paintBar"]++; }; 

	var iDisplayedScrollRange = this["iGetDisplayedScrollRange"](),
		sStyleAttribute = this["bIsVertical"] ? "height" : "width",
		iPxTotal = this["iGetOuterSize"](),
		fPxItemRange = this["iScrollRange"] ? (iPxTotal / iDisplayedScrollRange) : 0, //Take care for divison by zero
		fPxPosition = fPxItemRange * (this["iScrollPos"] - 1),
		fPxHandleRange = fPxItemRange * this["iScrollClipping"],
		iPxPosition = Math["round"](fPxPosition),
		iPxHandleRange = Math["max"](this["HANDLE_MIN_SIZE"], Math["round"](fPxHandleRange)),
		iPxMaxPosition = iPxTotal - iPxHandleRange - 1,
		bDisabled = this["bIsDisabled"]();

	if (iPxPositionDirect >= 0) {
		iPxPosition = iPxPositionDirect;
	}

	iPxPosition = Math["min"](iPxPosition, iPxMaxPosition);

	// Update handle size
	if (!bDisabled && !this["bIsInInteraction"]()) {
		var sResultSize = null;

		if (this["bPixelDirectMode"]) {
			if (!this["bIsVertical"] && (UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]() || window["UCF_System"]["sDevice"] == "standards")) {
				//Span cannot apply width in FireFox
				var oDomRefInnerElement = this["oDomRefHandle"]["firstChild"],
					iBorderWidth = this["oDomRefHandle"]["offsetWidth"] - oDomRefInnerElement["offsetWidth"];

				this["oDomRefHandle"]["style"][sStyleAttribute] = iPxHandleRange + "px";
				oDomRefInnerElement["style"][sStyleAttribute] = (iPxHandleRange - iBorderWidth) + "px";
			} else {
				sResultSize = iPxHandleRange + "px";
			}
		} else if (iDisplayedScrollRange > this["iScrollClipping"]) {
			//This calculation is also done in renderer
			var iPxTotalHeight = parseInt(this["bIsVertical"] ?
				((this["iScrollClipping"] * this["iPxItemSize"]) - 34 + this["iPxItemSpanCorrection"]) : //Use Server approximation algorithm to keep server and client in sync
				iPxTotal //Use exact algorithm
				, 10),
				iPcMinHandleSize = Math["max"](1, parseInt((this["HANDLE_MIN_SIZE"] * 100) / iPxTotalHeight, 10)),
				iPcCalculatetHandleSize = parseInt((this["iScrollClipping"] * 100) / iDisplayedScrollRange, 10),
				iPcHandleSize = Math["max"](iPcMinHandleSize, iPcCalculatetHandleSize),
				oDomRefInnerHandle = this["oDomRefHandle"]["firstChild"],
				bHasGrip = UCF_DomUtil["bHasClass"](oDomRefInnerHandle, "urSCBGrip"),
				bShouldHaveGrip = (((iPcHandleSize * iPxTotalHeight) / 100) > this["HANDLE_GRIP_TRESHOLD"]);

			sResultSize = iPcHandleSize + "%";

			if (bHasGrip != bShouldHaveGrip) {
				if (bShouldHaveGrip) UCF_DomUtil["addClass"](oDomRefInnerHandle, "urSCBGrip");
				else UCF_DomUtil["removeClass"](oDomRefInnerHandle, "urSCBGrip");
			}
		}

		if (sResultSize !== null) this["oDomRefHandle"]["style"][sStyleAttribute] = sResultSize;
	}

	// Update spacer size
	if (iPxPosition > 0) {
		this["oDomRefSpacer"]["style"]["display"] = this["bIsVertical"] ? "block" : "inline";

		if (iPxTotal / 100 < 1.0 || this["bPixelDirectMode"]) {
			//Pixel mode
			if (iPxPosition == iPxMaxPosition) {
				this["oDomRefSpacer"]["style"][sStyleAttribute] = (iPxTotal - iPxHandleRange) + "px";
			} else {
				this["oDomRefSpacer"]["style"][sStyleAttribute] = iPxPosition + "px";
			}
		} else {
			//Percentage mode
			if (iPxPosition == iPxMaxPosition) {

				var sPcHandleRange = this["oDomRefHandle"]["style"][sStyleAttribute],
					iPcHandleRange = parseInt(sPcHandleRange, 10);

				if (__UCF_ASSERT__) { UCF_Tracer.assert((100 - iPcHandleRange) >= 1, "(100 - iPcHandleRange) >= 1", "Scrollbar.js(1259): paintBar"); };

				this["oDomRefSpacer"]["style"][sStyleAttribute] = (100 - iPcHandleRange) + "%";
			} else {
				this["oDomRefSpacer"]["style"][sStyleAttribute] = Math["round"]((100 * iPxPosition) / iPxTotal) + "%";
			}
		}
	} else {
		this["oDomRefSpacer"]["style"]["display"] = "none";
		this["oDomRefSpacer"]["style"][sStyleAttribute] = 0;
	}

	// Update disabled UI state when changed
	if (this["oDomRef"]["bDisabled"] !== bDisabled) {
		var bInitial = !this["oDomRef"]["bDisabled"] && this["oDomRef"]["bDisabled"] !== false;

		this["oDomRef"]["bDisabled"] = bDisabled;

		if (this["bIsVertical"] || !this["bPixelDirectMode"]) {

			//Handle
			if (bDisabled) this["oDomRefHandle"]["style"]["display"] = "none";
			else this["oDomRefHandle"]["style"]["display"] = this["bIsVertical"] ? "block" : "inline-block";

			//Spacer
			if (bDisabled) this["oDomRefSpacer"]["style"]["display"] = "none";

			//Buttons
			{
				var oDomRef = null,
					sClassName = null;

				for (var sButtonType in UCF_Scrollbar["prototype"]["BUTTON_TYPE"]) {

					sButtonType = UCF_Scrollbar["prototype"]["BUTTON_TYPE"][sButtonType];

					oDomRef = UCF_DomUtil["$"](this["sId"] + "-" + sButtonType);
					if (oDomRef) {
						sClassName = "urSCB";

						if (this["bIsVertical"]) {
							if (sButtonType == "Bgn") sClassName += "Top";
							else if (sButtonType == "End") sClassName += "Btm";
							else if (sButtonType == "Prev") sClassName += "Up";
							else if (sButtonType == "Nxt") sClassName += "Dwn";
						} else {
							sClassName += sButtonType;
						}

						// Correction for initial run through this code section
						// If "this.oDomRef.bDisabled" is not initialized check last state by analyzing the class names
						if (bInitial
							&& (
								(bDisabled && UCF_DomUtil["bHasClass"](oDomRef, sClassName + "Dsbl"))
								|| (!bDisabled && !UCF_DomUtil["bHasClass"](oDomRef, sClassName + "Dsbl"))
							)
						) {
							continue;
						}

						UCF_DomUtil["replaceClass"](oDomRef, bDisabled ? sClassName : sClassName + "Dsbl", bDisabled ? sClassName + "Dsbl" : sClassName);
					}
				}
			}
		} else {
			//Complete hidden bar
			if (this["bIsDisabled"]()) this["oDomRef"]["style"]["visibility"] = "hidden";
			else this["oDomRef"]["style"]["visibility"] = "inherit";
		}
	}

};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["paintBar"] = 0; };

/**
 * Set pressed button style
 *
 * @param {Object} oAccessInfo
 * @private
 */
UCF_Scrollbar["prototype"]["setPressedButtonUI"] = function (oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setPressedButtonUI"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo != null, "oAccessInfo != null", "Scrollbar.js(1339): setPressedButtonUI"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oAccessInfo) == "object", "typeof (oAccessInfo) == \"object\"", "Scrollbar.js(1340): setPressedButtonUI"); };

	if (this["oDomRefCurrentPressedButton"] == null) {
		this["oDomRefCurrentPressedButton"] = oAccessInfo["oAccessFragmentDomRef"];

		UCF_DomUtil["addClass"](this["oDomRefCurrentPressedButton"], "urSCBBtnPressed");
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setPressedButtonUI"] = 0; };

/**
 * Reset pressed button style
 * @private
 */
UCF_Scrollbar["prototype"]["resetButtonUI"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["resetButtonUI"]++; }; 
	if (this["oDomRefCurrentPressedButton"] != null) {
		UCF_DomUtil["removeClass"](this["oDomRefCurrentPressedButton"], "urSCBBtnPressed");
		this["oDomRefCurrentPressedButton"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["resetButtonUI"] = 0; };

/**
 * Set scroll repition
 *
 * @param {number} iIncrement
 * @private
 */
UCF_Scrollbar["prototype"]["setScrollRepetition"] = function (iIncrement, iScrollRepetitionReferencePos) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setScrollRepetition"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (iIncrement) == "number", "typeof (iIncrement) == \"number\"", "Scrollbar.js(1367): setScrollRepetition"); };

	this["iScrollRepetitionProcessId"]++;
	if (iScrollRepetitionReferencePos) this["iScrollRepetitionReferencePos"] = iScrollRepetitionReferencePos;
	UCF_JsUtil["delayedCall"](this["SCROLL_REPETITION_LATENCY"], this, "startScrollRepetition", [iIncrement, this["iScrollRepetitionProcessId"]]);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setScrollRepetition"] = 0; };

/**
 * Start scroll repitition
 *
 * @param {number} iIncrement
 * @param {number} iScrollRepitionProcessId
 * @private
 */
UCF_Scrollbar["prototype"]["startScrollRepetition"] = function (iIncrement, iScrollRepetitionProcessId) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["startScrollRepetition"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (iIncrement) == "number", "typeof (iIncrement) == \"number\"", "Scrollbar.js(1382): startScrollRepetition"); };
	if (iScrollRepetitionProcessId == this["iScrollRepetitionProcessId"]) {
		this["iScrollRepetitionIncrement"] = iIncrement;
		this["processScrollRepetition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["startScrollRepetition"] = 0; };

/**
 * Process scroll repitition
 * @private
 */
UCF_Scrollbar["prototype"]["processScrollRepetition"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["processScrollRepetition"]++; }; 
	if (this["bIsScrollRepetitionInProcess"]()) {
		this["scrollTo"](
			this["oGetAccessInfo"](null, this["ACCESS_TYPE"]["REPETITION"]),
			(this["iScrollRepetitionReferencePos"] > 0 && this["bIsScrolledIntoView"](this["iScrollRepetitionReferencePos"])) ?
				this["iScrollPos"] :
				this["iScrollPos"] + this["iScrollRepetitionIncrement"]
		);

		UCF_JsUtil["delayedCall"](this["SCROLL_REPETITION_DELAY"], this, "processScrollRepetition");

	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["processScrollRepetition"] = 0; };

/**
 * Reset scroll repitition
 * @private
 */
UCF_Scrollbar["prototype"]["resetScrollRepetition"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["resetScrollRepetition"]++; }; 
	this["iScrollRepetitionIncrement"] = 0;
	this["iScrollRepetitionReferencePos"] = -1;
	//Invalidate current process id
	this["iScrollRepetitionProcessId"]++;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["resetScrollRepetition"] = 0; };

/**
 * Detects if currently a scroll repetition is in process
 *
 * @return {boolean}
 * @private
 */
UCF_Scrollbar["prototype"]["bIsScrollRepetitionInProcess"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsScrollRepetitionInProcess"]++; }; 
	return this["iScrollRepetitionIncrement"] != 0;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsScrollRepetitionInProcess"] = 0; };

/**
 * Show scroll tip
 * @private
 */
UCF_Scrollbar["prototype"]["showScrollTip"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["showScrollTip"]++; }; 
	if (!this["oDomRefScrollTip"]) {
		this["initScrollTip"]();
	}
	this["updateScrollTip"]();
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["showScrollTip"] = 0; };

/**
 * Init scroll tip
 * @private
 */
UCF_Scrollbar["prototype"]["initScrollTip"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["initScrollTip"]++; }; 
	this["oDomRefScrollTip"] = document["createElement"]("DIV");
	this["oDomRefScrollTip"]["setAttribute"]("id", "ur-scrolltip");
	this["oDomRefScrollTip"]["style"]["position"] = "absolute";
	this["oDomRefScrollTip"]["style"]["top"] = "0px";
	this["oDomRefScrollTip"]["style"]["left"] = "0px";
	// Support for DIV-popups in WebGUI and WDA: The popups are also rendered in the assoc-area with a z-index
	// => Must also use z-index value of layered controls
	this["oDomRefScrollTip"]["style"]["zIndex"] = UCF_LS["E_LAYERS"]["POPUPMENUS"];

	// adhere to tokenizer (almost)
	UCF_DomUtil["oAddLayeredElement"](this["oDomRefScrollTip"], this["oLS"]["oGetAssociatedAreaRef"](), this["oGetParentScrollAreaDomRef"]());

	//Prepare application ScrollTips when available
	if (UCF_DomUtil["$"](this["sId"] + "-" + this["FRAGMENT"]["SCROLLTIPS"])) {
		this["mAppScrollTipMap"] = UCF_JsUtil["oJsonParse"](UCF_DomUtil["$"](this["sId"] + "-" + this["FRAGMENT"]["SCROLLTIPS"] + "-map")["innerHTML"]);
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (this["mAppScrollTipMap"]) == "object", "typeof (this.mAppScrollTipMap) == \"object\"", "Scrollbar.js(1459): initScrollTip"); };
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["initScrollTip"] = 0; };

/**
 * Update scroll tip
 * @private
 */
UCF_Scrollbar["prototype"]["updateScrollTip"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["updateScrollTip"]++; }; 
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](this["oDomRefScrollTip"], this["sGetScrollTipHtml"]());
	this["updateScrollTipPosition"]();
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["updateScrollTip"] = 0; };

/**
 * Hide scroll tip
 * @private
 */
UCF_Scrollbar["prototype"]["hideScrollTip"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["hideScrollTip"]++; }; 

	UCF_DomUtil["removeFromDom"](this["oDomRefScrollTip"]);

	this["oDomRefScrollTip"] = null;
	this["mAppScrollTipMap"] = null;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["hideScrollTip"] = 0; };

/**
 * Update scroll tip position
 * @private
 */
UCF_Scrollbar["prototype"]["updateScrollTipPosition"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["updateScrollTipPosition"]++; }; 
	var oRectHandle = UCF_DomUtil["oGetObjectRect"](this["oDomRefHandle"], this["oDomRefScrollTip"]["parentNode"] === this["oLS"]["oGetAssociatedAreaRef"]() ? null : this["oDomRefScrollTip"]["parentNode"]),
		oRectScrollTip = this["oGetObjectRect"](this["oDomRefScrollTip"]),
		iScrollTipX = 0,
		iScrollTipY = 0;

	if (this["bIsVertical"]) {
		var oRectScrollBar = UCF_DomUtil["oGetObjectRect"](this["oDomRef"], this["oGetParentScrollAreaDomRef"]());

		if (window["UCF_System"]["bIsRTL"]) {
			iScrollTipX = oRectHandle["left"] + oRectHandle["width"];
		} else {
			iScrollTipX = oRectHandle["left"] - oRectScrollTip["width"];
		}
		iScrollTipY = Math["min"](oRectHandle["top"], oRectScrollBar["top"] + oRectScrollBar["height"] - oRectScrollTip["height"]);
	} else {
		if (window["UCF_System"]["bIsRTL"]) {
			iScrollTipX = oRectHandle["left"] + oRectHandle["width"] - oRectScrollTip["width"];
		} else {
			iScrollTipX = oRectHandle["left"];
		}
		iScrollTipY = oRectHandle["top"] - oRectScrollTip["height"];
	}

	this["oDomRefScrollTip"]["style"]["left"] = iScrollTipX + "px";
	this["oDomRefScrollTip"]["style"]["top"] = iScrollTipY + "px";
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["updateScrollTipPosition"] = 0; };

/**
 * Get scroll tip HTML
 * @return {string}
 * @private
 */
UCF_Scrollbar["prototype"]["sGetScrollTipHtml"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["sGetScrollTipHtml"]++; }; 
	var aScrollTipHtml = [];
	var iScrollRangeBegin = this["iScrollPos"];
	var iScrollRangeEnd = this["iScrollPos"] + this["iScrollClipping"] - 1;
	var aScrollTipTexts = UCF_DomUtil["$"](this["sId"] + "-" + this["FRAGMENT"]["SCROLLTIPS"] + "-texts");

	aScrollTipHtml["push"]("<table id=\"" + this["sId"] + "-part\" class=\"lsScrollbar--dataTip urDataTipStd urDataTipTxt lsDataTip lsDataTip__text lsDataTip__size lsDataTip__extraPadding lsDataTip__textAlign");
	aScrollTipHtml["push"](this["bIsVertical"] ? "Right" : "Left");
	aScrollTipHtml["push"]("\">");

	if (this["mAppScrollTipMap"]) {
		var iLastMatchIndex = -1,
			iTipRangeBegin = -1,
			iTipRangeEnd = -1,
			bShowTipRange = true;

		for (var n in this["mAppScrollTipMap"]) {
			if (iTipRangeBegin == -1 && n > iScrollRangeBegin) {
				iTipRangeBegin = iLastMatchIndex;
				if (!bShowTipRange) break;
			}
			if (iTipRangeEnd == -1 && n > iScrollRangeEnd) {
				iTipRangeEnd = iLastMatchIndex;
				break;
			}

			iLastMatchIndex = n;
		}

		if (iTipRangeBegin == -1) iTipRangeBegin = iLastMatchIndex;
		if (iTipRangeEnd == -1) iTipRangeEnd = iLastMatchIndex;

		aScrollTipHtml["push"]("<tr><td nowrap><b>");
		aScrollTipHtml["push"](aScrollTipTexts["childNodes"][this["mAppScrollTipMap"][iTipRangeBegin]]["innerHTML"]);
		if (bShowTipRange && iTipRangeBegin != iTipRangeEnd) {
			aScrollTipHtml["push"](" - ");
			aScrollTipHtml["push"](aScrollTipTexts["childNodes"][this["mAppScrollTipMap"][iTipRangeEnd]]["innerHTML"]);
		}
		aScrollTipHtml["push"]("</b></td></tr>");
	}

	aScrollTipHtml["push"]("<tr><td nowrap>");

	if (this["bIsVertical"] && this["sScrollTipValueDescription"] == "ROW") {
		aScrollTipHtml["push"](this["oLS"]["sGetText"]("SAPUR_PG_ROW"));
	} else if (!this["bIsVertical"] && this["sScrollTipValueDescription"] == "COL") {
		aScrollTipHtml["push"](this["oLS"]["sGetText"]("SAPUR_PG_COLUMN"));
	} else {
		aScrollTipHtml["push"](this["sScrollTipValueDescription"]);
	}

	aScrollTipHtml["push"](" ");
	aScrollTipHtml["push"](iScrollRangeBegin); //From
	aScrollTipHtml["push"](" - ");
	aScrollTipHtml["push"](iScrollRangeEnd); // To
	aScrollTipHtml["push"](" ");
	aScrollTipHtml["push"](this["oLS"]["sGetText"]("SAPUR_PG_INDEX"));
	aScrollTipHtml["push"](" ");
	aScrollTipHtml["push"](this["iItemCount"]); //of
	aScrollTipHtml["push"]("</td></tr>");

	aScrollTipHtml["push"]("</table>");

	return aScrollTipHtml["join"]("");
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["sGetScrollTipHtml"] = 0; };

/******************************************************
 ** METHODS FOR PixelDirectMode
 *******************************************************/

/**
 * Calculates the displayed ScrollRange which is used for painting the bar.
 * Especially when the scoll position is set, the scrollbar has to be still interactive even whe the scrollrange is smaller than the
 * clipping area
 *
 * @return {number}
 * @private
 */
UCF_Scrollbar["prototype"]["iGetDisplayedScrollRange"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetDisplayedScrollRange"]++; }; 
	return ((this["iScrollPos"] - 1) + this["iScrollClipping"] > this["iScrollRange"]) ?
		(this["iScrollPos"] - 1) + this["iScrollClipping"] : //scrollbar is not zero based
		this["iScrollRange"];
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetDisplayedScrollRange"] = 0; };

/**
 * Serializes the resize event to provide a seuqntial processing
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Scrollbar["prototype"]["onresize"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onresize"]++; }; 
	UCF_JsUtil["feedMassNotificationFilter"](100, this, this, "onClientUpdateResize");
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onresize"] = 0; };

/**
 * Attaches the resize event to the scrollbar
 * @private
 */
UCF_Scrollbar["prototype"]["attachResize"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["attachResize"]++; }; 
	if (this["bPixelDirectMode"] && !this["bAttachedClientUpdateResize"]) {
		this["attachBrowserEvent"]("resize", this["oDomRefBar"]);
		this["bAttachedClientUpdateResize"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["attachResize"] = 0; };

/**
 * Detaches the resize event from the scrollbar
 * @private
 */
UCF_Scrollbar["prototype"]["detachResize"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["detachResize"]++; }; 
	if (this["bAttachedClientUpdateResize"]) {
		this["detachBrowserEvent"]("resize", this["oDomRefBar"]);
		this["bAttachedClientUpdateResize"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["detachResize"] = 0; };

/**
 * This method is called when the scrollbar was resized
 * @private
 */
UCF_Scrollbar["prototype"]["onClientUpdateResize"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onClientUpdateResize"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["ClientUpdateResize"], { "oInternalEventInfo": this["oInternalEventInfo"] });

	if (this["bOptimizedPixelDirectMode"]) {
		//recalc scrollRange again for the case the scrollbar has already been initialized in a hidden dom (display none in tabstripItem realting in no offsetWidth/Height)
		//indicator: this.iScrollRange == iDimensionCorrection
		var oDomRefScrolledElement = UCF_DomUtil["$"](this["sScrolledElementId"]);
		var iDimensionCorrection = parseInt(oDomRefScrolledElement["getAttribute"](this["bIsVertical"] ? "iVScrollContentDimCorrection" : "iHScrollContentDimCorrection"), 10);
		if (this["iScrollRange"] == iDimensionCorrection) {
			var oDomRefScrollContent = UCF_DomUtil["$"](oDomRefScrolledElement["getAttribute"](this["bIsVertical"] ? "sVScrollContentId" : "sHScrollContentId"));
			if (oDomRefScrollContent) {
				this["iScrollRange"] = (this["bIsVertical"] ? oDomRefScrollContent["offsetHeight"] : oDomRefScrollContent["offsetWidth"]) + iDimensionCorrection;
			}
		}

		this["updateDimensions"](this["iScrollRange"], this["bIsVertical"] ? this["oDomRef"]["offsetHeight"] : this["oDomRef"]["offsetWidth"], this["iScrollPos"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["onClientUpdateResize"] = 0; };

/**
 * Returns true if an property and UI update is necessary
 *
 * @param {number} iScrollRange The width/heigt of the whole scrolling range
 * @param {number} iScrollClipping  The width/height of area the ScrollRange is clipped
 * @param {number} iScrollPos The scroll position of the ScrollRange in the ScrollClipping area
 *
 * @return {boolean}
 * @private
 */
UCF_Scrollbar["prototype"]["bIsUpdateNecessary"] = function (iScrollRange, iScrollClipping, iScrollPos) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsUpdateNecessary"]++; }; 
	return iScrollRange != this["iScrollRange"]
		|| iScrollClipping != this["iScrollClipping"]
		|| iScrollPos != this["iScrollPos"];
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsUpdateNecessary"] = 0; };

/**
 * Updates the Scrollbar to the new sizes of the area to scroll
 *
 * @param {number} iScrollRange The width/heigt of the whole scrolling range
 * @param {number} iScrollClipping  The width/height of area the ScrollRange is clipped
 * @param {number} iScrollPos The scroll position of the ScrollRange in the ScrollClipping area
 * @private
 */
UCF_Scrollbar["prototype"]["updateDimensions"] = function (iScrollRange, iScrollClipping, iScrollPos) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["updateDimensions"]++; }; 

	if (this["bIsUpdateNecessary"](iScrollRange, iScrollClipping, iScrollPos)) {
		this["detachResize"]();

		this["updateProperties"](iScrollRange, iScrollClipping, iScrollPos);
		this["paintBar"](-1);

		this["attachResize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["updateDimensions"] = 0; };

/**
 * Calculates if scrollbar is disabled
 *
 * @return {boolean}
 * @private
 */
UCF_Scrollbar["prototype"]["bIsDisabled"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsDisabled"]++; }; 
	return !(
		(this["iScrollRange"] > this["iScrollClipping"] || this["iScrollPos"] > 1 || this["bIsInInteraction"]()) && this["bEnabled"]
	);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["bIsDisabled"] = 0; };

/******************************************************
 * DragRemain methods
 *
 * The DragReamin event is fired when the user remains within his drag operation on a certain position
 * to investigate the currently scrolled section.
 * This can be used to load data if the scolled in section contains no data
 *******************************************************/

/**
 * Cleans the DragRemain module (e.g. call by destructor)
 * @private
 */
UCF_Scrollbar["prototype"]["cleanUpDragRemain"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["cleanUpDragRemain"]++; }; 
	this["resetDragRemain"]();
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["cleanUpDragRemain"] = 0; };

/**
 * Inits the DragRemain module
 * @private
 */
UCF_Scrollbar["prototype"]["initDragRemain"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["initDragRemain"]++; }; 
	this["sDragRemainTimer"] = null;
	this["iRemainLatency"] = 300;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["initDragRemain"] = 0; };

/**
 * Sets the remaining time which lead to event triggering
 * @param {number} iRemainLatency
 * @public
 * @private
 */
UCF_Scrollbar["prototype"]["setRemainLatency"] = function (iRemainLatency) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setRemainLatency"]++; }; 
	this["iRemainLatency"] = iRemainLatency;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setRemainLatency"] = 0; };

/**
 * Resets the DragRemain timer
 * @private
 */
UCF_Scrollbar["prototype"]["resetDragRemain"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["resetDragRemain"]++; }; 
	if (this["sDragRemainTimer"] != null) UCF_JsUtil["clearDelayedCall"](this["sDragRemainTimer"]);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["resetDragRemain"] = 0; };

/**
 * Triggers the DragRemain timer
 * @private
 */
UCF_Scrollbar["prototype"]["checkDragRemain"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["checkDragRemain"]++; }; 
	this["resetDragRemain"]();
	this["sDragRemainTimer"] = UCF_JsUtil["delayedCall"](this["iRemainLatency"], this, "processDragRemain");
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["checkDragRemain"] = 0; };

/**
 * Processes the actual DragRemain event
 * @private
 */
UCF_Scrollbar["prototype"]["processDragRemain"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["processDragRemain"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["DragRemain"], { "oInternalEventInfo": this["oInternalEventInfo"] });
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["processDragRemain"] = 0; };

/******************************************************
 ** Standard control methods
 *******************************************************/

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_Scrollbar["prototype"]["collectFocusInfo"] = function (oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "Scrollbar.js(1780): collectFocusInfo"); };

	oFocusInfo["setApplyControl"](this);

};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["collectFocusInfo"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_Scrollbar["prototype"]["applyFocusInfo"] = function (oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "Scrollbar.js(1792): applyFocusInfo"); };
	//Do nothing: This avoids the scrolling into view when focus comes back
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["applyFocusInfo"] = 0; };

/******************************************************
 ** Used by external access (e.g. drag drop delegates)
 *******************************************************/

/**
 * Returns the maximal scroll position in indices
 *
 * @return {number}
 * @private
 */
UCF_Scrollbar["prototype"]["iGetMaxScrollTo"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetMaxScrollTo"]++; }; 
	return this["iGetDisplayedScrollRange"]() - this["iScrollClipping"] + 1;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetMaxScrollTo"] = 0; };

/**
 * Returns the the first visible itme
 *
 * @return {number}
 * @private
 */
UCF_Scrollbar["prototype"]["iGetFirstVisibleItem"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetFirstVisibleItem"]++; }; 
	return this["iScrollPos"];
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetFirstVisibleItem"] = 0; };

/**
 * Returns the small change
 *
 * @return {number}
 * @private
 */
UCF_Scrollbar["prototype"]["iGetSmallChange"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetSmallChange"]++; }; 
	return this["iSmallChange"];
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetSmallChange"] = 0; };

/**
 * Util to find subindices in the control
 *
 * @parame {string} mFragment a map of strings
 *
 * @return {Object}
 * @private
 */
UCF_Scrollbar["prototype"]["oGetFragmentRef"] = function (mFragment) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["oGetFragmentRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + "-" + mFragment);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["oGetFragmentRef"] = 0; };

/**
 * The maximal position in pixels
 *
 * @return {number}
 * @private
 */
UCF_Scrollbar["prototype"]["iGetMaxPosition"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetMaxPosition"]++; }; 

	var iPxTotal = this["iGetOuterSize"](),
		fPxItemRange = iPxTotal / this["iScrollRange"],
		fPxHandleRange = fPxItemRange * this["iScrollClipping"],
		iPxHandleRange = Math["max"](this["HANDLE_MIN_SIZE"], Math["round"](fPxHandleRange)),
		iPxMaxPosition = iPxTotal - iPxHandleRange - 1;

	return iPxMaxPosition;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetMaxPosition"] = 0; };

/**
 * Returns the height or width of the whole scrollbar in pixel
 *
 * @return {number}
 * @private
 */
UCF_Scrollbar["prototype"]["iGetOuterSize"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetOuterSize"]++; }; 
	//Must not be 0 because outer size can be divisor for some calculations. Prevent "division by zero"
	return Math["max"](this["HANDLE_MIN_SIZE"], this["bIsVertical"] ? this["oDomRefBar"]["offsetHeight"] : this["oDomRefBar"]["offsetWidth"]);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["iGetOuterSize"] = 0; };

/**
 * Touch support
 */

/**
 * Initializes touch support
 * @private
 */
UCF_Scrollbar["prototype"]["initTouchSupport"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["initTouchSupport"]++; }; 
	this["oTouchInfo"] = null;
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["initTouchSupport"] = 0; };

/**
 * Clean up of touch support refrences
 * @private
 */
UCF_Scrollbar["prototype"]["cleanUpTouchSupport"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["cleanUpTouchSupport"]++; }; 
	var oTouchInfo = this["oTouchInfo"];

	if (oTouchInfo) {
		if (oTouchInfo["sDelayedCallTouch"]) UCF_JsUtil["clearDelayedCall"](oTouchInfo["sDelayedCallTouch"]);
		this["oTouchInfo"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["cleanUpTouchSupport"] = 0; };

/**
 * Handles the touch events isolated in its own handle method
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @param {ACCESS_TYPE} eAccessType
 * @param {Object} oAccessInfo
 * @private
 */
UCF_Scrollbar["prototype"]["handleTouchSupport"] = function (oBrowserEvent, eAccessType, oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["handleTouchSupport"]++; }; 
	var iPxPos;
	var iTime;
	var oTouchInfo;

	if (eAccessType == this["ACCESS_TYPE"]["TOUCH_START"]) {
		var oScrolledElement = this["oGetScrolledElement"](),
			iPxItemHeight = 1;
		iTime = new Date()["getTime"]();
		iPxPos = (this["bIsVertical"] ? oBrowserEvent["iPageY"]() : oBrowserEvent["iPageX"]());

		this["stopTouchMomentum"]();

		this["fVelocityFactor"] = 10;
		this["fDurationFactor"] = 40;
		if (oScrolledElement && UCF_JsUtil["bInstanceOf"](oScrolledElement, "UCF_SapTable")) {
			// in case of horizontal server side scrolling the iPxItemHeight can only be estimated
			// as the width of the table divided by the number of visible columns
			// the additional factor 2 was introduced just of a better empiric behaviour
			iPxItemHeight = (this["bIsVertical"] ?
				oScrolledElement["iGetRowHeight"]() : oScrolledElement["sHorizontalScrollUpdateMode"] == oScrolledElement["SCROLL_UPDATE_MODE"]["SERVER"] ?
					Math["floor"](oScrolledElement["oDomRef"]["offsetWidth"] / (2 * oScrolledElement["iVisibleColCount"])) : 1);
			this["fVelocityFactor"] = (this["bIsVertical"] ? 0.8 : 10);
			this["fDurationFactor"] = (this["bIsVertical"] ? 400 : 40);
		}

		this["oTouchInfo"] = {
			"iScrollPosStart": this["iScrollPos"],
			"iPxItemHeight": iPxItemHeight,
			"iPxPosStart": iPxPos,
			"iTimeStart": iTime,
			"iPxPosLast": iPxPos,
			"iTimeLast": iTime,
			"bDirectionPositiveLast": true,
			"fVelocity": 0.0,
			"bHasMomentum": false
		};

	} else if (eAccessType == this["ACCESS_TYPE"]["TOUCH_MOVE"]) {
		oTouchInfo = this["oTouchInfo"];
		if (oTouchInfo) {
			iPxPos = this["bIsVertical"] ? oBrowserEvent["iPageY"]() : oBrowserEvent["iPageX"]();
			iTime = new Date()["getTime"]();
			var iScrollPosAfter = oTouchInfo["iScrollPosStart"] + Math["round"]((oTouchInfo["iPxPosStart"] - iPxPos) / oTouchInfo["iPxItemHeight"]),
				iTimeDelta = Math["min"](10, Math["abs"](iTime - oTouchInfo["iTimeLast"])),
				fVelocity = iTimeDelta ? Math["abs"](oTouchInfo["iPxPosLast"] - iPxPos) / iTimeDelta : 0;

			oTouchInfo["fVelocity"] = this["fVelocityFactor"] * fVelocity + 0.2 * this["oTouchInfo"]["fVelocity"];
			oTouchInfo["bDirectionPositiveLast"] = iPxPos < oTouchInfo["iPxPosLast"];
			oTouchInfo["iPxPosLast"] = iPxPos;
			oTouchInfo["iTimeLast"] = iTime;

			//for touch events set the action alway to DIRECT
			oAccessInfo["eAction"] = this["ACTION"]["DIRECT"];
			this["scrollTo"](oAccessInfo, iScrollPosAfter);
			oAccessInfo["bHandled"] = true;
			if (this["bStartPosition"] && this["iScrollPos"] <= 1) {
				//top reached - do not cancel to let parent controls/elements scroll
				oAccessInfo["bHandled"] = false;
			}
			if (this["bEndPosition"] && this["iScrollPos"] >= this["iGetMaxScrollTo"]()) {
				//bottom reached - do not cancel to let parent controls/elements scroll
				oAccessInfo["bHandled"] = false;
			}
			// only cancel for the case of scrolling has taken place
			// doesn't work because for slow swiping the first/second touchmove does not
			// provide any movement - afterwards canceling of the touchmove event does not take  any effect
			// oAccessInfo.bHandled = iScrollPosBefore != this.iScrollPos;
		}
	} else if (eAccessType == this["ACCESS_TYPE"]["TOUCH_END"]) {
		oTouchInfo = this["oTouchInfo"];

		if (oTouchInfo && oTouchInfo["fVelocity"] > 1.0) {
			this["startTouchMomentum"]();
		} else {
			this["scrollTo"](oAccessInfo, this["iScrollPos"]);
			this["cleanUpTouchSupport"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["handleTouchSupport"] = 0; };

/**
 * When the user touches ,drags the scoll content and releases the touch screen there can be a momentum simulated
 * which let's scolling continuing a slowly eases it out
 * This is the method which starts the momentum simulation.
 * @private
 */
UCF_Scrollbar["prototype"]["startTouchMomentum"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["startTouchMomentum"]++; }; 
	var oTouchInfo = this["oTouchInfo"],
		oTouchMomentumInfo = null,
		oAccessInfo = this["oGetAccessInfo"](null, this["ACCESS_TYPE"]["TOUCH_MOVE"]),
		iDuration = this["fDurationFactor"] * oTouchInfo["fVelocity"],
		iScrollDistance = (oTouchInfo["bDirectionPositiveLast"] ? 0.8 : -0.8) * oTouchInfo["fVelocity"] * oTouchInfo["fVelocity"];

	oTouchInfo["bHasMomentum"] = true;

	oTouchMomentumInfo = {
		"oAccessInfo": oAccessInfo,
		"iTimeStart": oTouchInfo["iTimeLast"],
		"iDuration": iDuration,
		"iScrollDistance": iScrollDistance,
		"iScollStart": this["iScrollPos"],
		"oTouchInfo": oTouchInfo
	};

	oTouchInfo["sDelayedCallTouch"] = UCF_JsUtil["delayedCall"](100, this, "applyTouchMomentum", [oTouchMomentumInfo]);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["startTouchMomentum"] = 0; };

/**
 * Applpies the scoll position calculated by the momentum
 * @private
 */
UCF_Scrollbar["prototype"]["applyTouchMomentum"] = function (oTouchMomentumInfo) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["applyTouchMomentum"]++; }; 
	var iTime = new Date()["getTime"]() - oTouchMomentumInfo["iTimeStart"];

	if (iTime < oTouchMomentumInfo["iDuration"]) {
		var bDirectionPositive = oTouchMomentumInfo["oTouchInfo"]["bDirectionPositiveLast"];
		if ((!bDirectionPositive || !this["bEndPosition"]()) && (bDirectionPositive || !this["bStartPosition"]())) {
			var fTime = iTime / oTouchMomentumInfo["iDuration"],
				iScrollPos = Math["round"](Math["sin"](fTime * Math["PI"] / 2) * oTouchMomentumInfo["iScrollDistance"]) + oTouchMomentumInfo["iScollStart"];

			this["scrollTo"](oTouchMomentumInfo["oAccessInfo"], iScrollPos);

			oTouchMomentumInfo["oTouchInfo"]["sDelayedCallTouch"] = UCF_JsUtil["delayedCall"](100, this, "applyTouchMomentum", [oTouchMomentumInfo]);
			return;
		}
	}

	this["stopTouchMomentum"]();
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["applyTouchMomentum"] = 0; };

/**
 * Stops the momentum
 * @private
 */
UCF_Scrollbar["prototype"]["stopTouchMomentum"] = function () {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["stopTouchMomentum"]++; }; 
	if (this["oTouchInfo"]) {
		if (this["oTouchInfo"]["bHasMomentum"]) this["scrollTo"](this["oGetAccessInfo"](null, this["ACCESS_TYPE"]["TOUCH_END"]), this["iScrollPos"]);
		this["cleanUpTouchSupport"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["stopTouchMomentum"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Scrollbar["prototype"]["aAttributeNames"] = ["iValue","iMaximum","iMinimum","iLargeChange","iSmallChange","sScrollDirection","sScrolledElementId","bShowScrollTip","sScrollTipValueDescription","bEnabled","iItemCount","sCustomData","sVisibility"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Scrollbar["prototype"]["aEventNames"] = ["Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Scrollbar["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_Scrollbar["prototype"]["iValue"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_Scrollbar["prototype"]["iMaximum"] = 100;

/**
 * @private
 * @type {number}
 */
UCF_Scrollbar["prototype"]["iMinimum"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_Scrollbar["prototype"]["iLargeChange"] = 10;

/**
 * @private
 * @type {number}
 */
UCF_Scrollbar["prototype"]["iSmallChange"] = 1;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ScrollDirection}
 */
UCF_Scrollbar["prototype"]["sScrollDirection"] = "VERTICAL";

/**
 * @private
 * @type {string}
 */
UCF_Scrollbar["prototype"]["sScrolledElementId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Scrollbar["prototype"]["bShowScrollTip"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Scrollbar["prototype"]["sScrollTipValueDescription"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Scrollbar["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {number}
 */
UCF_Scrollbar["prototype"]["iItemCount"] = -1;

/**
 * @private
 * @type {string}
 */
UCF_Scrollbar["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Scrollbar["prototype"]["sVisibility"] = "VISIBLE";

//#JSCOVER_EXCL_START
/** @protected */
UCF_Scrollbar["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setDefaultValues"]++; }; 
	this["iValue"] = 0;
	this["iMaximum"] = 100;
	this["iMinimum"] = 0;
	this["iLargeChange"] = 10;
	this["iSmallChange"] = 1;
	this["sScrollDirection"] = "VERTICAL";
	this["sScrolledElementId"] = '';
	this["bShowScrollTip"] = false;
	this["sScrollTipValueDescription"] = '';
	this["bEnabled"] = true;
	this["iItemCount"] = -1;
	this["sCustomData"] = '';
	this["sVisibility"] = "VISIBLE";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Value", 0, true);
		this["setClientProperty"]("Maximum", 100, true);
		this["setClientProperty"]("Minimum", 0, true);
		this["setClientProperty"]("LargeChange", 10, true);
		this["setClientProperty"]("SmallChange", 1, true);
		this["setClientProperty"]("ScrollDirection", "VERTICAL", true);
		this["setClientProperty"]("ScrolledElementId", '', true);
		this["setClientProperty"]("ShowScrollTip", false, true);
		this["setClientProperty"]("ScrollTipValueDescription", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("ItemCount", -1, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
	}
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iValue The new value representing the position of the scrollbar handle
 * @param {string} sAction The action which lead to the scroll event: NONE, PREVIOUS, NEXT, BEGIN, END, NEXT_PAGE, PREVIOUS_PAGE, DIRECT
 * @param {string} sAccess The type of access which lead to the scroll event. SCROLLBAR for a direct scrollbar access and EXTERNAL for a method call from a none-scrollbar control.
 * @param {boolean} bShift True if the SIFT modifier is pressed
 * @param {boolean} bCtrl True if the CTRL modifier is pressed
 * @param {boolean} bAlt True if the ALT modifier is pressed
 * @fires Scrollbar::Scroll
 */
UCF_Scrollbar["prototype"]["fireScroll"] = function(sId, iValue, sAction, sAccess, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, Value: number, Action: string, Access: string, Shift: boolean, Ctrl: boolean, Alt: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 7, "arguments.length == 7", "Scrollbar.js(2195): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Scrollbar.js(2196): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Scrollbar.js(2197): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iValue != null, "iValue != null", "Scrollbar.js(2198): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iValue) == "number", "typeof(iValue) == \"number\"", "Scrollbar.js(2199): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAction != null, "sAction != null", "Scrollbar.js(2200): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAction) == "string", "typeof(sAction) == \"string\"", "Scrollbar.js(2201): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccess != null, "sAccess != null", "Scrollbar.js(2202): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccess) == "string", "typeof(sAccess) == \"string\"", "Scrollbar.js(2203): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "Scrollbar.js(2204): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "Scrollbar.js(2205): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bCtrl != null, "bCtrl != null", "Scrollbar.js(2206): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bCtrl) == "boolean", "typeof(bCtrl) == \"boolean\"", "Scrollbar.js(2207): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAlt != null, "bAlt != null", "Scrollbar.js(2208): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAlt) == "boolean", "typeof(bAlt) == \"boolean\"", "Scrollbar.js(2209): fireScroll"); };
	mParams = {
		"Id": sId,
		"Value": iValue,
		"Action": sAction,
		"Access": sAccess,
		"Shift": bShift,
		"Ctrl": bCtrl,
		"Alt": bAlt
	};
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("Scrollbar", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Scrollbar["_"]["fireScroll"] = 0; };

UCF_Scrollbar.prototype["aPublicMethods"] = ["setRemainLatency"].concat(UCF_Scrollbar.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_SectionHeader"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SectionHeader(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["UCF_SectionHeader"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "SectionHeader.js(30): UCF_SectionHeader"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SectionHeader.js(31): UCF_SectionHeader"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SectionHeader.js(32): UCF_SectionHeader"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["allowTextSelection"]();

	this["initializeHandle"](oDomRef);

	// inplace edit
	if (this["bEditable"]) {
		var oInplaceEditDelegate = this["oInplaceEditDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEditDelegate"))(oLS);

		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this, 'onInplaceEditStart');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this, 'onInplaceEditFinished');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this, 'onInplaceEditClosed');
		this["addDelegate"](oInplaceEditDelegate);
	}
};window["UCF_SectionHeader"] = UCF_SectionHeader; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SectionHeader"); UCF_SectionHeader["_"] = {UCF_SectionHeader: 0}; }; ;
UCF_SectionHeader["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_SectionHeader.prototype["sClassName"] = "UCF_SectionHeader";

UCF_SectionHeader["prototype"]["eStyles"] = {
	"SECTIONHEADER_HOVERABLE": "lsSectionHeader--hoverable"
};

/**
 * Called when Inplace Edit starts
 */

UCF_SectionHeader["prototype"]["onInplaceEditStart"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["onInplaceEditStart"]++; }; 

	var oBoundaries = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);

	this["oInplaceEditDelegate"]["setAlignRight"](this["sAlign"] === 'RIGHT');
	this["oInplaceEditDelegate"]["setInplaceEditData"](
		this["oDomRef"],
		oBoundaries,
		this["sText"]
	);
};;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["onInplaceEditStart"] = 0; };

/**
 * Called when Inplace Edit is finished
 */

UCF_SectionHeader["prototype"]["onInplaceEditFinished"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["onInplaceEditFinished"]++; }; 

	var sText = oParams["oGetParam"]('sText');

	if (sText === this["sText"]) return;

	if (window["UCF_System"]["bIsAria"]) {
		// change -arialabel text
		var oLabelDomRef = UCF_DomUtil["$"](this["sId"] + '-arialabel');

		if (oLabelDomRef) {
			oLabelDomRef["textContent"] = sText + ' ' + this["sTooltip"] + ' ' + this["oLS"]["sGetText"]('SAPUR_ACR_EDIT_TITLE') + ' ' + this["oLS"]["sGetText"]('SAPUR_ACR_LOCK_TITLE');
		}
	}

	var sTextWithAccessKey = new (UCF_ClassLoader["oGetClass"]("UCF_UrBase"))(undefined, this["oLS"])["sAccessKeyTextFragment"](sText, this["sAccessKey"]);

	if (this["bTextOverflow"]) {
		var oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + '-ovfl');
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](this["oDomRef"], UCF_XSSEncoder["encodeHTML"](sTextWithAccessKey));

		if (oDomRefOvfl) {
			// eslint-disable-next-line no-unsanitized/property
			UCF_DomUtil["setInnerHtml"](oDomRefOvfl, UCF_XSSEncoder["encodeHTML"](sText));
			this["oDomRef"]["appendChild"](oDomRefOvfl);
		}
	} else {
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](this["oDomRef"], UCF_XSSEncoder["encodeHTML"](sTextWithAccessKey));
	}

	if (window["UCF_System"]["bIsAria"]) {
		if (oLabelDomRef) {
			this["oDomRef"]["appendChild"](oLabelDomRef);
			oLabelDomRef["textContent"] = sText + ' ' + this["sTooltip"] + ' ' + this["oLS"]["sGetText"]('SAPUR_ACR_EDIT_TITLE') + ' ' + this["oLS"]["sGetText"]('SAPUR_ACR_LOCK_TITLE');
		}
	}
	if (window["UCF_System"]["bIs508"]) {
		// change t attribute value
		this["oDomRef"]["setAttribute"]('t', sText);
	}

	this["sText"] = sText;
	this["setClientProperty"]("Text", this["sText"], true);
	UCF_DomUtil["focusDomElement"](this["oDomRef"]);
	this["fireChange"](this["sId"], sText);
};;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["onInplaceEditFinished"] = 0; };

UCF_SectionHeader["prototype"]["onInplaceEditClosed"] = function() {;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["onInplaceEditClosed"]++; }; 
	UCF_DomUtil["focusDomElement"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["onInplaceEditClosed"] = 0; };

UCF_SectionHeader["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["destroy"]++; }; 

	var oInplaceEditDelegate = this["oInplaceEditDelegate"];

	if (oInplaceEditDelegate) {
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this);
		this["oInplaceEditDelegate"]["destroy"]();
		this["oInplaceEditDelegate"] = null;
	}
	this["sText"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["destroy"] = 0; };

/**
 * Handles the mouseover event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_SectionHeader["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SectionHeader.js(152): onmouseover"); };

	if (oBrowserEvent["bIsMouseHover"]()) {
		if (!UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["SECTIONHEADER_HOVERABLE"])) {
			UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["SECTIONHEADER_HOVERABLE"]);
		}
	} else {
		if (UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["SECTIONHEADER_HOVERABLE"])) {
			UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["SECTIONHEADER_HOVERABLE"]);
		}
	}
	if (window["UCF_System"]["bIs508"]) return;

	var oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + '-ovfl');

	UCF_DomUtil["checkTooltip"](this["oDomRef"], this["sTooltip"], oDomRefOvfl, this["sText"]);

};;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["onmouseover"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 */

UCF_SectionHeader["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["oGetInplaceEditDomRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + '-ovfl') || this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["oGetInplaceEditDomRef"] = 0; };

/**
 * @return { UCF_Control_TouchContextMenuEntry[] }
 * @private
 */
UCF_SectionHeader["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	if (this["bTextOverflow"]) {
		var oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-ovfl');
		if (oTextDomRef && UCF_DomUtil["bHasTextEllipsis"](this["oDomRef"], oTextDomRef)) {
			aResult["push"]({
				"sType": 'TEXT',
				"sText": UCF_DomUtil["removeColon"](UCF_DomUtil["sGetInnerText"](oTextDomRef))
			});
		}
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["aGetTouchContextMenuEntries"] = 0; };

/**
 * Makes the browser selection visible
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the selectstart
 */
UCF_SectionHeader["prototype"]["onselectstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["onselectstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SectionHeader.js(204): onselectstart"); };
	// for touch, cancel text selection
	if (oBrowserEvent["bIsTouchInteraction"]()) {
		oBrowserEvent["oDomEvent"]["returnValue"] = false;
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}

	UCF_Control.prototype["onselectstart"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["onselectstart"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SectionHeader["prototype"]["aAttributeNames"] = ["sText","sTooltip","sVisibility","sAccessKey","bIsDragHandle","bHasUnderline","bEditable","bTextOverflow","sCustomData","sCustomStyle","iHeadingLevel"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SectionHeader["prototype"]["aEventNames"] = ["DoubleClick","Change"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SectionHeader["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_SectionHeader["prototype"]["sText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SectionHeader["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_SectionHeader["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_SectionHeader["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_SectionHeader["prototype"]["bIsDragHandle"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_SectionHeader["prototype"]["bHasUnderline"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_SectionHeader["prototype"]["bEditable"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_SectionHeader["prototype"]["bTextOverflow"] = false;

/**
 * @private
 * @type {string}
 */
UCF_SectionHeader["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SectionHeader["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {number}
 */
UCF_SectionHeader["prototype"]["iHeadingLevel"] = 0;

//#JSCOVER_EXCL_START
/** @protected */
UCF_SectionHeader["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sAccessKey"] = '';
	this["bIsDragHandle"] = false;
	this["bHasUnderline"] = false;
	this["bEditable"] = false;
	this["bTextOverflow"] = false;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["iHeadingLevel"] = 0;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("IsDragHandle", false, true);
		this["setClientProperty"]("HasUnderline", false, true);
		this["setClientProperty"]("Editable", false, true);
		this["setClientProperty"]("TextOverflow", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
	}
};;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires SectionHeader::DoubleClick
 */
UCF_SectionHeader["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "SectionHeader.js(343): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SectionHeader.js(344): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SectionHeader.js(345): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("SectionHeader", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the Label.
 * @param {string} sValue The new label.
 * @fires SectionHeader::Change
 */
UCF_SectionHeader["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "SectionHeader.js(363): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SectionHeader.js(364): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SectionHeader.js(365): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "SectionHeader.js(366): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "SectionHeader.js(367): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("SectionHeader", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_SectionHeader["_"]["fireChange"] = 0; };

};
sap["ls"]["preload"]["UCF_SegmentedButton"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_ControlFactory */
/// <reference path="../core/ControlFactory.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SegmentedButton(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["UCF_SegmentedButton"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef !== null, "oDomRef !== null", "SegmentedButton.js(33): UCF_SegmentedButton"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "SegmentedButton.js(34): UCF_SegmentedButton"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SegmentedButton.js(35): UCF_SegmentedButton"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	/** @type {UCF_Cache} */
	this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
	if (this["sSelectionType"] === 'NONE') return;

	this["attachButtonEvents"]();

	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]);
	this["iCurrentFocusedIndex"] = 0;
	this["createItems"]();
	//this.oItemNavigation.attachEvent(this.oItemNavigation.E_EVENTS.Select, this, 'onItemSelect');
	UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
	this["oItemNavigation"]["setFocusedIndex"](this["oItemNavigation"]["iFocusedIndex"]);
	this["oItemNavigation"]["setNavigateInLoop"](false);
	this["bIsNavigationFirst"] = false;
	this["bIsNavigationLast"] = false;

};window["UCF_SegmentedButton"] = UCF_SegmentedButton; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SegmentedButton"); UCF_SegmentedButton["_"] = {UCF_SegmentedButton: 0}; }; ;
UCF_SegmentedButton["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_SegmentedButton.prototype["sClassName"] = "UCF_SegmentedButton";

/** @returns {void} */
UCF_SegmentedButton["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["initialize"]++; }; 
	this["addAriaAttributes"]();
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["initialize"] = 0; };

/**
 * fires the select event
 *
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_SegmentedButton["prototype"]["onItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onItemSelect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "SegmentedButton.js(72): onItemSelect"); };

	var oItem = oEvent["oGetParam"]("oItem");

	if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Button") && oItem["bEnabled"])
		this["fireSelect"](this["sId"], oItem["sId"]);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onItemSelect"] = 0; };

/**
 * fires the select event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_SegmentedButton["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsenter"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SegmentedButton.js(88): onlsenter"); };
	// The repeated keydown would already "hit" the menu item
	if (oBrowserEvent["bRepeat"]()) {
		return;
	}

	var oItem = oBrowserEvent["oGetSourceControl"]();

	if (oItem && UCF_JsUtil["bInstanceOf"](oItem, "UCF_Button") && oItem["bEnabled"])
		this["fireSelect"](this["sId"], oItem["sId"]);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsenter"] = 0; };

/**
 * fires the select event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_SegmentedButton["prototype"]["onlsspaceup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsspaceup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SegmentedButton.js(107): onlsspaceup"); };
	// The repeated keydown would already "hit" the menu item
	if (oBrowserEvent["bRepeat"]()) {
		return;
	}
	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}
	var oItem = oBrowserEvent["oGetSourceControl"]();

	if (oItem && UCF_JsUtil["bInstanceOf"](oItem, "UCF_Button") && oItem["bEnabled"])
		this["fireSelect"](this["sId"], oItem["sId"]);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsspaceup"] = 0; };

/**@return {UCF_Button[]} */
UCF_SegmentedButton["prototype"]["oGetButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["oGetButtons"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;

	return this["oCache"]["get"]('oButtons', function() {
		return UCF_JsUtil["reduce"](
			UCF_JsUtil["arrayFrom"](UCF_DomUtil["childNodes"](UCF_DomUtil["$"](self["sId"]), 'DIV')),
			function(oButtons, oChildnode) {
				oButtons[oChildnode["id"]] = self["oLS"]["oControlFactory"]["oGetControlByDomRef"](
					oChildnode,
					true
				);

				return oButtons;
			}, {}
		);
	});
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["oGetButtons"] = 0; };

/**
 * @private
 * @return {boolean} `true` if the SegmentedButton is rendered in Toolbar,
 * otherwise `false`
 */
UCF_SegmentedButton["prototype"]["bIsInToolbar"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["bIsInToolbar"]++; }; 
	/** @type {UCF_SegmentedButton} */
	var self = this;

	return this["oCache"]["get"]('bIsInToolbar', function() {
		var oParent = self["oGetParent"]();
		return (oParent && oParent != null && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_Toolbar'));
	});
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["bIsInToolbar"] = 0; };

/**
 * Passes all items that are neccessary for the navigation to the navigation framework
 */
UCF_SegmentedButton["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["createItems"]++; }; 
	var aDomItems = UCF_DomUtil["childNodes"](this["oDomRef"], 'DIV');

	for (var i = 0; i < aDomItems["length"]; i++) {

		var oControlItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[i], true);

		if (oControlItem == null) continue;
		if (oControlItem["bEnabled"] || window["UCF_System"]["bIs508"] || window["UCF_System"]["bIsAria"]) {
			this["oItemNavigation"]["addItem"](oControlItem, oControlItem["bDown"]);
			this["oItemNavigation"]["aItems"][this["oItemNavigation"]["aItems"]["length"] - 1]["iIndex"] = this["oItemNavigation"]["aItems"]["length"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["createItems"] = 0; };

/** @private */
UCF_SegmentedButton["prototype"]["attachButtonEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["attachButtonEvents"]++; }; 
	if (this["sSelectionType"] === 'NONE') return;
	/** @type {UCF_SegmentedButton} */
	var self = this;

	UCF_JsUtil["forEach"](UCF_JsUtil["values"](this["oGetButtons"]()), function(oButton) {
		oButton["attachSemanticEvent"]('Press', self, 'onPress');
	});
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["attachButtonEvents"] = 0; };

/**
 * @private
 * @param {UCF_SemanticEvent} oEvent
 */
UCF_SegmentedButton["prototype"]["onPress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onPress"]++; }; 
	/** @type {string} */
	var sId = oEvent["mGetParameters"]()["Id"];
	/** @type {UCF_Button[]} */
	var oButtons = this["oGetButtons"]();
	/** @type {UCF_SegmentedButton} */
	var self;

	if (this["sSelectionType"] === 'SINGLE') {
		self = this;

		UCF_JsUtil["forEach"](UCF_JsUtil["values"](oButtons), function(oButton) {
			self["setDown"](oButton, oButton["sId"] === sId);
		});
	} else {
		this["setDown"](oButtons[sId], !oButtons[sId]["bDown"]);
	}

	oEvent["mParameters"]["CancelEvent"] = true;

	this["fireChange"](this["sId"], UCF_JsUtil["reduce"](
		UCF_JsUtil["values"](oButtons),
		function(aIds, oB) { return oB["bDown"] ? aIds["concat"]([oB["sId"]]) : aIds; },
		[]
	));
	this["bIsNavigationFirst"] = false;
	this["bIsNavigationLast"] = false;
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onPress"] = 0; };

UCF_SegmentedButton["prototype"]["addAriaAttributes"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["addAriaAttributes"]++; }; 
	if (this["sSelectionType"] === 'NONE') return;
	/** @type {UCF_Button[]} */
	var oButtons = this["oGetButtons"]();
	/**@type {UCF_SegmentedButton} */
	var self = this;

	UCF_JsUtil["forEach"](UCF_JsUtil["values"](oButtons), function(oButton) {
		if (self["sSelectionType"] === 'MULTIPLE') {
			oButton["oDomRef"]["setAttribute"]('aria-describedby', oButton["sId"] + '-ariaDescription');
			oButton["oDomRef"]["setAttribute"]('aria-posinset', oButton["iIndex"]);
			oButton["oDomRef"]["setAttribute"]('aria-setsize', UCF_JsUtil["keys"](oButtons)["length"]);
		}

	});
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["addAriaAttributes"] = 0; };

/**
 * Writes the appropriate accessibility text into the tooltip
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SegmentedButton["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SegmentedButton.js(244): onlsaccessibility"); };

	oAccessibilityHelper["applyContainerEntryBehaviour"]();

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsaccessibility"] = 0; };

/**
 * @private
 * @param {UCF_Button} oButton
 * @param {boolean} bDown
 */
UCF_SegmentedButton["prototype"]["setDown"] = function(oButton, bDown) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["setDown"]++; }; 
	oButton["bDown"] = bDown;

	if (bDown) {
		UCF_DomUtil["replaceClass"](oButton["oDomRef"], 'lsButton--up', 'lsButton--down');
		oButton["oDomRef"]["setAttribute"]('aria-selected', 'true');
	} else {
		UCF_DomUtil["replaceClass"](oButton["oDomRef"], 'lsButton--down', 'lsButton--up');
		oButton["oDomRef"]["setAttribute"]('aria-selected', 'false');
	}
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["setDown"] = 0; };

/**
 * Handles the tabnext (go to next control)
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsprevious
 */
UCF_SegmentedButton["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlstabnext"]++; }; 
	if (this["sSelectionType"] === 'NONE') return;
	this["handleSkipForward"](oBrowserEvent);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlstabnext"] = 0; };

/**
 * Handles the tabpreviousm(go to previous control)
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsprevious
 */
UCF_SegmentedButton["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlstabprevious"]++; }; 
	if (this["sSelectionType"] === 'NONE') return;
	this["handleSkipBack"](oBrowserEvent);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlstabprevious"] = 0; };

/**
 * [LEFT] Key
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_SegmentedButton
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_SegmentedButton["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsleft"]++; }; 

	if (this["bIsInToolbar"]() && this["oItemNavigation"]["bIsFirstFocused"]())
		this["bIsNavigationFirst"] = true;

	if (!this["bIsNavigationFirst"]) {
		oBrowserEvent["cancelBubble"]();
	} else
		this["bIsNavigationFirst"] = false;

	this["bIsNavigationLast"] = false;
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsleft"] = 0; };

/**
 * [UP] Key
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_SegmentedButton
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_SegmentedButton["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsup"]++; }; 
	this["onlsleft"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsup"] = 0; };

/**
 * [DOWN] Key
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_SegmentedButton
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_SegmentedButton["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsdown"]++; }; 
	this["onlsright"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsdown"] = 0; };

/**
 * [LEFT] / [UP] Key
 * Avoid bubbling into a control that nests the toolbar.
 * I.e.UCF_SegmentedButton
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_SegmentedButton["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsprevious"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsprevious"] = 0; };

/**
 * [RIGHT] / [DOWN] Key
 * Avoid bubbling into a control that nests the toolbar.
 * I.e.UCF_SegmentedButton
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_SegmentedButton["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsnext"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsnext"] = 0; };

/**
 * [RIGHT] Key
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_SegmentedButton
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_SegmentedButton["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsright"]++; }; 

	if (this["bIsInToolbar"]() && this["oItemNavigation"]["bIsLastFocused"]())
		this["bIsNavigationLast"] = true;

	if (!this["bIsNavigationLast"]) {
		oBrowserEvent["cancelBubble"]();
	} else
		this["bIsNavigationLast"] = false;

	this["bIsNavigationFirst"] = false;
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsright"] = 0; };

/**
 * Focus the first item
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_SegmentedButton["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlshome"]++; }; 
	this["onlsleft"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlshome"] = 0; };

/**
 * Focus the last item
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_SegmentedButton["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsend"]++; }; 
	this["onlsright"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsend"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_SegmentedButton["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsskipforward"]++; }; 
	if (this["sSelectionType"] === 'NONE') return;
	this["handleSkipForward"](oBrowserEvent);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_SegmentedButton["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsskipback"]++; }; 
	if (this["sSelectionType"] === 'NONE') return;
	this["handleSkipBack"](oBrowserEvent);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["onlsskipback"] = 0; };

/** @override */
UCF_SegmentedButton["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["destroy"]++; }; 
	if (this["sSelectionType"] !== 'NONE') {
		UCF_JsUtil["forEach"](UCF_JsUtil["values"](this["oGetButtons"]()), function(oButton) {
			oButton["destroy"]();
		});
	}

	this["oCache"]["destroy"]();
	this["oCache"] = null;
	this["iCurrentFocusedIndex"] = null;
	if (this["oItemNavigation"]) {
		this["oItemNavigation"]["destroy"]();
		this["oItemNavigation"] = null;
	}
	this["bIsNavigationFirst"] = null;
	this["bIsNavigationLast"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["destroy"] = 0; };

/**
 * @protected
 * @return {Object}
 */
UCF_SegmentedButton["prototype"]["oGetJSON"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["oGetJSON"]++; }; 
	var oButtons = this["oGetButtons"]();
	var aButtons = [];
	UCF_JsUtil["forEach"](UCF_JsUtil["values"](oButtons), function(oButton) {
		aButtons["push"](oButton["oGetJSON"]());
	});
	var oResult = UCF_Control.prototype["oGetJSON"]["apply"](this, arguments);
	oResult['SegmentedButton'] = UCF_JsUtil["extend"](oResult['SegmentedButton'], { "Buttons": aButtons });
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["oGetJSON"] = 0; };

/**
 * Return true if the button is hidden in toolbar
 * @return {boolean} - true if the button is hidden in toolbar
 * @private
 */
UCF_SegmentedButton["prototype"]["bIsHiddenToolbarButton"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["bIsHiddenToolbarButton"]++; }; 
	var oParent = this["oGetParent"]();
	if (oParent && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_Toolbar')) {
		var sToolbarItemId = UCF_DomUtil["sGetAttribute"](this["oDomRef"], 'data-toolbaritem-id');
		var oToolbarItemDomRef = (sToolbarItemId ? UCF_DomUtil["$"](sToolbarItemId) : null) || this["oRootRef"];
		return !oParent["bIsVisibleItem"](oToolbarItemDomRef);
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["bIsHiddenToolbarButton"] = 0; };

/**
 * Focus the Toolbar if the SegmentedButton is hidden in ToolbarOverflow
 */
UCF_SegmentedButton["prototype"]["focusParent"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["focusParent"]++; }; 

	var oParent = this["oGetParent"]();
	if (oParent && UCF_JsUtil["bInstanceOf"](oParent, 'UCF_Toolbar') && this["bIsHiddenToolbarButton"]()) {
		oParent["setFocusFromHiddenItem"](true);
		oParent["moveFocus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["focusParent"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SegmentedButton["prototype"]["aAttributeNames"] = ["sVisibility","sWidth","sHeight","sSelectionType"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SegmentedButton["prototype"]["aEventNames"] = ["Change"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SegmentedButton["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_SegmentedButton["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_SegmentedButton["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SegmentedButton["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SegmentedButtonSelectionType}
 */
UCF_SegmentedButton["prototype"]["sSelectionType"] = "SINGLE";

//#JSCOVER_EXCL_START
/** @protected */
UCF_SegmentedButton["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sWidth"] = '';
	this["sHeight"] = '';
	this["sSelectionType"] = "SINGLE";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("SelectionType", "SINGLE", true);
	}
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId 
 * @param {Array<any>} sSelectedIds 
 * @fires SegmentedButton::Change
 */
UCF_SegmentedButton["prototype"]["fireChange"] = function(sId, sSelectedIds) {;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["fireChange"]++; }; 
	/** @type {{Id: string, SelectedIds: Array<any>}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "SegmentedButton.js(563): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SegmentedButton.js(564): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SegmentedButton.js(565): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSelectedIds != null, "sSelectedIds != null", "SegmentedButton.js(566): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSelectedIds) == "object", "typeof(sSelectedIds) == \"object\"", "SegmentedButton.js(567): fireChange"); };
	mParams = {
		"Id": sId,
		"SelectedIds": sSelectedIds
	};
	
	
	this["fireSemanticEvent"]("SegmentedButton", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButton["_"]["fireChange"] = 0; };

};
sap["ls"]["preload"]["UCF_SegmentedButtonDropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * @class
 * @param {UCF_Control} oSegmentedButton
 * @param {UCF_LS} oLS
 */
function UCF_SegmentedButtonDropDecorator(oSegmentedButton, oLS) {if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDecorator["_"]["UCF_SegmentedButtonDropDecorator"]++; }; 
	UCF_LineDecorator["apply"](this, [oSegmentedButton, true]);
	this["oLS"] = oLS;
};window["UCF_SegmentedButtonDropDecorator"] = UCF_SegmentedButtonDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SegmentedButtonDropDecorator"); UCF_SegmentedButtonDropDecorator["_"] = {UCF_SegmentedButtonDropDecorator: 0}; }; ;

UCF_SegmentedButtonDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(); UCF_SegmentedButtonDropDecorator.prototype["sClassName"] = "UCF_SegmentedButtonDropDecorator";

/** @param {UCF_BrowserEvent} oBrowserEvent */
UCF_SegmentedButtonDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDecorator["_"]["update"]++; }; 

	//var oItem = oBrowserEvent.oGetSourceControl();

	var oItemDomRef = UCF_DomUtil["$"](this["oControl"]["sId"]),
		oItemRect = UCF_DomUtil["oGetObjectRect"](oItemDomRef);

	this["setBounds"](oItemRect["left"], oItemRect["top"], oItemRect["length"]);
	this["show"]();
};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDecorator["_"]["update"] = 0; };

UCF_SegmentedButtonDropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDecorator["_"]["oGetDropLocation"]++; }; 
	if (this["sItemId"] === null) return null;
	else return {
		"sItemId": this["sItemId"],
		"iOffset": this["iOffset"]
	};
};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDecorator["_"]["oGetDropLocation"] = 0; };

/**
 * destructor
 */
UCF_SegmentedButtonDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDecorator["_"]["destroy"]++; }; 

	this["oLS"] = null;
	UCF_LineDecorator.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_SegmentedButtonDropDelegate"] = function() {/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_SegmentedButtonDropDecorator */
/// <reference path="../decorators/SegmentedButtonDropDecorator.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_SegmentedButtonDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDelegate["_"]["UCF_SegmentedButtonDropDelegate"]++; }; 
	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);
	this["oLS"] = oLS;
};window["UCF_SegmentedButtonDropDelegate"] = UCF_SegmentedButtonDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SegmentedButtonDropDelegate"); UCF_SegmentedButtonDropDelegate["_"] = {UCF_SegmentedButtonDropDelegate: 0}; }; ;

UCF_SegmentedButtonDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_SegmentedButtonDropDelegate.prototype["sClassName"] = "UCF_SegmentedButtonDropDelegate";

UCF_SegmentedButtonDropDelegate["prototype"]["oCreateDropDecorator"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDelegate["_"]["oCreateDropDecorator"]++; }; 
	if (!this["oDropDecorator"])
		this["oDropDecorator"] = new (UCF_ClassLoader["oGetClass"]("UCF_SegmentedButtonDropDecorator"))(this["oDropTargetControl"], this["oLS"]);

	return this["oDropDecorator"];
};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDelegate["_"]["oCreateDropDecorator"] = 0; };

UCF_SegmentedButtonDropDelegate["prototype"]["oGetDropLocation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDelegate["_"]["oGetDropLocation"]++; }; 
	if (this["oDropDecorator"]) {
		return this["oDropDecorator"]["oGetDropLocation"]();
	} else {
		return undefined;
	}
};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDelegate["_"]["oGetDropLocation"] = 0; };

UCF_SegmentedButtonDropDelegate["prototype"]["onlsdrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDelegate["_"]["onlsdrop"]++; }; 

	var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"];

	if (oDragSession["sGetDragData"]() === undefined) {
		this["fGetDropCallBack"](oDragSession)["apply"](this, [oBrowserEvent["oGetSource"]()["innerHTML"], 'text/html']);
	} else {
		UCF_DropDelegate.prototype["onlsdrop"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDelegate["_"]["onlsdrop"] = 0; };

UCF_SegmentedButtonDropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function(sDragData, sMimeType) {

		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY
		);
	};

};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDelegate["_"]["fGetDropCallBack"] = 0; };

UCF_SegmentedButtonDropDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDelegate["_"]["destroy"]++; }; 
	if (this["oDropDecorator"]) {
		this["oDropDecorator"]["destroy"]();
		this["oDropDecorator"] = null;
	}
	UCF_DropDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonDropDelegate["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_SegmentedButtonGroup"] = function() {/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>

/** @class
 *
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SegmentedButtonGroup(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SegmentedButtonGroup["_"]["UCF_SegmentedButtonGroup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef !== null, "oDomRef !== null", "SegmentedButtonGroup.js(33): UCF_SegmentedButtonGroup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "SegmentedButtonGroup.js(34): UCF_SegmentedButtonGroup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SegmentedButtonGroup.js(35): UCF_SegmentedButtonGroup"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	/** @type {UCF_Cache} */
	this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

};window["UCF_SegmentedButtonGroup"] = UCF_SegmentedButtonGroup; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SegmentedButtonGroup"); UCF_SegmentedButtonGroup["_"] = {UCF_SegmentedButtonGroup: 0}; }; ;

UCF_SegmentedButtonGroup["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_SegmentedButtonGroup.prototype["sClassName"] = "UCF_SegmentedButtonGroup";

/** @return {void} */
UCF_SegmentedButtonGroup["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonGroup["_"]["initialize"]++; }; 
	// console.log('this.id = ' + this.sId);
	// console.log(this.aGetSegments());
	console["log"](this["aGetCheckedSegments"]());
};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonGroup["_"]["initialize"] = 0; };

UCF_SegmentedButtonGroup["prototype"]["aGetSegments"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonGroup["_"]["aGetSegments"]++; }; 
	/** @type {UCF_SegmentedButtonGroup} */
	var self = this;

	return this["oCache"]["get"]('aSegments', function() {
		return UCF_DomUtil["querySelectorAll"]("ul[id='" + self["sId"] + "']>li");
		// return UCF_JsUtil.map(
		// 	UCF_DomUtil.querySelectorAll("ul[id='" + self.sId + "']>li"),
		// 	function(oChildnode) {
		// 		return {
		// 			oDomRef: oChildnode,
		// 			sValue: UCF_DomUtil.$(oChildnode.id).firstChild.value
		// 			bIsChecked: UCF_DomUtil.$(oChildnode.id).firstChild.checked
		// 		};
		// 	}
		// );
	});
};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonGroup["_"]["aGetSegments"] = 0; };

UCF_SegmentedButtonGroup["prototype"]["aGetCheckedSegments"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonGroup["_"]["aGetCheckedSegments"]++; }; 
	/** @type {Array} */
	var aSegments = this["aGetSegments"]();
	/** @type {Array} */
	var aCheckedSegments = [];


	return this["oCache"]["get"]('aCheckedSegments', function() {
		for (var i = 0; i < aSegments["length"]; i++) {
			if (UCF_DomUtil["$"](aSegments[i]["id"])["firstChild"]["checked"]) {
				aCheckedSegments["push"](aSegments[i]);
			}
		};
		return aCheckedSegments;
	});
};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonGroup["_"]["aGetCheckedSegments"] = 0; };

UCF_SegmentedButtonGroup["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SegmentedButtonGroup["_"]["destroy"]++; }; 
	this["oCache"]["destroy"]();
	this["oCache"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SegmentedButtonGroup["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_SelectListBox"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemListBox_ie6 */
/// <reference path="./base/ItemListBox_ie6.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_ItemListBoxDragDelegate */
/// <reference path="./delegates/ItemListBoxDragDelegate.js"/>
/* global UCF_ItemListBoxDropDelegate */
/// <reference path="./delegates/ItemListBoxDropDelegate.js"/>

/**
 * SelectListBox
 *
 * 
 * @class UCF_SelectListBox
 * @extends UCF_ItemListBox
 * @param {HTMLElement} oDomRef the DOM element that represents the control
 * @param {UCF_LS} oLS the LightSpeed instance that manages the control
 */
function UCF_SelectListBox(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["UCF_SelectListBox"]++; }; 
	if (arguments["length"] > 0) {
		UCF_ItemListBox_ie6["apply"](this, [oDomRef, oLS]);

		/** @type {UCF_ItemListBoxItem} currently focussed item */
		this["oFocussedItem"] = null;

		/** @type {number} timer for select event */
		this["iSelectTimerId"] = null;

		/** @type {string} keyboard input for finding items */
		this["sSearchString"] = '';

		/** @type {string} start key for range selection */
		this["sStartKey"] = null;

		/**
		 * @type {boolean} flag to initialize the tabindex of the item listbox
		 * only once
		 */
		this["bTabIndexInitialized"] = false;

		/** @type {boolean} flag to know if the selection has changed */
		this["bSelectionChanged"] = false;

		/**
		 * @type {boolean} flag to know if the click event is already handled in
		 * mousedown
		 */
		this["bClickHandled"] = false;

		/** @type {boolean} */
		this["bTouchstartSelected"] = false;

		// generic scroll area
		this["oScrollArea"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(UCF_DomUtil["$"](this["sId"])); // eslint-disable-line @ur/no-memory-leaks
		this["oScrollArea"]["enableDragScrolling"](this["sDropTargetInfo"] ? true : false);
		this["oScrollArea"]["attachEvent"](
			this["oScrollArea"]["E_EVENTS"]["Scroll"],
			this,
			'onAreaScroll'
		);
		this["addDelegate"](this["oScrollArea"]);
		this["attachBrowserEvent"]('scroll', this["oDomRef"]);
	}
};window["UCF_SelectListBox"] = UCF_SelectListBox; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SelectListBox"); UCF_SelectListBox["_"] = {UCF_SelectListBox: 0}; }; ;
UCF_SelectListBox["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemListBox_ie6"))(); UCF_SelectListBox.prototype["sClassName"] = "UCF_SelectListBox";

/**
 * Initialize width, height and scroll position
 */
UCF_SelectListBox["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["initialize"]++; }; 
	/** @type {number} */
	var iOffsetWidthBefore = this["oDomRef"]["offsetWidth"];
	/** @type {number} */
	var iOffsetHeightBefore = this["oDomRef"]["offsetHeight"];

	this["applyHeight"]();
	this["applyWidth"]();

	if (UCF_UserAgent["bIsFirefox"]()) {
		UCF_JsUtil["delayedCall"](
			200, // eslint-disable-line no-magic-numbers
			this["oScrollArea"],
			'setScrollPosition', [this["iScrollTop"], 0]
		);
	} else {
		this["oScrollArea"]["setScrollPosition"](this["iScrollTop"], 0);
	}

	if (
		iOffsetWidthBefore !== this["oDomRef"]["offsetWidth"] ||
		iOffsetHeightBefore !== this["oDomRef"]["offsetHeight"]
	) {
		this["notifyLayoutChange"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["initialize"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_SelectListBox["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["destroy"]++; }; 
	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	this["oDomRef"] = null;
	this["oFocussedItem"] = null;

	this["iSelectTimerId"] = null;
	this["iLastKeypress"] = null;

	this["sSearchString"] = null;
	this["sStartKey"] = null;
	this["sTooltip"] = null;

	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}

	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}

	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}

	UCF_ItemListBox_ie6.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["destroy"] = 0; };

/**
 * @see UCF_Control
 * @param {UCF_FocusInfo} oFocusInfo the focus info
 */
UCF_SelectListBox["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oFocusInfo, 'UCF_FocusInfo'), "UCF_JsUtil.bInstanceOf(oFocusInfo, 'UCF_FocusInfo')", "SelectListBox.js(153): collectFocusInfo"); };

	oFocusInfo["setApplyControl"](this);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["collectFocusInfo"] = 0; };

/**
 * @see UCF_Control
 * @param {UCF_FocusInfo} oFocusInfo the focus info
 */
UCF_SelectListBox["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["applyFocusInfo"]++; }; 
	/** @type {UCF_Control} */
	var oFocussedControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oFocusInfo, 'UCF_FocusInfo'), "UCF_JsUtil.bInstanceOf(oFocusInfo, 'UCF_FocusInfo')", "SelectListBox.js(166): applyFocusInfo"); };

	oFocussedControl = this["oLS"]["oControlFactory"]["oGetControlById"](
		oFocusInfo["sGetFocussedId"]()
	);

	this["focusItem"](this["oGetFirstSelectedItem"]()
		|| this["oGetFirstItem"]()
		|| (
			UCF_JsUtil["bInstanceOf"](oFocussedControl, 'UCF_ItemListBoxItem') &&
			oFocussedControl
		)
	);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["applyFocusInfo"] = 0; };

/**
 * Fires the scroll event
 *
 * @param {UCF_Event} oEvent the area scroll event
 */
UCF_SelectListBox["prototype"]["onAreaScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onAreaScroll"]++; }; 
	/** @type {number} */
	var iScrollTop = oEvent["oGetParam"]('iScrollTop');

	if (iScrollTop > 0) {
		this["fireScroll"](this["sId"], iScrollTop);
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onAreaScroll"] = 0; };

/**
 * Handles the onlsfocus event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_SelectListBox["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(202): onlsfocus"); };

	if (!this["bTabIndexInitialized"] && oBrowserEvent["oSource"] === this["oDomRef"]) {
		this["focusItem"](this["oGetFirstSelectedItem"]() || this["oGetFirstItem"]());
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsfocus"] = 0; };

/**
 * Handles the onmousedown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the mousedown
 * @private
 */
UCF_SelectListBox["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onmousedown"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(219): onmousedown"); };

	// handle click in mousedown for dragging
	if (this["sDragSourceInfo"]) {
		if (oBrowserEvent && oBrowserEvent["bIsTouchInteraction"]()) {
			if (!this["bOnDragHandle"](oBrowserEvent)) {
				this["handleSelection"](oBrowserEvent);
				this["bClickHandled"] = true;
			}
		} else if (oBrowserEvent["eGetMouseButtonState"]() ===
			oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"]
		) {
			oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);

			if (oItem &&
				(!this["iGetSelectedItemCount"]() > 1 ||
					oBrowserEvent["oDomEvent"]["shiftKey"] ||
					!oItem["bIsSelected"]())
			) {
				this["bClickHandled"] = true;
				this["handleClick"](oBrowserEvent);
			}
		} else {
			this["bClickHandled"] = true;
		}

	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onmousedown"] = 0; };

/**
 * Handles the onclick event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that
 * occurred
 * @private
 */
UCF_SelectListBox["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(256): onclick"); };

	// click is handled in mousedown for dragging
	if (this["bClickHandled"]) {
		this["bClickHandled"] = false;
	} else {
		this["handleClick"](oBrowserEvent);
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onclick"] = 0; };

/**
 * Handles the click event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that
 * occurred
 * @private
 */
UCF_SelectListBox["prototype"]["handleClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["handleClick"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;
	/** @type {Array.<string>} */
	var aKeys;
	/** @type {boolean} */
	var bIsCtrlAndMultipleSelection;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(283): handleClick"); };

	if (this["bIsWriteable"]()) {
		oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);

		if (oItem) {
			if (this["bMultipleSelection"] && oBrowserEvent["oDomEvent"]["shiftKey"]) {
				aKeys = this["aGetSelectedKeys"]();

				this["sStartKey"] = this["sStartKey"]
					|| (aKeys && aKeys["length"] > 0 && aKeys[aKeys["length"] - 1])
					|| oItem["sKey"];

				this["selectItemRange"](this["sStartKey"], oItem["sKey"]);
			} else {
				bIsCtrlAndMultipleSelection = this["bMultipleSelection"] &&
					oBrowserEvent["bCtrl"]();

				// initialize start key for range selection
				this["sStartKey"] = oItem["sKey"];
				this["selectItem"](
					oItem, !(bIsCtrlAndMultipleSelection && oItem["bIsSelected"]()), !bIsCtrlAndMultipleSelection
				);
			}

			this["focusItem"](oItem);

			if (this["bSelectionChanged"]) {
				this["fireSelectEvent"](false); // fire select event directly
			}
		}
	}

};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["handleClick"] = 0; };

/**
 * Handles the onlsselect event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_SelectListBox["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsselect"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;
	/** @type {boolean} */
	var bClear;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(330): onlsselect"); };

	if (this["bIsWriteable"]()) {
		oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);
		bClear = true;

		if (oItem) {
			if (this["bMultipleSelection"] && oBrowserEvent["bCtrl"]()) {
				bClear = false;
			}

			this["selectItem"](oItem, !oItem["bIsSelected"](), bClear);
			this["focusItem"](oItem);
			this["fireSelectEvent"](true); // fire select event delayed

			// cancel default behaviour and bubbling
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	}

};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsselect"] = 0; };

/**
 * Handles the onlsselectmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the lsselectmodifier
 * @private
 */
UCF_SelectListBox["prototype"]["onlsselectmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsselectmodifier"]++; }; 
	this["onlsselect"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsselectmodifier"] = 0; };

/**
 * Handles the onlshome event: The onlshome event is fired when you press home.
 * If the item listbox is enabled and does not have the read only state, the
 * first item is selected.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the lshome
 * @private
 */
UCF_SelectListBox["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlshome"]++; }; 
	this["handleLsHomeEnd"](oBrowserEvent, true);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlshome"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the lshome/lsend
 * @param {boolean} bIsStart `true` to select the first item, `false` for the
 * last
 */
UCF_SelectListBox["prototype"]["handleLsHomeEnd"] = function(oBrowserEvent, bIsStart) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["handleLsHomeEnd"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(384): handleLsHomeEnd"); };

	oItem = bIsStart ? this["oGetFirstItem"]() : this["oGetLastItem"]();

	if (!this["bReadonly"] &&
		!(this["bMultipleSelection"] && oBrowserEvent["bCtrl"]())
	) {
		this["selectItem"](oItem, true, true);
	}

	this["focusItem"](oItem);
	this["fireSelectEvent"](true); // fire select event delayed

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["handleLsHomeEnd"] = 0; };

/**
 * Handles the onlstop event:
 * The onlstop event is fired when you press home and the Control key.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the lstop
 * @private
 */
UCF_SelectListBox["prototype"]["onlstop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlstop"]++; }; 
	this["onlshome"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlstop"] = 0; };

/**
 * Handles the onlsend event:
 * The onlsend event is fired when you press end. If the item istbox is enabled
 * and does not have the read only state, the last item is selected.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the lsend
 * @private
 */
UCF_SelectListBox["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsend"]++; }; 
	this["handleLsHomeEnd"](oBrowserEvent, false);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsend"] = 0; };

/**
 * Handles the onlsbottom event:
 * The onlsbottom event is fired when you press end and the Control key.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the lsbottom
 * @private
 */
UCF_SelectListBox["prototype"]["onlsbottom"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsbottom"]++; }; 
	this["onlsend"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsbottom"] = 0; };

/**
 * Handles the onlspagedown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the lspagedown
 * @private
 */
UCF_SelectListBox["prototype"]["onlspagedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlspagedown"]++; }; 
	this["handleLsPageUpDown"](oBrowserEvent, false);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlspagedown"] = 0; };

/**
 * Handles the onlspageup event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lspageup
 */
UCF_SelectListBox["prototype"]["onlspageup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlspageup"]++; }; 
	this["handleLsPageUpDown"](oBrowserEvent, true);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlspageup"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the lspageup/lspagedown
 * @param {boolean} bIsUp `true` to select the previous item, `false` to select
 * the next
 */
UCF_SelectListBox["prototype"]["handleLsPageUpDown"] = function(oBrowserEvent, bIsUp) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["handleLsPageUpDown"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItemBefore;
	/** @type {UCF_ItemListBoxItem} */
	var oItemAfter;
	/** @type {Array.<UCF_ItemListBoxItem>} */
	var aItems = this["aGetItems"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(468): handleLsPageUpDown"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof bIsUp === 'boolean', "typeof bIsUp === 'boolean'", "SelectListBox.js(469): handleLsPageUpDown"); };

	if (this["bEnabled"]) {
		oItemBefore = this["oGetItemFromBrowserEvent"](oBrowserEvent);

		if (oItemBefore) {
			oItemAfter = aItems[Math["min"](
				aItems["length"] - 1,
				Math["max"](
					0,
					oItemBefore["oDomRef"]["rowIndex"] +
					(this["iVisibleItems"] - 1) * (bIsUp ? -1 : 1)
				)
			)];

			if (oItemAfter) {
				if (this["bIsWriteable"]()) {
					this["selectItem"](oItemAfter, true, true);
				}
				this["focusItem"](oItemAfter);
			}

			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["handleLsPageUpDown"] = 0; };

/**
 * Handles the onkeydown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the keydown
 * @private
 */
UCF_SelectListBox["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onkeydown"]++; }; 
	/** @type {number} */
	var iKeyCode;
	/** @type {UCF_ItemListBoxItem} */
	var oNewItem;
	/** @type {boolean} */
	var bSelect;
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(513): onkeydown"); };

	iKeyCode = oBrowserEvent["iKeyCode"]();
	oNewItem = null;
	bSelect = true;
	oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent) || this["oFocussedItem"];

	// arrow up and down
	if (iKeyCode === UCF_KeyCodes["ARROW_UP"] ||
		iKeyCode === UCF_KeyCodes["ARROW_DOWN"]
	) {
		oNewItem = iKeyCode === UCF_KeyCodes["ARROW_UP"]
			? this["oGetPreviousItem"](oItem)
			: this["oGetNextItem"](oItem);

		// do nothing if you are on top or on bottom of the list
		if (oItem !== oNewItem) {
			if (!this["bIsWriteable"]()) {
				this["focusItem"](oNewItem);
			} else if (oBrowserEvent["bShift"]()) {
				bSelect = !oNewItem["bIsSelected"]();
				this["selectItem"](
					bSelect ? oNewItem : oItem, bSelect, !this["bMultipleSelection"]
				);
				this["focusItem"](oNewItem);
				this["fireSelectEvent"](true); // fire select event delayed
			} else if (oBrowserEvent["bCtrl"]() && this["bMultipleSelection"]) {
				this["focusItem"](oNewItem);
			} else {
				this["selectItem"](oNewItem, bSelect, true);
				this["sStartKey"] = oNewItem["sKey"];
				this["focusItem"](oNewItem);
				this["fireSelectEvent"](true); // fire select event delayed
			}
		}

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onkeydown"] = 0; };

/**
 * Handles the onclick event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_SelectListBox["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "SelectListBox.js(561): ondblclick"); };

	if (this["mEvents"]["DoubleClick"] && this["bIsWriteable"]()) {
		this["fireDoubleClick"](this["sId"], this["aGetSelectedKeys"]());
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["ondblclick"] = 0; };

/**
 * Handles the onkeypress event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_SelectListBox["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onkeypress"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);
	/** @type {string} */
	var cKey = String["fromCharCode"](oBrowserEvent["iKeyCode"]());
	/** @type {number} */
	var iNow;
	/** @type {UCF_ItemListBoxItem} */
	var oNewItem;

	if (this["iLastKeypress"]) {
		iNow = new Date()["getTime"]();
		// eslint-disable-next-line no-magic-numbers
		if (iNow - this["iLastKeypress"] > 250) {
			this["sSearchString"] = '';
		}
		this["iLastKeypress"] = iNow;
	} else {
		this["iLastKeypress"] = new Date()["getTime"]();
	}
	this["sSearchString"] += cKey;

	oNewItem = this["oFindItem"](this["sSearchString"], oItem);

	if (oNewItem) {
		this["selectItem"](oNewItem, true, true);
		this["focusItem"](oNewItem);
		this["fireSelectEvent"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onkeypress"] = 0; };

/**
 * @private
 * @return {UCF_ItemListBoxItem} the first selected item
 */
UCF_SelectListBox["prototype"]["oGetFirstSelectedItem"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["oGetFirstSelectedItem"]++; }; 
	return UCF_JsUtil["find"](
		this["aGetItems"](),
		function(oItem) { return oItem["bIsSelected"](); }
	);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["oGetFirstSelectedItem"] = 0; };

/**
 * Get value column of an item
 *
 * @private
 * @param {HTMLElement} oItem item
 * @return {HTMLElement} value column of an item
 */
UCF_SelectListBox["prototype"]["oGetItemValueColumn"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["oGetItemValueColumn"]++; }; 
	return UCF_JsUtil["find"](
		UCF_JsUtil["arrayFrom"](UCF_DomUtil["$"](oItem["id"])["childNodes"]),
		function(oRef) {
			return UCF_DomUtil["bHasClass"](oRef, 'lsItemlistbox__content--value');
		}
	);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["oGetItemValueColumn"] = 0; };

/**
 * Selects or deselects an item
 *
 * @param {UCF_ItemListBoxITem} oItem the item
 * @param {boolean} bSelect true to select the specified item, otherwise, false
 * @param {boolean} bClear clears previous selection if true
 * @private
 */
UCF_SelectListBox["prototype"]["selectItem"] = function(oItem, bSelect, bClear) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["selectItem"]++; }; 
	/** @type {UCF_SelectListBox} */
	var self = this;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem'), "UCF_JsUtil.bInstanceOf(oItem, 'UCF_ItemListBoxItem')", "SelectListBox.js(645): selectItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof bSelect === 'boolean', "typeof bSelect === 'boolean'", "SelectListBox.js(646): selectItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof bClear === 'boolean', "typeof bClear === 'boolean'", "SelectListBox.js(647): selectItem"); };

	this["bSelectionChanged"] = false;

	if (oItem["bIsEnabled"]()) {
		UCF_JsUtil["forEach"](this["aGetItems"](), function(oCurrentItem) {
			/** @type {boolean} */
			var bIsSelected;

			if (oCurrentItem["bIsEnabled"]()) {
				bIsSelected = oCurrentItem["bIsSelected"]();
				if (oCurrentItem === oItem) {
					if (bSelect && !bIsSelected) {
						oItem["select"](true);
						self["bSelectionChanged"] = true;
					} else if (!bSelect && bIsSelected) {
						oItem["select"](false);
						self["bSelectionChanged"] = true;
					}
				} else if (bClear && bIsSelected) {
					oCurrentItem["select"](false);
					self["bSelectionChanged"] = true;
				}
			}
		});
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["selectItem"] = 0; };

/**
 * Selects a range of items
 *
 * @param {string} sKey1 the first item of the range
 * @param {string} sKey2 the last item of the range
 * @private
 */
UCF_SelectListBox["prototype"]["selectItemRange"] = function(sKey1, sKey2) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["selectItemRange"]++; }; 
	/** @type {boolean} */
	var bSelect = false;
	/** @type {number} */
	var i;
	/** @type {Array.<UCF_ItemListBoxItem>} */
	var aItems = this["aGetItems"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sKey1 === 'string', "typeof sKey1 === 'string'", "SelectListBox.js(690): selectItemRange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sKey2 === 'string', "typeof sKey2 === 'string'", "SelectListBox.js(691): selectItemRange"); };

	for (i = 0; i < aItems["length"]; i++) {
		if (aItems[i]["sKey"] === sKey1 || aItems[i]["sKey"] === sKey2) {
			bSelect = !bSelect;
		}

		if (bSelect ||
			aItems[i]["sKey"] === sKey1 ||
			aItems[i]["sKey"] === sKey2
		) {
			if (!aItems[i]["bIsSelected"]() && aItems[i]["bIsEnabled"]()) {
				aItems[i]["select"](true);
				this["bSelectionChanged"] = true;
				if (sKey1 === sKey2) {
					break;
				}
			}
		} else if (aItems[i]["bIsSelected"]()) {
			aItems[i]["select"](false);
			this["bSelectionChanged"] = true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["selectItemRange"] = 0; };

/**
 * Returns the selected keys
 * @private
 * @return {Array.<string>} list of the keys of the selected items
 */
UCF_SelectListBox["prototype"]["aGetSelectedKeys"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["aGetSelectedKeys"]++; }; 
	return UCF_JsUtil["map"](
		this["aGetSelectedItems"](),
		function(oItem) { return oItem["sKey"]; }
	);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["aGetSelectedKeys"] = 0; };

/**
 * Returns the selected {UCF_ItemListBoxItem}s
 * @private
 * @return {Array.<UCF_ItemListBoxItem>} list of the selected items
 */
UCF_SelectListBox["prototype"]["aGetSelectedItems"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["aGetSelectedItems"]++; }; 
	return UCF_JsUtil["filter"](
		this["aGetItems"](),
		function(oItem) { return oItem["bIsSelected"](); }
	);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["aGetSelectedItems"] = 0; };

/**
 * Fires the Select event if the item selection has changed
 *
 * @param {boolean} bDelayed Select event is fired delayed
 * @private
 */
UCF_SelectListBox["prototype"]["fireSelectEvent"] = function(bDelayed) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["fireSelectEvent"]++; }; 
	/** @type {Array.<UCF_ItemListBoxItem>} */
	var aSelectedKeys = this["aGetSelectedKeys"]();

	// clear timer
	if (this["iSelectTimerId"]) {
		UCF_JsUtil["clearDelayedCall"](this["iSelectTimerId"]);
	}

	if (bDelayed) {
		this["iSelectTimerId"] = UCF_JsUtil["delayedCall"](
			500, // eslint-disable-line no-magic-numbers
			this,
			'fireSelect', [this["sId"], aSelectedKeys]
		);
	} else {
		this["fireSelect"](this["sId"], aSelectedKeys);
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["fireSelectEvent"] = 0; };

/**
 * Determines and applies the height of the ItemListBox
 *
 *  @private
 */
UCF_SelectListBox["prototype"]["applyHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["applyHeight"]++; }; 
	/** @type {number} */
	var iNewHeight = 0;
	/** @type {number} */
	var iBorderHeight = 2;
	/** @type {number} */
	var iCurrentHeight;

	if (this["iVisibleItems"] > 0) {
		iCurrentHeight = this["oDomRef"]["offsetHeight"];
		iNewHeight = this["iVisibleItems"] * this["iGetItemHeight"]() + iBorderHeight;

		if (iNewHeight > 0 && iCurrentHeight !== iNewHeight) {
			this["oDomRef"]["style"]["height"] = iNewHeight + 'px';
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["applyHeight"] = 0; };

/**
 * Determines and applies the width of the ItemListBox.
 * If a width is defined, set it on the root container and allow
 * scrolling if needed.
 *
 * @private
 */
UCF_SelectListBox["prototype"]["applyWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["applyWidth"]++; }; 
	/** @type {HTMLTableElement} */
	var oTableRef = UCF_DomUtil["oGetFirstChild"](this["oDomRef"]);
	/** @type {number} */
	var iScrollbarWidth;
	/** @type {number} */
	var iTableWidth;
	/** @type {string} */
	var sDomRefOverflowY;

	if (UCF_UserAgent["bIsIECompatibilityMode"]()) {
		this["oDomRef"]["style"]["width"] = '';
		iScrollbarWidth = this["oDomRef"]["offsetWidth"] - this["oDomRef"]["clientWidth"];

		this["oRootRef"]["style"]["width"] = this["sWidth"] === ''
			? '0'
			: this["sWidth"];
		this["oRootRef"]["display"] = 'block';

		if (!this["sWidth"] || parseInt(this["sWidth"]) <= 0) {
			this["oDomRef"]["style"]["width"] = (oTableRef["offsetWidth"] + iScrollbarWidth) +
				'px';
		}
		if (oTableRef["offsetWidth"] <= this["oDomRef"]["clientWidth"]) {
			this["oDomRef"]["style"]["overflowX"] = 'hidden';
		}

		oTableRef["style"]["width"] = '100%';
	} else {
		// get scrollbar width by removing width and diffing offsetWidth/clientWidth
		sDomRefOverflowY = UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'overflowY');
		this["oDomRef"]["style"]["overflowY"] = 'scroll';
		this["oDomRef"]["style"]["width"] = '';
		iScrollbarWidth = this["oDomRef"]["offsetWidth"] - this["oDomRef"]["clientWidth"];

		// get item width by setting width:auto and display:inline-block
		this["oDomRef"]["style"]["width"] = 'auto';
		this["oDomRef"]["style"]["display"] = 'inline-block';
		iTableWidth = oTableRef["offsetWidth"];

		// reset width+display to useable values
		this["oDomRef"]["style"]["overflowY"] = sDomRefOverflowY;
		this["oDomRef"]["style"]["width"] = this["sWidth"] === ''
			? '0'
			: this["sWidth"];
		this["oDomRef"]["display"] = 'block';

		// if there is no width defined or it is wider than the table
		// => push to needed width and disable scrollbar
		if (!this["sWidth"] || parseInt(this["sWidth"]) <= 0) {
			this["oDomRef"]["style"]["width"] = (iTableWidth + iScrollbarWidth) + 'px';
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["applyWidth"] = 0; };

/**
 * Set readonly state of the ItemListBox
 *
 * @private
 * @param {boolean} bReadonly set read only state if true, remove read only state if false
 */
UCF_SelectListBox["prototype"]["setReadonly"] = function(bReadonly) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["setReadonly"]++; }; 
	if (bReadonly !== this["bReadonly"]) {
		this["bReadonly"] = bReadonly;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("ReadOnly", bReadonly, true);
		this["rerenderReadonly"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["setReadonly"] = 0; };

/** @private */
UCF_SelectListBox["prototype"]["rerenderReadonly"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["rerenderReadonly"]++; }; 
	this["rerenderClassName"]();
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["rerenderReadonly"] = 0; };

/** @private */
UCF_SelectListBox["prototype"]["rerenderClassName"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["rerenderClassName"]++; }; 
	UCF_DomUtil["setClass"](this["oDomRef"], this["sItemListBoxGetRootClass"]());
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["rerenderClassName"] = 0; };

/** @return {string} the ClassName as computed by the ItemListBoxGetRootClass renderer fragment */
UCF_SelectListBox["prototype"]["sItemListBoxGetRootClass"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["sItemListBoxGetRootClass"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'ItemListBoxGetRootClass',
		'ItemListBox', {
			"IsPopup": false,
			"Enabled": this["bEnabled"],
			"Readonly": this["bReadonly"],
			"Invalid": this["bInvalid"],
			"InputState": this["sInputState"]
		}
	);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["sItemListBoxGetRootClass"] = 0; };

/**
 * Sets the focus to an item
 *
 * @param {UCF_ItemListBoxItem} oItem
 * @private
 */
UCF_SelectListBox["prototype"]["focusItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["focusItem"]++; }; 
	/** @type {HTMLElement} */
	var oItemFocusDomRef;

	if (oItem) {
		// remove tabindex from previously focused item
		if (this["oFocussedItem"]) {
			oItemFocusDomRef = this["oGetItemValueColumn"](this["oFocussedItem"]["oDomRef"]);
			if (oItemFocusDomRef) {
				UCF_DomUtil["setTabIndex"](oItemFocusDomRef, -1);
				// remove accessKey from previous item
				UCF_DomUtil["setAccessKey"](oItemFocusDomRef, '');
			}
		}

		// focus item
		oItemFocusDomRef = this["oGetItemValueColumn"](oItem["oDomRef"]);
		if (oItemFocusDomRef) {
			UCF_DomUtil["setTabIndex"](oItemFocusDomRef, 0);
			// set accessKey to the new item
			UCF_DomUtil["setAccessKey"](oItemFocusDomRef, this["sAccessKey"]);

			if (!UCF_DomUtil["bIsRTL"]) {
				UCF_JsUtil["delayedCall"](
					1,
					UCF_DomUtil,
					'focusDomElement', [oItemFocusDomRef]
				);
			}
		}

		// remove tabindex from root
		// Why? TG
		UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);

		if (window["UCF_System"]["bIsAria"]) {
			if (oItem && oItemFocusDomRef) {
				UCF_AriaStateHelper["addAriaLabelTag"](
					oItemFocusDomRef,
					oItem["sId"],
					'aria-labelledby'
				);
			}
		}

		UCF_DomUtil["setAccessKey"](this["oDomRef"], ''); // remove accessKey from root

		// save this item as previously focused item
		this["oFocussedItem"] = oItem;

		this["bTabIndexInitialized"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["focusItem"] = 0; };

/**
 * Gets the number of selected items
 *
 * @private
 * @return {number} number of "selected" items
 */
UCF_SelectListBox["prototype"]["iGetSelectedItemCount"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["iGetSelectedItemCount"]++; }; 
	return this["aGetSelectedItems"]()["length"];
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["iGetSelectedItemCount"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @return {UCF_ItemListBoxItem} the active item
 */
UCF_SelectListBox["prototype"]["oGetActiveItem"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["oGetActiveItem"]++; }; 
	/** @type {HTMLElement} */
	var oDomRef = oBrowserEvent["oGetSource"]();
	/** @type {UCF_ItemListBoxItem} */
	var oItem = null;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(971): oGetActiveItem"); };

	while (oDomRef["tagName"] !== 'TR') {
		oDomRef = oDomRef["parentNode"];
		if (oDomRef["tagName"] === 'TABLE' || oDomRef["tagName"] === 'DIV') {
			return null;
		}
	}

	oItem = this["oLS"]["oGetControlByDomRef"](oDomRef);

	return UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem')
		? oItem
		: null;
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["oGetActiveItem"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element
 * within the control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 * @private
 */
UCF_SelectListBox["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_Control} */
	var oSourceControl = oBrowserEvent["oGetSourceControl"]();
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper;
	/** @type {HTMLElement} */
	var oSource;
	/** @type {boolean} `true` if navigation inside the control, `false` if control entered from extern */
	var bNavigation;
	/** @type {HTMLElement} */
	var oFrom;
	/** @type {UCF_ItemListBoxItem} */
	var oActiveItem;
	/** @type {string} */
	var sSecondValue;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(1010): onlsaccessibility"); };

	if (oSourceControl === this ||
		UCF_JsUtil["bInstanceOf"](oSourceControl, 'UCF_ItemListBoxItem')
	) {
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
		oSource = oBrowserEvent["oGetSource"]();

		oFrom = oBrowserEvent["oGetFromElement"]();
		bNavigation = oFrom &&
			UCF_DomUtil["bContains"](this["oDomEvent"], oFrom) &&
			oFrom["tagName"] !== 'DIV';

		// check if an item is focused
		if (oSource["tagName"] === 'TD') {
			oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
			oAccessibilityHelper["setEnabled"](this["bEnabled"]);
			oAccessibilityHelper["setReadonly"](this["bReadonly"]);
			oAccessibilityHelper["setRequired"](this["bRequired"]);
			oAccessibilityHelper["setInvalid"](this["bInvalid"]);

			oActiveItem = this["oGetActiveItem"](oBrowserEvent);

			oAccessibilityHelper["setSelected"](oActiveItem["bIsSelected"]());
			oAccessibilityHelper["setNotSelected"](!oActiveItem["bIsSelected"]());

			// get text of the focused item
			sSecondValue = '';
			if (oActiveItem["oParentControl"]["sSecondValueVisibility"] ===
				'DESCRIPTIVE'
			) {
				sSecondValue = oActiveItem["sValue2"];
				if (sSecondValue !== '') {
					sSecondValue = ' ' + sSecondValue;
				}
			}
			oAccessibilityHelper["setText"](
				UCF_DomUtil["sGetInnerText"](oSource) + sSecondValue
			);
			oAccessibilityHelper["setItemCount"](this["iGetItemCount"]());
			oAccessibilityHelper["setItemIndex"](
				this["oGetActiveItem"](oBrowserEvent)["oDomRef"]["rowIndex"] + 1
			);

			oAccessibilityHelper["addTooltip"](
				bNavigation ? oActiveItem["sTooltip"] : this["sTooltip"]
			);

			if (!bNavigation) {
				oAccessibilityHelper["setControlType"](
					this["bMultipleSelection"] ? 'ILBM' : 'ILBS'
				);
				oAccessibilityHelper["applyLabelingInfo"](this);

				if (this["bIsWriteable"]()) {
					oAccessibilityHelper["addEnabledTutor"](
						this["bMultipleSelection"] ? 'ILBM_TUT' : 'ILBS_TUT',
						this["bEnabled"]
					);
				} else {
					oAccessibilityHelper["addTutor"]('UDNAV_TUT', this["bEnabled"]);
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlsaccessibility"] = 0; };

/**
 * @inheritdoc
 * @private
 */
UCF_SelectListBox["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["createDragDelegate"]++; }; 
	if (this["sDragSourceInfo"] && !this["oDragDelegate"]) {
		this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemListBoxDragDelegate"))(this["oLS"], this);
		this["addDelegate"](this["oDragDelegate"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["createDragDelegate"] = 0; };

/**
 * @inheritdoc
 * @private
 */
UCF_SelectListBox["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["createDropDelegate"]++; }; 
	if (this["sDropTargetInfo"] && !this["oDropDelegate"]) {
		this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemListBoxDropDelegate"))(this["oLS"], this);
		this["addDelegate"](this["oDropDelegate"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["createDropDelegate"] = 0; };

/**
 * Set enabled state of the SelectListBox
 *
 * @public
 * @param {boolean} bEnabled the new enabled state
 */
UCF_SelectListBox["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["setEnabled"]++; }; 
	if (bEnabled || window["UCF_System"]["bIs508"]) {
		UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
	} else {
		UCF_DomUtil["resetTabIndex"](this["oDomRef"]);
	}

	UCF_ItemListBox_ie6.prototype["setEnabled"]["call"](this, bEnabled);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["setEnabled"] = 0; };

/**
 * Sets the tooltip of the ItemListBox. Will only be given
 * to the AccessibilityHelper, will not be set as title directly.
 *
 * @public
 * @param {string} sTooltip the tooltip to set
 */
UCF_SelectListBox["prototype"]["setTooltip"] = function(sTooltip) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["setTooltip"]++; }; 
	this["sTooltip"] = sTooltip;
	// eslint-disable-next-line quotes
	this["setClientProperty"]("Tooltip", this["sTooltip"], true);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["setTooltip"] = 0; };

/**
 * selects a item of the itemlistbox
 *
 * @param {string} sItemId
 * @public
 */
UCF_SelectListBox["prototype"]["selectItemById"] = function(sItemId) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["selectItemById"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (this["bIsWriteable"]()) {
		oItem = this["oGetControlById"](sItemId);

		if (oItem) {
			this["selectItem"](oItem, true, !this["bMultipleSelection"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["selectItemById"] = 0; };

/**
 * Scrolls the itemlistbox to given item index
 *
 * @public
 * @param {number} itemIndex the index (in #aItems) of the item to scroll to
 */
UCF_SelectListBox["prototype"]["scrollToItemByIndex"] = function(itemIndex) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["scrollToItemByIndex"]++; }; 
	/** @type {UCF_ItemListBox} */
	var oItem;
	/** @type {number} */
	var iItemOffsetHeight;
	/** @type {number} */
	var iItemOffsetTop;
	/** @type {number} */
	var iScrollTop;
	/** @type {number} */
	var iOffsetHeight;
	/** @type {number} */
	var iScrollHeight;
	/** @type {boolean} */
	var bIsAboveViewport;
	/** @type {boolean} */
	var bIsBelowViewport;

	if (!isNaN(itemIndex)) {
		oItem = this["aGetItems"]()[itemIndex];

		if (oItem) {
			iScrollHeight = this["oDomRef"]["scrollHeight"];
			iOffsetHeight = this["oDomRef"]["offsetHeight"];
			iScrollTop = this["oDomRef"]["scrollTop"];
			iItemOffsetTop = oItem["oDomRef"]["offsetTop"];
			iItemOffsetHeight = oItem["oDomRef"]["offsetHeight"];

			bIsAboveViewport = iItemOffsetTop < iScrollTop;
			bIsBelowViewport = iScrollTop + iOffsetHeight < iItemOffsetTop + iItemOffsetHeight;

			if (bIsAboveViewport || bIsBelowViewport) {
				if (this["oLS"]["oSystem"]["sDevice"] === 'ie6') {
					this["oDomRef"]["scrollTop"] = Math["max"](
						0,
						Math["min"](iItemOffsetTop, iScrollHeight - iOffsetHeight)
					);
				} else {
					this["oLS"]["scrollIntoView"](oItem["sId"], true);
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["scrollToItemByIndex"] = 0; };

/**
 * deselects a item of the itemlistbox
 *
 * @public
 * @param {string} sItemId the ID if the item that should be deselected
 */
UCF_SelectListBox["prototype"]["deselectItemById"] = function(sItemId) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["deselectItemById"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (this["bIsWriteable"]()) {
		oItem = this["oGetControlById"](sItemId);

		if (oItem) {
			this["selectItem"](oItem, false, false);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["deselectItemById"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the scroll event
 */
UCF_SelectListBox["prototype"]["onscroll"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onscroll"]++; }; 
	if (UCF_UserAgent["bIsFirefox"]()) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onscroll"] = 0; };

/**
 * Handles the touchstart event
 *
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the touchstart
 */
UCF_SelectListBox["prototype"]["onlstouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlstouchstart"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(1237): onlstouchstart"); };

	oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);
	this["bTouchstartSelected"] = false;

	if (this["bOnDragHandle"](oBrowserEvent) && !oItem["bIsSelected"]()) {
		this["bTouchstartSelected"] = true;
		this["handleSelection"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlstouchstart"] = 0; };

/**
 * Handles the touchend event
 *
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the touchend
 */
UCF_SelectListBox["prototype"]["onlstouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlstouchend"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(1258): onlstouchend"); };

	oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);

	if (this["bOnDragHandle"](oBrowserEvent) && !this["bTouchstartSelected"] &&
		oItem["bIsSelected"]()) {
		this["handleSelection"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["onlstouchend"] = 0; };

/**
 * Handles the selection of item(s)
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_SelectListBox["prototype"]["handleSelection"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["handleSelection"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oItem;
	/** @type {boolean} */
	var bClear;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectListBox.js(1280): handleSelection"); };

	if (this["bIsWriteable"]()) {
		oItem = this["oGetItemFromBrowserEvent"](oBrowserEvent);
		bClear = true;

		if (oItem) {
			if (this["bMultipleSelection"]) {
				bClear = false;
			}

			this["selectItem"](oItem, !oItem["bIsSelected"](), bClear);
			this["focusItem"](oItem);
			this["fireSelectEvent"](true); // fire select event delayed

			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["handleSelection"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_SelectListBox["prototype"]["bOnDragHandle"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["bOnDragHandle"]++; }; 
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();

	return oSource
		&& UCF_DomUtil["bHasClass"](oSource, 'lsItemlistbox__content')
		&& UCF_DomUtil["bHasClass"](oSource, 'lsItemlistbox__content--draghandle');
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["bOnDragHandle"] = 0; };

/** @return {boolean} `true` if the user may change the control value or it is enabled (readonly) in 508 mode */
UCF_SelectListBox["prototype"]["bIsWriteableOr508"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["bIsWriteableOr508"]++; }; 
	return this["bEnabled"] && (!this["bReadonly"] || this["oLS"]["oSystem"]["bIs508"]);
};;if (__UCF_COVERAGE__) { UCF_SelectListBox["_"]["bIsWriteableOr508"] = 0; };

UCF_SelectListBox.prototype["aPublicMethods"] = ["setEnabled","setTooltip","selectItemById","scrollToItemByIndex","deselectItemById"].concat(UCF_SelectListBox.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_SelectorDelegate"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="../base/LayeredControl.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_EventProvider */
/// <reference path="../../../core/EventProvider.js"/>

/**
 * Selector-Controls currently availabel:
 * Checkbox, Radio Button, Tristate-Checkbox, Switch
 *
 *
 * @class UCF_SelectorDelegate
 * @extends UCF_Object
 * @param { UCF_Control } oSelector can be a checkbox, radio button or tristate checkbox
 */
function UCF_SelectorDelegate(oSelector) {if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["UCF_SelectorDelegate"]++; }; 
	UCF_EventProvider["apply"](this);
	/** @type {UCF_Control} checkbox, radio button or tristate-checkbox*/
	this["oSelector"] = oSelector;
	/** @type {Array} used in ARIA*/
	this["aSet"] = [];
	/** @type {string} used in ARIA*/
	this["sName"] = null;
	/** @type {string} used in ACC*/
	this["sTooltip"] = '';

	// connect the datatip to the checkboxes image
	if (oSelector["oDataTip"]) {
		oSelector["oDataTip"]["setOpenerRef"](oSelector["oFocusDomRef"]);
		if (oSelector["sTooltip"] !== '' || window["UCF_System"]["bIs508"]) {
			oSelector["oDataTip"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"]);
		}
		if (oSelector["bShowHelp"]) {
			oSelector["oDataTip"]["setHoverDomRef"](oSelector["oFocusDomRef"]);
			oSelector["oDataTip"]["setHoverDomRefExcluded"](oSelector["oFocusDomRef"]);
		}
	}
};window["UCF_SelectorDelegate"] = UCF_SelectorDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SelectorDelegate"); UCF_SelectorDelegate["_"] = {UCF_SelectorDelegate: 0}; }; ;
UCF_SelectorDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_SelectorDelegate.prototype["sClassName"] = "UCF_SelectorDelegate";

UCF_SelectorDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["destroy"]++; }; 
	this["oSelector"] = null;
	this["aSet"] = null;
	this["sTooltip"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["destroy"] = 0; };
/**
 * ############################################################
 *
 * Section with public APIs
 *
 * ############################################################
 **/

/**
 * Returns the value of the CheckBox, true=checked; false=not checked
 * @return {boolean} bChecked The value of the CheckBox, true=checked; false=not checked
 * @public
 */
UCF_SelectorDelegate["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["getValue"]++; }; 
	return this["oSelector"]["bChecked"];
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["getValue"] = 0; };

/**
 * Get enabled
 * @return {boolean} bEnabled
 * @public
 */
UCF_SelectorDelegate["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["getEnabled"]++; }; 
	return this["oSelector"]["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["getEnabled"] = 0; };

/**
 * Set enabled
 * @param {boolean} bSwitchToEnabled the new enabled value
 * @public
 */
UCF_SelectorDelegate["prototype"]["setEnabled"] = function(bSwitchToEnabled) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["setEnabled"]++; }; 
	/** @type {UCF_Control} any selector control */
	var oSelector = this["oSelector"];
	/** @type {enum-list} */
	var eState = this["eInterActionState"];
	/** @type {enum-value} */
	var sInterActionState = this["sGetInterActionState"](oSelector);

	var fSwitchToState = function() {
		return bSwitchToEnabled ? eState["ENABLED"] : eState["DISABLED"];
	};

	if (this["sGetInputState"](oSelector) !== this["eInputState"]["NONE"] ||
		sInterActionState === fSwitchToState() ||
		sInterActionState === eState["READONLY"]) {
		return;
	}

	this["styleFactory"](this["toggleMethods"]["switchInterActionState"],
		oSelector, fSwitchToState());

	if (window["UCF_System"]["bIs508"] || (oSelector["bEnabled"] && !oSelector["bReadonly"])) {
		UCF_DomUtil["setTabIndex"](oSelector["oFocusDomRef"], 0);
	} else {
		UCF_DomUtil["setTabIndex"](oSelector["oFocusDomRef"], -1);
	}

	oSelector["bEnabled"] = bSwitchToEnabled;
	oSelector["setClientProperty"]("Enabled", this["oSelector"]["bEnabled"], true);

};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["setEnabled"] = 0; };

/**
 * Get the editable state of the checkbox
 * @return {boolean} bReadonly
 * @public
 */
UCF_SelectorDelegate["prototype"]["getEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["getEditable"]++; }; 
	return !this["oSelector"]["bReadonly"];
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["getEditable"] = 0; };

/**
 * Set the editable state of the checkbox
 *
 * @param {boolean} bSetEditable the new editable value
 * @public
 */
UCF_SelectorDelegate["prototype"]["setEditable"] = function(bSetEditable) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["setEditable"]++; }; 

	var oSelector = this["oSelector"],
		eState = this["eInterActionState"],
		sInterActionState = this["sGetInterActionState"](oSelector);

	/**
	 * @return {bool}
	 * @private
	 */
	var fSwitchToState = function() {
		return bSetEditable ? eState["ENABLED"] : eState["READONLY"];
	};

	if (sInterActionState === fSwitchToState() ||
		sInterActionState === eState["DISABLED"]) {
		return;
	}

	this["styleFactory"](this["toggleMethods"]["switchInterActionState"],
		oSelector, fSwitchToState());

	oSelector["bReadonly"] = !oSelector["bReadonly"];
	oSelector["setClientProperty"]("Readonly", oSelector["bReadonly"], true);

	if (window["UCF_System"]["bIs508"] || (oSelector["bEnabled"] && !oSelector["bReadonly"])) {
		UCF_DomUtil["setTabIndex"](oSelector["oFocusDomRef"], 0);
	} else {
		UCF_DomUtil["setTabIndex"](oSelector["oFocusDomRef"], -1);
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["setEditable"] = 0; };

/**
 * Gets the value state of this checkbox
 * @return {string} sInputState the required state
 * @public
 */
UCF_SelectorDelegate["prototype"]["getValueState"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["getValueState"]++; }; 
	if (this["oSelector"]["bInvalid"]) {
		return this["eInputState"]["ERROR"];
	} else {
		return this["oSelector"]["sInputState"];
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["getValueState"] = 0; };

/**
 * Sets the input state of the checkbox
 * @param {string} sInputState
 * @public
 */
UCF_SelectorDelegate["prototype"]["setValueState"] = function(sInputState) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["setValueState"]++; }; 
	/** @type {UCF_Control} any selector */
	var oSelector = this["oSelector"];
	/** @type {enum-list} */
	var eState = this["eInputState"];
	/** @type {enum-value} */
	var sState = this["sGetInputState"](oSelector);

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sInputState === 'ERROR' || sInputState === 'WARNING' || sInputState === 'NONE', "sInputState === 'ERROR' || sInputState === 'WARNING' || sInputState === 'NONE'", "SelectorDelegate.js(201): setValueState"); };

	if (sState === sInputState ||
		this["sGetInterActionState"](oSelector) === this["eInterActionState"]["DISABLED"]) {
		return;
	}

	this["styleFactory"](this["toggleMethods"]["switchInputState"],
		oSelector, sInputState);

	oSelector["sInputState"] = sInputState;
	oSelector["setClientProperty"]("InputState", oSelector["sInputState"], true);

	if (sInputState === eState["ERROR"]) {

		oSelector["bInvalid"] = true;
		oSelector["setClientProperty"]("Invalid", oSelector["bInvalid"], true);

	} else if (sInputState === eState["NONE"] ||
		sInputState === eState["WARNING"]) {

		oSelector["bInvalid"] = false;
		oSelector["setClientProperty"]("Invalid", oSelector["bInvalid"], true);
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["setValueState"] = 0; };

/**
 * Checks if the control can get the focus or not
 * @return {boolean} Whether the control can get the focus
 * @private
 */
UCF_SelectorDelegate["prototype"]["bIsFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bIsFocusable"]++; }; 
	if (window["UCF_System"]["bIs508"] ||
		(this["oSelector"]["bEnabled"] && !this["oSelector"]["bReadonly"])) {

		return (this["oSelector"]["oFocusDomRef"] &&
			UCF_DomUtil["bHasTabIndex"](this["oSelector"]["oFocusDomRef"]));

	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bIsFocusable"] = 0; };
/**
 * ############################################################
 *
 * Style Style Class Switch Section
 *
 * ############################################################
 **/

UCF_SelectorDelegate["prototype"]["E_PROPERTIES"] = {
	'CHECKED': 'bChecked',
	'STATE': 'sState',
	'ENABLED': 'bEnabled',
	'READONLY': 'bReadonly',
	'ASSOCIATED_EDITCONTEXT': 'sAssociatedEditContext',
	'INPUTSTATE': 'sInputState',
	'TYPE': 'sType',
	'TEXT': 'sText',
	'NAME': 'sName',
	'SELECTION': 'sSelection',
	'INTERACTION': 'sInterAction',
	'INVALID': 'bInvalid'
};

/**
 * An enumaration of all the interaction states a checkbox,
 * tristate-checkbox or
 * radio button can assume.
 *
 * An interaction state determines whether or not the user can interact with
 * above mentioned controls
 *
 * @private
 */
UCF_SelectorDelegate["prototype"]["eInterActionState"] = {
	'PARENT_READONLY': 'PARENTREADONLY',
	'PARENT_EDITABLE': 'PARENTEDITABLE',
	'READONLY': 'READONLY',
	'DISABLED': 'DISABLED',
	'ENABLED': 'ENABLED'
};

/**
 * An enumaration of all the input states a checkbox,
 * tristate-checkbox or
 * radio button can assume.
 *
 * An input state conveys information about the user's input
 *
 * @private
 */
UCF_SelectorDelegate["prototype"]["eInputState"] = {
	'ERROR': 'ERROR',
	'WARNING': 'WARNING',
	'ACCEPTED_REJECT': 'ACCEPTEDREJECT',
	'NONE': 'NONE'
};

/** @typedef {'SELECTED'|'UNSELECTED'|'CHECKED'|'UNCHECKED'|'INDETERMINATE'} UCF_SelectorDelegate_SelectionState */
/**
 * An enumeration of all the selection states the different selector controls can assume.
 *
 * @private
 * @enum {UCF_SelectorDelegate_SelectionState}
 */
UCF_SelectorDelegate["prototype"]["eSelectionState"] = {
	'SELECTED': 'SELECTED',
	'UNSELECTED': 'UNSELECTED',
	'CHECKED': 'CHECKED',
	'UNCHECKED': 'UNCHECKED',
	'SAPTABLE_PRIMARY_SELECTED': 'SAPTABLE_PRIMARY',
	'SAPTABLE_PRIMARY_UNSELECTED': 'SAPTABLE_PRIMARY',
	'SAPTABLE_SECONDARY_SELECTED': 'SAPTABLE_SECONDARY',
	'SAPTABLE_SECONDARY_UNSELECTED': 'SAPTABLE_SECONDARY',
	'INDETERMINATE': 'INDETERMINATE'
};

UCF_SelectorDelegate["prototype"]["eBaseStyles"] = {
	'SAPTABLE_PRIMARY_SELECTED': 'SAPTABLE_PRIMARY_SELECTED',
	'SAPTABLE_PRIMARY_UNSELECTED': 'SAPTABLE_PRIMARY_UNSELECTED',
	'SAPTABLE_SECONDARY_SELECTED': 'SAPTABLE_SECONDARY_SELECTED',
	'SAPTABLE_SECONDARY_UNSELECTED': 'SAPTABLE_SECONDARY_UNSELECTED',
	'API_DRIVEN': 'SELECTOR_BASE',
	'SELECTOR_BASE': 'SELECTOR_BASE'
};

/**
 * enumaration
 *
 * @private
 */
UCF_SelectorDelegate["prototype"]["E_TYPE"] = {
	'DEFAULT': 'DEFAULT',
	'ACCEPTREJECT': 'ACCEPTREJECT',
	'NONE': 'NONE'
};

/**
 * Returns a bool that indicates whether or not a selector has a certain property
 *
 * @return {bool} selection state
 * @param {UCF_Control} oSelector
 * @param {string} sProperty
 * @private
 */
UCF_SelectorDelegate["prototype"]["bHasProperty"] = function(oSelector, sProperty) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bHasProperty"]++; }; 
	return oSelector[sProperty] !== 'undefined'
		&& oSelector[sProperty] !== undefined
		&& oSelector[sProperty] !== null;
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bHasProperty"] = 0; };

/**
 * Returns the current state of selection of a selector control such as a radio button,
 * checkbox or tristate-checkbox
 *
 * @return {string} selection state
 * @param {UCF_Control} oSelector
 * @private
 */
UCF_SelectorDelegate["prototype"]["sGetSelectionState"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetSelectionState"]++; }; 

	var eSelectionState = this["eSelectionState"];

	if (this["bHasProperty"](oSelector, this["E_PROPERTIES"]["CHECKED"])
		&& oSelector["bChecked"] === true) {
		return eSelectionState["SELECTED"];
	}

	if (this["bHasProperty"](oSelector, this["E_PROPERTIES"]["CHECKED"])
		&& oSelector["bChecked"] === false) {
		return eSelectionState["UNSELECTED"];
	}

	if (this["bHasProperty"](oSelector, this["E_PROPERTIES"]["STATE"])
		&& oSelector["sState"] === eSelectionState["CHECKED"]) {
		return eSelectionState["SELECTED"];
	}

	if (this["bHasProperty"](oSelector, this["E_PROPERTIES"]["STATE"])
		&& oSelector["sState"] === eSelectionState["UNCHECKED"]) {
		return eSelectionState["UNSELECTED"];
	}

	if (this["bHasProperty"](oSelector, this["E_PROPERTIES"]["STATE"])
		&& oSelector["sState"] === eSelectionState["INDETERMINATE"]) {
		return eSelectionState["INDETERMINATE"];
	}

	if (this["bHasProperty"](oSelector, this["E_PROPERTIES"]["STATE"])
		&& oSelector["sState"] === eSelectionState["UNCHECKED"]) {
		return eSelectionState["UNSELECTED"];
	}

	if (this["bHasProperty"](oSelector, this["E_PROPERTIES"]["SELECTION"])
		&& oSelector["sSelection"] === eSelectionState["CHECKED"]) {
		return eSelectionState["SELECTED"];
	}

	if (this["bHasProperty"](oSelector, this["E_PROPERTIES"]["SELECTION"])
		&& oSelector["sSelection"] === eSelectionState["UNCHECKED"]) {
		return eSelectionState["UNSELECTED"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetSelectionState"] = 0; };

/** @typedef {'GROUPED'|''} UCF_SelectorDelegate_Grouping */
/**
 * enumaration
 *	Used For the Radio Button Group only
 * @private
 * @enum {UCF_SelectorDelegate_Grouping}
 */
UCF_SelectorDelegate["prototype"]["eGrouping"] = {
	'GROUPED': 'GROUPED',
	'NONE': ''
};

/**
 * determines whether of not a radio button group is to be highlighted
 *
 * @private
 * @param { UCF_Control } oSelector
 * @return {string}
 */
UCF_SelectorDelegate["prototype"]["sGetGrouping"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetGrouping"]++; }; 
	if (oSelector["sGrouping"] === this["eGrouping"]["NONE"])
		return '';
	return oSelector["sGrouping"] + '_';
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetGrouping"] = 0; };

/**
 * This method returns those interaction-states of a selector control
 * that are relevant for the style switch during selection. Styles are
 * switched based on the return value.
 *
 * @param {control} oSelector a checkbox, radio button or tristate checkbox
 * @private
 * @return {string} value from enum eInterActionState
 */
// eslint-disable-next-line complexity
UCF_SelectorDelegate["prototype"]["sGetInterActionState"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetInterActionState"]++; }; 
	/** @type {enum-value} */
	var eInterActionState = this["eInterActionState"];
	/** @type {enum-value} */
	var E_PROPERTIES = this["E_PROPERTIES"];

	// no other state is allowed once the control is set to DISABLED
	if (oSelector["bEnabled"] === false
		|| (oSelector["sInterAction"]
			&& oSelector["sInterAction"] === eInterActionState["DISABLED"])) {
		return eInterActionState["DISABLED"];
	}

	// disabled
	if (this["bHasProperty"](oSelector, E_PROPERTIES["INTERACTION"])
		&& oSelector["sInterAction"] === eInterActionState["DISABLED"]) {
		return eInterActionState["DISABLED"];
	}

	// circumstances under which control is ENABLED
	if (this["bHasProperty"](oSelector, E_PROPERTIES["READONLY"])
		&& oSelector["bReadonly"] === false
		&& this["bHasProperty"](oSelector, E_PROPERTIES["ASSOCIATED_EDITCONTEXT"])
		&& oSelector["sAssociatedEditContext"] === eInterActionState["PARENT_EDITABLE"]
		&& oSelector["bEnabled"] === true) {
		return eInterActionState["ENABLED"];
	}

	// circumstances under which control is ENABLED
	if (this["bHasProperty"](oSelector, E_PROPERTIES["INTERACTION"])
		&& oSelector["sInterAction"] === eInterActionState["ENABLED"]) {
		return eInterActionState["ENABLED"];
	}

	// circumstances under which control is READONLY
	if (this["bHasProperty"](oSelector, E_PROPERTIES["READONLY"])
		&& oSelector["bReadonly"] === true
		&& this["bHasProperty"](oSelector, E_PROPERTIES["ASSOCIATED_EDITCONTEXT"])
		&& oSelector["sAssociatedEditContext"] === eInterActionState["PARENT_EDITABLE"]
		&& oSelector["bEnabled"] === true) {
		return eInterActionState["READONLY"];
	}

	// circumstances under which control is PARENT_READONLY
	if (this["bHasProperty"](oSelector, E_PROPERTIES["READONLY"])
		&& oSelector["bReadonly"] === false
		&& this["bHasProperty"](oSelector, E_PROPERTIES["ASSOCIATED_EDITCONTEXT"])
		&& oSelector["sAssociatedEditContext"] === eInterActionState["PARENT_READONLY"]
		&& oSelector["bEnabled"] === true) {
		return eInterActionState["PARENT_READONLY"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetInterActionState"] = 0; };

/**
 * This method returns those input-states of a selector control
 * that are relevant for the style switch during selection. Styles are
 * switched based on the return value.
 *
 * @param {control} oSelector a checkbox, radio button or tristate checkbox
 * @private
 * @return {string} value from enum eInputState
 */
UCF_SelectorDelegate["prototype"]["sGetInputState"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetInputState"]++; }; 
	/** @type {enum-list} */
	var E_PROPERTIES = this["E_PROPERTIES"];

	// -- Inputstate is WARNING
	if (this["bHasProperty"](oSelector, E_PROPERTIES["INPUTSTATE"])
		&& oSelector["sInputState"] === this["eInputState"]["WARNING"]) {
		return this["eInputState"]["WARNING"];
	}

	// -- Inputstate is ERROR
	if (
		(this["bHasProperty"](oSelector, E_PROPERTIES["INPUTSTATE"])
			&& oSelector["sInputState"] === this["eInputState"]["ERROR"])
		||
		(this["bHasProperty"](oSelector, E_PROPERTIES["INVALID"]) &&
			oSelector["bInvalid"] === true)) {
		return this["eInputState"]["ERROR"];
	}

	return this["eInputState"]["NONE"];
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetInputState"] = 0; };

/**
 * This method returns the type of a selector, for example,
 * acceptReject
 *
 * @param {control} oSelector a checkbox, radio button or tristate checkbox
 * @private
 * @return {string} value from enum E_TYPE
 */
UCF_SelectorDelegate["prototype"]["sGetType"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetType"]++; }; 
	if (this["bHasProperty"](oSelector, this["E_PROPERTIES"]["TYPE"])) {
		return oSelector["sType"];
	} else {
		return this["E_TYPE"]["NONE"];
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetType"] = 0; };

/**
 * Determines whether or not the selector control is selectable
 *
 * @return {boolean} determine selectability
 * @private
 */
UCF_SelectorDelegate["prototype"]["bIsSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bIsSelectable"]++; }; 
	/** @type {enum-value} */
	var sAssociatedEditContext = this["oSelector"]["sAssociatedEditContext"];

	return (this["oSelector"]["bEnabled"] &&
		(!this["oSelector"]["bReadonly"] &&
			sAssociatedEditContext !== this["eInterActionState"]["PARENT_READONLY"]));
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bIsSelectable"] = 0; };

/**
 * Provides static methods for the style switch process regardless
 * whether it is performed for selection or with a public api
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_SelectorDelegate["prototype"]["toggleMethods"] = {

	/**
	 * This static function is used as a callback by a selector control such as
	 * a radio button, checkbox, tristate-checkbox.
	 *
	 * It switches the base class of a selector such as lsSeleoctor--generic to
	 * a SAPTABLE specific base class
	 * @private
	 * @param {Object} oData all information necessary to switch styles
	 **/
	'switchBaseClass': function(oData) {
		UCF_DomUtil["replaceClass"](oData["oSelector"]["oDomRef"],
			oData["oSelector"]["eStyles"][oData["sBaseClassToRemove"]],
			oData["oSelector"]["eStyles"][oData["sBaseClassToAssign"]]);
	},

	/**
	 * This static function is used as a callback by a selector control such as
	 * a radio button, checkbox, tristate-checkbox.
	 *
	 * It switches the class to selected independent of its interaction-
	 * or selection state
	 * @private
	 * @param {Object} oData all information necessary to switch styles
	 **/
	'switchSelectionState': function(oData) {
		/** @type {string} determines field in style enum of selector */
		var sKey = oData["fDetermineKey"](oData["sStateToSwitchTo"])(oData["sSecondKeyPart"])(oData["sThirdKeyPart"]);
		/** @type {string} */
		var sStyleToSet = oData["oSelector"]["eStyles"][sKey];

		UCF_DomUtil["replaceClass"](oData["oSelector"]["oDomRef"], oData["sStyleToRemove"], sStyleToSet);
	},

	/**
	 * This static function is used as a callback by a selector control such as
	 * a radio button, checkbox, tristate-checkbox.
	 *
	 * It changes the input- or selection-state
	 * @private
	 * @param {Object} oData all information necessary to switch styles
	 **/
	'switchInterActionState': function(oData) {
		/** @type {string} determines field in style enum of selector */
		var sKey = oData["fDetermineKey"](oData["sFirstKeyPart"])(oData["sSecondKeyPart"])(oData["sStateToSwitchTo"]);
		/** @type {string} */
		var sStyleToSet = oData["oSelector"]["eStyles"][sKey];

		UCF_DomUtil["replaceClass"](oData["oSelector"]["oDomRef"], oData["sStyleToRemove"], sStyleToSet);
	},

	/**
	 * This static function is used as a callback by a selector control such as
	 * a radio button, checkbox, tristate-checkbox.
	 *
	 * It changes the inputsate of a style
	 * @private
	 * @param {Object} oData all information necessary to switch styles
	 **/
	'switchInputState': function(oData) {
		/** @type {string} determines field in style enum of selector */
		var sKey = oData["fDetermineKey"](oData["sFirstKeyPart"])(oData["sStateToSwitchTo"])(oData["sThirdKeyPart"]);
		/** @type {string} */
		var sStyleToSet = oData["oSelector"]["eStyles"][sKey];

		UCF_DomUtil["replaceClass"](oData["oSelector"]["oDomRef"], oData["sStyleToRemove"], sStyleToSet);
	},

	'switchToGrouped': function(oData) {
		var sField = oData["fDetermineKey"](oData["sStateToSwitchTo"])(oData["sFirstKeyPart"])(oData["sThirdKeyPart"]),
			sSwitchTo = oData["oSelector"]["eStyles"][sField];
		UCF_DomUtil["replaceClass"](oData["oSelector"]["oDomRef"], oData["sStyleToRemove"], sSwitchTo);
	},

	'switchToUngrouped': function(oData) {
		var sSelectionState = this["sGetSelectionState"](oData["oSelector"]);
		var sInterActionState = this["sGetInterActionState"](oData["oSelector"]);
		var sSwitchTo = sSelectionState + '_' + sInterActionState;
		var sSwitchFrom = this["eGrouping"]["GROUPED"] + '_' + sSwitchTo;
		var eStyles = oData["oSelector"]["eStyles"];

		UCF_DomUtil["replaceClass"](oData["oSelector"]["oDomRef"], eStyles[sSwitchFrom], eStyles[sSwitchTo]);
	}

};

/**
 * The style Factory is the central point that puts all the pieces together
 * @private
 * @param {function} fCallback a callback function provided by toggleMethods
 * @param {UCF_Control} oSelector any selector such as a radiobutton, checkbox or tristatecheckbox
 * @param { string } sStateToSwitchTo state to switch to
 */
UCF_SelectorDelegate["prototype"]["styleFactory"] = function(fCallback, oSelector, sStateToSwitchTo) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["styleFactory"]++; }; 
	/** @type {Object} */
	var oData;
	/** @type {enum-list} */
	var eSelectionState = this["eSelectionState"];
	/** @type {UCF_Selector_Delegate} */
	var self = this;
	/** @type {string} */
	var sFirstKeyPart;
	/** @type {string} */
	var sSecondKeyPart;
	/** @type {string} */
	var sThirdKeyPart;
	/** @type {string} */
	var sKeyToRemove;

	/**
	 * @param {string} State the selection state to be mapped
	 * @return {enum-value}
	 * @private
	 */
	function fMapStates(State) {
		switch (State) {
			case eSelectionState["UNCHECKED"]:
				return eSelectionState["UNSELECTED"];
			case eSelectionState["CHECKED"]:
				return eSelectionState["SELECTED"];
		default:
				return State;
		}
	}

/**
	 * @return {string} the first part of the key determines the selection state
	 * 									or the base style if the selector is used as a
	 * 									SAP Table select button
	 * @param { UCF_Control } oSelector
 * @private
 */
	function sGetFirstKeyPart(oSelector) {
		var sState = self["sGetSelectionState"](oSelector);
		return fMapStates(sState);
	}

	/**
	 * @return {string} the second part of the key determines the inputsate
	 * @param { UCF_Control } oSelector
	 * @private
	 */
	function sGetSecondKeyPart(oSelector) {
		if (oSelector[self["E_PROPERTIES"]["INPUTSTATE"]]) {
			return self["sGetInputState"](oSelector);
		}
		return '';
	}

	/**
	 * @return {string} the third part of the key determines the interaction state
	 * @param { UCF_Control } oSelector
	 * @private
	 */
	function sGetThirdKeyPart(oSelector) {
		return self["sGetInterActionState"](oSelector);
				}

	/**
	 * this key part determines not state related semantics such:
	 * type (ACCEPTREJECT)
	 * grouped: grouping of radio buttons in sap table etc
	 *
	 * @return {string} the fourth part of the key determines the type
	 * @param { UCF_Control } oSelector
	 * @private
	 */
	function sAdditionalSematics(oSelector) {
		/** @type {enum-value}  */
		var sType;
		//var sGrouped;

		sType = self["sGetType"](oSelector);
		sType = (sType === self["E_TYPE"]["NONE"]
					|| sType === self["E_TYPE"]["DEFAULT"]) ? '' : '_' + sType;

		//sGrouped = self.sGetGrouping(oSelector);

		return sType;
	}

	/**
	 * @return {enum-value} determines the bases classes that are to be swaped
	 * @param {UCF_Control} oSelector
	 * @private
	 */
	function sGetBaseCalssToRemove(oSelector) {
		var oData = oSelector["oData"];
		if (oData
			&& oData["controlusage"] === 'FRAGMENT_DRIVEN'
			&& self["eBaseStyles"][oData["selectionstate"]]) {
			return oData["selectionstate"];
		} else {
			return self["eBaseStyles"]["API_DRIVEN"];
		}
	}

	/**
	 * @return {string} puts all keyparts together
	 * @private
	 */
	function fDetermineKey() {
		var f = function(sFirstKeyPart) {
			return function(sSecondKeyPart) {
				sSecondKeyPart = (sSecondKeyPart === '' || sSecondKeyPart === 'NONE') ? '' : '_' + sSecondKeyPart;
				return function(sThirdKeyPart) {
					sThirdKeyPart = '_' + sThirdKeyPart;
					return sFirstKeyPart + sSecondKeyPart + sThirdKeyPart + sAdditionalSematics(oSelector);
				};
			};
		};
		return f;
	}

	// -- map selection state to expected value
	sStateToSwitchTo = fMapStates(sStateToSwitchTo);
	// -- find all key parts
	sFirstKeyPart = sGetFirstKeyPart(oSelector);
	sSecondKeyPart = sGetSecondKeyPart(oSelector);
	sThirdKeyPart = sGetThirdKeyPart(oSelector);
	// -- determine key for style to remove
	sKeyToRemove = fDetermineKey()(sFirstKeyPart)(sSecondKeyPart)(sThirdKeyPart);

	oData = {
		'sBaseClassToRemove': sGetBaseCalssToRemove(oSelector),
		'sBaseClassToAssign': sStateToSwitchTo,
		'sStyleToRemove': oSelector["eStyles"][sKeyToRemove],
		'oSelector': oSelector,
		'sFirstKeyPart': sFirstKeyPart,
		'sSecondKeyPart': sSecondKeyPart,
		'sThirdKeyPart': sThirdKeyPart,
		'fDetermineKey': fDetermineKey(),
		'sStateToSwitchTo': sStateToSwitchTo
	};

	fCallback(oData);
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["styleFactory"] = 0; };

/**
 * ############################################################
 *
 * Section for Inplace Edit
 *
 * ############################################################
 **/

/**
 * @return {HTMLElement}
 */
UCF_SelectorDelegate["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["oGetInplaceEditDomRef"]++; }; 
	var aSpans = this["oSelector"]["oRootRef"]["getElementsByTagName"]('SPAN');

	for (var i = 0; i < aSpans["length"]; i++) {
		if (aSpans[i]["getAttribute"]('iid') === 'text') {
			return aSpans[i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["oGetInplaceEditDomRef"] = 0; };

/**
 * @return {string}
 */
UCF_SelectorDelegate["prototype"]["sGetInplaceEditText"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetInplaceEditText"]++; }; 
	var oClientContol = this["oSelector"]["getClientControl"]();

	if (oClientContol) {
		if (oClientContol["getText"]()) {
			return oClientContol["getText"]();
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetInplaceEditText"] = 0; };

/**
 * @param {string} sText
 */
UCF_SelectorDelegate["prototype"]["setInplaceEditText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["setInplaceEditText"]++; }; 
	var oClientContol = this["oSelector"]["getClientControl"]();

	if (oClientContol) {
		oClientContol["setText"](sText);
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["setInplaceEditText"] = 0; };

/**
 * ############################################################
 *
 * Section for ARIA
 *
 * ############################################################
 **/

/**
 * List with all ARIA roles
 * @private
 */
UCF_SelectorDelegate["prototype"]["eAriaRole"] = {
	"UCF_Switch": 'switch',
	"UCF_CheckBox_standards": 'checkbox',
	"UCF_TriStateCheckBox_standards": 'checkbox',
	"UCF_RadioButton_standards": 'radio'
};

/**
 * Determine ARIA tutor text for Switch
 * @private
 * @param { UCF_Control } oSelector
 * @return { string } sAriaDescibeText
 */
UCF_SelectorDelegate["prototype"]["sGetAriaTutorText"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetAriaTutorText"]++; }; 
	/** @type {string} */
	var sType = this["sGetType"](oSelector);
	/** @type {string} */
	var sAriaDescibeText = '';

	if (sType === this["E_TYPE"]["ACCEPTREJECT"] && this["sGetInterActionState"](oSelector) === this["eInterActionState"]["ENABLED"]) {
		if (this["sGetInputState"](oSelector) === this["eInputState"]["WARNING"]) {
			sAriaDescibeText = this["oSelector"]["oLS"]["sGetText"]('SAPUR_WARNING');
		}
		if (this["bSelected"](oSelector)) {
			sAriaDescibeText = sAriaDescibeText === ''
				? this["oSelector"]["oLS"]["sGetText"]('SAPUR_SWITCH_ACCEPT')
				: sAriaDescibeText + ' ' + this["oSelector"]["oLS"]["sGetText"]('SAPUR_SWITCH_ACCEPT');
		} else {
			sAriaDescibeText = sAriaDescibeText === ''
				? this["oSelector"]["oLS"]["sGetText"]('SAPUR_SWITCH_REJECT')
				: sAriaDescibeText + ' ' + this["oSelector"]["oLS"]["sGetText"]('SAPUR_SWITCH_REJECT');
		}
	}
	return sAriaDescibeText;
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetAriaTutorText"] = 0; };

/**
 * Update Aria tutor text for Switch
 * @private
 * @param { UCF_Control } oSelector
 */
UCF_SelectorDelegate["prototype"]["updateAriaTutorText"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["updateAriaTutorText"]++; }; 
	/** @type {HTMLSpanElement} */
	var oAriaRef = UCF_DomUtil["$"](oSelector["sId"] + "-invisible");
	/** @type {string} */
	var sAriaTutorText = this["sGetAriaTutorText"](oSelector);
	/** @type {string} */
	var sAriaTextFromRef;

	if (oAriaRef && this["sGetInterActionState"](oSelector) === this["eInterActionState"]["ENABLED"]) {
		sAriaTextFromRef = UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](oAriaRef));
		if (sAriaTextFromRef !== '' && sAriaTutorText !== '' && sAriaTextFromRef !== sAriaTutorText) {
			oAriaRef["textContent"] = sAriaTutorText;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["updateAriaTutorText"] = 0; };

/**
 * Determine ARIA Mode
 * @private
 * @param { UCF_Control } oSelector
 */
UCF_SelectorDelegate["prototype"]["updateAriaInfo"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["updateAriaInfo"]++; }; 
	UCF_AriaStateHelper["setChecked"](oSelector["oDomRef"], this["bSelected"](oSelector));
	// will be used for Switch control to update ARIA tutor text sType = ACCEPTREJECT
	this["updateAriaTutorText"](oSelector);
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["updateAriaInfo"] = 0; };

/**
 * Collects the selectors from the HTML
 * @private
 * @param {UCF_TriStateCheckBox} oSelector
 * @return {Array} the set
 */
UCF_SelectorDelegate["prototype"]["iGetSet"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["iGetSet"]++; }; 
	/** @type {UCF_ChekckBox} */
	/** @type {UCF_RadioButton} */
	oSelector = this["oSelector"];

	/** @type {Array} contains all selectors that form a group */
	var aHTMLSet;
	/** @type {string} */
	var sControl = this["oSelector"]["oDomRef"]["getAttribute"]('ct');
	/** @type {Object} */
	var sName = oSelector["sName"];
	/** @type {function} */
	var fFilter;

	// -- only selectors with a name attribute can have a set-size
	if (!this["bHasProperty"](oSelector, this["E_PROPERTIES"]["NAME"])) return -1;

	// -- if we are still in the same set of Selectors don't try to create a new set
	if (oSelector["sName"] === '' || (this["aSet"]["length"] > 0 && this["sName"] === oSelector["sName"])) {
		return this["aSet"]["length"];
	}

	// -- the function to use as filter
	fFilter = function(aSelectors, oHTMLRef) {
		var oControl = oSelector["oLS"]["oControlFactory"]["oGetControlByDomRef"](oHTMLRef, true);
		if (oControl["sName"] === sName)
			aSelectors["push"](oControl);
		return aSelectors;
	};

	// -- get the collections of selectors needed
	aHTMLSet = UCF_JsUtil["arrayFrom"](document["querySelectorAll"]('[ct=\"' + sControl + '\"]'));

	// -- create the set of selectors
	this["aSet"] = UCF_JsUtil["reduce"](aHTMLSet, fFilter, []);

	return this["aSet"]["length"];
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["iGetSet"] = 0; };

/**
 * @private
 * @return {integer} index in set
 */
UCF_SelectorDelegate["prototype"]["iGetPosInSet"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["iGetPosInSet"]++; }; 

	if (this["aSet"] === null
		|| !this["bHasProperty"](this["oSelector"], this["E_PROPERTIES"]["NAME"])) return -1;

	return UCF_JsUtil["indexOf"](this["aSet"], this["oSelector"]) + 1;
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["iGetPosInSet"] = 0; };

/**
 * Collects the selectors from the HTML
 * @private
 * @return {boolean}
 */
UCF_SelectorDelegate["prototype"]["bAccModeOn"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bAccModeOn"]++; }; 
	return window["UCF_System"]["bIsAria"] || window["UCF_System"]["bIs508"];
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bAccModeOn"] = 0; };

/**
 * @param { UCF_Control } oSelector
 * @return {string} sLabel
 * @private
 */
UCF_SelectorDelegate["prototype"]["addLabel"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["addLabel"]++; }; 
	/** @type {string} */
	var sLabel;
	/** @type {UCF_Label} */
	var oLabel;
	/** @type {UCF_SelectorDelegate} */
	var self = this;

	/**
	 * @return {UCF_Label}
	 */
	function oGetLabelControl() {
		/** @type {UCF_Label} */
		var oLabel;

		if (oSelector["sLabelledBy"] && oSelector["sLabelledBy"] !== '') {
			oLabel = oSelector["oLS"]["oControlFactory"]["oGetControlById"](oSelector["sLabelledBy"], true);
		} else {
			oLabel = null;
		}
		return oLabel;
	}

	/**
	 * @param { UCF_Control } oControl
	 * @return {string}
	 */
	function sGetLabelText(oControl) {
		/** @type {string} */
		var sText;

		if (self["bHasProperty"](oControl, self["E_PROPERTIES"]["TEXT"])) {
			sText = oControl["sText"];
		} else {
			sText = '';
		}
		return sText;
	}

	/**
	 * @param {string} sLabel
	 * @return {string}
	 */
	function removeColon(sLabel) {
		/** @type {string} */
		var sText;

		if (UCF_StringUtil["bIsEmpty"](sLabel)
			|| !sLabel) {
			sText = '';

		} else if (sLabel["indexOf"](':') > -1) {
			sText = sLabel["split"](':')[0];

		} else {
			sText = sLabel;

		}
		return sText;
	}

	/**
	 * @param {string} sLabel
	 * @return {string}
	 */
	function sLabelForIE(sLabel) { // eslint-disable-line no-unused-vars
		/** @type {string} */
		var sText;

		if (oSelector["sTooltip"]
			&& UCF_StringUtil["bIsEmpty"](oSelector["sTooltip"]) === false) {
			sText = sLabel + ' ' + oSelector["sTooltip"];
		}
		return sText;
	}

	oLabel = oGetLabelControl();
	sLabel = sGetLabelText(oLabel !== null ? oLabel : oSelector);
	sLabel = removeColon(sLabel);

	// if (UCF_UserAgent.bIsIE()) {
	// 	sLabel = sLabelForIE(sLabel);
	// }

	return sLabel;
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["addLabel"] = 0; };

/**
 * Check if selector can and must be marked as read-only
 * @param { UCF_Control } oSelector
 * @private
 * @return {boolean}
 */
UCF_SelectorDelegate["prototype"]["bReadOnly"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bReadOnly"]++; }; 
	/** @type {enum-value} */
	var sInterActionState;

	if (!this["bHasProperty"](oSelector, this["E_PROPERTIES"]["READONLY"])) {
		return false;
	} else {
		sInterActionState = this["sGetInterActionState"](oSelector);
		return sInterActionState === this["eInterActionState"]["READONLY"]
			|| sInterActionState === this["eInterActionState"]["PARENT_READONLY"];
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bReadOnly"] = 0; };

/**
 * Check if selector can and must be marked as read-only
 * @param { UCF_Control } oSelector
 * @private
 * @return {boolean}
 */
UCF_SelectorDelegate["prototype"]["bSelected"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bSelected"]++; }; 
	/** @type {enum-value} */
	var sSelectionState = this["sGetSelectionState"](oSelector);

	switch (sSelectionState) {
		case this["eSelectionState"]["SELECTED"]:
		case this["eSelectionState"]["CHECKED"]:
			return true;

		case this["eSelectionState"]["UNSELECTED"]:
		case this["eSelectionState"]["UNCHECKED"]:
			return false;

		case this["eSelectionState"]["INDETERMINATE"]:
			return null;
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["bSelected"] = 0; };

/**
 *
 * @param { sTooltip } sTooltip a tootltip text not present in sTooltip
 * @private
 */
UCF_SelectorDelegate["prototype"]["addTooltip"] = function(sTooltip) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["addTooltip"]++; }; 
	if (sTooltip) {
		this["sTooltip"] = sTooltip;
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["addTooltip"] = 0; };

/**
 *
 * @param { oSelector } oSelector UCF_Control - any selector
 * @return {string}
 * @private
 */
UCF_SelectorDelegate["prototype"]["sGetTooltip"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetTooltip"]++; }; 
	if (UCF_UserAgent["bIsIE"]()) return '';
	if (UCF_StringUtil["bIsEmpty"](this["sTooltip"]))
		return oSelector["sTooltip"];
	if (typeof(this["sTooltip"]) === 'undefined')
		this["sTooltip"] = '';

	return oSelector["sTooltip"] + ' ' + this["sTooltip"];
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["sGetTooltip"] = 0; };

/**
 * ############################################################
 *
 * Section with various events
 *
 * ############################################################
 **/

/**
 * Fires an ENTER Event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_SelectorDelegate["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SelectorDelegate.js(1177): onlsenter"); };

	if (this["oSelector"]["mEvents"]["Enter"]) {
		this["oSelector"]["fireEnter"](this["oSelector"]["sId"]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["onlsenter"] = 0; };
/**
 * ############################################################
 *
 * Section with internal events
 *
 * ############################################################
 **/
/**
 * Check the text if rendered with ellipsis, and display it in tooltip
 * @param {enum-value} sSelectionState
 * @private
 */
UCF_SelectorDelegate["prototype"]["fireInternalEvent"] = function(sSelectionState) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["fireInternalEvent"]++; }; 
	this["fireEvent"](this["E_EVENTS"]["Select"], {
		"sId": this["oSelector"]["sId"],
		"sSelectionState": sSelectionState
	});
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["fireInternalEvent"] = 0; };

/**
 * ############################################################
 *
 * Section for Miscellaneous Functions
 *
 * ############################################################
 **/

/**
 * Check the text if rendered with ellipsis, and display it in tooltip
 * @private
 */
UCF_SelectorDelegate["prototype"]["applyTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["applyTooltip"]++; }; 

	var oSelector = this["oSelector"];

	if (window["UCF_System"]["bIs508"]) return;
	// the text will not be added to the Title when Wrapping=true and the
	if (!this["bTextOverflow"] && this["bWrapping"])
		return;
	var oDomRefTxt = UCF_DomUtil["$"](oSelector["sId"] + '-txt'),
		oDomRefContainer = UCF_DomUtil["$"](oSelector["sId"]);
	if (oSelector["bTextOverflow"]) {
		UCF_DomUtil["checkTooltip"](oDomRefContainer, oSelector["sTooltip"], oDomRefTxt);
	} else {
		UCF_DomUtil["checkTooltip"](oDomRefTxt, oSelector["sTooltip"], null);
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["applyTooltip"] = 0; };

/**
 * @override
 * @see {UCF_Control}
 * @private
 */
UCF_SelectorDelegate["prototype"]["colorizeHighlightedText"] = function(iStart, iLength, sTextProperty, bFocused) {;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["colorizeHighlightedText"]++; }; 
	if (bFocused) {
		if (this["oSelector"]["oFocusDomRef"] && !UCF_DomUtil["bHasClass"](this["oSelector"]["oFocusDomRef"], 'lsHighlightTextFocus')) {
			UCF_DomUtil["addClass"](this["oSelector"]["oFocusDomRef"], 'lsHighlightTextFocus');
		}
	} else if (this["oFocusDomRef"] && !UCF_DomUtil["bHasClass"](this["oFocusDomRef"], 'lsHighlightText')) {
		UCF_DomUtil["addClass"](this["oSelector"]["oFocusDomRef"], 'lsHighlightText');
	}
};;if (__UCF_COVERAGE__) { UCF_SelectorDelegate["_"]["colorizeHighlightedText"] = 0; };

UCF_SelectorDelegate.prototype["aPublicMethods"] = ["getValue","getEnabled","setEnabled","getEditable","setEditable","getValueState","setValueState"].concat(UCF_SelectorDelegate.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Selector_508_Delegate"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>

/**
 * Helper Class for all selector controls such as checkbox, tristate-checkbox
 * and radio button. Handles accessibility in 508 and standards.
 * 
 *
 * @param {UCF_Control} oSelector
 */
function UCF_Selector_508_Delegate(oSelector) {if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["UCF_Selector_508_Delegate"]++; }; 
	//UCF_EventProvider.apply(this);
	//this.defineEvents(['Accessibility']);

	/** @type {UCF_Control} can be a checkbox radio button or tristate-checbox*/
	this["oSelector"] = oSelector;
	/** @type {Array} */
	this["aItems"] = [];
	/** @type {enum-value} */
	this["S_COLLECTING_ITEMS"] = 'PENDING';
	/** @type {string} used in ACC*/
	this["sTooltip"] = '';
};window["UCF_Selector_508_Delegate"] = UCF_Selector_508_Delegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Selector_508_Delegate"); UCF_Selector_508_Delegate["_"] = {UCF_Selector_508_Delegate: 0}; }; ;
UCF_Selector_508_Delegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_Selector_508_Delegate.prototype["sClassName"] = "UCF_Selector_508_Delegate";

/**
 * ############################################################################
 *
 * SECTION WITH ALL ENUMERATIONS
 *
 * ############################################################################
 */

/**
 * @private
 */
UCF_Selector_508_Delegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["destroy"]++; }; 
	this["oSelector"] = null;
	this["aItems"] = null;
	this["S_COLLECTING_ITEMS"] = null;
	this["sTooltip"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["destroy"] = 0; };

/**
 * @private
 * a list with all tutors neccessary in 508
 */
UCF_Selector_508_Delegate["prototype"]["E_TUTOR"] = {
	'C_CHECKED': 'C_SEL_TUT', //"To select, press spacebar"
	'C_UNCHECKED': 'C_NSEL_TUT', //"To deselect, press spacebar"

	'R_CHECKED': 'R_SEL_TUT', //"To select a different item, use the arrow keys. To navigate to a different item press Shift and use the arrow keys."
	'R_UNCHECKED': 'R_TUT', // To select press spacebar. To navigate to a different item, press Shift and use the arrow keys
	'R_DISABLED': 'R_DSBL_TUT',

	'TRI_CHECKED': 'TRI_SEL_TUT', // "To set to undefined, press spacebar"
	'TRI_UNCHECKED': 'TRI_NSEL_TUT', // "To select, press spacebar"
	'TRI_INDETERMINATE': 'TRI_UNDEF_TUT' //"To deselect, press spacebar"
};

/**
 * @private
 * a list with all input states as defined in the API.
 * This class uses enums rather than bools
 */
UCF_Selector_508_Delegate["prototype"]["E_INPUT_STATE"] = {
	'ERROR': 'ERROR',
	'WARNING': 'WARNING',
	'NONE': 'NONE'
};

/**
 * @private
 * a list with all interaction states as defined in the API.
 * This class uses enums rather than bools
 */
UCF_Selector_508_Delegate["prototype"]["E_INTERACTION_STATE"] = {
	'ENABLED': 'ENABLED',
	'DISABLED': 'DISABLED',
	'READONLY': 'READONLY',
	'PARENTREADONLY': 'PARENTREADONLY',
	'PARENTEDITABLE': 'PARENTEDITABLE'
};

/**
 * @private
 * a list with all selection states as defined in the API.
 * This class uses enums rather than bools
 */
UCF_Selector_508_Delegate["prototype"]["E_SELECTION_STATE"] = {
	'CHECKED': 'CHECKED',
	'UNCHECKED': 'UNCHECKED',
	'INDETERMINATE': 'INDETERMINATE'
};

/**
 * @private
 * a list that maps the class name to the key that represents
 * the role in 508
 */
UCF_Selector_508_Delegate["prototype"]["E_ROLE"] = {
	'UCF_Switch': 'C',
	'UCF_CheckBox': 'C',
	'UCF_CheckBox_standards': 'C',
	'UCF_RadioButton': 'R',
	'UCF_RadioButton_standards': 'R',
	'UCF_TristateCheckBox': 'TRI',
	'UCF_TriStateCheckBox_standards': 'TRI'
};

/**
 * @private
 * a list that maps the class name to the ct
 */
UCF_Selector_508_Delegate["prototype"]["E_CT"] = {
	'UCF_Switch': '[ct=\"Switch\"]',
	'UCF_CheckBox': '[ct=\"C_standards\"]',
	'UCF_CheckBox_standards': '[ct=\"C_standards\"]',
	'UCF_RadioButton': '[ct=\"R_standards\"]',
	'UCF_RadioButton_standards': '[ct=\"C_standards\"]',
	'UCF_TristateCheckBox': '[ct=\"TRI_standards\"]',
	'UCF_TriStateCheckBox_standards': '[ct=\"TRI_standards\"]'
};

/**
 * @private
 * a list that maps the class name to the control type
 */
UCF_Selector_508_Delegate["prototype"]["E_CONTROL_TYPE"] = {
	'UCF_Switch': 'CHECKBOX',

	'UCF_CheckBox': 'CHECKBOX',
	'UCF_CheckBox_standards': 'CHECKBOX',
	'CHECKBOX': 'CHECKBOX',

	'UCF_RadioButton': 'RADIOBUTTON',
	'UCF_RadioButton_standards': 'RADIOBUTTON',
	'RADIOBUTTON': 'RADIOBUTTON',

	'UCF_TristateCheckBox': 'TRISTATECHECKBOX',
	'UCF_TriStateCheckBox_standards': 'TRISTATECHECKBOX',
	'TRISTATECHECKBOX': 'TRISTATECHECKBOX'
};

/**
 * @private
 * a list with all group controls
 */
UCF_Selector_508_Delegate["prototype"]["E_GROUPS"] = {
	'UCF_CheckBoxGroup': 'CHECKBOX',
	'UCF_RadioButtonGroup': 'RADIOBUTTON'
};

/**
 * @private
 * a list that reflects whether or not a list of items has been collected
 * from the dom.
 */
UCF_Selector_508_Delegate["prototype"]["E_COLECTING_ITEMS"] = {
	'DONE': 'DONE',
	'PENDING': 'PENDING',
	'IMPOSSIBLE': 'IMPOSSIBLE'
};
/**
 * ############################################################################
 *
 * SECTION RESPONSIBLE FOR COLLECTING THE ITEMS SO AS TO GET INDEX AND ITEM COUNT
 *
 * ############################################################################
 */

/**
 * @private
 * @param { Array } aItems an array with all selectors grouped by their name
 *
 * This function is to be used by all selectors that collect items that
 * belong to one group. Currently the radio button
 */
UCF_Selector_508_Delegate["prototype"]["addItems"] = function(aItems) {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["addItems"]++; }; 

	if (!aItems || aItems["length"] === 0) {
		this["S_COLLECTING_ITEMS"] = this["E_COLECTING_ITEMS"]["IMPOSSIBLE"];
	} else {
		this["S_COLLECTING_ITEMS"] = this["E_COLECTING_ITEMS"]["DONE"];
	}

	this["aItems"] = aItems;
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["addItems"] = 0; };

/**
 * @private
 * @return {Object}
 * collect the respective selectors from the HTML and filter
 * them by their name
 *
 */
UCF_Selector_508_Delegate["prototype"]["aCollectItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["aCollectItems"]++; }; 
	/** @type {UCF_Control} - can be a checkbox, a radio button or a tristate-checkbox*/
	var oSelector = this["oSelector"];
	/** @type {Array} */
	var aCollectedItems;
	/** @type {enum} */
	var E_CT = this["E_CT"];
	/** @type {Object} */
	var oControlFactory = oSelector["oLS"]["oControlFactory"];
	/** @type {UCF_Control} */
	var oParent = oSelector["oGetParent"]();
	/** @type {Array} */
	var aFilteredSelectors;

	// --- depending on
	// 1) the SubmitMethod
	// 2) whether the selector is in a group-control
	// the selectors need to be collected  deferently from the dom
	if (
		oParent
		&& oParent["sClassName"]
		&& this["E_GROUPS"][oParent["sClassName"]]
	) {
		aCollectedItems = oParent["oDomRef"]["getElementsByTagName"](oSelector["oDomRef"]["tagName"]);
	} else {
		aCollectedItems = document["getElementsByName"](oSelector["sName"]);
	}

	// --- it was not possible to find any selectors
	if (!aCollectedItems || aCollectedItems["length"] === 0) {
		this["S_COLLECTING_ITEMS"] = this["E_COLECTING_ITEMS"]["IMPOSSIBLE"];
		this["aItems"] = null;
		return null;
	}

	// --- from the array with all selectors filter those that belong
	// --- to the same group
	aFilteredSelectors = UCF_JsUtil["reduce"](UCF_JsUtil["arrayFrom"](aCollectedItems), function(aItems, oItem) {
		var oFilteredSelector;

		if (window["UCF_System"]["sSubmitMethod"] === 'FORM') {
			oItem = UCF_DomUtil["oGetParentElement"](oItem);
		}

		if (!oItem) {
			return aItems;
		}

		if (
			E_CT[oSelector["sClassName"]]
			&& oItem
			&& oItem["getAttribute"]('ct')
			&& oItem["getAttribute"]('ct')["indexOf"](E_CT[oSelector["sClassName"]] > -1)
		) {
			oFilteredSelector = oControlFactory["oGetControlByDomRef"](oItem, true);
		}

		if (
			oFilteredSelector
			&& oFilteredSelector["sName"]
			&& oFilteredSelector["sName"] === oSelector["sName"]
		) {
			aItems["push"](oFilteredSelector);
		}

		return aItems;
	}, []);

	// --- it was not possible to find any selectors with the same name or ct
	if (!aFilteredSelectors || aFilteredSelectors["length"] === 0) {
		this["S_COLLECTING_ITEMS"] = this["E_COLECTING_ITEMS"]["IMPOSSIBLE"];
		this["aItems"] = null;
		return null;
	}

	this["S_COLLECTING_ITEMS"] = this["E_COLECTING_ITEMS"]["DONE"];
	this["aItems"] = aFilteredSelectors;
	return aFilteredSelectors;
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["aCollectItems"] = 0; };

/**
 * @private
 * @return { int } the index of this.oSelector
 */
// eslint-disable-next-line consistent-return
UCF_Selector_508_Delegate["prototype"]["iGetIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["iGetIndex"]++; }; 
	/** @type {enum-list} */
	var _ = this["E_COLECTING_ITEMS"];

	switch (this["S_COLLECTING_ITEMS"]) {
		case _["IMPOSSIBLE"]:
			return null;

		case _["DONE"]:
			return UCF_JsUtil["indexOf"](this["aItems"], this["oSelector"]) + 1;
	}
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["iGetIndex"] = 0; };

/**
 * @private
 * @return { int } the amount of all items
 */
// eslint-disable-next-line consistent-return
UCF_Selector_508_Delegate["prototype"]["iGetItemCount"] = function() {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["iGetItemCount"]++; }; 
	/** @type {enum-list} */
	var _ = this["E_COLECTING_ITEMS"];

	switch (this["S_COLLECTING_ITEMS"]) {
		case _["IMPOSSIBLE"]:
			return null;

		case _["PENDING"]:
			this["aCollectItems"]();
			return this["S_COLLECTING_ITEMS"] === _["DONE"] ? this["aItems"]["length"] : null;

		case _["DONE"]:
			return this["aItems"]["length"];
	}
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["iGetItemCount"] = 0; };

/**
 * ############################################################################
 *
 * SECTION THAT MAPS THE VARIOUS COMBINATIONS OF BOOLEANS TO ENUMS
 *
 * ############################################################################
 *
 * controls such as checkbox, radiobutton etc. share more or less the same
 * API values. some times a complex combination of boolean determines. some
 * times they differ in type. here we map all possible variations to three
 * properties:
 *
 * 1) sInteractionState
 * 2) sSelectionState
 * 3) sInputState
 *
 * this allows us to treat all selecor-controls equaly as to the assigment
 * of acc texts.
 */

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the LS ACC Event
 * @return {boolean}
 */
UCF_Selector_508_Delegate["prototype"]["handle508"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["handle508"]++; }; 

	if (!window["UCF_System"]["bIs508"]) return false;
	if (oBrowserEvent["oGetSourceControl"]() !== this["oSelector"]) return false;
	if (this["oSelector"]["sName"] && this["oSelector"]["sName"] === '') return false;

	this["assign_508_Fields"]();
	return true;
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["handle508"] = 0; };

/**
 * @private
 * in order to avoid a huge list of bools and different types of
 * properties we use assign three new fields a a selector that is
 * reused in the ACC event
 */
UCF_Selector_508_Delegate["prototype"]["assign_508_Fields"] = function() {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["assign_508_Fields"]++; }; 
	/** @type {UCF_Control} Checkbox, Radio Button or Tristate-Checkbox*/
	var oSelector = this["oSelector"];

	oSelector["sSelectionState"] = this["sGetSelectionState"]();
	oSelector["sInteractionState"] = this["sGetInteractionState"]();
	oSelector["sInputState"] = this["sGetInputState"]();
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["assign_508_Fields"] = 0; };

/**
 * @private
 * @return {enum-value}
 */
UCF_Selector_508_Delegate["prototype"]["sGetControlType"] = function() {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["sGetControlType"]++; }; 
	return this["oSelector"]["sClassName"];
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["sGetControlType"] = 0; };

// eslint-disable-next-line consistent-return
UCF_Selector_508_Delegate["prototype"]["sGetSelectionState"] = function() {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["sGetSelectionState"]++; }; 
	/** @type {UCF_Control} can be a checkbox, radio button or tristate-checkbox */
	var oSelector = this["oSelector"];
	/** @type {enum} */
	var _ = this["E_SELECTION_STATE"];

	if (typeof(oSelector["bChecked"]) !== 'undefined'
		&& typeof(oSelector["bChecked"]) !== undefined) {
		return oSelector["bChecked"] ? _["CHECKED"] : _["UNCHECKED"];;
	} else if (oSelector['sState']) {
		return oSelector["sState"];
	} else if (oSelector['sSelection']) {
		return oSelector["sSelection"];
	}
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["sGetSelectionState"] = 0; };

/**
 * @private
 * @return {enum-value}
 * The bellow combination of bools and properties corresponds with one
 * single value of the enumeration E_INTERACTION_STATE
 */
UCF_Selector_508_Delegate["prototype"]["sGetInteractionState"] = function() {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["sGetInteractionState"]++; }; 
	/** @type {UCF_Control} can be a checkbox, radio button or tristate-checkbox */
	var oSelector = this["oSelector"];
	/** @type {enum} */
	var _ = this["E_INTERACTION_STATE"];

	// --- selector has enumeratrions instead of bools
	if (oSelector['sInterAction']) {
		return oSelector["sInterAction"];
	}

	// --- interaction state is disabled
	if (!oSelector["bEnabled"])
		return _["DISABLED"];

	// --- interaction state is enabled
	if (oSelector["bEnabled"]
		&& !oSelector["bReadonly"]
		&& oSelector["sAssociatedEditContext"] === _["PARENTEDITABLE"])
		return _["ENABLED"];

	// --- interaction state is read only
	if (oSelector["bEnabled"] && oSelector["bReadonly"])
		return _["READONLY"];

	// --- interaction state is read only, again
	if (oSelector["bEnabled"]
		&& !oSelector["bReadonly"]
		&& oSelector["sAssociatedEditContext"] === this["E_INTERACTION_STATE"]["PARENTREADONLY"])
		return _["READONLY"];
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["sGetInteractionState"] = 0; };

/**
 * @private
 * @return {enum-value}
 */
UCF_Selector_508_Delegate["prototype"]["sGetInputState"] = function() {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["sGetInputState"]++; }; 
	if (this["oSelector"]["bInvalid"] && this["oSelector"]["sInputState"] !== this["E_INPUT_STATE"]["ERROR"]) {
		return this["E_INPUT_STATE"]["ERROR"];
	}
	return this["oSelector"]["sInputState"];
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["sGetInputState"] = 0; };

/**
 * @private
 * @param {string} sRole
 * @return {string} the key for the tutor
 *
 */
UCF_Selector_508_Delegate["prototype"]["findTutor"] = function(sRole) {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["findTutor"]++; }; 
	if (this["E_CONTROL_TYPE"][this["oSelector"]["sClassName"]] === this["E_CONTROL_TYPE"]["RADIOBUTTON"]
		&& this["sGetInteractionState"]() === this["E_INTERACTION_STATE"]["DISABLED"]) {
		return "R_DSBL_TUT";
	}

	if (this["oSelector"]["sInteractionState"] !== this["E_INTERACTION_STATE"]["ENABLED"])
		return null;

	return this["E_TUTOR"][sRole + '_' + this["oSelector"]["sSelectionState"]];
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["findTutor"] = 0; };

/**
 * @private
 * @return {boolean or null}
 *
 */
UCF_Selector_508_Delegate["prototype"]["bEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["bEnabled"]++; }; 
	/** @type {UCF_Control} can be a checkbox, radio button or tristate-checkbox */
	var oSelector = this["oSelector"];
	/** @type {enum} */
	var _ = this["E_INTERACTION_STATE"];

	// with the interaction state set to read only the control is not enabled
	// nevetheless the screen-reader must not announce 'unavailable'
	switch (oSelector["sInteractionState"]) {
		case _["READONLY"]:
			return null;

		case _["ENABLED"]:
			return true;

		case _["DISABLED"]:
			return false;
	}
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["bEnabled"] = 0; };

/**
 * Fires an ENTER Event
 *
 * @param { sTooltip } sTooltip a tootltip text not present in sTooltip
 * @private
 */
UCF_Selector_508_Delegate["prototype"]["addTooltip"] = function(sTooltip) {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["addTooltip"]++; }; 
	this["sTooltip"] = sTooltip;
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["addTooltip"] = 0; };

/**
 *
 * @param { oSelector } oSelector UCF_Control - any selector
 * @return {string} the tooltip
 * @private
 */
UCF_Selector_508_Delegate["prototype"]["sGetTooltip"] = function(oSelector) {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["sGetTooltip"]++; }; 
	if (UCF_StringUtil["bIsEmpty"](this["sTooltip"])
		|| typeof(this["sTooltip"]) === 'undefined') {
		return oSelector["sTooltip"];
	}

	return oSelector["sTooltip"] + ' ' + this["sTooltip"];
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["sGetTooltip"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the LS ACC
 */
UCF_Selector_508_Delegate["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Selector_508_Delegate.js(527): onlsaccessibility"); };

	/** @type {UCF_Control} can be a radio button, checkbox or tristate-checkbox*/
	var o;
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper;
	/** @type {string} */
	var sRole;
	/** @type {enum} */
	var SEL;
	/** @type {enum} */
	var INT;
	/** @type {enum} */
	var INP;

	if (!this["handle508"](oBrowserEvent)) return;

	oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	o = this["oSelector"];
	sRole = this["E_ROLE"][this["sGetControlType"]()];
	SEL = this["E_SELECTION_STATE"];
	INT = this["E_INTERACTION_STATE"];
	INP = this["E_INPUT_STATE"];

	// --- the role of oSelector
	oAccessibilityHelper["setControlType"](sRole);

	// --- all texts relevant for the selection state
	oAccessibilityHelper["setSelected"](o["sSelectionState"] === SEL["CHECKED"]);
	oAccessibilityHelper["setNotSelected"](o["sSelectionState"] === SEL["UNCHECKED"]);
	oAccessibilityHelper["setMixed"](o["sSelectionState"] === SEL["INDETERMINATE"]);

	// --- allTutors
	oAccessibilityHelper["addTutor"](this["findTutor"](sRole));

	// --- tooltip
	oAccessibilityHelper["setTooltip"](this["sGetTooltip"](o));

	// --- label
	// oAccessibilityHelper.setLabel(o.sText);
	oAccessibilityHelper["applyLabelingInfo"](o, o["sAccDescription"], o["sText"], '');

	// -- input states
	oAccessibilityHelper["setWarning"](o["sInputState"] === INP["WARNING"]);
	oAccessibilityHelper["setInvalid"](o["sInputState"] === INP["ERROR"]);

	// --- interaction states
	oAccessibilityHelper["setReadonly"](o["sInteractionState"] === INT["READONLY"]);
	oAccessibilityHelper["setEnabled"](this["bEnabled"]());

	oAccessibilityHelper["setItemCount"](this["iGetItemCount"]());
	oAccessibilityHelper["setItemIndex"](this["iGetIndex"]());

	// --- the access key
	oAccessibilityHelper["setAccessKey"](o["sAccessKey"]);

	// --- data tip
	if (this["oDataTip"]) {
		oAccessibilityHelper["setDataTip"](o["oDataTip"]["sText"]);
	}

	// --- high light info
	oAccessibilityHelper["applyHighlightInfo"](o["mGetHighlightInfo"]());

	// --- Update UCF_Control with ACC text
	o["sTitle"] = oAccessibilityHelper["sGetAccessibilityText"]();

	// this.fireEvent(this.E_EVENTS.Accessibility, {
	// 	oItem: this.aItems[this.iFocusedIndex]
	// });
};;if (__UCF_COVERAGE__) { UCF_Selector_508_Delegate["_"]["onlsaccessibility"] = 0; };

//** Following a list of 508 text keys as used in the LS Messagebundle*/
/*

The message bundle can be found in: UCF_MessageBundle["prototype"]["sGetRawText"]

SAPUR_C: "Checkbox"

SAPUR_CG: "Checkbox group with {0} items"
SAPUR_CG_END: "End of checkbox group"
SAPUR_CG_SHORTNAME: "Checkbox group"

SAPUR_R_DSBL_TUT: "To navigate to a different item use the arrow keys"
SAPUR_R_DSEL_TUT: "To deselect, press spacebar. To navigate to a different item, press Shift and use the arrow keys"
SAPUR_R_SEL_TUT: "To select a different item, use the arrow keys. To navigate to a different item press Shift and use the arrow keys."
SAPUR_R_TUT: "To select press spacebar. To navigate to a different item, press Shift and use the arrow keys"

SAPUR_TRI: "Tristate checkbox"
SAPUR_TRI_NSEL_TUT: "To select, press spacebar"
SAPUR_TRI_SEL_TUT: "To set to undefined, press spacebar"
SAPUR_TRI_UNDEF_TUT: "To deselect, press spacebar"

SAPUR_CHECK_TUT: "To check, press spacebar"
SAPUR_C_NSEL_TUT: "To select, press spacebar"
SAPUR_C_SEL_TUT: "To deselect, press spacebar"

SAPUR_ENABLED: ""
SAPUR_MIXED: "Mixed"
SAPUR_NOTCHECKED: "Not checked"

SAPUR_INVALID: "Invalid"
*/

};
sap["ls"]["preload"]["UCF_SessionMonitor"] = function() {/* global _trace, DEBUG, INFO, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_RequestUtil */
/// <reference path="../../core/util/RequestUtil.js"/>
/* global UCF_SystemPopup */
/// <reference path="../../core/util/SystemPopup.js" />
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_PostMessageServices */
/// <reference path="../controls/PostMessageServices.js"/>
/* eslint no-magic-numbers:0 */

/**
 * Session timeout monitor, keeps track of the current session timeout and shows
 * a popup window before session is actually timing out.
 *
 * This does only works if UCF is used to send the server requests, otherwise
 * we do not know, when a request to the server is sent.
 * @class
 * @param {UCF_LS} oLS the lightspeed object
 * @param {number} iTimeout the serverside session timeout in seconds
 * @param {string} sKeepAliveUrl the URL to call to keep the session alive
 * @param {string} sSessionTimeoutActionUrl Used for additional button to
 * trigger and action (e.g. reload the page)
 * @param {string} sSessionTimeoutActionTarget The target for the action Url
 * @param {string} sSessionTimeoutActionText The text on the action button
 * @param { string } sSessionTimeoutBehavior
 * @param { string } sUnloadUrl
 * @param { string } sSessionLogoutServiceName
 * @param { string } sSessionExtendServiceName
 * @param { number } iSessionTimeoutWarning
 */
function UCF_SessionMonitor(oLS, iTimeout, sKeepAliveUrl, sSessionTimeoutActionUrl,
	sSessionTimeoutActionTarget, sSessionTimeoutActionText, sSessionTimeoutBehavior, sUnloadUrl, sSessionLogoutServiceName,
	sSessionExtendServiceName, iSessionTimeoutWarning) {if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["UCF_SessionMonitor"]++; }; 
	/** @type {number} */
	var iCurrentTime;
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow;
	/** @type {UCF_EventHandler} */
	var oEventHandler;

	UCF_Object["apply"](this);

	if (!window["UCF_System"]["bIsUCF"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Session timeout handling can only used with UCF enabled', "SessionMonitor.js(50): UCF_SessionMonitor"); };

		return;
	}

	iCurrentTime = UCF_JsUtil["iGetTimeStamp"]();

	this["oLS"] = oLS;
	this["iTimeout"] = iTimeout * 1000;
	this["sUnloadUrl"] = sUnloadUrl; // eslint-disable-line @ur/no-memory-leaks
	this["sKeepAliveUrl"] = sKeepAliveUrl;
	this["sSessionTimeoutActionUrl"] = sSessionTimeoutActionUrl;
	this["sSessionTimeoutActionTarget"] = sSessionTimeoutActionTarget;
	this["sSessionTimeoutActionText"] = sSessionTimeoutActionText;
	this["sSessionExtendServiceName"] = sSessionExtendServiceName;
	this["bTimedOut"] = false;

	this["iLastServerRequest"] = iCurrentTime;
	this["iLastUserInteraction"] = iCurrentTime;

	this["iBeforeTimeout"] = this["iTimeout"] - Math["min"](120000, Math["floor"](this["iTimeout"] * 0.2));
	this["iCheckThreshold"] = Math["floor"](this["iTimeout"] * 0.1);
	this["bWarnPopupActive"] = false;
	this["sSessionTimeoutBehavior"] = sSessionTimeoutBehavior; // eslint-disable-line @ur/no-memory-leaks
	this["iSessionTimeoutWarning"] = iSessionTimeoutWarning * 1000; // eslint-disable-line @ur/no-memory-leaks
	// temp for developing

	if (this["sSessionTimeoutBehavior"] === 'PAGE' || this["sSessionTimeoutBehavior"] === 'POPUP' || this["sSessionTimeoutBehavior"] === 'POPUPWINDOW') {
		this["iInterval"] = UCF_JsUtil["intervalCall"](1000, this, 'checkTimeout');

		this["oSystemPopup"] = new (UCF_ClassLoader["oGetClass"]("UCF_SystemPopup"))(); // eslint-disable-line @ur/no-memory-leaks

		oBrowserWindow = this["oLS"]["oBrowserWindow"];
		oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this, 'onUserInteraction');

		oEventHandler = this["oLS"]["oEventHandler"];
		oEventHandler["attachEvent"](oEventHandler["E_EVENTS"]["AfterRequestSubmit"], this, 'onServerRequest');
	} else if (this["sSessionTimeoutBehavior"] === 'POSTMESSAGE') {
		// Don't let the session time out
		// The service from "sap.ushell.sessionHandler.logout"
		var self = this;
		if (!sSessionLogoutServiceName)
			sSessionLogoutServiceName = "sap.ushell.sessionHandler.logout";
		if (this["sUnloadUrl"] && this["sUnloadUrl"] !== '')
			UCF_PostMessageServices["addPostMessageService"](sSessionLogoutServiceName,
				function(sService, oEvent) {
					try {
						var oMessage = UCF_JsUtil["oJsonParse"](oEvent["data"]);
						oMessage["status"] = 'success';
						oMessage["type"] = 'response';
					} catch (e) {}
					self["logout"]();
					return oMessage;
				});
		if (this["sSessionExtendServiceName"]) {
			UCF_PostMessageServices["addPostMessageService"](this["sSessionExtendServiceName"],
				function(sService, oEvent) {
					try {
						var oMessage = UCF_JsUtil["oJsonParse"](oEvent["data"]);
						oMessage["status"] = 'success';
						oMessage["type"] = 'response';
					} catch (e) {}
					self["keepSessionAlive"]();
					return oMessage;
				});
		}
		this["iInterval"] = UCF_JsUtil["intervalCall"](this["iBeforeTimeout"], this, 'keepSessionAlive');
		this["oLS"]["oEventHandler"]["attachEvent"](this["oLS"]["oEventHandler"]["E_EVENTS"]["AfterRequestSubmit"], this, 'onServerRequestKeepAlive');
	}
};window["UCF_SessionMonitor"] = UCF_SessionMonitor; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SessionMonitor"); UCF_SessionMonitor["_"] = {UCF_SessionMonitor: 0}; }; 
UCF_SessionMonitor["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_SessionMonitor.prototype["sClassName"] = "UCF_SessionMonitor";

UCF_SessionMonitor["prototype"]["logout"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["logout"]++; }; 
	UCF_JsUtil["clearIntervalCall"](this["iInterval"]);
	this["oLS"]["oEventHandler"]["detachEvent"](this["oLS"]["oEventHandler"]["E_EVENTS"]["AfterRequestSubmit"], this,
		'onServerRequestKeepAlive');
	UCF_RequestUtil["sendSyncRequest"](
		this["sUnloadUrl"] +
		(this["sUnloadUrl"]["indexOf"]('?') > -1 ? '&' : '?'),
		'GET'
	);
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["logout"] = 0; };

UCF_SessionMonitor["prototype"]["keepSessionAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["keepSessionAlive"]++; }; 
	this["onServerRequestKeepAlive"]();
	this["sendSessionKeepAliveRequest"]();
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["keepSessionAlive"] = 0; };

UCF_SessionMonitor["prototype"]["onServerRequestKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["onServerRequestKeepAlive"]++; }; 
	UCF_JsUtil["clearIntervalCall"](this["iInterval"]);
	this["iInterval"] = UCF_JsUtil["intervalCall"](this["iBeforeTimeout"], this, 'keepSessionAlive');
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["onServerRequestKeepAlive"] = 0; };

/** @override */
UCF_SessionMonitor["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["destroy"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow;
	/** @type {UCF_EventHandler} */
	var oEventHandler;

	if (this["oSystemPopup"]) {
		oBrowserWindow = this["oLS"]["oBrowserWindow"];
		if (oBrowserWindow) {
			oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this);
		}

		oEventHandler = this["oLS"]["oEventHandler"];
		if (oEventHandler) {
			oEventHandler["detachEvent"](oEventHandler["E_EVENTS"]["AfterRequestSubmit"], this);
		}

		this["oSystemPopup"]["destroy"]();
		this["oSystemPopup"] = null;
	}

	// Needed AFTER destroy was called for the SessionTimeoutActionURl feature of the page
	// See onButtonPress...
	UCF_SessionMonitor["_sSessionTimeoutActionUrl"] = this["sSessionTimeoutActionUrl"];
	UCF_SessionMonitor["_sSessionTimeoutActionTarget"] = this["sSessionTimeoutActionTarget"];

	this["iInterval"] = null;
	this["iCheckThreshold"] = null;
	this["iBeforeTimeout"] = null;
	this["iLastUserInteraction"] = null;
	this["iLastServerRequest"] = null;
	this["sSessionTimeoutActionText"] = null;
	this["sSessionTimeoutActionTarget"] = null;
	this["sSessionTimeoutActionUrl"] = null;
	this["sSessionExtendServiceName"] = null;
	this["sKeepAliveUrl"] = null;
	this["iTimeout"] = null;
	this["oLS"] = null;
	this["oSessionTimeoutWarningPopup"] = null;
	this["iCounterUpdateInterval"] = null;
	this["iUpdateCounterValue"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["destroy"] = 0; };

/**
 * Event handler for the AnyEvent event in the BrowserWindow
 * @param {UCF_Event<{oBrowserEvent: UCF_BrowserEvent}>} oEvent
 */
UCF_SessionMonitor["prototype"]["onUserInteraction"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["onUserInteraction"]++; }; 
/*	if (oEvent.mParameters.oBrowserEvent.sName.indexOf('mouse') === 0) {
		// TODO touch?
		return;
	}
*/
	if (!this["oSystemPopup"]["bIsOpen"]) {
		this["iLastUserInteraction"] = UCF_JsUtil["iGetTimeStamp"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["onUserInteraction"] = 0; };

/** Event handler for the AfterRequestSubmit event in the EventHandler */
UCF_SessionMonitor["prototype"]["onServerRequest"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["onServerRequest"]++; }; 
	this["iLastServerRequest"] = UCF_JsUtil["iGetTimeStamp"]();
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["onServerRequest"] = 0; };

/** Event handler for the Button event in the SystemPopup */
UCF_SessionMonitor["prototype"]["onButtonPress"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["onButtonPress"]++; }; 
	if (!this["bTimedOut"]) {
		this["sendSessionKeepAliveRequest"](true);
	}
	this["oLS"]["unlock"]();
	this["oSystemPopup"]["hide"]();
	this["bWarnPopupActive"] = false;
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["onButtonPress"] = 0; };

/** Event handler for the action-Button event in the SystemPopup */
UCF_SessionMonitor["prototype"]["onActionButtonPress"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["onActionButtonPress"]++; }; 
	this["bWarnPopupActive"] = false;

	// Redirect with given URL and target
	UCF_RequestUtil["sendFormRequest"](
		'GET',
		UCF_SessionMonitor["_sSessionTimeoutActionUrl"], {},
		UCF_SessionMonitor["_sSessionTimeoutActionTarget"]
	);
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["onActionButtonPress"] = 0; };

/** Checks, whether the timeout has been reached and takes appropriate action */
UCF_SessionMonitor["prototype"]["checkTimeout"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["checkTimeout"]++; }; 
	/** @type {number} */
	var iCurrentTime = UCF_JsUtil["iGetTimeStamp"]();
	/** @type {number} */
	var iUserInteractionDiff = iCurrentTime - this["iLastUserInteraction"];
	/** @type {number} */
	var iServerRequestDiff = iCurrentTime - this["iLastServerRequest"];

	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Last user interaction: ' + iUserInteractionDiff + ', last roundtrip: ' + iServerRequestDiff, "SessionMonitor.js(239): checkTimeout"); };

	if (iServerRequestDiff > this["iTimeout"]) {
		// Session is already timed out, destroy it
		this["bTimedOut"] = true;
		if (this["sSessionTimeoutBehavior"] === 'POPUPWINDOW')
			this["modifyTimeOutWarning"]( false );
		else
			this["showSessionTimeoutPopup"]();
		UCF_JsUtil["clearIntervalCall"](this["iInterval"]);
		if (this["sSessionTimeoutBehavior"] !== 'POPUPWINDOW')
			this["oLS"]["destroy"]();

		return;
	}

	if (
		iServerRequestDiff > this["iCheckThreshold"] &&
		this["sKeepAliveUrl"] &&
		iUserInteractionDiff < iServerRequestDiff
	) {
		// If there have been user interactions since the last request, just
		// prolong the session
		if (!this["oSessionTimeoutWarningPopup"])
			this["sendSessionKeepAliveRequest"]();
	}
	if (
		(iServerRequestDiff > this["iBeforeTimeout"] ||
			(this["iSessionTimeoutWarning"] > 0 && iServerRequestDiff > (this["iTimeout"] - this["iSessionTimeoutWarning"]))) &&
		!this["bWarnPopupActive"] &&
		this["sKeepAliveUrl"] &&
		this["sKeepAliveUrl"] !== ''
	) {
		// Otherwise show a warning popup to notify the user that the session is
		// about to expire
		this["bWarnPopupActive"] = true;
		if (this["sSessionTimeoutBehavior"] === 'POPUPWINDOW')
			this["showSessionTimeoutWarningPopup"]();
		else
			this["showSessionWarningPopup"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["checkTimeout"] = 0; };

/** @param {boolean} bForceReset */
UCF_SessionMonitor["prototype"]["sendSessionKeepAliveRequest"] = function(bForceReset) {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["sendSessionKeepAliveRequest"]++; }; 
	/** @type {number} */
	var iCurrentTime = UCF_JsUtil["iGetTimeStamp"]();

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Send session keepalive request to prolong the session.', "SessionMonitor.js(287): sendSessionKeepAliveRequest"); };

	if (this["sKeepAliveUrl"] !== '' && !this["oLS"]["bIsSleeping"]()) {
		this["iLastServerRequest"] = iCurrentTime;
		UCF_RequestUtil["sendSyncRequest"](
			this["sKeepAliveUrl"] +
			(this["sKeepAliveUrl"]["indexOf"]('?') > -1 ? '&' : '?') +
			'$time=' +
			iCurrentTime,
			'GET'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["sendSessionKeepAliveRequest"] = 0; };

/** */
UCF_SessionMonitor["prototype"]["showSessionWarningPopup"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["showSessionWarningPopup"]++; }; 
	/** @type {number} */
	var iCurrentTime = UCF_JsUtil["iGetTimeStamp"]();
	/** @type {number} */
	var iTimeSinceLastRequest = iCurrentTime - this["iLastServerRequest"];
	/** @type {number} */
	var iRemainingTime = Math["floor"]((this["iTimeout"] - iTimeSinceLastRequest) / 1000);
	/** @type {number} */
	var iRemainingMinutes = Math["max"](Math["floor"](iRemainingTime / 60), 0);
	/** @type {number|string} */
	var iRemainingSeconds = Math["max"](iRemainingTime % 60, 0);
	/** @type {string} */
	var sTitle = this["oLS"]["sGetText"]('SAPUR_STO_WARNING') + ': ' + document["title"];
	/** @type {string} */
	var sButtonText = this["oLS"]["sGetText"]('SAPUR_STO_WARN_CONTINUE');
	/** @type {string[]} */
	var aContent = [];

	if (iRemainingSeconds < 10) {
		iRemainingSeconds = '0' + iRemainingSeconds;
	}

	aContent["push"]('<div class="lsSessionMonitor__content"');
	aContent["push"](this["oLS"]["sGetText"](
		'SAPUR_STO_WARN_TEXT',
		[iRemainingMinutes, iRemainingSeconds]
	));
	if (this["oLS"]["bIsDirty"]()) {
		aContent["push"](' ');
		aContent["push"](this["oLS"]["sGetText"]('SAPUR_STO_WARN_UNSAVED'));
	}
	aContent["push"]('<br><br>');
	aContent["push"](this["oLS"]["sGetText"]('SAPUR_STO_WARN_ADVICE', [sButtonText]));
	aContent["push"]('</div>');

	this["oSystemPopup"]["setTitle"](sTitle);
	this["oSystemPopup"]["setContent"](aContent["join"](''));
	this["oSystemPopup"]["clearButtons"]();
	this["oSystemPopup"]["setButton"]('SessionMonitorButton', sButtonText);
	// this.oSystemPopup.attachEvent(
	// 	this.oSystemPopup.E_EVENTS.Button,
	// 	this,
	// 	'onButtonPress'
	// );
	var _this = this;
	var fHandler = function(a) {
		_this["onButtonPress"](a);
	};
	this["oSystemPopup"]["onClick"](fHandler);
	this["oSystemPopup"]["show"]();
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["showSessionWarningPopup"] = 0; };

/** */
UCF_SessionMonitor["prototype"]["showSessionTimeoutPopup"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["showSessionTimeoutPopup"]++; }; 
	/** @type {string} */
	var sTitle = this["oLS"]["sGetText"]('SAPUR_STO_TIMEOUT') + ': ' + document["title"];
	/** @type {string} */
	var sButtonText = this["oLS"]["sGetText"]('SAPUR_STO_TIME_CLOSE');
	/** @type {string[]} */
	var aContent = [];

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Session timeout after ' + Math["floor"](this["iTimeout"] / 1000) + ' seconds.', "SessionMonitor.js(363): showSessionTimeoutPopup"); };

	aContent["push"]('<div class="lsSessionMonitor__content"');
	aContent["push"](this["oLS"]["sGetText"]('SAPUR_STO_TIME_TEXT'));
	if (this["oLS"]["bIsDirty"]()) {
		aContent["push"](' ');
		aContent["push"](this["oLS"]["sGetText"]('SAPUR_STO_TIME_UNSAVED'));
	}
	aContent["push"]('<br><br>');
	aContent["push"](this["oLS"]["sGetText"]('SAPUR_STO_TIME_TIPS'));
	aContent["push"](':<ul>');
	aContent["push"]('<li>' + this["oLS"]["sGetText"]('SAPUR_STO_TIME_TIP1'));
	aContent["push"]('</ul></div>');

	this["oSystemPopup"]["setTitle"](sTitle);
	this["oSystemPopup"]["setContent"](aContent["join"](''));
	this["oSystemPopup"]["clearButtons"]();
	var _this = this;
	var fHandler;
	if (this["sSessionTimeoutActionUrl"]) {
		this["oSystemPopup"]["setButton"]('ActionButton', this["sSessionTimeoutActionText"], 0);
		fHandler = function(a) {
			_this["onActionButtonPress"](a);
		};
		this["oSystemPopup"]["onClick"](fHandler);
	} else {
		this["oSystemPopup"]["setButton"]('SessionMonitorButton', sButtonText, 1);
		fHandler = function(a) {
			_this["onButtonPress"](a);
		};
		this["oSystemPopup"]["onClick"](fHandler);
	}
	this["oSystemPopup"]["show"]();
};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["showSessionTimeoutPopup"] = 0; };

UCF_SessionMonitor["prototype"]["showSessionTimeoutWarningPopup"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["showSessionTimeoutWarningPopup"]++; }; 
	this["sPopupId"] = 'ls_timeoutpopup';
	var iNow = UCF_JsUtil["iGetTimeStamp"]();
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iLogoutTime"] = iNow + this["iTimeout"] - (iNow - this["iLastServerRequest"]);
	this["iUpdateCounterValue"] = parseInt((this["iLogoutTime"] - iNow) / 1000);
	//this.iUpdateCounterValue = (this.iTimeout - this.iSessionTimeoutWarning) / 1000;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iFullCounterValue"] = this["iUpdateCounterValue"];
	this["oLS"]["oCreateClientControl"]({
		"PopupWindow": {
			"Id": this["sPopupId"],
			"Title": this["oLS"]["sGetText"]('SAPUR_SMO_ATTENTION'),
			"InfoType": 'WARNING',
			"Width": '35rem',
			"IsResizable": false,
			"HasCloseButton": false,
			"Content": {
				"SingleColumnLayout": {
					"MarginLeft": '1rem',
					"MarginRight": '1rem',
					"Cells": [{
							"SingleColumnLayoutCell": {
								"Content": {
									"FlowLayout": {
										"FlowLayoutItems": [{
											"FlowLayoutItem": {
												"ItemDesign": 'LPAD',
												"Control": {
													"TextView": { "Design": 'EMPHASIZED', "SemanticColor": 'CRITICAL', "Id": this["sPopupId"] + 'message', "Text": this["sGetTimeoutCounterText"]()
														}
												}
											}
										}
										]
									}
								}
							}
						},
						{
							"SingleColumnLayoutCell": {
								"Content": {
									"ProgressIndicator": {
										"Width": '100%', "BarColor": 'CRITICAL', "Id": this["sPopupId"] + '-pi', "PercentValue": 0, "DisplayValue": ''
									}
								}
							}
						}
					]
					}
				},
				"FooterToolbar": {
					"Toolbar": {
						"Design": 'FOOTER',
						"Id": this["sId"] + '-toolbar',
						"RightItems": [{
								"ToolbarButton": { "Id": this["sPopupId"] + '-toolbar-ok', "Text": this["oLS"]["sGetText"]('SAPUR_SMO_CONTINUE'),
									"Design": 'EMPHASIZED', "Enabled": false }
							},
							{
								"ToolbarButton": { "Id": this["sPopupId"] + '-toolbar-cancel', "Text": this["oLS"]["sGetText"]('SAPUR_SMO_SIGNOUT') }
							}
							]
					}
				}
			}
		})["placeAt"](this["oLS"]["oGetAssociatedAreaRef"]()["id"]);

		var that = this;
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-toolbar-cancel')["attachPress"](function() {
			that["cancel"]();
		});
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-toolbar-ok')["attachPress"](function() {
			that["okPressed"]();
		});
		this["oSessionTimeoutWarningPopup"] = this["oLS"]["oGetClientControlById"](this["sPopupId"]);
		this["iCounterUpdateInterval"] = UCF_JsUtil["intervalCall"](1000, this, 'updateTimeoutCounter');
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-toolbar-ok')["setEnabled"](true);
	};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["showSessionTimeoutWarningPopup"] = 0; };

	UCF_SessionMonitor["prototype"]["keyPressed"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["keyPressed"]++; }; 
	};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["keyPressed"] = 0; };

	UCF_SessionMonitor["prototype"]["modifyTimeOutWarning"] = function(bAlive){;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["modifyTimeOutWarning"]++; }; 
		if (!this["sPopupId"]) return;
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + 'message')["setText"](this["oLS"]["sGetText"]('SAPUR_SMO_TIMEOUTSIGNOUT'));
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-toolbar-ok')["setEnabled"](bAlive);
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-toolbar-cancel')["setEnabled"](bAlive);
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-pi')["setDisplayValue"]('');
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-pi')["setPercentValue"](100);
		UCF_JsUtil["clearIntervalCall"](this["iCounterUpdateInterval"]);
		this["iCounterUpdateInterval"] = 0;
		this["logout"]();
		this["oLS"]["oGetPage"]()["disableContextMenuEvent"]();
	};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["modifyTimeOutWarning"] = 0; };

	UCF_SessionMonitor["prototype"]["sGetTimeoutCounterText"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["sGetTimeoutCounterText"]++; }; 
		if (this["iUpdateCounterValue"] > 60) {
			var sDelim = '';
			if ((this["iUpdateCounterValue"] - 60 * Math["floor"](this["iUpdateCounterValue"] / 60)) < 10)
				sDelim = '0';
			return(
				this["oLS"]["sGetText"]('SAPUR_SMO_TIMEOUTWARNINGMIN',
					[Math["floor"](this["iUpdateCounterValue"] / 60), sDelim + (this["iUpdateCounterValue"] - 60 * Math["floor"](this["iUpdateCounterValue"] / 60))]));
		} else
			return (
				this["oLS"]["sGetText"]('SAPUR_SMO_TIMEOUTWARNING', [this["iUpdateCounterValue"]]));
	};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["sGetTimeoutCounterText"] = 0; };

	UCF_SessionMonitor["prototype"]["updateTimeoutCounter"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["updateTimeoutCounter"]++; }; 
		if (this["bIsDestroyed"] || this["iCounterUpdateInterval"] === 0)
			return;
		if (this["iUpdateCounterValue"] <= 1){
			this["modifyTimeOutWarning"](false);
			return;
		}

		var iNow = UCF_JsUtil["iGetTimeStamp"]();
		this["iUpdateCounterValue"] = parseInt((this["iLogoutTime"] - iNow) / 1000);
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + 'message')["setText"](
				this["sGetTimeoutCounterText"]());
		var iPercentValue = (this["iFullCounterValue"] - this["iUpdateCounterValue"]) / this["iFullCounterValue"] * 100;
		if (iPercentValue > 70)
			this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-pi')["setBarColor"]('NEGATIVE');
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-pi')["setPercentValue"](iPercentValue);
	};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["updateTimeoutCounter"] = 0; };

	UCF_SessionMonitor["prototype"]["cancel"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["cancel"]++; }; 
		UCF_JsUtil["clearIntervalCall"](this["iCounterUpdateInterval"]);
		this["iCounterUpdateInterval"] = 0;
		this["logout"]();
		this["oLS"]["oGetPage"]()["disableContextMenuEvent"]();
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + 'message')["setText"](this["oLS"]["sGetText"]('SAPUR_SMO_SIGNEDOUT'));
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-toolbar-ok')["setEnabled"](false);
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-toolbar-cancel')["setEnabled"](false);
		this["oLS"]["oGetClientControlById"](this["sPopupId"] + '-pi')["setPercentValue"](100);
	};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["cancel"] = 0; };

	UCF_SessionMonitor["prototype"]["okPressed"] = function() {;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["okPressed"]++; }; 
		UCF_JsUtil["clearIntervalCall"](this["iCounterUpdateInterval"]);
		this["iCounterUpdateInterval"] = 0;
		this["sendSessionKeepAliveRequest"]();
		this["bWarnPopupActive"] = false;
		this["oLS"]["oGetPopupManager"]()["closePopup"](this["sPopupId"]);
		this["oSessionTimeoutWarningPopup"]["destroy"]();
		this["oSessionTimeoutWarningPopup"] = null;
	};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["okPressed"] = 0; };

	/** @param {string} sKeepAliveUrl */
	UCF_SessionMonitor["prototype"]["setKeepAliveUrl"] = function(sKeepAliveUrl){;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["setKeepAliveUrl"]++; }; 
		this["sKeepAliveUrl"] = sKeepAliveUrl;
	};;if (__UCF_COVERAGE__) { UCF_SessionMonitor["_"]["setKeepAliveUrl"] = 0; };

};
sap["ls"]["preload"]["UCF_Shuttle"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Shuttle(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["UCF_Shuttle"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Shuttle.js(27): UCF_Shuttle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Shuttle.js(28): UCF_Shuttle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Shuttle.js(29): UCF_Shuttle"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	/** @type {UCF_Cache} */
	this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
};window["UCF_Shuttle"] = UCF_Shuttle; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Shuttle"); UCF_Shuttle["_"] = {UCF_Shuttle: 0}; }; ;
UCF_Shuttle["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Shuttle.prototype["sClassName"] = "UCF_Shuttle";

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Shuttle["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Shuttle.js(45): onclick"); };

	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}

	var oSource = oBrowserEvent["oGetSource"]();

	this["fireEvents"](oSource);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onclick"] = 0; };

/**
 * Handles the [ENTER] event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Shuttle["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Shuttle.js(67): onlsenter"); };

	var oSource = oBrowserEvent["oGetSource"]();

	this["fireEvents"](oSource);
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsenter"] = 0; };

/**
 * Handles the [SPACE] event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Shuttle["prototype"]["onlsspaceup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsspaceup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Shuttle.js(83): onlsspaceup"); };

	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}

	var oSource = oBrowserEvent["oGetSource"]();

	this["fireEvents"](oSource);
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsspaceup"] = 0; };

/**
 * Handles the events
 *
 * @param {HTMLElement} oSource
 * @private
 */
UCF_Shuttle["prototype"]["fireEvents"] = function(oSource) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["fireEvents"]++; }; 

	if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-A") {
		this["fireAdd"](this["sId"]);
	}
	if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-AA") {
		this["fireAddAll"](this["sId"]);
	}
	if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-R") {
		this["fireRemove"](this["sId"]);
	}
	if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-RA") {
		this["fireRemoveAll"](this["sId"]);
	}

};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["fireEvents"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Shuttle["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Shuttle.js(127): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setControlType"]("B");
	if (this["sShuttleBehavior"] === "ADD") {
		if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-AA") {
			if (this["sTooltipAddAllButton"]) {
				oAccessibilityHelper["setTooltip"](this["sTooltipAddAllButton"]);
			} else {
				oAccessibilityHelper["addTutor"]("PG_AA");
			}
		} else if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-A") {
			if (this["sTooltipAddButton"]) {
				oAccessibilityHelper["setTooltip"](this["sTooltipAddButton"]);
			} else {
				oAccessibilityHelper["addTutor"]("PG_A");
			}
		}
		if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-RA") {
			if (this["sTooltipRemoveAllButton"]) {
				oAccessibilityHelper["setTooltip"](this["sTooltipRemoveAllButton"]);
			} else {
				oAccessibilityHelper["addTutor"]("PG_RA");
			}
		} else if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-R") {
			if (this["sTooltipRemoveButton"]) {
				oAccessibilityHelper["setTooltip"](this["sTooltipRemoveButton"]);
			} else {
				oAccessibilityHelper["addTutor"]("PG_R");
			}
		}
		if (oSource["className"]["indexOf"]("Dsbl") > -1) {
			oAccessibilityHelper["addTutor"]("DISABLED");
		} else {
			oAccessibilityHelper["addTutor"]("B_TUT");
		}
	} else {
		if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-AA") {
			if (this["sTooltipAddAllButton"]) {
				oAccessibilityHelper["setTooltip"](this["sTooltipAddAllButton"]);
			} else {
				oAccessibilityHelper["addTutor"]("PG_MB");
			}
		} else if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-A") {
			if (this["sTooltipAddButton"]) {
				oAccessibilityHelper["setTooltip"](this["sTooltipAddButton"]);
			} else {
				oAccessibilityHelper["addTutor"]("PG_MD");
			}
		}
		if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-RA") {
			if (this["sTooltipRemoveAllButton"]) {
				oAccessibilityHelper["setTooltip"](this["sTooltipRemoveAllButton"]);
			} else {
				oAccessibilityHelper["addTutor"]("PG_MT");
			}
		} else if (UCF_DomUtil["sGetAttribute"](oSource, "data-shuttle-type") === "buttontype-R") {
			if (this["sTooltipRemoveButton"]) {
				oAccessibilityHelper["setTooltip"](this["sTooltipRemoveButton"]);
			} else {
				oAccessibilityHelper["addTutor"]("PG_MU");
			}
		}
		if (oSource["className"]["indexOf"]("Dsbl") > -1) {
			oAccessibilityHelper["addTutor"]("DISABLED");
		} else {
			oAccessibilityHelper["addTutor"]("B_TUT");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsaccessibility"] = 0; };

/**
 * Passes all items that are neccessary for the navigation to the navigation framework
 * @return {UCF_Button[]}
 */
UCF_Shuttle["prototype"]["oGetButtons"] = function() {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["oGetButtons"]++; }; 

	/** @type {UCF_Shuttle} */
	var self = this;

	return this["oCache"]["get"]('oButtons', function() {
		return UCF_DomUtil["querySelectorAll"]('button', self["oDomRef"]);
	});
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["oGetButtons"] = 0; };

/**
 * Passes all items that are neccessary for the navigation to the navigation framework
 * @param {DOMElement} oDomRef
 * @return {int}
 */
UCF_Shuttle["prototype"]["iGetPosition"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["iGetPosition"]++; }; 

	var oButtons = this["oGetButtons"]();
	var iCurrentPosition = 0;

	for (var i = 0; i < oButtons["length"]; i++) {
		iCurrentPosition = i;
		if (oButtons[i] === oDomRef)
			break;
	}

	return iCurrentPosition;
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["iGetPosition"] = 0; };

/**
 *  [RIGHT]
 * @param { UCF_BrowserEvent } oBrowserEvent the lsnext
 * @private
 */
UCF_Shuttle["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsright"]++; }; 

	var oSourceDomRef = oBrowserEvent["oGetSource"](),
		oNextDomRef,
		aButtons = this["oGetButtons"]();
	var iCurrentIndex = this["iGetPosition"](oSourceDomRef);
	var iNextIndex = iCurrentIndex < (aButtons["length"] - 1) ? iCurrentIndex + 1 : iCurrentIndex;
	oNextDomRef = aButtons[iNextIndex];
	if (oNextDomRef) {
		UCF_DomUtil["moveFocusDomElement"](oNextDomRef, true);
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsright"] = 0; };

/**
 *  [DOWN]
 * @param { UCF_BrowserEvent } oBrowserEvent the lsnext
 * @private
 */
UCF_Shuttle["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsdown"]++; }; 

	this["onlsright"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsdown"] = 0; };

/**
 *  [LEFT]
 * @param { UCF_BrowserEvent } oBrowserEvent the lsleft
 * @private
 */
UCF_Shuttle["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsleft"]++; }; 

	var oSourceDomRef = oBrowserEvent["oGetSource"](),
		oPreviousDomRef,
		aButtons = this["oGetButtons"]();
	var iCurrentIndex = this["iGetPosition"](oSourceDomRef);
	var iNextIndex = iCurrentIndex === 0 ? 0 : iCurrentIndex - 1;
	oPreviousDomRef = aButtons[iNextIndex];
	if (oPreviousDomRef) {
		UCF_DomUtil["moveFocusDomElement"](oPreviousDomRef, true);
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsleft"] = 0; };

/**
 *  [UP]
 * @param { UCF_BrowserEvent } oBrowserEvent the lsup
 * @private
 */
UCF_Shuttle["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsup"]++; }; 

	this["onlsleft"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsup"] = 0; };

/**
 *  [HOME]
 * @param { UCF_BrowserEvent } oBrowserEvent the lshome
 * @private
 */
UCF_Shuttle["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlshome"]++; }; 

	var oPreviousDomRef,
		aButtons = this["oGetButtons"]();

	oPreviousDomRef = aButtons[0];
	if (oPreviousDomRef) {
		UCF_DomUtil["moveFocusDomElement"](oPreviousDomRef, true);
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlshome"] = 0; };

/**
 *  [END]
 * @param { UCF_BrowserEvent } oBrowserEvent the lsend
 * @private
 */
UCF_Shuttle["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsend"]++; }; 

	var oPreviousDomRef,
		aButtons = this["oGetButtons"]();

	oPreviousDomRef = aButtons[aButtons["length"] - 1];
	if (oPreviousDomRef) {
		UCF_DomUtil["moveFocusDomElement"](oPreviousDomRef, true);
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsend"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Shuttle["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Shuttle["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["onlsskipback"] = 0; };

/** @override */
UCF_Shuttle["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["destroy"]++; }; 

	if (this["oCache"]) {
		this["oCache"]["destroy"]();
		this["oCache"] = null;
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Shuttle["prototype"]["aAttributeNames"] = ["sShuttleBehavior","sTooltipAddButton","sTooltipAddAllButton","sTooltipRemoveButton","sTooltipRemoveAllButton","sVisibility","sCustomData","sAccessibilityDescription"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Shuttle["prototype"]["aEventNames"] = ["Add","RemoveAll","AddAll","Remove"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Shuttle["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ShuttleBehavior}
 */
UCF_Shuttle["prototype"]["sShuttleBehavior"] = "ADD";

/**
 * @private
 * @type {string}
 */
UCF_Shuttle["prototype"]["sTooltipAddButton"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Shuttle["prototype"]["sTooltipAddAllButton"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Shuttle["prototype"]["sTooltipRemoveButton"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Shuttle["prototype"]["sTooltipRemoveAllButton"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Shuttle["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_Shuttle["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Shuttle["prototype"]["sAccessibilityDescription"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Shuttle["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["setDefaultValues"]++; }; 
	this["sShuttleBehavior"] = "ADD";
	this["sTooltipAddButton"] = '';
	this["sTooltipAddAllButton"] = '';
	this["sTooltipRemoveButton"] = '';
	this["sTooltipRemoveAllButton"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["sAccessibilityDescription"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("ShuttleBehavior", "ADD", true);
		this["setClientProperty"]("TooltipAddButton", '', true);
		this["setClientProperty"]("TooltipAddAllButton", '', true);
		this["setClientProperty"]("TooltipRemoveButton", '', true);
		this["setClientProperty"]("TooltipRemoveAllButton", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Shuttle::Add
 */
UCF_Shuttle["prototype"]["fireAdd"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["fireAdd"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Shuttle.js(474): fireAdd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Shuttle.js(475): fireAdd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Shuttle.js(476): fireAdd"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Shuttle", "Add", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["fireAdd"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Shuttle::RemoveAll
 */
UCF_Shuttle["prototype"]["fireRemoveAll"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["fireRemoveAll"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Shuttle.js(493): fireRemoveAll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Shuttle.js(494): fireRemoveAll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Shuttle.js(495): fireRemoveAll"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Shuttle", "RemoveAll", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["fireRemoveAll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Shuttle::AddAll
 */
UCF_Shuttle["prototype"]["fireAddAll"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["fireAddAll"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Shuttle.js(512): fireAddAll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Shuttle.js(513): fireAddAll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Shuttle.js(514): fireAddAll"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Shuttle", "AddAll", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["fireAddAll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Shuttle::Remove
 */
UCF_Shuttle["prototype"]["fireRemove"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["fireRemove"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Shuttle.js(531): fireRemove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Shuttle.js(532): fireRemove"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Shuttle.js(533): fireRemove"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Shuttle", "Remove", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Shuttle["_"]["fireRemove"] = 0; };

};
sap["ls"]["preload"]["UCF_SidePopup"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_PopupBase */
/// <reference path="../helper/PopupBase.js"/>

/**
 * The SidePopup control
 * @class
 * @param {HMTLElement} oDomRef The DOM reference
 * @param {UCF_LS} oLS The LS instance
 * @extends UCF_PopupBase
 */
function UCF_SidePopup(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SidePopup["_"]["UCF_SidePopup"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "SidePopup.js(21): UCF_SidePopup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SidePopup.js(22): UCF_SidePopup"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SidePopup.js(23): UCF_SidePopup"); };

	UCF_PopupBase["apply"](this, [oDomRef, oLS]);
};window["UCF_SidePopup"] = UCF_SidePopup; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SidePopup"); UCF_SidePopup["_"] = {UCF_SidePopup: 0}; }; ;
UCF_SidePopup["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PopupBase"))(); UCF_SidePopup.prototype["sClassName"] = "UCF_SidePopup";

/**
 * @private
 * @see UCF_PopupBase#show
 */
UCF_SidePopup["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_SidePopup["_"]["show"]++; }; 
	this["oDomRef"]["style"]["top"] = '0px';
	if (window["UCF_System"]["bIsRTL"]) {
		this["oDomRef"]["style"]["right"] = '0px';
	} else {
		this["oDomRef"]["style"]["left"] = '0px';
	}
	UCF_DomUtil["addClass"](this["oDomRef"], 'lsSPW--animation-open');
};;if (__UCF_COVERAGE__) { UCF_SidePopup["_"]["show"] = 0; };

/**
 * @private
 * @see UCF_PopupBase#hide
 */
UCF_SidePopup["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_SidePopup["_"]["hide"]++; }; 
	UCF_DomUtil["addClass"](this["oDomRef"], 'lsSPW--animation-close');
	var _this = this;
	return function() {
		_this["oDomRef"]["style"]["display"] = 'none';
	};
};;if (__UCF_COVERAGE__) { UCF_SidePopup["_"]["hide"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SidePopup["prototype"]["aAttributeNames"] = ["sMode","sDefaultButtonId","sHotkeysId","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SidePopup["prototype"]["aEventNames"] = ["Close","Hotkey"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SidePopup["prototype"]["aMethodNames"] = ["setDefaultButtonId","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Mode}
 */
UCF_SidePopup["prototype"]["sMode"] = "MODAL";

/**
 * @private
 * @type {string}
 */
UCF_SidePopup["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SidePopup["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_SidePopup["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_SidePopup["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SidePopup["_"]["setDefaultValues"]++; }; 
	this["sMode"] = "MODAL";
	this["sDefaultButtonId"] = '';
	this["sHotkeysId"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Mode", "MODAL", true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SidePopup["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires SidePopup::Close
 */
UCF_SidePopup["prototype"]["fireClose"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SidePopup["_"]["fireClose"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "SidePopup.js(126): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SidePopup.js(127): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SidePopup.js(128): fireClose"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("SidePopup", "Close", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SidePopup["_"]["fireClose"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @param {string} sControlId The Id of the control where the event occured
 * @fires SidePopup::Hotkey
 */
UCF_SidePopup["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId, sControlId) {;if (__UCF_COVERAGE__) { UCF_SidePopup["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string, ControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "SidePopup.js(150): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SidePopup.js(151): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SidePopup.js(152): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "SidePopup.js(153): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "SidePopup.js(154): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "SidePopup.js(155): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "SidePopup.js(156): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sControlId != null, "sControlId != null", "SidePopup.js(157): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sControlId) == "string", "typeof(sControlId) == \"string\"", "SidePopup.js(158): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId,
		"ControlId": sControlId
	};
	
	
	if (sProviderId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sProviderId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ProviderId");
			}
		}
	if (sControlId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sControlId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ControlId");
			}
		}
	this["fireSemanticEvent"]("SidePopup", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SidePopup["_"]["fireHotkey"] = 0; };

};
sap["ls"]["preload"]["UCF_SilverlightContainer"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ActiveComponent */
/// <reference path="./base/ActiveComponent.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SilverlightContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SilverlightContainer["_"]["UCF_SilverlightContainer"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "SilverlightContainer.js(20): UCF_SilverlightContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SilverlightContainer.js(21): UCF_SilverlightContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SilverlightContainer.js(22): UCF_SilverlightContainer"); };

	UCF_ActiveComponent["apply"](this, [oDomRef, oLS]);

};window["UCF_SilverlightContainer"] = UCF_SilverlightContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SilverlightContainer"); UCF_SilverlightContainer["_"] = {UCF_SilverlightContainer: 0}; }; ;
UCF_SilverlightContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ActiveComponent"))(); UCF_SilverlightContainer.prototype["sClassName"] = "UCF_SilverlightContainer";

/**
 * Writes the appropriate acc text into the tooltip
 */
UCF_SilverlightContainer["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SilverlightContainer["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SilverlightContainer.js(33): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() != this) return;

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource["getAttribute"]("tp") == "END") {
		oAccessibilityHelper["setControlType"]("SLC_END");
	} else if (oSource["getAttribute"]("tp") == "START") {
		oAccessibilityHelper["setControlType"]("SLC");
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	} else {
		oAccessibilityHelper["setControlType"]("SLC");
	}

};;if (__UCF_COVERAGE__) { UCF_SilverlightContainer["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SilverlightContainer["prototype"]["aAttributeNames"] = ["sVisibility","sTooltip","sLifeCycle","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SilverlightContainer["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SilverlightContainer["prototype"]["aMethodNames"] = ["setKeepAlive","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_SilverlightContainer["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_SilverlightContainer["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_SilverlightContainer["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_SilverlightContainer["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_SilverlightContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SilverlightContainer["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["sLifeCycle"] = "BROWSER";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SilverlightContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_SimpleLayoutDragDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_DragSession */
/// <reference path="../base/DragSession.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>
/* global UCF_ReferenceGhost */
/// <reference path="../base/ReferenceGhost.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 * @param {string} sDropDecoratorType
 */
function UCF_SimpleLayoutDragDelegate(oLS, oDragSourceControl, sDropDecoratorType) {if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["UCF_SimpleLayoutDragDelegate"]++; }; 

	UCF_DragDelegate["apply"](this, [oLS]);
	this["setDragSourceControl"](oDragSourceControl);
	this["sDropDecoratorType"] = sDropDecoratorType;

};window["UCF_SimpleLayoutDragDelegate"] = UCF_SimpleLayoutDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SimpleLayoutDragDelegate"); UCF_SimpleLayoutDragDelegate["_"] = {UCF_SimpleLayoutDragDelegate: 0}; }; ;

UCF_SimpleLayoutDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_SimpleLayoutDragDelegate.prototype["sClassName"] = "UCF_SimpleLayoutDragDelegate";

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SimpleLayoutDragDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["onlsdragstart"]++; }; 
	//_trace(INFO,"dragstart");

	//ensure that layout does not collapse when dragging a single cell
	this["oDragSourceControl"]["oDomRef"]["style"]["width"] = this["oDragSourceControl"]["oDomRef"]["scrollWidth"]; // + "px" ???

	var sDragSourceInfoId = this["oDragSourceControl"]["sDragSourceInfo"];
	if (!sDragSourceInfoId)
		return;

	var oDragSourceInfoControl = this["oDragSourceControl"]["oGetControlById"](sDragSourceInfoId);
	if (!oDragSourceInfoControl)
		return;

	var sTags = oDragSourceInfoControl["sGetTags"]();
	if (!sTags)
		return;

	if (!this["bIsDragPossible"](oBrowserEvent))
		return;
	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		iHoveredRow = this["iGetHoveredRow"](oBrowserEvent); //get the hovered row before the ghost is created because UCF_DomUtil.bContains does no longer work correctly in FF

	if (iHoveredRow === -1)
		return;

	var oTBody = this["oGetTBody"](oBrowserEvent),
		oCellControl = this["oDragSourceControl"]["oGetControlByDomRef"](oTBody["childNodes"][iHoveredRow]["cells"][0], true),
		oGhost = this["oGetGhost"](oBrowserEvent),
		oDragSession = oDragAndDropManager["startDragSession"](this["oDragSourceControl"]["sId"], sTags, UCF_DragSession["DRAG_TYPE"]["STANDARD"], null, oGhost, oDragSourceInfoControl["sHint"]);

	this["oDragSourceControl"]["oDraggedCellId"] = oCellControl["sId"];

	//if Drag-Event is registered
	if (this["oDragSourceControl"]["mEvents"]["Drag"]) {
		this["oDragSourceControl"]["fireDrag"](this["oDragSourceControl"]["sId"], sDragSourceInfoId, oDragSession["sId"]);
	}

	//if DataAccess is registered
	if (oDragSourceInfoControl["mEvents"]["DataAccess"]) {
		//use mime type from drag source info
		//server can override it with a non-null value
		oDragSession["sMimeType"] = oDragSourceInfoControl["sGetMimeType"]();

		oDragSourceInfoControl["fireDataAccess"](sDragSourceInfoId, this["oDragSourceControl"]["sId"], oDragSession["sId"]);
	} else if (oCellControl["sDragData"]) {
		oDragSession["setDragData"](oCellControl["sDragData"], oDragSourceInfoControl["sGetMimeType"]());
	} else {
		//use data from drag source info control
		oDragSession["setDragData"](oDragSourceInfoControl["sGetData"](), oDragSourceInfoControl["sGetMimeType"]());
	}

	oBrowserEvent["bHandled"] = true;
	oBrowserEvent["cancelBubble"]();
	oDragAndDropManager["setDropEnabledCursor"](UCF_DragSession["E_CURSOR"]["MOVE"]);
	this["oDragSourceControl"]["bDragStartedHere"] = true;
	//this.oDragSourceControl.notifyLayoutChange();

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["onlsdragstart"] = 0; };

/**
 * Handler for the native drag start event which initializes the drag session
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_SimpleLayoutDragDelegate["prototype"]["ondragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["ondragstart"]++; }; 

	if (UCF_UserAgent["bIsGecko"]()) {
		//FF raises native dragstart event for images even if draggable is set to false in DOM and dragstart is set to return false in DOM
		//therefore it is neccessary to check in dragstart handler of the delegate which only exists if there is a dragsourceinfo attached
		//wether the dragstart event is wanted (browserDragDrop = true) or not (browserDragDrop = false)
		//if not wanted the return statement avoids running into the super method because lsdragstart handler should take action
		var sDragSourceInfoId = this["oGetDragSourceInfoId"](oBrowserEvent);
		if (sDragSourceInfoId) {
			var oDragSourceInfo = this["oLS"]["oControlFactory"]["oGetControlById"](sDragSourceInfoId);
			if (oDragSourceInfo) {
				if (!oDragSourceInfo["bBrowserDragDrop"]) {
					var oDragAndDropManager = oDragSourceInfo["oLS"]["oBrowserWindow"]["oDragAndDropManager"];
					oDragAndDropManager["bBrowserDragDrop"] = false;
					return;
				}
			}
		}
	}
	UCF_DragDelegate.prototype["ondragstart"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["ondragstart"] = 0; };

UCF_SimpleLayoutDragDelegate["CONSTANTS"] = {
	"BGCOLOR": "#D6E1EB",
	"BORDERCOLOR": "#7C98B6",
	"BORDERWIDTH": 2
};
/**
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @return { UCF_ReferenceGhost }
 */
UCF_SimpleLayoutDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["oGetGhost"]++; }; 

	var iHoveredRow = this["iGetHoveredRow"](oBrowserEvent),
		oTBody = this["oGetTBody"](oBrowserEvent),
		oRow = oTBody["childNodes"][iHoveredRow]["cells"]["length"] === 1 && false ? oTBody["childNodes"][iHoveredRow]["cells"][0] : oTBody["childNodes"][iHoveredRow],
		oRect = UCF_DomUtil["oGetObjectRect"](oRow);

	if (this["sDropDecoratorType"] === "LINE") {
		var oDiv = document["createElement"]("DIV"),
			oStyle = oDiv["style"];
		UCF_DomUtil["addClass"](oDiv, 'lsSimpleLayoutDrag');
		/*		oStyle.border = UCF_SimpleLayoutDragDelegate.CONSTANTS.BORDERWIDTH
					+ "px dashed "
					+ UCF_SimpleLayoutDragDelegate.CONSTANTS.BORDERCOLOR;
				oStyle.backgroundColor = UCF_SimpleLayoutDragDelegate.CONSTANTS.BGCOLOR;*/
		oStyle["width"] = oRect["width"] + "px";
		oStyle["height"] = oRect["height"] + "px";

		UCF_DomUtil["setInnerHtml"](oDiv, "&nbsp;");

		this["oGhost"] = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv);

	} else {
		this["oGhost"] = new (UCF_ClassLoader["oGetClass"]("UCF_ReferenceGhost"))(this["oLS"], oRow);
		this["oGhost"]["applyAlphaFilter"](false);

	}

	var iOffsetX = oRect["left"] - oBrowserEvent["oDragAndDropManager"]["iDragStartX"],
		iOffsetY = oRect["top"] - oBrowserEvent["oDragAndDropManager"]["iDragStartY"];

	this["oGhost"]["setOffset"](iOffsetX, iOffsetY);

	return this["oGhost"];

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["oGetGhost"] = 0; };

/**
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @return {boolean}
 */
UCF_SimpleLayoutDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["bIsDragPossible"]++; }; 

	var oSourceControl = oBrowserEvent["oGetSourceControl"]();
	if (!oSourceControl)
		return false;

	var oDragHandleDomRef = oSourceControl["oDragHandleDomRef"];

	return oDragHandleDomRef && UCF_DomUtil["bContains"](oDragHandleDomRef, oBrowserEvent["oGetSource"]());

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["bIsDragPossible"] = 0; };

/**
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_SimpleLayoutDragDelegate["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["onlsdragend"]++; }; 

	var bDropHandled = oBrowserEvent["bDropHandled"];

	if (this["sDropDecoratorType"] === "LINE") {
		// nothing to do here yet
	} else {
		// restore dragged cell if drop was not successful
		// eslint-disable-next-line no-lonely-if
		if (!bDropHandled) {
			// destroy will be called by d&D-manager
			// therefore destroy is empty

			// put cell back into table
			if (this["oGhost"]) this["oGhost"]["doDestroy"]();

			//CSN 3774019: cancelling dragdrop multiple times
			//would render the layout in an unexpected manner
			if (UCF_UserAgent["bIsGecko"]()) {
				var oDomRef = this["oDragSourceControl"]["oDomRef"];
				if (oDomRef["childNodes"]["length"] === 1) {
					var aTRs = oDomRef["childNodes"][0]["childNodes"];
					for (var x = 0; x < aTRs["length"]; x++) {
						if (aTRs[x])
							aTRs[x]["style"]["display"] = "table-row";
					}
				}
			}

			this["oDragSourceControl"]["notifyLayoutChange"]();
		} else {

			this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "unlock");
		}

	}
	// this.oDragSourceControl.oDraggedCellId = null;
	this["oDragSourceControl"]["bDragStartedHere"] = false;
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["onlsdragend"] = 0; };

UCF_SimpleLayoutDragDelegate["prototype"]["unlock"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["unlock"]++; }; 
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "unlock");
	this["oGhost"]["removeFromDom"]();
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["unlock"] = 0; };

UCF_SimpleLayoutDragDelegate["prototype"]["iGetHoveredRow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["iGetHoveredRow"]++; }; 

	var oDomRef = this["oDragSourceControl"]["oDomRef"];
	var countInt = 0;
	if (oDomRef["childNodes"]["length"] !== 1) {
		//Check if the first are the colgroup and if so, take
		//the next
		if (UCF_DomUtil["bIsCTInstanceOf"](oDomRef, "GL") && oDomRef["childNodes"][0]["childNodes"][0]["tagName"] === "COL") {
			countInt = 1;
		} else
			return -1;
	}

	var aTRs = oDomRef["childNodes"][countInt]["childNodes"],
		oSource = oBrowserEvent["oGetSource"]();

	for (var x = 0; x < aTRs["length"]; x++) {
		if (UCF_DomUtil["bContains"](aTRs[x], oSource))
			return x;

	}

	return -1;
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["iGetHoveredRow"] = 0; };

UCF_SimpleLayoutDragDelegate["prototype"]["oGetTBody"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["oGetTBody"]++; }; 

	var oDomRef = this["oDragSourceControl"]["oDomRef"];
	var countInt = 0;

	if (oDomRef["childNodes"]["length"] !== 1) {
		if (UCF_DomUtil["bIsCTInstanceOf"](oDomRef, "GL") && oDomRef["childNodes"][0]["childNodes"][0]["tagName"] === "COL") {
			countInt = 1;
		} else
			return null;
	}

	var oTBody = oDomRef["childNodes"][countInt];

	return oTBody;
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["oGetTBody"] = 0; };
/**
 * destructor
 */
UCF_SimpleLayoutDragDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["destroy"]++; }; 

	if (this["oLS"]) this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "unlock");
	this["sDropDecoratorType"] = null;
	if (this["oGhost"]) {
		this["oGhost"]["destroy"]();
		this["oGhost"] = null;
	}
	UCF_DragDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDragDelegate["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_SimpleLayoutDropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_Animation */
/// <reference path="../../anim/Animation.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>

/**
 * @class
 * 
 * @param {UCF_Control} oLayoutControl
 * @param {UCF_LS} oLS
 */
function UCF_SimpleLayoutDropDecorator(oLayoutControl, oLS) {if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["UCF_SimpleLayoutDropDecorator"]++; }; 

	this["oLayoutControl"] = oLayoutControl;

};window["UCF_SimpleLayoutDropDecorator"] = UCF_SimpleLayoutDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SimpleLayoutDropDecorator"); UCF_SimpleLayoutDropDecorator["_"] = {UCF_SimpleLayoutDropDecorator: 0}; }; ;
UCF_SimpleLayoutDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_SimpleLayoutDropDecorator.prototype["sClassName"] = "UCF_SimpleLayoutDropDecorator";

UCF_SimpleLayoutDropDecorator["CONSTANTS"] = {
	"BGCOLOR": "#D6E1EB",
	"BORDERCOLOR": "#7C98B6",
	"BORDERWIDTH": 2
};

/**
 * destructor
 */
UCF_SimpleLayoutDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["destroy"]++; }; 
	this["oLayoutControl"] = null;
	if (this["oAnimation"]) this["oAnimation"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["destroy"] = 0; };

UCF_SimpleLayoutDropDecorator["prototype"]["init"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["init"]++; }; 
	//minimal height 48px, if ghost is just a small image
	//max height 200px for better usability

	var iDecoratorHeight = 48,
		iHeight = 0,
		oDivForSafari = null;
	if (oDragSession["oGhost"]) {

		var iGhostHeight = 0;
		if (oDragSession["oGhost"]["oGhostRef"]) {
			iGhostHeight = UCF_DomUtil["oGetObjectRect"](oDragSession["oGhost"]["oGhostRef"])["height"];
		} else {
			iGhostHeight = UCF_DomUtil["oGetObjectRect"](oDragSession["oGhost"]["oDomRef"])["height"];
		}

		iDecoratorHeight = Math["min"](iDecoratorHeight, 200);
		iDecoratorHeight = Math["max"](iDecoratorHeight, iGhostHeight);
	}

	if (!this["oDomRef"]) {
		var oTR = document["createElement"]("TR"),
			oTD = document["createElement"]("TD");

		oDivForSafari = document["createElement"]("div");

		oTR["appendChild"](oTD);
		oTD["setAttribute"]("colSpan", 10);
		oTD["setAttribute"]("vAlign", "top");

		oTD["appendChild"](oDivForSafari);
		UCF_DomUtil["addClass"](oDivForSafari, 'lsSimpleLayoutDrop');
		oDivForSafari["style"]["height"] = "1px";
		/*	oDivForSafari.style.lineHeight = "1px";
			oDivForSafari.style.border = UCF_SimpleLayoutDropDecorator.CONSTANTS.BORDERWIDTH
				+ "px dashed "
				+ UCF_SimpleLayoutDropDecorator.CONSTANTS.BORDERCOLOR;
			oDivForSafari.style.backgroundColor = UCF_SimpleLayoutDropDecorator.CONSTANTS.BGCOLOR;*/
		UCF_DomUtil["setInnerHtml"](oDivForSafari, "&nbsp;");
		this["oDomRef"] = oTR;

		oDivForSafari["style"]["height"] = iDecoratorHeight + "px";
	}

	if (this["oAnimation"])
		this["oAnimation"]["stop"]();

	//if droptarget was dragsource
	//show decorator instantly

	//true: do no longer show animations
	if (this["oLayoutControl"]["bDragStartedHere"] || !window["UCF_System"]["bUseAnimation"] || true) {
		this["oLayoutControl"]["notifyLayoutChange"]();
	} else {
		this["oAnimation"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(oDivForSafari, 400);
		this["oAnimation"]["addStyleChange"]("height", "", "px", 1, iHeight, this["oAnimation"]["M_TRANSITIONS"]["EaseInOut"]);
		this["oAnimation"]["callbackFinish"](this["oLayoutControl"], "notifyLayoutChange");
		this["oAnimation"]["callbackStep"](this["oLayoutControl"], "notifyLayoutChange");
		this["oAnimation"]["play"]();
	}

	//only one time -> on re-entering show animation again
	this["oLayoutControl"]["bDragStartedHere"] = false;

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["init"] = 0; };

UCF_SimpleLayoutDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["update"]++; }; 

	if (!this["oDomRef"])
		return;

	var oTableBody = UCF_DomUtil["oGetFirstChild"](this["oLayoutControl"]["oDomRef"]),
		aRows = this["oLayoutControl"]["oDomRef"]["rows"],
		oViewPort = UCF_DomUtil["oGetObjectRect"](this["oLayoutControl"]["oDomRef"]),
		iMouseY = oBrowserEvent["iPageY"]() - oViewPort["top"],
		iCellSpacing = parseInt(this["oLayoutControl"]["oDomRef"]["getAttribute"]("cellSpacing")) || 0,
		iHeight = iCellSpacing / 2,
		iDropIndex = 0,
		aVisibleRows = [],
		oRow;

	if (!oTableBody)
		oTableBody = this["oLayoutControl"]["oDomRef"];

	this["iOffset"] = 1;

	for (var i = 0; i < aRows["length"]; i++) {
		oRow = aRows[i];

		if (oRow === this["oDomRef"] || oRow["style"]["position"] === "absolute")
			continue;

		//collect visible rows
		aVisibleRows[aVisibleRows["length"]] = oRow;

		var iThresholdY = iHeight + oRow["offsetHeight"] + iCellSpacing;

		//position already found, only collect remaining visible rows
		if (this["iOffset"] === -1)
			continue;

		if (iMouseY < iThresholdY) {
			//correct position found -> no more counting
			this["iOffset"] = -1;
			continue;
		}

		iHeight = iThresholdY;
		iDropIndex++;

	}

	if (this["iOffset"] === 1)
		iDropIndex--;

	//drop location has changed
	//so remove decorator
	UCF_DomUtil["removeFromDom"](this["oDomRef"]);

	if (this["iOffset"] === -1 && iDropIndex !== -1) {

		//between existing rows
		oRow = aVisibleRows[iDropIndex];
		oTableBody["insertBefore"](this["oDomRef"], oRow);

		this["sCell"] = oRow["cells"][0]["id"];

	} else {
		//no visible rows, because we dragged a single row
		//and dropped on that or layout was empty
		if (iDropIndex === -1) {
			iDropIndex = 0;

			if (aRows["length"] > 0) {
				this["iOffset"] = -1;
				this["sCell"] = aRows[0]["cells"][0]["id"];
			} else {
				//drag started in this layout and layout is now empty
				if (this["oLayoutControl"]["oDraggedCellId"]) {
					this["iOffset"] = -1;
					this["sCell"] = this["oLayoutControl"]["oDraggedCellId"];

				} else {
					this["iOffset"] = 0;
					this["sCell"] = "";
				}
				//layout was empty

			}
		} else {
			this["sCell"] = aVisibleRows[aVisibleRows["length"] - 1]["cells"][0]["id"];
		}
		//add decorator below last row
		oTableBody["appendChild"](this["oDomRef"]);

	}

	//window.status = iDropIndex + " [" + this.iOffset + "] (cellId:" + this.sCell + ")";

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["update"] = 0; };

/**
 * removes elements from DOM
 */
UCF_SimpleLayoutDropDecorator["prototype"]["cleanUp"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["cleanUp"]++; }; 

	if (this["oAnimation"])
		this["oAnimation"]["stop"]();

	if (!this["bDoNotCleanUp"])
		this["doCleanUp"]();

	this["oLayoutControl"]["notifyLayoutChange"]();
	this["oLayoutControl"]["oDropDelegate"]["bInitialized"] = false;
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["cleanUp"] = 0; };
/**
 * removes elements from DOM
 */
UCF_SimpleLayoutDropDecorator["prototype"]["doCleanUp"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["doCleanUp"]++; }; 

	UCF_DomUtil["removeFromDom"](this["oDomRef"]);
	this["oDomRef"] = null;

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["doCleanUp"] = 0; };

UCF_SimpleLayoutDropDecorator["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["hide"]++; }; 
	//override because hiding the decorator is not needed here
	//and only tampers correct calculation
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["hide"] = 0; };

UCF_SimpleLayoutDropDecorator["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["show"]++; }; 
	//override because hiding the decorator is not needed here
	//and only tampers correct calculation
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["show"] = 0; };

UCF_SimpleLayoutDropDecorator["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["bIsVisible"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["bIsVisible"] = 0; };

/**
 * destructor
 */
UCF_SimpleLayoutDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["destroy"]++; }; 

	this["sCell"] = null;
	this["iOffset"] = null;
	this["oDomRef"] = null;

	if (this["oAnimation"]) {
		this["oAnimation"]["destroy"]();
		this["oAnimation"] = null;
	}

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_SimpleLayoutDropDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../../core/ResourceUtil.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_SimpleLayoutDropDecorator */
/// <reference path="../decorators/SimpleLayoutDropDecorator.js"/>
/* global UCF_SimpleLayoutLineDecorator */
/// <reference path="../decorators/SimpleLayoutLineDecorator.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 * @param {string} sDropDecoratorType
 */
function UCF_SimpleLayoutDropDelegate(oLS, oDropTargetControl, sDropDecoratorType) {if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["UCF_SimpleLayoutDropDelegate"]++; }; 

	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);
	this["bInitialized"] = false;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sDropDecoratorType"] = sDropDecoratorType;

};window["UCF_SimpleLayoutDropDelegate"] = UCF_SimpleLayoutDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SimpleLayoutDropDelegate"); UCF_SimpleLayoutDropDelegate["_"] = {UCF_SimpleLayoutDropDelegate: 0}; }; ;

UCF_SimpleLayoutDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_SimpleLayoutDropDelegate.prototype["sClassName"] = "UCF_SimpleLayoutDropDelegate";

/**
 * @override {UCF_DropDelegate.prototype.oCreateDropDecorator}
 */
UCF_SimpleLayoutDropDelegate["prototype"]["oCreateDropDecorator"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["oCreateDropDecorator"]++; }; 

	if (this["sDropDecoratorType"] === "LINE")
		return new (UCF_ClassLoader["oGetClass"]("UCF_SimpleLayoutLineDecorator"))(this["oDropTargetControl"]);

	return new (UCF_ClassLoader["oGetClass"]("UCF_SimpleLayoutDropDecorator"))(this["oDropTargetControl"], this["oLS"]);

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["oCreateDropDecorator"] = 0; };

/**
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_SimpleLayoutDropDelegate["prototype"]["onlsdragenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["onlsdragenter"]++; }; 

	UCF_JsUtil["clearDelayedCall"](this["sDelayedCall"]);

	if (this["sDropDecoratorType"] === "LINE") {

		UCF_DropDelegate.prototype["onlsdragenter"]["call"](this, oBrowserEvent);

	} else {
		if (!this["bInitialized"]) {
			// eslint-disable-next-line @ur/no-memory-leaks
			this["bDropAllowed"] = UCF_DropDelegate.prototype["onlsdragenter"]["call"](this, oBrowserEvent);
		}

		this["oDropTargetControl"]["notifyLayoutChange"]();

		if (this["bDropAllowed"]) {
			this["bInitialized"] = true;
			oBrowserEvent["cancelBubble"]();
		}
	}

	//create shims, even if you cannot drop here
	//do not create shims in native browser drag/drop mode
	if (!oBrowserEvent["oDragAndDropManager"]["bBrowserDragDrop"]) {
		this["createShims"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["onlsdragenter"] = 0; };

/**
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_SimpleLayoutDropDelegate["prototype"]["onlsdragover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["onlsdragover"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "--", "SimpleLayoutDropDelegate.js(85): onlsdragover"); };

	if (this["sDropDecoratorType"] === "LINE") {
		UCF_DropDelegate.prototype["onlsdragover"]["call"](this, oBrowserEvent);
	} else {

		//box decorator here:
		if (!this["bInitialized"]) {
			this["onlsdragenter"](oBrowserEvent);
		}

		if (this["bDropAllowed"]) {
			this["updateShims"]();
			this["oDropTargetControl"]["notifyLayoutChange"]();
			UCF_DropDelegate.prototype["onlsdragover"]["call"](this, oBrowserEvent);
			oBrowserEvent["cancelBubble"]();
		}

	}

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["onlsdragover"] = 0; };

/**
 *
 */

UCF_SimpleLayoutDropDelegate["prototype"]["onlsdragleave"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["onlsdragleave"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "--", "SimpleLayoutDropDelegate.js(112): onlsdragleave"); };

	if (this["sDropDecoratorType"] === "LINE") {
		UCF_DropDelegate.prototype["onlsdragleave"]["call"](this, oBrowserEvent);
	} else {

		UCF_JsUtil["clearDelayedCall"](this["sDelayedCall"]);
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sDelayedCall"] = UCF_JsUtil["delayedCall"](1, this, "dolsdragleave", [oBrowserEvent["oDragAndDropManager"]]);

		if (this["bDropAllowed"]) oBrowserEvent["cancelBubble"]();

	}

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["onlsdragleave"] = 0; };

UCF_SimpleLayoutDropDelegate["prototype"]["dolsdragleave"] = function(oDragAndDropManager) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["dolsdragleave"]++; }; 

	this["removeShims"]();

	if (!this["bDropAllowed"]) return;
	//do not destroy an other decorator
	// since this method will be called delayed!
	if (oDragAndDropManager["oDropDecoration"] === this["oDropDecorator"]) {
		//code copy from super method
		oDragAndDropManager["cleanUpDropArea"]();
	}

	if (this["oDropDecorator"]) this["oDropDecorator"]["cleanUp"]();

	//end code copy
	this["bInitialized"] = false;
	this["oDropTargetControl"]["notifyLayoutChange"]();

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["dolsdragleave"] = 0; };

/**
 * reset delegate
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_SimpleLayoutDropDelegate["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["onlsdragend"]++; }; 
	this["bInitialized"] = false;
	this["removeShims"]();

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["onlsdragend"] = 0; };

UCF_SimpleLayoutDropDelegate["prototype"]["onlsdrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["onlsdrop"]++; }; 

	var
		// oDropTargetControl = this.oGetDropTargetControl(oBrowserEvent),
		oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"],
		sDropTags = this["sGetDropTags"](oBrowserEvent),
		sValidMimeTypes = this["sGetValidMimeTypes"](oBrowserEvent);

	if (oBrowserEvent["oDragAndDropManager"]["bGetDropAllowed"](sDropTags, sValidMimeTypes) && this["bIsDropPossible"](oBrowserEvent)) {
		var sDragData = oDragSession["sGetDragData"]();
		var sMimeType = oDragSession["sGetMimeType"]();

		//drag response not yet available
		if (sDragData === null) {
			oDragSession["setDragDataChangeListener"](this["fGetDropCallBack"](oDragSession));
			oDragSession["bDropPending"] = true;

		} else {
			this["fGetDropCallBack"](oDragSession)["apply"](this, [sDragData, sMimeType]);
		}
		oBrowserEvent["bHandled"] = true;
		oBrowserEvent["cancelBubble"]();

		this["oDropDecorator"]["bDoNotCleanUp"] = true;
	}

	if (this["sDropDecoratorType"] === "LINE" && this["oDropDecorator"]) this["oDropDecorator"]["cleanUp"]();
	this["removeShims"]();
	oBrowserEvent["oDragAndDropManager"]["cleanUpDropArea"]();

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["onlsdrop"] = 0; };

UCF_SimpleLayoutDropDelegate["prototype"]["createShims"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["createShims"]++; }; 

	if (this["aShimRefs"] != null) return;

	var bCreateShim = false;
	var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"];
	var oShimRef;
	// create shim for every placeholder (could be iframe)
	var oContainerRef = UCF_DomUtil["$"](this["oDropTargetControl"]["sId"] + "-r");

	if (!oContainerRef) oContainerRef = this["oDropTargetControl"]["oDomRef"];

	this["aShimRefs"] = [];
	// get all LS PlaceHolders (PlaceHolders are located outside of
	// LS Page to ensure that expensive updates are not effecting themselves)
	var aPotentialPlaceHolders = this["oDropTargetControl"]["oLS"]["oControlFactory"]["oGetCurrentControlsByClassName"]("UCF_PlaceHolder", true);
	for (var x = 0; x < aPotentialPlaceHolders["length"]; x++) {

		var aPlaceHolderDomRef = aPotentialPlaceHolders[x]["oContentRef"];
		//Ignore PlaceHolders if their content is not existing (anymore)
		if (!aPlaceHolderDomRef) continue;
		//Ignore PlaceHolders outside of the current DropArea (for example currently entered GridLayout ... lsdragenter)
		if (!UCF_DomUtil["bContains"](this["oDropTargetControl"]["oDomRef"], aPotentialPlaceHolders[x]["oRootRef"])) continue;

		if (aPotentialPlaceHolders[x]["sClassName"] === "UCF_Iframe") {
			if ((aPotentialPlaceHolders[x]["oDomRef"]["getAttribute"]("forwardDragDropEvents") === "true") ||
				//do not create shim for that specific iFrame which has started the dragsession (contains dragSource)
				UCF_DomUtil["bContains"](aPotentialPlaceHolders[x]["contentWindow"], oDragSession["oGetDragSource"]())) bCreateShim = false;
			//UCF_DomUtil.bContains(aPotentialPlaceHolders[x].contentDocument, oDragSession.oGetDragSource())) bCreateShim = false;
			else bCreateShim = true;
		} else if (aPotentialPlaceHolders[x]["sClassName"] === "UCF_FlashContainer") bCreateShim = false;
		else bCreateShim = true;

		if (bCreateShim) {
			// var oPlaceHolderRect = UCF_DomUtil.oGetObjectRect(aPlaceHolderDomRef);
			oShimRef = this["oCreateShimOn"](oContainerRef);

			this["aShimRefs"]["push"]({
				"oShimRef": oShimRef,
				"oRef": aPlaceHolderDomRef
			});
		}
	}

	// create shim for every iframe inside of the DropArea
	// (for example currently entered GridLayout ... lsdragenter)
	//we won't get duplicate iFrames because those
	// iFrames identified via PlaceHolders are located outside of LS page
	var aIFrameRefs = UCF_DomUtil["$"](this["oDropTargetControl"]["sId"])["getElementsByTagName"]("iframe");

	for (var y = 0; y < aIFrameRefs["length"]; y++) {

		if ((aIFrameRefs[y]["getAttribute"]("forwardDragDropEvents") === "true") ||
			aIFrameRefs[y]["style"]["display"] === "none" ||
			// do not create shim for that specific iFrame which has started the dragsession (contains dragSource)
			UCF_DomUtil["bContains"](aIFrameRefs[y]["contentWindow"], oDragSession["oGetDragSource"]())) bCreateShim = false;
		// UCF_DomUtil.bContains(aIFrameRefs[y].contentDocument, oDragSession.oGetDragSource())) bCreateShim = false;
		else bCreateShim = true;

		if (bCreateShim) {
			oShimRef = this["oCreateShimOn"](oContainerRef);

			this["aShimRefs"]["push"]({
				"oShimRef": oShimRef,
				"oRef": aIFrameRefs[y]
			});
		}
	}

	this["updateShims"]();

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["createShims"] = 0; };

UCF_SimpleLayoutDropDelegate["prototype"]["oCreateShimOn"] = function(oContainerRef) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["oCreateShimOn"]++; }; 

	var oShimRef = document["createElement"]("IMG");

	oShimRef["style"]["position"] = "absolute";
	oShimRef["style"]["zIndex"] = UCF_LS["E_LAYERS"]["DECORATORS"];
	oShimRef["src"] = UCF_ResourceUtil["sGetSpacerImageUrl"]();

	// for testing
	// oShimRef.style.border = "1px solid red";
	oContainerRef["appendChild"](oShimRef);

	return oShimRef;
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["oCreateShimOn"] = 0; };

UCF_SimpleLayoutDropDelegate["prototype"]["updateShims"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["updateShims"]++; }; 

	if (!this["aShimRefs"]) return;

	for (var x = 0; x < this["aShimRefs"]["length"]; x++) {
		var oRect = UCF_DomUtil["oGetViewPort"](this["aShimRefs"][x]["oRef"]);
		for (var sAttribute in oRect) {
			this["aShimRefs"][x]["oShimRef"]["style"][sAttribute] = oRect[sAttribute] + "px";
		}
	}

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["updateShims"] = 0; };

UCF_SimpleLayoutDropDelegate["prototype"]["removeShims"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["removeShims"]++; }; 

	if (!this["aShimRefs"]) return;

	for (var x = 0; x < this["aShimRefs"]["length"]; x++) {
		UCF_DomUtil["removeFromDom"](this["aShimRefs"][x]["oShimRef"]);
	}
	this["aShimRefs"] = null;

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["removeShims"] = 0; };

/**
 * returns the method which will be executed on drop
 * @return the method
 * type function
 */

UCF_SimpleLayoutDropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["fGetDropCallBack"]++; }; 
	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		sCell = this["oDropDecorator"]["sCell"],
		iOffset = this["oDropDecorator"]["iOffset"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function(sDragData, sMimeType) {
		oDropTargetControl["fireDrop"](oDropTargetControl["sId"], sDragSourceId, sDropTargetInfoId, sCell, iOffset, sDragData, sMimeType, sDragTags, iMouseButtonState, iPosX, iPosY, oDragSession["eGetDropEffect"]());
	};
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["fGetDropCallBack"] = 0; };

UCF_SimpleLayoutDropDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["destroy"]++; }; 
	UCF_DropDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutDropDelegate["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_SimpleLayoutLineDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_ItemListBox} oItemListBox
 * @param {UCF_LS} oLS
 */
function UCF_SimpleLayoutLineDecorator(oItemListBox, oLS) {if (__UCF_COVERAGE__) { UCF_SimpleLayoutLineDecorator["_"]["UCF_SimpleLayoutLineDecorator"]++; }; 

	UCF_LineDecorator["apply"](this, [oItemListBox, true]);
	this["oLS"] = oItemListBox["oLS"];
	this["bDashed"] = true;
};window["UCF_SimpleLayoutLineDecorator"] = UCF_SimpleLayoutLineDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SimpleLayoutLineDecorator"); UCF_SimpleLayoutLineDecorator["_"] = {UCF_SimpleLayoutLineDecorator: 0}; }; ;

/**
 *
 */
UCF_SimpleLayoutLineDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(); UCF_SimpleLayoutLineDecorator.prototype["sClassName"] = "UCF_SimpleLayoutLineDecorator";

/** @param {UCF_BrowserEvent} oBrowserEvent */
UCF_SimpleLayoutLineDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutLineDecorator["_"]["update"]++; }; 

	var oLayoutRect = UCF_DomUtil["oGetObjectRect"](this["oControl"]["oDomRef"]);

	var oDomRef = this["oControl"]["oDomRef"];

	var aTRs = oDomRef["tBodies"][0]["childNodes"],
		//		oSource = oBrowserEvent.oGetSource(),
		iY = 0;

	var iHoveredRow = aTRs["length"] - 1,
		oHoveredRow = aTRs[iHoveredRow];

	var iThreshold = oLayoutRect["top"];
	for (var x = 0; x < aTRs["length"]; x++) {

		iThreshold += UCF_DomUtil["oGetObjectRect"](aTRs[x])["height"];

		if (oBrowserEvent["iPageY"]() < iThreshold) {
			iHoveredRow = x;
			oHoveredRow = aTRs[x];
			break;
		}
	}

	if (!aTRs["length"]) {
		this["sCell"] = "";
		this["iOffset"] = 0;
		oLayoutRect = UCF_DomUtil["oGetObjectRect"](this["oControl"]["oDomRef"]["parentNode"]);
		iY = oLayoutRect["top"];

	} else {

		var oRowRect = UCF_DomUtil["oGetObjectRect"](oHoveredRow);
		iThreshold = oRowRect["top"] + oRowRect["height"] / 2;

		iY = oRowRect["top"];

		this["sCell"] = oHoveredRow["cells"][0]["id"];
		this["iOffset"] = -1;

		if (oBrowserEvent["iPageY"]() > iThreshold) {
			this["iOffset"] = +1;
			iY += oRowRect["height"];
		}

	}

	this["setBounds"](oLayoutRect["left"] - 3, iY - 1, oLayoutRect["width"] + 6);

};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutLineDecorator["_"]["update"] = 0; };

/**
 * destructor
 */
UCF_SimpleLayoutLineDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SimpleLayoutLineDecorator["_"]["destroy"]++; }; 

	this["sCell"] = null;
	this["iOffset"] = null;
	this["oLS"] = null;
	UCF_LineDecorator.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SimpleLayoutLineDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_SimpleType"] = function() {/* global UCF_Object */
/// <reference path="../../core/Object.js"/>

/**
 * Base Class for simple types
 * @class
 * 
 */
function UCF_SimpleType() {if (__UCF_COVERAGE__) { UCF_SimpleType["_"]["UCF_SimpleType"]++; }; };window["UCF_SimpleType"] = UCF_SimpleType; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SimpleType"); UCF_SimpleType["_"] = {UCF_SimpleType: 0}; }; 
UCF_SimpleType["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_SimpleType.prototype["sClassName"] = "UCF_SimpleType";

/**
 * @protected
 * @static
 * @param {string} sName
 * @param {Object} oConfiguration
 * @return {function(new: UCF_SimpleType)}
 */
UCF_SimpleType["createNewType"] = function(sName, oConfiguration) {;if (__UCF_COVERAGE__) { UCF_SimpleType["_"]["createNewType"]++; }; 
	var oClass = function(oConfiguration) { // intentional?
		UCF_SimpleType["apply"](this, arguments);
		this["sName"] = sName;
	};

	oClass["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SimpleType"))();
	window[sName] = oClass;

	return oClass;
};;if (__UCF_COVERAGE__) { UCF_SimpleType["_"]["createNewType"] = 0; };

};
sap["ls"]["preload"]["UCF_SingleCarousel"] = function() {/* global _assert, _trace, INFO, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Carousel */
/// <reference path="./Carousel.js"/>
/* eslint no-magic-numbers: [1, {"ignore": [0, 1, -1, 2]}] */

/**
 * @class
 * @extends UCF_Carousel
 * @param {HTMLDivElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SingleCarousel(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["UCF_SingleCarousel"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Carousel["apply"](this, [oDomRef, oLS]);
	}
};window["UCF_SingleCarousel"] = UCF_SingleCarousel; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SingleCarousel"); UCF_SingleCarousel["_"] = {UCF_SingleCarousel: 0}; }; ;
UCF_SingleCarousel["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Carousel"))(); UCF_SingleCarousel.prototype["sClassName"] = "UCF_SingleCarousel";

/** @override */
UCF_SingleCarousel["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["destroy"]++; }; 
	this["iFirstVisible"] = null;

	UCF_Carousel.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["destroy"] = 0; };

/** @override */
UCF_SingleCarousel["prototype"]["oGetInitialDomRefStyle"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["oGetInitialDomRefStyle"]++; }; 
	/**@type {Object} */
	var oStyle = {};
	/** @type {number} */
	var iPaginationWidth = this["sPagination"] !== 'NONE' ? this["oGetPaginationcontainerRef"]()["clientWidth"] : 0;
	/** @type {number} */
	var iPaginationHeight = this["sPagination"] !== 'NONE' ? this["oGetPaginationcontainerRef"]()["offsetHeight"] : 0;
	/** @type {number} */
	var iButtonsSize = this["iGetButtonsSize"]();
	/** @type {number} */
	var iFullButtonHeight = this["sNavigationPlacement"] === 'CONTENT'
		? this["iGetFullButtonHeight"]()
		: this["sNavigationPlacement"] === 'PAGINATION' && this["sAlignment"] === 'VERTICAL'
		? this["iGetFullButtonHeight"]()
		: 0;
	/** @type {number} */
	var iMinPaginationSize = this["iGetMinPaginationSize"]();
	/** @type {number} */
	var iLargestItemWidth = this["iGetLargestItemWidth"]();
	/** @type {number} */
	var iLargestItemHeight = this["iGetLargestItemHeight"]();
	/** @type {number} */
	var clientWidth = this["sWidth"] === '' ? iLargestItemWidth : this["iGetScrollRefClientWidth"]();
	/** @type {number} */
	var clientHeight = this["sHeight"] === '' ? iLargestItemHeight : this["iGetScrollRefClientHeight"]();

	switch (this["sAlignment"]) {
		case 'HORIZONTAL':
			if (this["sWidth"] === '') {
				oStyle["width"] = (Math["max"]((iLargestItemWidth + iButtonsSize), iMinPaginationSize) + this["iGetPaddingLeft"]() + this["iGetPaddingRight"]()) + 'px';
			}
			if (this["sHeight"] === '') {
				oStyle["height"] = (Math["max"](iLargestItemHeight, iFullButtonHeight) + this["iGetPaddingTop"]() + this["iGetPaddingBottom"]() + iPaginationHeight) + 'px';
			}
			if (this["sWidth"] !== '') {
				oStyle["width"] = Math["max"](clientWidth + iButtonsSize, iMinPaginationSize) + 'px';
			}
			break;
		case 'VERTICAL':
			if (this["sWidth"] === '') {
				oStyle["width"] = iLargestItemWidth + iPaginationWidth + this["iGetPaddingLeft"]() + this["iGetPaddingRight"]() + 'px';
			}
			if (this["sHeight"] === '') {
				oStyle["height"] = Math["max"]((iLargestItemHeight + iButtonsSize), iMinPaginationSize) + this["iGetPaddingTop"]() + this["iGetPaddingBottom"]() + 'px';
			}
			if (this["sHeight"] !== '') {
				oStyle["height"] = Math["max"](clientHeight + iButtonsSize, iMinPaginationSize) + 'px';
			}
			break;
	}

	return oStyle;
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["oGetInitialDomRefStyle"] = 0; };

/** @override */
UCF_SingleCarousel["prototype"]["onBeforeInitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onBeforeInitialize"]++; }; 
	/** @type {number} */
	// var iItemcontainerHeight = Math.max(this.iGetFullButtonHeight(), this.iCalcItemcontainerHeight());
	var iItemcontainerHeight = this["iCalcItemcontainerHeight"]();
	/** @type {number} */
	var iItemcontainerWidth = this["iCalcItemcontainerWidth"]();

	/** @type {number} */
	var iItemcontainerPaddingTop = this["iGetPaddingTop"]();

	switch (this["sAlignment"]) {
		case 'HORIZONTAL':
			UCF_JsUtil["forEach"](
				UCF_DomUtil["querySelectorAll"]('.lsCarousel__items[id="' + this["sId"] + '-items"] > tr > .lsCarousel__item--dummy'),
				function(oDummyRef) {
					UCF_DomUtil["setStyle"](oDummyRef, { "minWidth": iItemcontainerWidth + 'px' });
				}
			);
			UCF_JsUtil["forEach"](
				UCF_DomUtil["querySelectorAll"]('.lsCarousel__items[id="' + this["sId"] + '-items"] > tr > td > .lsCarousel__item--container'),
				function(oContainerRef) {
					UCF_DomUtil["setStyle"](oContainerRef, {
						"width": iItemcontainerWidth + 'px',
						"minWidth": iItemcontainerWidth + 'px',
						"maxWidth": iItemcontainerWidth + 'px',
						"height": iItemcontainerHeight + 'px',
						"minHeight": iItemcontainerHeight + 'px',
						"maxHeight": iItemcontainerHeight + 'px'
					});
				}
			);
			break;
		case 'VERTICAL':
			UCF_JsUtil["forEach"](
				UCF_DomUtil["querySelectorAll"]('.lsCarousel__items[id="' + this["sId"] + '-items"] > tr > .lsCarousel__item--dummy'),
				function(oDummyRef) {
					var iMinHeight = iItemcontainerHeight - iItemcontainerPaddingTop;
					UCF_DomUtil["setStyle"](oDummyRef, { "height": iMinHeight + 'px' });
				}
			);
			UCF_JsUtil["forEach"](
				UCF_DomUtil["querySelectorAll"]('.lsCarousel__items[id="' + this["sId"] + '-items"] > tr > td > .lsCarousel__item--container'),
				function(oContainerRef) {
					UCF_DomUtil["setStyle"](oContainerRef, {
						"width": iItemcontainerWidth + 'px',
						"minWidth": iItemcontainerWidth + 'px',
						"maxWidth": iItemcontainerWidth + 'px',
						"height": iItemcontainerHeight + 'px',
						"minHeight": iItemcontainerHeight + 'px',
						"maxHeight": iItemcontainerHeight + 'px'
					});
				}
			);
			break;
	}
	this["oCache"]["invalidate"]('aItems');
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onBeforeInitialize"] = 0; };

UCF_SingleCarousel["prototype"]["iCalcItemcontainerHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iCalcItemcontainerHeight"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {number} */
	var iLargestItemHeight = this["iGetLargestItemHeight"]();
	/** @type {number} */
	var clientHeight = this["sHeight"] === '' ? iLargestItemHeight : this["iGetScrollRefClientHeight"]();
	/** @type {number} */
	var iMinPaginationSize = this["iGetMinPaginationSize"]();

	if (self["sPagination"] !== "NONE") {
		if (self["sAlignment"] === 'HORIZONTAL') {
			var calcHeight = self["sWidth"] === ''
				? Math["max"](clientHeight, clientHeight - self["oGetPaginationcontainerRef"]()["offsetHeight"])
				: clientHeight - self["oGetPaginationcontainerRef"]()["offsetHeight"];
			return self["sNavigationPlacement"] === 'CONTENT'
				? Math["max"](self["iGetFullButtonHeight"](), calcHeight)
				: calcHeight;
		} else {
			return Math["max"](clientHeight, self["sNavigationPlacement"] === 'CONTENT' ? iMinPaginationSize - self["iGetButtonsSize"]() : iMinPaginationSize);
		}
	} else {
		return clientHeight;
	}
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iCalcItemcontainerHeight"] = 0; };

UCF_SingleCarousel["prototype"]["iCalcItemcontainerWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iCalcItemcontainerWidth"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {number} */
	var iLargestItemWidth = this["iGetLargestItemWidth"]();
	/** @type {number} */
	var clientWidth = this["sWidth"] === '' ? iLargestItemWidth : this["iGetScrollRefClientWidth"]();
	/** @type {number} */
	var iMinPaginationSize = this["iGetMinPaginationSize"]();

	return self["oCache"]["get"]('iItemcontainerWidth', function() {
		if (self["sPagination"] !== "NONE") {
			if (self["sAlignment"] === 'HORIZONTAL') {
				return Math["max"](clientWidth, self["sNavigationPlacement"] === 'CONTENT' ? iMinPaginationSize - self["iGetButtonsSize"]() : iMinPaginationSize);
			} else {
				return self["sWidth"] === ''
					? Math["max"](clientWidth, clientWidth - self["oGetPaginationcontainerRef"]()["offsetWidth"])
					: clientWidth - self["oGetPaginationcontainerRef"]()["offsetWidth"];
			}
		} else {
			return clientWidth;
		}
	});

};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iCalcItemcontainerWidth"] = 0; };

/** @override
 * @param { Array } aItems
 * @param { number } iIndex
 * @param { boolean } [bImmediate]
 * @param { boolean } [bHomeOrEnd]
 */
UCF_SingleCarousel["prototype"]["_scrollTo"] = function(aItems, iIndex, bImmediate, bHomeOrEnd) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["_scrollTo"]++; }; 
	/** @type {number[]} */
	var aItemOffsets = this["aGetItemOffsets"]();
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {number[]} */
	var iScrollPx = 0;

	if (window["UCF_System"]["bIsRTL"]) {
		if (UCF_UserAgent["bIsIE"]()) {
			iScrollPx = this["iGetOffsetRight"](iIndex) + this["iGetScrollRefClientWidth"]() / 2 + (aItems[iIndex]["iOffsetWidth"] / 2);
		} else if (UCF_UserAgent["bIsFirefox"]() || UCF_UserAgent["bIsSafari"]()) {
			iScrollPx = (this["iGetOffsetRight"](iIndex) + this["iGetScrollRefClientWidth"]() / 2 + (aItems[iIndex]["iOffsetWidth"] / 2)) * -1;
		} else {
			iScrollPx = this["iGetScrollRefScrollWidth"]() - this["iGetScrollRefClientWidth"]() * 2 + this["iGetScrollRefClientWidth"]() / 2 - this["iGetOffsetRight"](iIndex) - aItems[iIndex]["iOffsetWidth"] / 2;
		}
	} else {
		// iScrollPx = aItemOffsets[iIndex] - (this.iGetScrollRefClientWidth() / 2) + (aItems[iIndex].iOffsetWidth / 2);
		iScrollPx = aItemOffsets[iIndex];
	}

	if (aItems["length"] > 0 && !bImmediate) {
		aItems[iIndex]["oDomRef"]["classList"]["add"]('lsCarousel__item--active');
		UCF_DomUtil["setStyle"](aItems[iIndex]["oDomRef"], { "opacity": 0 });
	}
	this["animateScroll"]({
		"iEndPx": this["sAlignment"] === 'HORIZONTAL'
			? iScrollPx
			: aItemOffsets[iIndex] - (this["iGetScrollRefClientHeight"]() / 2) + (aItems[iIndex]["iOffsetHeight"] / 2),
		"bImmediate": bImmediate,
		"iCurrentIndex": self["iFirstVisible"],
		"iFutureIndex": iIndex,
		"fDone": function() {
			UCF_JsUtil["forEach"](aItems, function(oItem) {
				UCF_DomUtil["removeClass"](oItem["oDomRef"], 'lsCarousel__item--active');
			});
			if (aItems["length"] > 0) {
				aItems[iIndex]["oDomRef"]["classList"]["add"]('lsCarousel__item--active');
			}

			self["iFirstVisible"] = iIndex;
			self["setClientProperty"]('FirstVisible', self["iFirstVisible"], true);
			self["updateNavigation"]();
			self["updatePagination"]();
			if (window["UCF_System"]["bIsAria"]) { self["updateAriaAttributes"](); };
			if (!bImmediate) {
				UCF_DomUtil["focusDomElement"](UCF_DomUtil["$"](self["sId"] + '__item-' + self["iFirstVisible"]));
			};
		}
	});
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["_scrollTo"] = 0; };

/** @override */
UCF_SingleCarousel["prototype"]["onAfterInitializeWithScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterInitializeWithScrollPosition"]++; }; 
	this["iFirstVisible"] = this["iGetCurrentVisibleItem"]();
	this["setClientProperty"]('FirstVisible', this["iFirstVisible"], true);
	this["updateNavigation"]();
	this["updatePagination"]();
	this["updateActiveItem"]();
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterInitializeWithScrollPosition"] = 0; };

/**
 * @return { number }
 */
UCF_SingleCarousel["prototype"]["iGetCurrentVisibleItem"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iGetCurrentVisibleItem"]++; }; 
	/** @type {UCF_SingleCarousel} */
	var self = this;
	/** @type {number} */
	var iCounter = 0;
	/** @type {number[]} */
	var aItemOffsets = this["aGetItemOffsets"]();

	UCF_JsUtil["forEach"](self["aGetItems"](), function(item, index) {
		switch (self["sAlignment"]) {
			case 'HORIZONTAL':
				if (UCF_DomUtil["bIsRTL"]) {
					if (self["iGetScrollRefScrollWidth"]() - self["iGetScrollRefClientWidth"]() * 2 + self["iGetScrollRefClientWidth"]() / 2 - self["iGetOffsetRight"](index) - item["iOffsetWidth"] / 2 > self["iScrollLeft"]) {
						iCounter++;
					}
				} else {
					if (aItemOffsets[index] - (self["iGetScrollRefClientWidth"]() / 2) + (item["iOffsetWidth"] / 2) < self["iScrollLeft"]) {
						iCounter++;
					}
				}
				break;
			case 'VERTICAL':
				if (aItemOffsets[index] - (self["iGetScrollRefClientHeight"]() / 2) + (item["iOffsetHeight"] / 2) < self["iScrollTop"]) {
					iCounter++;
				}
				break;
		}
	});

	return iCounter;
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iGetCurrentVisibleItem"] = 0; };

UCF_SingleCarousel["prototype"]["updateActiveItem"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["updateActiveItem"]++; }; 
	/** @type {UCF_SingleCarousel} */
	var self = this;

	UCF_JsUtil["forEach"](self["aGetItems"](), function(oItem) {
		UCF_DomUtil["removeClass"](oItem["oDomRef"], 'lsCarousel__item--active');
	});
	if (self["aGetItems"]()["length"] > 0) {
		self["aGetItems"]()[self["iFirstVisible"]]["oDomRef"]["classList"]["add"]('lsCarousel__item--active');
	}
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["updateActiveItem"] = 0; };

/** @protected */
UCF_SingleCarousel["prototype"]["onAfterLsBlur"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterLsBlur"]++; }; 
	this["resetFocusStyles"]();
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterLsBlur"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SingleCarousel["prototype"]["onAfterClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterClick"]++; }; 
	/**@type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();

	if (UCF_StringUtil["bStartsWith"](oSource["id"], this["sId"])) {
		UCF_DomUtil["focusDomElement"](this["oGetActiveItem"]());
	}
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterClick"] = 0; };

/**
 * @protected
 */
UCF_SingleCarousel["prototype"]["resetFocusStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["resetFocusStyles"]++; }; 
	UCF_DomUtil["removeClass"](this["oGetContentRef"](), 'lsCarousel--single-focus');
	UCF_DomUtil["removeClass"](this["oGetContentRef"](), 'lsCarousel--focus');
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["resetFocusStyles"] = 0; };

/**
 * @protected
 */
UCF_SingleCarousel["prototype"]["setFocusStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["setFocusStyles"]++; }; 
	UCF_DomUtil["addClass"](this["oGetContentRef"](), 'lsCarousel--single-focus');
	UCF_DomUtil["addClass"](this["oGetContentRef"](), 'lsCarousel--focus');
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["setFocusStyles"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SingleCarousel["prototype"]["onAfterCarouselFocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterCarouselFocus"]++; }; 
	/** @type {HTMLElement}*/
	var oSource = oBrowserEvent["oGetSource"]();

	this["resetFocusStyles"]();

	if (oSource === this["oDomRef"]) {
		UCF_DomUtil["focusDomElement"](this["oGetActiveItem"]());
	} else if (this["bIsItemId"](oSource["id"]) ||
		oSource === this["oGetContentRef"]() ||
		oSource === this["oGetScrollRef"]() ||
		oSource === this["oGetItemsRef"]() ||
		(oSource === this["oGetPaginationcontainerRef"]() && this["sNavigationPlacement"] === 'CONTENT') ||
		oSource === this["oGetPaginationElementscontainerRef"]()) {
		this["setFocusStyles"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterCarouselFocus"] = 0; };

/**
 * @override
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SingleCarousel["prototype"]["onAfterPointerDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterPointerDown"]++; }; 
	if (UCF_DomUtil["bContains"](this["oGetScrollRef"](), oBrowserEvent["oGetSource"]())) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterPointerDown"] = 0; };

/**
 * @override
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SingleCarousel["prototype"]["onAfterPointerUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterPointerUp"]++; }; 
	/** @type {number} */
	var iDistX = oBrowserEvent["oDomEvent"]["x"] - this["iStartXCoordinate"];
	/** @type {number} */
	var iDistY = oBrowserEvent["oDomEvent"]["y"] - this["iStartYCoordinate"];
	/** @type {UCF_ScrollContainer} */
	var oScrollContainer = this["oGetScrollingChildScrollContainer"](oBrowserEvent);

	if (!oScrollContainer) {
		if (this["sAlignment"] === 'HORIZONTAL' && iDistX > UCF_Carousel["MOVE_THRESHOLD"] && !window["UCF_System"]["bIsRTL"] ||
			this["sAlignment"] === 'HORIZONTAL' && iDistX < -UCF_Carousel["MOVE_THRESHOLD"] && window["UCF_System"]["bIsRTL"] ||
			this["sAlignment"] === 'VERTICAL' && iDistY > UCF_Carousel["MOVE_THRESHOLD"]) {
			this["scrollTo"](this["iFirstVisible"] - 1);
		}
		if (this["sAlignment"] === 'HORIZONTAL' && iDistX < -UCF_Carousel["MOVE_THRESHOLD"] && !window["UCF_System"]["bIsRTL"] ||
			this["sAlignment"] === 'HORIZONTAL' && iDistX > UCF_Carousel["MOVE_THRESHOLD"] && window["UCF_System"]["bIsRTL"] ||
			this["sAlignment"] === 'VERTICAL' && iDistY < -UCF_Carousel["MOVE_THRESHOLD"]) {
			this["scrollTo"](this["iFirstVisible"] + 1);
		}

		if (UCF_DomUtil["bContains"](this["oGetScrollRef"](), oBrowserEvent["oGetSource"]())) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	};
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterPointerUp"] = 0; };

/** @override */
UCF_SingleCarousel["prototype"]["_updateNavigation"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["_updateNavigation"]++; }; 
	/** @type {number} */
	var iItems = this["aGetItems"]()["length"];

	if (this["oPrevButton"]) {
		this["enablePrevButton"](iItems > 0 && this["iFirstVisible"] > 0);
	}
	if (this["oNextButton"]) {
		this["enableNextButton"](iItems > 0 && this["iFirstVisible"] < iItems - 1);
	}
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["_updateNavigation"] = 0; };

/**
 * @override
 * @return { number }
 */
UCF_SingleCarousel["prototype"]["iGetPrevIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iGetPrevIndex"]++; }; 
	return this["iFirstVisible"] > 0 ? this["iFirstVisible"] - 1 : 0;
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iGetPrevIndex"] = 0; };

/**
 * @override
 * @return { number }
 */
UCF_SingleCarousel["prototype"]["iGetPrevPageIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iGetPrevPageIndex"]++; }; 
	return this["iFirstVisible"] - this["iPageSize"] > 0 ? this["iFirstVisible"] - this["iPageSize"] : 0;
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iGetPrevPageIndex"] = 0; };

/**
 * @override
 * @return { number }
 */
UCF_SingleCarousel["prototype"]["iGetNextIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iGetNextIndex"]++; }; 
	return this["iFirstVisible"] < this["aGetItems"]()["length"] - 1 ? this["iFirstVisible"] + 1 : this["iFirstVisible"];
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iGetNextIndex"] = 0; };

/**
 * @override
 * @return { number }
 */
UCF_SingleCarousel["prototype"]["iGetNextPageIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iGetNextPageIndex"]++; }; 
	return this["iFirstVisible"] + this["iPageSize"] < this["aGetItems"]()["length"] - 1 ? this["iFirstVisible"] + this["iPageSize"] : this["aGetItems"]()["length"] - 1;
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iGetNextPageIndex"] = 0; };

UCF_SingleCarousel["prototype"]["onAfterAnimationStep"] = function(oConfiguration, iStep) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterAnimationStep"]++; }; 
	// FadeIn the future visible item
	UCF_DomUtil["setStyle"](
		this["aGetItems"]()[oConfiguration["iCurrentIndex"]]["oDomRef"], { "opacity": 1 - UCF_SingleCarousel["iCalcOpacity"](iStep) }
	);
	// FadeOut current visible item
	UCF_DomUtil["setStyle"](
		this["aGetItems"]()[oConfiguration["iFutureIndex"]]["oDomRef"], { "opacity": UCF_SingleCarousel["iCalcOpacity"](iStep) }
	);
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterAnimationStep"] = 0; };

/** @private */
UCF_SingleCarousel["prototype"]["hideItemsBeforeFirstVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["hideItemsBeforeFirstVisible"]++; }; 
	/** @type {number} */
	var index = 0;
	/** @type {UCF_Carousel_ItemInfo[]} */
	var items = this["aGetItems"]();

	// _trace(INFO, 'iFirstVisible == ' + this.iFirstVisible);

	for (index; index < this["iFirstVisible"]; index++) {
		UCF_DomUtil["setStyle"](items[index]["oDomRef"], { "visibility": 'hidden' });
	};
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["hideItemsBeforeFirstVisible"] = 0; };

/**@private */
UCF_SingleCarousel["prototype"]["updateFirstVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["updateFirstVisible"]++; }; 
	/** @type {UCF_Carousel} */
	var self = this;
	/** @type {number} */
	var iCounter = 0;

	UCF_JsUtil["forEach"](this["aGetItems"](), function(item, index) {
		switch (self["sAlignment"]) {
			case 'HORIZONTAL':
				if (UCF_DomUtil["bIsRTL"]) {
					if (self["iGetOffsetRight"](index) + item["iOffsetWidth"] <= self["iGetScrollRefScrollWidth"]() - self["iGetScrollRefClientWidth"]() - UCF_DomUtil["iGetScrollLeft"](self["oGetScrollRef"]())) {
						iCounter++;
					}
				} else {
					// eslint-disable-next-line no-lonely-if
					if (item["iOffsetLeft"] + item["iOffsetWidth"] <= UCF_DomUtil["iGetScrollLeft"](self["oGetScrollRef"]())) {
						iCounter++;
					}
				}
				break;
			case 'VERTICAL':
				if (item["iOffsetTop"] + item["iOffsetHeight"] <= self["oGetScrollRef"]()["scrollTop"]) {
					iCounter++;
					break;
				}
		}
	});
	// _trace(INFO, 'iFirstVisible = ' + iCounter);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["iFirstVisible"] = iCounter;
	this["setClientProperty"]('FirstVisible', this["iFirstVisible"], true);
	if (window["UCF_System"]["bIsAria"]) { this["updateAriaAttributes"](); };
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["updateFirstVisible"] = 0; };

/**
 * @private
 * @static
 * @param {number} x
 * @return {number}
 */
UCF_SingleCarousel["iCalcOpacity"] = function(x) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iCalcOpacity"]++; }; 
	return Math["max"](0.0, Math["min"](1.0, x));
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["iCalcOpacity"] = 0; };

/**
 * @override
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SingleCarousel["prototype"]["onAfterlsfocusItemDomRef"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterlsfocusItemDomRef"]++; }; 
	this["focus"]();
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterlsfocusItemDomRef"] = 0; };

/**
 * @override
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SingleCarousel["prototype"]["onAfterMousewheel"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterMousewheel"]++; }; 
	/** @type {number} */
	var iScrollDistance = oBrowserEvent["iWheelDelta"]();
	// var iScrollDistance = oBrowserEvent.oDomEvent.wheelDelta / 120 * 40;
	/** @type {UCF_ScrollContainer} */
	var oScrollContainer = this["oGetScrollingChildScrollContainer"](oBrowserEvent);

	if (
		iScrollDistance > 0 &&
		(!oScrollContainer || this["bIsScrolledToStart"](oScrollContainer))
	) {
		this["scrollTo"](this["iGetPrevIndex"]());
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else if (
		iScrollDistance < 0 &&
		(!oScrollContainer || this["bIsScrolledToEnd"](oScrollContainer))
	) {
		this["scrollTo"](this["iGetNextIndex"]());
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	};
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["onAfterMousewheel"] = 0; };

/**
 * @private
 * @param {UCF_ScrollContainer} oScrollContainer
 * @return {boolean}
 */
UCF_SingleCarousel["prototype"]["bIsScrolledToStart"] = function(oScrollContainer) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["bIsScrolledToStart"]++; }; 
	return oScrollContainer["getScrollPosition"]()["top"] === 0;
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["bIsScrolledToStart"] = 0; };

/**
 * @private
 * @param {UCF_ScrollContainer} oScrollContainer
 * @return {boolean}
 */
UCF_SingleCarousel["prototype"]["bIsScrolledToEnd"] = function(oScrollContainer) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["bIsScrolledToEnd"]++; }; 
	return oScrollContainer["getScrollPosition"]()["top"] +
		oScrollContainer["oDomRef"]["clientHeight"] >=
		oScrollContainer["oScrollArea"]["oDomRef"]["scrollHeight"];
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["bIsScrolledToEnd"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {UCF_ScrollContainer}
 */
UCF_SingleCarousel["prototype"]["oGetScrollingChildScrollContainer"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["oGetScrollingChildScrollContainer"]++; }; 
	/** @type {UCF_Control} */
	var oSource = oBrowserEvent["oGetSourceControl"]();

	while (oSource !== this) {
		if (
			UCF_JsUtil["bInstanceOf"](oSource, 'UCF_ScrollContainer') &&
			oSource["oScrollArea"]
		) {
			return oSource;
		}
		oSource = oSource["oGetParent"]();
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_SingleCarousel["_"]["oGetScrollingChildScrollContainer"] = 0; };

};
sap["ls"]["preload"]["UCF_SingleColumnLayout"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SingleColumnLayout(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SingleColumnLayout["_"]["UCF_SingleColumnLayout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "SingleColumnLayout.js(21): UCF_SingleColumnLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SingleColumnLayout.js(22): UCF_SingleColumnLayout"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SingleColumnLayout.js(23): UCF_SingleColumnLayout"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_SingleColumnLayout"] = UCF_SingleColumnLayout; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SingleColumnLayout"); UCF_SingleColumnLayout["_"] = {UCF_SingleColumnLayout: 0}; }; ;
UCF_SingleColumnLayout["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_SingleColumnLayout.prototype["sClassName"] = "UCF_SingleColumnLayout";

/**
 * @private
 * @param {UCF_DTElement} oDTElement
 * @return {UCF_DTExtension}
 */
UCF_SingleColumnLayout["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_SingleColumnLayout["_"]["oGetDTExtension"]++; }; 
	return UCF_Control.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]("UCF_LayoutEditorExtension"));
};;if (__UCF_COVERAGE__) { UCF_SingleColumnLayout["_"]["oGetDTExtension"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_SingleColumnLayout["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SingleColumnLayout["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SingleColumnLayout.js(46): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SingleColumnLayout["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_SingleColumnLayout["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SingleColumnLayout["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SingleColumnLayout.js(58): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SingleColumnLayout["_"]["onlsskipback"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SingleColumnLayout["prototype"]["aAttributeNames"] = ["sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SingleColumnLayout["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SingleColumnLayout["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_SingleColumnLayout["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_SingleColumnLayout["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_SingleColumnLayout["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SingleColumnLayout["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SingleColumnLayout["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_SizeInfo"] = function() {/* global _trace, DEBUG, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * Shows or hides an size info pane
 *
 * @class
 * 
 * @version
 */
function UCF_SizeInfo() {if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["UCF_SizeInfo"]++; }; 
	UCF_Object["apply"](this);

	/** @type {boolean} */
	this["bRunning"] = false;
	/** @type {HTMLDivElement} */
	this["oDiv"] = null;
	/** @type {string} */
	this["sOut"] = null;
	/** @type {function(Event): void} */
	this["updateForwarder"] = null;
	/** @type {function(Event): void} */
	this["eventForwarder"] = null;
};window["UCF_SizeInfo"] = UCF_SizeInfo; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SizeInfo"); UCF_SizeInfo["_"] = {UCF_SizeInfo: 0}; }; ;
UCF_SizeInfo["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_SizeInfo.prototype["sClassName"] = "UCF_SizeInfo";

/** @override */
UCF_SizeInfo["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["destroy"]++; }; 
	this["stop"]();

	this["sOut"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["destroy"] = 0; };

/**
 * Trigger method which is called by the debug handler when shortcut is pressed
 * @protected
 */
UCF_SizeInfo["prototype"]["trigger"] = function() {;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["trigger"]++; }; 
	// Toggle display on and off
	if (this["bRunning"]) {
		this["stop"]();
	} else {
		this["start"]();
	}
};;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["trigger"] = 0; };

/**
 * shows the info pane
 * @private
 */
UCF_SizeInfo["prototype"]["start"] = function() {;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["start"]++; }; 
	/** @type {Document} */
	var oDoc;
	/** @type {HTMLDivElement} */
	var oDiv;
	/** @type {UCF_SizeInfo} */
	var self = this;

	if (__UCF_DEBUG__) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Show Size Info', "SizeInfo.js(68): updateForwarder"); };
		oDoc = UCF_DomUtil["oGetDocument"]();

		oDiv = oDoc["createElement"]('div');
		UCF_DomUtil["setStyle"](oDiv, {
			"position": 'absolute',
			"left": '10px',
			"height": '40px',
			"backgroundColor": '#FF7',
			"border": '1px solid #888',
			"margin": '3px',
			"padding": '2px',
			"overflow": 'auto',
			"fontSize": '0.7em',
			"zIndex": 9999
		});

		// eslint-disable-next-line no-magic-numbers
		UCF_DomUtil["setOpacityStyle"](oDiv, 80);

		UCF_DomUtil["setInnerHtml"](oDiv, 'Size Info - Ready');
		oDoc["body"]["appendChild"](oDiv);

		this["oDiv"] = oDiv;
		UCF_DomUtil["attachEvent"](this["oDiv"], 'selectstart', function() { return false; });

		this["updatePanePosition"]();

		this["sOut"] = '';
		this["updateForwarder"] = function(oEvent) { self["updateSizeInfo"](oEvent); };
		//this.oHelperInterval = setInterval(this.updateForwarder ,250);

		UCF_DomUtil["attachEvent"](oDoc, 'mousemove', this["updateForwarder"]);

		this["eventForwarder"] = function() {
			self["onScrollOrResize"]();
		};

		UCF_DomUtil["attachEvent"](oDiv, 'click', function() {
			if (window["clipboardData"] && window["clipboardData"]["setData"]) {
				window["clipboardData"]["setData"]('Text', self["sOut"]);
			}

			return false;
		});

		UCF_DomUtil["attachEvent"](window, 'scroll', this["eventForwarder"]);
		UCF_DomUtil["attachEvent"](window, 'resize', this["eventForwarder"]);

		this["bRunning"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["start"] = 0; };

/** hides the info pane
 * @private
 */
UCF_SizeInfo["prototype"]["stop"] = function() {;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["stop"]++; }; 
	/** @type {Document} */
	var oDoc = UCF_DomUtil["oGetDocument"]();

	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Hide Size Info', "SizeInfo.js(128): stop"); };
	/*if (this.oHelperInterval) {
		clearInterval(this.oHelperInterval);
	}*/
	UCF_DomUtil["detachEvent"](oDoc, 'mousemove', this["updateForwarder"]);
	UCF_DomUtil["detachEvent"](window, 'scroll', this["eventForwarder"]);
	UCF_DomUtil["detachEvent"](window, 'resize', this["eventForwarder"]);
	this["bRunning"] = false;

	this["updateForwarder"] = null;
	this["eventForwarder"] = null;

	oDoc["body"]["removeChild"](this["oDiv"]);
	UCF_DomUtil["detachEvent"](this["oDiv"], 'selectstart');
	this["oDiv"] = null;
};;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["stop"] = 0; };

/**
 * Update the the text displayed in the info pane
 * @param {Event} oEvent the event
 * @private
 */
UCF_SizeInfo["prototype"]["updateSizeInfo"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["updateSizeInfo"]++; }; 
	/** @type {Document} */
	var oDoc;
	/** @type {_ObjectRect} */
	var oActiveElementPosition;
	/** @type {string} */
	var sX;
	/** @type {string} */
	var sY;
	/** @type {HTMLElement} */
	var oP;

	try {
		oDoc = UCF_DomUtil["oGetDocument"]();

		if (oDoc["activeElement"]) {
			oActiveElementPosition = UCF_DomUtil["oGetObjectRect"](oDoc["activeElement"]);
			sX = 'Size:';
			sY = 'Size:';

			if (oEvent) {
				sX += ' cX:' + oEvent["clientX"] + ' sX:' + oEvent["screenX"];
				sY += ' cY:' + oEvent["clientY"] + ' sY:' + oEvent["screenY"];

				if (oEvent["offsetX"]) {
					sX += ' oX:' + oEvent["offsetX"];
					sY += ' oY:' + oEvent["offsetY"];
				}

				if (window["event"]) {
					sX += ' weX:' + window["event"]["x"];
					sY += ' weY:' + window["event"]["y"];
				}
			}

			if (oDoc["activeElement"]["width"]) {
				sX += ' w:' + oDoc["activeElement"]["width"];
				sY += ' h:' + oDoc["activeElement"]["height"];
			}

			sX += ' cW:' + oDoc["activeElement"]["clientWidth"]
				+ ' oL:' + oDoc["activeElement"]["offsetLeft"]
				+ ' oW:' + oDoc["activeElement"]["offsetWidth"]
				+ ' sL:' + oDoc["body"]["scrollLeft"]
				+ ' RL:' + oActiveElementPosition["left"]
				+ ' RW:' + oActiveElementPosition["width"];
			sY += ' cH:' + oDoc["activeElement"]["clientHeight"]
				+ ' oT:' + oDoc["activeElement"]["offsetTop"]
				+ ' oH:' + oDoc["activeElement"]["offsetHeight"]
				+ ' sT:' + oDoc["body"]["scrollTop"]
				+ ' RT:' + oActiveElementPosition["top"]
				+ ' RH:' + oActiveElementPosition["height"];

			if (
				oDoc["activeElement"]["offsetParent"] &&
				oDoc["activeElement"]["offsetParent"] != null
			) {
				oP = oDoc["activeElement"]["offsetParent"];
				sX += ' oPoL:' + oP["offsetLeft"];
				sY += ' oPoT:' + oP["offsetTop"];
			}

			if (oDoc["activeElement"]["id"]) {
				sY += ' Active:' + oDoc["activeElement"]["id"];
			}
			UCF_DomUtil["setInnerHtml"](this["oDiv"], sX + '<br/>' + sY);
			this["sOut"] = this["oDiv"]["innerText"];
		}
	} catch (e) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Error in size info' + e, "SizeInfo.js(219): updateSizeInfo"); };
	} // suppress any errors
};;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["updateSizeInfo"] = 0; };

/**
 * Scroll event handler
 * @private
 */
UCF_SizeInfo["prototype"]["onScrollOrResize"] = function() {;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["onScrollOrResize"]++; }; 
	this["updatePanePosition"]();
};;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["onScrollOrResize"] = 0; };

/**
 * Update the position of the info pane on the screen
 * @private
 */
UCF_SizeInfo["prototype"]["updatePanePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["updatePanePosition"]++; }; 
	UCF_DomUtil["setStyle"](this["oDiv"], {
		"top": (
			UCF_DomUtil["iClientHeight"]() -
			this["oDiv"]["offsetHeight"] -
			6 + // eslint-disable-line no-magic-numbers
			UCF_DomUtil["oGetScrollOffset"]()["y"]
		) + 'px',
		// eslint-disable-next-line no-magic-numbers
		"width": (UCF_DomUtil["iClientWidth"]() - 20) + 'px'
	});
};;if (__UCF_COVERAGE__) { UCF_SizeInfo["_"]["updatePanePosition"] = 0; };

};
sap["ls"]["preload"]["UCF_Slideshow"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * @class
 * @extends UCF_Control
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Slideshow(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["UCF_Slideshow"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Slideshow.js(19): UCF_Slideshow"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Slideshow.js(20): UCF_Slideshow"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Slideshow.js(21): UCF_Slideshow"); };
	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oDomRef"] = oDomRef;
	this["oInnerDomRef"] = UCF_DomUtil["oGetFirstChild"](oDomRef);

	//TODO: depends on images
	this["oTileSize"] = { "width": 204, "height": 206 };
	this["oTileCount"] = UCF_DomUtil["oGetFirstChild"](this["oInnerDomRef"])["rows"][0]["cells"]["length"];
	this["iOldDate"] = 0;

	//TODO: depends on which image should be displayed
	this["oPosition"] = {
		"x": 0,
		"y": 0
	};

	this["oObjectSpeed"] = {
		"x": 0,
		"y": 0
	};

	this["sUpdateInterval"] = UCF_JsUtil["intervalCall"](UCF_Slideshow["SAMPLE_INTERVAL"], this, "updatePosition");

};window["UCF_Slideshow"] = UCF_Slideshow; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Slideshow"); UCF_Slideshow["_"] = {UCF_Slideshow: 0}; }; 

UCF_Slideshow["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Slideshow.prototype["sClassName"] = "UCF_Slideshow";

UCF_Slideshow["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["destroy"]++; }; 

	UCF_JsUtil["clearIntervalCall"](this["sUpdateInterval"]);
	this["oInnerDomRef"] = null;
	this["oTileCount"] = null;
	this["iOldDate"] = null;
	this["oObjectSpeed"] = null;
	this["sUpdateInterval"] = null;
	this["sPullInterval"] = null;
	this["oDragOffset"] = null;
	this["iDragIndex"] = null;
	this["iMouseX"] = null;
	this["iMouseY"] = null;
	this["oPreviousMouseLocation"] = null;
	this["fMouseMove"] = null;
	this["fMouseUp"] = null;
	this["oMouseSpeed"] = null;
	this["sMouseSampleInterval"] = null;
	this["oVector"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["destroy"] = 0; };

UCF_Slideshow["DAMPING_FACTOR"] = .75;
UCF_Slideshow["SAMPLE_INTERVAL"] = 10;
UCF_Slideshow["SPEEDTHRESHOLD"] = 3;

/**
 *
 */
UCF_Slideshow["prototype"]["updatePosition"] = function() {;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["updatePosition"]++; }; 

	//damp the current speed
	this["oObjectSpeed"]["x"] *= UCF_Slideshow["DAMPING_FACTOR"];
	this["oObjectSpeed"]["y"] *= UCF_Slideshow["DAMPING_FACTOR"];

	//move layer accordin to speed
	this["oInnerDomRef"]["style"]["left"] = (this["oPosition"]["x"] += this["oObjectSpeed"]["x"]) + "px";

};;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["updatePosition"] = 0; };

/**
 *
 */
UCF_Slideshow["prototype"]["pullTo"] = function(oPosition, fForce) {;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["pullTo"]++; }; 

	UCF_JsUtil["clearIntervalCall"](this["sPullInterval"]);
	this["sPullInterval"] = UCF_JsUtil["intervalCall"](UCF_Slideshow["SAMPLE_INTERVAL"], this, "pull", [oPosition, fForce]);
	this["pull"](oPosition, fForce);

};;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["pullTo"] = 0; };

UCF_Slideshow["prototype"]["pull"] = function(oTargetPosition, fForce) {;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["pull"]++; }; 

	var oDistanceVector = {
		"x": oTargetPosition["x"] - this["oPosition"]["x"],
		"y": oTargetPosition["y"] - this["oPosition"]["y"]
	};

	if (Math["abs"](oDistanceVector["x"]) < 1) {
		UCF_JsUtil["clearIntervalCall"](this["sPullInterval"]);
		return;
	}

	this["oObjectSpeed"] = {
		"x": oDistanceVector["x"] * fForce,
		"y": oDistanceVector["y"] * fForce
	};
};;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["pull"] = 0; };

UCF_Slideshow["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["onmousedown"]++; }; 

	this["oDragOffset"] = {
		"x": oBrowserEvent["iClientX"]() - UCF_DomUtil["oGetObjectRect"](this["oInnerDomRef"])["left"],
		"y": oBrowserEvent["iClientY"]() - UCF_DomUtil["oGetObjectRect"](this["oInnerDomRef"])["top"]
	};

	this["iDragIndex"] = Math["floor"](this["oDragOffset"]["x"] / this["oTileSize"]["width"]);

	this["oPreviousMouseLocation"] = {
		"x": oBrowserEvent["iClientX"](),
		"y": oBrowserEvent["iClientY"]()
	};

	var that = this;
	UCF_DomUtil["attachEvent"](window["document"], "mousemove", this["fMouseMove"] = function(event) { that["handlemousemove"](event); });
	UCF_DomUtil["attachEvent"](window["document"], "mouseup", this["fMouseUp"] = function(event) { that["onmouseup"](event); });

	//start sampling speed
	this["startSampling"]();

};;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["onmousedown"] = 0; };

UCF_Slideshow["prototype"]["startSampling"] = function() {;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["startSampling"]++; }; 

	this["oMouseSpeed"] = {
		"x": 0,
		"y": 0
	};
	this["iOldDate"] = new Date()["valueOf"]();
	this["sMouseSampleInterval"] = UCF_JsUtil["intervalCall"](UCF_Slideshow["SAMPLE_INTERVAL"], this, "takeSample");

};;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["startSampling"] = 0; };

UCF_Slideshow["prototype"]["takeSample"] = function() {;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["takeSample"]++; }; 

	this["oVector"] = {
		"x": this["iMouseX"] - this["oPreviousMouseLocation"]["x"],
		"y": this["iMouseY"] - this["oPreviousMouseLocation"]["y"]
	};

	var date = new Date()["valueOf"]();

	this["oMouseSpeed"] = {
		"x": this["oVector"]["x"], //(this.oVector.x - this.oObjectSpeed.x) * UCF_Slideshow.DAMPING_FACTOR,
		"y": (this["oVector"]["y"] - this["oObjectSpeed"]["y"]) * UCF_Slideshow["DAMPING_FACTOR"]
	};

	this["iOldDate"] = date;
	this["oPreviousMouseLocation"] = {
		"x": this["iMouseX"],
		"y": this["iMouseY"]
	};

};;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["takeSample"] = 0; };

UCF_Slideshow["prototype"]["handlemousemove"] = function(event) {;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["handlemousemove"]++; }; 

	event = event || window["event"];

	this["iMouseX"] = event["clientX"];
	this["iMouseY"] = event["clientY"];

	this["pullTo"]({
		"x": event["clientX"] - this["oDragOffset"]["x"] - UCF_DomUtil["oGetObjectRect"](this["oDomRef"])["left"],
		"y": event["clientY"] - this["oDragOffset"]["y"]
	}, 1);

};;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["handlemousemove"] = 0; };

UCF_Slideshow["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["onmouseup"]++; }; 

	UCF_DomUtil["detachEvent"](window["document"], "mousemove", this["fMouseMove"]);
	UCF_DomUtil["detachEvent"](window["document"], "mouseup", this["fMouseUp"]);
	UCF_JsUtil["clearIntervalCall"](this["sMouseSampleInterval"]);

	//get currently touched image
	var iIndex = Math["round"](-this["oPosition"]["x"] / this["oTileSize"]["width"]);

	//see if mouse speed is above a certain threshold
	if (this["oMouseSpeed"]["x"] > UCF_Slideshow["SPEEDTHRESHOLD"]) {
		//gesture wipe right
		iIndex = this["iDragIndex"] - 1;
	} else if (this["oMouseSpeed"]["x"] < -UCF_Slideshow["SPEEDTHRESHOLD"]) {
		//gesture wipe left
		iIndex = this["iDragIndex"] + 1;
	}

	if (iIndex < 0)
		iIndex = 0;

	if (iIndex > this["oTileCount"] - 1)
		iIndex = this["oTileCount"] - 1;

	//not enough momentum
	//let position decide where image snaps to

	this["pullTo"]({ "x": -iIndex * this["oTileSize"]["width"], "y": 0 }, 0.3);

};;if (__UCF_COVERAGE__) { UCF_Slideshow["_"]["onmouseup"] = 0; };

/**
 * pushes the object

UCF_Slideshow.prototype.push = function(oVector){

  this.oObjectSpeed.x += oVector.x;
  this.oObjectSpeed.y += oVector.y;

};
*/

};
sap["ls"]["preload"]["UCF_Splitter"] = function() {/* global _assert, _trace, _measure, DEBUG, ERROR, START, STOP */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_SplitterBase */
/// <reference path="./base/SplitterBase.js"/>
/* eslint quotes:0 */

/**
 * Use the SAP Splitter {@link UCF_Control} to construct a group of
 * {@link UCF_Control}s within an area, each of which is placed in a separate
 * cell. The {@link UCF_Splitter} control manages and displays the cells. You
 * can change the size of the cells using a sash. Enlarging one cell reduces
 * the size of the adjacent cell.
 *
 * 
 * @version 1.0.0.0
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Splitter(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Splitter["_"]["UCF_Splitter"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) == "object", "typeof (oDomRef) == \"object\"", "Splitter.js(43): UCF_Splitter"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Splitter.js(44): UCF_Splitter"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Splitter.js(45): UCF_Splitter"); };

		UCF_SplitterBase["apply"](this, [oDomRef, oLS]);
	}
};window["UCF_Splitter"] = UCF_Splitter; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Splitter"); UCF_Splitter["_"] = {UCF_Splitter: 0}; }; ;
UCF_Splitter["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterBase"))(); UCF_Splitter.prototype["sClassName"] = "UCF_Splitter";

/**
 * Destructor
 * @private
 */
UCF_Splitter["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["destroy"]++; }; 
	UCF_SplitterBase.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["destroy"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Splitter["prototype"]["aAttributeNames"] = ["sId","iWidth","sWidthSizeMode","sWidthSizeModeOfColums","iHeight","sHeightSizeMode","sHeightSizeModeOfRows","sMode","bDebugMode","sVisibility","sType","sCustomData","sCustomStyle","bVerticalPushMode","sSashDragBehavior","sRenderingMode"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Splitter["prototype"]["aEventNames"] = ["MoveEnd","Scroll","DoubleClick","Expand","Collapse","Resize"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Splitter["prototype"]["aMethodNames"] = ["setColumnWidth","setSplitterWidth","setRowHeight","setSplitterHeight","getAvailableWidth","getAvailableHeight","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Splitter["prototype"]["sId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_Splitter["prototype"]["iWidth"] = -1;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterSizeMode}
 */
UCF_Splitter["prototype"]["sWidthSizeMode"] = "RELATIVE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterSizeMode}
 */
UCF_Splitter["prototype"]["sWidthSizeModeOfColums"] = "ABSOLUTE";

/**
 * @private
 * @type {number}
 */
UCF_Splitter["prototype"]["iHeight"] = -1;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterSizeMode}
 */
UCF_Splitter["prototype"]["sHeightSizeMode"] = "RELATIVE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterSizeMode}
 */
UCF_Splitter["prototype"]["sHeightSizeModeOfRows"] = "ABSOLUTE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterMode}
 */
UCF_Splitter["prototype"]["sMode"] = "WEB";

/**
 * @private
 * @type {boolean}
 */
UCF_Splitter["prototype"]["bDebugMode"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Splitter["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterType}
 */
UCF_Splitter["prototype"]["sType"] = "SPLITTER";

/**
 * @private
 * @type {string}
 */
UCF_Splitter["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Splitter["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Splitter["prototype"]["bVerticalPushMode"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterSashDragBehavior}
 */
UCF_Splitter["prototype"]["sSashDragBehavior"] = "SERVERSIDE_DRAGGING";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterRenderingMode}
 */
UCF_Splitter["prototype"]["sRenderingMode"] = "HEAVY_DOM";

//#JSCOVER_EXCL_START
/** @protected */
UCF_Splitter["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["iWidth"] = -1;
	this["sWidthSizeMode"] = "RELATIVE";
	this["sWidthSizeModeOfColums"] = "ABSOLUTE";
	this["iHeight"] = -1;
	this["sHeightSizeMode"] = "RELATIVE";
	this["sHeightSizeModeOfRows"] = "ABSOLUTE";
	this["sMode"] = "WEB";
	this["bDebugMode"] = false;
	this["sVisibility"] = "VISIBLE";
	this["sType"] = "SPLITTER";
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["bVerticalPushMode"] = false;
	this["sSashDragBehavior"] = "SERVERSIDE_DRAGGING";
	this["sRenderingMode"] = "HEAVY_DOM";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("Width", -1, true);
		this["setClientProperty"]("WidthSizeMode", "RELATIVE", true);
		this["setClientProperty"]("WidthSizeModeOfColums", "ABSOLUTE", true);
		this["setClientProperty"]("Height", -1, true);
		this["setClientProperty"]("HeightSizeMode", "RELATIVE", true);
		this["setClientProperty"]("HeightSizeModeOfRows", "ABSOLUTE", true);
		this["setClientProperty"]("Mode", "WEB", true);
		this["setClientProperty"]("DebugMode", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Type", "SPLITTER", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("VerticalPushMode", false, true);
		this["setClientProperty"]("SashDragBehavior", "SERVERSIDE_DRAGGING", true);
		this["setClientProperty"]("RenderingMode", "HEAVY_DOM", true);
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Id of the splitter
 * @param {boolean} bIsColumnResize Type of the sash
 * @param {number} iPrevious Size of the previous cells. The size is maybe wrong if the default size was used. Please check at first the default frlags inside of this event.
 * @param {number} iNext Size of the following cells. The size is maybe wrong if the default size was used. Please check at first the default frlags inside of this event.
 * @param {boolean} bIsAbsolute The mode of the size parameter in the event
 * @param {string} sPreviousElements Elements of the previous cells
 * @param {boolean} bIsDefaultSizeInPreviousElements true if the elements are defined with the default size
 * @param {string} sNextElements Elements of the following cells
 * @param {boolean} bIsDefaultSizeInNextElements true if the elements are defined with the default size
 * @param {number} iExpanded Size of original Splitter cell before it was collapsed. It is the default value if the Splitter is expanded.
 * @fires Splitter::MoveEnd
 */
UCF_Splitter["prototype"]["fireMoveEnd"] = function(sId, bIsColumnResize, iPrevious, iNext, bIsAbsolute, sPreviousElements, bIsDefaultSizeInPreviousElements, sNextElements, bIsDefaultSizeInNextElements, iExpanded) {;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireMoveEnd"]++; }; 
	/** @type {{Id: string, IsColumnResize: boolean, Previous: number, Next: number, IsAbsolute: boolean, PreviousElements: string, IsDefaultSizeInPreviousElements: boolean, NextElements: string, IsDefaultSizeInNextElements: boolean, Expanded: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 10, "arguments.length == 10", "Splitter.js(237): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Splitter.js(238): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Splitter.js(239): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsColumnResize != null, "bIsColumnResize != null", "Splitter.js(240): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsColumnResize) == "boolean", "typeof(bIsColumnResize) == \"boolean\"", "Splitter.js(241): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPrevious != null, "iPrevious != null", "Splitter.js(242): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPrevious) == "number", "typeof(iPrevious) == \"number\"", "Splitter.js(243): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iNext != null, "iNext != null", "Splitter.js(244): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iNext) == "number", "typeof(iNext) == \"number\"", "Splitter.js(245): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsAbsolute != null, "bIsAbsolute != null", "Splitter.js(246): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsAbsolute) == "boolean", "typeof(bIsAbsolute) == \"boolean\"", "Splitter.js(247): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPreviousElements != null, "sPreviousElements != null", "Splitter.js(248): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPreviousElements) == "string", "typeof(sPreviousElements) == \"string\"", "Splitter.js(249): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsDefaultSizeInPreviousElements != null, "bIsDefaultSizeInPreviousElements != null", "Splitter.js(250): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsDefaultSizeInPreviousElements) == "boolean", "typeof(bIsDefaultSizeInPreviousElements) == \"boolean\"", "Splitter.js(251): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNextElements != null, "sNextElements != null", "Splitter.js(252): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNextElements) == "string", "typeof(sNextElements) == \"string\"", "Splitter.js(253): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsDefaultSizeInNextElements != null, "bIsDefaultSizeInNextElements != null", "Splitter.js(254): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsDefaultSizeInNextElements) == "boolean", "typeof(bIsDefaultSizeInNextElements) == \"boolean\"", "Splitter.js(255): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iExpanded != null, "iExpanded != null", "Splitter.js(256): fireMoveEnd"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iExpanded) == "number", "typeof(iExpanded) == \"number\"", "Splitter.js(257): fireMoveEnd"); };
	mParams = {
		"Id": sId,
		"IsColumnResize": bIsColumnResize,
		"Previous": iPrevious,
		"Next": iNext,
		"IsAbsolute": bIsAbsolute,
		"PreviousElements": sPreviousElements,
		"IsDefaultSizeInPreviousElements": bIsDefaultSizeInPreviousElements,
		"NextElements": sNextElements,
		"IsDefaultSizeInNextElements": bIsDefaultSizeInNextElements,
		"Expanded": iExpanded
	};
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("Splitter", "MoveEnd", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireMoveEnd"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sCellId Identifier of the splitter cell
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires Splitter::Scroll
 * @deprecated
 */
UCF_Splitter["prototype"]["fireScroll"] = function(sId, sCellId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, CellId: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "Splitter.js(298): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Splitter.js(299): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Splitter.js(300): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "Splitter.js(301): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "Splitter.js(302): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "Splitter.js(303): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "Splitter.js(304): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "Splitter.js(305): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "Splitter.js(306): fireScroll"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	if (sCellId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sCellId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "CellId");
			}
		}
	
	
	this["fireSemanticEvent"]("Splitter", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Id of the splitter.
 * @param {string} sPreviousElements Elements of the previous cells.
 * @param {string} sNextElements Elements of the following cells
 * @param {number} iPosition The position of the prevoius row or column.
 * @param {boolean} bIsVerticalSash The type of the sash
 * @param {UCF_ClientInterfaces.E.SplitterSashType} sSashType The resize mode of the sash.
 * @fires Splitter::DoubleClick
 * @deprecated
 */
UCF_Splitter["prototype"]["fireDoubleClick"] = function(sId, sPreviousElements, sNextElements, iPosition, bIsVerticalSash, sSashType) {;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string, PreviousElements: string, NextElements: string, Position: number, IsVerticalSash: boolean, SashType: UCF_ClientInterfaces.E.SplitterSashType}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 6, "arguments.length == 6", "Splitter.js(340): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Splitter.js(341): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Splitter.js(342): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPreviousElements != null, "sPreviousElements != null", "Splitter.js(343): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPreviousElements) == "string", "typeof(sPreviousElements) == \"string\"", "Splitter.js(344): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNextElements != null, "sNextElements != null", "Splitter.js(345): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNextElements) == "string", "typeof(sNextElements) == \"string\"", "Splitter.js(346): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosition != null, "iPosition != null", "Splitter.js(347): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosition) == "number", "typeof(iPosition) == \"number\"", "Splitter.js(348): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsVerticalSash != null, "bIsVerticalSash != null", "Splitter.js(349): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsVerticalSash) == "boolean", "typeof(bIsVerticalSash) == \"boolean\"", "Splitter.js(350): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSashType != null, "sSashType != null", "Splitter.js(351): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSashType) == "string", "typeof(sSashType) == \"string\"", "Splitter.js(352): fireDoubleClick"); };
	mParams = {
		"Id": sId,
		"PreviousElements": sPreviousElements,
		"NextElements": sNextElements,
		"Position": iPosition,
		"IsVerticalSash": bIsVerticalSash,
		"SashType": sSashType
	};
	
	
	
	
	
	
	this["fireSemanticEvent"]("Splitter", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {boolean} bIsColumnResize Type of the sash
 * @param {number} iPrevious Size of the previous cells
 * @param {number} iNext Size of the following cells
 * @param {boolean} bIsAbsolute The mode of the size parameter in the event
 * @param {string} sPreviousElements Elements of the previous cells
 * @param {boolean} bIsDefaultSizeInPreviousElements true if the elements are defined with the default size
 * @param {string} sNextElements Elements of the following cells
 * @param {boolean} bIsDefaultSizeInNextElements true if the elements are defined with the default size
 * @fires Splitter::Expand
 * @deprecated
 */
UCF_Splitter["prototype"]["fireExpand"] = function(sId, bIsColumnResize, iPrevious, iNext, bIsAbsolute, sPreviousElements, bIsDefaultSizeInPreviousElements, sNextElements, bIsDefaultSizeInNextElements) {;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireExpand"]++; }; 
	/** @type {{Id: string, IsColumnResize: boolean, Previous: number, Next: number, IsAbsolute: boolean, PreviousElements: string, IsDefaultSizeInPreviousElements: boolean, NextElements: string, IsDefaultSizeInNextElements: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 9, "arguments.length == 9", "Splitter.js(388): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Splitter.js(389): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Splitter.js(390): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsColumnResize != null, "bIsColumnResize != null", "Splitter.js(391): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsColumnResize) == "boolean", "typeof(bIsColumnResize) == \"boolean\"", "Splitter.js(392): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPrevious != null, "iPrevious != null", "Splitter.js(393): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPrevious) == "number", "typeof(iPrevious) == \"number\"", "Splitter.js(394): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iNext != null, "iNext != null", "Splitter.js(395): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iNext) == "number", "typeof(iNext) == \"number\"", "Splitter.js(396): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsAbsolute != null, "bIsAbsolute != null", "Splitter.js(397): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsAbsolute) == "boolean", "typeof(bIsAbsolute) == \"boolean\"", "Splitter.js(398): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPreviousElements != null, "sPreviousElements != null", "Splitter.js(399): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPreviousElements) == "string", "typeof(sPreviousElements) == \"string\"", "Splitter.js(400): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsDefaultSizeInPreviousElements != null, "bIsDefaultSizeInPreviousElements != null", "Splitter.js(401): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsDefaultSizeInPreviousElements) == "boolean", "typeof(bIsDefaultSizeInPreviousElements) == \"boolean\"", "Splitter.js(402): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNextElements != null, "sNextElements != null", "Splitter.js(403): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNextElements) == "string", "typeof(sNextElements) == \"string\"", "Splitter.js(404): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsDefaultSizeInNextElements != null, "bIsDefaultSizeInNextElements != null", "Splitter.js(405): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsDefaultSizeInNextElements) == "boolean", "typeof(bIsDefaultSizeInNextElements) == \"boolean\"", "Splitter.js(406): fireExpand"); };
	mParams = {
		"Id": sId,
		"IsColumnResize": bIsColumnResize,
		"Previous": iPrevious,
		"Next": iNext,
		"IsAbsolute": bIsAbsolute,
		"PreviousElements": sPreviousElements,
		"IsDefaultSizeInPreviousElements": bIsDefaultSizeInPreviousElements,
		"NextElements": sNextElements,
		"IsDefaultSizeInNextElements": bIsDefaultSizeInNextElements
	};
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("Splitter", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireExpand"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {boolean} bIsColumnResize Type of the sash
 * @param {number} iPrevious Size of the previous cells
 * @param {number} iNext Size of the following cells
 * @param {boolean} bIsAbsolute The mode of the size parameter in the event
 * @param {string} sPreviousElements Elements of the previous cells
 * @param {boolean} bIsDefaultSizeInPreviousElements true if the elements are defined with the default size
 * @param {string} sNextElements Elements of the following cells
 * @param {boolean} bIsDefaultSizeInNextElements true if the elements are defined with the default size
 * @fires Splitter::Collapse
 * @deprecated
 */
UCF_Splitter["prototype"]["fireCollapse"] = function(sId, bIsColumnResize, iPrevious, iNext, bIsAbsolute, sPreviousElements, bIsDefaultSizeInPreviousElements, sNextElements, bIsDefaultSizeInNextElements) {;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string, IsColumnResize: boolean, Previous: number, Next: number, IsAbsolute: boolean, PreviousElements: string, IsDefaultSizeInPreviousElements: boolean, NextElements: string, IsDefaultSizeInNextElements: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 9, "arguments.length == 9", "Splitter.js(448): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Splitter.js(449): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Splitter.js(450): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsColumnResize != null, "bIsColumnResize != null", "Splitter.js(451): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsColumnResize) == "boolean", "typeof(bIsColumnResize) == \"boolean\"", "Splitter.js(452): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPrevious != null, "iPrevious != null", "Splitter.js(453): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPrevious) == "number", "typeof(iPrevious) == \"number\"", "Splitter.js(454): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iNext != null, "iNext != null", "Splitter.js(455): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iNext) == "number", "typeof(iNext) == \"number\"", "Splitter.js(456): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsAbsolute != null, "bIsAbsolute != null", "Splitter.js(457): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsAbsolute) == "boolean", "typeof(bIsAbsolute) == \"boolean\"", "Splitter.js(458): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPreviousElements != null, "sPreviousElements != null", "Splitter.js(459): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPreviousElements) == "string", "typeof(sPreviousElements) == \"string\"", "Splitter.js(460): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsDefaultSizeInPreviousElements != null, "bIsDefaultSizeInPreviousElements != null", "Splitter.js(461): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsDefaultSizeInPreviousElements) == "boolean", "typeof(bIsDefaultSizeInPreviousElements) == \"boolean\"", "Splitter.js(462): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNextElements != null, "sNextElements != null", "Splitter.js(463): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNextElements) == "string", "typeof(sNextElements) == \"string\"", "Splitter.js(464): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsDefaultSizeInNextElements != null, "bIsDefaultSizeInNextElements != null", "Splitter.js(465): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsDefaultSizeInNextElements) == "boolean", "typeof(bIsDefaultSizeInNextElements) == \"boolean\"", "Splitter.js(466): fireCollapse"); };
	mParams = {
		"Id": sId,
		"IsColumnResize": bIsColumnResize,
		"Previous": iPrevious,
		"Next": iNext,
		"IsAbsolute": bIsAbsolute,
		"PreviousElements": sPreviousElements,
		"IsDefaultSizeInPreviousElements": bIsDefaultSizeInPreviousElements,
		"NextElements": sNextElements,
		"IsDefaultSizeInNextElements": bIsDefaultSizeInNextElements
	};
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("Splitter", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sCellId Identifier of the splitter cell
 * @param {number} iWidthDelta Delta width of the resize operation
 * @param {number} iHeightDelta Delta height of the resize operation
 * @param {number} iWidth Offset Width of the resize operation. (Always the current size of the cell in px)
 * @param {number} iHeight Height of the resize operation. (Always the current size of the cell in px)
 * @fires Splitter::Resize
 * @deprecated
 */
UCF_Splitter["prototype"]["fireResize"] = function(sId, sCellId, iWidthDelta, iHeightDelta, iWidth, iHeight) {;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireResize"]++; }; 
	/** @type {{Id: string, CellId: string, WidthDelta: number, HeightDelta: number, Width: number, Height: number}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 6, "arguments.length == 6", "Splitter.js(507): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Splitter.js(508): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Splitter.js(509): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sCellId != null, "sCellId != null", "Splitter.js(510): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sCellId) == "string", "typeof(sCellId) == \"string\"", "Splitter.js(511): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iWidthDelta != null, "iWidthDelta != null", "Splitter.js(512): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iWidthDelta) == "number", "typeof(iWidthDelta) == \"number\"", "Splitter.js(513): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iHeightDelta != null, "iHeightDelta != null", "Splitter.js(514): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iHeightDelta) == "number", "typeof(iHeightDelta) == \"number\"", "Splitter.js(515): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iWidth != null, "iWidth != null", "Splitter.js(516): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iWidth) == "number", "typeof(iWidth) == \"number\"", "Splitter.js(517): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iHeight != null, "iHeight != null", "Splitter.js(518): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iHeight) == "number", "typeof(iHeight) == \"number\"", "Splitter.js(519): fireResize"); };
	mParams = {
		"Id": sId,
		"CellId": sCellId,
		"WidthDelta": iWidthDelta,
		"HeightDelta": iHeightDelta,
		"Width": iWidth,
		"Height": iHeight
	};
	
	if (sCellId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sCellId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "CellId");
			}
		}
	
	
	
	
	this["fireSemanticEvent"]("Splitter", "Resize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Splitter["_"]["fireResize"] = 0; };

};
sap["ls"]["preload"]["UCF_SplitterBase"] = function() {/* global _assert, _trace, _measure, DEBUG, ERROR, START, STOP, WARNING, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../../core/util/XSSEncoder.js"/>
/* global UCF_Animation */
/// <reference path="../../anim/Animation.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_UrBase */
/// <reference path="./UrBase.js"/>

/**
 * @class
 * Helper Class for all controls that use the BaseFragment of the HeaderArea Control
 * and for the Header Area Control itself
 * @param { HTMLElement } oDomRef
 * @param { UCF_LS } oLS
 * 
 *
 * @version
 */
function UCF_SplitterBase(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["UCF_SplitterBase"]++; }; 

	// necessary for inheritance
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "SplitterBase.js(41): UCF_SplitterBase"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterBase.js(42): UCF_SplitterBase"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterBase.js(43): UCF_SplitterBase"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	/** @type {Object} */
	this["oSashData"] = null;
	/** @type {HTML_Element} */
	this["oSash"] = null;
	/** @type {Object} */
	this["oSashRect"] = null;
	/** @type {Object} */
	this["oBounds"] = null;
	/** @type {HTML_Element} */
	this["oGhost"] = null;
	/** @type {Object} */
	this["iLastGhostCoordinates"] = null;
	/** @type {Object} */
	this["oSplitterRect"] = null;
	/** @type {Object} - all cols and rows along with their values and units*/
	this["oGridData"] = null;
	/** @type {string} */
	this["sConstantStyles"] = null;
	/** @type {string} */
	this["sNewStyles"] = null;
	/** @type {enum-value} */
	this["sDragSession"] = 'QUIET';
	/** @type {Object} */
	this["oInitialized"] = {};
	/** @type {Object} */
	this["oAfterActionData"] = null;
	/** @type {Object} stores the ids of all cells whose padding has been touched*/
	this["oPaddingData"] = {};
	/** @type {string} */
	this["sAccessType"] = 'NONE';
	/** @type {string} */
	this["sEventsToFire"] = '';
	/** @type {string} */
	this["sTimeOutId"] = null;
	/** @type {boolean} */
	this["bDalayedDoubbleClick"] = false;
	/** @type {boolean} */
	this["bSashAccessed"] = false;
	/** @type {Object} */
	this["oResetSizes"] = {};
	/** @type {int} */
	this["iGhostAtStart"] = -1;
	/** @type {Object} */
	this["oSashAtBounds"] = {};
	/** @type {Object} */
	this["oSashesAtSplitterEnd"] = {};
	/** @type {Object} */
	this["oSashesAtSplitterStart"] = {};
	/** @type {Object} */
	this["oDependencies"] = null;
	/** @type {string} */
	this["sTimeOutId"] = null;
	/** @type {boolean} */
	this["bResizeObserverStarted"] = false;
	/** @type {Array} */
	this["aResizeEvents"] = [];
	/** @type {int} */
	this["iResizeEvents"] = 0;
	/** @type {int} */
	this["iKeyboardStepSize"] = 50;
	/** @type {enum-value} */
	this["sCollectResizeEvent"] = 'START';
	/** @type {enum-value} */
	this["sMousePosition"] = 'OUTSIDE_SPLITTER';
	/** @type {Object} */
	this["oStoredSplitterSizes"] = {
		'width': null,
		'height': null
	};
	/** @type {Object} */
	this["oRelativeSplitterSize"] = {
		'width': 0,
		'height': 0
	};
};window["UCF_SplitterBase"] = UCF_SplitterBase; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterBase"); UCF_SplitterBase["_"] = {UCF_SplitterBase: 0}; }; ;

UCF_SplitterBase["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_SplitterBase.prototype["sClassName"] = "UCF_SplitterBase";

/**
 * Destructor
 * @private
 */
UCF_SplitterBase["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["destroy"]++; }; 
	this["purgeData"]();
	this["sDragSession"] = null;
	this["oInitialized"] = null;
	this["sCellPaddings"] = null;
	this["oPaddingData"] = null;
	this["sAccessType"] = null;
	this["oOldSash"] = null;
	this["bDalayedDoubbleClick"] = null;
	this["oGridData"] = null;
	this["oResetSizes"] = null;
	this["iGhostAtStart"] = null;
	this["oSashData"] = null;
	this["oSash"] = null;
	this["bSashAccessed"] = null;
	this["oSashAtBounds"] = null;
	this["oStoredSplitterSizes"] = null;
	this["oRelativeSplitterSize"] = null;
	this["oSashesAtSplitterEnd"] = null;
	this["oSashesAtSplitterStart"] = null;
	this["oDependencies"] = null;
	this["sTimeOutId"] = null;
	this["bResizeObserverStarted"] = null;
	this["aResizeEvents"] = null;
	this["iResizeEvents"] = null;
	this["sCollectResizeEvent"] = null;
	this["iKeyboardStepSize"] = null;
	this["sMousePosition"] = null;
	this["sEventsToFire"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["destroy"] = 0; };

/**
 * @private
 */
UCF_SplitterBase["prototype"]["purgeData"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["purgeData"]++; }; 
	this["oSashRect"] = null;
	this["oBounds"] = null;
	this["oGhost"] = null;
	this["oGhostRect"] = null;
	this["oSplitterRect"] = null;
	this["sConstantStyles"] = null;
	this["sNewStyles"] = null;
	this["iLastGhostCoordinates"] = null;
	this["aCellWitoutPadding"] = null;
	this["oAfterActionData"] = null;
	this["sAccessType"] = 'NONE';
	this["sEventsToFire"] = '';
	this["sTimeOutId"] = null;
	this["bSashAccessed"] = false;
	this["sCollectResizeEvent"] = 'START';
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["purgeData"] = 0; };

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eNeighbourhood"] = {
	"PREVIOUS": 'PREVIOUS',
	"NEXT": 'NEXT',
	"BOTH": 'BOTH',
	"NONE": 'NONE',
	"ONLY_PREVIOUS_AVAILABLE": 'ONLY_PREVIOUS_AVAILABLE',
	"ONLY_NEXT_AVAILABLE": 'ONLY_NEXT_AVAILABLE',
	"PLACE_BEFORE_BOTH_RESPECT_PREVIOUS": 'PLACE_BEFORE_BOTH_RESPECT_PREVIOUS',
	"PLACE_BEFORE_BOTH_RESPECT_NEXT": 'PLACE_BEFORE_BOTH_RESPECT_NEXT',
	"START": 'START',
	"END": 'END'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eMousePosition"] = {
	"OUTSIDE_SPLITTER": 'OUTSIDE_SPLITTER',
	"INSIDE_SPLITTER": 'INSIDE_SPLITTER'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["ePointing"] = {
	"AT_EACH_OTHER": 'AT_EACH_OTHER',
	"IN_DIFFERENT_DIRECTIONS": 'IN_DIFFERENT_DIRECTIONS'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eSashPosition"] = {
	"OWN_TOGGLE_POSITION_MIN": 'OWN_TOGGLE_POSITION_MIN',
	"OWN_TOGGLE_POSITION_MIN_RETURN_TO_NEXT": 'OWN_TOGGLE_POSITION_MIN_RETURN_TO_NEXT',
	"OWN_TOGGLE_POSITION_MIN_RETURN_TO_PREVIOUS": 'OWN_TOGGLE_POSITION_MIN_RETURN_TO_PREVIOUS',
	"OWN_TOGGLE_POSITION_MIN_AT_BOUNDS_OF_NEXT": 'OWN_TOGGLE_POSITION_MIN_AT_BOUNDS_OF_NEXT',
	"OWN_TOGGLE_POSITION_MIN_ONLY_NEXT": 'OWN_TOGGLE_POSITION_MIN_ONLY_NEXT',

	"OWN_TOGGLE_POSITION_MAX": 'OWN_TOGGLE_POSITION_MAX',
	"OWN_TOGGLE_POSITION_MAX_RETURN_TO_NEXT": 'OWN_TOGGLE_POSITION_MAX_RETURN_TO_NEXT',
	"OWN_TOGGLE_POSITION_MAX_RETURN_TO_PREVIOUS": 'OWN_TOGGLE_POSITION_MAX_RETURN_TO_PREVIOUS',
	"OWN_TOGGLE_POSITION_MAX_AT_BOUNDS_OF_PREVIOUS": 'OWN_TOGGLE_POSITION_MAX_AT_BOUNDS_OF_PREVIOUS',
	"OWN_TOGGLE_POSITION_MAX_ONLY_PREVIOUS": 'OWN_TOGGLE_POSITION_MAX_ONLY_PREVIOUS',

	// only for D&D
	"NEW_DIMESNIONS_MIN": 'NEW_DIMESNIONS_MIN',
	"NEW_DIMESNIONS_MAX": 'NEW_DIMESNIONS_MAX',
	"NEW_EXPAND_POSITION_MIN": 'NEW_EXPAND_POSITION_MIN',
	"NEW_EXPAND_POSITION_MAX": 'NEW_EXPAND_POSITION_MAX',

	"NOT_APPLICABLE": 'NOT_APPLICABLE'
};


/**
 * @private
 */
UCF_SplitterBase["prototype"]["eToggleBehaviour"] = {
	"COLLAPSE_TO_ZERO": 'COLLAPSE_TO_ZERO',
	"COLLAPSE_TO_OWN_EXPANDED_SIZE": 'COLLAPSE_TO_OWN_EXPANDED_SIZE',
	"COLLAPSE_BY_SIZE_OF_CURRENTLY_COLLAPSED": 'COLLAPSE_BY_SIZE_OF_CURRENTLY_COLLAPSED',

	"COLLAPSE_TO_SIZE_OF_PREVIOUS": 'COLLAPSE_TO_SIZE_OF_PREVIOUS',
	"COLLAPSE_TO_SIZE_OF_NEXT": 'COLLAPSE_TO_SIZE_OF_NEXT',
	"COLLAPSE_BY_SIZE_OF_PREVIOUS_OF_ACCESSED": 'COLLAPSE_BY_SIZE_OF_PREVIOUS_OF_ACCESSED',
	"COLLAPSE_BY_SIZE_OF_NEXT_OF_ACCESSED": 'COLLAPSE_BY_SIZE_OF_NEXT_OF_ACCESSED',
	"COLLAPSE_TO_SIZE_OF_OMITTED_AT_MIN": 'COLLAPSE_TO_SIZE_OF_OMITTED_AT_MIN',
	"COLLAPSE_TO_SIZE_OF_OMITTED_AT_MAX": 'COLLAPSE_TO_SIZE_OF_OMITTED_AT_MAX',

	"EXPAND_TO_OWN_EXPANDED_SIZE": 'EXPAND_TO_OWN_EXPANDED_SIZE',
	"EXPAND_TO_SIZE_OF_BOTH": 'EXPAND_TO_SIZE_OF_BOTH',
	"EXPAND_TO_SIZE_OF_CURRENTLY_EXPANDED": 'EXPAND_TO_SIZE_OF_CURRENTLY_EXPANDED',
	"EXPAND_TO_SIZE_OF_PREVIOUS": 'EXPAND_TO_SIZE_OF_PREVIOUS',
	"EXPAND_TO_SIZE_OF_NEXT": 'EXPAND_TO_SIZE_OF_NEXT',
	"EXPAND_TO_SIZE_OF_PREVIOUS_OF_ACCESSED": 'EXPAND_TO_SIZE_OF_PREVIOUS_OF_ACCESSED',
	"EXPAND_TO_SIZE_OF_NEXT_OF_ACCESSED": 'EXPAND_TO_SIZE_OF_NEXT_OF_ACCESSED',
	"EXPAND_TO_SIZE_OF_BOTH_RESPECT_PREVIOUS": 'EXPAND_TO_SIZE_OF_BOTH_RESPECT_PREVIOUS',
	"EXPAND_TO_SIZE_OF_BOTH_PLACE_RESPECT_NEXT": 'EXPAND_TO_SIZE_OF_BOTH_PLACE_RESPECT_NEXT',

	"NOT_APPLICABLE": 'NOT_APPLICABLE'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eSingleCellState"] = {
	"EXPANDED": 'EXPANDED',
	"COLLAPSED": 'COLLAPSED'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eCellPairStates"] = {
	"EXPANDED_AND_EXPANDED": 'EXPANDED_AND_EXPANDED',
	"COLLAPSED_AND_COLLAPSED": 'COLLAPSED_AND_COLLAPSED',
	"EXPANDED_AND_COLLAPSED": 'EXPANDED_AND_COLLAPSED',
	"COLLAPSED_AND_EXPANDED": 'COLLAPSED_AND_EXPANDED',
	"NOT_APPLICABLE": 'NOT_APPLICABLE'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eShiftType"] = {
	"STEP_TO_NEXT": 'STEP_TO_NEXT',
	"STEP_TO_PREVIOUS": 'STEP_TO_PREVIOUS',
	"MOVE_TO_START": 'MOVE_TO_START',
	"MOVE_TO_END": 'MOVE_TO_END'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eCellActionType"] = {
	"COLLAPSE": 'COLLAPSE',
	"EXPAND": 'EXPAND'
};

/**
 * All element types of the splitter
 * @private
 */
UCF_SplitterBase["prototype"]["eGridType"] = {
	"ROWSASH": 'ROWSASH',
	"COLSASH": 'COLSASH',
	"CELL": 'CELL'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eSizeMode"] = {
	"RELATIVE": 'RELATIVE',
	"ABSOLUTE": 'ABSOLUTE',
	"HORIZONTAL": 'sHeightSizeModeOfRows',
	"VERTICAL": 'sWidthSizeModeOfColums'
};

/**
 * All element types of the splitter
 * @private
 */
UCF_SplitterBase["prototype"]["eDragSession"] = {
	"QUIET": 'QUIET',
	"INITIALIZED": 'INITIALIZED',
	"ONGOING": 'ONGOING',
	"FINISHED": 'FINISHED'
};

/**
 * All sash types of the splitter
 * @private
 */
UCF_SplitterBase["prototype"]["eSashType"] = {
	"TOGGLE_AND_RESIZE":'TOGGLE_AND_RESIZE',
	"RESIZE": 'RESIZE',
	"INVISIBLE": 'INVISIBLE',
	"FIX": 'FIX',
	"NONE": 'NONE'
};

/**
 * The orientation of the drag process
 * @private
 */
UCF_SplitterBase["prototype"]["eDragOrientation"] = {
	"HORIZONTAL": 'HORIZONTAL',
	"VERTICAL": 'VERTICAL',
	"NONE": 'NONE'
};

/**
 * The different access types must not interfere with each other
 * @private
 */
UCF_SplitterBase["prototype"]["eAccessType"] = {
	"NONE": 'NONE',
	"DRAGGING": 'DRAGGING',
	"DELAYEDDOUBLECLICK": 'DELAYEDDOUBLECLICK',
	"KEYBOARD": 'KEYBOARD',
	"BROWSERRESIZE": 'BROWSERRESIZE'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eUnits"] = {
	"PERCENTAGE": '%',
	"PIXEL": 'px',
	"REM": 'rem',
	"AUTO": 'auto',
	"FRACTION": 'fr'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eCellPaddings"] = {
	"UNTOUCHED": 'UNTOUCHED',
	"REMOVED": 'REMOVED',
	"ASSIGNED": 'ASSIGNED'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eEventsToFire"] = {
	"RESIZED_BY_BROWSER": 'RESIZED_BY_BROWSER',
	"RESIZED_BY_SASH": 'RESIZED_BY_SASH',
	"RESIZE": 'RESIZE',
	"MOVEEND": 'MOVEEND'
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["eCollectResizeEvents"] = {
	"START": 'START',
	"CONTINUE": 'CONTINUE',
	"STOP": 'STOP'
};

/**
 * This map stores keys and properties that are valid in the orienation
 * of the dom, which is determined by the sash ty<pe or the drag direction
 * @private
 */
UCF_SplitterBase["prototype"]["mOrientationMap"] = {
	"HORIZONTAL": {
		"cursor": '_iClientX',
		"domDimension": 'width',
		"oppositeDomDimension": 'height',
		"domDelta": 'widthDelta',
		"oppositeDomDelta": 'heightDelta',
		"domOrientation": 'left',
		"gridDimension": 'size',
		"gridElement": 'cols',
		"oppositeGridElement": 'rows',
		"preceding": 'precedingcol',
		"succeeding": 'succeedingcol',
		"oppositePreceding": 'succeedingcol',
		"oppositeSucceeding": 'precedingcol',
		"fixed": 'top',
		"paddingStart": 'paddingLeft',
		"paddingEnd": 'paddingRight',
		"startStyle": 'REMOVE_LEFT_PADDING',
		"endStyle": 'REMOVE_RIGHT_PADDING',
		"windowDimension": 'innerWidth',
		"sizeMode": 'WidthSizeModeOfColums',
		"offset": 'offsetWidth',
		"oppositeOffset": 'offsetHeight',
		"precedingCellDimension": 'precedingCellWidth',
		"succeedingCellDimension": 'succeedingCellWidth',
		"oppositePrecedingCellDimension": 'precedingCellHeight',
		"oppositeSucceedingCellDimension": 'succeedingCellHeight',
		"oppositeOrientation": 'VERTICAL',
		"expandedSize": 'iExpandedWidth'
	},
	"VERTICAL": {
		"cursor": '_iClientY',
		"domDimension": 'height',
		"oppositeDomDimension": 'width',
		"domDelta": 'heightDelta',
		"oppositeDomDelta": 'widthDelta',
		"domOrientation": 'top',
		"gridDimension": 'size',
		"gridElement": 'rows',
		"oppositeGridElement": 'cols',
		"preceding": 'precedingrow',
		"succeeding": 'succeedingrow',
		"oppositePreceding": 'succeedingrow',
		"oppositeSucceeding": 'precedingrow',
		"fixed": 'left',
		"paddingStart": 'paddingTop',
		"paddingEnd": 'paddingBottom',
		"startStyle": 'REMOVE_TOP_PADDING',
		"endStyle": 'REMOVE_BOTTOM_PADDING',
		"windowDimension": 'innerHeight',
		"sizeMode": 'HeightSizeModeOfRows',
		"offset": 'offsetHeight',
		"oppositeOffset": 'offsetWidth',
		"precedingCellDimension": 'precedingCellHeight',
		"succeedingCellDimension": 'succeedingCellHeight',
		"oppositePrecedingCellDimension": 'precedingCellWidth',
		"oppositeSucceedingCellDimension": 'succeedingCellWidth',
		"oppositeOrientation": 'HORIZONTAL',
		"expandedSize": 'iExpandedHeight'
	}
};

/**
 * PREVIOUS and NEXT mark the position of the ghost
 * @private
 */
UCF_SplitterBase["prototype"]["mCellActionMap"] = {
	"PREVIOUS": {
		"domStateDocked": 'data-statesucceeding',
		"domStateAccessed": 'data-statepreceding',
		"jsStateDocked": 'statesucceeding',
		"jsStateAccessed": 'statepreceding',

		"oppDomStateDocked": 'data-statepreceding',
		"oppDomStateAccessed": 'data-statesucceeding',
		"oppJsStateDocked": 'statepreceding',
		"oppJsStateAccessed": 'statesucceeding',

		"increased": 'succCellSizeForEvent',
		"decreased": 'precCellSizeForEvent',

		"EXPANDED": 'COLLAPSED',
		"COLLAPSED": 'EXPANDED',
		"PREVIOUS": 'NEXT',
		"NEXT": 'PREVIOUS'
	},
	"NEXT": {
		"domStateDocked": 'data-statepreceding',
		"domStateAccessed": 'data-statesucceeding',
		"jsStateDocked": 'statepreceding',
		"jsStateAccessed": 'statesucceeding',

		"oppDomStateDocked": 'data-statesucceeding',
		"oppDomStateAccessed": 'data-statepreceding',
		"oppJsStateDocked": 'statesucceeding',
		"oppJsStateAccessed": 'statepreceding',

		"increased": 'precCellSizeForEvent',
		"decreased": 'succCellSizeForEvent',

		"EXPANDED": 'COLLAPSED',
		"COLLAPSED": 'EXPANDED',
		"PREVIOUS": 'NEXT',
		"NEXT": 'PREVIOUS'
	}
};

/**
 * @private
 */
UCF_SplitterBase["prototype"]["mPaddingMethods"] = {
	"KEYBOARD": {
		"bWithinStartPaddingArea": 'bSashWithinStartPaddingArea',
		"bWithinEndPaddingArea": 'bSashWithinEndPaddingArea'
	},
	"DRAGGING": {
		"bWithinStartPaddingArea": 'bGhostWithinStartPaddingArea',
		"bWithinEndPaddingArea": 'bGhostWithinEndPaddingArea'
	}
};


/**
 * ############################################################################
 *
 * SECTION WITH HELPER METHODS THAT RETURN DATA FROM ORIENTATION MAP
 *
 * ############################################################################
 */

/**
 * return that part of the oDomOrientation map that is valid with the current
 * dom orientation
 * @private
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["oGetOrientationMap"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetOrientationMap"]++; }; 
	/** @type {enum-value} */
	var sOrientation = this["sGetOrientation"]();
	return this["mOrientationMap"][sOrientation];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetOrientationMap"] = 0; };

/**
 * the key "preseding" as stored in the oDomOrientation map in depentance of the
 * current orientation
 * @private
 * @return {string}
 */
UCF_SplitterBase["prototype"]["sGetKey_preceding_fromMap"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_preceding_fromMap"]++; }; 
	/** @type {Object} */
	var oMap = this["oGetOrientationMap"]();
	return oMap["preceding"];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_preceding_fromMap"] = 0; };


/**
 * the key "succeeding" as stored in the oDomOrientation map in depentance of the
 * current orientation
 * @private
 * @return {string}
 */
UCF_SplitterBase["prototype"]["sGetKey_succeeding_fromMap"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_succeeding_fromMap"]++; }; 
	/** @type {Object} */
	var oMap = this["oGetOrientationMap"]();
	return oMap["succeeding"];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_succeeding_fromMap"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_SplitterBase["prototype"]["sGet_domDimension_fromMap"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGet_domDimension_fromMap"]++; }; 
	/** @type {Object} */
	var oMap = this["oGetOrientationMap"]();
	return oMap["domDimension"];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGet_domDimension_fromMap"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_SplitterBase["prototype"]["sGet_expandedSizeProperty_fromMap"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGet_expandedSizeProperty_fromMap"]++; }; 
	/** @type {Object} */
	var oMap = this["oGetOrientationMap"]();
	return oMap["expandedSize"];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGet_expandedSizeProperty_fromMap"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_SplitterBase["prototype"]["sGet_oppositeDomDimention_fromMap"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGet_oppositeDomDimention_fromMap"]++; }; 
	/** @type {Object} */
	var oMap = this["oGetOrientationMap"]();
	return oMap["oppositeDomDimension"];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGet_oppositeDomDimention_fromMap"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_SplitterBase["prototype"]["sGet_domOrientation_fromMap"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGet_domOrientation_fromMap"]++; }; 
	/** @type {Object} */
	var oMap = this["oGetOrientationMap"]();
	return oMap["domOrientation"];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGet_domOrientation_fromMap"] = 0; };


/**
 * @private
 * @return {string}
 */
UCF_SplitterBase["prototype"]["sGetKey_gridPart_fromMap"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_gridPart_fromMap"]++; }; 
	/** @type {enum-value} */
	var oMap = this["oGetOrientationMap"]();
	/** @type {string} */
	var sGridPart = oMap["gridElement"];

	return sGridPart;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_gridPart_fromMap"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_SplitterBase["prototype"]["sGetKey_fixed_fromMap"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_fixed_fromMap"]++; }; 
	/** @type {Object} */
	var oMap = this["oGetOrientationMap"]();
	return oMap["fixed"];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_fixed_fromMap"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_SplitterBase["prototype"]["sGetKey_paddingStart_fromMap"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_paddingStart_fromMap"]++; }; 
	/** @type {Object} */
	var oMap = this["oGetOrientationMap"]();
	return oMap["paddingStart"];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_paddingStart_fromMap"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_SplitterBase["prototype"]["sGetKey_paddingEnd_fromMap"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_paddingEnd_fromMap"]++; }; 
	/** @type {Object} */
	var oMap = this["oGetOrientationMap"]();
	return oMap["paddingEnd"];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetKey_paddingEnd_fromMap"] = 0; };

/**
 * ############################################################################
 * Neighbours and their handling after any action
 * ############################################################################
 */

UCF_SplitterBase["prototype"]["oGetSqueezed"] = function(oSash) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetSqueezed"]++; }; 
	/** @type {Object} */
	var oSqueezed;
	/** @type { enum-list }*/
	var eNeighbour;

	if (oSash) {
		oSqueezed = oSash;
		eNeighbour = this["eNeighbourhood"];

		oSqueezed["toggledirection"] = oSash["toggledirection"];
		oSqueezed["dockedto"] = eNeighbour["BOTH"];
		oSqueezed["cellsowned"] = eNeighbour["NONE"];
		if (oSash["toggledirection"] === eNeighbour["NEXT"] ||
				oSash["toggledirection"] === eNeighbour["ONLY_NEXT_AVAILABLE"]) {
					oSqueezed["returntosizeof"] = eNeighbour["ONLY_PREVIOUS_AVAILABLE"];
		}
		else if (
			oSash["toggledirection"] === eNeighbour["PREVIOUS"] ||
			oSash["toggledirection"] === eNeighbour["ONLY_PREVIOUS_AVAILABLE"]
		) {
			oSqueezed["returntosizeof"] = eNeighbour["ONLY_NEXT_AVAILABLE"];
		}

	} else {
		oSqueezed = null;
	}
	return oSqueezed;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetSqueezed"] = 0; };

/**
 * @private
 * @param {Object} oData
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["oGetNeighbours_atNewDimensions"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetNeighbours_atNewDimensions"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oFreed = oData["freed"];
	/** @type {Object} */
	var oAccessed = oData["accessed"];
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];
	/** @type { enum-list }*/
	var eSashType = this["eSashType"];
	/** @type { enum-list }*/
	var eCellPairStates = this["eCellPairStates"];
	/** @type {enum-value} */
	var sCellPairStates;
	/** @type {boolean}*/
	var bIsLast;
	/** @type {boolean}*/
	var bIsFirst;

	/**
	 * FREED
	 * SIZE TO RETURN TO
	 */
	if (oFreed && oFreed["sashtype"] === eSashType["TOGGLE_AND_RESIZE"]) {
		bIsLast = this["bIsLastSash"](oFreed["id"]);
		bIsFirst = this["bIsFirstSash"](oFreed["id"]);
		sCellPairStates = this["sGetAdjucentCellStatesAfterAction"](oFreed);

		if (sCellPairStates === eCellPairStates["EXPANDED_AND_COLLAPSED"]) {
			oFreed["returntosizeof"] = eNeighbour["ONLY_PREVIOUS_AVAILABLE"];
			oFreed["toggledirection"] = eNeighbour["PREVIOUS"];
			oFreed["cellsowned"] = eNeighbour["PREVIOUS"];
			oFreed["dockedto"] = (bIsLast) ? eNeighbour["NONE"] : eNeighbour["PREVIOUS"];
		}
		else if (sCellPairStates === eCellPairStates["COLLAPSED_AND_EXPANDED"]) {
			oFreed["returntosizeof"] = eNeighbour["ONLY_NEXT_AVAILABLE"];
			oFreed["toggledirection"] = eNeighbour["NEXT"];
			oFreed["cellsowned"] = eNeighbour["NEXT"];
			oFreed["dockedto"] = (bIsFirst) ? eNeighbour["NONE"] : eNeighbour["PREVIOUS"];
		}
		else if (sCellPairStates === eCellPairStates["EXPANDED_AND_EXPANDED"]) {
			oFreed["returntosizeof"] = oFreed["toggledirection"];
			oFreed["toggledirection"] = oFreed["toggledirection"];
			oFreed["cellsowned"] = eNeighbour["BOTH"];
			oFreed["dockedto"] = eNeighbour["NONE"];
		}
		else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(
				ERROR,
				'sCellPairStates: ' + sCellPairStates, "SplitterBase.js(755): oGetNeighbours_atNewDimensions"
			); };
		}
	}

	/**
	 * ACCESSED
	 * SIZE To RETURN TO
	 */
	if (oAccessed && oAccessed["sashtype"] === eSashType["TOGGLE_AND_RESIZE"]) {
		bIsFirst = this["bIsFirstSash"](oAccessed["id"]);
		bIsLast = this["bIsLastSash"](oAccessed["id"]);
		oAccessed["dockedto"] = eNeighbour["NONE"];
		oAccessed["cellsowned"] = eNeighbour["BOTH"];

		if (bIsLast && !bIsFirst) {
			oAccessed["returntosizeof"] = eNeighbour["NEXT"];
		} else if (bIsFirst && !bIsLast) {
			oAccessed["returntosizeof"] = eNeighbour["PREVIOUS"];
		} else {
			oAccessed["returntosizeof"] = this["sGetInitialToggleDirection"]();
		}
		oAccessed["toggledirection"] = oAccessed["returntosizeof"];
	}

	oResult["accessed"] = oAccessed;
	oResult["docked"] = null;
	oResult["freed"] = oFreed;
	oResult["squeezed"] = this["oGetSqueezed"](oData["squeezed"]);

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetNeighbours_atNewDimensions"] = 0; };

/**
 * @private
 * @param {Object} oData
 * @return { Object }
 */
UCF_SplitterBase["prototype"]["oGetNeighbours_atNewExpandPosition"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetNeighbours_atNewExpandPosition"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oAccessed = oData["accessed"];
	/** @type {Object} */
	var oDocked = oData["docked"];
	/** @type {Object} */
	var oFreed = oData["freed"];
	/** @type {Object} */
	var oSqueezed = oData["squeezed"];
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];
	/** @type { enum-list }*/
	var eCellPairStates = this["eCellPairStates"];
	/** @type { enum-list }*/
	var eSashType = this["eSashType"];
	/** @type {enum-value}*/
	var sCellPairStates;
	/** @type {boolean}*/
	var bIsFirst;
	/** @type {boolean}*/
	var bIsLast;
		/**
		 * DOCKED
		 * SIZE TO RETURN TO
		 */
	if (oDocked && oDocked["sashtype"] === eSashType["TOGGLE_AND_RESIZE"]) {
		if (oDocked["position"] === eNeighbour["PREVIOUS"]) {
			oDocked["dockedto"] = eNeighbour["NEXT"];
			oDocked["returntosizeof"] = eNeighbour["ONLY_PREVIOUS_AVAILABLE"];
			oDocked["toggledirection"] = eNeighbour["PREVIOUS"];
			oDocked["cellsowned"] = eNeighbour["PREVIOUS"];
		}
		else if (oDocked["position"] === eNeighbour["NEXT"]) {
			oDocked["dockedto"] = eNeighbour["PREVIOUS"];
			oDocked["returntosizeof"] = eNeighbour["ONLY_NEXT_AVAILABLE"];
			oDocked["toggledirection"] = eNeighbour["NEXT"];
			oDocked["cellsowned"] = eNeighbour["NEXT"];
		}
	}

	/** FREED */
	if (oFreed && oFreed["sashtype"] === eSashType["TOGGLE_AND_RESIZE"]) {
		sCellPairStates = this["sGetAdjucentCellStatesAfterAction"](oFreed);
		bIsFirst = this["bIsFirstSash"](oFreed["id"]);
		bIsLast = this["bIsLastSash"](oFreed["id"]);

		if (sCellPairStates === eCellPairStates["EXPANDED_AND_COLLAPSED"]) {
			oFreed["returntosizeof"] = eNeighbour["ONLY_PREVIOUS_AVAILABLE"];
			oFreed["toggledirection"] = eNeighbour["PREVIOUS"];
			oFreed["dockedto"] = (bIsLast) ? eNeighbour["NONE"] : eNeighbour["NEXT"];
			oFreed["cellsowned"] = eNeighbour["PREVIOUS"];
		}
		else if (sCellPairStates === eCellPairStates["COLLAPSED_AND_EXPANDED"]) {
			oFreed["returntosizeof"] = eNeighbour["ONLY_NEXT_AVAILABLE"];
			oFreed["toggledirection"] = eNeighbour["NEXT"];
			oFreed["dockedto"] = (bIsFirst) ? eNeighbour["NONE"] : eNeighbour["PREVIOUS"];
			oFreed["cellsowned"] = eNeighbour["NEXT"];
		}
		else if (sCellPairStates === eCellPairStates["EXPANDED_AND_EXPANDED"]) {
			if (oFreed["returntosizeof"] === eNeighbour["ONLY_NEXT_AVAILABLE"]) {
				oFreed["returntosizeof"] = eNeighbour["NEXT"];
				oFreed["toggledirection"] = eNeighbour["NEXT"];
				oFreed["dockedto"] = eNeighbour["NONE"];
				oFreed["cellsowned"] = eNeighbour["BOTH"];
			}
			else if (oFreed["returntosizeof"] === eNeighbour["ONLY_PREVIOUS_AVAILABLE"]) {
				oFreed["returntosizeof"] = eNeighbour["PREVIOUS"];
				oFreed["toggledirection"] = eNeighbour["PREVIOUS"];
			}
			else if (oFreed["returntosizeof"] === eNeighbour["BOTH"]) {
				oFreed["returntosizeof"] = oFreed["toggledirection"];
				oFreed["toggledirection"] = oFreed["toggledirection"];
			}
			else {
				if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'oFreed.returntosizeof: ' + oFreed["returntosizeof"], "SplitterBase.js(871): oGetNeighbours_atNewExpandPosition"); };
			}
		}
		else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'sCellPairStates: ' + sCellPairStates, "SplitterBase.js(875): oGetNeighbours_atNewExpandPosition"); };
		}
	}

	/**
	 * ACCESSED
	 */
	if (oAccessed && oAccessed["sashtype"] === eSashType["TOGGLE_AND_RESIZE"]) {

			sCellPairStates = this["sGetAdjucentCellStatesAfterAction"](oAccessed);
			oAccessed["cellsowned"] = eNeighbour["BOTH"];

			if (sCellPairStates === eCellPairStates["EXPANDED_AND_COLLAPSED"]) {
				oAccessed["toggledirection"] = eNeighbour["PREVIOUS"];
				oAccessed["returntosizeof"] = eNeighbour["BOTH"];
			}
			else if (sCellPairStates === eCellPairStates["COLLAPSED_AND_EXPANDED"]) {
				oAccessed["toggledirection"] = eNeighbour["NEXT"];
				oAccessed["returntosizeof"] = eNeighbour["BOTH"];
			}

		if (oSqueezed) {
			oAccessed["dockedto"] = oSqueezed["position"];
		}
		else if (oDocked) {
			oAccessed["dockedto"] = oDocked["position"];
		}
		else {
			oAccessed["dockedto"] = eNeighbour["NONE"];
		}
	}

	oResult["accessed"] = oAccessed;
	oResult["docked"] = oDocked;
	oResult["freed"] = oFreed;
	oResult["squeezed"] = this["oGetSqueezed"](oData["squeezed"]);

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetNeighbours_atNewExpandPosition"] = 0; };

/**
 * This function determines all neighbours for all sashes that are included in
 * a user interaction where the sash is at its minimal toggle position.
 *
 * @private
 * @param {Object} oData
 * @return { Object }
 */
UCF_SplitterBase["prototype"]["oGetNeighbours_atOwnToggleMin"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetNeighbours_atOwnToggleMin"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oAccessed = oData["accessed"];
	/** @type {Object} */
	var oFreed = oData["freed"];
	/** @type {Object} */
	var oDocked = oData["docked"];
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];
	/** @type {enum-list} */
	var eCellPairStates = this["eCellPairStates"];
	/** @type { enum-list }*/
	var eSashPosition = this["eSashPosition"];
	/** @type { enum-list }*/
	var eSashType = this["eSashType"];
	/** @type {enum-value} */
	var sCellPairStates;
	/** @type {enum-value} */
	var sSashPosition = oData["sashPosition"];
	/** @type {boolean}*/
	var bIsLast;
	/** @type {boolean}*/
	var bIsFirst;

	/**  NEIGHBOURS OF DOCKED*/
	if (oDocked && oDocked["sashtype"] === eSashType["TOGGLE_AND_RESIZE"]) {
		oDocked["dockedto"] = eNeighbour["NEXT"];
		oDocked["toggledirection"] = eNeighbour["PREVIOUS"];
		oDocked["cellsowned"] = eNeighbour["PREVIOUS"];
		oDocked["returntosizeof"] = eNeighbour["ONLY_PREVIOUS_AVAILABLE"];
	}

	/** NEIGHBOURS OF FREED*/
	if (oFreed && oFreed["sashtype"] === eSashType["TOGGLE_AND_RESIZE"]) {
		bIsLast = this["bIsLastSash"](oFreed["id"]);
		sCellPairStates = this["sGetAdjucentCellStatesAfterAction"](oFreed);
		if (
			sCellPairStates === eCellPairStates["EXPANDED_AND_EXPANDED"]
			) {
				oFreed["returntosizeof"] = oFreed["toggledirection"];
				oFreed["toggledirection"] = oFreed["toggledirection"];
				oFreed["cellsowned"] = eNeighbour["BOTH"];
				oFreed["dockedto"] = eNeighbour["NONE"];
		}
		else if (
			sCellPairStates === eCellPairStates["EXPANDED_AND_COLLAPSED"]
		) {
			oFreed["returntosizeof"] = eNeighbour["ONLY_PREVIOUS_AVAILABLE"];
			oFreed["toggledirection"] = eNeighbour["PREVIOUS"];
			oFreed["cellsowned"] = eNeighbour["PREVIOUS"];
			oFreed["dockedto"] = (bIsLast) ? eNeighbour["NONE"] : oFreed["dockedto"] = eNeighbour["NEXT"];
		}
	}

	/** ### NEIGHBOURS OF ACCESSED - SIZES TO RETURN TO ###
	 */
	if (oAccessed && oAccessed["sashtype"] === eSashType["TOGGLE_AND_RESIZE"]) {
		bIsFirst = this["bIsFirstSash"](oAccessed["id"]);
		oAccessed["toggledirection"] = eNeighbour["NEXT"];
		oAccessed["dockedto"] = (bIsFirst) ? eNeighbour["NONE"] : eNeighbour["PREVIOUS"];

		if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MIN_RETURN_TO_PREVIOUS"]) {
			oAccessed["returntosizeof"] = eNeighbour["PREVIOUS"];
			oAccessed["cellsowned"] = eNeighbour["BOTH"];
		}
		else if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MIN"]) {

			if (oAccessed["cellsowned"] === eNeighbour["BOTH"]) {
				oAccessed["returntosizeof"] = eNeighbour["BOTH"];
				oAccessed["cellsowned"] = eNeighbour["BOTH"];
			}
			else if (oAccessed["cellsowned"] !== eNeighbour["BOTH"]) {
				oAccessed["returntosizeof"] = eNeighbour["ONLY_PREVIOUS_AVAILABLE"];
				oAccessed["cellsowned"] = eNeighbour["PREVIOUS"];
			}
		}
	}

	oResult["accessed"] = oAccessed;
	oResult["docked"] = oDocked;
	oResult["freed"] = oFreed;
	oResult["squeezed"] = this["oGetSqueezed"](oData["squeezed"]);

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetNeighbours_atOwnToggleMin"] = 0; };

/**
 * @private
 * @param {Object} oData
 * @return { Object }
 */
UCF_SplitterBase["prototype"]["oGetNeighbours_atOwnToggleMax"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetNeighbours_atOwnToggleMax"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oAccessed = oData["accessed"];
	/** @type {Object} */
	var oFreed = oData["freed"];
	/** @type {Object} */
	var oDocked = oData["docked"];
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];
	/** @type { enum-list }*/
	var eCellPairStates = this["eCellPairStates"];
	/** @type { enum-list }*/
	var eSashType = this["eSashType"];
	/** @type { enum-list }*/
	var eSashPosition = this["eSashPosition"];
	/** @type {enum-value} */
	var sCellPairStates;
	/** @type {enum-value} */
	var sSashPosition = oData["sashPosition"];
	/** @type {boolean}*/
	var bIsFirst;
	/** @type {boolean}*/
	var bIsLast;

	/**  NEIGHBOURS OF DOCKED */
	if (oDocked && oDocked["sashtype"] === eSashType["TOGGLE_AND_RESIZE"]) {
		oDocked["dockedto"] = eNeighbour["PREVIOUS"];
		oDocked["toggledirection"] = eNeighbour["NEXT"];
		oDocked["cellsowned"] = eNeighbour["NEXT"];
		oDocked["returntosizeof"] = eNeighbour["ONLY_NEXT_AVAILABLE"];
	}

	/**
	 * NEIGHBOURS OF FREED
	 */
	if (oFreed && oFreed["sashtype"] === eSashType["TOGGLE_AND_RESIZE"]) {
		sCellPairStates = this["sGetAdjucentCellStatesAfterAction"](oFreed);
		bIsFirst = this["bIsFirstSash"](oFreed["id"]);

		if (sCellPairStates === eCellPairStates["EXPANDED_AND_EXPANDED"]) {
			oFreed["returntosizeof"] = oFreed["toggledirection"];
			oFreed["dockedto"] = eNeighbour["NONE"];
			oFreed["toggledirection"] = oFreed["toggledirection"];
			oFreed["cellsowned"] = eNeighbour["BOTH"];
		}
		else if (sCellPairStates === eCellPairStates["COLLAPSED_AND_EXPANDED"]) {
			oFreed["returntosizeof"] = eNeighbour["ONLY_NEXT_AVAILABLE"];
			oFreed["toggledirection"] = eNeighbour["NEXT"];
			oFreed["cellsowned"] = eNeighbour["NEXT"];
			oFreed["dockedto"] = (bIsFirst) ? eNeighbour["NONE"] : eNeighbour["PREVIOUS"];

		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR,
				'SashType: ' + oFreed["sashtype"] +
				'sCellPairStates: ' + sCellPairStates, "SplitterBase.js(1070): oGetNeighbours_atOwnToggleMax"
			); };
		}
	}

	/**
	 * NEIGHBOURS OF ACCESSED
	 */
	if (oAccessed && oAccessed["sashtype"] === eSashType["TOGGLE_AND_RESIZE"]) {
		bIsLast = this["bIsLastSash"](oAccessed["id"]);
		oAccessed["dockedto"] = (bIsLast) ? eNeighbour["NONE"] : eNeighbour["NEXT"];
		oAccessed["toggledirection"] = eNeighbour["PREVIOUS"];

		if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MAX_RETURN_TO_NEXT"]) {
			oAccessed["returntosizeof"] = eNeighbour["NEXT"];
		}
		else if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MAX"]) {
			oAccessed["returntosizeof"] = oAccessed["returntosizeof"];
		}
		else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR,
				'sSashPosition: ' + sSashPosition, "SplitterBase.js(1092): oGetNeighbours_atOwnToggleMax"
				); };
		}
	}

	oResult["accessed"] = oAccessed;
	oResult["docked"] = oDocked;
	oResult["freed"] = oFreed;
	oResult["squeezed"] = this["oGetSqueezed"](oData["squeezed"]);

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetNeighbours_atOwnToggleMax"] = 0; };


/**
 * @private
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["oGetNeighbourhoodStorage"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetNeighbourhoodStorage"]++; }; 
	/** @type {Object} */
	var oResult = null;
	/** @type {enum-list} */
	var eAccessType = this["eAccessType"];
	/** @type {enum-value} */
	var sAccessType = this["sAccessType"];

	if (sAccessType === eAccessType["DRAGGING"]) {
		if (this["bGhostAtAbsoluteSplitterEnd"]() ||
				this["bGhostAtRelativeSplitterEnd"]()) {
			oResult = this["oSashesAtSplitterEnd"];

		} else if (this["bGhostAtAbsoluteSplitterStart"]() ||
							this["bGhostAtRelativeSplitterStart"]()) {
			oResult = this["oSashesAtSplitterStart"];
		}
	}
	else if (sAccessType === eAccessType["DELAYEDDOUBLECLICK"]) {

	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetNeighbourhoodStorage"] = 0; };

/**
 * @private
 */
UCF_SplitterBase["prototype"]["addToNeighboudhoodStorage"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["addToNeighboudhoodStorage"]++; }; 
	/** @type {Array} */
	var args = arguments;
	/** @type {Object} */
	var oStorage = this["oGetNeighbourhoodStorage"]();
	/** @type {int} */
	var l = args["length"];
	/** @type {string} */
	var sId;
	/** @type {int} */
	var i;

	if (oStorage) {
		for (i = 0; i < l; i++) {
			if (args[i]) {
				sId = args[i]["accessedsash"];
				oStorage[sId] = true;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["addToNeighboudhoodStorage"] = 0; };

/**
 * @private
 */
UCF_SplitterBase["prototype"]["removeFromNeighboudhoodStorage"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["removeFromNeighboudhoodStorage"]++; }; 
	/** @type {Array} */
	var args = arguments;
	/** @type {Object} */
	var oStorage = this["oGetNeighbourhoodStorage"]();
	/** @type {int} */
	var l = args["length"];
	/** @type {string} */
	var sId;
	/** @type {int} */
	var i;

	if (oStorage) {
		for (i = 0; i < l; i++) {
			if (args[i]) {
				sId = args[i]["accessedsash"];
				delete oStorage[sId];
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["removeFromNeighboudhoodStorage"] = 0; };

/**
 * @private
 * @param { Object } aSashes
 */
UCF_SplitterBase["prototype"]["setNeigbourhoodForNextToggling"] = function(aSashes) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["setNeigbourhoodForNextToggling"]++; }; 
	/** @type {string} */
	var sPrevious;
	/** @type {string} */
	var sNext;
	/** @type {string} */
	var sStates;
	/** @type {int} */
	var l = aSashes["length"];
	/** @type {int} */
	var i;

	for (i = 0; i < l; i++) {
		if (aSashes[i]) {
			sStates = this["sGetAdjucentCellStatesAfterAction"](aSashes[i]);
			sPrevious = sStates["split"]('_AND_')[0];
			sNext = sStates["split"]('_AND_')[1];

			this["setPrecedingState"](aSashes[i], sPrevious);
			this["setSucceedingState"](aSashes[i], sNext);
			this["setSizeToReturnTo"](aSashes[i], aSashes[i]["returntosizeof"]);
			this["setDocked"](aSashes[i], aSashes[i]["dockedto"]);
			this["setToggleDirection"](aSashes[i], aSashes[i]["toggledirection"]);
			this["setCellsOwned"](aSashes[i], aSashes[i]["cellsowned"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["setNeigbourhoodForNextToggling"] = 0; };

/**
 * @private
 * @param {Object} oElement
 * @param {enum-value} sValue
 */
UCF_SplitterBase["prototype"]["setCellsOwned"] = function(oElement, sValue) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["setCellsOwned"]++; }; 
	oElement["cellsowned"] = sValue;
	oElement["oDomRef"]["setAttribute"]('data-cellsowned', sValue);
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["setCellsOwned"] = 0; };


/**
 * @private
 * @param {Object} oElement
 * @param {enum-value} sValue
 */
UCF_SplitterBase["prototype"]["setDocked"] = function(oElement, sValue) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["setDocked"]++; }; 
	oElement["dockedto"] = sValue;
	oElement["oDomRef"]["setAttribute"]('data-dockedto', sValue);
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["setDocked"] = 0; };

/**
 * @private
 * @param {Object} oSash
 * @param {enum-value} sValue
 */
UCF_SplitterBase["prototype"]["setSizeToReturnTo"] = function(oSash, sValue) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["setSizeToReturnTo"]++; }; 
	oSash["returntosizeof"] = sValue;
	oSash["oDomRef"]["setAttribute"]('data-returntosizeof', sValue);
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["setSizeToReturnTo"] = 0; };

/**
 * @private
 * @return {enum-value}
 */
UCF_SplitterBase["prototype"]["sGetOrientation"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetOrientation"]++; }; 
	/** @type {enum-value} */
	var sOrientation;
	/** @type {enum-list} */
	var eDragOrientation;
	/** @type {enum-value} */
	var sGridType;
	/** @type {enum-list} */
	var eGridType;

	eDragOrientation = this["eDragOrientation"];
	sGridType = this["sGetGridType"](this["oSash"]);
	eGridType = this["eGridType"];

	switch (sGridType) {
		case eGridType["ROWSASH"]:
			sOrientation = eDragOrientation["VERTICAL"];
			break;
		case eGridType["COLSASH"]:
			sOrientation = eDragOrientation["HORIZONTAL"];
			break;
		default:
			sOrientation = eDragOrientation["NONE"];
	}
	return sOrientation;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["sGetOrientation"] = 0; };

/**
 * ############################################################################
 *
 * SECTION WITH HELPER METHODS FOR SPLITTER AND ITS SIZES
 *
 * ############################################################################
 */
/**
 * returns the rectangle of a splitter. Either the one stored in this.oSashrect or,
 * if the variable is null, it creates it and returns it
 * @private
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["oGetSplitterRect"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetSplitterRect"]++; }; 
	/** @type {Object} */
	var oSplitterRect = this["oSplitterRect"];

	if (oSplitterRect) {
		// _trace(INFO, '-----------------oGetSplitterRect---------------------');
		// _trace(WARNING, 'oSplitterRect: ' + oSplitterRect.toString);
		return this["oSplitterRect"];

	} else {
		this["updateSplitterRect"]();
		return this["oSplitterRect"];
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetSplitterRect"] = 0; };

/**
 * @private
 */
UCF_SplitterBase["prototype"]["updateSplitterRect"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["updateSplitterRect"]++; }; 
	this["oSplitterRect"] = this["oGetClientRect"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["updateSplitterRect"] = 0; };

/**
 * Returns the inline-style block of the splitter
 * @private
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["oGetSplitterStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetSplitterStyles"]++; }; 
	/** @type {Object} */
	var oStyles = UCF_DomUtil["$"](this["sId"] + '-rootCss');

	if (oStyles) {
		return oStyles;
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No splitter-styles found', "SplitterBase.js(1327): oGetSplitterStyles"); };
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetSplitterStyles"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["iGetAbsoluteSplitterSizeInPixel"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetAbsoluteSplitterSizeInPixel"]++; }; 
	/** @type {string} */
	var sDimension = this["sGet_domDimension_fromMap"]();
	/** @type {Object} */
	var oRect = this["oGetSplitterRect"]();

	return oRect[sDimension];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetAbsoluteSplitterSizeInPixel"] = 0; };

/**
 * @private
 * @return {int}
 */
UCF_SplitterBase["prototype"]["iGetRelativeSplitterSizeInPixel"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetRelativeSplitterSizeInPixel"]++; }; 
	/** @type {string} */
	var sDimension = this["sGet_domDimension_fromMap"]();

	return this["oRelativeSplitterSize"][sDimension];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetRelativeSplitterSizeInPixel"] = 0; };

/**
 * @private
 * @return {int}
 */
UCF_SplitterBase["prototype"]["iGetRelativeSplitterSizeInPercent"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetRelativeSplitterSizeInPercent"]++; }; 
	/** @type {string} */
	var iResult;
	/** @type {string} */
	var iSplitterSize = this["iGetAbsoluteSplitterSizeInPixel"]();
	/** @type {int} */
	var iSashNumber = this["iGetNumberOfSashes"]();
	/** @type {int} */
	var iSashSize = this["iGetSashSize"]();
	/** @type {int} */
	var iSashes = iSashSize * iSashNumber;

	iResult = iSplitterSize - iSashes;
	iResult = this["iGetPercentFromPixel"](iResult);

	return iResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetRelativeSplitterSizeInPercent"] = 0; };


/**
 * @private
 * @return {int}
 */
UCF_SplitterBase["prototype"]["iGetStoredSplitterSize"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetStoredSplitterSize"]++; }; 
	/** @type {Object} */
	var oStoredSizes = this["oStoredSplitterSizes"];
	/** @type {string} */
	var sDimension = this["sGet_domDimension_fromMap"]();

	return oStoredSizes[sDimension];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetStoredSplitterSize"] = 0; };

/**
 * @private
 */
UCF_SplitterBase["prototype"]["updateStoredSplitterSizes"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["updateStoredSplitterSizes"]++; }; 
	/** @type {Object} */
	var oSplitterRect = this["oGetSplitterRect"]();
	/** @type {int} */
	var iSashNumber = this["iGetNumberOfSashes"]();
	/** @type {int} */
	var iSashSize = this["iGetSashSize"]();
	/** @type {int} */
	var iSashes = iSashNumber * iSashSize;

	this["oRelativeSplitterSize"]["height"] = oSplitterRect["height"] - iSashes;
	this["oRelativeSplitterSize"]["width"] = oSplitterRect["width"] - iSashes;
	this["oStoredSplitterSizes"]["height"] = oSplitterRect["height"];
	this["oStoredSplitterSizes"]["width"] = oSplitterRect["width"];
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["updateStoredSplitterSizes"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterBase["prototype"]["bSplitterIsDragType"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["bSplitterIsDragType"]++; }; 
	/** @type {Object} */
	var oDomRef = this["oDomRef"];
	/** @type {boolean} */
	var bPureDragType = oDomRef["getAttribute"]('data-puredragtype');

	return bPureDragType === 'true';
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["bSplitterIsDragType"] = 0; };

/**
 * ############################################################################
 *
 * SECTION WITH HELPER METHODS THAT RETURN CALCULATION RESULTS
 *
 * ############################################################################
 */

/**
 * @private
 * @param {HTML_Element} oDomRef
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["oGetClientRect"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetClientRect"]++; }; 
	/** @type {Object} */
	// var oResult = {};
	/** @type {string} */
	var oData = oDomRef["getBoundingClientRect"]();
	/** @type {string} */
	// var n;

	// for (n in oData) {
	// 	if (typeof oData[n] === 'number') {
	// 		oResult[n] = Math.ceil(oData[n]);
	// 	}
	// }
	// return oResult;
	return oData;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetClientRect"] = 0; };

/**
 * @private
 * @param {int} iSize
 * @return {int}
 */
UCF_SplitterBase["prototype"]["iGetPercentFromPixel"] = function(iSize) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetPercentFromPixel"]++; }; 
	/** @type {int} */
	var iSplitterSize = this["iGetAbsoluteSplitterSizeInPixel"]();
	/** @type {int} */
	var iPercent;

	iPercent = iSize * 100 / iSplitterSize;
	//iPercent = Math.ceil(iPercent);

	return iPercent;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetPercentFromPixel"] = 0; };

/**
 * @private
 * @param {Object} oData
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["oGetPercentFromPixel"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetPercentFromPixel"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {int} */
	var oSplitterRect = this["oGetSplitterRect"]();

	oResult["height"] = oData["height"] * 100 / oSplitterRect["height"];
	oResult["width"] = oData["width"] * 100 / oSplitterRect["width"];
	//iPercent = Math.ceil(iPercent);

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetPercentFromPixel"] = 0; };


/**
 * @private
 * @param {int} iSize
 * @return {int}
 */
UCF_SplitterBase["prototype"]["iGetPixelFromPercent"] = function(iSize) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetPixelFromPercent"]++; }; 
	/** @type {int} */
	var iSplitterSize = this["iGetAbsoluteSplitterSizeInPixel"]();
	/** @type {int} */
	var iPixel;

	iPixel = iSize * iSplitterSize / 100;
	//iPixel = Math.ceil(iPixel);

	return iPixel;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iGetPixelFromPercent"] = 0; };


/**
 * @private
 * @param {Object} oGridPart
 * @param {HTML_Element} oCell
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["calcPixelsForCell"] = function(oGridPart, oCell) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["calcPixelsForCell"]++; }; 
	/** @type {Object} */
	var oRect = this["oGetClientRect"](oCell);
	/** @type {string} */
	var sDomDimension = this["sGet_domDimension_fromMap"]();
	/** @type {int} */
	var iSize = oRect[sDomDimension];

	oGridPart["sizeinpixel"] = iSize;
	oGridPart["expandedsizeinpixel"] = iSize;

	return oGridPart;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["calcPixelsForCell"] = 0; };

/**
 * @private
 * @param {Object} oGridPart
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["calcPercentageForCell"] = function(oGridPart) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["calcPercentageForCell"]++; }; 
	/** @type {int} */
	var iPixel = oGridPart["sizeinpixel"];
	/** @type {int} */
	var iPercent = this["iGetPercentFromPixel"](iPixel);

	oGridPart["sizeinpercent"] = iPercent;
	oGridPart["expandedsizeinpercent"] = iPercent;
	return oGridPart;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["calcPercentageForCell"] = 0; };


/**
 * @private
 * @return {int}
 * @param {int} iNumberToRound
 */
UCF_SplitterBase["prototype"]["iRoundNumber"] = function(iNumberToRound) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iRoundNumber"]++; }; 
	/** @type {int} */
	var iRound = Math["ceil"](iNumberToRound);
	/** @type {int} */
	var iResult = iNumberToRound - iRound;

	if (iResult < iNumberToRound) {
		iRound = Math["floor"](iNumberToRound);
		iResult = iNumberToRound - iRound;
	}

	if (iResult >= 0.5) {
		iRound = Math["ceil"](iNumberToRound);

	} else {
		iRound = Math["floor"](iNumberToRound);
	}

	return iRound;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iRoundNumber"] = 0; };


/**
 * @private
 * @param {int} iValue
 * @return {int}
 */
UCF_SplitterBase["prototype"]["iCalcRelativeValue"] = function(iValue) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iCalcRelativeValue"]++; }; 
	/** @type {Object} */
	var oSplitterRect = this["oGetSplitterRect"]();
	/** @type {Object} */
	var oOrientation = this["oGetOrientationMap"]();
	/** @type {string} */
	var sOrientation = oOrientation["domOrientation"];
	/** @type {int} */
	var iSplitterOffset = oSplitterRect[sOrientation];

	return iValue - iSplitterOffset;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["iCalcRelativeValue"] = 0; };


/**
 * @private
 * @return {Object}
 * @param { HTML_Element } oDomRef
 */
UCF_SplitterBase["prototype"]["oGetDataSet"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetDataSet"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oDataSet = UCF_DomUtil["dataset"](oDomRef);
	/** @type {string} */
	var n;

	for (n in oDataSet) {
		oResult[n] = oDataSet[n];
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetDataSet"] = 0; };


/**
 * collects all data needed to calculate the resized cells
 * @private
 * @param {Object} oDelta
 * @param { Object } oElements
 * @param { Object } oSizeAndUnitPairs
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SplitterBase["prototype"]["determineDataAfterMoveAction"] = function(oDelta, oElements, oSizeAndUnitPairs, oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["determineDataAfterMoveAction"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oDeltaOfDimensions = this["oAssignDeltaToDimensions"](oDelta);
	/** @type {Object} */
	var oCellCoordinates = this["oGetCellCoordinates"]();
	/** @type {Object} */
	var oIncreased = oSizeAndUnitPairs["oIncreased"];
	/** @type {Object} */
	var oDecreased = oSizeAndUnitPairs["oDecreased"];
	/** @type {Object} */
	var oCellFields = this["oGetCellActionMap"](oBrowserEvent);

	/** style data */
	oResult["elementToIncrease"] = oElements["toBeIncreased"]["id"];
	oResult["elementToDecrease"] = oElements["toBeDecreased"]["id"];
	oResult["increasedSizeForStyles"] = oIncreased["size"];
	oResult["increasedUnitForStyles"] = oIncreased["unit"];
	oResult["decreasedSizeForStyles"] = oDecreased["size"];
	oResult["decreasedUnitForStyles"] = oDecreased["unit"];

	/** update data for oGridData */
	oResult[oResult["elementToIncrease"]] = {};
	oResult[oResult["elementToDecrease"]] = {};
	oResult[oResult["elementToIncrease"]] = oIncreased;
	oResult[oResult["elementToDecrease"]] = oDecreased;

	/** event data */
	oResult["heightDelta"] = oDeltaOfDimensions["heightDelta"];
	oResult["widthDelta"] = oDeltaOfDimensions["widthDelta"];
	oResult["increasedSizeForEvent"] = oIncreased["eventData"];
	oResult["decreasedSizeForEvent"] = oDecreased["eventData"];
	oResult[oCellFields["increased"]] = oIncreased["eventData"];
	oResult[oCellFields["decreased"]] = oDecreased["eventData"];
	oResult["originalSize"] = oElements["originalSize"];
	oResult["coordIncreased"] = oCellCoordinates["increased"];
	oResult["coordDecreased"] = oCellCoordinates["decreased"];
	oResult["coordNext"] = oCellCoordinates["next"];
	oResult["coordPrevious"] = oCellCoordinates["previous"];

	this["oAfterActionData"] = oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["determineDataAfterMoveAction"] = 0; };

/**
 * @private
 * @param { Object } oDelta
 * @param { Object } oElements
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["oGetSizesAfterMoveAction"] = function(oDelta, oElements) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetSizesAfterMoveAction"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	// var oDelta = this.oGetGhostDelta();
	/** @type {Object} */
	var oToBeIncreased = oElements["toBeIncreased"];
	/** @type {Object} */
	var oToBeDecreased = oElements["toBeDecreased"];
	/** @type {int} */
	var iIncreasedSizeInPixel;
	/** @type {int} */
	var iIncreasedSizeInPercent;
	/** @type {int} */
	var iDecreasedSizeInPixel;
	/** @type {int} */
	var iDecreasedSizeInPercent;

	if (this["bIsCollapsed"](oToBeDecreased["id"])) {
		iIncreasedSizeInPixel = oDelta["pixel"];
		iIncreasedSizeInPercent = oDelta["percent"];

	} else {
		iIncreasedSizeInPixel = oToBeIncreased["sizeinpixel"] + oDelta["pixel"];
		iIncreasedSizeInPercent = oToBeIncreased["sizeinpercent"] + oDelta["percent"];
	}

	if (oToBeDecreased["sizeinpixel"] < oDelta["pixel"]) {
		oDelta["pixel"] = oToBeDecreased["sizeinpixel"];
	}

	if (oToBeDecreased["sizeinpercent"] < oDelta["percent"]) {
		oDelta["percent"] = oToBeDecreased["sizeinpercent"];
	}

	iDecreasedSizeInPixel = oToBeDecreased["sizeinpixel"] - oDelta["pixel"];
	iDecreasedSizeInPercent = oToBeDecreased["sizeinpercent"] - oDelta["percent"];

	oResult["increasedPixel"] = iIncreasedSizeInPixel;
	oResult["increasedPercent"] = iIncreasedSizeInPercent;
	oResult["decreasedPixel"] = iDecreasedSizeInPixel;
	oResult["decreasedPercent"] = iDecreasedSizeInPercent;

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetSizesAfterMoveAction"] = 0; };

/**
 * @private
 * @param { Object } oSizes
 * @param { Object } oElements
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["oGetSizeAndUnitPairOfMoveAction"] = function(oSizes, oElements) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetSizeAndUnitPairOfMoveAction"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oToBeIncreased = oElements["toBeIncreased"];
	/** @type {Object} */
	var oToBeDecreased = oElements["toBeDecreased"];
	/** @type {Object} */
	var eUnits = this["eUnits"];

	oResult["oIncreased"] = {};
	oResult["oDecreased"] = {};
	oResult["oIncreased"]["sizeinpixel"] = oSizes["increasedPixel"];
	oResult["oIncreased"]["sizeinpercent"] = oSizes["increasedPercent"];
	oResult["oIncreased"]["expandedsizeinpixel"] = oSizes["increasedPixel"];
	oResult["oIncreased"]["expandedsizeinpercent"] = oSizes["increasedPercent"];
	oResult["oDecreased"]["sizeinpixel"] = oSizes["decreasedPixel"];
	oResult["oDecreased"]["sizeinpercent"] = oSizes["decreasedPercent"];

	switch (oToBeIncreased["unit"]) {
		case eUnits["PIXEL"]:
			oResult["oIncreased"]["size"] = oSizes["increasedPixel"];
			oResult["oIncreased"]["expandedsize"] = oSizes["increasedPixel"];
			oResult["oIncreased"]["unit"] = eUnits["PIXEL"];
			oResult["oIncreased"]["eventData"] = oSizes["increasedPixel"];
			break;
		case eUnits["PERCENTAGE"]:
			oResult["oIncreased"]["size"] = oSizes["increasedPercent"];
			oResult["oIncreased"]["expandedsize"] = oSizes["increasedPercent"];
			oResult["oIncreased"]["unit"] = eUnits["PERCENTAGE"];
			oResult["oIncreased"]["eventData"] = oSizes["increasedPercent"];
			break;
		case eUnits["FRACTION"]:
			oResult["oIncreased"]["size"] = 1;
			oResult["oIncreased"]["expandedsize"] = 1;
			oResult["oIncreased"]["unit"] = eUnits["FRACTION"];
			oResult["oIncreased"]["eventData"] = oSizes["increasedPercent"];
			break;
	}

	switch (oToBeDecreased["unit"]) {
		case eUnits["PIXEL"]:
			oResult["oDecreased"]["size"] = oSizes["decreasedPixel"];
			oResult["oDecreased"]["unit"] = eUnits["PIXEL"];
			oResult["oDecreased"]["eventData"] = oSizes["decreasedPixel"];
			if (oSizes["decreasedPixel"] > 0) {
				oResult["oDecreased"]["expandedsize"] = oSizes["decreasedPixel"];
			} else {
				oResult["oDecreased"]["expandedsize"] = oToBeDecreased["expandedsize"];
			}
			break;
		case eUnits["PERCENTAGE"]:
			oResult["oDecreased"]["size"] = oSizes["decreasedPercent"];
			oResult["oDecreased"]["unit"] = eUnits["PERCENTAGE"];
			oResult["oDecreased"]["eventData"] = oSizes["decreasedPercent"];
			if (oSizes["decreasedPixel"] > 0) {
				oResult["oDecreased"]["expandedsize"] = oSizes["decreasedPercent"];
			} else {
				oResult["oDecreased"]["expandedsize"] = oToBeDecreased["expandedsize"];
			}
			break;
		case eUnits["FRACTION"]:
			oResult["oDecreased"]["size"] = (oSizes["decreasedPixel"] > 0) ? 1 : 0;
			oResult["oDecreased"]["unit"] = eUnits["FRACTION"];
			oResult["oDecreased"]["expandedsize"] = 1;
			oResult["oDecreased"]["eventData"] = oSizes["decreasedPercent"];
			break;
	}

	if (oSizes["decreasedPixel"] > 0) {
		oResult["oDecreased"]["expandedsizeinpixel"] = oSizes["decreasedPixel"];
		oResult["oDecreased"]["expandedsizeinpercent"] = oSizes["decreasedPercent"];

	} else {
		oResult["oDecreased"]["expandedsizeinpixel"] = oToBeDecreased["expandedsizeinpixel"];
		oResult["oDecreased"]["expandedsizeinpercent"] = oToBeDecreased["expandedsizeinpercent"];
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oGetSizeAndUnitPairOfMoveAction"] = 0; };

/**
 * @private
 * @param { Object } oDelta
 * @return {Object}
 */
UCF_SplitterBase["prototype"]["oAssignDeltaToDimensions"] = function(oDelta) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oAssignDeltaToDimensions"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {string} */
	var sOrientation = this["sGetOrientation"]();
	/** @type {enum-list} */
	var eSizeMode = this["eSizeMode"];

	if (this["sAccessType"] !== this["BROWSERRESIZE"]) {
			if (sOrientation === this["eDragOrientation"]["HORIZONTAL"]) {
				oResult["heightDelta"] = 0;

			if (this[eSizeMode[sOrientation]] === eSizeMode["RELATIVE"]) {
				oResult["widthDelta"] = oDelta["percent"];

			} else {
				oResult["widthDelta"] = oDelta["pixel"];
			}
		} else {
				oResult["widthDelta"] = 0;

			if (this[eSizeMode[sOrientation]] === eSizeMode["RELATIVE"]) {
				oResult["heightDelta"] = oDelta["percent"];

			} else {
				oResult["heightDelta"] = oDelta["pixel"];
			}
		}
	} else {

	}


	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["oAssignDeltaToDimensions"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SplitterBase["prototype"]["updateClientAfterMoveAction"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["updateClientAfterMoveAction"]++; }; 
	/** @type { enum-value}*/
	var sSashPosition;
	/** @type {Object} */
	var oAccessedSash;
	/** @type {Object} */
	var oDockedSash;
	/** @type {Object} */
	var oFreedSash;
	/** @type {Object} */
	var oSqueezedSash;
	/** @type {Object} */
	var oData = {};
	/** @type {enum-value} */
	var sAccessType = this["sAccessType"];
	/** @type {enum-list} */
	var eAccessType = this["eAccessType"];

	if (sAccessType === eAccessType["DRAGGING"]) {
		sSashPosition = this["sGetSashPositionAfterDrag"]();
	}
	else if (sAccessType === eAccessType["KEYBOARD"]) {
		sSashPosition = this["sGetSashPositionAfterShift"](oBrowserEvent);
	}
	else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'No Sash-Position determined', "SplitterBase.js(1873): updateClientAfterMoveAction"); };
	}
	oAccessedSash = this["oGetSashData"]();
	oDockedSash = this["oGetDockedSashData"](sSashPosition);
	oFreedSash = this["oGetFreedSashData"](sSashPosition);
	oSqueezedSash = this["oGetSqueezedSashData"](sSashPosition);

	oData["sashPosition"] = sSashPosition;
	oData["accessed"] = oAccessedSash;
	oData["docked"] = oDockedSash;
	oData["freed"] = oFreedSash;
	oData["squeezed"] = oSqueezedSash;

	this["storeCollapsed"]();
	this["updateGridDimensionsInDom"]();
	this["updateGridDataAfterAnyAction"](sSashPosition);
	this["updateControlDataAfterAnyAction"]();
	this["updateNeighbourhoodAfterDrag"](oData);
	this["updateSashStylesAfterAnyAction"](oData);
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["updateClientAfterMoveAction"] = 0; };

/**
 * @private
 */
UCF_SplitterBase["prototype"]["storeCollapsed"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["storeCollapsed"]++; }; 
	/** @type { Object }*/
	var oGridData = this["oGetGridData"]();
	/** @type { Object }*/
	var oActionData = this["oGetAfterActionData"]();
	/** @type { string }*/
	var sDecreased = oActionData["elementToDecrease"];
	/** @type { string }*/
	var sCellId = oGridData[sDecreased]["associatedcells"][0];
	/** @type { Object }*/
	var oDomRef = UCF_DomUtil["$"](sCellId);
	/** @type { Object }*/
	var oCell = this["oGetClientRect"](oDomRef);

	oGridData[sDecreased]["collapsed"] = oCell[this["sGet_domDimension_fromMap"]()] < 1;
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["storeCollapsed"] = 0; };

/**
 * @private
 */
UCF_SplitterBase["prototype"]["updateControlDataAfterAnyAction"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["updateControlDataAfterAnyAction"]++; }; 
	/** @type { Object }*/
	var oActionData = this["oGetAfterActionData"]();
	/** @type { Object }*/
	var oControls = this["oGetGridDummies"]();
	/** @type {string} */
	var iExpandedSize = this["sGet_expandedSizeProperty_fromMap"]();
	/** @type {string} */
	var sDecreased = oActionData["elementToDecrease"];
	/** @type {string} */
	var sIncreased = oActionData["elementToIncrease"];

	oControls[sIncreased]["setClientProperty"](iExpandedSize, oActionData["increasedSizeForStyles"], true);
	oControls[sDecreased]["setClientProperty"](iExpandedSize, oActionData["decreasedSizeForStyles"], true);
};;if (__UCF_COVERAGE__) { UCF_SplitterBase["_"]["updateControlDataAfterAnyAction"] = 0; };

};
sap["ls"]["preload"]["UCF_SplitterCell"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * Use the SplitterCell {@link UCF_Control} to create a layout cell in the
 * {@link UCF_Splitter} control.
 *
 * 
 * @version 1.0.0.0
 *
 * @see {@link UCF_Control}
 * @see {@link UCF_Splitter}
 * @see {@link UCF_ScrollArea}
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 *
 */
function UCF_SplitterCell(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterCell["_"]["UCF_SplitterCell"]++; }; 

	if (arguments["length"] === 0) return;
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterCell.js(29): UCF_SplitterCell"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterCell.js(30): UCF_SplitterCell"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterCell.js(31): UCF_SplitterCell"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_SplitterCell"] = UCF_SplitterCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterCell"); UCF_SplitterCell["_"] = {UCF_SplitterCell: 0}; }; ;
UCF_SplitterCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_SplitterCell.prototype["sClassName"] = "UCF_SplitterCell";

/**
 * Destructor
 * @private
 */
UCF_SplitterCell["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SplitterCell["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SplitterCell["prototype"]["aAttributeNames"] = ["sScrollbars","sDefaultButtonId","iScrollTop","iScrollLeft","bAttachBrowserResize","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SplitterCell["prototype"]["aEventNames"] = ["Resize","Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SplitterCell["prototype"]["aMethodNames"] = ["iGetWidth","iGetHeight","setDefaultButtonId","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ScrollingMode}
 */
UCF_SplitterCell["prototype"]["sScrollbars"] = "AUTO";

/**
 * @private
 * @type {string}
 */
UCF_SplitterCell["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_SplitterCell["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_SplitterCell["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_SplitterCell["prototype"]["bAttachBrowserResize"] = false;

/**
 * @private
 * @type {string}
 */
UCF_SplitterCell["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_SplitterCell["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell["_"]["setDefaultValues"]++; }; 
	this["sScrollbars"] = "AUTO";
	this["sDefaultButtonId"] = '';
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["bAttachBrowserResize"] = false;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Scrollbars", "AUTO", true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("AttachBrowserResize", false, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterCell["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iWidthDelta Delta width of the resize operation
 * @param {number} iHeightDelta Delta height of the resize operation
 * @param {number} iWidth Width of the resize operation.  (Always the current size of the cell in px)
 * @param {number} iHeight Height of the resize operation.  (Always the current size of the cell in px)
 * @fires SplitterCell::Resize
 */
UCF_SplitterCell["prototype"]["fireResize"] = function(sId, iWidthDelta, iHeightDelta, iWidth, iHeight) {;if (__UCF_COVERAGE__) { UCF_SplitterCell["_"]["fireResize"]++; }; 
	/** @type {{Id: string, WidthDelta: number, HeightDelta: number, Width: number, Height: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 5, "arguments.length == 5", "SplitterCell.js(136): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SplitterCell.js(137): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SplitterCell.js(138): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iWidthDelta != null, "iWidthDelta != null", "SplitterCell.js(139): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iWidthDelta) == "number", "typeof(iWidthDelta) == \"number\"", "SplitterCell.js(140): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iHeightDelta != null, "iHeightDelta != null", "SplitterCell.js(141): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iHeightDelta) == "number", "typeof(iHeightDelta) == \"number\"", "SplitterCell.js(142): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iWidth != null, "iWidth != null", "SplitterCell.js(143): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iWidth) == "number", "typeof(iWidth) == \"number\"", "SplitterCell.js(144): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iHeight != null, "iHeight != null", "SplitterCell.js(145): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iHeight) == "number", "typeof(iHeight) == \"number\"", "SplitterCell.js(146): fireResize"); };
	mParams = {
		"Id": sId,
		"WidthDelta": iWidthDelta,
		"HeightDelta": iHeightDelta,
		"Width": iWidth,
		"Height": iHeight
	};
	
	
	
	
	
	this["fireSemanticEvent"]("SplitterCell", "Resize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SplitterCell["_"]["fireResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires SplitterCell::Scroll
 * @deprecated
 */
UCF_SplitterCell["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_SplitterCell["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "SplitterCell.js(174): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "SplitterCell.js(175): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "SplitterCell.js(176): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "SplitterCell.js(177): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "SplitterCell.js(178): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "SplitterCell.js(179): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "SplitterCell.js(180): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("SplitterCell", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_SplitterCell["_"]["fireScroll"] = 0; };

};
sap["ls"]["preload"]["UCF_SplitterCellDTExtension"] = function() {/* global UCF_DTExtension */
/// <reference path="./DTExtension.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oControl
 * @param {UCF_DTElement} oDTElement
 */
function UCF_SplitterCellDTExtension(oLS, oControl, oDTElement) {if (__UCF_COVERAGE__) { UCF_SplitterCellDTExtension["_"]["UCF_SplitterCellDTExtension"]++; }; 
	if (arguments["length"] == 0) return;
	UCF_DTExtension["apply"](this, arguments);
};window["UCF_SplitterCellDTExtension"] = UCF_SplitterCellDTExtension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterCellDTExtension"); UCF_SplitterCellDTExtension["_"] = {UCF_SplitterCellDTExtension: 0}; }; ;

UCF_SplitterCellDTExtension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTExtension"))(); UCF_SplitterCellDTExtension.prototype["sClassName"] = "UCF_SplitterCellDTExtension";

/**
 * Returns a DOM reference for the scrollable part of the control or null.
 * @return {HTMLElement}
 */
UCF_SplitterCellDTExtension["prototype"]["oGetScrollAreaDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCellDTExtension["_"]["oGetScrollAreaDomRef"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_SplitterCellDTExtension["_"]["oGetScrollAreaDomRef"] = 0; };

};
sap["ls"]["preload"]["UCF_SplitterCell_ie6"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_SplitterCell */
/// <reference path="SplitterCell.js"/>

/**
 * Use the SplitterCell {@link UCF_Control} to create a layout cell in the
 * {@link UCF_SplitterCell_ie6} control.
 *
 * 
 * @version 1.0.0.0
 *
 * @see {@link UCF_Control}
 * @see {@link UCF_Splitter}
 * @see {@link UCF_ScrollArea}
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 *
 */
function UCF_SplitterCell_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["UCF_SplitterCell_ie6"]++; }; 

	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterCell_ie6.js(37): UCF_SplitterCell_ie6"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterCell_ie6.js(38): UCF_SplitterCell_ie6"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterCell_ie6.js(39): UCF_SplitterCell_ie6"); };

		UCF_SplitterCell["apply"](this, [oDomRef, oLS]);

		var oSplitterRow = this["oGetParent"](),
			oSplitter = oSplitterRow["oGetParent"]();

		if (this["sScrollbars"] !== "NONE" && oSplitter["mEvents"]["Scroll"] /* && this.sScrollbars != "HIDE"*/) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Attach to scroll on cell " + this["sId"], "SplitterCell_ie6.js(47): UCF_SplitterCell_ie6"); };
			this["iCurrentScrollTop"] = this["iScrollTop"];
			this["iCurrentScrollLeft"] = this["iScrollLeft"];
			this["oScrollArea"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(this["oDomRef"]); // eslint-disable-line @ur/no-memory-leaks
			this["attachBrowserEvent"]("scroll", this["oDomRef"]);
			this["oScrollArea"]["attachEvent"](this["oScrollArea"]["E_EVENTS"]["Scroll"], this, "onAreaScroll");
			this["addDelegate"](this["oScrollArea"]);
		}

		//initialize the default button for this control
		this["setDefaultButtonId"](this["sDefaultButtonId"]);

		//TODO: add parameter to initialize the control at page load to
		// avoid the initialization of all cells
		if (this["bAttachBrowserResize"] && oSplitter["mEvents"]["Resize"]) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Attach to resize on cell " + this["sId"], "SplitterCell_ie6.js(62): UCF_SplitterCell_ie6"); };
			this["iWidth"] = this["oDomRef"]["offsetWidth"];
			this["iHeight"] = this["oDomRef"]["offsetHeight"];
			this["attachBrowserEvent"]("resize", this["oDomRef"]);
		}
	}
};window["UCF_SplitterCell_ie6"] = UCF_SplitterCell_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterCell_ie6"); UCF_SplitterCell_ie6["_"] = {UCF_SplitterCell_ie6: 0}; }; ;
UCF_SplitterCell_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterCell"))(); UCF_SplitterCell_ie6.prototype["sClassName"] = "UCF_SplitterCell_ie6";

/** The {UCF_ScrollArea} delegate.
 * @private
 */
UCF_SplitterCell_ie6["prototype"]["oScrollArea"] = null;

/**
 * Handles the scroll event. Only fire if necessary.
 * @see {UCF_ScrollArea}
 *
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_SplitterCell_ie6["prototype"]["onAreaScroll"] = function (oEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["onAreaScroll"]++; }; 
	var oSplitterRow = this["oGetParent"](),
		oSplitter = oSplitterRow["oGetParent"](),
		iScrollTop = oEvent["oGetParam"]("iScrollTop"),
		iScrollLeft = oEvent["oGetParam"]("iScrollLeft");

	if (this["iCurrentScrollTop"] !== iScrollTop || this["iCurrentScrollLeft"] !== iScrollLeft) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Scroll cell " + this["sId"] + " Top:" + iScrollTop + " Left:" + iScrollLeft + " DeltaTop:" + (iScrollTop - this["iCurrentScrollTop"]) + " DeltaLeft:" + (iScrollLeft - this["iCurrentScrollLeft"]), "SplitterCell_ie6.js(90): onAreaScroll"); };
		this["iCurrentScrollTop"] = iScrollTop;
		this["iCurrentScrollLeft"] = iScrollLeft;

		oSplitter["fireScroll"](oSplitter["sId"], this["sId"], iScrollTop, iScrollLeft);
		this["fireScroll"](this["sId"], iScrollTop, iScrollLeft);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No Scroll fired on cell " + this["sId"] + " Top:" + iScrollTop + " Left:" + iScrollLeft + " DeltaTop:" + (iScrollTop - this["iCurrentScrollTop"]) + " DeltaLeft:" + (iScrollLeft - this["iCurrentScrollLeft"]), "SplitterCell_ie6.js(97): onAreaScroll"); };
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["onAreaScroll"] = 0; };

/**
 * Intialize only if scroll position needs to be set
 * @private
 */
UCF_SplitterCell_ie6["prototype"]["initialize"] = function () {;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["initialize"]++; }; 

	if (this["oScrollArea"] && this["oScrollArea"] != null) {
		this["oScrollArea"]["setScrollPosition"](this["iScrollTop"], this["iScrollLeft"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["initialize"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_SplitterCell_ie6["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["destroy"]++; }; 
	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}

	if (this["bAttachBrowserResize"]) {
		this["detachBrowserEvent"]("resize", this["oDomRef"]);
	}

	UCF_JsUtil["clearDelayedCall"](this["sTimerId"]);
	this["sTimerId"] = null;

	this["iCurrentScrollTop"] = 0;
	this["iCurrentScrollLeft"] = 0;
	this["iWidth"] = 0;
	this["iHeight"] = 0;

	UCF_SplitterCell.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["destroy"] = 0; };

/**
 * Handles the onresize event of the browser. It's the resize event handler if
 * this.bAttachBrowserResize == true
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_SplitterCell_ie6["prototype"]["onresize"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["onresize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SplitterCell_ie6.js(145): onresize"); };

	if (this["sTimerId"] != null) return;

	var iWidth = this["oDomRef"]["offsetWidth"],
		iHeight = this["oDomRef"]["offsetHeight"],

		//Resize event was fired at hovering over sash so determine real delta
		iWidthDelta = iWidth - this["iWidth"],
		iHeightDelta = iHeight - this["iHeight"];

	if (iWidthDelta !== 0 || iHeightDelta !== 0) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Resize cell " + this["sId"] + " Width:" + iWidthDelta + " Height:" + iHeightDelta, "SplitterCell_ie6.js(157): onresize"); };
		var oSplitterRow = this["oGetParent"](),
			oSplitter = oSplitterRow["oGetParent"]();
		this["iWidth"] = iWidth;
		this["iHeight"] = iHeight;
		oSplitter["fireResize"](oSplitter["sId"], this["sId"], iWidthDelta, iHeightDelta, iWidth, iHeight);
		this["fireResize"](this["sId"], iWidthDelta, iHeightDelta, iWidth, iHeight);

		// Notify framework, that layout has changed after toggling the Tray
		//this.notifyLayoutChange();

		this["sTimerId"] = UCF_JsUtil["delayedCall"](100, this, "onresizeActivate");
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "No Resize fired on cell " + this["sId"] + " Width:" + iWidth + " Height:" + iHeight, "SplitterCell_ie6.js(170): onresize"); };
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["onresize"] = 0; };

/**
 * @private
 */
UCF_SplitterCell_ie6["prototype"]["onresizeActivate"] = function () {;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["onresizeActivate"]++; }; 
	UCF_JsUtil["clearDelayedCall"](this["sTimerId"]);
	this["sTimerId"] = null;
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["onresizeActivate"] = 0; };

/**
 * Returns the current width of the cell in px.
 * @public
 */
UCF_SplitterCell_ie6["prototype"]["iGetWidth"] = function () {;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["iGetWidth"]++; }; 
	/*
	var oSplitterRow = this.oGetParent(),
		oSplitter = oSplitterRow.oGetParent(),
		bFixSize = oSplitter.sMode == 'ITS' && oSplitter.sWidthSizeModeOfColums == oSplitter.E_SIZEMODE.ABSOLUTE;
	*/
	var iSize =
		/*this.oDomRef.width
			? */
		parseInt(this["oDomRef"]["offsetWidth"])
		/*
		: this.oDomRef.col
				? parseInt(UCF_DomUtil.$(this.oDomRef.col).offsetWidth)
				: null*/
		;

	return iSize;

	/* bFixSize && iSize != null
			&& UCF_DomUtil.nextSibling(UCF_DomUtil.oGetParentByTagName(this.oDomRef, "TD"), "TD") != null
			? ((iSize >= 4
				?
				(iSize + 4)
				: 0))
			: */
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["iGetWidth"] = 0; };

/**
 * Returns the height of this cell in the DOM
 * @public
 */
UCF_SplitterCell_ie6["prototype"]["iGetHeight"] = function () {;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["iGetHeight"]++; }; 
	/* var oSplitterRow = this.oGetParent(),
		oSplitter = oSplitterRow.oGetParent(),
		bFixSize = oSplitter.sMode == 'ITS' && oSplitter.sHeightSizeModeOfRows == oSplitter.E_SIZEMODE.ABSOLUTE;
	*/
	var iSize =
		/*this.oDomRef.height
			?*/
		parseInt(this["oDomRef"]["offsetHeight"])
		/*
				:  parseInt(UCF_DomUtil.oGetParentByTagName(this.oDomRef, "TD").height)
				*/
		;

	return iSize;

	/* bFixSize && iSize != null
			&& UCF_DomUtil.nextSibling(UCF_DomUtil.oGetParentByTagName(this.oDomRef, "TR"), "TR") != null
			? ((iSize >= 4
				? (iSize + 4)
				: 0))
			: */
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["iGetHeight"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 * @public
 */
UCF_SplitterCell_ie6["prototype"]["setDefaultButtonId"] = function (sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["setDefaultButtonId"]++; }; 
	UCF_SplitterCell.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["setDefaultButtonId"] = 0; };

/**
 * @private
 * @see UCF_DTExtension
 */
UCF_SplitterCell_ie6["prototype"]["oGetDTExtension"] = function (oDTElement) {;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["oGetDTExtension"]++; }; 
	return UCF_SplitterCell.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]("UCF_SplitterCellDTExtension"));
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_ie6["_"]["oGetDTExtension"] = 0; };

UCF_SplitterCell_ie6.prototype["aPublicMethods"] = ["iGetWidth","iGetHeight","setDefaultButtonId"].concat(UCF_SplitterCell_ie6.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_SplitterCell_standards"] = function() {/* global _assert, _trace, DEBUG, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_SplitterCell */
/// <reference path="SplitterCell.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>

/**
 * Use the SplitterCell {@link UCF_Control} to create a layout cell in the
 * {@link UCF_Splitter} control.
 *
 * 
 * @version 1.0.0.0
 *
 * @see {@link UCF_Control}
 * @see {@link UCF_Splitter}
 * @see {@link UCF_ScrollArea}
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 *
 */
function UCF_SplitterCell_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["UCF_SplitterCell_standards"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterCell_standards.js(40): UCF_SplitterCell_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterCell_standards.js(41): UCF_SplitterCell_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterCell_standards.js(42): UCF_SplitterCell_standards"); };

	UCF_SplitterCell["apply"](this, [oDomRef, oLS]);

	this["oSplitter"] = null;
	this["oScrollArea"] = null;
	this["sTimeOutId"] = null;

};window["UCF_SplitterCell_standards"] = UCF_SplitterCell_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterCell_standards"); UCF_SplitterCell_standards["_"] = {UCF_SplitterCell_standards: 0}; }; ;
UCF_SplitterCell_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterCell"))(); UCF_SplitterCell_standards.prototype["sClassName"] = "UCF_SplitterCell_standards";


/**
 * Destructor
 * @private
 */
UCF_SplitterCell_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["destroy"]++; }; 
	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}
	this["oSplitter"] = null;
	this["sTimeOutId"] = null;
	UCF_SplitterCell.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["destroy"] = 0; };

/**
 * puts cells in corrent scrollposition
 * @private
 */
UCF_SplitterCell_standards["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["initialize"]++; }; 
	this["loadScrollArea"]();
	this["setScrollPosition"]();
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["initialize"] = 0; };

/**
 * @private
 */
UCF_SplitterCell_standards["prototype"]["loadScrollArea"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["loadScrollArea"]++; }; 
	/** @type {UCF_ScrollArea} */
	var oScrollArea = this["oGetScrollArea"]();
	if (oScrollArea) {
		this["oScrollArea"] = oScrollArea;
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["loadScrollArea"] = 0; };

/**
 * @private
 */
UCF_SplitterCell_standards["prototype"]["setScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["setScrollPosition"]++; }; 
	/** @type {UCF_ScrollArea} */
	var oScrollArea = this["oGetScrollArea"]();

	if (this["bCanScroll"]() && oScrollArea) {
		oScrollArea["setScrollPosition"](this["iScrollTop"], this["iScrollLeft"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["setScrollPosition"] = 0; };

/**
 * @private
 */
UCF_SplitterCell_standards["prototype"]["onScroll"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["onScroll"]++; }; 
	if (this["bHasScrolled"]()) {
			if (this["sTimeOutId"] != null) {
				UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
			}
			this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterScrolling');
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["onScroll"] = 0; };

/**
 * @private
 */
UCF_SplitterCell_standards["prototype"]["onAfterScrolling"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["onAfterScrolling"]++; }; 
	/** @type {UCF_Splitter_standards} */
	var oSplitter;
	/** @type {Object} */
	var oPosition;
	/** @type {int} */
	var iTop;
	/** @type {int} */
	var iLeft;

	oSplitter = this["oGetSplitter"]();
	oPosition = this["oGetScrollPosition"]();
	iTop = oPosition["top"];
	iLeft = oPosition["left"];

	oSplitter["fireScroll"](oSplitter["sId"], this["sId"], iTop, iLeft);
	this["fireScroll"](this["sId"], iTop, iLeft);
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["onAfterScrolling"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterCell_standards["prototype"]["bCanScroll"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["bCanScroll"]++; }; 
	/** @type {Object} */
	var oPosition = this["oGetScrollPosition"]();

	return (this["iScrollTop"] !== oPosition["top"] ||
		this["iScrollLeft"] !== oPosition["left"]);
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["bCanScroll"] = 0; };

/**
 * @private
 * @return { boolean }
 */
UCF_SplitterCell_standards["prototype"]["bHasScrolled"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["bHasScrolled"]++; }; 
	/** @type {Object} */
	var oPosition = this["oGetScrollPosition"]();
	/** @type {boolean} */
	var bHasScrolled = this["iScrollTop_"] !== oPosition["top"] ||
										this["iScrollLeft_"] !== oPosition["left"];

		return bHasScrolled;
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["bHasScrolled"] = 0; };

/**
 * @private
 * @return {UCF_Splitter}
 */
UCF_SplitterCell_standards["prototype"]["oGetSplitter"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["oGetSplitter"]++; }; 
	/** @type {UCF_SplitterCell_standards} */
	var oSplitter;

	if (!this["oSplitter"]) {
		oSplitter = this["oGetParent"]();

		if (UCF_JsUtil["bInstanceOf"](oSplitter, 'UCF_Splitter_standards')) {
			this["oSplitter"] = oSplitter;
			return oSplitter;
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'SplitterCell could not find parent control splitter', "SplitterCell_standards.js(175): oGetSplitter"); };
		}
	} else {
		return this["oSplitter"];
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["oGetSplitter"] = 0; };

/**
 * @private
 * @return {UCF_ScrollArea}
 */
UCF_SplitterCell_standards["prototype"]["oGetScrollArea"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["oGetScrollArea"]++; }; 
		/** @type {UCF_ScrollArea} */
		var oScrollArea;
		/** @type {HTML_Element} */
		var oDomRef;

		if (!this["oScrollArea"]) {
			oDomRef = UCF_DomUtil["$"](this["sId"] + '-scrl');
			oScrollArea = UCF_ClassLoader["oGetClass"]('UCF_ScrollArea');
			oScrollArea = oScrollArea["oCreateAndConnectScrollArea"](this, 'auto', 'onScroll', oDomRef);
			if (oScrollArea) {
				this["oGetParent"]()["addDelegate"](oScrollArea);
				return oScrollArea;
			} else {
				if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'SplitterCell could not load ScrollArea', "SplitterCell_standards.js(200): oGetScrollArea"); };
			}
		} else {
			return this["oScrollArea"];
		}
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["oGetScrollArea"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_SplitterCell_standards["prototype"]["oGetScrollPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["oGetScrollPosition"]++; }; 
		/** @type {UCF_ScrollArea} */
		var oScrollArea = this["oGetScrollArea"]();
		/** @type {Object} */
		var oPosition;

		if (oScrollArea) {
			oPosition = this["oScrollArea"]["oGetScrollPosition"]();
			if (oPosition) {
				return oPosition;
			} else {
				if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Could not retrieve position values', "SplitterCell_standards.js(222): oGetScrollPosition"); };
			}
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Could not find oScrollArea', "SplitterCell_standards.js(225): oGetScrollPosition"); };
		}
};;if (__UCF_COVERAGE__) { UCF_SplitterCell_standards["_"]["oGetScrollPosition"] = 0; };

};
sap["ls"]["preload"]["UCF_SplitterCol"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * Use the Splitter column {@link UCF_Control} to define a layout col in the
 * {@link UCF_Splitter} control.
 *
 * 
 * @version 1.0.0.0
 *
 * @see UCF_Control
 * @see UCF_Splitter
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SplitterCol(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterCol["_"]["UCF_SplitterCol"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterCol.js(24): UCF_SplitterCol"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterCol.js(25): UCF_SplitterCol"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterCol.js(26): UCF_SplitterCol"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);
	}
};window["UCF_SplitterCol"] = UCF_SplitterCol; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterCol"); UCF_SplitterCol["_"] = {UCF_SplitterCol: 0}; }; ;
UCF_SplitterCol["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_SplitterCol.prototype["sClassName"] = "UCF_SplitterCol";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SplitterCol["prototype"]["aAttributeNames"] = ["iWidth","sSashType","sCollapseDirection","iExpandedWidth","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SplitterCol["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SplitterCol["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_SplitterCol["prototype"]["iWidth"] = -1;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterSashType}
 */
UCF_SplitterCol["prototype"]["sSashType"] = "RESIZABLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterCollapseDirection}
 */
UCF_SplitterCol["prototype"]["sCollapseDirection"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_SplitterCol["prototype"]["iExpandedWidth"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_SplitterCol["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_SplitterCol["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCol["_"]["setDefaultValues"]++; }; 
	this["iWidth"] = -1;
	this["sSashType"] = "RESIZABLE";
	this["sCollapseDirection"] = "NONE";
	this["iExpandedWidth"] = 0;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Width", -1, true);
		this["setClientProperty"]("SashType", "RESIZABLE", true);
		this["setClientProperty"]("CollapseDirection", "NONE", true);
		this["setClientProperty"]("ExpandedWidth", 0, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterCol["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_SplitterCol_ie6"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_SplitterCol */
/// <reference path="SplitterCol.js"/>

/**
 * Use the Splitter column {@link UCF_Control} to define a layout col in the
 * {@link UCF_Splitter} control.
 *
 * 
 * @version 1.0.0.0
 *
 * @see UCF_Control
 * @see UCF_Splitter
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SplitterCol_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterCol_ie6["_"]["UCF_SplitterCol_ie6"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterCol_ie6.js(26): UCF_SplitterCol_ie6"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterCol_ie6.js(27): UCF_SplitterCol_ie6"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterCol_ie6.js(28): UCF_SplitterCol_ie6"); };

		UCF_SplitterCol["apply"](this, [oDomRef, oLS]);
	}
};window["UCF_SplitterCol_ie6"] = UCF_SplitterCol_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterCol_ie6"); UCF_SplitterCol_ie6["_"] = {UCF_SplitterCol_ie6: 0}; }; ;
UCF_SplitterCol_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterCol"))(); UCF_SplitterCol_ie6.prototype["sClassName"] = "UCF_SplitterCol_ie6";

};
sap["ls"]["preload"]["UCF_SplitterCol_standards"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_SplitterCol */
/// <reference path="SplitterCol.js"/>

/**
 * Use the Splitter column {@link UCF_Control} to define a layout col in the
 * {@link UCF_Splitter} control.
 *
 * 
 * @version 1.0.0.0
 *
 * @see UCF_Control
 * @see UCF_Splitter
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SplitterCol_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterCol_standards["_"]["UCF_SplitterCol_standards"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterCol_standards.js(26): UCF_SplitterCol_standards"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterCol_standards.js(27): UCF_SplitterCol_standards"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterCol_standards.js(28): UCF_SplitterCol_standards"); };

		UCF_SplitterCol["apply"](this, [oDomRef, oLS]);
	}
};window["UCF_SplitterCol_standards"] = UCF_SplitterCol_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterCol_standards"); UCF_SplitterCol_standards["_"] = {UCF_SplitterCol_standards: 0}; }; ;
UCF_SplitterCol_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterCol"))(); UCF_SplitterCol_standards.prototype["sClassName"] = "UCF_SplitterCol_standards";

/**
 * Destructor
 * @private
 */
UCF_SplitterCol_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterCol_standards["_"]["destroy"]++; }; 
	UCF_SplitterCol.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SplitterCol_standards["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_SplitterDragAndDrop"] = function() {/* global _assert, _trace, _measure, DEBUG, ERROR, START, STOP, WARNING, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_SplitterGhost */
/// <reference path="./SplitterGhost.js"/>
/* eslint quotes:0 */

/**
 * Use the SAP Splitter {@link UCF_Control} to construct a group of
 * {@link UCF_Control}s within an area, each of which is placed in a separate
 * cell. The {@link UCF_Splitter} control manages and displays the cells. You
 * can change the size of the cells using a sash. Enlarging one cell reduces
 * the size of the adjacent cell.
 *
 * 
 * @version 1.0.0.0
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SplitterDragAndDrop(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["UCF_SplitterDragAndDrop"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterDragAndDrop.js(44): UCF_SplitterDragAndDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterDragAndDrop.js(45): UCF_SplitterDragAndDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterDragAndDrop.js(46): UCF_SplitterDragAndDrop"); };

	UCF_SplitterGhost["apply"](this, [oDomRef, oLS]);
};window["UCF_SplitterDragAndDrop"] = UCF_SplitterDragAndDrop; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterDragAndDrop"); UCF_SplitterDragAndDrop["_"] = {UCF_SplitterDragAndDrop: 0}; }; ;
UCF_SplitterDragAndDrop["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterGhost"))(); UCF_SplitterDragAndDrop.prototype["sClassName"] = "UCF_SplitterDragAndDrop";



/**
 * @private
 * @return {enum-value}
 */
UCF_SplitterDragAndDrop["prototype"]["sGetDragDirection"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["sGetDragDirection"]++; }; 
	/** @type {enum-list} */
	var eNeighbour = this["eNeighbourhood"];
	/** @type {Object} */
	var oGhostCoordinates = this["oGetGhostCoordinates"]();

	if (oGhostCoordinates["start"] > oGhostCoordinates["end"]) {
		return eNeighbour["PREVIOUS"];
	} else if (oGhostCoordinates["start"] < oGhostCoordinates["end"]) {
		return eNeighbour["NEXT"];
	} else {
		return eNeighbour["NONE"];
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["sGetDragDirection"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterDragAndDrop["prototype"]["bDragOccured"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["bDragOccured"]++; }; 
	/** @type {Object} */
	var oGhostCoordinates = this["oGetGhostCoordinates"]();
	return oGhostCoordinates["start"] !== oGhostCoordinates["end"];
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["bDragOccured"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterDragAndDrop["prototype"]["bCanDrag"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["bCanDrag"]++; }; 
	/** @type {enum-list} */
	var eAccessType = this["eAccessType"];
	/** @type {enum-list} */
	var eSashType = this["eSashType"];
	/** @type {enum-value} */
	var sSashType = this["sGetSashType"]();
	/** @type {enum-value} */
	var sAccessType = this["sAccessType"];

	return (
		sAccessType !== eAccessType["DELAYEDDOUBLECLICK"] &&
		(sSashType === eSashType["RESIZE"] ||
		sSashType === eSashType["TOGGLE_AND_RESIZE"])
			&&
		(this["sDragSession"] === this["eDragSession"]["QUIET"] ||
		 this["sDragSession"] === this["eDragSession"]["FINISHED"]));
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["bCanDrag"] = 0; };
/**
 * @private
 */
UCF_SplitterDragAndDrop["prototype"]["prepareDragEnviroment"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["prepareDragEnviroment"]++; }; 
	/** @type {HTML_Element} */
	var oRoot = this["oDomRef"];
	/** @type {HTML_Element} */
	var oSash = this["oSash"];

	this["detachBrowserEvent"]("resize", this["oDomRef"]);
	oRoot["style"]["position"] = 'relative';
	oSash["style"]["pointerEvents"] = 'none';
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["prepareDragEnviroment"] = 0; };

/**
 * @private
 */
UCF_SplitterDragAndDrop["prototype"]["cleanDragEnviroment"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["cleanDragEnviroment"]++; }; 
	/** @type {HTML_Element} */
	var oRoot = this["oDomRef"];
	/** @type {HTML_Element} */
	var oSash = this["oSash"];

	oRoot["style"]["position"] = '';
	oSash["removeAttribute"]('style');
	this["attachBrowserEvent"]('resize', this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["cleanDragEnviroment"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SplitterDragAndDrop["prototype"]["prepareDragSession"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["prepareDragSession"]++; }; 
	/** @type {HTML_Element} */
	var oSource = oBrowserEvent["oSource"];
	/** @type {string} */
	var sId = oSource["getAttribute"]('id');

	this["sAccessType"] = this["eAccessType"]["DRAGGING"];
	this["sDragSession"] = this["eDragSession"]["INITIALIZED"];
	oBrowserEvent["oDragAndDropManager"]["startDragSession"](
		sId + '-ghost',
		"",
		UCF_DragSession["DRAG_TYPE"]["NONE"],
		null,
		null,
		null);
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["prepareDragSession"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SplitterDragAndDrop["prototype"]["cleanDragSession"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["cleanDragSession"]++; }; 
	this["sDragSession"] = this["eDragSession"]["FINISHED"];
	oBrowserEvent["oDragAndDropManager"]["finishDragSession"]();
	this["oAfterActionData"] = null;
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["cleanDragSession"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SplitterDragAndDrop["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["onlsdragstart"]++; }; 

	if (this["bCanDrag"]()) {
		this["prepareDragSession"](oBrowserEvent);
		this["prepareDragEnviroment"]();
		this["oGetBounds"]();
		this["createGhost"]();
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["onlsdragstart"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SplitterDragAndDrop["prototype"]["onlsdrag"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["onlsdrag"]++; }; 
	this["sDragSession"] = this["eDragSession"]["ONGOING"];
	this["determineGhostPosition"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["onlsdrag"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SplitterDragAndDrop["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["onlsdragend"]++; }; 

	this["determineGhostPosition"](oBrowserEvent);
	this["updateLastGhostCoordinates"]();

	if (this["sDragSession"] === this["eDragSession"]["ONGOING"] && this["bDragOccured"]()) {
		this["updateLastGhostCoordinates"]();
		this["determineAfterDragData"]();
		this["determineEventsToFire"](
			this["eEventsToFire"]["RESIZED_BY_SASH"],
			this["eEventsToFire"]["MOVEEND"]);
		this["fireSematicEvents"]();
		this["handlePaddings"]();
		this["concatValuesToStyles"]();
		this["updateClientAfterMoveAction"]();
		this["removeGhost"]();
		this["unlockCells"]();
		this["cleanDragSession"](oBrowserEvent);
		this["cleanDragEnviroment"]();
		this["purgeData"]();

	} else {
		this["cleanDragSession"](oBrowserEvent);
		this["updateLastGhostCoordinates"]();
		this["removeGhost"]();
		this["unlockCells"]();
		this["cleanDragEnviroment"]();
		this["purgeData"]();
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["onlsdragend"] = 0; };


/**
 * ############################################################################
 *
 * SECTION OBSERVES DRAG-PROCESS
 *
 * ############################################################################
 */

/**
 * retuns the oBounds-Object that stores all values concerning the drag-zone.
 * If no oBounds-Object is there it creates a new, unless the current drag-session
 * has the status PENDING, which means that the oBounds-data must remain unchanged
 * untill a new drag-session starts.
 * @private
 * @return {Object}
 */
UCF_SplitterDragAndDrop["prototype"]["oGetBounds"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["oGetBounds"]++; }; 

	if (this["oBounds"]) {
		return this["oBounds"];
	} else {
		this["determineBounds"]();
		if (this["oBounds"]) {
			return this["oBounds"];
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Cannot determine bounds', "SplitterDragAndDrop.js(255): oGetBounds"); };
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["oGetBounds"] = 0; };

/**
 * @private
 * @return {int}
 */
UCF_SplitterDragAndDrop["prototype"]["iGetSashesWithinBounds"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["iGetSashesWithinBounds"]++; }; 
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();
	/** @type {string} */
	var sGridPart = this["sGetGridPartId_attachedToSash"]();
	/** @type {int} */
	var iSashes = 0;
	/** @type {n} */
	var n;

	for (n in oGridData) {
		if (oGridData[n]["sash"]) {
			iSashes++;
		}
		if (n === sGridPart) {
			break;
		}
	}
	return iSashes;
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["iGetSashesWithinBounds"] = 0; };

/**
 * Determines the bounderies within which the sash can move
 * @private
 */
UCF_SplitterDragAndDrop["prototype"]["determineBounds"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["determineBounds"]++; }; 
	/** @type {Object} */
	var oBounds = {};
	/** @type {string} */
	var sOrientation = this["sGet_domOrientation_fromMap"]();
	/** @type {string} */
	var sDimension = this["sGet_domDimension_fromMap"]();
	/** @type {Object} */
	var oSashRect = this["oGetSashRect"]();
	/** @type {Object} */
	var oSucceedingSizes = this["oGetSucceedingCellParams"]();
	/** @type {Object} */
	var oSucceedingCellRect = this["oGetSucceedingCellRect"]();
	/** @type {Object} */
	var oPrecedingCellRect = this["oGetPrecedingCellRect"]();
	/** @type {int} */
	var iSashStart = this["iCalcRelativeValue"](oSucceedingCellRect[sOrientation]);
	/** @type {Object} */
	var oPrevCell = this["oGetPrecedingCellDomRef"]();
	/** @type {Object} */
	var oNextCell = this["oGetSucceedingCellDomRef"]();

	/** Collect the position of the sash */
	oBounds["height"] = oSashRect["height"];
	oBounds["width"] = oSashRect["width"];
	oBounds["size"] = oSashRect[sDimension];
	oBounds["start"] = iSashStart - oSashRect[sDimension];

	/** Collect the dimensions of the cell that preceds the sash */
	oBounds["min"] = oPrecedingCellRect[sOrientation];
	oBounds["paddingStart"] = this["iGetPaddingForBounds"](oPrevCell, this["sGetKey_paddingStart_fromMap"]());
	// this.storeCellPadding({ "precedingcell": oPrevCell });

	/** Collect the dimensions of the cell that succeeds the sash */
	oBounds["max"] = oSucceedingCellRect[sOrientation] + oSucceedingSizes["sizeinpixel"] - oBounds["size"];
	oBounds["paddingEnd"] = this["iGetPaddingForBounds"](oNextCell, this["sGetKey_paddingEnd_fromMap"]());
//  this.storeCellPadding({ "succeedingcell": oNextCell });

	this["oBounds"] = oBounds;
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["determineBounds"] = 0; };

/**
 * @private
 * @param {DOM_Element} oCellDomRef
 * @param {string} sPaddingKey
 * @return {int}
 */
UCF_SplitterDragAndDrop["prototype"]["iGetPaddingForBounds"] = function(oCellDomRef, sPaddingKey) {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["iGetPaddingForBounds"]++; }; 
	/** @type {int} */
	var iPadding;

	iPadding = UCF_DomUtil["sGetCurrentStyle"](oCellDomRef, sPaddingKey);
	iPadding = iPadding["split"]('px')[0];
	iPadding = parseInt(iPadding);

	return iPadding;
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["iGetPaddingForBounds"] = 0; };

/**
 * collects all data needed to calculate the resized cells
 * @private
 */
UCF_SplitterDragAndDrop["prototype"]["determineAfterDragData"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["determineAfterDragData"]++; }; 
	/** @type {Object} */
	var oDelta = this["oGetGhostDelta"]();
	/** @type {Object} */
	var oDragedElements = this["oGetDragedElements"]();
	/** @type {Object} */
	var oSizes = this["oGetSizesAfterMoveAction"](oDelta, oDragedElements);
	/** @type {Object} */
	var oSizeAndUnitPairs = this["oGetSizeAndUnitPairOfMoveAction"](oSizes, oDragedElements);

	this["determineDataAfterMoveAction"](oDelta, oDragedElements, oSizeAndUnitPairs);
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["determineAfterDragData"] = 0; };


/**
 * @private
 * @return {Object}
 */
UCF_SplitterDragAndDrop["prototype"]["oGetDragedElements"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["oGetDragedElements"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */

	var oPrecedingSizes = this["oGetPrecedingCellParams"]();
	/** @type {Object} */
	var oSucceedingSizes = this["oGetSucceedingCellParams"]();
	/** @type {Object} */
	var oGhostCoordinates = this["oGetGhostCoordinates"]();
	/** @type {enum-list} */
	var eNeighbour = this["eNeighbourhood"];
	/** @type {enum-value} */
	var sOrientation = this["sGetOrientation"]();
	/** @type {enum-list} */
	var eSizeMode = this["eSizeMode"];

	if (oGhostCoordinates["start"] > oGhostCoordinates["end"]) {
		oResult["toBeIncreased"] = oSucceedingSizes;
		oResult["toBeDecreased"] = oPrecedingSizes;
		oResult["increase"] = eNeighbour["NEXT"];
		oResult["decrease"] = eNeighbour["PREVIOUS"];

	} else {
		oResult["toBeIncreased"] = oPrecedingSizes;
		oResult["toBeDecreased"] = oSucceedingSizes;
		oResult["increase"] = eNeighbour["PREVIOUS"];
		oResult["decrease"] = eNeighbour["NEXT"];
	}

	if (this[eSizeMode[sOrientation]] === eSizeMode["RELATIVE"]) {
		oResult["originalSize"] = oResult["toBeDecreased"]["sizeinpercent"];
	} else {
		oResult["originalSize"] = oResult["toBeDecreased"]["sizeinpixel"];
	}
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["oGetDragedElements"] = 0; };



/**
 * @private
 * @param { Object } oSizeToChange
 * @param {Object} oDelta
 * @return {Object}
 */
UCF_SplitterDragAndDrop["prototype"]["oGetIncreasedDragData"] = function(oSizeToChange, oDelta) {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["oGetIncreasedDragData"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {enum-list} */
	var eUnits = this["eUnits"];
	/** @type {enum-value} */
	var sUnit = oSizeToChange["unit"];

	switch (sUnit) {
		case eUnits["PIXEL"]:
			oResult["size"] = oSizeToChange["size"] + oDelta["pixel"];
			oResult["sizeinpixel"] = oSizeToChange["sizeinpixel"] + oDelta["pixel"];
			oResult["expandedsize"] = oSizeToChange["expandedsize"] + oDelta["pixel"];
			oResult["expandedsizeinpixel"] = oSizeToChange["expandedsizeinpixel"] + oDelta;
			oResult["expandedsizeinpercent"] = oSizeToChange["expandedsizeinpercent"] + oDelta["percent"];
			break;

		case eUnits["PERCENTAGE"]:
			oResult["size"] = oSizeToChange["size"] + oDelta["percent"];
			oResult["sizeinpixel"] = oSizeToChange["sizeinpixel"] + oDelta["pixel"];
			oResult["expandedsize"] = oSizeToChange["expandedsize"] + oDelta["percent"];
			oResult["expandedsizeinpixel"] = oSizeToChange["expandedsizeinpixel"] + oDelta["pixel"];
			oResult["expandedsizeinpercent"] = oSizeToChange["expandedsizeinpercent"] + oDelta["percent"];
			break;

		case eUnits["FRACTION"]:
			oResult["size"] = 1;
			oResult["sizeinpixel"] = oSizeToChange["sizeinpixel"] + oDelta["pixel"];
			oResult["expandedsize"] = 1;
			oResult["expandedsizeinpixel"] = oSizeToChange["expandedsizeinpixel"] + oDelta["pixel"];
			oResult["expandedsizeinpercent"] = oSizeToChange["expandedsizeinpercent"] + oDelta["percent"];
	}

	oResult["sizeinpercent"] = oSizeToChange["sizeinpercent"] + oDelta["percent"];
	oResult["id"] = oSizeToChange["id"];
	oResult["unit"] = sUnit;
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["oGetIncreasedDragData"] = 0; };

/**
 * @private
 * @param { Object } oSizeToChange
 * @param {Object} oDelta
 * @return {Object}
 */
UCF_SplitterDragAndDrop["prototype"]["oGetDecreasedDragData"] = function(oSizeToChange, oDelta) {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["oGetDecreasedDragData"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {enum-list} */
	var eUnits = this["eUnits"];
	/** @type {enum-value} */
	var sUnit = oSizeToChange["unit"];
	/** @type {int} */
	var iPixel = oSizeToChange["sizeinpixel"] - oDelta["pixel"];
	/** @type {int} */
	var iPercent = oSizeToChange["sizeinpercent"] - oDelta["percent"];

	if (sUnit === eUnits["PIXEL"]) {
		oResult["size"] = iPixel;
		oResult["sizeinpixel"] = iPixel;
		oResult["sizeinpercent"] = iPercent;

		if (iPixel > 0) {
			oResult["expandedsizeinpixel"] = iPixel;
			oResult["expandedsize"] = iPixel;

		} else {
			oResult["expandedsizeinpixel"] = oSizeToChange["expandedsizeinpixel"];
			oResult["expandedsize"] = oSizeToChange["expandedsize"];
		}

		if (iPercent > 0) {
			oResult["expandedsizeinpercent"] = iPercent;

		} else {
			oResult["expandedsizeinpercent"] = oSizeToChange["expandedsizeinpercent"];
		}

	} else if (sUnit === eUnits["PERCENTAGE"]) {
		oResult["size"] = iPercent;
		oResult["sizeinpixel"] = iPixel;
		oResult["sizeinpercent"] = iPercent;

		if (iPixel > 0) {
			oResult["expandedsizeinpixel"] = iPixel;

		} else {
			oResult["expandedsizeinpixel"] = oSizeToChange["expandedsizeinpixel"];
		}

		if (iPercent > 0) {
			oResult["expandedsize"] = iPercent;
			oResult["expandedsizeinpercent"] = iPercent;

		} else {
			oResult["expandedsize"] = oSizeToChange["expandedsize"];
			oResult["expandedsizeinpercent"] = oSizeToChange["expandedsizeinpercent"];
		}

	} else if (sUnit === eUnits["FRACTION"]) {
		oResult["sizeinpixel"] = iPixel;
		oResult["expandedsize"] = 1;
		oResult["sizeinpercent"] = iPercent;

		if (iPixel > 0) {
			oResult["size"] = 1;
			oResult["expandedsizeinpixel"] = iPixel;

		} else {
			oResult["size"] = 0;
			oResult["expandedsizeinpixel"] = oSizeToChange["expandedsizeinpixel"];
		}

		if (iPercent > 0) {
			oResult["expandedsizeinpercent"] = iPercent;

		} else {
			oResult["expandedsizeinpercent"] = oSizeToChange["expandedsizeinpercent"];
		}
	}

	if (oResult["size"] < 0) oResult["size"] = 0;

	oResult["id"] = oSizeToChange["id"];
	oResult["unit"] = sUnit;
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["oGetDecreasedDragData"] = 0; };

// /**
//  * @private
//  */
// UCF_SplitterDragAndDrop.prototype.updateClientAfterDrag = function() {
// 	/** @type {boolean} */
// 	var bPureDragType = this.bSplitterIsDragType();
// 	/** @type { enum-value}*/
// 	var sSashPosition = this.sGetSashPositionAfterDrag();
// 	/** @type {Object} */
// 	var oAccessedSash;
// 	/** @type {Object} */
// 	var oDockedSash;
// 	/** @type {Object} */
// 	var oFreedSash;
// 	/** @type {Object} */
// 	var oSqueezedSash;
// 	/** @type {Object} */
// 	var oData = {};

// 	if (!bPureDragType) {
// 		oAccessedSash = this.oGetSashData();
// 		oDockedSash = this.oGetDockedSashData(sSashPosition);
// 		oFreedSash = this.oGetFreedSashData(sSashPosition);
// 		oSqueezedSash = this.oGetSqueezedSashData(sSashPosition);

// 		oData.sashPosition = sSashPosition;
// 		oData.accessed = oAccessedSash;
// 		oData.docked = oDockedSash;
// 		oData.freed = oFreedSash;
// 		oData.squeezed = oSqueezedSash;

// 		this.updateGridDimensionsInDom();
// 		this.updateGridDataAfterAnyAction(sSashPosition);
// 		this.updateNeighbourhoodAfterDrag(oData);
// 		this.updateSashStylesAfterAnyAction(oData);
// 	}
// 	else {
// 		this.updateGridDimensionsInDom();
// 		this.updateGridDataAfterAnyAction(sSashPosition);
// 	}
// };

/**
 * @private
 * @return {enum-value}
 */
UCF_SplitterDragAndDrop["prototype"]["sGetSashPositionAfterDrag"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["sGetSashPositionAfterDrag"]++; }; 
	/** @type { enum-value }*/
	var sResult;
	/** @type {Object} */
	var oSashData = this["oGetSashData"]();
	/** @type { enum-list }*/
	var eCellPairStates = this["eCellPairStates"];
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];
	/** @type { enum-list }*/
	var eSashPosition = this["eSashPosition"];
	/** @type { enum-value }*/
	var sStatesBeforeAction = this["sGetAdjucentCellStatesBeforeAction"](oSashData);
	/** @type { enum-value }*/
	var sDragDirection = this["sGetDragDirection"]();
	/** @type { enum-value }*/
	var sReturnToSize = oSashData["returntosizeof"];
	/** @type { enum-value }*/
	// var sToggleDirection = oSashData.toggledirection;

	sResult = eSashPosition["NOT_APPLICABLE"];

	if (this["bGhostWithinBounds"]()) {
		if (sDragDirection === eNeighbour["NEXT"]) {
			sResult = eSashPosition["NEW_DIMESNIONS_MAX"];
		}
		else if (sDragDirection === eNeighbour["PREVIOUS"]) {
			sResult = eSashPosition["NEW_DIMESNIONS_MIN"];
		}
	}
	else if (this["bGhostAtMin"]()) {
		if (
			sStatesBeforeAction === eCellPairStates["EXPANDED_AND_EXPANDED"] &&
			sReturnToSize === eNeighbour["PREVIOUS"]
		) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MIN_RETURN_TO_PREVIOUS"];
		}
		else if (
			sStatesBeforeAction === eCellPairStates["EXPANDED_AND_EXPANDED"] &&
			sReturnToSize === eNeighbour["NEXT"]
		) {
			sResult = eSashPosition["NEW_EXPAND_POSITION_MIN"];
		}
		else if (
			// sStatesBeforeAction === eCellPairStates.EXPANDED_AND_COLLAPSED &&
			sReturnToSize === eNeighbour["ONLY_NEXT_AVAILABLE"]
		) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MIN"];
		}
		else if (
			sStatesBeforeAction === eCellPairStates["EXPANDED_AND_COLLAPSED"]
		) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MIN"];
		}
		else {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MIN"];
		}
	}
	else if (this["bGhostAtMax"]()) {

		if (
			sStatesBeforeAction === eCellPairStates["EXPANDED_AND_EXPANDED"] &&
			sReturnToSize === eNeighbour["NEXT"]
		) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MAX_RETURN_TO_NEXT"];
		}
		else if (
			sStatesBeforeAction === eCellPairStates["EXPANDED_AND_EXPANDED"] &&
			sReturnToSize === eNeighbour["PREVIOUS"]
		) {
			sResult = eSashPosition["NEW_EXPAND_POSITION_MAX"];
		}
		else if (
			 sStatesBeforeAction === eCellPairStates["COLLAPSED_AND_EXPANDED"] &&
			 sReturnToSize === eNeighbour["ONLY_PREVIOUS_AVAILABLE"]
		) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MAX"];
		}
		else if (
			sStatesBeforeAction === eCellPairStates["COLLAPSED_AND_EXPANDED"]
		) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MAX"];
		}
		else {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MAX"];
		}

	}
	return sResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["sGetSashPositionAfterDrag"] = 0; };

/**
 * @private
 * @param {Object} oData
 */
UCF_SplitterDragAndDrop["prototype"]["updateNeighbourhoodAfterDrag"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["updateNeighbourhoodAfterDrag"]++; }; 
	/** @type {Object} */
	var oAccessed = oData["accessed"];
	/** @type {Object} */
	var oDocked = oData["docked"];
	/** @type {Object} */
	var oFreed = oData["freed"];
	/** @type {Object} */
	var oSqueezed = oData["squeezed"];
	/** @type {Object} */
	var oNeighbours;
	/** @type { enum-list }*/
	var eSashPosition = this["eSashPosition"];
	/** @type { enum-value}*/
	var sSashPosition = oData["sashPosition"];

	/**
	 * New containers created and / or moved away from docked
	 */
	if (sSashPosition === eSashPosition["NEW_DIMESNIONS_MAX"] ||
			sSashPosition === eSashPosition["NEW_DIMESNIONS_MIN"]) {
		oNeighbours = this["oGetNeighbours_atNewDimensions"](oData);
		this["removeFromNeighboudhoodStorage"](oAccessed, oFreed);
	}
	/**
	 * New expand position where only one container with new sizes is visible
	 * and / or moved away from docked
	 */
	else if (
		sSashPosition === eSashPosition["NEW_EXPAND_POSITION_MAX"] ||
		sSashPosition === eSashPosition["NEW_EXPAND_POSITION_MIN"]
		) {
		oNeighbours = this["oGetNeighbours_atNewExpandPosition"](oData);
	}
	/**
	 * Moved to already exsiting position and or moved away from docked
	 */
	else if (
		sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MIN"] ||
		sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MIN_RETURN_TO_PREVIOUS"]
		) {
		oNeighbours = this["oGetNeighbours_atOwnToggleMin"](oData);
	}
	else if (
		sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MAX"] ||
		sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MAX_RETURN_TO_NEXT"]
		) {
		oNeighbours = this["oGetNeighbours_atOwnToggleMax"](oData);
	}

	this["setNeigbourhoodForNextToggling"]([oNeighbours["accessed"], oNeighbours["docked"], oNeighbours["freed"], oSqueezed]);
	this["addToNeighboudhoodStorage"](oAccessed, oDocked, oFreed, oSqueezed);
};;if (__UCF_COVERAGE__) { UCF_SplitterDragAndDrop["_"]["updateNeighbourhoodAfterDrag"] = 0; };

};
sap["ls"]["preload"]["UCF_SplitterGhost"] = function() {/* global _assert, _trace, _measure, DEBUG, ERROR, START, STOP, WARNING, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_SplitterSash */
/// <reference path="./SplitterSash.js"/>
/* eslint quotes:0 */

/**
 * Use the SAP Splitter {@link UCF_Control} to construct a group of
 * {@link UCF_Control}s within an area, each of which is placed in a separate
 * cell. The {@link UCF_Splitter} control manages and displays the cells. You
 * can change the size of the cells using a sash. Enlarging one cell reduces
 * the size of the adjacent cell.
 *
 * 
 * @version 1.0.0.0
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SplitterGhost(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["UCF_SplitterGhost"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterGhost.js(44): UCF_SplitterGhost"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterGhost.js(45): UCF_SplitterGhost"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterGhost.js(46): UCF_SplitterGhost"); };

	UCF_SplitterSash["apply"](this, [oDomRef, oLS]);
};window["UCF_SplitterGhost"] = UCF_SplitterGhost; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterGhost"); UCF_SplitterGhost["_"] = {UCF_SplitterGhost: 0}; }; ;
UCF_SplitterGhost["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterSash"))(); UCF_SplitterGhost.prototype["sClassName"] = "UCF_SplitterGhost";

/**
 *
 * @private
 */
UCF_SplitterGhost["prototype"]["createGhost"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["createGhost"]++; }; 
	/** @type {HTML_Element} */
	var oGhost;
	/** @type {HTML_Element} */
	var oSash = this["oSash"];
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {string} */
	var start = this["sGet_domOrientation_fromMap"]();
	/** @type {int} */
	var iStart;
	/** @type {string} */
	var fixed = this["sGetKey_fixed_fromMap"]();
	/** @type {int} */
	var iLastGhostCoordinates = this["iGetLastGhostCoordinates"]();
	/** @type {enum-value} */
	var sDragSession = this["sDragSession"];
	/** @type {enum-list} */
	var eDragsession = this["eDragSession"];

	if (sDragSession === eDragsession["INITIALIZED"]) {
		iStart = oBounds["start"];
	} else {
		iStart = iLastGhostCoordinates;
	}

	if (oSash && oBounds) {
		this["storeFirstGhostCoordinates"](iStart);
		oGhost = this["oGetGhostDomRef"]();
		oGhost["style"][start] = iStart + 'px';
		oGhost["style"][fixed] = '0px';
		oGhost["style"]["width"] = oBounds["width"] + 'px';
		oGhost["style"]["height"] = oBounds["height"] + 'px';
		oGhost["style"]["position"] = 'absolute';
		oGhost["style"]["display"] = '';
		UCF_DomUtil["addClass"](oGhost, oSash["classList"][1]);
		this["oGhost"] = oGhost;
	}
	// _trace(INFO, '---------------------createGhost-----------------');
	// _trace(WARNING, 'iStart: ' + iStart);
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["createGhost"] = 0; };

/**
 * @private
 */
UCF_SplitterGhost["prototype"]["removeGhost"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["removeGhost"]++; }; 
	/** @type {HTML_Element} */
	var oGhost = this["oGhost"];

	if (oGhost) {
		oGhost["removeAttribute"]('style');
		oGhost["className"] = this["eStyles"]["GHOST"];
		oGhost["style"]["display"] = 'none';
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["removeGhost"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_SplitterGhost["prototype"]["oGetGhostRect"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["oGetGhostRect"]++; }; 
	/** @type {HTML_Element} */
	var oGhost;
	/** @type {Object} */
	var oGhostRect;

	oGhost = this["oGetGhostDomRef"]();
	oGhostRect = this["oGetClientRect"](oGhost);
	// _trace(INFO, '----------------oGetGhostRect----------------------');
	// _trace(WARNING, 'oGhostRect: ' + oGhostRect.toString());
	return oGhostRect;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["oGetGhostRect"] = 0; };

/**
 * @private
 * @return {HTML_Element}
 */
UCF_SplitterGhost["prototype"]["oGetGhostDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["oGetGhostDomRef"]++; }; 
	/** @type {HTML_Element} */
	var oSash;
	/** @type {HTML_Element} */
	var oGhost;
	/** @type {string} */
	var sId;

	if (this["oGhost"]) {
		return this["oGhost"];

	} else {
		oSash = this["oSash"];
		sId = oSash["getAttribute"]('id');
		sId = sId["split"]('-')[0];
		sId = sId + '-ghost';
		oGhost = UCF_DomUtil["$"](sId);
		this["oGhost"] = oGhost;
		return oGhost;
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["oGetGhostDomRef"] = 0; };

/**
 * @private
 */
UCF_SplitterGhost["prototype"]["updateLastGhostCoordinates"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["updateLastGhostCoordinates"]++; }; 
	/** @type {int} */
	var iPosition;
	/** @type {Object} */
	var oGhostRect = this["oGetGhostRect"]();
	/** @type {Object} */
	var oSplitterRect = this["oGetSplitterRect"]();
	/** @type {string} */
	var sOrientation = this["sGet_domOrientation_fromMap"]();

	iPosition = oGhostRect[sOrientation] - oSplitterRect[sOrientation];
	this["iLastGhostCoordinates"] = iPosition;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["updateLastGhostCoordinates"] = 0; };

/**
 * Returns the updated ghost coordinates after or during dragging
 * @private
 * @return {int}
 */
UCF_SplitterGhost["prototype"]["iGetLastGhostCoordinates"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetLastGhostCoordinates"]++; }; 
	return this["iLastGhostCoordinates"];
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetLastGhostCoordinates"] = 0; };

/**
 * Returns the stored ghost coordinates at the beginning of the drag session
 * @private
 * @return {int}
 */
UCF_SplitterGhost["prototype"]["iGetFirstGhostCoordinates"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetFirstGhostCoordinates"]++; }; 
	return this["iGhostAtStart"];
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetFirstGhostCoordinates"] = 0; };

/**
 * @private
 * @param {int} iPosition
 */
UCF_SplitterGhost["prototype"]["storeFirstGhostCoordinates"] = function(iPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["storeFirstGhostCoordinates"]++; }; 
	this["iGhostAtStart"] = iPosition;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["storeFirstGhostCoordinates"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_SplitterGhost["prototype"]["oGetGhostDelta"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["oGetGhostDelta"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {int} */
	var iStart = this["iGetFirstGhostCoordinates"]();
	/** @type {int} */
	var iEnd = this["iGetLastGhostCoordinates"]();
	/** @type {int} */
	var iPixel;
	/** @type {int} */
	var iPercent;

	iPixel = iStart - iEnd;

	if (iPixel < 0) {
		iPixel = iPixel * -1;
	}

	if (iEnd > iStart) {
		iPixel = iPixel; // - this.oBounds.size;
	}

	iPercent = this["iGetPercentFromPixel"](iPixel);
	oResult["pixel"] = iPixel;
	oResult["percent"] = iPercent;
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["oGetGhostDelta"] = 0; };

/**
 * Determines whether the ghost is whithin the bounderies where
 * dragging is allowed
 * @private
 * @return {boolean}
 */
UCF_SplitterGhost["prototype"]["bGhostWithinBounds"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostWithinBounds"]++; }; 
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {Object} */
	var oGhostRect = this["oGetGhostRect"]();
	/** @type {Object} */
	var sOrientation = this["oGetOrientationMap"]()["domOrientation"];
	/** @type {boolean} */
	var bWithinBounds = (oGhostRect[sOrientation] > oBounds["min"] &&
		oGhostRect[sOrientation] < oBounds["max"] &&
		!this["bGhostWithinStartPaddingArea"]() &&
		!this["bGhostWithinEndPaddingArea"]());

	// _trace(INFO, '--------------------bGhostWithinBounds------------------');
	// _trace(WARNING, 'oBounds.min: ' + oBounds.min);
	// _trace(WARNING, 'oBounds.max: ' + oBounds.max);
	// _trace(WARNING, 'must not be within StartPaddingArea: ' + this.bGhostWithinStartPaddingArea());
	// _trace(WARNING, 'must not be within EndPaddingArea: ' + this.bGhostWithinEndPaddingArea());

	return bWithinBounds;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostWithinBounds"] = 0; };

/**
 * Determines that the ghost is exactly at the bounderies. As a result,
 * the ghost freazes there.
 * @private
 * @return {boolean}
 */
UCF_SplitterGhost["prototype"]["bGhostAtBounds"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtBounds"]++; }; 
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {Object} */
	var oGhostRect = this["oGetGhostRect"]();
	/** @type {Object} */
	var sOrientation = this["oGetOrientationMap"]()["domOrientation"];
	/** @type {boolean} */
	var bAtBounds = (oGhostRect[sOrientation] <= oBounds["min"] ||
		oGhostRect[sOrientation] >= oBounds["max"] ||
		this["bGhostWithinEndPaddingArea"]() ||
		this["bGhostWithinStartPaddingArea"]());
	// _trace(INFO, '');
	// _trace(INFO, '------------------bGhostAtBounds--------------------');
	// _trace(WARNING, 'oBounds.min: ' + oBounds.min);
	// _trace(WARNING, 'oBounds.max: ' + oBounds.max);
	// _trace(WARNING, 'must be within StartPaddingArea: ' + this.bGhostWithinStartPaddingArea());
	// _trace(WARNING, 'must be within EndPaddingArea: ' + this.bGhostWithinEndPaddingArea());

	return bAtBounds;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtBounds"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterGhost["prototype"]["bGhostAtMax"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtMax"]++; }; 
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {Object} */
	var iPosition = this["iGetAbsoluteGhostPosition"]();

	return iPosition === oBounds["max"];
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtMax"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterGhost["prototype"]["bGhostAtMin"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtMin"]++; }; 
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {Object} */
	var iPosition = this["iGetAbsoluteGhostPosition"]();

	return iPosition === oBounds["min"];
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtMin"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterGhost["prototype"]["bGhostAtRelativeSplitterStart"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtRelativeSplitterStart"]++; }; 
	/** @type {Object} */
	var oSplitterRect = this["oGetSplitterRect"]();
	/** @type {string} */
	var sOrientation = this["sGet_domOrientation_fromMap"]();
	/** @type {int} */
	var iThreshold = oSplitterRect[sOrientation];
	/** @type {string} */
	var iGhostPosition = this["iGetAbsoluteGhostPosition"]();
	/** @type {Object} */
	var oSashesAtStart = this["oSashesAtSplitterStart"];
	/** @type {int} */
	var iInclude = 0;
	/** @type {int} */
	var iSashSize = this["oBounds"]["size"];
	/** @type {string} */
	var n;

	// eslint-disable-next-line
	for (n in oSashesAtStart) {
		iInclude += iSashSize;
	}

	iThreshold += iInclude;

	return iGhostPosition === iThreshold;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtRelativeSplitterStart"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterGhost["prototype"]["bGhostAtRelativeSplitterEnd"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtRelativeSplitterEnd"]++; }; 
	/** @type {Object} */
	var oSplitterRect = this["oGetSplitterRect"]();
	/** @type {string} */
	var sOrientation = this["sGet_domOrientation_fromMap"]();
	/** @type {string} */
	var sDimension = this["sGet_domDimension_fromMap"]();
	/** @type {int} */
	var iGhostPosition = this["iGetAbsoluteGhostPosition"]();
	/** @type {int} */
	var iPosition;
	/** @type {Object} */
	var oSashesAtEnd = this["oSashesAtSplitterEnd"];
	/** @type {int} */
	var iExclude = 0;
	/** @type {int} */
	var iSashSize = this["oBounds"]["size"];
	/** @type {string} */
	var n;

	// eslint-disable-next-line
	for (n in oSashesAtEnd) {
		iExclude += iSashSize;
	}

	iPosition = oSplitterRect[sOrientation] + oSplitterRect[sDimension];
	iPosition = iPosition - this["oBounds"]["size"];
	iPosition = iPosition - iExclude;

	return iGhostPosition === iPosition;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtRelativeSplitterEnd"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterGhost["prototype"]["bGhostAtAbsoluteSplitterStart"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtAbsoluteSplitterStart"]++; }; 
	/** @type {Object} */
	var oSplitterRect = this["oGetSplitterRect"]();
	/** @type {string} */
	var sOrientation = this["sGet_domOrientation_fromMap"]();
	/** @type {string} */
	var iGhostPosition = this["iGetAbsoluteGhostPosition"]();

	return iGhostPosition === oSplitterRect[sOrientation];
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtAbsoluteSplitterStart"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterGhost["prototype"]["bGhostAtAbsoluteSplitterEnd"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtAbsoluteSplitterEnd"]++; }; 
	/** @type {Object} */
	var oSplitterRect = this["oGetSplitterRect"]();
	/** @type {string} */
	var sOrientation = this["sGet_domOrientation_fromMap"]();
	/** @type {string} */
	var sDimension = this["sGet_domDimension_fromMap"]();
	/** @type {int} */
	var iGhostPosition = this["iGetAbsoluteGhostPosition"]();
	/** @type {int} */
	var iPosition;

	iPosition = oSplitterRect[sOrientation] + oSplitterRect[sDimension];
	iPosition = iPosition - this["oBounds"]["size"];

	return iGhostPosition === iPosition;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostAtAbsoluteSplitterEnd"] = 0; };

/**
 * Determines that the ghost is within the padding zone at the start of
 * the drag zone
 * @private
 * @return {boolean}
 */
UCF_SplitterGhost["prototype"]["bGhostWithinStartPaddingArea"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostWithinStartPaddingArea"]++; }; 
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {int} */
	var iMax = oBounds["min"] + oBounds["paddingStart"];
	/** @type {int} */
	var iMin = oBounds["min"];
	/** @type {int} */
	var iGhostPosition = this["iGetAbsoluteGhostPosition"]();
	/** @type {boolean} */
	var bWithinStartPaddingArea = (oBounds["paddingStart"] > 0 &&
		iGhostPosition >= iMin &&
		iGhostPosition <= iMax);

	// _trace(INFO, '------------------bGhostWithinStartPaddingArea--------------------');
	// _trace(WARNING, 'oBounds.paddingStart: ' + oBounds.paddingStart);
	// _trace(WARNING, 'iMin: ' + iMin);
	// _trace(WARNING, 'iMax: ' + iMax);
	// _trace(WARNING, 'iRelativeGhostPosition:' + iRelative);
	// _trace(WARNING, 'iAbsoluteGhostPos:' + iGhostPosition);
	// _trace(WARNING, 'bWithinStartPaddingArea:' + bWithinStartPaddingArea);

	return bWithinStartPaddingArea;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostWithinStartPaddingArea"] = 0; };

/**
 * Determines that the ghost is within the padding area at the end of the
 * the drag zone
 * @private
 * @return {boolean}
 */
UCF_SplitterGhost["prototype"]["bGhostWithinEndPaddingArea"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostWithinEndPaddingArea"]++; }; 
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {Object} */
	var oGhostRect = this["oGetGhostRect"]();
	/** @type {Object} */
	var sOrientation = this["sGet_domOrientation_fromMap"]();
	/** @type {int} */
	var iMax = oBounds["max"];
	/** @type {int} */
	var iMin = oBounds["max"] - oBounds["paddingEnd"];
	/** @type {boolean} */
	var bWithinEndPaddingArea = (oBounds["paddingEnd"] > 0 &&
		oGhostRect[sOrientation] >= iMin &&
		oGhostRect[sOrientation] <= iMax);

	// _trace(INFO, '------------------bGhostWithinEndPaddingArea--------------------');
	// _trace(WARNING, 'oBounds.paddingEnd: ' + oBounds.paddingEnd);
	// _trace(WARNING, 'iMin: ' + iMin);
	// _trace(WARNING, 'iMax: ' + iMax);
	// _trace(WARNING, 'bWithinEndPaddingArea: ' + bWithinEndPaddingArea);

	return bWithinEndPaddingArea;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bGhostWithinEndPaddingArea"] = 0; };

/**
 * @private
 * @return {int}
 */
UCF_SplitterGhost["prototype"]["iGetRelativeGhostPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetRelativeGhostPosition"]++; }; 
	/** @type {Object} */
	var oSplitterRect = this["oGetSplitterRect"]();
	/** @type {string} */
	var sOrientation = this["sGet_domOrientation_fromMap"]();
	/** @type {Object} */
	var oGhostRect = this["oGetGhostRect"]();
	/** @type {int} */
	var iPosition;

	iPosition = oGhostRect[sOrientation] - oSplitterRect[sOrientation];

	// _trace(INFO, '------------------iGetRelativeGhostPosition--------------------');
	// _trace(WARNING, 'iPosition: ' + iPosition);
	// _trace(WARNING, 'oGhostRect[sOrientation]: ' + oGhostRect[sOrientation]);
	// _trace(WARNING, 'oSplitterRect[sOrientation]: ' + oSplitterRect[sOrientation]);

	return iPosition;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetRelativeGhostPosition"] = 0; };

/**
 * @private
 * @return {int}
 */
UCF_SplitterGhost["prototype"]["iGetAbsoluteGhostPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetAbsoluteGhostPosition"]++; }; 
	/** @type {Object} */
	var oGhostRect = this["oGetGhostRect"]();
	/** @type {string} */
	var sOrientation = this["sGet_domOrientation_fromMap"]();

	// _trace(INFO, '-----------------iGetAbsoluteGhostPosition---------------------');
	// _trace(WARNING, 'iPosition: ' + oGhostRect[sOrientation]);
	return oGhostRect[sOrientation];
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetAbsoluteGhostPosition"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_SplitterGhost["prototype"]["oGetGhostCoordinates"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["oGetGhostCoordinates"]++; }; 
	var oResult = {};
	var iStart = this["iGetFirstGhostCoordinates"]();
	var iEnd = this["iGetLastGhostCoordinates"]();

	oResult["start"] = iStart;
	oResult["end"] = iEnd;

	// _trace(INFO, '------------------oGetGhostCoordinates--------------------');
	// _trace(WARNING, 'iStart:' + iStart);
	// _trace(WARNING, 'iEnd:' + iEnd);

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["oGetGhostCoordinates"] = 0; };

/**
 * ############################################################################
 *
 * SECTION HANDLES CURSOR POSITION
 *
 * ############################################################################
 */

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @return {int}
 */
UCF_SplitterGhost["prototype"]["iGetRelativeCursorPosition"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetRelativeCursorPosition"]++; }; 
	/** @type {Object} */
	var oSplitterRect = this["oGetSplitterRect"]();
	/** @type {Object} */
	var oDomOrientation = this["oGetOrientationMap"]();
	/** @type {enum-value} */
	var sDomOrientation = oDomOrientation["domOrientation"];
	/** @type {enum-value} */
	var sCursorOrienatation = oDomOrientation["cursor"];
	var iPosition = oBrowserEvent[sCursorOrienatation] - oSplitterRect[sDomOrientation];

	// _trace(INFO, '------------------iGetRelativeCursorPosition--------------------');
	// _trace(WARNING, 'iPosition: ' + iPosition);
	return iPosition;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetRelativeCursorPosition"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @return {string}
 */
UCF_SplitterGhost["prototype"]["iGetAbsoluteCursorPosition"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetAbsoluteCursorPosition"]++; }; 
	/** @type {Object} */
	var oDomOrientation = this["oGetOrientationMap"]();
	/** @type {enum-value} */
	var sCursorOrienatation = oDomOrientation["cursor"];

	// _trace(INFO, '------------------iGetAbsoluteCursorPosition--------------------');
	// _trace(WARNING, 'iPosition: ' + oBrowserEvent[sCursorOrienatation]);
	return oBrowserEvent[sCursorOrienatation];
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["iGetAbsoluteCursorPosition"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @return {boolean}
 */
UCF_SplitterGhost["prototype"]["bCursorOutsideBounds"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bCursorOutsideBounds"]++; }; 
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {string} */
	var sCursorOrienatation = this["oGetOrientationMap"]()["cursor"];
	/** @type {boolean} */
	var bOutsideBounds = (oBrowserEvent[sCursorOrienatation] > oBounds["max"] ||
		oBrowserEvent[sCursorOrienatation] < oBounds["min"]);

	return bOutsideBounds;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bCursorOutsideBounds"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @return { boolean }
 */
UCF_SplitterGhost["prototype"]["bCursorWithinBounds"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bCursorWithinBounds"]++; }; 
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {string} */
	var sCursorOrienatation = this["oGetOrientationMap"]()["cursor"];
	/** @type {string}*/
	var bWithinBounds = (oBrowserEvent[sCursorOrienatation] < oBounds["max"] &&
		oBrowserEvent[sCursorOrienatation] > oBounds["min"]);

	return bWithinBounds;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bCursorWithinBounds"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @return { boolean }
 */
UCF_SplitterGhost["prototype"]["bCursorAtBounds"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bCursorAtBounds"]++; }; 
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {string} */
	var sCursorOrienatation = this["oGetOrientationMap"]()["cursor"];
	/** @type {boolean} */
	var bAtBounds = (oBrowserEvent[sCursorOrienatation] === oBounds["max"] ||
		oBrowserEvent[sCursorOrienatation] === oBounds["min"]);

	return bAtBounds;
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["bCursorAtBounds"] = 0; };

/**
 * ############################################################################
 *
 * SECTION DETERMINES POSITION OF GHOST IN DEPENDACE TO CURSOR AND BOUNDS
 *
 * ############################################################################
 */

/**
 * All position cursor and ghost can have and their permutations
 * Depending on permutations ghost is placed within bounds
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SplitterGhost["prototype"]["determineGhostPosition"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["determineGhostPosition"]++; }; 

	/** @type {int} */
	var iPosition = this["iGetRelativeCursorPosition"](oBrowserEvent);

	/** ghost within bounds
	 * cursor within bounds
	 * ==> move ghost to cursor position
	 */
	if (
		this["bGhostWithinBounds"]() &&
		this["bCursorWithinBounds"](oBrowserEvent)
	) {
		this["assignPositionWithinBounds"](iPosition);

	}
	/** ghost whithin bounds
	 * cursor outside bounds
	 * ==> move ghost to one end determined by bounds
	 */
	else if (
		this["bGhostWithinBounds"]() &&
		this["bCursorOutsideBounds"](oBrowserEvent)
	) {
		this["assignPositionAtBounds"](oBrowserEvent);

	}
	/** ghost within bounds
	 * cursor at bounds
	 * ==> move ghost to one end determined by bounds
	 */
	else if (
		this["bGhostWithinBounds"]() &&
		this["bCursorAtBounds"](oBrowserEvent)
	) {
		this["assignPositionAtBounds"](oBrowserEvent);

	}
	/**
	 * ghost at bounds
	 * cusror whithin bounds
	 * ==> move ghost to cursor
	 */
	else if (
		this["bGhostAtBounds"]() &&
		this["bCursorWithinBounds"](oBrowserEvent)
	) {
		this["assignPositionWithinBounds"](iPosition);
	}
	/**ghost at bounds
	 * cursor at bounds
	 * ==> ignore
	 */
	else if (
		this["bGhostAtBounds"]() &&
		this["bCursorAtBounds"](oBrowserEvent)
	) {
		this["assignPositionAtBounds"](oBrowserEvent);
	}
	/**ghost at bounds
	 * cursor outside bounds
	 * ==> ignore
	 */
	else if (
		this["bGhostAtBounds"]() &&
		this["bCursorOutsideBounds"](oBrowserEvent)) {
		this["assignPositionAtBounds"](oBrowserEvent);
	}

	// _trace(INFO, '------------------determineGhostPosition--------------------');
	// _trace(WARNING, 'iPosition: ' + iPosition);

	// _trace(WARNING, 'oBounds.min: ' + this.oBounds.min);
	// _trace(WARNING, 'oBounds.max: ' + this.oBounds.max);

	// _trace(WARNING, 'bGhostWithinBounds: ' + this.bGhostWithinBounds());
	// _trace(WARNING, 'bCursorWithinBounds: ' + this.bCursorWithinBounds(oBrowserEvent));
	// _trace(WARNING, 'bCursorOutsideBounds: ' + this.bCursorOutsideBounds(oBrowserEvent));
	// _trace(WARNING, 'bCursorAtBounds: ' + this.bCursorAtBounds(oBrowserEvent));
	// _trace(WARNING, 'bGhostAtBounds: ' + this.bGhostAtBounds());
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["determineGhostPosition"] = 0; };

/**
 * @private
 * @param {int} iPosition
 */
UCF_SplitterGhost["prototype"]["assignPositionWithinBounds"] = function(iPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["assignPositionWithinBounds"]++; }; 
	/** @type {HTML_Element} */
	var oGhost = this["oGhost"];
	/** @type {string} */
	var sOrientation = this["oGetOrientationMap"]()["domOrientation"];

	// _trace(INFO, '----------------assignPositionWithinBounds----------------------');
	// _trace(WARNING, 'assignPositionWithinBounds - iPosition: ' + iPosition);
	oGhost["style"][sOrientation] = iPosition + 'px';
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["assignPositionWithinBounds"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SplitterGhost["prototype"]["assignPositionAtBounds"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["assignPositionAtBounds"]++; }; 
	/** @type {HTML_Element} */
	var oGhost = this["oGhost"];
	/** @type {string} */
	var sOrientation = this["oGetOrientationMap"]()["domOrientation"];
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {int} */
	var iPosition = this["iGetAbsoluteCursorPosition"](oBrowserEvent);
	/** @type {Object} */
	var oSplitterRect = this["oGetSplitterRect"]();

	if (iPosition <= oBounds["min"]) {
		oGhost["style"][sOrientation] = (oBounds["min"] - oSplitterRect[sOrientation]) + 'px';
		// _trace(INFO, '--------------------assignPositionAtBounds------------------');
		// _trace(WARNING, 'case: ' + 'if');
		// _trace(WARNING, 'iPosition: ' + (oBounds.min - oSplitterRect[sOrientation]));
		// _trace(WARNING, 'oBounds.min: ' + oBounds.min);
		// _trace(WARNING, 'oSplitterRect-' + sOrientation + ': ' + oSplitterRect[sOrientation]);
	} else if (iPosition >= oBounds["max"]) {
		oGhost["style"][sOrientation] = (oBounds["max"] - oSplitterRect[sOrientation]) + 'px';
		// _trace(INFO, '------------------assignPositionAtBounds--------------------');
		// _trace(WARNING, 'case: ' + 'else');
		// _trace(WARNING, 'iPosition: ' + oBounds.max - oSplitterRect[sOrientation]);
		// _trace(WARNING, 'oBounds.man: ' + oBounds.max);
		// _trace(WARNING, 'oSplitterRect-' + sOrientation + ': ' + oSplitterRect[sOrientation]);
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterGhost["_"]["assignPositionAtBounds"] = 0; };


};
sap["ls"]["preload"]["UCF_SplitterGrid"] = function() {/* global _assert, _trace, _measure, DEBUG, ERROR, START, STOP, WARNING, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_Splitter */
/// <reference path="./Splitter.js"/>
/* eslint quotes:0 */

/**
 * Use the SAP Splitter {@link UCF_Control} to construct a group of
 * {@link UCF_Control}s within an area, each of which is placed in a separate
 * cell. The {@link UCF_Splitter} control manages and displays the cells. You
 * can change the size of the cells using a sash. Enlarging one cell reduces
 * the size of the adjacent cell.
 *
 * 
 * @version 1.0.0.0
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SplitterGrid(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["UCF_SplitterGrid"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterGrid.js(44): UCF_SplitterGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterGrid.js(45): UCF_SplitterGrid"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterGrid.js(46): UCF_SplitterGrid"); };

	UCF_Splitter["apply"](this, [oDomRef, oLS]);
};window["UCF_SplitterGrid"] = UCF_SplitterGrid; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterGrid"); UCF_SplitterGrid["_"] = {UCF_SplitterGrid: 0}; }; ;
UCF_SplitterGrid["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Splitter"))(); UCF_SplitterGrid.prototype["sClassName"] = "UCF_SplitterGrid";

/**
 * @private
 * @param {HTML_Element} oElement
 * @return {enum-value}
 */
UCF_SplitterGrid["prototype"]["sGetGridType"] = function(oElement) {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridType"]++; }; 
	/** @type {enum-value} */
	var sResult = null;
	if (oElement && oElement["getAttribute"]('data-gridtype')) {
		sResult = oElement["getAttribute"]('data-gridtype');
	}
	return sResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridType"] = 0; };

/**
 * Converts a JSON string that dipicts the structure of the
 * CSS grid that constructs the splitter into a JS object
 * @private
 */
UCF_SplitterGrid["prototype"]["createGridData"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["createGridData"]++; }; 
	/** @type {string} */
	var sGridData;
	/** @type {boolean} */
	var oGridData = this["oGridData"];

	if (!oGridData) {
		sGridData = this["oDomRef"]["getAttribute"]('data-structure');
		oGridData = UCF_JsUtil["oJsonParse"](sGridData);
		this["oGridData"] = oGridData;
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["createGridData"] = 0; };


/**
 * converts the strings of the dimensions of the cells
 * into int values
 * @private
 */
UCF_SplitterGrid["prototype"]["calcGridDimensions"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["calcGridDimensions"]++; }; 
	/** @type {string} */
	var sDragOrientation;
	/** @type {Object} */
	var oGridData;
	/** @type {string} */
	var sGridElement;
	/** @type {Array} */
	var aPrecedingCells;
	/** @type {Array} */
	var aSucceedingCells;
	/** @type {Array} */
	var aAssociatedCells;
	/** @type {string} */
	var sGridPartPrecedingSash;
	/** @type {string} */
	var sGridPartSuccedingSash;
	/** @type {string} */
	var sAssociatedCell;
	/** @type {Object} */
	var eUnits = this["eUnits"];
	/** @type {HTML} */
	var oDomRef;
	/** @type {string} */
	var n;

	if (this["bGridInitialized"]() === false  || this["bGridDataInvalid"]()) {

		oGridData = this["oGetGridData"]();
		aPrecedingCells = this["aGetCellsPrecedingSash"]();
		aSucceedingCells = this["aGetCellsSucceedingSash"]();
		sGridPartPrecedingSash = this["sGetGridPartId_precedingSash"]();
		sGridPartSuccedingSash = this["sGetGridPartId_succeedingSash"]();
		sGridElement = this["sGetKey_gridPart_fromMap"]();
		sDragOrientation = this["sGetOrientation"]();

		for (n in oGridData) {

			if (sGridPartPrecedingSash === n) {
				oDomRef = UCF_DomUtil["$"](aPrecedingCells[0]);

			} else if (sGridPartSuccedingSash === n) {
				oDomRef = UCF_DomUtil["$"](aSucceedingCells[0]);

			} else {
				aAssociatedCells = oGridData[n]["associatedcells"];
				sAssociatedCell = aAssociatedCells[0];
				oDomRef = UCF_DomUtil["$"](sAssociatedCell);
			}

			if (oGridData[n]["unit"] === eUnits["PIXEL"]) {
				oGridData[n] = this["calcPercentageForCell"](oGridData[n]);

			} else if (oGridData[n]["unit"] === eUnits["PERCENTAGE"]) {
				oGridData[n] = this["calcPixelsForCell"](oGridData[n], oDomRef);

			} else if (oGridData[n]["unit"] === eUnits["FRACTION"]) {
				oGridData[n] = this["calcPixelsForCell"](oGridData[n], oDomRef);
				oGridData[n] = this["calcPercentageForCell"](oGridData[n]);
			}
		}

		this["updateStoredSplitterSizes"]();
		this["oGridData"][sGridElement] = oGridData;
		this["oInitialized"][sDragOrientation] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["calcGridDimensions"] = 0; };

/**
 * @private
 * @param  {enum-value} sSashPosition
 */
UCF_SplitterGrid["prototype"]["updateGridDataAfterAnyAction"] = function(sSashPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["updateGridDataAfterAnyAction"]++; }; 
	/** @type { Object }*/
	var oGridData = this["oGetGridData"]();
	/** @type { Object }*/
	var oAfterActionData = this["oGetAfterActionData"]();
	/** @type { string }*/
	var sDecrease = oAfterActionData["elementToDecrease"];
	/** @type { string }*/
	var sIncrease = oAfterActionData["elementToIncrease"];
	/** @type { enum-list }*/
	var eSashPosition = this["eSashPosition"];

	/** assign the calculated sizes */
	oGridData[sDecrease]["size"] = oAfterActionData[sDecrease]["size"];
	oGridData[sDecrease]["sizeinpixel"] = oAfterActionData[sDecrease]["sizeinpixel"];
	oGridData[sDecrease]["sizeinpercent"] = oAfterActionData[sDecrease]["sizeinpercent"];
	oGridData[sIncrease]["size"] = oAfterActionData[sIncrease]["size"];
	oGridData[sIncrease]["sizeinpixel"] = oAfterActionData[sIncrease]["sizeinpixel"];
	oGridData[sIncrease]["sizeinpercent"] = oAfterActionData[sIncrease]["sizeinpercent"];

	if (sSashPosition === eSashPosition["NEW_DIMESNIONS_MIN"] ||
			sSashPosition === eSashPosition["NEW_DIMESNIONS_MAX"] ||
			sSashPosition === eSashPosition["NEW_DIMESNIONS_MAX"] ||
			sSashPosition === eSashPosition["NEW_DIMESNIONS_MIN"]) {

			if (oGridData[sDecrease]["sizeinpixel"] > 0) {
				oGridData[sDecrease]["expandedsize"] = oAfterActionData[sDecrease]["expandedsize"];
				oGridData[sDecrease]["expandedsizeinpixel"] = oAfterActionData[sDecrease]["expandedsizeinpixel"];
				oGridData[sDecrease]["expandedsizeinpercent"] = oAfterActionData[sDecrease]["expandedsizeinpercent"];

				oGridData[sIncrease]["expandedsize"] = oAfterActionData[sIncrease]["expandedsize"];
				oGridData[sIncrease]["expandedsizeinpixel"] = oAfterActionData[sIncrease]["expandedsizeinpixel"];
				oGridData[sIncrease]["expandedsizeinpercent"] = oAfterActionData[sIncrease]["expandedsizeinpercent"];
			}
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["updateGridDataAfterAnyAction"] = 0; };


/**
 * @private
 */
UCF_SplitterGrid["prototype"]["updateGridDimensionsInDom"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["updateGridDimensionsInDom"]++; }; 
	/** @type {Object} */
	var oStyle = UCF_DomUtil["$"](this["sId"] + '-rootCss');
	/** @type {string} */
	var sParameter = this["sGetGridParameter"]();
	/** @type {string} */
	var sSelector = '[id="' + this["sId"] + '"]';
	/** @type {string} */
	var sConstantStyles = this["sGetConstantStyleBlock"]();
	/** @type {string} */
	var sNewStyles = this["sGetNewStyles"]();
	/** @type {string} */
	var sStyleBlock = sSelector + '{' + sConstantStyles + sParameter + sNewStyles + '}';

	oStyle["innerText"] = sStyleBlock;
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["updateGridDimensionsInDom"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_SplitterGrid["prototype"]["sGetGridParameter"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridParameter"]++; }; 
	/** @type {enum-value} */
	var sDirection = this["sGetOrientation"]();
	/** @type {enum-list} */
	var eDragOrientation = this["eDragOrientation"];

	if (sDirection === eDragOrientation["HORIZONTAL"] &&
			UCF_UserAgent["bIsIE"]()) {
			return '-ms-grid-columns:';
	}

	if (sDirection === eDragOrientation["HORIZONTAL"] &&
			!UCF_UserAgent["bIsIE"]()) {
			return 'grid-template-columns:';
	}

	if (sDirection === eDragOrientation["VERTICAL"] &&
			UCF_UserAgent["bIsIE"]()) {
			return '-ms-grid-rows:';
	}

	if (sDirection === eDragOrientation["VERTICAL"] &&
			!UCF_UserAgent["bIsIE"]()) {
			return 'grid-template-rows:';
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridParameter"] = 0; };

/**
 * ############################################################################
 *
 * SECTION WITH HELPER METHODS THAT RETURN DATA FROM oGridData
 *
 * ############################################################################
 */

/**
 * return the id of that determines in its API which type of sash
 * it has to precede
 *
 * @private
 * @return { string }
 */
UCF_SplitterGrid["prototype"]["sGetGridPartId_attachedToSash"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridPartId_attachedToSash"]++; }; 
	/** @type {string} */
	var sKey = this["sGetKey_preceding_fromMap"]();
	/** @type {Object} */
	var oSashData = this["oSashData"];

	return oSashData[sKey];
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridPartId_attachedToSash"] = 0; };

/**
 * return the id of that grid part that follows the sash in depentance of
 * the current dom orientation
 *
 * @private
 * @return { string }
 */
UCF_SplitterGrid["prototype"]["sGetGridPartId_precedingSash"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridPartId_precedingSash"]++; }; 
	/** @type {string} */
	var sKey = this["sGetKey_preceding_fromMap"]();
	/** @type {Object} */
	var oSashData = this["oSashData"];

	return oSashData[sKey];
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridPartId_precedingSash"] = 0; };

/**
 * Returns the id of the grid part (col, row) the succeedes the
 * accessed sash, in dependance of the dom orientaion
 * @private
 * @return { string }
 */
UCF_SplitterGrid["prototype"]["sGetGridPartId_succeedingSash"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridPartId_succeedingSash"]++; }; 
	/** @type {string} */
	var sKey = this["sGetKey_succeeding_fromMap"]();
	/** @type {Object} */
	var oSashData = this["oSashData"];

	return oSashData[sKey];
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridPartId_succeedingSash"] = 0; };

/**
 * @private
 * @param {string} sId
 * @return { string }
 */
UCF_SplitterGrid["prototype"]["sGetGridPartUnit"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridPartUnit"]++; }; 
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();
	return oGridData[sId]["unit"];
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["sGetGridPartUnit"] = 0; };

/**
 * converts the strings of the dimensions of the cells
 * into int values
 * @private
 * @return {boolean}
 */
UCF_SplitterGrid["prototype"]["bGridDataInvalid"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["bGridDataInvalid"]++; }; 
	/** @type {int} */
	var iStoredSize = this["iGetStoredSplitterSize"]();
	/** @type {int} */
	var iSize = this["iGetAbsoluteSplitterSizeInPixel"]();

	return (iStoredSize === null || iSize !== iStoredSize);
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["bGridDataInvalid"] = 0; };

/**
 * returns an objects that depicts the structure of the CSS-Grid
 * behind the splitter-control
 * @private
 * @return {Object}
 */
UCF_SplitterGrid["prototype"]["oGetGridData"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["oGetGridData"]++; }; 
	/** @type {string} */
	var sGridPart = this["sGetKey_gridPart_fromMap"]();

	if (this["oGridData"]) {
		return this["oGridData"][sGridPart];

	} else {
		this["createGridData"]();
		if (this["oGridData"]) {
			return this["oGridData"][sGridPart];

		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Cannot create grid-structure', "SplitterGrid.js(352): oGetGridData"); };
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["oGetGridData"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterGrid["prototype"]["bGridInitialized"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["bGridInitialized"]++; }; 
	/** @type {Object} */
	var oInitialized = this["oInitialized"];
	/** @type {string} */
	var sDragOrientation = this["sGetOrientation"]();

	return oInitialized && oInitialized[sDragOrientation] !== undefined;
};;if (__UCF_COVERAGE__) { UCF_SplitterGrid["_"]["bGridInitialized"] = 0; };


};
sap["ls"]["preload"]["UCF_SplitterGridCell"] = function() {/* global _assert, _trace, _measure, DEBUG, ERROR, START, STOP, WARNING, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_SplitterGrid */
/// <reference path="./SplitterGrid.js"/>
/* eslint quotes:0 */

/**
 * Use the SAP Splitter {@link UCF_Control} to construct a group of
 * {@link UCF_Control}s within an area, each of which is placed in a separate
 * cell. The {@link UCF_Splitter} control manages and displays the cells. You
 * can change the size of the cells using a sash. Enlarging one cell reduces
 * the size of the adjacent cell.
 *
 * 
 * @version 1.0.0.0
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SplitterGridCell(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["UCF_SplitterGridCell"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterGridCell.js(44): UCF_SplitterGridCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterGridCell.js(45): UCF_SplitterGridCell"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterGridCell.js(46): UCF_SplitterGridCell"); };

	UCF_SplitterGrid["apply"](this, [oDomRef, oLS]);
};window["UCF_SplitterGridCell"] = UCF_SplitterGridCell; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterGridCell"); UCF_SplitterGridCell["_"] = {UCF_SplitterGridCell: 0}; }; ;
UCF_SplitterGridCell["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterGrid"))(); UCF_SplitterGridCell.prototype["sClassName"] = "UCF_SplitterGridCell";

/**
 * ############################################################################
 *
 * SECTION WITH HELPER METHODS CONCERING CELL-DATA
 *
 * ############################################################################
 */


/**
 * @private
 * @return { enum-value }
 */
UCF_SplitterGridCell["prototype"]["sGetCellState"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetCellState"]++; }; 
	/** @type {enum-value} */
	var sResult;
	/** @type {Object} */
	var oSashData = this["oGetSashData"]();
	/** @type {enum-list} */
	var eNeighbour = this["eNeighbourhood"];
	/** @type {enum-list} */
	var eState = this["eSingleCellState"];
	/** @type {enum-value} */
	var sCollapseDirection = this["sGetCollapseDirection"]();

	if (sCollapseDirection === eNeighbour["NEXT"] &&
		oSashData["statesucceeding"] === eState["COLLAPSED"]) {
		sResult = eState["COLLAPSED"];
	} else if (
		sCollapseDirection === eNeighbour["PREVIOUS"] &&
		oSashData["statepreceding"] === eState["COLLAPSED"]
	) {
		sResult = eState["COLLAPSED"];
	} else if (
		sCollapseDirection === eNeighbour["NEXT"] &&
		oSashData["statesucceeding"] === eState["EXPANDED"]
	) {
		sResult = eState["EXPANDED"];
	} else if (
		sCollapseDirection === eNeighbour["PREVIOUS"] &&
		oSashData["statepreceding"] === eState["EXPANDED"]
	) {
		sResult = eState["EXPANDED"];
	}

	return sResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetCellState"] = 0; };

/**
 *
 * @private
 * @param { HTML_Element } oSash
 * @return {enum-value}
 */
UCF_SplitterGridCell["prototype"]["sGetAdjucentCellStatesBeforeAction"] = function(oSash) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetAdjucentCellStatesBeforeAction"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oSash) === 'object', "typeof(oSash) === 'object'", "SplitterGridCell.js(107): sGetAdjucentCellStatesBeforeAction"); };

	/** @type {enum-value} */
	var sResult;

	sResult = this["eCellPairStates"]["NOT_APPLICABLE"];

	if (oSash) {
		sResult = oSash["statepreceding"] + '_AND_' + oSash["statesucceeding"];
	}

	return sResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetAdjucentCellStatesBeforeAction"] = 0; };

/**
 *
 * @private
 * @param { HTML_Element } oSash
 * @return {enum-value}
 */
UCF_SplitterGridCell["prototype"]["sGetAdjucentCellStatesAfterAction"] = function(oSash) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetAdjucentCellStatesAfterAction"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oSash) === 'object', "typeof(oSash) === 'object'", "SplitterGridCell.js(128): sGetAdjucentCellStatesAfterAction"); };

	/** @type {enum-value} */
	var sResult;
	/** @type {enum-list} */
	var eCellPairStates = this["eCellPairStates"];
	/** @type {string} */
	var sPreceding = this["sGetKey_preceding_fromMap"]();
	/** @type {string} */
	var sSucceeding = this["sGetKey_succeeding_fromMap"]();
	/** @type {boolean} */
	var bPreviousIsCollapsed;
	/** @type {boolean} */
	var bNextIsCollapsed;

	sResult = this["eCellPairStates"]["NOT_APPLICABLE"];

	if (oSash) {
		bPreviousIsCollapsed = this["bIsCollapsed"](oSash[sPreceding]);
		bNextIsCollapsed = this["bIsCollapsed"](oSash[sSucceeding]);

		if (!bPreviousIsCollapsed && !bNextIsCollapsed) {
			sResult = eCellPairStates["EXPANDED_AND_EXPANDED"];
		}
		else if (bPreviousIsCollapsed && !bNextIsCollapsed) {
			sResult = eCellPairStates["COLLAPSED_AND_EXPANDED"];
		}
		else if (!bPreviousIsCollapsed && bNextIsCollapsed) {
			sResult = eCellPairStates["EXPANDED_AND_COLLAPSED"];
		}
		else if (bPreviousIsCollapsed && bNextIsCollapsed) {
			sResult = eCellPairStates["COLLAPSED_AND_COLLAPSED"];
		}
	}

	return sResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetAdjucentCellStatesAfterAction"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetGridDummies"]= function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetGridDummies"]++; }; 
	/** @type {HTML_Element} */
	var oDomRef = UCF_DomUtil["$"](this["sId"] + '-dummies');
	/** @type {Array} */
	var aHTML = oDomRef["getElementsByTagName"]('SPAN');
	/** @type {Object} */
	var oSizes = {};
	/** @type {Object} */
	var oControl;
	/** @type {string} */
	var sGridPart;
	/** @type {int} */
	var l = aHTML["length"];
	/** @type {int} */
	var i;

	sGridPart = (this["sGetOrientation"]() === this["eDragOrientation"]["HORIZONTAL"]) ? 'SPC_standards' : 'SPR_standards';

	for (i = 0; i < l; i++) {
		if (aHTML[i]["getAttribute"]('ct') === sGridPart) {
					oControl = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aHTML[i], true);
					oSizes[aHTML[i]["getAttribute"]('id')] = oControl;
		}
	}

	return oSizes;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetGridDummies"] = 0; };

/**
 * returns an array with the ids of all cells that surround a sash
 * for the purpose of locking them
 * @private
 * @return {Array}
 */
UCF_SplitterGridCell["prototype"]["aGetCellsSurroundingSash"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["aGetCellsSurroundingSash"]++; }; 
	/** @type {Array} */
	var aPreceding = this["aGetCellsPrecedingSash"]();
	/** @type {Array} */
	var aSucceeding = this["aGetCellsSucceedingSash"]();
	/** @type {Array} */
	var aIdSet;

	aIdSet = aPreceding["concat"](aSucceeding);
	return aIdSet;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["aGetCellsSurroundingSash"] = 0; };

/**
 * returns an array with the ids of all cells that preced a sash,
 * in dependency of the current dom-orientation
 *
 * @private
 * @return {Array}
 */
UCF_SplitterGridCell["prototype"]["aGetCellsPrecedingSash"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["aGetCellsPrecedingSash"]++; }; 
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();
	/** @type {Object} */
	var sGrid = this["sGetGridPartId_attachedToSash"]();
	/** @type {Object} */
	var oData = oGridData[sGrid];

	return oData["sash"]["precedingcells"];
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["aGetCellsPrecedingSash"] = 0; };

/**
 * returns an array with the ids of all cells that follow a sash,
 * in dependency of the current dom-orientation
 *
 * @private
 * @return {Array}
 */
UCF_SplitterGridCell["prototype"]["aGetCellsSucceedingSash"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["aGetCellsSucceedingSash"]++; }; 
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();
	/** @type {Object} */
	var sGrid = this["sGetGridPartId_attachedToSash"]();
	/** @type {Object} */
	var oData = oGridData[sGrid];

	return oData["sash"]["succeedingcells"];
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["aGetCellsSucceedingSash"] = 0; };

/**
 * return an object that sores all size aspect of a cell located before a sash,
 * that is:
 * the actual definitions as done in the API for its height and width
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetPrecedingCellParams"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetPrecedingCellParams"]++; }; 
	/** @type {Object} */
	var oResult;
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();
	/** @type {string} */
	var sGridPart = this["sGetGridPartId_precedingSash"]();

	if (this["bIsCollapsed"](sGridPart) &&
			oGridData[sGridPart]["expandedsize"] === 0 &&
			this["sAccessType"] !== this["eAccessType"]["DRAGGING"]) {
		oResult = this["oGetCollapsedCellParams"](sGridPart);

	} else {
		oResult = oGridData[sGridPart];
	}

	oResult["id"] = sGridPart;
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetPrecedingCellParams"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetSucceedingCellParams"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetSucceedingCellParams"]++; }; 
	/** @type {Object} */
	var oResult;
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();
	/** @type {string} */
	var sGridPart = this["sGetGridPartId_succeedingSash"]();

	if (this["bIsCollapsed"](sGridPart) &&
			oGridData[sGridPart]["expandedsize"] === 0 &&
			this["sAccessType"] !== this["eAccessType"]["DRAGGING"]) {
		oResult = this["oGetCollapsedCellParams"](sGridPart);

	} else {
		oResult = oGridData[sGridPart];
	}

	oResult["id"] = sGridPart;
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetSucceedingCellParams"] = 0; };

/**
 * @private
 * @param { string } sGridPart
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetCollapsedCellParams"] = function(sGridPart) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCollapsedCellParams"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oGridDummies = this["oGetGridDummies"]();
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();
	/** @type {enum-list} */
	var eUnits = this["eUnits"];
	/** @type {string} */
	var iExpandedSize = this["sGet_expandedSizeProperty_fromMap"]();
	/** @type {int} */
	var iSize;

	iSize = oGridDummies[sGridPart][iExpandedSize];
	oResult["unit"] = oGridData[sGridPart]["unit"];

	switch (oResult["unit"]) {
		case eUnits["PIXEL"]:
			oResult["size"] = iSize;
			oResult["sizeinpixel"] = iSize;
			oResult["sizeinpercent"] = this["iGetPercentFromPixel"](iSize);
			oResult["expandedsize"] = iSize;
			oResult["expandedsizeinpixel"] = iSize;
			oResult["expandedsizeinpercent"] = this["iGetPercentFromPixel"](iSize);
		break;
		case eUnits["PERCENTAGE"]:
			oResult["size"] = iSize;
			oResult["sizeinpixel"] = this["iGetPixelFromPercent"](iSize);
			oResult["sizeinpercent"] = iSize;
			oResult["expandedsize"] = iSize;
			oResult["expandedsizeinpixel"] = this["iGetPixelFromPercent"](iSize);
			oResult["expandedsizeinpercent"] = iSize;
		break;
		case eUnits["FRACTION"]:
			oResult["size"] = 1;
			oResult["sizeinpixel"] = this["iGetPixelFromPercent"](iSize);
			oResult["sizeinpercent"] = iSize;
			oResult["expandedsize"] = 1;
			oResult["expandedsizeinpixel"] = this["iGetPixelFromPercent"](iSize);
			oResult["expandedsizeinpercent"] = iSize;
		break;
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCollapsedCellParams"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetPrecedingCellRect"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetPrecedingCellRect"]++; }; 
	/** @type {Object} */
	var oResult;
	/** @type {Array} */
	var aCells = this["aGetCellsPrecedingSash"]();
	/** @type {HTML_Element} */
	var oDomRef = UCF_DomUtil["$"](aCells[0]);

	oResult = this["oGetClientRect"](oDomRef);
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetPrecedingCellRect"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetSucceedingCellRect"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetSucceedingCellRect"]++; }; 
	/** @type {Object} */
	var oResult;
	/** @type {Array} */
	var aCells = this["aGetCellsSucceedingSash"]();
	/** @type {HTML_Element} */
	var oDomRef = UCF_DomUtil["$"](aCells[0]);

	oResult = this["oGetClientRect"](oDomRef);
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetSucceedingCellRect"] = 0; };

/**
 * @private
 * @return { HTML_Element }
 */
UCF_SplitterGridCell["prototype"]["oGetPrecedingCellDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetPrecedingCellDomRef"]++; }; 
	/** @type {Array} */
	var aCellIds = this["aGetCellsPrecedingSash"]();
	/** @type {string} */
	var sCellId = aCellIds[0];
	/** @type {HTML_Element} */
	var oDomRef = UCF_DomUtil["$"](sCellId);

	return oDomRef;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetPrecedingCellDomRef"] = 0; };

/**
 * @private
 * @return { HTML_Element }
 */
UCF_SplitterGridCell["prototype"]["oGetSucceedingCellDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetSucceedingCellDomRef"]++; }; 
	/** @type {Array} */
	var aCellIds = this["aGetCellsSucceedingSash"]();
	/** @type {string} */
	var sCellId = aCellIds[0];
	/** @type {HTML_Element} */
	var oDomRef = UCF_DomUtil["$"](sCellId);

	return oDomRef;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetSucceedingCellDomRef"] = 0; };

/**
 * return the coordinates of preceding and succeeding cells.
 * necessary for resize event
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetCellCoordinates"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCellCoordinates"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oActionData;
	/** @type {Array} */
	var aPreceding = this["aGetCellsPrecedingSash"]();
	/** @type {Array} */
	var aSucceeding = this["aGetCellsSucceedingSash"]();
	/** @type {Array} */
	var aDomData = this["oDomRef"]["getElementsByTagName"]('DIV');
	/** @type {enum-list} */
	var eNeighbour = this["eNeighbourhood"];
	/** @type {enum-list} */
	var eAccessType = this["eAccessType"];
	/** @type {enum-value} */
	var sAccessType = this["sAccessType"];
	/** @type {string} */
	var sIncrease;
	/** @type {string} */
	var sDecrease;
	/** @type {string} */
	var sNext;
	/** @type {string} */
	var sPrevious;
	/** @type {int} */
	var l = aDomData["length"] - 1;
	/** @type {int} */
	var i;
	/** @type {string} */
	var sId;

	if (sAccessType === eAccessType["DELAYEDDOUBLECLICK"] ||
		sAccessType === eAccessType["KEYBOARD"]) {
		oActionData = this["oGetCellToggleDirections"]();
	}
	else if (
		sAccessType === eAccessType["DRAGGING"]) {
		oActionData = this["oGetDragedElements"]();
	}

	oResult["increased"] = [];
	oResult["decreased"] = [];
	oResult["next"] = [];
	oResult["previous"] = [];

	sNext = aSucceeding["toString"]();
	sPrevious = aPreceding["toString"]();

	if (oActionData["increase"] === eNeighbour["NEXT"]) {
		sIncrease = aSucceeding["toString"]();
	} else {
		sIncrease = aPreceding["toString"]();
	}

	if (oActionData["decrease"] === eNeighbour["NEXT"]) {
		sDecrease = aSucceeding["toString"]();
	} else {
		sDecrease = aPreceding["toString"]();
	}

	for (i = 0; i <= l; i++) {

		if (aDomData[i]["getAttribute"]('data-gridtype') === this["eGridType"]["CELL"]) {
			sId = aDomData[i]["getAttribute"]('id');

			if (sId) {
				if (sIncrease["indexOf"](sId) > -1) {
					oResult["increased"]["push"](this["sGetCellCoord"](aDomData[i]));
				}
				else if (sDecrease["indexOf"](sId) > -1) {
					oResult["decreased"]["push"](this["sGetCellCoord"](aDomData[i]));
				}
				if (sNext["indexOf"](sId) > -1) {
					oResult["next"]["push"](this["sGetCellCoord"](aDomData[i]));
				}
				else if (sPrevious["indexOf"](sId) > -1) {
					oResult["previous"]["push"](this["sGetCellCoord"](aDomData[i]));
				}
			}
		}
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCellCoordinates"] = 0; };

/**
 * @private
 * @param { HTML_Element } oDomRef
 * @return {string}
 */
UCF_SplitterGridCell["prototype"]["sGetCellCoord"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetCellCoord"]++; }; 
	/** @type {int} */
	var iRow = oDomRef["getAttribute"]('data-rowIndex');
	/** @type {int} */
	var iCol = oDomRef["getAttribute"]('data-colIndex');

	return this["sId"] + '-R' + iRow + '-C' + iCol;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetCellCoord"] = 0; };

/**
 * @private
 * @return {Array}
 */
UCF_SplitterGridCell["prototype"]["aGetAllSplitterCellIds"]= function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["aGetAllSplitterCellIds"]++; }; 
	/** @type {Array} */
	var aResult = [];
	/** @type {Array} */
	var aDomRef;
	/** @type {enum-list} */
	var eGridType = this["eGridType"];
	/** @type {int} */
	var i;
	/** @type {int} */
	var l;

	aDomRef = this["oDomRef"]["getElementsByTagName"]('DIV');
	l = aDomRef["length"];

	for (i = 0; i < l; i++) {
		if (aDomRef[i]["getAttribute"]('data-gridtype') === eGridType["CELL"]) {
			aResult["push"](aDomRef[i]["getAttribute"]('id'));
		}
	}

	return aResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["aGetAllSplitterCellIds"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetCellActionElements"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCellActionElements"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oActions = this["oGetCellToggleDirections"]();
	/** @type {enum-list} */
	var eNeighbour = this["eNeighbourhood"];
	/** @type {enum-list} */
	var eCellPairStates = this["eCellPairStates"];
	/** @type {enum-value} */
	var sCellPairStates = this["sGetAdjucentCellStatesBeforeAction"](this["oSashData"]);
	var sOrientation = this["sGetOrientation"]();
	/** @type {enum-list} */
	var eSizeMode = this["eSizeMode"];

	if (oActions["increase"] === eNeighbour["PREVIOUS"]) {

		if (sCellPairStates !== eCellPairStates["COLLAPSED_AND_COLLAPSED"]) {
			oResult["toBeExpanded"] = this["oGetPrecedingCellParams"]();
			oResult["toBeCollapsed"] = this["oGetSucceedingCellParams"]();
		}
		else {
			oResult["toBeExpanded"] = this["oGetPrecedingCellParams"]();
			oResult["toBeCollapsed"] = this["oGetNextExpanded"](oResult["toBeExpanded"]);
		}

		oResult["previous"] = oResult["toBeExpanded"];
		oResult["next"] = oResult["toBeCollapsed"];

	} else {
		if(sCellPairStates !== eCellPairStates["COLLAPSED_AND_COLLAPSED"]) {
			oResult["toBeExpanded"] = this["oGetSucceedingCellParams"]();
			oResult["toBeCollapsed"] = this["oGetPrecedingCellParams"]();
		}
		else {
			oResult["toBeExpanded"] = this["oGetSucceedingCellParams"]();
			oResult["toBeCollapsed"] = this["oGetPreviousExpanded"](oResult["toBeExpanded"]);
		}

		oResult["previous"] = oResult["toBeCollapsed"];
		oResult["next"] = oResult["toBeExpanded"];
	}

	if (this[eSizeMode[sOrientation]] === eSizeMode["RELATIVE"]) {
		oResult["originalSize"] = oResult["toBeCollapsed"]["sizeinpercent"];
	} else {
		oResult["originalSize"] = oResult["toBeCollapsed"]["sizeinpixel"];
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCellActionElements"] = 0; };

/**
 * @private
 * @param  {Object} oToBeCollapsed
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetPreviousExpanded"] = function(oToBeCollapsed) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetPreviousExpanded"]++; }; 
	/** @type {Object} */
	var oExpanded;
	/** @type {Object} */
	var oGridata = this["oGetGridData"]();
	/** @type {string} */
	var n;

	for (n in oGridata) {
		if (!this["bIsCollapsed"](n)) {
			oExpanded = oGridata[n];
		}

		if (n === oToBeCollapsed["id"]) break;
	}

	return oExpanded;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetPreviousExpanded"] = 0; };

/**
 * @private
 * @param {Object} oToBeCollapsed
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetNextExpanded"] = function(oToBeCollapsed) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetNextExpanded"]++; }; 
	/** @type {Object} */
	var oExpanded;
	/** @type {Object} */
	var oGridata = this["oGetGridData"]();
	/** @type {boolean} */
	var bDoIt = false;
	/** @type {string} */
	var n;

	for (n in oGridata) {

		if (bDoIt && !this["bIsCollapsed"](n)) {
			oExpanded = oGridata[n];
		}

		if (n === oToBeCollapsed["id"]) {
			bDoIt = true;
		}
	}

	return oExpanded;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetNextExpanded"] = 0; };

/**
 * Returns the sum of all sizes of the collapsed grid elements that are before that element
 * that preceds the sash
 * @private
 * @return {Array}
 */
UCF_SplitterGridCell["prototype"]["oGetSizesOfAllCollapsedBeforePreceding"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetSizesOfAllCollapsedBeforePreceding"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();
	/** @type {string} */
	var sPreceding = this["sGetGridPartId_precedingSash"]();
	/** @type {string} */
	var n;

	oResult["pixel"] = 0;
	oResult["percent"] = 0;

	for (n in oGridData) {
		if (n === sPreceding) break;

		if (this["bIsCollapsed"](n)) {
			oResult["pixel"] += oGridData[n]["expandedsizeinpixel"];
			oResult["percent"] += oGridData[n]["expandedsizeinpercent"];
		}
	}
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetSizesOfAllCollapsedBeforePreceding"] = 0; };


/**
 * Returns the sum of all sizes of the collapsed elements that are after that element
 * the succeeds the sash
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetSizesOfAllCollapsedAfterSucceeding"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetSizesOfAllCollapsedAfterSucceeding"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oGridData;
	/** @type {boolean} */
	var bDoIt = false;
	/** @type {string} */
	var sDirectSuccesor = this["sGetGridPartId_succeedingSash"]();
	/** @type {string} */
	var n;

	oResult["pixel"] = 0;
	oResult["percent"] = 0;
	oGridData = this["oGetGridData"]();

	for (n in oGridData) {
		if (bDoIt && this["bIsCollapsed"](n)) {
			oResult["pixel"] += oGridData[n]["expandedsizeinpixel"];
			oResult["percent"] += oGridData[n]["expandedsizeinpercent"];
		}
		if (n === sDirectSuccesor) {
			bDoIt = true;
		}
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetSizesOfAllCollapsedAfterSucceeding"] = 0; };

/**
 * @private
 * @return {enum-value}
 */
UCF_SplitterGridCell["prototype"]["sGetCollapseBehaviour"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetCollapseBehaviour"]++; }; 
	/** @type {enum-value} */
	var sResult;
	/** @type {Object} */
	var oSashData = this["oGetSashData"]();
	/** @type {Object} */
	var sStatesBeforeToggle = this["sGetAdjucentCellStatesBeforeAction"](oSashData);
	/** @type {enum-list} */
	var eToggleBehaviour = this["eToggleBehaviour"];
	/** @type {enum-list} */
	var eCellPairStates = this["eCellPairStates"];
	/** @type {enum-list} */
	var eNeighbour = this["eNeighbourhood"];
	/** @type {enum-value} */
	var sReturnToSize = this["sGetSizeToReturnTo"]();

	if (sReturnToSize === eNeighbour["NEXT"] &&
		sStatesBeforeToggle === eCellPairStates["EXPANDED_AND_COLLAPSED"]) {
		sResult = eToggleBehaviour["COLLAPSE_BY_SIZE_OF_CURRENTLY_COLLAPSED"];
	}
	else if (
		sReturnToSize === eNeighbour["PREVIOUS"] &&
		sStatesBeforeToggle === eCellPairStates["COLLAPSED_AND_EXPANDED"]
	) {
		sResult = eToggleBehaviour["COLLAPSE_BY_SIZE_OF_CURRENTLY_COLLAPSED"];
	}
	else if (sStatesBeforeToggle === eCellPairStates["COLLAPSED_AND_COLLAPSED"]) {
		sResult = eToggleBehaviour["COLLAPSE_BY_SIZE_OF_CURRENTLY_COLLAPSED"];
	}
	else if (sStatesBeforeToggle === eCellPairStates["EXPANDED_AND_EXPANDED"]) {
		sResult = eToggleBehaviour["COLLAPSE_TO_ZERO"];
	}
	else if (
		sReturnToSize !== eNeighbour["NEXT"] &&
		sStatesBeforeToggle === eCellPairStates["EXPANDED_AND_COLLAPSED"]
	) {
		sResult = eToggleBehaviour["COLLAPSE_TO_ZERO"];
	}
	else if (
		sReturnToSize !== eNeighbour["PREVIOUS"] &&
		sStatesBeforeToggle === eCellPairStates["COLLAPSED_AND_EXPANDED"]
	) {
		sResult = eToggleBehaviour["COLLAPSE_TO_ZERO"];
	}
	return sResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetCollapseBehaviour"] = 0; };

/**
 * @private
 * @return {enum-value}
 */
UCF_SplitterGridCell["prototype"]["sGetExpandBehaviour"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetExpandBehaviour"]++; }; 
	/** @type {enum-value} */
	var sResult;
	/** @type {Object} */
	var oSashData = this["oGetSashData"]();
	/** @type {enum-list} */
	var eNeighbour = this["eNeighbourhood"];
	/** @type {enum-list} */
	var eToggleBehaviour = this["eToggleBehaviour"];
	/** @type {enum-list} */
	var eCellPairStates = this["eCellPairStates"];
	/** @type {enum-value} */
	var sStatesBeforeToggle = this["sGetAdjucentCellStatesBeforeAction"](oSashData);
	/** @type {enum-value} */
	var sReturnToSize = this["sGetSizeToReturnTo"]();

	if (sReturnToSize === eNeighbour["NEXT"] &&
			sStatesBeforeToggle === eCellPairStates["EXPANDED_AND_COLLAPSED"]) {
				sResult = eToggleBehaviour["EXPAND_TO_OWN_EXPANDED_SIZE"];
	}
	else if (
		sReturnToSize === eNeighbour["PREVIOUS"] &&
		sStatesBeforeToggle === eCellPairStates["COLLAPSED_AND_EXPANDED"]
	) {
		sResult = eToggleBehaviour["EXPAND_TO_OWN_EXPANDED_SIZE"];
	}
	else if (sStatesBeforeToggle === eCellPairStates["COLLAPSED_AND_COLLAPSED"]) {
		sResult = eToggleBehaviour["EXPAND_TO_OWN_EXPANDED_SIZE"];
	}
	else if (sStatesBeforeToggle === eCellPairStates["EXPANDED_AND_EXPANDED"]) {
		sResult = eToggleBehaviour["EXPAND_TO_SIZE_OF_BOTH"];
	}
	else if (
		sReturnToSize !== eNeighbour["NEXT"] &&
		sStatesBeforeToggle === eCellPairStates["EXPANDED_AND_COLLAPSED"]
	) {
		sResult = eToggleBehaviour["EXPAND_TO_SIZE_OF_CURRENTLY_EXPANDED"];
	}
	else if (
		sReturnToSize !== eNeighbour["PREVIOUS"] &&
		sStatesBeforeToggle === eCellPairStates["COLLAPSED_AND_EXPANDED"]
	) {
		sResult = eToggleBehaviour["EXPAND_TO_SIZE_OF_CURRENTLY_EXPANDED"];
	}
	return sResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetExpandBehaviour"] = 0; };

/**
 * @private
 * @param {string} sElement
 * @return {boolean}
 */
UCF_SplitterGridCell["prototype"]["bIsCollapsed"] = function(sElement) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["bIsCollapsed"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sElement) === 'string', "typeof(sElement) === 'string'", "SplitterGridCell.js(836): bIsCollapsed"); };
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();

	return oGridData[sElement]["sizeinpixel"] === 0;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["bIsCollapsed"] = 0; };


/**
 * @private
 * @return {boolean}
 */
UCF_SplitterGridCell["prototype"]["bStopCellsAction"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["bStopCellsAction"]++; }; 
	/** @type {Object} */
	var oPrecedingSizes = this["oGetPrecedingCellParams"]();
	/** @type {Object} */
	var oSucceedingSizes = this["oGetSucceedingCellParams"]();

	return (oPrecedingSizes["sizeinpixel"] === 0 &&
		oSucceedingSizes["sizeinpixel"] === 0);
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["bStopCellsAction"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_SplitterGridCell["prototype"]["bToggleCells"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["bToggleCells"]++; }; 
	var sSashType = this["sGetSashType"]();

	return (this["bIsSashAccessed"]() &&
					sSashType === this["eSashType"]["TOGGLE_AND_RESIZE"]);
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["bToggleCells"] = 0; };

/**
 * @private
 */
UCF_SplitterGridCell["prototype"]["processCellToggling"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["processCellToggling"]++; }; 
	/** @type {enum-list} */
	var eSingleCellState;
	/** @type {enum-value} */
	var sCellState;
	/** @type {string} */
	var sSashId;

	if (this["bToggleCells"]()) {
		eSingleCellState = this["eSingleCellState"];
		sCellState = this["sGetCellState"]();
		sSashId = this["sGetSashId"]();
		this["determineDataAfterCellToggle"]();
		this["storeCollapsed"]();
		this["updateClientAfterCellToggle"]();

		if (sCellState === eSingleCellState["EXPANDED"]) {
			this["oSashAtBounds"][sSashId] = true;

		} else if (sCellState === eSingleCellState["COLLAPSED"]) {
			delete this["oSashAtBounds"][sSashId];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["processCellToggling"] = 0; };

/**
 * @private
 */
UCF_SplitterGridCell["prototype"]["updateClientAfterCellToggle"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["updateClientAfterCellToggle"]++; }; 
	/** @type { enum-value}*/
	var sSashPosition = this["sGetSashPositionAfterCellToggle"]();
	/** @type {Object} */
	var oAccessed = this["oGetSashData"]();
	/** @type {Object} */
	var oDocked = this["oGetDockedSashData"](sSashPosition);
	/** @type {Object} */
	var oFreed = this["oGetFreedSashData"](sSashPosition);
	/** @type {Object} */
	var oSqueezed = this["oGetSqueezedSashData"](sSashPosition);
	/** @type {Object} */
	var oData = {};

	oData["sashPosition"] = sSashPosition;
	oData["accessed"] = oAccessed;
	oData["docked"] = oDocked;
	oData["freed"] = oFreed;
	oData["squeezed"] = oSqueezed;

	this["updateGridDimensionsInDom"]();
	this["updateGridDataAfterAnyAction"](sSashPosition);
	this["updateNeighbourhoodAfterToggle"](oData);
	this["updateSashStylesAfterAnyAction"](oData);
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["updateClientAfterCellToggle"] = 0; };

/**
 * @private
 * @param {Object} oData
 */
// eslint-disable-next-line
UCF_SplitterGridCell["prototype"]["updateNeighbourhoodAfterToggle"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["updateNeighbourhoodAfterToggle"]++; }; 
	/** @type {Object} */
	var oAccessed = oData["accessed"];
	/** @type {Object} */
	var oDocked = oData["docked"];
	/** @type {Object} */
	var oFreed = oData["freed"];
	/** @type {Object} */
	var oSqueezed = oData["squeezed"];
	/** @type {Object} */
	var oDependentBefore;
	/** @type {Object} */
	var oDependentAfter;
	/** @type { enum-value}*/
	var sSashPosition = oData["sashPosition"];

	if (oSqueezed) {
		oSqueezed["dockedto"] = this["eNeighbourhood"]["BOTH"];
		// oSqueezed.returntosizeof = oSqueezed.toggledirection;
		oSqueezed["toggledirection"] = oSqueezed["toggledirection"];
	}

	//oDependentBefore = this.oGetUpdatedDependentBeforeAction(oAccessed, sSashPosition);

	if (sSashPosition["indexOf"]('MIN') > -1) {
		oAccessed = this["oGetUpdatedAccessedAtMinPosition"](oAccessed, sSashPosition);
		oDocked = this["oGetUpdatedDockedAtMinPosition"](oDocked, sSashPosition);
		oFreed = this["oGetUpdatedFreedAtMinPosition"](oFreed, sSashPosition);
	}
	else if (sSashPosition["indexOf"]('MAX') > -1) {
		oAccessed = this["oGetUpdatedAccessedAtMaxPosition"](oAccessed, sSashPosition);
		oDocked = this["oGetUpdatedDockedAtMaxPosition"](oDocked, sSashPosition);
		oFreed = this["oGetUpdatedFreedAtMaxPosition"](oFreed, sSashPosition);
	}

	// oDependentAfter = this.oGetUpdatedDependentAfterAction(oAccessed, sSashPosition);

	this["setNeigbourhoodForNextToggling"](
		[oAccessed,
		 oDocked,
		 oFreed,
		 oSqueezed,
		 oDependentBefore,
		 oDependentAfter]);
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["updateNeighbourhoodAfterToggle"] = 0; };

/**
 * @private
 * @param {Object} oAccessed
 * @param {enum-value} sSashPosition
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetUpdatedAccessedAtMaxPosition"] = function(oAccessed, sSashPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedAccessedAtMaxPosition"]++; }; 
	/** @type { enum-list }*/
	var eSashPosition = this["eSashPosition"];
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];
	/** @type { boolean }*/
	var bIsLast = this["bIsLastSash"](oAccessed["id"]);

	oAccessed["toggledirection"] = eNeighbour["PREVIOUS"];

	// both cells expanded
	if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MAX_AT_BOUNDS_OF_PREVIOUS"]) {
			// oAccessed.returntosizeof = eNeighbour.PREVIOUS;
			oAccessed["cellsowned"] = eNeighbour["BOTH"];
			oAccessed["dockedto"] = eNeighbour["NONE"];
	}
	// expanded and collapsed owns both cells
	else if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MAX_RETURN_TO_NEXT"]) {
			// oAccessed.returntosizeof = eNeighbour.NEXT;
			oAccessed["cellsowned"] = eNeighbour["BOTH"];
			oAccessed["dockedto"] = (bIsLast) ? eNeighbour["NONE"] : eNeighbour["NEXT"];
	}
	// expanded and collapsed owns one cell
	else if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MAX_ONLY_PREVIOUS"]) {
		// oAccessed.returntosizeof = eNeighbour.PREVIOUS;
		oAccessed["cellsowned"] = oAccessed["cellsowned"];
		oAccessed["dockedto"] = eNeighbour["NONE"];
	}
	else if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MAX"]) {
		oAccessed["dockedto"] = (bIsLast) ? eNeighbour["NONE"] : eNeighbour["NEXT"];
	}
	else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'sSashPosition: ' + sSashPosition, "SplitterGridCell.js(1015): oGetUpdatedAccessedAtMaxPosition"); };
	}
	return oAccessed;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedAccessedAtMaxPosition"] = 0; };

/**
 * @private
 * @param {Object} oAccessed
 * @param {enum-value} sSashPosition
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetUpdatedAccessedAtMinPosition"] = function(oAccessed, sSashPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedAccessedAtMinPosition"]++; }; 
	/** @type { enum-list }*/
	var eSashPosition = this["eSashPosition"];
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];
	/** @type { boolean }*/
	var bIsFirst = this["bIsFirstSash"](oAccessed["id"]);

	oAccessed["toggledirection"] = eNeighbour["NEXT"];

	// expanded and expanded
	if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MIN_AT_BOUNDS_OF_NEXT"]) {
		// oAccessed.returntosizeof = eNeighbour.NEXT;
		oAccessed["cellsowned"] = eNeighbour["BOTH"];
		oAccessed["dockedto"] = eNeighbour["NONE"];
	}
	// collapsed and expanded
	else if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MIN_RETURN_TO_PREVIOUS"]) {
		// oAccessed.returntosizeof = eNeighbour.PREVIOUS;
		oAccessed["cellsowned"] = eNeighbour["BOTH"];
		oAccessed["dockedto"] = (bIsFirst) ? eNeighbour["NONE"] : eNeighbour["PREVIOUS"];
	}
	// collapsed and expanded
	else if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MIN_ONLY_NEXT"]) {
		// oAccessed.returntosizeof = eNeighbour.NEXT;
		oAccessed["cellsowned"] = oAccessed["cellsowned"];
		oAccessed["dockedto"] = eNeighbour["NONE"];
	}
	// collapsed and expanded
	else if (sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MIN"]) {
		oAccessed["dockedto"] = (bIsFirst) ? eNeighbour["NONE"] : eNeighbour["PREVIOUS"]; //eNeighbour.NEXT;
	}
	else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'sSashPosition: ' + sSashPosition, "SplitterGridCell.js(1059): oGetUpdatedAccessedAtMinPosition"); };
	}

	return oAccessed;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedAccessedAtMinPosition"] = 0; };

/**
 * @private
 * @param { Object } oDocked
 * @param {enum-value} sSashPosition
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetUpdatedDockedAtMaxPosition"] = function(oDocked, sSashPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedDockedAtMaxPosition"]++; }; 
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];

	if (oDocked) {
		oDocked["dockedto"] = eNeighbour["PREVIOUS"];
		oDocked["toggledirection"] = oDocked["toggledirection"];

		if (oDocked["returntosizeof"] !== eNeighbour["BOTH"]) {
			oDocked["returntosizeof"] = eNeighbour["BOTH"];
			oDocked["cellsowned"] = eNeighbour["BOTH"];
		} else {
			oDocked["returntosizeof"] = oDocked["returntosizeof"];
			oDocked["cellsowned"] = oDocked["cellsowned"];
		}
	}
	return oDocked;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedDockedAtMaxPosition"] = 0; };

/**
 * @private
 * @param { Object } oDocked
 * @param {enum-value} sSashPosition
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetUpdatedDockedAtMinPosition"] = function(oDocked, sSashPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedDockedAtMinPosition"]++; }; 
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];

	if (oDocked) {
		oDocked["dockedto"] = eNeighbour["NEXT"];
		oDocked["toggledirection"] = oDocked["toggledirection"];
		oDocked["returntosizeof"] = eNeighbour["ONLY_PREVIOUS_AVAILABLE"];
		oDocked["cellsowned"] = eNeighbour["PREVIOUS"];
	}
	return oDocked;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedDockedAtMinPosition"] = 0; };

/**
 * @private
 * @param { Object } oFreed
 * @param {enum-value} sSashPosition
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetUpdatedFreedAtMaxPosition"] = function(oFreed, sSashPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedFreedAtMaxPosition"]++; }; 
	/** @type { enum-list }*/
	var eCellPairStates = this["eCellPairStates"];
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];
	/** @type { enum-list }*/
	var sCellStatesAfterToggle;

	if (oFreed) {
		sCellStatesAfterToggle = this["sGetAdjucentCellStatesAfterAction"](oFreed);

		if (sCellStatesAfterToggle === eCellPairStates["EXPANDED_AND_EXPANDED"]) {
			oFreed["dockedto"] = eNeighbour["NONE"];
			// oFreed.returntosizeof = oFreed.toggledirection;
			// oFreed.toggledirection = oFreed.toggledirection;
			oFreed["cellsowned"] = eNeighbour["BOTH"];
		}
		else if (sCellStatesAfterToggle === eCellPairStates["COLLAPSED_AND_EXPANDED"]) {
			oFreed["dockedto"] = eNeighbour["NEXT"];
			// oFreed.returntosizeof = eNeighbour.ONLY_NEXT_AVAILABLE;
			oFreed["toggledirection"] = eNeighbour["NEXT"];
			oFreed["cellsowned"] = eNeighbour["NEXT"];
		}
	}
	return oFreed;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedFreedAtMaxPosition"] = 0; };

/**
 * @private
 * @param { Object } oFreed
 * @param {enum-value} sSashPosition
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetUpdatedFreedAtMinPosition"] = function(oFreed, sSashPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedFreedAtMinPosition"]++; }; 
	/** @type { enum-list }*/
	var eCellPairStates = this["eCellPairStates"];
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];
	/** @type { enum-list }*/
	var sCellStatesAfterToggle;

	if (oFreed) {
		sCellStatesAfterToggle = this["sGetAdjucentCellStatesAfterAction"](oFreed);

		if (sCellStatesAfterToggle === eCellPairStates["EXPANDED_AND_EXPANDED"]) {
			oFreed["dockedto"] = eNeighbour["NONE"];
			// oFreed.returntosizeof = oFreed.toggledirection;
			oFreed["toggledirection"] = oFreed["toggledirection"];
			oFreed["cellsowned"] = eNeighbour["BOTH"];
		}
		else if (sCellStatesAfterToggle === eCellPairStates["COLLAPSED_AND_EXPANDED"]) {
			oFreed["dockedto"] = eNeighbour["NEXT"];
			// oFreed.returntosizeof = eNeighbour.ONLY_NEXT_AVAILABLE;
			oFreed["toggledirection"] = eNeighbour["NEXT"];
			oFreed["cellsowned"] = eNeighbour["NEXT"];
		}
	}

	return oFreed;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedFreedAtMinPosition"] = 0; };

/**
 * @private
 * @param {Object} oAccessed
 * @param {enum-value} sSashPosition
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetUpdatedDependentBeforeAction"] = function(oAccessed, sSashPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedDependentBeforeAction"]++; }; 
	/** @type {Object}*/
	var oDependent = this["oGetDependentSashData"](oAccessed, sSashPosition);
	/** @type { enum-list }*/
	var eNeighbour;
	/** @type { enum-list }*/
	var eCellPairStates;
	/** @type { enum-value}*/
	var sCellPairStates;

	if (oDependent && this["bDependent"](oAccessed, oDependent)) {
		eNeighbour = this["eNeighbourhood"];
		eCellPairStates = this["eCellPairStates"];
		sCellPairStates = this["sGetAdjucentCellStatesBeforeAction"](oDependent);

		if (sCellPairStates === eCellPairStates["COLLAPSED_AND_EXPANDED"]) {
			oDependent["returntosizeof"] = eNeighbour["ONLY_NEXT_AVAILABLE"];
			oDependent["cellsowned"] = eNeighbour["NEXT"];
		}
		else if (sCellPairStates === eCellPairStates["EXPANDED_AND_COLLAPSED"]) {
			oDependent["returntosizeof"] = eNeighbour["ONLY_PREVIOUS_AVAILABLE"];
			oDependent["cellsowned"] = eNeighbour["PREVIOUS"];
		}
	}

	return oDependent;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedDependentBeforeAction"] = 0; };

/**
 * @private
 * @param {Object} oAccessed
 * @param {enum-value} sSashPosition
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetUpdatedDependentAfterAction"] = function(oAccessed, sSashPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedDependentAfterAction"]++; }; 
	/** @type {Object}*/
	var oDependent = this["oGetDependentSashData"](oAccessed, sSashPosition);
	/** @type { enum-list }*/
	var eNeighbour;

	if (oDependent) {
		eNeighbour = this["eNeighbourhood"];

		if (oAccessed["returntosizeof"] === eNeighbour["PREVIOUS"]) {
			oDependent["returntosizeof"] = eNeighbour["PLACE_BEFORE_BOTH_RESPECT_PREVIOUS"];
		}
		else if (oAccessed["returntosizeof"] === eNeighbour["NEXT"]) {
			oDependent["returntosizeof"] = eNeighbour["PLACE_BEFORE_BOTH_RESPECT_NEXT"];
		}
	}
	return oDependent;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetUpdatedDependentAfterAction"] = 0; };


/**
 * @private
 * @return {enum-value}
 */
UCF_SplitterGridCell["prototype"]["sGetSashPositionAfterCellToggle"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetSashPositionAfterCellToggle"]++; }; 
	/** @type {enum-value} */
	var sResult;
	/** @type {Object} */
	var oSashData = this["oGetSashData"]();
	/** @type { enum-list }*/
	var eNeighbour = this["eNeighbourhood"];
	/** @type { enum-list }*/
	var eCellPairStates = this["eCellPairStates"];
	/** @type { enum-list }*/
	var eSashPosition = this["eSashPosition"];
	/** @type {enum-value} */
	var sStatesBeforeToggle = this["sGetAdjucentCellStatesBeforeAction"](oSashData);
	/** @type {enum-value} */
	var sToggleDirection = this["sGetToggleDirection"]();
	/** @type {enum-value} */
	var sReturnToSize = oSashData["returntosizeof"];

	if (
		sStatesBeforeToggle === eCellPairStates["EXPANDED_AND_EXPANDED"] &&
		sToggleDirection === eNeighbour["PREVIOUS"]
		) {
		sResult = eSashPosition["OWN_TOGGLE_POSITION_MIN_RETURN_TO_PREVIOUS"];
	}
	else if (
		sStatesBeforeToggle === eCellPairStates["EXPANDED_AND_EXPANDED"] &&
		sToggleDirection === eNeighbour["NEXT"]
		) {
		sResult = eSashPosition["OWN_TOGGLE_POSITION_MAX_RETURN_TO_NEXT"];
	}
	else if (
		sStatesBeforeToggle === eCellPairStates["EXPANDED_AND_COLLAPSED"] &&
		sToggleDirection === eNeighbour["PREVIOUS"] &&
		sReturnToSize === eNeighbour["NEXT"]
	) {
		sResult = eSashPosition["OWN_TOGGLE_POSITION_MIN_AT_BOUNDS_OF_NEXT"];
	}
	else if (
		sStatesBeforeToggle === eCellPairStates["EXPANDED_AND_COLLAPSED"] &&
		sToggleDirection === eNeighbour["PREVIOUS"] &&
		sReturnToSize === eNeighbour["PLACE_BEFORE_BOTH_RESPECT_PREVIOUS"]
	) {
		sResult = eSashPosition["OWN_TOGGLE_POSITION_MIN_ONLY_NEXT"];
	}
	else if (
		sStatesBeforeToggle === eCellPairStates["COLLAPSED_AND_EXPANDED"] &&
		sToggleDirection === eNeighbour["NEXT"] &&
		sReturnToSize === eNeighbour["PREVIOUS"]
	) {
		sResult = eSashPosition["OWN_TOGGLE_POSITION_MAX_AT_BOUNDS_OF_PREVIOUS"];
	}
	else if (
		sStatesBeforeToggle === eCellPairStates["COLLAPSED_AND_EXPANDED"] &&
		sToggleDirection === eNeighbour["NEXT"] &&
		sReturnToSize === eNeighbour["PLACE_BEFORE_BOTH_RESPECT_NEXT"]
	) {
		sResult = eSashPosition["OWN_TOGGLE_POSITION_MAX_OMIT_PREVIOUS"];
	}
	else if (
		sStatesBeforeToggle === eCellPairStates["COLLAPSED_AND_COLLAPSED"] &&
		sToggleDirection === eNeighbour["NEXT"]
		) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MAX"];
	}
	else if (
		sStatesBeforeToggle === eCellPairStates["COLLAPSED_AND_COLLAPSED"] &&
		sToggleDirection === eNeighbour["PREVIOUS"]
		) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MIN"];
	}
	else {
		if (sStatesBeforeToggle === eCellPairStates["EXPANDED_AND_COLLAPSED"]) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MIN"];
		}
		else if (sStatesBeforeToggle === eCellPairStates["COLLAPSED_AND_EXPANDED"]) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MAX"];
		}
		else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING,
			'sStatesBeforeToggle: ' + sStatesBeforeToggle +
			'sToggleDirection: ' + sToggleDirection +
			'sReturnToSize: ' + sReturnToSize, "SplitterGridCell.js(1318): sGetSashPositionAfterCellToggle"
			); };
		}
	}
	return sResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["sGetSashPositionAfterCellToggle"] = 0; };

/**
 * @private
 */
UCF_SplitterGridCell["prototype"]["determineDataAfterCellToggle"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["determineDataAfterCellToggle"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oElements = this["oGetCellActionElements"]();
	/** @type {Object} */
	var oToBeExpanded = oElements["toBeExpanded"];
	/** @type {Object} */
	var oToBeCollapsed = oElements["toBeCollapsed"];
	/** @type {Object} */
	var oSizeAndUnitPairs = this["oGetCellActionSizeAndUnitPair"]();
	/** @type {Object} */
	var oExpandedSizeAndUnitPair = oSizeAndUnitPairs["ToBeExpanded"];
	/** @type {Object} */
	var oCollapsedSizeAndUnitPair = oSizeAndUnitPairs["ToBeCollapsed"];
	/** @type {Object} */
	var oCellCoordinates = this["oGetCellCoordinates"]();
	/** @type {Object} */
	var oDeltaToDimensions = this["oAssignDeltaToDimensions"](oExpandedSizeAndUnitPair);
	/** @type {Object} */
	var oCellFields = this["oGetCellActionMap"]();

	/** style data */
	oResult["elementToDecrease"] = oToBeCollapsed["id"];
	oResult["elementToIncrease"] = oToBeExpanded["id"];
	oResult["decreasedSizeForStyles"] = oCollapsedSizeAndUnitPair["size"];
	oResult["decreasedUnitForStyles"] = oCollapsedSizeAndUnitPair["unit"];
	oResult["increasedSizeForStyles"] = oExpandedSizeAndUnitPair["size"];
	oResult["increasedUnitForStyles"] = oExpandedSizeAndUnitPair["unit"];

	/** Event data.*/
	oResult["heightDelta"] = oDeltaToDimensions["heightDelta"];
	oResult["widthDelta"] = oDeltaToDimensions["widthDelta"];
	oResult["increasedSizeForEvent"] = oCollapsedSizeAndUnitPair["eventData"];
	oResult["decreasedSizeForEvent"] = oExpandedSizeAndUnitPair["eventData"];
	oResult[oCellFields["increased"]] = oExpandedSizeAndUnitPair["eventData"];
	oResult[oCellFields["decreased"]] = oCollapsedSizeAndUnitPair["eventData"];
	oResult["originalSize"] = oElements["originalSize"];
	oResult["coordIncreased"] = oCellCoordinates["increased"];
	oResult["coordDecreased"] = oCellCoordinates["decreased"];
	oResult["coordNext"] = oCellCoordinates["next"];
	oResult["coordPrevious"] = oCellCoordinates["previous"];

	/** data for oGridata upgrade*/
	oResult[oResult["elementToDecrease"]] = oCollapsedSizeAndUnitPair;
	oResult[oResult["elementToIncrease"]] = oExpandedSizeAndUnitPair;

	this["oAfterActionData"] = oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["determineDataAfterCellToggle"] = 0; };


/**
 * There are always two cells affected by the
 * expand / collapse action: An increasing cell and a
 * decreasing cell - independant of the expand / collapse action
 *
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetIncreasedSizesAfterCellAction"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetIncreasedSizesAfterCellAction"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oElements = this["oGetCellActionElements"]();
	/** @type {Object} */
	var oToBeExpanded = oElements["toBeExpanded"];
	/** @type {Object} */
	var oToBeCollapsed = oElements["toBeCollapsed"];
	/** @type {enum-list} */
	var eExpandBehaviour = this["eToggleBehaviour"];
	/** @type {enum-value} */
	var sExpandBehaviour = this["sGetExpandBehaviour"]();

	if (sExpandBehaviour === eExpandBehaviour["EXPAND_TO_SIZE_OF_BOTH"]) {
		oResult["fraction"] = 1;
		oResult["pixel"] = oToBeExpanded["sizeinpixel"] + oToBeCollapsed["sizeinpixel"];
		oResult["percent"] = oToBeExpanded["sizeinpercent"] + oToBeCollapsed["sizeinpercent"];
	}
	else if (sExpandBehaviour === eExpandBehaviour["EXPAND_TO_OWN_EXPANDED_SIZE"]) {
		oResult["fraction"] = 1;
		oResult["pixel"] = oToBeExpanded["expandedsizeinpixel"];
		oResult["percent"] = oToBeExpanded["expandedsizeinpercent"];
	}
	else if (sExpandBehaviour === eExpandBehaviour["EXPAND_TO_SIZE_OF_CURRENTLY_EXPANDED"]) {
		oResult["fraction"] = 1;
		oResult["pixel"] = oToBeCollapsed["sizeinpixel"];
		oResult["percent"] = oToBeCollapsed["sizeinpercent"];
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetIncreasedSizesAfterCellAction"] = 0; };

/**
 * There are always two cells affected by the
 * expand / collapse action: An increasing cell and a
 * decreasing cell - independant of the expand / collapse action
 *
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetDecreasedSizesAfterCellAction"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetDecreasedSizesAfterCellAction"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oElements = this["oGetCellActionElements"]();
	/** @type {Object} */
	var oToBeCollapsed = oElements["toBeCollapsed"];
	/** @type {Object} */
	var oToBeExpanded = oElements["toBeExpanded"];
	/** @type {enum-list} */
	var eCollapseBehaviour = this["eToggleBehaviour"];
	/** @type {enum-value} */
	var sCollapseBehaviour = this["sGetCollapseBehaviour"]();

	if (sCollapseBehaviour === eCollapseBehaviour["COLLAPSE_TO_ZERO"]) {
		oResult["pixel"] = 0;
		oResult["percent"] = 0;
		oResult["fraction"] = 0;
	}
	else {
		oResult["pixel"] = oToBeCollapsed["sizeinpixel"] - oToBeExpanded["expandedsizeinpixel"];
		oResult["percent"] = oToBeCollapsed["sizeinpercent"] - oToBeExpanded["expandedsizeinpercent"];
		oResult["fraction"] = 1;
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetDecreasedSizesAfterCellAction"] = 0; };

/**
 * The collapse action comprises two containers. One is to be collapsed to zero
 * and a second ist to be expanded by the size of the collapsed
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetCellActionSizeAndUnitPair"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCellActionSizeAndUnitPair"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var ActionData = this["oGetCellActionElements"]();
	/** @type {Object} */
	var oToBeExpanded = ActionData["toBeExpanded"];
	/** @type {Object} */
	var oToBeCollapsed = ActionData["toBeCollapsed"];
	/** @type {Object} */
	var oDecreasedSizes = this["oGetDecreasedSizesAfterCellAction"]();
	/** @type {Object} */
	var oIncreasedSizes = this["oGetIncreasedSizesAfterCellAction"]();
	/** @type {enum-list} */
	var eUnits = this["eUnits"];
	/** @type {string} */
	var sExpandUnit = oToBeExpanded["unit"];
	/** @type {string} */
	var sCollapseUnit = oToBeCollapsed["unit"];

	/** keep the primal expanded sizes as defined in the API */
	oResult["ToBeCollapsed"] = {};
	oResult["ToBeCollapsed"]["sizeinpixel"] = oDecreasedSizes["pixel"];
	oResult["ToBeCollapsed"]["sizeinpercent"] = oDecreasedSizes["percent"];
	oResult["ToBeCollapsed"]["expandedsize"] = oToBeCollapsed["expandedsize"];
	oResult["ToBeCollapsed"]["expandedsizeinpixel"] = oToBeCollapsed["expandedsizeinpixel"];
	oResult["ToBeCollapsed"]["expandedsizeinpercent"] = oToBeCollapsed["expandedsizeinpercent"];
	oResult["ToBeCollapsed"]["unit"] = sCollapseUnit;
	oResult["ToBeCollapsed"]["pixel"] = oDecreasedSizes["pixel"];
	oResult["ToBeCollapsed"]["percent"] = oDecreasedSizes["percent"];

	/** assign values with regards to their unit */
	switch (sCollapseUnit) {
		case eUnits["PIXEL"]:
			oResult["ToBeCollapsed"]["size"] = oDecreasedSizes["pixel"];
			oResult["ToBeCollapsed"]["eventData"] = oDecreasedSizes["pixel"];
			break;
		case eUnits["PERCENTAGE"]:
			oResult["ToBeCollapsed"]["size"] = oDecreasedSizes["percent"];
			oResult["ToBeCollapsed"]["eventData"] = oDecreasedSizes["percent"];
			break;
		case eUnits["FRACTION"]:
			oResult["ToBeCollapsed"]["size"] = oDecreasedSizes["fraction"];
			oResult["ToBeCollapsed"]["eventData"] = oDecreasedSizes["percent"];
	}

	/** keep the primal expanded sizes as defined in the API */
	oResult["ToBeExpanded"] = {};
	oResult["ToBeExpanded"]["sizeinpixel"] = oIncreasedSizes["pixel"];
	oResult["ToBeExpanded"]["sizeinpercent"] = oIncreasedSizes["percent"];
	oResult["ToBeExpanded"]["expandedsize"] = oToBeExpanded["expandedsize"];
	oResult["ToBeExpanded"]["expandedsizeinpixel"] = oToBeExpanded["expandedsizeinpixel"];
	oResult["ToBeExpanded"]["expandedsizeinpercent"] = oToBeExpanded["expandedsizeinpercent"];
	oResult["ToBeExpanded"]["unit"] = oToBeExpanded["unit"];
	oResult["ToBeExpanded"]["pixel"] = oIncreasedSizes["pixel"];
	oResult["ToBeExpanded"]["percent"] = oIncreasedSizes["percent"];

	/** assign values with regards to their unit */
	switch (sExpandUnit) {
		case eUnits["PIXEL"]:
			oResult["ToBeExpanded"]["size"] = oIncreasedSizes["pixel"];
			oResult["ToBeExpanded"]["eventData"] = oIncreasedSizes["pixel"];
			break;
		case eUnits["PERCENTAGE"]:
			oResult["ToBeExpanded"]["size"] = oIncreasedSizes["percent"];
			oResult["ToBeExpanded"]["eventData"] = oIncreasedSizes["percent"];
			break;
		case eUnits["FRACTION"]:
			oResult["ToBeExpanded"]["size"] = 1;
			oResult["ToBeExpanded"]["eventData"] = oIncreasedSizes["percent"];
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCellActionSizeAndUnitPair"] = 0; };

/**
 * ´puts a block-layer over all cells that surround a sash
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_SplitterGridCell["prototype"]["lockCells"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["lockCells"]++; }; 
	/** @type {int} */
	var i;
	/** @type {HTML_Element} */
	var oCell;
	/** @type {HTML_Element} */
	var oBlockLayer;
	/** @type {string} */
	var sId;
	/** @type {enum-list} */
	var eStyles = this["eStyles"];
	/** @type {Array} */
	var aIdSet;

	if (oBrowserEvent["sName"] === 'mousedown') {
		aIdSet = this["aGetCellsSurroundingSash"]();

		if (aIdSet === null) return;

		this["oDomRef"]["style"]["position"] = 'relative';

		for (i = 0; i < aIdSet["length"]; i++) {
			sId = aIdSet[i];
			oCell = UCF_DomUtil["$"](sId);
			oBlockLayer = UCF_DomUtil["$"](sId + '-blockLayer');
			UCF_DomUtil["addClass"](oBlockLayer, eStyles["BLOCKlAYER_VISIBLE"]);
			UCF_DomUtil["addClass"](oCell, eStyles["CELL_LOCKED"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["lockCells"] = 0; };

/**
 * removes the block-layer from the cells
 * @private
 */
UCF_SplitterGridCell["prototype"]["unlockCells"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["unlockCells"]++; }; 
	/** @type {int} */
	var i;
	/** @type {HTML_Element} */
	var oCell;
	/** @type {HTML_Element} */
	var oBlockLayer;
	/** @type {string} */
	var sId;
	/** @type {enum-list} */
	var eStyles = this["eStyles"];
	/** @type {Array} */
	var aIdSet;

	aIdSet = this["aGetCellsSurroundingSash"]();

	if (aIdSet === null) return;

	this["oDomRef"]["style"]["position"] = '';

	for (i = 0; i < aIdSet["length"]; i++) {
		sId = aIdSet[i];
		oCell = UCF_DomUtil["$"](sId);
		oBlockLayer = UCF_DomUtil["$"](sId + '-blockLayer');
		UCF_DomUtil["replaceClass"](oBlockLayer, eStyles["BLOCKlAYER_VISIBLE"], eStyles["BLOCKlAYER_HIDDEN"]);
		UCF_DomUtil["replaceClass"](oCell, eStyles["CELL_LOCKED"], eStyles["CELL_UNLOCKED"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["unlockCells"] = 0; };

/**
 * @private
 * @return {Object}
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SplitterGridCell["prototype"]["oGetCellActionMap"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCellActionMap"]++; }; 
	/** @type {Object} */
	var oCellActionMap = this["mCellActionMap"];
	/** @type {Object} */
	var oMapPart = null;
	/** @type {enum-value} */
	var sDirection;
	/** @type {enum-list} */
	var eNeighBour = this["eNeighbourhood"];
	/** @type {enum-list} */
	var eShiftType = this["eShiftType"];
	/** @type {enum-list} */
	var eAccessType = this["eAccessType"];
	/** @type {enum-value} */
	var sAccessType = this["sAccessType"];

	if (sAccessType === eAccessType["DRAGGING"]) {
		sDirection = this["sGetDragDirection"]();
	}
	else if (sAccessType === eAccessType["DELAYEDDOUBLECLICK"]) {
		sDirection = this["sGetCollapseDirection"]();
	}
	else if (sAccessType === eAccessType["KEYBOARD"]) {
		sDirection = this["sGetShiftType"](oBrowserEvent);
	}

	if (sDirection === eNeighBour["NEXT"] ||
			sDirection === eShiftType["STEP_TO_NEXT"] ||
			sDirection === eShiftType["MOVE_TO_END"]) {
		oMapPart = oCellActionMap["NEXT"];
	} else {
		oMapPart = oCellActionMap["PREVIOUS"];
	}

	return oMapPart;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCellActionMap"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_SplitterGridCell["prototype"]["oGetCellToggleDirections"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCellToggleDirections"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {enum-list} */
	var sToggleDirection = this["sGetToggleDirection"]();
	/** @type {enum-list} */
	var eNeighbour = this["eNeighbourhood"];

	if (sToggleDirection === eNeighbour["NEXT"]) {
		oResult["increase"] = eNeighbour["PREVIOUS"];
		oResult["decrease"] = eNeighbour["NEXT"];
	}
	else {
		oResult["increase"] = eNeighbour["NEXT"];
		oResult["decrease"] = eNeighbour["PREVIOUS"];
	}

	// var eSingleCellState = this.eSingleCellState;
	// /** @type {enum-list} */
	// var eNeighbour = this.eNeighbourhood;
	// /** @type {enum-value} */
	// var sCollapseDirection = this.sGetCollapseDirection();
	// /** @type {enum-value} */
	// var sExpandDirection = this.sGetExpandDirection();
	// /** @type {enum-value} */
	// var sCellState = this.sGetCellState();

	// if (sCellState === eSingleCellState.EXPANDED &&
	// 	sCollapseDirection === eNeighbour.PREVIOUS
	// ) {
	// 	oResult.increase = eNeighbour.NEXT;
	// 	oResult.decrease = eNeighbour.PREVIOUS;
	// } else if (
	// 	sCellState === eSingleCellState.EXPANDED &&
	// 	sCollapseDirection === eNeighbour.NEXT
	// ) {
	// 	oResult.increase = eNeighbour.PREVIOUS;
	// 	oResult.decrease = eNeighbour.NEXT;
	// } else if (
	// 	sCellState === eSingleCellState.COLLAPSED &&
	// 	sExpandDirection === eNeighbour.PREVIOUS
	// ) {
	// 	oResult.increase = eNeighbour.NEXT;
	// 	oResult.decrease = eNeighbour.PREVIOUS;
	// } else if (
	// 	sCellState === eSingleCellState.COLLAPSED &&
	// 	sExpandDirection === eNeighbour.NEXT
	// ) {
	// 	oResult.increase = eNeighbour.PREVIOUS;
	// 	oResult.decrease = eNeighbour.NEXT;
	// }

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_SplitterGridCell["_"]["oGetCellToggleDirections"] = 0; };

};
sap["ls"]["preload"]["UCF_SplitterRow"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * Use the SplitterRow {@link UCF_Control} to create a layout row in the
 * {@link UCF_Splitter} control.
 *
 * 
 * @version 1.0.0.0
 *
 * @see UCF_Control
 * @see UCF_Splitter
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SplitterRow(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterRow["_"]["UCF_SplitterRow"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterRow.js(24): UCF_SplitterRow"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterRow.js(25): UCF_SplitterRow"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterRow.js(26): UCF_SplitterRow"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);
	}
};window["UCF_SplitterRow"] = UCF_SplitterRow; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterRow"); UCF_SplitterRow["_"] = {UCF_SplitterRow: 0}; }; ;
UCF_SplitterRow["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_SplitterRow.prototype["sClassName"] = "UCF_SplitterRow";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_SplitterRow["prototype"]["aAttributeNames"] = ["iHeight","sSashType","sCollapseDirection","iExpandedHeight","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_SplitterRow["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_SplitterRow["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {number}
 */
UCF_SplitterRow["prototype"]["iHeight"] = -1;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterSashType}
 */
UCF_SplitterRow["prototype"]["sSashType"] = "RESIZABLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SplitterCollapseDirection}
 */
UCF_SplitterRow["prototype"]["sCollapseDirection"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_SplitterRow["prototype"]["iExpandedHeight"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_SplitterRow["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_SplitterRow["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterRow["_"]["setDefaultValues"]++; }; 
	this["iHeight"] = -1;
	this["sSashType"] = "RESIZABLE";
	this["sCollapseDirection"] = "NONE";
	this["iExpandedHeight"] = 0;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Height", -1, true);
		this["setClientProperty"]("SashType", "RESIZABLE", true);
		this["setClientProperty"]("CollapseDirection", "NONE", true);
		this["setClientProperty"]("ExpandedHeight", 0, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterRow["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_SplitterRow_ie6"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_SplitterRow */
/// <reference path="SplitterRow.js"/>

/**
 * Use the SplitterRow {@link UCF_Control} to create a layout row in the
 * {@link UCF_Splitter} control.
 *
 * 
 * @version 1.0.0.0
 *
 * @see UCF_Control
 * @see UCF_Splitter
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SplitterRow_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterRow_ie6["_"]["UCF_SplitterRow_ie6"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterRow_ie6.js(26): UCF_SplitterRow_ie6"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterRow_ie6.js(27): UCF_SplitterRow_ie6"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterRow_ie6.js(28): UCF_SplitterRow_ie6"); };

		UCF_SplitterRow["apply"](this, [oDomRef, oLS]);
	}
};window["UCF_SplitterRow_ie6"] = UCF_SplitterRow_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterRow_ie6"); UCF_SplitterRow_ie6["_"] = {UCF_SplitterRow_ie6: 0}; }; ;
UCF_SplitterRow_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterRow"))(); UCF_SplitterRow_ie6.prototype["sClassName"] = "UCF_SplitterRow_ie6";

};
sap["ls"]["preload"]["UCF_SplitterRow_standards"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_SplitterRow */
/// <reference path="SplitterRow.js"/>

/**
 * Use the SplitterRow {@link UCF_Control} to create a layout row in the
 * {@link UCF_Splitter} control.
 *
 * 
 * @version 1.0.0.0
 *
 * @see UCF_Control
 * @see UCF_Splitter
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SplitterRow_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterRow_standards["_"]["UCF_SplitterRow_standards"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterRow_standards.js(26): UCF_SplitterRow_standards"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterRow_standards.js(27): UCF_SplitterRow_standards"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterRow_standards.js(28): UCF_SplitterRow_standards"); };

		UCF_SplitterRow["apply"](this, [oDomRef, oLS]);
	}
};window["UCF_SplitterRow_standards"] = UCF_SplitterRow_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterRow_standards"); UCF_SplitterRow_standards["_"] = {UCF_SplitterRow_standards: 0}; }; ;
UCF_SplitterRow_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterRow"))(); UCF_SplitterRow_standards.prototype["sClassName"] = "UCF_SplitterRow_standards";

/**
 * Destructor
 * @private
 */
UCF_SplitterRow_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterRow_standards["_"]["destroy"]++; }; 
	UCF_SplitterRow.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SplitterRow_standards["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_SplitterSash"] = function() {/* global _assert, _trace, _measure, DEBUG, ERROR, START, STOP, WARNING, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_SplitterGridCell */
/// <reference path="./SplitterGridCell.js"/>
/* eslint quotes:0 */

/**
 * Use the SAP Splitter {@link UCF_Control} to construct a group of
 * {@link UCF_Control}s within an area, each of which is placed in a separate
 * cell. The {@link UCF_Splitter} control manages and displays the cells. You
 * can change the size of the cells using a sash. Enlarging one cell reduces
 * the size of the adjacent cell.
 *
 * 
 * @version 1.0.0.0
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_SplitterSash(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["UCF_SplitterSash"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "SplitterSash.js(44): UCF_SplitterSash"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "SplitterSash.js(45): UCF_SplitterSash"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "SplitterSash.js(46): UCF_SplitterSash"); };

	UCF_SplitterGridCell["apply"](this, [oDomRef, oLS]);
};window["UCF_SplitterSash"] = UCF_SplitterSash; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SplitterSash"); UCF_SplitterSash["_"] = {UCF_SplitterSash: 0}; }; ;
UCF_SplitterSash["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterGridCell"))(); UCF_SplitterSash.prototype["sClassName"] = "UCF_SplitterSash";

/**
 * ############################################################################
 *
 * SECTION WITH HELPER METHODS THAT RETURN DATA FROM oSashData
 *
 * ############################################################################
 */

/**
 * @private
 * @return { enum-value }
 */
UCF_SplitterSash["prototype"]["sGetToggleDirection"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetToggleDirection"]++; }; 
	return this["oSashData"]["toggledirection"];
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetToggleDirection"] = 0; };

/**
 * return the collapse direction of a sash and its associated grid parts
 * @private
 * @return { string }
 */
UCF_SplitterSash["prototype"]["sGetCollapseDirection"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetCollapseDirection"]++; }; 
	return this["oSashData"]["collapsedirection"];
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetCollapseDirection"] = 0; };

/**
 * return the expand direction of a sash and its associated grid parts
 * @private
 * @return { string }
 */
UCF_SplitterSash["prototype"]["sGetExpandDirection"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetExpandDirection"]++; }; 
	return this["oSashData"]["expanddirection"];
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetExpandDirection"] = 0; };

/**

 * @private
 * @return { string }
 */
UCF_SplitterSash["prototype"]["sGetInitialToggleDirection"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetInitialToggleDirection"]++; }; 
	return this["oSashData"]["collapsedirection"];
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetInitialToggleDirection"] = 0; };


/**
 * determins whether a sash has been accessed
 * @private
 * @return {boolean}
 */
UCF_SplitterSash["prototype"]["bIsSashAccessed"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bIsSashAccessed"]++; }; 
	return this["bSashAccessed"];
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bIsSashAccessed"] = 0; };

/**
 * determins whether a sash has been accessed
 * @private
 * @return {enum-value}
 */
UCF_SplitterSash["prototype"]["sGetSizeToReturnTo"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetSizeToReturnTo"]++; }; 
	return this["oSashData"]["returntosizeof"];
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetSizeToReturnTo"] = 0; };

/**
 *
 * @private
 * @return { Object }
 */
UCF_SplitterSash["prototype"]["oGetSashData"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetSashData"]++; }; 
	if (this["oSashData"]) {
		return this["oSashData"];
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'oSashdata not available', "SplitterSash.js(123): oGetSashData"); };
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetSashData"] = 0; };

/**
 *
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_SplitterSash["prototype"]["createSashData"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["createSashData"]++; }; 
	/** @type {HTML_Element} */
	var oDomRef = oBrowserEvent["oSource"];

	if (!this["oSashData"] || (this["oSashData"] &&
		oDomRef["getAttribute"]('id') !== this["oSashData"]["id"])) {
		this["oSash"] = oDomRef;
		this["oSashData"] = this["oGetDataSet"](oDomRef);
		this["oSashData"]["oDomRef"] = oDomRef;
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["createSashData"] = 0; };

/**
 * returns the rectangle of a sash. Either the one stored in this.oSashrect or,
 * if the variable is null, it creates it and returns it
 *  @private
 * @return {Object}
 */
UCF_SplitterSash["prototype"]["oGetSashRect"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetSashRect"]++; }; 
	/** @type {HTML_Element} */
	var oSash;
	/** @type {Object} */
	var oSashRect;

	if (this["oSashRect"]) {

		// _trace(INFO, '----------------oGetSashRect----------------------');
		// _trace(WARNING, 'SashRect: ' + this.oSashRect.toString);
		return this["oSashRect"];
	} else {
		oSash = this["oSash"];
		oSashRect = this["oGetClientRect"](oSash);
		this["oSashRect"] = oSashRect;
		return oSashRect;
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetSashRect"] = 0; };

/**
 * @private
 * @return { enum-value }
 */
UCF_SplitterSash["prototype"]["sGetSashType"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetSashType"]++; }; 
	return this["oSashData"]["sashtype"];
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetSashType"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_SplitterSash["prototype"]["sGetSashId"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetSashId"]++; }; 
	/** @type {Object} */
	var oSashData = this["oSashData"];

	return oSashData["accessedsash"];
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetSashId"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_SplitterSash["prototype"]["iGetNumberOfSashes"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["iGetNumberOfSashes"]++; }; 
	/** @type {string} */
	var sDragOrientation = this["sGetOrientation"]();
	/** @type {int} */
	var iNumber;

	if (sDragOrientation === this["eDragOrientation"]["HORIZONTAL"]) {
		iNumber = this["oDomRef"]["getAttribute"]('data-colsashes');
	} else {
		iNumber = this["oDomRef"]["getAttribute"]('data-rowsashes');
	}

	iNumber = parseInt(iNumber);
	return iNumber;
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["iGetNumberOfSashes"] = 0; };

/**
 * @private
 * @return {int}
 */
UCF_SplitterSash["prototype"]["iGetSashSize"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["iGetSashSize"]++; }; 
	/** @type {HTML} */
	var oSash = this["oSash"];
	/** @type {Object} */
	var oGridData;
	/** @type {Object} */
	var oRect;
	/** @type {string} */
	var sSashId;
	/** @type {string} */
	var n;

	if (!oSash) {
		this["createGridData"]();
		oGridData = this["oGridData"];
		for (n in oGridData["cols"]) {
			sSashId = n + '-sash';
			break;
		}
		oSash = UCF_DomUtil["$"](sSashId);
	}

	oRect = this["oGetClientRect"](oSash);

	return oRect["width"];
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["iGetSashSize"] = 0; };

/**
 * the sash data of the sash after the accessed
 * @private
 * @return {Object}
 */
UCF_SplitterSash["prototype"]["oGetNextSashData"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetNextSashData"]++; }; 
	/** @type {Object} */
	var oSashData = null;
	/** @type {string} */
	var sSashId = this["sGetGridPartId_succeedingSash"]();
	/** @type {HTML_Element} */
	var oSashDomRef;

	sSashId = sSashId + '-sash';

	if (this["bSashExists"](sSashId)) {
		oSashDomRef = UCF_DomUtil["$"](sSashId);
		oSashData = this["oGetDataSet"](oSashDomRef);
		oSashData["oDomRef"] = oSashDomRef;
		oSashData["id"] = sSashId;
		oSashData["position"] = 'NEXT';
	}

	return oSashData;
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetNextSashData"] = 0; };

/**
 * The sash data of the sash before the accessed
 * @private
 * @return {Object}
 */
UCF_SplitterSash["prototype"]["oGetPreviousSashData"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetPreviousSashData"]++; }; 
	/** @type {Object} */
	var oSashData = null;
	/** @type {HTML_Element} */
	var oSashDomRef;
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();
	/** @type {string} */
	var sAccessedSash = this["sGetGridPartId_attachedToSash"]();
	/** @type {string} */
	var sSashId;
	/** @type {string} */
	var n;

	for (n in oGridData) {
		if (n === sAccessedSash) {
			break;
		} else {
			sSashId = n;
		}
	}

	sSashId = sSashId + '-sash';

	if (this["bSashExists"](sSashId)) {
		oSashDomRef = UCF_DomUtil["$"](sSashId);
		oSashData = this["oGetDataSet"](oSashDomRef);;
		oSashData["oDomRef"] = oSashDomRef;
		oSashData["id"] = sSashId;
		oSashData["position"] = 'PREVIOUS';
	}

	return oSashData;
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetPreviousSashData"] = 0; };

/**
 * @private
 * @param {string} sId
 * @return {boolean}
 */
UCF_SplitterSash["prototype"]["bSashExists"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bSashExists"]++; }; 
	/** @type {HTML_Element} */
	var oCheck = UCF_DomUtil["$"](sId);
	return oCheck !== null && oCheck !== undefined;
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bSashExists"] = 0; };

/**
 * @private
 * @param {string} sId
 * @return {boolean}
 */
UCF_SplitterSash["prototype"]["bIsFirstSash"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bIsFirstSash"]++; }; 
	/** @type {Object} */
	var oGridata = this["oGetGridData"]();
	/** @type {string} */
	var sKey;
	/** @type {string} */
	var n;

	for (n in oGridata) {
		sKey = n + '-sash';
		break;
	}
	return sKey === sId;
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bIsFirstSash"] = 0; };

/**
 * @private
 * @param {string} sId
 * @return {boolean}
 */
UCF_SplitterSash["prototype"]["bIsLastSash"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bIsLastSash"]++; }; 
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();
	/** @type {string} */
	var sKey = '';
	/** @type {string} */
	var n;

	for (n in oGridData) {
		if (oGridData[n]["sash"]) {
			sKey = n + '-sash';
		}
	}
	return sKey === sId;
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bIsLastSash"] = 0; };

/**
 * ############################################################################
 *
 * SECTION WITH HELPER METHODS FOR STATES AND ACTIONS
 *
 * ############################################################################
 */


 /**
  * @private
  * @param {Object} oSash
  * @param {enum-value} sState
  */
 UCF_SplitterSash["prototype"]["setPrecedingState"] = function(oSash, sState) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setPrecedingState"]++; }; 
 	oSash["statepreceding"] = sState;
 	oSash["oDomRef"]["setAttribute"]('data-statepreceding', sState);
 };;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setPrecedingState"] = 0; };

 /**
  * @private
  * @param {Object} oSash
  * @param {enum-value} sState
  */
 UCF_SplitterSash["prototype"]["setSucceedingState"] = function(oSash, sState) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setSucceedingState"]++; }; 
 	oSash["statesucceeding"] = sState;
 	oSash["oDomRef"]["setAttribute"]('data-statesucceeding', sState);
 };;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setSucceedingState"] = 0; };

 /**
  * @private
  * @param {Object} oSash
  * @param {enum-value} sDirection
  */
 UCF_SplitterSash["prototype"]["setToggleDirection"] = function(oSash, sDirection) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setToggleDirection"]++; }; 
 	oSash["toggledirection"] = sDirection;
 	oSash["oDomRef"]["setAttribute"]('data-toggledirection', sDirection);
 };;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setToggleDirection"] = 0; };



 /**
  * @private
  * @param { Object } oData
  */
 UCF_SplitterSash["prototype"]["setToggleStatesOfAccessed"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setToggleStatesOfAccessed"]++; }; 
	/** @type {Object} */
	var oAccessed = oData["accessed"];
 	/** @type {enum-value} */
 	var sPreceding;
 	/** @type {enum-value} */
 	var sSucceeding;
 	/** @type {enum-value} */
 	var sToggleDirection = oData["accessedToggleDirection"];
	 /** @type {enum-value} */
	var sCellPairStates = this["sGetAdjucentCellStatesAfterAction"](oAccessed);

	sPreceding = sCellPairStates["split"]('_AND_')[0];
	sSucceeding = sCellPairStates["split"]('_AND_')[1];

 	this["setPrecedingState"](oAccessed, sPreceding);
 	this["setSucceedingState"](oAccessed, sSucceeding);
 	this["setToggleDirection"](oAccessed, sToggleDirection);
 };;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setToggleStatesOfAccessed"] = 0; };

 /**
  * @private
  * @param {Object} oData
  */
 UCF_SplitterSash["prototype"]["setToggleStatesOfFreed"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setToggleStatesOfFreed"]++; }; 
	/** @type {Object} */
	var oFreed = oData["freed"];
 	/** @type {enum-list} */
 	var eState = this["eSingleCellState"];
 	/** @type {enum-value} */
 	var sStatePrevious;
 	/** @type {enum-value} */
 	var sStateNext;
	/** @type {string} */
	var sPreceding = this["sGetKey_preceding_fromMap"]();
	/** @type {string} */
	var sSucceeding = this["sGetKey_succeeding_fromMap"]();

	if (this["bIsCollapsed"](oFreed[sPreceding])) {
		sStatePrevious = eState["COLLAPSED"];
	} else {
		sStatePrevious = eState["EXPANDED"];
	}

	if (this["bIsCollapsed"](oFreed[sSucceeding])) {
		sStateNext = eState["COLLAPSED"];
	} else {
		sStateNext = eState["EXPANDED"];
	}

 	this["setPrecedingState"](oFreed, sStatePrevious);
 	this["setSucceedingState"](oFreed, sStateNext);
 };;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setToggleStatesOfFreed"] = 0; };


 /**
  * @private
  * @param { Object } oData
  */
 UCF_SplitterSash["prototype"]["setToggleStatesOfDocked"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setToggleStatesOfDocked"]++; }; 
	/** @type {Object} */
	var oDocked = oData["docked"];
 	/** @type {enum-list} */
 	var eState = this["eSingleCellState"];
 	/** @type {enum-list} */
 	var eNeighbour = this["eNeighbourhood"];
 	/** @type {enum-value} */
 	var sPreceding;
 	/** @type {enum-value} */
 	var sSucceeding;
 	/** @type {enum-value} */
 	var sToggleDirection = oData["toggledirection"];

 	switch (oDocked["dockedto"]) {
 		case eNeighbour["NEXT"]:
 			sPreceding = eState["EXPANDED"];
 			sSucceeding = eState["COLLAPSED"];
 			break;
 		case eNeighbour["PREVIOUS"]:
 			sPreceding = eState["COLLAPSED"];
 			sSucceeding = eState["EXPANDED"];
 			break;
 	}

 	this["setPrecedingState"](oDocked, sPreceding);
 	this["setSucceedingState"](oDocked, sSucceeding);
 	this["setToggleDirection"](oDocked, sToggleDirection);
 };;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setToggleStatesOfDocked"] = 0; };

 /**
  * @private
  * @param { Object } oSqueezed
  */
 UCF_SplitterSash["prototype"]["setToggleStatesOfSqueezed"] = function(oSqueezed) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setToggleStatesOfSqueezed"]++; }; 
 	/** @type {enum-list} */
 	var eState = this["eSingleCellState"];

 	this["setPrecedingState"](oSqueezed, eState["COLLAPSED"]);
 	this["setSucceedingState"](oSqueezed, eState["COLLAPSED"]);
 	this["setToggleDirection"](oSqueezed, oSqueezed["toggledirection"]);
 };;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["setToggleStatesOfSqueezed"] = 0; };

 /**
  * @private
  * @param {enum-value} sSashPosition
  * @return {Object}
  */
 UCF_SplitterSash["prototype"]["oGetSqueezedSashData"] = function(sSashPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetSqueezedSashData"]++; }; 
 	/** @type {Object} */
 	var oSqueezed = null;
	 /** @type {Object} */
	// var oSashData = this.oGetSashData();
 	/** @type {Object} */
 	var oSashToCheck;
 	/** @type {enum-list} */
 	// var eNeighbour = this.eNeighbourhood;
 	/** @type {enum-list} */
 	var eSashPosition = this["eSashPosition"];
 	/** @type {enum-list} */
 	// var eAccessType = this.eAccessType;
 	/** @type {enum-list} */
 	var eState = this["eSingleCellState"];
 	/** @type {enum-list} */
 	// var sCellToggleDirection = this.sGetToggleDirection();
 	// /** @type {enum-value} */
 	// var sDragDirection = this.sGetDragDirection();
 	// /** @type {enum-value} */
 	// var sAccessType = this.sAccessType;
	//  /** @type {enum-value} */
	// var sReturnToSize = oSashData.returntosizeof;

	if (sSashPosition["indexOf"]('MAX') > - 1 &&
			sSashPosition !== eSashPosition["OWN_TOGGLE_POSITION_MAX_AT_BOUNDS_OF_PREVIOUS"]) {
				oSashToCheck = this["oGetNextSashData"]();
				if (oSashToCheck && oSashToCheck["statesucceeding"] === eState["COLLAPSED"]) {
					oSqueezed = oSashToCheck;
				}
	}
	else if (
		sSashPosition["indexOf"]('MIN') > -1 &&
		sSashPosition !== eSashPosition["OWN_TOGGLE_POSITION_MIN_AT_BOUNDS_OF_NEXT"]
	) {
 			oSashToCheck = this["oGetPreviousSashData"]();
 			if (oSashToCheck && oSashToCheck["statepreceding"] === eState["COLLAPSED"]) {
 				oSqueezed = oSashToCheck;
 			}
	}

 	// if (sSashPosition !== eSashPosition.NEW_DIMESNIONS_MIN &&
	// 		sSashPosition !== eSashPosition.NEW_DIMESNIONS_MAX) {


 	// 	if ((sAccessType === eAccessType.DELAYEDDOUBLECLICK &&
	// 			 sReturnToSize === eNeighbour.ONLY_NEXT_AVAILABLE &&
 	// 			 sCellToggleDirection === eNeighbour.NEXT)
	// 			||
	// 			(sAccessType === eAccessType.DRAGGING &&
	// 			 sDragDirection === eNeighbour.NEXT)) {

 	// 		oSashToCheck = this.oGetNextSashData();
 	// 		if (oSashToCheck && oSashToCheck.statesucceeding === eState.COLLAPSED) {
 	// 			oSqueezed = oSashToCheck;
 	// 		}

 	// 	} else if (
 	// 		(sAccessType === eAccessType.DELAYEDDOUBLECLICK &&
	// 		 sReturnToSize === eNeighbour.ONLY_PREVIOUS_AVAILABLE &&
 	// 		 sCellToggleDirection === eNeighbour.PREVIOUS)
	// 			||
 	// 		 (sAccessType === eAccessType.DRAGGING &&
 	// 			sDragDirection === eNeighbour.PREVIOUS)) {

 	// 		oSashToCheck = this.oGetPreviousSashData();
 	// 		if (oSashToCheck && oSashToCheck.statepreceding === eState.COLLAPSED) {
 	// 			oSqueezed = oSashToCheck;
 	// 		}
 	// 	}
 	// }

 	return oSqueezed;
 };;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetSqueezedSashData"] = 0; };

 /**
  * @private
  * @param {enum-value} sSashPosition
  * @return {Object}
  */
 UCF_SplitterSash["prototype"]["oGetDockedSashData"] = function(sSashPosition) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetDockedSashData"]++; }; 
 	/** @type {Object} */
 	var oDocked = null;
	 /** @type {Object} */
	var oSashToCheck = null;
	/** @type {enum-list} */
	var eState = this["eSingleCellState"];
 	/** @type {enum-list} */
 	var eSashPosition = this["eSashPosition"];
	/** @type {string} */
	var sIdAccessed = this["sGetSashId"]();

	if (!this["bIsLastSash"](sIdAccessed) &&
			(sSashPosition === eSashPosition["NEW_EXPAND_POSITION_MAX"] ||
			sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MAX"] ||
			sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MAX_RETURN_TO_NEXT"])) {

			oSashToCheck = this["oGetNextSashData"]();
			if (oSashToCheck && oSashToCheck["statesucceeding"] !== eState["COLLAPSED"]) {
				oDocked = oSashToCheck;
			}
	}
	else if (
		!this["bIsFirstSash"](sIdAccessed) &&
		(sSashPosition === eSashPosition["NEW_EXPAND_POSITION_MIN"] ||
		 sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MIN"] ||
		 sSashPosition === eSashPosition["OWN_TOGGLE_POSITION_MIN_RETURN_TO_PREVIOUS"])) {

			oSashToCheck = this["oGetPreviousSashData"]();
			if (oSashToCheck && oSashToCheck["statepreceding"] !== eState["COLLAPSED"]) {
				oDocked = oSashToCheck;
			}
	}

 	return oDocked;
 };;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetDockedSashData"] = 0; };

 /**
  * @private
  * @return {Object}
  */
 UCF_SplitterSash["prototype"]["oGetFreedSashData"] = function() {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetFreedSashData"]++; }; 
 	/** @type {Object} */
 	var oFreed = null;
 	/** @type {enum-list} */
 	var eNeighbour = this["eNeighbourhood"];
 	/** @type {enum-list} */
 	var eAccessType = this["eAccessType"];
 	/** @type {Object} */
 	var oSashToCheck;
 	/** @type {enum-value} */
 	var sDragDirection = this["sGetDragDirection"]();
 	/** @type {enum-value} */
 	var sCellToggleDirection = this["sGetToggleDirection"]();
 	/** @type {enum-value} */
 	var sAccessType = this["sAccessType"];

 	if ((sAccessType === eAccessType["DELAYEDDOUBLECLICK"] &&
 			sCellToggleDirection === eNeighbour["NEXT"]) ||
 		(sAccessType === eAccessType["DRAGGING"] &&
 			sDragDirection === eNeighbour["NEXT"])) {

 		oSashToCheck = this["oGetPreviousSashData"]();

 		if (oSashToCheck &&
 			(oSashToCheck["dockedto"] === eNeighbour["NEXT"] ||
 				oSashToCheck["dockedto"] === eNeighbour["BOTH"])) {

 			oFreed = oSashToCheck;
 		}

 	} else if (
 		(sAccessType === eAccessType["DELAYEDDOUBLECLICK"] &&
 			sCellToggleDirection === eNeighbour["PREVIOUS"]) ||
 		(sAccessType === eAccessType["DRAGGING"] &&
 			sDragDirection === eNeighbour["PREVIOUS"])
 	) {
 		oSashToCheck = this["oGetNextSashData"]();

 		if (oSashToCheck &&
 			(oSashToCheck["dockedto"] === eNeighbour["PREVIOUS"] ||
 				oSashToCheck["dockedto"] === eNeighbour["BOTH"])) {

 			oFreed = oSashToCheck;
 		}
 	}

 	return oFreed;
 };;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetFreedSashData"] = 0; };

/**
* @private
* @param {Object} oAccessed
* @return {Object}
*/
UCF_SplitterSash["prototype"]["oGetDependentSashData"] = function(oAccessed) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetDependentSashData"]++; }; 
	/** @type {Object} */
	var oPrevious;
	/** @type {Object} */
	var oNext;
	/** @type {Object} */
	var oDependent = null;

	oPrevious = this["oGetPreviousSashData"]();
	oNext = this["oGetNextSashData"]();

	if (oPrevious && this["bDependent"](oAccessed, oPrevious)) {
		oDependent = oPrevious;
	}
	else if (oNext && this["bDependent"](oAccessed, oNext)) {
		oDependent = oNext;
	}

	return oDependent;
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["oGetDependentSashData"] = 0; };

/**
 * @private
 * @param {Object} oAccessed
 * @param {Object} oDependent
 * @return {boolean}
 */
UCF_SplitterSash["prototype"]["bDependent"] = function(oAccessed, oDependent) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bDependent"]++; }; 
	/** @type {boolean} */
	var bDependent = false;
	/** @type {enum-list} */
	var eNeighbour = this["eNeighbourhood"];

	if (oDependent) {
		if ((parseInt(oAccessed["index"]) < parseInt(oDependent["index"]) &&
				oAccessed["toggledirection"] === eNeighbour["NEXT"] &&
				oDependent["toggledirection"] === eNeighbour["PREVIOUS"])
				||
			 (parseInt(oAccessed["index"]) > parseInt(oDependent["index"]) &&
				oAccessed["toggledirection"] === eNeighbour["PREVIOUS"] &&
				oDependent["toggledirection"] === eNeighbour["NEXT"])) {
					bDependent = true;
		}
	}

	return bDependent;
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bDependent"] = 0; };


/**
 * @private
 * @param {HTML_Element} oSash
 * @return {enum-value}
 */
UCF_SplitterSash["prototype"]["sGetSashPointingDirection"] = function(oSash) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetSashPointingDirection"]++; }; 
	/** @type {enum-list} */
	var eNeighbour = this["eNeighbourhood"];
	/** @type {enum-value} */
	var sDirection;
	/** @type {enum-list} */
	var eStyles = this["eStyles"];

	if (UCF_DomUtil["bHasClass"](oSash, eStyles["COLSASH_TO_PREVIOUS"]) ||
		UCF_DomUtil["bHasClass"](oSash, eStyles["ROWSASH_TO_PREVIOUS"])) {
		sDirection = eNeighbour["PREVIOUS"];

	} else if (
		UCF_DomUtil["bHasClass"](oSash, eStyles["COLSASH_TO_NEXT"]) ||
		UCF_DomUtil["bHasClass"](oSash, eStyles["ROWSASH_TO_NEXT"])
	) {
		sDirection = eNeighbour["NEXT"];
	}

	return sDirection;
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["sGetSashPointingDirection"] = 0; };

/**
 * styles of sashes need to be considered if ghost is at max or min position
 * of the drag area
 * @private
 * @param {Object} oData
 */
UCF_SplitterSash["prototype"]["updateSashStylesAfterAnyAction"] = function(oData) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["updateSashStylesAfterAnyAction"]++; }; 
	/** @type {Object} */
	var oAccessed = oData["accessed"];

	if (oAccessed["toggledirection"] !== this["sGetSashPointingDirection"](oAccessed["oDomRef"])) {
		this["updateSashStyles"](oAccessed["oDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["updateSashStylesAfterAnyAction"] = 0; };

/**
 * @private
 * @param {HTML_Element} oSash
 */
UCF_SplitterSash["prototype"]["updateSashStyles"] = function(oSash) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["updateSashStyles"]++; }; 
	/** @type {enum-list} */
	var eStyles = this["eStyles"];
	/** @type {string} */
	var sSashType = this["sGetGridType"](oSash);
	/** @type {string} */
	var sDirection = this["sGetToggleDirection"]();
	/** @type {string} */
	var sAction = sSashType + '_TO_' + sDirection;

	switch (sAction) {
		case 'ROWSASH_TO_PREVIOUS':
			UCF_DomUtil["replaceClass"](oSash, eStyles["ROWSASH_TO_NEXT"], eStyles[sAction]);
			break;

		case 'ROWSASH_TO_NEXT':
			UCF_DomUtil["replaceClass"](oSash, eStyles["ROWSASH_TO_PREVIOUS"], eStyles[sAction]);
			break;

		case 'COLSASH_TO_PREVIOUS':
			UCF_DomUtil["replaceClass"](oSash, eStyles["COLSASH_TO_NEXT"], eStyles[sAction]);
			break;

		case 'COLSASH_TO_NEXT':
			UCF_DomUtil["replaceClass"](oSash, eStyles["COLSASH_TO_PREVIOUS"], eStyles[sAction]);
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["updateSashStyles"] = 0; };


/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_SplitterSash["prototype"]["bSashWithinStartPaddingArea"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bSashWithinStartPaddingArea"]++; }; 
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {Object} */
	var oElements = this["oGetShiftedElements"](oBrowserEvent);
	/** @type {Object} */
	var oDecreased = oElements["toBeDecreased"];
	/** @type {Object} */
	var oRect = this["oGetClientRect"](UCF_DomUtil["$"](oDecreased["associatedcells"][0]));
	/** @type {string} */
	var sDomOrientation = this["sGet_domOrientation_fromMap"]();
	/** @type {int} */
	var iMax = oBounds["min"] + oBounds["paddingStart"];
	/** @type {int} */
	var iMin = oBounds["min"];
	/** @type {boolean} */
	var bWithinStartPaddingArea = (oBounds["paddingStart"] > 0 &&
		oRect[sDomOrientation] >= iMin &&
		oRect[sDomOrientation] <= iMax);

	return bWithinStartPaddingArea;
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bSashWithinStartPaddingArea"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {boolean}
 */
UCF_SplitterSash["prototype"]["bSashWithinEndPaddingArea"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bSashWithinEndPaddingArea"]++; }; 
	/** @type {Object} */
	var oBounds = this["oGetBounds"]();
	/** @type {Object} */
	var oElements = this["oGetShiftedElements"](oBrowserEvent);
	/** @type {Object} */
	var oDecreased = oElements["toBeDecreased"];
	/** @type {Object} */
	var oRect = this["oGetClientRect"](UCF_DomUtil["$"](oDecreased["associatedcells"][0]));
	/** @type {string} */
	var sDomOrientation = this["sGet_domOrientation_fromMap"]();
	/** @type {int} */
	var iMax = oBounds["min"] + oBounds["paddingEnd"];
	/** @type {int} */
	var iMin = oBounds["min"];
	/** @type {boolean} */
	var bWithinStartPaddingArea = (oBounds["paddingEnd"] > 0 &&
		oRect[sDomOrientation] >= iMin &&
		oRect[sDomOrientation] <= iMax);

	return bWithinStartPaddingArea;
};;if (__UCF_COVERAGE__) { UCF_SplitterSash["_"]["bSashWithinEndPaddingArea"] = 0; };


};
sap["ls"]["preload"]["UCF_Splitter_ie6"] = function() {/* global _assert, _trace, _measure, DEBUG, ERROR, START, STOP */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_Splitter */
/// <reference path="./Splitter.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* eslint quotes:0 */

/**
 * Use the SAP Splitter {@link UCF_Control} to construct a group of
 * {@link UCF_Control}s within an area, each of which is placed in a separate
 * cell. The {@link UCF_Splitter_ie6} control manages and displays the cells. You
 * can change the size of the cells using a sash. Enlarging one cell reduces
 * the size of the adjacent cell.
 *
 * 
 * @version 1.0.0.0
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Splitter_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["UCF_Splitter_ie6"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "Splitter_ie6.js(43): UCF_Splitter_ie6"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Splitter_ie6.js(44): UCF_Splitter_ie6"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Splitter_ie6.js(45): UCF_Splitter_ie6"); };

		UCF_Splitter["apply"](this, [oDomRef, oLS]);

		/** Defines the size at which drag & drop starts, see Drag & Drop core framework for more details
		 * @private */
		this["iDDThreshold"] = 0; //done to reduce D&D threshold

		this["createIframe"]();

	}
};window["UCF_Splitter_ie6"] = UCF_Splitter_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Splitter_ie6"); UCF_Splitter_ie6["_"] = {UCF_Splitter_ie6: 0}; }; ;
UCF_Splitter_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Splitter"))(); UCF_Splitter_ie6.prototype["sClassName"] = "UCF_Splitter_ie6";

UCF_Splitter_ie6["prototype"]["initialize"] = function () {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["initialize"]++; }; 
	if (UCF_DomUtil["bCheckStandardsCorrection"]()) {
		UCF_DomUtil["initHtmlTableCorrection"](this["oDomRef"]["firstChild"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["initialize"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_Splitter_ie6["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["destroy"]++; }; 
	if (this["sRefreshTimeout"]) UCF_JsUtil["clearDelayedCall"](this["sRefreshTimeout"]);

	this["releaseSash"]();
	/** the IFrame block layer (background shim)
	 * @private */
	this["oBackgroundShim"] = null;
	/** the background visualization of the moveable area
	 * @private */
	this["oBackgroundDomRef"] = null;
	/** the IFrame block layer for the dragged sash (shim for the dragged sash)
	 * @private */
	this["oSashShim"] = null;
	/** the visualization of the dragged sash
	 * @private */
	this["oSashDomRef"] = null;

	this["iPageX"] = 0;
	this["iPageY"] = 0;

	this["mSashRect"] = null;
	this["mSashInfo"] = null;
	this["mSplitterRect"] = null;
	this["oSource"] = null;

	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	this["sRefreshTimeout"] = null;

	UCF_Splitter.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["destroy"] = 0; };

/** Constants that reduces the D&D threshold
 * @private
 */
UCF_Splitter_ie6["prototype"]["iDDThreshold"] = 1;

//size of a scrollBar - splitter collapses to 1 px;
/** Constants of the minimal size at which the splitter collapses. This is almost the size of a scrollBar.
 * @private
 */
UCF_Splitter_ie6["iCollapseSize"] = 25;
UCF_Splitter_ie6["iStepSize"] = 50;
UCF_Splitter_ie6["iPageSize"] = 500;

/** Constants of the resize mode
 * @private
 */
UCF_Splitter_ie6["E_SIZEMODE"] = {
	"RELATIVE": "RELATIVE",
	"ABSOLUTE": "ABSOLUTE"
};

/** Constants of the collapse directions
 * @private
 */
UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"] = {
	"PREVIOUS": "PREVIOUS",
	"NEXT": "NEXT",
	"NONE": "NONE"
};

/** Constants of the resize directions
 * @private
 */
UCF_Splitter_ie6["E_DIRECTION"] = {
	"COLUMN": "columnresize", //column/vertical
	"ROW": "rowresize" //row/horizontal
};

/** Constants of the CT values in the renderer
 * @private
 */
UCF_Splitter_ie6["E_CT"] = {
	//SASH_COLUMN_RESIZE: "SPC",
	//SASH_ROW_RESIZE: "SPR",
	"CELL": "SPCE",
	"SPLITTER": "SP"
};

/** Constants of the CSS classes in the renderer
 * @private
 */
UCF_Splitter_ie6["E_CSSTYPE"] = {
	"SASH_COLUMN_RESIZE": "urSpTVs", //=tp
	"SASH_COLUMN_RESIZE_HOVER": "urSpTVsH",
	"SASH_COLUMN_RESIZE_ACTIVE": "urSpTVsA", //the active = ghost
	"SASH_COLUMN_RESIZE_ACTIVE_P": "urSpTVsAP", //the active = ghost previous
	"SASH_COLUMN_RESIZE_ACTIVE_N": "urSpTVsAN", //the active = ghost next
	/* not used
	SASH_COLUMN_FIX: "urSpTVsD",
	SASH_COLUMN_INVISIBLE: "urSpTVsI",
	*/
	"SASH_ROW_RESIZE": "urSpTHs", //=tp
	"SASH_ROW_RESIZE_HOVER": "urSpTHsH",
	"SASH_ROW_RESIZE_ACTIVE": "urSpTHsA", //the active = ghost
	"SASH_ROW_RESIZE_ACTIVE_P": "urSpTHsAP", //the active = ghost previous
	"SASH_ROW_RESIZE_ACTIVE_N": "urSpTHsAN", //the active = ghost next
	/* not used
	SASH_ROW_FIX: "urSpTHsD",
	SASH_ROW_INVISIBLE: "urSpTHsI",
	*/
	"BACKGROUND": "urSpTSB"
};

/** The Drag and drop constants
 * @private
 */
UCF_Splitter_ie6["ACCESS_TYPE"] = {
	"DRAG_START": false,
	"DRAG": false,
	"DRAG_END": false,
	"CLICK": false
};

/** Constants of the sash visual designs
 * @private
 */
UCF_Splitter_ie6["E_MOVETYPE"] = {
	"RESIZABLE": "RESIZABLE",
	"FIX": "FIX",
	"INVISIBLE": "INVISIBLE"
};

/** Returns the sash type enumeration value under the DOM reference in the {UCF_BrowserEvent}
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @return {Map} eDirection,eMoveType,oSash: the vertical/orizontal orientation, the sash type and the sash reference
 * @private
 */
UCF_Splitter_ie6["oGetSashType"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["oGetSashType"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Splitter_ie6.js(198): oGetSashType"); };
	var oSource = oBrowserEvent["oGetSource"](),
		oSash = UCF_DomUtil["oGetTPElement"](oSource);
	if (oSash != null && oSash["nodeType"] === 1 && oSash["getAttribute"]("tp")) {
		var tp = oSash["getAttribute"]("tp");
		switch (tp) {
			case UCF_Splitter_ie6["E_CSSTYPE"]["SASH_COLUMN_RESIZE"]:
				return { "eDirection": UCF_Splitter_ie6["E_DIRECTION"]["COLUMN"], "eMoveType": UCF_Splitter_ie6["E_MOVETYPE"]["RESIZABLE"], "oSash": oSash };
			case UCF_Splitter_ie6["E_CSSTYPE"]["SASH_ROW_RESIZE"]:
				return { "eDirection": UCF_Splitter_ie6["E_DIRECTION"]["ROW"], "eMoveType": UCF_Splitter_ie6["E_MOVETYPE"]["RESIZABLE"], "oSash": UCF_DomUtil["firstChild"](oSash, 'TD') };
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["oGetSashType"] = 0; };

/** Checks that the selected splitter resizes the width of two columns
 *
 * true if it is a horizontal resize
 * @return {boolean}
 * @private
 */
UCF_Splitter_ie6["prototype"]["bIsColumnResize"] = function () {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["bIsColumnResize"]++; }; 
	var mSashInfo = this["mSashInfo"];
	if (mSashInfo && mSashInfo["type"] && mSashInfo["type"]["eDirection"]) {
		return mSashInfo["type"]["eDirection"] === UCF_Splitter_ie6["E_DIRECTION"]["COLUMN"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["bIsColumnResize"] = 0; };

/** Checks that the selected splitter resizes the height of two rows
 *
 * @private
 * @return {boolean} true if it is a vertical resize
 */
UCF_Splitter_ie6["prototype"]["bIsRowResize"] = function () {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["bIsRowResize"]++; }; 
	var mSashInfo = this["mSashInfo"];
	if (mSashInfo && mSashInfo["type"] && mSashInfo["type"]["eDirection"]) {
		return mSashInfo["type"]["eDirection"] === UCF_Splitter_ie6["E_DIRECTION"]["ROW"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["bIsRowResize"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Splitter_ie6["prototype"]["onmouseover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onmouseover"]++; }; 
	if (this["mSashInfo"] == null) {
		//avoids performance flickering in D&D
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Splitter_ie6.js(249): onmouseover"); };
		var oSashType = UCF_Splitter_ie6["oGetSashType"](oBrowserEvent);

		if (oSashType != null) {
			var oSash = oSashType["oSash"],
				//sClass = UCF_DomUtil.sGetClass(oSash),
				eDirection = oSashType["eDirection"],
				eMoveType = oSashType["eMoveType"];

			if (eMoveType === UCF_Splitter_ie6["E_MOVETYPE"]["RESIZABLE"]) {
				switch (eDirection) {
					case UCF_Splitter_ie6["E_DIRECTION"]["COLUMN"]:
						UCF_DomUtil["replaceClass"](oSash, UCF_Splitter_ie6["E_CSSTYPE"]["SASH_COLUMN_RESIZE"], UCF_Splitter_ie6["E_CSSTYPE"]["SASH_COLUMN_RESIZE_HOVER"]);
						oBrowserEvent["cancelBubble"]();
						//this.lastActiveElement = UCF_DomUtil.oGetActiveElement();
						break;
					case UCF_Splitter_ie6["E_DIRECTION"]["ROW"]:
						UCF_DomUtil["replaceClass"](oSash, UCF_Splitter_ie6["E_CSSTYPE"]["SASH_ROW_RESIZE"], UCF_Splitter_ie6["E_CSSTYPE"]["SASH_ROW_RESIZE_HOVER"]);
						oBrowserEvent["cancelBubble"]();
						//this.lastActiveElement = UCF_DomUtil.oGetActiveElement();
						break;
					default:
					/*
					 _trace(ERROR, "Splitter onmouseover in unsupported area '" + this.sId + "' " + UCF_Splitter_ie6.sGetSubControlId(oBrowserEvent));
					 */
				}
			}
		}
		return;
	}

	//_trace(INFO, "onmouseover if sash is != null");
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onmouseover"] = 0; };

/**
 * Handles the onmouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_Splitter_ie6["prototype"]["onmouseout"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onmouseout"]++; }; 
	if (this["mSashInfo"] == null) {
		//avoidsperformance flickering in D&D
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Splitter_ie6.js(292): onmouseout"); };
		var oSashType = UCF_Splitter_ie6["oGetSashType"](oBrowserEvent);

		if (oSashType != null) {
			var oSash = oSashType["oSash"],
				//sClass = UCF_DomUtil.sGetClass(oSash),
				eDirection = oSashType["eDirection"],
				eMoveType = oSashType["eMoveType"];
			if (eMoveType === UCF_Splitter_ie6["E_MOVETYPE"]["RESIZABLE"]) {
				switch (eDirection) {
					case UCF_Splitter_ie6["E_DIRECTION"]["COLUMN"]:
						UCF_DomUtil["replaceClass"](oSash, UCF_Splitter_ie6["E_CSSTYPE"]["SASH_COLUMN_RESIZE_HOVER"], UCF_Splitter_ie6["E_CSSTYPE"]["SASH_COLUMN_RESIZE"]);
						oBrowserEvent["cancelBubble"]();
						break;
					case UCF_Splitter_ie6["E_DIRECTION"]["ROW"]:
						UCF_DomUtil["replaceClass"](oSash, UCF_Splitter_ie6["E_CSSTYPE"]["SASH_ROW_RESIZE_HOVER"], UCF_Splitter_ie6["E_CSSTYPE"]["SASH_ROW_RESIZE"]);
						oBrowserEvent["cancelBubble"]();
						break;
					default:
					/*
					 _trace(ERROR, "Splitter onmouseout in unsupported area '" + this.sId + "' " + UCF_Splitter_ie6.sGetSubControlId(oBrowserEvent) );
					 */
				}
			}
		}

		//avoids user select
		var oStyle = this["oDomRef"]["style"];
		oStyle["cursor"] = "";
		oStyle["UserSelect"] = "";
		if (UCF_UserAgent["bIsGecko"]()) {
			oStyle["MozUserSelect"] = "";
			oStyle["MozUserFocus"] = "";
			oStyle["MozUserInput"] = "";
		} else if (UCF_UserAgent["bIsWebKit"]()) {
			oStyle["WebkitUserSelect"] = "";
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onmouseout"] = 0; };

/**
 * Create IFrame dynamically if it doesn't exists yet
 *
 * @private
 */
UCF_Splitter_ie6["prototype"]["createIframe"] = function () {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["createIframe"]++; }; 
	var i;
	var oTemp;

	var sId = this["sId"];
	this["oSashDomRef"] = UCF_DomUtil["$"](sId + "-div");
	if (!this["oSashDomRef"]) {
		var oFragment = document["createDocumentFragment"](),
			//allowtransparency="true" causes that PDF viewer is not blocked
			sIFrame = '<iframe frameborder=\"0\" scrolling=\"no\" src=\"about:blank\" id=\"',
			sDiv = '<div id=\"',
			sAll = 'class=\"urSplitterAll\"',
			sTouch = 'class=\"urSplitterTouch\"',
			aHTMLTouch = [
				[sIFrame, sId, '-bgiframe\" name=\"', sId, '-bgiframe\"', sAll, '/>']["join"](''), [sDiv, sId, '-bgdiv\"', sAll, '/>']["join"](''), [sIFrame, sId, '-iframe\" name=\"', sId, '-iframe\"', sAll, '/>']["join"](''), [sDiv, sId, '-div\"', sAll, '>', sDiv, sId, '-div-touch\"', sTouch, '/>']["join"]('')
			],
			aHTML = [
				[sIFrame, sId, '-bgiframe\" name=\"', sId, '-bgiframe\"', sAll, '/>']["join"](''), [sDiv, sId, '-bgdiv\"', sAll, '/>']["join"](''), [sIFrame, sId, '-iframe\" name=\"', sId, '-iframe\"', sAll, '/>']["join"](''), [sDiv, sId, '-div\"', sAll, '/>']["join"]('')
			]; //for strange reasons, IFrame and DIVs cannot be created at the same time in IE?

		if (window["UCF_System"]["sInteractionType"] === 'TOUCH') {
			for (i = 0; i < aHTMLTouch["length"]; i++) {
				oTemp = document["createElement"]("div");
				// eslint-disable-next-line no-unsanitized/property
				oTemp["innerHTML"] = aHTMLTouch[i];

				//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
				while (oTemp["firstChild"]) {
					oFragment["appendChild"](oTemp["firstChild"]);
				}
				this["oDomRef"]["appendChild"](oFragment);
			}
		} else {
			for (i = 0; i < aHTML["length"]; i++) {
				oTemp = document["createElement"]("div");
				// eslint-disable-next-line no-unsanitized/property
				oTemp["innerHTML"] = aHTML[i];

				//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
				while (oTemp["firstChild"]) {
					oFragment["appendChild"](oTemp["firstChild"]);
				}
				this["oDomRef"]["appendChild"](oFragment);
			}
		}
	}

	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oBackgroundDomRef"] = UCF_DomUtil["$"](sId + "-bgdiv"), "this.oBackgroundDomRef = UCF_DomUtil.$(sId + \"-bgdiv\")", "Splitter_ie6.js(384): createIframe"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oBackgroundShim"] = UCF_DomUtil["$"](sId + "-bgiframe"), "this.oBackgroundShim = UCF_DomUtil.$(sId + \"-bgiframe\")", "Splitter_ie6.js(385): createIframe"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oSashDomRef"] = UCF_DomUtil["$"](sId + "-div"), "this.oSashDomRef = UCF_DomUtil.$(sId + \"-div\")", "Splitter_ie6.js(386): createIframe"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oSashShim"] = UCF_DomUtil["$"](sId + "-iframe"), "this.oSashShim = UCF_DomUtil.$(sId + \"-iframe\")", "Splitter_ie6.js(387): createIframe"); };

};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["createIframe"] = 0; };

/**
 * Handles the onlsdragstart event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Splitter_ie6["prototype"]["onlsdragstart"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsdragstart"]++; }; 
	if (this["mSashInfo"] == null) {
		this["onmousedown"](oBrowserEvent);
	}

	if (this["mSashInfo"] == null) {
		//this is still null if the sash is none
		this["releaseSash"](oBrowserEvent);
		//cancel
		return null;
	}

	//else
	/** stores the internal reference to the oDragAndDropManager of the BrowserEvent
	 * @private */
	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];

	if (oDragAndDropManager != null) {
		//workaround for IFrames
		oDragAndDropManager["startDragSession"](this["sId"], null,
			this["mSashInfo"]["bIsColumnResize"]
				? UCF_DragSession["DRAG_TYPE"]["H_RESIZE"]
				: UCF_DragSession["DRAG_TYPE"]["V_RESIZE"],
			null, null, null);
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["bHandled"] = true;
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsdragstart"] = 0; };

UCF_Splitter_ie6["prototype"]["onlstouchstart"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlstouchstart"]++; }; 
	this["onmousedown"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlstouchstart"] = 0; };

/* eslint-disable complexity */
/**
 * Workaround for IFrames and similar...
 * Handles the onmousedown event of the browser - calculates required size of the changed cells and shows the sash in the active mode
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @return{x}
 */
UCF_Splitter_ie6["prototype"]["onmousedown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onmousedown"]++; }; 
	var oNextContainer;
	var oStyle;

	if (this["mSashInfo"] == null) {
		if (__UCF_MEASURE__) { UCF_Tracer.measure(START, this["sId"]); };
		//_trace(DEBUG, "Splitter onlsdragstart in " + UCF_Splitter_ie6.E_DIRECTION.ROW + " '" + this.sId + "' " + UCF_Splitter_ie6.sGetSubControlId(oBrowserEvent) );

		var oSashType = UCF_Splitter_ie6["oGetSashType"](oBrowserEvent),
			eMoveType = oSashType == null ? null : oSashType["eMoveType"],
			oSash = oSashType == null ? null : oSashType["oSash"];

		if (oSash == null || eMoveType !== UCF_Splitter_ie6["E_MOVETYPE"]["RESIZABLE"]) {
			//_trace(INFO, oSash == null	? "info, event was fired on a non-resizable sash" : "info, event was fired on the dom ref of the splitter or the blind layer");
			this["releaseSash"](oBrowserEvent);

			if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, this["sId"], "Handle invalid onmousedown"); };
			//cancel
			return null;
		}

		//only define if the event was fired on an active sash
		/** the DomRef to the Sash root Dom element
		 * @private */
		this["oSash"] = oSash;

		//avoids user select
		oStyle = this["oDomRef"]["style"];
		oStyle["UserSelect"] = "none";
		if (UCF_UserAgent["bIsGecko"]()) {
			oStyle["MozUserSelect"] = "none";
			oStyle["MozUserFocus"] = "none";
			oStyle["MozUserInput"] = "disabled";
		} else if (UCF_UserAgent["bIsWebKit"]()) {
			oStyle["WebkitUserSelect"] = "none";
		}

		var sId = this["sId"];

		/** the ObjectRect of the Sash
		 * @private */
		this["mSashRect"] = this["oGetObjectRect"](oSash);
		//??wrong size calculation ??
		this["mSashRect"]["height"] = oSash["offsetHeight"];
		this["mSashRect"]["width"] = oSash["offsetWidth"];
		var mSashRect = this["mSashRect"];

		/** A map containing values for the resize operation, this statement resets values of previous resize operation
		 * @private */
		this["mSashInfo"] = { "prev": {}, "next": {}, "type": oSashType }; // type of the selected sash
		var mSashInfo = this["mSashInfo"],
			bIsColumnResize = this["bIsColumnResize"]();
		mSashInfo["bIsColumnResize"] = bIsColumnResize;

		var oSource = oBrowserEvent["oGetSource"]();
		while (oSource != null && oSource !== oSash && !(mSashInfo["bIsClickOnArea"])) {
			var sCurrentClass = oSource["className"];

			switch (sCurrentClass) {
				//don't change CSS classes because this is not a bHasClass -  it is a ==
				case "urSpTDP":
				case "urSpTDN":
				case "urSpTDImg":
				case "urSpTHsButton urSpTDP":
				case "lsSpVisTouchHandle urSpTDP":
				case "urSpTHsButton urSpTDN":
				case "lsSpVisTouchHandle urSpTDN":
					mSashInfo["bIsClickOnArea"] = true;
			}
			oSource = oSource["parentNode"];
		}

		var oSplitter = UCF_DomUtil["oGetFirstElement"](this["oDomRef"]);
		if (oSplitter == null) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "fatal error, event was fired on the dom ref of the blind layer", "Splitter_ie6.js(515): onmousedown"); };
			this["releaseSash"](oBrowserEvent);

			if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, sId, "Show active sash"); };
			//	cancel
			return null;
		}
		var oRoot = oSplitter["parentNode"];
		/** the ObjectRect of the complete Splitter
		 * @private */
		this["mSplitterRect"] = this["oGetObjectRect"](oRoot);
		//??wrong size calculation ??
		this["mSplitterRect"]["height"] = oSplitter["offsetHeight"];
		this["mSplitterRect"]["width"] = oSplitter["offsetWidth"];

		//migrate to UCF_ReferenceGhost odesn't work - problems with the calculation of the shim position
		this["oBackgroundDomRef"] = this["oBackgroundDomRef"] != null ? this["oBackgroundDomRef"] : UCF_DomUtil["$"](sId + "-bgdiv");
		this["oBackgroundShim"] = this["oBackgroundShim"] != null ? this["oBackgroundShim"] : UCF_DomUtil["$"](sId + "-bgiframe");
		this["oSashDomRef"] = this["oSashDomRef"] != null ? this["oSashDomRef"] : UCF_DomUtil["$"](sId + "-div");
		this["oSashShim"] = this["oSashShim"] != null ? this["oSashShim"] : UCF_DomUtil["$"](sId + "-iframe");

		//ID of the active splitter
		mSashInfo["id"] = oSash["id"];

		if (oBrowserEvent["sName"] === "lshome" || oBrowserEvent["sName"] === "lsend" ||
			oBrowserEvent["sName"] === "lsupmodifier" || oBrowserEvent["sName"] === "lspreviousmodifier" ||
			oBrowserEvent["sName"] === "lsdownmodifier" || oBrowserEvent["sName"] === "lsnextmodifier" ||
			oBrowserEvent["sName"] === "lspageup" || oBrowserEvent["sName"] === "lspagedown") {
			if (bIsColumnResize) {
				this["iPageX"] = this["mSashRect"]["left"];
				this["iPageY"] = this["mSashRect"]["height"] / 2;
			} else {
				this["iPageX"] = this["mSashRect"]["width"] / 2;
				this["iPageY"] = this["mSashRect"]["top"];
			}
		} else {
			/** the initial iPageX coordinate from the BrowserEvent
			 * @private */
			this["iPageX"] = oBrowserEvent["iPageX"]();
			/** the initial iPageY coordinate from the BrowserEvent
			 * @private */
			this["iPageY"] = oBrowserEvent["iPageY"]();
		}

		if (bIsColumnResize) {
			//vertical splitter
			mSashInfo["iPosition"] = UCF_StringUtil["iParseInt"](oSash["getAttribute"]("prevcol"));
			// Map of the IDs of the preceding components (.prev) and the following components (.next) in relation to the selected sash
			mSashInfo["aCells"] = this["aGetElements"](UCF_Splitter_ie6["E_DIRECTION"]["COLUMN"], oSplitter, mSashInfo["iPosition"]);
			mSashInfo["iSashDragPosition"] = this["iPageX"] - mSashRect["left"];
		} else {
			//horizontal splitter
			mSashInfo["iPosition"] = UCF_StringUtil["iParseInt"](oSash["getAttribute"]("prevrow"));
			// Map of the IDs of the preceding components (.prev) and the following components (.next) in relation to the selected sash
			mSashInfo["aCells"] = this["aGetElements"](UCF_Splitter_ie6["E_DIRECTION"]["ROW"], oSplitter, mSashInfo["iPosition"]);
			mSashInfo["iSashDragPosition"] = this["iPageY"] - mSashRect["top"];
		}

		var oPrev = mSashInfo["prev"],
			oNext = mSashInfo["next"];

		oPrev["aCells"] = mSashInfo["aCells"]["prevCells"];
		oPrev["sContainer"] = mSashInfo["aCells"]["prev"]; //contains <COL> or the <tds>

		if (!bIsColumnResize) {
			//change also the height in the <TR>
			oPrev["sContainer"]["push"](mSashInfo["aCells"]["prevRow"]);
		}

		if (__UCF_ASSERT__) { UCF_Tracer.assert((bIsColumnResize ? mSashInfo["aCells"]["prevCol"] : mSashInfo["aCells"]["prevRow"]) != null, "(bIsColumnResize ? mSashInfo.aCells.prevCol : mSashInfo.aCells.prevRow) != null", "Splitter_ie6.js(584): onmousedown"); };
		var oPreviousContainer = oPrev["oContainer"] = this["oGetControlById"](bIsColumnResize ? mSashInfo["aCells"]["prevCol"] : mSashInfo["aCells"]["prevRow"]);

		oNext["aCells"] = mSashInfo["aCells"]["nextCells"];
		oNext["sContainer"] = mSashInfo["aCells"]["next"]; //contains <COL> or the <tds>

		if (!bIsColumnResize) {
			//change also the height in the <TR>
			oNext["sContainer"]["push"](mSashInfo["aCells"]["nextRow"]);
		}

		if (__UCF_ASSERT__) { UCF_Tracer.assert((bIsColumnResize ? mSashInfo["aCells"]["nextCol"] : mSashInfo["aCells"]["nextRow"]) != null, "(bIsColumnResize ? mSashInfo.aCells.nextCol : mSashInfo.aCells.nextRow) != null", "Splitter_ie6.js(595): onmousedown"); };
		oNextContainer = oNext["oContainer"] = this["oGetControlById"](bIsColumnResize ? mSashInfo["aCells"]["nextCol"] : mSashInfo["aCells"]["nextRow"]);

		var aPrevCells = oPrev["aCells"];

		//Default size of the cell in the group of the preceding components
		mSashInfo["iPrevSize"] = bIsColumnResize ? oPreviousContainer["iWidth"] : oPreviousContainer["iHeight"];
		//check whether previous cell has * value
		oPrev["bIsDefaultSize"] = mSashInfo["iPrevSize"] < 0;
		/** the ObjectRect of the first cell in the array of elements of the previous collection	(used to determine the maximum height/width)
		 * @private */
		mSashInfo["prevRect"] = this["oGetObjectRect"](UCF_DomUtil["$"](aPrevCells[0]));
		oPrev["iSize"] = bIsColumnResize ? mSashInfo["prevRect"]["width"] : mSashInfo["prevRect"]["height"];
		//oPrev.iSize = UCF_Splitter_ie6.iGetSize(mSashInfo.type.eDirection, oPrev.sContainer);

		//Default size of the cell in the group of the following components
		mSashInfo["iNextSize"] = bIsColumnResize ? oNextContainer["iWidth"] : oNextContainer["iHeight"];
		//check weather next cell has * value
		oNext["bIsDefaultSize"] = mSashInfo["iNextSize"] < 0;
		/** the ObjectRect of the last cell in the array of elements in the next collection (used to determine the maximum height/width)
		 * @private */
		mSashInfo["nextRect"] = this["oGetObjectRect"](UCF_DomUtil["$"](oNext["aCells"][oNext["aCells"]["length"] - 1]));

		if (oPrev["bIsDefaultSize"] && oNext["bIsDefaultSize"]) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "fatal error, resizing between default cells is not possible", "Splitter_ie6.js(619): onmousedown"); };
			this["releaseSash"](oBrowserEvent);

			if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, sId, "Show active sash"); };
			//cancel
			return null;
		};

		oNext["iSize"] = bIsColumnResize ? mSashInfo["nextRect"]["width"] : mSashInfo["nextRect"]["height"];
		//oNext.iSize = UCF_Splitter_ie6.iGetSize(mSashInfo.type.eDirection, oNext.sContainer);

		mSashInfo["iSplitterSize"] = oPrev["iSize"] + oNext["iSize"] + (bIsColumnResize ? (mSashRect["width"]) : mSashRect["height"]);

		var bIsRelative = bIsColumnResize && this["sWidthSizeModeOfColums"] === UCF_Splitter_ie6["E_SIZEMODE"]["RELATIVE"]
			|| !bIsColumnResize && this["sHeightSizeModeOfRows"] === UCF_Splitter_ie6["E_SIZEMODE"]["RELATIVE"];

		if (bIsColumnResize) {
			if (oPreviousContainer["sCollapseDirection"] === UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"] &&
				oPreviousContainer["iExpandedWidth"] === -1) {

				if (bIsRelative) {
					oPreviousContainer["iExpandedWidth"] = oPrev["oContainer"]["iExpandedWidth"] = 100 - oNextContainer["iExpandedWidth"];
				} else {
					oPreviousContainer["iExpandedWidth"] = oPrev["oContainer"]["iExpandedWidth"] = oNext["iSize"] - oNextContainer["iExpandedWidth"];
				}
				oNextContainer["iExpandedWidth"] = oNext["oContainer"]["iExpandedWidth"] = 0;

			}
			if (oPreviousContainer["sCollapseDirection"] === UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["NEXT"] &&
				oNextContainer["iExpandedWidth"] === -1) {

				if (bIsRelative) {
					oNextContainer["iExpandedWidth"] = oNext["oContainer"]["iExpandedWidth"] = 100 - oPreviousContainer["iExpandedWidth"];
				} else {
					oNextContainer["iExpandedWidth"] = oNext["oContainer"]["iExpandedWidth"] = oPrev["iSize"] - oPreviousContainer["iExpandedWidth"];
				}
				oPreviousContainer["iExpandedWidth"] = oPrev["oContainer"]["iExpandedWidth"] = 0;

			}
		} else {
			if (oPreviousContainer["sCollapseDirection"] === UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"] &&
				oPreviousContainer["iExpandedHeight"] === -1) {

				if (bIsRelative) {
					oPreviousContainer["iExpandedHeight"] = oPrev["oContainer"]["iExpandedHeight"] = 100 - oNextContainer["iExpandedHeight"];
				} else {
					oPreviousContainer["iExpandedHeight"] = oPrev["oContainer"]["iExpandedHeight"] = oNext["iSize"] - oNextContainer["iExpandedHeight"];
				}
				oNextContainer["iExpandedHeight"] = oNext["oContainer"]["iExpandedHeight"] = 0;

			}
			if (oPreviousContainer["sCollapseDirection"] === UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["NEXT"] &&
				oNextContainer["iExpandedHeight"] === -1) {

				if (bIsRelative) {
					oNextContainer["iExpandedHeight"] = oNext["oContainer"]["iExpandedHeight"] = 100 - oPreviousContainer["iExpandedHeight"];
				} else {
					oNextContainer["iExpandedHeight"] = oNext["oContainer"]["iExpandedHeight"] = oPrev["iSize"] - oPreviousContainer["iExpandedHeight"];
				}
				oPreviousContainer["iExpandedHeight"] = oPrev["oContainer"]["iExpandedHeight"] = 0;

			}
		}

		if (oPrev["oContainer"]["sCollapseDirection"] !== UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["NONE"] && mSashInfo["bIsClickOnArea"]) {
			//click on the collapse/expand
			oNextContainer = oNext["oContainer"];
			var oContainer = null,
				oPrevContainer = oPrev["oContainer"];

			//check move direction and set actively expanding or collapsing container
			//check iSize <=3 because of border
			if (bIsColumnResize) {
				if (oPrevContainer["sCollapseDirection"] === UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["NEXT"]) {
					if (oNextContainer["iExpandedWidth"] > 0 && oNext["iSize"] <= 3) {
						oContainer = oNextContainer;
					} else {
						oContainer = oPrevContainer;
					}
				} else if (oPrevContainer["sCollapseDirection"] === UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"]) {
					if (oPrevContainer["iExpandedWidth"] > 0 && oPrev["iSize"] <= 3) {
						oContainer = oPrevContainer;
					} else {
						oContainer = oNextContainer;
					}
				}
			} else {
				if (oPrevContainer["sCollapseDirection"] === UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["NEXT"]) {
					if (oNextContainer["iExpandedHeight"] > 0 && oNext["iSize"] <= 3) {
						oContainer = oNextContainer;
					} else {
						oContainer = oPrevContainer;
					}
				} else if (oPrevContainer["sCollapseDirection"] === UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"]) {
					if (oPrevContainer["iExpandedHeight"] > 0 && oPrev["iSize"] <= 3) {
						oContainer = oPrevContainer;
					} else {
						oContainer = oNextContainer;
					}
				}
			}
		} //else

		if (oContainer) mSashInfo["iExpandedSize"] = bIsColumnResize ? oContainer["iExpandedWidth"] : oContainer["iExpandedHeight"];

		var oBackgroundDomRef = this["oBackgroundDomRef"];
		if (oBackgroundDomRef) {
			oStyle = this["oBackgroundShim"]["style"];
			oStyle["position"] = "relative";
			oStyle["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"] + 9; //reset default zIndex

			var iTop = ((bIsColumnResize ? 0 : (mSashInfo["prevRect"]["top"] - this["mSplitterRect"]["top"])) - this["mSplitterRect"]["height"]);
			oStyle["marginTop"] = iTop + "px";
			var iLeft = (bIsColumnResize ? (window["UCF_System"]["bIsRTL"]
				? this["mSplitterRect"]["left"] + this["mSplitterRect"]["width"] - mSashInfo["prevRect"]["left"] - mSashInfo["prevRect"]["width"]
				: mSashInfo["prevRect"]["left"] - this["mSplitterRect"]["left"])
				: 0);
			if (window["UCF_System"]["bIsRTL"]) {
				oStyle["marginRight"] = iLeft + "px";
			} else {
				oStyle["marginLeft"] = iLeft + "px";
			}

			oStyle["height"] = (bIsColumnResize ? this["mSplitterRect"]["height"] : mSashInfo["iSplitterSize"]) + "px";
			oStyle["width"] = (bIsColumnResize ? mSashInfo["iSplitterSize"] : this["mSplitterRect"]["width"]) + "px";

			UCF_DomUtil["setClass"](oBackgroundDomRef, UCF_Splitter_ie6["E_CSSTYPE"]["BACKGROUND"]);

			//blind layer API doesn't work because blind layer is not in the same scrolling area - renderer directly the iframe in the renderers
			//this.oBackgroundShim = this.oLS.oGetBlindLayer();

			var oStyleShim = oBackgroundDomRef["style"];
			oStyleShim["position"] = "relative";
			oStyleShim["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"] + 10; //reset default zIndex

			//delete this.oBackgroundShim.height;
			oStyleShim["height"] = oStyle["height"];
			//delete this.oBackgroundShim.width;
			oStyleShim["width"] = oStyle["width"];

			oStyleShim["marginTop"] = (bIsColumnResize
				//position relative to the IFrame which means -1 * height of IFrame
				? (-this["mSplitterRect"]["height"])
				: (-mSashInfo["iSplitterSize"])
			) + "px";
			if (window["UCF_System"]["bIsRTL"]) {
				oStyleShim["marginRight"] = oStyle["marginRight"];
			} else {
				oStyleShim["marginLeft"] = oStyle["marginLeft"];
			}

			//move to style class if not transparent anymore

			oStyleShim["display"] = "block";
			oStyle["display"] = "block";
			oStyleShim["backgroundColor"] = "white";
			oStyle["backgroundColor"] = "white";

			UCF_DomUtil["setOpacityStyle"](this["oBackgroundShim"], 1);
			UCF_DomUtil["setOpacityStyle"](oBackgroundDomRef, 1);

			if (this["bDebugMode"]) {
				UCF_DomUtil["setOpacityStyle"](this["oBackgroundShim"], 30);
				UCF_DomUtil["setOpacityStyle"](oBackgroundDomRef, 30);
			}

			//mSashInfo.mDrag = { top: null , left : null};
			//mSashInfo.mDrag.top = this.iPageX - this.mSplitterRect.top;
			//mSashInfo.mDrag.left = this.iPageY - this.mSplitterRect.left;

			if (!this["oSashDomRef"]) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "fatal error, the sash shim could not be found", "Splitter_ie6.js(790): onmousedown"); };
				this["releaseSash"](oBrowserEvent);

				if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, sId, "Show active sash"); };
				//cancel
				return null;
			}
		}

		var oSashStyle = this["oSashShim"]["style"];
		oSashStyle["position"] = "relative";
		oSashStyle["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"] + 11; //use higher zIndex than blind layer
		oSashStyle["height"] = mSashRect["height"] + "px";
		oSashStyle["lineHeight"] = mSashRect["height"] + "px";
		oSashStyle["width"] = mSashRect["width"] + "px";

		if (bIsColumnResize) {
			/*
			oSashStyle.top = oPrev.top+"px";
			oSashStyle.left =	(this.iPageX - oPrev.left -
								(bIE
								? this.mSplitterRect.left : 0) - mSashInfo.iSashDragPosition
								)+"px";
			*/

			oSashStyle["marginTop"] = (-this["mSplitterRect"]["height"]) + "px";
			if (window["UCF_System"]["bIsRTL"]) {
				mSashInfo["iOld"] = this["mSplitterRect"]["left"] + this["mSplitterRect"]["width"] - this["iPageX"];
				oSashStyle["marginRight"] = mSashInfo["iOld"] + "px";
			} else {
				mSashInfo["iOld"] = this["iPageX"] - this["mSplitterRect"]["left"] - mSashInfo["iSashDragPosition"];
				oSashStyle["marginLeft"] = mSashInfo["iOld"] + "px";
			}
			mSashInfo["iMin"] = iLeft;
			mSashInfo["iMax"] = mSashInfo["iMin"] + mSashInfo["iSplitterSize"] - mSashRect["width"];

			if (oPreviousContainer["sCollapseDirection"] === UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["NONE"]) {
				UCF_DomUtil["setClass"](this["oSashDomRef"], UCF_Splitter_ie6["E_CSSTYPE"]["SASH_COLUMN_RESIZE_ACTIVE"]);
			} else {
				if (UCF_DomUtil["bHasClass"](this["oSash"], "urSpTDVN")) UCF_DomUtil["setClass"](this["oSashDomRef"], UCF_Splitter_ie6["E_CSSTYPE"]["SASH_COLUMN_RESIZE_ACTIVE_N"]);
				else if (UCF_DomUtil["bHasClass"](this["oSash"], "urSpTDVP")) UCF_DomUtil["setClass"](this["oSashDomRef"], UCF_Splitter_ie6["E_CSSTYPE"]["SASH_COLUMN_RESIZE_ACTIVE_P"]);
			}
			// correction for vertical sash in IOS
			if (window["UCF_System"]["sInteractionType"] === 'TOUCH') {
				this["oSashDomRef"]["firstChild"]["style"]["marginTop"] = "-12px";
				UCF_DomUtil["setClass"](this["oSashDomRef"]["firstChild"], "urSpTouchsA");
			}

		} else { //if(this.bIsVertical == UCF_Splitter_ie6.E_DIRECTION.ROW)

			mSashInfo["iOld"] = (this["iPageY"] - mSashInfo["prevRect"]["top"] - mSashInfo["iSplitterSize"] - mSashRect["height"]);
			oSashStyle["marginTop"] = mSashInfo["iOld"] + "px";
			if (window["UCF_System"]["bIsRTL"]) {
				oSashStyle["marginRight"] = "0px";
			} else {
				oSashStyle["marginLeft"] = "0px";
			}
			mSashInfo["iMin"] = -mSashInfo["iSplitterSize"];
			mSashInfo["iMax"] = -mSashRect["height"];

			if (oPreviousContainer["sCollapseDirection"] == UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["NONE"]) {
				UCF_DomUtil["setClass"](this["oSashDomRef"], UCF_Splitter_ie6["E_CSSTYPE"]["SASH_ROW_RESIZE_ACTIVE"]);
			} else {
				if (UCF_DomUtil["bHasClass"](this["oSash"], "urSpTDHN")) UCF_DomUtil["setClass"](this["oSashDomRef"], UCF_Splitter_ie6["E_CSSTYPE"]["SASH_ROW_RESIZE_ACTIVE_N"]);
				else if (UCF_DomUtil["bHasClass"](this["oSash"], "urSpTDHP")) UCF_DomUtil["setClass"](this["oSashDomRef"], UCF_Splitter_ie6["E_CSSTYPE"]["SASH_ROW_RESIZE_ACTIVE_P"]);
			}
			// correction for horizontal sash in IOS
			if (window["UCF_System"]["sInteractionType"] === 'TOUCH') {
				this["oSashDomRef"]["firstChild"]["style"]["marginTop"] = "-12px";
				UCF_DomUtil["setClass"](this["oSashDomRef"]["firstChild"], "urSpTouchsA");
			}
		}

		var oStyleSashShim = this["oSashDomRef"]["style"];
		oStyleSashShim["position"] = "relative";
		oStyleSashShim["zIndex"] = UCF_LS["E_LAYERS"]["GHOSTS"] + 12; //reset default zIndex
		oStyleSashShim["height"] = oSashStyle["height"];
		oStyleSashShim["lineHeight"] = oSashStyle["lineHeight"];
		oStyleSashShim["maxHeight"] = oStyleSashShim["height"];
		oStyleSashShim["width"] = oSashStyle["width"];
		oStyleSashShim["maxWidth"] = oStyleSashShim["width"];
		oStyleSashShim["marginTop"] = (bIsColumnResize
			? (-this["mSplitterRect"]["height"])
			//the height that is missing in the block layer
			: (-mSashRect["height"])
			// the height of the Splitter
		) + "px";
		if (window["UCF_System"]["bIsRTL"]) {
			oStyleSashShim["marginRight"] = oSashStyle["marginRight"];
		} else {
			oStyleSashShim["marginLeft"] = oSashStyle["marginLeft"];
		}

		//set cursor on Splitter so that correct cursor is always showed
		//maybe not fully working maybe because empty IFrame reset it
		var sCursor = UCF_DomUtil["sGetCurrentStyle"](oSash, "cursor");
		this["oDomRef"]["style"]["cursor"] = oSashStyle["cursor"] = oStyleSashShim["cursor"] = sCursor;
		if (this["oBackgroundDomRef"]) {
			this["oBackgroundDomRef"]["style"]["cursor"] = this["oBackgroundShim"]["style"]["cursor"] = sCursor;
		}

		if (this["bDebugMode"]) {
			UCF_DomUtil["setOpacityStyle"](this["oSashShim"], 30);
			oSashStyle["backgroundColor"] = "#555555";
			//frames[this.oSashShim.id].document.body.style.backgroundColor = "green";

			UCF_DomUtil["setOpacityStyle"](this["oSashDomRef"], 30);
			oStyleSashShim["backgroundColor"] = "#555555";
		}

		oSashStyle["display"] = "block";
		oStyleSashShim["display"] = "block";
		oStyleSashShim["visibility"] = "visible";

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;

		if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, sId, "Show active sash"); };
		return UCF_Splitter_ie6["ACCESS_TYPE"]["DRAG_START"];
	} //end this.mSashInfo != null

	return null;
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onmousedown"] = 0; };
/* eslint-enable complexity */

/**
 * Workaround for IFrames and similar...
 *
 * Handles the onmouseup event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Splitter_ie6["prototype"]["onmouseup"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onmouseup"]++; }; 
	return this["onlsdragend"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onmouseup"] = 0; };

UCF_Splitter_ie6["prototype"]["onlstouchend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlstouchend"]++; }; 
	this["onmouseup"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlstouchend"] = 0; };

/* eslint-disable complexity */
/**
 * Handles the drop event of the browser - fires the events for the resize of the cells, removes the visualization of the active sash
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object, that occurred
 * @private
 */
UCF_Splitter_ie6["prototype"]["onlsdragend"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsdragend"]++; }; 
	var i;
	var iPanesPosition;
	var c;
	var iPaneMaxSize;
	var iLen;
	var oItem;
	var oD;
	var sId;
	var oPanelDomRef;
	var oCell;
	var iOldSize;
	var iExpandedSize;
	var b;

	if (this["mSashInfo"] != null) {
		if (__UCF_MEASURE__) { UCF_Tracer.measure(START, this["sId"]); };
		//_trace(DEBUG, "Deactivate Sash started.");
		var oStyle = this["oDomRef"]["style"],
			oSplitter = UCF_DomUtil["oGetFirstElement"](this["oDomRef"]),
			bIsColumnResize = this["bIsColumnResize"](),
			mSashInfo = this["mSashInfo"],

			oPrev = mSashInfo["prev"],
			aPrevCells = oPrev["aCells"],
			aPrevContainer = oPrev["sContainer"],
			bPrevIsDefaultSize = oPrev["bIsDefaultSize"],
			//iPrevCellsLen = aPrevCells.length,
			oPreviousContainer = UCF_DomUtil["$"](bIsColumnResize ? aPrevContainer : aPrevContainer[0]),

			oNext = mSashInfo["next"],
			aNextCells = oNext["aCells"],
			aNextContainer = oNext["sContainer"],
			bNextIsDefaultSize = oNext["bIsDefaultSize"],
			iNextCellsLen = aNextCells["length"],
			oNextContainer = UCF_DomUtil["$"](bIsColumnResize ? aNextContainer : aNextContainer[0]);

		//bIE = UCF_UserAgent.bIsIE(),
		var iPageX = oBrowserEvent["iPageX"]();
		var iPageY = oBrowserEvent["iPageY"]();
		//calculation from ondrag

		var bKeyBoardNavigation = false;
		var oActiveElement = null;

		if (oBrowserEvent["sName"] === "lshome") {
			bKeyBoardNavigation = true;
			if (bIsColumnResize) {
				iPageX = this["mSplitterRect"]["left"];
				iPageY = this["iPageY"];
			} else {
				iPageX = this["iPageX"];
				iPageY = this["mSplitterRect"]["top"];
			}
		}
		if (oBrowserEvent["sName"] === "lsend") {
			bKeyBoardNavigation = true;
			if (bIsColumnResize) {
				iPageX = this["mSplitterRect"]["left"] + this["mSplitterRect"]["width"];
				iPageY = this["iPageY"];
			} else {
				iPageX = this["iPageX"];
				iPageY = this["mSplitterRect"]["top"] + this["mSplitterRect"]["height"];
			}
		}
		if (oBrowserEvent["sName"] === "lsupmodifier" || oBrowserEvent["sName"] == "lspreviousmodifier") {
			bKeyBoardNavigation = true;
			if (bIsColumnResize) {
				iPageX = this["iPageX"] - UCF_Splitter_ie6["iStepSize"];
				iPageY = this["iPageY"];
			} else {
				iPageX = this["iPageX"];
				iPageY = this["iPageY"] - UCF_Splitter_ie6["iStepSize"];
			}
		}
		if (oBrowserEvent["sName"] === "lsdownmodifier" || oBrowserEvent["sName"] == "lsnextmodifier") {
			bKeyBoardNavigation = true;
			if (bIsColumnResize) {
				iPageX = this["iPageX"] + UCF_Splitter_ie6["iStepSize"];
				iPageY = this["iPageY"];
			} else {
				iPageX = this["iPageX"];
				iPageY = this["iPageY"] + UCF_Splitter_ie6["iStepSize"];
			}
		}
		if (oBrowserEvent["sName"] === "lspageup") {
			bKeyBoardNavigation = true;
			if (bIsColumnResize) {
				iPageX = this["iPageX"] - UCF_Splitter_ie6["iPageSize"];
				iPageY = this["iPageY"];
			} else {
				iPageX = this["iPageX"];
				iPageY = this["iPageY"] - UCF_Splitter_ie6["iPageSize"];
			}
		}
		if (oBrowserEvent["sName"] === "lspagedown") {
			bKeyBoardNavigation = true;
			if (bIsColumnResize) {
				iPageX = this["iPageX"] + UCF_Splitter_ie6["iPageSize"];
				iPageY = this["iPageY"];
			} else {
				iPageX = this["iPageX"];
				iPageY = this["iPageY"] + UCF_Splitter_ie6["iPageSize"];
			}
		}

		/* the size starting from the splitter beginning to the left border of the moved sash */
		var iSize = bIsColumnResize
			? window["UCF_System"]["bIsRTL"]
				? (this["mSplitterRect"]["left"] + this["mSplitterRect"]["width"] - iPageX)
				: iPageX - this["mSplitterRect"]["left"] - mSashInfo["iSashDragPosition"]
			: (iPageY - mSashInfo["prevRect"]["top"] - this["mSashRect"]["height"]),
			iDifferencePreviousElements = bIsColumnResize ? iSize - mSashInfo["iOld"] : iSize - (mSashInfo["iOld"] + mSashInfo["iSplitterSize"]),
			iSplitterOffset = (bIsColumnResize ? oSplitter["offsetWidth"] : oSplitter["offsetHeight"]),
			iPreviousElementsOffsetOld = (bIsColumnResize ? UCF_DomUtil["$"](aPrevCells[0])["offsetWidth"] : UCF_DomUtil["$"](aPrevCells[0])["offsetHeight"]),
			iPreviousElementsOffset = iPreviousElementsOffsetOld,
			iNextElementsOffsetOld = (bIsColumnResize ? UCF_DomUtil["$"](aNextCells[iNextCellsLen - 1])["offsetWidth"] : UCF_DomUtil["$"](aNextCells[iNextCellsLen - 1])["offsetHeight"]),
			iNextElementsOffset = iNextElementsOffsetOld,

			//the container that contaisns the iExpandedWidth or iExpandedHeight value for this sash
			oContainer = oPrev["oContainer"],
			// % = relative values
			bIsRelative = bIsColumnResize && this["sWidthSizeModeOfColums"] == UCF_Splitter_ie6["E_SIZEMODE"]["RELATIVE"]
				|| !bIsColumnResize && this["sHeightSizeModeOfRows"] == UCF_Splitter_ie6["E_SIZEMODE"]["RELATIVE"],
			iSashSize = bIsColumnResize ? this["mSashRect"]["width"] : this["mSashRect"]["height"],
			//TODO: use corect size instead of iSashSize depending on the start point of the D&D operation
			bIsClickOnArea = oContainer["sCollapseDirection"] != UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["NONE"]
				&& (mSashInfo["iExpandedSize"] != null && Math["abs"](Math["ceil"](iDifferencePreviousElements)) <= iSashSize),

			iPreviousSize,
			iNextSize;

		//Check if handle has been released outside of trigger point +/-5
		if (!bIsClickOnArea && (this["iPageX"] - iPageX < 5) && (this["iPageX"] - iPageX > -5) &&
			(this["iPageY"] - iPageY < 5) && (this["iPageY"] - iPageY > -5)) {
			// cleanup and leave sash on old position
			this["releaseSash"](oBrowserEvent);

			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["bHandled"] = true;

			//avoids multiple re-flow (rendering of the screen)
			oStyle["visibility"] = "visible";

			if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, this["sId"], "Hide active sash"); };
			return UCF_Splitter_ie6["ACCESS_TYPE"]["DRAG_END"];
		}

		//IE blurs the activeElement when setting visibility to hidden ... therefore store activeElement for the case of keyboardNavigation and
		//restore again when setting visibility to visible
		if (bKeyBoardNavigation) {
			oActiveElement = UCF_DomUtil["oGetActiveElement"]();
		}
		//avoids multiple re-flow (rendering of the screen)
		oStyle["visibility"] = "hidden";

		var iFactor = 1; //if % then the factor calculates the px
		if (bIsRelative) {
			iFactor = bIsColumnResize ? oSplitter["offsetWidth"] / 100 : oSplitter["offsetHeight"] / 100;
		}

		if (bIsClickOnArea) { //handle click on collapse/expand
			//mouseup = click was done on section so collapse/expand section and otherwise use standard d&d
			iDifferencePreviousElements = (
				oContainer["sCollapseDirection"] == UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"]
					? mSashInfo["iExpandedSize"] < 1
						? //prev collapse
						-1 * iPreviousElementsOffset
						: //prev expand
						mSashInfo["iExpandedSize"]
					: mSashInfo["iExpandedSize"] < 1
						? //next collapse
						iPreviousElementsOffset + iNextElementsOffset
						: //next expand
						-1 * mSashInfo["iExpandedSize"]) * iFactor;

			iSize = iDifferencePreviousElements + mSashInfo["iOld"];
			//replace the expand size in the control instance for the following operation

			iOldSize = oContainer["sCollapseDirection"] == UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"]
				? bPrevIsDefaultSize || bIsRelative
					? //prev is default - collapse
					Math["ceil"](iPreviousElementsOffset / iFactor)
					: oPrev["iSize"]
				: bPrevIsDefaultSize || bIsRelative
					? //prev is default - expand
					Math["ceil"](iNextElementsOffset / iFactor)
					: oNext["iSize"];

			oContainer[bIsColumnResize ? "iExpandedWidth" : "iExpandedHeight"] = !bIsRelative && iOldSize < UCF_Splitter_ie6["iCollapseSize"]
				|| bIsRelative && iOldSize <= 1
				? 0 : iOldSize;
		} //end click on collapse

		{ //handle drag or handle click

			if (bPrevIsDefaultSize && bNextIsDefaultSize) {
				//relative colum or row - ignore resizing, only determine size to fire event
				iPreviousSize = Math["abs"](Math["floor"](iDifferencePreviousElements + iPreviousElementsOffset));
				if (iPreviousSize < 1) {
					iPreviousSize = 1;
					iNextSize = iPreviousElementsOffset + iNextElementsOffset - 1;
				} else {
					iNextSize = Math["abs"](Math["ceil"](iNextElementsOffset - iDifferencePreviousElements));
					//TODO size > 100%
				}

				if (bIsColumnResize) {
					if (bIsRelative) {
						iPreviousSize = Math["ceil"]((iPreviousSize / oSplitter["offsetWidth"]) * 100);
						iNextSize = Math["ceil"]((iNextSize / oSplitter["offsetWidth"]) * 100);
					}
				} else {
					//row resize
					if (bIsRelative) {
						iPreviousSize = Math["ceil"]((iPreviousSize / oSplitter["offsetHeight"]) * 100);
						iNextSize = Math["ceil"]((iNextSize / oSplitter["offsetHeight"]) * 100);
					}
				}
			} else if (bIsRelative) {
				//begin refactoring splitter: case expand/collapse in relative mode
				if (bIsClickOnArea) {
					if (mSashInfo["iExpandedSize"] == 0) {
						//collapse
						if (oPrev["oContainer"]["sCollapseDirection"] == UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"]) {
							//previous collapse
							iPreviousSize = 0;
							iNextSize = Math["round"]((oPrev["iSize"] + oNext["iSize"]) / (iSplitterOffset - iSashSize) * 100);
						} else {
							//next collapse
							iNextSize = 0;
							iPreviousSize = Math["round"]((oPrev["iSize"] + oNext["iSize"]) / (iSplitterOffset - iSashSize) * 100);
						}
					} else {
						//expand
						if (oPrev["oContainer"]["sCollapseDirection"] == UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"]) {
							//previous expand
							iPreviousSize = mSashInfo["iExpandedSize"];
							iNextSize = Math["round"]((oNext["iSize"] / (iSplitterOffset - iSashSize) * 100) - iPreviousSize);
						} else {
							//next expand
							iNextSize = mSashInfo["iExpandedSize"];
							iPreviousSize = Math["round"]((oPrev["iSize"] / (iSplitterOffset - iSashSize) * 100) - iNextSize);
						}
					}
				}
				//end refactoring splitter: case expand/collapse in relative mode
				else {
					// % - calculates relative values
					var iPreviousElementSize = Math["floor"]((oPrev["iSize"] + iSashSize) / iSplitterOffset * 100),
						iNextElementSize = Math["ceil"](oNext["iSize"] / iSplitterOffset * 100),
						iPaneSize = Math["floor"](iPreviousElementSize + iDifferencePreviousElements / iSplitterOffset * 100),
						iPaneMinCollapseSize = Math["ceil"](UCF_Splitter_ie6["iCollapseSize"] / iSplitterOffset * 100),
						iPaneMaxExpandSize = Math["floor"]((mSashInfo["iMax"] - mSashInfo["iMin"] - UCF_Splitter_ie6["iCollapseSize"]) / iSplitterOffset * 100);
					iPaneMaxSize = Math["ceil"]((mSashInfo["iMax"] - mSashInfo["iMin"]) / iSplitterOffset * 100);

					//calculate previous only if not default
					if (!bPrevIsDefaultSize) {
						if (iPaneSize <= iPaneMinCollapseSize) {
							iPaneSize = 0;
						} else if (iPaneSize > iPaneMaxExpandSize) {
							iPaneSize = iPaneMaxSize;
						}
						iPreviousSize = iPaneSize;
					}

					//only do real calculation if not default
					if (!bNextIsDefaultSize) {

						iPaneSize = Math["floor"](oNext["iSize"] / iSplitterOffset * 100 + iPreviousElementSize - iPaneSize + 1);
						if (iPaneSize <= iPaneMinCollapseSize || (!bPrevIsDefaultSize && iPreviousSize >= iPaneMaxExpandSize)) {
							//pane size is 0
							iPaneSize = 0;
						} else if (bPrevIsDefaultSize && iPaneSize > iPaneMaxExpandSize) {
							iPaneSize = iPaneMaxSize;
						}
						iNextSize = iPaneSize;
					} else {

						//next has default size
						if (iPreviousSize < 1) {
							iNextSize = (iPreviousElementSize + iNextElementSize);
						} else if (iPreviousSize >= iPaneMaxExpandSize) {
							iNextSize = 0;
						} else {
							iNextSize = (iPreviousElementSize + iNextElementSize) - iPreviousSize;
						}
					}

					if (bPrevIsDefaultSize) {
						//fix the previous size because it was not calculated in the default size case (ceil because next is floor)
						iPreviousSize = Math["ceil"]((iPreviousElementSize + iNextElementSize) - iNextSize);
						if (iPreviousSize < iPaneMinCollapseSize) {
							iPreviousSize = 0;
						}
					}
				}
				//update containers
				if (bIsColumnResize) {
					//vertical mode
					oPreviousContainer["style"]["width"] = iPreviousSize > 0 ? (iPreviousSize + "%") : "1px";;
					oNextContainer["style"]["width"] = iNextSize > 0 ? (iNextSize + "%") : "1px";;
				} else {
					//horizontal mode update previous containers
					var oItems = aPrevContainer;
					// in relative mode, cells also need to be adjusted
					for (i = 0; i < oPrev["aCells"]["length"]; i++) {
						oItems["push"](oPrev["aCells"][i]);
					}
					iLen = aPrevContainer["length"];

					for (iPanesPosition = iLen; iPanesPosition--;) {
						c = UCF_DomUtil["$"](oItems[iPanesPosition]);
						//_assert(iPreviousSize < 100);
						//_assert(iPreviousSize > 0);
						c["style"]["height"] = iPreviousSize > 0 ? (iPreviousSize + "%") : "1px"; //don't hide cells in 508 so that it can be focused
					}

					//update next containers
					oItems = aNextContainer;
					// in relative mode, cells also need to be adjusted
					for (i = 0; i < oNext["aCells"]["length"]; i++) {
						oItems["push"](oNext["aCells"][i]);
					}
					iLen = oItems["length"];

					for (iPanesPosition = iLen; iPanesPosition--;) {
						c = UCF_DomUtil["$"](oItems[iPanesPosition]);
						//_assert(iNextSize < 100);
						//_assert(iNextSize > 0);
						//don't hide cells in 508 so that it can be focused
						c["style"]["height"] = iNextSize > 0 ? (iNextSize + "%") : "1px";
					}
				}

				//_assert(iPreviousSize + iNextSize <= 100);
			} else {
				//debugger;
				//px - absolute size
				var iPaneSizeOfPreviousElements = oPrev["iSize"] + iDifferencePreviousElements,
					iPaneSizeOfNextElements = oNext["iSize"] - iDifferencePreviousElements;
				iPaneMaxSize = (iPreviousElementsOffsetOld + iNextElementsOffsetOld - 1);

				if (oContainer["sCollapseDirection"] === UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"]) {
					iPaneSizeOfPreviousElements = iPaneSizeOfPreviousElements - 1;
					iPaneSizeOfNextElements = iPaneSizeOfNextElements + 1;
				} else {
					iPaneSizeOfPreviousElements = iPaneSizeOfPreviousElements + 1;
					iPaneSizeOfNextElements = iPaneSizeOfNextElements - 1;
				}

				if (!bPrevIsDefaultSize) {
					//handle horizontal mode differently since position is calculated from bottom
					if (iPaneSizeOfPreviousElements < UCF_Splitter_ie6["iCollapseSize"]) {
						//oPreviousCell is collapsed
						iPreviousSize = 1;
					} else if (iPaneSizeOfPreviousElements >= (iPaneMaxSize - UCF_Splitter_ie6["iCollapseSize"])) {
						iPreviousSize = iPaneMaxSize;
					} else {
						iPreviousSize = iPaneSizeOfPreviousElements;
					}
					//iPreviousSize = (bIsColumnResize ? UCF_StringUtil.iParseInt(oPreviousContainer.style.width) : UCF_StringUtil.iParseInt(oPreviousContainer.style.height));
				}

				//update again the offsets to avoid calculation errors
				iPreviousElementsOffset = (bIsColumnResize ? UCF_DomUtil["$"](aPrevCells[0])["offsetWidth"] : UCF_DomUtil["$"](aPrevCells[0])["offsetHeight"]);
				iNextElementsOffset = (bIsColumnResize ? UCF_DomUtil["$"](aNextCells[iNextCellsLen - 1])["offsetWidth"] : UCF_DomUtil["$"](aNextCells[iNextCellsLen - 1])["offsetHeight"]);

				if (!bNextIsDefaultSize) {
					if (iPaneSizeOfNextElements < UCF_Splitter_ie6["iCollapseSize"]) {
						//oNextCell is collapsed
						iNextSize = 1;
					} else if (iPaneSizeOfNextElements >= (iPaneMaxSize - UCF_Splitter_ie6["iCollapseSize"])) {
						iNextSize = iPaneMaxSize;
					} else {
						iNextSize = iPaneSizeOfNextElements;
					}
					//iNextSize = (bIsColumnResize ? UCF_StringUtil.iParseInt(oNextContainer.style.width) : UCF_StringUtil.iParseInt(oNextContainer.style.height));

					if (iNextSize <= 1) {
						iPreviousSize = iPaneMaxSize;
					} else if (iNextSize >= iPaneMaxSize) {
						iPreviousSize = 1;
					} else {
						iPreviousSize = iPaneMaxSize - iNextSize;
					}

				} else {
					//next has default size
					if (iPreviousSize <= 1) {
						iNextSize = iPaneMaxSize;
					} else if (iPreviousSize >= iPaneMaxSize) {
						iNextSize = 1;
					} else {
						iNextSize = iPaneMaxSize - iPreviousSize;
					}
				}
				iPaneSizeOfNextElements = iNextSize;
				iPaneSizeOfPreviousElements = iPreviousSize;

				//check if previous is default and collapsed
				if (bPrevIsDefaultSize) {
					//other cases are handled by 100% size
					if (iNextSize >= iPaneMaxSize) iPreviousSize = 1;
				}

				if (bIsColumnResize) {
					//set 100% if default-> only one defalt cell allowed in absolute mode
					oPreviousContainer["style"]["width"] = bPrevIsDefaultSize && !iPreviousSize ? '100%' : iPreviousSize + 'px';
					oNextContainer["style"]["width"] = bNextIsDefaultSize ? '100%' : iNextSize + "px";
				} else {
					oItem = aPrevContainer;
					// in relative mode, cells also need to be adjusted
					for (i = 0; i < oPrev["aCells"]["length"]; i++) {
						oItem["push"](oPrev["aCells"][i]);
					}
					iLen = oItem["length"];
					for (iPanesPosition = iLen; iPanesPosition--;) {
						//don't hide cells in 508 so that it can be focused
						c = UCF_DomUtil["$"](oItem[iPanesPosition]);
						//100% does not work reliably for 1px height also needed to set visible again
						//if not collapsed iPreviousSize is not initialized in default scenario
						c["style"]["height"] = bPrevIsDefaultSize && !iPreviousSize ? '100%' : iPreviousSize + 'px';;
					}

					oItem = aNextContainer;
					// in relative mode, cells also need to be adjusted
					for (i = 0; i < oNext["aCells"]["length"]; i++) {
						oItem["push"](oNext["aCells"][i]);
					}
					iLen = oItem["length"];
					for (iPanesPosition = iLen; iPanesPosition--;) {
						//don't hide cells in 508 so that it can be focused
						c = UCF_DomUtil["$"](oItem[iPanesPosition]);
						//100% does not work reliably for 1px height, also needed to set visible again
						c["style"]["height"] = bNextIsDefaultSize && iNextSize > 1 ? '100%' : iNextSize + "px";
					}
				}

			} //end of px
		} //end handle drag

		this["refreshTable"](oSplitter);

		if (!bIsColumnResize) {
			oItem = aPrevContainer;
			iLen = oItem["length"];

			for (iPanesPosition = iLen; iPanesPosition--;) {
				oD = UCF_DomUtil["$"](oItem[iPanesPosition]);
				oD["style"]["maxHeight"] = oD["style"]["height"] = oPreviousContainer["style"]["height"];
			}
		}

		oItem = aPrevCells;
		iLen = oItem["length"];

		for (iPanesPosition = iLen; iPanesPosition--;) {
			sId = oItem[iPanesPosition];
			var oCellDomRef = UCF_DomUtil["$"](sId);
			if (bIsColumnResize) {
				//TODO: set size on all cells to avoid resize problems in browsers, maybe this can be removed
				if (oCellDomRef["style"]["maxWidth"] == "1px" && UCF_UserAgent["bIsGecko"]()) {
					oCellDomRef["style"]["width"] = oPreviousContainer["style"]["width"];
					oCellDomRef["style"]["maxWidth"] = "";
				} else {
					oCellDomRef["style"]["maxWidth"] = oCellDomRef["style"]["width"] = oPreviousContainer["style"]["width"];
				}
			} else {
				//in case of relative mode, the divs height is always 100%
				if (this["sHeightSizeModeOfRows"] == UCF_Splitter_ie6["E_SIZEMODE"]["ABSOLUTE"]) {
					oCellDomRef["style"]["maxHeight"] = oCellDomRef["style"]["height"] = oPreviousContainer["style"]["height"];
				}
			}
			oPanelDomRef = UCF_DomUtil["firstChild"](oCellDomRef, 'DIV');
			oCell = this["oGetControlByDomRef"](oPanelDomRef, true);

			if (UCF_JsUtil["bInstanceOf"](oCell, "UCF_SplitterCell_ie6")) {
				if (oPreviousContainer["style"][bIsColumnResize ? 'width' : 'height'] == '1px') {
					oPanelDomRef["style"]["visibility"] = "hidden";
				} else {
					oPanelDomRef["style"]["visibility"] = "visible";
				}

				oCell["fireResize"](sId,
					bIsColumnResize ? iDifferencePreviousElements : 0, //iWidthDelta
					!bIsColumnResize ? iDifferencePreviousElements : 0, //iHeightDelta
					UCF_StringUtil["iParseInt"](bIsColumnResize ? iPreviousSize : oCell["iGetWidth"]()), //iWidth
					UCF_StringUtil["iParseInt"](!bIsColumnResize ? iPreviousSize : oCell["iGetHeight"]())); //iHeight
				this["fireResize"](
					this["sId"], //sId,
					sId, //sCellId,
					bIsColumnResize ? iDifferencePreviousElements : 0, //iWidthDelta,
					!bIsColumnResize ? iDifferencePreviousElements : 0, //iHeightDelta,
					UCF_StringUtil["iParseInt"](bIsColumnResize ? iPreviousSize : oCell["iGetWidth"]()), //iWidth
					UCF_StringUtil["iParseInt"](!bIsColumnResize ? iPreviousSize : oCell["iGetHeight"]())); //iHeight
				// notify framework, that layout has changed after toggling e.g. the tray
			}
		}

		if (!bIsColumnResize) {
			oItem = aNextContainer;
			iLen = oItem["length"];

			for (iPanesPosition = iLen; iPanesPosition--;) {
				oD = UCF_DomUtil["$"](oItem[iPanesPosition]);
				oD["style"]["maxHeight"] = oD["style"]["height"] = oNextContainer["style"]["height"];
			}
		}

		oItem = aNextCells;
		iLen = oItem["length"];
		for (iPanesPosition = iLen; iPanesPosition--;) {
			sId = oItem[iPanesPosition];
			oCellDomRef = UCF_DomUtil["$"](sId);
			if (bIsColumnResize) {
				//TODO: set size on all cells to avoid resize problems in browsers, maybe this can be removed
				if (UCF_UserAgent["bIsGecko"]()) {
					oCellDomRef["style"]["width"] = oNextContainer["width"];
					oCellDomRef["style"]["maxWidth"] = "";
				} else {
					oCellDomRef["style"]["maxWidth"] = oCellDomRef["style"]["width"] = oNextContainer["style"]["width"];
				}
			} else {
				//in case of relative mode, the divs height is always 100%
				if (this["sHeightSizeModeOfRows"] == UCF_Splitter_ie6["E_SIZEMODE"]["ABSOLUTE"]) {
					oCellDomRef["style"]["maxHeight"] = oCellDomRef["style"]["height"] = oNextContainer["style"]["height"];
				}
			}

			oPanelDomRef = UCF_DomUtil["firstChild"](oCellDomRef, 'DIV');
			oCell = this["oGetControlByDomRef"](oPanelDomRef, true);

			//resize is fired if the "content size" changes
			if (UCF_JsUtil["bInstanceOf"](oCell, "UCF_SplitterCell_ie6")) {

				oPanelDomRef["style"]["visibility"] = UCF_StringUtil["iParseInt"](
					bIsColumnResize
						? oNextContainer["offsetWidth"]
						: oNextContainer["offsetHeight"]) == 1
					? "hidden" : "visible";

				//I only want to fire the event on the cells but for historic reasons I have to fire it on the splitter as well
				oCell["fireResize"](sId,
					/* the two lines looks similar but is use to transfer 0 if nothing changed */
					bIsColumnResize ? -1 * iDifferencePreviousElements : 0, !bIsColumnResize ? -1 * iDifferencePreviousElements : 0,
					bIsColumnResize ? iNextSize : oCell["iGetWidth"](), !bIsColumnResize ? iNextSize : oCell["iGetHeight"]());
				this["fireResize"](
					this["sId"],
					sId,
					/* the two lines looks similar but is use to transfer 0 if nothing changed */
					bIsColumnResize ? iDifferencePreviousElements : 0, !bIsColumnResize ? iDifferencePreviousElements : 0,
					bIsColumnResize ? iNextSize : oCell["iGetWidth"](), !bIsColumnResize ? iNextSize : oCell["iGetHeight"]());
			}
		}

		//TODO: WARNING, the iPreviousSize & iNextSize in MoveEnd is not calculated correctly - in px at the move to right, % in all cases

		if (!bIsClickOnArea && oContainer["sCollapseDirection"] != UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["NONE"]) {
			//adjust collapse size if drag & drop
			iExpandedSize = oContainer[bIsColumnResize ? "iExpandedWidth" : "iExpandedHeight"];
			iOldSize = iFactor * (oContainer["sCollapseDirection"] == UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"]
				? Math["ceil"](iPreviousElementsOffsetOld / iFactor)
				: Math["ceil"](iNextElementsOffsetOld / iFactor));
			var iNewExpandedSize = oContainer["sCollapseDirection"] == UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"]
				? /*mSashInfo.*/ iExpandedSize < 1 && iSize > UCF_Splitter_ie6["iCollapseSize"]
					? 0
					//in % and px
					: iOldSize < UCF_Splitter_ie6["iCollapseSize"]
						? 0
						: Math["ceil"](iOldSize / iFactor)
				: //oContainer.sCollapseDirection == UCF_Splitter_ie6.E_COLLAPSE_DIRECTION.NEXT
				iExpandedSize < 1 && (iNextSize * iFactor) > UCF_Splitter_ie6["iCollapseSize"]
					? 0
					//in % and px
					: iOldSize < UCF_Splitter_ie6["iCollapseSize"]
						? 0
						: Math["ceil"](iOldSize / iFactor);
			oContainer[bIsColumnResize ? "iExpandedWidth" : "iExpandedHeight"] = iNewExpandedSize;

		}

		if (oContainer["sCollapseDirection"] != UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["NONE"]) {
			//adjust images if collapsed or expanded
			iExpandedSize = oContainer[bIsColumnResize ? "iExpandedWidth" : "iExpandedHeight"];
			var bShowCloseIcon = oContainer["sCollapseDirection"] == UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["PREVIOUS"] && iExpandedSize > 0
				//in NEXT the iExpanded is the value of the previous column so the logic is different to previous
				|| oContainer["sCollapseDirection"] == UCF_Splitter_ie6["E_COLLAPSE_DIRECTION"]["NEXT"] && iExpandedSize < 1;

			UCF_DomUtil["replaceClass"](this["oSash"],
				bIsColumnResize && !window["UCF_System"]["bIsRTL"]
					? bShowCloseIcon ? "urSpTDVP" : "urSpTDVN"
					: bShowCloseIcon ? "urSpTDHP" : "urSpTDHN",
				bIsColumnResize && !window["UCF_System"]["bIsRTL"]
					? bShowCloseIcon ? "urSpTDVN" : "urSpTDVP"
					: bShowCloseIcon ? "urSpTDHN" : "urSpTDHP");

			var oA = UCF_DomUtil["firstChild"](this["oSash"], "A");
			if (oA) {
				b = bIsColumnResize
					? window["UCF_System"]["bIsRTL"]
						? !bShowCloseIcon
						: bShowCloseIcon
					: bShowCloseIcon;
				UCF_DomUtil["replaceClass"](oA,
					b ? "urSpTDP" : "urSpTDN",
					b ? " urSpTDN" : " urSpTDP");
			}

			if (window["UCF_System"]["sInteractionType"] === 'TOUCH') {
				var oTouch = UCF_DomUtil["firstChild"](this["oSash"], "DIV")["firstChild"]["firstChild"];
				if (oTouch) {
					b = bIsColumnResize
						? window["UCF_System"]["bIsRTL"]
							? !bShowCloseIcon
							: bShowCloseIcon
						: bShowCloseIcon;
					UCF_DomUtil["replaceClass"](oTouch,
						b ? "urSpTDP" : "urSpTDN",
						b ? " urSpTDN" : " urSpTDP");
				}
			}
		}

		//avoids multiple re-flow (rendering of the screen)
		oStyle["visibility"] = "visible";
		//IE blurs the activeElement when setting visibility to hidden ... therefore store activeElement for the case of keyboardNavigation and
		//restore again when setting visibility to visible
		if (bKeyBoardNavigation) {
			UCF_DomUtil["focusDomElement"](oActiveElement);
		}

		//MoveEnd fired if the Sash was moved
		this["fireMoveEnd"](
			this["sId"], bIsColumnResize,
			//return maybe an invalid value because browser sometimes don't updates the sizes immediately
			iPreviousSize, iNextSize, !bIsRelative,
			aPrevCells["join"](","),
			bPrevIsDefaultSize,
			aNextCells["join"](","),
			bNextIsDefaultSize,
			bIsColumnResize ? oContainer["iExpandedWidth"] : oContainer["iExpandedHeight"]
		);

		//_trace(INFO, "Splitter onlsdragend in '" + this.sId	+ "' " + UCF_Splitter_ie6.sGetSubControlId(oBrowserEvent) );
		this["releaseSash"](oBrowserEvent);

		// Notify framework, that layout has changed after moving the sash
		this["notifyLayoutChange"]();

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;

		if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, this["sId"], "Hide active sash"); };
		//_trace(DEBUG, "Deactivate Sash finished.");
		return UCF_Splitter_ie6["ACCESS_TYPE"]["DRAG_END"];
	} //end mSashInfo != null
	return null;
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsdragend"] = 0; };
/* eslint-enable complexity */

/** Private method that release the blind layers
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Splitter_ie6["prototype"]["releaseSash"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["releaseSash"]++; }; 
	//oBrowserEvent and this.oDomRef is null at destroy()
	var oStyle = null;
	//	if (!oBrowserEvent || ! oBrowserEvent.bCtrl())
	{
		if (this["oBackgroundShim"]) {
			oStyle = this["oBackgroundShim"]["style"];
			//oStyle.position = "absolute";
			oStyle["display"] = "none";
			//oStyle.top = "-1000px";
			oStyle["height"] = "1px";
			oStyle["marginTop"] = "-1px";
			oStyle["cursor"] = "";
			//this.oLS.releaseShim(this.oBackgroundShim);
		}

		if (this["oBackgroundDomRef"]) {
			oStyle = this["oBackgroundDomRef"]["style"];
			//oStyle.position = "absolute";
			oStyle["display"] = "none";
			//oStyle.top =	"-1000px";
			oStyle["height"] = "1px";
			oStyle["marginTop"] = "-1px";
			oStyle["cursor"] = "";
		}
	}

	if (this["oSashShim"]) {
		oStyle = this["oSashShim"]["style"];
		//oStyle.position = "absolute";
		oStyle["display"] = "none";
		//oStyle.top = "-1000px";
		oStyle["height"] = "1px";
		oStyle["marginTop"] = "-1px";
		oStyle["cursor"] = "";
		//this.oLS.releaseShim(this.oSashShim);
	}
	if (this["oSashDomRef"]) {
		oStyle = this["oSashDomRef"]["style"];
		//oStyle.position = "absolute";
		oStyle["display"] = "none";
		oStyle["visibility"] = "hidden";
		//oStyle.top = "-1000px";
		oStyle["height"] = "1px";
		oStyle["marginTop"] = "-1px";
		oStyle["cursor"] = "";
	}

	//avoids user select
	if (this["oDomRef"]) {
		//is null in the destroy method
		oStyle = this["oDomRef"]["style"];
		oStyle["UserSelect"] = "";
		if (UCF_UserAgent["bIsGecko"]()) {
			oStyle["MozUserSelect"] = "";
			oStyle["MozUserFocus"] = "";
			oStyle["MozUserInput"] = "";
		} else if (UCF_UserAgent["bIsWebKit"]()) {
			oStyle["WebkitUserSelect"] = "";
		}

		//reset cursor on Splitter so that cursor is always showed
		oStyle["cursor"] = "";
	}

	//this.lastActiveElement =
	this["iPageX"] =
		this["iPageY"] =
		//this.prevRect =
		//this.nextRect =
		this["mSplitterRect"] =
		this["mSashRect"] =
		this["mSashInfo"] =
		this["oSource"] =
		this["oSash"] = null;
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["releaseSash"] = 0; };

/** Updates the visualisation of the active sash after mouse move
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Splitter_ie6["prototype"]["onlsdrag"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsdrag"]++; }; 
	var mSashInfo = this["mSashInfo"];
	var iSize;

	if (mSashInfo != null) {
		//_measure(START,this.sId + "-d");

		var iPageX = oBrowserEvent["iPageX"](),
			iPageY = oBrowserEvent["iPageY"]()
			//,oDS = this.oDragAndDropManager.oDragSession
			;

		if (iPageX != this["iPageX"] || iPageY != this["iPageY"]) {
			//TODO: add animation to have a more smooth transition at resizing
			if (this["bIsColumnResize"]()) {
				//the same position like in lsdragstart

				iSize = window["UCF_System"]["bIsRTL"]
					? this["mSplitterRect"]["left"] + this["mSplitterRect"]["width"] - iPageX
					: iPageX - this["mSplitterRect"]["left"] - mSashInfo["iSashDragPosition"];
				var iMargin = iSize < mSashInfo["iMin"] + UCF_Splitter_ie6["iCollapseSize"]
					? mSashInfo["iMin"] + "px"
					: iSize > mSashInfo["iMax"] - UCF_Splitter_ie6["iCollapseSize"]
						? mSashInfo["iMax"] + "px"
						: iSize + "px";

				if (window["UCF_System"]["bIsRTL"]) {
					this["oSashDomRef"]["style"]["marginRight"] = this["oSashShim"]["style"]["marginRight"] = iMargin;
				} else {
					this["oSashDomRef"]["style"]["marginLeft"] = this["oSashShim"]["style"]["marginLeft"] = iMargin;
				}
			} else {
				//horizontal sash

				iSize = (iPageY - mSashInfo["prevRect"]["top"] - mSashInfo["iSplitterSize"] - this["mSashRect"]["height"]);
				this["oSashShim"]["style"]["marginTop"] =
					iSize < mSashInfo["iMin"] + UCF_Splitter_ie6["iCollapseSize"]
						? mSashInfo["iMin"] + "px"
						: iSize > mSashInfo["iMax"] - UCF_Splitter_ie6["iCollapseSize"]
							? mSashInfo["iMax"] + "px"
							: iSize + "px";
			}

			//this.iPageX = iPageX;
			//this.iPageY = iPageY;
		}

		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;

		return UCF_Splitter_ie6["ACCESS_TYPE"]["DRAG"];
		//_measure(STOP,this.sId + "-d", "Move active sash");
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsdrag"] = 0; };

/** Skips to the following splitter cell
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Splitter_ie6["prototype"]["onlsskipforward"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Splitter_ie6.js(1751): onlsskipforward"); };
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {HTMLElement} */
	var div = UCF_DomUtil["oGetCTElement"](oSource);
	/** @type {HTMLElement} */
	var oResult;
	/** @type {HTMLElement} */
	var oDomElement;
	/** @type {HTMLElement} */
	var oFirstChild;

	while (div != null && !UCF_DomUtil["bIsCTInstanceOf"](div, 'SPCE_ie6')) {
		div = UCF_DomUtil["oGetCTElement"](div["parentNode"]); // splitter cell found
	}
	// div is null if focus was on the sash
	// div equals the cell in which the focused dom element lives

	if (div != null) {
		// dom element was focused
		oDomElement = UCF_DomUtil["oGetParentByTagName"](div, 'TD');
		if (oDomElement) {
			oDomElement = UCF_DomUtil["nextSibling"](oDomElement, 'TD'); //verti. sash
		}
		if (oDomElement != null) {
			oFirstChild = oDomElement["firstChild"];
			if (oFirstChild && !UCF_DomUtil["bIsCTInstanceOf"](oFirstChild, 'SPCE_ie6')) {
				oDomElement = UCF_DomUtil["nextSibling"](oDomElement, 'TD'); //next cell
			}
		} else {
			// new row
			oDomElement = UCF_DomUtil["oGetParentByTagName"](div, 'TD');
			oDomElement = UCF_DomUtil["oGetParentByTagName"](oDomElement, 'TR'); //SPR_ie6
			oDomElement = UCF_DomUtil["nextSibling"](oDomElement, 'TR'); //sash
			oDomElement = UCF_DomUtil["nextSibling"](oDomElement, 'TR'); //row
			if (UCF_DomUtil["bIsCTInstanceOf"](oSource, 'SPR_ie6')) {
				oDomElement = UCF_DomUtil["firstChild"](oDomElement, 'TD');
			}
		}
	} else {
		// sash was focused
		oDomElement = UCF_DomUtil["nextSibling"](oSource, 'TD');
	}

	if (oDomElement) {
		oResult = UCF_DomUtil["oGetTabbableElementForward"](oDomElement, true);
	} else {
		// horizontal sash
		oDomElement = UCF_DomUtil["oGetParentByTagName"](oSource, 'TR'); //row tr
		oDomElement = UCF_DomUtil["nextSibling"](oDomElement, 'TR'); // horiz. sash
		oDomElement = UCF_DomUtil["firstChild"](oDomElement, 'TD'); // cell
		if (oDomElement === null) {
			//do nothing
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Splitter skip forward to next element was NOT successfull - bubble up.", "Splitter_ie6.js(1804): onlsskipforward"); };
			var focussed = this["focusNextControl"](); //try to focus next sibling and their children
			if (focussed) {
				oBrowserEvent["cancel"]();
				oBrowserEvent["cancelBubble"]();
			} else {
				oResult = UCF_DomUtil["oGetTabbableElementForward"](document["body"]);
			}
		} else {
			oResult = UCF_DomUtil["oGetTabbableElementForward"](oDomElement, true);
		}
	}
	if (oResult && UCF_DomUtil["bDomElementFocused"](oResult)) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Splitter skip forward to next cell", "Splitter_ie6.js(1817): onlsskipforward"); };
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Splitter skip forward to next cell was NOT successfull - bubble up.", "Splitter_ie6.js(1821): onlsskipforward"); };
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsskipforward"] = 0; };

/** Skip to the previous splitter cell
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Splitter_ie6["prototype"]["onlsskipback"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Splitter_ie6.js(1831): onlsskipback"); };
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {HTMLElement} */
	var div = UCF_DomUtil["oGetCTElement"](oSource);
	/** @type {HTMLElement} */
	var oResult;
	/** @type {HTMLElement} */
	var oDomElement;
	/** @type {HTMLElement} */
	var oLastChild;

	while (div != null && !UCF_DomUtil["bIsCTInstanceOf"](div, 'SPCE_ie6')) {
		div = UCF_DomUtil["oGetCTElement"](div["parentNode"]); // splitter cell found
	}
	// div is null if focus was on the sash
	// div equals the cell in which the focused dom element lives

	if (div != null) {
		// dom element was focused
		oDomElement = UCF_DomUtil["oGetParentByTagName"](div, 'TD');
		if (oDomElement) {
			oDomElement = UCF_DomUtil["previousSibling"](oDomElement, 'TD'); //verti. sash
		}
		if (oDomElement != null) {
			oLastChild = oDomElement["lastChild"];
			if (oLastChild && !UCF_DomUtil["bIsCTInstanceOf"](oLastChild, 'SPCE_ie6')) {
				oDomElement = UCF_DomUtil["previousSibling"](oDomElement, 'TD'); //next cell
			}
		} else {
			// new row
			oDomElement = UCF_DomUtil["oGetParentByTagName"](div, 'TD');
			oDomElement = UCF_DomUtil["oGetParentByTagName"](oDomElement, 'TR'); //SPR_ie6
			oDomElement = UCF_DomUtil["previousSibling"](oDomElement, 'TR'); //sash
			oDomElement = UCF_DomUtil["previousSibling"](oDomElement, 'TR'); //row
			if (UCF_DomUtil["bIsCTInstanceOf"](oSource, 'SPR_ie6')) {
				oDomElement = UCF_DomUtil["lastChild"](oDomElement, 'TD');
			}
		}
	} else {
		// sash was focused
		oDomElement = UCF_DomUtil["previousSibling"](oSource, 'TD');
	}

	if (oDomElement) {
		oResult = UCF_DomUtil["oGetTabbableElementBackward"](oDomElement, true);
	} else {
		// horizontal sash
		oDomElement = UCF_DomUtil["oGetParentByTagName"](oSource, 'TR'); //row tr
		oDomElement = UCF_DomUtil["previousSibling"](oDomElement, 'TR'); // horiz. sash
		oDomElement = UCF_DomUtil["lastChild"](oDomElement, 'TD'); // cell
		if (oDomElement === null) {
			//do nothing
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Splitter skip back to next element was NOT successfull - bubble up.", "Splitter_ie6.js(1884): onlsskipback"); };
			var focussed = this["focusPreviousControl"](); //try to focus previous sibling and their children
			if (focussed) {
				oBrowserEvent["cancel"]();
				oBrowserEvent["cancelBubble"]();
			} else {
				oResult = UCF_DomUtil["oGetTabbableElementBackward"](document["body"]);
			}
		} else {
			oResult = UCF_DomUtil["oGetTabbableElementBackward"](oDomElement, true);
		}
	}
	if (oResult && UCF_DomUtil["bDomElementFocused"](oResult)) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Splitter skip back to next cell", "Splitter_ie6.js(1897): onlsskipback"); };
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Splitter skip back to next cell was NOT successfull - bubble up.", "Splitter_ie6.js(1901): onlsskipback"); };
	}
	};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsskipback"] = 0; };

/** Fills the {UCF_AccessibilityHelper}
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Splitter_ie6["prototype"]["onlsaccessibility"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Splitter_ie6.js(1911): onlsaccessibility"); };

	var oSrcControl = oBrowserEvent["oGetSourceControl"]();
	if (oSrcControl == this
		|| (UCF_JsUtil["bInstanceOf"](oSrcControl, "UCF_SplitterRow_ie6") && oSrcControl["oGetParent"]() === this)
		|| (UCF_JsUtil["bInstanceOf"](oSrcControl, "UCF_SplitterCell_ie6") && oSrcControl["oGetParent"]()["oGetParent"]() === this)
	) {
		var oDom = oBrowserEvent["oGetSource"]();
		var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
		if (UCF_DomUtil["bIsCTInstanceOf"](oDom, UCF_Splitter_ie6["E_CT"]["CELL"])) {
			//cell
			oAccessibilityHelper["setControlType"](UCF_Splitter_ie6["E_CT"]["SPLITTER"]);
			oAccessibilityHelper["applyContainerEntryBehaviour"]();
		} else if (oDom["getAttribute"]("id")["indexOf"]((this["sId"] + "-VSR")) != -1) {
			///vertical sash
			oAccessibilityHelper["setControlType"]("SP_SASH_VERTICAL");
			oAccessibilityHelper["addTutor"]("SP_SASH_TUT");
		} else if (oDom["getAttribute"]("id")["indexOf"]((this["sId"] + "-HSR")) != -1) {
			//horizontal sash
			oAccessibilityHelper["setControlType"]("SP_SASH_HORIZONTAL");
			oAccessibilityHelper["addTutor"]("SP_SASH_TUT");
		}
	} //else do nothing
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsaccessibility"] = 0; };

/**
 * Returns the size of the activated element.
 *
 * @param {string} oObject
 * @param {string} eDirection
 * @return {int} size of the element
 * @private
 */
UCF_Splitter_ie6["iGetSize"] = function (eDirection, oObject) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["iGetSize"]++; }; 
	var iLen = oObject["length"];
	if (iLen) {
		var iSize = -1,
			oDomRef;
		for (var i = iLen; i--;) {
			if (typeof oObject[i] === "string") {
				oDomRef = UCF_DomUtil["$"](oObject[i]);
			} else {
				oDomRef = oObject[i];
			}

			{
				if (eDirection === UCF_Splitter_ie6["E_DIRECTION"]["COLUMN"]) {
					var sWidth = oDomRef["style"]["width"];
					if (!sWidth || sWidth["indexOf"]("%") > -1 || sWidth === "") {
						//Relative
						iSize = oDomRef["offsetWidth"];
					} else {
						//Absolute
						iSize = sWidth;
						break;
					}
				} else if (eDirection == UCF_Splitter_ie6["E_DIRECTION"]["ROW"]) {
					var sHeight = oDomRef["style"]["height"];
					if (!sHeight || sHeight["indexOf"]("%") > -1 || sHeight === "") {
						//Relative
						iSize = oDomRef["offsetHeight"];
					} else {
						//Absolute
						iSize = sHeight;
						break;
					}
				}
			}
		}
		if (__UCF_ASSERT__) { UCF_Tracer.assert(iSize != -1, "iSize != -1", "Splitter_ie6.js(1980): iGetSize"); };
		//Unexpected error: Cannot determine size
		return UCF_StringUtil["iParseInt"](iSize);
	} else {
		return UCF_Splitter_ie6["iGetSize"](eDirection, new Array(oObject));
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["iGetSize"] = 0; };

/** Returns the splitter sub controls (Rows, Cells) that are affected by the resize operation
 *
 * @return Map: prev, next: the elements with the changed width/height;prevCells, nextCells: the SplitterCells;prevRow, nextRow: the SplitterRow elements
 * @type Map
 * @private
 */
UCF_Splitter_ie6["prototype"]["aGetElements"] = function (eDirection, oSplitterTable, iPosition) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["aGetElements"]++; }; 
	if (eDirection == UCF_Splitter_ie6["E_DIRECTION"]["COLUMN"]) {
		return UCF_Splitter_ie6["aGetColumnCells"](oSplitterTable, iPosition);
	} else if (eDirection == UCF_Splitter_ie6["E_DIRECTION"]["ROW"]) {
		return UCF_Splitter_ie6["aGetRowCells"](oSplitterTable, iPosition);
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["aGetElements"] = 0; };

/** Returns a list of sub elements for the sash
 *
 * @return Map: prev, next: the elements with the changed width/height;prevCells, nextCells: the SplitterCells;prevCol, nextCol: the SplitterCol elements
 * @type Map
 * @private
 */
UCF_Splitter_ie6["aGetColumnCells"] = function (oSplitterTable, iPosition) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["aGetColumnCells"]++; }; 
	var colgroup = UCF_DomUtil["firstChild"](oSplitterTable, "COLGROUP");
	var sPreviousCol;
	var sNextCol;
	var iTr1N;
	var oDiv;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(colgroup != null, "colgroup != null", "Splitter_ie6.js(2016): aGetColumnCells"); };
	var cols = UCF_DomUtil["childNodes"](colgroup, "COL"),
		iTr1 = 0,
		iTr2 = 0,
		colL = cols["length"];
	sPreviousCol = null;
	sNextCol = null;
	iTr1N = 0;
	if (__UCF_ASSERT__) { UCF_Tracer.assert(cols != null, "cols != null", "Splitter_ie6.js(2024): aGetColumnCells"); };
	if (colL > 0) {
		// eslint-disable-next-line no-redeclare
		for (var iTr1 = 0; iTr1 < colL; iTr1++) {
			if (cols[iTr1]["getAttribute"]("ct") === null) continue;
			if (iTr2 === iPosition) {
				sPreviousCol = cols[iTr1]["id"];
				var oN = cols[iTr1 + 1];
				if (oN["getAttribute"]("ct") != null) {
					sNextCol = oN["id"];
					iTr1N = iTr1 + 1;
				} else {
					sNextCol = cols[iTr1 + 2]["id"];
					iTr1N = iTr1 + 2;
				}
				break;
			}
			iTr2++;
		}

		if (sPreviousCol == null) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "Unexpected error: Unknown col", "Splitter_ie6.js(2045): aGetColumnCells"); };
		}
	}

	// IDs of the preceding components in relation to the selected sash
	var aPreviousSplitterCells = new Array(),
		// IDs of the following components in relation to the selected sash
		aNextSplitterCells = new Array(),
		tbody = UCF_DomUtil["firstChild"](oSplitterTable, "TBODY"),
		trs = UCF_DomUtil["childNodes"](tbody, "TR"),
		trsL = trs["length"]; {
		for (var iTrRow = 0; iTrRow < trsL; iTrRow++) {
			var oTr = trs[iTrRow];
			if (oTr["getAttribute"]("ct") != null) { //ignore horizontal sashs
				var tds = UCF_DomUtil["childNodes"](oTr, "TD");
				if (tds["length"] > 0) {
					if (iTrRow == 0) {
						oDiv = tds[iTr1];
						if (__UCF_ASSERT__) { UCF_Tracer.assert(oDiv != null && oDiv["id"] && oDiv["id"] != null, "oDiv != null && oDiv.id && oDiv.id != null", "Splitter_ie6.js(2063): aGetColumnCells"); };
						aPreviousSplitterCells["push"](oDiv["id"]);
						if (tds[iTr1N]) {
							oDiv = tds[iTr1N];
							if (__UCF_ASSERT__) { UCF_Tracer.assert(oDiv != null && oDiv["id"] && oDiv["id"] != null, "oDiv != null && oDiv.id && oDiv.id != null", "Splitter_ie6.js(2067): aGetColumnCells"); };
							aNextSplitterCells["push"](oDiv["id"]);
						}
					} else {
						oDiv = tds[iTr2];
						if (__UCF_ASSERT__) { UCF_Tracer.assert(oDiv != null && oDiv["id"] && oDiv["id"] != null, "oDiv != null && oDiv.id && oDiv.id != null", "Splitter_ie6.js(2072): aGetColumnCells"); };
						aPreviousSplitterCells["push"](oDiv["id"]);
						if (tds[iTr2 + 1]) {
							oDiv = tds[iTr2 + 1];
							if (__UCF_ASSERT__) { UCF_Tracer.assert(oDiv != null && oDiv["id"] && oDiv["id"] != null, "oDiv != null && oDiv.id && oDiv.id != null", "Splitter_ie6.js(2076): aGetColumnCells"); };
							aNextSplitterCells["push"](oDiv["id"]);
						}
					}
				}
			}
			oTr = UCF_DomUtil["nextSibling"](oTr, "TR");
		}
	}
	return { "prev": sPreviousCol, "next": sNextCol, "prevCol": sPreviousCol, "nextCol": sNextCol, "prevCells": aPreviousSplitterCells, "nextCells": aNextSplitterCells };

};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["aGetColumnCells"] = 0; };

/** Returns a list of sub elements for the sash
 *
 * @return Map: prev, next: the elements with the changed width/height;prevCells, nextCells: the SplitterCells;prevRow, nextRow: the SplitterRow elements
 * @type Map
 * @private
 */
UCF_Splitter_ie6["aGetRowCells"] = function (oSplitterTable, iPosition) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["aGetRowCells"]++; }; 
	// IDs of the preceding Divs in relation to the selected sash
	var aPreviousSplitterCells = new Array(),
		// IDs of the following Divs in relation to the selected sash
		aNextSplitterCells = new Array(),
		//IDs of the preceding TDs in relation to the selected sash
		aPrev = new Array(),
		//IDs of the following TDs in relation to the selected sash
		aNext = new Array(),
		tbody = UCF_DomUtil["firstChild"](oSplitterTable, "TBODY"),
		trs = UCF_DomUtil["childNodes"](tbody, "TR"),
		trsL = trs["length"],
		oPreviousTr,
		oNextTr,
		iTr = 0;
	var p;
	var oTd;
	var iLen;

	if (trsL > 0) {
		for (var iTrRow = 0; iTrRow < trsL; iTrRow++) {
			var oTr = trs[iTrRow];
			if (oTr["getAttribute"]("ct") === null) continue;
			if (iTr === iPosition) {
				oPreviousTr = oTr;
				var oN = trs[iTrRow + 1];
				if (oN["getAttribute"]("ct") != null) {
					oNextTr = oN;
				} else {
					oNextTr = trs[iTrRow + 2];
				}
				break;
			}
			iTr++;
		}
		var oPreviousTds = UCF_DomUtil["childNodes"](oPreviousTr, "TD");
		iLen = oPreviousTds["length"];
		if (iPosition == 0) {
			//first line with sashs
			for (p = 0; p < iLen; p++) {
				oTd = oPreviousTds[p];
				if (oTd["getAttribute"]("tp") != null) { continue; }
				if (__UCF_ASSERT__) { UCF_Tracer.assert(oTd["id"], "oTd.id", "Splitter_ie6.js(2137): aGetRowCells"); };
				aPrev["push"](oTd["id"]);
			}
		} else {
			//all other lines without sashs
			for (p = 0; p < iLen; p++) {
				oTd = oPreviousTds[p];
				if (__UCF_ASSERT__) { UCF_Tracer.assert(oTd["id"], "oTd.id", "Splitter_ie6.js(2144): aGetRowCells"); };
				aPrev["push"](oTd["id"]);
				// divs should not be adjusted in relative mode
				if (false) {
					var oDiv = UCF_DomUtil["firstChild"](oTd, "DIV");
					if (__UCF_ASSERT__) { UCF_Tracer.assert(oDiv["id"], "oDiv.id", "Splitter_ie6.js(2149): aGetRowCells"); };
					//_trace(ERROR,"Unexpected error: missing ID in prev row component pos:" + p);
					aPreviousSplitterCells["push"](oDiv["id"]);
				}
			}
		}

		//next elements only lines without sash possible
		var oNextTds = UCF_DomUtil["childNodes"](oNextTr, "TD");
		iLen = oNextTds["length"];
		for (p = 0; p < iLen; p++) {
			oTd = oNextTds[p];
			if (__UCF_ASSERT__) { UCF_Tracer.assert(oTd["id"], "oTd.id", "Splitter_ie6.js(2161): aGetRowCells"); };
			aNext["push"](oTd["id"]);
		}

	}
	return { "prevCells": aPrev, "nextCells": aNext, "prevRow": oPreviousTr == null ? null : oPreviousTr["id"], "nextRow": oNextTr == null ? null : oNextTr["id"], "prev": aPreviousSplitterCells, "next": aNextSplitterCells };
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["aGetRowCells"] = 0; };

/** Changes the size of all cells in one column or one row
 *
 * @param {string} eDirection columns or cells?
 * @param {int} iPosition the index in the list of rows or columns
 * @param {int} iSize the new size
 * @private
 */
UCF_Splitter_ie6["prototype"]["setCellSize"] = function (eDirection, iPosition, iSize) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["setCellSize"]++; }; 
	if (eDirection == UCF_Splitter_ie6["E_DIRECTION"]["COLUMN"]) {
		this["setColumnWidth"](iPosition, iSize);
	} else if (eDirection == UCF_Splitter_ie6["E_DIRECTION"]["ROW"]) {
		this["setRowHeight"](iPosition, iSize);
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["setCellSize"] = 0; };

/**
 * Sets the width of a column.
 *
 * @param {int} iPosition the index in the list of columns
 * @param {int} iSize the new size
 * @public
 */
UCF_Splitter_ie6["prototype"]["setColumnWidth"] = function (iPosition, iSize) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["setColumnWidth"]++; }; 

	var oSplitter = UCF_DomUtil["firstChild"](this["oDomRef"], "TABLE"),
		aCells = UCF_Splitter_ie6["aGetColumnCells"](oSplitter, Math["floor"](iPosition / 2)),
		bRelative = this["sWidthSizeModeOfColums"] == UCF_Splitter_ie6["E_SIZEMODE"]["RELATIVE"],
		iLen = aCells["prevCells"]["length"],
		sWidth = iSize > 0 ?
			(iSize + (bRelative ? "%" : "px"))
			: iSize == 0 ?
				(bRelative ? "1%" : "1px") //don't hide cells in 508 so that it can be focused
				: // flexible column
				"1*", //TODO
		sWidthCells = iSize > -1 ? sWidth : null;

	if (Math["floor"](iPosition / 2) == iPosition) UCF_DomUtil["$"](aCells["prevCol"])["style"]["width"] = sWidth;
	else UCF_DomUtil["$"](aCells["nextCol"])["style"]["width"] = sWidth;

	for (var iPanesPosition = iLen; iPanesPosition--;) {
		if (Math["floor"](iPosition / 2) == iPosition) UCF_DomUtil["$"](aCells["prevCells"][iPanesPosition])["style"]["width"] = sWidthCells;
		else UCF_DomUtil["$"](aCells["nextCells"][iPanesPosition])["style"]["width"] = sWidthCells;

		UCF_DomUtil["$"](aCells["prevCells"][iPanesPosition])["firstChild"]["style"]["visibility"] = "";
		UCF_DomUtil["$"](aCells["nextCells"][iPanesPosition])["firstChild"]["style"]["visibility"] = "";
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["setColumnWidth"] = 0; };

/**
 * Sets the width of the Splitter control.
 *
 * @param {int} iSize the new size
 * @public
 */
UCF_Splitter_ie6["prototype"]["setSplitterWidth"] = function (iSize) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["setSplitterWidth"]++; }; 

	var oSplitter = UCF_DomUtil["firstChild"](this["oDomRef"], "TABLE");
	if (iSize > 0) {
		oSplitter["width"] = iSize + (this["sWidthSizeMode"] == UCF_Splitter_ie6["E_SIZEMODE"]["RELATIVE"] ? "%" : "px");
		return;
	} else {
		oSplitter["width"] = "100%";
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["setSplitterWidth"] = 0; };

/**
 * Sets the height of a row.
 *
 * @param {int} iPosition the index in the list of rows
 * @param {int} iSize the new size
 * @public
 */
UCF_Splitter_ie6["prototype"]["setRowHeight"] = function (iPosition, iSize) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["setRowHeight"]++; }; 

	var oSplitter = UCF_DomUtil["firstChild"](this["oDomRef"], "TABLE"),
		aCells = UCF_Splitter_ie6["aGetRowCells"](oSplitter, Math["floor"](iPosition / 2)),
		bRelative = this["sHeightSizeModeOfRows"] == UCF_Splitter_ie6["E_SIZEMODE"]["RELATIVE"],
		iLen = aCells["prevCells"]["length"],
		sHeight = iSize > 0 ?
			(iSize + (bRelative ? "%" : "px"))
			: iSize == 0 ?
				(bRelative ? "1%" : "1px") //don't hide cells in 508 so that it can be focused
				: // flexible column
				"1*", //TODO
		sHeightCells = iSize > -1 ? sHeight : null;
	var iPanesPosition;

	if (Math["floor"](iPosition / 2) == iPosition) UCF_DomUtil["$"](aCells["prevRow"])["style"]["height"] = sHeight;
	else UCF_DomUtil["$"](aCells["nextRow"])["style"]["height"] = sHeight;

	for (iPanesPosition = iLen; iPanesPosition--;) {
		if (Math["floor"](iPosition / 2) == iPosition) UCF_DomUtil["$"](aCells["prevCells"][iPanesPosition])["style"]["height"] = sHeightCells;
		else UCF_DomUtil["$"](aCells["nextCells"][iPanesPosition])["style"]["height"] = sHeightCells;

		UCF_DomUtil["$"](aCells["prevCells"][iPanesPosition])["firstChild"]["style"]["visibility"] = "";
		UCF_DomUtil["$"](aCells["nextCells"][iPanesPosition])["firstChild"]["style"]["visibility"] = "";
	}

	iLen = aCells["prev"]["length"];
	for (iPanesPosition = iLen; iPanesPosition--;) {
		if (Math["floor"](iPosition / 2) == iPosition) UCF_DomUtil["$"](aCells["prev"][iPanesPosition])["style"]["height"] = sHeightCells;
		else UCF_DomUtil["$"](aCells["next"][iPanesPosition])["style"]["height"] = sHeightCells;
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["setRowHeight"] = 0; };

/**
 * Sets the height of the Splitter control.
 *
 * @param {int} iSize the new size
 * @public
 */
UCF_Splitter_ie6["prototype"]["setSplitterHeight"] = function (iSize) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["setSplitterHeight"]++; }; 

	var oSplitter = UCF_DomUtil["firstChild"](this["oDomRef"], "TABLE");
	if (iSize > 0) {
		if (this["sHeightSizeMode"] == UCF_Splitter_ie6["E_SIZEMODE"]["RELATIVE"]) {
			oSplitter["height"] = iSize + "%";
			return;
		} else //if (sizeMode == UCF_Splitter_ie6.E_SIZEMODE.ABSOLUTE)
		{
			oSplitter["height"] = iSize + "px";
			return;
		}
	} else {
		oSplitter["height"] = "100%";
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["setSplitterHeight"] = 0; };

/**
 * Forces a refresh of the table rendering in the browser. This is needed to fix some calculation problems.
 * TODO: table is sometimes not drawn correctly
 *
 * @private
 */
UCF_Splitter_ie6["prototype"]["refresh"] = function (oTableDomRef) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["refresh"]++; }; 
	//oTableDomRef.style.marginTop = "0px";
	//oTableDomRef.style.marginLeft = "0px";
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["refresh"] = 0; };

/**
 * Forces a refresh of the table rendering in the browser. This is needed to fix some calculation problems.
 *
 * @param {Object} oTableDomRef table the DOM element of the table
 * @private
 */
UCF_Splitter_ie6["prototype"]["refreshTable"] = function (oTableDomRef) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["refreshTable"]++; }; 
	if (oTableDomRef["refresh"]) {
		oTableDomRef["refresh"]();
	} else { //simulate refresh for firefox
		//oTableDomRef.style.marginTop = "1px";
		//oTableDomRef.style.marginLeft = "1px";

		/** timout to refresh the table is Table.refesh() doesn't exists
		 * @private
		 */
		this["sRefreshTimeout"] = UCF_JsUtil["delayedCall"](0, this, "refresh", [oTableDomRef]);

		//use multiple timeouts, because refresh works not in every case
		//TODO: find a better workaround for the missing refresh functionality on the table
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["refreshTable"] = 0; };

/**
 * Shift arrow up
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the onlsupmodifier
 */
UCF_Splitter_ie6["prototype"]["onlsupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsupmodifier"]++; }; 
	var sId = oBrowserEvent["oGetSource"]()["getAttribute"]("id");

	if (UCF_KeyboardHelper["bHasModifiers"](oBrowserEvent, 's') && sId &&
		(sId["indexOf"](this["sId"] + "-VSR") != -1 || sId["indexOf"](this["sId"] + "-HSR") !== -1)) {
		this["onmousedown"](oBrowserEvent);
		this["onmouseup"](oBrowserEvent);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsupmodifier"] = 0; };

/**
 * Shift arrow left
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lspreviousmodifier
 */
UCF_Splitter_ie6["prototype"]["onlspreviousmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlspreviousmodifier"]++; }; 
	var sId = oBrowserEvent["oGetSource"]()["getAttribute"]("id");
	if (UCF_KeyboardHelper["bHasModifiers"](oBrowserEvent, 's') && sId && (sId["indexOf"](this["sId"] + "-VSR") !== -1 || sId["indexOf"](this["sId"] + "-HSR") !== -1)) {
		this["onmousedown"](oBrowserEvent);
		this["onmouseup"](oBrowserEvent);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlspreviousmodifier"] = 0; };

/**
 * Shift arrow down
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdownmodifier
 */
UCF_Splitter_ie6["prototype"]["onlsdownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsdownmodifier"]++; }; 
	var sId = oBrowserEvent["oGetSource"]()["getAttribute"]("id");

	if (UCF_KeyboardHelper["bHasModifiers"](oBrowserEvent, 's') && sId &&
		(sId["indexOf"](this["sId"] + "-VSR") !== -1 || sId["indexOf"](this["sId"] + "-HSR") !== -1)) {
		this["onmousedown"](oBrowserEvent);
		this["onmouseup"](oBrowserEvent);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsdownmodifier"] = 0; };

/**
 * Shift arrow right
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsnextmodifier
 */
UCF_Splitter_ie6["prototype"]["onlsnextmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsnextmodifier"]++; }; 
	var sId = oBrowserEvent["oGetSource"]()["getAttribute"]("id");
	if (UCF_KeyboardHelper["bHasModifiers"](oBrowserEvent, 's') && sId && (sId["indexOf"](this["sId"] + "-VSR") !== -1 || sId["indexOf"](this["sId"] + "-HSR") !== -1)) {
		this["onmousedown"](oBrowserEvent);
		this["onmouseup"](oBrowserEvent);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsnextmodifier"] = 0; };

/**
 * Home
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshome
 */
UCF_Splitter_ie6["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlshome"]++; }; 
	var sId = oBrowserEvent["oGetSource"]()["getAttribute"]("id");
	if (sId && (sId["indexOf"](this["sId"] + "-VSR") !== -1 || sId["indexOf"](this["sId"] + "-HSR") !== -1)) {
		this["onmousedown"](oBrowserEvent);
		this["onmouseup"](oBrowserEvent);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlshome"] = 0; };

/**
 * End
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsend
 */
UCF_Splitter_ie6["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsend"]++; }; 
	var sId = oBrowserEvent["oGetSource"]()["getAttribute"]("id");
	if (sId && (sId["indexOf"](this["sId"] + "-VSR") !== -1 || sId["indexOf"](this["sId"] + "-HSR") !== -1)) {
		this["onmousedown"](oBrowserEvent);
		this["onmouseup"](oBrowserEvent);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlsend"] = 0; };

/**
 * Home
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the lsend
 */
UCF_Splitter_ie6["prototype"]["onlspageup"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlspageup"]++; }; 
	var sId = oBrowserEvent["oGetSource"]()["getAttribute"]("id");
	if (sId && (sId["indexOf"](this["sId"] + "-VSR") !== -1 || sId["indexOf"](this["sId"] + "-HSR") !== -1)) {
		this["onmousedown"](oBrowserEvent);
		this["onmouseup"](oBrowserEvent);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlspageup"] = 0; };

/**
 * End
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the lspagedown
 */
UCF_Splitter_ie6["prototype"]["onlspagedown"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlspagedown"]++; }; 
	var sId = oBrowserEvent["oGetSource"]()["getAttribute"]("id");
	if (sId && (sId["indexOf"](this["sId"] + "-VSR") !== -1 || sId["indexOf"](this["sId"] + "-HSR") !== -1)) {
		this["onmousedown"](oBrowserEvent);
		this["onmouseup"](oBrowserEvent);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["onlspagedown"] = 0; };

/**
 * @public
 * @return {number}
 */
UCF_Splitter_ie6["prototype"]["getAvailableWidth"] = function () {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["getAvailableWidth"]++; }; 
	/** @type {CSSStyleDeclaration} */

	//get TopLeft as well as TopRight cell in order to get padding
	var oSplitterTableRef = UCF_DomUtil["firstChild"](this["oDomRef"], 'TABLE');
	var oSplitterTBodyRef = UCF_DomUtil["firstChild"](oSplitterTableRef, 'TBODY');
	var oSplitterFirstRowRef = UCF_DomUtil["firstChild"](oSplitterTBodyRef, 'TR');
	var oSplitterTopLeftCellRef = UCF_DomUtil["firstChild"](oSplitterFirstRowRef, 'TD');
	var oSplitterTopRightCellRef = UCF_DomUtil["lastChild"](oSplitterFirstRowRef, 'TD');
	var oComputedStyleTopLeftCell = UCF_DomUtil["oGetComputedStyle"](oSplitterTopLeftCellRef);
	var oComputedStyleTopRightCell = UCF_DomUtil["oGetComputedStyle"](oSplitterTopRightCellRef);

	return this["oDomRef"]["offsetWidth"] -
		(parseInt(oComputedStyleTopLeftCell["paddingLeft"], 10) || 0) -
		(parseInt(oComputedStyleTopRightCell["paddingRight"], 10) || 0);
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["getAvailableWidth"] = 0; };

/**
 * @public
 * @return {number}
 */
UCF_Splitter_ie6["prototype"]["getAvailableHeight"] = function () {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["getAvailableHeight"]++; }; 
	/** @type {CSSStyleDeclaration} */

	//get TopLeft as well as BottomLeft cell in order to get padding
	var oSplitterTableRef = UCF_DomUtil["firstChild"](this["oDomRef"], 'TABLE');
	var oSplitterTBodyRef = UCF_DomUtil["firstChild"](oSplitterTableRef, 'TBODY');
	var oSplitterFirstRowRef = UCF_DomUtil["firstChild"](oSplitterTBodyRef, 'TR');
	var oSplitterTopLeftCellRef = UCF_DomUtil["firstChild"](oSplitterFirstRowRef, 'TD');
	var oSplitterLastRowRef = UCF_DomUtil["lastChild"](oSplitterTBodyRef, 'TR');
	var oSplitterBottomLeftCellRef = UCF_DomUtil["firstChild"](oSplitterLastRowRef, 'TD');
	var oComputedStyleTopLeftCell = UCF_DomUtil["oGetComputedStyle"](oSplitterTopLeftCellRef);
	var oComputedStyleBottomLeftCell = UCF_DomUtil["oGetComputedStyle"](oSplitterBottomLeftCellRef);

	return this["oDomRef"]["offsetHeight"] -
		(parseInt(oComputedStyleTopLeftCell["paddingTop"], 10) || 0) -
		(parseInt(oComputedStyleBottomLeftCell["paddingBottom"], 10) || 0);
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["getAvailableHeight"] = 0; };

UCF_Splitter_ie6["prototype"]["oGetFocusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["oGetFocusDomRef"]++; }; 
	var oFirstVSash = UCF_DomUtil["oGetFirstChildByAttribute"](this["oDomRef"], 'id', this["sId"] + '-VSR0C0');
	var oFirstHSash = UCF_DomUtil["oGetFirstChildByAttribute"](this["oDomRef"], 'id', this["sId"] + '-HSR0');
	return oFirstVSash ? oFirstVSash : oFirstHSash ? oFirstHSash : UCF_Splitter.prototype["oGetFocusDomRef"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Splitter_ie6["_"]["oGetFocusDomRef"] = 0; };

UCF_Splitter_ie6.prototype["aPublicMethods"] = ["setColumnWidth","setSplitterWidth","setRowHeight","setSplitterHeight","getAvailableWidth","getAvailableHeight"].concat(UCF_Splitter_ie6.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Splitter_standards"] = function() {/* global _assert, _trace, _measure, DEBUG, ERROR, START, STOP, WARNING, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Splitter */
/// <reference path="./Splitter.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_SplitterDragAndDrop */
/// <reference path="./SplitterDragAndDrop.js"/>
/* eslint quotes:0 */

/**
 * Use the SAP Splitter {@link UCF_Control} to construct a group of
 * {@link UCF_Control}s within an area, each of which is placed in a separate
 * cell. The {@link UCF_Splitter} control manages and displays the cells. You
 * can change the size of the cells using a sash. Enlarging one cell reduces
 * the size of the adjacent cell.
 *
 * 
 * @version 1.0.0.0
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Splitter_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["UCF_Splitter_standards"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof (oDomRef) === "object", "typeof (oDomRef) === \"object\"", "Splitter_standards.js(46): UCF_Splitter_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Splitter_standards.js(47): UCF_Splitter_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Splitter_standards.js(48): UCF_Splitter_standards"); };

	UCF_SplitterDragAndDrop["apply"](this, [oDomRef, oLS]);
	this["attachBrowserEvent"]('resize', this["oDomRef"]);
};window["UCF_Splitter_standards"] = UCF_Splitter_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Splitter_standards"); UCF_Splitter_standards["_"] = {UCF_Splitter_standards: 0}; }; ;
UCF_Splitter_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_SplitterDragAndDrop"))(); UCF_Splitter_standards.prototype["sClassName"] = "UCF_Splitter_standards";


/**
 * ############################################################################
 *
 * SECTION WITH MOUSE EVENTS
 *
 * ############################################################################
 */

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Splitter_standards["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onmousedown"]++; }; 

	this["determineAccess"](oBrowserEvent);

	if (this["bIsSashAccessed"]()) {
		this["createSashData"](oBrowserEvent);
		this["sDragSession"] = this["eDragSession"]["QUIET"];
		if (this["bCanDrag"]()) {
			this["createGridData"]();
			this["calcGridDimensions"]();
			this["lockCells"](oBrowserEvent);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onmousedown"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Splitter_standards["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onmouseup"]++; }; 
	if (this["bIsSashAccessed"]() && this["bCanDrag"]()) {
		this["unlockCells"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onmouseup"] = 0; };

/**
 * @private
 */
UCF_Splitter_standards["prototype"]["onmouseover"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onmouseover"]++; }; 
	this["sMousePosition"] = this["eMousePosition"]["INSIDE_SPLITTER"];
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onmouseover"] = 0; };

/**
 * @private
 */
UCF_Splitter_standards["prototype"]["onmouseout"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onmouseout"]++; }; 
	this["sMousePosition"] = this["eMousePosition"]["OUTSIDE_SPLITTER"];
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onmouseout"] = 0; };


/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Splitter_standards["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["ondblclick"]++; }; 
	if (this["sGetSashType"]() === this["eSashType"]["TOGGLE_AND_RESIZE"] &&
			this["bDalayedDoubbleClick"] === false &&
			this["sAccessType"] === this["eAccessType"]["NONE"] &&
			this["sDragSession"] === this["eDragSession"]["QUIET"] &&
			oBrowserEvent["oSourceControl"] === this) {

		this["sAccessType"] = this["eAccessType"]["DELAYEDDOUBLECLICK"];
		this["processCellToggling"]();
		this["determineEventsToFire"](
			this["eEventsToFire"]["RESIZE"],
			this["eEventsToFire"]["MOVEEND"]);
		this["fireSematicEvents"]();
		this["handlePaddings"]();
		this["concatValuesToStyles"]();
		this["updateGridDimensionsInDom"]();
		this["purgeData"]();
	} else {
		this["sDragSession"] = this["eDragSession"]["QUIET"];
		this["bDalayedDoubbleClick"] = false;
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["ondblclick"] = 0; };
/**
 * ############################################################################
 *
 * SECTION MISC
 *
 * ############################################################################
 */

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Splitter_standards["prototype"]["determineAccess"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["determineAccess"]++; }; 
	var oSource = oBrowserEvent["oSource"];

	if (oSource["getAttribute"]('data-gridType') &&
			oSource["getAttribute"]('data-gridType')["indexOf"]('SASH') > -1) {
			this["bSashAccessed"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["determineAccess"] = 0; };


/**
 * The oAfterActionData object is a data pool that stores values that
 * are calculated after any kind of cell-resize such as collapsing,
 * server drag and drop, client drag and drop
 *
 * @private
 * @return {Object}
 */
UCF_Splitter_standards["prototype"]["oGetAfterActionData"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetAfterActionData"]++; }; 
	if (this["oAfterActionData"]) {
		return this["oAfterActionData"];
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Cannot determine after-action-data', "Splitter_standards.js(174): oGetAfterActionData"); };
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetAfterActionData"] = 0; };


/**
 * ############################################################################
 *
 * SECTION WITH HANDLING OF PADDINGS
 *
 * ############################################################################
 */

/**
 * determines if and where to remove or to add paddings and
 * calls the respective methods
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Splitter_standards["prototype"]["handlePaddings"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["handlePaddings"]++; }; 
	/** @type {Object} */
	var oDomOrientation;
	/** @type {Object} */
	var oBounds;
	/** @type {Object} */
	var oPaddingMethod;
	/** @type {string} */
	var sStartStyle;
	/** @type {string} */
	var sEndStyle;
	/** @type {enum-list} */
	var eStyles;

	if (this["sAccessType"] === this["eAccessType"]["DELAYEDDOUBLECLICK"]) return;

	oDomOrientation = this["oGetOrientationMap"]();
	sStartStyle = oDomOrientation["startStyle"];
	sEndStyle = oDomOrientation["endStyle"];
	oBounds = this["oGetBounds"]();
	eStyles = this["eStyles"];
	oPaddingMethod = this["mPaddingMethods"][this["sAccessType"]];

	if (
		this[oPaddingMethod["bWithinStartPaddingArea"]](oBrowserEvent) &&
		oBounds["paddingStart"] > 0
	) {
		this["removePaddingsFromCells"](eStyles[sStartStyle], 'precedingcells');
	} else if (
		this[oPaddingMethod["bWithinEndPaddingArea"]](oBrowserEvent) &&
		oBounds["paddingEnd"] > 0
	) {
		this["removePaddingsFromCells"](eStyles[sEndStyle], 'succeedingcells');
	} else if (
		this[oPaddingMethod["bWithinStartPaddingArea"]](oBrowserEvent) === false &&
		this[oPaddingMethod["bWithinEndPaddingArea"]](oBrowserEvent) === false
	) {
		this["reassignPaddingToCells"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["handlePaddings"] = 0; };

/**
 * Without touching the assigned padding styles, this method sets a styles
 * that overwrites all paddings
 *
 * @param {string} style
 * @param {string} cells
 * @private
 */
UCF_Splitter_standards["prototype"]["removePaddingsFromCells"] = function(style, cells) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["removePaddingsFromCells"]++; }; 
	/** @type {Object} */
	var oGrid = this["oGetGridData"]();
	/** @type {Object} */
	var oAfterActionData = this["oGetAfterActionData"]();
	/** @type {Array} */
	var aCellsToRemovePadding;
	/** @type {HTML_Element} */
	var oCell;
	/** @type {string} */
	var sField = oAfterActionData["elementToDecrease"];
	/** @type {int} */
	var i;

	/** find the cells associated with the respective column */
	if (oGrid[sField]["sash"]) {
		aCellsToRemovePadding = oGrid[sField]["sash"][cells];
	} else {
		aCellsToRemovePadding = oGrid[sField]["associatedcells"];
	}


	/** add a class that removes the padding at the respective position */
	for (i = 0; i < aCellsToRemovePadding["length"]; i++) {
		oCell = UCF_DomUtil["$"](aCellsToRemovePadding[i]);
		UCF_DomUtil["addClass"](oCell, style);
	}

	/** store the edited cells to find them again */
	this["oPaddingData"][sField] = {};
	this["oPaddingData"][sField]["cells"] = aCellsToRemovePadding;
	this["oPaddingData"][sField]["bPaddingsRemoved"] = true;
	this["oPaddingData"][sField]["bPaddingsReassigned"] = false;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["removePaddingsFromCells"] = 0; };

/**
 * Add the previously assigned paddings by removing the zero-padding
 * class from the dom
 * @private
 */
UCF_Splitter_standards["prototype"]["reassignPaddingToCells"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["reassignPaddingToCells"]++; }; 
	/** @type {Object} */
	var oDomOrientation = this["oGetOrientationMap"]();
	/** @type {Object} */
	var oPaddingData = this["oPaddingData"];
	/** @type {Object} */
	var oAfterActionData = this["oGetAfterActionData"]();
	/** @type {string} */
	var sField = oAfterActionData["elementToIncrease"];
	/** @type {string} */
	var sStartStyle = oDomOrientation["startStyle"];
	/** @type {string} */
	var sEndStyle = oDomOrientation["endStyle"];
	/** @type {Array} */
	var aCellsToAddPadding;
	/** @type {enum-list} */
	var eStyles = this["eStyles"];
	/** @type {HTML_Element} */
	var oCell;
	/** @type {int} */
	var i;

	if (
		oPaddingData &&
		oPaddingData[sField] &&
		oPaddingData[sField]["cells"] &&
		oPaddingData[sField]["cells"]["length"] > 0
	) {
		aCellsToAddPadding = oPaddingData[sField]["cells"];
		for (i = 0; i < aCellsToAddPadding["length"]; i++) {
			oCell = UCF_DomUtil["$"](aCellsToAddPadding[i]);
			UCF_DomUtil["removeClass"](oCell, eStyles[sStartStyle]);
			UCF_DomUtil["removeClass"](oCell, eStyles[sEndStyle]);
		}
		delete this["oPaddingData"][sField];
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["reassignPaddingToCells"] = 0; };

/**
 * @private
 * @param { string } sElementToDecrease
 * @return {boolean}
 *
 */
UCF_Splitter_standards["prototype"]["bAddPadding"] = function(sElementToDecrease) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bAddPadding"]++; }; 
	/** @type {Object} */
	var oPaddings = this["oPaddingData"];
	/** @type {boolean} */
	var bAdd = (oPaddings[sElementToDecrease] &&
		oPaddings[sElementToDecrease]["bPaddingsRemoved"]);

	return bAdd;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bAddPadding"] = 0; };

/**
 * Determines whether or not padding had been added to a grid cell
 * and return
 * @private
 * @param { string } sField
 * @return { boolean }
 */
UCF_Splitter_standards["prototype"]["bRemovePadding"] = function(sField) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bRemovePadding"]++; }; 
	/** @type {Object} */
	var oPaddings = this["oPaddingData"];
	/** @type {boolean} */
	var bRemove = (oPaddings[sField] &&
		oPaddings[sField]["bPaddingsReassigned"]);

	return bRemove;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bRemovePadding"] = 0; };

/**
 * ############################################################################
 *
 * SECTION ORCHASTRATES EVERYTHING FOR GRID STYlES UPDATE
 *
 * ############################################################################
 */

/**
 * Creates and stores a string of styles that belong to those elements of the
 * CSS grid that remain untouched during and after resize.
 *
 * @private
 * @return {string}
 */
UCF_Splitter_standards["prototype"]["sGetConstantStyleBlock"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["sGetConstantStyleBlock"]++; }; 
	/** @type {Array} */
	var aDeaggregatedStyles;
	/** @type {string} */
	var sAggregetedStyles;

	if (this["sConstantStyles"] === null) {
		aDeaggregatedStyles = this["deaggregateStyles"]();
		sAggregetedStyles = this["aggregateStyles"](aDeaggregatedStyles);
		this["sConstantStyles"] = sAggregetedStyles;
		return this["sConstantStyles"];

	} else {
		return this["sConstantStyles"];
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["sGetConstantStyleBlock"] = 0; };

/**
 * @private
 * @return {Array}
 */
UCF_Splitter_standards["prototype"]["deaggregateStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["deaggregateStyles"]++; }; 
	/** @type {Object} */
	var oStyleBlock = UCF_DomUtil["$"](this["sId"] + ('-rootCss'));
	/** @type {string} */
	var sStyles = oStyleBlock["innerText"];
	/** @type {int} */
	var iStart = (sStyles["indexOf"]('{') + 1);
	/** @type {int} */
	var iStop = sStyles["indexOf"]('}');
	/** @type {string} */
	var sOparable = sStyles["slice"](iStart, iStop);
	/** @type {Array} */
	var aStyles = sOparable["split"](";");
	/** @type {int} */
	var i;

	for (i = 0; i < aStyles["length"] - 1; i++) {
		aStyles[i] = aStyles[i] + ';';

	}

	return aStyles;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["deaggregateStyles"] = 0; };

/**
 * @private
 * @param {Array} aDeaggregatedStyles
 * @return {string}
 */
UCF_Splitter_standards["prototype"]["aggregateStyles"] = function(aDeaggregatedStyles) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["aggregateStyles"]++; }; 
	/** @type {string} */
	var sStyles = '';
	/** @type {int} */
	var i;
	/** @type {string} */
	var sParameter = this["sGetGridParameter"]();

	for (i = 0; i < aDeaggregatedStyles["length"]; i++) {
		if (aDeaggregatedStyles[i]["indexOf"](sParameter) < 0 &&
			!UCF_StringUtil["bIsEmpty"](aDeaggregatedStyles[i])) {
			sStyles = sStyles + aDeaggregatedStyles[i];
		}
	}

	return sStyles;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["aggregateStyles"] = 0; };


/**
 * @private
 */
UCF_Splitter_standards["prototype"]["concatValuesToStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["concatValuesToStyles"]++; }; 
	/** @type {string} */
	var sStyles = '';
	/** @type {int} */
	var iSize;
	/** @type {string} */
	var sUnit;
	/** @type {string} */
	var n;
	/** @type {Array} */
	var aKeys;
	/** @type {string} */
	var sKey;
	/** @type {Object} */
	var oGridData = this["oGetGridData"]();
	/** @type {Object} */
	var oAfterActionData = this["oGetAfterActionData"]();
	/** @type {Object} */
	var oUnheeded;

	aKeys = UCF_JsUtil["keys"](oGridData);
	sKey = aKeys[aKeys["length"] - 1];

	/* interate over grid parts as stored in oGrodData
	so as to guarantee correct sequence of style values */
	for (n in oGridData) {
		/* Cell to be decreased */
		if (
			n === oAfterActionData["elementToDecrease"]
			) {
				iSize = oAfterActionData["decreasedSizeForStyles"];
				sUnit = oAfterActionData["decreasedUnitForStyles"];
		}

		/* Cell to be increased */
		else if (
			n === oAfterActionData["elementToIncrease"]
			) {
				iSize = oAfterActionData["increasedSizeForStyles"];
				sUnit = oAfterActionData["increasedUnitForStyles"];
		}

		/* Any other cell of the grid keeps its dimensions*/
		else {
				oUnheeded = oGridData[n];
				iSize = oUnheeded["size"];
				sUnit = oUnheeded["unit"];
			}

		sStyles = sStyles + ' ' + iSize;

		if (iSize === 0) {
			sStyles = sStyles + this["eUnits"]["PIXEL"];
		} else {
			sStyles = sStyles + sUnit;
		}

		/**
		 * Put a value for the sash after every col/row
		 * unless its nthe key of the last
		 */
		if (n !== sKey) {
			if (UCF_UserAgent["bIsIE"]()) {
				sStyles = sStyles + ' 5px';
			} else {
				sStyles = sStyles + ' auto';
			}
		}
	}

	sStyles = sStyles + ';';
	this["sNewStyles"] = sStyles;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["concatValuesToStyles"] = 0; };


/**
 * @private
 * @return {string}
 */
UCF_Splitter_standards["prototype"]["sGetNewStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["sGetNewStyles"]++; }; 

	if (this["sNewStyles"]) {
		return this["sNewStyles"];
	} else {
		this["concatValuesToStyles"]();
		if (this["sNewStyles"]) {
			return this["sNewStyles"];
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'cannot calculate new styles', "Splitter_standards.js(529): sGetNewStyles"); };
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["sGetNewStyles"] = 0; };


/**
 * ############################################################################
 *
 * SECTION HANDLES SEMANTIC EVENTS
 *
 * ############################################################################
 */

/**
 * @private
 * @return {bool}
 */
UCF_Splitter_standards["prototype"]["bProcessEvent"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bProcessEvent"]++; }; 
	/** @type {enum-value} */
	var sAccessType = this["sAccessType"];
	/** @type {enum-list} */
	var eAccessType = this["eAccessType"];
	/** @type {Object} */
	var oGhostCoordinates = this["oGetGhostCoordinates"]();
	/** @type {bool} */
	var bProcess = true;

	if ((sAccessType === eAccessType["DRAGGING"] &&
			oGhostCoordinates["start"] === oGhostCoordinates["end"]) ||
		this["oAfterActionData"] === null) {
		bProcess = false;
	}

	return bProcess;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bProcessEvent"] = 0; };

/**
 * @private
 */
UCF_Splitter_standards["prototype"]["determineEventsToFire"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["determineEventsToFire"]++; }; 
	/** @type {int} */
	var i;
	/** @type {int} */
	var l = arguments["length"];

	for (i = 0; i < l; i++) {
		this["sEventsToFire"] += arguments[i];
		this["sEventsToFire"] += '&';
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["determineEventsToFire"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_Splitter_standards["prototype"]["bIsColumnResize"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bIsColumnResize"]++; }; 
	return this["sGetGridType"](this["oSash"]) === this["eGridType"]["COLSASH"];
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bIsColumnResize"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_Splitter_standards["prototype"]["bIsAbsoluteSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bIsAbsoluteSize"]++; }; 
	/** @type {Object} */
	var oDomOrientation = this["oGetOrientationMap"]();
	/** @type {string} */
	var sSizeMode = oDomOrientation["sizeMode"];

	return this[sSizeMode] === this["eSizeMode"]["ABSOLUTE"];
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bIsAbsoluteSize"] = 0; };


/**
 * @private
 * @param {Object} oItem
 * @param {Object} oData
 * @return {Object}
 */
UCF_Splitter_standards["prototype"]["sFormatDimensions"] = function(oItem, oData) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["sFormatDimensions"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oRect = this["oGetClientRect"](oItem);
	/** @type {enum-value} */
	var sSashType = this["sGetGridType"](this["oSash"]);

	if (sSashType === this["eGridType"]["COLSASH"]) {
		if (oData["decreasedSizeForStyles"] === 0) {
			oResult["widthDecreased"] = oData["decreasedSizeForEvent"];
		} else {
			oResult["widthDecreased"] = (oData["decreasedSizeForEvent"] * -1);
		}

		oResult["widthIncreased"] = oData["increasedSizeForEvent"];
		oResult["heightDecreased"] = oRect["height"];
		oResult["heightIncreased"] = oRect["height"];
	} else {
		if (oData["decreasedSizeForStyles"] === 0) {
			oResult["heightDecreased"] = oData["decreasedSizeForEvent"];
		} else {
			oResult["heightDecreased"] = (oData["decreasedSizeForEvent"] * -1);
		}

		oResult["heightIncreased"] = oData["increasedSizeForEvent"];
		oResult["widthDecreased"] = oRect["width"];
		oResult["widthIncreased"] = oRect["width"];
	}
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["sFormatDimensions"] = 0; };

/**
 * @private
 * @return {int}
 */
UCF_Splitter_standards["prototype"]["iGetExpandedSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["iGetExpandedSize"]++; }; 
	/** @type {int} */
	var iResult;
	/** @type {Object} */
	var oAfterActionData = this["oGetAfterActionData"]();
	/** @type {string} */
	var sId = oAfterActionData["elementToIncrease"];

	if (this["bIsCollapsed"](sId)) {
		iResult = 0;

	} else {
		iResult = oAfterActionData["originalSize"];
	}

	return iResult;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["iGetExpandedSize"] = 0; };

/**
 * @private
 */
UCF_Splitter_standards["prototype"]["fireSematicEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["fireSematicEvents"]++; }; 
	/** @type {enum-value} */
	var sEventsToFire = this["sEventsToFire"];
	/** @type {enum-list} */
	var eEventsToFire = this["eEventsToFire"];

	if (this["bProcessEvent"]()) {
		// Fire Resize
		if (sEventsToFire["indexOf"](eEventsToFire["RESIZED_BY_SASH"]) > -1) {
			this["processResizedBySash"]();
		}
		// Fire Resize
		if (sEventsToFire["indexOf"](eEventsToFire["RESIZED_BY_BROWSER"]) > -1) {
			this["processResizedByBrowser"]();
		}
		// Fire MoveEnd
		if (sEventsToFire["indexOf"](eEventsToFire["MOVEEND"]) > -1) {
			this["processMoveEnd"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["fireSematicEvents"] = 0; };

/**
 * @private
 */
UCF_Splitter_standards["prototype"]["processResizedByBrowser"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["processResizedByBrowser"]++; }; 
	/** @type {Array} */
	var aData = this["oAfterActionData"]["browserResize"];
	/** @type {UCF_SplitterCell} */
	var oControl;
	/** @type {int} */
	var sCellId;
	/** @type {int} */
	var l = aData["length"];
	/** @type {int} */
	var i;

	for (i = 0; i < l; i++) {
		sCellId = aData[i]["id"];
		oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sCellId, true);
		this["fireResize"](
			this["sId"], /** splitter id */
			sCellId, /** cell id is actual cell coordinate */
			aData[i]["widthDelta"], /** widthDelta */
			aData[i]["heightDelta"], /** heightDelta */
			aData[i]["width"], /** Width */
			aData[i]["height"] /** Height */
		);

		oControl["fireResize"](
			sCellId, /** cell id is actual cell coordinate */
			aData[i]["widthDelta"], /** widthDelta */
			aData[i]["heightDelta"], /** heightDelta */
			aData[i]["width"], /** Width */
			aData[i]["height"] /** Height */
		);
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["processResizedByBrowser"] = 0; };


/**
 * @private
 */
UCF_Splitter_standards["prototype"]["processResizedBySash"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["processResizedBySash"]++; }; 
	/** @type {Object} */
	var oData = this["oGetAfterActionData"]();
	/** @type {Object} */
	var oResizedCells = this["oGetResizedCells"]();
	/** @type {Object} */
	var oDimensions;
	/** @type {HTML_Element} */
	var oDomRef;
	/** @type {UCF_SplitterCell_standards} */
	var oControl;
	/** @type {string} */
	var sCoordinates;
	/** @type {int} */
	var l = oResizedCells["increased"]["length"] - 1;
	/** @type {int} */
	var i;
	/** @type {string} */
	var sCellId;

	/** Events for all increased cells and the splitter */
	for (i = 0; i <= l; i++) {
		sCellId = oResizedCells["increased"][i];
		oDomRef = UCF_DomUtil["$"](sCellId);
		sCoordinates = oData["coordDecreased"]["toString"]();
		oDimensions = this["sFormatDimensions"](oDomRef, oData);
		oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sCellId, true);

		this["fireResize"](
			this["sId"], /** splitter id */
			sCoordinates, /** cell id is actual cell coordinate */
			oData["widthDelta"], /** widthDelta */
			oData["heightDelta"], /** heightDelta */
			oDimensions["widthIncreased"], /** Width */
			oDimensions["heightIncreased"] /** Height */
		);

		oControl["fireResize"](
			this["sGetCellCoord"](oDomRef), /** cell id is actual cell coordinate */
			oData["widthDelta"], /** widthDelta */
			oData["heightDelta"], /** heightDelta */
			oDimensions["widthIncreased"], /** Width */
			oDimensions["heightIncreased"] /** Height */
		);
	}

	/** Events for all decreased cells and the splitter */
	l = oData["coordDecreased"]["length"] - 1;

	for (i = 0; i <= l; i++) {
		sCellId = oResizedCells["decreased"][i];
		oDomRef = UCF_DomUtil["$"](sCellId);
		sCoordinates = oData["coordIncreased"]["toString"]();
		oDimensions = this["sFormatDimensions"](oDomRef, oData);
		oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sCellId, true);

		this["fireResize"](
			this["sId"], /** splitter id */
			sCoordinates, /** cell id is actual cell coordinate */
			oData["widthDelta"], /** widthDelta */
			oData["heightDelta"], /** heightDelta */
			oDimensions["widthDecreased"], /** Width */
			oDimensions["heightDecreased"] /** Height */
		);

		oControl["fireResize"](
			this["sGetCellCoord"](oDomRef), /** cell id is actual cell coordinate */
			oData["widthDelta"], /** widthDelta */
			oData["heightDelta"], /** heightDelta */
			oDimensions["widthDecreased"], /** Width */
			oDimensions["heightDecreased"] /** Height */
		);
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["processResizedBySash"] = 0; };


/**
 * The name take from the API is missleading.
 *
 * @private
 * @return {Object}
 */
UCF_Splitter_standards["prototype"]["bDefaultSizeInNextElements"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bDefaultSizeInNextElements"]++; }; 
	/** @type {Object} */
	var oSucceedingSizes = this["oGetSucceedingCellParams"]();
	/** @type {enum-list} */
	var eUnits = this["eUnits"];

	return (oSucceedingSizes["unit"] === eUnits["FRACTION"] ||
				 oSucceedingSizes["unit"] === eUnits["PIXEL"]);
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bDefaultSizeInNextElements"] = 0; };

/**
 * @private
 */
UCF_Splitter_standards["prototype"]["processMoveEnd"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["processMoveEnd"]++; }; 
		/** @type {Object} */
		var oData = this["oGetAfterActionData"]();
		/** @type {Object} */
		var oDefault = this["oGetDefaults"]();

		this["fireMoveEnd"](
		this["sId"], /** splitter id */
		this["bIsColumnResize"](), /**sash type */
		oData["precCellSizeForEvent"], /** cell size of preceeding grid element */
		oData["succCellSizeForEvent"], /** cell size of succeeding grid element */
		this["bIsAbsoluteSize"](), /** px */
		oData["coordPrevious"]["toString"](), /** coordinat4es of the previous cells */
		oDefault["previous"], /** -1 as set as default in the api */
		oData["coordNext"]["toString"](), /** coordinates of next cells */
		oDefault["next"], /** -1 as set as default in the api */
		this["iGetExpandedSize"]()
		);
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["processMoveEnd"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_Splitter_standards["prototype"]["oGetDefaults"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetDefaults"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oGridata = this["oGetGridData"]();
	/** @type {Object} */
	var oSashData = this["oGetSashData"]();
	/** @type {Object} */
	var sPrevious = oSashData[this["sGetKey_preceding_fromMap"]()];
	/** @type {Object} */
	var sNext = oSashData[this["sGetKey_succeeding_fromMap"]()];

	oResult["previous"] = oGridata[sPrevious]["hasdefaultsize"];
	oResult["next"] = oGridata[sNext]["hasdefaultsize"];

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetDefaults"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_Splitter_standards["prototype"]["oGetResizedCells"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetResizedCells"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Array} */
	var aPrecedingCells = this["aGetCellsPrecedingSash"]();
	/** @type {Array} */
	var aSucceedingCells = this["aGetCellsSucceedingSash"]();
	/** @type {enum-value} */
	var sDragDirection = this["sGetDragDirection"]();

	if (sDragDirection === this["eNeighbourhood"]["NEXT"]) {
		oResult["increased"] = aPrecedingCells;
		oResult["decreased"] = aSucceedingCells;
	}
	else {
		oResult["increased"] = aSucceedingCells;
		oResult["decreased"] = aPrecedingCells;
	}
	return oResult;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetResizedCells"] = 0; };
/**
 * ############################################################################
 *
 * SECTION FOR RESIZE
 *
 * ############################################################################
 */

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Splitter_standards["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onresize"]++; }; 

	if (this["sAccessType"] !== this["eAccessType"]["NONE"]) return;

	if (this["sCollectResizeEvent"] === this["eCollectResizeEvents"]["START"] ||
			this["sCollectResizeEvent"] === this["eCollectResizeEvents"]["CONTINUE"]) {
		this["aResizeEvents"]["push"](oBrowserEvent);
	}


	if (!this["bResizeObserverStarted"]) {
		if (!this["oStoredSplitterSizes"]["height"] ||
				!this["oStoredSplitterSizes"]["width"]) {
			this["oStoredSplitterSizes"] = this["oGetClientRect"](this["oDomRef"]);
		}
		this["determineResize"]();
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onresize"] = 0; };

/**
 * @private
 */
UCF_Splitter_standards["prototype"]["determineResize"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["determineResize"]++; }; 
	/** @type {Object} */
	var oRect = this["oGetClientRect"](this["oDomRef"]);
	/** @type {Object} */
	var oStoredSizes = this["oStoredSplitterSizes"];

	if (oRect["width"] !== oStoredSizes["width"] ||
			oRect["height"] !== oStoredSizes["height"]) {
				this["sCollectResizeEvent"] = this["eCollectResizeEvents"]["CONTINUE"];
				this["observeResize"]();
	} else {
		this["aResizeEvents"] = [];
		this["sCollectResizeEvent"] = this["eCollectResizeEvents"]["STOP"];
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["determineResize"] = 0; };

/**
 * @private
 */
UCF_Splitter_standards["prototype"]["observeResize"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["observeResize"]++; }; 

	this["bResizeObserverStarted"] = true;

	if (this["sTimeOutId"] != null) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
	}

	if (this["iResizeEvents"] !== this["aResizeEvents"]["length"]) {
				this["iResizeEvents"] = this["aResizeEvents"]["length"];
				this["sTimeOutId"] = UCF_JsUtil["delayedCall"](300, this, 'observeResize');

	} else {
		if (this["sTimeOutId"] != null) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["aResizeEvents"] = [];
		this["bResizeObserverStarted"] = false;
		this["iResizeEvents"] = 0;
		this["onAfterResize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["observeResize"] = 0; };

/**
 * @private
 */
UCF_Splitter_standards["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onAfterResize"]++; }; 
	if (this["sMousePosition"] === this["eMousePosition"]["OUTSIDE_SPLITTER"]) {
			this["sAccessType"] = this["eAccessType"]["BROWSERRESIZE"];
			this["determineDataAfterBrowserResize"]();
			this["updateStoredSplitterSizes"]();
			this["determineEventsToFire"](this["eEventsToFire"]["RESIZED_BY_BROWSER"]);
			this["fireSematicEvents"]();
			this["purgeData"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onAfterResize"] = 0; };

/**
 * @private
 */
UCF_Splitter_standards["prototype"]["determineDataAfterBrowserResize"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["determineDataAfterBrowserResize"]++; }; 
	/** @type {Array} */
	var aResult = [];
	/** @type {Object} */
	var oDelta = this["oGetResizeDelta"]();
	/** @type {Object} */
	var oDimensions;
	/** @type {Object} */
	var oCell = {};
	/** @type {Object} */
	var oRect;
	/** @type {enum-list} */
	var eSizeMode = this["eSizeMode"];
	/** @type {Array} */
	var aCells = this["aGetAllSplitterCellIds"]();
	/** @type {int} */
	var l = aCells["length"];
	/** @type {int} */
	var i;
	/** @type {string} */
	var sCellId;
	/** @type {int} */
	var iWidth;
	/** @type {int} */
	var iHeight;

	for (i = 0; i < l; i++) {
		sCellId = aCells[i];
		oRect = this["oGetClientRect"](UCF_DomUtil["$"](sCellId));
		oCell["id"] = sCellId;
		iWidth = oRect["width"] - oDelta["widthDelta"];
		iHeight = oRect["height"] - oDelta["heightDelta"];
		oDimensions = this["oGetPercentFromPixel"]({'height':iHeight,'width':iWidth});

		if (this["sWidthSizeModeOfColums"] === eSizeMode["RELATIVE"]) {
			oCell["width"] = oDimensions["width"];
		} else {
			oCell["width"] = iWidth;
		}

		if (this["sHeightSizeModeOfRows"] === eSizeMode["RELATIVE"]) {
			oCell["height"] = oDimensions["height"];
		} else {
			oCell["height"] = iHeight;
		}

		oCell["widthDelta"] = oDelta["widthDelta"];
		oCell["heightDelta"] = oDelta["heightDelta"];
		aResult["push"](oCell);
	}

	this["oAfterActionData"] = {};
	this["oAfterActionData"]["browserResize"] = aResult;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["determineDataAfterBrowserResize"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_Splitter_standards["prototype"]["oGetResizeDelta"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetResizeDelta"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oDimensions;
	/** @type {Object} */
	var oStoredSplitterSizes = this["oStoredSplitterSizes"];
	/** @type {Object} */
	var oSplitterRect = this["oGetSplitterRect"]();
	/** @type {enum-list} */
	var eSizeMode = this["eSizeMode"];
	/** @type {int} */
	var iWidthDelta;
	/** @type {int} */
	var iHeightDelta;

	iWidthDelta = oStoredSplitterSizes["width"] - oSplitterRect["width"];
	iHeightDelta = oStoredSplitterSizes["height"] - oSplitterRect["height"];
	oDimensions = this["oGetPercentFromPixel"]({ 'height': iHeightDelta, 'width': iWidthDelta });

	if (this["sWidthSizeModeOfColums"] === eSizeMode["RELATIVE"]) {
		oResult["widthDelta"] = oDimensions["width"];
	}
	else {
		oResult["widthDelta"] = iWidthDelta;
	}

	if (this["sHeightSizeModeOfRows"] === eSizeMode["RELATIVE"]) {
		oResult["heightDelta"] = oDimensions["height"];
	}
	else {
		oResult["heightDelta"] = iHeightDelta;
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetResizeDelta"] = 0; };
/**
 * ############################################################################
 *
 * SECTION WITH STYLES
 *
 * ############################################################################
 */
/**
 * @private
 */
UCF_Splitter_standards["prototype"]["eStyles"] = {
	"COL_RESIZE_HANDLE": 'lsSplitter__colSash--resizeHandle',
	"ROW_RESIZE_HANDLE": 'lsSplitter__rowSash--resizeHandle',

	"GHOST": 'lsSplitter__ghost',

	"BLOCKlAYER_HIDDEN": 'lsSplitter__blockLayer--hidden',
	"BLOCKlAYER_VISIBLE": 'lsSplitter__blockLayer--visible',

	"CELL_LOCKED": 'lsSplitter__cell--locked',
	"CELL_UNLOCKED": '',

	"REMOVE_TOP_PADDING": 'lsSplitter__removeTopPadding',
	"REMOVE_RIGHT_PADDING": 'lsSplitter__removeRightPadding',
	"REMOVE_BOTTOM_PADDING": 'lsSplitter__removeBottomPadding',
	"REMOVE_LEFT_PADDING": 'lsSplitter__removeLeftPadding',

	"COLSASH_TO_PREVIOUS": 'lsSplitter__colSash--collapseToPrevious',
	"COLSASH_TO_NEXT": 'lsSplitter__colSash--collapseToNext',
	"ROWSASH_TO_PREVIOUS": 'lsSplitter__rowSash--collapseToPrevious',
	"ROWSASH_TO_NEXT": 'lsSplitter__rowSash--collapseToNext'
};


/**
 * ############################################################################
 *
 * SECTION WITH KEYBOAD INTERACTION
 *
 * ############################################################################
 */

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @return {enum-value}
 */
UCF_Splitter_standards["prototype"]["sGetShiftType"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["sGetShiftType"]++; }; 
	/** @type { enum-value }*/
	var sResult;
	/** @type { enum-list }*/
	var eShiftType = this["eShiftType"];
	/** @type {string}*/
	var sEventName = oBrowserEvent["sName"];

	switch (sEventName) {
		case 'lsnextmodifier':
		case 'lsupmodifier':
		sResult = eShiftType["STEP_TO_NEXT"];
		break;

		case 'lspreviousmodifier':
		case 'lsdownmodifier':
		sResult = eShiftType["STEP_TO_PREVIOUS"];
		break;

		case 'lshome':
		case 'lspageup':
		sResult = eShiftType["MOVE_TO_START"];
		break;

		case 'lsend':
		case 'lspagedown':
		sResult = eShiftType["MOVE_TO_END"];
	}

	return sResult;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["sGetShiftType"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @return {boolean}
 */
UCF_Splitter_standards["prototype"]["bDecreasedAboutToCollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bDecreasedAboutToCollapse"]++; }; 
	/** @type {Object} */
	var oElements = this["oGetShiftedElements"](oBrowserEvent);
	/** @type {int} */
	var iKeyboardStep = this["iKeyboardStepSize"];
	/** @type {HTML_Element} */
	var oDomRef = UCF_DomUtil["$"](oElements["toBeDecreased"]["associatedcells"][0]);
	/** @type {Object} */
	var oRect = this["oGetClientRect"](oDomRef);
	/** @type {string} */
	var sDomDimension = this["sGet_domDimension_fromMap"]();

	return oRect[sDomDimension] <= iKeyboardStep;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["bDecreasedAboutToCollapse"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @return {enum-value}
 */
UCF_Splitter_standards["prototype"]["sGetSashPositionAfterShift"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["sGetSashPositionAfterShift"]++; }; 
	/** @type { enum-value }*/
	var sResult;
	/** @type { enum-list }*/
	var eShiftType = this["eShiftType"];
	/** @type { enum-list }*/
	var eSashPosition = this["eSashPosition"];
	var eNeighbour = this["eNeighbourhood"];
	/** @type { enum-value}*/
	var sShiftType = this["sGetShiftType"](oBrowserEvent);
	/** @type { enum-value}*/
	var sToggleDirection = this["sGetToggleDirection"]();


	if (sShiftType === eShiftType["STEP_TO_NEXT"]) {
		if(this["bDecreasedAboutToCollapse"](oBrowserEvent)) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MAX"];
		}
		else {
			sResult = eSashPosition["NEW_DIMESNIONS_MAX"];
		}
	}
	else if (sShiftType === eShiftType["STEP_TO_PREVIOUS"]) {
		if (this["bDecreasedAboutToCollapse"](oBrowserEvent)) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MIN"];
		} else {
			sResult = eSashPosition["NEW_DIMESNIONS_MIN"];
		}
	}
	else if (sShiftType === eShiftType["MOVE_TO_START"]) {
		if (sToggleDirection === eNeighbour["PREVIOUS"]) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MIN"];
		} else {
			sResult = eSashPosition["NEW_EXPAND_POSITION_MAX"];
		}
	}
	else {
		if (sToggleDirection === eNeighbour["NEXT"]) {
			sResult = eSashPosition["OWN_TOGGLE_POSITION_MAX"];
		} else {
			sResult = eSashPosition["NEW_EXPAND_POSITION_MIN"];
		}
	}

	return sResult;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["sGetSashPositionAfterShift"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {Object}
 */
UCF_Splitter_standards["prototype"]["oGetShiftedElements"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetShiftedElements"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oPrecedingSizes = this["oGetPrecedingCellParams"]();
	/** @type {Object} */
	var oSucceedingSizes = this["oGetSucceedingCellParams"]();
	/** @type {enum-list} */
	var eShiftType = this["eShiftType"];
	/** @type {enum-list} */
	var eNeighbour = this["eNeighbourhood"];
	/** @type {enum-value} */
	var sShiftType = this["sGetShiftType"](oBrowserEvent);
	/** @type {enum-value} */
	var sOrientation = this["sGetOrientation"]();
	/** @type {enum-list} */
	var eSizeMode = this["eSizeMode"];

	if (sShiftType === eShiftType["STEP_TO_NEXT"] ||
			sShiftType === eShiftType["MOVE_TO_END"]) {
		oResult["toBeIncreased"] = oPrecedingSizes;
		oResult["toBeDecreased"] = oSucceedingSizes;
		oResult["increase"] = eNeighbour["PREVIOUS"];
		oResult["decrease"] = eNeighbour["NEXT"];
	} else {
		oResult["toBeIncreased"] = oSucceedingSizes;
		oResult["toBeDecreased"] = oPrecedingSizes;
		oResult["increase"] = eNeighbour["NEXT"];
		oResult["decrease"] = eNeighbour["PREVIOUS"];
	}

	if (this[eSizeMode[sOrientation]] === eSizeMode["RELATIVE"]) {
		oResult["originalSize"] = oResult["toBeDecreased"]["sizeinpercent"];
	} else {
		oResult["originalSize"] = oResult["toBeDecreased"]["sizeinpixel"];
	}

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetShiftedElements"] = 0; };


/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {Object}
 */
UCF_Splitter_standards["prototype"]["oGetKeyActionDelta"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetKeyActionDelta"]++; }; 
	/** @type {Object} */
	var oResult = {};
	/** @type {Object} */
	var oRect;
	/** @type {HTML_Element} */
	var oDomRef;
	/** @type {enum-list} */
	var eShiftType = this["eShiftType"];
	/** @type {enum-value} */
	var sShiftType = this["sGetShiftType"](oBrowserEvent);
	/** @type {int} */
	var iStepSize;
	/** @type {string} */
	var sId;
	/** @type {string} */
	var sDomDimension = this["sGet_domDimension_fromMap"]();

	if (sShiftType === eShiftType["STEP_TO_NEXT"]) {
		sId = this["aGetCellsSucceedingSash"]()[0];
		iStepSize = this["iGetStepSize"](sId);
	}
	else if (sShiftType === eShiftType["STEP_TO_PREVIOUS"]) {
		sId = this["aGetCellsPrecedingSash"]()[0];
		iStepSize = this["iGetStepSize"](sId);
	}
	else if (sShiftType === eShiftType["MOVE_TO_START"]) {
		sId = this["aGetCellsPrecedingSash"]()[0];
		oDomRef = UCF_DomUtil["$"](sId);
		oRect = this["oGetClientRect"](oDomRef);
		iStepSize = oRect[sDomDimension];
	}
	else {
		sId = this["aGetCellsSucceedingSash"]()[0];
		oDomRef = UCF_DomUtil["$"](sId);
		oRect = this["oGetClientRect"](oDomRef);
		iStepSize = oRect[sDomDimension];
	}

	oResult["pixel"] = iStepSize;
	oResult["percent"] = this["iGetPercentFromPixel"](iStepSize);

	return oResult;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetKeyActionDelta"] = 0; };

/**
 * @private
 * @param {string} sId
 * @return {int}
 */
UCF_Splitter_standards["prototype"]["iGetStepSize"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["iGetStepSize"]++; }; 
	/** @type {int} */
	var iStepSize = this["iKeyboardStepSize"];
	/** @type {Object} */
	var oToBeDecreased;
	/** @type {string} */
	var sDomDimension = this["sGet_domDimension_fromMap"]();

	oToBeDecreased = this["oGetClientRect"](UCF_DomUtil["$"](sId));
	iStepSize = (oToBeDecreased[sDomDimension] < iStepSize) ? oToBeDecreased[sDomDimension] : iStepSize;

	return iStepSize;
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["iGetStepSize"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Splitter_standards["prototype"]["determineDataAfterKeyAction"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["determineDataAfterKeyAction"]++; }; 
	/** @type {Object} */
	var oMovedElements;
	/** @type {Object} */
	var oDelta;
	/** @type {Object} */
	var oSizes;
	/** @type {Object} */
	var oSizeAndUnitPairs;

	this["sAccessType"] = this["eAccessType"]["KEYBOARD"];
	this["onmousedown"](oBrowserEvent);
	oMovedElements = this["oGetShiftedElements"](oBrowserEvent);

	if (!this["bIsCollapsed"](oMovedElements["toBeDecreased"]["id"])) {
		oDelta = this["oGetKeyActionDelta"](oBrowserEvent);
		oSizes = this["oGetSizesAfterMoveAction"](oDelta, oMovedElements);
		oSizeAndUnitPairs = this["oGetSizeAndUnitPairOfMoveAction"](oSizes, oMovedElements);

		this["determineDataAfterMoveAction"](oDelta, oMovedElements, oSizeAndUnitPairs, oBrowserEvent);
		this["handlePaddings"](oBrowserEvent);
		this["concatValuesToStyles"]();
		this["updateClientAfterMoveAction"](oBrowserEvent);
		this["determineEventsToFire"](
			this["eEventsToFire"]["RESIZED_BY_SASH"],
			this["eEventsToFire"]["MOVEEND"]);
		this["fireSematicEvents"]();
		this["purgeData"]();
	}

	this["onmouseup"](oBrowserEvent);
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["determineDataAfterKeyAction"] = 0; };



/**
 * Shift arrow up
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the onlsupmodifier
 */
UCF_Splitter_standards["prototype"]["onlsupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlsupmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasModifiers"](oBrowserEvent, 's')) {
		this["determineDataAfterKeyAction"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlsupmodifier"] = 0; };

/**
 * Shift arrow left
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lspreviousmodifier
 */
UCF_Splitter_standards["prototype"]["onlspreviousmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlspreviousmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasModifiers"](oBrowserEvent, 's')) {
		this["determineDataAfterKeyAction"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlspreviousmodifier"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdownmodifier
 */
UCF_Splitter_standards["prototype"]["onlsdownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlsdownmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasModifiers"](oBrowserEvent, 's')) {
		this["determineDataAfterKeyAction"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlsdownmodifier"] = 0; };

/**
 * Shift arrow right
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsnextmodifier
 */
UCF_Splitter_standards["prototype"]["onlsnextmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlsnextmodifier"]++; }; 
	if (UCF_KeyboardHelper["bHasModifiers"](oBrowserEvent, 's')) {
		this["determineDataAfterKeyAction"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlsnextmodifier"] = 0; };

/**
 * Home
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshome
 */
UCF_Splitter_standards["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlshome"]++; }; 
	this["determineDataAfterKeyAction"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlshome"] = 0; };

/**
 * End
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsend
 */
UCF_Splitter_standards["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlsend"]++; }; 
	this["determineDataAfterKeyAction"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlsend"] = 0; };

/**
 * Home
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lspageup
 */
UCF_Splitter_standards["prototype"]["onlspageup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlspageup"]++; }; 
	this["determineDataAfterKeyAction"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlspageup"] = 0; };

/**
 * End
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lspagedown
 */
UCF_Splitter_standards["prototype"]["onlspagedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlspagedown"]++; }; 
	this["determineDataAfterKeyAction"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["onlspagedown"] = 0; };

UCF_Splitter_standards["prototype"]["oGetFocusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetFocusDomRef"]++; }; 
	var oFirstVSash = UCF_DomUtil["oGetFirstChildByAttribute"](this["oDomRef"], 'data-gridtype', 'COLSASH');
	var oFirstHSash = UCF_DomUtil["oGetFirstChildByAttribute"](this["oDomRef"], 'data-gridtype', 'ROWSASH');
	return oFirstVSash ? oFirstVSash : oFirstHSash ? oFirstHSash : UCF_SplitterDragAndDrop.prototype["oGetFocusDomRef"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Splitter_standards["_"]["oGetFocusDomRef"] = 0; };

};
sap["ls"]["preload"]["UCF_StickyNote"] = function() {/* global _assert, _trace, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>

/**
 * StickyNote control
 *
 * @class
 * @param {HMTLElement} oDomRef DOM reference
 * @param {UCF_LS} oLS LS Instance
 */
function UCF_StickyNote(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["UCF_StickyNote"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "StickyNote.js(33): UCF_StickyNote"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "StickyNote.js(34): UCF_StickyNote"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "StickyNote.js(35): UCF_StickyNote"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["allowTextSelection"]();

		/** @type {string} */
		this["sOldValue"] = null;

		// Support 100% height
		this["oLS"]["oBrowserWindow"]["attachEvent"](
			this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"],
			this,
			'onLayoutChange'
		);

		// Support inplace edit of title
		// eslint-disable-next-line @ur/no-memory-leaks
		this["oInplaceEditTitleDelegate"] = null;
		if (this["bInplaceEditTitle"]) {
			this["oInplaceEditTitleDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEditDelegate"))(oLS);
			this["oInplaceEditTitleDelegate"]["attachEvent"](
				this["oInplaceEditTitleDelegate"]["E_EVENTS"]["InplaceEditStart"],
				this,
				'onInplaceEditTitleStart'
			);
			this["oInplaceEditTitleDelegate"]["attachEvent"](
				this["oInplaceEditTitleDelegate"]["E_EVENTS"]["InplaceEditFinished"],
				this,
				'onInplaceEditTitleFinished'
			);
			this["oInplaceEditTitleDelegate"]["attachEvent"](
				this["oInplaceEditTitleDelegate"]["E_EVENTS"]["InplaceEditClose"],
				this,
				'onInplaceEditTitleClosed'
			);
			this["addDelegate"](this["oInplaceEditTitleDelegate"]);
		}

		/** @type {HTMLSpanElement|HTMLDivElement|HTMLTextAreaElement} */
		this["oFocusDomRef"] = this["bIsCollapsed"]
			? UCF_DomUtil["$"](this["sId"] + '-icon')
			: this["bHasTitleArea"]
			? UCF_DomUtil["$"](this["sId"] + '-titlearea')
			: UCF_DomUtil["$"](this["sId"] + '-text');
	}
};window["UCF_StickyNote"] = UCF_StickyNote; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_StickyNote"); UCF_StickyNote["_"] = {UCF_StickyNote: 0}; }; ;
UCF_StickyNote["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_StickyNote.prototype["sClassName"] = "UCF_StickyNote";

/** @override */
UCF_StickyNote["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["destroy"]++; }; 
	this["oLS"]["oBrowserWindow"]["attachEvent"](
		this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"],
		this,
		'onLayoutChange'
	);
	if (this["oInplaceEditTitleDelegate"]) {
		this["oInplaceEditTitleDelegate"]["detachEvent"](
			this["oInplaceEditTitleDelegate"]["E_EVENTS"]["InplaceEditStart"],
			this
		);
		this["oInplaceEditTitleDelegate"]["detachEvent"](
			this["oInplaceEditTitleDelegate"]["E_EVENTS"]["InplaceEditFinished"],
			this
		);
		this["oInplaceEditTitleDelegate"]["detachEvent"](
			this["oInplaceEditTitleDelegate"]["E_EVENTS"]["InplaceEditClose"],
			this
		);
		this["oInplaceEditTitleDelegate"] = null;
	}
	this["handleRLIMode"](UCF_StickyNote["RLI_MODE"]["DESTROY"]);
	this["sOldValue"] = null;
	this["oInplaceEditTitleDelegate"] = null;
	this["sSaveRLIWidth"] = null;
	this["sSaveRLIHeight"] = null;
	this["sSaveRLITop"] = null;
	this["sSaveRLILeft"] = null;
	this["sTitle"] = null;
	this["oRLIPlaceholder"] = null;
	this["oRLIParent"] = null;
	this["oRLI"] = null;
	this["oParentScrollAreaControl"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["destroy"] = 0; };

/** @protected */
UCF_StickyNote["prototype"]["onLayoutChange"] = function() {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onLayoutChange"]++; }; 
	if (!this["bIsDestroyed"]) {
		this["applyHeights"]();
		this["handleRLIMode"](UCF_StickyNote["RLI_MODE"]["LAYOUT_CHANGE"]);
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onLayoutChange"] = 0; };

/** @override */
UCF_StickyNote["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["initialize"]++; }; 
	/** @type {HTMLSpanElement} */
	var oIcon;

	if (this["bIsCollapsed"]) {
		// Initially collapsed
		oIcon = UCF_DomUtil["$"](this["sId"] + '-icon');
		this["oRootRef"]["style"]["height"] = oIcon["offsetHeight"] + 'px';
		this["oRootRef"]["style"]["width"] = oIcon["offsetWidth"] + 'px';
		// Remove the box-shadow on the root DIV (The collapsed-state-icon may have
		// a box-shadow on the icons itself if specified in CustomStyles)
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsLCDropShadow');
	}

	this["applyHeights"]();
	this["sOldValue"] = this["sText"];

	// TODO: Remove this workaround when RLIMode property can be set for newly
	// inserted controls in Personas Editor
	if (
		window["sap"] &&
		window["sap"]["personas"] &&
		window["sap"]["personas"]["fw"] &&
		window["sap"]["personas"]["fw"]["wda"] &&
		this["bRLIMode"] === false &&
		this["oRootRef"]["parentNode"]["getAttribute"]('ct') === 'RLI'
	) {
		this["bRLIMode"] = true;
		this["setClientProperty"]('RLIMode', this["bRLIMode"], true);
	}

	this["handleRLIMode"](UCF_StickyNote["RLI_MODE"]["INIT"]);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["initialize"] = 0; };

/** @private */
UCF_StickyNote["prototype"]["applyHeights"] = function() {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["applyHeights"]++; }; 
	/** @type {HTMLDivElement} */
	var oTitleDiv = UCF_DomUtil["$"](this["sId"] + '-titlearea');
	/** @type {HTMLDivElement} */
	var oNoteDiv;
	/** @type {CSSStyleDeclaration} */
	var oNoteCS;
	/** @type {number} Support additional top/bottom padding in custom styles */
	var iPadding;
	/** @type {number} */
	var iHeight;
	/** @type {HTMLTextAreaElement} */
	var oTextDiv;

	if (oTitleDiv) {
		oNoteDiv = UCF_DomUtil["$"](this["sId"] + '-note');
		oNoteCS = UCF_DomUtil["oGetComputedStyle"](oNoteDiv);
		iPadding = parseInt(oNoteCS["paddingTop"]) + parseInt(oNoteCS["paddingBottom"]);
		iHeight = oNoteDiv["offsetHeight"] - oTitleDiv["offsetHeight"] - iPadding;
		oTextDiv = UCF_DomUtil["$"](this["sId"] + '-text');

		if (oTextDiv) {
			oTextDiv["style"]["height"] = iHeight + 'px';
		} else {
			UCF_DomUtil["$"](this["sId"] + '-scroll')["style"]["height"] = iHeight + 'px';
		}
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["applyHeights"] = 0; };

/**
 * @private
 * @param {boolean} bFireEvent
 * @param {boolean} bSetFocus
 */
UCF_StickyNote["prototype"]["expand"] = function(bFireEvent, bSetFocus) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["expand"]++; }; 
	/** @type {HTMLDivElement} */
	var oNote;
	/** @type {HTMLSpanElement} */
	var oIcon;

	if (this["bClientCollapse"]) {
		oNote = UCF_DomUtil["$"](this["sId"] + '-note');
		oIcon = UCF_DomUtil["$"](this["sId"] + '-icon');

		UCF_DomUtil["removeClass"](oNote, 'lsSTNHidden');
		UCF_DomUtil["removeClass"](oIcon, 'lsSTNVisible');
		UCF_DomUtil["addClass"](oNote, 'lsSTNVisible');
		UCF_DomUtil["addClass"](oIcon, 'lsSTNHidden');
		this["bIsCollapsed"] = false;
		this["oRootRef"]["style"]["height"] = this["sHeight"];
		this["oRootRef"]["style"]["width"] = this["sWidth"];
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsLCDropShadow');
		this["setClientProperty"]('IsCollapsed', false, true);
		if (bSetFocus) {
			if (this["bHasTitleArea"] && (window["UCF_System"]["bIs508"] || window["UCF_System"]["bIsAria"])) {
				UCF_DomUtil["focusDomElement"](UCF_DomUtil["$"](this["sId"] + '-titlearea'));
			} else {
				UCF_DomUtil["focusDomElement"](UCF_DomUtil["$"](this["sId"] + '-text'));
			}
		}
		this["applyHeights"]();
		this["handleRLIMode"](UCF_StickyNote["RLI_MODE"]["TOGGLE"]);
	}
	if (bFireEvent) {
		this["fireExpand"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["expand"] = 0; };

/**
 * @private
 * @param {boolean} bFireEvent
 * @param {boolean} bSetFocus
 */
UCF_StickyNote["prototype"]["collapse"] = function(bFireEvent, bSetFocus) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["collapse"]++; }; 
	/** @type {HTMLDivElement} */
	var oNote;
	/** @type {HTMLSpanElement} */
	var oIcon;

	if (this["bClientCollapse"]) {
		oNote = UCF_DomUtil["$"](this["sId"] + '-note');
		oIcon = UCF_DomUtil["$"](this["sId"] + '-icon');

		UCF_DomUtil["removeClass"](oNote, 'lsSTNVisible');
		UCF_DomUtil["removeClass"](oIcon, 'lsSTNHidden');
		UCF_DomUtil["addClass"](oIcon, 'lsSTNVisible');
		UCF_DomUtil["addClass"](oNote, 'lsSTNHidden');
		this["oRootRef"]["style"]["height"] = oIcon["clientHeight"] + 'px';
		this["oRootRef"]["style"]["width"] = oIcon["clientWidth"] + 'px';
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsLCDropShadow');
		this["bIsCollapsed"] = true;
		this["setClientProperty"]('IsCollapsed', true, true);
		if (bSetFocus) {
			UCF_DomUtil["focusDomElement"](UCF_DomUtil["$"](this["sId"] + '-icon'));
		}
		this["applyHeights"]();
		this["handleRLIMode"](UCF_StickyNote["RLI_MODE"]["TOGGLE"]);
	}
	if (bFireEvent) {
		this["fireCollapse"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["collapse"] = 0; };

/** @protected */
UCF_StickyNote["prototype"]["onLock"] = function() {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onLock"]++; }; 
	this["handleRLIMode"](UCF_StickyNote["RLI_MODE"]["LOCK"]);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onLock"] = 0; };

/** @typedef {0} UCF_StickyNote_RliMode_Init */
/** @typedef {1} UCF_StickyNote_RliMode_Toggle */
/** @typedef {2} UCF_StickyNote_RliMode_LayoutChange */
/** @typedef {3} UCF_StickyNote_RliMode_Destroy */
/** @typedef {4} UCF_StickyNote_RliMode_Lock */
/** @typedef {UCF_StickyNote_RliMode_Init|UCF_StickyNote_RliMode_Toggle|UCF_StickyNote_RliMode_LayoutChange|UCF_StickyNote_RliMode_Destroy|UCF_StickyNote_RliMode_Lock} UCF_StickyNote_RliMode */
/** @enum {UCF_StickyNote_RliMode} */
UCF_StickyNote["RLI_MODE"] = {
	"INIT": 0,
	"TOGGLE": 1,
	"LAYOUT_CHANGE": 2,
	"DESTROY": 3,
	"LOCK": 4
};

/**
 * @protected
 * @param {UCF_StickyNote_RliMode} iEvent
 */
UCF_StickyNote["prototype"]["handleRLIMode"] = function(iEvent) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["handleRLIMode"]++; }; 
	/** @type {UCF_StickyNote} */
	var self = this;
	/** @type {function(): void} */
	var handleSize;
	/** @type {function(): boolean} */
	var isMoved;
	/** @type {function(): boolean} */
	var isVisible;
	/** @type {function(): boolean} */
	var isNotVisible;
	/** @type {function(HTMLElement): HTMLElement} */
	var findOverflowHiddenContainer;
	/** @type {function(number): void} */
	var handleClipping;
	/** @type {_ObjectRect} */
	var oRLIAbsRect;

	if (this["bRLIMode"]) {
		handleSize = function() {
			// RLI Mode in WDA: RLI has size in px and STN has 100%
			// => Do also collapse the RLI and remember the size
			if (self["bIsCollapsed"]) {
				self["sSaveRLIWidth"] = self["oRLI"]["style"]["width"];
				self["sSaveRLIHeight"] = self["oRLI"]["style"]["height"];
				self["oRLI"]["style"]["width"] = '0px';
				self["oRLI"]["style"]["height"] = '0px';
			} else {
				self["oRLI"]["style"]["width"] = self["sSaveRLIWidth"];
				self["oRLI"]["style"]["height"] = self["sSaveRLIHeight"];
			}
		};

		isMoved = function() {
			//return this.oLS.oGetPageInternal().oGetAssociatedAreaRef() == this.oRLI.parentNode;
			return (self["oParentScrollAreaControl"] != null);
		};

		isVisible = function() {
			return UCF_DomUtil["bIsVisible"](
				isMoved() ? self["oRLIParent"] : self["oRLI"]["parentNode"],
				true
			);
		};
		isNotVisible = function() { return !isVisible(); };

		findOverflowHiddenContainer = function(oDomRef) {
			var o = oDomRef;
			var sOverflow;

			while (o != null) {
				if (o === document["body"]) {
					return null;
				} else {
					sOverflow = UCF_DomUtil["sGetCurrentStyle"](o, 'overflow');
					if (sOverflow === 'hidden') {
						return o;
					}
				}
				o = o["parentNode"];
			}

			return null;
		};

		handleClipping = function(iExpand) {
			/** @type {string} */
			var sParentId;
			/** @type {string} */
			var sLayoutId;
			/** @type {UCF_GridLayout|UCF_MatrixLayout|UCF_SingleColumnLayout} */
			var oLayout;
			/** @type {HTMLElement} */
			var oContainer;
			/** @type {_ObjectRect} */
			var oRLIMoveRect;
			/** @type {_ObjectRect} */
			var oCurrentRLIAbsRect;

			// If the RLI is contained as child in the root of certain layouts that use
			// position:relative ("RasterItems" parameter) AND would be clipped in a
			// parent container with overflow:hidden => move to parent scroll-area
			if (iExpand) {
				if (!isMoved()) {
					sParentId = this["oRLI"]["parentNode"]["id"];

					if (
						sParentId &&
						UCF_DomUtil["sGetCurrentStyle"](this["oRLI"]["parentNode"], 'position') === 'relative'
					) {
						// eslint-disable-next-line no-magic-numbers
						sLayoutId = UCF_StringUtil["bEndsWith"](sParentId, '-r')
							// eslint-disable-next-line no-magic-numbers
							? sParentId["substring"](0, sParentId["length"] - 2)
							: sParentId;
						oLayout = this["oLS"]["oControlFactory"]["oGetControlById"](sLayoutId);

						if (
							oLayout &&
							(
								UCF_JsUtil["bInstanceOf"](oLayout, 'UCF_GridLayout') ||
								UCF_JsUtil["bInstanceOf"](oLayout, 'UCF_MatrixLayout') ||
								UCF_JsUtil["bInstanceOf"](oLayout, 'UCF_SingleColumnLayout')
							)
						) {
							oContainer = findOverflowHiddenContainer(this["oRLI"]["parentNode"]);

							// If there is no other offsetParent node between the parent
							// (layout-root) and the overflow:hidden container
							// we are able to calculate if the STN is clipped
							if ( // eslint-disable-line max-depth
								oContainer &&
								(
									this["oRLI"]["parentNode"]["offsetParent"] == null ||
									!oContainer["contains"](this["oRLI"]["parentNode"]["offsetParent"])
								)
							) {
								// eslint-disable-next-line max-depth
								if (
									oContainer["offsetWidth"] - this["oRLI"]["offsetLeft"] < this["oRLI"]["scrollWidth"] ||
									oContainer["offsetHeight"] - this["oRLI"]["offsetTop"] < this["oRLI"]["scrollHeight"]
								) {
									// Insert a "placeholder" to remember the position among the siblings
									this["oRLIPlaceholder"] = document["createElement"]('DIV');
									this["oRLIPlaceholder"]["style"]["width"] = '0px';
									this["oRLIPlaceholder"]["style"]["height"] = '0px';
									this["oRLIPlaceholder"]["style"]["top"] = this["sSaveRLITop"];
									this["oRLIPlaceholder"]["style"]["left"] = this["sSaveRLILeft"];
									this["oRLIPlaceholder"]["style"]["position"] = 'absolute';
									this["oRLIPlaceholder"]["style"]["display"] = 'none';
									this["oRLI"]["parentNode"]["insertBefore"](this["oRLIPlaceholder"], this["oRLI"]);

									this["oRLIParent"] = this["oRLI"]["parentNode"];

									//							var oRLIAbsRect = UCF_DomUtil.oGetObjectRect(this.oRLI); // Do not cache! The scroll-position may be different each time
									//							this.oLS.oGetPageInternal().oGetAssociatedAreaRef().appendChild(this.oRLI);
									this["oParentScrollAreaControl"] = this["oGetParentScrollAreaDomRef"]();

									oRLIMoveRect = UCF_DomUtil["oGetObjectRect"](this["oRLI"], this["oParentScrollAreaControl"]);
									UCF_DomUtil["oAddLayeredElement"](this["oRLI"], null, this["oParentScrollAreaControl"]);

									this["oRLI"]["style"]["top"] = oRLIMoveRect["top"] + 'px';
									this["oRLI"]["style"]["left"] = oRLIMoveRect["left"] + 'px';
								}
							}
						}
					}
				}
			} else if (isMoved()) {
				this["oRLIParent"]["insertBefore"](this["oRLI"], this["oRLIPlaceholder"]);

				// We cannot simply restore the original position because user may have scrolled between expand and collapse
				// Calculate current position based on placeholder element
				this["oRLIPlaceholder"]["style"]["display"] = '';

				oCurrentRLIAbsRect = UCF_DomUtil["oGetObjectRect"](this["oRLIPlaceholder"], this["oRLIParent"]);
				this["oRLI"]["style"]["top"] = oCurrentRLIAbsRect["top"] + 'px';
				this["oRLI"]["style"]["left"] = oCurrentRLIAbsRect["left"] + 'px';
				this["oRLIPlaceholder"]["parentNode"]["removeChild"](this["oRLIPlaceholder"]);
				this["oRLIParent"] = null;
				this["oRLIPlaceholder"] = null;
				this["oParentScrollAreaControl"] = null;
			}
		}["bind"](this);

		switch (iEvent) {
			case UCF_StickyNote["RLI_MODE"]["INIT"]:
				if (this["oRootRef"]["parentNode"]["getAttribute"]('ct') === 'RLI') {
					this["oRLI"] = this["oRootRef"]["parentNode"];
					// Set z-index so it will be in front of stuff that uses
					// position:relative trick on other layouts
					this["oRLI"]["style"]["zIndex"] = UCF_LS["E_LAYERS"]["CONTROLS"];
					this["sSaveRLITop"] = this["oRLI"]["style"]["top"];
					this["sSaveRLILeft"] = this["oRLI"]["style"]["left"];
					if (this["bIsCollapsed"]) {
						handleSize();
					} else if (isVisible()) {
						handleClipping(true);
					}
					this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, 'onLock');
				} else {
					if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'RLIMode not possible: Parent RasterLayoutItem not found', "StickyNote.js(474): handleRLIMode"); };
				}
				break;
			case UCF_StickyNote["RLI_MODE"]["TOGGLE"]:
				handleSize();
				handleClipping(!this["bIsCollapsed"]);
				break;
			case UCF_StickyNote["RLI_MODE"]["LAYOUT_CHANGE"]:
				if (!this["bIsCollapsed"] && !this["oLS"]["bLocked"]()) {
					if (isMoved() && isNotVisible()) {
						handleClipping(false);
					} else if (!isMoved() && isVisible()) {
						handleClipping(true);
					} else if (isMoved() && isVisible()) {
						this["oRLIPlaceholder"]["style"]["display"] = '';
						oRLIAbsRect = UCF_DomUtil["oGetObjectRect"](this["oRLIPlaceholder"], this["oParentScrollAreaControl"]);
						this["oRLIPlaceholder"]["style"]["display"] = 'none';
						this["oRLI"]["style"]["top"] = oRLIAbsRect["top"] + 'px';
						this["oRLI"]["style"]["left"] = oRLIAbsRect["left"] + 'px';
					}
				}
				break;
			case UCF_StickyNote["RLI_MODE"]["DESTROY"]:
				if (isMoved()) {
					handleClipping(false);
				}
				this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this);
				this["oRLI"] = null;
				break;
			case UCF_StickyNote["RLI_MODE"]["LOCK"]:
				if (isMoved()) {
					handleClipping(false);
				}
				break;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["handleRLIMode"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_StickyNote["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onclick"]++; }; 
	/** @type {HTMLElement} */
	var oSourceDom = oBrowserEvent["oGetSource"]();

	if (this["bIsCollapsed"]) {
		this["expand"](true, true);
	} else if (oSourceDom &&
		(oSourceDom === UCF_DomUtil["$"](this["sId"] + '-coll') || oSourceDom === UCF_DomUtil["$"](this["sId"] + '-titlearea'))) {
		this["collapse"](true, true);
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onclick"] = 0; };

/**
 * Handles the onlsselect event
 *  [ENTER] & [SPACE]
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_StickyNote["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onlsselect"]++; }; 
	var oSourceDom = oBrowserEvent["oGetSource"]();

	if (this["bIsCollapsed"]) {
		this["expand"](true, true);
	} else if (oSourceDom &&
		(oSourceDom === UCF_DomUtil["$"](this["sId"] + '-coll') || oSourceDom === UCF_DomUtil["$"](this["sId"] + '-titlearea'))) {
		this["collapse"](true, true);
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onlsselect"] = 0; };

/**
 * Fires change event if value has changed
 * @private
 */
UCF_StickyNote["prototype"]["prepareFireChange"] = function() {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["prepareFireChange"]++; }; 
	/** @type {HTMLTextAreaElement} */
	var oText = UCF_DomUtil["$"](this["sId"] + '-text');
	/** @type {string} */
	var sValue;

	if (oText) {
		sValue = oText["value"];

		if (sValue !== this["sOldValue"]) {
			this["oLS"]["setDomChanged"](true);
			this["sOldValue"] = sValue;
			if (this["bHasEventListeners"]('Change')) {
				this["fireChange"](this["sId"], 'C', sValue);
				this["setPendingChange"](false);
			} else if (this["bHasEventListeners"]('TextChange')) {
				this["fireTextChange"](this["sId"], sValue);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["prepareFireChange"] = 0; };

/**
 * Press [+]
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_StickyNote["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onlsexpand"]++; }; 
	if (this["bIsCollapsed"]) {
		this["expand"](true, true);
	}
	if (window["UCF_System"]["bIs508"]) {
		this["onlsaccessibility"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onlsexpand"] = 0; };

/**
 *  Press [-]
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_StickyNote["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onlscollapse"]++; }; 
	if (!this["bIsCollapsed"]) {
		this["collapse"](true, true);
	}
	if (window["UCF_System"]["bIs508"]) {
		this["onlsaccessibility"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onlscollapse"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_StickyNote["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onlsblur"]++; }; 
	this["prepareFireChange"]();
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onlsblur"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_StickyNote["prototype"]["onpaste"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onpaste"]++; }; 
	if (!this["bEditText"]) {
		oBrowserEvent["cancel"]();
	}

	this["handleEditEvents"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onpaste"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_StickyNote["prototype"]["oncut"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["oncut"]++; }; 
	if (!this["bEditText"]) {
		oBrowserEvent["cancel"]();
	}

	this["handleEditEvents"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["oncut"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_StickyNote["prototype"]["onkeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onkeyup"]++; }; 
	this["handleEditEvents"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onkeyup"] = 0; };

/**
 * Handler for events that are fired when the textarea is edited.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_StickyNote["prototype"]["handleEditEvents"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["handleEditEvents"]++; }; 
	/** @type {HTMLTextAreaElement} */
	var oTextRef = UCF_DomUtil["$"](this["sId"] + '-text');

	if (oTextRef && oTextRef["value"] !== this["sOldValue"] && !this["bIsDirty"]) {
		this["bIsDirty"] = true;
		this["markDirty"](true);
		this["setPendingChange"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["handleEditEvents"] = 0; };

/**
 * @private
 * @param {UCF_Event} oParams
 */
UCF_StickyNote["prototype"]["onInplaceEditTitleStart"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onInplaceEditTitleStart"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent = oParams["mParameters"]["oBrowserEvent"];
	/** @type {HTMLElement} */
	var oSource = oBrowserEvent["oGetSource"]();
	/** @type {HTMLDivElement} */
	var oTitle = UCF_DomUtil["$"](this["sId"] + '-titletext');
	/** @type {_ObjectRect} */
	var oBoundaries = UCF_DomUtil["oGetObjectRect"](oTitle);

	if (UCF_DomUtil["bContains"](oSource, oTitle)) {
		this["oInplaceEditTitleDelegate"]["setInplaceEditData"](
			oTitle,
			oBoundaries,
			this["sTitle"]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onInplaceEditTitleStart"] = 0; };

/**
 * @private
 * @param {UCF_Event} oParams
 */
UCF_StickyNote["prototype"]["onInplaceEditTitleFinished"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onInplaceEditTitleFinished"]++; }; 
	/** @type {string} */
	var sText = oParams["oGetParam"]('sText');
	/** @type {HTMLDivElement} */
	var oTitle;

	if (sText !== this["sTitle"]) {
		oTitle = UCF_DomUtil["$"](this["sId"] + '-titletext');
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](oTitle, UCF_XSSEncoder["encodeHTML"](sText));
		this["sTitle"] = sText;
		this["setClientProperty"]('Title', this["sTitle"], true);
		if (this["bHasEventListeners"]('Change')) {
			this["fireChange"](this["sId"], 'H', sText);
		} else {
			this["fireTitleChange"](this["sId"], sText);
		}
		UCF_DomUtil["focusDomElement"](UCF_DomUtil["$"](this["sId"] + '-titlearea'));
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onInplaceEditTitleFinished"] = 0; };

/** @private */
UCF_StickyNote["prototype"]["onInplaceEditTitleClosed"] = function() {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onInplaceEditTitleClosed"]++; }; 
	UCF_DomUtil["focusDomElement"](UCF_DomUtil["$"](this["sId"] + '-titlearea'));
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onInplaceEditTitleClosed"] = 0; };

/** @override */
UCF_StickyNote["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["oGetInplaceEditDomRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + '-titletext');
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["oGetInplaceEditDomRef"] = 0; };

/** @override */
UCF_StickyNote["prototype"]["sGetInplaceEditText"] = function() {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["sGetInplaceEditText"]++; }; 
	return this["getClientProperty"]('Title') || this["sTitle"];
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["sGetInplaceEditText"] = 0; };

/** @override */
UCF_StickyNote["prototype"]["setInplaceEditText"] = function(s) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["setInplaceEditText"]++; }; 
	this["sTitle"] = s;
	this["setClientProperty"]('Title', s);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["setInplaceEditText"] = 0; };

/** @override */
UCF_StickyNote["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["oGetDTExtension"]++; }; 
	return UCF_Control.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]('UCF_StickyNoteDTExtension'));
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["oGetDTExtension"] = 0; };

/**
 * @return {string}
 */
UCF_StickyNote["prototype"]["getInnerText"] = function() {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["getInnerText"]++; }; 
	return this["sText"] ||
		UCF_DomUtil["sGetInnerText"](UCF_DomUtil["$"](this["sId"] + '-text'));
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["getInnerText"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_StickyNote["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper;
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {string} */
	var sTitle;
	/** @type {string} */
	var sText;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "StickyNote.js(755): onlsaccessibility"); };

	oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oBrowserEvent["oGetSourceControl"]() === this) {

		//focused part
		oDomRef = oBrowserEvent["oGetSource"]();

		oAccessibilityHelper["setControlType"]('STN');
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

		sTitle = this["sTitle"];
		sText = this["getInnerText"]();
		if (oDomRef === UCF_DomUtil["$"](this["sId"] + '-titlearea')) {
			if (this["bInplaceEditTitle"]) {
				oAccessibilityHelper["addTutor"]('STN_EDIT_TITLE');
			}
			oAccessibilityHelper["addTutor"]('STN_COL_TUT');
			oAccessibilityHelper["setText"](sTitle);
			oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		} else if (oDomRef === UCF_DomUtil["$"](this["sId"] + '-icon')) {
			oAccessibilityHelper["addTutor"]('STN_EXP_TUT');
			oAccessibilityHelper["setText"](sTitle);
		} else if (oDomRef === UCF_DomUtil["$"](this["sId"] + '-text')) {
			oAccessibilityHelper["setText"](this["sText"]);
			oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		} else if (oDomRef === UCF_DomUtil["$"](this["sId"] + '-ftext')) {
			if (this["bEditText"]) {
				oAccessibilityHelper["addTutor"]('STN_EDIT_TEXT');
			}
			oAccessibilityHelper["setText"](this["sText"]);
			oAccessibilityHelper["setTooltip"](sText);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_StickyNote["prototype"]["aAttributeNames"] = ["bHasTitleArea","sTitle","sText","bIsCollapsed","bClientCollapse","sWidth","sHeight","sCustomStyle","sCustomData","bInplaceEditTitle","bEditText","sVisibility","sTooltip","bRLIMode"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_StickyNote["prototype"]["aEventNames"] = ["Change","TitleChange","TextChange","Collapse","Expand"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_StickyNote["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {boolean}
 */
UCF_StickyNote["prototype"]["bHasTitleArea"] = true;

/**
 * @private
 * @type {string}
 */
UCF_StickyNote["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_StickyNote["prototype"]["sText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_StickyNote["prototype"]["bIsCollapsed"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_StickyNote["prototype"]["bClientCollapse"] = true;

/**
 * @private
 * @type {string}
 */
UCF_StickyNote["prototype"]["sWidth"] = '250px';

/**
 * @private
 * @type {string}
 */
UCF_StickyNote["prototype"]["sHeight"] = '200px';

/**
 * @private
 * @type {string}
 */
UCF_StickyNote["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_StickyNote["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_StickyNote["prototype"]["bInplaceEditTitle"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_StickyNote["prototype"]["bEditText"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_StickyNote["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_StickyNote["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_StickyNote["prototype"]["bRLIMode"] = false;

//#JSCOVER_EXCL_START
/** @protected */
UCF_StickyNote["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["setDefaultValues"]++; }; 
	this["bHasTitleArea"] = true;
	this["sTitle"] = '';
	this["sText"] = '';
	this["bIsCollapsed"] = false;
	this["bClientCollapse"] = true;
	this["sWidth"] = '250px';
	this["sHeight"] = '200px';
	this["sCustomStyle"] = '';
	this["sCustomData"] = '';
	this["bInplaceEditTitle"] = false;
	this["bEditText"] = false;
	this["sVisibility"] = "VISIBLE";
	this["sTooltip"] = '';
	this["bRLIMode"] = false;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("HasTitleArea", true, true);
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("IsCollapsed", false, true);
		this["setClientProperty"]("ClientCollapse", true, true);
		this["setClientProperty"]("Width", '250px', true);
		this["setClientProperty"]("Height", '200px', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("InplaceEditTitle", false, true);
		this["setClientProperty"]("EditText", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("RLIMode", false, true);
	}
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The id of the control.
 * @param {string} sHeaderOrContent Indicates the value that was changed: H=title (via inplace-edit), C=text
 * @param {string} sValue The new value.
 * @fires StickyNote::Change
 */
UCF_StickyNote["prototype"]["fireChange"] = function(sId, sHeaderOrContent, sValue) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["fireChange"]++; }; 
	/** @type {{Id: string, HeaderOrContent: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "StickyNote.js(945): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "StickyNote.js(946): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "StickyNote.js(947): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHeaderOrContent != null, "sHeaderOrContent != null", "StickyNote.js(948): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHeaderOrContent) == "string", "typeof(sHeaderOrContent) == \"string\"", "StickyNote.js(949): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "StickyNote.js(950): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "StickyNote.js(951): fireChange"); };
	mParams = {
		"Id": sId,
		"HeaderOrContent": sHeaderOrContent,
		"Value": sValue
	};
	
	
	
	this["fireSemanticEvent"]("StickyNote", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the control.
 * @param {string} sValue The new value.
 * @fires StickyNote::TitleChange
 */
UCF_StickyNote["prototype"]["fireTitleChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["fireTitleChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "StickyNote.js(973): fireTitleChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "StickyNote.js(974): fireTitleChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "StickyNote.js(975): fireTitleChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "StickyNote.js(976): fireTitleChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "StickyNote.js(977): fireTitleChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("StickyNote", "TitleChange", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["fireTitleChange"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the control.
 * @param {string} sValue The new value.
 * @fires StickyNote::TextChange
 */
UCF_StickyNote["prototype"]["fireTextChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["fireTextChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "StickyNote.js(997): fireTextChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "StickyNote.js(998): fireTextChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "StickyNote.js(999): fireTextChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "StickyNote.js(1000): fireTextChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "StickyNote.js(1001): fireTextChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("StickyNote", "TextChange", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["fireTextChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires StickyNote::Collapse
 */
UCF_StickyNote["prototype"]["fireCollapse"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "StickyNote.js(1020): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "StickyNote.js(1021): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "StickyNote.js(1022): fireCollapse"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("StickyNote", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["fireCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires StickyNote::Expand
 */
UCF_StickyNote["prototype"]["fireExpand"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["fireExpand"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "StickyNote.js(1039): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "StickyNote.js(1040): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "StickyNote.js(1041): fireExpand"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("StickyNote", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_StickyNote["_"]["fireExpand"] = 0; };

};
sap["ls"]["preload"]["UCF_StickyNoteDTExtension"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_DTExtension */
/// <reference path="./DTExtension.js"/>
/* global sap */

/**
 * 
 *
 * @class
 * @extends UCF_DTExtension
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oControl
 * @param {UCF_DTElement} oDTElement
 */
function UCF_StickyNoteDTExtension(oLS, oControl, oDTElement) {if (__UCF_COVERAGE__) { UCF_StickyNoteDTExtension["_"]["UCF_StickyNoteDTExtension"]++; }; 
	if (arguments["length"] === 0) return;
	UCF_DTExtension["apply"](this, arguments);
};window["UCF_StickyNoteDTExtension"] = UCF_StickyNoteDTExtension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_StickyNoteDTExtension"); UCF_StickyNoteDTExtension["_"] = {UCF_StickyNoteDTExtension: 0}; }; ;

UCF_StickyNoteDTExtension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTExtension"))(); UCF_StickyNoteDTExtension.prototype["sClassName"] = "UCF_StickyNoteDTExtension";

UCF_StickyNoteDTExtension["prototype"]["oGetDomRefForRect"] = function(sElementId) {;if (__UCF_COVERAGE__) { UCF_StickyNoteDTExtension["_"]["oGetDomRefForRect"]++; }; 
	if (this["oControl"]["oGetParent"]() && UCF_JsUtil["bInstanceOf"](this["oControl"]["oGetParent"](), "UCF_RasterLayoutItem")) {
		return this["oControl"]["oGetParent"]()["oRootRef"];
	}
	var s = this["oControl"]["bIsCollapsed"] ? "icon" : "note";
	return UCF_DomUtil["$"](this["oControl"]["sId"] + "-" + s);
};;if (__UCF_COVERAGE__) { UCF_StickyNoteDTExtension["_"]["oGetDomRefForRect"] = 0; };

/**
 * This is a workaround: RLI inserted by Personas Editor has initial width 0px
 */
UCF_StickyNoteDTExtension["prototype"]["oPostprocessRect"] = function(oRect, sElementId, bIsScrollElement) {;if (__UCF_COVERAGE__) { UCF_StickyNoteDTExtension["_"]["oPostprocessRect"]++; }; 
	if (sap["personas"]["Client"] && this["oControl"]["bIsCollapsed"] && oRect["width"] === 0) {
		var oIcon = UCF_DomUtil["$"](this["oControl"]["sId"] + "-icon");
		oRect["width"] = oIcon["clientWidth"];
		//oRect.height = oIcon.clientHeight;
	}
	return oRect;
};;if (__UCF_COVERAGE__) { UCF_StickyNoteDTExtension["_"]["oPostprocessRect"] = 0; };

};
sap["ls"]["preload"]["UCF_SuggestBox"] = function() {/* global UCF_ComboBox */
/// <reference path="./ComboBox.js"/>
/* global UCF_EditFieldBase */
/// <reference path="./base/EditFieldBase.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Exception */
/// <reference path="../core/Exception.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_Tracer, _assert, _trace, INFO, DEBUG, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>

/**
 * 
 * @class UCF_SuggestBox
 * @extends UCF_ComboBox
 * @param {HTMLElement} oDomRef the html element representing the control
 * @param {UCF_LS} oLS the LightSpeed instance managing the control
 */
function UCF_SuggestBox(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["UCF_SuggestBox"]++; };  //eslint-disable-line @ur/no-memory-leaks
	/** @type {HTMLSpanElement} */
	var oAriaSuggestRef;

	if (arguments["length"] > 0) {
		UCF_ComboBox["apply"](this, [oDomRef, oLS]);

		/**
		 * @type {boolean} bClientFilter indicates whether the client or the
		 * server can filter further typing
		 */
		this["bClientFilter"] = false;

		/**
		 * @type {number} iServerFilterDelay delay for triggering the filter
		 * events to the server
		 */
		this["iServerFilterDelay"] = 250;

		/**
		 * @type {number} iClientFilterDelay delay for triggering the clientside
		 * filtering
		 */
		this["iClientFilterDelay"] = 50;

		/**
		 * @type {number} iChangeAFId id of the timer for value changes of the
		 * field
		 */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iChangeAFId"] = null;

		/**
		 * @type {string} sOldValue store the old value to get notification of a
		 * value change
		 */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sOldValue"] = this["sGetCurrentValue"]();

		/** @type {boolean}  */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["bFieldHelpPress"] = false;

		/**
		 * @type {string} sEscapeValue store the value if the user presses escape
		 * after a lot of typing
		 */
		this["sEscapeValue"] = '';

		/** @type {string} */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sSelectedKey"] = '';

		/** @type {string} selected part of the input field value */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sSelectedValue"] = '';

		/**
		 * @type {boolean} bAllowVirtualTyping combobox setting to not allow
		 * virtual typing
		 */
		//eslint-disable-next-line @ur/no-missing-setClientProperty
		this["bAllowVirtualTyping"] = false;

		/** @type {string} */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sTypedValue"] = null;

		/** @type {boolean} */
		this["bLeaveList"] = true;

		/**
		 * @type {string} sTypedValueBeforeAC value typed before auto completion
		 * kicks in
		 */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sTypedValueBeforeAC"] = null;

		this["setInteractionState"]({ "FocusOnInput": true });

		// ARIA: create -aria-suggest span
		if (window["UCF_System"]["bIsAria"] && this["bShouldShowSuggest"]()) {
			oAriaSuggestRef = document["createElement"]('span');
			oAriaSuggestRef["id"] = this["sId"] + '-aria-suggest';
			UCF_DomUtil["setStyle"](oAriaSuggestRef, {
				"display": 'none',
				"visibility": 'hidden'
			});

			if (this["bIsTableRenderMode"]()) {
				this["oDomRef"]["parentNode"]["appendChild"](oAriaSuggestRef);
			} else {
				this["oRootRef"]["appendChild"](oAriaSuggestRef);
			}
		}

		this["attachEvent"](
			this["E_EVENTS"]["WillDestroy"],
			this,
			'onWillDestroySuggestBox'
		);
	}
};window["UCF_SuggestBox"] = UCF_SuggestBox; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SuggestBox"); UCF_SuggestBox["_"] = {UCF_SuggestBox: 0}; }; ;
UCF_SuggestBox["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ComboBox"))(); UCF_SuggestBox.prototype["sClassName"] = "UCF_SuggestBox";

/**
 * @private
 * @return {boolean} `true` if autocomplete should be performed, otherwise
 * `false`
 */
UCF_SuggestBox["prototype"]["bShouldAutoComplete"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bShouldAutoComplete"]++; }; 
	return this["bSuggestAutoComplete"]
		&& this["sSuggestFilter"] === 'CLIENT_SERVER_PREFIX';
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bShouldAutoComplete"] = 0; };

/**
 * @private
 * @return {boolean} `true` if autocomplete should be performed, otherwise
 * `false`
 */
UCF_SuggestBox["prototype"]["bShouldShowSuggest"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bShouldShowSuggest"]++; }; 
	return !this["bReadonly"] || this["bShowHelpButtonAlways"];
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bShouldShowSuggest"] = 0; };

UCF_SuggestBox["prototype"]["requestChangeTimer"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["requestChangeTimer"]++; }; 
	/** @type {UCF_SuggestBox} */
	var self = this;
	/** @type {number} */
	var iNow;
	/** @type {function(): void} */
	var fAnimationFrame;

	this["cancelChangeTimer"]();

	iNow = new Date()["getTime"]();
	fAnimationFrame = function() {
		if (
			(new Date()["getTime"]() - iNow) >
			(self["bClientFilter"] ? self["iClientFilterDelay"] : self["iServerFilterDelay"])
		) {
			self["iChangeAFId"] = null;
			self["onValueChange"]();
		} else {
			self["iChangeAFId"] = UCF_JsUtil["requestAnimationFrame"](fAnimationFrame);
		}
	};

	this["iChangeAFId"] = UCF_JsUtil["requestAnimationFrame"](fAnimationFrame);
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["requestChangeTimer"] = 0; };

UCF_SuggestBox["prototype"]["cancelChangeTimer"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["cancelChangeTimer"]++; }; 
	if (typeof this["iChangeAFId"] === 'number') {
		UCF_JsUtil["cancelAnimationFrame"](this["iChangeAFId"]);
		this["iChangeAFId"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["cancelChangeTimer"] = 0; };

/**
 * Handles a value change and triggers list access event with filter values to
 * the server
 */
UCF_SuggestBox["prototype"]["onValueChange"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onValueChange"]++; }; 
	/** @type {string} */
	var sValue;

	this["cancelChangeTimer"]();

	if (this["sSuggestFilter"] !== 'OFF') {
		sValue = this["sGetValue"]();
		if (this["sOldValue"] !== sValue || this["bTyped"]) {
			this["sOldValue"] = this["sGetValue"]();
			if (sValue !== '') {
				// if the server filter already contains the filter just open the list
				// otherwise fire an event
				// to deliver the list

				if (this["bContainedInServerFiltered"](sValue)) {
					if (this["oFieldHelp"]) {
						// Any change that causes update/filter: clear the selection
						this["sSelectedKey"] = '';
						this["sKey"] = '';
						// eslint-disable-next-line quotes
						this["setClientProperty"]("Key", this["sKey"], true);
						this["oFieldHelp"]["clearSelection"]();
					}
					this["open"](this["bIsOpen"]());
				} else {
					this["bClientFilter"] = false;

					if (!this["bIsInOverlayMode"]()) {
						this["closeFieldHelp"](this["bIsOpen"]());
					}

					// No listaccess when LS is locked, I-1712591 2010
					if (this["lockListAccessEvents"]) {
						if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'List access eventing is locked...', "SuggestBox.js(232): onValueChange"); };
					} else {
						this["fireListAccessInternal"](sValue);
					}
				}
				// eslint-disable-next-line @ur/no-memory-leaks
				this["bTyped"] = false;
			}
		}
	}

};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onValueChange"] = 0; };

/**
 * Opens the list and triggers a filter of the listbox
 * @param {boolean} [bImmediate=false]
 */
UCF_SuggestBox["prototype"]["open"] = function(bImmediate) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["open"]++; }; 
	/** @type {UCF_ComboBoxListBox} */
	var oList;
	/** @type {string} sValue the current value of the SuggestBox */
	var sValue;
	/**
	 * @type {boolean} bIsServerFilter filter on the client if list is complete
	 * and suggest filter type is right
	 */
	var bIsServerFilter;
	/** @type {HTMLDivElement} */
	var oAriaSuggestRef;
	/** @type {HTMLTableDataCellElement|HTMLSpanElement|HTMLTableElement} */
	var oOpenerRef;

	if (this["sSuggestFilter"] === 'OFF') {
		UCF_ComboBox.prototype["open"]["call"](this, bImmediate);
	} else {
		oList = this["getListBox"]();

		if (oList) {
			if (this["bOpen"]) {
				if (!this["bShouldShowOverlay"]()) {
					this["closeFieldHelp"](true);
				}
			}

			sValue = this["sGetValue"]();

			if (this["oFieldHelp"] &&
				this["oFieldHelp"]["filterList"] &&
				(this["bHasFocus"]() || this["oFieldHelp"]["sServerFilter"] === '')
			) {
				// this is a ugly thing but it identifies a fieldhelppress with an
				// exchange of the whole page
				this["bFieldHelpPress"] = this["bFieldHelpPress"]
					|| (this["oFieldHelp"]["sServerFilter"] === '' &&
						!this["bHasFocus"]());

				// lock ListAccess
				this["unlockListAccess"]();

				// required for TableData ListBox Phone Overlay
				if (this["bShouldShowOverlay"]()) {
					oOpenerRef = this["oGetOpenRef"]();
					this["oFieldHelp"]["setOpenerRef"](oOpenerRef);
				}

				// the value is not set or bFieldHelpPress was fired, new we open the
				// listbox
				if (sValue === '' && !this["bFieldHelpPress"]) {
					this["setInteractionState"]({ "FocusOnInput": true });
					this["oFieldHelp"]["clearFocus"]();
					UCF_ComboBox.prototype["open"]["call"](this, bImmediate); //will not filter reused listboxes
				} else {
					if (!this["bFieldHelpPress"] && this["bHasFocus"]()
						|| this["bShouldShowOverlay"]()
					) {
						bIsServerFilter = this["bContainedInServerFiltered"](sValue);
						if (bIsServerFilter &&
							(this["sSuggestFilter"] === 'CLIENT_SERVER_PREFIX' ||
								this["sSuggestFilter"] === 'CLIENT_SERVER')
						) {
							// filter the list on the client
							// eslint-disable-next-line @ur/no-memory-leaks
							this["oFirstVisibleItem"] = this["oFieldHelp"]["filterList"](
								sValue,
								this["sSuggestFilter"] === 'CLIENT_SERVER_PREFIX',
								this["sSuggestFilterCondition"] === 'VALUE1_OR_VALUE2'
							);
							this["bClientFilter"] = true;
							this["sOldValue"] = this["sGetValue"]();

							// Auto-complete
							if (this["oFirstVisibleItem"] && this["bShouldAutoComplete"]()) {
								// Take first value from prefix-filtered list for
								// auto-completion
								this["setCurrentValue"](this["oFirstVisibleItem"]["sValue1"]);
								this["createSelection"](this["sOldValue"]);
								// Save only string typed by the user to be able to restore it
								// for keyboard navigation (onListBoxSelect)
								this["sTypedValueBeforeAC"] = this["sOldValue"];

								// First item is also automatically selected
								this["sSelectedKey"] = this["oFirstVisibleItem"]["sKey"];
								this["sTypedValue"] = this["sOldValue"];
							}
						} else if (this["sOldValue"] !== sValue) {
							// check the value again to trigger a change
							this["requestChangeTimer"]();
							return;
						}
					} else if (this["bFieldHelpPress"]) {
						if (!this["bShouldShowOverlay"]()) {
							this["select"]();
						}
					}

					if (this["oFieldHelp"]) {
						if (this["oFieldHelp"]["iGetSuggestedItems"]() > 0 || this["bShouldShowOverlay"]()) {
							this["oFieldHelp"]["hideNoResults"]();
							UCF_ComboBox.prototype["open"]["call"](this, bImmediate);
							// TODO: find correct selected item
							this["oFieldHelp"]["selectItem"](this["sSelectedKey"]);
						} else if (this["oFieldHelp"]["oTableData"]) {
							if (this["bIsExplicitListAccess"] && (this["oFieldHelp"]["bShowNoResults"](sValue) || this["bShouldShowOverlay"]())) {
								// "No Results"
								UCF_ComboBox.prototype["open"]["call"](this, bImmediate);
							}
						}
					} else {
						if (window["UCF_System"]["bIsAria"]) {
							oAriaSuggestRef = document["getElementById"](this["sId"] + '-aria-suggest');
							oAriaSuggestRef["innerText"] = this["oLS"]["sGetText"]('SAPUR_SUG_MATCH');
						}
						// no results to display and list will not open in overlay mode
						this["closeFieldHelp"](bImmediate);
						this["updateStyles"]();
					}
					this["bFieldHelpPress"] = false;
				}
				if (window["UCF_System"]["bIsAria"]) {
					// remove tutor texts
					UCF_AriaStateHelper["removeDescribedby"](this["oDomRef"]);
					// add matches
					UCF_AriaStateHelper["addDescribedby"](this["oDomRef"], this["sId"] + '-aria-suggest');
				}
			}
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Loading of suggest listbox failed id = ' + this["sItemListBoxId"], "SuggestBox.js(378): open"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["open"] = 0; };

/**
 * Checks if the given text contains unicode characters
 *
 * @private
 * @param {string} sText the text to check for unicode chars
 * @return {boolean} `true` if there are unicode chars in `sText`
 * (i.e. > `\u00ff`)
 */
UCF_SuggestBox["bContainsUnicode"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bContainsUnicode"]++; }; 
	return /[^\u0000-\u00ff]/["test"](sText);
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bContainsUnicode"] = 0; };

/**
 * Creates the selection in the InputField for auto-complete feature. The
 * complete value must already exist in this.oDomRef.value, the incomplete
 * value (typed by the user) must be contained in the argument.
 *
 * @example
 * ```javascript
 * // given <input value="hugowilli">
 * #createSelection('hugo')
 * // => hugo[willi] "willi" will be selected, "hugo" not
 * ```
 * @private
 * @param {string} sTypedValue the part of the complete value that should not be selected
 */
UCF_SuggestBox["prototype"]["createSelection"] = function(sTypedValue) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["createSelection"]++; }; 
	/** @type {TextRange} */
	var oTextRange;
	/** @type {string} */
	var sSelection;

	try { // IE8
		if (this["oFocusDomRef"]["createTextRange"]) {
			oTextRange = this["oFocusDomRef"]["createTextRange"]();
			sSelection = this["sGetCurrentValue"]()["substr"](
				sTypedValue["length"],
				this["sGetCurrentValue"]()["length"] - sTypedValue["length"]
			);

			if (sSelection !== '') {
				// IE7+8 Crash with findText of unicode textrange
				// eslint-disable-next-line no-magic-numbers
				if (UCF_UserAgent["bIsTrident"](5 /* IE9+ */ )
					// eslint-disable-next-line no-magic-numbers
					|| (UCF_UserAgent["bIsTrident"](4 /* IE8- */ ) &&
						!UCF_SuggestBox["bContainsUnicode"](sSelection))
					|| UCF_UserAgent["bIsEdgeHtml"]()
				) {
					// NO unicode
					oTextRange["findText"](sSelection, -sSelection["length"]);
				}

				oTextRange["select"]();
			}
		} else if (this["oDomRef"]["selectionStart"]) {
			this["oDomRef"]["selectionStart"] = sTypedValue["length"];
			this["oDomRef"]["selectionEnd"] = this["sGetCurrentValue"]()["length"];
		}
	} catch (oException) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, UCF_JsUtil["sJsonStringify"](oException), "SuggestBox.js(443): createSelection"); };
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["createSelection"] = 0; };

/** @private */
UCF_SuggestBox["prototype"]["openFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["openFieldHelp"]++; }; 
	/** @type {number} */
	var iSuggestedItems;
	/** @type {number} */
	var iActionItems;
	/** @type {HTMLDivElement} */
	var oAriaSuggestRef;
	/** @type {UCF_Listbox_ActionItems} */
	var oAIM;
	/** @type {UCF_Listbox_ActionItems} */
	var aActionItems;

	UCF_ComboBox.prototype["openFieldHelp"]["apply"](this, arguments);

	this["oFieldHelp"]["setPosition"]();

	if (this["sSuggestFilter"] !== 'OFF' && this["oFieldHelp"]) {
		// remove the filtering if the list is opened after a fieldhelppress event.
		if (this["bFieldHelpPress"] &&
			this["oFieldHelp"]["bComplete"] &&
			this["oFieldHelp"]["sServerFilter"] === ''
			&& this["oFieldHelp"]["filterList"]
		) {
			this["oFieldHelp"]["filterList"]('');
		}
		this["bFieldHelpPress"] = false;
	}

	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["removeExpanded"](this["oDomRef"]);
		UCF_AriaStateHelper["setExpanded"](this["oDomRef"], true);
		if (this["oFieldHelp"]) {
			UCF_AriaStateHelper["setControls"](
				this["oDomRef"],
				UCF_JsUtil["bInstanceOf"](this["oFieldHelp"], 'UCF_Listbox_Popup')
				? this["oFieldHelp"]["sId"] + '-first'
				: this["oFieldHelp"]["sId"] + '-tab'
			);
			if (UCF_JsUtil["bInstanceOf"](this["oFieldHelp"], 'UCF_Listbox_Popup')) {
				oAIM = this["oFieldHelp"]["oGetActionItemsManager"]();
				aActionItems = oAIM["aGetItems"]();
			} else if (UCF_JsUtil["bInstanceOf"](this["oFieldHelp"], 'UCF_SuggestBoxListBox')) {
				aActionItems = this["oFieldHelp"]["aGetActionItems"]()["length"];
			}
			iActionItems = aActionItems ? aActionItems["length"] : 0;
			iSuggestedItems = this["oFieldHelp"]["iGetSuggestedItems"]();
			oAriaSuggestRef = document["getElementById"](this["sId"] + '-aria-suggest');
			if (oAriaSuggestRef) {
				if (iSuggestedItems > 0 || iActionItems > 0) {
					oAriaSuggestRef["innerText"] = this["oLS"]["sGetText"]('SAPUR_CB_SUGGEST_COUNT_TUT', [iSuggestedItems + iActionItems]);
					// TODO: number of suggestions for NVDA
				} else {
					oAriaSuggestRef["innerText"] = this["oLS"]["sGetText"]('SAPUR_SUG_MATCH');
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["openFieldHelp"] = 0; };

/** @override */
UCF_SuggestBox["prototype"]["onAfterCloseFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterCloseFieldHelp"]++; }; 
	/** @type {HTMLDivElement} */
	var oAriaSuggestRef;

	UCF_ComboBox.prototype["onAfterCloseFieldHelp"]["apply"](this, arguments);
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["removeExpanded"](this["oDomRef"]);
		UCF_AriaStateHelper["setExpanded"](this["oDomRef"], false);
		// remove matches found
		UCF_AriaStateHelper["removeDescribedby"](this["oDomRef"]);
		// add tutor texts
		//UCF_AriaStateHelper.addDescribedby(this.oDomRef, 'ARIA_CB_F4Lookup_TUT');
		//UCF_AriaStateHelper.addDescribedby(this.oDomRef, 'ARIA_CB_FH_TUT');
		oAriaSuggestRef = document["getElementById"](this["sId"] + '-aria-suggest');
		if (oAriaSuggestRef) {
			oAriaSuggestRef["innerText"] = '';
		}
	}
	this["sSelectedKey"] = '';
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterCloseFieldHelp"] = 0; };

/**
 * Handles the FieldHelp event that is fired with alt arrow down or press on
 * the button. This needs special coding becaus the list needs to be unfiltered
 * in this case. If the list is complete for filter ='' filtering is removed on
 * the client otherwise a fireFieldHelpPress is fired.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event that triggered the
 * field help
 * @return {boolean} `true`
 */
UCF_SuggestBox["prototype"]["handleFieldHelpEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["handleFieldHelpEvent"]++; }; 
	this["bFieldHelpPress"] = true;
	this["getListBox"]();
	if (this["oFieldHelp"]) {
		if (this["bOpen"] && !this["oInteractionState"]["Overlay"]) {
			this["closeFieldHelp"]();
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();

			return true;
		}
		// check whether the default F4 button is used and if the server already
		// delivered a complete list
		if (this["sFieldHelp"] === 'DEFAULT' &&
			this["oFieldHelp"]["sServerFilter"] === '' &&
			this["oFieldHelp"]["bComplete"]
		) {
			// was the list filtered on the client as well, yes, then remove it
			if (this["oFieldHelp"]["sClientFilter"] === '') {
				this["open"]();
			} else {
				this["oFieldHelp"]["filterList"]('');
				this["oFieldHelp"]["selectItem"](this["sSelectedKey"]);
				this["sSelectedKey"] = '';
				this["open"]();
			}
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();

			return true;
		} else {
			// fireFieldHelpPress event in this case
			try {
				this["prepareFireChange"]();
			} catch (oException) {
				this["handleEarlyHandlerLeave"](oException);
			}
			if (this["handleFieldHelpPress"]()) {
				if (this["oInteractionState"]["Overlay"]) {
					this["closeFieldHelp"](true);
				}
				oBrowserEvent["cancel"]();
				oBrowserEvent["cancelBubble"]();
			}
			this["bTyped"] = false;

			return true;
		}
	} else {
		try {
			this["prepareFireChange"]();
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}
		if (this["handleFieldHelpPress"]()) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}

		return true;
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["handleFieldHelpEvent"] = 0; };

/**
 * Checks whether the given value is contained in the server filter of the
 * current list box
 *
 * @param {string} sValue the value to compare to the server filter
 * @return {boolean} `true` if it is contained, `false` if not or the list is
 * not available or incomplete
 */
UCF_SuggestBox["prototype"]["bContainedInServerFiltered"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bContainedInServerFiltered"]++; }; 
	this["getListBox"]();

	if ( // if there is no listbox nothing to check
		!this["oFieldHelp"] ||
		// the server should filter always or the listbox is marked as not
		// complete
		(this["sSuggestFilter"] === 'SERVER' || !this["oFieldHelp"]["bComplete"])
	) {
		return false;
	}

	// compare the values
	return UCF_StringUtil[
		(this["sSuggestFilter"] === 'CLIENT_SERVER') ? 'bContains' : 'bStartsWith'
	](
		sValue["toUpperCase"](),
		this["oFieldHelp"]["sServerFilter"]["toUpperCase"]()
	);
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bContainedInServerFiltered"] = 0; };

/**
 * Checks whether the SuggestBox has the focus or not. The focus might be in
 * the field or on the F4 button.
 *
 * @return {boolean} `true` if the suggestbox is focussed, otherwise `false`
 */
UCF_SuggestBox["prototype"]["bHasFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bHasFocus"]++; }; 
	var oRef = UCF_DomUtil["oGetActiveElement"]();

	return oRef === this["oDomRef"]
		|| oRef === this["oGetHelpButtonRef"]()
		|| oRef === this["oFocusDomRef"];
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bHasFocus"] = 0; };

/**
 * Allows to set the ItemListBoxId dynamically Needs to be implemented in
 * derived class
 *
 * @public
 * @param {string} sItemListBoxId id of the itemlistbox
 */
UCF_SuggestBox["prototype"]["setItemListBoxId"] = function(sItemListBoxId) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["setItemListBoxId"]++; }; 
	UCF_ComboBox.prototype["setItemListBoxId"]["call"](this, sItemListBoxId);
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["setItemListBoxId"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_SuggestBox["prototype"]["onAfterClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterClick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "SuggestBox.js(661): onAfterClick"); };

	if (this["sSuggestFilter"] === 'OFF') {
		UCF_ComboBox.prototype["onAfterClick"]["apply"](this, arguments);
	} else {
		if (!this["bEnabled"] || (this["bReadonly"] && !this["bShowHelpButtonAlways"])) {
			return;
		}

		if ( // check if it is a combo box click, do not handles list box clicks
			oBrowserEvent["oGetSourceControl"]() !== this ||
			// F4 needs special handling pipeline to handleFieldHelpEvent
			// and return
			(oBrowserEvent["oSource"] === this["oGetHelpButtonRef"]() &&
				this["handleFieldHelpEvent"](oBrowserEvent))
		) {
			return;
		}

		UCF_ComboBox.prototype["onAfterClick"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterClick"] = 0; };

/**
 * Handles the keydown event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_SuggestBox["prototype"]["onBeforeKeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onBeforeKeydown"]++; }; 
	/** @type {number} */
	var iKeyCode = oBrowserEvent["iKeyCode"]();

	if (UCF_UserAgent["bIsAndroid"]()) {
		// Android returns keyCode 229 for the soft keyboards and will not change
		// this, see https: //bugs.chromium.org/p/chromium/issues/detail?id=118639
		// A possible workaround to check if the user presses DELETE or BACKSPACE
		// is to store the value in keydown and to compare it in keyup. The reason
		// for this is that the value in the field will be updated immediately
		// before keyup
		// eslint-disable-next-line @ur/no-memory-leaks
		this["sAndroidOldValue"] = this["sGetValue"]();
	}

	if (this["oDataTip"]) {
		this["oDataTip"]["close"]();
	}

	if (iKeyCode !== UCF_KeyCodes["TAB"] &&
		iKeyCode !== UCF_KeyCodes["ARROW_UP"] &&
		iKeyCode !== UCF_KeyCodes["ARROW_DOWN"] &&
		iKeyCode !== UCF_KeyCodes["ARROW_LEFT"] &&
		iKeyCode !== UCF_KeyCodes["ARROW_RIGHT"] &&
		iKeyCode !== UCF_KeyCodes["SHIFT"] &&
		iKeyCode !== UCF_KeyCodes["PAGE_UP"] &&
		iKeyCode !== UCF_KeyCodes["PAGE_DOWN"] &&
		iKeyCode !== UCF_KeyCodes["END"] &&
		iKeyCode !== UCF_KeyCodes["HOME"] &&
		iKeyCode !== UCF_KeyCodes["DELETE"]
	) {
		this["bLeaveList"] = true;
	}

	if (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["F4"])) {
		this["handleFieldHelpEvent"](oBrowserEvent);

		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('[F4] => fieldhelp requested');
	}

	if ((UCF_KeyboardHelper["bIsEventForKey"](
				oBrowserEvent,
				UCF_KeyCodes["ARROW_DOWN"],
				'A'
			) ||
			UCF_KeyboardHelper["bIsEventForKey"](
				oBrowserEvent,
				UCF_KeyCodes["ARROW_UP"],
				'A'
			)
		) &&
		!this["bOpen"] &&
		this["sGetCurrentValue"]()["length"] === 0 && this["oNavigation"]["bIsEditMode"]()
	) {
		// only if the ListAccess was triggered explicitly by pressing
		// [ALT][DOWN] "no matches found" may be displayed
		this["bIsExplicitListAccess"] = true;
		this["fireListAccessInternal"]('');
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # Alt + DOWN (requesting list)', "SuggestBox.js(747): onBeforeKeydown"); };

		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('[ALT][DOWN] => list requested');
	}

	if (this["sSuggestFilter"] !== 'OFF') {
		// request might be required on Phones
		if (this["bShouldShowOverlay"]()) {
			this["requestChangeTimer"]();
		} else {
			this["cancelChangeTimer"]();
		}
	}

	UCF_ComboBox.prototype["onBeforeKeydown"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onBeforeKeydown"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the keyup
 */
UCF_SuggestBox["prototype"]["onBeforeKeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onBeforeKeyup"]++; }; 
	/** @type {number} */
	var iKeyCode;
	/** @type {number} */
	var sCurrentValue;

	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '->()', "SuggestBox.js(773): onBeforeKeyup"); };

	// for readonly SuggestBox without HelpButton do nothing
	if (!this["bShouldShowSuggest"]()) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		return;
	}

	if (this["sSuggestFilter"] === 'OFF') {
		UCF_ComboBox.prototype["onBeforeKeyup"]["apply"](this, arguments);
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # suggestFilter=OFF => called _super()', "SuggestBox.js(784): onBeforeKeyup"); };
	} else {
		this["handleEditEvents"](oBrowserEvent);

		iKeyCode = oBrowserEvent["iKeyCode"]();
		sCurrentValue = this["sGetCurrentValue"]();

		if (
			this["sGetValue"]() === '' &&
			(
				iKeyCode === UCF_KeyCodes["BACKSPACE"] ||
				iKeyCode === UCF_KeyCodes["DELETE"] ||
				(UCF_UserAgent["bIsAndroid"]() && this["sAndroidOldValue"] !== '')
			)
		) {
			this["sOldValue"] = '';
			this["sKey"] = '';
			this["setClientProperty"]("Key", this["sKey"], true);
			if (!this["bShouldShowOverlay"]()) { this["closeFieldHelp"](); }
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> empty + Backspace', "SuggestBox.js(803): onBeforeKeyup"); };
		} else {
			// copy from ComboBox code
			if (iKeyCode === UCF_KeyCodes["ARROW_LEFT"] ||
				iKeyCode === UCF_KeyCodes["ARROW_RIGHT"]
			) {
				this["bListNavigation"] = false;
				this["sSelectedKey"] = '';
				if (this["oFieldHelp"] && this["bOpen"]) {
					this["oFieldHelp"]["selectItem"](this["sSelectedKey"]);
				}
			}

			// copy from ComboBox code
			if (iKeyCode === UCF_KeyCodes["F2"]) {
				// F2 is now delayed, hence we need to close the FieldHelp delayed
				UCF_JsUtil["delayedCall"](500, this, 'checkF2Delayed');
			} else if (this["bIsRejectedKeyup"](iKeyCode)) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # not allowed key', "SuggestBox.js(821): onBeforeKeyup"); };
			} else {
				// close any opened listbox if the value is now empty
				if (sCurrentValue === '' &&
					this["oFieldHelp"] &&
					!this["bFieldHelpPress"] && (
						!oBrowserEvent["bAlt"]() || (
							iKeyCode !== UCF_KeyCodes["ARROW_UP"] &&
							iKeyCode !== UCF_KeyCodes["ARROW_DOWN"]
						)
					) &&
					iKeyCode !== UCF_KeyCodes["F4"]
				) {
					// FIXME with sSuggestFilter==='SERVER' this is not correct.
					// A shared ItemListBox opens with the previous values if it
					// is not updated -- and no ListAccess is fired when trying
					// to open it
					this["oFieldHelp"]["sClientFilter"] = '';
					this["closeFieldHelp"](true);
					this["open"](true); // reload
					UCF_DomUtil["setCursorPos"](
						this["oFocusDomRef"],
						sCurrentValue["length"]
					);
				}

				// let the combobox take over for alt and ctrl keys if value didn't
				// change
				if ((oBrowserEvent["bAlt"]() || oBrowserEvent["bCtrl"]()) &&
					this["sOldValue"] === sCurrentValue
				) {
					UCF_ComboBox.prototype["onBeforeKeyup"]["apply"](this, arguments);
					if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # {Alt,Ctrl} + unchanged value => called _super()', "SuggestBox.js(853): onBeforeKeyup"); };
				} else {
					// if the text was selected and now the user types
					if (this["bSelected"] && !this["bTyped"]) {
						this["bTyped"] = true;
						this["bSelected"] = false;
					}
					// exit if the value is still the same as before
					if (this["sOldValue"] === sCurrentValue &&
						!this["bTyped"] &&
						// CSN 1570840796: proceed if the value was selected and
						// overridden with the exact same value (i.e. enter 'a' ->
						// listbox opens, press 'esc', press 'cmd+a', press 'a' ->
						// listbox should open)
						this["sSelectedValue"] !== sCurrentValue
					) {
						if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # value didnt change', "SuggestBox.js(869): onBeforeKeyup"); };
					} else {
						this["bTyped"] = this["sOldValue"] !== sCurrentValue ||
							this["sSelectedValue"] === sCurrentValue ||
							this["bTyped"];
						this["bListNavigation"] = false;

						if (this["bShouldAutoComplete"]() &&
							this["sOldValue"]["toLowerCase"]() ===
							sCurrentValue["toLowerCase"]() &&
							this["sSelectedValue"]["toLowerCase"]() !==
							sCurrentValue["toLowerCase"]()
						) {
							if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # autocomplete, value didnt change', "SuggestBox.js(882): onBeforeKeyup"); };
						} else if (!this["lockListAccessEvents"]) {
							// start the filter timer
							// avoid valuechange after deleting a deletable history item
							// or pressing CTRL+A
							if (
								(!UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["DELETE"]) ||
									!this["bIsDeleteOnHistoryItem"]) &&
								!UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["A"], 'C')
							) {
								this["requestChangeTimer"]();
							}
						}
						if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()->', "SuggestBox.js(895): onBeforeKeyup"); };
					}
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onBeforeKeyup"] = 0; };

/**
 * @private
 */
UCF_SuggestBox["prototype"]["checkF2Delayed"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["checkF2Delayed"]++; }; 
	if(!this["oNavigation"]["bIsEditMode"]() && this["bOpen"]) {
		this["closeFieldHelp"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # F2, open, in table mode', "SuggestBox.js(909): checkF2Delayed"); };
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["checkF2Delayed"] = 0; };


/**
 * @private
 * @param {number} iKeyCode the keycode of the keyup
 * @return {boolean}
 */
UCF_SuggestBox["prototype"]["bIsRejectedKeyup"] = function(iKeyCode) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bIsRejectedKeyup"]++; }; 
	return iKeyCode === UCF_KeyCodes["ALT"] ||
		iKeyCode === UCF_KeyCodes["CONTROL"] ||
		iKeyCode === UCF_KeyCodes["WINDOWS"] ||
		iKeyCode === UCF_KeyCodes["ENTER"] ||
		iKeyCode === UCF_KeyCodes["HOME"] ||
		iKeyCode === UCF_KeyCodes["END"] ||
		iKeyCode === UCF_KeyCodes["PAGE_DOWN"] ||
		iKeyCode === UCF_KeyCodes["PAGE_UP"] ||
		iKeyCode === UCF_KeyCodes["ESCAPE"] ||
		iKeyCode === UCF_KeyCodes["SHIFT"] ||
		iKeyCode === UCF_KeyCodes["TAB"] ||
		iKeyCode === UCF_KeyCodes["ARROW_RIGHT"] ||
		iKeyCode === UCF_KeyCodes["ARROW_LEFT"] ||
		iKeyCode === UCF_KeyCodes["ARROW_UP"] ||
		iKeyCode === UCF_KeyCodes["ARROW_DOWN"] ||
		iKeyCode === UCF_KeyCodes["F1"] ||
		iKeyCode === UCF_KeyCodes["F2"] ||
		iKeyCode === UCF_KeyCodes["F3"] ||
		iKeyCode === UCF_KeyCodes["F4"] ||
		iKeyCode === UCF_KeyCodes["F5"] ||
		iKeyCode === UCF_KeyCodes["F6"] ||
		iKeyCode === UCF_KeyCodes["F7"] ||
		iKeyCode === UCF_KeyCodes["F8"] ||
		iKeyCode === UCF_KeyCodes["F9"] ||
		iKeyCode === UCF_KeyCodes["F10"] ||
		iKeyCode === UCF_KeyCodes["F11"] ||
		iKeyCode === UCF_KeyCodes["F12"] ||
		iKeyCode === UCF_KeyCodes["PRINT"] ||
		iKeyCode === UCF_KeyCodes["INSERT"] ||
		iKeyCode === UCF_KeyCodes["PAUSE"] ||
		iKeyCode === UCF_KeyCodes["CAPS_LOCK"] ||
		iKeyCode === UCF_KeyCodes["NUM_LOCK"] ||
		iKeyCode === UCF_KeyCodes["SCROLL_LOCK"];
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["bIsRejectedKeyup"] = 0; };

/** @override */
UCF_SuggestBox["prototype"]["onAfterLsFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterLsFocus"]++; }; 
	UCF_ComboBox.prototype["onAfterLsFocus"]["apply"](this, arguments);

	if (
		window["UCF_System"]["bIsAria"] &&
		this["bShouldShowSuggest"]() &&
		this["sItemListBoxId"] &&
		UCF_DomUtil["$"](this["sItemListBoxId"])
	) {
		// add tutor: "To open suggest list, press ALT + arrow down"
		// UCF_AriaStateHelper.addDescribedby(this.oDomRef, 'ARIA_CB_FH_TUT');
		// UCF_AriaStateHelper.setHasPopup(this.oDomRef, 'true');
	}

	this["unlockListAccess"]();
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterLsFocus"] = 0; };

/**
 * @override
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lshome/lsend
 */
UCF_SuggestBox["prototype"]["onAfterLsEnter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterLsEnter"]++; }; 
	UCF_ComboBox.prototype["onAfterLsEnter"]["apply"](this, arguments);
	if (!this["bListNavigation"] && this["bShouldAutoComplete"]()) {
		// The user "selected" the auto-completed suggestion using [ENTER] without
		// moving into the suggest list: Select the whole input
		this["select"]();
	}
	this["sSelectedKey"] = '';
	this["sOldValue"] = this["sGetCurrentValue"]();
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterLsEnter"] = 0; };

/**
 * @override
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshome/lsend
 * @param {string} sAction the name of the UCF_SuggestBox member function to be
 * called
 */
UCF_SuggestBox["prototype"]["handleLsItemNavigationKeys"] = function(oBrowserEvent, sAction) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["handleLsItemNavigationKeys"]++; }; 
	if (
		this["bIsWriteable"]() &&
		this["oNavigation"]["bIsEditMode"]() &&
		this["bListNavigation"] &&
		this["oFieldHelp"]["bOpened"]
	) {
		UCF_ComboBox.prototype["handleLsItemNavigationKeys"]["call"](this, oBrowserEvent, sAction);
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["handleLsItemNavigationKeys"] = 0; };

/** @override */
UCF_SuggestBox["prototype"]["onBeforeLsEscape"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onBeforeLsEscape"]++; }; 
	if (this["oFieldHelp"] && this["bOpen"]) {
		if (this["sTypedValue"]) {
			this["updateValue"]('', this["sTypedValue"], true);
			if (
				UCF_KeyboardHelper["bIsEventForKey"](
					oBrowserEvent,
					UCF_KeyCodes["ESCAPE"]
				) &&
				this["oNavigation"]["bIsEditMode"]()
			) {
				this["fireListAccessInternal"](this["sTypedValue"]);
				this["setInteractionState"]({ "FocusOnInput": true });
				this["oFieldHelp"]["clearFocus"]();
				if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '()-> # [ESC] (requesting list)', "SuggestBox.js(1022): onBeforeLsEscape"); };
			}
			this["sTypedValue"] = null;
		} else {
			this["closeFieldHelp"]();
		}
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		if (window["UCF_System"]["bIsAria"] || window["UCF_System"]["bIs508"]) {
			UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], '');
		}

		throw new (UCF_ClassLoader["oGetClass"]("UCF_Exception"))('value updated => leaving [ESC] handler');
	} else {
		UCF_ComboBox.prototype["onBeforeLsEscape"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onBeforeLsEscape"] = 0; };

/**
 * Handles the selectstart event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the selectstart
 */
UCF_SuggestBox["prototype"]["onselectstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onselectstart"]++; }; 
	if (this["sSuggestFilter"] !== 'OFF') {
		this["bSelected"] = true;
	}
	UCF_ComboBox.prototype["onselectstart"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onselectstart"] = 0; };

/** @override */
UCF_SuggestBox["prototype"]["onAfterSelect"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterSelect"]++; }; 
	UCF_JsUtil["delayedCall"](0, this, 'storeSelection');
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterSelect"] = 0; };

/** @private */
UCF_SuggestBox["prototype"]["storeSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["storeSelection"]++; }; 
	// IE11 says it supports getSelection(), but it is always empty...
	if (typeof this["oDomRef"]["selectionStart"] === 'number' &&
		typeof this["oDomRef"]["selectionEnd"] === 'number'
	) {
		this["sSelectedValue"] = this["sGetCurrentValue"]()["slice"](
			this["oDomRef"]["selectionStart"],
			this["oDomRef"]["selectionEnd"]
		);
	} else if (typeof window["getSelection"] === 'function') {
		this["sSelectedValue"] = window["getSelection"]()["toString"]();
	}
	// CL 241205: UCF_DomUtil.sGetSelectionText is broken in IE,
	// otherwise we'd just use it (see JIRA:WDAUIUR-436)
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["storeSelection"] = 0; };

/**
 * @override
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_SuggestBox["prototype"]["onBeforeLsBlur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onBeforeLsBlur"]++; }; 
	if (this["sSuggestFilter"] !== 'OFF') {
		this["bFieldHelpPress"] = false;
	}
	UCF_ComboBox.prototype["onBeforeLsBlur"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onBeforeLsBlur"] = 0; };

UCF_SuggestBox["prototype"]["onAfterLsBlur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterLsBlur"]++; }; 
	UCF_ComboBox.prototype["onAfterLsBlur"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onAfterLsBlur"] = 0; };

/**
 * Code combined from ComboBox onlstabnext and onlsreturn
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the lstabnext
 */
UCF_SuggestBox["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onlstabnext"]++; }; 
	/** @type {string} */
	var sKey;
	/** @type {string} */
	var sValue;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oBrowserEvent, 'UCF_BrowserEvent'), "UCF_JsUtil.bInstanceOf(oBrowserEvent, 'UCF_BrowserEvent')", "SuggestBox.js(1100): onlstabnext"); };

	this["sSelectedKey"] = '';
	this["sOldValue"] = this["sGetCurrentValue"]();

	if (this["bOpen"]) {
		this["bNoBlur"] = false;

		// if you did a list navigation with the keyboard, copy selected value from
		// the list
		if (this["bListNavigation"]) {
			sKey = this["oFieldHelp"]["sGetSelectedItemKey"]();
			sValue = '';
			if (sKey) {
				sValue = this["oFieldHelp"]["sGetItemValue"](sKey);
				this["updateValue"](sKey, sValue, true);
			} else {
				sValue = this["oFieldHelp"]["sGetItemValue"](this["sKeySave"]);
				this["updateValue"](this["sKeySave"], this["sValueSave"], true);
			}
			this["selectText"](sValue);
		}
		this["closeFieldHelp"]();

		// 1904497 2009: NO button pressed event when item list was opened
		this["bIgnoreDefaultButton"] = true;

		// fire change event if value has changed
		try {
			this["prepareFireChange"](
				UCF_EditFieldBase["E_CHANGE_REASON"]["Other"],
				true
			);
		} catch (oException) {
			this["handleEarlyHandlerLeave"](oException);
		}

		this["bIgnoreDefaultButton"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onlstabnext"] = 0; };

/**
 * override implementation of ComboBox because it is wrong
 * @override
 * @param {UCF_Event} oEvent the listboxselect
 */
UCF_SuggestBox["prototype"]["onListBoxSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onListBoxSelect"]++; }; 
	/** @type {string} */
	var sEventName = oEvent["oGetParam"]('sEventName');
	/** @type {boolean} */
	var bFireSelect = null;
	/** @type {string} */
	var sValue = oEvent["oGetParam"]('sValue');

	this["setInteractionState"]({ "FocusOnInput": false });
	this["sSelectedKey"] = oEvent["oGetParam"]('sKey');

	switch (sEventName) {
		case 'click':
		case 'lstouchend':
			bFireSelect = oEvent["oGetParam"]('bFireSelect');
			this["oNavigation"]["keepEditMode"]();
			this["updateValue"](this["sSelectedKey"], sValue, !bFireSelect);
			this["bIgnoreDefaultButton"] = false;
			this["focus"]();
			this["select"]();
			break;

		case 'previousitem':
		case 'nextitem':
		case 'firstitem':
		case 'lastitem':
		case 'pageup':
		case 'pagedown':
			if ((!this["oFieldHelp"] || this["oFieldHelp"]["bOpened"])
				&& !this["oInteractionState"]["TouchInteraction"]
			) {
				UCF_DomUtil["setCursorPos"](this["oFocusDomRef"], this["sGetDomRefValue"]()["length"]);
				bFireSelect = oEvent["oGetParam"]('bFireSelect');
				// Save the value the user typed to be able to restore it when the user
				// leaves the listbox via up/down keys
				if (typeof this["sTypedValue"] !== 'string' || this["bLeaveList"]) {
					this["sTypedValue"] = this["sGetCurrentValue"]();
				}
				this["updateValue"](
					this["sSelectedKey"],
					sValue || this["sTypedValue"], !bFireSelect
				);
				this["bLeaveList"] = false;
			}
			break;

		case 'leave':
			if (!this["oFieldHelp"] || this["oFieldHelp"]["bOpened"]) {
				this["bLeaveList"] = true;
				// Restore typed value
				if (!this["sTypedValue"]) {
					this["sTypedValue"] = this["sGetCurrentValue"]();
				}
				this["updateValue"]('', this["sTypedValue"], !bFireSelect);
				if (this["bShouldAutoComplete"]() && this["sTypedValueBeforeAC"]) {
					this["createSelection"](this["sTypedValueBeforeAC"]);
				}
				this["sTypedValue"] = null;
				this["closeFieldHelp"]();
				this["oNavigation"]["keepEditMode"]();
				this["focus"]();
			}
			break;

		case 'delete':
			if (!this["oFieldHelp"] || this["oFieldHelp"]["bOpened"]) {
				bFireSelect = oEvent["oGetParam"]('bFireSelect');
				this["updateValue"](
					this["sSelectedKey"],
					sValue || this["sTypedValue"], !bFireSelect
				);
				this["bLeaveList"] = false;
			}
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onListBoxSelect"] = 0; };

/**
 * @private
 * @override
 */
UCF_SuggestBox["prototype"]["onWillDestroySuggestBox"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onWillDestroySuggestBox"]++; }; 
	if (typeof this["iChangeAFId"] === 'number') {
		UCF_JsUtil["cancelAnimationFrame"](this["iChangeAFId"]);
		this["iChangeAFId"] = null;
	}
	if (this["oSuggestTip"] && !this["oSuggestTip"]["bIsDestroyed"]) {
		this["oSuggestTip"]["destroy"]();
	}
	this["sOldValue"] = null;
	this["sSelectedKey"] = null;
	this["sSelectedValue"] = null;
	this["sTypedValue"] = null;
	this["sTypedValueBeforeAC"] = null;
	this["sAndroidOldValue"] = null;

	this["bFieldHelpPress"] = null;
	this["bTyped"] = null;

	this["oFirstVisibleItem"] = null;
};;if (__UCF_COVERAGE__) { UCF_SuggestBox["_"]["onWillDestroySuggestBox"] = 0; };

UCF_SuggestBox.prototype["aPublicMethods"] = ["setItemListBoxId"].concat(UCF_SuggestBox.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_SuggestBoxListBox"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ComboBoxListBox */
/// <reference path="./ComboBoxListBox.js"/>

/**
 * SuggestBoxListBox
 * Implements an extension to the ComboBoxListBox that allows filtering for the
 * SuggestBox
 * <br>
 * <b>Java Control references</b><br>
 * <a href='../javadoc/com/sap/tc/ls/api/controls/LSItemListBox.html'>LSItemListBox</a>
 *
 * 
 *
 * @version
 * @class
 * @extends UCF_ComboBoxListBox
 * @param {HTMLElement} oDomRef the DOM element that represents the control
 * @param {UCF_LS} oLS the LightSpeed instance that manages the control
 */
function UCF_SuggestBoxListBox(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["UCF_SuggestBoxListBox"]++; }; 
	UCF_ComboBoxListBox["apply"](this, [oDomRef, oLS]);
	// remember the client side filter for the SuggestBox.
	this["sClientFilter"] = '';

	// do not move the suggest box over the input field if it doesn't fit on the screen
	this["setMoveIntoViewPortXY"](true, false);
};window["UCF_SuggestBoxListBox"] = UCF_SuggestBoxListBox; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_SuggestBoxListBox"); UCF_SuggestBoxListBox["_"] = {UCF_SuggestBoxListBox: 0}; }; ;
UCF_SuggestBoxListBox["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ComboBoxListBox"))(); UCF_SuggestBoxListBox.prototype["sClassName"] = "UCF_SuggestBoxListBox";

/**
 * @private
 */
UCF_SuggestBoxListBox["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["destroy"]++; }; 
	this["sClientFilter"] = null;
	this["iSuggestedItems"] = null;
	UCF_ComboBoxListBox.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["destroy"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_SuggestBoxListBox["prototype"]["iGetSuggestedItems"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["iGetSuggestedItems"]++; }; 
	if (typeof this["iSuggestedItems"] !== 'number') {
		this["iSuggestedItems"] = this["iGetItemCount"]();
	}

	return this["iSuggestedItems"];
};;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["iGetSuggestedItems"] = 0; };

/**
 * Filters the list dynamically on the client for all values that match a sFilter
 * Items that start with the sFilter are displayed. Filtering is not case sensitive.
 *
 * @param {string} sFilter String to be filtered.
 * @param {boolean} bPrefixSearch indicates whether a 'prefix' search or 'contains' search is done.
 * @param {boolean} bBothValues `true` => match only against Value1, `false` => match against 'Value1 OR Value2'.
 * @return {UCF_ItemListBoxItem?} The first visible item or null.
 */
UCF_SuggestBoxListBox["prototype"]["filterList"] = function(sFilter, bPrefixSearch, bBothValues) {;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["filterList"]++; }; 
	// count the visible items
	var iVisibleItems = 0,
		oFirstVisibleItem, self, iSeparatorIndex;
	/** @type {Array.<DomRefs>} */
	var aItemsDomRef;

	// eslint-disable-next-line quotes
	this["setClientProperty"]("VisibleItems", this["iVisibleItems"], true);

	// make filter ignore case
	sFilter = sFilter["toUpperCase"]();
	if (this["sClientFilter"] === sFilter) {
		// The same filter is already applied, just find first visible item
		return UCF_JsUtil["find"](this["aGetItems"](), function(oItem) { return oItem["oDomRef"]["style"]["display"] === ''; });
	}

	// update to the new client filter
	this["sClientFilter"] = sFilter;
	this["oCache"]["invalidate"]('aGetItemsDomRefs');
	this["aItems"] = null;

	self = this;

	UCF_JsUtil["forEach"](this["aGetItems"](), function(oItem, iIndex) {
		// if the filter is empty make all items visible
		if (sFilter === '') {
			iVisibleItems++;
			self["showRef"](oItem["oDomRef"]);
		} else {
			if (self["bIsMatch"](sFilter, bPrefixSearch, oItem["sValue1"], bBothValues ? oItem["sValue2"] : undefined)) {
				// increase the item count
				iVisibleItems++;
				// searchstring found, display row
				self["showRef"](oItem["oDomRef"]);

				if (!oFirstVisibleItem) {
					oFirstVisibleItem = oItem;
				}
			} else {
				// searchstring not found, do not display row
				self["hideRef"](oItem["oDomRef"]);
			}
		}
	});

	iSeparatorIndex = this["iGetSeparatorIndex"]();
	aItemsDomRef = this["aGetItemsDomRefs"]();

	if (this["bShouldShowSeparator"](iSeparatorIndex)) {
		this["showRef"](aItemsDomRef[iSeparatorIndex]);
		iVisibleItems++;
	}

	// SuggestBox asks for this
	this["iSuggestedItems"] = iVisibleItems;

	if (iVisibleItems === 0) {
		return null;
	}

	return oFirstVisibleItem;
};;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["filterList"] = 0; };

/**
 * @override
 * @return {number} the # of currently visible items
 */
UCF_SuggestBoxListBox["prototype"]["iGetCurrentlyVisibleItems"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["iGetCurrentlyVisibleItems"]++; }; 
	return this["iGetSuggestedItems"]();
};;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["iGetCurrentlyVisibleItems"] = 0; };

/** @return {number} the index of the first separator in #aItemsDomRef, or `undefined` */
UCF_SuggestBoxListBox["prototype"]["iGetSeparatorIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["iGetSeparatorIndex"]++; }; 
	/** @type {Array.<DomRefs>} */
	var aItemsDomRef;

	aItemsDomRef = this["aGetItemsDomRefs"]();
	for (var i = 0; i < aItemsDomRef["length"]; i++) {
		if (aItemsDomRef[i]["getAttribute"]('name') === 'HLine') {
			return i;
		}
	}
	return undefined;
};;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["iGetSeparatorIndex"] = 0; };

/**
 * @param {number} iSeparatorIndex the index of the first separator in #aItemsDomRef
 * @return {boolean} `true` if both a history item and a normal item are visible (=> need to show the separator), else `false`
 */
UCF_SuggestBoxListBox["prototype"]["bShouldShowSeparator"] = function(iSeparatorIndex) {;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["bShouldShowSeparator"]++; }; 
	/** @type {UCF_SuggestBoxListBox} */
	var self = this;
	/** @type {Array.<DomRefs>} */
	var aItemsDomRef;

	aItemsDomRef = this["aGetItemsDomRefs"]();

	return iSeparatorIndex
		&& iSeparatorIndex > 0
		&& UCF_JsUtil["find"](aItemsDomRef["slice"](0, iSeparatorIndex), function(oDomRef) { return !self["bIsRefHidden"](oDomRef); })
		&& UCF_JsUtil["find"](aItemsDomRef["slice"](iSeparatorIndex + 1), function(oDomRef) { return !self["bIsRefHidden"](oDomRef); });
};;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["bShouldShowSeparator"] = 0; };

/**
 * @param {string} sFilter the filter value that should be matched
 * @param {boolean} bPrefixSearch wether or not the match must be a prefix
 * @param {string} _sValue1 the first value
 * @param {string} [_sValue2] the second value
 * @return {boolean} `true` if sValue1 (and sValue2, if provided) match sFilter given bPrefixSearch
 */
UCF_SuggestBoxListBox["prototype"]["bIsMatch"] = function(sFilter, bPrefixSearch, _sValue1, _sValue2) {;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["bIsMatch"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sFilter === 'string', "typeof sFilter === 'string'", "SuggestBoxListBox.js(182): bIsMatch"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof bPrefixSearch === 'boolean', "typeof bPrefixSearch === 'boolean'", "SuggestBoxListBox.js(183): bIsMatch"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof _sValue1 === 'string', "typeof _sValue1 === 'string'", "SuggestBoxListBox.js(184): bIsMatch"); };
	if (_sValue2) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof _sValue2 === 'string', "typeof _sValue2 === 'string'", "SuggestBoxListBox.js(186): bIsMatch"); };
	}

	var sValue1 = _sValue1["toUpperCase"](),
		iIndexValue1 = UCF_JsUtil["indexOf"](sValue1, sFilter),
		sValue2, iIndexValue2;

	if (_sValue2) {
		sValue2 = _sValue2["toUpperCase"]();
		iIndexValue2 = UCF_JsUtil["indexOf"](sValue2, sFilter);
		return !((bPrefixSearch && (iIndexValue1 !== 0 && iIndexValue2 !== 0 && sFilter !== '')) ||
			(!bPrefixSearch && (iIndexValue1 < 0 && iIndexValue2 < 0 && sFilter !== '')));
	} else {
		return !((bPrefixSearch && (iIndexValue1 !== 0 && sFilter !== '')) ||
			(!bPrefixSearch && (iIndexValue1 < 0 && sFilter !== '')));
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["bIsMatch"] = 0; };

/**
 * Checks if the control has a valid DOM reference.
 * This can be used for timeout methods, that may be called after the HTML
 * of the control has already been removed.
 *
 * @return {boolean} Whether the control has a valid DOM reference
 */
UCF_SuggestBoxListBox["prototype"]["bIsValid"] = function() {;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["bIsValid"]++; }; 
	var oRootRef = UCF_DomUtil["$"](this["sId"] + '-r');

	if (this["oRootRef"] && this["oRootRef"] !== oRootRef) {
		return false;
	} else {
		if (this["oDomRef"] && this["oDomRef"]["parentNode"] && this["oDomRef"]["parentNode"]["parentNode"] && !(UCF_DomUtil["bContains"](this["oRootRef"], this["oDomRef"]))) {
			this["oDomRef"]["parentNode"]["parentNode"]["removeChild"](this["oDomRef"]["parentNode"]);
			return false;
		}
		return true;
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["bIsValid"] = 0; };

/**
 * Handle Delete Item
 * @protected
 * @param {UCF_ItemListBoxItem|UCF_ItemListBoxActionItem} oItem the next item
 */
UCF_SuggestBoxListBox["prototype"]["handleDeleteItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["handleDeleteItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!oItem || UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem'), "!oItem || UCF_JsUtil.bInstanceOf(oItem, 'UCF_ItemListBoxItem')", "SuggestBoxListBox.js(231): handleDeleteItem"); };

	// var sEventName = 'nextitem';
	var oNextItem = null;

	// if an item in the list is selected, take this one
	if (this["oSelectedItem"]) oItem = this["oSelectedItem"];

	oNextItem = this["oGetNextItem"](oItem);
	if (oNextItem !== oItem) {
		// there's a 'real' next item? Select this.
		this["selectItemAndFire"](oNextItem, 'nextitem');
	} else {
		oNextItem = this["oGetFirstActionItem"]();
		if (oNextItem) {
			// there's an action item? Select this.
			this["selectActionItem"](oNextItem);
			this["fireSelect"]({
				"sKey": '',
				"sValue": '',
				"bFireSelect": false,
				"sEventName": 'nextitem'
			});
		} else {
			oNextItem = this["oGetPreviousItem"](oItem);
			if (oNextItem !== oItem) {
				// there's an item before? Select this.
				this["selectItemAndFire"](oNextItem, 'delete');
			} else {
				// give up: unselect
				this["fireEvent"](this["E_EVENTS"]["Select"], { "sKey": '', "sValue": '', "bFireSelect": false, "sEventName": 'leave' });
			}
		}
	}

	this["deleteItem"](oItem);

};;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["handleDeleteItem"] = 0; };

/**
 * Select next item
 *
 * @private
 * @param {UCF_ItemListBoxItem|UCF_ItemListBoxActionItem} [oItem] the next item that should be handled
 */
UCF_SuggestBoxListBox["prototype"]["handleNextItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["handleNextItem"]++; }; 
	/** @type {UCF_ItemListBoxItem} */
	var oNextItem;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(!oItem || UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem') || UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxActionItem'), "!oItem || UCF_JsUtil.bInstanceOf(oItem, 'UCF_ItemListBoxItem') || UCF_JsUtil.bInstanceOf(oItem, 'UCF_ItemListBoxActionItem')", "SuggestBoxListBox.js(280): handleNextItem"); };

	// if an item in the list is selected, take this one
	if (this["oSelectedItem"]) oItem = this["oSelectedItem"];

	if (UCF_JsUtil["bInstanceOf"](this["oSelectedItem"], 'UCF_ItemListBoxActionItem')) {
		// if an action item is currently selected, navigate in the action item list
		oNextItem = this["oGetNextActionItem"](this["oSelectedItem"]);
		this["selectActionItem"](oNextItem);
		this["fireSelect"]({
			"sKey": '',
			"sValue": '',
			"bFireSelect": false,
			"sEventName": 'nextitem'
		});
	} else if (oItem === this["oGetLastItem"]() && this["aGetActionItems"]()["length"] > 0) {
		// if the item is already the last one in the list and there are action items,
		// select the first action item
		oNextItem = this["oGetFirstActionItem"]();
		this["selectActionItem"](oNextItem);
		this["fireSelect"]({
			"sKey": '',
			"sValue": '',
			"bFireSelect": false,
			"sEventName": 'nextitem'
		});
	} else {
		// select the next item or the first item if no item is passed
		this["selectItemAndFire"](oItem ? this["oGetNextItem"](oItem) : this["oGetFirstItem"](), 'nextitem');
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["handleNextItem"] = 0; };

/**
 * Select previous item
 * @protected
 * @param {(UCF_ItemListBoxItem|UCF_ItemListBoxActionItem)} [oItem]
 */
UCF_SuggestBoxListBox["prototype"]["handlePreviousItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["handlePreviousItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(!oItem || UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxItem') || UCF_JsUtil["bInstanceOf"](oItem, 'UCF_ItemListBoxActionItem'), "!oItem || UCF_JsUtil.bInstanceOf(oItem, 'UCF_ItemListBoxItem') || UCF_JsUtil.bInstanceOf(oItem, 'UCF_ItemListBoxActionItem')", "SuggestBoxListBox.js(318): handlePreviousItem"); };

	var oPreviousItem = null;

	// if an item in the list is selected, take this one
	if (this["oSelectedItem"]) oItem = this["oSelectedItem"];

	if (UCF_JsUtil["bInstanceOf"](this["oSelectedItem"], 'UCF_ItemListBoxActionItem')) {
		// if an action item is currently selected, navigate in the action item list
		oPreviousItem = this["oGetPreviousActionItem"](this["oSelectedItem"]);
		if (this["oSelectedItem"] !== oPreviousItem) {
			this["oSelectedItem"]["select"](false);
			oPreviousItem["select"](true);
			this["oSelectedItem"] = oPreviousItem;
		} else {
			oPreviousItem = this["oGetLastItem"]();
			if (oPreviousItem) {
				this["selectItem"](oPreviousItem["sKey"]);
				if (this["oSelectedItem"]) {
					this["fireSelect"]({
						"sKey": this["oSelectedItem"]["sKey"],
						"sValue": this["sGetItemValue"](this["oSelectedItem"]["sKey"]),
						"bFireSelect": false,
						"sEventName": 'previousitem'
					});
				}
			}
		}
		// 1780119710: as a workaround we need to add aria attributes also in 508
		// else JAWS 17/18 does not announce the items within a list properly
		if ((window["UCF_System"]["bIsAria"] || this["oLS"]["oSystem"]["bIs508"]) && this["oOpenerRef"]) {
			UCF_AriaStateHelper["setActivedescendant"](this["oOpenerRef"], this["oSelectedItem"]["sId"]);
		}
	} else {
		// select the previous item or the last item if no item is passed
		this["selectItemAndFire"](oItem ? this["oGetPreviousItem"](oItem) : this["oGetLastItem"](), 'previousitem');
	}
};;if (__UCF_COVERAGE__) { UCF_SuggestBoxListBox["_"]["handlePreviousItem"] = 0; };

};
sap["ls"]["preload"]["UCF_Switch"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_SelectorDelegate */
/// <reference path="./delegates/SelectorDelegate.js"/>
/* global UCF_Selector_508_Delegate */
/// <reference path="./delegates/Selector_508_Delegate.js"/>

/**
 * @class Switch
 * @version
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Switch(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Switch["_"]["UCF_Switch"]++; }; 
	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Switch.js(29): UCF_Switch"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Switch.js(30): UCF_Switch"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Switch.js(31): UCF_Switch"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oFocusDomRef"] = this["oDomRef"];
	this["sFocusType"] = 'NAVIGATION';
	this["oBase"] = new (UCF_ClassLoader["oGetClass"]("UCF_SelectorDelegate"))(this);
	this["addDelegate"](this["oBase"]);

	if (window["UCF_System"]["bIs508"]) {
		this["Delegate_508"] = new (UCF_ClassLoader["oGetClass"]("UCF_Selector_508_Delegate"))(this);
		this["addDelegate"](this["Delegate_508"]);
	}
};window["UCF_Switch"] = UCF_Switch; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Switch"); UCF_Switch["_"] = {UCF_Switch: 0}; }; ;
UCF_Switch["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Switch.prototype["sClassName"] = "UCF_Switch";

/**
 * ############################################################################
 *
 * SECTION IS A COLLECTION OF ALL DATA NECESSARY FOR INTERACTION
 *
 * ############################################################################
 */

/**
 * Enumeration that indicates whether or not the switch is turned on
 * @private
 */
UCF_Switch["prototype"]["eHandle"] = {
	"ON": 'on',
	"OFF": 'off'
};

/**
 * Enumeration that indicates how users change the selection state
 * @private
 */
UCF_Switch["prototype"]["E_ACCESSTYPE"] = {
	"CLICK": 'CLICK',
	"KEYBOARD": 'KEYBOARD',
	"DRAG": 'DRAG',
	"TOUCH": 'TOUCH',
	"NONE": 'NONE'
};

/**
 * Enumeration that indicates how users change the selection state
 * @private
 */
UCF_Switch["prototype"]["E_DRAG_DIRECTION"] = {
	"LEFT": 'LEFT',
	"RIGHT": 'RIGHT',
	"NONE": 'NONE'
};

/**
 * Data necessary during the process of dragging
 * @private
 */
UCF_Switch["prototype"]["oData"] = {
	"MARGIN_PROPERTY_ON": null,
	"MARGIN_PROPERTY_OFF": null,
	"MARGIN_TO_REFERE": null,
	"LAST_MARGIN": null,
	"LAST_MOUSE_POSITION": null,
	"ACCESS_TYPE": 'NONE',
	"HANDLE": null,
	"CONTAINER_TO_MOVE": null,
	"RECT": null,
	"DIRECTION": null,
	"CURRENT_SELECTION": null,
	"POINT_ZERO": null
};

/**
 * @private
 * @param { oBrowserEvent } oBrowserEvent
 */
UCF_Switch["prototype"]["collectData"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["collectData"]++; }; 
	/** @type {UCF_Switch} */
	var self = this;
	/** @type {bool} */
	// eslint-disable-next-line @ur/no-memory-leaks
	var bChecked = this["sSelection"] === this["oBase"]["eSelectionState"]["CHECKED"];

	this["oData"]["MARGIN_PROPERTY_ON"] = (window["UCF_System"]["bIsRTL"]) ? 'marginLeft' : 'marginRight';
	this["oData"]["MARGIN_PROPERTY_OFF"] = (window["UCF_System"]["bIsRTL"]) ? 'marginRight' : 'marginLeft';
	this["oData"]["CONTAINER_TO_MOVE"] = UCF_DomUtil["$"](this["sId"] + '-drag');
	/**
	 * @return { int } The margin of the handle in the current theme
	 * The margin of the handle indicates the selection state of
	 * the switch
	 */
	function iGetReferenceMargin() {
		/** @type {string} value as retrieved from HTML */
		var sMargin;
		/** @type {int} HTML value turned into integer */
		var iMargin;
		/** @type {string} value as retrieved from HTML */
		var sPointZero;
		/** @type {int} HTML value turned into integer */
		var iPointZero;

		sMargin = UCF_DomUtil["sGetCurrentStyle"](self["oData"]["CONTAINER_TO_MOVE"], bChecked ? self["oData"]["MARGIN_PROPERTY_ON"] : self["oData"]["MARGIN_PROPERTY_OFF"]);
		sPointZero = UCF_DomUtil["sGetCurrentStyle"](self["oData"]["CONTAINER_TO_MOVE"], bChecked ? self["oData"]["MARGIN_PROPERTY_OFF"] : self["oData"]["MARGIN_PROPERTY_ON"]);

		iMargin = parseInt(sMargin);
		iPointZero = parseInt(sPointZero);

		return { 'iMargin': iMargin, 'iPointZero': iPointZero };
	}
	/** @type {Object} */
	var oMargins = iGetReferenceMargin();
	this["oData"]["MARGIN_TO_REFERE"] = oMargins["iMargin"];
	this["oData"]["HANDLE"] = UCF_DomUtil["$"](this["sId"] + '-handle');
	this["oData"]["LAST_MOUSE_POSITION"] = oBrowserEvent ? oBrowserEvent["_iClientX"] : null;
	this["oData"]["LAST_MARGIN"] = bChecked ? 0 : this["oData"]["MARGIN_TO_REFERE"];
	this["oData"]["RECT"] = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oData"]["CURRENT_SELECTION"] = this["sSelection"];
	this["oData"]["POINT_ZERO"] = oMargins["iPointZero"];
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["collectData"] = 0; };

/**
 * @private
 * Reset the whole set of drag data
 */
UCF_Switch["prototype"]["purgeData"] = function() {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["purgeData"]++; }; 
	this["oData"]["MARGIN_TO_REFERE"] = null;
	this["oData"]["LAST_MARGIN"] = null;
	this["oData"]["LAST_MOUSE_POSITION"] = null;
	this["oData"]["ACCESS_TYPE"] = this["E_ACCESSTYPE"]["NONE"];
	this["oData"]["HANDLE"] = null;
	this["oData"]["MARGIN_PROPERTY_OFF"] = null;
	this["oData"]["MARGIN_ON"] = null;
	this["oData"]["RECT"] = null;
	this["oData"]["CONTAINER_TO_MOVE"] = null;
	this["oData"]["CURRENT_SELECTION"] = null;
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["purgeData"] = 0; };

/**
 * ############################################################################
 *
 * THIS SECTION IS RESPONSIBLE FOR SELECTION BY MOUSE AND KEYBOARD
 *
 * ############################################################################
 */
/**
 * @private
 * @param { oBrowserEvent } oBrowserEvent
 */
UCF_Switch["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onclick"]++; }; 

	if (this["oData"]["ACCESS_TYPE"] === this["E_ACCESSTYPE"]["NONE"]) {

		this["oData"]["ACCESS_TYPE"] = this["E_ACCESSTYPE"]["CLICK"];
		this["toggle"](oBrowserEvent);
		this["oData"]["ACCESS_TYPE"] = this["E_ACCESSTYPE"]["NONE"];

		// -- refocus to get Jaws to anounce new state
		if (this["oBase"]["bAccModeOn"]()) {
			this["sFocusType"] = this["eFocusType"]["REFOCUSED"];
			UCF_DomUtil["refocusDomElement"](this["oFocusDomRef"]);
		}

		// -- fire event
		// eslint-disable-next-line @ur/no-memory-leaks
		this["fireChange"](this["sId"], this["sSelection"]);

	} else if (this["oData"]["ACCESS_TYPE"] === this["E_ACCESSTYPE"]["DRAG"]) {
		this["oData"]["ACCESS_TYPE"] = this["E_ACCESSTYPE"]["NONE"];
	}
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onclick"] = 0; };

/**
 * @private
 * @param { oBrowserEvent } oBrowserEvent
 */
 UCF_Switch["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onmousedown"]++; }; 
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
 };;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onmousedown"] = 0; };

/**
 * @private
 * @param { oBrowserEvent } oBrowserEvent
 */
UCF_Switch["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onlsselect"]++; }; 

	// -- trigger selection
	this["oData"]["ACCESS_TYPE"] = this["E_ACCESSTYPE"]["KEYBOARD"];
	this["toggle"](oBrowserEvent);
	this["oData"]["ACCESS_TYPE"] = this["E_ACCESSTYPE"]["NONE"];

	// -- refocus to get Jaws to anounce new state
	if (this["oBase"]["bAccModeOn"]()) {
		this["sFocusType"] = this["eFocusType"]["REFOCUSED"];
		UCF_DomUtil["refocusDomElement"](this["oFocusDomRef"]);
	}
	// -- fire event
	// eslint-disable-next-line @ur/no-memory-leaks
	this["fireChange"](this["sId"], this["sSelection"]);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onlsselect"] = 0; };

/**
 * Turns the switch on and off
 * @param {BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Switch["prototype"]["toggle"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["toggle"]++; }; 
	/** @type {delegate} SelectorDelegate*/
	var oBase = this["oBase"];

	if (oBase["sGetInterActionState"](this) === oBase["eInterActionState"]["ENABLED"]) {
		this["collectData"](oBrowserEvent);
		// eslint-disable-next-line @ur/no-memory-leaks
		if (this["sSelection"] === oBase["eSelectionState"]["CHECKED"]) {
			// -- switch control styles
			this["switchOff"]();
			// -- switch control attributes
			this["updateSelectionAttributes"](oBase["eSelectionState"]["UNCHECKED"]);
		} else {
			// -- switch control styles
			this["switchOn"]();
			// -- switch control attributes
			this["updateSelectionAttributes"](oBase["eSelectionState"]["CHECKED"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["toggle"] = 0; };

/**
 * ############################################################################
 *
 * THIS SECTION HOLDS METHODS THAT ARE EQUALY USED BY ALL MEANS OF SELECTION
 *
 * ############################################################################
 */

/**
 * Turns the switch on
 * @private
 */
UCF_Switch["prototype"]["switchOn"] = function() {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["switchOn"]++; }; 
	/** @type {delegate} SelectorDelegate*/
	var oBase = this["oBase"];
	/** @type {method} responsible for the correct style change*/
	var Style_Factory = oBase["styleFactory"]["bind"](oBase);
	/** @type {method} */
	var switchSelectionState = oBase["toggleMethods"]["switchSelectionState"]["bind"](oBase);
	/** @type {Object} */
	var oData = this["oData"];

	// -- perform animation upon click
	if (oData["ACCESS_TYPE"] === this["E_ACCESSTYPE"]["CLICK"]
		|| oData["ACCESS_TYPE"] === this["E_ACCESSTYPE"]["KEYBOARD"]) {
		oData["CONTAINER_TO_MOVE"]["style"]["transition"] = "margin 0.1s";
		oData["CONTAINER_TO_MOVE"]["style"][oData["MARGIN_PROPERTY_OFF"]] = oData["POINT_ZERO"] + 'px';
	}

	// -- switch styles
	Style_Factory(switchSelectionState, this, oBase["eSelectionState"]["SELECTED"]);
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["switchOn"] = 0; };

/**
 * Turns the switch on
 * @private
 */
UCF_Switch["prototype"]["switchOff"] = function() {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["switchOff"]++; }; 
	/** @type {delegate} SelectorDelegate*/
	var oBase = this["oBase"];
	/** @type {method} responsible for the correct style change*/
	var Style_Factory = oBase["styleFactory"]["bind"](oBase);
	/** @type {method} */
	var switchSelectionState = oBase["toggleMethods"]["switchSelectionState"]["bind"](oBase);
	/** @type {Object} */
	var oData = this["oData"];

	// -- perform animation upon click
	if (oData["ACCESS_TYPE"] === this["E_ACCESSTYPE"]["CLICK"]
		|| oData["ACCESS_TYPE"] === this["E_ACCESSTYPE"]["KEYBOARD"]) {
		oData["CONTAINER_TO_MOVE"]["style"]["transition"] = "margin 0.1s";
		oData["CONTAINER_TO_MOVE"]["style"][oData["MARGIN_PROPERTY_OFF"]] = oData["MARGIN_TO_REFERE"] + 'px';
	}

	// -- switch styles
	Style_Factory(switchSelectionState, this, oBase["eSelectionState"]["UNSELECTED"]);
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["switchOff"] = 0; };

/**
 * @private
 * @param { enum-value } sSelectionState
 */
UCF_Switch["prototype"]["updateSelectionAttributes"] = function(sSelectionState) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["updateSelectionAttributes"]++; }; 
	/** @type {enum-value} */
	var sHandle = (sSelectionState === this["oBase"]["eSelectionState"]["CHECKED"]) ? this["eHandle"]["ON"] : this["eHandle"]["OFF"];
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sSelection"] = sSelectionState;
	this["oDomRef"]["setAttribute"]('switch', sHandle);
	// eslint-disable-next-line @ur/no-memory-leaks
	this["setClientProperty"]("Selection", this["sSelection"], true);
	this["oBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["updateSelectionAttributes"] = 0; };

/**
 * ############################################################################
 *
 * THIS SECTION IS RESPONSIBLE FOR SELECTION BY DRAGGING
 *
 * ############################################################################
 */
/**
 * @private
 * @param {BrowserEvent} oBrowserEvent
 * Prepare dragging of handle
 */
UCF_Switch["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onlsdragstart"]++; }; 
	/** @type {delegate} SelectorDelegate*/
	var oBase = this["oBase"];
	/** @type {string} */
	var sDragId;
	/** @type {Object} */
	var oData;

	if (oBase["sGetInterActionState"](this) !== oBase["eInterActionState"]["ENABLED"]) return;

	oData = this["oData"];
	/**
	 * @private
	 * @return {string} pixel values of margins as strings
	 */
	function sMarginValues() {
		var marginOn = ':0px';
		var marginOff = oData["MARGIN_TO_REFERE"] + 'px';
		return { 'ON': marginOn, 'OFF': marginOff };
	}

	if (oBrowserEvent["bIsTouchInteraction"]()) {
		this["oData"]["ACCESS_TYPE"] = this["E_ACCESSTYPE"]["TOUCH"];
		sDragId = this["sId"] + '-drag';
	} else {
		this["oData"]["ACCESS_TYPE"] = this["E_ACCESSTYPE"]["DRAG"];
		sDragId = this["sId"] + '-handle';
	}

	// -- get all data needed for drag session
	this["collectData"](oBrowserEvent);
	// eslint-disable-next-line @ur/no-memory-leaks
	if (this["sSelection"] === oBase["eSelectionState"]["CHECKED"]) {
		oData["CONTAINER_TO_MOVE"]["setAttribute"]('style', oData["MARGIN_PROPERTY_ON"] + sMarginValues()["ON"]);
	} else {
		this["oData"]["CONTAINER_TO_MOVE"]["setAttribute"]('style', oData["MARGIN_PROPERTY_OFF"] + sMarginValues()["OFF"]);
	}

	this["oDomRef"]["removeAttribute"]('switch');

	oBrowserEvent["oDragAndDropManager"]["startDragSession"](sDragId, "", UCF_DragSession["DRAG_TYPE"]["NONE"], null, null, null);
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onlsdragstart"] = 0; };

/**
 * @private
 * @param {BrowserEvent} oBrowserEvent
 * @returns { int } the new margin
 * Increase or decrease margin
 */
UCF_Switch["prototype"]["onlsdrag"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onlsdrag"]++; }; 
	/** @type {UCF_Switch} */
	var self = this;
	/** @type {int} margin left of the handle */
	var iNewMargin;
	/** @type {int} */
	var iMousePosNow = oBrowserEvent["_iClientX"];
	/** @type {Object} stores all data relevant for dragging handle */
	var oData = this["oData"];
	/** @type {int} delta handle is to be moved during drag process */
	var iDifference;

	// eslint-disable-next-line jsdoc/require-returns
	/**
	 * @private
	 * @returns { enum-value } the current drag direction
	 */
	var determinDirection = function() {
		if (iMousePosNow < oData["LAST_MOUSE_POSITION"]) {
			return self["E_DRAG_DIRECTION"]["LEFT"];

		} else if (iMousePosNow > oData["LAST_MOUSE_POSITION"]) {
			return self["E_DRAG_DIRECTION"]["RIGHT"];

		} else {
			return self["E_DRAG_DIRECTION"]["NONE"];
		}
	};

	// eslint-disable-next-line jsdoc/require-returns
	/**
	 * @private
	 * @returns { boolean }
	 */
	var bMouseWithinSwitchBounderies = function() {
		return (iMousePosNow >= oData["RECT"]["left"] - 1
			&& iMousePosNow <= (oData["RECT"]["left"] + oData["RECT"]["width"] + 1));
	};

	// eslint-disable-next-line jsdoc/require-returns
	/**
	 * @private
	 * @returns { int } the new margin / offset of Handle to the left
	 */
	var iCalcMargin = function() {
		/** @type {int} */
		var iCalcMargin;

		switch (determinDirection()) {
			case self["E_DRAG_DIRECTION"]["LEFT"]:
				iDifference = oData["LAST_MOUSE_POSITION"] - iMousePosNow;

			if (window["UCF_System"]["bIsRTL"]) {
				iCalcMargin = oData["LAST_MARGIN"] + iDifference;
			} else {
			iCalcMargin = oData["LAST_MARGIN"] - iDifference;
			}
				break;

			case self["E_DRAG_DIRECTION"]["RIGHT"]:
				iDifference = iMousePosNow - oData["LAST_MOUSE_POSITION"];

			if (window["UCF_System"]["bIsRTL"]) {
				iCalcMargin = oData["LAST_MARGIN"] - iDifference;
			} else {
			iCalcMargin = oData["LAST_MARGIN"] + iDifference;
			}
				break;

			case self["E_DRAG_DIRECTION"]["NONE"]:
				iCalcMargin = oData["LAST_MARGIN"];
		}

		// _trace(WARNING, 'DRAG - iCalcMargin: ' + iCalcMargin);
		// _trace(WARNING, 'DRAG - iMousePosNow: ' + iMousePosNow);
		// _trace(WARNING, 'DRAG - oData.LAST_MOUSE_POSITION: ' + oData.LAST_MOUSE_POSITION);
		// _trace(ERROR, '##############################################################');

		// -- reset values if they ecxeed a certain threshold
		if (iCalcMargin < oData["MARGIN_TO_REFERE"]) {
			self["switchOff"]();
			self["updateSelectionAttributes"](self["oBase"]["eSelectionState"]["UNCHECKED"]);
			iCalcMargin = oData["MARGIN_TO_REFERE"];
		} else if (iCalcMargin > oData["POINT_ZERO"]) {
			self["switchOn"]();
			self["updateSelectionAttributes"](self["oBase"]["eSelectionState"]["CHECKED"]);
			iCalcMargin = oData["POINT_ZERO"];
		}
		return iCalcMargin;
	};

	// eslint-disable-next-line jsdoc/require-returns
	/**
	 * @private
	 * @returns { boolean } determines dragging of handle is to be continued
	 * bounderies
	 * Increase or decrease margin
	 */
	var bKeepDragging = function() {
		if (bMouseWithinSwitchBounderies()) {
			oData["DIRECTION"] = determinDirection();
			return true;
		} else {
			return determinDirection() === oData["DIRECTION"];
		}
	};

	// -- The dragging process that changes the margin-offset of the handle
	iNewMargin = iCalcMargin();
	if (bKeepDragging() && isNaN(iNewMargin) === false) {
		this["oData"]["CONTAINER_TO_MOVE"]["style"][this["oData"]["MARGIN_PROPERTY_OFF"]] = iNewMargin + 'px';
		this["oData"]["LAST_MARGIN"] = iNewMargin;
	}
	this["oData"]["LAST_MOUSE_POSITION"] = iMousePosNow;
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onlsdrag"] = 0; };

/**
 * @private
 * @param {BrowserEvent} oBrowserEvent
 */
UCF_Switch["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onlsdragend"]++; }; 
	/** @type {int} */
	var iHandlePos;
	/** @type {int} */
	var iThreshold;
	/** @type {enum-list} */
	var eHandle = this["eHandle"];
	/** @type {_ObjectRect} */
	var oSwitchRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]["firstChild"]);
	/** @type {_ObjectRect} */
	var oHandleRect = UCF_DomUtil["oGetObjectRect"](this["oData"]["HANDLE"]);
	/** @type {enum-value} */
	var sNewSelectionState;
	/** @type {function} determines position of handle it is to be moved after dragging*/
	var sHandlePosition = function() {

		iThreshold = Math["ceil"](oSwitchRect["width"] / 2) - (oHandleRect["width"] / 2);
		iHandlePos = oHandleRect["left"] - oSwitchRect["left"];

		// _trace(WARNING, 'DRAG END - iThreshold: ' + iThreshold);
		// _trace(WARNING, 'DRAG END - iHandlePos: ' + iHandlePos);

		if (iHandlePos > iThreshold) {
			return !window["UCF_System"]["bIsRTL"] ? eHandle["ON"] : eHandle["OFF"];
		} else {
			return !window["UCF_System"]["bIsRTL"] ? eHandle["OFF"] : eHandle["ON"];
		}
	};

	switch (sHandlePosition()) {
		case this["eHandle"]["ON"]:
			sNewSelectionState = this["oBase"]["eSelectionState"]["CHECKED"];
			this["switchOn"]();
			break;

		case this["eHandle"]["OFF"]:
			sNewSelectionState = this["oBase"]["eSelectionState"]["UNCHECKED"];
			this["switchOff"]();
	}

	// _trace(WARNING, 'DRAG END - sHandlePosition(): ' + sHandlePosition());
	// _trace(WARNING, 'DRAG END - sNewSelectionState: ' + sNewSelectionState);
	// _trace(WARNING, 'DRAG END - this.sSelection: ' + this.sSelection);

	this["oData"]["CONTAINER_TO_MOVE"]["removeAttribute"]('style');
	this["updateSelectionAttributes"](sNewSelectionState);

	if (this["oData"]["CURRENT_SELECTION"] !== sNewSelectionState) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["fireChange"](this["sId"], this["sSelection"]);
	}
	this["purgeData"]();
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onlsdragend"] = 0; };

/**
 * @private
 * A list with all styles of the switch control
 * Is used in the Style Factory of SelectorDelegate
 */
UCF_Switch["prototype"]["eStyles"] = {
	'SELECTED_ENABLED': 'lsSwitch--on',
	'UNSELECTED_ENABLED': 'lsSwitch--off',
	'SELECTED_READONLY': 'lsSwitch--on--readOnly',
	'UNSELECTED_READONLY': 'lsSwitch--off--readOnly',
	'SELECTED_ERROR_ENABLED': 'lsSwitch--on--error',
	'UNSELECTED_ERROR_ENABLED': 'lsSwitch--off--error',
	'SELECTED_WARNING_ENABLED': 'lsSwitch--on--warning',
	'UNSELECTED_WARNING_ENABLED': 'lsSwitch--off--warning',
	'SELECTED_PARENT_READONLY': 'lsSwitch--on--parentReadOnly',
	'UNSELECTED_PARENT_READONLY': 'lsSwitch--off--parentReadOnly',
	'SELECTED_ERROR_READONLY': 'lsSwitch--on--error--readOnly',
	'UNSELECTED_ERROR_READONLY': 'lsSwitch--off--error--readOnly',
	'SELECTED_WARNING_READONLY': 'lsSwitch--on--warning--readOnly',
	'UNSELECTED_WARNING_READONLY': 'lsSwitch--off--warning--readOnly',
	'SELECTED_DISABLED': 'lsSwitch--on--disabled',
	'UNSELECTED_DISABLED': 'lsSwitch--off--disabled',

	'SELECTED_ENABLED_ACCEPTREJECT': 'lsSwitch--on--acceptReject',
	'UNSELECTED_ENABLED_ACCEPTREJECT': 'lsSwitch--off--acceptReject',
	'SELECTED_ERROR_ENABLED_ACCEPTREJECT': 'lsSwitch--on--error--acceptReject',
	'UNSELECTED_ERROR_ENABLED_ACCEPTREJECT': 'lsSwitch--off--error--acceptReject',
	'SELECTED_WARNING_ENABLED_ACCEPTREJECT': 'lsSwitch--on--warning--acceptReject',
	'UNSELECTED_WARNING_ENABLED_ACCEPTREJECT': 'lsSwitch--off--warning--acceptReject'
};

/**
 * ############################################################################
 *
 * SECTION WITH PUBLIC APIS FOR SELECTION
 *
 * ###########################################################################
 */

/**
 * Turns the switch on and off
 * @param { Enumerator } sSelectionState
 * @public
 */
UCF_Switch["prototype"]["setSelectionState"] = function(sSelectionState) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["setSelectionState"]++; }; 
	this["collectData"]();

	switch (sSelectionState) {
		case this["oBase"]["eSelectionState"]["CHECKED"]:
			// -- switch control styles
			this["switchOn"]();
			// -- switch control attributes
			this["updateSelectionAttributes"](this["oBase"]["eSelectionState"]["CHECKED"]);
			this["fireChange"](this["sId"], sSelectionState);
			break;

		case this["oBase"]["eSelectionState"]["UNCHECKED"]:
			// -- switch control styles
			this["switchOff"]();
			// -- switch control attributes
			this["updateSelectionAttributes"](this["oBase"]["eSelectionState"]["UNCHECKED"]);
			this["fireChange"](this["sId"], sSelectionState);
	}
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["setSelectionState"] = 0; };

/**
 * Turns the switch on and off
 * @return { enum-value } selection state of switch
 * @public
 */
UCF_Switch["prototype"]["getSelectionState"] = function() {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["getSelectionState"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	return this["sSelection"];
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["getSelectionState"] = 0; };

/**
 * ############################################################################
 *
 * SECTION RESPONSIBLE FOR ACC BE IT 508 OR ARIA
 *
 * ###########################################################################
 */

/**
 * Enumeration that indicates the sematic of the focus
 * @private
 */
UCF_Switch["prototype"]["eFocusType"] = {
	"NAVIGATION": 'NAVIGATION',
	"REFOCUSED": 'REFOCUSED'
};

/**
 * Handles the onlsfocus event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Switch["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Switch.js(671): onlsfocus"); };

	if (window["UCF_System"]["bIsAria"]) {
		// eslint-disable-next-line @ur/no-memory-leaks
		if (this["sSelection"] === this["oBase"]["CHECKED"]) {
			this["oBase"]["addTooltip"](this["sCustomTextOn"]);
		} else {
			this["oBase"]["addTooltip"](this["sCustomTextOff"]);
		}
	} else if (window["UCF_System"]["bIs508"]) {
		// eslint-disable-next-line @ur/no-memory-leaks
		if (this["sSelection"] === this["oBase"]["CHECKED"]) {
			this["Delegate_508"]["addTooltip"](this["sCustomTextOn"]);
		} else {
			this["Delegate_508"]["addTooltip"](this["sCustomTextOff"]);
		}
	}

	// --
	if (this["sFocusType"] === this["eFocusType"]["REFOCUSED"]) {
		this["sFocusType"] = this["eFocusType"]["NAVIGATION"];
		return;
	}

	this["oBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["onlsfocus"] = 0; };

/**
 * ###########################################################################
 *
 * SECTION RESPONSIBLE FOR DESTRUCTION OF THE CONTROL
 *
 * ###########################################################################
 */
/**
 * Destructor
 * @private
 */
UCF_Switch["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["destroy"]++; }; 
	this["purgeData"]();
	this["oBase"]["destroy"]();
	this["oBase"] = null;
	this["sFocusType"] = null;

	if (this["Delegate_508"]) {
		this["Delegate_508"]["destroy"]();
		this["Delegate_508"] = null;
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["destroy"] = 0; };

// _trace(WARNING, ' oBrowserEvent.oGetSource(): ' + oBrowserEvent.oGetSource().outerHTML);
// _trace(WARNING, ' this.oData.ACCESS_TYPE: ' + this.oData.ACCESS_TYPE);
// _trace(WARNING, ' oInteractionArea: ' + oInteractionArea.outerHTML);
// _trace(WARNING, ' this.oData.MARGIN_TO_REFERE: ' + this.oData.MARGIN_TO_REFERE);
// _trace(WARNING, ' this.sSelection: ' + this.sSelection);
// _trace(WARNING, ' oData.MARGIN_PROPERTY_ON: ' + oData.MARGIN_PROPERTY_ON);
// _trace(WARNING, ' oData.MARGIN_PROPERTY_OFF: ' + oData.MARGIN_PROPERTY_OFF);
// _trace(WARNING, ' sMarginValues().ON: ' + sMarginValues().ON);
// _trace(WARNING, ' sMarginValues().OFF: ' + sMarginValues().OFF);
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Switch["prototype"]["aAttributeNames"] = ["sSelection","sInterAction","sType","sTooltip","sVisibility","sCustomData","sCustomStyle","sLabelledBy","sInputState","bShowHelp","sAccessKey"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Switch["prototype"]["aEventNames"] = ["Change"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Switch["prototype"]["aMethodNames"] = ["setSelectionState","getSelectionState","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SelectionState}
 */
UCF_Switch["prototype"]["sSelection"] = "UNCHECKED";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InterActionState}
 */
UCF_Switch["prototype"]["sInterAction"] = "ENABLED";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SwitchType}
 */
UCF_Switch["prototype"]["sType"] = "DEFAULT";

/**
 * @private
 * @type {string}
 */
UCF_Switch["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Switch["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_Switch["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Switch["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Switch["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputState}
 */
UCF_Switch["prototype"]["sInputState"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_Switch["prototype"]["bShowHelp"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Switch["prototype"]["sAccessKey"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Switch["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["setDefaultValues"]++; }; 
	this["sSelection"] = "UNCHECKED";
	this["sInterAction"] = "ENABLED";
	this["sType"] = "DEFAULT";
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sLabelledBy"] = '';
	this["sInputState"] = "NONE";
	this["bShowHelp"] = false;
	this["sAccessKey"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Selection", "UNCHECKED", true);
		this["setClientProperty"]("InterAction", "ENABLED", true);
		this["setClientProperty"]("Type", "DEFAULT", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("InputState", "NONE", true);
		this["setClientProperty"]("ShowHelp", false, true);
		this["setClientProperty"]("AccessKey", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sSelectionState The values CHECKED or UNCHECKED that indicate the selection state of the switch
 * @fires Switch::Change
 */
UCF_Switch["prototype"]["fireChange"] = function(sId, sSelectionState) {;if (__UCF_COVERAGE__) { UCF_Switch["_"]["fireChange"]++; }; 
	/** @type {{Id: string, SelectionState: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Switch.js(860): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Switch.js(861): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Switch.js(862): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSelectionState != null, "sSelectionState != null", "Switch.js(863): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSelectionState) == "string", "typeof(sSelectionState) == \"string\"", "Switch.js(864): fireChange"); };
	mParams = {
		"Id": sId,
		"SelectionState": sSelectionState
	};
	
	
	this["fireSemanticEvent"]("Switch", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Switch["_"]["fireChange"] = 0; };

UCF_Switch.prototype["aPublicMethods"] = ["setSelectionState","getSelectionState"].concat(UCF_Switch.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TabStrip"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * TabStrip
 *
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TabStrip(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["UCF_TabStrip"]++; }; 
	if (arguments["length"] !== 2) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "TabStrip.js(20): UCF_TabStrip"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TabStrip.js(21): UCF_TabStrip"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TabStrip.js(22): UCF_TabStrip"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["sAccKeyHandling"] = 'INITIAL';
};window["UCF_TabStrip"] = UCF_TabStrip; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TabStrip"); UCF_TabStrip["_"] = {UCF_TabStrip: 0}; }; ;
UCF_TabStrip["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TabStrip.prototype["sClassName"] = "UCF_TabStrip";

UCF_TabStrip["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TabStrip["prototype"]["aAttributeNames"] = ["iCurrentIndex","sHeight","sWidth","sAccessibilityDescription","sVisibility","iFirstVisibleItemIdx","bScrollable","bExactTabAlignment","bClientTabSelect","sDragSourceInfo","sDropTargetInfo","sTabItemsPosition","sCustomData","sCustomStyle","sTabItemsDesign","iHeadingLevel"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TabStrip["prototype"]["aEventNames"] = ["TabSelect","TabClose","Scroll","TabScroll","Hotkey","Drag","Drop","Change"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TabStrip["prototype"]["aMethodNames"] = ["selectTabStripItem","setScrollPosition","getScrollPosition","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {number}
 */
UCF_TabStrip["prototype"]["iCurrentIndex"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_TabStrip["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TabStrip["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TabStrip["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_TabStrip["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {number}
 */
UCF_TabStrip["prototype"]["iFirstVisibleItemIdx"] = -1;

/**
 * @private
 * @type {boolean}
 */
UCF_TabStrip["prototype"]["bScrollable"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_TabStrip["prototype"]["bExactTabAlignment"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_TabStrip["prototype"]["bClientTabSelect"] = true;

/**
 * @private
 * @type {string}
 */
UCF_TabStrip["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TabStrip["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TabItemsPosition}
 */
UCF_TabStrip["prototype"]["sTabItemsPosition"] = "TOP";

/**
 * @private
 * @type {string}
 */
UCF_TabStrip["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TabStrip["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TabItemsDesign}
 */
UCF_TabStrip["prototype"]["sTabItemsDesign"] = "TAB";

/**
 * @private
 * @type {number}
 */
UCF_TabStrip["prototype"]["iHeadingLevel"] = 0;

//#JSCOVER_EXCL_START
/** @protected */
UCF_TabStrip["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["setDefaultValues"]++; }; 
	this["iCurrentIndex"] = 0;
	this["sHeight"] = '';
	this["sWidth"] = '';
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["iFirstVisibleItemIdx"] = -1;
	this["bScrollable"] = false;
	this["bExactTabAlignment"] = true;
	this["bClientTabSelect"] = true;
	this["sDragSourceInfo"] = '';
	this["sDropTargetInfo"] = '';
	this["sTabItemsPosition"] = "TOP";
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sTabItemsDesign"] = "TAB";
	this["iHeadingLevel"] = 0;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CurrentIndex", 0, true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("FirstVisibleItemIdx", -1, true);
		this["setClientProperty"]("Scrollable", false, true);
		this["setClientProperty"]("ExactTabAlignment", true, true);
		this["setClientProperty"]("ClientTabSelect", true, true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("TabItemsPosition", "TOP", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("TabItemsDesign", "TAB", true);
		this["setClientProperty"]("HeadingLevel", 0, true);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the changed tabstrip control
 * @param {string} sItemId Id of the tabstrip item to select
 * @param {number} iItemIndex Index of the tabstrip item to select
 * @param {number} iFirstVisibleItemIndex Index of the first visible tab in the viewport
 * @fires TabStrip::TabSelect
 */
UCF_TabStrip["prototype"]["fireTabSelect"] = function(sId, sItemId, iItemIndex, iFirstVisibleItemIndex) {;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireTabSelect"]++; }; 
	/** @type {{Id: string, ItemId: string, ItemIndex: number, FirstVisibleItemIndex: number}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "TabStrip.js(206): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TabStrip.js(207): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TabStrip.js(208): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "TabStrip.js(209): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "TabStrip.js(210): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iItemIndex != null, "iItemIndex != null", "TabStrip.js(211): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iItemIndex) == "number", "typeof(iItemIndex) == \"number\"", "TabStrip.js(212): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFirstVisibleItemIndex != null, "iFirstVisibleItemIndex != null", "TabStrip.js(213): fireTabSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iFirstVisibleItemIndex) == "number", "typeof(iFirstVisibleItemIndex) == \"number\"", "TabStrip.js(214): fireTabSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"ItemIndex": iItemIndex,
		"FirstVisibleItemIndex": iFirstVisibleItemIndex
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	
	this["fireSemanticEvent"]("TabStrip", "TabSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireTabSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sItemId Id of the tabstrip item to close
 * @fires TabStrip::TabClose
 */
UCF_TabStrip["prototype"]["fireTabClose"] = function(sId, sItemId) {;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireTabClose"]++; }; 
	/** @type {{Id: string, ItemId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "TabStrip.js(245): fireTabClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TabStrip.js(246): fireTabClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TabStrip.js(247): fireTabClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "TabStrip.js(248): fireTabClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "TabStrip.js(249): fireTabClose"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	this["fireSemanticEvent"]("TabStrip", "TabClose", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireTabClose"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sFirstVisibleItemId Id of the first visible tabstrip item after the user scrolled
 * @param {string} sScrollDirection Determines the direction in which the user has scrolled. Possible values are 'FORWARD' | 'BACKWARD'
 * @fires TabStrip::Scroll
 */
UCF_TabStrip["prototype"]["fireScroll"] = function(sId, sFirstVisibleItemId, sScrollDirection) {;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, FirstVisibleItemId: string, ScrollDirection: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "TabStrip.js(277): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TabStrip.js(278): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TabStrip.js(279): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFirstVisibleItemId != null, "sFirstVisibleItemId != null", "TabStrip.js(280): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFirstVisibleItemId) == "string", "typeof(sFirstVisibleItemId) == \"string\"", "TabStrip.js(281): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sScrollDirection != null, "sScrollDirection != null", "TabStrip.js(282): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sScrollDirection) == "string", "typeof(sScrollDirection) == \"string\"", "TabStrip.js(283): fireScroll"); };
	mParams = {
		"Id": sId,
		"FirstVisibleItemId": sFirstVisibleItemId,
		"ScrollDirection": sScrollDirection
	};
	
	if (sFirstVisibleItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sFirstVisibleItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "FirstVisibleItemId");
			}
		}
	
	this["fireSemanticEvent"]("TabStrip", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sItemId ItemId of the scrolled tabstrip item
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires TabStrip::TabScroll
 */
UCF_TabStrip["prototype"]["fireTabScroll"] = function(sId, sItemId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireTabScroll"]++; }; 
	/** @type {{Id: string, ItemId: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "TabStrip.js(314): fireTabScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TabStrip.js(315): fireTabScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TabStrip.js(316): fireTabScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "TabStrip.js(317): fireTabScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "TabStrip.js(318): fireTabScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "TabStrip.js(319): fireTabScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "TabStrip.js(320): fireTabScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "TabStrip.js(321): fireTabScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "TabStrip.js(322): fireTabScroll"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	
	this["fireSemanticEvent"]("TabStrip", "TabScroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireTabScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sItemId ItemId of the tabstrip item which is currently selected and hotkey is fired
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires TabStrip::Hotkey
 */
UCF_TabStrip["prototype"]["fireHotkey"] = function(sId, sItemId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, ItemId: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "TabStrip.js(355): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TabStrip.js(356): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TabStrip.js(357): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "TabStrip.js(358): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "TabStrip.js(359): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "TabStrip.js(360): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "TabStrip.js(361): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "TabStrip.js(362): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "TabStrip.js(363): fireHotkey"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	
	this["fireSemanticEvent"]("TabStrip", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireHotkey"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires TabStrip::Drag
 */
UCF_TabStrip["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "TabStrip.js(393): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TabStrip.js(394): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TabStrip.js(395): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "TabStrip.js(396): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "TabStrip.js(397): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "TabStrip.js(398): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "TabStrip.js(399): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("TabStrip", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sIndex The Index of the TabstripItem where the drop occured
 * @param {number} iOffset The Offset relative to the TabStripItem where the drop occured (signum)
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires TabStrip::Drop
 */
UCF_TabStrip["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, sIndex, iOffset, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, Index: string, Offset: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 12, "arguments.length == 12", "TabStrip.js(433): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TabStrip.js(434): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TabStrip.js(435): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "TabStrip.js(436): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "TabStrip.js(437): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "TabStrip.js(438): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "TabStrip.js(439): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sIndex != null, "sIndex != null", "TabStrip.js(440): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sIndex) == "string", "typeof(sIndex) == \"string\"", "TabStrip.js(441): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOffset != null, "iOffset != null", "TabStrip.js(442): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOffset) == "number", "typeof(iOffset) == \"number\"", "TabStrip.js(443): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "TabStrip.js(444): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "TabStrip.js(445): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "TabStrip.js(446): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "TabStrip.js(447): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "TabStrip.js(448): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "TabStrip.js(449): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "TabStrip.js(450): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "TabStrip.js(451): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "TabStrip.js(452): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "TabStrip.js(453): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "TabStrip.js(454): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "TabStrip.js(455): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "TabStrip.js(456): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "TabStrip.js(457): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"Index": sIndex,
		"Offset": iOffset,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	if (sDropTargetInfo) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sDropTargetInfo);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "DropTargetInfo");
			}
		}
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("TabStrip", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId The id of the TabStrip
 * @param {string} sItemId The id of the TabStripItem.
 * @param {string} sValue The new tile.
 * @fires TabStrip::Change
 */
UCF_TabStrip["prototype"]["fireChange"] = function(sId, sItemId, sValue) {;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireChange"]++; }; 
	/** @type {{Id: string, ItemId: string, Value: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "TabStrip.js(505): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TabStrip.js(506): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TabStrip.js(507): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "TabStrip.js(508): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "TabStrip.js(509): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "TabStrip.js(510): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "TabStrip.js(511): fireChange"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId,
		"Value": sValue
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	
	this["fireSemanticEvent"]("TabStrip", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_TabStrip["_"]["fireChange"] = 0; };

};
sap["ls"]["preload"]["UCF_TabStripDragDelegate"] = function() {/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_DragSession */
/// <reference path="../base/DragSession.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_TabStripDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_TabStripDragDelegate["_"]["UCF_TabStripDragDelegate"]++; }; 

	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);

};window["UCF_TabStripDragDelegate"] = UCF_TabStripDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TabStripDragDelegate"); UCF_TabStripDragDelegate["_"] = {UCF_TabStripDragDelegate: 0}; }; ;
UCF_TabStripDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_TabStripDragDelegate.prototype["sClassName"] = "UCF_TabStripDragDelegate";

UCF_TabStripDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripDragDelegate["_"]["oGetGhost"]++; }; 

	var oTabStripItem = oBrowserEvent["oGetSourceControl"]();
	var oGhostFragment = oTabStripItem["oDomRef"]["cloneNode"](true);
	oGhostFragment["style"]["width"] = oTabStripItem["oDomRef"]["offsetWidth"] + "px";
	oGhostFragment["style"]["fontSize"] = "0.7em";
	var oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oGhostFragment);
	oGhost["setOffset"](12, 12);

	return oGhost;
};;if (__UCF_COVERAGE__) { UCF_TabStripDragDelegate["_"]["oGetGhost"] = 0; };

UCF_TabStripDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripDragDelegate["_"]["bIsDragPossible"]++; }; 

	if (oBrowserEvent["oGetSource"]() === this["oDragSourceControl"]["oDomRef"])
		return false;
	return true;
};;if (__UCF_COVERAGE__) { UCF_TabStripDragDelegate["_"]["bIsDragPossible"] = 0; };

UCF_TabStripDragDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripDragDelegate["_"]["onlsdragstart"]++; }; 
	//_trace(INFO,"dragstart");

	var oDragSourceControl = this["oGetDragSourceControl"](oBrowserEvent);

	var sDragSourceInfoId = oDragSourceControl["sDragSourceInfo"];
	if (!sDragSourceInfoId)
		return;

	var oDragSourceInfoControl = oDragSourceControl["oGetControlById"](sDragSourceInfoId);
	if (!oDragSourceInfoControl)
		return;

	var sTags = oDragSourceInfoControl["sGetTags"]();
	if (!sTags)
		return;

	if (!this["bIsDragPossible"](oBrowserEvent))
		return;

	var oTabStripItem = this["oGetTabStripSourceControl"](oBrowserEvent);

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
		oDragSession = oDragAndDropManager["startDragSession"](oTabStripItem["sId"], sTags, UCF_DragSession["DRAG_TYPE"]["STANDARD"], null, this["oGetGhost"](oBrowserEvent), oDragSourceInfoControl["sHint"]);

	//set dragSource
	oDragSession["oSetDragSource"](oTabStripItem["oDomRef"]);

	//if Drag-Event is registered
	if (oDragSourceControl["mEvents"]["Drag"]) {
		oDragSourceControl["fireDrag"](oTabStripItem["sId"], sDragSourceInfoId, oDragSession["sId"]);
	}

	//use data from drag source info control
	oDragSession["setDragData"](oDragSourceInfoControl["sGetData"](), oDragSourceInfoControl["sGetMimeType"]());

	oBrowserEvent["bHandled"] = true;
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_TabStripDragDelegate["_"]["onlsdragstart"] = 0; };

UCF_TabStripDragDelegate["prototype"]["oGetTabStripSourceControl"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripDragDelegate["_"]["oGetTabStripSourceControl"]++; }; 

	var oItem = oBrowserEvent["oGetSourceControl"]();

	if (oItem != null && UCF_JsUtil["bInstanceOf"](oItem, "UCF_TabStripItem"))
		return oItem;

	return this["oDragSourceControl"];

};;if (__UCF_COVERAGE__) { UCF_TabStripDragDelegate["_"]["oGetTabStripSourceControl"] = 0; };

};
sap["ls"]["preload"]["UCF_TabStripDropDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_ItemListBox} oItemListBox
 * @param {UCF_LS} oLS
 */
function UCF_TabStripDropDecorator(oItemListBox, oLS) {if (__UCF_COVERAGE__) { UCF_TabStripDropDecorator["_"]["UCF_TabStripDropDecorator"]++; }; 

	UCF_LineDecorator["apply"](this, [oItemListBox, false]);
	this["oLS"] = oLS;
};window["UCF_TabStripDropDecorator"] = UCF_TabStripDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TabStripDropDecorator"); UCF_TabStripDropDecorator["_"] = {UCF_TabStripDropDecorator: 0}; }; ;

/**
 *
 */
UCF_TabStripDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(); UCF_TabStripDropDecorator.prototype["sClassName"] = "UCF_TabStripDropDecorator";

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_TabStripDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripDropDecorator["_"]["update"]++; }; 

	this["sTargetTabId"] = -1;

	var oPanelDomRef = UCF_DomUtil["$"](this["oControl"]["sId"] + "-panel"),
		oViewPort = UCF_DomUtil["oGetObjectRect"](oPanelDomRef),
		iMouseX = oBrowserEvent["iClientX"](),
		iMouseY = oBrowserEvent["iClientY"]();

	if (iMouseX < oViewPort["left"] ||
		iMouseX > oViewPort["left"] + oViewPort["width"] ||
		iMouseY < oViewPort["top"] ||
		iMouseY > oViewPort["top"] + oViewPort["height"]) {
		this["hide"]();
		return;
	}

	var aTabStripDomRefs = oPanelDomRef["childNodes"];

	var x = 0,
		iPosition, iLeft, iHeight;

	while (this["sTargetTabId"] === -1 && x < aTabStripDomRefs["length"]) {
		if (!UCF_DomUtil["bContains"](aTabStripDomRefs[x], oBrowserEvent["oGetSource"]())) {
			x++;
			continue;
		}

		var oTabRect = UCF_DomUtil["oGetObjectRect"](aTabStripDomRefs[x]);

		iHeight = oTabRect["height"];

		this["sTargetTabId"] = aTabStripDomRefs[x]["getAttribute"]("id");

		var iThreshold = oTabRect["left"] + (window["UCF_System"]["bIsRTL"] ? 8 : 0) + oTabRect["width"] / 2;

		if (iMouseX < iThreshold) {
			iPosition = -1;

			iLeft = oTabRect["left"];

			if (!window["UCF_System"]["bIsRTL"])
				iLeft -= parseInt(UCF_DomUtil["sGetCurrentStyle"](aTabStripDomRefs[x], "marginLeft"));

		} else {
			iPosition = 1;
			iLeft = oTabRect["left"] + oTabRect["width"];
			if (window["UCF_System"]["bIsRTL"])
				iLeft += parseInt(UCF_DomUtil["sGetCurrentStyle"](aTabStripDomRefs[x], "marginRight"));
		}

		//window.status = x + " [" + iPosition + "]";

		break;

	}

	if (this["sTargetTabId"] === -1) {
		this["hide"]();
		return;
	}

	this["iPosition"] = iPosition;
	this["show"]();

	this["setBounds"](iLeft, oViewPort["top"], iHeight);

};;if (__UCF_COVERAGE__) { UCF_TabStripDropDecorator["_"]["update"] = 0; };

/**
 *
 */
UCF_TabStripDropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripDropDecorator["_"]["oGetDropLocation"]++; }; 

	if (this["sTargetTabId"] === -1)
		return null;

	var oTabStripItem = this["oControl"]["oGetControlById"](this["sTargetTabId"]);

	return { "iIndex": oTabStripItem["iIndex"], "iOffset": this["iPosition"] };

};;if (__UCF_COVERAGE__) { UCF_TabStripDropDecorator["_"]["oGetDropLocation"] = 0; };

/**
 * destructor
 */
UCF_TabStripDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripDropDecorator["_"]["destroy"]++; }; 

	this["iPosition"] = null;
	this["sTargetTabId"] = null;
	this["oLS"] = null;
	UCF_LineDecorator.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TabStripDropDecorator["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_TabStripDropDelegate"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_TabStripDropDecorator */
/// <reference path="../decorators/TabStripDropDecorator.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_TabStripDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_TabStripDropDelegate["_"]["UCF_TabStripDropDelegate"]++; }; 

	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);
	this["oLS"] = oLS;

};window["UCF_TabStripDropDelegate"] = UCF_TabStripDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TabStripDropDelegate"); UCF_TabStripDropDelegate["_"] = {UCF_TabStripDropDelegate: 0}; }; ;
UCF_TabStripDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_TabStripDropDelegate.prototype["sClassName"] = "UCF_TabStripDropDelegate";

/**
 * @override
 */
UCF_TabStripDropDelegate["prototype"]["oCreateDropDecorator"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripDropDelegate["_"]["oCreateDropDecorator"]++; }; 

	return new (UCF_ClassLoader["oGetClass"]("UCF_TabStripDropDecorator"))(this["oDropTargetControl"], this["oLS"]);

};;if (__UCF_COVERAGE__) { UCF_TabStripDropDelegate["_"]["oCreateDropDecorator"] = 0; };

/**
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @return
 */
UCF_TabStripDropDelegate["prototype"]["oGetDropLocation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripDropDelegate["_"]["oGetDropLocation"]++; }; 

	if (!this["oDropDecorator"])
		return null;

	return this["oDropDecorator"]["oGetDropLocation"]();

};;if (__UCF_COVERAGE__) { UCF_TabStripDropDelegate["_"]["oGetDropLocation"] = 0; };

/**
 *
 */
UCF_TabStripDropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_TabStripDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		oLocation = this["oGetDropLocation"](),
		iIndex = oLocation["iIndex"] + "",
		iOffset = oLocation["iOffset"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function(sDragData, sMimeType) {

		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			iIndex,
			iOffset,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);
	};

};;if (__UCF_COVERAGE__) { UCF_TabStripDropDelegate["_"]["fGetDropCallBack"] = 0; };

UCF_TabStripDropDelegate["prototype"]["onlsdraghover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripDropDelegate["_"]["onlsdraghover"]++; }; 

	var oPanelDomRef = UCF_DomUtil["$"](this["oDropTargetControl"]["sId"] + "-panel"),
		oViewPort = UCF_DomUtil["oGetObjectRect"](oPanelDomRef),
		iMouseX = oBrowserEvent["iClientX"](),
		iMouseY = oBrowserEvent["iClientY"]();

	if (iMouseY < oViewPort["top"] || iMouseY > oViewPort["top"] + oViewPort["height"])
		return;

	if (iMouseX < oViewPort["left"] + 20)
		this["oDropTargetControl"]["previousPage"]();

	if (iMouseX > oViewPort["left"] + oViewPort["width"] - 20)
		this["oDropTargetControl"]["nextPage"]();

	this["oDropDecorator"]["update"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_TabStripDropDelegate["_"]["onlsdraghover"] = 0; };

UCF_TabStripDropDelegate["prototype"]["bIsDropPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripDropDelegate["_"]["bIsDropPossible"]++; }; 

	if (this["oDropDecorator"] && this["oDropDecorator"]["sTargetTabId"] === -1)
		return false;

	return UCF_DropDelegate.prototype["bIsDropPossible"]["call"](this, oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_TabStripDropDelegate["_"]["bIsDropPossible"] = 0; };

};
sap["ls"]["preload"]["UCF_TabStripItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * TabStripItem
 *
 * 
 * @class
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TabStripItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TabStripItem["_"]["UCF_TabStripItem"]++; }; 

	if (arguments["length"] !== 2) return;
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "TabStripItem.js(20): UCF_TabStripItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TabStripItem.js(21): UCF_TabStripItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TabStripItem.js(22): UCF_TabStripItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_TabStripItem"] = UCF_TabStripItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TabStripItem"); UCF_TabStripItem["_"] = {UCF_TabStripItem: 0}; }; ;
UCF_TabStripItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TabStripItem.prototype["sClassName"] = "UCF_TabStripItem";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TabStripItem["prototype"]["aAttributeNames"] = ["sId","iIndex","sCaption","bHasTitleCaption","sTooltip","bEnabled","sScrollingMode","bHasToolbar","sDefaultButtonId","bIsClosable","iScrollTop","iScrollLeft","bClientTabSelect","sHotkeysId","sAccessKey","bHasEditableTitle","sAreaDesign","sCustomData","sCustomStyle","sVisibility"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TabStripItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TabStripItem["prototype"]["aMethodNames"] = ["editInplace","setDefaultButtonId","setVisibility","getVisibility","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_TabStripItem["prototype"]["sId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_TabStripItem["prototype"]["iIndex"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_TabStripItem["prototype"]["sCaption"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_TabStripItem["prototype"]["bHasTitleCaption"] = false;

/**
 * @private
 * @type {string}
 */
UCF_TabStripItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_TabStripItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ScrollingMode}
 */
UCF_TabStripItem["prototype"]["sScrollingMode"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_TabStripItem["prototype"]["bHasToolbar"] = false;

/**
 * @private
 * @type {string}
 */
UCF_TabStripItem["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_TabStripItem["prototype"]["bIsClosable"] = false;

/**
 * @private
 * @type {number}
 */
UCF_TabStripItem["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_TabStripItem["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_TabStripItem["prototype"]["bClientTabSelect"] = true;

/**
 * @private
 * @type {string}
 */
UCF_TabStripItem["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TabStripItem["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_TabStripItem["prototype"]["bHasEditableTitle"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.AreaDesign}
 */
UCF_TabStripItem["prototype"]["sAreaDesign"] = "FILL";

/**
 * @private
 * @type {string}
 */
UCF_TabStripItem["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TabStripItem["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_TabStripItem["prototype"]["sVisibility"] = "VISIBLE";

//#JSCOVER_EXCL_START
/** @protected */
UCF_TabStripItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["iIndex"] = 0;
	this["sCaption"] = '';
	this["bHasTitleCaption"] = false;
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["sScrollingMode"] = "NONE";
	this["bHasToolbar"] = false;
	this["sDefaultButtonId"] = '';
	this["bIsClosable"] = false;
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["bClientTabSelect"] = true;
	this["sHotkeysId"] = '';
	this["sAccessKey"] = '';
	this["bHasEditableTitle"] = false;
	this["sAreaDesign"] = "FILL";
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sVisibility"] = "VISIBLE";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("Index", 0, true);
		this["setClientProperty"]("Caption", '', true);
		this["setClientProperty"]("HasTitleCaption", false, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("ScrollingMode", "NONE", true);
		this["setClientProperty"]("HasToolbar", false, true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("IsClosable", false, true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("ClientTabSelect", true, true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("HasEditableTitle", false, true);
		this["setClientProperty"]("AreaDesign", "FILL", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStripItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_TabStripItem_ie6"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>
/* global UCF_TabStripItem */
/// <reference path="./TabStripItem.js"/>

/**
 * TabStripItem
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TabStripItem_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["UCF_TabStripItem_ie6"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "TabStripItem_ie6.js(34): UCF_TabStripItem_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TabStripItem_ie6.js(35): UCF_TabStripItem_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TabStripItem_ie6.js(36): UCF_TabStripItem_ie6"); };
	//
	UCF_TabStripItem["apply"](this, [oDomRef, oLS]);

	this["oScrollArea"] = (this["sScrollingMode"] !== 'NONE') //scroll area only exists when a height is provided
		? UCF_ClassLoader["oGetClass"]('UCF_ScrollArea')["oCreateAndConnectScrollArea"](this, this["sScrollingMode"], 'onScroll')
		: null;

	//TODO: replace by UCF_DomUtil.lastChild(this.oDomRef) to avoid problems with text node
	this["oFocusDomRef"] = this["oDomRef"]["lastChild"];
	this["sHiddenTextEnd"] = '-';
	//create inplace edit objects and fields

	if (this["bHasEditableTitle"]) {
		var oInplaceEditDelegate = this["oInplaceEditDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEditDelegate"))(oLS);
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this, 'onInplaceEditStart');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this, 'onInplaceEditFinished');
		this["addDelegate"](oInplaceEditDelegate);
		var oCaptionIcon = UCF_DomUtil["$"](this["sId"] + '-icon');
		if (oCaptionIcon) {
			this["sHiddenTextEnd"] += 'img';
		}
		if (this["bIsClosable"] && this["bEnabled"]) {
			this["sHiddenTextEnd"] += 'm';
		}
	}
	this["bCheckSetFocus"] = false;
	this["sTitle"] = '';
};window["UCF_TabStripItem_ie6"] = UCF_TabStripItem_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TabStripItem_ie6"); UCF_TabStripItem_ie6["_"] = {UCF_TabStripItem_ie6: 0}; }; ;
UCF_TabStripItem_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_TabStripItem"))(); UCF_TabStripItem_ie6.prototype["sClassName"] = "UCF_TabStripItem_ie6";

/**
 * Intialize in case scroll positions have to be applied
 */
UCF_TabStripItem_ie6["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["initialize"]++; }; 
	if (this["oScrollArea"]) {
		this["oGetParent"]()["addDelegate"](this["oScrollArea"]);
		this["oScrollArea"]["setScrollPosition"](this["iScrollTop"], this["iScrollLeft"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["initialize"] = 0; };

/**
 * Destructor
 */
UCF_TabStripItem_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["destroy"]++; }; 
	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}

	if (this["oInplaceEditDelegate"]) {

		UCF_JsUtil["clearDelayedCallsOfObject"](this["oInplaceEditDelegate"]);

		this["oInplaceEditDelegate"]["detachEvent"](this["oInplaceEditDelegate"]["E_EVENTS"]["InplaceEditStart"], this);
		this["oInplaceEditDelegate"]["detachEvent"](this["oInplaceEditDelegate"]["E_EVENTS"]["InplaceEditFinished"], this);
		this["oInplaceEditDelegate"]["destroy"]();
		this["oInplaceEditDelegate"] = null;
	}
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sVisibility"] = null;
	this["sTitle"] = null;
	this["sCaption"] = null;
	UCF_TabStripItem.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["destroy"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 * @return {string}
 */
UCF_TabStripItem_ie6["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["oGetInplaceEditDomRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + '-focus');
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["oGetInplaceEditDomRef"] = 0; };

/**
 * @see UCF_Control.sGetInplaceEditText
 * @return {string}
 */
// eslint-disable-next-line consistent-return
UCF_TabStripItem_ie6["prototype"]["sGetInplaceEditText"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["sGetInplaceEditText"]++; }; 
	var oClientContol = this["getClientControl"]();
	if (oClientContol) {
		if (oClientContol["getHasTitleCaption"]()) {
			var oCaption = oClientContol["getTitleCaption"]();
			return oCaption["getText"]();
		} else {
			this["getClientProperty"]('Caption');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["sGetInplaceEditText"] = 0; };

/**
 * @see UCF_Control.setInplaceEditDomRef
 * @param {string} sCaption
 */
UCF_TabStripItem_ie6["prototype"]["setInplaceEditText"] = function(sCaption) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["setInplaceEditText"]++; }; 
	var oClientContol = this["getClientControl"]();
	if (oClientContol) {
		if (oClientContol["getHasTitleCaption"]()) {
			var oCaption = oClientContol["getTitleCaption"]();
			oCaption["setText"](sCaption);
		} else {
			this["sCaption"] = sCaption;
			this["setClientProperty"]("Caption", sCaption);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["setInplaceEditText"] = 0; };

/**
 * @public
 * starts inplaceedit programmatically
 *
 */
UCF_TabStripItem_ie6["prototype"]["editInplace"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["editInplace"]++; }; 
	if (this["bHasEditableTitle"]) {
		UCF_JsUtil["delayedCall"](1, this["oInplaceEditDelegate"], 'openInplaceEdit', [null]);
		//this.oInplaceEditDelegate.openInplaceEdit(null);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["editInplace"] = 0; };

/**
 * @param {Object} oParams
 */
UCF_TabStripItem_ie6["prototype"]["onInplaceEditStart"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["onInplaceEditStart"]++; }; 

	var oBrowserEvent = oParams["mParameters"]["oBrowserEvent"],
		oSource = oBrowserEvent && oBrowserEvent["oGetSourceControl"](),
		oSourceTitle = oSource && UCF_DomUtil["$"](oSource["sId"] + '-focus'),
		oTitle = UCF_DomUtil["$"](this["sId"] + '-focus');
	this["sTitle"] = UCF_StringUtil["sTrim"](this["sGetInnerText"](oTitle));

	if (oSourceTitle && oSourceTitle !== oTitle) return;

	this["oInplaceEditDelegate"]["setInplaceEditData"](
		oTitle,
		this["oGetBoundaries"](),
		this["sTitle"]
	);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["onInplaceEditStart"] = 0; };
/**
 * Get the TabStripItem title text
 * @param {HTMLElement} oReferenceDomRef
 * @return {string}
 */
UCF_TabStripItem_ie6["prototype"]["sGetInnerText"] = function(oReferenceDomRef) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["sGetInnerText"]++; }; 

	// The title can have Caption Image, AceesKey or Close Icon in the Title
	// The last DIV contains the actually the text with some suffix
	// 'img' when the Caption has image
	// 'm' when the TabStripItenm has isClosable=true
	var oChildNode = oReferenceDomRef["lastChild"], //the DIV child,
		sText = '';

	//the Title can have Caption with Image, Close Image or/and Access Key
	if (oChildNode && oChildNode["nodeName"] === 'DIV') {
		sText = oChildNode["firstChild"]["data"];
		sText = sText["substr"](0, sText["lastIndexOf"](this["sHiddenTextEnd"]));
	}

	return sText;
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["sGetInnerText"] = 0; };

UCF_TabStripItem_ie6["prototype"]["oGetBoundaries"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["oGetBoundaries"]++; }; 

	var oIcon = UCF_DomUtil["$"](this["sId"] + '-icon'),
		oTitle = UCF_DomUtil["$"](this["sId"] + '-focus'),
		oBoundaries = UCF_DomUtil["oGetObjectRect"](oTitle),
		iIconWidth = (oIcon != null) ? (oIcon["offsetWidth"] + 2) : 0,

		iOffsetStart = (!window["UCF_System"]["bIsRTL"]) ? UCF_DomUtil["sGetCurrentStyle"](oTitle, 'paddingLeft') :
		UCF_DomUtil["sGetCurrentStyle"](oTitle, 'paddingRight'),

		iOffsetTop = this["oGetParent"]()["sTabItemsPosition"] === 'BOTTOM' ? 3 : 4;

	iOffsetStart = parseInt(iOffsetStart["split"]('px')[0]);

	if (!window["UCF_System"]["bIsRTL"]) {
		oBoundaries["left"] += (iOffsetStart + iIconWidth);
	} else {
		oBoundaries["right"] += (iOffsetStart + iIconWidth);
	}

	oBoundaries["top"] += iOffsetTop;

	return oBoundaries;
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["oGetBoundaries"] = 0; };

/**
 * @param {Object} oParams
 */
UCF_TabStripItem_ie6["prototype"]["onInplaceEditFinished"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["onInplaceEditFinished"]++; }; 

	var sText = oParams["oGetParam"]('sText');
	if (sText === this["sTitle"]) return;

	var oTitle = UCF_DomUtil["$"](this["sId"] + '-focus'),
		oTitleSpan = UCF_DomUtil["$"](this["sId"] + '-title'),
		oTabstrip = this["oGetParent"]();

	if (!oTitleSpan) oTitleSpan = oTitle;

	UCF_InplaceEditDelegate["setInnerText"](oTitleSpan, ' ' + sText + ' ');
	// force resize on the tabStrip in order to generates scrollButtons
	//D039230, csn 1681546 2010
	oTabstrip["iWidth"] = '';
	oTabstrip["fireChange"](oTabstrip["sId"], this["sId"], sText);

	var oChildNode = oTitle["lastChild"], //the DIV child,
		sHiddenText = sText;

	//the Title can have Caption with Image, Close Image or/and Access Key
	if (oChildNode && oChildNode["nodeName"] === 'DIV') {
		sHiddenText += this["sHiddenTextEnd"];
		UCF_InplaceEditDelegate["setInnerText"](oChildNode, sHiddenText);
		//oChildNode.innerText = sHiddenText;
	}

	UCF_DomUtil["focusDomElement"](oTitle);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["onInplaceEditFinished"] = 0; };

UCF_TabStripItem_ie6["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["onmouseover"]++; }; 

	if (!this["bEnabled"] || !this["bIsClosable"]) return;

	var oCloseIcon = UCF_DomUtil["$"](this["sId"] + '-close'),
		oSource = oBrowserEvent["oGetSource"]();

	if (oSource !== oCloseIcon) {
		if (oCloseIcon["className"]["indexOf"]('Hover') < 0) {
			UCF_DomUtil["replaceClass"](oCloseIcon, 'lsTbsClose', 'lsTbsCloseIconHover');
		}
	} else {
		if (oCloseIcon["className"]["indexOf"]('Sel') < 0) {
			UCF_DomUtil["replaceClass"](oCloseIcon, 'lsTbsCloseIcon', 'lsTbsCloseIconSel');
		}
	}

};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["onmouseover"] = 0; };

UCF_TabStripItem_ie6["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["onmouseout"]++; }; 

	if (!this["bEnabled"] || !this["bIsClosable"]) return;

	var oCloseIcon = UCF_DomUtil["$"](this["sId"] + '-close');

	if (oCloseIcon["className"]["indexOf"]('Hover') > -1) {

		if (this["iGetSelected"]() === this["iIndex"]) {
			UCF_DomUtil["removeClass"](oCloseIcon, 'lsTbsCloseIconHover');
			UCF_DomUtil["replaceClass"](oCloseIcon, 'lsTbsCloseIconSel', 'lsTbsCloseIcon');
		} else {
			UCF_DomUtil["replaceClass"](oCloseIcon, 'lsTbsCloseIconHover', 'lsTbsClose');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["onmouseout"] = 0; };

UCF_TabStripItem_ie6["prototype"]["iGetSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["iGetSelected"]++; }; 
	return this["oGetParent"]()["iCurrentIndex"];
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["iGetSelected"] = 0; };

/**
 * Checks if the control can get the focus or not
 *
 * @return {boolean} Whether the control can get the focus
 */
UCF_TabStripItem_ie6["prototype"]["bIsFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["bIsFocusable"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["bIsFocusable"] = 0; };

/**
 * Handle the area scroll event
 *
 * @param {UCF_Event} oEvent
 */
UCF_TabStripItem_ie6["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["onScroll"]++; }; 
	var oTabStrip = this["oGetParent"](),
		iScrollTop = oEvent["oGetParam"]('iScrollTop'),
		iScrollLeft = oEvent["oGetParam"]('iScrollLeft');
	oTabStrip["fireTabScroll"](oTabStrip["sId"], this["sId"], iScrollTop, iScrollLeft);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["onScroll"] = 0; };

/**
 * Gets the direct accessibility relevant children.
 *
 * @return {string} String to be announced
 *
 * @see aGetAccChildrenRecursive
 *
 */
UCF_TabStripItem_ie6["prototype"]["sGetAccChildren"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["sGetAccChildren"]++; }; 
	var aAccChildren = this["aGetAccChildrenRecursive"](this["oGetParent"]()["oDomRef"], new Array());
	return this["sGetAccChildrenText"](aAccChildren);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["sGetAccChildren"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 * @public
 */
UCF_TabStripItem_ie6["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["setDefaultButtonId"]++; }; 
	UCF_TabStripItem.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["setDefaultButtonId"] = 0; };

/**
 * Sets the visibility state of the TabStripItem control.
 * @param {string} sVisibility
 * @public
 */
UCF_TabStripItem_ie6["prototype"]["setVisibility"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["setVisibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sVisibility) === 'string', "typeof(sVisibility) === 'string'", "TabStripItem_ie6.js(346): setVisibility"); };

	UCF_DomUtil["setVisibility"](this["oDomRef"], sVisibility);
	this["sVisibility"] = sVisibility;
	this["setClientProperty"]("Visibility", this["sVisibility"], true);
	var oTabStrip = this["oGetParent"]();
	if (oTabStrip) {
		oTabStrip["iWidth"] = 0;
		oTabStrip["onAfterResize"]();
		if (oTabStrip["iCurrentIndex"] === this["iIndex"]) {
			//the selected Tab
			var oTabContent = UCF_DomUtil["$"](this["sId"] + '-cnt');
			if (oTabContent) {
				UCF_DomUtil["setVisibility"](oTabContent, sVisibility);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["setVisibility"] = 0; };

/** Returns the visibility of the TabStripItem control.
 * For the parameter values see enumeration 'Visibility'.
 * @public
 * @return {string} Returns the Visibility
 */
UCF_TabStripItem_ie6["prototype"]["getVisibility"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["getVisibility"]++; }; 
	return this["sVisibility"];
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["getVisibility"] = 0; };

/**
 * Overwrite UCF_Control method: Returns false if item is not visible because of overflow (width too small for all items),
 * fallback to super otherwise.
 * @return {boolean}
 * @private
 */
UCF_TabStripItem_ie6["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["bIsVisible"]++; }; 
	// if this.bCheckSetFocus is true that means that an explicit focus had been set
	// to the TabStripItem and this should be set visible
	// the this.bCheckSetFocus is reseted
	if (this["bCheckSetFocus"]) {
		this["bCheckSetFocus"] = false;
		return true;
	}
	//else check that the item OffsetTop should be the same with the
	//parent scrollTop
	var oTabStrip = this["oGetParent"](),
		iScrollTop = UCF_DomUtil["$"](oTabStrip["sId"] + '-panel')["scrollTop"],
		bIsVisible = (this["oDomRef"]["offsetTop"] >= iScrollTop && this["oDomRef"]["offsetTop"] < iScrollTop + (this["oDomRef"]["offsetHeight"] / 2));
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, '=== ' + bIsVisible + ' ======= item - offsetTop - ' + this["oDomRef"]["offsetTop"] + ' ======= Parent scrollTop - ' + iScrollTop, "TabStripItem_ie6.js(393): bIsVisible"); };
	if (bIsVisible) {
		return UCF_TabStripItem.prototype["bIsVisible"]["apply"](this, arguments);
	}
	return bIsVisible;
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["bIsVisible"] = 0; };

UCF_TabStripItem_ie6["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["focus"]++; }; 
	// While arrow navigation an explicit focus is set on the element
	// even if this is not yet visible
	// this will set this.bCheckSetFocus to a true value
	//_trace(INFO, 'Focus ' + this.sClassName + ' \'' + this.sId + '\'');
	this["bCheckSetFocus"] = true;
	UCF_TabStripItem.prototype["focus"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_ie6["_"]["focus"] = 0; };

UCF_TabStripItem_ie6.prototype["aPublicMethods"] = ["editInplace","setDefaultButtonId","setVisibility","getVisibility"].concat(UCF_TabStripItem_ie6.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TabStripItem_standards"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>
/* global UCF_TabStripItem */
/// <reference path="./TabStripItem.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TabStripItem_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["UCF_TabStripItem_standards"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "TabStripItem_standards.js(32): UCF_TabStripItem_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TabStripItem_standards.js(33): UCF_TabStripItem_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TabStripItem_standards.js(34): UCF_TabStripItem_standards"); };

	UCF_TabStripItem["apply"](this, [oDomRef, oLS]);

	//TODO: replace by UCF_DomUtil.lastChild(this.oDomRef) to avoid problems with text node
	this["oFocusDomRef"] = UCF_DomUtil["$"](this["sId"] + '-title');
	this["sHiddenTextEnd"] = '-';
	//create inplace edit objects and fields

	if (this["bHasEditableTitle"]) {
		var oInplaceEditDelegate = this["oInplaceEditDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_InplaceEditDelegate"))(oLS);
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this, 'onInplaceEditStart');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this, 'onInplaceEditFinished');
		oInplaceEditDelegate["attachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this, 'onInplaceEditClosed');
		this["addDelegate"](oInplaceEditDelegate);
		var oCaptionIcon = UCF_DomUtil["$"](this["sId"] + '-icon');
		if (oCaptionIcon) {
			this["sHiddenTextEnd"] += 'img';
		}
		if (this["bIsClosable"] && this["bEnabled"]) {
			this["sHiddenTextEnd"] += 'm';
		}
	}
	this["bCheckSetFocus"] = false;
	this["sTitle"] = '';
	this["oScrollArea"] = null;
};window["UCF_TabStripItem_standards"] = UCF_TabStripItem_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TabStripItem_standards"); UCF_TabStripItem_standards["_"] = {UCF_TabStripItem_standards: 0}; }; ;
UCF_TabStripItem_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_TabStripItem"))(); UCF_TabStripItem_standards.prototype["sClassName"] = "UCF_TabStripItem_standards";

/**
 * programmatically loads / creates a scroll area for a particular item
 * @private
 */
UCF_TabStripItem_standards["prototype"]["loadScrollArea"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["loadScrollArea"]++; }; 
	if (this["sScrollingMode"] === 'NONE') return;
	this["oScrollArea"] = UCF_ClassLoader["oGetClass"]('UCF_ScrollArea')["oCreateAndConnectScrollArea"](this, this["sScrollingMode"], 'onScroll', UCF_DomUtil["$"](this["sId"] + '-scrl'));
	if (this["oScrollArea"])
		this["oGetParent"]()["addDelegate"](this["oScrollArea"]);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["loadScrollArea"] = 0; };

/**
 * Fires the scroll event
 * @private
 * @param {UCF_EventObject} oEvent
 */
UCF_TabStripItem_standards["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["onScroll"]++; }; 

	var oTabStrip = this["oGetParent"](),
		iScrollTop = oEvent["oGetParam"]('iScrollTop'),
		iScrollLeft = oEvent["oGetParam"]('iScrollLeft');

	oTabStrip["fireTabScroll"](oTabStrip["sId"], this["sId"], iScrollTop, iScrollLeft);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["onScroll"] = 0; };

/**
 * Destructor
 *  @private
 */
UCF_TabStripItem_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["destroy"]++; }; 
	/** @type {UCF_InplaceEditDelegate} */
	var oInplaceEditDelegate = this["oInplaceEditDelegate"];

	if (oInplaceEditDelegate) {
		UCF_JsUtil["clearDelayedCallsOfObject"](oInplaceEditDelegate);

		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditStart"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditFinished"], this);
		oInplaceEditDelegate["detachEvent"](oInplaceEditDelegate["E_EVENTS"]["InplaceEditClose"], this);

		this["oInplaceEditDelegate"]["destroy"]();
		this["oInplaceEditDelegate"] = null;
	}

	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sVisibility"] = null;
	this["sTitle"] = null;
	this["sCaption"] = null;
	UCF_TabStripItem.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["destroy"] = 0; };

/**
 * @return {string}
 */
UCF_TabStripItem_standards["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["oGetInplaceEditDomRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + '-title');
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["oGetInplaceEditDomRef"] = 0; };

/**
 * @see UCF_Control.sGetInplaceEditText
 */
UCF_TabStripItem_standards["prototype"]["sGetInplaceEditText"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["sGetInplaceEditText"]++; }; 
	var oClientContol = this["getClientControl"]();
	if (oClientContol) {
		if (oClientContol["getHasTitleCaption"]()) {
			var oCaption = oClientContol["getTitleCaption"]();
			return oCaption["getText"]();
		} else {
			this["getClientProperty"]('Caption');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["sGetInplaceEditText"] = 0; };

/**
 * @see UCF_Control.setInplaceEditDomRef
 * @param {string} sCaption
 */
UCF_TabStripItem_standards["prototype"]["setInplaceEditText"] = function(sCaption) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["setInplaceEditText"]++; }; 
	var oClientContol = this["getClientControl"]();
	if (oClientContol) {
		if (oClientContol["getHasTitleCaption"]()) {
			var oCaption = oClientContol["getTitleCaption"]();
			oCaption["setText"](sCaption);
		} else {
			this["sCaption"] = sCaption;
			this["setClientProperty"]("Caption", sCaption);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["setInplaceEditText"] = 0; };

/**
 * @public
 * starts inplaceedit programmatically
 *
 */
UCF_TabStripItem_standards["prototype"]["editInplace"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["editInplace"]++; }; 
	if (this["bHasEditableTitle"]) {
		UCF_JsUtil["delayedCall"](1, this["oInplaceEditDelegate"], 'openInplaceEdit', [null]);
		//this.oInplaceEditDelegate.openInplaceEdit(null);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["editInplace"] = 0; };

/**
 * @param {Object} oParams
 */
UCF_TabStripItem_standards["prototype"]["onInplaceEditStart"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["onInplaceEditStart"]++; }; 

	var oBrowserEvent = oParams["mParameters"]["oBrowserEvent"],
		oSource = oBrowserEvent && oBrowserEvent["oGetSourceControl"](),
		oSourceTitle = oSource && UCF_DomUtil["$"](oSource["sId"] + '-title'),
		oTitle = UCF_DomUtil["$"](this["sId"] + '-title');
	this["sTitle"] = UCF_StringUtil["sTrim"](this["sGetInnerText"](oTitle));

	if (oSourceTitle && oSourceTitle !== oTitle) return;

	this["oInplaceEditDelegate"]["setInplaceEditData"](
		oTitle,
		this["oGetBoundaries"](),
		this["sTitle"]
	);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["onInplaceEditStart"] = 0; };
/**
 * Get the TabStripItem title text
 * @param {HTMLElement} oReferenceDomRef
 * @return {string}
 */
UCF_TabStripItem_standards["prototype"]["sGetInnerText"] = function(oReferenceDomRef) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["sGetInnerText"]++; }; 

	// The title can have Caption Image, AceesKey or Close Icon in the Title
	// The last DIV contains the actually the text with some suffix
	// 'img' when the Caption has image
	// 'm' when the TabStripItenm has isClosable=true
	var oChildNode = oReferenceDomRef["lastChild"], //the DIV child,
		sText = '';

	//the Title can have Caption with Image, Close Image or/and Access Key
	if (oChildNode && oChildNode["nodeName"] === 'DIV') {
		sText = oChildNode["firstChild"]["data"];
		sText = sText["substr"](0, sText["lastIndexOf"](this["sHiddenTextEnd"]));
	}

	return sText;
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["sGetInnerText"] = 0; };

UCF_TabStripItem_standards["prototype"]["oGetBoundaries"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["oGetBoundaries"]++; }; 

	var oIcon = UCF_DomUtil["$"](this["sId"] + '-icon'),
		oTitle = UCF_DomUtil["$"](this["sId"] + '-title'),
		oBoundaries = UCF_DomUtil["oGetObjectRect"](oTitle),
		iIconWidth = (oIcon != null) ? (oIcon["offsetWidth"] + 2) : 0,

		iOffsetStart = (!window["UCF_System"]["bIsRTL"]) ? UCF_DomUtil["sGetCurrentStyle"](oTitle, 'paddingLeft') :
		UCF_DomUtil["sGetCurrentStyle"](oTitle, 'paddingRight'),

		iOffsetTop = this["oGetParent"]()["sTabItemsPosition"] === 'BOTTOM' ? 3 : 4;

	iOffsetStart = parseInt(iOffsetStart["split"]('px')[0]);

	if (!window["UCF_System"]["bIsRTL"]) {
		oBoundaries["left"] += (iOffsetStart + iIconWidth);
	} else {
		oBoundaries["right"] += (iOffsetStart + iIconWidth);
	}

	oBoundaries["top"] += iOffsetTop;

	return oBoundaries;
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["oGetBoundaries"] = 0; };

/**
 * @param {Object} oParams
 */
UCF_TabStripItem_standards["prototype"]["onInplaceEditFinished"] = function(oParams) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["onInplaceEditFinished"]++; }; 

	var sText = oParams["oGetParam"]('sText');
	if (sText === this["sTitle"]) return;

	var oTitle = UCF_DomUtil["$"](this["sId"] + '-title'),
		oTitleSpan = UCF_DomUtil["$"](this["sId"] + '-title'),
		oTabstrip = this["oGetParent"]();

	if (!oTitleSpan) oTitleSpan = oTitle;

	UCF_InplaceEditDelegate["setInnerText"](oTitleSpan, ' ' + sText + ' ');
	// force resize on the tabStrip in order to generates scrollButtons
	//D039230, csn 1681546 2010
	oTabstrip["iWidth"] = '';
	oTabstrip["fireChange"](oTabstrip["sId"], this["sId"], sText);

	var oChildNode = oTitle["lastChild"], //the DIV child,
		sHiddenText = sText;

	//the Title can have Caption with Image, Close Image or/and Access Key
	if (oChildNode && oChildNode["nodeName"] === 'DIV') {
		sHiddenText += this["sHiddenTextEnd"];
		UCF_InplaceEditDelegate["setInnerText"](oChildNode, sHiddenText);
		//oChildNode.innerText = sHiddenText;
	}

	UCF_DomUtil["focusDomElement"](oTitle);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["onInplaceEditFinished"] = 0; };

UCF_TabStripItem_standards["prototype"]["onInplaceEditClosed"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["onInplaceEditClosed"]++; }; 
	var oTitle = UCF_DomUtil["$"](this["sId"] + '-title');

	UCF_DomUtil["focusDomElement"](oTitle);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["onInplaceEditClosed"] = 0; };

UCF_TabStripItem_standards["prototype"]["iGetSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["iGetSelected"]++; }; 
	return this["oGetParent"]()["iCurrentIndex"];
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["iGetSelected"] = 0; };

/**
 * Checks if the control can get the focus or not
 *
 * @return {boolean} Whether the control can get the focus
 */
UCF_TabStripItem_standards["prototype"]["bIsFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["bIsFocusable"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["bIsFocusable"] = 0; };

/**
 * Gets the direct accessibility relevant children.
 *
 * @return {string} String to be announced
 *
 * @see aGetAccChildrenRecursive
 *
 */
UCF_TabStripItem_standards["prototype"]["sGetAccChildren"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["sGetAccChildren"]++; }; 
	var aAccChildren = this["aGetAccChildrenRecursive"](this["oGetParent"]()["oDomRef"], new Array());
	return this["sGetAccChildrenText"](aAccChildren);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["sGetAccChildren"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 * @public
 */
UCF_TabStripItem_standards["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["setDefaultButtonId"]++; }; 
	//_super(sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["setDefaultButtonId"] = 0; };

/**
 * Sets the visibility state of the TabStripItem control.
 * @param {string} sVisibility
 * @public
 */
UCF_TabStripItem_standards["prototype"]["setVisibility"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["setVisibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sVisibility) === 'string', "typeof(sVisibility) === 'string'", "TabStripItem_standards.js(317): setVisibility"); };

	UCF_DomUtil["setVisibility"](this["oDomRef"], sVisibility);
	this["sVisibility"] = sVisibility;
	this["setClientProperty"]("Visibility", this["sVisibility"], true);
	var oTabStrip = this["oGetParent"]();
	if (oTabStrip) {
		oTabStrip["iWidth"] = 0;
		oTabStrip["onAfterResize"]();
		if (oTabStrip["iCurrentIndex"] === this["iIndex"]) {
			//the selected Tab
			var oTabContent = UCF_DomUtil["$"](this["sId"] + '-cnt');
			if (oTabContent) {
				UCF_DomUtil["setVisibility"](oTabContent, sVisibility);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["setVisibility"] = 0; };

/** Returns the visibility of the TabStripItem control.
 * For the parameter values see enumeration 'Visibility'.
 * @public
 * @return {string} Returns the Visibility
 */
UCF_TabStripItem_standards["prototype"]["getVisibility"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["getVisibility"]++; }; 
	return this["sVisibility"];
};;if (__UCF_COVERAGE__) { UCF_TabStripItem_standards["_"]["getVisibility"] = 0; };

UCF_TabStripItem_standards["prototype"]["eStyles"] = {

	"FIRST_SELECTED": "lsTbsv5-FirstItemSel",
	"LAST_SELECTED": "lsTbsv5-LastItemSel",
	"ANY_SELECTED": "lsTbsv5-ItemSel",

	"FIRST_UNSELECTED": "lsTbsv5-FirstItem",
	"LAST_UNSELECTED": "lsTbsv5-LastItem",
	"ANY_UNSELECTED": "lsTbsv5-Item",

	"FIRST_DISABLED_SELECTED": "lsTbsv5-FirstItemSelDsbl",
	"LAST_DISABLED_SELECTED": "lsTbsv5-LastItemSelDsbl",
	"ANY_DISABLED_SELECTED": "lsTbsv5-ItemSelDsbl",

	"SOLE_ITEM_UNSELECTED": "lsTbsv5-SoleItem",
	"SOLE_ITEM_SELECTED": "lsTbsv5-SoleItemSel",
	"SOLE_ITEM_DISABLED_SELECTED": "lsTbsv5-SoleItemSelDsbl",

	"MORE_INDICATOR_UNSELECTED": "lsTbsv5-MoreIndicator",
	"MORE_INDICATOR_SELECTED": "lsTbsv5-MoreIndicatorSel",

	"ANY_DISABLED": 'lsTbsv5-ItemDsbl',
	"FIRST_DISABLED": 'lsTbsv5-FirstItemDsbl',
	"LAST_DISABLED": 'lsTbsv5-LastItemDsbl'
};

UCF_TabStripItem_standards.prototype["aPublicMethods"] = ["editInplace","setDefaultButtonId","setVisibility","getVisibility"].concat(UCF_TabStripItem_standards.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TabStrip_ie6"] = function() {/* global _assert, _trace, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_TabStripDragDelegate */
/// <reference path="./delegates/TabStripDragDelegate.js"/>
/* global UCF_TabStripDropDelegate */
/// <reference path="./delegates/TabStripDropDelegate.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>
/* global UCF_TabStrip */
/// <reference path="./TabStrip.js"/>
/* global UCF_TabStripItem */
/// <reference path="./TabStripItem.js"/>

/**
 * TabStrip
 *
 * 
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TabStrip_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["UCF_TabStrip_ie6"]++; }; 

	UCF_TabStrip["apply"](this, [oDomRef, oLS]);

	this["bInitial"] = this["bScrollable"];
	this["sScrollDirection"] = 'FORWARD';
	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]);

	this["createItems"]();
	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Select"], this, 'onItemSelect');

	if (this["bScrollable"]) {
		this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Activate"], this, 'onItemActivate');
	}

	if (this["aItems"]["length"] > 0) {
		this["oItemNavigation"]["oItemContainer"] = UCF_DomUtil["$"](this["sId"] + '-panel');
		this["setDefaultButtonId"](this["aItems"][this["iCurrentIndex"]]["sDefaultButtonId"]);
	} 
	
	//this.oItemNavigation.bIgnoreFocus = true;
	//this.oItemNavigation.setFocusedIndex(this.oItemNavigation.iFocusedIndex);
	
	UCF_DomUtil["resetTabIndex"](this["oDomRef"]);

	this["oObserver"] = UCF_DomUtil["$"](this["sId"] + '-observer');
	this["oOldFirst"] = null;
	//create inplace edit objects and fields
	this["oEditItem"] = null;
	this["iDomRefHeight"] = 0;
	this["oPreviousButton"] = UCF_DomUtil["$"](this["sId"] + '-prev');
	this["oPreviousLeftButton"] = UCF_DomUtil["$"](this["sId"] + '-prevLeft');
	this["oNextButton"] = UCF_DomUtil["$"](this["sId"] + '-next');
	this["oMenuButton"] = UCF_DomUtil["$"](this["sId"] + '-menu');
	this["bCheckResizeStd"] = false;
	
	this["bIgnoreResizeOnScroll"] = false;
	//this.oLS.oBrowserWindow.attachEvent(this.oLS.oBrowserWindow.E_EVENTS.LayoutChange, this, 'onLayoutChange');
};window["UCF_TabStrip_ie6"] = UCF_TabStrip_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TabStrip_ie6"); UCF_TabStrip_ie6["_"] = {UCF_TabStrip_ie6: 0}; }; ;
UCF_TabStrip_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_TabStrip"))(); UCF_TabStrip_ie6.prototype["sClassName"] = "UCF_TabStrip_ie6";

/**########################################################################
 * 
 * Access Key Handling
 * 
 * #######################################################################
 **/

UCF_TabStrip_ie6["prototype"]["onItemActivate"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onItemActivate"]++; }; 

	var oItem = oEvent["mParameters"]["oItem"];

	if (this["bIsHidden"](oItem["oDomRef"])) {
		this["oScrollDomRef"]["scrollTop"] = oItem["oDomRef"]["offsetTop"];
	}

	this["resetVisibility"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onItemActivate"] = 0; };

/**
 * Initialize
 * @private
 */
UCF_TabStrip_ie6["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["initialize"]++; }; 

	if (this["aItems"]["length"] === 0 || !this["bScrollable"]) return;
	
	this["callInitialize"]();
	//this.removeSecondLevelStyles();
	this["oScrollDomRef"] = UCF_DomUtil["$"](this["sId"] + '-panel');
	
	this["iWidth"] = this["oDomRef"]["offsetWidth"];

	if (!this["bItemsVisible"]()) {

		//if a first visible item has been defined scroll it into view, otherwise scroll the selected item into view
		if (this["iFirstVisibleItemIdx"] > -1) {
			this["oScrollDomRef"]["scrollTop"] = this["aItems"][this["iFirstVisibleItemIdx"]]["oDomRef"]["offsetTop"];
		} else {
			this["scrollSelectedTabIntoView"](true);
		}

		this["setNextButton"]();
		this["setPreviousButton"]();
		this["setMoreIndicator"](null);

		if (this["oPreviousButton"]) this["oPreviousButton"]["style"]["visibility"] = 'visible';
		if (this["oPreviousLeftButton"] && this["oGetFirstVisibleItem"]()["iIndex"] === 0) this["oPreviousLeftButton"]["style"]["visibility"] = 'hidden';
		if (this["oNextButton"]) this["oNextButton"]["style"]["visibility"] = 'visible';
		if (this["oMenuButton"]) this["oMenuButton"]["style"]["visibility"] = 'visible';

		if (this["bScrollable"]) {
		this["resetVisibility"]();
	}
	}
	// call initialize of the visible tabstripitem
	var oCurrentItem = this["aItems"][this["iCurrentIndex"]];
	if (oCurrentItem) oCurrentItem["initialize"]();
	
	this["attachBrowserEvent"]('tabNavigate', this["oScrollDomRef"]);
	this["bCheckResizeStd"] = UCF_DomUtil["bCheckStandardsCorrection"]() && this["sHeight"] !== '' && (this["sHeight"]["indexOf"]('px') > -1 || this["sHeight"]["indexOf"]('%') > -1);
	//_trace(INFO, '== TabStripId - ' + this.sId + ' - resize - ' + this.bCheckResizeStd);
	this["iDomRefHeight"] = 0;
	this["correctTabStripHeight"]();
	this["bInitial"] = false;
	
	//UpdateComplete is not working
	//this.oLS.attachEvent(this.oLS.E_EVENTS.UpdateComplete, this, 'onUpdateComplete');
	if (this["oScrollDomRef"]) {
		this["attachBrowserEvent"]('resize', this["oScrollDomRef"]);
	}
	//IE Standards mode - correction algorithm	
	if (this["bCheckResizeStd"]) {
		this["attachBrowserEvent"]('resize', this["oDomRef"]);
	}	
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["initialize"] = 0; };

UCF_TabStrip_ie6["prototype"]["removeSecondLevelStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["removeSecondLevelStyles"]++; }; 
	
	var aMatchesDomRef = Array["prototype"]["slice"]["apply"](UCF_DomUtil["querySelectorAll"]('.lsTbsPanelDesign .lsTbsPanelDesign'));
	for (var oItem in aMatchesDomRef) {
		aMatchesDomRef[oItem]["classList"]["remove"]('lsTbsPanelDesign');
		aMatchesDomRef[oItem]["classList"]["add"]('lsTabStripButton');
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["removeSecondLevelStyles"] = 0; };

/**
 * The ResizeEventHelper will calculate its initial values during attach.
 * This has to be done when all other controls (especially PopupWindow) have already initialized.
 * Otherwise it may happen that we get an resize immediately after re-rendering and it will cause a visible glitch - especially with IE9/10 Std. Mode correction codeing 
 */
UCF_TabStrip_ie6["prototype"]["onUpdateComplete"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onUpdateComplete"]++; }; 
	this["resetVisibility"]();
	this["attachBrowserEvent"]('resize', this["oScrollDomRef"]);
	//IE Standards mode - correction algorithm	
	if (this["bCheckResizeStd"]) {
		this["attachBrowserEvent"]('resize', this["oDomRef"]);
	}	
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onUpdateComplete"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_TabStrip_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["destroy"]++; }; 
	
	//this.oLS.detachEvent(this.oLS.E_EVENTS.UpdateComplete, this);
	if (this["oScrollDomRef"]) {
		this["detachBrowserEvent"]('resize', this["oScrollDomRef"]);
		this["detachBrowserEvent"]('scroll', this["oScrollDomRef"]);
	}
	if (this["bCheckResizeStd"]) {
		this["detachBrowserEvent"]('resize', this["oDomRef"]);
	}
	
	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	
	if (this["oItemNavigation"]) this["oItemNavigation"]["destroy"]();
	
	this["oItemNavigation"] = null;
	this["aItems"] = null;
	this["oItemMenu"] = null;
	this["oActiveCloseIcon"] = null;
	this["oFirstVisibleItem"] = null;
		
	this["oScrollDomRef"] = null;
	this["oPreviousButton"] = null;
	this["oNextButton"] = null;
	this["oPreviousLeftButton"] = null;
	this["oMenuButton"] = null;
	this["bInitial"] = null;
	this["oObserver"] = null;
	this["oOldFirst"] = null;
	this["iDomRefHeight"] = null;
	this["bCheckResizeStd"] = null;
	this["iWidth"] = null;
	this["sTimeOutId"] = null;
	this["sTimeOutIdStd"] = null;
	this["iFirstVisibleItemIdx"] = null;
	this["iCurrentIndex"] = null;
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}
	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sVisibility"] = null;

	UCF_TabStrip.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["destroy"] = 0; };

/***
 * Handles the resize event of the browser
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 * 
 */
 
UCF_TabStrip_ie6["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onresize"]++; }; 
	
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oScrollDomRef"]) {

		if (this["sTimeOutId"] != null) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResize');
		oBrowserEvent["cancelBubble"]();
	} else if (oSource === this["oDomRef"]) {
		if (this["sTimeOutIdStd"] != null) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutIdStd"]);
		}
		this["sTimeOutIdStd"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResizeStd');
	}
	
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onresize"] = 0; };

/**
 * This function is called after resizing has finished
 * 
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onAfterResize"]++; }; 
	if (this["bIgnoreResizeOnScroll"] || this["aItems"] === null || (this["aItems"] && this["aItems"]["length"] === 0)) return;
	if (!this["bIsValid"]() || this["iWidth"] === this["oDomRef"]["offsetWidth"]) return;
	
	if (this["bInitial"] === true) this["initialize"]();

	this["oScrollDomRef"]["scrollTop"] = this["aItems"][this["iCurrentIndex"]]["oDomRef"]["offsetTop"];

	this["setNextButton"]();
	this["setPreviousButton"]();
	this["setMoreIndicator"](null);
	//this.setPaddingLastVissible();
	this["resetVisibility"]();	
	
	if (!this["bItemsVisible"]()) {
		if (this["oPreviousButton"]) this["oPreviousButton"]["style"]["visibility"] = 'visible';
		if (this["oPreviousLeftButton"]) this["oPreviousLeftButton"]["style"]["visibility"] = 'visible';
		if (this["oNextButton"]) this["oNextButton"]["style"]["visibility"] = 'visible';
		if (this["oMenuButton"]) this["oMenuButton"]["style"]["visibility"] = 'visible';
	} else {
		if (this["oPreviousButton"]) this["oPreviousButton"]["style"]["visibility"] = 'hidden';
		if (this["oPreviousLeftButton"]) this["oPreviousLeftButton"]["style"]["visibility"] = 'hidden';
		if (this["oNextButton"]) this["oNextButton"]["style"]["visibility"] = 'hidden';
		if (this["oMenuButton"]) this["oMenuButton"]["style"]["visibility"] = 'hidden';
	}

	this["iWidth"] = this["oDomRef"]["offsetWidth"];
	//this.correctTabStripHeight();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onAfterResize"] = 0; };

/**
 * This function is called after resizing has finished
 * 
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onAfterResizeStd"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onAfterResizeStd"]++; }; 
	if (this["bCheckResizeStd"] && this["iDomRefHeight"] !== this["oDomRef"]["offsetHeight"]) {
		this["correctTabStripHeight"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onAfterResizeStd"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_TabStrip_ie6["prototype"]["bItemsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["bItemsVisible"]++; }; 
	return this["aItems"][0]["oDomRef"]["offsetTop"] === this["oScrollDomRef"]["scrollTop"] &&
		this["aItems"][this["aItems"]["length"] - 1]["oDomRef"]["offsetTop"] === this["oScrollDomRef"]["scrollTop"];
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["bItemsVisible"] = 0; };

/**
 * Handles the keydown event
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */	
UCF_TabStrip_ie6["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onkeydown"]++; }; 

	// fire tab close event	
	if (oBrowserEvent["bCtrl"]() || oBrowserEvent["bShift"]()) return;
	var oSource = oBrowserEvent["oGetSourceControl"]();
	
	if (oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["DELETE"] && oSource["bIsClosable"] && oSource["bEnabled"])
		this["fireTabClose"](this["sId"], oSource["sId"]);
		
	oBrowserEvent["returnValue"] = false;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onkeydown"] = 0; };

/**
 * Handle the area scroll event
 * 
 * @param {UCF_EventObject} oEvent the browser event object that occurred
 * @private
 */	
UCF_TabStrip_ie6["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onScroll"]++; }; 
	
	if (this["iCurrentIndex"] < 0) return;
	
	var iScrollTop = oEvent["oGetParam"]('iScrollTop'),
		iScrollLeft = oEvent["oGetParam"]('iScrollLeft'),
		oSelected = this["aItems"][this["iCurrentIndex"]],
		oScrollContainer = UCF_DomUtil["$"](oSelected["sId"] + '-scrl');
	
	if (oScrollContainer["offsetHeight"] !== oScrollContainer["scrollHeight"] || oScrollContainer["offsetWidth"] !== oScrollContainer["scrollWidth"]) {
		this["fireTabScroll"](this["sId"], oSelected["sId"], iScrollTop, iScrollLeft);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onScroll"] = 0; };

/**
 * Sets the scroll position programmatically
 *
 * @param {string} sId
 * @param {string} sItemId
 * @param {integer} iScrollTop
 * @param {integer} iScrollLeft
 * @public
 */
UCF_TabStrip_ie6["prototype"]["setScrollPosition"] = function(sId, sItemId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setScrollPosition"]++; }; 

	if (typeof(sId) === 'undefined') {
		return;
	}
	if (typeof(sItemId) === 'undefined') {
		return;
	}
	if (this["sId"] !== sId) return;

	var oTabItem = this["oGetItemById"](sItemId);

	if (!oTabItem) return;

	if (oTabItem["sScrollingMode"] === 'NONE' ||
		!UCF_DomUtil["$"](oTabItem["sId"] + '-scrl')) return;

	if (oTabItem["oScrollArea"] !== null) {
		oTabItem["oScrollArea"]["setScrollPosition"](iScrollTop, iScrollLeft);
	}

};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setScrollPosition"] = 0; };
/**
 * Sets the scroll position programmatically
 *
 * @param {string} sId
 * @param {string} sItemId
 * @return {integer} scroll position
 * @public
 */
UCF_TabStrip_ie6["prototype"]["getScrollPosition"] = function(sId, sItemId) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["getScrollPosition"]++; }; 

	if (typeof(sId) === 'undefined') {
		return null;
	}
	if (typeof(sItemId) === 'undefined') {
		return null;
	}
	if (this["sId"] !== sId) return null;

	var oTabItem = this["oGetItemById"](sItemId);

	if (!oTabItem) return null;

	if (oTabItem["sScrollingMode"] === 'NONE' ||
		!UCF_DomUtil["$"](oTabItem["sId"] + '-scrl')) return null;

	if (oTabItem["oScrollArea"] === null) {
		return null;
	}
	return oTabItem["oScrollArea"]["oGetScrollPosition"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["getScrollPosition"] = 0; };

/**
 * Handles the mouse over event by doing the following:
 * - showing the appropriate close icon on a item provided its hasCloseIcon flag was set to TRUE
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onmouseover"]++; }; 

	var oItem = oBrowserEvent["oGetSourceControl"]();

	if (this["oActiveCloseIcon"] !== null && this["oActiveCloseIcon"] !== 'undefined' && this["oActiveCloseIcon"] !== oItem) {
		this["onmouseout"](oBrowserEvent);
	}
	
	if (!oItem["bEnabled"] || !oItem["bIsClosable"]) return;

	var oCloseIcon = UCF_DomUtil["$"](oItem["sId"] + '-close'),
		oSource = oBrowserEvent["oGetSource"]();
	
	if (oSource !== oCloseIcon) {
		if (oCloseIcon["className"]["indexOf"]('Hover') < 0) {
			UCF_DomUtil["replaceClass"](oCloseIcon, 'lsTbsClose', 'lsTbsCloseIconHover');
		}
	} else {
		if (oCloseIcon["className"]["indexOf"]('Sel') < 0) {
			UCF_DomUtil["replaceClass"](oCloseIcon, 'lsTbsCloseIcon', 'lsTbsCloseIconSel');
		}
	}
	
	this["oActiveCloseIcon"] = oItem;
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onmouseover"] = 0; };

/**
 * Handles the mouse out event by doing the following:
 * - hiding the appropriate close icon on a item provided its hasCloseIcon flag was set to TRUE
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onmouseout"]++; }; 

	var oItem = this["oActiveCloseIcon"];
	
	if (!oItem || !oItem["bEnabled"] || !oItem["bIsClosable"]) return;
	
	var oCloseIcon = UCF_DomUtil["$"](oItem["sId"] + '-close');
	
	if (oCloseIcon && (oCloseIcon["className"]["indexOf"]('Hover') > -1 || oCloseIcon["className"]["indexOf"]('Sel') > -1)) {
		
		if (this["iCurrentIndex"] === oItem["iIndex"]) {
			UCF_DomUtil["replaceClass"](oCloseIcon, 'lsTbsCloseIconSel', 'lsTbsCloseIcon');
		} else {
			UCF_DomUtil["replaceClass"](oCloseIcon, 'lsTbsCloseIconHover', 'lsTbsClose');
		}
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onmouseout"] = 0; };

/**
 * Selects the next tab by ctrl + page up
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */	
UCF_TabStrip_ie6["prototype"]["onlspageupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlspageupmodifier"]++; }; 
	
	var oSource = oBrowserEvent["oGetSourceControl"]();
	
	//select next item by using page up
	if (oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]() && !oBrowserEvent["bAlt"]()) {
		var oItem = this["nextSelectable"]();

		if (oItem != null) {
			this["selectByPaging"](oSource, oItem);
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlspageupmodifier"] = 0; };

/**
 * Selects the prevouis tab by ctrl + page down
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */	
UCF_TabStrip_ie6["prototype"]["onlspagedownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlspagedownmodifier"]++; }; 
	
	var oSource = oBrowserEvent["oGetSourceControl"]();

	//select previous item by using page down
	if (oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]() && !oBrowserEvent["bAlt"]()) {
		var oItem = this["previousSelectable"]();
		if (oItem != null) {
			this["selectByPaging"](oSource, oItem);
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlspagedownmodifier"] = 0; };

/**
 * Selects the next tab by page up / down
 *
 * @param {UCF_TabstripItem} oSource
 * @param {UCF_TabstripItem} oItem
 * @private
 */	
UCF_TabStrip_ie6["prototype"]["selectByPaging"] = function(oSource, oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["selectByPaging"]++; }; 

	if (this["iCurrentIndex"] !== oItem["iIndex"]) {
		this["fireTabSelect"](this["sId"], oItem["sId"], oItem["iIndex"], -1);
	}

	this["setSelectedDesign"](oItem);
	this["oItemNavigation"]["setFocusedIndex"](oItem["iIndex"]);
	
	UCF_DomUtil["resetTabIndex"](oSource["oFocusDomRef"]);
	UCF_DomUtil["setTabIndex"](oItem["oFocusDomRef"], 0);
	oItem["moveFocus"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["selectByPaging"] = 0; };

/**
 * Finds the next selectable tab. Returns null, if there is none
 * @return {UCF_TabstripItem}
 * @private
 */
// eslint-disable-next-line consistent-return
UCF_TabStrip_ie6["prototype"]["nextSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["nextSelectable"]++; }; 
	
	if (this["iCurrentIndex"] + 1 >= this["aItems"]["length"]) return;
			
	var i = this["iCurrentIndex"] + 1,
		aItems = this["aItems"],
		oItem = null;
			
	while (i < aItems["length"]) {
		
		if (aItems[i]["bEnabled"]) {
			oItem = aItems[i];
			break;
		}
		i++;	
	}
	return oItem;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["nextSelectable"] = 0; };

/**
 * Finds the previous selectable tab. Returns null, if there is none
 * @return {UCF_TabstripItem}
 * @private
 */
// eslint-disable-next-line consistent-return
UCF_TabStrip_ie6["prototype"]["previousSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["previousSelectable"]++; }; 
	
	if (this["iCurrentIndex"] < 0) return;
			
	var i = this["iCurrentIndex"] - 1,
		aItems = this["aItems"],
		oItem = null;
	
	while (i >= 0) {
		
		if (aItems[i]["bEnabled"]) {
			oItem = aItems[i];
			break;
		}
		i--;
	}
	return oItem;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["previousSelectable"] = 0; };

/**
 * Resets the status of the buttons and the more indicator, if scrolling was caused
 * by item navigation
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onTabNavigate"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onTabNavigate"]++; }; 
	
	var oSource = UCF_DomUtil["oGetActiveElement"](),
		oItem = UCF_DomUtil["oGetCTElement"](oSource);

	if (oItem && oItem["getAttribute"]('ct') === 'TSITM') {
		this["setNextButton"]();
		this["setPreviousButton"]();
		this["setMoreIndicator"](null);
		if (this["sScrollDirection"] != null)
			this["fireScroll"](this["sId"], this["aItems"][this["iFirstVisibleItemIdx"]]["sId"], this["sScrollDirection"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onTabNavigate"] = 0; };

/**
 * Handles the onclick event of the browser
 * for the buttons and the item menu
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TabStrip_ie6.js(624): onclick"); };

	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource === this["oNextButton"] && oSource["className"]["indexOf"]('Dsbl') === -1) {
		this["nextPage"]();
	} else if ((oSource === this["oPreviousButton"] || oSource === this["oPreviousLeftButton"]) && oSource["className"]["indexOf"]('Dsbl') === -1) {
		this["previousPage"]();
	} else if (oSource === this["oMenuButton"]) {
		if (!this["oItemMenu"]) {
			//create the popupmenu
			var sMenuId = oSource["getAttribute"]('menuid');
			if (!sMenuId) return;
			this["oItemMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](sMenuId);
			this["oItemMenu"]["setOpenerRef"](oSource);
			this["oItemMenu"]["setOpenerId"](this["sId"]);
			this["oItemMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
		}
	
		this["oItemMenu"]["attachEvent"](this["oItemMenu"]["E_EVENTS"]["Select"], this, 'onMenuItemSelect');
		this["oItemMenu"]["attachEvent"](this["oItemMenu"]["E_EVENTS"]["Close"], this, 'onMenuClose');
		this["oItemMenu"]["bFirstVisibleItemIndex"] = 0;
	
		if (this["oItemMenu"]["bOpened"]) {
			this["oItemMenu"]["close"]();
		} else {
    		
			this["oItemMenu"]["open"]();
    		
			var oMenuItems = this["oItemMenu"]["aItems"];
			for (var i = 0; i < oMenuItems["length"]; i++) {
				if (oMenuItems[i]["bChecked"] && i !== this["iCurrentIndex"]) oMenuItems[i]["setChecked"](false);
			}
			this["oItemMenu"]["aItems"][this["iCurrentIndex"]]["setChecked"](true);
			this["bMenuOpened"] = true;
		}
	}
	oBrowserEvent["cancelBubble"]();
	
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onclick"] = 0; };

/**
 * Handle hotkey events
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlshotkey"]++; }; 

	var oSelectedItem = this["aItems"][this["iCurrentIndex"]];

	if (oSelectedItem["sHotkeysId"] === '') return;

	var oHotkeys = this["oGetControlById"](oSelectedItem["sHotkeysId"]);
	if (oHotkeys == null) return;
	
	var oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {	
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
			oBrowserEvent["cancel"]();			
		}
		oBrowserEvent["cancelBubble"](); 
		
		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oSelectedItem["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
			
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlshotkey"] = 0; };

UCF_TabStrip_ie6["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onkeypress"]++; }; 

	if (UCF_ClassLoader["oGetClass"]('UCF_Hotkeys')["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();			
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onkeypress"] = 0; };

/**
 * Scroll the selected tab into view
 *
 * @param {boolean} bFireEvent
 * @private
 */
UCF_TabStrip_ie6["prototype"]["scrollSelectedTabIntoView"] = function(bFireEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["scrollSelectedTabIntoView"]++; }; 
	var oSelected = this["aItems"][this["iCurrentIndex"]];

	if (!this["bScrollable"] || oSelected["oDomRef"]["offestTop"] === this["oScrollDomRef"]["scrollTop"]) return;
	
	this["oScrollDomRef"]["scrollTop"] = oSelected["oDomRef"]["offsetTop"];
	
	if (bFireEvent) {
		this["oFirstVisibleItem"] = this["oGetFirstVisibleItem"]();
		this["iFirstVisibleItemIdx"] = this["oGetFirstVisibleItem"]()["iIndex"];
		this["setClientProperty"]("FirstVisibleItemIdx", this["iFirstVisibleItemIdx"], true);
		this["fireScroll"](this["sId"], this["oFirstVisibleItem"]["sId"], this["sScrollDirection"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["scrollSelectedTabIntoView"] = 0; };

/**
 * Update more indicator button
 *
 * @param {UCF_TabstripItem} oItem
 * @private
 */
UCF_TabStrip_ie6["prototype"]["setMoreIndicator"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setMoreIndicator"]++; }; 

	var oNewFirst = (oItem != null) ? oItem : this["oGetFirstVisibleItem"](),
		oOldFirst = this["oOldFirst"],
		sTabPosition = (this["sTabItemsPosition"] === 'BOTTOM') ? 'Btm' : '',
		sStyleVersion = (this["sTabItemsPosition"] === 'BOTTOM') ? '' : '2';
	
	//remove the more indicator on the first tab and apply the correct style
	if (oOldFirst != null && oOldFirst["iIndex"] !== 0) {
		
		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
		if (oOldFirst["iIndex"] === this["iCurrentIndex"])
			oOldFirst["oDomRef"]["firstChild"]["className"] = 'lsTbs' + sTabPosition + 'Start' + sStyleVersion + 'Sel';
		else if (oOldFirst["iIndex"] === this["iCurrentIndex"] + 1)
			oOldFirst["oDomRef"]["firstChild"]["className"] = 'lsTbs' + sTabPosition + 'StartEnd' + sStyleVersion + 'Sel';
		else 
			oOldFirst["oDomRef"]["firstChild"]["className"] = 'lsTbs' + sTabPosition + 'Start' + sStyleVersion;
	}
	
	//set the more indicator on the first tab
	if (oNewFirst["iIndex"] > 0) {		
		if (oNewFirst["iIndex"] === this["iCurrentIndex"])
			oNewFirst["oDomRef"]["firstChild"]["className"] = 'lsTbs' + sTabPosition + 'FirstMore' + sStyleVersion + 'Sel';
		else
			oNewFirst["oDomRef"]["firstChild"]["className"] = 'lsTbs' + sTabPosition + 'FirstMore' + sStyleVersion;
	}
	
	this["oOldFirst"] = oNewFirst;
	this["iFirstVisibleItemIdx"] = oNewFirst["iIndex"];
	this["setClientProperty"]("FirstVisibleItemIdx", this["iFirstVisibleItemIdx"], true);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setMoreIndicator"] = 0; };

/**
 * Gets the first item in the previous, invisible line
 * 
 * @param {boolean} bCheckDisabled
 * @return {UCF_TabstriItem}
 * @private
 */
UCF_TabStrip_ie6["prototype"]["oGetFirstInPreviousLine"] = function(bCheckDisabled) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["oGetFirstInPreviousLine"]++; }; 
	if (typeof(bCheckDisabled) === 'undefined') {
		bCheckDisabled = false;
	}
	var oItem = this["aItems"][this["iFirstVisibleItemIdx"]]["oDomRef"],
		iRefTop = oItem["offsetTop"] - oItem["offsetHeight"],
		aItems = this["aItems"],
		oReturnItem, iPrevItemIndex;
	// for Standards, sometimes the offsetTop is 1px bigger; for iPad is even bigger
	for (var i = 0; i < aItems["length"]; i++) {
		if (this["aItems"][i]["oDomRef"]["offsetTop"] === iRefTop || Math["abs"](this["aItems"][i]["oDomRef"]["offsetTop"] - iRefTop) < 5) {
			oReturnItem = this["aItems"][i];
			break;
		}	
	}		
	if (typeof(oReturnItem) === 'undefined') {
		oReturnItem = this["aItems"][this["aItems"]["length"] - 1];
	}

	while (!oReturnItem["bEnabled"] && !window["UCF_System"]["bIs508"] && bCheckDisabled) {
		iPrevItemIndex = oReturnItem["iIndex"];
		iPrevItemIndex = (iPrevItemIndex === 0 ? this["aItems"]["length"] - 1 : iPrevItemIndex - 1);
		
		oReturnItem = this["aItems"][iPrevItemIndex];
	}
	return oReturnItem;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["oGetFirstInPreviousLine"] = 0; };

/**
 *  When the tab isCloseable, the last visible item has no space between
 *  close image and ens of the tab
 *  Add some padding for the last item
 *  CSN 2622211 2010
 */
UCF_TabStrip_ie6["prototype"]["setPaddingLastVissible"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setPaddingLastVissible"]++; }; 
	var oItem = this["oGetLastVisibleItem"]();
	if (oItem != null) {
		var firstChildSpan = UCF_DomUtil["lastChild"](oItem["oDomRef"], 'SPAN');
		if (firstChildSpan) {
			var paddingRight = firstChildSpan["style"]["paddingRight"];
			if (paddingRight === '0px') {
				firstChildSpan["style"]["paddingRight"] = '4px';
			}	
		}	
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setPaddingLastVissible"] = 0; };

/**
 * Gets the first item in the next, invisible line
 * 
 * @param {boolean} bCheckDisabled
 * @return {UCF_TabstripItem}
 * @private
 */
UCF_TabStrip_ie6["prototype"]["oGetFirstInNextLine"] = function(bCheckDisabled) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["oGetFirstInNextLine"]++; }; 
	if (typeof(bCheckDisabled) === 'undefined') {
		bCheckDisabled = false;
	}
	var oItem = this["oGetLastVisibleItem"]();
	var iFirstLine = (oItem && oItem["iIndex"] + 1 < this["aItems"]["length"] ? oItem["iIndex"] + 1 : 0),
		oFirstLineItem = this["aItems"][iFirstLine];

	while (!oFirstLineItem["bEnabled"] && !window["UCF_System"]["bIs508"] && bCheckDisabled) {
		iFirstLine = (oFirstLineItem && oFirstLineItem["iIndex"] + 1 < this["aItems"]["length"] ? oFirstLineItem["iIndex"] + 1 : 0);
		oFirstLineItem = this["aItems"][iFirstLine];
	}
	
	return oFirstLineItem;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["oGetFirstInNextLine"] = 0; };

/**
 * Gets the first currently visible item of the tabstrip
 * 
 * @param {boolean} bCheckDisabled
 * @return {UCF_TabstripItem}
 * @private
 */
UCF_TabStrip_ie6["prototype"]["oGetFirstVisibleItem"] = function(bCheckDisabled) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["oGetFirstVisibleItem"]++; }; 
	if (typeof(bCheckDisabled) === 'undefined') {
		bCheckDisabled = false;
	}

	var aItems = this["aItems"],
		oItem, iFirstVisible;
	for (var i = 0; i < aItems["length"]; i++) {
		if (this["bIsHidden"](this["aItems"][i]["oDomRef"])) continue;

		oItem = aItems[i];
		iFirstVisible = i;
		break; 
	}
	while (oItem && !oItem["bEnabled"] && !window["UCF_System"]["bIs508"] && bCheckDisabled) {
		iFirstVisible = (oItem && oItem["iIndex"] + 1 < this["aItems"]["length"] ? oItem["iIndex"] + 1 : 0);
		oItem = this["aItems"][iFirstVisible];
	}
	return oItem;
	
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["oGetFirstVisibleItem"] = 0; };
/**
 * Gets the last currently visible item of the tabstrip
 * 
 * @param {boolean} bCheckDisabled
 * @return {UCF_TabstripItem}
 * @private
 */
UCF_TabStrip_ie6["prototype"]["oGetLastVisibleItem"] = function(bCheckDisabled) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["oGetLastVisibleItem"]++; }; 
	if (typeof(bCheckDisabled) === 'undefined') {
		bCheckDisabled = false;
	}
	var aItems = this["aItems"],
		oItem, iLastVisible;
	for (var i = aItems["length"] - 1; i >= 0; i--) {
			
		if (this["bIsHidden"](this["aItems"][i]["oDomRef"])) continue;
	
		oItem = aItems[i];
		break;		
	}
	while (!oItem["bEnabled"] && !window["UCF_System"]["bIs508"] && bCheckDisabled) {
		iLastVisible = (oItem && oItem["iIndex"] - 1 >= 0 ? oItem["iIndex"] - 1 : this["aItems"]["length"] - 1);
		oItem = this["aItems"][iLastVisible];
	}
	return oItem;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["oGetLastVisibleItem"] = 0; };

/**
 * @private
 */
 
UCF_TabStrip_ie6["prototype"]["callInitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["callInitialize"]++; }; 

	var aItems = this["aItems"];
	for (var i = aItems["length"] - 1; i >= 0; i--) {
		this["aItems"][i]["initialize"]();	
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["callInitialize"] = 0; };

/**
 * @private
 * @param {HTMLElement} oTabDomRef
 * @return {boolean}
 */
UCF_TabStrip_ie6["prototype"]["bIsHidden"] = function(oTabDomRef) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["bIsHidden"]++; }; 
	if (this["bScrollable"]) {
		return oTabDomRef["offsetTop"] > this["oScrollDomRef"]["scrollTop"] + this["oScrollDomRef"]["offsetHeight"] / 2
			|| oTabDomRef["offsetTop"] < this["oScrollDomRef"]["scrollTop"] - this["oScrollDomRef"]["offsetHeight"] / 2;
	} else
		return false;
		
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["bIsHidden"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlsnext"]++; }; 
	var oSource = oBrowserEvent["oGetSourceControl"](),
		oLastItem = this["oGetLastVisibleItem"](true);
		
	if (oSource !== oLastItem) return;
	
	this["nextPage"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlsnext"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlsprevious"]++; }; 
	var oSource = oBrowserEvent["oGetSourceControl"](),
		oFirstItem = this["oGetFirstVisibleItem"](true);

	if (oSource !== oFirstItem) return;
	
	this["previousPage"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlsprevious"] = 0; };

/**
 * Scroll to previous page
 * 
 * @private
 */
UCF_TabStrip_ie6["prototype"]["previousPage"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["previousPage"]++; }; 

	var oItem = this["oGetFirstInPreviousLine"]();
	
	this["oScrollDomRef"]["scrollTop"] = oItem["oDomRef"]["offsetTop"];
	this["setMoreIndicator"](oItem);
	
	this["sScrollDirection"] = 'BACKWARD';
	this["setPreviousButton"]();
	this["setNextButton"]();
	this["resetVisibility"]();
	//this.setPaddingLastVissible();
	this["fireScroll"](this["sId"], this["aItems"][this["iFirstVisibleItemIdx"]]["sId"], 'BACKWARD');
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["previousPage"] = 0; };

/**
 * Scroll to next page
 * 
 * @private
 */
UCF_TabStrip_ie6["prototype"]["nextPage"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["nextPage"]++; }; 
	var oItem = this["oGetFirstInNextLine"]();
	this["setMoreIndicator"](oItem);

	this["oScrollDomRef"]["scrollTop"] = oItem["oDomRef"]["offsetTop"];

	this["sScrollDirection"] = 'FORWARD';
	this["setPreviousButton"]();
	this["setNextButton"]();
	this["resetVisibility"]();
	//this.setPaddingLastVissible();
	this["fireScroll"](this["sId"], this["aItems"][this["iFirstVisibleItemIdx"]]["sId"], 'FORWARD');
	
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		this["bIgnoreResizeOnScroll"] = true;
		UCF_JsUtil["delayedCall"](200, this, 'resetIgnoreResizeOnScroll');
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["nextPage"] = 0; };

UCF_TabStrip_ie6["prototype"]["resetIgnoreResizeOnScroll"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["resetIgnoreResizeOnScroll"]++; }; 
	this["bIgnoreResizeOnScroll"] = false;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["resetIgnoreResizeOnScroll"] = 0; };

/**
 * reset the visibility flag for TabItem after navigation
 * 
 * @private
 */
UCF_TabStrip_ie6["prototype"]["resetVisibility"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["resetVisibility"]++; }; 
	var aItems = this["aItems"],
		oItem;
	for (var i = aItems["length"] - 1; i >= 0; i--) {
		oItem = this["aItems"][i]["oDomRef"];
		if (this["aItems"][i]["sVisibility"] === 'VISIBLE') {
			// see incident 1570445065 -> BIBS->Tabstrip in Firefox
			//			if (this.oScrollDomRef.scrollTop === oItem.offsetTop) {
			if (Math["abs"](oItem["offsetTop"] - this["oScrollDomRef"]["scrollTop"]) <= 1) {
				//if (this.bIsHidden(oItem)) {
				oItem["style"]["visibility"] = 'visible';
				//UCF_DomUtil.addClass(oItem, 'lsTbsTransparent');
			} else {
				oItem["style"]["visibility"] = 'hidden';
				//UCF_DomUtil.removeClass(oItem, 'lsTbsTransparent');
				
			}		
		}	
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["resetVisibility"] = 0; };

/**
 * Sets the enabled state of the next button
 * 
 * @private
 */
UCF_TabStrip_ie6["prototype"]["setNextButton"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setNextButton"]++; }; 
	
	if (!this["bScrollable"]) return;

	if (!this["oNextButton"]) return;
	
	var oLastItem = this["oGetLastVisibleItem"](),
		bEnabled = oLastItem["iIndex"] < this["aItems"]["length"] - 1,
		sItemPos = (this["sTabItemsPosition"] === 'BOTTOM') ? 'Btm' : '';
	var sEnabledClassName = 'lsTbs' + sItemPos + 'PageNext',
		sDisabledClassName = 'lsTbs' + sItemPos + 'PageNextDsbl',
		sDisabledDisplClassName = 'lsTbsPgNextDsblDisp',
		sNewClassName = bEnabled ? sEnabledClassName : sDisabledClassName + ' ' + sDisabledDisplClassName;
	UCF_DomUtil["removeClass"](this["oNextButton"], sDisabledClassName);
	UCF_DomUtil["removeClass"](this["oNextButton"], sEnabledClassName);
	UCF_DomUtil["removeClass"](this["oNextButton"], sDisabledDisplClassName);
	UCF_DomUtil["addClass"](this["oNextButton"], sNewClassName);
	
	/* var oLastMoreDomRef = UCF_DomUtil.$(this.sId + '-lastMore'),
		sLastMoreDisplayMode = bEnabled ? 'inline-block':'none',
		oPanel = UCF_DomUtil.$(this.sId + '-panel');
	if (oLastMoreDomRef) {
		oLastMoreDomRef.style.display=sLastMoreDisplayMode;	
		//debugger;		
		if (UCF_UserAgent.bIsGecko()) {
			//debugger;		
			var iLeftPos = oLastItem.oDomRef.offsetLeft + oLastItem.oDomRef.offsetWidth - oPanel.offsetLeft + 3;
			
			oLastMoreDomRef.style.marginTop = '-' +(oLastItem.oDomRef.offsetHeight + oLastItem.oDomRef.clientTop)+ 'px';
			oLastMoreDomRef.style.left= iLeftPos +'px';
		}
		else {
			var iRightPos = oPanel.offsetWidth + oPanel.offsetLeft - (oLastItem.oDomRef.offsetLeft + oLastItem.oDomRef.offsetWidth) - 3;
			oLastMoreDomRef.style.right= iRightPos +'px';
		}
	} */
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setNextButton"] = 0; };

/**
 * Sets the enabled state of the prev button
 * 
 * @private
 */
UCF_TabStrip_ie6["prototype"]["setPreviousButton"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setPreviousButton"]++; }; 
	
	if (!this["bScrollable"]) return;
		
	if (!this["oPreviousButton"] || !this["oPreviousLeftButton"]) return;

	var bEnabled = this["oScrollDomRef"]["scrollTop"] > 0,
		sItemPos = (this["sTabItemsPosition"] === 'BOTTOM') ? 'Btm' : '';
	var sEnabledClassName = 'lsTbs' + sItemPos + 'PagePrev',
		sDisabledClassName = 'lsTbs' + sItemPos + 'PagePrevDsbl',
		sNewClassName = bEnabled ? sEnabledClassName : sDisabledClassName;
	
	UCF_DomUtil["removeClass"](this["oPreviousButton"], sDisabledClassName);
	UCF_DomUtil["removeClass"](this["oPreviousButton"], sEnabledClassName);
	UCF_DomUtil["addClass"](this["oPreviousButton"], sNewClassName);
	
	if (this["oPreviousLeftButton"]) {
		UCF_DomUtil["removeClass"](this["oPreviousLeftButton"], sEnabledClassName);
		if (this["oGetFirstVisibleItem"]()["iIndex"] !== 0) {
			UCF_DomUtil["addClass"](this["oPreviousLeftButton"], sEnabledClassName);
			this["oPreviousLeftButton"]["style"]["visibility"] = 'visible';
		} else {
			UCF_DomUtil["removeClass"](this["oPreviousLeftButton"], sEnabledClassName);
			this["oPreviousLeftButton"]["style"]["visibility"] = 'hidden';
		}
	}
	/*var oFirstMoreDomRef = UCF_DomUtil.$(this.sId + '-firstMore'),
		sFirstMoreDisplayMode = bEnabled ? 'inline-block':'none';
	if (oFirstMoreDomRef) {
		oFirstMoreDomRef.style.display=sFirstMoreDisplayMode;			
	}*/
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setPreviousButton"] = 0; };

/**
 * Handle MenuItemSelect event
 * 
 * @param {UCF_Event} oEvent the event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onMenuItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onMenuItemSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "TabStrip_ie6.js(1108): onMenuItemSelect"); };

	var sItemId = oEvent["oGetParam"]('sItemId');
	if (!sItemId) return;
	
	var oControl = this["oGetControlById"](sItemId),
		oItem = this["aItems"][oControl["iIndex"]];
	
	if (oItem && !oItem["bEnabled"]) return;
	
	this["checkMenuItem"](oItem);
	
	if (this["iCurrentIndex"] !== oItem["iIndex"]) {
		this["fireTabSelect"](this["sId"], oItem["sId"], oItem["iIndex"], -1);
	}
	
	if (this["bClientTabSelect"] && oItem["bClientTabSelect"]) {
		this["setSelectedDesign"](oItem);
	}
	
	if (!this["bScrollable"]) return;	
	this["scrollSelectedTabIntoView"](false);
	this["setPreviousButton"]();
	this["setNextButton"]();
	this["resetVisibility"]();
	//this.setPaddingLastVissible();
	this["setMoreIndicator"](null);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onMenuItemSelect"] = 0; };

/**
 * Checks the selected item and unchecks the previous selected
 * @private
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_ie6["prototype"]["checkMenuItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["checkMenuItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_TabStripItem, "oItem instanceof UCF_TabStripItem", "TabStrip_ie6.js(1143): checkMenuItem"); };
	
	if (this["oItemMenu"]) {
		var oOldMenuItem = this["oItemMenu"]["aItems"][this["iCurrentIndex"]],
			oNewMenuItem = this["oItemMenu"]["aItems"][oItem["iIndex"]];
		oOldMenuItem["setChecked"](false);	
		oNewMenuItem["setChecked"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["checkMenuItem"] = 0; };

/**
 * handles the menu close event
 * 
 * @private
 * @param {UCF_EventObject} oEvent
 */
UCF_TabStrip_ie6["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onMenuClose"]++; }; 

	UCF_DomUtil["focusDomElement"](this["oMenuButton"]);
	this["oItemMenu"]["detachEvent"](this["oItemMenu"]["E_EVENTS"]["Close"], this);
	this["oItemMenu"]["detachEvent"](this["oItemMenu"]["E_EVENTS"]["Select"], this, 'onMenuItemSelect');
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onMenuClose"] = 0; };

/**
 * Handle ItemSelect event
 * 
 * @param {UCF_Event} oEvent the event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onItemSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "TabStrip_ie6.js(1173): onItemSelect"); };

	var oItem = oEvent["oGetParam"]('oItem'),
		oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent'),
		oSourceElement = oBrowserEvent["oGetSource"]();
		
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_TabStripItem, "oItem instanceof UCF_TabStripItem", "TabStrip_ie6.js(1179): onItemSelect"); };

	oBrowserEvent["cancelBubble"](); 
		
	if (!oItem["bEnabled"]) return;

	if (oItem["bEnabled"] 
		&& oItem["bIsClosable"] 
		&& oSourceElement 
		&& oSourceElement["id"]["indexOf"]('-cl') > -1) {
		this["fireTabClose"](this["sId"], oItem["sId"]);
		return;
	} else if (oItem["bEnabled"] && oItem["iIndex"] !== this["iCurrentIndex"]) {
		if (window["UCF_System"]["bIsAria"]) {
			UCF_AriaStateHelper["setSelected"](UCF_DomUtil["$"](oItem["sId"] + '-focus'), true);
			UCF_AriaStateHelper["setSelected"](UCF_DomUtil["$"](this["aItems"][this["iCurrentIndex"]]["sId"] + '-focus'), false);
			UCF_AriaStateHelper["setActivedescendant"](this["oItemNavigation"]["oItemContainer"], oItem["sId"] + '-focus');
		}

		this["fireTabSelect"](this["sId"], oItem["sId"], oItem["iIndex"], -1);
		if (!this["bClientTabSelect"] || !oItem["bClientTabSelect"]) return;
		this["setSelectedDesign"](oItem);
		if (window["UCF_System"]["bIs508"]) {
			var oActiveElement = UCF_DomUtil["oGetActiveElement"]();
			if (oActiveElement) UCF_DomUtil["refocusDomElement"](oActiveElement);
		}

		return;
	}
	
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onItemSelect"] = 0; };

/**
 * Selects a Tab
 * 
 * @param {UCF_TabStripItem} oItem the tab item to select
 * @private
 */
UCF_TabStrip_ie6["prototype"]["setSelectedDesign"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setSelectedDesign"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_TabStripItem, "oItem instanceof UCF_TabStripItem", "TabStrip_ie6.js(1219): setSelectedDesign"); };

	var aItems = this["aItems"],
		oNewTab = oItem["oDomRef"],
		iSelectedIndex = this["iCurrentIndex"],
		oOldTab = aItems[iSelectedIndex]["oDomRef"],
		iFirstItemIndex = (this["iFirstVisibleItemIdx"] >= 0) ? this["iFirstVisibleItemIdx"] : 0,
		sTabPosition = this["sTabItemsPosition"] === 'BOTTOM' ? 'Btm' : '',
		sStyleVersion = this["sTabItemsPosition"] === 'BOTTOM' ? '' : '2',
		sStyleLabel = this["sTabItemsPosition"] === 'BOTTOM' ? 'Label' : 'Label2',
		oCloseIcon;
		
	//all styles of the previously selected tab
	oOldTab["className"] = oOldTab["className"]["replace"]('Sel', '');
	
	//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	oOldTab["firstChild"]["className"] = oOldTab["firstChild"]["className"]["replace"]('Sel', '');
	
	//TODO: replace by UCF_DomUtil.lastChild(this.oDomRef) to avoid problems with text node
	oOldTab["lastChild"]["className"] = oOldTab["lastChild"]["className"]["replace"](sStyleLabel + 'Sel', sStyleLabel);
	if (iSelectedIndex < aItems["length"] - 1 && iFirstItemIndex !== iSelectedIndex + 1)
		aItems[iSelectedIndex + 1]["oDomRef"]["firstChild"]["className"] = 'lsTbs' + sTabPosition + 'Start' + sStyleVersion;
	
	if (aItems[iSelectedIndex]["bIsClosable"]) {
		oCloseIcon = UCF_DomUtil["$"](aItems[iSelectedIndex]["sId"] + '-close');
		UCF_DomUtil["removeClass"](oCloseIcon, 'lsTbsCloseIcon');
		if (!UCF_DomUtil["bHasClass"](oCloseIcon, 'lsTbsClose')) {
			UCF_DomUtil["addClass"](oCloseIcon, 'lsTbsClose');
		}
	}
	
	//all styles of the new selcted tab
	if (this["bScrollable"]) {
		oNewTab["className"] = oNewTab["className"] + 'Sel';
	}
	
	//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
	oNewTab["firstChild"]["className"] = oNewTab["firstChild"]["className"] + 'Sel';

	if (oItem["bEnabled"]) {
		//TODO: replace by UCF_DomUtil.lastChild(this.oDomRef) to avoid problems with text node
		oNewTab["lastChild"]["className"] = oNewTab["lastChild"]["className"] + 'Sel';
	} else {
		oNewTab["lastChild"]["className"] = oNewTab["lastChild"]["className"]["replace"]('Dsbl', '') + 'SelDsbl';
	}
	
	if (oItem["iIndex"] < aItems["length"] - 1)
		aItems[oItem["iIndex"] + 1]["oDomRef"]["firstChild"]["className"] = 'lsTbs' + sTabPosition + 'StartEnd' + sStyleVersion + 'Sel';
	
	if (oItem["bIsClosable"]) {
		oCloseIcon = UCF_DomUtil["$"](oItem["sId"] + '-close');
		UCF_DomUtil["removeClass"](oCloseIcon, 'lsTbsClose');
		if (!UCF_DomUtil["bHasClass"](oCloseIcon, 'lsTbsCloseIcon')) {
			UCF_DomUtil["addClass"](oCloseIcon, 'lsTbsCloseIcon');
		}
	}
	
	this["hideContent"](aItems[iSelectedIndex]);
	this["showContent"](aItems[oItem["iIndex"]]);
	this["iCurrentIndex"] = oItem["iIndex"];
	this["setClientProperty"]("CurrentIndex", this["iCurrentIndex"], true);
	if (aItems[iSelectedIndex]["sDefaultButtonId"]) {
		this["setDefaultButtonId"](aItems[oItem["iIndex"]]["sDefaultButtonId"]);
		this["oLS"]["highlightDefaultButton"](this["sActiveDefaultButtonId"]);
	}

	// Notify framework, that layout has changed after switching the tab
	this["notifyLayoutChangeFrom"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setSelectedDesign"] = 0; };

/**
 * Hides the content of the tab with the index iIndex
 * 
 * @private
 * 
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_ie6["prototype"]["hideContent"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["hideContent"]++; }; 

	var oContent = UCF_DomUtil["$"](oItem["sId"] + '-cnt');
	
	if (oContent === null) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Cannot find content - with ID ' + oItem["sId"] + '-cnt', "TabStrip_ie6.js(1301): hideContent"); };
		return;
	}
	
	oContent["style"]["height"] = '1px';
	oContent["style"]["width"] = '1px';
	
	if (window["UCF_System"]["bIsRTL"] === false && !UCF_UserAgent["bIsWebKit"]() && window["UCF_System"]["sDevice"] !== 'standards') {
		oContent["style"]["position"] = 'absolute';
		oContent["style"]["top"] = '-10000px';
		// D039230 - CSN 1909557 2011
		// oContent.style.left = '-10000px';
		oContent["style"]["visibility"] = 'hidden';
	} else {
		oContent["style"]["display"] = 'none';
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["hideContent"] = 0; };

/**
 * Shows the content of the tab with the index iIndex
 * 
 * @private
 * 
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_ie6["prototype"]["showContent"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["showContent"]++; }; 
	
	var oContent = UCF_DomUtil["$"](oItem["sId"] + '-cnt');

	if (oContent === null) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Cannot find content - with ID ' + oItem["sId"] + '-cnt', "TabStrip_ie6.js(1331): showContent"); };
		return;
	}	
	
	if (window["UCF_System"]["bIsRTL"] === false && !UCF_UserAgent["bIsWebKit"]() && window["UCF_System"]["sDevice"] !== 'standards') {
		oContent["style"]["visibility"] = 'visible';
		oContent["style"]["position"] = 'static';
	} else {
		oContent["style"]["display"] = '';
	}
	oContent["style"]["height"] = '100%';
	oContent["style"]["width"] = '100%';
	
	if (window["UCF_System"]["sDevice"] === 'standards' && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
		try {
			var oTabContent = UCF_DomUtil["$"](this["sId"] + '-cnt');
			if (oTabContent) {
				var sStyleHeight = oTabContent["style"]["height"];
				if (sStyleHeight && sStyleHeight["indexOf"]('%') > -1)
					oTabContent["style"]["height"] = '100%';
				//_trace(INFO, '================================== TabStrip -  showContent ' + oTabStripCnt.style.height );
			}			
		} catch (e) {}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["showContent"] = 0; };

/**
 * Create tab strip item controls
 * @private
 */
UCF_TabStrip_ie6["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["createItems"]++; }; 
	
	this["aItems"] = [];
	// Avoid NPEx when the tabs are not found
	var oTabStrip = UCF_DomUtil["$"](this["sId"] + '-panel');
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oTabStrip != null, "oTabStrip != null", "TabStrip_ie6.js(1366): createItems"); };
	if (!oTabStrip) return;
	
	var aDomItems = oTabStrip["childNodes"];
	for (var iItemCount = 0; iItemCount < aDomItems["length"]; iItemCount++) {
		var oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[iItemCount], true);

		if (!UCF_JsUtil["bInstanceOf"](oItem, 'UCF_TabStripItem_ie6')) continue;
		if (window["UCF_System"]["sDevice"] === 'standards' && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && oItem["bHasToolbar"] && oItem["iIndex"] === this["iCurrentIndex"]) {
			var oTabToolbar = UCF_DomUtil["$"](oItem["sId"] + '-tabTbar');
			if (oTabToolbar) {
				oTabToolbar["style"]["height"] = oTabToolbar["offsetHeight"] + 'px';
			}
		}
		this["aItems"]["push"](oItem);
		if (oItem["bEnabled"] || window["UCF_System"]["bIs508"]) {
			this["oItemNavigation"]["addItem"](oItem, oItem["iIndex"] === this["iCurrentIndex"]);
		}
	}
	
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["createItems"] = 0; };

/**
 * Skip to the next control
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control 
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlsskipback"] = 0; };

/**
 * Sets the correct acc text
 * 
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_ie6["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlsaccessibility"]++; }; 	
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TabStrip_ie6.js(1417): onlsaccessibility"); };
	
	if (!window["UCF_System"]["bIs508"]) return;
	
	var oSource = oBrowserEvent["oGetSourceControl"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (UCF_JsUtil["bInstanceOf"](oSource, 'UCF_TabStripItem')) {
	
		if (this["sTabItemsPosition"] === 'TOP') {
			oAccessibilityHelper["setControlType"]('TS');
			oAccessibilityHelper["applyContainerEntryBehaviour"]();
		} else {
			oAccessibilityHelper["setControlType"]('TSB');
			oAccessibilityHelper["addTutor"]('TSB_TUT');
		}
		
		if (!UCF_StringUtil["bIsEmpty"](this["sAccessibilityDescription"])) {
			oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);
		}
		
		oAccessibilityHelper["setEnabled"](oSource["bEnabled"]);
		
		if (!UCF_StringUtil["bIsEmpty"](oSource["sTooltip"])) {
			oAccessibilityHelper["setTooltip"](oSource["sTooltip"]);
		}
		
		var sCapt = oSource["oDomRef"]["captt"];

		if (oSource["bHasTitleCaption"] && sCapt != null && !UCF_StringUtil["bIsEmpty"](sCapt)) {
			oAccessibilityHelper["addTooltip"](sCapt);			
		}
		
		oAccessibilityHelper["setAccessKey"](oSource["sAccessKey"]);
		oAccessibilityHelper["setText"](oSource["sCaption"]);
		oAccessibilityHelper["setItemCount"](this["oItemNavigation"]["aItems"]["length"]);
		oAccessibilityHelper["setItemIndex"](oSource["iIndex"] + 1);
		if (oSource["iIndex"] !== this["iCurrentIndex"] && oSource["bEnabled"]) oAccessibilityHelper["addTutor"]('SELECT_TUT');
		oAccessibilityHelper["setSelected"](oSource["iIndex"] === this["iCurrentIndex"]);
		oAccessibilityHelper["addTutor"]('LRNAV_TUT');
		if (oSource["bIsClosable"] && oSource["bEnabled"]) {
			oAccessibilityHelper["addTutor"]('TS_ITM_CLOSE');
		}
	} else if (oBrowserEvent["oGetSource"]()["id"]["indexOf"]('-end') > -1 && oSource === this) {
		oAccessibilityHelper["setControlType"]('TS_END');
	} else if (oBrowserEvent["oGetSource"]()["id"]["indexOf"]('-start') > -1 && oSource === this) {
		oAccessibilityHelper["setControlType"]('TSB');
		oAccessibilityHelper["addTutor"]('TSB_START_SI', [oAccessibilityHelper["sGetSkipContainerText"]()]);
		oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](this["oItemNavigation"]["aItems"][this["iCurrentIndex"]]["oDomRef"]));
	} 
	
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["onlsaccessibility"] = 0; };

/**
 * implements method from UCF_Control
 * @private
 */
UCF_TabStrip_ie6["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["createDragDelegate"]++; }; 

	if (!this["sDragSourceInfo"])
		return;
	
	if (this["oDragDelegate"])
		return;
	
	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_TabStripDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);
	
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["createDragDelegate"] = 0; };

/**
 * implements method from UCF_Control
 * @private
 */
UCF_TabStrip_ie6["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["createDropDelegate"]++; }; 

	if (!this["sDropTargetInfo"])
		return;
	
	if (this["oDropDelegate"])
		return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_TabStripDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);
	
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["createDropDelegate"] = 0; };

/**
 * recalculate the height of the given oDomRef element
 * only for IE & Standards
 * @private
 */
UCF_TabStrip_ie6["prototype"]["correctTabStripHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["correctTabStripHeight"]++; }; 
	if (!UCF_DomUtil["bCheckStandardsCorrection"]())
		return;
	
	if (this["sHeight"] !== '' && !(this["sHeight"]["indexOf"]('px') > -1 || this["sHeight"]["indexOf"]('%') > -1))
		return;
	//debugger;
	var sTabStripHeight = this["sHeight"],
		iParentHeight = this["iGetParentHeight"](),
		iDomRefHeight = 0;
	if (iParentHeight !== 0) {
		iDomRefHeight = iParentHeight;
		sTabStripHeight = iParentHeight + 'px';
	} else {
		iDomRefHeight = this["oDomRef"]["offsetHeight"];
	}
	if (this["iDomRefHeight"] === this["oDomRef"]["offsetHeight"]) return;
	var oHeaderTabs = UCF_DomUtil["$"](this["sId"] + '-panel'),
		iFixHeight = oHeaderTabs["offsetHeight"] - 3,
		oTabStripCnt = UCF_DomUtil["$"](this["sId"] + '-cnt'),
		bIsPXUnit = (sTabStripHeight && sTabStripHeight["indexOf"]('px') > -1),
		iTbarFactor = (iDomRefHeight > 220) ? 1 : 2;
	
	if (iDomRefHeight < 2 * iFixHeight) {
		//_trace(INFO, 'oTbarContent -iFixHeight height ' + iFixHeight);
		//something is wrong, no calculation will be done
		oTabStripCnt["style"]["height"] = '92%';
	} else {
		if (this["iCurrentIndex"] !== -1) {
			try {
				var sId = this["aItems"][this["iCurrentIndex"]]["sId"],
					oTbarContent = UCF_DomUtil["$"](sId + '-tabTbar');
				if (oTbarContent) {
					iFixHeight += bIsPXUnit ? oTbarContent["offsetHeight"] : Math["floor"](oTbarContent["offsetHeight"] * iTbarFactor);
					//_trace(INFO, 'oTbarContent -iFixHeight height ' + iFixHeight);
				}
									
			} catch (e) {}
		}
		
		if (bIsPXUnit) {
			iFixHeight += 7; // the line between tabs & content
			var iTabstripHeight = parseInt(sTabStripHeight);
			oTabStripCnt["style"]["height"] = (iTabstripHeight - iFixHeight) + 'px';
		} else {
		
			oTabStripCnt["style"]["height"] = Math["floor"](99 - (iFixHeight * 100 / iDomRefHeight)) + '%';
			//_trace(INFO, '== TabStripId - ' + this.sId + ' - OffsetHeight - ' + iDomRefHeight + 'px - FixedHeight - ' +  iFixHeight + 'px - ContentHeight - ' +  oTabStripCnt.style.height );
		}
	}
	this["iDomRefHeight"] = this["oDomRef"]["offsetHeight"]; 		

};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["correctTabStripHeight"] = 0; };
/**
 * @private
 * @return {integer}
 */
UCF_TabStrip_ie6["prototype"]["iGetParentHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["iGetParentHeight"]++; }; 

	var oParentDomRef = this["oDomRef"]["parentNode"];
	if (UCF_DomUtil["bIsCTInstanceOf"](oParentDomRef, 'RLI')) {
		return oParentDomRef["clientHeight"];		
	}
	return 0;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["iGetParentHeight"] = 0; };

/**
 * Sets the visibility state of the TabStrip control.
 * @param {string} sVisibility
 * @public
 */
UCF_TabStrip_ie6["prototype"]["setVisibility"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setVisibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sVisibility) === 'string', "typeof(sVisibility) === 'string'", "TabStrip_ie6.js(1582): setVisibility"); };
		
	UCF_DomUtil["setVisibility"](this["oDomRef"], sVisibility);
	this["sVisibility"] = sVisibility;
	this["setClientProperty"]("Visibility", this["sVisibility"], true);
	this["onAfterResize"]();
	
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["setVisibility"] = 0; };

/**
 * Gets the TabStripItem by given sTabItenId
 *
 * it also might return null or undefined in case that the sTabItenId is invalid
 * @private
 * @param {string} sTabItenId
 * @return {UCF_TabstripItem}
 */
UCF_TabStrip_ie6["prototype"]["oGetItemById"] = function(sTabItenId) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["oGetItemById"]++; }; 
	if (typeof(sTabItenId) === 'undefined') {
		return null;
	}
	var aItems = this["aItems"],
		oItem;
	for (var i = 0; i < aItems["length"]; i++) {
		oItem = aItems[i];
		if (oItem["sId"] === sTabItenId) {
			break; 
		}	
	} 	
	return oItem;
	 
};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["oGetItemById"] = 0; };

/**
 * Select the TabStripItem with the given Id for the TabStrip.
 * @param {string} sTabStripItemId - identifier of the TabStripItem that is to be selected.
 * @public
 */
UCF_TabStrip_ie6["prototype"]["selectTabStripItem"] = function(sTabStripItemId) {;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["selectTabStripItem"]++; }; 

	var oItem = this["oGetItemById"](sTabStripItemId);
	if (oItem || oItem != null) {
		if (this["iCurrentIndex"] !== oItem["iIndex"]) {
			this["fireTabSelect"](this["sId"], oItem["sId"], oItem["iIndex"], -1);
		}

		this["setSelectedDesign"](oItem);
		this["oItemNavigation"]["setFocusedIndex"](oItem["iIndex"]);
		
		UCF_DomUtil["setTabIndex"](oItem["oFocusDomRef"], 0);
		oItem["moveFocus"]();
	}

};;if (__UCF_COVERAGE__) { UCF_TabStrip_ie6["_"]["selectTabStripItem"] = 0; };

UCF_TabStrip_ie6.prototype["aPublicMethods"] = ["setScrollPosition","getScrollPosition","setVisibility","selectTabStripItem"].concat(UCF_TabStrip_ie6.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TabStrip_standards"] = function() {/* global _assert, _trace, ERROR, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_TabstripDelegate_standards */
/// <reference path="./delegates/TabstripDelegate_standards.js"/>
/* global UCF_TabStripDragDelegate */
/// <reference path="./delegates/TabStripDragDelegate.js"/>
/* global UCF_TabStripDropDelegate */
/// <reference path="./delegates/TabStripDropDelegate.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>
/* global UCF_TabStrip */
/// <reference path="./TabStrip.js"/>
/* global UCF_TabStripItem_standards */
/// <reference path="./TabStripItem_standards.js"/>

/**
 * TabStrip implementation for standards mode.
 *
 * 
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TabStrip_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["UCF_TabStrip_standards"]++; }; 
	/** @type {UCF_TabStrip_standards} */

	UCF_TabStrip["apply"](this, [oDomRef, oLS]);

	// if(this.bIsDestroyed) return;

	this["createGenericFields"]();
	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]);

	this["createItems"]();
	this["createItemNavigation"]();
	this["createSpecificFields"]();

	this["oTabstripDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_TabstripDelegate_standards"))(this["aItems"], this["iCurrentIndex"], this["iVisibilityThreashold"]);
	this["addDelegate"](this["oTabstripDelegate"]);

	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, 'onLayoutChange');

	if (this["bScrollable"])
		this["attachBrowserEvent"]('resize', this["oDomRef"]);

	// init the default button
	if (this["aItems"] && this["aItems"]["length"] > 0 && this["aItems"][this["iSelected"]]["sDefaultButtonId"] && this["aItems"][this["iSelected"]]["sDefaultButtonId"] !== '')
		this["setDefaultButtonId"](this["aItems"][this["iSelected"]]["sDefaultButtonId"]);

	//focusDomRef of the selected TabIndex
	if (this["aItems"] && this["aItems"]["length"] > 0 && this["aItems"][this["iSelected"]])
		this["oFocusDomRef"] = this["aItems"][this["iSelected"]]["oDomRef"]["firstChild"];
};window["UCF_TabStrip_standards"] = UCF_TabStrip_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TabStrip_standards"); UCF_TabStrip_standards["_"] = {UCF_TabStrip_standards: 0}; }; ;
UCF_TabStrip_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_TabStrip"))(); UCF_TabStrip_standards.prototype["sClassName"] = "UCF_TabStrip_standards";

/**
 * ############################################################
 *
 * Everything that needs do be done during initialization
 *
 * ############################################################
 * **
 * Creates all static variables necessary
 * @private
 */
UCF_TabStrip_standards["prototype"]["createGenericFields"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createGenericFields"]++; }; 
	this["oOldFirst"] = null;
	this["iSelected"] = this["iCurrentIndex"];
	this["iWidthBeforeResize"] = this["oDomRef"]["offsetWidth"];
	this["oPanel"] = UCF_DomUtil["$"](this["sId"] + '-panel');
	this["bTabStylesCleaned"] = false;
	this["iVisibilityThreashold"] = 0;
	this["oMoreIndicatorItem"] = null;
	this["bHasInvisibleItems"] = false;
	this["sFocusType"] = 'NAVIGATION';
	this["oAFId"] = null;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createGenericFields"] = 0; };

UCF_TabStrip_standards["prototype"]["eFocusType"] = {
	"NAVIGATION": 'NAVIGATION',
	"REFOCUSED": 'REFOCUSED'
};

/**
 * Creates all static variables necessary for a specific purpose
 * @private
 */
UCF_TabStrip_standards["prototype"]["createSpecificFields"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createSpecificFields"]++; }; 
	if (!this["bScrollable"] || !this["aItems"] || this["aItems"]["length"] < 2) return;

	// The action items
	var oPreviosButton = UCF_DomUtil["$"](this["sId"] + '-prev');

	this["oPreviousButton"] = UCF_DomUtil["sGetCurrentStyle"](oPreviosButton, 'display') === 'none' ? UCF_DomUtil["$"](this["sId"] + '-prevLeft') : oPreviosButton;
	this["oNextButton"] = UCF_DomUtil["$"](this["sId"] + '-next');
	this["oMenuButton"] = UCF_DomUtil["$"](this["sId"] + '-menu');
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createSpecificFields"] = 0; };

/**
 * Creates the delegate necessary for focus navigation
 * @private
 */
UCF_TabStrip_standards["prototype"]["createItemNavigation"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createItemNavigation"]++; }; 

	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Select"], this, 'onTabItemAccess');
	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Activate"], this, 'onTabItemActivate');

	if (this["aItems"]["length"] > 0) {
		this["oItemNavigation"]["oItemContainer"] = this["oPanel"];
		this["setDefaultButtonId"](this["aItems"][this["iSelected"]]["sDefaultButtonId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createItemNavigation"] = 0; };

/**
 * Creates an array with all items necessary for focus navigation
 * @private
 */
UCF_TabStrip_standards["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createItems"]++; }; 

	var self = this;

	this["aItems"] = UCF_JsUtil["reduce"](UCF_JsUtil["arrayFrom"](this["oPanel"]["childNodes"]), function(aItems, oItemRef) {
		var oItem = self["oLS"]["oControlFactory"]["oGetControlByDomRef"](oItemRef, true);

		if (UCF_JsUtil["bInstanceOf"](oItem, 'UCF_TabStripItem_standards')) {
			aItems["push"](oItem);
			if (oItem["bEnabled"] || window["UCF_System"]["bIs508"] || window["UCF_System"]["bIsAria"]) {

				if (oItem["sVisibility"] === 'VISIBLE') {
					self["oItemNavigation"]["addItem"](oItem, oItem["iIndex"] === self["iSelected"]);
				}

				if (oItem["sVisibility"] !== 'VISIBLE') {
					self["oItemNavigation"]["updateSelectedIndex"](self["iSelected"]);
				}
			}
		}

		return aItems;
	}, []);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createItems"] = 0; };

/**
 * Scrolls the selected item into the view port
 * if it is not visible during the initialization
 * @private
 */
UCF_TabStrip_standards["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["initialize"]++; }; 

	if (this["aItems"] && this["aItems"]["length"] > 1 && this["bScrollable"]) {

		if (this["bIsInNextHidden"](this["aItems"][this["iSelected"]])) {
			this["iVisibilityThreashold"] = this["aItems"][this["iSelected"]]["oDomRef"]["offsetTop"];
			this["oPanel"]["scrollTop"] = this["iVisibilityThreashold"];
			this["updateMoreIndicator"]();
		}

		this["updateActionItems"]();
	}

	if (this["aItems"] && this["aItems"]["length"] > 0) {
		this["initVisibilityProperties"]();
	}

	if (this["aItems"] && this["aItems"]["length"] > 1 && this["aItems"][this["iSelected"]] && this["aItems"][this["iSelected"]]["sScrollingMode"] !== 'NONE') {
		this["scrollContent"](this["aItems"][this["iSelected"]]);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["initialize"] = 0; };

/**
 * ########################################################################
 *
 * Section responsible to keep the control working after parts received
 * a different visibility
 *
 * #######################################################################
 **/

/**
 * Handles the update of all item properties whenever the visibility of one
 * item was switched off on the server
 * @private
 */
UCF_TabStrip_standards["prototype"]["initVisibilityProperties"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["initVisibilityProperties"]++; }; 

	var i, n = 0,
		m = 1,
		bItemVisibilityChanged = this["oDomRef"]["getAttribute"]('ItemVisibilityChanged'),
		bStyleChangedFirstItem = false,
		bStyleChangedLastItem = false,
		iLength = this["aItems"]["length"] - 1,
		oContentToShow;

	if (bItemVisibilityChanged === 'false') return;

	this["bHasInvisibleItems"] = true;

	//if the selected tab-item is not visible assign the tabIndex to the first
	//visible item that is enabled
	if (this["aItems"][this["iSelected"]]["sVisibility"] !== 'VISIBLE') {

		oContentToShow = this["oItemNavigation"]["aItems"][0];

		UCF_DomUtil["setTabIndex"](oContentToShow["oFocusDomRef"], 0);
		this["hideContent"](this["aItems"][this["iSelected"]]);
		this["showContent"](oContentToShow);

		this["iSelected"] = oContentToShow["iIndex"];
		this["iCurrentIndex"] = this["iSelected"];
		this["setClientProperty"]("CurrentIndex", this["iSelected"], true);
	}

	for (i = 0; i < this["aItems"]["length"]; i++) {

		//count the visible items so that the figure can be used for ARIA
		if (this["aItems"][i]["sVisibility"] === 'VISIBLE') {
			n++;
		}

		//if the very first item is not visible adjust the styles of the subsequent visible
		//so that it is shown with the styles of the first in the respective themes
		if (this["aItems"][0]["sVisibility"] !== 'VISIBLE' && i > 0 && !bStyleChangedFirstItem) {
			if (this["aItems"][i]["sVisibility"] === 'VISIBLE') {
				this["updateStyles"](this["aItems"][i], 'FIRST');
				bStyleChangedFirstItem = true;
			}
		}

		//if the very last item is not visible adjust the styles of the previous visble
		//so that it is shown with the styles of the last in the respective themes
		if (this["aItems"][iLength]["sVisibility"] !== 'VISIBLE' && i < iLength && !bStyleChangedLastItem) {
			if (this["aItems"][iLength - i]["sVisibility"] === 'VISIBLE') {
				this["updateStyles"](this["aItems"][iLength - i], 'LAST');
				this["aItems"][iLength - i]["oDomRef"]["setAttribute"]('last', 'true');
				bStyleChangedLastItem = true;
			}
		}
	}

	//adapt the ARIA properties to the amount of visible items
	for (i = 0; i < this["aItems"]["length"]; i++) {
		if (this["aItems"][i]["sVisibility"] === 'VISIBLE') {
			UCF_AriaStateHelper["setPosinset"](this["aItems"][i]["oFocusDomRef"], m);
			UCF_AriaStateHelper["setSetsize"](this["aItems"][i]["oFocusDomRef"], n);
			m++;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["initVisibilityProperties"] = 0; };

/**
 * It adjsut the style of visible items that succeed or preceed
 * invisibleso that the still convey the impression of the first
 * or last item
 *
 * @param {UCF_TabstripItem} oItem
 * @param {string} sPosition determines whether the styles of the first or the
 *last item are relevant
 */
UCF_TabStrip_standards["prototype"]["updateStyles"] = function(oItem, sPosition) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateStyles"]++; }; 

	var oStyles = this["aItems"][0]["eStyles"],
		sStatus = (oItem["iIndex"] === this["iCurrentIndex"]) ? 'SELECTED' : 'UNSELECTED',
		sFieldPart = !oItem["bEnabled"] ? 'DISABLED' : sStatus;

	UCF_DomUtil["replaceClass"](oItem["oDomRef"],
		oStyles['ANY_' + sFieldPart],
		oStyles[sPosition + '_' + sFieldPart]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateStyles"] = 0; };

/**
 * ########################################################################
 *
 * Access Key Handling
 *
 * #######################################################################
 **/

UCF_TabStrip_standards["prototype"]["onTabItemActivate"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onTabItemActivate"]++; }; 

	var oItem = oEvent["mParameters"]["oItem"];

	if (!oItem || this["sFocusType"] === this["eFocusType"]["REFOCUSED"]) {
		this["sFocusType"] = this["eFocusType"]["NAVIGATION"];
		return;
	}

	switch (this["sItemScrollPosition"](oItem)) {

		case this["eItemScrollPosition"]["IN_PREVIOUS_HIDDEN"]:
			this["bIsInPreviousHidden"](oItem);
			break;

		case this["eItemScrollPosition"]["IN_NEXT_HIDDEN"]:
			this["scrollNextItemIntoViewport"](oItem);
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onTabItemActivate"] = 0; };

/**
 * ############################################################################
 * SECTION FOR  ACTION BUTTONS ON THE RIGHT. These are
 *
 * SCROLL-LEFT + SCROLL-RIGHT + OPEN-MENU
 *
 * All routines handling the interaction on the panel with the scroll-
 * and menu buttons
 *
 * ############################################################################
 */

/**
 * An enumerations with all actions that can be triggered on click
 * @private
 */
UCF_TabStrip_standards["prototype"]["eAction"] = {
	"SCROLL_TO_PREVIOUS_ITEMS": 'SCROLL_TO_PREVIOUS_ITEMS',
	"SCROLL_TO_NEXT_ITEMS": 'SCROLL_TO_NEXT_ITEMS',
	"OPEN_MENU": 'OPEN_MENU'
};

/**
 * Determines the action that needs to be triggered on click
 * @private
 * @param {BrowserEvent} oBrowserEvent
 * @return {string}
 */
UCF_TabStrip_standards["prototype"]["sButtonDetermineAction"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["sButtonDetermineAction"]++; }; 
	var oButton = oBrowserEvent["oSource"],
		sAction = oButton["getAttribute"]('action');

	return sAction;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["sButtonDetermineAction"] = 0; };

/**
 * Handles the ontouch event on a tablett
 * for the buttons and the item menu
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
// UCF_TabStrip_standards.prototype.onlstouchend = function(oBrowserEvent) {
// 	_assert(oBrowserEvent instanceof UCF_BrowserEvent);

// 	this.onclick(oBrowserEvent);
// 	oBrowserEvent.cancelBubble();
// 	oBrowserEvent.cancel();
// };

/**
 * Handles the onclick event of the browser
 * for the buttons and the item menu
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_standards["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TabStrip_standards.js(383): onclick"); };

	switch (this["sButtonDetermineAction"](oBrowserEvent)) {
		case this["eAction"]["SCROLL_TO_PREVIOUS_ITEMS"]:
			this["scrollToPreviousRowOfItems"]();
			this["updateActionItems"]();
			this["updateMoreIndicator"]();
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			break;

		case this["eAction"]["SCROLL_TO_NEXT_ITEMS"]:
			this["scrollToNextRowOfItems"]();
			this["updateActionItems"]();
			this["updateMoreIndicator"]();
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			break;

		case this["eAction"]["OPEN_MENU"]:
			this["openMenu"](oBrowserEvent);
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onclick"] = 0; };

/**
 * Determines status and visibility of the action items, i.e. scroll button and menu button
 *
 * @private
 */
UCF_TabStrip_standards["prototype"]["updateActionItems"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateActionItems"]++; }; 

	var bFirstItemVisible = this["bFirstItemVisible"](),
		bLastItemVisible = this["bLastItemVisible"](),
		bNextBtnOn = this["oNextButton"]["className"]["indexOf"](this["eStyles"]["NEXT_BTN_ON"]) > -1,
		bPrevBtnOn = this["oPreviousButton"]["className"]["indexOf"](this["eStyles"]["PREV_BTN_ON"]) > -1;

	// Switch between the enabled/disabled i.e. on/off state of the next button
	if (!bLastItemVisible && !bNextBtnOn) {
		UCF_DomUtil["replaceClass"](this["oNextButton"], this["eStyles"]["NEXT_BTN_OFF"], this["eStyles"]["NEXT_BTN_ON"]);
	} else if (bLastItemVisible && bNextBtnOn) {
		UCF_DomUtil["replaceClass"](this["oNextButton"], this["eStyles"]["NEXT_BTN_ON"], this["eStyles"]["NEXT_BTN_OFF"]);
	}

	// Switch between the enabled/disabled i.e. on/off state of the previous button
	if (!bFirstItemVisible && !bPrevBtnOn) {
		UCF_DomUtil["replaceClass"](this["oPreviousButton"], this["eStyles"]["PREV_BTN_OFF"], this["eStyles"]["PREV_BTN_ON"]);
	} else if (bFirstItemVisible && bPrevBtnOn) {
		UCF_DomUtil["replaceClass"](this["oPreviousButton"], this["eStyles"]["PREV_BTN_ON"], this["eStyles"]["PREV_BTN_OFF"]);
	}

	// hide / show the menu button
	if (bFirstItemVisible && bLastItemVisible) {
		UCF_DomUtil["replaceClass"](this["oMenuButton"], this["eStyles"]["MENU_BTN_ON"], this["eStyles"]["MENU_BTN_OFF"]);

		this["oPreviousButton"]["style"]["visibility"] = 'hidden';
		this["oNextButton"]["style"]["visibility"] = 'hidden';
		this["oMenuButton"]["style"]["visibility"] = 'hidden';
	} else if (!bFirstItemVisible || !bLastItemVisible) {
		UCF_DomUtil["replaceClass"](this["oMenuButton"], this["eStyles"]["MENU_BTN_OFF"], this["eStyles"]["MENU_BTN_ON"]);

		this["oPreviousButton"]["style"]["visibility"] = 'visible';
		this["oNextButton"]["style"]["visibility"] = 'visible';
		this["oMenuButton"]["style"]["visibility"] = 'visible';
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateActionItems"] = 0; };

/**
 * Handles the more indicator image in themes that use it.
 *
 * @private
 */
UCF_TabStrip_standards["prototype"]["updateMoreIndicator"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateMoreIndicator"]++; }; 

	var oFirst = this["oGetFirstItemInViewPort"]();
	var sLast = (oFirst["iIndex"] === this["aItems"]["length"] - 1) ? '_LAST' : '';
	var sSelected = (oFirst["iIndex"] === this["iSelected"]) ? '_SELECTED' : '';
	var sEnabled = (oFirst["bEnabled"] === false) ? '_DISABLED' : '';

	if (this["oMoreIndicatorItem"]) {
		this["oMoreIndicatorItem"]["oDomRef"]["className"] = this["oMoreIndicatorItem"]["sItemClass"];
	}

	if (oFirst["iIndex"] > 0) {

		this["oMoreIndicatorItem"] = oFirst;
		this["oMoreIndicatorItem"]["sItemClass"] = oFirst["oDomRef"]["className"];
		if (UCF_DomUtil["bHasClass"](oFirst["oDomRef"], 'lsTbsItem--scrollable'))
			oFirst["oDomRef"]["className"] = 'lsTbsItem--scrollable ' + this["eStyles"]['MORE_INDICATOR' + sLast + sSelected + sEnabled];
		else
			oFirst["oDomRef"]["className"] = this["eStyles"]['MORE_INDICATOR' + sLast + sSelected + sEnabled];
	}

};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateMoreIndicator"] = 0; };
/**#####################################################################################
 *
 *
 * SECTION RESPONSIBLE FOR FOR ALL MENU ACTIONS
 *
 * select stem, scroll item selected through menu in view port, close menu etc.
 *
 * #####################################################################################


/**
 * Opens the associated menu
 *
 * @private
 */

UCF_TabStrip_standards["prototype"]["openMenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["openMenu"]++; }; 

	var oSource = oBrowserEvent["oSource"];

	if (!this["oItemMenu"]) {
		//create the popupmenu
		var sMenuId = oSource["getAttribute"]('menuid');
		if (!sMenuId) return;
		this["oItemMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](sMenuId);
		if (!this["oItemMenu"]) return;
		this["oItemMenu"]["setOpenerRef"](oSource);
		this["oItemMenu"]["setOpenerId"](this["sId"]);
		this["oItemMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
	}

	this["oItemMenu"]["attachEvent"](this["oItemMenu"]["E_EVENTS"]["Select"], this, 'onMenuItemAccess');
	this["oItemMenu"]["attachEvent"](this["oItemMenu"]["E_EVENTS"]["Close"], this, 'onMenuClose');
	this["oItemMenu"]["bFirstVisibleItemIndex"] = 0;

	if (this["oItemMenu"]["bOpened"]) {
		this["oItemMenu"]["close"]();
	} else {

		this["oItemMenu"]["open"]();

		var oMenuItems = this["oItemMenu"]["aItems"];
		for (var i = 0; i < oMenuItems["length"]; i++) {
			if (oMenuItems[i]["bChecked"] && i !== this["iSelected"]) oMenuItems[i]["setChecked"](false);
		}
		this["oItemMenu"]["aItems"][this["iSelected"]]["setChecked"](true);
		this["bMenuOpened"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["openMenu"] = 0; };

/**
 * Handle MenuItemSelect event
 *
 * @param {UCF_Event} oEvent the event object that occurred
 * @private
 */
UCF_TabStrip_standards["prototype"]["onMenuItemAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onMenuItemAccess"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "TabStrip_standards.js(537): onMenuItemAccess"); };

	var sItemId = oEvent["oGetParam"]('sItemId');
	if (!sItemId) return;

	var oMenuItem = this["oGetControlById"](sItemId);
	var oSelectedTab = this["aItems"][oMenuItem["iIndex"]];

	if (this["sEvaluateSelectability"](oSelectedTab) === this["eItemStatus"]["ACCESSIBLE"]) {

		switch (this["sItemScrollPosition"](oSelectedTab)) {

			case this["eItemScrollPosition"]["IN_PREVIOUS_HIDDEN"]:
				this["scrollPreviousItemIntoViewport"](oSelectedTab);
				break;

			case this["eItemScrollPosition"]["IN_NEXT_HIDDEN"]:
				this["scrollNextItemIntoViewport"](oSelectedTab);
				break;
		}

		if (this["bClientTabSelect"]) {
			var oDeselectedTab = this["aItems"][this["iSelected"]];

			this["proceedGenericSelectionSteps"](oSelectedTab, oEvent);
			this["updateActionItems"]();
			this["updateMoreIndicator"]();
			this["updateVisibilityThreshold"](oSelectedTab);
			this["handleMeansOfSelection"](this["eMeansOfSelection"]["CALL"], oSelectedTab, oDeselectedTab);
		}

		this["fireTabSelect"](this["sId"], oSelectedTab["sId"], oSelectedTab["iIndex"], this["oGetFirstItemInViewPort"]()["iIndex"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onMenuItemAccess"] = 0; };

/**
 * Checks the selected item and unchecks the previous selected
 * @private
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_standards["prototype"]["checkMenuItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["checkMenuItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_TabStripItem_standards, "oItem instanceof UCF_TabStripItem_standards", "TabStrip_standards.js(578): checkMenuItem"); };

	if (this["oItemMenu"]) {
		var oOldMenuItem = this["oItemMenu"]["aItems"][this["iSelected"]],
			oNewMenuItem = this["oItemMenu"]["aItems"][oItem["iIndex"]];
		oOldMenuItem["setChecked"](false);
		oNewMenuItem["setChecked"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["checkMenuItem"] = 0; };

/**
 * handles the menu close event
 *
 * @private
 * @param {UCF_BrowserEvent} oEvent
 */
UCF_TabStrip_standards["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onMenuClose"]++; }; 
	UCF_DomUtil["focusDomElement"](this["oMenuButton"]);
	this["oItemMenu"]["detachEvent"](this["oItemMenu"]["E_EVENTS"]["Close"], this);
	this["oItemMenu"]["detachEvent"](this["oItemMenu"]["E_EVENTS"]["Select"], this, 'onMenuItemAccess');
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onMenuClose"] = 0; };

/**#####################################################################################
 *
 * SECTION RESPONSIBLE FOR SCROLLING OF TABS 		#scrolling#
 *
 * SCROLL-LEFT + SCROLL-RIGHT + OPEN-MENU
 *
 * All routines handling the interaction on the panel with the scroll- and menu buttons
 *
 * #####################################################################################*/

/**
 * Generic paging function
 * @private
 * @param {UCF_TabstripItem} oTabItem
 */
UCF_TabStrip_standards["prototype"]["scrollToItem"] = function(oTabItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollToItem"]++; }; 
	this["iVisibilityThreashold"] = oTabItem["oDomRef"]["offsetTop"];
	this["oPanel"]["scrollTop"] = this["iVisibilityThreashold"];
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollToItem"] = 0; };

/**
 * Scrolls forwards to a previously defined item
 * @private
 * @param {UCF_TabstripItem} oTabItem
 */
UCF_TabStrip_standards["prototype"]["scrollNextItemIntoViewport"] = function(oTabItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollNextItemIntoViewport"]++; }; 

	if (!this["bIsInNextHidden"](oTabItem)) return;
	this["scrollToItem"](oTabItem);
	this["updateActionItems"]();
	this["updateMoreIndicator"]();
	this["updateVisibilityThreshold"](oTabItem);

	this["fireScroll"](this["sId"], this["oGetFirstItemInViewPort"]()["sId"], 'FORWARD');
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollNextItemIntoViewport"] = 0; };

/**
 * Scrolls backwards to a previously defined item
 * @private
 * @param {UCF_TabstripItem} oTabItem
 */
UCF_TabStrip_standards["prototype"]["scrollPreviousItemIntoViewport"] = function(oTabItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollPreviousItemIntoViewport"]++; }; 

	if (!this["bIsInPreviousHidden"](oTabItem)) return;
	this["scrollToItem"](oTabItem);
	this["updateActionItems"]();
	this["updateMoreIndicator"]();
	this["updateVisibilityThreshold"](oTabItem);

	this["fireScroll"](this["sId"], this["oGetFirstItemInViewPort"]()["sId"], 'BACKWARD');
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollPreviousItemIntoViewport"] = 0; };

/**
 * Pages to the previous items
 * @private
 */
UCF_TabStrip_standards["prototype"]["scrollToPreviousRowOfItems"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollToPreviousRowOfItems"]++; }; 

	var oFirstInViewPort = this["oGetFirstItemInViewPort"]();

	if (oFirstInViewPort["iIndex"] === 0) return;

	var oTabItem = this["aItems"][oFirstInViewPort["iIndex"] - 1];
	this["scrollToItem"](oTabItem);
	this["updateVisibilityThreshold"](oTabItem);
	this["updateActionItems"]();
	this["updateMoreIndicator"]();
	this["fireScroll"](this["sId"], this["oGetFirstItemInViewPort"]()["sId"], 'BACKWARD');
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollToPreviousRowOfItems"] = 0; };

/**
 * Pages to the next items
 * @private
 */
UCF_TabStrip_standards["prototype"]["scrollToNextRowOfItems"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollToNextRowOfItems"]++; }; 

	var oLastInViewPort = this["oGetLastItemInViewPort"]();

	if (oLastInViewPort["iIndex"] === this["aItems"]["length"] - 1) return;

	var oTabItem = this["aItems"][oLastInViewPort["iIndex"] + 1];
	this["scrollToItem"](oTabItem);
	this["updateVisibilityThreshold"](oTabItem);
	this["updateActionItems"]();
	this["updateMoreIndicator"]();
	this["fireScroll"](this["sId"], this["oGetFirstItemInViewPort"]()["sId"], 'FORWARD');
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollToNextRowOfItems"] = 0; };

/**
 * Returns the first item visible in the view port
 * @private
 * @return {UCF_TabstripItem}
 */
UCF_TabStrip_standards["prototype"]["oGetFirstItemInViewPort"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["oGetFirstItemInViewPort"]++; }; 

	if (!this["aItems"]) return;

	var aItems = this["aItems"];
	// eslint-disable-next-line consistent-return
	if (!this["bScrollable"]) return this["aItems"][0];

	for (var i = 0; i < aItems["length"]; i++) {
		if (aItems[i]["oDomRef"]["offsetTop"] === this["iVisibilityThreashold"])
			// eslint-disable-next-line consistent-return
			return aItems[i];
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["oGetFirstItemInViewPort"] = 0; };

/**
 * Returns the last item visible in the view port
 * @private
 * @return {UCF_TabstripItem}
 */
// eslint-disable-next-line consistent-return
UCF_TabStrip_standards["prototype"]["oGetLastItemInViewPort"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["oGetLastItemInViewPort"]++; }; 
	if (!this["aItems"]) return;

	var aItems = this["aItems"];
	// eslint-disable-next-line consistent-return
	if (!this["bScrollable"]) return this["aItems"][this["aItems"]["length"] - 1];

	for (var i = aItems["length"] - 1; i >= 0; i--) {
		if (aItems[i]["oDomRef"]["offsetTop"] === this["iVisibilityThreashold"])
			// eslint-disable-next-line consistent-return
			return aItems[i];
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["oGetLastItemInViewPort"] = 0; };

/**
 * Determines whether an item is not in the view port
 * @private
 * @return {boolean}
 */
UCF_TabStrip_standards["prototype"]["bLastItemVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["bLastItemVisible"]++; }; 
	if (!this["aItems"]) return;
	// eslint-disable-next-line consistent-return
	return !this["bIsInNextHidden"](this["aItems"][this["aItems"]["length"] - 1]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["bLastItemVisible"] = 0; };

/**
 * Determines whether an item is not in the view port
 * @private
 * @return {boolean}
 */
UCF_TabStrip_standards["prototype"]["bFirstItemVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["bFirstItemVisible"]++; }; 

	return (!this["bIsInPreviousHidden"](this["aItems"][0]));
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["bFirstItemVisible"] = 0; };

/**
 * Determines whether an item is hidden on the left, on the right, or is visible
 * @private
 * @param {UCF_TabstripItem} oItem
 * @return {string}
 */
UCF_TabStrip_standards["prototype"]["sItemScrollPosition"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["sItemScrollPosition"]++; }; 

	if (!this["bScrollable"])
		return this["eItemScrollPosition"]["IN_VIEWPORT"];

	if (this["bIsInPreviousHidden"](oItem))
		return this["eItemScrollPosition"]["IN_PREVIOUS_HIDDEN"];

	if (this["bIsInNextHidden"](oItem))
		return this["eItemScrollPosition"]["IN_NEXT_HIDDEN"];

	if (!this["bIsHidden"](oItem))
		return this["eItemScrollPosition"]["IN_VIEWPORT"];

	return null;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["sItemScrollPosition"] = 0; };

/**
 * Enumeration the indicates the different visibility states
 * @private
 */
UCF_TabStrip_standards["prototype"]["eItemScrollPosition"] = {
	"IN_VIEWPORT": 'IN_VIEWPORT',
	"IN_PREVIOUS_HIDDEN": 'IN_PREVIOUS_HIDDEN',
	"IN_NEXT_HIDDEN": 'IN_NEXT_HIDDEN'
};

/**
 * Determines whether an item is not in the view port
 * @private
 * @param {UCF_TabstripItem} oItem
 * @return {boolean}
 */
UCF_TabStrip_standards["prototype"]["bIsHidden"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["bIsHidden"]++; }; 
	if (!oItem) return;
	// eslint-disable-next-line consistent-return
	if (!this["bScrollable"]) return false;
	// eslint-disable-next-line consistent-return
	return oItem["oDomRef"]["offsetTop"] !== this["iVisibilityThreashold"];
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["bIsHidden"] = 0; };

/**
 * Determines whether an item is within the items hidden on the left side
 * @private
 * @param {UCF_TabstripItem} oItem
 * @return {boolean}
 */
UCF_TabStrip_standards["prototype"]["bIsInPreviousHidden"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["bIsInPreviousHidden"]++; }; 

	if (!oItem) return;
	// eslint-disable-next-line consistent-return
	return oItem["oDomRef"]["offsetTop"] < this["iVisibilityThreashold"];
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["bIsInPreviousHidden"] = 0; };

/**
 * Determines whether an item is within the items hidden on the right side
 * @private
 * @param {UCF_TabstripItem} oItem
 * @return {boolean}
 */
UCF_TabStrip_standards["prototype"]["bIsInNextHidden"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["bIsInNextHidden"]++; }; 
	if (!oItem) return;
	// eslint-disable-next-line consistent-return
	return oItem["oDomRef"]["offsetTop"] > this["iVisibilityThreashold"];

};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["bIsInNextHidden"] = 0; };

UCF_TabStrip_standards["prototype"]["updateVisibilityThreshold"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateVisibilityThreshold"]++; }; 
	this["iVisibilityThreashold"] = oItem["oDomRef"]["offsetTop"];
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateVisibilityThreshold"] = 0; };

/**######################################################################
 *
 * SECTION WITH ALL KEYBOARD HANDLERS; MAINLY RESPONSIBLE FOR SCROLLING
 *
 * #######################################################################
 */

/**
 * Does not navigate. Scrolls an items into the view port so that
 * the item navigation can focus it
 *
 * @private
 */

UCF_TabStrip_standards["prototype"]["onlsprevious"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsprevious"]++; }; 

	var iPreviousTab = this["oItemNavigation"]["iFocusedIndex"] - 1,
		oPreviousTab;

	if (iPreviousTab >= 0) {
		oPreviousTab = this["oItemNavigation"]["aItems"][iPreviousTab];
	}

	if (this["bIsHidden"](oPreviousTab)) {
		this["scrollToItem"](oPreviousTab);
		this["updateActionItems"]();
		this["updateMoreIndicator"]();
		this["updateVisibilityThreshold"](oPreviousTab);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsprevious"] = 0; };

/**
 * Doea not navigate. Scrolls an items into the view port so that
 * the item navigation can focus it
 *
 * @private
 */

UCF_TabStrip_standards["prototype"]["onlsnext"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsnext"]++; }; 

	var iNextTab = this["oItemNavigation"]["iFocusedIndex"] + 1,
		oNextTab;

	if (iNextTab <= this["oItemNavigation"]["aItems"]["length"] - 1) {
		oNextTab = this["oItemNavigation"]["aItems"][iNextTab];
	}

	if (this["bIsHidden"](oNextTab)) {
		this["scrollToItem"](oNextTab);
		this["updateActionItems"]();
		this["updateMoreIndicator"]();
		this["updateVisibilityThreshold"](oNextTab);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsnext"] = 0; };

/**
 * Scroll to first item
 *
 * @private
 */
UCF_TabStrip_standards["prototype"]["onlshome"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlshome"]++; }; 

	var oFirstInViewPort = this["oGetFirstItemInViewPort"]();

	if (oFirstInViewPort["iIndex"] === 0) return;

	this["scrollToItem"](this["aItems"][0]);
	this["updateActionItems"]();
	this["updateMoreIndicator"]();
	this["updateVisibilityThreshold"](this["aItems"][0]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlshome"] = 0; };

/**
 * Scroll to last item
 *
 * @private
 */
UCF_TabStrip_standards["prototype"]["onlsend"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsend"]++; }; 

	var oLastInViewPort = this["oGetLastItemInViewPort"]();

	if (oLastInViewPort["iIndex"] === this["aItems"]["length"] - 1) return;

	this["scrollToItem"](this["aItems"][this["aItems"]["length"] - 1]);
	this["updateActionItems"]();
	this["updateMoreIndicator"]();
	this["updateVisibilityThreshold"](this["aItems"][this["aItems"]["length"] - 1]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsend"] = 0; };

/**
 * Scroll 5 items forwards or to the last
 *
 * @private
 * @param {UCF_EventObject} oEvent
 */
UCF_TabStrip_standards["prototype"]["onlspageup"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlspageup"]++; }; 

	var oLastInViewPort = this["oGetLastItemInViewPort"]();

	if (oLastInViewPort["iIndex"] === this["aItems"]["length"] - 1) return;

	var iIndex = ((this["aItems"]["length"] - 1) - oLastInViewPort["iIndex"] > 5) ? oLastInViewPort["iIndex"] + 5 : this["aItems"]["length"] - 1;

	this["scrollNextItemIntoViewport"](this["aItems"][iIndex]);

	UCF_DomUtil["setTabIndex"](this["aItems"][this["oItemNavigation"]["iFocusedIndex"]]["oFocusDomRef"], -1);
	UCF_DomUtil["setTabIndex"](this["aItems"][iIndex]["oFocusDomRef"], 0);
	UCF_DomUtil["focusDomElement"](this["aItems"][iIndex]["oFocusDomRef"]);
	this["oItemNavigation"]["iFocusedIndex"] = this["iGetItemNavIndex"](this["aItems"][iIndex]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlspageup"] = 0; };

/**
 * Scroll 5 items backwards or to the first
 *
 * @private
 * @param {UCF_EventObject} oEvent
 */
UCF_TabStrip_standards["prototype"]["onlspagedown"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlspagedown"]++; }; 
	var oFirstInViewPort = this["oGetFirstItemInViewPort"]();

	if (oFirstInViewPort["iIndex"] === 0) return;

	var iIndex = ((oFirstInViewPort["iIndex"] - 5) >= 5) ? (oFirstInViewPort["iIndex"] - 5) : 0;

	this["bIsInPreviousHidden"](this["aItems"][iIndex]);

	UCF_DomUtil["setTabIndex"](this["aItems"][this["oItemNavigation"]["iFocusedIndex"]]["oFocusDomRef"], -1);
	UCF_DomUtil["setTabIndex"](this["aItems"][iIndex]["oFocusDomRef"], 0);
	UCF_DomUtil["focusDomElement"](this["aItems"][iIndex]["oFocusDomRef"]);
	this["oItemNavigation"]["iFocusedIndex"] = this["iGetItemNavIndex"](this["aItems"][iIndex]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlspagedown"] = 0; };

UCF_TabStrip_standards["prototype"]["iGetItemNavIndex"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["iGetItemNavIndex"]++; }; 
	var aItems = this["oItemNavigation"]["aItems"];

	for (var i = 0; i < aItems["length"]; i++) {
		if (aItems[i]["sId"] === oItem["sId"])
			return aItems[i]["iIndex"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["iGetItemNavIndex"] = 0; };

/**######################################################
 *
 * SECTION RESPONSIBLE FOR TAB ITEM SELECTION
 *
 * #####################################################
 */

/**
 * enumeration that lists the different means by which
 * a tab item can be selected
 */
UCF_TabStrip_standards["prototype"]["eMeansOfSelection"] = {
	"MOUSE": 'MOUSE',
	"KEYBOARD": 'KEYBOARD',
	"CALL": 'CALL'
};

/**
 * An enumeration with the different statuses of a tab item
 * @private
 */
UCF_TabStrip_standards["prototype"]["eItemStatus"] = {
	"ACCESSIBLE": 'ACCESSIBLE',
	"INACCESSIBLE": 'INACCESSIBLE',
	"INACCESSIBLE_AND_SELECTED": 'INACCESSIBLE_AND_SELECTED',
	"SELECTED": 'SELECTED'
};

/**
 * Returns the selection status of an item
 * @private
 * @param {UCF_TabstripItem} oItem
 * @return {string}
 */
UCF_TabStrip_standards["prototype"]["sGetItemStatus"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["sGetItemStatus"]++; }; 
	//item is disabled
	if (!oItem["bEnabled"] && oItem["iIndex"] !== this["iSelected"])
		return this["eItemStatus"]["INACCESSIBLE"];
	//item can be selected
	if (oItem["bEnabled"] && oItem["iIndex"] !== this["iSelected"])
		return this["eItemStatus"]["ACCESSIBLE"];
	//item is disabled and selected
	if (!oItem["bEnabled"] && oItem["iIndex"] === this["iSelected"])
		return this["eItemStatus"]["INACCESSIBLE_AND_SELECTED"];
	//item is enabled and selected
	if (oItem["bEnabled"] && oItem["iIndex"] === this["iSelected"])
		return this["eItemStatus"]["SELECTED"];
	return null;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["sGetItemStatus"] = 0; };

/**
 * An enumeration that lists the different actions that can be performed when accessing a tab
 */
UCF_TabStrip_standards["prototype"]["eTabAction"] = {
	"TAB_ACCESS": 'TAB_ACCESS',
	"TAB_CLOSE": 'TAB_CLOSE',
	"NONE": 'NONE'
};

/**
 * Determines the action to performed based on the value of the custom
 * attribute 'action'
 *
 * @param {UCF_EventObject} oEvent
 * @return {string}
 */
// eslint-disable-next-line consistent-return
UCF_TabStrip_standards["prototype"]["determineTabAction"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["determineTabAction"]++; }; 
	var oSource = oEvent["mParameters"]["oBrowserEvent"]["oSource"];
	var sAction = oSource["getAttribute"]('action');

	if (oSource["className"] === 'urAccessKey')
		return this["eTabAction"]["TAB_ACCESS"];

	if (oSource["id"] === oEvent["mParameters"]["oItem"]["sId"] + '-icon')
		return this["eTabAction"]["TAB_ACCESS"];

	switch (sAction) {
		case this["eTabAction"]["TAB_ACCESS"]:
			return this["eTabAction"]["TAB_ACCESS"];
		case this["eTabAction"]["TAB_CLOSE"]:
			return this["eTabAction"]["TAB_CLOSE"];
	}

	if (oEvent["mParameters"]["oItem"]["sClassName"] === 'UCF_TabStripItem_standards') {
		return this["eTabAction"]["TAB_ACCESS"];
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["determineTabAction"] = 0; };

/**
 * Based on the selection status, this function determines how to select / deselect an item
 * @private
 * @param {UCF_EventObject} oEvent
 */
UCF_TabStrip_standards["prototype"]["onTabItemAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onTabItemAccess"]++; }; 

	var sTabAction = this["determineTabAction"](oEvent),
		oSelectedTab = oEvent["mParameters"]["oItem"],
		oDeselectedTab = this["aItems"][this["iSelected"]],
		sName = oEvent["mParameters"]["oBrowserEvent"]["sName"],
		sMeans = (sName === 'click') ? this["eMeansOfSelection"]["MOUSE"] : this["eMeansOfSelection"]["KEYBOARD"];

	switch (sTabAction) {
		case this["eTabAction"]["TAB_CLOSE"]:
			this["fireTabClose"](this["sId"], oSelectedTab["sId"]);
			break;

		case this["eTabAction"]["TAB_ACCESS"]:

			if (this["sEvaluateSelectability"](oSelectedTab) === this["eItemStatus"]["ACCESSIBLE"]) {
				if (this["bClientTabSelect"]) {
					this["proceedGenericSelectionSteps"](oSelectedTab, oEvent);
					this["handleMeansOfSelection"](sMeans, oSelectedTab, oDeselectedTab);
				}
				this["fireTabSelect"](this["sId"], oSelectedTab["sId"], oSelectedTab["iIndex"], this["oGetFirstItemInViewPort"]()["iIndex"]);
			}
	}
	oEvent["mParameters"]["oBrowserEvent"]["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onTabItemAccess"] = 0; };

/**
 * The means of selection can be the mouse, the keyboard, a menu or a public api. Depending on the means the by-activities
 * of the selection of an
 * item might need to be handled differently for example in terms of focus handling
 *
 * @private
 * @param {string} sMeansOfSelection
 * @param {UCF_TabstripItem} oSelectedTab
 * @param {UCF_TabstripItem} oDeselectedTab
 */
UCF_TabStrip_standards["prototype"]["handleMeansOfSelection"] = function(sMeansOfSelection, oSelectedTab, oDeselectedTab) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["handleMeansOfSelection"]++; }; 
	switch (sMeansOfSelection) {
		case this["eMeansOfSelection"]["MOUSE"]:
			this["selectionByMouse"](oSelectedTab, oDeselectedTab);
			break;
		case this["eMeansOfSelection"]["KEYBOARD"]:
			this["selectionByKeyboard"](oSelectedTab, oDeselectedTab);
			break;
		case this["eMeansOfSelection"]["CALL"]:
			this["selectionByCall"](oSelectedTab, oDeselectedTab);
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["handleMeansOfSelection"] = 0; };

/**
 * Handles selections performed by mouse
 *
 * @private
 * @param {UCF_TabstripItem} oSelectedTab
 * @param {UCF_TabstripItem} oDeselectedTab
 */
UCF_TabStrip_standards["prototype"]["selectionByMouse"] = function(oSelectedTab, oDeselectedTab) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["selectionByMouse"]++; }; 
	this["sFocusType"] = this["eFocusType"]["REFOCUSED"];
	UCF_DomUtil["setTabIndex"](oDeselectedTab["oFocusDomRef"], -1);
	UCF_DomUtil["setTabIndex"](oSelectedTab["oFocusDomRef"], 0);
	UCF_DomUtil["refocusDomElement"](oSelectedTab["oFocusDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["selectionByMouse"] = 0; };

/**
 * Handles selections performed by keyboard
 *
 * @private
 * @param {UCF_TabstripItem} oSelectedTab
 * @param {UCF_TabstripItem} oDeselectedTab
 */
UCF_TabStrip_standards["prototype"]["selectionByKeyboard"] = function(oSelectedTab, oDeselectedTab) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["selectionByKeyboard"]++; }; 
	UCF_DomUtil["setTabIndex"](oDeselectedTab["oFocusDomRef"], -1);
	UCF_DomUtil["setTabIndex"](oSelectedTab["oFocusDomRef"], 0);
	this["sFocusType"] = this["eFocusType"]["REFOCUSED"];
	UCF_DomUtil["refocusDomElement"](oSelectedTab["oFocusDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["selectionByKeyboard"] = 0; };

/**
 * Handles selections performed by menu
 *
 * @private
 * @param {UCF_TabstripItem} oSelectedTab
 * @param {UCF_TabstripItem} oDeselectedTab
 */
UCF_TabStrip_standards["prototype"]["selectionByCall"] = function(oSelectedTab, oDeselectedTab) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["selectionByCall"]++; }; 

	this["updateAriaSelectionProperties"](oSelectedTab);
	UCF_DomUtil["setTabIndex"](oDeselectedTab["oFocusDomRef"], -1);
	UCF_DomUtil["setTabIndex"](oSelectedTab["oFocusDomRef"], 0);

	oSelectedTab["moveFocus"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["selectionByCall"] = 0; };

/**
 * Responsible for the update of all properties that reflect a selected status in all different ACC modes
 * @private
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_standards["prototype"]["updateAriaSelectionProperties"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateAriaSelectionProperties"]++; }; 
	var oDeselected = UCF_DomUtil["$"](this["aItems"][this["iSelected"]]["sId"] + '-title');
	var oSelected = UCF_DomUtil["$"](oItem["sId"] + '-title');

	UCF_AriaStateHelper["setSelected"](oSelected, true);
	UCF_AriaStateHelper["setSelected"](oDeselected, false);
	UCF_AriaStateHelper["setActivedescendant"](this["oItemNavigation"]["oItemContainer"], oItem["sId"]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateAriaSelectionProperties"] = 0; };

/**
 * assign all values and properties to the the HTML of an item that indicate its status as selected
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_standards["prototype"]["updateSelectionValues"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateSelectionValues"]++; }; 
	if (!oItem) return;
	var oSelected = oItem["oDomRef"];
	oSelected["setAttribute"]('selected', 'true');
	this["iSelected"] = oItem["iIndex"];
	this["iCurrentIndex"] = oItem["iIndex"];
	this["oTabstripDelegate"]["iSelected"] = oItem["iIndex"];
	this["setClientProperty"]("CurrentIndex", this["iSelected"], true);

	if (this["aItems"][this["iSelected"]]["sDefaultButtonId"]) {
		this["setDefaultButtonId"](this["aItems"][this["iSelected"]]["sDefaultButtonId"]);
		this["oLS"]["highlightDefaultButton"](this["sActiveDefaultButtonId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["updateSelectionValues"] = 0; };

/**
 * Remove all values and properties from the HTML of an item that indicate its status as selected
 */
UCF_TabStrip_standards["prototype"]["removeSelectionValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["removeSelectionValues"]++; }; 
	var oDeselected = this["aItems"][this["iSelected"]]["oDomRef"];
	oDeselected["removeAttribute"]('selected');
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["removeSelectionValues"] = 0; };

/**
 * If focus handling is done by the tab strip, as with the menu selection,
 * this method is used to assign the focus to the selected
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_standards["prototype"]["assignFocusValues"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["assignFocusValues"]++; }; 
	if (!oItem) return;
	UCF_DomUtil["setTabIndex"](oItem["oFocusDomRef"], 0);
	UCF_DomUtil["focusDomElement"](oItem["oFocusDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["assignFocusValues"] = 0; };

/**
 * Determines whether or not the item can be selected and calls the selection functions in dependence to the item's status
 * @private
 * @param {UCF_TabstripItem} oItem
 * @return {string}
 */
UCF_TabStrip_standards["prototype"]["sEvaluateSelectability"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["sEvaluateSelectability"]++; }; 
	if (this["sGetItemStatus"](oItem) !== this["eItemStatus"]["ACCESSIBLE"]) return this["eItemStatus"]["INACCESSIBLE"];
	return this["eItemStatus"]["ACCESSIBLE"];
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["sEvaluateSelectability"] = 0; };

/**
 * Methods shared by all means of selection
 * @private
 * @param {UCF_TabstripItem} oItem
 * @param { UCF_BrowserEvent } oEvent
 */
UCF_TabStrip_standards["prototype"]["proceedGenericSelectionSteps"] = function(oItem, oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["proceedGenericSelectionSteps"]++; }; 
	this["checkMenuItem"](oItem);
	this["determineDeselection"](this["aItems"][this["iSelected"]]);
	this["performSelection"](oItem);
	this["removeSelectionValues"]();
	this["showContent"](oItem, oEvent);
	this["scrollContent"](oItem);
	this["updateAriaSelectionProperties"](oItem);
	this["updateSelectionValues"](oItem);
	this["updateMoreIndicator"]();
	this["notifyLayoutChangeFrom"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["proceedGenericSelectionSteps"] = 0; };

/**
 * Determines whether or not the item can be de-selected and calls the de-selection functions in dependence to the item's status
 * @private
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_standards["prototype"]["determineDeselection"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["determineDeselection"]++; }; 
	if (!oItem) return;
	switch (this["sGetItemStatus"](oItem)) {

		case this["eItemStatus"]["SELECTED"]:
			this["performDeselection"](oItem);
			this["hideContent"](oItem);
			break;

		case this["eItemStatus"]["INACCESSIBLE_AND_SELECTED"]:
			this["performDeselectionOfInAccessible"](oItem);
			this["hideContent"](oItem);
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["determineDeselection"] = 0; };

/**#####################################################################
 *
 * SECTION RESPONSIBLE FOR THE HANDLING OF THE CONTENT AREA
 *
 * ######################################################################
 */

/**
 * Scrolls the content area and creates a scroll area object if needed.
 * @private
 * @param {UCF_TabstripItem} oItemToScroll
 */
UCF_TabStrip_standards["prototype"]["scrollContent"] = function(oItemToScroll) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollContent"]++; }; 
	var iLeft;
	var iTop;

	if (this["sGetItemStatus"](oItemToScroll) === !this["bClientTabSelect"] ||
		oItemToScroll["sScrollingMode"] === 'NONE' ||
		!UCF_DomUtil["$"](oItemToScroll["sId"] + '-scrl')) return;

	if (oItemToScroll["oScrollArea"] === null) {
		oItemToScroll["loadScrollArea"]();
	}
	if (window["UCF_System"]["bIsRTL"] && UCF_UserAgent["bIsIE"]()) {

		if (oItemToScroll["iScrollTop"] === 0) {
			iTop = '100%';
		} else {
			iTop = oItemToScroll["iScrollTop"];
		}
		if (oItemToScroll["iScrollLeft"] === 0) {
			iLeft = '100%';
		} else {
			iLeft = oItemToScroll["iScrollLeft"];
		}

		oItemToScroll["oScrollArea"]["setScrollPosition"](iTop, iLeft);
	} else {
		oItemToScroll["oScrollArea"]["setScrollPosition"](oItemToScroll["iScrollTop"], oItemToScroll["iScrollLeft"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["scrollContent"] = 0; };

/**
 * Turns the content of the selected item visible
 * @private
 *
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_standards["prototype"]["hideContent"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["hideContent"]++; }; 
	if (!oItem) return;
	var oContent = UCF_DomUtil["$"](oItem["sId"] + '-cnt');

	if (oContent === null) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Cannot find content - with ID ' + oItem["sId"] + '-cnt', "TabStrip_standards.js(1312): hideContent"); };
		return;
	}

	oContent["style"]["height"] = '1px';
	oContent["style"]["width"] = '1px';

	if (window["UCF_System"]["bIsRTL"] === false && !UCF_UserAgent["bIsWebKit"]() && window["UCF_System"]["sDevice"] !== 'standards') {
		oContent["style"]["position"] = 'absolute';
		oContent["style"]["top"] = '-10000px';
		// D039230 - CSN 1909557 2011
		// oContent.style.left = '-10000px';
		oContent["style"]["visibility"] = 'hidden';
	} else {
		oContent["style"]["display"] = 'none';
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["hideContent"] = 0; };

/**
 * Shows the content of the tab with the index iIndex
 *
 * @private
 *
 * @param {UCF_TabstripItem} oItem
 * @param { UCF_BrowserEvent } oEvent
 */
UCF_TabStrip_standards["prototype"]["showContent"] = function(oItem, oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["showContent"]++; }; 
	if (!oItem) return;
	var oContent = UCF_DomUtil["$"](oItem["sId"] + '-cnt');

	if (oContent === null) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Cannot find content - with ID ' + oItem["sId"] + '-cnt', "TabStrip_standards.js(1343): showContent"); };
		return;
	}

	if (UCF_UserAgent["bIsSafari"]()) {
		oContent["style"]["display"] = '';
		oContent["style"]["width"] = '1px';
		oContent["style"]["height"] = '1px';
		this["oAFId"] = UCF_JsUtil["requestAnimationFrame"](function() {
			if (oContent) {
				oContent["style"]["width"] = '100%';
				oContent["style"]["height"] = '100%';
			}
		});
	} else {
		oContent["style"]["display"] = '';
		oContent["style"]["height"] = '100%';
		oContent["style"]["width"] = '100%';
	}

	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		try {
			var oTabContent = UCF_DomUtil["$"](this["sId"] + '-cnt');
			if (oTabContent) {
				var sStyleHeight = oTabContent["style"]["height"];
				if (sStyleHeight && sStyleHeight["indexOf"]('%') > -1)
					oTabContent["style"]["height"] = '100%';
				//_trace(INFO, '================================== TabStrip -  showContent ' + oTabStripCnt.style.height );
			}
		} catch (e) {}
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["showContent"] = 0; };

/**######################################################
 *
 * SECTION WITH ALTERNATIVE WAYS TO SELECT WITH KEYBOARD
 *
 * #####################################################
 */

/**
 * Selects the next tab by ctrl + page up
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_standards["prototype"]["onlspageupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlspageupmodifier"]++; }; 

	var oSource = oBrowserEvent["oGetSourceControl"]();

	if (oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]() && !oBrowserEvent["bAlt"]()) {
		var oItem = this["oGetNextSelectable"]();

		if (oItem != null) {
			this["scrollNextItemIntoViewport"](oItem);
			this["selectByPageKey"](oSource, oItem);
		}
	}
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlspageupmodifier"] = 0; };

/**
 * Selects the prevouis tab by ctrl + page down
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_standards["prototype"]["onlspagedownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlspagedownmodifier"]++; }; 

	var oSource = oBrowserEvent["oGetSourceControl"]();

	if (oBrowserEvent["bCtrl"]() && !oBrowserEvent["bShift"]() && !oBrowserEvent["bAlt"]()) {
		var oItem = this["oGetPreviousSelectable"]();
		if (oItem != null) {
			this["scrollPreviousItemIntoViewport"](oItem);
			this["selectByPageKey"](oSource, oItem);
		}
	}
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlspagedownmodifier"] = 0; };

/**
 * Selects the next tab by page up / down
 *
 * @private
 * @param {UCF_TabstripItem} oSource
 * @param {UCF_TabstripItem} oSelectedTab
 */
UCF_TabStrip_standards["prototype"]["selectByPageKey"] = function(oSource, oSelectedTab) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["selectByPageKey"]++; }; 

	if (this["sEvaluateSelectability"](oSelectedTab) === this["eItemStatus"]["ACCESSIBLE"]) {

		if (this["bClientTabSelect"]) {
			var oDeselectedTab = this["aItems"][this["iSelected"]];
			this["proceedGenericSelectionSteps"](oSelectedTab);
			this["handleMeansOfSelection"](this["eMeansOfSelection"]["KEYBOARD"], oSelectedTab, oDeselectedTab);
		}

		this["fireTabSelect"](this["sId"], oSelectedTab["sId"], oSelectedTab["iIndex"], this["oGetFirstItemInViewPort"]()["iIndex"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["selectByPageKey"] = 0; };

/**
 * Finds the next selectable tab. Returns null, if there is none
 *
 * @private
 * @return {UCF_TabstripItem} oItem
 */
UCF_TabStrip_standards["prototype"]["oGetNextSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["oGetNextSelectable"]++; }; 

	var iStart = this["iSelected"] + 1;

	if (iStart > this["aItems"]["length"] - 1) return;

	for (var i = iStart; i < this["aItems"]["length"]; i++) {
		if (this["sGetItemStatus"](this["aItems"][i]) === this["eItemStatus"]["ACCESSIBLE"]) break;
	}
	// eslint-disable-next-line consistent-return
	return this["aItems"][i];
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["oGetNextSelectable"] = 0; };

/**
 * Finds the previous selectable tab. Returns null, if there is none
 *
 * @private
 * @return {UCF_TabstripItem} oItem
 */
UCF_TabStrip_standards["prototype"]["oGetPreviousSelectable"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["oGetPreviousSelectable"]++; }; 

	var iStart = this["iSelected"] - 1;

	if (iStart < 0) return;

	for (var i = iStart; i >= 0; i--) {
		if (this["sGetItemStatus"](this["aItems"][i]) === this["eItemStatus"]["ACCESSIBLE"]) break;
	}
	// eslint-disable-next-line consistent-return
	return this["aItems"][i];
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["oGetPreviousSelectable"] = 0; };

/**#####################################################################
 *
 * SECTION WHERE ALL RELEVANT STYLES ARE ASSIGNED TO THE SELECTED ITEM
 *
 * #####################################################################
 */

/**
 *
 * Assigns all styles that indicate selection
 * @private
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_standards["prototype"]["performSelection"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["performSelection"]++; }; 
	var oDelegate = this["oTabstripDelegate"];
	this["oTabstripDelegate"]["styleFactory"](oDelegate["eToggleMethods"]["switchToSelected"], oItem, oDelegate["eSelectionState"]["SELECTED"]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["performSelection"] = 0; };

/**
 * Removes all styles and that indicate selection
 * @private
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_standards["prototype"]["performDeselection"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["performDeselection"]++; }; 
	var oDelegate = this["oTabstripDelegate"];
	this["oTabstripDelegate"]["styleFactory"](oDelegate["eToggleMethods"]["switchToUnselected"], oItem, oDelegate["eSelectionState"]["UNSELECTED"]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["performDeselection"] = 0; };

/**
 * Handles the selection of an item that is both selected and disabled
 * @private
 * @param {UCF_TabstripItem} oItem
 */
UCF_TabStrip_standards["prototype"]["performDeselectionOfInAccessible"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["performDeselectionOfInAccessible"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["performDeselectionOfInAccessible"] = 0; };

/**#####################################################################################
 *
 *  SECTION WHERE ALL TABSTRIB STYLES ARE MAINTAINED
 *
 * #####################################################################################
 * */

UCF_TabStrip_standards["prototype"]["eStyles"] = {
	"PREV_BTN_OFF": "lsTbsv6-PageToPrevOff",
	"NEXT_BTN_OFF": "lsTbsv6-PageToNextOff",
	"PREV_BTN_ON": "lsTbsv6-PageToPrevOn",
	"NEXT_BTN_ON": "lsTbsv6-PageToNextOn",
	"MENU_BTN_OFF": "lsTbsv6-MenuOff",
	"MENU_BTN_ON": "lsTbsv6-MenuOn",

	"MORE_INDICATOR": 'lsTbsv5-MoreIndicator',
	"MORE_INDICATOR_SELECTED": 'lsTbsv5-MoreIndicatorSel',
	"MORE_INDICATOR_DISABLED": 'lsTbsv5-MoreIndicatorDsbl',
	"MORE_INDICATOR_LAST": 'lsTbsv5-MoreIndicatorLast',
	"MORE_INDICATOR_LAST_SELECTED": 'lsTbsv5-MoreIndicatorLastSel'
};

/**#####################################################################################

 * SECTION THAT HANDLES RESIZING

 * #####################################################################################
 * */

UCF_TabStrip_standards["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onLayoutChange"]++; }; 

	var sSourceControlId;

	if (!this["bScrollable"]) return;

	sSourceControlId = oEvent["oGetParam"]('sSourceControlId');

	// Ignore my own LayoutChange ...
	if (sSourceControlId && sSourceControlId === this["sId"]) return;

	//if (this.aItems && this.bIsHidden(this.aItems[this.aItems.length - 1])) {
	this["onAfterResize"]();
	//}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onLayoutChange"] = 0; };

/**
 * Handles the resize event of the browser
 *
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_standards["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onresize"]++; }; 

	if (!this["bScrollable"]) return;

	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oDomRef"]) {

		if (this["sTimeOutId"] != null) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResize');
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onresize"] = 0; };

/**
 * This function is called after resizing has finished
 *
 * @private
 */
UCF_TabStrip_standards["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onAfterResize"]++; }; 

	if (!this["bScrollable"]) return;

	if (this["aItems"] === null || (this["aItems"] && this["aItems"]["length"] < 2)) return;
	if (!this["bIsValid"]() || this["iWidthBeforeResize"] === this["oDomRef"]["offsetWidth"]) return;

	var oSelected = this["aItems"][this["iSelected"]];

	if (this["bIsHidden"](oSelected)) {
		this["scrollToItem"](oSelected);
		this["updateVisibilityThreshold"](oSelected);
	} else {
		this["updateVisibilityThreshold"](this["oGetFirstItemInViewPort"]());
	}
	this["updateActionItems"]();
	this["updateMoreIndicator"]();
	this["iWidthBeforeResize"] = this["oDomRef"]["offsetWidth"];
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onAfterResize"] = 0; };

/**###################################################################
 *
 * SECTION WITH Generic Keyboard Actions
 *
 * ###################################################################
 * Selects the next tab by ctrl + page up
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */

/**
 * Handle hotkey events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_standards["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlshotkey"]++; }; 
	var oSelectedItem = this["aItems"][this["iSelected"]];

	if (oSelectedItem["sHotkeysId"] === '') return;

	var oHotkeys = this["oGetControlById"](oSelectedItem["sHotkeysId"]);
	if (oHotkeys == null) return;

	var oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oSelectedItem["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}

	}

};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlshotkey"] = 0; };

UCF_TabStrip_standards["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]('UCF_Hotkeys')["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onkeypress"] = 0; };

UCF_TabStrip_standards["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onkeydown"]++; }; 

	switch (oBrowserEvent["iKeyCode"]()) {
		case UCF_KeyCodes["DELETE"]:
			var oItem = oBrowserEvent["oSourceControl"];
			if (oItem["bIsClosable"] && oItem["bEnabled"]) {
				this["fireTabClose"](this["sId"], oItem["sId"]);
			}
			break;

	}
	oBrowserEvent["returnValue"] = false;
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onkeydown"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_standards["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_standards["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsskipback"] = 0; };

/**##############################################################################
 *
 * Accessibility Section
 *
 * #############################################################################
 * Sets the correct acc text
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TabStrip_standards["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TabStrip_standards.js(1706): onlsaccessibility"); };

	if (!window["UCF_System"]["bIs508"]) return;

	var oSource = oBrowserEvent["oGetSourceControl"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (UCF_JsUtil["bInstanceOf"](oSource, 'UCF_TabStripItem')) {

		if (this["sTabItemsPosition"] === 'TOP') {
			oAccessibilityHelper["setControlType"]('TS');
			oAccessibilityHelper["applyContainerEntryBehaviour"]();
		} else {
			oAccessibilityHelper["setControlType"]('TSB');
			oAccessibilityHelper["addTutor"]('TSB_TUT');
		}

		if (!UCF_StringUtil["bIsEmpty"](this["sAccessibilityDescription"])) {
			oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);
		}

		oAccessibilityHelper["setEnabled"](oSource["bEnabled"]);

		if (!UCF_StringUtil["bIsEmpty"](oSource["sTooltip"])) {
			oAccessibilityHelper["setTooltip"](oSource["sTooltip"]);
		}

		var sCapt = oSource["oDomRef"]["captt"];

		if (oSource["bHasTitleCaption"] && sCapt != null && !UCF_StringUtil["bIsEmpty"](sCapt)) {
			oAccessibilityHelper["addTooltip"](sCapt);
		}

		oAccessibilityHelper["setAccessKey"](oSource["sAccessKey"]);
		oAccessibilityHelper["setText"](oSource["sCaption"]);
		oAccessibilityHelper["setItemCount"](this["oItemNavigation"]["aItems"]["length"]);
		oAccessibilityHelper["setItemIndex"](oSource["iIndex"] + 1);
		if (oSource["iIndex"] !== this["iSelected"] && oSource["bEnabled"]) oAccessibilityHelper["addTutor"]('SELECT_TUT');
		oAccessibilityHelper["setSelected"](oSource["iIndex"] === this["iSelected"]);
		oAccessibilityHelper["addTutor"]('LRNAV_TUT');
		if (oSource["bIsClosable"] && oSource["bEnabled"]) {
			oAccessibilityHelper["addTutor"]('TS_ITM_CLOSE');
		}
	} else if (oBrowserEvent["oGetSource"]()["id"]["indexOf"]('-end') > -1 && oSource === this) {
		oAccessibilityHelper["setControlType"]('TS_END');
	} else if (oBrowserEvent["oGetSource"]()["id"]["indexOf"]('-start') > -1 && oSource === this) {
		oAccessibilityHelper["setControlType"]('TSB');
		oAccessibilityHelper["addTutor"]('TSB_START_SI', [oAccessibilityHelper["sGetSkipContainerText"]()]);
		oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](this["oItemNavigation"]["aItems"][this["iSelected"]]["oDomRef"]));
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onlsaccessibility"] = 0; };

/**###############################################################
 *
 * Section with all public methods
 *
 * ###############################################################
 */

/**
 * Sets the visibility state of the TabStrip control.
 * @param {string} sVisibility
 * @public
 */
UCF_TabStrip_standards["prototype"]["setVisibility"] = function(sVisibility) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["setVisibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sVisibility) === 'string', "typeof(sVisibility) === 'string'", "TabStrip_standards.js(1773): setVisibility"); };

	UCF_DomUtil["setVisibility"](this["oDomRef"], sVisibility);
	this["sVisibility"] = sVisibility;
	this["setClientProperty"]("Visibility", this["sVisibility"], true);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["setVisibility"] = 0; };

/**
 * Select the TabStripItem with the given Id for the TabStrip.
 * @param {string} sTabStripItemId - identifier of the TabStripItem that is to be selected.
 * @public
 */
UCF_TabStrip_standards["prototype"]["selectTabStripItem"] = function(sTabStripItemId) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["selectTabStripItem"]++; }; 

	var oSelectedTabItem = this["oGetItemById"](sTabStripItemId);
	var oDeselectedTabItem = this["aItems"][this["iSelected"]];

	if (!oSelectedTabItem) return;

	if (this["sEvaluateSelectability"](oSelectedTabItem) === this["eItemStatus"]["ACCESSIBLE"]) {

		this["proceedGenericSelectionSteps"](oSelectedTabItem);
		this["handleMeansOfSelection"](this["eMeansOfSelection"]["CALL"], oSelectedTabItem, oDeselectedTabItem);

		this["fireTabSelect"](this["sId"], oSelectedTabItem["sId"], oSelectedTabItem["iIndex"], this["oGetFirstItemInViewPort"]()["iIndex"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["selectTabStripItem"] = 0; };

/**
 * Sets the scroll position programmatically
 *
 * @public
 * @param {string} sId
 * @param {string} sItemId
 * @param {integer} iScrollTop
 * @param {integer} iScrollLeft
 */
UCF_TabStrip_standards["prototype"]["setScrollPosition"] = function(sId, sItemId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["setScrollPosition"]++; }; 

	if (typeof(sId) === 'undefined') {
		return;
	}
	if (typeof(sItemId) === 'undefined') {
		return;
	}
	if (this["sId"] !== sId) return;

	var oTabItem = this["oGetItemById"](sItemId);

	if (!oTabItem) return;

	if (oTabItem["sScrollingMode"] === 'NONE' ||
		!UCF_DomUtil["$"](oTabItem["sId"] + '-scrl')) return;

	if (oTabItem["oScrollArea"] === null) {
		oTabItem["loadScrollArea"]();
	}

	oTabItem["oScrollArea"]["setScrollPosition"](iScrollTop, iScrollLeft);

};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["setScrollPosition"] = 0; };
/**
 * Sets the scroll position programmatically
 *
 * @public
 * @param {string} sId
 * @param {string} sItemId
 * @return {integer}
 */
UCF_TabStrip_standards["prototype"]["getScrollPosition"] = function(sId, sItemId) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["getScrollPosition"]++; }; 

	if (typeof(sId) === 'undefined') {
		return null;
	}
	if (typeof(sItemId) === 'undefined') {
		return null;
	}
	if (this["sId"] !== sId) return null;

	var oTabItem = this["oGetItemById"](sItemId);

	if (!oTabItem) return null;

	if (oTabItem["sScrollingMode"] === 'NONE' ||
		!UCF_DomUtil["$"](oTabItem["sId"] + '-scrl')) return null;

	if (oTabItem["oScrollArea"] === null) {
		oTabItem["loadScrollArea"]();
	}
	return oTabItem["oScrollArea"]["oGetScrollPosition"]();
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["getScrollPosition"] = 0; };

/**
 * Gets the TabStripItem by given sTabItenId
 *
 * it also might return null or undefined in case that the sTabItenId is invalid
 * @private
 * @param {string} sTabItenId
 * @return {UCF_TabstripItem}
 */
UCF_TabStrip_standards["prototype"]["oGetItemById"] = function(sTabItenId) {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["oGetItemById"]++; }; 
	if (typeof(sTabItenId) === 'undefined') {
		return null;
	}
	var aItems = this["aItems"],
		oItem;
	for (var i = 0; i < aItems["length"]; i++) {
		oItem = aItems[i];
		if (oItem["sId"] === sTabItenId) {
			break;
		}
	}
	return oItem;

};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["oGetItemById"] = 0; };
/**###############################################################
 *
 *
 * Drag & Drop Section
 *
 * ###############################################################
 * implements method from UCF_Control
 * @private
 */
UCF_TabStrip_standards["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createDragDelegate"]++; }; 

	if (!this["sDragSourceInfo"])
		return;

	if (this["oDragDelegate"])
		return;

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_TabStripDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createDragDelegate"] = 0; };

/**
 * implements method from UCF_Control
 * @private
 */
UCF_TabStrip_standards["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createDropDelegate"]++; }; 

	if (!this["sDropTargetInfo"])
		return;

	if (this["oDropDelegate"])
		return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_TabStripDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["createDropDelegate"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_TabStrip_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["destroy"]++; }; 

	this["detachBrowserEvent"]('resize', this["oDomRef"]);
	this["detachBrowserEvent"]('scroll', this["oPanel"]);

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	if (this["oItemNavigation"]) this["oItemNavigation"]["destroy"]();

	if (this["oAFId"]) {
		UCF_JsUtil["cancelAnimationFrame"](this["oAFId"]);
		this["oAFId"] = null;
	}

	this["oItemNavigation"] = null;
	this["aItems"] = null;
	this["oItemMenu"] = null;
	this["oPanel"] = null;
	this["oPreviousButton"] = null;
	this["oNextButton"] = null;
	this["oMenuButton"] = null;
	this["oTabstripDelegate"] = null;
	this["onTouchStart"] = null;
	this["onTouchEnd"] = null;
	this["iSelected"] = null;
	this["iWidthBeforeResize"] = null;
	this["iVisibilityThreashold"] = null;
	this["oMoreIndicatorItem"] = null;
	this["sFocusType"] = null;
	this["bInitialized"] = null;
	if (this["oTabstripDelegate"]) {
		this["oTabstripDelegate"]["destroy"]();
		this["oTabstripDelegate"] = null;
	}
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}
	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	this["sTimeOutId"] = null;
	this["sVisibility"] = null;
	this["iCurrentIndex"] = null;
	this["iStartXCoordinate"] = null;
	this["iStartYCoordinate"] = null;
	UCF_TabStrip.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["destroy"] = 0; };

/**
 * The ResizeEventHelper will calculate its initial values during attach.
 * This has to be done when all other controls (especially PopupWindow) have already initialized.
 * Otherwise it may happen that we get a resize immediately after re-rendering and it will cause a visible glitch - especially with IE9/10 Std. Mode correction codeing
 */
UCF_TabStrip_standards["prototype"]["onUpdateComplete"] = function() {;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onUpdateComplete"]++; }; 
	this["attachBrowserEvent"]('resize', this["oPanel"]);
};;if (__UCF_COVERAGE__) { UCF_TabStrip_standards["_"]["onUpdateComplete"] = 0; };

UCF_TabStrip_standards.prototype["aPublicMethods"] = ["setVisibility","selectTabStripItem","setScrollPosition","getScrollPosition"].concat(UCF_TabStrip_standards.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TableFieldNavigationDelegate"] = function() {/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_FieldNavigationDelegate */
/// <reference path="./FieldNavigationDelegate.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>

/**
 * Standard selection behaviour of browsers for INPUT elements:
 * <TabIn>: value gets selected
 * <Click>: Value is not selected, caret is set to the click position
 *
 * For tables, we decided to have another (Excel-like) selection behaviour:
 * <TabIn>, <Click> (to get the focus, "first click": Value gets selected;
 * the table/field is in "table navigation mode"
 * <Click> (to switch in edit mode, "follow up click"): Caret is set to the
 * click position, the table/field is in "edit mode"
 *
 * The default behaviour of the browsers is to set the caret in the mouseup
 * event (and remove the selection thereby); we have to avoid this and cancel
 * the mouseup event for that case
 *
 * @class UCF_TableFieldNavigationDelegate
 * @extends UCF_Object
 * @param {UCF_EditFieldBase} oControl the field
 */
function UCF_TableFieldNavigationDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["UCF_TableFieldNavigationDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		this["oControl"] = oControl;
		this["bEditMode"] = false;
		this["bKeepEditMode"] = false;
		this["iSelectionStart"] = this["oControl"]["sGetValue"]()["length"];
		this["iSelectionEnd"] = this["iSelectionStart"];

		/** @type {boolean} bMouseInteraction flag required for selection */
		this["bMouseInteraction"] = false;
		/** @type {Date} */
		this["oTimer"] = null;
		/** @type {boolean} bBlockSelectionActive */
		this["bBlockSelectionActive"] = false;

		var oParent = this["oControl"]["oGetParent"]();
		this["oParentSapTable"] = null;

		while (oParent) {
			if (UCF_JsUtil["bInstanceOf"](oParent, 'UCF_SapTable') || UCF_JsUtil["bInstanceOf"](oParent, 'UCF_SapTableCS')) {
				this["oParentSapTable"] = oParent;
				break;
			}
			oParent = oParent["oGetParent"]();
		}
		if (this["oControl"]["bUsedInSapTable"] && this["oParentSapTable"]) {
			this["oControl"]["attachEvent"](this["oControl"]["E_EVENTS"]["EditMode"], this["oParentSapTable"], "onCellEditorEditMode");
			this["oControl"]["attachEvent"](this["oControl"]["E_EVENTS"]["NavigationMode"], this["oParentSapTable"], "onCellEditorNavigationMode");
			this["bBlockSelectionActive"] = this["oParentSapTable"]["bBlockSelectionActive"]();
		}
	}
};window["UCF_TableFieldNavigationDelegate"] = UCF_TableFieldNavigationDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TableFieldNavigationDelegate"); UCF_TableFieldNavigationDelegate["_"] = {UCF_TableFieldNavigationDelegate: 0}; }; ;
UCF_TableFieldNavigationDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_FieldNavigationDelegate"))(); UCF_TableFieldNavigationDelegate.prototype["sClassName"] = "UCF_TableFieldNavigationDelegate";

UCF_TableFieldNavigationDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["destroy"]++; }; 
	this["detachAnyEventHandler"]();
	this["iSelectionEnd"] = null;
	this["iSelectionStart"] = null;
	this["bMouseInteraction"] = null;
	this["oTimer"] = null;
	this["bBlockSelectionActive"] = null;
	this["oParentSapTable"] = null;

	UCF_FieldNavigationDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["destroy"] = 0; };

UCF_TableFieldNavigationDelegate["prototype"]["attachAnyEventHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["attachAnyEventHandler"]++; }; 
	var oBrowserWindow = this["oControl"]["oLS"]["oBrowserWindow"];

	oBrowserWindow["attachEvent"](
		oBrowserWindow["E_EVENTS"]["AnyEvent"],
		this,
		'onAnyEvent'
	);
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["attachAnyEventHandler"] = 0; };

UCF_TableFieldNavigationDelegate["prototype"]["detachAnyEventHandler"] = function() {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["detachAnyEventHandler"]++; }; 
	var oBrowserWindow = this["oControl"]["oLS"]["oBrowserWindow"];

	oBrowserWindow["detachEvent"](
		oBrowserWindow["E_EVENTS"]["AnyEvent"],
		this,
		'onAnyEvent'
	);
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["detachAnyEventHandler"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlshotkey"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlshotkey"]++; }; 
	if (UCF_KeyboardHelper["bIsEventForKey"](oHotkey, UCF_KeyCodes["F2"])) {
		this["handleF2"](oHotkey);
	}
	if (UCF_KeyboardHelper["bIsEventForKey"](oHotkey, UCF_KeyCodes["A"], 'C')) {
		this["handleCtrlA"](oHotkey);
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlshotkey"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oHotkey the hotkey
 */
UCF_TableFieldNavigationDelegate["prototype"]["handleF2"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["handleF2"]++; }; 
	if (new Date()["getTime"]() - this["oTimer"] < 300) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'passing through for drilldown functionality in tables', "TableFieldNavigationDelegate.js(123): handleF2"); };
		this["oTimer"] = null;
	} else {
		this["oTimer"] = new Date()["getTime"]();
		if (this["bEditMode"]) {
			// save selection start and end
			this["iSelectionStart"] = UCF_DomUtil["iGetSelectionStart"](
				this["oControl"]["oDomRef"]
			);
			this["iSelectionEnd"] = UCF_DomUtil["iGetSelectionEnd"](
				this["oControl"]["oDomRef"]
			);
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'handled to switch on navigationMode in tables', "TableFieldNavigationDelegate.js(135): handleF2"); };
			this["navigationMode"]();
		} else {
			if (this["oControl"]["bIsWriteable"]()) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'handled to switch off navigationMode in tables', "TableFieldNavigationDelegate.js(139): handleF2"); };
				this["editMode"]();
				UCF_DomUtil["setSelection"](
					this["oControl"]["oDomRef"],
					this["iSelectionStart"],
					this["iSelectionEnd"]
				);
			} else {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'passing through for drilldown functionality in tables', "TableFieldNavigationDelegate.js(147): handleF2"); };
				this["oTimer"] = null;
			}
		}
		if (window["UCF_System"]["bIs508"]) {
			this["oControl"]["refocus"]();
		}
		// cancel here as we need to let the hotkey bubble for drilldown - see above
		oHotkey["cancelBubble"]();

	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["handleF2"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oHotkey the hotkey
 */
UCF_TableFieldNavigationDelegate["prototype"]["handleCtrlA"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["handleCtrlA"]++; }; 
	if (
		// Limitation: Not in IE: Focus gets lost!
		!UCF_UserAgent["bIsIE"]() &&
		// not selected yet
		!this["bSelected"] &&
		// AND read only or disabled
		!this["oControl"]["bIsWriteable"]()
	) {
		// select the text and cancel the event.
		// otherwise: Let the event bubble, and the table raises a RowSelect event
		this["selectText"]();
		oHotkey["cancelBubble"]();
		oHotkey["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["handleCtrlA"] = 0; };

/** @override */
// eslint-disable-next-line complexity
UCF_TableFieldNavigationDelegate["prototype"]["onkeydown"] = function(oKeydown) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onkeydown"]++; }; 
	this["bMouseInteraction"] = false;

	if (
		UCF_DomUtil["oGetActiveElement"]() === this["oControl"]["oDomRef"] &&
		this["oControl"]["bIsWriteable"]()
	) {
		if (this["bEditMode"] && (
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["DELETE"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ESCAPE"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["INSERT"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"])
			)) {
			oKeydown["cancelBubble"]();
		} else if (this["bIsImplicitEditModeSwitch"](oKeydown)) {
			this["editMode"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onkeydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @return {boolean}
 */
UCF_TableFieldNavigationDelegate["prototype"]["bIsImplicitEditModeSwitch"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["bIsImplicitEditModeSwitch"]++; }; 
	/** @type {number} */
	var iKeyCode = oBrowserEvent["iKeyCode"]();

	return UCF_KeyboardHelper["bIsEditKey"](iKeyCode)
		&& iKeyCode !== UCF_KeyCodes["ENTER"]
		&& (!oBrowserEvent["bCtrl"]() || oBrowserEvent["bAlt"]())
		&& !UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["SPACE"])
		&& UCF_DomUtil["oGetActiveElement"]() === this["oControl"]["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["bIsImplicitEditModeSwitch"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onpaste"] = function() {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onpaste"]++; }; 
	this["editMode"]();
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onpaste"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onmousedown"] = function(oMouseDown) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onmousedown"]++; }; 
	// set bMouseInteraction flag, so that we can decide in navigationMode()
	// if the selection needs to be set
	this["bMouseInteraction"] = true;

	if (UCF_DomUtil["oGetActiveElement"]() === this["oControl"]["oDomRef"]) {
		// field is already active element -> switch to edit mode
		this["editMode"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onmousedown"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsfocus"]++; }; 
	if (!this["oControl"]["bIsWriteable"]() && this["oControl"]["oDomRef"]["tagName"] !== 'INPUT') {
		this["attachAnyEventHandler"]();
	}

	if (
		this["oControl"]["oFakeFieldDelegate"] &&
		this["oControl"]["oDomRef"]["tagName"] !== 'INPUT'
	) {
		// ignore this, there's another lsfocus when the fakefield
		// is replaced by an <input>
		return;
	}

	if (oBrowserEvent["bIsTouchInteraction"]()) {
		this["editMode"]();
	} else if (
		this["bKeepEditMode"] ||
		oBrowserEvent["oFromElement"] === this["oControl"]["oDomRef"]
	) {
		this["bKeepEditMode"] = false;
	} else {
		this["navigationMode"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsfocus"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsblur"] = function(oBlur) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsblur"]++; }; 
	this["detachAnyEventHandler"]();
	this["bSelected"] = false;
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsblur"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onAnyEvent"] = function(oAnyEvent) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onAnyEvent"]++; }; 
	var oBrowserEvent = oAnyEvent["oGetParam"]('oBrowserEvent');

	switch (oBrowserEvent["sGetName"]()) {
		case 'mousedown':
			if (this["oControl"]["oLS"]["oControlFactory"]["oGetEnclosingControlByDomRef"](oBrowserEvent["oGetSource"]()) !== this["oControl"]) {
				this["deselectText"]();
			}
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onAnyEvent"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onmouseup"] = function(oMouseUp) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onmouseup"]++; }; 
	if (
		// mouseup but not activeElement? -> mousedown was outside, i.e. that's
		// not a click!
		UCF_DomUtil["oGetActiveElement"]() === this["oControl"]["oDomRef"] &&
		!this["bEditMode"] &&
		// CSN 1880059247: in IE, when starting to select text from a readonly
		// cell, one can continue changing the selection after the mouseup, because
		// the mouseup would be canceled
		this["oControl"]["bIsWriteable"]()
	) {
		if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsEdgeHtml"]()) {
			// IE11 and Edge don't select the value - so we do it explicitely
			this["oControl"]["select"]();
		}
		// browsers set the caret in the mouseup event
		// and remove the selection thereby...
		// therefore, we cancel this event for the browser
		oMouseUp["cancel"]();
	}
	// for fake fields we can't select the text here as
	// the SPAN might not have been exchanged yet
	// text selection is done in .navigationMode()
	// not required in Quirks as fake field is not supported in Quirks
	if (window["UCF_System"]["sDevice"] === 'standards' && !UCF_UserAgent["bIsIE"]() &&
		this["oControl"]["bIsWriteable"]() &&
		 //do not select all when there is already a selection
		 //for example triggered in editMode via mouse drag selection
		!UCF_DomUtil["sGetSelectionText"](this["oControl"]["oDomRef"])) {
		this["selectText"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onmouseup"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsleft"] = function(oLsLeft) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsleft"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsleft"]["apply"](this, arguments);
	} else {
		this["bubbleToSapTable"](oLsLeft);
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsleft"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsleftmodifier"] = function(oLsLeftModifier) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsleftmodifier"]++; }; 
	if (this["bBlockSelectionActive"] && this["bEditMode"]) oLsLeftModifier["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsleftmodifier"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsright"] = function(oLsRight) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsright"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsright"]["apply"](this, arguments);
	} else {
		this["bubbleToSapTable"](oLsRight);
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsright"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsrightmodifier"] = function(oLsRightModifier) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsrightmodifier"]++; }; 
	if (this["bBlockSelectionActive"] && this["bEditMode"]) oLsRightModifier["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsrightmodifier"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsdragstart"] = function(oLsDragStart) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsdragstart"]++; }; 
	if (this["bBlockSelectionActive"] && this["bEditMode"]) oLsDragStart["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsdragstart"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsup"] = function(oLsup) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsup"]++; }; 
	if (!this["oControl"]["bShouldHandleLsUp"](oLsup)) {
		this["bubbleToSapTable"](oLsup);
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsup"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsdown"] = function(oLsdown) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsdown"]++; }; 
	if (!this["oControl"]["bShouldHandleLsDown"](oLsdown)) {
		this["bubbleToSapTable"](oLsdown);
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsdown"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["bubbleToSapTable"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["bubbleToSapTable"]++; }; 
	this["deselectText"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["bubbleToSapTable"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsspace"] = function(oLsSpace) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsspace"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsspace"]["apply"](this, arguments);
	} else {
		if (UCF_DomUtil["oGetActiveElement"]() === this["oControl"]["oDomRef"] &&
		!this["oParentSapTable"]["bCurrentSelectionBound"](this["oControl"]["oDomRef"])) {
			//CSN: 2270151644 - space should be handled as an edit key
			this["editMode"]();
		} else {
			oLsSpace["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsspace"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsspacemodifier"] = function(oLsSpaceModifier) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsspacemodifier"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsspacemodifier"]["apply"](this, arguments);
	} else {
		oLsSpaceModifier["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsspacemodifier"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsselect"] = function(oLsSelect) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsselect"]++; }; 
	if (this["bEditMode"]) {
		oLsSelect["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsselect"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsselectmodifier"] = function(oLsSelectModifier) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsselectmodifier"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsselectmodifier"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsselectmodifier"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlshome"] = function(oLsHome) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlshome"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlshome"]["apply"](this, arguments);
	} else {
		oLsHome["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlshome"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsend"] = function(oLsEnd) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsend"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsend"]["apply"](this, arguments);
	} else {
		oLsEnd["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsend"] = 0; };

/** @override */
UCF_TableFieldNavigationDelegate["prototype"]["onlsescape"] = function(oLsEscape) {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsescape"]++; }; 
	if (this["bEditMode"] && this["oControl"]["sGetCurrentValue"]() === this["oControl"]["sEscapeValue"]) {
		this["navigationMode"]();
		oLsEscape["cancel"]();
		oLsEscape["cancelBubble"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'toggle Edit Mode', "TableFieldNavigationDelegate.js(431): onlsescape"); };
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["onlsescape"] = 0; };


/** @protected */
UCF_TableFieldNavigationDelegate["prototype"]["navigationMode"] = function() {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["navigationMode"]++; }; 
	this["bEditMode"] = false;
	this["oControl"]["fireEvent"](this["oControl"]["E_EVENTS"]["NavigationMode"], {});
	if (this["oControl"]["bOpen"] && !this["oControl"]["sBehavior"] === 'DROPDOWNSELECT') {
		this["oControl"]["closeFieldHelp"]();
	}
	// if no mouse interation or
	// if fake field has just been exchanged via mouse interaction
	// select the text here
	// else we will select the text on mouseup
	if (this["oControl"]["bIsWriteable"]() && UCF_UserAgent["bIsIE"]()) {
		// don't change anything for IE11
			this["selectText"]();
	} else if (this["oControl"]["bIsWriteable"]() &&
		(!this["bMouseInteraction"] || (this["bMouseInteraction"] &&
			this["oControl"]["bIsWriteable"]() &&
			this["oControl"]["bIsFakeField"] &&
			this["oControl"]["bFakeFieldExchangeInProcess"] &&
			this["oControl"]["oDomRef"]["nodeName"] === 'INPUT'))) {
		this["selectText"]();
		this["oControl"]["bFakeFieldExchangeInProcess"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["navigationMode"] = 0; };

/** @protected */
UCF_TableFieldNavigationDelegate["prototype"]["editMode"] = function() {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["editMode"]++; }; 
	if (this["oControl"]["bIsWriteable"]()) {
		this["bEditMode"] = true;
		if (this["oControl"]["bOpen"] && !this["oControl"]["sBehavior"] === 'DROPDOWNSELECT') {
			this["oControl"]["closeFieldHelp"]();
		}
		// select text on touch devices
		if (this["bMouseInteraction"] &&
		this["oControl"]["bIsWriteable"]() &&
		this["oControl"]["bIsFakeField"] &&
		this["oControl"]["bFakeFieldExchangeInProcess"] &&
		this["oControl"]["oDomRef"]["nodeName"] === 'INPUT') {
			this["selectText"]();
			this["oControl"]["bFakeFieldExchangeInProcess"] = false;
		}
		this["oControl"]["fireEvent"](this["oControl"]["E_EVENTS"]["EditMode"], {});
	}
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["editMode"] = 0; };

/** @protected */
UCF_TableFieldNavigationDelegate["prototype"]["keepEditMode"] = function() {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["keepEditMode"]++; }; 
	this["bKeepEditMode"] = true;
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["keepEditMode"] = 0; };

/** @private */
UCF_TableFieldNavigationDelegate["prototype"]["selectText"] = function() {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["selectText"]++; }; 
	/** @type {Document} */
	var document = window["document"];
	/** @type {Selection} */
	var selection;
	/** @type {Range} */
	var range;

	if (this["oControl"]["oDomRef"]["select"]) {
		if (UCF_UserAgent["bIsFirefox"]()) {
			this["oControl"]["select"]();
		} else {
			this["oControl"]["oDomRef"]["select"]();
		}
		if (UCF_UserAgent["bIsSafari"]()) {
			// Safari dosn't raise onselect browser event
			this["oControl"]["sSelectedValue"] = this["oControl"]["oDomRef"]["value"]["slice"](
				this["oControl"]["oDomRef"]["selectionStart"],
				this["oControl"]["oDomRef"]["selectionEnd"]
			);
		}
	} else if (window["getSelection"] && document["createRange"]) {
		// Chrome, Firefox, IE11
		selection = window["getSelection"]();
		range = document["createRange"]();
		range["selectNodeContents"](this["oControl"]["oDomRef"]);
		selection["removeAllRanges"]();
		selection["addRange"](range);
	} else if (document["body"]["createTextRange"]) {
		// IE11
		range = document["body"]["createTextRange"]();
		range["moveToElementText"](this["oControl"]["oDomRef"]);
		range["select"]();
	}
	this["bSelected"] = true;
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["selectText"] = 0; };

/** @private */
UCF_TableFieldNavigationDelegate["prototype"]["deselectText"] = function() {;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["deselectText"]++; }; 
	if (this["oControl"]["oDomRef"]["select"]) {
		this["oControl"]["oDomRef"]["selectionStart"] = 0;
		this["oControl"]["oDomRef"]["selectionEnd"] = 0;
	} else {
		UCF_DomUtil["removeSelection"]();
	}
	this["bSelected"] = false;
};;if (__UCF_COVERAGE__) { UCF_TableFieldNavigationDelegate["_"]["deselectText"] = 0; };

};
sap["ls"]["preload"]["UCF_TabstripDelegate_standards"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>

/**
 * TabstripDelegate_standards
 *
 * 
 * @class
 * @param {UCF_Tabstrip_Items} aItems
 * @param {number} iSelected
 * @param {number} iVisibilityThreashold
 */
function UCF_TabstripDelegate_standards(aItems, iSelected, iVisibilityThreashold) {if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["UCF_TabstripDelegate_standards"]++; }; 
	this["aItems"] = aItems;
	this["iSelected"] = iSelected;
	this["iVisibilityThreashold"] = iVisibilityThreashold;
};window["UCF_TabstripDelegate_standards"] = UCF_TabstripDelegate_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TabstripDelegate_standards"); UCF_TabstripDelegate_standards["_"] = {UCF_TabstripDelegate_standards: 0}; }; ;
UCF_TabstripDelegate_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_TabstripDelegate_standards.prototype["sClassName"] = "UCF_TabstripDelegate_standards";

/**#####################################################################
 *
 * SECTION WHERE ALL RELEVANT STYLES ARE ASSIGNED TO THE SELECTED ITEM
 *
 * #####################################################################
 */

/**
 * An enumeration of all the selection states an item can assume can assume.
 *
 * @private
 */
UCF_TabstripDelegate_standards["prototype"]["eSelectionState"] = {
	'SELECTED': 'SELECTED',
	'UNSELECTED': 'UNSELECTED'
};

/**
 * An enumeration of all the selection states an item can assume can assume.
 *
 * @private
 */
UCF_TabstripDelegate_standards["prototype"]["ePosition"] = {
	'FIRST': 'FIRST',
	'LAST': 'LAST',
	'SOLE_ITEM': 'SOLE_ITEM',
	'ANY': 'ANY',
	'MORE_INDICATOR': 'MORE_INDICATOR'
};

/**
 * An enumeration of all the interaction states an item can assume can assume.
 *
 * @private
 */
UCF_TabstripDelegate_standards["prototype"]["eInterActionState"] = {
	'ENABLED': 'ENABLED',
	'DISABLED': 'DISABLED'
};

/**
 * Determines whether the item is selected or unselected
 * @param {UCF_TabstripItem} oItem
 * @return {string}
 * @private
 */
UCF_TabstripDelegate_standards["prototype"]["sGetSelectionState"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["sGetSelectionState"]++; }; 
	if (oItem["iIndex"] === this["iSelected"]) {
		return this["eSelectionState"]["SELECTED"];
	} else {
		return this["eSelectionState"]["UNSELECTED"];
	}
};;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["sGetSelectionState"] = 0; };

/**
 * Determines whether the item can be selected
 * @param {UCF_TabstripItem} oItem
 * @return {string}
 * @private
 */
UCF_TabstripDelegate_standards["prototype"]["sGetInterActionState"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["sGetInterActionState"]++; }; 
	if (oItem["bEnabled"]) {
		return this["eInterActionState"]["ENABLED"];
	} else {
		return this["eInterActionState"]["DISABLED"];
	}
};;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["sGetInterActionState"] = 0; };

/**
 * Determines the position of the item
 * @param {UCF_TabstripItem} oItem
 * @return {string}
 * @private
 */
UCF_TabstripDelegate_standards["prototype"]["sGetPosition"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["sGetPosition"]++; }; 

	if (this["aItems"]["length"] === 1) {
		return this["ePosition"]["SOLE_ITEM"];
	} else if (oItem["iIndex"] === 0) {
		return this["ePosition"]["FIRST"];
	} else if (oItem["iIndex"] === this["aItems"]["length"] - 1) {
		return this["ePosition"]["LAST"];
	} else if (this["oGetFirstItemInViewPort"]()["iIndex"] > 0) {
		return this["ePosition"]["MORE_INDICATOR"];
	} else {
		return this["ePosition"]["ANY"];
	}

};;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["sGetPosition"] = 0; };

/**
 * Returns the first item visible in the view port
 * @return {UCF_TabstripItem}
 * @private
 */
UCF_TabstripDelegate_standards["prototype"]["oGetFirstItemInViewPort"] = function() {;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["oGetFirstItemInViewPort"]++; }; 

	if (!this["aItems"]) return;

	var aItems = this["aItems"];

	for (var i = 0; i < aItems["length"]; i++) {
		if (aItems[i]["oDomRef"]["offsetTop"] === this["iVisibilityThreashold"])
			// eslint-disable-next-line consistent-return
			return aItems[i];
	}
};;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["oGetFirstItemInViewPort"] = 0; };

/**
 * This is an enumeration with predefined callback function that an item
 * can use to trigger selection.
 */
UCF_TabstripDelegate_standards["prototype"]["eToggleMethods"] = {

	'switchToUnselected': function(oData) {
		var sSwitchTo = oData["determineField"](oData["sPosition"], oData["sStateToSwitchTo"]);
		oData["fReplace"](oData["oItem"]["oDomRef"], oData["sSwitchFrom"], oData["oItem"]["eStyles"][sSwitchTo]);
		oData["oItem"]["oDomRef"]["removeAttribute"]('selected');
	},

	'switchToSelected': function(oData) {
		var sSwitchTo = oData["determineField"](oData["sPosition"], oData["sStateToSwitchTo"]);
		oData["fReplace"](oData["oItem"]["oDomRef"], oData["sSwitchFrom"], oData["oItem"]["eStyles"][sSwitchTo]);
		oData["oItem"]["oDomRef"]["setAttribute"]('selected', 'true');
	}
};

UCF_TabstripDelegate_standards["prototype"]["styleFactory"] = function(fCallback, oItem, sStateToSwitchTo) {;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["styleFactory"]++; }; 

	var determineField = function(sPosition, sSelectionState) {
		return sPosition + '_' + sSelectionState;
	};

	var sPosition = this["sGetPosition"](oItem),
		sSelectionState = this["sGetSelectionState"](oItem),
		sSwitchFrom = determineField(sPosition, sSelectionState);

	var oData = {
		"determineField": determineField,
		"sStateToSwitchTo": sStateToSwitchTo,
		"oItem": oItem,
		"fReplace": UCF_DomUtil["replaceClass"],
		"sSwitchFrom": oItem["eStyles"][sSwitchFrom],
		"sSelectionState": sSelectionState,
		"sPosition": sPosition
	};

	fCallback(oData);
};;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["styleFactory"] = 0; };

/**
 * destructor
 */
UCF_TabstripDelegate_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["destroy"]++; }; 
	this["aItems"] = null;
	this["iSelected"] = null;
	this["iVisibilityThreashold"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TabstripDelegate_standards["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_TagCloud"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TagCloud(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TagCloud["_"]["UCF_TagCloud"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "TagCloud.js(19): UCF_TagCloud"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TagCloud.js(20): UCF_TagCloud"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TagCloud.js(21): UCF_TagCloud"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_TagCloud"] = UCF_TagCloud; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TagCloud"); UCF_TagCloud["_"] = {UCF_TagCloud: 0}; }; ;
UCF_TagCloud["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TagCloud.prototype["sClassName"] = "UCF_TagCloud";

/**
 * Returns the max size of the contained links for Importance calculation in item accessibility
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {number} the maximum size of the items contained in the tag cloud
 */
UCF_TagCloud["prototype"]["iGetMaxSize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TagCloud["_"]["iGetMaxSize"]++; }; 
	var aItems = this["oDomRef"]["getElementsByTagName"]("A"),
		iSize = 1;
	for (var i = 0; i < aItems["length"]; i++) {
		var oItem = this["oGetControlById"](aItems[i]["getAttribute"]("id"));
		if (oItem) {
			iSize = Math["max"](iSize, oItem["iSize"]);
		}
	}

	return iSize;
};;if (__UCF_COVERAGE__) { UCF_TagCloud["_"]["iGetMaxSize"] = 0; };

/**
 * Skip to the next control
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_TagCloud["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TagCloud["_"]["onlsskipforward"]++; }; 
	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_TagCloud["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_TagCloud["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TagCloud["_"]["onlsskipback"]++; }; 
	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_TagCloud["_"]["onlsskipback"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TagCloud["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TagCloud["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TagCloud.js(72): onlsaccessibility"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TagCloud.js(73): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setControlType"]("TAGCLOUD", [this["oDomRef"]["getElementsByTagName"]("A")["length"]]);
	oAccessibilityHelper["addTutor"]("TAGCLOUD_TUT");
};;if (__UCF_COVERAGE__) { UCF_TagCloud["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TagCloud["prototype"]["aAttributeNames"] = ["sVisibility","sCustomData","sAccessibilityDescription"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TagCloud["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TagCloud["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_TagCloud["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_TagCloud["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TagCloud["prototype"]["sAccessibilityDescription"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_TagCloud["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TagCloud["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["sAccessibilityDescription"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_TagCloud["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_TagCloudItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TagCloudItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["UCF_TagCloudItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "TagCloudItem.js(22): UCF_TagCloudItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TagCloudItem.js(23): UCF_TagCloudItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TagCloudItem.js(24): UCF_TagCloudItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	this["bIsFocusable"] = window["UCF_System"]["bIs508"] || (!window["UCF_System"]["bIs508"] && this["bEnabled"]);

};window["UCF_TagCloudItem"] = UCF_TagCloudItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TagCloudItem"); UCF_TagCloudItem["_"] = {UCF_TagCloudItem: 0}; }; ;
UCF_TagCloudItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TagCloudItem.prototype["sClassName"] = "UCF_TagCloudItem";

UCF_TagCloudItem["prototype"]["eStyles"] = {
	"TAGCLOUDITEM_FOCUSABLE": "lsTagCloudItem--focusable",
	"TAGCLOUDITEM_TOUCHABLE": "lsTagCloudItem--touchable"
};
/**
 * Handles the select event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TagCloudItem["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TagCloudItem.js(43): onlsselect"); };
	if (this["bEnabled"]) {
		this["fireSelect"](this["sId"], this["oGetParent"]()["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["onlsselect"] = 0; };

/**
 * Handles the click event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TagCloudItem["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["onclick"]++; }; 
	this["toggleFocusClass"](!oBrowserEvent["bIsTouchInteraction"]());

	this["onlsselect"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["onclick"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TagCloudItem["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TagCloudItem.js(69): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](this["oDomRef"]));
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["setControlType"]("LN");
	oAccessibilityHelper["addEnabledTutor"]("LN_TUT", this["bEnabled"]);
	oAccessibilityHelper["setExplanationText"](oAccessibilityHelper["sGetText"]("TAGCLOUD_IMP", [this["iSize"], this["oGetParent"]()["iGetMaxSize"]()]));
};;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 */
UCF_TagCloudItem["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["destroy"]++; }; 

	this["bIsFocusable"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["destroy"] = 0; };

/**
 * remove/add the focus class and add/remove the touch class
 *
 * @param { boolean } bSetFocusClass -	if it should add/remove the focus css class
 * @private
 */
UCF_TagCloudItem["prototype"]["toggleFocusClass"] = function(bSetFocusClass) {;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["toggleFocusClass"]++; }; 

	if (!this["bIsFocusable"]) return;

	if (bSetFocusClass) {
		if (!UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["TAGCLOUDITEM_FOCUSABLE"]))
			UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["TAGCLOUDITEM_FOCUSABLE"]);
		UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["TAGCLOUDITEM_TOUCHABLE"]);
	} else {
		if (!UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["TAGCLOUDITEM_TOUCHABLE"]))
			UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["TAGCLOUDITEM_TOUCHABLE"]);

		UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["TAGCLOUDITEM_FOCUSABLE"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["toggleFocusClass"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TagCloudItem["prototype"]["aAttributeNames"] = ["sText","bEnabled","sHitCount","sTooltip","iSize","sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TagCloudItem["prototype"]["aEventNames"] = ["Select"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TagCloudItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_TagCloudItem["prototype"]["sText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_TagCloudItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_TagCloudItem["prototype"]["sHitCount"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TagCloudItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {number}
 */
UCF_TagCloudItem["prototype"]["iSize"] = 1;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_TagCloudItem["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_TagCloudItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_TagCloudItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["bEnabled"] = true;
	this["sHitCount"] = '';
	this["sTooltip"] = '';
	this["iSize"] = 1;
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("HitCount", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Size", 1, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the TagCloudItem that is selected
 * @param {string} sTagCloudId Id of the TagCloud control
 * @fires TagCloudItem::Select
 */
UCF_TagCloudItem["prototype"]["fireSelect"] = function(sId, sTagCloudId) {;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, TagCloudId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "TagCloudItem.js(212): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TagCloudItem.js(213): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TagCloudItem.js(214): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTagCloudId != null, "sTagCloudId != null", "TagCloudItem.js(215): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTagCloudId) == "string", "typeof(sTagCloudId) == \"string\"", "TagCloudItem.js(216): fireSelect"); };
	mParams = {
		"Id": sId,
		"TagCloudId": sTagCloudId
	};
	
	if (sTagCloudId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sTagCloudId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "TagCloudId");
			}
		}
	this["fireSemanticEvent"]("TagCloudItem", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TagCloudItem["_"]["fireSelect"] = 0; };

};
sap["ls"]["preload"]["UCF_TextBar"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TextBar(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TextBar["_"]["UCF_TextBar"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "TextBar.js(24): UCF_TextBar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TextBar.js(25): UCF_TextBar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TextBar.js(26): UCF_TextBar"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["allowTextSelection"]();

};window["UCF_TextBar"] = UCF_TextBar; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TextBar"); UCF_TextBar["_"] = {UCF_TextBar: 0}; }; ;
UCF_TextBar["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TextBar.prototype["sClassName"] = "UCF_TextBar";

/**
 * Sets the screen reader text for the text view
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event
 */
UCF_TextBar["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextBar["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextBar.js(40): onlsaccessibility"); };

	var oControl = oBrowserEvent["oGetSourceControl"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		sText = UCF_DomUtil["sGetInnerText"](oControl["oDomRef"]);

	//Textbar has no control type announcement just the text
	oAccessibilityHelper["setText"](sText);
};;if (__UCF_COVERAGE__) { UCF_TextBar["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TextBar["prototype"]["aAttributeNames"] = ["sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TextBar["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TextBar["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_TextBar["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_TextBar["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_TextBar["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TextBar["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_TextBar["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_TextEdit"] = function() {/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_BrowserWindow */
/// <reference path="../browser/BrowserWindow.js"/>
/* global UCF_ScrollArea */
/// <reference path="../controls/base/ScrollArea.js"/>
/* global UCF_LayeredControl */
/// <reference path="../controls/base/LayeredControl.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>

/**
 * TextEdit
 *
 * @constructor
 * 
 * @version
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TextEdit(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["UCF_TextEdit"]++; }; 
	/** @type {HTMLElement} */
	var oScrollDomRef;
	/** @type {UCF_Page} */
	var oPage;
	/** @type {UCF_PopupManager} */
	var oPopupManager;

	// necessary for inheritance of InplaceEdit
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oDomRef === 'object', "typeof oDomRef === 'object'", "TextEdit.js(59): UCF_TextEdit"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TextEdit.js(60): UCF_TextEdit"); };
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TextEdit.js(61): UCF_TextEdit"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		// use blur instead of lsblur because value has not changed on lsblur when
		// you drag the value away. onchange is to early as well.
		this["attachBrowserEvent"]('blur', oDomRef);
		this["attachBrowserEvent"]('cut', oDomRef);

		// internal css 626118/2014 -> TextEdit does not release focus in IE if
		// beforedeactivate has been attached since onbeforedeactivate handler is
		// only neccessary in IE QUIRKS mode to get the correct selection/cursor
		// position attach only in IE QUIRKS mode to fix the focus issue in IE
		// STANDARDS mode (see also CL185724, CL194158, CL203159)
		if (UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== 'standards') {
			this["attachBrowserEvent"]('beforedeactivate', oDomRef);
		}

		/** @type {boolean} don't highlight the default button */
		this["bIgnoreDefaultButton"] = true;

		/**
		 * @private
		 * @type {boolean} Ensure text selection is possible
		 */
		this["bAllowTextSelection"] = true;

		/**
		 * @private
		 * @type {boolean} flag to check if a textarea height in a table cell
		 * already calculated
		 */
		this["bHeightAdapted"] = false;

		/**
		 * @private
		 * @type {boolean} flag to check if a textarea height calculation needed
		 */
		this["bAdjustHeightToCellNeeded"] = this["bUsedInSapTable"] &&
			!this["bItsMode"] &&
			this["oGetParent"]()["sClassName"] === 'UCF_SapTable';

		/**
		 * @private
		 * @type {boolean} flag to enable arrow key navigation etc., you can only
		 * toggle the navigation mode in a table
		 */
		this["bNavigation"] = !this["bUsedInSapTable"];
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation initially = ' + this["bNavigation"], "TextEdit.js(109): UCF_TextEdit"); };

		/**
		 * @private
		 * @type {number} End of selection
		 */
		this["iEndSelection"] = -1;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iEndSelection = -1', "TextEdit.js(116): UCF_TextEdit"); };
		/**
		 * @private
		 * @type {number} start of selection - special use case for a unlock
		 * scenario
		 */
		this["iStartSelection"] = -1;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iStartSelection = -1', "TextEdit.js(123): UCF_TextEdit"); };
		/**
		 * @private
		 * @type {number} Cursor pos of selection - sspecial use case for a unlock
		 * scenario
		 */
		this["iCursorPos"] = -1;

		// scroll area
		if (this["bItsMode"]) {
			//In ITS mode the area does not scroll but a surrounding DIV
			if (UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== 'standards') {
				//special table constellation in quirks mode
				oScrollDomRef = UCF_DomUtil["$"](this["sId"])["parentNode"];
			} else {
				oScrollDomRef = this["oRootRef"];
			}
		} else {
			oScrollDomRef = UCF_DomUtil["$"](this["sId"]);
		}

		/**
		 * @private
		 * @type {UCF_ScrollArea} Scroll area control
		 */
		this["oScrollArea"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(oScrollDomRef); // eslint-disable-line @ur/no-memory-leaks
		this["attachBrowserEvent"]('scroll', oScrollDomRef);
		this["oScrollArea"]["attachEvent"](
			this["oScrollArea"]["E_EVENTS"]["Scroll"],
			this,
			'onAreaScroll'
		);
		this["addDelegate"](this["oScrollArea"]);

		/**
		 * @private
		 * @type {string} save value to identify the change of the value
		 */
		this["sOldValue"] = this["oDomRef"]["value"];

		/** @type {boolean} the dirty state changes after controls was edited */
		this["bIsDirty"] = false;

		// selection start and end
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iSelectionStart = 0', "TextEdit.js(167): UCF_TextEdit"); };
		/**
		 * @private
		 * @type {number} End of selection
		 */
		this["iSelectionStart"] = 0;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iSelectionEnd = 0', "TextEdit.js(173): UCF_TextEdit"); };
		/**
		 * @private
		 * @type {number} Start of selection
		 */
		this["iSelectionEnd"] = 0;

		/** @type {boolean} Lightspeed Unlock Event attached or not */
		this["bUnlockEventAttached"] = false;

		this["bHovered"] = false;

		/**
		 * @type {number} the maximum height of the text edit if bShowTextFieldHelp
		 * is used.
		 */
		this["iMaxResizeHeight"] = 300;

		/** @type {boolean} ignoring the next blur for resizing mode */
		this["bIgnoreNextFocusOut"] = false;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocusOut initially = ' + this["bIgnoreNextFocusOut"], "TextEdit.js(193): UCF_TextEdit"); };

		/** @type {boolean} ignoring the next focus */
		this["bIgnoreNextFocus"] = false;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocus initially = ' + this["bIgnoreNextFocus"], "TextEdit.js(197): UCF_TextEdit"); };

		/**
		 * @type {HTMLElement} for some weired reasons in web kit the parent node
		 * is sometimes lost for oPlaceHolder, there create a member here
		 */
		this["oParentNode"] = this["oRootRef"]["parentNode"];

		// Attach to the page before resize event, ITS speciale
		if (this["oLS"]["bAlternativeKeyboardHandling"]) {
			oPage = this["oLS"]["oGetPageInternal"]();
			if (oPage) {
				oPage["attachEvent"](
					oPage["E_EVENTS"]["BeforeResize"],
					this,
					'onBeforeResizePage'
				);
			}
		}

		// holds the height of the resize slider
		this["oResizeHandleRect"] = null;

		// attach to open event of a popup window to close the fieldhelp
		oPopupManager = this["oLS"]["oGetPopupManagerInternal"]();
		if (oPopupManager) {
			oPopupManager["attachEvent"](
				oPopupManager["E_EVENTS"]["WindowOpen"],
				this,
				'close'
			);
		}
	}
};window["UCF_TextEdit"] = UCF_TextEdit; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TextEdit"); UCF_TextEdit["_"] = {UCF_TextEdit: 0}; }; ;
UCF_TextEdit["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TextEdit.prototype["sClassName"] = "UCF_TextEdit";

UCF_TextEdit["prototype"]["E_EVENTS"] = {
	"DidOpen": 0
};

UCF_TextEdit["prototype"]["eStyles"] = {
	"TEXTEDIT_HOVERABLE": "lsTextEdit--hover",
	"TEXTEDIT_FOCUSABLE": "lsTextEdit--focus",
	"TEXTEDIT_TOUCHABLE": "lsTextEdit--touchable"
};
/**
 * Sets the scroll position programmatically
 * The parameters iScrollLeft, iScrollTop are defined in the API of the
 * ScrollContainer control.
 *
 * @private
 */
UCF_TextEdit["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["initialize"]++; }; 
	/** @type {number} */
	var iScrollHeight;
	/** @type {number} */
	var iScrollWidth;

	// called by the renderer
	if (this["bItsMode"]) {
		// needed because of height calculation for ItsMode
		this["initializeInITSMode"]();
		this["oLS"]["oBrowserWindow"]["attachEvent"](
			this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"],
			this,
			'initializeInITSMode'
		);
	}

	if (this["iScrollTop"] > 0 || this["iScrollLeft"] > 0) {
		this["oScrollArea"]["setScrollPosition"](this["iScrollTop"], this["iScrollLeft"]);
	}

	this["adjustTextEditHeightToTableCellHeight"]();

	if (!this["bHeightAdapted"] && this["bAdjustHeightToCellNeeded"]) {
		this["attachBrowserEvent"]('resize', this["oDomRef"]);
	}

	// Get scroll height and scroll width to make sure that it has
	// been calculated properly by Internet Explorer in Quirks mode
	if (UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== 'standards') {
		// eslint-disable-next-line no-unused-vars
		iScrollHeight = this["oDomRef"]["scrollHeight"];
		// eslint-disable-next-line no-unused-vars
		iScrollWidth = this["oDomRef"]["scrollWidth"];
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["initialize"] = 0; };

/**
 * @private
 */
UCF_TextEdit["prototype"]["initializeInITSMode"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["initializeInITSMode"]++; }; 
	/** @type {HTMLTableElement} */
	var oItsTextEdit;

	if (this["bItsMode"]) {
		if (
			UCF_UserAgent["bIsGecko"]() ||
			UCF_UserAgent["bIsWebKit"]() ||
			window["UCF_System"]["sDevice"] === 'standards'
		) {
			// The height of the textarea has been calculated depends from the scroll
			// height.
			this["oDomRef"]["style"]["height"] = this["oDomRef"]["scrollHeight"] + 'px';
		}
		if (UCF_DomUtil["bCheckStandardsCorrection"]() && this["sItsMessage"] !== '') {
			oItsTextEdit = UCF_DomUtil["$"](this["sId"] + '-itsMsg');

			if (oItsTextEdit) {
				UCF_DomUtil["initHtmlTableCorrection"](oItsTextEdit, true);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["initializeInITSMode"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_TextEdit["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["destroy"]++; }; 
	/** @type {UCF_Page} */
	var oPage;

	this["detachBrowserEvent"]('blur', this["oDomRef"]);
	this["detachBrowserEvent"]('cut', this["oDomRef"]);
	if (UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== 'standards') {
		this["detachBrowserEvent"]('beforedeactivate', this["oDomRef"]);
	}

	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}

	if (this["sInterval"]) {
		UCF_JsUtil["clearIntervalCall"](this["sInterval"]);
	}

	this["close"]();

	// Detach the page before resize event, ITS speciale
	if (this["oLS"]["bAlternativeKeyboardHandling"]) {
		oPage = this["oLS"]["oGetPageInternal"]();
		if (oPage) {
			this["oLS"]["detachEvent"](
				oPage["E_EVENTS"]["BeforeResize"],
				this,
				'onBeforeResizePage'
			);
		}
	}
	if (this["bItsMode"]) {
		this["oLS"]["oBrowserWindow"]["detachEvent"](
			this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"],
			this,
			'initializeInITSMode'
		);
	}

	if (this["oFieldHelp"]) {
		this["detachFieldHelp"]();
		this["oFieldHelp"] = null;
	}

	if (this["bHeightAdapted"] && this["bAdjustHeightToCellNeeded"]) {
		this["detachBrowserEvent"]('resize', this["oDomRef"]);
	}

	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	this["oDomRef"] = null;
	this["oParentNode"] = null;
	this["oResizeHandleRect"] = null;

	this["iEndSelection"] = null;
	this["iStartSelection"] = null;
	this["iCursorPos"] = null;

	this["iSelectionStart"] = null;
	this["iSelectionEnd"] = null;
	this["iScroll_Left"] = null;
	this["iScroll_Top"] = null;
	this["iParentTop"] = null;
	this["iParentLeft"] = null;
	this["iParentWidth"] = null;
	this["iMaxResizeHeight"] = null;
	this["iResizeHeight"] = null;
	this["iTextHeight"] = null;
	this["iInitialHeight"] = null;
	this["iOldHeight"] = null;

	this["sOldValue"] = null;
	this["sOldZIndex"] = null;
	this["sOldWidth"] = null;
	this["sTimeOutId"] = null;
	this["bHovered"] = null;
	this["bAdjustHeightToCellNeeded"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["destroy"] = 0; };

/**
 * @override
 * @param {UCF_FocusInfo} oFocusInfo the focus info that is collected
 */
UCF_TextEdit["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["collectFocusInfo"]++; }; 
	/** @type {number} */
	var iCursorPos;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(UCF_JsUtil["bInstanceOf"](oFocusInfo, 'UCF_FocusInfo'), "UCF_JsUtil.bInstanceOf(oFocusInfo, 'UCF_FocusInfo')", "TextEdit.js(406): collectFocusInfo"); };

	iCursorPos = UCF_DomUtil["iGetCursorPos"](this["oDomRef"]);

	oFocusInfo["setApplyControl"](this);
	oFocusInfo["addParam"]('iSelectionStart', this["iGetSelectionStart"]());
	oFocusInfo["addParam"]('iSelectionEnd', this["iGetSelectionEnd"]());
	oFocusInfo["addParam"]('iScrollLeft', UCF_DomUtil["iGetScrollLeft"](this["oRootRef"]));
	oFocusInfo["addParam"]('iScrollTop', UCF_DomUtil["iGetScrollTop"](this["oRootRef"]));

	if (iCursorPos >= 0) {
		oFocusInfo["addParam"]('iCursorPos', iCursorPos);
	}

	if (this["bUsedInSapTable"]) {
		oFocusInfo["addParam"]('bNavigation', this["bNavigation"]);
		oFocusInfo["setApplyControl"](this);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["collectFocusInfo"] = 0; };

/**
 * @override
 * @param {UCF_FocusInfo} oFocusInfo the focus info to apply
 */
UCF_TextEdit["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "TextEdit.js(431): applyFocusInfo"); };
	this["oFocusDomRef"]["focus"]();

	this["setSelectionInternal"](this["oFocusDomRef"],
		oFocusInfo["oGetParam"]('iSelectionStart'),
		oFocusInfo["oGetParam"]('iSelectionEnd')
	);
	this["setScrollPosition"](
		oFocusInfo["oGetParam"]('iScrollLeft'),
		oFocusInfo["oGetParam"]('iScrollTop')
	);

	if (this["bUsedInSapTable"]) {
		this["bNavigation"] = oFocusInfo["oGetParam"]('bNavigation');
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["applyFocusInfo"] = 0; };

/**
 * @private
 * @return {boolean} `true` if it is a legacy theme, otherwise `false`
 */
UCF_TextEdit["prototype"]["bIsLegacy"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bIsLegacy"]++; }; 
	return UCF_ResourceUtil["oGetMetadataFromTheme"]('lsTextEdit__metadata')["bIsLegacy"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bIsLegacy"] = 0; };

/**
 * @private
 * @return {boolean} `true` if textarea has a box shadow according to a theme,
 * otherwise `false`
 */
UCF_TextEdit["prototype"]["bHasBoxShadow"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bHasBoxShadow"]++; }; 
	return UCF_ResourceUtil["oGetMetadataFromTheme"]('lsTextEdit__metadata')["bHasBoxShadow"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bHasBoxShadow"] = 0; };

/**
 * Checks if a key code changes the value of the text edit
 *
 * @private
 * @param {number} iKey key code
 * @return {boolean}
 */
UCF_TextEdit["prototype"]["bIsEditKey"] = function(iKey) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bIsEditKey"]++; }; 
	return UCF_KeyboardHelper["bIsEditKey"](iKey);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bIsEditKey"] = 0; };

/**
 * @private
 * @param {UCF_Event} oEvent the pending request event
 */
UCF_TextEdit["prototype"]["onPendingRequest"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onPendingRequest"]++; }; 
	/** @type {UCF_PendingRequest} */
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oPendingRequest"] = oEvent["oGetParam"]('oPendingRequest');

	this["oPendingRequest"]["suspend"](this["sId"]);
	// because of special handling for Chrome in setSelectionDirectly();
	if (UCF_UserAgent["bIsIE"]()) {
		this["close"]();
	}

	this["oPendingRequest"]["resume"](this["sId"]);
	this["oPendingRequest"] = null;
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onPendingRequest"] = 0; };

/**
 * @private
 * calculate textarea height as a surrounding SapTable cell height
 */
UCF_TextEdit["prototype"]["adjustTextEditHeightToTableCellHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["adjustTextEditHeightToTableCellHeight"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()' + ' (ControlId: ' + this["sId"] + ')', "TextEdit.js(500): adjustTextEditHeightToTableCellHeight"); };

	/** @type {number} */
	var iParentClientHeight;
	/** @type {boolean} */
	var bIsQuirks = UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== 'standards';

	if (this["bAdjustHeightToCellNeeded"]) {
		// CWB: 012006153200014392422014
		// CL: 220335 Aug 15, 2014, 7:51:26 AM
		// Note: 2054852 - TextEdit is used in SapTable control might not get the full height
		// Issue: If a TextEdit is used in SapTable control in Internet Explorers Quirks mode
		// it collapses to the height of the row even if the TextEdit has a height of 100% specified
		// Get the parents height and let the textarea be as high as the
		// surrounding cell
		iParentClientHeight = this["oDomRef"]["parentNode"]["clientHeight"];
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'iParentClientHeight=' + iParentClientHeight, "TextEdit.js(516): adjustTextEditHeightToTableCellHeight"); };

		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, ' this.oDomRef.offsetHeight=' + this["oDomRef"]["offsetHeight"], "TextEdit.js(518): adjustTextEditHeightToTableCellHeight"); };
		if (iParentClientHeight > 0 && iParentClientHeight > this["oDomRef"]["offsetHeight"]) {
			// https://css-tricks.com/box-sizing/ => box model for IE Quirks
			// https://www.quirksmode.org/dom/tests/elementdimensions.html
			// 2 = cell border top and bottom
			if (bIsQuirks) {
				this["oDomRef"]["style"]["height"] = (iParentClientHeight - 2) + 'px';
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.oDomRef.style.height=' + this["oDomRef"]["style"]["height"], "TextEdit.js(525): adjustTextEditHeightToTableCellHeight"); };
			} else {
				this["oDomRef"]["style"]["height"] = iParentClientHeight + 'px';
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.oDomRef.style.height=' + this["oDomRef"]["style"]["height"], "TextEdit.js(528): adjustTextEditHeightToTableCellHeight"); };
			}
			this["bHeightAdapted"] = true;
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bHeightAdapted=' + this["bHeightAdapted"], "TextEdit.js(531): adjustTextEditHeightToTableCellHeight"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["adjustTextEditHeightToTableCellHeight"] = 0; };

/**
 * Handles the resize event of the browser
 *
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TextEdit["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onresize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(543): onresize"); };
	if (this["oDomRef"]["parentNode"]["clientHeight"] > 0) {
		this["adjustTextEditHeightToTableCellHeight"]();
		oBrowserEvent["cancelBubble"]();
		this["detachBrowserEvent"]('resize', this["oDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onresize"] = 0; };

/**
 * Handles the onlsleft event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsleft
 */
UCF_TextEdit["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsleft"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(558): onlsleft"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation = ' + this["bNavigation"], "TextEdit.js(559): onlsleft"); };
	if (this["bNavigation"]) {
		oBrowserEvent["cancelBubble"]();
	} else {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsleft"] = 0; };

/**
 * Handles the onlsright event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsright
 */
UCF_TextEdit["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsright"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(574): onlsright"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation = ' + this["bNavigation"], "TextEdit.js(576): onlsright"); };
	if (this["bNavigation"]) {
		oBrowserEvent["cancelBubble"]();
	} else {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsright"] = 0; };

/**
 * Handles the onlsup event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsup
 */
UCF_TextEdit["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(591): onlsup"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation = ' + this["bNavigation"], "TextEdit.js(593): onlsup"); };
	if (this["bNavigation"]) {
		oBrowserEvent["cancelBubble"]();
	} else {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsup"] = 0; };

/**
 * Handles the onlsdown event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsdown
 */
UCF_TextEdit["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsdown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(608): onlsdown"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation = ' + this["bNavigation"], "TextEdit.js(610): onlsdown"); };
	if (this["bNavigation"]) {
		oBrowserEvent["cancelBubble"]();
	} else {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsdown"] = 0; };

/**
 * Handles the onlshome event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshome
 */
UCF_TextEdit["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlshome"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(625): onlshome"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation = ' + this["bNavigation"], "TextEdit.js(627): onlshome"); };
	if (this["bNavigation"]) {
		oBrowserEvent["cancelBubble"]();
	} else {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlshome"] = 0; };

/**
 * Handles the onlsend
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsend
 */
UCF_TextEdit["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(642): onlsend"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation = ' + this["bNavigation"], "TextEdit.js(644): onlsend"); };
	if (this["bNavigation"]) {
		oBrowserEvent["cancelBubble"]();
	} else {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsend"] = 0; };

/**
 * Handles the lsexpand event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsexpand
 */
UCF_TextEdit["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsexpand"]++; }; 
	oBrowserEvent["cancelBubble"](); // cancel bubbling of typing '+'
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsexpand"] = 0; };

/**
 * Handles the lscollapse event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lscollapse
 */
UCF_TextEdit["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlscollapse"]++; }; 
	oBrowserEvent["cancelBubble"](); // cancel bubbling of typing '-'
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlscollapse"] = 0; };

/**
 * Handles the onlsprevious event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsprevious
 */
UCF_TextEdit["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsprevious"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsprevious"] = 0; };

/**
 * Handles the onlsnext event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsnext
 */
UCF_TextEdit["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsnext"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsnext"] = 0; };

/**
 * Handles the onbeforedeactivate event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the beforedecativate
 */
UCF_TextEdit["prototype"]["onbeforedeactivate"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onbeforedeactivate"]++; }; 
	// 3433558 2011, caused to problems with popups, we detach in blur
	if (UCF_DomUtil["oGetActiveElement"]() === this["oDomRef"]) {
		this["saveSelection"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onbeforedeactivate"] = 0; };

// @param {UCF_BrowserEvent} oBrowserEvent the lsblur

/**
 * Handles the onlsblur event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oLsBlur onlsblur
 */
UCF_TextEdit["prototype"]["onlsblur"] = function(oLsBlur) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsblur"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()' + ' (ControlId: ' + this["sId"] + ')', "TextEdit.js(714): onlsblur"); };

	/** @type {HTMLElement} */
	var oRelatedTarget;

	if (UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== 'standards') {
		this["detachBrowserEvent"]('beforedeactivate', this["oDomRef"]);
	} else {
		this["saveSelection"]();
	}

	// Special handling for a PopupMenu opens via right click in a TextEdit
	// RelatedTarget in WebKit and Gecko for the first onlsblur event is null.
	oRelatedTarget = UCF_DomUtil["oGetRelatedTarget"](oLsBlur["oDomEvent"]);

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocusOut before = ' + this["bIgnoreNextFocusOut"] + ' | ' + ' oRelatedTarget = ' + oRelatedTarget, "TextEdit.js(729): onlsblur"); };

	if (this["bIgnoreNextFocusOut"] && (oRelatedTarget === undefined || oRelatedTarget === null)) {
		this["bIgnoreNextFocusOut"] = false;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocusOut after = ' + this["bIgnoreNextFocusOut"], "TextEdit.js(733): onlsblur"); };
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->close()', "TextEdit.js(735): onlsblur"); };
		this["close"]();

	}
	this["removeFocusStyles"]();

	// fire change event
	this["prepareFireChange"]();
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsblur"] = 0; };

/**
 * Handles the onblur event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the blur
 */

UCF_TextEdit["prototype"]["onblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onblur"]++; }; 
	// fire change event
	this["prepareFireChange"]();
	if (this["bOpen"] && UCF_BrowserEvent["bTouchInteraction"]) {
		this["bIgnoreNextFocusOut"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onblur"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the dblclick
 */
UCF_TextEdit["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(767): ondblclick"); };

	if (UCF_DomUtil["oGetActiveElement"]() === this["oDomRef"]) {
		this["saveSelection"]();
	}

	if (this["mEvents"]["DoubleClick"]) {
		this["prepareFireChange"](); // ITS needs the change event
		this["fireDoubleClick"](
			this["sId"],
			this["iGetSelectionStart"](),
			this["iGetSelectionEnd"]()
		);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["ondblclick"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TextEdit["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onkeydown"]++; }; 
	/** @type {number} */
	var iKey;
	/** @type {number} */
	var iLength;
	/** @type {number} */
	var iSelectedTextLength;
	/** @type {number} */
	var iSelectedTextLengthCorrected;
	/** @type {string} */
	var sTextValue;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(802): onkeydown"); };

	iKey = oBrowserEvent["iKeyCode"]();

	// do not allow editing for readonly fields
	if (this["bReadonly"] && this["bIsEditKey"](iKey) && !oBrowserEvent["bCtrl"]()) {
		oBrowserEvent["cancel"]();

		return;
	}
	if ((iKey === UCF_KeyCodes["TAB"] || iKey === UCF_KeyCodes["ESCAPE"])) {
		if (this["bOpen"]) {
			this["bIgnoreNextFocusOut"] = true;
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocusOut = ' + this["bIgnoreNextFocusOut"], "TextEdit.js(815): onkeydown"); };
			this["close"]();
			if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
				this["prepareFireChange"]();
			}
			if (iKey === UCF_KeyCodes["TAB"]) {
				if (oBrowserEvent["bShift"]()) {
					this["focusPreviousControl"]();
				} else {
					this["focusNextControl"]();
				}
				oBrowserEvent["cancelBubble"]();
				oBrowserEvent["cancel"]();
				return;
			}
		}
		if (iKey === UCF_KeyCodes["ESCAPE"]) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocus before = ' + this["bIgnoreNextFocus"], "TextEdit.js(832): onkeydown"); };
			this["bIgnoreNextFocus"] = true;
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocus after = ' + this["bIgnoreNextFocus"], "TextEdit.js(834): onkeydown"); };
			this["focus"]();
			if (this["bValueEdited"]) {
				this["setValue"](this["sOldValue"]);
			}
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["cancel"]();
			return;
		}
		return;
	}

	// cancel bubbling if a function key s used in the text edit
	if (UCF_TextEdit["bIsLocallyUsedFunctionKey"](iKey)) {
		oBrowserEvent["cancelBubble"]();
		return;
	}

	if (
		this["iMaxLength"] > 0 &&
		iKey === UCF_KeyCodes["Z"] &&
		oBrowserEvent["bCtrl"]() &&
		!oBrowserEvent["bAlt"]() &&
		!oBrowserEvent["bShift"]()
	) { // [CTRL][Z] -> undo check the maxlength again CSN E-0000576574 2010
		if (this["sTimeOutId"]) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'cutToMaxlength');
	}

	// check if the maxlength is reached and adding characters is not allowed
	// anymore. check for a selection because selection will be overwritten by
	// the keydown and can be subtracted from the current length
	if (this["bIsEditKey"](iKey) && !oBrowserEvent["bCtrl"]()) {
		iLength = this["getCorrectLength"](this["oDomRef"]["value"]);
		sTextValue = "";
		iSelectedTextLength = 0;
		iSelectedTextLengthCorrected = 0;
		//for IE < 9
		if (document["selection"]) {
			sTextValue = document["selection"]["createRange"]()["text"];
		} else if (this["oDomRef"]["selectionEnd"]) {
			iSelectedTextLength = this["oDomRef"]["selectionEnd"] - this["oDomRef"]["selectionStart"];
			sTextValue = this["oDomRef"]["value"]["substr"](this["oDomRef"]["selectionStart"], iSelectedTextLength);
		}
		iSelectedTextLengthCorrected = this["getCorrectLength"](sTextValue);
		iLength = iLength - iSelectedTextLengthCorrected;
		if (this["iMaxLength"] > 0 &&
			(iLength >= this["iMaxLength"] || iLength === this["iMaxLength"] - 1
				&& UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["ENTER"]))) {
			oBrowserEvent["cancel"]();
		}
		this["bNavigation"] = true;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation = ' + this["bNavigation"], "TextEdit.js(888): onkeydown"); };
	}
	// toggle navigation mode for table input fields
	if (iKey === UCF_KeyCodes["F2"] && this["bUsedInSapTable"]) {
		this["bNavigation"] = !this["bNavigation"];
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation = ' + this["bNavigation"], "TextEdit.js(893): onkeydown"); };
	}

	// open or close the text input help
	if (
		!this["bOpen"] &&
		this["bShowTextInputHelp"] &&
		this["bNavigation"] &&
		(this["bIsEditKey"](iKey) || iKey === UCF_KeyCodes["F2"])
	) {
		this["open"](oBrowserEvent["bTouchInteraction"]);
		UCF_DomUtil["setCursorPos"](this["oDomRef"], this["oDomRef"]["value"]["length"]);
	} else if (this["bOpen"] && this["bShowTextInputHelp"] && !this["bNavigation"]) {
		this["close"]();
		UCF_DomUtil["setCursorPos"](this["oDomRef"], 0);
	}

	if (iKey === UCF_KeyCodes["F2"] && this["bUsedInSapTable"]) {
		this["refocus"](this["oDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onkeydown"] = 0; };

/**
 * @private
 * @static
 * @param {number} iKey
 * @return {boolean}
 */
UCF_TextEdit["bIsLocallyUsedFunctionKey"] = function(iKey) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bIsLocallyUsedFunctionKey"]++; }; 
	return iKey === UCF_KeyCodes["TAB"] ||
		iKey === UCF_KeyCodes["ARROW_UP"] ||
		iKey === UCF_KeyCodes["ARROW_DOWN"] ||
		iKey === UCF_KeyCodes["ARROW_LEFT"] ||
		iKey === UCF_KeyCodes["ARROW_RIGHT"] ||
		iKey === UCF_KeyCodes["BACKSPACE"] ||
		iKey === UCF_KeyCodes["SHIFT"] ||
		iKey === UCF_KeyCodes["DELETE"] ||
		iKey === UCF_KeyCodes["HOME"] ||
		iKey === UCF_KeyCodes["END"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bIsLocallyUsedFunctionKey"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_TextEdit["prototype"]["onlshomemodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlshomemodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(939): onlshomemodifier"); };

	// FIX: control home for TextEdit im PopupWindow, otherwise is the title of PopupWindow focused
	if (oBrowserEvent["bCtrl"]() && !oBrowserEvent["bAlt"]() && !oBrowserEvent["bShift"]()) oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlshomemodifier"] = 0; };

/**
 * Handle hotkey events
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lshotkey
 */
UCF_TextEdit["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlshotkey"]++; }; 
	/** @type {number} */
	var iKey = oBrowserEvent["iKeyCode"]();

	// handle these hotkeys locally and do not bubble them
	if (
		oBrowserEvent["bCtrl"]() &&
		!oBrowserEvent["bAlt"]() &&
		!oBrowserEvent["bShift"]() && (
			iKey === UCF_KeyCodes["C"] ||
			iKey === UCF_KeyCodes["X"] ||
			iKey === UCF_KeyCodes["V"] ||
			iKey === UCF_KeyCodes["Z"] ||
			iKey === UCF_KeyCodes["Y"] ||
			iKey === UCF_KeyCodes["A"]
		)
	) {
		oBrowserEvent["cancelBubble"]();

		return;
	}

	if (
		iKey === UCF_KeyCodes["DELETE"] ||
		iKey === UCF_KeyCodes["ESCAPE"] ||
		iKey === UCF_KeyCodes["ENTER"] ||
		iKey === UCF_KeyCodes["INSERT"]
	) {
		oBrowserEvent["cancelBubble"]();

		return;
	}

	// fire change event if value has changed
	this["prepareFireChange"]();
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlshotkey"] = 0; };

/**
 * Handles the keyup event and checks whether the value of the field changed to
 * propagate the dirty state
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the keyup
 */
UCF_TextEdit["prototype"]["onkeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onkeyup"]++; }; 
	this["handleEditEvents"](oBrowserEvent);
	if (this["bItsMode"]) {
		if (
			UCF_UserAgent["bIsGecko"]() ||
			UCF_UserAgent["bIsWebKit"]() ||
			window["UCF_System"]["sDevice"] === 'standards'
		) {
			this["oDomRef"]["style"]["height"] = this["oDomRef"]["scrollHeight"] + 'px';
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onkeyup"] = 0; };

/**
 * Handles the onpaste event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the paste
 */
UCF_TextEdit["prototype"]["onpaste"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onpaste"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(1017): onpaste"); };

	if (this["bReadonly"]) {
		oBrowserEvent["cancel"]();
	}
	this["handleEditEvents"](oBrowserEvent);

	if (this["iMaxLength"] > 0) {
		// call cutToMaxLength delayed so that the pasted value is available,
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'check maxlength...', "TextEdit.js(1026): onpaste"); };
		if (this["sTimeOutId"]) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'cutToMaxlength');
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onpaste"] = 0; };

/**
 * Handles the oncut event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the cut
 */
UCF_TextEdit["prototype"]["oncut"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oncut"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(1041): oncut"); };

	if (this["bReadonly"]) {
		oBrowserEvent["cancel"]();
	}
	this["handleEditEvents"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oncut"] = 0; };

/**
 * Handles the ondrop event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the drop
 */
UCF_TextEdit["prototype"]["ondrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["ondrop"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(1056): ondrop"); };

	if (this["bReadonly"]) {
		oBrowserEvent["cancel"]();
	}

	// call cutToMaxLength delayed so that the pasted value is available
	if (this["iMaxLength"] > 0) {
		if (this["sTimeOutId"]) {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'cutToMaxlength');
	}
	this["handleEditEvents"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["ondrop"] = 0; };

/**
 * Handles the onkeypress event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the keypress
 */
UCF_TextEdit["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onkeypress"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(1079): onkeypress"); };
	if (this["bItsMode"]) {
		if (
			UCF_UserAgent["bIsGecko"]() ||
			UCF_UserAgent["bIsWebKit"]() ||
			window["UCF_System"]["sDevice"] === 'standards'
		) {
			this["oDomRef"]["style"]["height"] = this["oDomRef"]["scrollHeight"] + 'px';
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onkeypress"] = 0; };

/**
 * Fires the scroll event
 *
 * @private
 * @param {UCF_Event} oEvent the AreaScroll
 */
UCF_TextEdit["prototype"]["onAreaScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onAreaScroll"]++; }; 
	/** @type {number} */
	var iScrollTop = oEvent["oGetParam"]('iScrollTop');
	/** @type {number} */
	var iScrollLeft = oEvent["oGetParam"]('iScrollLeft');

	this["fireScroll"](this["sId"], iScrollLeft, iScrollTop);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onAreaScroll"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element
 * within the control gets the focus.
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 */
UCF_TextEdit["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsaccessibility"]++; }; 
	/** @type {UCF_AccessibilityHelper} */
	var oAccessibilityHelper;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(1117): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() === this) {
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

		oAccessibilityHelper["setControlType"]('TE');

		// Apply label and accDescription
		oAccessibilityHelper["applyLabelingInfo"](this);
		oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

		// status
		oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
		oAccessibilityHelper["setEnabled"](this["bEnabled"]);
		oAccessibilityHelper["setReadonly"](this["bReadonly"]);
		oAccessibilityHelper["setRequired"](this["bRequired"]);
		if (this["bInvalid"] || this["sInputState"] === 'ERROR') {
			oAccessibilityHelper["setInvalid"](true);
		}
		oAccessibilityHelper["setWarning"](this["sInputState"] === 'WARNING');

		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsaccessibility"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the click
 */
UCF_TextEdit["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(1149): onclick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oBrowserEvent === 'object', "typeof oBrowserEvent === 'object'", "TextEdit.js(1150): onclick"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()' + ' (ControlId: ' + this["sId"] + ')', "TextEdit.js(1152): onclick"); };

	// set cursor position when clicked in div container
	if (
		this["bItsMode"] &&
		(oBrowserEvent["oGetSource"]() !== oBrowserEvent["oGetSourceRoot"]())
	) {
		UCF_DomUtil["setCursorPos"](this["oDomRef"], this["oDomRef"]["value"]["length"]);
	}

	if (this["bEnabled"]) {
		oBrowserEvent["cancelBubble"]();

		//TODO: RAIK - Touch Screen
		if (
			this["oLS"]["fInputAssistantCallBack"] &&
			(!this["oFieldHelp"] || !this["oFieldHelp"]["bOpen"])
		) {
			this["openFieldHelp"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onclick"] = 0; };

/**
 * @protected
 * @return {HTMLSpanElement}
 */

UCF_TextEdit["prototype"]["oGetHelpButtonRef"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oGetHelpButtonRef"]++; }; 
	// The TextEdit control has no FieldHelpButton, we need it otherwise
	// we get a error in onAnyEvent() in InputAssistent.js
	return null;

};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oGetHelpButtonRef"] = 0; };

/**
 * TODO: RAIK - Touch Screen
 * Opens the field help. The method is only available if onscreen keyboard
 * is available.
 * @private
 */
UCF_TextEdit["prototype"]["openFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["openFieldHelp"]++; }; 
	this["attachFieldHelp"]();
	this["oFieldHelp"]["open"]();
	if (this["oDataTip"]) {
		this["oDataTip"]["close"]();
	}
	UCF_TextEdit["oPendingFieldHelp"] = this["oFieldHelp"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["openFieldHelp"] = 0; };

/**
 * TODO: RAIK - Touch Screen
 * Attaches a suitable field help to the input field.
 * Field helps available in javascript are the onscreen keyboard
 * @private
 */
UCF_TextEdit["prototype"]["attachFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["attachFieldHelp"]++; }; 
	/** @type {UCF_InputAssistant} */
	this["oFieldHelp"] = this["oLS"]["oControlFactory"]["oGetControl"](
		'UCF_InputAssistant',
		'ls-InputAssistant'
	);
	this["oFieldHelp"]["setConnectedControl"](this);
	this["oFieldHelp"]["setValue"](this["oDomRef"]["value"]);
	this["oFieldHelp"]["attachEvent"](
		this["oFieldHelp"]["E_EVENTS"]["Select"],
		this,
		'onFieldHelpSelect'
	);
	this["oFieldHelp"]["attachEvent"](
		this["oFieldHelp"]["E_EVENTS"]["Close"],
		this,
		'onFieldHelpClose'
	);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["attachFieldHelp"] = 0; };

/**
 * TODO: RAIK - Touch Screen
 * Handles internal datepicker select event from field help datepicker.
 *
 * @private
 * @param {UCF_Event} oEvent the FieldHelpSelect
 */
UCF_TextEdit["prototype"]["onFieldHelpSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onFieldHelpSelect"]++; }; 
	this["detachFieldHelp"]();

	if (!this["bReadonly"]) {
		this["focus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onFieldHelpSelect"] = 0; };

/**
 * TODO: RAIK - Touch Screen
 * Handles internal onscreen keyboard cancel event from field help onscreen keyboard.
 *
 * @private
 * @param {UCF_Event} oEvent the FieldHelpClose
 */
UCF_TextEdit["prototype"]["onFieldHelpClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onFieldHelpClose"]++; }; 
	this["detachFieldHelp"]();
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onFieldHelpClose"] = 0; };

/**
 * @private
 * @param {UCF_Event} oEvent the event
 */
UCF_TextEdit["prototype"]["closeFieldHelp"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["closeFieldHelp"]++; }; 
	this["detachFieldHelp"]();
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["closeFieldHelp"] = 0; };

/**
 * TODO: RAIK - Touch Screen
 * Detach events needed for the field help handling
 * @private
 */
UCF_TextEdit["prototype"]["detachFieldHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["detachFieldHelp"]++; }; 
	this["oFieldHelp"]["detachEvent"](
		this["oFieldHelp"]["E_EVENTS"]["Select"],
		this,
		'onFieldHelpSelect'
	);
	this["oFieldHelp"]["detachEvent"](
		this["oFieldHelp"]["E_EVENTS"]["Close"],
		this,
		'onFieldHelpClose'
	);
	UCF_TextEdit["oPendingFieldHelp"] = null;
	this["prepareFireChange"]();
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["detachFieldHelp"] = 0; };

/**
 * Handles the oncontextmenu event of the browser
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the contextmenu
 */
UCF_TextEdit["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oncontextmenu"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(1289): oncontextmenu"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()' + ' (ControlId: ' + this["sId"] + ')', "TextEdit.js(1291): oncontextmenu"); };

	this["prepareFireChange"]();

	//if (this.bOpen) {
	//	this.close();
	//}

};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oncontextmenu"] = 0; };

/**
 * Handles the onlsselect event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the lsselect
 */
UCF_TextEdit["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "TextEdit.js(1308): onlsselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oBrowserEvent === 'object', "typeof oBrowserEvent === 'object'", "TextEdit.js(1309): onlsselect"); };

	if (this["bEnabled"]) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsselect"] = 0; };

/**
 * Handles the onlsselectmodifier event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TextEdit["prototype"]["onlsselectmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsselectmodifier"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "TextEdit.js(1323): onlsselectmodifier"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof oBrowserEvent === 'object', "typeof oBrowserEvent === 'object'", "TextEdit.js(1324): onlsselectmodifier"); };

	if (this["bEnabled"]) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsselectmodifier"] = 0; };

/**
 * Handles the onlsfocus event
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TextEdit["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsfocus"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()' + ' (ConrolId: ' + this["sId"] + ')', "TextEdit.js(1337): onlsfocus"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocus before = ' + this["bIgnoreNextFocus"], "TextEdit.js(1339): onlsfocus"); };
	if (this["bIgnoreNextFocus"]) {
		this["bIgnoreNextFocus"] = false;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocus after = ' + this["bIgnoreNextFocus"], "TextEdit.js(1342): onlsfocus"); };
		return;
	}

	// Set focusStyles for textarea
	// when it is not resizable.
	// For resizable textarea used in SapTable focus styles will be
	// in onmousedown set otherwise in opendelayed.
	if (this["bUsedInSapTable"]) {
		this["setFocusStylesInTable"]();
	} else {
		this["setFocusStyles"]();
	}
	// to restore Selection or CursorPosition in finishOpen is to late
	if (this["bShowTextInputHelp"] && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) && window["UCF_System"]["sDevice"] === 'standards') {
		this["restoreSelection"]();
	}

	if (!this["bOpen"] && this["bShowTextInputHelp"]) {
		// Wait for the mouse down to occur in webkit.
		// TextArea does not open in SapTable via openDelayed because of Keyboard navigation.
		UCF_JsUtil["delayedCall"](0, this, 'openDelayed', [oBrowserEvent["bIsTouchInteraction"]()]);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onlsfocus"] = 0; };

/**
 * @private
 * @param { boolean } bTouchInteraction the event
 */
UCF_TextEdit["prototype"]["openDelayed"] = function(bTouchInteraction) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["openDelayed"]++; }; 

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation = ' + this["bNavigation"], "TextEdit.js(1373): openDelayed"); };
	if (this["bNavigation"]) {
		this["setFocusStyles"]();
		this["open"](bTouchInteraction);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["openDelayed"] = 0; };

/**
 * Returns whether the value was edited by the user
 *
 * @private
 * @return {boolean}
 */
UCF_TextEdit["prototype"]["bValueEdited"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bValueEdited"]++; }; 
	return this["oDomRef"]["value"] !== this["sOldValue"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bValueEdited"] = 0; };

/**
 * Handler for events that are fired during a field is edited.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the event
 * @private
 */
UCF_TextEdit["prototype"]["handleEditEvents"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["handleEditEvents"]++; }; 
	if (this["bValueEdited"]() && !this["bIsDirty"]) {
		this["bIsDirty"] = true;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Checked value for changes ' + this["oDomRef"]["value"] + ' != ' + this["sOldValue"] + ' -> setting dirty state now!', "TextEdit.js(1399): handleEditEvents"); };
		this["markDirty"](true);
		this["setPendingChange"](true);
	}

	if (
		this["bOpen"] &&
		oBrowserEvent["iKeyCode"]() !== UCF_KeyCodes["ESCAPE"] &&
		oBrowserEvent["iKeyCode"]() !== UCF_KeyCodes["F2"]
	) {
		this["adjustHeightToText"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["handleEditEvents"] = 0; };

/**
 * Fires change event if value has changed
 * @private
 */
UCF_TextEdit["prototype"]["prepareFireChange"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["prepareFireChange"]++; }; 
	/** @type {string} */
	var sValue;

	if (
		UCF_TextEdit["oPendingFieldHelp"] == null ||
		UCF_TextEdit["oPendingFieldHelp"]["sClassName"] !== 'UCF_InputAssistant'
	) {
		sValue = this["oDomRef"]["value"];
		// to prevent that a change is fired twice check the old and new value
		if (sValue !== this["sOldValue"]) {
			// the dom was modified by this user interaction, tell lightspeed that
			// this happened
			this["oLS"]["setDomChanged"](true);
			this["sOldValue"] = sValue;
			this["fireChange"](this["sId"], sValue);
			this["setPendingChange"](false);
			this["bIsDirty"] = false;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["prepareFireChange"] = 0; };

/**
 * Calculates the correct length of a string with line break.
 * Especially FF returns for a line break a length of 1 but it is two ASCII
 * characters.
 *
 * @private
 * @param {string} txtValue the value
 * @return {number}
 */
UCF_TextEdit["prototype"]["getCorrectLength"] = function(txtValue) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getCorrectLength"]++; }; 
	if (txtValue["indexOf"]('\r\n') !== -1) {
		// IE on windows do nothing
	} else if (txtValue["indexOf"]('\r') !== -1) {
		// IE on MAC uses /r
		txtValue = txtValue["replace"](/\r/g, '\r\n');
	} else if (txtValue["indexOf"]('\n') !== -1) {
		// Firefox on all platforms counts line break as one character but
		// transfers two ASCII characters
		txtValue = txtValue["replace"](/\n/g, '\r\n');
	}

	return txtValue["length"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getCorrectLength"] = 0; };

/**
 * Cut value to maxlength characters
 *
 * @private
 */
UCF_TextEdit["prototype"]["cutToMaxlength"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["cutToMaxlength"]++; }; 
	// ensure that in paste operations the mexlength is still valid and remove to
	// extra charcters

	/** @type {string} */
	var txtValue = this["oDomRef"]["value"];
	/** @type {number} */
	var lineBreakCount = 0;

	if (txtValue !== '' && this["getCorrectLength"](txtValue) >= this["iMaxLength"]) {
		txtValue = txtValue["substr"](0, this["iMaxLength"]);

		// on some platforms and browser the newline character just counts as one
		// character even two characters are transferred. Ensure that the correct
		// amount of characters are transfered to the server.
		// CSN E-0000576574 2010
		if (txtValue["indexOf"]('\r\n') !== -1) {
			// IE on windows do nothing
			lineBreakCount = 0;
		} else if (txtValue["indexOf"]('\r') !== -1) {
			// IE on MAC uses /r
			lineBreakCount = (txtValue["split"](/\r/g)["length"] - 1);
		} else if (txtValue["indexOf"]('\n') !== -1) {
			// Firefox on all platforms counts line break as one character but
			// transfers two ASCII characters
			lineBreakCount = (txtValue["split"](/\n/g)["length"] - 1);
		}

		if (lineBreakCount > 0) {
			txtValue = txtValue["substr"](0, this["iMaxLength"] - lineBreakCount);
		}
		this["oDomRef"]["value"] = txtValue;
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["cutToMaxlength"] = 0; };

/**
 * @see UCF_Control
 * @public
 */
UCF_TextEdit["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["focus"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()', "TextEdit.js(1508): focus"); };
	// on focus select the complete text???
	if (UCF_DomUtil["oGetActiveElement"]() !== this["oFocusDomRef"]) {
		if (!this["bUsedInSapTable"] && this["oFocusDomRef"]["value"]) {
			this["setCursorPositionInternal"](
				this["oFocusDomRef"],
				this["oFocusDomRef"]["value"]["length"]
			);
		}
		UCF_Control.prototype["focus"]["apply"](this, arguments);
		if (this["iSelectionEnd"] > 0) {
			this["setSelectionInternal"](
				this["oFocusDomRef"],
				this["iSelectionStart"],
				this["iSelectionEnd"]
			);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["focus"] = 0; };

/**
 * @see UCF_Control
 */
UCF_TextEdit["prototype"]["focusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["focusDomRef"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()', "TextEdit.js(1533): focusDomRef"); };
	// on focus select the complete text???
	if (UCF_DomUtil["oGetActiveElement"]() !== this["oDomRef"]) {
		if (!this["bUsedInSapTable"]) {
			this["setCursorPositionInternal"](this["oDomRef"], this["oDomRef"]["value"]["length"]);
		}
		UCF_DomUtil["focusDomElement"](this["oDomRef"]);
		if (this["iSelectionEnd"] > 0) {
			this["setSelectionInternal"](
				this["oDomRef"],
				this["iSelectionStart"],
				this["iSelectionEnd"]
			);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["focusDomRef"] = 0; };

/**
 * Sets focus styles in table
 * @private
 */
UCF_TextEdit["prototype"]["setFocusStylesInTable"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setFocusStylesInTable"]++; }; 
	/** @type {number} */
	var iHeight;

	// do not set focus color if animation is turned off (performance issue)
	if (
		window["UCF_System"]["bUseAnimation"] ||
		window["UCF_System"]["bUseFocusColor"] ||
		window["UCF_System"]["sUseFocusColor"] === 'true'
	) {

		this["sInputFocusStyleInTable"] = '';

		if (__UCF_IE6__) {
			if (this["bIsWriteable"]()) {
				this["sInputFocusStyleInTable"] = 'lsTextEdit--table-focus';
				if (this["bInvalid"] || this["sInputState"] === 'ERROR') {
					this["sInputFocusStyleInTable"] += '-invalid';
				}
				if (this["sInputState"] === 'WARNING') {
					this["sInputFocusStyleInTable"] += '-warning';
				}
			}
			if (this["bShowTextInputHelp"]) {
				if (!this["bEnabled"]) {
					this["sInputFocusStyleInTable"] += 'lsTextEdit--table-focus-disabled';
				}

				if ((this["bEnabled"] && this["bReadonly"]) || this["bReadonly"]) {
					if (this["sAssociatedEditContext"] === 'PARENTREADONLY') {
						this["sInputFocusStyleInTable"] += 'lsTextEdit--table-focus-parentreadonly';
					} else {
						if (this["bInvalid"] || this["sInputState"] === 'ERROR') {
							this["sInputFocusStyleInTable"] += 'lsTextEdit--table-focus-invalid-readonly';
						}
						if (this["sInputState"] === 'WARNING') {
							this["sInputFocusStyleInTable"] += 'lsTextEdit--table-focus-warning-readonly';
						}
						if (this["sInputState"] === 'NONE' && !this["bInvalid"]) {
							this["sInputFocusStyleInTable"] += 'lsTextEdit--table-focus-readonly';
						}
					}
				}
			}
		} else {
			if (window["UCF_System"]["bIs508"]) {
				this["sInputFocusStyleInTable"] = 'lsTextEdit--focus';
			} else if (window["UCF_System"]["bIsAria"] &&
				(this["bIsWriteable"]() || (this["bReadonly"] && this["bEnabled"])
					|| this["bReadonly"])) {
				this["sInputFocusStyleInTable"] = 'lsTextEdit--focus';
			} else if (this["bIsWriteable"]() && this["sInputFocusStyleInTable"] === '') {
				this["sInputFocusStyleInTable"] = 'lsTextEdit--focus';
			} else if (!this["bEnabled"] && this["bShowTextInputHelp"]) {
				this["sInputFocusStyleInTable"] = 'lsTextEdit--focus';
			}
		}
		if (this["bUsedInSapTable"]) {
			if (!this["bShowTextInputHelp"]) {
				iHeight = this["oDomRef"]["offsetHeight"];
				if (this["sOverflow"] === 'AUTO') {
					this["oDomRef"]["style"]["overflow"] = 'auto';
				} else if (this["sOverflow"] === 'SCROLL') {
					this["oDomRef"]["style"]["overflow"] = 'scroll';
				}
				// for firefox (otherwise setting of overflow will cause the field to
				// grow)
				this["oDomRef"]["style"]["height"] = iHeight + 'px';
			}
			//	this.setSelection(0, 0);
		}

		UCF_DomUtil["addClass"](this["oDomRef"], this["sInputFocusStyleInTable"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setFocusStylesInTable"] = 0; };

/**
 * Sets focus styles
 * @private
 */
UCF_TextEdit["prototype"]["setFocusStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setFocusStyles"]++; }; 
	/** @type {HTMLTableElement} */
	var oItsContainer,
		oItsRootContainerIE6;

	var bIsReadonly = this["bEnabled"] && this["bReadonly"] || this["bReadonly"];

	// do not set focus color if animation is turned off (performance issue)
	if (
		window["UCF_System"]["bUseAnimation"] ||
		window["UCF_System"]["bUseFocusColor"] ||
		window["UCF_System"]["sUseFocusColor"] === 'true'
	) {
		// Focus styles for textarea stand alone
		this["sInputFocusStyle"] = 'lsTextEdit--focus';

		if (__UCF_IE6__) {
			if (!this["bEnabled"]) {
				if (this["bShowTextInputHelp"] || window["UCF_System"]["bIs508"]) {
					this["sInputFocusStyle"] += '-disabled';
				} else {
					this["sInputFocusStyle"] = '';
				}
			}
			if (this["bIsWriteable"]()) {
				if (this["bInvalid"] || this["sInputState"] === 'ERROR') {
					this["sInputFocusStyle"] += '-invalid';
				}
				if (this["sInputState"] === 'WARNING') {
					this["sInputFocusStyle"] += '-warning';
				}
			}
			if (bIsReadonly || bIsReadonly && (this["bShowTextInputHelp"] || window["UCF_System"]["bIs508"])) {
				if (this["sAssociatedEditContext"] === 'PARENTREADONLY') {
					this["sInputFocusStyle"] += '-parentreadonly';
				} else {
					if (this["bInvalid"] || this["sInputState"] === 'ERROR') {
						this["sInputFocusStyle"] += '-invalid-readonly';
					}
					if (this["sInputState"] === 'WARNING') {
						this["sInputFocusStyle"] += '-warning-readonly';
					}
					if (this["sInputState"] === 'NONE' && !this["bInvalid"]) {
						this["sInputFocusStyle"] += '-readonly';
					}
				}
			}
		} else {
			// textarea focus color for disabled and read only fields is set for 508 mode
			// textarea focus color for enabled and read only fields is set for ARIA
			if (this["bIsWriteable"]() ||
				((this["bIsWriteable"]() || (this["bEnabled"] && this["bReadonly"]))
					&& window["UCF_System"]["bIsAria"])
				|| window["UCF_System"]["bIs508"]) {

				UCF_DomUtil["addClass"](this["oDomRef"], this["sInputFocusStyle"]);
				// set focus style in ItsMode
				if (this["bItsMode"]) {
					UCF_DomUtil["removeClass"](this["oDomRef"], this["sInputFocusStyle"]);
					UCF_DomUtil["addClass"](this["oRootRef"], this["sInputFocusStyle"]);
					//Its container with a message
					oItsContainer = UCF_DomUtil["$"](this["sId"] + '-itsMsg');
					if (oItsContainer) {
						UCF_DomUtil["addClass"](oItsContainer, this["sInputFocusStyle"]);
					}
				}
			}
		}
		if (__UCF_IE6__) {
			if (this["bItsMode"]) {
				oItsRootContainerIE6 = UCF_DomUtil["$"](this["sId"] + '-r');
				UCF_DomUtil["addClass"](oItsRootContainerIE6, this["sInputFocusStyle"]);
			}
			UCF_DomUtil["addClass"](this["oDomRef"], this["sInputFocusStyle"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setFocusStyles"] = 0; };

/**
 * Remove focus styles
 * @private
 */
UCF_TextEdit["prototype"]["removeFocusStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["removeFocusStyles"]++; }; 
	/** @type {HTMLTableElement} */
	var oItsContainer,
		oItsRootContainerIE6;

	// focus color is not set if animation is turned off (performance issue)
	if (
		window["UCF_System"]["bUseAnimation"] ||
		window["UCF_System"]["bUseFocusColor"] ||
		window["UCF_System"]["sUseFocusColor"] === 'true'
	) {

		if (this["bUsedInSapTable"]) {
			// this.oDomRef.style.overflow = 'hidden';
			if (this["sInputFocusStyleInTable"]) {
				// remove focus style in SapTable
				UCF_DomUtil["removeClass"](this["oDomRef"], this["sInputFocusStyleInTable"]);
			}
		}
		if (this["sInputFocusStyle"]) {
			// remove focus style
			UCF_DomUtil["removeClass"](this["oDomRef"], this["sInputFocusStyle"]);
			// remove focus in ItsMode
			if (this["bItsMode"]) {
				if (__UCF_IE6__) {
					oItsRootContainerIE6 = UCF_DomUtil["$"](this["sId"] + '-r');
					UCF_DomUtil["removeClass"](oItsRootContainerIE6, this["sInputFocusStyle"]);
				} else {
					UCF_DomUtil["removeClass"](this["oRootRef"], this["sInputFocusStyle"]);
				}
			}
			oItsContainer = UCF_DomUtil["$"](this["sId"] + '-itsMsg');
			if (oItsContainer) {
				UCF_DomUtil["removeClass"](oItsContainer, this["sInputFocusStyle"]);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["removeFocusStyles"] = 0; };

/**
 * Save selection start and end
 * @private
 */
UCF_TextEdit["prototype"]["saveSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["saveSelection"]++; }; 
	/** @type {TextRange} */
	var oSelection;
	/** @type {TextRange} */
	var oSelRange;
	/** @type {number} */
	var iSelLength;
	/** @type {TextRange} */
	var oTextRange;
	/** @type {TextRange} */
	var oTextRange2;
	/** @type {string} */
	var sTextWhole;
	/** @type {string} */
	var sTextPart;
	/** @type {number} */
	var iTextPos;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'saving text selection...', "TextEdit.js(1778): saveSelection"); };
	// All browser without IE in non standards...
	if (
		this["oDomRef"]["selectionStart"] !== 'undefined' &&
		typeof this["oDomRef"]["selectionStart"] === 'number'
	) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iSelectionStart = ' + this["oDomRef"]["selectionStart"], "TextEdit.js(1784): saveSelection"); };
		this["iSelectionStart"] = this["oDomRef"]["selectionStart"];
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iSelectionEnd = ' + this["oDomRef"]["selectionEnd"], "TextEdit.js(1786): saveSelection"); };
		this["iSelectionEnd"] = this["oDomRef"]["selectionEnd"];
	} else if (this["oDomRef"]["createTextRange"]) { //IE
		try {
			oSelection = document["selection"]["createRange"]();
			oSelRange = oSelection["duplicate"]();
			iSelLength = oSelRange["text"]["length"];
			oTextRange = this["oDomRef"]["createTextRange"]();
			oTextRange2 = oTextRange["duplicate"]();
			sTextWhole = this["oDomRef"]["value"];

			// doesn't make any sense if selection empty
			if (oSelection && oTextRange) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iSelectionStart = 0', "TextEdit.js(1799): saveSelection"); };
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iSelectionEnd = 0', "TextEdit.js(1800): saveSelection"); };
				this["iSelectionStart"] = this["iSelectionEnd"] = 0;

				// get position in original text
				oTextRange2["moveToBookmark"](oSelection["getBookmark"]());
				oTextRange["setEndPoint"]('EndToStart', oTextRange2);

				// for some reason IE doesn't always count the \n and \r in the length
				// therefore all characters have to be escaped
				sTextPart = oSelection["text"]["replace"](/\r\n/g, '.');
				sTextWhole = sTextWhole["replace"](/\r\n/g, '.');

				// position might or might not include linebreaks in length
				iTextPos = oTextRange["text"]["replace"](/\r\n/g, '.')["length"];

				// from position the next match of the selection text is the selection
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iSelectionStart = ' + sTextWhole["indexOf"](sTextPart, iTextPos), "TextEdit.js(1816): saveSelection"); };
				this["iSelectionStart"] = sTextWhole["indexOf"](sTextPart, iTextPos);
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iSelectionEnd = ' + (this["iSelectionStart"] + iSelLength), "TextEdit.js(1818): saveSelection"); };
				this["iSelectionEnd"] = this["iSelectionStart"] + iSelLength;
			}
		} catch (e) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Could not calculate selection position of "' + this["sId"] + '" ERROR occured', "TextEdit.js(1822): saveSelection"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["saveSelection"] = 0; };

/**
 * Set scroll position
 * @param {number} iScrollLeft
 * @param {number} iScrollTop
 * @public
 */
UCF_TextEdit["prototype"]["setScrollPosition"] = function(iScrollLeft, iScrollTop) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setScrollPosition"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() ', "TextEdit.js(1834): setScrollPosition"); };

	if (this["oLS"]["bIsLocked"]) {
		this["iScroll_Left"] = iScrollLeft;
		this["iScroll_Top"] = iScrollTop;
		this["attachUnlockOnce"]();
	} else {
		this["setScrollPositionDirectly"](iScrollLeft, iScrollTop);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setScrollPosition"] = 0; };

/**
 * Set scroll position directly
 * @param {number} iScrollLeft
 * @param {number} iScrollTop
 * @public
 */
UCF_TextEdit["prototype"]["setScrollPositionDirectly"] = function(iScrollLeft, iScrollTop) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setScrollPositionDirectly"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() ', "TextEdit.js(1852): setScrollPositionDirectly"); };

	this["oScrollArea"]["setScrollPosition"](iScrollTop, iScrollLeft);

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'iScrollTop: ' + UCF_DomUtil["iGetScrollTop"](this["oDomRef"]), "TextEdit.js(1856): setScrollPositionDirectly"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'iScrollLeft: ' + UCF_DomUtil["iGetScrollLeft"](this["oDomRef"]), "TextEdit.js(1857): setScrollPositionDirectly"); };

};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setScrollPositionDirectly"] = 0; };

/** @private check if Unlock Event already attached */
UCF_TextEdit["prototype"]["attachUnlockOnce"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["attachUnlockOnce"]++; }; 
	if (!this["bUnlockEventAttached"]) {
		this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, 'onUnlock');
		this["bUnlockEventAttached"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["attachUnlockOnce"] = 0; };

/** @private Detache the Lightspeed Unlock Event if aready attached */
UCF_TextEdit["prototype"]["detachUnlockOnce"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["detachUnlockOnce"]++; }; 
	this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this);
	this["bUnlockEventAttached"] = false;
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["detachUnlockOnce"] = 0; };

/**
 * Set cursor position
 * @param {HTMLElement} oDomRef the Element to set the cursor in
 * @param {number} iPos the position to set the cursor to
 */
UCF_TextEdit["prototype"]["setCursorPositionInternal"] = function(oDomRef, iPos) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setCursorPositionInternal"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()', "TextEdit.js(1881): setCursorPositionInternal"); };
	//focus will not work if LS is still locked
	if (this["oLS"]["bIsLocked"]) {
		this["iCursorPos"] = iPos;
		this["attachUnlockOnce"]();
	} else {
		this["setCursorPositionDirectly"](iPos, oDomRef);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setCursorPositionInternal"] = 0; };

/**
 * Set cursor position
 * @public
 * @param {number} iPos
 */
UCF_TextEdit["prototype"]["setCursorPosition"] = function(iPos) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setCursorPosition"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()', "TextEdit.js(1897): setCursorPosition"); };

	//focus will not work if LS is still locked
	if (this["oLS"]["bIsLocked"]) {
		this["iCursorPos"] = iPos;
		this["attachUnlockOnce"]();
	} else {
		this["setCursorPositionDirectly"](iPos, this["oDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setCursorPosition"] = 0; };

/**
 * setCursorPositionDirectly
 * @private
 * @param {number} iPos the position to set the cursor to
 * @param {HTMLElement} oDomRef the element to set the cursor in
 */
UCF_TextEdit["prototype"]["setCursorPositionDirectly"] = function(iPos, oDomRef) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setCursorPositionDirectly"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iPos === 'number', "typeof iPos === 'number'", "TextEdit.js(1916): setCursorPositionDirectly"); };

	// set CursorPos for Chrome and FireFox using selectionRange
	if (UCF_UserAgent["bIsWebKit"]() || UCF_UserAgent["bIsGecko"]()) {
		this["setSelectionDirectly"](iPos, iPos, oDomRef);
	} else {
		UCF_DomUtil["setCursorPos"](oDomRef, iPos);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setCursorPositionDirectly"] = 0; };

/**
 * setSelectionDirectly
 * @param {number} iStart start index of the selection
 * @param {number} iEnd end index of the selection
 * @param {HTMLElement} oDomRef the element to set the selection in
 */
UCF_TextEdit["prototype"]["setSelectionDirectly"] = function(iStart, iEnd, oDomRef) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setSelectionDirectly"]++; }; 

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'iStart = ' + iStart + ', iEnd = ' + iEnd + ', oDomRef = ' + oDomRef["outerHTML"]["slice"](0, 20), "TextEdit.js(1934): setSelectionDirectly"); };

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iStart === 'number', "typeof iStart === 'number'", "TextEdit.js(1936): setSelectionDirectly"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iEnd === 'number', "typeof iEnd === 'number'", "TextEdit.js(1937): setSelectionDirectly"); };

	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'UCF_DomUtil.setSelection(oDomRef, ' + iStart + ', ' + iEnd + ')', "TextEdit.js(1940): setSelectionDirectly"); };
		UCF_DomUtil["setSelection"](oDomRef, iStart, iEnd);
	} else {
		// Chrome does only scroll to a 0-width selection range
		// => create a 0-width selection range at the and before
		// applying the selection
		if (UCF_UserAgent["bIsWebKit"]() && !(UCF_UserAgent["bIsSafari"]())) {
			if (UCF_DomUtil["oGetActiveElement"]() === oDomRef && !this["bShowTextInputHelp"]) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oDomRef.blur()', "TextEdit.js(1948): setSelectionDirectly"); };
				oDomRef["blur"]();
			}
			if (iStart < iEnd) {
				this["setSelectionDirectly"](iEnd, iEnd, oDomRef);
			}
		}
		// Chrome only scrolls to the selection if the
		// textarea is focused *after* setting the selection
		// FireFox bug: TextEdit ItsMode  selection and scrolling to selection
		// works once only. The next one selection is correctly but no scrolling

		if (oDomRef["setSelectionRange"]) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oDomRef.setSelectionRange(' + iStart + ', ' + iEnd + ')', "TextEdit.js(1961): setSelectionDirectly"); };
			oDomRef["setSelectionRange"](iStart, iEnd);

			if (UCF_UserAgent["bIsSafari"]()) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oDomRef.blur()', "TextEdit.js(1965): setSelectionDirectly"); };
				oDomRef["blur"]();
			}

		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oDomRef.focus()', "TextEdit.js(1970): setSelectionDirectly"); };
		oDomRef["focus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setSelectionDirectly"] = 0; };

/**
 * Set selection
 * @public
 * @param {number} iStart start index
 * @param {number} iEnd end index
 */
UCF_TextEdit["prototype"]["setSelection"] = function(iStart, iEnd) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setSelection"]++; }; 
	// focus will not work if LS is still locked
	if (this["oLS"]["bIsLocked"]) {
		this["attachUnlockOnce"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iStartSelection = ' + iStart, "TextEdit.js(1985): setSelection"); };
		this["iStartSelection"] = iStart;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iEndSelection = ' + iEnd, "TextEdit.js(1987): setSelection"); };
		this["iEndSelection"] = iEnd;
	} else {
		this["setSelectionDirectly"](iStart, iEnd, this["oDomRef"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setSelection"] = 0; };

/**
 * Set selection
 * @private
 * @param {HTMLElement} oDomRef the element to set the selection in
 * @param {number} iStart start index
 * @param {number} iEnd end index
 */
UCF_TextEdit["prototype"]["setSelectionInternal"] = function(oDomRef, iStart, iEnd) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setSelectionInternal"]++; }; 
	// focus will not work if LS is still locked
	if (this["oLS"]["bIsLocked"]) {
		this["attachUnlockOnce"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iStartSelection = ' + iStart, "TextEdit.js(2005): setSelectionInternal"); };
		this["iStartSelection"] = iStart;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iEndSelection = ' + iEnd, "TextEdit.js(2007): setSelectionInternal"); };
		this["iEndSelection"] = iEnd;
	} else {
		this["setSelectionDirectly"](iStart, iEnd, oDomRef);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setSelectionInternal"] = 0; };

/**
 * Apply Selection
 * @private
 * @param {HTMLElement} oDomRef the element to apply the selection in after Unlock
 * @param {number} iStart start index
 * @param {number} iEnd end index
 */
UCF_TextEdit["prototype"]["applySelection"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["applySelection"]++; }; 
	if (this["iStartSelection"] >= 0 && this["iEndSelection"] >= 0) {
		this["setSelectionDirectly"](this["iStartSelection"], this["iEndSelection"], this["oFocusDomRef"]);
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iEndSelection = -1', "TextEdit.js(2024): applySelection"); };
		this["iEndSelection"] = -1;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.iStartSelection = -1', "TextEdit.js(2026): applySelection"); };
		this["iStartSelection"] = -1;
	} else if (this["iCursorPos"] >= 0) {
		this["setCursorPositionDirectly"](this["iCursorPos"], this["oFocusDomRef"]);
		this["iCursorPos"] = -1;
	}

	if (this["iScroll_Top"] >= 0 || this["iScroll_Left"] >= 0) {
		this["setScrollPositionDirectly"](this["iScroll_Left"], this["iScroll_Top"]);
		this["iScroll_Left"] = -1;
		this["iScroll_Top"] = -1;
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["applySelection"] = 0; };

/**
 * Restore Selection
 * @private
 * @param {HTMLElement} oDomRef the element to restore the selection in internal
 * @param {number} iStart start index
 * @param {number} iEnd end index
 */
UCF_TextEdit["prototype"]["restoreSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["restoreSelection"]++; }; 
	var iSelectionStart = typeof this["iSelectionStart"] === 'number'
		? this["iSelectionStart"]
		: this["iGetSelectionStart"]();
	var iSelectionEnd = typeof this["iSelectionEnd"] === 'number'
		? this["iSelectionEnd"]
		: this["iGetSelectionEnd"]();

	if (iSelectionStart === iSelectionEnd) {
		this["setCursorPosition"](this["oDomRef"]["value"]["length"]);
	} else {
		this["setSelection"](iSelectionStart, iSelectionEnd);
	}

};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["restoreSelection"] = 0; };

/**
 * Handler for the unlock event of lightspeed
 *
 * If LS is still locked it's not possible to set the focus.
 *
 * @private
 * @param {UCF_Event} oEvent the unlock
 */
UCF_TextEdit["prototype"]["onUnlock"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onUnlock"]++; }; 
	if (this["oDomRef"] == null) {
		return;
	}
	if (this["bShowTextInputHelp"]) {
		this["attachEvent"](this["E_EVENTS"]["DidOpen"], this, 'onDidOpenAfterUnlock');
		this["oFocusDomRef"]["focus"]();
	} else {
		this["applySelection"]();
	}

	this["detachUnlockOnce"]();
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onUnlock"] = 0; };

/** @private */
UCF_TextEdit["prototype"]["onDidOpenAfterUnlock"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onDidOpenAfterUnlock"]++; }; 
	this["applySelection"]();
	this["detachEvent"](this["E_EVENTS"]["DidOpen"], this);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onDidOpenAfterUnlock"] = 0; };

/**
 * Get start of selection
 *
 * @public
 * @return {number} start of selection
 */
UCF_TextEdit["prototype"]["iGetSelectionStart"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["iGetSelectionStart"]++; }; 
	// CSN 1680203125: IE sets .selectionStart/.selectionEnd to 0 after a blur.
	// oGetActiveElement == this.oDomRef || typeof(this.oDomRef.selectionStart)
	// == 'number' will be true and the 0/0 selection will be saved wrongly
	// => may only save the selection if the TextEdit is still the active element
	if (UCF_DomUtil["oGetActiveElement"]() === this["oDomRef"]) {
		this["saveSelection"]();
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'iSelectionStart=' + this["iSelectionStart"], "TextEdit.js(2105): iGetSelectionStart"); };

	return this["iSelectionStart"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["iGetSelectionStart"] = 0; };

/**
 * Get end of selection
 *
 * @public
 * @return {number} end of selection
 */
UCF_TextEdit["prototype"]["iGetSelectionEnd"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["iGetSelectionEnd"]++; }; 
	/*
		CSN 1680203125: IE sets .selectionStart/.selectionEnd to 0
		after a blur. oGetActiveElement == this.oDomRef || typeof(this.oDomRef.selectionEnd) == 'number'
		will be true and the 0/0 selection will be saved wrongly
		=> may only save the selection if the TextEdit is still the active element
	*/
	if (UCF_DomUtil["oGetActiveElement"]() === this["oDomRef"]) {
		this["saveSelection"]();
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'iSelectionEnd=' + this["iSelectionEnd"], "TextEdit.js(2126): iGetSelectionEnd"); };

	return this["iSelectionEnd"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["iGetSelectionEnd"] = 0; };

/**
 * Sets the value of the text edit
 *
 * @public
 * @param {string} sValue of the text edit
 */
UCF_TextEdit["prototype"]["setValue"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setValue"]++; }; 

	this["oDomRef"]["value"] = sValue;
	this["sOldValue"] = sValue;

	if (this["iMaxLength"] > 0) {
		this["cutToMaxlength"]();
	}

	if (this["bItsMode"]) {
		this["initializeInITSMode"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setValue"] = 0; };

/**
 * Returns the value of the text edit
 *
 * @public
 * @return {string} value of the text edit
 */
UCF_TextEdit["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getValue"]++; }; 
	return this["oDomRef"]["tagName"] === 'TEXTAREA' ? this["oDomRef"]["value"] : null;
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getValue"] = 0; };

/**
 * Sets the state of all corresponding Message Bars of this textedit
 *
 * @private
 * @param {string} sText the text of the message bar
 * @param {string} sType the type of the message bar
 */
UCF_TextEdit["prototype"]["setMessageBarsState"] = function(sText, sType) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setMessageBarsState"]++; }; 
	/** @type {UCF_TextEdit} */
	var self = this;

	UCF_JsUtil["forEach"](
		this["oLS"]["oControlFactory"]["oGetCurrentControlsByClassName"](
			'UCF_MessageBar',
			false
		),
		function(messageBar) {
			if (messageBar["sConnectedControlId"] === self["sId"]) {
				if (sType === 'INVALIDATE') {
					messageBar["setInvalidated"](true);
				} else if (sType === 'INVALIDATELOADING') {
					messageBar["setInvalidated"](true);
					messageBar["setType"]('LOADING');
				} else {
					messageBar["setText"](sText);
					messageBar["setType"](sType);
				}
			}
		}
	);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setMessageBarsState"] = 0; };

/**
 * Sets the input state of an input field
 * @param {string} sInputState input state
 * @param {string} sText text to display in the data tip
 * @public
 */
UCF_TextEdit["prototype"]["setValueState"] = function(sInputState, sText) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setValueState"]++; }; 
	/** @type {UCF_DataTip} */
	var oDataTip = this["oDataTip"];

	if (__UCF_ASSERT__) { UCF_Tracer.assert(sInputState === 'ERROR' || sInputState === 'WARNING' || sInputState === 'NONE' || sInputState === 'OK' || sInputState === 'INVALIDATE' || sInputState === 'INVALIDATELOADING', "sInputState === 'ERROR' || sInputState === 'WARNING' || sInputState === 'NONE' || sInputState === 'OK' || sInputState === 'INVALIDATE' || sInputState === 'INVALIDATELOADING'", "TextEdit.js(2203): setValueState"); };

	if (!oDataTip) {
		oDataTip = this["createDataTip"]();
	}

	// set new state
	switch (sInputState) {
		case 'ERROR':
			//this.setMessageBarsState(sText, 'ERROR');
			if (oDataTip) {
				oDataTip["setType"]('ERROR');
				oDataTip["setText"](sText);
				oDataTip["fadeIn"]();
			}
			break;

		case 'WARNING':
			//this.setMessageBarsState(sText, 'WARNING');
			if (oDataTip) {
				oDataTip["setType"]('WARNING');
				oDataTip["setText"](sText);
				oDataTip["fadeIn"]();
			}
			break;

		case 'NONE':
			//this.setMessageBarsState(sText, 'NONE');
			if (oDataTip) {
				this["removeDataTip"]();
			}
			break;

		case 'OK':
			//this.setMessageBarsState(sText, 'OK');
			if (oDataTip) {
				oDataTip["setType"]('OK');
				oDataTip["setText"](sText);
				oDataTip["fadeIn"]();
			}
			break;

		case 'INVALIDATE':
			//this.setMessageBarsState(sText, 'INVALIDATE');
			if (oDataTip) {
				oDataTip["setInvalidated"](true);
			}
			break;

		case 'INVALIDATELOADING':
			//this.setMessageBarsState(sText, 'INVALIDATE');
			if (oDataTip) {
				oDataTip["setInvalidated"](true);
			}
			break;

	}
	// eslint-disable-next-line @ur/no-missing-setClientProperty, @ur/no-memory-leaks
	this["sInputState"] = sInputState;
	// eslint-disable-next-line quotes
	this["setClientProperty"]("InputState", this["sInputState"], true);

	UCF_DomUtil["setClass"](this["oDomRef"], this["getEditFieldStyleClass"]());
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setValueState"] = 0; };

/**
 * Gets the input state of this edit field
 *
 * @public
 * @return {string} the required state
 */
UCF_TextEdit["prototype"]["getValueState"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getValueState"]++; }; 
	return this["sInputState"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getValueState"] = 0; };

/**
 * Get enabled
 *
 * @public
 * @return {boolean} the enabled state
 */
UCF_TextEdit["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getEnabled"]++; }; 
	return this["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getEnabled"] = 0; };

/**
 * Set enabled
 *
 * @public
 * @param {boolean} bEnabled the new enabled value
 */
UCF_TextEdit["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setEnabled"]++; }; 
	if (this["bEnabled"] !== bEnabled) {
		// eslint-disable-next-line @ur/no-missing-setClientProperty, @ur/no-memory-leaks
		this["bEnabled"] = bEnabled;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Enabled", this["bEnabled"], true);

		this["oDomRef"]["readOnly"] = this["bReadonly"] ? true : !bEnabled;
		UCF_DomUtil["setTabIndex"](
			this["oDomRef"],
			(window["UCF_System"]["bIs508"] || (this["bEnabled"] && !this["bReadonly"])) ? 0 : -1
		);

		UCF_DomUtil["setClass"](this["oDomRef"], this["getEditFieldStyleClass"]());
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setEnabled"] = 0; };

/**
 * @private
 * @return {boolean} `true` if enabled and not readonly, otherwise `false`
 */
UCF_TextEdit["prototype"]["bIsWriteable"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bIsWriteable"]++; }; 
	return UCF_Control.prototype["bIsWriteable"]["apply"](this, arguments) && this["sAssociatedEditContext"] !== 'PARENTREADONLY';
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bIsWriteable"] = 0; };

/**
 * @private
 *  Updates the attributes of the control with the given String representation
 * of a JS object taken from the HTML attribute 'lsdata'.
 */

UCF_TextEdit["prototype"]["updateAttributes"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["updateAttributes"]++; }; 
	UCF_Control.prototype["updateAttributes"]["apply"](this, arguments);
	// if surrounding context is readonly te is also readonly
	if (this["sAssociatedEditContext"] === 'PARENTREADONLY') {
		/** @type {boolean} */
		// eslint-disable-next-line @ur/no-missing-setClientProperty, @ur/no-memory-leaks
		this["bReadonly"] = true;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Readonly", this["bReadonly"], true);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["updateAttributes"] = 0; };

/**
 * Get readonly
 *
 * @public
 * @return {boolean} the readonly state
 */
UCF_TextEdit["prototype"]["getEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getEditable"]++; }; 
	return !this["bReadonly"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getEditable"] = 0; };

/**
 * Set Editable
 *
 * @param {boolean} bEditable the new readonly value
 * @public
 */
UCF_TextEdit["prototype"]["setEditable"] = function(bEditable) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setEditable"]++; }; 
	if (this["bReadonly"] === !bEditable) {
		return;
	} else if (!this["bEnabled"]) {
		this["bReadonly"] = !bEditable;
		// eslint-disable-next-line quotes
		this["setClientProperty"]("Readonly", this["bReadonly"], true);

		return;
	}
	this["bReadonly"] = this["oDomRef"]["readOnly"] = !bEditable;
	// eslint-disable-next-line quotes
	this["setClientProperty"]("Readonly", this["bReadonly"], true);
	UCF_DomUtil["setClass"](this["oDomRef"], this["getEditFieldStyleClass"]());

	UCF_DomUtil["setTabIndex"](
		this["oDomRef"],
		(window["UCF_System"]["bIs508"] || (this["bEnabled"] && !this["bReadonly"])) ? 0 : -1
	);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setEditable"] = 0; };

/**
 * Get the corresponding style classes of this edit field
 *
 * @private
 * @return {string}
 */
UCF_TextEdit["prototype"]["getEditFieldStyleClass"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getEditFieldStyleClass"]++; }; 
	/** @type {string} */
	var sClass = 'lsTextEdit';

	if (!this["bEnabled"]) {
		sClass = sClass + ' lsTextEdit--disabled';
	}

	if (this["bIsWriteable"]()) {
		if (this["bInvalid"] || this["sInputState"] === 'ERROR') {
			sClass = sClass + ' lsTextEdit--invalid';
		}
		if (this["sInputState"] === 'WARNING') {
			sClass = sClass + ' lsTextEdit--warning';
		}
		if (this["sInputState"] === 'NONE') {
			sClass = sClass;
		}
	}

	if (this["bEnabled"] && this["bReadonly"]) {
		if (this["bInvalid"] || this["sInputState"] === 'ERROR') {
			sClass = sClass + ' lsTextEdit--invalid-readonly';
		}
		if (this["sInputState"] === 'WARNING') {
			sClass = sClass + ' lsTextEdit--warning-readonly';
		}
		if (this["sInputState"] === 'NONE' && !this["bInvalid"]) {
			if (this["sAssociatedEditContext"] === 'PARENTREADONLY') {
				sClass = sClass + ' lsTextEdit--parent-readonly';
			} else {
				sClass = sClass + ' lsTextEdit--readonly';
			}
		}
	}

	if (this["sDesign"] === 'MONOSPACE') {
		sClass = sClass + ' lsTextEdit--monospace';
	}
	if (this["bDisplayAsText"]) {
		sClass = sClass + ' lsTextEdit--astext';
	}

	return sClass;
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getEditFieldStyleClass"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TextEdit["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(2433): onmouseover"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()' + ' (ConrolId: ' + this["sId"] + ')', "TextEdit.js(2435): onmouseover"); };

	if (oBrowserEvent["bIsMouseHover"]()) {
		this["applyHoverStylesToDom"]();
	} else {
		this["removeHoverStylesFromDom"]();
	}

};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onmouseover"] = 0; };

/**
 * Handles the onmouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TextEdit["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextEdit.js(2452): onmouseout"); };

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()' + ' (ConrolId: ' + this["sId"] + ')', "TextEdit.js(2454): onmouseout"); };

	this["removeHoverStylesFromDom"]();
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onmouseout"] = 0; };

/**
 * This method checks the hover state of the control and applies hover classes
 * to a related DOM node.
 *
 * @private
 */
UCF_TextEdit["prototype"]["applyHoverStylesToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["applyHoverStylesToDom"]++; }; 
	/** @type {HTMLElement} */
	var oItsContainer,
		oHoverRef;

	if (this["bIsWriteable"]()) {
		if (this["bItsMode"]) {
			oItsContainer = UCF_DomUtil["$"](this["sId"] + '-itsMsg');
			oHoverRef = oItsContainer !== null ? oItsContainer : this["oRootRef"];
		} else {
			oHoverRef = this["oDomRef"];
		}
		if (!UCF_DomUtil["bHasClass"](oHoverRef, this["eStyles"]["TEXTEDIT_HOVERABLE"])) {
			UCF_DomUtil["addClass"](oHoverRef, this["eStyles"]["TEXTEDIT_HOVERABLE"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["applyHoverStylesToDom"] = 0; };

/**
 * This method checks the hover state of the control and remove hover classes
 * from a related DOM node.
 *
 * @private
 */
UCF_TextEdit["prototype"]["removeHoverStylesFromDom"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["removeHoverStylesFromDom"]++; }; 
	/** @type {HTMLElement} */
	var oItsContainer,
		oHoverRef;

	if (this["bItsMode"]) {
		oItsContainer = UCF_DomUtil["$"](this["sId"] + '-itsMsg');
		oHoverRef = oItsContainer !== null ? oItsContainer : this["oRootRef"];
	} else {
		oHoverRef = this["oDomRef"];
	}
	if (UCF_DomUtil["bHasClass"](oHoverRef, this["eStyles"]["TEXTEDIT_HOVERABLE"])) {
		UCF_DomUtil["removeClass"](oHoverRef, this["eStyles"]["TEXTEDIT_HOVERABLE"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["removeHoverStylesFromDom"] = 0; };

/**
 * Handles the mousedown even
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mousedown
 */
UCF_TextEdit["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onmousedown"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()' + ' (ConrolId: ' + this["sId"] + ')', "TextEdit.js(2512): onmousedown"); };
	var iSelectionStart = typeof this["iSelectionStart"] === 'number'
		? this["iSelectionStart"]
		: this["iGetSelectionStart"]();
	var iSelectionEnd = typeof this["iSelectionEnd"] === 'number'
		? this["iSelectionEnd"]
		: this["iGetSelectionEnd"]();
	// restore selection
	if (iSelectionStart !== iSelectionEnd && this["bShowTextInputHelp"] && !this["bUsedInSapTable"] && window["UCF_System"]["sDevice"] === 'standards') {
		this["setCursorPosition"](this["oDomRef"]["value"]["length"]);
	}
	if (
		!this["bOpen"] &&
		this["bShowTextInputHelp"] &&
		oBrowserEvent["oGetSource"]() === this["oDomRef"] &&
		this["bUsedInSapTable"]
	) {
		//_trace(INFO, 'this.bNavigation before = ' + this.bNavigation);
		//this.bNavigation = true;
		//_trace(INFO, 'this.bNavigation after = ' + this.bNavigation);
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocus  before = ' + this["bIgnoreNextFocus"], "TextEdit.js(2532): onmousedown"); };
		this["bIgnoreNextFocus"] = true;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocus after = ' + this["bIgnoreNextFocus"], "TextEdit.js(2534): onmousedown"); };

		this["open"](oBrowserEvent["bIsTouchInteraction"]());
		this["setFocusStylesInTable"]();
	}
	if (this["bIsWriteable"]()) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onmousedown"] = 0; };

/**
 * Handles the mouseup even
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseup
 */
UCF_TextEdit["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onmouseup"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()' + ' (ConrolId: ' + this["sId"] + ')', "TextEdit.js(2551): onmouseup"); };
	if (UCF_DomUtil["oGetActiveElement"]() === this["oDomRef"]) {
		this["saveSelection"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onmouseup"] = 0; };

/**
 * Handles any event on the browser
 *
 * @private
 * @param {UCF_Event} oEvent the any event
 */
UCF_TextEdit["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onAnyEvent"]++; }; 
	var oBrowserEvent;
	var sName;
	var oSource;
	var oSourceControl;
	var bOpenAndOutside;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "TextEdit.js(2570): onAnyEvent"); };

	if (this["oDomRef"]) {
		oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');
		sName = oBrowserEvent["sGetName"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "*** " + sName + ' (ControlId: ' + this["sId"] + ')', "TextEdit.js(2575): onAnyEvent"); };
		oSource = oBrowserEvent["oGetSource"]();
		oSourceControl = this["oLS"]["oGetControlByDomRef"](oBrowserEvent["oGetSourceRoot"]());
		bOpenAndOutside = !this["bResizing"] && this["bOpen"] && oSourceControl !== this;

		switch (sName) {

			case 'mousedown':
				if (oSource && oSource === this["oResizeHandle"]) {
					this["startResize"]();
					oBrowserEvent["cancel"]();
					oBrowserEvent["cancelBubble"]();
				} else if (bOpenAndOutside && this["bUsedInSapTable"]) {
					this["close"]();
				}
				break;

			case 'lsfocuslost':
				if (!this["bResizing"]) {
					this["close"]();
				}
				break;

			case 'scroll':
				if (bOpenAndOutside && ((UCF_UserAgent["bIsWebKit"]() && !oBrowserEvent["bIsTouchInteraction"]()) || UCF_UserAgent["bIsGecko"]())) {
					this["close"]();
				}
				break;

			case 'lstouchstart':
				this["iMoves"] = 0;
				if (oSource && oSource === this["oResizeHandle"]) {
					this["startResize"]();
					oBrowserEvent["cancel"]();
					oBrowserEvent["cancelBubble"]();
				}
				break;

			case 'lstouchmove':
				++this["iMoves"];
				break;
			case 'lstouchend':
				if (bOpenAndOutside && this["iMoves"] < 3) {
					this["close"]();
					this["saveSelection"]();
					if (this["bUsedInSapTable"]) {
						UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTextEdit--focus');
					} else {
						this["removeFocusStyles"]();
					}
					if (UCF_UserAgent["bIsIOS"]() && this["oDomRef"]) {
						this["oDomRef"]["blur"]();
					}
				}
				break;

			case 'lstabnext':
				// Incident 1224 / 2017: Saptable should have the source of the last
				// focused Element to refresh the buffer but it has no reference to
				// the TextEdit, because it is in asso-area.
				if (bOpenAndOutside && this["bUsedInSapTable"]) {
					this["close"]();
					if (UCF_DomUtil["oActiveElement"] !== this) {
						this["focus"]();
					}
				}
				break;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onAnyEvent"] = 0; };

/**
 * Handles the state before the page will be resized.
 *
 * @param {UCF_Event} oEvent the internal event
 */
UCF_TextEdit["prototype"]["onBeforeResizePage"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onBeforeResizePage"]++; }; 
	if (this["oDomRef"] && this["bIsWriteable"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Got resize event, check for change...', "TextEdit.js(2653): onBeforeResizePage"); };
		this["prepareFireChange"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onBeforeResizePage"] = 0; };

/**
 * Starts the resize process and attaches to the mousemove and mouseup event
 * centrally.
 *
 * @private
 */
UCF_TextEdit["prototype"]["startResize"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["startResize"]++; }; 
	/** @type {UCF_Page} */
	var oPage;
	/** @type {UCF_TextEdit} */
	var self = this;
	/** @type {UCF_BrowserWindow} */
	var oWindow;

	this["bResizing"] = true;
	this["saveSelection"]();

	if (UCF_UserAgent["bIsGecko"]()) {
		this["bIgnoreNextFocusOut"] = true;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocusOut = ' + this["bIgnoreNextFocusOut"], "TextEdit.js(2677): handleEvent"); };
	}

	oPage = this["oLS"]["oGetPageInternal"]();
	if (oPage) {
		oPage["disableTextSelection"]();
	}

	this["oDomRef"]["style"]["webkitUserSelect"] = 'none';
	this["oDomRef"]["style"]["mozUserSelect"] = 'none';
	this["oDomRef"]["style"]["cursor"] = 'row-resize';

	// attaching event
	// eslint-disable-next-line @ur/no-memory-leaks
	this["handleEvent"] = function(oDomEvent) {
		switch (oDomEvent["type"]) {
			case 'mousemove':
				self["onResizeHandleMouseMove"](oDomEvent);
				break;
			case 'mouseup':
				self["onResizeHandleMouseUp"](oDomEvent);
				break;
			case 'touchmove':
				self["onResizeHandleMouseMove"](oDomEvent);
				break;
			case 'touchend':
				self["onResizeHandleMouseUp"](oDomEvent);
				break;
		}
		oDomEvent["returnValue"] = false;
		oDomEvent["cancelBubble"] = true;
		// W3C
		if (oDomEvent["preventDefault"]) {
			oDomEvent["preventDefault"]();
		}
		if (oDomEvent["stopPropagation"]) {
			oDomEvent["stopPropagation"]();
		}
	};

	UCF_DomUtil["attachEvent"](document["body"], 'mousemove', this["handleEvent"], true);
	UCF_DomUtil["attachEvent"](document["body"], 'mouseup', this["handleEvent"], true);
	UCF_DomUtil["attachEvent"](document["body"], 'touchmove', this["handleEvent"], true);
	UCF_DomUtil["attachEvent"](document["body"], 'touchend', this["handleEvent"], true);

	// locking the window
	oWindow = this["oLS"]["oBrowserWindow"];
	oWindow["lock"](UCF_BrowserWindow["LOCKTYPES"]["DRAGDROP"]);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["startResize"] = 0; };

/**
 * Stops the resize process
 * @private
 */
UCF_TextEdit["prototype"]["stopResize"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["stopResize"]++; }; 
	/** @type {UCF_Page} */
	var oPage;
	/** @type {UCF_BrowserWindow} */
	var oWindow;

	this["bResizing"] = false;

	oPage = this["oLS"]["oGetPageInternal"]();
	if (oPage) {
		oPage["enableTextSelection"]();
	}
	this["oDomRef"]["style"]["webkitUserSelect"] = '';
	this["oDomRef"]["style"]["mozUserSelect"] = '';
	this["oDomRef"]["style"]["cursor"] = '';

	this["focus"]();

	this["iResizeHeight"] = this["oDomRef"]["offsetHeight"];

	// detaching events
	UCF_DomUtil["detachEvent"](document["body"], 'mousemove', this["handleEvent"], true);
	UCF_DomUtil["detachEvent"](document["body"], 'mouseup', this["handleEvent"], true);
	UCF_DomUtil["detachEvent"](document["body"], 'touchmove', this["handleEvent"], true);
	UCF_DomUtil["detachEvent"](document["body"], 'touchend', this["handleEvent"], true);
	// unlocking the window
	oWindow = this["oLS"]["oBrowserWindow"];
	oWindow["unlock"](UCF_BrowserWindow["LOCKTYPES"]["DRAGDROP"]);

};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["stopResize"] = 0; };

/**
 * Handles the mouse down on the resize handle if the text edit is open
 * It stops the resizing
 *
 * @param {MouseEvent} oDomEvent the mouseup on the resize handle
 */
UCF_TextEdit["prototype"]["onResizeHandleMouseUp"] = function(oDomEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onResizeHandleMouseUp"]++; }; 
	this["stopResize"]();
	oDomEvent["cancelBubble"] = true;
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onResizeHandleMouseUp"] = 0; };

/**
 * Handles the mouse move on the resize handle if the text edit is open
 *
 * @param {MouseEvent} oDomEvent the mousemove on the resize handle
 */
UCF_TextEdit["prototype"]["onResizeHandleMouseMove"] = function(oDomEvent) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onResizeHandleMouseMove"]++; }; 
	/** @type {UCF_BrowserEvent} */
	var oBrowserEvent;
	/** @type {number} */
	var iPageY;

	if (this["oResizeHandle"]) {
		// eslint-disable-next-line @ur/no-memory-leaks
		oBrowserEvent = new (UCF_ClassLoader["oGetClass"]("UCF_BrowserEvent"))(oDomEvent);
		iPageY = oBrowserEvent["iPageY"]();
		oBrowserEvent["destroy"]();

		if (this["bUsedInSapTable"]) {
			this["oResizeHandle"]["style"]["top"] = Math["max"](
				iPageY - this["oResizeHandleRect"]["height"],
				this["oDomRef"]["offsetTop"] +
				this["oParentNode"]["offsetHeight"] -
				this["oResizeHandleRect"]["height"]
			) + 'px';
			this["oDomRef"]["style"]["height"] = Math["max"](
				iPageY - this["oDomRef"]["offsetTop"] - this["oResizeHandleRect"]["height"],
				this["oParentNode"]["offsetHeight"]
			) + 'px';
			// Resize the BlindLayer too otherwise the ResizeHandle stick to the mouse
			// and doesn't stop to resize it self,
			// when the TextArea is smaller as the BlindLayer!!!
			this["oBlindLayer"]["oDomRef"]["style"]["height"] = this["oDomRef"]["style"]["height"];
		} else {
			this["oResizeHandle"]["style"]["top"] = Math["max"](
				iPageY - this["oResizeHandleRect"]["height"],
				this["oDomRef"]["offsetTop"] +
				this["oPlaceHolder"]["offsetHeight"] -
				this["oResizeHandleRect"]["height"]
			) + 'px';
			this["oDomRef"]["style"]["height"] = Math["max"](
				iPageY - this["oDomRef"]["offsetTop"] - this["oResizeHandleRect"]["height"],
				this["oPlaceHolder"]["offsetHeight"]
			) + 'px';
			// Resize the BlindLayer too otherwise the ResizeHandle stick  to the mouse
			// and doesn't stop to resize it self,
			// when the TextArea is smaller as the BlindLayer!!!
			this["oBlindLayer"]["oDomRef"]["style"]["height"] = this["oDomRef"]["style"]["height"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["onResizeHandleMouseMove"] = 0; };

/**
 * adds the placeholder. It does not add it to the dom reference as there where
 * lot of issues in webkit.
 * @private
 */
UCF_TextEdit["prototype"]["addPlaceHolder"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["addPlaceHolder"]++; }; 
	/** @type {HTMLTextAreaElement} */
	this["oPlaceHolder"] = document["createElement"]('TEXTAREA');
	this["oPlaceHolder"]["style"]["visibility"] = 'hidden';
	this["oPlaceHolder"]["className"] = this["oDomRef"]["className"];
	this["oPlaceHolder"]["style"]["height"] = this["oDomRef"]["offsetHeight"] + 'px';
	this["oPlaceHolder"]["style"]["width"] = this["oDomRef"]["offsetWidth"] + 'px';
	this["oPlaceHolder"]["tabIndex"] = '-1';
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["addPlaceHolder"] = 0; };

/**
 * Removes the placeholder that is added if the text edit is opened at the
 * original space
 * @private
 */
UCF_TextEdit["prototype"]["removePlaceHolder"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["removePlaceHolder"]++; }; 
	if (this["oPlaceHolder"] && this["oPlaceHolder"]["parentNode"]) {
		this["oPlaceHolder"]["parentNode"]["removeChild"](this["oPlaceHolder"]);
		this["oPlaceHolder"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["removePlaceHolder"] = 0; };

/**
 * Opens the TextInputHelp
 * @private
 * @param { boolean } bTouchInteraction
 */
UCF_TextEdit["prototype"]["open"] = function(bTouchInteraction) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["open"]++; }; 
	if (!this["bOpen"]) {
		this["bNavigation"] = true;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation = ' + this["bNavigation"], "TextEdit.js(2859): open"); };
		this["bOpen"] = true;
		// Need it for Desktop case at this place
		if (UCF_UserAgent["bIsDesktop"]() && this["bUsedInSapTable"]) {
			if (!__UCF_IE6__) {
				UCF_DomUtil["addClass"](this["oDomRef"], 'lsTextEdit--focus');
			}
		}

		if (this["bDisplayAsText"]) {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTextEdit--astext');
		}
		if (!this["iTextHeight"]) {
			this["iTextHeight"] = UCF_DomUtil["oGetTextSize"](
				'I',
				this["oDomRef"]["className"]
			)["height"];
		}
		this["sOldZIndex"] = UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'zIndex');
		this["sOldWidth"] = this["oDomRef"]["style"]["width"];
		this["addPlaceHolder"]();

		this["undockFromParent"]();

		this["finishOpen"](bTouchInteraction);

		// need it to place the focusStyles after finishOpen,
		// because of issue on touch device
		if (bTouchInteraction) {
			if ((this["bIsWriteable"]()
					|| window["UCF_System"]["bIs508"])
				|| ((this["bReadonly"]
					|| this["bIsWriteable"]()) && window["UCF_System"]["bIsAria"])) {
				UCF_DomUtil["addClass"](this["oDomRef"], 'lsTextEdit--focus');
			}
		}
		this["fireEvent"](this["E_EVENTS"]["DidOpen"], {});
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["open"] = 0; };

/**
 * Checks whether a datatip exists for the given control. If this is
 * the case, the datatip control is created and added as a delegate
 * @override
 */
UCF_TextEdit["prototype"]["initializeDataTip"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["initializeDataTip"]++; }; 
	this["oDataTip"] = this["oGetDataTipById"](this["sId"]);
	if (this["oDataTip"]) {
		if (this["oPlaceHolder"]) {
			this["oDataTip"]["setOpenerRef"](this["oPlaceHolder"]);
			if (window["UCF_System"]["bIsRTL"]) {
				this["oDataTip"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT"]);
			} else {
				this["oDataTip"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"]);
			}

		} else {
			this["oDataTip"]["setOpenerRef"](this["oDomRef"]);
		}
		this["addDelegate"](this["oDataTip"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["initializeDataTip"] = 0; };

/**
 * Returns the height that should be applied if the text edit is opened
 * @return {number}
 */
UCF_TextEdit["prototype"]["getOpenedHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getOpenedHeight"]++; }; 
	/** @type {HTMLTextAreaElement} */
	var oDomRef = this["oDomRef"];
	/** @type {number} */
	var iPaddingTop = parseInt(UCF_DomUtil["sGetCurrentStyle"](oDomRef, 'paddingTop'));
	/** @type {number} */
	var iPaddingBottom = parseInt(UCF_DomUtil["sGetCurrentStyle"](oDomRef, 'paddingBottom'));
	/** @type {number} */
	var iTargetHeight = oDomRef["scrollHeight"] + iPaddingTop + iPaddingBottom;
	/** @type {number} */
	var clientHeight;
	/** @type {HTMLElement} */
	var oSC;
	/** @type {_ObjectRect} */
	var oOpenerRect;
	/** @type {{x:number, y:number}} */
	var oScrollOffset;
	/** @type {number} */
	var iBottomSpace;

	if (this["iResizeHeight"]) {
		iTargetHeight = this["iResizeHeight"];
	}
	if (oDomRef["offsetHeight"] > this["iMaxResizeHeight"]) {
		this["iMaxResizeHeight"] = oDomRef["offsetHeight"] + 300;
	}
	if (iTargetHeight > this["iMaxResizeHeight"]) {
		iTargetHeight = this["iMaxResizeHeight"];
	}
	if (iTargetHeight < oDomRef["offsetHeight"]) {
		iTargetHeight = Math["min"](
			oDomRef["offsetHeight"],
			this["oParentNode"]["scrollHeight"]
		);
	}

	if (this["bUsedInSapTable"]) {
		iTargetHeight = Math["max"](
			iTargetHeight,
			this["oParentNode"]["offsetHeight"],
			this["iResizeHeight"] || 0
		);
	}

	clientHeight = UCF_DomUtil["iClientHeight"]();
	if (clientHeight === 0) { // popup problematic
		oSC = UCF_DomUtil["oGetParentScrollContainer"](this["oOpenerRef"]);

		if (oSC) {
			clientHeight = oSC["clientHeight"];
		}
	}

	oOpenerRect = this["oGetObjectRect"](this["oParentNode"]);
	oScrollOffset = UCF_DomUtil["oGetScrollOffset"]();
	iBottomSpace = parseInt(clientHeight) -
		(oOpenerRect["top"] - oScrollOffset["y"]) -
		// 1 for the border + 14 for the resizer
		15; // eslint-disable-line no-magic-numbers

	if (iTargetHeight > iBottomSpace) {
		iTargetHeight = Math["max"](iBottomSpace, oDomRef["offsetHeight"]);
	}

	return iTargetHeight;
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getOpenedHeight"] = 0; };

/** @private */
UCF_TextEdit["prototype"]["storeParentRect"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["storeParentRect"]++; }; 
	/** @type {_ObjectRect} */
	var oRect = this["oGetObjectRect"](this["oParentNode"]);

	this["iParentTop"] = oRect["top"];
	this["iParentLeft"] = oRect["left"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["storeParentRect"] = 0; };

/** @private */
UCF_TextEdit["prototype"]["ignoreNextFocusEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["ignoreNextFocusEvents"]++; }; 
	if (UCF_UserAgent["bIsGecko"]() || UCF_UserAgent["bIsWebKit"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocusOut before = ' + this["bIgnoreNextFocusOut"], "TextEdit.js(3005): ignoreNextFocusEvents"); };
		this["bIgnoreNextFocusOut"] = true;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocusOut after = ' + this["bIgnoreNextFocusOut"], "TextEdit.js(3007): ignoreNextFocusEvents"); };
	}
	// this.bIgnoreNextFocus = true in FF, avoid to open a TextArea according
	// to scenario with a contextmenu and a popupwindow!!!
	//if (UCF_UserAgent.bIsGecko()) {
	//removing a node that currently has the focus will cause onblur
	//	this.bIgnoreNextFocus = true;
	//}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["ignoreNextFocusEvents"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_TextEdit["prototype"]["iGetPaddingTop"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["iGetPaddingTop"]++; }; 
	return parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'paddingTop'));
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["iGetPaddingTop"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_TextEdit["prototype"]["iGetPaddingBottom"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["iGetPaddingBottom"]++; }; 
	return parseInt(UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'padding'));
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["iGetPaddingBottom"] = 0; };

/**
 * @private
 * @return {_ObjectRect}
 */
UCF_TextEdit["prototype"]["oGetRect"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oGetRect"]++; }; 
	/** @type {_ObjectRect} */
	var oRect;

	if (this["bUsedInSapTable"]) {
		oRect = UCF_DomUtil["oGetObjectRect"](this["oPlaceHolder"]);
		oRect["left"] -= 1;
		oRect["width"] += 1;

		return oRect;
	} else {
		return UCF_DomUtil["oGetObjectRect"](this["oPlaceHolder"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oGetRect"] = 0; };

/**
 * Undocks the root ref and puts it to the asso area of the page
 * It reconnects to the dom
 * @private
 */

UCF_TextEdit["prototype"]["undockFromParent"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["undockFromParent"]++; }; 
	/** @type {_ObjectRect} */
	var oRect;
	// WebKit is weired: removeChild also removes the placeholder => re-add it
	/** @type {HTMLTextAreaElement} */
	var oPlaceHolder = this["oPlaceHolder"];
	/** @type {number} */
	//var iPaddingTop = this.iGetPaddingTop();
	/** @type {number} */
	var iHeight;
	var sPerceivedBackgroundColor = UCF_DomUtil["sGetPerceivedBackgroundColor"](this["oDomRef"]);
	this["attachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"], 'onPendingRequest');
	this["saveSelection"]();
	this["storeParentRect"]();
	this["ignoreNextFocusEvents"]();

	UCF_DomUtil["setStyle"](this["oDomRef"], UCF_JsUtil["extend"]({
			"height": this["oDomRef"]["offsetHeight"] + 'px',
			"width": 0,
			"top": 0,
			"left": 0,
			"position": 'absolute',
			"zIndex": (UCF_LS["E_LAYERS"]["POPUPWINDOWS"] + 500) + '',
			"boxShadow": '1px 1px 3px 0 #c0c0c0'
		}

	));

	this["oDomRef"]["parentNode"]["insertBefore"](oPlaceHolder, this["oDomRef"]);
	oRect = this["oGetRect"]();

	UCF_DomUtil["setStyle"](this["oDomRef"], {
		"width": oRect["width"] + 'px',
		"top": oRect["top"] + 'px',
		"left": oRect["left"] + 'px'
	});
	// eslint-disable-next-line @ur/no-memory-leaks
	this["oBlindLayer"] = this["oLS"]["oGetBlindLayer"]();
	UCF_DomUtil["setStyle"](this["oBlindLayer"]["oDomRef"], {
		"top": oRect["top"] + 'px',
		"left": oRect["left"] + 'px',
		"width": oRect["width"] + 'px',
		"height": oRect["height"] + 'px'
	});

	this["oCreateUndockingWrapper"]()["appendChild"](this["oDomRef"]);
	this["reconnectToDom"]();

	// if surrounding context is readonly te is also readonly
	if (this["sAssociatedEditContext"] === 'PARENTREADONLY') {
		UCF_DomUtil["setStyle"](this["oDomRef"], 'background-color', sPerceivedBackgroundColor);
	}

	iHeight = this["oDomRef"]["offsetHeight"];
	if (this["sOverflow"] === 'AUTO') {
		this["oDomRef"]["style"]["overflow"] = 'auto';
	} else if (this["sOverflow"] === 'SCROLL') {
		this["oDomRef"]["style"]["overflow"] = 'scroll';
	}
	// for firefox (otherwise setting of overflow will cause the field to grow)
	this["oDomRef"]["style"]["height"] = iHeight + 'px';
	this["iParentWidth"] = this["oParentNode"]["offsetWidth"];

	UCF_JsUtil["delayedCall"](0, this, 'focusDomRef');
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["undockFromParent"] = 0; };

/**
 * @private
 * @return {HTMLDivElement}
 */
UCF_TextEdit["prototype"]["oCreateUndockingWrapper"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oCreateUndockingWrapper"]++; }; 
	/** @type {HTMLDivElement} */
	var oAssociatedAreaRef = this["oLS"]["oGetAssociatedAreaRef"]();
	/** @type {string} */
	var sContentThemeScope = typeof this["oParentControl"]["sContentThemeScope"] === 'string' &&
		this["oParentControl"]["sContentThemeScope"];
	/** @type {HTMLDivElement} */
	var oWrapper;

	if (sContentThemeScope) {
		oWrapper = document["createElement"]('div');
		oWrapper["className"] = sContentThemeScope;
		oAssociatedAreaRef["appendChild"](oWrapper);

		return oWrapper;
	} else {
		return oAssociatedAreaRef;
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oCreateUndockingWrapper"] = 0; };

/**
 * Docks the current root ref back to the place where it was taken out.
 * @private
 */
UCF_TextEdit["prototype"]["dockToParent"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["dockToParent"]++; }; 
	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["PendingRequest"]);
	if (this["oDomRef"]) {
		this["oDomRef"]["style"]["height"] = this["oPlaceHolder"]["offsetHeight"] + 'px';
		this["oDomRef"]["style"]["width"] = this["sOldWidth"];
		this["oDomRef"]["style"]["zIndex"] = this["sOldZIndex"];
		this["oDomRef"]["style"]["position"] = 'static';
		if (this["bHasBoxShadow"]()) {
			this["oDomRef"]["style"]["boxShadow"] = '';
		} else {
			this["oDomRef"]["style"]["boxShadow"] = 'none';
		}
		if (this["sAssociatedEditContext"] === 'PARENTREADONLY') {
			UCF_DomUtil["setStyle"](this["oDomRef"], 'background-color', '');
		}

		if (this["bUsedInSapTable"]) {
			//	UCF_DomUtil.replaceClass(this.oDomRef, 'urTedWhl', 'urTedWhlTbl');
			this["oDomRef"]["style"]["overflow"] = 'hidden';
		}
		//this.oDomRef.style.paddingTop = '';

		if (UCF_UserAgent["bIsWebKit"]() || UCF_UserAgent["bIsGecko"]()) {
			//removing a node that currently has the focus will cause onblur
			this["bIgnoreNextFocusOut"] = true;
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bIgnoreNextFocusOut = ' + this["bIgnoreNextFocusOut"], "TextEdit.js(3177): dockToParent"); };
		}

		this["removeUndockingWrapper"]();
		this["oPlaceHolder"]["parentNode"]["replaceChild"](this["oDomRef"], this["oPlaceHolder"]);
		this["reconnectToDom"]();
		this["oDomRef"]["scrollTop"] = 0;

		if (this["oBlindLayer"]) {
			this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
		}

	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["dockToParent"] = 0; };

/** @private */
UCF_TextEdit["prototype"]["removeUndockingWrapper"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["removeUndockingWrapper"]++; }; 
	/** @type {HTMLDivElement} */
	var oAssociatedArea = this["oLS"]["oGetAssociatedAreaRef"]();

	if (
		UCF_DomUtil["bContains"](oAssociatedArea, this["oDomRef"]["parentElement"]) &&
		oAssociatedArea !== this["oDomRef"]["parentElement"]
	) {
		oAssociatedArea["removeChild"](this["oDomRef"]["parentElement"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["removeUndockingWrapper"] = 0; };

/**
 * Finishes opening of the text edit input help
 * @private
 * @param { boolean } bTouchInteraction
 */
UCF_TextEdit["prototype"]["finishOpen"] = function(bTouchInteraction) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["finishOpen"]++; }; 
	if (!this["iInitialHeight"]) {
		this["iInitialHeight"] = this["getOpenedHeight"]();
	}
	this["oDomRef"]["style"]["height"] = this["getOpenedHeight"]() + 'px';

	// set the cursor position to the end after the animation or
	// UCF_DomUtil.setCursorPos(this.oDomRef, this.oDomRef.value.length);
	// restore selection
	this["restoreSelection"]();

	this["addResizeHandle"](bTouchInteraction);

	this["oDomRef"]["style"]["left"] = this["oResizeHandle"]["style"]["left"];
	this["sInterval"] = UCF_JsUtil["intervalCall"](60, this, 'checkSize');
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["finishOpen"] = 0; };

/**
 * Returns the resize handle dom element
 * @private
 * @param { boolean } bTouchInteraction
 * @return {HTMLDivElement}
 */
UCF_TextEdit["prototype"]["getResizeHandleDom"] = function(bTouchInteraction) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getResizeHandleDom"]++; }; 
	/** @type {HTMLDivElement} */
	var oHandle = document["createElement"]('DIV');
	/** @type {UCF_Rectangle} */
	var oRect = null;
	/** @type {UCF_PopupWindow} */
	var oParentPW;
	/** @type {number} */
	var iParentPWBorderLeft;

	oRect = UCF_DomUtil["oGetObjectRect"](this["oPlaceHolder"]);

	if (window["UCF_System"]["bIsRTL"]) {
		oParentPW = this["oGetParentPopupWindow"]();
		if (oParentPW) {
			iParentPWBorderLeft = parseInt(UCF_DomUtil["sGetCurrentStyle"](
				oParentPW["oRootRef"],
				'borderLeftWidth'
			));
			if (!isNaN(iParentPWBorderLeft)) {
				oRect["left"] += iParentPWBorderLeft;
			}
		}
	}
	oHandle["setAttribute"]('id', this["sId"] + '-resizehandle');
	if (bTouchInteraction) {
		oHandle["className"] = 'urSpTHs lsTextEdit__resizehandle lsTextEdit__resizehandle--touchable';
	} else {
		oHandle["className"] = 'urSpTHs lsTextEdit__resizehandle';
	}
	oHandle["style"]["position"] = 'absolute';
	//oHandle.style.zIndex = (UCF_LS.E_LAYERS.CONTROLS + 1) + '';
	//oHandle.style.zIndex = (UCF_LS.E_LAYERS.POPUPMENUS + 1) + '';
	oHandle["style"]["zIndex"] = (UCF_LS["E_LAYERS"]["POPUPWINDOWS"] + 501) + '';
	oHandle["style"]["left"] = oRect["left"] + 'px';
	oHandle["style"]["top"] = (oRect["top"] + oRect["height"] + 1) + 'px';
	oHandle["style"]["height"] = '6px';
	if (this["bIsLegacy"]()) {
		oHandle["style"]["boxSizing"] = 'border-box';
		oHandle["style"]["MozBoxSizing"] = 'border-box';
	} else {
		oHandle["style"]["boxSizing"] = 'content-box';
		oHandle["style"]["MozBoxSizing"] = 'content-box';
	}

	if (this["bUsedInSapTable"]) {
		if (this["bIsLegacy"]()) {
			oHandle["style"]["width"] = (oRect["width"] + 1) + 'px';
		} else {
			oHandle["style"]["width"] = oRect["width"] + 'px';
		}
	} else {
		oHandle["style"]["width"] = oRect["width"] + 'px';
	}
	oHandle["style"]["borderTop"] = 'none';
	oHandle["style"]["overflow"] = 'hidden';
	oHandle["style"]["backgroundPosition"] = 'center center';
	oHandle["style"]["boxShadow"] = '1px 1px 2px 0px #c0c0c0';
	oHandle["style"]["top"] = this["oDomRef"]["offsetTop"] + this["oDomRef"]["offsetHeight"] + 'px';

	return oHandle;
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["getResizeHandleDom"] = 0; };

/**
 * Remove the resize handle
 * @private
 */
UCF_TextEdit["prototype"]["removeResizeHandle"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["removeResizeHandle"]++; }; 
	/** @type {HTMLDivElement} */
	var oHandle = this["oResizeHandle"];
	/** @type {UCF_BrowserWindow} */
	var oWindow = this["oLS"]["oBrowserWindow"];

	if (oHandle) {
		if (oHandle["parentNode"]) {
			oHandle["parentNode"]["removeChild"](oHandle);
		}
		this["oResizeHandle"] = null;
	}

	oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["removeResizeHandle"] = 0; };

/**
 * Adds the resize handle
 * @private
 * @param { boolean } bTouchInteraction
 */
UCF_TextEdit["prototype"]["addResizeHandle"] = function(bTouchInteraction) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["addResizeHandle"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oWindow = this["oLS"]["oBrowserWindow"];

	if (!this["oResizeHandle"]) {
		this["oResizeHandle"] = this["getResizeHandleDom"](bTouchInteraction);
		this["oDomRef"]["parentNode"]["appendChild"](this["oResizeHandle"]);
		this["oResizeHandleRect"] = this["oGetObjectRect"](this["oResizeHandle"]);
	}

	oWindow["attachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent');
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["addResizeHandle"] = 0; };

/**
 * Checks whether the size of the parent has changed and closes the TextInputHelp
 * @private
 */
UCF_TextEdit["prototype"]["checkSize"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["checkSize"]++; }; 
	/** @type {_ObjectRect} */
	var oRect;

	if (this["oOpenAnimation"] && this["oOpenAnimation"]["bIsRunning"]) {
		this["oOpenAnimation"]["finish"]();
		this["oOpenAnimation"] = null;
	}

	// Already destroyed (this.oParentNode is also null!)
	if (this["oDomRef"]) {
		oRect = this["oGetObjectRect"](this["oParentNode"]);
		if (
			this["oPlaceHolder"] &&
			(
				this["iParentWidth"] !== this["oParentNode"]["offsetWidth"] ||
				oRect["top"] !== this["iParentTop"] ||
				oRect["left"] !== this["iParentLeft"]
			)
		) {
			UCF_JsUtil["clearIntervalCall"](this["sInterval"]);
			this["sInterval"] = '';
			this["close"]();
		} else if (this["sInterval"] && !this["oPlaceHolder"]) {
			UCF_JsUtil["clearIntervalCall"](this["sInterval"]);
			this["sInterval"] = '';
		}
	} else {
		UCF_JsUtil["clearIntervalCall"](this["sInterval"]);
		this["sInterval"] = '';
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["checkSize"] = 0; };

/**
 * Closes the TextInputHelp
 * @private
 */
UCF_TextEdit["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["close"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()' + ' (ConrolId: ' + this["sId"] + ')', "TextEdit.js(3376): close"); };

	if (this["bOpen"]) {
		if (this["bDisplayAsText"] && !this["bUsedInSapTable"]) {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsTextEdit--astext');
		}
		this["removeFocusStyles"]();
		this["removeResizeHandle"]();

		// blur and lsblur are too early to get the change in FF. That's why we
		// need to fire changes before TextEdit is closed this.bIgnoreNextFocusOut
		// will be set to true in dockToParent();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'prepareFireChange', "TextEdit.js(3388): close"); };
		this["prepareFireChange"]();

		this["dockToParent"]();
		this["removePlaceHolder"]();

		// reset navigation mode
		if (this["bUsedInSapTable"]) {
			this["bNavigation"] = false;
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'this.bNavigation is set to = ' + this["bNavigation"], "TextEdit.js(3397): close"); };
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTextEdit--focus');
		}

		this["bOpen"] = false;

		if (this["sInterval"]) {
			UCF_JsUtil["clearIntervalCall"](this["sInterval"]);
			this["sInterval"] = '';
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["close"] = 0; };

/**
 * Adjusts the height to the texts height
 * @private
 */
UCF_TextEdit["prototype"]["adjustHeightToText"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["adjustHeightToText"]++; }; 
	/** @type {number} */
	var iTargetHeight;
	/** @type {number} */
	var iPaddingTop;
	/** @type {number} */
	var iPaddingBottom;

	if (!this["iInitialHeight"]) {
		this["iInitialHeight"] = this["oDomRef"]["offsetHeight"];
	}

	iTargetHeight = this["iResizeHeight"];
	iPaddingTop = parseInt(
		UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'paddingTop')
	);
	iPaddingBottom = parseInt(
		UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'paddingBottom')
	);

	if (
		!iTargetHeight &&
		this["iOldHeight"] &&
		(this["iOldHeight"] !== this["oDomRef"]["scrollHeight"])
	) {
		iTargetHeight = Math["min"](
			this["iMaxResizeHeight"],
			this["oDomRef"]["scrollHeight"] + 2 + (UCF_UserAgent["bIsWebKit"]() ? 0 : iPaddingTop + iPaddingBottom)
		);
	}
	// target height should always be same or larger as the inital height
	iTargetHeight = Math["max"](iTargetHeight, this["iInitialHeight"] + 2);

	this["oDomRef"]["style"]["height"] = iTargetHeight + 'px';
	if (
		iTargetHeight < this["oRootRef"]["scrollHeight"] &&
		(this["sOverflow"] === 'AUTO' || this["bUsedInSapTable"])
	) {
		this["oDomRef"]["style"]["overflow"] = 'auto';
	}
	if (this["oResizeHandle"]) {
		this["oResizeHandle"]["style"]["top"] = this["oDomRef"]["offsetTop"] + iTargetHeight + 'px';
	}
	//store current scrollHeight to compare in next step
	this["iOldHeight"] = this["oDomRef"]["scrollHeight"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["adjustHeightToText"] = 0; };

/**
 * @override
 * @return {UCF_TextEditDTExtension}
 */
UCF_TextEdit["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oGetDTExtension"]++; }; 
	return UCF_Control.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]('UCF_TextEditDTExtension'));
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oGetDTExtension"] = 0; };
/**
 * returns the DomRef which is to be focused
 * @protected
 * @return {HTMLElement} oFocusDomRef
 */
UCF_TextEdit["prototype"]["oGetFocusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oGetFocusDomRef"]++; }; 
	return this["oDomRef"]["getAttribute"]('ti') === '0'
		? this["oDomRef"]
		: this["oRootRef"]["getAttribute"]('ti') === '0'
		? this["oRootRef"]
		: this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["oGetFocusDomRef"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_TextEdit["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
		}
	}
	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["bPrepareAria"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TextEdit["prototype"]["aAttributeNames"] = ["iRows","bEnabled","bRequired","bReadonly","sTooltip","bInvalid","sVisibility","iMaxLength","sInputState","iScrollLeft","iScrollTop","bUsedInSapTable","sAccessKey","sOverflow","bDisplayAsText","bAdjustRowsToText","sAssociatedEditContext","bItsMode","bShowTextInputHelp","sCustomData","sCustomStyle","sItsMessage","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TextEdit["prototype"]["aEventNames"] = ["Change","DoubleClick","Scroll"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TextEdit["prototype"]["aMethodNames"] = ["setScrollPosition","setCursorPosition","setSelection","iGetSelectionStart","iGetSelectionEnd","setValueState","getValueState","setValue","getValue","setEnabled","getEnabled","setEditable","getEditable","createDataTip","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {number}
 */
UCF_TextEdit["prototype"]["iRows"] = -1;

/**
 * @private
 * @type {boolean}
 */
UCF_TextEdit["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_TextEdit["prototype"]["bRequired"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_TextEdit["prototype"]["bReadonly"] = false;

/**
 * @private
 * @type {string}
 */
UCF_TextEdit["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_TextEdit["prototype"]["bInvalid"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_TextEdit["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {number}
 */
UCF_TextEdit["prototype"]["iMaxLength"] = 0;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputState}
 */
UCF_TextEdit["prototype"]["sInputState"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_TextEdit["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_TextEdit["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_TextEdit["prototype"]["bUsedInSapTable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_TextEdit["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TextEditOverflow}
 */
UCF_TextEdit["prototype"]["sOverflow"] = "AUTO";

/**
 * @private
 * @type {boolean}
 */
UCF_TextEdit["prototype"]["bDisplayAsText"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_TextEdit["prototype"]["bAdjustRowsToText"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.EditContext}
 */
UCF_TextEdit["prototype"]["sAssociatedEditContext"] = "PARENTEDITABLE";

/**
 * @private
 * @type {boolean}
 */
UCF_TextEdit["prototype"]["bItsMode"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_TextEdit["prototype"]["bShowTextInputHelp"] = false;

/**
 * @private
 * @type {string}
 */
UCF_TextEdit["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TextEdit["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TextEdit["prototype"]["sItsMessage"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TextEdit["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_TextEdit["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setDefaultValues"]++; }; 
	this["iRows"] = -1;
	this["bEnabled"] = true;
	this["bRequired"] = false;
	this["bReadonly"] = false;
	this["sTooltip"] = '';
	this["bInvalid"] = false;
	this["sVisibility"] = "VISIBLE";
	this["iMaxLength"] = 0;
	this["sInputState"] = "NONE";
	this["iScrollLeft"] = 0;
	this["iScrollTop"] = 0;
	this["bUsedInSapTable"] = false;
	this["sAccessKey"] = '';
	this["sOverflow"] = "AUTO";
	this["bDisplayAsText"] = false;
	this["bAdjustRowsToText"] = false;
	this["sAssociatedEditContext"] = "PARENTEDITABLE";
	this["bItsMode"] = false;
	this["bShowTextInputHelp"] = false;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sItsMessage"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Rows", -1, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Required", false, true);
		this["setClientProperty"]("Readonly", false, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Invalid", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("MaxLength", 0, true);
		this["setClientProperty"]("InputState", "NONE", true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("UsedInSapTable", false, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("Overflow", "AUTO", true);
		this["setClientProperty"]("DisplayAsText", false, true);
		this["setClientProperty"]("AdjustRowsToText", false, true);
		this["setClientProperty"]("AssociatedEditContext", "PARENTEDITABLE", true);
		this["setClientProperty"]("ItsMode", false, true);
		this["setClientProperty"]("ShowTextInputHelp", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("ItsMessage", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue Value of the TextEdit control.
 * @fires TextEdit::Change
 */
UCF_TextEdit["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "TextEdit.js(3726): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TextEdit.js(3727): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TextEdit.js(3728): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "TextEdit.js(3729): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "TextEdit.js(3730): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("TextEdit", "Change", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the TextEdit control.
 * @param {number} iSelectionStart Start of selection
 * @param {number} iSelectionEnd End of selection
 * @fires TextEdit::DoubleClick
 */
UCF_TextEdit["prototype"]["fireDoubleClick"] = function(sId, iSelectionStart, iSelectionEnd) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string, SelectionStart: number, SelectionEnd: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "TextEdit.js(3751): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TextEdit.js(3752): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TextEdit.js(3753): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iSelectionStart != null, "iSelectionStart != null", "TextEdit.js(3754): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iSelectionStart) == "number", "typeof(iSelectionStart) == \"number\"", "TextEdit.js(3755): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iSelectionEnd != null, "iSelectionEnd != null", "TextEdit.js(3756): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iSelectionEnd) == "number", "typeof(iSelectionEnd) == \"number\"", "TextEdit.js(3757): fireDoubleClick"); };
	mParams = {
		"Id": sId,
		"SelectionStart": iSelectionStart,
		"SelectionEnd": iSelectionEnd
	};
	
	
	
	this["fireSemanticEvent"]("TextEdit", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollLeft Sets the distance between the left edge of the object and the leftmost portion of the content currently visible in pixels.
 * @param {number} iScrollTop Sets the distance between the top of the object and the topmost portion of the content currently visible in pixels.
 * @fires TextEdit::Scroll
 */
UCF_TextEdit["prototype"]["fireScroll"] = function(sId, iScrollLeft, iScrollTop) {;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollLeft: number, ScrollTop: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "TextEdit.js(3780): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TextEdit.js(3781): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TextEdit.js(3782): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "TextEdit.js(3783): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "TextEdit.js(3784): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "TextEdit.js(3785): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "TextEdit.js(3786): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollLeft": iScrollLeft,
		"ScrollTop": iScrollTop
	};
	
	
	
	this["fireSemanticEvent"]("TextEdit", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TextEdit["_"]["fireScroll"] = 0; };

UCF_TextEdit.prototype["aPublicMethods"] = ["focus","setScrollPosition","setScrollPositionDirectly","setCursorPosition","setSelection","iGetSelectionStart","iGetSelectionEnd","setValue","getValue","setValueState","getValueState","getEnabled","setEnabled","getEditable","setEditable"].concat(UCF_TextEdit.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TextEditDTExtension"] = function() {/* global UCF_DTExtension */
/// <reference path="./DTExtension.js"/>

/**
 * 
 * @class
 *
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oControl
 * @param {UCF_DTElement} oDTElement
 * @private
 */
function UCF_TextEditDTExtension(oLS, oControl, oDTElement) {if (__UCF_COVERAGE__) { UCF_TextEditDTExtension["_"]["UCF_TextEditDTExtension"]++; }; 
	if (arguments["length"] === 0) return;
	UCF_DTExtension["apply"](this, arguments);
};window["UCF_TextEditDTExtension"] = UCF_TextEditDTExtension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TextEditDTExtension"); UCF_TextEditDTExtension["_"] = {UCF_TextEditDTExtension: 0}; }; ;

UCF_TextEditDTExtension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTExtension"))(); UCF_TextEditDTExtension.prototype["sClassName"] = "UCF_TextEditDTExtension";

UCF_TextEditDTExtension["prototype"]["oGetDomRefForParentPosRefContainer"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditDTExtension["_"]["oGetDomRefForParentPosRefContainer"]++; }; 
	// The root element is a ScrollArea!
	return this["oControl"]["oRootRef"]["parentNode"];
};;if (__UCF_COVERAGE__) { UCF_TextEditDTExtension["_"]["oGetDomRefForParentPosRefContainer"] = 0; };

};
sap["ls"]["preload"]["UCF_TextEditInplaceEdit"] = function() {/* global _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Animation */
/// <reference path="../anim/Animation.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_TextEdit */
/// <reference path="./TextEdit.js"/>
/**
 * @constructor
 * 
 * @param {HTMLElement} oDomRef the dom element
 * @param {UCF_LS} oLS the LS instance
 */
function UCF_TextEditInplaceEdit(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["UCF_TextEditInplaceEdit"]++; }; 
	UCF_TextEdit["apply"](this, [oDomRef, oLS]);

	/** @type {number} */
	this["iOldHeight"] = 0;
	/** @type {number} */
	this["iBorderWidth"] = 1;
};window["UCF_TextEditInplaceEdit"] = UCF_TextEditInplaceEdit; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TextEditInplaceEdit"); UCF_TextEditInplaceEdit["_"] = {UCF_TextEditInplaceEdit: 0}; }; ;
UCF_TextEditInplaceEdit["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_TextEdit"))(); UCF_TextEditInplaceEdit.prototype["sClassName"] = "UCF_TextEditInplaceEdit";

/** @constant {string} */
//UCF_TextEditInplaceEdit.CLASSNAME = 'lsEdTextEditInplaceEdit';

/** @override */
UCF_TextEditInplaceEdit["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["initialize"]++; }; 
	this["iBorderWidth"] = 1;
	//this.oDomRef.parentNode.style.padding = this.iBorderWidth;

	// needed because of calculation bug when width is not set
	if (
		this["oDomRef"]["offsetWidth"] > 0
		&& (
			window["UCF_System"]["sDevice"] !== 'standards' ||
			this["oDomRef"]["style"]["width"] === ''
		)
	) {
		this["oDomRef"]["style"]["width"] = this["oDomRef"]["offsetWidth"] + 'px';
	}

	if (this["bAdjustRowsToText"]) {
		this["adaptHeight"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["initialize"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsfocus
 */
UCF_TextEditInplaceEdit["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["onlsfocus"]++; }; 

	if (UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsTextEdit--astext')) {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTextEdit--astext');
	}

	UCF_TextEdit.prototype["onlsfocus"]["call"](this, oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["onlsfocus"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the lsblur
 */
UCF_TextEditInplaceEdit["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["onlsblur"]++; }; 
	UCF_TextEdit.prototype["onlsblur"]["call"](this, oBrowserEvent);

	this["enterViewMode"]();

};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["onlsblur"] = 0; };

/** @private */
UCF_TextEditInplaceEdit["prototype"]["enterEditMode"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["enterEditMode"]++; }; 

	if (this["bIsEditable"]()) {
		if (UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsTextEdit--astext')) {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTextEdit--astext');
		}
	}

};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["enterEditMode"] = 0; };

/** @private */
UCF_TextEditInplaceEdit["prototype"]["enterViewMode"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["enterViewMode"]++; }; 

	if (!this["bUsedInSapTable"]) {
		if (!UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsTextEdit--astext')) {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsTextEdit--astext');
		}
	}

};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["enterViewMode"] = 0; };

/**
 * gets the height of the parent element reduced by the computed border
 * width. caches the result for performance.
 *
 * @private
 * @return {number} the height of the parent element
 */
UCF_TextEditInplaceEdit["prototype"]["iGetRootHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["iGetRootHeight"]++; }; 
	if (!this["iRootHeight"]) {
		if (this["oRootRef"]["clientHeight"]) {
			// eslint-disable-next-line no-magic-numbers
			this["iRootHeight"] = this["oRootRef"]["clientHeight"] - (this["iBorderWidth"] * 2);
		}
	}
	return this["iRootHeight"];
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["iGetRootHeight"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_TextEditInplaceEdit["prototype"]["oGetComputedStyle"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["oGetComputedStyle"]++; }; 
	if (this["oComputedStyle"] === undefined) {
		this["oComputedStyle"] = UCF_DomUtil["oGetComputedStyle"](this["oDomRef"]);
	}

	return this["oComputedStyle"];
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["oGetComputedStyle"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_TextEditInplaceEdit["prototype"]["sGetBorderTopWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["sGetBorderTopWidth"]++; }; 
	if (this["iBorderTopWidth"] === undefined) {
		this["sBorderTopWidth"] = this["oGetComputedStyle"]()["borderTopWidth"];
	}

	return this["sBorderTopWidth"];
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["sGetBorderTopWidth"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_TextEditInplaceEdit["prototype"]["sGetBorderBottomWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["sGetBorderBottomWidth"]++; }; 
	if (this["iBorderBottomWidth"] === undefined) {
		this["sBorderBottomWidth"] = this["oGetComputedStyle"]()["borderBottomWidth"];
	}

	return this["sBorderBottomWidth"];
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["sGetBorderBottomWidth"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_TextEditInplaceEdit["prototype"]["onkeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["onkeyup"]++; }; 
	if (this["bAdjustRowsToText"] && !this["bReadonly"]) {
		if (UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsTextEdit--astext')) {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTextEdit--astext');
		}
		this["adaptHeight"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["onkeyup"] = 0; };

/**
 * @private
 * @param {boolean} bUseAnimation `true` to animate height adaption
 */
UCF_TextEditInplaceEdit["prototype"]["adaptHeight"] = function(bUseAnimation) {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["adaptHeight"]++; }; 
	/** @type {number} */
	var iOldHeight = this["oDomRef"]["clientHeight"];
	/** @type {number} */
	var iCurrentHeight;
	/** @type {number} */
	var iLineHeight;
	/** @type {number} */
	var iThreshold;
	/** @type {number} */
	var iNewHeight = 0;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oldHeight = ' + iOldHeight, "TextEditInplaceEdit.js(181): adaptHeight"); };

	//needed for FF, also works for IE
	this["oDomRef"]["style"]["height"] = '1px';
	iCurrentHeight = this["oDomRef"]["scrollHeight"];

	// eslint-disable-next-line no-magic-numbers
	if (this["sGetBorderTopWidth"]() === '0px' && this["sGetBorderBottomWidth"]() === '0px') {
		this["oDomRef"]["style"]["height"] = iOldHeight + 'px';
	} else {
		this["oDomRef"]["style"]["height"] = (iOldHeight + (this["iBorderWidth"] * 2)) + 'px';
	}

	iLineHeight = this["iGetLineHeight"]();
	// eslint-disable-next-line no-magic-numbers
	iThreshold = (this["iBorderWidth"] * 2) + this["iRows"] * iLineHeight;
	iNewHeight = Math["max"](
		// eslint-disable-next-line no-magic-numbers
		(iCurrentHeight >= iThreshold) ? iThreshold : iCurrentHeight + 2,
		// eslint-disable-next-line no-magic-numbers
		iLineHeight + (this["iBorderWidth"] * 2)
	);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'iNewHeight = ' + iNewHeight, "TextEditInplaceEdit.js(203): adaptHeight"); };

	if (iNewHeight !== this["iOldHeight"]) {
		if (window["UCF_System"]["bUseAnimation"] && bUseAnimation) {
			if (this["oAnim"] && this["oAnim"]["bRunning"]) {
				this["oAnim"]["stop"]();
			}

			// eslint-disable-next-line no-magic-numbers
			this["oAnim"] = new (UCF_ClassLoader["oGetClass"]("UCF_Animation"))(this["oDomRef"], 300);
			this["oAnim"]["addStyleChange"](
				'height',
				'',
				'px',
				this["iOldHeight"],
				iNewHeight,
				this["oAnim"]["M_TRANSITIONS"]["EaseIn"]
			);

			this["oAnim"]["play"]();
		} else {
			this["oDomRef"]["style"]["height"] = iNewHeight + 'px';
		}
		this["iOldHeight"] = iNewHeight;
	}
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["adaptHeight"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_TextEditInplaceEdit["prototype"]["iGetLineHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["iGetLineHeight"]++; }; 
	/** @type {HTMLSpanElement} */
	var oCloneDomRef = document["createElement"]('span');
	/** @type {number} */
	var iOffsetHeight;

	oCloneDomRef["className"] = this["oDomRef"]["className"];
	oCloneDomRef["style"]["display"] = 'block';
	oCloneDomRef["style"]["position"] = 'absolute';
	oCloneDomRef["style"]["top"] = '-1000px';
	var sText = 'AbC';

	UCF_DomUtil["setInnerHtml"](oCloneDomRef, sText);
	this["oLS"]["oGetAssociatedAreaRef"]()["appendChild"](oCloneDomRef);

	iOffsetHeight = oCloneDomRef["offsetHeight"];

	this["oLS"]["oGetAssociatedAreaRef"]()["removeChild"](oCloneDomRef);

	// eslint-disable-next-line no-magic-numbers
	return iOffsetHeight - (this["iBorderWidth"] * 2);
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["iGetLineHeight"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseover
 */
UCF_TextEditInplaceEdit["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["onmouseover"]++; }; 

	if (!this["bUsedInSapTable"]) {
		if (this["bIsEditable"]() && (this["bIsViewMode"]() || this["bIsFocused"]())) {
			if (UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsTextEdit--astext')) {
				UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTextEdit--astext');
			}
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsTextEdit--hover');
		}
		if (this["bReadonly"] || !this["bEnabled"]) {
			if (UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsTextEdit--astext')) {
				UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTextEdit--astext');
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["onmouseover"] = 0; };

/**
 * @protected
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseout
 */
UCF_TextEditInplaceEdit["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["onmouseout"]++; }; 

	if (!this["bUsedInSapTable"]) {
		if (this["bIsEditable"]()) {
			if (this["bIsViewMode"]()) {
				UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTextEdit--hover');
			} else if (this["bIsFocused"]()) {
				UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTextEdit--hover');
			} else {
				UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTextEdit--hover');
				UCF_DomUtil["addClass"](this["oDomRef"], 'lsTextEdit--astext');
			}
		}
		if ((this["bReadonly"] || !this["bEnabled"]) && UCF_DomUtil["oGetActiveElement"]() !== this["oDomRef"]) {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsTextEdit--astext');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["onmouseout"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_TextEditInplaceEdit["prototype"]["bIsHovered"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["bIsHovered"]++; }; 
	return UCF_DomUtil["bHasClass"](
		this["oDomRef"],
		'lsTextEdit--hover'
	);
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["bIsHovered"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_TextEditInplaceEdit["prototype"]["bIsFocused"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["bIsFocused"]++; }; 
	return UCF_DomUtil["bHasClass"](
		this["oDomRef"],
		'lsTextEdit--focus'
	);
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["bIsFocused"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_TextEditInplaceEdit["prototype"]["bIsEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["bIsEditable"]++; }; 
	return this["bEnabled"] && !this["bReadonly"];
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["bIsEditable"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_TextEditInplaceEdit["prototype"]["bIsViewMode"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["bIsViewMode"]++; }; 
	return UCF_DomUtil["bHasClass"](
		this["oDomRef"],
		'lsTextEdit--astext'
	);
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["bIsViewMode"] = 0; };

UCF_TextEditInplaceEdit["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["destroy"]++; }; 

	this["iRootHeight"] = null;
	this["oComputedStyle"] = null;
	this["sBorderTopWidth"] = null;
	this["sBorderBottomWidth"] = null;

	if (this["oAnim"]) {
		this["oAnim"]["destroy"]();
		this["oAnim"] = null;
	}

	UCF_TextEdit.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TextEditInplaceEdit["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_TextInputHelp"] = function() {/* global UCF_EventProvider */
/// <reference path="../../core/EventProvider.js"/>

/**
 * Provides a Input Help that allows to enter text. You can run this InputHelp
 * in RichText or TextArea mode. The user can enter multi line text and take
 * this text over into a connected control. The Close event is raised on the
 * TextInputHelp control. Close is raised if the user presses F2, TAB passes
 * the new value back. ESC key does not return any value. Close is raised also
 * if the user unfocusses the InputHelp somehow including the new value. The
 * TextBox in the InputHelp can be resized by the user. The default width
 * depends on the with of the connected control. The default height will be 5
 * rows that can be possibly entered.
 *
 * 
 * @version
 *
 * @class
 * @param {UCF_LS} oLS
 * @param {HTMLElement} oDomRef
 * @param {UCF_Control} oConnectedControl
 */
function UCF_TextInputHelp(oLS, oDomRef, oConnectedControl) {if (__UCF_COVERAGE__) { UCF_TextInputHelp["_"]["UCF_TextInputHelp"]++; }; 
	UCF_EventProvider["apply"](this, []);

	this["defineEvents"](['Close']);

	this["oLS"] = oLS;
	this["oDomRef"] = oDomRef;
	this["oConnectedControl"] = oConnectedControl;
};window["UCF_TextInputHelp"] = UCF_TextInputHelp; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TextInputHelp"); UCF_TextInputHelp["_"] = {UCF_TextInputHelp: 0}; }; ;
UCF_TextInputHelp["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_TextInputHelp.prototype["sClassName"] = "UCF_TextInputHelp";

/**
 * Destructor
 */
UCF_TextInputHelp["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TextInputHelp["_"]["destroy"]++; }; 

	this["oLS"] = null;
	this["oDomRef"] = null;
	this["oConnectedControl"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TextInputHelp["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_TextView"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * A TextView should be used for displaying a non-editable text. Like in a text
 * document or on a Web page, the text may have different styles (colors and
 * font-sizes).
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TextView(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TextView["_"]["UCF_TextView"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "TextView.js(34): UCF_TextView"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TextView.js(35): UCF_TextView"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TextView.js(36): UCF_TextView"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	/** Ensure text selection is possible @private */
	this["allowTextSelection"]();
	//ensure the text member has the current inner text value.
	this["sText"] = this["getText"]();
	//this.setClientProperty("Text", this.sText);
	this["sAriaRole"] = null;
};window["UCF_TextView"] = UCF_TextView; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TextView"); UCF_TextView["_"] = {UCF_TextView: 0}; }; ;
UCF_TextView["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TextView.prototype["sClassName"] = "UCF_TextView";

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TextView["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextView.js(57): onclick"); };

	if (this["mEvents"]["Activate"]) {
		this["fireActivate"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onclick"] = 0; };

/**
 * Handles the onmousedown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TextView["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextView.js(72): onmousedown"); };

	if (this["mEvents"]["Activate"]) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onmousedown"] = 0; };

/**
 * Returns the DOM element for the Text Overflow
 * it might reurn null
 *
 * @return {HTMLElement} the DOM element that should be focussed if the
 * controls focus method is called.
 */
UCF_TextView["prototype"]["oGetTextOverflowDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["oGetTextOverflowDomRef"]++; }; 

	/**@type {HTMLElement} */
	var oDomRefOvfl = null;

	if (window["UCF_System"]["sDevice"] === 'standards') {
		if (this["oDomRef"]["getAttribute"] && this["oDomRef"]["getAttribute"]('data-textoverflow') === 'true') {
			oDomRefOvfl = document["createElement"]("span");
			UCF_DomUtil["addClass"](oDomRefOvfl, 'lsTextView--overflow-hidden');
			UCF_DomUtil["setInnerText"](oDomRefOvfl, this["sText"]);
			UCF_DomUtil["append"](this["oDomRef"], oDomRefOvfl);
		}

	} else
		oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + "-ovfl");

	return oDomRefOvfl;
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["oGetTextOverflowDomRef"] = 0; };

/**
 * Returns the DOM element for the Text Overflow
 * it might be null
 * @param {HTMLElement} oDomRef
 */
UCF_TextView["prototype"]["removeTextOverflowDomRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["removeTextOverflowDomRef"]++; }; 
	if (window["UCF_System"]["sDevice"] === 'standards') {
		if (this["oDomRef"]["getAttribute"] && this["oDomRef"]["getAttribute"]('data-textoverflow') === 'true') {
			UCF_DomUtil["removeFromDom"](oDomRef);
			oDomRef = null;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["removeTextOverflowDomRef"] = 0; };

/**
 * Handles the mouseover event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_TextView["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextView.js(126): onmouseover"); };

	if (window["UCF_System"]["bIs508"]) return;
	var sCurrentText = this["getText"](),
		oDomRefOvfl = this["oGetTextOverflowDomRef"](); // UCF_DomUtil.$(this.sId + "-ovfl");

	UCF_DomUtil["checkTooltip"](this["oDomRef"], this["sTooltip"], oDomRefOvfl, sCurrentText);
	this["removeTextOverflowDomRef"](oDomRefOvfl);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onmouseover"] = 0; };

/**
 * Handles the onmouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TextView["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextView.js(143): onmouseout"); };

	if (window["UCF_System"]["bIs508"]) return;

	if (this["sTooltip"])
		this["oDomRef"]["title"] = this["sTooltip"];
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onmouseout"] = 0; };
/**
 * Handles the lsselect (space and enter) event of LightSpeed
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TextView["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onlsselect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextView.js(158): onlsselect"); };

	if (this["mEvents"]["Activate"]) {
		this["fireActivate"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onlsselect"] = 0; };
if (!__UCF_IE6__) {
	/**
	 * Handles the onlsfocus event of LightSpeed
	 *
	 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
	 * @private
	 */
	UCF_TextView["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onlsfocus"]++; }; 

		if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextView.js(174): onlsfocus"); };
		if (!window["UCF_System"]["bIsAria"]) return;

		// The TextView has no information in renderer if  the Activate event is set
		// So on lsFocus set the role=button when the Activate event is configured
		/*		if (this.mEvents.Activate && this.sAriaRole !== 'button') {
					this.oDomRef.setAttribute('role', 'button');
					this.sAriaRole = 'button';
				}*/
	};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onlsfocus"] = 0; };

}

/**
 * Returns the DOM element that should be focussed if the controls focus method
 * is called. Please do overide if the DOM element is other than the oRootRef
 * or the oDomRef.
 *
 * @return {HTMLElement} the DOM element that should be focussed if the
 * controls focus method is called.
 */
UCF_TextView["prototype"]["oGetForcedFocusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["oGetForcedFocusDomRef"]++; }; 
	return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["oGetForcedFocusDomRef"] = 0; };

/**
 * Handles the double click event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TextView["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["ondblclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextView.js(207): ondblclick"); };

	if (this["mEvents"]["DoubleClick"]) {
		UCF_DomUtil["removeSelection"](this["oDomRef"]);
		this["fireDoubleClick"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["ondblclick"] = 0; };

/**
 * Sets the text of a textview control
 *
 * @public
 * @param {string} sText the new text of the textview
 */
UCF_TextView["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setText"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sText) === "string", "typeof(sText) === \"string\"", "TextView.js(224): setText"); };
	if (this["sText"] === '' || sText === '') {
		this["updateToEmptyText"](sText);
	} else {
		var oOverflow = UCF_DomUtil["$"](this["sId"] + '-ovfl'),
			oAriaTooltip = UCF_DomUtil["$"](this["sId"] + '-ariadescription'),
			bContent = this["bRequired"] || oOverflow != null
			|| oAriaTooltip != null;

		if (bContent) {
			if (this["oDomRef"]["firstChild"] === oOverflow)
				this["oDomRef"]["insertBefore"](document["createTextNode"](sText), oOverflow);
			else if (this["oDomRef"]["firstChild"] === oAriaTooltip) {
				this["oDomRef"]["insertBefore"](document["createTextNode"](sText), oAriaTooltip);
			} else
				this["oDomRef"]["firstChild"]["data"] = sText;
			// Set the text for the TextOverflow
			if (oOverflow && oOverflow !== this["oDomRef"]["firstChild"])
				UCF_DomUtil["setInnerText"](oOverflow, sText);
			// if the Tooltip is empty and the Text was empty, the Aria Description has <Empty> as text
			// which is obsolated when a text is set
			if (oAriaTooltip && this["sTooltip"] === '' && sText !== '') {
				UCF_DomUtil["removeFromDom"](oAriaTooltip);
			}
		} else UCF_DomUtil["setInnerText"](this["oDomRef"], sText);
	}

	this["sText"] = sText;
	this["setClientProperty"]("Text", sText, true);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setText"] = 0; };

/**
 *  set or Add - ariadescription
 * @param {string} sText the new text of the Textview
 */
UCF_TextView["prototype"]["updateToEmptyText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["updateToEmptyText"]++; }; 
	/**@type {RenderManager} */
	var oRenderManager;

	oRenderManager = this["oLS"]["oGetRenderManager"]();
	oRenderManager["write"](this["oLS"]["oGetRenderManager"]()["callFragment"](
		'TextViewFragment',
		'TextView', {
			"Id": this["sId"],
			"Text": sText,
			"Tooltip": this["sTooltip"],
			"Wrapping": false,
			"Required": false,
			"Enabled": this["bEnabled"],
			"Design": this["sDesign"],
			"Layout": this["sLayout"],
			"SemanticColor": this["sSemanticColor"],
			"SemanticBgColor": this["sSemanticBgColor"],
			"HasPopupMenu": false,
			"IsNested": false,
			"Width": '',
			"Align": this["sAlign"],
			"TextDirection": 'INHERIT',
			"Visibility": 'VISIBLE',
			"TextForTooltip": '',
			"TextOverflow": true,
			"Tabstop": this["bTabstop"],
			"UsedInSapTable": this["bUsedInSapTable"],
			"PreserveWhitespace": false,
			"CustomData": this["sCustomData"],
			"CustomStyle": this["sCustomStyle"],
			"HeadingLevel": this["iHeadingLevel"],
			"LabelledBy": this["sLabelledBy"],
			"Hint": '',
			"VerticalSpacing": 'ALIGNED'
		}
	));

	UCF_DomUtil["replaceElement"](
		this["oRootRef"],
		oRenderManager["oGetElementFromHtml"]()
	);
	oRenderManager["clearBuffer"]();

};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["updateToEmptyText"] = 0; };

/**
 *  set or Add -ariadescription
 * @param {string} sTooltip the new tooltip of the textview
 */
UCF_TextView["prototype"]["updateAriaDescription"] = function(sTooltip) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["updateAriaDescription"]++; }; 
	/** @type {Node} */
	var oAriaDescDomRef;
	/** @type {HTMLSpanElement} */
	var oSpan;

	if (!window["UCF_System"]["bIsAria"]) return;

	// set/add -ariadescription
	/** @type {Node} */
	oAriaDescDomRef = UCF_DomUtil["$"](this["sId"] + '-ariadescription');
	if (oAriaDescDomRef) {
		UCF_DomUtil["setInnerText"](oAriaDescDomRef, sTooltip);
	} else {
		oSpan = document["createElement"]("span");
		oSpan["setAttribute"]('id', this["sId"] + '-ariadescription');
		UCF_DomUtil["setClass"](oSpan, 'lsTextView--pseudoHidden');
		UCF_DomUtil["setInnerText"](oSpan, sTooltip);
		UCF_DomUtil["append"](this["oDomRef"], oSpan);
	}
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["updateAriaDescription"] = 0; };
/**
 * Sets the tooltip of a textview control
 *
 * @public
 * @param {string} sTooltip the new tooltip of the textview
 */
UCF_TextView["prototype"]["setTooltip"] = function(sTooltip) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setTooltip"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTooltip) === "string", "typeof(sTooltip) === \"string\"", "TextView.js(338): setTooltip"); };

	//Todo: refocus
	UCF_DomUtil["setTooltip"](this["oDomRef"], sTooltip);
	this["updateAriaDescription"](sTooltip);

	this["sTooltip"] = sTooltip;
	this["setClientProperty"]("Tooltip", sTooltip, true);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setTooltip"] = 0; };

/**
 * Sets the Align property of a textview control
 *
 * @public
 * @param {string} sAlign the textAlign style property of the textview
 * @param {string} sTextDirection the sTextDirection style property of the textview
 */
UCF_TextView["prototype"]["setAlign"] = function(sAlign, sTextDirection) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setAlign"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAlign) === "string", "typeof(sAlign) === \"string\"", "TextView.js(357): setAlign"); };

	UCF_DomUtil["setTextAlign"](this["oDomRef"], sAlign, sTextDirection);

	this["sAlign"] = sAlign;
	this["setClientProperty"]("Align", sAlign, true);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setAlign"] = 0; };

/**
 * Sets the Align property of a textview control
 *
 * @public
 * @param {string} sDesign the design
 */
UCF_TextView["prototype"]["setDesign"] = function(sDesign) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setDesign"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDesign) === "string", "typeof(sDesign) === \"string\"", "TextView.js(373): setDesign"); };

	if (sDesign && this["sDesign"] === sDesign) return;
	var iHeadingLevel = 0;
	var sOldClassDesign = this["sGetTextDesignClass"](this["sDesign"]),
		sNewClassDesign = this["sGetTextDesignClass"](sDesign);

	UCF_DomUtil["removeClass"](this["oDomRef"], sOldClassDesign);
	UCF_DomUtil["addClass"](this["oDomRef"], sNewClassDesign);

	switch (sDesign) {
		case "HEADER1":
			if (this["iHeadingLevel"] > 0) {
				iHeadingLevel = this["iGetHeaderAria"](this["iHeadingLevel"]);
			} else {
				iHeadingLevel = 1;
			}
			break;
		case "HEADER2":
			if (this["iHeadingLevel"] > 0) {
				iHeadingLevel = this["iGetHeaderAria"](this["iHeadingLevel"]);
			} else {
				iHeadingLevel = 2;
			}
			break;
		case "HEADER3":
			if (this["iHeadingLevel"] > 0) {
				iHeadingLevel = this["iGetHeaderAria"](this["iHeadingLevel"]);
			} else {
				iHeadingLevel = 3;
			}
			break;
		case "HEADER4":
			if (this["iHeadingLevel"] > 0) {
				iHeadingLevel = this["iGetHeaderAria"](this["iHeadingLevel"]);
			} else {
				iHeadingLevel = 4;
			}
			break;
		case "GROUPTITLE":
			if (this["iHeadingLevel"] > 0) {
				iHeadingLevel = this["iGetHeaderAria"](this["iHeadingLevel"]);
			} else {
				iHeadingLevel = 2;
			}
			break;
	}

	if (iHeadingLevel > 0 && (window["UCF_System"]["bIs508"] || window["UCF_System"]["sAccessibility"] === "ARIA")) {
		this["oDomRef"]["setAttribute"]("role", "heading");
		this["oDomRef"]["setAttribute"]("aria-level", iHeadingLevel);
	} else {
		this["oDomRef"]["removeAttribute"]("role");
		this["oDomRef"]["removeAttribute"]("aria-level");
	}

	if ((window["UCF_System"]["bIs508"] && !this["bIsNested"] && (this["sDesign"] !== "GROUPTITLE")) || this["bTabstop"]) {
		this["oDomRef"]["setAttribute"]("tabindex", 0);
	} else {
		this["oDomRef"]["setAttribute"]("tabindex", -1);
	}

	this["sDesign"] = sDesign;
	this["setClientProperty"]("Design", sDesign, true);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setDesign"] = 0; };

/**
 * Retrieves the design class
 *
 * @private
 * @param {string} sDesign the design
 * @return {string} the design class
 */
UCF_TextView["prototype"]["sGetTextDesignClass"] = function(sDesign) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["sGetTextDesignClass"]++; }; 
	return sDesign
		? this["oLS"]["oGetRenderManager"]()["callFragment"](
			'TextViewDesignClass',
			'TextView', {
				"Design": sDesign,
				"Enabled": this["bEnabled"],
				"SemanticColor": this["sSemanticColor"]
			}
		)
		: '';
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["sGetTextDesignClass"] = 0; };

/**
 * @private
 * @param {number} iHeadingLevel
 * @return {number}
 */
UCF_TextView["prototype"]["iGetHeaderAria"] = function(iHeadingLevel) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["iGetHeaderAria"]++; }; 
	return typeof iHeadingLevel !== 'undefined' && this["oLS"]["oGetRenderManager"]()["callFragment"](
		'UrBase_iAriaLevel',
		'UrBase', { "HeadingLevel": iHeadingLevel }
	);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["iGetHeaderAria"] = 0; };
/**
 * Gets the text of a textview control
 *
 * @public
 * @return {string} - the text of the text view
 */
UCF_TextView["prototype"]["getText"] = function() {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["getText"]++; }; 

	if (!this["oDomRef"]) return '';

	if (this["oDomRef"]["getAttribute"] && this["oDomRef"]["getAttribute"]('data-emptytext') === 'true')
		return '';

	var oOverflow = UCF_DomUtil["$"](this["sId"] + '-ovfl'),
		oAriaTooltip = UCF_DomUtil["$"](this["sId"] + '-ariadescription'),
		bContent = this["bRequired"] || oOverflow != null
		|| oAriaTooltip != null;
	var sText = UCF_DomUtil["sGetInnerText"](this["oDomRef"]);

	if (bContent) {
		if (this["oDomRef"]["firstChild"] === oOverflow
			|| this["oDomRef"]["firstChild"] === oAriaTooltip) {
			// there is no text set
			sText = '';
		} else
			sText = this["oDomRef"]["firstChild"]["data"];
	}
	if (this["bRequired"])
		sText = sText["substring"](0, sText["lastIndexOf"]('*') - 1); //-1 because of leading space
	return sText;
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["getText"] = 0; };

/**
 * Sets the Semantic Color of the current text view
 * Not all combination with semantic background color are supported.
 * @public
 * @param {string} sSemanticColor
 */
UCF_TextView["prototype"]["setSemanticColor"] = function(sSemanticColor) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setSemanticColor"]++; }; 
	this["sSemanticColor"] = sSemanticColor;
	this["setClientProperty"]("SemanticColor", this["sSemanticColor"], true);
	this["setClass"]();
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setSemanticColor"] = 0; };

/**
 * Gets the semantic color of the current text view
 *
 * @public
 * @return {string} the sSemanticColor
 */
UCF_TextView["prototype"]["getSemanticColor"] = function() {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["getSemanticColor"]++; }; 
	return this["sSemanticColor"];
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["getSemanticColor"] = 0; };

/**
 * Sets the semantc background color of the current text view
 * Not all combination with semanticColor are supported.
 * @public
 * @param {string} sSemanticBgColor
 */
UCF_TextView["prototype"]["setSemanticBgColor"] = function(sSemanticBgColor) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setSemanticBgColor"]++; }; 
	this["sSemanticBgColor"] = sSemanticBgColor;
	this["setClientProperty"]("SemanticBgColor", this["sSemanticBgColor"], true);
	this["setClass"]();
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setSemanticBgColor"] = 0; };

/**
 * Gets the semantic background color of the current text view
 *
 * @public
 * @return {string} the sSemanticBgColor
 */
UCF_TextView["prototype"]["getSemanticBgColor"] = function() {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["getSemanticBgColor"]++; }; 
	return this["sSemanticBgColor"];
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["getSemanticBgColor"] = 0; };

/**
 * Set the CSS classes according to the different states
 * @private
 */
// eslint-disable-next-line complexity
UCF_TextView["prototype"]["setClass"] = function() {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setClass"]++; }; 

	var sOldClass = UCF_DomUtil["sGetClass"](this["oDomRef"]),
		sNewClass = "",
		arrayClasses = sOldClass["split"](' ');
	sNewClass = arrayClasses[0];
	for (var i = 1; i < arrayClasses["length"] - 1; i++) {
		sNewClass += (" " + arrayClasses[i]);
	}
	//
	if (this["sSemanticColor"] === "INHERIT" || this["sSemanticColor"] === "DEFAULT") {
		// Returns the font color for the according design

		switch (this["sDesign"]) {
			case "HEADER1":
				sNewClass += " urH1Color";
				break;

			case "HEADER2":
				sNewClass += " urH1Color";
				break;

			case "HEADER3":
				sNewClass += " urH1Color";
				break;

			case "HEADER4":
				sNewClass += " urH1Color";
				break;

			default:
				sNewClass += " urTxtColor";
		}

		if (!this["bEnabled"]) sNewClass += "Dsbl";
	}

	switch (this["sSemanticColor"]) {
		case "DIMINISHED":
			sNewClass += " urTxtDim";
			break;

		case "POSITIVE":
			sNewClass += " urTxtPos";
			break;

		case "CRITICAL":
			sNewClass += " urTxtCrit";
			break;

		case "NEGATIVE":
			sNewClass += " urTxtNeg";
			break;

		case "MARKED1":
			sNewClass += " urTxtM1";
			break;

		case "MARKED2":
			sNewClass += " urTxtM2";
			break;

		case "LISTHEADING":
			sNewClass += " urTxtLH";
			break;

		case "LISTHEADINGINTENSIV":
			sNewClass += " urTxtLHI";
			break;

		case "LISTNORMAL":
			sNewClass += " urTxtLN";
			break;

		case "LISTNORMALINTENSIV":
			sNewClass += " urTxtLNI";
			break;

		case "LISTTOTAL":
			sNewClass += " urTxtLT";
			break;

		case "LISTTOTALINTENSIV":
			sNewClass += " urTxtLTI";
			break;

		case "LISTKEY":
			sNewClass += " urTxtLK";
			break;

		case "LISTKEYINTENSIV":
			sNewClass += " urTxtLKI";
			break;

		case "LISTPOSITIVE":
			sNewClass += " urTxtLP";
			break;

		case "LISTPOSITIVEINTENSIV":
			sNewClass += " urTxtLPI";
			break;

		case "LISTNEGATIVE":
			sNewClass += " urTxtLNeg";
			break;

		case "LISTNEGATIVEINTENSIV":
			sNewClass += " urTxtLNegI";
			break;

		case "LISTGROUP":
			sNewClass += " urTxtLGr";
			break;

		case "LISTGROUPINTENSIV":
			sNewClass += " urTxtLGrI";
			break;
	}

	//Returns the styles that render the different semantic background colors
	switch (this["sSemanticBgColor"]) {
		case "DIMINISHED":
			sNewClass += " urTxtDim";
			break;

		case "POSITIVE":
			sNewClass += " urTxtPos";
			break;

		case "CRITICAL":
			sNewClass += " urTxtCrit";
			break;

		case "NEGATIVE":
			sNewClass += " urTxtNeg";
			break;

		case "MARKED1":
			sNewClass += " urTxtM1";
			break;

		case "MARKED2":
			sNewClass += " urTxtM2";
			break;

		case "LISTHEADING":
			sNewClass += " urTxtLHBg";
			break;

		case "LISTHEADINGINTENSIV":
			sNewClass += " urTxtLHIBg";
			break;

		case "LISTNORMAL":
			sNewClass += " urTxtLNBg";
			break;

		case "LISTNORMALINTENSIV":
			sNewClass += " urTxtLNIBg";
			break;

		case "LISTTOTAL":
			sNewClass += " urTxtLTBg";
			break;

		case "LISTTOTALINTENSIV":
			sNewClass += " urTxtLTIBg";
			break;

		case "LISTKEY":
			sNewClass += " urTxtLKBg";
			break;

		case "LISTKEYINTENSIV":
			sNewClass += " urTxtLKIBg";
			break;

		case "LISTPOSITIVE":
			sNewClass += " urTxtLPBg";
			break;

		case "LISTPOSITIVEINTENSIV":
			sNewClass += " urTxtLPIBg";
			break;

		case "LISTNEGATIVE":
			sNewClass += " urTxtLNegBg";
			break;

		case "LISTNEGATIVEINTENSIV":
			sNewClass += " urTxtLNegIBg";
			break;

		case "LISTGROUP":
			sNewClass += " urTxtLGrBg";
			break;

		case "LISTGROUPINTENSIV":
			sNewClass += " urTxtLGrIBg";
			break;
	}
	//_trace(INFO, "========== new Class TV-" + this.sId + " - " + sNewClass );
	UCF_DomUtil["setClass"](this["oDomRef"], sNewClass);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setClass"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 * @return {UCF_HTMLElement}
 */
UCF_TextView["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["oGetInplaceEditDomRef"]++; }; 
	return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["oGetInplaceEditDomRef"] = 0; };

/**
 *  Sets the text typed in InplaceEdit field
 * @param { string } sText - the text typed
 * @return {string} - the text for inplaceedit
 * @see UCF_Control.sGetInplaceEditText
 */
UCF_TextView["prototype"]["sGetInplaceEditText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["sGetInplaceEditText"]++; }; 
	return this["getClientProperty"]("Text") || this["sText"];
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["sGetInplaceEditText"] = 0; };

/**
 * @see UCF_Control.setInplaceEditDomRef
 * @param {string} sText - the text typed
 */
UCF_TextView["prototype"]["setInplaceEditText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setInplaceEditText"]++; }; 
	this["sText"] = sText;
	this["setClientProperty"]("Text", sText);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setInplaceEditText"] = 0; };

/**
 * Sets the screen reader text for the text view
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_TextView["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TextView.js(790): onlsaccessibility"); };

	var oControl = oBrowserEvent["oGetSourceControl"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		sText = this["sGetInnerText"](oControl["oDomRef"]),
		sSemantic = "";

	if (oControl["bRequired"]) sText["replace"]("*", "");

	if (UCF_StringUtil["bIsEmpty"](sText)) oAccessibilityHelper["setEmpty"](true);
	else if (sText !== this["sTooltip"])
		oAccessibilityHelper["setText"](sText);

	switch (oControl["sSemanticColor"]) {
		case "DIMINISHED":
			//sSemantic = "DISABLED"; //ACC decided not to announce a dimished state see speech output spec.
			break;
		case "POSITIVE":
			sSemantic = "POSITIVE";
			break;
		case "CRITICAL":
			sSemantic = "CRITICALVALUE";
			break;
		case "NEGATIVE":
			sSemantic = "NEGATIVE";
			break;
		case "MARKED1":
			sSemantic = "MARKED";
			break;
		case "MARKED2":
			sSemantic = "MARKED";
			break;

	}
	if (sSemantic !== "")
		oAccessibilityHelper["addSemantic"](sSemantic);

	sSemantic = "";
	switch (this["sDesign"]) {
		case "EMPHASIZED":
			sSemantic = "EMPHASIZED";
			break;
		case "HEADER1":
			sSemantic = "H1";
			break;
		case "HEADER2":
			sSemantic = "H2";
			break;
		case "HEADER3":
			sSemantic = "H3";
			break;
		case "HEADER4":
			sSemantic = "H4";
			break;
	}
	if (sSemantic !== "")
		oAccessibilityHelper["addSemantic"](sSemantic);

	if (sSemantic !== "DIMINISHED")
		oAccessibilityHelper["setEnabled"](this["bEnabled"]);

	//Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this);
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

	oAccessibilityHelper["setRequired"](this["bRequired"]);
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["onlsaccessibility"] = 0; };

UCF_TextView["prototype"]["sGetInnerText"] = function(oReferenceDomRef) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["sGetInnerText"]++; }; 

	//TODO: replace by UCF_DomUtil
	// The TextView should have always the text as first child
	var oChildNode = oReferenceDomRef["firstChild"],
		sInnerText = '';
	if (this["sLayout"] !== 'NATIVE' && oChildNode && oChildNode["nodeType"] === 3) {
		sInnerText = oChildNode["data"];
	} else {
		sInnerText = UCF_DomUtil["sGetInnerText"](oReferenceDomRef);
	}

	return sInnerText;
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["sGetInnerText"] = 0; };

/**
 * @see UCF_Control
 * @override
 */
UCF_TextView["prototype"]["setHighlightTextByIndex"] = function(iStart, iLength, sAccDescription, sTextProperty, bFocused) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setHighlightTextByIndex"]++; }; 

	UCF_Control.prototype["setHighlightTextByIndex"]["call"](this, iStart, iLength, sAccDescription, sTextProperty, bFocused);

};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setHighlightTextByIndex"] = 0; };

/**
 * @return { UCF_Control_TouchContextMenuEntry[] }
 * @private
 */
UCF_TextView["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	var oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-ovfl');
	if (UCF_DomUtil["bHasTextEllipsis"](this["oDomRef"], oTextDomRef)) {
		var oGetTextDomRef = oTextDomRef ? oTextDomRef : this["oDomRef"];
		aResult["push"]({
			"sType": 'TEXT',
			"sText": UCF_DomUtil["removeColon"](UCF_DomUtil["sGetInnerText"](oGetTextDomRef))
		});
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["aGetTouchContextMenuEntries"] = 0; };

/**
 * @override
 * @see {UCF_Control}
 * @private
 */
UCF_TextView["prototype"]["colorizeHighlightedText"] = function(iStart, iLength, sTextProperty, bFocused) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["colorizeHighlightedText"]++; }; 
	if (bFocused) {
		if (this["oDomRef"] && !UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsHighlightTextFocus')) {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsHighlightTextFocus');
		}
	} else {
		if (this["oDomRef"] && !UCF_DomUtil["bHasClass"](this["oDomRef"], 'lsHighlightText')) {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsHighlightText');
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["colorizeHighlightedText"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_TextView["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;
	/** @type {Node} */
	var oParent;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			this["oDomRef"]["setAttribute"]('role', 'gridcell');
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
			oParent = this["oDomRef"]["parentNode"];
			UCF_Control["addAriaGeneric"](oParent, oSapTableInfo);
			if (this["oDomRef"]["getAttribute"]("aria-labelledby"))
				oParent["setAttribute"]("aria-labelledby", this["oDomRef"]["getAttribute"]("aria-labelledby"));
			oParent["setAttribute"]('role', 'presentation');
		}
	}
	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["bPrepareAria"] = 0; };

UCF_TextView["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["destroy"]++; }; 

	this["sText"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sTooltip"] = null;
	this["sAlign"] = null;
	this["sSemanticBgColor"] = null;
	this["sSemanticColor"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sDesign"] = null;
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sAriaRole"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TextView["prototype"]["aAttributeNames"] = ["sTooltip","bRequired","bEnabled","sDesign","sLayout","sSemanticColor","sSemanticBgColor","bIsNested","sAlign","sVisibility","bTextOverflow","bTabstop","bUsedInSapTable","bPreserveWhitespace","sCustomData","sCustomStyle","iHeadingLevel","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TextView["prototype"]["aEventNames"] = ["Activate","DoubleClick"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TextView["prototype"]["aMethodNames"] = ["setText","getText","setSemanticColor","getSemanticColor","setSemanticBgColor","getSemanticBgColor","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_TextView["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_TextView["prototype"]["bRequired"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_TextView["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TextViewDesign}
 */
UCF_TextView["prototype"]["sDesign"] = "STANDARD";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TextViewLayout}
 */
UCF_TextView["prototype"]["sLayout"] = "NATIVE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TextViewSemanticColor}
 */
UCF_TextView["prototype"]["sSemanticColor"] = "DEFAULT";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TextViewSemanticColor}
 */
UCF_TextView["prototype"]["sSemanticBgColor"] = "DEFAULT";

/**
 * @private
 * @type {boolean}
 */
UCF_TextView["prototype"]["bIsNested"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HorizontalAlign}
 */
UCF_TextView["prototype"]["sAlign"] = "LEFT";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_TextView["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_TextView["prototype"]["bTextOverflow"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_TextView["prototype"]["bTabstop"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_TextView["prototype"]["bUsedInSapTable"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_TextView["prototype"]["bPreserveWhitespace"] = false;

/**
 * @private
 * @type {string}
 */
UCF_TextView["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TextView["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {number}
 */
UCF_TextView["prototype"]["iHeadingLevel"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_TextView["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_TextView["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["bRequired"] = false;
	this["bEnabled"] = true;
	this["sDesign"] = "STANDARD";
	this["sLayout"] = "NATIVE";
	this["sSemanticColor"] = "DEFAULT";
	this["sSemanticBgColor"] = "DEFAULT";
	this["bIsNested"] = false;
	this["sAlign"] = "LEFT";
	this["sVisibility"] = "VISIBLE";
	this["bTextOverflow"] = false;
	this["bTabstop"] = false;
	this["bUsedInSapTable"] = false;
	this["bPreserveWhitespace"] = false;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["iHeadingLevel"] = 0;
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Required", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Design", "STANDARD", true);
		this["setClientProperty"]("Layout", "NATIVE", true);
		this["setClientProperty"]("SemanticColor", "DEFAULT", true);
		this["setClientProperty"]("SemanticBgColor", "DEFAULT", true);
		this["setClientProperty"]("IsNested", false, true);
		this["setClientProperty"]("Align", "LEFT", true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("TextOverflow", false, true);
		this["setClientProperty"]("Tabstop", false, true);
		this["setClientProperty"]("UsedInSapTable", false, true);
		this["setClientProperty"]("PreserveWhitespace", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the TextView control.
 * @fires TextView::Activate
 */
UCF_TextView["prototype"]["fireActivate"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["fireActivate"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "TextView.js(1145): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TextView.js(1146): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TextView.js(1147): fireActivate"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("TextView", "Activate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["fireActivate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the TextView control.
 * @fires TextView::DoubleClick
 */
UCF_TextView["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_TextView["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "TextView.js(1164): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TextView.js(1165): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TextView.js(1166): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("TextView", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TextView["_"]["fireDoubleClick"] = 0; };

UCF_TextView.prototype["aPublicMethods"] = ["setText","setTooltip","setAlign","setDesign","getText","setSemanticColor","getSemanticColor","setSemanticBgColor","getSemanticBgColor"].concat(UCF_TextView.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ThresholdPoint"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ThresholdPoint(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ThresholdPoint["_"]["UCF_ThresholdPoint"]++; }; 
	if (arguments["length"] === 0) return;
	
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ThresholdPoint.js(19): UCF_ThresholdPoint"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ThresholdPoint.js(20): UCF_ThresholdPoint"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ThresholdPoint.js(21): UCF_ThresholdPoint"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_ThresholdPoint"] = UCF_ThresholdPoint; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ThresholdPoint"); UCF_ThresholdPoint["_"] = {UCF_ThresholdPoint: 0}; }; ;
UCF_ThresholdPoint["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ThresholdPoint.prototype["sClassName"] = "UCF_ThresholdPoint";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ThresholdPoint["prototype"]["aAttributeNames"] = ["bShowAsMarker","iPosition","sSemantic","sTooltip","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ThresholdPoint["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ThresholdPoint["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {boolean}
 */
UCF_ThresholdPoint["prototype"]["bShowAsMarker"] = false;

/**
 * @private
 * @type {number}
 */
UCF_ThresholdPoint["prototype"]["iPosition"] = 0;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.SapTableCellDesign}
 */
UCF_ThresholdPoint["prototype"]["sSemantic"] = "GOODVALUE_DARK";

/**
 * @private
 * @type {string}
 */
UCF_ThresholdPoint["prototype"]["sTooltip"] = 'threshold tooltip';

/**
 * @private
 * @type {string}
 */
UCF_ThresholdPoint["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ThresholdPoint["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdPoint["_"]["setDefaultValues"]++; }; 
	this["bShowAsMarker"] = false;
	this["iPosition"] = 0;
	this["sSemantic"] = "GOODVALUE_DARK";
	this["sTooltip"] = 'threshold tooltip';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("ShowAsMarker", false, true);
		this["setClientProperty"]("Position", 0, true);
		this["setClientProperty"]("Semantic", "GOODVALUE_DARK", true);
		this["setClientProperty"]("Tooltip", 'threshold tooltip', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdPoint["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ThresholdPoint_dynamic"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ThresholdPoint */
/// <reference path="./ThresholdPoint.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ThresholdPoint_dynamic(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ThresholdPoint_dynamic["_"]["UCF_ThresholdPoint_dynamic"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ThresholdPoint_dynamic.js(19): UCF_ThresholdPoint_dynamic"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ThresholdPoint_dynamic.js(20): UCF_ThresholdPoint_dynamic"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ThresholdPoint_dynamic.js(21): UCF_ThresholdPoint_dynamic"); };

	UCF_ThresholdPoint["apply"](this, [oDomRef, oLS]);
};window["UCF_ThresholdPoint_dynamic"] = UCF_ThresholdPoint_dynamic; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ThresholdPoint_dynamic"); UCF_ThresholdPoint_dynamic["_"] = {UCF_ThresholdPoint_dynamic: 0}; }; ;
UCF_ThresholdPoint_dynamic["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ThresholdPoint"))(); UCF_ThresholdPoint_dynamic.prototype["sClassName"] = "UCF_ThresholdPoint_dynamic";

};
sap["ls"]["preload"]["UCF_ThresholdPoint_static"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ThresholdPoint */
/// <reference path="./ThresholdPoint.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ThresholdPoint_static(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ThresholdPoint_static["_"]["UCF_ThresholdPoint_static"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ThresholdPoint_static.js(19): UCF_ThresholdPoint_static"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ThresholdPoint_static.js(20): UCF_ThresholdPoint_static"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ThresholdPoint_static.js(21): UCF_ThresholdPoint_static"); };

	UCF_ThresholdPoint["apply"](this, [oDomRef, oLS]);
};window["UCF_ThresholdPoint_static"] = UCF_ThresholdPoint_static; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ThresholdPoint_static"); UCF_ThresholdPoint_static["_"] = {UCF_ThresholdPoint_static: 0}; }; ;
UCF_ThresholdPoint_static["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ThresholdPoint"))(); UCF_ThresholdPoint_static.prototype["sClassName"] = "UCF_ThresholdPoint_static";

};
sap["ls"]["preload"]["UCF_ThresholdSlider"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * ThresholdSlider Control
 * @class
 * @param {HTMLElement} oDomRef The DOM reference
 * @param {UCF_LS} oLS The LS instance
 */
function UCF_ThresholdSlider(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ThresholdSlider["_"]["UCF_ThresholdSlider"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ThresholdSlider.js(18): UCF_ThresholdSlider"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ThresholdSlider.js(19): UCF_ThresholdSlider"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ThresholdSlider.js(20): UCF_ThresholdSlider"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_ThresholdSlider"] = UCF_ThresholdSlider; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ThresholdSlider"); UCF_ThresholdSlider["_"] = {UCF_ThresholdSlider: 0}; }; ;
UCF_ThresholdSlider["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ThresholdSlider.prototype["sClassName"] = "UCF_ThresholdSlider";

UCF_ThresholdSlider["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ThresholdSlider["prototype"]["aAttributeNames"] = ["sTooltip","bShowUnits","iTotalUnits","iSubUnitsPerUnit","iSubUnitWidth","iColoredBarSubUnits","bIsInteractive","sText","sVisibility","sCustomData","sLabelledBy","sSizingBehavior"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ThresholdSlider["prototype"]["aEventNames"] = ["Change","Activate"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ThresholdSlider["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ThresholdSlider["prototype"]["sTooltip"] = 'control tooltip';

/**
 * @private
 * @type {boolean}
 */
UCF_ThresholdSlider["prototype"]["bShowUnits"] = true;

/**
 * @private
 * @type {number}
 */
UCF_ThresholdSlider["prototype"]["iTotalUnits"] = 10;

/**
 * @private
 * @type {number}
 */
UCF_ThresholdSlider["prototype"]["iSubUnitsPerUnit"] = 1;

/**
 * @private
 * @type {number}
 */
UCF_ThresholdSlider["prototype"]["iSubUnitWidth"] = 10;

/**
 * @private
 * @type {number}
 */
UCF_ThresholdSlider["prototype"]["iColoredBarSubUnits"] = 5;

/**
 * @private
 * @type {boolean}
 */
UCF_ThresholdSlider["prototype"]["bIsInteractive"] = true;

/**
 * @private
 * @type {string}
 */
UCF_ThresholdSlider["prototype"]["sText"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ThresholdSlider["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ThresholdSlider["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ThresholdSlider["prototype"]["sLabelledBy"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ThresholdSliderSizing}
 */
UCF_ThresholdSlider["prototype"]["sSizingBehavior"] = "STATIC";

//#JSCOVER_EXCL_START
/** @protected */
UCF_ThresholdSlider["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = 'control tooltip';
	this["bShowUnits"] = true;
	this["iTotalUnits"] = 10;
	this["iSubUnitsPerUnit"] = 1;
	this["iSubUnitWidth"] = 10;
	this["iColoredBarSubUnits"] = 5;
	this["bIsInteractive"] = true;
	this["sText"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';
	this["sSizingBehavior"] = "STATIC";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", 'control tooltip', true);
		this["setClientProperty"]("ShowUnits", true, true);
		this["setClientProperty"]("TotalUnits", 10, true);
		this["setClientProperty"]("SubUnitsPerUnit", 1, true);
		this["setClientProperty"]("SubUnitWidth", 10, true);
		this["setClientProperty"]("ColoredBarSubUnits", 5, true);
		this["setClientProperty"]("IsInteractive", true, true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
		this["setClientProperty"]("SizingBehavior", "STATIC", true);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iColoredBarSubUnits 
 * @fires ThresholdSlider::Change
 */
UCF_ThresholdSlider["prototype"]["fireChange"] = function(sId, iColoredBarSubUnits) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider["_"]["fireChange"]++; }; 
	/** @type {{Id: string, ColoredBarSubUnits: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ThresholdSlider.js(166): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ThresholdSlider.js(167): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ThresholdSlider.js(168): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColoredBarSubUnits != null, "iColoredBarSubUnits != null", "ThresholdSlider.js(169): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColoredBarSubUnits) == "number", "typeof(iColoredBarSubUnits) == \"number\"", "ThresholdSlider.js(170): fireChange"); };
	mParams = {
		"Id": sId,
		"ColoredBarSubUnits": iColoredBarSubUnits
	};
	
	
	this["fireSemanticEvent"]("ThresholdSlider", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iColoredBarSubUnits 
 * @fires ThresholdSlider::Activate
 */
UCF_ThresholdSlider["prototype"]["fireActivate"] = function(sId, iColoredBarSubUnits) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider["_"]["fireActivate"]++; }; 
	/** @type {{Id: string, ColoredBarSubUnits: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ThresholdSlider.js(190): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ThresholdSlider.js(191): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ThresholdSlider.js(192): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iColoredBarSubUnits != null, "iColoredBarSubUnits != null", "ThresholdSlider.js(193): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iColoredBarSubUnits) == "number", "typeof(iColoredBarSubUnits) == \"number\"", "ThresholdSlider.js(194): fireActivate"); };
	mParams = {
		"Id": sId,
		"ColoredBarSubUnits": iColoredBarSubUnits
	};
	
	
	this["fireSemanticEvent"]("ThresholdSlider", "Activate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider["_"]["fireActivate"] = 0; };

};
sap["ls"]["preload"]["UCF_ThresholdSlider_dynamic"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_ThresholdSlider */
/// <reference path="./ThresholdSlider.js"/>
/* global UCF_ClassLoader */

/**
 * ThresholdSlider Control
 *
 * @class
 * @param {HTMLElement} oDomRef The DOM reference
 * @param {UCF_LS} oLS The LS instance
 */
function UCF_ThresholdSlider_dynamic(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["UCF_ThresholdSlider_dynamic"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ThresholdSlider_dynamic.js(38): UCF_ThresholdSlider_dynamic"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ThresholdSlider_dynamic.js(39): UCF_ThresholdSlider_dynamic"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ThresholdSlider_dynamic.js(40): UCF_ThresholdSlider_dynamic"); };

	UCF_ThresholdSlider["apply"](this, [oDomRef, oLS]);

	this["sTooltipText"] = null;

	if (this["iColoredBarSubUnits"] < 0) {
		this["iColoredBarSubUnits"] = 0;
		this["setClientProperty"]("ColoredBarSubUnits", this["iColoredBarSubUnits"], true);
	}

	// -- all data necessary for all types of changes
	this["oData"] = {
		"ALL_THRESHOLDS": null,
		"SELECTED_THRESHOLD": null,
		"ESCAPED": null,
		"SELECTED_SUBUNIT_INDEX": null,
		"ACCESSED_SUBUNIT_INDEX": null,
		"ALL_SUBUNITS": null,
		"ACCESSTYPE": 'NONE',
		"DIRECTION": null,
		"LAST_MOUSE_POSITION": null,
		"SUBUNITS_BEFORE_KEYCHANGE": null,
		"NAVIGATION_CONTROLED_BY": 'NONE',
		"FOCUS_TYPE": 'FOCUS_TYPE'
	};
	this["oData"]["SUBUNITS_BEFORE_KEYCHANGE"] = this["iColoredBarSubUnits"];
	// -- create the ucf control threashold point
	this["createThresholds"]();

	// -- create "private" legend for semantic colors
	if (window["UCF_System"]["bIs508"]) {
		this["mLegend"] = {};
		this["mLegend"]["BADVALUE_DARK"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "BADVALUE");
		this["mLegend"]["BADVALUE_LIGHT"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "BADVALUE");
		this["mLegend"]["CRITICALVALUE_DARK"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "BADVALUE");
		this["mLegend"]["SELECTED5"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "CRITICALVALUE");
		this["mLegend"]["SECONDARY_SELECTED"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "CRITICALVALUE");
		this["mLegend"]["TOTAL"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "CRITICALVALUE");
		this["mLegend"]["SUBTOTAL_LIGHT"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "CRITICALVALUE");
		this["mLegend"]["GOODVALUE_MEDIUM"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "GOODVALUE");
		this["mLegend"]["SELECTED3"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "GOODVALUE");
		this["mLegend"]["GOODVALUE_DARK"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "GOODVALUE");

	}

	// -- create internal property usedInSapTable because Api lacks it
	this["bUsedInSapTable"] = UCF_JsUtil["bInstanceOf"](this["oGetParent"](), "UCF_SapTable") || UCF_JsUtil["bInstanceOf"](this["oGetParent"](), "UCF_SapTableCS");

	if (this["bUsedInSapTable"]) {
		this["oData"]["NAVIGATION_CONTROLED_BY"] = this["E_NAVIGATOR"]["SAP_TABLE"];
	} else {
		this["oData"]["NAVIGATION_CONTROLED_BY"] = this["E_NAVIGATOR"]["THRESHOLD_SLIDER"];
	}
};window["UCF_ThresholdSlider_dynamic"] = UCF_ThresholdSlider_dynamic; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ThresholdSlider_dynamic"); UCF_ThresholdSlider_dynamic["_"] = {UCF_ThresholdSlider_dynamic: 0}; }; ;
UCF_ThresholdSlider_dynamic["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ThresholdSlider"))(); UCF_ThresholdSlider_dynamic.prototype["sClassName"] = "UCF_ThresholdSlider_dynamic";

/**
 * Crreates an array with threshold point controls
 */
UCF_ThresholdSlider_dynamic["prototype"]["createThresholds"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["createThresholds"]++; }; 
	/** @type {Array} the thresholdpoints as html elements*/
	var aDomRef;
	/** @type {UCF_Control}*/
	var oThreshold;
	/** @type {int}*/
	var i;
	/** @type {int}*/
	var ii = 0;
	/** @type {Object}*/
	var oData;

	aDomRef = UCF_DomUtil["childNodes"](this["oDomRef"]);
	oData = this["oData"];
	oData["ALL_THRESHOLDS"] = [];

	for (i = 0; i < aDomRef["length"]; i++) {
		if (!aDomRef[i]["firstChild"]
			|| aDomRef[i]["firstChild"]["nodeType"] === 3) continue;
		oThreshold = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomRef[i]["firstChild"], true);
		if (!oThreshold) continue;
		oThreshold["iIndex"] = ii;
		oData["ALL_THRESHOLDS"]["push"](oThreshold);
		ii++;
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["createThresholds"] = 0; };

/**
 * determines whehter or not the control has any thresholds
 * @return {boolean}
 */
UCF_ThresholdSlider_dynamic["prototype"]["bThresholdsAvailable"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["bThresholdsAvailable"]++; }; 
	return this["oData"]["ALL_THRESHOLDS"] !== null && this["oData"]["ALL_THRESHOLDS"]["length"] > 0;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["bThresholdsAvailable"] = 0; };

UCF_ThresholdSlider_dynamic["prototype"]["E_FOCUS_TYPE"] = {
	"NAVIGATION": 'NAVIGATION',
	"REFOCUSED": 'REFOCUSED'
};

/**
 * Enumeration that indicates how users change the selection state
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["E_ACCESSTYPE"] = {
	"CLICK": 'CLICK',
	"KEYBOARD": 'KEYBOARD',
	"DRAG": 'DRAG',
	"TOUCH": 'TOUCH',
	"NONE": 'NONE'
};

/**
 * Enumeration that indicates how users change the selection state
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["E_SOURCE_TYPE"] = {
	"ROOT": 'root',
	"UNIT": 'unit',
	"POINT": 'point'
};

/**
 * Enumeration that indicates in which the control is being switched
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["E_DIRECTION"] = {
	"UP": 'UP',
	"DOWN": 'DOWN',
	"NONE": 'NONE'
};

/**
 * Enumeration that indicates in which the control is being switched
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["E_NAVIGATOR"] = {
	"THRESHOLD_SLIDER": 'THRESHOLD_SLIDER',
	"SAP_TABLE": 'SAP_TABLE',
	"F2_MODE": 'F2_MODE',
	"NONE": 'NONE'
};

/**
 * @return {enum-value} sSourceType
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["sGetSourceType"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["sGetSourceType"]++; }; 
	var sSourceType;
	var oSource;
	oSource = oBrowserEvent["oSource"];
	sSourceType = oSource["getAttribute"]('tp');
	return sSourceType;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["sGetSourceType"] = 0; };

/**
 * fill the data object with all neccessary data
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["collectData"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["collectData"]++; }; 
	/** @type {int}*/
	var iAccessedSubUnitIndex;
	/** @type {HTML_Element}*/
	var oSource;
	/** @type {int}*/
	var i;
	/** @type {Nodelist}*/
	var oNodeList;
	/** @type {Array}*/
	var aAllSubUnits;
	/** @type {Object}*/
	var oData;

	oSource = oBrowserEvent["oGetSource"]();
	iAccessedSubUnitIndex = parseInt(oSource["getAttribute"]('index'));
	oNodeList = this["oDomRef"]["childNodes"];
	aAllSubUnits = [];
	oData = this["oData"];

	/**
	 * @return {Array}
	 * an array with all subunits minus the text node
	 */
	function oGetAllSubUnits() {
		for (i = 0; i <= oNodeList["length"] - 1; i++) {
			if (!oNodeList[i]
				|| (oNodeList[i]["firstChild"]
					&& oNodeList[i]["firstChild"]["nodeType"] === 3))
				continue;
			aAllSubUnits["push"](oNodeList[i]);
		}
		return aAllSubUnits;
	}

	oData["ESCAPED"] = false;

	// -- get mouse position for drag and drop
	oData["LAST_MOUSE_POSITION"] = oBrowserEvent["_iClientX"];

	// -- collect all necessary indices
	oData["ACCESSED_SUBUNIT_INDEX"] = iAccessedSubUnitIndex;
	oData["SELECTED_SUBUNIT_INDEX"] = this["iColoredBarSubUnits"];

	// -- collect all subunits the control consists of
	if (!oData["ALL_SUBUNITS"])
		oData["ALL_SUBUNITS"] = oGetAllSubUnits();

	// -- find who is in chanrge of navigation
	if (oData["NAVIGATION_CONTROLED_BY"] === this["E_NAVIGATOR"]["NONE"]) {
		if (this["bUsedInSapTable"]) {
			oData["NAVIGATION_CONTROLED_BY"] = this["E_NAVIGATOR"]["SAP_TABLE"];
		} else {
			oData["NAVIGATION_CONTROLED_BY"] = this["E_NAVIGATOR"]["THRESHOLD_SLIDER"];
		}
	}

	// -- find the threshold the semantic of which is currently used
	oData["SELECTED_THRESHOLD"] = this["oGetSelectedThreshold"]();
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["collectData"] = 0; };

/**
 * update the data object with all neccessary data
 * @param { UCF_ThresholdPoint_dynamic } oSelected
 * @param { int } iIndexToMoveTo
 * @param { enum-value } sDirection
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["updateData"] = function(oSelected, iIndexToMoveTo, sDirection) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["updateData"]++; }; 
	this["oData"]["DIRECTION"] = sDirection;
	this["oData"]["SELECTED_THRESHOLD"] = oSelected;

	if (this["oData"]["ACCESSTYPE"] !== this["E_ACCESSTYPE"]["KEYBOARD"])
		this["oData"]["SUBUNITS_BEFORE_KEYCHANGE"] = iIndexToMoveTo;

	this["iColoredBarSubUnits"] = iIndexToMoveTo;
	this["setClientProperty"]("ColoredBarSubUnits", iIndexToMoveTo, true);
	if (window["UCF_System"]["bIsAria"]) {
		this["oDomRef"]["setAttribute"]('aria-valuenow', this["iColoredBarSubUnits"]);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["updateData"] = 0; };

/**
 * @private
 * clean data fields
 */
UCF_ThresholdSlider_dynamic["prototype"]["purgeData"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["purgeData"]++; }; 
	this["oData"]["ESCAPED"] = null;
	this["oData"]["ACCESSED_SUBUNIT_INDEX"] = null;
	this["oData"]["DIRECTION"] = null;
	this["oData"]["NAVIGATION_CONTROLED_BY"] = 'NONE';
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["purgeData"] = 0; };

/**
 * Achtung:
 * Als erstes Selected bestimmen
 * Als zweites iIndexToMoveTo
 * Dann oAccessed
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @return { UCF_ThresholdPoint_dynamic }
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["oGetAccesedThreshold"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["oGetAccesedThreshold"]++; }; 
	/** @type {Object} */
	var oData;
	/** @type {Array} */
	var aThresholds;
	/** @type {UCF_ThresholdPoint_dynamic} */
	var oSelectedThreshold;
	/** @type {UCF_ThresholdPoint_dynamic} */
	var oAccessedThreshold;
	/** @type {int} */
	var iSelectedThreshold;
	/** @type {int} */
	var iAccessedUnitIndex;
	/** @type {enum-value} */
	var _DIRECTION;
	/** @type {UCF_ThresholdSlider_dynamic} */
	var self;
	/** @type {int} */
	var i;
	/** @type {int} */
	var iIndexToMoveTo;

	/**
	 * @return {int}
	 * @private
	 * determines index to be used as selected unit
	 */
	function getSelectedIndex() {
		if (oSelectedThreshold === null) {
			return 0;
		} else {
			return oSelectedThreshold["iPosition"];
		}
	}

	// -- assign values
	oData = this["oData"];
	aThresholds = oData["ALL_THRESHOLDS"];
	oSelectedThreshold = oData["SELECTED_THRESHOLD"];
	self = this;
	oAccessedThreshold = null;
	iSelectedThreshold = getSelectedIndex();

	// -- determine the direction - UP or DOWN- in which a change occurs depentant
	// -- on the ACCESSTYPE - CLICK or DRAG
	switch (oData["ACCESSTYPE"]) {
		case this["E_ACCESSTYPE"]["CLICK"]:
			iAccessedUnitIndex = parseInt(oBrowserEvent["oSource"]["getAttribute"]('index'));
			_DIRECTION = this["sGetSwitchDirection"](oBrowserEvent);
			iIndexToMoveTo = this["iGetIndexToMoveTo"](iAccessedUnitIndex, iSelectedThreshold, _DIRECTION);
			break;
		case this["E_ACCESSTYPE"]["DRAG"]:
		case this["E_ACCESSTYPE"]["KEYBOARD"]:
			_DIRECTION = oData["DIRECTION"];
			iIndexToMoveTo = oData["INDEX_TO_MOVE_TO"];
	}

	/**
	 * @return {int}
	 * @private
	 */
	function bAccessThreshold() {

		if (iSelectedThreshold === iIndexToMoveTo
			&& _DIRECTION === self["E_DIRECTION"]["UP"]) {
			return false;
		}

		if (iIndexToMoveTo === iSelectedThreshold + 1
			&& _DIRECTION === self["E_DIRECTION"]["DOWN"]) {
			return false;
		}
		return true;
	}

	if (bAccessThreshold()) {
		if (this["iColoredBarSubUnits"] > 0
			&& iIndexToMoveTo === this["iColoredBarSubUnits"]
			&& _DIRECTION === this["E_DIRECTION"]["DOWN"]) {
			oAccessedThreshold = aThresholds[oData["SELECTED_THRESHOLD"]["iIndex"] - 1];

		} else if (iIndexToMoveTo < this["iColoredBarSubUnits"]) {
			// -- click bellow selected unit
			// -- selected threshold is bellow or on selected unit
			// -- a new threshold will only be determined it click was bellow selected
			for (i = aThresholds["length"] - 1; i >= 0; i--) {
				if (iIndexToMoveTo >= aThresholds[i]["iPosition"]) {
					oAccessedThreshold = aThresholds[i];
					break;
				}
			}

		} else if (iIndexToMoveTo > this["iColoredBarSubUnits"]) {

			for (i = aThresholds["length"] - 1; i >= 0; i--) {
				if (iIndexToMoveTo >= aThresholds[i]["iPosition"]) {
					oAccessedThreshold = aThresholds[i];
					break;
				}
			}
		} else {
			oAccessedThreshold = oData["SELECTED_THRESHOLD"];
		}
	} else {
		oAccessedThreshold = oData["SELECTED_THRESHOLD"];
	}
	oData["ACCESSED_THRESHOLD"] = oAccessedThreshold;
	return oAccessedThreshold;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["oGetAccesedThreshold"] = 0; };

/**
 * @return {UCF_ThresholdPoint_dynamic}
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["oGetSelectedThreshold"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["oGetSelectedThreshold"]++; }; 
	/** @type {Array} */
	var aThresholds;
	/** @type {UCF_ThresholdPoint_dynamic} */
	var oSelectedThreshold;
	/** @type {Object} */
	var oData;
	/** @type {int} */
	var i;

	// -- assign values
	oData = this["oData"];
	aThresholds = oData["ALL_THRESHOLDS"];
	self = this;
	oSelectedThreshold = null;

	/**
	 * @return {bool}
	 * @private
	 * determines whether the there is a colored bar
	 */
	function hasSelectedThreshold() {
		return self["iColoredBarSubUnits"] > 0;
	}

	// -- determine selected
	if (oData["SELECTED_THRESHOLD"] === null) {
		if (hasSelectedThreshold()) {
			for (i = aThresholds["length"] - 1; i >= 0; i--) {
				if (aThresholds[i]["iPosition"] <= this["iColoredBarSubUnits"]) {
					oSelectedThreshold = aThresholds[i];
					break;
				}
			}
		}
	} else {
		oSelectedThreshold = oData["SELECTED_THRESHOLD"];
	}
	return oSelectedThreshold ? oSelectedThreshold : null;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["oGetSelectedThreshold"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {enum-value}
 * on the basis of a threshold which is half the size of the clicked html element
 * this function determines whether or not a subunit is to be switched to
 * a different color
 */
// eslint-disable-next-line consistent-return
UCF_ThresholdSlider_dynamic["prototype"]["sGetSwitchDirection"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["sGetSwitchDirection"]++; }; 
	/** @type {HTML_Element} */
	var oAccessedUnit;
	/** @type {Object} */
	var oUnitRect;
	/** @type {int} */
	var iMousePosNow;

	iMousePosNow = oBrowserEvent["_iClientX"];
	oAccessedUnit = oBrowserEvent["oSource"];
	oUnitRect = UCF_DomUtil["oGetObjectRect"](oAccessedUnit);

	// -- click within bounderies
	if (iMousePosNow >= oUnitRect["left"]
		&& iMousePosNow <= oUnitRect["left"] + oUnitRect["width"]) {

		if (Math["floor"](oUnitRect["left"] + (oUnitRect["width"] / 2)) < iMousePosNow) {
			return this["E_DIRECTION"]["UP"];
		} else {
			return this["E_DIRECTION"]["DOWN"];
		}
	} else {
		// -- special handling for click
		// -- if click has a 1px distance to the unit, i.e.,
		// -- oUnitRect.left = 128 and iMousePosNow = 127
		// -- the source is still identifined as oUnitRect
		// -- although click did not occur there
		if (this["oData"]["ACCESSTYPE"] === this["E_ACCESSTYPE"]["CLICK"]) {
			if (iMousePosNow < oUnitRect["left"]) {
				return this["E_DIRECTION"]["DOWN"];
			} else if (iMousePosNow > Math["floor"](oUnitRect["left"] + (oUnitRect["width"] / 2))) {
				return this["E_DIRECTION"]["UP"];
			}
		} else {
			return this["E_DIRECTION"]["NONE"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["sGetSwitchDirection"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @return {enum-value}
 * Returns the direction in which the colored bar is beeing draged
 */
UCF_ThresholdSlider_dynamic["prototype"]["sGetDragDirection"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["sGetDragDirection"]++; }; 

	if (this["oData"]["LAST_MOUSE_POSITION"] < oBrowserEvent["_iClientX"]) {
		if (window["UCF_System"]["bIsRTL"]) {
			return this["E_DIRECTION"]["DOWN"];
		} else {
			return this["E_DIRECTION"]["UP"];
		}
	} else if (this["oData"]["LAST_MOUSE_POSITION"] > oBrowserEvent["_iClientX"]) {
		if (window["UCF_System"]["bIsRTL"]) {
			return this["E_DIRECTION"]["UP"];
		} else {
			return this["E_DIRECTION"]["DOWN"];
		}
	} else {
		return this["E_DIRECTION"]["NONE"];
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["sGetDragDirection"] = 0; };

/**
 * @private
 * @param { int } iAccessedUnit
 * @param { int } iSelectedUnit
 * @param { enum-value } sSwitchDirection
 * @return {int}
 */
UCF_ThresholdSlider_dynamic["prototype"]["iGetIndexToMoveTo"] = function(iAccessedUnit, iSelectedUnit, sSwitchDirection) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["iGetIndexToMoveTo"]++; }; 

	var E_DIRECTION = this["E_DIRECTION"];
	var iIndexToMoveTo;

	// -- selected threshold clicked above center ==> stay
	if (iAccessedUnit === iSelectedUnit
		&& sSwitchDirection === E_DIRECTION["UP"]) {
		iIndexToMoveTo = iAccessedUnit;
	}
	// -- selected threshold clicked bellow center ==> decrease
	if (iAccessedUnit === iSelectedUnit
		&& sSwitchDirection === E_DIRECTION["DOWN"]) {
		iIndexToMoveTo = iAccessedUnit - 1;
	}
	// -- a threshold after the selected clicked above center ==> increase to clicked
	if (iAccessedUnit > iSelectedUnit
		&& sSwitchDirection === E_DIRECTION["UP"]) {
		iIndexToMoveTo = iAccessedUnit;
	}
	// -- a threshold after the selected clicked bellow center ==> increade to one before clicked
	if (iAccessedUnit > iSelectedUnit
		&& sSwitchDirection === E_DIRECTION["DOWN"]) {
		iIndexToMoveTo = iAccessedUnit - 1;
	}
	// -- a threshold before the selected clicked above center ==> decrease to accessed
	if (iAccessedUnit < iSelectedUnit
		&& sSwitchDirection === E_DIRECTION["UP"]) {
		iIndexToMoveTo = iAccessedUnit;
	}
	// -- a threshold before the selected clicked bellow center ==> decrease
	if (iAccessedUnit < iSelectedUnit
		&& sSwitchDirection === E_DIRECTION["DOWN"]) {
		iIndexToMoveTo = iAccessedUnit - 1;
	}
	return iIndexToMoveTo;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["iGetIndexToMoveTo"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onclick"]++; }; 

	if (this["sGetSourceType"](oBrowserEvent) === this["E_SOURCE_TYPE"]["UNIT"]
		&& this["bThresholdsAvailable"]()
		&& this["bIsInteractive"]
		&& (this["oData"]["ACCESSTYPE"] === this["E_ACCESSTYPE"]["NONE"]
			|| this["oData"]["ACCESSTYPE"] === this["E_ACCESSTYPE"]["CLICK"])) {

		this["collectData"](oBrowserEvent);
		this["oData"]["ACCESSTYPE"] = this["E_ACCESSTYPE"]["CLICK"];
		this["switchThresholdValues"](oBrowserEvent);
		this["purgeData"]();
		this["oData"]["ACCESSTYPE"] = this["E_ACCESSTYPE"]["NONE"];
		this["fireChange"](this["sId"], this["iColoredBarSubUnits"]);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onclick"] = 0; };

/**
 * changes the classes respectively
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["switchThresholdValues"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["switchThresholdValues"]++; }; 
	/** @type {Object} */
	var oData = this["oData"];
	/** @type {UCF_ThresholdPoint_dynamic} */
	var oAccessedThreshold;
	/** @type {int} */
	var iAccessedUnit;
	/** @type {int} */
	var iSelectedUnit;
	/** @type {int} */
	var iIndexToMoveTo;
	/** @type {enum-value} */
	var sSwitchDirection;

	oAccessedThreshold = this["oGetAccesedThreshold"](oBrowserEvent);
	iAccessedUnit = oData["ACCESSED_SUBUNIT_INDEX"];
	iSelectedUnit = this["iColoredBarSubUnits"];
	sSwitchDirection = this["sGetSwitchDirection"](oBrowserEvent);
	iIndexToMoveTo = this["iGetIndexToMoveTo"](iAccessedUnit, iSelectedUnit, sSwitchDirection);

	// _trace(ERROR, 'oBrowserEvent.oSource: ' + oBrowserEvent.oSource.outerHTML);
	// _trace(ERROR, 'iAccessedUnit: ' + iAccessedUnit);
	// _trace(ERROR, 'accesed unit: ' + oData.ALL_SUBUNITS[iAccessedUnit]);

	if (iIndexToMoveTo === iSelectedUnit
		|| sSwitchDirection === this["E_DIRECTION"]["NONE"]
		|| iIndexToMoveTo === undefined
		|| iIndexToMoveTo === 'undefined') return;

	// -- place the handle correctly
	this["switchHandleStyles"](iIndexToMoveTo, iSelectedUnit);

	// -- assign the correct semantic colour
	this["switchBarStyles"](iIndexToMoveTo, oAccessedThreshold["sSemantic"]);

	// -- update data
	this["updateData"](oAccessedThreshold, iIndexToMoveTo, sSwitchDirection);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["switchThresholdValues"] = 0; };

/**
 * @param { int } iAccessed
 * @param { int } iSelected
 */
UCF_ThresholdSlider_dynamic["prototype"]["switchHandleStyles"] = function(iAccessed, iSelected) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["switchHandleStyles"]++; }; 
	/** @type {HTMLElement} handle element of the accessed threshold */
	var oAccessedHandle;
	/** @type {HTMLElement} handle element of the selected threshold */
	var oSelectedHandle;
	/** @type {enumeratiom} */
	var eStyles;

	if (iAccessed === iSelected
		|| iAccessed === -1
		|| iSelected === -1) return;

	oAccessedHandle = this["oData"]["ALL_SUBUNITS"][iAccessed];
	oSelectedHandle = this["oData"]["ALL_SUBUNITS"][iSelected];
	eStyles = this["eStyles"];

	if (oAccessedHandle)
		UCF_DomUtil["addClass"](oAccessedHandle, eStyles["HANDLE"]);
	if (oSelectedHandle)
		UCF_DomUtil["removeClass"](oSelectedHandle, eStyles["HANDLE"]);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["switchHandleStyles"] = 0; };

/**
 * @param { int } iIndexToMoveTo
 * @param { enum-value } sSemantic
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["switchBarStyles"] = function(iIndexToMoveTo, sSemantic) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["switchBarStyles"]++; }; 
	/** @type {Array} */
	var aSubunits;
	/** @type {enumeratiom} */
	var eStyles;

	if (iIndexToMoveTo < 0) return;

	aSubunits = this["oData"]["ALL_SUBUNITS"];
	eStyles = this["eStyles"];

	UCF_JsUtil["forEach"](aSubunits, function(oSubunit) {
		if (iIndexToMoveTo === 0) {
			self["switchSematicColors"](oSubunit, eStyles["NO_SEMANTIC"], iIndexToMoveTo);
		}
		if (parseInt(oSubunit["getAttribute"]('index')) <= iIndexToMoveTo) {
			self["switchSematicColors"](oSubunit, eStyles[sSemantic], iIndexToMoveTo);
		}
		if ((parseInt(oSubunit["getAttribute"]('index')) > iIndexToMoveTo)) {
			self["switchSematicColors"](oSubunit, eStyles["NO_SEMANTIC"], iIndexToMoveTo);
		}
	});
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["switchBarStyles"] = 0; };

/**
 * @param { HTMLElement } oDomRef the DomRef where styles are to be changed
 * @param { enum-value } sSwitchTo style to remove
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["switchSematicColors"] = function(oDomRef, sSwitchTo) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["switchSematicColors"]++; }; 
	/** @type {enumeration} */
	var eStyles = this["eStyles"];
	/** @type {string} */
	var sSwitchFrom;
	/** @type {Object} */
	var oData = this["oData"];
	/** @type {int} */
	var iCurentIndex;

	iCurentIndex = parseInt(oDomRef["getAttribute"]('index'));

	if (oData["SELECTED_SUBUNIT_INDEX"] === 0) {
		sSwitchFrom = eStyles["NO_SEMANTIC"];
	} else if (iCurentIndex <= oData["SELECTED_SUBUNIT_INDEX"]) {
		sSwitchFrom = eStyles[oData["SELECTED_THRESHOLD"]["sSemantic"]];
	} else if (iCurentIndex > oData["SELECTED_SUBUNIT_INDEX"]) {
		sSwitchFrom = eStyles["NO_SEMANTIC"];
	}

	// if (UCF_System.bIs508
	// 	|| UCF_System.bIsAria) {

	// 	sSwitchFrom = 'ACC_' + sSwitchFrom;
	// 	sSwitchTo = 'ACC_' + sSwitchTo;
	// }

	UCF_DomUtil["replaceClass"](oDomRef, sSwitchFrom, sSwitchTo);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["switchSematicColors"] = 0; };

/**
 * a list with all relevant styles
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["eStyles"] = {
	"POINT_ZERO_UNIT": 'lsTSL__handle--zero',
	"HANDLE": 'lsTSL__handle',
	"NO_SEMANTIC": 'lsTSL__none',

	"UNIT": 'lsTSL__unit',
	"SUBUNIT": 'lsTSL__subUnit',
	"FIRST_SUBUNIT": 'lsTSL__firstSubunit',

	"BADVALUE_DARK": 'lsTSL_BADVALUE_DARK',
	"BADVALUE_LIGHT": 'lsTSL_BADVALUE_LIGHT',
	"CRITICALVALUE_DARK": 'lsTSL_CRITICALVALUE_DARK',
	"SELECTED5": 'lsTSL_SELECTED5',
	"SECONDARY_SELECTED": 'lsTSL_SECONDARY_SELECTED',
	"TOTAL": 'lsTSL_TOTAL',
	"SUBTOTAL_LIGHT": 'lsTSL_SUBTOTAL_LIGHT',
	"GOODVALUE_MEDIUM": 'lsTSL_GOODVALUE_MEDIUM',
	"SELECTED3": 'lsTSL_SELECTED3',
	"GOODVALUE_DARK": 'lsTSL_GOODVALUE_DARK',

	"ACC_BADVALUE_DARK": 'lsTSL--negative',
	"ACC_BADVALUE_LIGHT": 'lsTSL--negative',
	"ACC_CRITICALVALUE_DARK": 'lsTSL--negative',
	"ACC_SELECTED5": 'lsTSL--critical',
	"ACC_SECONDARY_SELECTED": 'lsTSL--critical',
	"ACC_TOTAL": 'lsTSL--critical',
	"ACC_SUBTOTAL_LIGHT": 'lsTSL--positive',
	"ACC_GOODVALUE_MEDIUM": 'lsTSL--positive',
	"ACC_SELECTED3": 'lsTSL--positive',
	"ACC_GOODVALUE_DARK": 'lsTSL--positive'
};

/*
###############################################################################
SECTION RESPONSIBLE FOR DRAG AND DROP
###############################################################################
*/

/**
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsdragstart"]++; }; 
	/** @type {string} */
	var sDrarId;

	if (this["oData"]["ACCESSTYPE"] !== this["E_ACCESSTYPE"]["NONE"]) return;

	sDrarId = oBrowserEvent["oSource"]["getAttribute"]('id');
	this["oData"]["ACCESSTYPE"] = this["E_ACCESSTYPE"]["DRAG"];
	this["collectData"](oBrowserEvent);
	oBrowserEvent["oDragAndDropManager"]["startDragSession"](sDrarId, "", UCF_DragSession["DRAG_TYPE"]["NONE"], null, null, null);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsdragstart"] = 0; };

/**
 * @param { UCF_BrowserEvent } oBrowserEvent
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["onlsdrag"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsdrag"]++; }; 

	/** @type {int} */
	var iIndexToMoveTo;
	/** @type {Object} */
	var oData = this["oData"];
	/** @type {UCF_ThresholdPoint_dynamic} */
	var oAccessedThreshold;
	/** @type {string} */
	// var sSwitchTo;
	/** @type {enum} */
	var eStyles;
	/** @type {enum} */
	var E_DIRECTION = this["E_DIRECTION"];
	/** @type {enum-value} */
	var sDirection;
	/** @type {HTML_Element} */
	var oAccessedUnit;
	/** @type {Object} */
	var oRootRect;
	/** @type {string} */
	var sSemantic;
	/** @type {Array} */
	var aSubunits;
	/** @type {HTML_Element} */
	var oSubunit;

	eStyles = this["eStyles"];
	oRootRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);
	sDirection = this["sGetDragDirection"](oBrowserEvent);

	// -- if drag direction changes update data
	if (oData["DIRECTION"]
		&& sDirection !== E_DIRECTION["NONE"]
		&& oData["DIRECTION"] !== E_DIRECTION["NONE"]
		&& oData["DIRECTION"] !== sDirection) {
		this["collectData"](oBrowserEvent);
		oData["DIRECTION"] = sDirection;
		oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["DRAG"];
	}

	/**
	 * @return {int}
	 * @private
	 *
	 */
	function iGetIndexToMoveTo() {
		switch (sDirection) {
			case E_DIRECTION["UP"]:
				return oData["SELECTED_SUBUNIT_INDEX"] + 1;
			case E_DIRECTION["DOWN"]:
				return oData["SELECTED_SUBUNIT_INDEX"] - 1;
			case E_DIRECTION["NONE"]:
				return oData["SELECTED_SUBUNIT_INDEX"];
			default:
				return -1;
		}
	}

	iIndexToMoveTo = iGetIndexToMoveTo();
	oData["INDEX_TO_MOVE_TO"] = iIndexToMoveTo;

	/**
	 * @return {HTML_Element}
	 * @private
	 */
	function oGetAccessedUnit() {
		switch (sDirection) {
			case E_DIRECTION["UP"]:
				return oData["ALL_SUBUNITS"][iIndexToMoveTo];
			case E_DIRECTION["DOWN"]:
				return oData["ALL_SUBUNITS"][iIndexToMoveTo + 1];
			case E_DIRECTION["NONE"]:
				return oData["ALL_SUBUNITS"][iIndexToMoveTo];
			default:
				return -1;
		}
	}

	oAccessedUnit = oGetAccessedUnit();

	/**
	 * @return {boolean}
	 * @private
	 * The switch point is the center of a subunit.
	 * The mouse has to pass that point before the subunit changes its colour
	 */
	function bSwitchPointPassed() {
		/** @type {Object} */
		var oAccesedRect;
		/** @type {int} */
		var iCursorPoint;
		/** @type {int} */
		var iRefercePoint;

		if (oAccessedUnit) {
			oAccesedRect = UCF_DomUtil["oGetObjectRect"](oAccessedUnit);
			iCursorPoint = oBrowserEvent["_iClientX"];
			iRefercePoint = Math["floor"](oAccesedRect["width"] / 2);
			iRefercePoint = oAccesedRect["left"] + iRefercePoint;

			switch (sDirection) {
				case E_DIRECTION["DOWN"]:
					return (iRefercePoint >= iCursorPoint) && (iCursorPoint >= oRootRect["left"]);
				case E_DIRECTION["UP"]:
					return (iRefercePoint <= iCursorPoint) && (iCursorPoint <= oRootRect["left"] + oRootRect["width"]);
				case E_DIRECTION["NONE"]:
					return false;
			}
		}
		return false;
	}
	/**
	 * @return {boolean}
	 * @private
	 */
	function bCursorWithinBounds() {
		switch (sDirection) {
			case E_DIRECTION["UP"]:
				return oBrowserEvent["_iClientX"] < oRootRect["width"] + oRootRect["left"];
			case E_DIRECTION["DOWN"]:
				return oBrowserEvent["_iClientX"] > oRootRect["left"];
			case E_DIRECTION["NONE"]:
				return false;
			default:
				return false;
		}
	}

	// -- switch styles respectively if
	// -- 1) the index is within the valid range
	// -- 2) the index is not identical with the currently selected
	// -- 3) the mouse is within the bounderies of the control
	// -- 4) the point set as switch point is passed
	if (iIndexToMoveTo >= 0
		&& iIndexToMoveTo !== oData["SELECTED_SUBUNIT_INDEX"]
		&& bCursorWithinBounds() === true
		&& bSwitchPointPassed() === true) {

		aSubunits = oData["ALL_SUBUNITS"];
		oSubunit = aSubunits[iIndexToMoveTo];

		// -- check if a threshold-point has been passed
		oAccessedThreshold = this["oGetAccesedThreshold"](oBrowserEvent);

		// -- assign repsective semantic
		sSemantic = (oAccessedThreshold) ? oAccessedThreshold["sSemantic"] : oData["SELECTED_THRESHOLD"]["sSemantic"];

		//-- put the handle icon to its respective position
		this["switchHandleStyles"](iIndexToMoveTo, oData["SELECTED_SUBUNIT_INDEX"]);

		// -- switch the styles of the units
		if (oAccessedThreshold === null) {
			this["switchSematicColors"](oSubunit, eStyles[oData["SELECTED_THRESHOLD"]["sSemantic"]], iIndexToMoveTo);
		} else {
			// -- assign the correct semantic colour
			this["switchBarStyles"](iIndexToMoveTo, sSemantic);
		}

		// -- update all data respectively
		oData["ACCESSED_SUBUNIT_INDEX"] = iIndexToMoveTo;
		oData["SELECTED_SUBUNIT_INDEX"] = iIndexToMoveTo;
		oData["SELECTED_THRESHOLD"] = oAccessedThreshold ? oAccessedThreshold : oData["SELECTED_THRESHOLD"];
		this["iColoredBarSubUnits"] = iIndexToMoveTo;
		this["setClientProperty"]("ColoredBarSubUnits", iIndexToMoveTo, true);
		if (window["UCF_System"]["bIsAria"]) {
			this["oDomRef"]["setAttribute"]('aria-valuenow', this["iColoredBarSubUnits"]);
		}
	}
	oData["DIRECTION"] = sDirection;
	oData["LAST_MOUSE_POSITION"] = oBrowserEvent["_iClientX"];
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsdrag"] = 0; };

UCF_ThresholdSlider_dynamic["prototype"]["onlsdragend"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsdragend"]++; }; 
	this["purgeData"]();
	this["oData"]["ACCESSTYPE"] = this["E_ACCESSTYPE"]["NONE"];
	this["fireChange"](this["sId"], this["iColoredBarSubUnits"]);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsdragend"] = 0; };

/**
 * Destructor
 */
UCF_ThresholdSlider_dynamic["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["destroy"]++; }; 
	this["oData"] = null;
	if (this["bUsedInSapTable"]) {
		this["bUsedInSapTable"] = null;
	}
	if (this["iColoredBarSubUnits"]) {
		this["iColoredBarSubUnits"] = null;
	}
	UCF_ThresholdSlider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["destroy"] = 0; };

// #####################################################
// SECTION RESPONSIBLE FOR KEYBOARD HANDLING
// #####################################################

/**
 * Handles the right arrow key
 *  @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 *  @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsright"]++; }; 
	/** @type {Object} */
	var oData;
	/** @type {int} */
	var iSelected;
	/** @type {int} */
	var iIndexToMoveTo;
	/** @type {int} */
	var iAllSubUnits;
	/** @type {int} */
	var i;
	/** @type {enum-value} */
	var sSemantic;
	/** @type {UCF_ThresholdPoint_dynamic} */
	var oAccessedThreshold;
	/** @type {enumeratiom} */
	var _DIR = this["E_DIRECTION"];
	/** @type {Array} */
	// var aSubunits;

	// -- collect data
	this["collectData"](oBrowserEvent);
	oData = this["oData"];

	if (oData["NAVIGATION_CONTROLED_BY"] === this["E_NAVIGATOR"]["SAP_TABLE"]) return;
	// --
	// aSubunits = oData.ALL_SUBUNITS;
	// --- update AccsessType
	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["KEYBOARD"];
	_DIR = this["E_DIRECTION"];
	// -- get the index to move to
	iIndexToMoveTo = this["iIndexToMoveToByKeyboard"](window["UCF_System"]["bIsRTL"] ? _DIR["DOWN"] : _DIR["UP"]);
	iAllSubUnits = oData["ALL_SUBUNITS"]["length"] - 1;
	iSelected = this["iColoredBarSubUnits"];
	// iIndexToMoveTo = (iSelected <= iAllSubUnits) ? iSelected + 1 : iSelected;

	// -- last subunit reached. don't don anything
	if (iIndexToMoveTo > iAllSubUnits && iSelected === iAllSubUnits) {
		oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["NONE"];
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}

	/**
	 * @return {UCF_ThresholdPoint_dynamic}
	 */
	function oGetNextThreshold() {
		var oThreshold;
		for (i = oData["ALL_THRESHOLDS"]["length"] - 1; i >= 0; i--) {
			if (oData["ALL_THRESHOLDS"][i]["iPosition"] <= iIndexToMoveTo) {
				oThreshold = oData["ALL_THRESHOLDS"][i];
				break;
			}
		}
		return oThreshold;
	}

	// -- find next threshold
	oAccessedThreshold = oGetNextThreshold();

	// -- assign repsective semantic
	sSemantic = (oAccessedThreshold) ? oAccessedThreshold["sSemantic"] : oData["SELECTED_THRESHOLD"]["sSemantic"];

	//-- put the handle icon to its respective position
	this["switchHandleStyles"](iIndexToMoveTo, oData["SELECTED_SUBUNIT_INDEX"]);

	// -- assign the correct semantic colour
	this["switchBarStyles"](iIndexToMoveTo, sSemantic);

	// -- update data
	this["updateData"](oAccessedThreshold, iIndexToMoveTo, this["E_DIRECTION"]["UP"]);
	oData["LAST_MOUSE_POSITION"] = null;
	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["NONE"];

	this["oData"]["FOCUS_TYPE"] = this["E_FOCUS_TYPE"]["REFOCUSED"];
	UCF_DomUtil["refocusDomElement"](this["oDomRef"]);

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsright"] = 0; };

/**
 * Handles the right arrow key
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsleft"]++; }; 
	/** @type {Object} */
	var oData;
	/** @type {int} */
	var iSelected;
	/** @type {int} */
	var iIndexToMoveTo;
	/** @type {int} */
	var i;
	/** @type {enum-value} */
	var sSemantic;
	/** @type {UCF_ThresholdPoint_dynamic} */
	var oAccessedThreshold;
	/** @type {enumeratiom} */
	var _DIR;

	// -- collect data
	this["collectData"](oBrowserEvent);
	oData = this["oData"];
	_DIR = this["E_DIRECTION"];

	if (oData["NAVIGATION_CONTROLED_BY"] === this["E_NAVIGATOR"]["SAP_TABLE"]) return;

	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["KEYBOARD"];

	// -- get the index to move to
	iIndexToMoveTo = this["iIndexToMoveToByKeyboard"](window["UCF_System"]["bIsRTL"] ? _DIR["UP"] : _DIR["DOWN"]);

	iSelected = this["iColoredBarSubUnits"];
	//iIndexToMoveTo = (iSelected >= 0) ? iSelected - 1 : iSelected;

	// -- first subunit reached. don't do anything
	if (iIndexToMoveTo < 0 && iSelected === 0) {
		oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["NONE"];
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}

	/**
	 * @return {UCF_ThresholdPoint_dynamic}
	 * @private
	 */
	function oGetPreviousThreshold() {
		var oThreshold;
		for (i = oData["ALL_THRESHOLDS"]["length"] - 1; i >= 0; i--) {
			if (oData["ALL_THRESHOLDS"][i]["iPosition"] <= iIndexToMoveTo) {
				oThreshold = oData["ALL_THRESHOLDS"][i];
				break;
			}
		}
		return oThreshold;
	}

	// -- find next threshold
	oAccessedThreshold = oGetPreviousThreshold();

	// -- assign repsective semantic
	sSemantic = (oAccessedThreshold) ? oAccessedThreshold["sSemantic"] : oData["SELECTED_THRESHOLD"]["sSemantic"];

	//-- put the handle icon to its respective position
	this["switchHandleStyles"](iIndexToMoveTo, oData["SELECTED_SUBUNIT_INDEX"]);

	// -- assign the correct semantic colour
	this["switchBarStyles"](iIndexToMoveTo, sSemantic);

	// -- update data
	this["updateData"](oAccessedThreshold, iIndexToMoveTo, this["E_DIRECTION"]["UP"]);
	oData["LAST_MOUSE_POSITION"] = null;
	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["NONE"];

	this["oData"]["FOCUS_TYPE"] = this["E_FOCUS_TYPE"]["REFOCUSED"];
	UCF_DomUtil["refocusDomElement"](this["oDomRef"]);

	// --
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsleft"] = 0; };

/**
 * Returns the correct index dependant on the reading direction.
 * @param {enum-value} _DIRECTION
 * @return {int}
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["iIndexToMoveToByKeyboard"] = function(_DIRECTION) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["iIndexToMoveToByKeyboard"]++; }; 
	/** @type {int} */
	var iIndexToMoveTo;
	/** @type {int} */
	var iSelected = this["iColoredBarSubUnits"];
	/** @type {int} */
	var iAllSubUnits = this["oData"]["ALL_SUBUNITS"]["length"] - 1;
	/** @type {enumeratiom} */
	var E_DIRECTION = this["E_DIRECTION"];

	if (_DIRECTION === E_DIRECTION["UP"]) {
		iIndexToMoveTo = (iSelected <= iAllSubUnits) ? iSelected + 1 : iSelected;
	} else if (_DIRECTION === E_DIRECTION["DOWN"]) {
		iIndexToMoveTo = (iSelected >= 0) ? iSelected - 1 : iSelected;
	}
	return iIndexToMoveTo;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["iIndexToMoveToByKeyboard"] = 0; };

/**
 * Hanldes the arrow down key
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsdown"]++; }; 
	this["onlsleft"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsdown"] = 0; };

/**
 * Handles the arrow left key
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsup"]++; }; 
	this["onlsright"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsup"] = 0; };

/**
 * Move the colored bar to the end
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsend"]++; }; 
	/** @type {UCF_ThresholdPoint_dynamic} */
	var oAccessedThreshold;
	/** @type {Object} */
	var oData;
	/** @type {Array} */
	var aThresholds;
	/** @type {int} */
	var iIndexToMoveTo;
	/** @type {enum-value} */
	var sSemantic;

	// -- collect data
	this["collectData"](oBrowserEvent);
	oData = this["oData"];

	if (oData["NAVIGATION_CONTROLED_BY"] === this["E_NAVIGATOR"]["SAP_TABLE"]) return;

	// --
	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["KEYBOARD"];
	aThresholds = oData["ALL_THRESHOLDS"];
	oAccessedThreshold = aThresholds[aThresholds["length"] - 1];
	iIndexToMoveTo = (window["UCF_System"]["bIsRTL"]) ? 0 : oData["ALL_SUBUNITS"]["length"] - 1;

	// -- get semantic
	sSemantic = (oAccessedThreshold) ? oAccessedThreshold["sSemantic"] : oData["SELECTED_THRESHOLD"]["sSemantic"];

	//-- put the handle icon to its respective position
	this["switchHandleStyles"](iIndexToMoveTo, oData["SELECTED_SUBUNIT_INDEX"]);

	// -- assign the correct semantic colour
	this["switchBarStyles"](iIndexToMoveTo, sSemantic);

	// -- update data
	this["updateData"](oAccessedThreshold, iIndexToMoveTo, this["E_DIRECTION"]["UP"]);
	oData["LAST_MOUSE_POSITION"] = null;
	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["NONE"];

	this["oData"]["FOCUS_TYPE"] = this["E_FOCUS_TYPE"]["REFOCUSED"];
	UCF_DomUtil["refocusDomElement"](this["oDomRef"]);

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsend"] = 0; };

/**
 * move the colored bar to the start
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlshome"]++; }; 
	/** @type {UCF_ThresholdPoint_dynamic} */
	var oAccessedThreshold;
	/** @type {Object} */
	var oData;
	/** @type {Array} */
	var aThresholds;
	/** @type {int} */
	var iIndexToMoveTo;
	/** @type {enum-value} */
	var sSemantic;

	this["collectData"](oBrowserEvent);
	oData = this["oData"];

	if (oData["NAVIGATION_CONTROLED_BY"] === this["E_NAVIGATOR"]["SAP_TABLE"]) return;

	// --
	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["KEYBOARD"];
	aThresholds = oData["ALL_THRESHOLDS"];
	oAccessedThreshold = aThresholds[0];
	iIndexToMoveTo = (window["UCF_System"]["bIsRTL"]) ? oData["ALL_SUBUNITS"]["length"] - 1 : 0;

	// -- get semantic
	sSemantic = (oAccessedThreshold) ? oAccessedThreshold["sSemantic"] : oData["SELECTED_THRESHOLD"]["sSemantic"];

	//-- put the handle icon to its respective position
	this["switchHandleStyles"](iIndexToMoveTo, oData["SELECTED_SUBUNIT_INDEX"]);

	// -- assign the correct semantic colour
	this["switchBarStyles"](iIndexToMoveTo, sSemantic);

	// -- update data
	this["updateData"](oAccessedThreshold, iIndexToMoveTo, this["E_DIRECTION"]["UP"]);
	oData["LAST_MOUSE_POSITION"] = null;
	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["NONE"];

	this["oData"]["FOCUS_TYPE"] = this["E_FOCUS_TYPE"]["REFOCUSED"];
	UCF_DomUtil["refocusDomElement"](this["oDomRef"]);

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlshome"] = 0; };

/**
 * The event is not fired upon keyboard changes.
 * The event is fired after changes have been made
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["onlsblur"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsblur"]++; }; 
	if (this["bFireChange"]()) {
		this["fireChange"](this["sId"], this["iColoredBarSubUnits"]);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsblur"] = 0; };

/**
 * The event is not fired upon keyboard changes.
 * The event is fired after changes have been made
 * @private
 * @return {boolean}
 */
UCF_ThresholdSlider_dynamic["prototype"]["bFireChange"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["bFireChange"]++; }; 
	/** @type {int} */
	var iInitSubUnits;

	if (!this["bIsInteractive"]
		|| this["oData"]["FOCUS_TYPE"] === this["E_FOCUS_TYPE"]["REFOCUSED"]) return false;

	iInitSubUnits = this["oData"]["SUBUNITS_BEFORE_KEYCHANGE"];

	if (iInitSubUnits !== this["iColoredBarSubUnits"]) {
		this["oData"]["SUBUNITS_BEFORE_KEYCHANGE"] = this["iColoredBarSubUnits"];
		return true;
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["bFireChange"] = 0; };

UCF_ThresholdSlider_dynamic["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onkeydown"]++; }; 
	/** @type {int} */
	var iKey;
	/** @type {Object} */
	var oData;
	/** @type {enumeration} */
	var NAVIGATOR_IS;

	if (oBrowserEvent["bAlt"]() || oBrowserEvent["bShift"]()) return;

	// -- assign values
	iKey = oBrowserEvent["iKeyCode"]();
	NAVIGATOR_IS = this["E_NAVIGATOR"];

	// collect data
	this["collectData"](oBrowserEvent);
	oData = this["oData"];

	if (iKey === UCF_KeyCodes["F2"]) {
		// -- switch on F2 mode if control is in SAP Table and SAP Table owns navigation
		if (oData["NAVIGATION_CONTROLED_BY"] === NAVIGATOR_IS["SAP_TABLE"]) {
			oData["NAVIGATION_CONTROLED_BY"] = NAVIGATOR_IS["F2_MODE"];
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
			return;

			// -- switch off F2 mode if control is in SAP Table and SAP Table owns navigation
		} else if (oData["NAVIGATION_CONTROLED_BY"] === NAVIGATOR_IS["F2_MODE"]) {
			oData["NAVIGATION_CONTROLED_BY"] = NAVIGATOR_IS["SAP_TABLE"];
		}

		// -- special handling with Ctrl key
	} else if (oBrowserEvent["bCtrl"]()
		&& (oData["NAVIGATION_CONTROLED_BY"] === NAVIGATOR_IS["THRESHOLD_SLIDER"]
			|| oData["NAVIGATION_CONTROLED_BY"] === NAVIGATOR_IS["F2_MODE"])) {

		// -- increament: Ctrl +
		if (iKey === UCF_KeyCodes["PLUS"]) {
			this["onlsnext"](oBrowserEvent);
			oBrowserEvent["cancel"]();

			// -- decrement: Ctrl -
		} else if (iKey === UCF_KeyCodes["MINUS"]) {
			this["onlsprevious"](oBrowserEvent);
			oBrowserEvent["cancel"]();

			// -- jump to next unit: Ctrl arrow-up
		} else if (iKey === UCF_KeyCodes["ARROW_UP"]
			|| iKey === UCF_KeyCodes["ARROW_RIGHT"]) {
			this["goToNextUnit"]();
			oBrowserEvent["cancel"]();

			// -- jump to previous unit: Ctrl arrow-down
		} else if (iKey === UCF_KeyCodes["ARROW_DOWN"]
			|| iKey === UCF_KeyCodes["ARROW_LEFT"]) {
			this["goToPreviousUnit"]();
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onkeydown"] = 0; };

UCF_ThresholdSlider_dynamic["prototype"]["goToNextUnit"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["goToNextUnit"]++; }; 
	/** @type {UCF_ThresholdPoint_dynamic} */
	var oAccessedThreshold;
	/** @type {Object} */
	var oData;
	/** @type {int} */
	var iIndexToMoveTo;
	/** @type {enum-value} */
	var sSemantic;
	/** @type {Array} */
	var aSubunits;
	/** @type {HTML_Element} */
	var oSelected;
	/** @type {int} */
	var iSelected;
	/** @type {int} */
	var i;

	// --
	oData = this["oData"];
	aSubunits = oData["ALL_SUBUNITS"];
	iSelected = this["iColoredBarSubUnits"];

	for (i = 0; i < aSubunits["length"]; i++) {
		if (i > iSelected
			&& aSubunits[i]["className"]["indexOf"](this["eStyles"]["UNIT"]) > -1) {
			oSelected = aSubunits[i];
			break;
		}
	}

	if (!oSelected) return;

	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["KEYBOARD"];
	iIndexToMoveTo = parseInt(oSelected["getAttribute"]('index'));
	oData["INDEX_TO_MOVE_TO"] = iIndexToMoveTo;
	oData["DIRECTION"] = this["E_DIRECTION"]["UP"];
	oAccessedThreshold = this["oGetAccesedThreshold"]();

	// -- get semantic
	sSemantic = (oAccessedThreshold) ? oAccessedThreshold["sSemantic"] : oData["SELECTED_THRESHOLD"]["sSemantic"];

	//-- put the handle icon to its respective position
	this["switchHandleStyles"](iIndexToMoveTo, oData["SELECTED_SUBUNIT_INDEX"]);

	// -- assign the correct semantic colour
	this["switchBarStyles"](iIndexToMoveTo, sSemantic);

	// -- update data
	this["updateData"](oAccessedThreshold, iIndexToMoveTo, this["E_DIRECTION"]["UP"]);
	oData["LAST_MOUSE_POSITION"] = null;
	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["NONE"];
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["goToNextUnit"] = 0; };

UCF_ThresholdSlider_dynamic["prototype"]["goToPreviousUnit"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["goToPreviousUnit"]++; }; 
	/** @type {UCF_ThresholdPoint_dynamic} */
	var oAccessedThreshold;
	/** @type {Object} */
	var oData;
	/** @type {int} */
	var iIndexToMoveTo;
	/** @type {enum-value} */
	var sSemantic;
	/** @type {Array} */
	var aSubunits;
	/** @type {HTML_Element} */
	var oSelected;
	/** @type {int} */
	var iSelected;
	/** @type {int} */
	var i;

	// --
	oData = this["oData"];
	aSubunits = oData["ALL_SUBUNITS"];
	iSelected = this["iColoredBarSubUnits"];

	for (i = aSubunits["length"] - 1; i >= 0; i--) {
		if (i < iSelected
			&& (aSubunits[i]["className"]["indexOf"](this["eStyles"]["UNIT"]) > -1
				|| aSubunits[i]["className"]["indexOf"](this["eStyles"]["FIRST_SUBUNIT"]) > -1)) {
			oSelected = aSubunits[i];
			break;
		}
	}

	if (!oSelected) return;

	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["KEYBOARD"];
	iIndexToMoveTo = parseInt(oSelected["getAttribute"]('index'));
	oData["INDEX_TO_MOVE_TO"] = iIndexToMoveTo;
	oData["DIRECTION"] = this["E_DIRECTION"]["DOWN"];
	oAccessedThreshold = this["oGetAccesedThreshold"]();

	if (iIndexToMoveTo < 0) return;

	// -- get semantic
	sSemantic = (oAccessedThreshold) ? oAccessedThreshold["sSemantic"] : oData["SELECTED_THRESHOLD"]["sSemantic"];

	//-- put the handle icon to its respective position
	this["switchHandleStyles"](iIndexToMoveTo, oData["SELECTED_SUBUNIT_INDEX"]);

	// -- assign the correct semantic colour
	this["switchBarStyles"](iIndexToMoveTo, sSemantic);

	// -- update data
	this["updateData"](oAccessedThreshold, iIndexToMoveTo, this["E_DIRECTION"]["UP"]);
	oData["LAST_MOUSE_POSITION"] = null;
	oData["ACCESSTYPE"] = this["E_ACCESSTYPE"]["NONE"];
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["goToPreviousUnit"] = 0; };

/* ############################################################################

	SECTION THAT HANDLES ACC

##############################################################################*/

/**
 *
 * @return {bool}
 */
UCF_ThresholdSlider_dynamic["prototype"]["bAccOn"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["bAccOn"]++; }; 
	return window["UCF_System"]["bIs508"]
		|| window["UCF_System"]["bIsAria"];
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["bAccOn"] = 0; };

/**
 * changes the styles according to the sThresholdType
 *
 * @param { UCF_Control } oThreshold
 */
UCF_ThresholdSlider_dynamic["prototype"]["setThresholdType"] = function(oThreshold) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["setThresholdType"]++; }; 

	if (oThreshold["sSemantic"] == null) return;

	//change class
	var sStyle = "lsTSL_" + oThreshold["sSemantic"] + " lsTSLsc_" + oThreshold["sSemantic"] + " lsTSLscBgImg lsTSLscBgImgH",
		oDomRef = this["oDomRef"]["getElementsByTagName"]("IMG")[0];
	oDomRef["className"] = sStyle;

	// Update the icon in belize_hcb/hcw
	var oText = UCF_DomUtil["$"](this["sId"] + "-text");
	if (oText) {
		var sIconSuffix = ""; //--negative";
		switch (oThreshold["sSemantic"]) {
			case "BADVALUE_DARK":
			case "BADVALUE_LIGHT":
			case "CRITICALVALUE_DARK":
				sIconSuffix = "--negative";
				break;
			case "SELECTED5":
			case "SECONDARY_SELECTED":
			case "TOTAL":
				sIconSuffix = "--critical";
				break;
			case "SUBTOTAL_LIGHT":
			case "GOODVALUE_MEDIUM":
			case "SELECTED3":
			case "GOODVALUE_DARK":
				sIconSuffix = "--positive";
				break;
		}
		// Note: These classes only exist in belize_hcb/hcw
		var CLASSNAME = "lsTSLhcbicon";
		var bFound = false;
		UCF_JsUtil["forEach"](["--positive", "--critical", "--negative"], function(s) {
			if (!bFound && UCF_DomUtil["bHasClass"](oText, CLASSNAME + s)) {
				UCF_DomUtil["replaceClass"](oText, CLASSNAME + s, CLASSNAME + sIconSuffix);
				bFound = true;
			}
		});
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["setThresholdType"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_ThresholdSlider_dynamic["prototype"]["sGetTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["sGetTooltip"]++; }; 
	/** @type {Object}*/
	var oData;
	/** @type {UCF_ThresholdPoint_dynamic}*/
	var oSelectedThreshold;
	/** @type {string}*/
	var sTooltip;

	oData = this["oData"];
	oSelectedThreshold = oData["SELECTED_THRESHOLD"];
	sTooltip = '';

	if (this["sText"] !== '')
		sTooltip = this["sText"];

	if (oSelectedThreshold !== null) {
		sTooltip += '- ';
		if (!this["bAccOn"]()) {
			sTooltip += this["mLegend"][oSelectedThreshold["sSemantic"]];
			sTooltip += ' - ';
		}
		sTooltip += oSelectedThreshold["sTooltip"];
	}

	return sTooltip;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["sGetTooltip"] = 0; };

/**
 * Sets the correct acc text
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ThresholdSlider_dynamic["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ThresholdSlider_dynamic.js(1606): onlsaccessibility"); };
	/** @type {Object}*/
	var oAccessibilityHelper;
	/** @type {UCF_ThresholdPoint_dynamic}*/
	var oSelectedThreshold;

	if (window["UCF_System"]["bIsAria"]) return;

	oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	oSelectedThreshold = this["oGetSelectedThreshold"]();

	// -- Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this);
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());
	oAccessibilityHelper["setControlType"]("SLIDER");
	oAccessibilityHelper["setItemCount"](this["iTotalUnits"] * this["iSubUnitsPerUnit"]);
	oAccessibilityHelper["setItemIndex"](this["iColoredBarSubUnits"]);
	oAccessibilityHelper["setLegend"](this["mLegend"]);
	oAccessibilityHelper["setText"](this["sText"]);

	if (oSelectedThreshold) {
		oAccessibilityHelper["setTooltip"](oSelectedThreshold["sTooltip"]);
		oAccessibilityHelper["addSemantic"](oSelectedThreshold["sSemantic"]);
	}
	if (this["bIsInteractive"]) {
		oAccessibilityHelper["addTutor"]("LRNAV_TUT");
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsaccessibility"] = 0; };

/**
 * Determine the current Aria mode
 */
UCF_ThresholdSlider_dynamic["prototype"]["updateAriaInfo"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["updateAriaInfo"]++; }; 
	var oSelectedThreshold = this["oGetSelectedThreshold"]();
	if (oSelectedThreshold) {
		//	UCF_AriaStateHelper.setAttribute(this.oDomRef, 'aria-valuetext', oSelectedThreshold.sTooltip);
		this["oDomRef"]["setAttribute"]('aria-valuetext', oSelectedThreshold["sTooltip"]);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["updateAriaInfo"] = 0; };

/**
 * Handles the onlsfocus event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ThresholdSlider_dynamic["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ThresholdSlider_dynamic.js(1653): onlsfocus"); };

	if (this["oData"]["FOCUS_TYPE"] === this["E_FOCUS_TYPE"]["REFOCUSED"]) {
		this["oData"]["FOCUS_TYPE"] = this["E_FOCUS_TYPE"]["NAVIGATION"];
		return;
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_dynamic["_"]["onlsfocus"] = 0; };

};
sap["ls"]["preload"]["UCF_ThresholdSlider_static"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_DragSession */
/// <reference path="./base/DragSession.js"/>
/* global UCF_ThresholdSlider */
/// <reference path="./ThresholdSlider.js"/>

/**
 * ThresholdSlider Control
 *
 * @class
 * @param {HTMLElement} oDomRef The DOM reference
 * @param {UCF_LS} oLS The LS instance
 */
function UCF_ThresholdSlider_static(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["UCF_ThresholdSlider_static"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ThresholdSlider_static.js(37): UCF_ThresholdSlider_static"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ThresholdSlider_static.js(38): UCF_ThresholdSlider_static"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ThresholdSlider_static.js(39): UCF_ThresholdSlider_static"); };

	UCF_ThresholdSlider["apply"](this, [oDomRef, oLS]);

	this["sTooltipText"] = null;

	if (!this["bIsInteractive"]) return;

	this["iTotalWidth"] = parseInt(this["oDomRef"]["getAttribute"]("iTotalwidth"));
	this["iTotalSubUnits"] = parseInt(this["oDomRef"]["getAttribute"]("iTotalsubunits"));
	this["iUnitWidth"] = parseInt(this["oDomRef"]["getAttribute"]("iUnitwidth"));
	this["iInitDisplay"] = parseInt(this["oDomRef"]["getAttribute"]("iColoredBarSubUnits"));
	this["iLastSubUnits"] = this["iInitDisplay"];

	if (this["iColoredBarSubUnits"] < 0) {
		this["iColoredBarSubUnits"] = 0;
		this["setClientProperty"]("ColoredBarSubUnits", this["iColoredBarSubUnits"], true);
	}

	this["bDragging"] = false;

	this["createThresholds"]();

	// Create "private" legend for semantic colors
	if (window["UCF_System"]["bIs508"]) {
		this["mLegend"] = {};
		this["mLegend"]["BADVALUE_DARK"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "BADVALUE");
		this["mLegend"]["BADVALUE_LIGHT"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "BADVALUE");
		this["mLegend"]["CRITICALVALUE_DARK"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "BADVALUE");
		this["mLegend"]["SELECTED5"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "CRITICALVALUE");
		this["mLegend"]["SECONDARY_SELECTED"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "CRITICALVALUE");
		this["mLegend"]["TOTAL"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "CRITICALVALUE");
		this["mLegend"]["SUBTOTAL_LIGHT"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "CRITICALVALUE");
		this["mLegend"]["GOODVALUE_MEDIUM"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "GOODVALUE");
		this["mLegend"]["SELECTED3"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "GOODVALUE");
		this["mLegend"]["GOODVALUE_DARK"] = UCF_KeyboardHelper["sGetText"](this["oLS"], "GOODVALUE");
	}

	this["bUsedInTable"] = UCF_JsUtil["bInstanceOf"](this["oGetParent"](), "UCF_SapTable") || UCF_JsUtil["bInstanceOf"](this["oGetParent"](), "UCF_SapTableCS");
	this["bTableNavigation"] = this["bUsedInTable"];
};window["UCF_ThresholdSlider_static"] = UCF_ThresholdSlider_static; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ThresholdSlider_static"); UCF_ThresholdSlider_static["_"] = {UCF_ThresholdSlider_static: 0}; }; ;
UCF_ThresholdSlider_static["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_ThresholdSlider"))(); UCF_ThresholdSlider_static.prototype["sClassName"] = "UCF_ThresholdSlider_static";

/**
 * apply hovereffekt to border of GSC and its slider
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_ThresholdSlider_static["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ThresholdSlider_static.js(88): onmouseover"); };

	if (!this["bIsInteractive"]) return;

	var oSlider = UCF_DomUtil["$"](this["sId"] + "-slider");

	if (oSlider != null)
		UCF_DomUtil["addClass"](oSlider, "lsTSLsliderHover");
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onmouseover"] = 0; };

/**
 * remove hovereffekt on border of GSC and its slider
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_ThresholdSlider_static["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ThresholdSlider_static.js(104): onmouseout"); };

	if (!this["bIsInteractive"]) return;

	var oSlider = UCF_DomUtil["$"](this["sId"] + "-slider");

	if (oSlider != null)
		UCF_DomUtil["removeClass"](oSlider, "lsTSLsliderHover");
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onmouseout"] = 0; };

UCF_ThresholdSlider_static["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onclick"]++; }; 
	var iMargin = 0;
	var oSource = oBrowserEvent["oSource"];

	if (!this["bThresholdsAvailable"]()
		|| oSource["getAttribute"]('ct') === 'THSL_static') return;

	this["bEscaped"] = false;

	if (this["oRect"] == null)
		this["oRect"] = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);

	//iClientX will not reflect the whole offset left, if there is an addional
	//scroll offset. This case is covered by the else case
	if (this["oRect"]["left"] < oBrowserEvent["iClientX"]()) {
		iMargin = oBrowserEvent["iClientX"]() - this["oRect"]["left"];
	} else {
		iMargin = (oBrowserEvent["iClientX"]() + UCF_DomUtil["oGetScrollOffset"]()["x"]) - this["oRect"]["left"];
	}

	if (window["UCF_System"]["bIsRTL"]) {
		iMargin = this["oDomRef"]["offsetWidth"] - iMargin + 10;
	}

	if (iMargin > this["iTotalWidth"]) {
		iMargin = this["iTotalWidth"];
	}

	var iSubUnits = this["calcSubUnits"](iMargin);

	if (!this["bIsInteractive"]) {
		this["fireActivate"](this["sId"], iSubUnits);
		return;
	}

	//avoid an additional Change event on mouse up after dragging has been finished
	if (this["bDragging"]) {
		return;
	}

	var oThreshold = this["getThreshold"](iSubUnits);

	if (oThreshold != null) {
		this["setThresholdType"](oThreshold);
		this["updateTooltip"](oThreshold);
	}

	if (iSubUnits != null) {
		this["setBarWidth"](iSubUnits);
		this["setSliderPosition"](iSubUnits);
	}
	this["iColoredBarSubUnits"] = iSubUnits;
	this["setClientProperty"]("ColoredBarSubUnits", this["iColoredBarSubUnits"], true);
	this["iInitDisplay"] = iSubUnits;
	if (window["UCF_System"]["bIsAria"]) {
		this["oDomRef"]["setAttribute"]('aria-valuenow', this["iColoredBarSubUnits"]);
	}
	this["fireChange"](this["sId"], iSubUnits);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onclick"] = 0; };

/**
 * Handles the right arrow key
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_ThresholdSlider_static["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsup"]++; }; 
	if (!this["bTableNavigation"]) {
		if (!window["UCF_System"]["bIsRTL"]) {
			this["incrementByKey"](1);
		} else {
			this["decrementByKey"](1);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsup"] = 0; };

/**
 * Handles the right arrow key
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_ThresholdSlider_static["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsprevious"]++; }; 
	if (!this["bTableNavigation"]) {
		if (!window["UCF_System"]["bIsRTL"]) {
			this["decrementByKey"](1);
		} else {
			this["incrementByKey"](1);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		if (window["UCF_System"]["bIsAria"]) {
			this["oDomRef"]["setAttribute"]('aria-valuenow', this["iColoredBarSubUnits"]);
		}
		this["fireChange"](this["sId"], this["iColoredBarSubUnits"]);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsprevious"] = 0; };

/**
 * Hanldes the arrow down key
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_ThresholdSlider_static["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsdown"]++; }; 
	if (!this["bTableNavigation"]) {
		if (!window["UCF_System"]["bIsRTL"]) {
			this["decrementByKey"](1);
		} else {
			this["incrementByKey"](1);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsdown"] = 0; };

/**
 * Handles the arrow left key
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ThresholdSlider_static["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsnext"]++; }; 
	if (!this["bTableNavigation"]) {
		if (!window["UCF_System"]["bIsRTL"]) {
			this["incrementByKey"](1);
		} else {
			this["decrementByKey"](1);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		if (window["UCF_System"]["bIsAria"]) {
			this["oDomRef"]["setAttribute"]('aria-valuenow', this["iColoredBarSubUnits"]);
		}
		this["fireChange"](this["sId"], this["iColoredBarSubUnits"]);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsnext"] = 0; };

UCF_ThresholdSlider_static["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsright"]++; }; 
	this["onlsnext"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsright"] = 0; };

UCF_ThresholdSlider_static["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsleft"]++; }; 
	this["onlsprevious"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsleft"] = 0; };

UCF_ThresholdSlider_static["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onkeydown"]++; }; 

	if (oBrowserEvent["bAlt"]() || oBrowserEvent["bShift"]()) return;

	var iKey = oBrowserEvent["iKeyCode"]();
	var iDiff;
	if (iKey === UCF_KeyCodes["F2"] && this["bUsedInTable"]) {
		this["bTableNavigation"] = !this["bTableNavigation"]; //toggle table navigation
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}
	if (this["bTableNavigation"]) return;

	//increment/decrement by units
	if (oBrowserEvent["bCtrl"]()) {

		if (iKey === UCF_KeyCodes["ARROW_UP"] || iKey === UCF_KeyCodes["ARROW_RIGHT"]) {
			iDiff = (this["iDiffToNextUntit"]() > 0) ? this["iDiffToNextUntit"]() : this["iSubUnitsPerUnit"];
			this["incrementByKey"](iDiff);
		} else if (iKey === UCF_KeyCodes["ARROW_DOWN"] || iKey === UCF_KeyCodes["ARROW_LEFT"]) {
			iDiff = (this["iDiffToPrevUntit"]() > 0) ? this["iDiffToPrevUntit"]() : this["iSubUnitsPerUnit"];
			this["decrementByKey"](iDiff);
		}
	}

	// inrement/decrement by subunits
	if (!oBrowserEvent["bCtrl"]()) {

		if (iKey === UCF_KeyCodes["PLUS"]) {
			this["incrementByKey"](1);
			oBrowserEvent["cancel"]();
		} else if (iKey === UCF_KeyCodes["MINUS"]) {
			this["decrementByKey"](1);
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onkeydown"] = 0; };

/**
 * Move the colored bar to the end
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ThresholdSlider_static["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsend"]++; }; 
	var oThreshold = this["aThresholds"][this["aThresholds"]["length"] - 1];

	this["setSliderPosition"](this["iTotalSubUnits"]);
	this["setBarWidth"](this["iTotalSubUnits"]);
	this["setThresholdType"](oThreshold);
	this["updateTooltip"](oThreshold);
	this["refocus"](this["oDomRef"]);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsend"] = 0; };

/**
 * move the colored bar to the start
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ThresholdSlider_static["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlshome"]++; }; 
	var oThreshold = this["aThresholds"][0];

	this["setSliderPosition"](0);
	this["setBarWidth"](0);
	this["setThresholdType"](oThreshold);
	this["updateTooltip"](oThreshold);
	this["refocus"](this["oDomRef"]);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlshome"] = 0; };

/**
 * Calculates the difference between colored bar and next unit.
 * Returns the value in subunits
 * @return { int }
 */
UCF_ThresholdSlider_static["prototype"]["iDiffToNextUntit"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["iDiffToNextUntit"]++; }; 
	var iDiff = this["iTotalSubUnits"] - this["iColoredBarSubUnits"];
	iDiff = iDiff % this["iSubUnitsPerUnit"];
	return iDiff;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["iDiffToNextUntit"] = 0; };

/**
 * Calculates the difference between colored bar and previous unit.
 * Returns the value in subunits
 * @return {int}
 */
UCF_ThresholdSlider_static["prototype"]["iDiffToPrevUntit"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["iDiffToPrevUntit"]++; }; 
	var iDiff = this["iColoredBarSubUnits"] % this["iSubUnitsPerUnit"];
	return iDiff;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["iDiffToPrevUntit"] = 0; };
/* *
 * Sets the position of the grip and the with of the bars while increasing it by one subunit
 */
UCF_ThresholdSlider_static["prototype"]["incrementByKey"] = function(iDiff) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["incrementByKey"]++; }; 

	if (this["iColoredBarSubUnits"] < this["iTotalSubUnits"]) {
		this["setSliderPosition"](this["iColoredBarSubUnits"] + iDiff);
		this["setBarWidth"](this["iColoredBarSubUnits"] + iDiff);

		//get the tooltip of the current threshold
		var oThreshold = this["getThreshold"](this["iColoredBarSubUnits"]);
		if (oThreshold != null) {
			this["setThresholdType"](oThreshold);
			this["updateTooltip"](oThreshold);

			//refocus if user action has finished
			if (this["sTimeOutId"] != null) {
				UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
			}
			this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, "refocus");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["incrementByKey"] = 0; };

/**
 * Sets the position of the grip and the with of the bars
 * while decreasing it by one subunit
 * @param {int} iDiff
 */
UCF_ThresholdSlider_static["prototype"]["decrementByKey"] = function(iDiff) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["decrementByKey"]++; }; 

	if (this["iColoredBarSubUnits"] > 0) {
		this["setSliderPosition"](this["iColoredBarSubUnits"] - iDiff);
		this["setBarWidth"](this["iColoredBarSubUnits"] - iDiff);

		//get the tooltip of the current threshold
		var oThreshold = this["getThreshold"](this["iColoredBarSubUnits"]);
		if (oThreshold != null) {
			this["setThresholdType"](oThreshold);
			this["updateTooltip"](oThreshold);

			//refocus if user action has finished
			if (this["sTimeOutId"] != null) {
				UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
			}
			this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, "refocus");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["decrementByKey"] = 0; };

/**
 * Handles the shift tab key
 */
UCF_ThresholdSlider_static["prototype"]["onlstabprevious"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlstabprevious"]++; }; 
	if (!this["bIsInteractive"]) return;

	if (this["bFireChange"]()) {
		this["fireChange"](this["sId"], this["iColoredBarSubUnits"]);
		this["iInitDisplay"] = this["iColoredBarSubUnits"];
	}

};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlstabprevious"] = 0; };

/**
 * Handles the tab key
 */
UCF_ThresholdSlider_static["prototype"]["onlstabnext"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlstabnext"]++; }; 
	if (!this["bIsInteractive"]) return;

	if (this["bFireChange"]()) {
		this["fireChange"](this["sId"], this["iColoredBarSubUnits"]);
		this["iInitDisplay"] = this["iColoredBarSubUnits"];
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlstabnext"] = 0; };

/**
 * checks whether a change event has to be fired
 * @return {boolean}
 */
UCF_ThresholdSlider_static["prototype"]["bFireChange"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["bFireChange"]++; }; 

	if (this["iLastSubUnits"] !== this["iColoredBarSubUnits"]) {
		this["iLastSubUnits"] = this["iColoredBarSubUnits"];
		return true;
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["bFireChange"] = 0; };

UCF_ThresholdSlider_static["prototype"]["calcSubUnits"] = function(iMargin) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["calcSubUnits"]++; }; 
	iMargin /= this["iSubUnitWidth"];
	return iMargin = Math["round"](iMargin);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["calcSubUnits"] = 0; };

/**
 * Crreates an array with threshold point controls
 */
UCF_ThresholdSlider_static["prototype"]["createThresholds"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["createThresholds"]++; }; 

	if (!this["bThresholdsAvailable"]()) return;

	var aDomRef = UCF_DomUtil["$"](this["sId"] + "-thold")["childNodes"];

	this["aThresholds"] = [];

	for (var i = 0; i < aDomRef["length"]; i++) {
		var oThreshold = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomRef[i], true);

		if (oThreshold == null) continue;

		this["aThresholds"]["push"](oThreshold);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["createThresholds"] = 0; };

UCF_ThresholdSlider_static["prototype"]["bThresholdsAvailable"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["bThresholdsAvailable"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + "-thold") != null;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["bThresholdsAvailable"] = 0; };

/**
 * find out to which thresholds the bar has been dragged
 *
 * @param {int} iBarPosition the amount of rated units
 * @return {UCF_ThresholdPoint}
 */
UCF_ThresholdSlider_static["prototype"]["getThreshold"] = function(iBarPosition) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["getThreshold"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iBarPosition) === "number", "typeof(iBarPosition) === \"number\"", "ThresholdSlider_static.js(467): getThreshold"); };

	if (iBarPosition < this["aThresholds"][0]["iPosition"] ||
		(iBarPosition > this["aThresholds"][0]["iPosition"] && this["aThresholds"]["length"] > 1 && iBarPosition < this["aThresholds"][1]["iPosition"])) {
		return this["aThresholds"][0];
	}

	if (iBarPosition >= this["aThresholds"][this["aThresholds"]["length"] - 1]["iPosition"]) {
		return this["aThresholds"][this["aThresholds"]["length"] - 1];
	}

	for (var i = 0; i < this["aThresholds"]["length"]; i++) {

		if (iBarPosition === this["aThresholds"][i]["iPosition"] ||
			(i > 0 && i < this["aThresholds"]["length"] - 1 &&
				iBarPosition > this["aThresholds"][i - 1]["iPosition"] &&
				iBarPosition < this["aThresholds"][i + 1]["iPosition"])) {
			return this["aThresholds"][i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["getThreshold"] = 0; };

/**
 * changes the styles according to the sThresholdType
 *
 * @param { UCF_ThresholdPoint } oThreshold
 * the defined threshold type of the current threshold point
 */
UCF_ThresholdSlider_static["prototype"]["setThresholdType"] = function(oThreshold) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["setThresholdType"]++; }; 

	if (oThreshold["sSemantic"] == null) return;

	//change class
	var sStyle = "lsTSL_" + oThreshold["sSemantic"] + " lsTSLsc_" + oThreshold["sSemantic"] + " lsTSLscBgImg lsTSLscBgImgH",
		oDomRef = this["oDomRef"]["getElementsByTagName"]("IMG")[0];
	oDomRef["className"] = sStyle;

	// Update the icon in belize_hcb/hcw
	var oText = UCF_DomUtil["$"](this["sId"] + "-text");
	if (oText) {
		var sIconSuffix = ""; //--negative";
		switch (oThreshold["sSemantic"]) {
			case "BADVALUE_DARK":
			case "BADVALUE_LIGHT":
			case "CRITICALVALUE_DARK":
				sIconSuffix = "--negative";
				break;
			case "SELECTED5":
			case "SECONDARY_SELECTED":
			case "TOTAL":
				sIconSuffix = "--critical";
				break;
			case "SUBTOTAL_LIGHT":
			case "GOODVALUE_MEDIUM":
			case "SELECTED3":
			case "GOODVALUE_DARK":
				sIconSuffix = "--positive";
				break;
		}
		// Note: These classes only exist in belize_hcb/hcw
		var CLASSNAME = "lsTSLhcbicon";
		var bFound = false;
		UCF_JsUtil["forEach"](["--positive", "--critical", "--negative"], function(s) {
			if (!bFound && UCF_DomUtil["bHasClass"](oText, CLASSNAME + s)) {
				UCF_DomUtil["replaceClass"](oText, CLASSNAME + s, CLASSNAME + sIconSuffix);
				bFound = true;
			}
		});
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["setThresholdType"] = 0; };

/**
 * adjusts the width of the bars according to the current rating
 *
 * @param {int} iSubUnits amount of rated units.
 */
UCF_ThresholdSlider_static["prototype"]["setBarWidth"] = function(iSubUnits) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["setBarWidth"]++; }; 

	if (!this["bIsInteractive"]) return;

	//avoid negative values that can be calculated because the container is 1px
	if (iSubUnits >= this["iTotalSubUnits"])
		iSubUnits = this["iTotalSubUnits"];

	var iColoredWidth = iSubUnits * this["iSubUnitWidth"],
		iGrayedoutWidth = this["iTotalWidth"] - iColoredWidth,
		aImages = this["oDomRef"]["getElementsByTagName"]("IMG");

	//subrtact one pixel to consider the border on one side the bars.
	if (iColoredWidth > 0 && iColoredWidth <= this["iTotalWidth"]) iColoredWidth -= 1;
	if (iGrayedoutWidth > 0 && iGrayedoutWidth <= this["iTotalWidth"]) iGrayedoutWidth -= 1;

	//switch off the bar that has 0 pixels and add a border to the visible bar
	//i.e.: vica versa

	if (iColoredWidth === 0) {
		aImages[0]["style"]["display"] = "none";
		aImages[1]["style"]["display"] = "inline";
	} else if (iGrayedoutWidth === 0) {
		aImages[0]["style"]["borderWidth"] = "1px 1px 1px 1px";
		aImages[0]["style"]["display"] = "inline";
		aImages[1]["style"]["display"] = "none";
	} else if (iSubUnits < this["iTotalSubUnits"] && iSubUnits > 0) {
		aImages[0]["style"]["borderWidth"] = "1px 0px 1px 1px";
		aImages[0]["style"]["display"] = "inline";
		aImages[1]["style"]["display"] = "inline";
	}

	//set the calculated bar widths
	aImages[0]["style"]["width"] = iColoredWidth + "px";
	aImages[1]["style"]["width"] = iGrayedoutWidth + "px";

	this["iColoredBarSubUnits"] = iSubUnits;
	this["setClientProperty"]("ColoredBarSubUnits", this["iColoredBarSubUnits"], true);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["setBarWidth"] = 0; };

/**
 * Sets the position of the slider
 * @param {int} iSubUnits
 */
UCF_ThresholdSlider_static["prototype"]["setSliderPosition"] = function(iSubUnits) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["setSliderPosition"]++; }; 

	if (!this["bIsInteractive"]) return;

	var oSlider = UCF_DomUtil["$"](this["sId"] + "-slider");
	var iMargin = iSubUnits * this["iSubUnitWidth"];

	iMargin -= 7;

	if (iMargin < -2) iMargin = -2;

	if (iMargin > this["iTotalWidth"]) {
		iMargin = this["iTotalWidth"];
	}

	if (!window["UCF_System"]["bIsRTL"])
		oSlider["style"]["left"] = iMargin + "px";
	else
		oSlider["style"]["right"] = iMargin + "px";
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["setSliderPosition"] = 0; };

/**
 * Sets the bar to its previous position if an action is canceled
 */
UCF_ThresholdSlider_static["prototype"]["setInitDisplay"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["setInitDisplay"]++; }; 

	var iSubUnits = this["iInitDisplay"];
	var oThreshold = this["getThreshold"](iSubUnits);

	if (oThreshold != null) {
		this["setThresholdType"](oThreshold);
	}

	if (iSubUnits != null) {
		this["setBarWidth"](iSubUnits);
		this["setSliderPosition"](iSubUnits);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["setInitDisplay"] = 0; };

/**
 * Updates the control tooltip according to the new position of the slider
 * @param { UCF_ThresholdPoint } oThreshold event object.
 */
UCF_ThresholdSlider_static["prototype"]["updateTooltip"] = function(oThreshold) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["updateTooltip"]++; }; 
	if (oThreshold == null) return;
	if (window["UCF_System"]["bIsAria"]) {
		this["oDomRef"]["setAttribute"]('aria-valuetext', oThreshold["sTooltip"]);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["updateTooltip"] = 0; };

/**
 * handles the drag start event. Creates a rectangle object representing the GS.
 * Calculates the initial x position of the cursor.
 *
 * @param { UCF_oBrowserEvent } oBrowserEvent event object.
 */
UCF_ThresholdSlider_static["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsdragstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ThresholdSlider_static.js(645): onlsdragstart"); };

	var oSlider = UCF_DomUtil["$"](this["sId"] + "-slider");
	var oTH = UCF_DomUtil["$"](this["sId"] + "-thold");

	if (window["UCF_System"]["sDevice"] !== "standards" && UCF_UserAgent["bIsIE"]()) {
		if (oBrowserEvent["oGetSource"]() !== oSlider && oBrowserEvent["oGetSource"]() !== oTH) {
			return;
		}
	} else {
		if (oBrowserEvent["oGetSource"]() !== oSlider) {
			return;
		}
	}

	oBrowserEvent["bHandled"] = true;

	if (this["oRect"] == null)
		this["oRect"] = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);

	this["iOffsetX"] = 0;

	this["iOffsetX"] = (!window["UCF_System"]["bIsRTL"]) ?
		oBrowserEvent["oDragAndDropManager"]["iDragStartX"] - this["oRect"]["left"] - parseInt(UCF_DomUtil["$"](this["sId"] + "-slider")["style"]["left"]) : 20;

	oBrowserEvent["oDragAndDropManager"]["startDragSession"](this["sId"] + "-slider", "", UCF_DragSession["DRAG_TYPE"]["NONE"], null, null, null);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsdragstart"] = 0; };

/**
 * handles the drag event.
 * Calculates the x position of the cursor while dragging.
 *
 * @param { UCF_oBrowserEvent } oBrowserEvent event object.
 */
UCF_ThresholdSlider_static["prototype"]["onlsdrag"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsdrag"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ThresholdSlider_static.js(680): onlsdrag"); };

	this["bDragging"] = true;

	var iMouseX = oBrowserEvent["iPageX"]();
	var iMargin = iMouseX - this["oRect"]["left"] - this["iOffsetX"] + 7;

	if (window["UCF_System"]["bIsRTL"]) {
		iMargin = this["oDomRef"]["offsetWidth"] - iMargin;
	}

	if (iMargin < 0) iMargin = 0;
	iMargin = Math["max"](-7, iMargin);

	if (iMargin > this["iTotalWidth"])
		iMargin = this["iTotalWidth"];

	var iSubUnits = this["calcSubUnits"](iMargin),
		oThreshold = null;

	if (iSubUnits != null) {
		oThreshold = this["getThreshold"](iSubUnits);
		this["setSliderPosition"](iSubUnits);
		this["setBarWidth"](iSubUnits);
	}

	if (oThreshold != null) {
		this["setThresholdType"](oThreshold);
		this["updateTooltip"](oThreshold);
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsdrag"] = 0; };

/**
 * handles the drag end event.
 *
 * @param {UCF_oBrowserEvent} oBrowserEvent event object.
 */
UCF_ThresholdSlider_static["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsdragend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ThresholdSlider_static.js(718): onlsdragend"); };

	if (oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["ESCAPE"]) {
		this["setInitDisplay"]();
		this["bEscaped"] = true;
	} else {
		this["fireChange"](this["sId"], this["iColoredBarSubUnits"]);
		this["iInitDisplay"] = this["iColoredBarSubUnits"];
		if (window["UCF_System"]["bIsAria"]) {
			this["oDomRef"]["setAttribute"]('aria-valuenow', this["iColoredBarSubUnits"]);
		}
	}
	this["bDragging"] = false;
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsdragend"] = 0; };

/**
 * Sets the correct acc text
 * @param { UCF_oBrowserEvent } oBrowserEvent event object.
 */
UCF_ThresholdSlider_static["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ThresholdSlider_static.js(738): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSourceControl"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (!UCF_JsUtil["bInstanceOf"](oSource, "UCF_ThresholdSlider_static")) return;

	//Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this);
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

	oAccessibilityHelper["setTooltip"](this["sTooltipText"]);
	oAccessibilityHelper["setControlType"]("SLIDER");
	oAccessibilityHelper["setItemCount"](this["iTotalUnits"]);
	oAccessibilityHelper["setItemIndex"](Math["floor"](this["iColoredBarSubUnits"] / this["iSubUnitsPerUnit"]));

	// Note: Adding semantic color info is currently only supported for "interactive" mode
	// because createThresholds() and getThreshold() work only in this mode !
	if (this["bIsInteractive"]) {
		var oThreshold = this["getThreshold"](this["iColoredBarSubUnits"]);
		if (oThreshold != null) {
			oAccessibilityHelper["setLegend"](this["mLegend"]);
			oAccessibilityHelper["addSemantic"](oThreshold["sSemantic"]);
		}
	}

	if (this["bIsInteractive"]) {
		oAccessibilityHelper["addTutor"]("LRNAV_TUT");
	}
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 */
UCF_ThresholdSlider_static["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["destroy"]++; }; 
	this["aThresholds"] = null;
	this["oRect"] = null;
	this["sTooltipText"] = null;
	this["iTotalWidth"] = null;
	this["iTotalSubUnits"] = null;
	this["iUnitWidth"] = null;
	this["iInitDisplay"] = null;
	this["iLastSubUnits"] = null;
	this["iColoredBarSubUnits"] = null;
	this["bUsedInTable"] = null;
	this["bTableNavigation"] = null;
	this["sTimeOutId"] = null;
	this["iOffsetX"] = null;

	UCF_ThresholdSlider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ThresholdSlider_static["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_TileLayout"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>

/**
 * 
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TileLayout(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["UCF_TileLayout"]++; }; 
	/** @type {number} */
	var i;
	/** @type {number} */
	var g;
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "TileLayout.js(37): initialize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TileLayout.js(38): initialize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TileLayout.js(39): initialize"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'parameters: minCellWidth = ' + this["sMinCellWidth"] + ', allowedColCounts = ' + this["sAllowedColCounts"] + '', "TileLayout.js(43): initialize"); };

	/** @type {UCF_Cache} */
	this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();
	/** @type {number} */
	this["iColumnCount"] = -1;
	/** @type {NodeListOf<HTMLLIElement>} */
	this["aCells"] = UCF_JsUtil["filter"](UCF_JsUtil["arrayFrom"](this["oRootRef"]["children"]), function(oItem) {
		return oItem["tagName"] === 'LI';
	});

	/** @type {boolean} `true` if padding applies only to gaps */
	this["bGapPadding"] = UCF_StringUtil["bEndsWith"](this["sCellPadding"], '_GAP');

	if (this["sAllowedColCounts"] === 'OPTIMAL') {
		/** @type {number[]} */
		this["aAllowedColCounts"] = [];
		for (i = this["aCells"]["length"]; i >= 1; --i) {
			g = parseInt(this["aCells"]["length"] / i, 10);
			if (this["aCells"]["length"] % i) {
				g++;
			}
			if (!this["aAllowedColCounts"][g - 1]) {
				this["aAllowedColCounts"]["push"](g);
			} else {
				this["aAllowedColCounts"][g - 1] = g;
			}
		}
	} else {
		/** @type {number[]} lists of numbers (separated by space) are allowed only */
		this["aAllowedColCounts"] = this["sAllowedColCounts"]["match"](/^[\d ]*\d+[\d ]*$/)
			? this["sAllowedColCounts"]["match"](/\d+/g)["sort"](function(a, b) { return a - b; })
			: null;
	}

	if (this["bAlignLastCell"] && this["aCells"]["length"]) {
		this["aCells"][this["aCells"]["length"] - 1]["style"]["float"] = (window["UCF_System"]["bIsRTL"] ? "left" : "right");
	}

	oBrowserWindow = this["oLS"]["oBrowserWindow"];

	if ((!UCF_UserAgent["bIsTrident"]() || UCF_UserAgent["bIsTrident"](5)) && !__UCF_IE6__) {
		oBrowserWindow["attachEvent"](
			oBrowserWindow["E_EVENTS"]["LayoutChange"],
			this,
			'onLayoutChange'
		);
	} else {
		this["initialize"] = function() {};
	}
};window["UCF_TileLayout"] = UCF_TileLayout; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TileLayout"); UCF_TileLayout["_"] = {UCF_TileLayout: 0}; }; 
UCF_TileLayout["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TileLayout.prototype["sClassName"] = "UCF_TileLayout";

/** */
UCF_TileLayout["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["initialize"]++; }; 
	this["resize"]();
};;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["initialize"] = 0; };

/**
 * Destroy is called when control is removed
 * @override
 */
UCF_TileLayout["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["destroy"]++; }; 
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow = this["oLS"]["oBrowserWindow"];

	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["LayoutChange"], this);

	this["oCache"]["destroy"]();
	this["oCache"] = null;

	this["bGapPadding"] = null;
	this["initialize"] = null;
	this["aAllowedColCounts"] = null;
	this["aCells"] = null;
	this["iColumnCount"] = 0;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["destroy"] = 0; };

/** @param {UCF_Event} oEvent */
UCF_TileLayout["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["onLayoutChange"]++; }; 
	/** @type {string} */
	var sSourceControlId = oEvent["oGetParam"]('sSourceControlId');
	/** @type {string} */
	var sSourceClassName = oEvent["oGetParam"]('sSourceClassName');
	/** @type {UCF_PopupWindow} */
	var oPW;

	if (sSourceClassName && (sSourceClassName === 'UCF_PopupWindow' || sSourceClassName === 'UCF_PopupWindow_standards' || sSourceClassName === 'UCF_PopupWindow_ie6')) {
		oPW = this["oGetParentPopupWindow"]();
		if (oPW && oPW["sGetId"]() === sSourceControlId) {
			this["resize"]();
		}
	} else {
		this["resize"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["onLayoutChange"] = 0; };

/**
 *
 */
UCF_TileLayout["prototype"]["resize"] = function() {;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["resize"]++; }; 
	/** @type {number} */
	var iColumnCount;
	/** @type {string} */
	var sPercWidth;
	/** @type {number} */
	var i;
	/** @type {number} */
	var iLen;
	/** @type {UCF_BrowserWindow} */
	var oBrowserWindow;
	/** @type {boolean} */
	var bFirstRow;
	/** @type {boolean} */
	var bLastRow;
	/** @type {boolean} */
	var bFirstCol;
	/** @type {boolean} */
	var bLastCol;

	if (this["oRootRef"]["clientWidth"]) { // layout may be invisible at the moment
		iColumnCount = this["iGetColumnCount"]();

		if (iColumnCount !== this["iColumnCount"]) { // iColumnCount may stay the same
			this["iColumnCount"] = iColumnCount;
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'New iColumnCount (' + this["iColumnCount"] + '), rearranging layout cells.', "TileLayout.js(170): resize"); };

			sPercWidth = Number(100 / this["iColumnCount"]) + '%';
			iLen = this["aCells"]["length"];

			for (i = 0; i < iLen; ++i) {
				bFirstRow = this["bGapPadding"] && i < iColumnCount;
				bLastRow = this["bGapPadding"] && i >= iLen - (iLen % iColumnCount || iColumnCount);
				bFirstCol = this["bGapPadding"] && i % iColumnCount === 0;
				bLastCol = this["bGapPadding"] && i % iColumnCount === iColumnCount - 1;

				UCF_DomUtil["setStyle"](this["aCells"][i], {
					"width": sPercWidth,
					"paddingTop": bFirstRow ? 0 : '',
					"paddingBottom": bLastRow ? 0 : '',
					"paddingLeft": (window["UCF_System"]["bIsRTL"] ? bLastCol : bFirstCol) ? 0 : '',
					"paddingRight": (window["UCF_System"]["bIsRTL"] ? bFirstCol : bLastCol) ? 0 : ''
				});
			}

			oBrowserWindow = this["oLS"]["oBrowserWindow"];
			//we are not interested in our own notifications
			oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["LayoutChange"], this);
			this["notifyLayoutChangeFrom"]();
			oBrowserWindow["attachEvent"](
				oBrowserWindow["E_EVENTS"]["LayoutChange"],
				this,
				'onLayoutChange'
			);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["resize"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_TileLayout["prototype"]["iGetColumnCount"] = function() {;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["iGetColumnCount"]++; }; 
	/** @type {number} */
	var iMaxColumnCount;
	/** @type {number} */
	var iValidColumnCount;
	/** @type {number} */
	var i;
	/** @type {number} */
	var len;

	if (!this["sMinCellWidth"])
		return 1;

	iMaxColumnCount = Math["max"](
		1,
		Math["min"](
			parseInt(this["oRootRef"]["clientWidth"] / this["iGetMinCellWidthPx"](), 10),
			this["aCells"]["length"]
		)
	);

	if (!this["aAllowedColCounts"] || !this["sAllowedColCounts"]["length"])
		return iMaxColumnCount;

	iValidColumnCount = this["aAllowedColCounts"][0];
	for (i = 1, len = this["aAllowedColCounts"]["length"]; i < len; ++i) {
		if (this["aAllowedColCounts"][i] <= iMaxColumnCount)
			iValidColumnCount = parseInt(this["aAllowedColCounts"][i], 10);
		else
			break;
	}

	return iValidColumnCount;
};;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["iGetColumnCount"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_TileLayout["prototype"]["iGetMinCellWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["iGetMinCellWidthPx"]++; }; 
	/** @type {UCF_TileLayout} */
	var self = this;

	return this["oCache"]["get"]('iMinCellWidthPx', function() {
		// adjust to match the size units in fragment "UrBase_sNormalizeCssSize" (except for "%")
		/** @type {RegExpMatchArray} */
		var aMinCellWidth = self["sMinCellWidth"]["match"](/^ *(\d+)(cm|em|ex|in|mm|pc|pt|px|rem|vh|vw)? *$/i);
		/** @type {number} */
		var iMinCellWidth;
		/** @type {CSSStyleDeclaration} */
		var oCS;
		/** @type {HTMLLIElement} */
		var oCell;
		/** @type {string} */
		var sPaddingLeft;
		/** @type {string} */
		var sPaddingRight;
		/** @type {number} */
		var iPaddingLeft;
		/** @type {number} */
		var iPaddingRight;

		if (!aMinCellWidth || aMinCellWidth[1] === '0') {
			return 1;
		} else {
			iMinCellWidth = (!aMinCellWidth[2] || aMinCellWidth[2] === 'px'
				? Number(aMinCellWidth[1])
				: UCF_DomUtil["iConvertAnySizeToPixel"](self["sMinCellWidth"]));

			if (self["aCells"]["length"] > 0) {
				oCell = self["aCells"][0];

				if (self["bGapPadding"]) {
					sPaddingLeft = oCell["style"]["paddingLeft"];
					sPaddingRight = oCell["style"]["paddingRight"];

					UCF_DomUtil["setStyle"](oCell, UCF_JsUtil["extend"](
						sPaddingLeft ? { "paddingLeft": '' } : {},
						sPaddingRight ? { "paddingRight": '' } : {}
					));
				}

				oCS = UCF_DomUtil["oGetComputedStyle"](oCell);

				iPaddingLeft = parseInt(oCS["paddingLeft"], 10);
				iPaddingRight = parseInt(oCS["paddingRight"], 10);

				if (self["bGapPadding"]) {
					UCF_DomUtil["setStyle"](oCell, UCF_JsUtil["extend"](
						sPaddingLeft ? { "paddingLeft": sPaddingLeft } : {},
						sPaddingRight ? { "paddingRight": sPaddingRight } : {}
					));
				}

				iMinCellWidth += iPaddingLeft + iPaddingRight;
			}

			return iMinCellWidth;
		}
	});
};;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["iGetMinCellWidthPx"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TileLayout["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["onlsskipforward"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TileLayout.js(316): onlsskipforward"); };
	this["handleSkipForward"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TileLayout["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["onlsskipback"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TileLayout.js(328): onlsskipback"); };
	this["handleSkipBack"](oBrowserEvent);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["onlsskipback"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TileLayout["prototype"]["aAttributeNames"] = ["sMinCellWidth","sAllowedColCounts","sCellPadding","bAlignLastCell"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TileLayout["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TileLayout["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_TileLayout["prototype"]["sMinCellWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TileLayout["prototype"]["sAllowedColCounts"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TileLayoutCellPadding}
 */
UCF_TileLayout["prototype"]["sCellPadding"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_TileLayout["prototype"]["bAlignLastCell"] = false;

//#JSCOVER_EXCL_START
/** @protected */
UCF_TileLayout["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["setDefaultValues"]++; }; 
	this["sMinCellWidth"] = '';
	this["sAllowedColCounts"] = '';
	this["sCellPadding"] = "NONE";
	this["bAlignLastCell"] = false;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("MinCellWidth", '', true);
		this["setClientProperty"]("AllowedColCounts", '', true);
		this["setClientProperty"]("CellPadding", "NONE", true);
		this["setClientProperty"]("AlignLastCell", false, true);
	}
};;if (__UCF_COVERAGE__) { UCF_TileLayout["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_TimeTrigger"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TimeTrigger(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["UCF_TimeTrigger"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "TimeTrigger.js(22): UCF_TimeTrigger"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TimeTrigger.js(23): UCF_TimeTrigger"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TimeTrigger.js(24): UCF_TimeTrigger"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["sTimerId"] = null;
	this["iDelayMilliseconds"] = this["iDelay"] * 1000;

};window["UCF_TimeTrigger"] = UCF_TimeTrigger; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TimeTrigger"); UCF_TimeTrigger["_"] = {UCF_TimeTrigger: 0}; }; ;
UCF_TimeTrigger["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TimeTrigger.prototype["sClassName"] = "UCF_TimeTrigger";

/**
 * Intialize
 */
UCF_TimeTrigger["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["initialize"]++; }; 
	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["Lock"], this, "stop");
	oBrowserWindow["attachEvent"](oBrowserWindow["E_EVENTS"]["Unlock"], this, "start");

	if (!oBrowserWindow["bIsLocked"]()) this["start"]();

};;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["initialize"] = 0; };

/**
 * Destructor
 */
UCF_TimeTrigger["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["destroy"]++; }; 
	this["stop"]();

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Lock"], this);
	oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["Unlock"], this);
	this["iDelayMilliseconds"] = null;
	this["bEnabled"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["destroy"] = 0; };

/**
 * Trigger event
 */
UCF_TimeTrigger["prototype"]["trigger"] = function() {;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["trigger"]++; }; 

	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	if (!oBrowserWindow["bIsLocked"]()) {
		if (oBrowserWindow["bIsFocussed"]() && (this["oLS"]["bIsDirty"]() || this["oLS"]["hasPendingChange"]())) {
			var sFocusedIdElement = this["oLS"]["sGetFocusedElementId"]();
			UCF_DomUtil["refocusDomElement"](UCF_DomUtil["oGetActiveElement"]());
			this["oLS"]["focusElement"](sFocusedIdElement);
		}
		this["fireTrigger"](this["sId"]);
		this["start"]();
	}

};;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["trigger"] = 0; };

/**
 * Start the timer
 */
UCF_TimeTrigger["prototype"]["start"] = function() {;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["start"]++; }; 

	if (!this["bEnabled"]) return;

	// Call stop first to avoid creating multiple delayed calls
	this["stop"]();
	this["sTimerId"] = UCF_JsUtil["delayedCall"](this["iDelayMilliseconds"], this, "trigger");

};;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["start"] = 0; };

/**
 * Stop the timer
 */
UCF_TimeTrigger["prototype"]["stop"] = function() {;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["stop"]++; }; 

	if (this["sTimerId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimerId"]);
		this["sTimerId"] = null;
	}

};;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["stop"] = 0; };

/**
 * Enables/disables the control
 */
UCF_TimeTrigger["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["setEnabled"]++; }; 
	this["bEnabled"] = bEnabled;

	this["setClientProperty"]("Enabled", bEnabled);

	if (bEnabled) {
		if (!this["oLS"]["oBrowserWindow"]["bIsLocked"]()) this["start"]();
	} else this["stop"]();
};;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["setEnabled"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TimeTrigger["prototype"]["aAttributeNames"] = ["bEnabled","iDelay","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TimeTrigger["prototype"]["aEventNames"] = ["Trigger"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TimeTrigger["prototype"]["aMethodNames"] = ["setEnabled","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {boolean}
 */
UCF_TimeTrigger["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {number}
 */
UCF_TimeTrigger["prototype"]["iDelay"] = 5;

/**
 * @private
 * @type {string}
 */
UCF_TimeTrigger["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_TimeTrigger["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["setDefaultValues"]++; }; 
	this["bEnabled"] = true;
	this["iDelay"] = 5;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Delay", 5, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the TimeTrigger control in the current HTML document context. The Id of any control should be unique within the document.
 * @fires TimeTrigger::Trigger
 */
UCF_TimeTrigger["prototype"]["fireTrigger"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["fireTrigger"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "TimeTrigger.js(180): fireTrigger"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TimeTrigger.js(181): fireTrigger"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TimeTrigger.js(182): fireTrigger"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("TimeTrigger", "Trigger", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TimeTrigger["_"]["fireTrigger"] = 0; };

};
sap["ls"]["preload"]["UCF_ToggleLink"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ToggleLink(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["UCF_ToggleLink"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ToggleLink.js(25): UCF_ToggleLink"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ToggleLink.js(26): UCF_ToggleLink"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ToggleLink.js(27): UCF_ToggleLink"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
	this["bIgnoreDefaultButton"] = true; //ignore the default button if the control gets the focus
	this["sToggleLinkTooltip"] = null;
};window["UCF_ToggleLink"] = UCF_ToggleLink; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ToggleLink"); UCF_ToggleLink["_"] = {UCF_ToggleLink: 0}; }; ;
UCF_ToggleLink["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ToggleLink.prototype["sClassName"] = "UCF_ToggleLink";

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ToggleLink["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ToggleLink.js(43): onclick"); };

	if (!this["bEnabled"]) return;

	if (this["bCollapsed"])
		this["fireExpand"](this["sId"]);
	else
		this["fireCollapse"](this["sId"]);
};;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["onclick"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ToggleLink["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["onlsselect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ToggleLink.js(61): onlsselect"); };

	if (!this["bEnabled"]) return;

	if (this["bCollapsed"])
		this["fireExpand"](this["sId"]);
	else
		this["fireCollapse"](this["sId"]);

	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setExpanded"](this["oDomRef"], !this["bCollapsed"]);
	}

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["onlsselect"] = 0; };

/**
 * Handles the mouseover event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @private
 */
UCF_ToggleLink["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ToggleLink.js(86): onmouseover"); };

	if (window["UCF_System"]["bIs508"]) return;

	try {
		if (this["sToggleLinkTooltip"] == null) {
			this["sToggleLinkTooltip"] = this["oDomRef"]["getAttribute"]("title");
		}
	} catch (oException) {
		this["sToggleLinkTooltip"] = this["sTooltip"];
	}
	var oDomRefOvfl = UCF_DomUtil["$"](this["sId"] + "-ovfl");
	UCF_DomUtil["checkTooltip"](this["oDomRef"], this["sToggleLinkTooltip"], oDomRefOvfl);
};;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["onmouseover"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_ToggleLink["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ToggleLink.js(109): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());

	oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
	oAccessibilityHelper["setHotkey"](this["sHotkey"]);
	oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](this["oDomRef"]));
	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setNotToggled"](this["bCollapsed"]);
	oAccessibilityHelper["setToggled"](!this["bCollapsed"]);
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["setControlType"]("TGL");
	oAccessibilityHelper["addEnabledTutor"]("TGL_TUT", this["bEnabled"]);
};;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["onlsaccessibility"] = 0; };

UCF_ToggleLink["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["destroy"]++; }; 

	this["sToggleLinkTooltip"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["destroy"] = 0; };

/**
 * @return {Object}
 * @private
 */
UCF_ToggleLink["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["aGetTouchContextMenuEntries"]++; }; 
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);
	var oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-ovfl');
	if (UCF_DomUtil["bHasTextEllipsis"](this["oDomRef"], oTextDomRef)) {
		var oGetTextDomRef = oTextDomRef ? oTextDomRef : this["oDomRef"];
		aResult["push"]({
			"sType": 'TEXT',
			"sText": UCF_DomUtil["sGetInnerText"](oGetTextDomRef)
		});
	}

	return aResult;
};;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["aGetTouchContextMenuEntries"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ToggleLink["prototype"]["aAttributeNames"] = ["sTooltip","bEnabled","bCollapsed","sVisibility","sAccessKey","sHotkey","sCustomData","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ToggleLink["prototype"]["aEventNames"] = ["Expand","Collapse"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ToggleLink["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ToggleLink["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_ToggleLink["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_ToggleLink["prototype"]["bCollapsed"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ToggleLink["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ToggleLink["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HotkeyValue}
 */
UCF_ToggleLink["prototype"]["sHotkey"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_ToggleLink["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ToggleLink["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ToggleLink["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["bCollapsed"] = true;
	this["sVisibility"] = "VISIBLE";
	this["sAccessKey"] = '';
	this["sHotkey"] = "NONE";
	this["sCustomData"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Collapsed", true, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("Hotkey", "NONE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires ToggleLink::Expand
 */
UCF_ToggleLink["prototype"]["fireExpand"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["fireExpand"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "ToggleLink.js(256): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ToggleLink.js(257): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ToggleLink.js(258): fireExpand"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("ToggleLink", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["fireExpand"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires ToggleLink::Collapse
 */
UCF_ToggleLink["prototype"]["fireCollapse"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "ToggleLink.js(275): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ToggleLink.js(276): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ToggleLink.js(277): fireCollapse"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("ToggleLink", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ToggleLink["_"]["fireCollapse"] = 0; };

};
sap["ls"]["preload"]["UCF_Token"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_TokenDragDelegate */
/// <reference path="./delegates/TokenDragDelegate.js"/>
/* global UCF_QuickView */
/// <reference path="./QuickView.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>

/**
 * The Token for the Tokenizer
 * @class
 * @extends UCF_Control
 * 
 * @version
 * @param {HTMLElement} oDomRef The DOM reference of the control
 * @param {UCF_LS} oLS The LS instance
 * @private
 */
function UCF_Token(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Token["_"]["UCF_Token"]++; }; 
	var i;
	var self = this;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "Token.js(44): UCF_Token"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Token.js(45): UCF_Token"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Token.js(46): UCF_Token"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["iIndex"] = -1; // eslint-disable-line @ur/no-memory-leaks
	this["bMouseDownSelected"] = false;

	if (!this["bEnabled"]) {
		for (i = 0; this["aDelegates"] && i < this["aDelegates"]["length"]; ++i) {
			if (this["aDelegates"][i] instanceof UCF_QuickView) {
				this["removeDelegate"](this["aDelegates"][i]);
			}
		}
	}

	this["oAnyFocusListener"] = {
		"onAnyFocusEvent": function(oEvent) {
			var oBrowserEvent;
			var sName;

			if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "Token.js(66): UCF_Token"); };

			oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');
			sName = oBrowserEvent["sGetName"]();
			if (
				(sName === 'lsfocus' || (sName === 'lsfocuslost' && !oBrowserEvent["bIsTouchInteraction"]()) || sName === 'lstouchstart') && // TODO: see BrowserWindow.checkForLostFocus()
				!UCF_DomUtil["bContains"](self["oDomRef"], oBrowserEvent["oGetSource"]())
			) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'AnyFocusListener: onAnyFocusEvent(): Token "' + self["sId"] + '": focusout detected: ' + sName, "Token.js(74): UCF_Token"); };
				this["detach"]();
			}
		},
		"attach": function() {
			var oBrowserWindow;

			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'AnyFocusListener: attach(): Token "' + self["sId"] + '": attach to any focus event', "Token.js(81): UCF_Token"); };

			// Add focus style
			if (self["bIsFocusable"]()) {
				// IE focusses elements without tabindex!?
				UCF_DomUtil["addClass"](self["oDomRef"], UCF_Token["FOCUSCLASS"]);
			}

			oBrowserWindow = self["oLS"]["oBrowserWindow"];
			oBrowserWindow["attachEvent"](
				oBrowserWindow["E_EVENTS"]["AnyEvent"],
				this,
				'onAnyFocusEvent'
			);
		},
		"detach": function() {
			var oBrowserWindow;

			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'AnyFocusListener: detach(): Token "' + self["sId"] + '": detach from any focus event', "Token.js(99): UCF_Token"); };

			// Remove focus style
			UCF_DomUtil["removeClass"](self["oDomRef"], UCF_Token["FOCUSCLASS"]);

			oBrowserWindow = self["oLS"]["oBrowserWindow"];
			oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this);
		}
	};

	this["oClickDetector"] = {
		"onAnyMouseUpEvent": function(oEvent) {
			var oBrowserEvent;
			var sName;

			if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "Token.js(114): UCF_Token"); };

			oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');
			sName = oBrowserEvent["sGetName"]();
			if (sName === 'mouseup' || sName === 'touchend') {
				if (UCF_DomUtil["bContains"](self["oDomRef"], oBrowserEvent["oGetSource"]())) {
					if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oClickDetector: onAnyMouseUpEvent(): Token "' + self["sId"] + '": click detected', "Token.js(120): UCF_Token"); };
					UCF_JsUtil["extend"](oBrowserEvent["oGetData"](), { "bClick": true });
				} else {
					if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oClickDetector: onAnyMouseUpEvent(): Token "' + self["sId"] + '": NO CLICK DETECTED', "Token.js(123): UCF_Token"); };
				}
				this["detach"]();
			}
		},

		"start": function() {
			var oBrowserWindow;

			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oClickDetector: start(): Token "' + self["sId"] + '": start watching for mouseup events', "Token.js(132): UCF_Token"); };
			oBrowserWindow = self["oLS"]["oBrowserWindow"];
			oBrowserWindow["attachEvent"](
				oBrowserWindow["E_EVENTS"]["AnyEvent"],
				this,
				'onAnyMouseUpEvent'
			);
		},

		"detach": function() {
			var oBrowserWindow;

			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oClickDetector: detach(): Token "' + self["sId"] + '": detach from any mouseup event', "Token.js(144): UCF_Token"); };
			oBrowserWindow = self["oLS"]["oBrowserWindow"];
			oBrowserWindow["detachEvent"](oBrowserWindow["E_EVENTS"]["AnyEvent"], this);
		},

		"isClick": function(oBrowserEvent) {
			if (oBrowserEvent["oGetData"]()["bClick"]) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oClickDetector: isClick(): Token "' + self["sId"] + '": true', "Token.js(151): UCF_Token"); };
				return true;
			}
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oClickDetector: isClick(): Token "' + self["sId"] + '": false', "Token.js(154): UCF_Token"); };
			return false;
		}
	};

	if (window["UCF_System"]["bIsAria"]) {
		if (!this["bReadOnly"] && this["bEnabled"] && this["bHasEventListeners"]('Edit')) {
			UCF_AriaStateHelper["addDescribedby"](
				this["oDomRef"],
				'ARIA_TOKEN_EDITABLE'
			);
		}
	}
};window["UCF_Token"] = UCF_Token; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Token"); UCF_Token["_"] = {UCF_Token: 0}; }; ;
UCF_Token["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Token.prototype["sClassName"] = "UCF_Token";

/** @const {string} */
UCF_Token["FOCUSCLASS"] = 'lsToken--focus';

/**
 * Destroy is called when control is removed
 * @override
 * @private
 */
UCF_Token["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["destroy"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, this["sId"] + ': destroy', "Token.js(179): destroy"); };

	if (!this["bIsDestroyed"]) {
		this["oAnyFocusListener"]["detach"]();
		this["oAnyFocusListener"] = null;

		this["oClickDetector"]["detach"]();
		this["oClickDetector"] = null;

		if (this["oDragDelegate"]) {
			this["oDragDelegate"]["destroy"]();
			this["oDragDelegate"] = null;
		}
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["destroy"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Token["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["onlsfocus"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()', "Token.js(201): onlsfocus"); };
	this["oAnyFocusListener"]["attach"]();
	this["select"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-()', "Token.js(204): onlsfocus"); };
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["onlsfocus"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Token["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["onlsblur"]++; }; 
	this["oAnyFocusListener"]["detach"]();
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["onlsblur"] = 0; };

/**
 * Handles the (simulated) click event
 * Note: onclick is not called if the tokenizer is in overlay-mode: Because
 * the DOM is exchanged, mousedown and mouseup come from different elements
 * ==> no click event
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_Token["prototype"]["handleClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["handleClick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Token.js(225): handleClick"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()', "Token.js(226): handleClick"); };

	if (
		UCF_StringUtil["bEndsWith"](oBrowserEvent["oSource"]["id"], '-icon') &&
		this["bIsEditable"]() &&
		!(oBrowserEvent["bCtrl"]() || oBrowserEvent["bAlt"]())
	) {
		// handle delete icon clicked
		this["fireDelete"](this["sId"], 'MOUSE');
	} else if (
		(oBrowserEvent["bCtrl"]() || oBrowserEvent["bIsTouchInteraction"]()) &&
		this["bSelected"] && !this["bMouseDownSelected"]
	) {
		this["unSelect"]();
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-()', "Token.js(242): handleClick"); };
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["handleClick"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Token["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Token.js(250): ondblclick"); };

	if (this["bIsEditable"]()) {
		this["fireEdit"](this["sId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["ondblclick"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Token["prototype"]["ontouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["ontouchstart"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"], "Token.js(262): ontouchstart"); };
	this["handleDown"](oBrowserEvent);
	this["focus"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Token.js(265): ontouchstart"); };
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["ontouchstart"] = 0; };

/**
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Token["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Token.js(273): onmouseover"); };

	if (oBrowserEvent["bIsMouseHover"]() && this["bIsEditable"]()) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsToken--hoverable');
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsToken--hoverable');
	}
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["onmouseover"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Token["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["onmousedown"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"], "Token.js(287): onmousedown"); };
	// discard mousedown event in case of touch interaction, it was already
	// executed in touchstart event
	if (!oBrowserEvent["bIsTouchInteraction"]()) {
		this["handleDown"](oBrowserEvent);
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Token.js(293): onmousedown"); };
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["onmousedown"] = 0; };

/**
 * shift => visualisiere "selektiert", setze Fokus, Event bubbeln
 *       Tokenizer: selektiere noch alle weiteren im Interval
 * kein modifier => visualisiere "selektiert", setze Fokus, Event bubbeln
 *       Tokenizer: deselektiere die anderen Tokens (aber erst im
 *       onmouseup, damit D&D korrekt funktioniert)
 * ctrl => toggle visualisierung "selektiert", setze Fokus wenn selektiert,
 *       Event bubbeln wenn deselektiert
 *       Tokenizer: falls deselektiert: suche neues zu selektierendes
 *       Token, setze Fokus, evtl Combobox fokusieren
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Token["prototype"]["handleDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["handleDown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Token.js(310): handleDown"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"] + ', event: ' + oBrowserEvent["sName"], "Token.js(311): handleDown"); };

	if (this["bIsFocusable"]()) {
		this["oClickDetector"]["start"]();
		UCF_JsUtil["extend"](oBrowserEvent["oGetData"](), { "oToken": this });
		this["bMouseDownSelected"] = false;
		if (!this["bSelected"]) {
			this["bMouseDownSelected"] = true;
			UCF_DomUtil["setTabIndex"](this["oDomRef"], 0); // without tabindex, an HTML element can't get focussed (activeElement)!
			this["select"](); // select here to handle drag&drop correctly
		}
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-()', "Token.js(324): handleDown"); };
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["handleDown"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Token["prototype"]["ontouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["ontouchend"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"], "Token.js(332): ontouchend"); };
	this["handleUp"](oBrowserEvent);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Token.js(334): ontouchend"); };
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["ontouchend"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Token["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["onmouseup"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"], "Token.js(342): onmouseup"); };
	// discard mouseup event in case of touch interaction, it was already
	// executed in touchend event
	if (!oBrowserEvent["bIsTouchInteraction"]()) {
		this["handleUp"](oBrowserEvent);
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Token.js(348): onmouseup"); };
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["onmouseup"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Token["prototype"]["handleUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["handleUp"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Token.js(356): handleUp"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: "' + this["sId"] + '"', "Token.js(357): handleUp"); };

	UCF_JsUtil["extend"](oBrowserEvent["oGetData"](), { "oToken": this });
	if (this["oClickDetector"]["isClick"](oBrowserEvent)) {
		this["handleClick"](oBrowserEvent);
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-()', "Token.js(364): handleUp"); };
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["handleUp"] = 0; };

/**
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Token["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["onkeydown"]++; }; 
	var iKeyCode;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Token.js(374): onkeydown"); };

	if (!this["bIsEditable"]()) {
		return;
	}

	iKeyCode = oBrowserEvent["iKeyCode"]();
	if (
		(iKeyCode === UCF_KeyCodes["BACKSPACE"] ||
			iKeyCode === UCF_KeyCodes["DELETE"]) &&
		!oBrowserEvent["bCtrl"]() && !oBrowserEvent["bAlt"]() && !oBrowserEvent["bShift"]()
	) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		this["fireDelete"](this["sId"], 'KEYBOARD');
	}

	if (iKeyCode === UCF_KeyCodes["F2"]) {
		this["fireEdit"](this["sId"]);
		if (this["mEvents"]["Edit"]) {
			oBrowserEvent["cancelBubble"]();
			oBrowserEvent["cancel"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["onkeydown"] = 0; };

/**
 * @public
 * @param { integer } iIndex The index of the token, when used in the tokenizer
 */
UCF_Token["prototype"]["setIndex"] = function(iIndex) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["setIndex"]++; }; 
	this["iIndex"] = iIndex;
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["setIndex"] = 0; };

/**
 * @public
 * @return { integer } The index of the token, when used in the tokenizer
 */
UCF_Token["prototype"]["iGetIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["iGetIndex"]++; }; 
	return this["iIndex"];
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["iGetIndex"] = 0; };

/**
 * @public
 * @return { boolean }
 */
UCF_Token["prototype"]["bIsSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["bIsSelected"]++; }; 
	return this["bSelected"];
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["bIsSelected"] = 0; };

/**
 * @public
 * @return { boolean }
 */
UCF_Token["prototype"]["bHasFocus"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["bHasFocus"]++; }; 
	return UCF_DomUtil["bContains"](this["oDomRef"], UCF_DomUtil["oGetActiveElement"]());
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["bHasFocus"] = 0; };

/**
 * @public
 * @return { boolean }
 */
UCF_Token["prototype"]["bIsEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["bIsEditable"]++; }; 
	return !this["bReadOnly"] && this["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["bIsEditable"] = 0; };

/**
 * @public
 * @return { boolean }
 */
UCF_Token["prototype"]["bIsFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["bIsFocusable"]++; }; 
	if (window["UCF_System"]["bIsAria"]) {
		return this["bEnabled"];
	}
	if (window["UCF_System"]["bIs508"]) {
		return true;
	}

	return !this["bReadOnly"] && this["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["bIsFocusable"] = 0; };

/**
 * @public
 * @return { boolean }
 */
UCF_Token["prototype"]["bIsInDragAndDrop"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["bIsInDragAndDrop"]++; }; 
	return (this["oDragDelegate"] && this["oDragDelegate"]["bDragAndDrop"]);
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["bIsInDragAndDrop"] = 0; };

/**
 * @public
 */
UCF_Token["prototype"]["select"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["select"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"] + ', iIndex:' + this["iIndex"], "Token.js(467): select"); };

	if (this["bIsEditable"]() && !this["bSelected"]) {
		this["bSelected"] = true;
		this["setClientProperty"]("Selected", this["bSelected"], true);
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsToken--selected');
		this["fireSelect"](this["sId"], true);
	}

	if (this["bIsFocusable"]() && window["UCF_System"]["bIsAria"]) {
		this["oDomRef"]["setAttribute"]('aria-selected', 'true');
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-()', "Token.js(480): select"); };
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["select"] = 0; };

/**
 * @public
 */
UCF_Token["prototype"]["unSelect"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["unSelect"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"], "Token.js(487): unSelect"); };

	if (this["bIsEditable"]() && this["bSelected"]) {
		this["bSelected"] = false;
		this["setClientProperty"]("Selected", this["bSelected"], true);
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsToken--selected');
		this["fireSelect"](this["sId"], false);
	}

	if (this["bIsFocusable"]() && window["UCF_System"]["bIsAria"]) {
		this["oDomRef"]["setAttribute"]('aria-selected', 'false');
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Token.js(500): unSelect"); };
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["unSelect"] = 0; };

/**
 * @override
 */
UCF_Token["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["createDragDelegate"]++; }; 
	if (this["sDragSourceInfo"] && !this["oDragDelegate"]) {
		this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_TokenDragDelegate"))(this["oLS"], this);
		this["addDelegate"](this["oDragDelegate"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["createDragDelegate"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if a source element
 * within the control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Token["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["onlsaccessibility"]++; }; 
	// "Token - To edit press F2. To delete press delete."
	var oAccessibilityHelper;
	var oTokenizer;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Token.js(525): onlsaccessibility"); };
	if (oBrowserEvent["oGetSourceControl"]() !== this) {
		return;
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->()', "Token.js(529): onlsaccessibility"); };

	oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	oAccessibilityHelper["setControlType"]('TOKEN');
	oAccessibilityHelper["setText"](this["sValue"]);
	oTokenizer = this["oGetParent"]();
	if (UCF_JsUtil["bInstanceOf"](oTokenizer, 'UCF_Tokenizer')) {
		oAccessibilityHelper["setItemCount"](oTokenizer["aTokens"]["length"]);
		oAccessibilityHelper["setItemIndex"](this["iIndex"] + 1);

		if (!oTokenizer["bTokenReadAccTokenTutor"]) {
			oTokenizer["bTokenReadAccTokenTutor"] = true;
			if (this["mEvents"]["Edit"] && this["mEvents"]["Edit"][0]) {
				oAccessibilityHelper["addTutor"]('TOKEN_EDIT_TUT');
			}
			if (this["mEvents"]["Delete"] && this["mEvents"]["Delete"][0]) {
				oAccessibilityHelper["addTutor"]('TOKEN_DELETE_TUT');
			}
			if (!oTokenizer["bReadAccTokenTutor"]) {
				oTokenizer["bReadAccTokenTutor"] = true;
				oAccessibilityHelper["addTutor"]('TOKENIZER_TUT');
				oAccessibilityHelper["applyLabelingInfo"](oTokenizer, '', '', '');
			}
		}
	}
	oAccessibilityHelper["setInvalid"](this["bInvalid"]);
	oAccessibilityHelper["setSelected"](this["bIsSelected"]());
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-()', "Token.js(556): onlsaccessibility"); };
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["onlsaccessibility"] = 0; };

/**
 * @override
 * @return {UCF_Control_TouchContextMenuEntry[]}
 */
UCF_Token["prototype"]["aGetTouchContextMenuEntries"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["aGetTouchContextMenuEntries"]++; }; 
	/** @type {UCF_Control_TouchContextMenuEntry[]} */
	var aResult = UCF_Control.prototype["aGetTouchContextMenuEntries"]["apply"](this, arguments);

	if (!this["bIsEditable"]()) return aResult;

	// Edit is triggered by double-click
	if (this["mEvents"]["Edit"] !== undefined) {
		var _this = this;
		aResult["push"]({
			"sType": 'DOUBLECLICK',
			"sText": this["oLS"]["sGetText"]('SAPUR_TOKEN_CX_EDIT'),
			"fTrigger": function() {
				_this["fireEdit"](_this["sId"]);
			}
		});
	}
	return aResult;
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["aGetTouchContextMenuEntries"] = 0; };

/**
 * Returns the Rectangle used for Help
 *
 * @private
 * @return {DOMRect}
 */
UCF_Token["prototype"]["oGetClientRectForHelp"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["oGetClientRectForHelp"]++; }; 
	var oDomRect = this["oDomRef"]["getBoundingClientRect"]();
	if (window["UCF_System"]["bIsRTL"]) {
		oDomRect["x"] = oDomRect["left"] - oDomRect["height"];
	} else {
		oDomRect["right"] = oDomRect["right"] + oDomRect["height"];
	}
	oDomRect["width"] = oDomRect["width"] + oDomRect["height"];
	return oDomRect;
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["oGetClientRectForHelp"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Token["prototype"]["aAttributeNames"] = ["sCustomData","sCustomStyle","sDragSourceInfo","bEnabled","bHideIcon","bInvalid","sKey","sMaxWidth","bReadOnly","bSelected","sTooltip","sTextDesign","sValue","sVisibility"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Token["prototype"]["aEventNames"] = ["Select","Delete","Edit","Drag"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Token["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_Token["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Token["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Token["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Token["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_Token["prototype"]["bHideIcon"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Token["prototype"]["bInvalid"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Token["prototype"]["sKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Token["prototype"]["sMaxWidth"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Token["prototype"]["bReadOnly"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Token["prototype"]["bSelected"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Token["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputDesign}
 */
UCF_Token["prototype"]["sTextDesign"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_Token["prototype"]["sValue"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Token["prototype"]["sVisibility"] = "VISIBLE";

//#JSCOVER_EXCL_START
/** @protected */
UCF_Token["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Token["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sDragSourceInfo"] = '';
	this["bEnabled"] = true;
	this["bHideIcon"] = false;
	this["bInvalid"] = false;
	this["sKey"] = '';
	this["sMaxWidth"] = '';
	this["bReadOnly"] = false;
	this["bSelected"] = false;
	this["sTooltip"] = '';
	this["sTextDesign"] = "STANDARD";
	this["sValue"] = '';
	this["sVisibility"] = "VISIBLE";

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("HideIcon", false, true);
		this["setClientProperty"]("Invalid", false, true);
		this["setClientProperty"]("Key", '', true);
		this["setClientProperty"]("MaxWidth", '', true);
		this["setClientProperty"]("ReadOnly", false, true);
		this["setClientProperty"]("Selected", false, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("TextDesign", "STANDARD", true);
		this["setClientProperty"]("Value", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
	}
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {boolean} bSelected The new selection state.
 * @fires Token::Select
 */
UCF_Token["prototype"]["fireSelect"] = function(sId, bSelected) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, Selected: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Token.js(753): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Token.js(754): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Token.js(755): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bSelected != null, "bSelected != null", "Token.js(756): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bSelected) == "boolean", "typeof(bSelected) == \"boolean\"", "Token.js(757): fireSelect"); };
	mParams = {
		"Id": sId,
		"Selected": bSelected
	};
	
	
	this["fireSemanticEvent"]("Token", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sEventSource The source of the delete event (MOUSE_DELETE, BACKSPACE).
 * @fires Token::Delete
 */
UCF_Token["prototype"]["fireDelete"] = function(sId, sEventSource) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["fireDelete"]++; }; 
	/** @type {{Id: string, EventSource: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Token.js(777): fireDelete"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Token.js(778): fireDelete"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Token.js(779): fireDelete"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sEventSource != null, "sEventSource != null", "Token.js(780): fireDelete"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sEventSource) == "string", "typeof(sEventSource) == \"string\"", "Token.js(781): fireDelete"); };
	mParams = {
		"Id": sId,
		"EventSource": sEventSource
	};
	
	
	this["fireSemanticEvent"]("Token", "Delete", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["fireDelete"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Token::Edit
 */
UCF_Token["prototype"]["fireEdit"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["fireEdit"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Token.js(800): fireEdit"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Token.js(801): fireEdit"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Token.js(802): fireEdit"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Token", "Edit", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["fireEdit"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires Token::Drag
 */
UCF_Token["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_Token["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Token.js(821): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Token.js(822): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Token.js(823): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "Token.js(824): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "Token.js(825): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "Token.js(826): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "Token.js(827): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("Token", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Token["_"]["fireDrag"] = 0; };

UCF_Token.prototype["aPublicMethods"] = ["setIndex","iGetIndex","bIsSelected","bHasFocus","bIsEditable","bIsFocusable","bIsInDragAndDrop","select","unSelect"].concat(UCF_Token.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TokenDragDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>
/* global UCF_Tokenizer */
/// <reference path="../Tokenizer.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_TokenDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_TokenDragDelegate["_"]["UCF_TokenDragDelegate"]++; }; 
	UCF_DragDelegate["apply"](this, [oLS]);
	this["setDragSourceControl"](oDragSourceControl);
	this["bDragAndDrop"] = false;
};window["UCF_TokenDragDelegate"] = UCF_TokenDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TokenDragDelegate"); UCF_TokenDragDelegate["_"] = {UCF_TokenDragDelegate: 0}; }; ;
UCF_TokenDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_TokenDragDelegate.prototype["sClassName"] = "UCF_TokenDragDelegate";

/**
 * @param {UCF_BrowserEvent} oBrowserEvent browser event
 * @return {UCF_HTMLGhost} the ghost
 */
UCF_TokenDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TokenDragDelegate["_"]["oGetGhost"]++; }; 
	var oTemp = document["createElement"]("DIV");

	if (this["oDragSourceControl"]["oGetParent"]() instanceof UCF_Tokenizer) {
		var aSelectedTokens = this["oDragSourceControl"]["oGetParent"]()["aGetSelectedTokens"]();
		if (aSelectedTokens["length"] > 3) {
			oTemp["appendChild"](aSelectedTokens[0]["oDomRef"]["cloneNode"](true));
			oTemp["appendChild"](aSelectedTokens[1]["oDomRef"]["cloneNode"](true));
			var oSpan = document["createElement"]("DIV");
			oSpan["style"]["display"] = "inline-block";
			oSpan["style"]["fontsize"] = "0.75em";
			oSpan["style"]["width"] = "15px";
			var oElipses = document["createTextNode"]("...");
			oSpan["appendChild"](oElipses);
			oTemp["appendChild"](oSpan);
			oTemp["appendChild"](aSelectedTokens[aSelectedTokens["length"] - 1]["oDomRef"]["cloneNode"](true));
		} else {
			for (var i = 0; i < aSelectedTokens["length"]; ++i) {
				oTemp["appendChild"](aSelectedTokens[i]["oDomRef"]["cloneNode"](true));
			}
		}
	} else {
		oTemp["appendChild"](this["oDragSourceControl"]["oDomRef"]["cloneNode"](true));
	}

	//direct cloning can cause errors because of attached events
	var oDiv = document["createElement"]("DIV");
	UCF_DomUtil["setInnerHtml"](oDiv, oTemp["innerHTML"]);

	return new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oDiv);
};;if (__UCF_COVERAGE__) { UCF_TokenDragDelegate["_"]["oGetGhost"] = 0; };

UCF_TokenDragDelegate["prototype"]["onlsdrag"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TokenDragDelegate["_"]["onlsdrag"]++; }; 
	oBrowserEvent["oDragAndDropManager"]["oDragSession"]["bShift"] = oBrowserEvent["bShift"]();
};;if (__UCF_COVERAGE__) { UCF_TokenDragDelegate["_"]["onlsdrag"] = 0; };

UCF_TokenDragDelegate["prototype"]["onlsdragstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TokenDragDelegate["_"]["onlsdragstart"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "->()", "TokenDragDelegate.js(65): onlsdragstart"); };
	this["bDragAndDrop"] = true;
	UCF_DragDelegate.prototype["onlsdragstart"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TokenDragDelegate["_"]["onlsdragstart"] = 0; };

UCF_TokenDragDelegate["prototype"]["onlsdragend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TokenDragDelegate["_"]["onlsdragend"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "->()", "TokenDragDelegate.js(71): onlsdragend"); };
	this["bDragAndDrop"] = false;
};;if (__UCF_COVERAGE__) { UCF_TokenDragDelegate["_"]["onlsdragend"] = 0; };

};
sap["ls"]["preload"]["UCF_Tokenizer"] = function() {/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global _assert, _trace, INFO, WARNING, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClipboardUtil */
/// <reference path="../../core/util/ClipboardUtil.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System  */
/// <reference path="../core/System.js"/>
/* global UCF_Token */
/// <reference path="./Token.js"/>
/* global UCF_TokenizerDropDelegate */
/// <reference path="./delegates/TokenizerDropDelegate.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>


/**
 * @typedef {Object} UCF_Tokenizer_TokenDimension
 * @property {number} iHeight
 * @property {number} iVerticalMargin
 */
/** @typedef {'NONE'|'WARNING'|'ERROR'} UCF_Tokenizer_Flavour */

/**
 * The Tokenizer control.
 * @class
 * @extends UCF_Control
 * 
 * @param {HTMLSpanElement} oDomRef The DOM reference of the control
 * @param {UCF_LS} oLS The LS instance
 */
function UCF_Tokenizer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["UCF_Tokenizer"]++; }; 
	/** @type {number} */
	var i;
	/** @type {UCF_Token} */
	var oToken;
	/** @type {Array<HTMLSpanElement>} */
	var aDomTokens;
	/** @type {number} */
	var iTmp;
	/** @type {string} */
	var sLabelledById;
	/** @type{UCF_Label} */
	var oLabel;
	/** @type {HTMLSpanElement} */
	var oTokensRef;

	UCF_Control["apply"](this, [oDomRef, oLS]);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) CONSTRUCTOR', "Tokenizer.js(71): UCF_Tokenizer"); };

	this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

	// Initialize everything for the token management
	/** @type {Array<UCF_Token>} */
	this["aTokens"] = [];
	aDomTokens = UCF_DomUtil["childNodes"](
		UCF_DomUtil["$"](this["sId"] + '-tokens'),
		'SPAN'
	);
	this["iNumLeftTokens"] = aDomTokens["length"]; // eslint-disable-line @ur/no-memory-leaks
	for (i = 0; i < aDomTokens["length"]; i++) {
		oToken = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomTokens[i], true);
		oToken["setIndex"](i);
		this["aTokens"]["push"](oToken);
		oToken["attachSemanticEvent"]('Select', this, 'onTokenSelect');
	}
	aDomTokens = UCF_DomUtil["childNodes"](
		UCF_DomUtil["$"](this["sId"] + '-righttokens'),
		'SPAN'
	);
	this["iNumRightTokens"] = aDomTokens["length"];
	for (i = 0; i < aDomTokens["length"]; i++) {
		oToken = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomTokens[i], true);
		oToken["setIndex"](this["iNumLeftTokens"] + i);
		this["aTokens"]["push"](oToken);
		oToken["attachSemanticEvent"]('Select', this, 'onTokenSelect');
	}

	// calculate lazy to avoid forced reflows
	this["iF4ButtonWidth"] = null; // eslint-disable-line @ur/no-memory-leaks

	if (window["UCF_System"]["bIsAria"]) {
		// we have to set aria-labelledby for the token-lists
		sLabelledById = this["sLabelledBy"];
		if (!sLabelledById) {
			oLabel = UCF_AriaStateHelper["oGetLabel"](this["oLS"], this["sId"]);
			if (oLabel) {
				sLabelledById = oLabel["sId"];
			}
		}
		if (sLabelledById) {
			if (this["iNumLeftTokens"] > 0) {
				oTokensRef = UCF_DomUtil["$"](this["sId"] + '-tokens');
				oTokensRef["setAttribute"]('aria-labelledby', sLabelledById);
			} else if (this["iNumRightTokens"] > 0) {
				oTokensRef = UCF_DomUtil["$"](this["sId"] + '-righttokens');
				oTokensRef["setAttribute"]('aria-labelledby', sLabelledById);
			}
		}
	}

	// Initialize ComboBox
	/** @type {HTMLElement} */
	this["oInputContainer_DomRef"] = UCF_DomUtil["$"](this["sId"] + '-inputcontainer');
	if (this["oInputContainer_DomRef"]) {
		/** @type {HTMLElement} */
		this["oComboBox_R_DomRef"] = UCF_DomUtil["$"](this["sId"] + '-input-r');

		/** @type {HTMLElement} */
		this["oComboBoxDomRef"] = UCF_DomUtil["$"](this["sId"] + '-input');

		/** @type {HTMLElement} */
		this["oF4ButtonDomRef"] = UCF_DomUtil["$"](this["sId"] + '-input-btn');

		/** @type {UCF_ComboBox|UCF_SuggestBox} */
		this["oComboBox"] = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](
			this["oComboBoxDomRef"],
			true
		);

		/** @type {HTMLElement} */
		this["oFocusDomRef"] = this["oComboBoxDomRef"];

		// attach to all relevant combobox events
		if (this["mEvents"]["Enter"]) {
			this["oComboBox"]["attachSemanticEvent"]('Enter', this, 'onComboBoxEnter');
		}
		if (this["mEvents"]["Change"]) {
			this["oComboBox"]["attachSemanticEvent"]('Change', this, 'onComboBoxChange');
		}
		if (this["mEvents"]["FieldHelpRequest"]) {
			this["oComboBox"]["attachSemanticEvent"](
				'FieldHelpPress',
				this,
				'onComboBoxFieldHelpPress'
			);
		}
		if (this["mEvents"]["ListAccess"]) {
			this["oComboBox"]["attachSemanticEvent"](
				'ListAccess',
				this,
				'onComboBoxListAccess'
			);
		}
		if (this["mEvents"]["SelectListItem"]) {
			this["oComboBox"]["attachSemanticEvent"]('Select', this, 'onComboBoxSelect');
		}
		if (this["mEvents"]["DeleteListItem"]) {
			this["oComboBox"]["attachSemanticEvent"](
				'DeleteItem',
				this,
				'onComboBoxDeleteItem'
			);
		}
		if (this["mEvents"]["ActionItemActivate"]) {
			this["oComboBox"]["attachSemanticEvent"](
				'ActionItemActivate',
				this,
				'onComboBoxActionItemActivate'
			);
		}

		UCF_DomUtil["resetTabIndex"](this["oDomRef"]);

		// some adjustments for the combobox for ARIA.
		// Note: doing this in onlsfocus() is too late due to virtual PC cursor mode!
		if (window["UCF_System"]["bIsAria"]) {
			this["oComboBoxDomRef"]["setAttribute"]('aria-roledescription', this["oLS"]["sGetText"]('SAPUR_TOKENIZER_ROLEDESCR') || 'Multi Value Input');

			// correct label-for, it has to reference the input
			oLabel = UCF_AriaStateHelper["oGetLabel"](this["oLS"], this["sId"]);
			if (oLabel) {
				oLabel["setLabelFor"](this["sId"] + '-input');
			}

			if (this["sInputState"] === 'WARNING') {
				UCF_AriaStateHelper["addDescribedby"](
					this["oComboBoxDomRef"],
					'ARIA_WARN'
				);
			}
			if (this["sInputState"] === 'ERROR') {
				this["oComboBoxDomRef"]["setAttribute"]('aria-invalid', 'true');
			}
			UCF_AriaStateHelper["addDescribedby"](
				this["oComboBoxDomRef"],
				this["sId"] + '-ariatokencount'
			);
			if (this["bRequired"]) {
				this["oComboBoxDomRef"]["setAttribute"]('aria-required', 'true');
			}
		}

		this["oComboBox"]["sHeight"] = this["sGetComboBoxHeight"]();
	} else { // !this.oInputContainer_DomRef
		// set tabindex to first (focusable) token, if available
		this["checkTokensTabIndex"]();

		if (window["UCF_System"]["bIsAria"]) {
			if (this["iNumLeftTokens"] + this["iNumRightTokens"] === 0) {
				this["oDomRef"]["setAttribute"]('aria-labelledby', sLabelledById);
			}
		}
	}

	/**
	 * @type {boolean} bCancelEnter Flag to store whether the combo box fired an
	 * enter, to cancel further processing of enter events
	 */
	this["bCancelEnter"] = false;

	/**
	 * @type {boolean} bWorkaroundIRBodyFocussing flag to ignore first lsfocus
	 * event on BODY HTML element when the DOM is rearranged for overlay-mode
	 */
	this["bWorkaroundIEBodyFocussing"] = false;

	this["bReadAccTokenTutor"] = false;
	this["bTokenReadAccTokenTutor"] = false;

	/** @type{boolean} bSelectListItemFired The tokenizer forwards the focus to
	 * one of its tokens or the combobox. This causes an additional onlsfocus or
	 * onlsblur which we have to handle
	 */
	this["bSelectListItemFired"] = false; // TODO

	if (!this["bIsFocusable"]()) {
		this["oFocusDomRef"] = null;
	}

	if (this["iMinVisibleLines"] < 1) {
		this["iMinVisibleLines"] = 1; // eslint-disable-line @ur/no-memory-leaks
		// eslint-disable-next-line quotes
		this["setClientProperty"]("MinVisibleLines", this["iMinVisibleLines"], true);
	}
	if (this["iMaxVisibleLines"] < 0) {
		// maxVisibleLines == 0 ==> no limitation
		this["iMaxVisibleLines"] = 0; // eslint-disable-line @ur/no-memory-leaks
		// eslint-disable-next-line quotes
		this["setClientProperty"]("MaxVisibleLines", this["iMaxVisibleLines"], true);
	}
	if (
		this["iMaxVisibleLines"] > 0 &&
		this["iMaxVisibleLines"] < this["iMinVisibleLines"]
	) {
		iTmp = this["iMaxVisibleLines"];
		this["iMaxVisibleLines"] = this["iMinVisibleLines"];
		this["setClientProperty"]('MaxVisibleLines', this["iMaxVisibleLines"], true);
		this["iMinVisibleLines"] = iTmp;
		this["setClientProperty"]('MinVisibleLines', this["iMinVisibleLines"], true);
	}

	if (
		UCF_UserAgent["bIsIECompatibilityMode"]() &&
		this["sOverflow"] === this["E_OVERFLOW"]["Overlay"]
	) { // no overlay mode in quirks mode
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, '(' + this["sId"] + ') No overlay mode for IE Quirks mode! Switch to push mode.', "Tokenizer.js(279): UCF_Tokenizer"); };
		this["sOverflow"] = this["E_OVERFLOW"]["Push"]; // eslint-disable-line @ur/no-memory-leaks
		this["setClientProperty"]('Overflow', this["sOverflow"], true);
	}

	this["attachContentListening"]();

	// Register for the resize event to recalculate the width of the combobox
	// and - if available - the overlay
	this["attachBrowserEvent"]('resize', this["oDomRef"]);

};window["UCF_Tokenizer"] = UCF_Tokenizer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Tokenizer"); UCF_Tokenizer["_"] = {UCF_Tokenizer: 0}; }; ;
UCF_Tokenizer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Tokenizer.prototype["sClassName"] = "UCF_Tokenizer";

/** @const {int} */
UCF_Tokenizer["MIN_COMBOBOX_WIDTH_PX"] = 150;

/** @const {string} */
UCF_Tokenizer["cFocusStyle"] = 'lsTokenizerFocus';

/** @type {Object<UCF_Tokenizer_Flavour,UCF_Tokenizer_TokenDimension>} */
UCF_Tokenizer["aTokenDimensions"] = [];

UCF_Tokenizer["prototype"]["E_OVERFLOW"] = {
	"Push": 'PUSH',
	"Overlay": 'OVERLAY'
};

/** @override */
UCF_Tokenizer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["destroy"]++; }; 
	var oBrowserWindow;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) DESTROY', "Tokenizer.js(311): destroy"); };

	// Detach from all attached events
	this["detachBrowserEvent"]('resize', this["oDomRef"]);
	oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["detachEvent"](
		oBrowserWindow["E_EVENTS"]["LayoutChange"],
		this,
		'onLayoutChange'
	);
	oBrowserWindow["detachEvent"](
		oBrowserWindow["E_EVENTS"]["AnyEvent"],
		this,
		'onAnyEvent'
	);

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	this["oTokenMore"] = null;
	this["aTokens"] = null;
	this["iNumLeftTokens"] = this["iNumRightTokens"] = 0;
	this["iInnerMinHeight"] = 0;

	// Remove overlay
	if (this["oOverlay"] && this["oOverlay"]["oPlaceHolder"]["parentNode"]) {
		this["oOverlay"]["oPlaceHolder"]["parentNode"]["replaceChild"](
			this["oDomRef"],
			this["oOverlay"]["oPlaceHolder"]
		);
		this["oOverlay"]["oPlaceHolder"] = null;
	}
	this["oOverlay"] = null;

	// Detach from ComboBox
	if (this["oComboBox"]) {
		this["oComboBox"]["detachSemanticEvent"]('Enter', this, 'onComboBoxEnter');
		this["oComboBox"]["detachSemanticEvent"]('Change', this, 'onComboBoxChange');
		this["oComboBox"]["detachSemanticEvent"](
			'FieldHelpPress',
			this,
			'onComboBoxFieldHelpPress'
		);
		this["oComboBox"]["detachSemanticEvent"](
			'ListAccess',
			this,
			'onComboBoxListAccess'
		);
		this["oComboBox"]["detachSemanticEvent"]('Select', this, 'onComboBoxSelect');
		this["oComboBox"]["detachSemanticEvent"](
			'DeleteItem',
			this,
			'onComboBoxDeleteItem'
		);
		this["oComboBox"]["detachSemanticEvent"](
			'ActionItemActivate',
			this,
			'onComboBoxActionItemActivate'
		);
	}
	this["oComboBox"] = null;
	this["oComboBoxDomRef"] = null;
	this["oComboBox_R_DomRef"] = null;
	this["oInputContainer_DomRef"] = null;
	this["oF4ButtonDomRef"] = null;
	this["oFocusDomRef"] = null;
	this["iMinComboBoxWidth"] = 0;

	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}

	this["oCache"]["destroy"]();
	this["oCache"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["destroy"] = 0; };

/** @private */
UCF_Tokenizer["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["initialize"]++; }; 
	var self = this;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' )', "Tokenizer.js(393): initialize"); };

	if (this["oComboBox"]) {
		this["oComboBox"]["updateStyles"]();
	}

	switch (this["sOverflow"]) {
		case this["E_OVERFLOW"]["Push"]:
			if (__UCF_IE6__) {
				// some corrections for IE quirks mode
				if (this["aTokens"]["length"]) { // correct margin of last token
					this["aTokens"][this["aTokens"]["length"] - 1]["oDomRef"]["style"]["marginBottom"] =
						UCF_Tokenizer["sGetComputedStyle"](
							this["aTokens"][this["aTokens"]["length"] - 1]["oDomRef"],
							'margin-top'
						);
				}
				if (this["oComboBoxDomRef"]) { // correct height of combobox
					this["oComboBoxDomRef"]["parentNode"]["parentNode"]["style"]["height"] =
						parseInt(this["sGetMinHeight"](), 10) -
						(this["iGetBorderTopWidth"]() + this["iGetBorderBottomWidth"]()) + 'px';
				}
			} else {
				this["oDomRef"]["style"]["minHeight"] = this["sGetMinHeight"]();
				if (this["iMaxVisibleLines"] > 0) {
					this["oDomRef"]["style"]["maxHeight"] = this["sGetMaxHeight"]();
				}
			}

			break;
		case this["E_OVERFLOW"]["Overlay"]:
			this["oDomRef"]["style"]["minHeight"] = this["sGetMinHeight"]();
			this["oDomRef"]["style"]["maxHeight"] = this["sGetMinHeight"]();

			break;
	}

	// Do not calculate the combobox width too soon, the width of the tokenizer
	// isn't correct otherwise...
	this["requestAnimationFrame"](function() {
		self["iMinComboBoxWidth"] = UCF_Tokenizer["MIN_COMBOBOX_WIDTH_PX"];
		if (self["oRootRef"]["offsetParent"]) { // visible?
			if (self["oInputContainer_DomRef"]) {
				self["iMinComboBoxWidth"] = Math["min"](self["iMinComboBoxWidth"], self["oDomRef"]["clientWidth"] - (self["iGetPaddingLeft"]() + self["iGetF4ButtonWidth"]()));
				self["oInputContainer_DomRef"]["style"]["minWidth"] = self["iMinComboBoxWidth"] + 'px';
			}

			self["addMore"]();

			if (self["oInputContainer_DomRef"]) {
					self["recalculateComboBoxWidth"](true);
			}
		} else if (self["oInputContainer_DomRef"]){
			self["oInputContainer_DomRef"]["style"]["minWidth"] = self["iMinComboBoxWidth"] + 'px';
		}
	}, 'onInitialize');
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["initialize"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_Tokenizer["prototype"]["bIsFocusable"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["bIsFocusable"]++; }; 
	// From the Fiori-keyboard specification:
	// Controls are in the tab chain, if they are interactive, enabled and visible.
	// This includes read-only controls.
	// Disabled or hidden controls are taken out of the tab chain.
	// Non-interactive controls (e.g.layout container) can never be reached via TAB.
	// Container which provide interaction (such as zooming or panning) are
	// included into the tab chain. 'Interactive controls' includes all controls
	// which react to at least one additional keyboard stroke besides navigation,
	// e.g. on SPACE (trigger default action), CTRL+C (copy to clipboard), etc.

	// This holds for accessibility mode ARIA!
	// The following rules apply for the old (deprecated) accessibility modes:
	// no accessibility: A Tokenizer is in the tab-chain, if it is enabled & not read-only
	// classic (508) accessibility mode: A Tokenizer is always in the tab-chain
	if (window["UCF_System"]["bIsAria"]) {
		return this["bEnabled"];
	}
	if (window["UCF_System"]["bIs508"]) {
		return true;
	}

	return !this["bReadOnly"] && this["bEnabled"];
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["bIsFocusable"] = 0; };

/**
 * @private
 * @static
 * @param {HTMLSpanElement} oDomRef  the dom element of the tokenizer
 * @param {string} sId  the ID of the tokenizer
 * @param {UCF_Tokenizer_Flavour} flavour  the flavour of the tokenizer
 * @return {UCF_Tokenizer_TokenDimension}
 */
UCF_Tokenizer["oGetTokenDimensions"] = function(oDomRef, sId, flavour) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetTokenDimensions"]++; }; 
	/** @type {HTMLSpanElement} */
	var oTestToken;
	/** @type {HTMLSpanElement} */
	var oTokensRef;

	if (!UCF_Tokenizer["aTokenDimensions"][flavour]) {
		oTestToken = UCF_Tokenizer["createToken"](sId, 'TestHeight', 'test', true);
		oTokensRef = UCF_DomUtil["$"](sId + '-tokens');
		oTokensRef["appendChild"](oTestToken);
		UCF_Tokenizer["aTokenDimensions"][flavour] = {
			"iHeight": parseInt(
				UCF_Tokenizer["sGetComputedStyle"](oDomRef, 'animation-delay'),
				10
			),
			"iVerticalMargin": parseInt(
				UCF_Tokenizer["sGetComputedStyle"](oTestToken, 'margin-top'),
				10
			)
		};
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + sId + ' ) oTokenDimensions: ' + UCF_JsUtil["sJsonStringify"](UCF_Tokenizer["aTokenDimensions"][flavour]), "Tokenizer.js(508): oGetTokenDimensions"); };
		oTokensRef["removeChild"](oTestToken);
	}

	return UCF_Tokenizer["aTokenDimensions"][flavour];
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetTokenDimensions"] = 0; };

/**
 * @private
 * @static
 * @param {string} sId
 * @param {string} sText
 * @param {string} sName
 * @param {boolean} bIcon
 * @return {UCF_Token}
 */
UCF_Tokenizer["createToken"] = function(sId, sText, sName, bIcon) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["createToken"]++; }; 
	var oTokenNode;
	var oTextNode;
	var oIconNode;

	oTokenNode = document["createElement"]('span');
	oTokenNode["id"] = sId + '-' + sName;
	UCF_DomUtil["addClass"](oTokenNode, 'lsToken');

	oTextNode = document["createElement"]('div');
	oTextNode["id"] = sId + '_' + sName + '-text';
	UCF_DomUtil["addClass"](oTextNode, 'lsToken__text');
	oTextNode["appendChild"](document["createTextNode"](sText));
	oTokenNode["appendChild"](oTextNode);

	if (bIcon) {
		UCF_DomUtil["addClass"](oTokenNode, 'lsToken--deletable');
		oIconNode = document["createElement"]('div');
		oIconNode["id"] = sId + '_' + sName + '-icon';
		UCF_DomUtil["addClass"](oIconNode, 'lsToken__icon');
		oTokenNode["appendChild"](oIconNode);
	}

	return oTokenNode;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["createToken"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Tokenizer["prototype"]["iGetPaddingLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetPaddingLeft"]++; }; 
	var self = this;

	return this["oCache"]["get"]('iPaddingLeft', function() {
		return parseInt(
			UCF_Tokenizer["sGetComputedStyle"](self["oDomRef"], 'padding-left'),
			10
		);
	});
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetPaddingLeft"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Tokenizer["prototype"]["iGetPaddingRight"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetPaddingRight"]++; }; 
	// do not cache, it changes for the opened/closed overlay-Tokenizer
	return parseInt(
		UCF_Tokenizer["sGetComputedStyle"](this["oDomRef"], 'padding-right'), 10
	);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetPaddingRight"] = 0; };

/**
 * @private
 * @return {Object}
 */
UCF_Tokenizer["prototype"]["oGetStyle"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetStyle"]++; }; 
	var self = this;

	return this["oCache"]["get"]('oComputedStyle', function() {
		return UCF_DomUtil["oGetComputedStyle"](self["oDomRef"]);
	});
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetStyle"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Tokenizer["prototype"]["iGetBorderTopWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetBorderTopWidth"]++; }; 
	var self = this;

	return this["oCache"]["get"]('iBorderTopWidth', function() {
		return parseInt(self["oGetStyle"]()["borderTopWidth"]) || 1;
	});
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetBorderTopWidth"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Tokenizer["prototype"]["iGetBorderBottomWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetBorderBottomWidth"]++; }; 
	var self = this;

	return this["oCache"]["get"]('iBorderBottomWidth', function() {
		return parseInt(self["oGetStyle"]()["borderBottomWidth"]) || 1;
	});
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetBorderBottomWidth"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_Tokenizer["prototype"]["iGetMinHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetMinHeight"]++; }; 
	var self = this;

	return this["oCache"]["get"]('iMinHeight', function() {
		var oTokenDimensions;

		if (self["iMinVisibleLines"]) {
			oTokenDimensions = UCF_Tokenizer["oGetTokenDimensions"](
				self["oDomRef"],
				self["sId"],
				self["sInputState"]
			);

			return self["iMinVisibleLines"] * oTokenDimensions["iHeight"] +
				(self["iMinVisibleLines"] + 1) * oTokenDimensions["iVerticalMargin"] +
				self["iGetBorderTopWidth"]() +
				self["iGetBorderBottomWidth"]();
		} else {
			return 0;
		}
	});
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetMinHeight"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_Tokenizer["prototype"]["sGetMinHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sGetMinHeight"]++; }; 
	return this["iGetMinHeight"]() ? this["iGetMinHeight"]() + 'px' : "";
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sGetMinHeight"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_Tokenizer["prototype"]["iGetMaxHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetMaxHeight"]++; }; 
	var self = this;

	return this["oCache"]["get"]('iMaxHeight', function() {
		var oTokenDimensions;

		if (self["iMaxVisibleLines"]) {
			oTokenDimensions = UCF_Tokenizer["oGetTokenDimensions"](
				self["oDomRef"],
				self["sId"],
				self["sInputState"]
				);

			return self["iMaxVisibleLines"] * oTokenDimensions["iHeight"] +
				(self["iMaxVisibleLines"] + 1) * oTokenDimensions["iVerticalMargin"] +
				self["iGetBorderTopWidth"]() +
				self["iGetBorderBottomWidth"]();
		} else {
			return self["iGetMinHeight"]();
		}
	});
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetMaxHeight"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_Tokenizer["prototype"]["sGetMaxHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sGetMaxHeight"]++; }; 
	return this["iGetMaxHeight"]() ? this["iGetMaxHeight"]() + 'px' : "";
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sGetMaxHeight"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Tokenizer["prototype"]["iGetInnerMinHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetInnerMinHeight"]++; }; 
	var self = this;

	return this["oCache"]["get"]('iInnerHeight', function() {
		var oTokenDimensions = UCF_Tokenizer["oGetTokenDimensions"](
			self["oDomRef"],
			self["sId"],
			self["sInputState"]
		);

		return self["iMinVisibleLines"] * oTokenDimensions["iHeight"] +
			(self["iMinVisibleLines"] + 1) * oTokenDimensions["iVerticalMargin"];
	});
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetInnerMinHeight"] = 0; };

/**
 * @private
 * @return {string}
 */
UCF_Tokenizer["prototype"]["sGetComboBoxHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sGetComboBoxHeight"]++; }; 
	var self = this;

	return this["oCache"]["get"]('sComboBoxHeight', function () {
		var oTokenDimensions = UCF_Tokenizer["oGetTokenDimensions"](
			self["oDomRef"],
			self["sId"],
			self["sInputState"]
		);

		return ((
			oTokenDimensions["iHeight"] +
			2 * oTokenDimensions["iVerticalMargin"] // eslint-disable-line no-magic-numbers
		) - (
			UCF_UserAgent["bIsTrident"]() || UCF_UserAgent["bIsEdgeHtml"]()
			? oTokenDimensions["iVerticalMargin"] + 1
			: 0
		)) + 'px';
	});
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sGetComboBoxHeight"] = 0; };

/**
 * @private
 * @return {number}
 */
UCF_Tokenizer["prototype"]["iGetF4ButtonWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetF4ButtonWidth"]++; }; 
	var oF4ButtonDomRef;

	if (this["iF4ButtonWidth"] == null) {
		oF4ButtonDomRef = this["oF4ButtonDomRef"] || UCF_DomUtil["$"](this["sId"] + '-btn');
		if (oF4ButtonDomRef) {
			if (oF4ButtonDomRef["offsetParent"]) {
				this["iF4ButtonWidth"] = oF4ButtonDomRef["offsetWidth"];
			} else {
				return 0;
			}
		} else {
			this["iF4ButtonWidth"] = 0;
		}
	}

	return this["iF4ButtonWidth"];
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetF4ButtonWidth"] = 0; };

/**
 * @protected
 * @return {HTMLSpanElement}
 */
UCF_Tokenizer["prototype"]["oGetFocusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetFocusDomRef"]++; }; 
	if (this["bIsFocusable"]()) {
		return this["oDomRef"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetFocusDomRef"] = 0; };

/**
 * @see UCF_Control.prototype.collectFocusInfo
 * @param {UCF_FocusInfo} oFocusInfo the focus info to collect to
 * @private
 */
UCF_Tokenizer["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["collectFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "Tokenizer.js(767): collectFocusInfo"); };

	oFocusInfo["setApplyControl"](this);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["collectFocusInfo"] = 0; };

/**
 * @see UCF_Control.prototype.applyFocusInfo
 * @param {UCF_FocusInfo} oFocusInfo the focus info to collect to
 * @private
 */
UCF_Tokenizer["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["applyFocusInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "Tokenizer.js(778): applyFocusInfo"); };

	this["handleFocus"](oFocusInfo["sFocussedId"], this);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["applyFocusInfo"] = 0; };

/**
 * @return {integer}
 * -1: there are no invisible tokens
 * [0 .. #tokens-1]: invisible token is returned value
 * #tokens: invisible token is the combobox
 * @private */
UCF_Tokenizer["prototype"]["iFindFirstInvisibleToken"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iFindFirstInvisibleToken"]++; }; 
	var iFirstInvisibleToken = -1;

	if (this["aTokens"]["length"] && this["aTokens"][this["aTokens"]["length"] - 1]["oDomRef"]["offsetTop"] >= this["iGetInnerMinHeight"]()){
		iFirstInvisibleToken = this["iFindFirstInvisibleToken_inner"](0, this["aTokens"]["length"] - 1);
	} else if (this["oComboBox"] && this["oComboBox_R_DomRef"]["offsetParent"]["offsetTop"] + 2 >= this["iGetInnerMinHeight"]()) {
		iFirstInvisibleToken = this["aTokens"]["length"];
	} else if (!this["oComboBox"] && this["aTokens"]["length"] === 1) {
		iFirstInvisibleToken = 1;
	}

	return iFirstInvisibleToken;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iFindFirstInvisibleToken"] = 0; };

/**
 * @param {integer} iFrom from index
 * @param {integer} iTo to index
 * @return {integer}
 * @private */
UCF_Tokenizer["prototype"]["iFindFirstInvisibleToken_inner"] = function(iFrom, iTo) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iFindFirstInvisibleToken_inner"]++; }; 
	if (iTo - iFrom > 1) {
		var iTokenizerHeight = this["iGetInnerMinHeight"]();
		var iToTest = iFrom + Math["ceil"]((iTo - iFrom) / 2);
		var iToTestOffsetTop = this["aTokens"][iToTest]["oDomRef"]["offsetTop"];

		if (iToTestOffsetTop >= iTokenizerHeight) {
			// test token in invisible area => search in front half
			return this["iFindFirstInvisibleToken_inner"](iFrom, iToTest);
		} else {
			// test token in visible area => search in rear half
			return this["iFindFirstInvisibleToken_inner"](iToTest, iTo);
		}
	} else {
		return iTo;
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iFindFirstInvisibleToken_inner"] = 0; };

/** @private */
UCF_Tokenizer["prototype"]["addMore"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["addMore"]++; }; 
	/** @type {HTMLElement} */
	var oActiveElement;
	/** @type {HTMLSpanElement} */
	var oTokensRef;
	/** @type {number} */
	var iMore;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ' )', "Tokenizer.js(835): addMore"); };

	if (!this["oRootRef"]["offsetParent"]) {
		// do not calculate "more..." token if the Tokenizer is not visible
		return;
	}

	// Step 1: Check, if 'more...' calculation has to be executed at all
	oActiveElement = UCF_DomUtil["oGetActiveElement"]();
	if (this["sOverflow"] === this["E_OVERFLOW"]["Push"] || // push mode, always all tokens visible
		this["oOverlay"] || // overlay mode, but open
		UCF_DomUtil["bContains"](this["oDomRef"], oActiveElement)) { // focus
		if (this["iNumLeftTokens"] + this["iNumRightTokens"] === 0 && this["oComboBox"]) {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTokenizer--showFakeVHButton');
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sId=' + this["sId"] + ' ) nothing to do', "Tokenizer.js(850): addMore"); };

		return;
	}

	this["removeMore"]();
	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTokenizer--showFakeVHButton');

	if (
		this["sFieldHelp"] !== 'OFF' &&
		(this["oComboBox_R_DomRef"] && this["oComboBox_R_DomRef"]["offsetParent"]["offsetTop"] + 2 >= this["iGetInnerMinHeight"]()
			|| !this["oComboBox_R_DomRef"])
	) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsTokenizer--showFakeVHButton');
	}

	var iFirstInvsibleToken = this["iFindFirstInvisibleToken"]();
	if (iFirstInvsibleToken >= 0) {
		iMore = this["aTokens"]["length"] - iFirstInvsibleToken;
		this["oTokenMore"] = UCF_Tokenizer["createToken"](this["sId"], this["sMore"](iMore), 'more', false);
		UCF_DomUtil["addClass"](this["oTokenMore"], 'lsToken--more');
		this["oTokenMore"]["style"]["maxWidth"] = (this["oDomRef"]["clientWidth"] - (this["iGetPaddingLeft"]() + this["iGetF4ButtonWidth"]())) + 'px';

		if (iFirstInvsibleToken < this["iNumLeftTokens"]) {
			// insert in (left-)tokens
			if (this["oComboBox"] && this["oComboBox"]["getEnteredText"]()) {
				this["oTokenMore"]["childNodes"][0]["childNodes"][0]["nodeValue"] = this["sMore"](++iMore);
			}
			oTokensRef = UCF_DomUtil["$"](this["sId"] + '-tokens');
			oTokensRef["insertBefore"](this["oTokenMore"], this["aTokens"][iFirstInvsibleToken]["oDomRef"]);
		} else if (iFirstInvsibleToken < this["aTokens"]["length"]) {
			// insert in righttokens
			oTokensRef = UCF_DomUtil["$"](this["sId"] + '-righttokens');
			oTokensRef["insertBefore"](this["oTokenMore"], this["aTokens"][iFirstInvsibleToken]["oDomRef"]);
		} else {
			// insert as last (left-)token
			if (this["oComboBox"] && this["oComboBox"]["getEnteredText"]()) {
				this["oTokenMore"]["childNodes"][0]["childNodes"][0]["nodeValue"] = this["sMore"](++iMore);
			}
			oTokensRef = UCF_DomUtil["$"](this["sId"] + '-tokens');
			oTokensRef["insertBefore"](this["oTokenMore"], null);

			if (this["sFieldHelp"] !== 'OFF') {
				UCF_DomUtil["addClass"](this["oDomRef"], 'lsTokenizer--showFakeVHButton');
			}
		}

		while (this["oTokenMore"]["offsetTop"] >= this["iGetInnerMinHeight"]()) {
			if (UCF_DomUtil["$"](this["sId"] + '-righttokens')["firstChild"] === this["oTokenMore"]) {
				// move from righttokens to (left-)tokens, i.e. from directly behind
				// the comboBox to directly before the comboBox
				if (this["oComboBox"] && this["oComboBox"]["getEnteredText"]()) {
					this["oTokenMore"]["childNodes"][0]["childNodes"][0]["nodeValue"] = this["sMore"](++iMore);
				}
				oTokensRef = UCF_DomUtil["$"](this["sId"] + '-tokens');
				oTokensRef["appendChild"](this["oTokenMore"]);
				if (this["sFieldHelp"] !== 'OFF') {
					UCF_DomUtil["addClass"](this["oDomRef"], 'lsTokenizer--showFakeVHButton');
				}
			} else {
				// move one token backwards (i.e. to the left)
				this["oTokenMore"]["childNodes"][0]["childNodes"][0]["nodeValue"] = this["sMore"](++iMore);
				oTokensRef["insertBefore"](this["oTokenMore"], this["oTokenMore"]["previousSibling"]);
			}
		}

		if (
			iMore === 0 ||
			iMore === 1 && this["aTokens"]["length"] === 1 && this["iNumLeftTokens"] === 1 && // exactly one token which is on the left
			(this["oComboBox"] ? !this["oComboBox"]["getEnteredText"]() : true) && // if there is a text input then it must be empty
			this["aTokens"][0]["oDomRef"]["clientWidth"] < this["oDomRef"]["clientWidth"] - (this["iGetPaddingLeft"]() + this["iGetF4ButtonWidth"]()) // first token doesn't fit in tokenizer
		) {
			this["removeMore"]();
			if (this["oComboBox_R_DomRef"] && this["oComboBox_R_DomRef"]["offsetParent"] && this["oComboBox_R_DomRef"]["offsetParent"]["offsetTop"] + 2 < this["iGetInnerMinHeight"]()) {
				UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTokenizer--showFakeVHButton');
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["addMore"] = 0; };

/**
 * @private
 * @param	{integer} i
 * @return {string}
 */
UCF_Tokenizer["prototype"]["sMore"] = function(i) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sMore"]++; }; 
	var self = this;
	return this["oCache"]["get"]('sMore', function() { return self["oLS"]["sGetText"]('SAPUR_TOKENIZER_MORE'); })["replace"]('{0}', i);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sMore"] = 0; };

/**
 * @private
 */
UCF_Tokenizer["prototype"]["removeMore"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["removeMore"]++; }; 
	if (this["oTokenMore"]) {
		this["oTokenMore"]["parentNode"]["removeChild"](this["oTokenMore"]);
		this["oTokenMore"] = null;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) "more..." removed', "Tokenizer.js(947): removeMore"); };
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["removeMore"] = 0; };

/**
 * @private
 * @return {UCF_Token[]}
 */
UCF_Tokenizer["prototype"]["aGetSelectedTokens"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["aGetSelectedTokens"]++; }; 
	var aSelectedTokens = [];
	var i;

	for (i = 0; i < this["aTokens"]["length"]; ++i) {
		if (this["aTokens"][i]["bIsSelected"]()) {
			aSelectedTokens["push"](this["aTokens"][i]);
		}
	}

	return aSelectedTokens;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["aGetSelectedTokens"] = 0; };

UCF_Tokenizer["prototype"]["iGetFocusedToken"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetFocusedToken"]++; }; 
	var i;

	for (i = 0; i < this["aTokens"]["length"]; ++i) {
		if (this["aTokens"][i]["bHasFocus"]()) {
			return i;
		}
	}

	return -1;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["iGetFocusedToken"] = 0; };

UCF_Tokenizer["prototype"]["oGetActiveToken"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetActiveToken"]++; }; 
	var i;

	for (i = 0; i < this["aTokens"]["length"]; ++i) {
		if (this["aTokens"][i]["bHasFocus"]()) {
			return this["aTokens"][i];
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetActiveToken"] = 0; };

UCF_Tokenizer["prototype"]["oGetNextFocusableToken"] = function(oFromToken) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetNextFocusableToken"]++; }; 
	var i;
	var iFromToken;

	if (!oFromToken) {
		oFromToken = this["oGetActiveToken"]();
	}
	if (oFromToken) {
		iFromToken = oFromToken["iGetIndex"]();
	} else {
		iFromToken = this["iNumLeftTokens"];
	}

	if (iFromToken < this["iNumLeftTokens"]) { // focus on a left token
		for (i = iFromToken + 1; i < this["iNumLeftTokens"]; ++i) {
			if (this["aTokens"][i]["bIsFocusable"]()) {
				return this["aTokens"][i];
			}
		}
		if (this["oComboBox"]) {
			return this["oComboBox"];
		}
	}

	if (!oFromToken) {
		iFromToken = this["iNumLeftTokens"] - 1;
	}
	for (i = iFromToken + 1; i < this["aTokens"]["length"]; ++i) {
		if (this["aTokens"][i]["bIsFocusable"]()) {
			return this["aTokens"][i];
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetNextFocusableToken"] = 0; };

UCF_Tokenizer["prototype"]["oGetPreviousFocusableToken"] = function(oFromToken) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetPreviousFocusableToken"]++; }; 
	var i;
	var iFromToken;

	if (!oFromToken) {
		oFromToken = this["oGetActiveToken"]();
	}
	if (oFromToken) {
		iFromToken = oFromToken["iGetIndex"]();
	} else {
		iFromToken = 0;
	}

	if (iFromToken >= this["iNumLeftTokens"]) {
		for (i = iFromToken - 1; i >= this["iNumLeftTokens"]; --i) {
			if (this["aTokens"][i]["bIsFocusable"]()) {
				return this["aTokens"][i];
			}
		}

		// if there are right tokens, there's definitely a combobox
		return this["oComboBox"];
	}

	if (!oFromToken) {
		iFromToken = this["iNumLeftTokens"];
	}
	for (i = iFromToken - 1; i >= 0; --i) {
		if (this["aTokens"][i]["bIsFocusable"]()) {
			return this["aTokens"][i];
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetPreviousFocusableToken"] = 0; };

UCF_Tokenizer["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tokenizer.js(1065): onlsenter"); };

	if (this["bCancelEnter"]) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		this["bCancelEnter"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onlsenter"] = 0; };

/**
 * @param { UCF_Event } oEvent
 */
UCF_Tokenizer["prototype"]["onTokenSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onTokenSelect"]++; }; 
	// a token has changed its selection state
	// -> selected:
	//    if it has the focus too:
	//    - remove focus style from tokenizer
	//    - reset tab index of all other tokens
	// -> deselected:
	//    - reset tab index of token
	//    - if there is no combobox: set tab index to first focusable token
	var oSelectedToken = this["oLS"]["oControlFactory"]["oGetControlById"](oEvent["mGetParameters"]()["Id"]);
	var i;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ' )', "Tokenizer.js(1089): onTokenSelect"); };

	if (oEvent["mGetParameters"]()["Selected"] === true) {
		UCF_DomUtil["removeClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]);
		if (oSelectedToken["bHasFocus"]()) {
			for (i = 0; i < this["aTokens"]["length"]; ++i) {
				if (this["aTokens"][i] !== oSelectedToken) {
					UCF_DomUtil["resetTabIndex"](this["aTokens"][i]["oDomRef"]);
				}
			}
		}
	} else {
		UCF_DomUtil["resetTabIndex"](oSelectedToken["oDomRef"]);
		this["checkTokensTabIndex"]();
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sId=' + this["sId"] + ' )', "Tokenizer.js(1105): onTokenSelect"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onTokenSelect"] = 0; };

/**
 * @param { UCF_Event } oEvent
 */
UCF_Tokenizer["prototype"]["onComboBoxEnter"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxEnter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "Tokenizer.js(1112): onComboBoxEnter"); };

	if (this["bSelectListItemFired"]) { // TODO
		oEvent["mParameters"]["CancelEvent"] = true;

		return;
	}
	this["fireEnter"](this["sId"]);
	oEvent["mParameters"]["CancelEvent"] = true;
	this["bCancelEnter"] = true;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxEnter"] = 0; };

/**
 * @param { UCF_Event } oEvent
 */
UCF_Tokenizer["prototype"]["onComboBoxChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxChange"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "Tokenizer.js(1128): onComboBoxChange"); };

	this["fireChange"](this["sId"], oEvent["mParameters"]["Value"]);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxChange"] = 0; };

/**
 * @param { UCF_Event } oEvent
 */
UCF_Tokenizer["prototype"]["onComboBoxFieldHelpPress"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxFieldHelpPress"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "Tokenizer.js(1137): onComboBoxFieldHelpPress"); };

	this["fireFieldHelpRequest"](this["sId"]);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxFieldHelpPress"] = 0; };

/**
 * @param { UCF_Event } oEvent
 */
UCF_Tokenizer["prototype"]["onComboBoxListAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxListAccess"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "Tokenizer.js(1146): onComboBoxListAccess"); };

	UCF_DomUtil["addClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]);
	this["fireListAccess"](
		this["sId"], oEvent["mParameters"]["ItemListBoxId"],
		oEvent["mParameters"]["FilterValue"],
		oEvent["mParameters"]["OptimalNumberOfItems"]
	);
	if (this["bHasEventListeners"]('ListAccess')) {
		oEvent["mParameters"]["CancelEvent"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxListAccess"] = 0; };

/**
 * @param { UCF_Event } oEvent
 */
UCF_Tokenizer["prototype"]["onComboBoxSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxSelect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "Tokenizer.js(1163): onComboBoxSelect"); };

	if (this["sSuggestFilter"] !== 'OFF') {
		UCF_DomUtil["setCursorPos"](this["oComboBox"]["oDomRef"], this["oComboBox"]["oDomRef"]["value"]["length"]);
	}

	this["bSelectListItemFired"] = true; // TODO
	this["fireSelectListItem"](this["sId"], oEvent["mParameters"]["Key"]);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxSelect"] = 0; };

/**
 * @param { UCF_Event } oEvent
 */
UCF_Tokenizer["prototype"]["onComboBoxDeleteItem"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxDeleteItem"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "Tokenizer.js(1177): onComboBoxDeleteItem"); };

	this["fireDeleteListItem"](this["sId"], oEvent["mParameters"]["Key"]);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxDeleteItem"] = 0; };

/**
 * @param { UCF_Event } oEvent
 */
UCF_Tokenizer["prototype"]["onComboBoxActionItemActivate"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxActionItemActivate"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "Tokenizer.js(1186): onComboBoxActionItemActivate"); };

	this["fireActionItemActivate"](this["sId"], oEvent["mParameters"]["ActionItemId"]);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onComboBoxActionItemActivate"] = 0; };

/**
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Tokenizer["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onlstabnext"]++; }; 
	var oNextSibling;
	var oNextTabbableElement;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ' )', "Tokenizer.js(1198): onlstabnext"); };

	// [TAB] on a token should
	// - deselect all tokens
	// - set the focus to the inputfield
	// - set the focus style to the tokenizer
	if (
		this["oComboBox"] &&
		UCF_JsUtil["bInstanceOf"](oBrowserEvent["oGetSourceControl"](), 'UCF_Token')
	) {
		this["deselectTokens"]();
		this["oComboBox"]["focus"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(1212): onlstabnext"); };

		return;
	}

	if (this["oOverlay"]) {
		oNextSibling = UCF_DomUtil["oGetNextSibling"](
			this["oOverlay"]["oPlaceHolder"],
			true
		);
		oNextTabbableElement = UCF_DomUtil["oGetTabbableElementForward"](
			oNextSibling,
			true
		);
		if (
			oNextTabbableElement !== this["oRootRef"] &&
			!UCF_DomUtil["bContains"](this["oRootRef"], oNextTabbableElement)
		) {
			UCF_DomUtil["moveFocusDomElement"](oNextTabbableElement, window["UCF_System"]["bIs508"]);
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(1234): onlstabnext"); };
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onlstabnext"] = 0; };

UCF_Tokenizer["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onlstabprevious"]++; }; 
	var oPreviousSibling;
	var oPreviousTabbableElement;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ' )', "Tokenizer.js(1242): onlstabprevious"); };

	// [SHIFT][TAB] on a token should
	// - deselect all tokens
	// - set the focus to the inputfield
	// - set the focus style to the tokenizer
	if (
		this["oComboBox"] &&
		UCF_JsUtil["bInstanceOf"](oBrowserEvent["oGetSourceControl"](), 'UCF_Token')
	) {
		this["deselectTokens"]();
		this["oComboBox"]["focus"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(1256): onlstabprevious"); };

		return;
	}

	oPreviousSibling = UCF_DomUtil["oGetPreviousSibling"](
		this["oOverlay"] ? this["oOverlay"]["oPlaceHolder"] : this["oDomRef"],
		true
	);
	oPreviousTabbableElement = UCF_DomUtil["oGetTabbableElementBackward"](
		oPreviousSibling,
		true
	);
	if (
		oPreviousTabbableElement !== this["oRootRef"] &&
		!UCF_DomUtil["bContains"](this["oRootRef"], oPreviousTabbableElement)
	) {
		UCF_DomUtil["moveFocusDomElement"](
			oPreviousTabbableElement,
			window["UCF_System"]["bIs508"]
		);
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- (' + this["sId"] + ' )', "Tokenizer.js(1280): onlstabprevious"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onlstabprevious"] = 0; };

/**
 * @param { UCF_Event } oEvent
 */
UCF_Tokenizer["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onLayoutChange"]++; }; 
	// the position of the Tokenizer may have changed - so we have to correct the
	// (absolute) position here. Additional width-changes will be handled in "onresize"
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["oOverlay"], "this.oOverlay", "Tokenizer.js(1289): onLayoutChange"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ' )', "Tokenizer.js(1290): onLayoutChange"); };

	if (this["oOverlay"]) {
		this["oOverlay"]["oRect"] = UCF_DomUtil["oGetObjectRect"](
			this["oOverlay"]["oPlaceHolder"],
			this["oOverlay"]["oScrollContainerRef"]
			);

		this["oDomRef"]["style"]["top"] = this["oOverlay"]["oRect"]["top"] - parseInt(
			UCF_Tokenizer["sGetComputedStyle"](this["oDomRef"], 'margin-top'),
			10
		) + 'px';
		this["oDomRef"]["style"]["left"] = this["oOverlay"]["oRect"]["left"] + 'px';
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(1305): onLayoutChange"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onLayoutChange"] = 0; };

/**
 * @param { UCF_Event } oEvent
 */
UCF_Tokenizer["prototype"]["onresize"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onresize"]++; }; 
	/** @type {UCF_Label} */
	var self = this;
	var oSourceControl = oEvent["oSourceControl"];

	// The width of the Tokenizer has changed: For
	// - an opened overlay-Tokenizer, we have to recalculate the width of the overlay
	// - a closed overlay-Tokenizer, we have to recalculate the 'n more' information
	// - all kinds of Tokenizers, we have to recalculate the width of the combobox
	// But all these calculations should be done for visible Tokenizers only,
	// they will fail otherwise!
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ' )', "Tokenizer.js(1322): onresize"); };

	if (this["oRootRef"]["offsetParent"]) {
		// execute onresize if the Tokenizer is visible only
		this["requestAnimationFrame"](function() {
			var iRemainingSpace = self["oDomRef"]["clientWidth"] - (self["iGetPaddingLeft"]() + self["iGetF4ButtonWidth"]());
			if (self["oInputContainer_DomRef"]) {
				self["iMinComboBoxWidth"] = Math["min"](UCF_Tokenizer["MIN_COMBOBOX_WIDTH_PX"], iRemainingSpace);
				self["oInputContainer_DomRef"]["style"]["minWidth"] = self["iMinComboBoxWidth"] + 'px';
			}
			if (self["oTokenMore"]){
				self["oTokenMore"]["style"]["maxWidth"] = iRemainingSpace + 'px';
			}

			if (self["oOverlay"]) {
				self["oOverlay"]["oRect"] = UCF_DomUtil["oGetObjectRect"](
					self["oOverlay"]["oPlaceHolder"],
					self["oOverlay"]["oScrollContainerRef"]
				);
				self["oDomRef"]["style"]["width"] = self["oOverlay"]["oRect"]["width"] + 'px';
				if (self["oDomRef"]["offsetHeight"] > self["oOverlay"]["oRect"]["height"]) {
					UCF_DomUtil["addClass"](self["oDomRef"], 'lsTokenizer--overlapping');
				} else {
					UCF_DomUtil["removeClass"](self["oDomRef"], 'lsTokenizer--overlapping');
				}
			} else {
				self["addMore"]();
			}

			self["recalculateComboBoxWidth"](oSourceControl === self);
		}, 'onResize');
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(1355): onresize"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onresize"] = 0; };

/**
 * @private
 * @param {boolean} fromMe `true` if the recalculation was initiated by the
 * tokenizer
 */
UCF_Tokenizer["prototype"]["recalculateComboBoxWidth"] = function(fromMe) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["recalculateComboBoxWidth"]++; }; 
	/** @type {number} */
	var iComboBoxWidth;
	/** @type {UCF_Token} */
	var oLastLeftToken;
	/** @type {string} */
	var sTmpWidth;
	/** @type {number} */
	var iTopComboBox;
	/** @type {number} */
	var iTopFirstRightToken;
	/** @type {number} */
	var iTopMore;

	if (!this["oRootRef"]["offsetParent"]) {
		// do not recalculate if the Tokenizer is not visible
		return;
	}

	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTokenizer--F4visible');
	if (this["oComboBoxDomRef"] && fromMe) {
		iTopComboBox = UCF_DomUtil["$"](this["sId"] + '-input-r')["parentNode"]["offsetTop"];
		iTopFirstRightToken = this["iNumRightTokens"] > 0 ?
			this["aTokens"][this["iNumLeftTokens"]]["oDomRef"]["offsetTop"] : -5;
		iTopMore = this["oTokenMore"] ?
			this["oTokenMore"]["offsetTop"] : iTopFirstRightToken;
		iTopFirstRightToken = Math["min"](iTopFirstRightToken, iTopMore);
		if (Math["abs"](iTopComboBox - iTopFirstRightToken) < 5) {
			this["oComboBox_R_DomRef"]["style"]["position"] = '';
			this["oComboBoxDomRef"]["style"]["width"] = this["iMinComboBoxWidth"] + 'px';

			if (UCF_UserAgent["bIsIE"]()) {
				// in IE, the minWidth on the inputcontainer restricts the width of the
				// combobox inside ?!? => force a greater minWidth on the RootRef
				this["oComboBox_R_DomRef"]["style"]["minWidth"] = this["iMinComboBoxWidth"] + 'px';
			}
		} else {
			sTmpWidth = this["oDomRef"]["style"]["width"];
			if (this["oOverlay"]) {
				this["oDomRef"]["style"]["width"] = this["oOverlay"]["oRect"]["width"] + 'px';
			}

			// Start with inner width of tokenizer
			iComboBoxWidth = this["oDomRef"]["clientWidth"];
			this["oDomRef"]["style"]["width"] = sTmpWidth;
			// Subtract width of value help button
			iComboBoxWidth -= this["iGetF4ButtonWidth"]();
			if (this["iNumLeftTokens"] > 0) {
				// Subtract width of all tokens in same line
				oLastLeftToken = this["aTokens"][this["iNumLeftTokens"] - 1];
				if (
					this["oComboBox_R_DomRef"]["parentNode"]["offsetTop"] -
					// eslint-disable-next-line no-magic-numbers
					oLastLeftToken["oDomRef"]["offsetTop"] < 5
				) {
					// eslint-disable-next-line max-depth
					if (window["UCF_System"]["bIsRTL"]) {
						iComboBoxWidth =
							oLastLeftToken["oDomRef"]["offsetLeft"] -
							(this["iGetF4ButtonWidth"]() +
								parseInt(
									UCF_Tokenizer["sGetComputedStyle"](
										oLastLeftToken["oDomRef"], 'margin-left'
									),
									10)
							);
					} else {
						iComboBoxWidth =
							iComboBoxWidth -
							(oLastLeftToken["oDomRef"]["offsetLeft"] +
								oLastLeftToken["oDomRef"]["offsetWidth"] + parseInt(
									UCF_Tokenizer["sGetComputedStyle"](
										oLastLeftToken["oDomRef"],
										'margin-right'
									),
									10)
							);
					}
				} else {
					iComboBoxWidth -= this["iGetPaddingLeft"]() + this["iGetPaddingRight"]();
				}
			} else {
				iComboBoxWidth -= this["iGetPaddingLeft"]() + this["iGetPaddingRight"]();
			}

			this["oComboBox"]["sWidth"] = this["oTokenMore"] ? this["iMinComboBoxWidth"] + 'px' : Math["max"](this["iMinComboBoxWidth"], iComboBoxWidth) + 'px';
			this["oComboBoxDomRef"]["style"]["width"] = this["oComboBox"]["sWidth"];

			if (UCF_UserAgent["bIsIE"]()) {
				// in IE, the minWidth on the inputcontainer restricts the width of the
				// combobox inside ?!? => force a greater minWidth on the RootRef
				this["oComboBox_R_DomRef"]["style"]["minWidth"] = (Math["max"](this["iMinComboBoxWidth"], iComboBoxWidth) + this["iGetF4ButtonWidth"]()) + 'px';
			}
			this["oComboBox"]["updateStyles"]();
		}
	}

	if (this["oF4ButtonDomRef"]) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsTokenizer--F4visible');
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-> ( sId=' + this["sId"] + ' ) iComboBoxWidth: ' + iComboBoxWidth, "Tokenizer.js(1464): recalculateComboBoxWidth"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["recalculateComboBoxWidth"] = 0; };

/**
 * @param { UCF_Event } oEvent
 */
UCF_Tokenizer["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onAnyEvent"]++; }; 
	var oBrowserEvent;
	var sName;
	var oSourceControl;
	var i;
	var oBrowserWindow;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "Tokenizer.js(1477): onAnyEvent"); };

	oBrowserEvent = oEvent["oGetParam"]('oBrowserEvent');
	sName = oBrowserEvent["sGetName"]();

	if (
		sName === 'mousedown' &&
		oBrowserEvent["oGetSource"]() === this["oComboBoxDomRef"]
	) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ', event=' + sName + ' )', "Tokenizer.js(1486): onAnyEvent"); };
		// combobox cancels mousedown
		this["deselectTokens"]();
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(1489): onAnyEvent"); };
		return;
	}

	if (sName === 'lstouchstart') {
		this["iTouchMoves"] = 0;
	}
	if (sName === 'lstouchmove') {
		++this["iTouchMoves"];
	}
	if (UCF_UserAgent["bIsIE"]() && this["bWorkaroundIEBodyFocussing"] === true && sName === 'lsfocus' && oBrowserEvent["oSource"]["nodeName"] === 'BODY') {
		this["bWorkaroundIEBodyFocussing"] = false;
		return;
	}
	if (sName === 'lsfocus' || (sName === 'lsfocuslost' && !oBrowserEvent["bIsTouchInteraction"]()) || sName === 'lstouchend' && this["iTouchMoves"] < 3) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ', event=' + sName + ' )', "Tokenizer.js(1504): onAnyEvent"); };
		oSourceControl =
			this["oLS"]["oGetControlByDomRef"](oBrowserEvent["oGetSourceRoot"]());
		if (
			// tokenizer itself
			oSourceControl === this ||
			// token or combobox
			(oSourceControl && oSourceControl["oGetParent"]() === this) ||
			( // suggestlist
				oSourceControl && this["oComboBox"] && this["oComboBox"]["sItemListBoxId"] &&
				oSourceControl["sId"]["indexOf"](this["oComboBox"]["sItemListBoxId"]) === 0
			)
		) {
			// lsfocus from 'inside' this tokenizer
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) INSIDE: sId: ' + this["sId"] + ', sName: ' + sName + ', sSourceId: ' + oSourceControl["sId"], "Tokenizer.js(1518): onAnyEvent"); };
		} else {
			// lsfocus from outside this tokenizer: cleanup and detach from anyEvent
			if (oSourceControl) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) OUTSIDE: sId: ' + this["sId"] + ', sName: ' + sName + ', sSourceControlId: ' + oSourceControl["sId"], "Tokenizer.js(1522): onAnyEvent"); };
			} else {
				if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) OUTSIDE: sId: ' + this["sId"] + ', sName: ' + sName + ', oSourceControl: null', "Tokenizer.js(1524): onAnyEvent"); };
				if (sName === 'lsfocus') {
					// Special handling for IE: D&D manager blurs the active control
					// (token) when drag starts.
					// There's a lsfocus event created in this case with
					// oSourceControl == null. We must not deselect the tokens in
					// this case, D&D doesn't work otherwise
					for (i = 0; i < this["aTokens"]["length"]; ++i) {
						if (this["aTokens"][i]["bIsInDragAndDrop"]()) {
							if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sId = ' + this["sId"] + ' )', "Tokenizer.js(1533): onAnyEvent"); };

							return;
						}
					}
				}
			}

			oBrowserWindow = this["oLS"]["oBrowserWindow"];
			oBrowserWindow["detachEvent"](
				oBrowserWindow["E_EVENTS"]["AnyEvent"],
				this,
				'onAnyEvent'
			);
			this["focusOut"]();
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sId=' + this["sId"] + ' )', "Tokenizer.js(1549): onAnyEvent"); };
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onAnyEvent"] = 0; };

UCF_Tokenizer["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["focus"]++; }; 
	var oFocussedElement = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](this["oFocusDomRef"], true);
	if (this !== oFocussedElement) {
		oFocussedElement["focus"]();
	} else {
		UCF_Control.prototype["focus"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["focus"] = 0; };

UCF_Tokenizer["prototype"]["handleFocus"] = function(sFocussedId, oSourceControl) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleFocus"]++; }; 
	// FF doesn't send focus events when the DOM is rearranged,
	// IE doesn't focus the combobox when the focus comes too early;
	// So for both browsers the delayed refocussing is necessary
	var bFocusDelayed = UCF_UserAgent["bIsFirefox"]() || UCF_UserAgent["bIsIE"]();
	var oFocusElement = null;
	var i;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ', sFocussedId=' + sFocussedId + ', oSourceControl=' + (oSourceControl ? oSourceControl["sId"] : 'null') + ' ) activeElement=' + (UCF_DomUtil["oGetActiveElement"]() ? UCF_DomUtil["oGetActiveElement"]()["id"] : 'null'), "Tokenizer.js(1570): handleFocus"); };

	if (!this["bIsFocusable"]()) {
		return;
	}

	UCF_DomUtil["addClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]);
	if (UCF_StringUtil["bEndsWith"](sFocussedId, '-btn')) {
		// value help button focussed: nothing to do, value help request event will be raised
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) focussed element is the value help button', "Tokenizer.js(1579): handleFocus"); };
	} else if (oSourceControl && UCF_Tokenizer["bIsToken"](oSourceControl)) {
		// token focussed: nothing to do, token will handle focus itself
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) the focussed element is a token', "Tokenizer.js(1582): handleFocus"); };
		UCF_DomUtil["removeClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]); // Remove style 'focused'
		oFocusElement = oSourceControl["oDomRef"];
	} else if (this["oComboBox"]) {
		// tokenizer focussed: if a combobox is available -> move focus to combobox
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) the combobox shall be focussed', "Tokenizer.js(1587): handleFocus"); };
		this["deselectTokens"]();
		oFocusElement = this["oComboBoxDomRef"];
	} else if (this["aTokens"]["length"] > 0) {
		// tokenizer focussed: if there's no combobox, but tokens -> focus first focusable token
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) the first token shall be focussed', "Tokenizer.js(1592): handleFocus"); };
		for (i = 0; i < this["aTokens"]["length"]; ++i) {
			if (this["aTokens"][i]["bIsSelected"]()) {
				oFocusElement = this["aTokens"][i]["oDomRef"];
			}
		}
		if (!oFocusElement) {
			this["deselectTokens"]();
			for (i = 0; i < this["aTokens"]["length"]; ++i) {
				if (this["aTokens"][i]["bIsFocusable"]()) {
					this["selectToken"](i, true);
					break;
				}
			}
		}
	} else {
		// a tokenizer without tokens and combobox???
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, '( sId=' + this["sId"] + ' ) unknown: focus tokenizer', "Tokenizer.js(1609): handleFocus"); };
		oFocusElement = this["oDomRef"];
	}

	if (oFocusElement && UCF_DomUtil["oGetActiveElement"]() !== oFocusElement) {
		this["focusDelayed"](oFocusElement, bFocusDelayed);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) element already focussed, no additional focus needed!', "Tokenizer.js(1616): handleFocus"); };
	}

	if (!this["oLS"]["oBrowserWindow"]["bIsListener"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"], this, 'onAnyEvent')) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'attach to AnyEvent', "Tokenizer.js(1620): handleFocus"); };
		this["oLS"]["oBrowserWindow"]["attachEvent"](
			this["oLS"]["oBrowserWindow"]["E_EVENTS"]["AnyEvent"],
			this,
			'onAnyEvent'
		);
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sId=' + this["sId"] + ')', "Tokenizer.js(1628): handleFocus"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleFocus"] = 0; };

UCF_Tokenizer["prototype"]["focusDelayed"] = function(oObject, bDelayed) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["focusDelayed"]++; }; 
	if (bDelayed) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'call delayed', "Tokenizer.js(1633): focusDelayed"); };
		UCF_JsUtil["delayedCall"](0, this, 'focusDelayed', [oObject, false]);
	} else {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ' ) now!', "Tokenizer.js(1636): focusDelayed"); };

		try {
			oObject["focus"]();
		} catch (oException) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, oException + ' ', "Tokenizer.js(1641): focusDelayed"); };
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sId=' + this["sId"] + ' )', "Tokenizer.js(1643): focusDelayed"); };
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["focusDelayed"] = 0; };

UCF_Tokenizer["prototype"]["focusOut"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["focusOut"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ' )', "Tokenizer.js(1648): focusOut"); };

	// Deselect all tokens
	this["deselectTokens"]();

	// Remove style 'focused'
	UCF_DomUtil["removeClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]);

	// Remove overlay in overlay-mode
	this["removeOverlay"]();

	// Reset accessibility flag to reread all accessibility information next time
	this["bReadAccTokenTutor"] = false;
	this["bTokenReadAccTokenTutor"] = false;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(1663): focusOut"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["focusOut"] = 0; };

UCF_Tokenizer["prototype"]["delayedPaste"] = function(sClipboardData, iSelectionStart, iSelectionEnd) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["delayedPaste"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ' )', "Tokenizer.js(1667): delayedPaste"); };

	try {
		this["oComboBox"]["prepareFireChange"]();
	} catch (oException) {
		this["oComboBox"]["handleEarlyHandlerLeave"](oException);
	}
	if (UCF_UserAgent["bIsMSEdge"]()) {
		// This workaround is not perfect: It sends the string pasted from
		// Edge to the inputfield (i.e. <newline>s get lost)
		sClipboardData = this["oComboBox"]["getEnteredText"]()["slice"](
			iSelectionStart,
			iSelectionEnd - sClipboardData["length"]
		);
	}
	// Standardize different representations of <CR>/<LF> for the server: Send <CR><LF> always!
	this["firePaste"](this["sId"], sClipboardData["replace"](/\r\n/g, '\r')["replace"](/\n/g, '\r')["replace"](/\r/g, '\r\n'));

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(1685): delayedPaste"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["delayedPaste"] = 0; };

UCF_Tokenizer["prototype"]["onpaste"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onpaste"]++; }; 
	var sClipboardData;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tokenizer.js(1691): onpaste"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ' )', "Tokenizer.js(1692): onpaste"); };

	if (UCF_UserAgent["bIsMSEdge"]()) {
		// Edge currently doesn't support clipboard API, see
		// https://developer.microsoft.com/en-us/microsoft-edge/
		//   platform/status/clipboardapi/
		UCF_JsUtil["delayedCall"](
			0,
			this,
			'delayedPaste', [
				this["oComboBox"]["getEnteredText"](),
				UCF_DomUtil["iGetSelectionStart"](this["oComboBoxDomRef"]),
				UCF_DomUtil["iGetSelectionEnd"](this["oComboBoxDomRef"])
			]
		);
	} else if (oBrowserEvent["oDomEvent"]["clipboardData"]) { // Chrome, FF, Safari
		UCF_JsUtil["delayedCall"](0, this, 'delayedPaste', [oBrowserEvent["oDomEvent"]["clipboardData"]["getData"]('text/plain')]);
	} else if (window["clipboardData"]) { // IE
		// IE behaves different to other browsers concerning pasting
		// values containing <newlines> ('a\nb'):
		// Whereas browsers != IE replace the <newline> by <space> and paste
		// this string, IE only pastes the first line of the string
		sClipboardData = window["clipboardData"]["getData"]('Text');
		this["oComboBox"]["setText"](UCF_StringUtil["replaceAtIndex"](this["oComboBox"]["getEnteredText"](), UCF_DomUtil["iGetSelectionStart"](this["oComboBoxDomRef"]), UCF_DomUtil["iGetSelectionEnd"](this["oComboBoxDomRef"]), sClipboardData["trim"]()["replace"](/\r\n/g, ' ')));
		UCF_JsUtil["delayedCall"](0, this, 'delayedPaste', [sClipboardData]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(1721): onpaste"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onpaste"] = 0; };

/**
 * @private
 * @param {UCF_Control} oControl the control
 * @return {boolean}
 */
UCF_Tokenizer["bIsToken"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["bIsToken"]++; }; 
	return UCF_JsUtil["bInstanceOf"](oControl, 'UCF_Token');
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["bIsToken"] = 0; };

/**
 * Handles CTRL-A: select all tokens
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_Tokenizer["prototype"]["handleCtrlA"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleCtrlA"]++; }; 
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	this["selectTokens"]();
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleCtrlA"] = 0; };

/**
 * Handles CTRL-C: copy selected tokens to clipboard
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event
 * @private
 */
UCF_Tokenizer["prototype"]["handleCtrlC"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleCtrlC"]++; }; 
	var oActiveElement = UCF_DomUtil["oGetActiveElement"]();

	if (oActiveElement && oActiveElement["getAttribute"]('ct') === 'TOKEN') {
		try {
			UCF_ClipboardUtil["copyTextToClipboard"](this["sGetClipboardData"](), this["oLS"], function(err, text) { if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, text, "Tokenizer.js(1754): handleCtrlC"); }; });
		} catch (err) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, err["message"], "Tokenizer.js(1756): handleCtrlC"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleCtrlC"] = 0; };

/**
 * Handles HOME: selects the first token
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_Tokenizer["prototype"]["handleHome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleHome"]++; }; 
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	if (oBrowserEvent["bShift"]()) {
		this["selectTokens"](0, this["iGetFocusedToken"]());
	} else {
		this["deselectTokens"]();
	}
	this["selectToken"](0, true);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleHome"] = 0; };

/**
 * Handles END: selects the last token
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_Tokenizer["prototype"]["handleEnd"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleEnd"]++; }; 
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	if (oBrowserEvent["bShift"]()) {
		this["selectTokens"](this["iGetFocusedToken"](), this["aTokens"]["length"] - 1);
	} else {
		this["deselectTokens"]();
	}
	this["selectToken"](this["aTokens"]["length"] - 1, true);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleEnd"] = 0; };

/**
 * Handles DELETE or BACKSPACE: selects the last left token
 * (if there's no text in the combobox)
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 */
UCF_Tokenizer["prototype"]["handleDelete"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleDelete"]++; }; 
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	if (!oBrowserEvent["bRepeat"]()) {
		this["selectToken"](this["iNumLeftTokens"] - 1, true);
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleDelete"] = 0; };

/**
 * Handles arrow keys:
 * ARROW_LEFT/ARROW_RIGHT/ARROW_UP/ARROW_DOWN
 *  !shift => visualisiere 'nicht selektiert', Event bubbeln lassen
 *            Tokenizer: suche nächstes Element, selektiere dieses,
 *            fokusiere dieses. Falls Combobox: setze Fokus auf Combobox
 *  shift =>  Event bubbeln lassen
 *            Tokenizer: suche nächstes Element, ... (wie oben)
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @param {number} iKeyCode the key code
 */
UCF_Tokenizer["prototype"]["handleArrowKeys"] = function(oBrowserEvent, iKeyCode) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleArrowKeys"]++; }; 
	var oPreviousFocusableToken;
	var oNextFocusableToken;
	var i;

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	if (
		iKeyCode === UCF_KeyCodes["ARROW_LEFT"] ||
		iKeyCode === UCF_KeyCodes["ARROW_UP"]
	) {
		oPreviousFocusableToken = this["oGetPreviousFocusableToken"]();

		if (this["oComboBox"] &&
			oPreviousFocusableToken === this["oComboBox"] &&
			!oBrowserEvent["bRepeat"]()
		) {
			// Transfer from first right token to combobox
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sid=' + this["sId"] + ' ) transfer focus from first right token to combobox', "Tokenizer.js(1837): handleArrowKeys"); };
			this["deselectTokens"]();
			UCF_DomUtil["addClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]);
			UCF_DomUtil["setCursorPos"](
				this["oComboBoxDomRef"],
				this["oComboBox"]["getEnteredText"]()["length"] + 1
			);
			this["oComboBox"]["focus"]();
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(1845): handleArrowKeys"); };

			return;
		} else if (
			UCF_JsUtil["bInstanceOf"](oPreviousFocusableToken, 'UCF_Token')
		) {
			this["selectToken"](oPreviousFocusableToken, true);

			if (!oBrowserEvent["bShift"]()) {
				for (i = 0; i < this["aTokens"]["length"]; i++) {
					if (!this["aTokens"][i]["bHasFocus"]()) {
						this["aTokens"][i]["unSelect"]();
					}
				}
			}
		}
	}

	if (
		iKeyCode === UCF_KeyCodes["ARROW_RIGHT"] ||
		iKeyCode === UCF_KeyCodes["ARROW_DOWN"]
	) {
		oNextFocusableToken = this["oGetNextFocusableToken"]();
		if (this["oComboBox"] &&
			oNextFocusableToken === this["oComboBox"] &&
			!oBrowserEvent["bRepeat"]()
		) {
			// Transfer from last left token to combobox
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) transfer focus from last left token to combobox', "Tokenizer.js(1873): handleArrowKeys"); };
			this["deselectTokens"]();
			UCF_DomUtil["addClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]);
			UCF_DomUtil["setCursorPos"](
				this["oComboBoxDomRef"],
				this["oComboBox"]["getEnteredText"]()["length"] + 1
			);
			this["oComboBox"]["focus"]();
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(1881): handleArrowKeys"); };

			return;

		} else if (UCF_JsUtil["bInstanceOf"](oNextFocusableToken, 'UCF_Token')) {
			this["selectToken"](oNextFocusableToken, true);
			if (!oBrowserEvent["bShift"]()) {
				for (i = 0; i < this["aTokens"]["length"]; i++) {
					if (!this["aTokens"][i]["bHasFocus"]()) {
						this["aTokens"][i]["unSelect"]();
					}
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleArrowKeys"] = 0; };

/**
 * Handles arrow key in comboBox:
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @param {number} iKeyCode the key code
 */
UCF_Tokenizer["prototype"]["handleArrowKeyInCB"] = function(oBrowserEvent, iKeyCode) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleArrowKeyInCB"]++; }; 
	var iCursorPos = UCF_DomUtil["iGetCursorPos"](this["oComboBoxDomRef"]);
	var iValueLen = this["oComboBox"]["getEnteredText"]()["length"];
	var oFocusableToken;

	// we are inside the combobox and the cursor is somewhere
	// in the middle of the text
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '( sId=' + this["sId"] + ' ) inside ComboBox: iCursorPos=' + iCursorPos + ', iValueLen=' + iValueLen + ', iNumLeftTokens=' + this["iNumLeftTokens"] + ', iNumRightTokens=' + this["iNumRightTokens"], "Tokenizer.js(1911): handleArrowKeyInCB"); };
	if (
		(
			iKeyCode === UCF_KeyCodes["ARROW_LEFT"] ||
			iKeyCode === UCF_KeyCodes["ARROW_UP"]
		) &&
		this["iNumLeftTokens"] > 0 &&
		iCursorPos === 0 &&
		!oBrowserEvent["bRepeat"]()
	) {
		// we have to close the itemlistbox, it will steal the focus when it
		// will be closed automatically by the focus change
		this["oComboBox"]["closeFieldHelp"]();
		oFocusableToken = this["oGetPreviousFocusableToken"]();
		if (oFocusableToken) {
			this["selectToken"](oFocusableToken, true);
		}
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
	if (
		(
			iKeyCode === UCF_KeyCodes["ARROW_RIGHT"] ||
			iKeyCode === UCF_KeyCodes["ARROW_DOWN"]
		) &&
		this["iNumRightTokens"] > 0 &&
		iCursorPos === iValueLen &&
		!oBrowserEvent["bRepeat"]()
	) {
		// we have to close the itemlistbox, it will steal the focus when
		// it will be closed automatically by the focus change
		this["oComboBox"]["closeFieldHelp"]();
		oFocusableToken = this["oGetNextFocusableToken"]();
		if (oFocusableToken) {
			this["selectToken"](oFocusableToken, true);
		}
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleArrowKeyInCB"] = 0; };

UCF_Tokenizer["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onkeydown"]++; }; 
	var bIsSourceToken = UCF_Tokenizer["bIsToken"](oBrowserEvent["oGetSourceControl"]());
	var iKeyCode;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tokenizer.js(1956): onkeydown"); };

	iKeyCode = oBrowserEvent["iKeyCode"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ', iKeyCode=' + iKeyCode + ')', "Tokenizer.js(1959): onkeydown"); };

	// CTRL-A pressed on a token selects all tokens
	if (
		UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["A"], 'C') &&
		bIsSourceToken
	) {
		this["handleCtrlA"](oBrowserEvent);
	}

	// CTRL-C pressed on a token copies the tokens value to the clipboard
	if (UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["C"], 'C') &&
		bIsSourceToken) {
		this["handleCtrlC"](oBrowserEvent);
	}

	// HOME selects the first token
	if (
		(UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["HOME"]) ||
			UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["HOME"], 'S')) &&
		bIsSourceToken
	) {
		this["handleHome"](oBrowserEvent);
	}

	// END selects the last token
	if (
		(UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["END"]) ||
			UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["END"], 'S')) &&
		bIsSourceToken
	) {
		this["handleEnd"](oBrowserEvent);
	}

	// BACKSPACE or DELETE selects the last left token
	// (if there's no text in the combobox)
	// (do not delete immediately, this would be very confusing for the user!!!)
	if (
		(
			iKeyCode === UCF_KeyCodes["BACKSPACE"] ||
			iKeyCode === UCF_KeyCodes["DELETE"]
		) &&
		!oBrowserEvent["bCtrl"]() &&
		!oBrowserEvent["bAlt"]() &&
		!oBrowserEvent["bShift"]() &&
		oBrowserEvent["oGetSourceControl"]() === this["oComboBox"] &&
		!this["oComboBox"]["getEnteredText"]() &&
		this["iNumLeftTokens"] > 0
	) {
		this["handleDelete"](oBrowserEvent);
	}

	// ARROW_LEFT/ARROW_RIGHT/ARROW_UP/ARROW_DOWN
	// !shift => visualisiere 'nicht selektiert', Event bubbeln lassen
	//           Tokenizer: suche nächstes Element, selektiere dieses,
	//           fokusiere dieses. Falls Combobox: setze Fokus auf Combobox
	// shift =>  Event bubbeln lassen
	//           Tokenizer: suche nächstes Element, ... (wie oben)
	if (
		iKeyCode === UCF_KeyCodes["ARROW_LEFT"] ||
		iKeyCode === UCF_KeyCodes["ARROW_UP"] ||
		iKeyCode === UCF_KeyCodes["ARROW_RIGHT"] ||
		iKeyCode === UCF_KeyCodes["ARROW_DOWN"]
	) {
		if (
			window["UCF_System"]["bIsRTL"] &&
			(
				iKeyCode === UCF_KeyCodes["ARROW_LEFT"] ||
				iKeyCode === UCF_KeyCodes["ARROW_RIGHT"]
			)
		) {
			if (iKeyCode === UCF_KeyCodes["ARROW_LEFT"]) {
				iKeyCode = UCF_KeyCodes["ARROW_RIGHT"];
			} else {
				iKeyCode = UCF_KeyCodes["ARROW_LEFT"];
			}
		}
		if (
			this["oComboBox"] &&
			oBrowserEvent["oGetSourceControl"]() === this["oComboBox"]
		) {
			this["handleArrowKeyInCB"](oBrowserEvent, iKeyCode);
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(2041): onkeydown"); };

			return;
		}
		this["handleArrowKeys"](oBrowserEvent, iKeyCode);
	}

	if (
		this["sFieldHelp"] !== 'OFF' &&
		iKeyCode === UCF_KeyCodes["F4"] &&
		!oBrowserEvent["bCtrl"]() &&
		!oBrowserEvent["bAlt"]() &&
		!oBrowserEvent["bShift"]() &&
		this["bEnabled"] &&
		!this["bReadOnly"] &&
		!oBrowserEvent["bRepeat"]()
	) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		this["fireFieldHelpRequest"](this["sId"]);
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(2063): onkeydown"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onkeydown"] = 0; };

UCF_Tokenizer["prototype"]["selectToken"] = function(oToken, bFocus) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["selectToken"]++; }; 
	if (typeof(oToken) !== "object") {
		oToken = this["aTokens"][oToken];
	}
	if (bFocus && oToken["bIsFocusable"]()) {
		UCF_DomUtil["removeClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]);
		UCF_DomUtil["resetTabIndex"](this["oDomRef"]);
		for (var i = 0; i < this["aTokens"]["length"]; ++i) {
			UCF_DomUtil["resetTabIndex"](this["aTokens"][i]["oDomRef"]);
		}
		UCF_DomUtil["setTabIndex"](oToken["oDomRef"], 0);
		UCF_DomUtil["focusDomElement"](oToken["oDomRef"]);
	}
	oToken["select"]();
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["selectToken"] = 0; };

UCF_Tokenizer["prototype"]["selectTokens"] = function(iFrom, iTo, iExcept) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["selectTokens"]++; }; 
	var i;

	if (!iFrom || iFrom < 0) {
		iFrom = 0;
	}
	if (!iTo || iTo > this["aTokens"]["length"] - 1) {
		iTo = this["aTokens"]["length"] - 1;
	}
	if (!iExcept) {
		iExcept = -1;
	}
	for (i = iFrom; i <= iTo; i++) {
		if (i !== iExcept) {
			this["selectToken"](this["aTokens"][i]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["selectTokens"] = 0; };

UCF_Tokenizer["prototype"]["deselectTokens"] = function(iFrom, iTo, iExcept) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["deselectTokens"]++; }; 
	var i;

	if (!iFrom || iFrom < 0) {
		iFrom = 0;
	}
	if (!iTo || iTo > this["aTokens"]["length"] - 1) {
		iTo = this["aTokens"]["length"] - 1;
	}
	if (!iExcept) {
		iExcept = -1;
	}
	for (i = iFrom; i <= iTo; i++) {
		if (i !== iExcept) {
			this["aTokens"][i]["unSelect"]();
			UCF_DomUtil["resetTabIndex"](this["aTokens"][i]["oDomRef"]); // read-only!
		}
	}
	if (iFrom === 0 && iTo === this["aTokens"]["length"] - 1 && iExcept < 0) {
		// all tokens deselected -> set focus style to tokenizer
		UCF_DomUtil["addClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]);
		this["checkTokensTabIndex"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["deselectTokens"] = 0; };

UCF_Tokenizer["prototype"]["checkTokensTabIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["checkTokensTabIndex"]++; }; 
	if (!this["oComboBox"] && this["bIsFocusable"]()) {
		UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
		for (var i = 0; i < this["aTokens"]["length"]; ++i) {
			if (this["aTokens"][i]["bIsFocusable"]()) {
				UCF_DomUtil["resetTabIndex"](this["oDomRef"]);
				UCF_DomUtil["setTabIndex"](this["aTokens"][i]["oDomRef"], 0);
				this["oFocusDomRef"] = this["aTokens"][i]["oDomRef"];
				break;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["checkTokensTabIndex"] = 0; };

// kein modifier =>
//   Maus:
//   Token: visualisiere 'selektiert', setze Fokus, Event bubbeln
//   Tokenizer: deselektiere die anderen Tokens  (aber erst im onmouseup,
//              damit D&D korrekt funktioniert)
//   Touch:
//   Token: toggle visualisierung 'selektiert', setze Fokus wenn
//          selektiert, Event bubbeln wenn deselektiert
//   Tokenizer: falls deselektiert: suche neues zu selektierendes Token,
//              setze Fokus, evtl Combobox fokusieren
// shift =>
//   Maus + Touch:
//   Token: visualisiere 'selektiert', setze Fokus, Event bubbeln
//   Tokenizer: selektiere noch alle weiteren im Interval
// ctrl =>
//   Maus + Touch
//   Token: toggle visualisierung 'selektiert', setze Fokus wenn
//          selektiert, Event bubbeln wenn deselektiert
//   Tokenizer: falls deselektiert: suche neues zu selektierendes Token,
//              setze Fokus, evtl Combobox fokusieren
UCF_Tokenizer["prototype"]["ontouchstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["ontouchstart"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"], "Tokenizer.js(2161): ontouchstart"); };
	if (oBrowserEvent["oGetSourceControl"]()["sClassName"] === 'UCF_Token') {
		this["handleDown"](oBrowserEvent);
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Tokenizer.js(2165): ontouchstart"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["ontouchstart"] = 0; };

UCF_Tokenizer["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onmousedown"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"], "Tokenizer.js(2169): onmousedown"); };

	if (
		!oBrowserEvent["bIsTouchInteraction"]() &&
		oBrowserEvent["oGetSourceControl"]()["sClassName"] === 'UCF_Token'
	) {
		this["handleDown"](oBrowserEvent);
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Tokenizer.js(2178): onmousedown"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onmousedown"] = 0; };

UCF_Tokenizer["prototype"]["handleDown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleDown"]++; }; 
	var i;
	var iMin;
	var iMax;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tokenizer.js(2186): handleDown"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"], "Tokenizer.js(2187): handleDown"); };

	if (!this["bIsFocusable"]()) {
		return;
	}

	if (oBrowserEvent["oGetSourceControl"]()["sClassName"] === 'UCF_Tokenizer') {
		UCF_DomUtil["addClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]);
	}

	if (oBrowserEvent["bShift"]()) {
		for (i = 0, iMin = -1, iMax = -1; i < this["aTokens"]["length"]; i++) {
			if (this["aTokens"][i]["bIsSelected"]()) {
				iMax = i;
				if (iMin === -1) {
					iMin = i;
				}
			}
		}
		this["selectTokens"](iMin, iMax);
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Tokenizer.js(2207): handleDown"); };

		return;
	}

	if (oBrowserEvent["bCtrl"]()) {
		if (oBrowserEvent["oGetData"]()["oToken"]["bIsSelected"]() === false) {
			// The token was deselected: Try to find a selected token and set
			// the focus on it; focus the combobox otherwise
			for (i = 0; i < this["aTokens"]["length"]; i++) {
				if (this["aTokens"][i]["bIsSelected"]()) {
					this["selectToken"](i, true);

					return;
				}
			}
			this["focus"]();
		}
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Tokenizer.js(2225): handleDown"); };

		return;
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Tokenizer.js(2229): handleDown"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleDown"] = 0; };

UCF_Tokenizer["prototype"]["ontouchend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["ontouchend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tokenizer.js(2233): ontouchend"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"], "Tokenizer.js(2234): ontouchend"); };

	if (oBrowserEvent["oGetSourceControl"]()["sClassName"] === 'UCF_Token') {
		this["handleUp"](oBrowserEvent);
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Tokenizer.js(2239): ontouchend"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["ontouchend"] = 0; };

UCF_Tokenizer["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onmouseup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tokenizer.js(2243): onmouseup"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"], "Tokenizer.js(2244): onmouseup"); };

	if (this["bEnabled"] && oBrowserEvent["oSource"]["id"] === this["sId"] + '-btn') {
		this["fireFieldHelpRequest"](this["sId"]);

		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}

	if (
		!oBrowserEvent["bIsTouchInteraction"]() &&
		oBrowserEvent["oGetSourceControl"]()["sClassName"] === 'UCF_Token'
	) {
		this["handleUp"](oBrowserEvent);
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Tokenizer.js(2259): onmouseup"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onmouseup"] = 0; };

UCF_Tokenizer["prototype"]["handleUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleUp"]++; }; 
	var i;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '->() sId: ' + this["sId"], "Tokenizer.js(2265): handleUp"); };

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

	if (!(
			oBrowserEvent["bShift"]() ||
			oBrowserEvent["bCtrl"]() ||
			oBrowserEvent["bIsTouchInteraction"]()
		))
		for (i = 0; i < this["aTokens"]["length"]; i++) {
			if (
				oBrowserEvent["oGetData"]()["oToken"] &&
				i !== oBrowserEvent["oGetData"]()["oToken"]["iGetIndex"]()
			) {
				this["aTokens"][i]["unSelect"]();
			}
		}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<-() sId: ' + this["sId"], "Tokenizer.js(2284): handleUp"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["handleUp"] = 0; };

UCF_Tokenizer["prototype"]["sGetClipboardData"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sGetClipboardData"]++; }; 
	var sClipboardData = '';
	var sSpace = '';
	var i;

	for (i = 0; i < this["aTokens"]["length"]; i++) {
		if (this["aTokens"][i]["bIsSelected"]()) {
			if (this["aTokens"][i]["sKey"]) {
				sClipboardData += sSpace + this["aTokens"][i]["sKey"];
			} else {
				sClipboardData += sSpace + this["aTokens"][i]["sValue"];
			}
			sSpace = ' ';
		}
	}

	return sClipboardData;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sGetClipboardData"] = 0; };

UCF_Tokenizer["prototype"]["selectElementContents"] = function(oElement) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["selectElementContents"]++; }; 
	var oSelectionRange;
	var oRange;
	var textRange;

	if (window["getSelection"] && document["createRange"]) {
		oSelectionRange = window["getSelection"]();
		oSelectionRange["removeAllRanges"]();
		oRange = document["createRange"]();
		oRange["selectNodeContents"](oElement);
		oSelectionRange["addRange"](oRange);
	} else if (document["selection"] && document["body"]["createTextRange"]) {
		textRange = document["body"]["createTextRange"]();
		textRange["moveToElementText"](oElement);
		textRange["select"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["selectElementContents"] = 0; };

UCF_Tokenizer["prototype"]["bAnyTokenSelected"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["bAnyTokenSelected"]++; }; 
	var i;

	for (i = 0; i < this["aTokens"]["length"]; i++) {
		if (this["aTokens"][i]["bIsSelected"]()) {
			return true;
		}
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["bAnyTokenSelected"] = 0; };

/**
 * Sets the ItemListBox for the suggest
 * @param {string} sItemListBoxId the ID of the ItemListBox
 * @public
 */
UCF_Tokenizer["prototype"]["setItemListBoxId"] = function(sItemListBoxId) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["setItemListBoxId"]++; }; 
	if (this["oComboBox"]) {
		this["oComboBox"]["setItemListBoxId"](sItemListBoxId);
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["setItemListBoxId"] = 0; };

/**
 * Sets the suggest filter algorithm to use.
 * @param {string} sFilter the filter to use
 * @public
 */
UCF_Tokenizer["prototype"]["setSuggestFilterCondition"] = function(sFilter) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["setSuggestFilterCondition"]++; }; 
	if (this["oComboBox"]) {
		this["oComboBox"]["setSuggestFilterCondition"](sFilter);
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["setSuggestFilterCondition"] = 0; };

/**
 * Delete a Token from the Tokenizer
 * @param {integer} sId the ID of the token to be deleted
 * @public
 */
UCF_Tokenizer["prototype"]["deleteToken"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["deleteToken"]++; }; 
	/** @type {integer} */
	var i;

	for (i = 0; i < this["aTokens"]["length"]; i++) {
		if (this["aTokens"][i]["sId"] === sId) {
			UCF_DomUtil["removeFromDom"](this["aTokens"][i]["oDomRef"]);
			this["aTokens"][i]["destroy"]();

			if (i < this["iNumLeftTokens"]) {
				this["iNumLeftTokens"]--;
			} else {
				this["iNumRightTokens"]--;
			}

			this["aTokens"]["splice"](i, 1);
			if (i < this["aTokens"]["length"]) {
				this["aTokens"][i]["setIndex"](i);
			}
		} else {
			this["aTokens"][i]["setIndex"](i);
		}
	}

	this["checkTokensTabIndex"]();

	this["addMore"]();
	this["recalculateComboBoxWidth"](true);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["deleteToken"] = 0; };

/**
 * Opens the itemListBox (the suggest items). Use this function if you want to
 * open the itemListBox after a server round trip.
 * @public
 */
UCF_Tokenizer["prototype"]["open"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["open"]++; }; 
	if (this["oComboBox"]) {
		if (this["oComboBox"]["getListBox"]()) {
			this["oComboBox"]["oFieldHelp"]["attachEvent"](
				this["oComboBox"]["oFieldHelp"]["E_EVENTS"]["FocusChange"],
				this,
				'onListBoxFocusChange'
			);
		}
		this["oComboBox"]["open"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["open"] = 0; };

/**
 * implements method from UCF_Control
 */
UCF_Tokenizer["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["createDropDelegate"]++; }; 
	if (!this["sDropTargetInfo"] || this["oDropDelegate"]) {
		return;
	}

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_TokenizerDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["createDropDelegate"] = 0; };

/**
 * remove unnecessary attributes from the DOM
 * @param {HTMLElement} oDomElement
 */
UCF_Tokenizer["deleteUnwantedAttributes"] = function(oDomElement) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["deleteUnwantedAttributes"]++; }; 
	if (UCF_DomUtil["bHasClass"](oDomElement, 'lsField')) {
		UCF_DomUtil["removeFromDom"](oDomElement);
	} else {
		var attributes = oDomElement["attributes"];
		for (var i = attributes["length"] - 1; i >= 0; i--) {
			var attributeName = attributes[i]["name"];
			if (attributeName !== 'class' && attributeName !== 'style') {
				oDomElement["removeAttribute"](attributeName);
			}
		}
		oDomElement["setAttribute"]('aria-hidden', true);
		UCF_JsUtil["forEach"](oDomElement["children"], function(oChildElement) {
			UCF_Tokenizer["deleteUnwantedAttributes"](oChildElement);
		});
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["deleteUnwantedAttributes"] = 0; };

UCF_Tokenizer["prototype"]["createOverlay"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["createOverlay"]++; }; 
	var oParentScrollAreaDomRef;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ')', "Tokenizer.js(2448): createOverlay"); };
	if (
		this["sOverflow"] !== this["E_OVERFLOW"]["Overlay"] ||
		this["oOverlay"] ||
		!this["bIsFocusable"]()
	) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sId=' + this["sId"] + ' ) no overlay mode or overlay already available: nothing to do', "Tokenizer.js(2454): createOverlay"); };

		return false;
	} else {
		// Find the first embedding scroll container (or null)
		// There are lots of possibilities to get the next embedding scrollcontainer:
		// this.oGetParentScrollAreaDomRef(),
		// UCF_DomUtil.oGetParentScrollContainer(),
		// UCF_DomUtil.oGetParentPositionReferenceContainer(), ...
		oParentScrollAreaDomRef = this["oGetParentScrollAreaDomRef"]();

		// Create a placeholder for the Tokenizer HTML
		this["oOverlay"] = {
			"oPlaceHolder": this["oDomRef"]["cloneNode"](true),
			"oScrollContainerRef": oParentScrollAreaDomRef,
			// Get the object rect from the tokenizer to get the correct coordinates to
			// position the overlay
			// If there's no scroll container, oParentScrollAreaDomRef is null and the
			// function returns the correct rect too!
			"oRect": UCF_DomUtil["oGetObjectRect"](this["oDomRef"], oParentScrollAreaDomRef)
		};

		UCF_Tokenizer["deleteUnwantedAttributes"](this["oOverlay"]["oPlaceHolder"]);
		this["oOverlay"]["oPlaceHolder"]["style"]["visibility"] = 'hidden';
		this["oOverlay"]["oPlaceHolder"]["setAttribute"]('id', this["sId"] + '-ph');
		this["oOverlay"]["oPlaceHolder"]["removeAttribute"]('aria-hidden');
		this["oOverlay"]["oPlaceHolder"]["setAttribute"]('aria-owns', this["sId"]);

		// Temporary detach from resize events, because the following
		// DOM operations create unwanted resize events
		this["detachBrowserEvent"]('resize', this["oDomRef"]);

		// Insert the placeholder at the same position in DOM as the tokenizer
		this["oDomRef"]["parentNode"]["insertBefore"](
			this["oOverlay"]["oPlaceHolder"],
			this["oDomRef"]
		);

		// Create a 'layered element' in the scroll container or (if no
		// scroll container available) in the assoc area
		UCF_DomUtil["oAddLayeredElement"](
			this["oDomRef"],
			this["oLS"]["oGetAssociatedAreaRef"](),
			this["oOverlay"]["oScrollContainerRef"],
			false
		);

		this["removeMore"]();
		if (this["oComboBoxDomRef"]) {
			// if there is a combobox, its value help button will bis displayed now
			// but for tokenizers without input, the value help button still has to be displayed
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTokenizer--showFakeVHButton');
		}

		this["oDomRef"]["style"]["left"] = this["oOverlay"]["oRect"]["left"] + 'px';
		this["oDomRef"]["style"]["width"] = this["oOverlay"]["oRect"]["width"] + 'px';
		this["oDomRef"]["style"]["height"] = 'auto';
		this["oDomRef"]["style"]["minHeight"] = this["sGetMinHeight"]();
		if (this["iMaxVisibleLines"] > 0) {
			this["oDomRef"]["style"]["maxHeight"] = this["sGetMaxHeight"]();
			this["oDomRef"]["style"]["overflowY"] = 'auto';
		} else {
			this["oDomRef"]["style"]["maxHeight"] = "";
		}
		this["oDomRef"]["style"]["zIndex"] = UCF_LS["E_LAYERS"]["CONTROLS"];

		if (!oParentScrollAreaDomRef || this["iGetMaxHeight"]() <= UCF_DomUtil["oGetObjectRect"](oParentScrollAreaDomRef || this["oLS"]["oRootRef"])["height"] - this["oOverlay"]["oRect"]["top"]) {
			// open downwards
			this["oDomRef"]["style"]["top"] = this["oOverlay"]["oRect"]["top"] - parseInt(
				UCF_Tokenizer["sGetComputedStyle"](this["oDomRef"], 'margin-top'), 10
			) + 'px';
		} else if (this["iGetMaxHeight"]() <= this["oOverlay"]["oRect"]["top"] + this["oOverlay"]["oRect"]["height"]) {
			// open upwards
			this["oDomRef"]["style"]["bottom"] = -1 * this["oOverlay"]["oRect"]["top"] - this["oOverlay"]["oRect"]["height"] - parseInt(
				UCF_Tokenizer["sGetComputedStyle"](this["oDomRef"], 'margin-top'), 10
				) + 'px';
			this["oDomRef"]["style"]["top"] = '';
		} else {
			// open downwards, but adjust max height
			this["oDomRef"]["style"]["maxHeight"] = (UCF_DomUtil["oGetObjectRect"](oParentScrollAreaDomRef || this["oLS"]["oRootRef"])["height"] - this["oOverlay"]["oRect"]["top"]) + 'px';
			this["oDomRef"]["style"]["top"] = this["oOverlay"]["oRect"]["top"] - parseInt(
				UCF_Tokenizer["sGetComputedStyle"](this["oDomRef"], 'margin-top'), 10
			) + 'px';
		}

		// Attach to resize events again (see above)
		this["attachBrowserEvent"]('resize', this["oOverlay"]["oPlaceHolder"]);

		// attach to layout change events: we have to reposition the overlay
		this["oLS"]["oBrowserWindow"]["attachEvent"](
			this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"],
			this,
			'onLayoutChange'
		);
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ')', "Tokenizer.js(2548): createOverlay"); };

		return true;
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["createOverlay"] = 0; };

UCF_Tokenizer["sGetComputedStyle"] = function(oDomRef, sStyleAttribute) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sGetComputedStyle"]++; }; 
	var style;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef, "oDomRef", "Tokenizer.js(2557): sGetComputedStyle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof sStyleAttribute === 'string', "typeof sStyleAttribute === 'string'", "Tokenizer.js(2558): sGetComputedStyle"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sStyleAttribute !== '', "sStyleAttribute !== ''", "Tokenizer.js(2559): sGetComputedStyle"); };

	style = (
		typeof window["getComputedStyle"] === 'function' &&
		window["getComputedStyle"](oDomRef)
	) || oDomRef["currentStyle"];
	if (style[sStyleAttribute] === 'auto') {
		return '0';
	}

	return style[sStyleAttribute];
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["sGetComputedStyle"] = 0; };

UCF_Tokenizer["prototype"]["removeOverlay"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["removeOverlay"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ' )', "Tokenizer.js(2573): removeOverlay"); };
	if (!this["oOverlay"] || !this["oOverlay"]["oPlaceHolder"]["parentNode"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sId=' + this["sId"] + ' ) no overlay: nothing to do', "Tokenizer.js(2575): removeOverlay"); };

		return;
	}

	// no repositioning necessary any longer
	var oBrowserWindow = this["oLS"]["oBrowserWindow"];
	oBrowserWindow["detachEvent"](
		oBrowserWindow["E_EVENTS"]["LayoutChange"],
		this,
		'onLayoutChange'
	);

	// Temporary detach from resize events, because the following DOM operations
	// create unwanted resize events
	this["detachBrowserEvent"]('resize', this["oOverlay"]["oPlaceHolder"]);

	// Replace placeholder by original (Tokenizer-) control
	this["oOverlay"]["oPlaceHolder"]["parentNode"]["replaceChild"](
		this["oDomRef"],
		this["oOverlay"]["oPlaceHolder"]
	);
	// IE: activeElement == null; Chrome: activeElement == body
	this["oOverlay"] = null;

	// Attach to resize events again (see above)
	this["attachBrowserEvent"]('resize', this["oDomRef"]);

	// Restore original styles of tokenizer
	this["oDomRef"]["style"]["height"] = '';
	this["oDomRef"]["style"]["minHeight"] = this["sGetMinHeight"]();
	this["oDomRef"]["style"]["maxHeight"] = this["sGetMinHeight"]();
	this["oDomRef"]["style"]["width"] = this["sWidth"] !== '100%' ? this["sWidth"] : '';
	this["oDomRef"]["style"]["zIndex"] = '';
	this["oDomRef"]["style"]["position"] = ''; // UCF_DomUtil.oAddLayeredElement() sets this to position:absolute!
	this["oDomRef"]["style"]["overflowY"] = '';
	UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTokenizer--overlapping');
	this["oDomRef"]["style"]["boxShadow"] = '';
	this["oDomRef"]["style"]["bottom"] = '';
	this["oDomRef"]["style"]["top"] = '';
	this["oDomRef"]["style"]["left"] = '';
	this["oDomRef"]["scrollTop"] = 0;

	this["addMore"]();
	this["recalculateComboBoxWidth"](true);

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sid=' + this["sId"] + ' )', "Tokenizer.js(2621): removeOverlay"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["removeOverlay"] = 0; };

/*
 * Checks if the control has a valid DOM reference.
 * This can be used for timeout methods, that may be called after the HTML
 * of the control has already been removed.
 *
 * @return {boolean} Whether the control has a valid DOM reference
 */
UCF_Tokenizer["prototype"]["bIsValid"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["bIsValid"]++; }; 
	var oDomRef;

	if (this["oOverlay"]) {
		oDomRef = UCF_DomUtil["$"](this["sId"] + '-ph');

		return (oDomRef != null && oDomRef === this["oOverlay"]["oPlaceHolder"]);
	} else {
		return UCF_Control.prototype["bIsValid"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["bIsValid"] = 0; };

/**
 * Returns the value of the Tokenizer
 *
 * @return {string} actual value of this tokenizer
 * @public
 */
UCF_Tokenizer["prototype"]["getText"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["getText"]++; }; 
	if (this["oComboBox"]) {
		return this["oComboBox"]["getText"]();
	} else {
		return '';
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["getText"] = 0; };

/**
 * Set selection
 *
 * @see UCF_DomUtil.setSelection
 * @param {number} iStart position of the start of the selection
 * @param {number} iEnd position of the end of the selection
 * @public
 */
UCF_Tokenizer["prototype"]["setSelection"] = function(iStart, iEnd) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["setSelection"]++; }; 
	if (this["oComboBox"]) {
		this["oComboBox"]["setSelection"](iStart, iEnd);
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["setSelection"] = 0; };

/**
 * Set cursor position
 *
 * @public
 * @param {number} iPos the position where the cursor should be set
 */
UCF_Tokenizer["prototype"]["setCursorPosition"] = function(iPos) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["setCursorPosition"]++; }; 
	if (this["oComboBox"]) {
		this["oComboBox"]["setCursorPosition"](iPos);
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["setCursorPosition"] = 0; };

/**
 * @param {UCF_Event} oEvent
 */
UCF_Tokenizer["prototype"]["onListBoxFocusChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onListBoxFocusChange"]++; }; 
	if (oEvent["mGetParameters"]()["oNewItem"]) {
		// Remove style 'focused' from input field
		UCF_DomUtil["removeClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]);
	} else {
		UCF_DomUtil["addClass"](this["oDomRef"], UCF_Tokenizer["cFocusStyle"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onListBoxFocusChange"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element
 * within the control gets the focus.
 *
 * @param { UCF_BrowserEvent } oBrowserEvent
 *            oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tokenizer["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onlsaccessibility"]++; }; 
	// 'Tokenizer w\o Tokens: 'Tokenizer - Type a text'
	// 'Tokenizer with Tokens: 'Tokenizer - Hugo, Otto, Seppl - 3 tokens -
	// To navigate use left and right arrow keys.'
	var sText;
	var oAccessibilityHelper;
	var i;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tokenizer.js(2711): onlsaccessibility"); };
	if (
		oBrowserEvent["oGetSourceControl"]() !== this &&
		oBrowserEvent["oGetSourceControl"]() !== this["oComboBox"]
	) {
		return;
	};

	sText = '';
	oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	oAccessibilityHelper["setControlType"]('TOKENIZER');

	oAccessibilityHelper["applyLabelingInfo"](
		this,
		'',
		this["sLabelText"],
		this["sInputPrompt"]
	);
	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setReadonly"](this["bReadOnly"] || this["bDisplayOnly"]);
	oAccessibilityHelper["setRequired"](this["bRequired"]);
	if (this["aTokens"]["length"] > 0) {
		// 'n tokens'
		oAccessibilityHelper["setCustomStatusText"]('TOKENS', [this["aTokens"]["length"]]);
		sText += ' ';
		for (i = 0; i < this["aTokens"]["length"]; ++i) {
			if (i !== 0) {
				sText += ', ';
			}
			sText += this["aTokens"][i]["sValue"];
		}
		if (!this["bReadAccTokenTutor"]) {
			this["bReadAccTokenTutor"] = true;
			oAccessibilityHelper["addEnabledTutor"](
				'TOKENIZER_TUT',
				this["bEnabled"] && !this["bReadOnly"]
			); // 'To navigate use left and right arrow keys.'
		}
	}
	if (this["oComboBox"] && this["oComboBox"]["getEnteredText"]()) {
		sText += ' ' + this["oComboBox"]["getEnteredText"]();
	}

	oAccessibilityHelper["setText"](sText);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onlsaccessibility"] = 0; };

/**
 * Provide internal stuff for QUnit test recording and playback
 * @private
 * @return {Object} o test data
 */
UCF_Tokenizer["prototype"]["oGetTestData"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetTestData"]++; }; 
	var o;

	o = UCF_Control.prototype["oGetTestData"]["apply"](this, arguments);
	o["internals"]["HasOverlay"] = (this["oOverlay"] == null) ? 'false' : 'true';

	return o;
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["oGetTestData"] = 0; };

/**
 * Attaches/activates the event capturing
 * @private
 */
UCF_Tokenizer["prototype"]["attachContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["attachContentListening"]++; }; 
	this["oLS"]["attachCaptureEvent"]('lsfocus', this, "onLsFocusCapture");
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["attachContentListening"] = 0; };

/**
 * detaches/deactivates the event capturing
 * @private
 */
UCF_Tokenizer["prototype"]["detachContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["detachContentListening"]++; }; 
	this["oLS"]["detachCaptureEvent"]('lsfocus', this);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["detachContentListening"] = 0; };

/**
 * Processes the captured events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Tokenizer["prototype"]["onLsFocusCapture"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onLsFocusCapture"]++; }; 
	var oActiveElement = UCF_DomUtil["oGetActiveElement"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tokenizer.js(2796): onLsFocusCapture"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '-> ( sId=' + this["sId"] + ')', "Tokenizer.js(2797): onLsFocusCapture"); };

	if (!UCF_StringUtil["bEndsWith"](oActiveElement["id"], '-btn')) {
		var bOverlayCreated = this["createOverlay"]();
		if (this["oOverlay"] && this["oDomRef"]["offsetHeight"] > this["oOverlay"]["oRect"]["height"]) {
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsTokenizer--overlapping');
		} else {
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTokenizer--overlapping');
		}

		this["recalculateComboBoxWidth"](true);

		this["detachContentListening"]();
		this["handleFocus"]('', oBrowserEvent["oSourceControl"]);
		this["attachContentListening"]();
		if (bOverlayCreated) {
			if (UCF_UserAgent["bIsIE"]()) {
				this["bWorkaroundIEBodyFocussing"] = true;
			}
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	}

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '<- ( sId=' + this["sId"] + ')', "Tokenizer.js(2821): onLsFocusCapture"); };
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["onLsFocusCapture"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Tokenizer["prototype"]["aAttributeNames"] = ["sId","sAccessKey","sCustomData","sCustomStyle","bDisplayOnly","sDropTargetInfo","bEnabled","sFieldHelp","sInputPrompt","sInputState","sItemListBoxId","sLabelText","iMaxInputLength","sMaxInputWidth","iMaxVisibleLines","iMinVisibleLines","bNoInput","sOverflow","bReadOnly","bRequired","sSuggest","sTextDesign","sTooltip","sValue","sVisibility","sWidth","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Tokenizer["prototype"]["aEventNames"] = ["Change","Enter","FieldHelpRequest","ListAccess","SelectListItem","DeleteListItem","ActionItemActivate","Paste","Drop"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Tokenizer["prototype"]["aMethodNames"] = ["open","setItemListBoxId","setSuggestFilterCondition","getText","setSelection","setCursorPosition","deleteToken","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Tokenizer["prototype"]["bDisplayOnly"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Tokenizer["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TokenizerFieldHelp}
 */
UCF_Tokenizer["prototype"]["sFieldHelp"] = "OFF";

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sInputPrompt"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputState}
 */
UCF_Tokenizer["prototype"]["sInputState"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sItemListBoxId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sLabelText"] = '';

/**
 * @private
 * @type {number}
 */
UCF_Tokenizer["prototype"]["iMaxInputLength"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sMaxInputWidth"] = '';

/**
 * @private
 * @type {number}
 */
UCF_Tokenizer["prototype"]["iMaxVisibleLines"] = 5;

/**
 * @private
 * @type {number}
 */
UCF_Tokenizer["prototype"]["iMinVisibleLines"] = 1;

/**
 * @private
 * @type {boolean}
 */
UCF_Tokenizer["prototype"]["bNoInput"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TokenizerOverflow}
 */
UCF_Tokenizer["prototype"]["sOverflow"] = "PUSH";

/**
 * @private
 * @type {boolean}
 */
UCF_Tokenizer["prototype"]["bReadOnly"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Tokenizer["prototype"]["bRequired"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TokenizerSuggest}
 */
UCF_Tokenizer["prototype"]["sSuggest"] = "OFF";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputDesign}
 */
UCF_Tokenizer["prototype"]["sTextDesign"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sValue"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Tokenizer["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tokenizer["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Tokenizer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sAccessKey"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["bDisplayOnly"] = false;
	this["sDropTargetInfo"] = '';
	this["bEnabled"] = true;
	this["sFieldHelp"] = "OFF";
	this["sInputPrompt"] = '';
	this["sInputState"] = "NONE";
	this["sItemListBoxId"] = '';
	this["sLabelText"] = '';
	this["iMaxInputLength"] = 0;
	this["sMaxInputWidth"] = '';
	this["iMaxVisibleLines"] = 5;
	this["iMinVisibleLines"] = 1;
	this["bNoInput"] = false;
	this["sOverflow"] = "PUSH";
	this["bReadOnly"] = false;
	this["bRequired"] = false;
	this["sSuggest"] = "OFF";
	this["sTextDesign"] = "STANDARD";
	this["sTooltip"] = '';
	this["sValue"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sWidth"] = '';
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("DisplayOnly", false, true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("FieldHelp", "OFF", true);
		this["setClientProperty"]("InputPrompt", '', true);
		this["setClientProperty"]("InputState", "NONE", true);
		this["setClientProperty"]("ItemListBoxId", '', true);
		this["setClientProperty"]("LabelText", '', true);
		this["setClientProperty"]("MaxInputLength", 0, true);
		this["setClientProperty"]("MaxInputWidth", '', true);
		this["setClientProperty"]("MaxVisibleLines", 5, true);
		this["setClientProperty"]("MinVisibleLines", 1, true);
		this["setClientProperty"]("NoInput", false, true);
		this["setClientProperty"]("Overflow", "PUSH", true);
		this["setClientProperty"]("ReadOnly", false, true);
		this["setClientProperty"]("Required", false, true);
		this["setClientProperty"]("Suggest", "OFF", true);
		this["setClientProperty"]("TextDesign", "STANDARD", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Value", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue The entered value
 * @fires Tokenizer::Change
 */
UCF_Tokenizer["prototype"]["fireChange"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireChange"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Tokenizer.js(3080): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tokenizer.js(3081): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tokenizer.js(3082): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "Tokenizer.js(3083): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Tokenizer.js(3084): fireChange"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("Tokenizer", "Change", mParams, true, true, false);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Tokenizer::Enter
 */
UCF_Tokenizer["prototype"]["fireEnter"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireEnter"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Tokenizer.js(3103): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tokenizer.js(3104): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tokenizer.js(3105): fireEnter"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Tokenizer", "Enter", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireEnter"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Tokenizer::FieldHelpRequest
 */
UCF_Tokenizer["prototype"]["fireFieldHelpRequest"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireFieldHelpRequest"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Tokenizer.js(3122): fireFieldHelpRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tokenizer.js(3123): fireFieldHelpRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tokenizer.js(3124): fireFieldHelpRequest"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Tokenizer", "FieldHelpRequest", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireFieldHelpRequest"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sItemListBoxId Identifier of the ItemListBox of the ComboBox that contains the values.
 * @param {string} sFilterValue Value used to filter the list.
 * @param {number} iOptimalNumberOfItems Optimal number of list items that can be displayed in the available space
 * @fires Tokenizer::ListAccess
 */
UCF_Tokenizer["prototype"]["fireListAccess"] = function(sId, sItemListBoxId, sFilterValue, iOptimalNumberOfItems) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireListAccess"]++; }; 
	/** @type {{Id: string, ItemListBoxId: string, FilterValue: string, OptimalNumberOfItems: number}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "Tokenizer.js(3146): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tokenizer.js(3147): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tokenizer.js(3148): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemListBoxId != null, "sItemListBoxId != null", "Tokenizer.js(3149): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemListBoxId) == "string", "typeof(sItemListBoxId) == \"string\"", "Tokenizer.js(3150): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFilterValue != null, "sFilterValue != null", "Tokenizer.js(3151): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFilterValue) == "string", "typeof(sFilterValue) == \"string\"", "Tokenizer.js(3152): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOptimalNumberOfItems != null, "iOptimalNumberOfItems != null", "Tokenizer.js(3153): fireListAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOptimalNumberOfItems) == "number", "typeof(iOptimalNumberOfItems) == \"number\"", "Tokenizer.js(3154): fireListAccess"); };
	mParams = {
		"Id": sId,
		"ItemListBoxId": sItemListBoxId,
		"FilterValue": sFilterValue,
		"OptimalNumberOfItems": iOptimalNumberOfItems
	};
	
	if (sItemListBoxId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemListBoxId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemListBoxId");
			}
		}
	
	
	this["fireSemanticEvent"]("Tokenizer", "ListAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireListAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sKey The selected key
 * @fires Tokenizer::SelectListItem
 */
UCF_Tokenizer["prototype"]["fireSelectListItem"] = function(sId, sKey) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireSelectListItem"]++; }; 
	/** @type {{Id: string, Key: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Tokenizer.js(3183): fireSelectListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tokenizer.js(3184): fireSelectListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tokenizer.js(3185): fireSelectListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sKey != null, "sKey != null", "Tokenizer.js(3186): fireSelectListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sKey) == "string", "typeof(sKey) == \"string\"", "Tokenizer.js(3187): fireSelectListItem"); };
	mParams = {
		"Id": sId,
		"Key": sKey
	};
	
	
	this["fireSemanticEvent"]("Tokenizer", "SelectListItem", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireSelectListItem"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sKey The key of the item that will be deleted
 * @fires Tokenizer::DeleteListItem
 */
UCF_Tokenizer["prototype"]["fireDeleteListItem"] = function(sId, sKey) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireDeleteListItem"]++; }; 
	/** @type {{Id: string, Key: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Tokenizer.js(3207): fireDeleteListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tokenizer.js(3208): fireDeleteListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tokenizer.js(3209): fireDeleteListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sKey != null, "sKey != null", "Tokenizer.js(3210): fireDeleteListItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sKey) == "string", "typeof(sKey) == \"string\"", "Tokenizer.js(3211): fireDeleteListItem"); };
	mParams = {
		"Id": sId,
		"Key": sKey
	};
	
	
	this["fireSemanticEvent"]("Tokenizer", "DeleteListItem", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireDeleteListItem"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sActionItemId Identifier of the action
 * @fires Tokenizer::ActionItemActivate
 */
UCF_Tokenizer["prototype"]["fireActionItemActivate"] = function(sId, sActionItemId) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireActionItemActivate"]++; }; 
	/** @type {{Id: string, ActionItemId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Tokenizer.js(3231): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tokenizer.js(3232): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tokenizer.js(3233): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sActionItemId != null, "sActionItemId != null", "Tokenizer.js(3234): fireActionItemActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sActionItemId) == "string", "typeof(sActionItemId) == \"string\"", "Tokenizer.js(3235): fireActionItemActivate"); };
	mParams = {
		"Id": sId,
		"ActionItemId": sActionItemId
	};
	
	
	this["fireSemanticEvent"]("Tokenizer", "ActionItemActivate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireActionItemActivate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sValue The clipboard content.
 * @fires Tokenizer::Paste
 */
UCF_Tokenizer["prototype"]["firePaste"] = function(sId, sValue) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["firePaste"]++; }; 
	/** @type {{Id: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Tokenizer.js(3255): firePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tokenizer.js(3256): firePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tokenizer.js(3257): firePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "Tokenizer.js(3258): firePaste"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Tokenizer.js(3259): firePaste"); };
	mParams = {
		"Id": sId,
		"Value": sValue
	};
	
	
	this["fireSemanticEvent"]("Tokenizer", "Paste", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["firePaste"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSourceId Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {number} iDropPositionIndex The index of the token where the drop happened, starting at 0.
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {boolean} bShift shift key pressed
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires Tokenizer::Drop
 */
UCF_Tokenizer["prototype"]["fireDrop"] = function(sId, sDragSourceId, sDropTargetInfo, iDropPositionIndex, sData, sMimeType, sDragSourceTags, bShift, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSourceId: string, DropTargetInfo: string, DropPositionIndex: number, Data: string, MimeType: string, DragSourceTags: string, Shift: boolean, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 12, "arguments.length == 12", "Tokenizer.js(3289): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tokenizer.js(3290): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tokenizer.js(3291): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceId != null, "sDragSourceId != null", "Tokenizer.js(3292): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceId) == "string", "typeof(sDragSourceId) == \"string\"", "Tokenizer.js(3293): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "Tokenizer.js(3294): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "Tokenizer.js(3295): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iDropPositionIndex != null, "iDropPositionIndex != null", "Tokenizer.js(3296): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iDropPositionIndex) == "number", "typeof(iDropPositionIndex) == \"number\"", "Tokenizer.js(3297): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "Tokenizer.js(3298): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "Tokenizer.js(3299): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "Tokenizer.js(3300): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "Tokenizer.js(3301): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "Tokenizer.js(3302): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "Tokenizer.js(3303): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bShift != null, "bShift != null", "Tokenizer.js(3304): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bShift) == "boolean", "typeof(bShift) == \"boolean\"", "Tokenizer.js(3305): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "Tokenizer.js(3306): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "Tokenizer.js(3307): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "Tokenizer.js(3308): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "Tokenizer.js(3309): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "Tokenizer.js(3310): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "Tokenizer.js(3311): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "Tokenizer.js(3312): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "Tokenizer.js(3313): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSourceId": sDragSourceId,
		"DropTargetInfo": sDropTargetInfo,
		"DropPositionIndex": iDropPositionIndex,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"Shift": bShift,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("Tokenizer", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Tokenizer["_"]["fireDrop"] = 0; };

UCF_Tokenizer.prototype["aPublicMethods"] = ["setItemListBoxId","setSuggestFilterCondition","deleteToken","open","getText","setSelection","setCursorPosition"].concat(UCF_Tokenizer.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TokenizerDropDecorator"] = function() {/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>

/**
 * @class
 * 
 * @param {UCF_Tokenizer} oTokenizer
 * @param {UCF_LS} oLS
 */
function UCF_TokenizerDropDecorator(oTokenizer, oLS) {if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["UCF_TokenizerDropDecorator"]++; }; 
	if (arguments["length"] === 0) return;

	this["oTokenizer"] = oTokenizer;
	this["bDashed"] = false;
	this["oBox"] = null;
	this["oParentContainer"] = oTokenizer["oLS"]["oGetRootRef"]();
	this["oLS"] = oLS;

	this["aHoverRects"] = [];
	this["oHoverRect"] = null;
};window["UCF_TokenizerDropDecorator"] = UCF_TokenizerDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TokenizerDropDecorator"); UCF_TokenizerDropDecorator["_"] = {UCF_TokenizerDropDecorator: 0}; }; ;

/**
 *
 */
UCF_TokenizerDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_TokenizerDropDecorator.prototype["sClassName"] = "UCF_TokenizerDropDecorator";

/**
 * destructor
 */
UCF_TokenizerDropDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["destroy"]++; }; 
	this["oBox"] = null;
	this["oParentContainer"] = null;
	this["oTokenizer"] = null;
	this["aHoverRects"] = null;
	this["oHoverRect"] = null;
	this["oLS"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["destroy"] = 0; };

UCF_TokenizerDropDecorator["prototype"]["createHoverRects"] = function() {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["createHoverRects"]++; }; 
	var aTokens = this["oGetChildrenByAttribute"](UCF_DomUtil["$"](this["oTokenizer"]["sId"] + "-tokens"), "CT", "TOKEN");
	var aRightTokens = this["oGetChildrenByAttribute"](UCF_DomUtil["$"](this["oTokenizer"]["sId"] + "-righttokens"), "CT", "TOKEN");
	if (aRightTokens["length"]) {
		aTokens["push"](UCF_DomUtil["$"](this["oTokenizer"]["sId"] + "-input"));
		aTokens = aTokens["concat"](aRightTokens);
	}
	var oTokenRect = null;
	var oPrevTokenRect = null;
	for (var i = 0; i < aTokens["length"]; i++) {
		oTokenRect = UCF_DomUtil["oGetObjectRect"](aTokens[i]);
		if (i === 0) {
			//special case first token
			this["aHoverRects"]["push"]({
				"top": oTokenRect["top"],
				"left": oTokenRect["left"],
				"width": oTokenRect["width"] / 2, //eslint-disable-line no-magic-numbers
				"height": oTokenRect["height"],
				"insertPos": oTokenRect["left"] - 4, //eslint-disable-line no-magic-numbers
				"dropLocation": i
			});
		} else if (oTokenRect["left"] < oPrevTokenRect["left"] + oPrevTokenRect["width"]) {
			//special case line break
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "special case line break", "TokenizerDropDecorator.js(71): createHoverRects"); };
			this["aHoverRects"]["push"]({
				"top": oPrevTokenRect["top"],
				"left": oPrevTokenRect["left"] + oPrevTokenRect["width"] / 2, //eslint-disable-line no-magic-numbers
				"width": oPrevTokenRect["width"] / 2, //eslint-disable-line no-magic-numbers
				"height": oPrevTokenRect["height"],
				"insertPos": oPrevTokenRect["left"] + oPrevTokenRect["width"],
				"dropLocation": i
			});
			this["aHoverRects"]["push"]({
				"top": oTokenRect["top"],
				"left": oTokenRect["left"],
				"width": oTokenRect["width"] / 2, //eslint-disable-line no-magic-numbers
				"height": oTokenRect["height"],
				"insertPos": oTokenRect["left"] - 4, //eslint-disable-line no-magic-numbers
				"dropLocation": i
			});
		} else {
			//default
			this["aHoverRects"]["push"]({
				"top": oTokenRect["top"],
				"left": oPrevTokenRect["left"] + oPrevTokenRect["width"] / 2, //eslint-disable-line no-magic-numbers
				"width": oTokenRect["left"] + oTokenRect["width"] / 2 - (oPrevTokenRect["left"] + oPrevTokenRect["width"] / 2), //eslint-disable-line no-magic-numbers
				"height": oTokenRect["height"],
				"insertPos": oTokenRect["left"] - 4, //eslint-disable-line no-magic-numbers
				"dropLocation": i
			});
		}
		oPrevTokenRect = oTokenRect;
	}
	if (oTokenRect) { //the last one
		this["aHoverRects"]["push"]({
			"top": oTokenRect["top"],
			"left": oTokenRect["left"] + oTokenRect["width"] / 2, //eslint-disable-line no-magic-numbers
			"width": oTokenRect["width"] / 2, //eslint-disable-line no-magic-numbers
			"height": oTokenRect["height"],
			"insertPos": oTokenRect["left"] + oTokenRect["width"],
			"dropLocation": aTokens["length"]
		});
	} else { //there are no tokens
		var oTokenizerRect = UCF_DomUtil["oGetObjectRect"](UCF_DomUtil["$"](this["oTokenizer"]["sId"]));
		this["aHoverRects"]["push"]({
			"top": oTokenizerRect["top"],
			"left": oTokenizerRect["left"],
			"width": oTokenizerRect["width"],
			"height": oTokenizerRect["height"],
			"insertPos": oTokenizerRect["left"],
			"dropLocation": 0
		});
	}
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["createHoverRects"] = 0; };

/**
 * creates DOM
 *
 */
UCF_TokenizerDropDecorator["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["init"]++; }; 
	if (this["oBox"]) return;

	this["aHoverRects"] = [];

	this["createHoverRects"]();

	this["oBox"] = document["createElement"]("DIV");
	this["oBox"]["style"]["position"] = "absolute";
	this["oBox"]["style"]["fontSize"] = "1px";
	this["oBox"]["style"]["zIndex"] = UCF_LS["E_LAYERS"]["DECORATORS"];
	this["oBox"]["style"]["height"] = "2px";
	this["oBox"]["style"]["width"] = "2px";
	try {
		this["oBox"]["style"]["boxSizing"] = "border-box";
	} catch (ex) {}

	if (this["bDashed"]) {
		this["oBox"]["style"]["border"] = "2px dashed black";
	} else {
		this["oBox"]["style"]["border"] = "2px solid black";
	}

	this["oParentContainer"]["appendChild"](this["oBox"]);
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["init"] = 0; };

/**
 * removes elements from DOM
 */
UCF_TokenizerDropDecorator["prototype"]["cleanUp"] = function() {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["cleanUp"]++; }; 
	UCF_DomUtil["removeFromDom"](this["oBox"]);
	this["oBox"] = null;
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["cleanUp"] = 0; };

/**
 * needed to determine the hovered element
 */
UCF_TokenizerDropDecorator["prototype"]["hide"] = function() {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["hide"]++; }; 
	if (this["oBox"]) {
		this["oBox"]["style"]["display"] = "none";
	}
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["hide"] = 0; };

UCF_TokenizerDropDecorator["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["show"]++; }; 
	if (this["oBox"]) {
		this["oBox"]["style"]["display"] = "block";
	}
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["show"] = 0; };

UCF_TokenizerDropDecorator["prototype"]["setBounds"] = function(iLeft, iTop, iHeight, iWidth) {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["setBounds"]++; }; 
	if (!this["oBox"]) {
		return;
	}

	if (!isNaN(iLeft)) {
		this["oBox"]["style"]["left"] = iLeft + "px";
	}

	if (!isNaN(iTop)) {
		this["oBox"]["style"]["top"] = iTop + "px";
	}

	if (!isNaN(iHeight)) {
		this["oBox"]["style"]["height"] = iHeight + "px";
	}

	if (!isNaN(iWidth)) {
		this["oBox"]["style"]["width"] = iWidth + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["setBounds"] = 0; };

UCF_TokenizerDropDecorator["prototype"]["bIsVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["bIsVisible"]++; }; 
	if (!this["oBox"]) {
		return false;
	}
	return this["oBox"]["style"]["display"] !== "none";
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["bIsVisible"] = 0; };

UCF_TokenizerDropDecorator["prototype"]["setContainer"] = function(oContainerDomRef) {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["setContainer"]++; }; 
	this["oParentContainer"] = oContainerDomRef;
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["setContainer"] = 0; };

UCF_TokenizerDropDecorator["prototype"]["update"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["update"]++; }; 
	var iMouseX = oBrowserEvent["iClientX"](),
		iMouseY = oBrowserEvent["iClientY"]();

	for (var i = 0; i < this["aHoverRects"]["length"]; i++) {
		this["oHoverRect"] = this["aHoverRects"][i];
		if (iMouseX >= this["oHoverRect"]["left"] &&
			iMouseX <= this["oHoverRect"]["left"] + this["oHoverRect"]["width"] &&
			iMouseY >= this["oHoverRect"]["top"] &&
			iMouseY <= this["oHoverRect"]["top"] + this["oHoverRect"]["height"]) {
			break;
		}
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Rect=[" + this["oHoverRect"]["top"] + "," + this["oHoverRect"]["left"] + "-" + (this["oHoverRect"]["top"] + this["oHoverRect"]["height"]) + "," + (this["oHoverRect"]["left"] + this["oHoverRect"]["width"]) + ", " + this["oHoverRect"]["insertPos"] + "], iMouseX=" + iMouseX + ", iMouseY=" + iMouseY, "TokenizerDropDecorator.js(222): update"); };

	this["setBounds"](this["oHoverRect"]["insertPos"], this["oHoverRect"]["top"], this["oHoverRect"]["height"], 1);
	this["show"]();
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["update"] = 0; };

UCF_TokenizerDropDecorator["prototype"]["oGetChildrenByAttribute"] = function(oDomRefNode, sAttribute, sValue) {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["oGetChildrenByAttribute"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRefNode) === "object", "typeof(oDomRefNode) === \"object\"", "TokenizerDropDecorator.js(229): oGetChildrenByAttribute"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAttribute) === "string", "typeof(sAttribute) === \"string\"", "TokenizerDropDecorator.js(230): oGetChildrenByAttribute"); };

	if (!oDomRefNode) return [];
	var aChildren = [];
	var oChildren = oDomRefNode["childNodes"];
	for (var i = 0; i < oChildren["length"]; i++) {
		var c = oChildren[i];
		if (c["nodeType"] === 1) {
			if ((!sValue && c["getAttribute"](sAttribute)) || (c["getAttribute"](sAttribute) === sValue)) {
				aChildren["push"](c);
			}
		}
	}

	return aChildren;
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["oGetChildrenByAttribute"] = 0; };

/**
 * Returns the drop location on which tokenizer the drop appeared
 *
 * @private
 * @return {Object} the actual value of this combobox
 */
UCF_TokenizerDropDecorator["prototype"]["oGetDropLocation"] = function() {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["oGetDropLocation"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "iIndex=" + this["oHoverRect"]["dropLocation"], "TokenizerDropDecorator.js(254): oGetDropLocation"); };

	return { "sItemId": this["sId"] + "-draghandle", "iIndex": this["oHoverRect"]["dropLocation"] };
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDecorator["_"]["oGetDropLocation"] = 0; };

};
sap["ls"]["preload"]["UCF_TokenizerDropDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_TokenizerDropDecorator */
/// <reference path="../decorators/TokenizerDropDecorator.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_TokenizerDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_TokenizerDropDelegate["_"]["UCF_TokenizerDropDelegate"]++; }; 
	UCF_DropDelegate["apply"](this, [oLS]);

	this["setDropTargetControl"](oDropTargetControl);
	this["iCurrentStep"] = 0;
	this["oLS"] = oLS;
};window["UCF_TokenizerDropDelegate"] = UCF_TokenizerDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TokenizerDropDelegate"); UCF_TokenizerDropDelegate["_"] = {UCF_TokenizerDropDelegate: 0}; }; ;
UCF_TokenizerDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_TokenizerDropDelegate.prototype["sClassName"] = "UCF_TokenizerDropDelegate";

/**
 * @override
 */
UCF_TokenizerDropDelegate["prototype"]["oCreateDropDecorator"] = function() {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDelegate["_"]["oCreateDropDecorator"]++; }; 
	return new (UCF_ClassLoader["oGetClass"]("UCF_TokenizerDropDecorator"))(this["oDropTargetControl"], this["oLS"]);
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDelegate["_"]["oCreateDropDecorator"] = 0; };

/**
 * @param { UCF_BrowserEvent } oBrowserEvent browser event
 * @return {Object} drop location
 */
UCF_TokenizerDropDelegate["prototype"]["oGetDropLocation"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDelegate["_"]["oGetDropLocation"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "", "TokenizerDropDelegate.js(34): oGetDropLocation"); };

	return this["oDropDecorator"]["oGetDropLocation"]();
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDelegate["_"]["oGetDropLocation"] = 0; };

UCF_TokenizerDropDelegate["prototype"]["oGetDropLocationIndex"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDelegate["_"]["oGetDropLocationIndex"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "", "TokenizerDropDelegate.js(40): oGetDropLocationIndex"); };

	return this["oDropDecorator"]["oGetDropLocationIndex"]();
};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDelegate["_"]["oGetDropLocationIndex"] = 0; };

/**
 * @param {UCF_DragSession} oDragSession drag session
 * @return {function(string, string):void}
 */
UCF_TokenizerDropDelegate["prototype"]["fGetDropCallBack"] = function(oDragSession) {;if (__UCF_COVERAGE__) { UCF_TokenizerDropDelegate["_"]["fGetDropCallBack"]++; }; 
	var sDropTargetInfoId = this["oDropTargetControl"]["sDropTargetInfo"],
		oDropTargetControl = this["oDropTargetControl"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		oLocation = this["oGetDropLocation"](),
		sDragTags = oDragSession["sGetDragTags"](),
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		bShift = oDragSession["bShift"],
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function(sDragData, sMimeType) {
		oDropTargetControl["fireDrop"](
			oDropTargetControl["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			oLocation["iIndex"],
			sDragData,
			sMimeType,
			sDragTags,
			bShift,
			iMouseButtonState,
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);
	};

};;if (__UCF_COVERAGE__) { UCF_TokenizerDropDelegate["_"]["fGetDropCallBack"] = 0; };

};
sap["ls"]["preload"]["UCF_Toolbar"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * Toolbar control implementation
 * @class
 * @param {HTMLElement} oDomRef DOM reference
 * @param {UCF_LS} oLS LS instance
 */
function UCF_Toolbar(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Toolbar["_"]["UCF_Toolbar"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Toolbar.js(18): UCF_Toolbar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Toolbar.js(19): UCF_Toolbar"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Toolbar.js(20): UCF_Toolbar"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_Toolbar"] = UCF_Toolbar; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Toolbar"); UCF_Toolbar["_"] = {UCF_Toolbar: 0}; }; ;
UCF_Toolbar["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Toolbar.prototype["sClassName"] = "UCF_Toolbar";

UCF_Toolbar["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Toolbar["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Toolbar["prototype"]["aAttributeNames"] = ["sId","sDesign","bHasShowAllState","bShowAll","bWrapping","sAccessibilityDescription","sVisibility","bItemOverflow","sAlignment","bHasBorder","sCustomData","sCustomStyle","bIsNested","sToolbarSize","bHasRightItemsFixed","sTooltip"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Toolbar["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Toolbar["prototype"]["aMethodNames"] = ["getHeightPx","getWidthPx","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Toolbar["prototype"]["sId"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ToolbarDesign}
 */
UCF_Toolbar["prototype"]["sDesign"] = "STANDARD";

/**
 * @private
 * @type {boolean}
 */
UCF_Toolbar["prototype"]["bHasShowAllState"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Toolbar["prototype"]["bShowAll"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Toolbar["prototype"]["bWrapping"] = true;

/**
 * @private
 * @type {string}
 */
UCF_Toolbar["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Toolbar["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_Toolbar["prototype"]["bItemOverflow"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ToolbarAlignment}
 */
UCF_Toolbar["prototype"]["sAlignment"] = "HORIZONTAL";

/**
 * @private
 * @type {boolean}
 */
UCF_Toolbar["prototype"]["bHasBorder"] = true;

/**
 * @private
 * @type {string}
 */
UCF_Toolbar["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Toolbar["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Toolbar["prototype"]["bIsNested"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Size}
 */
UCF_Toolbar["prototype"]["sToolbarSize"] = "MEDIUM";

/**
 * @private
 * @type {boolean}
 */
UCF_Toolbar["prototype"]["bHasRightItemsFixed"] = true;

/**
 * @private
 * @type {string}
 */
UCF_Toolbar["prototype"]["sTooltip"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Toolbar["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sDesign"] = "STANDARD";
	this["bHasShowAllState"] = false;
	this["bShowAll"] = false;
	this["bWrapping"] = true;
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["bItemOverflow"] = false;
	this["sAlignment"] = "HORIZONTAL";
	this["bHasBorder"] = true;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["bIsNested"] = false;
	this["sToolbarSize"] = "MEDIUM";
	this["bHasRightItemsFixed"] = true;
	this["sTooltip"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("Design", "STANDARD", true);
		this["setClientProperty"]("HasShowAllState", false, true);
		this["setClientProperty"]("ShowAll", false, true);
		this["setClientProperty"]("Wrapping", true, true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ItemOverflow", false, true);
		this["setClientProperty"]("Alignment", "HORIZONTAL", true);
		this["setClientProperty"]("HasBorder", true, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("IsNested", false, true);
		this["setClientProperty"]("ToolbarSize", "MEDIUM", true);
		this["setClientProperty"]("HasRightItemsFixed", true, true);
		this["setClientProperty"]("Tooltip", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ToolbarDTExtension"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_Rectangle */
/// <reference path="../../../core/types/Rectangle.js"/>
/* global UCF_DragSession */
/// <reference path="../base/DragSession.js"/>
/* global UCF_RectangleManager */
/// <reference path="../util/RectangleManager.js"/>
/* global UCF_DTExtension */
/// <reference path="./DTExtension.js"/>

/**
 * @class
 * 
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oControl
 * @param {UCF_DTElement} oDTElement
 */
function UCF_ToolbarDTExtension(oLS, oControl, oDTElement) {if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["UCF_ToolbarDTExtension"]++; }; 
	if (arguments["length"] === 0) return;
	UCF_DTExtension["apply"](this, arguments);
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Delegate for Toolbar " + oControl["sId"], "ToolbarDTExtension.js(24): UCF_ToolbarDTExtension"); };

	this["sToolbarId"] = oControl["sGetId"]();
	this["oDomRef"] = this["oDTElement"]["oGetContentDomRef"]();
	this["oDTContainer"] = this["oDTElement"]["oDTContainer"];

	this["oDomRef"]["style"]["display"] = "block";
	this["sCurrentDropZoneId"] = "";
	this["oCurrentMatchingRect"] = null;
	this["oDTElement"]["bShowDropDecorators"] = false;
	this["oRectangleManager"] = new (UCF_ClassLoader["oGetClass"]("UCF_RectangleManager"))();

	this["iLineHeight"] = 0;
	this["oToolbarRect"] = null;

	// If the framework does not support right items at all (WebGUI) we just need to suppress the dashed box for the empty right area
	this["bSupportRightItems"] = true;
	if (this["oControl"]["getClientControl"]()) {
		this["bSupportRightItems"] = (this["oControl"]["getClientControl"]()["bNoRightAreaInDesigntime"] === false);
	}
};window["UCF_ToolbarDTExtension"] = UCF_ToolbarDTExtension; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ToolbarDTExtension"); UCF_ToolbarDTExtension["_"] = {UCF_ToolbarDTExtension: 0}; }; ;
UCF_ToolbarDTExtension["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DTExtension"))(); UCF_ToolbarDTExtension.prototype["sClassName"] = "UCF_ToolbarDTExtension";

UCF_ToolbarDTExtension["cDefaultDropZoneWidth"] = 200;

/**
 * Tell the LS framework that this extension is also a delegate
 */
UCF_ToolbarDTExtension["prototype"]["bIsDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["bIsDelegate"]++; }; 
	// Acivate delegate only for personas!
	//return (window.sap !== undefined && window.sap.personas !== undefined);
	return this["oDTContainer"]["bIsPersonasEnabled"]();
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["bIsDelegate"] = 0; };

UCF_ToolbarDTExtension["prototype"]["oGetToolbar"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["oGetToolbar"]++; }; 
	return this["oLS"]["oControlFactory"]["oGetControlById"](this["sToolbarId"]);
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["oGetToolbar"] = 0; };

UCF_ToolbarDTExtension["prototype"]["bIsDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["bIsDropDelegate"]++; }; 
	// deactivate default drop decorators
	return this["bIsDelegate"]();
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["bIsDropDelegate"] = 0; };

UCF_ToolbarDTExtension["prototype"]["onlsdragenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["onlsdragenter"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, this["sToolbarId"], "ToolbarDTExtension.js(68): onlsdragenter"); };
	this["createDropZones"]();
	oBrowserEvent["oDragAndDropManager"]["oDragSession"]["oGetGhost"]()["oDomRef"]["style"]["opacity"] = "0.8";
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["onlsdragenter"] = 0; };

UCF_ToolbarDTExtension["prototype"]["onlsdragleave"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["onlsdragleave"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, this["sToolbarId"], "ToolbarDTExtension.js(76): onlsdragleave"); };
	this["removePushItem"]();
	this["oRectangleManager"]["destroy"](); // remove hover rectangles
	oBrowserEvent["oDragAndDropManager"]["oDragSession"]["oGetGhost"]()["oDomRef"]["style"]["opacity"] = "1";
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["onlsdragleave"] = 0; };

UCF_ToolbarDTExtension["prototype"]["onlsdragover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["onlsdragover"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, this["sToolbarId"], "ToolbarDTExtension.js(85): onlsdragover"); };

	// Note:
	// This extension handles some events like a DnD delegate but does NOT inherit from Drag/DropDelegate base classes
	// which contain DnD framework coding necessary e.g. for proper Tag matching => We have to copy some code from the DropDelegate here...
	if (this["oGetDropTargetInfoId"]()) {
		var sDropTags = this["sGetDropTags"](oBrowserEvent),
			sValidMimeTypes = this["sGetValidMimeTypes"](oBrowserEvent),
			oDragAndDropManager = oBrowserEvent["oDragAndDropManager"],
			bEventBubbling = this["bGetEventBubbling"](oBrowserEvent);
		if (!oDragAndDropManager["bGetDropAllowed"](sDropTags, sValidMimeTypes)) {
			if (!bEventBubbling) oBrowserEvent["cancelBubble"]();
			return;
		}
	}

	var aMatchingRects = this["oRectangleManager"]["getRectangles"](oBrowserEvent["iPageX"](), oBrowserEvent["iPageY"]());
	if (aMatchingRects["length"] !== 1) {
		// cleanup if we are not over a hoverzone
		this["removePushItem"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["oDragAndDropManager"]["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["NOT_ALLOWED"]);
		return;
	}
	oBrowserEvent["oDragAndDropManager"]["oDragSession"]["setCursor"](UCF_DragSession["E_CURSOR"]["MOVE"]);

	var oMatchingRect = aMatchingRects[0];
	var sDropZoneId = "toolbar-" + this["oGetToolbar"]()["sId"] + "-" + oMatchingRect["oCustomData"]["sAggregationName"] + "-" + oMatchingRect["oCustomData"]["iIndex"];
	if (this["sCurrentDropZoneId"] && this["sCurrentDropZoneId"] !== sDropZoneId) {
		this["removePushItem"]();
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}
	if (document["getElementById"](sDropZoneId)) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}

	// create dropzone
	var oDropZone = document["createElement"]("DIV");
	oDropZone["setAttribute"]("id", sDropZoneId);
	if (oMatchingRect["oCustomData"]["oPreviousItem"] === null && oMatchingRect["oCustomData"]["oNextItem"] === null) {
		oDropZone["style"]["border"] = "dashed";
		oDropZone["style"]["borderWidth"] = "1px";
		oDropZone["style"]["width"] = oBrowserEvent["oDragAndDropManager"]["oGhost"]["oDomRef"]["offsetWidth"] + "px";
		oDropZone["style"]["height"] = oMatchingRect["oRectangle"]["iHeight"] + "px";
		oDropZone["style"]["top"] = oMatchingRect["oRectangle"]["iTop"] + "px";
		var iLeft = 0;
		if (oMatchingRect["oCustomData"]["sAggregationName"] === "Items") {
			iLeft = this["oToolbarRect"]["left"];
		} else {
			iLeft = this["oToolbarRect"]["left"] + this["oToolbarRect"]["width"] - oBrowserEvent["oDragAndDropManager"]["oGhost"]["oDomRef"]["offsetWidth"];
		}
		oDropZone["style"]["left"] = iLeft + "px";
		oDropZone["style"]["position"] = "absolute";
		if (oMatchingRect["oCustomData"]["sAggregationName"] !== "RightItems" || this["bSupportRightItems"]) {
			document["body"]["appendChild"](oDropZone);
		}
	} else {
		oDropZone["style"]["verticalAlign"] = "baseline";
		oDropZone["style"]["display"] = "inline-block";
		var oInner = document["createElement"]("DIV");
		oInner["style"]["border"] = "solid";
		oInner["style"]["borderWidth"] = "1px";
		oInner["style"]["width"] = "0px"; //oBrowserEvent.oDragAndDropManager.oGhost.oDomRef.offsetWidth + "px";
		oInner["style"]["height"] = (this["iLineHeight"] - 4) + "px";
		oInner["style"]["marginTop"] = "-2px";
		// Workaround: Must be correct value for each theme (!!) otherwise all Toolbar items will "jump" when decorator is shown...
		if (this["iLineHeight"] === 33 || this["iLineHeight"] === 32) {
			// blue-crystal or belize
			oInner["style"]["marginBottom"] = "-9px";
		} else if (this["iLineHeight"] === 23) {
			// corbu
			oInner["style"]["marginBottom"] = "-3px";
		} else {
			// sap_tradeshow_plus etc.: 21
			oInner["style"]["marginBottom"] = "-2px";
		}

		oDropZone["style"]["verticalAlign"] = "inherit";
		oDropZone["insertBefore"](oInner, null);

		if (oMatchingRect["oCustomData"]["oNextItem"]) {
			// Workaround for new "float" rendering
			oDropZone["style"]["float"] = UCF_DomUtil["sGetCurrentStyle"](oMatchingRect["oCustomData"]["oNextItem"], "float");
			oMatchingRect["oCustomData"]["oNextItem"]["parentNode"]["insertBefore"](oDropZone, oMatchingRect["oCustomData"]["oNextItem"]);
		} else {
			oDropZone["style"]["float"] = UCF_DomUtil["sGetCurrentStyle"](oMatchingRect["oCustomData"]["oPreviousItem"], "float");
			oMatchingRect["oCustomData"]["oPreviousItem"]["parentNode"]["insertBefore"](oDropZone, oMatchingRect["oCustomData"]["oPreviousItem"]["nextSibling"]);
		}
	}
	this["sCurrentDropZoneId"] = sDropZoneId;
	this["oCurrentMatchingRect"] = oMatchingRect;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "currentDropZoneId: " + this["sCurrentDropZoneId"], "ToolbarDTExtension.js(181): onlsdragover"); };

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["onlsdragover"] = 0; };

UCF_ToolbarDTExtension["prototype"]["onlsdrop"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["onlsdrop"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, this["sToolbarId"], "ToolbarDTExtension.js(188): onlsdrop"); };

	if (this["sCurrentDropZoneId"]) { // Drop in a dropzone
		//var oAddItemContent = oBrowserEvent.oDragAndDropManager.oGhost.oDomRef.cloneNode(true);
		var oClientToolbar = this["oGetToolbar"]()["getClientControl"]();
		if (oClientToolbar) {
			//items, toolbar with id, control with id, index
			var sDraggedId = oBrowserEvent["oDragAndDropManager"]["oDragSession"]["sDragSourceId"];
			var oDraggedDTElement = this["oGetToolbar"]()["oGetControlById"](sDraggedId);
			if (oDraggedDTElement) {
				var oDraggedControl = oDraggedDTElement["oGetConnectedControl"]();
				if (oDraggedControl) {
					var oDraggedClientControl = oDraggedControl["getClientControl"]();
					if (oDraggedClientControl) {
						var iIndex = this["oCurrentMatchingRect"]["oCustomData"]["iIndex"];
						if (oDraggedClientControl["getParent"]() === oClientToolbar &&
							oDraggedClientControl["sAggregationName"] === this["oCurrentMatchingRect"]["oCustomData"]["sAggregationName"]) {
							//adjust index, if move is executed from front to back in same aggregation
							var iCurrentIndex = oClientToolbar["indexOfAggregation"](oDraggedClientControl["sAggregationName"], oDraggedClientControl);
							if (iCurrentIndex <= iIndex) {
								iIndex--;
							}
						}

						//client side rendering moved to event handler, e.g. ./personas/fw/wda/extensions/Toolbar.js

						//fire drop event
						oDraggedDTElement["oDTContainer"]["fireDrop"](
							oDraggedDTElement["oDTContainer"]["sId"], //sId
							oDraggedDTElement["sId"], //sDragSource

							//<parameter name="DragTargetDTElement" type="string" docu="Identifier of the element that was the target" />
							this["oDTElement"]["sId"],

							"", //sPosition
							"", //sDropTargetInfo
							this["oCurrentMatchingRect"]["oCustomData"]["sAggregationName"], //sData
							"", //sMimeType
							"", //sDragSourceTags
							0, //iMouseButton
							oBrowserEvent["oDragAndDropManager"]["oDragSession"]["oGetDropPosition"]()["left"], //iPosX
							oBrowserEvent["oDragAndDropManager"]["oDragSession"]["oGetDropPosition"]()["top"], //iPosY
							iIndex + "", //sDropIndex
							-1, -1, -1, -1 // iDropGridRow/iDropGridColumn
						);
					}
				}
			}
		}
	}

	//stop whole D&D operation
	this["removePushItem"]();
	this["oRectangleManager"]["removeAll"]();
	oBrowserEvent["bHandled"] = true;
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["onlsdrop"] = 0; };

UCF_ToolbarDTExtension["prototype"]["addDropZone"] = function(oItem, iIndex, oNextItem, sAggregationName) {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["addDropZone"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "iIndex=" + iIndex + ", sAggregationName=" + sAggregationName, "ToolbarDTExtension.js(248): addDropZone"); };

	var oRect = null;
	var iWidthLeft = 0;
	var iWidthRight = 0;
	var iItemPadding = 0;
	var iOffsetLeft = 0;
	if (oItem) {
		oRect = UCF_DomUtil["oGetObjectRect"](oItem);
		iWidthLeft = parseInt(oItem["offsetWidth"] / 3);
		iOffsetLeft = 2 * iWidthLeft;
		if (oNextItem) {
			iItemPadding = 5;
		}
	} else { //before first
		oRect = UCF_DomUtil["oGetObjectRect"](oNextItem);
		if (sAggregationName === "RightItems") {
			var iWidthRightItems = 0;
			if (oNextItem["offsetParent"] && oNextItem["offsetParent"]["childNodes"]) {
				//summ up the width of all right items
				for (var i = 0; i < oNextItem["offsetParent"]["childNodes"]["length"]; i++) {
					iWidthRightItems += oNextItem["offsetParent"]["childNodes"][i]["offsetWidth"];
				}
			}
			//half of the toolbar width minus width of the right items
			if (this["iWidthLeftSide"] && this["iWidthLeftSide"] > 0) {
				iWidthLeft = (this["oToolbarRect"]["width"] - this["iWidthLeftSide"]) - iWidthRightItems;
			} else {
				iWidthLeft = (this["oToolbarRect"]["width"] / 2) - iWidthRightItems;
			}
			iOffsetLeft = -iWidthLeft;
		}
	}

	if (oNextItem) {
		iWidthRight = parseInt(oNextItem["offsetWidth"] / 3);
	} else { //after last
		if (sAggregationName === "Items") {
			//half of the toolbar width minus width of the left items
			iWidthRight = (this["oToolbarRect"]["width"] / 2) - (oItem["offsetLeft"] + oItem["offsetWidth"]);
			if (iWidthRight <= 0) {
				//width of left items is larger than half of the toolbar width
				iWidthRight = parseInt(oItem["offsetWidth"] / 3);
				this["iWidthLeftSide"] = oItem["offsetLeft"] + oItem["offsetWidth"] + iWidthRight;
			}
		}
	}
	var iWidth = iWidthLeft + iWidthRight + iItemPadding;
	oRect["left"] = oRect["left"] + iOffsetLeft;
	if (oRect["left"] + iWidth > this["oToolbarRect"]["left"] + this["oToolbarRect"]["width"]) {
		iWidth -= (oRect["left"] + iWidth) - (this["oToolbarRect"]["left"] + this["oToolbarRect"]["width"]);
	}

	var oHoverRect = new (UCF_ClassLoader["oGetClass"]("UCF_Rectangle"))(oRect["top"], oRect["left"], iWidth, this["iLineHeight"]);
	this["oRectangleManager"]["addRectangle"](oHoverRect, {
		"iIndex": iIndex,
		"sAggregationName": sAggregationName,
		"oPreviousItem": oItem,
		"oNextItem": oNextItem
	});
	return oHoverRect;
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["addDropZone"] = 0; };

UCF_ToolbarDTExtension["prototype"]["addLeftDropZones"] = function(oItemCell) {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["addLeftDropZones"]++; }; 
	var aItems = [];
	var oItem = null;
	var oNextItem = null;
	var oLastDropZone = null;

	if (oItemCell && oItemCell["childNodes"]["length"]) {
		aItems = oItemCell["childNodes"];
	}

	for (var i = aItems["length"]; i > 0; i--) {
		if (!this["oGetToolbar"]()["bItemIsHidden"](aItems[i - 1])) {
			oItem = aItems[i - 1];
			oLastDropZone = this["addDropZone"](oItem, i, oNextItem, "Items");
			oNextItem = oItem;
			oItem = null;
		}
	}

	//leftmost zone, independent from existing items
	var iWidth = UCF_ToolbarDTExtension["cDefaultDropZoneWidth"];
	if (oLastDropZone) {
		iWidth = oLastDropZone["iLeft"] - this["oToolbarRect"]["left"];
	} else {
		var iWidthLeftItems = 0;
		if (oItemCell && oItemCell["childNodes"]) {
			//sum up the width of all left items
			for (i = 0; i < oItemCell["childNodes"]["length"]; i++) {
				iWidthLeftItems += oItemCell["childNodes"][i]["offsetWidth"];
			}
		}
		//half of the toolbar width minus width of the left items
		iWidth = (this["oToolbarRect"]["width"] / 2) - iWidthLeftItems;
	}

	var oHoverRect = new (UCF_ClassLoader["oGetClass"]("UCF_Rectangle"))(this["oToolbarRect"]["top"], this["oToolbarRect"]["left"], iWidth, this["iLineHeight"]);
	this["oRectangleManager"]["addRectangle"](oHoverRect, {
		"iIndex": 0,
		"sAggregationName": "Items",
		"oPreviousItem": oItem,
		"oNextItem": oNextItem
	});
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["addLeftDropZones"] = 0; };

UCF_ToolbarDTExtension["prototype"]["addRightDropZones"] = function(oItemCell, iNumLines) {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["addRightDropZones"]++; }; 
	var aItems = [];
	var oItem = null;
	var oNextItem = null;
	var oLastDropZone = null;

	if (oItemCell && oItemCell["childNodes"]["length"]) {
		aItems = oItemCell["childNodes"];
	}

	for (var i = 0; i < aItems["length"]; i++) {
		if (!this["oGetToolbar"]()["bItemIsHidden"](aItems[i])) {
			oNextItem = aItems[i];
			oLastDropZone = this["addDropZone"](oItem, i, oNextItem, "RightItems");
			oItem = oNextItem;
			oNextItem = null;
		}
	}

	//rightmost zone, independent from existing items
	var iWidth = UCF_ToolbarDTExtension["cDefaultDropZoneWidth"];
	if (oLastDropZone) {
		iWidth = (this["oToolbarRect"]["left"] + this["oToolbarRect"]["width"]) - (oLastDropZone["iLeft"] + oLastDropZone["iWidth"]);
	} else if (iNumLines === 1) {
		var iWidthRightItems = 0;
		if (oItemCell && oItemCell["childNodes"]) {
			//sum up the width of all right items
			for (i = 0; i < oItemCell["childNodes"]["length"]; i++) {
				iWidthRightItems += oItemCell["childNodes"][i]["offsetWidth"];
			}
		}
		//half of the toolbar width minus width of the right items
		iWidth = (this["oToolbarRect"]["width"] / 2) - iWidthRightItems;
	}

	var oHoverRect = new (UCF_ClassLoader["oGetClass"]("UCF_Rectangle"))(this["oToolbarRect"]["top"] + (iNumLines - 1) * this["iLineHeight"], this["oToolbarRect"]["left"] + this["oToolbarRect"]["width"] - iWidth, iWidth, this["iLineHeight"]);
	this["oRectangleManager"]["addRectangle"](oHoverRect, {
		"iIndex": aItems["length"],
		"sAggregationName": "RightItems",
		"oPreviousItem": oItem,
		"oNextItem": oNextItem
	});
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["addRightDropZones"] = 0; };

UCF_ToolbarDTExtension["prototype"]["createDropZones"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["createDropZones"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "add drop zones", "ToolbarDTExtension.js(400): createDropZones"); };

	//calculate height of the "toolbar line"
	var iToolbarHeight = this["oGetToolbar"]()["oDomRef"]["childNodes"][0]["clientHeight"];
	this["oToolbarRect"] = UCF_DomUtil["oGetObjectRect"](this["oGetToolbar"]()["oDomRef"]);

	// items left
	var iNumLinesLeft = 0;
	var aItems, iCurrentOffsetLeft;
	var oItemCell = UCF_DomUtil["$"](this["oGetToolbar"]()["sId"] + "-itms");
	if (oItemCell && oItemCell["childNodes"]["length"]) {
		aItems = oItemCell["childNodes"];
		iCurrentOffsetLeft = 99999;
		for (var i = 0; i < aItems["length"]; i++) {
			if (!this["oGetToolbar"]()["bItemIsHidden"](aItems[i])) {
				if (aItems[i]["offsetLeft"] < iCurrentOffsetLeft) {
					++iNumLinesLeft;
				}
				iCurrentOffsetLeft = aItems[i]["offsetLeft"];
			}
		}
	}
	// items right
	var iNumLinesRight = 1;
	oItemCell = UCF_DomUtil["$"](this["oGetToolbar"]()["sId"] + "-rItms");
	if (oItemCell && oItemCell["childNodes"]["length"]) {
		aItems = oItemCell["childNodes"];
		iCurrentOffsetLeft = 99999;
		for (i = 0; i < aItems["length"]; i++) {
			if (!this["oGetToolbar"]()["bItemIsHidden"](aItems[i])) {
				if (aItems[i]["offsetLeft"] < iCurrentOffsetLeft) {
					++iNumLinesRight;
				}
				iCurrentOffsetLeft = aItems[i]["offsetLeft"];
			}
		}
		--iNumLinesRight;
	}
	this["iLineHeight"] = iToolbarHeight / Math["max"](1, Math["max"](iNumLinesLeft, iNumLinesRight));
	this["iWidthLeftSide"] = 0;
	this["addLeftDropZones"](UCF_DomUtil["$"](this["oGetToolbar"]()["sId"] + "-itms"));
	if (this["bSupportRightItems"]) {
		this["addRightDropZones"](UCF_DomUtil["$"](this["oGetToolbar"]()["sId"] + "-rItms"), iNumLinesRight);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["createDropZones"] = 0; };

UCF_ToolbarDTExtension["prototype"]["removePushItem"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["removePushItem"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, this["sToolbarId"] + ": " + this["sCurrentDropZoneId"], "ToolbarDTExtension.js(447): removePushItem"); };

	if (this["sCurrentDropZoneId"]) {
		var oCurrentPushItem = document["getElementById"](this["sCurrentDropZoneId"]);
		if (oCurrentPushItem)
			oCurrentPushItem["parentNode"]["removeChild"](oCurrentPushItem);
		this["sCurrentDropZoneId"] = "";
		this["oCurrentMatchingRect"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["removePushItem"] = 0; };

UCF_ToolbarDTExtension["prototype"]["bHideWhenDropNotAllowed"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["bHideWhenDropNotAllowed"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["bHideWhenDropNotAllowed"] = 0; };

UCF_ToolbarDTExtension["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["destroy"]++; }; 
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "D E S T R O Y: " + this["sToolbarId"], "ToolbarDTExtension.js(463): destroy"); };
	if (this["oRectangleManager"])	this["oRectangleManager"]["destroy"]();
	this["sToolbarId"] = null;
	this["oDomRef"] = null;
	this["oDTContainer"] = null;
	this["sCurrentDropZoneId"] = null;
	this["oCurrentMatchingRect"] = null;
	this["oRectangleManager"] = null;
	this["iLineHeight"] = null;
	this["oToolbarRect"] = null;
	this["bSupportRightItems"] = null;
	this["iWidthLeftSide"] = null;
	this["oDropTargetControl"] = null;
	this["oDropTargetInfoControl"] = null;
	UCF_DTExtension.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["destroy"] = 0; };

// From DropDelegate:

UCF_ToolbarDTExtension["prototype"]["sGetDropTags"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["sGetDropTags"]++; }; 

	var oDropTargetControl = this["oDTElement"],
		sDropTargetInfoId = this["oGetDropTargetInfoId"](oBrowserEvent);
	if (!sDropTargetInfoId)
		return "";

	var oDropTargetInfoControl = oDropTargetControl["oGetControlById"](sDropTargetInfoId);
	if (!oDropTargetInfoControl)
		return "";

	var sDropTags = oDropTargetInfoControl["sGetTags"]();
	if (!sDropTags)
		return "";

	return sDropTags;
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["sGetDropTags"] = 0; };

UCF_ToolbarDTExtension["prototype"]["sGetValidMimeTypes"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["sGetValidMimeTypes"]++; }; 
	var oDropTargetControl = this["oDTElement"],
		sDropTargetInfoId = this["oGetDropTargetInfoId"](oBrowserEvent);
	if (!sDropTargetInfoId) {
		return "";
	}
	var oDropTargetInfoControl = oDropTargetControl["oGetControlById"](sDropTargetInfoId);
	if (!oDropTargetInfoControl) {
		return "";
	}
	var sValidMimeTypes = oDropTargetInfoControl["sGetValidMimeTypes"]();
	if (!sValidMimeTypes) {
		return "";
	}
	return sValidMimeTypes;
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["sGetValidMimeTypes"] = 0; };

UCF_ToolbarDTExtension["prototype"]["oGetDropTargetInfoId"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["oGetDropTargetInfoId"]++; }; 
	return this["oDTElement"]["sDropTargetInfo"] || this["oDTElement"]["sDropTargetInfoTop"];
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["oGetDropTargetInfoId"] = 0; };

UCF_ToolbarDTExtension["prototype"]["bGetEventBubbling"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["bGetEventBubbling"]++; }; 
	if (!this["oDropTargetControl"]) this["oDropTargetControl"] = this["oDTElement"];
	if (this["oDropTargetControl"]) {
		if (!this["oDropTargetInfoControl"]) {
			if (this["oGetDropTargetInfoId"](oBrowserEvent)) {
				this["oDropTargetInfoControl"] = this["oDropTargetControl"]["oGetControlById"](this["oGetDropTargetInfoId"](oBrowserEvent));
				if (this["oDropTargetInfoControl"]) return this["oDropTargetInfoControl"]["bGetEventBubbling"]();
				else return true;
			} else return true;
		} else return this["oDropTargetInfoControl"]["bGetEventBubbling"]();
	} else return true;
};;if (__UCF_COVERAGE__) { UCF_ToolbarDTExtension["_"]["bGetEventBubbling"] = 0; };

};
sap["ls"]["preload"]["UCF_ToolbarFieldNavigationDelegate"] = function() {/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>

/* global UCF_TableFieldNavigationDelegate, UCF_FieldNavigationDelegate */
/**
 * Standard selection behaviour of browsers for INPUT elements:
 * <TabIn>: value gets selected
 * <Click>: Value is not selected, caret is set to the click position
 *
 * For Toolbar the selection behaviour should be the same as default
 * <TabIn>: value gets selected, but not in EditMode;
 * 	with ARROWS or TAB it can continue the navigations;
 *  As soon it start to edit or press F2, it'll switch to EditMode and ARROWS navigation will not be possible.
 *  F2 will switch back the EditMode: false and ARROWs navigation is possible again
 *
 * <Click>: Value is not selected, caret is set to the click position;
 * 	EditMode is enabled, so no ARROW navigation is possble
 *  F2 will switch back the EditMode: false and ARROWs navigation is possible again
 *
 * @class UCF_ToolbarFieldNavigationDelegate
 * @extends UCF_Object
 * @param {UCF_EditFieldBase} oControl the field
 */
function UCF_ToolbarFieldNavigationDelegate(oControl) {if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["UCF_ToolbarFieldNavigationDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		this["oControl"] = oControl;
		this["bEditMode"] = false;
		this["bKeepEditMode"] = false;
		this["iSelectionStart"] = this["oControl"]["sGetValue"]()["length"];
		this["iSelectionEnd"] = this["iSelectionStart"];
	}

};window["UCF_ToolbarFieldNavigationDelegate"] = UCF_ToolbarFieldNavigationDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ToolbarFieldNavigationDelegate"); UCF_ToolbarFieldNavigationDelegate["_"] = {UCF_ToolbarFieldNavigationDelegate: 0}; }; ;
UCF_ToolbarFieldNavigationDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_FieldNavigationDelegate"))(); UCF_ToolbarFieldNavigationDelegate.prototype["sClassName"] = "UCF_ToolbarFieldNavigationDelegate";

UCF_ToolbarFieldNavigationDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["destroy"]++; }; 

	this["iSelectionEnd"] = null;
	this["iSelectionStart"] = null;
	UCF_FieldNavigationDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["destroy"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsfocus"]++; }; 

	if (oBrowserEvent["bIsTouchInteraction"]()) {
		this["editMode"]();
	} else if (
		this["bKeepEditMode"] ||
		oBrowserEvent["oFromElement"] === this["oControl"]["oDomRef"]
	) {
		this["bKeepEditMode"] = false;
	} else if (!this["bEditMode"]) {
		this["navigationMode"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsfocus"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlshotkey"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlshotkey"]++; }; 
	if (UCF_KeyboardHelper["bIsEventForKey"](oHotkey, UCF_KeyCodes["F2"])) {
		this["handleF2"](oHotkey);
	}
	if (UCF_KeyboardHelper["bIsEventForKey"](oHotkey, UCF_KeyCodes["A"], 'C')) {
		this["handleCtrlA"](oHotkey);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlshotkey"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oHotkey the hotkey
 */
UCF_ToolbarFieldNavigationDelegate["prototype"]["handleF2"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["handleF2"]++; }; 
	if (this["bEditMode"]) {
		// save selection start and end
		this["iSelectionStart"] = UCF_DomUtil["iGetSelectionStart"](
			this["oControl"]["oDomRef"]
		);
		this["iSelectionEnd"] = UCF_DomUtil["iGetSelectionEnd"](
			this["oControl"]["oDomRef"]
		);
		this["navigationMode"]();
	} else {
		this["editMode"]();
		UCF_DomUtil["setSelection"](
			this["oControl"]["oDomRef"],
			this["iSelectionStart"],
			this["iSelectionEnd"]
		);
	}
	if (window["UCF_System"]["bIs508"]) {
		this["oControl"]["refocus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["handleF2"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oHotkey the hotkey
 */
UCF_ToolbarFieldNavigationDelegate["prototype"]["handleCtrlA"] = function(oHotkey) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["handleCtrlA"]++; }; 
	if (
		// Limitation: Not in IE: Focus gets lost!
		!UCF_UserAgent["bIsIE"]() &&
		// not selected yet
		!this["bSelected"] &&
		// AND read only or disabled
		!this["oControl"]["bIsWriteable"]()
	) {
		// select the text and cancel the event.
		// otherwise: Let the event bubble, and the table raises a RowSelect event
		this["selectText"]();
		oHotkey["cancelBubble"]();
		oHotkey["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["handleCtrlA"] = 0; };

/** @override */
// eslint-disable-next-line complexity
UCF_ToolbarFieldNavigationDelegate["prototype"]["onkeydown"] = function(oKeydown) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onkeydown"]++; }; 
	if (
		UCF_DomUtil["oGetActiveElement"]() === this["oControl"]["oDomRef"] &&
		this["oControl"]["bIsWriteable"]()
	) {
		if (this["bEditMode"] && (
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["DELETE"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["ESCAPE"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["INSERT"]) ||
				UCF_KeyboardHelper["bIsEventForKey"](oKeydown, UCF_KeyCodes["SPACE"])
			)) {
			oKeydown["cancelBubble"]();
		} else if (this["bIsImplicitEditModeSwitch"](oKeydown)) {
			this["editMode"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onkeydown"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event
 * @return {boolean}
 */
UCF_ToolbarFieldNavigationDelegate["prototype"]["bIsImplicitEditModeSwitch"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["bIsImplicitEditModeSwitch"]++; }; 
	/** @type {number} */
	var iKeyCode = oBrowserEvent["iKeyCode"]();

	return UCF_KeyboardHelper["bIsEditKey"](iKeyCode)
		&& iKeyCode !== UCF_KeyCodes["ENTER"]
		&& (!oBrowserEvent["bCtrl"]() || oBrowserEvent["bAlt"]())
		&& !UCF_KeyboardHelper["bIsEventForKey"](oBrowserEvent, UCF_KeyCodes["SPACE"])
		&& UCF_DomUtil["oGetActiveElement"]() === this["oControl"]["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["bIsImplicitEditModeSwitch"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onpaste"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onpaste"]++; }; 
	this["editMode"]();
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onpaste"] = 0; };

/** @override
 * On MouseDown set the bEditMode: true
 */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onmousedown"] = function(oMouseDown) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onmousedown"]++; }; 
	var oSourceControl = oMouseDown["oGetSourceControl"]();
	if (oSourceControl === this["oControl"]) {
		this["editMode"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onmousedown"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlsblur"] = function(oBlur) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsblur"]++; }; 
	this["bSelected"] = false;
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsblur"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlsleft"] = function(oLsLeft) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsleft"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsleft"]["apply"](this, arguments);
	} else {
		this["bubbleToToolbar"](oLsLeft);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsleft"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlsright"] = function(oLsRight) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsright"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsright"]["apply"](this, arguments);
	} else {
		this["bubbleToToolbar"](oLsRight);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsright"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlsup"] = function(oLsup) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsup"]++; }; 
	if (!this["oControl"]["bShouldHandleLsUp"](oLsup)) {
		this["bubbleToToolbar"](oLsup);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsup"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlsdown"] = function(oLsdown) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsdown"]++; }; 
	if (!this["oControl"]["bShouldHandleLsDown"](oLsdown)) {
		this["bubbleToToolbar"](oLsdown);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsdown"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["bubbleToToolbar"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["bubbleToToolbar"]++; }; 
	this["deselectText"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["bubbleToToolbar"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlsspacemodifier"] = function(oLsSpaceModifier) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsspacemodifier"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsspacemodifier"]["apply"](this, arguments);
	} else {
		oLsSpaceModifier["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsspacemodifier"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlsselect"] = function(oLsSelect) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsselect"]++; }; 
	if (this["bEditMode"]) {
		oLsSelect["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsselect"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlsselectmodifier"] = function(oLsSelectModifier) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsselectmodifier"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsselectmodifier"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsselectmodifier"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlshome"] = function(oLsHome) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlshome"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlshome"]["apply"](this, arguments);
	} else {
		oLsHome["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlshome"] = 0; };

/** @override */
UCF_ToolbarFieldNavigationDelegate["prototype"]["onlsend"] = function(oLsEnd) {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsend"]++; }; 
	if (this["bEditMode"]) {
		UCF_FieldNavigationDelegate.prototype["onlsend"]["apply"](this, arguments);
	} else {
		oLsEnd["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["onlsend"] = 0; };

/** @protected */
UCF_ToolbarFieldNavigationDelegate["prototype"]["navigationMode"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["navigationMode"]++; }; 
	this["bEditMode"] = false;

	if (this["oControl"]["bIsWriteable"]()) {
		this["selectText"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["navigationMode"] = 0; };

/** @protected */
UCF_ToolbarFieldNavigationDelegate["prototype"]["editMode"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["editMode"]++; }; 
	if (this["oControl"]["bIsWriteable"]()) {
		this["bEditMode"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["editMode"] = 0; };

/** @protected */
UCF_ToolbarFieldNavigationDelegate["prototype"]["keepEditMode"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["keepEditMode"]++; }; 
	this["bKeepEditMode"] = true;
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["keepEditMode"] = 0; };

/** @private
 *  Selects the text of the Input
 */
UCF_ToolbarFieldNavigationDelegate["prototype"]["selectText"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["selectText"]++; }; 
	/** @type {Document} */
	var document = window["document"];
	/** @type {Selection} */
	var selection;
	/** @type {Range} */
	var range;

	if (this["oControl"]["oDomRef"]["select"]) {
		if (UCF_UserAgent["bIsFirefox"]()) {
			this["oControl"]["select"]();
		} else {
			this["oControl"]["oDomRef"]["select"]();
		}
		if (UCF_UserAgent["bIsSafari"]()) {
			// Safari dosn't raise onselect browser event
			this["oControl"]["sSelectedValue"] = this["oControl"]["oDomRef"]["value"]["slice"](
				this["oControl"]["oDomRef"]["selectionStart"],
				this["oControl"]["oDomRef"]["selectionEnd"]
			);
		}
	} else if (window["getSelection"] && document["createRange"]) {
		// Chrome, Firefox, IE11
		selection = window["getSelection"]();
		range = document["createRange"]();
		range["selectNodeContents"](this["oControl"]["oDomRef"]);
		selection["removeAllRanges"]();
		selection["addRange"](range);
	} else if (document["body"]["createTextRange"]) {
		// IE11
		range = document["body"]["createTextRange"]();
		range["moveToElementText"](this["oControl"]["oDomRef"]);
		range["select"]();
	}
	this["bSelected"] = true;
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["selectText"] = 0; };

/** @private */
UCF_ToolbarFieldNavigationDelegate["prototype"]["deselectText"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["deselectText"]++; }; 
	if (this["oControl"]["oDomRef"]["select"]) {
		this["oControl"]["oDomRef"]["selectionStart"] = 0;
		this["oControl"]["oDomRef"]["selectionEnd"] = 0;
	} else {
		UCF_DomUtil["removeSelection"]();
	}
	this["bSelected"] = false;
};;if (__UCF_COVERAGE__) { UCF_ToolbarFieldNavigationDelegate["_"]["deselectText"] = 0; };

};
sap["ls"]["preload"]["UCF_ToolbarOverflowDelegate"] = function() {/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../../core/KeyboardHelper.js"/>
/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_ToolbarOverflowDecorator */
/// <reference path="../decorators/ToolbarOverflowDecorator.js"/>
/* global UCF_ToolbarOverflowMenuDecorator */
/// <reference path="../decorators/ToolbarOverflowMenuDecorator.js"/>
/* global UCF_ToolbarOverflowViewDecorator */
/// <reference path="../decorators/ToolbarOverflowViewDecorator.js"/>
/**
 * @constructor UCF_ToolbarOverflowDelegate
 * @extends UCF_Object
 * @param {UCF_Toolbar} oControl the field
 * @param {UCF_LS} oLS
 * @param {boolean} bOpenMenu the field
 */
function UCF_ToolbarOverflowDelegate(oControl, oLS, bOpenMenu) {if (__UCF_COVERAGE__) { UCF_ToolbarOverflowDelegate["_"]["UCF_ToolbarOverflowDelegate"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Object["apply"](this, []);

		this["oControl"] = oControl;
		this["oLS"] = oLS;
		this["oToolbarOverflowDecorator"] = this["oGetDecorator"](this["oControl"], this["oLS"], bOpenMenu);
	}
};window["UCF_ToolbarOverflowDelegate"] = UCF_ToolbarOverflowDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ToolbarOverflowDelegate"); UCF_ToolbarOverflowDelegate["_"] = {UCF_ToolbarOverflowDelegate: 0}; }; ;
UCF_ToolbarOverflowDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_ToolbarOverflowDelegate.prototype["sClassName"] = "UCF_ToolbarOverflowDelegate";

/** @override */
UCF_ToolbarOverflowDelegate["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowDelegate["_"]["destroy"]++; }; 

	this["oControl"] = null;
	if (this["oToolbarOverflowDecorator"]) {
		this["oToolbarOverflowDecorator"]["destroy"]();
		this["oToolbarOverflowDecorator"] = null;
	}

	this["oLS"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowDelegate["_"]["destroy"] = 0; };

/**
 * @protected
 * @param {UCF_Event} oEvent on opening the Overflow
 */
UCF_ToolbarOverflowDelegate["prototype"]["onOverflowOpen"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowDelegate["_"]["onOverflowOpen"]++; }; 
	this["oToolbarOverflowDecorator"]["openOverflow"](oEvent);
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowDelegate["_"]["onOverflowOpen"] = 0; };

/**
 * @protected
 * @param { UCF_Event } oEvent on opening the Overflow
 */
UCF_ToolbarOverflowDelegate["prototype"]["onOverflowClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowDelegate["_"]["onOverflowClose"]++; }; 
	this["oToolbarOverflowDecorator"]["closeOverflow"](oEvent);
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowDelegate["_"]["onOverflowClose"] = 0; };

/**
 * @protected
 * @param {UCF_Toolbar} oControl - the Control which will set the decorators
 * @param {UCF_LS} oLS
 * @param {boolean} bOpenMenu - decide which decorator will be open
 * @return {Object}
 */
UCF_ToolbarOverflowDelegate["prototype"]["oGetDecorator"] = function(oControl, oLS, bOpenMenu) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowDelegate["_"]["oGetDecorator"]++; }; 
	if (bOpenMenu) {
		return new (UCF_ClassLoader["oGetClass"]("UCF_ToolbarOverflowMenuDecorator"))(oControl, oLS);
	} else {
		return new (UCF_ClassLoader["oGetClass"]("UCF_ToolbarOverflowViewDecorator"))(oControl, oLS);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowDelegate["_"]["oGetDecorator"] = 0; };

};
sap["ls"]["preload"]["UCF_ToolbarOverflowMenuDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/// <referenc/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_ClientPopupMenuHelper */
/// <reference path="../../helper/ClientPopupMenuHelper.js"/>
/* global UCF_LayeredControl */
/// <reference path="../base/LayeredControl.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_Event */
/// <reference path="../../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>
/**
 * A generic Toolbar Overflow PopupMenu decorator implementation.
 * @class
 * @param {UCF_Object} oControl Control instance
 * @param {UCF_LS } oLS
 */
function UCF_ToolbarOverflowMenuDecorator(oControl, oLS) {if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["UCF_ToolbarOverflowMenuDecorator"]++; }; 

	if (arguments["length"] === 0) return;

	this["oToolbar"] = oControl;
	this["oLS"] = oLS;
	this["sPopupMenuId"] = oControl["sId"] + '__tbarMenu';
};window["UCF_ToolbarOverflowMenuDecorator"] = UCF_ToolbarOverflowMenuDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ToolbarOverflowMenuDecorator"); UCF_ToolbarOverflowMenuDecorator["_"] = {UCF_ToolbarOverflowMenuDecorator: 0}; }; ;
UCF_ToolbarOverflowMenuDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_ToolbarOverflowMenuDecorator.prototype["sClassName"] = "UCF_ToolbarOverflowMenuDecorator";

/**
 * destructor
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["destroy"]++; }; 
	this["oToolbar"] = null;
	this["oLS"] = null;
	if (this["oPopupMenu"]) {
		UCF_ClientPopupMenuHelper["handleDestroy"](this["oPopupMenu"]);
		this["oPopupMenu"] = null;
	}
	this["sPopupMenuId"] = null;
	this["aItems"] = null;
	this["bTabbedOutOfMenu"] = false;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["destroy"] = 0; };

/**
 * creates dom
 * @param { UCF_Event } oEvent on opening the Overflow
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["openOverflow"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["openOverflow"]++; }; 
	if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"]();
		this["oToolbar"]["toggleOverflowPress"](false);
	} else {
		this["aItems"] = oEvent["oGetParam"]('aItems');
		this["handlePopupMenuOpen"](this["aItems"], oEvent["oGetParam"]('bWithKeyboard'));
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["openOverflow"] = 0; };

/**
 * Returns the overflow opening status
 * @return {boolean} - true if the overflow is opened
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["isOverflowOpened"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["isOverflowOpened"]++; }; 
	return (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]);
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["isOverflowOpened"] = 0; };

/**
 * Closes the PopupMenu and resets the opener the down state
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["closeOverflow"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["closeOverflow"]++; }; 
	if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"]();
		this["oToolbar"]["toggleOverflowPress"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["closeOverflow"] = 0; };

/**
 * Update items, render menu and open it.
 * @param {Array} aItems
 * @param {boolean} bWithKeyboard - if the PopupMenu will be opne with keyboard
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["handlePopupMenuOpen"] = function(aItems, bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["handlePopupMenuOpen"]++; }; 
	var oMenuHelper = new (UCF_ClassLoader["oGetClass"]("UCF_ClientPopupMenuHelper"))(this["oLS"]);
	this["oPopupMenu"] = oMenuHelper["oRenderMenu"](
		this["sPopupMenuId"],
		null,
		//this.oLS.oGetAssociatedAreaRef(),
		this["createPopupMenuItems"](aItems)
	);
	//The dom reference of the opener control, that should be used for alignment.
	this["oPopupMenu"]["setOpenerRef"](this["oToolbar"]["oGetPopupOpener"]());
	//control id of the control that opened the PopupMenu
	this["oPopupMenu"]["setOpenerId"](this["oToolbar"]["sGetPopupOpenerId"]());
	this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
	this["oPopupMenu"]["bAutoRefocus"] = false;

	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, "onMenuItemSelect");
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["MenuAccess"], this, "onSubMenuAccess");

	this["oPopupMenu"]["bContentChanged"] = false;
	// do not call the delayed call, otherwise items are not present when trying to access them first
	this["oPopupMenu"]["open"](bWithKeyboard);
	this["oToolbar"]["toggleOverflowPress"](true);
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["handlePopupMenuOpen"] = 0; };

/**
 * Creates new PopupMenuItems in the overflow menu with the properties of all hidden buttons.
 * @param {Array} aItems
 * @return {Object} - an array with JSONs with PopupMenuItem
 * @private
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["createPopupMenuItems"] = function(aItems) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["createPopupMenuItems"]++; }; 
	var aNewItems = [];
	var oItem, bIsHidden, bHasSeparator, bLastSegmentedButton = false;

	for (var i = 0; i < aItems["length"]; i++) {
		oItem = aItems[i];
		bIsHidden = oItem["bIsHidden"];
		bHasSeparator = oItem["bHasSeparator"] || bLastSegmentedButton;
		bLastSegmentedButton = false;
		if (oItem["setDelegateOpenMenu"]) {
			oItem["setDelegateOpenMenu"](bIsHidden);
		}

		if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Button")) {
			oItem["setDelegateOpenMenu"](bIsHidden);
			oItem["attachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
			aNewItems["push"](this["addButtonToMenu"](oItem, bHasSeparator));
		} else if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Link")) {
			aNewItems["push"](this["addLinkToMenu"](oItem, bHasSeparator));
		} else if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_LinkChoice")) {
			oItem["setDelegateOpenMenu"](bIsHidden);
			oItem["attachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
			aNewItems["push"](this["addLinkChoiceToMenu"](oItem, bHasSeparator));
		} else if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_SegmentedButton")) {
			//	oItem.setDelegateOpenMenu(bIsHidden);
			var oButtonsItems = UCF_JsUtil["values"](oItem["oGetButtons"]());
			for (var j = 0; j < oButtonsItems["length"]; j++) {
				var oButton = oButtonsItems[j];
				oButton["attachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
				oButton["setDelegateOpenMenu"](bIsHidden);
				aNewItems["push"](this["addButtonToMenu"](oButton, (j === 0)));
			}
			bLastSegmentedButton = true;
		}
	}
	return aNewItems;
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["createPopupMenuItems"] = 0; };

/**
 * Create a PopupMenuItem with the values of a Button control
 * @param {Object} oButton - the Button object
 * @param {boolean} bHasSeparator - true if it should be render a separator after the PopupMenuItems
 * @return {PopupMenuItem} - the JSON for clientside PopupMenuItem
 * @private
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["addButtonToMenu"] = function(oButton, bHasSeparator) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["addButtonToMenu"]++; }; 

	var bIconButton = oButton["bHasCssIcon"](),
		sIconSrc = bIconButton ? oButton["sIconButtonClass"]() : oButton["sGetIconSource"](),
		sSuffix = this["sGetToolbarItemType"](oButton) === this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"] ?
		"-" + this["MENU_ITEM_TYPE"]["BUTTONCHOICE"] : "-" + this["MENU_ITEM_TYPE"]["BUTTON"],
		sText = oButton["sGetText"]();

	return {
		"PopupMenuItem": {
			"Id": oButton["sId"] + sSuffix,
			"Text": sText,
			"CanCheck": oButton["bDown"] || oButton["sDesign"] === "TOGGLE",
			"Checked": oButton["bDown"],
			"Enabled": oButton["bEnabled"],
			"SubMenuId": oButton["sPopupMenuId"],
			"HasSubMenu": oButton["bHasPopupMenu"],
			"HasElipsis": oButton["bTextOverflow"],
			"HasIcon": !UCF_StringUtil["bIsEmpty"](sIconSrc) || (!UCF_StringUtil["bIsEmpty"](oButton["sDisabledIconSrc"]) && !oButton["bEnabled"]),
			"EnabledIconSrc": sIconSrc,
			"DisabledIconSrc": !UCF_StringUtil["bIsEmpty"](oButton["sDisabledIconSrc"]) ? oButton["sDisabledIconSrc"] : sIconSrc,
			"HasSubMenuSection": oButton["bHasPopupMenuSection"],
			"Hotkey": oButton["sHotkey"],
			"Tooltip": ((sText && UCF_StringUtil["bIsEmpty"](sText)) ? oButton["sTooltip"] : ""),
			"HasSeparator": bHasSeparator
		}
	};
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["addButtonToMenu"] = 0; };

/**
 * Create a PopupMenuItem with the values of a Link control
 * @param {Object} oLink - the Link control
 * @param {boolean} bHasSeparator - true if it should be render a separator after the PopupMenuItems
 * @return {PopupMenuItem} - the JSON for clientside PopupMenuItem
 * @private
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["addLinkToMenu"] = function(oLink, bHasSeparator) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["addLinkToMenu"]++; }; 

	var sIconSrc = oLink["sGetIconSource"](),
		bHasIcon = !UCF_StringUtil["bIsEmpty"](sIconSrc);

	return {
		"PopupMenuItem": {
			"Id": oLink["sId"] + "-LinkMenu",
			"Text": oLink["sText"], //oLink.sGetTitle(), - in ARAI mode the getTitle retrive a double text
			"HasSeparator": bHasSeparator,
			"Enabled": oLink["bEnabled"],
			"HasIcon": bHasIcon,
			"EnabledIconSrc": sIconSrc,
			"DisabledIconSrc": sIconSrc,
			"Hotkey": oLink["sHotkey"],
			"Tooltip": oLink["sTooltip"]
		}
	};
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["addLinkToMenu"] = 0; };

/**
 * Create a PopupMenuItem with the values of a LinkChoice control
 * @param {Object} oLink - the LinkChoice object
 * @param {boolean} bHasSeparator - true if it should be render a separator after the PopupMenuItems
 * @return {PopupMenuItem} - the JSON for clientside PopupMenuItem
 * @private
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["addLinkChoiceToMenu"] = function(oLink, bHasSeparator) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["addLinkChoiceToMenu"]++; }; 

	var sIconSrc = oLink["sGetIconSource"](),
		bHasIcon = !UCF_StringUtil["bIsEmpty"](sIconSrc);

	return {
		"PopupMenuItem": {
			"Id": oLink["sId"] + "-LinkChoiceMenu",
			"Text": oLink["sText"], //oLink.sGetTitle(), - in ARAI mode the getTitle retrive a double text
			"HasSeparator": bHasSeparator,
			"Enabled": oLink["bEnabled"],
			"SubMenuId": oLink["sPopupMenuId"],
			"HasSubMenu": true,
			"HasIcon": bHasIcon,
			"EnabledIconSrc": sIconSrc,
			"DisabledIconSrc": sIconSrc,
			"Tooltip": oLink["sTooltip"]
		}
	};
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["addLinkChoiceToMenu"] = 0; };

/**
 * enumerates the possible types of menu items.
 * @private
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["TOOLBAR_ITEM_TYPE"] = {
	"BUTTON": 0,
	"BUTTONCHOICE": 1,
	"LINK": 2,
	"LINKCHOICE": 3
};

/**
 * @private
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["MENU_ITEM_TYPE"] = {
	"BUTTON": "BtnMenu",
	"BUTTONCHOICE": "BtnChoiceMenu",
	"LINK": "LinkMenu",
	"LINKCHOICE": "LinkChoiceMenu"
};

/**
 * Determines whether out of which toolbar control the menu item was created.
 * @param {string} sId  - the id of the control
 * @return {string} the toolbar item type
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["sGetMenuItemType"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["sGetMenuItemType"]++; }; 

	if (sId === null) return null;

	var aType = sId["split"]("-"),
		sType = aType[aType["length"] - 1];

	switch (sType) {
		case this["MENU_ITEM_TYPE"]["BUTTON"]:
			return this["TOOLBAR_ITEM_TYPE"]["BUTTON"];

		case this["MENU_ITEM_TYPE"]["BUTTONCHOICE"]:
			return this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"];

		case this["MENU_ITEM_TYPE"]["LINK"]:
			return this["TOOLBAR_ITEM_TYPE"]["LINK"];

		case this["MENU_ITEM_TYPE"]["LINKCHOICE"]:
			return this["TOOLBAR_ITEM_TYPE"]["LINKCHOICE"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["sGetMenuItemType"] = 0; };

/**
 * Determines the toolbar item control type
 * @param {UCF_Control} oItem  - the control
 * @return {string} the toolbar item type
 * @private
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["sGetToolbarItemType"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["sGetToolbarItemType"]++; }; 
	var sClassName = oItem["sClassName"];

	switch (sClassName) {
		case "UCF_Button":
			return (!oItem["bHasPopupMenu"]) ? this["TOOLBAR_ITEM_TYPE"]["BUTTON"] : this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"];

		case "UCF_Link":
			return this["TOOLBAR_ITEM_TYPE"]["LINK"];

		case "UCF_LinkChoice":
			return this["TOOLBAR_ITEM_TYPE"]["LINKCHOICE"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["sGetToolbarItemType"] = 0; };

/**
 * When an item is selected, fire the according event on the
 * corresponding toolbar item that is hidden
 * @param {UCF_BrowserEvent} oEvent the event object that occurred
 * @private
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["onMenuItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["onMenuItemSelect"]++; }; 
	var sMenuItemId = oEvent["oGetParam"]("sItemId"),
		sId = sMenuItemId["split"]("-")[0],
		oToolbarItem = this["oLS"]["oControlFactory"]["oGetControlById"](sId);

	if (this["sGetMenuItemType"](sMenuItemId) === this["TOOLBAR_ITEM_TYPE"]["BUTTON"]) {
		oToolbarItem["fireEvent"](oToolbarItem["E_EVENTS"]["Press"], { "sId": oToolbarItem["sId"] });
		oToolbarItem["firePress"](oToolbarItem["sId"]);
	} else if (this["sGetMenuItemType"](sMenuItemId) === this["TOOLBAR_ITEM_TYPE"]["LINK"]) {
		oToolbarItem["fireActivate"](oToolbarItem["sId"]);
	} else if (this["sGetMenuItemType"](sMenuItemId) === this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"]) {
		var oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent"),
			oSource = oBrowserEvent["oGetSource"](),
			oMenuItem = UCF_DomUtil["$"](sMenuItemId),
			oMenuSection = UCF_DomUtil["lastChild"](oMenuItem, "TD");

		if (oSource !== oMenuSection) {
			oToolbarItem["firePress"](oToolbarItem["sId"]);
		}

	}

	this["oToolbar"]["setFocusFromHiddenItem"](true);
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["onMenuItemSelect"] = 0; };

/**
 * All toolbar items that have their own menu can fire a OpenMenu event. If the menu is rendered on the server
 * the toobar item must not open the menu, when it is currently not visible. Instead it fires an OpenMenu event.
 * The Toolbar listens to the event and handles it in this function.
 * @param {UCF_BrowserEvent} oEvent the event object that occurred
 * @private
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["onToolbarItemMenuOpen"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["onToolbarItemMenuOpen"]++; }; 
	var sSumMenuId = oEvent["oGetParam"]("sMenuId"),
		sToolbarItemId = oEvent["oGetParam"]("sId"),
		oToolbarItem = this["oLS"]["oControlFactory"]["oGetControlById"](sToolbarItemId),
		sToolbarItemType = this["sGetToolbarItemType"](oToolbarItem),
		sEndFix = "-";

	switch (sToolbarItemType) {
		case this["TOOLBAR_ITEM_TYPE"]["BUTTON"]:
			sEndFix += this["MENU_ITEM_TYPE"]["BUTTON"];
			break;

		case this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"]:
			sEndFix += this["MENU_ITEM_TYPE"]["BUTTONCHOICE"];
			break;

		case this["TOOLBAR_ITEM_TYPE"]["LINKCHOICE"]:
			sEndFix += this["MENU_ITEM_TYPE"]["LINKCHOICE"];
			break;

		case this["TOOLBAR_ITEM_TYPE"]["LINK"]:
			sEndFix += this["MENU_ITEM_TYPE"]["LINK"];
	}

	var sMenuItemId = sToolbarItemId + sEndFix,
		oMenuItem = this["oLS"]["oControlFactory"]["oGetControlById"](sMenuItemId);
	if (oMenuItem) {
		oMenuItem["setSubMenuId"](sSumMenuId);
		oMenuItem["openSubMenu"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["onToolbarItemMenuOpen"] = 0; };

/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @param {UCF_BrowserEvent} oEvent  when the menu is closed
 * @private
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["onMenuClose"]++; }; 
	if (this["aItems"]) {
		for (var i = 0; i < this["aItems"]["length"]; i++) {
			var oItem = this["aItems"][i];
			if (oItem && oItem["E_EVENTS"] && oItem["E_EVENTS"]["OpenMenu"])
				oItem["detachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
		}
	}
	this["oToolbar"]["toggleOverflowPress"](false);
	this["oToolbar"]["bOverflowMenuJustClosed"] = false;

	//TODO: destroy items?
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, "onMenuItemSelect");
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["MenuAccess"], this, "onSubMenuAccess");

	//@ToDo set the focus on the opener
	if (!this["bTabbedOutOfMenu"])
		this["oToolbar"]["setFocusOnOpener"]();
	this["bTabbedOutOfMenu"] = false;
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["onMenuClose"] = 0; };

/**
 * If menu of toolbar item is loaded from server, the menu item fires a MenuAccess event.
 * The toolbar handles it in this function. It finds the toolbar item represented by the menu item
 * and programmatically triggers the MenuAcces event there, again.
 * @param {UCF_BrowserEvent} oEvent the event object that occurred
 * @private
 */
UCF_ToolbarOverflowMenuDecorator["prototype"]["onSubMenuAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["onSubMenuAccess"]++; }; 

	var sItemId = oEvent["oGetParam"]("sMenuId")["split"]("-")[0],
		bEnabled = oEvent["oGetParam"]("bEnabled"),
		oTbarItem = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);

	if (bEnabled) {
		oTbarItem["fireMenuAccess"](oTbarItem["sId"], oTbarItem["sPopupMenuId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowMenuDecorator["_"]["onSubMenuAccess"] = 0; };

};
sap["ls"]["preload"]["UCF_ToolbarOverflowViewDecorator"] = function() {/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Object */
/// <reference path="../../../core/Object.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global _assert, _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/// <referenc/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_ClientPopupMenuHelper */
/// <reference path="../../helper/ClientPopupMenuHelper.js"/>
/* global UCF_LayeredControl */
/// <reference path="../base/LayeredControl.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_Event */
/// <reference path="../../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>

/**
 * A generic Toolbar Overflow HeierachicalView decorator implementation.
 * @class
 * @param {UCF_Object} oControl Control instance
 * @param {UCF_LS } oLS
 */
function UCF_ToolbarOverflowViewDecorator(oControl, oLS) {if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["UCF_ToolbarOverflowViewDecorator"]++; }; 

	if (arguments["length"] === 0) return;

	this["oToolbar"] = oControl;
	this["oLS"] = oLS;

	this["sPopupMenuId"] = oControl["sId"] + '__tbarMenu';
	this["bHasHierarchicalViewTitle"] = false;
	this["oHiddenOpener"] = null;
	// Toolbar.OverflowClose - closed the QuickView when is clicked outside
	this["bRenderClose"] = !this["oLS"]["oGetRenderManager"]()["callFragment"](
		'IsEnabled',
		'FeatureFlags', { "Feature": 'Toolbar.OverflowClose' }
	);
	this["bHasMinWin"] = this["oLS"]["oGetRenderManager"]()["callFragment"](
		'IsEnabled',
		'FeatureFlags', { "Feature": 'Toolbar.OverflowViewWidth' }
	);
	this["aItems"] = null;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'ToolbarOverflowDecorator - constructor', "ToolbarOverflowViewDecorator.js(52): UCF_ToolbarOverflowViewDecorator"); };
};window["UCF_ToolbarOverflowViewDecorator"] = UCF_ToolbarOverflowViewDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ToolbarOverflowViewDecorator"); UCF_ToolbarOverflowViewDecorator["_"] = {UCF_ToolbarOverflowViewDecorator: 0}; }; ;
UCF_ToolbarOverflowViewDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_ToolbarOverflowViewDecorator.prototype["sClassName"] = "UCF_ToolbarOverflowViewDecorator";

/**
 * destructor
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["destroy"]++; }; 
	this["oToolbar"] = null;
	this["oLS"] = null;
	if (this["oQuickView"]) {
		this["oQuickView"]["detachEvent"]('Close', this, "onQuickViewClose");
		this["oQuickView"]["close"]();
	}
	this["oQuickView"] = null;
	this["bHasHierarchicalViewTitle"] = null;
	this["oHiddenOpener"] = null;
	this["sPopupMenuId"] = null;
	this["aItems"] = null;
	this["bRenderClose"] = null;
	this["bHasMinWin"] = null;
	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["destroy"] = 0; };

/**
 * creates dom
 * @param { UCF_Event } oEvent on opening the Overflow
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["openOverflow"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["openOverflow"]++; }; 
	if (this["oQuickView"] && this["oQuickView"]["bOpened"] && this["oToolbar"]["bOverflowIsPressed"]()) {
		this["closeQuickView"]();
	} else {
		if (this["oHiddenOpener"] == null) {
			this["oHiddenOpener"] = UCF_DomUtil["$"](oEvent["oGetParam"]('sOpenerId'));
		}
		this["aItems"] = oEvent["oGetParam"]('aItems');
		this["openHierarchycalView"]();
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["openOverflow"] = 0; };

/**
 * removes elements from DOM
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["closeOverflow"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["closeOverflow"]++; }; 
	this["closeQuickView"]();
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["closeOverflow"] = 0; };

UCF_ToolbarOverflowViewDecorator["prototype"]["openHierarchycalView"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["openHierarchycalView"]++; }; 
	this["bHasHierarchicalViewTitle"] = false;

	var oClientQuickView = this["createHierarchycalView"](this["sPopupMenuId"]);
	// Note: placeAt() calls UCF_CLientControl.replace() which is (re-)rendering the control synchronously
	// when it is already invalidated (which is the case because we modified the Items aggregation before)
	oClientQuickView["placeAt"](this["oHiddenOpener"]);
	this["oQuickView"] = this["oLS"]["oControlFactory"]["oGetControlById"](this["sPopupMenuId"]);
	if (this["oQuickView"]) {
		this["oQuickView"]["openAtControl"](this["oHiddenOpener"]["id"], false);
		this["oQuickView"]["attachEvent"]('Close', this, "onQuickViewClose");
		if (!this["bRenderClose"])
			this["oQuickView"]["attachSemanticEvent"]('Close', this, 'onQuickViewSemanticClose');
		//	this.oLS.oBrowserWindow.attachEvent(this.oLS.oBrowserWindow.E_EVENTS.LayeredControlClose, this, 'onControlClose');
		if (this["bRenderClose"]) {
			var oCloseButon = this["oLS"]["oControlFactory"]["oGetControlById"](this["sPopupMenuId"] + '_close');
			if (oCloseButon)
				oCloseButon["attachSemanticEvent"]('Press', this, 'onQuickViewSemanticClose');
		}
		this["connectControls"]();
		this["oToolbar"]["toggleOverflowPress"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["openHierarchycalView"] = 0; };

/**
 * @protected
 * Creates the QuickView container with the HierarchicalView inside
 * @param {string} sId
 * @return {UCF_Control} oControl
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["createHierarchycalView"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["createHierarchycalView"]++; }; 
	var aHiddendControls = this["generatesJSONList"](this["aItems"]);
	return this["oLS"]["oCreateClientControl"]({
		"QuickView": {
			"Id": sId,
			"Behavior": 'POPOVER',
			"PopOverCloseEvent": true,
			"PopOverAlignment": 'DEFAULT',
			"Content": {
				"HierarchicalView": {
					"Id": sId + '_hv',
					"Close": this["bRenderClose"] ? { "Button": { "Id": sId + '_close', "HasIcon": true, "UpIconSrc": 'sap-icon://decline', "Design": 'TRANSPARENT' } } : {},
					//	Name: 'Overflow Items with Long Name',
					"Navigation": this["bHasHierarchicalViewTitle"] || this["bRenderClose"] ? 'BREADCRUMB_SELF' : 'NONE',
					"Items": aHiddendControls,
					"Width": this["bHasMinWin"] ? '300px' : '',
					"Height": this["bHasMinWin"] ? '100%' : ''
				}
			}
		}
	});
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["createHierarchycalView"] = 0; };

/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @param {UCF_BrowserEvent} oEvent  when the menu is closed
 * @private
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["onQuickViewClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["onQuickViewClose"]++; }; 
	this["closeQuickView"]();
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["onQuickViewClose"] = 0; };

/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @param {UCF_BrowserEvent} oEvent  when the menu is closed
 * @private
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["onControlClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["onControlClose"]++; }; 
	//debugger;
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["onControlClose"] = 0; };

/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @param {UCF_BrowserEvent} oEvent  when the menu is closed
 * @private
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["onQuickViewSemanticClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["onQuickViewSemanticClose"]++; }; 
	this["closeQuickView"]();
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["onQuickViewSemanticClose"] = 0; };
/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @private
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["closeQuickView"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["closeQuickView"]++; }; 
	this["transferDataBeforeClose"]();
	if (this["oQuickView"]) {
		this["oQuickView"]["detachEvent"]('Close', this, "onQuickViewClose");
		this["oQuickView"]["close"]();
		this["oToolbar"]["toggleOverflowPress"](false);
	}
	this["aItems"] = null;
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["closeQuickView"] = 0; };

/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @private
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["transferDataBeforeClose"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["transferDataBeforeClose"]++; }; 
	var oControl;
	var oHVClientControl;
	if (this["aItems"] === null) return;
	for (var i = 0; i < this["aItems"]["length"]; i++) {
		oControl = this["aItems"][i];
		if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_InputField')) {
			oHVClientControl = this["oLS"]["oGetClientControlById"](oControl["sId"] + '_hv');
			if (oHVClientControl)
				oControl["setValue"](oHVClientControl["getValue"]());
		} else if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_ComboBox')) {
			oHVClientControl = this["oLS"]["oGetClientControlById"](oControl["sId"] + '_hv');
			if (oHVClientControl)
				oControl["setValue"](oHVClientControl["getValue"]());
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["transferDataBeforeClose"] = 0; };

/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @private
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["connectControls"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["connectControls"]++; }; 
	var oControl;
	var oHVClientControl;
	if (this["aItems"] === null) return;
	for (var i = 0; i < this["aItems"]["length"]; i++) {
		oControl = this["aItems"][i];
		if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_InputField')) {
			oHVClientControl = this["oLS"]["oControlFactory"]["oGetControlById"](oControl["sId"] + '_hv');
			if (oHVClientControl) {
				oHVClientControl["addDelegate"](oControl);
			}

		} else if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_ComboBox')) {
			oHVClientControl = this["oLS"]["oControlFactory"]["oGetControlById"](oControl["sId"] + '_hv');
			if (oHVClientControl) {
				oHVClientControl["addDelegate"](oControl);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["connectControls"] = 0; };

/**
 * Generates the List
 * @param {Array} aItems
 */

UCF_ToolbarOverflowViewDecorator["prototype"]["generatesJSONList"] = function(aItems) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["generatesJSONList"]++; }; 
	var aJSONList = [],
		oCOntrolJSON;
	for (var i = 0; i < aItems["length"]; i++) {
		oCOntrolJSON = this["oFromControl"](aItems[i]);
		if (oCOntrolJSON) aJSONList["push"](oCOntrolJSON);
	}
	return aJSONList;
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["generatesJSONList"] = 0; };
/**
 * @protected
 * @param {UCF_Control} oControl
 * @return {Object}
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["oFromControl"] = function(oControl) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromControl"]++; }; 

	if (oControl) {
		if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_PopupMenu')) {
			this["bHasHierarchicalViewTitle"] = true;
			return this["oFromPopupMenu"](oControl);
		} else if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_PopupMenuItem')) {
			return this["oFromPopupMenuItem"](oControl);
		} else if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_Button')) {
			return this["oFromButton"](oControl);
		} else if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_Link')) {
			return this["oFromLink"](oControl);
		} else if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_LinkChoice')) {
			this["bHasHierarchicalViewTitle"] = true;
			return this["oFromLinkChoice"](oControl);
		} else if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_InputField')) {
			return this["oFromInputField"](oControl);
		} else if (UCF_JsUtil["bInstanceOf"](oControl, 'UCF_ComboBox')) {
			return this["oFromComboBox"](oControl);
		} {
			return null;
		}
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromControl"] = 0; };
// #endregion
// #region oFromPopupMenu -----------------------------------------------------
/**
 * @private
 * @param {UCF_PopupMenu} oPopupMenu
 * @return {UCF_HierarchicalView_PopupMenuRenderInfo}
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["oFromPopupMenu"] = function(oPopupMenu) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromPopupMenu"]++; }; 
	/** @type {UCF_HierarchicalView} */
	var self = this;
	/** @type {UCF_PopupMenuItem[]} */
	var aItems = oPopupMenu["aGetItems"]() || [];

	return {
		"_sControlClassName": 'PopupMenu',
		"Items": UCF_JsUtil["reduce"](aItems, function(oItems, oItem, i) {
			oItems[i] = self["oFromPopupMenuItem"](oItem);

			return oItems;
		}, { "Position": 0, "length": aItems["length"] })
	};
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromPopupMenu"] = 0; };
// #endregion

// #region oFromButton --------------------------------------------------------
/**
 * @private
 * @param {UCF_Button} oButton
 * @return {Object}
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["oFromButton"] = function(oButton) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromButton"]++; }; 
	var bIconButton = oButton["bHasCssIcon"](),
		sIconSrc = bIconButton ? oButton["sIconButtonClass"]() : oButton["sGetIconSource"](),
		sText = oButton["sGetText"]();
	return {
		"HierarchicalViewItem": {
			"ItemId": oButton["sId"],
			"Text": sText,
			"Enabled": oButton["bEnabled"],
			"Emphasized": false,
			"Readonly": false,
			"Required": false,
			"HasSegment": oButton["bHasPopupMenu"],
			"SegmentId": oButton["sPopupMenuId"],
			"Hotkey": oButton["sHotkey"],
			"UpIconSrc": sIconSrc,
			"DownIconSrc": oButton["sDownIconSrc"],
			"CustomStyle": oButton["sCustomStyle"],
			"Role": 'button'
		}
	};
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromButton"] = 0; };
// #endregion

/**
 * @private
 * @param {UCF_Link} oLink
 * @return {Object}
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["oFromLink"] = function(oLink) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromLink"]++; }; 
	return {
		"HierarchicalViewItem": {
			"ItemId": oLink["sId"],
			"Text": oLink["sText"],
			"Enabled": oLink["bEnabled"],
			"Emphasized": oLink["bEmphasized"],
			"Readonly": false,
			"Required": false,
			"HasSegment": false,
			"SegmentId": '',
			"Hotkey": oLink["sHotkey"],
			"UpIconSrc": oLink["sGetIconSource"](),
			"DownIconSrc": oLink["sGetIconSource"](),
			"CustomStyle": oLink["sCustomStyle"],
			"Role": 'link'
		}
	};
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromLink"] = 0; };
// #endregion

/**
 * @private
 * @param {UCF_LinkChoice} oLinkChoice
 * @return {Object}
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["oFromLinkChoice"] = function(oLinkChoice) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromLinkChoice"]++; }; 
	return {
		"HierarchicalViewItem": {
			"ItemId": oLinkChoice["sId"],
			"Text": oLinkChoice["sText"],
			"Enabled": oLinkChoice["bEnabled"],
			"Emphasized": false,
			"Readonly": false,
			"Required": false,
			"HasSegment": true,
			"SegmentId": oLinkChoice["sPopupMenuId"],
			"Hotkey": '',
			"UpIconSrc": oLinkChoice["sImageSrc"],
			"DownIconSrc": oLinkChoice["sImageSrc"],
			"CustomStyle": oLinkChoice["sCustomStyle"],
			"Role": 'button'
		}
	};
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromLinkChoice"] = 0; };

/**
 * @private
 * @param { UCF_InputField } oInputField
 * @return {Object}
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["oFromInputField"] = function(oInputField) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromInputField"]++; }; 
	var oLabelDomRef = UCF_DomUtil["$"](oInputField["sId"] + '-tlbl'),
		sLabelText = '';
	if (oLabelDomRef) {
		var oLabel = this["oLS"]["oControlFactory"]["oGetControlById"](oInputField["sId"] + '-tlbl');
		sLabelText = oLabel["sText"];
	}
	/** @type {Object} */
	var oControlJSON = oInputField["oGetJSON"]();

	var oClientJSON = UCF_JsUtil["extend"](oControlJSON["InputField"], {
		"Id": oInputField["sId"] + '_hv',
		"LabelText": sLabelText,
		// add association
		"Align": oInputField["sAlign"],
		"TextDirection": oInputField["sTextDirection"],
		"Visibility": oInputField["sVisibility"],
		"FieldHelp": oInputField["sFieldHelp"],
		"Type": oInputField["sType"],
		"IMEMode": oInputField["sIMEMode"],
		"InputState": oInputField["sInputState"],
		"Design": oInputField["sDesign"],
		"SemanticColor": oInputField["sSemanticColor"]
	});
	/** @type {Object} */
	var oClientResult = {};
	oClientResult['ToolbarInputField'] = oClientJSON;
	return oClientResult;
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromInputField"] = 0; };

/**
 * Returns the JSON from the ToolbarComboBox Client for HierarchicalView
 * @private
 * @param { UCF_ComboBox } oComboBox
 * @return {Object}
 */
UCF_ToolbarOverflowViewDecorator["prototype"]["oFromComboBox"] = function(oComboBox) {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromComboBox"]++; }; 
	var oLabelDomRef = UCF_DomUtil["$"](oComboBox["sId"] + '-tlbl'),
		sLabelText = '';
	if (oLabelDomRef) {
		var oLabel = this["oLS"]["oControlFactory"]["oGetControlById"](oComboBox["sId"] + '-tlbl');
		sLabelText = oLabel["sText"];
	}
	/** @type {Object} */
	var oControlJSON = oComboBox["oGetJSON"]();

	var oClientJSON = UCF_JsUtil["extend"](oControlJSON["ComboBox"], {
		"Id": oComboBox["sId"] + '_hv',
		"LabelText": sLabelText,
		// add association - should be implemented in Coltrol.oGetJSON()
		"Behavior": oComboBox["sBehavior"],
		"TextDirection": oComboBox["sTextDirection"],
		"Visibility": oComboBox["sVisibility"],
		"Align": oComboBox["sAlign"],
		"SuggestFilter": oComboBox["sSuggestFilter"],
		"FieldHelp": oComboBox["sFieldHelp"],
		"Type": oComboBox["sType"],
		"IMEMode": oComboBox["sIMEMode"],
		"InputState": oComboBox["sInputState"],
		"Design": oComboBox["sDesign"],
		"SuggestFilterCondition": oComboBox["sSuggestFilterCondition"],
		"TabBehaviour": oComboBox["sTabBehaviour"],
		"SemanticColor": oComboBox["sSemanticColor"]
	});
	/** @type {Object} */
	var oClientResult = {};
	oClientResult['ToolbarComboBox'] = oClientJSON;
	return oClientResult;
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oFromComboBox"] = 0; };

UCF_ToolbarOverflowViewDecorator["prototype"]["oSeparatorJSON"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oSeparatorJSON"]++; }; 
	return { "ToolbarSeparator": { "ItemSeparation": 'MEDIUMWITHLINE' } };
};;if (__UCF_COVERAGE__) { UCF_ToolbarOverflowViewDecorator["_"]["oSeparatorJSON"] = 0; };

};
sap["ls"]["preload"]["UCF_ToolbarSeparator"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ToolbarSeparator(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ToolbarSeparator["_"]["UCF_ToolbarSeparator"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ToolbarSeparator.js(20): UCF_ToolbarSeparator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ToolbarSeparator.js(21): UCF_ToolbarSeparator"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ToolbarSeparator.js(22): UCF_ToolbarSeparator"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_ToolbarSeparator"] = UCF_ToolbarSeparator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ToolbarSeparator"); UCF_ToolbarSeparator["_"] = {UCF_ToolbarSeparator: 0}; }; ;
UCF_ToolbarSeparator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ToolbarSeparator.prototype["sClassName"] = "UCF_ToolbarSeparator";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ToolbarSeparator["prototype"]["aAttributeNames"] = ["sVisibility","sCustomData","sCustomStyle","sHeight"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ToolbarSeparator["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ToolbarSeparator["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ToolbarSeparator["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ToolbarSeparator["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ToolbarSeparator["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ToolbarSeparator["prototype"]["sHeight"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ToolbarSeparator["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ToolbarSeparator["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["sHeight"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("Height", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ToolbarSeparator["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Toolbar_ie6"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ClientPopupMenuHelper */
/// <reference path="../helper/ClientPopupMenuHelper.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_Toolbar */
/// <reference path="./Toolbar.js"/>
/**
 *
 * The Toolbar control for IE Quirks mode.
 *
 *
 * @class
 * 
 *
 * @param {HTMLElement} oDomRef The DOM reference
 * @param {UCF_LS} oLS The LS instance
 */
function UCF_Toolbar_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["UCF_Toolbar_ie6"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "Toolbar_ie6.js(46): UCF_Toolbar_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Toolbar_ie6.js(47): UCF_Toolbar_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Toolbar_ie6.js(48): UCF_Toolbar_ie6"); };

	UCF_Toolbar["apply"](this, [oDomRef, oLS]);

	// container with LeftItems
	this["oViewPort"] = UCF_DomUtil["$"](this["sId"] + '-itms');
	// container with RightItems
	this["oRightItemContainer"] = UCF_DomUtil["$"](this["sId"] + '-rItms');
	this["oHiddenOpener"] = UCF_DomUtil["$"](this["sId"] + '-hiddenOpener');
	this["oPopupOpenerRef"] = this["oHiddenOpener"];
	this["sPopupOpener"] = this["sId"] + '-opener';
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sPopupMenuId"] = '__tbarMenu';
	this["oEndToolbar"] = null;
	if (window["UCF_System"]["bIs508"]) {
		this["oEndToolbar"] = UCF_DomUtil["$"](this["sId"] + '-end');
	}
	/*
	_trace(INFO, 'Toolbar Attributes - 		Id: ' + this.sId + '\nDesign: ' + this.sDesign + '\nHasShowAllState: '
		+ this.bHasShowAllState + '\nShowAll: ' + this.bShowAll + '\nWrapping: ' + this.bWrapping
		+ '\nAccessibilityDescription: ' + this.sAccessibilityDescription + '\nItemOverflow: ' + this.bItemOverflow
		+ '\nCustomStyle: ' + this.sCustomStyle
		+ '\nHasBorder: ' + this.bHasBorder + '\nIsNested: ' + this.bIsNested + '\nToolbarSize: ' + this.sToolbarSize
		+ '\nHasRightItemsFixed: ' + this.bHasRightItemsFixed
		+ '\nTooltip: ' + this.sTooltip);
		*/
	this["iItmsScrollTop"] = 0;

	this["createItems"]();
	// D039230:CSN 270813 2011 - fix the close of the openerMenu by onresize
	this["iToolbarWidth"] = 0;

	if (this["bItemOverflow"] && this["aItems"]["length"] > 0) {
		//this.oViewPort = UCF_DomUtil.$(this.sId + '-itms');
		if (this["oViewPort"]) {
			this["iItmsScrollTop"] = this["oViewPort"]["offsetTop"];
			if (this["oViewPort"] != null) {
				this["attachBrowserEvent"]('mousemove', this["oViewPort"]);
			}
		}
		this["attachBrowserEvent"]('resize', this["oDomRef"]);
		this["adjustFocusHelper"]();
		this["bTabbedOutOfMenu"] = false;
		if (this["oLS"]) {
			this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, 'onLayoutChange');
		}
	}
	this["bLayoutChangeProcessed"] = false;
	// for Quirks mode only
	this["bToolbarOverflowOpen"] = false;

	this["bFocusFromHiddenItem"] = false;
	this["bToolbarWidthMaximized"] = false;
};window["UCF_Toolbar_ie6"] = UCF_Toolbar_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Toolbar_ie6"); UCF_Toolbar_ie6["_"] = {UCF_Toolbar_ie6: 0}; }; ;

UCF_Toolbar_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Toolbar"))(); UCF_Toolbar_ie6.prototype["sClassName"] = "UCF_Toolbar_ie6";

/**
 * Checks whether the items are wrapping
 * @param {HTMLElement} oDomRef - The DOM reference
 * @return {boolean} if the DOM reference is shown or not
 * @private
 */
UCF_Toolbar_ie6["prototype"]["bIsShown"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsShown"]++; }; 
	var bIsShown = true;

	if (typeof oDomRef !== 'undefined' && oDomRef !== null && oDomRef["getAttribute"]('show')) {
		bIsShown = !('false' === oDomRef["getAttribute"]('show'));
	}

	return bIsShown;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsShown"] = 0; };

/**
 * Checks whether the items are wrapping
 * @param {HTMLElement} oDomRef - The DOM reference
 * @return {boolean} if the DOM reference is shown or not
 * @private
 */
UCF_Toolbar_ie6["prototype"]["bIsShowAlwaysItem"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsShowAlwaysItem"]++; }; 
	var bIsShown = false;

	if (typeof oDomRef !== 'undefined' && oDomRef !== null && oDomRef["getAttribute"]('data-showalways')) {
		bIsShown = !('true' === oDomRef["getAttribute"]('data-showalways'));
	}

	return bIsShown;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsShowAlwaysItem"] = 0; };

/**
 * Handles the click event and calls a central handler used for click and enter
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Toolbar_ie6.js(143): onclick"); };
	var bHandled = this["handleEvent"](oBrowserEvent);

	if (bHandled) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onclick"] = 0; };

/**
 * Handles the enter event and calls a central handler used for click and enter
 * @private
 */

UCF_Toolbar_ie6["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsenter"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Toolbar_ie6.js(158): onlsenter"); };

	var bHandled = this["handleEvent"](oBrowserEvent);

	if (bHandled) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsenter"] = 0; };

/**
 * @private
 */

UCF_Toolbar_ie6["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onkeydown"]++; }; 
	var iKey = oBrowserEvent["iKeyCode"](),
		oSourceControl = oBrowserEvent["oGetSourceControl"]();

	// go further only for the Toolbar's menu
	if (oSourceControl && !(UCF_StringUtil["bStartsWith"](oSourceControl["sId"], this["sId"] + '-') || oSourceControl["sId"] === this["sId"]))
		return;

	if (iKey === UCF_KeyCodes["SPACE"]) {
		this["onlsshow"](oBrowserEvent);
		oBrowserEvent["cancel"]();
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onkeydown"] = 0; };

/**
 * @private
 */

UCF_Toolbar_ie6["prototype"]["handleEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["handleEvent"]++; }; 
	var oToggleButton = UCF_DomUtil["$"](this["sId"] + '-tgl'),
		oEventSource = oBrowserEvent["oGetSource"](),
		bHandled = false;

	// TODO: replace by UCF_DomUtil.firstChild(this.oDomRef)
	// to avoid problems with text node
	if (oToggleButton != null && this["bHasShowAllState"] && UCF_DomUtil["bContains"](oToggleButton, oEventSource)) {

		var bOpen = this["bIsToggleButtonExpanded"]();
		this["toggleButtonIcon"](bOpen);
		this["toggleItems"](bOpen);
		bHandled = true;
	} else if (this["aItems"]["length"] > 0
		&& (this["bOpenerTriggered"](oBrowserEvent) || oEventSource === this["oHiddenOpener"])
		&& this["bIsWrapping"]()) {
		this["openPopupMenu"]();
		bHandled = true;
	}

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["handleEvent"] = 0; };
/**
 *  Opens or close the PopupMenu
 */
UCF_Toolbar_ie6["prototype"]["openPopupMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["openPopupMenu"]++; }; 
	if (this["oPopupMenu"] && this["bIsMenuOpened"](this["oPopupMenu"]["bOpened"])) {
		this["oPopupMenu"]["close"]();
		this["bToolbarOverflowOpen"] = false;
	} else {
		this["handlePopupMenuOpen"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["openPopupMenu"] = 0; };

UCF_Toolbar_ie6["prototype"]["bIsMenuOpened"] = function(bMenuOpened) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsMenuOpened"]++; }; 

	return this["bToolbarOverflowOpen"];

};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsMenuOpened"] = 0; };

/**
 * After resizing the toolbar some items may become visible.
 * For these items the delegateOpenMenu property must be changed.
 * Otherwise they cannot be opened programmatically, if relying
 * on "bIsHidden".
 * @private
 */

UCF_Toolbar_ie6["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onresize"]++; }; 

	// Close popup if the toolbar is resized.
	// D039230:CSN 270813 2011 - fix the close of the openerMenu by onresize
	var iWidth = this["oDomRef"]["offsetWidth"];
	var deltaWidth = this["iToolbarWidth"] - iWidth;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bToolbarWidthMaximized"] = deltaWidth < 0;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'onresize(): deltaWidth - ' + deltaWidth, "Toolbar_ie6.js(247): onresize"); };

	if (this["oPopupMenu"] != null
		&& this["oPopupMenu"]["bOpened"] && deltaWidth !== 0) {
		this["oPopupMenu"]["close"]();
		this["bToolbarOverflowOpen"] = false;
		if (this["oHiddenOpener"]) {
			// remove focus
			UCF_DomUtil["setTabIndex"](this["oHiddenOpener"], -1);
			this["oHiddenOpener"]["blur"]();

			UCF_DomUtil["removeClass"](this["oViewPort"]["parentNode"], 'lsTbarNoMnuInd');
			UCF_DomUtil["addClass"](this["oViewPort"]["parentNode"], 'lsTbarMnuInd');

		}
	}
	if (deltaWidth !== 0) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iToolbarWidth"] = iWidth;

		if (typeof(this["sTimeOutId"]) !== 'undefined') {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResize');
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onresize"] = 0; };

UCF_Toolbar_ie6["prototype"]["bMenuOpenerVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bMenuOpenerVisible"]++; }; 

	return this["oPopupMenu"] != null && this["oPopupMenu"]["aItems"]
		&& this["oPopupMenu"]["aItems"]["length"] > 0;

};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bMenuOpenerVisible"] = 0; };

/** @private
 */
UCF_Toolbar_ie6["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onAfterResize"]++; }; 
	this["adjustFocusHelper"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onAfterResize"] = 0; };

/**
 * Open menu with keyboard
 * @private
 */

UCF_Toolbar_ie6["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsshow"]++; }; 
	if (!this["bItemOverflow"]) return;

	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource === this["oHiddenOpener"]) {
		if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
			this["oPopupMenu"]["close"]();
			this["bToolbarOverflowOpen"] = false;
		} else {
			this["handlePopupMenuOpen"](true);
		}
	}
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsshow"] = 0; };

/**
 * Hide / show toolbar items
 *
 * @param {boolean} bOpen - if the items are already shown or not
 * @private
 */
UCF_Toolbar_ie6["prototype"]["toggleItems"] = function(bOpen) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["toggleItems"]++; }; 
	if (this["aToggleItems"] === null) return;

	var sDisplay = bOpen ? 'none' : '';

	for (var i = 0; i < this["aToggleItems"]["length"]; i++) {
		if (this["aToggleItems"][i]) {
			this["aToggleItems"][i]["style"]["display"] = sDisplay;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["toggleItems"] = 0; };

/**
 * Hide / show toolbar items
 *
 * @param { boolean } bExpanded -	if the items are already shown or not
 * @private
 */

UCF_Toolbar_ie6["prototype"]["onToggleButton"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onToggleButton"]++; }; 
	var oToggleButton = UCF_DomUtil["$"](this["sId"] + '-tgl');

	// TODO: replace by UCF_DomUtil.firstChild(this.oDomRef)
	// to avoid problems with text node
	if (oToggleButton != null && this["bHasShowAllState"]) {

		var bOpen = this["bIsToggleButtonExpanded"]();
		this["toggleButtonIcon"](bOpen);
		this["toggleItems"](bOpen);
	}
	oEvent["mParameters"]["CancelEvent"] = true;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onToggleButton"] = 0; };

/**
 * Hide / show toolbar items
 *
 * @param { boolean } bExpanded -	if the items are already shown or not
 * @private
 */
UCF_Toolbar_ie6["prototype"]["toggleButtonIcon"] = function(bExpanded) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["toggleButtonIcon"]++; }; 
	var oToggleButtonIcon = UCF_DomUtil["$"](this["sId"] + '-tgl-img');
	if (!oToggleButtonIcon) return;

	if (bExpanded) {
		UCF_DomUtil["replaceClass"](oToggleButtonIcon, 'urTBtnExp2', 'urTBtnCol2');

	} else {
		UCF_DomUtil["replaceClass"](oToggleButtonIcon, 'urTBtnCol2', 'urTBtnExp2');
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["toggleButtonIcon"] = 0; };

/**
 * Checks if the toggle button is expanded or collapsed
 *
 * @return { boolean } true if the toggle button is expanded
 * @private
 */
UCF_Toolbar_ie6["prototype"]["bIsToggleButtonExpanded"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsToggleButtonExpanded"]++; }; 
	var oToggleButtonIcon = UCF_DomUtil["$"](this["sId"] + '-tgl-img');
	if (!oToggleButtonIcon) return false;

	var sCssClass = 'urTBtnExp2';
	return UCF_DomUtil["bHasClass"](oToggleButtonIcon, sCssClass);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsToggleButtonExpanded"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mousemove
 */
UCF_Toolbar_ie6["prototype"]["onmousemove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onmousemove"]++; }; 

	var oRef = UCF_DomUtil["$"](this["sId"] + '-menuindicator'),
		sCursor = UCF_UserAgent["bIsIE"](100) ? "cursor" : "pointer",
		oEventSource = oBrowserEvent["oGetSource"]();

	if (!this["bItemOverflow"] || oRef === null || this["oViewPort"] === null) return;

	if (!this["bMenuOpenerVisible"]()) return;

	var bShowCursor = (this["bOpenerTriggered"](oBrowserEvent)
		|| oEventSource === this["oHiddenOpener"]) && this["bIsWrapping"]();

	if (bShowCursor && oRef["style"]["cursor"] !== sCursor) {
		oRef["style"]["cursor"] = sCursor;
	} else if (!bShowCursor && oRef["style"]["cursor"] === sCursor) {
		oRef["style"]["cursor"] = '';
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onmousemove"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseout
 */
UCF_Toolbar_ie6["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onmouseout"]++; }; 

	var oRef = UCF_DomUtil["$"](this["sId"] + "-menuindicator"),
		sCursor = UCF_UserAgent["bIsIE"](100) ? "cursor" : "pointer";

	if (!this["bItemOverflow"] || oRef === null || this["oViewPort"] === null) return;
	if (!this["bMenuOpenerVisible"]()) return;
	if (oRef["style"]["cursor"] === sCursor)
		oRef["style"]["cursor"] = "";
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onmouseout"] = 0; };

/**
 * Checks whether the items are wrapping
 * @return {boolean} if the overflow DOM reference is wrapped or not
 * @private
 */
UCF_Toolbar_ie6["prototype"]["bIsWrapping"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsWrapping"]++; }; 
	if (typeof this["oViewPort"] !== "undefined" && this["oViewPort"] != null
		&& this["oViewPort"]["offsetHeight"] !== "undefined"
		&& this["oViewPort"]["scrollHeight"] !== "undefined") {
		//_trace(INFO, "===== -itms - offsetHeight - " + this.oViewPort.offsetHeight+ "px - scrollHeightt - " + this.oViewPort.scrollHeight + "px ");
		//_trace(INFO, "===== -itms - bIsWrapping - " + ((this.oViewPort.offsetHeight + 5) < this.oViewPort.scrollHeight));
		return (this["oViewPort"]["offsetHeight"] + 5) < this["oViewPort"]["scrollHeight"];

	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsWrapping"] = 0; };

/**
 *
 * Find out whether the user has interacted in some way with the opener icon.
 * The opener icon is a background image in order to avoid initial scripting.
 * The user has to interact with its coordinates in some way.
 * The coordinates of the client rectangle defined for the menu indicator.
 *
 * 	y1-------- y1/x2
 *	|			|
 *	|			|
 *	|			|
 *	y2/x1------ x2
 *
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the mouseout
 */

UCF_Toolbar_ie6["prototype"]["bOpenerTriggered"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bOpenerTriggered"]++; }; 

	var oRect = UCF_DomUtil["oGetObjectRect"](this["oViewPort"]),
		//e = oBrowserEvent,
		y1 = oRect["top"],
		y2 = oRect["top"] + oRect["height"],
		x1 = (!window["UCF_System"]["bIsRTL"]) ? oRect["left"] + oRect["width"] - 9 :
		oRect["left"] + 22,
		x2 = (!window["UCF_System"]["bIsRTL"]) ? oRect["left"] + oRect["width"] + 2 :
		oRect["left"];
	//CSN 3144405 2011 - considering the scroll position
	var oScrollOffset = UCF_DomUtil["oGetScrollOffset"](window);
	var iXPos = oBrowserEvent["_iClientX"] + oScrollOffset["x"],
		iYPos = oBrowserEvent["_iClientY"] + oScrollOffset["y"];
	return (!window["UCF_System"]["bIsRTL"]) ?
		(iYPos >= y1 && iYPos <= y2 && iXPos >= x1 && iXPos <= x2) :
		(iYPos >= y1 && iYPos <= y2 && iXPos <= x1 && iXPos >= x2);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bOpenerTriggered"] = 0; };

/**
 * Creates new PopupMenuItems in the overflow menu with the properties of all hidden buttons.
 * @return {Object} - an array with JSONs with PopupMenuItem
 * @private
 */
UCF_Toolbar_ie6["prototype"]["createPopupMenuItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["createPopupMenuItems"]++; }; 
	var aNewItems = [];
	var oItem, oDomRef, bIsHidden, bHasSeparator;
	var sGroupId = null,
		sCurrentGroupId = null;
	var bFirstHiddenItem = true;
	var bIsSeparator = false;
	var bIsQuirksSeparator = false;
	var aItemOverflowItems = [];
	var bIsSeqgmentedButtonSeparator = false;

	aItemOverflowItems = this["aItems"];

	for (var i = 0; i < aItemOverflowItems["length"]; i++) {
		oItem = aItemOverflowItems[i];
		oDomRef = oItem["oTbarRef"];
		bIsHidden = this["bItemIsHidden"](oDomRef) || !UCF_DomUtil["bIsVisible"](oDomRef);

		if (oItem["setDelegateOpenMenu"]) {
			oItem["setDelegateOpenMenu"](bIsHidden);
		}
		if (!bIsHidden) continue;
		//searches for the previous visible tag and check if it is a separator
		//oDomRef = oItem.oTbarRef && oItem.oTbarRef.previousSibling;

		//_trace(INFO, "===== add to the ToolbarOverflow - " + oItem.sId);
		/*	while (oDomRef != null && (oDomRef.nodeType !== 1 || !UCF_DomUtil.bIsVisible(oDomRef))) {
				oDomRef = oDomRef.previousSibling;
			}*/
		if (!this["bIsShown"](oItem["oTbarRef"])) continue;

		bHasSeparator = false || bIsQuirksSeparator || bIsSeqgmentedButtonSeparator;
		bIsSeqgmentedButtonSeparator = false;

		bIsSeparator = !UCF_JsUtil["bInstanceOf"](oItem, 'UCF_SegmentedButton') && oDomRef && oDomRef["nodeType"] === 1 && oDomRef["getAttribute"]('data-separator') === 'true';

		bIsQuirksSeparator = bIsSeparator;

		sCurrentGroupId = oDomRef && oDomRef["hasAttribute"] && oDomRef["hasAttribute"]('data-separator-group') ? oDomRef["getAttribute"]('data-separator-group') : null;
		if (bFirstHiddenItem) {
			sGroupId = sCurrentGroupId;
			bFirstHiddenItem = false;
		}

		if (sGroupId && sCurrentGroupId && sCurrentGroupId !== sGroupId) {
			bHasSeparator = true;
			sGroupId = sCurrentGroupId;
		}

		if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Button")) {
			oItem["setDelegateOpenMenu"](bIsHidden);
			oItem["attachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
			aNewItems["push"](this["addButtonToMenu"](oItem, bHasSeparator));
		} else if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Link")) {
			aNewItems["push"](this["addLinkToMenu"](oItem, bHasSeparator));
		} else if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_LinkChoice")) {
			oItem["setDelegateOpenMenu"](bIsHidden);
			oItem["attachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
			aNewItems["push"](this["addLinkChoiceToMenu"](oItem, bHasSeparator));
		}
	}
	bHasSeparator = false;

	return aNewItems;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["createPopupMenuItems"] = 0; };

/**
 * Create a PopupMenuItem with the values of a Button control
 * @param {Object} oButton - the Button object
 * @param {boolean} bHasSeparator - true if it should be render a separator after the PopupMenuItems
 * @return {PopupMenuItem} - the JSON for clientside PopupMenuItem
 * @private
 */
UCF_Toolbar_ie6["prototype"]["addButtonToMenu"] = function(oButton, bHasSeparator) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["addButtonToMenu"]++; }; 

	var bIconButton = oButton["bHasCssIcon"](),
		sIconSrc = bIconButton ? oButton["sIconButtonClass"]() : oButton["sGetIconSource"](),
		sSuffix = this["sGetToolbarItemType"](oButton) === this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"] ?
		"-" + this["MENU_ITEM_TYPE"]["BUTTONCHOICE"] : "-" + this["MENU_ITEM_TYPE"]["BUTTON"],
		sText = oButton["sGetText"]();

	return {
		"PopupMenuItem": {
			"Id": oButton["sId"] + sSuffix,
			"Text": sText,
			"CanCheck": oButton["sInteractionBehaviour"] === "TOGGLE" || oButton["sDesign"] === "TOGGLE",
			"Checked": oButton["bDown"],
			"Enabled": oButton["bEnabled"],
			"SubMenuId": oButton["sPopupMenuId"],
			"HasSubMenu": oButton["bHasPopupMenu"],
			"HasElipsis": oButton["bTextOverflow"],
			"HasIcon": !UCF_StringUtil["bIsEmpty"](sIconSrc) || (!UCF_StringUtil["bIsEmpty"](oButton["sDisabledIconSrc"]) && !oButton["bEnabled"]),
			"EnabledIconSrc": sIconSrc,
			"DisabledIconSrc": !UCF_StringUtil["bIsEmpty"](oButton["sDisabledIconSrc"]) ? oButton["sDisabledIconSrc"] : sIconSrc,
			"HasSubMenuSection": oButton["bHasPopupMenuSection"],
			"Hotkey": oButton["sHotkey"],
			"Tooltip": ((sText && UCF_StringUtil["bIsEmpty"](sText)) ? oButton["sTooltip"] : ""),
			"HasSeparator": bHasSeparator
		}
	};
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["addButtonToMenu"] = 0; };

/**
 * Create a PopupMenuItem with the values of a Link control
 * @param {Object} oLink - the Link control
 * @param {boolean} bHasSeparator - true if it should be render a separator after the PopupMenuItems
 * @return {PopupMenuItem} - the JSON for clientside PopupMenuItem
 * @private
 */
UCF_Toolbar_ie6["prototype"]["addLinkToMenu"] = function(oLink, bHasSeparator) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["addLinkToMenu"]++; }; 

	var sIconSrc = oLink["sGetIconSource"](),
		bHasIcon = !UCF_StringUtil["bIsEmpty"](sIconSrc);

	return {
		"PopupMenuItem": {
			"Id": oLink["sId"] + "-LinkMenu",
			"Text": oLink["sText"], //oLink.sGetTitle(), - in ARAI mode the getTitle retrive a double text
			"HasSeparator": bHasSeparator,
			"Enabled": oLink["bEnabled"],
			"HasIcon": bHasIcon,
			"EnabledIconSrc": sIconSrc,
			"DisabledIconSrc": sIconSrc,
			"Hotkey": oLink["sHotkey"],
			"Tooltip": oLink["sTooltip"]
		}
	};
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["addLinkToMenu"] = 0; };

/**
 * Create a PopupMenuItem with the values of a LinkChoice control
 * @param {Object} oLink - the LinkChoice object
 * @param {boolean} bHasSeparator - true if it should be render a separator after the PopupMenuItems
 * @return {PopupMenuItem} - the JSON for clientside PopupMenuItem
 * @private
 */
UCF_Toolbar_ie6["prototype"]["addLinkChoiceToMenu"] = function(oLink, bHasSeparator) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["addLinkChoiceToMenu"]++; }; 

	var sIconSrc = oLink["sGetIconSource"](),
		bHasIcon = !UCF_StringUtil["bIsEmpty"](sIconSrc);

	return {
		"PopupMenuItem": {
			"Id": oLink["sId"] + "-LinkChoiceMenu",
			"Text": oLink["sText"], //oLink.sGetTitle(), - in ARAI mode the getTitle retrive a double text
			"HasSeparator": bHasSeparator,
			"Enabled": oLink["bEnabled"],
			"SubMenuId": oLink["sPopupMenuId"],
			"HasSubMenu": true,
			"HasIcon": bHasIcon,
			"EnabledIconSrc": sIconSrc,
			"DisabledIconSrc": sIconSrc,
			"Tooltip": oLink["sTooltip"]
		}
	};
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["addLinkChoiceToMenu"] = 0; };

/**
 * Update items, render menu and open it.
 * @param {boolean} bWithKeyboard - if the PopupMenu will be opne with keyboard
 */
UCF_Toolbar_ie6["prototype"]["handlePopupMenuOpen"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["handlePopupMenuOpen"]++; }; 
	var oMenuHelper = new (UCF_ClassLoader["oGetClass"]("UCF_ClientPopupMenuHelper"))(this["oLS"]);
	this["oPopupMenu"] = oMenuHelper["oRenderMenu"](
		this["sId"] + this["sPopupMenuId"],
		null,
		//this.oLS.oGetAssociatedAreaRef(),
		this["createPopupMenuItems"]()
	);

	this["oPopupMenu"]["setOpenerRef"](this["oPopupOpenerRef"]);
	this["oPopupMenu"]["setOpenerId"](this["sPopupOpener"]);
	this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
	this["oPopupMenu"]["bAutoRefocus"] = false;

	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, "onMenuItemSelect");
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["TabPrevious"], this, "onMenuTabToPrevious");
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["MenuAccess"], this, "onSubMenuAccess");

	this["bToolbarOverflowOpen"] = true;
	this["oPopupMenu"]["bContentChanged"] = false; // do not call the delayed call, otherwise items are not present when trying to access them first
	this["oPopupMenu"]["open"](bWithKeyboard);

};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["handlePopupMenuOpen"] = 0; };

/**
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @param {UCF_BrowserEvent} oEvent  when the menu is closed
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onMenuClose"]++; }; 
	if (!this["bItemOverflow"] || !this["aItems"]) return;

	for (var i = 0; i < this["aItems"]["length"]; i++) {
		var oItem = this["aItems"][i];
		if (oItem && oItem["E_EVENTS"] && oItem["E_EVENTS"]["OpenMenu"])
			oItem["detachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
	}
	//TODO: destroy items?
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, "onMenuItemSelect");
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["TabPrevious"], this, "onMenuTabToPrevious");
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["MenuAccess"], this, "onSubMenuAccess");

	if (!this["bTabbedOutOfMenu"]) {
		//this.oViewPort.scrollTop = this.iItmsScrollTop;
		var oActive = UCF_DomUtil["oGetActiveElement"](),
			bContains = UCF_DomUtil["bContains"](this["oDomRef"], oActive);

		if (!bContains || (bContains && this["bItemIsHidden"](oActive))) {
			UCF_DomUtil["focusDomElement"](this["oHiddenOpener"]);
		}
	}
	this["bTabbedOutOfMenu"] = false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onMenuClose"] = 0; };

/**
 * enumerates the possible types of menu items.
 * @private
 */
UCF_Toolbar_ie6["prototype"]["TOOLBAR_ITEM_TYPE"] = {
	"BUTTON": 0,
	"BUTTONCHOICE": 1,
	"LINK": 2,
	"LINKCHOICE": 3
};

/**
 * @private
 */
UCF_Toolbar_ie6["prototype"]["MENU_ITEM_TYPE"] = {
	"BUTTON": "BtnMenu",
	"BUTTONCHOICE": "BtnChoiceMenu",
	"LINK": "LinkMenu",
	"LINKCHOICE": "LinkChoiceMenu"
};

/**
 * Determines whether out of which toolbar control the menu item was created.
 * @param {string} sId  - the id of the control
 * @return {string} the toolbar item type
 */
UCF_Toolbar_ie6["prototype"]["sGetMenuItemType"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["sGetMenuItemType"]++; }; 

	if (sId === null) return null;

	var aType = sId["split"]("-"),
		sType = aType[aType["length"] - 1];

	switch (sType) {
		case this["MENU_ITEM_TYPE"]["BUTTON"]:
			return this["TOOLBAR_ITEM_TYPE"]["BUTTON"];

		case this["MENU_ITEM_TYPE"]["BUTTONCHOICE"]:
			return this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"];

		case this["MENU_ITEM_TYPE"]["LINK"]:
			return this["TOOLBAR_ITEM_TYPE"]["LINK"];

		case this["MENU_ITEM_TYPE"]["LINKCHOICE"]:
			return this["TOOLBAR_ITEM_TYPE"]["LINKCHOICE"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["sGetMenuItemType"] = 0; };

/**
 * Determines the toolbar item control type
 * @param {UCF_Control} oItem  - the control
 * @return {string} the toolbar item type
 * @private
 */
UCF_Toolbar_ie6["prototype"]["sGetToolbarItemType"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["sGetToolbarItemType"]++; }; 
	var sClassName = oItem["sClassName"];

	switch (sClassName) {
		case "UCF_Button":
			return (!oItem["bHasPopupMenu"]) ? this["TOOLBAR_ITEM_TYPE"]["BUTTON"] : this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"];

		case "UCF_Link":
			return this["TOOLBAR_ITEM_TYPE"]["LINK"];

		case "UCF_LinkChoice":
			return this["TOOLBAR_ITEM_TYPE"]["LINKCHOICE"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["sGetToolbarItemType"] = 0; };

/**
 * When an item is selected, fire the according event on the
 * corresponding toolbar item that is hidden
 * @param {UCF_BrowserEvent} oEvent the event object that occurred
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onMenuItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onMenuItemSelect"]++; }; 
	var sMenuItemId = oEvent["oGetParam"]("sItemId"),
		sId = sMenuItemId["split"]("-")[0],
		oToolbarItem = this["oLS"]["oControlFactory"]["oGetControlById"](sId);

	if (this["sGetMenuItemType"](sMenuItemId) === this["TOOLBAR_ITEM_TYPE"]["BUTTON"]) {
		oToolbarItem["fireEvent"](oToolbarItem["E_EVENTS"]["Press"], { "sId": oToolbarItem["sId"] });
		oToolbarItem["firePress"](oToolbarItem["sId"]);
	} else if (this["sGetMenuItemType"](sMenuItemId) === this["TOOLBAR_ITEM_TYPE"]["LINK"]) {
		oToolbarItem["fireActivate"](oToolbarItem["sId"]);
	} else if (this["sGetMenuItemType"](sMenuItemId) === this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"]) {
		var oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent"),
			oSource = oBrowserEvent["oGetSource"](),
			oMenuItem = UCF_DomUtil["$"](sMenuItemId),
			oMenuSection = UCF_DomUtil["lastChild"](oMenuItem, "TD");

		if (oSource !== oMenuSection) {
			oToolbarItem["firePress"](oToolbarItem["sId"]);
		}

	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onMenuItemSelect"] = 0; };

/**
 * If menu of toolbar item is loaded from server, the menu item fires a MenuAccess event.
 * The toolbar handles it in this function. It finds the toolbar item represented by the menu item
 * and programmatically triggers the MenuAcces event there, again.
 * @param {UCF_BrowserEvent} oEvent the event object that occurred
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onSubMenuAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onSubMenuAccess"]++; }; 

	var sItemId = oEvent["oGetParam"]("sMenuId")["split"]("-")[0],
		bEnabled = oEvent["oGetParam"]("bEnabled"),
		oTbarItem = this["oGetControlById"](sItemId);

	if (bEnabled) {
		oTbarItem["fireMenuAccess"](oTbarItem["sId"], oTbarItem["sPopupMenuId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onSubMenuAccess"] = 0; };

/**
 * All toolbar items that have their own menu can fire a OpenMenu event. If the menu is rendered on the server
 * the toobar item must not open the menu, when it is currently not visible. Instead it fires an OpenMenu event.
 * The Toolbar listens to the event and handles it in this function.
 * @param {UCF_BrowserEvent} oEvent the event object that occurred
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onToolbarItemMenuOpen"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onToolbarItemMenuOpen"]++; }; 
	var sSumMenuId = oEvent["oGetParam"]("sMenuId"),
		sToolbarItemId = oEvent["oGetParam"]("sId"),
		oToolbarItem = this["oGetControlById"](sToolbarItemId),
		sToolbarItemType = this["sGetToolbarItemType"](oToolbarItem),
		sEndFix = "-";

	switch (sToolbarItemType) {
		case this["TOOLBAR_ITEM_TYPE"]["BUTTON"]:
			sEndFix += this["MENU_ITEM_TYPE"]["BUTTON"];
			break;

		case this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"]:
			sEndFix += this["MENU_ITEM_TYPE"]["BUTTONCHOICE"];
			break;

		case this["TOOLBAR_ITEM_TYPE"]["LINKCHOICE"]:
			sEndFix += this["MENU_ITEM_TYPE"]["LINKCHOICE"];
			break;

		case this["TOOLBAR_ITEM_TYPE"]["LINK"]:
			sEndFix += this["MENU_ITEM_TYPE"]["LINK"];
	}

	var sMenuItemId = sToolbarItemId + sEndFix,
		oMenuItem = this["oLS"]["oControlFactory"]["oGetControlById"](sMenuItemId);
	if (oMenuItem) {
		oMenuItem["setSubMenuId"](sSumMenuId);
		oMenuItem["openSubMenu"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onToolbarItemMenuOpen"] = 0; };

/**
 * When tab back is performed, we must ensure that the focus does not go
 * to a hidden element. Otherwise it will scroll into the view port.
 * @param {UCF_BrowserEvent} oEvent the event object that occurred
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onMenuTabToPrevious"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onMenuTabToPrevious"]++; }; 
	var oLastVisible = this["getLastVisibleItem"]()["oDomRef"],
		oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent");

	UCF_DomUtil["focusDomElement"](oLastVisible);
	oBrowserEvent["cancel"]();
	this["bTabbedOutOfMenu"] = true;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onMenuTabToPrevious"] = 0; };

/**
 * Returns the last visible toolbar item
 * @return {Object} - the last visible item
 * @private
 */
UCF_Toolbar_ie6["prototype"]["getLastVisibleItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["getLastVisibleItem"]++; }; 
	var aItems = this["aItems"];

	for (var i = aItems["length"] - 1; i >= 0; i--) {
		if (!this["bItemIsHidden"](i)) {
			return aItems[i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["getLastVisibleItem"] = 0; };

/**
 * Returns the last visible and focusable toolbar item
 *
 * @return { UCF_Control } oItem - the control
 * @private
 */
UCF_Toolbar_ie6["prototype"]["getLastVisibleAndFocusableItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["getLastVisibleAndFocusableItem"]++; }; 
	var aItems = this["aItems"];

	for (var i = aItems["length"] - 1; i >= 0; i--) {
		if (!this["bItemIsHidden"](i) && UCF_DomUtil["bHasTabIndex"](aItems[i]["oDomRef"])) {
			return aItems[i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["getLastVisibleAndFocusableItem"] = 0; };

/**
 * Returns the last visible toolbar item
 *
 * @return { UCF_Control } oItem - the control
 * @private
 */
UCF_Toolbar_ie6["prototype"]["getIsHiddenItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["getIsHiddenItem"]++; }; 
	var aItems = this["aItems"];

	for (var i = aItems["length"] - 1; i >= 0; i--) {
		if (this["bItemIsHidden"](i)) {
			return aItems[i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["getIsHiddenItem"] = 0; };

/**
 * Check if the current control is the last focusable and visible
 * Returns false - if there is a next ctrl which is focusable and visible
 * Returns true - if is the last focusable and visible ctrl
 * fix CSN 169912 2010
 * @param {string} sId - id of the item
 * @return {boolean} - true if the item is the last visible and focusable item
 * @private
 */
UCF_Toolbar_ie6["prototype"]["bIsLastVisibleAndFocusable"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsLastVisibleAndFocusable"]++; }; 
	// in 508 mode all items are focusable
	//if (UCF_System.bIs508) return false;

	if (sId === null) return true;
	var aItems = this["aItems"];
	var oDomItem, found = false,
		bLastEnabled = true;
	for (var i = 0; i <= aItems["length"] - 1; i++) {
		oDomItem = aItems[i];
		if (oDomItem["sId"] != null &&
			(sId === oDomItem["sId"] || oDomItem["sId"]["indexOf"](sId) > -1)) {
			found = true;
		}
		if (found && sId !== oDomItem["sId"]) {
			// check if next ctrl is focusable and not hidden
			bLastEnabled = !this["bItemIsHidden"](i) && oDomItem["bIsFocusable"]();
			if (bLastEnabled) {
				return false;
			}
		}
	}
	return true;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsLastVisibleAndFocusable"] = 0; };

/**
 * Check if the current control is a right item
 * @param {string} sId - id of the item
 * @return {boolean} - true if the item is a right item
 * @private
 */
UCF_Toolbar_ie6["prototype"]["bIsRightItem"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsRightItem"]++; }; 

	if (sId === null) return false;
	var aItems = this["rItems"],
		sToolbarLabelId = sId + "-tlbl";
	var oDomItem,
		found = false;
	for (var i = 0; i <= aItems["length"] - 1; i++) {
		oDomItem = aItems[i];
		if (oDomItem["sId"] != null && (sId === oDomItem["sId"] || sToolbarLabelId === oDomItem["sId"])) {
			found = true;
			continue;
		}
	}
	return found;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsRightItem"] = 0; };

/**
 * Check if the given item is hidden
 * @param {Object} oParam - the item
 * @return {boolean} true if the item is hidden
 * @private
 */
UCF_Toolbar_ie6["prototype"]["bItemIsHidden"] = function(oParam) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bItemIsHidden"]++; }; 
	var oItem = typeof(oParam) === "number" ? this["aItems"][oParam]["oTbarRef"] : oParam;
	if (!oItem || !oItem["id"]) return true;

	if (this["oViewPort"]) {
		/*_trace(INFO, 'sId - ' + oItem.id + ' - ViewPort  scrollTop - ' + this.oViewPort.scrollTop
			+ ' - ViewPort  offsetTop - ' + this.oViewPort.offsetTop
			+ ' - item offsetTop - ' + oItem.offsetTop);*/
		return oItem === null || (oItem != null && !UCF_DomUtil["bIsVisible"](oItem))
			//|| oItem.offsetTop !=  this.oViewPort.offsetTop;
			|| (Math["abs"](this["oViewPort"]["offsetTop"] - oItem["offsetTop"]) > 4);
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bItemIsHidden"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_Toolbar_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["destroy"]++; }; 

	if (this["sTimeOutId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		this["sTimeOutId"] = null;
	}
	if (this["bItemOverflow"]) {
		if (this["oViewPort"]) {
			this["detachBrowserEvent"]("mousemove", this["oViewPort"]);
		}

		this["detachBrowserEvent"]("resize", this["oDomRef"]);
	}

	this["oViewPort"] = null;
	this["aItems"] = null;
	this["rItems"] = null;
	this["aToggleItems"] = null;
	this["oViewPort"] = null;
	if (this["oPopupMenu"]) {
		UCF_ClientPopupMenuHelper["handleDestroy"](this["oPopupMenu"]);
		this["oPopupMenu"] = null;
	}
	this["oHiddenOpener"] = null;
	this["oRightItemContainer"] = null;

	if (window["UCF_System"]["bIs508"]) {
		this["oEndToolbar"] = null;
	}

	this["sPopupOpener"] = null;
	this["oPopupOpenerRef"] = null;
	this["oPopupOpenerItem"] = null;

	this["iFirstInvisibleItem"] = null;
	this["iItmsScrollTop"] = null;
	this["iToolbarWidth"] = null;

	this["bFocusFromHiddenItem"] = null;
	this["bToolbarWidthMaximized"] = null;

	this["oToggleButton"] = null;
	this["aRightItemsIdList"] = null;
	this["oLastAccItem"] = null;

	UCF_Toolbar.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["destroy"] = 0; };

/**
 * Create an array with all UCF_Toolbar_ie6Items apart from the separators
 * @private
 */
// eslint-disable-next-line complexity
UCF_Toolbar_ie6["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["createItems"]++; }; 
	/** Contains the child control (separators are currently no UCF controls)
	 */
	this["aItems"] = [];

	this["aRightItemsIdList"] = [];
	this["accItems"] = [];
	var bIsToolbarSeparator = false,
		iAccIndex = -1;

	this["rItems"] = [];
	this["aToggleItems"] = [];
	var iMaxHeight = 0;

	if (this["oViewPort"] === null && this["oRightItemContainer"] === null) return;
	var aDomItems = UCF_DomUtil["childNodes"](this["oViewPort"], 'SPAN');
	var aRightDomItems = UCF_DomUtil["childNodes"](this["oRightItemContainer"], 'SPAN');
	var oDomItem;
	for (var i = 0; i < aDomItems["length"]; i++) {
		//do not handle elements that are no potential items
		oDomItem = aDomItems[i];
		bIsToolbarSeparator = false;
		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node

		if (oDomItem["id"] === null
			|| (oDomItem["firstChild"] && oDomItem["firstChild"]["nodeType"] === 3))
			continue;

		if (oDomItem["getAttribute"]('canHide') === 'true') {
			this["aToggleItems"]["push"](oDomItem);
		}
		// Test if oDomItem is a separator
		bIsToolbarSeparator = UCF_DomUtil["sGetClass"](oDomItem)["indexOf"]('urTSep') > -1;

		var oCtRef = this["oGetCTElement"](oDomItem);
		if (oCtRef === null)
			continue;
		var oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oCtRef, true);

		iMaxHeight = Math["max"](iMaxHeight, oItem["oDomRef"]["offsetHeight"]);

		if (this["bItemOverflow"]) {
			// check if the oDomRef has display=none; either visibility.None or Show=false
			// this should be done in renderer
			if (oDomItem && !UCF_DomUtil["bIsVisible"](oDomItem)) {
				oDomItem["setAttribute"]('show', 'false');
			}
		}

		oItem["oTbarRef"] = oDomItem;

		if (!bIsToolbarSeparator && window["UCF_System"]["bIs508"] && this["bIsShown"](oDomItem)) {
			iAccIndex++;
			oItem["iAccIndex"] = iAccIndex;
		}
		oItem["iIndex"] = this["aItems"]["length"];
		oItem["bShowAlways"] = this["bIsShowAlwaysItem"](oDomItem);

		this["aItems"]["push"](oItem);

		if (!bIsToolbarSeparator && window["UCF_System"]["bIs508"] && this["bIsShown"](oDomItem)) {
			this["accItems"]["push"](oItem);
		}
	}
	if (this["bHasRightItemsFixed"])
		iAccIndex = -1;
	for (i = 0; i < aRightDomItems["length"]; i++) {
		//do not handle elements that are no potential items
		oDomItem = aRightDomItems[i];
		bIsToolbarSeparator = false;
		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node

		if (oDomItem["id"] === null
			|| (oDomItem["firstChild"] && oDomItem["firstChild"]["nodeType"] === 3))
			continue;

		// Test if oDomItem is a separator
		bIsToolbarSeparator = oDomItem && oDomItem["nodeType"] === 1 && oDomItem["getAttribute"]('data-separator') === 'true';

		oCtRef = this["oGetCTElement"](oDomItem);
		if (oCtRef === null || oCtRef["getAttribute"]('ct') === 'TBARSEP') continue;

		oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oCtRef, true);

		oItem["oTbarRef"] = oDomItem;
		if (this["bHasRightItemsFixed"]) {
			oItem["iIndex"] = this["rItems"]["length"];
			if (!bIsToolbarSeparator && window["UCF_System"]["bIs508"]) {
				iAccIndex++;
				oItem["iAccIndex"] = iAccIndex;
			}
		} else {
			oItem["iIndex"] = this["aItems"]["length"];
			if (!bIsToolbarSeparator && window["UCF_System"]["bIs508"]
				&& this["bIsShown"](oDomItem)) {
				iAccIndex++;
				oItem["iAccIndex"] = iAccIndex;
			}
		}

		if (this["bHasRightItemsFixed"])
			this["rItems"]["push"](oItem);
		else {
			this["aItems"]["push"](oItem);
			if (!bIsToolbarSeparator && window["UCF_System"]["bIs508"]) {
				this["accItems"]["push"](oItem);
			}
		}

	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["createItems"] = 0; };

/**
 * @param {UCF_Control} oItem - the control
 * @return  {HTMLElement} oDomRef - the html element of the item
 *
 * @private
 */
UCF_Toolbar_ie6["prototype"]["oGetItemRef"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["oGetItemRef"]++; }; 

	// in case of ToolbarItems, -r or -tr will fail
	if (oItem["oTbarRef"])
		return oItem["oTbarRef"];

	var oDomRef = UCF_DomUtil["$"](oItem["sId"] + "-tr");

	if (!oDomRef) {
		oDomRef = UCF_DomUtil["$"](oItem["sId"] + "-r");
	}
	if (!oDomRef) {
		oDomRef = UCF_DomUtil["$"](oItem["sId"]);
	}
	return oDomRef;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["oGetItemRef"] = 0; };

/**
 * Rerieves the DOM reference with ct attribute
 * @param {HTMLElement} oDomRef The DOM reference
 * @return {HTMLElement} - the DOM Reference with ct attribute
 * @private
 */
UCF_Toolbar_ie6["prototype"]["oGetCTElement"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["oGetCTElement"]++; }; 
	/** @type {HTMLElement} */
	var oCurrDomRef;
	/** @type {HTMLElement} */
	var oDomRefFound;
	oCurrDomRef = oDomRef["firstChild"];
	oDomRefFound = null;

	while (oCurrDomRef) {
		if (oCurrDomRef["nodeType"] === 1) {
			if (oCurrDomRef["getAttribute"] && oCurrDomRef["getAttribute"]("ct")) {
				return oCurrDomRef;
			}

			if (oCurrDomRef["childNodes"]) {
				oDomRefFound = this["oGetCTElement"](oCurrDomRef);
				if (oDomRefFound) return oDomRefFound;
			}
		}
		oCurrDomRef = oCurrDomRef["nextSibling"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["oGetCTElement"] = 0; };

/**
 * Used in IE Quirks mode to set the focus on Toolbar Overflow
 *
 * @private
 */
UCF_Toolbar_ie6["prototype"]["adjustFocusHelper"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["adjustFocusHelper"]++; }; 
	if (this["oHiddenOpener"] != null && this["bItemOverflow"]) {
		if (this["bIsWrapping"]()) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'adjustFocusHelper - this.bIsWrapping(): true ', "Toolbar_ie6.js(1229): adjustFocusHelper"); };
			UCF_DomUtil["setTabIndex"](this["oHiddenOpener"], 0);
		} else {

			if (!this["bIsWrapping"]()) {
				UCF_DomUtil["resetTabIndex"](this["oHiddenOpener"]);
			}
			if (this["getIsHiddenItem"]() === null) {
				UCF_DomUtil["resetTabIndex"](this["oHiddenOpener"]);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["adjustFocusHelper"] = 0; };

/**
 * Used in IE Quirks mode to set the focus on Toolbar Overflow
 *
 * @private
 */

UCF_Toolbar_ie6["prototype"]["bHasHiddenItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bHasHiddenItems"]++; }; 
	if (!this["bItemOverflow"]) return false;
	if (this["iFirstInvisibleItem"] !== -1 && this["iFirstInvisibleItem"] < this["aItems"]["length"])
		return true;
	return false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bHasHiddenItems"] = 0; };

/**
 * @param {boolean} bMoveFocus - if the focus s´hould be set for a hidden item
 * @private
 */
UCF_Toolbar_ie6["prototype"]["setFocusFromHiddenItem"] = function(bMoveFocus) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["setFocusFromHiddenItem"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bFocusFromHiddenItem"] = bMoveFocus;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["setFocusFromHiddenItem"] = 0; };

/**
 *
 * @param { UCF_BrowserEvent } oBrowserEvent the lsfocus
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsfocus"]++; }; 
	if (this["oViewPort"] === null
		|| !this["bItemOverflow"]
		|| this["aItems"]["length"] === 0) return;

	if (this["bItemOverflow"]) {

		this["adjustFocusHelper"]();
	}

	if (this["bFocusFromHiddenItem"]) {
		this["setFocusFromHiddenItem"](false);
		UCF_DomUtil["focusDomElement"](this["oHiddenOpener"]);

	}
	var oActive = UCF_DomUtil["oGetActiveElement"]();

	if (oActive === this["oHiddenOpener"]) {
		//	this.oViewPort.scrollTop = this.iItmsScrollTop;
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsfocus"] = 0; };

/**
 * @param { UCF_BrowserEvent } oBrowserEvent the lsblur
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsblur"]++; }; 

	if (this["oViewPort"] === null || !this["bItemOverflow"] || this["aItems"]["length"] === 0 || !this["bIsWrapping"]()) return;

	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource === this["oHiddenOpener"]) {
		UCF_DomUtil["setClass"](this["oViewPort"]["parentNode"], UCF_DomUtil["sGetClass"](this["oViewPort"]["parentNode"])["replace"](/Hover/g, ""));
		//UCF_DomUtil.removeClass(this.oHiddenOpener,"lsTbarBtnOvflActive");
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsblur"] = 0; };

/**
 * Avoids scrolling of the browser if the HasHideMachanism is on. Otherwise
 * items that broke down to the next line would become visible, if focus would go there
 * @param { UCF_BrowserEvent } oBrowserEvent the lstabnext
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlstabnext"]++; }; 
	if (!this["bItemOverflow"] || this["aItems"]["length"] === 0 || !this["bIsWrapping"]()) return;

	var oControl = oBrowserEvent["oGetSourceControl"](),
		oSource = oBrowserEvent["oGetSource"](),
		oLast = this["getLastVisibleItem"]();
	if (this["bIsRightItem"](oControl["sId"])) return;

	// D039230 Fix the tabnext when the focus is on the overflow icon
	if (oSource === this["oHiddenOpener"]) {
		if (this["rItems"]["length"] > 0)
			return;
		if (window["UCF_System"]["bIs508"]) {
			UCF_DomUtil["focusDomElement"](this["oEndToolbar"]);
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		} else {
			// Workaround:
			// If contained in PopupWindow-footer: Do nothing here so the PopupWindow-tab-chain
			// will work, which "connects" the last control in the content with the title
			// Without a new parameter like "UsedInPopupWindowFooter" there is only this workaround
			var oPW = this["oGetParentPopupWindow"]();
			if (oPW) {
				var oTB = oPW["oGetFooterToolbar"]();
				if (oTB === this) {
					return;
				}
			}

			var focussed = this["focusNextControl"](); //try to focus next sibling and their children
			if (focussed) {
				oBrowserEvent["cancel"]();
				oBrowserEvent["cancelBubble"]();
			} else {
				//No focusable control after the tab strip then leave it up to ls object to find the next element
				this["oLS"]["focusEnd"]();
			}
		}
	} else {
		//check if the next focusable ctrl is visible; otherwise the hiddenOpener should be focused
		var bIgnore = (this === oControl)
			|| (this["oEndToolbar"] != null && this["oEndToolbar"] === oSource);
		if (!bIgnore && this["bItemOverflow"] && this["getIsHiddenItem"]() != null) {
			if (oLast["sId"]["indexOf"](oControl["sId"]) > -1 || this["bIsLastVisibleAndFocusable"](oControl["sId"])) {

				UCF_DomUtil["focusDomElement"](this["oHiddenOpener"]);
				oBrowserEvent["cancel"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlstabnext"] = 0; };

/**
 * Avoids scrolling of the browser if the HasHideMachanism is on. Otherwise
 * items that broke down to the next line would become visible, if focus would go there
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the lstabprevious
 */
UCF_Toolbar_ie6["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlstabprevious"]++; }; 

	if (!this["bItemOverflow"] || this["aItems"]["length"] === 0) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oLast = this["getLastVisibleAndFocusableItem"]();

	if (oSource === this["oHiddenOpener"]) {
		UCF_DomUtil["focusDomElement"](oLast["oDomRef"]);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlstabprevious"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsskipforward"]++; }; 
	//the panel handles skipping, if the toolbar is
	//within a panel
	var oParentNode = this["oDomRef"]["parentNode"];
	if (oParentNode != null && oParentNode["id"] && oParentNode["id"]["indexOf"]("-hdtbar") > -1) return;

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsskipback"]++; }; 
	//the panel handles skipping, if the toolbar is
	//within a panel
	var oParentNode = this["oDomRef"]["parentNode"];
	if (oParentNode != null && oParentNode["id"] && oParentNode["id"]["indexOf"]("-hdtbar") > -1) return;

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsskipback"] = 0; };

/**
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_PanelStack
 * @param { UCF_BrowserEvent } oBrowserEvent the lsnext
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsnext"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsnext"] = 0; };

/**
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_PanelStack
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsprevious"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsprevious"] = 0; };

/**
 * Writes the appropriate accessibility text into the tooltip
 * @param { UCF_BrowserEvent } oBrowserEvent the lsaccessibility
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Toolbar_ie6.js(1444): onlsaccessibility"); };

	var oSourceControl = oBrowserEvent["oGetSourceControl"](),
		oToggleButtonSource = UCF_DomUtil["$"](this["sId"] + "-tgl");

	if (oBrowserEvent["oGetSourceControl"]() !== this && !this["bIsToolbarItem"](oSourceControl)) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource === this["oHiddenOpener"]) {
		oAccessibilityHelper["addTutor"]("T_MENU_TUT");
	} else if (oSource["getAttribute"]("tp") === "END") {
		oAccessibilityHelper["setControlType"]("T_END");
	} else if (oSource === oToggleButtonSource && oSource["children"]["length"] > 0
		&& UCF_DomUtil["sGetClass"](oSource["children"][0])["indexOf"]("Col") > -1) {
		oAccessibilityHelper["addTutor"]("T_BTN_E");
		oAccessibilityHelper["addTutor"]("LN_TUT");
	} else if (oSource === oToggleButtonSource && oSource["children"]["length"] > 0
		&& UCF_DomUtil["sGetClass"](oSource["children"][0])["indexOf"]("Exp") > -1) {
		oAccessibilityHelper["addTutor"]("T_BTN_C");
		oAccessibilityHelper["addTutor"]("LN_TUT");
	} else if (this["bIsToolbarItem"](oSourceControl)) {
		if (this["oLastAccItem"] === oSourceControl) {
			// if the event is bubbled by the previous control this means that
			// an action, like Arrow Down/Up, occurs and the Toolbar should cancel
			// its annoucement
			oBrowserEvent["cancelBubble"]();
			return;
		} else {
			if (this["bIsRightItem"](oSource["id"])) {
				oAccessibilityHelper["setItemCount"](this["rItems"]["length"]);
			} else {
				oAccessibilityHelper["setItemCount"](this["accItems"]["length"]);
			}
			oAccessibilityHelper["setItemIndex"](oSourceControl["iAccIndex"] + 1);
			oAccessibilityHelper["setItemCountText"]("T_ITMPOS");
			this["oLastAccItem"] = oSourceControl;
		}
	} else {

		oAccessibilityHelper["setControlType"]("T");
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		oAccessibilityHelper["applyContainerEntryBehaviour"]();

		oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onlsaccessibility"] = 0; };

/**
 * Check if the source is one of the below controls
 * @param {Object} oItem -
 * @return {boolean} - true if the object is a toolbar item
 * @private
 */
UCF_Toolbar_ie6["prototype"]["bIsToolbarItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsToolbarItem"]++; }; 
	if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Button") ||
		UCF_JsUtil["bInstanceOf"](oItem, "UCF_Link") ||
		UCF_JsUtil["bInstanceOf"](oItem, "UCF_LinkChoice") ||
		UCF_JsUtil["bInstanceOf"](oItem, "UCF_ComboBox") ||
		UCF_JsUtil["bInstanceOf"](oItem, "UCF_InputField")
	) {
		return true;
	} //else
	return false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["bIsToolbarItem"] = 0; };

/**
 * Focus on next item
 * @param { UCF_BrowserEvent } oBrowserEvent the lsaccessibility
 * @private
 */
UCF_Toolbar_ie6["prototype"]["focusNextItem"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["focusNextItem"]++; }; 
	for (var i = 0; i < this["aItems"]["length"]; i++)
		if (this["aItems"][i] === oBrowserEvent["oGetSourceControl"]())
			break;
	for (var j = ++i; j < this["aItems"]["length"]; j++)
		if (this["aItems"][j]["bEnabled"])
			break;
	if (j < this["aItems"]["length"]) {
		this["aItems"][j]["focus"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["focusNextItem"] = 0; };

/**
 * Focus on previous item
 * @param { UCF_BrowserEvent } oBrowserEvent the lsaccessibility
 * @private
 */
UCF_Toolbar_ie6["prototype"]["focusPreviousItem"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["focusPreviousItem"]++; }; 
	for (var i = 0; i < this["aItems"]["length"]; i++)
		if (this["aItems"][i] === oBrowserEvent["oGetSourceControl"]())
			break;
	for (var j = --i; j > 0; j--)
		if (this["aItems"][j]["bEnabled"])
			break;
	if (j >= 0) {
		this["aItems"][j]["focus"]();
		this["oDomRef"]["ariaActivedescendant"] = this["aItems"][j]["sId"];
		UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], this["aItems"][j]["sId"]);
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["focusPreviousItem"] = 0; };

/**
 * react onLayouChange event
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onLayoutChange"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onLayoutChange"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onLayoutChange"] = 0; };

/**
 * react onCustomStylesApplied event
 * @private
 */
UCF_Toolbar_ie6["prototype"]["onCustomStylesApplied"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onCustomStylesApplied"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["onCustomStylesApplied"] = 0; };

/**
 * @private
 * @see UCF_DTExtension
 * @param {UCF_BrowserEvent} oDTElement the lsaccessibility
 * @return {Object} - the DTE extension
 */
UCF_Toolbar_ie6["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["oGetDTExtension"]++; }; 
	return UCF_Toolbar.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]("UCF_Toolbar_DTExtension"));
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["oGetDTExtension"] = 0; };

/**
 * Returns the current control height in pixel
 * @return {int} - returns the height value in px
 * @public
 */
UCF_Toolbar_ie6["prototype"]["getHeightPx"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["getHeightPx"]++; }; 
	return this["iGetHeightPx"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["getHeightPx"] = 0; };

/**
 * Returns the current control width in pixel
 * @return {int} - returns the width value in px
 * @public
 */
UCF_Toolbar_ie6["prototype"]["getWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["getWidthPx"]++; }; 
	return this["iGetWidthPx"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_ie6["_"]["getWidthPx"] = 0; };

UCF_Toolbar_ie6.prototype["aPublicMethods"] = ["getHeightPx","getWidthPx"].concat(UCF_Toolbar_ie6.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Toolbar_standards"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ClientPopupMenuHelper */
/// <reference path="../helper/ClientPopupMenuHelper.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_Toolbar */
/// <reference path="./Toolbar.js"/>
/* global UCF_ToolbarOverflowDelegate */
/// <reference path="./delegates/ToolbarOverflowDelegate.js"/>
/**
 *
 * The Toolbar control.
 * 	Hidden items for ToolbarOverflow
 * 	1. Standard mode, the hidden items are wrapped to the next line
 * 	2. MORE button in PageHeader, fiori themes, hidden items have display:none
 * 	3. OverflowButton, hidden items have display:none
 * 	4. Items with Priority - hidden items get order:1
 * 	5. Items with MinWidth - in this case the items do not wrap, display: node
 *
 *
 * @class
 * 
 *
 * @param {HTMLElement} oDomRef The DOM reference
 * @param {UCF_LS} oLS The LS instance
 */
function UCF_Toolbar_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["UCF_Toolbar_standards"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "Toolbar_standards.js(54): UCF_Toolbar_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Toolbar_standards.js(55): UCF_Toolbar_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Toolbar_standards.js(56): UCF_Toolbar_standards"); };

	UCF_Toolbar["apply"](this, [oDomRef, oLS]);
	// container with LeftItems
	this["oViewPort"] = UCF_DomUtil["$"](this["sId"] + '-itms');
	// container with RightItems
	this["oRightItemContainer"] = UCF_DomUtil["$"](this["sId"] + '-rItms');
	// container with OverflowItems
	this["oOverflowItems"] = UCF_DomUtil["$"](this["sId"] + '-ovflItems');
	this["oHiddenOpener"] = UCF_DomUtil["$"](this["sId"] + '-hiddenOpener');
	this["setPopupOpener"](this["oHiddenOpener"]);
	this["setPopupOpenerId"](this["sId"] + '-opener');
	// eslint-disable-next-line @ur/no-missing-setClientProperty
	this["sPopupMenuId"] = '__tbarMenu';
	this["sOverflowItemsState"] = this["eOverflowItemsState"]["NONE"];
	this["oEndToolbar"] = null;

	if (window["UCF_System"]["bIs508"]) {
		this["oEndToolbar"] = UCF_DomUtil["$"](this["sId"] + '-end');
	}
	// the container of the More Button
	this["oMoreOvflDomRef"] = null;
	//
	this["oMoreButton"] = null;
	this["oMoreClientButton"] = null;
	this["oMoreIconButton"] = null;
	this["oMoreButtonDomRef"] = null;

	this["oOverflowButtonDomRef"] = null; // -overflowButton
	this["sOverflowButtonId"] = null;
	this["oDomOvflPusher"] = null;
	// Flag for More button visibility
	this["bMoreButtonVisible"] = false;
	// check in styles if the More Button is visible and
	// set this.bMoreButtonVisible accordingly
	//this.bHasOveflowItems = this.bItemOverflow && (this.oOverflowItems != null);
	this["bHasOveflowItems"] = this["bItemOverflow"];
	this["bPriorityChanged"] = false;
	this["bHasMinWidth"] = false;
	this["bRendersHierarchicalView"] = false;
	this["bHasHierarchicalViewTitle"] = false;
	this["bIsHierarchicalViewOpen"] = false;
	this["oToolbarDelegate"] = null;
	if (this["bHasOveflowItems"]) {

		this["sOverflowButtonId"] = this["oDomRef"]["getAttribute"]("data-overflowButton-id") ? this["oDomRef"]["getAttribute"]("data-overflowButton-id") : null;
		this["sOverflowItemsState"] = this["eOverflowItemsState"]["STANDARD"];
		this["oOverflowButtonDomRef"] = this["sOverflowButtonId"] ? UCF_DomUtil["$"](this["sOverflowButtonId"]) : null;
		this["oDomOvflPusher"] = UCF_DomUtil["$"](this["sId"] + '-ovflPusher');
		this["iFirstInvisibleItem"] = -1;
		if (this["oOverflowButtonDomRef"]) {
			//this.oHiddenOpener.style.display = 'none';
			this["oMoreOvflDomRef"] = UCF_DomUtil["$"](this["sOverflowButtonId"] + '-r');
			this["createOverflowButton"]();
			this["bMoreButtonVisible"] = true;
			this["oHiddenOpener"] = this["oOverflowButtonDomRef"];
			this["setPopupOpenerId"](this["sOverflowButtonId"]);
			this["setPopupOpener"](this["oOverflowButtonDomRef"]);
			// eslint-disable-next-line @ur/no-missing-setClientProperty
			this["sPopupMenuId"] = '-tbarMoreMenu';
			this["sOverflowItemsState"] = this["eOverflowItemsState"]["OVERFLOWBUTTON"];
			this["iFirstInvisibleItem"] = -1;
		} else {
			this["bHasOveflowItems"] = this["bItemOverflow"] && (this["oOverflowItems"] != null);
			this["oMoreOvflDomRef"] = UCF_DomUtil["$"](this["sId"] + '-moreOvfl');
			if (this["oMoreOvflDomRef"]) {
				var sMoreButtonDisplay = UCF_DomUtil["sGetCurrentStyle"](this["oMoreOvflDomRef"], 'display');

				if (sMoreButtonDisplay != null && sMoreButtonDisplay !== 'none') {
					this["oHiddenOpener"]["style"]["display"] = 'none';
					this["createMoreButton"]();
					this["oMoreButtonDomRef"] = UCF_DomUtil["$"](this["sId"] + '-moreButton');
					this["bMoreButtonVisible"] = true;
					this["oHiddenOpener"] = this["oMoreButtonDomRef"];
					this["setPopupOpenerId"](this["sId"] + '-moreButton');
					//	this.oMoreIconButton = UCF_DomUtil.$(this.sId + this.sPopupOpener);
					this["setPopupOpener"](this["oMoreOvflDomRef"]);
					// eslint-disable-next-line @ur/no-missing-setClientProperty
					this["sPopupMenuId"] = '-tbarMoreMenu';
					this["sOverflowItemsState"] = this["eOverflowItemsState"]["MORE"];
					this["iFirstInvisibleItem"] = -1;
					var oTbarHiddenBtn = UCF_DomUtil["$"](this["sId"] + '-hiddenBtn');
					if (oTbarHiddenBtn) {
						UCF_DomUtil["addClass"](oTbarHiddenBtn, 'lsToolbar--overflow-none');
					}
				}
			}
		}

		var oHierachcalViewDomRef = UCF_DomUtil["$"](this["sId"] + '-hierarchicalView');
		var sHierachcalViewDisplay = oHierachcalViewDomRef ? UCF_DomUtil["sGetCurrentStyle"](oHierachcalViewDomRef, 'display') : null;
		if (sHierachcalViewDisplay && sHierachcalViewDisplay !== 'none') {
			this["bRendersHierarchicalView"] = true;
		}
		/*	this.bIsToolbarFeatureEnabled = true;
	this.bIsToolbarFeatureEnabled = this.oLS.oGetRenderManager().callFragment(
				'IsEnabled',
				'FeatureFlags', { Feature: 'Toolbar.Overflow' }
			);*/

		this["oToolbarDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_ToolbarOverflowDelegate"))(this, this["oLS"], !this["bRendersHierarchicalView"]);
		this["addDelegate"](this["oToolbarDelegate"]);
		this["defineEvents"]([
			// Opens the OverflowMenu
			'OpenOverflow',
			//Closes the OverflowMenu
			'CloseOverflow']);

		this["attachEvent"](
			this["E_EVENTS"]["OpenOverflow"],
			this["oToolbarDelegate"],
			'onOverflowOpen'
		);
		this["attachEvent"](
			this["E_EVENTS"]["CloseOverflow"],
			this["oToolbarDelegate"],
			'onOverflowClose'
		);
	}

	// The offsetTop of the oViewPort
	this["iItmsScrollTop"] = 0;
	this["aSeparatorGroups"] = null;
	this["oLastAccItem"] = null;
	// if HasRightItemsFixed = false, the rightItems-pusher will be rendered
	// it should not be hidden if ToolbarInputs are rendered as right items
	this["oRightItemsPusher"] = UCF_DomUtil["$"](this["sId"] + '-rightItems-pusher');

	this["createItems"]();
	// D039230:CSN 270813 2011 - fix the close of the openerMenu by onresize
	this["iToolbarWidth"] = this["oDomRef"]["offsetWidth"];

	if (this["bItemOverflow"] && this["aItems"]["length"] > 0) {
		//this.oViewPort = UCF_DomUtil.$(this.sId + '-itms');
		this["iItmsScrollTop"] = this["oViewPort"]["offsetTop"];

		this["attachBrowserEvent"]('resize', this["oDomRef"]);
		this["adjustFocusHelper"]();
		this["bTabbedOutOfMenu"] = false;
		if (this["oLS"]) {
			this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, 'onLayoutChange');
		}
	}
	this["bLayoutChangeProcessed"] = false;
	// IE, when the svg images are rendered in img tag
	// the checkToolbarOverflowHeight should be called delayed
	this["bDelayOverflowHeight"] = false;

	this["bFocusFromHiddenItem"] = false;
	this["bToolbarWidthMaximized"] = false;

	this["oToggleButtonDomRef"] = UCF_DomUtil["$"](this["sId"] + '-tgl');
	if (this["oToggleButtonDomRef"]) {
		this["oToggleButton"] = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](this["oToggleButtonDomRef"], true);
		if (this["oToggleButton"])
			this["oToggleButton"]["attachSemanticEvent"]('Press', this, 'onToggleButton');
	}
	// true - when the OverflowMenu is closed while selecting an menu item
	this["bOverflowMenuJustClosed"] = false;

};window["UCF_Toolbar_standards"] = UCF_Toolbar_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Toolbar_standards"); UCF_Toolbar_standards["_"] = {UCF_Toolbar_standards: 0}; }; ;

UCF_Toolbar_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Toolbar"))(); UCF_Toolbar_standards.prototype["sClassName"] = "UCF_Toolbar_standards";

UCF_Toolbar_standards["prototype"]["eOverflowItemsState"] = {
	// no ItemOverflow
	"NONE": 'NONE',
	// standard mode, where the overflow appears when there are hidden items
	// the toolbar wrap its items, toolbar overflow appears only when there are hidden items
	// display:none is not needed
	"STANDARD": 'STANDARD',
	//the toolbar wrap its items; the overflow appears always when the toolbar has OverflowItems
	"STANDARD_OVERFLOWITEMS": 'STANDARD_OVERFLOWITEMS',
	// only for fiori theme, in PageHeader when OverflowItems are set
	// it appears always, all the Items before it which do not fit, have display:none
	"MORE": 'MORE',
	// overflow Button appears only when there are hidden items
	"OVERFLOWBUTTON": 'OVERFLOWBUTTON',
	// overflow Button always when OverflowItems
	"OVERFLOWBUTTON_OVERFLOWITEMS": 'OVERFLOWBUTTON_OVERFLOWITEMS'
};

UCF_Toolbar_standards["prototype"]["eStyles"] = {
	"TOOLBAR_ITEM_HIDDEN": "lsToolbar--item-hidden",
	"TOOLBAR_OVERFLOW_PUSHER_HIDDEN": "lsToolbar--standards-overflowButton--hidden",
	"TOOLBAR_OVERFLOW_PUSHER_VISIBLE": "lsToolbar--standards-overflowButton--visible",

	"TOOLBAR_OVERFLOW_HOVERABLE": 'lsToolbar--standards-overflowButton-hoverable'

};

/** Constructor
 * @private
 */
UCF_Toolbar_standards["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["initialize"]++; }; 

	if (this["aItems"]["length"] === 0) {
		this["createItems"]();
	}

	if (this["aItems"]["length"] === 0) {
		return;
	}

	if (this["bDelayOverflowHeight"]) {
		UCF_JsUtil["delayedCall"](0, this, 'checkToolbarOverflowHeight');
	} else {
		this["checkToolbarOverflowHeight"]();
	}

	this["applyLargeToolbarStyles"]();
	this["checkOverflowFixedRightItems"]();

	this["keepMoreButtonVisible"]();
	var oPage = this["oLS"]["oGetPageInternal"]();

	if (oPage)
		oPage["attachEvent"](oPage["E_EVENTS"]["CustomStylesApplied"], this, 'onCustomStylesApplied');

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["initialize"] = 0; };

/**
 * creates a more button (using clientside rendering)
 * for a given format
 */
UCF_Toolbar_standards["prototype"]["createOverflowButton"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["createOverflowButton"]++; }; 
	if (this["oOverflowButton"])
		return;
	if (!this["oOverflowButtonDomRef"]) {
		this["oOverflowButtonDomRef"] = UCF_DomUtil["$"](this["sOverflowButtonId"]);
	}

	if (this["oOverflowButtonDomRef"]) {

		this["oOverflowButton"] = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](this["oOverflowButtonDomRef"], true);
		if (this["oOverflowButton"]) {
			this["oOverflowButton"]["attachSemanticEvent"]('MenuAccess', this, 'onPressOverflowButton');
			this["oOverflowButton"]["attachSemanticEvent"]('Press', this, 'onPressOverflowButton');
		}

		this["oOverflowClientButton"] = this["oLS"]["oGetClientControlById"](this["sOverflowButtonId"]);
		if (this["oOverflowClientButton"]) {
			this["oOverflowClientButton"]["onAfterRendering"] = function() {
				this["getUCFInstance"]()["attachSemanticEvent"]('MenuAccess', this["getParent"]()["getUCFInstance"](), 'onPressOverflowButton');
				this["getUCFInstance"]()["attachSemanticEvent"]('Press', this["getParent"]()["getUCFInstance"](), 'onPressOverflowButton');
				this["getParent"]()["getUCFInstance"]()["resetOverflowButton"]();
				this["getParent"]()["getUCFInstance"]()["keepMoreButtonVisible"]();
			};

		}

	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["createOverflowButton"] = 0; };

UCF_Toolbar_standards["prototype"]["resetOverflowButton"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["resetOverflowButton"]++; }; 
	this["oOverflowButtonDomRef"] = this["sOverflowButtonId"] ? UCF_DomUtil["$"](this["sOverflowButtonId"]) : null;
	this["oMoreOvflDomRef"] = UCF_DomUtil["$"](this["sOverflowButtonId"] + '-r');
	if (!this["bHasRightItemsFixed"]) {
		UCF_DomUtil["removeClass"](this["oMoreOvflDomRef"], 'lsToolbar--item-left');
	}
	//	this.createOverflowButton();
	this["bMoreButtonVisible"] = true;
	this["oHiddenOpener"] = this["oOverflowButtonDomRef"];
	this["setPopupOpenerId"](this["sOverflowButtonId"]);
	this["setPopupOpener"](this["oOverflowButtonDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["resetOverflowButton"] = 0; };

UCF_Toolbar_standards["prototype"]["onPressOverflowButton"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onPressOverflowButton"]++; }; 
	this["oOverflowButtonDomRef"] = this["sOverflowButtonId"] ? UCF_DomUtil["$"](this["sOverflowButtonId"]) : null;
	this["oHiddenOpener"] = this["oOverflowButtonDomRef"];
	this["setPopupOpener"](this["oOverflowButtonDomRef"]);
	this["openToolbarOverflow"](true);

	oEvent["mParameters"]["CancelEvent"] = true;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onPressOverflowButton"] = 0; };

UCF_Toolbar_standards["prototype"]["createMoreButton"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["createMoreButton"]++; }; 
	if (this["oMoreButton"])
		return;
	if (!this["oMoreButtonDomRef"]) {
		this["oMoreButtonDomRef"] = UCF_DomUtil["$"](this["sId"] + '-moreButton');
	}

	if (this["oMoreButtonDomRef"]) {
		/*	this.oCreateClientMoreButton();
			if (this.oMoreClientButton) {
				this.oMoreButton = this.oMoreClientButton.getUCFInstance();
				if (this.oMoreButton) {
					this.oMoreButton.attachSemanticEvent('MenuAccess', this, 'onPressMoreButton');
				}
			} else { */
		this["oMoreButton"] = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](this["oMoreButtonDomRef"], true);
		if (this["oMoreButton"])
			this["oMoreButton"]["attachSemanticEvent"]('MenuAccess', this, 'onPressMoreButton');
		//	}
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["createMoreButton"] = 0; };

/**
 * creates a more button (using clientside rendering)
 * for a given format
 */

UCF_Toolbar_standards["prototype"]["oCreateClientMoreButton"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oCreateClientMoreButton"]++; }; 
	if (this["oMoreClientButton"])
		return;
	var sMoreId = this["sId"] + '-moreButton';

	this["oMoreClientButton"] = this["oLS"]["oGetClientControlById"](sMoreId);

	if (this["oMoreClientButton"]) {
		this["oMoreClientButton"]["setText"]('More');
		this["oMoreClientButton"]["attachPropertyChange"](this, 'onMorePropertyChange');
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oCreateClientMoreButton"] = 0; };

UCF_Toolbar_standards["prototype"]["onPressMoreButton"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onPressMoreButton"]++; }; 

	this["openToolbarOverflow"](true);
	oEvent["mParameters"]["CancelEvent"] = true;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onPressMoreButton"] = 0; };

UCF_Toolbar_standards["prototype"]["onMorePropertyChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onMorePropertyChange"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "Toolbar_standards.js(381): onMorePropertyChange"); };
	if (oEvent && oEvent["mParameters"]
		&& oEvent["mParameters"]["name"] === 'Visibility') {
		var sValue = oEvent["mParameters"]["newValue"];

		if (sValue === 'NONE') {
			this["oMoreOvflDomRef"]["style"]["display"] = 'none';
			this["oMoreOvflDomRef"]["setAttribute"]('show', 'false');
		} else if (sValue === 'VISIBLE') {
			this["oMoreOvflDomRef"]["style"]["display"] = '';
			this["oMoreOvflDomRef"]["setAttribute"]('show', 'true');
		}
		this["keepMoreButtonVisible"]();
	}

	oEvent["mParameters"]["CancelEvent"] = true;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onMorePropertyChange"] = 0; };

/**
 * Check Toolbar Height when ToolbarOverflow is enabled
 * used only in standards mode
 * @private
 */
UCF_Toolbar_standards["prototype"]["checkToolbarOverflowHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["checkToolbarOverflowHeight"]++; }; 
	if (!this["aItems"]) return;
	if (!this["bItemOverflow"]) return;

	var iMaxHeight = 0;

	for (var i = 0; i < this["aItems"]["length"]; i++) {
		var oItem = this["aItems"][i];

		if (oItem["oDomRef"]) {
			iMaxHeight = Math["max"](iMaxHeight, oItem["oDomRef"]["offsetHeight"]);
		} else {

			oItem = this["oLS"]["oControlFactory"]["oGetControlById"](oItem["sId"]);
			if (oItem && oItem["oDomRef"]) {
				iMaxHeight = Math["max"](iMaxHeight, oItem["oDomRef"]["offsetHeight"]);
				this["aItems"][i] = oItem;
			}
		}

	}
	if (iMaxHeight > this["oViewPort"]["offsetHeight"]) {
		var sHeight = iMaxHeight + 'px';

		this["oViewPort"]["style"]["height"] = sHeight;
		this["oViewPort"]["style"]["maxHeight"] = sHeight;
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["checkToolbarOverflowHeight"] = 0; };

/**
 * In standards mode, when the HasRightItemsFixed:false,
 * after resize, check if the ToolbarOverflow should visble or not
 * only in standards mode
 * @private
 */
UCF_Toolbar_standards["prototype"]["checkOverflowFixedRightItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["checkOverflowFixedRightItems"]++; }; 

	if (!this["bItemOverflow"]) return;
	if (!this["oDomOvflPusher"]) return;
	if (this["bHasMinWidth"]) return;

	if (!UCF_DomUtil["bHasClass"](this["oDomOvflPusher"], this["eStyles"]["TOOLBAR_OVERFLOW_PUSHER_HIDDEN"]) && !UCF_DomUtil["bHasClass"](this["oDomOvflPusher"], this["eStyles"]["TOOLBAR_OVERFLOW_PUSHER_VISIBLE"]))
		UCF_DomUtil["addClass"](this["oDomOvflPusher"], this["eStyles"]["TOOLBAR_OVERFLOW_PUSHER_HIDDEN"]);
	this["oViewPort"] = UCF_DomUtil["$"](this["sId"] + '-itms');
	//IE, Floating toolbar has the difference 4
	if (Math["abs"](this["oViewPort"]["scrollHeight"] - this["oViewPort"]["offsetHeight"]) > 4) {
		UCF_DomUtil["removeClass"](this["oDomOvflPusher"], this["eStyles"]["TOOLBAR_OVERFLOW_PUSHER_HIDDEN"]);
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["checkOverflowFixedRightItems"] = 0; };

/**
 * Applys the styles for LARGE Toolbar
 * @private
 */
UCF_Toolbar_standards["prototype"]["applyLargeToolbarStyles"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["applyLargeToolbarStyles"]++; }; 

	var aItems = this["aItems"];
	var bLargeToolbar = (this["sToolbarSize"] === 'LARGE'),
		bFirstButton = true,
		bIsButton = false,
		oItem = null;

	if (!bLargeToolbar) return;

	if (bLargeToolbar) {
		for (var i = 0; i < this["aItems"]["length"]; i++) {
			oItem = aItems[i];
			var oDomRef = oItem["oTbarRef"] && oItem["oTbarRef"]["previousSibling"];

			while (oDomRef != null && oDomRef["nodeType"] !== 1) { //|| !UCF_DomUtil.bIsVisible(oDomRef)
				oDomRef = oDomRef["previousSibling"];
			}
			var
				// sClassName = oDomRef != null ? UCF_DomUtil.sGetClass(oDomRef) : '',
				bHasSeparator = oDomRef && oDomRef["nodeType"] === 1 && oDomRef["getAttribute"]('data-separator') === 'true';
			//	bHasSeparator = sClassName === 'urTSepTrans' || sClassName.indexOf('urTSep ') > -1;

			if (bHasSeparator) {
				bFirstButton = true;
			}

			bIsButton = UCF_JsUtil["bInstanceOf"](oItem, 'UCF_Button');
			if (bIsButton && oDomRef && UCF_DomUtil["bIsVisible"](oDomRef)) {
				if (bFirstButton) {
					bFirstButton = false;
				} else {
					// apply class to dom
					var oToolbarBtnDomRef = UCF_DomUtil["$"](oItem["sId"] + '-r');

					if (oToolbarBtnDomRef) {
						UCF_DomUtil["addClass"](oToolbarBtnDomRef, 'lsToolbar--size-large-button');
					}
				}
			} else {
				bFirstButton = true;
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["applyLargeToolbarStyles"] = 0; };

/**
 * Sets the width of the RightItems td, when the Toolbar has ItemOverflow,
 * table-layout:fixed and fixed RightItems
 * no needed anymore
 * @private
 */
UCF_Toolbar_standards["prototype"]["applyOverflowFixedRightItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["applyOverflowFixedRightItems"]++; }; 

	if (!this["bHasRightItemsFixed"]) return;
	//	if (!(UCF_UserAgent.bIsIE() && this.bIsStandardsMode)) return;

	var oRightItemsDomRef = UCF_DomUtil["$"](this["sId"] + '-rItms');

	if (!oRightItemsDomRef) return;

	var sTableLayout = UCF_DomUtil["sGetCurrentStyle"](this["oDomRef"], 'table-layout');

	if (sTableLayout === 'fixed') {
		this["oDomRef"]["style"]["tableLayout"] = 'initial';
		oRightItemsDomRef["style"]["width"] = oRightItemsDomRef["offsetWidth"] + 'px';
		this["oDomRef"]["style"]["tableLayout"] = '';
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["applyOverflowFixedRightItems"] = 0; };

/**
 * Checks if the More button is visible
 * @return {boolean} - if the More button is visible
 */
UCF_Toolbar_standards["prototype"]["bIsMoreButtomVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsMoreButtomVisible"]++; }; 

	if (!this["bMoreButtonVisible"]) return false;
	if (!this["oMoreOvflDomRef"]) return false;

	return Math["abs"](this["oMoreOvflDomRef"]["offsetTop"] - this["iItmsScrollTop"]) < 2 &&
		(this["oViewPort"]["offsetLeft"] + this["oViewPort"]["offsetWidth"] - this["oMoreOvflDomRef"]["offsetLeft"] - this["oMoreOvflDomRef"]["offsetWidth"]) >= 0;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsMoreButtomVisible"] = 0; };

/**
 * Keeps More Button visible
 * @private
 */
UCF_Toolbar_standards["prototype"]["keepMoreButtonVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["keepMoreButtonVisible"]++; }; 

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, '== keepMoreButtonVisible - ', "Toolbar_standards.js(550): keepMoreButtonVisible"); };
	if (!this["bMoreButtonVisible"]) {
		this["maintainVisibleItems"]();
	} else {
		this["maintainOverflowButtonVisible"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["keepMoreButtonVisible"] = 0; };

/**
 * Keeps More Button visible
 * @private
 */
UCF_Toolbar_standards["prototype"]["maintainOverflowButtonVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["maintainOverflowButtonVisible"]++; }; 
	var aItems = this["aItems"],
		oDomRef, bMoreVisible, bItemVisible;

	// this should be optimized
	if (!this["oMoreOvflDomRef"]) return;
	if (!this["bIsShown"](this["oMoreOvflDomRef"])) return;
	if (!aItems) return;

	if (this["sOverflowItemsState"] === this["eOverflowItemsState"]["OVERFLOWBUTTON"]
		&& this["oMoreOvflDomRef"]["style"]["display"] === 'none') {
		this["oMoreOvflDomRef"]["style"]["display"] = '';
		bMoreVisible = false;
	} else {
		bMoreVisible = this["bIsMoreButtomVisible"]();
	}
	// more & last Item are visible -> nothing to check
	if (bMoreVisible && this["iFirstInvisibleItem"] === aItems["length"] && this["sOverflowItemsState"] !== this["eOverflowItemsState"]["OVERFLOWBUTTON"])
		return;

	var oItem, bStepOut;
	if (bMoreVisible) {
		// it means that iFirstInvisibleItem < (aItems.length - 1)
		// and that it might
		if (this["iFirstInvisibleItem"] === -1)
			this["iFirstInvisibleItem"] = 0;
		bStepOut = false;
		for (var i = this["iFirstInvisibleItem"]; i < aItems["length"] && !bStepOut; i++) {
			oItem = aItems[i];

			oDomRef = this["oGetItemRef"](oItem);

			if (oDomRef && this["bIsShown"](oDomRef))
				this["forceHideItem"](oItem, false);
			//oDomRef.style.display = '';

			bMoreVisible = this["bIsMoreButtomVisible"]();

			if (!bMoreVisible) {
				if (oDomRef) {
					this["forceHideItem"](oItem, true);
					//oDomRef.style.display = 'none';
					// eslint-disable-next-line @ur/no-memory-leaks
					this["iFirstInvisibleItem"] = i;
				}
				bStepOut = true;
			}
		}
		if (!bStepOut) {
			// means that all items are visible
			// eslint-disable-next-line @ur/no-memory-leaks
			this["iFirstInvisibleItem"] = aItems["length"];
		}

	} else {
		// means that no/all item(s) is/are visible

		if (this["iFirstInvisibleItem"] === -1
			|| this["iFirstInvisibleItem"] === aItems["length"])
			// eslint-disable-next-line @ur/no-memory-leaks
			this["iFirstInvisibleItem"] = aItems["length"] - 1;

		bMoreVisible = this["bIsMoreButtomVisible"]();
		bStepOut = false;
		for (i = this["iFirstInvisibleItem"]; i >= 0 && !bMoreVisible; i--) {
			oItem = aItems[i];
			oDomRef = this["oGetItemRef"](oItem);
			var oItemDomRef = oItem["oDomRef"];

			bItemVisible = Math["abs"](oItemDomRef["offsetTop"] - this["iItmsScrollTop"]) < 2;
			if (oDomRef && (bItemVisible || !bMoreVisible)) {
				//oDomRef.style.display = 'none';
				this["forceHideItem"](oItem, true);
				bStepOut = true;
			}
			bMoreVisible = this["bIsMoreButtomVisible"]();

			// eslint-disable-next-line @ur/no-memory-leaks
			this["iFirstInvisibleItem"] = i;
		}
		if (!bStepOut) {
			// means that all items are visible
			// eslint-disable-next-line @ur/no-memory-leaks
			this["iFirstInvisibleItem"] = aItems["length"];
		}
	}
	if (this["sOverflowItemsState"] === this["eOverflowItemsState"]["OVERFLOWBUTTON"]) {
		if (this["iFirstInvisibleItem"] === aItems["length"])
			this["oMoreOvflDomRef"]["style"]["display"] = 'none';
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["maintainOverflowButtonVisible"] = 0; };

UCF_Toolbar_standards["prototype"]["forceHideItem"] = function(oItem, bHide) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["forceHideItem"]++; }; 
	if (!oItem || !this["oGetItemRef"](oItem)) return;
	var oTbarRef = this["oGetItemRef"](oItem);
	if (bHide) {
		if (!UCF_DomUtil["bHasClass"](oTbarRef, this["eStyles"]["TOOLBAR_ITEM_HIDDEN"])) {
			UCF_DomUtil["addClass"](oTbarRef, this["eStyles"]["TOOLBAR_ITEM_HIDDEN"]);
		}
	} else {
		UCF_DomUtil["removeClass"](oTbarRef, this["eStyles"]["TOOLBAR_ITEM_HIDDEN"]);
	}
	this["forceHideSeparator"](oItem, bHide);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["forceHideItem"] = 0; };

UCF_Toolbar_standards["prototype"]["forceHideSeparator"] = function(oItem, bHide) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["forceHideSeparator"]++; }; 
	if (!oItem || !this["oGetItemRef"](oItem)) return;
	var oTbarRef = this["oGetItemRef"](oItem),
		sCurrentId = oTbarRef["id"],
		aGroupIds;
	if (oTbarRef && oTbarRef["hasAttribute"] && oTbarRef["hasAttribute"]('data-separator-group')) {
		var iIndexGroup = parseInt(oTbarRef["getAttribute"]('data-separator-group'), 10);
		if (iIndexGroup < this["aSeparatorGroups"]["length"]) {
			var oSeparatorGroup = this["aSeparatorGroups"][iIndexGroup];
			aGroupIds = oSeparatorGroup["GroupIds"];
			if (bHide) {
				aGroupIds = UCF_JsUtil["filter"](
					aGroupIds,
					function(sItemId) { return sItemId !== sCurrentId; }
				);
				this["aSeparatorGroups"][iIndexGroup]["GroupIds"] = aGroupIds;
			} else {
				if (sCurrentId !== oSeparatorGroup["SeparatorId"]) {
					aGroupIds["push"](sCurrentId);
					this["aSeparatorGroups"][iIndexGroup]["GroupIds"] = aGroupIds;
				}
			}
		}
	}
	this["checkWithNextSeparators"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["forceHideSeparator"] = 0; };

/**
 * Proofs if the are next Items for each separator
 * and hide each separator which has no next items
 *
 */
UCF_Toolbar_standards["prototype"]["checkWithNextSeparators"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["checkWithNextSeparators"]++; }; 
	var bHasNextItems = false;
	var sToolbarSeparatorId, oSeparatorDomRef;
	for (var i = this["aSeparatorGroups"]["length"] - 1; i >= 0; i--) {
		var aSeparatorGroup = this["aSeparatorGroups"][i]["GroupIds"];
		if (aSeparatorGroup && aSeparatorGroup["length"] !== 0) {
			sToolbarSeparatorId = this["aSeparatorGroups"][i]["SeparatorId"];
			oSeparatorDomRef = sToolbarSeparatorId ? UCF_DomUtil["$"](sToolbarSeparatorId) : null;
			if (!bHasNextItems) {
				//	if (this.bAvoidPusher(oSeparatorDomRef))
				if (oSeparatorDomRef && !oSeparatorDomRef["hasAttribute"]('data-showalways'))
					UCF_DomUtil["addClass"](oSeparatorDomRef, this["eStyles"]["TOOLBAR_ITEM_HIDDEN"]);
			} else {
				if (oSeparatorDomRef)
					UCF_DomUtil["removeClass"](oSeparatorDomRef, this["eStyles"]["TOOLBAR_ITEM_HIDDEN"]);
			}
			bHasNextItems = true;
		} else {
			sToolbarSeparatorId = this["aSeparatorGroups"][i]["SeparatorId"];
			oSeparatorDomRef = sToolbarSeparatorId ? UCF_DomUtil["$"](sToolbarSeparatorId) : null;
			if (oSeparatorDomRef && !oSeparatorDomRef["hasAttribute"]('data-showalways'))
				UCF_DomUtil["addClass"](oSeparatorDomRef, this["eStyles"]["TOOLBAR_ITEM_HIDDEN"]);
			bHasNextItems = bHasNextItems || false;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["checkWithNextSeparators"] = 0; };

/**
 *
 * @param {HTMLElement} oSeparatorDomRef
 * @return {boolean}
 *
 */
UCF_Toolbar_standards["prototype"]["bAvoidPusher"] = function(oSeparatorDomRef) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bAvoidPusher"]++; }; 
	if (oSeparatorDomRef
		&& this["oRightItemsPusher"]
		&& this["oRightItemsPusher"] === oSeparatorDomRef
		&& this["oRightItemsPusher"]["getAttribute"]
		&& this["oRightItemsPusher"]["getAttribute"]('data-showalways') === 'true') {
		return false;

	}

	return true;

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bAvoidPusher"] = 0; };
/**
 * Checks if the item is hidden
 * @param {Object} oItem - the current item
 * @return	{boolean} - true if the item is hidden
 */
UCF_Toolbar_standards["prototype"]["bIsForceHideItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsForceHideItem"]++; }; 
	if (!oItem || !this["oGetItemRef"](oItem)) return false;
	var oTbarRef = this["oGetItemRef"](oItem);
	return UCF_DomUtil["bHasClass"](oTbarRef, this["eStyles"]["TOOLBAR_ITEM_HIDDEN"]);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsForceHideItem"] = 0; };

/**
 * Checks if the item is hidden
 *
 */
UCF_Toolbar_standards["prototype"]["removeForceHideItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["removeForceHideItem"]++; }; 
	var aItems = this["aItems"],
		oItem;
	for (var i = 0; i < aItems["length"]; i++) {
		oItem = aItems[i];
		this["forceHideItem"](oItem, false);
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["removeForceHideItem"] = 0; };

/**
 * @private
 *  maintain the items with minWidth without priority on the visible area
 *
 */
UCF_Toolbar_standards["prototype"]["maintainVisibleItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["maintainVisibleItems"]++; }; 
	if (!this["bPriorityChanged"] && !this["bHasMinWidth"]) return;

	if (this["sOverflowItemsState"] !== this["eOverflowItemsState"]["STANDARD"] &&
		this["sOverflowItemsState"] !== this["eOverflowItemsState"]["STANDARD_OVERFLOWITEMS"]) return;

	var aItems = this["aItems"];
	if (!aItems) return;
	var bStepOut;
	if (this["oDomOvflPusher"]) {
		UCF_DomUtil["removeClass"](this["oDomOvflPusher"], this["eStyles"]["TOOLBAR_OVERFLOW_PUSHER_VISIBLE"]);
	}
	if (this["bIsWrapping"]()) {
		// means that no/all item(s) is/are visible
		if (this["oDomOvflPusher"])
			UCF_DomUtil["removeClass"](this["oDomOvflPusher"], this["eStyles"]["TOOLBAR_OVERFLOW_PUSHER_HIDDEN"]);
		if (this["iFirstInvisibleItem"] === -1 || this["iFirstInvisibleItem"] === aItems["length"]) {
			// eslint-disable-next-line @ur/no-memory-leaks
			this["iFirstInvisibleItem"] = aItems["length"] - 1;
		}
		bStepOut = false;
		for (var i = this["iFirstInvisibleItem"]; i >= 0 && !bStepOut; i--) {
			var oItem = aItems[i];
			this["forceHideItem"](oItem, true);
			bStepOut = !this["bIsWrapping"]();
			// eslint-disable-next-line @ur/no-memory-leaks
			this["iFirstInvisibleItem"] = i;
		}
	} else {
		if (this["iFirstInvisibleItem"] === -1) {
			// eslint-disable-next-line @ur/no-memory-leaks
			this["iFirstInvisibleItem"] = aItems["length"];
		}
		for (i = this["iFirstInvisibleItem"]; i < aItems["length"] && !bStepOut; i++) {
			oItem = aItems[i];
			this["forceHideItem"](oItem, false);
			bStepOut = this["bIsWrapping"]();
			// eslint-disable-next-line @ur/no-memory-leaks
			this["iFirstInvisibleItem"] = i;
		}
		if (!this["bIsWrapping"]()) {
			if (this["oDomOvflPusher"]) {
				UCF_DomUtil["addClass"](this["oDomOvflPusher"], this["eStyles"]["TOOLBAR_OVERFLOW_PUSHER_HIDDEN"]);
				// eslint-disable-next-line @ur/no-memory-leaks
				this["iFirstInvisibleItem"] = aItems["length"];
			}
		} else {
			if (this["iFirstInvisibleItem"] < aItems["length"]) {
				oItem = aItems[this["iFirstInvisibleItem"]];
				this["forceHideItem"](oItem, true);
				// only if not all items are invisible
				if (this["iFirstInvisibleItem"] !== 0)
					this["iFirstInvisibleItem"]--;
			}
		}
	}
	if (this["iFirstInvisibleItem"] <= (aItems["length"] - 1) && this["oDomOvflPusher"]) {
		UCF_DomUtil["addClass"](this["oDomOvflPusher"], this["eStyles"]["TOOLBAR_OVERFLOW_PUSHER_VISIBLE"]);
		UCF_DomUtil["removeClass"](this["oDomOvflPusher"], this["eStyles"]["TOOLBAR_OVERFLOW_PUSHER_HIDDEN"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["maintainVisibleItems"] = 0; };

/**
 * Checks whether the items are wrapping
 * @param {HTMLElement} oDomRef - The DOM reference
 * @return {boolean} if the DOM reference is shown or not
 * @private
 */
UCF_Toolbar_standards["prototype"]["bIsShown"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsShown"]++; }; 
	var bIsShown = true;

	if (typeof oDomRef !== 'undefined' && oDomRef !== null && oDomRef["getAttribute"]('show')) {
		bIsShown = !('false' === oDomRef["getAttribute"]('show'));
	}

	return bIsShown;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsShown"] = 0; };

/**
 * Checks whether the items are wrapping
 * @param {HTMLElement} oDomRef - The DOM reference
 * @return {boolean} if the DOM reference is shown or not
 * @private
 */
UCF_Toolbar_standards["prototype"]["bIsShowAlwaysItem"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsShowAlwaysItem"]++; }; 
	var bIsShown = false;

	if (typeof oDomRef !== 'undefined' && oDomRef !== null && oDomRef["getAttribute"]('data-showalways')) {
		bIsShown = !('true' === oDomRef["getAttribute"]('data-showalways'));
	}

	return bIsShown;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsShowAlwaysItem"] = 0; };

/**
 * Handles the click event and calls a central handler used for click and enter
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Toolbar_standards["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Toolbar_standards.js(874): onclick"); };
	var bHandled = this["handleEvent"](oBrowserEvent);

	if (bHandled) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onclick"] = 0; };

/**
 * Handles the onlsenter event [ENTER]
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */

UCF_Toolbar_standards["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsenter"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Toolbar_standards.js(891): onlsenter"); };

	var bHandled = this["handleEvent"](oBrowserEvent);

	if (bHandled) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsenter"] = 0; };

/**
 * Handles the onlsspace event [SPACE]
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */

UCF_Toolbar_standards["prototype"]["onlsspace"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsspace"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Toolbar_standards.js(910): onlsspace"); };

	var bHandled = this["handleEvent"](oBrowserEvent);

	if (bHandled) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsspace"] = 0; };

/**
 * @private
 */

UCF_Toolbar_standards["prototype"]["handleEvent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["handleEvent"]++; }; 
	var oToggleButton = UCF_DomUtil["$"](this["sId"] + '-tgl'),
		oEventSource = oBrowserEvent["oGetSource"](),
		bHandled = false;

	// TODO: replace by UCF_DomUtil.firstChild(this.oDomRef)
	// to avoid problems with text node
	if (oToggleButton != null && this["bHasShowAllState"] && UCF_DomUtil["bContains"](oToggleButton, oEventSource)) {

		var bOpen = this["bIsToggleButtonExpanded"]();
		this["toggleButtonIcon"](bOpen);
		this["toggleItems"](bOpen);
		bHandled = true;
	} else if (this["aItems"]["length"] > 0
		&& (this["bOpenerTriggered"](oBrowserEvent)
			|| oEventSource === this["oHiddenOpener"]
			|| oEventSource === this["oMoreButton"])
		&& (this["bIsWrapping"]() || this["bHasOveflowItems"] || this["bPriorityChanged"] || this["bHasMinWidth"])) {
		//|| (this.oMoreIconButton != null && this.oMoreIconButton === oEventSource)
		this["openToolbarOverflow"](true);
		bHandled = true;
	}

	return bHandled;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["handleEvent"] = 0; };

/**
 * Creates an array with the all hidden items.
 * @return { Object } - an array all hidden items.
 * @private
 */
UCF_Toolbar_standards["prototype"]["oGetHiddenItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oGetHiddenItems"]++; }; 
	var aNewItems = [];
	var oItem, oDomRef, bIsHidden, bHasSeparator;
	var sGroupId = null,
		sCurrentGroupId = null;
	var bFirstHiddenItem = true;
	var bIsSeparator = false;

	var aItemOverflowItems = [];
	var bIsSeqgmentedButtonSeparator = false;
	var bHasHiddenItems = false;
	if (this["bPriorityChanged"]) {
		aItemOverflowItems = []["concat"](this["aItems"]);
		aItemOverflowItems["sort"](function(a, b) {
			return a["iIndex"] - b["iIndex"];
		});
	} else {
		aItemOverflowItems = this["aItems"];
	}

	for (var i = 0; i < aItemOverflowItems["length"]; i++) {
		oItem = aItemOverflowItems[i];
		oDomRef = oItem["oTbarRef"];
		bIsHidden = this["bMoreButtonVisible"] ? (oItem["iPriorityIndex"] >= this["iFirstInvisibleItem"]) : (this["bItemIsHidden"](oDomRef) || !UCF_DomUtil["bIsVisible"](oDomRef));

		if (oItem["setDelegateOpenMenu"]) {
			oItem["setDelegateOpenMenu"](bIsHidden);
		}
		if (!bIsHidden) continue;

		if (!this["bIsShown"](oItem["oTbarRef"])) continue;

		bHasSeparator = false || bIsSeqgmentedButtonSeparator;
		bIsSeqgmentedButtonSeparator = false;
		bHasHiddenItems = true;
		bIsSeparator = !UCF_JsUtil["bInstanceOf"](oItem, 'UCF_SegmentedButton') && oDomRef && oDomRef["nodeType"] === 1 && oDomRef["getAttribute"]('data-separator') === 'true';
		if (bIsSeparator) continue;

		sCurrentGroupId = oDomRef && oDomRef["hasAttribute"] && oDomRef["hasAttribute"]('data-separator-group') ? oDomRef["getAttribute"]('data-separator-group') : null;
		if (bFirstHiddenItem) {
			sGroupId = sCurrentGroupId;
			bFirstHiddenItem = false;
		}

		if (sGroupId && sCurrentGroupId && sCurrentGroupId !== sGroupId) {
			bHasSeparator = true;
			sGroupId = sCurrentGroupId;
		}

		oItem["bIsHidden"] = bIsHidden;
		oItem["bHasSeparator"] = bHasSeparator;
		aNewItems["push"](oItem);
	}
	bHasSeparator = false;
	if (this["bHasOveflowItems"]) {
		for (i = 0; i < this["ovflItems"]["length"]; i++) {
			oItem = this["ovflItems"][i];
			bHasSeparator = bHasSeparator || (i === 0 && bHasHiddenItems);
			oItem["bIsHidden"] = bIsHidden;
			oItem["bHasSeparator"] = bHasSeparator;
			aNewItems["push"](oItem);

			//check if the separator for the next item
			//this will be rendered on the top of the next item
			oDomRef = oItem["oTbarRef"];
			bHasSeparator = oDomRef && oDomRef["nodeType"] === 1 && oDomRef["getAttribute"]('data-separator') === 'true';
		}
	}
	return aNewItems;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oGetHiddenItems"] = 0; };

/**
 * Opens the Overflow menu after onClick
 * @param { boolean } bWithKeyboard -	if the menu should be opened with the keyboard
 */
UCF_Toolbar_standards["prototype"]["openToolbarOverflow"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["openToolbarOverflow"]++; }; 
	if (!this["bOverflowMenuJustClosed"]) {
		//_trace(INFO, " openToolbarOverflow: " + this.oHiddenOpener.id);
		this["fireEvent"](this["E_EVENTS"]["OpenOverflow"], { "aItems": this["oGetHiddenItems"](), "bWithKeyboard": bWithKeyboard, "sOpenerId": this["oHiddenOpener"]["id"] });
	}
	this["bOverflowMenuJustClosed"] = false;
	/*
		if (this.bIsToolbarFeatureEnabled || this.bRendersHierarchicalView) {
			this.fireEvent(this.E_EVENTS.OpenOverflow, { aItems: this.oGetHiddenItems(), bWithKeyboard: bWithKeyboard, sOpenerId: this.oHiddenOpener.id });
		} else {
			this.openPopupMenu(bWithKeyboard);
		}*/
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["openToolbarOverflow"] = 0; };

/**
 * After resizing the toolbar some items may become visible.
 * For these items the delegateOpenMenu property must be changed.
 * Otherwise they cannot be opened programmatically, if relying
 * on "bIsHidden".
 * @private
 */

UCF_Toolbar_standards["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onresize"]++; }; 

	// Close popup if the toolbar is resized.
	// D039230:CSN 270813 2011 - fix the close of the openerMenu by onresize
	var iWidth = this["oDomRef"]["offsetWidth"];
	var deltaWidth = this["iToolbarWidth"] - iWidth;
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bToolbarWidthMaximized"] = deltaWidth < 0;
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'onresize(): deltaWidth - ' + deltaWidth, "Toolbar_standards.js(1060): onresize"); };

	if (this["oPopupMenu"] != null
		&& this["oPopupMenu"]["bOpened"] && deltaWidth !== 0) {
		this["oPopupMenu"]["close"]();
		this["toggleOverflowPress"](false);
		if (this["oHiddenOpener"]) {
			// remove focus
			UCF_DomUtil["setTabIndex"](this["oHiddenOpener"], -1);
			this["oHiddenOpener"]["blur"]();
		}
	}
	if (deltaWidth !== 0) {
		this["fireEvent"](this["E_EVENTS"]["CloseOverflow"], {});
	}
	if (deltaWidth !== 0) {
		// eslint-disable-next-line @ur/no-memory-leaks
		this["iToolbarWidth"] = iWidth;

		if (typeof(this["sTimeOutId"]) !== 'undefined') {
			UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		}
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, 'onAfterResize');
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onresize"] = 0; };

UCF_Toolbar_standards["prototype"]["bMenuOpenerVisible"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bMenuOpenerVisible"]++; }; 

	return this["oPopupMenu"] != null && this["oPopupMenu"]["aItems"]
		&& this["oPopupMenu"]["aItems"]["length"] > 0;

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bMenuOpenerVisible"] = 0; };

/** @private
 */
UCF_Toolbar_standards["prototype"]["onAfterResize"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onAfterResize"]++; }; 

	// TODO: replace by always creation of a new Popup Menu instead
	// of hiding items (known issues on the PM scrolling)
	//	_trace(INFO, '++++++++++++++++== onAfterResize - ');
	// The ITS in FLP, after back and forward, render initially the Toolbar
	// into frmae and then it makes the page visible
	// the this.iItmsScrollTop needs ti be updated
	this["updateScrollTop"]();
	this["keepMoreButtonVisible"]();
	if (this["bItemOverflow"] && this["aItems"]) {
		var iMaxHeight = 0;

		for (var i = 0; i < this["aItems"]["length"]; i++) {

			var oItem = this["aItems"][i];

			iMaxHeight = Math["max"](iMaxHeight, oItem && oItem["oDomRef"] ? oItem["oDomRef"]["offsetHeight"] : 0);
			//#ToDo check with the MenuDecorator
			if (oItem && oItem["setDelegateOpenMenu"]) {
				oItem["setDelegateOpenMenu"](this["bItemIsHidden"](i));
			}
		}
		if (this["oViewPort"] && iMaxHeight > this["oViewPort"]["offsetHeight"]) {
			this["oViewPort"]["style"]["height"] = iMaxHeight + 'px !important';
		}
	}

	this["checkOverflowFixedRightItems"]();
	this["adjustFocusHelper"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onAfterResize"] = 0; };

/**
 * Hide / show toolbar items
 *
 * @param {boolean} bOpen - if the items are already shown or not
 * @private
 */
UCF_Toolbar_standards["prototype"]["toggleItems"] = function(bOpen) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["toggleItems"]++; }; 
	if (this["aToggleItems"] === null) return;

	var sDisplay = bOpen ? 'none' : '';

	for (var i = 0; i < this["aToggleItems"]["length"]; i++) {
		if (this["aToggleItems"][i]) {
			this["aToggleItems"][i]["style"]["display"] = sDisplay;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["toggleItems"] = 0; };

/**
 * Hide / show toolbar items
 *
 * @param { boolean } bExpanded -	if the items are already shown or not
 * @private
 */

UCF_Toolbar_standards["prototype"]["onToggleButton"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onToggleButton"]++; }; 
	var oToggleButton = UCF_DomUtil["$"](this["sId"] + '-tgl');

	// TODO: replace by UCF_DomUtil.firstChild(this.oDomRef)
	// to avoid problems with text node
	if (oToggleButton != null && this["bHasShowAllState"]) {

		var bOpen = this["bIsToggleButtonExpanded"]();
		this["toggleButtonIcon"](bOpen);
		this["toggleItems"](bOpen);
	}
	oEvent["mParameters"]["CancelEvent"] = true;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onToggleButton"] = 0; };

/**
 * Hide / show toolbar items
 *
 * @param { boolean } bExpanded -	if the items are already shown or not
 * @private
 */
UCF_Toolbar_standards["prototype"]["toggleButtonIcon"] = function(bExpanded) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["toggleButtonIcon"]++; }; 
	var oToggleButton = UCF_DomUtil["$"](this["sId"] + '-tgl');

	// TODO: replace by UCF_DomUtil.firstChild(this.oDomRef)
	// to avoid problems with text node

	var oToggleIcon = this["bIsIEQuirksMode"] ? oToggleButton["firstChild"] : UCF_DomUtil["$"](this["sId"] + '-tgl-img');

	if (bExpanded) {
		UCF_DomUtil["replaceClass"](oToggleIcon, 'lsToolbar--toogleIcon-expanded', 'lsToolbar--toogleIcon-collapsed');
		if (window["UCF_System"]["bIsAria"]) {
			UCF_AriaStateHelper["setExpanded"](oToggleButton, false);
		}

	} else {
		UCF_DomUtil["replaceClass"](oToggleIcon, 'lsToolbar--toogleIcon-collapsed', 'lsToolbar--toogleIcon-expanded');
		if (window["UCF_System"]["bIsAria"]) {
			UCF_AriaStateHelper["setExpanded"](oToggleButton, true);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["toggleButtonIcon"] = 0; };

/**
 * Checks if the toggle button is expanded or collapsed
 *
 * @return { boolean } true if the toggle button is expanded
 * @private
 */
UCF_Toolbar_standards["prototype"]["bIsToggleButtonExpanded"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsToggleButtonExpanded"]++; }; 
	var oToggleButtonIcon = UCF_DomUtil["$"](this["sId"] + '-tgl-img');
	if (!oToggleButtonIcon) return false;

	var sCssClass = 'lsToolbar--toogleIcon-expanded';
	return UCF_DomUtil["bHasClass"](oToggleButtonIcon, sCssClass);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsToggleButtonExpanded"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mousemove
 */
UCF_Toolbar_standards["prototype"]["onmousemove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onmousemove"]++; }; 

	var oRef = UCF_DomUtil["$"](this["sId"] + '-menuindicator'),
		sCursor = UCF_UserAgent["bIsIE"](100) ? "cursor" : "pointer",
		oEventSource = oBrowserEvent["oGetSource"]();

	if (!this["bItemOverflow"] || oRef === null || this["oViewPort"] === null) return;

	if (!this["bMenuOpenerVisible"]()) return;

	var bShowCursor = (this["bOpenerTriggered"](oBrowserEvent)
		|| oEventSource === this["oHiddenOpener"]) && this["bIsWrapping"]();

	if (bShowCursor && oRef["style"]["cursor"] !== sCursor) {
		oRef["style"]["cursor"] = sCursor;
	} else if (!bShowCursor && oRef["style"]["cursor"] === sCursor) {
		oRef["style"]["cursor"] = '';
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onmousemove"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the mouseout
 */
UCF_Toolbar_standards["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onmouseout"]++; }; 

	var oRef = UCF_DomUtil["$"](this["sId"] + "-menuindicator"),
		sCursor = UCF_UserAgent["bIsIE"](100) ? "cursor" : "pointer";

	if (!this["bItemOverflow"] || oRef === null || this["oViewPort"] === null) return;
	if (!this["bMenuOpenerVisible"]()) return;
	if (oRef["style"]["cursor"] === sCursor)
		oRef["style"]["cursor"] = "";
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onmouseout"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Toolbar_standards["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Toolbar_standards.js(1256): onmouseover"); };
	// fired by mouse click

	var oSourceDomRef = oBrowserEvent["oGetSource"]();
	if (this["oHiddenOpener"] !== oSourceDomRef) return;

	var bIsTouch = !oBrowserEvent["bIsMouseHover"]();
	if (bIsTouch) {
		if (UCF_DomUtil["bHasClass"](this["oHiddenOpener"], this["eStyles"]["TOOLBAR_OVERFLOW_HOVERABLE"])) {
			UCF_DomUtil["removeClass"](this["oHiddenOpener"], this["eStyles"]["TOOLBAR_OVERFLOW_HOVERABLE"]);
		}

	} else {
		if (!UCF_DomUtil["bHasClass"](this["oHiddenOpener"], this["eStyles"]["TOOLBAR_OVERFLOW_HOVERABLE"])) {
			UCF_DomUtil["addClass"](this["oHiddenOpener"], this["eStyles"]["TOOLBAR_OVERFLOW_HOVERABLE"]);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onmouseover"] = 0; };

/**
 * Checks whether the items are wrapping
 * @return {boolean} if the overflow DOM reference is wrapped or not
 * @private
 */
UCF_Toolbar_standards["prototype"]["bIsWrapping"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsWrapping"]++; }; 
	if (typeof this["oViewPort"] !== "undefined" && this["oViewPort"] != null
		&& this["oViewPort"]["offsetHeight"] !== "undefined"
		&& this["oViewPort"]["scrollHeight"] !== "undefined") {
		//_trace(INFO, "===== -itms - offsetHeight - " + this.oViewPort.offsetHeight+ "px - scrollHeightt - " + this.oViewPort.scrollHeight + "px ");
		//_trace(INFO, "===== -itms - bIsWrapping - " + ((this.oViewPort.offsetHeight + 5) < this.oViewPort.scrollHeight));

		//_trace(INFO, " bIsWrapping ===== this.oViewPort.offsetHeight: " + this.oViewPort.offsetHeight + "; - this.oViewPort.scrollHeight: " + this.oViewPort.scrollHeight);
		return (this["oViewPort"]["offsetHeight"] + 5) < this["oViewPort"]["scrollHeight"] || (Math["abs"](this["oViewPort"]["offsetWidth"] - this["oViewPort"]["scrollWidth"]) > 2);

	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsWrapping"] = 0; };

/**
 *
 * Find out whether the user has interacted in some way with the opener icon.
 * The opener icon is a background image in order to avoid initial scripting.
 * The user has to interact with its coordinates in some way.
 * The coordinates of the client rectangle defined for the menu indicator.
 *
 * 	y1-------- y1/x2
 *	|			|
 *	|			|
 *	|			|
 *	y2/x1------ x2
 *
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the mouseout
 */

UCF_Toolbar_standards["prototype"]["bOpenerTriggered"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bOpenerTriggered"]++; }; 

	var oRect = UCF_DomUtil["oGetObjectRect"](this["oViewPort"]),
		//e = oBrowserEvent,
		y1 = oRect["top"],
		y2 = oRect["top"] + oRect["height"],
		x1 = (!window["UCF_System"]["bIsRTL"]) ? oRect["left"] + oRect["width"] - 9 :
		oRect["left"] + 22,
		x2 = (!window["UCF_System"]["bIsRTL"]) ? oRect["left"] + oRect["width"] + 2 :
		oRect["left"];
	//CSN 3144405 2011 - considering the scroll position
	var oScrollOffset = UCF_DomUtil["oGetScrollOffset"](window);
	var iXPos = oBrowserEvent["_iClientX"] + oScrollOffset["x"],
		iYPos = oBrowserEvent["_iClientY"] + oScrollOffset["y"];
	return (!window["UCF_System"]["bIsRTL"]) ?
		(iYPos >= y1 && iYPos <= y2 && iXPos >= x1 && iXPos <= x2) :
		(iYPos >= y1 && iYPos <= y2 && iXPos <= x1 && iXPos >= x2);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bOpenerTriggered"] = 0; };

/**
 * The dom reference of the opener control, that should be used for alignment.
 * Used by {ToolbarOverflowMenuDecorator}
 * @return {HTMLElement} - the current opener
 */
UCF_Toolbar_standards["prototype"]["oGetPopupOpener"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oGetPopupOpener"]++; }; 
	return this["oPopupOpenerRef"];
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oGetPopupOpener"] = 0; };

/**
 * Sets the dom reference of the opener control
 * @param {HTMLElement} oOpener - the current opener
 */
UCF_Toolbar_standards["prototype"]["setPopupOpener"] = function(oOpener) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["setPopupOpener"]++; }; 
	this["oPopupOpenerRef"] = oOpener;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["setPopupOpener"] = 0; };

/**
 * Retrieves the control id of the control that opens the PopupMenu
 * Used by { ToolbarOverflowMenuDecorator }
 * @return {string} - the control id
 */
UCF_Toolbar_standards["prototype"]["sGetPopupOpenerId"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["sGetPopupOpenerId"]++; }; 
	return this["sPopupOpener"];
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["sGetPopupOpenerId"] = 0; };

/**
 * Sets the control id that opens the PopupMenu
 * @param {string} sOpenerId - the current opener
 */
UCF_Toolbar_standards["prototype"]["setPopupOpenerId"] = function(sOpenerId) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["setPopupOpenerId"]++; }; 
	this["sPopupOpener"] = sOpenerId;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["setPopupOpenerId"] = 0; };

/**
 * Set the focus on the Opener after the Overflow menu is closed
 * Used by {ToolbarOverflowMenuDecorator}
 * @private
 */
UCF_Toolbar_standards["prototype"]["setFocusOnOpener"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["setFocusOnOpener"]++; }; 
	var oActive = UCF_DomUtil["oGetActiveElement"](),
		bContains = UCF_DomUtil["bContains"](this["oDomRef"], oActive);

	if (!bContains || (bContains && this["bItemIsHidden"](oActive))
		|| this["oHiddenOpener"] === this["oMoreButtonDomRef"]) {
		UCF_DomUtil["focusDomElement"](this["oHiddenOpener"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["setFocusOnOpener"] = 0; };

/**
 * Returns the last visible toolbar item
 * @return {Object} - the last visible item
 * @private
 */
UCF_Toolbar_standards["prototype"]["getLastVisibleItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["getLastVisibleItem"]++; }; 
	var aItems = this["aItems"];

	for (var i = aItems["length"] - 1; i >= 0; i--) {
		if (!this["bItemIsHidden"](i)) {
			return aItems[i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["getLastVisibleItem"] = 0; };

/**
 * Returns the last visible and focusable toolbar item
 *
 * @return { UCF_Control } oItem - the control
 * @private
 */
UCF_Toolbar_standards["prototype"]["getLastVisibleAndFocusableItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["getLastVisibleAndFocusableItem"]++; }; 
	var aItems = this["aItems"];

	for (var i = aItems["length"] - 1; i >= 0; i--) {
		if (!this["bItemIsHidden"](i) && UCF_DomUtil["bHasTabIndex"](aItems[i]["oDomRef"])) {
			return aItems[i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["getLastVisibleAndFocusableItem"] = 0; };

/**
 * Returns the last visible toolbar item
 *
 * @return { UCF_Control } oItem - the control
 * @private
 */
UCF_Toolbar_standards["prototype"]["getIsHiddenItem"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["getIsHiddenItem"]++; }; 
	var aItems = this["aItems"];

	for (var i = aItems["length"] - 1; i >= 0; i--) {
		if (this["bItemIsHidden"](i)) {
			return aItems[i];
		}
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["getIsHiddenItem"] = 0; };

/**
 * Check if the current control is the last focusable and visible
 * Returns false - if there is a next ctrl which is focusable and visible
 * Returns true - if is the last focusable and visible ctrl
 * fix CSN 169912 2010
 * @param {string} sId - id of the item
 * @return {boolean} - true if the item is the last visible and focusable item
 * @private
 */
UCF_Toolbar_standards["prototype"]["bIsLastVisibleAndFocusable"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsLastVisibleAndFocusable"]++; }; 
	// in 508 mode all items are focusable
	//if (UCF_System.bIs508) return false;

	if (sId === null) return true;
	var aItems = this["aItems"];
	var oDomItem, found = false,
		bLastEnabled = true;
	for (var i = 0; i <= aItems["length"] - 1; i++) {
		oDomItem = aItems[i];
		if (oDomItem["sId"] != null &&
			(sId === oDomItem["sId"] || oDomItem["sId"]["indexOf"](sId) > -1)) {
			found = true;
		}
		if (found && sId !== oDomItem["sId"]) {
			// check if next ctrl is focusable and not hidden
			bLastEnabled = !this["bItemIsHidden"](i) && oDomItem["bIsFocusable"]();
			if (bLastEnabled) {
				return false;
			}
		}
	}
	return true;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsLastVisibleAndFocusable"] = 0; };

/**
 * Check if the current control is a right item
 * @param {HTMLElement} oDomRef - the current Control
 * @return {boolean} - true if the item is a right item
 * @private
 */
UCF_Toolbar_standards["prototype"]["bIsRightItem"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsRightItem"]++; }; 

	if (!oDomRef) return false;
	if (oDomRef["hasAttribute"] && oDomRef["hasAttribute"]('data-rightitem')) {
		return oDomRef["getAttribute"]('data-rightitem') === 'true';
	} else if (oDomRef["hasAttribute"] && oDomRef["hasAttribute"]('data-toolbaritem-id')) {
		var sToolbarItemId = oDomRef["getAttribute"]('data-toolbaritem-id');
		if (sToolbarItemId) {
			var oParentDomRef = UCF_DomUtil["$"](sToolbarItemId);
			return oParentDomRef && oParentDomRef["getAttribute"] && oParentDomRef["getAttribute"]('data-rightitem') === 'true';
		}
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsRightItem"] = 0; };

/**
 * Check if the given item is hidden
 * @param {Object} oParam - the item
 * @return {boolean} true if the item is hidden
 * @private
 */
UCF_Toolbar_standards["prototype"]["bItemIsHidden"] = function(oParam) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bItemIsHidden"]++; }; 
	if (!this["bItemOverflow"]) return false;
	var oItem = typeof(oParam) === "number" ? this["aItems"][oParam]["oTbarRef"] : oParam;
	if (!oItem || !oItem["id"]) return true;

	if (this["bMoreButtonVisible"]) return false;

	if (this["oViewPort"]) {
		return oItem === null || (oItem != null && (!UCF_DomUtil["bIsVisible"](oItem) || UCF_DomUtil["sGetAttribute"](oItem, 'data-itemoverflow') === 'true'))
			//|| oItem.offsetTop !=  this.oViewPort.offsetTop;
			//Zoom to 80% might make the difference 1px
			|| Math["abs"](oItem["offsetTop"] - this["oViewPort"]["offsetTop"]) > 2;
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bItemIsHidden"] = 0; };

/**
 * Check if the given item is visible;
 * this check includes the Overflow Items
 * @param {Object} oItem - the item
 * @return {boolean} true if the item is hidden
 * @private
 */
UCF_Toolbar_standards["prototype"]["bIsVisibleItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsVisibleItem"]++; }; 
	if (!this["bItemOverflow"]) return true;
	if (!oItem || !oItem["id"]) return false;

	if (UCF_DomUtil["sGetAttribute"](oItem, 'data-itemoverflow') === 'true') return false;
	if (!UCF_DomUtil["bIsVisible"](oItem, true)) return false;

	return !this["bItemIsHidden"](oItem);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsVisibleItem"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_Toolbar_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["destroy"]++; }; 

	if (this["sTimeOutId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		this["sTimeOutId"] = null;
	}
	if (this["bDelayOverflowHeight"]) {
		UCF_JsUtil["clearDelayedCallsOfObject"](this);
	}
	if (this["bItemOverflow"]) {

		this["detachBrowserEvent"]("resize", this["oDomRef"]);
	}
	if (this["bRendersHierarchicalView"]) {
		//remove DomReferences
		for (var i = this["aItems"]["length"] - 1; i >= 0; i--) {
			var oItem = this["aItems"][i];

			if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Button") || UCF_JsUtil["bInstanceOf"](oItem, "UCF_LinkChoice")) {
				oItem["detachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
			}

			oItem["oTbarRef"] = null;
		}
		if (this["bItemOverflow"] && this["aItems"]["length"] > 0) {
			if (this["oLS"]) {
				this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
				if (this["oLS"]["oGetPageInternal"]()) {
					this["oLS"]["oGetPageInternal"]()["detachEvent"](this["oLS"]["oGetPageInternal"]()["E_EVENTS"]["CustomStylesApplied"], this, "onCustomStylesApplied");
				}
			}
		}
	}
	if (this["oMoreButton"]) {
		this["oMoreButton"]["detachSemanticEvent"]('MenuAccess', this, 'onPressMoreButton');
	}

	if (this["oOverflowButton"]) {
		this["oOverflowButton"]["detachSemanticEvent"]('MenuAccess', this, 'onPressOverflowButton');
		this["oOverflowButton"]["detachSemanticEvent"]('Press', this, 'onPressOverflowButton');
	}

	this["oViewPort"] = null;
	this["aItems"] = null;

	this["rItems"] = null;
	this["aToggleItems"] = null;
	this["oViewPort"] = null;
	if (this["oPopupMenu"]) {
		UCF_ClientPopupMenuHelper["handleDestroy"](this["oPopupMenu"]);
		this["oPopupMenu"] = null;
	}
	this["oHiddenOpener"] = null;
	this["oMoreButton"] = null;
	this["oRightItemContainer"] = null;
	// container with OverflowItems
	this["oOverflowItems"] = null;
	if (window["UCF_System"]["bIs508"]) {
		this["oEndToolbar"] = null;
	}
	this["oOverflowButtonDomRef"] = null;
	this["oDomOvflPusher"] = null;
	this["oMoreOvflDomRef"] = null;
	this["oMoreButtonDomRef"] = null;
	this["oQuickView"] = null;
	this["oOverflowButton"] = null;
	this["oMoreClientButton"] = null;
	this["oOverflowClientButton"] = null;
	this["sOverflowItemsState"] = null;
	this["sPopupOpener"] = null;
	this["oPopupOpenerRef"] = null;
	this["oPopupOpenerItem"] = null;

	this["sOverflowButtonId"] = null;
	this["bHasOveflowItems"] = null;
	this["bPriorityChanged"] = null;
	this["bHasMinWidth"] = null;
	this["bHasHierarchicalViewTitle"] = null;
	this["iFirstInvisibleItem"] = null;
	this["iItmsScrollTop"] = null;
	this["iToolbarWidth"] = null;
	this["bDelayOverflowHeight"] = null;
	this["bFocusFromHiddenItem"] = null;
	this["bToolbarWidthMaximized"] = null;
	this["oToggleButtonDomRef"] = null;
	this["oToggleButton"] = null;
	this["aRightItemsIdList"] = null;
	this["oLastAccItem"] = null;
	if (this["bHasOveflowItems"]) {
		this["detachEvent"](
			this["E_EVENTS"]["OpenOverflow"],
			this["oToolbarDelegate"],
			'onOverflowOpen'
		);
		this["detachEvent"](
			this["E_EVENTS"]["CloseOverflow"],
			this["oToolbarDelegate"],
			'onOverflowClose'
		);
	}
	if (this["oToolbarDelegate"])
		this["oToolbarDelegate"]["destroy"]();
	this["oToolbarDelegate"] = null;
	this["oRightItemsPusher"] = null;
	this["bOverflowMenuJustClosed"] = null;
	UCF_Toolbar.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["destroy"] = 0; };

/**
 *
 * 'data-control-id' the id of the toolbar item
 * 'data-rightitem' - true if it's right item
 * 'data-priority' - the priority given via API
 * 'data-after-priority' - calculated using the index
 * 'data-separator-group' - the separator group which belongs
 * 'data-separator' - if it's separatoe
 * 'data-showalways' - item should alwayd be showed
 * 'data-minwidth' - true, if it has min-width via API
 *  Create an array with all UCF_Toolbar_standardsItems apart from the separators
 *
 * @private
 */
// eslint-disable-next-line complexity
UCF_Toolbar_standards["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["createItems"]++; }; 
	/** Contains the child control (separators are currently no UCF controls)
	 */
	this["aItems"] = [];
	// groups the Items after the ToolbarSeparator
	this["aSeparatorGroups"] = [];
	var aSeparatorGroupsId = [];
	this["aRightItemsIdList"] = [];
	this["accItems"] = [];
	var bIsToolbarSeparator = false,
		iAccIndex = -1;
	this["ovflItems"] = [];
	this["rItems"] = [];
	this["aToggleItems"] = [];
	var iMaxHeight = 0;
	//ToobarSeparator belongs to the next ToolbarItem
	var sToolbarSeparatorId = null;
	var iSeparatorGroup = 0;
	var bHideRightItemsPusher = true;
	var iPriority = 0;
	var bAllowMinWidth = !this["bWrapping"];

	var bAlwaysVisibleSeparator = false;

	var oRightItemsIds = UCF_DomUtil["$"](this["sId"] + '-rightItemsIds'),
		sRightItemsIds = '';
	//
	var bIsBrowserForDelay = UCF_UserAgent["bIsIE"]();

	if (oRightItemsIds) {
		//sRightItemsIds = oRightItemsIds.
		sRightItemsIds = oRightItemsIds["innerText"];
		sRightItemsIds = sRightItemsIds["replace"](/(&#x20;)/g, ' ');
		sRightItemsIds = sRightItemsIds["replace"](/(&nbsp;)/g, ' ');

		// eslint-disable-next-line @ur/no-memory-leaks
		this["aRightItemsIdList"] = sRightItemsIds["split"](', ');

	}
	if (this["oViewPort"] === null && this["oRightItemContainer"] === null) return;

	var oDomItem;
	for (var oLeftItem = this["oViewPort"]["firstElementChild"]; oLeftItem; oLeftItem = oLeftItem["nextElementSibling"]) {
		//do not handle elements that are no potential items
		oDomItem = oLeftItem;
		bIsToolbarSeparator = false;
		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node

		if (oDomItem["id"] === null
			|| (oDomItem["firstChild"] && oDomItem["firstChild"]["nodeType"] === 3)
			|| (oDomItem["id"] != null && oDomItem["id"] === (this["sId"] + '-moreOvfl'))
			|| (this["sOverflowButtonId"] && oDomItem["id"] != null && oDomItem["id"] === (this["sOverflowButtonId"] + '-r')))
			continue;

		if (oDomItem["getAttribute"]('canHide') === 'true') {
			this["aToggleItems"]["push"](oDomItem);
		}
		// Test if oDomItem is a separator
		//	bIsToolbarSeparator = UCF_DomUtil.sGetClass(oDomItem).indexOf('urTSep') > -1;
		bIsToolbarSeparator = oDomItem && oDomItem["nodeType"] === 1 && oDomItem["getAttribute"]('data-separator') === 'true';
		if (bIsToolbarSeparator) {
			sToolbarSeparatorId = oDomItem["id"];
			this["aSeparatorGroups"]["push"]({ "SeparatorId": sToolbarSeparatorId, "GroupIds": aSeparatorGroupsId });
			oDomItem["setAttribute"]('data-separator-group', iSeparatorGroup);
			if (bAlwaysVisibleSeparator && aSeparatorGroupsId["length"] === 0) {
				oDomItem["setAttribute"]('data-showalways', 'true');
				bAlwaysVisibleSeparator = false;
			}
			aSeparatorGroupsId = [];
			iSeparatorGroup++;
		}

		var oCtRef = this["oGetCtRef"](oDomItem);
		if (oCtRef === null)
			continue;
		var oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oCtRef, true);
		if (UCF_JsUtil["bInstanceOf"](oItem, 'UCF_SegmentedButton')) {
			oDomItem["setAttribute"]('data-separator', 'true');
			oDomItem["setAttribute"]('data-showalways', 'false');
		}

		iMaxHeight = Math["max"](iMaxHeight, oItem["oDomRef"]["offsetHeight"]);
		// eslint-disable-next-line @ur/no-memory-leaks
		this["bHasMinWidth"] = bAllowMinWidth && (this["bHasMinWidth"] || (oDomItem["getAttribute"]('data-minwidth') === 'true'));

		if (bIsBrowserForDelay && this["bItemOverflow"] && !this["bDelayOverflowHeight"] && oItem) {
			var oImageDomRef = UCF_DomUtil["$"](oItem["sId"] + '-img');
			// eslint-disable-next-line @ur/no-memory-leaks
			this["bDelayOverflowHeight"] = oImageDomRef && oImageDomRef["tagName"] === 'IMG' && oImageDomRef["src"]["indexOf"]('.svg') > -1;
			//	_trace(INFO, 'Toolbar: ' + this.sId + ' - Item: ' + oItem.sId + ' - height: ' + oItem.oDomRef.offsetHeight);
		}

		if (this["bMoreButtonVisible"] || this["bItemOverflow"]) {
			// check if the oDomRef has display=none; either visibility.None or Show=false
			// this should be done in renderer
			if (oDomItem && !UCF_DomUtil["bIsVisible"](oDomItem)) {
				oDomItem["setAttribute"]('show', 'false');
			}
		}
		// the always visible items should not belong to the items group for separators
		if (!bIsToolbarSeparator) {
			if (!oDomItem["hasAttribute"]('data-showalways')) {
				oDomItem["setAttribute"]('data-separator-group', iSeparatorGroup);
				aSeparatorGroupsId["push"](oDomItem["id"]);
			} else {
				bAlwaysVisibleSeparator = true;
			}
		}
		oItem["oTbarRef"] = oDomItem;

		if (!bIsToolbarSeparator && window["UCF_System"]["bIs508"] && this["bIsShown"](oDomItem)) {
			iAccIndex++;
			oItem["iAccIndex"] = iAccIndex;
		}
		oItem["iIndex"] = this["aItems"]["length"];
		oItem["iPriorityIndex"] = this["aItems"]["length"];
		iPriority = this["iGeneratePriority"](this["iGetPriorityFromDom"](oDomItem), oItem["iIndex"]);

		// if there are right items which should not be hidden,
		// then also the right item pusher should not be hidden
		// in this way the right items will be pushed to the right
		if (!this["bHasRightItemsFixed"]
			&& this["bIsRightItem"](oDomItem)
			&& oDomItem["hasAttribute"]('data-showalways')) {
			bHideRightItemsPusher = false;
		}

		oItem["iPriority"] = iPriority;
		oItem["bShowAlways"] = this["bIsShowAlwaysItem"](oDomItem);
		if (sToolbarSeparatorId != null && sToolbarSeparatorId !== oDomItem["id"]) {
			oDomItem["setAttribute"]('data-separator-id', sToolbarSeparatorId);
			sToolbarSeparatorId = null;
		}
		oDomItem["setAttribute"]('data-after-priority', oItem["iPriority"]);
		this["aItems"]["push"](oItem);

		if (!bIsToolbarSeparator && window["UCF_System"]["bIs508"] && this["bIsShown"](oDomItem)) {
			this["accItems"]["push"](oItem);
		}
	}

	if (!bHideRightItemsPusher && this["oRightItemsPusher"]) {
		this["oRightItemsPusher"]["setAttribute"]('data-showalways', true);
	}

	this["aSeparatorGroups"]["push"]({ "SeparatorId": this["sId"] + '-lastSeparatorId', "GroupIds": aSeparatorGroupsId });

	if (this["bHasRightItemsFixed"])
		iAccIndex = -1;
	// fetch the right items
	if (this["oRightItemContainer"] !== null) {
		for (var oRightItem = this["oRightItemContainer"]["firstElementChild"]; oRightItem; oRightItem = oRightItem["nextElementSibling"]) {
			//do not handle elements that are no potential items
			oDomItem = oRightItem;
			oDomItem["setAttribute"]('data-rightitem', true);
			bIsToolbarSeparator = false;
			//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node

			if (oDomItem["id"] === null
				|| (oDomItem["firstChild"] && oDomItem["firstChild"]["nodeType"] === 3))
				continue;

			// Test if oDomItem is a separator
			bIsToolbarSeparator = oDomItem && oDomItem["nodeType"] === 1 && oDomItem["getAttribute"]('data-separator') === 'true';
			if (bIsToolbarSeparator)
				sToolbarSeparatorId = oDomItem["id"];

			oCtRef = this["oGetCtRef"](oDomItem);
			if (oCtRef === null || oCtRef["getAttribute"]('ct') === 'TBARSEP') continue;

			oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oCtRef, true);

			oItem["oTbarRef"] = oDomItem;
			// eslint-disable-next-line @ur/no-memory-leaks
			this["bHasMinWidth"] = bAllowMinWidth && (this["bHasMinWidth"] || (oDomItem["getAttribute"]('data-minwidth') === 'true'));
			if (this["bHasRightItemsFixed"]) {
				oItem["iIndex"] = this["rItems"]["length"];
				if (!bIsToolbarSeparator && window["UCF_System"]["bIs508"]) {
					iAccIndex++;
					oItem["iAccIndex"] = iAccIndex;
				}
			} else {
				oItem["iIndex"] = this["aItems"]["length"];
				if (!bIsToolbarSeparator && window["UCF_System"]["bIs508"]
					&& this["bIsShown"](oDomItem)) {
					iAccIndex++;
					oItem["iAccIndex"] = iAccIndex;
				}
			}

			if (this["bHasRightItemsFixed"])
				this["rItems"]["push"](oItem);
			else {
				this["aItems"]["push"](oItem);
				if (!bIsToolbarSeparator && window["UCF_System"]["bIs508"]) {
					this["accItems"]["push"](oItem);
				}
			}
		}
	}

	this["aItems"]["sort"](function(a, b) {
		return a["iPriority"] - b["iPriority"];
	});
	for (var i = 0; i < this["aItems"]["length"]; i++) {
		this["aItems"][i]["iPriorityIndex"] = i;
	}

	// if an Item has Min-width
	if (this["bHasMinWidth"]) {
		UCF_DomUtil["addClass"](this["oDomRef"], 'lsToolbar--minWidth');
		if (this["oDomOvflPusher"]) {
			UCF_DomUtil["addClass"](this["oDomOvflPusher"], this["eStyles"]["TOOLBAR_OVERFLOW_PUSHER_HIDDEN"]);
		}

	}
	// Overflow Items
	if (this["bHasOveflowItems"] && this["oOverflowItems"]) {
		for (var oOvflCurrentItem = this["oOverflowItems"]["firstElementChild"]; oOvflCurrentItem; oOvflCurrentItem = oOvflCurrentItem["nextElementSibling"]) {
			var oOvflItem = oOvflCurrentItem;

			if (oOvflItem["id"] === null
				|| (oOvflItem["firstChild"] && oOvflItem["firstChild"]["nodeType"] === 3))
				continue;

			oCtRef = this["oGetCtRef"](oOvflItem);
			//D039230: CSN 3450900 2012 - add the ToolbarInputField and ToolbarComboBox in the list
			// in order to be announced in 508 mode
			if (oCtRef === null && window["UCF_System"]["bIs508"] && oOvflItem["childNodes"]["length"] >= 2) {
				oCtRef = this["oGetCtRef"](oOvflItem["childNodes"][1]);
			}

			//if (oCtRef === null || oCtRef.getAttribute('ct') === 'TBARSEP') continue; // it'll not render separators
			if (oCtRef === null) continue;

			oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oCtRef, true);
			if (UCF_JsUtil["bInstanceOf"](oItem, 'UCF_SegmentedButton')) {
				oOvflItem["setAttribute"]('data-separator', 'true');
			}
			oItem["oTbarRef"] = oOvflItem;
			oItem["iIndex"] = this["ovflItems"]["length"];
			oItem["oTbarRef"]["setAttribute"]('data-itemoverflow', 'true');

			this["ovflItems"]["push"](oItem);
		}
		// eslint-disable-next-line @ur/no-memory-leaks
		this["bHasOveflowItems"] = this["ovflItems"]["length"] > 0;
		if (this["bHasOveflowItems"]) {
			this["sOverflowItemsState"] = (this["sOverflowItemsState"] === this["eOverflowItemsState"]["OVERFLOWBUTTON"] ? this["eOverflowItemsState"]["OVERFLOWBUTTON_OVERFLOWITEMS"] : this["sOverflowItemsState"]);
			this["sOverflowItemsState"] = (this["sOverflowItemsState"] === this["eOverflowItemsState"]["STANDARD"] ? this["eOverflowItemsState"]["STANDARD_OVERFLOWITEMS"] : this["sOverflowItemsState"]);
		}

	} else {
		this["bHasOveflowItems"] = false;
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["createItems"] = 0; };

/**
 * @param {UCF_Control} oItem - the control
 * @return  {HTMLElement} oDomRef - the html element of the item
 *
 * @private
 */
UCF_Toolbar_standards["prototype"]["oGetItemRef"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oGetItemRef"]++; }; 

	// in case of ToolbarItems, -r or -tr will fail
	if (oItem["oTbarRef"])
		return oItem["oTbarRef"];

	var oDomRef = UCF_DomUtil["$"](oItem["sId"] + "-tr");

	if (!oDomRef) {
		oDomRef = UCF_DomUtil["$"](oItem["sId"] + "-r");
	}
	if (!oDomRef) {
		oDomRef = UCF_DomUtil["$"](oItem["sId"]);
	}
	return oDomRef;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oGetItemRef"] = 0; };

/**
 * Generates a priority according with the API priority and position in the Toolbar
 * @param {int} iApiPriority - the priority given via API
 * @param {int} iIndex - the position in the Toolbar
 * @return {int} - the generated priority
 * @private
 */
UCF_Toolbar_standards["prototype"]["iGeneratePriority"] = function(iApiPriority, iIndex) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["iGeneratePriority"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bPriorityChanged"] = this["bPriorityChanged"] || (iApiPriority !== 0);
	return iApiPriority * 100 + iIndex;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["iGeneratePriority"] = 0; };

/**
 * Retrives the priority from DOM element
 * @param {HTMLElement} oDomRef The DOM reference
 * @return {int} - the priority as integer
 * @private
 */
UCF_Toolbar_standards["prototype"]["iGetPriorityFromDom"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["iGetPriorityFromDom"]++; }; 
	if (oDomRef && oDomRef["getAttribute"]('data-priority')) {
		var iPriority = parseInt(oDomRef["getAttribute"]('data-priority'));
		// Labels should first be hidden
		if (!this["bRendersHierarchicalView"] && iPriority === 0 && UCF_StringUtil["bContains"](oDomRef["id"], '-tlbl-tr') > 0) {
			iPriority = -1;
		}
		if (!this["bRendersHierarchicalView"] && iPriority === 0 && UCF_StringUtil["bContains"](oDomRef["id"], '-tr') > 0) {
			iPriority = -2;
		}

		return iPriority;
	}
	return 0;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["iGetPriorityFromDom"] = 0; };

/**
 * Rerieves the DOM reference with ct attribute
 * @param {HTMLElement} oDomRef The DOM reference
 * @return {HTMLElement} - the DOM Reference with ct attribute
 * @private
 */
UCF_Toolbar_standards["prototype"]["oGetCtRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oGetCtRef"]++; }; 
	//D039230: CSN 3450900 2012 - add the ToolbarInputField and ToolbarComboBox in the list
	// in order to be announced in 508 modeoDomRef
	/** @type {HTMLElement} */
	var oControlDomRef;
	/** @type {stringt} */
	var sToolbarItemId;
	sToolbarItemId = oDomRef["id"];
	oControlDomRef = null;
	if (UCF_StringUtil["bContains"](oDomRef["id"], '-tr')) {
		var sControlId = oDomRef["getAttribute"]("data-control-id");
		if (sControlId)
			oControlDomRef = UCF_DomUtil["$"](sControlId);
	} else {
		while (oDomRef != null) {
			if (oDomRef["nodeType"] !== 3 && oDomRef["getAttribute"]("ct")) {
				oControlDomRef = oDomRef;
				break;
			}
			oDomRef = UCF_DomUtil["oGetFirstChild"](oDomRef);
		}
	}
	if (oControlDomRef) {
		oControlDomRef["setAttribute"]('data-toolbaritem-id', sToolbarItemId);
	}
	return oControlDomRef;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oGetCtRef"] = 0; };

/**
 * Return true if the control from the focus is comming is the Overflow Menu
 * @param {UCF_BrowserEvent} oBrowserEvent the lsaccessibility
 * @return {boolean} - true if the control from event is the curent control
 * @private
 */
UCF_Toolbar_standards["prototype"]["bFocusInFromPopupMenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bFocusInFromPopupMenu"]++; }; 

	if (!this["bItemOverflow"]) return false;
	if (!this["oGetPopupOpener"]()) return false;
	var oBrowserSource = oBrowserEvent["oGetSource"]();
	if (oBrowserSource !== this["oGetPopupOpener"]() && oBrowserSource !== UCF_DomUtil["oGetFirstChild"](this["oGetPopupOpener"]())) return false;
	var oFromElement = oBrowserEvent["oGetFromElement"]();
	if (!oFromElement) return false;
	if (UCF_DomUtil["bIsCTInstanceOf"](oFromElement, 'POMNI')) {
		var oParentElement = UCF_DomUtil["oGetCTElement"](oFromElement);
		if (oParentElement) {
			return UCF_StringUtil["bStartsWith"](oParentElement["id"], this["sId"]);
		}

	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bFocusInFromPopupMenu"] = 0; };

/**
 * [ENTER] or [SPACE] on PopupMenuItem set the focus on the Button and send an lsselectup event
 *
 * Checks if the the focus is triggered by the PopupMenu and sets the MENU_CLOSE event state
 * This state will cancel the action on onlsselectup method
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private

UCF_Toolbar_standards.prototype.onfocusin = function(oBrowserEvent) {
	_assert(oBrowserEvent instanceof UCF_BrowserEvent);
	if (this.bFocusInFromPopupMenu(oBrowserEvent))
			this.bOverflowMenuJustClosed = true;
};
 */

/**
 * Used in IE Quirks mode to set the focus on Toolbar Overflow
 * #ToDo - check if it's still necessary on standards mode
 * @private
 */
UCF_Toolbar_standards["prototype"]["adjustFocusHelper"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["adjustFocusHelper"]++; }; 
	if (this["oHiddenOpener"] != null && this["bItemOverflow"]) {
		if (this["bIsWrapping"]() || this["bHasHiddenItems"]()) {
			//_trace(INFO, 'adjustFocusHelper - this.bIsWrapping(): true ');
			UCF_DomUtil["setTabIndex"](this["oHiddenOpener"], 0);
		} else if (!this["bHasOveflowItems"]) {

			if (!this["bIsWrapping"]()) {
				//	_trace(INFO, 'adjustFocusHelper - this.bIsWrapping(): false ');
				UCF_DomUtil["resetTabIndex"](this["oHiddenOpener"]);
			}
			if (this["getIsHiddenItem"]() === null) {
				//	_trace(INFO, 'adjustFocusHelper - this.getIsHiddenItem() == null: true ');
				UCF_DomUtil["resetTabIndex"](this["oHiddenOpener"]);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["adjustFocusHelper"] = 0; };

/**
 * Used in IE Quirks mode to set the focus on Toolbar Overflow
 * #ToDo - check if it 's still necessary on standards mode
 * @private
 */

UCF_Toolbar_standards["prototype"]["bHasHiddenItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bHasHiddenItems"]++; }; 
	if (!this["bItemOverflow"]) return false;
	if (this["iFirstInvisibleItem"] !== -1 && this["iFirstInvisibleItem"] < this["aItems"]["length"])
		return true;
	return false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bHasHiddenItems"] = 0; };

/**
 * @param {boolean} bMoveFocus - if the focus s´hould be set for a hidden item
 * @private
 */
UCF_Toolbar_standards["prototype"]["setFocusFromHiddenItem"] = function(bMoveFocus) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["setFocusFromHiddenItem"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["bFocusFromHiddenItem"] = bMoveFocus;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["setFocusFromHiddenItem"] = 0; };

/**
 *
 * @param { UCF_BrowserEvent } oBrowserEvent the lsfocus
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsfocus"]++; }; 

	if (this["bWrapping"] && !this["bItemOverflow"]) {
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}
	if (this["oViewPort"] === null
		|| !this["bItemOverflow"]
		|| this["aItems"]["length"] === 0) return;

	if (this["bFocusFromHiddenItem"] || (this["oDomRef"] === oBrowserEvent["oGetSource"]() && !window["UCF_System"]["bIs508"])) {
		this["setFocusFromHiddenItem"](false);
		if (this["oMoreButton"]) {
			UCF_DomUtil["focusDomElement"](this["oMoreButton"]);
		} else {
			UCF_DomUtil["focusDomElement"](this["oHiddenOpener"]);
		}
	}

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsfocus"] = 0; };

/**
 * @param { UCF_BrowserEvent } oBrowserEvent the lsblur
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlsblur"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsblur"]++; }; 

	if (this["oViewPort"] === null || !this["bItemOverflow"] || this["aItems"]["length"] === 0 || !this["bIsWrapping"]()) return;

	var oSource = oBrowserEvent["oGetSource"]();

	if (oSource === this["oHiddenOpener"]) {
		UCF_DomUtil["setClass"](this["oViewPort"]["parentNode"], UCF_DomUtil["sGetClass"](this["oViewPort"]["parentNode"])["replace"](/Hover/g, ""));
		//UCF_DomUtil.removeClass(this.oHiddenOpener,"lsTbarBtnOvflActive");
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsblur"] = 0; };

/**
 * Avoids scrolling of the browser if the HasHideMachanism is on. Otherwise
 * items that broke down to the next line would become visible, if focus would go there
 * @param { UCF_BrowserEvent } oBrowserEvent the lstabnext
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlstabnext"]++; }; 
	if (!this["bItemOverflow"] || this["aItems"]["length"] === 0 || !(this["bIsWrapping"]() || this["bHasOveflowItems"])) return;

	var oControl = oBrowserEvent["oGetSourceControl"](),
		oSource = oBrowserEvent["oGetSource"](),
		oLast = this["getLastVisibleItem"]();
	if (this["bIsRightItem"](oSource) && this["bHasRightItemsFixed"]) return;

	// D039230 Fix the tabnext when the focus is on the overflow icon
	if (oSource === this["oHiddenOpener"]) {
		if (this["rItems"]["length"] > 0)
			return;
		if (window["UCF_System"]["bIs508"]) {
			UCF_DomUtil["focusDomElement"](this["oEndToolbar"]);
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		} else {
			// Workaround:
			// If contained in PopupWindow-footer: Do nothing here so the PopupWindow-tab-chain
			// will work, which "connects" the last control in the content with the title
			// Without a new parameter like "UsedInPopupWindowFooter" there is only this workaround
			var oPW = this["oGetParentPopupWindow"]();
			if (oPW) {
				var oTB = oPW["oGetFooterToolbar"]();
				if (oTB === this) {
					return;
				}
			}
			// do the same if embedded in DataGrid header
			var oParent = this["oGetParent"]();
			if (oParent &&
				(UCF_JsUtil["bInstanceOf"](oParent, "UCF_DataGrid")
					|| UCF_JsUtil["bInstanceOf"](oParent, "UCF_SapTable")
					|| UCF_JsUtil["bInstanceOf"](oParent, "UCF_SapTableCS"))) return;

			var focussed = this["focusNextControl"](); //try to focus next sibling and their children
			if (focussed) {
				oBrowserEvent["cancel"]();
				oBrowserEvent["cancelBubble"]();
			} else {
				//No focusable control after the tab strip then leave it up to ls object to find the next element
				this["oLS"]["focusEnd"]();
			}
		}
	} else {
		//check if the next focusable ctrl is visible; otherwise the hiddenOpener should be focused
		var bIgnore = (this === oControl)
			|| (this["oEndToolbar"] != null && this["oEndToolbar"] === oSource)
			|| (this["oMoreButton"] != null && this["oMoreButton"] === oSource);
		if (!bIgnore && this["bItemOverflow"] && this["getIsHiddenItem"]() != null) {
			if (oLast["sId"]["indexOf"](oControl["sId"]) > -1 || this["bIsLastVisibleAndFocusable"](oControl["sId"])) {

				UCF_DomUtil["focusDomElement"](this["oHiddenOpener"]);
				oBrowserEvent["cancel"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlstabnext"] = 0; };

/**
 * Avoids scrolling of the browser if the HasHideMachanism is on. Otherwise
 * items that broke down to the next line would become visible, if focus would go there
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent the lstabprevious
 */
UCF_Toolbar_standards["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlstabprevious"]++; }; 

	if (!this["bItemOverflow"] || this["aItems"]["length"] === 0) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oLast = this["getLastVisibleAndFocusableItem"]();

	if (oSource === this["oHiddenOpener"] && !this["bMoreButtonVisible"]) {
		UCF_DomUtil["focusDomElement"](oLast["oDomRef"]);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlstabprevious"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsskipforward"]++; }; 
	//the panel handles skipping, if the toolbar is
	//within a panel
	var oParentNode = this["oDomRef"]["parentNode"];
	if (oParentNode != null && oParentNode["id"] && oParentNode["id"]["indexOf"]("-hdtbar") > -1) return;

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsskipback"]++; }; 
	//the panel handles skipping, if the toolbar is
	//within a panel
	var oParentNode = this["oDomRef"]["parentNode"];
	if (oParentNode != null && oParentNode["id"] && oParentNode["id"]["indexOf"]("-hdtbar") > -1) return;

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsskipback"] = 0; };

/**
 *  [DOWN] Key
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_PanelStack
 * @param { UCF_BrowserEvent } oBrowserEvent the lsnext
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsdown"]++; }; 
	this["focusNextItem"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsdown"] = 0; };

/**
 *  [RIGHT]
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_PanelStack
 * @param { UCF_BrowserEvent } oBrowserEvent the lsnext
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsright"]++; }; 
	this["focusNextItem"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsright"] = 0; };

/**
 *  [RIGHT] / [DOWN]
 * Avoid bubbling into a control that nests the toolbar.
 * @param { UCF_BrowserEvent } oBrowserEvent the lsnext
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlsnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsnext"]++; }; 
	this["focusNextItem"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsnext"] = 0; };

/**
 * [LEFT] Key
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_PanelStack
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsleft"]++; }; 
	this["focusPreviousItem"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsleft"] = 0; };

/**
 * [UP] Key
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_PanelStack
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsup"]++; }; 
	this["focusPreviousItem"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsup"] = 0; };

/**
 * [LEFT] / [UP] Key
 * Avoid bubbling into a control that nests the toolbar.
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlsprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsprevious"]++; }; 
	this["focusPreviousItem"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsprevious"] = 0; };

/**
 * [HOME] Key
 * Avoid bubbling into a control that nests the toolbar.
 * I.e. UCF_PanelStack
 * @param { UCF_BrowserEvent } oBrowserEvent the lsprevious
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlshome"]++; }; 
	this["focusFirstItem"](oBrowserEvent);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlshome"] = 0; };

/**
 * [END]
 * Hanldes the lsend event
 * @private
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Toolbar_standards["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsend"]++; }; 
	this["focusLastItem"](oBrowserEvent);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsend"] = 0; };

/**
 * Writes the appropriate accessibility text into the tooltip
 * @param { UCF_BrowserEvent } oBrowserEvent the lsaccessibility
 * @private
 */
UCF_Toolbar_standards["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Toolbar_standards.js(2341): onlsaccessibility"); };

	var oSourceControl = oBrowserEvent["oGetSourceControl"](),
		oToggleButtonSource = UCF_DomUtil["$"](this["sId"] + "-tgl");

	if (oBrowserEvent["oGetSourceControl"]() !== this && !this["bIsToolbarItem"](oSourceControl)) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource === this["oHiddenOpener"] || (this["oMoreButton"] && this["oMoreButton"] === oSource)) {
		oAccessibilityHelper["addTutor"]("T_MENU_TUT");
	} else if (oSource["getAttribute"]("tp") === "END") {
		oAccessibilityHelper["setControlType"]("T_END");
	} else if (oSource === oToggleButtonSource && oSource["children"]["length"] > 0
		&& UCF_DomUtil["sGetClass"](oSource["children"][0])["indexOf"]("Col") > -1) {
		oAccessibilityHelper["addTutor"]("T_BTN_E");
		oAccessibilityHelper["addTutor"]("LN_TUT");
	} else if (oSource === oToggleButtonSource && oSource["children"]["length"] > 0
		&& UCF_DomUtil["sGetClass"](oSource["children"][0])["indexOf"]("Exp") > -1) {
		oAccessibilityHelper["addTutor"]("T_BTN_C");
		oAccessibilityHelper["addTutor"]("LN_TUT");
	} else if (this["bIsToolbarItem"](oSourceControl)) {
		if (this["oLastAccItem"] === oSourceControl) {
			// if the event is bubbled by the previous control this means that
			// an action, like Arrow Down/Up, occurs and the Toolbar should cancel
			// its annoucement
			oBrowserEvent["cancelBubble"]();
			return;
		} else {
			if (this["bIsRightItem"](oSource)) {
				oAccessibilityHelper["setItemCount"](this["rItems"]["length"]);
			} else {
				oAccessibilityHelper["setItemCount"](this["accItems"]["length"]);
			}
			oAccessibilityHelper["setItemIndex"](oSourceControl["iAccIndex"] + 1);
			oAccessibilityHelper["setItemCountText"]("T_ITMPOS");
			this["oLastAccItem"] = oSourceControl;
		}
	} else {

		oAccessibilityHelper["setControlType"]("T");
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		oAccessibilityHelper["applyContainerEntryBehaviour"]();

		oAccessibilityHelper["setAccessibilityDescription"](this["sAccessibilityDescription"]);
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onlsaccessibility"] = 0; };

/**
 * Check if the source is one of the below controls
 * needed for accessibility
 * @param {Object} oItem -
 * @return {boolean} - true if the object is a toolbar item
 * @private
 */
UCF_Toolbar_standards["prototype"]["bIsToolbarItem"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsToolbarItem"]++; }; 
	if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Button") ||
		UCF_JsUtil["bInstanceOf"](oItem, "UCF_Link") ||
		UCF_JsUtil["bInstanceOf"](oItem, "UCF_LinkChoice") ||
		UCF_JsUtil["bInstanceOf"](oItem, "UCF_ComboBox") ||
		UCF_JsUtil["bInstanceOf"](oItem, "UCF_InputField")
	) {
		return true;
	} //else
	return false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bIsToolbarItem"] = 0; };

/**
 * Focus on first focusable item of the toolbar
 * if the current items is the last one, it'll focus the first focusable item of the toolbar
 * @param { UCF_BrowserEvent } oBrowserEvent the lsaccessibility
 * @private
 */
UCF_Toolbar_standards["prototype"]["focusFirstItem"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["focusFirstItem"]++; }; 

	var oFirstFocusedDomRef;

	// moves the focus on the first left item
	if (this["oViewPort"] != null) {
		oFirstFocusedDomRef = UCF_DomUtil["oGetTabbableElementForward"](this["oViewPort"], true);
	} else if (this["oRightItemContainer"] != null) {
		// moves the focus on first right item, if no left items exists
		oFirstFocusedDomRef = UCF_DomUtil["oGetTabbableElementForward"](this["oRightItemContainer"], true);
	}

	if (oFirstFocusedDomRef) {
		UCF_DomUtil["moveFocusDomElement"](oFirstFocusedDomRef, true);
		if (window["UCF_System"]["bIsAria"]) {
			this["oDomRef"]["ariaActivedescendant"] = oFirstFocusedDomRef["id"];
			UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], oFirstFocusedDomRef["id"]);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["focusFirstItem"] = 0; };

/**
 * Focus on next focusable item of the toolbar
 * if the current items is the last one, it'll focus the first focusable item of the toolbar
 * @param { UCF_BrowserEvent } oBrowserEvent the lsaccessibility
 * @private
 */
UCF_Toolbar_standards["prototype"]["focusNextItem"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["focusNextItem"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();
	var oNextDomRef = UCF_DomUtil["oGetNextSibling"](oSource, true),
		oNextTabbableDomRef, oNextFocusedDomRef;

	if (this["oHiddenOpener"] != null && oSource === this["oHiddenOpener"]) {
		//Check if there are right items
		if (this["oRightItemContainer"] != null) {
			// moves the focus on first right item, if no left items exists
			oNextFocusedDomRef = UCF_DomUtil["oGetTabbableElementForward"](this["oRightItemContainer"], true);
		} else {
			//if the last item is the OverflowMenu, the focus should remain on it
			oNextFocusedDomRef = oSource;
		}

	} else {
		while (oNextDomRef) {
			oNextTabbableDomRef = UCF_DomUtil["oGetTabbableElementForward"](oNextDomRef, true);
			if (oNextTabbableDomRef)
				break;
			oNextDomRef = UCF_DomUtil["oGetNextSibling"](oNextDomRef, true);
		}
		// container with LeftItems -> this.oViewPort
		// container with RightItems -> 	this.oRightItemContainer
		if (oNextTabbableDomRef
			&& ((this["oViewPort"] != null && UCF_DomUtil["bContains"](this["oViewPort"], oNextTabbableDomRef))
				|| (this["oRightItemContainer"] !== null && UCF_DomUtil["bContains"](this["oRightItemContainer"], oNextTabbableDomRef))
				|| (this["oHiddenOpener"] != null && oNextTabbableDomRef === this["oHiddenOpener"]))) {
			// this item is inside of the toolbr, left or right item
			oNextFocusedDomRef = oNextTabbableDomRef;

		} else {
			// moves the focus on the first left item
			/*if (this.oViewPort != null) {
				oNextFocusedDomRef = UCF_DomUtil.oGetTabbableElementForward(this.oViewPort, false);
			} else if (this.oRightItemContainer != null) {
				// moves the focus on first right item, if no left items exists
				oNextFocusedDomRef = UCF_DomUtil.oGetTabbableElementForward(this.oRightItemContainer, false);
			}*/
		}
	}

	if (oNextFocusedDomRef) {
		UCF_DomUtil["moveFocusDomElement"](oNextFocusedDomRef, true);
		if (window["UCF_System"]["bIsAria"]) {
			this["oDomRef"]["ariaActivedescendant"] = oNextFocusedDomRef["id"];
			UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], oNextFocusedDomRef["id"]);
		}
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["focusNextItem"] = 0; };

/**
 * Focus on previous focusable item of the toolbar
 * if the current items is the first one, it'll focus the last focusable item of the toolbar
 * @param { UCF_BrowserEvent } oBrowserEvent the lsaccessibility
 * @private
 */
UCF_Toolbar_standards["prototype"]["focusPreviousItem"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["focusPreviousItem"]++; }; 
	var oSource = oBrowserEvent["oGetSource"]();
	var oPreviousDomRef = UCF_DomUtil["oGetPreviousSibling"](oSource, true),
		oPreviousTabbableDomRef;

	while (oPreviousDomRef) {
		oPreviousTabbableDomRef = UCF_DomUtil["oGetTabbableElementBackward"](oPreviousDomRef, true);
		if (oPreviousTabbableDomRef)
			break;
		oPreviousDomRef = UCF_DomUtil["oGetNextSibling"](oPreviousDomRef, true);
	}

	// container with LeftItems -> this.oViewPort
	// container with RightItems -> 	this.oRightItemContainer
	if (oPreviousTabbableDomRef
		&& ((this["oViewPort"] != null && UCF_DomUtil["bContains"](this["oViewPort"], oPreviousTabbableDomRef))
			|| (this["oRightItemContainer"] !== null && UCF_DomUtil["bContains"](this["oRightItemContainer"], oPreviousTabbableDomRef))
			|| (this["oHiddenOpener"] != null && oPreviousTabbableDomRef === this["oHiddenOpener"]))) {
		// this item is inside of the toolbar, left or right item
		UCF_DomUtil["moveFocusDomElement"](oPreviousTabbableDomRef, true);
		if (window["UCF_System"]["bIsAria"]) {
			this["oDomRef"]["ariaActivedescendant"] = oPreviousTabbableDomRef["id"];
			UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], oPreviousTabbableDomRef["id"]);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	} else {
		this["focusFirstItem"](oBrowserEvent);
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["focusPreviousItem"] = 0; };

/**
 * Focus the first item of the toolbar
 * if the current items is the first one, it'll focus the last focusable item of the toolbar
 * @param { UCF_BrowserEvent } oBrowserEvent the lsaccessibility
 * @private
 */
UCF_Toolbar_standards["prototype"]["focusLastItem"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["focusLastItem"]++; }; 
	var oLastFocusedDomRef;
	var bFoundItem = false;

	// moves the focus on the last right item
	if (this["oRightItemContainer"] != null) {
		oLastFocusedDomRef = UCF_DomUtil["oGetLastFocusableDomRef"](this["oRightItemContainer"], false);
		bFoundItem = (oLastFocusedDomRef && oLastFocusedDomRef != null);
	}
	// moves the focus on the ToolbarOverflow
	if (!bFoundItem && this["oHiddenOpener"] != null && UCF_DomUtil["bIsVisible"](this["oHiddenOpener"])) {
		if (this["oDomOvflPusher"] && UCF_DomUtil["bContains"](this["oDomOvflPusher"], this["oHiddenOpener"])) {
			oLastFocusedDomRef = UCF_DomUtil["bIsVisible"](this["oDomOvflPusher"]) ? this["oHiddenOpener"] : null;
		} else
			oLastFocusedDomRef = this["oHiddenOpener"];

		bFoundItem = (oLastFocusedDomRef && oLastFocusedDomRef != null);
	}

	if (!bFoundItem && this["oViewPort"] != null) {
		// moves the focus on last left items, if no right items exists
		oLastFocusedDomRef = UCF_DomUtil["oGetLastFocusableDomRef"](this["oViewPort"], false);
	}

	if (oLastFocusedDomRef) {
		UCF_DomUtil["moveFocusDomElement"](oLastFocusedDomRef, true);
		if (window["UCF_System"]["bIsAria"]) {
			this["oDomRef"]["ariaActivedescendant"] = oLastFocusedDomRef["id"];
			UCF_AriaStateHelper["setActivedescendant"](this["oDomRef"], oLastFocusedDomRef["id"]);
		}
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["focusLastItem"] = 0; };

/**
 * react onLayouChange event
 * @private
 */
UCF_Toolbar_standards["prototype"]["onLayoutChange"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onLayoutChange"]++; }; 
	if (this["oDomRef"] && this["oDomRef"]["offsetWidth"] !== this["iToolbarWidth"] && this["aItems"]) {
		this["onAfterResize"]();
		this["iToolbarWidth"] = this["oDomRef"]["offsetWidth"];
	} else {
		this["updateScrollTop"]();
		this["checkToolbarOverflowHeight"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onLayoutChange"] = 0; };

/**
 * react on content change
 * @private
 */
UCF_Toolbar_standards["prototype"]["onCustomStylesApplied"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onCustomStylesApplied"]++; }; 
	this["updateScrollTop"]();
	this["checkToolbarOverflowHeight"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onCustomStylesApplied"] = 0; };

/**
 * react onCustomStylesApplied event
 * @private
 */
UCF_Toolbar_standards["prototype"]["onContentChange"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onContentChange"]++; }; 
	this["onAfterResize"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onContentChange"] = 0; };

/**
 * Update the scrollTop position
 * appliyng border-width on Toolbar triiger offsetTop changes
 * @private
 */
UCF_Toolbar_standards["prototype"]["updateScrollTop"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["updateScrollTop"]++; }; 
	if (!this["oViewPort"]) return;
	this["iItmsScrollTop"] = this["oViewPort"]["offsetTop"];
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["updateScrollTop"] = 0; };

/**
 * @private
 * @see UCF_DTExtension
 * @param {UCF_BrowserEvent} oDTElement the lsaccessibility
 * @return {Object} - the DTE extension
 */
UCF_Toolbar_standards["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oGetDTExtension"]++; }; 
	return UCF_Toolbar.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]("UCF_ToolbarDTExtension"));
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["oGetDTExtension"] = 0; };

/**
 * Returns the current control height in pixel
 * @return {int} - returns the height value in px
 * @public
 */
UCF_Toolbar_standards["prototype"]["getHeightPx"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["getHeightPx"]++; }; 
	return this["iGetHeightPx"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["getHeightPx"] = 0; };

/**
 * Returns the current control width in pixel
 * @return {int} - returns the width value in px
 * @public
 */
UCF_Toolbar_standards["prototype"]["getWidthPx"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["getWidthPx"]++; }; 
	return this["iGetWidthPx"]();
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["getWidthPx"] = 0; };

/**
 * Set the down state of the opener
 * Used by the {ToolbarOverflowMenuDecorator} to set/reset the down state
 * @param {boolean} bDown  when the menu is closed
 * @private
 */
UCF_Toolbar_standards["prototype"]["toggleOverflowPress"] = function(bDown) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["toggleOverflowPress"]++; }; 
	if (this["oPopupOpenerRef"]) {
		if (bDown)
			UCF_DomUtil["addClass"](this["oPopupOpenerRef"], 'lsToolbar--overflowMenu-opened');
		else
			UCF_DomUtil["removeClass"](this["oPopupOpenerRef"], 'lsToolbar--overflowMenu-opened');
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["toggleOverflowPress"] = 0; };

/**
 * Gets the down state of the opener
 * Used by the {ToolbarOverflowViewDecorator} get the down state
 * @return {boolean}
 * @private
 */
UCF_Toolbar_standards["prototype"]["bOverflowIsPressed"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bOverflowIsPressed"]++; }; 
	if (this["oPopupOpenerRef"]) {
		UCF_DomUtil["bHasClass"](this["oPopupOpenerRef"], 'lsToolbar--overflowMenu-opened');
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["bOverflowIsPressed"] = 0; };

//========================= ToolbarOverflow - PopupMenu Section ===================

/**
 * #ToDo - clear it
 * Opens or close the PopupMenu
 * @param {boolean} bWithKeyboard - if the menu should be opened with the keyboard
 */
UCF_Toolbar_standards["prototype"]["openPopupMenu"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["openPopupMenu"]++; }; 
	if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"]();
		this["toggleOverflowPress"](false);
	} else {
		this["handlePopupMenuOpen"](bWithKeyboard);
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["openPopupMenu"] = 0; };

/**
 * Update the qUnit/popupWindow/EnhancedSize.qunit.js
 * #ToDo - clear it
 * Update items, render menu and open it.
 * @param {boolean} bWithKeyboard - if the PopupMenu will be opne with keyboard
 */
UCF_Toolbar_standards["prototype"]["handlePopupMenuOpen"] = function(bWithKeyboard) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["handlePopupMenuOpen"]++; }; 
	var oMenuHelper = new (UCF_ClassLoader["oGetClass"]("UCF_ClientPopupMenuHelper"))(this["oLS"]);
	this["oPopupMenu"] = oMenuHelper["oRenderMenu"](
		this["sId"] + this["sPopupMenuId"],
		null,
		//this.oLS.oGetAssociatedAreaRef(),
		this["createPopupMenuItems"]()
	);

	this["oPopupMenu"]["setOpenerRef"](this["oGetPopupOpener"]());
	this["oPopupMenu"]["setOpenerId"](this["sGetPopupOpenerId"]());
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'oPopupOpenerRef.id - ' + this["oPopupOpenerRef"]["id"] + '; sPopupOpener - ' + this["sPopupOpener"], "Toolbar_standards.js(2712): handlePopupMenuOpen"); };
	this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
	this["oPopupMenu"]["bAutoRefocus"] = false;

	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, "onMenuItemSelect");
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["MenuAccess"], this, "onSubMenuAccess");

	this["oPopupMenu"]["bContentChanged"] = false; // do not call the delayed call, otherwise items are not present when trying to access them first
	this["oPopupMenu"]["open"](bWithKeyboard);
	this["toggleOverflowPress"](true);
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["handlePopupMenuOpen"] = 0; };

/**
 * #ToDo - clear it
 * Detach from events and focus the hidden reference element that serves
 * as openers for the menu.
 * @param {UCF_BrowserEvent} oEvent  when the menu is closed
 * @private
 */
UCF_Toolbar_standards["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onMenuClose"]++; }; 
	if (!this["bItemOverflow"] || !this["aItems"]) return;

	for (var i = 0; i < this["aItems"]["length"]; i++) {
		var oItem = this["aItems"][i];
		if (oItem && oItem["E_EVENTS"] && oItem["E_EVENTS"]["OpenMenu"])
			oItem["detachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
	}
	this["toggleOverflowPress"](false);
	//TODO: destroy items?
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Select"], this, "onMenuItemSelect");
	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["MenuAccess"], this, "onSubMenuAccess");

	if (!this["bTabbedOutOfMenu"]) {
		this["setFocusOnOpener"]();
	}
	this["bTabbedOutOfMenu"] = false;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onMenuClose"] = 0; };

/**
 * #ToDo - clear it
 * Creates new PopupMenuItems in the overflow menu with the properties of all hidden buttons.
 * @return {Object} - an array with JSONs with PopupMenuItem
 * @private
 */
UCF_Toolbar_standards["prototype"]["createPopupMenuItems"] = function() {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["createPopupMenuItems"]++; }; 
	var aNewItems = [];
	var oItem, oDomRef, bIsHidden, bHasSeparator;
	var sGroupId = null,
		sCurrentGroupId = null;
	var bFirstHiddenItem = true;
	var bIsSeparator = false;
	var bIsQuirksSeparator = false;
	var aItemOverflowItems = [];
	var bIsSeqgmentedButtonSeparator = false;
	var bHasHiddenItems = false;
	if (this["bPriorityChanged"]) {
		aItemOverflowItems = []["concat"](this["aItems"]);
		aItemOverflowItems["sort"](function(a, b) {
			return a["iIndex"] - b["iIndex"];
		});
	} else {
		aItemOverflowItems = this["aItems"];
	}

	for (var i = 0; i < aItemOverflowItems["length"]; i++) {
		oItem = aItemOverflowItems[i];
		oDomRef = oItem["oTbarRef"];
		bIsHidden = this["bMoreButtonVisible"] ? (oItem["iPriorityIndex"] >= this["iFirstInvisibleItem"]) : (this["bItemIsHidden"](oDomRef) || !UCF_DomUtil["bIsVisible"](oDomRef));

		if (oItem["setDelegateOpenMenu"]) {
			oItem["setDelegateOpenMenu"](bIsHidden);
		}
		if (!bIsHidden) continue;
		//searches for the previous visible tag and check if it is a separator
		//oDomRef = oItem.oTbarRef && oItem.oTbarRef.previousSibling;

		//_trace(INFO, "===== add to the ToolbarOverflow - " + oItem.sId);
		/*	while (oDomRef != null && (oDomRef.nodeType !== 1 || !UCF_DomUtil.bIsVisible(oDomRef))) {
				oDomRef = oDomRef.previousSibling;
			}*/
		if (!this["bIsShown"](oItem["oTbarRef"])) continue;

		bHasSeparator = false || bIsQuirksSeparator || bIsSeqgmentedButtonSeparator;
		bIsSeqgmentedButtonSeparator = false;
		bHasHiddenItems = true;
		bIsSeparator = !UCF_JsUtil["bInstanceOf"](oItem, 'UCF_SegmentedButton') && oDomRef && oDomRef["nodeType"] === 1 && oDomRef["getAttribute"]('data-separator') === 'true';
		if (bIsSeparator) continue;

		sCurrentGroupId = oDomRef && oDomRef["hasAttribute"] && oDomRef["hasAttribute"]('data-separator-group') ? oDomRef["getAttribute"]('data-separator-group') : null;
		if (bFirstHiddenItem) {
			sGroupId = sCurrentGroupId;
			bFirstHiddenItem = false;
		}

		if (sGroupId && sCurrentGroupId && sCurrentGroupId !== sGroupId) {
			bHasSeparator = true;
			sGroupId = sCurrentGroupId;
		}

		if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Button")) {
			oItem["setDelegateOpenMenu"](bIsHidden);
			oItem["attachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
			aNewItems["push"](this["addButtonToMenu"](oItem, bHasSeparator));
		} else if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Link")) {
			aNewItems["push"](this["addLinkToMenu"](oItem, bHasSeparator));
		} else if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_LinkChoice")) {
			oItem["setDelegateOpenMenu"](bIsHidden);
			oItem["attachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
			aNewItems["push"](this["addLinkChoiceToMenu"](oItem, bHasSeparator));
		} else if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_SegmentedButton")) {
			//	oItem.setDelegateOpenMenu(bIsHidden);
			var oButtonsItems = UCF_JsUtil["values"](oItem["oGetButtons"]());
			bIsSeqgmentedButtonSeparator = true;
			for (var j = 0; j < oButtonsItems["length"]; j++) {
				var oButton = oButtonsItems[j];
				oButton["attachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
				oButton["setDelegateOpenMenu"](bIsHidden);
				aNewItems["push"](this["addButtonToMenu"](oButton, (j === 0)));
			}
		}
		//check if the separator for the next item
		//this will be rendered on the top of the next item
		//oDomRef = oItem.oTbarRef;
		//bHasSeparator = oDomRef && oDomRef.nodeType === 1 && oDomRef.getAttribute('data-separator') === 'true';
	}
	bHasSeparator = false;
	if (this["bHasOveflowItems"]) {
		for (i = 0; i < this["ovflItems"]["length"]; i++) {
			oItem = this["ovflItems"][i];
			bHasSeparator = bHasSeparator || (i === 0 && bHasHiddenItems);
			if (oItem["setDelegateOpenMenu"]) {
				oItem["setDelegateOpenMenu"](bIsHidden);
			}
			if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Button")) {
				oItem["setDelegateOpenMenu"](bIsHidden);
				oItem["attachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
				aNewItems["push"](this["addButtonToMenu"](oItem, bHasSeparator));
			} else if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_Link")) {
				aNewItems["push"](this["addLinkToMenu"](oItem, bHasSeparator));
			} else if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_LinkChoice")) {
				oItem["setDelegateOpenMenu"](bIsHidden);
				oItem["attachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
				aNewItems["push"](this["addLinkChoiceToMenu"](oItem, bHasSeparator));
			} else if (UCF_JsUtil["bInstanceOf"](oItem, "UCF_SegmentedButton")) {
				//	oItem.setDelegateOpenMenu(bIsHidden);
				oButtonsItems = UCF_JsUtil["values"](oItem["oGetButtons"]());
				for (var k = 0; k < oButtonsItems["length"]; k++) {
					oButton = oButtonsItems[k];
					oButton["attachEvent"](oItem["E_EVENTS"]["OpenMenu"], this, "onToolbarItemMenuOpen");
					oButton["setDelegateOpenMenu"](bIsHidden);
					aNewItems["push"](this["addButtonToMenu"](oButton, (k === 0)));
				}
			}
			//check if the separator for the next item
			//this will be rendered on the top of the next item
			oDomRef = oItem["oTbarRef"];
			bHasSeparator = oDomRef && oDomRef["nodeType"] === 1 && oDomRef["getAttribute"]('data-separator') === 'true';

		}
	}
	return aNewItems;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["createPopupMenuItems"] = 0; };

/**
 * #ToDo - clear it
 * Create a PopupMenuItem with the values of a Button control
 * @param {Object} oButton - the Button object
 * @param {boolean} bHasSeparator - true if it should be render a separator after the PopupMenuItems
 * @return {PopupMenuItem} - the JSON for clientside PopupMenuItem
 * @private
 */
UCF_Toolbar_standards["prototype"]["addButtonToMenu"] = function(oButton, bHasSeparator) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["addButtonToMenu"]++; }; 

	var bIconButton = oButton["bHasCssIcon"](),
		sIconSrc = bIconButton ? oButton["sIconButtonClass"]() : oButton["sGetIconSource"](),
		sSuffix = this["sGetToolbarItemType"](oButton) === this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"] ?
		"-" + this["MENU_ITEM_TYPE"]["BUTTONCHOICE"] : "-" + this["MENU_ITEM_TYPE"]["BUTTON"],
		sText = oButton["sGetText"]();

	return {
		"PopupMenuItem": {
			"Id": oButton["sId"] + sSuffix,
			"Text": sText,
			"CanCheck": oButton["sInteractionBehaviour"] === "TOGGLE" || oButton["sDesign"] === "TOGGLE",
			"Checked": oButton["bDown"],
			"Enabled": oButton["bEnabled"],
			"SubMenuId": oButton["sPopupMenuId"],
			"HasSubMenu": oButton["bHasPopupMenu"],
			"HasElipsis": oButton["bTextOverflow"],
			"HasIcon": !UCF_StringUtil["bIsEmpty"](sIconSrc) || (!UCF_StringUtil["bIsEmpty"](oButton["sDisabledIconSrc"]) && !oButton["bEnabled"]),
			"EnabledIconSrc": sIconSrc,
			"DisabledIconSrc": !UCF_StringUtil["bIsEmpty"](oButton["sDisabledIconSrc"]) ? oButton["sDisabledIconSrc"] : sIconSrc,
			"HasSubMenuSection": oButton["bHasPopupMenuSection"],
			"Hotkey": oButton["sHotkey"],
			"Tooltip": ((sText && UCF_StringUtil["bIsEmpty"](sText)) ? oButton["sTooltip"] : ""),
			"HasSeparator": bHasSeparator
		}
	};
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["addButtonToMenu"] = 0; };

/**
 * #ToDo - clear it
 * Create a PopupMenuItem with the values of a Link control
 * @param {Object} oLink - the Link control
 * @param {boolean} bHasSeparator - true if it should be render a separator after the PopupMenuItems
 * @return {PopupMenuItem} - the JSON for clientside PopupMenuItem
 * @private
 */
UCF_Toolbar_standards["prototype"]["addLinkToMenu"] = function(oLink, bHasSeparator) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["addLinkToMenu"]++; }; 

	var sIconSrc = oLink["sGetIconSource"](),
		bHasIcon = !UCF_StringUtil["bIsEmpty"](sIconSrc);

	return {
		"PopupMenuItem": {
			"Id": oLink["sId"] + "-LinkMenu",
			"Text": oLink["sText"], //oLink.sGetTitle(), - in ARAI mode the getTitle retrive a double text
			"HasSeparator": bHasSeparator,
			"Enabled": oLink["bEnabled"],
			"HasIcon": bHasIcon,
			"EnabledIconSrc": sIconSrc,
			"DisabledIconSrc": sIconSrc,
			"Hotkey": oLink["sHotkey"],
			"Tooltip": oLink["sTooltip"]
		}
	};
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["addLinkToMenu"] = 0; };

/**
 * #ToDo - clear it
 * Create a PopupMenuItem with the values of a LinkChoice control
 * @param {Object} oLink - the LinkChoice object
 * @param {boolean} bHasSeparator - true if it should be render a separator after the PopupMenuItems
 * @return {PopupMenuItem} - the JSON for clientside PopupMenuItem
 * @private
 */
UCF_Toolbar_standards["prototype"]["addLinkChoiceToMenu"] = function(oLink, bHasSeparator) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["addLinkChoiceToMenu"]++; }; 

	var sIconSrc = oLink["sGetIconSource"](),
		bHasIcon = !UCF_StringUtil["bIsEmpty"](sIconSrc);

	return {
		"PopupMenuItem": {
			"Id": oLink["sId"] + "-LinkChoiceMenu",
			"Text": oLink["sText"], //oLink.sGetTitle(), - in ARAI mode the getTitle retrive a double text
			"HasSeparator": bHasSeparator,
			"Enabled": oLink["bEnabled"],
			"SubMenuId": oLink["sPopupMenuId"],
			"HasSubMenu": true,
			"HasIcon": bHasIcon,
			"EnabledIconSrc": sIconSrc,
			"DisabledIconSrc": sIconSrc,
			"Tooltip": oLink["sTooltip"]
		}
	};
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["addLinkChoiceToMenu"] = 0; };
/**
 * #ToDo - clear it
 * enumerates the possible types of menu items.
 * @private
 */
UCF_Toolbar_standards["prototype"]["TOOLBAR_ITEM_TYPE"] = {
	"BUTTON": 0,
	"BUTTONCHOICE": 1,
	"LINK": 2,
	"LINKCHOICE": 3
};

/**
 * #ToDo - clear it
 * @private
 */
UCF_Toolbar_standards["prototype"]["MENU_ITEM_TYPE"] = {
	"BUTTON": "BtnMenu",
	"BUTTONCHOICE": "BtnChoiceMenu",
	"LINK": "LinkMenu",
	"LINKCHOICE": "LinkChoiceMenu"
};

/**
 * #ToDo - clear it
 * Determines whether out of which toolbar control the menu item was created.
 * @param {string} sId  - the id of the control
 * @return {string} the toolbar item type
 */
UCF_Toolbar_standards["prototype"]["sGetMenuItemType"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["sGetMenuItemType"]++; }; 

	if (sId === null) return null;

	var aType = sId["split"]("-"),
		sType = aType[aType["length"] - 1];

	switch (sType) {
		case this["MENU_ITEM_TYPE"]["BUTTON"]:
			return this["TOOLBAR_ITEM_TYPE"]["BUTTON"];

		case this["MENU_ITEM_TYPE"]["BUTTONCHOICE"]:
			return this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"];

		case this["MENU_ITEM_TYPE"]["LINK"]:
			return this["TOOLBAR_ITEM_TYPE"]["LINK"];

		case this["MENU_ITEM_TYPE"]["LINKCHOICE"]:
			return this["TOOLBAR_ITEM_TYPE"]["LINKCHOICE"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["sGetMenuItemType"] = 0; };

/**
 * #ToDo - clear it
 * Determines the toolbar item control type
 * @param {UCF_Control} oItem  - the control
 * @return {string} the toolbar item type
 * @private
 */
UCF_Toolbar_standards["prototype"]["sGetToolbarItemType"] = function(oItem) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["sGetToolbarItemType"]++; }; 
	var sClassName = oItem["sClassName"];

	switch (sClassName) {
		case "UCF_Button":
			return (!oItem["bHasPopupMenu"]) ? this["TOOLBAR_ITEM_TYPE"]["BUTTON"] : this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"];

		case "UCF_Link":
			return this["TOOLBAR_ITEM_TYPE"]["LINK"];

		case "UCF_LinkChoice":
			return this["TOOLBAR_ITEM_TYPE"]["LINKCHOICE"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["sGetToolbarItemType"] = 0; };

/**
 * #ToDo - clear it
 * When an item is selected, fire the according event on the
 * corresponding toolbar item that is hidden
 * @param {UCF_BrowserEvent} oEvent the event object that occurred
 * @private
 */
UCF_Toolbar_standards["prototype"]["onMenuItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onMenuItemSelect"]++; }; 
	var sMenuItemId = oEvent["oGetParam"]("sItemId"),
		sId = sMenuItemId["split"]("-")[0],
		oToolbarItem = this["oLS"]["oControlFactory"]["oGetControlById"](sId);

	if (this["sGetMenuItemType"](sMenuItemId) === this["TOOLBAR_ITEM_TYPE"]["BUTTON"]) {
		oToolbarItem["fireEvent"](oToolbarItem["E_EVENTS"]["Press"], { "sId": oToolbarItem["sId"] });
		oToolbarItem["firePress"](oToolbarItem["sId"]);
	} else if (this["sGetMenuItemType"](sMenuItemId) === this["TOOLBAR_ITEM_TYPE"]["LINK"]) {
		oToolbarItem["fireActivate"](oToolbarItem["sId"]);
	} else if (this["sGetMenuItemType"](sMenuItemId) === this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"]) {
		var oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent"),
			oSource = oBrowserEvent["oGetSource"](),
			oMenuItem = UCF_DomUtil["$"](sMenuItemId),
			oMenuSection = UCF_DomUtil["lastChild"](oMenuItem, "TD");

		if (oSource !== oMenuSection) {
			oToolbarItem["firePress"](oToolbarItem["sId"]);
		}

	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onMenuItemSelect"] = 0; };

/**
 * #ToDo - clear it
 * If menu of toolbar item is loaded from server, the menu item fires a MenuAccess event.
 * The toolbar handles it in this function. It finds the toolbar item represented by the menu item
 * and programmatically triggers the MenuAcces event there, again.
 * @param {UCF_BrowserEvent} oEvent the event object that occurred
 * @private
 */
UCF_Toolbar_standards["prototype"]["onSubMenuAccess"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onSubMenuAccess"]++; }; 

	var sItemId = oEvent["oGetParam"]("sMenuId")["split"]("-")[0],
		bEnabled = oEvent["oGetParam"]("bEnabled"),
		oTbarItem = this["oGetControlById"](sItemId);

	if (bEnabled) {
		oTbarItem["fireMenuAccess"](oTbarItem["sId"], oTbarItem["sPopupMenuId"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onSubMenuAccess"] = 0; };

/**
 * #ToDo - clear it
 * All toolbar items that have their own menu can fire a OpenMenu event. If the menu is rendered on the server
 * the toobar item must not open the menu, when it is currently not visible. Instead it fires an OpenMenu event.
 * The Toolbar listens to the event and handles it in this function.
 * @param {UCF_BrowserEvent} oEvent the event object that occurred
 * @private
 */
UCF_Toolbar_standards["prototype"]["onToolbarItemMenuOpen"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onToolbarItemMenuOpen"]++; }; 
	var sSumMenuId = oEvent["oGetParam"]("sMenuId"),
		sToolbarItemId = oEvent["oGetParam"]("sId"),
		oToolbarItem = this["oGetControlById"](sToolbarItemId),
		sToolbarItemType = this["sGetToolbarItemType"](oToolbarItem),
		sEndFix = "-";

	switch (sToolbarItemType) {
		case this["TOOLBAR_ITEM_TYPE"]["BUTTON"]:
			sEndFix += this["MENU_ITEM_TYPE"]["BUTTON"];
			break;

		case this["TOOLBAR_ITEM_TYPE"]["BUTTONCHOICE"]:
			sEndFix += this["MENU_ITEM_TYPE"]["BUTTONCHOICE"];
			break;

		case this["TOOLBAR_ITEM_TYPE"]["LINKCHOICE"]:
			sEndFix += this["MENU_ITEM_TYPE"]["LINKCHOICE"];
			break;

		case this["TOOLBAR_ITEM_TYPE"]["LINK"]:
			sEndFix += this["MENU_ITEM_TYPE"]["LINK"];
	}

	var sMenuItemId = sToolbarItemId + sEndFix,
		oMenuItem = this["oLS"]["oControlFactory"]["oGetControlById"](sMenuItemId);
	if (oMenuItem) {
		oMenuItem["setSubMenuId"](sSumMenuId);
		oMenuItem["openSubMenu"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Toolbar_standards["_"]["onToolbarItemMenuOpen"] = 0; };

UCF_Toolbar_standards.prototype["aPublicMethods"] = ["getHeightPx","getWidthPx"].concat(UCF_Toolbar_standards.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TrackSwitch"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TrackSwitch(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TrackSwitch["_"]["UCF_TrackSwitch"]++; }; 
	if (arguments["length"] == 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TrackSwitch.js(25): UCF_TrackSwitch"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

};window["UCF_TrackSwitch"] = UCF_TrackSwitch; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TrackSwitch"); UCF_TrackSwitch["_"] = {UCF_TrackSwitch: 0}; }; ;
UCF_TrackSwitch["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TrackSwitch.prototype["sClassName"] = "UCF_TrackSwitch";

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_TrackSwitch["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TrackSwitch["_"]["onlstabnext"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TrackSwitch.js(38): onlstabnext"); };
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	return false;
};;if (__UCF_COVERAGE__) { UCF_TrackSwitch["_"]["onlstabnext"] = 0; };

/**
 * @see UCF_Control
 * @override
 * @private
 */
UCF_TrackSwitch["prototype"]["onlstabprevious"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TrackSwitch["_"]["onlstabprevious"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TrackSwitch.js(50): onlstabprevious"); };
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
	return false;
};;if (__UCF_COVERAGE__) { UCF_TrackSwitch["_"]["onlstabprevious"] = 0; };

/**
 * Handles the onlsfocus event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TrackSwitch["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TrackSwitch["_"]["onlsfocus"]++; }; 

	var oSource = oBrowserEvent["oGetSource"](),
		sConnectId = oSource["getAttribute"]("connectId"),
		oConnectedTrackSwitch = sConnectId ? this["oLS"]["oControlFactory"]["oGetControlById"](sConnectId) : null,
		oFocusTo = null;

	if (!oConnectedTrackSwitch) oConnectedTrackSwitch = this;

	if (oSource == this["oDomRef"]) { //Forward
		var oNext = UCF_DomUtil["oGetNextSibling"](oConnectedTrackSwitch["oDomRef"], true);
		if (oNext) oFocusTo = UCF_DomUtil["oGetTabbableElementForward"](oNext, true);
	} else { //Backward
		var oPrevious = UCF_DomUtil["oGetPreviousSibling"](oConnectedTrackSwitch["oDomRef"], true);
		if (oPrevious) oFocusTo = UCF_DomUtil["oGetTabbableElementBackward"](oPrevious, true);
	}

	if (oFocusTo) {
		if (window["UCF_System"]["bIs508"])
			UCF_DomUtil["moveFocusDomElement"](oFocusTo);
		else
			UCF_DomUtil["focusDomElement"](oFocusTo);
			// CSN 155063/2023: browser will select the text in an input by default
			// when tabbing into the field. When the focus is forwarded through a
			// TrackSwitch there is no selection by default. We need to add it here.
			if (UCF_DomUtil["bIsCTInstanceOf"](oFocusTo, 'CBS') ||
				UCF_DomUtil["bIsCTInstanceOf"](oFocusTo, 'CB') ||
				UCF_DomUtil["bIsCTInstanceOf"](oFocusTo, 'I')) {
				oFocusTo["select"]();
			}
	} else {
		this["oLS"]["focusEnd"]();
	}

};;if (__UCF_COVERAGE__) { UCF_TrackSwitch["_"]["onlsfocus"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TrackSwitch["prototype"]["aAttributeNames"] = [];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TrackSwitch["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TrackSwitch["prototype"]["aMethodNames"] = [];


//#JSCOVER_EXCL_START
/** @protected */
UCF_TrackSwitch["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TrackSwitch["_"]["setDefaultValues"]++; }; 
	

	if (this["getClientControl"]() && !this["bKeepAlive"]) ;
};;if (__UCF_COVERAGE__) { UCF_TrackSwitch["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_Tray"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_Hotkeys */
/// <reference path="./Hotkeys.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Tray(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Tray["_"]["UCF_Tray"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Tray.js(36): UCF_Tray"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Tray.js(37): UCF_Tray"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Tray.js(38): UCF_Tray"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oOptionMenu"] = null;

	this["oScrollArea"] = (this["sScrollingMode"] !== 'NONE' && this["sContentHeight"] && this["sContentHeight"]["indexOf"]('%') < 0) //scroll area only exists when a height is provided and not % (due to compatibility reasons)
		? UCF_ClassLoader["oGetClass"]('UCF_ScrollArea')["oCreateAndConnectScrollArea"](this, this["sScrollingMode"], 'onScroll')
		: null;

	//initialize the default button for this control
	this["setDefaultButtonId"](this["sDefaultButtonId"]);

	/** @type {HTMLElement} */
	this["oHeaderText"] = UCF_DomUtil["$"](this["sId"] + '-hdtxt');
	/** @type {HTMLElement} */
	this["oHeader"] = UCF_DomUtil["$"](this["sId"] + '-hd');

	/** @type {HTMLElement} */
	this["oCloseButton"] = UCF_DomUtil["$"](this["sId"] + '-close');
	/** @type {HTMLElement} */
	this["oExpandButton"] = UCF_DomUtil["$"](this["sId"] + '-exp');

	/** @type {HTMLElement} */
	this["oMenuButton"] = UCF_DomUtil["$"](this["sId"] + '-menu');

	/** @type {HTMLElement} */
	this["oToggleButton"] = UCF_DomUtil["$"](this["sId"] + '-toggle');
	this["oTitleArea"] = UCF_DomUtil["$"](this["sId"] + '-title') || this["oHeaderText"];
	this["bHasToggleButton"] = this["oToggleButton"] && UCF_DomUtil["sGetCurrentStyle"](this["oToggleButton"], 'display') !== 'none';
	this["oFocusDomRef"] = this["bHasToggleButton"] ? this["oTitleArea"] : this["oHeader"];

	/** @type {HTMLElement} */
	this["oContent"] = UCF_DomUtil["$"](this["sId"] + '-tbd');

	this["initializeHandle"](this["oHeaderText"]);
};window["UCF_Tray"] = UCF_Tray; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Tray"); UCF_Tray["_"] = {UCF_Tray: 0}; }; ;
UCF_Tray["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Tray.prototype["sClassName"] = "UCF_Tray";

/**
 * Intialize in case scroll positions have to be applied
 */
UCF_Tray["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["initialize"]++; }; 
	if (this["oScrollArea"]) {
		this["oScrollArea"]["setScrollPosition"](this["iScrollTop"], this["iScrollLeft"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["initialize"] = 0; };

/**
 * Destructor
 */
UCF_Tray["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["destroy"]++; }; 
	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
	}

	this["oOptionMenu"] = null;
	this["bCollapsed"] = null;
	this["oHeaderText"] = null;
	this["oCloseButton"] = null;
	this["oExpandButton"] = null;
	this["oMenuButton"] = null;
	this["oToggleButton"] = null;
	this["oContent"] = null;
	this["oHeader"] = null;
	this["oTitleArea"] = null;
	this["bHasToggleButton"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["destroy"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tray.js(117): onclick"); };
	this["handleClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onclick"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["ondblclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tray.js(129): ondblclick"); };
	/** @type {HTMLElement} */
	var oSource;

	if (!this["bEnabled"]) return;

	oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oExpandButton"] ||
		oSource === this["oTitleArea"]) {
		this["bIgnoreDefaultButton"] = true;
		this["toggle"](oSource);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();

	}
	return;
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["ondblclick"] = 0; };

/**
 * opens/closes the tray
 * @param { HTMLElement } oSouceDomRef - for refocus the element which trigger
 *  the expand / collapse action
 *
 */
UCF_Tray["prototype"]["toggle"] = function(oSouceDomRef) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["toggle"]++; }; 

	if (!this["bIsCollapsible"]) return;

	if (!this["oContent"]) return;

	if (this["bClientSelect"]) {
		if (this["bCollapsed"]) {
			//TODO: Animation
			//		this.oExpander.expand(this.sContentHeight);
			//oDomBodyRef.style.display = '';
			UCF_DomUtil["removeClass"](this["oContent"], 'lsTray--body-collapsed');
			if (!this["sContentHeight"] && this["sHeight"]) {
				this["oRootRef"]["style"]["height"] = this["sHeight"];
			} else {
				this["oRootRef"]["style"]["height"] = '';
			}
			if (__UCF_IE6__) {
				this["oExpandButton"]["className"] = this["oExpandButton"]["className"]["replace"]('Closed', 'Open');
				this["oExpandButton"]["className"] = this["oExpandButton"]["className"]["replace"]('Expand', 'Collapse');
			} else {
				UCF_DomUtil["replaceClass"](this["oExpandButton"], 'lsTray--button-collapsed', 'lsTray--button-expanded');
			}
			//TODO fix 508 in renderer and here
			this["oExpandButton"]["title"] = this["oLS"]["sGetText"]('SAPUR_P_COLLAPSE');
			if (this["oToggleButton"]) {
				UCF_DomUtil["removeClass"](this["oToggleButton"], 'lsTray--toggle-collapsed');
				UCF_DomUtil["addClass"](this["oToggleButton"], 'lsTray--toggle-expanded');

			}
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTray--collapsed');
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsTray--expanded');
		} else {
			//TODO: Animation
			//		this.oExpander.collapse();
			UCF_DomUtil["addClass"](this["oContent"], 'lsTray--body-collapsed');
			//oDomBodyRef.style.display = 'none';
			this["oRootRef"]["style"]["height"] = '0';
			if (__UCF_IE6__) {
				this["oExpandButton"]["className"] = this["oExpandButton"]["className"]["replace"]('Open', 'Closed');
				this["oExpandButton"]["className"] = this["oExpandButton"]["className"]["replace"]('Collapse', 'Expand');
			} else {
				UCF_DomUtil["replaceClass"](this["oExpandButton"], 'lsTray--button-expanded', 'lsTray--button-collapsed');
			}
			this["oExpandButton"]["title"] = this["oLS"]["sGetText"]('SAPUR_P_EXPAND');

			if (this["oToggleButton"]) {
				UCF_DomUtil["addClass"](this["oToggleButton"], 'lsTray--toggle-collapsed');
				UCF_DomUtil["removeClass"](this["oToggleButton"], 'lsTray--toggle-expanded');

			}
			UCF_DomUtil["addClass"](this["oDomRef"], 'lsTray--collapsed');
			UCF_DomUtil["removeClass"](this["oDomRef"], 'lsTray--expanded');
		}
	}

	// set the new status on js object
	this["bCollapsed"] = !this["bCollapsed"];
	this["setClientProperty"]('Collapsed', this["bCollapsed"], true);

	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setExpanded"](this["bHasToggleButton"] ? this["oTitleArea"] : this["oHeaderText"], !this["bCollapsed"]);
	}

	if (!this["bCollapsed"]) {
		// fire the semantic event if the tray was expanded
		this["fireExpand"](this["sId"]);
	}
	if (this["bCollapsed"]) {
		// fire the semantic event if the tray was expanded
		this["fireCollapse"](this["sId"]);
	}
	// refocus the element in order to trigger accessibility event
	this["refocus"](oSouceDomRef);
	// Notify framework, that layout has changed after toggling the Tray
	this["notifyLayoutChange"]();

};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["toggle"] = 0; };

/**
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Tray["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsfocus"]++; }; 
	/** @type {HTMLElement} */
	var oSource;

	oSource = oBrowserEvent["oGetSource"]();

	if (!this["bEnabled"]) return;

	if (this["bHasToggleButton"])
		UCF_DomUtil["resetTabIndex"](this["oHeaderText"]);

	// Ignore the DefaultButton when the focus is on the
	// following elements, so ENTER should not fire Press on DefaultButton
	if (oSource === this["oCloseButton"]
		|| oSource === this["oExpandButton"]
		|| oSource === this["oMenuButton"]
		|| oSource === this["oToggleButton"]
		|| (oSource === this["oHeaderText"] && this["bIsCollapsible"])) {
		this["bIgnoreDefaultButton"] = true;
	} else {
		this["bIgnoreDefaultButton"] = false;
	}

};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsfocus"] = 0; };

/**
 * Opens the trays option menu
 */
UCF_Tray["prototype"]["toggleMenu"] = function() {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["toggleMenu"]++; }; 

	if (!this["sOptionMenuId"]) return;

	if (!this["oMenuButton"]) return;
	if (!this["oOptionMenu"]) {
		this["oOptionMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](this["sOptionMenuId"], true);

		if (!this["oOptionMenu"]) return;

		this["oOptionMenu"]["setOpenerRef"](this["oMenuButton"]);
		this["oOptionMenu"]["setOpenerId"](this["sId"]);
		this["oOptionMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"]);
		this["oOptionMenu"]["setOffsetTop"](-1);
		this["oOptionMenu"]["setOffsetLeft"](-1);
	}
	this["oOptionMenu"]["attachEvent"](this["oOptionMenu"]["E_EVENTS"]["Close"], this, 'onMenuClose');

	if (this["oOptionMenu"]["bOpened"]) {
		UCF_DomUtil["removeClass"](this["oMenuButton"], 'lsTray--menu-open');
		this["oOptionMenu"]["close"]();
	} else {
		UCF_DomUtil["addClass"](this["oMenuButton"], 'lsTray--menu-open');
		this["fireMenuAccess"](this["sId"], this["sOptionMenuId"]);
		this["oOptionMenu"]["open"]();
	}

};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["toggleMenu"] = 0; };

/**
 * Handles the keydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsshow"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tray.js(301): onlsshow"); };

	if (window["UCF_System"]["bIsAria"]) {
		// tabstop is placed at the -ariaty element
		// else the aria roles clash so that
		// the screen reader announcement is not proper
		var oSource = oBrowserEvent["oGetSource"]();
		if (this["bEnabled"] && oSource === this["oHeaderText"]) {
			this["toggleMenu"]();
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	} else {
		if (this["bEnabled"] && this["oDomRef"] === oBrowserEvent["oGetSource"]()) {
			this["toggleMenu"]();
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsshow"] = 0; };

/**
 * Handles the expand event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsexpand"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tray.js(330): onlsexpand"); };
	// if the Tray is expanded do nothing
	if (!this["bCollapsed"]) return;
	this["toggleContent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsexpand"] = 0; };

/**
 * Handles the right (expand) event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsright"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tray.js(343): onlsright"); };
	// if the Tray is expanded do nothing
	if (!this["bCollapsed"]) return;
	this["toggleContent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsright"] = 0; };

/**
 * Handles the left (collapse) event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsleft"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tray.js(357): onlsleft"); };
	// if the Tray is collapsed do nothing
	if (this["bCollapsed"]) return;
	this["toggleContent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsleft"] = 0; };

/**
 * Handles the collapse event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlscollapse"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tray.js(370): onlscollapse"); };
	// if the Tray is collapsed do nothing
	if (this["bCollapsed"]) return;
	this["toggleContent"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlscollapse"] = 0; };

/**
 * Handles the expand event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["toggleContent"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["toggleContent"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();
	if (window["UCF_System"]["bIsAria"]) {
		// tabstop is placed at the -ariaty element
		// else the aria roles clash so that
		// the screen reader announcement is not proper

		if (this["bEnabled"] &&
			(((oSource === this["oTitleArea"] || oSource === this["oExpandButton"]) && !this["bHasToggleButton"]) ||
				(oSource === this["oTitleArea"]))) {
			this["toggle"](oSource);
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	} else {
		if (this["bEnabled"] && this["oDomRef"] === oBrowserEvent["oGetSource"]()) {
			this["toggle"](oSource);
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["toggleContent"] = 0; };

/**
 * Handles the expand event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["handleClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["handleClick"]++; }; 

	var oSource = oBrowserEvent["oGetSource"]();

	if (!this["bEnabled"]) return;

	if (oSource === this["oCloseButton"]) {
		this["bIgnoreDefaultButton"] = true;
		this["fireClose"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		return;
	}
	//toggle the tray if clicked on the icon
	if (oSource === this["oExpandButton"] ||
		oSource === this["oTitleArea"]) {
		this["bIgnoreDefaultButton"] = true;
		this["toggle"](oSource);
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		return;
	}
	if (oSource === this["oMenuButton"]) {
		this["toggleMenu"]();
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
		return;
	}

	this["toggleContent"](oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["handleClick"] = 0; };

/**
 * Handles the onlsselect event
 *  ENTER & SPACE key
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tray.js(453): onlsselect"); };
	//fired by space

	this["handleClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsselect"] = 0; };

/**
 * Handle hotkey events
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["onlshotkey"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlshotkey"]++; }; 

	if (this["sHotkeysId"] === '') return;

	var oHotkeys = this["oGetControlById"](this["sHotkeysId"]),
		oHotkey = null;
	if (oHotkeys == null) return;

	oHotkey = oHotkeys["oGetHotkeyFromEvent"](oBrowserEvent);

	if (oHotkey) {
		if (UCF_Hotkeys["bMustCancelLSHotKey"](oBrowserEvent)) {
			oBrowserEvent["cancel"]();
		}
		oBrowserEvent["cancelBubble"]();

		if (!oHotkeys["bHandleHotkeyOnClient"](oHotkey)) {
			this["oLS"]["fireBeforeHotkey"]();
			this["fireHotkey"](this["sId"], oHotkey["sHotkey"], oHotkey["sProviderId"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlshotkey"] = 0; };

UCF_Tray["prototype"]["onkeypress"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onkeypress"]++; }; 
	if (UCF_ClassLoader["oGetClass"]('UCF_Hotkeys')["bMustCancelKeyPress"](oBrowserEvent)) {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onkeypress"] = 0; };

/**
 * Set the press state of the toggle
 * @param {boolean} bDown - down flag
 * @private
 */
UCF_Tray["prototype"]["pressToogleButton"] = function(bDown) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["pressToogleButton"]++; }; 
	if (this["oToggleButton"]) {
		if (bDown)
			UCF_DomUtil["addClass"](this["oToggleButton"], 'lsTray--button-pressed');
		else
			UCF_DomUtil["removeClass"](this["oToggleButton"], 'lsTray--button-pressed');
	}
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["pressToogleButton"] = 0; };

/**
 *  While SPACE & ENTER it should push down the Toggle Button
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @returns
 */
UCF_Tray["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tray.js(514): onkeydown"); };

	/** @type {int} */
	var iKeyCode = oBrowserEvent["iKeyCode"]();
	if (iKeyCode !== UCF_KeyCodes["SPACE"] && iKeyCode !== UCF_KeyCodes["ENTER"]) return;
	// The event should be canceled only when the space is press on the Toggle area
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oToggleButton"]) {
		this["pressToogleButton"](true);
	}
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onkeydown"] = 0; };

/**
 *  While SPACE & ENTER it should set back the Toggle Button
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @returns
 */
UCF_Tray["prototype"]["onkeyup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onkeyup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tray.js(532): onkeyup"); };
	/** @type {int} */
	var iKeyCode = oBrowserEvent["iKeyCode"]();
	if (iKeyCode !== UCF_KeyCodes["SPACE"] && iKeyCode !== UCF_KeyCodes["ENTER"]) return;
	// The event should be canceled only when the space is press on the Toggle area
	var oSource = oBrowserEvent["oGetSource"]();
	if (oSource === this["oToggleButton"]) {
		this["pressToogleButton"](false);
	}
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onkeyup"] = 0; };
/**
 * Handles the onMenuClose event
 *
 * @param {UCF_Event} oEvent
 */
UCF_Tray["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onMenuClose"]++; }; 
	this["bOptionMenuIsOpened"] = false;
	if (!this["oMenuButton"]) return;
	UCF_DomUtil["removeClass"](this["oMenuButton"], 'lsTray--menu-open');
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onMenuClose"] = 0; };

/**
 * handles the mouse over event:
 * - initializes fields laizy
 * - applies hover effect, when title has menu associated
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onmouseover"]++; }; 

	if (window["UCF_System"]["bIs508"]) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oDomRefContent = UCF_DomUtil["$"](this["sId"] + '-tbdc');

	if (oSource === oDomRefContent) return;

	UCF_DomUtil["checkTooltip"](this["oHeaderText"], this["sTooltip"], this["oHeaderText"]);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onmouseover"] = 0; };

/**
 * Handle the area scroll event
 *
 * @param {UCF_Event} oEvent
 */
UCF_Tray["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onScroll"]++; }; 
	var iScrollTop = oEvent["oGetParam"]('iScrollTop'),
		iScrollLeft = oEvent["oGetParam"]('iScrollLeft');

	this["fireScroll"](this["sId"], iScrollTop, iScrollLeft);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onScroll"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tray["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsskipback"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 *  @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_Tray["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tray.js(611): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		oSource = oBrowserEvent["oGetSource"]();

	if (oSource === this["oDomRef"]) {
		oAccessibilityHelper["setText"](this["sTitle"]);
		oAccessibilityHelper["setControlType"]('TY');
		oAccessibilityHelper["setAccessKey"](this["sAccessKey"]);
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		oAccessibilityHelper["setEnabled"](this["bEnabled"]);

		if (this["sAccessibilityDescription"]) {
			oAccessibilityHelper["setText"](this["sTitle"] + ' - ' + this["sAccessibilityDescription"]);
		}

		oAccessibilityHelper["applyContainerEntryBehaviour"](this["bIsCollapsible"], this["bEnabled"], this["bCollapsed"]);

		if ((this["bHasOptionMenu"]) && (this["bEnabled"])) {
			oAccessibilityHelper["addTutor"]('MENU_TUT');
		}
	} else if (oSource["getAttribute"]('tp') === 'END') {
		oAccessibilityHelper["setControlType"]('TY_END');
	}
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["onlsaccessibility"] = 0; };

/**
 * Sets the default button id for the control
 *
 * @param {string} sDefaultButtonId string Id of the button that is executed if the user presses enter
 * @public
 */
UCF_Tray["prototype"]["setDefaultButtonId"] = function(sDefaultButtonId) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["setDefaultButtonId"]++; }; 
	UCF_Control.prototype["setDefaultButtonId"]["call"](this, sDefaultButtonId);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["setDefaultButtonId"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Tray["prototype"]["aAttributeNames"] = ["sTitle","sDesign","bCollapsed","bEnabled","sTooltip","sHeight","sContentHeight","bHasOptionMenu","sOptionMenuId","bHasCloseButton","sScrollingMode","bHasToolbar","bIsCollapsible","sAccessibilityDescription","sVisibility","sDefaultButtonId","iScrollTop","iScrollLeft","sAccessKey","sHotkeysId","bIsDragHandle","bClientSelect","iHeadingLevel","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Tray["prototype"]["aEventNames"] = ["Expand","Collapse","Close","MenuAccess","Scroll","Hotkey"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Tray["prototype"]["aMethodNames"] = ["setDefaultButtonId","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Tray["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TrayDesign}
 */
UCF_Tray["prototype"]["sDesign"] = "TRANSPARENT";

/**
 * @private
 * @type {boolean}
 */
UCF_Tray["prototype"]["bCollapsed"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Tray["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_Tray["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tray["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tray["prototype"]["sContentHeight"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Tray["prototype"]["bHasOptionMenu"] = true;

/**
 * @private
 * @type {string}
 */
UCF_Tray["prototype"]["sOptionMenuId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Tray["prototype"]["bHasCloseButton"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ScrollingMode}
 */
UCF_Tray["prototype"]["sScrollingMode"] = "NONE";

/**
 * @private
 * @type {boolean}
 */
UCF_Tray["prototype"]["bHasToolbar"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Tray["prototype"]["bIsCollapsible"] = true;

/**
 * @private
 * @type {string}
 */
UCF_Tray["prototype"]["sAccessibilityDescription"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Tray["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_Tray["prototype"]["sDefaultButtonId"] = '';

/**
 * @private
 * @type {number}
 */
UCF_Tray["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_Tray["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_Tray["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tray["prototype"]["sHotkeysId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Tray["prototype"]["bIsDragHandle"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Tray["prototype"]["bClientSelect"] = true;

/**
 * @private
 * @type {number}
 */
UCF_Tray["prototype"]["iHeadingLevel"] = 0;

/**
 * @private
 * @type {string}
 */
UCF_Tray["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tray["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Tray["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["setDefaultValues"]++; }; 
	this["sTitle"] = '';
	this["sDesign"] = "TRANSPARENT";
	this["bCollapsed"] = false;
	this["bEnabled"] = true;
	this["sTooltip"] = '';
	this["sHeight"] = '';
	this["sContentHeight"] = '';
	this["bHasOptionMenu"] = true;
	this["sOptionMenuId"] = '';
	this["bHasCloseButton"] = false;
	this["sScrollingMode"] = "NONE";
	this["bHasToolbar"] = false;
	this["bIsCollapsible"] = true;
	this["sAccessibilityDescription"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sDefaultButtonId"] = '';
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["sAccessKey"] = '';
	this["sHotkeysId"] = '';
	this["bIsDragHandle"] = false;
	this["bClientSelect"] = true;
	this["iHeadingLevel"] = 0;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("Design", "TRANSPARENT", true);
		this["setClientProperty"]("Collapsed", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("ContentHeight", '', true);
		this["setClientProperty"]("HasOptionMenu", true, true);
		this["setClientProperty"]("OptionMenuId", '', true);
		this["setClientProperty"]("HasCloseButton", false, true);
		this["setClientProperty"]("ScrollingMode", "NONE", true);
		this["setClientProperty"]("HasToolbar", false, true);
		this["setClientProperty"]("IsCollapsible", true, true);
		this["setClientProperty"]("AccessibilityDescription", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("DefaultButtonId", '', true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("HotkeysId", '', true);
		this["setClientProperty"]("IsDragHandle", false, true);
		this["setClientProperty"]("ClientSelect", true, true);
		this["setClientProperty"]("HeadingLevel", 0, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Tray::Expand
 */
UCF_Tray["prototype"]["fireExpand"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireExpand"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Tray.js(888): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tray.js(889): fireExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tray.js(890): fireExpand"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Tray", "Expand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireExpand"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Tray::Collapse
 */
UCF_Tray["prototype"]["fireCollapse"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireCollapse"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Tray.js(907): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tray.js(908): fireCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tray.js(909): fireCollapse"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Tray", "Collapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Tray::Close
 */
UCF_Tray["prototype"]["fireClose"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireClose"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Tray.js(926): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tray.js(927): fireClose"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tray.js(928): fireClose"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Tray", "Close", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireClose"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sMenuId Identifier of the menu
 * @fires Tray::MenuAccess
 */
UCF_Tray["prototype"]["fireMenuAccess"] = function(sId, sMenuId) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireMenuAccess"]++; }; 
	/** @type {{Id: string, MenuId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Tray.js(946): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tray.js(947): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tray.js(948): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMenuId != null, "sMenuId != null", "Tray.js(949): fireMenuAccess"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMenuId) == "string", "typeof(sMenuId) == \"string\"", "Tray.js(950): fireMenuAccess"); };
	mParams = {
		"Id": sId,
		"MenuId": sMenuId
	};
	
	
	this["fireSemanticEvent"]("Tray", "MenuAccess", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireMenuAccess"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop undefined
 * @param {number} iScrollLeft undefined
 * @fires Tray::Scroll
 */
UCF_Tray["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Tray.js(971): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tray.js(972): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tray.js(973): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "Tray.js(974): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "Tray.js(975): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "Tray.js(976): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "Tray.js(977): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("Tray", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {UCF_ClientInterfaces.E.HotkeyValue} sHotkey The fired hotkey
 * @param {string} sProviderId ID of the hotkey provider
 * @fires Tray::Hotkey
 */
UCF_Tray["prototype"]["fireHotkey"] = function(sId, sHotkey, sProviderId) {;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireHotkey"]++; }; 
	/** @type {{Id: string, Hotkey: UCF_ClientInterfaces.E.HotkeyValue, ProviderId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Tray.js(1000): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tray.js(1001): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tray.js(1002): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHotkey != null, "sHotkey != null", "Tray.js(1003): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHotkey) == "string", "typeof(sHotkey) == \"string\"", "Tray.js(1004): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sProviderId != null, "sProviderId != null", "Tray.js(1005): fireHotkey"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sProviderId) == "string", "typeof(sProviderId) == \"string\"", "Tray.js(1006): fireHotkey"); };
	mParams = {
		"Id": sId,
		"Hotkey": sHotkey,
		"ProviderId": sProviderId
	};
	
	
	
	this["fireSemanticEvent"]("Tray", "Hotkey", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tray["_"]["fireHotkey"] = 0; };

UCF_Tray.prototype["aPublicMethods"] = ["setDefaultButtonId"].concat(UCF_Tray.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_Tree"] = function() {/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_FocusInfo */
/// <reference path="../core/FocusInfo.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ScrollArea */
/// <reference path="./base/ScrollArea.js"/>
/* global UCF_TreeDragDelegate */
/// <reference path="./delegates/TreeDragDelegate.js"/>
/* global UCF_TreeDropDelegate */
/// <reference path="./delegates/TreeDropDelegate.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/**
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Tree(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Tree["_"]["UCF_Tree"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Tree.js(35): UCF_Tree"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Tree.js(36): UCF_Tree"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Tree.js(37): UCF_Tree"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	if (this["sScrollingMode"] !== "NONE") {
		this["oScrollDomRef"] = UCF_DomUtil["$"](this["sId"] + "-scrl");
		/** @type {UCF_ScrollArea} */
		// eslint-disable-next-line @ur/no-memory-leaks
		this["oScrollArea"] = new (UCF_ClassLoader["oGetClass"]("UCF_ScrollArea"))(this["oScrollDomRef"]);
		this["attachBrowserEvent"]("scroll", this["oScrollDomRef"]);
		this["oScrollArea"]["attachEvent"](this["oScrollArea"]["E_EVENTS"]["Scroll"], this, "onScroll");
		this["addDelegate"](this["oScrollArea"]);
	}
	// 1 Dimensional Index for Selection
	this["aChildIndex"] = new Array();

	this["oFocussedNode"] = null;
	this["oSelectedNode"] = null;
	this["bForwardedFromOutside"] = false;
	this["initClientSelectionHandling"]();
	this["initContentListening"](); // Needs initClientSelectionHandling
	// processed before

	this["oChildrenRef"] = UCF_DomUtil["$"](this["sId"] + "-child");
	// if root node is visible and scrolling is enabled "-child" is renamed to "-scrl"
	if (!this["oChildrenRef"]) this["oChildrenRef"] = this["oScrollDomRef"];

	this["oSkipStartRef"] = UCF_DomUtil["$"](this["sId"] + "-skipstart");
	this["oSkipEndRef"] = UCF_DomUtil["$"](this["sId"] + "-skipend");
	this["oCollapseAllRef"] = UCF_DomUtil["$"](this["sId"] + "-collapseall");
	this["oExpandAllRef"] = UCF_DomUtil["$"](this["sId"] + "-expandall");
	this["oFocusDomRef"] = this["oSkipStart"];

	// although this event is already attached in BrowserWindow by default
	// the tree needs to attach separately to be called, before WD Java
	// HtmlClient event handling is canceling the event
	this["attachBrowserEvent"]("contextmenu", this["oRootRef"]);

	this["bIsPrimarySelectionSet"] = false;
};window["UCF_Tree"] = UCF_Tree; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Tree"); UCF_Tree["_"] = {UCF_Tree: 0}; }; ;
UCF_Tree["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Tree.prototype["sClassName"] = "UCF_Tree";

/**
 * Initialize in case scroll positions have to be applied
 * @private
 */
UCF_Tree["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["initialize"]++; }; 
	if (this["oScrollArea"]) {
		this["oScrollArea"]["setScrollPosition"](this["iScrollTop"], this["iScrollLeft"]);
	}

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["initialize"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_Tree["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["destroy"]++; }; 
	if (this["oScrollArea"]) {
		UCF_ScrollArea["disconnectAndDestroyScrollArea"](this, this["oScrollArea"]);
		this["oScrollArea"] = null;
		this["oScrollDomRef"] = null;
	}

	this["detachBrowserEvent"]("contextmenu", this["oRootRef"]);
	this["destroyChildIndex"]();
	this["cleanContentListening"]();
	this["cleanClientSelectionHandling"]();

	this["aChildIndex"] = null;
	this["oFocussedNode"] = null;
	this["oSelectedNode"] = null;
	this["oChildrenRef"] = null;
	this["oSkipEndRef"] = null;
	this["oSkipStartRef"] = null;
	this["oCollapseAllRef"] = null;
	this["oExpandAllRef"] = null;
	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["destroy"] = 0; };
/*******************************************************************************
 * * CONSTANTS
 ******************************************************************************/
/*
 * Keyboard modifier
 */
UCF_Tree["prototype"]["MODIFIER_NAME"] = {
	"SHIFT": "SHIFT",
	"CTRL": "CTRL",
	"ALT": "ALT"
};

/**
 * Access types
 */
UCF_Tree["prototype"]["ACCESS_TYPE"] = {
	"NONE": 0,
	"MOUSE": 1,
	"KEYBOARD_SELECT": 2,
	"KEYBOARD_EXPAND": 3,
	"KEYBOARD_COLLAPSE": 4,
	"DRAG_START": 5,
	"DRAG": 6,
	"DRAG_END": 7,
	"DRAG_OVER": 8,
	"DROP": 9,
	"DRAG_ENTER": 10,
	"DRAG_LEAVE": 11,
	"S_508": 12,
	"HOTKEY": 13,
	"KEYBOARD_ENTER": 14,
	"KEYBOARD_NAVIGATE": 15
};

/**
 * Access type event params
 */
UCF_Tree["prototype"]["EVENT_PARAM_MAP_ACCESS_TYPE"] = {
	"INVALID": "INVALID",
	"STANDARD": "STANDARD",
	"RANGE": "RANGE",
	"TOGGLE": "TOGGLE"
};

/**
 * Focus behaviour params
 */
UCF_Tree["prototype"]["FOCUS_BEHAVIOUR"] = {
	"NONE": 0,
	"NODE": 1
};

/**
 * Navigation types
 */
UCF_Tree["prototype"]["NAVIGATION"] = {
	"NONE": 0,
	"UP": 1,
	"DOWN": 2,
	"TOP": 3,
	"BOTTOM": 4,
	"HOME": 5,
	"END": 6
};

/**
 * Handles the click event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tree["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tree.js(197): onclick"); };

	if (!this["bEnabled"]) return;

	var oSourceRef = oBrowserEvent["oGetSource"](),
		sAccessFragment = oSourceRef["getAttribute"]("acf");

	if (sAccessFragment === "expall") {
		this["fireExpandAll"](this["sId"]);
	}
	if (sAccessFragment === "colall" && this["bCanCollapseAll"]) {
		this["fireCollapseAll"](this["sId"]);
	}

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onclick"] = 0; };

/**
 * When pressing the numpad asterisk, collapse all
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Tree["prototype"]["onlscollapseall"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlscollapseall"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tree.js(220): onlscollapseall"); };
	if (!this["bEnabled"]) return;

	if (!this["bCanCollapseAll"]) return;

	this["fireCollapseAll"](this["sId"]);

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlscollapseall"] = 0; };

/**
 * When pressing the down key move the focus to the next visible node
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Tree["prototype"]["onlsdown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsdown"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tree.js(239): onlsdown"); };

	if (this["bCancelHandlerProcessing"](oBrowserEvent)) return;

	this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["DOWN"]);

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsdown"] = 0; };

/**
 * When pressing the down key with a modifier key
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Tree["prototype"]["onlsdownmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsdownmodifier"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tree.js(257): onlsdownmodifier"); };

	if (!UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent)) return;

	if (this["bCancelHandlerProcessing"](oBrowserEvent)) return;

	this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["DOWN"]);

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsdownmodifier"] = 0; };

/**
 * When pressing the  key move the focus to the previous visible node
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Tree["prototype"]["onlsup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsup"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tree.js(277): onlsup"); };
	if (this["bCancelHandlerProcessing"](oBrowserEvent)) return;

	this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["UP"]);

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsup"] = 0; };

/**
 * When pressing the  key with a modifier key
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Tree["prototype"]["onlsupmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsupmodifier"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tree.js(294): onlsupmodifier"); };
	if (!UCF_KeyboardHelper["bHasOnlyAltAsModifier"](oBrowserEvent)) return;
	if (this["bCancelHandlerProcessing"](oBrowserEvent)) return;

	this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["UP"]);

	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsupmodifier"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_Tree["prototype"]["onlshome"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlshome"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Tree.js(311): onlshome"); };
	if (this["bCancelHandlerProcessing"](oBrowserEvent)) return;

	this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["HOME"], true);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlshome"] = 0; };

/**
 * Event handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 */
UCF_Tree["prototype"]["onlsend"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsend"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Tree.js(323): onlsend"); };
	if (this["bCancelHandlerProcessing"](oBrowserEvent)) return;

	this["handleKeyboardNavigation"](oBrowserEvent, this["NAVIGATION"]["END"], true);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsend"] = 0; };

/**
 * When Tree is focused, put focus on last focused node or first node
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @private
 */
UCF_Tree["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsfocus"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tree.js(337): onlsfocus"); };

	var oFocusDomRef = oBrowserEvent["oGetSource"](),
		oFromElementRef = oBrowserEvent["oGetFromElement"](),
		bFromOutside = !UCF_DomUtil["bContains"](this["oRootRef"], oFromElementRef)
		|| oFromElementRef === this["oCollapseAllRef"]
		|| oFromElementRef === this["oExpandAllRef"],
		oNode;

	// Don't do anything if not skipstart or skipend get the focus
	if (oFocusDomRef !== this["oSkipStartRef"] && oFocusDomRef !== this["oSkipEndRef"]) {
		return;
	}

	// Once Tree has been focused remove tabIndex from skip spans
	UCF_DomUtil["setTabIndex"](this["oSkipStartRef"], -1);
	UCF_DomUtil["setTabIndex"](this["oSkipEndRef"], -1);

	// otherwise set focus to either the first node or the last focussed node
	if (bFromOutside) {

		// if there is no focussed node yet, go to the first node
		if (!this["oFocussedNode"]) {
			oNode = this["oGetFirstNode"]();
		} else {
			oNode = this["oFocussedNode"];
		}

		// Call delayed to make JAWS work right
		UCF_JsUtil["delayedCall"](0, this, "focusNodeFromOutside", [oNode]);
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsfocus"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_Tree["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_Tree["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsskipback"] = 0; };

/**
 * Add currently focused node id to FocusInfo
 *
 * @param {UCF_FocusInfo} oFocusInfo
 * @private
 */
UCF_Tree["prototype"]["collectFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["collectFocusInfo"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "Tree.js(401): collectFocusInfo"); };

	var sFocussedNodeId = "";

	if (this["oFocussedNode"]) {
		sFocussedNodeId = this["oFocussedNode"]["sId"];
	}

	oFocusInfo["setApplyControl"](this);
	oFocusInfo["addParam"]("sFocussedNodeId", sFocussedNodeId);

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["collectFocusInfo"] = 0; };

/**
 * Get node object for the current focused node and focus it
 * @param {UCF_FocusInfo} oFocusInfo
 * @private
 */
UCF_Tree["prototype"]["applyFocusInfo"] = function(oFocusInfo) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["applyFocusInfo"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oFocusInfo instanceof UCF_FocusInfo, "oFocusInfo instanceof UCF_FocusInfo", "Tree.js(421): applyFocusInfo"); };

	var sId = oFocusInfo["oGetParam"]("sFocussedNodeId"),
		oNode = this["oGetControlById"](sId);

	if (!oNode) {
		oNode = this["oGetFirstNode"]();
	}

	this["focusNode"](oNode);

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["applyFocusInfo"] = 0; };

/**
 * Set the focus to the given TreeNode and set from-outside-flag
 * @param {UCF_TreeNode} oNode
 * @private
 */
UCF_Tree["prototype"]["focusNodeFromOutside"] = function(oNode) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["focusNodeFromOutside"]++; }; 
	this["bForwardedFromOutside"] = true;
	this["focusNode"](oNode);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["focusNodeFromOutside"] = 0; };

/**
 * Set the focus to the given TreeNode
 * @param {UCF_TreeNode} oNode
 * @private
 */
UCF_Tree["prototype"]["focusNode"] = function(oNode) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["focusNode"]++; }; 
	if (oNode) {

		if (this["oFocussedNode"]) {
			UCF_DomUtil["setTabIndex"](this["oFocussedNode"]["oFocusDomRef"], -1);
		}
		UCF_DomUtil["setTabIndex"](oNode["oFocusDomRef"], 0);
		UCF_DomUtil["focusDomElement"](oNode["oFocusDomRef"]);
		this["oFocussedNode"] = oNode;
	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["focusNode"] = 0; };

/**
 * Selects the node
 * @param {UCF_TreeNode} oNode
 * @param { UCF_AccessInfo } oAccessInfo
 * @private
 */
UCF_Tree["prototype"]["selectNode"] = function(oNode, oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["selectNode"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo, "oAccessInfo", "Tree.js(468): selectNode"); };
	this["internalFireNodeSelectDirect"](oNode, oAccessInfo["eAccessType"], this["sGetEventSelectAccessType"](oAccessInfo));
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["selectNode"] = 0; };

/**
 * Toggles the node
 *
 * @param {UCF_TreeNode} oNode
 * @param oAccessInfo
 * @private
 */
UCF_Tree["prototype"]["toggleNode"] = function(oNode, oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["toggleNode"]++; }; 
	this["internalFireNodeSelectDirect"](oNode, oAccessInfo["eAccessType"], this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["toggleNode"] = 0; };

/**
 * Set the selected node ID
 * This is only sported when ClientSelection 'SINGLE' is enabled. Use public methods on TreeNodes for multiple selection.
 * @param {string} sNodeId
 * @public
 */
UCF_Tree["prototype"]["setSelection"] = function(sNodeId) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["setSelection"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["sClientSelection"] === "SINGLE", "this.sClientSelection === \"SINGLE\"", "Tree.js(490): setSelection"); };
	if (this["sClientSelection"] !== "SINGLE") return;

	var oNode = this["oGetControlById"](sNodeId);
	if (oNode) {
		this["internalFireNodeSelectDirect"](oNode, this["ACCESS_TYPE"]["NONE"], "STANDARD");
	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["setSelection"] = 0; };

/**
 * Get the selected node ID
 * This is only sported when ClientSelection 'SINGLE' is enabled. Use public methods on TreeNodes for multiple selection.
 * @return {string}
 * @public
 */
UCF_Tree["prototype"]["getSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["getSelection"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(this["sClientSelection"] === "SINGLE", "this.sClientSelection === \"SINGLE\"", "Tree.js(506): getSelection"); };
	if (this["sClientSelection"] !== "SINGLE") return null;

	var sNodeId = null;
	if (this["oSelectedNode"]) sNodeId = this["oSelectedNode"]["sId"];
	return sNodeId;
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["getSelection"] = 0; };

/**
 * Handle the area scroll event
 *
 * @param {UCF_Event} oEvent
 * @private
 */
UCF_Tree["prototype"]["onScroll"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onScroll"]++; }; 
	var iScrollTop = oEvent["oGetParam"]("iScrollTop"),
		iScrollLeft = oEvent["oGetParam"]("iScrollLeft");

	this["fireScroll"](this["sId"], iScrollTop, iScrollLeft);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onScroll"] = 0; };

/**
 * Collapse all tree nodes
 * @public
 */
UCF_Tree["prototype"]["collapseAllNodes"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["collapseAllNodes"]++; }; 

	var aChildNodes = this["aGetChildNodes"]();
	for (var i = 0; i < aChildNodes["length"]; i++) {
		aChildNodes[i]["collapseRecursive"]();
	}
	this["focusNode"](this["oGetFirstNode"]());

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["collapseAllNodes"] = 0; };

/**
 * Expands all tree nodes
 * @public
 */
UCF_Tree["prototype"]["expandAllNodes"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["expandAllNodes"]++; }; 
	var aChildNodes = this["aGetChildNodes"]();
	for (var i = 0; i < aChildNodes["length"]; i++) {
		aChildNodes[i]["expandRecursive"]();
	}

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["expandAllNodes"] = 0; };

/**
 * Returns an array of all child nodes of this node
 * @private
 * @return {Array}
 */
UCF_Tree["prototype"]["aGetChildNodes"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["aGetChildNodes"]++; }; 

	if (!this["oChildrenRef"])
		return [];

	var aChildRefs = this["oChildrenRef"]["childNodes"],
		aChildRef,
		aChildNodes = [];
	for (var i = 0; i < aChildRefs["length"]; i++) {
		aChildRef = aChildRefs[i];
		if (aChildRef["getAttribute"]("ct")) {
			aChildNodes["push"](this["oGetControlByDomRef"](aChildRef, true));
		}
	}
	return aChildNodes;
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["aGetChildNodes"] = 0; };

/**
 * Returns the first child node of the tree
 * @return {UCF_TreeNode}
 * @private
 */
UCF_Tree["prototype"]["oGetFirstNode"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetFirstNode"]++; }; 

	if (!this["oChildrenRef"])
		return null;

	//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node

	var oNodeRef = this["oChildrenRef"]["firstChild"],
		oNode = null;

	if (oNodeRef) oNode = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oNodeRef, true);

	return oNode;

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetFirstNode"] = 0; };

/**
 * Returns the last node in the tree (must not be a direct child!)
 * @private
 */
UCF_Tree["prototype"]["oGetLastNode"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetLastNode"]++; }; 

	if (!this["oChildrenRef"])
		return null;

	//TODO: replace by UCF_DomUtil.lastChild(this.oDomRef) to avoid problems with text node
	var oNodeRef = this["oChildrenRef"]["lastChild"],
		oNode = null,
		oLastChild;

	//TODO replace by UCF_DomUtil.oGetPreviousSibling

	if (oNodeRef) oNodeRef = oNodeRef["previousSibling"];
	if (oNodeRef) oNode = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oNodeRef, true);

	oLastChild = oNode["oGetLastChild"]();
	while (oLastChild) {
		oNode = oLastChild;
		oLastChild = oNode["oGetLastChild"]();
	}

	return oNode;

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetLastNode"] = 0; };

/**
 * Termination of recursive calls from the TreeNode
 * @private
 */
UCF_Tree["prototype"]["oGetNextNode"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetNextNode"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetNextNode"] = 0; };

/**
 * Termination of recursive calls from the TreeNode
 * @private
 */
UCF_Tree["prototype"]["oGetPreviousNode"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetPreviousNode"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetPreviousNode"] = 0; };

/**
 * Termination of recursive calls from the TreeNode
 * @private
 */
UCF_Tree["prototype"]["oGetNextSibling"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetNextSibling"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetNextSibling"] = 0; };

/**
 * Termination of recursive calls from the TreeNode
 * @private
 */
UCF_Tree["prototype"]["oGetPreviousSibling"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetPreviousSibling"]++; }; 
	return null;
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["oGetPreviousSibling"] = 0; };

/**
 * Gets the direct children as string.
 * @return {string}
 * @see UCF_Control.sGetAccChildren
 * @private
 */
UCF_Tree["prototype"]["sGetAccChildren"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["sGetAccChildren"]++; }; 
	return this["oLS"]["sGetText"]("SAPUR_ACC_TREE_CHILDREN");
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["sGetAccChildren"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Tree["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tree.js(675): onlsaccessibility"); };

	var oFromElementRef = oBrowserEvent["oGetFromElement"](),
		bFromOutside = !UCF_DomUtil["bContains"](this["oRootRef"], oFromElementRef);

	if (bFromOutside || this["bForwardedFromOutside"]) {

		this["bForwardedFromOutside"] = false;

		var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

		oAccessibilityHelper["setParentText"](this["sTitle"]);
		oAccessibilityHelper["setParentControlType"]("TR");
		oAccessibilityHelper["setParentTooltip"](this["sTooltip"]);
		if (this["bCanCollapseAll"]) {
			oAccessibilityHelper["addTutor"]("TR_TUT_COLLAPSE_ALL");
		} else {
			oAccessibilityHelper["addTutor"]("TR_TUT");
		}

	}

	oBrowserEvent["cancelBubble"]();

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onlsaccessibility"] = 0; };

/**
 * Event handler
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object
 * @private
 */
UCF_Tree["prototype"]["onmousemove"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onmousemove"]++; }; 

	this["createDragDelegate"]();
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onmousemove"] = 0; };

/**
 * implements method from UCF_Control
 * @private
 */
UCF_Tree["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["createDragDelegate"]++; }; 

	if (this["oDragDelegate"])
		return;

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_TreeDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["createDragDelegate"] = 0; };

/**
 * implements method from UCF_Control
 * @private
 */
UCF_Tree["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["createDropDelegate"]++; }; 

	if (this["oDropDelegate"])
		return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_TreeDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["createDropDelegate"] = 0; };

/**
 * Events for capturing (these are actually processed by TreeNode)
 * @private
 */
UCF_Tree["prototype"]["aNodeCaptureEvents"] = ["lsselect", "lsenter", "click", "mousedown"];

/**
 * Attaches/activates the event capturing
 * @private
 */
UCF_Tree["prototype"]["attachContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["attachContentListening"]++; }; 

	if (!this["bContentListening"]) return;

	for (var i = 0; i < this["aNodeCaptureEvents"]["length"]; i++) {
		this["oLS"]["attachCaptureEvent"](this["aNodeCaptureEvents"][i], this, "onContentEventCapture");
	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Event capturing of \"" + this["sId"] + "\" attached", "Tree.js(756): attachContentListening"); };
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["attachContentListening"] = 0; };

/**
 * detaches/deactivates the event capturing
 * @private
 */
UCF_Tree["prototype"]["detachContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["detachContentListening"]++; }; 

	if (!this["bContentListening"])
		return;

	for (var i = 0; i < this["aNodeCaptureEvents"]["length"]; i++) {
		this["oLS"]["detachCaptureEvent"](this["aNodeCaptureEvents"][i], this);

	}
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Event capturing of \"" + this["sId"] + "\" detached", "Tree.js(772): detachContentListening"); };
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["detachContentListening"] = 0; };

/**
 * Processes the captured events
 *
 * @param {UCF_BrowserEvent}     oBrowserEvent
 */
UCF_Tree["prototype"]["onContentEventCapture"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onContentEventCapture"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tree.js(781): onContentEventCapture"); };

	var oSource = oBrowserEvent["oGetSource"]();

	var oNode = UCF_DomUtil["oGetParentByAttribute"](oSource, 'treeId', this["sId"]);

	if (oNode) {
		var sHandlerName = "on" + oBrowserEvent["sGetName"]();

		//add modifier suffix
		if (oBrowserEvent["sGetName"]()["indexOf"]("ls") === 0 && (oBrowserEvent["bShift"]() || oBrowserEvent["bCtrl"]()
				|| oBrowserEvent["bAlt"]())) sHandlerName += "modifier";

		this["bCapturedEventProcessing"] = true;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Fetched control: " + oNode["id"] + " trying to call method: " + sHandlerName, "Tree.js(795): onContentEventCapture"); };

		// if(this.oChildrenRef[sHandlerName])
		var oNodeControl = this["oLS"]["oControlFactory"]["oGetControlById"](oNode["id"]);

		if (oNodeControl)
			oNodeControl[sHandlerName](oBrowserEvent);

		this["bCapturedEventProcessing"] = false;

	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onContentEventCapture"] = 0; };

/**
 * Initialize content listening for capturing
 */
UCF_Tree["prototype"]["initContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["initContentListening"]++; }; 
	if (!this["bContentListening"])
		return;

	this["attachContentListening"]();
	this["bCapturedEventProcessing"] = false;
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["initContentListening"] = 0; };

/**
 * Cleanup content listening
 * @private
 */
UCF_Tree["prototype"]["cleanContentListening"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["cleanContentListening"]++; }; 
	if (!this["bContentListening"])
		return;

	this["detachContentListening"]();
	this["bContentListening"] = false;
	this["bCapturedEventProcessing"] = false;
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["cleanContentListening"] = 0; };

/**
 * Initializes the selection handling on client side
 * @private
 */
UCF_Tree["prototype"]["initClientSelectionHandling"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["initClientSelectionHandling"]++; }; 

	this["bNodeSelectionByNavigation"] = true; // enables the selection

	this["bNodeSelectionToggleMode"] = this["sSelectionClientBehaviour"] === "WEB";

	this["bContentListening"] = this["sNodeEventProcessing"] === "CAPTURE"
		|| (this["sNodeSelectionClientBehaviour"] === "SMART" && this["sNodeSelectionFollowFocus"] !== "NONE");

	this["bSkipSelectionByEnter"] = this["sSelectionClientBehaviour"] === "SMART";

	this["bNodeSelectionFollowFocusKeyboard"] = this["sNodeSelectionFollowFocus"] === "KEYBOARD"
		|| this["sNodeSelectionFollowFocus"] === "BOTH";
	this["bNodeSelectionFollowFocusMouse"] = this["sNodeSelectionFollowFocus"] === "MOUSE"
		|| this["sNodeSelectionFollowFocus"] === "BOTH";

	// The primary is part of the multi selection. No visual difference.
	this["bNodeSelectionImplicitPrimary"] = this["sClientSelection"]["indexOf"]("IMPLICIT") !== -1;

	if (this["sClientSelection"] !== "NONE") {
		this["buildChildIndexInternal"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["initClientSelectionHandling"] = 0; };

/**
 * Clean for all variables and instances used by selection handling on client
 * side
 * @private
 */
UCF_Tree["prototype"]["cleanClientSelectionHandling"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["cleanClientSelectionHandling"]++; }; 
	this["bNodeSelectionFollowFocusKeyboard"] = false;
	this["bNodeSelectionFollowFocusMouse"] = false;
	this["bNodeSelectionToggleMode"] = false;
	this["bNodeSelectionByNavigation"] = false;
	this["bSkipSelectionByEnter"] = false;
	this["bNodeSelectionImplicitPrimary"] = false;
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["cleanClientSelectionHandling"] = 0; };

/**
 * Return if currently the captured event is processed
 * @public
 */
UCF_Tree["prototype"]["bIsCapturedEventProcessing"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["bIsCapturedEventProcessing"]++; }; 
	return this["bCapturedEventProcessing"];
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["bIsCapturedEventProcessing"] = 0; };

/**
 * Event handler
 *
 * @private
 * @param {UCF_BrowserEvent}   oBrowserEvent the browser event object
 */
UCF_Tree["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Tree.js(889): onmousedown"); };

	if (this["bCancelHandlerProcessing"](oBrowserEvent))
		return;

	if (oBrowserEvent["eGetMouseButtonState"]() !== oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"])
		return;

	// Sometimes IE does not clear selection text when mouse is pressed.
	// Therefore we call it explicitly
	// See I-1786179 2010
	UCF_DomUtil["removeSelection"](document);

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["onmousedown"] = 0; };

/**
 * Returns if the event should be canceled
 *
 * @private
 * @param {UCF_BrowserEvent}   oBrowserEvent the browser event object
 */
UCF_Tree["prototype"]["bCancelHandlerProcessing"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["bCancelHandlerProcessing"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Tree.js(911): bCancelHandlerProcessing"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Tree.js(912): bCancelHandlerProcessing"); };
	// Some events are not allowed to be canceled, therefore using
	// BrowserEvent.oData
	if (oBrowserEvent["oGetData"]()["bProcessedByTreeCancel"]) {

		if (oBrowserEvent["oGetData"]()["bProcessedByTreeCancelBubbleEvent"])
			this["cancelBubbleEventInternal"](oBrowserEvent);

		if (oBrowserEvent["oGetData"]()["bProcessedByTreeCancelEvent"])
			this["cancelEventInternal"](oBrowserEvent);

		return true;
	} else {
		oBrowserEvent["oGetData"]()["bProcessedByTreeCancel"] = true;
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["bCancelHandlerProcessing"] = 0; };

/**
 * Cancel the bubble event internally
 *
 * @private
 * @param {UCF_BrowserEvent}  oBrowserEvent the browser event object
 */
UCF_Tree["prototype"]["cancelBubbleEventInternal"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["cancelBubbleEventInternal"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Tree.js(937): cancelBubbleEventInternal"); };

	if (this["bCapturedEventProcessing"]) {
		oBrowserEvent["oGetData"]()["bProcessedByTreeCancelBubbleEvent"] = true;
	} else {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["cancelBubbleEventInternal"] = 0; };

/**
 * Cancel event
 *
 * @private
 * @param {UCF_BrowserEvent}   oBrowserEvent the browser event object
 */
UCF_Tree["prototype"]["cancelEventInternal"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["cancelEventInternal"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent != null, "oBrowserEvent != null", "Tree.js(953): cancelEventInternal"); };

	if (this["bCapturedEventProcessing"]) {
		oBrowserEvent["oGetData"]()["bProcessedByTreeCancelEvent"] = true;
	} else {
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["cancelEventInternal"] = 0; };

/**
 * Main routine to handle and fire the select event
 *
 * @private
 * @param {Object} oNode Node which has been clicked
 * @param {number} eAccessType Enumeration how the node was accessed e.g. mouse
 * @param {string} sSelectAccess Determines the selection type e.g. RANGE or TOGGLE
 *
 */
UCF_Tree["prototype"]["internalFireNodeSelectDirect"] = function(oNode, eAccessType, sSelectAccess) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["internalFireNodeSelectDirect"]++; };  // eslint-disable-line complexity
	if (!oNode["bIsClickable"] || !oNode["bEnabled"])
		return;

	// check if selection was set on server side, cannot be done in constructor
	if (!this["oSelectedNode"]) {
		//initialize Reference node for selection
		if (this["sReferenceNodeId"]) {
			var oRefNode = this["oLS"]["oControlFactory"]["oGetControlById"](this["sReferenceNodeId"]);
			if (__UCF_ASSERT__) { UCF_Tracer.assert(oRefNode != null, "oRefNode != null", "Tree.js(980): internalFireNodeSelectDirect"); };
			this["oSelectedNode"] = oRefNode;
		}
	}

	if (this["sClientSelection"] !== "NONE" && (this["sSelectionClientBehaviour"] === "SMART" || this["sSelectionClientBehaviour"] === "WEB")) {
		// Client side selection activated
		var bHasPrimarySelection = this["sClientSelection"]["indexOf"]("PRIMARY") !== -1,
			bHasMandatoryPrimarySelection = bHasPrimarySelection && this["sClientSelection"]["indexOf"]("MANDATORY") !== -1,
			bIsMulti = this["sClientSelection"]["indexOf"]("MULTI") !== -1,
			bHasPrimarySelectionChanged = false;

		// SINGLE has to be Primary in order to stay compatible
		if (this["sClientSelection"] === "SINGLE")
			bHasPrimarySelection = true;

		// selection only follows focus if set
		if (!this["bNodeSelectionFollowFocusMouse"] && eAccessType === this["ACCESS_TYPE"]["MOUSE"]) return;
		if (this["bNodeSelectionFollowFocusKeyboard"] && eAccessType === this["ACCESS_TYPE"]["KEYBOARD"]) return;

		if (!bIsMulti) {
			// Cleanup for access type which makes no sense for single selection
			if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"]) {
				sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
			} else if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"] && oNode["sSelection"] === "NONE") {
				sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
			}
		}

		if (this["sSelectionClientBehaviour"] === "WEB") {
			// No Primary for WEB pported
			bHasPrimarySelection = false;
			bHasMandatoryPrimarySelection = false;
			bHasPrimarySelectionChanged = false;

			// For "WEB" mode the standard access type is toggle
			if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"])
				sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"];

		} else if (this["bNodeSelectionToggleMode"]) {
			if (eAccessType === this["ACCESS_TYPE"]["KEYBOARD_NAVIGATE"]) {
				if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]) {
					return;
				} else if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]) {
					sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
				}
			} else if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]) {
				sSelectAccess = this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"];
			}
		}

		if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]) {

			if (this["sSelectionClientBehaviour"] !== "WEB") this["deselectAll"]();
			// Primary selection if set or single
			if (bHasPrimarySelection && this["sSelectionClientBehaviour"] !== "WEB") {
				oNode["select"]();
				this["fireClientPrimarySelectionChange"](this["sId"]);
			} else {
				oNode["setSelection"]("SECONDARYSELECTION");
			}
			this["oSelectedNode"] = oNode;

		} else if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"]) {
			//Start node is set to first node, when empty
			if (!this["oSelectedNode"]) this["oSelectedNode"] = this["oGetFirstNode"]();
			//special case selected node is last selected node then range is 1
			if (oNode["sId"] === this["oSelectedNode"]["sId"]) {
				this["deselectAll"](bHasPrimarySelection);
			} else {
				this["performRangeSelection"](oNode, this["oSelectedNode"], bHasPrimarySelection);
			}

		} else if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"]) {

			if (bHasMandatoryPrimarySelection && oNode["getSelection"]() === "PRIMARY")
				return;

			//apply selection type
			switch (oNode["sSelection"]) {
				case "NONE":
					if (!bIsMulti) {
						if (oNode["getSelection"] === "NONE")
							this["deselectAll"]();
					}
					if (!this["bIsPrimarySelectionSet"] && bHasPrimarySelection) { // tree has no selection set -> primary
						oNode["select"]();
						bHasPrimarySelectionChanged = true;
					} else { // tree contains primary selection already ->secondary
						// selection
						oNode["setSelection"]("SECONDARYSELECTION");
					}
					this["oSelectedNode"] = oNode;
					break;
				case "PRIMARY":
					if (!bHasMandatoryPrimarySelection)
						oNode["deselect"]();
					break;
				case "SECONDARYSELECTION":
					oNode["deselect"]();
					break;
			}

		}

		this["fireClientNodeSelect"](this["sId"], oNode["sId"], sSelectAccess);
		// Refocus to recalculate announcement after mapi call
		if (window["UCF_System"]["bIs508"]) {
			var oActiveElement = UCF_DomUtil["oGetActiveElement"]();
			if (oActiveElement)
				UCF_DomUtil["refocusDomElement"](oActiveElement);
		}

		if (bHasPrimarySelectionChanged) {
			this["fireClientPrimarySelectionChange"](this["sId"]);
		}

	} else {
		if (sSelectAccess === this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"] && oNode["sSelection"] !== "NONE") {
			this["fireNodeDeselect"](this["sId"], oNode["sId"]);
		} else {
			this["fireNodeSelect"](this["sId"], oNode["sId"], sSelectAccess);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["internalFireNodeSelectDirect"] = 0; };

/**
 * Checks the modifier keys
 *
 * @private
 * @param { int } iModifierMask
 * @param { boolean } bShift
 * @param { boolean } bCtrl
 * @param { boolean } bAlt
 * @return {boolean}
 */
UCF_Tree["prototype"]["bCheckModifierMask"] = function(iModifierMask, bShift, bCtrl, bAlt) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["bCheckModifierMask"]++; }; 
	var iModifierMaskToCheck = UCF_JsUtil["MODIFIER"]["NONE"];

	if (iModifierMask >= UCF_JsUtil["MODIFIER"]["ALL"]) {
		// mask OR operation
		return iModifierMask === UCF_JsUtil["MODIFIER"]["ALL"]
			|| !bShift
			&& !bCtrl
			&& !bAlt // NONE is allowed for every mask
			|| iModifierMask === UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT"] && bShift
			&& !bCtrl && !bAlt
			|| iModifierMask === UCF_JsUtil["MODIFIER"]["NONE_OR_CTRL"] && !bShift
			&& bCtrl && !bAlt
			|| iModifierMask === UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT_XOR_CTRL"]
			&& !bShift && !bAlt
			|| iModifierMask === UCF_JsUtil["MODIFIER"]["NONE_OR_SHIFT_XOR_CTRL"]
			&& !bCtrl && !bAlt;

	} else {
		// mask AND operation
		if (bShift)
			iModifierMaskToCheck |= 1;
		if (bCtrl)
			iModifierMaskToCheck |= 2;
		if (bAlt)
			iModifierMaskToCheck |= 4;

		return iModifierMask === iModifierMaskToCheck;
	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["bCheckModifierMask"] = 0; };

/**
 * Returns the access type from the AccessInfo object
 *
 * @private
 * @param {Object} oAccessInfo Contains the aggregated access information
 * @return {string}
 */
UCF_Tree["prototype"]["sGetEventSelectAccessType"] = function(oAccessInfo) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["sGetEventSelectAccessType"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oAccessInfo !== null, "oAccessInfo !== null", "Tree.js(1155): sGetEventSelectAccessType"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oAccessInfo) === "object", "typeof(oAccessInfo) === \"object\"", "Tree.js(1156): sGetEventSelectAccessType"); };

	var bShift = oAccessInfo["oBrowserEvent"]["bShift"](),
		bCtrl = oAccessInfo["oBrowserEvent"]["bCtrl"](),
		bAlt = oAccessInfo["oBrowserEvent"]["bAlt"]();

	if (this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["NONE"], bShift, bCtrl, bAlt))
		return this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"];
	else if (this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["SHIFT"], bShift, bCtrl, bAlt))
		return this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"];
	else if (this["bCheckModifierMask"](UCF_JsUtil["MODIFIER"]["CTRL"], bShift, bCtrl, bAlt))
		return this["EVENT_PARAM_MAP_ACCESS_TYPE"]["TOGGLE"];
	else
		return this["EVENT_PARAM_MAP_ACCESS_TYPE"]["INVALID"];
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["sGetEventSelectAccessType"] = 0; };

/**
 * deselects all nodes in the tree
 *
 * @param {boolean} bKeepPrimarySelection
 * @private
 */
UCF_Tree["prototype"]["deselectAll"] = function(bKeepPrimarySelection) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["deselectAll"]++; }; 
	if (this["aChildIndex"] == null || this["aChildIndex"]["length"] < 1) this["buildChildIndexInternal"]();
	// deselect all nodes in 1 dimensional index
	for (var i = 0, len = this["aChildIndex"]["length"]; i < len; i++) {
		if (!bKeepPrimarySelection) {
			this["aChildIndex"][i]["deselect"]();
		} else {
			if (this["aChildIndex"][i]["sSelection"] !== "PRIMARY") {
				this["aChildIndex"][i]["deselect"]();
			} else {
				// since primary selection is kept set as selected node
				this["oSelectedNode"] = this["aChildIndex"][i];
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["deselectAll"] = 0; };

/**
 * Performs a range selection within the tree

 * @private
 * @param {UCF_TreeNode} oSelectedChildNode The node on which was clicked in this event loop
 * @param { UCF_TreeNode } oSelectionLimiterNode The node, which determines the end of the selection
 * @param {boolean} bHasPrimarySelection Determines, if the primary selection should be set in the range
 *
 */
UCF_Tree["prototype"]["performRangeSelection"] = function(oSelectedChildNode, oSelectionLimiterNode, bHasPrimarySelection) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["performRangeSelection"]++; }; 

	if (!this["oSelectedNode"]) return;
	var bSelStartFound = false,
		bSelEndFound = false;

	if (this["aChildIndex"] == null || this["aChildIndex"]["length"] < 1) this["buildChildIndexInternal"]();

	// deselect all before range select (exception WEB)
	if (this["sSelectionClientBehaviour"] !== "WEB") this["deselectAll"]();

	// set secondary selections
	for (var i = 0, len = this["aChildIndex"]["length"]; i < len && !bSelEndFound; i++) {
		if (this["aChildIndex"][i]["sId"] === oSelectedChildNode["sId"] || this["aChildIndex"][i]["sId"] === oSelectionLimiterNode["sId"]) {
			if (bSelStartFound) {
				// -> done
				bSelEndFound = true;
			} else {
				bSelStartFound = true;
			}
		}

		// set lead selection on last selected node
		if (bHasPrimarySelection && this["aChildIndex"][i]["sId"] === this["oSelectedNode"]["sId"]) {
			//selection is only set if enabled
			if (this["aChildIndex"][i]["bIsClickable"] && this["aChildIndex"][i]["bEnabled"])
				this["aChildIndex"][i]["select"]();
		}

		// normal selection within range
		if (this["aChildIndex"][i]["sSelection"] === "NONE") {
			if (bSelStartFound) {
				// node in between select
				if (this["aChildIndex"][i]["bIsClickable"] && this["aChildIndex"][i]["bEnabled"])
					this["aChildIndex"][i]["setSelection"]("SECONDARYSELECTION");
			}
		}
	}

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["performRangeSelection"] = 0; };

/**
 * Builds the one dimensional index of all visible nodes in the tree
 *
 * @private
 */
UCF_Tree["prototype"]["buildChildIndexInternal"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["buildChildIndexInternal"]++; }; 
	var aChildRef = this["aGetChildNodes"]();
	var sSelection = this["sClientSelection"];

	for (var i = 0, len = aChildRef["length"]; i < len; i++) {
		aChildRef[i]["buildNodeIndex"](sSelection);
	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["buildChildIndexInternal"] = 0; };

/**
 * Destroys the child index
 *
 * @private
 */
UCF_Tree["prototype"]["destroyChildIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["destroyChildIndex"]++; }; 
	this["aChildIndex"] = new Array();
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["destroyChildIndex"] = 0; };

/**
 * Returns the position of the node within the ChildIndex
 *
 * @private
 * @param {string} sChildNodeId Id of the requested Node
 *
 * @return {int}
 */
UCF_Tree["prototype"]["iGetNodeIndex"] = function(sChildNodeId) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["iGetNodeIndex"]++; }; 
	var iNodeIndex = 0;

	if (this["aChildIndex"] == null || this["aChildIndex"]["length"] < 1)
		this["buildChildIndexInternal"]();

	for (var i = 0, len = this["aChildIndex"]["length"]; i < len; i++) {
		if (this["aChildIndex"][i]["sId"] === sChildNodeId) {
			iNodeIndex = i;
			break;
		}
	}

	return iNodeIndex;
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["iGetNodeIndex"] = 0; };

/**
 * Handle navigation
 *
 * @param {UCF_BrowserEvent}  oBrowserEvent
 * @param {int} eOperation
 */
UCF_Tree["prototype"]["handleKeyboardNavigation"] = function(oBrowserEvent, eOperation) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["handleKeyboardNavigation"]++; }; 

	var bShift = oBrowserEvent["bShift"](),
		bCtrl = oBrowserEvent["bCtrl"](),
		bNavOutOfScope = false,
		iFocusIndex = null;

	var bIsMulti = this["sClientSelection"]["indexOf"]("MULTI") !== -1;
	var bSelectionFollowFocus = (this["sNodeSelectionFollowFocus"] === "KEYBOARD" || this["sNodeSelectionFollowFocus"] === "BOTH");

	//prepare Node Index
	if (this["aChildIndex"] == null || this["aChildIndex"]["length"] < 1)
		this["buildChildIndexInternal"]();

	//focus processing
	if (this["oFocussedNode"] == null) {
		iFocusIndex = this["iGetNodeIndex"](this["oGetFirstNode"]()["sId"]);
	} else {
		iFocusIndex = this["iGetNodeIndex"](this["oFocussedNode"]["sId"]);
	}

	if (__UCF_ASSERT__) { UCF_Tracer.assert(iFocusIndex >= 0, "iFocusIndex >= 0", "Tree.js(1319): handleKeyboardNavigation"); };
	switch (eOperation) {
		case this["NAVIGATION"]["UP"]:
			if (iFocusIndex > 0) {
				iFocusIndex -= 1;
			} else {
				bNavOutOfScope = true;
			}
			break;
		case this["NAVIGATION"]["DOWN"]:
			if ((iFocusIndex + 1) < this["aChildIndex"]["length"]) {
				iFocusIndex += 1;
			} else {
				bNavOutOfScope = true;
			}
			break;
		case this["NAVIGATION"]["HOME"]:
			iFocusIndex = 0;
			break;
		case this["NAVIGATION"]["END"]:
			iFocusIndex = this["aChildIndex"]["length"] - 1;
			break;
		default:
			break;
	}

	//selection processing
	if (!bNavOutOfScope) {
		if (bShift && bIsMulti) {
			this["internalFireNodeSelectDirect"](this["aChildIndex"][iFocusIndex], this["ACCESS_TYPE"]["KEYBOARD_NAVIGATE"], this["EVENT_PARAM_MAP_ACCESS_TYPE"]["RANGE"]);
		} else if (!bCtrl && this["sSelectionClientBehaviour"] === "SMART" && bSelectionFollowFocus) {
			// smart case selection follows focus
			this["internalFireNodeSelectDirect"](this["aChildIndex"][iFocusIndex], this["ACCESS_TYPE"]["KEYBOARD_NAVIGATE"], this["EVENT_PARAM_MAP_ACCESS_TYPE"]["STANDARD"]);
		}
	}

	//focus only if within bounds
	if (!bNavOutOfScope) this["focusNode"](this["aChildIndex"][iFocusIndex]);

};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["handleKeyboardNavigation"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Tree["prototype"]["aAttributeNames"] = ["sTitle","bRootNodeIsVisible","sTooltip","bCanCollapseAll","bCanExpandAll","sVisibility","bEnabled","sScrollingMode","iScrollTop","iScrollLeft","bDropBug","sBackground","sClientSelection","sNodeSelectionFollowFocus","sSelectionClientBehaviour","sNodeEventProcessing","sReferenceNodeId","sDropTargetInfo","sCustomData","iHeadingLevel"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Tree["prototype"]["aEventNames"] = ["CollapseAll","ExpandAll","NodeSelect","ClientNodeSelect","ClientPrimarySelectionChange","NodeDeselect","NodeExpand","NodeCollapse","NodeContextMenu","NodeDrop","Scroll","Drop","Drag","DoubleClick"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Tree["prototype"]["aMethodNames"] = ["collapseAllNodes","expandAllNodes","getSelection","setSelection","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Tree["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Tree["prototype"]["bRootNodeIsVisible"] = true;

/**
 * @private
 * @type {string}
 */
UCF_Tree["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Tree["prototype"]["bCanCollapseAll"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_Tree["prototype"]["bCanExpandAll"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Tree["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_Tree["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ScrollingMode}
 */
UCF_Tree["prototype"]["sScrollingMode"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_Tree["prototype"]["iScrollTop"] = 0;

/**
 * @private
 * @type {number}
 */
UCF_Tree["prototype"]["iScrollLeft"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_Tree["prototype"]["bDropBug"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TreeBackground}
 */
UCF_Tree["prototype"]["sBackground"] = "STANDARD";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TreeSelectionMode}
 */
UCF_Tree["prototype"]["sClientSelection"] = "NONE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TreeNodeSelectionFollowFocus}
 */
UCF_Tree["prototype"]["sNodeSelectionFollowFocus"] = "MOUSE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TreeSelectionClientBehaviour}
 */
UCF_Tree["prototype"]["sSelectionClientBehaviour"] = "SMART";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TreeNodeEventProcessing}
 */
UCF_Tree["prototype"]["sNodeEventProcessing"] = "STANDARD";

/**
 * @private
 * @type {string}
 */
UCF_Tree["prototype"]["sReferenceNodeId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tree["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Tree["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {number}
 */
UCF_Tree["prototype"]["iHeadingLevel"] = 0;

//#JSCOVER_EXCL_START
/** @protected */
UCF_Tree["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["setDefaultValues"]++; }; 
	this["sTitle"] = '';
	this["bRootNodeIsVisible"] = true;
	this["sTooltip"] = '';
	this["bCanCollapseAll"] = true;
	this["bCanExpandAll"] = false;
	this["sVisibility"] = "VISIBLE";
	this["bEnabled"] = true;
	this["sScrollingMode"] = "NONE";
	this["iScrollTop"] = 0;
	this["iScrollLeft"] = 0;
	this["bDropBug"] = false;
	this["sBackground"] = "STANDARD";
	this["sClientSelection"] = "NONE";
	this["sNodeSelectionFollowFocus"] = "MOUSE";
	this["sSelectionClientBehaviour"] = "SMART";
	this["sNodeEventProcessing"] = "STANDARD";
	this["sReferenceNodeId"] = '';
	this["sDropTargetInfo"] = '';
	this["sCustomData"] = '';
	this["iHeadingLevel"] = 0;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("RootNodeIsVisible", true, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("CanCollapseAll", true, true);
		this["setClientProperty"]("CanExpandAll", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("ScrollingMode", "NONE", true);
		this["setClientProperty"]("ScrollTop", 0, true);
		this["setClientProperty"]("ScrollLeft", 0, true);
		this["setClientProperty"]("DropBug", false, true);
		this["setClientProperty"]("Background", "STANDARD", true);
		this["setClientProperty"]("ClientSelection", "NONE", true);
		this["setClientProperty"]("NodeSelectionFollowFocus", "MOUSE", true);
		this["setClientProperty"]("SelectionClientBehaviour", "SMART", true);
		this["setClientProperty"]("NodeEventProcessing", "STANDARD", true);
		this["setClientProperty"]("ReferenceNodeId", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
	}
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the tree control
 * @fires Tree::CollapseAll
 */
UCF_Tree["prototype"]["fireCollapseAll"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireCollapseAll"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Tree.js(1559): fireCollapseAll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1560): fireCollapseAll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1561): fireCollapseAll"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Tree", "CollapseAll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireCollapseAll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the tree control
 * @fires Tree::ExpandAll
 */
UCF_Tree["prototype"]["fireExpandAll"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireExpandAll"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Tree.js(1578): fireExpandAll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1579): fireExpandAll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1580): fireExpandAll"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Tree", "ExpandAll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireExpandAll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the tree control
 * @param {string} sNodeId Identifier of the tree node control
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select , TOGGLE for a selection toggle, DESELECT_ALL for deselction of all rows, SELECT_ALL for selcetion of all rows
 * @fires Tree::NodeSelect
 */
UCF_Tree["prototype"]["fireNodeSelect"] = function(sId, sNodeId, sAccessType) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeSelect"]++; }; 
	/** @type {{Id: string, NodeId: string, AccessType: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Tree.js(1601): fireNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1602): fireNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1603): fireNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNodeId != null, "sNodeId != null", "Tree.js(1604): fireNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNodeId) == "string", "typeof(sNodeId) == \"string\"", "Tree.js(1605): fireNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "Tree.js(1606): fireNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "Tree.js(1607): fireNodeSelect"); };
	mParams = {
		"Id": sId,
		"NodeId": sNodeId,
		"AccessType": sAccessType
	};
	
	if (sNodeId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sNodeId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "NodeId");
			}
		}
	
	this["fireSemanticEvent"]("Tree", "NodeSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the tree control
 * @param {string} sNodeId Identifier of the tree node control
 * @param {string} sAccessType The type of access which lead to the select event. STANDARD for the standard access, RANGE for an intended range select , TOGGLE for a selection toggle, DESELECT_ALL for deselction of all rows, SELECT_ALL for selcetion of all rows
 * @fires Tree::ClientNodeSelect
 */
UCF_Tree["prototype"]["fireClientNodeSelect"] = function(sId, sNodeId, sAccessType) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireClientNodeSelect"]++; }; 
	/** @type {{Id: string, NodeId: string, AccessType: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Tree.js(1637): fireClientNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1638): fireClientNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1639): fireClientNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNodeId != null, "sNodeId != null", "Tree.js(1640): fireClientNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNodeId) == "string", "typeof(sNodeId) == \"string\"", "Tree.js(1641): fireClientNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAccessType != null, "sAccessType != null", "Tree.js(1642): fireClientNodeSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAccessType) == "string", "typeof(sAccessType) == \"string\"", "Tree.js(1643): fireClientNodeSelect"); };
	mParams = {
		"Id": sId,
		"NodeId": sNodeId,
		"AccessType": sAccessType
	};
	
	if (sNodeId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sNodeId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "NodeId");
			}
		}
	
	this["fireSemanticEvent"]("Tree", "ClientNodeSelect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireClientNodeSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of tree
 * @fires Tree::ClientPrimarySelectionChange
 */
UCF_Tree["prototype"]["fireClientPrimarySelectionChange"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireClientPrimarySelectionChange"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Tree.js(1669): fireClientPrimarySelectionChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1670): fireClientPrimarySelectionChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1671): fireClientPrimarySelectionChange"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Tree", "ClientPrimarySelectionChange", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireClientPrimarySelectionChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the tree control
 * @param {string} sNodeId Identifier of the tree node control
 * @fires Tree::NodeDeselect
 */
UCF_Tree["prototype"]["fireNodeDeselect"] = function(sId, sNodeId) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeDeselect"]++; }; 
	/** @type {{Id: string, NodeId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Tree.js(1691): fireNodeDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1692): fireNodeDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1693): fireNodeDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNodeId != null, "sNodeId != null", "Tree.js(1694): fireNodeDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNodeId) == "string", "typeof(sNodeId) == \"string\"", "Tree.js(1695): fireNodeDeselect"); };
	mParams = {
		"Id": sId,
		"NodeId": sNodeId
	};
	
	if (sNodeId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sNodeId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "NodeId");
			}
		}
	this["fireSemanticEvent"]("Tree", "NodeDeselect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeDeselect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the tree control
 * @param {string} sNodeId Identifier of the tree node control
 * @fires Tree::NodeExpand
 */
UCF_Tree["prototype"]["fireNodeExpand"] = function(sId, sNodeId) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeExpand"]++; }; 
	/** @type {{Id: string, NodeId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Tree.js(1722): fireNodeExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1723): fireNodeExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1724): fireNodeExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNodeId != null, "sNodeId != null", "Tree.js(1725): fireNodeExpand"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNodeId) == "string", "typeof(sNodeId) == \"string\"", "Tree.js(1726): fireNodeExpand"); };
	mParams = {
		"Id": sId,
		"NodeId": sNodeId
	};
	
	if (sNodeId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sNodeId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "NodeId");
			}
		}
	this["fireSemanticEvent"]("Tree", "NodeExpand", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeExpand"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the tree control
 * @param {string} sNodeId Identifier of the tree node control
 * @fires Tree::NodeCollapse
 */
UCF_Tree["prototype"]["fireNodeCollapse"] = function(sId, sNodeId) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeCollapse"]++; }; 
	/** @type {{Id: string, NodeId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Tree.js(1753): fireNodeCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1754): fireNodeCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1755): fireNodeCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNodeId != null, "sNodeId != null", "Tree.js(1756): fireNodeCollapse"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNodeId) == "string", "typeof(sNodeId) == \"string\"", "Tree.js(1757): fireNodeCollapse"); };
	mParams = {
		"Id": sId,
		"NodeId": sNodeId
	};
	
	if (sNodeId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sNodeId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "NodeId");
			}
		}
	this["fireSemanticEvent"]("Tree", "NodeCollapse", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeCollapse"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the tree control
 * @param {string} sNodeId Identifier of the tree node control
 * @param {number} iLeft Left position where the popup menu should open
 * @param {number} iTop Top position where the popup menu should open
 * @fires Tree::NodeContextMenu
 */
UCF_Tree["prototype"]["fireNodeContextMenu"] = function(sId, sNodeId, iLeft, iTop) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeContextMenu"]++; }; 
	/** @type {{Id: string, NodeId: string, Left: number, Top: number}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 4, "arguments.length == 4", "Tree.js(1786): fireNodeContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1787): fireNodeContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1788): fireNodeContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNodeId != null, "sNodeId != null", "Tree.js(1789): fireNodeContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNodeId) == "string", "typeof(sNodeId) == \"string\"", "Tree.js(1790): fireNodeContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iLeft != null, "iLeft != null", "Tree.js(1791): fireNodeContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iLeft) == "number", "typeof(iLeft) == \"number\"", "Tree.js(1792): fireNodeContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iTop != null, "iTop != null", "Tree.js(1793): fireNodeContextMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iTop) == "number", "typeof(iTop) == \"number\"", "Tree.js(1794): fireNodeContextMenu"); };
	mParams = {
		"Id": sId,
		"NodeId": sNodeId,
		"Left": iLeft,
		"Top": iTop
	};
	
	if (sNodeId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sNodeId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "NodeId");
			}
		}
	
	
	this["fireSemanticEvent"]("Tree", "NodeContextMenu", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeContextMenu"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the tree control
 * @param {string} sNodeId Identifier of the tree node control
 * @param {string} sDropControlId Identifier of the control that was dropped the node
 * @fires Tree::NodeDrop
 */
UCF_Tree["prototype"]["fireNodeDrop"] = function(sId, sNodeId, sDropControlId) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeDrop"]++; }; 
	/** @type {{Id: string, NodeId: string, DropControlId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Tree.js(1826): fireNodeDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1827): fireNodeDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1828): fireNodeDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNodeId != null, "sNodeId != null", "Tree.js(1829): fireNodeDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNodeId) == "string", "typeof(sNodeId) == \"string\"", "Tree.js(1830): fireNodeDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropControlId != null, "sDropControlId != null", "Tree.js(1831): fireNodeDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropControlId) == "string", "typeof(sDropControlId) == \"string\"", "Tree.js(1832): fireNodeDrop"); };
	mParams = {
		"Id": sId,
		"NodeId": sNodeId,
		"DropControlId": sDropControlId
	};
	
	if (sNodeId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sNodeId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "NodeId");
			}
		}
	
	this["fireSemanticEvent"]("Tree", "NodeDrop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireNodeDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {number} iScrollTop The new position of the vertical scroll bar in pixels.
 * @param {number} iScrollLeft The new position of the horizontal scroll bar in pixels.
 * @fires Tree::Scroll
 */
UCF_Tree["prototype"]["fireScroll"] = function(sId, iScrollTop, iScrollLeft) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireScroll"]++; }; 
	/** @type {{Id: string, ScrollTop: number, ScrollLeft: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Tree.js(1860): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1861): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1862): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollTop != null, "iScrollTop != null", "Tree.js(1863): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollTop) == "number", "typeof(iScrollTop) == \"number\"", "Tree.js(1864): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iScrollLeft != null, "iScrollLeft != null", "Tree.js(1865): fireScroll"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iScrollLeft) == "number", "typeof(iScrollLeft) == \"number\"", "Tree.js(1866): fireScroll"); };
	mParams = {
		"Id": sId,
		"ScrollTop": iScrollTop,
		"ScrollLeft": iScrollLeft
	};
	
	
	
	this["fireSemanticEvent"]("Tree", "Scroll", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireScroll"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSource Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sNodeId The id of the TreeNode where the drop occured
 * @param {number} iOffset The Offset relative to the TreeNode where the drop occured (signum)
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires Tree::Drop
 */
UCF_Tree["prototype"]["fireDrop"] = function(sId, sDragSource, sDropTargetInfo, sNodeId, iOffset, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSource: string, DropTargetInfo: string, NodeId: string, Offset: number, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 12, "arguments.length == 12", "Tree.js(1898): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1899): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1900): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSource != null, "sDragSource != null", "Tree.js(1901): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSource) == "string", "typeof(sDragSource) == \"string\"", "Tree.js(1902): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "Tree.js(1903): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "Tree.js(1904): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNodeId != null, "sNodeId != null", "Tree.js(1905): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNodeId) == "string", "typeof(sNodeId) == \"string\"", "Tree.js(1906): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iOffset != null, "iOffset != null", "Tree.js(1907): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iOffset) == "number", "typeof(iOffset) == \"number\"", "Tree.js(1908): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "Tree.js(1909): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "Tree.js(1910): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "Tree.js(1911): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "Tree.js(1912): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "Tree.js(1913): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "Tree.js(1914): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "Tree.js(1915): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "Tree.js(1916): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "Tree.js(1917): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "Tree.js(1918): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "Tree.js(1919): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "Tree.js(1920): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "Tree.js(1921): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "Tree.js(1922): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSource": sDragSource,
		"DropTargetInfo": sDropTargetInfo,
		"NodeId": sNodeId,
		"Offset": iOffset,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("Tree", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires Tree::Drag
 */
UCF_Tree["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Tree.js(1963): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1964): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1965): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "Tree.js(1966): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "Tree.js(1967): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "Tree.js(1968): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "Tree.js(1969): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("Tree", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @param {string} sNodeId Identifier of the tree node control
 * @fires Tree::DoubleClick
 */
UCF_Tree["prototype"]["fireDoubleClick"] = function(sId, sNodeId) {;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string, NodeId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Tree.js(1993): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Tree.js(1994): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Tree.js(1995): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sNodeId != null, "sNodeId != null", "Tree.js(1996): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sNodeId) == "string", "typeof(sNodeId) == \"string\"", "Tree.js(1997): fireDoubleClick"); };
	mParams = {
		"Id": sId,
		"NodeId": sNodeId
	};
	
	if (sNodeId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sNodeId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "NodeId");
			}
		}
	this["fireSemanticEvent"]("Tree", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Tree["_"]["fireDoubleClick"] = 0; };

UCF_Tree.prototype["aPublicMethods"] = ["setSelection","getSelection","collapseAllNodes","expandAllNodes","bIsCapturedEventProcessing"].concat(UCF_Tree.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TreeBinding"] = function() {/* global UCF_Binding */
/// <reference path="./Binding.js"/>

/**
 * Constructor for TreeBinding
 *
 * The TreeBinding is a specific binding for trees in the model, which can be
 * used to populate Trees.
 *
 * @public
 * @class
 * @param {UCF_Model} oModel
 * @param {string} sPath the path pointing to the tree/array that should be
 * bound
 * @param {Object} [oContext] the context object for this databinding
 * @param {Array} [aFilters] predefined filter/s contained in an array
 * @param {Object} [mParameters] additional model specific parameters
 */
function UCF_TreeBinding(oModel, sPath, oContext, aFilters, mParameters) {if (__UCF_COVERAGE__) { UCF_TreeBinding["_"]["UCF_TreeBinding"]++; }; 
	if (arguments["length"] > 0) {
		UCF_Binding["apply"](this, [oModel, sPath, oContext, mParameters]);
		this["aFilters"] = aFilters;
	}
};window["UCF_TreeBinding"] = UCF_TreeBinding; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TreeBinding"); UCF_TreeBinding["_"] = {UCF_TreeBinding: 0}; }; ;
UCF_TreeBinding["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Binding"))(); UCF_TreeBinding.prototype["sClassName"] = "UCF_TreeBinding";

UCF_TreeBinding["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeBinding["_"]["destroy"]++; }; 
	this["aFilters"] = [];

	UCF_Binding.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TreeBinding["_"]["destroy"] = 0; };

// the 'abstract methods' to be implemented by child classes
/**
 * Returns the current value of the bound target
 *
 * @function
 * @name UCF_TreeBinding.prototype.getRootContexts
 * @return {Array} the array of child contexts for the root node
 *
 * @public
 */

/**
 * Returns the current value of the bound target
 *
 * @function
 * @name UCF_TreeBinding.prototype.getNodeContexts
 * @param {Object} oContext the context element of the node
 * @return {Array} the array of child contexts for the given node
 *
 * @public
 */

/**
 * Filters the tree according to the filter definitions.
 *
 * @function
 * @name UCF_TreeBinding.prototype.filter
 * @param {Array} aFilters Array of UCF_Filter objects
 *
 * @public
 */

/**
 * Attach event-handler <code>fnFunction</code> to the '_filter' event of this
 * <code>UCF_TreeBinding</code>.<br/>
 *
 * @param {function} fnFunction The function to call, when the event occurs.
 * @param {Object} [oListener] object on which to call the given function.
 * @protected
 */
UCF_TreeBinding["prototype"]["attachFilter"] = function(fnFunction, oListener) {;if (__UCF_COVERAGE__) { UCF_TreeBinding["_"]["attachFilter"]++; }; 
	this["attachEvent"]('_filter', fnFunction, oListener);
};;if (__UCF_COVERAGE__) { UCF_TreeBinding["_"]["attachFilter"] = 0; };

/**
 * Detach event-handler <code>fnFunction</code> from the '_filter' event of
 * this <code>UCF_TreeBinding</code>.<br/>
 *
 * @param {function} fnFunction The function to call, when the event occurs.
 * @param {Object} [oListener] object on which to call the given function.
 * @protected
 */
UCF_TreeBinding["prototype"]["detachFilter"] = function(fnFunction, oListener) {;if (__UCF_COVERAGE__) { UCF_TreeBinding["_"]["detachFilter"]++; }; 
	this["detachEvent"]('_filter', fnFunction, oListener);
};;if (__UCF_COVERAGE__) { UCF_TreeBinding["_"]["detachFilter"] = 0; };

/**
 * Fire event _filter to attached listeners.
 * @param {Map} [mArguments] the arguments to pass along with the event.
 * @private
 */
UCF_TreeBinding["prototype"]["_fireFilter"] = function(mArguments) {;if (__UCF_COVERAGE__) { UCF_TreeBinding["_"]["_fireFilter"]++; }; 
	this["fireEvent"]('_filter', mArguments);
};;if (__UCF_COVERAGE__) { UCF_TreeBinding["_"]["_fireFilter"] = 0; };

UCF_TreeBinding.prototype["aPublicMethods"] = ["UCF_TreeBinding"].concat(UCF_TreeBinding.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TreeDragDelegate"] = function() {/* global UCF_DragDelegate */
/// <reference path="../base/DragDelegate.js"/>
/* global UCF_HTMLGhost */
/// <reference path="../base/HTMLGhost.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDragSourceControl
 */
function UCF_TreeDragDelegate(oLS, oDragSourceControl) {if (__UCF_COVERAGE__) { UCF_TreeDragDelegate["_"]["UCF_TreeDragDelegate"]++; }; 
	UCF_DragDelegate["apply"](this, [oLS]);

	this["setDragSourceControl"](oDragSourceControl);
};window["UCF_TreeDragDelegate"] = UCF_TreeDragDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TreeDragDelegate"); UCF_TreeDragDelegate["_"] = {UCF_TreeDragDelegate: 0}; }; ;
UCF_TreeDragDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragDelegate"))(); UCF_TreeDragDelegate.prototype["sClassName"] = "UCF_TreeDragDelegate";

UCF_TreeDragDelegate["prototype"]["oGetGhost"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDragDelegate["_"]["oGetGhost"]++; }; 

	var oControl = oBrowserEvent["oGetSourceControl"]();
	var oControlDomRef = oControl["oDomRef"];

	var oContainer = document["createElement"]("div");

	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oContainer, oControl["oDomRef"]["innerHTML"]);
	UCF_DomUtil["setClass"](oContainer, "urTreNSel");

	// TODO: replace by UCF_DomUtil.nextSibling
	if (oControlDomRef["nextSibling"] && oControlDomRef["nextSibling"]["id"] === oControlDomRef["id"] + "-child")
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](oContainer, oContainer["innerHTML"] + oControlDomRef["nextSibling"]["innerHTML"]);

	var oGhost = new (UCF_ClassLoader["oGetClass"]("UCF_HTMLGhost"))(oContainer);
	oGhost["setOffset"](12, 12);

	return oGhost;

};;if (__UCF_COVERAGE__) { UCF_TreeDragDelegate["_"]["oGetGhost"] = 0; };

UCF_TreeDragDelegate["prototype"]["bIsDragPossible"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDragDelegate["_"]["bIsDragPossible"]++; }; 

	var oTreeNode = oBrowserEvent["oGetSourceControl"]();

	if (oTreeNode["sClassName"] !== "UCF_TreeNode")
		return false;

	return oTreeNode["sSelection"] !== "NONE";

};;if (__UCF_COVERAGE__) { UCF_TreeDragDelegate["_"]["bIsDragPossible"] = 0; };

/**
 * do not return the tree but the selected tree node
 */

UCF_TreeDragDelegate["prototype"]["oGetDragSourceControl"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDragDelegate["_"]["oGetDragSourceControl"]++; }; 

	var oControl = oBrowserEvent["oGetSourceControl"]();

	return oControl;
};;if (__UCF_COVERAGE__) { UCF_TreeDragDelegate["_"]["oGetDragSourceControl"] = 0; };

};
sap["ls"]["preload"]["UCF_TreeDropDecorator"] = function() {/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_LineDecorator */
/// <reference path="./LineDecorator.js"/>

/**
 * @class
 * 
 * @param {UCF_Tree} oTree
 */
function UCF_TreeDropDecorator(oTree) {if (__UCF_COVERAGE__) { UCF_TreeDropDecorator["_"]["UCF_TreeDropDecorator"]++; }; 

	UCF_LineDecorator["apply"](this, [oTree, true]);
	this["setId"](oTree["sId"] + "-linedecorator");

	// needed for event bubbling in FF

	// FF2 has problems when decorator is appended to control
	// enlarging space below tree table
	if (UCF_UserAgent["bIsGecko"]())
		this["oParentContainer"] = oTree["oLS"]["oGetRootRef"]();

};window["UCF_TreeDropDecorator"] = UCF_TreeDropDecorator; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TreeDropDecorator"); UCF_TreeDropDecorator["_"] = {UCF_TreeDropDecorator: 0}; }; ;
UCF_TreeDropDecorator["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LineDecorator"))(); UCF_TreeDropDecorator.prototype["sClassName"] = "UCF_TreeDropDecorator";

UCF_TreeDropDecorator["prototype"]["cleanUp"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDecorator["_"]["cleanUp"]++; }; 
	this["hide"]();

};;if (__UCF_COVERAGE__) { UCF_TreeDropDecorator["_"]["cleanUp"] = 0; };

};
sap["ls"]["preload"]["UCF_TreeDropDelegate"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_DropDelegate */
/// <reference path="../base/DropDelegate.js"/>
/* global UCF_DragSession */
/// <reference path="../base/DragSession.js"/>
/* global UCF_TreeDropDecorator */
/// <reference path="../decorators/TreeDropDecorator.js"/>

/**
 * @class
 * @param {UCF_LS} oLS
 * @param {UCF_Control} oDropTargetControl
 */
function UCF_TreeDropDelegate(oLS, oDropTargetControl) {if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["UCF_TreeDropDelegate"]++; }; 

	UCF_DropDelegate["apply"](this, [oLS]);

	this["oLS"] = oLS;
	this["setDropTargetControl"](oDropTargetControl);
	this["bDropAllowed"] = false;
	this["sDTI"] = null;
	this["sDT"] = null;

};window["UCF_TreeDropDelegate"] = UCF_TreeDropDelegate; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TreeDropDelegate"); UCF_TreeDropDelegate["_"] = {UCF_TreeDropDelegate: 0}; }; ;
UCF_TreeDropDelegate["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_DropDelegate"))(); UCF_TreeDropDelegate.prototype["sClassName"] = "UCF_TreeDropDelegate";
/**
 * @override
 */
UCF_TreeDropDelegate["prototype"]["oCreateDropDecorator"] = function () {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["oCreateDropDecorator"]++; }; 

	return new (UCF_ClassLoader["oGetClass"]("UCF_TreeDropDecorator"))(this["oDropTargetControl"]);

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["oCreateDropDecorator"] = 0; };

UCF_TreeDropDelegate["prototype"]["onlsdragenter"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdragenter"]++; }; 

	var sHint = this["oLS"]["oBrowserWindow"]["oDragAndDropManager"]["oDragSession"]["sHint"];

	// eslint-disable-next-line @ur/no-memory-leaks
	this["sTreeDropLevel"] = "";
	this["sTreeDropLevel"] = UCF_JsUtil["oJsonParse"](sHint);

	this["onlsdragover"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdragenter"] = 0; };

UCF_TreeDropDelegate["prototype"]["onlsdrop"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdrop"]++; }; 

	if (this["oDropDecorator"])
		this["oDropDecorator"]["hide"]();

	if (this["bDropAllowed"]) {
		UCF_DropDelegate.prototype["onlsdrop"]["apply"](this, arguments);
		this["unmarkHoveredNode"]();
	} else {
		//the hovered tree node
		var oHoveredTreeNodeDomRef = UCF_DomUtil["oGetParentByAttribute"](oBrowserEvent["oGetSource"](), "ct", "TRN");

		if (!oHoveredTreeNodeDomRef) {
			var oHoveredTreeDomRef = UCF_DomUtil["oGetParentByTagName"](oBrowserEvent["oGetSource"](), "TABLE");
			if (oHoveredTreeDomRef && oHoveredTreeDomRef["className"]["indexOf"]("urTreHead") !== -1) {
				var sTreeDTI = this["oDropTargetControl"]["sDropTargetInfo"];
				if (sTreeDTI) {
					var oTreeDTI = this["oDropTargetControl"]["oGetControlById"](sTreeDTI);
					if (oTreeDTI && !oTreeDTI["bGetEventBubbling"]()) oBrowserEvent["cancelBubble"]();
				}
			}
		} else {
			if (this["sDTI"]) {
				var oDTI = this["oDropTargetControl"]["oGetControlById"](this["sDTI"]);
				if (oDTI && !oDTI["bGetEventBubbling"]()) oBrowserEvent["cancelBubble"]();
			}
		}
	}

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdrop"] = 0; };

UCF_TreeDropDelegate["prototype"]["forbidDrop"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["forbidDrop"]++; }; 

	//remove hover style
	this["unmarkHoveredNode"]();
	this["oDropDecorator"]["hide"]();
	this["bDropAllowed"] = false;

	oBrowserEvent["oDragAndDropManager"]["cleanUpDropArea"]();

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["forbidDrop"] = 0; };

/**
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_TreeDropDelegate["prototype"]["onlsdragleave"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdragleave"]++; }; 

	this["forbidDrop"](oBrowserEvent);

	//the hovered tree node
	var oHoveredTreeNodeDomRef = UCF_DomUtil["oGetParentByAttribute"](oBrowserEvent["oGetSource"](), "ct", "TRN");

	if (!oHoveredTreeNodeDomRef) {
		var oHoveredTreeDomRef = UCF_DomUtil["oGetParentByTagName"](oBrowserEvent["oGetSource"](), "TABLE");
		if (oHoveredTreeDomRef && oHoveredTreeDomRef["className"]["indexOf"]("urTreHead") !== -1) {
			var sTreeDTI = this["oDropTargetControl"]["sDropTargetInfo"];
			if (sTreeDTI) {
				var oTreeDTI = this["oDropTargetControl"]["oGetControlById"](sTreeDTI);
				if (oTreeDTI && !oTreeDTI["bGetEventBubbling"]()) oBrowserEvent["cancelBubble"]();
			}
		}
	} else {
		if (this["sDTI"]) {
			var oDTI = this["oDropTargetControl"]["oGetControlById"](this["sDTI"]);
			if (oDTI && !oDTI["bGetEventBubbling"]()) oBrowserEvent["cancelBubble"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdragleave"] = 0; };
UCF_TreeDropDelegate["prototype"]["markHovered"] = function (oTreeNode) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["markHovered"]++; }; 

	this["oMarkedNode"] = oTreeNode;

	UCF_DomUtil["addClass"](oTreeNode["oDomRef"], "urTreNHov");
};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["markHovered"] = 0; };

UCF_TreeDropDelegate["prototype"]["unmarkHoveredNode"] = function (oTreeNode) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["unmarkHoveredNode"]++; }; 

	if (!this["oMarkedNode"])
		return;

	UCF_DomUtil["removeClass"](this["oMarkedNode"]["oDomRef"], "urTreNHov");
	this["oMarkedNode"] = null;
};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["unmarkHoveredNode"] = 0; };

UCF_TreeDropDelegate["prototype"]["onlsdragover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdragover"]++; }; 

	var oDragAndDropManager = oBrowserEvent["oDragAndDropManager"];
	var oDTI;
	if (!this["oDropDecorator"]) {
		this["oDropDecorator"] = this["oCreateDropDecorator"]();
		this["oDropDecorator"]["init"](oDragAndDropManager["oDragSession"]);
		this["oDropDecorator"]["hide"]();
	}

	//the hovered tree node
	var oHoveredTreeNodeDomRef = UCF_DomUtil["oGetParentByAttribute"](oBrowserEvent["oGetSource"](), "ct", "TRN");

	if (!oHoveredTreeNodeDomRef) {
		var oHoveredTreeDomRef = UCF_DomUtil["oGetParentByTagName"](oBrowserEvent["oGetSource"](), "TABLE");
		if (oHoveredTreeDomRef && oHoveredTreeDomRef["className"]["indexOf"]("urTreHead") !== -1) {
			var sTreeDTI = this["oDropTargetControl"]["sDropTargetInfo"];
			if (sTreeDTI) {
				var oTreeDTI = this["oDropTargetControl"]["oGetControlById"](sTreeDTI);
				if (oTreeDTI && !oTreeDTI["bGetEventBubbling"]()) oBrowserEvent["cancelBubble"]();
			}
		}
		return;
	}

	var oContainer = document["getElementById"](this["oDropTargetControl"]["sId"] + "-scrl");
	if (!oContainer)
		oContainer = this["oDropTargetControl"]["oDomRef"];

	var oHoveredTreeNode = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oHoveredTreeNodeDomRef, true),
		oRect = UCF_DomUtil["oGetObjectRect"](oHoveredTreeNodeDomRef),
		iMouseY = oBrowserEvent["iPageY"](),
		oInnerSpan = document["getElementById"](oHoveredTreeNode["sId"] + "-cnt-start"),
		oInnerRect = UCF_DomUtil["oGetObjectRect"](oInnerSpan["parentNode"]["parentNode"]),
		oViewPort = UCF_DomUtil["oGetObjectRect"](oContainer),
		iLeft = oInnerRect["left"] - (window["UCF_System"]["bIsRTL"] ? 21 : 0),
		iWidth = oContainer["clientWidth"] - (oInnerRect["left"] - oViewPort["left"]),
		//height is divided in upper quarter, lower quarter and the middle
		iDivideBy = 2;

	if (oHoveredTreeNode["bHasChildren"] || !this["oDropTargetControl"]["bDropBug"]) {
		// var oDragSession = oDragAndDropManager.oDragSession,
		//	iMouseButton = oDragSession.iGetMouseButtonState();

		if (this["bCanDropOnDTIById"](oHoveredTreeNode["sDropTargetInfo"], oBrowserEvent))
			iDivideBy = 4;

	}

	// mouse in upper region
	if (iMouseY < oRect["top"] + oRect["height"] / iDivideBy) {
		this["oDropDecorator"]["setBounds"](iLeft, oRect["top"], iWidth);
		this["iOffset"] = -1;

	}
	// mouse in lower region
	else if (iMouseY >= oRect["top"] + oRect["height"] - oRect["height"] / iDivideBy) {

		var iTop = oRect["top"] + oRect["height"] - (UCF_UserAgent["bIsFirefox"](2) ? 0 : 4);
		this["oDropDecorator"]["setBounds"](iLeft, iTop, iWidth);
		this["iOffset"] = 1;
	}
	// mouse directly on node
	else {
		this["iOffset"] = 0;

	}

	if (this["iOffset"] !== 0 && !this["oDropTargetControl"]["bDropBug"]) {
		this["sDTI"] = oHoveredTreeNode["oGetParent"]()["sDropTargetInfo"];
		this["oDT"] = oHoveredTreeNode["oGetParent"]();
		// prevent dropping before or after root node
		if (oHoveredTreeNode["oGetParent"]() === this["oDropTargetControl"] && !this["oDropTargetControl"]["bRootNodeIsVisible"]) {
			this["sDTI"] = this["oDropTargetControl"]["oDomRef"]["getAttribute"]("sRootNodeDropTargetInfo");
		}

	} else {
		this["sDTI"] = oHoveredTreeNode["sDropTargetInfo"];
		this["oDT"] = oHoveredTreeNode;
	}

	//treenode on which the drop occurs
	this["oDropTreeNode"] = oHoveredTreeNode;
	if (!UCF_JsUtil["bInstanceOf"](this["oDT"], "UCF_TreeNode")) this["iDTNodeLevel"] = 0;
	else this["iDTNodeLevel"] = this["oDT"]["iLevel"];
	if (this["iOffset"] !== 0) this["iDTNodeLevel"]++;

	if (this["bCanDropOnDTIById"](this["sDTI"], oBrowserEvent) && this["bIsValidDropLevel"]()) {
		oDTI = this["oDropTargetControl"]["oGetControlById"](this["sDTI"]);
		var sDropTags = oDTI["sGetTags"]();

		this["sTags"] = sDropTags;

		this["unmarkHoveredNode"]();
		if (this["iOffset"] === 0) {
			this["oDropDecorator"]["hide"]();
			this["markHovered"](oHoveredTreeNode);

		} else {
			this["oDropDecorator"]["show"]();
		}

		oDragAndDropManager["initDropArea"](
			UCF_DragSession["DROP_TYPE"]["STANDARD"],
			sDropTags,
			this["oDropDecorator"]
		);

		this["bDropAllowed"] = true;

		//if control handles this event it should always cancel bubble
		//to avoid ambiguities (e.g. nested drop targets)
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["bHandled"] = true;
		return;

	} else {
		if (this["bDropAllowed"])
			this["forbidDrop"](oBrowserEvent);
	}

	if (this["sDTI"]) {
		oDTI = this["oDropTargetControl"]["oGetControlById"](this["sDTI"]);
		if (oDTI && !oDTI["bGetEventBubbling"]()) oBrowserEvent["cancelBubble"]();
	}

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdragover"] = 0; };

UCF_TreeDropDelegate["prototype"]["bCanDropOnDTIById"] = function (sDTIId, oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["bCanDropOnDTIById"]++; }; 

	if (sDTIId) {
		var oDTI = this["oDropTargetControl"]["oGetControlById"](sDTIId);
		if (oDTI) {
			var sDropTags = oDTI["sGetTags"]();

			if (oBrowserEvent["oDragAndDropManager"]["bGetDropAllowed"](sDropTags)) {
				var oDragSession = oBrowserEvent["oDragAndDropManager"]["oDragSession"],
					iMouseButton = oDragSession["iGetMouseButtonState"]();

				if (iMouseButton === oDragSession["MOUSE_BUTTON_STATES"]["RIGHT"])
					return oDTI["bSupportRightMouseButton"];

				return true;

			}
		}
	}

	return false;

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["bCanDropOnDTIById"] = 0; };

UCF_TreeDropDelegate["prototype"]["bIsValidDropLevel"] = function () {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["bIsValidDropLevel"]++; }; 

	if (this["sTreeDropLevel"]) {
		if (this["iDTNodeLevel"] === parseInt(this["sTreeDropLevel"])) return true;
		else return false;
	} else return true;

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["bIsValidDropLevel"] = 0; };

UCF_TreeDropDelegate["prototype"]["onlsdragscroll"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdragscroll"]++; }; 

	if (this["oDropDecorator"])
		this["oDropDecorator"]["update"](oBrowserEvent);

	//the hovered tree node
	var oHoveredTreeNodeDomRef = UCF_DomUtil["oGetParentByAttribute"](oBrowserEvent["oGetSource"](), "ct", "TRN");

	if (!oHoveredTreeNodeDomRef) {
		var oHoveredTreeDomRef = UCF_DomUtil["oGetParentByTagName"](oBrowserEvent["oGetSource"](), "TABLE");

		if (oHoveredTreeDomRef && oHoveredTreeDomRef["className"]["indexOf"]("urTreHead") !== -1) {
			var sTreeDTI = this["oDropTargetControl"]["sDropTargetInfo"];
			if (sTreeDTI) {
				var oTreeDTI = this["oDropTargetControl"]["oGetControlById"](sTreeDTI);
				if (oTreeDTI && !oTreeDTI["bGetEventBubbling"]()) oBrowserEvent["cancelBubble"]();
			}
		}
	} else {
		if (this["sDTI"]) {
			var oDTI = this["oDropTargetControl"]["oGetControlById"](this["sDTI"]);
			if (oDTI && !oDTI["bGetEventBubbling"]()) oBrowserEvent["cancelBubble"]();
		}
	}

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdragscroll"] = 0; };

UCF_TreeDropDelegate["prototype"]["sGetDropTags"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["sGetDropTags"]++; }; 

	return this["sTags"];

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["sGetDropTags"] = 0; };

UCF_TreeDropDelegate["prototype"]["bSupportsRightMouseButton"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["bSupportsRightMouseButton"]++; }; 

	var oDropTargetControl = this["oGetTagRelevantNode"](oBrowserEvent);

	var sDropTargetInfoId = oDropTargetControl["sDropTargetInfo"];
	if (!sDropTargetInfoId)
		return false;

	var oDropTargetInfoControl = this["oDropTargetControl"]["oGetControlById"](sDropTargetInfoId);
	if (!oDropTargetInfoControl)
		return false;

	return oDropTargetInfoControl["bSupportRightMouseButton"];

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["bSupportsRightMouseButton"] = 0; };

UCF_TreeDropDelegate["prototype"]["oGetDropTargetControl"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["oGetDropTargetControl"]++; }; 

	return this["oDropTreeNode"];

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["oGetDropTargetControl"] = 0; };

UCF_TreeDropDelegate["prototype"]["fGetDropCallBack"] = function (oDragSession) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["fGetDropCallBack"]++; }; 

	var sDropTargetInfoId = this["oDropTreeNode"]["sDropTargetInfo"],
		oTree = this["oDropTargetControl"],
		sTreeNodeId = this["oDropTreeNode"]["sId"],
		iOffset = this["iOffset"],
		sDragSourceId = oDragSession["sGetDragSourceId"](),
		sDragTags = oDragSession["sGetDragTags"](),
		that = this,
		iMouseButtonState = oDragSession["iGetMouseButtonState"](),
		oDropPosition = oDragSession["oGetDropPosition"](),
		iPosX = oDropPosition["left"],
		iPosY = oDropPosition["top"];

	return function (sDragData, sMimeType) {

		if (that["oDropDecorator"])
			that["oDropDecorator"]["hide"]();

		oTree["fireDrop"](
			oTree["sId"],
			sDragSourceId,
			sDropTargetInfoId,
			sTreeNodeId,
			iOffset,
			sDragData,
			sMimeType,
			sDragTags,
			iMouseButtonState,
			iPosX,
			iPosY,
			oDragSession["eGetDropEffect"]()
		);
	};

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["fGetDropCallBack"] = 0; };

UCF_TreeDropDelegate["prototype"]["onlsdraghover"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdraghover"]++; }; 

	var oControl = oBrowserEvent["oGetSourceControl"]();
	if (!oControl)
		return;

	if (oControl["sClassName"] !== "UCF_TreeNode")
		return;

	//the expand / collapse icon
	if (oBrowserEvent["oGetSource"]()["id"] !== oControl["sId"] + "-exp")
		return;

	if (this["oDropTargetControl"]["bOpened"])
		return;

	oControl["expandInternal"]();

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["onlsdraghover"] = 0; };

UCF_TreeDropDelegate["prototype"]["oGetDomRefToBeFocussed"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["oGetDomRefToBeFocussed"]++; }; 

	var oDomRefId = this["oDropTreeNode"]["oDomRef"]["id"] + "-cnt-start",
		oDomRef = UCF_DomUtil["$"](oDomRefId);

	if (oDomRef) {
		UCF_DomUtil["setTabIndex"](oDomRef, 0);
	}

	return oDomRef ? oDomRef : UCF_DropDelegate.prototype["oGetDomRefToBeFocussed"]["call"](this, oBrowserEvent);

};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["oGetDomRefToBeFocussed"] = 0; };

/**
 * destructor
 */
UCF_TreeDropDelegate["prototype"]["destroy"] = function () {;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["destroy"]++; }; 
	this["sDTI"] = null;
	this["oMarkedNode"] = null;
	this["iOffset"] = null;
	this["oDT"] = null;
	this["oDropTreeNode"] = null;
	this["iDTNodeLevel"] = null;
	this["sTags"] = null;
	UCF_DropDelegate.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TreeDropDelegate["_"]["destroy"] = 0; };

};
sap["ls"]["preload"]["UCF_TreeNode"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_AccessibilityHelper */
/// <reference path="../helper/AccessibilityHelper.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TreeNode(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["UCF_TreeNode"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "TreeNode.js(36): UCF_TreeNode"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef !== null, "oDomRef !== null", "TreeNode.js(37): UCF_TreeNode"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TreeNode.js(38): UCF_TreeNode"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oTree"] = this["oGetTree"]();
	this["oExpanderRef"] = UCF_DomUtil["$"](this["sId"] + "-exp");
	this["oContentRef"] = UCF_DomUtil["$"](this["sId"] + "-cnt-start");
	this["oChildrenRef"] = UCF_DomUtil["$"](this["sId"] + "-child");
	this["oFocusDomRef"] = this["oContentRef"];

	this["oAnimation"] = null;

	this["allowTextSelection"]();

	//	if (this.sDragSourceInfo)
	//		this.addDelegate(new UCF_TreeNodeDragDelegate(oLS,this));
	//
	//	if (this.sDropTargetInfo)
	//		this.addDelegate(new UCF_TreeNodeDropDelegate(oLS,this));

};window["UCF_TreeNode"] = UCF_TreeNode; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TreeNode"); UCF_TreeNode["_"] = {UCF_TreeNode: 0}; }; ;
UCF_TreeNode["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TreeNode.prototype["sClassName"] = "UCF_TreeNode";

/**
 * Access types
 */
UCF_TreeNode["prototype"]["ACCESS_TYPE"] = {
	"NONE": 0,
	"MOUSE": 1,
	"KEYBOARD_SELECT": 2,
	"KEYBOARD_EXPAND": 3,
	"KEYBOARD_COLLAPSE": 4,
	"DRAG_START": 5,
	"DRAG": 6,
	"DRAG_END": 7,
	"DRAG_OVER": 8,
	"DROP": 9,
	"DRAG_ENTER": 10,
	"DRAG_LEAVE": 11,
	"S_508": 12,
	"HOTKEY": 13,
	"KEYBOARD_ENTER": 14,
	"KEYBOARD_NAVIGATE": 15
};

/**
 * Actions
 */
UCF_TreeNode["prototype"]["ACTION"] = {
	"NONE": "",
	"CELL_SELECT": "CSEL",
	"HEADER_ICON": "HCICO",
	"HEADER_SORT": "HCSORT",
	"HIERARCHY_EXPAND": "HICEXP",
	"HIERARCHY_COLLAPSE": "HICCOL",
	"HIERARCHY_ALTERNATIVE": "HICALT",
	"SELECTION_MENU_OPEN": "SELMNUOPN",
	"HEADER_ACTION_MENU_OPEN": "HCACTMNUOPN",
	"FILTER": "FLTR",
	"FILTER_ENTER": "FLTR_ENTER",
	"COL_RESIZE": "CRESIZE",
	"COL_DRAG": "CDRAG",
	"TABLE_V_RESIZE": "TVRESIZE",
	"TABLE_END": "TABLE_END",
	"CONFIG": "CONFIG"
};

/**
 * Subcontrol types
 */
UCF_TreeNode["prototype"]["SUBCONTROL"] = {
	"NONE": false,
	"TABLE": "ST",
	"HEADER_CELL": "HC",
	"STANDARD_CELL": "STC",
	"HIERARCHY_CELL": "HIC",
	"MATRIX_CELL": "MC",
	"SELECTION_CELL": "SC",
	"POPIN_CELL": "PC"
};

/**
 * Handles the mousedown event
 * For unselected nodes the selection is done in the mousedown to get the node selected before
 * starting a drag operation. For selected nodes there is no need to send a server request
 * immediately, so these are handled in the onclick.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TreeNode["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onmousedown"]++; }; 
	var oAccessInfo;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TreeNode.js(131): onmousedown"); };

	// only handle left-button clicks
	if (oBrowserEvent["eGetMouseButtonState"]() !== oBrowserEvent["MOUSE_BUTTON_STATE"]["Left"]) {
		return;
	}
	if (this["oTree"]["bCancelHandlerProcessing"](oBrowserEvent)) return;

	if (!this["oTree"]["bIsCapturedEventProcessing"]()) {
		oBrowserEvent["cancelBubble"]();
		//oBrowserEvent.cancel();
	}

	this["oTree"]["focusNode"](this);

	if (!this["bEnabled"]) return;

	if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"]();
	}

	var oSourceRef = oBrowserEvent["oGetSource"]();
	if (this["bHasChildren"] && oSourceRef === this["oExpanderRef"]) {
		this["toggle"]();
		return;
	}
	//property used to avoid double events fired in mouse down + click
	this["sOldSelection"] = this["sSelection"];
	if (oBrowserEvent["bCtrl"]() && !oBrowserEvent["bAlt"]() && !oBrowserEvent["bShift"]()) {
		//get access info and toggle
		oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);
		this["oTree"]["toggleNode"](this, oAccessInfo);
	} else if (!oBrowserEvent["bCtrl"]() && !oBrowserEvent["bAlt"]() && this["sSelection"] === "NONE") {
		//select access
		oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);
		this["oTree"]["selectNode"](this, oAccessInfo);
	}

	//	var oNodeTemp = UCF_DomUtil.$(this.sId);
	var oNodeTemp = this["oDomRef"];
	//	if (UCF_DomUtil.bHasClass(oNodeTemp, "urTreNoDsbl")) return;
	UCF_DomUtil["addClass"](oNodeTemp, "lsTreNodeDown");

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onmousedown"] = 0; };

UCF_TreeNode["prototype"]["onmouseup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onmouseup"]++; }; 
	//	var oNodeTemp = UCF_DomUtil.$(this.sId);
	var oNodeTemp = this["oDomRef"];
	UCF_DomUtil["removeClass"](oNodeTemp, "lsTreNodeDown");
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onmouseup"] = 0; };

UCF_TreeNode["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onmouseout"]++; }; 
	//	var oNodeTemp = UCF_DomUtil.$(this.sId);
	var oNodeTemp = this["oDomRef"];
	UCF_DomUtil["removeClass"](oNodeTemp, "lsTreNodeDown");
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onmouseout"] = 0; };

/**
 * Handles the click event
 * Cancel bubbling of click to avoid parent controls to handle tree clicks
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TreeNode["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TreeNode.js(197): onclick"); };

	if (this["oTree"]["bCancelHandlerProcessing"](oBrowserEvent)) return;

	if (!this["oTree"]["bIsCapturedEventProcessing"]()) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}

	if (!this["bEnabled"]) return;

	var oSourceRef = oBrowserEvent["oGetSource"]();
	if (this["bHasChildren"] && oSourceRef === this["oExpanderRef"]) return;

	if (!oBrowserEvent["bCtrl"]() && !oBrowserEvent["bAlt"]() //	&& !oBrowserEvent.bShift()
		&& this["sOldSelection"] !== "NONE" /*&& this.oTree.sClientSelection === "NONE"*/ ) {
		var oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["MOUSE"]);
		this["oTree"]["selectNode"](this, oAccessInfo);
	}
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onclick"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TreeNode["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TreeNode.js(225): ondblclick"); };

	if (!this["bEnabled"] || !this["oTree"]["bEnabled"] || !this["oTree"]["mEvents"]["DoubleClick"]) return;

	this["oTree"]["fireDoubleClick"](this["oTree"]["sId"], this["sId"]);
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["ondblclick"] = 0; };

/**
 * Handles the contextmenu event.
 * Adds a special parameter to the event object to suppress the WD context menu.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TreeNode["prototype"]["oncontextmenu"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oncontextmenu"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TreeNode.js(242): oncontextmenu"); };

	// only focus node for direct node event, not bubbled events
	var oSource = oBrowserEvent["oGetSourceControl"]();
	if (oSource === this) this["oTree"]["focusNode"](this);

	if (!this["bEnabled"]) return;
	if (!this["bHasPopupMenu"]) return;
	if (!UCF_DomUtil["bContains"](this["oDomRef"], oBrowserEvent["oGetSource"]())) return;

	var iPosX = oBrowserEvent["iClientX"]() || 0,
		iPosY = oBrowserEvent["iClientY"]() || 0,
		oRect = UCF_DomUtil["oGetObjectRect"](oBrowserEvent["oGetSource"]());

	// if mouse is outside the source element (= contextmenu triggered by keyboard),
	// calculate a position relative to the source element
	if (iPosX < oRect["left"] || iPosX > oRect["left"] + oRect["width"] ||
		iPosY < oRect["top"] || iPosY > oRect["top"] + oRect["height"]) {

		iPosX = oRect["left"];
		iPosY = oRect["top"] + oRect["height"];
	}

	this["openPopupMenuAtPosition"](iPosX, iPosY);

	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oncontextmenu"] = 0; };

/**
 * Expand triggered by the keyboard expands the focused node
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_TreeNode["prototype"]["onlsexpand"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsexpand"]++; }; 

	oBrowserEvent["cancelBubble"]();

	this["expandInternal"]();

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsexpand"] = 0; };

/**
 * Collapse triggered by the keyboard collapses the focused node
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_TreeNode["prototype"]["onlscollapse"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlscollapse"]++; }; 

	oBrowserEvent["cancelBubble"]();

	this["collapseInternal"]();

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlscollapse"] = 0; };

/**
 * The right key (dependant on RTL mode) expands or collapses
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_TreeNode["prototype"]["onlsright"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsright"]++; }; 

	oBrowserEvent["cancelBubble"]();

	if (window["UCF_System"]["bIsRTL"]) this["collapseInternal"]();
	else this["expandInternal"]();

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsright"] = 0; };

/**
 * The left key (dependant on RTL mode) expands or collapses
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_TreeNode["prototype"]["onlsleft"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsleft"]++; }; 

	oBrowserEvent["cancelBubble"]();

	if (window["UCF_System"]["bIsRTL"]) this["expandInternal"]();
	else this["collapseInternal"]();

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsleft"] = 0; };

/**
 * Event Handler
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_TreeNode["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsselect"]++; }; 
	if (this["oTree"]["bCancelHandlerProcessing"](oBrowserEvent)) return;

	if (!this["oTree"]["bIsCapturedEventProcessing"]()) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}

	var oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["KEYBOARD_SELECT"]);
	this["oTree"]["toggleNode"](this, oAccessInfo);

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsselect"] = 0; };

/**
 * Event Handler
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 */
UCF_TreeNode["prototype"]["onlsselectmodifier"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsselectmodifier"]++; }; 
	if (this["oTree"]["bCancelHandlerProcessing"](oBrowserEvent)) return;

	if (!this["oTree"]["bIsCapturedEventProcessing"]()) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}

	var oAccessInfo = this["oGetAccessInfo"](oBrowserEvent, this["ACCESS_TYPE"]["KEYBOARD_SELECT"]);
	this["oTree"]["toggleNode"](this, oAccessInfo);

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsselectmodifier"] = 0; };

/**
 * If a node is focused, it can be selected
 *  @param { UCF_BrowserEvent } oBrowserEvent the lsshow
 */
UCF_TreeNode["prototype"]["onlsshow"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsshow"]++; }; 

	oBrowserEvent["cancelBubble"]();

	if (!this["bEnabled"]) return;
	if (!this["bHasPopupMenu"]) return;

	this["openPopupMenu"](this["sPopupMenuId"]);
	oBrowserEvent["cancel"]();

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsshow"] = 0; };

/**
 * If the popup menu is closed, detach event and focus node again
 * @param { UCF_Event } oEvent the menuClose event
 */
UCF_TreeNode["prototype"]["onMenuClose"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onMenuClose"]++; }; 

	this["oPopupMenu"]["detachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this);
	this["focus"]();

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onMenuClose"] = 0; };

/**
 * Toggles the open state of the node
 */
UCF_TreeNode["prototype"]["toggle"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["toggle"]++; }; 

	if (!this["bEnabled"]) return;
	if (!this["bHasChildren"]) return;

	if (this["bIsOpen"]) {
		this["collapseInternal"]();
	} else {
		this["expandInternal"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["toggle"] = 0; };

/**
 * Expands the node
 */
UCF_TreeNode["prototype"]["expandInternal"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["expandInternal"]++; }; 

	if (!this["bEnabled"]) return;
	if (!this["bHasChildren"]) return;

	//child index changes
	this["oTree"]["destroyChildIndex"]();

	if (!this["bIsOpen"]) {
		this["expandNode"]();
		this["refocus"]();
		this["oTree"]["fireNodeExpand"](this["oTree"]["sId"], this["sId"]);
	}
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setExpanded"](this["oContentRef"], true);
	}
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["expandInternal"] = 0; };

/**
 * Expands the node.
 * @public
 */
UCF_TreeNode["prototype"]["expand"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["expand"]++; }; 
	if (!this["bHasChildren"]) return;
	if (!this["bIsOpen"]) {
		this["expandNode"]();
		this["refocus"]();
	}
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setExpanded"](this["oContentRef"], true);
	}
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["expand"] = 0; };

/**
 * Expand node and all child nodes.
 * This method does not fire events for each expanded node
 */
UCF_TreeNode["prototype"]["expandRecursive"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["expandRecursive"]++; }; 

	if (!this["bHasChildren"]) return;

	if (!this["bIsOpen"]) {
		this["expandNode"]();

		var aChildNodes = this["aGetChildNodes"]();
		for (var i = 0; i < aChildNodes["length"]; i++) {
			aChildNodes[i]["expandRecursive"]();
		}

	}
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["expandRecursive"] = 0; };

/**
 * Expand node.
 */
UCF_TreeNode["prototype"]["expandNode"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["expandNode"]++; }; 
	UCF_DomUtil["replaceClass"](this["oExpanderRef"], "urTreExpClo", "urTreExpOp");
	this["oChildrenRef"]["style"]["display"] = "";
	this["bIsOpen"] = true;
	this["setClientProperty"]("IsOpen", this["bIsOpen"], true);
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["expandNode"] = 0; };

/**
 * Collapses the node
 */
UCF_TreeNode["prototype"]["collapseInternal"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["collapseInternal"]++; }; 

	if (!this["bEnabled"]) return;
	if (!this["bHasChildren"]) return;

	//child index changes
	this["oTree"]["destroyChildIndex"]();

	if (this["bIsOpen"]) {
		this["collapseNode"]();
		this["refocus"]();
		this["oTree"]["fireNodeCollapse"](this["oTree"]["sId"], this["sId"]);
	}
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setExpanded"](this["oContentRef"], false);
	}
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["collapseInternal"] = 0; };

/**
 * Collapses the node.
 * @public
 */
UCF_TreeNode["prototype"]["collapse"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["collapse"]++; }; 
	if (!this["bHasChildren"]) return;
	if (this["bIsOpen"]) {
		this["collapseNode"]();
		this["refocus"]();
	}
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setExpanded"](this["oContentRef"], false);
	}
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["collapse"] = 0; };

/**
 * Collapses node and all child nodes.
 * This method does not send toggle events for each collapsed node
 */
UCF_TreeNode["prototype"]["collapseRecursive"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["collapseRecursive"]++; }; 

	if (!this["bHasChildren"]) return;

	if (this["bIsOpen"]) {
		this["collapseNode"]();

		var aChildNodes = this["aGetChildNodes"]();
		for (var i = 0; i < aChildNodes["length"]; i++) {
			aChildNodes[i]["collapseRecursive"]();
		}

	}
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["collapseRecursive"] = 0; };

/**
 * Collapses node.
 */
UCF_TreeNode["prototype"]["collapseNode"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["collapseNode"]++; }; 
	UCF_DomUtil["replaceClass"](this["oExpanderRef"], "urTreExpOp", "urTreExpClo");
	this["oChildrenRef"]["style"]["display"] = "none";
	this["bIsOpen"] = false;
	this["setClientProperty"]("IsOpen", this["bIsOpen"], true);

	//enhancement for selection
	this["deselectChildNodes"]();

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["collapseNode"] = 0; };

/**
 * Selects the node
 */
UCF_TreeNode["prototype"]["select"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["select"]++; }; 
	this["sSelection"] = "PRIMARY";
	this["setClientProperty"]("Selection", this["sSelection"], true);
	this["oTree"]["bIsPrimarySelectionSet"] = true;
	UCF_DomUtil["addClass"](this["oDomRef"], "urTreNSel");
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setSelected"](this["oContentRef"], true);
	}
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["select"] = 0; };

/**
 * Deselects the node
 */
UCF_TreeNode["prototype"]["deselect"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["deselect"]++; }; 
	if (this["sSelection"] === "PRIMARY") {
		UCF_DomUtil["removeClass"](this["oDomRef"], "urTreNSel");
	} else {
		UCF_DomUtil["removeClass"](this["oDomRef"], "urTreNSel2");
	}

	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setSelected"](this["oContentRef"], false);
	}

	this["sSelection"] = "NONE";
	this["setClientProperty"]("Selection", this["sSelection"], true);
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["deselect"] = 0; };

/**
 * Returns an array of all child nodes of this node
 * @return { Array } the child nodes
 */
UCF_TreeNode["prototype"]["aGetChildNodes"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["aGetChildNodes"]++; }; 

	var aChildRefs = this["oChildrenRef"]["childNodes"],
		aChildRef,
		aChildNodes = [];
	for (var i = 0; i < aChildRefs["length"]; i++) {
		aChildRef = aChildRefs[i];
		if (aChildRef["getAttribute"]("ct")) {
			aChildNodes["push"](this["oGetControlByDomRef"](aChildRef, true));
		}
	}
	return aChildNodes;
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["aGetChildNodes"] = 0; };

/**
 * Find the next visible node, null if you are the last node
 *  @return { HTMLElement } the node DOM Ref
 */
UCF_TreeNode["prototype"]["oGetNextNode"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetNextNode"]++; }; 

	var oNode = null;

	oNode = this["oGetFirstChild"]();

	if (!oNode) oNode = this["oGetNextSibling"]();

	if (!oNode) oNode = this["oGetParent"]()["oGetNextSibling"]();

	return oNode;

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetNextNode"] = 0; };

/**
 * Get the next sibling node, null if it is the last node
 * @return { HTMLElement } the node DOM Ref
 */
UCF_TreeNode["prototype"]["oGetNextSibling"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetNextSibling"]++; }; 

	var oNodeRef, oNode = null;

	if (this["bHasChildren"]) {

		//TODO: replace by UCF_DomUtil.nextSibling
		oNodeRef = this["oChildrenRef"]["nextSibling"];
	} else {
		oNodeRef = this["oRootRef"]["nextSibling"];
	}

	if (oNodeRef) oNode = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oNodeRef, true);

	if (!oNode) oNode = this["oGetParent"]()["oGetNextSibling"]();

	return oNode;

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetNextSibling"] = 0; };

/**
 * Get the first child node, null if there is none
 * @return { HTMLElement } the node DOM Ref
 */
UCF_TreeNode["prototype"]["oGetFirstChild"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetFirstChild"]++; }; 

	var oNodeRef, oNode = null;

	if (this["bHasChildren"] && this["bIsOpen"]) {

		//TODO: replace by UCF_DomUtil.firstChild(this.oDomRef) to avoid problems with text node
		oNodeRef = this["oChildrenRef"]["firstChild"];
		if (oNodeRef) oNode = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oNodeRef, true);
	}

	return oNode;

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetFirstChild"] = 0; };

/**
 * Find the next visible node, null if you are the last node
 * @return { HTMLElement } the node DOM Ref
 */
UCF_TreeNode["prototype"]["oGetPreviousNode"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetPreviousNode"]++; }; 

	var oNode = null,
		oLastChild;

	oNode = this["oGetPreviousSibling"]();

	if (oNode) {
		oLastChild = oNode["oGetLastChild"]();
		while (oLastChild) {
			oNode = oLastChild;
			oLastChild = oNode["oGetLastChild"]();
		}
	}

	if (!oNode) oNode = this["oGetParent"]();

	if (oNode === this["oTree"]) oNode = null;

	return oNode;

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetPreviousNode"] = 0; };

/**
 * Get the next sibling node, null if it is the last node
 * @return { HTMLElement } the node DOM Ref
 */
UCF_TreeNode["prototype"]["oGetPreviousSibling"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetPreviousSibling"]++; }; 

	var oNodeRef, oNode = null;

	//TODO replace by UCF_DomUtil.oGetPreviousSibling
	oNodeRef = this["oRootRef"]["previousSibling"];
	if (oNodeRef && oNodeRef["id"]["indexOf"]("-child") > 0) oNodeRef = oNodeRef["previousSibling"];

	if (oNodeRef) oNode = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oNodeRef, true);

	return oNode;

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetPreviousSibling"] = 0; };

/**
 * Get the last child node, null if there is none
 * @return { HTMLElement } the node DOM Ref
 */
UCF_TreeNode["prototype"]["oGetLastChild"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetLastChild"]++; }; 

	var oNodeRef, oNode = null;

	if (this["bHasChildren"] && this["bIsOpen"]) {

		//TODO: replace by UCF_DomUtil.lastChild(this.oDomRef) to avoid problems with text node
		oNodeRef = this["oChildrenRef"]["lastChild"];
		if (oNodeRef && oNodeRef["id"]["indexOf"]("-child") > 0) oNodeRef = oNodeRef["previousSibling"];
		if (oNodeRef) oNode = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oNodeRef, true);
	}

	return oNode;

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetLastChild"] = 0; };

UCF_TreeNode["prototype"]["onlslongtap"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlslongtap"]++; }; 
	if (this["bHasPopupMenu"] !== false && UCF_UserAgent["bIsIOS"]() && UCF_UserAgent["bIsSafari"]()) {
		this["oncontextmenu"](oBrowserEvent);
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlslongtap"] = 0; };

/**
 * Opens the context menu for this node
 *
 * @param {int} iLeft the left position of the popup
 * @param {int} iTop the top position of the popup
 * @see UCF_PopupMenu
 * @public
 */
UCF_TreeNode["prototype"]["openPopupMenuAtPosition"] = function(iLeft, iTop) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["openPopupMenuAtPosition"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iLeft) === "number", "typeof(iLeft) === \"number\"", "TreeNode.js(724): openPopupMenuAtPosition"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iTop) === "number", "typeof(iTop) === \"number\"", "TreeNode.js(725): openPopupMenuAtPosition"); };

	if (this["sPopupMenuId"] === "") {
		if (this["oPopupMenu"] && this["oPopupMenu"]["bOpened"]) this["oPopupMenu"]["close"]();
		// this.oTree.fireNodeContextMenu(this.oTree.sId, this.sId, "", iLeft, iTop);
		// TODO: Temporary hack for WD: send node id instead of tree id
		this["oTree"]["fireNodeContextMenu"](this["sId"], this["sId"], iLeft, iTop);
		return;
	}

	if (!this["oPopupMenu"]) {
		this["oPopupMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](this["sPopupMenuId"], true);
		if (this["oPopupMenu"]["bOpened"]) {
			this["oPopupMenu"]["close"]();
		}
	}

	this["oPopupMenu"]["setLeft"](iLeft);
	this["oPopupMenu"]["setTop"](iTop);

	if (this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["setPosition"]();
		return;
	}

	this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["POSITION"]);
	this["oPopupMenu"]["setOffsetLeft"](0);
	this["oPopupMenu"]["setOffsetTop"](0);
	this["oPopupMenu"]["setOpenerRef"](this["oDomRef"]);
	this["oPopupMenu"]["setOpenerId"](this["sId"]);
	this["oPopupMenu"]["setUserData"](this["sUserData"]);
	this["oPopupMenu"]["open"]();
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["openPopupMenuAtPosition"] = 0; };

/**
 * Sets the selection color for the TreeNode control. For the parameter values see enumeration 'TreeNodeSelection'.
 *
 * @param {string} sSelection The selection color
 * @public
 */
UCF_TreeNode["prototype"]["setSelection"] = function(sSelection) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["setSelection"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSelection) === "string", "typeof(sSelection) === \"string\"", "TreeNode.js(768): setSelection"); };
	var sOldClassName = this["oDomRef"]["className"],
		sClassToRemove = sOldClassName["indexOf"]("urTreNSel") === -1 ?
		null :
		(sOldClassName["indexOf"]("urTreNSel2") === -1 ? "urTreNSel" : "urTreNSel2"),
		sClassToAdd = (sSelection === "PRIMARYSELECTION") ?
		"urTreNSel" :
		(sSelection === "SECONDARYSELECTION" ? "urTreNSel2" : "");

	this["oDomRef"]["className"] = UCF_StringUtil["sTrim"](
		sClassToRemove ?
		this["oDomRef"]["className"]["replace"](sClassToRemove, sClassToAdd) :
		this["oDomRef"]["className"] + " " + sClassToAdd
	);

	if (this["sSelection"] === "PRIMARYSELECTION") this["oTree"]["bIsPrimarySelectionSet"] = true;

	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setSelected"](this["oContentRef"], true);
	}

	this["sSelection"] = sSelection; //for ACC
	this["setClientProperty"]("Selection", this["sSelection"], true);

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["setSelection"] = 0; };

/**
 * Returns the selection color for the TreeNode control. For the return values see enumeration 'TreeNodeSelection'.
 * @return {string} the selection
 * @public
 */
UCF_TreeNode["prototype"]["getSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["getSelection"]++; }; 
	return this["sSelection"];
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["getSelection"] = 0; };

/**
 * Opens the context menu for this node
 *
 * @param {string} sPopupMenuId the id of the popup menu to open
 * @see UCF_PopupMenu
 */
UCF_TreeNode["prototype"]["openPopupMenu"] = function(sPopupMenuId) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["openPopupMenu"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sPopupMenuId) === "string", "typeof(sPopupMenuId) === \"string\"", "TreeNode.js(811): openPopupMenu"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sPopupMenuId !== "", "sPopupMenuId !== \"\"", "TreeNode.js(812): openPopupMenu"); };

	this["oPopupMenu"] = this["oLS"]["oControlFactory"]["oGetControlById"](sPopupMenuId, true);
	if (this["oPopupMenu"]["bOpened"]) {
		this["oPopupMenu"]["close"]();
	}
	this["oPopupMenu"]["setAlignment"](UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]);
	this["oPopupMenu"]["setOffsetLeft"](50);
	this["oPopupMenu"]["setOffsetTop"](-12);
	this["oPopupMenu"]["setOpenerRef"](this["oDomRef"]["firstChild"]);
	this["oPopupMenu"]["setOpenerId"](this["sId"]);
	this["oPopupMenu"]["setUserData"](this["sUserData"]);
	this["oPopupMenu"]["open"]();
	this["oPopupMenu"]["attachEvent"](this["oPopupMenu"]["E_EVENTS"]["Close"], this, "onMenuClose");

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["openPopupMenu"] = 0; };

/**
 * Returns the Tree where this node belongs to
 *
 * @type UCF_Tree
 */
UCF_TreeNode["prototype"]["oGetTree"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetTree"]++; }; 

	var oParent = this["oGetParent"]();
	while (!UCF_JsUtil["bInstanceOf"](oParent, "UCF_Tree")) {
		if (!oParent) return null;

		oParent = oParent["oGetParent"]();
	}
	return oParent;

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetTree"] = 0; };

/**
 * Get the the parent of a tree node. Overrides UCF_Control.oGetParent,
 * as the child nodes in the tree are not nested inside the node
 * @return { HTMLElement } the parent DOM Ref
 */
UCF_TreeNode["prototype"]["oGetParent"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetParent"]++; }; 
	var oParentRef = this["oRootRef"]["parentNode"];
	// If Tree is scrollable there is no previousSibling on the child div
	if (UCF_StringUtil["bEndsWith"](oParentRef["parentNode"]["id"], "-scrl")) {
		oParentRef = oParentRef["parentNode"];
	}

	//TODO replace by UCF_DomUtil.oGetPreviousSibling
	oParentRef = oParentRef["previousSibling"];
	while (oParentRef && oParentRef !== document["body"]) {
		if (oParentRef["getAttribute"]("ct")) {
			return this["oLS"]["oControlFactory"]["oGetControlByDomRef"](oParentRef, true);
		}
		oParentRef = oParentRef["parentNode"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetParent"] = 0; };

/**
 * Get the acc short name of a the control.
 * @return {string}
 */
UCF_TreeNode["prototype"]["sGetAccControlName"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["sGetAccControlName"]++; }; 
	var oAccessibilityHelper = null;

	oAccessibilityHelper = new (UCF_ClassLoader["oGetClass"]("UCF_AccessibilityHelper"))(this["oLS"]);

	oAccessibilityHelper["setControlType"]("TR");
	return oAccessibilityHelper["sGetControlTypeShortText"]();
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["sGetAccControlName"] = 0; };

/**
 * Handles the lsaccessibility event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TreeNode["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TreeNode.js(890): onlsaccessibility"); };

	var oSourceRef = oBrowserEvent["oGetSource"]();
	if (!UCF_DomUtil["bContains"](this["oRootRef"], oSourceRef)) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"],
		iItemIndex = this["oDomRef"]["getAttribute"]("idx"),
		iItemCount = this["oDomRef"]["getAttribute"]("ic"),
		iContainingItemCount = this["oDomRef"]["getAttribute"]("ici");

	oAccessibilityHelper["setEnabled"](this["bEnabled"]);
	oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](this["oDomRef"]));
	oAccessibilityHelper["setLevel"](this["iLevel"]);
	oAccessibilityHelper["setItemIndex"](iItemIndex);
	oAccessibilityHelper["setItemCount"](iItemCount);
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["setContainingItemCount"](iContainingItemCount);

	//set the expanded and collpsed state, tutors are defined on the tree level not for every node
	oAccessibilityHelper["setExpanded"](
		this["bHasChildren"] &&
		this["bIsOpen"]);
	oAccessibilityHelper["setCollapsed"](
		this["bHasChildren"] &&
		!this["bIsOpen"]);

	//set the selection state and tutors
	oAccessibilityHelper["setSelected"](
		this["sSelection"] !== "NONE");

	var sTutorKey = (this["sSelection"] === "NONE" ? "SELECT_TUT" : "DESELECT_TUT");
	oAccessibilityHelper["addEnabledTutor"](sTutorKey, this["bEnabled"] && this["bIsClickable"]);

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onlsaccessibility"] = 0; };

/**
 * Get access information
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 * @param {int} eAccessType
 * @return { HTMLElement } the parent DOM Ref
 */
UCF_TreeNode["prototype"]["oGetAccessInfo"] = function(oBrowserEvent, eAccessType) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetAccessInfo"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent !== null, "oBrowserEvent !== null", "TreeNode.js(933): oGetAccessInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oBrowserEvent) === "object", "typeof(oBrowserEvent) === \"object\"", "TreeNode.js(934): oGetAccessInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(eAccessType) === "number", "typeof(eAccessType) === \"number\"", "TreeNode.js(935): oGetAccessInfo"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(eAccessType >= 0, "eAccessType >= 0", "TreeNode.js(936): oGetAccessInfo"); };

	var oDomRef = oBrowserEvent["oGetSource"](),
		sContentControlType = null,
		eAction = this["ACTION"]["NONE"],
		sAccessFragmentType = "",
		oAccessFragmentDomRef = null,
		eSubControlType = null;

	while (oDomRef && oDomRef["tagName"] !== "BODY") {
		if (oDomRef["getAttribute"]("subct")) {
			eSubControlType = oDomRef["getAttribute"]("subct");
		} else if (!sContentControlType && oDomRef["getAttribute"]("ct")) {
			sContentControlType = oDomRef["getAttribute"]("ct");
		}

		if (!sAccessFragmentType && oDomRef["getAttribute"]("acf")) {
			sAccessFragmentType = oDomRef["getAttribute"]("acf");
			oAccessFragmentDomRef = oDomRef;
			eAction = sAccessFragmentType;
		}

		if (eSubControlType || sContentControlType) {
			return {
				"oBrowserEvent": oBrowserEvent,
				"eAccessType": eAccessType,
				"sSubControlId": oDomRef["getAttribute"]("id") ? oDomRef["getAttribute"]("id") : "",
				"oSubControlDomRef": oDomRef,
				"eSubControlType": eSubControlType,
				"sContentControlType": sContentControlType,
				"sAccessFragmentType": sAccessFragmentType,
				"oAccessFragmentDomRef": oAccessFragmentDomRef,
				"eAction": eAction,
				"bHandled": false,
				"bForceCancelEvent": false
			};
		}
		oDomRef = oDomRef["parentNode"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["oGetAccessInfo"] = 0; };

/**
 * setDragSourceInfo
 *
 * @param { string } sDragSourceInfo of the the new DragSourceInfo
 * @public
 */
UCF_TreeNode["prototype"]["setDragSourceInfo"] = function(sDragSourceInfo) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["setDragSourceInfo"]++; }; 

	this["sDragSourceInfo"] = sDragSourceInfo;
	this["setClientProperty"]("DragSourceInfo", this["sDragSourceInfo"], true);

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["setDragSourceInfo"] = 0; };

/**
 *
 * @param { string } sClientSelection
 */
UCF_TreeNode["prototype"]["buildNodeIndex"] = function(sClientSelection) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["buildNodeIndex"]++; }; 

	this["oTree"]["aChildIndex"]["push"](this);

	//required to set selected node
	if (sClientSelection === "SINGLE") {
		if (this["sSelection"] !== "NONE") this["oTree"]["oSelectedNode"] = this;
	}

	if (!this["oChildrenRef"] || !this["bIsOpen"]) return;

	var aChildRef = this["aGetChildNodes"]();

	for (var i = 0, len = aChildRef["length"]; i < len; i++) {
		aChildRef[i]["buildNodeIndex"](sClientSelection);
	}

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["buildNodeIndex"] = 0; };

/**
 * Recursively deselects the Nodes in the tree. Also provides information if the primary selection was deselected
 * (in this case it is passed to the parent node)
 * @return {boolean}
 */
UCF_TreeNode["prototype"]["bRecursiveDeselect"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["bRecursiveDeselect"]++; }; 

	var bPrimarySelectionFound = this["sSelection"] === "PRIMARY";
	this["deselect"]();

	if (this["oChildrenRef"]) {

		var aChildRef = this["aGetChildNodes"](),
			bTemp = false;

		for (var i = 0, len = aChildRef["length"]; i < len; i++) {
			bTemp = aChildRef[i]["bRecursiveDeselect"]();
			if (bTemp) bPrimarySelectionFound = true;
		}
	}

	if (bPrimarySelectionFound) return true;

	return false;

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["bRecursiveDeselect"] = 0; };

/**
 * Deselects the child nodes of a node
 */
UCF_TreeNode["prototype"]["deselectChildNodes"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["deselectChildNodes"]++; }; 

	if (!this["oChildrenRef"]) return;

	var aChildRef = this["aGetChildNodes"](),
		bSetPrimarySelectionParent = false;

	for (var i = 0, len = aChildRef["length"]; i < len; i++) {
		bSetPrimarySelectionParent = aChildRef[i]["bRecursiveDeselect"]();
		if (bSetPrimarySelectionParent) {
			this["deselect"]();
			this["select"]();
			this["oTree"]["oSelectedNode"] = this;
		}
	}

};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["deselectChildNodes"] = 0; };

/**
 * Destructor
 * @private
 */
UCF_TreeNode["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["destroy"]++; }; 

	this["oTree"] = null;
	this["oExpanderRef"] = null;
	this["oContentRef"] = null;
	this["oChildrenRef"] = null;

	this["sOldSelection"] = null;
	this["sSelection"] = null;
	this["sDragSourceInfo"] = null;
	this["oPopupMenu"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["destroy"] = 0; };

/**
 * Makes the browser selection visible
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the selectstart
 */
UCF_TreeNode["prototype"]["onselectstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onselectstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TreeNode.js(1088): onselectstart"); };
	// for touch, cancel text selection
	if (oBrowserEvent["bIsTouchInteraction"]()) {
		oBrowserEvent["oDomEvent"]["returnValue"] = false;
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}

	UCF_Control.prototype["onselectstart"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["onselectstart"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TreeNode["prototype"]["aAttributeNames"] = ["iLevel","bHasChildren","bIsOpen","bIsClickable","bHasPopupMenu","sPopupMenuId","bEnabled","sSelection","sTooltip","sUserData","sDragSourceInfo","sDropTargetInfo","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TreeNode["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TreeNode["prototype"]["aMethodNames"] = ["collapse","expand","openPopupMenu","setSelection","getSelection","setDragSourceInfo","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {number}
 */
UCF_TreeNode["prototype"]["iLevel"] = 0;

/**
 * @private
 * @type {boolean}
 */
UCF_TreeNode["prototype"]["bHasChildren"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_TreeNode["prototype"]["bIsOpen"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_TreeNode["prototype"]["bIsClickable"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_TreeNode["prototype"]["bHasPopupMenu"] = false;

/**
 * @private
 * @type {string}
 */
UCF_TreeNode["prototype"]["sPopupMenuId"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_TreeNode["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TreeNodeSelection}
 */
UCF_TreeNode["prototype"]["sSelection"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_TreeNode["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TreeNode["prototype"]["sUserData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TreeNode["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TreeNode["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TreeNode["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_TreeNode["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["setDefaultValues"]++; }; 
	this["iLevel"] = 0;
	this["bHasChildren"] = false;
	this["bIsOpen"] = true;
	this["bIsClickable"] = true;
	this["bHasPopupMenu"] = false;
	this["sPopupMenuId"] = '';
	this["bEnabled"] = true;
	this["sSelection"] = "NONE";
	this["sTooltip"] = '';
	this["sUserData"] = '';
	this["sDragSourceInfo"] = '';
	this["sDropTargetInfo"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Level", 0, true);
		this["setClientProperty"]("HasChildren", false, true);
		this["setClientProperty"]("IsOpen", true, true);
		this["setClientProperty"]("IsClickable", true, true);
		this["setClientProperty"]("HasPopupMenu", false, true);
		this["setClientProperty"]("PopupMenuId", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Selection", "NONE", true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("UserData", '', true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_TreeNode["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_TreeNode.prototype["aPublicMethods"] = ["expand","collapse","openPopupMenuAtPosition","setSelection","getSelection","setDragSourceInfo"].concat(UCF_TreeNode.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TriStateCheckBox"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * TriStateCheckBox control implementation.
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TriStateCheckBox(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TriStateCheckBox["_"]["UCF_TriStateCheckBox"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "TriStateCheckBox.js(18): UCF_TriStateCheckBox"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TriStateCheckBox.js(19): UCF_TriStateCheckBox"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TriStateCheckBox.js(20): UCF_TriStateCheckBox"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_TriStateCheckBox"] = UCF_TriStateCheckBox; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TriStateCheckBox"); UCF_TriStateCheckBox["_"] = {UCF_TriStateCheckBox: 0}; }; ;
UCF_TriStateCheckBox["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_TriStateCheckBox.prototype["sClassName"] = "UCF_TriStateCheckBox";

UCF_TriStateCheckBox["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_TriStateCheckBox["prototype"]["aAttributeNames"] = ["sName","sState","bEnabled","bReadonly","sText","sTooltip","bInvalid","sVisibility","bShowHelp","sInputState","sAccessKey","sArrangement","sUserChoice","sAssociatedEditContext","bUsedInSapTable","sCustomData","sCustomStyle","bTextOverflow","sHeight","bIsTextLabel","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_TriStateCheckBox["prototype"]["aEventNames"] = ["Change","DoubleClick","Enter"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_TriStateCheckBox["prototype"]["aMethodNames"] = ["setValueState","getValueState","setEnabled","getEnabled","setValue","getValue","setEditable","getEditable","createDataTip","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_TriStateCheckBox["prototype"]["sName"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TriStateCheckBoxState}
 */
UCF_TriStateCheckBox["prototype"]["sState"] = "UNCHECKED";

/**
 * @private
 * @type {boolean}
 */
UCF_TriStateCheckBox["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_TriStateCheckBox["prototype"]["bReadonly"] = false;

/**
 * @private
 * @type {string}
 */
UCF_TriStateCheckBox["prototype"]["sText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TriStateCheckBox["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_TriStateCheckBox["prototype"]["bInvalid"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_TriStateCheckBox["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_TriStateCheckBox["prototype"]["bShowHelp"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.InputState}
 */
UCF_TriStateCheckBox["prototype"]["sInputState"] = "NONE";

/**
 * @private
 * @type {string}
 */
UCF_TriStateCheckBox["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.CheckBoxArrangement}
 */
UCF_TriStateCheckBox["prototype"]["sArrangement"] = "CHECKBOXFIRST";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.TriStateCheckBoxUserChoice}
 */
UCF_TriStateCheckBox["prototype"]["sUserChoice"] = "TRISTATE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.EditContext}
 */
UCF_TriStateCheckBox["prototype"]["sAssociatedEditContext"] = "PARENTEDITABLE";

/**
 * @private
 * @type {boolean}
 */
UCF_TriStateCheckBox["prototype"]["bUsedInSapTable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_TriStateCheckBox["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_TriStateCheckBox["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_TriStateCheckBox["prototype"]["bTextOverflow"] = false;

/**
 * @private
 * @type {string}
 */
UCF_TriStateCheckBox["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_TriStateCheckBox["prototype"]["bIsTextLabel"] = false;

/**
 * @private
 * @type {string}
 */
UCF_TriStateCheckBox["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_TriStateCheckBox["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox["_"]["setDefaultValues"]++; }; 
	this["sName"] = '';
	this["sState"] = "UNCHECKED";
	this["bEnabled"] = true;
	this["bReadonly"] = false;
	this["sText"] = '';
	this["sTooltip"] = '';
	this["bInvalid"] = false;
	this["sVisibility"] = "VISIBLE";
	this["bShowHelp"] = false;
	this["sInputState"] = "NONE";
	this["sAccessKey"] = '';
	this["sArrangement"] = "CHECKBOXFIRST";
	this["sUserChoice"] = "TRISTATE";
	this["sAssociatedEditContext"] = "PARENTEDITABLE";
	this["bUsedInSapTable"] = false;
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';
	this["bTextOverflow"] = false;
	this["sHeight"] = '';
	this["bIsTextLabel"] = false;
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Name", '', true);
		this["setClientProperty"]("State", "UNCHECKED", true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Readonly", false, true);
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Invalid", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("ShowHelp", false, true);
		this["setClientProperty"]("InputState", "NONE", true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("Arrangement", "CHECKBOXFIRST", true);
		this["setClientProperty"]("UserChoice", "TRISTATE", true);
		this["setClientProperty"]("AssociatedEditContext", "PARENTEDITABLE", true);
		this["setClientProperty"]("UsedInSapTable", false, true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("TextOverflow", false, true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("IsTextLabel", false, true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sState State of the control
 * @fires TriStateCheckBox::Change
 */
UCF_TriStateCheckBox["prototype"]["fireChange"] = function(sId, sState) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox["_"]["fireChange"]++; }; 
	/** @type {{Id: string, State: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "TriStateCheckBox.js(238): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TriStateCheckBox.js(239): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TriStateCheckBox.js(240): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sState != null, "sState != null", "TriStateCheckBox.js(241): fireChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sState) == "string", "typeof(sState) == \"string\"", "TriStateCheckBox.js(242): fireChange"); };
	mParams = {
		"Id": sId,
		"State": sState
	};
	
	
	this["fireSemanticEvent"]("TriStateCheckBox", "Change", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox["_"]["fireChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control.
 * @fires TriStateCheckBox::DoubleClick
 */
UCF_TriStateCheckBox["prototype"]["fireDoubleClick"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "TriStateCheckBox.js(261): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TriStateCheckBox.js(262): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TriStateCheckBox.js(263): fireDoubleClick"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("TriStateCheckBox", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox["_"]["fireDoubleClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires TriStateCheckBox::Enter
 */
UCF_TriStateCheckBox["prototype"]["fireEnter"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox["_"]["fireEnter"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "TriStateCheckBox.js(280): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "TriStateCheckBox.js(281): fireEnter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "TriStateCheckBox.js(282): fireEnter"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("TriStateCheckBox", "Enter", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox["_"]["fireEnter"] = 0; };

};
sap["ls"]["preload"]["UCF_TriStateCheckBox_ie6"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_CheckBoxDelegate_ie6 */
/// <reference path="./delegates/CheckBoxDelegate_ie6.js"/>
/* global UCF_TriStateCheckBox */
/// <reference path="./TriStateCheckBox.js"/>

/**
 * TriStateCheckBox control implementation.
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TriStateCheckBox_ie6(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["UCF_TriStateCheckBox_ie6"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "TriStateCheckBox_ie6.js(21): UCF_TriStateCheckBox_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TriStateCheckBox_ie6.js(22): UCF_TriStateCheckBox_ie6"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TriStateCheckBox_ie6.js(23): UCF_TriStateCheckBox_ie6"); };

	UCF_TriStateCheckBox["apply"](this, [oDomRef, oLS]);
	this["oCheckBoxBase"] = new (UCF_ClassLoader["oGetClass"]("UCF_CheckBoxDelegate_ie6"))(this);
	this["addDelegate"](this["oCheckBoxBase"]);
	this["oFocusDomRef"] = UCF_DomUtil["$"](this["sId"] + '-lbl');
	this["bIsMouseOver"] = false;
	this["oTriStateCheckBoxRef"] = UCF_DomUtil["$"](this["sId"]);
};window["UCF_TriStateCheckBox_ie6"] = UCF_TriStateCheckBox_ie6; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TriStateCheckBox_ie6"); UCF_TriStateCheckBox_ie6["_"] = {UCF_TriStateCheckBox_ie6: 0}; }; ;
UCF_TriStateCheckBox_ie6["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_TriStateCheckBox"))(); UCF_TriStateCheckBox_ie6.prototype["sClassName"] = "UCF_TriStateCheckBox_ie6";

/**
 * Destructor
 * @private
 */
UCF_TriStateCheckBox_ie6["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["destroy"]++; }; 
	this["oTriStateCheckBoxRef"] = null;
	this["oCheckBoxBase"]["destroy"]();
	this["oCheckBoxBase"] = null;
	this["sState"] = null;
	UCF_TriStateCheckBox.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["destroy"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_ie6["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_ie6.js(53): onclick"); };

	if (!this["bEnabled"] || this["bReadonly"]) return;

	this["toggle"]();
	this["applyHoverState"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onclick"] = 0; };

UCF_TriStateCheckBox_ie6["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_ie6.js(63): onmousedown"); };

	if (!this["bEnabled"] || this["bReadonly"]) {
		return;
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onmousedown"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_ie6["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_ie6.js(78): ondblclick"); };

	if (this["mEvents"]["DoubleClick"]) {
		this["fireDoubleClick"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["ondblclick"] = 0; };

/**
 * Handles the onlsselect event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_ie6["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_ie6.js(93): onlsselect"); };

	if (!this["bEnabled"] || this["bReadonly"]) {
		return;
	}

	// if(oBrowserEvent.iKeyCode()!=UCF_KeyCodes.ENTER)
	this["toggle"]();
	oBrowserEvent["cancelBubble"]();
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onlsselect"] = 0; };

/**
 * Toggles checked stateand updates the visual representation of the TriStateCheckBox
 */
UCF_TriStateCheckBox_ie6["prototype"]["toggle"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["toggle"]++; }; 

	switch (this["sState"]) {
		case 'CHECKED':
			if (this["sUserChoice"] === 'TRISTATE') {
				this["setState"]('INDETERMINATE');
			} else if (this["sUserChoice"] === 'BISTATE') {
				this["setState"]('UNCHECKED');
			}
			break;
		case 'UNCHECKED':
			this["setState"]('CHECKED');
			break;
		case 'INDETERMINATE':
			this["setState"]('UNCHECKED');
			break;
	}

	this["applySelection"]();
	this["fireChange"](this["sId"], this["sState"]);
	this["oFocusDomRef"]["focus"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["toggle"] = 0; };

/**
 * Sets the state and updates the visual representation of the TriStateCheckBox
 *
 * @param {string} sState the new state of the TriStateCheckBox
 */
UCF_TriStateCheckBox_ie6["prototype"]["setState"] = function(sState) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["setState"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sState != null, "sState != null", "TriStateCheckBox_ie6.js(137): setState"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sState !== '', "sState !== ''", "TriStateCheckBox_ie6.js(138): setState"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sState === 'CHECKED' || sState === 'INDETERMINATE' || sState === 'UNCHECKED', "sState === 'CHECKED' || sState === 'INDETERMINATE' || sState === 'UNCHECKED'", "TriStateCheckBox_ie6.js(139): setState"); };

	if (this["sState"] === sState) return;

	this["sState"] = sState;
	this["setClientProperty"]("State", this["sState"], true);
	this["oCheckBoxBase"]["applySelection"]();
	this["oCheckBoxBase"]["applyStateToDom"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["setState"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_ie6["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onlsaccessibility"]++; }; 
	var oAccessibilityHelper;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_ie6.js(159): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) {
		return;
	}

	oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (this["sUserChoice"] === 'TRISTATE') {
		oAccessibilityHelper["setControlType"]('TRI');
	} else if (this["sUserChoice"] === 'BISTATE') {
		oAccessibilityHelper["setControlType"]('C');
	}

	if (!this["bReadonly"]) {
		switch (this["sState"]) {
			case 'CHECKED':
				if (this["sUserChoice"] === 'TRISTATE') {
					oAccessibilityHelper["addEnabledTutor"]('TRI_SEL_TUT', this["bEnabled"]);
				} else if (this["sUserChoice"] === 'BISTATE') {
					oAccessibilityHelper["addEnabledTutor"]('TRI_UNDEF_TUT', this["bEnabled"]);
				}
				break;
			case 'UNCHECKED':
				oAccessibilityHelper["addEnabledTutor"]('TRI_NSEL_TUT', this["bEnabled"]);
				break;
			case 'INDETERMINATE':
				oAccessibilityHelper["addEnabledTutor"]('TRI_UNDEF_TUT', this["bEnabled"]);
				break;
		}
	}

};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onlsaccessibility"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_ie6["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_ie6.js(200): onmouseover"); };

	this["bIsMouseOver"] = true;
	this["applyHoverState"]();
	this["oCheckBoxBase"]["applyTooltip"]();

};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onmouseover"] = 0; };

UCF_TriStateCheckBox_ie6["prototype"]["applyHoverState"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["applyHoverState"]++; }; 
	var oImg;
	var sClasses;

	if (this["bReadonly"] || !this["bEnabled"])
		return;
	if (this["bIsMouseOver"]) {
		oImg = UCF_DomUtil["$"](this["sId"] + '-img');
		if (!oImg)
			return;
		sClasses = UCF_DomUtil["sGetClass"](oImg);
		if (sClasses["indexOf"]('Hover') != -1)
			return;
		var sValueState = this["oCheckBoxBase"]["getValueState"]();
		if ('NONE' == sValueState) {
			if (this["sState"] === 'INDETERMINATE')
				sClasses += ' urTriImgIndHover';
			else if (this["sState"] == 'UNCHECKED')
				sClasses += ' urTriImgOffHover';
			else if (this["sState"] == 'CHECKED')
				sClasses += ' urTriImgOnHover';
		} else if ('ERROR' == sValueState) {
			if (this["sState"] == 'INDETERMINATE')
				sClasses += ' urTriImgIndInvHover';
			else if (this["sState"] == 'UNCHECKED')
				sClasses += ' urTriImgOffInvHover';
			else if (this["sState"] == 'CHECKED')
				sClasses += ' urTriImgOnInvHover';
		} else if ('WARNING' == sValueState) {
			if (this["sState"] == 'INDETERMINATE')
				sClasses += ' urTriImgIndWarnHover';
			else if (this["sState"] == 'UNCHECKED')
				sClasses += ' urTriImgOffWarnHover';
			else if (this["sState"] == 'CHECKED')
				sClasses += ' urTriImgOnWarnHover';
		}
		UCF_DomUtil["setClass"](oImg, sClasses);
	} else {
		oImg = UCF_DomUtil["$"](this["sId"] + '-img');
		if (!oImg)
			return;
		sClasses = UCF_DomUtil["sGetClass"](oImg);
		if (sClasses["indexOf"]('Hover') == -1)
			return;
		var aClasses = sClasses["split"](' ');
		var sClassName = aClasses[0];
		for (var i = 1; i < aClasses["length"] - 1; i++)
			sClassName = sClassName + ' ' + aClasses[i];
		UCF_DomUtil["setClass"](oImg, sClassName);
	}
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["applyHoverState"] = 0; };

/**
 *Handles the onmouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_ie6["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_ie6.js(267): onmouseout"); };

	this["bIsMouseOver"] = false;
	this["applyHoverState"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["onmouseout"] = 0; };

/**
 * Sets the value of the TriStateCheckBox
 * @param {boolean} bValue, true=selected; false=deselected; null=indeterminate
 * @public
 */
UCF_TriStateCheckBox_ie6["prototype"]["setValue"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["setValue"]++; }; 
	switch (bValue) {
		case true:
			this["setState"]('CHECKED');
			break;
		case false:
			this["setState"]('UNCHECKED');
			break;
		case null:
			this["setState"]('INDETERMINATE');
			break;
	}

	// don't fire events in MAPIs
	// this.fireChange(this.sId, this.sState);

	this["refocus"](this["oFocusDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["setValue"] = 0; };

/**
 * Returns the value of the TriStateCheckBox
 * @return {boolean} the value, true=selected; false=deselected; null=indeterminate
 * @public
 */
UCF_TriStateCheckBox_ie6["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["getValue"]++; }; 
	switch (this["sState"]) {
		case 'CHECKED':
			return true;
		case 'UNCHECKED':
			return false;
		case 'INDETERMINATE':
			return null;
	}
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["getValue"] = 0; };

UCF_TriStateCheckBox_ie6["prototype"]["applyStateToDom"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["applyStateToDom"]++; }; 
	// _super('Tri');
	this["oCheckBoxBase"]["applyStateToDom"]('Tri');
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["applyStateToDom"] = 0; };

UCF_TriStateCheckBox_ie6["prototype"]["applySelection"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["applySelection"]++; }; 
	// _super('Tri');
	this["oCheckBoxBase"]["applySelection"]('Tri');
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_ie6["_"]["applySelection"] = 0; };

UCF_TriStateCheckBox_ie6.prototype["aPublicMethods"] = ["setValue","getValue"].concat(UCF_TriStateCheckBox_ie6.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TriStateCheckBox_standards"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_SelectorDelegate */
/// <reference path="./delegates/SelectorDelegate.js"/>
/* global UCF_Selector_508_Delegate */
/// <reference path="./delegates/Selector_508_Delegate.js"/>
/* global UCF_TriStateCheckBox */
/// <reference path="./TriStateCheckBox.js"/>

/**
 * TriStateCheckBox control implementation.
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_TriStateCheckBox_standards(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["UCF_TriStateCheckBox_standards"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === 'object', "typeof(oDomRef) === 'object'", "TriStateCheckBox_standards.js(29): UCF_TriStateCheckBox_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "TriStateCheckBox_standards.js(30): UCF_TriStateCheckBox_standards"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "TriStateCheckBox_standards.js(31): UCF_TriStateCheckBox_standards"); };

	UCF_TriStateCheckBox["apply"](this, [oDomRef, oLS]);

	this["oFocusDomRef"] = this["oDomRef"];
	this["oCheckBoxBase"] = new (UCF_ClassLoader["oGetClass"]("UCF_SelectorDelegate"))(this);
	this["addDelegate"](this["oCheckBoxBase"]);
	this["sFocusType"] = 'NAVIGATION';

	if (window["UCF_System"]["bIs508"]) {
		this["Delegate_508"] = new (UCF_ClassLoader["oGetClass"]("UCF_Selector_508_Delegate"))(this);
		this["addDelegate"](this["Delegate_508"]);
		// this.Delegate_508.attachEvent(this.Delegate_508.E_EVENTS.Accessibility, this, 'on_508_Internal');
	}
};window["UCF_TriStateCheckBox_standards"] = UCF_TriStateCheckBox_standards; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TriStateCheckBox_standards"); UCF_TriStateCheckBox_standards["_"] = {UCF_TriStateCheckBox_standards: 0}; }; ;
UCF_TriStateCheckBox_standards["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_TriStateCheckBox"))(); UCF_TriStateCheckBox_standards.prototype["sClassName"] = "UCF_TriStateCheckBox_standards";

/**
 * ############################################################################
 *
 * SECTION RESPONSIBLE FOR SELECTION
 *
 * ############################################################################
 */

UCF_TriStateCheckBox_standards["prototype"]["eFocusType"] = {
	"NAVIGATION": 'NAVIGATION',
	"REFOCUSED": 'REFOCUSED'
};

/**
 * Handles the onlsselect event
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_standards["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_standards.js(68): onlsselect"); };

	// --- return if element is not selectable
	if (!this["oCheckBoxBase"]["bIsSelectable"]()) {
		return;
	}

	//--- toggle selection state
	if (oBrowserEvent["iKeyCode"]() !== UCF_KeyCodes["ENTER"]) {
		this["toggle"]();

		// --- refocus to get Jaws to anounce new state
		if (this["oCheckBoxBase"]["bAccModeOn"]()) {
			this["sFocusType"] = this["eFocusType"]["REFOCUSED"];
			UCF_DomUtil["refocusDomElement"](this["oFocusDomRef"]);
		}
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onlsselect"] = 0; };
/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_standards["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_standards.js(95): onclick"); };
	if (this["oDataTip"] && this["oDataTip"]["sExplanationText"]) {
		this["oDataTip"]["close"]();
	}
	if (this["oCheckBoxBase"]["bIsSelectable"]()) {
		this["toggle"]();
		//this.moveFocus(this.oFocusDomRef);
		// this.setClientProperty("Checked", this.bChecked, true);

		// --
		if (this["oCheckBoxBase"]["bAccModeOn"]()) {
			UCF_DomUtil["refocusDomElement"](this["oFocusDomRef"]);
			this["sFocusType"] = this["eFocusType"]["REFOCUSED"];
		}
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onclick"] = 0; };

/**
 * Finds the respective selection state
 * @private
 * @return {UCF_SelectorDelegate_SelectionState}
 */
// eslint-disable-next-line consistent-return
UCF_TriStateCheckBox_standards["prototype"]["sGetSucceedingSelectionState"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["sGetSucceedingSelectionState"]++; }; 
	var oCheckBoxBase = this["oCheckBoxBase"];
	var eSelectionState = oCheckBoxBase["eSelectionState"];

	if (this["sUserChoice"] === 'BISTATE') {

		if (this["sState"] === eSelectionState["CHECKED"]) {
			return eSelectionState["UNCHECKED"];
		} else {
			return eSelectionState["CHECKED"];
		}

	} else {
		switch (this["sState"]) {
			case eSelectionState["UNCHECKED"]:
				return eSelectionState["CHECKED"];

			case eSelectionState["CHECKED"]:
				return eSelectionState["INDETERMINATE"];

			case eSelectionState["INDETERMINATE"]:
				return eSelectionState["UNCHECKED"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["sGetSucceedingSelectionState"] = 0; };

/**
 * Toggles checked state and updates the visual representation of the checkbox
 * @private
 */
UCF_TriStateCheckBox_standards["prototype"]["toggle"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["toggle"]++; }; 

	var oCheckBoxBase = this["oCheckBoxBase"];
	var Style_Factory = oCheckBoxBase["styleFactory"]["bind"](this["oCheckBoxBase"]);
	var toggleMethods = oCheckBoxBase["toggleMethods"];
	var sSwitchToState = this["sGetSucceedingSelectionState"]();

	Style_Factory(toggleMethods["switchSelectionState"]["bind"](this["oCheckBoxBase"]),
		this, sSwitchToState);

	// -- find the correct parameters to pass on
	// switch (this.sState) {
	// 	case eSelectionState.UNCHECKED:
	// 		Style_Factory(toggleMethods.switchSelectionState.bind(this.oCheckBoxBase),
	// 			this, eSelectionState.SELECTED);
	// 		sSwitchToState = eSelectionState.CHECKED;
	// 		break;

	// 	case eSelectionState.CHECKED:
	// 		Style_Factory(toggleMethods.switchSelectionState.bind(this.oCheckBoxBase),
	// 			this, eSelectionState.INDETERMINATE);
	// 		sSwitchToState = eSelectionState.INDETERMINATE;
	// 		break;

	// 	case eSelectionState.INDETERMINATE:
	// 		Style_Factory(toggleMethods.switchSelectionState.bind(this.oCheckBoxBase),
	// 			this, eSelectionState.UNSELECTED);
	// 		sSwitchToState = eSelectionState.UNCHECKED;
	// 		break;
	// }

	// -- update client-side properties
	this["sValue"] = sSwitchToState;
	this["sState"] = sSwitchToState;
	this["setClientProperty"]("Value", sSwitchToState, true);
	this["setClientProperty"]("State", sSwitchToState, true);
	this["oCheckBoxBase"]["updateAriaInfo"](this);

	// // -- refocus to get Jaws to announce new states
	// if (UCF_System.bIs508 || UCF_System.bIsAria)
	// 	UCF_DomUtil.moveFocusDomElement(this.oFocusDomRef);

	this["fireChange"](this["sId"], this["sState"]);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["toggle"] = 0; };

/**
 * A compiled list with all styles relevant for selection
 * and deselection
 *
 * @private
 */
UCF_TriStateCheckBox_standards["prototype"]["eStyles"] = {
	'SELECTED_ENABLED': 'lsCheckBox--checked',
	'UNSELECTED_ENABLED': 'lsCheckBox--unchecked',
	'INDETERMINATE_ENABLED': 'lsCheckBox--indeterminate',

	'SELECTED_READONLY': 'lsCheckBox--checked--readOnly',
	'UNSELECTED_READONLY': 'lsCheckBox--unchecked--readOnly',
	'INDETERMINATE_READONLY': 'lsCheckBox--indeterminate--readOnly',

	'SELECTED_ERROR_ENABLED': 'lsCheckBox--checked--error',
	'UNSELECTED_ERROR_ENABLED': 'lsCheckBox--unchecked--error',
	'INDETERMINATE_ERROR_ENABLED': 'lsCheckBox--indeterminate--error',

	'SELECTED_WARNING_ENABLED': 'lsCheckBox--checked--warning',
	'UNSELECTED_WARNING_ENABLED': 'lsCheckBox--unchecked--warning',
	'INDETERMINATE_WARNING_ENABLED': 'lsCheckBox--indeterminate--warning',

	'SELECTED_PARENT_READONLY': 'lsCheckBox--checked--parentReadOnly',
	'UNSELECTED_PARENT_READONLY': 'lsCheckBox--unchecked--parentReadOnly',
	'INDETERMINATE_PARENT_READONLY': 'lsCheckBox--indeterminate--parentReadOnly',

	'SELECTED_ERROR_READONLY': 'lsCheckBox--checked--error--readOnly',
	'UNSELECTED_ERROR_READONLY': 'lsCheckBox--unchecked--error--readOnly',
	'INDETERMINATE_ERROR_READONLY': 'lsCheckBox--indeterminate--error--readOnly',

	'SELECTED_WARNING_READONLY': 'lsCheckBox--checked--warning--readOnly',
	'UNSELECTED_WARNING_READONLY': 'lsCheckBox--unchecked--warning--readOnly',
	'INDETERMINATE_WARNING_READONLY': 'lsCheckBox--indeterminate--warning--readOnly',

	'SELECTED_DISABLED': 'lsCheckBox--checked--disabled',
	'UNSELECTED_DISABLED': 'lsCheckBox--unchecked--disabled',
	'INDETERMINATE_DISABLED': 'lsCheckBox--indeterminate--disabled'
};
/**
 * ############################################################################
 *
 * SECTION WITH ALL PUBLIC APIS
 *
 * ############################################################################
 */

/**
 * Set the value of the CheckBox, true=selected; false=deselected
 * @param {boolean} bSetToChecked the new value
 * @public
 */
// UCF_TriStateCheckBox_standards.prototype.setValue = function(bSetToChecked) {
// 	if (this.bChecked !== bSetToChecked) {
// 		this.toggle(bSetToChecked);
// 		this.oCheckBoxBase.updateAriaInfo(this);
// 	}
// };

/**
 * Sets the value of the TriStateCheckBox
 * @param {boolean} bValue true=selected; false=deselected; null=indeterminate
 * @public
 */
UCF_TriStateCheckBox_standards["prototype"]["setValue"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["setValue"]++; }; 

	var eSelectionState = this["oCheckBoxBase"]["eSelectionState"];
	var oCheckBoxBase = this["oCheckBoxBase"];
	var Style_Factory = oCheckBoxBase["styleFactory"]["bind"](this["oCheckBoxBase"]);
	var toggleMethods = oCheckBoxBase["toggleMethods"];
	var sSwitchToState;

	switch (bValue) {
		case true:
			Style_Factory(toggleMethods["switchSelectionState"]["bind"](this["oCheckBoxBase"]),
				this, eSelectionState["SELECTED"]);
			sSwitchToState = eSelectionState["CHECKED"];
			break;
		case false:
			Style_Factory(toggleMethods["switchSelectionState"]["bind"](this["oCheckBoxBase"]),
				this, eSelectionState["UNSELECTED"]);
			sSwitchToState = eSelectionState["UNCHECKED"];
			break;
		case null:
			Style_Factory(toggleMethods["switchSelectionState"]["bind"](this["oCheckBoxBase"]),
				this, eSelectionState["INDETERMINATE"]);
			sSwitchToState = eSelectionState["INDETERMINATE"];
			break;
	}

	this["sState"] = sSwitchToState;
	this["setClientProperty"]("Value", sSwitchToState, true);
	this["setClientProperty"]("State", sSwitchToState, true);

	UCF_DomUtil["focusDomElement"](this["oFocusDomRef"]);
	this["sFocusType"] = this["eFocusType"]["REFOCUSED"];
	this["oCheckBoxBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["setValue"] = 0; };

/**
 * Returns the value of the CheckBox, true=checked; false=not checked
 * @return {boolean} The value of the CheckBox,
 * true=checked; false=not checked
 * @public
 */
// eslint-disable-next-line consistent-return
UCF_TriStateCheckBox_standards["prototype"]["getValue"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["getValue"]++; }; 
	switch (this["sState"]) {
		case 'CHECKED':
			return true;
		case 'UNCHECKED':
			return false;
		case 'INDETERMINATE':
			return null;
	}
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["getValue"] = 0; };

UCF_TriStateCheckBox_standards["prototype"]["getValueState"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["getValueState"]++; }; 
	return this["oCheckBoxBase"]["getValueState"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["getValueState"] = 0; };
/**
 * Sets the input state of the checkbox
 * @param {string} sValue state
 * @public
 */
UCF_TriStateCheckBox_standards["prototype"]["setValueState"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["setValueState"]++; }; 
	this["oCheckBoxBase"]["setValueState"](sValue);
	this["oCheckBoxBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["setValueState"] = 0; };

/**
 * Get enabled
 * @return {boolean} the enabled state
 * @public
 */
UCF_TriStateCheckBox_standards["prototype"]["getEnabled"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["getEnabled"]++; }; 
	return this["oCheckBoxBase"]["getEnabled"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["getEnabled"] = 0; };
/**
 * Set enabled
 * @param {boolean} bEnabled the new enabled value
 * @public
 */
UCF_TriStateCheckBox_standards["prototype"]["setEnabled"] = function(bEnabled) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["setEnabled"]++; }; 
	this["oCheckBoxBase"]["setEnabled"](bEnabled);
	this["oCheckBoxBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["setEnabled"] = 0; };
/**
 * Get the editable state of the checkbox
 * @return {boolean} the editable state
 * @public
 */
UCF_TriStateCheckBox_standards["prototype"]["getEditable"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["getEditable"]++; }; 
	return this["oCheckBoxBase"]["getEditable"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["getEditable"] = 0; };
/**
 * Set the editable state of the checkbox
 *
 * @param {boolean} bValue the new editable value
 * @public
 */
UCF_TriStateCheckBox_standards["prototype"]["setEditable"] = function(bValue) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["setEditable"]++; }; 
	this["oCheckBoxBase"]["setEditable"](bValue);
	this["oCheckBoxBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["setEditable"] = 0; };
/**
 * Gets the value state of this checkbox
 * @return {string} the required state
 * @public
 */
UCF_TriStateCheckBox_standards["prototype"]["getValueState"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["getValueState"]++; }; 
	return this["oCheckBoxBase"]["getValueState"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["getValueState"] = 0; };
/**
 * Sets the input state of the checkbox
 * @param {string} sValue state
 * @public
 */
UCF_TriStateCheckBox_standards["prototype"]["setValueState"] = function(sValue) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["setValueState"]++; }; 
	this["oCheckBoxBase"]["setValueState"](sValue);
	this["oCheckBoxBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["setValueState"] = 0; };
/**
 * ###########################################################################
 *
 * SECTION WITH GENERICALLY USED MOUSE EVENTS
 *
 * ###########################################################################
 */
/**
 * Handles the onmouse down event
 * @private
 * @param {oBrowserEvent} oBrowserEvent
 */
UCF_TriStateCheckBox_standards["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_standards.js(389): onmousedown"); };
	if (!this["bEnabled"] || this["bReadonly"]) {
		return;
	}
	if (this["oCheckBoxBase"]["bIsSelectable"]() && this["oCheckBoxBase"]["bAccModeOn"]()) {
		UCF_DomUtil["focusDomElement"](this["oFocusDomRef"]);
		this["sFocusType"] = this["eFocusType"]["REFOCUSED"];
	}
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onmousedown"] = 0; };

/**
 * Handles the ondblclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_standards["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["ondblclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_standards.js(407): ondblclick"); };
	if (this["mEvents"]["DoubleClick"]) {
		this["fireDoubleClick"](this["sId"]);
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["ondblclick"] = 0; };

/**
 * Handles the onkeydown event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_standards["prototype"]["onkeydown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onkeydown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_standards.js(421): onkeydown"); };
	if (!this["bEnabled"]) {
		return;
	}

	if (oBrowserEvent["iKeyCode"]() === UCF_KeyCodes["SPACE"] &&
		!oBrowserEvent["bAlt"]()) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	}
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onkeydown"] = 0; };
/*
 * ############################################################################
 *
 * SECTION RESPONSIBLE FOR ACC BE IT 508 OR ARIA
 *
 * ###########################################################################
 */
/**
 * Handles the onlsfocus event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_standards["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onlsfocus"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_standards.js(446): onlsfocus"); };

	// --
	if (this["sFocusType"] === this["eFocusType"]["REFOCUSED"]) {
		this["sFocusType"] = this["eFocusType"]["NAVIGATION"];
		return;
	}

	this["oCheckBoxBase"]["updateAriaInfo"](this);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onlsfocus"] = 0; };

/**
 * @private
 * @param {UCF_Control} oDTElement
 * @return {class}
 */
UCF_TriStateCheckBox_standards["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["oGetDTExtension"]++; }; 
	return UCF_TriStateCheckBox.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]('UCF_CheckBoxDTExtension'));
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["oGetDTExtension"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_TriStateCheckBox_standards["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "TriStateCheckBox_standards.js(473): onmouseover"); };

	this["oCheckBoxBase"]["applyTooltip"]();
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["onmouseover"] = 0; };

UCF_TriStateCheckBox_standards["prototype"]["on_508_Internal"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["on_508_Internal"]++; }; 
	return true;
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["on_508_Internal"] = 0; };

/**
 * ###########################################################################
 *
 * SECTION RESPONSIBLE FOR DESTRUCTION OF THE CONTROL
 *
 * ###########################################################################
 */
/**
 * Destructor
 * @private
 */
UCF_TriStateCheckBox_standards["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["destroy"]++; }; 
	this["oCheckBoxBase"]["destroy"]();
	this["oCheckBoxBase"] = null;
	this["sFocusType"] = null;
	this["Delegate_508"] = null;
	this["sState"] = null;
	this["sValue"] = null;
	if (this["Delegate_508"]) {
		this["Delegate_508"]["destroy"]();
		this["Delegate_508"] = null;
	}
	UCF_TriStateCheckBox.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TriStateCheckBox_standards["_"]["destroy"] = 0; };

UCF_TriStateCheckBox_standards.prototype["aPublicMethods"] = ["setValue","setValueState","getEnabled","setEnabled","getEditable","setEditable","getValueState","setValueState"].concat(UCF_TriStateCheckBox_standards.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TypedTemplatePool"] = function() {/* global _trace, DEBUG, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Object */
/// <reference path="../../core/Object.js"/>

/**
 * @typedef {Object} UCF_TypedTemplatePool_Type
 * @property {UCF_ClientElement} template
 * @property {UCF_ClientElement[]} free
 * @property {UCF_ClientElement[]} borrowed
 * @property {number} index
 */

/**
 *
 * Typed template pool instance used for virtualization Based on a TemplateList
 * or a normal template a control can activate virtualization. In this case a
 * TypedTemplatePool instance will be created and for new instances of the same
 * type of clone an instance can be borrowed and returned to the pool. The type
 * name if given is the name of the TemplateItem in the TemplateList. If no
 * template list is used the type name can should not be given. This is also
 * the case for types that do not exit.
 *
 * Before usage a type needs to be added to the typed pool using addType method
 * where the template that should be used for this type is given. The template
 * needs to be a control instance of type UCF_ClientElement. Also the user
 * should add a default template to use via setDefaultType method.
 *
 * The pool internally uses ids for its clones. The real id that the user
 * requested is available for the cloned instance by calling the getRealId
 * method.
 *
 * 
 *
 * @class
 * @param {UCF_Control} oControl
 */
function UCF_TypedTemplatePool(oControl) {if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["UCF_TypedTemplatePool"]++; }; 
	/** @type {UCF_Control} */
	this["oControl"] = oControl;
	/** @type {Object<string, UCF_TypedTemplatePool_Type>} */
	this["mTypes"] = {};
	this["mRealIds"] = {};
	this["mCloneIds"] = {};
};window["UCF_TypedTemplatePool"] = UCF_TypedTemplatePool; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TypedTemplatePool"); UCF_TypedTemplatePool["_"] = {UCF_TypedTemplatePool: 0}; }; ;
UCF_TypedTemplatePool["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_TypedTemplatePool.prototype["sClassName"] = "UCF_TypedTemplatePool";

/**
 * @private
 * @static
 * @type {number}
 */
UCF_TypedTemplatePool["iIndex"] = 0;

/**
 * Sets the default type instance template that is used if object are borrowed
 * that have a none existing type or use the default type
 *
 * @public
 * @param {UCF_ClientElement} oTemplateInstance the instance that is
 * cloned if object are borrowed
 */
UCF_TypedTemplatePool["prototype"]["setDefaultType"] = function(oTemplateInstance) {;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["setDefaultType"]++; }; 
	this["addType"]('__defaulttype', oTemplateInstance);
};;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["setDefaultType"] = 0; };

/**
 * Adds a instance for a given type.
 *
 * @public
 * @param {string} sType the type of the instance
 * @param {UCF_ClientElement} oTemplateInstance the template instance
 */
UCF_TypedTemplatePool["prototype"]["addType"] = function(sType, oTemplateInstance) {;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["addType"]++; }; 
	if (!oTemplateInstance || !oTemplateInstance["clone"]) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'Template is not clonable ' + sType, "TypedTemplatePool.js(76): addType"); };

		return;
	}
	if (this["mTypes"][sType]) {
		this["deleteType"](sType);
	}
	this["mTypes"][sType] = {
		"template": null,
		"free": [],
		"borrowed": [],
		"index": 0
	};
	this["mTypes"][sType]["template"] = oTemplateInstance;
};;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["addType"] = 0; };

/**
 * Returns a new cloned instance for the given type. The id is representing the
 * id that the client would like to use for this instance. This id is available
 * for clones with getRealId() method. If no type is given an instance of the
 * default type is returned.
 *
 * @public
 * @param {string} sType the type of the instance
 * @param {string} sId the real id of the instance that the client likes to use
 * @param {Object} oContext
 * @return {UCF_Element} based on the registered type that was previously added
 * with addType
 */
UCF_TypedTemplatePool["prototype"]["borrowInstance"] = function(sType, sId, oContext) {;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["borrowInstance"]++; }; 
	/** @type {UCF_TypedTemplatePool_Type} */
	var oType;
	/** @type {string} */
	var sCloneId;
	/** @type {UCF_ClientElement} */
	var oTemplate;
	/** @type {UCF_ClientElement} */
	var oInstance;
	/** @type {number} */
	var i;

	if (!sId && sType) {
		sId = sType;
		sType = '';
	}
	if (!sType || sType === '') {
		sType = '__defaulttype';
	}

	oType = this["mTypes"][sType];

	if (!oType) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'No such type ' + sType, "TypedTemplatePool.js(128): getRealId"); };

		return null;
	}

	oTemplate = oType["template"];
	if (!oTemplate) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'No template for ' + sType, "TypedTemplatePool.js(135): getRealId"); };

		return null;
	}

	oInstance = null;
	if (oType["free"]["length"] > 0) {

		//find a free instance with the same context first
		for (i = 0; i < oType["free"]["length"]; i++) {
			if (oContext === oType["free"][i]["getBindingContext"]()) {
				oInstance = oType["free"][i];
				oType["free"]["splice"](i, 1);
				break;
			}
		}
		if (!oInstance) {
			oInstance = oType["free"]["pop"]();
			this["oControl"]["onCloneReturn"](oInstance);
		}
		sCloneId = oInstance["getId"]();
		sId = this["mCloneIds"][sCloneId];
		this["mRealIds"][sId] = sCloneId;
		oInstance["_sRealId"] = sId;
		oInstance["_bFree"] = false;
	} else {
		sCloneId = this["oControl"]["getId"]() + '_' + sType + '_' + (UCF_TypedTemplatePool["iIndex"]++);

		oInstance = oTemplate["clone"](sCloneId, oContext);
		sCloneId = oInstance["getId"]();
		this["mRealIds"][sId] = sCloneId;
		this["mCloneIds"][sCloneId] = sId;
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Clone created ' + sCloneId + ' for ' + sId, "TypedTemplatePool.js(167): getRealId"); };
		oInstance["_sRealId"] = sId;
		oInstance["getRealId"] = function() {
			return this["_sRealId"];
		};
		oInstance["getTemplateId"] = function() {
			return oTemplate["getId"]();
		};
		oInstance["_bFree"] = false;
		this["oControl"]["onCloneCreate"](oInstance);
	}
	oType["borrowed"]["push"](oInstance);

	return oInstance;
};;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["borrowInstance"] = 0; };

/**
 * Returns the instance with the given id (real id) and the type to
 * the pool
 *
 * @param {string} sType the type of the instance
 * @param {string} sId the real id of the instance that the client likes to use
 *
 * @public
 */
UCF_TypedTemplatePool["prototype"]["returnInstance"] = function(sType, sId) {;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["returnInstance"]++; }; 
	/** @type {UCF_TypedTemplatePool_Type} */
	var oType;
	/** @type {number} */
	var i;
	/** @type {string} */
	var sCloneId;
	/** @type {string} */
	var sRealId;
	/** @type {UCF_ClientElement} */
	var oBorrowedObject;

	if (!sId && sType) {
		sId = sType;
		sType = '';
	}
	if (!sType || sType === '') {
		sType = '__defaulttype';
	}

	oType = this["mTypes"][sType];
	if (!oType) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'No such type ' + sType, "TypedTemplatePool.js(214): returnInstance"); };

		return;
	}

	for (i = 0; i < oType["borrowed"]["length"]; i++) {
		sCloneId = oType["borrowed"][i]["getId"]();
		sRealId = this["mCloneIds"][sCloneId];

		if (sId === sRealId) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Clone returned ' + sCloneId, "TypedTemplatePool.js(224): returnInstance"); };
			delete this["mRealIds"][sId];
			delete this["mCloneIds"][sCloneId];

			oBorrowedObject = oType["borrowed"][i];
			oBorrowedObject["_bFree"] = true;
			oType["free"]["push"](oBorrowedObject);
			oType["borrowed"]["splice"](i, 1);

			return;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["returnInstance"] = 0; };

/**
 * Checks whether a given type uses the given template instance for cloning.
 *
 * @public
 * @param {string} sType the type of the instance
 * @param {UCF_Element} oTemplateInstance the template instance
 * @return {boolean}
 */
UCF_TypedTemplatePool["prototype"]["checkType"] = function(sType, oTemplateInstance) {;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["checkType"]++; }; 
	if (!oTemplateInstance && typeof sType === 'object') {
		oTemplateInstance = sType;
		sType = '';
	}
	if (sType === '') {
		sType = '__defaulttype';
	}
	if (this["mTypes"][sType]) {
		return oTemplateInstance === this["mTypes"][sType]["template"];
	}

	return false;
};;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["checkType"] = 0; };

/**
 * Returns the template for the given type
 * @param {string} sType
 * @return {UCF_ClientElement}
 */
UCF_TypedTemplatePool["prototype"]["getTemplate"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["getTemplate"]++; }; 
	if (!sType) {
		sType = '__defaulttype';
	}
	if (this["mTypes"][sType]["template"]) {
		return this["mTypes"][sType]["template"];
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["getTemplate"] = 0; };
/**
 * Returns all borrowed instances of all types to the pool of free cells
 * @public
 */
UCF_TypedTemplatePool["prototype"]["returnAll"] = function() {;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["returnAll"]++; }; 
	/** @type {string} */
	var n;
	/** @type {Object} */
	var oType;
	/** @type {number} */
	var i;
	/** @type {string} */
	var sCloneId;

	for (n in this["mTypes"]) {
		oType = this["mTypes"][n];

		for (i = 0; i < oType["borrowed"]["length"]; i++) {
			sCloneId = oType["borrowed"][i]["getId"]();

			delete this["mRealIds"][this["mCloneIds"][sCloneId]];
			delete this["mCloneIds"][sCloneId];

			oType["free"]["push"](oType["borrowed"][i]);
		}
		oType["borrowed"] = [];
	}
};;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["returnAll"] = 0; };

/**
 * Delivers a list of borrowed instances
 *
 * @public
 * @param {string} sType the type of the instance
 * @return {UCF_ClientElement[]}
 */
UCF_TypedTemplatePool["prototype"]["getBorrowedInstances"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["getBorrowedInstances"]++; }; 
	/** @type {UCF_TypedTemplatePool_Type} */
	var oType = this["mTypes"][(!sType || sType === '') ? '__defaulttype' : sType];

	return oType && oType["borrowed"];
};;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["getBorrowedInstances"] = 0; };

/**
 * Delivers a list of free instances
 *
 * @public
 * @return {UCF_ClientElement[]}
 */
UCF_TypedTemplatePool["prototype"]["getFreeInstances"] = function() {;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["getFreeInstances"]++; }; 
	/** @type {UCF_ClientElement[]} */
	var aFree = [];
	/** @type {string} */
	var n;
	/** @type {UCF_TypedTemplatePool_Type} */
	var oType;
	/** @type {number} */
	var i;

	for (n in this["mTypes"]) {
		oType = this["mTypes"][n];
		for (i = 0; i < oType["free"]["length"]; i++) {
			aFree["push"](oType["free"][i]);
		}
	}

	return aFree;
};;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["getFreeInstances"] = 0; };

/**
 * Deletes all cloned instances of a given type from the pools
 *
 * @public
 * @param {string} sType the type of the instance
 */
UCF_TypedTemplatePool["prototype"]["deleteType"] = function(sType) {;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["deleteType"]++; }; 
	var oType = this["mTypes"][sType];
	var oInstance;

	if (oType) {
		//delete the old instances
		while (oType["borrowed"]["length"] > 0) {
			oInstance = oType["borrowed"]["pop"]();
			this["oControl"]["onCloneDelete"](oInstance);
			oInstance["destroy"]();
		}
		while (oType["free"]["length"] > 0) {
			oInstance = oType["free"]["pop"]();
			this["oControl"]["onCloneDelete"](oInstance);
			oInstance["destroy"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["deleteType"] = 0; };

/**
 * @public
 * Destroy the TypedTemplatePool and deletes all cloned instances
 */
UCF_TypedTemplatePool["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["destroy"]++; }; 
	/** @type {string} */
	var n;

	for (n in this["mTypes"]) {
		this["deleteType"](n);
	}

	this["oControl"] = null;

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TypedTemplatePool["_"]["destroy"] = 0; };

UCF_TypedTemplatePool.prototype["aPublicMethods"] = ["setDefaultType","addType","borrowInstance","returnInstance","checkType","returnAll","getBorrowedInstances","getFreeInstances","deleteType","destroy"].concat(UCF_TypedTemplatePool.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_TypingBuffer"] = function() {/* global _trace, INFO */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_EventProvider */
/// <reference path="../../../core/EventProvider.js"/>

/** @class */
function UCF_TypingBuffer() {if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["UCF_TypingBuffer"]++; }; 
	UCF_EventProvider["apply"](this);

	this["defineEvents"](['LIVECHANGE', 'STOPPED']);

	this["initialize"]();
};window["UCF_TypingBuffer"] = UCF_TypingBuffer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_TypingBuffer"); UCF_TypingBuffer["_"] = {UCF_TypingBuffer: 0}; }; ;
UCF_TypingBuffer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_EventProvider"))(); UCF_TypingBuffer.prototype["sClassName"] = "UCF_TypingBuffer";

UCF_TypingBuffer["prototype"]["initialize"] = function(iWaitTime, sValue) {;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["initialize"]++; }; 
	this["stop"]();
	this["iTimer"] = null;
	this["sValue"] = sValue || "";
	this["bDirty"] = false;
	this["iWaitTime"] = typeof(iWaitTime) == "number" ? iWaitTime : 650;
};;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["initialize"] = 0; };

UCF_TypingBuffer["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["destroy"]++; }; 
	this["stop"]();
	this["iTimer"] = null;
	this["sValue"] = null;
	this["iWaitTime"] = null;

	UCF_EventProvider.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["destroy"] = 0; };

UCF_TypingBuffer["prototype"]["start"] = function() {;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["start"]++; }; 
	this["iTimer"] = UCF_JsUtil["delayedCall"](this["iWaitTime"], this, "_stop", [true]);
};;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["start"] = 0; };

UCF_TypingBuffer["prototype"]["addChar"] = function(sChar) {;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["addChar"]++; }; 
	this["stop"]();
	this["bDirty"] = true;
	this["sValue"] += sChar;
	this["fireEvent"](this["E_EVENTS"]["LIVECHANGE"], { "Value": this["sValue"] });
	this["start"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "TypingBuffer added char " + sChar + ", Value:" + this["sValue"], "TypingBuffer.js(45): addChar"); };
};;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["addChar"] = 0; };

UCF_TypingBuffer["prototype"]["setWaitTime"] = function(iMilliSeconds) {;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["setWaitTime"]++; }; 
	this["iWaitTime"] = iMilliSeconds;
};;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["setWaitTime"] = 0; };

UCF_TypingBuffer["prototype"]["stop"] = function() {;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["stop"]++; }; 
	if (this["iTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["iTimer"]);
	}
};;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["stop"] = 0; };

UCF_TypingBuffer["prototype"]["_stop"] = function() {;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["_stop"]++; }; 
	this["stop"]();
	if (this["bDirty"]) {
		this["fireEvent"](this["E_EVENTS"]["STOPPED"], { "Value": this["sValue"] });
	}
};;if (__UCF_COVERAGE__) { UCF_TypingBuffer["_"]["_stop"] = 0; };

};
sap["ls"]["preload"]["UCF_UI5WebComponent"] = function() {/* global _assert, _trace, UCF_Tracer, WARNING, ERROR, DEBUG */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../../core/enums/KeyCodes.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../../core/util/ClassLoader.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_StringUtil */
/// <reference path="../../../core/util/StringUtil.js"/>
/* global UCF_ScrollArea */
/// <reference path="../../controls/base/ScrollArea.js"/>
/* global UCF_Hotkeys */
/// <reference path="../../controls/Hotkeys.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>

/**
 * UI5 WebComponent control:
 * Derived class naming covention: 'ui5-some-component' <-> '(UCF_)SomeComponent'.
 * Events are also mapped via naming convention.
 * @class
 * @extends UCF_Control
 * @param { HTMLElement } oDomRef
 * @param { UCF_LS } oLS LS instance
 */
function UCF_UI5WebComponent(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["UCF_UI5WebComponent"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "UI5WebComponent.js(39): UCF_UI5WebComponent"); };
		UCF_Control["apply"](this, [oDomRef, oLS]);
	}

	// We access the CustomElement because we are interested in the meta-data for event-mapping
	// this.oDomRef is the root node containing the shadow-DOM and it provides the events and methods.

	/** @type {HTMLElement} */
	this["oCustomElement"] = null;

	this["sUI5WwebComponentName"] = null;
	this["oEventHandlers"] = {};
};window["UCF_UI5WebComponent"] = UCF_UI5WebComponent; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_UI5WebComponent"); UCF_UI5WebComponent["_"] = {UCF_UI5WebComponent: 0}; }; ;
UCF_UI5WebComponent["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_UI5WebComponent.prototype["sClassName"] = "UCF_UI5WebComponent";

UCF_UI5WebComponent["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["destroy"]++; }; 
	this["oCustomElement"] = null;
	this["sUI5WwebComponentName"] = null;
	var _this = this;
	UCF_JsUtil["forEach"](UCF_JsUtil["keys"](this["oEventHandlers"]), function(sUI5EventName) {
		_this["oDomRef"]["removeEventListener"](sUI5EventName, _this["oEventHandlers"][sUI5EventName]);
	});
	this["oEventHandlers"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["destroy"] = 0; };

/**
 * @private
 */
UCF_UI5WebComponent["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["initialize"]++; }; 
	if (__UCF_IE6__) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, this["sClassName"] + ' is supported in standards mode only', "UI5WebComponent.js(70): initialize"); };
		// eslint-disable-next-line no-unsanitized/property
		this["oDomRef"]["innerHTML"] = this["oLS"]
			["sGetText"](
				"SAPUR_HTML5_CONTROL_ERROR",
				["<a target=\"_blank\" href=\"https://service.sap.com/sap/support/notes/1970689\">Note 1970689</a>",
					"ColorPalette"]
			);
		return;
	}

	// UI5 config
	var UI5_CONFIG_SCRIPT_ID = 'ls-ui5-config';
	if (!UCF_DomUtil["$"](UI5_CONFIG_SCRIPT_ID)) {
		var oScript = document["createElement"]("script");
		oScript["id"] = UI5_CONFIG_SCRIPT_ID;
		oScript["type"] = "application/json";
		oScript["setAttribute"]('data-ui5-config', '');
		oScript["innerText"] = JSON["stringify"]({
			"theme": window["UCF_System"]["sThemeID"],
			"language": window["UCF_System"]["sLanguage"]
		});
		document["getElementsByTagName"]("HEAD")[0]["appendChild"](oScript);
	}

	// Load bundle script from resource root
	// Page will load scripts only once - BUT it will trigger the callback again,
	// e.g. when client-side re-rendering.
	this["oLS"]["oGetPageInternal"]()["addScript"](
		UCF_ResourceUtil["sGetUI5WebCompomentRoot"]() + '/index.js',
		null,
		{ "async": 'true' },
		this,
		'onScriptsLoaded'
	);
};;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["initialize"] = 0; };

UCF_UI5WebComponent["prototype"]["onScriptsLoaded"] = function() {;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["onScriptsLoaded"]++; }; 
	if (this["bIsDestroyed"]) return;
	if (!this["oDomRef"]) return;
	this["init"]();
};;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["onScriptsLoaded"] = 0; };

UCF_UI5WebComponent["prototype"]["init"] = function() {;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["init"]++; }; 
	this["sUI5WwebComponentName"] = 'ui5' + UCF_StringUtil["sDasherize"](this["sClassName"]["replace"]('UCF_', ''));
	this["oCustomElement"] = window["customElements"]["get"](this["sUI5WwebComponentName"]);
	if (!this["oCustomElement"]) {
		// Reasons for this error
		// - control name does not adhere to the naming convention (kebab case <-> camel case)
		// - UI5 has a problem with the configuration, e.g. an unsupported theme
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'UI5 web-component custom element not found: ' + this["sUI5WwebComponentName"], "UI5WebComponent.js(120): init"); };
		return;
	}
	this["mapEvents"]();
	this["mapMethods"]();
};;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["init"] = 0; };

/**
 * Map UI5 component events to UR interface events when the name fits the mapping and listeners are registered.
 * E.g. item-click -> ItemClick
 * @private
 */
UCF_UI5WebComponent["prototype"]["mapEvents"] = function() {;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["mapEvents"]++; }; 
	var oInterface = UCF_ClassLoader["oGetClass"]('UCF_ClientInterfaces')["getInterface"](this["sClassName"]["replace"]('UCF_', ''));
	for (var sUI5EventName in this["oCustomElement"]["metadata"]["events"]) {
		var sEventName = UCF_StringUtil["sCamelize"](sUI5EventName);
		sEventName = sEventName["substring"](0, 1)["toUpperCase"]() + sEventName["substring"](1);
		if (oInterface["events"][sEventName] && this["bHasEventListeners"](sEventName)) {
			var _this = this;
			this["oEventHandlers"][sUI5EventName] = function(oCustomEvent) {
				var aParams = [];
				for (var d in oCustomEvent["detail"]) {
					// We cannot check/map parameter names because they are not contained in ClientInterfaces.js
					// Events have to be defined in the interface in the same order as the custom event.
					aParams["push"](oCustomEvent["detail"][d]);
				}
				_this['fire' + sEventName]["apply"](_this, [_this["sId"]]["concat"](aParams));
			};
			this["oDomRef"]["addEventListener"](sUI5EventName, this["oEventHandlers"][sUI5EventName]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["mapEvents"] = 0; };

/**
 * Map UI5 component's methods to UR interface methods: Add implementation that forwards the call.
 * The method name in UR interface must be exactly the same as in UI5 component and have parameters with the same type and order.
 */
UCF_UI5WebComponent["prototype"]["mapMethods"] = function() {;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["mapMethods"]++; }; 
	var oInterface = UCF_ClassLoader["oGetClass"]('UCF_ClientInterfaces')["getInterface"](this["sClassName"]["replace"]('UCF_', ''));
	var aPM = oInterface["publicMethods"];
	if (!aPM || aPM["length"] === 0) return;
	for (var i = 0; i < aPM["length"]; i++) {
		var sMethodName = aPM[i];
		if (typeof (this["oDomRef"][sMethodName]) === 'function') {
			var _this = this;
			this[sMethodName] = function() { // eslint-disable-line @ur/no-memory-leaks
				_this["oDomRef"][sMethodName]["apply"](_this["oDomRef"], arguments);
			};
		}
	}
};;if (__UCF_COVERAGE__) { UCF_UI5WebComponent["_"]["mapMethods"] = 0; };


};
sap["ls"]["preload"]["UCF_UrBase"] = function() {/* global _assert */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_RenderManager */
/// <reference path="../../core/RenderManager.js"/>

/** @class
 * Implements a Lightspeed ColorItem control
 *
 * <br>
 * <b>Java Control references</b><br>
 * <a href="../javadoc/com/sap/tc/ls/api/controls/LSColorItem.html">ColorItem</a>
 *
 * 
 *
 * @version
 */
function UCF_UrBase(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_UrBase["_"]["UCF_UrBase"]++; }; 
	// necessary for inheritance
	if (arguments["length"] == 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "UrBase.js(25): UCF_UrBase"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_UrBase"] = UCF_UrBase; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_UrBase"); UCF_UrBase["_"] = {UCF_UrBase: 0}; }; ;

UCF_UrBase["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_UrBase.prototype["sClassName"] = "UCF_UrBase";

/** @return the CSS implementing the semantic color
 * @type string
 *
 * Copy of the method from UrBase
 */
UCF_UrBase["getSemanticColor"] = function(sSemanticColor) {;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["getSemanticColor"]++; };  // eslint-disable-line complexity
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSemanticColor) == "string", "typeof(sSemanticColor) == \"string\"", "UrBase.js(38): getSemanticColor"); };
	switch (sSemanticColor) {
		case 'ALTERNATING':
			return 'lsSemanticColor--background urAlt';
		case 'TRANSPARENT':
			return 'lsSemanticColor--background urTrans';
		case 'NEGATIVE':
			return 'lsSemanticColor--background urNeg';
		case 'POSITIVE':
			return 'lsSemanticColor--background urPos';
		case 'TOTAL':
			return 'lsSemanticColor--background urTot';
		case 'SUBTOTAL':
			return 'lsSemanticColor--background urSubtot';
		case 'SUBTOTAL_LIGHT':
			return 'lsSemanticColor--background urSubtotLight';
		case 'BADVALUE_DARK':
			return 'lsSemanticColor--background urBadDark';
		case 'BADVALUE_MEDIUM':
			return 'lsSemanticColor--background urBadMedium';
		case 'BADVALUE_LIGHT':
			return 'lsSemanticColor--background urBadLight';
		case 'CRITICAL':
			return 'lsSemanticColor--background urCrit';
		case 'CRITICALVALUE_DARK':
			return 'lsSemanticColor--background urCritDark';
		case 'CRITICALVALUE_MEDIUM':
			return 'lsSemanticColor--background urCritMedium';
		case 'CRITICALVALUE_LIGHT':
			return 'lsSemanticColor--background urCritLight';
		case 'GOODVALUE_DARK':
			return 'lsSemanticColor--background urGoodDark';
		case 'GOODVALUE_MEDIUM':
			return 'lsSemanticColor--background urGoodMedium';
		case 'GOODVALUE_LIGHT':
			return 'lsSemanticColor--background urGoodLight';
		case 'GROUP_HIGHLIGHTED':
			return 'lsSemanticColor--background urGrpHL';
		case 'GROUP_HIGHLIGHTED_LIGHT':
			return 'lsSemanticColor--background urGrpHLLight';
		case 'KEY_MEDIUM':
			return 'lsSemanticColor--background urKeyMedium';
		case 'GROUP_LEVEL1':
			return 'lsSemanticColor--background urGrpLvl1';
		case 'GROUP_LEVEL2':
			return 'lsSemanticColor--background urGrpLvl2';
		case 'GROUP_LEVEL3':
			return 'lsSemanticColor--background urGrpLvl3';
		case 'MARKED':
			return 'lsSemanticColor--background urMarked';
		case 'POPIN':
			return 'lsSemanticColor--background urPopIn';
		case 'DISABLED':
			return 'lsSemanticColor--background urDNDsbl';
		case 'TODAY':
			return 'lsSemanticColor--background urToday';
		case 'SELECTED1':
			return 'lsSemanticColor--background urSel1';
		case 'SELECTED2':
			return 'lsSemanticColor--background urSel2';
		case 'SELECTED3':
			return 'lsSemanticColor--background urSel3';
		case 'SELECTED4':
			return 'lsSemanticColor--background urSel4';
		case 'SELECTED5':
			return 'lsSemanticColor--background urSel5';
		case 'CALENDAR_METAL':
			return 'lsSemanticColor--background urMetal';
		case 'CALENDAR_PEACH':
			return 'lsSemanticColor--background urPeach';
		case 'CALENDAR_BLUE':
			return 'lsSemanticColor--background urBlue';
		case 'CALENDAR_ROSE':
			return 'lsSemanticColor--background urRose';
		case 'CALENDAR_PURPLE':
			return 'lsSemanticColor--background urPurple';
		case 'CALENDAR_AQUA':
			return 'lsSemanticColor--background urAqua';
		case 'CALENDAR_TEAL':
			return 'lsSemanticColor--background urTeal';
		case 'CALENDAR_YELLOW':
			return 'lsSemanticColor--background urYellow';
		case 'CALENDAR_BROWN':
			return 'lsSemanticColor--background urBrown';
		case 'CALENDAR_DEFAULT':
			return 'lsSemanticColor--background urCalDefault';
		case 'CALENDAR_GREEN':
			return 'lsSemanticColor--background urGreen';
		case 'COLOR_BLACK':
			return 'lsSemanticColor--background urColorBlack';
		case 'COLOR_BROWN':
			return 'lsSemanticColor--background urColorBrown';
		case 'COLOR_OLIVE_GREEN':
			return 'lsSemanticColor--background urColorOliveGreen';
		case 'COLOR_DARK_GREEN':
			return 'lsSemanticColor--background urColorDarkGreen';
		case 'COLOR_DARK_TEAL':
			return 'lsSemanticColor--background urColorDarkTeal';
		case 'COLOR_DARK_BLUE':
			return 'lsSemanticColor--background urColorDarkBlue';
		case 'COLOR_INDIGO':
			return 'lsSemanticColor--background urColorIndigo';
		case 'COLOR_GRAY_80':
			return 'lsSemanticColor--background urColorGray80';
		case 'COLOR_DARK_RED':
			return 'lsSemanticColor--background urColorDarkRed';
		case 'COLOR_ORANGE':
			return 'lsSemanticColor--background urColorOrange';
		case 'COLOR_DARK_YELLOW':
			return 'lsSemanticColor--background urColorDarkYellow';
		case 'COLOR_GREEN':
			return 'lsSemanticColor--background urColorGreen';
		case 'COLOR_TEAL':
			return 'lsSemanticColor--background urColorTeal';
		case 'COLOR_BLUE':
			return 'lsSemanticColor--background urColorBlue';
		case 'COLOR_BLUE_GRAY':
			return 'lsSemanticColor--background urColorBlueGray';
		case 'COLOR_GRAY_50':
			return 'lsSemanticColor--background urColorGray50';
		case 'COLOR_RED':
			return 'lsSemanticColor--background urColorRed';
		case 'COLOR_LIGHT_ORANGE':
			return 'lsSemanticColor--background urColorLightOrange';
		case 'COLOR_LIME':
			return 'lsSemanticColor--background urColorLime';
		case 'COLOR_SEA_GREEN':
			return 'lsSemanticColor--background urColorSeaGreen';
		case 'COLOR_AQUA':
			return 'lsSemanticColor--background urColorAqua';
		case 'COLOR_LIGHT_BLUE':
			return 'lsSemanticColor--background urColorLightBlue';
		case 'COLOR_VIOLET':
			return 'lsSemanticColor--background urColorViolet';
		case 'COLOR_GRAY_40':
			return 'lsSemanticColor--background urColorGray40';
		case 'COLOR_PINK':
			return 'lsSemanticColor--background urColorPink';
		case 'COLOR_GOLD':
			return 'lsSemanticColor--background urColorGold';
		case 'COLOR_YELLOW':
			return 'lsSemanticColor--background urColorYellow';
		case 'COLOR_BRIGHT_GREEN':
			return 'lsSemanticColor--background urColorBrightGreen';
		case 'COLOR_TURQUOISE':
			return 'lsSemanticColor--background urColorTurquoise';
		case 'COLOR_SKY_BLUE':
			return 'lsSemanticColor--background urColorSkyBlue';
		case 'COLOR_PLUM':
			return 'lsSemanticColor--background urColorPlum';
		case 'COLOR_GRAY_25':
			return 'lsSemanticColor--background urColorGray25';
		case 'COLOR_ROSE':
			return 'lsSemanticColor--background urColorRose';
		case 'COLOR_TAN':
			return 'lsSemanticColor--background urColorTan';
		case 'COLOR_LIGHT_YELLOW':
			return 'lsSemanticColor--background urColorLightYellow';
		case 'COLOR_LIGHT_GREEN':
			return 'lsSemanticColor--background urColorLightGreen';
		case 'COLOR_LIGHT_TURQUOISE':
			return 'lsSemanticColor--background urColorLightTurquoise';
		case 'COLOR_PALE_BLUE':
			return 'lsSemanticColor--background urColorPaleBlue';
		case 'COLOR_LAVENDER':
			return 'lsSemanticColor--background urColorLavender';
		case 'COLOR_WHITE':
			return 'lsSemanticColor--background urColorWhite';
		case 'COLOR_A_1':
			return 'lsSemanticColor--background urColorRedDarkest';
		case 'COLOR_A_2':
			return 'lsSemanticColor--background urColorRedVeryDark';
		case 'COLOR_A_3':
			return 'lsSemanticColor--background urColorRedDark';
		case 'COLOR_A_4':
			return 'lsSemanticColor--background urColorRedMediumDark';
		case 'COLOR_A_5':
			return 'lsSemanticColor--background urColorRedMedium';
		case 'COLOR_A_6':
			return 'lsSemanticColor--background urColorRedMediumLight';
		case 'COLOR_A_7':
			return 'lsSemanticColor--background urColorRedLight';
		case 'COLOR_A_8':
			return 'lsSemanticColor--background urColorRedVeryLight';
		case 'COLOR_A_9':
			return 'lsSemanticColor--background urColorRedLightest';
		case 'COLOR_B_1':
			return 'lsSemanticColor--background urColorYellowDarkest';
		case 'COLOR_B_2':
			return 'lsSemanticColor--background urColorYellowVeryDark';
		case 'COLOR_B_3':
			return 'lsSemanticColor--background urColorYellowDark';
		case 'COLOR_B_4':
			return 'lsSemanticColor--background urColorYellowMediumDark';
		case 'COLOR_B_5':
			return 'lsSemanticColor--background urColorYellowMedium';
		case 'COLOR_B_6':
			return 'lsSemanticColor--background urColorYellowMediumLight';
		case 'COLOR_B_7':
			return 'lsSemanticColor--background urColorYellowLight';
		case 'COLOR_B_8':
			return 'lsSemanticColor--background urColorYellowVeryLight';
		case 'COLOR_B_9':
			return 'lsSemanticColor--background urColorYellowLightest';
		case 'COLOR_C_1':
			return 'lsSemanticColor--background urColorGreenDarkest';
		case 'COLOR_C_2':
			return 'lsSemanticColor--background urColorGreenVeryDark';
		case 'COLOR_C_3':
			return 'lsSemanticColor--background urColorGreenDark';
		case 'COLOR_C_4':
			return 'lsSemanticColor--background urColorGreenMediumDark';
		case 'COLOR_C_5':
			return 'lsSemanticColor--background urColorGreenMedium';
		case 'COLOR_C_6':
			return 'lsSemanticColor--background urColorGreenMediumLight';
		case 'COLOR_C_7':
			return 'lsSemanticColor--background urColorGreenLight';
		case 'COLOR_C_8':
			return 'lsSemanticColor--background urColorGreenVeryLight';
		case 'COLOR_C_9':
			return 'lsSemanticColor--background urColorGreenLightest';
		case 'COLOR_D_1':
			return 'lsSemanticColor--background urColorBlueDarkest';
		case 'COLOR_D_2':
			return 'lsSemanticColor--background urColorBlueVeryDark';
		case 'COLOR_D_3':
			return 'lsSemanticColor--background urColorBlueDark';
		case 'COLOR_D_4':
			return 'lsSemanticColor--background urColorBlueMediumDark';
		case 'COLOR_D_5':
			return 'lsSemanticColor--background urColorBlueMedium';
		case 'COLOR_D_6':
			return 'lsSemanticColor--background urColorBlueMediumLight';
		case 'COLOR_D_7':
			return 'lsSemanticColor--background urColorBlueLight';
		case 'COLOR_D_8':
			return 'lsSemanticColor--background urColorBlueVeryLight';
		case 'COLOR_D_9':
			return 'lsSemanticColor--background urColorBlueLightest';
		case 'COLOR_E_1':
			return 'lsSemanticColor--background urColorGreyDarkest';
		case 'COLOR_E_2':
			return 'lsSemanticColor--background urColorGreyVeryDark';
		case 'COLOR_E_3':
			return 'lsSemanticColor--background urColorGreyDark';
		case 'COLOR_E_4':
			return 'lsSemanticColor--background urColorGreyMediumDark';
		case 'COLOR_E_5':
			return 'lsSemanticColor--background urColorGreyMedium';
		case 'COLOR_E_6':
			return 'lsSemanticColor--background urColorGreyMediumLight';
		case 'COLOR_E_7':
			return 'lsSemanticColor--background urColorGreyLight';
		case 'COLOR_E_8':
			return 'lsSemanticColor--background urColorGreyVeryLight';
		case 'COLOR_E_9':
			return 'lsSemanticColor--background urColorGreyLightest';
		default:
			return "";
	}
};;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["getSemanticColor"] = 0; };

/** @return the CSS implementing the semantic color
 * @type string
 *
 * Copy of the method from UrBase
 */
UCF_UrBase["getSemanticTextColor"] = function(sTextColor) {;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["getSemanticTextColor"]++; };  // eslint-disable-line complexity
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTextColor) == "string", "typeof(sTextColor) == \"string\"", "UrBase.js(307): getSemanticTextColor"); };
	switch (sTextColor) {
		case 'ALTERNATING':
			return 'lsSemanticColor--background urColorTxtAlt';
		case 'TRANSPARENT':
			return 'lsSemanticColor--background urColorTxtTrans';
		case 'NEGATIVE':
			return 'lsSemanticColor--background urColorTxtNeg';
		case 'POSITIVE':
			return 'lsSemanticColor--background urColorTxtPos';
		case 'TOTAL':
			return 'lsSemanticColor--background urColorTxtTot';
		case 'SUBTOTAL':
			return 'lsSemanticColor--background urColorTxtSubtot';
		case 'SUBTOTAL_LIGHT':
			return 'lsSemanticColor--background urColorTxtSubtotLight';
		case 'BADVALUE_DARK':
			return 'lsSemanticColor--background urColorTxtBadDark';
		case 'BADVALUE_MEDIUM':
			return 'lsSemanticColor--background urColorTxtBadMedium';
		case 'BADVALUE_LIGHT':
			return 'lsSemanticColor--background urColorTxtBadLight';
		case 'CRITICAL':
			return 'lsSemanticColor--background urColorTxtCrit';
		case 'CRITICALVALUE_DARK':
			return 'lsSemanticColor--background urColorTxtCritDark';
		case 'CRITICALVALUE_MEDIUM':
			return 'lsSemanticColor--background urColorTxtCritMedium';
		case 'CRITICALVALUE_LIGHT':
			return 'lsSemanticColor--background urColorTxtCritLight';
		case 'GOODVALUE_DARK':
			return 'lsSemanticColor--background urColorTxtGoodDark';
		case 'GOODVALUE_MEDIUM':
			return 'lsSemanticColor--background urColorTxtGoodMedium';
		case 'GOODVALUE_LIGHT':
			return 'lsSemanticColor--background urColorTxtGoodLight';
		case 'GROUP_HIGHLIGHTED':
			return 'lsSemanticColor--background urColorTxtGrpHL';
		case 'GROUP_HIGHLIGHTED_LIGHT':
			return 'lsSemanticColor--background urColorTxtGrpHLLight';
		case 'KEY_MEDIUM':
			return 'lsSemanticColor--background urColorTxtKeyMedium';
		case 'GROUP_LEVEL1':
			return 'lsSemanticColor--background urColorTxtGrpLvl1';
		case 'GROUP_LEVEL2':
			return 'lsSemanticColor--background urColorTxtGrpLvl2';
		case 'GROUP_LEVEL3':
			return 'lsSemanticColor--background urColorTxtGrpLvl3';
		case 'MARKED':
			return 'lsSemanticColor--background urColorTxtMarked';
		case 'POPIN':
			return 'lsSemanticColor--background urColorTxtPopIn';
		case 'DISABLED':
			return 'lsSemanticColor--background urColorTxtDNDsbl';
		case 'TODAY':
			return 'lsSemanticColor--background urColorTxtToday';
		case 'SELECTED1':
			return 'lsSemanticColor--background urColorTxtSel1';
		case 'SELECTED2':
			return 'lsSemanticColor--background urColorTxtSel2';
		case 'SELECTED3':
			return 'lsSemanticColor--background urColorTxtSel3';
		case 'SELECTED4':
			return 'lsSemanticColor--background urColorTxtSel4';
		case 'SELECTED5':
			return 'lsSemanticColor--background urColorTxtSel5';
		case 'CALENDAR_METAL':
			return 'lsSemanticColor--background urColorTxtMetal';
		case 'CALENDAR_PEACH':
			return 'lsSemanticColor--background urColorTxtPeach';
		case 'CALENDAR_BLUE':
			return 'lsSemanticColor--background urColorTxtBlue';
		case 'CALENDAR_ROSE':
			return 'lsSemanticColor--background urColorTxtRose';
		case 'CALENDAR_PURPLE':
			return 'lsSemanticColor--background urColorTxtPurple';
		case 'CALENDAR_AQUA':
			return 'lsSemanticColor--background urColorTxtAqua';
		case 'CALENDAR_TEAL':
			return 'lsSemanticColor--background urColorTxtTeal';
		case 'CALENDAR_YELLOW':
			return 'lsSemanticColor--background urColorTxtYellow';
		case 'CALENDAR_BROWN':
			return 'lsSemanticColor--background urColorTxtBrown';
		case 'CALENDAR_DEFAULT':
			return 'lsSemanticColor--background urColorTxtCalDefault';
		case 'CALENDAR_GREEN':
			return 'lsSemanticColor--background urColorTxtGreen';
		case 'COLOR_BLACK':
			return 'lsSemanticColor--background urColorTxtBlack';
		case 'COLOR_BROWN':
			return 'lsSemanticColor--background urColorTxtBrown';
		case 'COLOR_OLIVE_GREEN':
			return 'lsSemanticColor--background urColorTxtOliveGreen';
		case 'COLOR_DARK_GREEN':
			return 'lsSemanticColor--background urColorTxtDarkGreen';
		case 'COLOR_DARK_TEAL':
			return 'lsSemanticColor--background urColorTxtDarkTeal';
		case 'COLOR_DARK_BLUE':
			return 'lsSemanticColor--background urColorTxtDarkBlue';
		case 'COLOR_INDIGO':
			return 'lsSemanticColor--background urColorTxtIndigo';
		case 'COLOR_GRAY_80':
			return 'lsSemanticColor--background urColorTxtGray80';
		case 'COLOR_DARK_RED':
			return 'lsSemanticColor--background urColorTxtDarkRed';
		case 'COLOR_ORANGE':
			return 'lsSemanticColor--background urColorTxtOrange';
		case 'COLOR_DARK_YELLOW':
			return 'lsSemanticColor--background urColorTxtDarkYellow';
		case 'COLOR_GREEN':
			return 'lsSemanticColor--background urColorTxtGreen';
		case 'COLOR_TEAL':
			return 'lsSemanticColor--background urColorTxtTeal';
		case 'COLOR_BLUE':
			return 'lsSemanticColor--background urColorTxtBlue';
		case 'COLOR_BLUE_GRAY':
			return 'lsSemanticColor--background urColorTxtBlueGray';
		case 'COLOR_GRAY_50':
			return 'lsSemanticColor--background urColorTxtGray50';
		case 'COLOR_RED':
			return 'lsSemanticColor--background urColorTxtRed';
		case 'COLOR_LIGHT_ORANGE':
			return 'lsSemanticColor--background urColorTxtLightOrange';
		case 'COLOR_LIME':
			return 'lsSemanticColor--background urColorTxtLime';
		case 'COLOR_SEA_GREEN':
			return 'lsSemanticColor--background urColorTxtSeaGreen';
		case 'COLOR_AQUA':
			return 'lsSemanticColor--background urColorTxtAqua';
		case 'COLOR_LIGHT_BLUE':
			return 'lsSemanticColor--background urColorTxtLightBlue';
		case 'COLOR_VIOLET':
			return 'lsSemanticColor--background urColorTxtViolet';
		case 'COLOR_GRAY_40':
			return 'lsSemanticColor--background urColorTxtGray40';
		case 'COLOR_PINK':
			return 'lsSemanticColor--background urColorTxtPink';
		case 'COLOR_GOLD':
			return 'lsSemanticColor--background urColorTxtGold';
		case 'COLOR_YELLOW':
			return 'lsSemanticColor--background urColorTxtYellow';
		case 'COLOR_BRIGHT_GREEN':
			return 'lsSemanticColor--background urColorTxtBrightGreen';
		case 'COLOR_TURQUOISE':
			return 'lsSemanticColor--background urColorTxtTurquoise';
		case 'COLOR_SKY_BLUE':
			return 'lsSemanticColor--background urColorTxtSkyBlue';
		case 'COLOR_PLUM':
			return 'lsSemanticColor--background urColorTxtPlum';
		case 'COLOR_GRAY_25':
			return 'lsSemanticColor--background urColorTxtGray25';
		case 'COLOR_ROSE':
			return 'lsSemanticColor--background urColorTxtRose';
		case 'COLOR_TAN':
			return 'lsSemanticColor--background urColorTxtTan';
		case 'COLOR_LIGHT_YELLOW':
			return 'lsSemanticColor--background urColorTxtLightYellow';
		case 'COLOR_LIGHT_GREEN':
			return 'lsSemanticColor--background urColorTxtLightGreen';
		case 'COLOR_LIGHT_TURQUOISE':
			return 'lsSemanticColor--background urColorTxtLightTurquoise';
		case 'COLOR_PALE_BLUE':
			return 'lsSemanticColor--background urColorTxtPaleBlue';
		case 'COLOR_LAVENDER':
			return 'lsSemanticColor--background urColorTxtLavender';
		case 'COLOR_WHITE':
			return 'lsSemanticColor--background urColorTxtWhite';
		case 'COLOR_A_1':
			return 'lsSemanticColor--background urColorTxtRedDarkest';
		case 'COLOR_A_2':
			return 'lsSemanticColor--background urColorTxtRedVeryDark';
		case 'COLOR_A_3':
			return 'lsSemanticColor--background urColorTxtRedDark';
		case 'COLOR_A_4':
			return 'lsSemanticColor--background urColorTxtRedMediumDark';
		case 'COLOR_A_5':
			return 'lsSemanticColor--background urColorTxtRedMedium';
		case 'COLOR_A_6':
			return 'lsSemanticColor--background urColorTxtRedMediumLight';
		case 'COLOR_A_7':
			return 'lsSemanticColor--background urColorTxtRedLight';
		case 'COLOR_A_8':
			return 'lsSemanticColor--background urColorTxtRedVeryLight';
		case 'COLOR_A_9':
			return 'lsSemanticColor--background urColorTxtRedLightest';
		case 'COLOR_B_1':
			return 'lsSemanticColor--background urColorTxtYellowDarkest';
		case 'COLOR_B_2':
			return 'lsSemanticColor--background urColorTxtYellowVeryDark';
		case 'COLOR_B_3':
			return 'lsSemanticColor--background urColorTxtYellowDark';
		case 'COLOR_B_4':
			return 'lsSemanticColor--background urColorTxtYellowMediumDark';
		case 'COLOR_B_5':
			return 'lsSemanticColor--background urColorTxtYellowMedium';
		case 'COLOR_B_6':
			return 'lsSemanticColor--background urColorTxtYellowMediumLight';
		case 'COLOR_B_7':
			return 'lsSemanticColor--background urColorTxtYellowLight';
		case 'COLOR_B_8':
			return 'lsSemanticColor--background urColorTxtYellowVeryLight';
		case 'COLOR_B_9':
			return 'lsSemanticColor--background urColorTxtYellowLightest';
		case 'COLOR_C_1':
			return 'lsSemanticColor--background urColorTxtGreenDarkest';
		case 'COLOR_C_2':
			return 'lsSemanticColor--background urColorTxtGreenVeryDark';
		case 'COLOR_C_3':
			return 'lsSemanticColor--background urColorTxtGreenDark';
		case 'COLOR_C_4':
			return 'lsSemanticColor--background urColorTxtGreenMediumDark';
		case 'COLOR_C_5':
			return 'lsSemanticColor--background urColorTxtGreenMedium';
		case 'COLOR_C_6':
			return 'lsSemanticColor--background urColorTxtGreenMediumLight';
		case 'COLOR_C_7':
			return 'lsSemanticColor--background urColorTxtGreenLight';
		case 'COLOR_C_8':
			return 'lsSemanticColor--background urColorTxtGreenVeryLight';
		case 'COLOR_C_9':
			return 'lsSemanticColor--background urColorTxtGreenLightest';
		case 'COLOR_D_1':
			return 'lsSemanticColor--background urColorTxtBlueDarkest';
		case 'COLOR_D_2':
			return 'lsSemanticColor--background urColorTxtBlueVeryDark';
		case 'COLOR_D_3':
			return 'lsSemanticColor--background urColorTxtBlueDark';
		case 'COLOR_D_4':
			return 'lsSemanticColor--background urColorTxtBlueMediumDark';
		case 'COLOR_D_5':
			return 'lsSemanticColor--background urColorTxtBlueMedium';
		case 'COLOR_D_6':
			return 'lsSemanticColor--background urColorTxtBlueMediumLight';
		case 'COLOR_D_7':
			return 'lsSemanticColor--background urColorTxtBlueLight';
		case 'COLOR_D_8':
			return 'lsSemanticColor--background urColorTxtBlueVeryLight';
		case 'COLOR_D_9':
			return 'lsSemanticColor--background urColorTxtBlueLightest';
		case 'COLOR_E_1':
			return 'lsSemanticColor--background urColorTxtGreyDarkest';
		case 'COLOR_E_2':
			return 'lsSemanticColor--background urColorTxtGreyVeryDark';
		case 'COLOR_E_3':
			return 'lsSemanticColor--background urColorTxtGreyDark';
		case 'COLOR_E_4':
			return 'lsSemanticColor--background urColorTxtGreyMediumDark';
		case 'COLOR_E_5':
			return 'lsSemanticColor--background urColorTxtGreyMedium';
		case 'COLOR_E_6':
			return 'lsSemanticColor--background urColorTxtGreyMediumLight';
		case 'COLOR_E_7':
			return 'lsSemanticColor--background urColorTxtGreyLight';
		case 'COLOR_E_8':
			return 'lsSemanticColor--background urColorTxtGreyVeryLight';
		case 'COLOR_E_9':
			return 'lsSemanticColor--background urColorTxtGreyLightest';
		default:
			return "";
	}
};;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["getSemanticTextColor"] = 0; };

/** @typedef {string} UCF_UrBase_SapTableCellDesign */

/** @typedef {'NONE'} UCF_UrBase_SapTableSemanticType_None */
/** @typedef {'KEY'} UCF_UrBase_SapTableSemanticType_Key */
/** @typedef {'TOTAL'} UCF_UrBase_SapTableSemanticType_Total */
/** @typedef {'SUBTOTAL'} UCF_UrBase_SapTableSemanticType_Subtotal */
/** @typedef {'GROUP1'} UCF_UrBase_SapTableSemanticType_Group1 */
/** @typedef {'GROUP2'} UCF_UrBase_SapTableSemanticType_Group2 */
/** @typedef {'GROUP3'} UCF_UrBase_SapTableSemanticType_Group3 */
/** @typedef {'POSITIVE1'} UCF_UrBase_SapTableSemanticType_Positive1 */
/** @typedef {'POSITIVE2'} UCF_UrBase_SapTableSemanticType_Positive2 */
/** @typedef {'POSITIVE3'} UCF_UrBase_SapTableSemanticType_Positive3 */
/** @typedef {'NEGATIVE1'} UCF_UrBase_SapTableSemanticType_Negative1 */
/** @typedef {'NEGATIVE2'} UCF_UrBase_SapTableSemanticType_Negative2 */
/** @typedef {'NEGATIVE3'} UCF_UrBase_SapTableSemanticType_Negative3 */
/** @typedef {'CRITICAL1'} UCF_UrBase_SapTableSemanticType_Critical1 */
/** @typedef {'CRITICAL2'} UCF_UrBase_SapTableSemanticType_Critical2 */
/** @typedef {'CRITICAL3'} UCF_UrBase_SapTableSemanticType_Critical3 */
/** @typedef {UCF_UrBase_SapTableSemanticType_None|UCF_UrBase_SapTableSemanticType_Key|UCF_UrBase_SapTableSemanticType_Total|UCF_UrBase_SapTableSemanticType_Subtotal|UCF_UrBase_SapTableSemanticType_Group1|UCF_UrBase_SapTableSemanticType_Group2|UCF_UrBase_SapTableSemanticType_Group3|UCF_UrBase_SapTableSemanticType_Positive1|UCF_UrBase_SapTableSemanticType_Positive2|UCF_UrBase_SapTableSemanticType_Positive3|UCF_UrBase_SapTableSemanticType_Negative1|UCF_UrBase_SapTableSemanticType_Negative2|UCF_UrBase_SapTableSemanticType_Negative3|UCF_UrBase_SapTableSemanticType_Critical1|UCF_UrBase_SapTableSemanticType_Critical2|UCF_UrBase_SapTableSemanticType_Critical3} UCF_UrBase_SapTableSemanticType */

/**
 * @see UrBase.renderer#UrBase_sSemanticType
 * @protected
 * @param {UCF_UrBase_SapTableSemanticType} sSemanticType
 * @return {string}
 */
UCF_UrBase["sSemanticType"] = function(sSemanticType) {;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["sSemanticType"]++; }; 
	switch (sSemanticType) {
		/* beautify preserve:start */
		case 'NONE': return '';
		case 'ALTERNATING': return 'lsCell--alternating';
		case 'ALTERNATING_KEY': return 'lsCell--alternating lsCell--key';
		case 'KEY': return 'lsCell--key';
		case 'TOTAL': return 'lsCell--total';
		case 'SUBTOTAL': return 'lsCell--subtotal';
		case 'GROUP1': return 'lsCell--group1';
		case 'GROUP2': return 'lsCell--group2';
		case 'GROUP3': return 'lsCell--group3';
		case 'POSITIVE1': return 'lsCell--positive1';
		case 'POSITIVE2': return 'lsCell--positive2';
		case 'POSITIVE3': return 'lsCell--positive3';
		case 'NEGATIVE1': return 'lsCell--negative1';
		case 'NEGATIVE2': return 'lsCell--negative2';
		case 'NEGATIVE3': return 'lsCell--negative3';
		case 'CRITICAL1': return 'lsCell--critical1';
		case 'CRITICAL2': return 'lsCell--critical2';
		case 'CRITICAL3': return 'lsCell--critical3';
		default: return '';
		/* beautify preserve:end */
	}
};;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["sSemanticType"] = 0; };

/** @return the CSS implementing the semantic color
 * @type string
 *
 * Copy of the method from UrBase
 */
UCF_UrBase["iGetAriaLevel"] = function(iHeadingLevel) {;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["iGetAriaLevel"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iHeadingLevel) == "number", "typeof(iHeadingLevel) == \"number\"", "UrBase.js(628): iGetAriaLevel"); };

	if (iHeadingLevel <= 0) {
		return 0;
	}
	// JAWS announces the header level properly, only INS+F6 does not work
	/*if (iHeadingLevel > 6) {
		return 6;
	}*/
	return iHeadingLevel;
};;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["iGetAriaLevel"] = 0; };

/**
 * @param {{Id: string, Src: string, SrcOnError: string, Width: string, Height: string, Tooltip: string, AlternativeText: string, CssClass: string, CssStyle: string, PreventDraging: bool}} oParameters
 * the parameters for the UrBase_IconFragment
 * @return {string} the html for the icon
 */
UCF_UrBase["prototype"]["sIconFragment"] = function(oParameters) {;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["sIconFragment"]++; }; 
	return this["oLS"]["oGetRenderManager"]()["callFragment"](
		'UrBase_IconFragment',
		'UrBase',
		oParameters
	);
};;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["sIconFragment"] = 0; };

/**
 * @protected
 * @param {string} sText
 * @param {string} sAccessKey
 * @param {boolean} [bEnabledAccessKey=true]
 * @param {string} [sEncodedText=sText]
 * @return {string}
 */
UCF_UrBase["prototype"]["sAccessKeyTextFragment"] = function(sText, sAccessKey, bEnabledAccessKey, sEncodedText) {;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["sAccessKeyTextFragment"]++; }; 
	return sAccessKey === ''
		? (sEncodedText || sText)
		: this["oLS"]["oGetRenderManager"]()["callFragment"](
			'UrBaseAccessKeyTextFragment',
			'UrBase', {
				"Text": sText,
				"AccessKey": sAccessKey,
				"EnabledAccessKey": typeof bEnabledAccessKey === 'boolean'
					? bEnabledAccessKey
					: true
			}
		);
};;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["sAccessKeyTextFragment"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_UrBase["prototype"]["aAttributeNames"] = [];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_UrBase["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_UrBase["prototype"]["aMethodNames"] = [];


//#JSCOVER_EXCL_START
/** @protected */
UCF_UrBase["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["setDefaultValues"]++; }; 
	

	if (this["getClientControl"]() && !this["bKeepAlive"]) ;
};;if (__UCF_COVERAGE__) { UCF_UrBase["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ValueComparison"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ValueComparison(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ValueComparison["_"]["UCF_ValueComparison"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ValueComparison.js(22): UCF_ValueComparison"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ValueComparison.js(23): UCF_ValueComparison"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ValueComparison.js(24): UCF_ValueComparison"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_ValueComparison"] = UCF_ValueComparison; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ValueComparison"); UCF_ValueComparison["_"] = {UCF_ValueComparison: 0}; }; ;

UCF_ValueComparison["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ValueComparison.prototype["sClassName"] = "UCF_ValueComparison";

/**
 * Apply ACC helper object
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ValueComparison["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ValueComparison["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ValueComparison.js(36): onlsaccessibility"); };

	if (this !== oBrowserEvent["oGetSourceControl"]()) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](this["oDomRef"]));
	oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	oAccessibilityHelper["applyHighlightInfo"](this["mGetHighlightInfo"]());
	oAccessibilityHelper["setControlType"]("VC");
};;if (__UCF_COVERAGE__) { UCF_ValueComparison["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ValueComparison["prototype"]["aAttributeNames"] = ["sTooltip","sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ValueComparison["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ValueComparison["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ValueComparison["prototype"]["sTooltip"] = 'Compares values';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ValueComparison["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ValueComparison["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ValueComparison["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ValueComparison["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = 'Compares values';
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", 'Compares values', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ValueComparison["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_VariantManagement"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_KeyCodes */
/// <reference path="../../core/enums/KeyCodes.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_ImageUtil */
/// <reference path="../core/ImageUtil.js"/>
/* global UCF_KeyboardHelper */
/// <reference path="../core/KeyboardHelper.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_RenderManager */
/// <reference path="../core/RenderManager.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_UrBase */
/// <reference path="./base/UrBase.js"/>
/* global UCF_ButtonDragDelegate */
/// <reference path="./delegates/ButtonDragDelegate.js"/>
/* global UCF_InplaceEditDelegate */
/// <reference path="./delegates/InplaceEditDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_VariantManagement(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["UCF_VariantManagement"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "VariantManagement.js(51): UCF_VariantManagement"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "VariantManagement.js(52): UCF_VariantManagement"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "VariantManagement.js(53): UCF_VariantManagement"); };
	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["defineEvents"](['Press']);
	// ignore the default button if the control gets the focus
	this["oVariantManagementButton"] = UCF_DomUtil["$"](this["sId"] + '-button');
	this["oFocusDomRef"] = this["bEnabled"] ? this["oVariantManagementButton"] : null;

};window["UCF_VariantManagement"] = UCF_VariantManagement; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_VariantManagement"); UCF_VariantManagement["_"] = {UCF_VariantManagement: 0}; }; ;

UCF_VariantManagement["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_VariantManagement.prototype["sClassName"] = "UCF_VariantManagement";

UCF_VariantManagement["prototype"]["eStyles"] = {
	"BUTTON_HOVERABLE": 'lsVariantManagement--hoverable',
	"BUTTON_DOWN": 'lsVariantManagement--down'
};

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_VariantManagement["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onclick"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "VariantManagement.js(77): onclick"); };

	if (!this["bEnabled"]) return;
	//fired by mouse click
	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}
	this["handleClick"](oBrowserEvent);
	return;

};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onclick"] = 0; };

/**
 * Handles the onlsenter event on key down
 * [ENTER]
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_VariantManagement["prototype"]["onlsenter"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onlsenter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "VariantManagement.js(97): onlsenter"); };

	if (this["bIsCurentControl"](oBrowserEvent)) {
		//cancel the event, otherwise will generate a scroll down

		//this.applyDownStyles(true);
		this["handleClick"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onlsenter"] = 0; };

/**
 * Handles the onlsenter event on key down
 * [ENTER]
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_VariantManagement["prototype"]["onlsenterup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onlsenterup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "VariantManagement.js(115): onlsenterup"); };

	//cancel the event, otherwise will generate a scroll down
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
	//	this.applyDownStyles(false);
	return;

};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onlsenterup"] = 0; };

/**
 * Handles the onlsspaceup event on key up
 * [SPACE]
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_VariantManagement["prototype"]["onlsspaceup"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onlsspaceup"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "VariantManagement.js(133): onlsspaceup"); };

	if (oBrowserEvent["iWasCanceledByKey"]() !== null) {
		return;
	}
	this["handleClick"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onlsspaceup"] = 0; };

/**
 * Handles the click on the menu with keyboard or mouse
 *
 * @param {UCF_BrowserEvent} oBrowserEvent - the browser event object that occurred
 * @private
 */
UCF_VariantManagement["prototype"]["handleClick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["handleClick"]++; }; 

	if (!this["bEnabled"]) return;

	this["firePress"](this["sId"]);
	// cancel event to avoid page scrolling in the browser
	oBrowserEvent["cancel"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["handleClick"] = 0; };

/**
 * Sets the Tooltip text for the Button control.
 * The Tooltip will be shown if the mouse hovers over the control.
 * In case that screenreader support is turned on, text will automatically be
 * added to the tooltip to support 508 features.
 * @public
 * @param {string} sTooltip
 */
UCF_VariantManagement["prototype"]["setTooltip"] = function(sTooltip) {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["setTooltip"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTooltip) === "string", "typeof(sTooltip) === \"string\"", "VariantManagement.js(166): setTooltip"); };
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sTooltip"] = sTooltip;
	this["setClientProperty"]("Tooltip", this["sTooltip"], true);

	var sHotkeyTooltip = '';
	if (this["sHotkey"] && (this["sHotkey"] !== 'NONE' || this["sHotkey"] !== 'undefinded')) {
		sHotkeyTooltip = this["sGetHotkeyString"]();
	}

	var sTitle = (sHotkeyTooltip !== '' && sTooltip !== '')
		? (sTooltip + ' ' + sHotkeyTooltip)
		: (sTooltip + '' + sHotkeyTooltip);

	if (sTitle !== '') {
		UCF_DomUtil["setTooltip"](this["oDomRef"], sTitle);
	}
};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["setTooltip"] = 0; };

/**
 * Returns the Tooltip text for the Button control.
 * The Tooltip will be shown if the mouse hovers over the control.
 * In case that screenreader support is turned on, text will automatically be
 * added to the tooltip to support 508 features.
 * @public
 * @return {string} Returns the Tooltip
 */
UCF_VariantManagement["prototype"]["getTooltip"] = function() {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["getTooltip"]++; }; 
	return this["sTooltip"];
};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["getTooltip"] = 0; };

/**
 * Applies or removes the hover styles for button
 * Only for Standards mode
 * @param {boolean} bHover - if the hover state should be applied or removed
 * @private
 */
UCF_VariantManagement["prototype"]["applyHoverStyles"] = function(bHover) {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["applyHoverStyles"]++; }; 

	if (!bHover) {
		if (UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"])) {
			UCF_DomUtil["removeClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"]);
		}

	} else {
		if (!UCF_DomUtil["bHasClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"])) {
			UCF_DomUtil["addClass"](this["oDomRef"], this["eStyles"]["BUTTON_HOVERABLE"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["applyHoverStyles"] = 0; };

/**
 * Handles the onmouseover event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_VariantManagement["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onmouseover"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "VariantManagement.js(224): onmouseover"); };

	if (!this["bEnabled"]) return;

	var oSourceControl = oBrowserEvent["oGetSourceControl"]();
	if (this !== oSourceControl) return;
	this["applyHoverStyles"](oBrowserEvent["bIsMouseHover"]());

};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onmouseover"] = 0; };

/**
 * Handles the onmouseout event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_VariantManagement["prototype"]["onmouseout"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onmouseout"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "VariantManagement.js(241): onmouseout"); };

	if (!this["bEnabled"]) return;

	var oSourceControl = oBrowserEvent["oGetSourceControl"]();
	if (this !== oSourceControl) return;
	this["applyHoverStyles"](false);

};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onmouseout"] = 0; };

/**
 * Returns the Caption of the Button control.
 * @public
 * @return {string} Returns the Text
 *
 */
UCF_VariantManagement["prototype"]["getText"] = function() {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["getText"]++; }; 
	if (this["sContentVisibility"] === 'ICON') {
		return this["sText"];
	}
	var oCaptionDomRef = UCF_DomUtil["$"](this["sId"] + '-caption'),
		oTextDomRef = UCF_DomUtil["$"](this["sId"] + '-txt'),
		sTitle;
	if (oCaptionDomRef)
		sTitle = UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](oCaptionDomRef));
	else if (oTextDomRef)
		sTitle = UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](oTextDomRef));
	else if (window["UCF_System"]["sDevice"] === 'standards') {
		sTitle = '';
	} else
		sTitle = UCF_StringUtil["sTrim"](UCF_DomUtil["sGetInnerText"](this["oDomRef"]));

	return sTitle;

};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["getText"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_VariantManagement["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "VariantManagement.js(285): onlsaccessibility"); };

};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["onlsaccessibility"] = 0; };

/**
 * Perfom destroy
 */
UCF_VariantManagement["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["destroy"]++; }; 

	this["oVariantManagementButton"] = null;
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_VariantManagement["prototype"]["aAttributeNames"] = ["sText","sTooltip","bEnabled","sVisibility","sAccessKey","sHotkey","iHeadingLevel"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_VariantManagement["prototype"]["aEventNames"] = ["Press"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_VariantManagement["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_VariantManagement["prototype"]["sText"] = '';

/**
 * @private
 * @type {string}
 */
UCF_VariantManagement["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_VariantManagement["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_VariantManagement["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_VariantManagement["prototype"]["sAccessKey"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HotkeyValue}
 */
UCF_VariantManagement["prototype"]["sHotkey"] = "NONE";

/**
 * @private
 * @type {number}
 */
UCF_VariantManagement["prototype"]["iHeadingLevel"] = 0;

//#JSCOVER_EXCL_START
/** @protected */
UCF_VariantManagement["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["sTooltip"] = '';
	this["bEnabled"] = true;
	this["sVisibility"] = "VISIBLE";
	this["sAccessKey"] = '';
	this["sHotkey"] = "NONE";
	this["iHeadingLevel"] = 0;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("AccessKey", '', true);
		this["setClientProperty"]("Hotkey", "NONE", true);
		this["setClientProperty"]("HeadingLevel", 0, true);
	}
};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control in the current HTML document context. The Id of any control should be unique within the document.
 * @fires VariantManagement::Press
 */
UCF_VariantManagement["prototype"]["firePress"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["firePress"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "VariantManagement.js(393): firePress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "VariantManagement.js(394): firePress"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "VariantManagement.js(395): firePress"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("VariantManagement", "Press", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_VariantManagement["_"]["firePress"] = 0; };

UCF_VariantManagement.prototype["aPublicMethods"] = ["setTooltip","getTooltip","getText"].concat(UCF_VariantManagement.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_ViewContainer"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * The UCF_ViewContainer control, an empty control that can change the
 * visibility.
 *
 * 
 * @version
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ViewContainer(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ViewContainer["_"]["UCF_ViewContainer"]++; }; 
	if (arguments["length"] == 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "ViewContainer.js(22): UCF_ViewContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ViewContainer.js(23): UCF_ViewContainer"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ViewContainer.js(24): UCF_ViewContainer"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_ViewContainer"] = UCF_ViewContainer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ViewContainer"); UCF_ViewContainer["_"] = {UCF_ViewContainer: 0}; }; ;
UCF_ViewContainer["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ViewContainer.prototype["sClassName"] = "UCF_ViewContainer";
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ViewContainer["prototype"]["aAttributeNames"] = ["sVisibility","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ViewContainer["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ViewContainer["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_ViewContainer["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_ViewContainer["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ViewContainer["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ViewContainer["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ViewContainer["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_ViewSwitch"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Event */
/// <reference path="../../core/Event.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ItemNavigation */
/// <reference path="./base/ItemNavigation.js"/>
/* global UCF_ViewSwitchItem */
/// <reference path="./ViewSwitchItem.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ViewSwitch(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["UCF_ViewSwitch"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ViewSwitch.js(34): UCF_ViewSwitch"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ViewSwitch.js(35): UCF_ViewSwitch"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ViewSwitch.js(36): UCF_ViewSwitch"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oItemNavigation"] = new (UCF_ClassLoader["oGetClass"]("UCF_ItemNavigation"))();
	this["addDelegate"](this["oItemNavigation"]);

	this["createItems"]();
	this["oItemNavigation"]["attachEvent"](this["oItemNavigation"]["E_EVENTS"]["Select"], this, "onItemSelect");

	this["oItemNavigation"]["setFocusedIndex"](this["oItemNavigation"]["iFocusedIndex"]);
	UCF_DomUtil["setTabIndex"](this["oDomRef"], -1);
};window["UCF_ViewSwitch"] = UCF_ViewSwitch; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ViewSwitch"); UCF_ViewSwitch["_"] = {UCF_ViewSwitch: 0}; }; ;

UCF_ViewSwitch["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ViewSwitch.prototype["sClassName"] = "UCF_ViewSwitch";

/**
 * Fires the select event.
 *
 * @param {UCF_Event} oEvent
 */
UCF_ViewSwitch["prototype"]["onItemSelect"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["onItemSelect"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oEvent instanceof UCF_Event, "oEvent instanceof UCF_Event", "ViewSwitch.js(59): onItemSelect"); };

	var oItem = oEvent["oGetParam"]("oItem"),
		oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent");

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oItem instanceof UCF_ViewSwitchItem, "oItem instanceof UCF_ViewSwitchItem", "ViewSwitch.js(64): onItemSelect"); };

	if (oItem["bEnabled"] && !oItem["bSelected"])
		this["fireSelect"](this["sId"], oItem["sId"]);

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["onItemSelect"] = 0; };

/**
 * Create items for keyboard navigation
 */
UCF_ViewSwitch["prototype"]["createItems"] = function() {;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["createItems"]++; }; 

	var aDomItems = this["oDomRef"]["getElementsByTagName"]("TD");

	for (var iItemCount = 0; iItemCount < aDomItems["length"]; iItemCount++) {
		var oItem = this["oLS"]["oControlFactory"]["oGetControlByDomRef"](aDomItems[iItemCount], true);
		oItem["iIndex"] = iItemCount;
		if (oItem["bEnabled"] || window["UCF_System"]["bIs508"] || window["UCF_System"]["bIsAria"]) {
			this["oItemNavigation"]["addItem"](oItem, oItem["bSelected"]);
		}
		if (window["UCF_System"]["bIsAria"]) {
			UCF_AriaStateHelper["setPosinset"](oItem["oDomRef"], iItemCount + 1);
			UCF_AriaStateHelper["setSetsize"](oItem["oDomRef"], aDomItems["length"]);
		}
	}

};;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["createItems"] = 0; };

/**
 * Apply ACC helper object
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_ViewSwitch["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "ViewSwitch.js(98): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSourceControl"]();

	if (!UCF_JsUtil["bInstanceOf"](oSource, "UCF_ViewSwitchItem")) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setText"](UCF_DomUtil["sGetInnerText"](oSource["oDomRef"]));
	oAccessibilityHelper["setTooltip"](oSource["sTooltip"]);
	oAccessibilityHelper["setItemCount"](this["oItemNavigation"]["aItems"]["length"]);
	oAccessibilityHelper["setItemIndex"](oSource["iIndex"] + 1);
	oAccessibilityHelper["setControlType"]("VS");
	oAccessibilityHelper["setEnabled"](oSource["bEnabled"]);
	oAccessibilityHelper["setSelected"](oSource["bSelected"]);

	if (!oSource["bSelected"])
		oAccessibilityHelper["addEnabledTutor"]("SELECT_TUT", oSource["bEnabled"]);

	oAccessibilityHelper["addTutor"]("VS_TUT", oSource["bEnabled"]);
};;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["onlsaccessibility"] = 0; };

/**
 * Destructor
 */
UCF_ViewSwitch["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["destroy"]++; }; 
	if (this["oItemNavigation"]) {
		this["oItemNavigation"]["destroy"]();
		this["oItemNavigation"] = null;
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ViewSwitch["prototype"]["aAttributeNames"] = ["sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ViewSwitch["prototype"]["aEventNames"] = ["Select"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ViewSwitch["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_ViewSwitch["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ViewSwitch["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["setDefaultValues"]++; }; 
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the ViewSwitch control.
 * @param {string} sItemId Identifier of the selected item.
 * @fires ViewSwitch::Select
 */
UCF_ViewSwitch["prototype"]["fireSelect"] = function(sId, sItemId) {;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, ItemId: string}} */
	var mParams;
	/** @type {UCF_Control} */
	var oControl;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "ViewSwitch.js(181): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "ViewSwitch.js(182): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "ViewSwitch.js(183): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sItemId != null, "sItemId != null", "ViewSwitch.js(184): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sItemId) == "string", "typeof(sItemId) == \"string\"", "ViewSwitch.js(185): fireSelect"); };
	mParams = {
		"Id": sId,
		"ItemId": sItemId
	};
	
	if (sItemId) {
			oControl = this["oLS"]["oControlFactory"]["oGetControlById"](sItemId);
			if (oControl) {
				oControl["enrichSemanticEventParamsWithBindingContext"](mParams, "ItemId");
			}
		}
	this["fireSemanticEvent"]("ViewSwitch", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_ViewSwitch["_"]["fireSelect"] = 0; };

};
sap["ls"]["preload"]["UCF_ViewSwitchItem"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_ViewSwitchItem(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_ViewSwitchItem["_"]["UCF_ViewSwitchItem"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "ViewSwitchItem.js(18): UCF_ViewSwitchItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "ViewSwitchItem.js(19): UCF_ViewSwitchItem"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "ViewSwitchItem.js(20): UCF_ViewSwitchItem"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_ViewSwitchItem"] = UCF_ViewSwitchItem; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ViewSwitchItem"); UCF_ViewSwitchItem["_"] = {UCF_ViewSwitchItem: 0}; }; ;
UCF_ViewSwitchItem["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_ViewSwitchItem.prototype["sClassName"] = "UCF_ViewSwitchItem";

UCF_ViewSwitchItem["prototype"]["onlsfocus"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_ViewSwitchItem["_"]["onlsfocus"]++; }; 
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_ViewSwitchItem["_"]["onlsfocus"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_ViewSwitchItem["prototype"]["aAttributeNames"] = ["bEnabled","bSelected","sTooltip","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_ViewSwitchItem["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_ViewSwitchItem["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {boolean}
 */
UCF_ViewSwitchItem["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_ViewSwitchItem["prototype"]["bSelected"] = false;

/**
 * @private
 * @type {string}
 */
UCF_ViewSwitchItem["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_ViewSwitchItem["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_ViewSwitchItem["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_ViewSwitchItem["_"]["setDefaultValues"]++; }; 
	this["bEnabled"] = true;
	this["bSelected"] = false;
	this["sTooltip"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("Selected", false, true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_ViewSwitchItem["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};
sap["ls"]["preload"]["UCF_VizFrame"] = function() {/* global _assert, _trace, WARNING, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_PlaceHolder */
/// <reference path="./base/PlaceHolder.js"/>
/* global sap */

/**
 * Please ensure to load the necessary script files as the actual source is not
 * known this cannot be done by the controls, but needs to be done centrally in
 * the page control using HeadScripts aggregation.
 *
 * Sample:
 * http://veui5infra.dhcp.wdf.sap.corp:8080/sapui5-sdk-dist/explored.html#/entity/sap.viz.ui5.controls.VizFrame/samples
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement}
 *            oDomRef
 * @param {UCF_LS}
 *            oLS
 */
function UCF_VizFrame(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["UCF_VizFrame"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "VizFrame.js(38): UCF_VizFrame"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef !== null, "oDomRef !== null", "VizFrame.js(39): UCF_VizFrame"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "VizFrame.js(40): UCF_VizFrame"); };

	UCF_PlaceHolder["apply"](this, [oDomRef, oLS]);

	this["oChartInstance"] = null;
	this["oData"] = {};
	this["oDataset"] = {};
	this["aFeedItems"] = [];
	this["oProperties"] = {};
	this["aScales"] = [];
	this["oDataSet"] = null;
	this["oModel"] = null;
	this["oSelection"] = null;

	this["_sType"] = ''; // For caching and compare
	this["_sData"] = ''; // For caching and compare
	this["_sDataSet"] = ''; // For caching and compare
	this["_sFeedItems"] = ''; // For caching and compare
	this["_sProperties"] = ''; // For caching and compare
	this["_sScales"] = ''; // For caching and compare
	this["_sSelection"] = ''; // For caching and compare

	this["bSuppressSelectionEvent"] = false; // If we set a selection via
	this["attachBrowserEvent"]("resize", this["oRootRef"]);
	this["oLS"]["oBrowserWindow"]["attachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
};window["UCF_VizFrame"] = UCF_VizFrame; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_VizFrame"); UCF_VizFrame["_"] = {UCF_VizFrame: 0}; }; 
UCF_VizFrame["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PlaceHolder"))(); UCF_VizFrame.prototype["sClassName"] = "UCF_VizFrame";

UCF_VizFrame["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["onLayoutChange"]++; }; 

	this["applySize"]();

};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["onLayoutChange"] = 0; };


/**
 * Initializes the VizFrame control
 *
 * @private
 */

UCF_VizFrame["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["initialize"]++; }; 
	UCF_PlaceHolder.prototype["initialize"]["apply"](this, arguments);
	if (!UCF_UserAgent["bIsStandardsMode"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "VizFrame is supported in standards mode only", "VizFrame.js(84): initialize"); };
		// eslint-disable-next-line no-unsanitized/property
		UCF_DomUtil["setInnerHtml"](this["oRootRef"], this["oLS"]
			["sGetText"](
				"SAPUR_HTML5_CONTROL_ERROR",
				[
					"<a target=\"_blank\" href=\"https://service.sap.com/sap/support/notes/1970689\">Note 1970689</a>",
					"VizFrame"]));
		return;
	}
	this["oRootRef"]["className"] = "lsBusyIndicator urLoadImg";
	this["oRootRef"]["style"]["backgroundPosition"] = "center center";
	this["oRootRef"]["style"]["backgroundRepeat"] = "no-repeat";
	this["loadScripts"]();
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["initialize"] = 0; };

/**
 * Loads the scripts and erases the carrying with the informations of the
 * scripts
 */
UCF_VizFrame["prototype"]["loadScripts"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["loadScripts"]++; }; 
	/** @type {string} */
	var sScriptJSON;
	/** @type {{src: string, content: string, customAttributes: Array}[]} */
	var aScriptsJSON;
	/** @type {{src: string, content: string, customAttributes: Array}} */
	var oScript;
	/** @type {UCF_Page} */
	var oPage;

	if (sap && sap["viz"]) {
		// check if sap.viz has been already requested
		this["onAfterScriptLoad"]();
	} else {
		// load sap.viz
		sScriptJSON = UCF_DomUtil["sGetInnerText"](UCF_DomUtil["$"](this["sId"] + '-scripts'));

		if (sScriptJSON) {
			try {
				aScriptsJSON = UCF_JsUtil["oJsonParse"](sScriptJSON);

				if (aScriptsJSON && aScriptsJSON["length"] === 1) {
					oScript = aScriptsJSON[0];
					// add script
					oPage = this["oLS"]["oGetPageInternal"]();
					if (oPage) { // eslint-disable-line max-depth
						// library
						oScript["customAttributes"]['data-sap-ui-libs'] = 'sap.viz';
						// asynchronous loading
						oScript["customAttributes"]['data-sap-ui-preload'] = 'async';
						oScript["customAttributes"]['data-sap-ui-async'] = 'true';

						oPage["addScript"](
							oScript["src"],
							oScript["content"],
							oScript["customAttributes"],
							this,
							'onAfterScriptLoad',
							null,
							// Workaround for jquery which may be already loaded by
							// sap.ui.core and contain 'plugins' in the jQuery.sap
							// namespace
							// By loading jquery again we would overwrite the existing
							// object.
							(oScript["src"]["indexOf"]('/jquery') > -1)
							? function() {
								return typeof jQuery === 'undefined'
									|| window["jQuery"] === null;
							}
							: null
						);
					}
				} else {
					if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, 'Failed to read scripts for VizFrame ' + this["sId"], "VizFrame.js(157): loadScripts"); };
				}
			} catch (ex) {
				if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Failed to read scripts for VizFrame ' + this["sId"], "VizFrame.js(160): loadScripts"); };
				this["onAfterScriptLoad"]();
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["loadScripts"] = 0; };

UCF_VizFrame["prototype"]["onAfterScriptLoad"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["onAfterScriptLoad"]++; }; 
	/** @type {UCF_VizFrame} */
	var self = this;
	// improve startup-performance by listening to event attachInit of
	// sap.ui.core
	sap["ui"]["getCore"]()["attachInit"](function() {
		if (!self["bIsDestroyed"]) {
			self["_onAfterScriptLoad"]();
		}
	});
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["onAfterScriptLoad"] = 0; };

UCF_VizFrame["prototype"]["_onAfterScriptLoad"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["_onAfterScriptLoad"]++; }; 
	this["oRootRef"]["className"] = "";
	this["oRootRef"]["style"]["backgroundPosition"] = "";
	var oScriptRef = UCF_DomUtil["$"](this["sId"] + "-scripts");
	if (oScriptRef) {
		oScriptRef["parentNode"]["removeChild"](oScriptRef);
	}

	var bCreateNew = false;

	// Apply new values
	this["applyPlaceholderChanges"]();

	// To prevent re-rendering each roundtrip, we cache type and compare
	if (this["_sType"] !== this["sType"]) {
		this["_sType"] = this["sType"];
		bCreateNew = true;
	}

	// To prevent re-rendering each roundtrip, we cache data and compare
	if (this["_sData"] !== this["sData"]) {
		this["_sData"] = this["sData"];
		try {
			this["oData"] = UCF_JsUtil["oJsonParse"](this["_sData"]);
		} catch (ex) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "VizFrame data could not be initialized", "VizFrame.js(204): _onAfterScriptLoad"); };
			return;
		}

		if (this["oData"]) {
			this["oModel"] = new sap["ui"]["model"]["json"]["JSONModel"](this["oData"]);
		} else {
			this["oModel"] = null;
		}
		bCreateNew = true;
	}

	// To prevent re-rendering each roundtrip, we cache data and compare
	if (this["_sDataSet"] !== this["sDataSet"]) {
		this["_sDataSet"] = this["sDataSet"];
		try {
			this["oDataset"] = UCF_JsUtil["oJsonParse"](this["_sDataSet"]);
		} catch (ex) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "VizFrame dataset could not be initialized", "VizFrame.js(222): _onAfterScriptLoad"); };
			return;
		}

		if (this["oDataset"]) {
			this["oDataSet"] = new sap["viz"]["ui5"]["data"]["FlattenedDataset"](this["oDataset"]);
		} else {
			this["oDataSet"] = null;
		}
		bCreateNew = true;
	}

	// To prevent re-rendering each roundtrip, we cache options and compare as
	// well
	if (this["_sProperties"] !== this["sProperties"]) {
		this["_sProperties"] = this["sProperties"];
		try {
			this["oProperties"] = UCF_JsUtil["oJsonParse"](this["_sProperties"]);
		} catch (ex) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "VizFrame properties could not be initialized", "VizFrame.js(241): _onAfterScriptLoad"); };
			return;
		}
		bCreateNew = true;
	}

	// To prevent re-rendering each roundtrip, we cache options and compare as
	// well
	if (this["_sScales"] !== this["sScales"]) {
		this["_sScales"] = this["sScales"];
		try {
			this["aScales"] = UCF_JsUtil["oJsonParse"](this["_sScales"]);
		} catch (ex) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "VizFrame scales could not be initialized", "VizFrame.js(254): _onAfterScriptLoad"); };
			return;
		}
		bCreateNew = true;
	}

	// To prevent re-rendering each roundtrip, we cache options and compare as
	// well
	if (this["_sFeedItems"] !== this["sFeedItems"]) {
		this["_sFeedItems"] = this["sFeedItems"];
		try {
			this["aFeedItems"] = UCF_JsUtil["oJsonParse"](this["_sFeedItems"]);
		} catch (ex) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "VizFrame feeding could not be initialized", "VizFrame.js(267): _onAfterScriptLoad"); };
			return;
		}
		bCreateNew = true;
	}

	// To prevent re-rendering each roundtrip, we cache selection and compare as
	// well
	if (this["_sSelection"] !== this["sSelection"]) {
		this["_sSelection"] = this["sSelection"];
		try {
			this["oSelection"] = UCF_JsUtil["oJsonParse"](this["_sSelection"]);
			if (this["oChartInstance"]) {
				// If we have already a VizFrame instance, apply selection now.
				// If not, the selection is set
				// via event handler in createChartInstance( )
				this["setChartSelection"]();
			}
		} catch (ex) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, "VizFrame selection could not be initialized", "VizFrame.js(286): _onAfterScriptLoad"); };
			return;
		}
	}

	if (bCreateNew) {
		this["createChartInstance"]();
	} else {
		this["applySize"](); // Needs to be done for some cases where the resize
		// event is not fired.
	}

};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["_onAfterScriptLoad"] = 0; };

/**
 * Creates a internal VizFrame instance and attaches the events
 */
UCF_VizFrame["prototype"]["createChartInstance"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["createChartInstance"]++; }; 

	// prerequisites
	if (!this["sType"] || !this["oModel"] || !this["oDataSet"] || !this["aFeedItems"]) {
		return;
	}

	// instance
	var bNewInstance = false;
	if (!this["oChartInstance"]) {
		// custom formatter
		this["enableCustomFormatter"]();
		// instance
		this["oChartInstance"] = new sap["viz"]["ui5"]["controls"]["VizFrame"]({
			"vizType": this["sType"]
		});
		bNewInstance = true;
	} else {
		this["oChartInstance"]["setVizType"](this["sType"]);
	}

	// position
	this["oChartInstance"]["placeAt"](this["oDomRef"]["getAttribute"]("id"));

	// model
	this["oChartInstance"]["setModel"](this["oModel"]);

	// dataset
	this["oChartInstance"]["setDataset"](this["oDataSet"]);

	// feeditems
	this["oChartInstance"]["destroyFeeds"]();
	for (var i = 0; i < this["aFeedItems"]["length"]; i++) {
		this["oChartInstance"]
			["addFeed"](new sap["viz"]["ui5"]["controls"]["common"]["feeds"]["FeedItem"](
				this["aFeedItems"][i]));
	}
	// properties
	this["oChartInstance"]["setVizProperties"](this["oProperties"]);

	// scales
	this["oChartInstance"]["setVizScales"](this["aScales"]);

	// selection
	if (bNewInstance) {
		var that = this;
		this["_handleChartEvent"] = function(oChartEvent) {
			that["handleChartEvent"](oChartEvent);
		};
		this["oChartInstance"]["attachSelectData"](this["_handleChartEvent"]);
		this["oChartInstance"]["attachDeselectData"](this["_handleChartEvent"]);

		if (this["oSelection"]) {
			this["oChartInstance"]["attachRenderComplete"](function() {
				that["setChartSelection"]();
				// We need to set the selection only one time after data
				// initialization.
				// As this would be called each time the VizFrame gets resized,
				// we
				// unregister this handler.
				that["oChartInstance"]["detachRenderComplete"](arguments["callee"]);
			});
		}
	}

	// size
	this["applySize"]();
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["createChartInstance"] = 0; };

/**
 * Handles event from the VizFrame instance *
 *
 * @param {Event}
 *            oChartEvent the VizFrame event that occurred
 * @private
 */
UCF_VizFrame["prototype"]["handleChartEvent"] = function(oChartEvent) {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["handleChartEvent"]++; }; 

	if (this["bSuppressSelectionEvent"]) {
		this["bSuppressSelectionEvent"] = false;
		return;
	}

	// selection string
	var sSelectionString = "";
	if (oChartEvent["oSource"]["vizSelection"]()["length"] > 0) {
		var aSelection = [];
		for (var i = 0; i < oChartEvent["oSource"]["vizSelection"]()["length"]; i++) {
			aSelection[i] = oChartEvent["oSource"]["vizSelection"]()[i]["data"];
		}
		sSelectionString = UCF_JsUtil["sJsonStringify"](aSelection);
	}

	// do some semantic event mapping for data to be sent
	if (oChartEvent["sId"] == "selectData") {
		this["fireSelect"](this["sId"], sSelectionString);
	} else if (oChartEvent["sId"] == "deselectData") {
		this["fireDeselect"](this["sId"], sSelectionString);
	}
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["handleChartEvent"] = 0; };

/**
 * Applies the new size after a resize of the div
 *
 * @private
 */
UCF_VizFrame["prototype"]["applySize"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["applySize"]++; }; 
	if (this["oChartInstance"] && this["oRootRef"]) {
		this["oChartInstance"]["setWidth"](this["oRootRef"]["offsetWidth"] + 'px');
		this["oChartInstance"]["setHeight"](this["oRootRef"]["offsetHeight"] + 'px');
	}
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["applySize"] = 0; };

/**
 * Handler for the resize event
 *
 * @param {UCF_BrowserEvent}
 *            oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_VizFrame["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["onresize"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "VizFrame.js(424): onresize"); };
	UCF_PlaceHolder.prototype["onresize"]["apply"](this, arguments);
	this["applySize"]();
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["onresize"] = 0; };

/**
 * Sets new selection for the VizFrame
 *
 * @public
 */
UCF_VizFrame["prototype"]["setChartSelection"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["setChartSelection"]++; }; 
	if (!this["oChartInstance"] || !this["oSelection"])
		return; // Nothing to select
	if (this["oChartInstance"]["vizSelection"]) {
		var bSuccess = this["oChartInstance"]["vizSelection"](this["oSelection"], {
			"clearSelection": true
		});
		if (bSuccess) {
			this["bSuppressSelectionEvent"] = true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["setChartSelection"] = 0; };

/**
 * Destroys the control and the VizFrame instance
 *
 * @private
 */
UCF_VizFrame["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["destroy"]++; }; 
	if (this["oRootRef"]) {
		this["detachBrowserEvent"]("resize", this["oRootRef"]);
	}
	if (this["oChartInstance"]) {
		this["oChartInstance"]["destroy"]();
	}

	this["_handleChartEvent"] = null;

	this["oChartInstance"] = null;
	this["oData"] = null;
	this["oDataset"] = null;
	this["aFeedItems"] = null;
	this["oProperties"] = null;
	this["aScales"] = null;
	this["oDataSet"] = null;
	this["oModel"] = null;
	this["oSelection"] = null;
	this["mEvents"] = null;

	this["_sType"] = '';
	this["_sData"] = '';
	this["_sDataSet"] = '';
	this["_sFeedItems"] = '';
	this["_sProperties"] = '';
	this["_sScales"] = '';
	this["_sSelection"] = '';
	this["oLS"]["oBrowserWindow"]["detachEvent"](this["oLS"]["oBrowserWindow"]["E_EVENTS"]["LayoutChange"], this);

	UCF_PlaceHolder.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["destroy"] = 0; };

/**
 * @private Applies the new values that are stored in XMP Can be used when
 *          init() Method is called
 */
UCF_VizFrame["prototype"]["applyPlaceholderChanges"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["applyPlaceholderChanges"]++; }; 
	var oNewRootRef = this["oGetRootRef"]();
	var oDiv;
	var oLsdataNode;

	if (!oNewRootRef) {
		return;
	}

	oDiv = document["createElement"]("div");
	// eslint-disable-next-line no-unsanitized/property
	UCF_DomUtil["setInnerHtml"](oDiv, oNewRootRef["firstChild"]["innerHTML"]);
	oLsdataNode = oDiv["querySelector"]("*[lsdata]");

	if (oLsdataNode) {
		// In case a new value has the default value, it is not transported via
		// lsdata.
		// Therefore we need to set all attributes to default and apply new
		// values
		this["setDefaultValues"]();

		UCF_JsUtil["extend"](this, UCF_Control["oGetPackedAttribute"](
			oLsdataNode,
			'lsdata',
			this["aAttributeNames"]
		));

		// Apply events
		this["mEvents"] = UCF_Control["oGetPackedAttribute"](oLsdataNode, 'lsevents', this["aEventNames"]);
	}
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["applyPlaceholderChanges"] = 0; };

/**
 * @public
 * @return {boolean} `true` if it's alive, otherwise `false`
 * @see UCF_PlaceHolder
 */
UCF_VizFrame["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["bDoKeepAlive"]++; }; 
	// In case of scrollcontainers the content div may get lost
	var oContentRef = UCF_DomUtil["$"](this["sId"] + "-ph");
	if (oContentRef) {
		return this["bKeepAlive"];
	} else {
		return false;
	}
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["bDoKeepAlive"] = 0; };

/**
 * @private provides a function for the vizFrame CustomFormatter
 */
UCF_VizFrame["prototype"]["enableCustomFormatter"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["enableCustomFormatter"]++; }; 
	var customFormatter = {
		"format": function(value, pattern) {

			if (typeof pattern !== 'string') {
				// invalid pattern
				return value;
			}

			// get the decimals, delimiters
			var aPattern = pattern["split"](" ");
			var aFrag = aPattern[0]["split"]("0");
			if (!aFrag || aFrag["length"] <= 1) {
				// invalid pattern
				return value;
			}
			var iDecimals = aFrag["length"] - 2;
			var sDecimalDelimiter = aFrag[1];
			var sSectionDelimiter = "";
			if (aFrag[0]["indexOf"](",") !== -1) {
				sSectionDelimiter = ",";
			} else if (aFrag[0]["indexOf"](".") !== -1) {
				sSectionDelimiter = ".";
			}

			// get currency or unit
			var sUnit = "";
			if (isNaN(aFrag[aFrag["length"] - 1])) {
				sUnit = aFrag[aFrag["length"] - 1];
			}
			if (aPattern["length"] === 2 && isNaN(aPattern[1])) {
				if (sUnit === "") {
					sUnit = " " + aPattern[1];
				} else {
					sUnit = sUnit + " " + aPattern[1];
				}
			}

			function applyPattern(value, n, x, s, c) {
				// @param integer n: length of decimal
				// @param integer x: length of whole part
				// @param mixed s: sections delimiter
				// @param mixed c: decimal delimiter
				var re = '\\d(?=(\\d{' + (x || 3) + '})+'
					+ (n > 0 ? '\\D' : '$') + ')',
					num = value["toFixed"](Math
						["max"](0, ~~n));
				return (c ? num["replace"]('.', c) : num)["replace"](new RegExp(re,
					'g'), '$&' + (s || ''));
			}

			if (sUnit !== "") {
				// consider percentage values
				if (sUnit["indexOf"]("%") !== -1) {
					value = value * 100;
				}
				// apply pattern and concatenate unit or currency
				return applyPattern(value, iDecimals, 3, sSectionDelimiter,
						sDecimalDelimiter)
					+ sUnit;
			} else {
				// apply pattern
				return applyPattern(value, iDecimals, 3, sSectionDelimiter,
					sDecimalDelimiter);
			}
		}
	};
	sap["viz"]["ui5"]["api"]["env"]["Format"]["numericFormatter"](customFormatter);
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["enableCustomFormatter"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_VizFrame["prototype"]["aAttributeNames"] = ["sType","sData","sDataSet","sFeedItems","sProperties","sScales","sSelection","sLifeCycle","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_VizFrame["prototype"]["aEventNames"] = ["Select","Deselect"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_VizFrame["prototype"]["aMethodNames"] = ["setKeepAlive","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_VizFrame["prototype"]["sType"] = '';

/**
 * @private
 * @type {string}
 */
UCF_VizFrame["prototype"]["sData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_VizFrame["prototype"]["sDataSet"] = '';

/**
 * @private
 * @type {string}
 */
UCF_VizFrame["prototype"]["sFeedItems"] = '';

/**
 * @private
 * @type {string}
 */
UCF_VizFrame["prototype"]["sProperties"] = '';

/**
 * @private
 * @type {string}
 */
UCF_VizFrame["prototype"]["sScales"] = '';

/**
 * @private
 * @type {string}
 */
UCF_VizFrame["prototype"]["sSelection"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_VizFrame["prototype"]["sLifeCycle"] = "MANUAL";

/**
 * @private
 * @type {string}
 */
UCF_VizFrame["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_VizFrame["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["setDefaultValues"]++; }; 
	this["sType"] = '';
	this["sData"] = '';
	this["sDataSet"] = '';
	this["sFeedItems"] = '';
	this["sProperties"] = '';
	this["sScales"] = '';
	this["sSelection"] = '';
	this["sLifeCycle"] = "MANUAL";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Type", '', true);
		this["setClientProperty"]("Data", '', true);
		this["setClientProperty"]("DataSet", '', true);
		this["setClientProperty"]("FeedItems", '', true);
		this["setClientProperty"]("Properties", '', true);
		this["setClientProperty"]("Scales", '', true);
		this["setClientProperty"]("Selection", '', true);
		this["setClientProperty"]("LifeCycle", "MANUAL", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sResult JSON representation of the selected data.
 * @fires VizFrame::Select
 */
UCF_VizFrame["prototype"]["fireSelect"] = function(sId, sResult) {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["fireSelect"]++; }; 
	/** @type {{Id: string, Result: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "VizFrame.js(721): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "VizFrame.js(722): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "VizFrame.js(723): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sResult != null, "sResult != null", "VizFrame.js(724): fireSelect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sResult) == "string", "typeof(sResult) == \"string\"", "VizFrame.js(725): fireSelect"); };
	mParams = {
		"Id": sId,
		"Result": sResult
	};
	
	
	this["fireSemanticEvent"]("VizFrame", "Select", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["fireSelect"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sResult JSON representation of the selected data.
 * @fires VizFrame::Deselect
 */
UCF_VizFrame["prototype"]["fireDeselect"] = function(sId, sResult) {;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["fireDeselect"]++; }; 
	/** @type {{Id: string, Result: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "VizFrame.js(745): fireDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "VizFrame.js(746): fireDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "VizFrame.js(747): fireDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sResult != null, "sResult != null", "VizFrame.js(748): fireDeselect"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sResult) == "string", "typeof(sResult) == \"string\"", "VizFrame.js(749): fireDeselect"); };
	mParams = {
		"Id": sId,
		"Result": sResult
	};
	
	
	this["fireSemanticEvent"]("VizFrame", "Deselect", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_VizFrame["_"]["fireDeselect"] = 0; };

UCF_VizFrame.prototype["aPublicMethods"] = ["setChartSelection","bDoKeepAlive"].concat(UCF_VizFrame.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_WebWidget"] = function() {/* global _assert, _trace, _measure, INFO, START, STOP */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_PlaceHolder */
/// <reference path="./base/PlaceHolder.js"/>
/* global UCF_DragAndDropDelegate */
/// <reference path="./delegates/DragAndDropDelegate.js"/>

/**
 * A Widget control is a wrapper for custom HTML and JS.
 *
 * @example
 * ```javascript
 * myWebWidgetInstance.load = function(oWebWidget,oDomRef) {
 *  //read all the available keys in the webWidget instance
 *  var aPropertyNames1 = oWebWidget.getPropertyNames(),
 *  // read the specific value for the key 'myKeyName'
 *  sValue1 = oWebWidget.get('myKeyName');
 *  //save the change state of the control in the key 'myNewKey'
 *  oWebWidget.set("myNewKey", "myControlStateString");
 *  //submits the state changes e.g. the framework could trigger a round-trip to the server.
 *  //The control instance is maybe destroyed because the WebWidget is re-rendered.
 *  oWebWidget.save();
 * };
 * ```
 *
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_WebWidget(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["UCF_WebWidget"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "WebWidget.js(40): UCF_WebWidget"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "WebWidget.js(41): UCF_WebWidget"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "WebWidget.js(42): UCF_WebWidget"); };

	UCF_PlaceHolder["apply"](this, [oDomRef, oLS]);

	this["aScripts"] = null;
	this["mWWParameters"] = null;
};window["UCF_WebWidget"] = UCF_WebWidget; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_WebWidget"); UCF_WebWidget["_"] = {UCF_WebWidget: 0}; }; ;

UCF_WebWidget["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PlaceHolder"))(); UCF_WebWidget.prototype["sClassName"] = "UCF_WebWidget";

/** Constructor
 * @private
 */
UCF_WebWidget["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["initialize"]++; }; 
	if (__UCF_MEASURE__) { UCF_Tracer.measure(START, "UCF_WebWidget.initialize"); };
	//http://www.digital-web.com/articles/scope_in_javascript/
	//TODO inherit from OpenAjax.widgets.WidgetWrapper?

	UCF_PlaceHolder.prototype["initialize"]["apply"](this, arguments);

	var oMetaDomRef = UCF_DomUtil["$"](this["sId"] + "-meta");

	this["aScripts"] = [];
	this["aScripts"]["push"]({ "src": null, "text": this["sLoad"] });

	this["mWWParameters"] = {};

	if (oMetaDomRef != null) {
		var oDomRef = UCF_DomUtil["lastChild"](oMetaDomRef);

		while (oDomRef) {
			if (oDomRef["getAttribute"]("ct") == "WA") {
				//Parameters
				var oControl = this["oGetControlByDomRef"](oDomRef, true);
				if (oControl != null) {
					this["mWWParameters"][oControl["sKey"]] = oControl["sValue"];
					//TODO: register EPCM/OpenAJAX listener on the parameter
					// //bListener = mParameter[3] != 'NONE',
				}
			} else {

				//hint: script is not transfered over lsdata="" because
				//client access cannot be added to LSScript because it would
				// render <script src="lightspeed.js" lsdata="{src:'lightspeed.js'}"/>
				// which looks strange on the page scripts

				//TODO: introduce special ScriptWebWidgetFragment, UCF_Script
				// control, add clientaccess and transport it therefore over
				// lsdata=""

				var mEntry = {
					"src": oDomRef["getAttribute"]("src"),
					"text": oDomRef["getAttribute"]("text")
				};

				if (mEntry["src"] || mEntry["text"]) {
					//push is in inverse order but "synchronised" with pop
					this["aScripts"]["push"](mEntry);
				}
			}
			oDomRef = UCF_DomUtil["previousSibling"](oDomRef);
		}
		this["oDomRef"]["removeChild"](oMetaDomRef);
	}

	this["attachLSEvent"](this["oLS"]["E_EVENTS"]["Lock"], "lock");
	this["attachLSEvent"](this["oLS"]["E_EVENTS"]["Unlock"], "unlock");

	//don't wait for UCF_ls because this is not public
	//this.load();
	//but doing in time could break the startup...
	this["sTimerId"] = UCF_JsUtil["delayedCall"](10, this, "load");

};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["initialize"] = 0; };

/** Destructor
 * @private
 */
UCF_WebWidget["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["destroy"]++; }; 
	if (__UCF_MEASURE__) { UCF_Tracer.measure(START, "UCF_WebWidget.destroy"); };

	if (this["sTimerId"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimerId"]);
		this["sTimerId"] = null;
	}

	this["eval"](this["sUnLoad"]);

	//TODO: remove JS registered by this WebWidget?

	this["oDragAndDropDelegate"] = null; // eslint-disable-line @ur/no-memory-leaks
	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["Lock"], "lock");
	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["Unlock"], "unlock");

	this["aScripts"] = null;
	this["mWWParameters"] = null;

	UCF_PlaceHolder.prototype["destroy"]["apply"](this, arguments);
	if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, "UCF_WebWidget.destroy", "Widget " + this["sId"] + " destroyed  "); };
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["destroy"] = 0; };

/** Executes the load script.
 * @private
 */
UCF_WebWidget["prototype"]["load"] = function() {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["load"]++; }; 
	// Problem is that the synchronous loading cannot be assured and often the scripts uses document.write that may fail

	if (this["aScripts"]["length"] > 0) {
		var that = this,
			mScript = this["aScripts"]["pop"]();

		if (mScript["src"] != null && mScript["src"] != "") {
			this["loadScript"](mScript["src"], function() {
				if (mScript["text"] != null && mScript["text"] != "") {
					that["eval"](mScript["text"]);
				}
				that["load"](); //recursion
			});
		}

		if (mScript["text"] != null && mScript["text"] != "") {
			that["eval"](mScript["text"]);
			that["load"](); //recursion
		}

	} else { //end of recursion
		this["unlock"](true);
		if (__UCF_MEASURE__) { UCF_Tracer.measure(STOP, "UCF_WebWidget.initialize", "Widget " + this["sId"] + " initialized and external scripts loaded."); };
	}
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["load"] = 0; };

/**
 * Wrapper that executes special widget JavaScript
 * @private
 * @param {string} sScript
 */
UCF_WebWidget["prototype"]["eval"] = function(sScript) {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["eval"]++; }; 
	// Variables that can be seen inside of the custom JS coding (all other
	// should be part of the this instance)
	if (sScript != null && sScript !== '') {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Execute script ' + sScript + ' on widget ' + this["widget"], "WebWidget.js(182): eval"); };

		UCF_JsUtil["eval"](sScript, {
			// don't attach this.oGetInterface() to your DOM node to avoid memory leaks
			"oWebWidget": this["oGetInterface"](),
			"oDomRef": this["oDomRef"]
		});
	}
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["eval"] = 0; };

/**
 * @see UCF_PlaceHolder
 */
UCF_WebWidget["prototype"]["bDoKeepAlive"] = function() {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["bDoKeepAlive"]++; }; 
	return (this["bKeepAlive"] && UCF_DomUtil["$"](this["sId"] + "-ph")) ? true : false;
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["bDoKeepAlive"] = 0; };

/**
 * TODO: define a list of available events - don't map it directly
 */
/*
this.attachEvent = function attachEvent(sName, oCallback)
{
	var sName = "on" + sName;
	if (this[sName] == null)
	{
		this[sName] = function()
		{
			_trace(INFO, "Attached event " + sName + " fired for widget " + this.sId);
			oCallback();
		}
	} else {
		//avoid recursion maybe use arrays for registration?
		_assert(false);
		 this[sName] = function() {
			var oOld = this[sName];
			//don't execute custom call-back if LS control return false
			return !(oOld() && oCallback());
		};
	}
};
*/

/** Returns the array of the available keys of all WebWidgetParameters of this
 * WebWidget instance. It includes the WebWidgetParameters transported from
 * the server and the keys created by the {@link #set()} method of this control.
 *
 * The method can be called e.g. in the oWebWidget.load() method or the
 * oWebWidget.unload() method.
 *
 * @return the available keys of this WebWidget transported form the server
 * or created by the {@link #set()}  method of this WebWidget instance.
 * @type Array
 *
 * @public
 */
UCF_WebWidget["prototype"]["getPropertyNames"] = function() {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["getPropertyNames"]++; }; 
	if (!this["mWWParameters"] || this["mWWParameters"] == null) {
		this["initialize"]();
	}

	var mParameterNames = [];
	for (var sKey in this["mWWParameters"]) {
		mParameterNames["push"](sKey);
	}
	return mParameterNames;
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["getPropertyNames"] = 0; };

/** Returns the string value of the specific WebWidgetParameter,
 * or {@code null} if this WebWidget contains no WebWidgetParameter
 * for the key. The list of values are extended by calling the {@link #set()}
 * method with a key different to any existing key in any WebWidgetParameter.
 *
 * The method should be used to transport data from the server to the
 * client to initialise the widget with a specific state on the client.
 * Example for such state information are the expanded item in an accordion
 * web widget.
 *
 * The method can be called e.g. in the oWebWidget.load() method or the
 * oWebWidget.unload() method.
 *
 * @param {string} sKey the name of the key
 * @return the value for the specific key.
 * @type string
 *
 * @public
 *
 */
UCF_WebWidget["prototype"]["get"] = function(sKey) {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["get"]++; }; 
	return (!this["mWWParameters"] || this["mWWParameters"] == null) ? null : this["mWWParameters"][sKey];
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["get"] = 0; };

/** Changes the value of the WebWidgtParameter with the specific key. If
 * there is no WebWidgetParameter with the key then it creates a new one
 * internally. This method should be used to notify the framework about any
 * state change in the WebWidget e.g. any change of the selected item in an
 * accordion web widget.
 *
 * In both cases, the setter fires a semantic event in the LightSpeed framework
 * that should be handled on the server side. The value should be forwarded to
 * the framework-specific coding that is used by the WebWidget developer.
 *
 * The method can be called e.g. in the oWebWidget.load() method or the
 * oWebWidget.unload() method.
 *
 * @param {string} sKey the name of the key
 * @param {string} sValue the new value of the WebWidgetParameter
 * @return the new parameter for the specific key.
 *
 * @public
 */
UCF_WebWidget["prototype"]["set"] = function(sKey, sValue) {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["set"]++; }; 
	if (!this["mWWParameters"] || this["mWWParameters"] == null) {
		this["initialize"]();
	}

	if (this["mWWParameters"][sKey] != sValue) {
		this["mWWParameters"][sKey] = sValue;
		//TODO: fire semantic event if EPCF changes the value
		this["fireValueChange"](this["sId"], sKey, sValue);
	}
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["set"] = 0; };

/** Method that causes the framework to trigger a (delta-request) to the server.
 * The WebWidget will be probably destroyed after the invocation of this method
 * so that the complete state has to be saved with help of the {@link #set()}
 * method on all WebWidgets.
 *
 * The method can be called e.g. in the oWebWidget.load() method or the
 * oWebWidget.unload() method.
 *
 * @public
 */
UCF_WebWidget["prototype"]["save"] = function() {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["save"]++; }; 

	//don't lock the widget because save is maybe configured with delay
	//_super.lock();
	//this.oLS.lock();
	this["fireAction"](this["sId"]);
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["save"] = 0; };

/** Serialisation of the current widget state for debugging
 *
UCF_WebWidget.prototype.toString = function(){
	var sResult = "Widget:{id:" + this.sId + ",parameters:";
	for (sEntry in this.mWWParameters) {
		sResult += sEntry + ":\"" + this.get(sEntry) + "\",";
	}
	return sResult.substring(0,sResult.length-1) + "}";
};
*/

/**
 * set a handler for drag and drop processing
 * @public
 * @param {oDragAndDropHandler} a drag and drop handler implementing lsdragstart, lsdrag, lsdragover, lsdraghover, lsdragscroll, lsdrop, lsdragend, lsdragenter, lsdragleave,
 */
UCF_WebWidget["prototype"]["setDragAndDropHandler"] = function(oDragAndDropHandler) {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["setDragAndDropHandler"]++; }; 

	if (this["oDragAndDropDelegate"])
		this["removeDelegate"](this["oDragAndDropDelegate"]);

	if (!oDragAndDropHandler)
		return;

	this["oDragAndDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_DragAndDropDelegate"))(oDragAndDropHandler);
	this["addDelegate"](this["oDragAndDropDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["setDragAndDropHandler"] = 0; };

/** Loads and executes a script
 * @private
 */
UCF_WebWidget["prototype"]["loadScript"] = function(sUrl, fCallback) {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["loadScript"]++; }; 
	//TODO: move to DOMUtils
	var oHead = document["documentElement"],
		oScript = document["createElement"]("script"),
		fHandler = null;

	//attach browser-specific load handlers UCF_DomUtil.attachEvent(oScript, "load" ,function(){});

	fHandler = function() {
		if (this["onload"] && (!this["readyState"] || this["readyState"] == "loaded" || this["readyState"] == "complete")) {

			//TODO: do timeout so that unlock and an error message is done after a time
			fCallback();

			//avoid memory leak
			this["onload"] = null;
			this["onreadystatechange"] = null;

			UCF_DomUtil["removeFromDom"](this);
		}
	};

	oScript["language"] = "text/javascript";
	oScript["type"] = "text/javascript";
	oScript["src"] = sUrl;
	oScript["onload"] = fHandler;
	oScript["onreadystatechange"] = fHandler;

	oHead["insertBefore"](oScript, oHead["firstChild"]);

	//Remove any references (except callback) to avoid leaks
	fHandler = null;
	oHead = null;
	oScript = null;
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["loadScript"] = 0; };

UCF_WebWidget["prototype"]["lock"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["lock"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["lock"] = 0; };

UCF_WebWidget["prototype"]["unlock"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["unlock"]++; }; 

};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["unlock"] = 0; };

/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_WebWidget["prototype"]["aAttributeNames"] = ["sId","sLoad","sUnLoad","sVisibility","sLifeCycle","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_WebWidget["prototype"]["aEventNames"] = ["ValueChange","Action"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_WebWidget["prototype"]["aMethodNames"] = ["getPropertyNames","get","set","save","setDragAndDropHandler","setKeepAlive","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_WebWidget["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_WebWidget["prototype"]["sLoad"] = '';

/**
 * @private
 * @type {string}
 */
UCF_WebWidget["prototype"]["sUnLoad"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_WebWidget["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_WebWidget["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_WebWidget["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_WebWidget["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sLoad"] = '';
	this["sUnLoad"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sLifeCycle"] = "BROWSER";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("Load", '', true);
		this["setClientProperty"]("UnLoad", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control in the current HTML document context. The Id of any control should be unique within the document.
 * @param {string} sKey The Key that should be send back to the server.
 * @param {string} sValue The value that should be send back to the server.
 * @fires WebWidget::ValueChange
 */
UCF_WebWidget["prototype"]["fireValueChange"] = function(sId, sKey, sValue) {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["fireValueChange"]++; }; 
	/** @type {{Id: string, Key: string, Value: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "WebWidget.js(489): fireValueChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "WebWidget.js(490): fireValueChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "WebWidget.js(491): fireValueChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sKey != null, "sKey != null", "WebWidget.js(492): fireValueChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sKey) == "string", "typeof(sKey) == \"string\"", "WebWidget.js(493): fireValueChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sValue != null, "sValue != null", "WebWidget.js(494): fireValueChange"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "WebWidget.js(495): fireValueChange"); };
	mParams = {
		"Id": sId,
		"Key": sKey,
		"Value": sValue
	};
	
	
	
	this["fireSemanticEvent"]("WebWidget", "ValueChange", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["fireValueChange"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control in the current HTML document context. The Id of any control should be unique within the document.
 * @fires WebWidget::Action
 */
UCF_WebWidget["prototype"]["fireAction"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["fireAction"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "WebWidget.js(516): fireAction"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "WebWidget.js(517): fireAction"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "WebWidget.js(518): fireAction"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("WebWidget", "Action", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_WebWidget["_"]["fireAction"] = 0; };

UCF_WebWidget.prototype["aPublicMethods"] = ["getPropertyNames","get","set","save","setDragAndDropHandler"].concat(UCF_WebWidget.prototype.aPublicMethods || []);
};
sap["ls"]["preload"]["UCF_WebWidgetParameter"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_WebWidgetParameter(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_WebWidgetParameter["_"]["UCF_WebWidgetParameter"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "WebWidgetParameter.js(17): UCF_WebWidgetParameter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "WebWidgetParameter.js(18): UCF_WebWidgetParameter"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "WebWidgetParameter.js(19): UCF_WebWidgetParameter"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);
};window["UCF_WebWidgetParameter"] = UCF_WebWidgetParameter; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_WebWidgetParameter"); UCF_WebWidgetParameter["_"] = {UCF_WebWidgetParameter: 0}; }; ;

UCF_WebWidgetParameter["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_WebWidgetParameter.prototype["sClassName"] = "UCF_WebWidgetParameter";

/** Destructor
 * @private
 */
UCF_WebWidgetParameter["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_WebWidgetParameter["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_WebWidgetParameter["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_WebWidgetParameter["prototype"]["aAttributeNames"] = ["sKey","sValue","sListener","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_WebWidgetParameter["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_WebWidgetParameter["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_WebWidgetParameter["prototype"]["sKey"] = '';

/**
 * @private
 * @type {string}
 */
UCF_WebWidgetParameter["prototype"]["sValue"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.WebWidgetListener}
 */
UCF_WebWidgetParameter["prototype"]["sListener"] = "ALL";

/**
 * @private
 * @type {string}
 */
UCF_WebWidgetParameter["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_WebWidgetParameter["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_WebWidgetParameter["_"]["setDefaultValues"]++; }; 
	this["sKey"] = '';
	this["sValue"] = '';
	this["sListener"] = "ALL";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Key", '', true);
		this["setClientProperty"]("Value", '', true);
		this["setClientProperty"]("Listener", "ALL", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_WebWidgetParameter["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};